!function(e){if(!e.hasInitialised){var t={escapeRegExp:function(e){return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g,"\\$&")},hasClass:function(e,t){var i=" ";return 1===e.nodeType&&(i+e.className+i).replace(/[\n\t]/g,i).indexOf(i+t+i)>=0},addClass:function(e,t){e.className+=" "+t},removeClass:function(e,t){var i=new RegExp("\\b"+this.escapeRegExp(t)+"\\b");e.className=e.className.replace(i,"")},interpolateString:function(e,t){return e.replace(/{{([a-z][a-z0-9\-_]*)}}/gi,function(e){return t(arguments[1])||""})},getCookie:function(e){var t=("; "+document.cookie).split("; "+e+"=");return t.length<2?void 0:t.pop().split(";").shift()},setCookie:function(e,t,i,n,o,s){var r=new Date;r.setHours(r.getHours()+24*(i||365));var a=[e+"="+t,"expires="+r.toUTCString(),"path="+(o||"/")];n&&a.push("domain="+n),s&&a.push("secure"),document.cookie=a.join(";")},deepExtend:function(e,t){for(var i in t)t.hasOwnProperty(i)&&(i in e&&this.isPlainObject(e[i])&&this.isPlainObject(t[i])?this.deepExtend(e[i],t[i]):e[i]=t[i]);return e},throttle:function(e,t){var i=!1;return function(){i||(e.apply(this,arguments),i=!0,setTimeout(function(){i=!1},t))}},hash:function(e){var t,i,n=0;if(0===e.length)return n;for(t=0,i=e.length;t<i;++t)n=(n<<5)-n+e.charCodeAt(t),n|=0;return n},normaliseHex:function(e){return"#"==e[0]&&(e=e.substr(1)),3==e.length&&(e=e[0]+e[0]+e[1]+e[1]+e[2]+e[2]),e},getContrast:function(e){return e=this.normaliseHex(e),(299*parseInt(e.substr(0,2),16)+587*parseInt(e.substr(2,2),16)+114*parseInt(e.substr(4,2),16))/1e3>=128?"#000":"#fff"},getLuminance:function(e){var t=parseInt(this.normaliseHex(e),16),i=38+(t>>16),n=38+(t>>8&255),o=38+(255&t);return"#"+(16777216+65536*(i<255?i<1?0:i:255)+256*(n<255?n<1?0:n:255)+(o<255?o<1?0:o:255)).toString(16).slice(1)},isMobile:function(){return/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)},isPlainObject:function(e){return"object"==typeof e&&null!==e&&e.constructor==Object},traverseDOMPath:function(e,i){return e&&e.parentNode?t.hasClass(e,i)?e:this.traverseDOMPath(e.parentNode,i):null}};e.status={deny:"deny",allow:"allow",dismiss:"dismiss"},e.transitionEnd=function(){var e=document.createElement("div"),t={t:"transitionend",OT:"oTransitionEnd",msT:"MSTransitionEnd",MozT:"transitionend",WebkitT:"webkitTransitionEnd"};for(var i in t)if(t.hasOwnProperty(i)&&void 0!==e.style[i+"ransition"])return t[i];return""}(),e.hasTransition=!!e.transitionEnd;var i=Object.keys(e.status).map(t.escapeRegExp);e.customStyles={},e.Popup=function(){var n={enabled:!0,container:null,cookie:{name:"cookieconsent_status",path:"/",domain:"",expiryDays:365,secure:!1},onPopupOpen:function(){},onPopupClose:function(){},onInitialise:function(e){},onStatusChange:function(e,t){},onRevokeChoice:function(){},onNoCookieLaw:function(e,t){},content:{header:"Cookies used on the website!",message:"This website uses cookies to ensure you get the best experience on our website.",dismiss:"Got it!",allow:"Allow cookies",deny:"Decline",link:"Learn more",href:"https://www.cookiesandyou.com",close:"&#x274c;",target:"_blank",policy:"Cookie Policy"},elements:{header:'<span class="cc-header">{{header}}</span>&nbsp;',message:'<span id="cookieconsent:desc" class="cc-message">{{message}}</span>',messagelink:'<span id="cookieconsent:desc" class="cc-message">{{message}} <a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a></span>',dismiss:'<a aria-label="dismiss cookie message" role=button tabindex="0" class="cc-btn cc-dismiss">{{dismiss}}</a>',allow:'<a aria-label="allow cookies" role=button tabindex="0"  class="cc-btn cc-allow">{{allow}}</a>',deny:'<a aria-label="deny cookies" role=button tabindex="0" class="cc-btn cc-deny">{{deny}}</a>',link:'<a aria-label="learn more about cookies" role=button tabindex="0" class="cc-link" href="{{href}}" rel="noopener noreferrer nofollow" target="{{target}}">{{link}}</a>',close:'<span aria-label="dismiss cookie message" role=button tabindex="0" class="cc-close">{{close}}</span>'},window:'<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}">\x3c!--googleoff: all--\x3e{{children}}\x3c!--googleon: all--\x3e</div>',revokeBtn:'<div class="cc-revoke {{classes}}">{{policy}}</div>',compliance:{info:'<div class="cc-compliance">{{dismiss}}</div>',"opt-in":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>',"opt-out":'<div class="cc-compliance cc-highlight">{{deny}}{{allow}}</div>'},type:"info",layouts:{basic:"{{messagelink}}{{compliance}}","basic-close":"{{messagelink}}{{compliance}}{{close}}","basic-header":"{{header}}{{message}}{{link}}{{compliance}}"},layout:"basic",position:"bottom",theme:"block",static:!1,palette:null,revokable:!1,animateRevokable:!0,showLink:!0,dismissOnScroll:!1,dismissOnTimeout:!1,dismissOnWindowClick:!1,ignoreClicksFrom:["cc-revoke","cc-btn"],autoOpen:!0,autoAttach:!0,whitelistPage:[],blacklistPage:[],overrideHTML:null};function o(){this.initialise.apply(this,arguments)}function s(e){this.openingTimeout=null,t.removeClass(e,"cc-invisible")}function r(t){t.style.display="none",t.removeEventListener(e.transitionEnd,this.afterTransition),this.afterTransition=null}function a(){var e=this.options.position.split("-"),t=[];return e.forEach(function(e){t.push("cc-"+e)}),t}function c(n){var o=this.options,s=document.createElement("div"),r=o.container&&1===o.container.nodeType?o.container:document.body;s.innerHTML=n;var a=s.children[0];return a.style.display="none",t.hasClass(a,"cc-window")&&e.hasTransition&&t.addClass(a,"cc-invisible"),this.onButtonClick=function(n){var o=t.traverseDOMPath(n.target,"cc-btn")||n.target;if(t.hasClass(o,"cc-btn")){var s=o.className.match(new RegExp("\\bcc-("+i.join("|")+")\\b")),r=s&&s[1]||!1;r&&(this.setStatus(r),this.close(!0))}t.hasClass(o,"cc-close")&&(this.setStatus(e.status.dismiss),this.close(!0));t.hasClass(o,"cc-revoke")&&this.revokeChoice()}.bind(this),a.addEventListener("click",this.onButtonClick),o.autoAttach&&(r.firstChild?r.insertBefore(a,r.firstChild):r.appendChild(a)),a}function l(e){return"000000"==(e=t.normaliseHex(e))?"#222":t.getLuminance(e)}function u(e,t){for(var i=0,n=e.length;i<n;++i){var o=e[i];if(o instanceof RegExp&&o.test(t)||"string"==typeof o&&o.length&&o===t)return!0}return!1}return o.prototype.initialise=function(i){this.options&&this.destroy(),t.deepExtend(this.options={},n),t.isPlainObject(i)&&t.deepExtend(this.options,i),function(){var t=this.options.onInitialise.bind(this);if(!window.navigator.cookieEnabled)return t(e.status.deny),!0;if(window.CookiesOK||window.navigator.CookiesOK)return t(e.status.allow),!0;var i=Object.keys(e.status),n=this.getStatus(),o=i.indexOf(n)>=0;o&&t(n);return o}.call(this)&&(this.options.enabled=!1),u(this.options.blacklistPage,location.pathname)&&(this.options.enabled=!1),u(this.options.whitelistPage,location.pathname)&&(this.options.enabled=!0);var o=this.options.window.replace("{{classes}}",function(){var i=this.options,n="top"==i.position||"bottom"==i.position?"banner":"floating";t.isMobile()&&(n="floating");var o=["cc-"+n,"cc-type-"+i.type,"cc-theme-"+i.theme];i.static&&o.push("cc-static");o.push.apply(o,a.call(this));(function(i){var n=t.hash(JSON.stringify(i)),o="cc-color-override-"+n,s=t.isPlainObject(i);this.customStyleSelector=s?o:null,s&&function(i,n,o){if(e.customStyles[i])return void++e.customStyles[i].references;var s={},r=n.popup,a=n.button,c=n.highlight;r&&(r.text=r.text?r.text:t.getContrast(r.background),r.link=r.link?r.link:r.text,s[o+".cc-window"]=["color: "+r.text,"background-color: "+r.background],s[o+".cc-revoke"]=["color: "+r.text,"background-color: "+r.background],s[o+" .cc-link,"+o+" .cc-link:active,"+o+" .cc-link:visited"]=["color: "+r.link],a&&(a.text=a.text?a.text:t.getContrast(a.background),a.border=a.border?a.border:"transparent",s[o+" .cc-btn"]=["color: "+a.text,"border-color: "+a.border,"background-color: "+a.background],a.padding&&s[o+" .cc-btn"].push("padding: "+a.padding),"transparent"!=a.background&&(s[o+" .cc-btn:hover, "+o+" .cc-btn:focus"]=["background-color: "+(a.hover||l(a.background))]),c?(c.text=c.text?c.text:t.getContrast(c.background),c.border=c.border?c.border:"transparent",s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+c.text,"border-color: "+c.border,"background-color: "+c.background]):s[o+" .cc-highlight .cc-btn:first-child"]=["color: "+r.text]));var u=document.createElement("style");document.head.appendChild(u),e.customStyles[i]={references:1,element:u.sheet};var h=-1;for(var p in s)s.hasOwnProperty(p)&&u.sheet.insertRule(p+"{"+s[p].join(";")+"}",++h)}(n,i,"."+o);return s}).call(this,this.options.palette);this.customStyleSelector&&o.push(this.customStyleSelector);return o}.call(this).join(" ")).replace("{{children}}",function(){var e={},i=this.options;i.showLink||(i.elements.link="",i.elements.messagelink=i.elements.message);Object.keys(i.elements).forEach(function(n){e[n]=t.interpolateString(i.elements[n],function(e){var t=i.content[e];return e&&"string"==typeof t&&t.length?t:""})});var n=i.compliance[i.type];n||(n=i.compliance.info);e.compliance=t.interpolateString(n,function(t){return e[t]});var o=i.layouts[i.layout];o||(o=i.layouts.basic);return t.interpolateString(o,function(t){return e[t]})}.call(this)),s=this.options.overrideHTML;if("string"==typeof s&&s.length&&(o=s),this.options.static){var r=c.call(this,'<div class="cc-grower">'+o+"</div>");r.style.display="",this.element=r.firstChild,this.element.style.display="none",t.addClass(this.element,"cc-invisible")}else this.element=c.call(this,o);(function(){var i=this.setStatus.bind(this),n=this.close.bind(this),o=this.options.dismissOnTimeout;"number"==typeof o&&o>=0&&(this.dismissTimeout=window.setTimeout(function(){i(e.status.dismiss),n(!0)},Math.floor(o)));var s=this.options.dismissOnScroll;if("number"==typeof s&&s>=0){var r=function(t){window.pageYOffset>Math.floor(s)&&(i(e.status.dismiss),n(!0),window.removeEventListener("scroll",r),this.onWindowScroll=null)};this.options.enabled&&(this.onWindowScroll=r,window.addEventListener("scroll",r))}var a=this.options.dismissOnWindowClick,c=this.options.ignoreClicksFrom;if(a){var l=function(o){for(var s=!1,r=o.path.length,a=c.length,u=0;u<r;u++)if(!s)for(var h=0;h<a;h++)s||(s=t.hasClass(o.path[u],c[h]));s||(i(e.status.dismiss),n(!0),window.removeEventListener("click",l),window.removeEventListener("touchend",l),this.onWindowClick=null)}.bind(this);this.options.enabled&&(this.onWindowClick=l,window.addEventListener("click",l),window.addEventListener("touchend",l))}}).call(this),function(){"info"!=this.options.type&&(this.options.revokable=!0);t.isMobile()&&(this.options.animateRevokable=!1);if(this.options.revokable){var e=a.call(this);this.options.animateRevokable&&e.push("cc-animate"),this.customStyleSelector&&e.push(this.customStyleSelector);var i=this.options.revokeBtn.replace("{{classes}}",e.join(" ")).replace("{{policy}}",this.options.content.policy);this.revokeBtn=c.call(this,i);var n=this.revokeBtn;if(this.options.animateRevokable){var o=t.throttle(function(e){var i=!1,o=window.innerHeight-20;t.hasClass(n,"cc-top")&&e.clientY<20&&(i=!0),t.hasClass(n,"cc-bottom")&&e.clientY>o&&(i=!0),i?t.hasClass(n,"cc-active")||t.addClass(n,"cc-active"):t.hasClass(n,"cc-active")&&t.removeClass(n,"cc-active")},200);this.onMouseMove=o,window.addEventListener("mousemove",o)}}}.call(this),this.options.autoOpen&&this.autoOpen()},o.prototype.destroy=function(){this.onButtonClick&&this.element&&(this.element.removeEventListener("click",this.onButtonClick),this.onButtonClick=null),this.dismissTimeout&&(clearTimeout(this.dismissTimeout),this.dismissTimeout=null),this.onWindowScroll&&(window.removeEventListener("scroll",this.onWindowScroll),this.onWindowScroll=null),this.onWindowClick&&(window.removeEventListener("click",this.onWindowClick),this.onWindowClick=null),this.onMouseMove&&(window.removeEventListener("mousemove",this.onMouseMove),this.onMouseMove=null),this.element&&this.element.parentNode&&this.element.parentNode.removeChild(this.element),this.element=null,this.revokeBtn&&this.revokeBtn.parentNode&&this.revokeBtn.parentNode.removeChild(this.revokeBtn),this.revokeBtn=null,function(i){if(t.isPlainObject(i)){var n=t.hash(JSON.stringify(i)),o=e.customStyles[n];if(o&&!--o.references){var s=o.element.ownerNode;s&&s.parentNode&&s.parentNode.removeChild(s),e.customStyles[n]=null}}}(this.options.palette),this.options=null},o.prototype.open=function(t){if(this.element)return this.isOpen()||(e.hasTransition?this.fadeIn():this.element.style.display="",this.options.revokable&&this.toggleRevokeButton(),this.options.onPopupOpen.call(this)),this},o.prototype.close=function(t){if(this.element)return this.isOpen()&&(e.hasTransition?this.fadeOut():this.element.style.display="none",t&&this.options.revokable&&this.toggleRevokeButton(!0),this.options.onPopupClose.call(this)),this},o.prototype.fadeIn=function(){var i=this.element;if(e.hasTransition&&i&&(this.afterTransition&&r.call(this,i),t.hasClass(i,"cc-invisible"))){if(i.style.display="",this.options.static){var n=this.element.clientHeight;this.element.parentNode.style.maxHeight=n+"px"}this.openingTimeout=setTimeout(s.bind(this,i),20)}},o.prototype.fadeOut=function(){var i=this.element;e.hasTransition&&i&&(this.openingTimeout&&(clearTimeout(this.openingTimeout),s.bind(this,i)),t.hasClass(i,"cc-invisible")||(this.options.static&&(this.element.parentNode.style.maxHeight=""),this.afterTransition=r.bind(this,i),i.addEventListener(e.transitionEnd,this.afterTransition),t.addClass(i,"cc-invisible")))},o.prototype.isOpen=function(){return this.element&&""==this.element.style.display&&(!e.hasTransition||!t.hasClass(this.element,"cc-invisible"))},o.prototype.toggleRevokeButton=function(e){this.revokeBtn&&(this.revokeBtn.style.display=e?"":"none")},o.prototype.revokeChoice=function(e){this.options.enabled=!0,this.clearStatus(),this.options.onRevokeChoice.call(this),e||this.autoOpen()},o.prototype.hasAnswered=function(t){return Object.keys(e.status).indexOf(this.getStatus())>=0},o.prototype.hasConsented=function(t){var i=this.getStatus();return i==e.status.allow||i==e.status.dismiss},o.prototype.autoOpen=function(e){!this.hasAnswered()&&this.options.enabled?this.open():this.hasAnswered()&&this.options.revokable&&this.toggleRevokeButton(!0)},o.prototype.setStatus=function(i){var n=this.options.cookie,o=t.getCookie(n.name),s=Object.keys(e.status).indexOf(o)>=0;Object.keys(e.status).indexOf(i)>=0?(t.setCookie(n.name,i,n.expiryDays,n.domain,n.path,n.secure),this.options.onStatusChange.call(this,i,s)):this.clearStatus()},o.prototype.getStatus=function(){return t.getCookie(this.options.cookie.name)},o.prototype.clearStatus=function(){var e=this.options.cookie;t.setCookie(e.name,"",-1,e.domain,e.path)},o}(),e.Location=function(){var e={timeout:5e3,services:["ipinfo"],serviceDefinitions:{ipinfo:function(){return{url:"//ipinfo.io",headers:["Accept: application/json"],callback:function(e,t){try{var i=JSON.parse(t);return i.error?s(i):{code:i.country}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},ipinfodb:function(e){return{url:"//api.ipinfodb.com/v3/ip-country/?key={api_key}&format=json&callback={callback}",isScript:!0,callback:function(e,t){try{var i=JSON.parse(t);return"ERROR"==i.statusCode?s({error:i.statusMessage}):{code:i.countryCode}}catch(e){return s({error:"Invalid response ("+e+")"})}}}},maxmind:function(){return{url:"//js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js",isScript:!0,callback:function(e){window.geoip2?geoip2.country(function(t){try{e({code:t.country.iso_code})}catch(t){e(s(t))}},function(t){e(s(t))}):e(new Error("Unexpected response format. The downloaded script should have exported `geoip2` to the global scope"))}}}}};function i(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i),this.currentServiceIndex=-1}function n(e,t,i){var n,o=document.createElement("script");o.type="text/"+(e.type||"javascript"),o.src=e.src||e,o.async=!1,o.onreadystatechange=o.onload=function(){var e=o.readyState;clearTimeout(n),t.done||e&&!/loaded|complete/.test(e)||(t.done=!0,t(),o.onreadystatechange=o.onload=null)},document.body.appendChild(o),n=setTimeout(function(){t.done=!0,t(),o.onreadystatechange=o.onload=null},i)}function o(e,t,i,n,o){var s=new(window.XMLHttpRequest||window.ActiveXObject)("MSXML2.XMLHTTP.3.0");if(s.open(n?"POST":"GET",e,1),s.setRequestHeader("Content-type","application/x-www-form-urlencoded"),Array.isArray(o))for(var r=0,a=o.length;r<a;++r){var c=o[r].split(":",2);s.setRequestHeader(c[0].replace(/^\s+|\s+$/g,""),c[1].replace(/^\s+|\s+$/g,""))}"function"==typeof t&&(s.onreadystatechange=function(){s.readyState>3&&t(s)}),s.send(n)}function s(e){return new Error("Error ["+(e.code||"UNKNOWN")+"]: "+e.error)}return i.prototype.getNextService=function(){var e;do{e=this.getServiceByIdx(++this.currentServiceIndex)}while(this.currentServiceIndex<this.options.services.length&&!e);return e},i.prototype.getServiceByIdx=function(e){var i=this.options.services[e];if("function"==typeof i){var n=i();return n.name&&t.deepExtend(n,this.options.serviceDefinitions[n.name](n)),n}return"string"==typeof i?this.options.serviceDefinitions[i]():t.isPlainObject(i)?this.options.serviceDefinitions[i.name](i):null},i.prototype.locate=function(e,t){var i=this.getNextService();i?(this.callbackComplete=e,this.callbackError=t,this.runService(i,this.runNextServiceOnError.bind(this))):t(new Error("No services to run"))},i.prototype.setupUrl=function(e){var t=this.getCurrentServiceOpts();return e.url.replace(/\{(.*?)\}/g,function(i,n){if("callback"===n){var o="callback"+Date.now();return window[o]=function(t){e.__JSONP_DATA=JSON.stringify(t)},o}if(n in t.interpolateUrl)return t.interpolateUrl[n]})},i.prototype.runService=function(e,t){var i=this;e&&e.url&&e.callback&&(e.isScript?n:o)(this.setupUrl(e),function(n){var o=n?n.responseText:"";e.__JSONP_DATA&&(o=e.__JSONP_DATA,delete e.__JSONP_DATA),i.runServiceCallback.call(i,t,e,o)},this.options.timeout,e.data,e.headers)},i.prototype.runServiceCallback=function(e,t,i){var n=this,o=t.callback(function(t){o||n.onServiceResult.call(n,e,t)},i);o&&this.onServiceResult.call(this,e,o)},i.prototype.onServiceResult=function(e,t){t instanceof Error||t&&t.error?e.call(this,t,null):e.call(this,null,t)},i.prototype.runNextServiceOnError=function(e,t){if(e){this.logError(e);var i=this.getNextService();i?this.runService(i,this.runNextServiceOnError.bind(this)):this.completeService.call(this,this.callbackError,new Error("All services failed"))}else this.completeService.call(this,this.callbackComplete,t)},i.prototype.getCurrentServiceOpts=function(){var e=this.options.services[this.currentServiceIndex];return"string"==typeof e?{name:e}:"function"==typeof e?e():t.isPlainObject(e)?e:{}},i.prototype.completeService=function(e,t){this.currentServiceIndex=-1,e&&e(t)},i.prototype.logError=function(e){var t=this.currentServiceIndex,i=this.getServiceByIdx(t);console.warn("The service["+t+"] ("+i.url+") responded with the following error",e)},i}(),e.Law=function(){var e={regionalLaw:!0,hasLaw:["AT","BE","BG","HR","CZ","CY","DK","EE","FI","FR","DE","EL","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","SK","ES","SE","GB","UK","GR","EU"],revokable:["HR","CY","DK","EE","FR","DE","LV","LT","NL","PT","ES"],explicitAction:["HR","IT","ES"]};function i(e){this.initialise.apply(this,arguments)}return i.prototype.initialise=function(i){t.deepExtend(this.options={},e),t.isPlainObject(i)&&t.deepExtend(this.options,i)},i.prototype.get=function(e){var t=this.options;return{hasLaw:t.hasLaw.indexOf(e)>=0,revokable:t.revokable.indexOf(e)>=0,explicitAction:t.explicitAction.indexOf(e)>=0}},i.prototype.applyLaw=function(e,t){var i=this.get(t);return i.hasLaw||(e.enabled=!1,"function"==typeof e.onNoCookieLaw&&e.onNoCookieLaw(t,i)),this.options.regionalLaw&&(i.revokable&&(e.revokable=!0),i.explicitAction&&(e.dismissOnScroll=!1,e.dismissOnTimeout=!1)),e},i}(),e.initialise=function(i,n,o){var s=new e.Law(i.law);n||(n=function(){}),o||(o=function(){});var r=Object.keys(e.status),a=t.getCookie("cookieconsent_status");r.indexOf(a)>=0?n(new e.Popup(i)):e.getCountryCode(i,function(t){delete i.law,delete i.location,t.code&&(i=s.applyLaw(i,t.code)),n(new e.Popup(i))},function(t){delete i.law,delete i.location,o(t,new e.Popup(i))})},e.getCountryCode=function(t,i,n){t.law&&t.law.countryCode?i({code:t.law.countryCode}):t.location?new e.Location(t.location).locate(function(e){i(e||{})},n):i({})},e.utils=t,e.hasInitialised=!0,window.cookieconsent=e}}(window.cookieconsent||{});
!function(a){if("object"==typeof exports)module.exports=a();else if("function"==typeof define&&define.amd)define(a);else{var b;"undefined"!=typeof window?b=window:"undefined"!=typeof global?b=global:"undefined"!=typeof self&&(b=self),b.proj4=a()}}(function(){return function a(b,c,d){function e(g,h){if(!c[g]){if(!b[g]){var i="function"==typeof require&&require;if(!h&&i)return i(g,!0);if(f)return f(g,!0);throw new Error("Cannot find module '"+g+"'")}var j=c[g]={exports:{}};b[g][0].call(j.exports,function(a){var c=b[g][1][a];return e(c?c:a)},j,j.exports,a,b,c,d)}return c[g].exports}for(var f="function"==typeof require&&require,g=0;g<d.length;g++)e(d[g]);return e}({1:[function(a,b,c){function Point(a,b,c){if(!(this instanceof Point))return new Point(a,b,c);if(Array.isArray(a))this.x=a[0],this.y=a[1],this.z=a[2]||0;else if("object"==typeof a)this.x=a.x,this.y=a.y,this.z=a.z||0;else if("string"==typeof a&&"undefined"==typeof b){var d=a.split(",");this.x=parseFloat(d[0],10),this.y=parseFloat(d[1],10),this.z=parseFloat(d[2],10)||0}else this.x=a,this.y=b,this.z=c||0;console.warn("proj4.Point will be removed in version 3, use proj4.toPoint")}var d=a("mgrs");Point.fromMGRS=function(a){return new Point(d.toPoint(a))},Point.prototype.toMGRS=function(a){return d.forward([this.x,this.y],a)},b.exports=Point},{mgrs:67}],2:[function(a,b,c){function Projection(a,b){if(!(this instanceof Projection))return new Projection(a);b=b||function(a){if(a)throw a};var c=d(a);if("object"!=typeof c)return void b(a);var f=g(c),h=Projection.projections.get(f.projName);h?(e(this,f),e(this,h),this.init(),b(null,this)):b(a)}var d=a("./parseCode"),e=a("./extend"),f=a("./projections"),g=a("./deriveConstants");Projection.projections=f,Projection.projections.start(),b.exports=Projection},{"./deriveConstants":33,"./extend":34,"./parseCode":37,"./projections":39}],3:[function(a,b,c){b.exports=function(a,b,c){var d,e,f,g=c.x,h=c.y,i=c.z||0;for(f=0;3>f;f++)if(!b||2!==f||void 0!==c.z)switch(0===f?(d=g,e="x"):1===f?(d=h,e="y"):(d=i,e="z"),a.axis[f]){case"e":c[e]=d;break;case"w":c[e]=-d;break;case"n":c[e]=d;break;case"s":c[e]=-d;break;case"u":void 0!==c[e]&&(c.z=d);break;case"d":void 0!==c[e]&&(c.z=-d);break;default:return null}return c}},{}],4:[function(a,b,c){var d=Math.PI/2,e=a("./sign");b.exports=function(a){return Math.abs(a)<d?a:a-e(a)*Math.PI}},{"./sign":21}],5:[function(a,b,c){var d=2*Math.PI,e=3.14159265359,f=a("./sign");b.exports=function(a){return Math.abs(a)<=e?a:a-f(a)*d}},{"./sign":21}],6:[function(a,b,c){b.exports=function(a){return Math.abs(a)>1&&(a=a>1?1:-1),Math.asin(a)}},{}],7:[function(a,b,c){b.exports=function(a){return 1-.25*a*(1+a/16*(3+1.25*a))}},{}],8:[function(a,b,c){b.exports=function(a){return.375*a*(1+.25*a*(1+.46875*a))}},{}],9:[function(a,b,c){b.exports=function(a){return.05859375*a*a*(1+.75*a)}},{}],10:[function(a,b,c){b.exports=function(a){return a*a*a*(35/3072)}},{}],11:[function(a,b,c){b.exports=function(a,b,c){var d=b*c;return a/Math.sqrt(1-d*d)}},{}],12:[function(a,b,c){b.exports=function(a,b,c,d,e){var f,g;f=a/b;for(var h=0;15>h;h++)if(g=(a-(b*f-c*Math.sin(2*f)+d*Math.sin(4*f)-e*Math.sin(6*f)))/(b-2*c*Math.cos(2*f)+4*d*Math.cos(4*f)-6*e*Math.cos(6*f)),f+=g,Math.abs(g)<=1e-10)return f;return 0/0}},{}],13:[function(a,b,c){var d=Math.PI/2;b.exports=function(a,b){var c=1-(1-a*a)/(2*a)*Math.log((1-a)/(1+a));if(Math.abs(Math.abs(b)-c)<1e-6)return 0>b?-1*d:d;for(var e,f,g,h,i=Math.asin(.5*b),j=0;30>j;j++)if(f=Math.sin(i),g=Math.cos(i),h=a*f,e=Math.pow(1-h*h,2)/(2*g)*(b/(1-a*a)-f/(1-h*h)+.5/a*Math.log((1-h)/(1+h))),i+=e,Math.abs(e)<=1e-10)return i;return 0/0}},{}],14:[function(a,b,c){b.exports=function(a,b,c,d,e){return a*e-b*Math.sin(2*e)+c*Math.sin(4*e)-d*Math.sin(6*e)}},{}],15:[function(a,b,c){b.exports=function(a,b,c){var d=a*b;return c/Math.sqrt(1-d*d)}},{}],16:[function(a,b,c){var d=Math.PI/2;b.exports=function(a,b){for(var c,e,f=.5*a,g=d-2*Math.atan(b),h=0;15>=h;h++)if(c=a*Math.sin(g),e=d-2*Math.atan(b*Math.pow((1-c)/(1+c),f))-g,g+=e,Math.abs(e)<=1e-10)return g;return-9999}},{}],17:[function(a,b,c){var d=1,e=.25,f=.046875,g=.01953125,h=.01068115234375,i=.75,j=.46875,k=.013020833333333334,l=.007120768229166667,m=.3645833333333333,n=.005696614583333333,o=.3076171875;b.exports=function(a){var b=[];b[0]=d-a*(e+a*(f+a*(g+a*h))),b[1]=a*(i-a*(f+a*(g+a*h)));var c=a*a;return b[2]=c*(j-a*(k+a*l)),c*=a,b[3]=c*(m-a*n),b[4]=c*a*o,b}},{}],18:[function(a,b,c){var d=a("./pj_mlfn"),e=1e-10,f=20;b.exports=function(a,b,c){for(var g=1/(1-b),h=a,i=f;i;--i){var j=Math.sin(h),k=1-b*j*j;if(k=(d(h,j,Math.cos(h),c)-a)*k*Math.sqrt(k)*g,h-=k,Math.abs(k)<e)return h}return h}},{"./pj_mlfn":19}],19:[function(a,b,c){b.exports=function(a,b,c,d){return c*=b,b*=b,d[0]*a-c*(d[1]+b*(d[2]+b*(d[3]+b*d[4])))}},{}],20:[function(a,b,c){b.exports=function(a,b){var c;return a>1e-7?(c=a*b,(1-a*a)*(b/(1-c*c)-.5/a*Math.log((1-c)/(1+c)))):2*b}},{}],21:[function(a,b,c){b.exports=function(a){return 0>a?-1:1}},{}],22:[function(a,b,c){b.exports=function(a,b){return Math.pow((1-a)/(1+a),b)}},{}],23:[function(a,b,c){b.exports=function(a){var b={x:a[0],y:a[1]};return a.length>2&&(b.z=a[2]),a.length>3&&(b.m=a[3]),b}},{}],24:[function(a,b,c){var d=Math.PI/2;b.exports=function(a,b,c){var e=a*c,f=.5*a;return e=Math.pow((1-e)/(1+e),f),Math.tan(.5*(d-b))/e}},{}],25:[function(a,b,c){c.wgs84={towgs84:"0,0,0",ellipse:"WGS84",datumName:"WGS84"},c.ch1903={towgs84:"674.374,15.056,405.346",ellipse:"bessel",datumName:"swiss"},c.ggrs87={towgs84:"-199.87,74.79,246.62",ellipse:"GRS80",datumName:"Greek_Geodetic_Reference_System_1987"},c.nad83={towgs84:"0,0,0",ellipse:"GRS80",datumName:"North_American_Datum_1983"},c.nad27={nadgrids:"@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",ellipse:"clrk66",datumName:"North_American_Datum_1927"},c.potsdam={towgs84:"606.0,23.0,413.0",ellipse:"bessel",datumName:"Potsdam Rauenberg 1950 DHDN"},c.carthage={towgs84:"-263.0,6.0,431.0",ellipse:"clark80",datumName:"Carthage 1934 Tunisia"},c.hermannskogel={towgs84:"653.0,-212.0,449.0",ellipse:"bessel",datumName:"Hermannskogel"},c.ire65={towgs84:"482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",ellipse:"mod_airy",datumName:"Ireland 1965"},c.rassadiran={towgs84:"-133.63,-157.5,-158.62",ellipse:"intl",datumName:"Rassadiran"},c.nzgd49={towgs84:"59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",ellipse:"intl",datumName:"New Zealand Geodetic Datum 1949"},c.osgb36={towgs84:"446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",ellipse:"airy",datumName:"Airy 1830"},c.s_jtsk={towgs84:"589,76,480",ellipse:"bessel",datumName:"S-JTSK (Ferro)"},c.beduaram={towgs84:"-106,-87,188",ellipse:"clrk80",datumName:"Beduaram"},c.gunung_segara={towgs84:"-403,684,41",ellipse:"bessel",datumName:"Gunung Segara Jakarta"},c.rnb72={towgs84:"106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",ellipse:"intl",datumName:"Reseau National Belge 1972"}},{}],26:[function(a,b,c){c.MERIT={a:6378137,rf:298.257,ellipseName:"MERIT 1983"},c.SGS85={a:6378136,rf:298.257,ellipseName:"Soviet Geodetic System 85"},c.GRS80={a:6378137,rf:298.257222101,ellipseName:"GRS 1980(IUGG, 1980)"},c.IAU76={a:6378140,rf:298.257,ellipseName:"IAU 1976"},c.airy={a:6377563.396,b:6356256.91,ellipseName:"Airy 1830"},c.APL4={a:6378137,rf:298.25,ellipseName:"Appl. Physics. 1965"},c.NWL9D={a:6378145,rf:298.25,ellipseName:"Naval Weapons Lab., 1965"},c.mod_airy={a:6377340.189,b:6356034.446,ellipseName:"Modified Airy"},c.andrae={a:6377104.43,rf:300,ellipseName:"Andrae 1876 (Den., Iclnd.)"},c.aust_SA={a:6378160,rf:298.25,ellipseName:"Australian Natl & S. Amer. 1969"},c.GRS67={a:6378160,rf:298.247167427,ellipseName:"GRS 67(IUGG 1967)"},c.bessel={a:6377397.155,rf:299.1528128,ellipseName:"Bessel 1841"},c.bess_nam={a:6377483.865,rf:299.1528128,ellipseName:"Bessel 1841 (Namibia)"},c.clrk66={a:6378206.4,b:6356583.8,ellipseName:"Clarke 1866"},c.clrk80={a:6378249.145,rf:293.4663,ellipseName:"Clarke 1880 mod."},c.clrk58={a:6378293.645208759,rf:294.2606763692654,ellipseName:"Clarke 1858"},c.CPM={a:6375738.7,rf:334.29,ellipseName:"Comm. des Poids et Mesures 1799"},c.delmbr={a:6376428,rf:311.5,ellipseName:"Delambre 1810 (Belgium)"},c.engelis={a:6378136.05,rf:298.2566,ellipseName:"Engelis 1985"},c.evrst30={a:6377276.345,rf:300.8017,ellipseName:"Everest 1830"},c.evrst48={a:6377304.063,rf:300.8017,ellipseName:"Everest 1948"},c.evrst56={a:6377301.243,rf:300.8017,ellipseName:"Everest 1956"},c.evrst69={a:6377295.664,rf:300.8017,ellipseName:"Everest 1969"},c.evrstSS={a:6377298.556,rf:300.8017,ellipseName:"Everest (Sabah & Sarawak)"},c.fschr60={a:6378166,rf:298.3,ellipseName:"Fischer (Mercury Datum) 1960"},c.fschr60m={a:6378155,rf:298.3,ellipseName:"Fischer 1960"},c.fschr68={a:6378150,rf:298.3,ellipseName:"Fischer 1968"},c.helmert={a:6378200,rf:298.3,ellipseName:"Helmert 1906"},c.hough={a:6378270,rf:297,ellipseName:"Hough"},c.intl={a:6378388,rf:297,ellipseName:"International 1909 (Hayford)"},c.kaula={a:6378163,rf:298.24,ellipseName:"Kaula 1961"},c.lerch={a:6378139,rf:298.257,ellipseName:"Lerch 1979"},c.mprts={a:6397300,rf:191,ellipseName:"Maupertius 1738"},c.new_intl={a:6378157.5,b:6356772.2,ellipseName:"New International 1967"},c.plessis={a:6376523,rf:6355863,ellipseName:"Plessis 1817 (France)"},c.krass={a:6378245,rf:298.3,ellipseName:"Krassovsky, 1942"},c.SEasia={a:6378155,b:6356773.3205,ellipseName:"Southeast Asia"},c.walbeck={a:6376896,b:6355834.8467,ellipseName:"Walbeck"},c.WGS60={a:6378165,rf:298.3,ellipseName:"WGS 60"},c.WGS66={a:6378145,rf:298.25,ellipseName:"WGS 66"},c.WGS7={a:6378135,rf:298.26,ellipseName:"WGS 72"},c.WGS84={a:6378137,rf:298.257223563,ellipseName:"WGS 84"},c.sphere={a:6370997,b:6370997,ellipseName:"Normal Sphere (r=6370997)"}},{}],27:[function(a,b,c){c.greenwich=0,c.lisbon=-9.131906111111,c.paris=2.337229166667,c.bogota=-74.080916666667,c.madrid=-3.687938888889,c.rome=12.452333333333,c.bern=7.439583333333,c.jakarta=106.807719444444,c.ferro=-17.666666666667,c.brussels=4.367975,c.stockholm=18.058277777778,c.athens=23.7163375,c.oslo=10.722916666667},{}],28:[function(a,b,c){c.ft={to_meter:.3048},c["us-ft"]={to_meter:1200/3937}},{}],29:[function(a,b,c){function d(a,b,c){var d;return Array.isArray(c)?(d=g(a,b,c),3===c.length?[d.x,d.y,d.z]:[d.x,d.y]):g(a,b,c)}function e(a){return a instanceof f?a:a.oProj?a.oProj:f(a)}function proj4(a,b,c){a=e(a);var f,g=!1;return"undefined"==typeof b?(b=a,a=h,g=!0):("undefined"!=typeof b.x||Array.isArray(b))&&(c=b,b=a,a=h,g=!0),b=e(b),c?d(a,b,c):(f={forward:function(c){return d(a,b,c)},inverse:function(c){return d(b,a,c)}},g&&(f.oProj=b),f)}var f=a("./Proj"),g=a("./transform"),h=f("WGS84");b.exports=proj4},{"./Proj":2,"./transform":65}],30:[function(a,b,c){var d=Math.PI/2,e=1,f=2,g=3,h=4,i=5,j=484813681109536e-20,k=1.0026,l=.3826834323650898,m=function(a){if(!(this instanceof m))return new m(a);if(this.datum_type=h,a){if(a.datumCode&&"none"===a.datumCode&&(this.datum_type=i),a.datum_params){for(var b=0;b<a.datum_params.length;b++)a.datum_params[b]=parseFloat(a.datum_params[b]);(0!==a.datum_params[0]||0!==a.datum_params[1]||0!==a.datum_params[2])&&(this.datum_type=e),a.datum_params.length>3&&(0!==a.datum_params[3]||0!==a.datum_params[4]||0!==a.datum_params[5]||0!==a.datum_params[6])&&(this.datum_type=f,a.datum_params[3]*=j,a.datum_params[4]*=j,a.datum_params[5]*=j,a.datum_params[6]=a.datum_params[6]/1e6+1)}this.datum_type=a.grids?g:this.datum_type,this.a=a.a,this.b=a.b,this.es=a.es,this.ep2=a.ep2,this.datum_params=a.datum_params,this.datum_type===g&&(this.grids=a.grids)}};m.prototype={compare_datums:function(a){return this.datum_type!==a.datum_type?!1:this.a!==a.a||Math.abs(this.es-a.es)>5e-11?!1:this.datum_type===e?this.datum_params[0]===a.datum_params[0]&&this.datum_params[1]===a.datum_params[1]&&this.datum_params[2]===a.datum_params[2]:this.datum_type===f?this.datum_params[0]===a.datum_params[0]&&this.datum_params[1]===a.datum_params[1]&&this.datum_params[2]===a.datum_params[2]&&this.datum_params[3]===a.datum_params[3]&&this.datum_params[4]===a.datum_params[4]&&this.datum_params[5]===a.datum_params[5]&&this.datum_params[6]===a.datum_params[6]:this.datum_type===g||a.datum_type===g?this.nadgrids===a.nadgrids:!0},geodetic_to_geocentric:function(a){var b,c,e,f,g,h,i,j=a.x,k=a.y,l=a.z?a.z:0,m=0;if(-d>k&&k>-1.001*d)k=-d;else if(k>d&&1.001*d>k)k=d;else if(-d>k||k>d)return null;return j>Math.PI&&(j-=2*Math.PI),g=Math.sin(k),i=Math.cos(k),h=g*g,f=this.a/Math.sqrt(1-this.es*h),b=(f+l)*i*Math.cos(j),c=(f+l)*i*Math.sin(j),e=(f*(1-this.es)+l)*g,a.x=b,a.y=c,a.z=e,m},geocentric_to_geodetic:function(a){var b,c,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t=1e-12,u=t*t,v=30,w=a.x,x=a.y,y=a.z?a.z:0;if(o=!1,b=Math.sqrt(w*w+x*x),c=Math.sqrt(w*w+x*x+y*y),b/this.a<t){if(o=!0,q=0,c/this.a<t)return r=d,void(s=-this.b)}else q=Math.atan2(x,w);e=y/c,f=b/c,g=1/Math.sqrt(1-this.es*(2-this.es)*f*f),j=f*(1-this.es)*g,k=e*g,p=0;do p++,i=this.a/Math.sqrt(1-this.es*k*k),s=b*j+y*k-i*(1-this.es*k*k),h=this.es*i/(i+s),g=1/Math.sqrt(1-h*(2-h)*f*f),l=f*(1-h)*g,m=e*g,n=m*j-l*k,j=l,k=m;while(n*n>u&&v>p);return r=Math.atan(m/Math.abs(l)),a.x=q,a.y=r,a.z=s,a},geocentric_to_geodetic_noniter:function(a){var b,c,e,f,g,h,i,j,m,n,o,p,q,r,s,t,u,v=a.x,w=a.y,x=a.z?a.z:0;if(v=parseFloat(v),w=parseFloat(w),x=parseFloat(x),u=!1,0!==v)b=Math.atan2(w,v);else if(w>0)b=d;else if(0>w)b=-d;else if(u=!0,b=0,x>0)c=d;else{if(!(0>x))return c=d,void(e=-this.b);c=-d}return g=v*v+w*w,f=Math.sqrt(g),h=x*k,j=Math.sqrt(h*h+g),n=h/j,p=f/j,o=n*n*n,i=x+this.b*this.ep2*o,t=f-this.a*this.es*p*p*p,m=Math.sqrt(i*i+t*t),q=i/m,r=t/m,s=this.a/Math.sqrt(1-this.es*q*q),e=r>=l?f/r-s:-l>=r?f/-r-s:x/q+s*(this.es-1),u===!1&&(c=Math.atan(q/r)),a.x=b,a.y=c,a.z=e,a},geocentric_to_wgs84:function(a){if(this.datum_type===e)a.x+=this.datum_params[0],a.y+=this.datum_params[1],a.z+=this.datum_params[2];else if(this.datum_type===f){var b=this.datum_params[0],c=this.datum_params[1],d=this.datum_params[2],g=this.datum_params[3],h=this.datum_params[4],i=this.datum_params[5],j=this.datum_params[6],k=j*(a.x-i*a.y+h*a.z)+b,l=j*(i*a.x+a.y-g*a.z)+c,m=j*(-h*a.x+g*a.y+a.z)+d;a.x=k,a.y=l,a.z=m}},geocentric_from_wgs84:function(a){if(this.datum_type===e)a.x-=this.datum_params[0],a.y-=this.datum_params[1],a.z-=this.datum_params[2];else if(this.datum_type===f){var b=this.datum_params[0],c=this.datum_params[1],d=this.datum_params[2],g=this.datum_params[3],h=this.datum_params[4],i=this.datum_params[5],j=this.datum_params[6],k=(a.x-b)/j,l=(a.y-c)/j,m=(a.z-d)/j;a.x=k+i*l-h*m,a.y=-i*k+l+g*m,a.z=h*k-g*l+m}}},b.exports=m},{}],31:[function(a,b,c){var d=1,e=2,f=3,g=5,h=6378137,i=.006694379990141316;b.exports=function(a,b,c){function j(a){return a===d||a===e}var k,l,m;if(a.compare_datums(b))return c;if(a.datum_type===g||b.datum_type===g)return c;var n=a.a,o=a.es,p=b.a,q=b.es,r=a.datum_type;if(r===f)if(0===this.apply_gridshift(a,0,c))a.a=h,a.es=i;else{if(!a.datum_params)return a.a=n,a.es=a.es,c;for(k=1,l=0,m=a.datum_params.length;m>l;l++)k*=a.datum_params[l];if(0===k)return a.a=n,a.es=a.es,c;r=a.datum_params.length>3?e:d}return b.datum_type===f&&(b.a=h,b.es=i),(a.es!==b.es||a.a!==b.a||j(r)||j(b.datum_type))&&(a.geodetic_to_geocentric(c),j(a.datum_type)&&a.geocentric_to_wgs84(c),j(b.datum_type)&&b.geocentric_from_wgs84(c),b.geocentric_to_geodetic(c)),b.datum_type===f&&this.apply_gridshift(b,1,c),a.a=n,a.es=o,b.a=p,b.es=q,c}},{}],32:[function(a,b,c){function d(a){var b=this;if(2===arguments.length){var c=arguments[1];d[a]="string"==typeof c?"+"===c.charAt(0)?f(arguments[1]):g(arguments[1]):c}else if(1===arguments.length){if(Array.isArray(a))return a.map(function(a){Array.isArray(a)?d.apply(b,a):d(a)});if("string"==typeof a){if(a in d)return d[a]}else"EPSG"in a?d["EPSG:"+a.EPSG]=a:"ESRI"in a?d["ESRI:"+a.ESRI]=a:"IAU2000"in a?d["IAU2000:"+a.IAU2000]=a:console.log(a);return}}var e=a("./global"),f=a("./projString"),g=a("./wkt");e(d),b.exports=d},{"./global":35,"./projString":38,"./wkt":66}],33:[function(a,b,c){var d=a("./constants/Datum"),e=a("./constants/Ellipsoid"),f=a("./extend"),g=a("./datum"),h=1e-10,i=.16666666666666666,j=.04722222222222222,k=.022156084656084655;b.exports=function(a){if(a.datumCode&&"none"!==a.datumCode){var b=d[a.datumCode];b&&(a.datum_params=b.towgs84?b.towgs84.split(","):null,a.ellps=b.ellipse,a.datumName=b.datumName?b.datumName:a.datumCode)}if(!a.a){var c=e[a.ellps]?e[a.ellps]:e.WGS84;f(a,c)}return a.rf&&!a.b&&(a.b=(1-1/a.rf)*a.a),(0===a.rf||Math.abs(a.a-a.b)<h)&&(a.sphere=!0,a.b=a.a),a.a2=a.a*a.a,a.b2=a.b*a.b,a.es=(a.a2-a.b2)/a.a2,a.e=Math.sqrt(a.es),a.R_A&&(a.a*=1-a.es*(i+a.es*(j+a.es*k)),a.a2=a.a*a.a,a.b2=a.b*a.b,a.es=0),a.ep2=(a.a2-a.b2)/a.b2,a.k0||(a.k0=1),a.axis||(a.axis="enu"),a.datum||(a.datum=g(a)),a}},{"./constants/Datum":25,"./constants/Ellipsoid":26,"./datum":30,"./extend":34}],34:[function(a,b,c){b.exports=function(a,b){a=a||{};var c,d;if(!b)return a;for(d in b)c=b[d],void 0!==c&&(a[d]=c);return a}},{}],35:[function(a,b,c){b.exports=function(a){a("EPSG:4326","+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees"),a("EPSG:4269","+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees"),a("EPSG:3857","+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs"),a.WGS84=a["EPSG:4326"],a["EPSG:3785"]=a["EPSG:3857"],a.GOOGLE=a["EPSG:3857"],a["EPSG:900913"]=a["EPSG:3857"],a["EPSG:102113"]=a["EPSG:3857"]}},{}],36:[function(a,b,c){var proj4=a("./core");proj4.defaultDatum="WGS84",proj4.Proj=a("./Proj"),proj4.WGS84=new proj4.Proj("WGS84"),proj4.Point=a("./Point"),proj4.toPoint=a("./common/toPoint"),proj4.defs=a("./defs"),proj4.transform=a("./transform"),proj4.mgrs=a("mgrs"),proj4.version=a("../package.json").version,a("./includedProjections")(proj4),b.exports=proj4},{"../package.json":68,"./Point":1,"./Proj":2,"./common/toPoint":23,"./core":29,"./defs":32,"./includedProjections":"hTEDpn","./transform":65,mgrs:67}],37:[function(a,b,c){function d(a){return"string"==typeof a}function e(a){return a in i}function f(a){var b=["GEOGCS","GEOCCS","PROJCS","LOCAL_CS"];return b.reduce(function(b,c){return b+1+a.indexOf(c)},0)}function g(a){return"+"===a[0]}function h(a){return d(a)?e(a)?i[a]:f(a)?j(a):g(a)?k(a):void 0:a}var i=a("./defs"),j=a("./wkt"),k=a("./projString");b.exports=h},{"./defs":32,"./projString":38,"./wkt":66}],38:[function(a,b,c){var d=.017453292519943295,e=a("./constants/PrimeMeridian"),f=a("./constants/units");b.exports=function(a){var b={},c={};a.split("+").map(function(a){return a.trim()}).filter(function(a){return a}).forEach(function(a){var b=a.split("=");b.push(!0),c[b[0].toLowerCase()]=b[1]});var g,h,i,j={proj:"projName",datum:"datumCode",rf:function(a){b.rf=parseFloat(a)},lat_0:function(a){b.lat0=a*d},lat_1:function(a){b.lat1=a*d},lat_2:function(a){b.lat2=a*d},lat_ts:function(a){b.lat_ts=a*d},lon_0:function(a){b.long0=a*d},lon_1:function(a){b.long1=a*d},lon_2:function(a){b.long2=a*d},alpha:function(a){b.alpha=parseFloat(a)*d},lonc:function(a){b.longc=a*d},x_0:function(a){b.x0=parseFloat(a)},y_0:function(a){b.y0=parseFloat(a)},k_0:function(a){b.k0=parseFloat(a)},k:function(a){b.k0=parseFloat(a)},a:function(a){b.a=parseFloat(a)},b:function(a){b.b=parseFloat(a)},r_a:function(){b.R_A=!0},zone:function(a){b.zone=parseInt(a,10)},south:function(){b.utmSouth=!0},towgs84:function(a){b.datum_params=a.split(",").map(function(a){return parseFloat(a)})},to_meter:function(a){b.to_meter=parseFloat(a)},units:function(a){b.units=a,f[a]&&(b.to_meter=f[a].to_meter)},from_greenwich:function(a){b.from_greenwich=a*d},pm:function(a){b.from_greenwich=(e[a]?e[a]:parseFloat(a))*d},nadgrids:function(a){"@null"===a?b.datumCode="none":b.nadgrids=a},axis:function(a){var c="ewnsud";3===a.length&&-1!==c.indexOf(a.substr(0,1))&&-1!==c.indexOf(a.substr(1,1))&&-1!==c.indexOf(a.substr(2,1))&&(b.axis=a)}};for(g in c)h=c[g],g in j?(i=j[g],"function"==typeof i?i(h):b[i]=h):b[g]=h;return"string"==typeof b.datumCode&&"WGS84"!==b.datumCode&&(b.datumCode=b.datumCode.toLowerCase()),b}},{"./constants/PrimeMeridian":27,"./constants/units":28}],39:[function(a,b,c){function d(a,b){var c=g.length;return a.names?(g[c]=a,a.names.forEach(function(a){f[a.toLowerCase()]=c}),this):(console.log(b),!0)}var e=[a("./projections/merc"),a("./projections/longlat")],f={},g=[];c.add=d,c.get=function(a){if(!a)return!1;var b=a.toLowerCase();return"undefined"!=typeof f[b]&&g[f[b]]?g[f[b]]:void 0},c.start=function(){e.forEach(d)}},{"./projections/longlat":51,"./projections/merc":52}],40:[function(a,b,c){var d=1e-10,e=a("../common/msfnz"),f=a("../common/qsfnz"),g=a("../common/adjust_lon"),h=a("../common/asinz");c.init=function(){Math.abs(this.lat1+this.lat2)<d||(this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e3=Math.sqrt(this.es),this.sin_po=Math.sin(this.lat1),this.cos_po=Math.cos(this.lat1),this.t1=this.sin_po,this.con=this.sin_po,this.ms1=e(this.e3,this.sin_po,this.cos_po),this.qs1=f(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat2),this.cos_po=Math.cos(this.lat2),this.t2=this.sin_po,this.ms2=e(this.e3,this.sin_po,this.cos_po),this.qs2=f(this.e3,this.sin_po,this.cos_po),this.sin_po=Math.sin(this.lat0),this.cos_po=Math.cos(this.lat0),this.t3=this.sin_po,this.qs0=f(this.e3,this.sin_po,this.cos_po),this.ns0=Math.abs(this.lat1-this.lat2)>d?(this.ms1*this.ms1-this.ms2*this.ms2)/(this.qs2-this.qs1):this.con,this.c=this.ms1*this.ms1+this.ns0*this.qs1,this.rh=this.a*Math.sqrt(this.c-this.ns0*this.qs0)/this.ns0)},c.forward=function(a){var b=a.x,c=a.y;this.sin_phi=Math.sin(c),this.cos_phi=Math.cos(c);var d=f(this.e3,this.sin_phi,this.cos_phi),e=this.a*Math.sqrt(this.c-this.ns0*d)/this.ns0,h=this.ns0*g(b-this.long0),i=e*Math.sin(h)+this.x0,j=this.rh-e*Math.cos(h)+this.y0;return a.x=i,a.y=j,a},c.inverse=function(a){var b,c,d,e,f,h;return a.x-=this.x0,a.y=this.rh-a.y+this.y0,this.ns0>=0?(b=Math.sqrt(a.x*a.x+a.y*a.y),d=1):(b=-Math.sqrt(a.x*a.x+a.y*a.y),d=-1),e=0,0!==b&&(e=Math.atan2(d*a.x,d*a.y)),d=b*this.ns0/this.a,this.sphere?h=Math.asin((this.c-d*d)/(2*this.ns0)):(c=(this.c-d*d)/this.ns0,h=this.phi1z(this.e3,c)),f=g(e/this.ns0+this.long0),a.x=f,a.y=h,a},c.phi1z=function(a,b){var c,e,f,g,i,j=h(.5*b);if(d>a)return j;for(var k=a*a,l=1;25>=l;l++)if(c=Math.sin(j),e=Math.cos(j),f=a*c,g=1-f*f,i=.5*g*g/e*(b/(1-k)-c/g+.5/a*Math.log((1-f)/(1+f))),j+=i,Math.abs(i)<=1e-7)return j;return null},c.names=["Albers_Conic_Equal_Area","Albers","aea"]},{"../common/adjust_lon":5,"../common/asinz":6,"../common/msfnz":15,"../common/qsfnz":20}],41:[function(a,b,c){var d=a("../common/adjust_lon"),e=Math.PI/2,f=1e-10,g=a("../common/mlfn"),h=a("../common/e0fn"),i=a("../common/e1fn"),j=a("../common/e2fn"),k=a("../common/e3fn"),l=a("../common/gN"),m=a("../common/asinz"),n=a("../common/imlfn");c.init=function(){this.sin_p12=Math.sin(this.lat0),this.cos_p12=Math.cos(this.lat0)},c.forward=function(a){var b,c,m,n,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H=a.x,I=a.y,J=Math.sin(a.y),K=Math.cos(a.y),L=d(H-this.long0);return this.sphere?Math.abs(this.sin_p12-1)<=f?(a.x=this.x0+this.a*(e-I)*Math.sin(L),a.y=this.y0-this.a*(e-I)*Math.cos(L),a):Math.abs(this.sin_p12+1)<=f?(a.x=this.x0+this.a*(e+I)*Math.sin(L),a.y=this.y0+this.a*(e+I)*Math.cos(L),a):(B=this.sin_p12*J+this.cos_p12*K*Math.cos(L),z=Math.acos(B),A=z/Math.sin(z),a.x=this.x0+this.a*A*K*Math.sin(L),a.y=this.y0+this.a*A*(this.cos_p12*J-this.sin_p12*K*Math.cos(L)),a):(b=h(this.es),c=i(this.es),m=j(this.es),n=k(this.es),Math.abs(this.sin_p12-1)<=f?(o=this.a*g(b,c,m,n,e),p=this.a*g(b,c,m,n,I),a.x=this.x0+(o-p)*Math.sin(L),a.y=this.y0-(o-p)*Math.cos(L),a):Math.abs(this.sin_p12+1)<=f?(o=this.a*g(b,c,m,n,e),p=this.a*g(b,c,m,n,I),a.x=this.x0+(o+p)*Math.sin(L),a.y=this.y0+(o+p)*Math.cos(L),a):(q=J/K,r=l(this.a,this.e,this.sin_p12),s=l(this.a,this.e,J),t=Math.atan((1-this.es)*q+this.es*r*this.sin_p12/(s*K)),u=Math.atan2(Math.sin(L),this.cos_p12*Math.tan(t)-this.sin_p12*Math.cos(L)),C=0===u?Math.asin(this.cos_p12*Math.sin(t)-this.sin_p12*Math.cos(t)):Math.abs(Math.abs(u)-Math.PI)<=f?-Math.asin(this.cos_p12*Math.sin(t)-this.sin_p12*Math.cos(t)):Math.asin(Math.sin(L)*Math.cos(t)/Math.sin(u)),v=this.e*this.sin_p12/Math.sqrt(1-this.es),w=this.e*this.cos_p12*Math.cos(u)/Math.sqrt(1-this.es),x=v*w,y=w*w,D=C*C,E=D*C,F=E*C,G=F*C,z=r*C*(1-D*y*(1-y)/6+E/8*x*(1-2*y)+F/120*(y*(4-7*y)-3*v*v*(1-7*y))-G/48*x),a.x=this.x0+z*Math.sin(u),a.y=this.y0+z*Math.cos(u),a))},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b,c,o,p,q,r,s,t,u,v,w,x,y,z,A,B,C,D,E,F,G,H,I;if(this.sphere){if(b=Math.sqrt(a.x*a.x+a.y*a.y),b>2*e*this.a)return;return c=b/this.a,o=Math.sin(c),p=Math.cos(c),q=this.long0,Math.abs(b)<=f?r=this.lat0:(r=m(p*this.sin_p12+a.y*o*this.cos_p12/b),s=Math.abs(this.lat0)-e,q=d(Math.abs(s)<=f?this.lat0>=0?this.long0+Math.atan2(a.x,-a.y):this.long0-Math.atan2(-a.x,a.y):this.long0+Math.atan2(a.x*o,b*this.cos_p12*p-a.y*this.sin_p12*o))),a.x=q,a.y=r,a}return t=h(this.es),u=i(this.es),v=j(this.es),w=k(this.es),Math.abs(this.sin_p12-1)<=f?(x=this.a*g(t,u,v,w,e),b=Math.sqrt(a.x*a.x+a.y*a.y),y=x-b,r=n(y/this.a,t,u,v,w),q=d(this.long0+Math.atan2(a.x,-1*a.y)),a.x=q,a.y=r,a):Math.abs(this.sin_p12+1)<=f?(x=this.a*g(t,u,v,w,e),b=Math.sqrt(a.x*a.x+a.y*a.y),y=b-x,r=n(y/this.a,t,u,v,w),q=d(this.long0+Math.atan2(a.x,a.y)),a.x=q,a.y=r,a):(b=Math.sqrt(a.x*a.x+a.y*a.y),B=Math.atan2(a.x,a.y),z=l(this.a,this.e,this.sin_p12),C=Math.cos(B),D=this.e*this.cos_p12*C,E=-D*D/(1-this.es),F=3*this.es*(1-E)*this.sin_p12*this.cos_p12*C/(1-this.es),G=b/z,H=G-E*(1+E)*Math.pow(G,3)/6-F*(1+3*E)*Math.pow(G,4)/24,I=1-E*H*H/2-G*H*H*H/6,A=Math.asin(this.sin_p12*Math.cos(H)+this.cos_p12*Math.sin(H)*C),q=d(this.long0+Math.asin(Math.sin(B)*Math.sin(H)/Math.cos(A))),r=Math.atan((1-this.es*I*this.sin_p12/Math.sin(A))*Math.tan(A)/(1-this.es)),a.x=q,a.y=r,a)},c.names=["Azimuthal_Equidistant","aeqd"]},{"../common/adjust_lon":5,"../common/asinz":6,"../common/e0fn":7,"../common/e1fn":8,"../common/e2fn":9,"../common/e3fn":10,"../common/gN":11,"../common/imlfn":12,"../common/mlfn":14}],42:[function(a,b,c){var d=a("../common/mlfn"),e=a("../common/e0fn"),f=a("../common/e1fn"),g=a("../common/e2fn"),h=a("../common/e3fn"),i=a("../common/gN"),j=a("../common/adjust_lon"),k=a("../common/adjust_lat"),l=a("../common/imlfn"),m=Math.PI/2,n=1e-10;c.init=function(){this.sphere||(this.e0=e(this.es),this.e1=f(this.es),this.e2=g(this.es),this.e3=h(this.es),this.ml0=this.a*d(this.e0,this.e1,this.e2,this.e3,this.lat0))},c.forward=function(a){var b,c,e=a.x,f=a.y;if(e=j(e-this.long0),this.sphere)b=this.a*Math.asin(Math.cos(f)*Math.sin(e)),c=this.a*(Math.atan2(Math.tan(f),Math.cos(e))-this.lat0);else{var g=Math.sin(f),h=Math.cos(f),k=i(this.a,this.e,g),l=Math.tan(f)*Math.tan(f),m=e*Math.cos(f),n=m*m,o=this.es*h*h/(1-this.es),p=this.a*d(this.e0,this.e1,this.e2,this.e3,f);b=k*m*(1-n*l*(1/6-(8-l+8*o)*n/120)),c=p-this.ml0+k*g/h*n*(.5+(5-l+6*o)*n/24)}return a.x=b+this.x0,a.y=c+this.y0,a},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b,c,d=a.x/this.a,e=a.y/this.a;if(this.sphere){var f=e+this.lat0;b=Math.asin(Math.sin(f)*Math.cos(d)),c=Math.atan2(Math.tan(d),Math.cos(f))}else{var g=this.ml0/this.a+e,h=l(g,this.e0,this.e1,this.e2,this.e3);if(Math.abs(Math.abs(h)-m)<=n)return a.x=this.long0,a.y=m,0>e&&(a.y*=-1),a;var o=i(this.a,this.e,Math.sin(h)),p=o*o*o/this.a/this.a*(1-this.es),q=Math.pow(Math.tan(h),2),r=d*this.a/o,s=r*r;b=h-o*Math.tan(h)/p*r*r*(.5-(1+3*q)*r*r/24),c=r*(1-s*(q/3+(1+3*q)*q*s/15))/Math.cos(h)}return a.x=j(c+this.long0),a.y=k(b),a},c.names=["Cassini","Cassini_Soldner","cass"]},{"../common/adjust_lat":4,"../common/adjust_lon":5,"../common/e0fn":7,"../common/e1fn":8,"../common/e2fn":9,"../common/e3fn":10,"../common/gN":11,"../common/imlfn":12,"../common/mlfn":14}],43:[function(a,b,c){var d=a("../common/adjust_lon"),e=a("../common/qsfnz"),f=a("../common/msfnz"),g=a("../common/iqsfnz");c.init=function(){this.sphere||(this.k0=f(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)))},c.forward=function(a){var b,c,f=a.x,g=a.y,h=d(f-this.long0);if(this.sphere)b=this.x0+this.a*h*Math.cos(this.lat_ts),c=this.y0+this.a*Math.sin(g)/Math.cos(this.lat_ts);else{var i=e(this.e,Math.sin(g));b=this.x0+this.a*this.k0*h,c=this.y0+this.a*i*.5/this.k0}return a.x=b,a.y=c,a},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b,c;return this.sphere?(b=d(this.long0+a.x/this.a/Math.cos(this.lat_ts)),c=Math.asin(a.y/this.a*Math.cos(this.lat_ts))):(c=g(this.e,2*a.y*this.k0/this.a),b=d(this.long0+a.x/(this.a*this.k0))),a.x=b,a.y=c,a},c.names=["cea"]},{"../common/adjust_lon":5,"../common/iqsfnz":13,"../common/msfnz":15,"../common/qsfnz":20}],44:[function(a,b,c){var d=a("../common/adjust_lon"),e=a("../common/adjust_lat");c.init=function(){this.x0=this.x0||0,this.y0=this.y0||0,this.lat0=this.lat0||0,this.long0=this.long0||0,this.lat_ts=this.lat_ts||0,this.title=this.title||"Equidistant Cylindrical (Plate Carre)",this.rc=Math.cos(this.lat_ts)},c.forward=function(a){var b=a.x,c=a.y,f=d(b-this.long0),g=e(c-this.lat0);return a.x=this.x0+this.a*f*this.rc,a.y=this.y0+this.a*g,a},c.inverse=function(a){var b=a.x,c=a.y;return a.x=d(this.long0+(b-this.x0)/(this.a*this.rc)),a.y=e(this.lat0+(c-this.y0)/this.a),a},c.names=["Equirectangular","Equidistant_Cylindrical","eqc"]},{"../common/adjust_lat":4,"../common/adjust_lon":5}],45:[function(a,b,c){var d=a("../common/e0fn"),e=a("../common/e1fn"),f=a("../common/e2fn"),g=a("../common/e3fn"),h=a("../common/msfnz"),i=a("../common/mlfn"),j=a("../common/adjust_lon"),k=a("../common/adjust_lat"),l=a("../common/imlfn"),m=1e-10;c.init=function(){Math.abs(this.lat1+this.lat2)<m||(this.lat2=this.lat2||this.lat1,this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=d(this.es),this.e1=e(this.es),this.e2=f(this.es),this.e3=g(this.es),this.sinphi=Math.sin(this.lat1),this.cosphi=Math.cos(this.lat1),this.ms1=h(this.e,this.sinphi,this.cosphi),this.ml1=i(this.e0,this.e1,this.e2,this.e3,this.lat1),Math.abs(this.lat1-this.lat2)<m?this.ns=this.sinphi:(this.sinphi=Math.sin(this.lat2),this.cosphi=Math.cos(this.lat2),this.ms2=h(this.e,this.sinphi,this.cosphi),this.ml2=i(this.e0,this.e1,this.e2,this.e3,this.lat2),this.ns=(this.ms1-this.ms2)/(this.ml2-this.ml1)),this.g=this.ml1+this.ms1/this.ns,this.ml0=i(this.e0,this.e1,this.e2,this.e3,this.lat0),this.rh=this.a*(this.g-this.ml0))},c.forward=function(a){var b,c=a.x,d=a.y;if(this.sphere)b=this.a*(this.g-d);else{var e=i(this.e0,this.e1,this.e2,this.e3,d);b=this.a*(this.g-e)}var f=this.ns*j(c-this.long0),g=this.x0+b*Math.sin(f),h=this.y0+this.rh-b*Math.cos(f);return a.x=g,a.y=h,a},c.inverse=function(a){a.x-=this.x0,a.y=this.rh-a.y+this.y0;var b,c,d,e;this.ns>=0?(c=Math.sqrt(a.x*a.x+a.y*a.y),b=1):(c=-Math.sqrt(a.x*a.x+a.y*a.y),b=-1);var f=0;if(0!==c&&(f=Math.atan2(b*a.x,b*a.y)),this.sphere)return e=j(this.long0+f/this.ns),d=k(this.g-c/this.a),a.x=e,a.y=d,a;var g=this.g-c/this.a;return d=l(g,this.e0,this.e1,this.e2,this.e3),e=j(this.long0+f/this.ns),a.x=e,a.y=d,a},c.names=["Equidistant_Conic","eqdc"]},{"../common/adjust_lat":4,"../common/adjust_lon":5,"../common/e0fn":7,"../common/e1fn":8,"../common/e2fn":9,"../common/e3fn":10,"../common/imlfn":12,"../common/mlfn":14,"../common/msfnz":15}],46:[function(a,b,c){var d=Math.PI/4,e=a("../common/srat"),f=Math.PI/2,g=20;c.init=function(){var a=Math.sin(this.lat0),b=Math.cos(this.lat0);b*=b,this.rc=Math.sqrt(1-this.es)/(1-this.es*a*a),this.C=Math.sqrt(1+this.es*b*b/(1-this.es)),this.phic0=Math.asin(a/this.C),this.ratexp=.5*this.C*this.e,this.K=Math.tan(.5*this.phic0+d)/(Math.pow(Math.tan(.5*this.lat0+d),this.C)*e(this.e*a,this.ratexp))},c.forward=function(a){var b=a.x,c=a.y;return a.y=2*Math.atan(this.K*Math.pow(Math.tan(.5*c+d),this.C)*e(this.e*Math.sin(c),this.ratexp))-f,a.x=this.C*b,a},c.inverse=function(a){for(var b=1e-14,c=a.x/this.C,h=a.y,i=Math.pow(Math.tan(.5*h+d)/this.K,1/this.C),j=g;j>0&&(h=2*Math.atan(i*e(this.e*Math.sin(a.y),-.5*this.e))-f,!(Math.abs(h-a.y)<b));--j)a.y=h;return j?(a.x=c,a.y=h,a):null},c.names=["gauss"]},{"../common/srat":22}],47:[function(a,b,c){var d=a("../common/adjust_lon"),e=1e-10,f=a("../common/asinz");c.init=function(){this.sin_p14=Math.sin(this.lat0),
this.cos_p14=Math.cos(this.lat0),this.infinity_dist=1e3*this.a,this.rc=1},c.forward=function(a){var b,c,f,g,h,i,j,k,l=a.x,m=a.y;return f=d(l-this.long0),b=Math.sin(m),c=Math.cos(m),g=Math.cos(f),i=this.sin_p14*b+this.cos_p14*c*g,h=1,i>0||Math.abs(i)<=e?(j=this.x0+this.a*h*c*Math.sin(f)/i,k=this.y0+this.a*h*(this.cos_p14*b-this.sin_p14*c*g)/i):(j=this.x0+this.infinity_dist*c*Math.sin(f),k=this.y0+this.infinity_dist*(this.cos_p14*b-this.sin_p14*c*g)),a.x=j,a.y=k,a},c.inverse=function(a){var b,c,e,g,h,i;return a.x=(a.x-this.x0)/this.a,a.y=(a.y-this.y0)/this.a,a.x/=this.k0,a.y/=this.k0,(b=Math.sqrt(a.x*a.x+a.y*a.y))?(g=Math.atan2(b,this.rc),c=Math.sin(g),e=Math.cos(g),i=f(e*this.sin_p14+a.y*c*this.cos_p14/b),h=Math.atan2(a.x*c,b*this.cos_p14*e-a.y*this.sin_p14*c),h=d(this.long0+h)):(i=this.phic0,h=0),a.x=h,a.y=i,a},c.names=["gnom"]},{"../common/adjust_lon":5,"../common/asinz":6}],48:[function(a,b,c){var d=a("../common/adjust_lon");c.init=function(){this.a=6377397.155,this.es=.006674372230614,this.e=Math.sqrt(this.es),this.lat0||(this.lat0=.863937979737193),this.long0||(this.long0=.4334234309119251),this.k0||(this.k0=.9999),this.s45=.785398163397448,this.s90=2*this.s45,this.fi0=this.lat0,this.e2=this.es,this.e=Math.sqrt(this.e2),this.alfa=Math.sqrt(1+this.e2*Math.pow(Math.cos(this.fi0),4)/(1-this.e2)),this.uq=1.04216856380474,this.u0=Math.asin(Math.sin(this.fi0)/this.alfa),this.g=Math.pow((1+this.e*Math.sin(this.fi0))/(1-this.e*Math.sin(this.fi0)),this.alfa*this.e/2),this.k=Math.tan(this.u0/2+this.s45)/Math.pow(Math.tan(this.fi0/2+this.s45),this.alfa)*this.g,this.k1=this.k0,this.n0=this.a*Math.sqrt(1-this.e2)/(1-this.e2*Math.pow(Math.sin(this.fi0),2)),this.s0=1.37008346281555,this.n=Math.sin(this.s0),this.ro0=this.k1*this.n0/Math.tan(this.s0),this.ad=this.s90-this.uq},c.forward=function(a){var b,c,e,f,g,h,i,j=a.x,k=a.y,l=d(j-this.long0);return b=Math.pow((1+this.e*Math.sin(k))/(1-this.e*Math.sin(k)),this.alfa*this.e/2),c=2*(Math.atan(this.k*Math.pow(Math.tan(k/2+this.s45),this.alfa)/b)-this.s45),e=-l*this.alfa,f=Math.asin(Math.cos(this.ad)*Math.sin(c)+Math.sin(this.ad)*Math.cos(c)*Math.cos(e)),g=Math.asin(Math.cos(c)*Math.sin(e)/Math.cos(f)),h=this.n*g,i=this.ro0*Math.pow(Math.tan(this.s0/2+this.s45),this.n)/Math.pow(Math.tan(f/2+this.s45),this.n),a.y=i*Math.cos(h)/1,a.x=i*Math.sin(h)/1,this.czech||(a.y*=-1,a.x*=-1),a},c.inverse=function(a){var b,c,d,e,f,g,h,i,j=a.x;a.x=a.y,a.y=j,this.czech||(a.y*=-1,a.x*=-1),g=Math.sqrt(a.x*a.x+a.y*a.y),f=Math.atan2(a.y,a.x),e=f/Math.sin(this.s0),d=2*(Math.atan(Math.pow(this.ro0/g,1/this.n)*Math.tan(this.s0/2+this.s45))-this.s45),b=Math.asin(Math.cos(this.ad)*Math.sin(d)-Math.sin(this.ad)*Math.cos(d)*Math.cos(e)),c=Math.asin(Math.cos(d)*Math.sin(e)/Math.cos(b)),a.x=this.long0-c/this.alfa,h=b,i=0;var k=0;do a.y=2*(Math.atan(Math.pow(this.k,-1/this.alfa)*Math.pow(Math.tan(b/2+this.s45),1/this.alfa)*Math.pow((1+this.e*Math.sin(h))/(1-this.e*Math.sin(h)),this.e/2))-this.s45),Math.abs(h-a.y)<1e-10&&(i=1),h=a.y,k+=1;while(0===i&&15>k);return k>=15?null:a},c.names=["Krovak","krovak"]},{"../common/adjust_lon":5}],49:[function(a,b,c){var d=Math.PI/2,e=Math.PI/4,f=1e-10,g=a("../common/qsfnz"),h=a("../common/adjust_lon");c.S_POLE=1,c.N_POLE=2,c.EQUIT=3,c.OBLIQ=4,c.init=function(){var a=Math.abs(this.lat0);if(this.mode=Math.abs(a-d)<f?this.lat0<0?this.S_POLE:this.N_POLE:Math.abs(a)<f?this.EQUIT:this.OBLIQ,this.es>0){var b;switch(this.qp=g(this.e,1),this.mmf=.5/(1-this.es),this.apa=this.authset(this.es),this.mode){case this.N_POLE:this.dd=1;break;case this.S_POLE:this.dd=1;break;case this.EQUIT:this.rq=Math.sqrt(.5*this.qp),this.dd=1/this.rq,this.xmf=1,this.ymf=.5*this.qp;break;case this.OBLIQ:this.rq=Math.sqrt(.5*this.qp),b=Math.sin(this.lat0),this.sinb1=g(this.e,b)/this.qp,this.cosb1=Math.sqrt(1-this.sinb1*this.sinb1),this.dd=Math.cos(this.lat0)/(Math.sqrt(1-this.es*b*b)*this.rq*this.cosb1),this.ymf=(this.xmf=this.rq)/this.dd,this.xmf*=this.dd}}else this.mode===this.OBLIQ&&(this.sinph0=Math.sin(this.lat0),this.cosph0=Math.cos(this.lat0))},c.forward=function(a){var b,c,i,j,k,l,m,n,o,p,q=a.x,r=a.y;if(q=h(q-this.long0),this.sphere){if(k=Math.sin(r),p=Math.cos(r),i=Math.cos(q),this.mode===this.OBLIQ||this.mode===this.EQUIT){if(c=this.mode===this.EQUIT?1+p*i:1+this.sinph0*k+this.cosph0*p*i,f>=c)return null;c=Math.sqrt(2/c),b=c*p*Math.sin(q),c*=this.mode===this.EQUIT?k:this.cosph0*k-this.sinph0*p*i}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(i=-i),Math.abs(r+this.phi0)<f)return null;c=e-.5*r,c=2*(this.mode===this.S_POLE?Math.cos(c):Math.sin(c)),b=c*Math.sin(q),c*=i}}else{switch(m=0,n=0,o=0,i=Math.cos(q),j=Math.sin(q),k=Math.sin(r),l=g(this.e,k),(this.mode===this.OBLIQ||this.mode===this.EQUIT)&&(m=l/this.qp,n=Math.sqrt(1-m*m)),this.mode){case this.OBLIQ:o=1+this.sinb1*m+this.cosb1*n*i;break;case this.EQUIT:o=1+n*i;break;case this.N_POLE:o=d+r,l=this.qp-l;break;case this.S_POLE:o=r-d,l=this.qp+l}if(Math.abs(o)<f)return null;switch(this.mode){case this.OBLIQ:case this.EQUIT:o=Math.sqrt(2/o),c=this.mode===this.OBLIQ?this.ymf*o*(this.cosb1*m-this.sinb1*n*i):(o=Math.sqrt(2/(1+n*i)))*m*this.ymf,b=this.xmf*o*n*j;break;case this.N_POLE:case this.S_POLE:l>=0?(b=(o=Math.sqrt(l))*j,c=i*(this.mode===this.S_POLE?o:-o)):b=c=0}}return a.x=this.a*b+this.x0,a.y=this.a*c+this.y0,a},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b,c,e,g,i,j,k,l=a.x/this.a,m=a.y/this.a;if(this.sphere){var n,o=0,p=0;if(n=Math.sqrt(l*l+m*m),c=.5*n,c>1)return null;switch(c=2*Math.asin(c),(this.mode===this.OBLIQ||this.mode===this.EQUIT)&&(p=Math.sin(c),o=Math.cos(c)),this.mode){case this.EQUIT:c=Math.abs(n)<=f?0:Math.asin(m*p/n),l*=p,m=o*n;break;case this.OBLIQ:c=Math.abs(n)<=f?this.phi0:Math.asin(o*this.sinph0+m*p*this.cosph0/n),l*=p*this.cosph0,m=(o-Math.sin(c)*this.sinph0)*n;break;case this.N_POLE:m=-m,c=d-c;break;case this.S_POLE:c-=d}b=0!==m||this.mode!==this.EQUIT&&this.mode!==this.OBLIQ?Math.atan2(l,m):0}else{if(k=0,this.mode===this.OBLIQ||this.mode===this.EQUIT){if(l/=this.dd,m*=this.dd,j=Math.sqrt(l*l+m*m),f>j)return a.x=0,a.y=this.phi0,a;g=2*Math.asin(.5*j/this.rq),e=Math.cos(g),l*=g=Math.sin(g),this.mode===this.OBLIQ?(k=e*this.sinb1+m*g*this.cosb1/j,i=this.qp*k,m=j*this.cosb1*e-m*this.sinb1*g):(k=m*g/j,i=this.qp*k,m=j*e)}else if(this.mode===this.N_POLE||this.mode===this.S_POLE){if(this.mode===this.N_POLE&&(m=-m),i=l*l+m*m,!i)return a.x=0,a.y=this.phi0,a;k=1-i/this.qp,this.mode===this.S_POLE&&(k=-k)}b=Math.atan2(l,m),c=this.authlat(Math.asin(k),this.apa)}return a.x=h(this.long0+b),a.y=c,a},c.P00=.3333333333333333,c.P01=.17222222222222222,c.P02=.10257936507936508,c.P10=.06388888888888888,c.P11=.0664021164021164,c.P20=.016415012942191543,c.authset=function(a){var b,c=[];return c[0]=a*this.P00,b=a*a,c[0]+=b*this.P01,c[1]=b*this.P10,b*=a,c[0]+=b*this.P02,c[1]+=b*this.P11,c[2]=b*this.P20,c},c.authlat=function(a,b){var c=a+a;return a+b[0]*Math.sin(c)+b[1]*Math.sin(c+c)+b[2]*Math.sin(c+c+c)},c.names=["Lambert Azimuthal Equal Area","Lambert_Azimuthal_Equal_Area","laea"]},{"../common/adjust_lon":5,"../common/qsfnz":20}],50:[function(a,b,c){var d=1e-10,e=a("../common/msfnz"),f=a("../common/tsfnz"),g=Math.PI/2,h=a("../common/sign"),i=a("../common/adjust_lon"),j=a("../common/phi2z");c.init=function(){if(this.lat2||(this.lat2=this.lat1),this.k0||(this.k0=1),this.x0=this.x0||0,this.y0=this.y0||0,!(Math.abs(this.lat1+this.lat2)<d)){var a=this.b/this.a;this.e=Math.sqrt(1-a*a);var b=Math.sin(this.lat1),c=Math.cos(this.lat1),g=e(this.e,b,c),h=f(this.e,this.lat1,b),i=Math.sin(this.lat2),j=Math.cos(this.lat2),k=e(this.e,i,j),l=f(this.e,this.lat2,i),m=f(this.e,this.lat0,Math.sin(this.lat0));this.ns=Math.abs(this.lat1-this.lat2)>d?Math.log(g/k)/Math.log(h/l):b,isNaN(this.ns)&&(this.ns=b),this.f0=g/(this.ns*Math.pow(h,this.ns)),this.rh=this.a*this.f0*Math.pow(m,this.ns),this.title||(this.title="Lambert Conformal Conic")}},c.forward=function(a){var b=a.x,c=a.y;Math.abs(2*Math.abs(c)-Math.PI)<=d&&(c=h(c)*(g-2*d));var e,j,k=Math.abs(Math.abs(c)-g);if(k>d)e=f(this.e,c,Math.sin(c)),j=this.a*this.f0*Math.pow(e,this.ns);else{if(k=c*this.ns,0>=k)return null;j=0}var l=this.ns*i(b-this.long0);return a.x=this.k0*j*Math.sin(l)+this.x0,a.y=this.k0*(this.rh-j*Math.cos(l))+this.y0,a},c.inverse=function(a){var b,c,d,e,f,h=(a.x-this.x0)/this.k0,k=this.rh-(a.y-this.y0)/this.k0;this.ns>0?(b=Math.sqrt(h*h+k*k),c=1):(b=-Math.sqrt(h*h+k*k),c=-1);var l=0;if(0!==b&&(l=Math.atan2(c*h,c*k)),0!==b||this.ns>0){if(c=1/this.ns,d=Math.pow(b/(this.a*this.f0),c),e=j(this.e,d),-9999===e)return null}else e=-g;return f=i(l/this.ns+this.long0),a.x=f,a.y=e,a},c.names=["Lambert Tangential Conformal Conic Projection","Lambert_Conformal_Conic","Lambert_Conformal_Conic_2SP","lcc"]},{"../common/adjust_lon":5,"../common/msfnz":15,"../common/phi2z":16,"../common/sign":21,"../common/tsfnz":24}],51:[function(a,b,c){function d(a){return a}c.init=function(){},c.forward=d,c.inverse=d,c.names=["longlat","identity"]},{}],52:[function(a,b,c){var d=a("../common/msfnz"),e=Math.PI/2,f=1e-10,g=57.29577951308232,h=a("../common/adjust_lon"),i=Math.PI/4,j=a("../common/tsfnz"),k=a("../common/phi2z");c.init=function(){var a=this.b/this.a;this.es=1-a*a,"x0"in this||(this.x0=0),"y0"in this||(this.y0=0),this.e=Math.sqrt(this.es),this.lat_ts?this.k0=this.sphere?Math.cos(this.lat_ts):d(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts)):this.k0||(this.k0=this.k?this.k:1)},c.forward=function(a){var b=a.x,c=a.y;if(c*g>90&&-90>c*g&&b*g>180&&-180>b*g)return null;var d,k;if(Math.abs(Math.abs(c)-e)<=f)return null;if(this.sphere)d=this.x0+this.a*this.k0*h(b-this.long0),k=this.y0+this.a*this.k0*Math.log(Math.tan(i+.5*c));else{var l=Math.sin(c),m=j(this.e,c,l);d=this.x0+this.a*this.k0*h(b-this.long0),k=this.y0-this.a*this.k0*Math.log(m)}return a.x=d,a.y=k,a},c.inverse=function(a){var b,c,d=a.x-this.x0,f=a.y-this.y0;if(this.sphere)c=e-2*Math.atan(Math.exp(-f/(this.a*this.k0)));else{var g=Math.exp(-f/(this.a*this.k0));if(c=k(this.e,g),-9999===c)return null}return b=h(this.long0+d/(this.a*this.k0)),a.x=b,a.y=c,a},c.names=["Mercator","Popular Visualisation Pseudo Mercator","Mercator_1SP","Mercator_Auxiliary_Sphere","merc"]},{"../common/adjust_lon":5,"../common/msfnz":15,"../common/phi2z":16,"../common/tsfnz":24}],53:[function(a,b,c){var d=a("../common/adjust_lon");c.init=function(){},c.forward=function(a){var b=a.x,c=a.y,e=d(b-this.long0),f=this.x0+this.a*e,g=this.y0+this.a*Math.log(Math.tan(Math.PI/4+c/2.5))*1.25;return a.x=f,a.y=g,a},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b=d(this.long0+a.x/this.a),c=2.5*(Math.atan(Math.exp(.8*a.y/this.a))-Math.PI/4);return a.x=b,a.y=c,a},c.names=["Miller_Cylindrical","mill"]},{"../common/adjust_lon":5}],54:[function(a,b,c){var d=a("../common/adjust_lon"),e=1e-10;c.init=function(){},c.forward=function(a){for(var b=a.x,c=a.y,f=d(b-this.long0),g=c,h=Math.PI*Math.sin(c),i=0;!0;i++){var j=-(g+Math.sin(g)-h)/(1+Math.cos(g));if(g+=j,Math.abs(j)<e)break}g/=2,Math.PI/2-Math.abs(c)<e&&(f=0);var k=.900316316158*this.a*f*Math.cos(g)+this.x0,l=1.4142135623731*this.a*Math.sin(g)+this.y0;return a.x=k,a.y=l,a},c.inverse=function(a){var b,c;a.x-=this.x0,a.y-=this.y0,c=a.y/(1.4142135623731*this.a),Math.abs(c)>.999999999999&&(c=.999999999999),b=Math.asin(c);var e=d(this.long0+a.x/(.900316316158*this.a*Math.cos(b)));e<-Math.PI&&(e=-Math.PI),e>Math.PI&&(e=Math.PI),c=(2*b+Math.sin(2*b))/Math.PI,Math.abs(c)>1&&(c=1);var f=Math.asin(c);return a.x=e,a.y=f,a},c.names=["Mollweide","moll"]},{"../common/adjust_lon":5}],55:[function(a,b,c){var d=484813681109536e-20;c.iterations=1,c.init=function(){this.A=[],this.A[1]=.6399175073,this.A[2]=-.1358797613,this.A[3]=.063294409,this.A[4]=-.02526853,this.A[5]=.0117879,this.A[6]=-.0055161,this.A[7]=.0026906,this.A[8]=-.001333,this.A[9]=67e-5,this.A[10]=-34e-5,this.B_re=[],this.B_im=[],this.B_re[1]=.7557853228,this.B_im[1]=0,this.B_re[2]=.249204646,this.B_im[2]=.003371507,this.B_re[3]=-.001541739,this.B_im[3]=.04105856,this.B_re[4]=-.10162907,this.B_im[4]=.01727609,this.B_re[5]=-.26623489,this.B_im[5]=-.36249218,this.B_re[6]=-.6870983,this.B_im[6]=-1.1651967,this.C_re=[],this.C_im=[],this.C_re[1]=1.3231270439,this.C_im[1]=0,this.C_re[2]=-.577245789,this.C_im[2]=-.007809598,this.C_re[3]=.508307513,this.C_im[3]=-.112208952,this.C_re[4]=-.15094762,this.C_im[4]=.18200602,this.C_re[5]=1.01418179,this.C_im[5]=1.64497696,this.C_re[6]=1.9660549,this.C_im[6]=2.5127645,this.D=[],this.D[1]=1.5627014243,this.D[2]=.5185406398,this.D[3]=-.03333098,this.D[4]=-.1052906,this.D[5]=-.0368594,this.D[6]=.007317,this.D[7]=.0122,this.D[8]=.00394,this.D[9]=-.0013},c.forward=function(a){var b,c=a.x,e=a.y,f=e-this.lat0,g=c-this.long0,h=f/d*1e-5,i=g,j=1,k=0;for(b=1;10>=b;b++)j*=h,k+=this.A[b]*j;var l,m,n=k,o=i,p=1,q=0,r=0,s=0;for(b=1;6>=b;b++)l=p*n-q*o,m=q*n+p*o,p=l,q=m,r=r+this.B_re[b]*p-this.B_im[b]*q,s=s+this.B_im[b]*p+this.B_re[b]*q;return a.x=s*this.a+this.x0,a.y=r*this.a+this.y0,a},c.inverse=function(a){var b,c,e,f=a.x,g=a.y,h=f-this.x0,i=g-this.y0,j=i/this.a,k=h/this.a,l=1,m=0,n=0,o=0;for(b=1;6>=b;b++)c=l*j-m*k,e=m*j+l*k,l=c,m=e,n=n+this.C_re[b]*l-this.C_im[b]*m,o=o+this.C_im[b]*l+this.C_re[b]*m;for(var p=0;p<this.iterations;p++){var q,r,s=n,t=o,u=j,v=k;for(b=2;6>=b;b++)q=s*n-t*o,r=t*n+s*o,s=q,t=r,u+=(b-1)*(this.B_re[b]*s-this.B_im[b]*t),v+=(b-1)*(this.B_im[b]*s+this.B_re[b]*t);s=1,t=0;var w=this.B_re[1],x=this.B_im[1];for(b=2;6>=b;b++)q=s*n-t*o,r=t*n+s*o,s=q,t=r,w+=b*(this.B_re[b]*s-this.B_im[b]*t),x+=b*(this.B_im[b]*s+this.B_re[b]*t);var y=w*w+x*x;n=(u*w+v*x)/y,o=(v*w-u*x)/y}var z=n,A=o,B=1,C=0;for(b=1;9>=b;b++)B*=z,C+=this.D[b]*B;var D=this.lat0+C*d*1e5,E=this.long0+A;return a.x=E,a.y=D,a},c.names=["New_Zealand_Map_Grid","nzmg"]},{}],56:[function(a,b,c){var d=a("../common/tsfnz"),e=a("../common/adjust_lon"),f=a("../common/phi2z"),g=Math.PI/2,h=Math.PI/4,i=1e-10;c.init=function(){this.no_off=this.no_off||!1,this.no_rot=this.no_rot||!1,isNaN(this.k0)&&(this.k0=1);var a=Math.sin(this.lat0),b=Math.cos(this.lat0),c=this.e*a;this.bl=Math.sqrt(1+this.es/(1-this.es)*Math.pow(b,4)),this.al=this.a*this.bl*this.k0*Math.sqrt(1-this.es)/(1-c*c);var f=d(this.e,this.lat0,a),g=this.bl/b*Math.sqrt((1-this.es)/(1-c*c));1>g*g&&(g=1);var h,i;if(isNaN(this.longc)){var j=d(this.e,this.lat1,Math.sin(this.lat1)),k=d(this.e,this.lat2,Math.sin(this.lat2));this.el=this.lat0>=0?(g+Math.sqrt(g*g-1))*Math.pow(f,this.bl):(g-Math.sqrt(g*g-1))*Math.pow(f,this.bl);var l=Math.pow(j,this.bl),m=Math.pow(k,this.bl);h=this.el/l,i=.5*(h-1/h);var n=(this.el*this.el-m*l)/(this.el*this.el+m*l),o=(m-l)/(m+l),p=e(this.long1-this.long2);this.long0=.5*(this.long1+this.long2)-Math.atan(n*Math.tan(.5*this.bl*p)/o)/this.bl,this.long0=e(this.long0);var q=e(this.long1-this.long0);this.gamma0=Math.atan(Math.sin(this.bl*q)/i),this.alpha=Math.asin(g*Math.sin(this.gamma0))}else h=this.lat0>=0?g+Math.sqrt(g*g-1):g-Math.sqrt(g*g-1),this.el=h*Math.pow(f,this.bl),i=.5*(h-1/h),this.gamma0=Math.asin(Math.sin(this.alpha)/g),this.long0=this.longc-Math.asin(i*Math.tan(this.gamma0))/this.bl;this.uc=this.no_off?0:this.lat0>=0?this.al/this.bl*Math.atan2(Math.sqrt(g*g-1),Math.cos(this.alpha)):-1*this.al/this.bl*Math.atan2(Math.sqrt(g*g-1),Math.cos(this.alpha))},c.forward=function(a){var b,c,f,j=a.x,k=a.y,l=e(j-this.long0);if(Math.abs(Math.abs(k)-g)<=i)f=k>0?-1:1,c=this.al/this.bl*Math.log(Math.tan(h+f*this.gamma0*.5)),b=-1*f*g*this.al/this.bl;else{var m=d(this.e,k,Math.sin(k)),n=this.el/Math.pow(m,this.bl),o=.5*(n-1/n),p=.5*(n+1/n),q=Math.sin(this.bl*l),r=(o*Math.sin(this.gamma0)-q*Math.cos(this.gamma0))/p;c=Math.abs(Math.abs(r)-1)<=i?Number.POSITIVE_INFINITY:.5*this.al*Math.log((1-r)/(1+r))/this.bl,b=Math.abs(Math.cos(this.bl*l))<=i?this.al*this.bl*l:this.al*Math.atan2(o*Math.cos(this.gamma0)+q*Math.sin(this.gamma0),Math.cos(this.bl*l))/this.bl}return this.no_rot?(a.x=this.x0+b,a.y=this.y0+c):(b-=this.uc,a.x=this.x0+c*Math.cos(this.alpha)+b*Math.sin(this.alpha),a.y=this.y0+b*Math.cos(this.alpha)-c*Math.sin(this.alpha)),a},c.inverse=function(a){var b,c;this.no_rot?(c=a.y-this.y0,b=a.x-this.x0):(c=(a.x-this.x0)*Math.cos(this.alpha)-(a.y-this.y0)*Math.sin(this.alpha),b=(a.y-this.y0)*Math.cos(this.alpha)+(a.x-this.x0)*Math.sin(this.alpha),b+=this.uc);var d=Math.exp(-1*this.bl*c/this.al),h=.5*(d-1/d),j=.5*(d+1/d),k=Math.sin(this.bl*b/this.al),l=(k*Math.cos(this.gamma0)+h*Math.sin(this.gamma0))/j,m=Math.pow(this.el/Math.sqrt((1+l)/(1-l)),1/this.bl);return Math.abs(l-1)<i?(a.x=this.long0,a.y=g):Math.abs(l+1)<i?(a.x=this.long0,a.y=-1*g):(a.y=f(this.e,m),a.x=e(this.long0-Math.atan2(h*Math.cos(this.gamma0)-k*Math.sin(this.gamma0),Math.cos(this.bl*b/this.al))/this.bl)),a},c.names=["Hotine_Oblique_Mercator","Hotine Oblique Mercator","Hotine_Oblique_Mercator_Azimuth_Natural_Origin","Hotine_Oblique_Mercator_Azimuth_Center","omerc"]},{"../common/adjust_lon":5,"../common/phi2z":16,"../common/tsfnz":24}],57:[function(a,b,c){var d=a("../common/e0fn"),e=a("../common/e1fn"),f=a("../common/e2fn"),g=a("../common/e3fn"),h=a("../common/adjust_lon"),i=a("../common/adjust_lat"),j=a("../common/mlfn"),k=1e-10,l=a("../common/gN"),m=20;c.init=function(){this.temp=this.b/this.a,this.es=1-Math.pow(this.temp,2),this.e=Math.sqrt(this.es),this.e0=d(this.es),this.e1=e(this.es),this.e2=f(this.es),this.e3=g(this.es),this.ml0=this.a*j(this.e0,this.e1,this.e2,this.e3,this.lat0)},c.forward=function(a){var b,c,d,e=a.x,f=a.y,g=h(e-this.long0);if(d=g*Math.sin(f),this.sphere)Math.abs(f)<=k?(b=this.a*g,c=-1*this.a*this.lat0):(b=this.a*Math.sin(d)/Math.tan(f),c=this.a*(i(f-this.lat0)+(1-Math.cos(d))/Math.tan(f)));else if(Math.abs(f)<=k)b=this.a*g,c=-1*this.ml0;else{var m=l(this.a,this.e,Math.sin(f))/Math.tan(f);b=m*Math.sin(d),c=this.a*j(this.e0,this.e1,this.e2,this.e3,f)-this.ml0+m*(1-Math.cos(d))}return a.x=b+this.x0,a.y=c+this.y0,a},c.inverse=function(a){var b,c,d,e,f,g,i,l,n;if(d=a.x-this.x0,e=a.y-this.y0,this.sphere)if(Math.abs(e+this.a*this.lat0)<=k)b=h(d/this.a+this.long0),c=0;else{g=this.lat0+e/this.a,i=d*d/this.a/this.a+g*g,l=g;var o;for(f=m;f;--f)if(o=Math.tan(l),n=-1*(g*(l*o+1)-l-.5*(l*l+i)*o)/((l-g)/o-1),l+=n,Math.abs(n)<=k){c=l;break}b=h(this.long0+Math.asin(d*Math.tan(l)/this.a)/Math.sin(c))}else if(Math.abs(e+this.ml0)<=k)c=0,b=h(this.long0+d/this.a);else{g=(this.ml0+e)/this.a,i=d*d/this.a/this.a+g*g,l=g;var p,q,r,s,t;for(f=m;f;--f)if(t=this.e*Math.sin(l),p=Math.sqrt(1-t*t)*Math.tan(l),q=this.a*j(this.e0,this.e1,this.e2,this.e3,l),r=this.e0-2*this.e1*Math.cos(2*l)+4*this.e2*Math.cos(4*l)-6*this.e3*Math.cos(6*l),s=q/this.a,n=(g*(p*s+1)-s-.5*p*(s*s+i))/(this.es*Math.sin(2*l)*(s*s+i-2*g*s)/(4*p)+(g-s)*(p*r-2/Math.sin(2*l))-r),l-=n,Math.abs(n)<=k){c=l;break}p=Math.sqrt(1-this.es*Math.pow(Math.sin(c),2))*Math.tan(c),b=h(this.long0+Math.asin(d*p/this.a)/Math.sin(c))}return a.x=b,a.y=c,a},c.names=["Polyconic","poly"]},{"../common/adjust_lat":4,"../common/adjust_lon":5,"../common/e0fn":7,"../common/e1fn":8,"../common/e2fn":9,"../common/e3fn":10,"../common/gN":11,"../common/mlfn":14}],58:[function(a,b,c){var d=a("../common/adjust_lon"),e=a("../common/adjust_lat"),f=a("../common/pj_enfn"),g=20,h=a("../common/pj_mlfn"),i=a("../common/pj_inv_mlfn"),j=Math.PI/2,k=1e-10,l=a("../common/asinz");c.init=function(){this.sphere?(this.n=1,this.m=0,this.es=0,this.C_y=Math.sqrt((this.m+1)/this.n),this.C_x=this.C_y/(this.m+1)):this.en=f(this.es)},c.forward=function(a){var b,c,e=a.x,f=a.y;if(e=d(e-this.long0),this.sphere){if(this.m)for(var i=this.n*Math.sin(f),j=g;j;--j){var l=(this.m*f+Math.sin(f)-i)/(this.m+Math.cos(f));if(f-=l,Math.abs(l)<k)break}else f=1!==this.n?Math.asin(this.n*Math.sin(f)):f;b=this.a*this.C_x*e*(this.m+Math.cos(f)),c=this.a*this.C_y*f}else{var m=Math.sin(f),n=Math.cos(f);c=this.a*h(f,m,n,this.en),b=this.a*e*n/Math.sqrt(1-this.es*m*m)}return a.x=b,a.y=c,a},c.inverse=function(a){var b,c,f,g;return a.x-=this.x0,f=a.x/this.a,a.y-=this.y0,b=a.y/this.a,this.sphere?(b/=this.C_y,f/=this.C_x*(this.m+Math.cos(b)),this.m?b=l((this.m*b+Math.sin(b))/this.n):1!==this.n&&(b=l(Math.sin(b)/this.n)),f=d(f+this.long0),b=e(b)):(b=i(a.y/this.a,this.es,this.en),g=Math.abs(b),j>g?(g=Math.sin(b),c=this.long0+a.x*Math.sqrt(1-this.es*g*g)/(this.a*Math.cos(b)),f=d(c)):j>g-k&&(f=this.long0)),a.x=f,a.y=b,a},c.names=["Sinusoidal","sinu"]},{"../common/adjust_lat":4,"../common/adjust_lon":5,"../common/asinz":6,"../common/pj_enfn":17,"../common/pj_inv_mlfn":18,"../common/pj_mlfn":19}],59:[function(a,b,c){c.init=function(){var a=this.lat0;this.lambda0=this.long0;var b=Math.sin(a),c=this.a,d=this.rf,e=1/d,f=2*e-Math.pow(e,2),g=this.e=Math.sqrt(f);this.R=this.k0*c*Math.sqrt(1-f)/(1-f*Math.pow(b,2)),this.alpha=Math.sqrt(1+f/(1-f)*Math.pow(Math.cos(a),4)),this.b0=Math.asin(b/this.alpha);var h=Math.log(Math.tan(Math.PI/4+this.b0/2)),i=Math.log(Math.tan(Math.PI/4+a/2)),j=Math.log((1+g*b)/(1-g*b));this.K=h-this.alpha*i+this.alpha*g/2*j},c.forward=function(a){var b=Math.log(Math.tan(Math.PI/4-a.y/2)),c=this.e/2*Math.log((1+this.e*Math.sin(a.y))/(1-this.e*Math.sin(a.y))),d=-this.alpha*(b+c)+this.K,e=2*(Math.atan(Math.exp(d))-Math.PI/4),f=this.alpha*(a.x-this.lambda0),g=Math.atan(Math.sin(f)/(Math.sin(this.b0)*Math.tan(e)+Math.cos(this.b0)*Math.cos(f))),h=Math.asin(Math.cos(this.b0)*Math.sin(e)-Math.sin(this.b0)*Math.cos(e)*Math.cos(f));return a.y=this.R/2*Math.log((1+Math.sin(h))/(1-Math.sin(h)))+this.y0,a.x=this.R*g+this.x0,a},c.inverse=function(a){for(var b=a.x-this.x0,c=a.y-this.y0,d=b/this.R,e=2*(Math.atan(Math.exp(c/this.R))-Math.PI/4),f=Math.asin(Math.cos(this.b0)*Math.sin(e)+Math.sin(this.b0)*Math.cos(e)*Math.cos(d)),g=Math.atan(Math.sin(d)/(Math.cos(this.b0)*Math.cos(d)-Math.sin(this.b0)*Math.tan(e))),h=this.lambda0+g/this.alpha,i=0,j=f,k=-1e3,l=0;Math.abs(j-k)>1e-7;){if(++l>20)return;i=1/this.alpha*(Math.log(Math.tan(Math.PI/4+f/2))-this.K)+this.e*Math.log(Math.tan(Math.PI/4+Math.asin(this.e*Math.sin(j))/2)),k=j,j=2*Math.atan(Math.exp(i))-Math.PI/2}return a.x=h,a.y=j,a},c.names=["somerc"]},{}],60:[function(a,b,c){var d=Math.PI/2,e=1e-10,f=a("../common/sign"),g=a("../common/msfnz"),h=a("../common/tsfnz"),i=a("../common/phi2z"),j=a("../common/adjust_lon");c.ssfn_=function(a,b,c){return b*=c,Math.tan(.5*(d+a))*Math.pow((1-b)/(1+b),.5*c)},c.init=function(){this.coslat0=Math.cos(this.lat0),this.sinlat0=Math.sin(this.lat0),this.sphere?1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=e&&(this.k0=.5*(1+f(this.lat0)*Math.sin(this.lat_ts))):(Math.abs(this.coslat0)<=e&&(this.con=this.lat0>0?1:-1),this.cons=Math.sqrt(Math.pow(1+this.e,1+this.e)*Math.pow(1-this.e,1-this.e)),1===this.k0&&!isNaN(this.lat_ts)&&Math.abs(this.coslat0)<=e&&(this.k0=.5*this.cons*g(this.e,Math.sin(this.lat_ts),Math.cos(this.lat_ts))/h(this.e,this.con*this.lat_ts,this.con*Math.sin(this.lat_ts))),this.ms1=g(this.e,this.sinlat0,this.coslat0),this.X0=2*Math.atan(this.ssfn_(this.lat0,this.sinlat0,this.e))-d,this.cosX0=Math.cos(this.X0),this.sinX0=Math.sin(this.X0))},c.forward=function(a){var b,c,f,g,i,k,l=a.x,m=a.y,n=Math.sin(m),o=Math.cos(m),p=j(l-this.long0);return Math.abs(Math.abs(l-this.long0)-Math.PI)<=e&&Math.abs(m+this.lat0)<=e?(a.x=0/0,a.y=0/0,a):this.sphere?(b=2*this.k0/(1+this.sinlat0*n+this.coslat0*o*Math.cos(p)),a.x=this.a*b*o*Math.sin(p)+this.x0,a.y=this.a*b*(this.coslat0*n-this.sinlat0*o*Math.cos(p))+this.y0,a):(c=2*Math.atan(this.ssfn_(m,n,this.e))-d,g=Math.cos(c),f=Math.sin(c),Math.abs(this.coslat0)<=e?(i=h(this.e,m*this.con,this.con*n),k=2*this.a*this.k0*i/this.cons,a.x=this.x0+k*Math.sin(l-this.long0),a.y=this.y0-this.con*k*Math.cos(l-this.long0),a):(Math.abs(this.sinlat0)<e?(b=2*this.a*this.k0/(1+g*Math.cos(p)),a.y=b*f):(b=2*this.a*this.k0*this.ms1/(this.cosX0*(1+this.sinX0*f+this.cosX0*g*Math.cos(p))),a.y=b*(this.cosX0*f-this.sinX0*g*Math.cos(p))+this.y0),a.x=b*g*Math.sin(p)+this.x0,a))},c.inverse=function(a){a.x-=this.x0,a.y-=this.y0;var b,c,f,g,h,k=Math.sqrt(a.x*a.x+a.y*a.y);if(this.sphere){var l=2*Math.atan(k/(.5*this.a*this.k0));return b=this.long0,c=this.lat0,e>=k?(a.x=b,a.y=c,a):(c=Math.asin(Math.cos(l)*this.sinlat0+a.y*Math.sin(l)*this.coslat0/k),b=j(Math.abs(this.coslat0)<e?this.lat0>0?this.long0+Math.atan2(a.x,-1*a.y):this.long0+Math.atan2(a.x,a.y):this.long0+Math.atan2(a.x*Math.sin(l),k*this.coslat0*Math.cos(l)-a.y*this.sinlat0*Math.sin(l))),a.x=b,a.y=c,a)}if(Math.abs(this.coslat0)<=e){if(e>=k)return c=this.lat0,b=this.long0,a.x=b,a.y=c,a;a.x*=this.con,a.y*=this.con,f=k*this.cons/(2*this.a*this.k0),c=this.con*i(this.e,f),b=this.con*j(this.con*this.long0+Math.atan2(a.x,-1*a.y))}else g=2*Math.atan(k*this.cosX0/(2*this.a*this.k0*this.ms1)),b=this.long0,e>=k?h=this.X0:(h=Math.asin(Math.cos(g)*this.sinX0+a.y*Math.sin(g)*this.cosX0/k),b=j(this.long0+Math.atan2(a.x*Math.sin(g),k*this.cosX0*Math.cos(g)-a.y*this.sinX0*Math.sin(g)))),c=-1*i(this.e,Math.tan(.5*(d+h)));return a.x=b,a.y=c,a},c.names=["stere","Stereographic_South_Pole","Polar Stereographic (variant B)"]},{"../common/adjust_lon":5,"../common/msfnz":15,"../common/phi2z":16,"../common/sign":21,"../common/tsfnz":24}],61:[function(a,b,c){var d=a("./gauss"),e=a("../common/adjust_lon");c.init=function(){d.init.apply(this),this.rc&&(this.sinc0=Math.sin(this.phic0),this.cosc0=Math.cos(this.phic0),this.R2=2*this.rc,this.title||(this.title="Oblique Stereographic Alternative"))},c.forward=function(a){var b,c,f,g;return a.x=e(a.x-this.long0),d.forward.apply(this,[a]),b=Math.sin(a.y),c=Math.cos(a.y),f=Math.cos(a.x),g=this.k0*this.R2/(1+this.sinc0*b+this.cosc0*c*f),a.x=g*c*Math.sin(a.x),a.y=g*(this.cosc0*b-this.sinc0*c*f),a.x=this.a*a.x+this.x0,a.y=this.a*a.y+this.y0,a},c.inverse=function(a){var b,c,f,g,h;if(a.x=(a.x-this.x0)/this.a,a.y=(a.y-this.y0)/this.a,a.x/=this.k0,a.y/=this.k0,h=Math.sqrt(a.x*a.x+a.y*a.y)){var i=2*Math.atan2(h,this.R2);b=Math.sin(i),c=Math.cos(i),g=Math.asin(c*this.sinc0+a.y*b*this.cosc0/h),f=Math.atan2(a.x*b,h*this.cosc0*c-a.y*this.sinc0*b)}else g=this.phic0,f=0;return a.x=f,a.y=g,d.inverse.apply(this,[a]),a.x=e(a.x+this.long0),a},c.names=["Stereographic_North_Pole","Oblique_Stereographic","Polar_Stereographic","sterea","Oblique Stereographic Alternative"]},{"../common/adjust_lon":5,"./gauss":46}],62:[function(a,b,c){var d=a("../common/e0fn"),e=a("../common/e1fn"),f=a("../common/e2fn"),g=a("../common/e3fn"),h=a("../common/mlfn"),i=a("../common/adjust_lon"),j=Math.PI/2,k=1e-10,l=a("../common/sign"),m=a("../common/asinz");c.init=function(){this.e0=d(this.es),this.e1=e(this.es),this.e2=f(this.es),this.e3=g(this.es),this.ml0=this.a*h(this.e0,this.e1,this.e2,this.e3,this.lat0)},c.forward=function(a){var b,c,d,e=a.x,f=a.y,g=i(e-this.long0),j=Math.sin(f),k=Math.cos(f);if(this.sphere){var l=k*Math.sin(g);if(Math.abs(Math.abs(l)-1)<1e-10)return 93;c=.5*this.a*this.k0*Math.log((1+l)/(1-l)),b=Math.acos(k*Math.cos(g)/Math.sqrt(1-l*l)),0>f&&(b=-b),d=this.a*this.k0*(b-this.lat0)}else{var m=k*g,n=Math.pow(m,2),o=this.ep2*Math.pow(k,2),p=Math.tan(f),q=Math.pow(p,2);b=1-this.es*Math.pow(j,2);var r=this.a/Math.sqrt(b),s=this.a*h(this.e0,this.e1,this.e2,this.e3,f);c=this.k0*r*m*(1+n/6*(1-q+o+n/20*(5-18*q+Math.pow(q,2)+72*o-58*this.ep2)))+this.x0,d=this.k0*(s-this.ml0+r*p*n*(.5+n/24*(5-q+9*o+4*Math.pow(o,2)+n/30*(61-58*q+Math.pow(q,2)+600*o-330*this.ep2))))+this.y0}return a.x=c,a.y=d,a},c.inverse=function(a){var b,c,d,e,f,g,h=6;if(this.sphere){var n=Math.exp(a.x/(this.a*this.k0)),o=.5*(n-1/n),p=this.lat0+a.y/(this.a*this.k0),q=Math.cos(p);b=Math.sqrt((1-q*q)/(1+o*o)),f=m(b),0>p&&(f=-f),g=0===o&&0===q?this.long0:i(Math.atan2(o,q)+this.long0)}else{var r=a.x-this.x0,s=a.y-this.y0;for(b=(this.ml0+s/this.k0)/this.a,c=b,e=0;!0&&(d=(b+this.e1*Math.sin(2*c)-this.e2*Math.sin(4*c)+this.e3*Math.sin(6*c))/this.e0-c,c+=d,!(Math.abs(d)<=k));e++)if(e>=h)return 95;if(Math.abs(c)<j){var t=Math.sin(c),u=Math.cos(c),v=Math.tan(c),w=this.ep2*Math.pow(u,2),x=Math.pow(w,2),y=Math.pow(v,2),z=Math.pow(y,2);b=1-this.es*Math.pow(t,2);var A=this.a/Math.sqrt(b),B=A*(1-this.es)/b,C=r/(A*this.k0),D=Math.pow(C,2);f=c-A*v*D/B*(.5-D/24*(5+3*y+10*w-4*x-9*this.ep2-D/30*(61+90*y+298*w+45*z-252*this.ep2-3*x))),g=i(this.long0+C*(1-D/6*(1+2*y+w-D/20*(5-2*w+28*y-3*x+8*this.ep2+24*z)))/u)}else f=j*l(s),g=this.long0}return a.x=g,a.y=f,a},c.names=["Transverse_Mercator","Transverse Mercator","tmerc"]},{"../common/adjust_lon":5,"../common/asinz":6,"../common/e0fn":7,"../common/e1fn":8,"../common/e2fn":9,"../common/e3fn":10,"../common/mlfn":14,"../common/sign":21}],63:[function(a,b,c){var d=.017453292519943295,e=a("./tmerc");c.dependsOn="tmerc",c.init=function(){this.zone&&(this.lat0=0,this.long0=(6*Math.abs(this.zone)-183)*d,this.x0=5e5,this.y0=this.utmSouth?1e7:0,this.k0=.9996,e.init.apply(this),this.forward=e.forward,this.inverse=e.inverse)},c.names=["Universal Transverse Mercator System","utm"]},{"./tmerc":62}],64:[function(a,b,c){var d=a("../common/adjust_lon"),e=Math.PI/2,f=1e-10,g=a("../common/asinz");c.init=function(){this.R=this.a},c.forward=function(a){var b,c,h=a.x,i=a.y,j=d(h-this.long0);Math.abs(i)<=f&&(b=this.x0+this.R*j,c=this.y0);var k=g(2*Math.abs(i/Math.PI));(Math.abs(j)<=f||Math.abs(Math.abs(i)-e)<=f)&&(b=this.x0,c=i>=0?this.y0+Math.PI*this.R*Math.tan(.5*k):this.y0+Math.PI*this.R*-Math.tan(.5*k));var l=.5*Math.abs(Math.PI/j-j/Math.PI),m=l*l,n=Math.sin(k),o=Math.cos(k),p=o/(n+o-1),q=p*p,r=p*(2/n-1),s=r*r,t=Math.PI*this.R*(l*(p-s)+Math.sqrt(m*(p-s)*(p-s)-(s+m)*(q-s)))/(s+m);0>j&&(t=-t),b=this.x0+t;var u=m+p;return t=Math.PI*this.R*(r*u-l*Math.sqrt((s+m)*(m+1)-u*u))/(s+m),c=i>=0?this.y0+t:this.y0-t,a.x=b,a.y=c,a},c.inverse=function(a){var b,c,e,g,h,i,j,k,l,m,n,o,p;return a.x-=this.x0,a.y-=this.y0,n=Math.PI*this.R,e=a.x/n,g=a.y/n,h=e*e+g*g,i=-Math.abs(g)*(1+h),j=i-2*g*g+e*e,k=-2*i+1+2*g*g+h*h,p=g*g/k+(2*j*j*j/k/k/k-9*i*j/k/k)/27,l=(i-j*j/3/k)/k,m=2*Math.sqrt(-l/3),n=3*p/l/m,Math.abs(n)>1&&(n=n>=0?1:-1),o=Math.acos(n)/3,c=a.y>=0?(-m*Math.cos(o+Math.PI/3)-j/3/k)*Math.PI:-(-m*Math.cos(o+Math.PI/3)-j/3/k)*Math.PI,b=Math.abs(e)<f?this.long0:d(this.long0+Math.PI*(h-1+Math.sqrt(1+2*(e*e-g*g)+h*h))/2/e),a.x=b,a.y=c,a},c.names=["Van_der_Grinten_I","VanDerGrinten","vandg"]},{"../common/adjust_lon":5,"../common/asinz":6}],65:[function(a,b,c){var d=.017453292519943295,e=57.29577951308232,f=1,g=2,h=a("./datum_transform"),i=a("./adjust_axis"),j=a("./Proj"),k=a("./common/toPoint");b.exports=function l(a,b,c){function m(a,b){return(a.datum.datum_type===f||a.datum.datum_type===g)&&"WGS84"!==b.datumCode}var n;return Array.isArray(c)&&(c=k(c)),a.datum&&b.datum&&(m(a,b)||m(b,a))&&(n=new j("WGS84"),l(a,n,c),a=n),"enu"!==a.axis&&i(a,!1,c),"longlat"===a.projName?(c.x*=d,c.y*=d):(a.to_meter&&(c.x*=a.to_meter,c.y*=a.to_meter),a.inverse(c)),a.from_greenwich&&(c.x+=a.from_greenwich),c=h(a.datum,b.datum,c),b.from_greenwich&&(c.x-=b.from_greenwich),"longlat"===b.projName?(c.x*=e,c.y*=e):(b.forward(c),b.to_meter&&(c.x/=b.to_meter,c.y/=b.to_meter)),"enu"!==b.axis&&i(b,!0,c),c}},{"./Proj":2,"./adjust_axis":3,"./common/toPoint":23,"./datum_transform":31}],66:[function(a,b,c){function d(a,b,c){a[b]=c.map(function(a){var b={};return e(a,b),b}).reduce(function(a,b){return j(a,b)},{})}function e(a,b){var c;return Array.isArray(a)?(c=a.shift(),"PARAMETER"===c&&(c=a.shift()),1===a.length?Array.isArray(a[0])?(b[c]={},e(a[0],b[c])):b[c]=a[0]:a.length?"TOWGS84"===c?b[c]=a:(b[c]={},["UNIT","PRIMEM","VERT_DATUM"].indexOf(c)>-1?(b[c]={name:a[0].toLowerCase(),convert:a[1]},3===a.length&&(b[c].auth=a[2])):"SPHEROID"===c?(b[c]={name:a[0],a:a[1],rf:a[2]},4===a.length&&(b[c].auth=a[3])):["GEOGCS","GEOCCS","DATUM","VERT_CS","COMPD_CS","LOCAL_CS","FITTED_CS","LOCAL_DATUM"].indexOf(c)>-1?(a[0]=["name",a[0]],d(b,c,a)):a.every(function(a){return Array.isArray(a)})?d(b,c,a):e(a,b[c])):b[c]=!0,void 0):void(b[a]=!0)}function f(a,b){var c=b[0],d=b[1];!(c in a)&&d in a&&(a[c]=a[d],3===b.length&&(a[c]=b[2](a[c])))}function g(a){return a*i}function h(a){function b(b){var c=a.to_meter||1;return parseFloat(b,10)*c}"GEOGCS"===a.type?a.projName="longlat":"LOCAL_CS"===a.type?(a.projName="identity",a.local=!0):a.projName="object"==typeof a.PROJECTION?Object.keys(a.PROJECTION)[0]:a.PROJECTION,a.UNIT&&(a.units=a.UNIT.name.toLowerCase(),"metre"===a.units&&(a.units="meter"),a.UNIT.convert&&(a.to_meter=parseFloat(a.UNIT.convert,10))),
a.GEOGCS&&(a.datumCode=a.GEOGCS.DATUM?a.GEOGCS.DATUM.name.toLowerCase():a.GEOGCS.name.toLowerCase(),"d_"===a.datumCode.slice(0,2)&&(a.datumCode=a.datumCode.slice(2)),("new_zealand_geodetic_datum_1949"===a.datumCode||"new_zealand_1949"===a.datumCode)&&(a.datumCode="nzgd49"),"wgs_1984"===a.datumCode&&("Mercator_Auxiliary_Sphere"===a.PROJECTION&&(a.sphere=!0),a.datumCode="wgs84"),"_ferro"===a.datumCode.slice(-6)&&(a.datumCode=a.datumCode.slice(0,-6)),"_jakarta"===a.datumCode.slice(-8)&&(a.datumCode=a.datumCode.slice(0,-8)),~a.datumCode.indexOf("belge")&&(a.datumCode="rnb72"),a.GEOGCS.DATUM&&a.GEOGCS.DATUM.SPHEROID&&(a.ellps=a.GEOGCS.DATUM.SPHEROID.name.replace("_19","").replace(/[Cc]larke\_18/,"clrk"),"international"===a.ellps.toLowerCase().slice(0,13)&&(a.ellps="intl"),a.a=a.GEOGCS.DATUM.SPHEROID.a,a.rf=parseFloat(a.GEOGCS.DATUM.SPHEROID.rf,10)),~a.datumCode.indexOf("osgb_1936")&&(a.datumCode="osgb36")),a.b&&!isFinite(a.b)&&(a.b=a.a);var c=function(b){return f(a,b)},d=[["standard_parallel_1","Standard_Parallel_1"],["standard_parallel_2","Standard_Parallel_2"],["false_easting","False_Easting"],["false_northing","False_Northing"],["central_meridian","Central_Meridian"],["latitude_of_origin","Latitude_Of_Origin"],["latitude_of_origin","Central_Parallel"],["scale_factor","Scale_Factor"],["k0","scale_factor"],["latitude_of_center","Latitude_of_center"],["lat0","latitude_of_center",g],["longitude_of_center","Longitude_Of_Center"],["longc","longitude_of_center",g],["x0","false_easting",b],["y0","false_northing",b],["long0","central_meridian",g],["lat0","latitude_of_origin",g],["lat0","standard_parallel_1",g],["lat1","standard_parallel_1",g],["lat2","standard_parallel_2",g],["alpha","azimuth",g],["srsCode","name"]];d.forEach(c),a.long0||!a.longc||"Albers_Conic_Equal_Area"!==a.projName&&"Lambert_Azimuthal_Equal_Area"!==a.projName||(a.long0=a.longc),a.lat_ts||!a.lat1||"Stereographic_South_Pole"!==a.projName&&"Polar Stereographic (variant B)"!==a.projName||(a.lat0=g(a.lat1>0?90:-90),a.lat_ts=a.lat1)}var i=.017453292519943295,j=a("./extend");b.exports=function(a,b){var c=JSON.parse((","+a).replace(/\s*\,\s*([A-Z_0-9]+?)(\[)/g,',["$1",').slice(1).replace(/\s*\,\s*([A-Z_0-9]+?)\]/g,',"$1"]').replace(/,\["VERTCS".+/,"")),d=c.shift(),f=c.shift();c.unshift(["name",f]),c.unshift(["type",d]),c.unshift("output");var g={};return e(c,g),h(g.output),j(b,g.output)}},{"./extend":34}],67:[function(a,b,c){function d(a){return a*(Math.PI/180)}function e(a){return 180*(a/Math.PI)}function f(a){var b,c,e,f,g,i,j,k,l,m=a.lat,n=a.lon,o=6378137,p=.00669438,q=.9996,r=d(m),s=d(n);l=Math.floor((n+180)/6)+1,180===n&&(l=60),m>=56&&64>m&&n>=3&&12>n&&(l=32),m>=72&&84>m&&(n>=0&&9>n?l=31:n>=9&&21>n?l=33:n>=21&&33>n?l=35:n>=33&&42>n&&(l=37)),b=6*(l-1)-180+3,k=d(b),c=p/(1-p),e=o/Math.sqrt(1-p*Math.sin(r)*Math.sin(r)),f=Math.tan(r)*Math.tan(r),g=c*Math.cos(r)*Math.cos(r),i=Math.cos(r)*(s-k),j=o*((1-p/4-3*p*p/64-5*p*p*p/256)*r-(3*p/8+3*p*p/32+45*p*p*p/1024)*Math.sin(2*r)+(15*p*p/256+45*p*p*p/1024)*Math.sin(4*r)-35*p*p*p/3072*Math.sin(6*r));var t=q*e*(i+(1-f+g)*i*i*i/6+(5-18*f+f*f+72*g-58*c)*i*i*i*i*i/120)+5e5,u=q*(j+e*Math.tan(r)*(i*i/2+(5-f+9*g+4*g*g)*i*i*i*i/24+(61-58*f+f*f+600*g-330*c)*i*i*i*i*i*i/720));return 0>m&&(u+=1e7),{northing:Math.round(u),easting:Math.round(t),zoneNumber:l,zoneLetter:h(m)}}function g(a){var b=a.northing,c=a.easting,d=a.zoneLetter,f=a.zoneNumber;if(0>f||f>60)return null;var h,i,j,k,l,m,n,o,p,q,r=.9996,s=6378137,t=.00669438,u=(1-Math.sqrt(1-t))/(1+Math.sqrt(1-t)),v=c-5e5,w=b;"N">d&&(w-=1e7),o=6*(f-1)-180+3,h=t/(1-t),n=w/r,p=n/(s*(1-t/4-3*t*t/64-5*t*t*t/256)),q=p+(3*u/2-27*u*u*u/32)*Math.sin(2*p)+(21*u*u/16-55*u*u*u*u/32)*Math.sin(4*p)+151*u*u*u/96*Math.sin(6*p),i=s/Math.sqrt(1-t*Math.sin(q)*Math.sin(q)),j=Math.tan(q)*Math.tan(q),k=h*Math.cos(q)*Math.cos(q),l=s*(1-t)/Math.pow(1-t*Math.sin(q)*Math.sin(q),1.5),m=v/(i*r);var x=q-i*Math.tan(q)/l*(m*m/2-(5+3*j+10*k-4*k*k-9*h)*m*m*m*m/24+(61+90*j+298*k+45*j*j-252*h-3*k*k)*m*m*m*m*m*m/720);x=e(x);var y=(m-(1+2*j+k)*m*m*m/6+(5-2*k+28*j-3*k*k+8*h+24*j*j)*m*m*m*m*m/120)/Math.cos(q);y=o+e(y);var z;if(a.accuracy){var A=g({northing:a.northing+a.accuracy,easting:a.easting+a.accuracy,zoneLetter:a.zoneLetter,zoneNumber:a.zoneNumber});z={top:A.lat,right:A.lon,bottom:x,left:y}}else z={lat:x,lon:y};return z}function h(a){var b="Z";return 84>=a&&a>=72?b="X":72>a&&a>=64?b="W":64>a&&a>=56?b="V":56>a&&a>=48?b="U":48>a&&a>=40?b="T":40>a&&a>=32?b="S":32>a&&a>=24?b="R":24>a&&a>=16?b="Q":16>a&&a>=8?b="P":8>a&&a>=0?b="N":0>a&&a>=-8?b="M":-8>a&&a>=-16?b="L":-16>a&&a>=-24?b="K":-24>a&&a>=-32?b="J":-32>a&&a>=-40?b="H":-40>a&&a>=-48?b="G":-48>a&&a>=-56?b="F":-56>a&&a>=-64?b="E":-64>a&&a>=-72?b="D":-72>a&&a>=-80&&(b="C"),b}function i(a,b){var c=""+a.easting,d=""+a.northing;return a.zoneNumber+a.zoneLetter+j(a.easting,a.northing,a.zoneNumber)+c.substr(c.length-5,b)+d.substr(d.length-5,b)}function j(a,b,c){var d=k(c),e=Math.floor(a/1e5),f=Math.floor(b/1e5)%20;return l(e,f,d)}function k(a){var b=a%q;return 0===b&&(b=q),b}function l(a,b,c){var d=c-1,e=r.charCodeAt(d),f=s.charCodeAt(d),g=e+a-1,h=f+b,i=!1;g>x&&(g=g-x+t-1,i=!0),(g===u||u>e&&g>u||(g>u||u>e)&&i)&&g++,(g===v||v>e&&g>v||(g>v||v>e)&&i)&&(g++,g===u&&g++),g>x&&(g=g-x+t-1),h>w?(h=h-w+t-1,i=!0):i=!1,(h===u||u>f&&h>u||(h>u||u>f)&&i)&&h++,(h===v||v>f&&h>v||(h>v||v>f)&&i)&&(h++,h===u&&h++),h>w&&(h=h-w+t-1);var j=String.fromCharCode(g)+String.fromCharCode(h);return j}function m(a){if(a&&0===a.length)throw"MGRSPoint coverting from nothing";for(var b,c=a.length,d=null,e="",f=0;!/[A-Z]/.test(b=a.charAt(f));){if(f>=2)throw"MGRSPoint bad conversion from: "+a;e+=b,f++}var g=parseInt(e,10);if(0===f||f+3>c)throw"MGRSPoint bad conversion from: "+a;var h=a.charAt(f++);if("A">=h||"B"===h||"Y"===h||h>="Z"||"I"===h||"O"===h)throw"MGRSPoint zone letter "+h+" not handled: "+a;d=a.substring(f,f+=2);for(var i=k(g),j=n(d.charAt(0),i),l=o(d.charAt(1),i);l<p(h);)l+=2e6;var m=c-f;if(m%2!==0)throw"MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters"+a;var q,r,s,t,u,v=m/2,w=0,x=0;return v>0&&(q=1e5/Math.pow(10,v),r=a.substring(f,f+v),w=parseFloat(r)*q,s=a.substring(f+v),x=parseFloat(s)*q),t=w+j,u=x+l,{easting:t,northing:u,zoneLetter:h,zoneNumber:g,accuracy:q}}function n(a,b){for(var c=r.charCodeAt(b-1),d=1e5,e=!1;c!==a.charCodeAt(0);){if(c++,c===u&&c++,c===v&&c++,c>x){if(e)throw"Bad character: "+a;c=t,e=!0}d+=1e5}return d}function o(a,b){if(a>"V")throw"MGRSPoint given invalid Northing "+a;for(var c=s.charCodeAt(b-1),d=0,e=!1;c!==a.charCodeAt(0);){if(c++,c===u&&c++,c===v&&c++,c>w){if(e)throw"Bad character: "+a;c=t,e=!0}d+=1e5}return d}function p(a){var b;switch(a){case"C":b=11e5;break;case"D":b=2e6;break;case"E":b=28e5;break;case"F":b=37e5;break;case"G":b=46e5;break;case"H":b=55e5;break;case"J":b=64e5;break;case"K":b=73e5;break;case"L":b=82e5;break;case"M":b=91e5;break;case"N":b=0;break;case"P":b=8e5;break;case"Q":b=17e5;break;case"R":b=26e5;break;case"S":b=35e5;break;case"T":b=44e5;break;case"U":b=53e5;break;case"V":b=62e5;break;case"W":b=7e6;break;case"X":b=79e5;break;default:b=-1}if(b>=0)return b;throw"Invalid zone letter: "+a}var q=6,r="AJSAJS",s="AFAFAF",t=65,u=73,v=79,w=86,x=90;c.forward=function(a,b){return b=b||5,i(f({lat:a[1],lon:a[0]}),b)},c.inverse=function(a){var b=g(m(a.toUpperCase()));return[b.left,b.bottom,b.right,b.top]},c.toPoint=function(a){var b=c.inverse(a);return[(b[2]+b[0])/2,(b[3]+b[1])/2]}},{}],68:[function(a,b,c){b.exports={name:"proj4",version:"2.3.6",description:"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.",main:"lib/index.js",directories:{test:"test",doc:"docs"},scripts:{test:"./node_modules/istanbul/lib/cli.js test ./node_modules/mocha/bin/_mocha test/test.js"},repository:{type:"git",url:"git://github.com/proj4js/proj4js.git"},author:"",license:"MIT",jam:{main:"dist/proj4.js",include:["dist/proj4.js","README.md","AUTHORS","LICENSE.md"]},devDependencies:{"grunt-cli":"~0.1.13",grunt:"~0.4.2","grunt-contrib-connect":"~0.6.0","grunt-contrib-jshint":"~0.8.0",chai:"~1.8.1",mocha:"~1.17.1","grunt-mocha-phantomjs":"~0.4.0",browserify:"~3.24.5","grunt-browserify":"~1.3.0","grunt-contrib-uglify":"~0.3.2",curl:"git://github.com/cujojs/curl.git",istanbul:"~0.2.4",tin:"~0.4.0"},dependencies:{mgrs:"0.0.0"}}},{}],"./includedProjections":[function(a,b,c){b.exports=a("hTEDpn")},{}],hTEDpn:[function(a,b,c){var d=[a("./lib/projections/tmerc"),a("./lib/projections/utm"),a("./lib/projections/sterea"),a("./lib/projections/stere"),a("./lib/projections/somerc"),a("./lib/projections/omerc"),a("./lib/projections/lcc"),a("./lib/projections/krovak"),a("./lib/projections/cass"),a("./lib/projections/laea"),a("./lib/projections/aea"),a("./lib/projections/gnom"),a("./lib/projections/cea"),a("./lib/projections/eqc"),a("./lib/projections/poly"),a("./lib/projections/nzmg"),a("./lib/projections/mill"),a("./lib/projections/sinu"),a("./lib/projections/moll"),a("./lib/projections/eqdc"),a("./lib/projections/vandg"),a("./lib/projections/aeqd")];b.exports=function(proj4){d.forEach(function(a){proj4.Proj.projections.add(a)})}},{"./lib/projections/aea":40,"./lib/projections/aeqd":41,"./lib/projections/cass":42,"./lib/projections/cea":43,"./lib/projections/eqc":44,"./lib/projections/eqdc":45,"./lib/projections/gnom":47,"./lib/projections/krovak":48,"./lib/projections/laea":49,"./lib/projections/lcc":50,"./lib/projections/mill":53,"./lib/projections/moll":54,"./lib/projections/nzmg":55,"./lib/projections/omerc":56,"./lib/projections/poly":57,"./lib/projections/sinu":58,"./lib/projections/somerc":59,"./lib/projections/stere":60,"./lib/projections/sterea":61,"./lib/projections/tmerc":62,"./lib/projections/utm":63,"./lib/projections/vandg":64}]},{},[36])(36)});
/*!
 * PointCloudViz.js - Mirage Technologies S.L.
 * Rafa Gaitán <rgaitan@topcon.com>
 * Julio Campos <jcampos@topcon.com>
 * David Haro <dharo@topcon.com>
 * Rocío Tortajada <rtortajada@topcon.com>
 * Salvador Bayarri <sbayarri@topcon.com>
 * Jorge Villalta <jvillalta@topcon.com>
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["PointCloudViz"] = factory();
	else
		root["PointCloudViz"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ({

/***/ "./dependencies/OSG.js":
/*!*****************************!*\
  !*** ./dependencies/OSG.js ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * OSGJS
 * Cedric Pinson <trigrou@trigrou.com> (http://cedricpinson.com)
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js"), __webpack_require__(/*! zlib */ "./node_modules/browserify-zlib/lib/index.js"), __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js"), (function webpackLoadOptionalExternalModule() { try { return __webpack_require__(/*! jquery */ "./node_modules/jquery/dist/jquery.js"); } catch(e) {} }()));
	else {}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_133__, __WEBPACK_EXTERNAL_MODULE_138__, __WEBPACK_EXTERNAL_MODULE_234__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 174);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mat3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return mat4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return quat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return vec2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return vec3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return vec4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_math__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gl_matrix__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gl_matrix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_config_js__ = __webpack_require__(185);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a; });




__WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.glMatrix.setMatrixArrayType(__WEBPACK_IMPORTED_MODULE_2_config_js__["a" /* default */].ArrayType);
__WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.glMatrix.EPSILON = 1e-9;

var vec2 = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.vec2;
var vec3 = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.vec3;
var vec4 = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.vec4;
var mat4 = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.mat4;
var mat3 = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.mat3;
var quat = __WEBPACK_IMPORTED_MODULE_1_gl_matrix___default.a.quat;

// osg vec3 additions

vec3.create32 = function() {
    return new Float32Array(3);
};

vec3.create64 = function() {
    return new Float64Array(3);
};

vec3.fromValues32 = function(a, b, c) {
    var out = new Float32Array(3);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    return out;
};

vec3.fromValues64 = function(a, b, c) {
    var out = new Float64Array(3);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    return out;
};

vec3.init = function(out) {
    return vec3.set(out, 0.0, 0.0, 0.0);
};

vec3.transformMat4Rotate = function(out, v, m) {
    var x = v[0],
        y = v[1],
        z = v[2];
    out[0] = m[0] * x + m[1] * y + m[2] * z;
    out[1] = m[4] * x + m[5] * y + m[6] * z;
    out[2] = m[8] * x + m[9] * y + m[10] * z;
    return out;
};

vec3.valid = function(a) {
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[0])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[1])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[2])) return false;
    return true;
};
vec3.neg = vec3.negate;
vec3.ZERO = vec3.create();
vec3.ONE = vec3.fromValues(1.0, 1.0, 1.0);
vec3.INFINITY = vec3.fromValues(Infinity, Infinity, Infinity);
vec3.NEGATIVE_INFINITY = vec3.fromValues(-Infinity, -Infinity, -Infinity);

// osg vec2 additions

vec2.create32 = function() {
    return new Float32Array(2);
};

vec2.create64 = function() {
    return new Float64Array(2);
};

vec2.fromValues32 = function(a, b) {
    var out = new Float32Array(2);
    out[0] = a;
    out[1] = b;
    return out;
};

vec2.fromValues64 = function(a, b) {
    var out = new Float64Array(2);
    out[0] = a;
    out[1] = b;
    return out;
};

vec2.init = function(out) {
    return vec2.set(out, 0.0, 0.0);
};

vec2.valid = function(a) {
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[0])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[1])) return false;
    return true;
};

vec2.ZERO = vec2.create();
vec2.ONE = vec2.fromValues(1.0, 1.0);
vec2.INFINITY = vec2.fromValues(Infinity, Infinity);
vec2.NEGATIVE_INFINITY = vec2.fromValues(-Infinity, -Infinity);

// osg vec4 additions

vec4.create32 = function() {
    return new Float32Array(4);
};

vec4.create64 = function() {
    return new Float64Array(4);
};

vec4.fromValues32 = function(a, b, c, d) {
    var out = new Float32Array(4);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    return out;
};

vec4.fromValues64 = function(a, b, c, d) {
    var out = new Float64Array(4);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    return out;
};

vec4.init = function(out) {
    return vec4.set(out, 0.0, 0.0, 0.0, 0.0);
};

vec4.valid = function(a) {
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[0])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[1])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[2])) return false;
    if (__WEBPACK_IMPORTED_MODULE_0_osg_math__["a" /* default */].isNaN(a[3])) return false;
    return true;
};
vec4.neg = vec4.negate;
vec4.ZERO = vec4.create();
vec4.ONE = vec4.fromValues(1.0, 1.0, 1.0, 1.0);
vec4.INFINITY = vec4.fromValues(Infinity, Infinity, Infinity, Infinity);
vec4.NEGATIVE_INFINITY = vec4.fromValues(-Infinity, -Infinity, -Infinity, -Infinity);

// quat

quat.IDENTITY = quat.create();

quat.zeroRotation = function(q) {
    return q[0] === 0.0 && q[1] === 0.0 && q[2] === 0.0 && q[3] === 1.0;
};

quat.create32 = function() {
    var out = new Float32Array(4);
    out[3] = 1.0;
    return out;
};

quat.create64 = function() {
    var out = new Float64Array(4);
    out[3] = 1.0;
    return out;
};

quat.fromValues32 = vec4.fromValues32;
quat.fromValues64 = vec4.fromValues64;
quat.init = quat.identity;

// http://physicsforgames.blogspot.fr/2010/02/quaternions.html
// called quatBlend
//
// NLERP is supposed to be
// - Commutative,
// - NOT Constant velocity
// - Torque minimal
//
// a and be must be normalized
// (otherwise they're not rotation...)
// t must be between 0 and 1
quat.nlerp = function(out, a, b, t) {
    var ax = a[0],
        ay = a[1],
        az = a[2],
        aw = a[3],
        bx = b[0],
        by = b[1],
        bz = b[2],
        bw = b[3];
    var dot = ax * bx + ay * by + az * bz + aw * bw;
    var at = 1.0 - t;
    var outx, outy, outz, outw;
    // shortest path
    if (dot < 0.0) {
        // negates directly b in the 4 equation
        // this.neg( b, r );
        outx = ax * at - bx * t;
        outy = ay * at - by * t;
        outz = az * at - bz * t;
        outw = aw * at - bw * t;
    } else {
        outx = ax * at + bx * t;
        outy = ay * at + by * t;
        outz = az * at + bz * t;
        outw = aw * at + bw * t;
    }

    var invLen = 1.0 / Math.sqrt(outx * outx + outy * outy + outz * outz + outw * outw);
    out[0] = outx * invLen;
    out[1] = outy * invLen;
    out[2] = outz * invLen;
    out[3] = outw * invLen;
    return out;
};

// MUST READ on SLERP, NLERP, LOG-LERP
// http://number-none.com/product/Understanding%20Slerp,%20Then%20Not%20Using%20It/
// with a slerp implementation (robust)
//
// MUST READ Howto enhance lerp, slerp and q normalize
// http://number-none.com/product/Hacking%20Quaternions/
//
// MUST READ The book:
// Essential Mathematics for Games and Interactive Applications page
// ( from 10.6.1 Linear Interpolation to 10.6.3 Performance Improvements )
//
//  SLERP is:
// - NOT commutative
// - constant velocity
// - torque minimal
//
// so not to be used when blending multiple non ordered rotations
// (as in multiple animation)
//
// slerp see glMatrix implementation

// mat3 additions
mat3.IDENTITY = mat3.create();
mat3.create32 = function() {
    var out = new Float32Array(9);
    out[0] = out[4] = out[8] = 1.0;
    return out;
};

mat3.create64 = function() {
    var out = new Float64Array(9);
    out[0] = out[4] = out[8] = 1.0;
    return out;
};

// mat4 additions
mat4.IDENTITY = mat4.create();

mat4.create32 = function() {
    var out = new Float32Array(16);
    out[0] = out[5] = out[10] = out[15] = 1.0;
    return out;
};

mat4.create64 = function() {
    var out = new Float64Array(16);
    out[0] = out[5] = out[10] = out[15] = 1.0;
    return out;
};

mat4.setTranslation = function(out, a) {
    out[12] = a[0];
    out[13] = a[1];
    out[14] = a[2];
    return out;
};

mat4.getFrustum = function(out, matrix) {
    var right = 0.0;
    var left = 0.0;
    var top = 0.0;
    var bottom = 0.0;
    var zNear, zFar;

    if (
        matrix[0 * 4 + 3] !== 0.0 ||
        matrix[1 * 4 + 3] !== 0.0 ||
        matrix[2 * 4 + 3] !== -1.0 ||
        matrix[3 * 4 + 3] !== 0.0
    ) {
        return false;
    }

    // note: near and far must be used inside this method instead of zNear and zFar
    // because zNear and zFar are references and they may point to the same variable.
    var tempNear = matrix[3 * 4 + 2] / (matrix[2 * 4 + 2] - 1.0);
    var tempFar = matrix[3 * 4 + 2] / (1.0 + matrix[2 * 4 + 2]);

    left = tempNear * (matrix[2 * 4] - 1.0) / matrix[0];
    right = tempNear * (1.0 + matrix[2 * 4]) / matrix[0];

    top = tempNear * (1.0 + matrix[2 * 4 + 1]) / matrix[1 * 4 + 1];
    bottom = tempNear * (matrix[2 * 4 + 1] - 1.0) / matrix[1 * 4 + 1];

    zNear = tempNear;
    zFar = tempFar;

    out.left = left;
    out.right = right;
    out.top = top;
    out.bottom = bottom;
    out.zNear = zNear;
    out.zFar = zFar;

    return true;
};

mat4.getPerspective = (function() {
    var c = {
        right: 0,
        left: 0,
        top: 0,
        bottom: 0,
        zNear: 0,
        zFar: 0
    };
    return function(out, matrix) {
        // get frustum and compute results
        var r = mat4.getFrustum(c, matrix);
        if (r) {
            out.fovy = 180 / Math.PI * (Math.atan(c.top / c.zNear) - Math.atan(c.bottom / c.zNear));
            out.aspectRatio = (c.right - c.left) / (c.top - c.bottom);
        }
        out.zNear = c.zNear;
        out.zFar = c.zFar;
        return out;
    };
})();

mat4.getLookAt = (function() {
    var inv = mat4.create();
    var v1 = vec3.create();
    var v2 = vec3.fromValues(0.0, 1.0, 0.0);
    var v3 = vec3.fromValues(0.0, 0.0, -1.0);

    return function(eye, center, up, matrix, distance) {
        var d = distance !== undefined ? distance : 1.0;
        mat4.invert(inv, matrix);
        mat4.getTranslation(eye, inv);
        vec3.transformMat4Rotate(up, v2, matrix);
        vec3.transformMat4Rotate(center, v3, matrix);
        vec3.normalize(center, center);
        vec3.add(center, vec3.scale(v1, center, d), eye);
    };
})();

mat4.getFrustumPlanes = (function() {
    var mvp = mat4.create();

    return function(out, projection, view, withNearFar) {
        mat4.mul(mvp, projection, view);

        var computeNearFar = !!withNearFar;

        // Right clipping plane.
        var right = out[0];
        right[0] = mvp[3] - mvp[0];
        right[1] = mvp[7] - mvp[4];
        right[2] = mvp[11] - mvp[8];
        right[3] = mvp[15] - mvp[12];

        // Left clipping plane.
        var left = out[1];
        left[0] = mvp[3] + mvp[0];
        left[1] = mvp[7] + mvp[4];
        left[2] = mvp[11] + mvp[8];
        left[3] = mvp[15] + mvp[12];

        // Bottom clipping plane.
        var bottom = out[2];
        bottom[0] = mvp[3] + mvp[1];
        bottom[1] = mvp[7] + mvp[5];
        bottom[2] = mvp[11] + mvp[9];
        bottom[3] = mvp[15] + mvp[13];

        // Top clipping plane.
        var top = out[3];
        top[0] = mvp[3] - mvp[1];
        top[1] = mvp[7] - mvp[5];
        top[2] = mvp[11] - mvp[9];
        top[3] = mvp[15] - mvp[13];

        var nbPlanes = 4;
        if (computeNearFar) {
            nbPlanes = 6;
            // Far clipping plane.
            var far = out[4];
            far[0] = mvp[3] - mvp[2];
            far[1] = mvp[7] - mvp[6];
            far[2] = mvp[11] - mvp[10];
            far[3] = mvp[15] - mvp[14];

            // Near clipping plane.
            var near = out[5];
            near[0] = mvp[3] + mvp[2];
            near[1] = mvp[7] + mvp[6];
            near[2] = mvp[11] + mvp[10];
            near[3] = mvp[15] + mvp[14];
        }

        //Normalize the planes, from osg code
        for (var i = 0; i < nbPlanes; i++) {
            var p = out[i];
            // multiply the coefficients of the plane equation with a constant factor so that the equation a^2+b^2+c^2 = 1 holds.
            var inv = 1.0 / Math.sqrt(p[0] * p[0] + p[1] * p[1] + p[2] * p[2]);
            p[0] *= inv;
            p[1] *= inv;
            p[2] *= inv;
            p[3] *= inv;
        }
    };
})();

// better precison
// no far clipping artifacts.
// no reason not to use.
// Tightening the Precision of Perspective Rendering
//http://www.geometry.caltech.edu/pubs/UD12.pdf
// drop-in, just remove the one below, and rename this one
mat4.infiniteFrustum = function(out, left, right, bottom, top, znear) {
    var X = 2.0 * znear / (right - left);
    var Y = 2.0 * znear / (top - bottom);
    var A = (right + left) / (right - left);
    var B = (top + bottom) / (top - bottom);
    var C = -1.0;
    out[0] = X;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;

    out[4] = 0.0;
    out[5] = Y;
    out[6] = 0.0;
    out[7] = 0.0;

    out[8] = A;
    out[9] = B;
    out[10] = C;
    out[11] = -1.0;

    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = -2.0 * znear;
    out[15] = 0.0;

    return out;
};

mat4.lookAtDirection = (function() {
    var s = vec3.create();
    var u = vec3.create();
    var neg = vec3.create();

    return function(out, eye, eyeDir, up) {
        var f = eyeDir;
        vec3.cross(s, f, up);
        vec3.normalize(s, s);

        vec3.cross(u, s, f);
        vec3.normalize(u, u);

        // s[0], u[0], -f[0], 0.0,
        // s[1], u[1], -f[1], 0.0,
        // s[2], u[2], -f[2], 0.0,
        // 0,    0,    0,     1.0

        out[0] = s[0];
        out[1] = u[0];
        out[2] = -f[0];
        out[3] = 0.0;
        out[4] = s[1];
        out[5] = u[1];
        out[6] = -f[1];
        out[7] = 0.0;
        out[8] = s[2];
        out[9] = u[2];
        out[10] = -f[2];
        out[11] = 0.0;
        out[12] = 0;
        out[13] = 0;
        out[14] = 0;
        out[15] = 1.0;

        return mat4.translate(out, out, vec3.neg(neg, eye));
    };
})();

mat4.getScale = (function() {
    var sx = vec3.create();
    var sy = vec3.create();
    var sz = vec3.create();
    return function(out, matrix) {
        sx[0] = matrix[0];
        sx[1] = matrix[4];
        sx[2] = matrix[8];
        sy[0] = matrix[1];
        sy[1] = matrix[5];
        sy[2] = matrix[9];
        sz[0] = matrix[2];
        sz[1] = matrix[6];
        sz[2] = matrix[10];

        out[0] = vec3.length(sx);
        out[1] = vec3.length(sy);
        out[2] = vec3.length(sz);
        return out;
    };
})();

mat4.getSqrScale = (function() {
    var sx = vec3.create();
    var sy = vec3.create();
    var sz = vec3.create();
    return function(out, matrix) {
        sx[0] = matrix[0];
        sx[1] = matrix[4];
        sx[2] = matrix[8];
        sy[0] = matrix[1];
        sy[1] = matrix[5];
        sy[2] = matrix[9];
        sz[0] = matrix[2];
        sz[1] = matrix[6];
        sz[2] = matrix[10];

        out[0] = vec3.sqrLen(sx);
        out[1] = vec3.sqrLen(sy);
        out[2] = vec3.sqrLen(sz);
        return out;
    };
})();

var glmRotate = mat4.rotate;
mat4.rotate = function(out, a, rad, axis) {
    return glmRotate(out, a, rad, axis) || mat4.identity(out);
};

var glmFromRotate = mat4.fromRotation;
mat4.fromRotation = function(out, rad, axis) {
    return glmFromRotate(out, rad, axis) || mat4.identity(out);
};




/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Timer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);




var utils = {};

utils.extend = function() {
    // Save a reference to some core methods
    var toString = window.Object.prototype.toString;
    var hasOwnPropertyFunc = window.Object.prototype.hasOwnProperty;

    var isFunction = function(obj) {
        return toString.call(obj) === '[object Function]';
    };
    var isArray = utils.isArray;
    var isPlainObject = function(obj) {
        // Must be an Object.
        // Because of IE, we also have to check the presence of the constructor property.
        // Make sure that DOM nodes and window objects don't pass through, as well
        if (!obj || toString.call(obj) !== '[object Object]' || obj.nodeType || obj.setInterval) {
            return false;
        }

        // Not own constructor property must be Object
        if (
            obj.constructor &&
            !hasOwnPropertyFunc.call(obj, 'constructor') &&
            !hasOwnPropertyFunc.call(obj.constructor.prototype, 'isPrototypeOf')
        ) {
            return false;
        }

        // Own properties are enumerated firstly, so to speed up,
        // if last one is own, then all properties are own.

        var key;
        for (key in obj) {
        }

        return key === undefined || hasOwnPropertyFunc.call(obj, key);
    };

    // copy reference to target object
    var target = arguments[0] || {},
        i = 1,
        length = arguments.length,
        deep = false,
        options,
        name,
        src,
        copy;

    // Handle a deep copy situation
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (typeof target !== 'object' && !isFunction(target)) {
        target = {};
    }

    // extend jQuery itself if only one argument is passed
    if (length === i) {
        target = this;
        --i;
    }

    for (; i < length; i++) {
        // Only deal with non-null/undefined values
        if ((options = arguments[i]) !== null) {
            // Extend the base object
            for (name in options) {
                src = target[name];
                copy = options[name];

                // Prevent never-ending loop
                if (target === copy) {
                    continue;
                }

                // Recurse if we're merging object literal values or arrays
                if (deep && copy && (isPlainObject(copy) || isArray(copy))) {
                    var clone =
                        src && (isPlainObject(src) || isArray(src)) ? src : isArray(copy) ? [] : {};

                    // Never move original objects, clone them
                    target[name] = utils.extend(deep, clone, copy);

                    // Don't bring in undefined values
                } else if (copy !== undefined) {
                    target[name] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
};

utils.objectInherit = function(base /*, extras*/) {
    function F() {}
    F.prototype = base;
    var obj = new F();

    // let augment object with multiple arguement
    for (var i = 1; i < arguments.length; i++) {
        utils.objectMix(obj, arguments[i], false);
    }
    return obj;
};

utils.objectMix = function(obj, properties, test) {
    for (var key in properties) {
        if (!(test && obj[key])) {
            obj[key] = properties[key];
        }
    }
    return obj;
};

utils.objectType = {};
utils.objectType.type = 0;

utils.arrayDense = function(index, array, createDefaultType) {
    var length = array.length;
    if (index >= length) {
        for (var i = length; i <= index; i++) {
            array.push(createDefaultType ? createDefaultType() : null);
        }
    }
};

utils.objectLibraryClass = function(object, libName, className) {
    object.className = function() {
        return className;
    };
    object.libraryName = function() {
        return libName;
    };
    var libraryClassName = libName + '::' + className;
    object.libraryClassName = function() {
        return libraryClassName;
    };

    return object;
};

utils.setTypeID = function(classObject) {
    var className = classObject.prototype.libraryClassName();
    var typeID = utils.generateId(utils.objectType, className);
    var getTypeID = function() {
        return typeID;
    };
    classObject.typeID = classObject.prototype.typeID = typeID;
    classObject.getTypeID = classObject.prototype.getTypeID = getTypeID;
};

utils.createPrototypeObject = function(Constructor, prototype, libraryName, className) {
    // we need to create an instance of {} if prototype is already used in an object
    // else we will override typeID ClassName...
    if (prototype.hasOwnProperty('getTypeID')) {
        prototype = utils.objectInherit(prototype, {});
    }

    Constructor.prototype = prototype;
    prototype.constructor = Constructor;

    // if the user dont provide library name or class name this class will not have typeID
    // and will inherit the typeID from it's parent class if it has one
    // so all call to getTypeID will be affected, it's mostly not a probablem for internal class
    // but for Node and StateAttribute you have to be aware
    if (!libraryName || !className) return;

    utils.objectLibraryClass(prototype, libraryName, className);
    utils.setTypeID(Constructor);
};

// ============== Node ID =================================
utils.generateId = function(typeMap, className) {
    if (typeMap[className] !== undefined) {
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].error(className + ' is already defined, change class name or library name');
        return -1;
    }

    var index = typeMap.type;
    typeMap[index] = className;
    typeMap[className] = index;
    typeMap.type += 1;
    return index;
};

utils.objectNodeType = {};
utils.objectNodeType.type = 0;

utils.setNodeTypeID = function(classObject) {
    var className = classObject.prototype.libraryClassName();
    var typeID = utils.generateId(utils.objectNodeType, className);
    var getTypeID = function() {
        return typeID;
    };
    classObject.nodeTypeID = classObject.prototype.nodeTypeID = typeID;
    classObject.getNodeTypeID = classObject.prototype.getNodeTypeID = getTypeID;
};

utils.createPrototypeNode = function(Constructor, prototype, libraryName, className) {
    var cullVisitorHelper = __webpack_require__(104).default;
    var parentNodeTypeID = prototype.nodeTypeID;
    utils.createPrototypeObject(Constructor, prototype, libraryName, className);

    // check the comment in function in utils.createPrototypeObject
    if (!libraryName || !className) return;

    utils.setNodeTypeID(Constructor);
    var nodeTypeId = Constructor.nodeTypeID;
    utils.arrayDense(nodeTypeId, cullVisitorHelper.applyFunctionArray);
    cullVisitorHelper.registerApplyFunction(
        nodeTypeId,
        cullVisitorHelper.getApplyFunction(parentNodeTypeID)
    );
};

// ===============================================

var typeMemberIndex = 0;
var textureTypeMemberIndex = 0;
var stateAttributeTypeMember = {};
var textureStateAttributeTypeMember = {};
var attributeTypeIndex = 0;
var stateAttributeType = {};

utils.getStateAttributeTypeNameToTypeId = function() {
    return stateAttributeType;
};

utils.createPrototypeStateAttribute = function(Constructor, prototype, libraryName, className) {
    utils.createPrototypeObject(Constructor, prototype, libraryName, className);
    var attributeId = utils.getOrCreateStateAttributeTypeId(Constructor);
    Constructor.prototype.attributeTypeId = attributeId;
};

utils.getMaxStateAttributeTypeID = function() {
    return attributeTypeIndex;
};

utils.getOrCreateStateAttributeTypeId = function(Constructor) {
    var attributeTypeName = Constructor.prototype.getType();

    if (stateAttributeType[attributeTypeName]) return stateAttributeType[attributeTypeName];

    var typeId = attributeTypeIndex++;
    stateAttributeType[attributeTypeName] = typeId;
    return typeId;
};

utils.getOrCreateStateAttributeTypeMemberIndex = function(attribute) {
    if (attribute._attributeTypeIndex !== undefined) return attribute._attributeTypeIndex;
    var typeMember = attribute.getTypeMember();
    attribute._attributeTypeIndex = utils.getOrCreateStateAttributeTypeMemberIndexFromName(
        typeMember
    );
    return attribute._attributeTypeIndex;
};

utils.getOrCreateStateAttributeTypeMemberIndexFromName = function(typeMemberName) {
    var type = stateAttributeTypeMember[typeMemberName];
    if (type !== undefined) return type;

    type = typeMemberIndex++;
    stateAttributeTypeMember[typeMemberName] = type;
    return type;
};

utils.getOrCreateTextureStateAttributeTypeMemberIndex = function(attribute) {
    if (attribute._attributeTypeIndex !== undefined) return attribute._attributeTypeIndex;
    var typeMember = attribute.getTypeMember();
    attribute._attributeTypeIndex = utils.getOrCreateTextureStateAttributeTypeMemberIndexFromName(
        typeMember
    );
    return attribute._attributeTypeIndex;
};

utils.getOrCreateTextureStateAttributeTypeMemberIndexFromName = function(typeMemberName) {
    var type = textureStateAttributeTypeMember[typeMemberName];
    if (type !== undefined) return type;

    type = textureTypeMemberIndex++;
    textureStateAttributeTypeMember[typeMemberName] = type;
    return type;
};

utils.getIdFromTypeMember = function(typeMember) {
    return stateAttributeTypeMember[typeMember];
};

utils.getTextureIdFromTypeMember = function(typeMember) {
    return textureStateAttributeTypeMember[typeMember];
};

utils.Int8Array = window.Int8Array;
utils.Uint8Array = window.Uint8Array;
utils.Uint8ClampedArray = window.Uint8ClampedArray;
utils.Int16Array = window.Int16Array;
utils.Uint16Array = window.Uint16Array;
utils.Int32Array = window.Int32Array;
utils.Uint32Array = window.Uint32Array;
utils.Float32Array = window.Float32Array;
utils.Float64Array = window.Float64Array;

var times = {};
var registeredTimers = {};
// we bind the function to notify.console once and for all to avoid costly apply function

utils.logTime = (__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.time ||
    function(name) {
        times[name] = __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().tick();
    }
).bind(__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console);

utils.logTimeEnd = (__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.timeEnd ||
    function(name) {
        if (times[name] === undefined) return;

        var duration = __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().deltaM(times[name], __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().tick());

        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log(name + ': ' + duration + 'ms');
        times[name] = undefined;
    }
).bind(__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console);

utils.time = function(name, logLevel) {
    var level = logLevel;
    if (level === undefined) level = __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].NOTICE;
    if (level > __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].getNotifyLevel()) return;
    registeredTimers[name] = 1;
    utils.logTime(name);
};

utils.timeEnd = function(name) {
    if (registeredTimers[name] === undefined) return;
    utils.logTimeEnd(name);
};

utils.timeStamp = (__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.timeStamp || __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.markTimeline || function() {}).bind(
    __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console
);
utils.profile = (__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.profile || function() {}).bind(__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console);
utils.profileEnd = (__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console.profileEnd || function() {}).bind(__WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].console);

utils.arrayUniq = function(a) {
    var len = a.length;
    var seen = {};
    var out = [];
    var j = 0;
    for (var i = 0; i < len; i++) {
        var item = a[i];
        if (seen[item] !== 1) {
            seen[item] = 1;
            out[j++] = item;
        }
    }
    return out;
};

// mostly used as an osgDB helper to issue a warning and reject a promise
utils.rejectObject = function(msg, jsonObj) {
    if (jsonObj) msg = 'Invalid json ' + msg + ' ' + Object.keys(jsonObj);
    __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn(msg); // useful for line debugging
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(msg); // reject with a message to avoid "undefined" rejection
};

/* harmony default export */ __webpack_exports__["a"] = (utils);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var notify = {};

// Range of notify levels from DEBUG through to FATAL
// ALWAYS is reserved for forcing the absorption of all messages.
// Must be uppercase and match loggers
notify.ALWAYS = 0;
notify.FATAL = notify.ERROR = 1;
notify.WARN = 2;
notify.NOTICE = notify.LOG = 3;
notify.INFO = 4;
notify.DEBUG = 5;

notify.currentNotifyLevel = notify.LOG;
notify.console = window.console;

/** logging with readability in mind.
 * @param { level } what severity is that log (gives text color too )
 * @param { str } actual log text
 * @param { fold  } sometimes you want to hide looooong text
 */
function logSub(intLevel, strLevel, str) {
    if (!notify.console || intLevel > notify.currentNotifyLevel) return;

    notify.console[strLevel](str);
    if (notify.traceLogCall && intLevel !== notify.ERROR) console.trace();
}

function logSubFold(intLevel, strLevel, title, str) {
    if (!notify.console || intLevel > notify.currentNotifyLevel) return;

    if (notify.console.groupCollapsed) notify.console.groupCollapsed(title);
    notify.console[strLevel](str);
    if (notify.traceLogCall && intLevel !== notify.ERROR) console.trace();

    if (notify.console.groupEnd) notify.console.groupEnd();
}

function unFlattenMatrix(m, rowMajor) {
    if (rowMajor) {
        return [m.slice(0, 4), m.slice(4, 8), m.slice(8, 12), m.slice(12, 16)];
    }

    return [
        [m[0], m[4], m[8], m[12]],
        [m[1], m[5], m[9], m[13]],
        [m[2], m[6], m[10], m[14]],
        [m[3], m[7], m[11], m[15]]
    ];
}

function logMatrix(intLevel, m, rowMajor) {
    if (intLevel > notify.currentNotifyLevel) return;

    if (notify.console.table) logSub('table', unFlattenMatrix(m, rowMajor));
}

function logMatrixFold(intLevel, title, m, rowMajor) {
    if (intLevel > notify.currentNotifyLevel) return;

    if (notify.console.table) logSubFold('table', title, unFlattenMatrix(m, rowMajor));
}

var levelEntries = ['error', 'warn', 'log', 'info', 'debug'];

for (var i = 0; i < levelEntries.length; ++i) {
    var level = levelEntries[i];
    var intLevel = notify[level.toUpperCase()];
    notify[level] = logSub.bind(notify, intLevel, level);
    notify[level + 'Fold'] = logSubFold.bind(notify, intLevel, level);
    notify[level + 'Matrix'] = logMatrix.bind(notify, intLevel);
    notify[level + 'MatrixFold'] = logMatrixFold.bind(notify, intLevel);
}

// alias
notify.notice = notify.log;
notify.noticeFold = notify.logFold;
notify.noticeMatrix = notify.logMatrix;
notify.noticeMatrixFold = notify.logMatrixFold;

notify.assert = function(test, str) {
    if (this.console !== undefined && !test) {
        this.console.assert(test, str);
    }
};

notify.setNotifyLevel = function(logLevel, trace) {
    notify.currentNotifyLevel = logLevel;
    if (trace !== undefined) notify.traceLogCall = trace;
};

notify.getNotifyLevel = function() {
    return notify.currentNotifyLevel;
};

notify.reportWebGLError = false;

notify.setConsole = function(replacement) {
    notify.console = replacement;
};

/* harmony default export */ __webpack_exports__["a"] = (notify);


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NodeVisitor = function(traversalMode) {
    /*jshint bitwise: false */
    this.traversalMask = ~0x0;
    /*jshint bitwise: true */
    this.nodeMaskOverride = 0;
    this.traversalMode = traversalMode;
    if (traversalMode === undefined) {
        this.traversalMode = NodeVisitor.TRAVERSE_ALL_CHILDREN;
    }
    this.nodePath = [];
    this.visitorType = NodeVisitor.NODE_VISITOR;
    this._databaseRequestHandler = undefined;
    this._frameStamp = undefined;

    this.traverse = NodeVisitor._traversalFunctions[this.traversalMode];
    this.pushOntoNodePath = NodeVisitor._pushOntoNodePath[this.traversalMode];
    this.popFromNodePath = NodeVisitor._popFromNodePath[this.traversalMode];
};

//NodeVisitor.TRAVERSE_NONE = 0;
NodeVisitor.TRAVERSE_PARENTS = 1;
NodeVisitor.TRAVERSE_ALL_CHILDREN = 2;
NodeVisitor.TRAVERSE_ACTIVE_CHILDREN = 3;

NodeVisitor.NODE_VISITOR = 0;
NodeVisitor.UPDATE_VISITOR = 1;
NodeVisitor.CULL_VISITOR = 2;

// =================== Traversal functions ===============
var traverseParents = function traverseParents(node) {
    node.ascend(this);
};

var traverseChildren = function traverseAllChildren(node) {
    node.traverse(this);
};

// must be sync with TRAVERSE_ENUMS
NodeVisitor._traversalFunctions = [undefined, traverseParents, traverseChildren, traverseChildren];

// =================== PushOntoNodePath functions ===============
var pushOntoNodePathParents = function(node) {
    this.nodePath.unshift(node);
};

var pushOntoNodePathChildren = function(node) {
    this.nodePath.push(node);
};

NodeVisitor._pushOntoNodePath = [
    undefined,
    pushOntoNodePathParents,
    pushOntoNodePathChildren,
    pushOntoNodePathChildren
];

// =================== PopOntoNodePath functions ===============
var popFromNodePathParents = function() {
    return this.nodePath.shift();
};

var popFromNodePathChildren = function() {
    this.nodePath.pop();
};

NodeVisitor._popFromNodePath = [
    undefined,
    popFromNodePathParents,
    popFromNodePathChildren,
    popFromNodePathChildren
];

NodeVisitor.prototype = {
    reset: function() {
        // to be used when you want to re-use a nv
        this.nodePath.length = 0;
    },

    setFrameStamp: function(frameStamp) {
        this._frameStamp = frameStamp;
    },

    getFrameStamp: function() {
        return this._frameStamp;
    },

    setNodeMaskOverride: function(m) {
        this.nodeMaskOverride = m;
    },
    getNodeMaskOverride: function() {
        return this.nodeMaskOverride;
    },

    setTraversalMask: function(m) {
        this.traversalMask = m;
    },
    getTraversalMask: function() {
        return this.traversalMask;
    },

    getNodePath: function() {
        return this.nodePath;
    },

    validNodeMask: function(node) {
        var nm = node.getNodeMask();
        /*jshint bitwise: false */
        return (this.traversalMask & (this.nodeMaskOverride | nm)) !== 0;
        /*jshint bitwise: true */
    },
    apply: function(node) {
        this.traverse(node);
    },
    getVisitorType: function() {
        return this.visitorType;
    },
    setDatabaseRequestHandler: function(dbpager) {
        this._databaseRequestHandler = dbpager;
    },
    getDatabaseRequestHandler: function() {
        return this._databaseRequestHandler;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (NodeVisitor);


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);



var StateAttribute = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    StateAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        _attributeTypeIndex: undefined,

        getType: function() {
            return this.attributeType;
        },

        // basically, if you want two StateAttribute with the same attributeType in a stateSet/State
        // their typeMember should be different
        getTypeMember: function() {
            return this.attributeType;
        },

        apply: function() {},

        // getHash is used by the compiler to know if a change in a StateAttribute
        // must trigger a shader build
        // If you create your own attribute you will have to customize this function
        // a good rule is to that if you change uniform it should not rebuild a shader
        // but if you change a type or representation of your StateAttribute, then it should
        // if it impact the rendering.
        // check other attributes for examples
        getHash: function() {
            return this.getType();
        }
    }),
    'osg',
    'StateAttribute'
);

StateAttribute.OFF = 0;
StateAttribute.ON = 1;
StateAttribute.OVERRIDE = 2;
StateAttribute.PROTECTED = 4;
StateAttribute.INHERIT = 8;

/* harmony default export */ __webpack_exports__["a"] = (StateAttribute);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


/**
 * Uniform manage variable used in glsl shader.
 * @class Uniform
 */
var Uniform = function(name) {
    this._data = undefined;
    this._transpose = false;
    this._glCall = '';
    this._cache = undefined;
    this._name = name;
    this._type = undefined;
    this._isMatrix = false;
};

Uniform.isUniform = function(obj) {
    if (typeof obj === 'object' && window.Object.getPrototypeOf(obj) === Uniform.prototype) {
        return true;
    }
    return false;
};

/** @lends Uniform.prototype */
Uniform.prototype = {
    getName: function() {
        return this._name;
    },

    getType: function() {
        return this._type;
    },

    apply: function UniformApply(gl, location) {
        if (!this._cache) this._cache = gl[this._glCall];

        if (this._isMatrix) {
            this._cache.call(gl, location, this._transpose, this._data);
        } else {
            this._cache.call(gl, location, this._data);
        }
    },

    // no type checking, so array should be valid
    setInternalArray: function(array) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(
            'setInternalArray deprecated, please use getInternalArray instead: ' + array.length
        );
        this._data = array;
    },

    getInternalArray: function() {
        return this._data;
    },

    setFloat: function(f) {
        this._data[0] = f;
    },

    setFloat1: function(f) {
        this._data[0] = f[0];
    },

    setFloat2: function(f) {
        this._data[0] = f[0];
        this._data[1] = f[1];
    },

    setFloat3: function(f) {
        this._data[0] = f[0];
        this._data[1] = f[1];
        this._data[2] = f[2];
    },

    setFloat4: function(f) {
        this._data[0] = f[0];
        this._data[1] = f[1];
        this._data[2] = f[2];
        this._data[3] = f[3];
    },

    setFloat9: function(f) {
        this._data[0] = f[0];
        this._data[1] = f[1];
        this._data[2] = f[2];
        this._data[3] = f[3];
        this._data[4] = f[4];
        this._data[5] = f[5];
        this._data[6] = f[6];
        this._data[7] = f[7];
        this._data[8] = f[8];
    },

    setFloat16: function(f) {
        this._data[0] = f[0];
        this._data[1] = f[1];
        this._data[2] = f[2];
        this._data[3] = f[3];
        this._data[4] = f[4];
        this._data[5] = f[5];
        this._data[6] = f[6];
        this._data[7] = f[7];
        this._data[8] = f[8];
        this._data[9] = f[9];
        this._data[10] = f[10];
        this._data[11] = f[11];
        this._data[12] = f[12];
        this._data[13] = f[13];
        this._data[14] = f[14];
        this._data[15] = f[15];
    }
};
Uniform.prototype.setVec2 = Uniform.prototype.setFloat2;
Uniform.prototype.setVec3 = Uniform.prototype.setFloat3;
Uniform.prototype.setVec4 = Uniform.prototype.setFloat4;
Uniform.prototype.setMatrix4 = Uniform.prototype.setFloat16;
Uniform.prototype.setMatrix3 = Uniform.prototype.setFloat9;
Uniform.prototype.setInt = Uniform.prototype.setFloat;
Uniform.prototype.setInt1 = Uniform.prototype.setFloat1;
Uniform.prototype.setInt2 = Uniform.prototype.setFloat2;
Uniform.prototype.setInt3 = Uniform.prototype.setFloat3;
Uniform.prototype.setInt4 = Uniform.prototype.setFloat4;

var createUniformX = function(
    dataOrName,
    nameOrNbItem,
    internalArray,
    glSignature,
    type,
    isMatrix
) {
    var data = nameOrNbItem && nameOrNbItem.length ? dataOrName : undefined;
    var uniform = new Uniform(data !== undefined ? nameOrNbItem : dataOrName);

    uniform._data = internalArray;

    if (data !== undefined) {
        if (data.length) {
            for (var i = 0, nbElts = data.length; i < nbElts; ++i) uniform._data[i] = data[i];
        } else {
            uniform._data[0] = data;
        }
    }

    uniform._glCall = glSignature;
    uniform._type = type;
    uniform._isMatrix = !!isMatrix;
    return uniform;
};

var createMat2 = function(nbItem) {
    var out = new Float32Array(nbItem * 4);
    for (var i = 0; i < out.length; i += 4) out[i] = out[i + 3] = 1.0;
    return out;
};

var createMat3 = function(nbItem) {
    var out = new Float32Array(nbItem * 9);
    for (var i = 0; i < out.length; i += 9) out[i] = out[i + 4] = out[i + 8] = 1.0;
    return out;
};

var createMat4 = function(nbItem) {
    var out = new Float32Array(nbItem * 16);
    for (var i = 0; i < out.length; i += 16) out[i] = out[i + 5] = out[i + 10] = out[i + 15] = 1.0;
    return out;
};

// possibles signatures
// name
// data, name
// name, nbItem
var _getNbItem = function(itemSize, dataOrName, nameOrNbItem) {
    if (nameOrNbItem && !nameOrNbItem.length) return nameOrNbItem; // name, nbItem
    if (typeof dataOrName !== 'string') return (dataOrName.length || 1) / itemSize; // data, name
    return 1; // name
};

// works also for float array but data must be given
Uniform.createFloat1 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Float32Array(1 * _getNbItem(1, dataOrName, nameOrNbItem)),
        'uniform1fv',
        'float'
    );
};
Uniform.createFloat2 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Float32Array(2 * _getNbItem(2, dataOrName, nameOrNbItem)),
        'uniform2fv',
        'vec2'
    );
};
Uniform.createFloat3 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Float32Array(3 * _getNbItem(3, dataOrName, nameOrNbItem)),
        'uniform3fv',
        'vec3'
    );
};
Uniform.createFloat4 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Float32Array(4 * _getNbItem(4, dataOrName, nameOrNbItem)),
        'uniform4fv',
        'vec4'
    );
};

Uniform.createInt1 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Int32Array(1 * _getNbItem(1, dataOrName, nameOrNbItem)),
        'uniform1iv',
        'int'
    );
};
Uniform.createInt2 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Int32Array(2 * _getNbItem(2, dataOrName, nameOrNbItem)),
        'uniform2iv',
        'vec2i'
    );
};
Uniform.createInt3 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Int32Array(3 * _getNbItem(3, dataOrName, nameOrNbItem)),
        'uniform3iv',
        'vec3i'
    );
};
Uniform.createInt4 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        new Int32Array(4 * _getNbItem(4, dataOrName, nameOrNbItem)),
        'uniform4iv',
        'vec4i'
    );
};

Uniform.createMatrix2 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        createMat2(_getNbItem(4, dataOrName, nameOrNbItem)),
        'uniformMatrix2fv',
        'mat2',
        true
    );
};

Uniform.createMatrix3 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        createMat3(_getNbItem(9, dataOrName, nameOrNbItem)),
        'uniformMatrix3fv',
        'mat3',
        true
    );
};

Uniform.createMatrix4 = function(dataOrName, nameOrNbItem) {
    return createUniformX(
        dataOrName,
        nameOrNbItem,
        createMat4(_getNbItem(16, dataOrName, nameOrNbItem)),
        'uniformMatrix4fv',
        'mat4',
        true
    );
};

// alias
Uniform.float = Uniform.createFloatArray = Uniform.createFloat = Uniform.createFloat1;
Uniform.vec2 = Uniform.createFloat2Array = Uniform.createFloat2;
Uniform.vec3 = Uniform.createFloat3Array = Uniform.createFloat3;
Uniform.vec4 = Uniform.createFloat4Array = Uniform.createFloat4;

Uniform.int = Uniform.createIntArray = Uniform.createInt = Uniform.createInt1;
Uniform.vec2i = Uniform.createInt2Array = Uniform.createInt2;
Uniform.vec3i = Uniform.createInt3Array = Uniform.createInt3;
Uniform.vec4i = Uniform.createInt4Array = Uniform.createInt4;

Uniform.mat2 = Uniform.createMat2Array = Uniform.createMat2 = Uniform.createMatrix2;
Uniform.mat3 = Uniform.createMat3Array = Uniform.createMat3 = Uniform.createMatrix3;
Uniform.mat4 = Uniform.createMat4Array = Uniform.createMat4 = Uniform.createMatrix4;

/* harmony default export */ __webpack_exports__["a"] = (Uniform);


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);


/**
 *  Object class
 *  @class Object
 */
var OSGObject = function() {
    this._name = undefined;
    this._userdata = undefined;
    this._instanceID = OSGObject.getInstanceID();
};

/** @lends Object.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    OSGObject,
    {
        // this method works only if constructor is set correctly
        // see issue https://github.com/cedricpinson/osgjs/issues/494
        cloneType: function() {
            var Constructor = this.constructor;
            return new Constructor();
        },

        getInstanceID: function() {
            return this._instanceID;
        },

        setName: function(name) {
            this._name = name;
        },

        getName: function() {
            return this._name;
        },

        setUserData: function(data) {
            this._userdata = data;
        },

        getUserData: function() {
            return this._userdata;
        }
    },
    'osg',
    'Object'
);

// get an instanceID for each object
var instanceID = 0;
OSGObject.getInstanceID = function() {
    instanceID += 1;
    return instanceID;
};

/* harmony default export */ __webpack_exports__["a"] = (OSGObject);


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Image__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_TextureManager__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_WebGLCaps__ = __webpack_require__(28);










var ImageBitmap = window.ImageBitmap || function() {};

// helper
var isPowerOf2 = function(x) {
    /*jshint bitwise: false */
    return x !== 0 && (x & (~x + 1)) === x;
    /*jshint bitwise: true */
};

/**
 * Texture encapsulate webgl texture object
 * @class Texture
 * Not that dirty here is mainly for texture binding
 * any dirty will cause re-bind
 * hint: don't dirty a texture attached to a camera/framebuffer
 * it will end blank
 * @inherits StateAttribute
 */
var Texture = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_StateAttribute__["a" /* default */].call(this);
    __WEBPACK_IMPORTED_MODULE_5_osg_GLObject__["a" /* default */].call(this);
    this.setDefaultParameters();
    this._dirty = true;
    this._dirtyMipmap = true;
    this._applyTexImage2DCallbacks = [];
    this._textureObject = undefined;

    this._textureNull = true;
};

var checkAndFixEnum = function(mode, fallback) {
    var value = Texture[mode];

    if (value === undefined) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('bad Texture enum argument ' + mode + '\n' + 'fallback to ' + fallback);
        return fallback;
    }

    return value;
};

Texture.UNPACK_COLORSPACE_CONVERSION_WEBGL = 0x9243;
Texture.UNPACK_FLIP_Y_WEBGL = 0x9240;
Texture.BROWSER_DEFAULT_WEBGL = 0x9244;
Texture.NONE = 0x0;

Texture.DEPTH_COMPONENT = 0x1902;
Texture.DEPTH_COMPONENT16 = 0x81a5;
Texture.DEPTH_STENCIL = 0x84f9;
// gl2
Texture.DEPTH24_STENCIL8 = 0x88f0;
Texture.DEPTH_COMPONENT24 = 0x81a6;
Texture.DEPTH_COMPONENT32F = 0x8cac;

// DXT formats, from:
// http://www.khronos.org/registry/webgl/extensions/WEBGL_compressed_texture_s3tc/
Texture.COMPRESSED_RGB_S3TC_DXT1_EXT = 0x83f0;
Texture.COMPRESSED_RGBA_S3TC_DXT1_EXT = 0x83f1;
Texture.COMPRESSED_RGBA_S3TC_DXT3_EXT = 0x83f2;
Texture.COMPRESSED_RGBA_S3TC_DXT5_EXT = 0x83f3;

// ATC formats, from:
// http://www.khronos.org/registry/webgl/extensions/WEBGL_compressed_texture_atc/
Texture.COMPRESSED_RGB_ATC_WEBGL = 0x8c92;
Texture.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL = 0x8c93;
Texture.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL = 0x87ee;

// PVR formats, from:
// http://www.khronos.org/registry/webgl/extensions/WEBGL_compressed_texture_pvrtc/
Texture.COMPRESSED_RGB_PVRTC_4BPPV1_IMG = 0x8c00;
Texture.COMPRESSED_RGB_PVRTC_2BPPV1_IMG = 0x8c01;
Texture.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG = 0x8c02;
Texture.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG = 0x8c03;

// ETC1 format, from:
// http://www.khronos.org/registry/webgl/extensions/WEBGL_compressed_texture_etc1/
Texture.COMPRESSED_RGB_ETC1_WEBGL = 0x8d64;

// filter mode
Texture.LINEAR = 0x2601;
Texture.NEAREST = 0x2600;
Texture.NEAREST_MIPMAP_NEAREST = 0x2700;
Texture.LINEAR_MIPMAP_NEAREST = 0x2701;
Texture.NEAREST_MIPMAP_LINEAR = 0x2702;
Texture.LINEAR_MIPMAP_LINEAR = 0x2703;
// filter anisotropy
Texture.TEXTURE_MAX_ANISOTROPY_EXT = 0x84fe;
Texture.MAX_TEXTURE_MAX_ANISOTROPY_EXT = 0x84ff;

// wrap mode
Texture.CLAMP_TO_EDGE = 0x812f;
Texture.REPEAT = 0x2901;
Texture.MIRRORED_REPEAT = 0x8370;

// target
Texture.TEXTURE_2D = 0x0de1;
Texture.TEXTURE_CUBE_MAP = 0x8513;
Texture.TEXTURE_BINDING_CUBE_MAP = 0x8514;
Texture.TEXTURE_CUBE_MAP_POSITIVE_X = 0x8515;
Texture.TEXTURE_CUBE_MAP_NEGATIVE_X = 0x8516;
Texture.TEXTURE_CUBE_MAP_POSITIVE_Y = 0x8517;
Texture.TEXTURE_CUBE_MAP_NEGATIVE_Y = 0x8518;
Texture.TEXTURE_CUBE_MAP_POSITIVE_Z = 0x8519;
Texture.TEXTURE_CUBE_MAP_NEGATIVE_Z = 0x851a;
Texture.MAX_CUBE_MAP_TEXTURE_SIZE = 0x851c;

// https: //www.khronos.org/registry/webgl/specs/latest/2.0/#3.7.6
///////////
// TYPE GL1
///////////
Texture.UNSIGNED_BYTE = 0x1401;
Texture.UNSIGNED_SHORT = 0x1403;
Texture.UNSIGNED_SHORT_4_4_4_4 = 0x8033;
Texture.UNSIGNED_SHORT_5_5_5_1 = 0x8034;
Texture.UNSIGNED_SHORT_5_6_5 = 0x8363;
Texture.FLOAT = 0x1406;
Texture.HALF_FLOAT_OES = 0x8d61;
// TYPE GL2
Texture.HALF_FLOAT = 0x140b;
Texture.UNSIGNED_INT_10F_11F_11F_REV = 0x8c3b;
Texture.UNSIGNED_INT_24_8 = 0x84fa;

/////////////
// FORMAT GL1
/////////////
Texture.ALPHA = 0x1906;
Texture.RGB = 0x1907;
Texture.RGBA = 0x1908;
Texture.LUMINANCE = 0x1909;
Texture.LUMINANCE_ALPHA = 0x190a;
// format gl2
Texture.RED_INTEGER = 0x8d94;
Texture.RGB_INTEGER = 0x8d98;
Texture.RGBA_INTEGER = 0x8d99;
Texture.RG_INTEGER = 0x8228;
Texture.RED = 0x1903;

//////////////////////
// INTERNAL FORMAT GL2
//////////////////////
Texture.R8 = 0x8229;
Texture.R8UI = 0x8232;
Texture.RG8 = 0x822b;
Texture.RG8UI = 0x8238;
Texture.RGB8 = 0x8f96;
Texture.RGB565 = 0x8d62;
Texture.RGB9_E5 = 0x8c3d;
Texture.RGB8UI = 0x8d7d;
Texture.RGBA8 = 0x8058;
Texture.RGB5_A1 = 0x8057;
Texture.RGBA4 = 0x8056;
Texture.RGBA8UI = 0x8d7c;
Texture.SRGB8_ALPHA8 = 0x8c43;
Texture.SRGB8 = 0x8c41;

// HALF FLOAT - FLOAT
Texture.R16F = 0x822d;
Texture.RG16F = 0x822f;
Texture.RGB16F = 0x881b;
Texture.RGBA16F = 0x881a;
Texture.R11F_G11F_B10F = 0x8c3a; // and UNSIGNED_INT_10F_11F_11F_REV
// FLOAT
Texture.R32F = 0x822e;
Texture.RG32F = 0x8230;
Texture.RGB32F = 0x8815;
Texture.RGBA32F = 0x8814;

var createMapGl2ToGl1 = function() {
    var map = {};

    map[Texture.R8] = Texture.LUMINANCE;
    map[Texture.R8UI] = Texture.LUMINANCE;
    map[Texture.R16F] = Texture.LUMINANCE;
    map[Texture.R32F] = Texture.LUMINANCE;
    map[Texture.SRGB8] = Texture.LUMINANCE;
    map[Texture.RG8] = Texture.RGB;
    map[Texture.RG8UI] = Texture.RGB;
    map[Texture.RG16F] = Texture.RGB;
    map[Texture.RG32F] = Texture.RGB;
    map[Texture.RGB8] = Texture.RGB;
    map[Texture.RGB565] = Texture.RGB;
    map[Texture.RGB9_E5] = Texture.RGB;
    map[Texture.RGB8UI] = Texture.RGB;
    map[Texture.RGB5_A1] = Texture.RGB;
    map[Texture.RGB16F] = Texture.RGB;
    map[Texture.RGB32F] = Texture.RGB;
    map[Texture.RGBA8] = Texture.RGBA;
    map[Texture.R11F_G11F_B10F] = Texture.RGBA;
    map[Texture.RGBA16F] = Texture.RGBA;
    map[Texture.RGBA32F] = Texture.RGBA;
    map[Texture.SRGB8_ALPHA8] = Texture.RGBA;

    return map;
};

var createMapGl1ToGl2 = function() {
    var map = {};

    var float = {};
    var halfFloat = {};
    var ushort = {};
    var uint = {};
    var uin24 = {};

    map[Texture.FLOAT] = float;
    map[Texture.HALF_FLOAT] = map[Texture.HALF_FLOAT_OES] = halfFloat;
    map[Texture.UNSIGNED_SHORT] = ushort;
    map[Texture.UNSIGNED_INT] = uint;
    map[Texture.UNSIGNED_INT_24_8] = uin24;

    halfFloat[Texture.LUMINANCE] = Texture.R16F;
    halfFloat[Texture.RGB] = Texture.RGB16F;
    halfFloat[Texture.RGBA] = Texture.RGBA16F;

    float[Texture.LUMINANCE] = Texture.R32F;
    float[Texture.RGB] = Texture.RGB32F;
    float[Texture.RGBA] = Texture.RGBA32F;

    ushort[Texture.DEPTH_COMPONENT] = Texture.DEPTH_COMPONENT16;
    uint[Texture.DEPTH_COMPONENT] = Texture.DEPTH_COMPONENT32F;
    uin24[Texture.DEPTH_STENCIL] = Texture.DEPTH24_STENCIL8;

    return map;
};

var internalFormatGl2ToGl1 = createMapGl2ToGl1();
var internalFormatGl1ToGl2 = createMapGl1ToGl2();

Texture._sTextureManager = new window.Map();

// Getter for textureManager
Texture.getTextureManager = function(gl) {
    if (!Texture._sTextureManager.has(gl)) Texture._sTextureManager.set(gl, new __WEBPACK_IMPORTED_MODULE_6_osg_TextureManager__["a" /* default */]());

    return Texture._sTextureManager.get(gl);
};

Texture.getEnumFromString = function(v) {
    var value = v;

    if (typeof value === 'string') value = checkAndFixEnum(value, v);

    return value;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Texture,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(
        __WEBPACK_IMPORTED_MODULE_5_osg_GLObject__["a" /* default */].prototype,
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_StateAttribute__["a" /* default */].prototype, {
            attributeType: 'Texture',

            cloneType: function() {
                return new Texture();
            },

            invalidate: function() {
                this._textureObject = undefined;
                this.dirty();
            },

            dirty: function() {
                this._dirty = true;
            },

            isDirty: function() {
                return this._dirty;
            },

            isTextureNull: function() {
                return this._textureNull;
            },

            getOrCreateUniforms: function(unit) {
                if (Texture.uniforms === undefined) {
                    Texture.uniforms = [];
                }
                if (Texture.uniforms[unit] === undefined) {
                    var name = this.getType() + unit;
                    Texture.uniforms[unit] = {
                        texture: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createInt1(unit, name)
                    };
                }

                // uniform for an texture attribute should directly in Texture.uniforms[unit]
                // and not in Texture.uniforms[unit][Texture0]

                // Why it's in Texture.uniforms[unit]['texture'] :
                // a 'texture' is a texture attribute but you also have old texenv
                //  that are texture attribute because  they are applied on a texture unit.
                // I admit that currently we dont have this or we used to but we dont have it anymore.
                // It's the same design than osg.
                // We could imagine for example a TextureGreyScale texture attributes,
                // that would transform the input texture
                // on unit X into greyscale used in the shader.

                return Texture.uniforms[unit];
            },

            setDefaultParameters: function() {
                this._image = undefined;
                this._magFilter = Texture.LINEAR;
                this._minFilter = Texture.LINEAR;
                this._maxAnisotropy = 1.0;
                this._wrapS = Texture.CLAMP_TO_EDGE;
                this._wrapT = Texture.CLAMP_TO_EDGE;
                this._textureWidth = 0;
                this._textureHeight = 0;
                this._unrefImageDataAfterApply = false;
                this._internalFormat = undefined;
                this._dirtyMipmap = true;
                this._textureTarget = Texture.TEXTURE_2D;
                this.setInternalFormatType(Texture.UNSIGNED_BYTE);
                this._isCompressed = false;

                this._flipY = true;
                this._colorSpaceConversion = Texture.NONE; //Texture.BROWSER_DEFAULT_WEBGL;
            },

            // check https://www.khronos.org/registry/webgl/specs/latest/1.0/#PIXEL_STORAGE_PARAMETERS
            setColorSpaceConversion: function(enumValue) {
                this._colorSpaceConversion = enumValue;
            },

            setFlipY: function(bool) {
                this._flipY = bool;
            },

            getTextureTarget: function() {
                return this._textureTarget;
            },

            getTextureObject: function() {
                return this._textureObject;
            },

            setTextureSize: function(w, h) {
                var maxSize = __WEBPACK_IMPORTED_MODULE_7_osg_WebGLCaps__["a" /* default */].instance().getWebGLParameter('MAX_TEXTURE_SIZE');

                if (w !== this._textureWidth || h !== this._textureHeight) this.dirty();

                if (w !== undefined) {
                    if (w > maxSize) {
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
                            'width (' +
                                w +
                                ') too big for GPU. Max Texture Size is "' +
                                maxSize +
                                '"'
                        );
                        this._textureWidth = maxSize;
                    } else {
                        this._textureWidth = w;
                    }
                }

                if (h !== undefined) {
                    if (h > maxSize) {
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
                            'height (' +
                                h +
                                ') too big for GPU. Max Texture Size is "' +
                                maxSize +
                                '"'
                        );
                        this._textureHeight = maxSize;
                    } else {
                        this._textureHeight = h;
                    }
                }

                this._textureNull = false;
            },

            init: function(state) {
                if (!this._gl) {
                    this.setGraphicContext(state.getGraphicContext());
                }

                if (!this._textureObject) {
                    this._textureObject = Texture.getTextureManager(this._gl).generateTextureObject(
                        this._gl,
                        this,
                        this._textureTarget,
                        this._internalFormat,
                        this._textureWidth,
                        this._textureHeight
                    );

                    this.dirty();
                    this._dirtyTextureObject = false;
                    this._textureNull = false;
                }
            },

            addApplyTexImage2DCallback: function(callback) {
                var index = this._applyTexImage2DCallbacks.indexOf(callback);
                if (index < 0) {
                    this._applyTexImage2DCallbacks.push(callback);
                }
            },

            removeApplyTexImage2DCallback: function(callback) {
                var index = this._applyTexImage2DCallbacks.indexOf(callback);
                if (index >= 0) {
                    this._applyTexImage2DCallbacks.splice(index, 1);
                }
            },

            getWidth: function() {
                return this._textureWidth;
            },

            getHeight: function() {
                return this._textureHeight;
            },

            releaseGLObjects: function() {
                if (
                    this._textureObject !== undefined &&
                    this._textureObject !== null &&
                    this._gl !== undefined
                ) {
                    Texture.getTextureManager(this._gl).releaseTextureObject(this._textureObject);
                    __WEBPACK_IMPORTED_MODULE_5_osg_GLObject__["a" /* default */].removeObject(this._gl, this);
                }
                this.invalidate();
            },

            getWrapT: function() {
                return this._wrapT;
            },

            getWrapS: function() {
                return this._wrapS;
            },

            setWrapS: function(value) {
                if (typeof value === 'string') {
                    this._wrapS = checkAndFixEnum(value, Texture.CLAMP_TO_EDGE);
                } else {
                    this._wrapS = value;
                }

                this.dirtyTextureParameters();
            },

            setWrapT: function(value) {
                if (typeof value === 'string') {
                    this._wrapT = checkAndFixEnum(value, Texture.CLAMP_TO_EDGE);
                } else {
                    this._wrapT = value;
                }

                this.dirtyTextureParameters();
            },

            // TODO CP:
            // we should split dirty texture object of parameters
            // dirty parameters only regenarate parameter
            // dirty texture object needs to release a texture and
            // re allocate one
            dirtyTextureParameters: function() {
                this.dirty(); // make everything dirty for now
                this.dirtyMipmap();
                this.dirtyTextureObject();
            },

            dirtyTextureObject: function() {
                this._dirtyTextureObject = true;
                this.dirtyMipmap();
                this.dirty(); // make everything dirty for now
            },

            getMinFilter: function() {
                return this._minFilter;
            },

            getMagFilter: function() {
                return this._magFilter;
            },

            // https://www.opengl.org/registry/specs/EXT/texture_filter_anisotropic.txt
            setMaxAnisotropy: function(multiplier) {
                this._maxAnisotropy = multiplier;
                this.dirtyTextureParameters();
            },

            getMaxAnisotropy: function() {
                return this._maxAnisotropy;
            },

            // some value enable mipmapping
            setMinFilter: function(value) {
                if (typeof value === 'string') {
                    this._minFilter = checkAndFixEnum(value, Texture.LINEAR);
                } else {
                    this._minFilter = value;
                }

                this.dirtyTextureParameters();
            },

            // Either Linear or nearest.
            setMagFilter: function(value) {
                if (typeof value === 'string') {
                    this._magFilter = checkAndFixEnum(value, Texture.LINEAR);
                } else {
                    this._magFilter = value;
                }

                this.dirtyTextureParameters();
            },

            setImage: function(img, imageFormat) {
                var image = img;
                if (
                    img instanceof window.Image ||
                    img instanceof HTMLCanvasElement ||
                    img instanceof ImageBitmap ||
                    img instanceof Uint8Array ||
                    img instanceof Uint16Array ||
                    img instanceof Float32Array
                ) {
                    image = new __WEBPACK_IMPORTED_MODULE_4_osg_Image__["a" /* default */](img);
                }

                this._image = image;
                this.setImageFormat(imageFormat);
                if (image) {
                    if (image.getWidth && image.getHeight) {
                        this.setTextureSize(image.getWidth(), image.getHeight());
                    } else if (image.width && image.height) {
                        this.setTextureSize(image.width, image.height);
                    }
                }
                this._textureNull = false;
                this.dirty();
            },

            getImage: function() {
                return this._image;
            },

            setImageFormat: function(format) {
                var imageFormat = format;
                if (imageFormat) {
                    if (typeof imageFormat === 'string') imageFormat = Texture[imageFormat];

                    this._imageFormat = imageFormat;
                } else {
                    this._imageFormat = Texture.RGBA;
                }
            },

            setInternalFormatType: function(value) {
                // UNSIGNED_BYTE, HALF_FLOAT, FLOAT

                if (typeof value === 'string') {
                    this._type = Texture[value];
                } else {
                    this._type = value;
                }
            },

            getInternalFormatType: function() {
                return this._type;
            },

            setUnrefImageDataAfterApply: function(bool) {
                this._unrefImageDataAfterApply = bool;
            },

            checkIsCompressed: function(format) {
                var fo = format || this._internalFormat;
                switch (fo) {
                    case Texture.COMPRESSED_RGB_S3TC_DXT1_EXT:
                    case Texture.COMPRESSED_RGBA_S3TC_DXT1_EXT:
                    case Texture.COMPRESSED_RGBA_S3TC_DXT3_EXT:
                    case Texture.COMPRESSED_RGBA_S3TC_DXT5_EXT:
                    case Texture.COMPRESSED_RGB_ATC_WEBGL:
                    case Texture.COMPRESSED_RGBA_ATC_EXPLICIT_ALPHA_WEBGL:
                    case Texture.COMPRESSED_RGBA_ATC_INTERPOLATED_ALPHA_WEBGL:
                    case Texture.COMPRESSED_RGB_PVRTC_4BPPV1_IMG:
                    case Texture.COMPRESSED_RGB_PVRTC_2BPPV1_IMG:
                    case Texture.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG:
                    case Texture.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG:
                    case Texture.COMPRESSED_RGB_ETC1_WEBGL:
                        return true;
                    default:
                        return false;
                }
            },

            setInternalFormat: function(formatSource) {
                // RGB, RGBA, ALPHA, LUMINANCE, LUMINANCE_ALPHA
                // RGB16F, RGB32F, etc...
                // DEPTH_COMPONENT, DEPTH_STENCIL

                var format = formatSource;
                if (format) {
                    if (typeof format === 'string') format = Texture[format];

                    this._isCompressed = this.checkIsCompressed(format);
                } else {
                    this._isCompressed = false;
                    format = Texture.RGBA;
                }

                this._internalFormat = format;
            },

            getInternalFormat: function() {
                return this._internalFormat;
            },

            isDirtyMipmap: function() {
                return this._dirtyMipmap;
            },

            // Will cause the mipmaps to be regenerated on the next bind of the texture
            // Nothing will be done if the minFilter is not of the form XXX_MIPMAP_XXX
            // TODO : not to be used if the texture is compressed !
            dirtyMipmap: function() {
                this._dirtyMipmap = true;
            },

            applyFilterParameter: function(gl, target) {
                var powerOfTwo = isPowerOf2(this._textureWidth) && isPowerOf2(this._textureHeight);
                if (!powerOfTwo) {
                    // NPOT non support in webGL explained here
                    // https://www.khronos.org/webgl/wiki/WebGL_and_OpenGL_Differences#Non-Power_of_Two_Texture_Support
                    // so disabling mipmap...
                    this._wrapT = Texture.CLAMP_TO_EDGE;
                    this._wrapS = Texture.CLAMP_TO_EDGE;

                    if (
                        this._minFilter === Texture.LINEAR_MIPMAP_LINEAR ||
                        this._minFilter === Texture.LINEAR_MIPMAP_NEAREST
                    ) {
                        this._minFilter = Texture.LINEAR;
                    }
                }
                gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, this._magFilter);
                gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, this._minFilter);

                // handle extension EXT_texture_filter_anisotropic
                if (this._maxAnisotropy > 1.0 && Texture.ANISOTROPIC_SUPPORT_EXT) {
                    var multiplier =
                        this._maxAnisotropy < Texture.ANISOTROPIC_SUPPORT_MAX
                            ? this._maxAnisotropy
                            : Texture.ANISOTROPIC_SUPPORT_MAX;
                    gl.texParameterf(target, Texture.TEXTURE_MAX_ANISOTROPY_EXT, multiplier);
                }

                gl.texParameteri(target, gl.TEXTURE_WRAP_S, this._wrapS);
                gl.texParameteri(target, gl.TEXTURE_WRAP_T, this._wrapT);
            },

            generateMipmap: function(gl, target) {
                this._dirtyMipmap = false;
                if (!this.hasMipmapFilter()) return;

                // manual mipmap provided
                var img = this._image;
                if (img && img.hasMipmap()) {
                    var internalFormat = this._getInternalFormatGL();
                    var mips = img.getMipmap();
                    for (var level = 1, nbLevel = mips.length; level < nbLevel; level++) {
                        var imi = mips[level];
                        if (this._isCompressed)
                            this.applyTexImage2D(
                                gl,
                                this._textureTarget,
                                level,
                                internalFormat,
                                imi.getWidth(),
                                imi.getHeight(),
                                0,
                                imi.getImage()
                            );
                        else
                            this.applyTexImage2D(
                                gl,
                                this._textureTarget,
                                level,
                                internalFormat,
                                imi.getWidth(),
                                imi.getHeight(),
                                0,
                                this._internalFormat,
                                this._type,
                                imi.getImage()
                            );
                    }
                } else {
                    // automatic mipmap
                    gl.generateMipmap(target);
                }
            },

            // return true if contains a mipmap filter
            hasMipmapFilter: function() {
                return (
                    this._minFilter === Texture.NEAREST_MIPMAP_NEAREST ||
                    this._minFilter === Texture.LINEAR_MIPMAP_NEAREST ||
                    this._minFilter === Texture.NEAREST_MIPMAP_LINEAR ||
                    this._minFilter === Texture.LINEAR_MIPMAP_LINEAR
                );
            },

            applyTexImage2D: function(gl) {
                var args = Array.prototype.slice.call(arguments, 1);
                __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeStamp('osgjs.metrics:Texture.texImage2d');

                // use parameters of pixel store
                gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, this._flipY);
                gl.pixelStorei(gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._colorSpaceConversion);

                if (this._isCompressed) gl.compressedTexImage2D.apply(gl, args);
                else gl.texImage2D.apply(gl, args);

                // call a callback when upload is done if there is one
                var numCallback = this._applyTexImage2DCallbacks.length;
                if (numCallback > 0) {
                    for (var i = 0, l = numCallback; i < l; i++) {
                        this._applyTexImage2DCallbacks[i].call(this);
                    }
                }
            },

            computeTextureFormat: function() {
                if (!this._internalFormat) {
                    this._internalFormat = this._imageFormat || Texture.RGBA;
                    this._imageFormat = this._internalFormat;
                } else {
                    this._imageFormat = this._internalFormat;
                }
            },

            applyImage: function(gl) {
                var internalFormat = this._getInternalFormatGL();
                var image = this._image || null;
                var data = image && this._image.getImage();

                var type = this._getTypeGL();

                if (this._isCompressed) {
                    this.applyTexImage2D(
                        gl,
                        this._textureTarget,
                        0,
                        internalFormat,
                        this._textureWidth,
                        this._textureHeight,
                        0,
                        data
                    );
                } else if (!data || image.isTypedArray()) {
                    this.applyTexImage2D(
                        gl,
                        this._textureTarget,
                        0,
                        internalFormat,
                        this._textureWidth,
                        this._textureHeight,
                        0,
                        this._internalFormat,
                        type,
                        data
                    );
                } else {
                    this.applyTexImage2D(
                        gl,
                        this._textureTarget,
                        0,
                        internalFormat,
                        this._internalFormat,
                        type,
                        data
                    );
                }

                if (image) image.setDirty(false);
            },

            apply: function(state) {
                var gl = state.getGraphicContext();
                // if need to release the texture
                if (this._dirtyTextureObject) {
                    this.releaseGLObjects();
                    this._dirtyTextureObject = false;
                    this.setGraphicContext(gl);
                }

                if (this._textureObject !== undefined && !this.isDirty()) {
                    this._textureObject.bind(gl);
                    // If we have modified the texture via Rtt or texSubImage2D and _need_ updated mipmaps,
                    // then we must regenerate the mipmaps explicitely.
                    // In all other cases, don't set this flag because it can be costly
                    if (this.isDirtyMipmap()) {
                        this.generateMipmap(gl, this._textureTarget);
                    }

                    // image update like video
                    if (this._image !== undefined && this._image.isDirty()) {
                        this.applyImage(gl);
                    }
                } else if (this._textureNull) {
                    gl.bindTexture(this._textureTarget, null);
                } else {
                    var image = this._image;
                    if (image !== undefined) {
                        // when data is ready we will upload it to the gpu
                        if (image.isReady()) {
                            // must be called before init
                            this.computeTextureFormat();

                            var imgWidth = image.getWidth() || this._textureWidth;
                            var imgHeight = image.getHeight() || this._textureHeight;

                            this.setTextureSize(imgWidth, imgHeight);

                            if (!this._textureObject) {
                                this.init(state);
                            }

                            this._textureObject.bind(gl);

                            this.applyImage(gl);
                            this.applyFilterParameter(gl, this._textureTarget);
                            this.generateMipmap(gl, this._textureTarget);

                            if (this._unrefImageDataAfterApply) {
                                this._image = undefined;
                            }

                            this._dirty = false;
                        } else {
                            gl.bindTexture(this._textureTarget, null);
                        }
                    } else if (this._textureHeight !== 0 && this._textureWidth !== 0) {
                        // must be called before init
                        this.computeTextureFormat();

                        if (!this._textureObject) {
                            this.init(state);
                        }
                        this._textureObject.bind(gl);

                        this.applyImage(gl);

                        this.applyFilterParameter(gl, this._textureTarget);
                        this.generateMipmap(gl, this._textureTarget);
                        this._dirty = false;
                    }
                }
            },

            _getInternalFormatGL: function() {
                var internalFormat = this._internalFormat;

                // gl1
                if (!__WEBPACK_IMPORTED_MODULE_7_osg_WebGLCaps__["a" /* default */].instance().isWebGL2()) {
                    return internalFormatGl2ToGl1[internalFormat] || internalFormat;
                }

                // gl2
                var map = internalFormatGl1ToGl2[this._type];
                return (map && map[internalFormat]) || internalFormat;
            },

            _getTypeGL: function() {
                if (this._type === Texture.HALF_FLOAT && !__WEBPACK_IMPORTED_MODULE_7_osg_WebGLCaps__["a" /* default */].instance().isWebGL2())
                    return Texture.HALF_FLOAT_OES;
                return this._type;
            }
        })
    ),
    'osg',
    'Texture'
);

Texture.textureNull = new Texture();

Texture.createFromImage = function(image, format) {
    var a = new Texture();
    a.setImage(image, format);
    return a;
};

Texture.createFromCanvas = function(canvas, format) {
    return Texture.createFromImage(canvas, format);
};

/* harmony default export */ __webpack_exports__["default"] = (Texture);


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var primitiveSet = {};
primitiveSet.POINTS = 0x0000;
primitiveSet.LINES = 0x0001;
primitiveSet.LINE_LOOP = 0x0002;
primitiveSet.LINE_STRIP = 0x0003;
primitiveSet.TRIANGLES = 0x0004;
primitiveSet.TRIANGLE_STRIP = 0x0005;
primitiveSet.TRIANGLE_FAN = 0x0006;

/* harmony default export */ __webpack_exports__["a"] = (primitiveSet);


/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_BoundingSphere__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_computeMatrixFromNodePath__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__ = __webpack_require__(11);











/**
 *  Node that can contains child node
 *  @class Node
 */
var Node = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);

    this.children = [];
    this._parents = [];
    /*jshint bitwise: false */
    this.nodeMask = ~0;
    /*jshint bitwise: true */

    this._boundingSphere = new __WEBPACK_IMPORTED_MODULE_3_osg_BoundingSphere__["a" /* default */]();
    this._boundingSphereComputed = false;

    this._boundingBox = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
    this._boundingBoxComputed = false;

    this._updateCallbacks = [];
    this._cullCallback = undefined;
    this._cullingActive = true;
    this._numChildrenWithCullingDisabled = 0;
    this._numChildrenRequiringUpdateTraversal = 0;

    // it's a tmp object for internal use, do not use
    this._tmpBox = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
};

var pooledMatrix = new __WEBPACK_IMPORTED_MODULE_7_osg_PooledResource__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create);
var nodeGetMat = function() {
    var matrix = pooledMatrix.getOrCreateObject();
    return __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].identity(matrix);
};

/** @lends Node.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Node,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        /**
      Return StateSet and create it if it does not exist yet
      @type StateSet
   */
        getOrCreateStateSet: function() {
            if (!this.stateset) this.setStateSet(new __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__["a" /* default */]());
            return this.stateset;
        },

        getStateSet: function() {
            return this.stateset;
        },

        accept: function(nv) {
            if (nv.validNodeMask(this)) {
                nv.pushOntoNodePath(this);
                nv.apply(this);
                nv.popFromNodePath();
            }
        },

        dirtyBound: function() {
            if (this._boundingSphereComputed === true || this._boundingBoxComputed === true) {
                this._boundingSphereComputed = false;
                this._boundingBoxComputed = false;
                var parents = this._parents;
                for (var i = 0, l = parents.length; i < l; i++) {
                    parents[i].dirtyBound();
                }
            }
        },

        setNodeMask: function(mask) {
            this.nodeMask = mask;
        },

        getNodeMask: function() {
            return this.nodeMask;
        },

        setStateSet: function(stateSet) {
            if (this.stateset === stateSet) return;

            var deltaUpdate = 0;

            if (this.stateset) {
                if (this.stateset.requiresUpdateTraversal()) deltaUpdate--;
                this.stateset.removeParent(this);
            }

            if (stateSet) {
                stateSet.addParent(this);
                if (stateSet.requiresUpdateTraversal()) ++deltaUpdate;
            }

            if (deltaUpdate !== 0)
                this.setNumChildrenRequiringUpdateTraversal(
                    this.getNumChildrenRequiringUpdateTraversal() + deltaUpdate
                );

            this.stateset = stateSet;
        },

        _updateNumChildrenRequeringUpdateTraversal: function(delta) {
            if (this._numChildrenRequiringUpdateTraversal === 0 && this._parents.length) {
                // the number of callbacks has changed, need to pass this
                // on to parents so they know whether app traversal is
                // required on this subgraph.
                for (var i = 0, l = this._parents.length; i < l; i++) {
                    var parent = this._parents[i];
                    var num = parent.getNumChildrenRequiringUpdateTraversal();
                    parent.setNumChildrenRequiringUpdateTraversal(num + delta);
                }
            }
        },

        setNumChildrenRequiringUpdateTraversal: function(num) {
            // if no changes just return.
            if (this._numChildrenRequiringUpdateTraversal === num) return;

            // note, if _updateCallback is set then the
            // parents won't be affected by any changes to
            // _numChildrenRequiringUpdateTraversal so no need to inform them.
            if (!this._updateCallbacks.length && this._parents.length) {
                // need to pass on changes to parents.
                var delta = 0;
                if (this._numChildrenRequiringUpdateTraversal > 0) --delta;
                if (num > 0) ++delta;

                if (delta !== 0) {
                    // the number of callbacks has changed, need to pass this
                    // on to parents so they know whether app traversal is
                    // required on this subgraph.
                    var parents = this._parents;
                    for (var i = 0, l = parents.length; i < l; i++) {
                        var parent = parents[i];
                        var parentNum = parent.getNumChildrenRequiringUpdateTraversal();
                        parent.setNumChildrenRequiringUpdateTraversal(parentNum + delta);
                    }
                }
            }

            // finally update this objects value.
            this._numChildrenRequiringUpdateTraversal = num;
        },

        getNumChildrenRequiringUpdateTraversal: function() {
            return this._numChildrenRequiringUpdateTraversal;
        },

        /** Get update node callback, called during update traversal.
      @type Oject
   */
        getUpdateCallback: function() {
            return this._updateCallbacks[0];
        },

        addUpdateCallback: function(cb) {
            var hasExistingCallback = Boolean(this._updateCallbacks.length);
            this._updateCallbacks.push(cb);

            // send the signal on first add
            if (!hasExistingCallback) this._updateNumChildrenRequeringUpdateTraversal(1);
        },

        removeUpdateCallback: function(cb) {
            var arrayIdx = this._updateCallbacks.indexOf(cb);
            if (arrayIdx === -1) return;
            this._updateCallbacks.splice(arrayIdx, 1);

            // send the signal when no more callback
            if (!this._updateCallbacks.length) this._updateNumChildrenRequeringUpdateTraversal(-1);
        },
        getUpdateCallbackList: function() {
            return this._updateCallbacks;
        },

        /**
     <p>
      Set cull node callback, called during cull traversal.
      The Object must have the following method
      cull(node, nodeVisitor) {}
      note, callback is responsible for scenegraph traversal so
      they must return true to traverse.
      </p>
      <p>
      Here a dummy CullCallback example
      </p>
      @example
      var DummyCullCallback = function() {};
      DummyCullCallback.prototype = {
          cull: function(node, nodeVisitor) {
              return true;
          }
      };

      @param Oject callback
   */
        setCullCallback: function(cb) {
            this._cullCallback = cb;
        },
        getCullCallback: function() {
            return this._cullCallback;
        },

        hasChild: function(child) {
            for (var i = 0, l = this.children.length; i < l; i++) {
                if (this.children[i] === child) {
                    return true;
                }
            }
            return false;
        },

        addChild: function(child) {
            if (this.children.indexOf(child) !== -1) return undefined;

            this.children.push(child);
            child.addParent(this);
            this.dirtyBound();

            // could now require app traversal thanks to the new subgraph,
            // so need to check and update if required.
            if (
                child.getNumChildrenRequiringUpdateTraversal() > 0 ||
                child.getUpdateCallbackList().length
            ) {
                this.setNumChildrenRequiringUpdateTraversal(
                    this.getNumChildrenRequiringUpdateTraversal() + 1
                );
            }

            // We need to check if culling is active in the child
            if (
                child.getNumChildrenWithCullingDisabled() > 0 ||
                child.getCullingActive() === false
            ) {
                this.setNumChildrenWithCullingDisabled(
                    this.getNumChildrenWithCullingDisabled() + 1
                );
            }

            return child;
        },

        getChildren: function() {
            return this.children;
        },
        getNumChildren: function() {
            return this.children.length;
        },
        getChild: function(num) {
            return this.children[num];
        },
        getParents: function() {
            return this._parents;
        },

        addParent: function(parent) {
            this._parents.push(parent);
        },

        removeParent: function(parent) {
            var idx = this._parents.indexOf(parent);
            if (idx === -1) return;
            this._parents.splice(idx, 1);
        },

        removeChildren: function() {
            var children = this.children;
            var nbChildren = children.length;
            if (!nbChildren) return;

            var updateCallbackRemoved = 0;

            for (var i = 0; i < nbChildren; i++) {
                var child = children[i];
                child.removeParent(this);
                if (
                    child.getNumChildrenRequiringUpdateTraversal() > 0 ||
                    child.getUpdateCallbackList().length
                )
                    ++updateCallbackRemoved;
            }

            children.length = 0;
            if (updateCallbackRemoved)
                this.setNumChildrenRequiringUpdateTraversal(
                    this.getNumChildrenRequiringUpdateTraversal() - updateCallbackRemoved
                );

            this.dirtyBound();
        },

        // preserve order
        removeChild: function(child) {
            var children = this.children;
            var id = children.indexOf(child);
            if (id === -1) return;

            child.removeParent(this);
            children.splice(id, 1);
            this.dirtyBound();

            if (
                child.getNumChildrenRequiringUpdateTraversal() > 0 ||
                child.getUpdateCallbackList().length
            )
                this.setNumChildrenRequiringUpdateTraversal(
                    this.getNumChildrenRequiringUpdateTraversal() - 1
                );
        },

        traverse: function(visitor) {
            var children = this.children;
            for (var i = 0, l = children.length; i < l; i++) {
                var child = children[i];
                child.accept(visitor);
            }
        },

        ascend: function(visitor) {
            var parents = this._parents;
            for (var i = 0, l = parents.length; i < l; i++) {
                var parent = parents[i];
                parent.accept(visitor);
            }
        },

        getBoundingBox: function() {
            if (!this._boundingBoxComputed) {
                this.computeBoundingBox(this._boundingBox);
                this._boundingBoxComputed = true;
            }
            return this._boundingBox;
        },

        computeBoundingBox: function(bbox) {
            // circular dependency... not sure if the global visitor instance should be instancied here
            var ComputeBoundsVisitor = __webpack_require__(57).default;
            var cbv = (ComputeBoundsVisitor.instance =
                ComputeBoundsVisitor.instance || new ComputeBoundsVisitor());
            cbv.setNodeMaskOverride(~0x0); // traverse everything to be consistent with computeBoundingSphere
            cbv.reset();

            cbv.apply(this);
            bbox.copy(cbv.getBoundingBox());
            return bbox;
        },

        getBoundingSphere: function() {
            return this.getBound();
        },

        getBound: function() {
            if (!this._boundingSphereComputed) {
                this.computeBoundingSphere(this._boundingSphere);
                this._boundingSphereComputed = true;
            }
            return this._boundingSphere;
        },

        computeBoundingSphere: function(bSphere) {
            var children = this.children;
            var l = children.length;

            bSphere.init();
            if (l === 0) return bSphere;

            var cc, i;
            var bb = this._tmpBox;
            bb.init();
            for (i = 0; i < l; i++) {
                cc = children[i];
                if (cc.referenceFrame !== __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) {
                    bb.expandByBoundingSphere(cc.getBound());
                }
            }
            if (!bb.valid()) return bSphere;

            bSphere.set(bb.center(bSphere.center()), 0.0);
            for (i = 0; i < l; i++) {
                cc = children[i];
                if (cc.referenceFrame !== __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) {
                    bSphere.expandRadiusBySphere(cc.getBound());
                }
            }
            return bSphere;
        },

        // matrixCreate allow user handling of garbage collection of matrices
        getWorldMatrices: (function() {
            var CollectParentPaths = function() {
                this.nodePaths = [];
                this.halt = undefined;
                __WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__["a" /* default */].TRAVERSE_PARENTS);
            };
            CollectParentPaths.prototype = __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__["a" /* default */].prototype, {
                reset: function() {
                    this.nodePath.length = 0;
                    this.nodePaths.length = 0;
                },
                apply: function(node) {
                    if (
                        node._parents.length === 0 ||
                        node === this.halt ||
                        node.referenceFrame === __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__["a" /* default */].ABSOLUTE_RF
                    ) {
                        // copy
                        this.nodePaths.push(this.nodePath.slice(0));
                    } else {
                        this.traverse(node);
                    }
                }
            });
            var collected = new CollectParentPaths();
            collected.setNodeMaskOverride(~0x0); // traverse everything

            return function computeLocalToWorldList(halt, matrixCreate) {
                collected.reset();
                collected.halt = halt;

                this.accept(collected);
                var matrixList = [];

                var matrixGenerator = matrixCreate || __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create;
                for (var i = 0, l = collected.nodePaths.length; i < l; i++) {
                    var np = collected.nodePaths[i];
                    var m = matrixGenerator();
                    if (np.length !== 0) {
                        __WEBPACK_IMPORTED_MODULE_8_osg_computeMatrixFromNodePath__["a" /* default */].computeLocalToWorld(np, true, m);
                    }
                    matrixList.push(m);
                }

                return matrixList;
            };
        })(),

        // same as getWorldMatrices GC: Perf WIN
        getWorldMatrix: function(halt, matrix) {
            // pass allocator on master
            var matrixList = this.getWorldMatrices(halt, nodeGetMat);

            if (matrixList.length === 0) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].identity(matrix);
            } else {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].copy(matrix, matrixList[0]);
            }

            pooledMatrix.reset();
            return matrix;
        },

        setCullingActive: function(value) {
            if (this._cullingActive === value) return;
            if (this._numChildrenWithCullingDisabled === 0 && this._parents.length > 0) {
                var delta = 0;
                if (!this._cullingActive) --delta;
                if (!value) ++delta;
                if (delta !== 0) {
                    for (var i = 0, k = this._parents.length; i < k; i++) {
                        this._parents[i].setNumChildrenWithCullingDisabled(
                            this._parents[i].getNumChildrenWithCullingDisabled() + delta
                        );
                    }
                }
            }
            this._cullingActive = value;
        },

        getCullingActive: function() {
            return this._cullingActive;
        },

        isCullingActive: function() {
            return (
                this._numChildrenWithCullingDisabled === 0 &&
                this._cullingActive &&
                this.getBound().valid()
            );
        },

        setNumChildrenWithCullingDisabled: function(num) {
            if (this._numChildrenWithCullingDisabled === num) return;
            if (this._cullingActive && this._parents.length > 0) {
                var delta = 0;
                if (this._numChildrenWithCullingDisabled > 0) --delta;
                if (num > 0) ++delta;
                if (delta !== 0) {
                    for (var i = 0, k = this._parents.length; i < k; i++) {
                        this._parents[i].setNumChildrenWithCullingDisabled(
                            this._parents[i].getNumChildrenWithCullingDisabled() + delta
                        );
                    }
                }
            }
            this._numChildrenWithCullingDisabled = num;
        },

        getNumChildrenWithCullingDisabled: function() {
            return this._numChildrenWithCullingDisabled;
        },

        releaseGLObjects: function() {
            if (this.stateset !== undefined) this.stateset.releaseGLObjects();
        }
    }),
    'osg',
    'Node'
);

/* harmony default export */ __webpack_exports__["a"] = (Node);


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_WebGLCaps__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_BufferArrayProxy__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_VertexArrayObject__ = __webpack_require__(58);







/**
 * Geometry manage array and primitives to draw a geometry.
 * @class Geometry
 */

var Geometry = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].call(this);

    this._attributes = {};
    this._primitives = [];

    // function is generated for each Shader Program ID
    // which generates a a special "draw"
    // TODO: could be upon hash of combination of attributes
    // (as multiple shader Programs can use same combination of attributes)
    this._cacheDrawCall = {};

    // VAO cached data, per combination of vertex buffer
    // program id also the cache key
    this._useVAO = undefined;
    this._vao = {};
    this._cacheVertexAttributeBufferList = {};

    // null means the kdTree builder will skip the kdTree creation
    this._shape = undefined;
};

Geometry.enableVAO = true;

/** @lends Geometry.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Geometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].prototype, {
        releaseGLObjects: function() {
            if (this.stateset !== undefined) this.stateset.releaseGLObjects();

            for (var keyAttribute in this._attributes) {
                var value = this._attributes[keyAttribute];
                value.releaseGLObjects();
            }

            for (var i = 0, h = this._primitives.length; i < h; i++) {
                var prim = this._primitives[i];
                if (prim.getIndices !== undefined) {
                    if (prim.getIndices() !== undefined && prim.getIndices() !== null) {
                        prim.indices.releaseGLObjects();
                    }
                }
            }

            this.releaseVAO();
        },

        releaseVAO: function() {
            if (!this._useVAO || !this._glContext) return;

            for (var prgID in this._vao) {
                if (this._vao[prgID]) {
                    this._vao[prgID].releaseGLObjects();
                    this._vao[prgID] = undefined;
                }
            }
        },

        dirty: function() {
            this._cacheDrawCall = {};
            this.releaseVAO();
        },

        getPrimitives: function() {
            // Notify.warn( 'deprecated use instead getPrimitiveSetList' );
            return this.getPrimitiveSetList();
        },

        getAttributes: function() {
            // Notify.warn( 'deprecated use instead getVertexAttributeList' );
            return this.getVertexAttributeList();
        },

        getShape: function() {
            return this._shape;
        },

        setShape: function(shape) {
            this._shape = shape;
        },

        getVertexAttributeList: function() {
            return this._attributes;
        },

        /**
         * Return the primitiveset list
         * If you modify something inside this array
         * you must call dirty() on the Geometry
         */
        getPrimitiveSetList: function() {
            return this._primitives;
        },

        /**
         * Set the buffer array on the attribute name key
         * key is often something like Vertex, Normal, Color, ...
         * for classic geometry
         *
         * if you change a buffer a dirty will be automatically
         * called to rebuild the VAO if needed.
         */
        setVertexAttribArray: function(key, array) {
            if (this._attributes[key] !== array) {
                this._attributes[key] = array;
                this.dirty();
            }
        },

        _generateVertexSetup: function(
            validAttributeKeyList,
            validAttributeIndexList,
            includeFirstIndexBuffer
        ) {
            // generate setup for vertex attribute
            // will be used as setup for vao or as is without vao
            var vertexAttributeSetup = [
                '//generated by Geometry::implementation',
                'state.lazyDisablingOfVertexAttributes();',
                'var attr;'
            ];

            for (var i = 0, l = validAttributeKeyList.length; i < l; i++) {
                vertexAttributeSetup.push(
                    "attr = this._attributes['" + validAttributeKeyList[i] + "'];"
                );
                vertexAttributeSetup.push(
                    'if ( attr.BufferArrayProxy ) attr = attr.getBufferArray();'
                );
                vertexAttributeSetup.push('if ( !attr.isValid() ) return;');
                vertexAttributeSetup.push(
                    'state.setVertexAttribArray(' +
                        validAttributeIndexList[i] +
                        ', attr, attr.getNormalize() );'
                );
            }

            vertexAttributeSetup.push('state.applyDisablingOfVertexAttributes();');

            if (includeFirstIndexBuffer)
                vertexAttributeSetup.push(
                    'state.setIndexArray( this._primitives[ 0 ].getIndices() );'
                );

            return vertexAttributeSetup;
        },

        _generatePrimitives: function(validPrimitives, hasVertexColor, optimizeVAO) {
            var primitiveSetup = [
                hasVertexColor ? 'state.enableVertexColor();' : 'state.disableVertexColor();'
            ];
            if (optimizeVAO) {
                return primitiveSetup.concat([
                    'var primitive = this._primitives[ ' + validPrimitives[0] + ' ];',
                    'var indexes = primitive.getIndices();',
                    'if ( indexes.isDirty() ) {;',
                    '  indexes.bind( gl );',
                    '  indexes.compile( gl );',
                    '};',
                    'primitive.drawElements( state );'
                ]);
            }

            primitiveSetup.push('var primitives = this._primitives;');
            for (var j = 0, m = validPrimitives.length; j < m; j++) {
                primitiveSetup.push('primitives[' + validPrimitives[j] + '].draw(state);');
            }

            return primitiveSetup;
        },

        /**
         *  Generate a function specific to the Geometry/Program
         *  two version one using VAO and a regular one
         */
        generateDrawCommand: (function() {
            var validAttributeList = [];
            var validAttributeKeyList = [];

            return function(state, program, prgID, validPrimitives) {
                var attributesCacheMap = program._attributesCache;
                var geometryVertexAttributes = this.getVertexAttributeList();

                validAttributeKeyList.length = 0;
                validAttributeList.length = 0;

                // 1 - register valid vertex attributes and color flag

                var attribute, j, m, attr;

                var useVAO = this._useVAO;
                var listVABuff = useVAO ? [] : undefined;

                var hasVertexColor = false;

                for (var key in attributesCacheMap) {
                    attribute = attributesCacheMap[key];
                    attr = geometryVertexAttributes[key];

                    if (attr === undefined) continue;

                    var attributeBuffer = this._attributes[key];

                    // dont use VAO if we have BufferArrayProxy
                    // typically used for morphing
                    if (attributeBuffer instanceof __WEBPACK_IMPORTED_MODULE_5_osg_BufferArrayProxy__["a" /* default */]) {
                        attributeBuffer = attributeBuffer.getBufferArray();
                        useVAO = false;
                    }

                    if (!attributeBuffer.isValid()) return undefined;

                    // store for later usage at draw time/update
                    if (useVAO) listVABuff.push(attributeBuffer);

                    if (!hasVertexColor && key === 'Color') hasVertexColor = true;

                    validAttributeKeyList.push(key);
                    validAttributeList.push(attribute);
                }

                var autogeneratedFunction;
                var functionName;

                // generate specific function using VAO or standard
                if (useVAO) {
                    this._cacheVertexAttributeBufferList[prgID] = listVABuff;

                    // if there is only one drawElement we can put the index buffer
                    // in the vao
                    var optimizeIndexBufferVAO =
                        validPrimitives.length === 1 &&
                        this._primitives[validPrimitives[0]] instanceof __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__["a" /* default */];

                    var vertexAttributeSetup = this._generateVertexSetup(
                        validAttributeKeyList,
                        validAttributeList,
                        optimizeIndexBufferVAO
                    );

                    state.clearVertexAttribCache();

                    var gl = state.getGraphicContext();
                    var vao = new __WEBPACK_IMPORTED_MODULE_6_osg_VertexArrayObject__["a" /* default */](gl);
                    vao.create(gl);
                    state.setVertexArrayObject(vao);
                    this._vao[prgID] = vao;

                    // evaluate the vertexAttribute setup to register into the vao
                    /*jshint evil: true */
                    var vertexSetupCommand = new Function('state', vertexAttributeSetup.join('\n'));
                    /*jshint evil: false */
                    vertexSetupCommand.call(this, state);

                    // setup the program
                    var vaoSetup = [
                        'var gl = state.getGraphicContext();',
                        'var vao = this._vao[ ' + prgID + ' ] ',
                        'var hasChanged = state.setVertexArrayObject( vao );',
                        'if ( hasChanged ) {',
                        '  var vaList = this._cacheVertexAttributeBufferList[ ' + prgID + ' ];',
                        '  var va;'
                    ];
                    for (j = 0, m = listVABuff.length; j < m; j++) {
                        vaoSetup.push('  va = vaList[ ' + j + '];');
                        vaoSetup.push('  if ( va.isDirty() ) {;');
                        vaoSetup.push('    va.bind( gl );');
                        vaoSetup.push('    va.compile( gl );');
                        vaoSetup.push('  };');
                    }
                    vaoSetup.push('}');

                    autogeneratedFunction = vaoSetup
                        .concat(
                            this._generatePrimitives(
                                validPrimitives,
                                hasVertexColor,
                                optimizeIndexBufferVAO
                            )
                        )
                        .join('\n');
                    functionName = 'GeometryDrawImplementationCacheVAO';
                } else {
                    autogeneratedFunction = this._generateVertexSetup(
                        validAttributeKeyList,
                        validAttributeList,
                        false
                    )
                        .concat(this._generatePrimitives(validPrimitives, hasVertexColor, false))
                        .join('\n');
                    functionName = 'GeometryDrawImplementationCache';
                }

                /*jshint evil: true */
                // name the function
                // http://stackoverflow.com/questions/5905492/dynamic-function-name-in-javascript
                var drawCommand = new Function(
                    'state',
                    'return function ' + functionName + '( state ) { ' + autogeneratedFunction + '}'
                )();
                /*jshint evil: false */

                this._cacheDrawCall[prgID] = drawCommand;
                return drawCommand;
            };
        })(),

        _getValidPrimitives: function() {
            var validPrimitives = [];

            for (var i = 0; i < this._primitives.length; i++) {
                var primitive = this._primitives[i];
                if (!primitive.getCount()) {
                    if (!this._warnInvalidPrimitives) {
                        __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                            'geometry with instanceID ' +
                                this._instanceID +
                                ' has invalid primitives'
                        );
                        this._warnInvalidPrimitives = true;
                    }
                    continue;
                }
                validPrimitives.push(i);
            }

            return validPrimitives;
        },

        drawImplementation: function(state) {
            var program = state.getLastProgramApplied();
            var prgID = program.getInstanceID();

            state.drawGeometry(this);
            var cachedDraw = this._cacheDrawCall[prgID];

            if (!this._vao[prgID]) {
                state.setVertexArrayObject(null);
            } else {
                if (this._vao[prgID].isDirty()) {
                    // need vertex array recreation
                    // ie: lost context
                    cachedDraw = undefined;
                }
            }

            if (cachedDraw) {
                cachedDraw.call(this, state);
                return;
            }

            if (!this._primitives.length) {
                if (!this._warnNoPrimitives) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                        'geometry with instanceID ' + this._instanceID + ' has no primitives'
                    );
                    this._warnNoPrimitives = true;
                }
                return;
            }

            var validPrimitives = this._getValidPrimitives();
            if (!validPrimitives.length) return;

            // generate cachedDraw
            if (this._useVAO === undefined && Geometry.enableVAO) {
                // will be null if not supported
                this._useVAO = __WEBPACK_IMPORTED_MODULE_3_osg_WebGLCaps__["a" /* default */].instance().hasVAO();
                this._glContext = state.getGraphicContext();
            }

            cachedDraw = this.generateDrawCommand(state, program, prgID, validPrimitives);
            cachedDraw.call(this, state);
            state.setVertexArrayObject(null);
        },

        setBound: function(bb) {
            this._boundingBox = bb;
            this._boundingBoxComputed = true;
        },

        computeBoundingBox: function(boundingBox) {
            boundingBox.init();

            var vertexArray = this.getVertexAttributeList().Vertex;
            if (vertexArray && vertexArray.getElements() && vertexArray.getItemSize() > 2) {
                var vertexes = vertexArray.getElements();
                var itemSize = vertexArray.getItemSize();

                var min = boundingBox.getMin();
                var max = boundingBox.getMax();

                var minx = min[0];
                var miny = min[1];
                var minz = min[2];
                var maxx = max[0];
                var maxy = max[1];
                var maxz = max[2];

                // if the box is un-initialized min=Inf and max=-Inf
                // we can't simply write if(x > min) [...] else (x < max) [...]
                // most of the time the else condition is run so it's a kinda useless
                // optimization anyway
                for (var idx = 0, l = vertexes.length; idx < l; idx += itemSize) {
                    var v1 = vertexes[idx];
                    var v2 = vertexes[idx + 1];
                    var v3 = vertexes[idx + 2];
                    if (v1 < minx) minx = v1;
                    if (v1 > maxx) maxx = v1;
                    if (v2 < miny) miny = v2;
                    if (v2 > maxy) maxy = v2;
                    if (v3 < minz) minz = v3;
                    if (v3 > maxz) maxz = v3;
                }

                min[0] = minx;
                min[1] = miny;
                min[2] = minz;
                max[0] = maxx;
                max[1] = maxy;
                max[2] = maxz;
            }

            return boundingBox;
        },

        computeBoundingSphere: function(boundingSphere) {
            boundingSphere.init();
            var bb = this.getBoundingBox();
            boundingSphere.expandByBoundingBox(bb);
            return boundingSphere;
        }
    }),
    'osg',
    'Geometry'
);

Geometry.appendVertexAttributeToList = function(from, to, postfix) {
    for (var key in from) {
        var keyPostFix = key;
        if (postfix !== undefined) keyPostFix += '_' + postfix;

        to[keyPostFix] = from[key];
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Geometry);


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    RELATIVE_RF: 0,
    ABSOLUTE_RF: 1
});


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Timer__ = __webpack_require__(21);






var getAttributeType = function(array) {
    var type;

    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Float32Array) type = 0x1406;

    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Int16Array) type = 0x1402;
    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Uint16Array) type = 0x1403;

    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Int8Array) type = 0x1400;
    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Uint8Array) type = 0x1401;
    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Uint8ClampedArray) type = 0x1401;

    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Int32Array) type = 0x1404; // webgl2 for vertexAttribPointer
    if (array instanceof __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Uint32Array) type = 0x1405; // webgl2 for vertexAttribPointer

    return type;
};

/**
 * BufferArray manage vertex / normal / ... array used by webgl.
 * osgjs automatically converts array buffers to Float32Array and
 * element array buffers to Uint16Array if not said explicitly with
 * preserveArrayType variable in constructor.
 * @class BufferArray
 */

var BufferArray = function(target, elements, itemSize) {
    __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].call(this);
    // maybe could inherit from Object
    this._instanceID = __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].getInstanceID();

    this.dirty();

    this._itemSize = itemSize;
    this._target = typeof target === 'string' ? BufferArray[target] : target;

    // initialized by setElements
    this._type = undefined;
    this._normalize = false;

    if (elements) {
        // byteLength should be enough to detect typedArray
        if (elements.byteLength === undefined) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('BufferArray with non typedArray elements is deprecated');
            if (this._target === BufferArray.ELEMENT_ARRAY_BUFFER) {
                elements = new __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Uint16Array(elements);
            } else {
                elements = new __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].Float32Array(elements);
            }
        }
        this.setElements(elements);
    }

    this._usage = BufferArray.STATIC_DRAW;
};

BufferArray.ELEMENT_ARRAY_BUFFER = 0x8893;
BufferArray.ARRAY_BUFFER = 0x8892;
BufferArray.STATIC_DRAW = 0x88e4;
BufferArray.DYNAMIC_DRAW = 0x88e8;
BufferArray.STREAM_DRAW = 0x88e0;

// static cache of glBuffers flagged for deletion, which will actually
// be deleted in the correct GL context.
BufferArray._sDeletedGLBufferArrayCache = new window.Map();

// static method to delete Program
BufferArray.deleteGLBufferArray = function(gl, buffer) {
    if (!BufferArray._sDeletedGLBufferArrayCache.has(gl))
        BufferArray._sDeletedGLBufferArrayCache.set(gl, []);
    BufferArray._sDeletedGLBufferArrayCache.get(gl).push(buffer);
};

// static method to flush all the cached glPrograms which need to be deleted in the GL context specified
BufferArray.flushDeletedGLBufferArrays = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;
    if (!BufferArray._sDeletedGLBufferArrayCache.has(gl)) return availableTime;
    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
    var deleteList = BufferArray._sDeletedGLBufferArrayCache.get(gl);
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteBuffer(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
    }
    return availableTime - elapsedTime;
};

BufferArray.flushAllDeletedGLBufferArrays = function(gl) {
    if (!BufferArray._sDeletedGLBufferArrayCache.has(gl)) return;
    var deleteList = BufferArray._sDeletedGLBufferArrayCache.get(gl);
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0; i--) {
        gl.deleteBuffer(deleteList[i]);
        deleteList.splice(i, 1);
    }
};

BufferArray.onLostContext = function(gl) {
    if (!BufferArray._sDeletedGLBufferArrayCache.has(gl)) return;
    var deleteList = BufferArray._sDeletedGLBufferArrayCache.get(gl);
    deleteList.length = 0;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    BufferArray,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].prototype, {
        setUsage: function(usage) {
            this._usage = usage;
        },
        getUsage: function() {
            return this._usage;
        },
        getInstanceID: function() {
            return this._instanceID;
        },
        setItemSize: function(size) {
            this._itemSize = size;
        },
        isValid: function() {
            if (this._buffer) return true;
            if (this._elements && this._elements.length) return true;
            return false;
        },

        invalidate: function() {
            this._buffer = undefined;
            this._elements = undefined;
            this.dirty();
        },

        releaseGLObjects: function() {
            if (this._buffer !== undefined && this._buffer !== null && this._gl !== undefined) {
                BufferArray.deleteGLBufferArray(this._gl, this._buffer);
                __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].removeObject(this._gl, this);
            }
            this.invalidate();
        },

        setNormalize: function(normalize) {
            this._normalize = normalize;
        },

        getNormalize: function() {
            return this._normalize;
        },

        bind: function(gl) {
            if (!this._gl) this.setGraphicContext(gl);
            var target = this._target;
            var buffer = this._buffer;

            if (buffer) {
                gl.bindBuffer(target, buffer);
                return;
            }

            if (!buffer && this._elements.length > 0) {
                this._buffer = gl.createBuffer();
                this._numItems = this._elements.length / this._itemSize;
                gl.bindBuffer(target, this._buffer);
            }
        },
        getItemSize: function() {
            return this._itemSize;
        },
        dirty: function() {
            this._dirty = true;
        },
        isDirty: function() {
            return this._dirty;
        },
        compile: function(gl) {
            if (this._dirty) {
                __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeStamp('osgjs.metrics:bufferData');
                gl.bufferData(this._target, this._elements, this._usage);
                this._dirty = false;
            }
        },
        getElements: function() {
            return this._elements;
        },
        setElements: function(elements) {
            this._elements = elements;
            this._type = getAttributeType(elements);
            this._dirty = true;
        },
        getType: function() {
            return this._type;
        }
    }),
    'osg',
    'BufferArray'
);

/* harmony default export */ __webpack_exports__["a"] = (BufferArray);


/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_CullSettings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__ = __webpack_require__(11);








/**
 * Camera - is a subclass of Transform which represents encapsulates the settings of a Camera.
 * @class Camera
 * @inherits Transform CullSettings
 */
var Camera = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Transform__["a" /* default */].call(this);
    __WEBPACK_IMPORTED_MODULE_2_osg_CullSettings__["a" /* default */].call(this);

    this.viewport = undefined;
    this._graphicContext = undefined;
    this._scissor = undefined;
    this.setClearColor(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0, 0, 0, 1.0));
    this.setClearDepth(1.0);

    /*jshint bitwise: false */
    this.setClearMask(Camera.COLOR_BUFFER_BIT | Camera.DEPTH_BUFFER_BIT);
    /*jshint bitwise: true */

    this.setViewMatrix(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create());
    this.setProjectionMatrix(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create());
    this.renderOrder = Camera.NESTED_RENDER;
    this.renderOrderNum = 0;

    this._view = undefined;
    this._renderer = undefined;
    this._attachments = {};
};

Camera.PRE_RENDER = 0;
Camera.NESTED_RENDER = 1;
Camera.POST_RENDER = 2;

Camera.COLOR_BUFFER_BIT = 0x00004000;
Camera.DEPTH_BUFFER_BIT = 0x00000100;
Camera.STENCIL_BUFFER_BIT = 0x00000400;

/** @lends Camera.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Camera,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(
        __WEBPACK_IMPORTED_MODULE_2_osg_CullSettings__["a" /* default */].prototype,
        __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Transform__["a" /* default */].prototype, {
            // at which view this camera is attached
            getView: function() {
                return this._view;
            },

            setView: function(view) {
                this._view = view;
            },

            getRenderer: function() {
                return this._renderer;
            },

            setRenderer: function(renderer) {
                this._renderer = renderer;
            },

            // Set the final draw callback for custom operations
            // to be done after the drawing of
            // the camera's subgraph and pre render stages.
            setFinalDrawCallback: function(cb) {
                this._finalDrawCallback = cb;
            },

            getFinalDrawCallback: function() {
                return this._finalDrawCallback;
            },

            // Set the initial draw callback for custom operations
            // to be done before the drawing of
            // the camera's subgraph and pre render stages.
            setInitialDrawCallback: function(cb) {
                this._initialDrawCallback = cb;
            },

            getInitialDrawCallback: function() {
                return this._initialDrawCallback;
            },

            getAttachments: function() {
                return this._attachments;
            },

            setGraphicContext: function(gc) {
                this._graphicContext = gc;
            },
            getGraphicContext: function() {
                return this._graphicContext;
            },
            setClearDepth: function(depth) {
                this.clearDepth = depth;
            },
            getClearDepth: function() {
                return this.clearDepth;
            },

            setClearMask: function(mask) {
                this.clearMask = mask;
            },
            getClearMask: function() {
                return this.clearMask;
            },

            setClearColor: function(color) {
                this.clearColor = color;
            },
            getClearColor: function() {
                return this.clearColor;
            },

            setViewport: function(vp) {
                this.viewport = vp;
                this.getOrCreateStateSet().setAttributeAndModes(vp);
            },
            getViewport: function() {
                return this.viewport;
            },

            setScissor: function(scissor) {
                this._scissor = scissor;
                this.getOrCreateStateSet().setAttributeAndModes(this._scissor);
            },
            getScissor: function() {
                return this._scissor;
            },

            setViewMatrix: function(matrix) {
                this.modelviewMatrix = matrix;
            },
            setViewMatrixAsLookAt: function(eye, center, up) {
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].lookAt(this.getViewMatrix(), eye, center, up);
            },
            setProjectionMatrix: function(matrix) {
                this.projectionMatrix = matrix;
            },

            /** Set to an orthographic projection. See OpenGL glOrtho for documentation further details.*/
            setProjectionMatrixAsOrtho: function(left, right, bottom, top, zNear, zFar) {
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].ortho(this.getProjectionMatrix(), left, right, bottom, top, zNear, zFar);
            },
            isRenderToTextureCamera: function() {
                return window.Object.keys(this._attachments).length > 0;
            },

            getViewMatrix: function() {
                return this.modelviewMatrix;
            },
            getProjectionMatrix: function() {
                return this.projectionMatrix;
            },
            getRenderOrder: function() {
                return this.renderOrder;
            },
            setRenderOrder: function(order, orderNum) {
                this.renderOrder = order;
                this.renderOrderNum = orderNum;
            },
            getFrameBufferObject: function() {
                return this.frameBufferObject;
            },
            setFrameBufferObject: function(fbo) {
                this.frameBufferObject = fbo;
            },
            detachAll: function() {
                this._attachments = {};

                if (this.frameBufferObject) {
                    this.frameBufferObject.dirty();
                }
            },

            // TODO: fix in case of shared fbo
            // TODO: fix adding a resize case
            resetAttachments: function() {
                if (this.frameBufferObject) {
                    this.frameBufferObject.reset();
                    // remove framebuffer
                    this.frameBufferObject = 0;
                }

                // removes camera attachement
                this._attachments = {};
            },

            attachTexture: function(bufferComponent, texture, textureTarget) {
                if (this.frameBufferObject) {
                    this.frameBufferObject.dirty();
                }

                // because before the argument was level and the spec says
                // it must always be 0 ! is valid for 0 or undefined
                if (!textureTarget) {
                    textureTarget = __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].TEXTURE_2D;
                }

                this._attachments[bufferComponent] = {
                    attachment: bufferComponent,
                    texture: texture,
                    textureTarget: textureTarget
                };
            },

            attachRenderBuffer: function(bufferComponent, internalFormat) {
                if (this.frameBufferObject) {
                    this.frameBufferObject.dirty();
                }
                this._attachments[bufferComponent] = {
                    format: internalFormat,
                    attachment: bufferComponent
                };
            },

            computeLocalToWorldMatrix: function(matrix /*,nodeVisitor*/) {
                if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, matrix, this.modelviewMatrix);
                } else {
                    // absolute
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(matrix, this.modelviewMatrix);
                }
                return true;
            },

            computeWorldToLocalMatrix: (function() {
                var minverse = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
                return function(matrix /*, nodeVisitor */) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].invert(minverse, this.modelviewMatrix);
                    if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, minverse, matrix);
                    } else {
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(matrix, minverse);
                    }
                    return true;
                };
            })()
        })
    ),
    'osg',
    'Camera'
);

/* harmony default export */ __webpack_exports__["a"] = (Camera);


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_transformEnums__ = __webpack_require__(11);





/**
 *  MatrixTransform is a Transform Node that can be customized with user matrix
 *  @class MatrixTransform
 */
var MatrixTransform = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Transform__["a" /* default */].call(this);
    this.matrix = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
};

/** @lends MatrixTransform.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    MatrixTransform,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Transform__["a" /* default */].prototype, {
        getMatrix: function() {
            return this.matrix;
        },

        setMatrix: function(m) {
            this.matrix = m;
            this.dirtyBound();
        },

        // local to "local world" (not Global World)
        computeLocalToWorldMatrix: function(matrix /*, nodeVisitor */) {
            if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_3_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].mul(matrix, matrix, this.matrix);
            } else {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(matrix, this.matrix);
            }
            return true;
        },

        computeWorldToLocalMatrix: (function() {
            var minverse = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
            return function(matrix /*, nodeVisitor */) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(minverse, this.matrix);
                if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_3_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].mul(matrix, minverse, matrix);
                } else {
                    // absolute
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(matrix, minverse);
                }
                return true;
            };
        })()
    }),
    'osg',
    'MatrixTransform'
);

/* harmony default export */ __webpack_exports__["a"] = (MatrixTransform);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__ = __webpack_require__(8);


/**
 * DrawElements manage rendering of indexed primitives
 * @class DrawElements
 */
var DrawElements = function(mode, indices) {
    this.mode = __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].POINTS;
    if (mode !== undefined) {
        if (typeof mode === 'string') {
            mode = __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */][mode];
        }
        this.mode = mode;
    }
    this.count = 0;
    this.offset = 0;
    this.indices = indices;
    this.uType = DrawElements.UNSIGNED_SHORT;
    if (indices !== undefined) {
        this.setIndices(indices);
    }
};

DrawElements.UNSIGNED_BYTE = 0x1401;
DrawElements.UNSIGNED_SHORT = 0x1403;
DrawElements.UNSIGNED_INT = 0x1405;

/** @lends DrawElements.prototype */
DrawElements.prototype = {
    getMode: function() {
        return this.mode;
    },
    draw: function(state) {
        if (this.count === 0) return;
        state.setIndexArray(this.indices);
        this.drawElements(state);
    },
    drawElements: function(state) {
        var gl = state.getGraphicContext();
        gl.drawElements(this.mode, this.count, this.uType, this.offset);
    },
    setIndices: function(indices) {
        this.indices = indices;
        var elts = indices.getElements();
        this.count = elts.length;

        var nbBytes = elts.BYTES_PER_ELEMENT;
        if (nbBytes === 1) this.uType = DrawElements.UNSIGNED_BYTE;
        else if (nbBytes === 2) this.uType = DrawElements.UNSIGNED_SHORT;
        else if (nbBytes === 4) this.uType = DrawElements.UNSIGNED_INT;
    },
    getIndices: function() {
        return this.indices;
    },
    setFirst: function(val) {
        this.offset = val;
    },
    getFirst: function() {
        return this.offset;
    },
    setCount: function(val) {
        this.count = val;
    },
    getCount: function() {
        return this.count;
    },
    getNumIndices: function() {
        return this.indices.getElements().length;
    },
    index: function(i) {
        return this.indices.getElements()[i];
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DrawElements);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PooledArray = function() {
    this._pool = [];
    this._length = 0;
};

PooledArray.prototype = {
    clean: function() {
        this._length = 0;
        this._pool.length = 0;
    },
    reset: function() {
        this._length = 0;
    },
    getLength: function() {
        return this._length;
    },
    getArray: function() {
        return this._pool;
    },
    back: function() {
        return this._pool[this._length - 1];
    },
    pop: function() {
        this._length--;
        return this._pool[this._length];
    },
    push: function(value) {
        if (this._length === this._pool.length) {
            this._pool.push(value);
        } else {
            this._pool[this._length] = value;
        }
        this._length++;
    },
    forEach: function(func) {
        for (var i = 0; i < this._length; i++) func(this._pool[i]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (PooledArray);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__ = __webpack_require__(8);


/**
 * DrawArrays manage rendering primitives
 * @class DrawArrays
 */
var DrawArrays = function(mode, first, count) {
    this.mode = mode;
    if (mode !== undefined) {
        if (typeof mode === 'string') {
            mode = __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */][mode];
        }
        this.mode = mode;
    }
    this.first = first;
    this.count = count;
};

/** @lends DrawArrays.prototype */
DrawArrays.prototype = {
    draw: function(state) {
        if (this.count === 0) return;
        var gl = state.getGraphicContext();
        gl.drawArrays(this.mode, this.first, this.count);
    },
    getMode: function() {
        return this.mode;
    },
    setCount: function(count) {
        this.count = count;
    },
    getCount: function() {
        return this.count;
    },
    setFirst: function(first) {
        this.first = first;
    },
    getFirst: function() {
        return this.first;
    },
    getNumIndices: function() {
        return this.count;
    },
    index: function(i) {
        return this.first + i;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DrawArrays);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_ShaderProcessor__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_Timer__ = __webpack_require__(21);







// singleton
var sp = new __WEBPACK_IMPORTED_MODULE_4_osgShader_ShaderProcessor__["a" /* default */]();
var errorCallback;

var uniformRegexp = /uniform\s+\w+\s+(\w+)((\s)?\[(.*?)\])?/g;
var attributesRegexp = /(in|attribute)\s+\w+\s+(\w+)\s*;/g;

var getAttributeList = function(shaderText) {
    var attributeMap = {};
    var r, attr;
    while ((r = attributesRegexp.exec(shaderText)) !== null) {
        attr = r[2];
        attributeMap[attr] = true;
    }

    return attributeMap;
};

var getUniformList = function(shaderText) {
    var uniformMap = {};
    var r;
    while ((r = uniformRegexp.exec(shaderText)) !== null) {
        var uniform = r[1];
        uniformMap[uniform] = true;
    }
    return uniformMap;
};

/**
 * Program encapsulate an vertex and fragment shader
 * @class Program
 */
var Program = function(vShader, fShader) {
    __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].call(this);
    __WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__["a" /* default */].call(this);
    this._program = null;

    // used to know if it's a default program
    // a default program does nothing but avoid to do some
    // useless logic
    // if we vertex or fragment shader are set it's not a default
    // program anymore
    this._nullProgram = true;

    this._vertex = undefined;
    this._fragment = undefined;

    this._uniformsCache = undefined;
    this._attributesCache = undefined;
    // state caches
    this._activeUniforms = undefined;
    this._foreignUniforms = undefined;
    this._trackAttributes = undefined;

    if (vShader) this.setVertexShader(vShader);
    if (fShader) this.setFragmentShader(fShader);

    this._dirty = true;
};

// static cache of glPrograms flagged for deletion, which will actually
// be deleted in the correct GL context.
Program._sDeletedGLProgramCache = new window.Map();

// static method to delete Program
Program.deleteGLProgram = function(gl, program) {
    if (!Program._sDeletedGLProgramCache.has(gl)) Program._sDeletedGLProgramCache.set(gl, []);

    Program._sDeletedGLProgramCache.get(gl).push(program);
};

// static method to flush all the cached glPrograms which need to be deleted in the GL context specified
Program.flushDeletedGLPrograms = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;

    if (!Program._sDeletedGLProgramCache.has(gl)) return availableTime;

    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_5_osg_Timer__["a" /* default */].instance().tick();
    var deleteList = Program._sDeletedGLProgramCache.get(gl);
    var numPrograms = deleteList.length;

    for (var i = numPrograms - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteProgram(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_5_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_5_osg_Timer__["a" /* default */].instance().tick());
    }

    return availableTime - elapsedTime;
};

Program.flushAllDeletedGLPrograms = function(gl) {
    if (!Program._sDeletedGLProgramCache.has(gl)) return;

    var deleteList = Program._sDeletedGLProgramCache.get(gl);
    var numPrograms = deleteList.length;

    for (var i = numPrograms - 1; i >= 0; i--) {
        gl.deleteProgram(deleteList[i]);
        deleteList.splice(i, 1);
    }
};

Program.onLostContext = function(gl) {
    if (!Program._sDeletedGLProgramCache.has(gl)) return;
    var deleteList = Program._sDeletedGLProgramCache.get(gl);
    deleteList.length = 0;
    return;
};

/** @lends Program.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Program,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(
        __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].prototype,
        __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__["a" /* default */].prototype, {
            attributeType: 'Program',

            cloneType: function() {
                return new Program();
            },

            setVertexShader: function(vs) {
                this._vertex = vs;
                this._nullProgram = false;
                vs.setText(sp.processShader(vs.getText()));
            },

            setFragmentShader: function(fs) {
                this._fragment = fs;
                this._nullProgram = false;
                fs.setText(sp.processShader(fs.getText()));
            },

            getVertexShader: function() {
                return this._vertex;
            },
            getFragmentShader: function() {
                return this._fragment;
            },

            getProgram: function() {
                return this._program;
            },

            setActiveUniforms: function(activeUniforms) {
                this._activeUniforms = activeUniforms;
            },

            getActiveUniforms: function() {
                return this._activeUniforms;
            },

            setForeignUniforms: function(foreignUniforms) {
                this._foreignUniforms = foreignUniforms;
            },

            getForeignUniforms: function() {
                return this._foreignUniforms;
            },

            setUniformsCache: function(uniformsCache) {
                this._uniformsCache = uniformsCache;
            },

            getUniformsCache: function() {
                return this._uniformsCache;
            },

            setAttributesCache: function(attributesCache) {
                this._attributesCache = attributesCache;
            },

            getAttributesCache: function() {
                return this._attributesCache;
            },

            setTrackAttributes: function(trackAttributes) {
                this._trackAttributes = trackAttributes;
            },

            getTrackAttributes: function() {
                return this._trackAttributes;
            },

            releaseGLObjects: function() {
                // Call to releaseGLOBjects on shaders
                if (this._vertex !== undefined) this._vertex.releaseGLObjects();
                if (this._fragment !== undefined) this._fragment.releaseGLObjects();
                if (this._program === null) return;
                if (this._gl !== undefined) {
                    Program.deleteGLProgram(this._gl, this._program);
                    __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].removeObject(this._gl, this);
                }
                this.invalidate();
            },

            dirty: function() {
                this._program = undefined;
            },

            invalidate: function() {
                this._cacheUniformId = undefined;

                this._uniformsCache = undefined;
                this._attributesCache = undefined;
                this._foreignUniforms = undefined;
                this._trackAttributes = undefined;

                this._program = undefined;
            },

            _rebuildProgramFromSpector: function(
                vertexShaderText,
                fragmentShaderText,
                onCompiled,
                onError
            ) {
                this._dirty = true;
                this._vertex.invalidate();
                this._fragment.invalidate();
                this.invalidate();
                this._vertex.setText(vertexShaderText);
                this._fragment.setText(fragmentShaderText);
                this._spectorOnCompiled = onCompiled;
                this._spectorOnError = onError;
            },

            _onErrorToSpector: function(errLink) {
                if (!this._spectorOnError) return false;
                this._spectorOnError(errLink);
                return true;
            },

            _onCompilationToSpector: function() {
                if (!this._spectorOnCompiled) return;
                this._spectorOnCompiled(this._program);
            },

            _bindProgramToSpector: function() {
                if (!window || !window.spector || this._program.__SPECTOR_rebuildProgram) return;
                this._program.__SPECTOR_rebuildProgram = this._rebuildProgramFromSpector.bind(this);
            },

            _logDebugShaders: function(gl, errLink) {
                if (errLink !== 'Failed to create D3D shaders.\n') return;
                // rawgl trick is for webgl inspector
                var debugShader = gl.rawgl !== undefined ? gl.rawgl : gl;
                if (debugShader === undefined || debugShader.getExtension !== undefined) return;
                debugShader = debugShader.getExtension('WEBGL_debug_shaders');
                if (!debugShader) return;
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].error(debugShader.getTranslatedShaderSource(this._vertex.shader));
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].error(debugShader.getTranslatedShaderSource(this._fragment.shader));
            },

            _activateFailSafe: function(gl) {
                var program = gl.createProgram();
                this._vertex.failSafe(gl, this._vertex.getText());
                this._fragment.failSafe(gl, this._fragment.getText());
                this._glAttachAndCompile(gl, program, this._vertex, this._fragment);
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn('FailSafe shader Activated ');
                this._program = program;
            },

            _glAttachAndCompile: function(gl, programGL, vertexShader, fragmentShader) {
                gl.attachShader(programGL, vertexShader.shader);
                gl.attachShader(programGL, fragmentShader.shader);
                __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].timeStamp('osgjs.metrics:linkShader');
                gl.linkProgram(programGL);
            },

            compile: function() {
                var gl = this._gl;

                var shaderName = this._fragment
                    .getText()
                    .match(/#define[\s]+SHADER_NAME[\s]+([\S]+)(\n|$)/);

                var compileClean = true;

                this._shaderName = shaderName ? shaderName[1] : '';

                if (!this._vertex.shader) {
                    compileClean = this._vertex.compile(gl, errorCallback);
                }

                if (!this._fragment.shader) {
                    compileClean = this._fragment.compile(gl, errorCallback);
                }

                this._attributeMap = getAttributeList(this._vertex.getText());

                if (!compileClean) {
                    // Any error, Any
                    // Pink must die.
                    return false;
                }

                this._program = gl.createProgram();

                if (this._attributeMap.Vertex) {
                    // force Vertex to be on 0
                    gl.bindAttribLocation(this._program, 0, 'Vertex');
                }
                this._glAttachAndCompile(gl, this._program, this._vertex, this._fragment);

                this._uniformMap = getUniformList(
                    this._fragment.getText() + '\n' + this._vertex.getText()
                );

                return true;
            },

            getCompilationResult: function(compileClean, gl) {
                if (compileClean) {
                    if (
                        !gl.getProgramParameter(this._program, gl.LINK_STATUS) &&
                        !gl.isContextLost()
                    ) {
                        var errLink = gl.getProgramInfoLog(this._program);

                        __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].errorFold(
                            errLink,
                            "can't link program\nvertex shader:\n" +
                                this._vertex.text +
                                '\n fragment shader:\n' +
                                this._fragment.text
                        );

                        this._logDebugShaders(gl, errLink);
                        if (errorCallback) {
                            errorCallback(this._vertex.text, this._fragment.text, errLink);
                        }
                        compileClean = false;
                        if (this._onErrorToSpector(errLink)) return;
                    } else {
                        this._onCompilationToSpector(this._program);
                    }
                }

                this._bindProgramToSpector();

                this._uniformsCache = {};
                this._attributesCache = {};

                if (!compileClean) {
                    // Any error, Any
                    // Pink must die.
                    this._activateFailSafe(gl);
                } else {
                    this.cacheAttributeList(gl, window.Object.keys(this._attributeMap));
                    this.cacheUniformList(gl, window.Object.keys(this._uniformMap));
                }
                return compileClean;
            },

            apply: function(state) {
                if (this._nullProgram) return;

                if (!this._gl) {
                    this.setGraphicContext(state.getGraphicContext());
                }

                if (this._program && !this._dirty) {
                    state.applyProgram(this._program);
                    return;
                }

                this._compileClean = this.compile();
                this.getCompilationResult(this._compileClean, this._gl);
                state.applyProgram(this._program);
                this._dirty = false;
            },

            cacheUniformList: function(gl, uniformList) {
                var map = this._uniformsCache;
                for (var i = 0, l = uniformList.length; i < l; i++) {
                    var uniform = uniformList[i];
                    var location = gl.getUniformLocation(this._program, uniform);
                    if (location !== undefined && location !== null) {
                        if (map[uniform] === undefined) {
                            map[uniform] = location;
                        }
                    }
                }
            },

            cacheAttributeList: function(gl, attributeList) {
                var map = this._attributesCache;
                for (var i = 0, l = attributeList.length; i < l; i++) {
                    var attr = attributeList[i];
                    var location = gl.getAttribLocation(this._program, attr);

                    if (location !== -1 && location !== undefined) {
                        if (map[attr] === undefined) {
                            map[attr] = location;
                        }
                    }
                }
            }
        })
    ),
    'osg',
    'Program'
);

Program.registerErrorCallback = function(callback) {
    errorCallback = callback;
};

/* harmony default export */ __webpack_exports__["a"] = (Program);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Controller = function(manipulator) {
    this._manipulator = manipulator;
    this._enable = true;
};

Controller.prototype = {

    // All eventProxy must check isEnabled before injecting
    // event into Controllers
    isEnabled: function() {
        return this._enable;
    },

    // called to enable/disable a Controller
    // it should be customized for controller that keeps states
    // on events
    setEnable: function(bool) {
        this._enable = bool;
    }

};

/* harmony default export */ __webpack_exports__["a"] = (Controller);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// user performance if available or fallback

var now = (function() {
    var w = window || global; // eslint-disable-line

    // if no window.performance
    if (w.performance === undefined) {
        return function() {
            return Date.now();
        };
    }

    var fn =
        w.performance.now ||
        w.performance.mozNow ||
        w.performance.msNow ||
        w.performance.oNow ||
        w.performance.webkitNow ||
        function() {
            return Date.now();
        };
    return function() {
        return fn.apply(w.performance, arguments);
    };
})();

var Timer = function() {};

Timer.instance = function() {
    if (!Timer._instance) Timer._instance = new Timer();

    return Timer._instance;
};

Timer.prototype = {
    // delta in seconds
    deltaS: function(t0, t1) {
        return (t1 - t0) / 1000.0;
    },

    // delta in milliseconds
    deltaM: function(t0, t1) {
        return t1 - t0;
    },

    tick: function() {
        return now();
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Timer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(178)))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_transformEnums__ = __webpack_require__(11);





/**
 * Transform - base class for Transform type node ( Camera, MatrixTransform )
 * @class Transform
 * @inherits Node
 */
var Transform = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);
    this.referenceFrame = __WEBPACK_IMPORTED_MODULE_3_osg_transformEnums__["a" /* default */].RELATIVE_RF;
};

/** @lends Transform.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Transform,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        setReferenceFrame: function(value) {
            this.referenceFrame = value;
        },
        getReferenceFrame: function() {
            return this.referenceFrame;
        },

        computeBoundingSphere: (function() {
            var matrix = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
            return function(bSphere) {
                __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.computeBoundingSphere.call(this, bSphere);
                if (!bSphere.valid()) {
                    return bSphere;
                }

                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].identity(matrix);
                // local to local world (not Global World)
                this.computeLocalToWorldMatrix(matrix);
                bSphere.transformMat4(bSphere, matrix);
                return bSphere;
            };
        })()
    }),
    'osg',
    'Transform'
);

/* harmony default export */ __webpack_exports__["a"] = (Transform);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_utils__ = __webpack_require__(1);




/** Stores a set of modes and attributes which represent a set of OpenGL state.
 *  Notice that a \c StateSet contains just a subset of the whole OpenGL state.
 * <p>In OSG, each \c Drawable and each \c Node has a reference to a
 * \c StateSet. These <tt>StateSet</tt>s can be shared between
 * different <tt>Drawable</tt>s and <tt>Node</tt>s (that is, several
 * <tt>Drawable</tt>s and <tt>Node</tt>s can reference the same \c StateSet).
 * Indeed, this practice is recommended whenever possible,
 * as this minimizes expensive state changes in the graphics pipeline.
 */

var StateSet = function() {
    __WEBPACK_IMPORTED_MODULE_0_osg_Object__["a" /* default */].call(this);

    this._parents = [];
    this._attributeArray = [];
    this._textureAttributeArrayList = [];

    // cache what is really used
    this._activeTextureAttributeUnit = [];
    this._activeAttribute = [];
    this._activeTextureAttribute = [];

    this._binName = undefined;
    this._binNumber = 0;

    // put the shader generator name in an AttributePair
    // so that we can use the mask value
    this._shaderGeneratorPair = null;

    this._updateCallbackList = [];

    this.uniforms = {};

    this._hasUniform = false;

    this._drawID = -1; // used by the RenderLeaf to decide if it should apply the stateSet
};

StateSet.AttributePair = function(attr, value) {
    this._object = attr;
    this._value = value;
};

StateSet.AttributePair.prototype = {
    getShaderGeneratorName: function() {
        return this._object;
    },
    getAttribute: function() {
        return this._object;
    },
    getUniform: function() {
        return this._object;
    },
    getValue: function() {
        return this._value;
    }
};

__WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].createPrototypeObject(
    StateSet,
    __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osg_Object__["a" /* default */].prototype, {
        setDrawID: function(id) {
            this._drawID = id;
        },

        getDrawID: function() {
            return this._drawID;
        },

        getAttributePair: function(attribute, value) {
            return new StateSet.AttributePair(attribute, value);
        },

        addUniform: function(uniform, originalMode) {
            var mode = originalMode !== undefined ? originalMode : __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].ON;
            var name = uniform.getName();
            this.uniforms[name] = this.getAttributePair(uniform, mode);
            this._hasUniform = true;
        },

        addParent: function(node) {
            this._parents.push(node);
        },

        removeParent: function(node) {
            var idx = this._parents.indexOf(node);
            if (idx === -1) return;
            this._parents.splice(idx, 1);
        },

        removeUniform: function(uniform) {
            this.removeUniformByName(uniform.getName());
        },

        removeUniformByName: function(uniformName) {
            delete this.uniforms[uniformName];
            this._hasUniform = window.Object.keys(this.uniforms).length ? true : false;
        },

        hasUniform: function() {
            return this._hasUniform;
        },

        getUniform: function(uniform) {
            var uniformMap = this.uniforms;
            if (uniformMap[uniform]) return uniformMap[uniform].getAttribute();
            return undefined;
        },

        getUniformList: function() {
            return this.uniforms;
        },

        setTextureAttributeAndModes: function(unit, attribute, mode) {
            this._setTextureAttribute(
                unit,
                this.getAttributePair(attribute, mode !== undefined ? mode : __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].ON)
            );
        },

        getNumTextureAttributeLists: function() {
            return this._textureAttributeArrayList.length;
        },

        getTextureAttribute: function(unit, typeMember) {
            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getTextureIdFromTypeMember(typeMember);
            if (index === undefined || !this._hasTextureAttribute(unit, index)) return undefined;

            var textureArray = this._textureAttributeArrayList[unit];
            if (textureArray[index]) return textureArray[index].getAttribute();
            return undefined;
        },

        removeTextureAttribute: function(unit, typeMember) {
            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getTextureIdFromTypeMember(typeMember);
            if (index === undefined || !this._hasTextureAttribute(unit, index)) return;

            var textureArray = this._textureAttributeArrayList[unit];

            textureArray[index] = undefined;
            this._computeValidTextureUnit();
        },

        getAttribute: function(typeMember) {
            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getIdFromTypeMember(typeMember);
            if (index === undefined || !this._hasAttribute(index)) return undefined;

            return this._attributeArray[index].getAttribute();
        },

        setAttributeAndModes: function(attribute, mode) {
            this._setAttribute(
                this.getAttributePair(attribute, mode !== undefined ? mode : __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].ON)
            );
        },

        setAttribute: function(attribute, mode) {
            this.setAttributeAndModes(attribute, mode);
        },

        // TODO: check if it's an attribute type or a attribute to remove it
        removeAttribute: function(typeMember) {
            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getIdFromTypeMember(typeMember);
            if (!this._hasAttribute(index)) return;

            this._attributeArray[index] = undefined;
            this._computeValidAttribute();
        },

        setRenderingHint: function(hint) {
            if (hint === 'OPAQUE_BIN') {
                this.setRenderBinDetails(0, 'RenderBin');
            } else if (hint === 'TRANSPARENT_BIN') {
                this.setRenderBinDetails(10, 'DepthSortedBin');
            } else {
                this.setRenderBinDetails(0, '');
            }
        },

        getUpdateCallbackList: function() {
            return this._updateCallbackList;
        },

        removeUpdateCallback: function(cb) {
            var idx = this._updateCallbackList.indexOf(cb);
            if (idx === -1) return;
            this._updateCallbackList.splice(idx, 1);

            if (this._updateCallbackList.length === 0) {
                var parents = this._parents;
                for (var i = 0, l = parents.length; i < l; i++) {
                    var parent = parents[i];
                    parent.setNumChildrenRequiringUpdateTraversal(
                        parent.getNumChildrenRequiringUpdateTraversal() - 1
                    );
                }
            }
        },

        requiresUpdateTraversal: function() {
            return !!this._updateCallbackList.length;
        },

        addUpdateCallback: function(cb) {
            var dontNoticeParents = Boolean(this._updateCallbackList.length);
            this._updateCallbackList.push(cb);

            // parent alreay know we have update callback
            if (dontNoticeParents) return;

            var parents = this._parents;
            for (var i = 0, l = parents.length; i < l; i++) {
                var parent = parents[i];
                parent.setNumChildrenRequiringUpdateTraversal(
                    parent.getNumChildrenRequiringUpdateTraversal() + 1
                );
            }
        },

        hasUpdateCallback: function(cb) {
            return this._updateCallbackList.indexOf(cb) !== -1;
        },

        setRenderBinDetails: function(num, binName) {
            this._binNumber = num;
            this._binName = binName;
        },
        getAttributeMap: function() {
            // not efficieant at all but not really critique
            var obj = {};
            for (var i = 0, l = this._attributeArray.length; i < l; i++) {
                var attributePair = this._attributeArray[i];
                if (!attributePair) continue;
                var attribute = attributePair.getAttribute();
                obj[attribute.getTypeMember()] = attributePair;
            }
            return obj;
        },
        getBinNumber: function() {
            return this._binNumber;
        },
        getBinName: function() {
            return this._binName;
        },
        setBinNumber: function(binNum) {
            this._binNumber = binNum;
        },
        setBinName: function(binName) {
            this._binName = binName;
        },
        getAttributeList: function() {
            var attributeArray = this._attributeArray;
            var list = [];
            for (var i = 0, l = attributeArray.length; i < l; i++) {
                if (attributeArray[i]) list.push(attributeArray[i]);
            }
            return list;
        },
        setShaderGeneratorName: function(generatorName, mode) {
            this._shaderGeneratorPair = this.getAttributePair(
                generatorName,
                mode !== undefined ? mode : __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].ON
            );
        },
        getShaderGeneratorPair: function() {
            return this._shaderGeneratorPair;
        },
        getShaderGeneratorName: function() {
            return this._shaderGeneratorPair
                ? this._shaderGeneratorPair.getShaderGeneratorName()
                : undefined;
        },
        releaseGLObjects: function() {
            for (var i = 0, j = this._textureAttributeArrayList.length; i < j; i++) {
                var attribute = this.getTextureAttribute(i, 'Texture');
                if (attribute) attribute.releaseGLObjects();
            }
            var list = this.getAttributeList();
            for (var k = 0, l = list.length; k < l; k++) {
                // Remove only if we have releaseGLObject method.
                if (list[k]._object.releaseGLObjects) {
                    list[k]._object.releaseGLObjects();
                }
            }
        },

        // for internal use, you should not call it directly
        _setTextureAttribute: function(unit, attributePair) {
            __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].arrayDense(unit, this._textureAttributeArrayList);
            if (!this._textureAttributeArrayList[unit]) this._textureAttributeArrayList[unit] = [];

            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getOrCreateTextureStateAttributeTypeMemberIndex(
                attributePair.getAttribute()
            );
            __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].arrayDense(index, this._textureAttributeArrayList[unit]);

            this._textureAttributeArrayList[unit][index] = attributePair;
            this._computeValidTextureUnit();
        },

        _computeValidTextureUnit: function() {
            this._activeTextureAttributeUnit.length = 0;
            this._activeTextureAttribute.length = 0;
            var textureAttributeArrayList = this._textureAttributeArrayList;
            for (var i = 0, l = textureAttributeArrayList.length; i < l; i++) {
                var attributeList = textureAttributeArrayList[i];
                if (!attributeList || !attributeList.length) continue;
                var hasValidAttribute = false;
                for (var j = 0, k = attributeList.length; j < k; j++) {
                    if (attributeList[j]) {
                        hasValidAttribute = true;

                        if (this._activeTextureAttribute.indexOf(j) === -1) {
                            this._activeTextureAttribute.push(j);
                        }
                    }
                }

                if (hasValidAttribute) this._activeTextureAttributeUnit.push(i);
            }
        },
        _computeValidAttribute: function() {
            this._activeAttribute.length = 0;
            var attributeArray = this._attributeArray;
            for (var i = 0, l = attributeArray.length; i < l; i++) {
                if (attributeArray[i]) this._activeAttribute.push(i);
            }
        },
        // for internal use, you should not call it directly
        _setAttribute: function(attributePair) {
            var index = __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndex(
                attributePair.getAttribute()
            );
            __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].arrayDense(index, this._attributeArray);
            this._attributeArray[index] = attributePair;
            this._computeValidAttribute();
        },
        _hasAttribute: function(typeIndex) {
            if (typeIndex >= this._attributeArray.length) return false;
            return !!this._attributeArray[typeIndex];
        },
        _hasTextureAttribute: function(unit, typeIndex) {
            if (
                unit >= this._textureAttributeArrayList.length ||
                !this._textureAttributeArrayList[unit]
            )
                return false;
            if (typeIndex >= this._textureAttributeArrayList[unit].length) return false;
            return !!this._textureAttributeArrayList[unit][typeIndex];
        }
    }),
    'osg',
    'StateSet'
);

/* harmony default export */ __webpack_exports__["a"] = (StateSet);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var PooledResource = function(createFunction) {
    this._createFunction = createFunction;
    this._pool = [];
    this._length = 0;
};

PooledResource.prototype = {
    clean: function() {
        this._pool.length = 0;
        this._length = 0;
    },
    getLength: function() {
        return this._length;
    },
    reset: function() {
        this._length = 0;
    },
    /**
     * Creates or returns an existing object.
     * The returned object could contain invalid data from previous object values. User is responsible to reset/init the returned object for its (re)use.
     */
    getOrCreateObject: function() {
        var obj;
        if (this._length === this._pool.length) {
            obj = this._createFunction();
            this._pool.push(obj);
        } else {
            obj = this._pool[this._length];
        }
        this._length++;
        return obj;
    },
    forEach: function(func) {
        for (var i = 0; i < this._length; i++) func(this._pool[i]);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (PooledResource);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Timer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__ = __webpack_require__(32);





/**
 * Shader manage shader for vertex and fragment, you need both to create a glsl program.
 * @class Shader
 */
var Shader = function(type, text) {
    __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].call(this);
    var t = type;
    if (typeof type === 'string') {
        t = Shader[type];
    }
    this.type = t;
    this.setText(text);
};

Shader.VERTEX_SHADER = 0x8b31;
Shader.FRAGMENT_SHADER = 0x8b30;

// Debug Pink shader for when shader fails
var debugName = '\n#define SHADER_NAME FailSafe';
Shader.VS_DBG =
    '#define _DEBUG 1\n#ifdef _DEBUG\nattribute vec3 Vertex;uniform mat4 uModelViewMatrix;uniform mat4 uProjectionMatrix;void main(void) {  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);}\n';
Shader.FS_DBG =
    '#define _DEBUG 1\n#ifdef _DEBUG\n precision lowp float; void main(void) { gl_FragColor = vec4(1.0, 0.6, 0.6, 1.0);}\n';

// static cache of glShaders flagged for deletion, which will actually
// be deleted in the correct GL context.
Shader._sDeletedGLShaderCache = new window.Map();

// static method to delete Program
Shader.deleteGLShader = function(gl, shader) {
    if (!Shader._sDeletedGLShaderCache.has(gl)) Shader._sDeletedGLShaderCache.set(gl, []);
    Shader._sDeletedGLShaderCache.get(gl).push(shader);
};

// static method to flush all the cached glShaders which need to be deleted in the GL context specified
Shader.flushDeletedGLShaders = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;
    if (!Shader._sDeletedGLShaderCache.has(gl)) return availableTime;
    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_2_osg_Timer__["a" /* default */].instance().tick();
    var deleteList = Shader._sDeletedGLShaderCache.get(gl);
    var numShaders = deleteList.length;
    for (var i = numShaders - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteShader(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_2_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_2_osg_Timer__["a" /* default */].instance().tick());
    }
    return availableTime - elapsedTime;
};

Shader.flushAllDeletedGLShaders = function(gl) {
    if (!Shader._sDeletedGLShaderCache.has(gl)) return;
    var deleteList = Shader._sDeletedGLShaderCache.get(gl);
    var numShaders = deleteList.length;
    for (var i = numShaders - 1; i >= 0; i--) {
        gl.deleteShader(deleteList[i]);
        deleteList.splice(i, 1);
    }
    return;
};

Shader.onLostContext = function(gl) {
    if (!Shader._sDeletedGLShaderCache.has(gl)) return;
    var deleteList = Shader._sDeletedGLShaderCache.get(gl);
    deleteList.length = 0;
    return;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    Shader,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].prototype, {
        setText: function(text) {
            this.text = text;
        },
        getText: function() {
            return this.text;
        },
        // this is where it creates a fail safe shader that should work everywhere
        failSafe: function(gl, shaderText) {
            this.shader = gl.createShader(this.type);

            // concat failsafe and broken shader under separate _DEBUG defines blocks
            var shaderName = shaderText.match(/#define[\s]+SHADER_NAME[\s]+([\S]+)(\n|$)/);
            shaderName = shaderName ? shaderName[1] : '';
            var debugShaderTxt = this.type === Shader.VERTEX_SHADER ? Shader.VS_DBG : Shader.FS_DBG;
            debugShaderTxt += debugName + shaderName + '\n#else\n' + shaderText + '\n#endif\n';
            gl.shaderSource(this.shader, debugShaderTxt);
            gl.compileShader(this.shader);
        },
        // webgl shader compiler error to source contextualization
        // for better console log messages
        processErrors: function(errors, source) {
            // regex to extract error message and line from webgl compiler reporting
            var r = /ERROR: [\d]+:([\d]+): (.+)/gim;
            // split sources in indexable per line array
            var lines = source.split('\n');
            var linesLength = lines.length;
            if (linesLength === 0) return;

            var i, m;

            // IE reporting is not the same
            if (r.exec(errors) === null) {
                r = /Shader compilation errors\n\((\d+)\, \d+\): (.+)/gim;
            }

            // we dont understand error try to print it instead of nothing
            if (r.exec(errors) === null) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(errors);
                return;
            }

            // reset index to start.
            r.lastIndex = 0;

            while ((m = r.exec(errors)) !== null) {
                if (m.index === r.lastIndex) {
                    // moving between errors
                    r.lastIndex++;
                }
                // get error line
                var line = parseInt(m[1], 10);

                if (line > linesLength) continue;
                // webgl error report.
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('ERROR ' + m[2] + ' in line ' + line);

                var minLine = Math.max(0, line - 7);
                var maxLine = Math.max(0, line - 2);
                // for context
                // log surrounding line priori to error with bof check
                for (i = minLine; i <= maxLine; i++) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(lines[i].replace(/^[ \t]+/g, ''));
                }

                // Warn adds a lovely /!\ icon in front of the culprit line
                maxLine = Math.max(0, line - 1);
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(lines[maxLine].replace(/^[ \t]+/g, ''));

                minLine = Math.min(linesLength, line);
                maxLine = Math.min(linesLength, line + 5);
                // for context
                // surrounding line posterior to error (with eof check)
                for (i = minLine; i < maxLine; i++) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(lines[i].replace(/^[ \t]+/g, ''));
                }
            }
        },

        compile: function(gl, errorCallback) {
            if (!this._gl) this.setGraphicContext(gl);
            this.shader = gl.createShader(this.type);

            var shaderText = this.text;
            gl.shaderSource(this.shader, shaderText);
            __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeStamp('osgjs.metrics:compileShader');
            gl.compileShader(this.shader);
            if (!gl.getShaderParameter(this.shader, gl.COMPILE_STATUS) && !gl.isContextLost()) {
                var err = gl.getShaderInfoLog(this.shader);


                this.processErrors(err, shaderText);

                var tmpText = shaderText;
                var splittedText = tmpText.split('\n');
                var newText = '\n';
                for (var i = 0, l = splittedText.length; i < l; ++i) {
                    newText += i + ' ' + splittedText[i] + '\n';
                }
                // still logging whole source but folded
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].errorFold("can't compile shader", newText);
                if (errorCallback) errorCallback(this.shaderText, newText, err);

                return false;
            }
            return true;
        },
        releaseGLObjects: function() {
            if (this._gl !== undefined) {
                Shader.deleteGLShader(this._gl, this.shader);
                __WEBPACK_IMPORTED_MODULE_3_osg_GLObject__["a" /* default */].removeObject(this._gl, this);
            }
            this.invalidate();
        },
        invalidate: function() {
            this.shader = undefined;
        }
    }),
    'osg',
    'Shader'
);

/* harmony default export */ __webpack_exports__["a"] = (Shader);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);




var BoundingBox = function() {
    this._min = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
    this._max = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    BoundingBox,
    {
        init: function() {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._min, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].INFINITY);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._max, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].NEGATIVE_INFINITY);
        },

        volume: function() {
            var v = this._max[0] - this._min[0];
            v *= this._max[1] - this._min[1];
            v *= this._max[2] - this._min[2];
            return v;
        },

        copy: function(box) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._min, box._min);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._max, box._max);
        },

        valid: function() {
            return (
                this._max[0] >= this._min[0] &&
                this._max[1] >= this._min[1] &&
                this._max[2] >= this._min[2]
            );
        },

        expandByBoundingSphere: function(bs) {
            if (!bs.valid()) {
                return;
            }
            var max = this._max;
            var min = this._min;
            var radius = bs._radius;
            var x = bs._center[0];
            var y = bs._center[1];
            var z = bs._center[2];
            min[0] = Math.min(min[0], x - radius);
            min[1] = Math.min(min[1], y - radius);
            min[2] = Math.min(min[2], z - radius);

            max[0] = Math.max(max[0], x + radius);
            max[1] = Math.max(max[1], y + radius);
            max[2] = Math.max(max[2], z + radius);
        },

        expandByvec3: function(v) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('deprecated, use expandByVec3');
            this.expandByVec3(v);
        },

        expandByVec3: function(v) {
            var min = this._min;
            var max = this._max;
            min[0] = Math.min(min[0], v[0]);
            min[1] = Math.min(min[1], v[1]);
            min[2] = Math.min(min[2], v[2]);

            max[0] = Math.max(max[0], v[0]);
            max[1] = Math.max(max[1], v[1]);
            max[2] = Math.max(max[2], v[2]);
        },

        expandByBoundingBox: function(bb) {
            if (!bb.valid()) return;

            var min = this._min;
            var max = this._max;
            var bbmin = bb._min;
            var bbmax = bb._max;

            if (bbmin[0] < min[0]) min[0] = bbmin[0];
            if (bbmax[0] > max[0]) max[0] = bbmax[0];

            if (bbmin[1] < min[1]) min[1] = bbmin[1];
            if (bbmax[1] > max[1]) max[1] = bbmax[1];

            if (bbmin[2] < min[2]) min[2] = bbmin[2];
            if (bbmax[2] > max[2]) max[2] = bbmax[2];
        },

        center: function(result) {
            var min = this._min;
            var max = this._max;
            result[0] = (min[0] + max[0]) * 0.5;
            result[1] = (min[1] + max[1]) * 0.5;
            result[2] = (min[2] + max[2]) * 0.5;
            return result;
        },

        radius: function() {
            return Math.sqrt(this.radius2());
        },

        radius2: function() {
            var min = this._min;
            var max = this._max;
            var dx = max[0] - min[0];
            var dy = max[1] - min[1];
            var dz = max[2] - min[2];
            return 0.25 * (dx * dx + dy * dy + dz * dz);
        },

        getMin: function() {
            return this._min;
        },

        getMax: function() {
            return this._max;
        },

        setMin: function(min) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._min, min);
            return this;
        },

        setMax: function(max) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._max, max);
            return this;
        },

        xMax: function() {
            return this._max[0];
        },

        yMax: function() {
            return this._max[1];
        },

        zMax: function() {
            return this._max[2];
        },

        xMin: function() {
            return this._min[0];
        },

        yMin: function() {
            return this._min[1];
        },

        zMin: function() {
            return this._min[2];
        },

        corner: function(pos, ret) {
            /*jshint bitwise: false */
            if (pos & 1) {
                ret[0] = this._max[0];
            } else {
                ret[0] = this._min[0];
            }
            if (pos & 2) {
                ret[1] = this._max[1];
            } else {
                ret[1] = this._min[1];
            }
            if (pos & 4) {
                ret[2] = this._max[2];
            } else {
                ret[2] = this._min[2];
            }
            return ret;
            /*jshint bitwise: true */
        },

        // http://dev.theomader.com/transform-bounding-boxes/
        // https://github.com/erich666/GraphicsGems/blob/master/gems/TransBox.c
        transformMat4: (function() {
            var tmpMin = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
            var tmpMax = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
            return function(out, m) {
                var inMin = this.getMin();
                var inMax = this.getMax();

                /* Take care of translation by beginning at T. */
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].getTranslation(tmpMin, m);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(tmpMax, tmpMin);

                /* Now find the extreme points by considering the product of the */
                /* min and max with each component of M.  */
                for (var i = 0; i < 3; ++i) {
                    var i4 = i * 4;
                    var mini = inMin[i];
                    var maxi = inMax[i];
                    for (var j = 0; j < 3; ++j) {
                        var cm = m[i4 + j];
                        var a = cm * maxi;
                        var b = cm * mini;
                        if (a < b) {
                            tmpMin[j] += a;
                            tmpMax[j] += b;
                        } else {
                            tmpMin[j] += b;
                            tmpMax[j] += a;
                        }
                    }
                }
                var outMax = out.getMax();
                var outMin = out.getMin();

                outMax[0] = tmpMax[0];
                outMax[1] = tmpMax[1];
                outMax[2] = tmpMax[2];

                outMin[0] = tmpMin[0];
                outMin[1] = tmpMin[1];
                outMin[2] = tmpMin[2];

                return out;
            };
        })()
    },
    'osg',
    'BoundingBox'
);

/* harmony default export */ __webpack_exports__["a"] = (BoundingBox);


/***/ }),
/* 27 */
/***/ (function(module, exports) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

/**
 * @class Common utilities
 * @name glMatrix
 */
var glMatrix = {};

// Configuration Constants
glMatrix.EPSILON = 0.000001;
glMatrix.ARRAY_TYPE = (typeof Float32Array !== 'undefined') ? Float32Array : Array;
glMatrix.RANDOM = Math.random;
glMatrix.ENABLE_SIMD = false;

// Capability detection
glMatrix.SIMD_AVAILABLE = (glMatrix.ARRAY_TYPE === Float32Array) && ('SIMD' in this);
glMatrix.USE_SIMD = glMatrix.ENABLE_SIMD && glMatrix.SIMD_AVAILABLE;

/**
 * Sets the type of array used when creating new vectors and matrices
 *
 * @param {Type} type Array type, such as Float32Array or Array
 */
glMatrix.setMatrixArrayType = function(type) {
    glMatrix.ARRAY_TYPE = type;
}

var degree = Math.PI / 180;

/**
* Convert Degree To Radian
*
* @param {Number} Angle in Degrees
*/
glMatrix.toRadian = function(a){
     return a * degree;
}

/**
 * Tests whether or not the arguments have approximately the same value, within an absolute
 * or relative tolerance of glMatrix.EPSILON (an absolute tolerance is used for values less 
 * than or equal to 1.0, and a relative tolerance is used for larger values)
 * 
 * @param {Number} a The first number to test.
 * @param {Number} b The second number to test.
 * @returns {Boolean} True if the numbers are approximately equal, false otherwise.
 */
glMatrix.equals = function(a, b) {
	return Math.abs(a - b) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a), Math.abs(b));
}

module.exports = glMatrix;


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgViewer_webgl_utils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Options__ = __webpack_require__(73);



var Texture;

var WebGLCaps = function() {
    // circular deps with texture
    if (!Texture) Texture = __webpack_require__(7).default;

    this._checkRTT = {};
    this._webGLExtensions = {};
    this._webGLParameters = {};
    this._webGLShaderMaxInt = 'NONE';
    this._webGLShaderMaxFloat = 'NONE';

    this._bugsDB = {};
    this._webGLPlatforms = {};

    // webgl minimum requirements as per webgl specs
    // useful for nodejs env
    this._webGLParameters['MAX_COMBINED_TEXTURE_IMAGE_UNITS'] = 8;
    this._webGLParameters['MAX_CUBE_MAP_TEXTURE_SIZE'] = 16;
    this._webGLParameters['MAX_FRAGMENT_UNIFORM_VECTORS'] = 16;
    this._webGLParameters['MAX_RENDERBUFFER_SIZE'] = 1;
    this._webGLParameters['MAX_TEXTURE_IMAGE_UNITS'] = 8;
    this._webGLParameters['MAX_TEXTURE_SIZE'] = 64;
    this._webGLParameters['MAX_VARYING_VECTORS'] = 8;
    this._webGLParameters['MAX_VERTEX_ATTRIBS'] = 8;
    this._webGLParameters['MAX_VERTEX_TEXTURE_IMAGE_UNITS'] = 0;
    this._webGLParameters['MAX_VERTEX_UNIFORM_VECTORS'] = 128;
    this._webGLParameters['MAX_VIEWPORT_DIMS'] = [1, 1];
    this._webGLParameters['NUM_COMPRESSED_TEXTURE_FORMATS'] = 0;
    this._webGLParameters['MAX_SHADER_PRECISION_FLOAT'] = 'none';
    this._webGLParameters['MAX_SHADER_PRECISION_INT'] = 'none';

    // for multiple context
    // allow checking we're on the good one
    this._gl = undefined;
};

WebGLCaps.instance = function(glParam, force) {
    if (!WebGLCaps._instance) {
        var oldWebGLInspector;
        var gl = glParam;

        if (!gl) {
            // make sure we don't break webglinspector
            // with our webglcaps canvas
            var webglInspector = typeof window !== 'undefined' && window.gli;

            if (webglInspector) {
                oldWebGLInspector = window.gli.host.inspectContext;
                window.gli.host.inspectContext = false;
            }

            var c = document.createElement('canvas');
            c.width = 32;
            c.height = 32;

            var options = new __WEBPACK_IMPORTED_MODULE_2_osg_Options__["a" /* default */]();
            // not necessary, but for some reasons it crashed on chromium vr build
            options.extend({
                antialias: false
            });
            // in case of webgl2
            options.extendWithOptionsURL();

            gl = __WEBPACK_IMPORTED_MODULE_1_osgViewer_webgl_utils__["a" /* default */].setupWebGL(c, options, function() {});
        }

        WebGLCaps._instance = new WebGLCaps();
        if (gl) {
            WebGLCaps._instance.init(gl);
        } else {
            // gracefully handle non webgl
            // like nodejs, phantomjs
            // warns but no error so that nodejs/phantomjs
            // can still has some webglcaps object
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('no support for webgl context detected.');
        }

        if (oldWebGLInspector) {
            window.gli.host.inspectContext = oldWebGLInspector;
        }

        //delete c;
    }

    if (glParam && (force || glParam !== WebGLCaps._instance.getContext())) {
        // webgl caps called with a different context or GPU
        // than the one we draw in, will result on hard crash
        // when using extension from another context
        WebGLCaps._instance.initContextDependant(glParam);
    }

    return WebGLCaps._instance;
};

WebGLCaps.prototype = {
    getContext: function() {
        return this._gl;
    },

    initContextDependant: function(gl) {
        // store context in case of multiple context
        this._gl = gl;
        // We need to check if this is a webGL2 context to get the extensions work.
        this._isGL2 =
            typeof window.WebGL2RenderingContext !== 'undefined' &&
            gl instanceof window.WebGL2RenderingContext;
        // Takes care of circular dependencies on Texture
        // Texture should be resolved at this point
        // Texture = require('osg/Texture').default;

        // get extensions
        this.initWebGLExtensions(gl);

        // get float support
        this.hasLinearHalfFloatRTT(gl);
        this.hasLinearFloatRTT(gl);
        this.hasHalfFloatRTT(gl);
        this.hasFloatRTT(gl);
    },

    init: function(gl) {
        // get capabilites
        this.initWebGLParameters(gl);

        // order is important
        // to allow webgl extensions filtering
        this.initPlatformSupport();
        this.initBugDB();

        this.initContextDependant(gl);

        if (this._isGL2) {
            var nativeExtension = [
                'OES_element_index_uint',
                'EXT_sRGB',
                'EXT_blend_minmax',
                'EXT_frag_depth',
                'WEBGL_depth_texture',
                'EXT_shader_texture_lod',
                'OES_standard_derivatives',
                'OES_texture_float',
                'OES_texture_half_float',
                'OES_texture_half_float_linear',
                'OES_texture_float_linear',
                'OES_vertex_array_object',
                'WEBGL_draw_buffers',
                'OES_fbo_render_mipmap',
                'ANGLE_instanced_arrays'
            ];

            var ext = WebGLCaps._instance.getWebGLExtensions();
            var dummyFunc = function() {};
            for (var i = 0, l = nativeExtension.length; i < l; i++) {
                ext[nativeExtension[i]] = dummyFunc;
            }
        }
    },

    isWebGL2: function() {
        return this._isGL2;
    },

    // inevitable bugs per platform (browser/OS/GPU)
    initBugDB: function() {
        var p = this._webGLPlatforms;
        var ext = this._webGLParameters;

        // derivatives gives strange results on Shadow Shaders
        if (p.Apple) {
            if (!ext.UNMASKED_VENDOR_WEBGL || ext.UNMASKED_VENDOR_WEBGL.indexOf('Intel') !== -1) {
                // bug is on INTEL GPU on APPLE
                // we disable the ext on Apple if we cannot get GPU info
                this._bugsDB['OES_standard_derivatives'] = true;
            }
        }
    },

    initPlatformSupport: function() {
        var p = this._webGLPlatforms;

        p.Apple =
            navigator.vendor.indexOf('Apple') !== -1 || navigator.vendor.indexOf('OS X') !== -1;

        // degrades complexity on handhelds.
        p.Mobile = /Mobi/.test(navigator.userAgent) || /ablet/.test(navigator.userAgent);
    },

    getWebGLPlatform: function(str) {
        return this._webGLPlatforms[str];
    },

    getWebGLPlatforms: function() {
        return this._webGLPlatforms;
    },

    getWebGLParameter: function(str) {
        return this._webGLParameters[str];
    },

    getWebGLParameters: function() {
        return this._webGLParameters;
    },

    getShaderMaxPrecisionFloat: function() {
        return this._webGLParameters.MAX_SHADER_PRECISION_FLOAT;
    },

    getShaderMaxPrecisionInt: function() {
        return this._webGLParameters.MAX_SHADER_PRECISION_INT;
    },

    checkSupportRTT: function(gl, typeFloat, typeTexture) {
        var key = typeFloat + ',' + typeTexture;

        if (this._isGL2) {
            return !!this._webGLExtensions['EXT_color_buffer_float'];
        }

        // check once only
        if (this._checkRTT[key] !== undefined) return this._checkRTT[key];

        // no cached results, need gl context
        if (!gl) return false;

        // from http://codeflow.org/entries/2013/feb/22/how-to-write-portable-webgl/#how-can-i-detect-if-i-can-render-to-floating-point-textures

        // setup the texture
        var texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 2, 2, 0, gl.RGBA, typeFloat, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, typeTexture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, typeTexture);

        // setup the framebuffer
        var framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);

        // check the framebuffer
        var status = (this._checkRTT[key] =
            gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE);

        // cleanup
        gl.deleteTexture(texture);
        gl.deleteFramebuffer(framebuffer);
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);

        return status;
    },

    hasLinearHalfFloatRTT: function(gl) {
        return (
            this._webGLExtensions['OES_texture_half_float_linear'] &&
            this.checkSupportRTT(gl, Texture.HALF_FLOAT_OES, Texture.LINEAR)
        );
    },

    hasLinearFloatRTT: function(gl) {
        return (
            this._webGLExtensions['OES_texture_float_linear'] &&
            this.checkSupportRTT(gl, Texture.FLOAT, Texture.LINEAR)
        );
    },

    hasHalfFloatRTT: function(gl) {
        return (
            this._webGLExtensions['OES_texture_half_float'] &&
            this.checkSupportRTT(gl, Texture.HALF_FLOAT_OES, Texture.NEAREST)
        );
    },

    hasFloatRTT: function(gl) {
        return (
            this._webGLExtensions['OES_texture_float'] &&
            this.checkSupportRTT(gl, Texture.FLOAT, Texture.NEAREST)
        );
    },

    queryPrecision: function(gl, shaderType, precision) {
        var answer = gl.getShaderPrecisionFormat(shaderType, precision);
        if (!answer) return false;
        return answer.precision !== 0;
    },

    hasVAO: function() {
        return !!this._webGLExtensions['OES_vertex_array_object'];
    },

    getDisjointTimerQuery: function() {
        return (
            this._webGLExtensions['EXT_disjoint_timer_query_webgl2'] ||
            this._webGLExtensions['EXT_disjoint_timer_query']
        );
    },

    initWebGLParameters: function(gl) {
        if (!gl) return;
        var limits = [
            'MAX_COMBINED_TEXTURE_IMAGE_UNITS',
            'MAX_CUBE_MAP_TEXTURE_SIZE',
            'MAX_FRAGMENT_UNIFORM_VECTORS',
            'MAX_RENDERBUFFER_SIZE',
            'MAX_TEXTURE_IMAGE_UNITS',
            'MAX_TEXTURE_SIZE',
            'MAX_VARYING_VECTORS',
            'MAX_VERTEX_ATTRIBS',
            'MAX_VERTEX_TEXTURE_IMAGE_UNITS',
            'MAX_VERTEX_UNIFORM_VECTORS',
            'MAX_VIEWPORT_DIMS',
            'SHADING_LANGUAGE_VERSION',
            'VERSION',
            'VENDOR',
            'RENDERER',
            'ALIASED_LINE_WIDTH_RANGE',
            'ALIASED_POINT_SIZE_RANGE',
            'RED_BITS',
            'GREEN_BITS',
            'BLUE_BITS',
            'ALPHA_BITS',
            'DEPTH_BITS',
            'STENCIL_BITS'
        ];
        var params = this._webGLParameters;
        for (var i = 0, len = limits.length; i < len; ++i) {
            var par = limits[i];
            params[par] = gl.getParameter(gl[par]);
        }

        //shader precisions for float
        if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.HIGH_FLOAT)) {
            params.MAX_SHADER_PRECISION_FLOAT = 'high';
        } else if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT)) {
            params.MAX_SHADER_PRECISION_FLOAT = 'medium';
        } else if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.LOW_FLOAT)) {
            params.MAX_SHADER_PRECISION_FLOAT = 'low';
        }

        //shader precisions for float
        if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.HIGH_INT)) {
            params.MAX_SHADER_PRECISION_INT = 'high';
        } else if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.MEDIUM_INT)) {
            params.MAX_SHADER_PRECISION_INT = 'medium';
        } else if (this.queryPrecision(gl, gl.FRAGMENT_SHADER, gl.LOW_INT)) {
            params.MAX_SHADER_PRECISION_INT = 'low';
        }

        // get GPU, Angle or not, Opengl/directx, etc.
        //  ffx && chrome only
        var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');
        if (debugInfo) {
            params.UNMASKED_RENDERER_WEBGL = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
            params.UNMASKED_VENDOR_WEBGL = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
        }
        // TODO ?
        // try to compile a small shader to test the spec is respected
    },

    applyExtension: function(gl, name) {
        var ext = gl.getExtension(name);
        // Borrowed from https://webgl2fundamentals.org/webgl/lessons/webgl1-to-webgl2.html
        // make "generalized" functions and name
        // so that can be used in webgl1 & wegbl2
        var suffix = name.split('_')[0];
        var prefix = '_' + suffix;
        var suffixRE = new RegExp(suffix + '$');
        var prefixRE = new RegExp(prefix);
        for (var key in ext) {
            var val = ext[key];
            if (typeof val === 'function') {
                // remove suffix (eg: bindVertexArrayOES -> bindVertexArray)
                var unsuffixedKey = key.replace(suffixRE, '');
                if (gl[unsuffixedKey] === undefined) gl[unsuffixedKey] = ext[key].bind(ext);
            } else {
                var unprefixedKey = key.replace(prefixRE, '');
                if (gl[unprefixedKey] === undefined) gl[unprefixedKey] = ext[key];
            }
        }
    },

    getWebGLExtension: function(str) {
        return this._webGLExtensions[str];
    },

    getWebGLExtensions: function() {
        return this._webGLExtensions;
    },

    initWebGLExtensions: function(gl, filterBugs) {
        // nodejs, phantomjs
        if (!gl) return;

        var doFilter = filterBugs;
        if (doFilter === undefined) doFilter = true;

        var supported = gl.getSupportedExtensions();
        if (!supported) return;
        var ext = this._webGLExtensions;
        // we load all the extensions
        for (var i = 0, len = supported.length; i < len; ++i) {
            var sup = supported[i];

            if (doFilter && this._bugsDB[sup]) {
                // bugs on that configuration, do not enable
                continue;
            }

            ext[sup] = gl.getExtension(sup);
            if (!this._isGL2) this.applyExtension(gl, sup);
        }

        var anisoExt = this.getWebGLExtension('EXT_texture_filter_anisotropic');
        if (anisoExt) {
            Texture.ANISOTROPIC_SUPPORT_EXT = true;
            Texture.ANISOTROPIC_SUPPORT_MAX = gl.getParameter(
                anisoExt.MAX_TEXTURE_MAX_ANISOTROPY_EXT
            );
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (WebGLCaps);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



/**
 *  Manage Blending mode
 *  @class BlendFunc
 */
var BlendFunc = function(sourceRGB, destinationRGB, sourceAlpha, destinationAlpha) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._sourceFactor = BlendFunc.DISABLE;
    this._destinationFactor = BlendFunc.DISABLE;
    this._sourceFactorAlpha = this._sourceFactor;
    this._destinationFactorAlpha = this._destinationFactor;
    this._separate = false;
    if (sourceRGB !== undefined) {
        this.setSource(sourceRGB);
    }
    if (destinationRGB !== undefined) {
        this.setDestination(destinationRGB);
    }

    if (sourceAlpha !== undefined) {
        this.setSourceAlpha(sourceAlpha);
    }
    if (destinationAlpha !== undefined) {
        this.setDestinationAlpha(destinationAlpha);
    }
};

BlendFunc.DISABLE = -1;
BlendFunc.ZERO = 0;
BlendFunc.ONE = 1;
BlendFunc.SRC_COLOR = 0x0300;
BlendFunc.ONE_MINUS_SRC_COLOR = 0x0301;
BlendFunc.SRC_ALPHA = 0x0302;
BlendFunc.ONE_MINUS_SRC_ALPHA = 0x0303;
BlendFunc.DST_ALPHA = 0x0304;
BlendFunc.ONE_MINUS_DST_ALPHA = 0x0305;
BlendFunc.DST_COLOR = 0x0306;
BlendFunc.ONE_MINUS_DST_COLOR = 0x0307;
BlendFunc.SRC_ALPHA_SATURATE = 0x0308;

/* Separate Blend Functions */
BlendFunc.BLEND_DST_RGB = 0x80c8;
BlendFunc.BLEND_SRC_RGB = 0x80c9;
BlendFunc.BLEND_DST_ALPHA = 0x80ca;
BlendFunc.BLEND_SRC_ALPHA = 0x80cb;
BlendFunc.CONSTANT_COLOR = 0x8001;
BlendFunc.ONE_MINUS_CONSTANT_COLOR = 0x8002;
BlendFunc.CONSTANT_ALPHA = 0x8003;
BlendFunc.ONE_MINUS_CONSTANT_ALPHA = 0x8004;
BlendFunc.BLEND_COLOR = 0x8005;

/** @lends BlendFunc.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    BlendFunc,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        /**
         * StateAttribute type of BlendFunc
         * @type String
         */
        attributeType: 'BlendFunc',
        /**
         * Create an instance of this StateAttribute
         */
        cloneType: function() /**BlendFunc*/ {
            return new BlendFunc();
        },
        setSource: function(f) {
            this.setSourceRGB(f);
            this.setSourceAlpha(f);
        },
        getSource: function() {
            return this._sourceFactor;
        },
        setDestination: function(f) {
            this.setDestinationRGB(f);
            this.setDestinationAlpha(f);
        },
        getDestination: function() {
            return this._destinationFactor;
        },
        getSeparate: function() {
            return this._separate;
        },
        checkSeparate: function() {
            return (
                this._sourceFactor !== this._sourceFactorAlpha ||
                this._destinationFactor !== this._destinationFactorAlpha
            );
        },
        setSourceRGB: function(f) {
            if (typeof f === 'string') {
                this._sourceFactor = BlendFunc[f];
            } else {
                this._sourceFactor = f;
            }
            this._separate = this.checkSeparate();
        },
        getSourceRGB: function() {
            return this._sourceFactor;
        },
        setSourceAlpha: function(f) {
            if (typeof f === 'string') {
                this._sourceFactorAlpha = BlendFunc[f];
            } else {
                this._sourceFactorAlpha = f;
            }
            this._separate = this.checkSeparate();
        },
        getSourceAlpha: function() {
            return this._sourceFactorAlpha;
        },
        setDestinationRGB: function(f) {
            if (typeof f === 'string') {
                this._destinationFactor = BlendFunc[f];
            } else {
                this._destinationFactor = f;
            }
            this._separate = this.checkSeparate();
        },
        getDestinationRGB: function() {
            return this._destinationFactor;
        },
        setDestinationAlpha: function(f) {
            if (typeof f === 'string') {
                this._destinationFactorAlpha = BlendFunc[f];
            } else {
                this._destinationFactorAlpha = f;
            }
            this._separate = this.checkSeparate();
        },
        getDestinationAlpha: function() {
            return this._destinationFactorAlpha;
        },

        /**
         * Apply the mode, must be called in the draw traversal
         * @param state
         */
        apply: function(state) {
            state.applyBlendFunc(this);
        }
    }),
    'osg',
    'BlendFunc'
);

/* harmony default export */ __webpack_exports__["a"] = (BlendFunc);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Timer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_WebGLCaps__ = __webpack_require__(28);







/**
 * FrameBufferObject manage fbo / rtt
 * @class FrameBufferObject
 */
var FrameBufferObject = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].call(this);
    __WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__["a" /* default */].call(this);

    this._fbo = undefined;
    this._rbo = undefined;
    this._attachments = [];
    this._buffers = [];
    this._dirty = true;
    this._hasMRT = __WEBPACK_IMPORTED_MODULE_5_osg_WebGLCaps__["a" /* default */].instance().getWebGLExtension('WEBGL_draw_buffers');
};

FrameBufferObject.COLOR_ATTACHMENT0 = 0x8ce0;
FrameBufferObject.DEPTH_ATTACHMENT = 0x8d00;
FrameBufferObject.DEPTH_COMPONENT16 = 0x81a5;

// static cache of glFrameBuffer flagged for deletion, which will actually
// be deleted in the correct GL context.
FrameBufferObject._sDeletedGLFrameBufferCache = new window.Map();

// static method to delete FrameBuffers
FrameBufferObject.deleteGLFrameBuffer = function(gl, fb) {
    if (!FrameBufferObject._sDeletedGLFrameBufferCache.has(gl))
        FrameBufferObject._sDeletedGLFrameBufferCache.set(gl, []);

    FrameBufferObject._sDeletedGLFrameBufferCache.get(gl).push(fb);
};

// static method to flush all the cached glFrameBuffers which need to be deleted in the GL context specified
FrameBufferObject.flushDeletedGLFrameBuffers = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;

    if (!FrameBufferObject._sDeletedGLFrameBufferCache.has(gl)) return availableTime;
    var deleteList = FrameBufferObject._sDeletedGLFrameBufferCache.get(gl);
    if (deleteList.length === 0) return availableTime;

    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteFramebuffer(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
    }

    return availableTime - elapsedTime;
};

FrameBufferObject.flushAllDeletedGLFrameBuffers = function(gl) {
    if (!FrameBufferObject._sDeletedGLFrameBufferCache.has(gl)) return;
    var deleteList = FrameBufferObject._sDeletedGLFrameBufferCache.get(gl);
    if (deleteList.length === 0) return;
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0; i--) {
        gl.deleteFramebuffer(deleteList[i]);
        deleteList.splice(i, 1);
    }
};

// static cache of glRenderBuffer flagged for deletion, which will actually
// be deleted in the correct GL context.
FrameBufferObject._sDeletedGLRenderBufferCache = new window.Map();

// static method to delete RenderBuffers
FrameBufferObject.deleteGLRenderBuffer = function(gl, fb) {
    if (!FrameBufferObject._sDeletedGLRenderBufferCache.has(gl))
        FrameBufferObject._sDeletedGLRenderBufferCache.set(gl, []);

    FrameBufferObject._sDeletedGLRenderBufferCache.get(gl).push(fb);
};

// static method to flush all the cached glRenderBuffers which need to be deleted in the GL context specified
FrameBufferObject.flushDeletedGLRenderBuffers = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;

    if (!FrameBufferObject._sDeletedGLRenderBufferCache.has(gl)) return availableTime;

    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
    var deleteList = FrameBufferObject._sDeletedGLRenderBufferCache.get(gl);
    var numBuffers = deleteList.length;

    for (var i = numBuffers - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteRenderbuffer(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
    }
    return availableTime - elapsedTime;
};

FrameBufferObject.flushAllDeletedGLRenderBuffers = function(gl) {
    if (!FrameBufferObject._sDeletedGLRenderBufferCache.has(gl)) return;

    var deleteList = FrameBufferObject._sDeletedGLRenderBufferCache.get(gl);
    var numBuffers = deleteList.length;

    for (var i = numBuffers - 1; i >= 0; i--) {
        gl.deleteRenderbuffer(deleteList[i]);
        deleteList.splice(i, 1);
    }
};

FrameBufferObject.onLostContext = function(gl) {
    if (!FrameBufferObject._sDeletedGLFrameBufferCache.has(gl)) return;

    var deleteList = FrameBufferObject._sDeletedGLFrameBufferCache.get(gl);
    deleteList.length = 0;

    if (!FrameBufferObject._sDeletedGLRenderBufferCache.has(gl)) return;

    deleteList = FrameBufferObject._sDeletedGLRenderBufferCache.get(gl);
    deleteList.length = 0;
};

/** @lends FrameBufferObject.prototype */
__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    FrameBufferObject,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(
        __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].prototype,
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_StateAttribute__["a" /* default */].prototype, {
            attributeType: 'FrameBufferObject',

            cloneType: function() {
                return new FrameBufferObject();
            },

            invalidate: function() {
                if (this._rbo && this._attachments) {
                    for (var i = 0, l = this._attachments.length; i < l; ++i) {
                        var attachment = this._attachments[i];
                        // shared renderbuffer object between camera
                        // must still be set to null as it's webgl object
                        // apply will reshare it when creating it.
                        if (!attachment.texture) {
                            attachment.renderBufferObject = undefined;
                        }
                    }
                    this._rbo = undefined;
                }
                this._fbo = undefined;
                this._buffers.length = 0;
                this._dirty = true;
            },

            dirty: function() {
                this._buffers.length = 0;
                this._dirty = true;
            },

            isDirty: function() {
                return this._dirty;
            },

            setAttachment: function(attachment) {
                this._attachments.push(attachment);
            },

            getAttachment: function(attachmentType) {
                if (!this._attachments) return;
                for (var i = 0, l = this._attachments.length; i < l; ++i) {
                    var attachment = this._attachments[i];
                    // shared renderbuffer object between camera
                    // must still be set to null as it's webgl object
                    // apply will reshare it when creating it.
                    if (attachment.attachment === attachmentType) {
                        return attachment;
                    }
                }
                return;
            },
            releaseGLObjects: function() {
                if (this._fbo !== undefined && this._gl !== undefined) {
                    FrameBufferObject.deleteGLFrameBuffer(this._gl, this._fbo);
                }
                this._fbo = undefined;

                if (this._rbo !== undefined && this._gl !== undefined) {
                    FrameBufferObject.deleteGLRenderBuffer(this._gl, this._rbo);
                }
                this.invalidate();
            },

            _reportFrameBufferError: function(code) {
                switch (code) {
                    case 0x8cd6:
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('FRAMEBUFFER_INCOMPLETE_ATTACHMENT');
                        break;
                    case 0x8cd7:
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT');
                        break;
                    case 0x8cd9:
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('FRAMEBUFFER_INCOMPLETE_DIMENSIONS');
                        break;
                    case 0x8cdd:
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('FRAMEBUFFER_UNSUPPORTED');
                        break;
                    default:
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('FRAMEBUFFER unknown error ' + code.toString(16));
                }
            },

            reset: function() {
                this.releaseGLObjects();
                this._attachments = [];
            },

            getFrameBufferObject: function() {
                return this._fbo;
            },

            getRenderBufferObject: function() {
                return this._rbo;
            },

            createFrameBufferObject: function(state) {
                this.setGraphicContext(state.getGraphicContext());
                this._fbo = this._gl.createFramebuffer();
            },

            createRenderBuffer: function(format, width, height) {
                var gl = this._gl;
                var renderBuffer = gl.createRenderbuffer();
                gl.bindRenderbuffer(gl.RENDERBUFFER, renderBuffer);
                gl.renderbufferStorage(gl.RENDERBUFFER, format, width, height);

                return renderBuffer;
            },

            framebufferRenderBuffer: function(attachment, renderBuffer) {
                var gl = this._gl;
                gl.bindRenderbuffer(gl.RENDERBUFFER, renderBuffer);
                gl.framebufferRenderbuffer(
                    gl.FRAMEBUFFER,
                    attachment,
                    gl.RENDERBUFFER,
                    renderBuffer
                );

            },

            framebufferTexture2D: function(state, attachment, textureTarget, texture) {
                var gl = this._gl;

                // apply on unit 1 to init it
                // make sure we do bind it whatever state stack
                // texture is cached
                state.applyTextureAttribute(1, texture);

                if (texture.isDirty() || !texture.getTextureObject()) {
                    // image wasn't ready, texture not allocated due to lack of gpu MEM
                    return false;
                }

                // gl2 vs gl1
                var target = gl.DRAW_FRAMEBUFFER || gl.FRAMEBUFFER;
                gl.framebufferTexture2D(
                    target,
                    attachment,
                    textureTarget,
                    texture.getTextureObject().id(),
                    0
                );


                return true;
            },

            bindFrameBufferObject: function() {
                var gl = this._gl;
                gl.bindFramebuffer(gl.FRAMEBUFFER, this._fbo);
            },

            checkStatus: function() {
                var gl = this._gl;
                var status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
                if (status !== gl.FRAMEBUFFER_COMPLETE) {
                    this._reportFrameBufferError(status);
                }
            },

            _checkAllowedSize: function(w, h) {
                var maxSize = __WEBPACK_IMPORTED_MODULE_5_osg_WebGLCaps__["a" /* default */].instance().getWebGLParameter('MAX_RENDERBUFFER_SIZE');

                if (w === 0 || h === 0 || h > maxSize || w > maxSize) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
                        'width (' +
                            w +
                            ') or height (' +
                            w +
                            ') makes frame buffer not bindable. Max RenderBuffer is "' +
                            maxSize +
                            '"'
                    );
                    return false;
                }

                return true;
            },

            apply: function(state) {
                if (!this._gl) this.setGraphicContext(state.getGraphicContext());
                var gl = this._gl;

                var attachments = this._attachments;

                // ?
                if (attachments.length === 0 && !this._fbo) {
                    gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                    return;
                }

                // each frame
                if (!this.isDirty()) {
                    gl.bindFramebuffer(gl.FRAMEBUFFER, this._fbo);
                    if (__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].reportWebGLError === true) this.checkStatus();
                    return;
                }

                // if the fbo is created manually, we want to just bind it
                if (!this._fbo) this.createFrameBufferObject(state);

                this.bindFrameBufferObject();

                // Check extDrawBuffers extension
                var bufs = this._hasMRT ? this._buffers : undefined;
                var hasRenderBuffer = false;

                for (var i = 0, l = attachments.length; i < l; ++i) {
                    var attachment = attachments[i];

                    // render buffer
                    if (!attachment.texture) {
                        if (!this._checkAllowedSize(attachment.width, attachment.height)) {
                            this.releaseGLObjects();
                            return;
                        }
                        if (attachment.renderBufferObject) {
                            // shared renderbuffer object between camera
                            // ie: early-z
                            this._rbo = attachment.renderBufferObject;
                        } else {
                            this._rbo = this.createRenderBuffer(
                                attachment.format,
                                attachment.width,
                                attachment.height
                            );
                            // necessary for shared attachment between camera
                            attachment.renderBufferObject = this._rbo;
                        }
                        this.framebufferRenderBuffer(attachment.attachment, this._rbo);
                        hasRenderBuffer = true;
                    } else {
                        // use texture
                        var texture = attachment.texture;

                        if (!this._checkAllowedSize(texture.getWidth(), texture.getHeight())) {
                            this.releaseGLObjects();
                            return;
                        }

                        // Not sure is needed to check the attachment.attachment
                        if (
                            this._hasMRT &&
                            attachment.attachment >= gl.COLOR_ATTACHMENT0 &&
                            attachment.attachment <= gl.COLOR_ATTACHMENT15 &&
                            bufs.indexOf(attachment.attachment) === -1
                        ) {
                            bufs.push(attachment.attachment);
                        }

                        if (
                            !this.framebufferTexture2D(
                                state,
                                attachment.attachment,
                                attachment.textureTarget,
                                texture
                            )
                        ) {
                            this.releaseGLObjects();
                            return;
                        }
                    }
                }

                if (bufs && bufs.length > 0) {
                    gl.drawBuffers(bufs);
                }

                this.checkStatus();

                // set it to null only if used renderbuffer
                if (hasRenderBuffer) gl.bindRenderbuffer(gl.RENDERBUFFER, null);

                this._dirty = false;
            }
        })
    ),
    'osg',
    'FrameBufferObject'
);

/* harmony default export */ __webpack_exports__["a"] = (FrameBufferObject);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



var Depth = function(func, near, far, writeMask) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    this._func = Depth.LESS;
    this._near = 0.0;
    this._far = 1.0;
    this._writeMask = true;

    if (func !== undefined) {
        if (typeof func === 'string') {
            this._func = Depth[func];
        } else {
            this._func = func;
        }
    }
    if (near !== undefined) {
        this._near = near;
    }
    if (far !== undefined) {
        this._far = far;
    }
    if (writeMask !== undefined) {
        this._writeMask = writeMask;
    }
};

Depth.DISABLE = 0x0000;
Depth.NEVER = 0x0200;
Depth.LESS = 0x0201;
Depth.EQUAL = 0x0202;
Depth.LEQUAL = 0x0203;
Depth.GREATER = 0x0204;
Depth.NOTEQUAL = 0x0205;
Depth.GEQUAL = 0x0206;
Depth.ALWAYS = 0x0207;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Depth,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Depth',
        cloneType: function() {
            return new Depth();
        },
        setRange: function(near, far) {
            this._near = near;
            this._far = far;
        },
        setWriteMask: function(mask) {
            this._writeMask = mask;
        },
        getWriteMask: function() {
            return this._writeMask;
        },
        getFunc: function() {
            return this._func;
        },
        apply: function(state) {
            state.applyDepth(this);
        }
    }),
    'osg',
    'Depth'
);

/* harmony default export */ __webpack_exports__["a"] = (Depth);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


// Base class for GLResources: Textures, Buffers, Programs, Shaders, FrameBuffers and RenderBuffers
// It holds a reference to the graphic context that is needed for resource deletion
var GLObject = function() {
    this._gl = undefined;
    this._onLostContextCallback = undefined;
};

GLObject.prototype = {
    setGraphicContext: function(gl) {
        this._gl = gl;
        GLObject.addObject(this._gl, this);
    },
    getGraphicContext: function() {
        return this._gl;
    },
    setLostContextCallback: function(cb) {
        this._onLostContextCallback = cb;
    },
    onLostContext: function() {
        if (this.invalidate && typeof this.invalidate === 'function') {
            this.invalidate();
        }
        if (this._onLostContextCallback) this._onLostContextCallback();
    }
};

// handle webgl restore by indexing all GLObject
GLObject._sResourcesArrayCache = new window.Map();

GLObject.addObject = function(gl, glObject) {
    if (!GLObject._sResourcesArrayCache.has(gl)) GLObject._sResourcesArrayCache.set(gl, []);
    var resourcesArray = GLObject._sResourcesArrayCache.get(gl);

    if (resourcesArray.indexOf(glObject) !== -1) return;
    resourcesArray.push(glObject);
};

GLObject.removeObject = function(gl, glObject) {
    if (!GLObject._sResourcesArrayCache.has(gl)) return;

    var resourcesArray = GLObject._sResourcesArrayCache.get(gl);
    var i = resourcesArray.indexOf(glObject);
    if (i === -1) return;
    resourcesArray.splice(i, 1);
};

GLObject.onLostContext = function(gl) {
    if (!GLObject._sResourcesArrayCache.has(gl)) return;

    var resourcesArray = GLObject._sResourcesArrayCache.get(gl);
    for (var i = 0, l = resourcesArray.length; i < l; i++) {
        resourcesArray[i].onLostContext();
    }
};

/* harmony default export */ __webpack_exports__["a"] = (GLObject);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_utils__ = __webpack_require__(1);










/**
 * Create a Textured Box on the given center with given size
 * @name createTexturedBox
 */
var createTexturedBoxGeometry = function(cx, cy, cz, sx, sy, sz) {
    var centerx = cx !== undefined ? cx : 0.0;
    var centery = cy !== undefined ? cy : 0.0;
    var centerz = cz !== undefined ? cz : 0.0;

    var sizex = sx !== undefined ? sx : 1.0;
    var sizey = sy !== undefined ? sy : 1.0;
    var sizez = sz !== undefined ? sz : 1.0;

    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
    var dx, dy, dz;
    dx = sizex / 2.0;
    dy = sizey / 2.0;
    dz = sizez / 2.0;

    var vertexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(72);
    var uv = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(48);
    var normal = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(72);

    // -ve y plane
    vertexes[0] = centerx - dx;
    vertexes[1] = centery - dy;
    vertexes[2] = centerz + dz;
    normal[0] = 0.0;
    normal[1] = -1.0;
    normal[2] = 0.0;
    uv[0] = 0.0;
    uv[1] = 1.0;

    vertexes[3] = centerx - dx;
    vertexes[4] = centery - dy;
    vertexes[5] = centerz - dz;
    normal[3] = 0.0;
    normal[4] = -1.0;
    normal[5] = 0.0;
    uv[2] = 0.0;
    uv[3] = 0.0;

    vertexes[6] = centerx + dx;
    vertexes[7] = centery - dy;
    vertexes[8] = centerz - dz;
    normal[6] = 0.0;
    normal[7] = -1.0;
    normal[8] = 0.0;
    uv[4] = 1.0;
    uv[5] = 0.0;

    vertexes[9] = centerx + dx;
    vertexes[10] = centery - dy;
    vertexes[11] = centerz + dz;
    normal[9] = 0.0;
    normal[10] = -1.0;
    normal[11] = 0.0;
    uv[6] = 1.0;
    uv[7] = 1.0;

    // +ve y plane
    vertexes[12] = centerx + dx;
    vertexes[13] = centery + dy;
    vertexes[14] = centerz + dz;
    normal[12] = 0.0;
    normal[13] = 1.0;
    normal[14] = 0.0;
    uv[8] = 0.0;
    uv[9] = 1.0;

    vertexes[15] = centerx + dx;
    vertexes[16] = centery + dy;
    vertexes[17] = centerz - dz;
    normal[15] = 0.0;
    normal[16] = 1.0;
    normal[17] = 0.0;
    uv[10] = 0.0;
    uv[11] = 0.0;

    vertexes[18] = centerx - dx;
    vertexes[19] = centery + dy;
    vertexes[20] = centerz - dz;
    normal[18] = 0.0;
    normal[19] = 1.0;
    normal[20] = 0.0;
    uv[12] = 1.0;
    uv[13] = 0.0;

    vertexes[21] = centerx - dx;
    vertexes[22] = centery + dy;
    vertexes[23] = centerz + dz;
    normal[21] = 0.0;
    normal[22] = 1.0;
    normal[23] = 0.0;
    uv[14] = 1.0;
    uv[15] = 1.0;

    // +ve x plane
    vertexes[24] = centerx + dx;
    vertexes[25] = centery - dy;
    vertexes[26] = centerz + dz;
    normal[24] = 1.0;
    normal[25] = 0.0;
    normal[26] = 0.0;
    uv[16] = 0.0;
    uv[17] = 1.0;

    vertexes[27] = centerx + dx;
    vertexes[28] = centery - dy;
    vertexes[29] = centerz - dz;
    normal[27] = 1.0;
    normal[28] = 0.0;
    normal[29] = 0.0;
    uv[18] = 0.0;
    uv[19] = 0.0;

    vertexes[30] = centerx + dx;
    vertexes[31] = centery + dy;
    vertexes[32] = centerz - dz;
    normal[30] = 1.0;
    normal[31] = 0.0;
    normal[32] = 0.0;
    uv[20] = 1.0;
    uv[21] = 0.0;

    vertexes[33] = centerx + dx;
    vertexes[34] = centery + dy;
    vertexes[35] = centerz + dz;
    normal[33] = 1.0;
    normal[34] = 0.0;
    normal[35] = 0.0;
    uv[22] = 1.0;
    uv[23] = 1.0;

    // -ve x plane
    vertexes[36] = centerx - dx;
    vertexes[37] = centery + dy;
    vertexes[38] = centerz + dz;
    normal[36] = -1.0;
    normal[37] = 0.0;
    normal[38] = 0.0;
    uv[24] = 0.0;
    uv[25] = 1.0;

    vertexes[39] = centerx - dx;
    vertexes[40] = centery + dy;
    vertexes[41] = centerz - dz;
    normal[39] = -1.0;
    normal[40] = 0.0;
    normal[41] = 0.0;
    uv[26] = 0.0;
    uv[27] = 0.0;

    vertexes[42] = centerx - dx;
    vertexes[43] = centery - dy;
    vertexes[44] = centerz - dz;
    normal[42] = -1.0;
    normal[43] = 0.0;
    normal[44] = 0.0;
    uv[28] = 1.0;
    uv[29] = 0.0;

    vertexes[45] = centerx - dx;
    vertexes[46] = centery - dy;
    vertexes[47] = centerz + dz;
    normal[45] = -1.0;
    normal[46] = 0.0;
    normal[47] = 0.0;
    uv[30] = 1.0;
    uv[31] = 1.0;

    // top
    // +ve z plane
    vertexes[48] = centerx - dx;
    vertexes[49] = centery + dy;
    vertexes[50] = centerz + dz;
    normal[48] = 0.0;
    normal[49] = 0.0;
    normal[50] = 1.0;
    uv[32] = 0.0;
    uv[33] = 1.0;

    vertexes[51] = centerx - dx;
    vertexes[52] = centery - dy;
    vertexes[53] = centerz + dz;
    normal[51] = 0.0;
    normal[52] = 0.0;
    normal[53] = 1.0;
    uv[34] = 0.0;
    uv[35] = 0.0;

    vertexes[54] = centerx + dx;
    vertexes[55] = centery - dy;
    vertexes[56] = centerz + dz;
    normal[54] = 0.0;
    normal[55] = 0.0;
    normal[56] = 1.0;
    uv[36] = 1.0;
    uv[37] = 0.0;

    vertexes[57] = centerx + dx;
    vertexes[58] = centery + dy;
    vertexes[59] = centerz + dz;
    normal[57] = 0.0;
    normal[58] = 0.0;
    normal[59] = 1.0;
    uv[38] = 1.0;
    uv[39] = 1.0;

    // bottom
    // -ve z plane
    vertexes[60] = centerx + dx;
    vertexes[61] = centery + dy;
    vertexes[62] = centerz - dz;
    normal[60] = 0.0;
    normal[61] = 0.0;
    normal[62] = -1.0;
    uv[40] = 0.0;
    uv[41] = 1.0;

    vertexes[63] = centerx + dx;
    vertexes[64] = centery - dy;
    vertexes[65] = centerz - dz;
    normal[63] = 0.0;
    normal[64] = 0.0;
    normal[65] = -1.0;
    uv[42] = 0.0;
    uv[43] = 0.0;

    vertexes[66] = centerx - dx;
    vertexes[67] = centery - dy;
    vertexes[68] = centerz - dz;
    normal[66] = 0.0;
    normal[67] = 0.0;
    normal[68] = -1.0;
    uv[44] = 1.0;
    uv[45] = 0.0;

    vertexes[69] = centerx - dx;
    vertexes[70] = centery + dy;
    vertexes[71] = centerz - dz;
    normal[69] = 0.0;
    normal[70] = 0.0;
    normal[71] = -1.0;
    uv[46] = 1.0;
    uv[47] = 1.0;

    var indexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Uint16Array(36);
    indexes[0] = 0;
    indexes[1] = 1;
    indexes[2] = 2;
    indexes[3] = 0;
    indexes[4] = 2;
    indexes[5] = 3;

    indexes[6] = 4;
    indexes[7] = 5;
    indexes[8] = 6;
    indexes[9] = 4;
    indexes[10] = 6;
    indexes[11] = 7;

    indexes[12] = 8;
    indexes[13] = 9;
    indexes[14] = 10;
    indexes[15] = 8;
    indexes[16] = 10;
    indexes[17] = 11;

    indexes[18] = 12;
    indexes[19] = 13;
    indexes[20] = 14;
    indexes[21] = 12;
    indexes[22] = 14;
    indexes[23] = 15;

    indexes[24] = 16;
    indexes[25] = 17;
    indexes[26] = 18;
    indexes[27] = 16;
    indexes[28] = 18;
    indexes[29] = 19;

    indexes[30] = 20;
    indexes[31] = 21;
    indexes[32] = 22;
    indexes[33] = 20;
    indexes[34] = 22;
    indexes[35] = 23;

    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertexes, 3);
    g.getAttributes().Normal = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, normal, 3);
    g.getAttributes().TexCoord0 = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, uv, 2);

    var primitive = new __WEBPACK_IMPORTED_MODULE_5_osg_DrawElements__["a" /* default */](
        __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES,
        new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER, indexes, 1)
    );
    g.getPrimitives().push(primitive);
    return g;
};

// better perf
// no more pixel shader hurt for nothing
// http://michaldrobot.com/2014/04/01/gcn-execution-patterns-in-full-screen-passes/
// It's a Singleton, as it's rendering invariant
// so same remove uneeded state change when same geom
var createTexturedFullScreenFakeQuadGeometry = (function() {
    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();

    var vertexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array([4.0, -1.0, -1.0, 4.0, -1.0, -1.0]);
    var buffer = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertexes, 2);
    // Further optim: (uv.xy = position.xy in vertex shader)
    g.getAttributes().Vertex = buffer;
    g.getAttributes().TexCoord0 = buffer;

    var primitive = new __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES, 0, 3);
    g.getPrimitives().push(primitive);

    return function() {
        return g;
    };
})();

var createTexturedQuadGeometry = function(
    cornerx,
    cornery,
    cornerz,
    wx,
    wy,
    wz,
    hx,
    hy,
    hz,
    l,
    b,
    r,
    t
) {
    if (r === undefined && t === undefined) {
        r = l;
        t = b;
        l = 0.0;
        b = 0.0;
    }

    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();

    var vertexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(12);
    vertexes[0] = cornerx + hx;
    vertexes[1] = cornery + hy;
    vertexes[2] = cornerz + hz;

    vertexes[3] = cornerx;
    vertexes[4] = cornery;
    vertexes[5] = cornerz;

    vertexes[6] = cornerx + wx;
    vertexes[7] = cornery + wy;
    vertexes[8] = cornerz + wz;

    vertexes[9] = cornerx + wx + hx;
    vertexes[10] = cornery + wy + hy;
    vertexes[11] = cornerz + wz + hz;

    if (r === undefined) {
        r = 1.0;
    }
    if (t === undefined) {
        t = 1.0;
    }

    var uvs = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(8);
    uvs[0] = l;
    uvs[1] = t;

    uvs[2] = l;
    uvs[3] = b;

    uvs[4] = r;
    uvs[5] = b;

    uvs[6] = r;
    uvs[7] = t;

    var n = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].fromValues(wx, wy, wz);
    __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].cross(n, n, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].fromValues(hx, hy, hz));
    __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].normalize(n, n);

    var normal = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(12);
    normal[0] = n[0];
    normal[1] = n[1];
    normal[2] = n[2];

    normal[3] = n[0];
    normal[4] = n[1];
    normal[5] = n[2];

    normal[6] = n[0];
    normal[7] = n[1];
    normal[8] = n[2];

    normal[9] = n[0];
    normal[10] = n[1];
    normal[11] = n[2];

    var indexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Uint16Array(6);
    indexes[0] = 0;
    indexes[1] = 1;
    indexes[2] = 2;
    indexes[3] = 0;
    indexes[4] = 2;
    indexes[5] = 3;

    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertexes, 3);
    g.getAttributes().Normal = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, normal, 3);
    g.getAttributes().TexCoord0 = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, uvs, 2);

    var primitive = new __WEBPACK_IMPORTED_MODULE_5_osg_DrawElements__["a" /* default */](
        __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES,
        new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER, indexes, 1)
    );
    g.getPrimitives().push(primitive);
    return g;
};

var createAxisGeometry = function(size) {
    if (size === undefined) {
        size = 1.0;
    }
    if (createAxisGeometry.getShader === undefined) {
        createAxisGeometry.getShader = function() {
            if (createAxisGeometry.getShader.program === undefined) {
                var vertexshader = [
                    '#ifdef GL_ES',
                    'precision highp float;',
                    '#endif',
                    'attribute vec3 Vertex;',
                    'attribute vec4 Color;',
                    'uniform mat4 uModelViewMatrix;',
                    'uniform mat4 uProjectionMatrix;',
                    '',
                    'varying vec4 vColor;',
                    '',
                    'void main(void) {',
                    '  gl_Position = uProjectionMatrix * (uModelViewMatrix * vec4(Vertex, 1.0));',
                    '  vColor = Color;',
                    '}'
                ].join('\n');

                var fragmentshader = [
                    '#ifdef GL_ES',
                    'precision highp float;',
                    '#endif',
                    'varying vec4 vColor;',

                    'void main(void) {',
                    'gl_FragColor = vColor;',
                    '}'
                ].join('\n');

                var program = new __WEBPACK_IMPORTED_MODULE_6_osg_Program__["a" /* default */](
                    new __WEBPACK_IMPORTED_MODULE_7_osg_Shader__["a" /* default */]('VERTEX_SHADER', vertexshader),
                    new __WEBPACK_IMPORTED_MODULE_7_osg_Shader__["a" /* default */]('FRAGMENT_SHADER', fragmentshader)
                );
                createAxisGeometry.getShader.program = program;
            }
            return createAxisGeometry.getShader.program;
        };
    }

    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();

    var vertexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(18);
    vertexes[3] = size;
    vertexes[10] = size;
    vertexes[17] = size;

    var colors = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(24);
    //red color
    colors[0] = colors[3] = 1.0;
    colors[4] = colors[4 + 3] = 1.0;
    //green color
    colors[4 * 2 + 1] = colors[4 * 2 + 3] = 1.0;
    colors[4 * 3 + 1] = colors[4 * 3 + 3] = 1.0;
    //blue color
    colors[4 * 4 + 2] = colors[4 * 4 + 3] = 1.0;
    colors[4 * 5 + 2] = colors[4 * 5 + 3] = 1.0;

    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertexes, 3);
    g.getAttributes().Color = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, colors, 4);

    var primitive = new __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].LINES, 0, 6);
    g.getPrimitives().push(primitive);
    g.getOrCreateStateSet().setAttributeAndModes(createAxisGeometry.getShader());

    return g;
};

/**
 * Create a Textured Sphere on the given center with given radius
 * @name createTexturedSphere
 * @author Darrell Esau
 */
var createTexturedSphere = function(
    radius,
    widthSegments,
    heightSegments,
    phiStart,
    phiLength,
    thetaStart,
    thetaLength
) {
    radius = radius || 1.0;

    phiStart = phiStart !== undefined ? phiStart : 0.0;
    phiLength = phiLength !== undefined ? phiLength : Math.PI * 2;

    thetaStart = thetaStart !== undefined ? thetaStart : 0.0;
    thetaLength = thetaLength !== undefined ? thetaLength : Math.PI;

    var segmentsX = Math.max(3, Math.floor(widthSegments) || 8);
    var segmentsY = Math.max(2, Math.floor(heightSegments) || 6);

    var useDrawArrays = segmentsX * segmentsY / 3 >= 65536;
    var nbPrim = useDrawArrays ? segmentsX * segmentsY * 6 : segmentsX * segmentsY * 4;
    var fullVerticesList = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(nbPrim * 3);
    var fullNormalsList = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(nbPrim * 3);
    var fullUVList = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(nbPrim * 2);
    var indexes = !useDrawArrays ? new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Uint16Array(segmentsX * segmentsY * 6) : undefined;
    var vtxCount = 0;
    var triCount = 0;

    var v1 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var v2 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var v3 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var v4 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var n1 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var n2 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var n3 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var n4 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(3);
    var uv1 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(2);
    var uv2 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(2);
    var uv3 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(2);
    var uv4 = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(2);
    var getCoordAndUvSphere = function(u, v, coord, norm, uv) {
        coord[0] =
            -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        coord[1] = radius * Math.cos(thetaStart + v * thetaLength);
        coord[2] =
            radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].normalize(norm, coord);
        uv[0] = u;
        uv[1] = 1 - v;
    };
    for (var y = 0; y < segmentsY; y++) {
        for (var x = 0; x < segmentsX; x++) {
            getCoordAndUvSphere((x + 1) / segmentsX, y / segmentsY, v1, n1, uv1);
            getCoordAndUvSphere(x / segmentsX, y / segmentsY, v2, n2, uv2);
            getCoordAndUvSphere(x / segmentsX, (y + 1) / segmentsY, v3, n3, uv3);
            getCoordAndUvSphere((x + 1) / segmentsX, (y + 1) / segmentsY, v4, n4, uv4);

            var idv = vtxCount * 3;
            fullVerticesList[idv] = v1[0];
            fullVerticesList[idv + 1] = v1[1];
            fullVerticesList[idv + 2] = v1[2];
            fullVerticesList[idv + 3] = v2[0];
            fullVerticesList[idv + 4] = v2[1];
            fullVerticesList[idv + 5] = v2[2];
            fullVerticesList[idv + 6] = v3[0];
            fullVerticesList[idv + 7] = v3[1];
            fullVerticesList[idv + 8] = v3[2];

            fullNormalsList[idv] = n1[0];
            fullNormalsList[idv + 1] = n1[1];
            fullNormalsList[idv + 2] = n1[2];
            fullNormalsList[idv + 3] = n2[0];
            fullNormalsList[idv + 4] = n2[1];
            fullNormalsList[idv + 5] = n2[2];
            fullNormalsList[idv + 6] = n3[0];
            fullNormalsList[idv + 7] = n3[1];
            fullNormalsList[idv + 8] = n3[2];

            var idu = vtxCount * 2;
            fullUVList[idu] = uv1[0];
            fullUVList[idu + 1] = uv1[1];
            fullUVList[idu + 2] = uv2[0];
            fullUVList[idu + 3] = uv2[1];
            fullUVList[idu + 4] = uv3[0];
            fullUVList[idu + 5] = uv3[1];

            vtxCount += 3;
            if (useDrawArrays) {
                idv = vtxCount * 3;
                fullVerticesList[idv] = v1[0];
                fullVerticesList[idv + 1] = v1[1];
                fullVerticesList[idv + 2] = v1[2];
                fullVerticesList[idv + 3] = v3[0];
                fullVerticesList[idv + 4] = v3[1];
                fullVerticesList[idv + 5] = v3[2];
                fullVerticesList[idv + 6] = v4[0];
                fullVerticesList[idv + 7] = v4[1];
                fullVerticesList[idv + 8] = v4[2];

                fullNormalsList[idv] = n1[0];
                fullNormalsList[idv + 1] = n1[1];
                fullNormalsList[idv + 2] = n1[2];
                fullNormalsList[idv + 3] = n3[0];
                fullNormalsList[idv + 4] = n3[1];
                fullNormalsList[idv + 5] = n3[2];
                fullNormalsList[idv + 6] = n4[0];
                fullNormalsList[idv + 7] = n4[1];
                fullNormalsList[idv + 8] = n4[2];

                idu = vtxCount * 2;
                fullUVList[idu] = uv1[0];
                fullUVList[idu + 1] = uv1[1];
                fullUVList[idu + 2] = uv3[0];
                fullUVList[idu + 3] = uv3[1];
                fullUVList[idu + 4] = uv4[0];
                fullUVList[idu + 5] = uv4[1];
                vtxCount += 3;
            } else {
                idv = vtxCount * 3;
                fullVerticesList[idv] = v4[0];
                fullVerticesList[idv + 1] = v4[1];
                fullVerticesList[idv + 2] = v4[2];

                fullNormalsList[idv] = n4[0];
                fullNormalsList[idv + 1] = n4[1];
                fullNormalsList[idv + 2] = n4[2];

                idu = vtxCount * 2;
                fullUVList[idu] = uv4[0];
                fullUVList[idu + 1] = uv4[1];

                var iStart = triCount * 3;
                var tristart = vtxCount - 3;
                indexes[iStart] = tristart;
                indexes[iStart + 1] = tristart + 1;
                indexes[iStart + 2] = tristart + 2;
                indexes[iStart + 3] = tristart;
                indexes[iStart + 4] = tristart + 2;
                indexes[iStart + 5] = tristart + 3;
                triCount += 2;
                vtxCount += 1;
            }
        }
    }

    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ARRAY_BUFFER', fullVerticesList, 3);
    g.getAttributes().Normal = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ARRAY_BUFFER', fullNormalsList, 3);
    g.getAttributes().TexCoord0 = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ARRAY_BUFFER', fullUVList, 2);

    if (useDrawArrays)
        g
            .getPrimitives()
            .push(new __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES, 0, fullVerticesList.length / 3));
    else
        g
            .getPrimitives()
            .push(
                new __WEBPACK_IMPORTED_MODULE_5_osg_DrawElements__["a" /* default */](
                    __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES,
                    new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ELEMENT_ARRAY_BUFFER', indexes, 1)
                )
            );
    return g;
};

var createGridGeometry = function(cx, cy, cz, wx, wy, wz, hx, hy, hz, res1, res2) {
    cx = cx !== undefined ? cx : -0.5;
    cy = cy !== undefined ? cy : -0.5;
    cz = cz !== undefined ? cz : 0.0;

    wx = wx !== undefined ? wx : 1.0;
    wy = wy !== undefined ? wy : 0.0;
    wz = wz !== undefined ? wz : 0.0;

    hx = hx !== undefined ? hx : 0.0;
    hy = hy !== undefined ? hy : 1.0;
    hz = hz !== undefined ? hz : 0.0;

    res1 = res1 !== undefined ? res1 : 5;
    res2 = res2 !== undefined ? res2 : res1;
    res1 += 2;
    res2 += 2;

    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
    var vertices = new Float32Array((res1 + res2) * 2 * 3);
    var i = 0;
    var j = 0;
    var sx = wx / (res1 - 1);
    var sy = wy / (res1 - 1);
    var sz = wz / (res1 - 1);
    var ux = cx + wx + hx;
    var uy = cy + wy + hy;
    var uz = cz + wz + hz;
    for (i = 0; i < res1; ++i) {
        j = i * 6;
        vertices[j] = cx + sx * i;
        vertices[j + 1] = cy + sy * i;
        vertices[j + 2] = cz + sz * i;
        vertices[j + 3] = ux - sx * (res1 - i - 1);
        vertices[j + 4] = uy - sy * (res1 - i - 1);
        vertices[j + 5] = uz - sz * (res1 - i - 1);
    }
    sx = hx / (res2 - 1);
    sy = hy / (res2 - 1);
    sz = hz / (res2 - 1);
    for (i = 0; i < res2; ++i) {
        j = (res1 + i) * 6;
        vertices[j] = cx + sx * i;
        vertices[j + 1] = cy + sy * i;
        vertices[j + 2] = cz + sz * i;
        vertices[j + 3] = ux - sx * (res2 - i - 1);
        vertices[j + 4] = uy - sy * (res2 - i - 1);
        vertices[j + 5] = uz - sz * (res2 - i - 1);
    }
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);
    var primitive = new __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].LINES, 0, (res1 + res2) * 2);
    g.getPrimitives().push(primitive);
    return g;
};

/*
 * debug lines showing bounding box abstraction
 * @param col bbox color
 */
var createBoundingBoxGeometry = function(col) {
    var g = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
    //unit cube centered on 0
    var vertices = new Float32Array([
        -0.5,
        -0.5,
        -0.5,
        0.5,
        -0.5,
        -0.5,
        0.5,
        0.5,
        -0.5,
        -0.5,
        0.5,
        -0.5,
        -0.5,
        -0.5,
        0.5,
        0.5,
        -0.5,
        0.5,
        0.5,
        0.5,
        0.5,
        -0.5,
        0.5,
        0.5
    ]);
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);

    // use color or red
    if (!col) col = [1.0, 0.0, 0.0, 1.0];
    var colors = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Float32Array(8 * 4);
    for (var i = 0; i < 8; i++) {
        for (var k = 0; k < 4; k++) {
            colors[i * 3 + k] = col[k];
        }
    }

    g.getAttributes().Color = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, colors, 4);

    var indexes = new __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].Uint16Array([
        //up
        0,
        1,
        1,
        2,
        2,
        3,
        3,
        0,
        //down
        4,
        5,
        5,
        6,
        6,
        7,
        7,
        4,
        // side
        0,
        4,
        1,
        5,
        2,
        6,
        3,
        7
    ]);

    g
        .getPrimitives()
        .push(
            new __WEBPACK_IMPORTED_MODULE_5_osg_DrawElements__["a" /* default */](
                __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].LINES,
                new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ELEMENT_ARRAY_BUFFER', indexes, 1)
            )
        );

    return g;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    createTexturedBoxGeometry: createTexturedBoxGeometry,
    createTexturedQuadGeometry: createTexturedQuadGeometry,
    createTexturedSphereGeometry: createTexturedSphere,
    createTexturedFullScreenFakeQuadGeometry: createTexturedFullScreenFakeQuadGeometry,
    createAxisGeometry: createAxisGeometry,
    createTexturedSphere: createTexturedSphere,
    createGridGeometry: createGridGeometry,
    createBoundingBoxGeometry: createBoundingBoxGeometry
});


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channelType__ = __webpack_require__(125);





var target = {};
target.InvalidTargetID = -1;

// defaultValue is used when no channels affect the value
var createTarget = function(type, value, defaultValue) {
    return {
        type: type,
        id: target.InvalidTargetID, // -1 means no id assigned yet
        channels: [],
        value: value,
        defaultValue: defaultValue
    };
};

var createQuatTarget = function(defaultValue) {
    return createTarget(
        __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channelType__["a" /* default */].Quat,
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create(), defaultValue),
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create(), defaultValue)
    );
};

var createMatrixTarget = function(defaultValue) {
    return createTarget(
        __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channelType__["a" /* default */].Matrix,
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), defaultValue),
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), defaultValue)
    );
};

var createVec3Target = function(defaultValue) {
    return createTarget(
        __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channelType__["a" /* default */].Vec3,
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create(), defaultValue),
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].copy(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create(), defaultValue)
    );
};

var createFloatTarget = function(defaultValue) {
    return createTarget(__WEBPACK_IMPORTED_MODULE_1_osgAnimation_channelType__["a" /* default */].Float, defaultValue, defaultValue);
};

target.createQuatTarget = createQuatTarget;
target.createVec3Target = createVec3Target;
target.createFloatTarget = createFloatTarget;
target.createMatrixTarget = createMatrixTarget;

/* harmony default export */ __webpack_exports__["a"] = (target);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BufferArrayProxy__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgAnimation_MorphAttribute__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_BoundingBox__ = __webpack_require__(26);










/**
 * MorphGeometry manage up to MorphGeometry.MAX_MORPH_GPU morphTargets
 * @class MorphGeometry
 * @inherits Geometry
 */

var MorphGeometry = function() {
    __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__["a" /* default */].call(this);

    this._shape = null; // by default no kdtree/shape for morph

    this._targets = []; // Target list (Geometry)
    this._stateSetAnimation = new __WEBPACK_IMPORTED_MODULE_5_osg_StateSet__["a" /* default */](); // StateSet to handle morphAttribute
    this._targetWeights = new Float32Array(MorphGeometry.MAX_MORPH_GPU); // Fixed length array feed by UpdateMorph

    this._morphAttribute = undefined;
    this._morphTargetNames = undefined;

    this._maxMorphGPU = MorphGeometry.MAX_MORPH_GPU; // used by updateMorph to limit the number of morphed attributes done by the gpu

    this._isInitialized = false;
};

// sync with UpdateMorph
MorphGeometry.EFFECTIVE_EPS = 0.05;

// this should be constant, if you change it only do it at parse time, otherwise it's better to call setMaximumPossibleMorphGPU
MorphGeometry.MAX_MORPH_GPU = 4;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    MorphGeometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osg_Geometry__["a" /* default */].prototype, {
        init: function() {
            if (this._morphAttribute) {
                this._isInitialized = true;
                return false;
            }

            this._morphAttribute = new __WEBPACK_IMPORTED_MODULE_6_osgAnimation_MorphAttribute__["a" /* default */](
                Math.min(this._maxMorphGPU, this.getMorphTargets().length)
            );
            this.getStateSetAnimation().setAttributeAndModes(
                this._morphAttribute,
                __WEBPACK_IMPORTED_MODULE_7_osg_StateAttribute__["a" /* default */].ON
            );
            this._morphAttribute.setTargetWeights(this.getTargetsWeight());

            if (this._targets[0]) {
                this._morphTargetNames = window.Object.keys(
                    this._targets[0].getVertexAttributeList()
                );
                this._morphAttribute.copyTargetNames(this._morphTargetNames);
            } else {
                this._morphTargetNames = [];
                __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].error('No Targets in the MorphGeometry !');
            }

            this._isInitialized = true;
            return true;
        },

        getMaximumPossibleMorphGPU: function() {
            return this._maxMorphGPU;
        },

        setMaximumPossibleMorphGPU: function(nb) {
            this._maxMorphGPU = nb;
            this._isInitialized = false; // it's mostly UpdateMorph that we want to dirty
            if (this._morphAttribute) this._morphAttribute.setNumTargets(nb);
        },

        getMorphTargetNames: function() {
            return this._morphTargetNames;
        },

        getStateSetAnimation: function() {
            return this._stateSetAnimation;
        },

        getMorphTargets: function() {
            return this._targets;
        },

        isInitialized: function() {
            return this._isInitialized;
        },

        getTargetsWeight: function() {
            return this._targetWeights;
        },

        computeBoundingBox: (function() {
            var tmpBox = new __WEBPACK_IMPORTED_MODULE_8_osg_BoundingBox__["a" /* default */]();

            return function(boundingBox) {
                __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__["a" /* default */].prototype.computeBoundingBox.call(this, boundingBox);

                // expand bb with targets
                // Note : if the morphs have many many targets it can be done more smartly in
                // the UpdateMorph on each frame by just taking into account the "active morphs"
                for (var i = 0, l = this._targets.length; i < l; i++) {
                    boundingBox.expandByBoundingBox(this._targets[i].computeBoundingBox(tmpBox));
                }

                return boundingBox;
            };
        })(),

        mergeChildrenVertexAttributeList: function() {
            for (var i = 0, l = this._targets.length; i < l; i++) {
                var target = this._targets[i];

                // change BufferArray to BufferArrayProxy
                var attributeList = target.getVertexAttributeList();
                for (var keyAttribute in attributeList) {
                    var att = attributeList[keyAttribute];
                    // check it's a buffer array before swtiching to proxy
                    if (att && !att.getBufferArray) {
                        attributeList[keyAttribute] = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArrayProxy__["a" /* default */](att);
                    }
                }

                __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__["a" /* default */].appendVertexAttributeToList(
                    target.getVertexAttributeList(),
                    this.getVertexAttributeList(),
                    i
                );
            }
        },

        _computeEffectiveSumWeights: function() {
            var sum = 0.0;
            var weights = this._targetWeights;
            for (var i = 0, nb = weights.length; i < nb; ++i) {
                var weight = weights[i];
                if (Math.abs(weight) <= MorphGeometry.EFFECTIVE_EPS) continue;

                sum += weight;
            }
            var eps = 1e-5;
            if (Math.abs(sum) > eps) return sum;
            return sum < 0.0 ? -eps : eps;
        },

        computeTransformedVertex: function(id, out) {
            out = out || __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();

            var id3 = id * 3;

            var weights = this._targetWeights;
            var vList = this.getVertexAttributeList();

            var baseVerts = vList.Vertex.getElements();

            var sumWeights = 1.0 - this._computeEffectiveSumWeights();
            out[0] = sumWeights * baseVerts[id3];
            out[1] = sumWeights * baseVerts[id3 + 1];
            out[2] = sumWeights * baseVerts[id3 + 2];

            for (var j = 0, nb = weights.length; j < nb; ++j) {
                var weight = weights[j];
                if (Math.abs(weight) <= MorphGeometry.EFFECTIVE_EPS) continue;

                var morphElts = vList['Vertex_' + j].getElements();
                out[0] += weight * morphElts[id3];
                out[1] += weight * morphElts[id3 + 1];
                out[2] += weight * morphElts[id3 + 2];
            }

            return out;
        },

        computeTransformedVertices: function() {
            var weights = this._targetWeights;
            var vList = this.getVertexAttributeList();

            var baseVerts = vList.Vertex.getElements();
            var vertexLen = baseVerts.length;

            var morphedVerts = (this._morphedVerts =
                this._morphedVerts || new Float32Array(vertexLen));

            // base vertex influence
            var baseWeight = 1.0 - this._computeEffectiveSumWeights();
            for (var i = 0; i < vertexLen; ++i) {
                morphedVerts[i] = baseWeight * baseVerts[i];
            }

            for (var j = 0, nb = weights.length; j < nb; ++j) {
                var weight = weights[j];
                if (Math.abs(weight) <= MorphGeometry.EFFECTIVE_EPS) continue;

                // important : we should not take getInitialBufferArray as we should take the partially computed cpu morph from UpdateMorph
                var morphElts = vList['Vertex_' + j].getElements();
                for (var k = 0; k < vertexLen; ++k) {
                    morphedVerts[k] += weight * morphElts[k];
                }
            }

            return morphedVerts;
        }
    }),
    'osgAnimation',
    'MorphGeometry'
);

/* harmony default export */ __webpack_exports__["a"] = (MorphGeometry);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);





var Viewport = function(x, y, w, h) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    this._x = x !== undefined ? x : 0;
    this._y = y !== undefined ? y : 0;
    this._width = w !== undefined ? w : 800;
    this._height = h !== undefined ? h : 600;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Viewport,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Viewport',

        cloneType: function() {
            return new Viewport();
        },

        setViewport: function(x, y, width, height) {
            this._x = x;
            this._y = y;
            this._width = width;
            this._height = height;
        },

        x: function() {
            return this._x;
        },

        y: function() {
            return this._y;
        },

        width: function() {
            return this._width;
        },

        height: function() {
            return this._height;
        },

        computeWindowMatrix: (function() {
            var translate = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
            var scale = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
            var tmpVec = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();

            return function(destination) {
                // res = Matrix offset * Matrix scale * Matrix translate
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(translate, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].ONE);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromScaling(scale, [0.5 * this._width, 0.5 * this._height, 0.5]);
                var offset = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(
                    destination,
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].set(tmpVec, this._x, this._y, 0.0)
                );

                return __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(offset, offset, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(scale, scale, translate));
            };
        })(),

        apply: function(state) {
            state.applyViewport(this);
        }
    }),
    'osg',
    'Viewport'
);

/* harmony default export */ __webpack_exports__["a"] = (Viewport);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_Projection__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgDB_Registry__ = __webpack_require__(52);
















var ReaderParser = {};

ReaderParser.ObjectWrapper = {};
ReaderParser.ObjectWrapper.serializers = {};

ReaderParser.readImage = function(url, options) {
    return ReaderParser.registry().readImageURL(url, options);
};
ReaderParser.readImageURL = ReaderParser.readImage; // alias

ReaderParser.readBinaryArrayURL = function(url, options) {
    return ReaderParser.registry().readBinaryArrayURL(url, options);
};

ReaderParser.readNodeURL = function(url, options) {
    var extension = url.substr(url.lastIndexOf('.') + 1);
    var readerWriter = __WEBPACK_IMPORTED_MODULE_14_osgDB_Registry__["a" /* default */].instance().getReaderWriterForExtension(extension);
    if (readerWriter !== undefined) return readerWriter.readNodeURL(url, options);
    // If we don't have a registered plugin go through the osgjs
    // FIXME: we should have osgjs also as a plugin in the future
    return ReaderParser.registry().readNodeURL(url, options);
};

ReaderParser.registry = function() {
    var Input = __webpack_require__(88).default;
    if (ReaderParser.registry._input === undefined) {
        ReaderParser.registry._input = new Input();
    }
    return ReaderParser.registry._input;
};

ReaderParser.parseSceneGraph = function(node, options) {
    if (node.Version !== undefined && node.Version > 0) {
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].time('osgjs.metric:ReaderParser.parseSceneGraph', __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);

        var key;
        for (var prop in node) {
            if (prop !== 'Generator' && prop !== 'Version') {
                key = prop;
                break;
            }
        }

        if (key) {
            var obj = {};
            obj[key] = node[key];
            var input = ReaderParser.registry().clone();
            input.setJSON(obj);

            // copy global options and override with user options
            var opt = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix(
                __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix({}, ReaderParser.registry().getOptions()),
                options || {}
            );
            input.setOptions(opt);
            var object = input.readObject();
            __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeEnd('osgjs.metric:ReaderParser.parseSceneGraph', __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);
            return object;
        } else {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log("can't parse scenegraph " + node, __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);
        }
    } else {
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].time('osgjs.metric:ReaderParser.parseSceneGraphDeprecated', __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);
        var nodeOld = ReaderParser.parseSceneGraphDeprecated(node);
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeEnd('osgjs.metric:ReaderParser.parseSceneGraphDeprecated', __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);
        return nodeOld;
    }
    return undefined;
};

ReaderParser.parseSceneGraphDeprecated = function(node) {
    var getFieldBackwardCompatible = function(field, json) {
        var value = json[field];
        if (value === undefined) {
            value = json[field.toLowerCase()];
        }
        return value;
    };
    var setName = function(osgjs, json) {
        var name = getFieldBackwardCompatible('Name', json);
        if (name && osgjs.setName !== undefined) {
            osgjs.setName(name);
        }
    };

    var setMaterial = function(osgjs, json) {
        setName(osgjs, json);
        osgjs.setAmbient(getFieldBackwardCompatible('Ambient', json));
        osgjs.setDiffuse(getFieldBackwardCompatible('Diffuse', json));
        osgjs.setEmission(getFieldBackwardCompatible('Emission', json));
        osgjs.setSpecular(getFieldBackwardCompatible('Specular', json));
        osgjs.setShininess(getFieldBackwardCompatible('Shininess', json));
    };

    var setBlendFunc = function(osgjs, json) {
        setName(osgjs, json);
        osgjs.setSourceRGB(json.SourceRGB);
        osgjs.setSourceAlpha(json.SourceAlpha);
        osgjs.setDestinationRGB(json.DestinationRGB);
        osgjs.setDestinationAlpha(json.DestinationAlpha);
    };

    var setTexture = function(osgjs, json) {
        var magFilter = json.MagFilter || json['mag_filter'] || undefined;
        if (magFilter) {
            osgjs.setMagFilter(magFilter);
        }
        var minFilter = json.MinFilter || json['min_filter'] || undefined;
        if (minFilter) {
            osgjs.setMinFilter(minFilter);
        }
        var wrapT = json.WrapT || json['wrap_t'] || undefined;
        if (wrapT) {
            osgjs.setWrapT(wrapT);
        }
        var wrapS = json.WrapS || json['wrap_s'] || undefined;
        if (wrapS) {
            osgjs.setWrapS(wrapS);
        }
        var file = getFieldBackwardCompatible('File', json);
        ReaderParser.readImage(file)
            .then(function(img) {
                osgjs.setImage(img);
            })
            .catch(function() {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log("Can't read image");
            });
    };

    var setStateSet = function(osgjs, json) {
        setName(osgjs, json);
        var textures =
            getFieldBackwardCompatible('Textures', json) ||
            getFieldBackwardCompatible('TextureAttributeList', json) ||
            undefined;
        if (textures) {
            for (var t = 0, tl = textures.length; t < tl; t++) {
                var file = getFieldBackwardCompatible('File', textures[t]);
                if (!file) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('no texture on unit ' + t + ' skip it');
                    continue;
                }
                var Texture = __webpack_require__(7).default;
                var tex = new Texture();
                setTexture(tex, textures[t]);

                osgjs.setTextureAttributeAndModes(t, tex);
                osgjs.addUniform(__WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createInt1(t, 'Texture' + t));
            }
        }

        var blendfunc = getFieldBackwardCompatible('BlendFunc', json);
        if (blendfunc) {
            var newblendfunc = new __WEBPACK_IMPORTED_MODULE_3_osg_BlendFunc__["a" /* default */]();
            setBlendFunc(newblendfunc, blendfunc);
            osgjs.setAttributeAndModes(newblendfunc);
        }

        var material = getFieldBackwardCompatible('Material', json);
        if (material) {
            var Material = __webpack_require__(84).default;
            var newmaterial = new Material();
            setMaterial(newmaterial, material);
            osgjs.setAttributeAndModes(newmaterial);
        }
    };

    var newnode;
    var children = node.children;
    var primitives = node._primitives || node.primitives || node.Primitives || undefined;
    var attributes = node._attributes || node.attributes || node.Attributes || undefined;
    if (primitives || attributes) {
        var geom = new __WEBPACK_IMPORTED_MODULE_4_osg_Geometry__["a" /* default */]();
        setName(geom, node);
        geom.stateset = node.stateset;
        node = geom;

        for (var p = 0, lp = primitives.length; p < lp; p++) {
            var mode = primitives[p].mode;
            if (primitives[p].indices) {
                var array = primitives[p].indices;
                array = new __WEBPACK_IMPORTED_MODULE_5_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_BufferArray__["a" /* default */][array.type], array.elements, array.itemSize);
                if (!mode) {
                    mode = 'TRIANGLES';
                } else {
                    mode = __WEBPACK_IMPORTED_MODULE_6_osg_primitiveSet__["a" /* default */][mode];
                }
                geom.getPrimitiveSetList().push(new __WEBPACK_IMPORTED_MODULE_8_osg_DrawElements__["a" /* default */](mode, array));
            } else {
                mode = __WEBPACK_IMPORTED_MODULE_6_osg_primitiveSet__["a" /* default */][mode];
                var first = primitives[p].first;
                var count = primitives[p].count;

                geom.getPrimitiveSetList().push(new __WEBPACK_IMPORTED_MODULE_7_osg_DrawArrays__["a" /* default */](mode, first, count));
            }
        }

        for (var attr in attributes) {
            var attributeArray = attributes[attr];
            geom.getVertexAttributeList()[attr] = new __WEBPACK_IMPORTED_MODULE_5_osg_BufferArray__["a" /* default */](
                attributeArray.type,
                attributeArray.elements,
                attributeArray.itemSize
            );
        }
    }

    var stateset = getFieldBackwardCompatible('StateSet', node);
    if (stateset) {
        var newstateset = new __WEBPACK_IMPORTED_MODULE_9_osg_StateSet__["a" /* default */]();
        setStateSet(newstateset, stateset);
        node.stateset = newstateset;
    }

    var matrix = node.matrix || node.Matrix || undefined;
    if (matrix) {
        newnode = new __WEBPACK_IMPORTED_MODULE_12_osg_MatrixTransform__["a" /* default */]();
        setName(newnode, node);

        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].extend(newnode, node);
        __WEBPACK_IMPORTED_MODULE_11_osg_glMatrix__["c" /* mat4 */].copy(newnode.getMatrix(), matrix);
        node = newnode;
    }

    var projection = node.projection || node.Projection || undefined;
    if (projection) {
        newnode = new __WEBPACK_IMPORTED_MODULE_13_osg_Projection__["a" /* default */]();
        setName(newnode, node);
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].extend(newnode, node);
        __WEBPACK_IMPORTED_MODULE_11_osg_glMatrix__["c" /* mat4 */].copy(newnode.setProjectionMatrix(), projection);
        node = newnode;
    }

    // default type
    if (node.typeID === undefined) {
        newnode = new __WEBPACK_IMPORTED_MODULE_10_osg_Node__["a" /* default */]();
        setName(newnode, node);
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].extend(newnode, node);
        node = newnode;
    }

    if (children) {
        // disable children, it will be processed in the end
        node.children = [];

        for (var child = 0, childLength = children.length; child < childLength; child++) {
            node.addChild(ReaderParser.parseSceneGraphDeprecated(children[child]));
        }
    }

    return node;
};

/* harmony default export */ __webpack_exports__["default"] = (ReaderParser);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var clamp = function(x, min, max) {
    // http://jsperf.com/math-clamp
    // http://jsperf.com/clamping-methods/2
    return Math.min(max, Math.max(min, x));
};

var smoothStep = function(edge0, edge1, x) {
    if (x <= edge0) return 0.0;
    if (x >= edge1) return 1.0;
    var y = (x - edge0) / (edge1 - edge0);
    return y * y * (3.0 - 2.0 * y);
};

// native isNaN is slow (e.g: https://jsperf.com/isnan-performance/2)
// note : native isNaN will return true for undefined but
// this function assume that x is a number
var fastIsNaN = function(x) {
    return x !== x;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    clamp: clamp,
    smoothStep: smoothStep,
    isNaN: fastIsNaN
});


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);





var BoundingSphere = function() {
    this._center = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
    this._radius = -1.0;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    BoundingSphere,
    {
        init: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].init(this._center);
            this._radius = -1.0;
        },

        valid: function() {
            return this._radius >= 0.0;
        },

        set: function(center, radius) {
            this._center = center;
            this._radius = radius;
        },

        center: function() {
            return this._center;
        },

        radius: function() {
            return this._radius;
        },

        radius2: function() {
            return this._radius * this._radius;
        },

        volume: function() {
            var r = this._radius;
            return r * r * r * Math.PI * 4 / 3;
        },

        copy: function(other) {
            this._radius = other._radius;
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(this._center, other._center);
        },

        copyBoundingBox: function(box) {
            box.center(this._center);
            this._radius = box.radius();
        },

        expandByBoundingBox: (function() {
            var v = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var newbb = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();

            return function(bb) {
                if (!bb.valid()) return;

                if (!this.valid()) {
                    this.copyBoundingBox(bb);
                    return;
                }

                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(newbb._min, bb._min);
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(newbb._max, bb._max);

                for (var i = 0; i < 8; i++) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sub(v, bb.corner(i, v), this._center); // get the direction vector from corner
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].normalize(v, v); // normalise it.
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(v, this._center, v, -this._radius); // move the vector in the opposite direction distance radius.
                    newbb.expandByVec3(v); // add it into the new bounding box.
                }

                newbb.center(this._center);
                this._radius = newbb.radius();
            };
        })(),

        expandByvec3: function(v) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('deprecated, use expandByVec3');
            this.expandByVec3(v);
        },

        expandByVec3: (function() {
            var dv = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            return function(v) {
                if (this.valid()) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sub(dv, v, this.center(dv));
                    var r = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].length(dv);
                    if (r > this.radius()) {
                        var dr = (r - this.radius()) * 0.5;
                        this._center[0] += dv[0] * (dr / r);
                        this._center[1] += dv[1] * (dr / r);
                        this._center[2] += dv[2] * (dr / r);
                        this._radius += dr;
                    }
                } else {
                    this._center[0] = v[0];
                    this._center[1] = v[1];
                    this._center[2] = v[2];
                    this._radius = 0.0;
                }
            };
        })(),

        expandRadiusBySphere: function(sh) {
            if (sh.valid()) {
                if (this.valid()) {
                    var r = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].distance(this._center, sh._center) + sh._radius;
                    if (r > this._radius) {
                        this._radius = r;
                    }
                    // else do nothing as vertex is within sphere.
                } else {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(this._center, sh._center);
                    this._radius = sh._radius;
                }
            }
        },

        expandByBoundingSphere: function(sh) {
            // ignore operation if incomming BoundingSphere is invalid.
            if (!sh.valid()) {
                return;
            }

            // This sphere is not set so use the inbound sphere
            if (!this.valid()) {
                this._center[0] = sh._center[0];
                this._center[1] = sh._center[1];
                this._center[2] = sh._center[2];
                this._radius = sh.radius();

                return;
            }

            // Calculate d == The distance between the sphere centers
            var d = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].distance(sh.center(), this.center());

            // New sphere is already inside this one
            if (d + sh.radius() <= this.radius()) {
                return;
            }

            //  New sphere completely contains this one
            if (d + this.radius() <= sh.radius()) {
                this._center[0] = sh._center[0];
                this._center[1] = sh._center[1];
                this._center[2] = sh._center[2];
                this._radius = sh._radius;
                return;
            }

            // Build a new sphere that completely contains the other two:
            //
            // The center point lies halfway along the line between the furthest
            // points on the edges of the two spheres.
            //
            // Computing those two points is ugly - so we'll use similar triangles
            var newRadius = (this.radius() + d + sh.radius()) * 0.5;
            var ratio = (newRadius - this.radius()) / d;

            this._center[0] += (sh._center[0] - this._center[0]) * ratio;
            this._center[1] += (sh._center[1] - this._center[1]) * ratio;
            this._center[2] += (sh._center[2] - this._center[2]) * ratio;

            this._radius = newRadius;
        },
        contains: function(v) {
            if (!this.valid()) return false;
            return __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sqrDist(this.center(), v) <= this.radius2();
        },
        intersects: function(bs) {
            if (!this.valid() || !bs.valid()) return false;
            var r = this.radius() + bs.radius();
            return __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sqrDist(bs.center(), this.center()) <= r * r;
        },

        transformMat4: (function() {
            var scaleVec = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            return function(out, matrix) {
                if (!this.valid()) return out;

                if (out._center !== this._center) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(out._center, this._center);
                    out._radius = this._radius;
                }
                var sphCenter = out._center;
                var sphRadius = out._radius;

                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].getSqrScale(scaleVec, matrix);
                var scale = Math.sqrt(Math.max(Math.max(scaleVec[0], scaleVec[1]), scaleVec[2]));
                sphRadius = sphRadius * scale;
                out._radius = sphRadius;
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].transformMat4(sphCenter, sphCenter, matrix);

                return out;
            };
        })()
    },
    'osg',
    'BoundingSphere'
);

/* harmony default export */ __webpack_exports__["a"] = (BoundingSphere);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);




/** @class Plane Operations */
var Plane = __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */], {
    // Many case (frustum, convexity)
    // needs to know where from a plane it stands,
    // not just boolean intersection
    INSIDE: 1,
    INTERSECT: 2,
    OUTSIDE: 3,
    /* Transform the plane */
    transformProvidingInverse: function() {
        var iplane = Plane.create();
        return function(p, m) {
            //Matrix.transformVec4PostMult( matrix, plane, iplane );
            var x = p[0];
            var y = p[1];
            var z = p[2];
            var w = p[3];

            iplane[0] = m[0] * x + m[1] * y + m[2] * z + m[3] * w;
            iplane[1] = m[4] * x + m[5] * y + m[6] * z + m[7] * w;
            iplane[2] = m[8] * x + m[9] * y + m[10] * z + m[11] * w;
            iplane[3] = m[12] * x + m[13] * y + m[14] * z + m[15] * w;

            Plane.normalizeEquation(iplane);
            Plane.copy(iplane, p);
            return p;
        };
    },

    normalizeEquation: function(plane) {
        // multiply the coefficients of the plane equation with a constant factor so that the equation a^2+b^2+c^2 = 1 holds.
        var inv = 1.0 / Math.sqrt(plane[0] * plane[0] + plane[1] * plane[1] + plane[2] * plane[2]);
        plane[0] *= inv;
        plane[1] *= inv;
        plane[2] *= inv;
        plane[3] *= inv;
    },
    /*only the normal Component*/
    getNormal: function(plane, result) {
        result[0] = plane[0];
        result[1] = plane[1];
        result[2] = plane[2];
        return result;
    },
    setNormal: function(plane, normal) {
        plane[0] = normal[0];
        plane[1] = normal[1];
        plane[2] = normal[2];
    },
    /* only the distance getter*/
    getDistance: function(plane) {
        return plane[3];
    },
    setDistance: function(plane, distance) {
        plane[3] = distance;
    },

    /* using the plane equation, compute distance to plane of a point*/
    distanceToPlane: function(plane, position) {
        return plane[0] * position[0] + plane[1] * position[1] + plane[2] * position[2] + plane[3];
    },

    intersectsOrContainsBoundingSphere: function(plane, bSphere) {
        if (!bSphere.valid()) return Plane.OUTSIDE;
        var position = bSphere.center();
        var radius = bSphere.radius();
        var d = this.distanceToPlane(plane, position);
        if (d < -radius) {
            return Plane.OUTSIDE;
        } else if (d <= radius) {
            return Plane.INTERSECT;
        }
        return Plane.INSIDE;
    },

    instersectsBoundingSphere: function(plane, bSphere) {
        return this.intersectsOrContainsBoundingSphere(plane, bSphere) === Plane.INTERSECT;
    },

    intersectsOrContainsBoundingBox: (function() {
        var retCorner = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
        return function(plane, bbox) {
            var upperBBCorner =
                (plane[0] >= 0.0 ? 1 : 0) | (plane[1] >= 0.0 ? 2 : 0) | (plane[2] >= 0.0 ? 4 : 0);
            var lowerBBCorner = ~upperBBCorner & 7;

            if (this.distanceToPlane(plane, bbox.corner(lowerBBCorner, retCorner)) > 0.0)
                return Plane.INSIDE;
            if (this.distanceToPlane(plane, bbox.corner(upperBBCorner, retCorner)) < 0.0)
                return Plane.OUTSIDE;
            return Plane.INTERSECT; // partially inside
        };
    })(),

    intersectsBoundingBox: function(plane, bbox, absPlane) {
        return this.intersectsOrContainsBoundingBox(plane, bbox, absPlane) === Plane.INTERSECT;
    },

    intersectOrContainsVertices: function(plane, vertices) {
        var side = -1;
        // all points must be on one side only
        for (var i = 0; i < vertices.length; i++) {
            var d = this.distanceToPlane(plane, vertices[i]);
            if (d < 0.0) {
                if (side === 1) return Plane.INTERSECT;
                side = 2;
            } else if (d > 0.0) {
                if (side === 2) return Plane.INTERSECT;
                side = 1;
            } else {
                //if ( d === 0.0 )
                return Plane.INTERSECT;
            }
        }
        return side > 0 ? Plane.INSIDE : Plane.OUTSIDE;
    },
    intersectVertices: function(plane, vertices) {
        return this.intersectOrContainsVertices(plane, vertices) === Plane.INTERSECT;
    }
});

/* harmony default export */ __webpack_exports__["a"] = (Plane);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_UpdateBone__ = __webpack_require__(82);







/**
 *  Bone
 *  @class Bone
 */
var Bone = function(name) {
    if (name !== undefined) this.setName(name);

    __WEBPACK_IMPORTED_MODULE_3_osg_MatrixTransform__["a" /* default */].call(this);
    this._invBindInSkeletonSpace = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
    this._boneInSkeletonSpace = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
    this._boneBoundingBox = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Bone,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_MatrixTransform__["a" /* default */].prototype, {
        // consistent color depending of id
        // _rand: function ( id ) {
        //     var x = Math.sin( id * 45.233 ) * 43758.5453;
        //     return x - Math.floor( x );
        // },
        // _generateBoneColor: function ( id ) {
        //     return vec3.fromValues( this._rand( id + 2.16 ), this._rand( id * 57.27 ), this._rand( id * 0.874 ) );
        // },

        getOrCreateDebugColor: function() {
            // for bone display (debugging, etc)
            if (this._boneColor) return this._boneColor;
            // this._boneColor = this._generateBoneColor( this.getInstanceID() );
            this._boneColor = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].fromValues(Math.random(), Math.random(), Math.random());
            return this._boneColor;
        },

        getBoneBoundingBox: function() {
            return this._boneBoundingBox;
        },

        setBoneBoundingBox: function(bb) {
            this._boneBoundingBox = bb;
        },

        getMatrixInSkeletonSpace: function() {
            return this._boneInSkeletonSpace;
        },

        getInvBindMatrixInSkeletonSpace: function() {
            return this._invBindInSkeletonSpace;
        },

        setMatrixInSkeletonSpace: function(m) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(this._boneInSkeletonSpace, m);
        },

        setInvBindMatrixInSkeletonSpace: function(m) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(this._invBindInSkeletonSpace, m);
        },

        getBoneParent: function() {
            var parents = this.getParents();
            for (var i = 0, l = parents.length; i < l; i++) {
                var typeID = parents[i].getTypeID();
                if (typeID === Bone.getTypeID()) {
                    return parents[i];
                }
            }
            return undefined;
        },

        setDefaultUpdateCallback: function(name) {
            this.addUpdateCallback(new __WEBPACK_IMPORTED_MODULE_4_osgAnimation_UpdateBone__["a" /* default */](name !== undefined ? name : this.getName()));
        }
    }),
    'osgAnimation',
    'Bone'
);

/* harmony default export */ __webpack_exports__["a"] = (Bone);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgAnimation_UpdateRigGeometry__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgAnimation_RigTransformHardware__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgAnimation_AnimationUpdateCallback__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_computeMatrixFromNodePath__ = __webpack_require__(44);












// RigGeometry is a Geometry deformed by bones
// To connect bones to RigGeometry it requires:
//     - a map of bones with index / weight eg also called VertexInfluenceMap
// {
//     bone0: { index: [],  // vertex index
//              weight: []  // weight for this index
//            },
//     bone2: { index: [],
//              weight: []
//            }
// }

var RigGeometry = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */].call(this);

    this._shape = null; // by default no kdtree/shape for rig

    this.addUpdateCallback(new __WEBPACK_IMPORTED_MODULE_6_osgAnimation_UpdateRigGeometry__["a" /* default */]());

    // handle matrixFromSkeletonToGeometry and invMatrixFromSkeletonToGeometry computation
    this._root = undefined;
    this._pathToRoot = undefined;
    this._isAnimatedPath = false;

    this._boneNameID = {};

    this._matrixFromSkeletonToGeometry = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
    this._invMatrixFromSkeletonToGeometry = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();

    this._rigTransformImplementation = new __WEBPACK_IMPORTED_MODULE_7_osgAnimation_RigTransformHardware__["a" /* default */]();

    // RigGeometry have a special stateset that will be pushed at the very end of the culling
    // this stateSet only represents animation (and shouldn't contain any rendering attributes)
    // It's a way to make every RigGeometry unique (in term of stateSet stack)
    this._stateSetAnimation = new __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__["a" /* default */]();

    this._needToComputeMatrix = true;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    RigGeometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */].prototype, {
        getStateSetAnimation: function() {
            return this._stateSetAnimation;
        },

        getSkeleton: function() {
            return this._root;
        },

        setSkeleton: function(root) {
            this._root = root;
        },

        setPathToSkeleton: function(path) {
            this._pathToRoot = path;
            this._isAnimatedPath = __WEBPACK_IMPORTED_MODULE_8_osgAnimation_AnimationUpdateCallback__["a" /* default */].checkPathIsAnimated(path);
        },

        setNeedToComputeMatrix: function(needToComputeMatrix) {
            this._needToComputeMatrix = needToComputeMatrix;
        },

        getNeedToComputeMatrix: function() {
            return this._needToComputeMatrix;
        },

        computeBoundingBox: function(boundingBox) {
            boundingBox.init();

            var vertexArray = this.getVertexAttributeList().Vertex;
            var weightsArray = this.getVertexAttributeList().Weights;
            // mainly copy paste of geometry computeBoundingBox code, except we only
            // take into account the non-influenced vertices

            // we do that only for the non-influenced vertices because the rigged ones
            // can't be statically computed (full moving bbox of rigs should be computed externally
            // through bones or cpu rigged colision mesh, etc)
            // bbox is important for culling (near/far)

            if (
                vertexArray &&
                weightsArray &&
                vertexArray.getElements() &&
                vertexArray.getItemSize() > 2
            ) {
                var weights = weightsArray.getElements();
                var vertexes = vertexArray.getElements();
                var itemSize = vertexArray.getItemSize();

                var min = boundingBox.getMin();
                var max = boundingBox.getMax();

                var minx = min[0];
                var miny = min[1];
                var minz = min[2];
                var maxx = max[0];
                var maxy = max[1];
                var maxz = max[2];

                for (
                    var idx = 0, idb = 0, l = vertexes.length;
                    idx < l;
                    idx += itemSize, idb += 4
                ) {
                    if (
                        weights[idx] !== 0.0 ||
                        weights[idx + 1] !== 0.0 ||
                        weights[idx + 2] !== 0.0 ||
                        weights[idx + 3] !== 0.0
                    )
                        continue;

                    var v1 = vertexes[idx];
                    var v2 = vertexes[idx + 1];
                    var v3 = vertexes[idx + 2];
                    if (v1 < minx) minx = v1;
                    if (v1 > maxx) maxx = v1;
                    if (v2 < miny) miny = v2;
                    if (v2 > maxy) maxy = v2;
                    if (v3 < minz) minz = v3;
                    if (v3 > maxz) maxz = v3;
                }

                min[0] = minx;
                min[1] = miny;
                min[2] = minz;
                max[0] = maxx;
                max[1] = maxy;
                max[2] = maxz;
            }

            return boundingBox;
        },

        computeMatrixFromRootSkeleton: function() {
            if (!this._root) {
                __WEBPACK_IMPORTED_MODULE_3_osg_notify__["a" /* default */].warn(
                    'Warning ' +
                        this.className() +
                        '.computeMatrixFromRootSkeleton if you have this message it means you miss to call buildTransformer( root ), or your RigGeometry (' +
                        this.getName() +
                        ') is not attached to a Skeleton subgraph'
                );
                return;
            }

            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].identity(this._matrixFromSkeletonToGeometry);
            __WEBPACK_IMPORTED_MODULE_9_osg_computeMatrixFromNodePath__["a" /* default */].computeLocalToWorld(
                this._pathToRoot,
                true,
                this._matrixFromSkeletonToGeometry
            );
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(this._invMatrixFromSkeletonToGeometry, this._matrixFromSkeletonToGeometry);

            if (!this._isAnimatedPath) this._needToComputeMatrix = false;
        },

        getMatrixFromSkeletonToGeometry: function() {
            return this._matrixFromSkeletonToGeometry;
        },

        getInvMatrixFromSkeletonToGeometry: function() {
            return this._invMatrixFromSkeletonToGeometry;
        },

        getSourceGeometry: function() {
            return this._geometry;
        },

        setSourceGeometry: function(geometry) {
            this._geometry = geometry;
        },

        getBoneNameID: function() {
            return this._boneNameID;
        },

        setBoneNameID: function(boneMap) {
            this._boneNameID = boneMap;
        },

        mergeChildrenVertexAttributeList: function() {
            if (this._geometry instanceof __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */])
                this._geometry.mergeChildrenVertexAttributeList();

            var sourceGeometryVertexAttributeList = this._geometry.getVertexAttributeList();

            __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */].appendVertexAttributeToList(
                sourceGeometryVertexAttributeList,
                this.getVertexAttributeList()
            );
        },

        mergeChildrenData: function() {
            // move to the rig the vertex attributes, the primitives and the stateset

            this.mergeChildrenVertexAttributeList();
            var primitiveSetList = this._geometry.getPrimitiveSetList();

            this.getPrimitiveSetList().length = 0;
            for (var i = 0, il = primitiveSetList.length; i < il; i++)
                this.getPrimitiveSetList()[i] = primitiveSetList[i];

            if (this.getStateSet())
                console.error('A stateset in the rig is already present : ' + this.getStateSet());
            this.setStateSet(this._geometry.getStateSet());
        },

        update: function() {
            this._rigTransformImplementation.update(this);
        },

        computeTransformedVertex: function(id, out) {
            out = out || __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            var vList = this.getVertexAttributeList();
            var vWeights = vList.Weights.getElements();
            var vBones = vList.Bones.getElements();

            var x = 0.0;
            var y = 0.0;
            var z = 0.0;
            if (this._geometry.computeTransformedVertex) {
                this._geometry.computeTransformedVertex(id, out);
                x = out[0];
                y = out[1];
                z = out[2];
            } else {
                var verts = vList.Vertex.getElements();
                x = verts[id * 3];
                y = verts[id * 3 + 1];
                z = verts[id * 3 + 2];
            }

            var id4 = id * 4;

            var palette = this._rigTransformImplementation._skinningAttribute.getMatrixPalette();
            var m0 = 0.0;
            var m1 = 0.0;
            var m2 = 0.0;
            var m4 = 0.0;
            var m5 = 0.0;
            var m6 = 0.0;
            var m8 = 0.0;
            var m9 = 0.0;
            var m10 = 0.0;
            var m12 = 0.0;
            var m13 = 0.0;
            var m14 = 0.0;
            var m15 = 0.0;

            var doSkin = false;
            for (var i = 0; i < 4; ++i) {
                var w = vWeights[id4 + i];
                if (w === 0.0) continue;

                var idBone = vBones[id4 + i] * 12;

                m0 += palette[idBone + 0] * w;
                m4 += palette[idBone + 1] * w;
                m8 += palette[idBone + 2] * w;
                m12 += palette[idBone + 3] * w;

                m1 += palette[idBone + 4] * w;
                m5 += palette[idBone + 5] * w;
                m9 += palette[idBone + 6] * w;
                m13 += palette[idBone + 7] * w;

                m2 += palette[idBone + 8] * w;
                m6 += palette[idBone + 9] * w;
                m10 += palette[idBone + 10] * w;
                m14 += palette[idBone + 11] * w;

                m15 += w;
                doSkin = true;
            }

            if (!doSkin) {
                out[0] = x;
                out[1] = y;
                out[2] = z;
            }

            var d = 1.0 / m15;
            out[0] = (m0 * x + m4 * y + m8 * z + m12) * d;
            out[1] = (m1 * x + m5 * y + m9 * z + m13) * d;
            out[2] = (m2 * x + m6 * y + m10 * z + m14) * d;

            return out;
        },

        computeTransformedVertices: function() {
            // obviously slow as it can't rely on kdTree AND we transform everything cpu side

            var vList = this.getVertexAttributeList();
            var verts = this._geometry.computeTransformedVertices
                ? this._geometry.computeTransformedVertices()
                : vList.Vertex.getElements();
            var vWeights = vList.Weights.getElements();
            var vBones = vList.Bones.getElements();

            var riggedVerts = this._riggedVerts || new Float32Array(verts.length);

            // /!\ if the geometry has several parents inside a skeleton
            // it might not work as it will just take the last compute matrix palette
            var palette = this._rigTransformImplementation._skinningAttribute.getMatrixPalette();

            // verbose... but fast
            for (var idv = 0, idr = 0, len = verts.length; idv < len; idv += 3, idr += 4) {
                var m0 = 0.0;
                var m1 = 0.0;
                var m2 = 0.0;

                var m4 = 0.0;
                var m5 = 0.0;
                var m6 = 0.0;

                var m8 = 0.0;
                var m9 = 0.0;
                var m10 = 0.0;

                var m12 = 0.0;
                var m13 = 0.0;
                var m14 = 0.0;
                var m15 = 0.0;

                var doSkin = false;

                var w = vWeights[idr];
                var idBone;
                if (w !== 0.0) {
                    idBone = vBones[idr] * 12;
                    m0 += palette[idBone + 0] * w;
                    m4 += palette[idBone + 1] * w;
                    m8 += palette[idBone + 2] * w;
                    m12 += palette[idBone + 3] * w;

                    m1 += palette[idBone + 4] * w;
                    m5 += palette[idBone + 5] * w;
                    m9 += palette[idBone + 6] * w;
                    m13 += palette[idBone + 7] * w;

                    m2 += palette[idBone + 8] * w;
                    m6 += palette[idBone + 9] * w;
                    m10 += palette[idBone + 10] * w;
                    m14 += palette[idBone + 11] * w;

                    m15 += w;
                    doSkin = true;
                }

                w = vWeights[idr + 1];
                if (w !== 0.0) {
                    idBone = vBones[idr + 1] * 12;
                    m0 += palette[idBone + 0] * w;
                    m4 += palette[idBone + 1] * w;
                    m8 += palette[idBone + 2] * w;
                    m12 += palette[idBone + 3] * w;

                    m1 += palette[idBone + 4] * w;
                    m5 += palette[idBone + 5] * w;
                    m9 += palette[idBone + 6] * w;
                    m13 += palette[idBone + 7] * w;

                    m2 += palette[idBone + 8] * w;
                    m6 += palette[idBone + 9] * w;
                    m10 += palette[idBone + 10] * w;
                    m14 += palette[idBone + 11] * w;

                    m15 += w;
                    doSkin = true;
                }

                w = vWeights[idr + 2];
                if (w !== 0.0) {
                    idBone = vBones[idr + 2] * 12;

                    m0 += palette[idBone + 0] * w;
                    m4 += palette[idBone + 1] * w;
                    m8 += palette[idBone + 2] * w;
                    m12 += palette[idBone + 3] * w;

                    m1 += palette[idBone + 4] * w;
                    m5 += palette[idBone + 5] * w;
                    m9 += palette[idBone + 6] * w;
                    m13 += palette[idBone + 7] * w;

                    m2 += palette[idBone + 8] * w;
                    m6 += palette[idBone + 9] * w;
                    m10 += palette[idBone + 10] * w;
                    m14 += palette[idBone + 11] * w;

                    m15 += w;
                    doSkin = true;
                }

                w = vWeights[idr + 3];
                if (w !== 0.0) {
                    idBone = vBones[idr + 3] * 12;

                    m0 += palette[idBone + 0] * w;
                    m4 += palette[idBone + 1] * w;
                    m8 += palette[idBone + 2] * w;
                    m12 += palette[idBone + 3] * w;

                    m1 += palette[idBone + 4] * w;
                    m5 += palette[idBone + 5] * w;
                    m9 += palette[idBone + 6] * w;
                    m13 += palette[idBone + 7] * w;

                    m2 += palette[idBone + 8] * w;
                    m6 += palette[idBone + 9] * w;
                    m10 += palette[idBone + 10] * w;
                    m14 += palette[idBone + 11] * w;

                    m15 += w;
                    doSkin = true;
                }

                var x = verts[idv];
                var y = verts[idv + 1];
                var z = verts[idv + 2];

                if (!doSkin) {
                    riggedVerts[idv] = x;
                    riggedVerts[idv + 1] = y;
                    riggedVerts[idv + 2] = z;
                    continue;
                }

                var d = 1.0 / m15;
                riggedVerts[idv] = (m0 * x + m4 * y + m8 * z + m12) * d;
                riggedVerts[idv + 1] = (m1 * x + m5 * y + m9 * z + m13) * d;
                riggedVerts[idv + 2] = (m2 * x + m6 * y + m10 * z + m14) * d;
            }

            return riggedVerts;
        }
    }),
    'osgAnimation',
    'RigGeometry'
);

/* harmony default export */ __webpack_exports__["a"] = (RigGeometry);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgAnimation_target__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__ = __webpack_require__(125);






var Channel = {};

// channel {
//     keys: [],
//     times: [],
//     type: enum,
//     target: targetName
// }
// init a channel with extra field
// start, end, duration
var initChannel = function(type, keys, times, targetName, channelName, channel) {
    var start = times[0];
    var end = times[times.length - 1];
    channel.start = start;
    channel.keys = keys;
    channel.end = end;
    channel.times = times;
    channel.type = type;
    channel.duration = end - start;
    channel.target = targetName;
    channel.name = channelName;
    return channel;
};

var createVec3Channel = function(keys, times, targetName, channelName, chan) {
    return initChannel(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Vec3, keys, times, targetName, channelName, chan || {});
};

var createFloatChannel = function(keys, times, targetName, channelName, chan) {
    return initChannel(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Float, keys, times, targetName, channelName, chan || {});
};

var createQuatChannel = function(keys, times, targetName, channelName, chan) {
    return initChannel(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Quat, keys, times, targetName, channelName, chan || {});
};

var createQuatSlerpChannel = function(keys, times, targetName, channelName, chan) {
    return initChannel(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].QuatSlerp, keys, times, targetName, channelName, chan || {});
};

var createFloatCubicBezierChannel = function(keys, times, targetName, channelName, chan) {
    return initChannel(
        __WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].FloatCubicBezier,
        keys,
        times,
        targetName,
        channelName,
        chan || {}
    );
};

var createVec3CubicBezierChannel = function(keys, times, targetName, channelName, chan) {
    return initChannel(
        __WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Vec3CubicBezier,
        keys,
        times,
        targetName,
        channelName,
        chan || {}
    );
};

// channel contains {
//     keys: [],
//     times: [],
//     start: 0.0,
//     end: 1.0,
// }
// return {
//     channel: channel,
//     value: vec3.create(),
//     targetID: int,
//     key: 0,
//     t: 0, //global start time
// }

var Float = {
    create: function() {
        return 0;
    }
};
var Vec3 = {
    create: function() {
        return __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create32();
    }
};
var Quat = {
    create: function() {
        return __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create32();
    }
};

var createInstanceChannelType = function(operator, channel) {
    return {
        channel: channel,
        value: operator.create(),
        targetID: __WEBPACK_IMPORTED_MODULE_1_osgAnimation_target__["a" /* default */].InvalidTargetID,
        weight: 1.0,
        key: 0,
        start: 0.0,
        end: 0.0
    };
};

var createInstanceVec3Channel = function(channel) {
    return createInstanceChannelType(Vec3, channel);
};

var createInstanceQuatChannel = function(channel) {
    return createInstanceChannelType(Quat, channel);
};

var createInstanceFloatChannel = function(channel) {
    return createInstanceChannelType(Float, channel);
};

var createInstanceFloatCubicBezierChannel = function(channel) {
    return createInstanceChannelType(Float, channel);
};

var createInstanceVec3CubicBezierChannel = function(channel) {
    return createInstanceChannelType(Vec3, channel);
};

// create an instance channel from type
var createInstanceChannel = function(channel) {
    return Channel[channel.type](channel);
};

// animations instances
/*

 |-----------------| anim0 (channel0_0, channel0_1 )
           |--------------| anim1 (channel1_0, channel1_1, channel1_2 )

 // si triage a cause de la priorité
 // iterate on priority
 // and for animations of the same priority


 // init d'une animation

 // init du manager
 //   createInstanceAnimation pour chaque animations
 //      createInstanceChannels pour chaque animation

 //   initChannelTargetID pour toute les animations du manager
 //      id -> targetName


 // get target for an animation to push on target list ( to blend )
 var targets = {};
 for ( var i = 0 ; i < channels.length; i++ ) {
    var target = channels[i].target;
    targets[target].push( channels[i] );
 }


 // pour l'instant on ignore les pb d'organisation de priorité
 //
 // target X : [
 //      ChannelAnima0_0
 //      ChannelAnima1_0
 // ]

 // target Y : [
 //      ChannelAnima0_1
 //      ChannelAnima1_1
 // ]


 */

// for a target compute each channel contribution
// channel0, value0, w, priority0
// channel1, value1, w, priority0
// channel2, value2, w, priority0

// channel0, value0, w, priority1
// channel1, value1, w, priority1
// channel2, value2, w, priority1

/*

 var value;
 Copy( channels[0].value, value );
 var weight = 0.0;
 var priority = channels[0].priority;
 var priorityWeight = channels[0].weight;

 for ( var i = 1; i < channels.length; i++ ) {

     if ( priority !== channels[i].priority ) {
          weight += priorityWeight * ( 1.0 - weight );
          priorityWeight = 0.0;
          priority = channels[i].priority;
     }

     priorityWeight += weight;
     t = ( 1.0 - weight ) * channels[i].weight / priorityWeight;
     lerp( t, value, channels[i].value );
 }


 // second version

 var value;
 Copy( channels[0].value, value );
 var weight = 0; //channels[0].weight;
 //var priority = channels[0].priority;
 var priorityWeight = 0;

 for ( var i = 0; i < channels.length; i++ ) {

     if ( priority !== channels[i].priority ) {
          weight += priorityWeight * ( 1.0 - weight );
          priorityWeight = 0.0;
          priority = channels[i].priority;
     }

     priorityWeight += weight;
     t = ( 1.0 - weight ) * channels[i].weight / priorityWeight;
     lerp( t, value, channels[i].value );
 }


 */

Channel.createInstanceChannel = createInstanceChannel;
Channel.createInstanceVec3Channel = createInstanceVec3Channel;
Channel.createInstanceQuatChannel = createInstanceQuatChannel;
Channel.createInstanceQuatSlerpChannel = createInstanceQuatChannel;
Channel.createInstanceFloatChannel = createInstanceFloatChannel;
Channel.createInstanceFloatCubicBezierChannel = createInstanceFloatCubicBezierChannel;
Channel.createInstanceVec3CubicBezierChannel = createInstanceVec3CubicBezierChannel;

Channel.createVec3Channel = createVec3Channel;
Channel.createQuatChannel = createQuatChannel;
Channel.createQuatSlerpChannel = createQuatSlerpChannel;
Channel.createFloatChannel = createFloatChannel;
Channel.createFloatCubicBezierChannel = createFloatCubicBezierChannel;
Channel.createVec3CubicBezierChannel = createVec3CubicBezierChannel;

Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Vec3] = createInstanceVec3Channel;
Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Quat] = createInstanceQuatChannel;
Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].QuatSlerp] = createInstanceQuatChannel;
Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Float] = createInstanceFloatChannel;
Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].FloatCubicBezier] = createInstanceFloatCubicBezierChannel;
Channel[__WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */].Vec3CubicBezier] = createInstanceVec3CubicBezierChannel;

Channel.ChannelType = __WEBPACK_IMPORTED_MODULE_2_osgAnimation_channelType__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Channel);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_transformEnums__ = __webpack_require__(11);



var computeLocalToWorld = function(nodePath, ignoreCameras, userMatrix, nodePathIndex) {
    var ignoreCamera = ignoreCameras;
    var nodePathLength = nodePathIndex !== undefined ? nodePathIndex : nodePath.length;
    if (ignoreCamera === undefined) ignoreCamera = true;

    var matrix = userMatrix || __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create();

    var j = 0;

    if (ignoreCamera) {
        for (j = nodePathLength - 1; j >= 0; j--) {
            var camera = nodePath[j];

            if (
                camera.className() === 'Camera' &&
                (camera.getReferenceFrame() !== __WEBPACK_IMPORTED_MODULE_1_osg_transformEnums__["a" /* default */].RELATIVE_RF ||
                    camera.getParents().length === 0)
            ) {
                break;
            }
        }

        // because when we break it's to an index - 1
        // it works because if nothing camera found j == -1 at the end of the loop
        // and if we found a camera we want to start at the camera index + 1
        j += 1;
    }

    for (var i = j, l = nodePathLength; i < l; i++) {
        var node = nodePath[i];

        if (node.computeLocalToWorldMatrix) {
            node.computeLocalToWorldMatrix(matrix);
        }
    }

    return matrix;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    computeLocalToWorld: computeLocalToWorld
});


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);




var ImageBitmap = window.ImageBitmap || function() {};

var ImageObject = function(image) {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);

    this._imageObject = undefined;
    this._url = undefined;
    this._width = undefined;
    this._height = undefined;
    this._dirty = true;
    this._mipmap = [];

    if (image) {
        this.setImage(image);
    }

    this._isGreyscale = undefined;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    ImageObject,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        dirty: function() {
            this._isGreyscale = undefined;
            this._dirty = true;
        },

        isDirty: function() {
            return this._dirty;
        },

        setDirty: function(bool) {
            this._dirty = bool;
        },

        getImage: function() {
            return this._imageObject instanceof ImageObject
                ? this._imageObject.getImage()
                : this._imageObject;
        },

        getURL: function() {
            return this._url;
        },

        setURL: function(url) {
            this._url = url;
        },

        useOrCreateImage: function(img) {
            return img instanceof ImageObject === false ? new ImageObject(img) : img;
        },

        setImage: function(img) {
            if (!this._url && img && (img.src || img.currentSrc)) {
                // TODO what is currentSrc ?
                this._url = img.src || img.currentSrc;
            }

            this._mipmap.length = 0;

            // img can be an image or an array of image if specify the
            // all mipmap levels
            if (Array.isArray(img)) {
                for (var i = 0, nbImg = img.length; i < nbImg; i++) {
                    this._mipmap.push(this.useOrCreateImage(img[i]));
                }
                this.setWidth(this._mipmap[0].getWidth());
                this.setHeight(this._mipmap[0].getHeight());
            } else {
                this._mipmap.push(img);
            }

            this._imageObject = this._mipmap[0];
            this.dirty();
        },

        isCanvas: function() {
            return this.getImage() instanceof window.HTMLCanvasElement;
        },

        isBitmap: function() {
            return this.getImage() instanceof ImageBitmap;
        },

        isVideo: function() {
            return this.getImage() instanceof window.HTMLVideoElement;
        },

        isImage: function() {
            return this.getImage() instanceof window.Image;
        },

        isTypedArray: function() {
            var img = this.getImage();
            return (
                img instanceof Uint8Array ||
                img instanceof Float32Array ||
                img instanceof Uint16Array
            );
        },

        setWidth: function(w) {
            this._width = w;
        },

        setHeight: function(h) {
            this._height = h;
        },

        getWidth: function() {
            var img = this.getImage();
            if (this.isImage()) {
                return img.naturalWidth;
            } else if (this.isVideo()) {
                return img.videoWidth;
            } else if (this.isCanvas() || this.isBitmap()) {
                return img.width;
            }
            return this._width;
        },

        getHeight: function() {
            var img = this.getImage();
            if (this.isImage()) {
                return img.naturalHeight;
            } else if (this.isVideo()) {
                return img.videoHeight;
            } else if (this.isCanvas() || this.isBitmap()) {
                return img.height;
            }
            return this._height;
        },

        isGreyscale: function(nbSamples) {
            if (this._isGreyscale !== undefined) return this._isGreyscale;

            if (
                this._imageObject !== undefined &&
                this.isReady() &&
                this._isGreyscale === undefined
            ) {
                var canvas = this._imageObject;
                if (!this.isCanvas()) {
                    canvas = document.createElement('canvas');
                }
                var ctx = canvas.getContext('2d');
                canvas.width = this._imageObject.width;
                canvas.height = this._imageObject.height;
                ctx.drawImage(this._imageObject, 0, 0);

                var sampleX, sampleY;
                // cap sample if needed
                if (!nbSamples) {
                    sampleX = canvas.width;
                    sampleY = canvas.height;
                }
                if (nbSamples > 0) {
                    nbSamples = Math.min(Math.min(canvas.width, canvas.height), nbSamples);
                    sampleX = sampleY = nbSamples;
                }

                var isGreyscale = true;
                var xFactor = canvas.width / sampleX;
                var yFactor = canvas.height / sampleY;
                for (var i = 0; i < sampleX; i++) {
                    for (var j = 0; j < sampleY; j++) {
                        var x = Math.floor(xFactor * (i + 0.5)),
                            y = Math.floor(yFactor * (j + 0.5));
                        var data = ctx.getImageData(x, y, 1, 1).data;
                        if (!(data[0] === data[1] && data[0] === data[2])) {
                            isGreyscale = false;
                            break;
                        }
                    }
                }
                this._isGreyscale = isGreyscale;
            }

            return this._isGreyscale;
        },

        isReady: function() {
            // image is a osgImage
            if (this._imageObject && this._imageObject instanceof ImageObject) {
                return this._imageObject.isReady();
            }

            // image are ready for static data
            if (this.isCanvas() || this.isTypedArray() || this.isBitmap()) {
                return true;
            }

            if (this.isImage()) {
                var image = this.getImage();
                if (image.complete) {
                    if (image.naturalWidth !== undefined && image.naturalWidth === 0) {
                        return false;
                    }

                    return true;
                }
            }

            if (this.isVideo()) {
                if (this.getWidth() !== 0) return true;
            }

            // here means we have something but we don't know what
            // Check if the object is not a image
            // by "feature" detect it
            var imageTry = this.getImage();
            if (imageTry.complete) {
                if (imageTry.naturalWidth !== undefined && imageTry.naturalWidth === 0) {
                    return false;
                }
                return true;
            }

            // It's not something we recognise
            return false;
        },

        getMipmap: function() {
            return this._mipmap;
        },

        hasMipmap: function() {
            return this._mipmap.length > 1;
        },

        release: function() {
            this._mipmap.length = 0;
            this._imageObject = undefined;
        }
    }),
    'osg',
    'Image'
);

/* harmony default export */ __webpack_exports__["a"] = (ImageObject);


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var CullSettings = function() {
    // Not doing a this.reset()
    // because of multiple inheritance
    // it will call the wrong reset
    // cullstack reset for isntance()
    CullSettings.prototype.reset.call(this);
};

CullSettings.prototype = {
    reset: function() {
        this._computeNearFar = true;
        this._nearFarRatio = 0.005;

        // Magic numbers 3 & 4
        this.bbCornerFar = 3;
        this.bbCornerNear = 4;
        // // see code below for for the
        // // Code simplification origin
        // var vec3 = require('osg/glMatrix').default.vec3;
        // var lookVector = vec3.fromValues(0.0, 0.0, -1.0);
        // this.bbCornerFar =
        //     (lookVector[0] >= 0 ? 1 : 0) |
        //     (lookVector[1] >= 0 ? 2 : 0) |
        //     (lookVector[2] >= 0 ? 4 : 0);
        // this.bbCornerNear = ~this.bbCornerFar & 7;
        // // is equivalent to

        this._enableFrustumCulling = false;

        // who sets the parameter
        // if it's cullvisitor
        // it's an OVERRIDER for enableFrustumCulling
        // allowing for global EnableFrustimCulling
        this._settingsSourceOverrider = this;
        //LOD bias for the CullVisitor to use
        this._LODScale = 1.0;
        // Custom clampProjectionMatrix
        this._clampProjectionMatrixCallback = undefined;
    },

    setCullSettings: function(settings) {
        this._computeNearFar = settings._computeNearFar;
        this._nearFarRatio = settings._nearFarRatio;
        this._enableFrustumCulling = settings._enableFrustumCulling;
        this._settingsSourceOverrider = settings._settingsSourceOverrider;
        this._clampProjectionMatrixCallback = settings._clampProjectionMatrixCallback;
    },

    setNearFarRatio: function(ratio) {
        this._nearFarRatio = ratio;
    },
    getNearFarRatio: function() {
        return this._nearFarRatio;
    },
    setComputeNearFar: function(value) {
        this._computeNearFar = value;
    },
    getComputeNearFar: function() {
        return this._computeNearFar;
    },

    setEnableFrustumCulling: function(value) {
        this._enableFrustumCulling = value;
    },
    getEnableFrustumCulling: function() {
        return this._enableFrustumCulling;
    },

    getSettingSourceOverrider: function() {
        return this._settingsSourceOverrider;
    },

    setClampProjectionMatrixCallback: function(callback) {
        this._clampProjectionMatrixCallback = callback;
    },

    getClampProjectionMatrixCallback: function() {
        return this._clampProjectionMatrixCallback;
    },

    setLODScale: function(scale) {
        this._LODScale = scale;
    },
    getLODScale: function() {
        return this._LODScale;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (CullSettings);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



/**
 *  Manage CullFace attribute
 *  @class CullFace
 */
var CullFace = function(mode) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this.setMode(mode !== undefined ? mode : CullFace.BACK);
};

CullFace.DISABLE = 0x0;
CullFace.FRONT = 0x0404;
CullFace.BACK = 0x0405;
CullFace.FRONT_AND_BACK = 0x0408;

/** @lends CullFace.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    CullFace,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'CullFace',

        cloneType: function() {
            return new CullFace();
        },

        setMode: function(mode) {
            var value = mode;
            if (typeof value === 'string') value = CullFace[value];
            this._mode = value;
        },

        getMode: function() {
            return this._mode;
        },

        apply: function(state) {
            state.applyCullFace(this);
        }
    }),
    'osg',
    'CullFace'
);

/* harmony default export */ __webpack_exports__["a"] = (CullFace);


/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_math__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_CullSettings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_CullStack__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_AutoTransform__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Projection__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_LightSource__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_RenderLeaf__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osg_RenderBin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osg_RenderStage__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osg_Lod__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_Switch__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osg_PagedLOD__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osgAnimation_Skeleton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_osgAnimation_Bone__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_osg_PooledResource__ = __webpack_require__(24);






























var createRenderLeaf = function() {
    return new __WEBPACK_IMPORTED_MODULE_13_osg_RenderLeaf__["a" /* default */]();
};

var createCullSettings = function() {
    return new __WEBPACK_IMPORTED_MODULE_4_osg_CullSettings__["a" /* default */]();
};

/**
 * CullVisitor traverse the tree and collect Matrix/State for the rendering traverse
 * @class CullVisitor
 */
var CullVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].TRAVERSE_ACTIVE_CHILDREN);
    __WEBPACK_IMPORTED_MODULE_4_osg_CullSettings__["a" /* default */].call(this);
    __WEBPACK_IMPORTED_MODULE_5_osg_CullStack__["a" /* default */].call(this);

    this._rootStateGraph = undefined;
    this._currentStateGraph = undefined;
    this._currentRenderBin = undefined;
    this._currentRenderStage = undefined;
    this._rootRenderStage = undefined;
    this._computedNear = Number.POSITIVE_INFINITY;
    this._computedFar = Number.NEGATIVE_INFINITY;

    var lookVector = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, -1.0);
    this._camera = undefined;
    /*jshint bitwise: false */
    this._bbCornerFar =
        (lookVector[0] >= 0 ? 1 : 0) | (lookVector[1] >= 0 ? 2 : 0) | (lookVector[2] >= 0 ? 4 : 0);
    this._bbCornerNear = ~this._bbCornerFar & 7;
    /*jshint bitwise: true */

    this._pooledLeaf = new __WEBPACK_IMPORTED_MODULE_27_osg_PooledResource__["a" /* default */](createRenderLeaf);

    this._pooledRenderStages = {};

    this._pooledCullSettings = new __WEBPACK_IMPORTED_MODULE_27_osg_PooledResource__["a" /* default */](createCullSettings);

    this._renderBinStack = new __WEBPACK_IMPORTED_MODULE_26_osg_PooledArray__["a" /* default */]();
    this.visitorType = __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].CULL_VISITOR;

    this._identityMatrix = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();

    this._renderer = undefined;
    this._renderStageType = __WEBPACK_IMPORTED_MODULE_15_osg_RenderStage__["a" /* default */];

    this._numCamera = 0;
    this._numMatrixTransform = 0;
    this._numProjection = 0;
    this._numNode = 0;
    this._numLightSource = 0;
    this._numGeometry = 0;
};

CullVisitor.registerApplyFunction = __WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction;
CullVisitor.getApplyFunction = __WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].getApplyFunction;

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    CullVisitor,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(
        __WEBPACK_IMPORTED_MODULE_5_osg_CullStack__["a" /* default */].prototype,
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].prototype, {
            applyFunctionArray: __WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].applyFunctionArray,

            distance: function(coord, matrix) {
                return -(
                    coord[0] * matrix[2] +
                    coord[1] * matrix[6] +
                    coord[2] * matrix[10] +
                    matrix[14]
                );
            },

            getComputedNear: function() {
                return this._computedNear;
            },

            getComputedFar: function() {
                return this._computedFar;
            },

            resetStats: function() {
                this._numCamera = 0;
                this._numMatrixTransform = 0;
                this._numProjection = 0;
                this._numNode = 0;
                this._numLightSource = 0;
                this._numGeometry = 0;
            },

            handleCullCallbacksAndTraverse: function(node) {
                var ccb = node.getCullCallback();
                if (ccb && !ccb.cull(node, this)) return;
                this.traverse(node);
            },

            getCurrentCamera: function() {
                return this._currentRenderBin.getStage().getCamera();
            },

            updateCalculatedNearFar: (function() {
                var nearVec = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
                var farVec = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();

                return function(matrix, drawable) {
                    var bb = drawable.getBoundingBox();
                    var dNear, dFar;

                    // efficient computation of near and far, only taking into account the nearest and furthest
                    // corners of the bounding box.
                    dNear = this.distance(bb.corner(this._bbCornerNear, nearVec), matrix);
                    dFar = this.distance(bb.corner(this._bbCornerFar, farVec), matrix);

                    if (dNear > dFar) {
                        var tmp = dNear;
                        dNear = dFar;
                        dFar = tmp;
                    }

                    if (dFar < 0.0) {
                        // whole object behind the eye point so discard
                        return false;
                    }

                    if (dNear < this._computedNear) {
                        this._computedNear = dNear;
                    }

                    if (dFar > this._computedFar) {
                        this._computedFar = dFar;
                    }

                    return true;
                };
            })(),

            setStateGraph: function(sg) {
                this._rootStateGraph = sg;
                this._currentStateGraph = sg;
            },
            setRenderStage: function(rg) {
                this._rootRenderStage = rg;
                this._currentRenderBin = rg;
            },
            setRenderer: function(renderer) {
                this._renderer = renderer;
            },
            getRenderer: function() {
                return this._renderer;
            },

            reset: function() {
                __WEBPACK_IMPORTED_MODULE_5_osg_CullStack__["a" /* default */].prototype.reset.call(this);

                this._pooledLeaf.reset();
                this._pooledCullSettings.reset();

                // renderstage / renderbin pools
                for (var key in this._pooledRenderStages) {
                    this._pooledRenderStages[key].reset();
                }
                __WEBPACK_IMPORTED_MODULE_14_osg_RenderBin__["a" /* default */].reset();

                this._computedNear = Number.POSITIVE_INFINITY;
                this._computedFar = Number.NEGATIVE_INFINITY;
            },

            getCurrentRenderBin: function() {
                return this._currentRenderBin;
            },

            setCurrentRenderBin: function(rb) {
                this._currentRenderBin = rb;
            },

            // mimic the osg implementation
            // in osg you can push 0, in this case an identity matrix will be loaded
            addPositionedAttribute: function(matrix, attribute) {
                var m = matrix ? matrix : this._identityMatrix;
                this._currentRenderBin.getStage().addPositionAttribute(m, attribute);
            },

            pushStateSet: function(stateset) {
                this._currentStateGraph = this._currentStateGraph.findOrInsert(stateset);
                if (stateset.getBinName() !== undefined) {
                    var renderBinStack = this._renderBinStack;
                    var currentRenderBin = this._currentRenderBin;
                    renderBinStack.push(currentRenderBin);
                    this._currentRenderBin = currentRenderBin
                        .getStage()
                        .findOrInsert(stateset.getBinNumber(), stateset.getBinName());
                }
            },

            /** Pop the top state set and hence associated state group.
             * Move the current state group to the parent of the popped
             * state group.
             */
            popStateSet: function() {
                var currentStateGraph = this._currentStateGraph;
                var stateset = currentStateGraph.getStateSet();
                this._currentStateGraph = currentStateGraph.getParent();
                if (stateset.getBinName() !== undefined) {
                    var renderBinStack = this._renderBinStack;
                    if (renderBinStack.getLength() === 0) {
                        this._currentRenderBin = this._currentRenderBin.getStage();
                    } else {
                        this._currentRenderBin = renderBinStack.pop();
                    }
                }
            },

            popProjectionMatrix: function() {
                if (this._computeNearFar === true && this._computedFar >= this._computedNear) {
                    var m = this.getCurrentProjectionMatrix();
                    if (this._clampProjectionMatrixCallback !== undefined) {
                        this._clampProjectionMatrixCallback(
                            m,
                            this._computedNear,
                            this._computedFar,
                            this._nearFarRatio
                        );
                    } else {
                        this.clampProjectionMatrix(
                            m,
                            this._computedNear,
                            this._computedFar,
                            this._nearFarRatio
                        );
                    }
                }
                __WEBPACK_IMPORTED_MODULE_5_osg_CullStack__["a" /* default */].prototype.popProjectionMatrix.call(this);
            },

            clampProjectionMatrix: function(projection, znear, zfar, nearFarRatio, resultNearFar) {
                var epsilon = 1e-6;
                if (zfar < znear - epsilon) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log(
                        'clampProjectionMatrix not applied, invalid depth range, znear = ' +
                            znear +
                            '  zfar = ' +
                            zfar,
                        false,
                        true
                    );
                    return false;
                }

                var desiredZnear, desiredZfar;
                if (zfar < znear + epsilon) {
                    // znear and zfar are too close together and could cause divide by zero problems
                    // late on in the clamping code, so move the znear and zfar apart.
                    var average = (znear + zfar) * 0.5;
                    znear = average - epsilon;
                    zfar = average + epsilon;
                    // OSG_INFO << '_clampProjectionMatrix widening znear and zfar to '<<znear<<' '<<zfar<<std::endl;
                }

                if (
                    Math.abs(projection[3]) < epsilon &&
                    Math.abs(projection[7]) < epsilon &&
                    Math.abs(projection[11]) < epsilon
                ) {
                    // OSG_INFO << 'Orthographic matrix before clamping'<<projection<<std::endl;

                    var deltaSpan = (zfar - znear) * 0.02;
                    if (deltaSpan < 1.0) {
                        deltaSpan = 1.0;
                    }
                    desiredZnear = znear - deltaSpan;
                    desiredZfar = zfar + deltaSpan;

                    // assign the clamped values back to the computed values.
                    znear = desiredZnear;
                    zfar = desiredZfar;

                    projection[10] = -2.0 / (desiredZfar - desiredZnear);
                    projection[14] = -(desiredZfar + desiredZnear) / (desiredZfar - desiredZnear);
                    // OSG_INFO << 'Orthographic matrix after clamping '<<projection<<std::endl;
                } else {
                    // OSG_INFO << 'Persepective matrix before clamping'<<projection<<std::endl;
                    //std::cout << '_computed_znear'<<_computed_znear<<std::endl;
                    //std::cout << '_computed_zfar'<<_computed_zfar<<std::endl;

                    var zfarPushRatio = 1.02;
                    var znearPullRatio = 0.98;

                    //znearPullRatio = 0.99;

                    desiredZnear = znear * znearPullRatio;
                    desiredZfar = zfar * zfarPushRatio;

                    // near plane clamping.
                    var minNearPlane = zfar * nearFarRatio;
                    if (desiredZnear < minNearPlane) {
                        desiredZnear = minNearPlane;
                    }

                    // assign the clamped values back to the computed values.
                    znear = desiredZnear;
                    zfar = desiredZfar;

                    var m22 = projection[10];
                    var m32 = projection[14];
                    var m23 = projection[11];
                    var m33 = projection[15];
                    var transNearPlane = (-desiredZnear * m22 + m32) / (-desiredZnear * m23 + m33);
                    var transFarPlane = (-desiredZfar * m22 + m32) / (-desiredZfar * m23 + m33);

                    var ratio = Math.abs(2.0 / (transNearPlane - transFarPlane));
                    var center = -(transNearPlane + transFarPlane) / 2.0;

                    var centerRatio = center * ratio;
                    projection[2] = projection[2] * ratio + projection[3] * centerRatio;
                    projection[6] = projection[6] * ratio + projection[7] * centerRatio;
                    projection[10] = m22 * ratio + m23 * centerRatio;
                    projection[14] = m32 * ratio + m33 * centerRatio;
                    // same as
                    // var matrix = [ 1.0, 0.0, 0.0, 0.0,
                    //     0.0, 1.0, 0.0, 0.0,
                    //     0.0, 0.0, ratio, 0.0,
                    //     0.0, 0.0, center * ratio, 1.0
                    // ];
                    // mat4.mul( projection , matrix, projection );

                    // OSG_INFO << 'Persepective matrix after clamping'<<projection<<std::endl;
                }
                if (resultNearFar !== undefined) {
                    resultNearFar[0] = znear;
                    resultNearFar[1] = zfar;
                }
                return true;
            },

            popCameraModelViewProjectionMatrix: function() {
                this.popModelViewMatrix();
                this.popProjectionMatrix();
            },

            pushCameraModelViewProjectionMatrix: function(camera, modelview, projection) {
                this.pushModelViewMatrix(modelview);
                this.pushProjectionMatrix(projection);
            },

            apply: function(node) {
                this.applyFunctionArray[node.nodeTypeID].call(this, node);
            },

            createOrReuseRenderLeaf: function() {
                return this._pooledLeaf.getOrCreateObject();
            },

            createOrReuseRenderStage: function(classInstance) {
                var type = !classInstance ? 'RenderStage' : classInstance.className();

                if (!this._pooledRenderStages[type]) {
                    var classCtor = !classInstance ? __WEBPACK_IMPORTED_MODULE_15_osg_RenderStage__["a" /* default */] : classInstance.constructor;
                    var createRenderStage = function() {
                        return new classCtor();
                    };
                    this._pooledRenderStages[type] = new __WEBPACK_IMPORTED_MODULE_27_osg_PooledResource__["a" /* default */](createRenderStage);
                }
                return this._pooledRenderStages[type].getOrCreateObject().init();
            },

            // function call after the push state in the geometry apply function
            // the idea is to avoid heavy copy-paste for the rigGeometry apply
            // since the only difference is that we want to push an additional state
            // Maybe it will be useful when we'll add morph target geometry or something...
            postPushGeometry: function(cull, node) {
                var sourceGeometry;
                var geometryStateSetAnimation;

                if (node instanceof __WEBPACK_IMPORTED_MODULE_23_osgAnimation_RigGeometry__["a" /* default */]) {
                    geometryStateSetAnimation = node.getStateSetAnimation();
                    if (geometryStateSetAnimation) cull.pushStateSet(geometryStateSetAnimation);

                    sourceGeometry = node.getSourceGeometry();

                    if (sourceGeometry instanceof __WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__["a" /* default */]) {
                        geometryStateSetAnimation = sourceGeometry.getStateSetAnimation();
                        if (geometryStateSetAnimation) cull.pushStateSet(geometryStateSetAnimation);
                    }
                } else if (node instanceof __WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__["a" /* default */]) {
                    geometryStateSetAnimation = node.getStateSetAnimation();
                    if (geometryStateSetAnimation) cull.pushStateSet(geometryStateSetAnimation);
                }
            },

            // same comment as above (postPushGeometry)
            prePopGeometry: function(cull, node) {
                if (node instanceof __WEBPACK_IMPORTED_MODULE_23_osgAnimation_RigGeometry__["a" /* default */]) {
                    var sourceGeometry = node.getSourceGeometry();

                    if (sourceGeometry instanceof __WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__["a" /* default */]) {
                        if (sourceGeometry.getStateSetAnimation()) cull.popStateSet();
                    }

                    if (node.getStateSetAnimation()) cull.popStateSet();
                } else if (node instanceof __WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__["a" /* default */] && node.getStateSetAnimation()) {
                    cull.popStateSet();
                }
            },

            pushLeaf: function(node, depth) {
                var leafs = this._currentStateGraph.getLeafs();
                if (!leafs.getLength()) {
                    this._currentRenderBin.addStateGraph(this._currentStateGraph);
                }

                var leaf = this.createOrReuseRenderLeaf();

                leaf.init(
                    this._currentStateGraph,
                    node,
                    this.getCurrentProjectionMatrix(),
                    this.getCurrentViewMatrix(),
                    this.getCurrentModelViewMatrix(),
                    this.getCurrentModelMatrix(),
                    depth
                );

                leafs.push(leaf);
            }
        })
    ),
    'osg',
    'CullVisitor'
);

// Camera cull visitor call
// ANY CHANGE, any change : double check in rendere Camera code
// for the first camera
var cameraApply = function(camera) {
    this._numCamera++;

    var stateset = camera.getStateSet();
    if (stateset) this.pushStateSet(stateset);

    var modelview = this._pooledMatrix.getOrCreateObject();
    var projection = this._pooledMatrix.getOrCreateObject();

    if (camera.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_21_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
        var lastProjectionMatrix = this.getCurrentProjectionMatrix();
        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(projection, lastProjectionMatrix, camera.getProjectionMatrix());

        var lastViewMatrix = this.getCurrentModelViewMatrix();
        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(modelview, lastViewMatrix, camera.getViewMatrix());
    } else {
        // absolute
        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].copy(modelview, camera.getViewMatrix());
        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].copy(projection, camera.getProjectionMatrix());
    }

    // save current state of the camera
    var previousZnear = this._computedNear;
    var previousZfar = this._computedFar;

    var previousCullsettings = this._pooledCullSettings.getOrCreateObject();
    previousCullsettings.reset();
    previousCullsettings.setCullSettings(this);

    this._computedNear = Number.POSITIVE_INFINITY;
    this._computedFar = Number.NEGATIVE_INFINITY;
    //

    this.setCullSettings(camera);
    // global override
    // upon who setted the parameter
    // if it's cullvisitor
    // it's an OVERRIDER for enableFrustumCulling
    // allowing for global EnableFrustimCulling
    if (
        previousCullsettings.getSettingSourceOverrider() === this &&
        previousCullsettings.getEnableFrustumCulling()
    ) {
        this.setEnableFrustumCulling(true);
    }

    this.pushCameraModelViewProjectionMatrix(camera, modelview, projection);

    if (camera.getViewport()) {
        this.pushViewport(camera.getViewport());
    }

    // nested camera
    if (camera.getRenderOrder() === __WEBPACK_IMPORTED_MODULE_20_osg_Camera__["a" /* default */].NESTED_RENDER) {
        this.handleCullCallbacksAndTraverse(camera);
    } else {
        var renderBin = this.getCurrentRenderBin();
        var previousStage = renderBin.getStage();

        // use render to texture stage
        var rtts = this.createOrReuseRenderStage(this._rootRenderStage);

        rtts.setCamera(camera);
        rtts.setClearDepth(camera.getClearDepth());
        rtts.setClearColor(camera.getClearColor());
        rtts.setClearMask(camera.getClearMask());

        var viewport = camera.getViewport() ? camera.getViewport() : previousStage.getViewport();
        var scissor = camera.getScissor() ? camera.getScissor() : previousStage.getScissor();
        rtts.setViewport(viewport);
        rtts.setScissor(scissor);

        // skip positional state for now
        // ...

        this.setCurrentRenderBin(rtts);

        this.handleCullCallbacksAndTraverse(camera);

        this.setCurrentRenderBin(renderBin);

        if (camera.getRenderOrder() === __WEBPACK_IMPORTED_MODULE_20_osg_Camera__["a" /* default */].PRE_RENDER) {
            this.getCurrentRenderBin()
                .getStage()
                .addPreRenderStage(rtts, camera.renderOrderNum);
        } else {
            this.getCurrentRenderBin()
                .getStage()
                .addPostRenderStage(rtts, camera.renderOrderNum);
        }
    }

    this.popCameraModelViewProjectionMatrix(camera);

    if (camera.getViewport()) {
        this.popViewport();
    }

    // restore previous state of the camera
    this.setCullSettings(previousCullsettings);
    this._computedNear = previousZnear;
    this._computedFar = previousZfar;

    if (stateset) this.popStateSet();
};

var matrixTransformApply = function(node) {
    this._numMatrixTransform++;

    // Camera and lights must enlarge node parent bounding boxes for this not to cull
    if (this.isCulled(node, this.nodePath)) {
        return;
    }
    // push the culling mode.
    this.pushCurrentMask();

    var matrix = this._pooledMatrix.getOrCreateObject();
    var lastMatrixStack = this.getCurrentModelViewMatrix();
    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].copy(matrix, lastMatrixStack);
    node.computeLocalToWorldMatrix(matrix);
    this.pushModelViewMatrix(matrix);

    var stateset = node.getStateSet();

    if (stateset) this.pushStateSet(stateset);

    this.handleCullCallbacksAndTraverse(node);

    if (stateset) this.popStateSet();

    this.popModelViewMatrix();

    // pop the culling mode.
    this.popCurrentMask();
};

var projectionApply = function(node) {
    this._numProjection++;

    var lastMatrixStack = this.getCurrentProjectionMatrix();
    var matrix = this._pooledMatrix.getOrCreateObject();
    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(matrix, lastMatrixStack, node.getProjectionMatrix());
    this.pushProjectionMatrix(matrix);

    var stateset = node.getStateSet();
    if (stateset) this.pushStateSet(stateset);

    this.handleCullCallbacksAndTraverse(node);

    if (stateset) this.popStateSet();

    this.popProjectionMatrix();
};

// here it's treated as a group node for culling
// as there's isn't any in osgjs
// so frustumCulling is done here
var nodeApply = function(node) {
    this._numNode++;

    // Camera and lights must enlarge node parent bounding boxes for this not to cull
    if (this.isCulled(node, this.nodePath)) {
        return;
    }

    // push the culling mode.
    this.pushCurrentMask();

    var stateset = node.getStateSet();
    if (stateset) this.pushStateSet(stateset);

    this.handleCullCallbacksAndTraverse(node);

    if (stateset) this.popStateSet();

    // pop the culling mode.
    this.popCurrentMask();
};

var lightSourceApply = function(node) {
    this._numLightSource++;

    var stateset = node.getStateSet();
    if (stateset) this.pushStateSet(stateset);

    var light = node.getLight();
    if (light) {
        if (node.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_21_osg_transformEnums__["a" /* default */].RELATIVE_RF)
            this.addPositionedAttribute(this.getCurrentModelViewMatrix(), light);
        else this.addPositionedAttribute(null, light);
    }

    this.handleCullCallbacksAndTraverse(node);

    if (stateset) this.popStateSet();
};

var tempVec = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
var loggedOnce = false;
var geometryApply = function(node) {
    this._numGeometry++;

    var modelview = this.getCurrentModelViewMatrix();
    var bb = node.getBoundingBox();
    if (this._computeNearFar && bb.valid()) {
        if (!this.updateCalculatedNearFar(modelview, node)) {
            return;
        }
    }

    // using modelview is not a pb because geometry
    // is a leaf node, else traversing the graph would be an
    // issue because we use modelview after
    var ccb = node.getCullCallback();
    if (ccb && !ccb.cull(node, this)) return;

    var stateset = node.getStateSet();
    if (stateset) this.pushStateSet(stateset);

    this.postPushGeometry(this, node);

    var depth = 0;
    if (bb.valid()) {
        depth = this.distance(bb.center(tempVec), modelview);
    }
    if (__WEBPACK_IMPORTED_MODULE_2_osg_math__["a" /* default */].isNaN(depth)) {
        if (!loggedOnce) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('warning geometry has a NaN depth, ' + modelview + ' center ' + tempVec);
            loggedOnce = true;
        }
    } else {
        this.pushLeaf(node, depth);
    }

    this.prePopGeometry(this, node);
    if (stateset) this.popStateSet();
};

__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_16_osg_Node__["a" /* default */].nodeTypeID, nodeApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_18_osg_Switch__["a" /* default */].nodeTypeID, nodeApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_19_osg_PagedLOD__["a" /* default */].nodeTypeID, nodeApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_20_osg_Camera__["a" /* default */].nodeTypeID, cameraApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_7_osg_MatrixTransform__["a" /* default */].nodeTypeID, matrixTransformApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_9_osg_Projection__["a" /* default */].nodeTypeID, projectionApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_12_osg_Geometry__["a" /* default */].nodeTypeID, geometryApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_22_osgAnimation_Skeleton__["a" /* default */].nodeTypeID, matrixTransformApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_24_osgAnimation_Bone__["a" /* default */].nodeTypeID, matrixTransformApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_8_osg_AutoTransform__["a" /* default */].nodeTypeID, matrixTransformApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_17_osg_Lod__["a" /* default */].nodeTypeID, nodeApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_10_osg_LightSource__["a" /* default */].nodeTypeID, lightSourceApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_23_osgAnimation_RigGeometry__["a" /* default */].nodeTypeID, geometryApply);
__WEBPACK_IMPORTED_MODULE_11_osg_cullVisitorHelper__["default"].registerApplyFunction(__WEBPACK_IMPORTED_MODULE_25_osgAnimation_MorphGeometry__["a" /* default */].nodeTypeID, geometryApply);

/* harmony default export */ __webpack_exports__["a"] = (CullVisitor);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_MatrixTransform__ = __webpack_require__(15);





/**
 *  AnimationUpdateCallback
 *  @class AnimationUpdateCallback
 */
var AnimationUpdateCallback = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);
};

// check if the path is animated, it could be elsewhere though
AnimationUpdateCallback.checkPathIsAnimated = function(path) {
    for (var i = 0, nbNodes = path.length; i < nbNodes; ++i) {
        var node = path[i];

        if (node instanceof __WEBPACK_IMPORTED_MODULE_3_osg_MatrixTransform__["a" /* default */]) {
            var ups = node.getUpdateCallbackList();
            for (var j = 0, nbUp = ups.length; j < nbUp; ++j) {
                if (ups[j] instanceof AnimationUpdateCallback) return true;
            }
        }
    }

    return false;
};

/** @lends AnimationUpdateCallback.prototype */
__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    AnimationUpdateCallback,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        linkChannel: function() {},
        linkAnimation: function(anim) {
            var name = this.getName();
            if (name.length === 0) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('no name on an update callback, discard');
                return 0;
            }
            var nbLinks = 0;
            var channels = anim.getChannels();
            for (var i = 0, l = channels.length; i < l; i++) {
                var channel = channels[i];
                if (channel.getTargetName() === name) {
                    this.linkChannel(channel);
                    nbLinks++;
                }
            }
            return nbLinks;
        }
    }),
    'osgAnimation',
    'AnimationUpdateCallback'
);

/* harmony default export */ __webpack_exports__["a"] = (AnimationUpdateCallback);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);








// use the same kind of opengl lights
// see http://www.glprogramming.com/red/chapter05.html

var Light = function(lightNum, disable) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    var lightNumber = lightNum !== undefined ? lightNum : 0;

    this._ambient = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0.2, 0.2, 0.2, 1.0);
    this._diffuse = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0.8, 0.8, 0.8, 1.0);
    this._specular = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0.2, 0.2, 0.2, 1.0);

    // Default is directional as postion[3] is 0
    this._position = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 1.0, 0.0);
    this._direction = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, -1.0);

    // TODO : refactor lights management w=1.0 (isHemi), w=-1.0
    // (isNotHemi) _ground contains the color but w says if it's
    // an hemi or not
    this._ground = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(0.2, 0.2, 0.2, -1.0);

    this._spotCutoff = 180.0;
    this._spotBlend = 0.01;

    // the array contains constant, linear, quadratic factor
    this._attenuation = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.0, 0.0, 0.0);

    this._lightNumber = lightNumber;

    this._enable = !disable;
    this._dirtyHash = true;
    this._hash = '';
};

Light.DIRECTION = 'DIRECTION';
Light.SPOT = 'SPOT';
Light.POINT = 'POINT';
Light.HEMI = 'HEMI';

Light.uniforms = {};
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Light,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Light',

        cloneType: function() {
            return new Light(this._lightNumber, true);
        },

        getTypeMember: function() {
            return this.attributeType + this._lightNumber;
        },

        getUniformName: function(name) {
            return 'u' + this.getTypeMember() + '_' + name;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },

        _computeInternalHash: function() {
            return this.getTypeMember() + this.getLightType() + this.isEnabled().toString();
        },
        getOrCreateUniforms: function() {
            var obj = Light;
            var typeMember = this.getTypeMember();

            if (obj.uniforms[typeMember]) return obj.uniforms[typeMember];

            obj.uniforms[typeMember] = {
                viewPosition: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('viewPosition')),
                viewDirection: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat3(this.getUniformName('viewDirection')),
                modelViewMatrix: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createMatrix4(this.getUniformName('modelViewMatrix')),
                modelViewNormalMatrix: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createMatrix3(
                    this.getUniformName('modelViewNormalMatrix')
                ),

                ambient: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('ambient')),
                diffuse: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('diffuse')),
                specular: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('specular')),
                attenuation: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('attenuation')),

                spotCutOff: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat1(this.getUniformName('spotCutOff')),
                spotBlend: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat1(this.getUniformName('spotBlend')),
                ground: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('ground'))
            };

            return obj.uniforms[typeMember];
        },

        // enable / disable is not implemented in uniform
        // we should add it
        isEnabled: function() {
            return this._enable;
        },

        setEnabled: function(bool) {
            this._enable = bool;
            this._dirtyHash = true;
        },

        // colors
        setAmbient: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].copy(this._ambient, a);
        },

        getAmbient: function() {
            return this._ambient;
        },

        setDiffuse: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].copy(this._diffuse, a);
        },

        getDiffuse: function() {
            return this._diffuse;
        },

        setSpecular: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].copy(this._specular, a);
        },

        getSpecular: function() {
            return this._specular;
        },

        // position, also used for directional light
        // position[3] === 0 means directional
        // see creating lightsources http://www.glprogramming.com/red/chapter05.html
        setPosition: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].copy(this._position, a);
        },

        getPosition: function() {
            return this._position;
        },

        // unused for directional
        setDirection: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(this._direction, a);
        },

        getDirection: function() {
            return this._direction;
        },

        setSpotCutoff: function(a) {
            this._spotCutoff = a;
        },

        getSpotCutoff: function() {
            return this._spotCutoff;
        },

        setSpotBlend: function(a) {
            this._spotBlend = a;
        },

        getSpotBlend: function() {
            return this._spotBlend;
        },

        // set/get the color of the ground
        setGround: function(a) {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(this._ground, a);
        },

        getGround: function() {
            return this._ground;
        },

        // attenuation coeff
        setConstantAttenuation: function(value) {
            this._attenuation[0] = value;
        },

        getConstantAttenuation: function() {
            return this._attenuation[0];
        },

        setLinearAttenuation: function(value) {
            this._attenuation[1] = value;
        },

        getLinearAttenuation: function() {
            return this._attenuation[1];
        },

        setQuadraticAttenuation: function(value) {
            this._attenuation[2] = value;
        },

        getQuadraticAttenuation: function() {
            return this._attenuation[2];
        },

        setLightType: function(type) {
            if (type === Light.DIRECTION) return this.setLightAsDirection();
            else if (type === Light.SPOT) return this.setLightAsSpot();
            else if (type === Light.HEMI) return this.setLightAsHemi();
            return this.setLightAsPoint();
        },

        getLightType: function() {
            if (this.isDirectionLight()) return Light.DIRECTION;
            else if (this.isSpotLight()) return Light.SPOT;
            else if (this.isHemiLight()) return Light.HEMI;
            return Light.POINT;
        },

        setLightAsSpot: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(this._position, 0.0, 0.0, 0.0, 1.0);
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].set(this._direction, 0.0, 0.0, -1.0);
            this._ground[3] = -1.0;
            this._spotCutoff = 90;
            this._dirtyHash = true;
        },

        setLightAsPoint: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(this._position, 0.0, 0.0, 0.0, 1.0);
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].set(this._direction, 0.0, 0.0, -1.0);
            this._ground[3] = -1.0;
            this._dirtyHash = true;
        },

        setLightAsDirection: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(this._position, 0.0, 0.0, 1.0, 0.0);
            this._spotCutoff = 180;
            this._ground[3] = -1.0;
            this._dirtyHash = true;
        },

        setLightAsHemi: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(this._position, 0.0, 0.0, 1.0, 0.0);
            this._spotCutoff = 180;
            this._ground[3] = 1.0;
            this._dirtyHash = true;
        },

        setLightNumber: function(unit) {
            this._lightNumber = unit;
            this._dirtyHash = true;
        },

        getLightNumber: function() {
            return this._lightNumber;
        },

        // internal helper
        isSpotLight: function() {
            return this._spotCutoff < 180.0;
        },

        isDirectionLight: function() {
            return this._position[3] === 0.0 && this._ground[3] === -1.0;
        },

        isHemiLight: function() {
            return this._ground[3] === 1.0;
        },

        // matrix is current model view, which can mean:
        // world (node refAbsolute)
        // world+camera (camera is refAbsolute)
        // world+camera+camera+... (camera relative...)
        applyPositionedUniform: function(matrix) {
            var uniformMap = this.getOrCreateUniforms();

            var modelView = uniformMap.modelViewMatrix.getInternalArray();
            var modelViewNormal = uniformMap.modelViewNormalMatrix.getInternalArray();
            var viewPosition = uniformMap.viewPosition.getInternalArray();
            var viewDirection = uniformMap.viewDirection.getInternalArray();

            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(modelView, matrix);
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["b" /* mat3 */].normalFromMat4(modelViewNormal, matrix);

            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].transformMat4(viewPosition, this._position, modelView);
            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].transformMat3(viewDirection, this._direction, modelViewNormal);
        },

        apply: function() {
            if (!this._enable) return;

            var uniformMap = this.getOrCreateUniforms();

            if (this.isSpotLight()) {
                var spotsize = Math.cos(this._spotCutoff * Math.PI / 180.0);
                uniformMap.spotCutOff.setFloat(spotsize);
                uniformMap.spotBlend.setFloat((1.0 - spotsize) * this._spotBlend);
            }

            if (this.isHemiLight()) {
                uniformMap.ground.setFloat4(this._ground);
            }

            uniformMap.attenuation.setFloat4(this._attenuation);
            uniformMap.diffuse.setFloat4(this._diffuse);
            uniformMap.specular.setFloat4(this._specular);
            uniformMap.ambient.setFloat4(this._ambient);
        }
    }),
    'osg',
    'Light'
);

/* harmony default export */ __webpack_exports__["a"] = (Light);


/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);


var requestFileFromURL = function(url, options) {
    return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function(resolve, reject) {
        var req = new XMLHttpRequest();
        req.open('GET', url, true);

        // handle responseType
        if (options && options.responseType) req.responseType = options.responseType;

        if (options && options.progress) {
            req.addEventListener('progress', options.progress, false);
        }

        req.addEventListener('error', reject, false);

        req.addEventListener('load', function() {
            if (req.responseType === 'arraybuffer' || req.responseType === 'blob')
                resolve(req.response);
            else resolve(req.responseText);
        });

        req.send(null);
    });
};

var requestFileFromReader = function(file, options) {
    return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function(resolve) {
        var reader = new window.FileReader();
        reader.onload = function(data) {
            if (options.responseType === 'blob') {
                var img = new window.Image();
                img.src = data.target.result;
                resolve(img);
            } else {
                resolve(data.target.result);
            }
        };
        // handle responseType
        if (options && options.responseType) {
            if (options.responseType === 'arraybuffer') reader.readAsArrayBuffer(file);
            else if (options.responseType === 'string') reader.readAsText(file);
            else reader.readAsDataURL(file);
        } else {
            reader.readAsText(file);
        }
    });
};

var requestFile = function(urlOrFile, options) {
    if (typeof urlOrFile === 'string') {
        return requestFileFromURL(urlOrFile, options);
    } else {
        return requestFileFromReader(urlOrFile, options);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (requestFile);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


/**
 * This is a very simplistic version of the OSG registry, we could
 * expand/improve it in the future
 */

var Registry = {
    instance: function() {
        if (!Registry._instance) {
            Registry._instance = Registry;
            Registry._instance.plugins = new window.Map();
        }
        return Registry._instance;
    },

    // We register directly a plugin for a extension.
    addReaderWriter: function(extension, plugin) {
        if (Registry.instance().plugins.get(extension) !== undefined)
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn("the '" + extension + "' plugin already exists");
        Registry.instance().plugins.set(extension, plugin);
    },

    getReaderWriterForExtension: function(name) {
        return Registry.instance().plugins.get(name);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Registry);


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__ = __webpack_require__(11);







var IntersectionVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);
    // We could need to use a stack of intersectors in case we want
    // to use several intersectors. Right now we use only one.
    this._intersector = undefined;

    this._projectionStack = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__["a" /* default */]();
    this._modelStack = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__["a" /* default */]();
    this._viewStack = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__["a" /* default */]();
    this._windowStack = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__["a" /* default */]();
    this._pooledMatrix = new __WEBPACK_IMPORTED_MODULE_3_osg_PooledResource__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create);

    this.reset();
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    IntersectionVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        reset: function() {
            this._pooledMatrix.reset();
            this._viewStack.reset();
            this._modelStack.reset();
            this._projectionStack.reset();
            this._windowStack.reset();

            this._viewStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
            this._modelStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
            this._projectionStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
            this._windowStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
        },
        setIntersector: function(intersector) {
            this._intersector = intersector;
        },
        getIntersector: function() {
            return this._intersector;
        },
        // Model matrix
        pushModelMatrix: function(matrix) {
            this._modelStack.push(matrix);
        },
        getModelMatrix: function() {
            return this._modelStack.back();
        },
        popModelMatrix: function() {
            return this._modelStack.pop();
        },
        // View Matrix
        pushViewMatrix: function(matrix) {
            this._viewStack.push(matrix);
        },
        getViewMatrix: function() {
            return this._viewStack.back();
        },
        popViewMatrix: function() {
            return this._viewStack.pop();
        },
        // Projection Matrix
        pushProjectionMatrix: function(matrix) {
            this._projectionStack.push(matrix);
        },
        getProjectionMatrix: function() {
            return this._projectionStack.back();
        },
        popProjectionMatrix: function() {
            return this._projectionStack.pop();
        },
        // Window Matrix
        pushWindowMatrix: function(matrix) {
            this._windowStack.push(matrix);
        },
        pushWindowMatrixUsingViewport: function(viewport) {
            this._windowStack.push(
                viewport.computeWindowMatrix(this._pooledMatrix.getOrCreateObject())
            );
        },
        getWindowMatrix: function() {
            return this._windowStack.back();
        },
        popWindowMatrix: function() {
            return this._windowStack.pop();
        },
        getTransformation: (function() {
            // We should move this to the intersector when we need to use different coordinate frames
            // Now we only support WINDOW coordinate frame

            // /!\ 64 bit precision because the picking is jittery otherwise
            // It's probably caused by one of the camera matrix that has too big/small values
            // but currently it's the ony fix we have
            var mat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create64();

            return function() {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(mat, this.getWindowMatrix());
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(mat, mat, this.getProjectionMatrix());
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(mat, mat, this.getViewMatrix());
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(mat, mat, this.getModelMatrix());

                return mat;
            };
        })(),

        enter: function(node) {
            // Call to each intersector
            return this._intersector.enter(node);
        },

        apply: function(node) {
            // Here we need to decide which apply method to use
            if (node.getViewMatrix) {
                // It's a Camera
                this.applyCamera(node);
            } else {
                if (node.getMatrix) {
                    // It's a Transform Node
                    this.applyTransform(node);
                } else {
                    // It's a leaf or an intermediate node
                    this.applyNode(node);
                }
            }
        },

        applyCamera: function(camera) {
            // We use an absolute reference frame for simplicity
            var vp = camera.getViewport();
            if (vp !== undefined) {
                this.pushWindowMatrixUsingViewport(vp);
            }

            var projection, view, model;
            if (
                camera.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].RELATIVE_RF &&
                this.getViewMatrix() &&
                this.getProjectionMatrix()
            ) {
                // relative
                projection = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(
                    this._pooledMatrix.getOrCreateObject(),
                    this.getProjectionMatrix(),
                    camera.getProjectionMatrix()
                );
                view = this.getViewMatrix();
                model = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(
                    this._pooledMatrix.getOrCreateObject(),
                    this.getModelMatrix(),
                    camera.getViewMatrix()
                );
            } else {
                // absolute
                projection = camera.getProjectionMatrix();
                view = camera.getViewMatrix();
                model = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].identity(this._pooledMatrix.getOrCreateObject());
            }

            this.pushProjectionMatrix(projection);
            this.pushViewMatrix(view);
            this.pushModelMatrix(model);

            // TODO maybe we should do something like OSG for the transformation given
            // to the intersector (having a stack)
            this._intersector.setCurrentTransformation(this.getTransformation());
            this.traverse(camera);

            this.popModelMatrix();
            this.popViewMatrix();
            this.popProjectionMatrix();
            if (vp !== undefined) {
                this.popWindowMatrix();
            }
            this._intersector.setCurrentTransformation(this.getTransformation());
        },

        applyNode: function(node) {
            if (!this.enter(node)) return;
            // As this part of the code is potentially executed a lot of times we don't use instanceof
            // https://jsperf.com/instanceof-performance/25
            if (node.getPrimitiveSetList) {
                this._intersector.intersect(this, node);
                // If it is a leaf (it has primitives) we can safely return
                return;
            }
            if (node.traverse) {
                this.traverse(node);
            }
        },

        applyTransform: function(node) {
            // Now only use PROJECTION coordinate frame
            if (!this.enter(node)) return;
            // Accumulate Transform
            if (node.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) {
                var matrix = this._pooledMatrix.getOrCreateObject();
                this.pushViewMatrix(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].identity(matrix));
                this.pushModelMatrix(node.getMatrix());
            } else if (this._modelStack.getLength() > 0) {
                var m = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(this._pooledMatrix.getOrCreateObject(), this.getModelMatrix());
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(m, m, node.getMatrix());
                this.pushModelMatrix(m);
            } else {
                this.pushModelMatrix(node.getMatrix());
            }

            // TODO see above
            this._intersector.setCurrentTransformation(this.getTransformation());
            this.traverse(node);

            this.popModelMatrix();
            if (node.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) this.popViewMatrix();
            this._intersector.setCurrentTransformation(this.getTransformation());
        }
    }),
    'osgUtil',
    'IntersectionVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (IntersectionVisitor);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_LineSegmentIntersectFunctor__ = __webpack_require__(139);






var LineSegmentIntersector = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__["a" /* default */].call(this);

    this._start = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._iStart = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

    this._end = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._iEnd = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

    // only used for lines and points
    this._threshold = 0.0;
    this._iThreshold = 0.0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    LineSegmentIntersector,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__["a" /* default */].prototype, {
        set: function(start, end, threshold) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._start, start);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iStart, start);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._end, end);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iEnd, end);

            if (threshold !== undefined) {
                this._threshold = this._iThreshold = threshold;
            }
        },

        setStart: function(start) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._start, start);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iStart, start);
        },

        setEnd: function(end) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._end, end);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iEnd, end);
        },

        intersectNode: function(node) {
            // TODO implement intersectBoundingBox?
            return this.intersectBoundingSphere(node.getBoundingSphere());
        },

        // Intersection Segment/Sphere
        intersectBoundingSphere: (function() {
            var sm = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var se = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(bsphere) {
                // test for _start inside the bounding sphere
                if (!bsphere.valid()) return false;
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(sm, this._iStart, bsphere.center());
                var c = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(sm) - bsphere.radius2();
                if (c <= 0.0) {
                    return true;
                }
                // solve quadratic equation
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(se, this._iEnd, this._iStart);
                var a = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(se);
                var b = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(sm, se) * 2.0;
                var d = b * b - 4.0 * a * c;
                // no intersections if d<0
                if (d < 0.0) {
                    return false;
                }
                // compute two solutions of quadratic equation
                d = Math.sqrt(d);
                var div = 0.5 / a;
                var r1 = (-b - d) * div;
                var r2 = (-b + d) * div;

                // return false if both intersections are before the ray start
                if (r1 <= 0.0 && r2 <= 0.0) {
                    return false;
                }

                if (r1 > 1.0 && r2 > 1.0) {
                    return false;
                }
                return true;
            };
        })(),

        intersect: (function() {
            var functor = new __WEBPACK_IMPORTED_MODULE_3_osgUtil_LineSegmentIntersectFunctor__["a" /* default */]();

            return function(iv, node) {
                functor.setGeometry(node);
                functor.setIntersectionVisitor(iv);
                functor.setIntersector(this);

                functor.set(this._iStart, this._iEnd, this._iThreshold);

                var kdtree = node.getShape();
                if (kdtree) {
                    kdtree.intersectLineSegment(
                        functor,
                        kdtree.getNodes()[0],
                        this._iStart,
                        this._iEnd,
                        this._iThreshold
                    );
                    return;
                } else {
                    // handle rig transformed vertices
                    if (node.computeTransformedVertices) {
                        functor.setVertices(node.computeTransformedVertices());
                    }

                    functor.apply(node);
                }

                functor.reset();
            };
        })(),

        setCurrentTransformation: function(matrix) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(matrix, matrix);

            if (this._threshold > 0.0) {
                var tmp = this._iStart;
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].getScale(tmp, matrix);
                var x = tmp[0];
                var y = tmp[1];
                var z = tmp[2];
                this._iThreshold = this._threshold * (x > y ? (x > z ? x : z) : y > z ? y : z);
            }
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(this._iStart, this._start, matrix);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(this._iEnd, this._end, matrix);
        }
    }),
    'osgUtil',
    'LineSegmentIntersector'
);

/* harmony default export */ __webpack_exports__["a"] = (LineSegmentIntersector);


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_Compiler__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShader_ShaderProcessor__ = __webpack_require__(63);






var ShaderGenerator = function() {
    this._cache = {};

    // ShaderProcessor singleton used by ShaderGenerator
    // but user can replace it if needed
    this._shaderProcessor = new __WEBPACK_IMPORTED_MODULE_5_osgShader_ShaderProcessor__["a" /* default */]();

    // ShaderCompiler Object to instanciate
    this._ShaderCompiler = undefined;

    this.setShaderCompiler(__WEBPACK_IMPORTED_MODULE_4_osgShader_Compiler__["a" /* default */]);
};

ShaderGenerator.prototype = {
    // setShaderCompiler that will be used to createShader
    setShaderCompiler: function(ShaderCompiler) {
        this._ShaderCompiler = ShaderCompiler;
        if (!ShaderCompiler._validAttributeTypeMemberCache)
            this._computeStateAttributeCache(ShaderCompiler);
    },

    getShaderCompiler: function() {
        return this._ShaderCompiler;
    },

    getShaderProcessor: function() {
        return this._shaderProcessor;
    },

    setShaderProcessor: function(shaderProcessor) {
        this._shaderProcessor = shaderProcessor;
    },

    // filter input types and write the result in the outputs array
    filterAttributeTypes: function(attribute) {
        // works for attribute that contains isEnabled
        // Light, Shadow. It let us to filter them to build a shader if not enabled
        if (attribute.isEnabled && !attribute.isEnabled()) return true;

        return false;
    },

    // get actives attribute that comes from state listed by compiler cache type
    getActiveAttributeList: function(state, list) {
        var hash = '';
        var _attributeArray = state._attributeArray;
        var cacheType = this._ShaderCompiler._validAttributeTypeMemberCache;

        for (var j = 0, k = cacheType.length; j < k; j++) {
            var type = cacheType[j];
            var attributeStack = type < _attributeArray.length ? _attributeArray[type] : undefined;
            if (!attributeStack) continue;

            var attribute = attributeStack._lastApplied;

            if (!attribute || this.filterAttributeTypes(attribute)) continue;

            hash += attribute.getHash();
            list.push(attribute);
        }

        return hash;
    },

    // create a hash from actives attribute listed by compiler cache type
    getActiveAttributeListCache: function(state) {
        var hash = '';

        var cacheType = this._ShaderCompiler._validAttributeTypeMemberCache;
        for (var i = 0, l = cacheType.length; i < l; i++) {
            var type = cacheType[i];
            var attributeStack =
                type < state._attributeArray.length ? state._attributeArray[type] : undefined;
            if (attributeStack) {
                var attribute = attributeStack._lastApplied;
                if (!attribute || this.filterAttributeTypes(attribute)) continue;

                hash += attributeStack._lastApplied.getHash();
            }
        }

        return hash;
    },

    // create a hash from actives texture attribute listed by compiler cache type
    getActiveTextureAttributeListCache: function(state) {
        var hash = '';

        var cacheType = this._ShaderCompiler._validTextureAttributeTypeMemberCache;
        var textureUnitList = state._textureAttributeArrayList;
        for (var j = 0; j < textureUnitList.length; j++) {
            var textureUnit = textureUnitList[j];
            if (!textureUnit) continue;

            var textureUnitLength = textureUnit.length;
            for (var i = 0; i < cacheType.length; i++) {
                var type = cacheType[i];
                var attributeStack = type < textureUnitLength ? textureUnit[type] : undefined;
                if (attributeStack) {
                    var attribute = attributeStack._lastApplied;

                    if (
                        !attribute ||
                        this.filterAttributeTypes(attribute) ||
                        attribute.isTextureNull()
                    )
                        continue;

                    // we check to filter texture null in hash
                    // but it's probably better to just set the hash correctly of a tetxure null, to remove this custom code
                    hash += attribute.getHash();
                }
            }
        }

        return hash;
    },

    // get actives texture attribute that comes from state
    getActiveTextureAttributeList: function(state, list) {
        var hash = '';
        var _attributeArrayList = state._textureAttributeArrayList;
        var i, l;
        var cacheType = this._ShaderCompiler._validTextureAttributeTypeMemberCache;

        for (i = 0, l = _attributeArrayList.length; i < l; i++) {
            var _attributeArrayForUnit = _attributeArrayList[i];

            if (!_attributeArrayForUnit) continue;

            list[i] = [];

            for (var j = 0, m = cacheType.length; j < m; j++) {
                var type = cacheType[j];

                var attributeStack =
                    type < _attributeArrayForUnit.length ? _attributeArrayForUnit[type] : undefined;
                if (!attributeStack) continue;

                var attribute = attributeStack._lastApplied;
                if (!attribute || this.filterAttributeTypes(attribute) || attribute.isTextureNull())
                    continue;

                hash += attribute.getHash();
                list[i].push(attribute);
            }
        }
        return hash;
    },

    getActiveUniforms: function(state, attributeList, textureAttributeList) {
        var uniforms = {};

        for (var i = 0, l = attributeList.length; i < l; i++) {
            var at = attributeList[i];
            if (at.getOrCreateUniforms) {
                var attributeUniformMap = at.getOrCreateUniforms();
                // It could happen that uniforms are declared conditionally
                if (attributeUniformMap !== undefined) {
                    for (var keyAttribute in attributeUniformMap) {
                        var uniform = attributeUniformMap[keyAttribute];
                        uniforms[uniform.getName()] = uniform;
                    }
                }
            }
        }

        for (var a = 0, n = textureAttributeList.length; a < n; a++) {
            var tat = textureAttributeList[a];
            if (tat) {
                for (var b = 0, o = tat.length; b < o; b++) {
                    var attr = tat[b];

                    var texUniformMap = attr.getOrCreateUniforms(a);

                    for (var tname in texUniformMap) {
                        var tuniform = texUniformMap[tname];
                        uniforms[tuniform.getName()] = tuniform;
                    }
                }
            }
        }

        return uniforms;
    },

    _computeStateAttributeCache: function(CompilerShader) {
        var typeMemberNames = CompilerShader.stateAttributeConfig.attribute || [];
        var validTypeMemberList = [];
        var typeMemberName;
        var i, il, cache;
        var id;
        for (i = 0, il = typeMemberNames.length; i < il; i++) {
            typeMemberName = typeMemberNames[i];
            id = __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].getIdFromTypeMember(typeMemberName);
            if (id !== undefined) {
                if (validTypeMemberList.indexOf(id) !== -1) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                        'Compiler ' +
                            CompilerShader.name +
                            ' contains duplicate attribute entry ' +
                            typeMemberName +
                            ', check the Compiler configuration'
                    );
                } else {
                    validTypeMemberList.push(id);
                }
            }
        }
        cache = new Uint8Array(validTypeMemberList);
        CompilerShader._validAttributeTypeMemberCache = cache;

        typeMemberNames = CompilerShader.stateAttributeConfig.textureAttribute || [];
        validTypeMemberList = [];
        for (i = 0, il = typeMemberNames.length; i < il; i++) {
            typeMemberName = typeMemberNames[i];
            id = __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].getTextureIdFromTypeMember(typeMemberName);
            if (validTypeMemberList.indexOf(id) !== -1) {
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                    'Compiler ' +
                        CompilerShader.name +
                        ' contains duplicate texture attribute entry ' +
                        typeMemberName +
                        ', check the Compiler configuration'
                );
            } else {
                validTypeMemberList.push(id);
            }
        }
        cache = new Uint8Array(validTypeMemberList);
        CompilerShader._validTextureAttributeTypeMemberCache = cache;
    },

    getOrCreateProgram: (function() {
        var textureAttributes = [];
        var attributes = [];

        return function(state) {
            // extract valid attributes

            // use ShaderCompiler, it can be overrided by a custom one
            var ShaderCompiler = this._ShaderCompiler;

            var hash =
                this.getActiveAttributeListCache(state) +
                this.getActiveTextureAttributeListCache(state);

            var cache = this._cache[hash];
            if (cache !== undefined) return cache;

            // slow path to generate shader
            attributes.length = 0;
            textureAttributes.length = 0;

            this.getActiveAttributeList(state, attributes);
            this.getActiveTextureAttributeList(state, textureAttributes);

            var shaderGen = new ShaderCompiler(
                attributes,
                textureAttributes,
                this._shaderProcessor
            );


            var fragmentshader = shaderGen.createFragmentShader();
            var vertexshader = shaderGen.createVertexShader();

            var program = new __WEBPACK_IMPORTED_MODULE_2_osg_Program__["a" /* default */](
                new __WEBPACK_IMPORTED_MODULE_3_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_Shader__["a" /* default */].VERTEX_SHADER, vertexshader),
                new __WEBPACK_IMPORTED_MODULE_3_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentshader)
            );

            program.hash = hash;
            program.setActiveUniforms(this.getActiveUniforms(state, attributes, textureAttributes));
            program.generated = true;

            this._cache[hash] = program;
            return program;
        };
    })(),

    resetCache: function(){
        this._cache = {};
    }

};

/* harmony default export */ __webpack_exports__["a"] = (ShaderGenerator);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_nodeFactory__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_CompilerVertex__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShader_CompilerFragment__ = __webpack_require__(232);







var Compiler = function(attributes, textureAttributes, shaderProcessor) {
    this._attributes = attributes;
    this._textureAttributes = textureAttributes;

    this._fragmentShaderMode = false; // current context

    this._activeNodeMap = {};
    this._compiledNodeMap = {};
    this._traversedNodeMap = {};

    this._variables = {};
    this._varyings = {};
    this._vertexShader = [];
    this._fragmentShader = [];

    this._shaderProcessor = shaderProcessor;
    this._texturesByName = {};

    // TODO: Have to handle better textures
    // 4 separate loop over texture list: one here, one for declareTexture, 2 for vertexShader (varying decl + varying store)
    // (not counting loops done above in shader generator)

    this._shadowsTextures = [];
    this._lights = [];
    this._shadows = [];
    this._textures = [];
    this._material = null;

    this._invariantPosition = false;
    this._isBillboard = false;

    // Important: if not using Compiler for Both VS and FS Check either of those
    // it allow override by custom Processor of some check between the VS & FS pass (varying mostly)
    this._customVertexShader = false;
    this._customFragmentShader = false;

    // from Attributes to variables to build shader nodes graph from
    this.initAttributes();
    this.initTextureAttributes();
};

Compiler.cloneStateAttributeConfig = function(compilerClass) {
    return JSON.parse(JSON.stringify(compilerClass.stateAttributeConfig));
};

Compiler.setStateAttributeConfig = function(compilerClass, config) {
    compilerClass.stateAttributeConfig = config;

    config.attribute.forEach(__WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndexFromName);
    config.textureAttribute.forEach(__WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].getOrCreateTextureStateAttributeTypeMemberIndexFromName);

    compilerClass.validAttributeTypeMember = config.attribute;
    compilerClass.validTextureAttributeTypeMember = config.textureAttribute;
};

Compiler.setStateAttributeConfig(Compiler, {
    attribute: [
        'Light0',
        'ShadowReceive0',
        'Light1',
        'ShadowReceive1',
        'Light2',
        'ShadowReceive2',
        'Light3',
        'ShadowReceive3',
        'Light4',
        'Light5',
        'Light6',
        'Light7',
        'Material',
        'PointSize',
        'Billboard',
        'Morph',
        'Skinning'
    ],
    textureAttribute: ['Texture']
});

Compiler.prototype = __WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].extend({}, __WEBPACK_IMPORTED_MODULE_4_osgShader_CompilerVertex__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5_osgShader_CompilerFragment__["a" /* default */], {
    constructor: Compiler,

    createFragmentShader: function() {
        this._fragmentShaderMode = true;
        return this._createFragmentShader();
    },

    createVertexShader: function() {
        this._fragmentShaderMode = false;
        return this._createVertexShader();
    },

    getOrCreateProjectionMatrix: function() {
        return this.getOrCreateUniform('mat4', 'uProjectionMatrix');
    },

    getCompilerName: function() {
        return this._material ? 'CompilerOSGJS' : 'NoMaterialCompilerOSGJS';
    },

    getFragmentShaderName: function() {
        var compilerName = this.getCompilerName();

        var materialName = this._material && this._material.getName();
        if (materialName) {
            // escape everything but letter and number
            materialName = materialName.replace(/[^a-zA-Z0-9]+/g, '_').slice(0, 20);
            compilerName += '(' + materialName + ')';
        }

        return compilerName;
    },

    getVertexShaderName: function() {
        return this.getFragmentShaderName();
    },

    getDebugIdentifier: function() {
        var vname = this.getVertexShaderName();
        var fname = this.getFragmentShaderName();
        return vname === fname ? fname : vname + '|' + fname;
    },

    logError: function(msg) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(this.getDebugIdentifier() + ' : ' + msg);
    },

    logWarn: function(msg) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(this.getDebugIdentifier() + ' : ' + msg);
    },

    getOrCreateConstantOne: function(type) {
        return this.getOrCreateConstant(type, type + 'White').setValue(type + '(1.0)');
    },

    getOrCreateConstantZero: function(type) {
        return this.getOrCreateConstant(type, type + 'Black').setValue(type + '(0.0)');
    },

    initAttributes: function() {
        var attributes = this._attributes;
        var lights = this._lights;
        var shadows = this._shadows;
        for (var i = 0, l = attributes.length; i < l; i++) {
            var type = attributes[i].className();

            // Test one light at a time
            if (type === 'Light') {
                // && lights.length === 0) {
                lights.push(attributes[i]);
            } else if (type === 'Material') {
                this._material = attributes[i];
            } else if (type === 'ShadowReceiveAttribute') {
                shadows.push(attributes[i]);
            } else if (type === 'Billboard') {
                this._isBillboard = !!attributes[i];
            } else if (type === 'SkinningAttribute') {
                this._skinningAttribute = attributes[i];
            } else if (type === 'MorphAttribute') {
                this._morphAttribute = attributes[i];
            } else if (type === 'PointSizeAttribute') {
                this._pointSizeAttribute = attributes[i];
            }
        }
    },

    initTextureAttributes: function() {
        var textureAttributes = this._textureAttributes;
        var texturesNum = textureAttributes.length;
        this._textures.length = this._shadowsTextures.length = texturesNum;

        for (var j = 0; j < texturesNum; j++) {
            var tu = textureAttributes[j];
            if (tu === undefined) {
                continue;
            }

            for (var t = 0, tl = tu.length; t < tl; t++) {
                this.registerTextureAttributes(tu[t], j);
            }
        }
    },

    registerTextureAttributes: function(tuTarget, tunit) {
        var tType = tuTarget.className();
        if (tType === 'Texture') return this.registerTexture(tuTarget, tunit);
        if (tType.indexOf('ShadowTexture') !== -1)
            return this.registerTextureShadow(tuTarget, tunit);
    },

    registerTexture: function(tuTarget, texUnit) {
        var tName = tuTarget.getName();
        if (!tName) {
            tName = 'Texture' + texUnit;
            tuTarget.setName(tName);
        }
        this._textures[texUnit] = tuTarget;

        this._texturesByName[tName] = {
            texture: tuTarget,
            variable: undefined,
            textureUnit: texUnit
        };
    },

    registerTextureShadow: function(tuTarget, texUnit) {
        var tName = tuTarget.getName();
        if (!tName) {
            tName = 'Texture' + texUnit;
            tuTarget.setName(tName);
        }
        this._shadowsTextures[texUnit] = tuTarget;

        this._texturesByName[tName] = {
            texture: tuTarget,
            variable: undefined,
            textureUnit: texUnit,
            shadow: true
        };
    },

    getTextureByName: function(name) {
        var texObj = this._texturesByName[name];
        if (!texObj || texObj.variable) return texObj;

        var texture = texObj.texture;
        var texCoordUnit = texObj.textureUnit;

        var textureSampler;

        var className = texture.className();
        var samplerName = 'Texture' + texCoordUnit;
        if (className === 'Texture') {
            textureSampler = this.getOrCreateSampler('sampler2D', samplerName);
        } else if (className === 'TextureCubeMap') {
            textureSampler = this.getOrCreateSampler('samplerCube', samplerName);
        } else {
            return;
        }

        var texCoord = this._fragmentShaderMode
            ? this.getOrCreateVarying('vec2', 'vTexCoord' + texCoordUnit)
            : this.getOrCreateAttribute('vec2', 'TexCoord' + texCoordUnit);

        texObj.variable = this.createTextureRGBA(texture, textureSampler, texCoord);

        return texObj;
    },

    // The Compiler Main Code called on Vertex or Fragment Shader Graph
    createShaderFromGraphs: function(roots) {
        this._compiledNodeMap = {};

        // list all vars
        var variables = [];
        for (var keyVariable in this._variables) {
            var varNode = this._variables[keyVariable];
            var d = varNode.declare();
            if (d) {
                variables.push(d);
            }
        }

        // defines and extensions are added by process shader
        var extensions = this.evaluateExtensions(roots);
        var defines = this.evaluateDefines(roots);

        var shaderStack = [];
        shaderStack.push('\n');
        shaderStack.push(this.evaluateGlobalVariableDeclaration(roots));
        if (this._invariantPosition && !this._fragmentShaderMode)
            shaderStack.push('\ninvariant gl_Position;');
        shaderStack.push('\n');
        shaderStack.push(this.evaluateGlobalFunctionDeclaration(roots));

        shaderStack.push('void main() {');

        // declare variables in main
        if (variables.length !== 0) {
            shaderStack.push('// vars\n');
            shaderStack.push(variables.join(' '));
            shaderStack.push('\n// end vars\n');
        }

        // make sure we have at least one output
        if (roots.length === 0) {
            this.logError('shader without any final Node output (need at least one)');
        }

        shaderStack.push(this.evaluate(roots));

        shaderStack.push('}');

        // Shader Graph has been outputed an array of string
        // we concatenate it to a shader string program
        var shaderStr = shaderStack.join('\n');

        // Process defines, add precision, resolve include pragma
        var shader = this._shaderProcessor.processShader(
            shaderStr,
            defines,
            extensions,
            this._fragmentShaderMode ? 'fragment' : 'vertex'
        );


        return shader;
    },

    _logLookForVariable: function(args, variable) {
        var res = [];
        for (var key in args) {
            if (args[key] === variable) {
                res.push(key);
            }
        }
        return res;
    },

    getNode: function(/*name, arg1, etc*/) {
        var n = __WEBPACK_IMPORTED_MODULE_2_osgShader_nodeFactory__["a" /* default */].getNode.apply(__WEBPACK_IMPORTED_MODULE_2_osgShader_nodeFactory__["a" /* default */], arguments);
        if (!n) __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('Unknown Node type : ' + arguments[0]);
        var cacheID = n.getID();
        this._activeNodeMap[cacheID] = n;
        return n;
    },

    getVariable: function(nameID) {
        return this._variables[nameID];
    },

    getAttributeType: function(type) {
        for (var i = 0; i < this._attributes.length; i++) {
            if (this._attributes[i].getType() === type) return this._attributes[i];
        }
        return undefined;
    },

    // TODO: add Precision qualifier
    // if doesn't exist create a new on
    // if nameID given and var already exist, create a varname +
    createVariable: function(type, varname, deepness) {
        var nameID = varname;

        if (nameID === undefined) {
            var len = window.Object.keys(this._variables).length;
            nameID = 'tmp_' + len;
        } else if (this._variables[nameID]) {
            // create a new variable
            // if we want to reuse a variable we should NOT
            // call this function in the first place and do the
            // test before...
            // however for uniform, varying and sampler, we return
            // the variable if it already exists, because they are
            // meant to be read only
            nameID = nameID + deepness;
            if (deepness === undefined) {
                return this.createVariable(type, varname, 1);
            } else if (this._variables[nameID]) {
                deepness++;
                return this.createVariable(type, varname, deepness);
            }
        }

        var v = this.getNode('Variable', type, nameID);
        this._variables[nameID] = v;
        return v;
    },

    getOrCreateUniform: function(type, varname, size) {
        var nameID = varname;

        // accept uniform as parameter to simplify code
        if (type instanceof __WEBPACK_IMPORTED_MODULE_1_osg_Uniform__["a" /* default */]) {
            var uniform = type;
            type = uniform.getType();
            nameID = uniform.getName();
        } else if (nameID === undefined) {
            this.logError('Cannot create unamed Uniform');
        }

        var exist = this._variables[nameID];
        if (exist) {
            if (exist.getType() === type) {
                return exist;
            }

        }

        var v = this.getNode('Uniform', type, nameID, size);
        this._variables[nameID] = v;

        return v;
    },

    // make sure we get correct Node
    getOrCreateSampler: function(type, varname) {
        if (varname === undefined) {
            this.logError('No name given for sampler type : ' + type);
        }

        var exist = this._variables[varname];
        if (exist) {
            return exist; // see comment in Variable function
        }

        var v = this.getNode('Sampler', type, varname);
        this._variables[varname] = v;

        return v;
    },

    // make sure we get correct Node
    getOrCreateAttribute: function(type, nameID) {
        if (this._fragmentShaderMode) {
            this.logError('No Vertex Attribute in Fragment Shader');
        }

        var exist = this._variables[nameID];
        if (exist) {

            return exist;
        }

        var v = this.getNode('Attribute', type, nameID);
        this._variables[nameID] = v;
        return v;
    },

    getOrCreateConstant: function(type, varname) {
        var nameID = varname;
        if (nameID === undefined) {
            // TODO: temp constant ? or enforcing reuse ?
            // maybe could parse variable to find other constant
            // but would need having scope info
            var len = window.Object.keys(this._variables).length;
            nameID = 'tmp_' + len;
        } else {
            var exist = this._variables[nameID];
            if (exist) {

                // see comment in Variable function
                return exist;
            }
        }

        var v = this.getNode('Constant', type, nameID);
        this._variables[nameID] = v;
        return v;
    },

    // make sure we get correct Node
    getOrCreateVarying: function(type, nameID) {
        if (nameID === undefined) {
            this.logError('Error: Mandatory to name varying (as you need to retrieve them)');
        }

        var variable = this._variables[nameID];
        if (variable) {
            if (!this._varyings[nameID]) {
                this.logError(
                    'Error: requesting a varying not declared with getOrCreateVarying previously'
                );
            }

            if (variable.getType() !== type) {
                this.logError('Error: Same varying, but different type');
            }

            return variable;
        }

        // if it's not in Varying Cache, but requested from vertex shader it means => error
        if (!this._fragmentShaderMode && !this._customFragmentShader) {
            this.logError(
                'Error: requesting a varying not declared in Fragment Shader Graph (for Custom Vertex Shader, add this._customFragmentShader to the processor): ' +
                    nameID +
                    ' ' +
                    type
            );
        }

        variable = this._variables[nameID] = this._varyings[nameID] = this.getNode(
            'Varying',
            type,
            nameID
        );

        return variable;
    },

    //////////////////
    // TRAVERSE STUFFS
    //////////////////

    markNodeAsVisited: function(n) {
        var cacheID = n.getID();
        if (this._activeNodeMap[cacheID] === n) {
            this._compiledNodeMap[cacheID] = n;
        } else {
            this.logWarn(
                'Node not requested by using Compiler getNode and/or not registered in nodeFactory ' +
                    n.toString()
            );
        }
    },

    // make sure we traverse once per evaluation of graph
    checkOrMarkNodeAsTraversed: function(n) {
        var cacheID = n.getID();
        if (this._traversedNodeMap[cacheID]) {
            return true;
        }
        this._traversedNodeMap[cacheID] = n;
        return false;
    },

    // TODO: add a visitor to debug the graph
    traverse: function(functor, node) {
        if (this.checkOrMarkNodeAsTraversed(node)) return;

        var inputs = node.getInputs();
        if (!Array.isArray(inputs)) {
            var objectToArray = [];
            for (var keyInput in inputs) {
                objectToArray.push(inputs[keyInput]);
            }
            inputs = objectToArray;
        }

        for (var i = 0, l = inputs.length; i < l; i++) {
            node.checkInputsOutputs();

            var child = inputs[i];
            if (child && child !== node) {
                this.traverse(functor, child);
            }
        }
        functor.call(functor, node);

        // keep trace we visited
        this.markNodeAsVisited(node);
    },

    _getAndInitFunctor: function(func) {
        this._traversedNodeMap = {};

        var map = {};
        var text = [];
        func = func.bind(this, map, text);
        func._map = map;
        func._text = text;

        return func;
    },

    _functorEvaluateAndGatherField: function(field, map, text, node) {
        var idx = node.getType();
        if (idx === undefined || idx === '') {
            this.logError('Your node ' + node + ' has no type');
        }

        if (!node[field] || map[idx]) return;
        map[idx] = true;

        Array.prototype.push.apply(text, node[field]());
    },

    // Gather a particular output field
    // for now one of
    // ['define', 'extensions']
    //
    // from a nodeGraph
    //
    // In case a node of same Type have different outputs (shadow with different defines)
    // it use ID rather than Type as map index UNIQUE PER TYPE
    // TODO: adds includes so that we can remove it from the eval Global Functions ?
    evaluateAndGatherField: function(nodes, field) {
        var func = this._getAndInitFunctor(this._functorEvaluateAndGatherField.bind(this, field));

        for (var j = 0, jl = nodes.length; j < jl; j++) {
            this.traverse(func, nodes[j]);
        }

        return func._text;
    },

    _functorEvaluateGlobalFunctionDeclaration: function(map, text, node) {
        // UNIQUE PER TYPE
        var idx = node.getType();
        if (idx === undefined || idx === '') {
            this.logError('Your node ' + node + ' has no type');
        }

        if (!node.globalFunctionDeclaration || map[idx]) return;
        map[idx] = true;

        var decl = node.globalFunctionDeclaration();
        if (decl) text.push(decl);
    },

    // Gather a functions declartions of nodesfrom a nodeGraph
    // (for now pragma include done here too. could be done with define/etc...)
    // Node of same Type has to share exact same "node.globalFunctionDeclaration" output
    // as it use Type rather than ID as map index
    evaluateGlobalFunctionDeclaration: function(nodes) {
        var func = this._getAndInitFunctor(this._functorEvaluateGlobalFunctionDeclaration);

        for (var j = 0, jl = nodes.length; j < jl; j++) {
            this.traverse(func, nodes[j]);
        }

        return func._text.join('\n');
    },

    _functorEvaluateGlobalVariableDeclaration: function(map, text, node) {
        // UNIQUE PER NODE
        var idx = node.getID();
        if (!node.globalDeclaration || map[idx]) return;
        map[idx] = true;

        var decl = node.globalDeclaration();
        if (decl) text.push(decl);
    },

    // Gather a Variables declarations of nodes from a nodeGraph to be outputted
    // outside the VOID MAIN code ( Uniforms, Varying )
    // Node of same Type has different output as it use Type rather than ID as map index
    evaluateGlobalVariableDeclaration: function(nodes) {
        var func = this._getAndInitFunctor(this._functorEvaluateGlobalVariableDeclaration);

        var i = 0;
        var nbNodes = nodes.length;
        for (i = 0; i < nbNodes; i++) {
            this.traverse(func, nodes[i]);
        }

        // beautify/formatting with empty line between type of var
        var declarations = func._text;
        var len = declarations.length;
        if (len > 0) {
            this.sortDeclarations(declarations);

            var type = declarations[0][0];
            for (i = 0; i < len; ++i) {
                var iType = declarations[i][0];
                if (iType !== type) {
                    type = iType;
                    declarations[i - 1] += '\n';
                }
            }
        }

        return declarations.join('\n');
    },

    sortDeclarations: function(declarations) {
        // sort in alphabetical order attr, unif, sample, varying
        declarations.sort();

        if (this._fragmentShaderMode) return;

        // making sure Vertex is always coming first (because of webgl warning)
        for (var i = 0, len = declarations.length; i < len; ++i) {
            var vatt = declarations[i];

            if (vatt[0] !== 'a') break;

            if (vatt.indexOf('Vertex') !== -1) {
                declarations.splice(i, 1);
                declarations.unshift(vatt);
                break;
            }
        }
    },

    _functorEvaluate: function(map, text, node) {
        var id = node.getID();
        if (map[id]) return;
        map[id] = true;

        var shader = node.computeShader();
        if (!shader) return;

        var comment = node.getComment && node.getComment();
        if (comment) text.push(comment);
        text.push(shader);
    },

    evaluate: function(nodes) {
        var func = this._getAndInitFunctor(this._functorEvaluate);

        for (var j = 0, jl = nodes.length; j < jl; j++) {
            this.traverse(func, nodes[j]);
        }

        return func._text.join('\n');
    },

    evaluateDefines: function(roots) {
        return this.evaluateAndGatherField(roots, 'getDefines');
    },

    evaluateExtensions: function(roots) {
        return this.evaluateAndGatherField(roots, 'getExtensions');
    },

    /////////////////////
    // Model space varying
    /////////////////////
    getOrCreateModelVertex: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec3', 'vModelVertex');
        }

        var out = this._variables.modelVertex;
        if (out) return out;
        out = this.createVariable('vec3', 'modelVertex');

        this.getNode('MatrixMultPosition')
            .inputs({
                matrix: this.getOrCreateUniform('mat4', 'uModelMatrix'),
                vec: this.getOrCreateLocalVertex()
            })
            .outputs({ vec: out });

        return out;
    },

    getOrCreateModelNormal: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec3', 'vModelNormal');
        }

        var out = this._variables.modelNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'modelNormal');

        this.getNode('MatrixMultDirection')
            .inputs({
                matrix: this.getOrCreateUniform('mat3', 'uModelNormalMatrix'),
                vec: this.getOrCreateLocalNormal()
            })
            .outputs({ vec: out });

        return out;
    },

    getOrCreateModelTangent: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec4', 'vModelTangent');
        }

        var out = this._variables.modelTangent;
        if (out) return out;
        out = this.createVariable('vec4', 'modelTangent');

        this.getNode('MatrixMultDirection')
            .setOverwriteW(false)
            .inputs({
                matrix: this.getOrCreateUniform('mat3', 'uModelNormalMatrix'),
                vec: this.getOrCreateLocalTangent()
            })
            .outputs({ vec: out });

        return out;
    },

    /////////////////////
    // View space varying
    /////////////////////
    getOrCreateViewVertex: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec4', 'vViewVertex');
        }

        var out = this._variables.viewVertex;
        if (out) return out;
        out = this.createVariable('vec4', 'viewVertex');

        this.getNode('MatrixMultPosition')
            .inputs({
                matrix: this.getOrCreateUniform('mat4', 'uModelViewMatrix'),
                vec: this.getOrCreateLocalVertex()
            })
            .outputs({ vec: out });

        return out;
    },

    getOrCreateViewNormal: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec3', 'vViewNormal');
        }

        var out = this._variables.viewNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'viewNormal');

        this.getNode('MatrixMultDirection')
            .inputs({
                matrix: this.getOrCreateUniform('mat3', 'uModelViewNormalMatrix'),
                vec: this.getOrCreateLocalNormal()
            })
            .outputs({ vec: out });

        return out;
    },

    getOrCreateViewTangent: function() {
        if (this._fragmentShaderMode) {
            return this.getOrCreateVarying('vec4', 'vViewTangent');
        }

        var out = this._variables.viewTangent;
        if (out) return out;
        out = this.createVariable('vec4', 'viewTangent');

        this.getNode('MatrixMultDirection')
            .setOverwriteW(false)
            .inputs({
                matrix: this.getOrCreateUniform('mat3', 'uModelViewNormalMatrix'),
                vec: this.getOrCreateLocalTangent()
            })
            .outputs({ vec: out });

        return out;
    }
});

/* harmony default export */ __webpack_exports__["a"] = (Compiler);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_PooledResource__ = __webpack_require__(24);









var ComputeBoundsVisitor = function(traversalMode) {
    __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__["a" /* default */].call(this, traversalMode);

    // keep a matrix in memory to avoid to create matrix
    this._pooledMatrix = new __WEBPACK_IMPORTED_MODULE_7_osg_PooledResource__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create);

    // Matrix stack along path traversal
    this._matrixStack = new __WEBPACK_IMPORTED_MODULE_6_osg_PooledArray__["a" /* default */]();
    this._matrixStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);

    this._bb = new __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__["a" /* default */]();
};

__WEBPACK_IMPORTED_MODULE_5_osg_utils__["a" /* default */].createPrototypeObject(
    ComputeBoundsVisitor,
    __WEBPACK_IMPORTED_MODULE_5_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__["a" /* default */].prototype, {
        reset: function() {
            this._pooledMatrix.reset();
            this._matrixStack.reset();
            this._matrixStack.push(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
            this._bb.init();
        },

        getBoundingBox: function() {
            return this._bb;
        },

        // not implemented
        //void getPolytope(osg::Polytope& polytope, float margin=0.1) const;
        //void getBase(osg::Polytope& polytope, float margin=0.1) const;

        //applyDrawable: function ( drawable ) {},

        applyTransform: function(transform) {
            var matrix = this._pooledMatrix.getOrCreateObject();
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(matrix, this._matrixStack.back());
            transform.computeLocalToWorldMatrix(matrix, this);
            this.pushMatrix(matrix);
            this.traverse(transform);
            this.popMatrix();
        },

        apply: function(node) {
            if (node instanceof __WEBPACK_IMPORTED_MODULE_3_osg_Transform__["a" /* default */]) {
                this.applyTransform(node);
                return;
            } else if (node instanceof __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]) {
                this.applyBoundingBox(node.getBoundingBox());
                return;
            }

            this.traverse(node);
        },

        pushMatrix: function(matrix) {
            this._matrixStack.push(matrix);
        },

        popMatrix: function() {
            this._matrixStack.pop();
        },

        applyBoundingBox: (function() {
            var bbOut = new __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__["a" /* default */]();

            return function(bbox) {
                if (bbox.valid()) {
                    bbox.transformMat4(bbOut, this._matrixStack.back());
                    this._bb.expandByBoundingBox(bbOut);
                }
            };
        })(),

        getMatrixStack: function() {
            return this._matrixStack;
        }
    }),
    'osg',
    'ComputeBoundsVisitor'
);

/* harmony default export */ __webpack_exports__["default"] = (ComputeBoundsVisitor);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Timer__ = __webpack_require__(21);





/**
 * VertexArrayObject "Bundles" multipel vertex / normal / ... buffer bind
 * in one webgl call
 * @class VertexArrayObject
 */
var VertexArrayObject = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].call(this);
    // maybe could inherit from Object
    this._instanceID = __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].getInstanceID();
    this._vaoObject = undefined;
    this.dirty();
};

// static cache of glBuffers flagged for deletion, which will actually
// be deleted in the correct GL context.
VertexArrayObject._sDeletedGLVertexArrayObjectCache = new window.Map();

// static method to delete Program
VertexArrayObject.deleteGLVertexArrayObject = function(gl, buffer) {
    if (!VertexArrayObject._sDeletedGLVertexArrayObjectCache.has(gl))
        VertexArrayObject._sDeletedGLVertexArrayObjectCache.set(gl, []);
    VertexArrayObject._sDeletedGLVertexArrayObjectCache.get(gl).push(buffer);
};

// static method to flush all the cached glPrograms which need to be deleted in the GL context specified
VertexArrayObject.flushDeletedGLVertexArrayObjects = function(gl, availableTime) {
    // if no time available don't try to flush objects.
    if (availableTime <= 0.0) return availableTime;
    if (!VertexArrayObject._sDeletedGLVertexArrayObjectCache.has(gl)) return availableTime;
    var elapsedTime = 0.0;
    var beginTime = __WEBPACK_IMPORTED_MODULE_3_osg_Timer__["a" /* default */].instance().tick();
    var deleteList = VertexArrayObject._sDeletedGLVertexArrayObjectCache.get(gl);
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0 && elapsedTime < availableTime; i--) {
        gl.deleteVertexArray(deleteList[i]);
        deleteList.splice(i, 1);
        elapsedTime = __WEBPACK_IMPORTED_MODULE_3_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_3_osg_Timer__["a" /* default */].instance().tick());
    }
    return availableTime - elapsedTime;
};

VertexArrayObject.flushAllDeletedGLVertexArrayObjects = function(gl) {
    if (!VertexArrayObject._sDeletedGLVertexArrayObjectCache.has(gl)) return;
    var deleteList = VertexArrayObject._sDeletedGLVertexArrayObjectCache.get(gl);
    var numBuffers = deleteList.length;
    for (var i = numBuffers - 1; i >= 0; i--) {
        gl.deleteVertexArray(deleteList[i]);
        deleteList.splice(i, 1);
    }
};

VertexArrayObject.onLostContext = function(gl) {
    if (!VertexArrayObject._sDeletedGLVertexArrayObjectCache.has(gl)) return;
    var deleteList = VertexArrayObject._sDeletedGLVertexArrayObjectCache.get(gl);
    deleteList.length = 0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    VertexArrayObject,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].prototype, {
        getInstanceID: function() {
            return this._instanceID;
        },

        invalidate: function() {
            this._vaoObject = undefined;
            this.dirty();
        },

        releaseGLObjects: function() {
            if (this._vaoObject !== undefined && this._gl !== undefined) {
                VertexArrayObject.deleteGLVertexArrayObject(this._gl, this._vaoObject);
                __WEBPACK_IMPORTED_MODULE_2_osg_GLObject__["a" /* default */].removeObject(this._gl, this);
            }
            this.invalidate();
        },

        create: function(gl) {
            this._vaoObject = gl.createVertexArray();
            this._dirty = false;
        },

        bind: function(gl) {
            if (!this._gl) {
                this.setGraphicContext(gl);
            }

            var vao = this._vaoObject;
            if (!vao) return;

            gl.bindVertexArray(this._vaoObject);
        },

        dirty: function() {
            this._dirty = true;
        },

        isDirty: function() {
            return this._dirty;
        }
    }),
    'osg',
    'VertexArrayObject'
);

/* harmony default export */ __webpack_exports__["a"] = (VertexArrayObject);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_PooledArray__ = __webpack_require__(17);


var PooledMap = function() {
    this._keys = new __WEBPACK_IMPORTED_MODULE_0_osg_PooledArray__["a" /* default */]();
    this._map = {};
};

PooledMap.prototype = {
    reset: function() {
        var array = this._keys.getArray();
        var arrayLength = this._keys.getLength();
        for (var i = 0; i < arrayLength; i++) {
            var key = array[i];
            this._map[key] = undefined;
        }
        this._keys.reset();
    },
    /**
     * Set a key value
     * you have to check that the key does not exist before otherwise you could hit performance hit when calling reset/forEach
     */
    set: function(key, value) {
        this._keys.push(key);
        this._map[key] = value;
    },
    hasKey: function(key) {
        return this._map[key] !== undefined;
    },
    getMap: function() {
        return this._map;
    },
    getKeys: function() {
        return this._keys;
    },
    forEach: function(func) {
        var array = this._keys.getArray();
        var arrayLength = this._keys.getLength();
        for (var i = 0; i < arrayLength; i++) {
            var key = array[i];
            func(key, this._map[key]);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (PooledMap);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_math__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_PooledMap__ = __webpack_require__(59);








var createPositionAttribute = function() {
    return [null, null];
};

/**
 * RenderBin base class. Renderbin contains geometries to be rendered as a group,
 * renderbins are rendered once each.  They can improve efficiency or
 * use different rendering algorithms.
 * A renderBin can contain further renderBins producing a tree hierarchy of renderBins.
 *
 * https://github.com/openscenegraph/osg/blob/master/include/osgUtil/RenderBin#L27-L32
 */
var RenderBin = function(sortMode) {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);

    this._renderStage = undefined;
    this._parent = undefined;
    this._binNum = 0;
    this._sorted = false;
    this._sortMode = sortMode !== undefined ? sortMode : RenderBin.defaultSortMode;
    this._drawCallback = undefined;
    this._leafs = [];
    this._pooledPositionedAttribute = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledResource__["a" /* default */](createPositionAttribute);
    this._positionedAttribute = new __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__["a" /* default */]();
    this._stateGraphList = new __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__["a" /* default */]();
    this._bins = new __WEBPACK_IMPORTED_MODULE_6_osg_PooledMap__["a" /* default */]();
    RenderBin.prototype.init.call(this, sortMode);
};

RenderBin.SORT_BY_STATE = 0;
RenderBin.SORT_BACK_TO_FRONT = 1;
RenderBin.SORT_FRONT_TO_BACK = 2;

// change it at runtime for default RenderBin if needed
RenderBin.defaultSortMode = RenderBin.SORT_BY_STATE;

var createRenderBin = function() {
    return new RenderBin();
};
var pooledRenderBin = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledResource__["a" /* default */](createRenderBin);

RenderBin.BinPrototypes = {
    RenderBin: function() {
        return pooledRenderBin.getOrCreateObject().init();
    },
    DepthSortedBin: function() {
        return pooledRenderBin.getOrCreateObject().init(RenderBin.SORT_BACK_TO_FRONT);
    }
};

var sortBackToFrontFunction = function(a, b) {
    return b._depth - a._depth;
};

var sortFrontToBackFunction = function(a, b) {
    return a._depth - b._depth;
};

var sortBinNumberFunction = function(a, b) {
    return a._binNum - b._binNum;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    RenderBin,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        init: function(sortMode) {
            this._renderStage = undefined;
            this._parent = undefined;
            this._binNum = 0;
            this._sortMode = sortMode !== undefined ? sortMode : RenderBin.defaultSortMode;
            this._drawCallback = undefined;
            RenderBin.prototype._initInternal.call(this);
            return this;
        },
        _initInternal: function() {
            this._bins.reset();
            this._stateGraphList.reset();
            this._positionedAttribute.reset();
            this._pooledPositionedAttribute.reset();
            this._leafs.length = 0;
            this._sorted = false;
        },
        _createRenderBin: function(binName) {
            // default render bin constructor
            var renderBinConstructor = RenderBin.BinPrototypes.RenderBin;

            if (binName && RenderBin.BinPrototypes[binName])
                renderBinConstructor = RenderBin.BinPrototypes[binName];

            return renderBinConstructor();
        },

        addPositionAttribute: function(m, attribute) {
            var pa = this._pooledPositionedAttribute.getOrCreateObject();
            pa[0] = m;
            pa[1] = attribute;
            this._positionedAttribute.push(pa);
        },

        getStateGraphList: function() {
            return this._stateGraphList;
        },

        getPositionedAttribute: function() {
            return this._positionedAttribute;
        },

        copyLeavesFromStateGraphListToRenderLeafList: function() {
            this._leafs.length = 0;
            var detectedNaN = false;

            var stateGraphList = this._stateGraphList.getArray();
            var stateGraphListLength = this._stateGraphList.getLength();
            for (var i = 0; i < stateGraphListLength; i++) {
                var leafs = stateGraphList[i]._leafs;
                var leafsArray = leafs.getArray();
                var leafsArrayLength = leafs.getLength();
                for (var j = 0; j < leafsArrayLength; j++) {
                    var leaf = leafsArray[j];
                    if (__WEBPACK_IMPORTED_MODULE_3_osg_math__["a" /* default */].isNaN(leaf._depth)) {
                        detectedNaN = true;
                    } else {
                        this._leafs.push(leaf);
                    }
                }
            }

            if (detectedNaN) {
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].debug(
                    'warning: RenderBin::copyLeavesFromStateGraphListToRenderLeafList() detected NaN depth values, database may be corrupted.'
                );
            }
            // empty the render graph list to prevent it being drawn along side the render leaf list (see drawImplementation.)
            this._stateGraphList.reset();
        },

        getSortMode: function() {
            return this._sortMode;
        },

        sortBackToFront: function() {
            this.copyLeavesFromStateGraphListToRenderLeafList();
            this._leafs.sort(sortBackToFrontFunction);
        },

        sortFrontToBack: function() {
            this.copyLeavesFromStateGraphListToRenderLeafList();
            this._leafs.sort(sortFrontToBackFunction);
        },

        sortImplementation: function() {
            var SortMode = RenderBin;
            switch (this._sortMode) {
                case SortMode.SORT_BACK_TO_FRONT:
                    this.sortBackToFront();
                    break;
                case SortMode.SORT_FRONT_TO_BACK:
                    this.sortFrontToBack();
                    break;
                case SortMode.SORT_BY_STATE:
                    // do nothing
                    break;
            }
        },

        sort: function() {
            if (this._sorted) return;

            var binsKeys = this._bins.getKeys();
            var binsMap = this._bins.getMap();
            var binsKeysArray = binsKeys.getArray();
            var binsKeysArrayLength = binsKeys.getLength();
            for (var i = 0; i < binsKeysArrayLength; i++) {
                var keyBin = binsKeysArray[i];
                binsMap[keyBin].sort();
            }
            this.sortImplementation();

            this._sorted = true;
        },

        setParent: function(parent) {
            this._parent = parent;
        },

        getParent: function() {
            return this._parent;
        },

        getBinNumber: function() {
            return this._binNum;
        },

        findOrInsert: function(binNum, binName) {
            var bins = this._bins.getMap();
            var bin = bins[binNum];

            if (!bin) {
                bin = this._createRenderBin(binName);
                bin._parent = this;
                bin._binNum = binNum;
                bin._renderStage = this._renderStage;
                this._bins.set(binNum, bin);
            }
            return bin;
        },

        getStage: function() {
            return this._renderStage;
        },

        addStateGraph: function(sg) {
            this._stateGraphList.push(sg);
        },

        reset: function() {
            RenderBin.prototype._initInternal.call(this);
        },

        draw: function(state, previousRenderLeaf) {
            var previousLeaf = previousRenderLeaf;
            // use callback drawImplementation if exist
            if (this._drawCallback && this._drawCallback.drawImplementation) {
                previousLeaf = this._drawCallback.drawImplementation(this, state, previousLeaf);
            } else {
                previousLeaf = this.drawImplementation(state, previousLeaf);
            }

            return previousLeaf;
        },

        applyPositionedAttribute: function(state, positionedAttributes) {
            // the idea is to set uniform 'globally' in uniform map.
            var elements = positionedAttributes.getArray();
            var length = positionedAttributes.getLength();
            for (var index = 0, l = length; index < l; index++) {
                var element = elements[index];
                // add or set uniforms in state
                var stateAttribute = element[1];
                var matrix = element[0];
                state.setGlobalDefaultAttribute(stateAttribute);
                stateAttribute.apply(state);
                stateAttribute.applyPositionedUniform(matrix, state);
                state.haveAppliedAttribute(stateAttribute);
            }
        },

        drawImplementation: function(state, previousRenderLeaf) {
            var previousLeaf = previousRenderLeaf;

            var binsArray = [];

            var bins = this._bins.getMap();
            var binsKeys = this._bins.getKeys();
            var binsKeysLength = binsKeys.getLength();
            var binsKeysArray = binsKeys.getArray();
            for (var i = 0; i < binsKeysLength; i++) {
                var keyBin = binsKeysArray[i];
                binsArray.push(bins[keyBin]);
            }
            binsArray.sort(sortBinNumberFunction);

            var current = 0;
            var end = binsArray.length;

            var bin;
            // draw pre bins
            for (; current < end; current++) {
                bin = binsArray[current];
                if (bin.getBinNumber() > 0) {
                    break;
                }
                previousLeaf = bin.draw(state, previousLeaf);
            }

            // draw leafs
            previousLeaf = this.drawLeafs(state, previousLeaf);

            // draw post bins
            for (; current < end; current++) {
                bin = binsArray[current];
                previousLeaf = bin.draw(state, previousLeaf);
            }
            return previousLeaf;
        },

        drawLeafs: function(state, previousRenderLeaf) {
            var stateList = this._stateGraphList.getArray();
            var stateListLength = this._stateGraphList.getLength();
            var leafs = this._leafs;
            var previousLeaf = previousRenderLeaf;
            var leaf;

            // draw fine grained ordering.
            for (var d = 0, dl = leafs.length; d < dl; d++) {
                leaf = leafs[d];
                leaf.render(state, previousLeaf);
                previousLeaf = leaf;
            }

            // draw coarse grained ordering.
            for (var i = 0, l = stateListLength; i < l; i++) {
                var sg = stateList[i];
                var leafArray = sg._leafs.getArray();
                var leafArrayLength = sg._leafs.getLength();
                for (var j = 0; j < leafArrayLength; j++) {
                    leaf = leafArray[j];
                    leaf.render(state, previousLeaf);
                    previousLeaf = leaf;
                }
            }
            return previousLeaf;
        }
    }),
    'osg',
    'RenderBin'
);

RenderBin.reset = function() {
    pooledRenderBin.reset();
};

RenderBin.clean = function () {
    pooledRenderBin.clean();
};

/* harmony default export */ __webpack_exports__["a"] = (RenderBin);


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateSkeleton__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_UpdateMatrixTransform__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_Bone__ = __webpack_require__(41);







var ResetRestPoseVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ResetRestPoseVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_5_osgAnimation_Bone__["a" /* default */].getTypeID()) {
                var cb = node.getUpdateCallback();
                if (cb instanceof __WEBPACK_IMPORTED_MODULE_4_osgAnimation_UpdateMatrixTransform__["a" /* default */]) {
                    var stackedTransforms = cb._stackedTransforms;
                    for (var st = 0, l = stackedTransforms.length; st < l; st++) {
                        var stackedTransform = stackedTransforms[st];
                        stackedTransform.resetToDefaultValue();
                    }
                    cb.computeChannels();
                }
            }
            this.traverse(node);
        }
    }),
    'osgAnimation',
    'ResetRestPoseVisitor'
);

var resetter = new ResetRestPoseVisitor();

var Skeleton = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_MatrixTransform__["a" /* default */].call(this);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Skeleton,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_MatrixTransform__["a" /* default */].prototype, {
        setDefaultUpdateCallback: function() {
            this.addUpdateCallback(new __WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateSkeleton__["a" /* default */]());
        },

        setRestPose: function() {
            this.accept(resetter);
        }
    }),
    'osgAnimation',
    'Skeleton'
);

/* harmony default export */ __webpack_exports__["a"] = (Skeleton);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_AnimationUpdateCallback__ = __webpack_require__(49);




/**
 *  UpdateMatrixTransform
 */
var UpdateMatrixTransform = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgAnimation_AnimationUpdateCallback__["a" /* default */].call(this);

    // maybe could have a more generic name and used by all AnimationUpdateCallback
    this._stackedTransforms = [];

    this._matrix = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();

    this._dirty = false;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateMatrixTransform,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_AnimationUpdateCallback__["a" /* default */].prototype, {
        getStackedTransforms: function() {
            return this._stackedTransforms;
        },

        computeChannels: function() {
            this._dirty = true;
            var matrix = this._matrix;
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].identity(matrix);
            var transforms = this._stackedTransforms;

            for (var i = 0, l = transforms.length; i < l; i++) {
                var transform = transforms[i];
                transform.applyToMatrix(matrix);
            }
        },

        update: function(node /*, nv */) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(node.getMatrix(), this._matrix);
            if (this._dirty) {
                node.dirtyBound();
                this._dirty = false;
            }
            return true;
        }
    }),
    'osgAnimation',
    'UpdateMatrixTransform'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateMatrixTransform);


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_shaderLib__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_shaderLib__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_WebGLCaps__ = __webpack_require__(28);





// webgl2 protected variable names : sample, texture

//     Shader as vert/frag/glsl files Using requirejs text plugin
//     Preprocess features like:    //
//     - Handle (recursive) include, avoiding code repeat and help code factorization
//     - Handle per shader and global define/precision

var ShaderProcessor = function(createInstance) {
    if (!createInstance) {
        if (ShaderProcessor.instance) {
            return ShaderProcessor.instance;
        }
        ShaderProcessor.instance = this;
    }

    this.addShaders(__WEBPACK_IMPORTED_MODULE_1_osgShader_shaderLib__["a" /* default */]);
    this.addShaders(__WEBPACK_IMPORTED_MODULE_2_osgShadow_shaderLib__["a" /* default */]);
    return this;
};

ShaderProcessor.prototype = {
    _shadersText: {},
    _shadersList: {},
    _globalDefaultprecision:
        '#ifdef GL_FRAGMENT_PRECISION_HIGH\n precision highp float;\n #else\n precision mediump float;\n#endif',
    _debugLines: false,
    _includeR: /#pragma include "([^"]+)"/g,
    _includeCondR: /#pragma include (["^+"]?["\ "[a-zA-Z_0-9](.*)"]*?)/g,
    _defineR: /\#define\s+([a-zA-Z_0-9]+)/,
    _precisionR: /precision\s+(high|low|medium)p\s+float/,

    // {
    //     'functions.glsl': textShaderFunctions,
    //     'lights.glsl': textShaderFunctions,
    //     'textures.glsl': textShaderFunctions
    // };
    addShaders: function(shaders) {
        for (var key in shaders) {
            this._shadersList[key] = key;
            this._shadersText[key] = shaders[key];
        }
    },

    instrumentShaderlines: function(content, sourceID) {
        // TODO instrumentShaderlines
        // http://immersedcode.org/2012/1/12/random-notes-on-webgl/
        // one ID per "file"
        // Each file has its line number starting at 0
        //   handle include, the do that numbering also in preprocess...
        // Then on shader error using sourceID and line you can point the correct line...
        // has to attach that info to osg.shader object.
        /*
          var allLines = content.split('\n');
          var i = 0;
          for (var k = 0; k _< allLines.length; k++) {
          if (!this._includeR.test(allLines[k])) {
          allLines[k] = "#line " + (i++) + " " + sourceID + '\n' + allLines[k] ;
          }
          }
          content = allLines.join('\n');
        */

        // seems just  prefixing first line seems ok to help renumbering error mesg
        return '\n#line ' + 0 + ' ' + sourceID + '\n' + content;
    },

    hasShader: function(shaderName) {
        // unlike getShaderTextPure, doesn't log an erreur if the shader doesn't exist
        return this._shadersText[shaderName] !== undefined;
    },

    getShaderTextPure: function(shaderName) {
        var preShader = this._shadersText[shaderName];

        if (!preShader) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('shader file/text: ' + shaderName + ' not registered');
            preShader = '';
        }

        return preShader;
    },

    getShader: function(shaderName, defines, extensions, type) {
        var shader = this.getShaderTextPure(shaderName);
        return this.processShader(shader, defines, extensions, type);
    },

    // recursively  handle #include external glsl
    // files (for now in the same folder.)
    preprocess: function(content, sourceID, includeList, inputsDefines /*, type */) {
        var self = this;
        return content.replace(
            this._includeCondR,
            function(_, strMatch) {
                var includeOpt = strMatch.split(' ');
                var includeName = includeOpt[0].replace(/"/g, '');

                // pure include is
                // \#pragma include "name";

                // conditionnal include is name included if _PCF defined
                // \#pragma include "name" "_PCF";
                if (includeOpt.length > 1 && inputsDefines) {
                    // some conditions here.
                    // if not defined we do not include
                    var found = false;
                    var defines = inputsDefines.map(function(defineString) {
                        // find '#define', remove duplicate whitespace, split on space and return the define Text
                        return (
                            self._defineR.test(defineString) &&
                            defineString.replace(/\s+/g, ' ').split(' ')[1]
                        );
                    });

                    for (var i = 1; i < includeOpt.length && !found; i++) {
                        var key = includeOpt[i].replace(/"/g, '');
                        for (var k = 0; k < defines.length && !found; k++) {
                            if (defines[k] !== false && defines[k] === key) {
                                found = true;
                                break;
                            }
                        }
                    }
                    if (!found) return '';
                }

                // already included
                if (includeList.indexOf(includeName) !== -1) return '';
                // avoid endless loop, not calling the impure
                var txt = this.getShaderTextPure(includeName);
                // make sure it's not included twice
                includeList.push(includeName);
                if (this._debugLines) {
                    txt = this.instrumentShaderlines(txt, sourceID);
                }
                sourceID++;
                // to the infinite and beyond !
                txt = this.preprocess(txt, sourceID, includeList, inputsDefines);
                return txt;
            }.bind(this)
        );
    },

    _getSortedUnique: (function() {
        var filterDuplicate = function(item, pos, self) {
            return !pos || item !== self[pos - 1];
        };

        return function(array) {
            return array && array.sort().filter(filterDuplicate);
        };
    })(),

    _convertExtensionsToWebGL2: (function() {
        var cbRenamer = function(match, extension) {
            return 'core_' + extension;
        };

        var cbDefiner = function(match, extension) {
            return '#define ' + extension;
        };

        var extensions =
            '(GL_EXT_shader_texture_lod|GL_OES_standard_derivatives|GL_EXT_draw_buffers|GL_EXT_frag_depth)';
        var definer = new RegExp('#\\s*extension\\s+' + extensions + '.*', 'g');
        var renamer = new RegExp(extensions, 'g');

        return function(strShader) {
            strShader = strShader.replace(definer, cbDefiner); // replace #extension by #define
            strShader = strShader.replace(renamer, cbRenamer); // rename extension
            return strShader;
        };
    })(),

    _convertToWebGL2: (function() {
        var frags = [];
        var replaceMRT = function(match, number) {
            var varName = 'glFragData_' + number;
            frags[number] = 'layout(location = ' + number + ') out vec4 ' + varName + ';';
            return varName;
        };

        return function(strShader, isFragment) {
            if (!strShader) return strShader;

            strShader = strShader.replace(/attribute\s+/g, 'in ');
            strShader = strShader.replace(/varying\s+/g, isFragment ? 'in ' : 'out ');
            strShader = strShader.replace(/(texture2D|textureCube)\s*\(/g, 'texture(');
            strShader = strShader.replace(/(textureCubeLodEXT)\s*\(/g, 'textureLod(');

            strShader = this._convertExtensionsToWebGL2(strShader);

            if (isFragment) {
                frags.length = 0;
                strShader = strShader.replace(/gl_FragData\s*\[\s*(\d+)\s*\]/g, replaceMRT);

                if (!frags.length) frags.push('out vec4 glFragColor_0;');
                strShader = strShader.replace(/gl_FragColor/g, 'glFragColor_0');
                strShader = strShader.replace(
                    /void\s+main\s*\(/g,
                    frags.join('\n') + '\nvoid main('
                );
            }

            return strShader;
        };
    })(),

    _hasVersion: function(shader) {
        // match first line starting with #
        var version = shader.match(/^#(.*)$/m);
        return version && version[0].indexOf('version') !== -1;
    },

    // process shader
    // - declare version, extensions, precision and defines
    // - resolve pragma include
    // - Convert webgl1 to webgl2 (glsl 100 to glsl 330 es)
    processShader: function(shader, defines, extensions, type) {
        // if the shader has #version statement we skip the shader processing
        if (this._hasVersion(shader)) {
            return shader;
        }

        var includeList = [];
        var preShader = shader;
        var sourceID = 0;
        if (this._debugLines) {
            preShader = this.instrumentShaderlines(preShader, sourceID);
            sourceID++;
        }

        // removes duplicates
        defines = this._getSortedUnique(defines);
        extensions = this._getSortedUnique(extensions);

        var strCore = this.preprocess(preShader, sourceID, includeList, defines, type);

        // avoid warning on unrecognized pragma
        strCore = strCore.replace(/#pragma DECLARE_FUNCTION/g, '//#pragma DECLARE_FUNCTION');

        var isFragment = strCore.indexOf('gl_Position') === -1;
        var convertToWebGL2 = __WEBPACK_IMPORTED_MODULE_3_osg_WebGLCaps__["a" /* default */].instance().isWebGL2();

        var strVersion = convertToWebGL2 ? '#version 300 es' : '#version 100';
        strVersion += '\n';

        var strExtensions = extensions ? extensions.join('\n') + '\n' : '';

        var strDefines = defines ? defines.join('\n') + '\n' : '';

        if (convertToWebGL2) {
            strExtensions = this._convertExtensionsToWebGL2(strExtensions);
            strDefines = this._convertToWebGL2(strDefines, isFragment);
            strCore = this._convertToWebGL2(strCore, isFragment);
        } else {
            // support multiline define
            strDefines = strDefines.replace(/\\\n/g, '');
            strCore = strCore.replace(/\\\n/g, '');
        }

        // vertex shader uses highp per default BUT if FS is using mediump then VS should too (conflict with varying/uniform otherwise)
        // also make sure precision is not already providen
        var strPrecision = '';
        if (this._globalDefaultprecision && !this._precisionR.test(strCore)) {
            strPrecision = this._globalDefaultprecision + '\n';
        }

        // order is important
        // See https://khronos.org/registry/gles/specs/2.0/GLSL_ES_Specification_1.0.17.pdf (p14-15: extension before any non-processor token)
        return strVersion + strExtensions + strPrecision + strDefines + strCore;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (ShaderProcessor);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgAnimation_channel__ = __webpack_require__(43);


// create Animation data
// Animation {
//     channels: [],
//     duration: 0.0;
//     name: string
// },

var animationCount = 0;

// assume that iniChannel has been called
// on each channel
var createAnimation = function(channels, name) {
    var min = Infinity;
    var max = -Infinity;
    for (var i = 0; i < channels.length; i++) {
        min = Math.min(min, channels[i].start);
        max = Math.max(max, channels[i].end);
    }

    var duration = max - min;
    var animationName = name || 'animation' + animationCount.toString();
    animationCount++;
    return {
        channels: channels,
        duration: duration,
        name: animationName,
        start: min
    };
};

// create instance Animation data. An instance animation
// contains instance channels instead of original channels
// Animation {
//     channels: [],
//     duration: 0.0;
//     start: 0.0, // used to know when an animation has been started
//     name: string
// },
var createInstanceAnimation = function(animation) {
    var channels = [];
    for (var i = 0; i < animation.channels.length; i++) {
        var channel = __WEBPACK_IMPORTED_MODULE_0_osgAnimation_channel__["a" /* default */].createInstanceChannel(animation.channels[i]);
        channels.push(channel);
    }

    return {
        channels: channels,
        duration: animation.duration,
        start: 0.0,
        name: animation.name,
        firstKeyTime: animation.start
    };
};

var Animation = function() {};

Animation.createAnimation = createAnimation;
Animation.createInstanceAnimation = createInstanceAnimation;

/* harmony default export */ __webpack_exports__["a"] = (Animation);


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_transformEnums__ = __webpack_require__(11);




var rejectObject = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].rejectObject;

var osgWrapper = {};

osgWrapper.Object = function(input, obj) {
    var jsonObj = input.getJSON();

    if (jsonObj.Name) obj.setName(jsonObj.Name);

    if (jsonObj.UserDataContainer) {
        var userdata = input.setJSON(jsonObj.UserDataContainer).readUserDataContainer();
        if (userdata !== undefined) {
            obj.setUserData(userdata);
        }
    }

    return obj;
};
/* jshint newcap: false */
osgWrapper.Node = function(input, node) {
    var jsonObj = input.getJSON();

    osgWrapper.Object(input, node);

    var promiseArray = [];

    if (jsonObj.UpdateCallbacks) {
        var cbAddCallback = node.addUpdateCallback.bind(node);
        for (var j = 0, l = jsonObj.UpdateCallbacks.length; j < l; j++) {
            var promise = input.setJSON(jsonObj.UpdateCallbacks[j]).readObject();
            promiseArray.push(promise);
            promise.then(cbAddCallback);
        }
    }

    if (jsonObj.StateSet) {
        var pp = input.setJSON(jsonObj.StateSet).readObject();
        promiseArray.push(pp);
        pp.then(node.setStateSet.bind(node));
    }

    var queue = [];
    // For each url, create a function call and add it to the queue
    if (jsonObj.Children) {
        for (var i = 0, k = jsonObj.Children.length; i < k; i++) {
            queue.push(input.setJSON(jsonObj.Children[i]).readObject());
        }
    }
    // Resolve first updateCallbacks and stateset.
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promiseArray).then(function() {
        // Need to wait until the stateset and the all the callbacks are resolved
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(queue).then(function(queueNodes) {
            // All the results from P.all are on the argument as an array
            // Now insert children in the right order
            var len = queueNodes.length;
            for (var n = 0; n < len; n++) node.addChild(queueNodes[n]);
            return node;
        });
    });
};

osgWrapper.StateSet = function(input, stateSet) {
    var jsonObj = input.getJSON();

    osgWrapper.Object(input, stateSet);

    if (jsonObj.RenderingHint !== undefined) {
        stateSet.setRenderingHint(jsonObj.RenderingHint);
    }

    var promiseArray = [];

    var createAttribute = function(jsonAttribute) {
        var promise = input.setJSON(jsonAttribute).readObject();
        if (
            promise.isRejected() // sometimes we have some empty objects
        )
            return;
        promiseArray.push(promise);
        promise.then(stateSet.setAttributeAndModes.bind(stateSet));
    };

    if (jsonObj.AttributeList !== undefined) {
        for (var i = 0, l = jsonObj.AttributeList.length; i < l; i++) {
            createAttribute(jsonObj.AttributeList[i]);
        }
    }

    var createTextureAttribute = function(unit, textureAttribute) {
        var promise = input.setJSON(textureAttribute).readObject();
        if (
            promise.isRejected() // sometimes we have some empty objects
        )
            return;
        promiseArray.push(promise);
        promise.then(stateSet.setTextureAttributeAndModes.bind(stateSet, unit));
    };

    if (jsonObj.TextureAttributeList) {
        var textures = jsonObj.TextureAttributeList;
        for (var t = 0, lt = textures.length; t < lt; t++) {
            var textureAttributes = textures[t];
            for (var a = 0, al = textureAttributes.length; a < al; a++) {
                createTextureAttribute(t, textureAttributes[a]);
            }
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promiseArray).then(function() {
        return stateSet;
    });
};

osgWrapper.Material = function(input, material) {
    var jsonObj = input.getJSON();
    if (
        !jsonObj.Diffuse ||
        !jsonObj.Emission ||
        !jsonObj.Specular ||
        jsonObj.Shininess === undefined
    ) {
        return rejectObject('Material', jsonObj);
    }

    osgWrapper.Object(input, material);

    material.setAmbient(jsonObj.Ambient);
    material.setDiffuse(jsonObj.Diffuse);
    material.setEmission(jsonObj.Emission);
    material.setSpecular(jsonObj.Specular);
    material.setShininess(jsonObj.Shininess);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(material);
};

osgWrapper.BlendFunc = function(input, blend) {
    var jsonObj = input.getJSON();
    if (
        !jsonObj.SourceRGB ||
        !jsonObj.SourceAlpha ||
        !jsonObj.DestinationRGB ||
        !jsonObj.DestinationAlpha
    ) {
        return rejectObject('BlendFunc', jsonObj);
    }

    osgWrapper.Object(input, blend);

    blend.setSourceRGB(jsonObj.SourceRGB);
    blend.setSourceAlpha(jsonObj.SourceAlpha);
    blend.setDestinationRGB(jsonObj.DestinationRGB);
    blend.setDestinationAlpha(jsonObj.DestinationAlpha);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(blend);
};

osgWrapper.CullFace = function(input, attr) {
    var jsonObj = input.getJSON();
    if (jsonObj.Mode === undefined) return rejectObject('CullFace', jsonObj);

    osgWrapper.Object(input, attr);
    attr.setMode(jsonObj.Mode);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(attr);
};

osgWrapper.BlendColor = function(input, attr) {
    var jsonObj = input.getJSON();
    if (!jsonObj.ConstantColor) return rejectObject('BlendColor', jsonObj);

    osgWrapper.Object(input, attr);
    attr.setConstantColor(jsonObj.ConstantColor);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(attr);
};

osgWrapper.Light = function(input, light) {
    var jsonObj = input.getJSON();

    if (
        !jsonObj.Ambient ||
        !jsonObj.Diffuse ||
        !jsonObj.Direction ||
        !jsonObj.Position ||
        !jsonObj.Specular ||
        jsonObj.LightNum === undefined ||
        jsonObj.SpotCutoff === undefined ||
        jsonObj.LinearAttenuation === undefined ||
        jsonObj.ConstantAttenuation === undefined ||
        jsonObj.QuadraticAttenuation === undefined
    ) {
        return rejectObject('Light', jsonObj);
    }

    osgWrapper.Object(input, light);
    light.setAmbient(jsonObj.Ambient);
    light.setConstantAttenuation(jsonObj.ConstantAttenuation);
    light.setDiffuse(jsonObj.Diffuse);
    light.setDirection(jsonObj.Direction);
    light.setLightNumber(jsonObj.LightNum);
    light.setLinearAttenuation(jsonObj.LinearAttenuation);
    light.setPosition(jsonObj.Position);
    light.setQuadraticAttenuation(jsonObj.QuadraticAttenuation);
    light.setSpecular(jsonObj.Specular);
    light.setSpotCutoff(jsonObj.SpotCutoff);
    light.setSpotBlend(0.01);
    if (jsonObj.SpotExponent !== undefined) {
        light.setSpotBlend(jsonObj.SpotExponent / 128.0);
    }
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(light);
};

osgWrapper.Texture = function(input, texture) {
    var jsonObj = input.getJSON();

    osgWrapper.Object(input, texture);

    if (jsonObj.MinFilter) texture.setMinFilter(jsonObj.MinFilter);
    if (jsonObj.MagFilter) texture.setMagFilter(jsonObj.MagFilter);
    if (jsonObj.WrapT) texture.setWrapT(jsonObj.WrapT);
    if (jsonObj.WrapS) texture.setWrapS(jsonObj.WrapS);

    // no file return dummy texture
    var file = jsonObj.File;
    if (file === undefined) {
        file = 'no-image-provided';
    }

    return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function (resolve) {
        input.readImageURL(file).then(function(img) {
            texture.setImage(img);
            resolve( texture );
        });
    } );
};

osgWrapper.Projection = function(input, node) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Matrix) return rejectObject('Projection', jsonObj);

    var promise = osgWrapper.Node(input, node);
    node.setMatrix(jsonObj.Matrix);
    return promise;
};

osgWrapper.MatrixTransform = function(input, node) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Matrix) return rejectObject('MatrixTransform', jsonObj);

    var promise = osgWrapper.Node(input, node);
    node.setMatrix(jsonObj.Matrix);
    return promise;
};

osgWrapper.LightSource = function(input, node) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Light) return rejectObject('LightSource', jsonObj);

    var promise = osgWrapper.Node(input, node);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([input.setJSON(jsonObj.Light).readObject(), promise]).then(function(args) {
        var light = args[0];
        //var lightsource = args[ 1 ];
        node.setLight(light);
        if (jsonObj.ReferenceFrame === 'ABSOLUTE_RF') {
            node.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_2_osg_transformEnums__["a" /* default */].ABSOLUTE_RF);
        }
        return node;
    });
};

// not robust, but we probably don't want to complexify the function for now
osgWrapper.functionSortAttributes = function(a, b) {
    if (a.indexOf('TexCoord') !== -1 && b.indexOf('TexCoord') !== -1) {
        return parseInt(a.substr(8), 10) - parseInt(b.substr(8), 10);
    }

    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
};

osgWrapper.Geometry = function(input, node) {
    var jsonObj = input.getJSON();
    if (!jsonObj.VertexAttributeList) return rejectObject('Geometry', jsonObj);

    jsonObj.PrimitiveSetList = jsonObj.PrimitiveSetList || [];

    var arraysPromise = [];
    arraysPromise.push(osgWrapper.Node(input, node));

    var prims = node.getPrimitives();
    var cbAddPrimitives = prims.push.bind(prims);
    var i = 0;
    var l = jsonObj.PrimitiveSetList.length;
    for (i = 0; i < l; i++) {
        var promisePrimitive = input.setJSON(jsonObj.PrimitiveSetList[i]).readPrimitiveSet();
        arraysPromise.push(promisePrimitive);
        promisePrimitive.then(cbAddPrimitives);
    }

    var cbSetBuffer = function(name, buffer) {
        this.getVertexAttributeList()[name] = buffer;
    };

    var vList = jsonObj.VertexAttributeList;
    var keys = window.Object.keys(vList);

    // TexCoord10 should be sorted after TexCoord5 (in case of referenced attributes)
    // alternative is to resolve the referenced keys (2 passes method for example)
    keys.sort(osgWrapper.functionSortAttributes);

    l = keys.length;
    for (i = 0; i < l; i++) {
        var name = keys[i];
        var promiseBuffer = input.setJSON(vList[name]).readBufferArray();
        arraysPromise.push(promiseBuffer);
        promiseBuffer.then(cbSetBuffer.bind(node, name));
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(arraysPromise).then(function() {
        return node;
    });
};

osgWrapper.PagedLOD = function(input, plod) {
    var jsonObj = input.getJSON();

    osgWrapper.Object(input, plod);
    // Parse center Mode
    if (jsonObj.CenterMode === 'USE_BOUNDING_SPHERE_CENTER') plod.setCenterMode(0);
    else if (jsonObj.CenterMode === 'UNION_OF_BOUNDING_SPHERE_AND_USER_DEFINED')
        plod.setCenterMode(2);

    // Parse center and radius
    plod.setCenter([jsonObj.UserCenter[0], jsonObj.UserCenter[1], jsonObj.UserCenter[2]]);
    plod.setRadius(jsonObj.UserCenter[3]);

    // Parse RangeMode
    if (jsonObj.RangeMode === 'PIXEL_SIZE_ON_SCREEN') plod.setRangeMode(1);

    var str;

    // Parse Ranges
    var o = jsonObj.RangeList;

    for (var i = 0; i < window.Object.keys(o).length; i++) {
        str = 'Range ' + i;
        var v = o[str];
        plod.setRange(i, v[0], v[1]);
    }
    // Parse Files
    o = jsonObj.RangeDataList;
    for (i = 0; i < window.Object.keys(o).length; i++) {
        str = 'File ' + i;
        plod.setFileName(i, o[str]);
    }
    // Set database path from options
    // TODO: Check also if we have a path from json
    plod.setDatabasePath(input.getDatabasePath());

    var queue = [];
    // For each url, create a function call and add it to the queue
    if (jsonObj.Children) {
        for (var j = 0, k = jsonObj.Children.length; j < k; j++) {
            queue.push(input.setJSON(jsonObj.Children[j]).readObject());
        }
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(queue).then(function(queueNodes) {
        // All the results from P.all are on the argument as an array
        var len = queueNodes.length;
        for (i = 0; i < len; i++) plod.addChildNode(queueNodes[i]);
        return plod;
    });
};
/* harmony default export */ __webpack_exports__["a"] = (osgWrapper);


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);




// Base class for Camera / User manipulator
var Manipulator = function(boundStrategy) {
    this._boundStrategy = boundStrategy;
    if (this._boundStrategy === undefined) {
        this._boundStrategy = Manipulator.COMPUTE_HOME_USING_SPHERE;
    }

    this._controllerList = {};
    this._inverseMatrix = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
    this._camera = undefined;
    this._node = undefined;
    this._frustum = {};
    this._computeBoundNodeMaskOverride = ~0x0;

    // for getHomeBoundingSphere
    this._tmpSphere = new __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__["a" /* default */]();
};

Manipulator.prototype = {
    setCamera: function(c) {
        this._camera = c;
    },
    getCamera: function() {
        return this._camera;
    },
    setNode: function(node) {
        this._node = node;
    },
    setComputeBoundNodeMaskOverride: function(mask) {
        this._computeBoundNodeMaskOverride = mask;
    },
    getComputeBoundNodeMaskOverride: function() {
        return this._computeBoundNodeMaskOverride;
    },

    // overrideStrat should be a bounding volume calculation strategy
    getHomeBoundingSphere: function(overrideStrat) {
        var node = this._node;
        if (!node) return;

        var type = overrideStrat !== undefined ? overrideStrat : this._boundStrategy;

        if (type & Manipulator.COMPUTE_HOME_USING_BBOX) {
            var box;
            if (this._computeBoundNodeMaskOverride === ~0x0) {
                box = node.getBoundingBox();
            } else {
                var ComputeBoundsVisitor = __webpack_require__(57).default;
                var cbv = new ComputeBoundsVisitor();
                cbv.setNodeMaskOverride(this._computeBoundNodeMaskOverride);
                cbv.reset();

                cbv.apply(node);
                box = cbv.getBoundingBox();
            }

            if (!box.valid()) return node.getBoundingSphere();

            // minimum between sphere and box
            if (type & Manipulator.COMPUTE_HOME_USING_SPHERE) {
                var bsphere = node.getBoundingSphere();
                if (bsphere.valid() && bsphere.volume() < box.volume()) {
                    return bsphere;
                }
            }

            this._tmpSphere.copyBoundingBox(box);
            return this._tmpSphere;
        }

        return node.getBoundingSphere();
    },

    getHomeBound: function(overrideStrat) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('Please use getHomeBoundingSphere instead');
        return this.getHomeBoundingSphere(overrideStrat);
    },

    getHomeDistance: function(bound) {
        var frustum = this._frustum;
        var dist = bound.radius();
        if (this._camera && __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].getFrustum(frustum, this._camera.getProjectionMatrix())) {
            var vertical2 = Math.abs(frustum.right - frustum.left) / frustum.zNear / 2;
            var horizontal2 = Math.abs(frustum.top - frustum.bottom) / frustum.zNear / 2;
            dist /= Math.sin(Math.atan2(horizontal2 < vertical2 ? horizontal2 : vertical2, 1));
        } else {
            dist *= 1.5;
        }
        return dist;
    },
    // eg: var currentTime = nv.getFrameStamp().getSimulationTime();
    update: function(/*nv*/) {},

    getInverseMatrix: function() {
        return this._inverseMatrix;
    },

    getControllerList: function() {
        return this._controllerList;
    }
};

// flags
Manipulator.COMPUTE_HOME_USING_SPHERE = 1 << 0;
Manipulator.COMPUTE_HOME_USING_BBOX = 1 << 1;

/* harmony default export */ __webpack_exports__["a"] = (Manipulator);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgUtil_intersectionEnums__ = __webpack_require__(68);


var Intersector = function() {
    this._intersections = [];
    this._primitiveMask = __WEBPACK_IMPORTED_MODULE_0_osgUtil_intersectionEnums__["a" /* default */].ALL_PRIMITIVES;
    this._intersectionLimit = __WEBPACK_IMPORTED_MODULE_0_osgUtil_intersectionEnums__["a" /* default */].NO_LIMIT;
};

Intersector.prototype = {
    reset: function() {
        this._intersections.length = 0;
    },

    enter: function(node) {
        if (this.reachedLimit()) return false;
        return !node.isCullingActive() || this.intersectNode(node);
    },

    intersectNode: function(node) {
        return (
            this.intersectBoundingSphere(node.getBoundingSphere()) ||
            this.intersectBoundingBox(node.getBoundingBox())
        );
    },

    intersectBoundingSphere: function(/*bsphere*/) {
        return false;
    },

    intersectBoundingBox: function(/*bsphere*/) {
        return false;
    },

    getIntersections: function() {
        return this._intersections;
    },

    setIntersectionLimit: function(limit) {
        this._intersectionLimit = limit;
    },

    getIntersectionLimit: function() {
        return this._intersectionLimit;
    },

    setPrimitiveMask: function(primitiveMask) {
        this._primitiveMask = primitiveMask;
    },

    getPrimitiveMask: function() {
        return this._primitiveMask;
    },

    reachedLimit: function() {
        return (
            this._intersectionLimit === __WEBPACK_IMPORTED_MODULE_0_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE &&
            this._intersections.length > 0
        );
    },

    setCurrentTransformation: function(/*matrix*/) {},

    intersect: function(/*iv, node*/) {}
};

/* harmony default export */ __webpack_exports__["a"] = (Intersector);


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    NO_LIMIT: 0,
    LIMIT_ONE_PER_DRAWABLE: 1,
    LIMIT_ONE: 2,

    // PrimitiveMask
    POINT_PRIMITIVES: 1 << 0, /// check for points
    LINE_PRIMITIVES: 1 << 1, /// check for lines
    TRIANGLE_PRIMITIVES: 1 << 2, /// check for triangles and other primitives like quad, polygons that can be decomposed into triangles
    ALL_PRIMITIVES: (1 << 0) | (1 << 1) | (1 << 2)
});


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_primitiveIndexFunctor__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__ = __webpack_require__(68);





var IntersectFunctor = function() {
    this._hit = false;

    // geom info
    this._primitiveIndex = 0;
    this._vertices = undefined;
    this._geometry = undefined;

    // intersection visitor (nodepath, etc...)
    this._intersectionVisitor = undefined;

    // intersector stuffs
    this._intersector = undefined;
    this._limitOneIntersection = false;
    this._primitiveMask = __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].ALL_PRIMITIVES;
};

// minimal "interface" for intersection type
IntersectFunctor.Intersection = function() {
    this._nodePath = undefined;
    this._drawable = undefined;
    this._matrix = undefined;
    this._primitiveIndex = undefined;

    this._ratio = 0.0;
    this._backface = false;
    this._localIntersectionPoint = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
};

IntersectFunctor.prototype = {
    reset: function() {
        this._hit = false;
        this._vertices = undefined;
        this._primitiveIndex = 0;
    },

    setPrimitiveIndex: function(primitiveIndex) {
        this._primitiveIndex = primitiveIndex;
    },
    setGeometry: function(geometry) {
        this._geometry = geometry;
        this._primitiveIndex = 0;
        this._vertices = geometry.getAttributes().Vertex.getElements();
    },
    setVertices: function(vertices) {
        this._vertices = vertices;
    },

    setIntersectionVisitor: function(intersectionVisitor) {
        this._intersectionVisitor = intersectionVisitor;
    },
    setIntersector: function(intersector) {
        this._intersector = intersector;
        this._primitiveMask = intersector.getPrimitiveMask();

        var limit = intersector.getIntersectionLimit();
        this._limitOneIntersection =
            limit === __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE_PER_DRAWABLE ||
            limit === __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE;
    },

    setLimitOneIntersection: function(limitOneIntersection) {
        this._limitOneIntersection = limitOneIntersection;
    },

    leave: function() {},

    enter: function(/*bbox*/) {},

    initIntersection: function(intersection) {
        intersection._matrix = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].clone(this._intersectionVisitor.getModelMatrix());
        intersection._nodePath = this._intersectionVisitor.getNodePath().slice();
        intersection._primitiveIndex = this._primitiveIndex;
        intersection._drawable = this._geometry;
        this._intersector.getIntersections().push(intersection);
        this._hit = true;
        return intersection;
    },

    intersectPoint: function(/*v0, p0*/) {},
    intersectLine: function(/*v0, v1, p0, p1*/) {},
    intersectTriangle: function(/*v0, v1, v2, p0, p1, p2*/) {},

    operatorPoint: (function() {
        var v0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();

        return function(p0) {
            if (this._limitOneIntersection && this._hit) return;
            if ((this._primitiveMask & __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].POINT_PRIMITIVES) === 0) return;

            var vertices = this._vertices;
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v0, vertices[3 * p0], vertices[3 * p0 + 1], vertices[3 * p0 + 2]);

            this.intersectPoint(v0, p0);
            this._primitiveIndex++;
        };
    })(),

    operatorLine: (function() {
        var v0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();

        return function(p0, p1) {
            if (this._limitOneIntersection && this._hit) return;
            if ((this._primitiveMask & __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].LINE_PRIMITIVES) === 0) return;

            var vertices = this._vertices;
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v0, vertices[3 * p0], vertices[3 * p0 + 1], vertices[3 * p0 + 2]);
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v1, vertices[3 * p1], vertices[3 * p1 + 1], vertices[3 * p1 + 2]);

            this.intersectLine(v0, v1, p0, p1);
            this._primitiveIndex++;
        };
    })(),

    operatorTriangle: (function() {
        var v0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();

        return function(p0, p1, p2) {
            if (this._limitOneIntersection && this._hit) return;
            if ((this._primitiveMask & __WEBPACK_IMPORTED_MODULE_2_osgUtil_intersectionEnums__["a" /* default */].TRIANGLE_PRIMITIVES) === 0) return;

            var vertices = this._vertices;
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v0, vertices[3 * p0], vertices[3 * p0 + 1], vertices[3 * p0 + 2]);
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v1, vertices[3 * p1], vertices[3 * p1 + 1], vertices[3 * p1 + 2]);
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v2, vertices[3 * p2], vertices[3 * p2 + 1], vertices[3 * p2 + 2]);

            this.intersectTriangle(v0, v1, v2, p0, p1, p2);
            this._primitiveIndex++;
        };
    })(),

    apply: function(node) {
        if (!node.getAttributes().Vertex) return;
        Object(__WEBPACK_IMPORTED_MODULE_1_osg_primitiveIndexFunctor__["a" /* default */])(node, this);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (IntersectFunctor);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DelayInterpolator = function(size, delay) {
    this._current = new Float32Array(size);
    this._target = new Float32Array(size);
    this._delta = new Float32Array(size);
    this._delay = delay !== undefined ? delay : 0.15;
    this._reset = false;
    this._start = 0.0;
    this.reset();
};

DelayInterpolator.prototype = {
    setDelay: function(delay) {
        this._delay = delay;
    },
    reset: function() {
        for (var i = 0, l = this._current.length; i < l; i++) {
            this._current[i] = this._target[i] = 0.0;
        }
        this._reset = true;
    },
    update: function(dt) {
        // assume 60 fps to be consistent with the old _delay values for backward compatibility
        // (otherwise we'd have to adjust the _delay values by multiplying to 60 )
        var dtDelay = Math.min(1.0, this._delay * dt * 60.0);
        for (var i = 0, l = this._current.length; i < l; i++) {
            var d = (this._target[i] - this._current[i]) * dtDelay;
            this._delta[i] = d;
            this._current[i] += d;
        }
        return this._delta;
    },
    set: function() {
        for (var i = 0, l = this._current.length; i < l; i++) {
            this._current[i] = this._target[i] = arguments[i];
        }
        this._reset = false;
    },
    isReset: function() {
        return this._reset;
    },
    getCurrent: function() {
        return this._current;
    },
    setTarget: function() {
        for (var i = 0, l = this._target.length; i < l; i++) {
            if (this._reset) {
                this._target[i] = this._current[i] = arguments[i];
            } else {
                this._target[i] = arguments[i];
            }
        }
        this._reset = false;
    },
    addTarget: function() {
        for (var i = 0; i < arguments.length; i++) {
            this._target[i] += arguments[i];
        }
    },
    getTarget: function() {
        return this._target;
    },
    getDelta: function() {
        return this._delta;
    },
    getStart: function() {
        return this._start;
    },
    setStart: function(start) {
        this._start = start;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DelayInterpolator);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


var instance = 0;
var Node = function() {
    this._name = 'AbstractNode';
    this._inputs = [];
    this._outputs = null;

    // category of node
    // same name implies same
    // define/function
    //this.type = '';

    // uuid: unicity
    // allows multipe node of same type
    // declaring multipe code paths
    // inside the main
    this._id = instance++;

    this._text = undefined;
};

Node.prototype = {
    getID: function() {
        return this._id;
    },
    getName: function() {
        return this._name;
    },

    getType: function() {
        return this.type;
    },

    toString: function() {
        var str = 'name : ' + this._name;
        if (this.type) str += ' (' + this.type + ')';
        return str;
    },

    getInputs: function() {
        return this._inputs;
    },

    getOutputs: function() {
        return this._outputs;
    },

    checkInputsOutputs: function() {
        var i, key;
        if (this.validInputs) {
            for (i = 0; i < this.validInputs.length; i++) {
                key = this.validInputs[i];
                if (!this._inputs[key]) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
                        'Shader node ' +
                            this.type +
                            ' validation error input ' +
                            key +
                            ' is missing'
                    );
                    return false;
                }
            }
        }

        if (this.validOutputs) {
            for (i = 0; i < this.validOutputs.length; i++) {
                key = this.validOutputs[i];
                if (!this._outputs[key]) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
                        'Shader node ' +
                            this.type +
                            ' validation error output ' +
                            key +
                            ' is missing'
                    );
                    return false;
                }
            }
        }

        return true;
    },

    // accepts inputs like that:
    // inputs( [ a, b, c , d] )
    // inputs( { a: x, b: y } )
    // inputs( a, b, c, d )
    inputs: function() {
        // handle inputs ( a, b, c, d)
        for (var i = 0, l = arguments.length; i < l; i++) {
            var input = arguments[i];
            if (!input) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('Shader node ' + this.type + ' input number ' + l + ' is undefined ');
                break;
            }

            // handle inputs( [a, b, c ,d] )
            if (Array.isArray(input)) {
                this.inputs.apply(this, input);
                return this;

                // check for an object {} and not something from base class Node
            } else if (
                typeof input === 'object' &&
                input !== null &&
                input instanceof Node === false
            ) {
                this._inputs = input;
                return this;
            } else {
                // add argument to the array
                this._inputs.push(input);
            }
        }

        return this;
    },

    // accepts inputs like that:
    // outputs( { a: x, b: y } )
    // outputs( a )
    outputs: function(outputs) {
        this._outputs = outputs;

        // single output
        if (this._outputs instanceof Node === true) {
            this.autoLink(this._outputs);
        } else {
            // iterate on objects keys
            for (var key in this._outputs) {
                this.autoLink(this._outputs[key]);
            }
        }

        return this;
    },

    autoLink: function(output) {
        if (output === undefined) return this;

        output.inputs(this);

        return this;
    },

    computeShader: function() {
        return this._text;
    },

    comment: function(txt) {
        this._comment = '//' + txt;
    },

    getComment: function() {
        return this._comment;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Node);


/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Node__ = __webpack_require__(9);








/** AutoTransform is a derived form of Transform that automatically
 * scales or rotates to keep its children aligned with screen coordinates.
 * W.r.t. AutorotateModes only rotate to screen is supported right now.
 * More AutorotateModes modes should be addressed in the future.
 * @class AutoTransform
 */

var AutoTransform = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Transform__["a" /* default */].call(this);
    this._matrix = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
    this._position = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
    this._matrixDirty = true;
    this._scale = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 1.0, 1.0);
    this._minimumScale = 0;
    this._maximumScale = Number.MAX_VALUE;
    this._rotation = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].create();
    this._pivotPoint = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
    this._autoScaleToScreen = false;
    this._autoRotateToScreen = false;
    this._cachedMatrix = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
    this._firstTimeToInitEyePoint = true;
    this._autoScaleTransitionWidthRatio = 0.25;
    this._billboardAttribute = undefined;
    this._previousWidth = 0.0;
    this._previousHeight = 0.0;
    this._previousProjection = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
    this._previousModelView = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
    this._previousPosition = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
};

/** @lends Autotransform.prototype */
__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeNode(
    AutoTransform,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Transform__["a" /* default */].prototype, {
        getMatrix: function() {
            return this._matrix;
        },

        setMatrix: function(m) {
            this._matrix = m;
            this.dirtyBound();
        },

        setPosition: function(pos) {
            this._position = pos;
            this._matrixDirty = true;
            this.dirtyBound();
        },
        getPosition: function() {
            return this._position;
        },

        setRotation: function(q) {
            this._rotation = q;
            this._matrixDirty = true;
            this.dirtyBound();
        },

        getRotation: function() {
            return this._rotation;
        },

        setScale: function(scale) {
            this.setScaleFromVec3(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].fromValues(scale, scale, scale));
        },

        setScaleFromvec3: function(scaleVec) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('deprecated, use setScaleFromVec3');
            this.setScaleFromVec3(scaleVec);
        },

        setScaleFromVec3: function(scaleVec) {
            this._scale = scaleVec;
            this._matrixDirty = true;
            this.dirtyBound();
        },

        getScale: function() {
            return this._scale;
        },

        setMinimumScale: function(minimumScale) {
            this._minimumScale = minimumScale;
        },

        getMinimumScale: function() {
            return this._minimumScale;
        },

        setMaximumScale: function(maximumScale) {
            this._maximumScale = maximumScale;
        },

        getMaximumScale: function() {
            return this._maximumScale;
        },

        setAutoScaleToScreen: function(autoScaleToScreen) {
            this._autoScaleToScreen = autoScaleToScreen;
            this._matrixDirty = true;
        },

        getAutoScaleToScreen: function() {
            return this._autoScaleToScreen;
        },

        setAutoRotateToScreen: function(value) {
            this._autoRotateToScreen = value;
        },

        getAutoRotateToScreen: function() {
            return this._autoRotateToScreen;
        },

        setAutoScaleTransitionWidthRatio: function(autoScaleTransitionWidthRatio) {
            this._autoScaleTransitionWidthRatio = autoScaleTransitionWidthRatio;
        },

        getAutoScaleTransitionWidthRatio: function() {
            return this._autoScaleTransitionWidthRatio;
        },

        // local to "local world" (not Global World)
        computeLocalToWorldMatrix: function(matrix /*, nodeVisitor */) {
            if (this._matrixDirty) this.computeMatrix();
            if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, matrix, this._matrix);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(matrix, this._matrix);
            }
        },

        computeMatrix: (function() {
            var neg = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var tmpMat = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
            return function() {
                if (!this._matrixDirty) return;
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromQuat(this._matrix, this._rotation);

                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromTranslation(tmpMat, this._position);
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(this._matrix, tmpMat, this._matrix);
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].scale(this._matrix, this._matrix, this._scale);
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].translate(this._matrix, this._matrix, __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].neg(neg, this._pivotPoint));
                this._matrixDirty = false;
            };
        })(),

        computeWorldToLocalMatrix: (function() {
            var neg = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var rotInverse = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].create();
            var scaleInverse = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var tmpMat = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();

            return function(matrix /*, nodeVisitor */) {
                if (this.scale[0] === 0.0 && this.scale[1] === 0.0 && this.scale[2] === 0.0) {
                    return false;
                }
                scaleInverse[0] = 1.0 / this._scale[0];
                scaleInverse[1] = 1.0 / this._scale[1];
                scaleInverse[2] = 1.0 / this._scale[2];
                if (this.referenceFrame === __WEBPACK_IMPORTED_MODULE_5_osg_transformEnums__["a" /* default */].RELATIVE_RF) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromTranslation(tmpMat, __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].neg(neg, this._position));
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);

                    if (!__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].zeroRotation(this._rotation)) {
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromQuat(tmpMat, __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].invert(rotInverse, this._rotation));
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);
                    }
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromScaling(tmpMat, scaleInverse);
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);

                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromTranslation(tmpMat, this._pivotPoint);
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);
                } else {
                    // absolute
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromQuat(this._matrix, __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].invert(rotInverse, this._rotation));
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].translate(matrix, matrix, __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].neg(neg, this._position));

                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromScaling(tmpMat, scaleInverse);
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);

                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].fromTranslation(tmpMat, this._pivotPoint);
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(matrix, tmpMat, matrix);
                }
                return true;
            };
        })(),

        computeBound: (function() {
            var matrix = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();
            return function(bSphere) {
                if (this._autoScaleToScreen && this._firstTimeToInitEyePoint) return bSphere;
                __WEBPACK_IMPORTED_MODULE_6_osg_Node__["a" /* default */].prototype.computeBound.call(this, bSphere);
                if (!bSphere.valid()) {
                    return bSphere;
                }
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].identity(matrix);
                // local to local world (not Global World)
                this.computeLocalToWorldMatrix(matrix);
                //Matrix.transformBoundingSphere( matrix, bSphere, bSphere );
                bSphere.transformMat4(bSphere, matrix);
                return bSphere;
            };
        })(),

        accept: (function() {
            return function(visitor) {
                if (visitor.getVisitorType() === __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__["a" /* default */].CULL_VISITOR) {
                    var width = visitor.getViewport().width();
                    var height = visitor.getViewport().height();
                    var projMat = visitor.getCurrentProjectionMatrix();
                    var modelViewMat = visitor.getCurrentModelViewMatrix();
                    var position = this._position;
                    var doUpdate = this._firstTimeToInitEyePoint;
                    if (!this._firstTimeToInitEyePoint) {
                        if (width !== this._previousWidth || height !== this._previousHeight) {
                            doUpdate = true;
                        } else if (!__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].exactEquals(projMat, this._previousProjection)) {
                            doUpdate = true;
                        } else if (!__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].exactEquals(modelViewMat, this._previousModelView)) {
                            doUpdate = true;
                        } else if (!__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].exactEquals(position, this._previousPosition)) {
                            doUpdate = true;
                        }
                    }
                    this._firstTimeToInitEyePoint = false;
                    if (doUpdate) {
                        if (this._autoScaleToScreen) {
                            var viewport = visitor.getViewport();
                            var psvector = this.computePixelSizeVector(
                                viewport,
                                projMat,
                                modelViewMat
                            );
                            var v = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(
                                this._position[0],
                                this._position[1],
                                this._position[2],
                                1.0
                            );
                            var pixelSize = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].dot(v, psvector);
                            pixelSize = 0.48 / pixelSize;
                            var size = 1.0 / pixelSize;
                            if (this._autoScaleTransitionWidthRatio > 0.0) {
                                var c, b, a;
                                if (this._minimumScale > 0.0) {
                                    var j = this._minimumScale;
                                    var i =
                                        this._maximumScale < Number.MAX_VALUE
                                            ? this._minimumScale +
                                              (this._maximumScale - this._minimumScale) *
                                                  this._autoScaleTransitionWidthRatio
                                            : this._minimumScale *
                                              (1.0 + this._autoScaleTransitionWidthRatio);
                                    c = 1.0 / (4.0 * (i - j));
                                    b = 1.0 - 2.0 * c * i;
                                    a = j + b * b / (4.0 * c);
                                    var k = -b / (2.0 * c);
                                    if (size < k) size = this._minimumScale;
                                    else if (size < i) size = a + b * size + c * (size * size);
                                }
                                if (this._maximumScale < Number.MAX_VALUE) {
                                    var n = this._maximumScale;
                                    var m =
                                        this._minimumScale > 0.0
                                            ? this._maximumScale +
                                              (this._minimumScale - this._maximumScale) *
                                                  this._autoScaleTransitionWidthRatio
                                            : this._maximumScale *
                                              (1.0 - this._autoScaleTransitionWidthRatio);
                                    c = 1.0 / (4.0 * (m - n));
                                    b = 1.0 - 2.0 * c * m;
                                    a = n + b * b / (4.0 * c);
                                    var p = -b / (2.0 * c);

                                    if (size > p) size = this._maximumScale;
                                    else if (size > m) size = a + b * size + c * (size * size);
                                }
                            }
                            this.setScale(size);
                        }
                        if (this._autoRotateToScreen) {
                            var rotation = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].create();
                            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].getRotation(rotation, modelViewMat);
                            this.setRotation(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */].invert(rotation, rotation));
                        }
                        this._previousWidth = width;
                        this._previousHeight = height;
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].copy(this._previousPosition, position);
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(this._previousProjection, projMat);
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].copy(this._previousModelView, modelViewMat);
                    }
                }

                __WEBPACK_IMPORTED_MODULE_6_osg_Node__["a" /* default */].prototype.accept.call(this, visitor);
            };
        })(),

        computePixelSizeVector: (function() {
            var scale00 = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var scale10 = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            return function(W, P, M) {
                // Where W = viewport, P = ProjectionMatrix, M = ModelViewMatrix
                // Comment from OSG:
                // pre adjust P00,P20,P23,P33 by multiplying them by the viewport window matrix.
                // here we do it in short hand with the knowledge of how the window matrix is formed
                // note P23,P33 are multiplied by an implicit 1 which would come from the window matrix.

                // scaling for horizontal pixels
                var P00 = P[0] * W.width() * 0.5;
                var P20_00 = P[8] * W.width() * 0.5 + P[11] * W.width() * 0.5;
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].set(
                    scale00,
                    M[0] * P00 + M[2] * P20_00,
                    M[4] * P00 + M[6] * P20_00,
                    M[8] * P00 + M[10] * P20_00
                );

                // scaling for vertical pixels
                var P10 = P[5] * W.height() * 0.5;
                var P20_10 = P[9] * W.height() * 0.5 + P[11] * W.height() * 0.5;
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].set(
                    scale10,
                    M[1] * P10 + M[2] * P20_10,
                    M[5] * P10 + M[6] * P20_10,
                    M[9] * P10 + M[10] * P20_10
                );

                var P23 = P[11];
                var P33 = P[15];
                var pixelSizeVector = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].fromValues(
                    M[2] * P23,
                    M[6] * P23,
                    M[10] * P23,
                    M[14] * P23 + M[15] * P33
                );

                var scaleRatio =
                    0.7071067811 / Math.sqrt(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sqrLen(scale00) + __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sqrLen(scale10));
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].scale(pixelSizeVector, pixelSizeVector, scaleRatio);
                return pixelSizeVector;
            };
        })()
    }),
    'osg',
    'AutoTransform'
);

/* harmony default export */ __webpack_exports__["a"] = (AutoTransform);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);



var OptionsDefault = {
    antialias: true, // activate MSAA
    //'overrideDevicePixelRatio': 1, // if specified override the device pixel ratio
    fullscreen: true,
    enableFrustumCulling: false,
    scrollwheel: true,
    webgl2: false,
    powerPreference: 'high-performance',
    stats: false // display stats, check in osgStats/Stats for all url options
    // statsFilter=cull;myGroup;webgl filters groups to display
    // statsFontSize=12 change the size of the fonts default 12
    // statsShowGraph=1 display graph
};

var Options = function() {
    for (var keyOption in OptionsDefault) {
        this[keyOption] = OptionsDefault[keyOption];
    }
};

var urlOptions;
Options.getOptionsURL = function() {
    if (urlOptions) return urlOptions;

    urlOptions = {};

    if (!window.location.search) return urlOptions;

    var vars = [];
    var hash;
    // slice(1) to remove leading '?'
    var hashes = window.location.search.slice(1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        var element = hash[0];
        vars.push(element);
        var result = hash[1];

        // ideally we should have typed option
        if (result === '0' || result === 'false') continue;
        if (result === undefined) result = '1';

        urlOptions[element] = result;
    }

    if (urlOptions.log !== undefined) {
        var level = urlOptions.log.toLowerCase();

        switch (level) {
            case 'debug':
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].setNotifyLevel(__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].DEBUG);
                break;
            case 'info':
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].setNotifyLevel(__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].INFO);
                break;
            case 'notice':
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].setNotifyLevel(__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].NOTICE);
                break;
            case 'warn':
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].setNotifyLevel(__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].WARN);
                break;
            case 'error':
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].setNotifyLevel(__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].ERROR);
                break;
            case 'html':
                var logContent = [];
                var divLogger = document.createElement('div');
                var codeElement = document.createElement('pre');
                document.addEventListener('DOMContentLoaded', function() {
                    document.body.appendChild(divLogger);
                    divLogger.appendChild(codeElement);
                });
                var logFunc = function(str) {
                    logContent.unshift(str);
                    codeElement.innerHTML = logContent.join('\n');
                };
                divLogger.style.overflow = 'hidden';
                divLogger.style.position = 'absolute';
                divLogger.style.zIndex = '10000';
                divLogger.style.height = '100%';
                divLogger.style.maxWidth = '600px';
                codeElement.style.overflow = 'scroll';
                codeElement.style.width = '105%';
                codeElement.style.height = '100%';
                codeElement.style.fontSize = '10px';

                ['log', 'error', 'warn', 'info', 'debug'].forEach(function(value) {
                    window.console[value] = logFunc;
                });
                break;
        }
    }

    return urlOptions;
};

Options.prototype = {
    extend: function(options) {
        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix(this, options);
        return this;
    },

    get: function(key) {
        return this[key];
    },

    getBoolean: function(key) {
        var val = this.getString(key);
        if (val) return val !== 'false' && val !== '0';
        return undefined;
    },

    getNumber: function(key) {
        var val = this[key];
        if (val) return Number(val);
        return undefined;
    },

    getString: function(key) {
        var val = this[key];
        if (val !== undefined) return this[key].toString();
        return undefined;
    },

    extendWithOptionsURL: function() {
        this.extend(Options.getOptionsURL());
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Options);


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__ = __webpack_require__(12);


var BufferArrayProxy = function(bufferArray) {
    this._initialBufferArray = undefined;
    this._bufferArray = undefined;
    if (bufferArray) {
        this.setBufferArray(bufferArray);
        this.setInitialBufferArray(bufferArray);
    }
};

var prototype = {
    setInitialBufferArray: function(bufferArray) {
        this._initialBufferArray = bufferArray;
    },
    getInitialBufferArray: function() {
        return this._initialBufferArray;
    },
    setBufferArray: function(bufferArray) {
        this._bufferArray = bufferArray.getBufferArray ? bufferArray.getBufferArray() : bufferArray;
    },
    getBufferArray: function() {
        return this._bufferArray;
    }
};

// adds original method of BufferArray prototype for the proxy for convenient usage
var makeFunc = function(func) {
    return function() {
        return func.apply(this._bufferArray, arguments);
    };
};

for (var methodName in __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].prototype) {
    prototype[methodName] = makeFunc(__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].prototype[methodName]);
}

BufferArrayProxy.prototype = prototype;
/* harmony default export */ __webpack_exports__["a"] = (BufferArrayProxy);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__ = __webpack_require__(17);






/*jshint bitwise: false */
/**
 * Polytope class for representing convex clipping volumes made up of a set of planes.
 * When adding planes, their normals should point inwards (into the volume)
 * @class Polytope
 */
var Polytope = function() {
    this._clippingMask = 0x0;

    this._planeList = [
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create()
    ];
    this._vertexList = [];

    // stack of clipping masks
    this._maskStack = new __WEBPACK_IMPORTED_MODULE_4_osg_PooledArray__["a" /* default */]();

    // init with a clear mask
    this._resultMask = 0;
    this._maskStack.push(this._resultMask);
};

__WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].createPrototypeObject(
    Polytope,
    __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osg_Object__["a" /* default */].prototype, {
        getPlanes: function() {
            return this._planeList;
        },

        setPlanes: function(pl) {
            this._planeList = pl;
            this.setupMask();
        },

        clear: function() {
            this._clippingMask = 0x0;
            if (this._planeList) {
                for (var i = 0, l = this._planeList.length; i < l; ++i) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].init(this._planeList[i]);
                }
            }
            this._vertexList = [];
            this.setupMask();
        },

        /** Create a Polytope which is a cube, centered at 0,0,0, with sides of 2 units.*/
        setToUnitFrustum: function(withNear, withFar) {
            if (withNear === undefined) withNear = true;

            if (withFar === undefined) withFar = true;

            this._planeList.length = 0;
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 1.0, 0.0, 0.0, 1.0)); // left plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), -1.0, 0.0, 0.0, 1.0)); // right plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 1.0, 0.0, 1.0)); // bottom plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, -1.0, 0.0, 1.0)); // top plane.
            if (withNear) this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 0.0, 1.0, 1.0)); // near plane
            if (withFar) this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 0.0, -1.0, 1.0)); // far plane
            this.setupMask();
        },

        /** Create a Polytope which is a equivalent to BoundingBox.*/
        setToBoundingBox: function(bb) {
            this._planeList.length = 0;
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 1.0, 0.0, 0.0, -bb.getMin()[0])); // left plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), -1.0, 0.0, 0.0, bb.getMax()[0])); // right plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 1.0, 0.0, -bb.getMin()[1])); // bottom plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, -1.0, 0.0, bb.getMax()[1])); // top plane.
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 0.0, 1.0, -bb.getMin()[2])); // near plane
            this._planeList.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["g" /* vec4 */].set(__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].create(), 0.0, 0.0, -1.0, bb.getMax()[2])); // far plane
            this.setupMask();
        },

        setAndTransformProvidingInverse: function(pt, matrix) {
            this._referenceVertexList = pt._referenceVertexList;
            var polytopBackIndex = this._maskStack.getLength() - 1;
            var resultMask = pt._maskStack[polytopBackIndex];
            if (resultMask === 0) {
                this._maskStack.getArray()[polytopBackIndex] = 0;
                this._resultMask = 0;
                this._planeList.length = 0;
                return;
            }
            var selectorMask = 0x1;

            var numActivePlanes = 0;
            // count number of active planes.
            var i;
            for (i = 0; i !== pt._planeList.length; ++i) {
                if (resultMask & selectorMask) ++numActivePlanes;
                selectorMask <<= 1;
            }

            this._planeList.length = numActivePlanes;
            this._resultMask = 0;
            selectorMask = 0x1;
            var index = 0;
            for (i = 0; i !== pt._planeList.length; ++i) {
                if (resultMask & selectorMask) {
                    this._planeList[index] = pt._planeList[i];
                    __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].transformProvidingInverse(this._planeList[index++], matrix);
                    this._resultMask = (this._resultMask << 1) | 1;
                }
                selectorMask <<= 1;
            }

            this._maskStack.getArray()[polytopBackIndex] = this._resultMask;
        },

        voidset: function(pl) {
            this._planeList = pl;
            this.setupMask();
        },

        add: function(pl) {
            this._planeList.push(pl);
            this.setupMask();
        },

        empty: function() {
            return this._planeList.length === 0;
        },

        setReferenceVertexList: function(vertices) {
            this._referenceVertexList = vertices;
        },

        getReferenceVertexList: function() {
            return this._referenceVertexList;
        },

        setupMask: function(plength) {
            this._resultMask = 0;
            var pMasklength = plength !== undefined ? plength : this._planeList.length;
            for (var i = 0; i < pMasklength; ++i) {
                this._resultMask = (this._resultMask << 1) | 1;
            }
            this._maskStack.reset();
            this._maskStack.push(this._resultMask);
        },

        getCurrentMask: function() {
            return this._maskStack.back();
        },

        setResultMask: function(mask) {
            this._resultMask = mask;
        },

        getResultMask: function() {
            return this._resultMask;
        },

        getMaskStack: function() {
            return this._maskStack;
        },

        // push but keep current mask
        pushCurrentMask: function() {
            this._maskStack.push(this._resultMask);
        },
        // pop and restore previous mask
        popCurrentMask: function() {
            return this._maskStack.pop();
        },

        /** Check whether a vertex is contained within clipping set.*/
        containsVertex: function(v) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return true;

            var selectorMask = 0x1;
            for (var i = 0; i < this._planeList.length; ++i) {
                if (
                    polytopeBack & selectorMask &&
                    __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].distanceToPlane(this._planeList[i], v) < 0.0
                ) {
                    return false;
                }
                selectorMask <<= 1;
            }
            return true;
        },

        /** Check whether any part of vertex list is contained within clipping set.*/
        containsVertices: function(vertices) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return true;

            this._resultMask = polytopeBack;

            for (var k = 0; k < vertices.length; ++k) {
                var v = vertices[k];
                var outside = false;
                var selectorMask = 0x1;
                for (var i = 0; !outside && i < this._planeList.length; ++i) {
                    if (
                        polytopeBack & selectorMask &&
                        __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].distanceToPlane(this._planeList[i], v) < 0.0
                    ) {
                        outside = true;
                    }
                    selectorMask <<= 1;
                }

                if (!outside) return true;
            }
            return false;
        },

        /** Check whether any part of a bounding sphere is contained within clipping set.
        Using a mask to determine which planes should be used for the check, and
        modifying the mask to turn off planes which wouldn't contribute to clipping
        of any internal objects.  This feature is used in osgUtil::CullVisitor
        to prevent redundant plane checking.*/
        containsBoundingSphere: function(bs) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack || !bs.valid()) return true;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;

            for (var i = 0; i < this._planeList.length; ++i) {
                if (this._resultMask & selectorMask) {
                    var res = __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].intersectsOrContainsBoundingSphere(this._planeList[i], bs);
                    if (__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].OUTSIDE === res) {
                        // totally outside a clipping set.
                        return false;
                    } else if (__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].INSIDE === res) {
                        // subsequent checks against this plane not required.
                        this._resultMask ^= selectorMask;
                    }
                    // else if ( Plane.INTERSECT === res ) { // last possible case
                    //   can say nothing.
                    // subsequent checks against this plane needed.
                    //}
                }
                selectorMask <<= 1;
            }
            return true;
        },

        /** Check whether any part of a bounding box is contained within clipping set.
        Using a mask to determine which planes should be used for the check, and
        modifying the mask to turn off planes which wouldn't contribute to clipping
        of any internal objects.  This feature is used in osgUtil::CullVisitor
        to prevent redundant plane checking.*/
        containsBoundingBox: function(bb) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return true;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;

            for (var i = 0; i < this._planeList.length; ++i) {
                if (this._resultMask & selectorMask) {
                    var res = __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].intersectsOrContainsBoundingBox(this._planeList[i], bb);
                    if (__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].OUTSIDE === res) return false;
                    else if (__WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].INSIDE === res)
                        // outside clipping set.
                        this._resultMask ^= selectorMask; // subsequent checks against this plane not required.
                    // else if ( Plane.INTERSECT === res ) the last case need
                    // no test here but further tests
                }
                selectorMask <<= 1;
            }
            // correct frustum culling should double check now for
            // http://www.iquilezles.org/www/articles/frustumcorrect/frustumcorrect.htm
            // which is inside one "plane", but outside the convex plane intersection
            return true;
        },

        /** Check whether all of vertex list is contained with clipping set.*/
        containsAllOfVertices: function(vertices) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return false;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;

            for (var i = 0; i < this._planeList.length; ++i) {
                if (this._resultMask & selectorMask) {
                    var res = __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].intersectsOrContainsVertices(this._planeList[i], vertices);
                    if (res < 1) return false; // intersects, or is below plane.
                    this._resultMask ^= selectorMask; // subsequent checks against this plane not required.
                }
                selectorMask <<= 1;
            }
            return true;
        },

        /** Check whether the entire bounding sphere is contained within clipping set.*/
        containsAllOfBoundingSphere: function(bs) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return false;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;

            for (var i = 0; i < this._planeList.length; ++i) {
                if (this._resultMask & selectorMask) {
                    var res = __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].intersectsOrContainsBoundingSphere(this._planeList[i], bs);
                    if (res < 1) return false; // intersects, or is below plane.
                    this._resultMask ^= selectorMask; // subsequent checks against this plane not required.
                }
                selectorMask <<= 1;
            }
            return true;
        },

        /** Check whether the entire bounding box is contained within clipping set.*/
        containsAllOfBoundingBox: function(bbox) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return false;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;

            for (var i = 0; i < this._planeList.length; ++i) {
                if (this._resultMask & selectorMask) {
                    var res = __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].intersectsOrContainsBoundingBox(this._planeList[i], bbox);
                    if (res < 1) return false; // intersects, or is below plane.
                    this._resultMask ^= selectorMask; // subsequent checks against this plane not required.
                }
                selectorMask <<= 1;
            }
            return true;
        },

        /** Transform the clipping set by provide a pre inverted matrix.
     * see transform for details. */
        transformProvidingInverse: function(matrix) {
            var polytopeBack = this._maskStack.back();
            if (!polytopeBack) return;

            this._resultMask = polytopeBack;
            var selectorMask = 0x1;
            for (var i = 0; i < this._planeList.length; ++i) {
                if (polytopeBack & selectorMask) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_Plane__["a" /* default */].transformProvidingInverse(this._planeList[i], matrix);
                }
                selectorMask <<= 1;
            }
        }
    }),
    'osg',
    'Polytope'
);

/*jshint bitwise: true */

/* harmony default export */ __webpack_exports__["a"] = (Polytope);


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);




var Projection = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);
    this.projection = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Projection,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        getProjectionMatrix: function() {
            return this.projection;
        },
        setProjectionMatrix: function(m) {
            this.projection = m;
        }
    }),
    'osg',
    'Projection'
);

/* harmony default export */ __webpack_exports__["a"] = (Projection);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);





/**
 *  LightSource is a positioned node to use with StateAttribute Light
 *  @class LightSource
 */
var LightSource = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);
    this.setCullingActive(false);
    this._light = undefined;
    this._referenceFrame = __WEBPACK_IMPORTED_MODULE_2_osg_transformEnums__["a" /* default */].RELATIVE_RF;
};

/** @lends LightSource.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    LightSource,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        getLight: function() {
            return this._light;
        },
        setLight: function(light) {
            this._light = light;
        },
        setReferenceFrame: function(value) {
            this._referenceFrame = value;
        },
        getReferenceFrame: function() {
            return this._referenceFrame;
        },
        computeBoundingSphere: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();

            return function(bsphere) {
                __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.computeBoundingSphere.call(this, bsphere);

                if (
                    this._light !== undefined &&
                    this._referenceFrame === __WEBPACK_IMPORTED_MODULE_2_osg_transformEnums__["a" /* default */].RELATIVE_RF
                ) {
                    var position = this._light.getPosition();

                    if (position[3] !== 0.0) {
                        bsphere.expandByVec3(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].scale(tmp, position, 1.0 / position[3]));
                    }
                }

                return bsphere;
            };
        })()
    }),
    'osg',
    'LightSource'
);

/* harmony default export */ __webpack_exports__["a"] = (LightSource);


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_PooledMap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_PooledResource__ = __webpack_require__(24);





var StateGraph = function() {
    this._depth = 0;
    this._children = new __WEBPACK_IMPORTED_MODULE_2_osg_PooledMap__["a" /* default */]();
    this._leafs = new __WEBPACK_IMPORTED_MODULE_1_osg_PooledArray__["a" /* default */]();
    this._stateset = undefined;
    this._parent = undefined;
};

var createStateGraph = function() {
    return new StateGraph();
};

StateGraph.pooledStateGraph = new __WEBPACK_IMPORTED_MODULE_3_osg_PooledResource__["a" /* default */](createStateGraph);
StateGraph.statsNbMoveStateGraph = 0;

StateGraph.reset = function() {
    StateGraph.pooledStateGraph.reset();
    StateGraph.statsNbMoveStateGraph = 0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StateGraph,
    {
        clean: function() {
            this._leafs.reset();
            this._children.reset();
            this._depth = 0;
            this._stateset = undefined;
            this._parent = undefined;
        },
        getStateSet: function() {
            return this._stateset;
        },
        getLeafs: function() {
            return this._leafs;
        },
        getParent: function() {
            return this._parent;
        },
        findOrInsert: function(stateset) {
            // nb call per frame as example: 22 (shadowmap) 55 (pbr) to 512 (performance)
            // it's called by node that have a stateSet
            var stateSetID = stateset.getInstanceID();
            var childrenMap = this._children.getMap();
            var sg = childrenMap[stateSetID];
            if (!sg) {
                sg = StateGraph.pooledStateGraph.getOrCreateObject();
                sg.clean();

                sg._parent = this;
                sg._depth = this._depth + 1;
                sg._stateset = stateset;
                this._children.set(stateSetID, sg);
            }

            return sg;
        }
    },
    'osg',
    'StateGraph'
);

StateGraph.moveStateGraph = (function() {
    var stack = new __WEBPACK_IMPORTED_MODULE_1_osg_PooledArray__["a" /* default */]();
    var stackArray = stack.getArray();
    return function(state, sgCurrentArg, sgNewArg) {
        StateGraph.statsNbMoveStateGraph++;
        // nb call per frame: 3 (pbr) 10 (shadowmap) 1(performance)

        stack.reset();
        var sgNew = sgNewArg;
        var sgCurrent = sgCurrentArg;
        var i, l;
        if (sgNew === sgCurrent || sgNew === undefined) return;

        if (sgCurrent === undefined) {
            // push stateset from sgNew to root, and apply
            // stateset from root to sgNew
            do {
                if (sgNew._stateset !== undefined) {
                    stack.push(sgNew._stateset);
                }
                sgNew = sgNew._parent;
            } while (sgNew);

            for (i = stack._length - 1, l = 0; i >= l; --i) {
                state.pushStateSet(stackArray[i]);
            }
            return;
        } else if (sgCurrent._parent === sgNew._parent) {
            // first handle the typical case which is two state groups
            // are neighbours.

            // state has changed so need to pop old state.
            if (sgCurrent._stateset !== undefined) {
                state.popStateSet();
            }
            // and push new state.
            if (sgNew._stateset !== undefined) {
                state.pushStateSet(sgNew._stateset);
            }
            return;
        }

        // need to pop back up to the same depth as the new state group.
        while (sgCurrent._depth > sgNew._depth) {
            if (sgCurrent._stateset !== undefined) {
                state.popStateSet();
            }
            sgCurrent = sgCurrent._parent;
        }

        // use return path to trace back steps to sgNew.
        stack.reset();

        // need to pop back up to the same depth as the curr state group.
        while (sgNew._depth > sgCurrent._depth) {
            if (sgNew._stateset !== undefined) {
                stack.push(sgNew._stateset);
            }
            sgNew = sgNew._parent;
        }

        // now pop back up both parent paths until they agree.

        // DRT - 10/22/02
        // should be this to conform with above case where two StateGraph
        // nodes have the same parent
        while (sgCurrent !== sgNew) {
            if (sgCurrent._stateset !== undefined) {
                state.popStateSet();
            }
            sgCurrent = sgCurrent._parent;

            if (sgNew._stateset !== undefined) {
                stack.push(sgNew._stateset);
            }
            sgNew = sgNew._parent;
        }

        for (i = stack._length - 1, l = 0; i >= l; --i) {
            state.pushStateSet(stackArray[i]);
        }
    };
})();

/* harmony default export */ __webpack_exports__["a"] = (StateGraph);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_PooledResource__ = __webpack_require__(24);








/**
 * From OpenSceneGraph http://www.openscenegraph.org
 * RenderStage base class. Used for encapsulate a complete stage in
 * rendering - setting up of viewport, the projection and model
 * matrices and rendering the RenderBin's enclosed with this RenderStage.
 * RenderStage also has a dependency list of other RenderStages, each
 * of which must be called before the rendering of this stage.  These
 * 'pre' rendering stages are used for advanced rendering techniques
 * like multistage pixel shading or impostors.
 */
var RenderStage = function() {
    __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].call(this);
    this._clearColor = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].create();
    this._clearDepth = undefined;
    this._clearMask = undefined;
    this._camera = undefined;
    this._viewport = undefined;
    this._scissor = undefined;
    this._preRenderList = [];
    this._postRenderList = [];
    // calling prototype to make sure
    // we call renderstage and not renderbin init
    RenderStage.prototype.init.call(this);
};

var createRenderStageOrder = function() {
    return {
        renderStage: null,
        order: null
    };
};

var pooledRenderStageOrder = new __WEBPACK_IMPORTED_MODULE_6_osg_PooledResource__["a" /* default */](createRenderStageOrder);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    RenderStage,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].prototype, {
        init: function() {
            __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].prototype.init.call(this);
            this._clearDepth = 1.0;
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].set(this._clearColor, 0.0, 0.0, 0.0, 1.0);
            /*jshint bitwise: false */
            this._clearMask = __WEBPACK_IMPORTED_MODULE_1_osg_Camera__["a" /* default */].COLOR_BUFFER_BIT | __WEBPACK_IMPORTED_MODULE_1_osg_Camera__["a" /* default */].DEPTH_BUFFER_BIT;
            /*jshint bitwise: true */
            this._camera = undefined;
            this._viewport = undefined;
            this._scissor = undefined;
            this._renderStage = this;
            RenderStage.prototype._initInternal.call(this);
            return this;
        },

        _initInternal: function() {
            this._preRenderList.length = 0;
            this._postRenderList.length = 0;
        },

        reset: function() {
            pooledRenderStageOrder.reset();
            __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].prototype.reset.call(this);
            RenderStage.prototype._initInternal.call(this);
        },

        setClearDepth: function(depth) {
            this._clearDepth = depth;
        },

        getClearDepth: function() {
            return this._clearDepth;
        },

        setClearColor: function(color) {
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].copy(this._clearColor, color);
        },

        getClearColor: function() {
            return this._clearColor;
        },

        setClearMask: function(mask) {
            this._clearMask = mask;
        },

        getClearMask: function() {
            return this._clearMask;
        },

        setViewport: function(vp) {
            this._viewport = vp;
        },

        getViewport: function() {
            return this._viewport;
        },

        setScissor: function(scissor) {
            this._scissor = scissor;
        },

        getScissor: function() {
            return this._scissor;
        },

        setCamera: function(camera) {
            this._camera = camera;
        },

        getCamera: function() {
            return this._camera;
        },

        getPreRenderStageList: function() {
            return this._preRenderList;
        },

        getPostRenderStageList: function() {
            return this._postRenderList;
        },

        addPreRenderStage: function(rs, order) {
            for (var i = 0, l = this._preRenderList.length; i < l; i++) {
                var render = this._preRenderList[i];
                if (order < render.order) {
                    break;
                }
            }

            var renderStageOrder = pooledRenderStageOrder.getOrCreateObject();
            renderStageOrder.order = order;
            renderStageOrder.renderStage = rs;
            if (i < this._preRenderList.length) {
                this._preRenderList = this._preRenderList.splice(i, 0, renderStageOrder);
            } else {
                this._preRenderList.push(renderStageOrder);
            }
        },

        addPostRenderStage: function(rs, order) {
            for (var i = 0, l = this._postRenderList.length; i < l; i++) {
                var render = this._postRenderList[i];
                if (order < render.order) {
                    break;
                }
            }

            var renderStageOrder = pooledRenderStageOrder.getOrCreateObject();
            renderStageOrder.order = order;
            renderStageOrder.renderStage = rs;
            if (i < this._postRenderList.length) {
                this._postRenderList = this._postRenderList.splice(i, 0, renderStageOrder);
            } else {
                this._postRenderList.push(renderStageOrder);
            }
        },

        drawPreRenderStages: function(state, previousRenderLeaf) {
            var previousLeaf = previousRenderLeaf;
            for (var i = 0, l = this._preRenderList.length; i < l; ++i) {
                var sg = this._preRenderList[i].renderStage;
                previousLeaf = sg.draw(state, previousLeaf);
            }
            return previousLeaf;
        },

        draw: function(state, previousRenderLeaf) {
            if (this._camera && this._camera.getInitialDrawCallback()) {
                // if we have a camera with a final callback invoke it.
                this._camera.getInitialDrawCallback()(state);
            }

            var previousLeaf = this.drawPreRenderStages(state, previousRenderLeaf);

            previousLeaf = this.drawImplementation(state, previousLeaf);

            previousLeaf = this.drawPostRenderStages(state, previousLeaf);

            if (this._camera && this._camera.getFinalDrawCallback()) {
                // if we have a camera with a final callback invoke it.
                this._camera.getFinalDrawCallback()(state);
            }

            return previousLeaf;
        },

        sort: function() {
            for (var i = 0, l = this._preRenderList.length; i < l; ++i) {
                this._preRenderList[i].renderStage.sort();
            }

            __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].prototype.sort.call(this);

            for (var j = 0, k = this._postRenderList.length; j < k; ++j) {
                this._postRenderList[j].renderStage.sort();
            }
        },

        drawPostRenderStages: function(state, previousRenderLeaf) {
            var previousLeaf = previousRenderLeaf;
            for (var i = 0, l = this._postRenderList.length; i < l; ++i) {
                var sg = this._postRenderList[i].renderStage;
                previousLeaf = sg.draw(state, previousLeaf);
            }
            return previousLeaf;
        },

        applyCamera: function(state) {
            var gl = state.getGraphicContext();
            if (this._camera === undefined) {
                gl.bindFramebuffer(gl.FRAMEBUFFER, null);
                return;
            }
            var viewport = this._camera.getViewport();
            var fbo = this._camera.frameBufferObject;

            if (!fbo) {
                fbo = new __WEBPACK_IMPORTED_MODULE_2_osg_FrameBufferObject__["a" /* default */]();
                this._camera.frameBufferObject = fbo;
            }

            if (fbo.isDirty()) {
                var attachments = this._camera.getAttachments();

                // framebuffer texture and renderbuffer must be same dimension
                // otherwise framebuffer is incomplete
                var framebufferWidth, framebufferHeight;
                var colorAttachment = attachments[__WEBPACK_IMPORTED_MODULE_2_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0];
                if (colorAttachment && colorAttachment.texture) {
                    framebufferWidth = colorAttachment.texture.getWidth();
                    framebufferHeight = colorAttachment.texture.getHeight();
                }

                // we should use a map in camera to avoid to regenerate the keys
                // each time. But because we dont have a lot of camera I guess
                // it does not change a lot
                // texture and renderbuffer must be same size.
                for (var keyAttachment in attachments) {
                    colorAttachment = attachments[keyAttachment];

                    var attach = {};
                    attach.attachment = colorAttachment.attachment;

                    if (colorAttachment.texture === undefined) {
                        //renderbuffer

                        attach.format = colorAttachment.format;
                        attach.width =
                            framebufferWidth !== undefined ? framebufferWidth : viewport.width();
                        attach.height =
                            framebufferHeight !== undefined ? framebufferHeight : viewport.height();
                    } else {
                        attach.texture = colorAttachment.texture;
                        attach.textureTarget = colorAttachment.textureTarget;

                        if (colorAttachment.format) {
                            attach.format = colorAttachment.format;
                        }
                    }

                    fbo.setAttachment(attach);
                }
            }
            fbo.apply(state);
        },

        drawImplementation: function(state, previousRenderLeaf) {
            var gl = state.getGraphicContext();

            this.applyCamera(state);

            // projection clipping
            if (this._viewport === undefined) {
                __WEBPACK_IMPORTED_MODULE_3_osg_notify__["a" /* default */].log('RenderStage does not have a valid viewport');
            }
            state.applyAttribute(this._viewport);

            if (this._scissor) {
                state.applyAttribute(this._scissor);
            }

            if (this._clearMask !== 0x0) {
                if (this._clearMask & gl.COLOR_BUFFER_BIT) {
                    state.clearColor(this._clearColor);
                }
                if (this._clearMask & gl.DEPTH_BUFFER_BIT) {
                    state.depthMask(true);
                    state.clearDepth(this._clearDepth);
                }
                state.clear(this._clearMask);
            }

            if (this._positionedAttribute.getLength() !== 0) {
                this.applyPositionedAttribute(state, this._positionedAttribute);
            }

            var previousLeaf = __WEBPACK_IMPORTED_MODULE_4_osg_RenderBin__["a" /* default */].prototype.drawImplementation.call(
                this,
                state,
                previousRenderLeaf
            );

            return previousLeaf;
        }
    }),
    'osg',
    'RenderStage'
);

RenderStage.clean = function () {
    pooledRenderStageOrder.clean();
};

/* harmony default export */ __webpack_exports__["a"] = (RenderStage);


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_BoundingSphere__ = __webpack_require__(39);








/**
 *  Lod that can contains child node
 *  @class Lod
 */
var Lod = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);
    this._radius = -1;
    this._range = [];
    this._rangeMode = Lod.DISTANCE_FROM_EYE_POINT;
    this._userDefinedCenter = [];
    this._centerMode = Lod.USE_BOUNDING_SPHERE_CENTER;
};

Lod.DISTANCE_FROM_EYE_POINT = 0;
Lod.PIXEL_SIZE_ON_SCREEN = 1;

Lod.USE_BOUNDING_SPHERE_CENTER = 0;
Lod.USER_DEFINED_CENTER = 1;
Lod.UNION_OF_BOUNDING_SPHERE_AND_USER_DEFINED = 2;

/** @lends Lod.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Lod,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        // Functions here
        getRadius: function() {
            return this._radius;
        },

        /** Set the object-space reference radius of the volume enclosed by the LOD.
     * Used to determine the bounding sphere of the LOD in the absence of any children.*/
        setRadius: function(radius) {
            this._radius = radius;
        },

        setCenter: function(center) {
            if (this._centerMode !== Lod.UNION_OF_BOUNDING_SPHERE_AND_USER_DEFINED)
                this._centerMode = Lod.USER_DEFINED_CENTER;
            this._userDefinedCenter = center;
        },

        getCenter: function() {
            if (
                this._centerMode === Lod.USER_DEFINED_CENTER ||
                this._centerMode === Lod.UNION_OF_BOUNDING_SPHERE_AND_USER_DEFINED
            )
                return this._userDefinedCenter;
            else return this.getBound().center();
        },

        setCenterMode: function(centerMode) {
            this._centerMode = centerMode;
        },

        computeBoundingSphere: function(bsphere) {
            if (this._centerMode === Lod.USER_DEFINED_CENTER && this._radius >= 0.0) {
                bsphere.set(this._userDefinedCenter, this._radius);
                return bsphere;
            } else if (
                this._centerMode === Lod.UNION_OF_BOUNDING_SPHERE_AND_USER_DEFINED &&
                this._radius >= 0.0
            ) {
                bsphere.set(this._userDefinedCenter, this._radius);
                var bs = new __WEBPACK_IMPORTED_MODULE_4_osg_BoundingSphere__["a" /* default */]();
                bsphere.expandByBoundingSphere(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.computeBoundingSphere.call(this, bs));
                return bsphere;
            } else {
                __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.computeBoundingSphere.call(this, bsphere);
                return bsphere;
            }
        },

        projectBoundingSphere: (function() {
            // from http://www.iquilezles.org/www/articles/sphereproj/sphereproj.htm
            // Sample code at http://www.shadertoy.com/view/XdBGzd?
            var o = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            return function(sph, camMatrix, fle) {
                __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].transformMat4(o, sph.center(), camMatrix);
                var r2 = sph.radius2();
                var z2 = o[2] * o[2];
                var l2 = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].sqrLen(o);
                var area =
                    -Math.PI *
                    fle *
                    fle *
                    r2 *
                    Math.sqrt(Math.abs((l2 - r2) / (r2 - z2))) /
                    (r2 - z2);
                return area;
            };
        })(),

        setRangeMode: function(mode) {
            //TODO: check if mode is correct
            this._rangeMode = mode;
        },

        addChildNode: function(node) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.addChild.call(this, node);
            if (this.children.length > this._range.length) {
                var r = [];
                var max = 0.0;
                if (this._range.lenght > 0) max = this._range[this._range.length - 1][1];
                r.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["e" /* vec2 */].fromValues(max, max));
                this._range.push(r);
            }
            return true;
        },

        addChild: function(node, min, max) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.addChild.call(this, node);

            if (this.children.length > this._range.length) {
                var r = [];
                r.push(__WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["e" /* vec2 */].fromValues(min, min));
                this._range.push(r);
            }
            this._range[this.children.length - 1][0] = min;
            this._range[this.children.length - 1][1] = max;
            return true;
        },

        traverse: (function() {
            // avoid to generate variable on the heap to limit garbage collection
            // instead create variable and use the same each time
            var zeroVector = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var eye = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var viewModel = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();

            return function(visitor) {
                var traversalMode = visitor.traversalMode;

                switch (traversalMode) {
                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN:
                        for (var index = 0; index < this.children.length; index++) {
                            this.children[index].accept(visitor);
                        }
                        break;

                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ACTIVE_CHILDREN:
                        var requiredRange = 0;
                        var matrix = visitor.getCurrentModelViewMatrix();
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].invert(viewModel, matrix);
                        // Calculate distance from viewpoint
                        if (this._rangeMode === Lod.DISTANCE_FROM_EYE_POINT) {
                            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, zeroVector, viewModel);
                            var d = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].distance(this.getBound().center(), eye);
                            requiredRange = d * visitor.getLODScale();
                        } else {
                            // Let's calculate pixels on screen
                            var projmatrix = visitor.getCurrentProjectionMatrix();
                            // focal lenght is the value stored in projmatrix[0]
                            requiredRange = this.projectBoundingSphere(
                                this.getBound(),
                                matrix,
                                projmatrix[0]
                            );
                            // Multiply by a factor to get the real area value
                            requiredRange =
                                requiredRange *
                                visitor.getViewport().width() *
                                visitor.getViewport().width() *
                                0.25 /
                                visitor.getLODScale();
                        }

                        var numChildren = this.children.length;
                        if (this._range.length < numChildren) numChildren = this._range.length;

                        for (var j = 0; j < numChildren; ++j) {
                            if (
                                this._range[j][0] <= requiredRange &&
                                requiredRange < this._range[j][1]
                            ) {
                                this.children[j].accept(visitor);
                            }
                        }
                        break;

                    default:
                        break;
                }
            };
        })()
    }),
    'osg',
    'Lod'
);

/* harmony default export */ __webpack_exports__["a"] = (Lod);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Lod__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);






/**
 *  PagedLOD that can contains paged child nodes
 *  @class PagedLod
 */
var PagedLOD = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].call(this);
    this._perRangeDataList = [];
    this._loading = false;
    this._expiryTime = 0.0;
    this._expiryFrame = 0;
    this._centerMode = __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].USER_DEFINED_CENTER;
    this._frameNumberOfLastTraversal = 0;
    this._databasePath = '';
    this._numChildrenThatCannotBeExpired = 0;
    this._databaseOptions = undefined;
    this._scaleRangeFactor = 4;
};

/**
 *  PerRangeData utility structure to store per range values
 *  @class PerRangeData
 */
var PerRangeData = function() {
    this.filename = '';
    this.function = undefined;
    this.loaded = false;
    this.timeStamp = 0.0;
    this.frameNumber = 0;
    this.frameNumberOfLastTraversal = 0;
    this.dbrequest = undefined;
};

/** @lends PagedLOD.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    PagedLOD,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].prototype, {
        // Functions here
        setRange: function(childNo, min, max) {
            if (childNo >= this._range.length) {
                var r = [];
                r.push([min, min]);
                this._range.push(r);
            }
            this._range[childNo][0] = min;
            this._range[childNo][1] = max;
        },

        setExpiryTime: function(expiryTime) {
            this._expiryTime = expiryTime;
        },

        setDatabasePath: function(path) {
            this._databasePath = path;
        },

        getDatabasePath: function() {
            return this._databasePath;
        },

        setFileName: function(childNo, filename) {
            // May we should expand the vector first?
            if (childNo >= this._perRangeDataList.length) {
                var rd = new PerRangeData();
                rd.filename = filename;
                this._perRangeDataList.push(rd);
            } else {
                this._perRangeDataList[childNo].filename = filename;
            }
        },
        setFunction: function(childNo, func) {
            if (childNo >= this._perRangeDataList.length) {
                var rd = new PerRangeData();
                rd.function = func;
                this._perRangeDataList.push(rd);
            } else {
                this._perRangeDataList[childNo].function = func;
            }
        },

        addChild: function(node, min, max) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].prototype.addChild.call(this, node, min, max);
            this._perRangeDataList.push(new PerRangeData());
        },

        addChildNode: function(node) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].prototype.addChildNode.call(this, node);
        },

        setFrameNumberOfLastTraversal: function(frameNumber) {
            this._frameNumberOfLastTraversal = frameNumber;
        },

        getFrameNumberOfLastTraversal: function() {
            return this._frameNumberOfLastTraversal;
        },
        setTimeStamp: function(childNo, timeStamp) {
            this._perRangeDataList[childNo].timeStamp = timeStamp;
        },
        setFrameNumber: function(childNo, frameNumber) {
            this._perRangeDataList[childNo].frameNumber = frameNumber;
        },
        setNumChildrenThatCannotBeExpired: function(num) {
            this._numChildrenThatCannotBeExpired = num;
        },
        getNumChildrenThatCannotBeExpired: function() {
            return this._numChildrenThatCannotBeExpired;
        },
        getDatabaseRequest: function(childNo) {
            return this._perRangeDataList[childNo].dbrequest;
        },
        removeExpiredChildren: function(expiryTime, expiryFrame, removedChildren) {
            if (this.children.length <= this._numChildrenThatCannotBeExpired) return;
            var i = this.children.length - 1;
            var timed, framed;
            timed = this._perRangeDataList[i].timeStamp + this._expiryTime;
            framed = this._perRangeDataList[i].frameNumber + this._expiryFrame;
            if (
                timed < expiryTime &&
                framed < expiryFrame &&
                (this._perRangeDataList[i].filename.length > 0 ||
                    this._perRangeDataList[i].function !== undefined)
            ) {
                removedChildren.push(this.children[i]);
                this.removeChild(this.children[i]);
                this._perRangeDataList[i].loaded = false;
                if (this._perRangeDataList[i].dbrequest !== undefined) {
                    this._perRangeDataList[i].dbrequest._groupExpired = true;
                }
            }
        },
        setDatabaseOptions: function(databaseOptions) {
            this._databaseOptions = databaseOptions;
        },
        getDatabaseOptions: function() {
            return this._databaseOptions;
        },

        traverse: (function() {
            // avoid to generate variable on the heap to limit garbage collection
            // instead create variable and use the same each time
            var zeroVector = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var eye = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].create();
            var viewModel = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].create();

            return function(visitor) {
                var traversalMode = visitor.traversalMode;
                var updateTimeStamp = false;

                if (visitor.getVisitorType() === __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].CULL_VISITOR) {
                    this._frameNumberOfLastTraversal = visitor.getFrameStamp().getFrameNumber();
                    updateTimeStamp = true;
                }

                switch (traversalMode) {
                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN:
                        for (var index = 0; index < this.children.length; index++) {
                            this.children[index].accept(visitor);
                        }
                        break;

                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ACTIVE_CHILDREN:
                        var requiredRange = 0;

                        // Calculate distance from viewpoint
                        var matrix = visitor.getCurrentModelViewMatrix();
                        __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].invert(viewModel, matrix);
                        if (this._rangeMode === __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].DISTANCE_FROM_EYE_POINT) {
                            __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, zeroVector, viewModel);
                            var d = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */].distance(this.getBound().center(), eye);
                            requiredRange = d * visitor.getLODScale();
                        } else {
                            // Calculate pixels on screen
                            var projmatrix = visitor.getCurrentProjectionMatrix();
                            requiredRange = this.getRequiredRange( this.getBound(), visitor, projmatrix[ 0 ] );
                            if (requiredRange < 0)
                                requiredRange = this._range[this._range.length - 1][0];
                        }

                        var needToLoadChild = false;
                        var lastChildTraversed = -1;
                        for (var j = 0; j < this._range.length; ++j) {
                            if (
                                this._range[j][0] <= requiredRange &&
                                requiredRange < this._range[j][1]
                            ) {
                                if (j < this.children.length) {
                                    if (updateTimeStamp) {
                                        this._perRangeDataList[
                                            j
                                        ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                                        this._perRangeDataList[
                                            j
                                        ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                                    }

                                    this.children[j].accept(visitor);
                                    lastChildTraversed = j;
                                } else {
                                    needToLoadChild = true;
                                }
                            }
                        }
                        if (needToLoadChild) {
                            var numChildren = this.children.length;
                            if (numChildren > 0 && numChildren - 1 !== lastChildTraversed) {
                                if (updateTimeStamp) {
                                    this._perRangeDataList[
                                        numChildren - 1
                                    ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                                    this._perRangeDataList[
                                        numChildren - 1
                                    ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                                }

                                this.children[numChildren - 1].accept(visitor);
                            }
                            // now request the loading of the next unloaded child.
                            if (numChildren < this._perRangeDataList.length) {
                                // compute priority from where abouts in the required range the distance falls.
                                var priority =
                                    (this._range[numChildren][0] - requiredRange) /
                                    (this._range[numChildren][1] - this._range[numChildren][0]);
                                if (this._rangeMode === __WEBPACK_IMPORTED_MODULE_1_osg_Lod__["a" /* default */].PIXEL_SIZE_ON_SCREEN) {
                                    priority = -priority;
                                }
                                // Here we do the request
                                var group = visitor.nodePath[visitor.nodePath.length - 1];
                                if (this._perRangeDataList[numChildren].loaded === false) {
                                    this._perRangeDataList[numChildren].loaded = true;
                                    var dbhandler = visitor.getDatabaseRequestHandler();
                                    this._perRangeDataList[
                                        numChildren
                                    ].dbrequest = dbhandler.requestNodeFile(
                                        this._perRangeDataList[numChildren].function,
                                        this._databasePath +
                                            this._perRangeDataList[numChildren].filename,
                                        group,
                                        visitor.getFrameStamp().getSimulationTime(),
                                        priority,
                                        this._databaseOptions
                                    );
                                } else {
                                    // Update timestamp of the request.
                                    if (
                                        this._perRangeDataList[numChildren].dbrequest !== undefined
                                    ) {
                                        this._perRangeDataList[
                                            numChildren
                                        ].dbrequest._timeStamp = visitor
                                            .getFrameStamp()
                                            .getSimulationTime();
                                        this._perRangeDataList[
                                            numChildren
                                        ].dbrequest._priority = priority;
                                    } else {
                                        // The DB request is undefined, so the DBPager was not accepting requests, we need to ask for the child again.
                                        this._perRangeDataList[numChildren].loaded = false;
                                    }
                                }
                            }
                        }
                        break;
                    default:
                        break;
                }
            };
        })(),
        getRequiredRange: function ( bound, visitor, focalLength ) {
            var requiredRange = 0;
            var epsilon = 25e-5;
            var projMatrix = visitor.getCurrentProjectionMatrix();
            var viewMatrix = visitor.getCurrentModelViewMatrix();
            // for ortho mode
            if ( Math.abs( projMatrix[ 2 ] ) < epsilon && Math.abs( projMatrix[ 6 ] ) < epsilon && Math.abs( projMatrix[ 11 ] ) < epsilon ) {
                var widthDiff = 2 / projMatrix[ 0 ];
                var heightDiff = 2 / projMatrix[ 5 ];

                requiredRange = this._scaleRangeFactor * ( ( Math.PI * this.getBound().radius() * this.getBound().radius() ) / ( widthDiff * heightDiff ) );
            } else {
                requiredRange = this.projectBoundingSphere( bound, viewMatrix, focalLength );
            }

            // Get the real area value and apply LODScale
            requiredRange = ( ( requiredRange * visitor.getViewport().width() * visitor.getViewport().width() ) * 0.25 ) / visitor.getLODScale();

            return requiredRange;
        }
    }),
    'osg',
    'PagedLOD'
);

/* harmony default export */ __webpack_exports__["a"] = (PagedLOD);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateMatrixTransform__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__ = __webpack_require__(3);






/**
 *  UpdateBone
 *  @class UpdateBone
 */
var UpdateBone = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateMatrixTransform__["a" /* default */].call(this);
};

/** @lends UpdateBone.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateBone,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateMatrixTransform__["a" /* default */].prototype, {
        update: function(node, nv) {
            if (nv.getVisitorType() === __WEBPACK_IMPORTED_MODULE_4_osg_NodeVisitor__["a" /* default */].UPDATE_VISITOR) {
                if (node.className && node.className() !== 'Bone') {
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn('Warning: UpdateBone set on non-Bone object.');
                    return false;
                }

                var bone = node;

                __WEBPACK_IMPORTED_MODULE_2_osgAnimation_UpdateMatrixTransform__["a" /* default */].prototype.update.call(this, node);
                bone.setMatrix(bone.getMatrix());
                var matrix = bone.getMatrix();
                var parent = bone.getBoneParent();

                if (parent) {
                    __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */].mul(
                        bone.getMatrixInSkeletonSpace(),
                        parent.getMatrixInSkeletonSpace(),
                        matrix
                    );
                } else {
                    bone.setMatrixInSkeletonSpace(matrix);
                }
            }
            return true;
        }
    }),
    'osgAnimation',
    'UpdateBone'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateBone);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_DrawArrays__ = __webpack_require__(18);




/**
 * PrimitiveIndexFunctor emulates the TemplatePrimitiveIndexFunctor class in OSG and can
 * be used to get access to the vertices that compose the things drawn by osgjs.
 *
 * You have to feed it with an object that references 3 callbacks :
 *
 * var myObject = {
 *     operatorPoint : function ( v ) { }, // Do your point operations here
 *     operatorLine : function ( v1, v2 ){ }, // Do you line operations here
 *     operatorTriangle : function ( v1, v2, v3 ) { } // Do your triangle operations here
 * };
 *
 */

var functorDrawElements = [];
var functorDrawArrays = [];

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLES] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; i += 3) {
        cb.operatorTriangle(indexes[i], indexes[i + 1], indexes[i + 2]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = function(offset, count, indexes, cb) {
    for (var i = 2, j = offset; i < count; ++i, ++j) {
        if (i % 2) cb.operatorTriangle(indexes[j], indexes[j + 2], indexes[j + 1]);
        else cb.operatorTriangle(indexes[j], indexes[j + 1], indexes[j + 2]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = function(offset, count, indexes, cb) {
    var first = indexes[offset];
    for (var i = 2, j = offset + 1; i < count; ++i, ++j) {
        cb.operatorTriangle(first, indexes[j], indexes[j + 1]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].POINTS] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; ++i) {
        cb.operatorPoint(indexes[i]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINES] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; i += 2) {
        cb.operatorLine(indexes[i], indexes[i + 1]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINE_STRIP] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; ++i) {
        cb.operatorLine(indexes[i], indexes[i + 1]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINE_LOOP] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; ++i) {
        cb.operatorLine(indexes[i], indexes[i + 1]);
    }
    cb.operatorLine(indexes[indexes.length - 1], indexes[0]);
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLES] = function(first, count, cb) {
    for (var i = 2, pos = first; i < count; i += 3, pos += 3) {
        cb.operatorTriangle(pos, pos + 1, pos + 2);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = function(first, count, cb) {
    for (var i = 2, pos = first; i < count; ++i, ++pos) {
        if (i % 2) cb.operatorTriangle(pos, pos + 2, pos + 1);
        else cb.operatorTriangle(pos, pos + 1, pos + 2);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = function(first, count, cb) {
    for (var i = 2, pos = first + 1; i < count; ++i, ++pos) {
        cb.operatorTriangle(first, pos, pos + 1);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].POINTS] = function(first, count, cb) {
    for (var i = 0, pos = first; i < count; ++i, ++pos) {
        cb.operatorPoint(pos);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINES] = function(first, count, cb) {
    for (var i = 1, pos = first; i < count; i += 2, pos += 2) {
        cb.operatorLine(pos, pos + 1);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINE_STRIP] = function(first, count, cb) {
    for (var i = 1, pos = first; i < count; ++i, ++pos) {
        cb.operatorLine(pos, pos + 1);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].LINE_LOOP] = function(first, count, cb) {
    for (var i = 1, pos = first; i < count; ++i, ++pos) {
        cb.operatorLine(pos, pos + 1);
    }
    cb.operatorLine(first + count - 1, first);
};

var primitiveIndexFunctor = function(geom, cb) {
    var primitives = geom.getPrimitiveSetList();
    if (!primitives) return;

    var cbFunctor;

    var nbPrimitives = primitives.length;
    for (var i = 0; i < nbPrimitives; i++) {
        var primitive = primitives[i];
        if (primitive instanceof __WEBPACK_IMPORTED_MODULE_1_osg_DrawElements__["a" /* default */]) {
            cbFunctor = functorDrawElements[primitive.getMode()];
            if (cbFunctor) {
                var indexes = primitive.indices.getElements();
                cbFunctor(
                    primitive.getFirst() / indexes.BYTES_PER_ELEMENT,
                    primitive.getCount(),
                    indexes,
                    cb
                );
            }
        } else if (primitive instanceof __WEBPACK_IMPORTED_MODULE_2_osg_DrawArrays__["a" /* default */]) {
            cbFunctor = functorDrawArrays[primitive.getMode()];
            if (cbFunctor) {
                cbFunctor(primitive.getFirst(), primitive.getCount(), cb);
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (primitiveIndexFunctor);


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__ = __webpack_require__(5);





// Define a material attribute
var Material = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._ambient = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.2, 0.2, 0.2, 1.0);
    this._diffuse = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.8, 0.8, 0.8, 1.0);
    this._specular = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 0.0, 1.0);
    this._emission = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 0.0, 1.0);
    this._shininess = 12.5;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Material,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Material',

        cloneType: function() {
            return new Material();
        },

        getParameterName: function(name) {
            return 'u' + this.getType() + '_' + name;
        },

        getOrCreateUniforms: function() {
            var obj = Material;
            if (obj.uniforms) return obj.uniforms;

            obj.uniforms = {
                ambient: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4('uMaterialAmbient'),
                diffuse: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4('uMaterialDiffuse'),
                specular: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4('uMaterialSpecular'),
                emission: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4('uMaterialEmission'),
                shininess: __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat1('uMaterialShininess')
            };

            return obj.uniforms;
        },

        setEmission: function(a) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].copy(this._emission, a);
        },

        getEmission: function() {
            return this._emission;
        },

        setAmbient: function(a) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].copy(this._ambient, a);
        },

        getAmbient: function() {
            return this._ambient;
        },

        setSpecular: function(a) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].copy(this._specular, a);
        },

        getSpecular: function() {
            return this._specular;
        },

        setDiffuse: function(a) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].copy(this._diffuse, a);
        },

        getDiffuse: function() {
            return this._diffuse;
        },

        setShininess: function(a) {
            this._shininess = a;
        },

        getShininess: function() {
            return this._shininess;
        },

        setTransparency: function(a) {
            this._diffuse[3] = 1.0 - a;
        },

        getTransparency: function() {
            return this._diffuse[3];
        },

        apply: function() {
            var uniforms = this.getOrCreateUniforms();

            uniforms.ambient.setFloat4(this._ambient);
            uniforms.diffuse.setFloat4(this._diffuse);
            uniforms.specular.setFloat4(this._specular);
            uniforms.emission.setFloat4(this._emission);
            uniforms.shininess.setFloat(this._shininess);
        }
    }),
    'osg',
    'Material'
);

/* harmony default export */ __webpack_exports__["default"] = (Material);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



var Scissor = function(x, y, w, h) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    this._x = x !== undefined ? x : -1;
    this._y = y !== undefined ? y : -1;
    this._width = w !== undefined ? w : -1;

    this._height = h !== undefined ? h : -1;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    Scissor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Scissor',

        cloneType: function() {
            return new Scissor();
        },

        setScissor: function(x, y, width, height) {
            this._x = x;
            this._y = y;
            this._width = width;
            this._height = height;
        },

        x: function() {
            return this._x;
        },

        y: function() {
            return this._y;
        },

        width: function() {
            return this._width;
        },

        height: function() {
            return this._height;
        },

        apply: function(state) {
            state.applyScissor(this);
        }
    }),
    'osg',
    'Scissor'
);

/* harmony default export */ __webpack_exports__["a"] = (Scissor);


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_AnimationUpdateCallback__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_target__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__ = __webpack_require__(35);







var UpdateMorph = function() {
    __WEBPACK_IMPORTED_MODULE_3_osgAnimation_AnimationUpdateCallback__["a" /* default */].call(this);

    this._targets = []; // float target
    this._targetNames = []; // names of targets
    this._morphs = []; // the update morph can update several morphs

    this._weights = new Float32Array(__WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].MAX_MORPH_GPU);
    // stuffs to handles > max morph gpu targets
    this._indexMap = new Uint32Array(__WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].MAX_MORPH_GPU); // we map VA to the last gpu morphed VA targets
    this._gpuMorphed = []; // size of this._targets, for each target a bool states if it's gpu morphed or not

    this._maxMorphGPU = -1;
};

// for sorting
var funcWeights = function(a, b) {
    return Math.abs(b.value) - Math.abs(a.value);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateMorph,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osgAnimation_AnimationUpdateCallback__["a" /* default */].prototype, {
        init: function(node) {
            this._maxMorphGPU = __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].MAX_MORPH_GPU;
            this._morphs.length = 0;

            //Find the morph geometry & init it
            var children = node.getChildren();
            for (var i = 0, l = children.length; i < l; i++) {
                var geom = children[i];
                var morph;
                if (geom instanceof __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */]) {
                    morph = geom;
                } else if (
                    geom instanceof __WEBPACK_IMPORTED_MODULE_2_osgAnimation_RigGeometry__["a" /* default */] &&
                    geom.getSourceGeometry() instanceof __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */]
                ) {
                    morph = geom.getSourceGeometry();
                }

                if (!morph) continue;

                if (morph.getName() === this.getName()) {
                    if (!morph.isInitialized()) morph.init();

                    this._morphs.push(morph);
                    this._maxMorphGPU = Math.min(
                        this._maxMorphGPU,
                        morph.getMaximumPossibleMorphGPU()
                    );
                }
            }
        },

        isInitialized: function() {
            var morphs = this._morphs;
            var nbMorphs = morphs.length;
            if (!nbMorphs) return false;

            for (var i = 0; i < nbMorphs; ++i) {
                if (!morphs[i].isInitialized()) return false;
            }

            return true;
        },

        getNumTarget: function() {
            return this._targets.length;
        },

        getTarget: function(index) {
            return this._targets[index];
        },

        getTargetName: function(index) {
            return this._targetNames[index];
        },

        addTarget: function(name, index) {
            this._targets[index] = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_target__["a" /* default */].createFloatTarget(0);
            this._targetNames[index] = name;
        },

        _remapBufferArrays: function() {
            // basically, this function remaps all the active morphed VA to the 4th first morphTargets VA
            var indexMap = this._indexMap;
            var morphs = this._morphs;
            for (var i = 0; i < this._maxMorphGPU; ++i) {
                var index = indexMap[i];
                var strI = '_' + i;
                var strIndex = '_' + index;

                for (var j = 0, nbMorphs = morphs.length; j < nbMorphs; ++j) {
                    var morph = morphs[j];
                    var vAttrs = morph.getVertexAttributeList();
                    var morphNames = morph.getMorphTargetNames();
                    for (var k = 0, nbNames = morphNames.length; k < nbNames; ++k) {
                        var attName = morphNames[k];
                        vAttrs[attName + strI].setBufferArray(
                            vAttrs[attName + strIndex].getInitialBufferArray()
                        );
                    }
                }
            }
        },

        _mergeExtraMorphTarget: function(attrs, attName, extraWeightSum) {
            var i = 0;
            // ignore the gpu morphed
            var gpuMorphed = this._gpuMorphed;
            var vAttr = attrs[attName];
            var vertexLen = vAttr.getElements().length;
            var nbVertex = vertexLen / vAttr.getItemSize();
            var itemSize = vAttr.getItemSize();

            vAttr._cpuMorph =
                vAttr._cpuMorph ||
                new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, new Float32Array(vertexLen), itemSize);
            var morphExtraTargets = vAttr._cpuMorph.getElements();
            for (i = 0; i < vertexLen; ++i) {
                morphExtraTargets[i] = 0.0;
            }

            var targets = this._targets;
            for (var j = 0, nb = targets.length; j < nb; ++j) {
                // ignore gpu morphed targets
                if (gpuMorphed[j] === true) continue;

                var weight = targets[j].value;
                if (Math.abs(weight) <= __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].EFFECTIVE_EPS) continue;

                weight /= extraWeightSum;

                var morphElts = attrs[attName + '_' + j].getInitialBufferArray().getElements();
                for (i = 0; i < nbVertex; ++i) {
                    var k = i * itemSize;
                    morphExtraTargets[k] += weight * morphElts[k];
                    morphExtraTargets[k + 1] += weight * morphElts[k + 1];
                    morphExtraTargets[k + 2] += weight * morphElts[k + 2];
                    // don't morph tangent w component
                }
            }

            // map on last index target
            attrs[attName + '_' + (this._maxMorphGPU - 1)].setBufferArray(vAttr._cpuMorph);
            vAttr._cpuMorph.dirty();
        },

        _computeExtraWeightsSum: function() {
            var gpuMorphed = this._gpuMorphed;
            var sum = 0.0;
            var targets = this._targets;
            for (var i = 0, nb = targets.length; i < nb; ++i) {
                // ignore gpu morphed targets
                if (gpuMorphed[i] === true) continue;

                var weight = targets[i].value;
                if (Math.abs(weight) <= __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].EFFECTIVE_EPS) continue;

                sum += weight;
            }
            // check comment in _morphBufferArrayCPU (avoid near zero value)
            var eps = 1e-5;
            if (Math.abs(sum) > eps) return sum;
            return sum < 0.0 ? -eps : eps;
        },

        _morphBufferArrayCPU: function() {
            // the idea is... we have :
            // v' = v * (1-w1-w2-w3) + t1*w1 + t2*w2 + t3*w3
            // we want
            // v' = v * (1-w1-w4) + t1*w1 + t4*w4
            // so basically we have to compute
            // w4 = w2+w3 // (check if ~0 !)
            // t4 = (t2*w2+t3*w3)/w4
            // (w4 is extraWeightSum and t4 will be computed in _mergeExtraMorphTarget)

            // compute new weights for the 4th target (all the extra target will be merged inside this one)
            var extraWeightSum = (this._weights[
                this._maxMorphGPU - 1
            ] = this._computeExtraWeightsSum());

            var processed = {}; // handles referenced buffer array (avoid useless double morph computation the same buffer)
            var morphs = this._morphs;
            for (var i = 0, nbMorphs = morphs.length; i < nbMorphs; ++i) {
                var morph = morphs[i];
                var vAttrs = morph.getVertexAttributeList();
                var morphNames = morph.getMorphTargetNames();

                for (var j = 0, nbNames = morphNames.length; j < nbNames; ++j) {
                    var name = morphNames[j];
                    var attr = vAttrs[name];
                    // skip if the bufferArray is shared in another morphGeometry and has already been cpu morphed
                    if (!attr || processed[attr.getInstanceID()]) continue;
                    processed[attr.getInstanceID()] = true;

                    this._mergeExtraMorphTarget(vAttrs, name, extraWeightSum);
                }
            }
        },

        updateWeights: function() {
            if (this._maxMorphGPU === 0) return;

            var i = 0;
            var targets = this._targets;
            var nbTargets = targets.length;
            // reset weights
            var weights = this._weights;
            weights[0] = weights[1] = weights[2] = weights[3] = 0.0;

            // no need to swap VA or to use CPU morph
            if (nbTargets <= this._maxMorphGPU) {
                for (i = 0; i < nbTargets; ++i) {
                    weights[i] = targets[i].value;
                }
                return;
            }

            // reset indexMap
            var indexMap = this._indexMap;
            indexMap[0] = indexMap[1] = indexMap[2] = indexMap[3] = 0;

            // reset gpu morphed array
            var gpuMorphed = this._gpuMorphed;
            gpuMorphed.length = nbTargets;
            for (i = 0; i < nbTargets; ++i) gpuMorphed[i] = false;

            var sortedTargets = targets.slice(0).sort(funcWeights);

            for (i = 0; i < this._maxMorphGPU; ++i) {
                var ti = targets.indexOf(sortedTargets[i]);
                gpuMorphed[ti] = true;
                indexMap[i] = ti;
                weights[i] = sortedTargets[i].value;
            }

            // check more than 4 targets, we compute all the extra targets influence and merge in the last 4th morphs targets
            var extraEpsilon = Math.abs(sortedTargets[this._maxMorphGPU].value);
            var extraMorphCPU = extraEpsilon > __WEBPACK_IMPORTED_MODULE_5_osgAnimation_MorphGeometry__["a" /* default */].EFFECTIVE_EPS;
            gpuMorphed[indexMap[this._maxMorphGPU - 1]] = !extraMorphCPU;

            this._remapBufferArrays();
            if (extraMorphCPU) {
                this._morphBufferArrayCPU();
            }
        },

        update: function(node /*, nv*/) {
            if (!this.isInitialized()) this.init(node);

            this.updateWeights();

            var weights = this._weights;
            var nbTargets = Math.min(this._maxMorphGPU, this._targets.length);
            var morphs = this._morphs;
            for (var i = 0, nbMorphs = morphs.length; i < nbMorphs; ++i) {
                var array = morphs[i].getTargetsWeight();
                for (var j = 0; j < nbTargets; j++) {
                    array[j] = weights[j];
                }
            }

            return true;
        }
    }),
    'osgAnimation',
    'UpdateMorph'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateMorph);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__ = __webpack_require__(34);






var StackedScale = function(name, scale) {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._target = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__["a" /* default */].createVec3Target(scale || __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].ONE);
    if (name) this.setName(name);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StackedScale,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        init: function(scale) {
            this.setScale(scale);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._target.defaultValue, scale);
        },

        setScale: function(scale) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._target.value, scale);
        },

        getTarget: function() {
            return this._target;
        },

        resetToDefaultValue: function() {
            this.setScale(this._target.defaultValue);
        },

        // must be optimized
        applyToMatrix: function(m) {
            var scale = this._target.value;
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].scale(m, m, scale);
        }
    }),
    'osgAnimation',
    'StackedScale'
);

/* harmony default export */ __webpack_exports__["a"] = (StackedScale);


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgNameSpace__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgDB_requestFile__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgDB_options__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgDB_zlib__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Image__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_DrawArrayLengths__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_primitiveSet__ = __webpack_require__(8);














var rejectObject = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].rejectObject;

var Input = function(json, identifier) {
    this._json = json;
    var map = identifier;
    if (map === undefined) {
        map = {};
    }
    this._identifierMap = map;
    this._objectRegistry = {};

    this._cacheReadObject = {}; //wrappers

    // this._progressXHRCallback = undefined;
    // this._prefixURL = '';
    // this.setImageLoadingOptions( {
    //     promise: true,
    //     onload: undefined
    // } );

    this.setOptions(__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix({}, __WEBPACK_IMPORTED_MODULE_4_osgDB_options__["a" /* default */]));

    // {
    //     prefixURL: '',
    //     progressXHRCallback: undefined,
    //     readImageURL: undefined,
    //     imageLoadingUsePromise: undefined,
    //     imageOnload: undefined,
    // };
};

// keep one instance of image fallback
if (!Input.imageFallback) {
    Input.imageFallback = (function() {
        var fallback = new window.Image();
        fallback.src =
            'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQIW2P8DwQACgAD/il4QJ8AAAAASUVORK5CYII=';
        return fallback;
    })();
}

Input.prototype = {
    clone: function() {
        var input = new Input();
        input._objectRegistry = this._objectRegistry;
        input._cacheReadObject = this._cacheReadObject;
        return input;
    },

    setOptions: function(options) {
        this._defaultOptions = options;
    },
    getOptions: function() {
        return this._defaultOptions;
    },
    setProgressXHRCallback: function(func) {
        this._defaultOptions.progressXHRCallback = func;
    },
    setReadNodeURLCallback: function(func) {
        this._defaultOptions.readNodeURL = func;
    },
    // used to override the type from pathname
    // typically if you want to create proxy object
    registerObject: function(fullyQualifiedObjectname, constructor) {
        this._objectRegistry[fullyQualifiedObjectname] = constructor;
    },

    getJSON: function() {
        return this._json;
    },

    setJSON: function(json) {
        this._json = json;
        return this;
    },

    setPrefixURL: function(prefix) {
        this._defaultOptions.prefixURL = prefix;
    },

    getPrefixURL: function() {
        return this._defaultOptions.prefixURL;
    },

    setDatabasePath: function(path) {
        this._defaultOptions.databasePath = path;
    },

    getDatabasePath: function() {
        return this._defaultOptions.databasePath;
    },

    computeURL: function(url) {
        if (
            typeof this._defaultOptions.prefixURL === 'string' &&
            this._defaultOptions.prefixURL.length > 0
        ) {
            return this._defaultOptions.prefixURL + url;
        }

        return url;
    },

    requestFile: function(url, options) {
        return Object(__WEBPACK_IMPORTED_MODULE_3_osgDB_requestFile__["a" /* default */])(url, options);
    },

    getObjectWrapper: function(path) {
        if (this._objectRegistry[path]) {
            return new this._objectRegistry[path]();
        }

        var scope = __WEBPACK_IMPORTED_MODULE_2_osgNameSpace__["a" /* default */];
        var splittedPath = path.split('.');
        for (var i = 0, l = splittedPath.length; i < l; i++) {
            var obj = scope[splittedPath[i]];
            if (obj === undefined) {
                return undefined;
            }
            scope = obj;
        }
        this._objectRegistry[path] = scope;
        // create the new obj
        return new scope();
    },

    fetchImage: function(image, url, options) {
        var checkInlineImage = 'data:image/';
        // crossOrigin does not work for inline data image
        var isInlineImage = url.substring(0, checkInlineImage.length) === checkInlineImage;
        var img = new window.Image();
        if (!isInlineImage && options.imageCrossOrigin) {
            img.crossOrigin = options.imageCrossOrigin;
        }
        image.setURL(url);
        image.setImage(img);
        img.src = url;

        return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function(resolve) {
            img.onerror = function() {
                __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].warn('warning use white texture as fallback instead of ' + url);
                image.setImage(Input.imageFallback);
                resolve(image);
            };

            img.onload = function() {
                if (options.imageOnload) options.imageOnload.call(image);
                resolve(image);
            };
        });
    },

    readImageURL: function(url, options) {
        if (options === undefined) {
            options = this._defaultOptions;
        }

        // hook reader
        if (options.readImageURL) {
            // be carefull if you plan to call hook the call and after
            // call the original readImageURL, you will need to remove
            // from options the readImageURL if you dont want an infinte
            // recursion call
            return options.readImageURL.call(this, url, options);
        }

        // if image is on inline image skip url computation
        if (url.substr(0, 10) !== 'data:image') {
            url = this.computeURL(url);
        }

        var image = new __WEBPACK_IMPORTED_MODULE_7_osg_Image__["a" /* default */]();
        return this.fetchImage(image, url, options);
    },

    readNodeURL: function(url, opt) {
        var options = opt;
        if (options === undefined) {
            options = this._defaultOptions;
        }

        // hook reader
        if (options.readNodeURL) {
            // be carefull if you plan to call hook the call and after
            // call the original readNodeURL, you will need to remove
            // from options the readNodeURL if you dont want an infinte
            // recursion call
            return options.readNodeURL.call(this, url, options);
        }

        url = this.computeURL(url);
        var that = this;
        // copy because we are going to modify it to have relative prefix to load assets
        options = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix({}, options);

        // automatic prefix if non specfied
        if (!options.prefixURL) {
            var prefix = that.getPrefixURL();
            var index = url.lastIndexOf('/');
            if (index !== -1) {
                prefix = url.substring(0, index + 1);
            }
            options.prefixURL = prefix;
        }

        var ReaderParser = __webpack_require__(37).default;

        var readSceneGraph = function(data) {
            return ReaderParser.parseSceneGraph(data, options).then(function(child) {
                __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].log('loaded ' + url);
                return child;
            });
        };

        var ungzipFile = function(arrayBuffer) {
            function pad(n) {
                return n.length < 2 ? '0' + n : n;
            }

            function uintToString(uintArray) {
                var str = '';
                for (var i = 0, len = uintArray.length; i < len; ++i) {
                    str += '%' + pad(uintArray[i].toString(16));
                }
                str = decodeURIComponent(str);
                return str;
            }

            var unpacked = arrayBuffer;
            if (__WEBPACK_IMPORTED_MODULE_5_osgDB_zlib__["a" /* default */].isGunzipBuffer(arrayBuffer)) {
                unpacked = __WEBPACK_IMPORTED_MODULE_5_osgDB_zlib__["a" /* default */].gunzip(arrayBuffer);
            }

            var typedArray = new Uint8Array(unpacked);
            var str = uintToString(typedArray);
            return str;
        };

        __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].time('osgjs.metric:Input.readNodeURL', __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].INFO);
        // try to get the file as responseText to parse JSON
        var fileTextPromise = that.requestFile(url);
        return fileTextPromise
            .then(function(str) {
                var data;
                try {
                    data = JSON.parse(str);
                } catch (error) {
                    // can't parse try with ungzip code path

                    __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].error('cant parse url ' + url + ' try to gunzip');
                }
                // we have the json, read it
                if (data) return readSceneGraph(data);

                // no data try with gunzip
                var fileGzipPromise = that.requestFile(url, {
                    responseType: 'arraybuffer'
                });
                return fileGzipPromise
                    .then(function(file) {
                        var strUnzip = ungzipFile(file);
                        data = JSON.parse(strUnzip);
                        return readSceneGraph(data);
                    })
                    .catch(function(status) {
                        var err = 'cant read file ' + url + ' status ' + status;
                        __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].error(err);
                        return err;
                    });
            })
            .catch(function(status) {
                var err = 'cant get file ' + url + ' status ' + status;
                __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].error(err);
                return err;
            })
            .finally(function() {
                // Stop the timer
                __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].timeEnd('osgjs.metric:Input.readNodeURL');
            });
    },

    _unzipTypedArray: function(binary) {
        var typedArray = new Uint8Array(binary);

        // check magic number 1f8b
        if (typedArray[0] === 0x1f && typedArray[1] === 0x8b) {
            var _zlib = __webpack_require__(133);

            if (!_zlib) {
                __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].error(
                    'osg failed to use a gunzip.min.js to uncompress a gz file.\n You can add this vendors to enable this feature or adds the good header in your gzip file served by your server'
                );
            }

            var zdec = new _zlib.Gunzip(typedArray);
            var result = zdec.decompress();
            return result.buffer;
        }

        return binary;
    },

    readBinaryArrayURL: function(url, options) {
        if (options === undefined) {
            options = this._defaultOptions;
        }

        if (options.readBinaryArrayURL) {
            return options.readBinaryArrayURL.call(this, url, options);
        }

        url = this.computeURL(url);

        if (this._identifierMap[url] !== undefined) {
            return this._identifierMap[url];
        }

        var filePromise = this.requestFile(url, {
            responseType: 'arraybuffer',
            progress: this._defaultOptions.progressXHRCallback
        });

        var that = this;
        this._identifierMap[url] = filePromise.then(function(file) {
            return that._unzipTypedArray(file);
        });

        return this._identifierMap[url];
    },

    initializeBufferArray: function(vb, type, buf, options) {
        if (options === undefined) options = this.getOptions();

        if (options.initializeBufferArray) {
            return options.initializeBufferArray.call(this, vb, type, buf);
        }

        var url = vb.File;

        return this.readBinaryArrayURL(url).then(function(array) {
            var typedArray;
            // manage endianness
            var bigEndian;
            (function() {
                var a = new Uint8Array([0x12, 0x34]);
                var b = new Uint16Array(a.buffer);
                bigEndian = b[0].toString(16) === '1234';
            })();

            var offset = 0;
            if (vb.Offset !== undefined) {
                offset = vb.Offset;
            }

            var bytesPerElement = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */][type].BYTES_PER_ELEMENT;
            var nbItems = vb.Size;
            var nbCoords = buf.getItemSize();
            var totalSizeInBytes = nbItems * bytesPerElement * nbCoords;

            if (bigEndian) {
                __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].log('big endian detected');
                var TypedArray = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */][type];
                var tmpArray = new TypedArray(nbItems * nbCoords);
                var data = new DataView(array, offset, totalSizeInBytes);
                var i = 0,
                    l = tmpArray.length;
                if (type === 'Uint16Array') {
                    for (; i < l; i++) {
                        tmpArray[i] = data.getUint16(i * bytesPerElement, true);
                    }
                } else if (type === 'Float32Array') {
                    for (; i < l; i++) {
                        tmpArray[i] = data.getFloat32(i * bytesPerElement, true);
                    }
                }
                typedArray = tmpArray;
                data = null;
            } else {
                typedArray = new __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */][type](array, offset, nbCoords * nbItems);
            }

            buf.setElements(typedArray);
            return buf;
        });
    },

    readBufferArray: function(options) {
        var jsonObj = this.getJSON();

        var uniqueID = jsonObj.UniqueID;
        var osgjsObject;
        if (uniqueID !== undefined) {
            osgjsObject = this._identifierMap[uniqueID];
            if (osgjsObject !== undefined) {
                return osgjsObject;
            }
        }

        if (options === undefined) options = this.getOptions();
        if (options.readBufferArray) return options.readBufferArray.call(this);

        if ((!jsonObj.Elements && !jsonObj.Array) || !jsonObj.ItemSize || !jsonObj.Type) {
            return rejectObject('BufferArray', jsonObj);
        }

        var promise;

        // inline array
        if (jsonObj.Elements) {
            promise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(
                new __WEBPACK_IMPORTED_MODULE_8_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8_osg_BufferArray__["a" /* default */][jsonObj.Type], jsonObj.Elements, jsonObj.ItemSize)
            );
        } else if (jsonObj.Array) {
            var buf = new __WEBPACK_IMPORTED_MODULE_8_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8_osg_BufferArray__["a" /* default */][jsonObj.Type]);
            buf.setItemSize(jsonObj.ItemSize);

            var vb, type;
            if (jsonObj.Array.Float32Array) {
                vb = jsonObj.Array.Float32Array;
                type = 'Float32Array';
            } else if (jsonObj.Array.Uint16Array) {
                vb = jsonObj.Array.Uint16Array;
                type = 'Uint16Array';
            } else if (jsonObj.Array.Uint8Array) {
                vb = jsonObj.Array.Uint8Array;
                type = 'Uint8Array';
            }

            if (vb === undefined) {
                return rejectObject('Typed Array ' + window.Object.keys(jsonObj.Array)[0]);
            }

            if (vb.File) {
                promise = this.initializeBufferArray(vb, type, buf);
            } else if (vb.Elements) {
                buf.setElements(new __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */][type](vb.Elements));
                promise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(buf);
            }
        }

        if (uniqueID !== undefined) {
            this._identifierMap[uniqueID] = promise;
        }
        return promise;
    },

    readUserDataContainer: function() {
        var jsonObj = this.getJSON();
        var osgjsObject;
        var uniqueID = jsonObj.UniqueID;
        if (uniqueID !== undefined) {
            osgjsObject = this._identifierMap[uniqueID];
            if (osgjsObject !== undefined) {
                return osgjsObject.Values;
            }
        }

        this._identifierMap[uniqueID] = jsonObj;
        return jsonObj.Values;
    },

    readPrimitiveSet: function() {
        var jsonObj = this.getJSON();
        var uniqueID;
        var osgjsObject;

        var promise;
        var obj, mode, first, count;
        var drawElements =
            jsonObj.DrawElementUShort ||
            jsonObj.DrawElementUByte ||
            jsonObj.DrawElementUInt ||
            jsonObj.DrawElementsUShort ||
            jsonObj.DrawElementsUByte ||
            jsonObj.DrawElementsUInt;
        var drawArray = jsonObj.DrawArray || jsonObj.DrawArrays;
        var drawArrayLengths = jsonObj.DrawArrayLengths;

        if (drawElements) {
            uniqueID = drawElements.UniqueID;
            if (uniqueID !== undefined) {
                osgjsObject = this._identifierMap[uniqueID];
                if (osgjsObject !== undefined) {
                    return osgjsObject;
                }
            }

            mode = drawElements.Mode ? __WEBPACK_IMPORTED_MODULE_12_osg_primitiveSet__["a" /* default */][drawElements.Mode] : __WEBPACK_IMPORTED_MODULE_12_osg_primitiveSet__["a" /* default */].TRIANGLES;
            obj = new __WEBPACK_IMPORTED_MODULE_11_osg_DrawElements__["a" /* default */](mode);

            this.setJSON(drawElements.Indices);
            promise = this.readBufferArray().then(function(array) {
                obj.setIndices(array);
                return obj;
            });
            this.setJSON(jsonObj);
        } else if (drawArray) {
            uniqueID = drawArray.UniqueID;
            if (uniqueID !== undefined) {
                osgjsObject = this._identifierMap[uniqueID];
                if (osgjsObject !== undefined) {
                    return osgjsObject;
                }
            }

            mode = drawArray.Mode || drawArray.mode;
            first = drawArray.First !== undefined ? drawArray.First : drawArray.first;
            count = drawArray.Count !== undefined ? drawArray.Count : drawArray.count;
            obj = new __WEBPACK_IMPORTED_MODULE_9_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_12_osg_primitiveSet__["a" /* default */][mode], first, count);
            promise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(obj);
        } else if (drawArrayLengths) {
            uniqueID = drawArrayLengths.UniqueID;
            if (uniqueID !== undefined) {
                osgjsObject = this._identifierMap[uniqueID];
                if (osgjsObject !== undefined) {
                    return osgjsObject;
                }
            }

            mode = drawArrayLengths.Mode;
            first = drawArrayLengths.First;
            var array = drawArrayLengths.ArrayLengths;
            obj = new __WEBPACK_IMPORTED_MODULE_10_osg_DrawArrayLengths__["a" /* default */](__WEBPACK_IMPORTED_MODULE_12_osg_primitiveSet__["a" /* default */][mode], first, array);
            promise = __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(obj);
        } else {
            promise = rejectObject('PrimitiveSet', jsonObj);
        }

        if (uniqueID !== undefined) {
            this._identifierMap[uniqueID] = promise;
        }

        return promise;
    },

    readObject: function() {
        var jsonObj = this.getJSON();
        var objKeys = window.Object.keys(jsonObj);
        var prop = objKeys[0];
        if (!prop) {
            return rejectObject("can't find property for object " + objKeys);
        }

        var uniqueID = jsonObj[prop].UniqueID;
        var osgjsObject;
        if (uniqueID !== undefined) {
            osgjsObject = this._identifierMap[uniqueID];
            if (osgjsObject !== undefined) {
                return osgjsObject;
            }
        }

        var obj = this.getObjectWrapper(prop);

        if (!obj) {
            return rejectObject("can't instanciate object " + prop);
        }

        var ReaderParser = __webpack_require__(37).default;
        var scope = ReaderParser.ObjectWrapper.serializers;

        if (this._cacheReadObject[prop]) {
            scope = this._cacheReadObject[prop];
        } else {
            var splittedPath = prop.split('.');
            for (var i = 0, l = splittedPath.length; i < l; i++) {
                var sub = splittedPath[i];
                var reader = scope[sub];
                if (!reader) {
                    return rejectObject('Unknown scope ' + prop + '(' + sub + ')');
                }
                scope = reader;
            }
            this._cacheReadObject[prop] = scope;
        }

        var promise = scope(this.setJSON(jsonObj[prop]), obj);

        if (uniqueID !== undefined) {
            this._identifierMap[uniqueID] = promise;
            obj._uniqueID = uniqueID;
        }

        return promise;
    }
};

/* harmony default export */ __webpack_exports__["default"] = (Input);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgDB_readerParser__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgDB_Registry__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgDB_requestFile_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_notify__ = __webpack_require__(2);







// Drag'n Drop file helper
// it also holds a list of basic types per extension to do requests.
var FileHelper = {
    readFileList: function(fileList) {
        var fileName;
        var filesMap = new window.Map();
        var promiseArray = [];
        var i;

        for (i = 0; i < fileList.length; ++i) {
            var ext = fileList[i].name.substr(fileList[i].name.lastIndexOf('.') + 1);
            var readerWriter = __WEBPACK_IMPORTED_MODULE_2_osgDB_Registry__["a" /* default */].instance().getReaderWriterForExtension(ext);
            // We need a hack for osgjs til it is converted to a readerwriter
            if (readerWriter !== undefined || ext === 'osgjs') {
                // So this is the main file to read
                fileName = fileList[i].name;
            }

            var type = FileHelper.getTypeForExtension(ext);
            promiseArray.push(
                Object(__WEBPACK_IMPORTED_MODULE_3_osgDB_requestFile_js__["a" /* default */])(fileList[i], {
                    responseType: type
                })
            );
        }

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promiseArray).then(function(files) {
            for (i = 0; i < files.length; ++i) {
                filesMap.set(fileList[i].name, files[i]);
            }

            return __WEBPACK_IMPORTED_MODULE_1_osgDB_readerParser__["default"].readNodeURL(fileName, {
                filesMap: filesMap
            });
        });
    },

    // Adds basic types
    init: function() {
        FileHelper._typesMap = new window.Map();
        // Binary
        FileHelper._typesMap.set('bin', 'arraybuffer');
        FileHelper._typesMap.set('b3dm', 'arraybuffer');
        FileHelper._typesMap.set('glb', 'arraybuffer');
        FileHelper._typesMap.set('zip', 'arraybuffer');
        // Image
        FileHelper._typesMap.set('png', 'blob');
        FileHelper._typesMap.set('jpg', 'blob');
        FileHelper._typesMap.set('jpeg', 'blob');
        FileHelper._typesMap.set('gif', 'blob');
        // Text
        FileHelper._typesMap.set('json', 'string');
        FileHelper._typesMap.set('gltf', 'string');
        FileHelper._typesMap.set('osgjs', 'string');
    },

    // To add user defined types
    addTypeForExtension: function(type, extension) {
        if (!FileHelper._typesMap) FileHelper.init();
        if (FileHelper._typesMap.get(extension) !== undefined) {
            __WEBPACK_IMPORTED_MODULE_4_osg_notify__["a" /* default */].warn("the '" + extension + "' already has a type");
        }
        FileHelper._typesMap.set(extension, type);
    },

    getTypeForExtension: function(extension) {
        if (!FileHelper._typesMap) {
            FileHelper.init();
        }
        return this._typesMap.get(extension);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (FileHelper);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
const KEYBOARD_EVENTS = {
    SPACE: ' ',
    D_KEY: 'd',
    S_KEY: 's',
    A_KEY: 'a',
    W_KEY: 'w',
    Z_KEY: 'z',
    Q_KEY: 'q',
    ARROW_DOWN: 'ArrowDown',
    ARROW_UP: 'ArrowUp',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight'
};


class KeyboardEventsController {
    isUpEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.ARROW_UP ||
            keyEvent.toLowerCase() === KEYBOARD_EVENTS.W_KEY ||
            keyEvent.toLowerCase() === KEYBOARD_EVENTS.Z_KEY;
    }

    isDownEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.ARROW_DOWN ||
        keyEvent === KEYBOARD_EVENTS.S_KEY;
    }

    isLeftEvent(keyEvent) {
        return keyEvent.toLowerCase() === KEYBOARD_EVENTS.A_KEY ||
            keyEvent.toLowerCase() === KEYBOARD_EVENTS.Q_KEY ||
            keyEvent === KEYBOARD_EVENTS.ARROW_LEFT;
    }

    isRightEvent(keyEvent) {
        return keyEvent.toLowerCase() === KEYBOARD_EVENTS.D_KEY ||
            keyEvent === KEYBOARD_EVENTS.ARROW_RIGHT;
    }

    isRotateEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.A_KEY;
    }

    isPanEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.D_KEY;
    }

    isZoomEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.S_KEY;
    }

    isSpaceEvent(keyEvent) {
        return keyEvent === KEYBOARD_EVENTS.SPACE;
    }
}
/* harmony export (immutable) */ __webpack_exports__["a"] = KeyboardEventsController;



/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgGA_Manipulator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulatorDeviceOrientationController__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgGA_OrbitManipulatorGamePadController__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgGA_OrbitManipulatorHammerController__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgGA_OrbitManipulatorStandardMouseKeyboardController__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgGA_OrbitManipulatorWebVRController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgUtil_DelayInterpolator__ = __webpack_require__(70);











/**
 *  OrbitManipulator
 *  @class
 */
var OrbitManipulator = function(boundStrategy) {
    __WEBPACK_IMPORTED_MODULE_2_osgGA_Manipulator__["a" /* default */].call(this, boundStrategy);
    this._homePosition = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._frustum = {};
    this.init();
};

OrbitManipulator.AvailableControllerList = [
    'StandardMouseKeyboard',
    'GamePad',
    'Hammer',
    'DeviceOrientation',
    'WebVR'
];

OrbitManipulator.ControllerList = [
    'StandardMouseKeyboard',
    'GamePad',
    'Hammer',
    'DeviceOrientation',
    'WebVR'
];

var TWO_PI = 2 * Math.PI;
var lowerOrEqual = function(val, limit) {
    return val < limit + 0.00001;
};

/** @lends OrbitManipulator.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulator,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgGA_Manipulator__["a" /* default */].prototype, {
        init: function() {
            this._distance = 25.0;
            this._target = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            this._upz = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].init(this._target);

            var rot1 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].fromRotation(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create(), -Math.PI, this._upz);
            var rot2 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].fromRotation(
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create(),
                Math.PI / 10.0,
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0)
            );
            this._rotation = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].mul(this._rotation, rot1, rot2);
            this._time = 0.0;

            this._vrMatrix = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();

            this._rotate = new __WEBPACK_IMPORTED_MODULE_8_osgUtil_DelayInterpolator__["a" /* default */](2);
            this._pan = new __WEBPACK_IMPORTED_MODULE_8_osgUtil_DelayInterpolator__["a" /* default */](2);
            this._zoom = new __WEBPACK_IMPORTED_MODULE_8_osgUtil_DelayInterpolator__["a" /* default */](1);

            this._minSpeed = 1e-4; // set a limit to pan/zoom speed
            this._scaleMouseMotion = 1.0;

            this._inverseMatrix = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();

            // distance at which we start pushing the target (so that we can still zoom)
            // with a very low _limitZoomIn, it's like a fps manipulator as long as you don't unzoom
            this._autoPushTarget = true;

            // pitch range [-PI/2, PI/2]
            this._limitPitchUp = Math.PI * 0.5 * 0.9;
            this._limitPitchDown = -this._limitPitchUp;

            // yaw range [-PI, PI]
            this._limitYawLeft = -Math.PI;
            this._limitYawRight = -this._limitYawLeft;

            this._limitZoomIn = 1e-4;
            this._limitZoomOut = Infinity;

            // instance of controller
            var self = this;

            OrbitManipulator.ControllerList.forEach(function(value) {
                if (OrbitManipulator[value] !== undefined) {
                    if (self._controllerList[value]) {
                        self._controllerList[value].init();
                    } else {
                        self._controllerList[value] = new OrbitManipulator[value](self);
                    }
                }
            });
        },
        setLimitPitchUp: function(up) {
            this._limitPitchUp = up;
        },
        setLimitPitchDown: function(down) {
            this._limitPitchDown = down;
        },
        setLimitYawLeft: function(left) {
            this._limitYawLeft = left;
        },
        setLimitYawRight: function(right) {
            this._limitYawRight = right;
        },
        setLimitZoomOut: function(zoomOut) {
            this._limitZoomOut = zoomOut;
        },
        setLimitZoomIn: function(zoomIn) {
            this._limitZoomIn = zoomIn;
        },
        setDelay: function(dt) {
            this._rotate.setDelay(dt);
            this._pan.setDelay(dt);
            this._zoom.setDelay(dt);
        },
        reset: function() {
            this.init();
        },
        setTarget: function(target) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._target, target);
            var eyePos = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            this.getEyePosition(eyePos);
            this._distance = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].distance(target, eyePos);
        },
        setEyePosition: (function() {
            var f = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var s = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var u = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(eye) {
                var result = this._rotation;
                var center = this._target;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(f, eye, center);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(f, f);

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(s, f, this._upz);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(s, s);

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(u, s, f);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(u, u);

                // s[0], f[0], u[0], 0.0,
                // s[1], f[1], u[1], 0.0,
                // s[2], f[2], u[2], 0.0,
                // 0,    0,    0,     1.0
                result[0] = s[0];
                result[1] = f[0];
                result[2] = u[0];
                result[3] = 0.0;
                result[4] = s[1];
                result[5] = f[1];
                result[6] = u[1];
                result[7] = 0.0;
                result[8] = s[2];
                result[9] = f[2];
                result[10] = u[2];
                result[11] = 0.0;
                result[12] = 0;
                result[13] = 0;
                result[14] = 0;
                result[15] = 1.0;

                this._distance = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].distance(center, eye);
            };
        })(),

        computeHomePosition: function(boundStrategy) {
            var bs = this.getHomeBoundingSphere(boundStrategy);
            if (!bs || !bs.valid()) return;

            this.setDistance(this.getHomeDistance(bs));
            this.setTarget(bs.center());
        },

        getHomePosition: function() {
            if (this._node !== undefined) {
                var target = this._target;
                var distance = this.getDistance();

                this.computeEyePosition(target, distance, this._homePosition);
            }
            return this._homePosition;
        },

        setMinSpeed: function(s) {
            this._minSpeed = s;
        },
        getMinSpeed: function() {
            return this._minSpeed;
        },

        setDistance: function(d) {
            this._distance = d;
        },
        getDistance: function() {
            return this._distance;
        },

        getSpeedFactor: function() {
            return Math.max(this._distance, this._minSpeed);
        },
        computePan: (function() {
            var inv = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
            var x = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var y = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(dx, dy) {
                var proj = this._camera.getProjectionMatrix();
                // modulate panning speed with verticalFov value
                // if it's an orthographic we don't change the panning speed
                // TODO : manipulators in osgjs don't support well true orthographic camera anyway because they
                // manage the view matrix (and you need to edit the projection matrix to 'zoom' for true ortho camera)
                var vFov = proj[15] === 1 ? 1.0 : 2.0 / proj[5];
                var speed = this.getSpeedFactor() * vFov;
                dy *= speed;
                dx *= speed;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(inv, this._rotation);
                x[0] = inv[0];
                x[1] = inv[1];
                x[2] = inv[2];
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(x, x);

                y[0] = inv[8];
                y[1] = inv[9];
                y[2] = inv[10];
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(y, y);

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(x, x, -dx);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(y, y, dy);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(this._target, this._target, x);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(this._target, this._target, y);
            };
        })(),
        computeRotation: (function() {
            var rightDir = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0);

            return function(dx, dy) {
                var prevPitch = Math.atan(-this._rotation[6] / this._rotation[5]);
                var pitch = this._computePitch(prevPitch, dy);

                var deltaYaw = dx / 10.0;
                var previousYaw = Math.atan2(this._rotation[4], this._rotation[0]);
                var yaw = this._computeYaw(previousYaw, deltaYaw);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].fromRotation(this._rotation, -pitch, rightDir);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].rotate(this._rotation, this._rotation, -yaw, this._upz);
            };
        })(),

        _computePitch: function(prevPitch, dy) {
            var pitch = prevPitch + dy / 10.0;
            return Math.min(Math.max(pitch, this._limitPitchDown), this._limitPitchUp);
        },

        _computeYaw: function(previousYaw, deltaYaw) {
            var yaw = previousYaw + deltaYaw;
            var left = this._limitYawLeft;
            var right = this._limitYawRight;

            if (right !== Math.PI || left !== -Math.PI) {
                if (right < left) {
                    if (yaw > Math.PI) {
                        previousYaw -= TWO_PI;
                        yaw -= TWO_PI;
                    }
                    if (yaw < -Math.PI) {
                        previousYaw += TWO_PI;
                        yaw += TWO_PI;
                    }
                }

                if (deltaYaw === 0) {
                    var isOutsideLimit = false;
                    if (left > right) isOutsideLimit = yaw < left && yaw > right;
                    else isOutsideLimit = yaw < left || yaw > right;
                    if (isOutsideLimit)
                        yaw = Math.abs(yaw - left) > Math.abs(yaw - right) ? right : left;
                }

                if (deltaYaw > 0.0 && lowerOrEqual(previousYaw, right) && yaw > right) {
                    yaw = right;
                } else if (deltaYaw < 0.0 && lowerOrEqual(left, previousYaw) && yaw < left) {
                    yaw = left;
                }
            }
            return yaw;
        },

        computeZoom: function(dz) {
            this.zoom(dz);
        },

        setAutoPushTarget: function(bool) {
            this._autoPushTarget = bool;
        },

        zoom: (function() {
            var dir = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(ratio) {
                var newValue = this._distance + this.getSpeedFactor() * (ratio - 1.0);

                if (this._autoPushTarget && newValue < this._limitZoomIn) {
                    // push the target instead of zooming on it
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(dir, this._target, this.getEyePosition(dir));
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(dir, dir);
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(dir, dir, this._limitZoomIn - newValue);
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(this._target, this._target, dir);
                }

                this._distance = Math.max(
                    this._limitZoomIn,
                    Math.min(this._limitZoomOut, newValue)
                );
            };
        })(),

        getRotateInterpolator: function() {
            return this._rotate;
        },
        getPanInterpolator: function() {
            return this._pan;
        },
        getZoomInterpolator: function() {
            return this._zoom;
        },
        getTarget: function(target) {
            return __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(target, this._target);
        },
        getEyePosition: function(eye) {
            this.computeEyePosition(this._target, this._distance, eye);
            return eye;
        },

        computeEyePosition: (function() {
            var tmpDist = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var tmpInverse = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();
            return function(target, distance, eye) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(tmpInverse, this._rotation);
                tmpDist[1] = distance;
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, tmpDist, tmpInverse);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(eye, target, eye);
            };
        })(),

        update: (function() {
            var eye = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(nv) {
                var dt = nv.getFrameStamp().getDeltaTime();

                var delta;
                var mouseFactor = 0.1;
                delta = this._rotate.update(dt);
                this.computeRotation(
                    -delta[0] * mouseFactor * this._scaleMouseMotion,
                    -delta[1] * mouseFactor * this._scaleMouseMotion
                );

                var panFactor = 0.002;
                delta = this._pan.update(dt);
                this.computePan(-delta[0] * panFactor, -delta[1] * panFactor);

                delta = this._zoom.update(dt);
                this.computeZoom(1.0 + delta[0] / 10.0);

                var target = this._target;
                var distance = this._distance;

                /* 1. Works but bypass other manipulators */
                // mat4.copy( this._inverseMatrix , this._vrMatrix );

                /* 2. Works but gets broken by other manipulators */
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(this._inverseMatrix, this._rotation);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].mul(this._inverseMatrix, this._vrMatrix, this._inverseMatrix);

                /* 3. Doesnt' work */
                // mat4.mul( this._vrMatrix,  this._vrMatrix, this._rotation );
                // mat4.invert( this._inverseMatrix, this._vrMatrix );

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].set(eye, 0.0, distance, 0.0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, eye, this._inverseMatrix);

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].lookAt(this._inverseMatrix, __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(eye, target, eye), target, this._upz);
            };
        })(),

        setPoseVR: function(q /*, pos*/) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].fromQuat(this._vrMatrix, q);
            // this._vrMatrix[ 12 ] = pos[ 0 ];
            // this._vrMatrix[ 13 ] = pos[ 1 ];
            // this._vrMatrix[ 14 ] = pos[ 2 ];
        }
    }),
    'osgGA',
    'OrbitManipulator'
);

OrbitManipulator.DeviceOrientation = __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulatorDeviceOrientationController__["a" /* default */];
OrbitManipulator.GamePad = __WEBPACK_IMPORTED_MODULE_4_osgGA_OrbitManipulatorGamePadController__["a" /* default */];
OrbitManipulator.Hammer = __WEBPACK_IMPORTED_MODULE_5_osgGA_OrbitManipulatorHammerController__["a" /* default */];
OrbitManipulator.WebVR = __WEBPACK_IMPORTED_MODULE_7_osgGA_OrbitManipulatorWebVRController__["a" /* default */];
OrbitManipulator.StandardMouseKeyboard = __WEBPACK_IMPORTED_MODULE_6_osgGA_OrbitManipulatorStandardMouseKeyboardController__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulator);


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);





var degtorad = Math.PI / 180.0; // Degree-to-Radian conversion

var makeRotateFromEuler = function(q, x, y, z, order) {
    // http://www.mathworks.com/matlabcentral/fileexchange/
    // 20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
    // content/SpinCalc.m

    var c1 = Math.cos(x / 2);
    var c2 = Math.cos(y / 2);
    var c3 = Math.cos(z / 2);
    var s1 = Math.sin(x / 2);
    var s2 = Math.sin(y / 2);
    var s3 = Math.sin(z / 2);

    if (order === 'XYZ') {
        q[0] = s1 * c2 * c3 + c1 * s2 * s3;
        q[1] = c1 * s2 * c3 - s1 * c2 * s3;
        q[2] = c1 * c2 * s3 + s1 * s2 * c3;
        q[3] = c1 * c2 * c3 - s1 * s2 * s3;
    } else if (order === 'YXZ') {
        q[0] = s1 * c2 * c3 + c1 * s2 * s3;
        q[1] = c1 * s2 * c3 - s1 * c2 * s3;
        q[2] = c1 * c2 * s3 - s1 * s2 * c3;
        q[3] = c1 * c2 * c3 + s1 * s2 * s3;
    } else if (order === 'ZXY') {
        q[0] = s1 * c2 * c3 - c1 * s2 * s3;
        q[1] = c1 * s2 * c3 + s1 * c2 * s3;
        q[2] = c1 * c2 * s3 + s1 * s2 * c3;
        q[3] = c1 * c2 * c3 - s1 * s2 * s3;
    } else if (order === 'ZYX') {
        q[0] = s1 * c2 * c3 - c1 * s2 * s3;
        q[1] = c1 * s2 * c3 + s1 * c2 * s3;
        q[2] = c1 * c2 * s3 - s1 * s2 * c3;
        q[3] = c1 * c2 * c3 + s1 * s2 * s3;
    } else if (order === 'YZX') {
        q[0] = s1 * c2 * c3 + c1 * s2 * s3;
        q[1] = c1 * s2 * c3 + s1 * c2 * s3;
        q[2] = c1 * c2 * s3 - s1 * s2 * c3;
        q[3] = c1 * c2 * c3 - s1 * s2 * s3;
    } else if (order === 'XZY') {
        q[0] = s1 * c2 * c3 - c1 * s2 * s3;
        q[1] = c1 * s2 * c3 - s1 * c2 * s3;
        q[2] = c1 * c2 * s3 + s1 * s2 * c3;
        q[3] = c1 * c2 * c3 + s1 * s2 * s3;
    }
    return q;
};

var FirstPersonManipulatorDeviceOrientationController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

FirstPersonManipulatorDeviceOrientationController.computeQuaternion = (function() {
    var screenTransform = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();
    var worldTransform = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].fromValues(-Math.sqrt(0.5), 0.0, 0.0, Math.sqrt(0.5)); // - PI/2 around the x-axis

    // but on ios alpha is relative to the first question:
    //
    // http://www.html5rocks.com/en/tutorials/device/orientation/
    // For most browsers, alpha returns the compass heading, so when the device is pointed
    // north, alpha is zero. With Mobile Safari, alpha is based on the direction the
    // device was pointing when device orientation was first requested. The compass
    // heading is available in the webkitCompassHeading parameter.

    return function(q, deviceOrientation, screenOrientation) {
        var alpha = deviceOrientation.alpha * degtorad;
        var beta = deviceOrientation.beta * degtorad;
        var gamma = deviceOrientation.gamma * degtorad;

        // If the user goes in landscape mode, he rotates his device with a certain angle
        // around the Z axis counterclockwise and the DeviceOrientation contains this
        // rotation To compensate this, we apply a rotation of the same angle in the
        // opposite way

        var screenAngle = screenOrientation * degtorad;

        // alpha is heading -> X
        // beta             -> Z Up
        // Gamma            -> Y view direction
        makeRotateFromEuler(q, beta, alpha, -gamma, 'YXZ');
        // equivalent to
        // var rotateX = mat4.fromRotation( mat4.create(), beta,[ 1,0,0 ] );
        // var rotateY = mat4.fromRotation( mat4.create(), alpha,[ 0,1,0 ] );
        // var rotateZ = mat4.fromRotation( mat4.create(), -gamma,[ 0,0,1 ] );
        // var result = mat4.create();
        // mat4.mul( result, rotateY, rotateX );
        // mat4.mul( result, result, rotateZ );
        // mat4.getRotation( q, result );

        var minusHalfAngle = -screenAngle / 2.0;
        screenTransform[1] = Math.sin(minusHalfAngle);
        screenTransform[3] = Math.cos(minusHalfAngle);

        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].mul(q, q, screenTransform);
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].mul(q, q, worldTransform);

        var yTemp = q[1];
        q[1] = -q[2];
        q[2] = yTemp;

        return q;
    };
})();

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    FirstPersonManipulatorDeviceOrientationController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._stepFactor = 1.0; // meaning radius*stepFactor to move
            this._quat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();
            this._pos = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
        },

        update: function(deviceOrientation, screenOrientation) {
            FirstPersonManipulatorDeviceOrientationController.computeQuaternion(
                this._quat,
                deviceOrientation,
                screenOrientation
            );
            this._manipulator.setPoseVR(this._quat, this._pos);
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (FirstPersonManipulatorDeviceOrientationController);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_math__ = __webpack_require__(38);




var OrbitManipulatorHammerController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulatorHammerController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._panFactorX = 1.0;
            this._panFactorY = -this._panFactorX;

            this._rotateFactorX = 0.6;
            this._rotateFactorY = -this._rotateFactorX;
            this._zoomFactor = 5.0;

            this._lastScale = 0;
            this._nbPointerLast = 0; // to check if we the number of pointers has changed
            this._delay = 0.15;

            this._transformStarted = false;
            this._dragStarted = false;

            this._cbPanStart = this.panStart.bind(this);
            this._cbPanMove = this.panMove.bind(this);
            this._cbPanEnd = this.panEnd.bind(this);

            this._cbPinchStart = this.pinchStart.bind(this);
            this._cbPinchEnd = this.pinchEnd.bind(this);
            this._cbPinchInOut = this.pinchInOut.bind(this);

            this._isValid = true;
        },

        setValid: function(valid) {
            if (valid === this._isValid) return;
            this._isValid = valid;
            // if validity change during a drag/transform
            this._transformStarted = false;
            this._dragStarted = false;
        },

        getPanStartBind: function() {
            return this._cbPanStart;
        },

        getPanMoveBind: function() {
            return this._cbPanMove;
        },

        getPanEndBind: function() {
            return this._cbPanEnd;
        },

        getPinchEndBind: function() {
            return this._cbPinchEnd;
        },

        _setListeners: function() {
            var hammer = this._eventProxy;

            // Let the pan be detected with two fingers.
            // 2 => pan, 1 -> rotate
            hammer.get('pan').set({
                threshold: 0,
                pointers: 0
            });

            var pinch = hammer.get('pinch');
            if (pinch) {
                // Set a minimal thresold on pinch event, to be detected after pan
                pinch.set({
                    threshold: 0.1
                });
                pinch.recognizeWith(hammer.get('pan'));
            }

            hammer.on('panstart ', this._cbPanStart);
            hammer.on('panmove', this._cbPanMove);
            hammer.on('panend', this._cbPanEnd);

            hammer.on('pinchend', this._cbPinchEnd);
            hammer.on('pinchstart', this._cbPinchStart);
            hammer.on('pinchin pinchout', this._cbPinchInOut);

            // if validity change during a drag/tranform
            this._transformStarted = false;
            this._dragStarted = false;
        },

        setEventProxy: function(hammer) {
            if (!hammer || hammer === this._eventProxy) {
                return;
            }

            this._eventProxy = hammer;
            if (this._manipulator) this._setListeners();
        },

        _computeTouches: function(event) {
            if (event.pointers !== undefined) return event.pointers.length;
            return 1; // mouse
        },

        panStart: function(event) {
            if (!this._isValid || this._transformStarted || event.pointerType === 'mouse') {
                return;
            }

            this._dragStarted = true;
            var manipulator = this._manipulator;
            this._nbPointerLast = this._computeTouches(event);
            if (this._nbPointerLast === 2) {
                var panInterpolator = manipulator.getPanInterpolator();
                panInterpolator.reset();
                var xPan = event.center.x * this._panFactorX;
                var yPan = event.center.y * this._panFactorY;
                panInterpolator.set(xPan, yPan);
            } else {
                var rotateInterpolator = manipulator.getRotateInterpolator();
                rotateInterpolator.reset();
                var xRot = event.center.x * this._rotateFactorX;
                var yRot = event.center.y * this._rotateFactorY;
                rotateInterpolator.set(xRot, yRot);
            }
        },

        panMove: function(event) {
            if (!this._isValid || !this._dragStarted || event.pointerType === 'mouse') {
                return;
            }

            var manipulator = this._manipulator;
            var nbPointers = this._computeTouches(event);
            // prevent sudden big changes in the event.center variables
            if (this._nbPointerLast !== nbPointers) {
                if (nbPointers === 2) manipulator.getPanInterpolator().reset();
                else manipulator.getRotateInterpolator().reset();
                this._nbPointerLast = nbPointers;
            }

            if (nbPointers === 2) {
                var panInterpolator = manipulator.getPanInterpolator();
                var xPan = event.center.x * this._panFactorX;
                var yPan = event.center.y * this._panFactorY;
                panInterpolator.setTarget(xPan, yPan);
            } else {
                var rotateInterpolator = manipulator.getRotateInterpolator();
                rotateInterpolator.setDelay(this._delay);
                var xRot = event.center.x * this._rotateFactorX;
                var yRot = event.center.y * this._rotateFactorY;
                rotateInterpolator.setTarget(xRot, yRot);
            }
        },

        panEnd: function(event) {
            if (!this._isValid || !this._dragStarted || event.pointerType === 'mouse') return;
            this._dragStarted = false;
        },

        pinchStart: function(event) {
            if (!this._isValid || event.pointerType === 'mouse') return;

            this._transformStarted = true;
            this._lastScale = event.scale;
            var zoomInterpolator = this._manipulator.getZoomInterpolator();
            zoomInterpolator.reset();
            zoomInterpolator.set(this._lastScale);
            event.preventDefault();
        },

        pinchEnd: function(event) {
            if (!this._isValid || event.pointerType === 'mouse') return;
            this._transformStarted = false;
        },

        pinchInOut: function(event) {
            if (!this._isValid || !this._transformStarted || event.pointerType === 'mouse') return;

            // make the dezoom faster (because the manipulator dezoom/dezoom distance speed is adaptive)
            var zoomFactor =
                event.scale > this._lastScale ? this._zoomFactor : this._zoomFactor * 3.0;
            // also detect pan (velocity) to reduce zoom force
            var minDezoom = 0.0;
            var maxDezoom = 0.5;
            var aSmooth = -Math.abs(event.velocity) + (minDezoom + maxDezoom);
            zoomFactor *= __WEBPACK_IMPORTED_MODULE_2_osg_math__["a" /* default */].smoothStep(minDezoom, maxDezoom, aSmooth);

            var scale = (event.scale - this._lastScale) * zoomFactor;
            this._lastScale = event.scale;

            var zoomInterpolator = this._manipulator.getZoomInterpolator();
            zoomInterpolator.setTarget(zoomInterpolator.getTarget()[0] - scale);
        },

        removeEventProxy: function(eventProxy) {
            var proxy = eventProxy || this._eventProxy;
            if (!proxy) return;

            proxy.off('panstart ', this._cbPanStart);
            proxy.off('panmove', this._cbPanMove);
            proxy.off('panend', this._cbPanEnd);
            proxy.off('pinchstart', this._cbPinchStart);
            proxy.off('pinchend', this._cbPinchEnd);
            proxy.off('pinchin pinchout', this._cbPinchInOut);
        },

        setManipulator: function(manipulator) {
            this._manipulator = manipulator;
            if (this._eventProxy) this._setListeners();
        }
    })
);
/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulatorHammerController);


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__ = __webpack_require__(71);




/*

Nodes are automatically created when parsing a glsl file

=== function name ===
* First letter of your glsl function will be converted to upperCase
* You can override the function name with NODE_NAME:myNewName

=== variable name ===
* The output variable is always named result, other variable names are unchanged
* You can override a variable name by writing glslName:jsName

=== overloading matching ===
* Overloading is supported, it will select the best matching depending of the js inputs/outputs
* For now you need to put the overload functions in the same glsl file
* Overloading will prioritize variable name matching first, then output types, and finally input types
* When there is a mismatch in types, it'll downcast your input (e.g: by transforming your vec4 into a vec3)

=== misc ===
* Shader nodes have a function addExtensions if you want to enable extensions
* Shader nodes have a function addDefines if you want to provides defines

* /!\ hack: Extensions in pragma is partially supported: for now only by writing DERIVATIVES:enable after the pragma will work

* /!\ hack: you can declare functions as defines too but it will only perform name checking
            No type checking/downcasting and no in/out validation

* /!\ hack: Optional argument are handled with define that have the structure : OPT_ARG_myOptVar
            The variable will be named myOptVar in that example
            No type checking/downcasting and no in/out validation for the optional variable


Try to stick with the simple example if possible

============================
====== SIMPLE EXAMPLE ======
============================

---- glsl ----
#pragma DECLARE_FUNCTION
vec3 myFunc(const in float myVarIn, out float myVarOut) {
    // do stuffs
}

---- js ----
this.getNode('MyFunc')
    .inputs({
        myVarIn: var1
    })
    .outputs({
        result: var2,
        myVarOut: var3
    });

============================
====== COMPLEX EXAMPLE =====
============================

---- glsl ----
#pragma DECLARE_FUNCTION NODE_NAME:myFuncTiti result:resOut myVarIn:totoIn optVariable:optVar DERIVATIVES:enable
vec3 myFunc(const in float myVarIn, out float myVarOut, OPT_ARG_optVariable) {
    // do stuffs
}

---- js ----
this.getNode('myFuncTiti')
    .inputs({
        totoIn: var1,
        optVar: var2
    })
    .outputs({
        resOut: var4,
        myVarOut: var5
    })
    .addDefines(['#define TOTO']);

*/

var sprintf = function(string, args) {
    if (!string || !args) {
        return '';
    }

    var arg;

    for (var index in args) {
        arg = args[index];

        if (arg === undefined) {
            continue;
        }

        if (arg.getVariable) {
            arg = arg.getVariable();
        }
        string = string.replace('%s', arg);
    }
    return string;
};

var checkVariableType = function(vars, optionalPrefix) {
    var inputs = vars;
    var varsList = [];
    var prefix = optionalPrefix;
    if (optionalPrefix === undefined) {
        prefix = '';
    }

    for (var i = 0, l = inputs.length; i < l; i++) {
        var variable = inputs[i];
        var output;

        if (variable === undefined) {
            output = 'undefined';
        } else if (typeof variable === 'string') {
            output = variable;
        } else if (variable.getType) {
            output = variable.getType() + ' ' + variable.getVariable();
        } else {
            output = variable.getVariable();
        }

        varsList.push(prefix + output);
    }

    return varsList;
};

var callFunction = function(funcName, output, inputs) {
    var osgShader = __webpack_require__(95).default;

    var debug = [];
    var callString = '';

    // debug
    if (osgShader.debugShaderNode) {
        debug.push('\n// output');
        Array.prototype.push.apply(debug, checkVariableType([output], '// '));
    }

    if (output) {
        callString = (output.getVariable ? output.getVariable() : output) + ' = ';
    }

    callString = callString + funcName + '( ';

    if (inputs && inputs.length > 0) {
        // debug
        if (osgShader.debugShaderNode) {
            debug.push('// inputs');
            Array.prototype.push.apply(debug, checkVariableType(inputs, '// '));
        }

        for (var i = 0, l = inputs.length; i < l; i++) {
            callString += inputs[i].getVariable ? inputs[i].getVariable() : inputs[i];
            if (i !== l - 1) callString += ', ';
        }
    }

    callString += ' );\n';

    if (osgShader.debugShaderNode) {
        return debug.join('\n') + '\n' + callString;
    }

    return callString;
};

var extractPragmaArgs = function(option) {
    // extract glslVar:jsVar pattern
    // res: ["DERIVATIVES:enable", "glslVarIn:jsVarIn", "glslVarOut:jsVarOut"]
    var res = option.match(/([^\s]+):([^\s]+)/g);

    var map = {};
    if (!res) return map;

    for (var i = 0; i < res.length; ++i) {
        var split = res[i].split(':');
        map[split[0]] = split[1];
    }

    return map;
};

var extractSignature = function(option, signature) {
    var openParen = signature.indexOf('(');
    var closeParen = signature.indexOf(')');

    // preSignature: "vec3 myFunction"
    var preSignature = signature.substring(0, openParen);
    preSignature = preSignature
        .replace(/[\r\n|\r|\n]/g, '')
        .trim()
        .replace(/\s+/g, ' ');

    var splitPre = preSignature.split(/\s/);
    var firstWord = splitPre[0];
    var nameFunc = splitPre[1];

    // override variable names
    var pragmaArgs = extractPragmaArgs(option);
    var returnName = pragmaArgs.result || 'result';

    // override node name
    var nodeName = pragmaArgs.NODE_NAME;
    if (!nodeName) {
        nodeName = nameFunc[0].toUpperCase() + nameFunc.substring(1);
    }

    // extensions
    var extensions = [];
    if (pragmaArgs.DERIVATIVES) {
        extensions.push('#extension GL_OES_standard_derivatives : ' + pragmaArgs.DERIVATIVES);
    }

    var outputs = [];
    var returnVariable;
    var isDefine = firstWord === '#define';
    // return variable
    if (firstWord !== 'void') {
        returnVariable = {
            name: returnName,
            type: !isDefine && firstWord
        };
        outputs.push(returnVariable);
    }

    // postSignature: "const in vec3 varIn,    const out float varOut"
    var postSignature = signature.substring(openParen + 1, closeParen);
    postSignature = postSignature.replace(/[\r\n|\r|\n]/g, '');

    // array of arguments
    var argumentList = postSignature.split(/OPT_ARG_|,/);
    var hasOptionalArgs = postSignature.indexOf('OPT_ARG_') !== -1;

    var inputs = [];
    var orderedArgs = [];
    for (var i = 0; i < argumentList.length; ++i) {
        var argi = argumentList[i];
        if (!argi) continue;

        // cleanArg: "const in vec3 varIn"
        var cleanArg = argi
            .trim()
            .replace(/\s+/g, ' ')
            .split('[')[0];
        var splits = cleanArg.split(/\s/);
        var nbSplits = splits.length;

        var isOutput = nbSplits >= 3 && splits[nbSplits - 3].indexOf('out') !== -1;
        var glslName = splits[nbSplits - 1];
        var res = {
            isOutput: isOutput,
            type: splits[nbSplits - 2],
            name: pragmaArgs[glslName] || glslName,
            optional: hasOptionalArgs && postSignature.indexOf('OPT_ARG_' + glslName) !== -1
        };

        orderedArgs.push(res);
        if (res.optional) continue;

        if (isOutput) outputs.push(res);
        else inputs.push(res);
    }

    return {
        nodeName: nodeName,
        functionName: nameFunc,
        signature: {
            returnVariable: returnVariable,
            orderedArgs: orderedArgs,
            outputs: outputs,
            inputs: inputs,
            extensions: extensions
        }
    };
};

var createNode = function(res, fileName) {
    var NodeCustom = function() {
        __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].call(this);
        this._defines = [];
        this._extensions = [];
        this._missingArgs = false;
    };

    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
        NodeCustom,
        __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].prototype, {
            type: res.nodeName,
            signatures: [res.signature],
            globalDeclare: '#pragma include "' + fileName + '"',

            checkInputsOutputs: function() {},

            globalFunctionDeclaration: function() {
                return this.globalDeclare;
            },

            addExtensions: function(exts) {
                this._extensions.push.apply(this._extensions, exts);
                return this;
            },

            getExtensions: function() {
                this.getOrCreateSignature();
                return this._extensions;
            },

            addDefines: function(defines) {
                this._defines.push.apply(this._defines, defines);
                return this;
            },

            getDefines: function() {
                return this._defines;
            },

            _validateSameVariables: function(glslArray, jsObj) {
                var nbGlsl = glslArray.length;
                for (var i = 0; i < nbGlsl; ++i) {
                    if (!jsObj[glslArray[i].name]) return false;
                }
                return glslArray.length === Object.keys(jsObj).length;
            },

            _validateSameType: function(glslArray, jsObj) {
                var nbGlsl = glslArray.length;
                for (var i = 0; i < nbGlsl; ++i) {
                    var jsVar = jsObj[glslArray[i].name];
                    if (jsVar.getType() !== glslArray[i].type) return false;
                }
                return true;
            },

            _getSignatureBestMatch: function() {
                if (this.signatures.length === 1) return this.signatures[0];

                var matchNames = [];
                var matchOutput = [];
                var matchInput = [];
                var nbSignatures = this.signatures.length;
                for (var i = 0; i < nbSignatures; ++i) {
                    var sig = this.signatures[i];
                    if (!this._validateSameVariables(sig.outputs, this._outputs)) continue;
                    if (!this._validateSameVariables(sig.inputs, this._inputs)) continue;
                    matchNames.push(sig);

                    if (!this._validateSameType(sig.outputs, this._outputs)) continue;
                    matchOutput.push(sig);

                    if (!this._validateSameType(sig.inputs, this._inputs)) continue;
                    matchInput.push(sig);
                }

                if (!matchNames.length) return this.signatures[0];
                if (matchNames.length === 1 || !matchOutput.length) return matchNames[0];
                if (matchOutput.length === 1 || !matchInput.length) return matchOutput[0];
                return matchInput[0];
            },

            getOrCreateSignature: function() {
                if (!this._signature) {
                    this._signature = this._getSignatureBestMatch();
                    this.addExtensions(this._signature.extensions);
                }
                return this._signature;
            },

            _typeDownCast: function(glslArg) {
                var jsArg;
                if (glslArg.optional) {
                    jsArg = this._inputs[glslArg.name] || this._outputs[glslArg.name];
                    if (!jsArg) return;
                } else {
                    jsArg = glslArg.isOutput
                        ? this._outputs[glslArg.name]
                        : this._inputs[glslArg.name];
                }

                if (!jsArg) {
                    var typeIn = glslArg.isOutput ? 'output' : 'input';
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].error(
                        'missing ' + typeIn + ' ' + glslArg.name + ' on NodeCustom ' + res.nodeName
                    );
                    this._missingArgs = true;
                    return;
                }

                var realType = jsArg.getType();
                var validType = glslArg.type;

                if (!validType || validType === realType) return jsArg;
                if (validType === 'vec3') return jsArg.getVariable() + '.rgb';
                if (validType === 'vec2') return jsArg.getVariable() + '.rg';
                if (validType === 'float') return jsArg.getVariable() + '.r';
                return jsArg;
            },

            computeShader: function() {
                var signature = this.getOrCreateSignature();

                var ret = signature.returnVariable && signature.returnVariable.name;
                var returnOut = ret ? this._outputs[ret] : undefined;
                if (ret && !returnOut) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].error('missing output ' + ret + ' on NodeCustom ' + res.nodeName);
                    this._missingArgs = true;
                }

                var orderedArgs = [];
                for (var i = 0; i < signature.orderedArgs.length; ++i) {
                    var input = this._typeDownCast(signature.orderedArgs[i]);
                    if (input) orderedArgs.push(input);
                }

                if (this._missingArgs) return '';
                return callFunction(res.functionName, returnOut, orderedArgs);
            }
        }),
        'osgShader',
        res.nodeName
    );

    return NodeCustom;
};

var shaderNodeClassGlobal = {};

var extractFunctions = function(shaderLib, fileName) {
    var signatures = shaderLib[fileName].split(/#pragma DECLARE_FUNCTION(.*)[\r\n|\r|\n]/);
    var nbSignatures = (signatures.length - 1) / 2;

    var shaderNodeClassLocal = {};
    for (var i = 0; i < nbSignatures; ++i) {
        var result = extractSignature(signatures[i * 2 + 1], signatures[i * 2 + 2]);
        var nodeName = result.nodeName;
        var shaderNode = shaderNodeClassLocal[nodeName];
        if (shaderNode) {
            shaderNode.prototype.signatures.push(result.signature);
            continue;
        }
        // new shadernode in this local shaderLib
        shaderNode = shaderNodeClassGlobal[nodeName];
        if (shaderNode) {
            // replace shader node globally
            shaderNode.prototype.signatures = [result.signature];
            shaderNode.prototype.globalDeclare = '#pragma include "' + fileName + '"';
        } else {
            shaderNode = createNode(result, fileName);
        }
        shaderNodeClassLocal[nodeName] = shaderNode;
        shaderNodeClassGlobal[nodeName] = shaderNode;
    }

    return shaderNodeClassLocal;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    callFunction: callFunction,
    checkVariableType: checkVariableType,
    sprintf: sprintf,
    extractFunctions: extractFunctions
});


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShader_Compiler__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_ShaderGenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_ShaderGeneratorProxy__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShader_ShaderProcessor__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_nodeFactory__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShader_node_Node__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgShader_utils__ = __webpack_require__(94);








var lib = {};

lib.Compiler = __WEBPACK_IMPORTED_MODULE_0_osgShader_Compiler__["a" /* default */];
lib.ShaderGenerator = __WEBPACK_IMPORTED_MODULE_1_osgShader_ShaderGenerator__["a" /* default */];
lib.ShaderGeneratorProxy = __WEBPACK_IMPORTED_MODULE_2_osgShader_ShaderGeneratorProxy__["a" /* default */];
lib.ShaderProcessor = __WEBPACK_IMPORTED_MODULE_3_osgShader_ShaderProcessor__["a" /* default */];
lib.nodeFactory = __WEBPACK_IMPORTED_MODULE_4_osgShader_nodeFactory__["a" /* default */];
lib.utils = __WEBPACK_IMPORTED_MODULE_6_osgShader_utils__["a" /* default */];

lib.node = {};
lib.node.Node = __WEBPACK_IMPORTED_MODULE_5_osgShader_node_Node__["a" /* default */]; // used for inheritance
__WEBPACK_IMPORTED_MODULE_4_osgShader_nodeFactory__["a" /* default */]._nodes.forEach(function(value, key) {
    lib.node[key] = value;
});

// debug utility: set it to one to have verbose in shaders
lib.debugShaderNode = false;

/* harmony default export */ __webpack_exports__["default"] = (lib);


/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgUtil_DisplayGraphRenderer__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgUtil_DisplayGraphNode__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);




var $;

var init$ = function() {
    try {
        $ = __webpack_require__(234);
    } catch (e) {
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn(
            'You will not be able to use osgUtil.DisplayGraph until you add jQuery in your page'
        );
    }
};

// Simple tooltips implementation
var SimpleTooltips = function(options) {
    this.options = options;
    var css = document.createElement('style');
    css.type = 'text/css';
    css.innerHTML = [
        '.osgDebugSimpleTooltip {',
        'display: none;',
        'position: absolute;',
        'margin-left: 10px;',
        'border-radius: 4px;',
        'padding: 10px;',
        'background: rgba(0,0,0,.9);',
        'color: #ffffff;',
        '}',
        '.osgDebugSimpleTooltip:before {',
        'content: ',
        ';',
        'position: absolute;',
        'left: -10px;',
        'top: 8px;',
        'border: 10px solid transparent;',
        'border-width: 10px 10px 10px 0;',
        'border-right-color: rgba(0,0,0,.9);',
        '}'
    ].join('\n');
    document.getElementsByTagName('head')[0].appendChild(css);

    this.el = document.createElement('div');
    this.el.className = 'osgDebugSimpleTooltip';
    document.body.appendChild(this.el);
    var nodes = document.querySelectorAll(this.options.selector);
    for (var i = 0; i < nodes.length; i++) {
        nodes[i].addEventListener('mouseover', this.showTooltip.bind(this), false);
        nodes[i].addEventListener('mouseout', this.hideTooltip.bind(this), false);
    }
};
SimpleTooltips.prototype = {
    showTooltip: function(e) {
        if (!$) return;

        var target = e.currentTarget;
        this.el.innerHTML = target.getAttribute('title');
        this.el.style.display = 'block';
        this.el.style.left =
            $(target).position().left +
            $(target)
                .get(0)
                .getBoundingClientRect().width +
            'px';
        this.el.style.top = $(target).position().top + 'px';
    },
    hideTooltip: function() {
        this.el.style.display = 'none';
    }
};

var DisplayGraph = function() {
    init$();
    if (!$) return;

    // indexed with instanceID, references nodes, stateSet, sourceGeometry...
    // referenced with strings !
    this._selectables = new window.Map();

    this._graphNode = new __WEBPACK_IMPORTED_MODULE_1_osgUtil_DisplayGraphNode__["a" /* default */](this._selectables);
    this._graphRender = new __WEBPACK_IMPORTED_MODULE_0_osgUtil_DisplayGraphRenderer__["a" /* default */](this._selectables);

    this._displayNode = true;
    this._displayRenderer = false;

    // callback when selecting a node
    this._cbSelect = undefined;

    this._focusedElement = 'graph';
    this._idToDomElement = new window.Map();

    this._$svg = $('<svg width=100% height=100% style="z-index: -1"></svg>');
    $('body').append(this._$svg);

    this._css =
        '.node {text-align: center;cursor: pointer;}.node rect {stroke: #FFF;}.edgePath path {stroke: #FFF;fill: none;}table {text-align: right;}svg {position: absolute;left: 0px;top: 0px;}.osgDebugButton {position: absolute;left: 15px;top: 15px;z-index: 8;border: 0;background: #65a9d7;background: -webkit-gradient(linear, left top, left bottom, from(#3e779d), to(#65a9d7));background: -webkit-linear-gradient(top, #3e779d, #65a9d7);background: -moz-linear-gradient(top, #3e779d, #65a9d7);background: -ms-linear-gradient(top, #3e779d, #65a9d7);background: -o-linear-gradient(top, #3e779d, #65a9d7);padding: 5px 10px;-webkit-border-radius: 7px;-moz-border-radius: 7px;border-radius: 7px;-webkit-box-shadow: rgba(0,0,0,1) 0 1px 0;-moz-box-shadow: rgba(0,0,0,1) 0 1px 0;box-shadow: rgba(0,0,0,1) 0 1px 0;text-shadow: rgba(0,0,0,.4) 0 1px 0;color: white;font-size: 15px;font-family: Helvetica, Arial, Sans-Serif;text-decoration: none;vertical-align: middle;}.osgDebugButton:hover {border-top-color: #28597a;background: #28597a;color: #ccc;}.osgDebugButton:active {border-top-color: #1b435e;background: #1b435e;}.osgDebugSimpleTooltip .osgDebugName {font-weight: bold;color: #60b1fc;margin: 0;}.osgDebugSimpleTooltip .osgDebugDescription {margin: 0;}';

    this._onlyGenerateGraph = false;
};

DisplayGraph.instance = function() {
    if (!DisplayGraph._instance) DisplayGraph._instance = new DisplayGraph();
    return DisplayGraph._instance;
};

DisplayGraph.prototype = {
    getColorFromClassName: __WEBPACK_IMPORTED_MODULE_1_osgUtil_DisplayGraphNode__["a" /* default */].prototype.getColorFromClassName,

    setCallbackSelect: function(cb) {
        this._cbSelect = cb;
    },

    reset: function() {
        if (!$) return;

        this._selectables.clear();
        this._$svg.empty();
        this._focusedElement = 'scene';
        $('.osgDebugButton').hide();
    },

    setDisplayGraphRenderer: function(bool) {
        this._displayRenderer = bool;
    },

    createRenderGraph: function(renderStage) {
        // called by renderer
        this._graphRender.createGraph(renderStage);
        this.displayGraph();
    },

    createGraph: function(root) {
        if (!$) return;
        this.reset();

        this._displayNode = !!root;
        if (root) {
            this._graphNode.createGraph(root);
        }

        // check if asynchronous is necessary
        if (!this._displayRenderer) {
            this.displayGraph();
        } else {
            // circular dependency
            __webpack_require__(97).default.debugGraph = true;
        }
    },

    // Create and display a dagre d3 graph
    displayGraph: function() {
        if (!$) return;
        if (window.d3 && window.dagreD3) {
            this._createGraphApply();
            return;
        }

        var d3url = '//cdnjs.cloudflare.com/ajax/libs/d3/3.4.13/d3.min.js';
        var dagreurl = '//cdn.jsdelivr.net/dagre-d3/0.2.9/dagre-d3.min.js';

        var cb = this._createGraphApply.bind(this);
        $.getScript(d3url).done(function() {
            $.getScript(dagreurl).done(cb);
        });
    },

    _createGraphApply: function() {
        var diGraph = new window.dagreD3.Digraph();
        if (this._displayNode) this._graphNode.generateNodeAndLink(diGraph);
        if (this._displayRenderer) this._graphRender.generateNodeAndLink(diGraph);

        if (this._onlyGenerateGraph) {
            if (!this._channel)
                this._channel = new BroadcastChannel('pcviz_osg_channel');

            this._channel.postMessage(diGraph);

            this._channel.onmessage = e => {
                var elt = this._selectables.get(e.data);
                if (!elt) return;

                window.activeNode = elt;
                __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].info('window.activeNode is set with the node below !');
                __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log(window.activeNode);
                __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log('\n');
            };
            return;
        }
        // Add the style of the graph
        this.injectStyleElement();
        $('.osgDebugButton').show();

        // Create the renderer
        var renderer = (this.renderer = new window.dagreD3.Renderer());

        // Set up an SVG group so that we can translate the final graph.
        var svg = window.d3.select(this._$svg.get(0));
        var svgGroup = svg.append('g');

        // Set initial zoom to 75%
        var initialScale = 0.75;
        var oldZoom = renderer.zoom();
        renderer.zoom(function(g, argSVG) {
            var zoom = oldZoom(g, argSVG);

            zoom.scale(initialScale).event(argSVG);
            return zoom;
        });

        // Simple function to style the tooltip for the given node.
        var styleTooltip = function(instanceID, description) {
            // instanceID is used by onNodeSelect to retrieve the node
            return (
                '<p class="osgDebugName">' +
                instanceID +
                '</p><pre class="osgDebugDescription">' +
                description +
                '</pre>'
            );
        };

        var idToDom = this._idToDomElement;
        // Override drawNodes to set up the hover.
        var oldDrawNodes = renderer.drawNodes();
        renderer.drawNodes(function(g, argSVG) {
            var svgNodes = oldDrawNodes(g, argSVG);

            // Set the title on each of the nodes and use tipsy to display the tooltip on hover
            svgNodes.attr('title', function(d) {
                idToDom.set(d, this);
                return styleTooltip(d, g.node(d).description || '');
            });

            return svgNodes;
        });

        // Run the renderer. This is what draws the final graph.
        renderer.run(diGraph, svgGroup);

        this.tooltip = new SimpleTooltips({
            selector: '.node'
        });

        // Do a console log of the node (or stateset) and save it in window.*
        $('.node').click(this.onNodeSelect.bind(this));
        this.focusOnGraph();
    },

    selectNode: function(node) {
        var id = node.getInstanceID();
        var dom = this._idToDomElement.get(id);
        if (dom) $(dom).click();
    },

    onNodeSelect: function(e) {
        var target = e.currentTarget;
        var identifier = $(target.getAttribute('title'))[0].innerHTML;
        var selectables = this._selectables;

        // color the node back
        if (this.lastNode) {
            this.lastNode.style.fill = this.lastColor;
        }

        // non selectables nodes
        var elt = selectables.get(identifier);
        if (!elt) return;

        this.lastNode = target.childNodes[0];
        this.lastColor = this.lastNode.style.fill;
        target.childNodes[0].style.fill = '#f00';

        window.activeNode = elt;
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].info('window.activeNode is set with the node below !');
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log(window.activeNode);
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log('\n');

        if (this._cbSelect) this._cbSelect(elt);
    },

    focusOnScene: function() {
        $('.osgDebugButton').text('Access to the graph');
        this._$svg.css('zIndex', '-2');
        this._focusedElement = 'scene';
    },

    focusOnGraph: function() {
        $('.osgDebugButton').text('Access to the scene');
        this._$svg.css('zIndex', '2');
        $('.osgDebugSimpleTooltip').css('zIndex', '3');
        this._focusedElement = 'graph';
    },

    // Apply all the style
    injectStyleElement: function() {
        if (this._cssInjected) return;
        this._cssInjected = true;

        $('body').append('<button class="osgDebugButton">Access to the scene</button>');
        $('.osgDebugButton').click(
            function() {
                if (this._focusedElement === 'scene') this.focusOnGraph();
                else this.focusOnScene();
            }.bind(this)
        );

        var css = document.createElement('style');
        css.type = 'text/css';
        css.innerHTML = this._css;
        document.getElementsByTagName('head')[0].appendChild(css);
    },

    setOnlyGenerateGraph: function(flag) {
        this._onlyGenerateGraph = flag;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DisplayGraph);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_CullSettings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_CullVisitor__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_RenderStage__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_State__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_StateGraph__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShader_osgShader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgUtil_DisplayGraph__ = __webpack_require__(96);











var Renderer = function(camera) {
    __WEBPACK_IMPORTED_MODULE_3_osg_Object__["a" /* default */].call(this);

    this._state = undefined;
    this._camera = camera;
    this._renderStage = undefined;
    this._stateGraph = undefined;

    this._frameStamp = undefined;

    this._previousCullsettings = new __WEBPACK_IMPORTED_MODULE_1_osg_CullSettings__["a" /* default */]();

    this.setDefaults();
};

Renderer.debugGraph = false;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Renderer,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_Object__["a" /* default */].prototype, {
        setDefaults: function() {
            this._state = new __WEBPACK_IMPORTED_MODULE_5_osg_State__["a" /* default */](new __WEBPACK_IMPORTED_MODULE_8_osgShader_osgShader__["default"].ShaderGeneratorProxy());

            this._cullVisitor = new __WEBPACK_IMPORTED_MODULE_2_osg_CullVisitor__["a" /* default */]();
            this._cullVisitor.setRenderer(this);
            this._stateGraph = new __WEBPACK_IMPORTED_MODULE_6_osg_StateGraph__["a" /* default */]();

            this.getCamera().setClearColor(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].create());
            this.setRenderStage(new __WEBPACK_IMPORTED_MODULE_4_osg_RenderStage__["a" /* default */]());

            var osg = __webpack_require__(103).default;
            var stateSet = this.getCamera().getOrCreateStateSet();
            stateSet.setAttributeAndModes(new osg.Material());
            stateSet.setAttributeAndModes(new osg.Depth());
            stateSet.setAttributeAndModes(new osg.BlendFunc());
            stateSet.setAttributeAndModes(new osg.CullFace());
        },

        getCullVisitor: function() {
            return this._cullVisitor;
        },

        setCullVisitor: function(cv) {
            if (cv && !cv.getRenderer()) cv.setRenderer(this);
            this._cullVisitor = cv;
        },

        setRenderStage: function(rs) {
            this._renderStage = rs;
        },

        getCamera: function() {
            return this._camera;
        },

        setFrameStamp: function(fs) {
            this._frameStamp = fs;
        },

        getFrameStamp: function() {
            return this._frameStamp;
        },

        getState: function() {
            return this._state;
        },

        setState: function(state) {
            this._state = state;
        },

        setGraphicContext: function(gc) {
            this._state.setGraphicContext(gc);
        },

        getGraphicContext: function() {
            return this._state.getGraphicContext();
        },

        cullAndDraw: function() {
            this.cull();
            this.draw();
        },

        cull: function() {
            var camera = this.getCamera();
            var view = camera.getView();

            this._cullVisitor.setFrameStamp(this._frameStamp);

            // reset stats
            this._cullVisitor.resetStats();

            // this part of code should be called for each view
            // right now, we dont support multi view

            // reset all stateGraph per frame
            __WEBPACK_IMPORTED_MODULE_6_osg_StateGraph__["a" /* default */].reset();
            this._stateGraph.clean();

            this._renderStage.reset();

            this._cullVisitor.reset();
            this._cullVisitor.setStateGraph(this._stateGraph);
            this._cullVisitor.setRenderStage(this._renderStage);

            this._cullVisitor.pushStateSet(camera.getStateSet());

            // save cullSettings
            this._previousCullsettings.reset();
            this._previousCullsettings.setCullSettings(this._cullVisitor);
            this._cullVisitor.setCullSettings(camera);
            if (
                this._previousCullsettings.getSettingSourceOverrider() === this._cullVisitor &&
                this._previousCullsettings.getEnableFrustumCulling()
            ) {
                this._cullVisitor.setEnableFrustumCulling(true);
            }

            // Push reference on the projection stack, it means that if compute near/far
            // is activated, it will update the projection matrix of the camera
            this._cullVisitor.pushCameraModelViewProjectionMatrix(
                camera,
                camera.getViewMatrix(),
                camera.getProjectionMatrix()
            );

            // update bound
            camera.getBound();

            var light = view.getLight();
            var View = __webpack_require__(98).default;

            if (light) {
                switch (view.getLightingMode()) {
                    case View.LightingMode.HEADLIGHT:
                        this._cullVisitor.addPositionedAttribute(null, light);
                        break;

                    case View.LightingMode.SKY_LIGHT:
                        this._cullVisitor.addPositionedAttribute(camera.getViewMatrix(), light);
                        break;

                    default:
                        break;
                }
            }

            var viewport = camera.getViewport();
            var scissor = camera.getScissor();

            this._cullVisitor.pushViewport(viewport);

            this._renderStage.setClearDepth(camera.getClearDepth());
            this._renderStage.setClearColor(camera.getClearColor());
            this._renderStage.setClearMask(camera.getClearMask());
            this._renderStage.setViewport(viewport);
            this._renderStage.setScissor(scissor);

            // pass de dbpager to the cullvisitor, so plod's can do the requests
            this._cullVisitor.setDatabaseRequestHandler(this._camera.getView().getDatabasePager());
            // dont add camera on the stack just traverse it
            this._cullVisitor.handleCullCallbacksAndTraverse(camera);

            // fix projection matrix if camera has near/far auto compute
            this._cullVisitor.popCameraModelViewProjectionMatrix(camera);

            // Important notes about near/far
            // If you are using the picking on the main camera and
            // you use only children sub camera for RTT, your
            // main camera will keep +/-infinity for near/far because
            // the computation of near/far is done by camera and use Geometry

            // restore previous state of the camera
            this._cullVisitor.setCullSettings(this._previousCullsettings);

            this._cullVisitor.popViewport();
            this._cullVisitor.popStateSet();

            this._renderStage.sort();
        },

        draw: function() {
            var state = this.getState();

            // important because cache are used in cullvisitor
            state.resetCacheFrame();

            // reset stats counter
            state.resetStats();

            this._renderStage.setCamera(this._camera);
            this._renderStage.draw(state);

            if (Renderer.debugGraph) {
                __WEBPACK_IMPORTED_MODULE_9_osgUtil_DisplayGraph__["a" /* default */].instance().createRenderGraph(this._renderStage);
                Renderer.debugGraph = false;
            }

            this._renderStage.setCamera(undefined);

            state.applyDefault();
        }
    }),
    'osgViewer',
    'Renderer'
);

/* harmony default export */ __webpack_exports__["default"] = (Renderer);


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_FrameStamp__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Light__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Scissor__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_VertexArrayObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_WebGLCaps__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgUtil_IntersectionVisitor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgUtil_LineSegmentIntersector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgViewer_Renderer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgViewer_Scene__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osgUtil_DisplayGraph__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_notify__ = __webpack_require__(2);





















// View is normally inherited from osg/View. In osgjs we dont need it yet
// this split, so everything is in osgViewer/View

var View = function() {
    this._camera = new __WEBPACK_IMPORTED_MODULE_1_osg_Camera__["a" /* default */]();
    this._camera.setName('OSGJS camera');

    this._scene = new __WEBPACK_IMPORTED_MODULE_16_osgViewer_Scene__["a" /* default */]();
    this._camera.setName('OSGJS Scene');

    this._frameStamp = new __WEBPACK_IMPORTED_MODULE_2_osg_FrameStamp__["a" /* default */]();
    this._lightingMode = undefined;
    this._manipulator = undefined;
    this._canvasWidth = 0;
    this._canvasHeight = 0;

    this._requestContinousUpdate = true;
    this._requestRedraw = true;

    this.setLightingMode(View.LightingMode.HEADLIGHT);
    // assign a renderer to the camera
    var renderer = this.createRenderer(this.getCamera());
    renderer.setFrameStamp(this._frameStamp);
    this.getCamera().setRenderer(renderer);
    this.getCamera().setView(this);
};

View.LightingMode = {
    NO_LIGHT: 0,
    HEADLIGHT: 1,
    SKY_LIGHT: 2
};

View.prototype = {
    requestRedraw: function() {
        this._requestRedraw = true;
    },
    requestContinuousUpdate: function(bool) {
        this._requestContinousUpdate = bool;
    },
    createRenderer: function(camera) {
        var render = new __WEBPACK_IMPORTED_MODULE_15_osgViewer_Renderer__["default"](camera);
        //camera->setStats(new osg::Stats("Camera"));
        return render;
    },

    setGraphicContext: function(gc) {
        this.getCamera()
            .getRenderer()
            .getState()
            .setGraphicContext(gc);
    },

    getGraphicContext: function() {
        return this.getCamera()
            .getRenderer()
            .getState()
            .getGraphicContext();
    },

    initWebGLCaps: function(gl, force) {
        __WEBPACK_IMPORTED_MODULE_12_osg_WebGLCaps__["a" /* default */].instance(gl, force);
    },

    // check Each frame because HTML standard inconsistencies
    // - mobile full-screen, device orientation, etc
    // peculiarity of webgl canvas resizing here some details
    // http://webglfundamentals.org/webgl/lessons/webgl-resizing-the-canvas.html
    // screen size
    // http://tripleodeon.com/2011/12/first-understand-your-screen/
    // touchy is touchy: many things to know
    // http://webglfundamentals.org/webgl/lessons/webgl-anti-patterns.html
    computeCanvasSize: (function() {
        return function(canvas) {
            var clientWidth, clientHeight;
            clientWidth = canvas.clientWidth;
            clientHeight = canvas.clientHeight;

            if (clientWidth < 1) clientWidth = 1;
            if (clientHeight < 1) clientHeight = 1;

            var devicePixelRatio = this._devicePixelRatio;

            var widthPixel = Math.max( 1, Math.floor( clientWidth * devicePixelRatio ) );
            var heightPixel = Math.max( 1, Math.floor( clientHeight * devicePixelRatio ) );

            var hasChanged = false;
            if (this._canvasWidth !== widthPixel) {
                canvas.width = widthPixel;
                this._canvasWidth = widthPixel;
                hasChanged = true;
            }

            if (this._canvasHeight !== heightPixel) {
                canvas.height = heightPixel;
                this._canvasHeight = heightPixel;
                hasChanged = true;
            }
            return hasChanged;
        };
    })(),

    getCanvasWidth: function() {
        return this._canvasWidth;
    },

    getCanvasHeight: function() {
        return this._canvasHeight;
    },

    getCanvasClientWidth: function() {
        return Math.ceil(this._canvasWidth / this._devicePixelRatio);
    },

    getCanvasClientHeight: function() {
        return Math.ceil(this._canvasHeight / this._devicePixelRatio);
    },

    getCanvasPixelRatio: function() {
        // in case of VR headset, it's probably not relevant anymore
        return this._devicePixelRatio;
    },

    setUpView: function(canvas, options) {
        var devicePixelRatio = window.devicePixelRatio || 1;
        var overrideDevicePixelRatio = options.getNumber('overrideDevicePixelRatio');
        var maxDevicePixelRatio = options.getNumber('maxDevicePixelRatio') || -1;

        // override the pixel ratio, used to save pixel on mobile
        if (typeof overrideDevicePixelRatio === 'number') {
            devicePixelRatio = overrideDevicePixelRatio;
        } else if (maxDevicePixelRatio !== -1) {
            devicePixelRatio = Math.min(devicePixelRatio, maxDevicePixelRatio);
        }
        this._devicePixelRatio = devicePixelRatio;

        this.computeCanvasSize(canvas);

        var width = canvas.width;
        var height = canvas.height;
        var ratio = width / height;

        this._camera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0, 0, width, height));
        this._camera.setScissor(new __WEBPACK_IMPORTED_MODULE_9_osg_Scissor__["a" /* default */]());

        this._camera.setGraphicContext(this.getGraphicContext());
        __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].lookAt(
            this._camera.getViewMatrix(),
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, -10.0),
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create(),
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0)
        );
        __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].perspective(
            this._camera.getProjectionMatrix(),
            Math.PI / 180 * 55,
            ratio,
            1.0,
            1000.0
        );

        if (options && options.enableFrustumCulling)
            this.getCamera()
                .getRenderer()
                .getCullVisitor()
                .setEnableFrustumCulling(true);

        // add a function to refresh the graph from the console
        if (options && options.debugGraph) {
            var camera = this.getCamera();
            __WEBPACK_IMPORTED_MODULE_17_osgUtil_DisplayGraph__["a" /* default */].instance().refreshGraph = function(onlyGenerateGraph) {
                var displayGraph = __WEBPACK_IMPORTED_MODULE_17_osgUtil_DisplayGraph__["a" /* default */].instance();
                displayGraph.setDisplayGraphRenderer(true);
                displayGraph.setOnlyGenerateGraph(onlyGenerateGraph);
                displayGraph.createGraph(camera);
            };

            __WEBPACK_IMPORTED_MODULE_18_osg_notify__["a" /* default */].log(
                'to refresh the graphs type in the console:\nOSG.osgUtil.DisplayGraph.instance().refreshGraph()'
            );
        }
    },

    /**
     * X = 0 at the left
     * Y = 0 at the BOTTOM
     */
    computeIntersections: function(x, y, traversalMask) {
        /*jshint bitwise: false */
        if (traversalMask === undefined) {
            traversalMask = ~0;
        }
        /*jshint bitwise: true */

        if (!this._lsi) {
            this._lsi = new __WEBPACK_IMPORTED_MODULE_14_osgUtil_LineSegmentIntersector__["a" /* default */]();
        } else {
            this._lsi.reset();
        }

        if (!this._origIntersect) {
            this._origIntersect = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            this._dstIntersect = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
        }

        this._lsi.set(
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(this._origIntersect, x, y, 0.0),
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(this._dstIntersect, x, y, 1.0)
        );

        if (!this._iv) {
            this._iv = new __WEBPACK_IMPORTED_MODULE_13_osgUtil_IntersectionVisitor__["a" /* default */]();
            this._iv.setIntersector(this._lsi);
        } else {
            this._iv.reset();
        }
        this._iv.setTraversalMask(traversalMask);
        this._camera.accept(this._iv);

        return this._lsi.getIntersections();
    },

    setFrameStamp: function(frameStamp) {
        this._frameStamp = frameStamp;
    },

    getFrameStamp: function() {
        return this._frameStamp;
    },

    setCamera: function(camera) {
        this._camera = camera;
    },

    getCamera: function() {
        return this._camera;
    },

    setSceneData: function(node) {
        var previousNode = this._scene.getSceneData();
        if (node === previousNode) return;

        this._scene.setSceneData(node);

        var children = this._camera.getChildren();
        var statsNode = undefined;
        for (var i = 0, l = children.length; i < l; i++) {
            if (children[i].getName() === 'osgStats') {
                statsNode = children[i];
                break;
            }
        }
        this._camera.removeChildren();
        this._camera.addChild(node);
        if (statsNode) this._camera.addChild(statsNode);
    },

    getSceneData: function() {
        return this._scene.getSceneData();
    },

    setDatabasePager: function(dbpager) {
        this._scene.setDatabasePager(dbpager);
    },

    getDatabasePager: function() {
        return this._scene.getDatabasePager();
    },

    getScene: function() {
        return this._scene;
    },

    getManipulator: function() {
        return this._manipulator;
    },

    setManipulator: function(manipulator) {
        this._manipulator = manipulator;
    },

    getLight: function() {
        return this._light;
    },

    setLight: function(light) {
        this._light = light;
        if (this._lightingMode !== View.LightingMode.NO_LIGHT) {
            this._scene.getOrCreateStateSet().setAttributeAndModes(this._light);
        }
    },

    getLightingMode: function() {
        return this._lightingMode;
    },

    setLightingMode: function(lightingMode) {
        if (this._lightingMode !== lightingMode) {
            this._lightingMode = lightingMode;

            if (this._lightingMode !== View.LightingMode.NO_LIGHT) {
                if (!this._light) this._light = new __WEBPACK_IMPORTED_MODULE_4_osg_Light__["a" /* default */]();
            } else {
                this._light = undefined;
            }
        }
    },

    // In OSG this call is done in SceneView
    flushDeletedGLObjects: function(availableTimeBudget) {
        // Flush all deleted OpenGL objects within the specified availableTime
        var gl = this.getGraphicContext();
        var availableTime = availableTimeBudget;
        availableTime = __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].flushDeletedGLBufferArrays(gl, availableTime);
        availableTime = __WEBPACK_IMPORTED_MODULE_11_osg_VertexArrayObject__["a" /* default */].flushDeletedGLVertexArrayObjects(gl, availableTime);
        availableTime = __WEBPACK_IMPORTED_MODULE_6_osg_Texture__["default"].getTextureManager(gl).flushDeletedTextureObjects(gl, availableTime);
        availableTime = __WEBPACK_IMPORTED_MODULE_7_osg_Program__["a" /* default */].flushDeletedGLPrograms(gl, availableTime);
        availableTime = __WEBPACK_IMPORTED_MODULE_8_osg_Shader__["a" /* default */].flushDeletedGLShaders(gl, availableTime);
        availableTime = __WEBPACK_IMPORTED_MODULE_3_osg_FrameBufferObject__["a" /* default */].flushDeletedGLFrameBuffers(gl, availableTime);
        __WEBPACK_IMPORTED_MODULE_3_osg_FrameBufferObject__["a" /* default */].flushDeletedGLRenderBuffers(gl, availableTime);
    },

    flushAllDeletedGLObjects: function() {
        // Flush all deleted OpenGL objects
        var gl = this.getGraphicContext();
        __WEBPACK_IMPORTED_MODULE_11_osg_VertexArrayObject__["a" /* default */].flushAllDeletedGLVertexArrayObjects(gl);
        __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].flushAllDeletedGLBufferArrays(gl);
        __WEBPACK_IMPORTED_MODULE_6_osg_Texture__["default"].getTextureManager(gl).flushAllDeletedTextureObjects(gl);
        __WEBPACK_IMPORTED_MODULE_7_osg_Program__["a" /* default */].flushAllDeletedGLPrograms(gl);
        __WEBPACK_IMPORTED_MODULE_8_osg_Shader__["a" /* default */].flushAllDeletedGLShaders(gl);
        __WEBPACK_IMPORTED_MODULE_3_osg_FrameBufferObject__["a" /* default */].flushAllDeletedGLFrameBuffers(gl);
        __WEBPACK_IMPORTED_MODULE_3_osg_FrameBufferObject__["a" /* default */].flushAllDeletedGLRenderBuffers(gl);
    }
};

/* harmony default export */ __webpack_exports__["default"] = (View);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Graph = function() {
    this._values = new Float32Array(Graph.maxGraphValue);
    this._index = 0;
    this._maxValue = 0.0;
    this._x = 0;
    this._y = 0;
};
Graph.maxGraphValue = 120;
Graph.prototype = {
    getIndex: function() {
        return this._index;
    },
    getValues: function() {
        return this._values;
    },
    setDisplayPosition: function(x, y) {
        this._x = x;
        this._y = y;
    },
    getX: function() {
        return this._x;
    },
    getY: function() {
        return this._y;
    },
    addValue: function(value, uvColor) {
        var index = this._index;
        this._maxValue = value > this._maxValue ? value : this._maxValue;
        this._maxValue *= 0.99;
        this._values[index] = value / (this._maxValue * 1.1);
        if (uvColor) this._values[index] += uvColor;
        this._index = (this._index + 1) % Graph.maxGraphValue;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (Graph);


/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_utils__ = __webpack_require__(1);




/**
 *  ShadowTechnique provides an implementation interface of shadow techniques.
 *  @class ShadowTechnique
 */
var ShadowTechnique = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);

    this._shadowedScene = undefined;
    this._dirty = false;
    this._continuousUpdate = true;
    // since dirtied, handy for static shadow map
    this._needRedraw = true;
};

/** @lends ShadowTechnique.prototype */
__WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].createPrototypeObject(
    ShadowTechnique,
    __WEBPACK_IMPORTED_MODULE_2_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        dirty: function() {
            this._dirty = true;
        },

        getShadowedScene: function() {
            return this._shadowedScene;
        },

        setContinuousUpdate: function(enabled) {
            this._continuousUpdate = enabled;
        },

        isContinuousUpdate: function() {
            return this._continuousUpdate;
        },

        needRedraw: function() {
            return this._needRedraw;
        },

        requestRedraw: function() {
            this._needRedraw = true;
        },

        setShadowedScene: function(shadowedScene) {
            this._shadowedScene = shadowedScene;
        },

        init: function() {
            // well shouldn't be called
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('No ShadowTechnique activated: normal rendering activated');
        },

        valid: function() {
            // make sure abstract class not used.
            return false;
        },

        // update the technic
        updateShadowTechnique: function(/*nodeVisitor*/) {},

        cullShadowCasting: function(/*cullVisitor*/) {},

        cleanSceneGraph: function() {
            // well shouldn't be called
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('No ShadowTechnique activated: normal rendering activated');
        }
    }),
    'osgShadow',
    'ShadowTechnique'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowTechnique);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_glMatrix__ = __webpack_require__(0);







/**
 * ShadowTexture Attribute encapsulate Texture webgl object
 * with Shadow specificities (no need of texcoord,fragtexcoord)
 * trigger hash change when changing texture precision from float to byt
 * shadowSettings.js header for param explanations
 * @class ShadowTexture
 * @inherits StateAttribute
 */
var ShadowTexture = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].call(this);

    this._uniforms = {};
    this._mapSize = __WEBPACK_IMPORTED_MODULE_4_osg_glMatrix__["g" /* vec4 */].create();
    this._renderSize = __WEBPACK_IMPORTED_MODULE_4_osg_glMatrix__["e" /* vec2 */].create();
    this._lightNumber = -1; // default for a valid cloneType
    this._dirtyHash = true;
    this._hash = '';
};

ShadowTexture.uniforms = {};
/** @lends Texture.prototype */
__WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    ShadowTexture,
    __WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype, {
        cloneType: function() {
            return new ShadowTexture();
        },
        invalidate: function() {
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.invalidate.call(this);
            this.dirty();
        },
        hasLightNumber: function(lightNum) {
            return this._lightNumber === lightNum;
        },

        setLightNumber: function(lun) {
            this._lightNumber = lun;
            this._dirtyHash = true;
        },

        getLightNumber: function() {
            return this._lightNumber;
        },

        getUniformName: function(name) {
            var prefix = 'Shadow_' + this.getType() + this._lightNumber.toString();
            return 'u' + prefix + '_' + name;
        },

        setInternalFormatType: function(value) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.setInternalFormatType.call(this, value);
            this._dirtyHash = true;
        },

        getOrCreateUniforms: function(unit) {
            // uniform are once per CLASS attribute, not per instance
            var obj = ShadowTexture;

            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].assert(unit !== undefined);
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].assert(this._lightNumber !== -1);

            if (obj.uniforms[unit] !== undefined) return obj.uniforms[unit];

            var uniforms = (obj.uniforms[unit] = {
                ViewRight: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('viewRight')),
                ViewUp: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('viewUp')),
                ViewLook: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('viewLook')),
                Projection: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat3(this.getUniformName('projection')),
                DepthRange: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat2(this.getUniformName('depthRange')),
                MapSize: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4(this.getUniformName('mapSize')),
                RenderSize: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat2(this.getUniformName('renderSize'))
            });

            // Dual Uniform of texture, needs:
            // - Sampler (type of texture)
            // - Int (texture unit)
            // tells Shader Program where to find it
            var name = 'Texture' + unit;
            var uniform = __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createInt1(unit, name);
            uniforms[name] = uniform;

            return obj.uniforms[unit];
        },

        setViewMatrix: function(viewMatrix) {
            this._viewMatrix = viewMatrix;
        },

        setProjection: function(projection) {
            this._projection = projection;
        },

        setDepthRange: function(depthRange) {
            this._depthRange = depthRange;
        },

        setTextureSize: function(w, h) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.setTextureSize.call(this, w, h);
            this.dirty();
            this._mapSize[0] = w;
            this._mapSize[1] = h;
            this._mapSize[2] = 1.0 / w;
            this._mapSize[3] = 1.0 / h;

            this._renderSize[0] = 1.0 / w;
            this._renderSize[1] = 1.0 / h;
        },

        // optimize a mat4 into 3 vec4 unforms
        _updateViewMatrixUniforms: function(viewMatrix, viewRight, viewUp, viewLook) {
            var v;
            var m = viewMatrix;
            v = viewRight.getInternalArray();
            v[0] = m[0];
            v[1] = m[4];
            v[2] = m[8];
            v[3] = m[12];

            v = viewUp.getInternalArray();
            v[0] = m[1];
            v[1] = m[5];
            v[2] = m[9];
            v[3] = m[13];

            v = viewLook.getInternalArray();
            v[0] = m[2];
            v[1] = m[6];
            v[2] = m[10];
            v[3] = m[14];
        },

        apply: function(state, texNumber) {
            // Texture stuff: call parent class method
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.apply.call(this, state, texNumber);

            if (this._lightNumber === -1) return;

            // update Uniforms
            var uniformMap = this.getOrCreateUniforms(texNumber);

            this._updateViewMatrixUniforms(
                this._viewMatrix,
                uniformMap.ViewRight,
                uniformMap.ViewUp,
                uniformMap.ViewLook
            );
            uniformMap.Projection.setFloat3(this._projection);
            uniformMap.DepthRange.setFloat2(this._depthRange);
            uniformMap.MapSize.setFloat4(this._mapSize);
            uniformMap.RenderSize.setFloat2(this._renderSize);
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },

        _computeInternalHash: function() {
            return this.getTypeMember() + '_' + this._lightNumber + '_' + this._type;
        }
    }),
    'osgShadow',
    'ShadowTexture'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowTexture);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_loader_package_json__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_json_loader_package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_json_loader_package_json__);


/* harmony default export */ __webpack_exports__["a"] = ({
    name: __WEBPACK_IMPORTED_MODULE_0_json_loader_package_json___default.a.name,
    version: __WEBPACK_IMPORTED_MODULE_0_json_loader_package_json___default.a.version,
    author: __WEBPACK_IMPORTED_MODULE_0_json_loader_package_json___default.a.author
});


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_AutoTransform__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BillboardAttribute__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BlendColor__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_BoundingSphere__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_BufferArrayProxy__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_ColorMask__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_ComputeBoundsVisitor__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_computeMatrixFromNodePath__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_CullFace__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_CullingSet__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osg_CullSettings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osg_CullStack__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osg_CullVisitor__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_DrawArrayLengths__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osg_EllipsoidModel__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_osg_FrameStamp__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_osg_Image__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_osg_ImageStream__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_osg_KdTree__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_osg_KdTreeBuilder__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_osg_Light__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_osg_LightSource__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_osg_LineWidth__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_osg_Lod__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_osg_Material__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_osg_math__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_osg_PooledMap__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_osg_Options__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_osg_PagedLOD__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_osg_Polytope__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_osg_PointSizeAttribute__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_osg_primitiveFunctor__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_osg_primitiveIndexFunctor__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_osg_Projection__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_osg_RenderBin__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_osg_RenderLeaf__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_osg_RenderStage__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_osg_StackObjectPairPool__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_osg_State__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_osg_StateGraph__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_osg_Switch__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_osg_TextureCubeMap__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_osg_TriangleIndexFunctor__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_osg_UpdateVisitor__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_osg_Viewport__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_osg_Scissor__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_osg_Timer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_osg_TimerGPU__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_osg_VertexArrayObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_osg_WebGLCaps__ = __webpack_require__(28);

















































































var osg = {};
osg.AutoTransform = __WEBPACK_IMPORTED_MODULE_0_osg_AutoTransform__["a" /* default */];
osg.BillboardAttribute = __WEBPACK_IMPORTED_MODULE_1_osg_BillboardAttribute__["a" /* default */];
osg.BlendColor = __WEBPACK_IMPORTED_MODULE_2_osg_BlendColor__["a" /* default */];
osg.BlendFunc = __WEBPACK_IMPORTED_MODULE_3_osg_BlendFunc__["a" /* default */];
osg.BoundingBox = __WEBPACK_IMPORTED_MODULE_4_osg_BoundingBox__["a" /* default */];
osg.BoundingSphere = __WEBPACK_IMPORTED_MODULE_5_osg_BoundingSphere__["a" /* default */];
osg.BufferArray = __WEBPACK_IMPORTED_MODULE_6_osg_BufferArray__["a" /* default */];
osg.BufferArrayProxy = __WEBPACK_IMPORTED_MODULE_7_osg_BufferArrayProxy__["a" /* default */];
osg.ColorMask = __WEBPACK_IMPORTED_MODULE_9_osg_ColorMask__["a" /* default */];
osg.Camera = __WEBPACK_IMPORTED_MODULE_8_osg_Camera__["a" /* default */];
osg.ColorMask = __WEBPACK_IMPORTED_MODULE_9_osg_ColorMask__["a" /* default */];
osg.ComputeBoundsVisitor = __WEBPACK_IMPORTED_MODULE_10_osg_ComputeBoundsVisitor__["default"];
__WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */].objectMix(osg, __WEBPACK_IMPORTED_MODULE_11_osg_computeMatrixFromNodePath__["a" /* default */]);
osg.CullFace = __WEBPACK_IMPORTED_MODULE_12_osg_CullFace__["a" /* default */];
osg.CullingSet = __WEBPACK_IMPORTED_MODULE_13_osg_CullingSet__["a" /* default */];
osg.CullSettings = __WEBPACK_IMPORTED_MODULE_14_osg_CullSettings__["a" /* default */];
osg.CullStack = __WEBPACK_IMPORTED_MODULE_15_osg_CullStack__["a" /* default */];
osg.CullVisitor = __WEBPACK_IMPORTED_MODULE_16_osg_CullVisitor__["a" /* default */];
osg.Depth = __WEBPACK_IMPORTED_MODULE_17_osg_Depth__["a" /* default */];
osg.DrawArrayLengths = __WEBPACK_IMPORTED_MODULE_18_osg_DrawArrayLengths__["a" /* default */];
osg.DrawArrays = __WEBPACK_IMPORTED_MODULE_19_osg_DrawArrays__["a" /* default */];
osg.DrawElements = __WEBPACK_IMPORTED_MODULE_20_osg_DrawElements__["a" /* default */];
osg.EllipsoidModel = __WEBPACK_IMPORTED_MODULE_21_osg_EllipsoidModel__["a" /* default */];
osg.WGS_84_RADIUS_EQUATOR = __WEBPACK_IMPORTED_MODULE_21_osg_EllipsoidModel__["a" /* default */].WGS_84_RADIUS_EQUATOR;
osg.WGS_84_RADIUS_POLAR = __WEBPACK_IMPORTED_MODULE_21_osg_EllipsoidModel__["a" /* default */].WGS_84_RADIUS_POLAR;
osg.FrameBufferObject = __WEBPACK_IMPORTED_MODULE_22_osg_FrameBufferObject__["a" /* default */];
osg.FrameStamp = __WEBPACK_IMPORTED_MODULE_23_osg_FrameStamp__["a" /* default */];
osg.Geometry = __WEBPACK_IMPORTED_MODULE_24_osg_Geometry__["a" /* default */];
osg.GLObject = __WEBPACK_IMPORTED_MODULE_26_osg_GLObject__["a" /* default */];
osg.Image = __WEBPACK_IMPORTED_MODULE_27_osg_Image__["a" /* default */];
osg.ImageStream = __WEBPACK_IMPORTED_MODULE_28_osg_ImageStream__["a" /* default */];
osg.KdTree = __WEBPACK_IMPORTED_MODULE_29_osg_KdTree__["a" /* default */];
osg.KdTreeBuilder = __WEBPACK_IMPORTED_MODULE_30_osg_KdTreeBuilder__["a" /* default */];
osg.Light = __WEBPACK_IMPORTED_MODULE_31_osg_Light__["a" /* default */];
osg.LightSource = __WEBPACK_IMPORTED_MODULE_32_osg_LightSource__["a" /* default */];
osg.LineWidth = __WEBPACK_IMPORTED_MODULE_33_osg_LineWidth__["a" /* default */];
osg.Lod = __WEBPACK_IMPORTED_MODULE_34_osg_Lod__["a" /* default */];
osg.Material = __WEBPACK_IMPORTED_MODULE_35_osg_Material__["default"];
__WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */].objectMix(osg, __WEBPACK_IMPORTED_MODULE_36_osg_math__["a" /* default */]);
osg.MatrixTransform = __WEBPACK_IMPORTED_MODULE_37_osg_MatrixTransform__["a" /* default */];
osg.PooledResource = __WEBPACK_IMPORTED_MODULE_38_osg_PooledResource__["a" /* default */];
osg.PooledArray = __WEBPACK_IMPORTED_MODULE_39_osg_PooledArray__["a" /* default */];
osg.PooledMap = __WEBPACK_IMPORTED_MODULE_40_osg_PooledMap__["a" /* default */];
osg.Node = __WEBPACK_IMPORTED_MODULE_41_osg_Node__["a" /* default */];
osg.NodeVisitor = __WEBPACK_IMPORTED_MODULE_42_osg_NodeVisitor__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */].objectMix(osg, __WEBPACK_IMPORTED_MODULE_43_osg_notify__["a" /* default */]);
osg.Object = __WEBPACK_IMPORTED_MODULE_44_osg_Object__["a" /* default */];
osg.Options = __WEBPACK_IMPORTED_MODULE_45_osg_Options__["a" /* default */];
osg.PagedLOD = __WEBPACK_IMPORTED_MODULE_46_osg_PagedLOD__["a" /* default */];
osg.Plane = __WEBPACK_IMPORTED_MODULE_49_osg_Plane__["a" /* default */];
osg.PointSizeAttribute = __WEBPACK_IMPORTED_MODULE_48_osg_PointSizeAttribute__["a" /* default */];
osg.Polytope = __WEBPACK_IMPORTED_MODULE_47_osg_Polytope__["a" /* default */];
osg.primitiveSet = __WEBPACK_IMPORTED_MODULE_52_osg_primitiveSet__["a" /* default */];
osg.primitiveFunctor = __WEBPACK_IMPORTED_MODULE_50_osg_primitiveFunctor__["a" /* default */];
osg.primitiveIndexFunctor = __WEBPACK_IMPORTED_MODULE_51_osg_primitiveIndexFunctor__["a" /* default */];
osg.Program = __WEBPACK_IMPORTED_MODULE_53_osg_Program__["a" /* default */];
osg.Projection = __WEBPACK_IMPORTED_MODULE_54_osg_Projection__["a" /* default */];
osg.RenderBin = __WEBPACK_IMPORTED_MODULE_55_osg_RenderBin__["a" /* default */];
osg.RenderLeaf = __WEBPACK_IMPORTED_MODULE_56_osg_RenderLeaf__["a" /* default */];
osg.RenderStage = __WEBPACK_IMPORTED_MODULE_57_osg_RenderStage__["a" /* default */];
osg.Shader = __WEBPACK_IMPORTED_MODULE_58_osg_Shader__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */].objectMix(osg, __WEBPACK_IMPORTED_MODULE_59_osg_shape__["a" /* default */]);
osg.StackObjectPairPool = __WEBPACK_IMPORTED_MODULE_60_osg_StackObjectPairPool__["a" /* default */];
osg.State = __WEBPACK_IMPORTED_MODULE_61_osg_State__["a" /* default */];
osg.StateAttribute = __WEBPACK_IMPORTED_MODULE_62_osg_StateAttribute__["a" /* default */];
osg.StateGraph = __WEBPACK_IMPORTED_MODULE_63_osg_StateGraph__["a" /* default */];
osg.StateSet = __WEBPACK_IMPORTED_MODULE_64_osg_StateSet__["a" /* default */];
osg.Scissor = __WEBPACK_IMPORTED_MODULE_74_osg_Scissor__["a" /* default */];
osg.Switch = __WEBPACK_IMPORTED_MODULE_65_osg_Switch__["a" /* default */];
osg.Texture = __WEBPACK_IMPORTED_MODULE_66_osg_Texture__["default"];
osg.TextureCubeMap = __WEBPACK_IMPORTED_MODULE_67_osg_TextureCubeMap__["a" /* default */];
osg.Transform = __WEBPACK_IMPORTED_MODULE_68_osg_Transform__["a" /* default */];
osg.TriangleIndexFunctor = __WEBPACK_IMPORTED_MODULE_69_osg_TriangleIndexFunctor__["a" /* default */];
osg.Uniform = __WEBPACK_IMPORTED_MODULE_70_osg_Uniform__["a" /* default */];
osg.UpdateVisitor = __WEBPACK_IMPORTED_MODULE_71_osg_UpdateVisitor__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */].objectMix(osg, __WEBPACK_IMPORTED_MODULE_72_osg_utils__["a" /* default */]);
osg.Viewport = __WEBPACK_IMPORTED_MODULE_73_osg_Viewport__["a" /* default */];
osg.VertexArrayObject = __WEBPACK_IMPORTED_MODULE_78_osg_VertexArrayObject__["a" /* default */];
osg.vec2 = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].vec2;
osg.vec3 = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].vec3;
osg.vec4 = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].vec4;
osg.quat = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].quat;
osg.mat3 = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].mat3;
osg.mat4 = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["a" /* glm */].mat4;

osg.Transform.RELATIVE_RF = __WEBPACK_IMPORTED_MODULE_75_osg_transformEnums__["a" /* default */].RELATIVE_RF;
osg.Transform.ABSOLUTE_RF = __WEBPACK_IMPORTED_MODULE_75_osg_transformEnums__["a" /* default */].ABSOLUTE_RF;
osg.Timer = __WEBPACK_IMPORTED_MODULE_76_osg_Timer__["a" /* default */];
osg.TimerGPU = __WEBPACK_IMPORTED_MODULE_77_osg_TimerGPU__["a" /* default */];
osg.WebGLCaps = __WEBPACK_IMPORTED_MODULE_79_osg_WebGLCaps__["a" /* default */];

/* harmony default export */ __webpack_exports__["default"] = (osg);


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var applyFunctionArray = [];

var registerApplyFunction = function(type, apply) {
    applyFunctionArray[type] = apply;
};

var getApplyFunction = function(type) {
    return applyFunctionArray[type];
};

/* harmony default export */ __webpack_exports__["default"] = ({
    applyFunctionArray: applyFunctionArray,
    registerApplyFunction: registerApplyFunction,
    getApplyFunction: getApplyFunction
});


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 3x3 Matrix
 * @name mat3
 */
var mat3 = {};

/**
 * Creates a new identity mat3
 *
 * @returns {mat3} a new 3x3 matrix
 */
mat3.create = function() {
    var out = new glMatrix.ARRAY_TYPE(9);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
};

/**
 * Copies the upper-left 3x3 values into the given mat3.
 *
 * @param {mat3} out the receiving 3x3 matrix
 * @param {mat4} a   the source 4x4 matrix
 * @returns {mat3} out
 */
mat3.fromMat4 = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[4];
    out[4] = a[5];
    out[5] = a[6];
    out[6] = a[8];
    out[7] = a[9];
    out[8] = a[10];
    return out;
};

/**
 * Creates a new mat3 initialized with values from an existing matrix
 *
 * @param {mat3} a matrix to clone
 * @returns {mat3} a new 3x3 matrix
 */
mat3.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(9);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};

/**
 * Copy the values from one mat3 to another
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
mat3.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};

/**
 * Create a new mat3 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} A new mat3
 */
mat3.fromValues = function(m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    var out = new glMatrix.ARRAY_TYPE(9);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
};

/**
 * Set the components of a mat3 to the given values
 *
 * @param {mat3} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m10 Component in column 1, row 0 position (index 3)
 * @param {Number} m11 Component in column 1, row 1 position (index 4)
 * @param {Number} m12 Component in column 1, row 2 position (index 5)
 * @param {Number} m20 Component in column 2, row 0 position (index 6)
 * @param {Number} m21 Component in column 2, row 1 position (index 7)
 * @param {Number} m22 Component in column 2, row 2 position (index 8)
 * @returns {mat3} out
 */
mat3.set = function(out, m00, m01, m02, m10, m11, m12, m20, m21, m22) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m10;
    out[4] = m11;
    out[5] = m12;
    out[6] = m20;
    out[7] = m21;
    out[8] = m22;
    return out;
};

/**
 * Set a mat3 to the identity matrix
 *
 * @param {mat3} out the receiving matrix
 * @returns {mat3} out
 */
mat3.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
};

/**
 * Transpose the values of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
mat3.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a12 = a[5];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a01;
        out[5] = a[7];
        out[6] = a02;
        out[7] = a12;
    } else {
        out[0] = a[0];
        out[1] = a[3];
        out[2] = a[6];
        out[3] = a[1];
        out[4] = a[4];
        out[5] = a[7];
        out[6] = a[2];
        out[7] = a[5];
        out[8] = a[8];
    }
    
    return out;
};

/**
 * Inverts a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
mat3.invert = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8],

        b01 = a22 * a11 - a12 * a21,
        b11 = -a22 * a10 + a12 * a20,
        b21 = a21 * a10 - a11 * a20,

        // Calculate the determinant
        det = a00 * b01 + a01 * b11 + a02 * b21;

    if (!det) { 
        return null; 
    }
    det = 1.0 / det;

    out[0] = b01 * det;
    out[1] = (-a22 * a01 + a02 * a21) * det;
    out[2] = (a12 * a01 - a02 * a11) * det;
    out[3] = b11 * det;
    out[4] = (a22 * a00 - a02 * a20) * det;
    out[5] = (-a12 * a00 + a02 * a10) * det;
    out[6] = b21 * det;
    out[7] = (-a21 * a00 + a01 * a20) * det;
    out[8] = (a11 * a00 - a01 * a10) * det;
    return out;
};

/**
 * Calculates the adjugate of a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the source matrix
 * @returns {mat3} out
 */
mat3.adjoint = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8];

    out[0] = (a11 * a22 - a12 * a21);
    out[1] = (a02 * a21 - a01 * a22);
    out[2] = (a01 * a12 - a02 * a11);
    out[3] = (a12 * a20 - a10 * a22);
    out[4] = (a00 * a22 - a02 * a20);
    out[5] = (a02 * a10 - a00 * a12);
    out[6] = (a10 * a21 - a11 * a20);
    out[7] = (a01 * a20 - a00 * a21);
    out[8] = (a00 * a11 - a01 * a10);
    return out;
};

/**
 * Calculates the determinant of a mat3
 *
 * @param {mat3} a the source matrix
 * @returns {Number} determinant of a
 */
mat3.determinant = function (a) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8];

    return a00 * (a22 * a11 - a12 * a21) + a01 * (-a22 * a10 + a12 * a20) + a02 * (a21 * a10 - a11 * a20);
};

/**
 * Multiplies two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
mat3.multiply = function (out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8],

        b00 = b[0], b01 = b[1], b02 = b[2],
        b10 = b[3], b11 = b[4], b12 = b[5],
        b20 = b[6], b21 = b[7], b22 = b[8];

    out[0] = b00 * a00 + b01 * a10 + b02 * a20;
    out[1] = b00 * a01 + b01 * a11 + b02 * a21;
    out[2] = b00 * a02 + b01 * a12 + b02 * a22;

    out[3] = b10 * a00 + b11 * a10 + b12 * a20;
    out[4] = b10 * a01 + b11 * a11 + b12 * a21;
    out[5] = b10 * a02 + b11 * a12 + b12 * a22;

    out[6] = b20 * a00 + b21 * a10 + b22 * a20;
    out[7] = b20 * a01 + b21 * a11 + b22 * a21;
    out[8] = b20 * a02 + b21 * a12 + b22 * a22;
    return out;
};

/**
 * Alias for {@link mat3.multiply}
 * @function
 */
mat3.mul = mat3.multiply;

/**
 * Translate a mat3 by the given vector
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to translate
 * @param {vec2} v vector to translate by
 * @returns {mat3} out
 */
mat3.translate = function(out, a, v) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8],
        x = v[0], y = v[1];

    out[0] = a00;
    out[1] = a01;
    out[2] = a02;

    out[3] = a10;
    out[4] = a11;
    out[5] = a12;

    out[6] = x * a00 + y * a10 + a20;
    out[7] = x * a01 + y * a11 + a21;
    out[8] = x * a02 + y * a12 + a22;
    return out;
};

/**
 * Rotates a mat3 by the given angle
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
mat3.rotate = function (out, a, rad) {
    var a00 = a[0], a01 = a[1], a02 = a[2],
        a10 = a[3], a11 = a[4], a12 = a[5],
        a20 = a[6], a21 = a[7], a22 = a[8],

        s = Math.sin(rad),
        c = Math.cos(rad);

    out[0] = c * a00 + s * a10;
    out[1] = c * a01 + s * a11;
    out[2] = c * a02 + s * a12;

    out[3] = c * a10 - s * a00;
    out[4] = c * a11 - s * a01;
    out[5] = c * a12 - s * a02;

    out[6] = a20;
    out[7] = a21;
    out[8] = a22;
    return out;
};

/**
 * Scales the mat3 by the dimensions in the given vec2
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat3} out
 **/
mat3.scale = function(out, a, v) {
    var x = v[0], y = v[1];

    out[0] = x * a[0];
    out[1] = x * a[1];
    out[2] = x * a[2];

    out[3] = y * a[3];
    out[4] = y * a[4];
    out[5] = y * a[5];

    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    return out;
};

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.translate(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Translation vector
 * @returns {mat3} out
 */
mat3.fromTranslation = function(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 1;
    out[5] = 0;
    out[6] = v[0];
    out[7] = v[1];
    out[8] = 1;
    return out;
}

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.rotate(dest, dest, rad);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat3} out
 */
mat3.fromRotation = function(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);

    out[0] = c;
    out[1] = s;
    out[2] = 0;

    out[3] = -s;
    out[4] = c;
    out[5] = 0;

    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat3.identity(dest);
 *     mat3.scale(dest, dest, vec);
 *
 * @param {mat3} out mat3 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat3} out
 */
mat3.fromScaling = function(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;

    out[3] = 0;
    out[4] = v[1];
    out[5] = 0;

    out[6] = 0;
    out[7] = 0;
    out[8] = 1;
    return out;
}

/**
 * Copies the values from a mat2d into a mat3
 *
 * @param {mat3} out the receiving matrix
 * @param {mat2d} a the matrix to copy
 * @returns {mat3} out
 **/
mat3.fromMat2d = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = 0;

    out[3] = a[2];
    out[4] = a[3];
    out[5] = 0;

    out[6] = a[4];
    out[7] = a[5];
    out[8] = 1;
    return out;
};

/**
* Calculates a 3x3 matrix from the given quaternion
*
* @param {mat3} out mat3 receiving operation result
* @param {quat} q Quaternion to create matrix from
*
* @returns {mat3} out
*/
mat3.fromQuat = function (out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        yx = y * x2,
        yy = y * y2,
        zx = z * x2,
        zy = z * y2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - yy - zz;
    out[3] = yx - wz;
    out[6] = zx + wy;

    out[1] = yx + wz;
    out[4] = 1 - xx - zz;
    out[7] = zy - wx;

    out[2] = zx - wy;
    out[5] = zy + wx;
    out[8] = 1 - xx - yy;

    return out;
};

/**
* Calculates a 3x3 normal matrix (transpose inverse) from the 4x4 matrix
*
* @param {mat3} out mat3 receiving operation result
* @param {mat4} a Mat4 to derive the normal matrix from
*
* @returns {mat3} out
*/
mat3.normalFromMat4 = function (out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32,

        // Calculate the determinant
        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

    if (!det) { 
        return null; 
    }
    det = 1.0 / det;

    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[2] = (a10 * b10 - a11 * b08 + a13 * b06) * det;

    out[3] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[4] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[5] = (a01 * b08 - a00 * b10 - a03 * b06) * det;

    out[6] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[7] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[8] = (a30 * b04 - a31 * b02 + a33 * b00) * det;

    return out;
};

/**
 * Returns a string representation of a mat3
 *
 * @param {mat3} mat matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
mat3.str = function (a) {
    return 'mat3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + 
                    a[3] + ', ' + a[4] + ', ' + a[5] + ', ' + 
                    a[6] + ', ' + a[7] + ', ' + a[8] + ')';
};

/**
 * Returns Frobenius norm of a mat3
 *
 * @param {mat3} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
mat3.frob = function (a) {
    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2)))
};

/**
 * Adds two mat3's
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
mat3.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    return out;
};

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @returns {mat3} out
 */
mat3.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    return out;
};

/**
 * Alias for {@link mat3.subtract}
 * @function
 */
mat3.sub = mat3.subtract;

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat3} out the receiving matrix
 * @param {mat3} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat3} out
 */
mat3.multiplyScalar = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    return out;
};

/**
 * Adds two mat3's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat3} out the receiving vector
 * @param {mat3} a the first operand
 * @param {mat3} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat3} out
 */
mat3.multiplyScalarAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    out[4] = a[4] + (b[4] * scale);
    out[5] = a[5] + (b[5] * scale);
    out[6] = a[6] + (b[6] * scale);
    out[7] = a[7] + (b[7] * scale);
    out[8] = a[8] + (b[8] * scale);
    return out;
};

/*
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat3.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && 
           a[3] === b[3] && a[4] === b[4] && a[5] === b[5] &&
           a[6] === b[6] && a[7] === b[7] && a[8] === b[8];
};

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat3} a The first matrix.
 * @param {mat3} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat3.equals = function (a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5], a6 = a[6], a7 = a[7], a8 = a[8];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5], b6 = a[6], b7 = b[7], b8 = b[8];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
            Math.abs(a6 - b6) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
            Math.abs(a7 - b7) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
            Math.abs(a8 - b8) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)));
};


module.exports = mat3;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 3 Dimensional Vector
 * @name vec3
 */
var vec3 = {};

/**
 * Creates a new, empty vec3
 *
 * @returns {vec3} a new 3D vector
 */
vec3.create = function() {
    var out = new glMatrix.ARRAY_TYPE(3);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    return out;
};

/**
 * Creates a new vec3 initialized with values from an existing vector
 *
 * @param {vec3} a vector to clone
 * @returns {vec3} a new 3D vector
 */
vec3.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(3);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
};

/**
 * Creates a new vec3 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} a new 3D vector
 */
vec3.fromValues = function(x, y, z) {
    var out = new glMatrix.ARRAY_TYPE(3);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};

/**
 * Copy the values from one vec3 to another
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the source vector
 * @returns {vec3} out
 */
vec3.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    return out;
};

/**
 * Set the components of a vec3 to the given values
 *
 * @param {vec3} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @returns {vec3} out
 */
vec3.set = function(out, x, y, z) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    return out;
};

/**
 * Adds two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    return out;
};

/**
 * Subtracts vector b from vector a
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    return out;
};

/**
 * Alias for {@link vec3.subtract}
 * @function
 */
vec3.sub = vec3.subtract;

/**
 * Multiplies two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    return out;
};

/**
 * Alias for {@link vec3.multiply}
 * @function
 */
vec3.mul = vec3.multiply;

/**
 * Divides two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    return out;
};

/**
 * Alias for {@link vec3.divide}
 * @function
 */
vec3.div = vec3.divide;

/**
 * Math.ceil the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to ceil
 * @returns {vec3} out
 */
vec3.ceil = function (out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    return out;
};

/**
 * Math.floor the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to floor
 * @returns {vec3} out
 */
vec3.floor = function (out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    return out;
};

/**
 * Returns the minimum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    return out;
};

/**
 * Returns the maximum of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    return out;
};

/**
 * Math.round the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to round
 * @returns {vec3} out
 */
vec3.round = function (out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    return out;
};

/**
 * Scales a vec3 by a scalar number
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec3} out
 */
vec3.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    return out;
};

/**
 * Adds two vec3's after scaling the second operand by a scalar value
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec3} out
 */
vec3.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    return out;
};

/**
 * Calculates the euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} distance between a and b
 */
vec3.distance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1],
        z = b[2] - a[2];
    return Math.sqrt(x*x + y*y + z*z);
};

/**
 * Alias for {@link vec3.distance}
 * @function
 */
vec3.dist = vec3.distance;

/**
 * Calculates the squared euclidian distance between two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} squared distance between a and b
 */
vec3.squaredDistance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1],
        z = b[2] - a[2];
    return x*x + y*y + z*z;
};

/**
 * Alias for {@link vec3.squaredDistance}
 * @function
 */
vec3.sqrDist = vec3.squaredDistance;

/**
 * Calculates the length of a vec3
 *
 * @param {vec3} a vector to calculate length of
 * @returns {Number} length of a
 */
vec3.length = function (a) {
    var x = a[0],
        y = a[1],
        z = a[2];
    return Math.sqrt(x*x + y*y + z*z);
};

/**
 * Alias for {@link vec3.length}
 * @function
 */
vec3.len = vec3.length;

/**
 * Calculates the squared length of a vec3
 *
 * @param {vec3} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
vec3.squaredLength = function (a) {
    var x = a[0],
        y = a[1],
        z = a[2];
    return x*x + y*y + z*z;
};

/**
 * Alias for {@link vec3.squaredLength}
 * @function
 */
vec3.sqrLen = vec3.squaredLength;

/**
 * Negates the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to negate
 * @returns {vec3} out
 */
vec3.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    return out;
};

/**
 * Returns the inverse of the components of a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to invert
 * @returns {vec3} out
 */
vec3.inverse = function(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  return out;
};

/**
 * Normalize a vec3
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a vector to normalize
 * @returns {vec3} out
 */
vec3.normalize = function(out, a) {
    var x = a[0],
        y = a[1],
        z = a[2];
    var len = x*x + y*y + z*z;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
        out[2] = a[2] * len;
    }
    return out;
};

/**
 * Calculates the dot product of two vec3's
 *
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {Number} dot product of a and b
 */
vec3.dot = function (a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
};

/**
 * Computes the cross product of two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @returns {vec3} out
 */
vec3.cross = function(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2],
        bx = b[0], by = b[1], bz = b[2];

    out[0] = ay * bz - az * by;
    out[1] = az * bx - ax * bz;
    out[2] = ax * by - ay * bx;
    return out;
};

/**
 * Performs a linear interpolation between two vec3's
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
vec3.lerp = function (out, a, b, t) {
    var ax = a[0],
        ay = a[1],
        az = a[2];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    return out;
};

/**
 * Performs a hermite interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
vec3.hermite = function (out, a, b, c, d, t) {
  var factorTimes2 = t * t,
      factor1 = factorTimes2 * (2 * t - 3) + 1,
      factor2 = factorTimes2 * (t - 2) + t,
      factor3 = factorTimes2 * (t - 1),
      factor4 = factorTimes2 * (3 - 2 * t);
  
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  
  return out;
};

/**
 * Performs a bezier interpolation with two control points
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the first operand
 * @param {vec3} b the second operand
 * @param {vec3} c the third operand
 * @param {vec3} d the fourth operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec3} out
 */
vec3.bezier = function (out, a, b, c, d, t) {
  var inverseFactor = 1 - t,
      inverseFactorTimesTwo = inverseFactor * inverseFactor,
      factorTimes2 = t * t,
      factor1 = inverseFactorTimesTwo * inverseFactor,
      factor2 = 3 * t * inverseFactorTimesTwo,
      factor3 = 3 * factorTimes2 * inverseFactor,
      factor4 = factorTimes2 * t;
  
  out[0] = a[0] * factor1 + b[0] * factor2 + c[0] * factor3 + d[0] * factor4;
  out[1] = a[1] * factor1 + b[1] * factor2 + c[1] * factor3 + d[1] * factor4;
  out[2] = a[2] * factor1 + b[2] * factor2 + c[2] * factor3 + d[2] * factor4;
  
  return out;
};

/**
 * Generates a random vector with the given scale
 *
 * @param {vec3} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec3} out
 */
vec3.random = function (out, scale) {
    scale = scale || 1.0;

    var r = glMatrix.RANDOM() * 2.0 * Math.PI;
    var z = (glMatrix.RANDOM() * 2.0) - 1.0;
    var zScale = Math.sqrt(1.0-z*z) * scale;

    out[0] = Math.cos(r) * zScale;
    out[1] = Math.sin(r) * zScale;
    out[2] = z * scale;
    return out;
};

/**
 * Transforms the vec3 with a mat4.
 * 4th vector component is implicitly '1'
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec3} out
 */
vec3.transformMat4 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2],
        w = m[3] * x + m[7] * y + m[11] * z + m[15];
    w = w || 1.0;
    out[0] = (m[0] * x + m[4] * y + m[8] * z + m[12]) / w;
    out[1] = (m[1] * x + m[5] * y + m[9] * z + m[13]) / w;
    out[2] = (m[2] * x + m[6] * y + m[10] * z + m[14]) / w;
    return out;
};

/**
 * Transforms the vec3 with a mat3.
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {mat4} m the 3x3 matrix to transform with
 * @returns {vec3} out
 */
vec3.transformMat3 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2];
    out[0] = x * m[0] + y * m[3] + z * m[6];
    out[1] = x * m[1] + y * m[4] + z * m[7];
    out[2] = x * m[2] + y * m[5] + z * m[8];
    return out;
};

/**
 * Transforms the vec3 with a quat
 *
 * @param {vec3} out the receiving vector
 * @param {vec3} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec3} out
 */
vec3.transformQuat = function(out, a, q) {
    // benchmarks: http://jsperf.com/quaternion-transform-vec3-implementations

    var x = a[0], y = a[1], z = a[2],
        qx = q[0], qy = q[1], qz = q[2], qw = q[3],

        // calculate quat * vec
        ix = qw * x + qy * z - qz * y,
        iy = qw * y + qz * x - qx * z,
        iz = qw * z + qx * y - qy * x,
        iw = -qx * x - qy * y - qz * z;

    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    return out;
};

/**
 * Rotate a 3D vector around the x-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
vec3.rotateX = function(out, a, b, c){
   var p = [], r=[];
	  //Translate point to the origin
	  p[0] = a[0] - b[0];
	  p[1] = a[1] - b[1];
  	p[2] = a[2] - b[2];

	  //perform rotation
	  r[0] = p[0];
	  r[1] = p[1]*Math.cos(c) - p[2]*Math.sin(c);
	  r[2] = p[1]*Math.sin(c) + p[2]*Math.cos(c);

	  //translate to correct position
	  out[0] = r[0] + b[0];
	  out[1] = r[1] + b[1];
	  out[2] = r[2] + b[2];

  	return out;
};

/**
 * Rotate a 3D vector around the y-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
vec3.rotateY = function(out, a, b, c){
  	var p = [], r=[];
  	//Translate point to the origin
  	p[0] = a[0] - b[0];
  	p[1] = a[1] - b[1];
  	p[2] = a[2] - b[2];
  
  	//perform rotation
  	r[0] = p[2]*Math.sin(c) + p[0]*Math.cos(c);
  	r[1] = p[1];
  	r[2] = p[2]*Math.cos(c) - p[0]*Math.sin(c);
  
  	//translate to correct position
  	out[0] = r[0] + b[0];
  	out[1] = r[1] + b[1];
  	out[2] = r[2] + b[2];
  
  	return out;
};

/**
 * Rotate a 3D vector around the z-axis
 * @param {vec3} out The receiving vec3
 * @param {vec3} a The vec3 point to rotate
 * @param {vec3} b The origin of the rotation
 * @param {Number} c The angle of rotation
 * @returns {vec3} out
 */
vec3.rotateZ = function(out, a, b, c){
  	var p = [], r=[];
  	//Translate point to the origin
  	p[0] = a[0] - b[0];
  	p[1] = a[1] - b[1];
  	p[2] = a[2] - b[2];
  
  	//perform rotation
  	r[0] = p[0]*Math.cos(c) - p[1]*Math.sin(c);
  	r[1] = p[0]*Math.sin(c) + p[1]*Math.cos(c);
  	r[2] = p[2];
  
  	//translate to correct position
  	out[0] = r[0] + b[0];
  	out[1] = r[1] + b[1];
  	out[2] = r[2] + b[2];
  
  	return out;
};

/**
 * Perform some operation over an array of vec3s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec3. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec3s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
vec3.forEach = (function() {
    var vec = vec3.create();

    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if(!stride) {
            stride = 3;
        }

        if(!offset) {
            offset = 0;
        }
        
        if(count) {
            l = Math.min((count * stride) + offset, a.length);
        } else {
            l = a.length;
        }

        for(i = offset; i < l; i += stride) {
            vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2];
            fn(vec, vec, arg);
            a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2];
        }
        
        return a;
    };
})();

/**
 * Get the angle between two 3D vectors
 * @param {vec3} a The first operand
 * @param {vec3} b The second operand
 * @returns {Number} The angle in radians
 */
vec3.angle = function(a, b) {
   
    var tempA = vec3.fromValues(a[0], a[1], a[2]);
    var tempB = vec3.fromValues(b[0], b[1], b[2]);
 
    vec3.normalize(tempA, tempA);
    vec3.normalize(tempB, tempB);
 
    var cosine = vec3.dot(tempA, tempB);

    if(cosine > 1.0){
        return 0;
    } else {
        return Math.acos(cosine);
    }     
};

/**
 * Returns a string representation of a vector
 *
 * @param {vec3} vec vector to represent as a string
 * @returns {String} string representation of the vector
 */
vec3.str = function (a) {
    return 'vec3(' + a[0] + ', ' + a[1] + ', ' + a[2] + ')';
};

/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec3.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2];
};

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec3} a The first vector.
 * @param {vec3} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec3.equals = function (a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2];
    var b0 = b[0], b1 = b[1], b2 = b[2];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)));
};

module.exports = vec3;


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 4 Dimensional Vector
 * @name vec4
 */
var vec4 = {};

/**
 * Creates a new, empty vec4
 *
 * @returns {vec4} a new 4D vector
 */
vec4.create = function() {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    return out;
};

/**
 * Creates a new vec4 initialized with values from an existing vector
 *
 * @param {vec4} a vector to clone
 * @returns {vec4} a new 4D vector
 */
vec4.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};

/**
 * Creates a new vec4 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} a new 4D vector
 */
vec4.fromValues = function(x, y, z, w) {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};

/**
 * Copy the values from one vec4 to another
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the source vector
 * @returns {vec4} out
 */
vec4.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};

/**
 * Set the components of a vec4 to the given values
 *
 * @param {vec4} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {vec4} out
 */
vec4.set = function(out, x, y, z, w) {
    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = w;
    return out;
};

/**
 * Adds two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
};

/**
 * Subtracts vector b from vector a
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
};

/**
 * Alias for {@link vec4.subtract}
 * @function
 */
vec4.sub = vec4.subtract;

/**
 * Multiplies two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    out[2] = a[2] * b[2];
    out[3] = a[3] * b[3];
    return out;
};

/**
 * Alias for {@link vec4.multiply}
 * @function
 */
vec4.mul = vec4.multiply;

/**
 * Divides two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    out[2] = a[2] / b[2];
    out[3] = a[3] / b[3];
    return out;
};

/**
 * Alias for {@link vec4.divide}
 * @function
 */
vec4.div = vec4.divide;

/**
 * Math.ceil the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to ceil
 * @returns {vec4} out
 */
vec4.ceil = function (out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    out[2] = Math.ceil(a[2]);
    out[3] = Math.ceil(a[3]);
    return out;
};

/**
 * Math.floor the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to floor
 * @returns {vec4} out
 */
vec4.floor = function (out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    out[2] = Math.floor(a[2]);
    out[3] = Math.floor(a[3]);
    return out;
};

/**
 * Returns the minimum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    out[2] = Math.min(a[2], b[2]);
    out[3] = Math.min(a[3], b[3]);
    return out;
};

/**
 * Returns the maximum of two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {vec4} out
 */
vec4.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    out[2] = Math.max(a[2], b[2]);
    out[3] = Math.max(a[3], b[3]);
    return out;
};

/**
 * Math.round the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to round
 * @returns {vec4} out
 */
vec4.round = function (out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    out[2] = Math.round(a[2]);
    out[3] = Math.round(a[3]);
    return out;
};

/**
 * Scales a vec4 by a scalar number
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec4} out
 */
vec4.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
};

/**
 * Adds two vec4's after scaling the second operand by a scalar value
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec4} out
 */
vec4.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    return out;
};

/**
 * Calculates the euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} distance between a and b
 */
vec4.distance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1],
        z = b[2] - a[2],
        w = b[3] - a[3];
    return Math.sqrt(x*x + y*y + z*z + w*w);
};

/**
 * Alias for {@link vec4.distance}
 * @function
 */
vec4.dist = vec4.distance;

/**
 * Calculates the squared euclidian distance between two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} squared distance between a and b
 */
vec4.squaredDistance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1],
        z = b[2] - a[2],
        w = b[3] - a[3];
    return x*x + y*y + z*z + w*w;
};

/**
 * Alias for {@link vec4.squaredDistance}
 * @function
 */
vec4.sqrDist = vec4.squaredDistance;

/**
 * Calculates the length of a vec4
 *
 * @param {vec4} a vector to calculate length of
 * @returns {Number} length of a
 */
vec4.length = function (a) {
    var x = a[0],
        y = a[1],
        z = a[2],
        w = a[3];
    return Math.sqrt(x*x + y*y + z*z + w*w);
};

/**
 * Alias for {@link vec4.length}
 * @function
 */
vec4.len = vec4.length;

/**
 * Calculates the squared length of a vec4
 *
 * @param {vec4} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
vec4.squaredLength = function (a) {
    var x = a[0],
        y = a[1],
        z = a[2],
        w = a[3];
    return x*x + y*y + z*z + w*w;
};

/**
 * Alias for {@link vec4.squaredLength}
 * @function
 */
vec4.sqrLen = vec4.squaredLength;

/**
 * Negates the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to negate
 * @returns {vec4} out
 */
vec4.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = -a[3];
    return out;
};

/**
 * Returns the inverse of the components of a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to invert
 * @returns {vec4} out
 */
vec4.inverse = function(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  out[2] = 1.0 / a[2];
  out[3] = 1.0 / a[3];
  return out;
};

/**
 * Normalize a vec4
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a vector to normalize
 * @returns {vec4} out
 */
vec4.normalize = function(out, a) {
    var x = a[0],
        y = a[1],
        z = a[2],
        w = a[3];
    var len = x*x + y*y + z*z + w*w;
    if (len > 0) {
        len = 1 / Math.sqrt(len);
        out[0] = x * len;
        out[1] = y * len;
        out[2] = z * len;
        out[3] = w * len;
    }
    return out;
};

/**
 * Calculates the dot product of two vec4's
 *
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @returns {Number} dot product of a and b
 */
vec4.dot = function (a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
};

/**
 * Performs a linear interpolation between two vec4's
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the first operand
 * @param {vec4} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec4} out
 */
vec4.lerp = function (out, a, b, t) {
    var ax = a[0],
        ay = a[1],
        az = a[2],
        aw = a[3];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    out[2] = az + t * (b[2] - az);
    out[3] = aw + t * (b[3] - aw);
    return out;
};

/**
 * Generates a random vector with the given scale
 *
 * @param {vec4} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec4} out
 */
vec4.random = function (out, scale) {
    scale = scale || 1.0;

    //TODO: This is a pretty awful way of doing this. Find something better.
    out[0] = glMatrix.RANDOM();
    out[1] = glMatrix.RANDOM();
    out[2] = glMatrix.RANDOM();
    out[3] = glMatrix.RANDOM();
    vec4.normalize(out, out);
    vec4.scale(out, out, scale);
    return out;
};

/**
 * Transforms the vec4 with a mat4.
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec4} out
 */
vec4.transformMat4 = function(out, a, m) {
    var x = a[0], y = a[1], z = a[2], w = a[3];
    out[0] = m[0] * x + m[4] * y + m[8] * z + m[12] * w;
    out[1] = m[1] * x + m[5] * y + m[9] * z + m[13] * w;
    out[2] = m[2] * x + m[6] * y + m[10] * z + m[14] * w;
    out[3] = m[3] * x + m[7] * y + m[11] * z + m[15] * w;
    return out;
};

/**
 * Transforms the vec4 with a quat
 *
 * @param {vec4} out the receiving vector
 * @param {vec4} a the vector to transform
 * @param {quat} q quaternion to transform with
 * @returns {vec4} out
 */
vec4.transformQuat = function(out, a, q) {
    var x = a[0], y = a[1], z = a[2],
        qx = q[0], qy = q[1], qz = q[2], qw = q[3],

        // calculate quat * vec
        ix = qw * x + qy * z - qz * y,
        iy = qw * y + qz * x - qx * z,
        iz = qw * z + qx * y - qy * x,
        iw = -qx * x - qy * y - qz * z;

    // calculate result * inverse quat
    out[0] = ix * qw + iw * -qx + iy * -qz - iz * -qy;
    out[1] = iy * qw + iw * -qy + iz * -qx - ix * -qz;
    out[2] = iz * qw + iw * -qz + ix * -qy - iy * -qx;
    out[3] = a[3];
    return out;
};

/**
 * Perform some operation over an array of vec4s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec4. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec4s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
vec4.forEach = (function() {
    var vec = vec4.create();

    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if(!stride) {
            stride = 4;
        }

        if(!offset) {
            offset = 0;
        }
        
        if(count) {
            l = Math.min((count * stride) + offset, a.length);
        } else {
            l = a.length;
        }

        for(i = offset; i < l; i += stride) {
            vec[0] = a[i]; vec[1] = a[i+1]; vec[2] = a[i+2]; vec[3] = a[i+3];
            fn(vec, vec, arg);
            a[i] = vec[0]; a[i+1] = vec[1]; a[i+2] = vec[2]; a[i+3] = vec[3];
        }
        
        return a;
    };
})();

/**
 * Returns a string representation of a vector
 *
 * @param {vec4} vec vector to represent as a string
 * @returns {String} string representation of the vector
 */
vec4.str = function (a) {
    return 'vec4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
};

/**
 * Returns whether or not the vectors have exactly the same elements in the same position (when compared with ===)
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec4.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
};

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec4} a The first vector.
 * @param {vec4} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec4.equals = function (a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
};

module.exports = vec4;


/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// jshint ignore: start

/*
 * Copyright 2010, Google Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are
 * met:
 *
 *     * Redistributions of source code must retain the above copyright
 * notice, this list of conditions and the following disclaimer.
 *     * Redistributions in binary form must reproduce the above
 * copyright notice, this list of conditions and the following disclaimer
 * in the documentation and/or other materials provided with the
 * distribution.
 *     * Neither the name of Google Inc. nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
 * "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
 * LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
 * A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
 * OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
 * SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
 * LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
 * DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
 * THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
 * OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 */

/**
 * @fileoverview This file contains functions every webgl program will need
 * a version of one way or another.
 *
 * Instead of setting up a context manually it is recommended to
 * use. This will check for success or failure. On failure it
 * will attempt to present an approriate message to the user.
 *
 *       gl = WebGLUtils.setupWebGL(canvas);
 *
 * For animated WebGL apps use of setTimeout or setInterval are
 * discouraged. It is recommended you structure your rendering
 * loop like this.
 *
 *       function render() {
 *         window.requestAnimationFrame(render, canvas);
 *
 *         // do rendering
 *         ...
 *       }
 *       render();
 *
 * This will call your rendering function up to the refresh rate
 * of your display but will stop rendering if your app is not
 * visible.
 */

var WebGLUtils = (function() {
    /**
     * Creates the HTLM for a failure message
     * @param {string} canvasContainerId id of container of th
     *        canvas.
     * @return {string} The html.
     */
    var makeFailHTML = function(msg) {
        return (
            '' +
            '<div style="margin: auto; width:500px;z-index:10000;margin-top:20em;text-align:center;">' +
            msg +
            '</div>'
        );
        // return '' +
        //   '<table style="background-color: #8CE; width: 100%; height: 100%;"><tr>' +
        //   '<td align="center">' +
        //   '<div style="display: table-cell; vertical-align: middle;">' +
        //   '<div style="">' + msg + '</div>' +
        //   '</div>' +
        //   '</td></tr></table>';
    };

    /**
     * Mesasge for getting a webgl browser
     * @type {string}
     */
    var GET_A_WEBGL_BROWSER =
        '' +
        'This page requires a browser that supports WebGL.<br/>' +
        '<a href="http://get.webgl.org">Click here to upgrade your browser.</a>';

    /**
     * Mesasge for need better hardware
     * @type {string}
     */
    var OTHER_PROBLEM =
        '' +
        "It doesn't appear your computer can support WebGL.<br/>" +
        '<a href="http://get.webgl.org">Click here for more information.</a>';

    /*
     * Allows to prevent the global canvas error code on webgl2
     * as we still have to check if we can fallback on webgl1
     */
    var doReportCreationError = true;
    /**
     * Creates a webgl context. If creation fails it will
     * change the contents of the container of the <canvas>
     * tag to an error message with the correct links for WebGL.
     * @return {WebGLRenderingContext} The created context.
     */
    var setupWebGL = function(
        /** Element */
        canvas,
        /** WebGLContextCreationAttributes */
        opt_attribs,
        /** function:(msg) */
        opt_onError
    ) {
        function handleCreationError(msg) {
            if (!doReportCreationError) return;
            var container = document.getElementsByTagName('body')[0];
            //var container = canvas.parentNode;
            if (container) {
                var str = window.WebGLRenderingContext ? OTHER_PROBLEM : GET_A_WEBGL_BROWSER;
                if (msg) {
                    str += '<br/><br/>Status: ' + msg;
                }
                container.innerHTML = makeFailHTML(str);
            }
        }

        opt_onError = opt_onError || handleCreationError;

        if (canvas.addEventListener) {
            canvas.addEventListener(
                'webglcontextcreationerror',
                function(event) {
                    opt_onError(event.statusMessage);
                },
                false
            );
        }
        var context = create3DContext(canvas, opt_attribs);
        if (!context) {
            //if ( !window.WebGLRenderingContext )
            opt_onError('');
        }

        return context;
    };

    /**
     * try to creaate webgl contexts
     * @param {Canvas} canvas The canvas tag to get context
     * @param {opt_attribs} webgl context options
     * @param {names} list of webgl context type to try
     * @return {!WebGLContext} The created context.
     */
    var checkAndCreate3DContext = function(canvas, opt_attribs, names) {
        var context = null;
        for (var ii = 0; ii < names.length; ++ii) {
            try {
                context = canvas.getContext(names[ii], opt_attribs);
            } catch (e) {}
            if (context) {
                break;
            }
        }
        return context;
    };

    /**
     * Creates a webgl context.
     * @param !Canvas} canvas The canvas tag to get context
     * @param {!opt_attribs} webgl context options
     * @return {!WebGLContext} The created context.
     */
    var create3DContext = function(canvas, opt_attribs) {
        var context;
        // only try to enable if URl options ?webgl2=1
        if (opt_attribs && opt_attribs.webgl2) {
            doReportCreationError = false;
            context = checkAndCreate3DContext(canvas, opt_attribs, [
                'webgl2',
                'experimental-webgl2'
            ]);
            if (context) return context;
            doReportCreationError = true;
        }
        return checkAndCreate3DContext(canvas, opt_attribs, [
            'webgl',
            'experimental-webgl',
            'webkit-3d',
            'moz-webgl'
        ]);
    };

    return {
        create3DContext: create3DContext,
        setupWebGL: setupWebGL
    };
})();

/**
 * Provides requestAnimationFrame in a cross browser
 * way.
 */
if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = (function() {
        return (
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            window.oRequestAnimationFrame ||
            window.msRequestAnimationFrame ||
            function(
                /* function FrameRequestCallback */ callback,
                /* DOMElement Element */ element
            ) {
                window.setTimeout(callback, 1000 / 60);
            }
        );
    })();
}

if (!window.cancelRequestAnimFrame) {
    window.cancelAnimationFrame = (function() {
        return (
            window.cancelAnimationFrame ||
            window.webkitCancelRequestAnimationFrame ||
            window.mozCancelRequestAnimationFrame ||
            window.oCancelRequestAnimationFrame ||
            window.msCancelRequestAnimationFrame ||
            clearTimeout
        );
    })();
}

if (!Date.now) {
    Date.now = function now() {
        return new Date().getTime();
    };
}

/* harmony default export */ __webpack_exports__["a"] = (WebGLUtils);


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Polytope__ = __webpack_require__(75);


var CullingSet = function() {
    this._mask = CullingSet.DEFAULT_CULLING;
    this._frustum = new __WEBPACK_IMPORTED_MODULE_0_osg_Polytope__["a" /* default */]();
};

CullingSet.prototype = {
    reset: function() {
        this._mask = CullingSet.DEFAULT_CULLING;
        this._frustum.clear();
    },
    setCullingMask: function(mask) {
        this._mask = mask;
    },
    getCullingMask: function() {
        return this._mask;
    },
    setFrustum: function(frustum) {
        this._frustum = frustum;
    },
    getFrustum: function() {
        return this._frustum;
    },
    getCurrentResultMask: function() {
        return this._frustum.getCurrentMask();
    },
    pushCurrentMask: function() {
        this._frustum.pushCurrentMask();
    },
    popCurrentMask: function() {
        this._frustum.popCurrentMask();
    },
    resetCullingMask: function() {
        this._frustum.setResultMask(this._frustum.getCurrentMask());
    },
    isBoundingBoxCulled: function(bbox) {
        if (this._mask & CullingSet.VIEW_FRUSTUM_CULLING) {
            // is it outside the view frustum...
            if (!this._frustum.containsBoundingBox(bbox)) return true;
        }
        return false;
    },
    isBoundingSphereCulled: function(bs) {
        if (this._mask & CullingSet.VIEW_FRUSTUM_CULLING) {
            // is it outside the view frustum...
            if (!this._frustum.containsBoundingSphere(bs)) return true;
        }
        return false;
    },
    isVerticesCulled: function(vertices) {
        if (this._mask & CullingSet.VIEW_FRUSTUM_CULLING) {
            // is it outside the view frustum...
            if (!this._frustum.containsVertices(vertices)) return true;
        }
        return false;
    }
};

CullingSet.NO_CULLING = 0x0;

CullingSet.VIEW_FRUSTUM_LEFT_CULLING = 0x1;
CullingSet.VIEW_FRUSTUM_RIGHT_CULLING = 0x2;
CullingSet.VIEW_FRUSTUM_TOP_CULLING = 0x3;
CullingSet.VIEW_FRUSTUM_BOTTOM_CULLING = 0x4;
CullingSet.NEAR_PLANE_CULLING = 0x5;
CullingSet.FAR_PLANE_CULLING = 0x6;

CullingSet.VIEW_FRUSTUM_SIDES_CULLING =
    CullingSet.VIEW_FRUSTUM_LEFT_CULLING |
    CullingSet.VIEW_FRUSTUM_RIGHT_CULLING |
    CullingSet.VIEW_FRUSTUM_BOTTOM_CULLING |
    CullingSet.VIEW_FRUSTUM_TOP_CULLING;

CullingSet.VIEW_FRUSTUM_CULLING =
    CullingSet.VIEW_FRUSTUM_SIDES_CULLING |
    CullingSet.NEAR_PLANE_CULLING |
    CullingSet.FAR_PLANE_CULLING;

CullingSet.DEFAULT_CULLING = CullingSet.VIEW_FRUSTUM_SIDES_CULLING;

CullingSet.ENABLE_ALL_CULLING = CullingSet.VIEW_FRUSTUM_CULLING;

/* harmony default export */ __webpack_exports__["a"] = (CullingSet);


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_computeMatrixFromNodePath__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_CullSettings__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_CullingSet__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_PooledMap__ = __webpack_require__(59);















var createCullingSet = function() {
    return new __WEBPACK_IMPORTED_MODULE_5_osg_CullingSet__["a" /* default */]();
};

var CullStack = function() {
    this._modelViewMatrixStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();
    this._projectionMatrixStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();
    this._viewportStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();
    this._cullingSetStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();
    this._frustumVolume = -1.0;
    this._bbCornerFar = 0;
    this._bbCornerNear = 0;

    // keep a matrix in memory to avoid to create matrix
    this._pooledMatrix = new __WEBPACK_IMPORTED_MODULE_11_osg_PooledResource__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create);

    this._pooledCullingSet = new __WEBPACK_IMPORTED_MODULE_11_osg_PooledResource__["a" /* default */](createCullingSet);

    // data for caching camera matrix inverse for computation of world/view
    // contains index of the camera node in the nodepath
    this._cameraIndexStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();

    // contains index of the camera modelview matrix in the modelViewMatrixStack
    this._cameraModelViewIndexStack = new __WEBPACK_IMPORTED_MODULE_10_osg_PooledArray__["a" /* default */]();

    // contains the id has a key to computed Inverse Matrix
    this._cameraMatrixInverse = new __WEBPACK_IMPORTED_MODULE_12_osg_PooledMap__["a" /* default */]();
    this._cameraMatrixInverseRoot = undefined;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CullStack,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osg_CullSettings__["a" /* default */].prototype, {
        reset: function() {
            this._modelViewMatrixStack.reset();
            this._projectionMatrixStack.reset();
            this._cullingSetStack.reset();

            this._pooledMatrix.reset();
            this._pooledCullingSet.reset();

            this._cameraModelViewIndexStack.reset();
            this._cameraIndexStack.reset();

            this._cameraMatrixInverse.reset();

            this._cameraMatrixInverseRoot = undefined;
        },

        getProjectionMatrixStack: function() {
            return this._projectionMatrixStack;
        },
        getCurrentProjectionMatrix: function() {
            return this._projectionMatrixStack.back();
        },

        getCurrentModelViewMatrix: function() {
            return this._modelViewMatrixStack.back();
        },

        getCameraInverseMatrix: function() {
            // Return or compute and cache the MatrixInverse of the last
            // active camera in absolute reference

            // if no index the camera inverse is the root with an fake id
            if (!this._cameraIndexStack.getLength()) return this._cameraMatrixInverseRoot;

            var idx = this._cameraIndexStack.back();

            // get the camera node
            var camera = this.getNodePath()[idx];
            var id = camera.getInstanceID();

            var mapCameraInverse = this._cameraMatrixInverse.getMap();
            var cameraInverse = mapCameraInverse[id];

            if (cameraInverse === undefined) {
                var indexInModelViewMatrixStack = this._cameraModelViewIndexStack.back();
                var mat = this._modelViewMatrixStack.getArray()[indexInModelViewMatrixStack];
                cameraInverse = this._pooledMatrix.getOrCreateObject();
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].invert(cameraInverse, mat);
                this._cameraMatrixInverse.set(id, cameraInverse);
            }
            return cameraInverse;
        },

        getCurrentModelMatrix: function() {
            // Improvment could be to cache more things
            // and / or use this method only if the shader use it
            var invMatrix = this.getCameraInverseMatrix();
            var m = this._pooledMatrix.getOrCreateObject();
            var world = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(m, invMatrix, this.getCurrentModelViewMatrix());
            return world;
        },

        getCurrentViewMatrix: function() {
            // Improvment could be to cache more things
            // and / or use this method only if the shader use it
            var modelViewMatrixStackArray = this._modelViewMatrixStack.getArray();
            if (!this._cameraIndexStack.getLength()) return modelViewMatrixStackArray[0];

            // also we could keep the index of the current to avoid lenght-1 at each access
            // it's implemented in osg like that:
            // https://github.com/openscenegraph/osg/blob/master/include/osg/fast_back_stack
            return modelViewMatrixStackArray[this._cameraModelViewIndexStack.back()];
        },

        getViewport: function() {
            if (this._viewportStack.getLength() === 0) {
                return undefined;
            }
            return this._viewportStack.back();
        },
        getLookVectorLocal: function(outLookVector) {
            var lookVectorLocal = this.getCurrentModelViewMatrix();
            return __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].set(
                outLookVector,
                -lookVectorLocal[2],
                -lookVectorLocal[6],
                -lookVectorLocal[10]
            );
        },
        pushViewport: function(vp) {
            this._viewportStack.push(vp);
        },
        popViewport: function() {
            this._viewportStack.pop();
        },

        getFrustumPlanes: (function() {
            var mvp = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();

            return function(out, projection, view, withNearFar) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(mvp, projection, view);

                var computeNearFar = !!withNearFar;

                // Right clipping plane.
                var right = out[0];
                right[0] = mvp[3] - mvp[0];
                right[1] = mvp[7] - mvp[4];
                right[2] = mvp[11] - mvp[8];
                right[3] = mvp[15] - mvp[12];

                // Left clipping plane.
                var left = out[1];
                left[0] = mvp[3] + mvp[0];
                left[1] = mvp[7] + mvp[4];
                left[2] = mvp[11] + mvp[8];
                left[3] = mvp[15] + mvp[12];

                // Bottom clipping plane.
                var bottom = out[2];
                bottom[0] = mvp[3] + mvp[1];
                bottom[1] = mvp[7] + mvp[5];
                bottom[2] = mvp[11] + mvp[9];
                bottom[3] = mvp[15] + mvp[13];

                // Top clipping plane.
                var top = out[3];
                top[0] = mvp[3] - mvp[1];
                top[1] = mvp[7] - mvp[5];
                top[2] = mvp[11] - mvp[9];
                top[3] = mvp[15] - mvp[13];

                if (computeNearFar) {
                    // Far clipping plane.
                    var far = out[4];
                    far[0] = mvp[3] - mvp[2];
                    far[1] = mvp[7] - mvp[6];
                    far[2] = mvp[11] - mvp[10];
                    far[3] = mvp[15] - mvp[14];

                    // Near clipping plane.
                    var near = out[5];
                    near[0] = mvp[3] + mvp[2];
                    near[1] = mvp[7] + mvp[6];
                    near[2] = mvp[11] + mvp[10];
                    near[3] = mvp[15] + mvp[14];
                }

                //Normalize the planes
                var j = withNearFar ? 6 : 4;
                for (var i = 0; i < j; i++) {
                    __WEBPACK_IMPORTED_MODULE_7_osg_Plane__["a" /* default */].normalizeEquation(out[i]);
                }
            };
        })(),

        pushCullingSet: function() {
            var cs = this._pooledCullingSet.getOrCreateObject();
            if (this._enableFrustumCulling) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].getFrustumPlanes(
                    cs.getFrustum().getPlanes(),
                    this.getCurrentProjectionMatrix(),
                    this.getCurrentModelViewMatrix(),
                    false
                );
                // TODO: no far no near.
                // should check if we have them
                // should add at least a near 0 clip if not
                cs.getFrustum().setupMask(4);
            }

            this._cullingSetStack.push(cs);
        },
        popCullingSet: function() {
            return this._cullingSetStack.pop();
        },
        getCurrentCullingSet: function() {
            return this._cullingSetStack.back();
        },

        pushCurrentMask: function() {
            var cs = this.getCurrentCullingSet();
            if (cs) cs.pushCurrentMask();
        },
        popCurrentMask: function() {
            var cs = this.getCurrentCullingSet();
            if (cs) cs.popCurrentMask();
        },

        isVerticesCulled: function(vertices) {
            if (!this._enableFrustumCulling) return false;
            return this.getCurrentCullingSet().isVerticesCulled(vertices);
        },

        isBoundingBoxCulled: function(bb) {
            if (!this._enableFrustumCulling) return false;
            return bb.valid() && this.getCurrentCullingSet().isBoundingBoxCulled(bb);
        },

        isBoundingSphereCulled: function(bs) {
            if (!this._enableFrustumCulling) return false;
            return bs.valid() && this.getCurrentCullingSet().isBoundingSphereCulled(bs);
        },

        isCulled: (function() {
            var bsWorld = new __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__["a" /* default */]();
            return function(node, nodePath) {
                if (!this._enableFrustumCulling) return false;
                if (node.isCullingActive()) {
                    if (this.getCurrentCullingSet().getCurrentResultMask() === 0) return false; // father bounding sphere totally inside

                    var matrix = this._pooledMatrix.getOrCreateObject();
                    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].identity(matrix);

                    var maxNodePathLength = nodePath.length;
                    if (node instanceof __WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */]) {
                        // MatrixTransform getBound is already transformed to
                        // its local space whereas nodepath also have its matrix ...
                        // so to get world space, you HAVE to remove that matrix from nodePATH
                        maxNodePathLength--;
                    }

                    __WEBPACK_IMPORTED_MODULE_3_osg_computeMatrixFromNodePath__["a" /* default */].computeLocalToWorld(
                        nodePath,
                        true,
                        matrix,
                        maxNodePathLength
                    );

                    node.getBound().transformMat4(bsWorld, matrix);

                    return this.getCurrentCullingSet().isBoundingSphereCulled(bsWorld);
                } else {
                    this.getCurrentCullingSet().resetCullingMask();
                    return false;
                }
            };
        })(),

        pushModelViewMatrix: (function() {
            var lookVector = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            return function(matrix) {
                // When pushing a matrix, it can be a transform or camera. To compute
                // differents matrix type in shader ( ViewMatrix/ModelMatrix/ModelViewMatrix )
                // we track camera node when using pushModelViewMatrix
                // To detect a camera, we check on the nodepath the type of the node and if the
                // camera is relatif or absolute.
                // When we detect an absolute camera we keep it's index to get it when needed to
                // compute the World/View matrix
                // Th    ere is an exception for the root camera, the root camera is not pushed on the
                // CullVisitor but only its matrixes, so to handle this we compute the inverse camera
                // when the nodepath has a lenght of 0
                // To avoid to compute too much inverse matrix, we keep a cache of them during the
                // traverse and store the result under the instanceID key, except for the root
                var np = this.getNodePath();
                var length = np.length;
                if (!length) {
                    // root
                    var matInverse = this._pooledMatrix.getOrCreateObject();
                    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].invert(matInverse, matrix);
                    this._cameraMatrixInverseRoot = matInverse;
                } else {
                    var index = length - 1;
                    if (
                        np[index].getTypeID() === __WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */].getTypeID() &&
                        np[index].getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_9_osg_transformEnums__["a" /* default */].ABSOLUTE_RF
                    ) {
                        this._cameraIndexStack.push(index);
                        this._cameraModelViewIndexStack.push(
                            this._modelViewMatrixStack.getLength()
                        );
                    }
                }

                this._modelViewMatrixStack.push(matrix);
                this.getLookVectorLocal(lookVector);

                /*jshint bitwise: false */
                this._bbCornerFar =
                    (lookVector[0] >= 0 ? 1 : 0) |
                    (lookVector[1] >= 0 ? 2 : 0) |
                    (lookVector[2] >= 0 ? 4 : 0);
                this._bbCornerNear = ~this._bbCornerFar & 7;
                /*jshint bitwise: true */
            };
        })(),
        popModelViewMatrix: (function() {
            var lookVector = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();

            return function() {
                // if same index it's a camera and we have to pop it
                var np = this.getNodePath();
                var index = np.length - 1;
                if (this._cameraIndexStack.getLength() && index === this._cameraIndexStack.back()) {
                    this._cameraIndexStack.pop();
                    this._cameraModelViewIndexStack.pop();
                }

                this._modelViewMatrixStack.pop();

                if (this._modelViewMatrixStack.getLength()) {
                    this.getLookVectorLocal(lookVector);
                } else {
                    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].set(lookVector, 0.0, 0.0, -1.0);
                }

                /*jshint bitwise: false */
                this._bbCornerFar =
                    (lookVector[0] >= 0.0 ? 1.0 : 0.0) |
                    (lookVector[1] >= 0 ? 2.0 : 0.0) |
                    (lookVector[2] >= 0 ? 4.0 : 0.0);
                this._bbCornerNear = ~this._bbCornerFar & 7;
                /*jshint bitwise: true */
            };
        })(),

        pushProjectionMatrix: function(matrix) {
            this._projectionMatrixStack.push(matrix);

            // need to recompute frustum volume.
            this._frustumVolume = -1.0;

            this.pushCullingSet();
        },
        popProjectionMatrix: function() {
            this._projectionMatrixStack.pop();

            // need to recompute frustum volume.
            this._frustumVolume = -1.0;

            this.popCullingSet();
        }
    }),
    'osg',
    'CullStack'
);

/* harmony default export */ __webpack_exports__["a"] = (CullStack);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_StateGraph__ = __webpack_require__(78);


// just use inline function, it's faster than having the test in the code
var applyUniformCache = [
    // apply just modelview and projection
    function(state, modelview, model, view, projection) {
        state.applyModelViewMatrix(modelview, model);
        state.applyProjectionMatrix(projection);
    },

    // apply model
    function(state, modelview, model, view, projection) {
        var gl = state.getGraphicContext();
        var matrixModelViewChanged = state.applyModelViewMatrix(modelview, model);
        state.applyProjectionMatrix(projection);

        if (matrixModelViewChanged) {
            var modelMatrix = state._modelMatrix;
            modelMatrix.setMatrix4(model);
            modelMatrix.apply(gl, this.modelUniform);
        }
    },

    // apply view
    function(state, modelview, model, view, projection) {
        var gl = state.getGraphicContext();
        var matrixModelViewChanged = state.applyModelViewMatrix(modelview, model);
        state.applyProjectionMatrix(projection);

        if (matrixModelViewChanged) {
            var viewMatrix = state._viewMatrix;
            viewMatrix.setMatrix4(view);
            viewMatrix.apply(gl, this.viewUniform);
        }
    },

    // applyModelAndViewUniform
    function(state, modelview, model, view, projection) {
        var gl = state.getGraphicContext();
        var matrixModelViewChanged = state.applyModelViewMatrix(modelview, model);
        state.applyProjectionMatrix(projection);

        if (matrixModelViewChanged) {
            var modelMatrix = state._modelMatrix;
            modelMatrix.setMatrix4(model);
            modelMatrix.apply(gl, this.modelUniform);

            var viewMatrix = state._viewMatrix;
            viewMatrix.setMatrix4(view);
            viewMatrix.apply(gl, this.viewUniform);
        }
    }
];

var CacheUniformApply = function(state, program) {
    this.modelUniform = program._uniformsCache[state._modelMatrix.getName()];
    this.viewUniform = program._uniformsCache[state._viewMatrix.getName()];

    var cacheIndex = 0;
    if (this.modelUniform) cacheIndex = 1;
    if (this.viewUniform) cacheIndex |= 2;

    this.apply = applyUniformCache[cacheIndex];
};

var RenderLeaf = function() {
    this._parent = undefined;
    this._geometry = undefined;
    this._depth = 0.0;

    this._projection = undefined;
    this._view = undefined;
    this._model = undefined;
    this._modelView = undefined;
};

RenderLeaf.prototype = {
    reset: function() {
        this._parent = undefined;
        this._geometry = undefined;
        this._depth = 0.0;

        this._projection = undefined;
        this._view = undefined;
        this._model = undefined;
        this._modelView = undefined;
    },

    init: function(parent, geom, projection, view, modelView, model, depth) {
        this._parent = parent;
        this._geometry = geom;
        this._depth = depth;

        this._projection = projection;
        this._view = view;
        this._model = model;
        this._modelView = modelView;
    },

    drawGeometry: (function() {
        return function(state) {
            var program = state.getLastProgramApplied();
            var programInstanceID = program.getInstanceID();
            var cache = state.getCacheUniformsApplyRenderLeaf();
            var obj = cache[programInstanceID];

            if (!obj) {
                obj = new CacheUniformApply(state, program);
                cache[programInstanceID] = obj;
            }

            obj.apply(state, this._modelView, this._model, this._view, this._projection);

            this._geometry.drawImplementation(state);
        };
    })(),

    render: (function() {
        var idLastDraw = 0;
        var lastStateSetStackSize = -1;

        return function(state, previousLeaf) {
            var prevRenderGraph;
            var prevRenderGraphParent;
            var curRenderGraph = this._parent;
            var curRenderGraphParent = curRenderGraph._parent;
            var curRenderGraphStateSet = curRenderGraph._stateset;

            // When rendering a RenderLeaf we try to limit the state change
            // to do that Graph of State is created during the culling pass.
            // this graph contains nodes of StateGraph type see the class StateGraph
            //
            // So to limit switching of StateSet we check where are the common parent
            // between previous RenderLeaf and this current.
            //
            // There are 3 cases when there is a prev / current render leaf
            //
            //
            // pRG: previousRenderGraph
            // cRG: currentRenderGraph
            // pRL: previousRenderLeaf
            // cRL: currentRenderLeaf
            // each RG contains a StateSet
            //
            //          A                        B                       C
            // +-----+     +-----+            +-----+                 +-----+
            // | pRG |     | cRG |         +--+ RG  +--+              | RG  |
            // +--+--+     +--+--+         |  +-----+  |              +--+--+
            //    |           |            |           |                 |
            // +--v--+     +--v--+      +--v--+     +--v--+           +--v--+
            // | pRG |     | cRG |      | pRG |     | cRG |        +--+ RG  +--+
            // +--+--+     +--+--+      +--+--+     +--+--+        |  +-----+  |
            //    |           |            |           |           |           |
            // +--v--+     +--v--+      +--v--+     +--v--+     +--v--+     +--v--+
            // | pRL |     | cRL |      | pRL |     | cRL |     | pRL |     | cRL |
            // +-----+     +-----+      +-----+     +-----+     +-----+     +-----+
            //
            //
            // Case A
            // no common parent StateGraphNode we need to
            // popStateSet until we find the common parent and then
            // pushStateSet from the common parent to the current
            // RenderLeaf
            //
            // Case B
            // common parent StateGraphNode so we apply the current stateSet
            //
            // Case C
            // the StateGraphNode is common to the previous RenderLeaf so we dont need
            // to do anything except if we used an insertStateSet
            //

            if (previousLeaf !== undefined) {
                // apply state if required.
                prevRenderGraph = previousLeaf._parent;
                prevRenderGraphParent = prevRenderGraph._parent;

                if (prevRenderGraphParent !== curRenderGraphParent) {
                    // Case A
                    __WEBPACK_IMPORTED_MODULE_0_osg_StateGraph__["a" /* default */].moveStateGraph(state, prevRenderGraphParent, curRenderGraphParent);

                    state.applyStateSet(curRenderGraphStateSet);
                } else if (curRenderGraph !== prevRenderGraph) {
                    // Case B
                    state.applyStateSet(curRenderGraphStateSet);
                } else {
                    // Case C

                    // in osg we call apply but actually we dont need
                    // except if the stateSetStack changed.
                    // for example if insert/remove StateSet has been used
                    if (state._stateSetStackChanged(idLastDraw, lastStateSetStackSize)) {
                        state.applyStateSet(curRenderGraphStateSet);
                    }
                }
            } else {
                __WEBPACK_IMPORTED_MODULE_0_osg_StateGraph__["a" /* default */].moveStateGraph(state, undefined, curRenderGraphParent);
                state.applyStateSet(curRenderGraphStateSet);
            }

            state._setStateSetsDrawID(++idLastDraw);
            lastStateSetStackSize = state.getStateSetStackSize();

            this.drawGeometry(state);
        };
    })()
};

/* harmony default export */ __webpack_exports__["a"] = (RenderLeaf);


/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__ = __webpack_require__(3);




/**
 *  Switch that can switch on and off separate children
 *  @class Switch
 */
var Switch = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);
    // This list of bools is effectively a bit mask.
    this._values = [];
};

/** @lends Switch.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeNode(
    Switch,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        addChild: function(node, value) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype.addChild.call(this, node);

            if (value === undefined) value = true;

            if (this.children.length > this._values.length) {
                this._values.push(value);
            } else {
                this._values[this.children.length - 1] = value;
            }
            return true;
        },

        setValue: function(index, value) {
            if (index < this._values.length) {
                this._values[index] = value;
            }
        },

        getValue: function(index) {
            if (index < this._values.length) {
                return this._values[index];
            }
        },

        setAllChildrenOff: function() {
            for (var i = 0; i < this._values.length; ++i) {
                this._values[i] = false;
            }
        },

        setAllChildrenOn: function() {
            for (var i = 0; i < this._values.length; ++i) {
                this._values[i] = true;
            }
        },

        traverse: (function() {
            return function(visitor) {
                var traversalMode = visitor.traversalMode;

                switch (traversalMode) {
                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN:
                        for (var i = 0; i < this.children.length; ++i) {
                            this.children[i].accept(visitor);
                        }
                        break;

                    case __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ACTIVE_CHILDREN:
                        var numChildren = this.children.length;
                        if (this._values.length < numChildren) numChildren = this._values.length;

                        for (i = 0; i < numChildren; ++i) {
                            if (this._values[i] === true) {
                                this.children[i].accept(visitor);
                            }
                        }
                        break;

                    default:
                        break;
                }
            };
        })()
    }),
    'osg',
    'Switch'
);

/* harmony default export */ __webpack_exports__["a"] = (Switch);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgAnimation_Bone__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Object__ = __webpack_require__(6);






/**
 *  ValidateSkeletonVisitor
 *  @class ValidateSkeletonVisitor
 */
var ValidateSkeletonVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].call(this);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ValidateSkeletonVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getTypeID() !== __WEBPACK_IMPORTED_MODULE_1_osgAnimation_Bone__["a" /* default */].getTypeID()) {
                return;
            }
            var foundNonBone = false;

            var children = node.getChildren();
            for (var i = 0, l = node.getChildren().length; i < l; i++) {
                var child = children[i];
                if (child.getTypeID() === __WEBPACK_IMPORTED_MODULE_1_osgAnimation_Bone__["a" /* default */].getTypeID()) {
                    if (foundNonBone) {
                        __WEBPACK_IMPORTED_MODULE_3_osg_notify__["a" /* default */].warn(
                            'Warning: a Bone was found after a non-Bone child ' +
                                'within a Skeleton. Children of a Bone must be ordered ' +
                                'with all child Bones first for correct update order.'
                        );
                        //this.traversalMode = NodeVisitor.TRAVERSE_NONE;
                        return;
                    }
                } else {
                    foundNonBone = true;
                }
            }
            this.traverse(node);
        }
    }),
    'osgAnimation',
    'ValidateSkeletonVisitor'
);

var compareBone = function(x, y) {
    var a = x instanceof __WEBPACK_IMPORTED_MODULE_1_osgAnimation_Bone__["a" /* default */] ? 0 : 1;
    var b = y instanceof __WEBPACK_IMPORTED_MODULE_1_osgAnimation_Bone__["a" /* default */] ? 0 : 1;

    return a - b;
};

/**
 *  UpdateSkeleton
 *  @class UpdateSkeleton
 */
var UpdateSkeleton = function() {
    this._needValidate = true;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateSkeleton,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osg_Object__["a" /* default */].prototype, {
        needToValidate: function() {
            return this._needValidate;
        },

        update: function(node, nv) {
            if (this._needValidate && nv.getVisitorType() === __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].UPDATE_VISITOR) {
                if (node.className && node.className() === 'Skeleton') {
                    var validateSkeletonVisitor = new ValidateSkeletonVisitor();
                    var children = node.getChildren();
                    for (var i = 0, l = children.length; i < l; i++) {
                        var child = children[i];
                        child.accept(validateSkeletonVisitor);
                    }

                    //Re-order skeleton children to force correct bones update, we should put bones first
                    children.sort(compareBone);

                    this._needValidate = false;
                }
            }
            return true;
        }
    }),
    'osgAnimation',
    'UpdateSkeleton'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateSkeleton);


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);




/**
 * MorphAttribute encapsulate Animation State
 * @class MorphAttribute
 * @inherits StateAttribute
 */
var MorphAttribute = function(nbTarget, disable) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._nbTarget = nbTarget;
    this._enable = !disable;

    this._targetNames = {};
    this._hashNames = ''; // compute only once target hash names

    this._hash = ''; // cache of hash
    this._dirtyHash = true;
};

MorphAttribute.uniforms = {};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    MorphAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Morph',

        cloneType: function() {
            return new MorphAttribute(undefined, true);
        },

        hasTarget: function(name) {
            return !!this._targetNames[name];
        },

        copyTargetNames: function(names) {
            var tNames = this._targetNames;
            var hash = '';
            var nbNames = (tNames.length = names.length);

            for (var i = 0; i < nbNames; ++i) {
                var att = names[i];
                tNames[att] = true;
                hash += att;
            }

            this._hashNames = hash;
            this._dirtyHash = true;
        },

        getOrCreateUniforms: function() {
            var obj = MorphAttribute;
            var unifHash = this.getNumTargets();

            if (obj.uniforms[unifHash]) return obj.uniforms[unifHash];

            obj.uniforms[unifHash] = {
                uTargetWeights: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4('uTargetWeights')
            };

            return obj.uniforms[unifHash];
        },

        setNumTargets: function(nb) {
            this._nbTarget = nb;
            this._dirtyHash = true;
        },

        getNumTargets: function() {
            return this._nbTarget;
        },

        setTargetWeights: function(targetWeight) {
            this._targetWeights = targetWeight;
        },

        getTargetWeights: function() {
            return this._targetWeights;
        },

        isEnabled: function() {
            return this._enable;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },

        _computeInternalHash: function() {
            return this.getTypeMember() + this._hashNames + this.getNumTargets() + this.isEnabled();
        },

        apply: function() {
            if (!this._enable) return;

            var uniformMap = this.getOrCreateUniforms();
            uniformMap.uTargetWeights.setFloat4(this._targetWeights);
        }
    }),
    'osgAnimation',
    'MorphAttribute'
);

/* harmony default export */ __webpack_exports__["a"] = (MorphAttribute);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);




/**
 * SkinningAttribute encapsulate Animation State
 * @class SkinningAttribute
 * @inherits StateAttribute
 */
var SkinningAttribute = function(disable, boneUniformSize) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._enable = !disable;
    // optional, if it's not provided, it will fall back to the maximum bone uniform size
    // boneUniformSize represents the number of vec4 (uniform) used in the shader for all the bones
    this._boneUniformSize = boneUniformSize;

    this._dirtyHash = true;
    this._hash = '';
};

SkinningAttribute.uniforms = {};
SkinningAttribute.maxBoneUniformSize = 1;
SkinningAttribute.maxBoneUniformAllowed = Infinity; // can be overriden by application specific limit on startup (typically gl limit)

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    SkinningAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Skinning',

        cloneType: function() {
            return new SkinningAttribute(true);
        },

        getBoneUniformSize: function() {
            return this._boneUniformSize !== undefined
                ? this._boneUniformSize
                : SkinningAttribute.maxBoneUniformSize;
        },

        getOrCreateUniforms: function() {
            var obj = SkinningAttribute;
            var boneSize = this.getBoneUniformSize();

            if (obj.uniforms[boneSize]) return obj.uniforms[boneSize];

            obj.uniforms[boneSize] = {
                uBones: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat4Array('uBones', boneSize)
            };

            return obj.uniforms[boneSize];
        },

        setMatrixPalette: function(matrixPalette) {
            this._matrixPalette = matrixPalette;
            // update max bone size
            if (this._boneUniformSize === undefined) {
                SkinningAttribute.maxBoneUniformSize = Math.max(
                    SkinningAttribute.maxBoneUniformSize,
                    matrixPalette.length / 4
                );
                SkinningAttribute.maxBoneUniformSize = Math.min(
                    SkinningAttribute.maxBoneUniformAllowed,
                    SkinningAttribute.maxBoneUniformSize
                );
            }
        },

        getMatrixPalette: function() {
            return this._matrixPalette;
        },

        // need a isEnabled to let the ShaderGenerator to filter
        // StateAttribute from the shader compilation
        isEnabled: function() {
            return this._enable;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = true;
            return this._hash;
        },

        _computeInternalHash: function() {
            // bone uniform size is hashed because the size of uniform is statically declared in the shader
            return this.getTypeMember() + this.getBoneUniformSize() + this.isEnabled();
        },

        apply: function() {
            if (!this._enable) return;

            this.getOrCreateUniforms()
                .uBones.getInternalArray()
                .set(this._matrixPalette);
        }
    }),
    'osgAnimation',
    'SkinningAttribute'
);

/* harmony default export */ __webpack_exports__["a"] = (SkinningAttribute);


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * DrawArrayLengths manage rendering primitives
 * @class DrawArrayLengths
 */
var DrawArrayLengths = function(mode, first, array) {
    this._mode = mode;
    this._first = first;
    this._arrayLengths = array.slice(0);
};

/** @lends DrawArrayLengths.prototype */
DrawArrayLengths.prototype = {
    draw: function(state) {
        var gl = state.getGraphicContext();
        var mode = this._mode;
        var first = this._first;
        var array = this._arrayLengths;
        for (var i = 0, l = array.length; i < l; i++) {
            var count = array[i];
            gl.drawArrays(mode, first, count);
            first += count;
        }
    },
    getMode: function() {
        return this._mode;
    },
    getNumIndices: function() {
        var count = 0;
        var array = this._arrayLengths;
        for (var i = 0, l = array.length; i < l; i++) {
            count += array[i];
        }
        return count;
    },
    getCount: function() {
        return this.getNumIndices();
    },
    getArrayLengths: function() {
        return this._arrayLengths;
    },
    getFirst: function() {
        return this._first;
    },
    setFirst: function(first) {
        this._first = first;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DrawArrayLengths);


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var FrameStamp = function() {
    this._frame = 0;
    this._startSimulation = 0.0;
    this._currentSimulation = 0.0;
    this._deltaTime = 0.0; // last time elapsed since the next traversal
};

FrameStamp.prototype = {
    setReferenceTime: function(s) {
        this._startSimulation = s;
    },
    getReferenceTime: function() {
        return this._startSimulation;
    },
    setSimulationTime: function(s) {
        this._currentSimulation = s;
    },
    getSimulationTime: function() {
        return this._currentSimulation;
    },
    setDeltaTime: function(d) {
        this._deltaTime = d;
    },
    getDeltaTime: function() {
        return this._deltaTime;
    },
    setFrameNumber: function(n) {
        this._frame = n;
    },
    getFrameNumber: function() {
        return this._frame;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (FrameStamp);


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_primitiveIndexFunctor__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_notify__ = __webpack_require__(2);







// **** GENERAL INFO ON KDTREE ****
// A KdTree is a Spatial Partitionning Tree (http://en.wikipedia.org/wiki/Space_partitioning)
// The type of tree is sort of defined by the splitting axis method:
// - Per Axis split (octree/ kdtree)
// - Arbritrary direction split (bsp)

// The algorithm used for splitting, the name for finding best split is 'Surface Area Heuristic (SAH)'
// Octree divide the space in 8 subspace (one box -> 8 sub boxes)
// whereas kdtree does it by splitting population number in two equal group

// Kd Tree http://en.wikipedia.org/wiki/K-d_tree
// a given set of points is sorted along one Axis (e.g. X).
// The sorted list is split at the median.
// The result are two sets, one for each half-space (left and right).

// Then, for the current node, the splitting-plane position (or the median-point) and depth is saved.
// Finally, if the point-set has more than n point and the tree depth is below m
// (with n,m chosen by the user, as build options), two child-nodes (L/R one for each point-set)
// are created which themselfs repeat the pocedure.

// The split-axis gets alternated at each depth, the split order is computed by checking the main
// bounding box the length of its axis
// **** GENERAL INFO ON KDTREE ****

// The KdTree implemented here is flattened, ie, a node and its children all lie in the same array
// The most important thing is the understanding of the variables first and second for each node
// Their semantic depend if the node is a leaf or not
// if it's a leaf :
//   first and second defines a range in the triangles array (triangles in the cell)
// if it's not a leaf :
// - first and second respectively represents the left and right sub children
// We know that a node is a leaf if first is negative, in that case the range will be defined by
// [ -first - 1, -first-1 + second ]
var KdNode = function(first, second) {
    this._bb = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
    this._first = first;
    this._second = second;
    // These variables represent the local clipped ray (for intersection test)
    // They are mostly temporary because they are recomputed for each intersection test
    this._nodeRayStart = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._nodeRayEnd = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
};

var InfoCollector = function() {
    this._numVertexIndices = 0;
};

InfoCollector.prototype = {
    apply: function(node) {
        if (!node.getAttributes().Vertex) return;
        Object(__WEBPACK_IMPORTED_MODULE_3_osg_primitiveIndexFunctor__["a" /* default */])(node, this);
    },

    operatorPoint: function() {
        this._numVertexIndices += 2;
    },

    operatorLine: function() {
        this._numVertexIndices += 3;
    },

    operatorTriangle: function() {
        this._numVertexIndices += 4;
    }
};

var PrimitiveIndicesCollector = function(buildKdTree) {
    this._buildKdTree = buildKdTree;
    this._numIndices = 0;
};

PrimitiveIndicesCollector.prototype = {
    apply: function(node) {
        if (!node.getAttributes().Vertex) return;
        Object(__WEBPACK_IMPORTED_MODULE_3_osg_primitiveIndexFunctor__["a" /* default */])(node, this);
    },

    operatorPoint: function(i0) {
        var vertices = this._buildKdTree._kdTree.getVertices();
        var iv = i0 * 3;
        this._buildKdTree._kdTree.addPoint(i0);
        this._buildKdTree._primitiveIndices[this._numIndices] = this._numIndices;
        var centers = this._buildKdTree._centers;
        var idCenter = this._numIndices * 3;
        centers[idCenter] = vertices[iv];
        centers[idCenter + 1] = vertices[iv + 1];
        centers[idCenter + 2] = vertices[iv + 2];
        this._numIndices++;
    },

    operatorLine: function(i0, i1) {
        if (i0 === i1) return;
        var vertices = this._buildKdTree._kdTree.getVertices();
        var iv0 = i0 * 3;
        var iv1 = i1 * 3;

        this._buildKdTree._kdTree.addLine(i0, i1);

        var numIndices = this._numIndices;
        this._buildKdTree._primitiveIndices[numIndices] = numIndices;

        var idCenter = numIndices * 3;

        var v0x = vertices[iv0];
        var v0y = vertices[iv0 + 1];
        var v0z = vertices[iv0 + 2];

        var v1x = vertices[iv1];
        var v1y = vertices[iv1 + 1];
        var v1z = vertices[iv1 + 2];

        var minx = v0x < v1x ? v0x : v1x;
        var miny = v0y < v1y ? v0y : v1y;
        var minz = v0z < v1z ? v0z : v1z;

        var maxx = v0x > v1x ? v0x : v1x;
        var maxy = v0y > v1y ? v0y : v1y;
        var maxz = v0z > v1z ? v0z : v1z;

        var centers = this._buildKdTree._centers;
        centers[idCenter] = (minx + maxx) * 0.5;
        centers[idCenter + 1] = (miny + maxy) * 0.5;
        centers[idCenter + 2] = (minz + maxz) * 0.5;

        this._numIndices++;
    },

    operatorTriangle: function(i0, i1, i2) {
        if (i0 === i1 || i0 === i2 || i1 === i2) return;

        var vertices = this._buildKdTree._kdTree.getVertices();
        var iv0 = i0 * 3;
        var iv1 = i1 * 3;
        var iv2 = i2 * 3;

        this._buildKdTree._kdTree.addTriangle(i0, i1, i2);

        var numIndices = this._numIndices;
        this._buildKdTree._primitiveIndices[numIndices] = numIndices;

        var idCenter = numIndices * 3;

        var v0x = vertices[iv0];
        var v0y = vertices[iv0 + 1];
        var v0z = vertices[iv0 + 2];

        var v1x = vertices[iv1];
        var v1y = vertices[iv1 + 1];
        var v1z = vertices[iv1 + 2];

        var v2x = vertices[iv2];
        var v2y = vertices[iv2 + 1];
        var v2z = vertices[iv2 + 2];

        var minx = v0x < v1x ? (v0x < v2x ? v0x : v2x) : v1x < v2x ? v1x : v2x;
        var miny = v0y < v1y ? (v0y < v2y ? v0y : v2y) : v1y < v2y ? v1y : v2y;
        var minz = v0z < v1z ? (v0z < v2z ? v0z : v2z) : v1z < v2z ? v1z : v2z;

        var maxx = v0x > v1x ? (v0x > v2x ? v0x : v2x) : v1x > v2x ? v1x : v2x;
        var maxy = v0y > v1y ? (v0y > v2y ? v0y : v2y) : v1y > v2y ? v1y : v2y;
        var maxz = v0z > v1z ? (v0z > v2z ? v0z : v2z) : v1z > v2z ? v1z : v2z;

        var centers = this._buildKdTree._centers;
        centers[idCenter] = (minx + maxx) * 0.5;
        centers[idCenter + 1] = (miny + maxy) * 0.5;
        centers[idCenter + 2] = (minz + maxz) * 0.5;

        this._numIndices++;
    }
};

var BuildKdTree = function(kdTree) {
    this._kdTree = kdTree;
    this._bb = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
    this._primitiveIndices = undefined; // Uint32Array
    this._centers = undefined; // Float32Array
    this._axisOrder = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._stackLength = 0;
};

BuildKdTree.prototype = {
    build: function(options, geom) {
        var targetTris = options._targetNumTrianglesPerLeaf;
        var vertexAttrib = geom.getVertexAttributeList().Vertex;
        if (!vertexAttrib) return false;
        var vertices = vertexAttrib.getElements();
        if (!vertices) return false;
        var nbVertices = vertices.length / 3;
        if (nbVertices < targetTris) return false;

        this._bb.copy(geom.getBoundingBox());
        this._kdTree.setVertices(vertices);

        this.computeDivisions(options);
        options._numVerticesProcessed += nbVertices;

        var totalLenArray = 0;
        var geomPrimitives = geom.getPrimitiveSetList();
        var nbPrimitives = geomPrimitives.length;

        for (var i = 0; i < nbPrimitives; i++) {
            var prim = geomPrimitives[i];
            var mode = prim.getMode();
            if (mode === __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP || mode === __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN)
                totalLenArray += Math.abs(prim.getCount() - 2) * 3;
            else totalLenArray += prim.getCount() * 3;
        }

        var infoCollector = new InfoCollector(this);
        infoCollector.apply(geom);
        var vertexIndicesSize = infoCollector._numVertexIndices;

        this._primitiveIndices = new Uint32Array(totalLenArray / 3);
        this._centers = new Float32Array(totalLenArray);

        // init kdtree arrays
        // Check if we can use Uint16 later
        this._kdTree.setPrimitiveIndices(new Uint32Array(totalLenArray));
        var vertexIndicesArray =
            nbVertices > 65535
                ? new Uint32Array(vertexIndicesSize)
                : new Uint16Array(vertexIndicesSize);
        this._kdTree.setVertexIndices(vertexIndicesArray);

        var pic = new PrimitiveIndicesCollector(this);
        pic.apply(geom);

        // Adjust sizes
        var kdPrimIndices = this._kdTree
            .getPrimitiveIndices()
            .slice(0, this._kdTree.getNumPrimitiveIndices());
        this._kdTree.setPrimitiveIndices(kdPrimIndices);
        var kdVertexIndices = this._kdTree
            .getVertexIndices()
            .slice(0, this._kdTree.getNumVertexIndices());
        this._kdTree.setVertexIndices(kdVertexIndices);

        this._primitiveIndices = this._primitiveIndices.slice(0, pic._numIndices);
        this._centers = this._centers.slice(0, pic._numIndices * 3);

        var node = new KdNode(-1, this._primitiveIndices.length);
        node._bb.copy(this._bb);
        var nodeNum = this._kdTree.addNode(node);

        var bb = new __WEBPACK_IMPORTED_MODULE_2_osg_BoundingBox__["a" /* default */]();
        bb.copy(this._bb);
        this.divide(options, bb, nodeNum, 0);

        var primitiveIndices = this._kdTree.getPrimitiveIndices();

        nbPrimitives = this._primitiveIndices.length;
        for (i = 0; i < nbPrimitives; ++i) {
            this._primitiveIndices[i] = primitiveIndices[this._primitiveIndices[i]];
        }
        this._kdTree.setPrimitiveIndices(this._primitiveIndices);

        return this._kdTree.getNodes().length > 0;
    },

    computeDivisions: function(options) {
        this._stackLength = options._maxNumLevels;
        var max = this._bb._max;
        var min = this._bb._min;
        var dx = max[0] - min[0];
        var dy = max[1] - min[1];
        var dz = max[2] - min[2];
        var axisOrder = this._axisOrder;

        // We set the cutting order (longest edge aabb first)
        axisOrder[0] = dx >= dy && dx >= dz ? 0 : dy >= dz ? 1 : 2;
        axisOrder[2] = dx < dy && dx < dz ? 0 : dy < dz ? 1 : 2;
        var sum = axisOrder[0] + axisOrder[2];
        axisOrder[1] = sum === 3 ? 0 : sum === 2 ? 1 : 2;
    },
    // The core function of the kdtree building
    // It checks if the node needs to be subdivided or not
    // If it's a leaf, it computes the final bounding box of the node
    // and it ends here
    // If it's a node, then it puts the splitting axis position on the median population
    // On the same time it reorders the triangle index array
    divide: function(options, bb, nodeIndex, level) {
        var kdTree = this._kdTree;
        var primitives = this._primitiveIndices;
        var nodes = kdTree.getNodes();
        var node = nodes[nodeIndex];

        var first = node._first;
        var second = node._second;

        var needToDivide =
            level < this._stackLength && first < 0 && second > options._targetNumTrianglesPerLeaf;
        var istart = -first - 1;
        var iend = istart + second - 1;

        if (!needToDivide) {
            if (first < 0) {
                // leaf is done, now compute bound on it.
                this.computeNodeBox(node, istart, iend);
            }
            return nodeIndex;
        }

        if (first >= 0) return nodeIndex;
        // leaf node as first < 0, so look at dividing it.

        var axis = this._axisOrder[level % 3];
        var originalMin = bb._min[axis];
        var originalMax = bb._max[axis];

        var mid = (originalMin + originalMax) * 0.5;

        var originalLeftChildIndex = 0;
        var originalRightChildIndex = 0;
        var insitueDivision = false;

        var left = istart;
        var right = iend;

        var centers = this._centers;
        while (left < right) {
            while (left < right && centers[primitives[left] * 3 + axis] <= mid) {
                ++left;
            }

            while (left < right && centers[primitives[right] * 3 + axis] > mid) {
                --right;
            }

            if (left < right) {
                var tmp = primitives[left];
                primitives[left] = primitives[right];
                primitives[right] = tmp;
                ++left;
                --right;
            }
        }

        if (left === right) {
            if (centers[primitives[left] * 3 + axis] <= mid) ++left;
            else --right;
        }

        if (right - istart <= -1) {
            originalLeftChildIndex = 0;
            originalRightChildIndex = nodeIndex;
            insitueDivision = true;
        } else if (iend - left <= -1) {
            originalLeftChildIndex = nodeIndex;
            originalRightChildIndex = 0;
            insitueDivision = true;
        } else {
            originalLeftChildIndex = kdTree.addNode(new KdNode(-istart - 1, right - istart + 1));
            originalRightChildIndex = kdTree.addNode(new KdNode(-left - 1, iend - left + 1));
        }

        var restore = bb._max[axis];
        bb._max[axis] = mid;

        var leftChildIndex =
            originalLeftChildIndex !== 0
                ? this.divide(options, bb, originalLeftChildIndex, level + 1)
                : 0;

        bb._max[axis] = restore;

        restore = bb._min[axis];
        bb._min[axis] = mid;

        var rightChildIndex =
            originalRightChildIndex !== 0
                ? this.divide(options, bb, originalRightChildIndex, level + 1)
                : 0;

        bb._min[axis] = restore;

        if (!insitueDivision) {
            node._first = leftChildIndex;
            node._second = rightChildIndex;

            insitueDivision = true;

            var bnode = node._bb;
            bnode.init();
            if (leftChildIndex !== 0) bnode.expandByBoundingBox(nodes[leftChildIndex]._bb);
            if (rightChildIndex !== 0) bnode.expandByBoundingBox(nodes[rightChildIndex]._bb);
        }
        return nodeIndex;
    },
    // It computes the bounding box of the node so that the box contains all the triangles
    // of the cell
    computeNodeBox: function(node, istart, iend) {
        var minx = Infinity,
            miny = Infinity,
            minz = Infinity,
            maxx = -Infinity,
            maxy = -Infinity,
            maxz = -Infinity;
        var vertexIndices = this._kdTree.getVertexIndices();
        var primitives = this._kdTree.getPrimitiveIndices();
        var vertices = this._kdTree.getVertices();
        for (var i = istart; i <= iend; ++i) {
            var primitiveIndex = primitives[this._primitiveIndices[i]];
            var numPoints = vertexIndices[primitiveIndex++];
            for (var j = 0; j < numPoints; ++j) {
                var vi = vertexIndices[primitiveIndex++] * 3;
                var vx = vertices[vi];
                var vy = vertices[vi + 1];
                var vz = vertices[vi + 2];

                if (vx < minx) minx = vx;
                if (vy < miny) miny = vy;
                if (vz < minz) minz = vz;

                if (vx > maxx) maxx = vx;
                if (vy > maxy) maxy = vy;
                if (vz > maxz) maxz = vz;
            }
        }
        var epsilon = 1e-6;
        var bnode = node._bb;
        var bmin = bnode._min;
        var bmax = bnode._max;
        bmin[0] = minx - epsilon;
        bmin[1] = miny - epsilon;
        bmin[2] = minz - epsilon;
        bmax[0] = maxx + epsilon;
        bmax[1] = maxy + epsilon;
        bmax[2] = maxz + epsilon;
    }
};

var KdTree = function() {
    this._vertices = null;
    this._kdNodes = [];
    this._primitiveIndices = undefined;
    this._vertexIndices = undefined;
    this._numVertexIndices = 0;
    this._numPrimitiveIndices = 0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    KdTree,
    {
        getVertices: function() {
            return this._vertices;
        },
        setVertices: function(vertices) {
            this._vertices = vertices;
        },

        getNumPrimitiveIndices: function() {
            return this._numPrimitiveIndices;
        },

        getNumVertexIndices: function() {
            return this._numVertexIndices;
        },

        setPrimitiveIndices: function(indices) {
            this._primitiveIndices = indices;
        },
        getPrimitiveIndices: function() {
            return this._primitiveIndices;
        },

        // vector containing the primitive vertex index data packed as no_vertice_indices then vertex indices
        // ie. for points it's (1, p0), for lines (2, p0, p1) etc.
        setVertexIndices: function(indices) {
            this._vertexIndices = indices;
        },

        getVertexIndices: function() {
            return this._vertexIndices;
        },

        getNodes: function() {
            return this._kdNodes;
        },

        addPoint: function(p0) {
            var i = this._numVertexIndices;
            this._primitiveIndices[this._numPrimitiveIndices++] = i;
            this._vertexIndices[this._numVertexIndices++] = 1;
            this._vertexIndices[this._numVertexIndices++] = p0;
        },

        addLine: function(p0, p1) {
            var i = this._numVertexIndices;
            this._primitiveIndices[this._numPrimitiveIndices++] = i;
            this._vertexIndices[this._numVertexIndices++] = 2;
            this._vertexIndices[this._numVertexIndices++] = p0;
            this._vertexIndices[this._numVertexIndices++] = p1;
        },

        addTriangle: function(p0, p1, p2) {
            var i = this._numVertexIndices;
            this._primitiveIndices[this._numPrimitiveIndices++] = i;
            this._vertexIndices[this._numVertexIndices++] = 3;
            this._vertexIndices[this._numVertexIndices++] = p0;
            this._vertexIndices[this._numVertexIndices++] = p1;
            this._vertexIndices[this._numVertexIndices++] = p2;
        },

        addNode: function(node) {
            this._kdNodes.push(node);
            return this._kdNodes.length - 1;
        },
        build: function(options, geom) {
            var buildTree = new BuildKdTree(this);
            return buildTree.build(options, geom);
        },

        _intersectFunctor: function(functor, node) {
            // treat as a leaf
            var istart = -node._first - 1;
            var iend = istart + node._second;
            var vIds = this._vertexIndices;

            functor.setVertices(this._vertices);
            functor.setPrimitiveIndex(istart);

            for (var i = istart; i < iend; ++i) {
                var pIndex = this._primitiveIndices[i];
                var numVertices = vIds[pIndex++];

                if (numVertices === 3) {
                    functor.operatorTriangle(vIds[pIndex], vIds[pIndex + 1], vIds[pIndex + 2]);
                } else if (numVertices === 2) {
                    functor.operatorLine(vIds[pIndex], vIds[pIndex + 1]);
                } else if (numVertices === 1) {
                    functor.operatorPoint(vIds[pIndex]);
                } else {
                    __WEBPACK_IMPORTED_MODULE_5_osg_notify__["a" /* default */].error('KdTree::intersect() unsupported vertices count :' + numVertices);
                }
            }
        },

        intersect: function(functor, node) {
            if (node._first < 0) {
                this._intersectFunctor(functor, node);
                return;
            }

            if (functor.enter(node._bb)) {
                if (node._first > 0) {
                    this.intersect(functor, this._kdNodes[node._first]);
                }

                if (node._second > 0) {
                    this.intersect(functor, this._kdNodes[node._second]);
                }
                functor.leave();
            }
        },
        intersectLineSegment: function(functor, node, ls, le) {
            if (node._first < 0) {
                this._intersectFunctor(functor, node);
                return;
            }

            var s = node._nodeRayStart;
            var e = node._nodeRayEnd;
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(s, ls);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(e, le);
            var kNodes = this._kdNodes;
            var kNode;
            if (node._first > 0) {
                kNode = kNodes[node._first];
                if (functor.enter(kNode._bb, s, e)) this.intersectLineSegment(functor, kNode, s, e);
            }

            if (node._second > 0) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(s, ls);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(e, le);
                kNode = kNodes[node._second];
                if (functor.enter(kNode._bb, s, e)) this.intersectLineSegment(functor, kNode, s, e);
            }
        }
    },
    'osg',
    'KdTree'
);

/* harmony default export */ __webpack_exports__["a"] = (KdTree);


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShader_node_common_glsl__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShader_node_common_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_osgShader_node_common_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_node_functions_glsl__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_node_functions_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_osgShader_node_functions_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_lightCommon_glsl__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_lightCommon_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_lightCommon_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShader_node_lights_glsl__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShader_node_lights_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_osgShader_node_lights_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_node_skinning_glsl__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_node_skinning_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_osgShader_node_skinning_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShader_node_morphing_glsl__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShader_node_morphing_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_osgShader_node_morphing_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgShader_node_textures_glsl__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgShader_node_textures_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_osgShader_node_textures_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgShader_node_colorEncode_glsl__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgShader_node_colorEncode_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_osgShader_node_colorEncode_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShader_node_billboard_glsl__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShader_node_billboard_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_osgShader_node_billboard_glsl__);










/* harmony default export */ __webpack_exports__["a"] = ({
    'common.glsl': __WEBPACK_IMPORTED_MODULE_0_osgShader_node_common_glsl___default.a,
    'functions.glsl': __WEBPACK_IMPORTED_MODULE_1_osgShader_node_functions_glsl___default.a,
    'lightCommon.glsl': __WEBPACK_IMPORTED_MODULE_2_osgShader_node_lightCommon_glsl___default.a,
    'lights.glsl': __WEBPACK_IMPORTED_MODULE_3_osgShader_node_lights_glsl___default.a,
    'skinning.glsl': __WEBPACK_IMPORTED_MODULE_4_osgShader_node_skinning_glsl___default.a,
    'morphing.glsl': __WEBPACK_IMPORTED_MODULE_5_osgShader_node_morphing_glsl___default.a,
    'textures.glsl': __WEBPACK_IMPORTED_MODULE_6_osgShader_node_textures_glsl___default.a,
    'colorEncode.glsl': __WEBPACK_IMPORTED_MODULE_7_osgShader_node_colorEncode_glsl___default.a,
    'billboard.glsl': __WEBPACK_IMPORTED_MODULE_8_osgShader_node_billboard_glsl___default.a
});


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShadow_shaders_shadowCast_glsl__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShadow_shaders_shadowCast_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_osgShadow_shaders_shadowCast_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShadow_shaders_shadowReceive_glsl__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShadow_shaders_shadowReceive_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_osgShadow_shaders_shadowReceive_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_shaders_shadowLinearSoft_glsl__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_shaders_shadowLinearSoft_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_osgShadow_shaders_shadowLinearSoft_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShadow_shaders_floatFromTex_glsl__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShadow_shaders_floatFromTex_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_osgShadow_shaders_floatFromTex_glsl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShadow_shaders_tapPCF_glsl__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShadow_shaders_tapPCF_glsl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_osgShadow_shaders_tapPCF_glsl__);






/* harmony default export */ __webpack_exports__["a"] = ({
    'shadowCast.glsl': __WEBPACK_IMPORTED_MODULE_0_osgShadow_shaders_shadowCast_glsl___default.a,
    'shadowReceive.glsl': __WEBPACK_IMPORTED_MODULE_1_osgShadow_shaders_shadowReceive_glsl___default.a,
    'shadowLinearSoft.glsl': __WEBPACK_IMPORTED_MODULE_2_osgShadow_shaders_shadowLinearSoft_glsl___default.a,
    'floatFromTex.glsl': __WEBPACK_IMPORTED_MODULE_3_osgShadow_shaders_floatFromTex_glsl___default.a,
    'tapPCF.glsl': __WEBPACK_IMPORTED_MODULE_4_osgShadow_shaders_tapPCF_glsl___default.a
});


/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var StackObjectPairPool = function() {
    this._globalDefault = undefined;
    this._lastApplied = undefined;
    this._changed = false;

    this._values = [];
    this._back = undefined;
    this._length = 0;
};

StackObjectPairPool.prototype = {
    getLength: function() {
        return this._length;
    },
    push: function(object, value) {
        var objectPair;
        if (this._length === this._values.length) {
            objectPair = { object: object, value: value };
            this._values.push(objectPair);
        } else {
            objectPair = this._values[this._length];
            objectPair.object = object;
            objectPair.value = value;
        }
        this._back = objectPair;
        this._length++;
    },
    pop: function() {
        if (!this._length) return undefined;
        var values = this._values;
        this._length--;
        var objectPair = values[this._length];
        this._back = this._length ? values[this._length - 1] : undefined;
        return objectPair;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (StackObjectPairPool);


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_StackObjectPairPool__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_WebGLCaps__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_StateCache__ = __webpack_require__(214);













var checkUniformCache = [
    undefined,
    function uniformCheck1(uniformArray, cacheArray) {
        if (uniformArray[0] === cacheArray[0]) return true;
        cacheArray[0] = uniformArray[0];
        return false;
    },

    function uniformCheck2(uniformArray, cacheArray) {
        if (uniformArray[0] === cacheArray[0] && uniformArray[1] === cacheArray[1]) return true;
        cacheArray[0] = uniformArray[0];
        cacheArray[1] = uniformArray[1];
        return false;
    },

    function uniformCheck3(uniformArray, cacheArray) {
        if (
            uniformArray[0] === cacheArray[0] &&
            uniformArray[1] === cacheArray[1] &&
            uniformArray[2] === cacheArray[2]
        )
            return true;
        cacheArray[0] = uniformArray[0];
        cacheArray[1] = uniformArray[1];
        cacheArray[2] = uniformArray[2];
        return false;
    },

    function uniformCheck4(uniformArray, cacheArray) {
        if (
            uniformArray[0] === cacheArray[0] &&
            uniformArray[1] === cacheArray[1] &&
            uniformArray[2] === cacheArray[2] &&
            uniformArray[3] === cacheArray[3]
        )
            return true;
        cacheArray[0] = uniformArray[0];
        cacheArray[1] = uniformArray[1];
        cacheArray[2] = uniformArray[2];
        cacheArray[3] = uniformArray[3];
        return false;
    }
];

var State = function(shaderGeneratorProxy) {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);

    this._excludeUniforms = {
        uProjectionMatrix: true,
        uModelMatrix: true,
        uViewMatrix: true,
        uModelViewMatrix: true,
        uModelNormalMatrix: true,
        uModelViewNormalMatrix: true,
        uArrayColorEnabled: true
    };

    this._graphicContext = undefined;
    this._shaderGeneratorProxy = shaderGeneratorProxy;

    if (shaderGeneratorProxy === undefined) console.break();

    this._currentVAO = null;
    this._currentIndexVBO = null;

    this._stateSets = new __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__["a" /* default */]();
    this._shaderGeneratorNames = new __WEBPACK_IMPORTED_MODULE_6_osg_StackObjectPairPool__["a" /* default */]();
    this._uniforms = {};

    this._textureAttributeArrayList = [];
    this._attributeArray = [];

    this._projectionMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix4(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), 'uProjectionMatrix');
    this._modelMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix4(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), 'uModelMatrix');
    this._viewMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix4(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), 'uViewMatrix');
    this._modelViewMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix4(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), 'uModelViewMatrix');
    this._modelNormalMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix3(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["b" /* mat3 */].create(), 'uModelNormalMatrix');
    this._modelViewNormalMatrix = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createMatrix3(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["b" /* mat3 */].create(), 'uModelViewNormalMatrix');

    // track uniform for color array enabled
    var arrayColorEnable = new __WEBPACK_IMPORTED_MODULE_6_osg_StackObjectPairPool__["a" /* default */]();
    arrayColorEnable._globalDefault = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createFloat1(0.0, 'uArrayColorEnabled');

    this._uniforms.ArrayColorEnabled = arrayColorEnable;

    this._previousColorAttribPair = {};
    this._vertexAttribMap = {};
    this._vertexAttribMap._disable = [];
    this._vertexAttribMap._keys = [];

    this._frameStamp = undefined;

    // we dont use Map because in this use case with a few entries
    // {} is faster
    this._programCommonUniformsCache = {};

    // keep pointer on the last applied modelview and projection matrix
    this._lastAppliedModelViewMatrix = undefined;
    this._lastAppliedProjectionMatrix = undefined;

    // keep track of last applied program
    this._program = undefined;
    // inject a default program to initialize the stack Program
    var program = new __WEBPACK_IMPORTED_MODULE_3_osg_Program__["a" /* default */]();
    this.applyAttribute(program);

    // cache programAttribute access
    this._programType = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndex(program);
    this._programAttribute = this._attributeArray[this._programType];

    this._numPushStateSet = 0;
    this._numApply = 0;

    this._programUniformCache = [];
    this._cacheUniformId = 0;

    // gl states cache
    this._stateCache = new __WEBPACK_IMPORTED_MODULE_10_osg_StateCache__["a" /* default */]();

    this.resetStats();
};

__WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].createPrototypeObject(
    State,
    __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        // excludeUniforms is a list of uniforms that will not be applied or checked automatically when applying a program
        // you should not add you uniforms in this list until you really know what you are doing.
        // The use case of the exclusions is because the RenderLeaf.drawGeometry will apply them without UniformStack and
        // it should be applied automatically because you will apply them RenderLeaf.drawGeometry.
        // If you are writing a custom renderStage or overriding RenderLeaf.drawGeometry and add new uniform and custom
        // behavior then it can make sense to add uniforms here.
        // To make it work you should add your uniforms before the rendering (usually before viewer.run())
        getExcludeUniforms: function() {
            return this._excludeUniforms;
        },

        resetCaches: function() {
            this._currentVAO = null;
            this._currentIndexVBO = null;

            this._previousColorAttribPair = {};
            this._vertexAttribMap = {};
            this._vertexAttribMap._disable = [];
            this._vertexAttribMap._keys = [];

            this._programCommonUniformsCache = {};
        },

        applyColorMask: function(attribute) {
            this._stateCache.applyColorMaskAttribute(attribute);
        },

        applyBlendFunc: function(attribute) {
            this._stateCache.applyBlendFuncAttribute(attribute);
        },

        applyCullFace: function(attribute) {
            this._stateCache.applyCullFaceAttribute(attribute);
        },

        applyDepth: function(attribute) {
            this._stateCache.applyDepthAttribute(attribute);
        },

        applyViewport: function(attribute) {
            this._stateCache.applyViewportAttribute(attribute);
        },

        applyScissor: function(attribute) {
            this._stateCache.applyScissorAttribute(attribute);
        },

        viewport: function(x, y, width, height) {
            this._stateCache.viewport(x, y, width, height);
        },

        depthMask: function(value) {
            this._stateCache.depthMask(value);
        },

        clearDepth: function(value) {
            this._stateCache.clearDepth(value);
        },

        clearColor: function(value) {
            this._stateCache.clearColor(value);
        },

        clear: function(mask) {
            this._stateCache.clear(this._graphicContext, mask);
        },

        drawGeometry: function(geom) {
            this._stateCache.drawGeometry(this._graphicContext, geom);
        },

        getCacheUniformsApplyRenderLeaf: function() {
            return this._programCommonUniformsCache;
        },

        setGraphicContext: function(graphicContext) {
            this._graphicContext = graphicContext;
            this._extVAO = __WEBPACK_IMPORTED_MODULE_9_osg_WebGLCaps__["a" /* default */].instance(graphicContext).getWebGLExtension(
                'OES_vertex_array_object'
            );
        },

        getGraphicContext: function() {
            return this._graphicContext;
        },

        getShaderGeneratorProxy: function() {
            return this._shaderGeneratorProxy;
        },

        pushCheckOverride: function(stack, object, maskValue) {
            var result = this._evaluateOverrideObjectOnStack(stack, object, maskValue);
            // override and protected case
            if (result !== object) stack.push(result, stack._back.value);
            else stack.push(object, maskValue);
        },

        _evaluateOverrideObjectOnStack: function(stack, object, maskValue) {
            var back = stack._back;
            // object can be a Uniform, an Attribute, or a shader generator name
            if (stack._length === 0) {
                return object;
            } else if (
                back.value & __WEBPACK_IMPORTED_MODULE_4_osg_StateAttribute__["a" /* default */].OVERRIDE &&
                !(maskValue & __WEBPACK_IMPORTED_MODULE_4_osg_StateAttribute__["a" /* default */].PROTECTED)
            ) {
                return back.object;
            } else {
                return object;
            }
        },

        pushStateSet: function(stateset) {
            this._numPushStateSet++;
            this._stateSets.push(stateset);

            this.pushAttributeMap(
                this._attributeArray,
                stateset._attributeArray,
                stateset._activeAttribute
            );

            var textureAttributeArrayList = stateset._textureAttributeArrayList;
            var activeTextureUnits = stateset._activeTextureAttributeUnit;
            var activeTextureAttribute = stateset._activeTextureAttribute;

            for (var i = 0, l = activeTextureUnits.length; i < l; i++) {
                var unit = activeTextureUnits[i];
                var _attributeArray = textureAttributeArrayList[unit];

                var textureUnitAttributeArray = this.getOrCreateTextureAttributeArray(unit);
                this.pushAttributeMap(
                    textureUnitAttributeArray,
                    _attributeArray,
                    activeTextureAttribute
                );
            }

            if (stateset.hasUniform())
                this.pushUniformsList(this._uniforms, stateset.getUniformList());

            var generatorPair = stateset.getShaderGeneratorPair();
            if (generatorPair)
                this.pushCheckOverride(
                    this._shaderGeneratorNames,
                    generatorPair.getShaderGeneratorName(),
                    generatorPair.getValue()
                );
        },

        getStateSetStackSize: function() {
            return this._stateSets.getLength();
        },

        insertStateSet: (function() {
            var tmpStack = new __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__["a" /* default */]();
            var tmpStackArray = tmpStack.getArray();
            return function(pos, stateSet) {
                tmpStack.reset();
                var length = this.getStateSetStackSize();
                while (length > pos) {
                    tmpStack.push(this._stateSets.back());
                    this.popStateSet();
                    length--;
                }

                this.pushStateSet(stateSet);

                for (var i = tmpStack._length - 1; i >= 0; i--) {
                    this.pushStateSet(tmpStackArray[i]);
                }
            };
        })(),

        removeStateSet: (function() {
            var tmpStack = new __WEBPACK_IMPORTED_MODULE_5_osg_PooledArray__["a" /* default */]();
            var tmpStackArray = tmpStack.getArray();
            return function(pos) {
                var length = this.getStateSetStackSize();
                if (pos >= length) {
                    __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn('Warning State:removeStateSet ' + pos + ' out of range');
                    return;
                }

                tmpStack.reset();

                // record the StateSet above the one we intend to remove
                while (length - 1 > pos) {
                    tmpStack.push(this._stateSets.back());
                    this.popStateSet();
                    length--;
                }

                // remove the intended StateSet as well
                this.popStateSet();

                // push back the original ones that were above the remove StateSet
                for (var i = tmpStack._length - 1; i >= 0; i--) {
                    this.pushStateSet(tmpStackArray[i]);
                }
            };
        })(),

        // needed because we use a cache during the frame to avoid
        // applying uniform or operation. At each frame we need to
        // invalidate those informations
        resetCacheFrame: function() {
            this._lastAppliedModelViewMatrix = this._lastAppliedProjectionMatrix = undefined;
        },

        resetStats: function() {
            this._numApply = 0;
            this._numPushStateSet = 0;
        },

        // apply program if needed
        applyProgram: function(program) {
            if (this._program === program) return;
            this._program = program;
            this.getGraphicContext().useProgram(program);
        },

        applyModelViewMatrix: (function() {
            var normal = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["b" /* mat3 */].create();

            return function StateApplyModelViewMatrix(matrix, matrixModel) {
                if (this._lastAppliedModelViewMatrix === matrix) return false;

                var program = this.getLastProgramApplied();
                var uniformCache = program.getUniformsCache();
                var mu = this._modelViewMatrix;
                var mul = uniformCache.uModelViewMatrix;
                var gc = this.getGraphicContext();
                if (mul) {
                    mu.setMatrix4(matrix);
                    mu.apply(gc, mul);
                }

                var sendNormal;
                if (this._lastAppliedModelViewMatrix) {
                    // check if we need to push normal
                    // test rotation component, if not diff
                    // we dont need to send normal
                    var m2 = this._lastAppliedModelViewMatrix;
                    for (var i = 0; i < 11; i++) {
                        if (matrix[i] !== m2[i]) {
                            sendNormal = true;
                            break;
                        }
                    }
                } else {
                    sendNormal = true;
                }

                if (sendNormal) {
                    mu = this._modelViewNormalMatrix;
                    mul = uniformCache.uModelViewNormalMatrix;
                    if (mul) {
                        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["b" /* mat3 */].normalFromMat4(normal, matrix);
                        mu.setMatrix3(normal);
                        mu.apply(gc, mul);
                    }

                    mul = uniformCache.uModelNormalMatrix;
                    if (mul) {
                        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["b" /* mat3 */].normalFromMat4(normal, matrixModel);
                        mu.setMatrix3(normal);
                        mu.apply(gc, mul);
                    }
                }

                this._lastAppliedModelViewMatrix = matrix;
                return true;
            };
        })(),

        applyProjectionMatrix: function(matrix) {
            if (this._lastAppliedProjectionMatrix === matrix) return;

            this._lastAppliedProjectionMatrix = matrix;
            var program = this.getLastProgramApplied();
            var mu = this._projectionMatrix;

            var mul = program.getUniformsCache()[mu.getName()];
            if (mul) {
                mu.setMatrix4(matrix);
                mu.apply(this.getGraphicContext(), mul);
            }
        },

        getCurrentShaderGeneratorStateSet: function(stateset) {
            var programStack = this._programAttribute;
            var stateSetProgramPair = stateset._attributeArray[this._programType];

            if (
                (programStack._length !== 0 && programStack._back.value !== __WEBPACK_IMPORTED_MODULE_4_osg_StateAttribute__["a" /* default */].OFF) ||
                (stateSetProgramPair && stateSetProgramPair.getValue() !== __WEBPACK_IMPORTED_MODULE_4_osg_StateAttribute__["a" /* default */].OFF)
            )
                return undefined;

            var stateSetGeneratorPair = stateset.getShaderGeneratorPair();
            var generatorStack = this._shaderGeneratorNames;
            var generator;

            if (stateSetGeneratorPair) {
                var maskValue = stateSetGeneratorPair.getValue();
                var stateSetGenerator = stateSetGeneratorPair.getShaderGeneratorName();
                generator = this._evaluateOverrideObjectOnStack(
                    this._shaderGeneratorNames,
                    stateSetGenerator,
                    maskValue
                );
            } else if (generatorStack._length) {
                generator = generatorStack._back.object;
            }

            // no custom program look into the stack of ShaderGenerator name
            // what we should use to generate a program
            var last = generator;
            var shaderGenerator = this._shaderGeneratorProxy.getShaderGenerator(last);
            return shaderGenerator;
        },

        _applyAttributeMapStateSet: function(_attributeArray, stateSetAttributeArray) {
            var max =
                _attributeArray.length > stateSetAttributeArray.length
                    ? _attributeArray.length
                    : stateSetAttributeArray.length;

            for (var i = 0, l = max; i < l; i++) {
                var attribute;
                var attributeId = i;

                var attributeStack =
                    attributeId < _attributeArray.length ? _attributeArray[attributeId] : undefined;

                var stateSetAttributePair =
                    attributeId < stateSetAttributeArray.length
                        ? stateSetAttributeArray[attributeId]
                        : undefined;

                var hasStateAttributeStack = !!attributeStack;
                var hasStateAttributeStackChanged =
                    hasStateAttributeStack && attributeStack._changed;

                if (!stateSetAttributePair && !hasStateAttributeStackChanged) continue;

                var stateSetAttribute = stateSetAttributePair
                    ? stateSetAttributePair.getAttribute()
                    : undefined;

                if (!hasStateAttributeStack) {
                    attributeStack = this._createAttributeStack(
                        _attributeArray,
                        attributeId,
                        stateSetAttribute.cloneType()
                    );
                    attributeStack._changed = true;
                    this._applyAttributeStack(stateSetAttribute, attributeStack);
                } else if (stateSetAttribute) {
                    var maskValue = stateSetAttributePair.getValue();
                    attribute = this._evaluateOverrideObjectOnStack(
                        attributeStack,
                        stateSetAttribute,
                        maskValue
                    );
                    if (attribute !== stateSetAttribute) {
                        // override

                        if (attributeStack._changed) {
                            this._applyAttributeStack(attribute, attributeStack);
                            attributeStack._changed = false;
                        }
                    } else if (this._applyAttributeStack(attribute, attributeStack)) {
                        attributeStack._changed = true;
                    }
                } else if (attributeStack._length) {
                    attributeStack._changed = false;
                    this._applyAttributeStack(attributeStack._back.object, attributeStack);
                } else {
                    attributeStack._changed = false;
                    this._applyAttributeStack(attributeStack._globalDefault, attributeStack);
                }
            }
        },

        _applyTextureAttributeMapListStateSet: function(
            _textureAttributeArrayList,
            stateSetTextureAttributeArrayList
        ) {
            var _textureAttributeArray;
            var stateSetTextureAttributeLength, stateTextureAttributeLength;
            // very interesting JIT optimizer behavior
            // max texture is supposed to be the max of activeTexture or stateSet texture list
            // if the loop is fix, for example max value that could be 16. It's faster than using the max of textureUnit of State and StateSet even if the value is 8 for example
            var maxTexture = 16;
            for (var i = 0, l = maxTexture; i < l; i++) {
                var textureUnit = i;

                _textureAttributeArray =
                    textureUnit < _textureAttributeArrayList.length
                        ? _textureAttributeArrayList[textureUnit]
                        : undefined;
                var stateSetTextureAttributeArray =
                    textureUnit < stateSetTextureAttributeArrayList.length
                        ? stateSetTextureAttributeArrayList[textureUnit]
                        : undefined;

                if (!_textureAttributeArray && !stateSetTextureAttributeArray) continue;

                stateSetTextureAttributeLength = stateTextureAttributeLength = 0;
                if (!_textureAttributeArray) {
                    _textureAttributeArray = this.getOrCreateTextureAttributeArray(textureUnit);
                    stateSetTextureAttributeLength = stateSetTextureAttributeArray.length;
                } else {
                    stateTextureAttributeLength = _textureAttributeArray.length;
                    if (stateSetTextureAttributeArray)
                        stateSetTextureAttributeLength = stateSetTextureAttributeArray.length;
                }

                var lt =
                    stateTextureAttributeLength > stateSetTextureAttributeLength
                        ? stateTextureAttributeLength
                        : stateSetTextureAttributeLength;
                for (var j = 0; j < lt; j++) {
                    var attributeId = j;

                    var attributeStack =
                        attributeId < stateTextureAttributeLength
                            ? _textureAttributeArray[attributeId]
                            : undefined;

                    var stateSetAttributePair =
                        stateSetTextureAttributeArray &&
                        attributeId < stateSetTextureAttributeArray.length
                            ? stateSetTextureAttributeArray[attributeId]
                            : undefined;
                    var hasStateAttributeStack = !!attributeStack;
                    var hasStateAttributeStackChanged =
                        hasStateAttributeStack && attributeStack._changed;
                    var attribute;

                    if (!stateSetAttributePair && !hasStateAttributeStackChanged) continue;

                    var stateSetAttribute = stateSetAttributePair
                        ? stateSetAttributePair.getAttribute()
                        : undefined;

                    if (!hasStateAttributeStack) {
                        attribute = stateSetAttributePair.getAttribute();
                        attributeStack = this._createAttributeStack(
                            _textureAttributeArray,
                            attributeId,
                            attribute.cloneType()
                        );
                        attributeStack._changed = true;
                        this._applyTextureAttribute(textureUnit, attribute, attributeStack);
                    } else if (stateSetAttribute) {
                        var maskValue = stateSetAttributePair.getValue();
                        attribute = this._evaluateOverrideObjectOnStack(
                            attributeStack,
                            stateSetAttribute,
                            maskValue
                        );
                        if (attribute !== stateSetAttribute) {
                            // override

                            if (attributeStack._changed) {
                                this._applyTextureAttribute(textureUnit, attribute, attributeStack);
                                attributeStack._changed = false;
                            }
                        } else if (
                            this._applyTextureAttribute(textureUnit, attribute, attributeStack)
                        ) {
                            attributeStack._changed = true;
                        }
                    } else if (attributeStack._length) {
                        attributeStack._changed = false;
                        this._applyTextureAttribute(
                            textureUnit,
                            attributeStack._back.object,
                            attributeStack
                        );
                    } else {
                        attributeStack._changed = false;
                        this._applyTextureAttribute(
                            textureUnit,
                            attributeStack._globalDefault,
                            attributeStack
                        );
                    }
                }
            }
        },

        applyStateSet: function(stateset) {
            this._numApply++;

            var previousProgram = this.getLastProgramApplied();

            // needed before calling applyAttributeMap because
            // we cache needed StateAttribute from the compiler
            this._currentShaderGenerator = this.getCurrentShaderGeneratorStateSet(stateset);

            this._applyAttributeMapStateSet(this._attributeArray, stateset._attributeArray);
            this._applyTextureAttributeMapListStateSet(
                this._textureAttributeArrayList,
                stateset._textureAttributeArrayList
            );

            var lastApplied;
            if (this._currentShaderGenerator) {
                // no custom program look into the stack of ShaderGenerator name
                // what we should use to generate a program
                var generatedProgram = this._currentShaderGenerator.getOrCreateProgram(this);
                this.applyAttribute(generatedProgram);
                lastApplied = generatedProgram;

                // will cache uniform and apply them with the program
                this._applyGeneratedProgramUniforms(generatedProgram, stateset);
            } else {
                lastApplied = this.getLastProgramApplied();
                // custom program so we will iterate on uniform from the program and apply them
                // but in order to be able to use Attribute in the state graph we will check if
                // our program want them. It must be defined by the user
                this._applyCustomProgramUniforms(lastApplied, stateset);
            }

            // reset reference of last applied matrix
            if (previousProgram !== lastApplied) {
                this._lastAppliedModelViewMatrix = undefined;
                this._lastAppliedProjectionMatrix = undefined;
            }
        },

        popAllStateSets: function() {
            while (this._stateSets._length) {
                this.popStateSet();
            }
        },

        popStateSet: function() {
            if (!this._stateSets._length) return;

            var stateset = this._stateSets.pop();

            this.popAttributeMap(
                this._attributeArray,
                stateset._attributeArray,
                stateset._activeAttribute
            );

            var textureAttributeArrayList = stateset._textureAttributeArrayList;
            var activeTextureUnits = stateset._activeTextureAttributeUnit;
            var activeTextureAttribute = stateset._activeTextureAttribute;

            for (var i = 0, l = activeTextureUnits.length; i < l; i++) {
                var unit = activeTextureUnits[i];
                var _attributeArray = textureAttributeArrayList[unit];
                var textureUnitAttributeArray = this._textureAttributeArrayList[unit];
                this.popAttributeMap(
                    textureUnitAttributeArray,
                    _attributeArray,
                    activeTextureAttribute
                );
            }

            if (stateset.hasUniform())
                this.popUniformsList(this._uniforms, stateset.getUniformList());

            if (stateset.getShaderGeneratorPair()) {
                this._shaderGeneratorNames.pop();
            }
        },

        _createAttributeStack: function(_attributeArray, typeIndex, globalDefault) {
            __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].arrayDense(typeIndex, _attributeArray);
            var attributeStack = new __WEBPACK_IMPORTED_MODULE_6_osg_StackObjectPairPool__["a" /* default */]();
            attributeStack._globalDefault = globalDefault;

            _attributeArray[typeIndex] = attributeStack;

            return attributeStack;
        },

        haveAppliedAttribute: function(attribute) {
            if (!attribute) return;

            var attributeArray = this._attributeArray;
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndex(attribute);
            var attributeStack = index < attributeArray.length ? attributeArray[index] : undefined;
            if (!attributeStack) {
                attributeStack = this._createAttributeStack(
                    attributeArray,
                    index,
                    attribute.cloneType()
                );
            }
            attributeStack._lastApplied = attribute;
            attributeStack._changed = true;
        },

        applyAttribute: function(attribute) {
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndex(attribute);

            var attributeArray = this._attributeArray;
            var attributeStack = index < attributeArray.length ? attributeArray[index] : undefined;
            if (!attributeStack) {
                attributeStack = this._createAttributeStack(
                    attributeArray,
                    index,
                    attribute.cloneType()
                );
            }

            attributeStack._changed = true;
            this._applyAttributeStack(attribute, attributeStack);
        },

        _applyAttributeStack: function(attribute, attributeStack) {
            if (attributeStack._lastApplied === attribute) return false;

            if (attribute.apply) attribute.apply(this);

            attributeStack._lastApplied = attribute;
            return true;
        },

        _applyTextureAttribute: function(unit, attribute, attributeStack) {
            if (attributeStack._lastApplied === attribute) return false;

            attributeStack._lastApplied = attribute;

            if (!attribute.apply) return true;

            var gl = this.getGraphicContext();
            gl.activeTexture(gl.TEXTURE0 + unit);

            // there is a texture we bind it.
            attribute.apply(this, unit);

            return true;
        },

        applyTextureAttribute: function(unit, attribute) {
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateTextureStateAttributeTypeMemberIndex(attribute);
            var textureUnitAttributeArray = this.getOrCreateTextureAttributeArray(unit);
            var attributeStack = textureUnitAttributeArray[index];

            if (!attributeStack)
                attributeStack = this._createAttributeStack(
                    textureUnitAttributeArray,
                    index,
                    attribute.cloneType()
                );

            attributeStack._changed = true;
            this._applyTextureAttribute(unit, attribute, attributeStack);
        },

        getLastProgramApplied: function() {
            return this._programAttribute._lastApplied;
        },

        applyDefault: function() {
            this.popAllStateSets();

            this._currentShaderGenerator = undefined;

            this.applyAttributeMap(this._attributeArray);
            this.applyTextureAttributeMapList(this._textureAttributeArrayList);
        },

        applyAttributeMap: function(_attributeArray) {
            var attributeStack;
            for (var i = 0, l = _attributeArray.length; i < l; i++) {
                attributeStack = _attributeArray[i];
                if (!attributeStack) continue;

                var attribute;
                if (attributeStack._length) attribute = attributeStack._back.object;
                else attribute = attributeStack._globalDefault;

                if (!attributeStack._changed) continue;

                if (attributeStack._lastApplied !== attribute) {
                    if (attribute.apply) attribute.apply(this);

                    attributeStack._lastApplied = attribute;
                }

                attributeStack._changed = false;
            }
        },

        pushUniformsList: function(uniformMap, stateSetUniformMap) {
            /*jshint bitwise: false */
            var name;
            var uniform;

            for (var key in stateSetUniformMap) {
                var uniformPair = stateSetUniformMap[key];
                uniform = uniformPair.getUniform();
                name = uniform.getName();
                if (!uniformMap[name]) {
                    this._createAttributeStack(uniformMap, name, uniform);
                }

                this.pushCheckOverride(uniformMap[name], uniform, uniformPair.getValue());
            }
            /*jshint bitwise: true */
        },

        popUniformsList: function(uniformMap, stateSetUniformMap) {
            for (var key in stateSetUniformMap) {
                uniformMap[key].pop();
            }
        },

        applyTextureAttributeMapList: function(textureAttributeArrayList) {
            var gl = this._graphicContext;
            var textureAttributeArray;

            for (
                var textureUnit = 0, l = textureAttributeArrayList.length;
                textureUnit < l;
                textureUnit++
            ) {
                textureAttributeArray = textureAttributeArrayList[textureUnit];
                if (!textureAttributeArray) continue;

                for (var i = 0, lt = textureAttributeArray.length; i < lt; i++) {
                    var attributeStack = textureAttributeArray[i];

                    // skip if not stack or not changed in stack
                    if (!attributeStack) continue;

                    var attribute;
                    if (attributeStack._length) attribute = attributeStack._back.object;
                    else attribute = attributeStack._globalDefault;

                    if (!attributeStack._changed) continue;

                    // if the the stack has changed but the last applied attribute is the same
                    // then we dont need to apply it again
                    if (attributeStack._lastApplied !== attribute) {
                        gl.activeTexture(gl.TEXTURE0 + textureUnit);
                        attribute.apply(this, textureUnit);

                        attributeStack._lastApplied = attribute;
                    }

                    attributeStack._changed = false;
                }
            }
        },

        setGlobalDefaultAttribute: function(attribute) {
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateStateAttributeTypeMemberIndex(attribute);
            if (index >= this._attributeArray.length || !this._attributeArray[index]) {
                this._createAttributeStack(this._attributeArray, index, attribute);
            } else {
                this._attributeArray[index]._globalDefault = attribute;
            }
        },

        getGlobalDefaultAttribute: function(typeMember) {
            var _attributeArray = this._attributeArray;
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getIdFromTypeMember(typeMember);
            if (index === undefined || index >= _attributeArray.length) return undefined;
            return _attributeArray[index] ? _attributeArray[index]._globalDefault : undefined;
        },

        setGlobalDefaultTextureAttribute: function(unit, attribute) {
            var attributeArray = this.getOrCreateTextureAttributeArray(unit);
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getOrCreateTextureStateAttributeTypeMemberIndex(attribute);

            if (index >= attributeArray.length || !attributeArray[index]) {
                this._createAttributeStack(attributeArray, index, attribute);
            } else {
                attributeArray[index]._globalDefault = attribute;
            }
        },

        getGlobalDefaultTextureAttribute: function(unit, typeMember) {
            var attributeArray = this.getOrCreateTextureAttributeArray(unit);
            var index = __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].getTextureIdFromTypeMember(typeMember);
            if (index === undefined || index >= attributeArray.length) return undefined;
            return attributeArray[index] ? attributeArray[index]._globalDefault : undefined;
        },

        getOrCreateTextureAttributeArray: function(unit) {
            __WEBPACK_IMPORTED_MODULE_8_osg_utils__["a" /* default */].arrayDense(unit, this._textureAttributeArrayList);

            if (!this._textureAttributeArrayList[unit]) this._textureAttributeArrayList[unit] = [];
            return this._textureAttributeArrayList[unit];
        },

        pushAttributeMap: function(_attributeArray, stateSetAttributeArray, validAttributeArray) {
            /*jshint bitwise: false */
            var attributeStack;
            var stateSetAttributeArrayLength = stateSetAttributeArray.length;
            var _attributeArrayLength = _attributeArray.length;
            for (var i = 0, l = validAttributeArray.length; i < l; i++) {
                var index = validAttributeArray[i];
                var attributePair =
                    index < stateSetAttributeArrayLength
                        ? stateSetAttributeArray[index]
                        : undefined;
                var attribute = attributePair.getAttribute();

                attributeStack = index < _attributeArrayLength ? _attributeArray[index] : undefined;
                if (!attributeStack) {
                    attributeStack = this._createAttributeStack(
                        _attributeArray,
                        index,
                        attribute.cloneType()
                    );
                }

                this.pushCheckOverride(attributeStack, attribute, attributePair.getValue());
                attributeStack._changed = true;
            }
        },

        popAttributeMap: function(_attributeArray, stateSetAttributeArray, activeAttribute) {
            for (var i = 0, l = activeAttribute.length; i < l; i++) {
                var index = activeAttribute[i];
                var attributeStack = _attributeArray[index];

                attributeStack.pop();
                attributeStack._changed = true;
            }
        },

        setIndexArray: function(array) {
            var gl = this._graphicContext;

            if (this._currentIndexVBO !== array) {
                array.bind(gl);
                this._currentIndexVBO = array;
            }

            if (array.isDirty()) {
                array.compile(gl);
            }
        },

        lazyDisablingOfVertexAttributes: function() {
            var keys = this._vertexAttribMap._keys;
            for (var i = 0, l = keys.length; i < l; i++) {
                var attr = keys[i];
                if (this._vertexAttribMap[attr]) {
                    this._vertexAttribMap._disable[attr] = true;
                }
            }
        },

        enableVertexColor: function() {
            var program = this._programAttribute._lastApplied;

            if (
                !program.getUniformsCache().uArrayColorEnabled ||
                !program.getAttributesCache().Color
            )
                return; // no color uniform or attribute used, exit

            // update uniform
            var uniform = this._uniforms.ArrayColorEnabled._globalDefault;

            var previousColorEnabled = this._previousColorAttribPair[program.getInstanceID()];

            if (!previousColorEnabled) {
                uniform.setFloat(1.0);
                uniform.apply(
                    this.getGraphicContext(),
                    program.getUniformsCache().uArrayColorEnabled
                );
                this._previousColorAttribPair[program.getInstanceID()] = true;
            }
        },

        disableVertexColor: function() {
            var program = this._programAttribute._lastApplied;

            if (
                !program.getUniformsCache().uArrayColorEnabled ||
                !program.getAttributesCache().Color
            )
                return; // no color uniform or attribute used, exit

            // update uniform
            var uniform = this._uniforms.ArrayColorEnabled._globalDefault;

            var previousColorEnabled = this._previousColorAttribPair[program.getInstanceID()];

            if (previousColorEnabled) {
                uniform.setFloat(0.0);
                uniform.apply(
                    this.getGraphicContext(),
                    program.getUniformsCache().uArrayColorEnabled
                );
                this._previousColorAttribPair[program.getInstanceID()] = false;
            }
        },

        applyDisablingOfVertexAttributes: function() {
            var keys = this._vertexAttribMap._keys;
            for (var i = 0, l = keys.length; i < l; i++) {
                if (this._vertexAttribMap._disable[keys[i]] === true) {
                    var attr = keys[i];
                    this._graphicContext.disableVertexAttribArray(attr);
                    this._vertexAttribMap._disable[attr] = false;
                    this._vertexAttribMap[attr] = false;
                }
            }
        },

        clearVertexAttribCache: function() {
            var vertexAttribMap = this._vertexAttribMap;
            var keys = vertexAttribMap._keys;
            for (var i = 0, l = keys.length; i < l; i++) {
                var attr = keys[i];
                vertexAttribMap[attr] = undefined;
                vertexAttribMap._disable[attr] = false;
            }

            this._vertexAttribMap._disable.length = 0;
            this._vertexAttribMap._keys.length = 0;
        },

        /**
         *  set a vertex array object.
         *  return true if binded the vao and false
         *  if was already binded
         */
        setVertexArrayObject: function(vao) {
            if (this._currentVAO === vao) return false;

            this._currentVAO = vao;

            if (vao) {
                vao.bind(this._graphicContext);
            } else {
                // disable cache to force a re enable of array
                this._graphicContext.bindVertexArray(null);
                this.clearVertexAttribCache();
            }

            // disable currentIndexVBO to force to bind indexArray from Geometry
            // if there is a change of vao
            this._currentIndexVBO = undefined;

            return true;
        },

        setVertexAttribArray: function(attrib, array, normalize) {
            var vertexAttribMap = this._vertexAttribMap;
            vertexAttribMap._disable[attrib] = false;
            var gl = this._graphicContext;
            var binded = false;

            if (array.isDirty()) {
                array.bind(gl);
                array.compile(gl);
                binded = true;
            }

            var currentArray = vertexAttribMap[attrib];
            if (currentArray !== array) {
                if (!binded) {
                    array.bind(gl);
                }

                if (!currentArray) {
                    gl.enableVertexAttribArray(attrib);

                    // can be === false (so undefined check is important)
                    if (currentArray === undefined) vertexAttribMap._keys.push(attrib);
                }

                vertexAttribMap[attrib] = array;
                gl.vertexAttribPointer(
                    attrib,
                    array.getItemSize(),
                    array.getType(),
                    normalize,
                    0,
                    0
                );
            }
        },

        _getActiveUniformsFromProgramAttributes: function(program, activeUniformsList) {
            var _attributeArrayStack = this._attributeArray;

            var attributeKeys = program.getTrackAttributes().attributeKeys;

            if (attributeKeys.length > 0) {
                for (var i = 0, l = attributeKeys.length; i < l; i++) {
                    var key = attributeKeys[i];
                    var index = this.typeMember[key];
                    var attributeStack = _attributeArrayStack[index];
                    if (!attributeStack) {
                        continue;
                    }

                    // we just need the uniform list and not the attribute itself
                    var attribute = attributeStack._globalDefault;
                    if (!attribute.getOrCreateUniforms) {
                        continue;
                    }

                    var uniformMap = attribute.getOrCreateUniforms();
                    for (var keyUniform in uniformMap) {
                        activeUniformsList.push(uniformMap[keyUniform]);
                    }
                }
            }
        },

        _getActiveUniformsFromProgramTextureAttributes: function(program, activeUniformsList) {
            var textureAttributeKeysList = program.getTrackAttributes().textureAttributeKeys;
            if (!textureAttributeKeysList) return;

            for (var unit = 0, nbUnit = textureAttributeKeysList.length; unit < nbUnit; unit++) {
                var textureAttributeKeys = textureAttributeKeysList[unit];
                if (!textureAttributeKeys) continue;

                var unitTextureAttributeList = this._textureAttributeArrayList[unit];
                if (!unitTextureAttributeList) continue;

                for (var i = 0, l = textureAttributeKeys.length; i < l; i++) {
                    var key = textureAttributeKeys[i];

                    var attributeStack = unitTextureAttributeList[key];
                    if (!attributeStack) {
                        continue;
                    }
                    // we just need the uniform list and not the attribute itself
                    var attribute = attributeStack._globalDefault;
                    if (!attribute.getOrCreateUniforms) {
                        continue;
                    }
                    var uniformMap = attribute.getOrCreateUniforms();
                    for (var keyUniform in uniformMap) {
                        activeUniformsList.push(uniformMap[keyUniform]);
                    }
                }
            }
        },

        _cacheUniformsForCustomProgram: function(program, activeUniformsList) {
            this._getActiveUniformsFromProgramAttributes(program, activeUniformsList);

            this._getActiveUniformsFromProgramTextureAttributes(program, activeUniformsList);

            var gl = this._graphicContext;

            // now we have a list on uniforms we want to track but we will filter them to use only what is needed by our program
            // not that if you create a uniforms whith the same name of a tracked attribute, and it will override it
            var uniformsFinal = {};

            for (var i = 0, l = activeUniformsList.length; i < l; i++) {
                var u = activeUniformsList[i];
                var uniformName = u.getName();
                var loc = gl.getUniformLocation(program._program, uniformName);
                if (loc !== undefined && loc !== null) {
                    uniformsFinal[uniformName] = u;
                }
            }
            program.trackUniforms = uniformsFinal;
        },

        _applyCustomProgramUniforms: (function() {
            var activeUniformsList = [];

            return function(program, stateset) {
                // custom program so we will iterate on uniform from the program and apply them
                // but in order to be able to use Attribute in the state graph we will check if
                // our program want them. It must be defined by the user

                // first time we see attributes key, so we will keep a list of uniforms from attributes
                activeUniformsList.length = 0;

                // fill the program with cached active uniforms map from attributes and texture attributes
                if (
                    program.getTrackAttributes() !== undefined &&
                    program.trackUniforms === undefined
                ) {
                    this._cacheUniformsForCustomProgram(program, activeUniformsList);
                }

                var programUniformMap = program.getUniformsCache();
                var uniformMapStack = this._uniforms;

                var programTrackUniformMap;
                if (program.trackUniforms) programTrackUniformMap = program.trackUniforms;

                var uniform;
                for (var uniformName in programUniformMap) {
                    var location = programUniformMap[uniformName];
                    var uniformStack = uniformMapStack[uniformName];

                    var hasStateSetUniformPair = stateset && stateset.uniforms[uniformName];

                    if (!uniformStack && !hasStateSetUniformPair) {
                        if (programTrackUniformMap === undefined) {
                            this._checkErrorUniform(uniformName);
                            continue;
                        }

                        uniform = programTrackUniformMap[uniformName];
                    } else if (hasStateSetUniformPair) {
                        var stateSetUniformPair = stateset.uniforms[uniformName];
                        var maskValue = stateSetUniformPair.getValue();
                        var stateSetUniform = stateSetUniformPair.getUniform();
                        if (uniformStack)
                            uniform = this._evaluateOverrideObjectOnStack(
                                uniformStack,
                                stateSetUniform,
                                maskValue
                            );
                        else uniform = stateSetUniform;
                    } else if (uniformStack._length) {
                        uniform = uniformStack._back.object;
                    } else {
                        uniform = uniformStack._globalDefault;
                    }

                    uniform.apply(this._graphicContext, location);
                }
            };
        })(),

        _checkErrorUniform: function(uniformName) {
            var unit = uniformName.substr(7);
            if (this._textureAttributeArrayList[unit] && uniformName === 'Texture' + unit) {
                return;
            }

            if (this._excludeUniforms[uniformName]) {
                return;
            }

            this._excludeUniforms[uniformName] = 1; // avoid multiple spammy errors

            __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].error('Uniform not in the scene hierarchy : ' + uniformName);
        },

        _computeForeignUniforms: function(programUniformMap, activeUniformMap) {
            var foreignUniforms = [];

            for (var keyUniform in programUniformMap) {
                var location = programUniformMap[keyUniform];

                // filter 'standard' uniform matrix that will be applied for all shader
                if (location !== undefined && activeUniformMap[keyUniform] === undefined) {
                    if (!this._excludeUniforms[keyUniform]) {
                        foreignUniforms.push(keyUniform);
                    }
                }
            }

            return foreignUniforms;
        },

        _removeUniformsNotRequiredByProgram: function(activeUniformMap, programUniformMap) {
            for (var keyUniform in activeUniformMap) {
                var location = programUniformMap[keyUniform];
                if (location === undefined || location === null) {
                    delete activeUniformMap[keyUniform];
                }
            }
        },

        _cacheUniformsForGeneratedProgram: function(program) {
            var shaderUniforms = program.getUniformsCache(); // declared in the shader
            var stateSetUniforms = program.getActiveUniforms(); // present in last stateset

            var foreignUniforms = this._computeForeignUniforms(shaderUniforms, stateSetUniforms);
            program.setForeignUniforms(foreignUniforms);

            // remove uniforms listed by attributes (getActiveUniforms) but not required by the program
            this._removeUniformsNotRequiredByProgram(stateSetUniforms, shaderUniforms);
        },

        _copyUniformEntry: function(uniform) {
            var internalArray = uniform.getInternalArray();
            var cacheData;
            if (internalArray.length < 16) {
                cacheData = new internalArray.constructor(internalArray.length);
            }

            return cacheData;
        },

        _initUniformCache: function(program) {
            var activeUniformMap = program.getActiveUniforms();

            var foreignUniformKeys = program.getForeignUniforms();
            var uniformMapStack = this._uniforms;

            var cacheForeignUniforms = [];
            var cacheActiveUniforms = [];

            var i, l, cache, name, cacheData, uniform;

            program._cacheUniformId = this._cacheUniformId++;
            this._programUniformCache[program._cacheUniformId] = {};

            if (foreignUniformKeys.length) {
                cache = cacheForeignUniforms;
                for (i = 0, l = foreignUniformKeys.length; i < l; i++) {
                    name = foreignUniformKeys[i];
                    var uniStack = uniformMapStack[name];
                    if (uniStack) {
                        uniform = uniStack._globalDefault;
                        cacheData = this._copyUniformEntry(uniform);
                        cache.push(cacheData);
                    }
                }
            }

            for (var keyUniform in activeUniformMap) {
                uniform = activeUniformMap[keyUniform];
                cacheData = this._copyUniformEntry(uniform);
                cacheActiveUniforms.push(cacheData);
            }

            this._programUniformCache[program._cacheUniformId].foreign = cacheForeignUniforms;
            this._programUniformCache[program._cacheUniformId].active = cacheActiveUniforms;
        },

        _checkCacheAndApplyUniform: function(
            uniform,
            cacheArray,
            indexCache,
            programUniformMap,
            nameUniform
        ) {
            var isCached;
            var internalArray = uniform.getInternalArray();
            var uniformArrayLength = internalArray.length;
            if (uniformArrayLength <= 4) {
                var uniformCache = cacheArray[indexCache];
                isCached = checkUniformCache[uniformArrayLength](internalArray, uniformCache);
            } else {
                isCached = false;
            }

            if (!isCached) {
                var location = programUniformMap[nameUniform];
                uniform.apply(this._graphicContext, location);
            }
        },

        // note that about TextureAttribute that need uniform on unit we would need to improve
        // the current uniformList ...

        // when we apply the shader for the first time, we want to compute the active uniforms for this shader and the list of uniforms not extracted from attributes called foreignUniforms
        _applyGeneratedProgramUniforms: function(program, stateset) {
            var uniformMapStack = this._uniforms;
            var uniform, uniformName, uniformStack, i;

            var foreignUniformKeys = program.getForeignUniforms();
            if (!foreignUniformKeys) {
                this._cacheUniformsForGeneratedProgram(program);
                foreignUniformKeys = program.getForeignUniforms();

                // be sure to create a stack for foreign uniform for this program
                // it's needed to do it here because of the cache of uniform
                if (stateset) {
                    var stateSetUniforms = stateset.uniforms;
                    for (i = 0; i < foreignUniformKeys.length; i++) {
                        uniformName = foreignUniformKeys[i];

                        // already exist
                        if (uniformMapStack[uniformName]) continue;

                        // does not exist check to initialize with stateSet uniforms
                        if (!stateSetUniforms[uniformName]) continue;

                        uniform = stateSetUniforms[uniformName].getUniform();
                        this._createAttributeStack(uniformMapStack, uniformName, uniform);
                    }
                }

                this._initUniformCache(program);
            }

            var programUniformMap = program.getUniformsCache();
            var activeUniformMap = program.getActiveUniforms();

            var cacheUniformsActive = this._programUniformCache[program._cacheUniformId].active;
            var cacheUniformsForeign = this._programUniformCache[program._cacheUniformId].foreign;

            // apply active uniforms
            // caching uniforms from attribtues make it impossible to overwrite uniform with a custom uniform instance not used in the attributes
            var indexCache = 0;
            for (var keyUniform in activeUniformMap) {
                uniform = activeUniformMap[keyUniform];
                this._checkCacheAndApplyUniform(
                    uniform,
                    cacheUniformsActive,
                    indexCache,
                    programUniformMap,
                    keyUniform
                );
                indexCache++; // TODO not good, for in ordered consistency, etc...
            }

            // apply now foreign uniforms, it's uniforms needed by the program but not contains in attributes used to generate this program
            indexCache = 0;
            var nbForeigns = foreignUniformKeys.length;
            for (i = 0; i < nbForeigns; i++) {
                uniformName = foreignUniformKeys[i];

                uniformStack = uniformMapStack[uniformName];
                var hasStateSetUniformPair = stateset && stateset.uniforms[uniformName];

                if (!hasStateSetUniformPair && !uniformStack) {
                    this._checkErrorUniform(uniformName);
                    continue;
                }

                if (hasStateSetUniformPair) {
                    var stateSetUniformPair = stateset.uniforms[uniformName];
                    var maskValue = stateSetUniformPair.getValue();
                    var stateSetUniform = stateSetUniformPair.getUniform();
                    uniform = this._evaluateOverrideObjectOnStack(
                        uniformStack,
                        stateSetUniform,
                        maskValue
                    );
                } else if (uniformStack._length) {
                    uniform = uniformStack._back.object;
                } else {
                    uniform = uniformStack._globalDefault;
                    this._checkErrorUniform(uniformName);
                }

                this._checkCacheAndApplyUniform(
                    uniform,
                    cacheUniformsForeign,
                    indexCache,
                    programUniformMap,
                    uniformName
                );
                indexCache++;
            }
        },

        // Use to detect changes in RenderLeaf between call to avoid to applyStateSet
        _setStateSetsDrawID: function(id) {
            var values = this._stateSets.getArray();
            for (var i = 0, nbStateSets = this._stateSets.length; i < nbStateSets; i++) {
                values[i].setDrawID(id);
            }
        },

        _stateSetStackChanged: function(id, nbLast) {
            var values = this._stateSets.getArray();
            var nbStateSets = this._stateSets.length;
            if (nbLast !== nbStateSets) return true;

            for (var i = 0; i < nbStateSets; i++) {
                if (id !== values[i].getDrawID()) return true;
            }

            return false;
        }
    }),
    'osg',
    'State'
);

/* harmony default export */ __webpack_exports__["a"] = (State);


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);



var UpdateVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);
    this.visitorType = __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].UPDATE_VISITOR;
    this._numUpdateCallback = 0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        resetStats: function() {
            this._numUpdateCallback = 0;
        },

        apply: function(node) {
            // a way to avoid extra call is to implement getNumChildrenRequiringUpdateTraversal
            // and stateset.requiresUpdateTraversal()

            // handle callback in stateset
            var stateSet = node.getStateSet();
            if (stateSet && stateSet.requiresUpdateTraversal()) {
                var updateCallbackList = stateSet.getUpdateCallbackList();

                var numStateSetUpdateCallback = updateCallbackList.length;
                if (numStateSetUpdateCallback) {
                    this._numUpdateCallback += numStateSetUpdateCallback;
                    for (var i = 0, l = numStateSetUpdateCallback; i < l; i++)
                        updateCallbackList[i].update(stateSet, this);
                }
            }

            // handle callback in nodes
            var ncs = node.getUpdateCallbackList();
            var numUpdateCallback = ncs.length;
            for (var j = 0; j < numUpdateCallback; j++) {
                this._numUpdateCallback++;
                if (!ncs[j].update(node, this)) {
                    return;
                }
            }

            if (node.getNumChildrenRequiringUpdateTraversal() > 0) this.traverse(node);
        }
    }),
    'osg',
    'NodeVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateVisitor);


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_WebGLCaps__ = __webpack_require__(28);



/*
use EXT_disjoint_timer_queryto time webgl calls GPU side average over multiple frames

If timestamp feature is not supported, we virtualize the query by splitting and adding
dummy queries, that way it should handle both nested and interleaved queries.

Also, if you time the same queryID multiple time in the same frame, it will sum the different
queries, that way you can track a particular of gl command for examples

*/

var TimerGPU = function(gl) {
    this._enabled = false;
    this.reset(gl);
};

TimerGPU.FRAME_COUNT = 0;

TimerGPU._instance = new Map();

TimerGPU.instance = function(gl, force) {
    if (!TimerGPU._instance.has(gl)) {
        TimerGPU._instance.set(gl, new TimerGPU(gl));
    } else if (gl && force) {
        TimerGPU._instance.get(gl).reset(gl);
    }
    return TimerGPU._instance.get(gl);
};

TimerGPU.prototype = {
    reset: function(gl) {
        if (gl) {
            var ext = __WEBPACK_IMPORTED_MODULE_1_osg_WebGLCaps__["a" /* default */].instance(gl).getDisjointTimerQuery();
            if (!ext) return this;

            // webgl1 to webgl2
            if (!gl.getQueryParameter) gl.getQueryParameter = ext.getQueryObjectEXT.bind(ext);

            // https://github.com/KhronosGroup/WebGL/blob/master/sdk/tests/conformance/extensions/ext-disjoint-timer-query.html#L102
            // run the page if strange results
            // to validate you gpu/browser has correct gpu queries support
            this._hasTimeElapsed =
                gl.getQuery(ext.TIME_ELAPSED_EXT, ext.QUERY_COUNTER_BITS_EXT) >= 30;
            this._hasTimeStamp = gl.getQuery(ext.TIMESTAMP_EXT, ext.QUERY_COUNTER_BITS_EXT) >= 30;

            if (!this._hasTimeElapsed && !this._hasTimeStamp) {
                return this;
            }

            // no timestamp means not start/end absolute time
            // which means each start must be followed by a end
            // BEFORE any other start (of other queryID)
            if (!this._hasTimeStamp) __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug('Warning: do not use interleaved GPU query');

            this._ext = ext;
            this._gl = gl;
            this._enabled = true;
        }

        this._frameAverageCount = 10;

        this._glQueries = [];
        this._queriesByID = {};
        this._userQueries = []; // for timestamp, it's the same as _glQueries

        // stuffs used to virtualize query (no timestamp)
        this._queryCount = 0;
        this._nbOpened = 0;
    },
    getContext: function() {
        return this._gl;
    },
    setContext: function(gl) {
        this._gl = gl;
    },
    setFrameAverageCount: function(val) {
        this._frameAverageCount = val;
    },

    clearQueries: function() {
        var glQueries = this._glQueries;
        for (var i = 0, nbQueries = glQueries.length; i < nbQueries; ++i) {
            var query = glQueries[i];
            this._gl.deleteQuery(query._pollingStartQuery);
            if (query._pollingEndQuery) this._gl.deleteQuery(query);
        }

        this._userQueries.length = 0;
        this._glQueries.length = 0;
        this._queriesByID = {};
    },

    supportTimeStamp: function() {
        return this._hasTimeStamp;
    },

    // many browser doesn't yet have
    // the marvellous gpu timers
    enable: function() {
        // enable only if we have the extension
        this._enabled = !!this._ext;
    },

    disable: function() {
        this._enabled = false;
    },
    isEnabled: function() {
        return this._enabled;
    },

    setCallback: function(cb) {
        this._callback = cb;
    },

    createUserQuery: function(queryID) {
        var query;
        if (this._hasTimeStamp) {
            query = this.createGLQuery();
        } else {
            query = {
                _startIndex: 0,
                _endIndex: 0
            };
        }

        query._id = queryID;
        query._frame = TimerGPU.FRAME_COUNT;
        query._isOpened = true;
        query._siblings = []; // if the query is called multiple time in the same frame

        return query;
    },

    createGLQuery: function() {
        var query = {};
        query._isWaiting = false; // wait typically 1 or 2 frames
        query._pollingStartQuery = undefined; // gl query object
        query._pollingEndQuery = undefined; // gl query object (timestamp only)
        query._averageTimer = 0.0; // cumulative average time
        query._resultCount = 0; // cumulative average count

        if (this._hasTimeStamp) query._pollingEndQuery = this._gl.createQuery();
        query._pollingStartQuery = this._gl.createQuery();

        this._glQueries.push(query);

        return query;
    },

    getOrCreateLastGLQuery: function() {
        var query = this._glQueries[this._queryCount - 1];
        if (query) return query;

        query = this._glQueries[this._queryCount - 1] = this.createGLQuery();

        return query;
    },

    beginCurrentQuery: function() {
        if (this._nbOpened === 0) return;

        this._queryCount++;

        var query = this.getOrCreateLastGLQuery();
        if (!query._isWaiting) {
            this._gl.beginQuery(this._ext.TIME_ELAPSED_EXT, query._pollingStartQuery);
        }
    },

    endCurrentQuery: function() {
        if (this._nbOpened === 0) return;

        if (!this.getOrCreateLastGLQuery()._isWaiting) {
            this._gl.endQuery(this._ext.TIME_ELAPSED_EXT);
        }
    },

    getAvailableQueryByID: function(queryID) {
        var query = this._queriesByID[queryID];
        if (!query) {
            query = this._queriesByID[queryID] = this.createUserQuery(queryID);
            this._userQueries.push(query);
            return query;
        }

        if (query._frame === TimerGPU.FRAME_COUNT) {
            if (query._isOpened) return query;

            var siblings = query._siblings;
            for (var i = 0, nbSiblings = siblings.length; i < nbSiblings; ++i) {
                var qsib = siblings[i];
                if (qsib._frame !== TimerGPU.FRAME_COUNT || qsib._isOpened) {
                    qsib._frame = TimerGPU.FRAME_COUNT;
                    return qsib;
                }
            }

            var newQuery = this.createUserQuery();
            siblings.push(newQuery);
            return newQuery;
        }

        query._frame = TimerGPU.FRAME_COUNT;

        return query;
    },

    // start recording time if query already exist, don't recreate
    start: function(queryID) {
        // If timing currently disabled or glTimer does not exist, exit early.
        if (!this._enabled) {
            return undefined;
        }

        var query = this.getAvailableQueryByID(queryID);
        query._isOpened = true;

        if (this._hasTimeStamp) {
            if (!query._isWaiting)
                this._ext.queryCounterEXT(query._pollingStartQuery, this._ext.TIMESTAMP_EXT);
        } else {
            this.endCurrentQuery();

            this._nbOpened++;
            query._startIndex = this._queryCount;

            this.beginCurrentQuery();
        }
    },

    // stop query recording (if running) polls for results
    end: function(queryID) {
        if (!this._enabled) {
            return;
        }

        var query = this.getAvailableQueryByID(queryID);
        query._isOpened = false;

        if (this._hasTimeStamp) {
            if (!query._isWaiting)
                this._ext.queryCounterEXT(query._pollingEndQuery, this._ext.TIMESTAMP_EXT);
        } else {
            this.endCurrentQuery();

            query._endIndex = this._queryCount;
            this._nbOpened--;

            this.beginCurrentQuery();
        }
    },

    computeQueryAverageTime: function(query) {
        var average = 0;
        var glQueries = this._glQueries;

        for (var i = query._startIndex; i < query._endIndex; ++i) {
            var glAvg = glQueries[i]._averageTimer;
            if (glAvg < 0) return -1;
            average += glAvg;
        }

        return average;
    },

    computeFullAverageTime: function(query) {
        var average = this.computeQueryAverageTime(query);

        if (average < 0) return -1;

        var siblings = query._siblings;
        for (var i = 0, nbSiblings = siblings.length; i < nbSiblings; ++i) {
            var qsib = siblings[i];
            if (qsib._frame !== TimerGPU.FRAME_COUNT - 1) continue;

            var sibAvg = this.computeQueryAverageTime(qsib);
            if (sibAvg < 0) return -1;
            average += sibAvg;
        }

        return average;
    },

    pollQueries: function() {
        TimerGPU.FRAME_COUNT++;
        this._queryCount = 0;
        this._nbOpened = 0;

        if (!this._enabled || !this._callback) {
            return;
        }

        var glQueries = this._glQueries;
        var nbGlQueries = glQueries.length;
        var i;

        // all timer are corrupted, clear the queries
        var disjoint = this._gl.getParameter(this._ext.GPU_DISJOINT_EXT);
        if (disjoint) {
            for (i = 0; i < nbGlQueries; ++i) {
                glQueries[i]._isWaiting = false;
            }
            return;
        }

        // update average time for each queries
        for (i = 0; i < nbGlQueries; ++i) {
            this.pollQuery(glQueries[i]);
        }

        var userQueries = this._userQueries;
        var nbUserQueries = userQueries.length;

        for (i = 0; i < nbUserQueries; ++i) {
            var query = userQueries[i];
            var average = this.computeFullAverageTime(query);
            if (average > 0) {
                this._callback(average, query._id);
            }
        }
    },

    pollQuery: function(query) {
        query._isWaiting = false;

        // last to be queried
        var lastQuery = this._hasTimeStamp ? query._pollingEndQuery : query._pollingStartQuery;

        // wait till results are ready
        var available = this._gl.getQueryParameter(lastQuery, this._gl.QUERY_RESULT_AVAILABLE);
        if (!available) {
            query._isWaiting = true;
            return 0;
        }

        var timeElapsed;

        if (this._hasTimeStamp) {
            var startTime = this._gl.getQueryParameter(
                query._pollingStartQuery,
                this._gl.QUERY_RESULT
            );
            var endTime = this._gl.getQueryParameter(lastQuery, this._gl.QUERY_RESULT);
            timeElapsed = endTime - startTime;
        } else {
            timeElapsed = this._gl.getQueryParameter(lastQuery, this._gl.QUERY_RESULT);
        }

        query._resultCount++;

        // restart cumulative average every frameAveragecount frames
        if (query._resultCount > this._frameAverageCount) {
            query._averageTimer = 0.0;
            query._resultCount = 1;
        }

        // https://en.wikipedia.org/wiki/Moving_average#Cumulative_moving_average
        query._averageTimer =
            query._averageTimer + (timeElapsed - query._averageTimer) / query._resultCount;

        return query._averageTimer;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (TimerGPU);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// must be sync wiht Interpolator Type
/* harmony default export */ __webpack_exports__["a"] = ({
    Vec3: 0,
    Quat: 1,
    Float: 2,
    FloatCubicBezier: 3,
    Vec3CubicBezier: 4,
    QuatSlerp: 5,
    Matrix: 6,
    Count: 7
});


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_animation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgAnimation_interpolator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgAnimation_CollectAnimationUpdateCallbackVisitor__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgAnimation_target__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgAnimation_UpdateMorph__ = __webpack_require__(86);













var Float = {
    lerp: function(a, b, t) {
        return a + (b - a) * t;
    },
    init: function() {
        return 0.0;
    },
    copy: function(out, src) {
        return src;
    },
    create: function() {
        return 0.0;
    }
};

var TypeToSize = [];
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Float] = 1;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.FloatCubicBezier] = 1;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Vec3] = 3;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Vec3CubicBezier] = 3;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Quat] = 4;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.QuatSlerp] = 4;
TypeToSize[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Matrix] = 16;

var ResultType = [];
ResultType.length = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Count;
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Vec3] = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */];
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Quat] = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */];
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.QuatSlerp] = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["d" /* quat */];
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Float] = Float;
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.FloatCubicBezier] = Float;
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Vec3CubicBezier] = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["f" /* vec3 */];
ResultType[__WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Matrix] = __WEBPACK_IMPORTED_MODULE_3_osg_glMatrix__["c" /* mat4 */];

/**
 *  BasicAnimationManager
 *  @class BasicAnimationManager
 */
var BasicAnimationManager = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);

    this._simulationTime = 0.0;
    this._pauseTime = 0.0;
    this._timeFactor = 1.0;
    this._startTime = 0.0;

    // contains a map with instance animations
    this._instanceAnimations = {};

    // animations to start
    this._startAnimations = {};

    // target contains an array of all target for this manager
    // index in the array is used as ID
    // see Animation.createTarget
    // [
    //     { id: 0,
    //       channels: [],
    //       value: 0.0,
    //       defaultValue: 0.0,
    //       type
    //     },
    //     ...
    // ];
    this._targets = [];
    this._targetsMap = {};

    // target id with active lists
    // [
    //   vec3: [ targetID0, targetID1 ]
    //   Quat: [ targetID2, targetID3,  ... ]
    //   Float: [ ... ]
    // ]
    this._targetsByTypes = [];
    this._targetsByTypes.length = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Count;
    for (var i = 0, ni = this._targetsByTypes.length; i < ni; i++) {
        this._targetsByTypes[i] = [];
    }

    // current playing animations
    this._activeAnimations = {};
    this._activeAnimationList = [];

    // current actives channels by types
    //   [ chanel0, channel1, ... ] // vec3 type
    //   [ chanel2, channel3, ... ] // Quat type
    //   [ chanel5, channel6, ... ] // Float type
    this._activeChannelsByTypes = [];
    this._activeChannelsByTypes.length = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Count;
    for (var j = 0, nj = this._activeChannelsByTypes.length; j < nj; j++) {
        this._activeChannelsByTypes[j] = [];
    }

    // assign all target/channel in animationCallback
    // then they can read it directly
    // animation callback to update
    this._animationsUpdateCallback = {};
    this._animationsUpdateCallbackArray = [];

    // queue of animations to register
    this._animationsToRegister = [];

    //Pause status (true / false)
    this._pause = false;

    this._dirty = false;

    this._seekTime = -1;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    BasicAnimationManager,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        init: function(animations) {
            // reset all
            this._simulationTime = 0.0;
            this._pauseTime = 0.0;
            this._timeFactor = 1.0;
            this._startTime = 0.0;

            // contains a map with instance animations
            this._instanceAnimations = {};

            // animations to start
            this._startAnimations = {};

            this._resetTargets();

            this._activeAnimations = {};
            this._activeAnimationList.length = 0;

            for (var i = 0, ni = this._activeChannelsByTypes.length; i < ni; i++)
                this._activeChannelsByTypes[i].length = 0;

            this._animationsUpdateCallback = {};
            this._animationsUpdateCallbackArray.length = 0;

            this._pause = false;
            this._seekTime = -1;

            // add animations
            this.addAnimations(animations);
        },

        // push all animations into the queue
        addAnimations: function(animations) {
            var instanceAnimationList = this._addAnimation(animations);

            // qeue them to assign target
            Array.prototype.push.apply(this._animationsToRegister, instanceAnimationList);
            this._dirty = true;
            this._registerAnimations();
        },

        update: function(node, nv) {
            if (this._dirty) {
                this._findAnimationUpdateCallback(node);
                this._registerTargetFoundInAnimationCallback();
                this._registerAnimations();
            }

            var t = nv.getFrameStamp().getSimulationTime();

            if (this._seekTime !== -1) this._pauseTime = -this._seekTime + this._startTime + t;
            this._seekTime = -1;

            if (!this._pause) {
                // Not in pause
                this._simulationTime = this._startTime + (t - this._pauseTime);
            } else {
                this._pauseTime = t - this._simulationTime + this._startTime;
            }

            this.updateManager(this._simulationTime * this._timeFactor);
            return true;
        },

        updateManager: function(t) {
            // adds active animations / channels requested
            //
            this._processStartAnimation(t);

            var l = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].ChannelType.Count;
            // update all actives channels by type
            //
            for (var i = 0; i < l; i++) {
                var activeChannelType = this._activeChannelsByTypes[i];
                this._updateChannelsType(t, activeChannelType, __WEBPACK_IMPORTED_MODULE_6_osgAnimation_interpolator__["a" /* default */][i]);
            }

            // update targets
            //
            for (var j = 0; j < l; j++) {
                var targetType = this._targetsByTypes[j];
                this._updateTargetType(targetType, ResultType[j]);
            }

            // update all animation callback
            // expect to have UpdateMatrixTransform
            for (var k = 0, nk = this._animationsUpdateCallbackArray.length; k < nk; k++) {
                var animCallback = this._animationsUpdateCallbackArray[k];
                animCallback.computeChannels();
            }

            // check animation finished
            this._removeFinishedAnimation(t);
        },

        togglePause: function() {
            //Pause the manager's time
            this._pause = !this._pause;
            // if we resume an animation we don't want to move forward the animation
            if (!this._pause) this._seekTime = this._simulationTime;
        },

        getSimulationTime: function() {
            return this._simulationTime;
        },

        setSimulationTime: function(t) {
            this._simulationTime = t;
        },

        setSeekTime: function(t) {
            this._simulationTime = t;
            this._seekTime = t;
        },

        stopAnimation: function(name) {
            var activeAnimationList = this._activeAnimationList;
            for (var i = 0, nbAnim = activeAnimationList.length; i < nbAnim; ++i) {
                if (activeAnimationList[i].name === name) {
                    this._removeActiveChannels(this._instanceAnimations[name]);
                    this._activeAnimations[name] = undefined;
                    activeAnimationList.splice(i, 1);
                    return;
                }
            }
        },

        stopAllAnimation: function() {
            var activeAnimationList = this._activeAnimationList;
            for (var i = 0, nbAnim = activeAnimationList.length; i < nbAnim; ++i) {
                var name = activeAnimationList[i].name;
                this._removeActiveChannels(this._instanceAnimations[name]);
                this._activeAnimations[name] = undefined;
            }
            activeAnimationList.length = 0;
        },

        setTimeFactor: function(timeFactor) {
            var tf = timeFactor / this._timeFactor;
            this._startTime += (this._simulationTime - this._simulationTime * tf) / tf;

            this._timeFactor = timeFactor;

            if (this._pause)
                this._simulationTime += (this._simulationTime - this._simulationTime * tf) / tf;
        },

        getTimeFactor: function() {
            return this._timeFactor;
        },

        isPlaying: function(name) {
            if (this._activeAnimations[name]) return true;
            return false;
        },

        // play animation using object as config
        // {
        //     name: string,
        //     priority: 0,
        //     weight: 1.0,
        //     loop: true / false
        // }
        playAnimationObject: function(obj) {
            var anim = this._instanceAnimations[obj.name];
            if (!anim) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].info('no animation ' + obj.name + ' found');
                return;
            }

            if (this.isPlaying(obj.name)) return;

            anim.priority = obj.priority === undefined ? 0 : obj.priority;
            anim.weight = obj.weight === undefined ? 1.0 : obj.weight;
            anim.loop = obj.loop === undefined ? true : obj.loop;

            this._startAnimations[anim.name] = anim;
        },

        // if first argument is an object
        // playAnimationObject is called instead
        playAnimation: function(name, loop, priority, weight) {
            var animationObject;
            if (typeof name === 'object') animationObject = name;
            else {
                animationObject = {
                    name: name,
                    priority: priority,
                    weight: weight,
                    loop: loop
                };
            }

            return this.playAnimationObject(animationObject);
        },

        getAnimations: function() {
            return this._instanceAnimations;
        },

        _registerAnimations: function() {
            if (!this._targets.length) return;

            for (var i = 0, ni = this._animationsToRegister.length; i < ni; i++) {
                var instanceAnimation = this._animationsToRegister[i];
                this._registerInstanceAnimation(instanceAnimation);
            }

            this._animationsToRegister.length = 0;
            this._dirty = false;
        },

        // Register animation
        //
        // Register animation list all target from channel in the animations and associate
        // target found in the scenegraph. If no target are registered animation cant be
        // registered. In this case animation will be pending and resolved after a visitor
        // extract target.
        _registerInstanceAnimation: function(instanceAnimation) {
            var instanceChannels = instanceAnimation.channels;
            for (var i = 0, ni = instanceChannels.length; i < ni; i++) {
                var instanceChannel = instanceChannels[i];
                var targetName = instanceChannel.channel.target;
                var name = instanceChannel.channel.name;
                var uniqueTargetName = targetName + '.' + name;

                // disply a warning if animation has a channel but not target found in the
                // scene graph. We could probably optimize and removes those channels, but
                // it must be a user decision in case the user plugin different scene
                // graph together and target would appear later in the scenegraph
                if (!this._targetMap[uniqueTargetName]) {
                    __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(
                        'registerInstanceAnimation did not find targetName (' +
                            uniqueTargetName +
                            ') in the scene graph'
                    );
                    continue;
                }

                instanceChannel.targetID = this._targetMap[uniqueTargetName].id;
            }
            return true;
        },

        _findAnimationUpdateCallback: function(node) {
            var collector = new __WEBPACK_IMPORTED_MODULE_7_osgAnimation_CollectAnimationUpdateCallbackVisitor__["a" /* default */]();
            node.accept(collector);
            this._animationsUpdateCallback = collector.getAnimationUpdateCallbackMap();
        },

        // assignTargetToAnimationCallback
        //
        // check all animationUpdateCallback collected and try to
        // assign the channel instance registered in the manager. If a
        // animationUpdateCallback contains channels not known by the
        // manager we skip it.  It means that it should be called
        // after the animations has been registered into the animation
        // manager
        _registerTargetFoundInAnimationCallback: function() {
            this._resetTargets();

            var targetID = 0;
            var targetMap = this._targetMap;
            var targets = this._targets;

            var registerTarget = function(uniqueTargetName, target, name) {
                if (!targetMap[uniqueTargetName]) {
                    targetMap[uniqueTargetName] = target;
                    // assign an id that will be an index into a array
                    target.id = targetID++;
                    targets.push(target);

                    var type = target.type; // split by type
                    this._targetsByTypes[type].push(target);
                } else {
                    // detect differents target instance with same
                    // unique target name. It's a problem
                    if (target !== targetMap[uniqueTargetName])
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(
                            'detected differents target instance with the same name (' + name + ')'
                        );
                }
            }.bind(this);

            var target;
            var name;
            var uniqueTargetName;

            for (var keyAnimation in this._animationsUpdateCallback) {
                var animationCallback = this._animationsUpdateCallback[keyAnimation];

                // handle UpdateBone and UpdateMatrixTransform but not stateSet
                if (
                    animationCallback.getStackedTransforms &&
                    animationCallback.getStackedTransforms().length
                ) {
                    this._animationsUpdateCallbackArray.push(animationCallback);

                    var stackedTransforms = animationCallback.getStackedTransforms();
                    for (var j = 0, nj = stackedTransforms.length; j < nj; j++) {
                        var stackedTransform = stackedTransforms[j];
                        target = stackedTransform.getTarget();
                        name = stackedTransform.getName();
                        uniqueTargetName = animationCallback.getName() + '.' + name;

                        registerTarget(uniqueTargetName, target, name);
                    }
                } else if (animationCallback instanceof __WEBPACK_IMPORTED_MODULE_9_osgAnimation_UpdateMorph__["a" /* default */]) {
                    for (
                        var t = 0, numTarget = animationCallback.getNumTarget();
                        t < numTarget;
                        t++
                    ) {
                        name = animationCallback.getTargetName(t);
                        uniqueTargetName = name + '.' + t;
                        target = animationCallback.getTarget(t);

                        registerTarget(uniqueTargetName, target, name);
                    }
                }
            }
        },

        _addAnimation: function(animations) {
            var instanceAnimationList = [];
            for (var i = 0, ni = animations.length; i < ni; i++) {
                var animation = animations[i];
                var animationName = animation.name;

                if (this._instanceAnimations[animationName]) continue;

                var instanceAnimation = __WEBPACK_IMPORTED_MODULE_5_osgAnimation_animation__["a" /* default */].createInstanceAnimation(animation);
                this._instanceAnimations[animationName] = instanceAnimation;
                instanceAnimationList.push(instanceAnimation);
            }

            return instanceAnimationList;
        },

        // add channels from instance animation to the active channels list
        _addActiveChannels: function(t, instanceAnimation) {
            var instanceChannels = instanceAnimation.channels;
            for (var i = 0, ni = instanceChannels.length; i < ni; i++) {
                var instanceChannel = instanceChannels[i];
                var type = instanceChannel.channel.type;
                instanceChannel.t = t; // reset time
                instanceChannel.instanceAnimation = instanceAnimation; // link with parent animation
                var targetID = instanceChannel.targetID;

                if (targetID === __WEBPACK_IMPORTED_MODULE_8_osgAnimation_target__["a" /* default */].InvalidTargetID) continue;

                this._activeChannelsByTypes[type].push(instanceChannel);
                this._targets[targetID].channels.push(instanceChannel);
            }
        },

        _removeActiveChannels: function(instanceAnimation) {
            var instanceChannels = instanceAnimation.channels;
            for (var i = 0, ni = instanceChannels.length; i < ni; i++) {
                var instanceChannel = instanceChannels[i];
                var type = instanceChannel.channel.type;
                var targetID = instanceChannel.targetID;

                if (targetID === __WEBPACK_IMPORTED_MODULE_8_osgAnimation_target__["a" /* default */].InvalidTargetID) continue;

                // remove channel instance from targetID channel list
                var targetChannelsList = this._targets[targetID].channels;
                var index = targetChannelsList.indexOf(instanceChannel);
                targetChannelsList.splice(index, 1);

                // remove channel from active channels
                var channelTypeList = this._activeChannelsByTypes[type];
                var channelIndex = channelTypeList.indexOf(instanceChannel);
                channelTypeList.splice(channelIndex, 1);
            }
        },

        // blend value from each channels for each target
        // or copy default value if not updated by an active animation
        _updateTargetType: function(targetList, operatorType) {
            for (var i = 0, ni = targetList.length; i < ni; i++) {
                var target = targetList[i];
                var affectedChannels = target.channels;
                var nbChannels = affectedChannels.length;
                // note operatorType operations doesn't always operate on arrays (float)
                // so we can't simply assume that target.value is an array so we need
                // to write "target.value = ..."

                if (nbChannels === 0) {
                    // no blending ?
                    target.value = operatorType.copy(target.value, target.defaultValue);
                } else if (nbChannels === 1) {
                    target.value = operatorType.copy(target.value, affectedChannels[0].value);
                } else {
                    // blend between multiple channels
                    target.value = operatorType.init(target.value);
                    var accumulatedWeight = 0.0;

                    // it's the same as targetOut = (v0 * w0 + v1 * w1 + ...) / (w0 + w1 + ...)
                    for (var j = 0, nj = affectedChannels.length; j < nj; j++) {
                        var achannel = affectedChannels[j];
                        var weight = achannel.weight;
                        accumulatedWeight += weight;
                        // avoid divide by zero and useless lerp
                        if (accumulatedWeight === 0.0 || weight === 0.0) continue;

                        var ratio = weight / accumulatedWeight;
                        target.value = operatorType.lerp(
                            target.value,
                            target.value,
                            achannel.value,
                            ratio
                        );
                    }
                }
            }
        },

        _updateChannelsType: function(t, channels, interpolator) {
            for (var i = 0, ni = channels.length; i < ni; i++) {
                var channel = channels[i];
                var instanceAnimation = channel.instanceAnimation;
                var loop = instanceAnimation.loop;

                var tLocal = t - channel.t;

                // handle loop, careful in case animation is one frame
                if (loop && instanceAnimation.duration > 0.0) {
                    tLocal = tLocal % instanceAnimation.duration;
                }

                interpolator(tLocal + instanceAnimation.firstKeyTime, channel);
            }
        },

        _removeFinishedAnimation: function(t) {
            var activeAnimationList = this._activeAnimationList;

            var i = 0;
            while (i < activeAnimationList.length) {
                var instanceAnimation = activeAnimationList[i];
                var name = instanceAnimation.name;

                if (t > instanceAnimation.end && instanceAnimation.loop === false) {
                    this._removeActiveChannels(instanceAnimation);
                    this._activeAnimations[name] = undefined;
                    activeAnimationList.splice(i, 1);
                } else {
                    i++;
                }
            }
        },

        _addActiveAnimation: function(t, cmd) {
            this._activeAnimations[cmd.name] = cmd; // set animation in the list of active one

            var instanceAnimation = this._instanceAnimations[cmd.name];
            instanceAnimation.start = t;
            instanceAnimation.end = t + instanceAnimation.duration;
            this._addActiveChannels(t, instanceAnimation);

            // keep track of instance animation active in a list
            this._activeAnimationList.push(instanceAnimation);
        },

        // execute start animations events
        // during the updateManager
        _processStartAnimation: function(t) {
            // dont really start animation if we dont have yet targets
            if (!this._targets.length) return;

            var keyAnimation;
            for (keyAnimation in this._startAnimations) {
                var cmd = this._startAnimations[keyAnimation];
                var name = cmd.name;

                if (this.isPlaying(name)) continue;

                this._addActiveAnimation(t, cmd);
            }

            if (keyAnimation !== undefined) this._startAnimations = {};
        },

        _resetTargets: function() {
            this._targetMap = {};
            this._targets.length = 0;

            for (var i = 0, ni = this._targetsByTypes.length; i < ni; i++) {
                this._targetsByTypes[i].length = 0;
            }
        },

        resetAllStackedTransforms: function() {
            var anims = this._animationsUpdateCallbackArray;
            for (var i = 0, nbAnims = anims.length; i < nbAnims; i++) {
                var stacked = anims[i].getStackedTransforms();
                for (var j = 0, nbStacked = stacked.length; j < nbStacked; j++) {
                    stacked[j].resetToDefaultValue();
                }

                // computeChannels is not mandatory here as the following frame will call
                // this function anyway
                anims[i].computeChannels();
            }
        },

        setAnimationLerpEndStart: function(anim, lerpDuration) {
            var channels = anim.channels;
            if (anim.originalDuration === undefined) anim.originalDuration = anim.duration;

            anim.duration = anim.originalDuration + lerpDuration;

            var firstKey = anim.firstKeyTime;
            var animDuration = anim.originalDuration;

            for (var i = 0, nbChannels = channels.length; i < nbChannels; ++i) {
                var ch = channels[i].channel;

                // compare first and last key and detect if we can loop the channel or not
                // it uses an arbitrary epsilon
                if (
                    Math.abs(ch.start - firstKey) > 0.01 ||
                    Math.abs(ch.duration - animDuration) > 0.01
                )
                    continue;

                // update channel end time
                if (ch.originalEnd === undefined) ch.originalEnd = ch.end;

                ch.end = ch.originalEnd + lerpDuration;

                // add or remove additonal key and time

                var sizeElt = TypeToSize[ch.type];
                var size = ch.times.buffer.byteLength / 4;

                // no lerp between end and start
                if (lerpDuration === 0.0) {
                    ch.keys = new Float32Array(ch.keys.buffer, 0, (size - 1) * sizeElt);
                    ch.times = new Float32Array(ch.times.buffer, 0, size - 1);
                } else {
                    // take full size of buffer (with additional keys)
                    ch.keys = new Float32Array(ch.keys.buffer, 0, size * sizeElt);
                    // copy first key
                    var idLast = (size - 1) * sizeElt;
                    for (var j = 0; j < sizeElt; ++j) ch.keys[idLast + j] = ch.keys[j];

                    ch.times = new Float32Array(ch.times.buffer, 0, size);
                    ch.times[size - 1] = ch.times[size - 2] + lerpDuration;
                }
            }
        }
    }),
    'osgAnimation',
    'BasicAnimationManager'
);

BasicAnimationManager.TypeToSize = TypeToSize;

/* harmony default export */ __webpack_exports__["a"] = (BasicAnimationManager);


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channel__ = __webpack_require__(43);




var vec3CopyKeyFrame = function(i, keys, result) {
    result[0] = keys[i++];
    result[1] = keys[i++];
    result[2] = keys[i++];
};

var Vec4CopyKeyFrame = function(i, keys, result) {
    result[0] = keys[i++];
    result[1] = keys[i++];
    result[2] = keys[i++];
    result[3] = keys[i++];
};

var Vec3LerpInterpolator = function(t, channelInstance) {
    var channel = channelInstance.channel;
    var value = channelInstance.value;
    var keys = channel.keys;
    var times = channel.times;

    if (t >= times[times.length - 1]) {
        channelInstance.key = 0;
        vec3CopyKeyFrame(keys.length - 3, keys, value);
        return;
    } else if (t <= times[0]) {
        channelInstance.key = 0;
        vec3CopyKeyFrame(0, keys, value);
        return;
    }

    var i1 = channelInstance.key;
    if (t > times[i1]) while (times[i1 + 1] < t) i1++;
    else if (t < times[i1]) while (times[i1] > t) i1--;

    var t1 = times[i1];
    var t2 = times[i1 + 1];

    var index = i1 * 3;
    var x1 = keys[index++];
    var y1 = keys[index++];
    var z1 = keys[index++];

    var x2 = keys[index++];
    var y2 = keys[index++];
    var z2 = keys[index++];

    var r = (t - t1) / (t2 - t1);

    value[0] = x1 + (x2 - x1) * r;
    value[1] = y1 + (y2 - y1) * r;
    value[2] = z1 + (z2 - z1) * r;
    channelInstance.key = i1;
};

var QuatLerpInterpolator = (function() {
    var q0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create32();
    var q1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create32();

    return function(t, channelInstance) {
        var channel = channelInstance.channel;
        var value = channelInstance.value;
        var keys = channel.keys;
        var times = channel.times;

        if (t >= times[times.length - 1]) {
            channelInstance.key = 0;
            Vec4CopyKeyFrame(keys.length - 4, keys, value);
            return;
        } else if (t <= times[0]) {
            channelInstance.key = 0;
            Vec4CopyKeyFrame(0, keys, value);
            return;
        }

        var i1 = channelInstance.key;
        if (t > times[i1]) while (times[i1 + 1] < t) i1++;
        else if (t < times[i1]) while (times[i1] > t) i1--;

        var t1 = times[i1];
        var t2 = times[i1 + 1];

        var index = i1 * 4;
        q0[0] = keys[index++];
        q0[1] = keys[index++];
        q0[2] = keys[index++];
        q0[3] = keys[index++];

        q1[0] = keys[index++];
        q1[1] = keys[index++];
        q1[2] = keys[index++];
        q1[3] = keys[index++];

        var r = (t - t1) / (t2 - t1);

        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].nlerp(value, q0, q1, r);
        channelInstance.key = i1;
    };
})();

var QuatSlerpInterpolator = (function() {
    var q0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create32();
    var q1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].create32();

    return function(t, channelInstance) {
        var channel = channelInstance.channel;
        var value = channelInstance.value;
        var keys = channel.keys;
        var times = channel.times;

        if (t >= times[times.length - 1]) {
            channelInstance.key = 0;
            Vec4CopyKeyFrame(keys.length - 4, keys, value);
            return;
        } else if (t <= times[0]) {
            channelInstance.key = 0;
            Vec4CopyKeyFrame(0, keys, value);
            return;
        }

        var i1 = channelInstance.key;
        if (t > times[i1]) while (times[i1 + 1] < t) i1++;
        else if (t < times[i1]) while (times[i1] > t) i1--;

        var t1 = times[i1];
        var t2 = times[i1 + 1];

        var index = i1 * 4;
        q0[0] = keys[index++];
        q0[1] = keys[index++];
        q0[2] = keys[index++];
        q0[3] = keys[index++];

        q1[0] = keys[index++];
        q1[1] = keys[index++];
        q1[2] = keys[index++];
        q1[3] = keys[index++];

        var r = (t - t1) / (t2 - t1);

        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["d" /* quat */].slerp(value, q0, q1, r);

        channelInstance.key = i1;
    };
})();

var FloatLerpInterpolator = function(t, channelInstance) {
    var channel = channelInstance.channel;
    var value = channelInstance.value;
    var keys = channel.keys;
    var times = channel.times;

    if (t >= times[times.length - 1]) {
        channelInstance.key = 0;
        channelInstance.value = keys[keys.length - 1];
        return;
    } else if (t <= times[0]) {
        channelInstance.key = 0;
        channelInstance.value = keys[0];
        return;
    }

    var i1 = channelInstance.key;
    if (t > times[i1]) while (times[i1 + 1] < t) i1++;
    else if (t < times[i1]) while (times[i1] > t) i1--;

    var t1 = times[i1];
    var t2 = times[i1 + 1];

    var index = i1;
    var x1 = keys[index++];
    var x2 = keys[index++];

    var r = (t - t1) / (t2 - t1);

    value = x1 + (x2 - x1) * r;
    channelInstance.key = i1;
    channelInstance.value = value;
};

var FloatCubicBezierInterpolator = function(t, channelInstance) {
    var channel = channelInstance.channel;
    var value = channelInstance.value;
    var keys = channel.keys;
    var times = channel.times;

    if (t >= times[times.length - 1]) {
        channelInstance.key = 0;
        channelInstance.value = keys[keys.length - 3];
        return;
    } else if (t <= times[0]) {
        channelInstance.key = 0;
        channelInstance.value = keys[0];
        return;
    }

    var i = channelInstance.key;
    if (t > times[i]) while (times[i + 1] < t) i++;
    else if (t < times[i]) while (times[i] > t) i--;

    var tt = (t - times[i]) / (times[i + 1] - times[i]);
    var oneMinusT = 1.0 - tt;
    var oneMinusT2 = oneMinusT * oneMinusT;
    var oneMinusT3 = oneMinusT2 * oneMinusT;
    var t2 = tt * tt;

    var id = i * 3;
    var v0 = keys[id] * oneMinusT3;
    var v1 = keys[id + 1] * (3.0 * tt * oneMinusT2);
    var v2 = keys[id + 2] * (3.0 * t2 * oneMinusT);
    var v3 = keys[id + 3] * (t2 * tt);

    value = v0 + v1 + v2 + v3;
    channelInstance.key = i;
    channelInstance.value = value;
};

var Vec3CubicBezierInterpolator = (function() {
    var v0 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();

    return function(t, channelInstance) {
        var channel = channelInstance.channel;
        var value = channelInstance.value;
        var keys = channel.keys;
        var times = channel.times;

        if (t >= times[times.length - 1]) {
            channelInstance.key = 0;
            vec3CopyKeyFrame(keys.length - 9, keys, value);
            return;
        } else if (t <= times[0]) {
            channelInstance.key = 0;
            vec3CopyKeyFrame(0, keys, value);
            return;
        }

        var i = channelInstance.key;
        if (t > times[i]) while (times[i + 1] < t) i++;
        else if (t < times[i]) while (times[i] > t) i--;

        var tt = (t - times[i]) / (times[i + 1] - times[i]);
        var oneMinusT = 1.0 - tt;
        var oneMinusT2 = oneMinusT * oneMinusT;
        var oneMinusT3 = oneMinusT2 * oneMinusT;
        var t2 = tt * tt;

        var id = i * 9;
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].scale(v0, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v0, keys[id++], keys[id++], keys[id++]), oneMinusT3);
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].scale(v1, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v1, keys[id++], keys[id++], keys[id++]), 3.0 * tt * oneMinusT2);
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].scale(v2, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v2, keys[id++], keys[id++], keys[id++]), 3.0 * t2 * oneMinusT);
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].scale(v3, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].set(v3, keys[id++], keys[id++], keys[id++]), t2 * tt);

        value[0] = v0[0] + v1[0] + v2[0] + v3[0];
        value[1] = v0[1] + v1[1] + v2[1] + v3[1];
        value[2] = v0[2] + v1[2] + v2[2] + v3[2];
        channelInstance.key = i;
    };
})();

// must be sync wiht Interpolator Type
var ChannelType = __WEBPACK_IMPORTED_MODULE_1_osgAnimation_channel__["a" /* default */].ChannelType;

var moduleInterpolator = {};

// refrence interpolator by channe enum id
moduleInterpolator[ChannelType.Vec3] = Vec3LerpInterpolator;
moduleInterpolator[ChannelType.Quat] = QuatLerpInterpolator;
moduleInterpolator[ChannelType.QuatSlerp] = QuatSlerpInterpolator;
moduleInterpolator[ChannelType.Float] = FloatLerpInterpolator;
moduleInterpolator[ChannelType.FloatCubicBezier] = FloatCubicBezierInterpolator;
moduleInterpolator[ChannelType.Vec3CubicBezier] = Vec3CubicBezierInterpolator;

moduleInterpolator.Vec3LerpInterpolator = Vec3LerpInterpolator;
moduleInterpolator.QuatLerpInterpolator = QuatLerpInterpolator;
moduleInterpolator.QuatSlerpInterpolator = QuatSlerpInterpolator;
moduleInterpolator.FloatLerpInterpolator = FloatLerpInterpolator;
moduleInterpolator.FloatCubicBezierInterpolator = FloatCubicBezierInterpolator;
moduleInterpolator.Vec3CubicBezierInterpolator = Vec3CubicBezierInterpolator;

/* harmony default export */ __webpack_exports__["a"] = (moduleInterpolator);


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_AnimationUpdateCallback__ = __webpack_require__(49);




// search into a subgraph all target
var CollectAnimationUpdateCallbackVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);
    this._animationUpdateCallback = {};
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CollectAnimationUpdateCallbackVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        getAnimationUpdateCallbackMap: function() {
            return this._animationUpdateCallback;
        },

        apply: function(node) {
            var cbs = node.getUpdateCallbackList();

            // collect and remove animation update callback
            for (var i = 0, cbsLength = cbs.length; i < cbsLength; i++) {
                var cb = cbs[i];
                if (cb instanceof __WEBPACK_IMPORTED_MODULE_2_osgAnimation_AnimationUpdateCallback__["a" /* default */]) {
                    this._animationUpdateCallback[cb.getInstanceID()] = cb;
                    //node.removeUpdateCallback( cb );
                }
            }
            this.traverse(node);
        }
    }),
    'osgAnimation',
    'CollectAnimationUpdateCallbackVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (CollectAnimationUpdateCallbackVisitor);


/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__ = __webpack_require__(34);





var StackedMatrix = function(name, matrix) {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._target = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__["a" /* default */].createMatrixTarget(matrix || __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].IDENTITY);
    if (name) this.setName(name);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StackedMatrix,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        init: function(matrix) {
            this.setMatrix(matrix);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(this._target.defaultValue, matrix);
        },

        getTarget: function() {
            return this._target;
        },

        getMatrix: function() {
            return this._target.value;
        },

        setMatrix: function(m) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(this._target.value, m);
        },

        resetToDefaultValue: function() {
            this.setMatrix(this._target.defaultValue);
        },

        applyToMatrix: function(m) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(m, m, this._target.value);
        }
    }),
    'osgAnimation',
    'StackedMatrix'
);

/* harmony default export */ __webpack_exports__["a"] = (StackedMatrix);


/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__ = __webpack_require__(34);






var qIdentity = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();

var StackedQuaternion = function(name, q) {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._target = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__["a" /* default */].createQuatTarget(q || qIdentity);
    if (name) this.setName(name);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StackedQuaternion,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        init: function(q) {
            this.setQuaternion(q);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].copy(this._target.defaultValue, q);
        },

        setQuaternion: function(q) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].copy(this._target.value, q);
        },

        getTarget: function() {
            return this._target;
        },

        resetToDefaultValue: function() {
            this.setQuaternion(this._target.defaultValue);
        },

        applyToMatrix: (function() {
            var matrixTmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();

            return function applyToMatrix(m) {
                var mtmp = matrixTmp;
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromQuat(mtmp, this._target.value);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(m, m, mtmp);
            };
        })()
    }),
    'osgAnimation',
    'StackedQuaternion'
);

/* harmony default export */ __webpack_exports__["a"] = (StackedQuaternion);


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__ = __webpack_require__(34);






/**
 *  StackedTranslate
 */
var StackedTranslate = function(name, translate) {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._target = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__["a" /* default */].createVec3Target(translate || __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].ZERO);
    if (name) this.setName(name);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StackedTranslate,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        init: function(translate) {
            this.setTranslate(translate);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._target.defaultValue, translate);
        },

        setTranslate: function(translate) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._target.value, translate);
        },

        getTarget: function() {
            return this._target;
        },

        resetToDefaultValue: function() {
            this.setTranslate(this._target.defaultValue);
        },

        applyToMatrix: function(m) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].translate(m, m, this._target.value);
        }
    }),
    'osgAnimation',
    'StackedTranslate'
);

/* harmony default export */ __webpack_exports__["a"] = (StackedTranslate);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


var isBufferGZIP = function(arrayBuffer) {
    var typedArray = new Uint8Array(arrayBuffer);
    return typedArray[0] === 0x1f && typedArray[1] === 0x8b;
};

var gunzip = function(arrayBuffer) {
    var typedArray = new Uint8Array(arrayBuffer);
    var zlib = __webpack_require__(133);

    if (!zlib) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error(
            'osg failed to use a gunzip.min.js to uncompress a gz file.\n You can add this vendors to enable this feature or get it at https://github.com/imaya/zlib.js/blob/master/bin/gunzip.min.js'
        );
    }

    var zdec = new zlib.Gunzip(typedArray);
    var result = zdec.decompress();
    return result.buffer;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    isGunzipBuffer: isBufferGZIP,
    gunzip: gunzip
});


/***/ }),
/* 133 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_133__;

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_PagedLOD__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Timer__ = __webpack_require__(21);






var FindPagedLODsVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);
    this._activePagedLODList = undefined;
    this._frameNumber = 0;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    FindPagedLODsVisitor,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_3_osg_PagedLOD__["a" /* default */].getTypeID()) {
                node.setFrameNumberOfLastTraversal(this._frameNumber);
                this._activePagedLODList.add(node);
            }
            this.traverse(node);
        },
        set: function(pagedLODList, frameNumber) {
            this._activePagedLODList = pagedLODList;
            this._frameNumber = frameNumber;
        }
    }),
    'osgDB',
    'FindPagedLODsVisitor'
);

var ReleaseVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    ReleaseVisitor,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            // mark GLResources in nodes to be released
            node.releaseGLObjects();
            this.traverse(node);
        }
    }),
    'osgDB',
    'ReleaseVisitor'
);

var ExpiredPagedLODVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);
    this._childrenList = [];
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    ExpiredPagedLODVisitor,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_3_osg_PagedLOD__["a" /* default */].getTypeID()) {
                this._childrenList.push(node);
                this._markRequestsExpired(node);
            }
            this.traverse(node);
        },

        removeExpiredChildrenAndFindPagedLODs: function(
            plod,
            expiryTime,
            expiryFrame,
            removedChildren
        ) {
            if (!plod.children.length) return false;

            var sizeBefore = removedChildren.length;
            plod.removeExpiredChildren(expiryTime, expiryFrame, removedChildren);
            for (var i = sizeBefore; i < removedChildren.length; i++) {
                removedChildren[i].accept(this);
            }
            return sizeBefore !== removedChildren.length;
        },

        _markRequestsExpired: function(plod) {
            var numRanges = plod._perRangeDataList.length;
            var request;
            for (var i = 0; i < numRanges; i++) {
                request = plod.getDatabaseRequest(i);
                if (request !== undefined) {
                    request._groupExpired = true;
                    request._loadedModel = null;
                }
            }
        },
        reset: function() {
            this._childrenList.length = 0;
        }
    }),
    'osgDB',
    'ExpiredPagedLODVisitor'
);

// Helper functions to avoid undesired memory allocation
var sortByTimeStamp = function(r1, r2) {
    return r2._timeStamp - r1._timeStamp;
};
var sortByPriority = function(r1, r2) {
    // Ask for newer requests first.
    var value = r1._timeStamp - r2._timeStamp;
    // Ask for the greater priority if the timestamp is the same.
    if (value === 0) {
        value = r1._priority - r2._priority;
    }
    return value;
};

/**
 * Database paging class which manages the loading of files
 * and synchronizing of loaded models with the main scene graph.
 *  @class DatabasePager
 */
var DatabasePager = function() {
    this._pendingRequests = [];
    this._pendingNodes = [];
    this._loading = false;
    this._progressCallback = undefined;
    this._lastCB = true;
    this._activePagedLODList = new Set();
    this._childrenToRemoveList = new Set();
    this._downloadingRequestsNumber = 0;
    this._maxRequestsPerFrame = 10;
    this._acceptNewRequests = true;
    this._releaseVisitor = new ReleaseVisitor();
    this._expiredPagedLODVisitor = new ExpiredPagedLODVisitor();
    this._findPagedLODsVisitor = new FindPagedLODsVisitor();
    // In OSG the targetMaximumNumberOfPagedLOD is 300 by default
    // here we set 75 as we need to be more strict with memory in a browser
    // This value can be setted using setTargetMaximumNumberOfPageLOD method.
    this._targetMaximumNumberOfPagedLOD = 75;
    // Helper variables to avoid memory allocation, not for user access
    this._elapsedTime = 0;
    this._beginTime = 0;
    this._availableTime = 0;
};

var DatabaseRequest = function() {
    this._loadedModel = undefined;
    this._group = undefined;
    this._url = undefined;
    this._function = undefined;
    this._timeStamp = 0.0;
    this._groupExpired = false;
    this._priority = 0.0;
    this._options = undefined;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    DatabasePager,
    {
        setTargetMaximumNumberOfPageLOD: function(target) {
            this._targetMaximumNumberOfPagedLOD = target;
        },

        getTargetMaximumNumberOfPageLOD: function() {
            return this._targetMaximumNumberOfPagedLOD;
        },

        setAcceptNewDatabaseRequests: function(acceptNewRequests) {
            this._acceptNewRequests = acceptNewRequests;
        },
        getAcceptNewDatabaseRequests: function() {
            return this._acceptNewRequests;
        },
        reset: function() {
            this._pendingRequests = [];
            this._pendingNodes = [];
            this._loading = false;
            this._lastCB = true;
            this._activePagedLODList.clear();
            this._childrenToRemoveList.clear();
            this._downloadingRequestsNumber = 0;
            this._maxRequestsPerFrame = 10;
            this._acceptNewRequests = true;
            this._targetMaximumNumberOfPagedLOD = 75;
        },

        updateSceneGraph: function(frameStamp) {
            // Progress callback
            if (this._progressCallback !== undefined) {
                // Maybe we should encapsulate this in a promise.
                this.executeProgressCallback();
            }
            // We need to control the time spent in DatabasePager tasks to
            // avoid making the rendering slow.
            // Probably we can have a time parameter to manage all the tasks.
            // Now it is fixed to 0.0025 ms to remove expired childs
            // and 0.005 ms  to add to the scene the loaded requests.

            // Remove expired nodes
            this.removeExpiredSubgraphs(frameStamp, 0.0025);
            // Time to do the requests.
            this.takeRequests();
            // Add the loaded data to the graph
            this.addLoadedDataToSceneGraph(frameStamp, 0.005);
        },

        executeProgressCallback: function() {
            if (this._pendingRequests.length > 0 || this._pendingNodes.length > 0) {
                this._progressCallback(
                    this._pendingRequests.length + this._downloadingRequestsNumber,
                    this._pendingNodes.length
                );
                this._lastCB = false;
            } else {
                if (!this._lastCB) {
                    this._progressCallback(
                        this._pendingRequests.length + this._downloadingRequestsNumber,
                        this._pendingNodes.length
                    );
                    this._lastCB = true;
                }
            }
        },

        setMaxRequestsPerFrame: function(numRequests) {
            this._maxRequestsPerFrame = numRequests;
        },

        getMaxRequestsPerFrame: function() {
            return this._maxRequestsPerFrame;
        },

        getRequestListSize: function() {
            return this._pendingRequests.length + this._downloadingRequestsNumber;
        },

        setProgressCallback: function(cb) {
            this._progressCallback = cb;
        },

        addLoadedDataToSceneGraph: function(frameStamp, availableTime) {
            if (!this._pendingNodes.length || availableTime <= 0.0) return 0.0;

            // Prune the list of database requests.
            var elapsedTime = 0.0;
            var beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
            this._pendingNodes.sort(sortByTimeStamp);

            for (var i = 0; i < this._pendingNodes.length; i++) {
                if (elapsedTime > availableTime) return 0.0;

                var request = this._pendingNodes.shift();
                var frameNumber = frameStamp.getFrameNumber();
                var timeStamp = frameStamp.getSimulationTime();

                // If the request is not expired, then add/register new childs
                if (request._groupExpired === false) {
                    var plod = request._group;
                    plod.setTimeStamp(plod.children.length, timeStamp);
                    plod.setFrameNumber(plod.children.length, frameNumber);
                    plod.addChildNode(request._loadedModel);

                    // Register PagedLODs.
                    if (!this._activePagedLODList.has(plod)) {
                        this.registerPagedLODs(plod, frameNumber);
                    } else {
                        this.registerPagedLODs(request._loadedModel, frameNumber);
                    }
                } else {
                    // Clean the request
                    request._loadedModel = undefined;
                    request = undefined;
                }
                elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
            }
            availableTime -= elapsedTime;
            return availableTime;
        },

        isLoading: function() {
            return this._loading;
        },

        registerPagedLODs: function(subgraph, frameNumber) {
            if (!subgraph) return;
            this._findPagedLODsVisitor.set(this._activePagedLODList, frameNumber);
            subgraph.accept(this._findPagedLODsVisitor);
        },

        requestNodeFile: function(func, url, node, timestamp, priority, options) {
            // Check if we are currently accepting requests.
            if (!this._acceptNewRequests) return undefined;
            // We don't need to determine if the dbrequest is in the queue
            // That is already done in the PagedLOD, so we just create the request
            var dbrequest = new DatabaseRequest();
            dbrequest._group = node;
            dbrequest._function = func;
            dbrequest._url = url;
            dbrequest._timeStamp = timestamp;
            dbrequest._priority = priority;
            dbrequest._options = options;
            this._pendingRequests.push(dbrequest);
            return dbrequest;
        },

        takeRequests: function() {
            if (this._pendingRequests.length) {
                var numRequests = Math.min(this._maxRequestsPerFrame, this._pendingRequests.length);
                this._pendingRequests.sort(sortByPriority);
                for (var i = 0; i < numRequests; i++) {
                    this._downloadingRequestsNumber++;
                    this.processRequest(this._pendingRequests.shift());
                }
            }
        },

        processRequest: function(dbrequest) {
            this._loading = true;
            var that = this;
            // Check if the request is valid;
            if (dbrequest._groupExpired) {
                //Notify.log( 'DatabasePager::processRequest() Request expired.' );
                that._downloadingRequestsNumber--;
                this._loading = false;
                return;
            }

            // Load from function
            if (dbrequest._function !== undefined) {
                this.loadNodeFromFunction(dbrequest._function, dbrequest._group).then(function(
                    child
                ) {
                    that._downloadingRequestsNumber--;
                    dbrequest._loadedModel = child;
                    that._pendingNodes.push(dbrequest);
                    that._loading = false;
                });
            } else if (dbrequest._url !== '') {
                // Load from URL
                this.loadNodeFromURL(dbrequest._url, dbrequest._options).then(function(child) {
                    that._downloadingRequestsNumber--;
                    dbrequest._loadedModel = child;
                    that._pendingNodes.push(dbrequest);
                    that._loading = false;
                });
            }
        },

        loadNodeFromFunction: function(func, plod) {
            // Need to call with pagedLOD as parent, to be able to have multiresolution structures.
            var promise = func(plod);
            // should func always return a promise ?
            if (!promise) return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject();
            if (promise && promise.then) return promise;
            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(promise);
        },

        loadNodeFromURL: function(url, options) {
            var ReaderParser = __webpack_require__(37).default;
            // Call to ReaderParser just in case there is a custom readNodeURL Callback
            // See osgDB/options.js and/or osgDB/Input.js
            // TODO: We should study if performance can be improved if separating the XHTTP request from
            // the parsing. This way several/many request could be done at the same time.
            // Also we should be able to cancel requests, so there is a need to have access
            // to the HTTPRequest Object
            return ReaderParser.readNodeURL(url, options);
        },

        releaseGLExpiredSubgraphs: function(availableTime) {
            this._availableTime = availableTime;
            if (!this._childrenToRemoveList.size || availableTime <= 0.0) return 0.0;
            // We need to test if we have time to flush
            this._elapsedTime = 0.0;
            this._beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
            this._childrenToRemoveList.forEach(this._releaseExpiredSubgraphs, this);
            this._availableTime -= this._elapsedTime;
            return this._availableTime;
        },

        // function to avoid memory allocation in forEach
        _releaseExpiredSubgraphs: function(node) {
            // If we don't have more time, break the loop.
            if (this._elapsedTime > this._availableTime) return;
            this._childrenToRemoveList.delete(node);
            node.accept(this._releaseVisitor);
            node.removeChildren();
            node = null;
            this._elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(this._beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
        },

        removeExpiredSubgraphs: function(frameStamp, availableTime) {
            if (frameStamp.getFrameNumber() === 0) return 0.0;
            var numToPrune = this._activePagedLODList.size - this._targetMaximumNumberOfPagedLOD;
            var expiryTime = frameStamp.getSimulationTime() - 0.1;
            var expiryFrame = frameStamp.getFrameNumber() - 1;
            // First traverse and remove inactive PagedLODs, as their children will
            // certainly have expired.
            // TODO: Then traverse active nodes if we still need to prune.
            if (numToPrune > 0) {
                availableTime = this.removeExpiredChildren(
                    numToPrune,
                    expiryTime,
                    expiryFrame,
                    availableTime
                );
            }
            return availableTime;
        },

        removeExpiredChildren: function(numToPrune, expiryTime, expiryFrame, availableTime) {
            // Iterate over the activePagedLODList to remove expired children
            // We need to control the time spent in remove childs.
            var elapsedTime = 0.0;
            var beginTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
            var that = this;
            var removedChildren = [];
            var expiredPagedLODVisitor = this._expiredPagedLODVisitor;
            expiredPagedLODVisitor.reset();

            this._activePagedLODList.forEach(function(plod) {
                // Check if we have time, else return 0
                if (elapsedTime > availableTime) return 0.0;
                if (numToPrune < 0) return availableTime;
                // See if plod is still active, so we don't have to prune
                if (expiryFrame < plod.getFrameNumberOfLastTraversal()) return availableTime;
                expiredPagedLODVisitor.removeExpiredChildrenAndFindPagedLODs(
                    plod,
                    expiryTime,
                    expiryFrame,
                    removedChildren
                );
                for (var i = 0; i < expiredPagedLODVisitor._childrenList.length; i++) {
                    that._activePagedLODList.delete(expiredPagedLODVisitor._childrenList[i]);
                    numToPrune--;
                }
                // Add to the remove list all the childs deleted
                for (i = 0; i < removedChildren.length; i++) {
                    that._childrenToRemoveList.add(removedChildren[i]);
                }
                expiredPagedLODVisitor._childrenList.length = 0;
                removedChildren.length = 0;
                elapsedTime = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
            });
            availableTime -= elapsedTime;
            return availableTime;
        }
    },
    'osgDB',
    'DatabasePager'
);

/* harmony default export */ __webpack_exports__["a"] = (DatabasePager);


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_animation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgDB_readerParser__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgAnimation_StackedMatrix__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgAnimation_StackedScale__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgAnimation_MorphGeometry__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Geometry__ = __webpack_require__(10);












var rejectObject = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].rejectObject;

var osgAnimationWrapper = {};

var channelCtor = function() {};

var registry = __WEBPACK_IMPORTED_MODULE_6_osgDB_readerParser__["default"].registry();
registry.registerObject('osgAnimation.Vec3LerpChannel', channelCtor);
registry.registerObject('osgAnimation.FloatLerpChannel', channelCtor);
registry.registerObject('osgAnimation.QuatSlerpChannel', channelCtor);
registry.registerObject('osgAnimation.QuatLerpChannel', channelCtor);
registry.registerObject('osgAnimation.FloatCubicBezierChannel', channelCtor);
registry.registerObject('osgAnimation.Vec3CubicBezierChannel', channelCtor);
// needs to be cleaned in c++
registry.registerObject('osgAnimation.StackedMatrixElement', __WEBPACK_IMPORTED_MODULE_7_osgAnimation_StackedMatrix__["a" /* default */]);
registry.registerObject('osgAnimation.StackedScaleElement', __WEBPACK_IMPORTED_MODULE_8_osgAnimation_StackedScale__["a" /* default */]);

osgAnimationWrapper.Animation = function(input) {
    var jsonObj = input.getJSON();
    if (jsonObj.Name === undefined || !jsonObj.Channels || jsonObj.Channels.length === 0) {
        return rejectObject('Animation', jsonObj);
    }

    var arrayChannelsPromise = [];

    // channels
    for (var i = 0, l = jsonObj.Channels.length; i < l; i++) {
        var promise = input.setJSON(jsonObj.Channels[i]).readObject();
        arrayChannelsPromise.push(promise);
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(arrayChannelsPromise).then(function(channels) {
        return __WEBPACK_IMPORTED_MODULE_5_osgAnimation_animation__["a" /* default */].createAnimation(channels, jsonObj.Name);
    });
};

osgAnimationWrapper.StandardVec3Channel = function(input, channel, creator) {
    var jsonObj = input.getJSON();
    if (
        jsonObj.TargetName === undefined ||
        !jsonObj.KeyFrames ||
        !jsonObj.Name ||
        !jsonObj.KeyFrames.Time ||
        !jsonObj.KeyFrames.Key ||
        jsonObj.KeyFrames.Key.length !== 3
    ) {
        return rejectObject('StandardVec3Channel', jsonObj);
    }

    var jsTime = input.setJSON(jsonObj.KeyFrames.Time).readBufferArray();
    var jsKeyX = input.setJSON(jsonObj.KeyFrames.Key[0]).readBufferArray();
    var jsKeyY = input.setJSON(jsonObj.KeyFrames.Key[1]).readBufferArray();
    var jsKeyZ = input.setJSON(jsonObj.KeyFrames.Key[2]).readBufferArray();

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([jsTime, jsKeyX, jsKeyY, jsKeyZ]).then(function(pArray) {
        var eTime = pArray[0].getElements();
        var eKeyX = pArray[1].getElements();
        var eKeyY = pArray[2].getElements();
        var eKeyZ = pArray[3].getElements();

        // the keys and time array are always create with a slightly biffer array buffer
        // (one additional element) in case we want to lerp between end and start
        var size = eTime.length;
        var keys = new Float32Array(new ArrayBuffer(4 * (size + 1) * 3), 0, size * 3);
        var times = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);

        for (var i = 0; i < size; i++) {
            var id = i * 3;
            times[i] = eTime[i];
            keys[id++] = eKeyX[i];
            keys[id++] = eKeyY[i];
            keys[id] = eKeyZ[i];
        }

        creator(keys, times, jsonObj.TargetName, jsonObj.Name, channel);
        return channel;
    });
};

osgAnimationWrapper.StandardQuatChannel = function(input, channel, creator) {
    var jsonObj = input.getJSON();
    if (
        jsonObj.TargetName === undefined ||
        !jsonObj.KeyFrames ||
        !jsonObj.Name ||
        !jsonObj.KeyFrames.Time ||
        !jsonObj.KeyFrames.Key ||
        jsonObj.KeyFrames.Key.length !== 4
    ) {
        return rejectObject('StandardQuatChannel', jsonObj);
    }

    var jsTime = input.setJSON(jsonObj.KeyFrames.Time).readBufferArray();
    var jsKeyX = input.setJSON(jsonObj.KeyFrames.Key[0]).readBufferArray();
    var jsKeyY = input.setJSON(jsonObj.KeyFrames.Key[1]).readBufferArray();
    var jsKeyZ = input.setJSON(jsonObj.KeyFrames.Key[2]).readBufferArray();
    var jsKeyW = input.setJSON(jsonObj.KeyFrames.Key[3]).readBufferArray();

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([jsTime, jsKeyX, jsKeyY, jsKeyZ, jsKeyW]).then(function(pArray) {
        var eTime = pArray[0].getElements();
        var eKeyX = pArray[1].getElements();
        var eKeyY = pArray[2].getElements();
        var eKeyZ = pArray[3].getElements();
        var eKeyW = pArray[4].getElements();

        var size = eTime.length;
        var keys = new Float32Array(new ArrayBuffer(4 * (size + 1) * 4), 0, size * 4);
        var times = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);

        for (var i = 0; i < size; i++) {
            var id = i * 4;
            times[i] = eTime[i];
            keys[id++] = eKeyX[i];
            keys[id++] = eKeyY[i];
            keys[id++] = eKeyZ[i];
            keys[id] = eKeyW[i];
        }
        creator(keys, times, jsonObj.TargetName, jsonObj.Name, channel);
        return channel;
    });
};

osgAnimationWrapper.StandardFloatChannel = function(input, channel, creator) {
    var jsonObj = input.getJSON();
    if (
        jsonObj.TargetName === undefined ||
        !jsonObj.KeyFrames ||
        !jsonObj.Name ||
        !jsonObj.KeyFrames.Time ||
        !jsonObj.KeyFrames.Key
    ) {
        return rejectObject('StandardFloatChannel', jsonObj);
    }

    var jsTime = input.setJSON(jsonObj.KeyFrames.Time).readBufferArray();
    var jsKey = input.setJSON(jsonObj.KeyFrames.Key).readBufferArray();

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([jsTime, jsKey]).then(function(pArray) {
        var eTime = pArray[0].getElements();
        var eKey = pArray[1].getElements();

        var size = eTime.length;
        var keys = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);
        var times = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);

        for (var i = 0; i < size; i++) {
            times[i] = eTime[i];
            keys[i] = eKey[i];
        }

        creator(keys, times, jsonObj.TargetName, jsonObj.Name, channel);
        return channel;
    });
};

osgAnimationWrapper.Vec3LerpChannel = function(input, channel) {
    return osgAnimationWrapper.StandardVec3Channel(input, channel, __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createVec3Channel);
};

osgAnimationWrapper.QuatLerpChannel = function(input, channel) {
    return osgAnimationWrapper.StandardQuatChannel(input, channel, __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createQuatChannel);
};

osgAnimationWrapper.QuatSlerpChannel = function(input, channel) {
    // nlerp is less expensive than slerp
    return osgAnimationWrapper.StandardQuatChannel(input, channel, __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createQuatChannel);
    // return osgAnimationWrapper.StandardQuatChannel( input, channel, Channel.createQuatSlerpChannel );
};

osgAnimationWrapper.FloatLerpChannel = function(input, channel) {
    return osgAnimationWrapper.StandardFloatChannel(input, channel, __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createFloatChannel);
};

osgAnimationWrapper.FloatCubicBezierChannel = function(input, channel) {
    var jsonObj = input.getJSON();

    if (
        jsonObj.TargetName === undefined ||
        !jsonObj.KeyFrames ||
        !jsonObj.Name ||
        !jsonObj.KeyFrames.Time ||
        !jsonObj.KeyFrames.Position ||
        !jsonObj.KeyFrames.ControlPointOut ||
        !jsonObj.KeyFrames.ControlPointIn
    ) {
        return rejectObject('FloatCubicBezierChannel', jsonObj);
    }

    var arrayPromise = [];
    var keyFrames = window.Object.keys(jsonObj.KeyFrames);
    var i;
    for (i = 0; i < keyFrames.length; i++)
        arrayPromise.push(input.setJSON(jsonObj.KeyFrames[keyFrames[i]]).readBufferArray());

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(arrayPromise).then(function(pArray) {
        var controlPointIn = pArray[0].getElements();
        var controlPointOut = pArray[1].getElements();
        var position = pArray[2].getElements();
        var time = pArray[3].getElements();

        var size = time.length;
        var keys = new Float32Array(new ArrayBuffer(4 * (size + 1) * 3), 0, size * 3);
        var times = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);

        for (i = 0; i < size; i++) {
            var id = i * 3;

            times[i] = time[i];
            keys[id++] = position[i];
            keys[id++] = controlPointIn[i];
            keys[id] = controlPointOut[i];
        }
        __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createFloatCubicBezierChannel(
            keys,
            times,
            jsonObj.TargetName,
            jsonObj.Name,
            channel
        );
        return channel;
    });
};

osgAnimationWrapper.Vec3CubicBezierChannel = function(input, channel) {
    var jsonObj = input.getJSON();

    if (
        jsonObj.TargetName === undefined ||
        !jsonObj.KeyFrames ||
        !jsonObj.Name ||
        !jsonObj.KeyFrames.Time ||
        !jsonObj.KeyFrames.Position ||
        !jsonObj.KeyFrames.ControlPointOut ||
        !jsonObj.KeyFrames.ControlPointIn ||
        jsonObj.KeyFrames.Position.length !== 3 ||
        jsonObj.KeyFrames.ControlPointIn.length !== 3 ||
        jsonObj.KeyFrames.ControlPointOut.length !== 3
    ) {
        return rejectObject('Vec3CubicBezierChannel', jsonObj);
    }

    var arrayPromise = [];

    //Reads all keyframes
    var keyFrames = window.Object.keys(jsonObj.KeyFrames);
    var i;
    for (i = 0; i < keyFrames.length; i++) {
        var key = keyFrames[i];
        var jsonAttribute = jsonObj.KeyFrames[key];
        if (key !== 'Time') {
            arrayPromise.push(input.setJSON(jsonAttribute[0]).readBufferArray());
            arrayPromise.push(input.setJSON(jsonAttribute[1]).readBufferArray());
            arrayPromise.push(input.setJSON(jsonAttribute[2]).readBufferArray());
        } else arrayPromise.push(input.setJSON(jsonAttribute).readBufferArray());
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(arrayPromise).then(function(pArray) {
        var cpi0 = pArray[0].getElements();
        var cpi1 = pArray[1].getElements();
        var cpi2 = pArray[2].getElements();
        var cpo0 = pArray[3].getElements();
        var cpo1 = pArray[4].getElements();
        var cpo2 = pArray[5].getElements();
        var p0 = pArray[6].getElements();
        var p1 = pArray[7].getElements();
        var p2 = pArray[8].getElements();
        var time = pArray[9].getElements();

        var size = time.length;
        var keys = new Float32Array(new ArrayBuffer(4 * (size + 1) * 9), 0, size * 9);
        var times = new Float32Array(new ArrayBuffer(4 * (size + 1)), 0, size);

        for (i = 0; i < size; i++) {
            var id = i * 9;

            times[i] = time[i];
            keys[id++] = p0[i];
            keys[id++] = p1[i];
            keys[id++] = p2[i];

            keys[id++] = cpi0[i];
            keys[id++] = cpi1[i];
            keys[id++] = cpi2[i];

            keys[id++] = cpo0[i];
            keys[id++] = cpo1[i];
            keys[id] = cpo2[i];
        }
        __WEBPACK_IMPORTED_MODULE_4_osgAnimation_channel__["a" /* default */].createVec3CubicBezierChannel(
            keys,
            times,
            jsonObj.TargetName,
            jsonObj.Name,
            channel
        );
        return channel;
    });
};

osgAnimationWrapper.BasicAnimationManager = function(input, manager) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Animations) return rejectObject('BasicAnimationManager', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, manager);

    var animPromises = [];

    for (var i = 0, l = jsonObj.Animations.length; i < l; i++) {
        var promiseAnimation = input.setJSON(jsonObj.Animations[i]).readObject();
        if (promiseAnimation.isRejected()) {
            __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn('An Animation failed on the parsing!');
            continue;
        }
        animPromises.push(promiseAnimation);
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(animPromises).then(function(animations) {
        manager.init(animations);
        return manager;
    });
};

osgAnimationWrapper.UpdateMatrixTransform = function(input, umt) {
    var jsonObj = input.getJSON();
    //  some stackedTransform on bones has no name but the transform is usefull
    if (/*!jsonObj.Name ||*/ !jsonObj.StackedTransforms) {
        return rejectObject('UpdateMatrixTransform', jsonObj);
    }

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, umt);

    var promiseArray = [];
    var i, l;
    for (i = 0, l = jsonObj.StackedTransforms.length; i < l; i++) {
        var promiseStacked = input.setJSON(jsonObj.StackedTransforms[i]).readObject();
        if (promiseStacked.isRejected()) {
            __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn('A stacked transforms failed on the parsing!');
            continue;
        }
        promiseArray.push(promiseStacked);
    }

    // when UpdateMatrixTransform is ready
    // compute the default value data
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promiseArray).then(function(array) {
        var stack = umt.getStackedTransforms();
        for (i = 0, l = array.length; i < l; i++) stack.push(array[i]);
        umt.computeChannels();
        return umt;
    });
};

osgAnimationWrapper.StackedTranslate = function(input, st) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Name || !jsonObj.Translate) return rejectObject('StackedTranslate', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, st);

    st.init(jsonObj.Translate);

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(st);
};

osgAnimationWrapper.StackedQuaternion = function(input, st) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Name || !jsonObj.Quaternion) return rejectObject('StackedQuaternion', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, st);

    st.init(jsonObj.Quaternion);

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(st);
};

osgAnimationWrapper.StackedRotateAxis = function(input, st) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Axis || jsonObj.Angle === undefined) {
        return rejectObject('StackedRotateAxis', jsonObj);
    }

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, st);

    st.init(jsonObj.Axis, jsonObj.Angle);

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(st);
};

osgAnimationWrapper.StackedMatrix = function(input, sme) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Name || !jsonObj.Matrix) return rejectObject('StackedMatrix', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, sme);

    sme.init(jsonObj.Matrix);

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(sme);
};

osgAnimationWrapper.StackedScale = function(input, stc) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Name || !jsonObj.Scale) return rejectObject('StackedScale', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, stc);

    stc.init(jsonObj.Scale);

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(stc);
};

osgAnimationWrapper.Bone = function(input, bone) {
    var jsonObj = input.getJSON();
    if (!jsonObj.InvBindMatrixInSkeletonSpace) return rejectObject('Bone', jsonObj);

    var promise = __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].MatrixTransform(input, bone);

    bone.setInvBindMatrixInSkeletonSpace(jsonObj.InvBindMatrixInSkeletonSpace);

    if (jsonObj.BoundingBox) {
        // It is mandatory because we need it for shadows and culling
        var bbox = bone.getBoneBoundingBox();
        bbox.setMax(jsonObj.BoundingBox.max);
        bbox.setMin(jsonObj.BoundingBox.min);
    }

    return promise;
};

osgAnimationWrapper.UpdateBone = osgAnimationWrapper.UpdateMatrixTransform;

osgAnimationWrapper.UpdateSkeleton = function(input, upSkl) {
    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, upSkl);
    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(upSkl);
};

osgAnimationWrapper.Skeleton = __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].MatrixTransform;

osgAnimationWrapper.RigGeometry = function(input, rigGeom) {
    var jsonObj = input.getJSON();

    // check boneMap
    if (!jsonObj.SourceGeometry) return rejectObject('RigGeometry', jsonObj);

    if (!jsonObj.BoneMap) __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn('No boneMap found in a RigGeometry !');

    //Import rigGeometry as Geometry + BoneMap
    var rigPromise = __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Geometry(input, rigGeom);
    rigGeom._boneNameID = jsonObj.BoneMap;

    //Import source geometry and merge it with the rigGeometry
    var sourceGeometry = jsonObj.SourceGeometry['osg.Geometry'];
    var geomPromise;
    if (sourceGeometry) {
        input.setJSON(sourceGeometry);
        rigGeom.setSourceGeometry(new __WEBPACK_IMPORTED_MODULE_10_osg_Geometry__["a" /* default */]());
        geomPromise = __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Geometry(input, rigGeom.getSourceGeometry());
    } else {
        sourceGeometry = jsonObj.SourceGeometry['osgAnimation.MorphGeometry'];
        if (sourceGeometry) {
            input.setJSON(sourceGeometry);
            rigGeom.setSourceGeometry(new __WEBPACK_IMPORTED_MODULE_9_osgAnimation_MorphGeometry__["a" /* default */]());
            geomPromise = osgAnimationWrapper.MorphGeometry(input, rigGeom.getSourceGeometry());
        } else {
            __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn('SourceGeometry type no recognized');
        }
    }

    // not sure if it's normal but rig geometry don't have UniqueID
    if (rigGeom._uniqueID === undefined) rigGeom._uniqueID = sourceGeometry.UniqueID;

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all([rigPromise, geomPromise]).then(function() {
        rigGeom.mergeChildrenData();
        return rigGeom;
    });
};

osgAnimationWrapper.MorphGeometry = function(input, morphGeometry) {
    var jsonObj = input.getJSON();

    if (!jsonObj.MorphTargets) return rejectObject('MorphGeometry', jsonObj);

    var morphTargets = jsonObj.MorphTargets;
    var arrayPromise = [];

    // arrayPromise[0] is the morphGeometry
    arrayPromise.push(__WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Geometry(input, morphGeometry));

    for (var i = 0, l = morphTargets.length; i < l; i++)
        arrayPromise.push(input.setJSON(morphTargets[i]).readObject());

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(arrayPromise).then(function(promiseResultArray) {
        var morphGeometryResolved = promiseResultArray[0];

        var targets = morphGeometryResolved.getMorphTargets();
        for (var j = 1, jn = promiseResultArray.length; j < jn; j++)
            targets.push(promiseResultArray[j]);

        morphGeometryResolved.mergeChildrenVertexAttributeList();
        return morphGeometryResolved;
    });
};

osgAnimationWrapper.UpdateMorph = function(input, updateMorph) {
    var jsonObj = input.getJSON();
    if (!jsonObj.TargetMap) return rejectObject('UpdateMorph', jsonObj);

    __WEBPACK_IMPORTED_MODULE_3_osgWrappers_serializers_osg__["a" /* default */].Object(input, updateMorph);

    var keys = window.Object.keys(jsonObj.TargetMap);
    for (var i = 0, l = keys.length; i < l; i++) {
        var key = keys[i];
        updateMorph.addTarget(jsonObj.TargetMap[key], parseInt(key, 10));
    }

    return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.resolve(updateMorph);
};

osgAnimationWrapper.StackedMatrixElement = osgAnimationWrapper.StackedMatrix;
osgAnimationWrapper.StackedScaleElement = osgAnimationWrapper.StackedScale;

/* harmony default export */ __webpack_exports__["a"] = (osgAnimationWrapper);


/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgWrappers_serializers_osg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgText_Text__ = __webpack_require__(137);





var osgTextWrapper = {};

osgTextWrapper.Text = function(input, node) {
    var jsonObj = input.getJSON();
    if (!jsonObj.Text) return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject();

    var promise = __WEBPACK_IMPORTED_MODULE_1_osgWrappers_serializers_osg__["a" /* default */].Node(input, node);
    node.setColor(jsonObj.Color);
    node.setText(jsonObj.Text);
    node.setAutoRotateToScreen(jsonObj.AutoRotateToScreen);
    node.setPosition(jsonObj.Position);
    node.setCharacterSize(jsonObj.CharacterSize);

    if (jsonObj.Layout === 'VERTICAL') {
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].error('Vertical Alignment not supported');
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject();
    }
    var alignment = jsonObj.Alignment;
    if (jsonObj.Alignment.indexOf('BASE_LINE') > -1) {
        if (jsonObj.Alignment === 'LEFT_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].LEFT_CENTER;
        } else if (jsonObj.Alignment === 'CENTER_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].CENTER_CENTER;
        } else if (jsonObj.Alignment === 'RIGHT_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].RIGHT_CENTER;
        } else if (jsonObj.Alignment === 'LEFT_BOTTOM_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].LEFT_BOTTOM;
        } else if (jsonObj.Alignment === 'CENTER_BOTTOM_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].CENTER_BOTTOM;
        } else if (jsonObj.Alignment === 'RIGHT_BOTTOM_BASE_LINE') {
            alignment = __WEBPACK_IMPORTED_MODULE_3_osgText_Text__["a" /* default */].RIGHT_BOTTOM;
        }
    }
    node.setAlignment(alignment);
    node.setLayout(jsonObj.Layout);

    return promise;
};

/* harmony default export */ __webpack_exports__["a"] = (osgTextWrapper);


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_AutoTransform__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Node__ = __webpack_require__(9);













/**
 *  @class Text: Text 2D using a Canvas2D as a texture for a textured quad.
 *  Notes: The OSGjs Text has been implemented like OSG osgText::Text as much as possible. However there are some
 *  things that should be noted:
 *  - This Text is far more simple than OSG ones, it only supports basic functionality.
 *  - In contrast to OSG, Text inherits from AutoTransform in osgjs.
 *  - Supported fonts are not the same in HTML than in OSG/C++.
 *  - Vertical layout is not supported right now.
 *  - BaseLine alignments are not supported, instead they are converted to supported ones if parsing a osgjs file.
 *  - Set the color in the range [ 0 - 1 ], as if you were working with OSG.
 *  - Texts are generated as a canvas 2D texture sticked in a quad. The size of the texture is the next power of two of the current size of the
 *    text so the bigger is your characterSize, the more memory it will consume.
 */
var Text = function(text) {
    __WEBPACK_IMPORTED_MODULE_3_osg_AutoTransform__["a" /* default */].call(this);
    // create a canvas element
    this._canvas = document.createElement('canvas');
    this._context = this._canvas.getContext('2d');
    this._matrixTransform = new __WEBPACK_IMPORTED_MODULE_4_osg_MatrixTransform__["a" /* default */]();
    this.addChild(this._matrixTransform);
    this._text = '';
    if (text !== undefined) this._text = text;
    this._font = 'monospace';
    // Vec4 value to load/return
    this._color = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 0.0, 1.0);
    // This determines the text color, it can take a hex value or rgba value (e.g. rgba(255,0,0,0.5))
    this._fillStyle = 'rgba( 0, 0, 0, 1 )';
    // This determines the alignment of text, e.g. left, center, right
    this._context.textAlign = 'center';
    this._textX = undefined;
    // This determines the baseline of the text, e.g. top, middle, bottom
    this._context.baseLine = 'middle';
    this._textY = undefined;
    // Size of the textured quad in meters.
    this._characterSize = 1;
    this._characterSizeMode = Text.OBJECT_COORDS;
    // Font resolution
    this._fontSize = 32;
    this._geometry = undefined;
    this._autoRotateToScreen = false;
    this._position = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
    this._layout = Text.LEFT_TO_RIGHT;
    this._alignment = Text.CENTER_CENTER;
    // NPOT textures
    this._forcePowerOfTwo = false;
    // Lazy initialization
    this._texture = new __WEBPACK_IMPORTED_MODULE_6_osg_Texture__["default"]();
    this.drawText();
    this._dirty = false;

    // We need to keep track of modelView Matrix
    this._previousModelView = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
};

// CharacterSizeMode
Text.OBJECT_COORDS = 0;
Text.SCREEN_COORDS = 1;
Text.OBJECT_COORDS_WITH_MAXIMUM_SCREEN_SIZE_CAPPED_BY_FONT_HEIGHT = 2;

// Layout enum
Text.LEFT_TO_RIGHT = 'ltr';
Text.RIGHT_TO_LEFT = 'rtl';

// Alignment enum
Text.LEFT_TOP = 0;
Text.LEFT_CENTER = 1;
Text.LEFT_BOTTOM = 2;

Text.CENTER_TOP = 3;
Text.CENTER_CENTER = 4;
Text.CENTER_BOTTOM = 5;

Text.RIGHT_TOP = 6;
Text.RIGHT_CENTER = 7;
Text.RIGHT_BOTTOM = 8;

/** @lends Text.prototype */
__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeNode(
    Text,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_AutoTransform__["a" /* default */].prototype, {
        drawText: function() {
            if (this._geometry !== undefined) {
                this._matrixTransform.removeChild(this._geometry);
                // The text could be dynamic, so we need to remove GL objects
                this._geometry.releaseGLObjects();
            }
            if (!this._text) return;
            this.setTextProperties();
            this._canvas.width = this._context.measureText(this._text).width;
            this._canvas.height = this._fontSize * 2;
            // For devices not supporting NPOT textures
            if (this._forcePowerOfTwo) {
                this._canvas.width = this._nextPowerOfTwo(this._canvas.width);
                this._canvas.height = this._nextPowerOfTwo(this._canvas.height);
            }
            // We need to set the text properties again, as the canvas size cold change.
            this.setTextProperties();
            this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
            this._context.fillText(this._text, this._textX, this._textY);
            // Right now we set the pivot point to center, to assure the bounding box is correct when rendering billboards.
            // TODO: Possibility to set different pivot point so we can have missing alignments.
            var aspectRatio = this._canvas.width / this._canvas.height;
            var quadWidth = this._characterSize * aspectRatio;
            this._geometry = __WEBPACK_IMPORTED_MODULE_5_osg_shape__["a" /* default */].createTexturedQuadGeometry(
                -quadWidth / 2,
                -this._characterSize / 2,
                0,
                quadWidth,
                0,
                0,
                0,
                this._characterSize,
                0
            );
            // create a texture to attach the canvas2D
            this._texture.setTextureSize(this._canvas.width, this._canvas.height);
            this._texture.setMinFilter('LINEAR');
            this._texture.setMagFilter('LINEAR');
            this._texture.setImage(this._canvas);
            // Transparency stuff
            var stateset = this._geometry.getOrCreateStateSet();
            stateset.setTextureAttributeAndModes(0, this._texture);
            stateset.setRenderingHint('TRANSPARENT_BIN');
            stateset.setAttributeAndModes(
                new __WEBPACK_IMPORTED_MODULE_7_osg_BlendFunc__["a" /* default */](__WEBPACK_IMPORTED_MODULE_7_osg_BlendFunc__["a" /* default */].ONE, __WEBPACK_IMPORTED_MODULE_7_osg_BlendFunc__["a" /* default */].ONE_MINUS_SRC_ALPHA)
            );
            this._matrixTransform.addChild(this._geometry);
            this.dirtyBound();
        },

        setText: function(text) {
            this._text = text;
            // Canvas size could change so we need to make it dirty.
            this._dirty = true;
        },

        getText: function() {
            return this._text;
        },

        setFont: function(font) {
            this._font = font;
            this._dirty = true;
        },

        setColor: function(color) {
            this._color = color;
            // Convert color to html range
            this._fillStyle =
                'rgba(' +
                Math.round(color[0] * 255) +
                ',' +
                Math.round(color[1] * 255) +
                ',' +
                Math.round(color[2] * 255) +
                ',' +
                color[3] +
                ')';
            this._context.fillStyle = this._fillStyle;
            // Canvas size does not change so we don't need to redo the quad.
            this._context.fillText(this._text, this._textX, this._textY);
        },

        getColor: function() {
            return this._color;
        },

        setCharacterSize: function(size) {
            this._characterSize = size;
            if (this._characterSizeMode !== Text.OBJECT_COORDS) {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromScaling(this._matrixTransform.getMatrix(), [
                    this._characterSize,
                    this._characterSize,
                    this._characterSize
                ]);
                if (
                    this._characterSizeMode ===
                    Text.OBJECT_COORDS_WITH_MAXIMUM_SCREEN_SIZE_CAPPED_BY_FONT_HEIGHT
                )
                    this.setMaximumScale(this._characterSize);
            }
            this._dirty = true;
        },

        getCharacterSize: function() {
            return this._characterSize;
        },

        setCharacterSizeMode: function(mode) {
            this._characterSizeMode = mode;
            if (this._characterSizeMode !== Text.OBJECT_COORDS) {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromScaling(this._matrixTransform.getMatrix(), [
                    this._characterSize,
                    this._characterSize,
                    this._characterSize
                ]);
                this.setAutoScaleToScreen(true);
                this.setMaximumScale(Number.MAX_VALUE);
                if (
                    this._characterSizeMode ===
                    Text.OBJECT_COORDS_WITH_MAXIMUM_SCREEN_SIZE_CAPPED_BY_FONT_HEIGHT
                )
                    this.setMaximumScale(this._characterSize);
            } else {
                this._matrixTransform.setMatrix(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create());
                this.setAutoScaleToScreen(false);
            }
            this._dirty = true;
        },

        getCharacterSizeMode: function() {
            return this._characterSizeMode;
        },

        setFontResolution: function(resolution) {
            this._fontSize = resolution;
            this._dirty = true;
        },

        getFontResolution: function() {
            return this._fontSize;
        },

        setPosition: function(position) {
            this._position = position;
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(this.getMatrix(), position);
        },

        getPosition: function() {
            return this._position;
        },

        setTextProperties: function() {
            this._context.fillStyle = this._fillStyle;
            this._setAlignmentValues(this._alignment);
            this._context.font = this._fontSize + 'px ' + this._font;
            this._context.direction = this._layout;
        },

        setAutoRotateToScreen: function(value) {
            __WEBPACK_IMPORTED_MODULE_3_osg_AutoTransform__["a" /* default */].prototype.setAutoRotateToScreen.call(this, value);
            this._dirty = true;
        },

        getAutoRotateToScreen: function() {
            return this._autoRotateToScreen;
        },

        setLayout: function(layout) {
            if (typeof layout === 'string') {
                this._layout = Text[layout];
            } else {
                this._layout = layout;
            }
            this._dirty = true;
        },
        getLayout: function() {
            return this._layout;
        },
        setAlignment: function(alignment) {
            if (typeof alignment === 'string') {
                this._alignment = Text[alignment];
            } else {
                this._alignment = alignment;
            }
            this._dirty = true;
        },
        getAlignment: function() {
            return this._alignment;
        },

        accept: (function() {
            return function(visitor) {
                if (this._dirty) {
                    this.drawText();
                    this._dirty = false;
                }
                if (visitor.getVisitorType() === __WEBPACK_IMPORTED_MODULE_8_osg_NodeVisitor__["a" /* default */].CULL_VISITOR) {
                    var width = visitor.getViewport().width();
                    var height = visitor.getViewport().height();
                    var projMat = visitor.getCurrentProjectionMatrix();
                    var modelViewMat = visitor.getCurrentModelViewMatrix();
                    var position = this._position;
                    var doUpdate = this._firstTimeToInitEyePoint;

                    if (!this._firstTimeToInitEyePoint) {
                        if (!__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].exactEquals(modelViewMat, this._previousModelView)) {
                            doUpdate = true;
                        } else if (
                            width !== this._previousWidth ||
                            height !== this._previousHeight
                        ) {
                            doUpdate = true;
                        } else if (!__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].exactEquals(projMat, this._previousProjection)) {
                            doUpdate = true;
                        } else if (!__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].exactEquals(position, this._previousPosition)) {
                            doUpdate = true;
                        }
                    }
                    this._firstTimeToInitEyePoint = false;
                    if (doUpdate) {
                        if (this._autoScaleToScreen) {
                            var viewport = visitor.getViewport();
                            var psvector = this.computePixelSizeVector(
                                viewport,
                                projMat,
                                modelViewMat
                            );
                            var v = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(
                                this._position[0],
                                this._position[1],
                                this._position[2],
                                1.0
                            );
                            var pixelSize = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].dot(v, psvector);
                            pixelSize = 0.48 / pixelSize;
                            var size = 1.0 / pixelSize;
                            if (this._autoScaleTransitionWidthRatio > 0.0) {
                                var c, b, a;
                                if (this._minimumScale > 0.0) {
                                    var j = this._minimumScale;
                                    var i =
                                        this._maximumScale < Number.MAX_VALUE
                                            ? this._minimumScale +
                                              (this._maximumScale - this._minimumScale) *
                                                  this._autoScaleTransitionWidthRatio
                                            : this._minimumScale *
                                              (1.0 + this._autoScaleTransitionWidthRatio);
                                    c = 1.0 / (4.0 * (i - j));
                                    b = 1.0 - 2.0 * c * i;
                                    a = j + b * b / (4.0 * c);
                                    var k = -b / (2.0 * c);
                                    if (size < k) size = this._minimumScale;
                                    else if (size < i) size = a + b * size + c * (size * size);
                                }
                                if (this._maximumScale < Number.MAX_VALUE) {
                                    var n = this._maximumScale;
                                    var m =
                                        this._minimumScale > 0.0
                                            ? this._maximumScale +
                                              (this._minimumScale - this._maximumScale) *
                                                  this._autoScaleTransitionWidthRatio
                                            : this._maximumScale *
                                              (1.0 - this._autoScaleTransitionWidthRatio);
                                    c = 1.0 / (4.0 * (m - n));
                                    b = 1.0 - 2.0 * c * m;
                                    a = n + b * b / (4.0 * c);
                                    var p = -b / (2.0 * c);

                                    if (size > p) size = this._maximumScale;
                                    else if (size > m) size = a + b * size + c * (size * size);
                                }
                            }
                            this.setScale(size);
                        }
                        if (this._autoRotateToScreen) {
                            var rotation = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();
                            var modelView = visitor.getCurrentModelViewMatrix();
                            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].getRotation(rotation, modelView);
                            this.setRotation(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].invert(rotation, rotation));
                        }
                        this._previousWidth = width;
                        this._previousHeight = height;
                        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._previousPosition, position);
                        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(this._previousProjection, projMat);
                        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].copy(this._previousModelView, modelViewMat);
                    }
                }

                __WEBPACK_IMPORTED_MODULE_9_osg_Node__["a" /* default */].prototype.accept.call(this, visitor);
            };
        })(),
        _setAlignmentValues: function(alignment) {
            // Convert the OSG Api to js API
            switch (alignment) {
                case Text.LEFT_TOP:
                    this._context.textAlign = 'left';
                    this._textX = 0;
                    this._context.textBaseline = 'top';
                    this._textY = 0;
                    break;
                case Text.LEFT_CENTER:
                    this._context.textAlign = 'left';
                    this._textX = 0;
                    this._context.textBaseline = 'middle';
                    this._textY = this._canvas.height / 2;
                    break;
                case Text.LEFT_BOTTOM:
                    this._context.textAlign = 'left';
                    this._textX = 0;
                    this._context.textBaseline = 'bottom';
                    this._textY = this._canvas.height;
                    break;
                case Text.CENTER_TOP:
                    this._context.textAlign = 'center';
                    this._textX = this._canvas.width / 2;
                    this._context.textBaseline = 'top';
                    this._textY = 0;
                    break;
                case Text.CENTER_CENTER:
                    this._context.textAlign = 'center';
                    this._textX = this._canvas.width / 2;
                    this._context.textBaseline = 'middle';
                    this._textY = this._canvas.height / 2;
                    break;
                case Text.CENTER_BOTTOM:
                    this._context.textAlign = 'center';
                    this._textX = this._canvas.width / 2;
                    this._context.textBaseline = 'bottom';
                    this._textY = this._canvas.height;
                    break;
                case Text.RIGHT_TOP:
                    this._context.textAlign = 'right';
                    this._textX = this._canvas.width;
                    this._context.textBaseline = 'top';
                    this._textY = 0;
                    break;
                case Text.RIGHT_CENTER:
                    this._context.textAlign = 'right';
                    this._textX = this._canvas.width;
                    this._context.textBaseline = 'middle';
                    this._textY = this._canvas.height / 2;
                    break;
                case Text.RIGHT_BOTTOM:
                    this._context.textAlign = 'right';
                    this._textX = this._canvas.width;
                    this._context.textBaseline = 'bottom';
                    this._textY = this._canvas.height;
                    break;
            }
        },
        setForcePowerOfTwo: function(value) {
            this._forcePowerOfTwo = value;
        },
        getForcePowerOfTwo: function() {
            return this._forcePowerOfTwo;
        },
        _nextPowerOfTwo: function(value) {
            var v = value;
            v--;
            v |= v >> 1;
            v |= v >> 2;
            v |= v >> 4;
            v |= v >> 8;
            v |= v >> 16;
            v++;
            return v;
        }
    }),
    'osgText',
    'Text'
);

// same code like Node
__WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__["a" /* default */].registerApplyFunction(
    Text.nodeTypeID,
    __WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__["a" /* default */].getApplyFunction(__WEBPACK_IMPORTED_MODULE_3_osg_AutoTransform__["a" /* default */].nodeTypeID)
);

/* harmony default export */ __webpack_exports__["a"] = (Text);


/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_138__;

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__ = __webpack_require__(69);





var LineSegmentIntersection = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].Intersection.call(this);

    this._localIntersectionNormal = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].clone(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].ONE);

    // index of vertex
    this._i1 = -1;
    this._i2 = -1;
    this._i3 = -1;

    // barycentric coordinates
    this._r1 = 0.0;
    this._r2 = 0.0;
    this._r3 = 0.0;
};

// Settings are needed.
var LineSegmentIntersectFunctor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].call(this);

    this._threshold = 0.0; // only used for lines and points
    this._d = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._length = 0;
    this._invLength = 0;

    this._start = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._end = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._dInvX = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._dInvY = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._dInvZ = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._hit = false;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    LineSegmentIntersectFunctor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].prototype, {
        set: function(start, end, threshold) {
            this._start = start;
            this._end = end;
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(this._d, end, start);

            this._length = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].length(this._d);
            this._invLength = this._length !== 0.0 ? 1.0 / this._length : 0.0;

            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(this._d, this._d, this._invLength);
            if (this._d[0] !== 0.0) __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(this._dInvX, this._d, 1.0 / this._d[0]);
            if (this._d[1] !== 0.0) __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(this._dInvY, this._d, 1.0 / this._d[1]);
            if (this._d[2] !== 0.0) __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(this._dInvZ, this._d, 1.0 / this._d[2]);

            if (threshold !== undefined) this._threshold = threshold;
        },

        enter: function(bbox, s, e) {
            var min = bbox._min;
            var xmin = min[0];
            var ymin = min[1];
            var zmin = min[2];

            var max = bbox._max;
            var xmax = max[0];
            var ymax = max[1];
            var zmax = max[2];

            var invX = this._dInvX;
            var invY = this._dInvY;
            var invZ = this._dInvZ;

            if (s[0] <= e[0]) {
                // trivial reject of segment wholely outside.
                if (e[0] < xmin) return false;
                if (s[0] > xmax) return false;

                if (s[0] < xmin) {
                    // clip s to xMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invX, xmin - s[0]);
                }

                if (e[0] > xmax) {
                    // clip e to xMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invX, xmax - s[0]);
                }
            } else {
                if (s[0] < xmin) return false;
                if (e[0] > xmax) return false;

                if (e[0] < xmin) {
                    // clip s to xMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invX, xmin - s[0]);
                }

                if (s[0] > xmax) {
                    // clip e to xMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invX, xmax - s[0]);
                }
            }

            // compare s and e against the yMin to yMax range of bb.
            if (s[1] <= e[1]) {
                // trivial reject of segment wholely outside.
                if (e[1] < ymin) return false;
                if (s[1] > ymax) return false;

                if (s[1] < ymin) {
                    // clip s to yMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invY, ymin - s[1]);
                }

                if (e[1] > ymax) {
                    // clip e to yMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invY, ymax - s[1]);
                }
            } else {
                if (s[1] < ymin) return false;
                if (e[1] > ymax) return false;

                if (e[1] < ymin) {
                    // clip s to yMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invY, ymin - s[1]);
                }

                if (s[1] > ymax) {
                    // clip e to yMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invY, ymax - s[1]);
                }
            }

            // compare s and e against the zMin to zMax range of bb.
            if (s[2] <= e[2]) {
                // trivial reject of segment wholely outside.
                if (e[2] < zmin) return false;
                if (s[2] > zmax) return false;

                if (s[2] < zmin) {
                    // clip s to zMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invZ, zmin - s[2]);
                }

                if (e[2] > zmax) {
                    // clip e to zMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invZ, zmax - s[2]);
                }
            } else {
                if (s[2] < zmin) return false;
                if (e[2] > zmax) return false;

                if (e[2] < zmin) {
                    // clip s to zMin.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(e, s, invZ, zmin - s[2]);
                }

                if (s[2] > zmax) {
                    // clip e to zMax.
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(s, s, invZ, zmax - s[2]);
                }
            }

            return true;
        },

        intersectPoint: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var dir = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            return function(v0, p0) {
                // https://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistPointSegment.h
                var st = this._start;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(tmp, v0, st);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(dir, this._end, st);
                // compute ratio (projection on line)
                var r = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(tmp, dir) * this._invLength * this._invLength;

                // compute distance to segment
                var distToSegmentSqr = 1.0;
                if (r < 0.0) distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(tmp);
                else if (r > 1.0) distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrDist(v0, this._end);
                else distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(tmp, tmp, dir, -r));

                if (distToSegmentSqr > this._threshold * this._threshold) {
                    return;
                }

                var intersection = this.initIntersection(new LineSegmentIntersection());
                intersection._i1 = p0;
                intersection._r1 = 1.0;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(intersection._localIntersectionPoint, st, dir, r);
                intersection._ratio = r;
            };
        })(),

        intersectLine: (function() {
            var u = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var v = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var w = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            var closest0 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var closest1 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            return function(v0, v1, p0, p1) {
                // https://www.geometrictools.com/GTEngine/Samples/Geometrics/DistanceSegments3/DistanceSegments3.cpp
                var epsilon = 0.00000001;
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(u, v1, v0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(v, this._end, this._start);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(w, v0, this._start);
                var a = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(u, u);
                var b = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(u, v);
                var c = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(v, v);
                var d = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(u, w);
                var e = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(v, w);
                var D = a * c - b * b;
                var sN;
                var tN;
                var sD = D;
                var tD = D;

                // compute the line parameters of the two closest points
                if (D < epsilon) {
                    // the lines are almost parallel
                    sN = 0.0; // force using point P0 on segment S1
                    sD = 1.0; // to prevent possible division by 0.0 later
                    tN = e;
                    tD = c;
                } else {
                    // get the closest points on the infinite lines
                    sN = b * e - c * d;
                    tN = a * e - b * d;
                    if (sN < 0.0) {
                        // sc < 0 => the s=0 edge is visible
                        sN = 0.0;
                        tN = e;
                        tD = c;
                    } else if (sN > sD) {
                        // sc > 1  => the s=1 edge is visible
                        sN = sD;
                        tN = e + b;
                        tD = c;
                    }
                }

                if (tN < 0.0) {
                    // tc < 0 => the t=0 edge is visible
                    tN = 0.0;
                    // recompute sc for this edge
                    if (-d < 0.0) sN = 0.0;
                    else if (-d > a) sN = sD;
                    else {
                        sN = -d;
                        sD = a;
                    }
                } else if (tN > tD) {
                    // tc > 1  => the t=1 edge is visible
                    tN = tD;
                    // recompute sc for this edge
                    if (-d + b < 0.0) sN = 0;
                    else if (-d + b > a) sN = sD;
                    else {
                        sN = -d + b;
                        sD = a;
                    }
                }
                // finally do the division to get sc and tc
                var sc = Math.abs(sN) < epsilon ? 0.0 : sN / sD;
                var tc = Math.abs(tN) < epsilon ? 0.0 : tN / tD;

                // get the difference of the two closest points
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(closest0, v0, u, sc);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(closest1, this._start, v, tc);

                var sqrDistance = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrDist(closest0, closest1);
                if (sqrDistance > this._threshold * this._threshold) {
                    return;
                }

                var intersection = this.initIntersection(new LineSegmentIntersection());
                intersection._i1 = p0;
                intersection._i2 = p1;
                intersection._r1 = 1.0 - tc;
                intersection._r2 = tc;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(intersection._localIntersectionPoint, closest1);
                intersection._ratio = tc;
            };
        })(),

        intersectTriangle: (function() {
            var normal = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var e2 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var e1 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var tvec = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var pvec = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var qvec = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var epsilon = 1e-20;

            return function(v0, v1, v2, p0, p1, p2) {
                var d = this._d;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(e2, v2, v0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(e1, v1, v0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(pvec, d, e2);

                var det = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(pvec, e1);
                if (det > -epsilon && det < epsilon) return;
                var invDet = 1.0 / det;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(tvec, this._start, v0);

                var u = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(pvec, tvec) * invDet;
                if (u < 0.0 || u > 1.0) return;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(qvec, tvec, e1);

                var v = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(qvec, d) * invDet;
                if (v < 0.0 || u + v > 1.0) return;

                var t = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(qvec, e2) * invDet;

                if (t < epsilon || t > this._length) return;

                var r0 = 1.0 - u - v;
                var r1 = u;
                var r2 = v;
                var r = t * this._invLength;

                var interX = v0[0] * r0 + v1[0] * r1 + v2[0] * r2;
                var interY = v0[1] * r0 + v1[1] * r1 + v2[1] * r2;
                var interZ = v0[2] * r0 + v1[2] * r1 + v2[2] * r2;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(normal, e1, e2);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(normal, normal);

                var intersection = this.initIntersection(new LineSegmentIntersection());
                intersection._i1 = p0;
                intersection._i2 = p1;
                intersection._i3 = p2;
                intersection._r1 = r0;
                intersection._r2 = r1;
                intersection._r3 = r2;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].set(intersection._localIntersectionPoint, interX, interY, interZ);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(intersection._localIntersectionNormal, normal);
                intersection._ratio = r;

                // http://gamedev.stackexchange.com/questions/54505/negative-scale-in-matrix-4x4
                // https://en.wikipedia.org/wiki/Determinant#Orientation_of_a_basis
                // you can't exactly extract scale of a matrix but the determinant will tell you
                // if the orientation is preserved
                intersection._backface = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].determinant(intersection._matrix) * det < 0;
            };
        })(),

        operatorPoint: function(p0) {
            if (this._threshold <= 0.0) return;
            __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].prototype.operatorPoint.call(this, p0);
        },

        operatorLine: function(p0, p1) {
            if (this._threshold <= 0.0) return;
            __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].prototype.operatorLine.call(this, p0, p1);
        }
    }),
    'osgUtil',
    'LineSegmentIntersectFunctor'
);

/* harmony default export */ __webpack_exports__["a"] = (LineSegmentIntersectFunctor);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Polytope__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgUtil_Intersector__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgUtil_PolytopeIntersectFunctor__ = __webpack_require__(141);








/** Concrete class for implementing polytope intersections with the scene graph.
 * To be used in conjunction with IntersectionVisitor. */
var PolytopeIntersector = function() {
    __WEBPACK_IMPORTED_MODULE_4_osgUtil_Intersector__["a" /* default */].call(this);

    this._index = 0;
    // We use one for reference and other for the intersections
    this._polytope = new __WEBPACK_IMPORTED_MODULE_2_osg_Polytope__["a" /* default */]();
    this._iPolytope = new __WEBPACK_IMPORTED_MODULE_2_osg_Polytope__["a" /* default */]();
    this._referencePlane = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create();
    this._iReferencePlane = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create();
};

var transformVec4PostMult = function(out, p, m) {
    var x = p[0];
    var y = p[1];
    var z = p[2];
    var w = p[3];

    out[0] = m[0] * x + m[1] * y + m[2] * z + m[3] * w;
    out[1] = m[4] * x + m[5] * y + m[6] * z + m[7] * w;
    out[2] = m[8] * x + m[9] * y + m[10] * z + m[11] * w;
    out[3] = m[12] * x + m[13] * y + m[14] * z + m[15] * w;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    PolytopeIntersector,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osgUtil_Intersector__["a" /* default */].prototype, {
        setPolytope: function(polytope) {
            this._polytope.setPlanes(polytope);
            var iPlanes = [];
            for (var i = 0; i < polytope.length; ++i) {
                var plane = polytope[i];
                iPlanes[i] = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].copy(this._iPolytope.getPlanes()[i] || __WEBPACK_IMPORTED_MODULE_3_osg_Plane__["a" /* default */].create(), plane);
            }
            this._iPolytope.setPlanes(iPlanes);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].copy(this._referencePlane, polytope[polytope.length - 1]);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].copy(this._iReferencePlane, this._referencePlane);
        },

        getPolytope: function() {
            return this._iPolytope;
        },

        setPolytopeFromWindowCoordinates: function(xMin, yMin, xMax, yMax) {
            // Note: last polytope value depends on the Coordinate frame
            // Now we are only supporting WINDOW coordinate frame, so must change this if we decide to support
            // other types of Coordinate Frame
            this.setPolytope([
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.0, 0.0, -xMin),
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(-1.0, 0.0, 0.0, xMax),
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 1.0, 0.0, -yMin),
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, -1.0, 0.0, yMax),
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 1.0, 0.0)
            ]);
        },

        intersectBoundingBox: function(bbox) {
            return this._iPolytope.containsBoundingBox(bbox);
        },

        intersectBoundingSphere: function(bsphere) {
            return this._iPolytope.containsBoundingSphere(bsphere);
        },

        intersect: (function() {
            var functor = new __WEBPACK_IMPORTED_MODULE_5_osgUtil_PolytopeIntersectFunctor__["a" /* default */]();

            return function(iv, node) {
                functor.setGeometry(node);
                functor.setIntersectionVisitor(iv);
                functor.setIntersector(this);

                var kdtree = node.getShape();
                if (kdtree) {
                    kdtree.intersect(functor, kdtree.getNodes()[0]);
                } else {
                    // handle rig transformed vertices
                    if (node.computeTransformedVertices) {
                        functor.setVertices(node.computeTransformedVertices());
                    }

                    functor.apply(node);
                }
                functor.reset();
            };
        })(),

        setCurrentTransformation: function(matrix) {
            // Transform the polytope and the referencePlane to the current Model local coordinate frame
            var planeList = this._polytope.getPlanes();
            var iPlaneList = this._iPolytope.getPlanes();
            for (var i = 0, j = planeList.length; i < j; i++) {
                var iplane = (iPlaneList[i] = iPlaneList[i] || __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create());
                // PostMult
                transformVec4PostMult(iplane, planeList[i], matrix);
                // multiply the coefficients of the plane equation with a constant factor so that the equation a^2+b^2+c^2 = 1 holds.
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].scale(iplane, iplane, 1.0 / __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].len(iplane));
            }

            //Post Mult
            transformVec4PostMult(this._iReferencePlane, this._referencePlane, matrix);

            // multiply the coefficients of the plane equation with a constant factor so that the equation a^2+b^2+c^2 = 1 holds.
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].scale(
                this._iReferencePlane,
                this._iReferencePlane,
                1.0 / __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].len(this._iReferencePlane)
            );
        }
    }),
    'osgUtil',
    'PolytopeIntersector'
);

/* harmony default export */ __webpack_exports__["a"] = (PolytopeIntersector);


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_IntersectFunctor__ = __webpack_require__(69);





var PolytopeIntersection = function() {
    __WEBPACK_IMPORTED_MODULE_3_osgUtil_IntersectFunctor__["a" /* default */].Intersection.call(this);

    this._intersectionPoints = [];
    this._distance = 0;
    this._maxDistance = 0;
    this._numIntersectionPoints = 0;
};

// Settings are needed.
var PolytopeIntersectFunctor = function() {
    __WEBPACK_IMPORTED_MODULE_3_osgUtil_IntersectFunctor__["a" /* default */].call(this);

    this._src = [];
    this._dest = [];
    this._maxNumIntersectionsPoints = 6;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    PolytopeIntersectFunctor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osgUtil_IntersectFunctor__["a" /* default */].prototype, {
        reset: function() {
            __WEBPACK_IMPORTED_MODULE_3_osgUtil_IntersectFunctor__["a" /* default */].prototype.reset.call(this);
            this._src = [];
            this._dest = [];
        },

        enter: function(bbox) {
            if (this._intersector.getPolytope().containsBoundingBox(bbox)) {
                this._intersector.getPolytope().pushCurrentMask();
                return true;
            }
            return false;
        },

        leave: function() {
            this._intersector.getPolytope().popCurrentMask();
        },

        addIntersection: function() {
            this._src = __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].arrayUniq(this._src);
            var src = this._src;

            var center = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var maxDistance = -Number.MAX_VALUE;
            var referencePlane = this._intersector._iReferencePlane;
            for (var i = 0; i < src.length; ++i) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(center, center, src[i]);
                var d = __WEBPACK_IMPORTED_MODULE_2_osg_Plane__["a" /* default */].distanceToPlane(referencePlane, src[i]);
                if (d > maxDistance) maxDistance = d;
            }

            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(center, center, 1.0 / src.length);

            var intersection = this.initIntersection(new PolytopeIntersection());
            intersection._distance = __WEBPACK_IMPORTED_MODULE_2_osg_Plane__["a" /* default */].distanceToPlane(referencePlane, center);
            intersection._maxDistance = maxDistance;
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(intersection._localIntersectionPoint, center);

            var maxNum = this._maxNumIntersectionsPoints;
            intersection._numIntersectionPoints = src.length < maxNum ? src.length : maxNum;

            for (i = 0; i < intersection._numIntersectionPoints; ++i) {
                intersection._intersectionPoints.push(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].clone(this._src[i]));
            }
        },

        contains: function() {
            var polytope = this._intersector.getPolytope();
            var planeList = polytope.getPlanes();

            var resultMask = polytope.getCurrentMask();
            if (!resultMask) return true;

            var selectorMask = 0x1;

            for (var i = 0; i < planeList.length; ++i) {
                if (resultMask & (selectorMask === 0)) {
                    selectorMask <<= 1;
                    continue;
                }

                this._dest = [];
                var plane = planeList[i];
                var vPrevious = this._src[0];
                var dPrevious = __WEBPACK_IMPORTED_MODULE_2_osg_Plane__["a" /* default */].distanceToPlane(plane, vPrevious);
                for (var j = 1; j < this._src.length; ++j) {
                    var vCurrent = this._src[j];
                    var dCurrent = __WEBPACK_IMPORTED_MODULE_2_osg_Plane__["a" /* default */].distanceToPlane(plane, vCurrent);
                    if (dPrevious >= 0.0) {
                        this._dest.push(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].clone(vPrevious));
                    }
                    if (dPrevious * dCurrent < 0.0) {
                        var distance = dPrevious - dCurrent;
                        var rCurrent = dPrevious / distance;
                        //(*v_previous)*(1.0-r_current) + (*v_current)*r_current;
                        var vnew = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].add(
                            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create(),
                            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create(), vPrevious, 1.0 - rCurrent),
                            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scale(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create(), vCurrent, rCurrent)
                        );
                        this._dest.push(vnew);
                    }
                    dPrevious = dCurrent;
                    vPrevious = vCurrent;
                }
                if (dPrevious >= 0.0) {
                    this._dest.push(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].clone(vPrevious));
                }
                if (this._dest.length <= 1) {
                    return false;
                }
                // swap values
                var swap = this._src.slice();
                this._src = this._dest.slice();
                this._dest = swap;
            }

            return true;
        },

        containsPoint: function(v0) {
            if (this._intersector.getPolytope().containsVertex(v0)) {
                // initialize the set of vertices to test.
                this._src = [];
                this._src[0] = v0;
                return true;
            }
            return false;
        },

        containsLine: function(v0, v1) {
            // initialize the set of vertices to test.
            this._src = [];
            this._src[0] = v0;
            this._src[1] = v1;
            this._src[2] = v0;
            return this.contains();
        },

        containsTriangle: function(v0, v1, v2) {
            // initialize the set of vertices to test.
            this._src = [];
            this._src[0] = v0;
            this._src[1] = v1;
            this._src[2] = v2;
            this._src[3] = v0;
            return this.contains();
        },

        intersectPoint: function(v0) {
            if (this.containsPoint(v0)) this.addIntersection();
        },

        intersectLine: function(v0, v1) {
            if (this.containsLine(v0, v1)) this.addIntersection();
        },

        intersectTriangle: function(v0, v1, v2) {
            if (this.containsTriangle(v0, v1, v2)) this.addIntersection();
        }
    }),
    'osgUtil',
    'PolytopeIntersectFunctor'
);

/* harmony default export */ __webpack_exports__["a"] = (PolytopeIntersectFunctor);


/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_keyboardEventsController__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__ = __webpack_require__(91);





var CADManipulatorStandardMouseKeyboardController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this._timer = false;
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    CADManipulatorStandardMouseKeyboardController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._mode = undefined;
            this._buttonup = true;
            this._keyboardEventsCtrl = new __WEBPACK_IMPORTED_MODULE_2_osg_keyboardEventsController__["a" /* default */]();
        },
        // called to enable/disable controller
        setEnable: function(bool) {
            if (!bool) {
                // reset mode if we disable it
                this._mode = undefined;
            }
            __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype.setEnable.call(this, bool);
        },
        getMode: function() {
            return this._mode;
        },
        setMode: function(mode) {
            this._mode = mode;
        },
        setEventProxy: function(proxy) {
            this._eventProxy = proxy;
        },
        setManipulator: function(manipulator) {
            this._manipulator = manipulator;
        },

        mousemove: function(ev) {
            if (this._buttonup === true) {
                return;
            }

            var manipulator = this._manipulator;
            var pos = manipulator.getPositionRelativeToCanvas(ev.clientX, ev.clientY);

            if (isNaN(pos[0]) === false && isNaN(pos[1]) === false) {
                var mode = this.getMode();
                if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Rotate) {
                    manipulator.getRotateInterpolator().setTarget(pos[0], pos[1]);
                } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan) {
                    manipulator.getPanInterpolator().setTarget(pos[0], pos[1]);
                } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Zoom) {
                    var zoom = manipulator.getZoomInterpolator();
                    manipulator.computeIntersections(pos);

                    if (zoom.isReset()) {
                        zoom.setStart(pos[1]);
                        zoom.set(0.0);
                    }
                    var dy = pos[1] - zoom.getStart();
                    zoom.setStart(pos[1]);
                    var v = zoom.getTarget()[0];
                    zoom.setTarget(v - dy / 20.0);
                }
            }

            ev.preventDefault();
        },
        mousedown: function(ev) {
            var manipulator = this._manipulator;
            var mode = this.getMode();
            if (mode === undefined) {
                if (ev.button === 0) {
                    if (ev.shiftKey) {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan);
                    } else if (ev.ctrlKey) {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Zoom);
                    } else {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Rotate);
                    }
                } else {
                    this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan);
                }
            }

            this.pushButton();

            //var pos = this.getPositionRelativeToCanvas( ev );
            var pos = manipulator.getPositionRelativeToCanvas(ev.clientX, ev.clientY);
            manipulator.computeIntersections(pos);

            mode = this.getMode();
            if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Rotate) {
                manipulator.getRotateInterpolator().reset();
                manipulator.getRotateInterpolator().set(pos[0], pos[1]);
            } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan) {
                manipulator.getPanInterpolator().reset();
                manipulator.getPanInterpolator().set(pos[0], pos[1]);
            } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Zoom) {
                manipulator.getZoomInterpolator().setStart(pos[1]);
                manipulator.getZoomInterpolator().set(0.0);
            }
        },
        mouseup: function(/*ev */) {
            this.releaseButton();
            this.setMode(undefined);
        },
        mousewheel: function(ev, intDelta /*, deltaX, deltaY */) {
            var manipulator = this._manipulator;
            var zoomTarget = manipulator.getZoomInterpolator().getTarget()[0] - intDelta;
            manipulator.getZoomInterpolator().setTarget(zoomTarget);
            var timer;
            if (this._timer === false) {
                this._timer = true;
                var that = this;
                clearTimeout(timer);
                timer = setTimeout(function() {
                    that._timer = false;
                }, 200);
                //var pos = this.getPositionRelativeToCanvas( ev );
                var pos = manipulator.getPositionRelativeToCanvas(ev.clientX, ev.clientY);
                manipulator.computeIntersections(pos);
            }
        },

        dblclick: function(ev) {
            var manipulator = this._manipulator;
            ev.preventDefault();

            manipulator.getZoomInterpolator().set(0.0);
            var zoomTarget = manipulator.getZoomInterpolator().getTarget()[0] - 10; // Default interval 10
            manipulator.getZoomInterpolator().setTarget(zoomTarget);
            //var pos = this.getPositionRelativeToCanvas( ev );
            var pos = manipulator.getPositionRelativeToCanvas(ev.clientX, ev.clientY);
            manipulator.computeIntersections(pos);
        },

        pushButton: function() {
            this._buttonup = false;
        },
        releaseButton: function() {
            this._buttonup = true;
        },

        keydown: function(ev) {
            const eventKey = ev.key.toLowerCase();
            if (this._keyboardEventsCtrl.isSpaceEvent(eventKey)) {
                this._manipulator.computeHomePosition();
                ev.preventDefault();
            } else if (this._keyboardEventsCtrl.isPanEvent(eventKey) && this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Pan);
                this._manipulator.getPanInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            } else if (this._keyboardEventsCtrl.isZoomEvent(eventKey) && this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Zoom) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Zoom);
                this._manipulator.getZoomInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            } else if (
                this._keyboardEventsCtrl.isRotateEvent(eventKey) &&
                this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Rotate
            ) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_OrbitManipulator__["a" /* default */].Rotate);
                this._manipulator.getRotateInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            }
        },

        keyup: function(ev) {
            const eventKey = ev.key.toLowerCase();
            if (this._keyboardEventsCtrl.isPanEvent(eventKey) ||
                this._keyboardEventsCtrl.isZoomEvent(eventKey) ||
                this._keyboardEventsCtrl.isRotateEvent(eventKey)
            ) {
                this.mouseup(ev);
            }
            this.setMode(undefined);
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (CADManipulatorStandardMouseKeyboardController);


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_FirstPersonManipulatorDeviceOrientationController__ = __webpack_require__(92);







var OrbitManipulatorDeviceOrientationController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulatorDeviceOrientationController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._stepFactor = 1.0; // meaning radius*stepFactor to move
            this._quat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();
            this._pos = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
        },

        update: function(deviceOrientation, screenOrientation) {
            // for now we use the same code in first person and orbit to compute rotation
            __WEBPACK_IMPORTED_MODULE_3_osgGA_FirstPersonManipulatorDeviceOrientationController__["a" /* default */].computeQuaternion(
                this._quat,
                deviceOrientation,
                screenOrientation
            );
            this._manipulator.setPoseVR(this._quat, this._pos);
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulatorDeviceOrientationController);


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);




var OrbitManipulatorGamePadController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulatorGamePadController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._delay = 0.15;
            this._threshold = 0.08;
            this._padFactor = 10.0;
            this._zoomFactor = 0.5;
            this._rotateFactor = 5.0;
        },

        addPan: function(pan, x, y) {
            pan.setDelay(this._delay);
            pan.addTarget(x * this._padFactor, y * this._padFactor);
        },

        addZoom: function(zoom, z) {
            zoom.setDelay(this._delay);
            zoom.addTarget(z * this._zoomFactor);
        },

        addRotate: function(rotate, x, y) {
            rotate.setDelay(this._delay);
            //var rotateTarget = rotate.getTarget();
            rotate.addTarget(x * this._rotateFactor, y * this._rotateFactor);
        },

        gamepadaxes: function(axes) {
            // Block badly balanced controllers
            var AXIS_THRESHOLD = 0.005;

            //var rotateTarget, panTarget;
            var rotate = this._manipulator.getRotateInterpolator();
            var zoom = this._manipulator.getZoomInterpolator();
            var pan = this._manipulator.getPanInterpolator();
            // Regular gamepads
            if (axes.length === 4) {
                if (Math.abs(axes[0]) > AXIS_THRESHOLD || Math.abs(axes[1]) > AXIS_THRESHOLD) {
                    this.addRotate(rotate, -axes[0], axes[1]);
                }
                if (Math.abs(axes[3]) > AXIS_THRESHOLD) {
                    this.addZoom(zoom, -axes[3]);
                }

                //SpaceNavigator & 6-axis controllers
            } else if (axes.length >= 5) {
                //Notify.log(axes);
                if (Math.abs(axes[0]) > AXIS_THRESHOLD || Math.abs(axes[1]) > AXIS_THRESHOLD) {
                    this.addPan(pan, -axes[0], axes[1]);
                }

                if (Math.abs(axes[2]) > AXIS_THRESHOLD) {
                    this.addZoom(zoom, -axes[2]);
                }

                if (Math.abs(axes[3]) > AXIS_THRESHOLD || Math.abs(axes[4]) > AXIS_THRESHOLD) {
                    this.addRotate(rotate, axes[4], axes[3]);
                }
            }
        },

        gamepadbuttondown: function(event /*, pressed */) {
            // Buttons 12 to 15 are the d-pad.
            if (event.button >= 12 && event.button <= 15) {
                var pan = this._manipulator.getPanInterpolator();
                var panTarget = pan.getTarget();
                var delta = {
                    12: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(0, -1),
                    13: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(0, 1),
                    14: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(-1, 0),
                    15: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(1, 0)
                }[event.button];
                pan.setDelay(this._delay);
                pan.setTarget(panTarget[0] - delta[0] * 10, panTarget[1] + delta[1] * 10);
            }
        },

        update: function(gm) {
            if (!gm) {
                return;
            }

            var axis = gm.axes;
            var buttons = gm.buttons;

            this.gamepadaxes(axis);

            // Dummy event wrapper
            var emptyFunc = function() {};
            for (var i = 0; i < buttons.length; i++) {
                if (buttons[i]) {
                    this.gamepadbuttondown(
                        {
                            preventDefault: emptyFunc,
                            gamepad: gm,
                            button: i
                        },
                        !!buttons[i]
                    );
                }
            }
        }
    })
);
/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulatorGamePadController);


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_math__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_keyboardEventsController__ = __webpack_require__(90);






var OrbitManipulatorStandardMouseKeyboardController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulatorStandardMouseKeyboardController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._delay = 0.15;
            this._mode = undefined;
            this._buttonup = true;
            this._keyboardEventsCtrl = new __WEBPACK_IMPORTED_MODULE_4_osg_keyboardEventsController__["a" /* default */]();
        },
        // called to enable/disable controller
        setEnable: function(bool) {
            if (!bool) {
                // reset mode if we disable it
                this._mode = undefined;
            }
            __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype.setEnable.call(this, bool);
        },
        getMode: function() {
            return this._mode;
        },
        setMode: function(mode) {
            this._mode = mode;
        },
        setEventProxy: function(proxy) {
            this._eventProxy = proxy;
        },
        setManipulator: function(manipulator) {
            this._manipulator = manipulator;
        },
        mousemove: function(ev) {
            if (this._buttonup === true) {
                return;
            }
            var pos = this._eventProxy.getPositionRelativeToCanvas(ev);
            var manipulator = this._manipulator;
            if (__WEBPACK_IMPORTED_MODULE_2_osg_math__["a" /* default */].isNaN(pos[0]) === false && __WEBPACK_IMPORTED_MODULE_2_osg_math__["a" /* default */].isNaN(pos[1]) === false) {
                var mode = this.getMode();
                if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE) {
                    manipulator.getRotateInterpolator().setDelay(this._delay);
                    manipulator.getRotateInterpolator().setTarget(pos[0], pos[1]);
                } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN) {
                    manipulator.getPanInterpolator().setTarget(pos[0], pos[1]);
                } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM) {
                    var zoom = manipulator.getZoomInterpolator();
                    if (zoom.isReset()) {
                        zoom.setStart(pos[1]);
                        zoom.set(0.0);
                    }
                    var dy = pos[1] - zoom.getStart();
                    zoom.setStart(pos[1]);
                    var v = zoom.getTarget()[0];
                    zoom.setTarget(v - dy / 20.0);
                }
            }

            ev.preventDefault();
        },
        mousedown: function(ev) {
            var manipulator = this._manipulator;
            var mode = this.getMode();
            if (mode === undefined) {
                if (ev.button === 0) {
                    if (ev.shiftKey) {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN);
                    } else if (ev.ctrlKey) {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM);
                    } else {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE);
                    }
                } else {
                    // For users on Mac machines for who CTRL+LeftClick is naturally converted
                    // into a RightClick in Firefox.
                    if (ev.button === 2 && ev.ctrlKey) {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM);
                    } else {
                        this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN);
                    }
                }
            }

            this.pushButton();

            var pos = this._eventProxy.getPositionRelativeToCanvas(ev);
            mode = this.getMode();
            if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE) {
                manipulator.getRotateInterpolator().reset();
                manipulator.getRotateInterpolator().set(pos[0], pos[1]);
            } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN) {
                manipulator.getPanInterpolator().reset();
                manipulator.getPanInterpolator().set(pos[0], pos[1]);
            } else if (mode === __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM) {
                manipulator.getZoomInterpolator().setStart(pos[1]);
                manipulator.getZoomInterpolator().set(0.0);
            }
        },
        mouseup: function(/*ev */) {
            this.releaseButton();
            this.setMode(undefined);
        },
        mouseout: function(/*ev */) {
            this.releaseButton();
            this.setMode(undefined);
        },
        mousewheel: function(ev, intDelta /*, deltaX, deltaY */) {
            var manipulator = this._manipulator;
            var zoomTarget = manipulator.getZoomInterpolator().getTarget()[0] - intDelta;
            manipulator.getZoomInterpolator().setTarget(zoomTarget);
        },

        pushButton: function() {
            this._buttonup = false;
        },
        releaseButton: function() {
            this._buttonup = true;
        },

        keydown: function (ev) {
            const eventKey = ev.key.toLowerCase();
            if (this._keyboardEventsCtrl.isSpaceEvent(eventKey)) {
                this._manipulator.computeHomePosition();
                ev.preventDefault();
            } else if (
                this._keyboardEventsCtrl.isPanEvent(eventKey) &&
                this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN
            ) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].PAN);
                this._manipulator.getPanInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            } else if (
                this._keyboardEventsCtrl.isZoomEvent(eventKey) &&
                this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM
            ) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM);
                this._manipulator.getZoomInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            } else if (
                this._keyboardEventsCtrl.isRotateEvent(eventKey) &&
                this.getMode() !== __WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE
            ) {
                this.setMode(__WEBPACK_IMPORTED_MODULE_3_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE);
                this._manipulator.getRotateInterpolator().reset();
                this.pushButton();
                ev.preventDefault();
            }
        },

        keyup: function(ev) {
            const eventKey = ev.key.toLowerCase();
            if (this._keyboardEventsCtrl.isPanEvent(eventKey) ||
                this._keyboardEventsCtrl.isZoomEvent(eventKey) ||
                this._keyboardEventsCtrl.isRotateEvent(eventKey)
            ) {
                this.mouseup(ev);
            }
            this.setMode(undefined);
        }
    })
);
/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulatorStandardMouseKeyboardController);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    ROTATE: 0,
    PAN: 1,
    ZOOM: 2
});


/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);



var OrbitManipulatorWebVRController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    OrbitManipulatorWebVRController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {},
        update: function(q, position) {
            this._manipulator.setPoseVR(q, position);
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (OrbitManipulatorWebVRController);


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);



var CADManipulatorHammerController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this._timer = false;
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    CADManipulatorHammerController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._panFactorX = 1.0;
            this._panFactorY = -this._panFactorX;

            this._rotateFactorX = 0.6;
            this._rotateFactorY = -this._rotateFactorX;
            this._zoomFactor = 5.0;

            this._lastScale = 0;
            this._nbPointerLast = 0; // to check if we the number of pointers has changed

            this._lastPos = undefined; // to set the pivot for rotation
            this._dragStarted = false;
            this._transformStarted = false;
            this._isValid = false;
        },

        // called to enable/disable controller
        setEnable: function(bool) {
            if (!bool) {
                // reset mode if we disable it
                this._dragStarted = false;
                this._lastPos = undefined;
                this._transformStarted = false;
                this._nbPointerLast = 0;
            }
            __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype.setEnable.call(this, bool);
        },

        setValid: function(valid) {
            this._isValid = valid;
        },

        setEventProxy: function(hammer) {
            if (!hammer || hammer === this._eventProxy) {
                return;
            }

            this._eventProxy = hammer;

            // Set a minimal thresold on pinch event, to be detected after pan
            hammer.get('pinch').set({
                threshold: 0.3
            });
            // Let the pan be detected with two fingers.
            hammer.get('pan').set({
                threshold: 0,
                pointers: 0
            });
            hammer.get('pinch').recognizeWith(hammer.get('pan'));

            hammer.get('tap').set({
                taps: 2,
                posThreshold: 300
            });

            this._cbPanStart = this.panStart.bind(this);
            this._cbPanMove = this.panMove.bind(this);
            this._cbPanEnd = this.panEnd.bind(this);
            this._cbPinchStart = this.pinchStart.bind(this);
            this._cbPinchEnd = this.pinchEnd.bind(this);
            this._cbPinchInOut = this.pinchInOut.bind(this);
            this._cbDoubleTap = this.doubleTap.bind(this);

            hammer.on('panstart ', this._cbPanStart);
            hammer.on('panmove', this._cbPanMove);
            hammer.on('panend', this._cbPanEnd);
            hammer.on('pinchstart', this._cbPinchStart);
            hammer.on('pinchend', this._cbPinchEnd);
            hammer.on('pinchin pinchout', this._cbPinchInOut);
            hammer.on('tap', this._cbDoubleTap);
        },

        _computeTouches: function(event) {
            if (event.pointers !== undefined) return event.pointers.length;
            return 1; // mouse
        },

        panStart: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || this._transformStarted || event.pointerType === 'mouse') {
                return;
            }

            this._dragStarted = true;
            this._nbPointerLast = this._computeTouches(event);

            var pos;
            if (this._nbPointerLast === 3 || this._nbPointerLast === 2) {
                pos = manipulator.getPositionRelativeToCanvas(event.center.x, event.center.y);
                this._lastPos = pos;
            } else if (this._nbPointerLast === 1) {
                if (this._lastPos === undefined) {
                    pos = manipulator.getCanvasCenter();
                } else {
                    pos = this._lastPos;
                }
            }

            manipulator.computeIntersections(pos);

            if (this._nbPointerLast === 3) {
                var panInterpolator = manipulator.getPanInterpolator();
                manipulator.getPanInterpolator().reset();
                var xPan = event.center.x * this._panFactorX;
                var yPan = event.center.y * this._panFactorY;
                panInterpolator.set(xPan, yPan);
            } else if (this._nbPointerLast === 1) {
                manipulator.getRotateInterpolator().reset();
            }
        },

        panMove: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || !this._dragStarted || event.pointerType === 'mouse') {
                return;
            }

            var nbPointers = this._computeTouches(event);

            // prevent sudden big changes in the event.center variables
            if (this._nbPointerLast !== nbPointers) {
                if (nbPointers === 3) manipulator.getPanInterpolator().reset();
                else if (this._nbPointerLast === 1) manipulator.getRotateInterpolator().reset();
                this._nbPointerLast = nbPointers;
            }

            if (nbPointers === 3) {
                var panInterpolator = manipulator.getPanInterpolator();
                var xPan = event.center.x * this._panFactorX;
                var yPan = event.center.y * this._panFactorY;
                panInterpolator.setTarget(xPan, yPan);
            } else if (this._nbPointerLast === 1) {
                var rotateInterpolator = manipulator.getRotateInterpolator();
                var xRot = event.center.x * this._rotateFactorX;
                var yRot = event.center.y * this._rotateFactorY;
                rotateInterpolator.setTarget(xRot, yRot);
            }
        },

        panEnd: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || !this._dragStarted || event.pointerType === 'mouse') {
                return;
            }

            this._dragStarted = false;
        },

        pinchStart: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || event.pointerType === 'mouse') {
                return;
            }

            this._transformStarted = true;

            this._lastScale = event.scale;
            manipulator.getZoomInterpolator().reset();
            manipulator.getZoomInterpolator().set(this._lastScale);
            event.preventDefault();
        },

        pinchEnd: function(event) {
            if (!this._isValid) return;

            if (event.pointerType === 'mouse') {
                return;
            }

            this._transformStarted = false;
        },

        pinchInOut: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || !this._transformStarted || event.pointerType === 'mouse') {
                return;
            }

            var scale = (event.scale - this._lastScale) * this._zoomFactor;
            this._lastScale = event.scale;

            var zoomInterpolator = manipulator.getZoomInterpolator();
            zoomInterpolator.setTarget(zoomInterpolator.getTarget()[0] - scale);
        },

        doubleTap: function(event) {
            if (!this._isValid) return;

            var manipulator = this._manipulator;
            if (!manipulator || event.pointerType === 'mouse') {
                return;
            }

            var pos = manipulator.getPositionRelativeToCanvas(event.center.x, event.center.y);
            this._lastPos = pos;

            manipulator.getZoomInterpolator().set(0.0);
            var zoomInterpolator = manipulator.getZoomInterpolator();
            // Default interval 10
            zoomInterpolator.setTarget(zoomInterpolator.getTarget()[0] - 10);
        },

        removeEventProxy: function(proxy) {
            if (!proxy || !this._eventProxy) return;

            proxy.off('panstart ', this._cbPanStart);
            proxy.off('panmove', this._cbPanMove);
            proxy.off('panend', this._cbPanEnd);
            proxy.off('pinchstart', this._cbPinchStart);
            proxy.off('pinchend', this._cbPinchEnd);
            proxy.off('pinchin pinchout', this._cbPinchInOut);
            proxy.off('tap', this._cbDoubleTap);
        },

        setManipulator: function(manipulator) {
            this._manipulator = manipulator;
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (CADManipulatorHammerController);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_OrbitManipulatorHammerController__ = __webpack_require__(93);


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_osgGA_OrbitManipulatorHammerController__["a" /* default */]);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);



var FirstPersonManipulatorWebVRController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    FirstPersonManipulatorWebVRController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {},
        update: function(q, position) {
            this._manipulator.setPoseVR(q, position);
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (FirstPersonManipulatorWebVRController);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_keyboardEventsController__ = __webpack_require__(90);




var FirstPersonManipulatorStandardMouseKeyboardController = function(manipulator) {
    __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].call(this, manipulator);
    this.init();
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    FirstPersonManipulatorStandardMouseKeyboardController,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype, {
        init: function() {
            this._delay = 0.15;
            this._stepFactor = 1.0; // meaning radius*stepFactor to move
            this._buttonup = true;
            this._keyboardEventsCtrl = new __WEBPACK_IMPORTED_MODULE_2_osg_keyboardEventsController__["a" /* default */]();
        },
        // called to enable/disable controller
        setEnable: function(bool) {
            if (!bool) {
                // reset mode if we disable it
                this._buttonup = true;
            }
            __WEBPACK_IMPORTED_MODULE_0_osgGA_Controller__["a" /* default */].prototype.setEnable.call(this, bool);
        },
        setEventProxy: function(proxy) {
            this._eventProxy = proxy;
        },
        setManipulator: function(manipulator) {
            this._manipulator = manipulator;

            // we always want to sync speed of controller with manipulator
            this._manipulator.setStepFactor(this._stepFactor);
        },

        pushButton: function() {
            this._buttonup = false;
        },
        releaseButton: function() {
            this._buttonup = true;
        },

        mousedown: function(ev) {
            var pos = this._eventProxy.getPositionRelativeToCanvas(ev);
            var manipulator = this._manipulator;
            manipulator.getLookPositionInterpolator().set(pos[0], pos[1]);
            this.pushButton();
        },
        mouseup: function(/*ev */) {
            this.releaseButton();
        },
        mouseout: function(/*ev */) {
            this.releaseButton();
        },
        mousemove: function(ev) {
            if (this._buttonup === true) {
                return;
            }

            var pos = this._eventProxy.getPositionRelativeToCanvas(ev);
            this._manipulator.getLookPositionInterpolator().setDelay(this._delay);
            this._manipulator.getLookPositionInterpolator().setTarget(pos[0], pos[1]);

            ev.preventDefault();
        },
        mousewheel: function(ev, intDelta /*, deltaX, deltaY */) {
            this._stepFactor = Math.min(Math.max(0.001, this._stepFactor + intDelta * 0.01), 4.0);
            this._manipulator.setStepFactor(this._stepFactor);
        },

        keydown: function(event) {
            var manipulator = this._manipulator;
            if (this._keyboardEventsCtrl.isSpaceEvent(event.key.toLowerCase())) {
                manipulator.computeHomePosition();
                event.preventDefault();
            } else if (this._keyboardEventsCtrl.isUpEvent(event.key)) {
                // w/z/up
                manipulator.getForwardInterpolator().setDelay(this._delay);
                manipulator.getForwardInterpolator().setTarget(1);
                event.preventDefault();
                return false;
            } else if (this._keyboardEventsCtrl.isDownEvent(event.key)) {
                // S/down
                manipulator.getForwardInterpolator().setDelay(this._delay);
                manipulator.getForwardInterpolator().setTarget(-1);
                event.preventDefault();
                return false;
            } else if (this._keyboardEventsCtrl.isRightEvent(event.key)) {
                // D/right
                manipulator.getSideInterpolator().setDelay(this._delay);
                manipulator.getSideInterpolator().setTarget(1);
                event.preventDefault();
                return false;
            } else if (this._keyboardEventsCtrl.isLeftEvent(event.key)) {
                // a/q/left
                manipulator.getSideInterpolator().setDelay(this._delay);
                manipulator.getSideInterpolator().setTarget(-1);
                event.preventDefault();
                return false;
            }
            return undefined;
        },

        keyup: function(event) {
            var manipulator = this._manipulator;
            if (
                this._keyboardEventsCtrl.isUpEvent(event.key) ||
                this._keyboardEventsCtrl.isDownEvent(event.key)
            ) {
                // S/down
                manipulator.getForwardInterpolator().setDelay(this._delay);
                manipulator.getForwardInterpolator().setTarget(0);
                return false;
            } else if (
                this._keyboardEventsCtrl.isRightEvent(event.key) ||
                this._keyboardEventsCtrl.isLeftEvent(event.key)
            ) {
                // a/q/left
                manipulator.getSideInterpolator().setDelay(this._delay);
                manipulator.getSideInterpolator().setTarget(0);
                return false;
            }
            return undefined;
        }
    })
);

/* harmony default export */ __webpack_exports__["a"] = (FirstPersonManipulatorStandardMouseKeyboardController);


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_shape__ = __webpack_require__(33);


/*
 * Given a Camera, update a wireframe representation of its
 * view frustum from a projection and depthrange
 * @param Geomtry g frustum geometry
 * @param Matrix proj Projection
 * @param Vec2 dR depthRange (optional, only if proj is infinite)
 */
var updateFrustum = function(proj, dR) {
    var near, far;
    if (!dR) {
        // Get near and far from the Projection matrix.
        near = proj[14] / (proj[10] - 1.0);
        far = proj[14] / (1.0 + proj[10]);
    } else {
        near = dR[0];
        far = dR[1];
    }

    // Get the sides of the near plane.
    var nLeft = near * (proj[8] - 1.0) / proj[0];
    var nRight = near * (1.0 + proj[8]) / proj[0];
    var nTop = near * (1.0 + proj[9]) / proj[5];
    var nBottom = near * (proj[9] - 1.0) / proj[5];

    // Get the sides of the far plane.
    var fLeft = far * (proj[8] - 1.0) / proj[0];
    var fRight = far * (1.0 + proj[8]) / proj[0];
    var fTop = far * (1.0 + proj[9]) / proj[5];
    var fBottom = far * (proj[9] - 1.0) / proj[5];

    var vBuff = this.getAttributes().Vertex;
    var v = vBuff.getElements();

    // eight corners of the near and far planes.
    v[0] = nLeft;
    v[1] = nBottom;
    v[2] = -near;

    v[3] = nRight;
    v[4] = nBottom;
    v[5] = -near;

    v[6] = nRight;
    v[7] = nTop;
    v[8] = -near;

    v[9] = nLeft;
    v[10] = nTop;
    v[11] = -near;

    v[12] = fLeft;
    v[13] = fBottom;
    v[14] = -far;

    v[15] = fRight;
    v[16] = fBottom;
    v[17] = -far;

    v[18] = fRight;
    v[19] = fTop;
    v[20] = -far;

    v[21] = fLeft;
    v[22] = fTop;
    v[23] = -far;

    vBuff.dirty();
};
/*
 * Given a Camera, create a wireframe representation
 *  of its view frustum
 */
var createDebugFrustrumGeometry = function() {
    var g = __WEBPACK_IMPORTED_MODULE_0_osg_shape__["a" /* default */].createBoundingBoxGeometry();
    g.updateGeometry = updateFrustum;
    return g;
};

/* harmony default export */ __webpack_exports__["a"] = ({
    createDebugFrustumGeometry: createDebugFrustrumGeometry
});


/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgShader_ShaderGenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgAnimation_MorphGeometry__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgAnimation_UpdateMorph__ = __webpack_require__(86);
















////////////////////////
// COMPILER OFFSET NORMAL
////////////////////////
var CompilerOffsetNormal = function() {
    __WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].apply(this, arguments);
};

var configNormal = __WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].cloneStateAttributeConfig(__WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */]);
configNormal.textureAttribute = [];

__WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].setStateAttributeConfig(CompilerOffsetNormal, configNormal);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CompilerOffsetNormal,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].prototype, {
        getCompilerName: function() {
            return 'CompilerOffsetNormal';
        },
        initTextureAttributes: function() {},
        createFragmentShaderGraph: function() {
            var frag = this.getNode('glFragColor');

            this.getNode('SetAlpha')
                .inputs({
                    color: this.getOrCreateUniform('vec3', 'uColorDebug'),
                    alpha: this.createVariable('float').setValue('1.0')
                })
                .outputs({
                    result: frag
                });

            return [frag];
        },
        getOffsetDirection: function() {
            return this.getOrCreateModelNormal();
        },
        getOrCreateModelVertex: function() {
            var vertexOffset = this.getVariable('vertexOffset');
            if (vertexOffset) return vertexOffset;

            vertexOffset = this.createVariable('vec3', 'vertexOffset');

            var str =
                '%out = %offset == 1.0 ? %vertex + normalize(%direction.xyz) * %scale: %vertex;';
            this.getNode('InlineCode')
                .code(str)
                .inputs({
                    offset: this.getOrCreateAttribute('float', 'Offset'),
                    direction: this.getOffsetDirection(),
                    vertex: __WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].prototype.getOrCreateModelVertex.call(this),
                    scale: this.getOrCreateUniform('float', 'uScale')
                })
                .outputs({
                    out: vertexOffset
                });

            return vertexOffset;
        },
        getOrCreateViewVertex: function() {
            var out = this._variables.FragEyeVector;
            if (out && !out.isEmpty()) return out;
            out = this._varyings.FragEyeVector || this.createVariable('vec4', 'FragEyeVector');

            this.getNode('MatrixMultPosition')
                .inputs({
                    matrix: this.getOrCreateUniform('mat4', 'uViewMatrix'),
                    vec: this.getOrCreateModelVertex()
                })
                .outputs({
                    vec: out
                });

            return out;
        }
    }),
    'osgUtil',
    'CompilerOffsetNormal'
);

var ShaderGeneratorCompilerOffsetNormal = function() {
    __WEBPACK_IMPORTED_MODULE_10_osgShader_ShaderGenerator__["a" /* default */].apply(this, arguments);
    this.setShaderCompiler(CompilerOffsetNormal);
};
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ShaderGeneratorCompilerOffsetNormal,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_10_osgShader_ShaderGenerator__["a" /* default */].prototype, {}),
    'osgUtil',
    'ShaderGeneratorCompilerOffsetNormal'
);

////////////////////////
// COMPILER OFFSET TANGENT
////////////////////////
var CompilerOffsetTangent = function() {
    CompilerOffsetNormal.apply(this, arguments);
};

var configTangent = configNormal;
__WEBPACK_IMPORTED_MODULE_11_osgShader_Compiler__["a" /* default */].setStateAttributeConfig(CompilerOffsetTangent, configTangent);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CompilerOffsetTangent,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(CompilerOffsetNormal.prototype, {
        getCompilerName: function() {
            return 'CompilerOffsetTangent';
        },
        getOffsetDirection: function() {
            return this.getOrCreateModelTangent();
        }
    }),
    'osgUtil',
    'CompilerOffsetTangent'
);

var ShaderGeneratorCompilerOffsetTangent = function() {
    __WEBPACK_IMPORTED_MODULE_10_osgShader_ShaderGenerator__["a" /* default */].apply(this, arguments);
    this.setShaderCompiler(CompilerOffsetTangent);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ShaderGeneratorCompilerOffsetTangent,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_10_osgShader_ShaderGenerator__["a" /* default */].prototype, {}),
    'osgUtil',
    'ShaderGeneratorCompilerOffsetTangent'
);

////////////////////////
// DISPLAY NORMAL VISITOR
////////////////////////

var DisplayNormalVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);

    this._unifScale = __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createFloat(1.0, 'uScale');

    var ns = (this._normalStateSet = new __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__["a" /* default */]());
    ns.addUniform(__WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createFloat3(__WEBPACK_IMPORTED_MODULE_9_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0), 'uColorDebug'));
    ns.addUniform(this._unifScale);
    ns.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].NEVER));
    ns.setShaderGeneratorName('debugNormal');

    var ts = (this._tangentStateSet = new __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__["a" /* default */]());
    ts.addUniform(__WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createFloat3(__WEBPACK_IMPORTED_MODULE_9_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0), 'uColorDebug'));
    ts.addUniform(this._unifScale);
    ts.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].NEVER));
    ts.setShaderGeneratorName('debugTangent');
};

DisplayNormalVisitor.CompilerOffsetNormal = CompilerOffsetNormal;
DisplayNormalVisitor.CompilerOffsetTangent = CompilerOffsetTangent;
DisplayNormalVisitor.ShaderGeneratorCompilerOffsetNormal = ShaderGeneratorCompilerOffsetNormal;
DisplayNormalVisitor.ShaderGeneratorCompilerOffsetTangent = ShaderGeneratorCompilerOffsetTangent;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    DisplayNormalVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        setScale: function(scale) {
            this._unifScale.setFloat(scale);
        },
        setTangentVisibility: function(bool) {
            this._tangentStateSet.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */](bool ? __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].LESS : __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].NEVER));
        },
        setNormalVisibility: function(bool) {
            this._normalStateSet.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */](bool ? __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].LESS : __WEBPACK_IMPORTED_MODULE_8_osg_Depth__["a" /* default */].NEVER));
        },
        apply: function(node) {
            if (node._isVisitedNormalDebug) return;
            node._isVisitedNormalDebug = true;

            if (node instanceof __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]) {
                this._createDebugGeom(node, 'Normal', this._normalStateSet);
                this._createDebugGeom(node, 'Tangent', this._tangentStateSet);
                return;
            }

            this.traverse(node);

            var list = node.getUpdateCallbackList();
            // reference the new morph geometry on the UpdateMorph callbacks
            for (var i = 0, nbCB = list.length; i < nbCB; ++i) {
                if (list[i] instanceof __WEBPACK_IMPORTED_MODULE_14_osgAnimation_UpdateMorph__["a" /* default */]) {
                    list[i].init(node);
                }
            }
        },
        _createDoubleOffsetArray: function(nbVertices) {
            // 0 means original vertex pos
            // 1 means offseted vertex
            var elts = new Float32Array(nbVertices * 2);
            for (var i = 0; i < nbVertices; ++i) {
                elts[i * 2] = 1.0;
            }
            return new __WEBPACK_IMPORTED_MODULE_3_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, elts, 1);
        },
        _createDoubledBufferArray: function(bufferArray) {
            // in case of morphs
            if (bufferArray.getInitialBufferArray)
                bufferArray = bufferArray.getInitialBufferArray();

            var itemSize = bufferArray.getItemSize();
            var elements = bufferArray.getElements();
            var nbElements = elements.length / itemSize;

            var ctor = elements.constructor;
            var elementsDouble = new ctor(elements.length * 2);
            for (var i = 0; i < nbElements; ++i) {
                var iSize = i * itemSize;
                var iSize2 = iSize * 2;

                for (var j = 0; j < itemSize; ++j) {
                    elementsDouble[iSize2 + j] = elementsDouble[iSize2 + j + itemSize] =
                        elements[iSize + j];
                }
            }

            return new __WEBPACK_IMPORTED_MODULE_3_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, elementsDouble, itemSize);
        },
        _addMorphTargets: function(originMorph, morph, vecName) {
            var targets = morph.getMorphTargets();
            morph.setName(originMorph.getName()); // for the UpdateMorph

            var originTargets = originMorph.getMorphTargets();
            for (var i = 0, nbTarget = originTargets.length; i < nbTarget; ++i) {
                var origTarget = originTargets[i];
                var origAttrs = origTarget.getVertexAttributeList();

                var newTarget = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
                newTarget.setName(origTarget.getName()); // for the UpdateMorph
                var newAttrs = newTarget.getVertexAttributeList();

                newAttrs.Vertex = this._createDoubledBufferArray(origAttrs.Vertex);
                if (origAttrs[vecName])
                    newAttrs[vecName] = this._createDoubledBufferArray(origAttrs[vecName]);

                targets.push(newTarget);
            }

            morph.mergeChildrenVertexAttributeList();
            return morph;
        },
        _createDebugGeom: function(node, vecName, stateSet) {
            var attrs = node.getAttributes();
            var dispVec = attrs[vecName];
            if (!dispVec) return;

            var vertices = attrs.Vertex;
            if (!vertices) return;

            var originMorph;
            if (node instanceof __WEBPACK_IMPORTED_MODULE_13_osgAnimation_MorphGeometry__["a" /* default */]) originMorph = node;
            else if (node.getSourceGeometry && node.getSourceGeometry() instanceof __WEBPACK_IMPORTED_MODULE_13_osgAnimation_MorphGeometry__["a" /* default */])
                originMorph = node.getSourceGeometry();

            var nbVertices = vertices.getElements().length / vertices.getItemSize();

            // vertex and normals
            var source = originMorph ? new __WEBPACK_IMPORTED_MODULE_13_osgAnimation_MorphGeometry__["a" /* default */]() : new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
            source.getAttributes().Vertex = this._createDoubledBufferArray(vertices);
            source.getAttributes().Offset = this._createDoubleOffsetArray(nbVertices);
            source.getAttributes()[vecName] = this._createDoubledBufferArray(dispVec);

            // primitive
            source.getPrimitives().push(new __WEBPACK_IMPORTED_MODULE_4_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_primitiveSet__["a" /* default */].LINES, 0, nbVertices * 2));

            if (originMorph) this._addMorphTargets(originMorph, source, vecName);

            var geom;
            if (node instanceof __WEBPACK_IMPORTED_MODULE_12_osgAnimation_RigGeometry__["a" /* default */]) {
                var rig = new __WEBPACK_IMPORTED_MODULE_12_osgAnimation_RigGeometry__["a" /* default */]();
                rig.setSourceGeometry(source);

                rig.getVertexAttributeList().Bones = this._createDoubledBufferArray(attrs.Bones);
                rig.getVertexAttributeList().Weights = this._createDoubledBufferArray(
                    attrs.Weights
                );

                // we can simply share the rig-animated stateSet attributes
                // (unlike morph, the stateSet and update animation doesn't operate at per vertex level)
                rig._rigTransformImplementation = node._rigTransformImplementation;
                rig._stateSetAnimation = node._stateSetAnimation;

                rig.mergeChildrenData();
                geom = rig;
            } else {
                geom = source;
            }

            // add geom to the graph
            var parents = node.getParents();
            var nbParents = parents.length;
            geom._isVisitedNormalDebug = true;
            geom._isNormalDebug = true;
            geom.setStateSet(stateSet);
            for (var i = 0; i < nbParents; ++i) parents[i].addChild(geom);

            return geom;
        }
    }),
    'osgUtil',
    'DisplayNormalVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (DisplayNormalVisitor);


/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_node_data__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_operations__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShader_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShadow_shaderLib__ = __webpack_require__(120);







var Factory = function() {
    this._nodes = new window.Map();

    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'lights.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'lightCommon.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'skinning.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'morphing.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'billboard.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'functions.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_4_osgShader_shaderLib__["a" /* default */], 'textures.glsl');

    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_5_osgShadow_shaderLib__["a" /* default */], 'shadowCast.glsl');
    this.extractFunctions(__WEBPACK_IMPORTED_MODULE_5_osgShadow_shaderLib__["a" /* default */], 'shadowReceive.glsl');

    this.registerNodes(__WEBPACK_IMPORTED_MODULE_1_osgShader_node_data__["a" /* default */]);
    this.registerNodes(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_operations__["a" /* default */]);
};

Factory.prototype = {
    registerNodes: function(obj) {
        for (var key in obj) {
            this.registerNode(key, obj[key]);
        }
    },

    registerNode: function(name, constructor) {
        if (this._nodes.has(name)) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('Node ' + name + ' already registered');
        }
        this._nodes.set(name, constructor);
    },

    extractFunctions: function(lib, filename) {
        this.registerNodes(__WEBPACK_IMPORTED_MODULE_3_osgShader_utils__["a" /* default */].extractFunctions(lib, filename));
    },

    // extra argument are passed to the constructor of the node
    getNode: function(name) {
        var Constructor = this._nodes.get(name);
        if (!Constructor) {
            // Means either:
            // - the node isn't registered by methods above
            // - you mistyped the name
            // - Core Node has changed its Name
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('Node ' + name + ' does not exist');
            return undefined;
        }

        // call a constructor with array arguments
        // http://www.ecma-international.org/ecma-262/5.1/#sec-13.2.2
        var instance = window.Object.create(Constructor.prototype);
        Constructor.apply(instance, Array.prototype.slice.call(arguments, 1));

        return instance;
    }
};

var instance = new Factory();

/* harmony default export */ __webpack_exports__["a"] = (instance);


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShader_ShaderGenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShadow_ShadowCastCompiler__ = __webpack_require__(156);



var ShaderGeneratorShadowCast = function() {
    __WEBPACK_IMPORTED_MODULE_0_osgShader_ShaderGenerator__["a" /* default */].apply(this, arguments);
    this.setShaderCompiler(__WEBPACK_IMPORTED_MODULE_1_osgShadow_ShadowCastCompiler__["a" /* default */]);
};

ShaderGeneratorShadowCast.prototype = __WEBPACK_IMPORTED_MODULE_0_osgShader_ShaderGenerator__["a" /* default */].prototype;

/* harmony default export */ __webpack_exports__["a"] = (ShaderGeneratorShadowCast);


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__ = __webpack_require__(56);



var CompilerShadowCast = function() {
    __WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__["a" /* default */].apply(this, arguments);
};

var config = __WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__["a" /* default */].cloneStateAttributeConfig(__WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__["a" /* default */]);
config.attribute = ['ShadowCast', 'Morph', 'Skinning', 'PointSize'];

__WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__["a" /* default */].setStateAttributeConfig(CompilerShadowCast, config);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CompilerShadowCast,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osgShader_Compiler__["a" /* default */].prototype, {
        getCompilerName: function() {
            return 'ShadowCast';
        },

        initAttributes: function() {
            var attributes = this._attributes;

            for (var i = 0, l = attributes.length; i < l; i++) {
                var type = attributes[i].className();

                if (type === 'ShadowCastAttribute') {
                    this._shadowCastAttribute = attributes[i];
                } else if (type === 'Billboard') {
                    this._isBillboard = !!attributes[i];
                } else if (type === 'SkinningAttribute') {
                    this._skinningAttribute = attributes[i];
                } else if (type === 'MorphAttribute') {
                    this._morphAttribute = attributes[i];
                } else if (type === 'PointSizeAttribute') {
                    this._pointSizeAttribute = attributes[i];
                }
            }
        },

        registerTextureAttributes: function() {},

        // Depth Shadow Map Casted from Light POV Depth encoded in color buffer
        createShadowCastDepth: function(out) {
            var defines = this._shadowCastAttribute.getDefines();

            var node = this.getNode('ShadowCast')
                .inputs({
                    shadowDepthRange: this.getOrCreateUniform('vec4', 'uShadowDepthRange'),
                    fragEye: this.getOrCreateViewVertex()
                })
                .outputs({ result: out });

            node.getDefines = function() {
                return defines;
            };

            return out;
        },

        // encapsulate for easier overwrite by user defined compiler
        // that would inherint from this compiler Do not merge with above method
        createFragmentShaderGraph: function() {
            var frag = this.getNode('glFragColor');
            return [this.createShadowCastDepth(frag)];
        }
    }),
    'osgShader',
    'CompilerShadowCast'
);

/* harmony default export */ __webpack_exports__["a"] = (CompilerShadowCast);


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgShader_ShaderGenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_Depth__ = __webpack_require__(31);















////////////////////////
// COMPILER DEBUG GEOMETRY
////////////////////////
var CompilerColorGeometry = function() {
    __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].apply(this, arguments);
};

var configColor = __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].cloneStateAttributeConfig(__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */]);
configColor.textureAttribute = [];
configColor.attribute = ['PointSize', 'Morph', 'Skinning'];

__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].setStateAttributeConfig(CompilerColorGeometry, configColor);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CompilerColorGeometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].prototype, {
        getCompilerName: function() {
            return 'CompilerDebugGeometry';
        },
        initTextureAttributes: function() {},
        createFragmentShaderGraph: function() {
            var frag = this.getNode('glFragColor');

            this.getNode('SetAlpha')
                .inputs({
                    color: this.getOrCreateUniform('vec3', 'uColorDebug'),
                    alpha: this.createVariable('float').setValue('1.0')
                })
                .outputs({
                    result: frag
                });

            return [frag];
        }
    }),
    'osgUtil',
    'CompilerColorGeometry'
);

var ShaderGeneratorCompilerColorGeometry = function() {
    __WEBPACK_IMPORTED_MODULE_7_osgShader_ShaderGenerator__["a" /* default */].apply(this, arguments);
    this.setShaderCompiler(CompilerColorGeometry);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ShaderGeneratorCompilerColorGeometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_7_osgShader_ShaderGenerator__["a" /* default */].prototype, {}),
    'osgUtil',
    'ShaderGeneratorCompilerColorGeometry'
);

////////////////////////
// COMPILER SKINNING DEBUG
////////////////////////
var CompilerColorSkinning = function() {
    __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].apply(this, arguments);
};

var configSkinning = __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].cloneStateAttributeConfig(__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */]);
configSkinning.textureAttribute = [];

__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].setStateAttributeConfig(CompilerColorSkinning, configSkinning);

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CompilerColorSkinning,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].prototype, {
        getCompilerName: function() {
            return 'CompilerDebugSkinning';
        },
        initTextureAttributes: function() {},
        createFragmentShaderGraph: function() {
            var frag = this.getNode('glFragColor');

            this.getNode('SetAlpha')
                .inputs({
                    color: this.getOrCreateVarying('vec3', 'vBonesColor'),
                    alpha: this.createVariable('float').setValue('1.0')
                })
                .outputs({
                    result: frag
                });

            return [frag];
        },
        declareVertexVaryings: function(roots) {
            var color = this.getOrCreateVarying('vec3', 'vBonesColor');
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateAttribute('vec3', 'BonesColor'))
                .outputs(color);
            return __WEBPACK_IMPORTED_MODULE_8_osgShader_Compiler__["a" /* default */].prototype.declareVertexVaryings.call(this, roots);
        }
    }),
    'osgUtil',
    'CompilerColorSkinning'
);

var ShaderGeneratorCompilerColorSkinning = function() {
    __WEBPACK_IMPORTED_MODULE_7_osgShader_ShaderGenerator__["a" /* default */].apply(this, arguments);
    this.setShaderCompiler(CompilerColorSkinning);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ShaderGeneratorCompilerColorSkinning,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_7_osgShader_ShaderGenerator__["a" /* default */].prototype, {}),
    'osgUtil',
    'ShaderGeneratorCompilerColorSkinning'
);

///////////////////////////
// DISPLAY GEOMETRY VISITOR
///////////////////////////

var GeometryColorDebugVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);
    this._debugColor = true;
    this._debugSkinning = false;

    this._stCenter = new __WEBPACK_IMPORTED_MODULE_5_osg_StateSet__["a" /* default */](); // state set of center crosses
    this._stCenter.setShaderGeneratorName('debugGeometry');
};

GeometryColorDebugVisitor.CompilerColorGeometry = CompilerColorGeometry;
GeometryColorDebugVisitor.ShaderGeneratorCompilerColorGeometry = ShaderGeneratorCompilerColorGeometry;

GeometryColorDebugVisitor.CompilerSkinningGeometry = CompilerColorSkinning;
GeometryColorDebugVisitor.ShaderGeneratorCompilerColorSkinning = ShaderGeneratorCompilerColorSkinning;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    GeometryColorDebugVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        setGeometryDebug: function(node) {
            this._stCenter.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */].ALWAYS));
            this._debugColor = true;
            this._debugSkinning = false;
            this.apply(node);
        },

        setSkinningDebug: function(node) {
            this._stCenter.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */].NEVER));
            this._debugColor = false;
            this._debugSkinning = true;
            this.apply(node);
        },

        disableDebug: function(node) {
            this._stCenter.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_13_osg_Depth__["a" /* default */].NEVER));
            this._debugColor = false;
            this._debugSkinning = false;
            this.apply(node);
        },

        _debugCenterGeometry: function(node, color) {
            // draw cross with slightly different color than the geometry
            var bb = node.getBound();

            var verts = new Float32Array(18);
            var off = bb.radius() * 0.1;
            verts[0] = off;
            verts[3] = -off;

            verts[7] = off;
            verts[10] = -off;

            verts[14] = off;
            verts[17] = -off;

            var geo = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();
            geo.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_9_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, verts, 3);
            var primitive = new __WEBPACK_IMPORTED_MODULE_10_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_osg_primitiveSet__["a" /* default */].LINES, 0, 6);
            geo.getPrimitives().push(primitive);

            var mt = new __WEBPACK_IMPORTED_MODULE_12_osg_MatrixTransform__["a" /* default */]();
            var center = bb.center();
            mt.getMatrix()[12] = center[0];
            mt.getMatrix()[13] = center[1];
            mt.getMatrix()[14] = center[2];

            mt.addChild(geo);
            this.nodePath[this.nodePath.length - 2].addChild(mt);
            color = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(color[0] * 0.8, color[1] * 0.8, color[2] * 0.8);
            geo.getOrCreateStateSet().addUniform(__WEBPACK_IMPORTED_MODULE_4_osg_Uniform__["a" /* default */].createFloat3(color, 'uColorDebug'));
            mt.setStateSet(this._stCenter);

            mt._isCenterDebug = true;
        },

        _debugRigGeometry: function(node) {
            // a bone can be shared between several rigs so we use the instanceID to get unique color
            var vList = node.getVertexAttributeList();
            if (vList.BonesColor) return;

            var eltBones = vList.Bones.getElements();
            var eltWeights = vList.Weights.getElements();

            var bones = node._rigTransformImplementation._bones;
            var nbBones = eltBones.length / 4;

            var bonesColor = new Float32Array(nbBones * 3);

            for (var i = 0; i < nbBones; ++i) {
                var idb = i * 4;
                var c0 = bones[eltBones[idb]].getOrCreateDebugColor();
                var c1 = bones[eltBones[idb + 1]].getOrCreateDebugColor();
                var c2 = bones[eltBones[idb + 2]].getOrCreateDebugColor();
                var c3 = bones[eltBones[idb + 3]].getOrCreateDebugColor();

                var w0 = eltWeights[idb];
                var w1 = eltWeights[idb + 1];
                var w2 = eltWeights[idb + 2];
                var w3 = eltWeights[idb + 3];

                var idc = i * 3;
                bonesColor[idc] = w0 * c0[0] + w1 * c1[0] + w2 * c2[0] + w3 * c3[0];
                bonesColor[idc + 1] = w0 * c0[1] + w1 * c1[1] + w2 * c2[1] + w3 * c3[1];
                bonesColor[idc + 2] = w0 * c0[2] + w1 * c1[2] + w2 * c2[2] + w3 * c3[2];
            }

            vList.BonesColor = new __WEBPACK_IMPORTED_MODULE_9_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_9_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, bonesColor, 3);
        },

        _debugGeometry: function(node) {
            var debugColor = this._debugColor;
            var debugSkinning = this._debugSkinning && node instanceof __WEBPACK_IMPORTED_MODULE_3_osgAnimation_RigGeometry__["a" /* default */];

            if (!debugColor && !debugSkinning) {
                if (node._originalStateSet !== undefined) {
                    node.setStateSet(node._originalStateSet || undefined);
                }
                return;
            }

            if (node._originalStateSet === undefined) {
                node._originalStateSet = node.getStateSet() || null;
            }

            var stateSet = new __WEBPACK_IMPORTED_MODULE_5_osg_StateSet__["a" /* default */]();
            node.setStateSet(stateSet);

            if (debugSkinning) {
                stateSet.setShaderGeneratorName('debugSkinning');
                this._debugRigGeometry(node);
                return;
            }

            // debug color
            var color = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(Math.random(), Math.random(), Math.random());
            stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_4_osg_Uniform__["a" /* default */].createFloat3(color, 'uColorDebug'));
            stateSet.setShaderGeneratorName('debugGeometry');

            this._debugCenterGeometry(node, color);
        },

        apply: function(node) {
            if (node._isNormalDebug || node._isCenterDebug) return;

            if (node instanceof __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]) {
                this._debugGeometry(node);
            }

            this.traverse(node);
        }
    }),
    'osgUtil',
    'GeometryColorDebugVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (GeometryColorDebugVisitor);


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_MorphGeometry__ = __webpack_require__(35);




var DisplayGraphNode = function(selectables) {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);

    this._selectables = selectables;
    this._nodeList = [];
    this._linkList = [];

    // don't reference twice same node
    this._uniqueNodes = new window.Set();
    this._uniqueEdges = new window.Set();
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    DisplayGraphNode,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        getColorFromClassName: function(name) {
            switch (name) {
                case 'ShadowedScene':
                    return '#3D3D3D';
                case 'Camera':
                    return '#AB7BCF';
                case 'RenderBin':
                    return '#59778B';
                case 'LightSource':
                    return '#53967D';
                case 'RenderStage':
                    return '#DDCC55';
                case 'RenderLeaf':
                case 'Geometry':
                    return '#FFCC55';
                case 'RigGeometry':
                    return '#DD8800';
                case 'MorphGeometry':
                    return '#AA5500';
                case 'MatrixTransform':
                    return '#CE697E';
                case 'StateSet':
                    return '#0099FF';
                case 'StateGraph':
                case 'Skeleton':
                    return '#96999E';
                case 'Bone':
                    return '#A9DEAA';
                case 'Node':
                    return '#FFFFFF';
                default:
                    return '#FF00AA';
            }
        },

        createGraph: function(root) {
            this.reset();
            root.accept(this);
        },

        reset: function() {
            this._nodeList.length = 0;
            this._linkList.length = 0;
            this._uniqueNodes.clear();
            this._uniqueEdges.clear();
        },

        apply: function(node) {
            if (node._isNormalDebug) return;

            if (!this._uniqueNodes.has(node.getInstanceID())) {
                this._uniqueNodes.add(node.getInstanceID());
                this._nodeList.push(node);
            }

            if (this.nodePath.length >= 2) {
                var parentID = this.nodePath[this.nodePath.length - 2].getInstanceID();
                var childID = node.getInstanceID();
                var key = parentID + '+' + childID;
                if (!this._uniqueEdges.has(key)) {
                    this._linkList.push({
                        parentNode: parentID,
                        childrenNode: childID
                    });
                    this._uniqueEdges.add(key);
                }
            }

            this.traverse(node);
        },

        // Create an array to display the matrix
        createMatrixGrid: function(node, matrixArray) {
            var nodeMatrix = '';

            nodeMatrix += '<table><tr><td>' + matrixArray[0] + '</td>';
            nodeMatrix += '<td>' + matrixArray[4] + '</td>';
            nodeMatrix += '<td>' + matrixArray[8] + '</td>';
            nodeMatrix += '<td>' + matrixArray[12] + '</td></tr>';

            nodeMatrix += '<tr><td>' + matrixArray[1] + '</td>';
            nodeMatrix += '<td>' + matrixArray[5] + '</td>';
            nodeMatrix += '<td>' + matrixArray[9] + '</td>';
            nodeMatrix += '<td>' + matrixArray[13] + '</td></tr>';

            nodeMatrix += '<tr><td>' + matrixArray[2] + '</td>';
            nodeMatrix += '<td>' + matrixArray[6] + '</td>';
            nodeMatrix += '<td>' + matrixArray[10] + '</td>';
            nodeMatrix += '<td>' + matrixArray[14] + '</td></tr>';

            nodeMatrix += '<tr><td>' + matrixArray[3] + '</td>';
            nodeMatrix += '<td>' + matrixArray[7] + '</td>';
            nodeMatrix += '<td>' + matrixArray[11] + '</td>';
            nodeMatrix += '<td>' + matrixArray[15] + '</td></tr></table>';

            return nodeMatrix;
        },

        getLabel: function(obj) {
            var label = obj.className() + ' (' + obj.getInstanceID() + ')';
            if (obj.getName && obj.getName()) label += '\n' + obj.getName();
            return label;
        },

        generateNode: function(g, node) {
            var description = '';
            if (node.getMatrix && node.getMatrix()) {
                description += '<br /><br />' + this.createMatrixGrid(node, node.getMatrix());
            }

            this._selectables.set(node.getInstanceID().toString(), node);
            g.addNode(node.getInstanceID(), {
                label: this.getLabel(node),
                description: description,
                style:
                    'fill: ' + this.getColorFromClassName(node.className()) + ';stroke-width: 0px;'
            });
        },

        generateStateSet: function(g, node) {
            var stateSet = node.getStateSet();
            var stateSetID = stateSet.getInstanceID();

            var label = this.getLabel(stateSet);
            label += '\nNbTexture : ' + stateSet.getNumTextureAttributeLists();

            if (!g.hasNode(stateSetID)) {
                this._selectables.set(stateSetID.toString(), stateSet);
                g.addNode(stateSetID, {
                    label: label,
                    style:
                        'fill: ' +
                        this.getColorFromClassName(stateSet.className()) +
                        ';stroke-width: 0px;'
                });
            }

            g.addEdge(null, node.getInstanceID(), stateSetID, {
                style: 'stroke: ' + this.getColorFromClassName(stateSet.className()) + ';'
            });
        },

        generateSourceGeometry: function(g, node) {
            var sourceGeom = node.getSourceGeometry();
            var sourceGeomID = sourceGeom.getInstanceID();

            this._selectables.set(sourceGeomID.toString(), sourceGeom);
            g.addNode(sourceGeomID, {
                label: this.getLabel(sourceGeom),
                style:
                    'fill: ' +
                    this.getColorFromClassName(sourceGeom.className()) +
                    ';stroke-width: 0px;'
            });

            g.addEdge(null, node.getInstanceID(), sourceGeomID, {
                style: 'stroke: ' + this.getColorFromClassName(sourceGeom.className()) + ';'
            });
        },

        // Subfunction of createGraph, will iterate to create all the node and link in dagre
        generateNodeAndLink: function(g) {
            for (var i = 0, ni = this._nodeList.length; i < ni; i++) {
                var node = this._nodeList[i];

                // node
                this.generateNode(g, node);

                // adds statesets node
                if (node.getStateSet()) {
                    this.generateStateSet(g, node);
                }

                // adds source geometry node
                if (node.getSourceGeometry && node.getSourceGeometry() instanceof __WEBPACK_IMPORTED_MODULE_2_osgAnimation_MorphGeometry__["a" /* default */]) {
                    this.generateSourceGeometry(g, node);
                }
            }

            for (var j = 0, nj = this._linkList.length; j < nj; j++) {
                g.addEdge(null, this._linkList[j].parentNode, this._linkList[j].childrenNode);
            }
        }
    }),
    'osgUtil',
    'DisplayGraphNode'
);

/* harmony default export */ __webpack_exports__["a"] = (DisplayGraphNode);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgDB_DatabasePager__ = __webpack_require__(134);




var Scene = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._databasePager = new __WEBPACK_IMPORTED_MODULE_2_osgDB_DatabasePager__["a" /* default */]();
    this._sceneData = undefined;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Scene,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        getSceneData: function() {
            return this._sceneData;
        },

        setSceneData: function(node) {
            this._sceneData = node;
        },

        setDatabasePager: function(dbpager) {
            this._databasePager = dbpager;
        },

        getDatabasePager: function() {
            return this._databasePager;
        },

        // database pager are not implemented yet here
        updateSceneGraph: function(updateVisitor) {
            if (this._databasePager)
                this._databasePager.updateSceneGraph(updateVisitor.getFrameStamp());
            if (this._sceneData) this._sceneData.accept(updateVisitor);
        }
    }),
    'osgViewer',
    'Scene'
);

/* harmony default export */ __webpack_exports__["a"] = (Scene);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Uniform__ = __webpack_require__(5);









var glPrecision = ['#ifdef GL_ES', 'precision highp float;', '#endif'].join('\n');

var program;
var getOrCreateShader = function() {
    if (program) return program;
    var shaderName = '#define SHADER_NAME GizmoLine3D';
    var vertexshader = [
        glPrecision,
        'attribute vec3 Vertex;',
        'uniform mat4 uModelViewMatrix;',
        'uniform mat4 uProjectionMatrix;',
        shaderName,
        '',
        'void main(void) {',
        '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);',
        '}'
    ].join('\n');

    var fragmentshader = [
        glPrecision,
        'uniform vec4 uColor;',
        shaderName,
        '',
        'void main(void) {',
        '  gl_FragColor = uColor;',
        '}'
    ].join('\n');

    program = new __WEBPACK_IMPORTED_MODULE_5_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].VERTEX_SHADER, vertexshader),
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentshader)
    );
    return program;
};

var program2D;
var getOrCreateShader2D = function() {
    if (program2D) return program2D;
    var shaderName = '#define SHADER_NAME GizmoLine2D';
    var vertexshader = [
        glPrecision,
        'attribute vec2 Vertex;',
        shaderName,
        '',
        'void main(void) {',
        '  gl_Position = vec4(Vertex, 0.0, 1.0);',
        '}'
    ].join('\n');

    var fragmentshader = [
        glPrecision,
        shaderName,
        '',
        'void main(void) {',
        '  gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);',
        '}'
    ].join('\n');

    program2D = new __WEBPACK_IMPORTED_MODULE_5_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].VERTEX_SHADER, vertexshader),
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentshader)
    );
    return program2D;
};

var programQC;
var getOrCreateShaderQuadCircle = function() {
    if (programQC) return programQC;
    var shaderName = '#define SHADER_NAME GizmoQuadCircle';
    var vertexshader = [
        glPrecision,
        'attribute vec3 Vertex;',
        'uniform mat4 uModelViewMatrix;',
        'uniform mat4 uProjectionMatrix;',
        'varying vec3 vViewVertex;',
        shaderName,
        '',
        'void main(void) {',
        '  vViewVertex = Vertex;',
        '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);',
        '}'
    ].join('\n');

    var fragmentshader = [
        glPrecision,
        'uniform float uAngle;',
        'uniform vec3 uBase;',
        'uniform float uSize;',
        'varying vec3 vViewVertex;',
        'const float PI = 3.14159265358979323846264;',
        'const float PI2 = PI * 2.0;',
        shaderName,
        '',
        'void main(void) {',
        '  if(length(vViewVertex) > (uSize * 0.5))',
        '    discard;',
        '  vec3 vn = normalize(vViewVertex);',
        '  float angle = atan(uBase.y * vn.x - uBase.x * vn.y, dot(uBase, vn));',
        '  if(angle > 0.0) {',
        '    if(uAngle >= 0.0 && angle > uAngle) discard;',
        '    if(uAngle < -PI && angle < uAngle + PI2) discard;',
        '    if(uAngle < 0.0 && uAngle > -PI) discard;',
        '  }',
        '  if(angle < 0.0) {',
        '    if(uAngle <= 0.0 && angle < uAngle) discard;',
        '    if(uAngle > PI && angle > uAngle - PI2) discard;',
        '    if(uAngle > 0.0 && uAngle < PI) discard;',
        '  }',
        '  gl_FragColor = vec4(1.0, 1.0, 0.0, 0.5);',
        '}'
    ].join('\n');

    programQC = new __WEBPACK_IMPORTED_MODULE_5_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].VERTEX_SHADER, vertexshader),
        new __WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_6_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentshader)
    );
    return programQC;
};

var resetPrograms = function () {
    program = undefined;
    program2D = undefined;
    programQC = undefined;
};

var createDebugLineGeometry = function() {
    var g = new __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]();
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, new Float32Array(4), 2);
    var primitive = new __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__["a" /* default */].LINES, 0, 2);
    g.getPrimitives().push(primitive);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShader2D());
    return g;
};

var createTorusGeometry = function(
    argRadiusOut,
    argRadiusWidth,
    argNbRadial,
    argNbTubular,
    argArc
) {
    var radiusOut = argRadiusOut !== undefined ? argRadiusOut : 1.0;
    var radiusWidth = argRadiusWidth !== undefined ? argRadiusWidth : 0.2;
    var nbRadial = argNbRadial !== undefined ? argNbRadial : 6;
    var nbTubular = argNbTubular !== undefined ? argNbTubular : 64;
    var arc = argArc !== undefined ? argArc : Math.PI * 2;

    var nbVertices = (nbRadial + 1) * (nbTubular + 1);
    var nbTriangles = nbRadial * nbTubular * 2;
    var g = new __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]();
    var vertices = new Float32Array(nbVertices * 3);
    var indices = new Uint16Array(nbTriangles * 3);
    arc = arc || Math.PI * 2;
    var id = 0;
    var k = 0;
    var i = 0;
    var j = 0;
    for (j = 0; j <= nbRadial; ++j) {
        for (i = 0; i <= nbTubular; ++i) {
            var u = i / nbTubular * arc;
            var v = j / nbRadial * Math.PI * 2;
            k = id * 3;
            vertices[k] = (radiusOut + radiusWidth * Math.cos(v)) * Math.cos(u);
            vertices[k + 1] = (radiusOut + radiusWidth * Math.cos(v)) * Math.sin(u);
            vertices[k + 2] = radiusWidth * Math.sin(v);
            id++;
        }
    }
    id = 0;
    for (j = 1; j <= nbRadial; ++j) {
        for (i = 1; i <= nbTubular; ++i) {
            k = id * 6;
            indices[k] = (nbTubular + 1) * j + i - 1;
            indices[k + 1] = indices[k + 3] = (nbTubular + 1) * (j - 1) + i - 1;
            indices[k + 2] = indices[k + 5] = (nbTubular + 1) * j + i;
            indices[k + 4] = (nbTubular + 1) * (j - 1) + i;
            id++;
        }
    }
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShader());
    g
        .getPrimitives()
        .push(
            new __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__["a" /* default */](
                __WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__["a" /* default */].TRIANGLES,
                new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER, indices, 1)
            )
        );
    return g;
};

var createCylinderGeometry = function(
    argRadiusTop,
    argRadiusBottom,
    argHeight,
    argRadialSegments,
    argHeightSegments,
    argTopCap,
    argLowCap
) {
    var radiusTop = argRadiusTop !== undefined ? argRadiusTop : 1.0;
    var radiusBottom = argRadiusBottom !== undefined ? argRadiusBottom : 1.0;
    var height = argHeight !== undefined ? argHeight : 5.0;
    var radialSegments = argRadialSegments !== undefined ? argRadialSegments : 32;
    var heightSegments = argHeightSegments !== undefined ? argHeightSegments : 1;
    var topCap = argTopCap !== undefined ? argTopCap : true;
    var lowCap = argLowCap !== undefined ? argLowCap : true;

    topCap = topCap && radiusTop > 0.0;
    lowCap = lowCap && radiusBottom > 0.0;
    var heightHalf = height * 0.5;

    var nbVertices = (heightSegments + 1) * (radialSegments + 1);
    var nbTriangles = heightSegments * radialSegments * 2;
    if (topCap) {
        nbVertices += 1;
        nbTriangles += radialSegments;
    }
    if (lowCap) {
        nbVertices += 1;
        nbTriangles += radialSegments;
    }
    var g = new __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]();
    var vertices = new Float32Array(nbVertices * 3);
    var indices = new Uint16Array(nbTriangles * 3);

    var id = 0;
    var k = 0;
    var i = 0;
    var j = 0;
    for (i = 0; i <= heightSegments; i++) {
        var v = i / heightSegments;
        var radius = v * (radiusBottom - radiusTop) + radiusTop;
        for (j = 0; j <= radialSegments; j++) {
            var u = j / radialSegments;
            k = id * 3;
            vertices[k] = radius * Math.sin(u * Math.PI * 2);
            vertices[k + 1] = radius * Math.cos(u * Math.PI * 2);
            vertices[k + 2] = -v * height + heightHalf;
            id++;
        }
    }

    id = 0;
    for (j = 0; j < radialSegments; j++) {
        for (i = 0; i < heightSegments; i++) {
            k = id * 6;
            indices[k] = (radialSegments + 1) * i + j;
            indices[k + 1] = indices[k + 3] = (radialSegments + 1) * (i + 1) + j;
            indices[k + 2] = indices[k + 5] = (radialSegments + 1) * i + j + 1;
            indices[k + 4] = (radialSegments + 1) * (i + 1) + j + 1;
            id++;
        }
    }
    id *= 2;
    var last;
    if (topCap) {
        last = (lowCap ? vertices.length - 6 : vertices.length - 3) / 3;
        vertices[last * 3 + 2] = heightHalf;
        for (j = 0; j < radialSegments; j++) {
            k = id * 3;
            indices[k] = j;
            indices[k + 1] = j + 1;
            indices[k + 2] = last;
            id++;
        }
    }

    if (lowCap) {
        last = (vertices.length - 3) / 3;
        vertices[last * 3 + 2] = -heightHalf;
        var end = (radialSegments + 1) * i;
        for (j = 0; j < radialSegments; j++) {
            k = id * 3;
            indices[k] = end + j + 1;
            indices[k + 1] = end + j;
            indices[k + 2] = last;
            id++;
        }
    }

    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShader());
    g
        .getPrimitives()
        .push(
            new __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__["a" /* default */](
                __WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__["a" /* default */].TRIANGLES,
                new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER, indices, 1)
            )
        );
    return g;
};

var createCircleGeometry = function(nbVertices, radius, argArc) {
    var g = new __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]();
    var vertices = new Float32Array(nbVertices * 3);
    var arc = argArc || Math.PI * 2;
    for (var i = 0; i < nbVertices; ++i) {
        var j = i * 3;
        var segment = arc * i / nbVertices;
        vertices[j] = Math.cos(segment) * radius;
        vertices[j + 1] = Math.sin(segment) * radius;
    }
    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);
    var primitive = new __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__["a" /* default */].LINE_STRIP, 0, nbVertices);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShader());
    g.getPrimitives().push(primitive);
    return g;
};

var createPlaneGeometry = function(width, height) {
    var offx = width ? width * 0.5 : 0.5;
    var offy = height ? height * 0.5 : 0.5;

    var g = new __WEBPACK_IMPORTED_MODULE_1_osg_Geometry__["a" /* default */]();
    var vertices = new Float32Array(12);
    vertices[0] = -offx;
    vertices[1] = -offy;

    vertices[3] = offx;
    vertices[4] = -offy;

    vertices[6] = -offx;
    vertices[7] = offy;

    vertices[9] = offx;
    vertices[10] = offy;

    g.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_0_osg_BufferArray__["a" /* default */].ARRAY_BUFFER, vertices, 3);
    var primitive = new __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP, 0, 4);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShader());
    g.getPrimitives().push(primitive);
    return g;
};

var createQuadCircleGeometry = function(width, height) {
    var g = createPlaneGeometry(width, height);
    g.getOrCreateStateSet().setAttributeAndModes(getOrCreateShaderQuadCircle());
    if (width === undefined)
        g.getOrCreateStateSet().addUniform(__WEBPACK_IMPORTED_MODULE_7_osg_Uniform__["a" /* default */].createFloat(1.0, 'uSize'));

    return g;
};

var GizmoGeometry = {};
GizmoGeometry.createCircleGeometry = createCircleGeometry;
GizmoGeometry.createCylinderGeometry = createCylinderGeometry;
GizmoGeometry.createTorusGeometry = createTorusGeometry;
GizmoGeometry.createDebugLineGeometry = createDebugLineGeometry;
GizmoGeometry.createPlaneGeometry = createPlaneGeometry;
GizmoGeometry.createQuadCircleGeometry = createQuadCircleGeometry;
GizmoGeometry.resetPrograms = resetPrograms;

/* harmony default export */ __webpack_exports__["a"] = (GizmoGeometry);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgViewer_eventProxy_GamePad__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgViewer_eventProxy_Hammer__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgViewer_eventProxy_StandardMouseKeyboard__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgViewer_eventProxy_WebVR__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgViewer_eventProxy_DeviceOrientation__ = __webpack_require__(248);






/* harmony default export */ __webpack_exports__["a"] = ({
    GamePad: __WEBPACK_IMPORTED_MODULE_0_osgViewer_eventProxy_GamePad__["a" /* default */],
    Hammer: __WEBPACK_IMPORTED_MODULE_1_osgViewer_eventProxy_Hammer__["a" /* default */],
    StandardMouseKeyboard: __WEBPACK_IMPORTED_MODULE_2_osgViewer_eventProxy_StandardMouseKeyboard__["a" /* default */],
    WebVR: __WEBPACK_IMPORTED_MODULE_3_osgViewer_eventProxy_WebVR__["a" /* default */],
    DeviceOrientation: __WEBPACK_IMPORTED_MODULE_4_osgViewer_eventProxy_DeviceOrientation__["a" /* default */]
});


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_CullFace__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgStats_Counter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgStats_Graph__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgStats_TextGenerator__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgUtil_IntersectionVisitor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgUtil_LineSegmentIntersector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_BoundingBox__ = __webpack_require__(26);




















// Stats usages:
// url usable in Options
//
// to active the stats: ?stats=1
//
// to filter content in the stats: statsFilter=cull;myGroup;webgl
//
// to change the fontSize: statsFontSize=40
//
// You can also change the configuration before running the viewer to adds counters
// var config = {
//     values: {
//         myCounter: {
//             caption: 'my uber counter',
//             average: true,
//             graph: true,
//             over: 16
//         },
//         myCounter2: {
//             caption: 'a second counter',
//             graph: true,
//             below: 16
//         }
//         groups: [
//             {
//                 name: myGroup,
//                 caption: 'blah my group',
//                 values: [ 'myCounter', 'myCounter2' ]
//             }
//         ]
//     };
//     getViewerStats().addConfig(config)
//     getViewerStats().setShowFilter(['cull', 'myGroup']) // will display only cull
//     and myGroup groups
//     getViewerStats().setFontSize(50)

var getCanvasCoord = function(vec, e) {
    if (e.touches && e.touches.length) {
        var touch = e.touches[0];
        vec[0] = touch.pageX;
        vec[1] = touch.pageY;
    } else {
        vec[0] = e.offsetX === undefined ? e.layerX : e.offsetX;
        vec[1] = e.offsetY === undefined ? e.layerY : e.offsetY;
    }
};

var PICKING_NODEMASK = 0x8000;

var createShader = function() {
    var vertexshader = [
        'attribute vec4 Vertex;',
        'uniform mat4 uModelViewMatrix;',
        'uniform mat4 uProjectionMatrix;',
        '',
        'varying vec2 vTexCoord0;',
        '',
        'void main(void) {',
        '  vTexCoord0 = Vertex.zw;',
        '  gl_Position = uProjectionMatrix * (uModelViewMatrix * vec4(Vertex.xy,0.0, 1.0));',
        '}'
    ].join('\n');

    var fragmentshader = [
        '#define SHADER_NAME STATS',
        'varying vec2 vTexCoord0;',
        'uniform sampler2D Texture0;',

        'void main(void) {',
        '  vec4 color = vec4(1.0);',
        '  vec2 uv =  vTexCoord0;',
        '  int isText = 0;',
        '  if ( uv.y < 0.0 ) {',
        '     isText = 1;',
        '     uv.y = -uv.y;',
        '  }',
        '  if ( uv.y >= ' + (__WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].backgroundColor - 1).toFixed(1) + ' ) {', // background
        '     color = vec4(0.0,0.0,0.0,0.5);',
        '     uv.y -= ' + __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].backgroundColor.toFixed(1) + ';',
        '  } else if ( uv.y >= ' + (__WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].redColor - 1).toFixed(1) + ' ) {',
        '     color = vec4(1.0,0.0,0.0,1.0);',
        '     uv.y -= ' + __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].redColor.toFixed(1) + ';',
        '  } else if ( uv.y == ' + (__WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].greyColor - 1).toFixed(1) + ' ) {',
        '     color = vec4(0.5,0.5,0.5,1.0);',
        '     uv.y -= ' + __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].greyColor.toFixed(1) + ';',
        '  } else {',
        '     uv.y -= ' + __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].whiteColor.toFixed(1) + ';',
        '  }',
        '  if ( isText == 1 ) {',
        '     color *= texture2D( Texture0, uv.xy);',
        '  }',
        '  gl_FragColor = color;',
        '}'
    ].join('\n');

    return new __WEBPACK_IMPORTED_MODULE_6_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_7_osg_Shader__["a" /* default */]('VERTEX_SHADER', vertexshader),
        new __WEBPACK_IMPORTED_MODULE_7_osg_Shader__["a" /* default */]('FRAGMENT_SHADER', fragmentshader)
    );
};

var Stats = function(viewer, options) {
    this._captionsBuffer = undefined;
    this._valuesBuffer = undefined;

    this._dirtyCaptions = true;
    this._dirtyValues = true;

    this._viewer = viewer;
    this._labelMaxWidth = 0;
    this._viewport = viewer.getCamera().getViewport();

    this._node = undefined;
    this._text = undefined;
    this._offsetGroup = undefined;

    this._counters = {};
    this._groups = {};
    this._updates = [];
    this._displayableCounters = {};
    this._x = 0;
    this._y = 0;
    this._width = 0;
    this._height = 0;

    this._maxCaptionTextLength = 32;

    this._lineFactor = 1.1;
    this._displayFilter = [];

    this._backgroundWidth = 0;
    this._backgroundHeight = 0;

    this._bufferStats = new __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */]();
    this._historyGraph = {};

    this._graphToDisplay = [];

    this._valuesMaxWidth = 6 * 12;

    this._showGraph = false;

    // inputs data
    this._backgroundPicking = __WEBPACK_IMPORTED_MODULE_17_osg_shape__["a" /* default */].createTexturedQuadGeometry(0, 0, 0, 10, 0, 0, 0, 10, 0);
    this._dragStop = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["e" /* vec2 */].create();
    this._dragStart = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["e" /* vec2 */].create();
    this._startTransformation = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["c" /* mat4 */].create();

    this._init(options);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(Stats, {
    getCounter: function(name) {
        if (!this._counters[name]) {
            this._counters[name] = new __WEBPACK_IMPORTED_MODULE_12_osgStats_Counter__["a" /* default */]({
                caption: name,
                average: true
            });
        }

        return this._counters[name];
    },
    getBufferStats: function() {
        return this._bufferStats;
    },
    addConfig: function(config) {
        if (config.init && !config.init()) return;

        for (var valueName in config.values) {
            var valueConfig = config.values[valueName];
            var counter = new __WEBPACK_IMPORTED_MODULE_12_osgStats_Counter__["a" /* default */](valueConfig);
            this._counters[valueName] = counter;
        }

        if (config.groups) {
            for (var i = 0; i < config.groups.length; i++) {
                var groupConfig = config.groups[i];
                var group = {
                    caption: groupConfig.caption,
                    values: groupConfig.values,
                    textCursorY: new Float32Array(groupConfig.values.length)
                };

                var name = groupConfig.name ? groupConfig.name : groupConfig.caption;
                this._groups[name] = group;
            }
        }

        if (config.update) {
            this._updates.push(config.update);
        }
    },
    reset: function() {
        this._bufferStats.resetCaptions();
        this._bufferStats.resetValues();

        this._dirtyCaptions = true;
        this._dirtyValue = true;

        this._bufferStats.resize(this._bufferStats._maxNbVertexes);
    },
    update: function() {
        for (var i = 0; i < this._updates.length; i++) {
            this._updates[i](this);
        }
        this._dirtyValues = true;

        if (this._checkViewportChanged() || this._checkCounterDisplayableChanged())
            this._dirtyCaptions = true;

        if (this._dirtyCaptions) {
            this._bufferStats.resetCaptions();
            this._generateCaptions();
            this._dirtyCaptions = false;
        }

        if (this._dirtyValues) {
            this._bufferStats.resetValues();
            this._generateValues();
            this._dirtyValues = false;
        }
    },
    getNode: function() {
        return this._node;
    },
    setShowFilter: function(groupNamesArray) {
        this._dirtyCaptions = true;
        if (!groupNamesArray) {
            this._displayFilter.length = 0;
            return;
        }
        this._displayFilter = groupNamesArray.slice();
    },
    _init: function(options) {
        // 3D init
        var camera = new __WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */]();

        camera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */].POST_RENDER, 0);
        camera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */].ABSOLUTE_RF);
        camera.setClearMask(0x0); // dont clear anything
        var node = new __WEBPACK_IMPORTED_MODULE_5_osg_MatrixTransform__["a" /* default */]();
        node.setName('StatsNode');
        node.addChild(this._backgroundPicking);
        this._nodeTransform = node;
        this._backgroundPicking.setNodeMask(0);

        camera.addChild(node);
        camera.setName('osgStats');
        camera.setViewport(this._viewport);
        this._node = camera;
        this._text = new __WEBPACK_IMPORTED_MODULE_14_osgStats_TextGenerator__["a" /* default */]();

        var fontSize = 12;
        if (options) {
            var statsGroupList = options.getString('statsFilter');
            if (statsGroupList) {
                var filterList = statsGroupList.split(';');
                this.setShowFilter(filterList);
            }
            var statsFontSize = options.getNumber('statsFontSize');
            if (statsFontSize !== undefined) fontSize = statsFontSize;

            this._showGraph = options.getBoolean('statsShowGraph');
        }

        var texture = new __WEBPACK_IMPORTED_MODULE_9_osg_Texture__["default"]();
        texture.setMinFilter(__WEBPACK_IMPORTED_MODULE_9_osg_Texture__["default"].NEAREST);
        texture.setMagFilter(__WEBPACK_IMPORTED_MODULE_9_osg_Texture__["default"].NEAREST);
        this._text.setFontSize(fontSize * this._viewer.getCanvasPixelRatio());
        this._text.getCanvas().then(
            function(canvas) {
                this._dirtyCaptions = true;
                var geometry = this._bufferStats.getGeometry();
                geometry.setName('StatsGeometry');
                geometry.setNodeMask(~PICKING_NODEMASK);
                node.addChild(geometry);
                texture.setImage(canvas);
                // invalidate the bounding box, we dont want it
                // to be used
                geometry.setBound(new __WEBPACK_IMPORTED_MODULE_18_osg_BoundingBox__["a" /* default */]());
            }.bind(this)
        );

        node.getOrCreateStateSet().setAttributeAndModes(createShader());
        node.getOrCreateStateSet().setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_3_osg_CullFace__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_CullFace__["a" /* default */].DISABLE));
        var blendFunc = new __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */]('SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA');
        node.getOrCreateStateSet().setAttributeAndModes(blendFunc);
        node.getOrCreateStateSet().setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_4_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4_osg_Depth__["a" /* default */].DISABLE));
        node.getOrCreateStateSet().setTextureAttributeAndModes(0, texture);

        var canvas = this._viewer.getGraphicContext().canvas;

        this._canvas = canvas;

        canvas.addEventListener('mousemove', this.onMouseMove.bind(this));
        canvas.addEventListener('mousedown', this.onMouseDown.bind(this));
        canvas.addEventListener('mouseup', this.onMouseUp.bind(this));
        canvas.addEventListener('mouseout', this.onMouseUp.bind(this));

        canvas.addEventListener('touchmove', this.onMouseMove.bind(this));
        canvas.addEventListener('touchstart', this.onMouseDown.bind(this));
        canvas.addEventListener('touchend', this.onMouseUp.bind(this));
        canvas.addEventListener('touchcancel', this.onMouseUp.bind(this));
    },
    onMouseDown: function(e) {
        var hits = this.computeNearestIntersection(e);
        this._onStats = !!hits.length;
        if (!this._onStats) return;

        this._viewer.setEnableManipulator(false);

        e.preventDefault();
        __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["c" /* mat4 */].copy(this._startTransformation, this._nodeTransform.getMatrix());
        getCanvasCoord(this._dragStart, e);
        this._dragStop[1] = this._dragStart[1];
    },
    onMouseMove: (function() {
        return function(e) {
            if (!this._onStats) return;

            getCanvasCoord(this._dragStop, e);
            var dy = this._dragStop[1] - this._dragStart[1];
            __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["c" /* mat4 */].translate(
                this._nodeTransform.getMatrix(),
                this._startTransformation,
                __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["f" /* vec3 */].fromValues(0, -dy, 0)
            );
        };
    })(),
    onMouseUp: function() {
        this._viewer.setEnableManipulator(true);
        this._onStats = false;
    },
    computeNearestIntersection: (function() {
        var coord = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["e" /* vec2 */].create();
        var lsi = new __WEBPACK_IMPORTED_MODULE_16_osgUtil_LineSegmentIntersector__["a" /* default */]();
        var origIntersect = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["f" /* vec3 */].create();
        var dstIntersect = __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["f" /* vec3 */].create();
        var iv = new __WEBPACK_IMPORTED_MODULE_15_osgUtil_IntersectionVisitor__["a" /* default */]();
        iv.setIntersector(lsi);
        return function(e) {
            getCanvasCoord(coord, e);

            // canvas to webgl coord
            var viewer = this._viewer;
            var canvas = this._canvas;
            var x = coord[0] * (viewer._canvasWidth / canvas.clientWidth);
            var y = (canvas.clientHeight - coord[1]) * (viewer._canvasHeight / canvas.clientHeight);

            lsi.reset();
            lsi.set(__WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["f" /* vec3 */].set(origIntersect, x, y, 0.0), __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["f" /* vec3 */].set(dstIntersect, x, y, 1.0));
            iv.reset();

            this._backgroundPicking.setNodeMask(PICKING_NODEMASK);
            iv.setTraversalMask(PICKING_NODEMASK);
            this._node.accept(iv);
            var hits = lsi.getIntersections();
            this._backgroundPicking.setNodeMask(0x0);

            return hits;
        };
    })(),
    _updateBackgroundPicking: function(x, y, w, h) {
        var vertexes = this._backgroundPicking.getVertexAttributeList().Vertex.getElements();
        vertexes[0] = x;
        vertexes[1] = y + h;

        vertexes[3] = x;
        vertexes[4] = y;

        vertexes[6] = x + w;
        vertexes[7] = y;

        vertexes[9] = x + w;
        vertexes[10] = y + h;
        this._backgroundPicking.dirtyBound();
    },

    _generateCaptions: function() {
        var initialX = 0;
        var characterHeight = this._text.getCharacterHeight();
        var textCursorX = initialX;
        var textCursorY = this._viewport.height() - characterHeight;

        this._labelMaxWidth = 0;

        // generate background
        this._bufferStats.generateBackground(
            0,
            this._viewport.height() - this._backgroundHeight,
            this._backgroundWidth,
            this._backgroundHeight
        );

        this._updateBackgroundPicking(
            0,
            this._viewport.height() - this._backgroundHeight,
            this._backgroundWidth,
            this._backgroundHeight
        );

        var filters = this._displayFilter;
        for (var groupName in this._groups) {
            if (groupName && filters.length && filters.indexOf(groupName) === -1) continue;

            var group = this._groups[groupName];
            var groupText = '--- ' + group.caption + ' ---';
            var textWidth = this._bufferStats.generateText(
                textCursorX,
                textCursorY,
                groupText,
                this._text,
                __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].whiteColor
            );
            this._labelMaxWidth = Math.max(textWidth, this._labelMaxWidth);
            textCursorX = initialX;
            textCursorY -= this._lineFactor * characterHeight;

            for (var j = 0; j < group.values.length; j++) {
                var counterName = group.values[j];
                var counter = this._counters[counterName];
                if (!counter || !counter.isDisplayable()) continue;

                group.textCursorY[j] = textCursorY;

                var text = counter._caption;
                // could need to split the label on multi line
                var nbSplits = text.length / this._maxCaptionTextLength;
                for (var c = 0; c < nbSplits; c++) {
                    var start = c * this._maxCaptionTextLength;
                    var splitText = text.substr(start, this._maxCaptionTextLength);
                    textWidth = this._bufferStats.generateText(
                        textCursorX,
                        textCursorY,
                        splitText,
                        this._text,
                        __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].whiteColor
                    );
                    this._labelMaxWidth = Math.max(textWidth, this._labelMaxWidth);
                    textCursorY -= characterHeight;
                    textCursorX = initialX;
                }
            }
            textCursorY -= characterHeight;
        }
        this._bufferStats.captionsEnd();
    },
    _generateValues: function() {
        var characterWidth = this._text.getCharacterWidth();
        var valuesOffsetX = this._labelMaxWidth + 2 * characterWidth;
        var graphOffsetX = this._valuesMaxWidth + 2 * characterWidth;
        var characterHeight = this._text.getCharacterHeight();
        var textCursorX = valuesOffsetX;
        var textCursorY;

        var filters = this._displayFilter;
        var valuesMaxWidth = 0;
        for (var groupName in this._groups) {
            if (groupName && filters.length && filters.indexOf(groupName) === -1) continue;

            var group = this._groups[groupName];
            textCursorX = valuesOffsetX;

            for (var j = 0; j < group.values.length; j++) {
                var counterName = group.values[j];
                var counter = this._counters[counterName];
                if (!counter || !counter.isDisplayable()) continue;

                var value = counter.getAverageMs() ? counter.getAverageValue() : counter.getValue();
                var text;
                if (!Number.isInteger(value)) {
                    text = value.toFixed(2);
                } else {
                    text = value.toString();
                }

                textCursorY = group.textCursorY[j];
                var color = __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].whiteColor;
                var over = counter.getOver();
                var below = counter.getBelow();
                if (over !== 0) color = value > over ? __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].redColor : color;
                else if (below !== 0) color = value < below ? __WEBPACK_IMPORTED_MODULE_11_osgStats_BufferStats__["a" /* default */].redColor : color;

                var valueWidth = this._bufferStats.generateText(
                    textCursorX,
                    textCursorY,
                    text,
                    this._text,
                    color
                );
                valuesMaxWidth = Math.max(valueWidth, valuesMaxWidth);

                if (this._showGraph && counter._graph) {
                    if (!this._historyGraph[counterName]) {
                        this._historyGraph[counterName] = new __WEBPACK_IMPORTED_MODULE_13_osgStats_Graph__["a" /* default */]();
                    }
                    this._graphToDisplay.push(this._historyGraph[counterName]);
                    this._historyGraph[counterName].setDisplayPosition(
                        valuesOffsetX + graphOffsetX,
                        textCursorY
                    );
                    this._historyGraph[counterName].addValue(value, color);
                }

                textCursorX = valuesOffsetX;
            }
        }
        this._bufferStats.valuesEnd();

        this._valuesMaxWidth = valuesMaxWidth;

        for (var g = 0; g < this._graphToDisplay.length; g++) {
            var graph = this._graphToDisplay[g];
            this._bufferStats.generateGraph(graph, characterHeight - 2.0);
        }

        var totalWidth = valuesOffsetX + graphOffsetX;

        if (this._graphToDisplay.length) totalWidth += __WEBPACK_IMPORTED_MODULE_13_osgStats_Graph__["a" /* default */].maxGraphValue * 2 + 1;
        var totalHeight = this._viewport.height() - textCursorY;

        if (this._backgroundWidth !== totalWidth || this._backgroundHeight !== totalHeight) {
            this._backgroundWidth = totalWidth;
            this._backgroundHeight = totalHeight;
            this._dirtyCaptions = true;
        }
        this._graphToDisplay.length = 0;

        this._bufferStats.graphsEnd();
        this._bufferStats.update();
    },
    _checkCounterDisplayableChanged: function() {
        var changed = false;
        for (var key in this._counters) {
            var counter = this._counters[key];
            if (this._displayableCounters[key] !== counter.isDisplayable()) {
                this._displayableCounters[key] = counter.isDisplayable();
                changed = true;
            }
        }
        return changed;
    },
    _checkViewportChanged: function() {
        var x = this._viewport.x();
        var y = this._viewport.y();
        var w = this._viewport.width();
        var h = this._viewport.height();
        if (x !== this._x || y !== this._y || w !== this._width || h !== this._height) {
            this._x = x;
            this._y = y;
            this._width = w;
            this._height = h;

            var camera = this._node;
            __WEBPACK_IMPORTED_MODULE_10_osg_glMatrix__["c" /* mat4 */].ortho(
                camera.getProjectionMatrix(),
                this._x,
                this._width,
                this._y,
                this._height,
                -5,
                5
            );
            return true;
        }
        return false;
    }
});

/* harmony default export */ __webpack_exports__["a"] = (Stats);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_DrawArrays__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgStats_Graph__ = __webpack_require__(99);









// captions data (4 vertexes, indexes)
// values data   (4 vertexes, indexes)
// graph data    (2 vertexes, drawArrays)

var BufferStats = function() {
    this._usageHint = __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].DYNAMIC_DRAW;
    // equivalent of 512 characters for caption, 128 of values characters
    // and 6 graph of 120 lines
    var nbVertexes = (1024 + 256) * 4 + 6 * 2 * 120;
    this._nbVertexes = 0;
    this._maxNbVertexes = 0;

    this._captionNbVertexes = 0;
    this._valuesNbVertexes = 0;
    this._graphsNbVertexes = 0;

    this.resize(nbVertexes);
};

BufferStats.backgroundColor = 10.0;
BufferStats.redColor = 7.0;
BufferStats.greyColor = 4.0;
BufferStats.whiteColor = 1.0;

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(BufferStats, {
    getGeometry: function() {
        return this._geometry;
    },
    generateBackground: function(x, y, w, h) {
        var vertexes = this._vertexes;
        this._nbVertexes += 4;

        vertexes[0] = x;
        vertexes[1] = y;
        vertexes[2] = 0.0;
        vertexes[3] = BufferStats.backgroundColor;

        var x1 = x + w;
        var y1 = y + h;

        vertexes[4] = x;
        vertexes[5] = y1;
        vertexes[6] = 0.0;
        vertexes[7] = BufferStats.backgroundColor;

        vertexes[8] = x1;
        vertexes[9] = y1;
        vertexes[10] = 0.0;
        vertexes[11] = BufferStats.backgroundColor;

        vertexes[12] = x1;
        vertexes[13] = y;
        vertexes[14] = 0.0;
        vertexes[15] = BufferStats.backgroundColor;
    },
    generateCharacter: function(x, y, w, h, ux, ux1, color) {
        var vertexes = this._vertexes;
        var nbVertexes = this._nbVertexes;

        this._nbVertexes += 4;
        var i = nbVertexes * 4;

        vertexes[i++] = x;
        vertexes[i++] = y;
        vertexes[i++] = ux;
        vertexes[i++] = -(0.0 + color);

        var x1 = x + w;
        var y1 = y + h;

        vertexes[i++] = x;
        vertexes[i++] = y1;
        vertexes[i++] = ux;
        vertexes[i++] = -(1.0 + color);

        vertexes[i++] = x1;
        vertexes[i++] = y1;
        vertexes[i++] = ux1;
        vertexes[i++] = -(1.0 + color);

        vertexes[i++] = x1;
        vertexes[i++] = y;
        vertexes[i++] = ux1;
        vertexes[i++] = -(0.0 + color);
    },
    generateText: function(x, y, text, textGenerator, zColor) {
        var size = text.length;
        if (this._nbVertexes + size * 4 >= this._maxNbVertexes) {
            this.resize(this._maxNbVertexes * 2);
        }
        var characterSizeUV = textGenerator._characterSizeUV;
        var characterWidth = textGenerator._characterWidth;
        var characterHeight = textGenerator._characterHeight;
        for (var i = 0; i < size; i++) {
            var characterCode = text.charCodeAt(i);
            var uvx = textGenerator.getCharacterUV(characterCode);
            this.generateCharacter(
                x,
                y,
                characterWidth,
                characterHeight,
                uvx,
                uvx + characterSizeUV,
                zColor
            );

            x += characterWidth;
        }
        return size * characterWidth;
    },
    generateGraph: function(graph, height) {
        if (this._nbVertexes + __WEBPACK_IMPORTED_MODULE_7_osgStats_Graph__["a" /* default */].maxGraphValue * 2 >= this._maxNbVertexes) {
            this.resize(this._maxNbVertexes * 2);
        }
        var vertexes = this._vertexes;
        var nbVertexes = this._nbVertexes;

        var graphValues = graph.getValues();
        var nbGraphValues = graphValues.length;
        var graphStartIndex = graph.getIndex();

        var x = graph.getX();
        var y = graph.getY();
        this._nbVertexes += nbGraphValues * 2;

        for (var i = 0; i < nbGraphValues; i++) {
            var graphIndex = (graphStartIndex + i) % nbGraphValues;
            var graphValue = graphValues[graphIndex];

            var bufferIndex = nbVertexes + i * 2;
            var vertexIndex = bufferIndex * 4;

            var value = graphValue;
            var color = BufferStats.greyColor;
            // check if the value is a warning or not
            if (value >= BufferStats.redColor) {
                color = BufferStats.redColor;
                value -= BufferStats.redColor;
            }

            if (value > 1.0) value = 1.0;
            value *= height;
            if (value < 1.0) value = 1.0;

            vertexes[vertexIndex] = x + i * 2;
            vertexes[vertexIndex + 1] = y;
            vertexes[vertexIndex + 2] = 0.0;
            vertexes[vertexIndex + 3] = color;

            vertexes[vertexIndex + 4] = x + i * 2;
            vertexes[vertexIndex + 5] = y + value;
            vertexes[vertexIndex + 6] = 0.0;
            vertexes[vertexIndex + 7] = color;
        }
    },
    resize: function(nbVertexes) {
        __WEBPACK_IMPORTED_MODULE_6_osg_notify__["a" /* default */].log('resize buffer to ' + nbVertexes);
        this._maxNbVertexes = nbVertexes;
        var vertexes = new Float32Array(nbVertexes * 4);
        if (this._vertexes) vertexes.set(this._vertexes);
        this._vertexes = vertexes;

        // it's the max number of characters displayable
        var nbCharacters = Math.ceil(nbVertexes / 4);
        this._indexes = new Uint16Array(nbCharacters * 6);
        for (var i = 0, j = 0; i < nbCharacters; i++) {
            this._indexes[j++] = i * 4 + 0;
            this._indexes[j++] = i * 4 + 1;
            this._indexes[j++] = i * 4 + 3;
            this._indexes[j++] = i * 4 + 3;
            this._indexes[j++] = i * 4 + 1;
            this._indexes[j++] = i * 4 + 2;
        }

        if (this._geometry) {
            this._geometry.getAttributes().Vertex.setElements(this._vertexes);
            this._characterPrimitive.getIndices().setElements(this._indexes);
            return;
        }

        this._geometry = new __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */]();

        this._geometry.getAttributes().Vertex = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](
            __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ARRAY_BUFFER,
            this._vertexes,
            4,
            true
        );
        var indexArray = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */](__WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER, this._indexes, 1);

        // for labels and values
        this._geometry.getAttributes().Vertex.setUsage(this._usageHint);

        var drawElement = new __WEBPACK_IMPORTED_MODULE_4_osg_DrawElements__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].TRIANGLES, indexArray);
        this._characterPrimitive = drawElement;
        this._geometry.getPrimitives().push(this._characterPrimitive);

        var drawArrays = new __WEBPACK_IMPORTED_MODULE_5_osg_DrawArrays__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_primitiveSet__["a" /* default */].LINES, 0, 0);
        this._graphPrimitive = drawArrays;
        this._geometry.getPrimitives().push(this._graphPrimitive);
    },
    update: function() {
        var nbTotalCharacters = this._captionNbVertexes + this._valuesNbVertexes;
        this._characterPrimitive.setCount(nbTotalCharacters / 4 * 6);
        this._graphPrimitive.setCount(this._graphsNbVertexes);
        this._graphPrimitive.setFirst(nbTotalCharacters);

        this._geometry.getAttributes().Vertex.dirty();
    },
    resetCaptions: function() {
        this._nbVertexes = 0;
        this._captionNbVertexes = 0;
    },
    resetValues: function() {
        this._nbVertexes = this._captionNbVertexes;
        this._valuesNbVertexes = 0;
        this._graphsNbVertexes = 0;
    },
    captionsEnd: function() {
        this._captionNbVertexes = this._nbVertexes;
    },
    valuesEnd: function() {
        this._valuesNbVertexes = this._nbVertexes - this._captionNbVertexes;
    },
    graphsEnd: function() {
        this._graphsNbVertexes =
            this._nbVertexes - (this._valuesNbVertexes + this._captionNbVertexes);
    },
    getCharacterPrimitive: function() {
        return this._characterPrimitive;
    },
    getGraphPrimitive: function() {
        return this._graphPrimitive;
    },
    getNbVertexes: function() {
        return this._nbVertexes;
    }
});

/* harmony default export */ __webpack_exports__["a"] = (BufferStats);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);

var performance = window.performance;

var Counter = function(config) {
    this._caption = config.caption;
    this._accumValue = 0;
    this._accumSamples = 0;
    this._accumStart = 0;
    this._value = 0;
    this._averageValue = 0;
    this._time = 0;
    this._avgMs = 0;
    this._over = config.over > 0.0 ? config.over : 0;
    this._below = config.below > 0.0 ? config.below : 0;
    this._graph = !!config.graph;
    if (config.average) {
        this._avgMs = config.avgMs ? config.avgMs : 1000;
    }
    this._display = false;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(Counter, {
    isDisplayable: function() {
        return this._display;
    },
    setDisplayable: function(boolean) {
        this._display = boolean;
    },
    getOver: function() {
        return this._over;
    },
    getBelow: function() {
        return this._below;
    },
    getGraph: function() {
        return this._graph;
    },
    getAverageMs: function() {
        return this._avgMs;
    },
    getAverageValue: function() {
        return this._averageValue;
    },
    getValue: function() {
        return this._value;
    },
    average: function(value) {
        if (!this._avgMs) return;

        this._accumValue += value;
        this._accumSamples++;
        var t = performance.now();
        if (t - this._accumStart > this._avgMs) {
            this._averageValue = this._accumValue / this._accumSamples;
            this._accumValue = 0;
            this._accumStart = t;
            this._accumSamples = 0;
        }
    },
    start: function() {
        this._display = true;
        this._time = performance.now();
    },
    end: function() {
        this._value = performance.now() - this._time;
        this.average(this._value);
    },
    set: function(value) {
        this._display = true;
        this._value = value;
        this.average(value);
    },
    tick: function() {
        this.end();
        this.start();
    },
    frame: function() {
        var delta = performance.now() - this._time;
        this.set(1000.0 / delta);
        this.start();
    }
});

/* harmony default export */ __webpack_exports__["a"] = (Counter);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);




var DefaultFont = 'Courier New';

var determineFontHeight = function(fontStyle) {
    var body = document.getElementsByTagName('body')[0];
    var dummy = document.createElement('div');
    var dummyText = document.createTextNode('M');
    dummy.appendChild(dummyText);
    dummy.setAttribute('style', fontStyle);
    body.appendChild(dummy);
    var result = dummy.offsetHeight;
    body.removeChild(dummy);
    return result;
};

var loadFont = function(fontFamily) {
    return new __WEBPACK_IMPORTED_MODULE_1_bluebird___default.a(function(resolve, reject) {
        window.WebFontConfig = {
            google: {
                families: [fontFamily + ':200']
            },
            active: function() {
                resolve(fontFamily);
            },
            inactive: function(error) {
                reject('loadFont error:' + error);
            }
        };
        var wf = document.createElement('script'),
            s = document.scripts[0];
        wf.src = 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js';
        wf.async = true;
        wf.onerror = function() {
            reject();
        };
        s.parentNode.insertBefore(wf, s);
    });
};

var TextGenerator = function() {
    this._canvas = undefined;
    this._characterHeight = 0;
    this._characterWidth = 0;
    this._fontSize = 16;
    this._fontFamily = 'Source Code Pro';
    this._characterFirstCode = ' '.charCodeAt();
    this._characterLastCode = 'z'.charCodeAt();
    this._characterSizeUV = 0;
    this._backgroundColor = 'rgba(0,0,0,0.0)';
    this._createCanvas();
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(TextGenerator, {
    setFontSize: function(size) {
        this._fontSize = size;
    },
    getCharacterWidth: function() {
        return this._characterWidth;
    },
    getCharacterHeight: function() {
        return this._characterHeight;
    },
    getCanvas: function() {
        return this._promise;
    },
    getCharacterUV: function(characterCode) {
        var index = characterCode - this._characterFirstCode;
        return index * this._characterSizeUV;
    },
    _fillCanvas: function(fontFamily, fontSize) {
        // get font height
        var size = fontSize + 'px';
        var style = 'font-family: ' + fontFamily + '; font-size: ' + size + ';';
        var pixelHeight = determineFontHeight(style);
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].debug(fontFamily + ' ' + size + ' ==> ' + pixelHeight + ' pixels high.');

        this._characterHeight = Math.ceil(pixelHeight);
        var font = fontSize + "px '" + fontFamily + "'";
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        this._canvas = canvas;
        ctx.font = font;
        ctx.textBaseline = 'middle';

        this._characterWidth = ctx.measureText(' ').width;
        this._characterWidth = Math.ceil(this._characterWidth);

        var nbCharacters = this._characterLastCode - this._characterFirstCode + 1;
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].info(
            'Stats character size ' +
                this._characterWidth +
                ' x ' +
                this._characterHeight +
                ' texture width ' +
                this._characterWidth * nbCharacters
        );

        canvas.width = Math.ceil(this._characterWidth * nbCharacters);
        canvas.height = this._characterHeight;

        this._characterSizeUV = this._characterWidth / canvas.width;

        ctx.font = font;
        ctx.textBaseline = 'middle';
        ctx.fillStyle = 'rgb(255,255,255)';
        for (var i = this._characterFirstCode, j = 0; i <= this._characterLastCode; i++, j++) {
            var code = String.fromCharCode(i);
            var x = j * this._characterWidth;
            var y = this._characterHeight / 2;
            ctx.fillText(code, x, y);
        }
        return canvas;
    },
    _createCanvas: function() {
        this._promise = loadFont(this._fontFamily)
            .then(
                function(fontFamily) {
                    return this._fillCanvas(fontFamily, this._fontSize);
                }.bind(this)
            )
            .catch(
                function() {
                    return this._fillCanvas(DefaultFont, this._fontSize);
                }.bind(this)
            );
    }
});

/* harmony default export */ __webpack_exports__["a"] = (TextGenerator);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var values = {
    frame: {
        caption: 'Total frame time',
        over: 16,
        average: true,
        graph: true,
        max: 4
    },
    stats: {
        caption: 'stats',
        over: 1,
        graph: true
    },
    fps: {
        caption: 'Framerate (FPS)',
        below: 30,
        average: true
    },
    raf: {
        caption: 'Time since last rAF',
        average: true,
        avgMs: 500
    },
    update: {
        caption: 'update',
        average: true,
        graph: true
    },
    cull: {
        caption: 'cull',
        average: true,
        graph: true,
        max: 16
    },
    render: {
        caption: 'render',
        average: true,
        graph: true
    },
    glframe: {
        caption: 'glframe',
        average: true,
        graph: true
    },

    textureused: {
        caption: 'texture used'
    },
    texturereserved: {
        caption: 'texture reserved'
    },
    texturetotal: {
        caption: 'texture total'
    },

    pushstateset: {
        caption: 'num pushStateSet'
    },
    applyStateSet: {
        caption: 'num applyStateSet'
    },
    updatecallback: {
        caption: 'num updateCallback'
    },

    cullcamera: {
        caption: 'camera'
    },
    cullmatrixtransform: {
        caption: 'matrixTransform'
    },
    cullprojection: {
        caption: 'projection'
    },
    cullnode: {
        caption: 'node'
    },
    culllightsource: {
        caption: 'lightSource'
    },
    cullgeometry: {
        caption: 'geometry'
    }
};

var groups = [
    {
        name: 'framerate',
        caption: 'Framerate',
        values: ['fps', 'raf']
    },
    {
        name: 'frameBudget',
        caption: 'Frame Budget',
        base: 'frame',
        values: ['frame', 'update', 'cull', 'render', 'glframe', 'stats']
    },
    {
        name: 'sceneGraph',
        caption: 'Scene Graph ',
        values: ['pushstateset', 'updatecallback', 'applyStateSet']
    },
    {
        name: 'cullVisitor',
        caption: 'Cull',
        values: [
            'cullnode',
            'cullmatrixtransform',
            'cullcamera',
            'culllighsource',
            'cullprojection',
            'cullgeometry'
        ]
    },
    {
        name: 'texture',
        caption: 'Texture Memory',
        values: ['texturereserved', 'textureused', 'texturetotal']
    }
];

var config = {
    values: values,
    groups: groups
};

/* harmony default export */ __webpack_exports__["a"] = (config);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var WebGLRenderingContext = window.WebGLRenderingContext;
var WebGL2RenderingContext = window.WebGL2RenderingContext;

var contextList = [WebGLRenderingContext, WebGL2RenderingContext];

var glProxy = function(f, c) {
    return function() {
        c.apply(this, arguments);
        f.apply(this, arguments);
    };
};

var totalDrawArraysCalls = 0,
    totalDrawElementsCalls = 0,
    totalUseProgramCalls = 0,
    totalFaces = 0,
    totalVertices = 0,
    totalPoints = 0,
    totalBindTexures = 0;
var statsVertices = 0,
    statsFaces = 0,
    statsLines = 0;

var init = function() {
    var hasContext = false;
    for (var i = 0; i < contextList.length; i++) {
        var WebGLContext = contextList[i];
        if (!WebGLContext) continue;

        hasContext = true;
        WebGLContext.prototype.drawArrays = glProxy(WebGLContext.prototype.drawArrays, function() {
            totalDrawArraysCalls++;
            if (arguments[0] === this.POINTS) totalPoints += arguments[2];
            else totalVertices += arguments[2];
        });
        WebGLContext.prototype.drawElements = glProxy(
            WebGLContext.prototype.drawElements,
            function() {
                totalDrawElementsCalls++;
                totalFaces += arguments[1] / 3;
                totalVertices += arguments[1];
            }
        );

        WebGLContext.prototype.useProgram = glProxy(WebGLContext.prototype.useProgram, function() {
            totalUseProgramCalls++;
        });

        WebGLContext.prototype.bindTexture = glProxy(
            WebGLContext.prototype.bindTexture,
            function() {
                totalBindTexures++;
            }
        );
    }
    return hasContext;
};

var update = function(stats) {
    var bufferStats = stats.getBufferStats();
    var nbVertexes = bufferStats.getNbVertexes();
    var drawElements = bufferStats.getCharacterPrimitive();
    var drawArrays = bufferStats.getGraphPrimitive();

    // substracts stats from regular gl stats
    totalDrawElementsCalls -= 1; // one drawcall for characters
    if (drawArrays.getCount()) totalDrawArraysCalls -= 1; // one draw array for graph
    totalBindTexures -= 2;
    totalUseProgramCalls -= 1;
    totalVertices -= drawElements.getCount() + drawArrays.getCount();
    totalFaces -= drawElements.getCount() / 3;

    statsVertices = nbVertexes;
    statsFaces = drawElements.getCount() / 3;
    statsLines = drawArrays.getCount() / 2;

    stats.getCounter('glDrawCalls').set(totalDrawElementsCalls + totalDrawArraysCalls);
    stats.getCounter('glDrawElements').set(totalDrawElementsCalls);
    stats.getCounter('glDrawArrays').set(totalDrawArraysCalls);
    stats.getCounter('glBindTexture').set(totalBindTexures);
    stats.getCounter('glUseProgram').set(totalUseProgramCalls);
    stats.getCounter('glFaces').set(totalFaces);
    stats.getCounter('glVertices').set(totalVertices);
    stats.getCounter('glPoints').set(totalPoints);

    stats.getCounter('statsVertices').set(statsVertices);
    stats.getCounter('statsFaces').set(statsFaces);
    stats.getCounter('statsLines').set(statsLines);

    statsVertices = 0;
    statsFaces = 0;
    statsLines = 0;
    totalDrawArraysCalls = 0;
    totalDrawElementsCalls = 0;
    totalUseProgramCalls = 0;
    totalFaces = 0;
    totalVertices = 0;
    totalPoints = 0;
    totalBindTexures = 0;
}.bind(this);

var config = {
    values: {
        glDrawCalls: {
            caption: 'drawCalls'
        },
        glDrawElements: {
            caption: 'drawElements'
        },
        glDrawArrays: {
            caption: 'drawArrays'
        },
        glBindTexture: {
            caption: 'bindTexture'
        },
        glUseProgram: {
            caption: 'useProgram'
        },
        glFaces: {
            caption: 'totalFaces'
        },
        glVertices: {
            caption: 'totalVertices'
        },
        glPoints: {
            caption: 'totalPoints'
        },
        statsFaces: {
            caption: 'statsFaces'
        },
        statsVertices: {
            caption: 'statsVertices'
        },
        statsLines: {
            caption: 'statsLines'
        }
    },
    groups: [
        {
            name: 'webgl',
            caption: 'WebGL',
            values: [
                'glDrawCalls',
                'glDrawElements',
                'glDrawArrays',
                'glUseProgram',
                'glBindTexture',
                'glFaces',
                'glVertices',
                'glPoints',
                'statsVertices',
                'statsFaces',
                'statsLines'
            ]
        }
    ],
    update: update,
    init: init
};

/* harmony default export */ __webpack_exports__["a"] = (config);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


var memory = undefined;

var log1024 = Math.log(1024);
var size = function(v) {
    var precision = 100; //Math.pow(10, 2);
    var i = Math.floor(Math.log(v) / log1024);
    if (v === 0) i = 1;
    return Math.round(v * precision / Math.pow(1024, i)) / precision; // + ' ' + sizes[i];
};

var init = function() {
    if (window.performance && window.performance.memory) memory = window.performance.memory;
    if (!memory || memory.totalJSHeapSize === 0) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('Stats will not report memory, not supported by your browse');
    }
    return !!memory;
};

var update = function(stats) {
    var usedJSHeapSize = 0;
    var totalJSHeapSize = 0;
    if (memory) {
        usedJSHeapSize = size(memory.usedJSHeapSize);
        totalJSHeapSize = size(memory.totalJSHeapSize);
    }
    stats.getCounter('browserMemory').set(usedJSHeapSize);
    stats.getCounter('browserMemoryTotal').set(totalJSHeapSize);
};

var config = {
    values: {
        browserMemory: {
            caption: 'Used Memory',
            average: true,
            avgMs: 1000
        },
        browserMemoryTotal: {
            caption: 'Total Memory'
        }
    },
    groups: [
        {
            name: 'browser',
            caption: 'Browser',
            values: ['browserMemory', 'browserMemoryTotal']
        }
    ],
    update: update,
    init: init
};

/* harmony default export */ __webpack_exports__["a"] = (config);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



// Used to notify the Compiler to create a Depth Casting optimized shader
var ShadowCastAttribute = function(disable, shadowReceiveAttribute) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._enable = !disable;
    this._shadowReceiveAttribute = shadowReceiveAttribute;
    this._dirtyHash = true;
    this._hash = '';
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    ShadowCastAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'ShadowCast',
        cloneType: function() {
            return new ShadowCastAttribute(true);
        },
        setReceiveAttribute: function(shadowReceiveAttribute) {
            this._shadowReceiveAttribute = shadowReceiveAttribute;
        },
        getReceiveAttribute: function() {
            return this._shadowReceiveAttribute;
        },
        getDefines: function() {
            return this._shadowReceiveAttribute.getDefines();
        },
        _computeInternalHash: function() {
            return 'ShadowCast' + this._enable + this._shadowReceiveAttribute.getPrecision();
        },
        getHash: function() {
            var receiveAttributeDirty = false;
            if (this._shadowReceiveAttribute && this._shadowReceiveAttribute._dirtyHash)
                this._receiveAttributeDirty = true;

            if (!this._dirtyHash && !receiveAttributeDirty) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },
        // need a isEnabled to let the ShaderGenerator to filter
        // StateAttribute from the shader compilation
        isEnabled: function() {
            return this._enable;
        }
    }),
    'osgShadow',
    'ShadowCastAttribute'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowCastAttribute);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Light__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_LightSource__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_utils__ = __webpack_require__(1);








/*
 * Remove nodes that shouldn't not be culled when casting
 * like lights, camera with render texture targets,
 * transparent (alphablended) geometries
 * (otherwise it might break things)
 * visits whole underlying scene recursively
 */
var ShadowCasterVisitor = function(mask) {
    __WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__["a" /* default */].call(this);
    // mask setting to avoid casting shadows
    this._noCastMask = mask;
    this._nodeList = [];
};

__WEBPACK_IMPORTED_MODULE_6_osg_utils__["a" /* default */].createPrototypeObject(
    ShadowCasterVisitor,
    __WEBPACK_IMPORTED_MODULE_6_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_5_osg_NodeVisitor__["a" /* default */].prototype, {
        reset: function() {
            this._nodeList = [];
        },
        removeNodeFromCasting: function(node) {
            /*jshint bitwise: false */

            var nm = node.getNodeMask();
            // ~0x0 as not to be processed

            if (nm === ~0x0) {
                // set to avoid casting shadow
                nm = this._noCastMask;
                node.setNodeMask(nm);
                this._nodeList.push(node);
            } else if ((nm & ~this._noCastMask) !== 0) {
                // set to avoid casting shadow
                node.setNodeMask(nm | this._noCastMask);
                this._nodeList.push(node);
            }
            /*jshint bitwise: true */
        },
        // Visiting whole casting scene recursively
        apply: function(node) {
            // check that and other things ?
            // TODO: should check whole hierarchy to check for override/protected/etc
            // Depth, BlendFunc Attributes...
            var st = node.getStateSet();
            if (st) {
                // check for transparency not casting shadows
                // as no alpha blending transparency shadow (no transmittance support)
                var blend = st.getAttribute('BlendFunc');
                if (blend !== undefined && blend.getSource() !== __WEBPACK_IMPORTED_MODULE_0_osg_BlendFunc__["a" /* default */].DISABLE) {
                    var depth = st.getAttribute('Depth');
                    if (
                        depth &&
                        (depth.getFunc() === __WEBPACK_IMPORTED_MODULE_2_osg_Depth__["a" /* default */].DISABLE || depth.getWriteMask() === false)
                    ) {
                        this.removeNodeFromCasting(node);
                        return;
                    }
                }
            }

            // check for lights, as lights are positionned attributes
            if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_3_osg_Light__["a" /* default */].typeID || node.getTypeID() === __WEBPACK_IMPORTED_MODULE_4_osg_LightSource__["a" /* default */].typeID) {
                this.removeNodeFromCasting(node);
                return;
            } else if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_1_osg_Camera__["a" /* default */].typeID && node.isRenderToTextureCamera()) {
                // no "Subrender" when rendering the shadow map as from light point of view
                this.removeNodeFromCasting(node);
                return;
            }
            this.traverse(node);
        },

        setNoCastMask: function(mask) {
            this._noCastMask = mask;
        },

        // restore to any previous mask avoiding any breaks
        // in other application mask usage.
        restore: function() {
            for (var i = 0, l = this._nodeList.length; i < l; i++) {
                var node = this._nodeList[i];
                var nm = node.getNodeMask();

                if (nm === this._noCastMask) {
                    node.setNodeMask(~0x0);
                } else {
                    node.setNodeMask(nm & ~this._noCastMask);
                }
            }
        }
    }),
    'osgShadow',
    'ShadowCasterVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowCasterVisitor);


/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_CullVisitor__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgUtil_debug__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osg_Viewport__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_WebGLCaps__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osgShadow_ShadowReceiveAttribute__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osgShadow_ShadowCastAttribute__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osgShadow_ShadowTechnique__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osgShadow_ShadowTexture__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_osg_Scissor__ = __webpack_require__(85);


























// Custom camera cull callback
// we customize it just to avoid to add extra 'virtual' function
// on the shadowTecnique class
var CameraCullCallback = function(shadowTechnique) {
    this._shadowTechnique = shadowTechnique;
};

__WEBPACK_IMPORTED_MODULE_15_osg_utils__["a" /* default */].createPrototypeObject(
    CameraCullCallback,
    {
        cull: function(node, nv) {
            this._shadowTechnique.getShadowedScene().nodeTraverse(nv);

            var cs = nv.getCurrentCullingSet();
            var m = nv.getCurrentProjectionMatrix();
            var near = nv.getComputedNear(),
                far = nv.getComputedFar();

            if (near === Infinity && far === -Infinity) {
                this._shadowTechnique.markSceneAsNoShadow();
                return false;
            }

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].getFrustumPlanes(
                cs.getFrustum().getPlanes(),
                m,
                nv.getCurrentModelViewMatrix(),
                false
            );
            cs.getFrustum().setupMask(6);
            this._shadowTechnique.setLightFrustum(cs.getFrustum(), near, far);

            return false;
        }
    },
    'osgShadow',
    'CameraCullCallback'
);

/**
 *  ShadowMap provides an implementation of shadow textures.
 *  @class ShadowMap
 */
var ShadowMap = function(settings, shadowTexture) {
    __WEBPACK_IMPORTED_MODULE_21_osgShadow_ShadowTechnique__["a" /* default */].call(this);

    this._projectionMatrix = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].create();
    this._projection = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
    this._viewMatrix = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].create();
    this._lightNumberArrayIndex = -1;
    this._lightUp = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);

    this._light = settings.light;

    // data
    this._cameraShadow = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
    this._cameraShadow.setCullCallback(new CameraCullCallback(this));
    this._cameraShadow.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].PRE_RENDER, 0);
    this._cameraShadow.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_13_osg_Transform__["a" /* default */].ABSOLUTE_RF);
    this._cameraShadow.setClearColor(__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 1.0, 1.0, 1.0));

    if (shadowTexture) {
        this._texture = shadowTexture;
    } else {
        this._texture = new __WEBPACK_IMPORTED_MODULE_22_osgShadow_ShadowTexture__["a" /* default */]();
        this._textureUnitBase = 4;
        this._textureUnit = this._textureUnitBase;

        // see shadowSettings.js header for param explanations
        this._textureMagFilter = undefined;
        this._textureMinFilter = undefined;
    }

    this._textureSize = 256;
    var unifRenderSize = __WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat2('RenderSize');
    this._texelSizeUniform = __WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat1(1.0 / this._textureSize, 'texelSize');
    this._renderSize = unifRenderSize.getInternalArray();
    this._renderSize[0] = this._renderSize[1] = this._textureSize;

    this._receivingStateset = undefined;

    this._casterStateSet = new __WEBPACK_IMPORTED_MODULE_10_osg_StateSet__["a" /* default */]();
    this._casterStateSet.addUniform(__WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat1(0, 'exponent0'));
    this._casterStateSet.addUniform(__WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat1(0, 'exponent1'));
    this._casterStateSet.addUniform(__WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat1(0.005, 'bias'));
    this._casterStateSet.addUniform(this._texelSizeUniform);
    this._casterStateSet.addUniform(unifRenderSize);

    // make sure no unintended blend happens
    // if casting semi-transparent (alphablend material with full opaque pixels) shadow
    this._casterStateSet.setAttributeAndModes(
        new __WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */].LESS),
        __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE
    );
    this._casterStateSet.setAttributeAndModes(
        new __WEBPACK_IMPORTED_MODULE_2_osg_BlendFunc__["a" /* default */](),
        __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE
    );

    this._shadowReceiveAttribute = new __WEBPACK_IMPORTED_MODULE_19_osgShadow_ShadowReceiveAttribute__["a" /* default */](this._light.getLightNumber());
    this._casterStateSet.setAttributeAndModes(
        this._shadowReceiveAttribute,
        __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE
    );

    // default name, overridable with shadow settings
    this._shadowCastShaderGeneratorName = 'ShadowCast';

    var near = 0.001;
    var far = 1000;
    var unifRange = __WEBPACK_IMPORTED_MODULE_14_osg_Uniform__["a" /* default */].createFloat4('uShadowDepthRange');
    this._casterStateSet.addUniform(unifRange);
    this._depthRange = unifRange.getInternalArray();
    this._depthRange[0] = near;
    this._depthRange[1] = far;

    this._worldLightPos = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].create();
    this._worldLightPos[3] = 0;
    this._worldLightDir = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].create();
    this._worldLightDir[3] = 1;

    this._castsShadowDrawTraversalMask = 0xffffffff;
    this._castsShadowBoundsTraversalMask = 0xffffffff;

    this._shaderProcessor = undefined;

    // tmp variables
    this._tmpVec = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
    this._tmpVecBis = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
    this._tmpVecTercio = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
    this._tmpMatrix = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].create();

    if (settings) this.setShadowSettings(settings);

    this._infiniteFrustum = true;
    var shadowStateAttribute = new __WEBPACK_IMPORTED_MODULE_20_osgShadow_ShadowCastAttribute__["a" /* default */](false, this._shadowReceiveAttribute);

    this._casterStateSet.setAttributeAndModes(
        shadowStateAttribute,
        __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE
    );
    this._casterStateSet.setShaderGeneratorName(
        this._shadowCastShaderGeneratorName,
        __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON
    );

    this._debug = false;
};

/** @lends ShadowMap.prototype */
__WEBPACK_IMPORTED_MODULE_15_osg_utils__["a" /* default */].createPrototypeObject(
    ShadowMap,
    __WEBPACK_IMPORTED_MODULE_15_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_21_osgShadow_ShadowTechnique__["a" /* default */].prototype, {
        getDepthRange: function() {
            return this._depthRange;
        },
        setLightFrustum: function(lf, near, far) {
            this._lightFrustum = lf;

            this._depthRange[0] = near;
            this._depthRange[1] = far;
            this.nearFarBounding();

            if (this._debug) {
                this._debugGeomFrustum.updateGeometry(this._projectionMatrix, this._depthRange);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].invert(this._debugNodeFrustum.getMatrix(), this._viewMatrix);
            }
        },
        getCamera: function() {
            return this._cameraShadow;
        },

        getTexture: function() {
            return this._texture;
        },

        isDirty: function() {
            return this._dirty;
        },
        /**
     * at which Texture unit number we start adding texture shadow
     */
        setTextureUnitBase: function(unitBase) {
            this._textureUnitBase = unitBase;
            this._textureUnit = unitBase;
        },

        /* Sets  shadowSettings
     */
        setShadowSettings: function(shadowSettings) {
            if (!shadowSettings) return;

            this._light = shadowSettings.light;
            this._shadowCastShaderGeneratorName = shadowSettings.getShadowCastShaderGeneratorName();

            this.setCastsShadowDrawTraversalMask(shadowSettings.castsShadowDrawTraversalMask);
            this.setCastsShadowBoundsTraversalMask(shadowSettings.castsShadowBoundsTraversalMask);

            this.setLight(this._light);
            this.setTextureSize(shadowSettings.textureSize);
            this.setTexturePrecision(shadowSettings.textureType);

            this.setKernelSizePCF(shadowSettings.kernelSizePCF);
            this.setBias(shadowSettings.bias);
            this.setNormalBias(shadowSettings.normalBias);
        },

        setCastsShadowDrawTraversalMask: function(mask) {
            this._castsShadowDrawTraversalMask = mask;
        },

        getCastsShadowDrawTraversalMask: function() {
            return this._castsDrawShadowTraversalMask;
        },

        setCastsShadowBoundsTraversalMask: function(mask) {
            this._castsShadowBoundsTraversalMask = mask;
        },

        getCastsShadowBoundsTraversalMask: function() {
            return this._castsShadowBoundsTraversalMask;
        },

        getNormalBias: function() {
            return this._shadowReceiveAttribute.getNormalBias();
        },

        setNormalBias: function(value) {
            this._shadowReceiveAttribute.setNormalBias(value);
        },

        getJitterOffset: function() {
            return this._shadowReceiveAttribute.getJitterOffset();
        },

        setJitterOffset: function(value) {
            this._shadowReceiveAttribute.setJitterOffset(value);
        },

        getBias: function() {
            return this._shadowReceiveAttribute.getBias();
        },

        setBias: function(value) {
            this._shadowReceiveAttribute.setBias(value);
            var uniform = this._casterStateSet.getUniformList().bias.getUniform();
            uniform.setFloat(value);
        },

        getKernelSizePCF: function() {
            return this._shadowReceiveAttribute.getKernelSizePCF();
        },

        setKernelSizePCF: function(value) {
            this._shadowReceiveAttribute.setKernelSizePCF(value);
        },

        setShadowedScene: function(shadowedScene) {
            __WEBPACK_IMPORTED_MODULE_21_osgShadow_ShadowTechnique__["a" /* default */].prototype.setShadowedScene.call(this, shadowedScene);
            this._receivingStateset = this._shadowedScene.getReceivingStateSet();
            this.dirty();
        },

        checkLightNumber: function() {
            var lightNumber = this._light.getLightNumber();

            // if light number changed we need to remove cleanly
            // attributes from receiveStateSet
            // it's because it use a typemember like light attribute
            // so the number if very important to keep State clean
            if (this._shadowReceiveAttribute.getLightNumber() !== lightNumber) {
                if (
                    this._receivingStateset.getAttribute(
                        this._shadowReceiveAttribute.getTypeMember()
                    ) === this._shadowReceiveAttribute
                )
                    this._receivingStateset.removeAttribute(
                        this._shadowReceiveAttribute.getTypeMember()
                    );
            }


            if (this._texture && !this._texture.hasLightNumber(lightNumber)) {
                // remove this._texture, but not if it's not this._texture
                if (
                    this._receivingStateset.getTextureAttribute(
                        this._textureUnit,
                        this._texture.getTypeMember()
                    ) === this._texture
                )
                    this._receivingStateset.removeTextureAttribute(
                        this._textureUnit,
                        this._texture.getTypeMember()
                    );
            }
        },

        /** initialize the ShadowedScene and local cached data structures.*/
        init: function(atlasTexture, lightIndex, textureUnit) {
            if (!this._shadowedScene) return;

            this._needRedraw = true;

            this.checkLightNumber();

            if (!this._cameraShadow) {
                this._cameraShadow = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
                this._cameraShadow.setCullCallback(new CameraCullCallback(this));
                this._cameraShadow.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].PRE_RENDER, 0);
                this._cameraShadow.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_13_osg_Transform__["a" /* default */].ABSOLUTE_RF);
                this._cameraShadow.setClearColor(__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 1.0, 1.0, 1.0));
            }

            var lightNumber = this._light.getLightNumber();

            if (!atlasTexture) {
                this.initTexture();

                this._textureUnit = this._textureUnitBase + lightNumber;
                this._texture.setLightNumber(lightNumber);
                this._texture.setName('ShadowTexture' + this._textureUnit);
                this._shadowReceiveAttribute.setAtlas(false);
            } else {
                this._texture = atlasTexture;

                // allow indexing properties in the texture uniforms
                this._lightNumberArrayIndex = lightIndex;
                this._textureUnit = textureUnit;
                this._shadowReceiveAttribute.setAtlas(true);
            }

            this._cameraShadow.setName('light_shadow_camera' + this._light.getName());
            this._shadowReceiveAttribute.setLightNumber(lightNumber);

            // Idea is to make sure the null texture is "binded" to all shadow casting scene
            // so we override all existing texture bind in the scene, preventing any texture bind.
            // When user implements alpha mask casting, they use PROTECTED to prevent OVERRIDE to remove their alpha mask texture needed.
            var fullOverride = __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON;

            this._receivingStateset.setAttributeAndModes(
                this._shadowReceiveAttribute,
                fullOverride
            );

            // prevent unnecessary texture bindings
            this._preventTextureBindingDuringShadowCasting();

            // Mandatory: prevent binding shadow textures themselves
            // ( ShadowedScene StateSet is applied  just above in StateSet hierarchy)
            // that would mean undefined values as it would be read/write access...
            // So we force it against Texture.null binding done just above (PROTECTED)
            // and Prevent any under hierarchy bind with OVERRIDE
            // must be done AFTER the prevent binding.
            this._casterStateSet.setTextureAttributeAndModes(
                this._textureUnit,
                __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].textureNull,
                __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].PROTECTED
            );

            // add shadow texture to the receivers
            // should make sure somehow that
            // alpha blender transparent receiver doesn't use it
            // compiler wise at least
            this._receivingStateset.setTextureAttributeAndModes(
                this._textureUnit,
                this._texture,
                fullOverride
            );

            this._dirty = false;
        },
        // Make sure we don't bind texture and thus make GPU work for nothing
        // as shadow casting just output Depth ( no color )
        // os we set a null texture and OVERRIDE StateAttribute flag
        // only case you want to use a texture is
        // alpha masked material, then you have StateAttribute to 'PROTECTED'
        _preventTextureBindingDuringShadowCasting: function() {
            // prevent unnecessary texture bindings on all texture unit
            var shouldGetMaxTextureUnits = __WEBPACK_IMPORTED_MODULE_18_osg_WebGLCaps__["a" /* default */].instance().getWebGLParameter(
                'MAX_TEXTURE_IMAGE_UNITS'
            );
            for (var k = 0; k < shouldGetMaxTextureUnits; k++) {
                // bind  null texture which OSGJS will not bind,
                // effectively preventing any other texture bind
                // just not touching texture unit state.
                this._casterStateSet.setTextureAttributeAndModes(
                    k,
                    __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].textureNull,
                    __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].OVERRIDE | __WEBPACK_IMPORTED_MODULE_9_osg_StateAttribute__["a" /* default */].ON
                );
            }
        },
        valid: function() {
            // checks
            return true;
        },

        updateShadowTechnique: function(nv, viewportDimension, frameBufferObject) {
            var camera = this._cameraShadow;
            var texture = this._texture;

            if (camera && texture) {
                var vp = camera.getViewport();

                if (!vp) {
                    vp = new __WEBPACK_IMPORTED_MODULE_17_osg_Viewport__["a" /* default */]();
                    camera.setViewport(vp);
                }

                if (viewportDimension) {
                    var scissor = camera.getScissor();
                    if (!scissor) {
                        scissor = new __WEBPACK_IMPORTED_MODULE_23_osg_Scissor__["a" /* default */](
                            viewportDimension[0],
                            viewportDimension[1],
                            viewportDimension[2],
                            viewportDimension[3]
                        );
                        camera.setScissor(scissor);
                    }

                    // if texture size changed update the camera rtt params
                    if (
                        vp.x() !== viewportDimension[0] ||
                        vp.y() !== viewportDimension[1] ||
                        vp.width() !== viewportDimension[2] ||
                        vp.height() !== viewportDimension[3]
                    ) {
                        camera.setFrameBufferObject(frameBufferObject);
                        vp.setViewport(
                            viewportDimension[0],
                            viewportDimension[1],
                            viewportDimension[2],
                            viewportDimension[3]
                        );

                        scissor.setScissor(
                            viewportDimension[0],
                            viewportDimension[1],
                            viewportDimension[2],
                            viewportDimension[3]
                        );
                    }
                } else if (
                    vp.width() !== texture.getWidth() ||
                    vp.height() !== texture.getHeight()
                ) {
                    // if texture size changed update the camera rtt params
                    camera.detachAll();
                    camera.attachTexture(__WEBPACK_IMPORTED_MODULE_4_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0, texture);
                    camera.attachRenderBuffer(
                        __WEBPACK_IMPORTED_MODULE_4_osg_FrameBufferObject__["a" /* default */].DEPTH_ATTACHMENT,
                        __WEBPACK_IMPORTED_MODULE_4_osg_FrameBufferObject__["a" /* default */].DEPTH_COMPONENT16
                    );
                    vp.setViewport(0, 0, texture.getWidth(), texture.getHeight());
                }
            }
        },

        updateShadowTechnic: function(/*nv*/) {
            __WEBPACK_IMPORTED_MODULE_7_osg_notify__["a" /* default */].log(
                'ShadowMap.updateShadowTechnic() is deprecated, use updateShadowTechnique instead'
            );
            this.updateShadowTechnique();
        },

        setTextureFiltering: function() {
            var textureType;
            var texType = this.getTexturePrecision();
            switch (texType) {
                case 'HALF_FLOAT':
                    textureType = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].HALF_FLOAT;
                    break;
                case 'FLOAT':
                    textureType = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].FLOAT;
                    break;
                default:
                case 'UNSIGNED_BYTE':
                    textureType = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].UNSIGNED_BYTE;
                    break;
            }

            this._texture.setInternalFormatType(textureType);
            this._texture.setMinFilter(__WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].NEAREST);
            this._texture.setMagFilter(__WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].NEAREST);
            this._textureMagFilter = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].NEAREST;
            this._textureMinFilter = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].NEAREST;
        },

        // internal texture allocation
        // handle any change like resize, filter param, etc.
        initTexture: function() {
            if (!this._dirty) return;

            if (!this._texture) {
                this._texture = new __WEBPACK_IMPORTED_MODULE_22_osgShadow_ShadowTexture__["a" /* default */]();
                this._textureUnit = this._textureUnitBase;
            }

            this._texture.setTextureSize(this._textureSize, this._textureSize);
            this._texelSizeUniform.setFloat(1.0 / this._textureSize);
            this._renderSize[0] = this._textureSize;
            this._renderSize[1] = this._textureSize;

            var textureFormat;
            // luminance Float format ?
            textureFormat = __WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].RGBA;

            this.setTextureFiltering();
            this._texture.setInternalFormat(textureFormat);

            this._texture.setWrapS(__WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].CLAMP_TO_EDGE);
            this._texture.setWrapT(__WEBPACK_IMPORTED_MODULE_12_osg_Texture__["default"].CLAMP_TO_EDGE);

            this._texture.dirty();
        },
        setTexturePrecision: function(format) {
            if (format === this._shadowReceiveAttribute.getPrecision()) return;

            this._shadowReceiveAttribute.setPrecision(format);
            this.dirty();
        },

        getTexturePrecision: function() {
            return this._shadowReceiveAttribute.getPrecision();
        },

        setTextureSize: function(mapSize) {
            if (mapSize === this._textureSize) return;

            this._textureSize = mapSize;

            this.dirty();
        },

        getCasterStateSet: function() {
            return this._casterStateSet;
        },

        setLight: function(light) {
            if (!light || light === this._light) return;

            this._light = light;
            this.dirty();
        },

        getUp: function(dir) {
            //avoid dir/up wrong angle breaking computation

            // compute a up vector ensuring avoiding parallel vectors
            // also might reverting to it once got the change here done once
            // vec3.fromValues( 0.0, 0.0, 1.0 );

            if (Math.abs(__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].dot(this._lightUp, dir)) >= 1.0) {
                // another camera up
                // vec3.fromValues( 1.0, 0.0, 0.0 );
                if (this._lightUp[0] === 1.0) {
                    this._lightUp[0] = 0.0;
                    this._lightUp[1] = 1.0;
                    this._lightUp[2] = 0.0;
                } else {
                    this._lightUp[0] = 1.0;
                    this._lightUp[1] = 0.0;
                    this._lightUp[2] = 0.0;
                }
            }
            return this._lightUp;
        },

        // makes sure we don't have incorrect near/far
        // or we actually have to render something.
        // Empty or Bad Frustums
        // No objects, handle it gracefully
        nearFarBounding: function() {
            var zNear = this._depthRange[0];
            var zFar = this._depthRange[1];

            var epsilon = ShadowMap.EPSILON;
            if (zFar < zNear - epsilon) {
                // early out
                this._emptyCasterScene = true;
                zFar = 1;
                zNear = epsilon;
            } else if (zNear < epsilon) {
                zNear = epsilon;
            }

            this._depthRange[0] = zNear;
            this._depthRange[1] = zFar;
        },

        makePerspectiveFromBoundingBox: function(bbox, fov, eyePos, eyeDir, view, projection) {
            var center = bbox.center(this._tmpVec);
            var radius = bbox.radius();
            var epsilon = ShadowMap.EPSILON;
            var zNear = epsilon;
            var zFar = 1.0;

            this._radius = radius;

            var distance = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].distance(center, eyePos);
            // inside or not have influence
            // on using radius for fov
            if (distance <= radius) {
                // shhh.. we're inside !
                // sphere center is in front
                zNear = epsilon;
                zFar = distance + radius;
            } else {
                //  Sphere totally in front
                // long distance runner
                // we must make a nicer zNear here!
                zNear = distance - radius;
                zFar = distance + radius;
            }

            this._depthRange[0] = zNear;
            this._depthRange[1] = zFar;
            this.nearFarBounding();

            // positional light: spot, point, area
            //  fov < 180.0
            // statically defined by spot, only needs zNear zFar estimates
            var fovRadius = this._depthRange[0] * Math.tan(fov * Math.PI / 180.0);
            // if scene radius is smaller than fov on scene
            // Tighten and enhance precision
            fovRadius = fovRadius > radius ? radius : fovRadius;

            var ymax = fovRadius;
            var ymin = -ymax;

            var xmax = fovRadius;
            var xmin = -xmax;

            var up = this.getUp(eyeDir);

            if (this._infiniteFrustum) {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].infiniteFrustum(projection, xmin, xmax, ymin, ymax, this._depthRange[0]);
            } else {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].frustum(
                    projection,
                    xmin,
                    xmax,
                    ymin,
                    ymax,
                    this._depthRange[0],
                    this._depthRange[1]
                );
            }

            this._projection[0] = this._projectionMatrix[0];
            this._projection[1] = this._projectionMatrix[5];
            this._projection[2] = 0.0;

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].lookAtDirection(view, eyePos, eyeDir, up);
        },

        makeOrthoFromBoundingBox: function(bbox, eyeDir, view, projection) {
            var center = bbox.center(this._tmpVecTercio);

            var radius = bbox.radius();
            var diameter = radius + radius;

            var zNear = 0.0001;
            var zFar = diameter + 0.0001;

            // compute eye Pos from a inverted lightDir Ray shot from center of bbox
            // firs make a RAY then move the eye to the that far pos following the ray
            var eyePos = this._tmpVec;
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(eyePos, center, eyeDir, -diameter);

            zNear = radius;
            zFar += radius;

            var zNearRatio = 0.001;
            if (zNear < zFar * zNearRatio) {
                zNear = zFar * zNearRatio;
            }

            var up = this.getUp(eyeDir);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].lookAtDirection(view, eyePos, eyeDir, up);

            var right, top;
            top = radius;
            right = top;
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].ortho(projection, -right, right, -top, top, zNear, zFar);

            this._projection[0] = right;
            this._projection[1] = top;
            this._projection[2] = 1.0;

            this._depthRange[0] = zNear;
            this._depthRange[1] = zFar;
        },
        /*
     * Sync camera and light vision so that
     * shadow map render using a camera whom
     * settings come from the light
     * and the scene being shadowed
     */
        aimShadowCastingCamera: function(cullVisitor, bbox) {
            var light = this._light;

            if (!light) {
                this._emptyCasterScene = true;
                return;
            }

            var camera = this._cameraShadow;

            var worldLightPos = this._worldLightPos;
            var worldLightDir = this._worldLightDir;

            // make sure it's not modified outside our computations
            // camera matrix can be modified by cullvisitor afterwards...
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(this._projectionMatrix, camera.getProjectionMatrix());
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(this._viewMatrix, camera.getViewMatrix());
            var projection = this._projectionMatrix;
            var view = this._viewMatrix;

            // inject camera world matrix.
            // from light current world/pos and camera eye pos.
            // inject camera world matrix.
            // from light current world/pos
            // NEED same camera eye pos
            var positionedAttribute = cullVisitor.getCurrentRenderBin().getPositionedAttribute();

            var lightMatrix;
            var positionedAttributeElements = positionedAttribute.getArray();
            for (var i = 0; i < positionedAttribute.getLength(); i++) {
                var pa = positionedAttributeElements[i];
                var attribute = pa[1];
                var matrix = pa[0];
                if (attribute === light) {
                    lightMatrix = matrix;
                    break;
                }
            }

            if (lightMatrix === undefined) {
                __WEBPACK_IMPORTED_MODULE_7_osg_notify__["a" /* default */].warn('light isnt inside children of shadowedScene Node');
                this._emptyCasterScene = true;
                return;
            }

            var eyeToWorld = this._tmpMatrix;
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].invert(eyeToWorld, cullVisitor.getCurrentModelViewMatrix());

            //  light pos & lightTarget in World Space
            if (!this._light.isDirectionLight()) {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].mul(this._tmpMatrix, eyeToWorld, lightMatrix);
                var worldMatrix = this._tmpMatrix;

                // same code as light spot shader
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].transformMat4(worldLightPos, light.getPosition(), worldMatrix);
                worldMatrix[12] = 0;
                worldMatrix[13] = 0;
                worldMatrix[14] = 0;
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].invert(worldMatrix, worldMatrix);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].transpose(worldMatrix, worldMatrix);

                // not a directional light, compute the world light dir
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].copy(worldLightDir, light.getDirection());
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].transformMat4(worldLightDir, worldLightDir, worldMatrix);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(worldLightDir, worldLightDir);

                // and compute a perspective frustum
                this.makePerspectiveFromBoundingBox(
                    bbox,
                    light.getSpotCutoff(),
                    worldLightPos,
                    worldLightDir,
                    view,
                    projection
                );
            } else {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].transformMat4(worldLightPos, light.getPosition(), lightMatrix);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["g" /* vec4 */].transformMat4(worldLightPos, worldLightPos, eyeToWorld);
                // same code as light sun shader
                // lightpos is a light dir
                // so we now have to normalize
                // since the transform to world above
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].scale(worldLightPos, worldLightPos, -1.0);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(worldLightPos, worldLightPos);
                this.makeOrthoFromBoundingBox(bbox, worldLightPos, view, projection);

                if (this._debug) {
                    // project box by view to get projection debug bbox
                    __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].invert(this._debugNodeFrustum.getMatrix(), view);
                }
            }

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(camera.getProjectionMatrix(), this._projectionMatrix);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(camera.getViewMatrix(), this._viewMatrix);
        },

        // culling is done,
        // now try for a the tightest frustum
        // possible for shadowcasting
        frameShadowCastingFrustum: function(cullVisitor) {
            if (!this._infiniteFrustum) {
                __WEBPACK_IMPORTED_MODULE_1_osg_CullVisitor__["a" /* default */].prototype.clampProjectionMatrix(
                    this._projectionMatrix,
                    this._depthRange[0],
                    this._depthRange[1],
                    cullVisitor.getNearFarRatio(),
                    this._depthRange
                );
            }

            // overwrite any cullvisitor wrongness done by any clampProjectionMatrix
            var camera = this._cameraShadow;
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(camera.getProjectionMatrix(), this._projectionMatrix);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(camera.getViewMatrix(), this._viewMatrix);

            this.setShadowUniformsReceive(false);
        },

        setShadowUniformsReceive: function(noDepth) {
            if (noDepth) {
                // receiver shader can read and early out
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["e" /* vec2 */].set(this._depthRange, 0.0, 0.0);
            }
            // even if noDepth, need to call those to make sure they are created
            // in shadowTexture / shadowTextureAtlas
            if (this._lightNumberArrayIndex !== -1) {
                var lightNumber = this._light.getLightNumber();
                this._texture.setViewMatrix(lightNumber, this._viewMatrix);
                this._texture.setProjection(lightNumber, this._projection);
                this._texture.setDepthRange(lightNumber, this._depthRange);
            } else {
                this._texture.setViewMatrix(this._viewMatrix);
                this._texture.setProjection(this._projection);
                this._texture.setDepthRange(this._depthRange);
            }
        },

        // we know the scene is empty so we don't draw it
        // but we still camera clear it.
        // but we want to mark the uniform so that receiver shader can do
        // an early out.
        // ie: in shader, no texfetch
        markSceneAsNoShadow: function() {
            this.setShadowUniformsReceive(true);
            // we still clear the shadow so we filled it
            this._needRedraw = false;
        },

        // Defines the frustum from light param.
        //
        cullShadowCasting: function(cullVisitor, bbox) {
            if (this._debug) {
                var min = bbox.getMin();
                var max = bbox.getMax();
                bbox.center(this._tmpVec);
                var matrix = this._debugNodeSceneCast.getMatrix();

                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].fromScaling(matrix, [max[0] - min[0], max[1] - min[1], max[2] - min[2], 1]);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].setTranslation(matrix, this._tmpVec);
            }

            this._emptyCasterScene = false;
            this.aimShadowCastingCamera(cullVisitor, bbox);

            if (this._emptyCasterScene) {
                // nothing to draw, tell receiver to do early out
                // ie: in shader, no texfetch
                this.markSceneAsNoShadow();
                // Early out, no need to traverse scene either
                return;
            }

            // get renderer to make the cull program
            // record the traversal mask on entry so we can reapply it later.
            var traversalMask = cullVisitor.getTraversalMask();

            cullVisitor.setTraversalMask(this._castsShadowDrawTraversalMask);

            // cast geometries into depth shadow map
            cullVisitor.pushStateSet(this._casterStateSet);

            this._cameraShadow.setEnableFrustumCulling(true);
            this._cameraShadow.setComputeNearFar(true);

            if (this._debug) {
                this._debugNode.accept(cullVisitor);
            }

            // do RTT from the camera traversal mimicking light pos/orient
            this._cameraShadow.accept(cullVisitor);

            // make sure no negative near
            this.nearFarBounding();

            // Here culling is done, we do have near/far.
            // and cull/non-culled info
            // if we wanted a tighter frustum.
            this.frameShadowCastingFrustum(cullVisitor);

            // disabling to prevent cullvisitor breaking
            // the projection matrix by "clamping" it
            this._cameraShadow.setComputeNearFar(false);

            cullVisitor.popStateSet();

            // re-apply the original traversal mask
            cullVisitor.setTraversalMask(traversalMask);
            this._needRedraw = false;
        },

        cleanReceivingStateSet: function(ignoreTexture) {
            if (this._receivingStateset) {
                if (
                    this._receivingStateset.getAttribute(
                        this._shadowReceiveAttribute.getTypeMember()
                    ) === this._shadowReceiveAttribute
                )
                    this._receivingStateset.removeAttribute(
                        this._shadowReceiveAttribute.getTypeMember()
                    );

                if (ignoreTexture) return;

                if (this._texture) {
                    // remove this._texture, but not if it's not this._texture
                    if (
                        this._receivingStateset.getTextureAttribute(
                            this._textureUnit,
                            this._texture.getTypeMember()
                        ) === this._texture
                    )
                        this._receivingStateset.removeTextureAttribute(
                            this._textureUnit,
                            this._texture.getTypeMember()
                        );
                }
            }
        },
        cleanSceneGraph: function(ignoreTexture) {
            // well release a lot more things when it works
            this._cameraShadow = undefined;
            this._needRedraw = true;

            this.cleanReceivingStateSet(ignoreTexture);

            // TODO: need state
            //this._texture.releaseGLObjects();
            //this._shadowReceiveAttribute = undefined;
            this._texture = undefined;
            this._shadowedScene = undefined;
        },

        setDebug: function(enable) {
            if (enable && !this._debug) {
                if (!this._debugNode) {
                    this._debugGeomFrustum = __WEBPACK_IMPORTED_MODULE_11_osgUtil_debug__["a" /* default */].createDebugFrustumGeometry();

                    this._debugGeomSceneCast = __WEBPACK_IMPORTED_MODULE_8_osg_shape__["a" /* default */].createBoundingBoxGeometry();

                    this._debugGeomSceneCast.getPrimitives()[0].mode = __WEBPACK_IMPORTED_MODULE_16_osg_primitiveSet__["a" /* default */].LINES;

                    this._debugNode = new __WEBPACK_IMPORTED_MODULE_6_osg_MatrixTransform__["a" /* default */]();
                    this._debugNodeFrustum = new __WEBPACK_IMPORTED_MODULE_6_osg_MatrixTransform__["a" /* default */]();
                    this._debugNodeSceneCast = new __WEBPACK_IMPORTED_MODULE_6_osg_MatrixTransform__["a" /* default */]();

                    this._debugNodeFrustum.addChild(this._debugGeomFrustum);
                    this._debugNodeSceneCast.addChild(this._debugGeomSceneCast);

                    this._debugNode.addChild(this._debugNodeFrustum);
                    this._debugNode.addChild(this._debugNodeSceneCast);
                }
            }
            this._debug = enable;
        },
        getDebug: function() {
            return this._debug;
        },
        getLightNumber: function() {
            return this._light.getLightNumber();
        },

        getLight: function() {
            return this._light;
        }
    }),
    'osgShadow',
    'ShadowMap'
);

ShadowMap.EPSILON = 5e-3;

/* harmony default export */ __webpack_exports__["a"] = (ShadowMap);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);




/**
 * ShadowReceiveAttribute encapsulate Shadow Main State object
 * @class ShadowReceiveAttribute
 * @inherits StateAttribute
 */
var ShadowReceiveAttribute = function(lightNum, disable) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    this._lightNumber = lightNum;

    // see shadowSettings.js header for shadow algo param explanations
    // hash change var

    // shadow depth bias as projected in shadow camera space texture
    // and viewer camera space projection introduce its bias
    this._bias = 0.001;

    // shadow normal bias from normal exploding offset technique
    this._normalBias = undefined;
    // shader compilation different upon texture precision
    this._precision = 'UNSIGNED_BYTE';
    // kernel size & type for pcf
    this._kernelSizePCF = undefined;

    this._fakePCF = true;

    this._jitterOffset = 'none';

    this._enable = !disable;
    this._isAtlasTexture = false;

    this._dirtyHash = true;
    this._hash = '';
};

ShadowReceiveAttribute.uniforms = {};
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    ShadowReceiveAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'ShadowReceive',

        cloneType: function() {
            return new ShadowReceiveAttribute(this._lightNumber, true);
        },

        getTypeMember: function() {
            return this.attributeType + this.getLightNumber();
        },

        getLightNumber: function() {
            return this._lightNumber;
        },

        getUniformName: function(name) {
            var prefix = this.getType() + this.getLightNumber().toString();
            return 'u' + prefix + '_' + name;
        },

        getAtlas: function() {
            return this._isAtlasTexture;
        },
        setAtlas: function(v) {
            this._isAtlasTexture = v;
        },

        setBias: function(bias) {
            this._bias = bias;
        },

        getBias: function() {
            return this._bias;
        },

        setNormalBias: function(bias) {
            this._normalBias = bias;
        },

        getNormalBias: function() {
            return this._normalBias;
        },

        setJitterOffset: function(jitter) {
            this._jitterOffset = jitter;
        },

        getJitterOffset: function() {
            return this._jitterOffset;
        },

        getKernelSizePCF: function() {
            return this._kernelSizePCF;
        },

        setKernelSizePCF: function(v) {
            this._kernelSizePCF = v;
            this._dirtyHash = true;
        },

        setPrecision: function(precision) {
            this._precision = precision;
            this._dirtyHash = true;
        },

        getPrecision: function() {
            return this._precision;
        },

        setLightNumber: function(lightNum) {
            this._lightNumber = lightNum;
            this._dirtyHash = true;
        },

        getOrCreateUniforms: function() {
            // uniform are once per CLASS attribute, not per instance
            var obj = ShadowReceiveAttribute;

            var typeMember = this.getTypeMember();

            if (obj.uniforms[typeMember]) return obj.uniforms[typeMember];

            obj.uniforms[typeMember] = {
                bias: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat(this.getUniformName('bias')),
                normalBias: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat(this.getUniformName('normalBias'))
            };

            return obj.uniforms[typeMember];
        },

        // Here to be common between  caster and receiver
        // (used by shadowMap and shadow node shader)
        getDefines: function() {
            var defines = [];

            var pcf = this.getKernelSizePCF();
            switch (pcf) {
                case '4Tap(16texFetch)':
                    defines.push('#define _PCFx4');
                    break;
                case '9Tap(36texFetch)':
                    defines.push('#define _PCFx9');
                    break;
                case '16Tap(64texFetch)':
                    defines.push('#define _PCFx25');
                    break;
                default:
                case '1Tap(4texFetch)':
                    defines.push('#define _PCFx1');
                    break;
            }

            if (this.getPrecision() !== 'UNSIGNED_BYTE') defines.push('#define _FLOATTEX');
            if (this.getAtlas()) defines.push('#define _ATLAS_SHADOW');
            if (this.getNormalBias()) defines.push('#define _NORMAL_OFFSET');
            if (this.getJitterOffset() !== 'none') defines.push('#define _JITTER_OFFSET');

            return defines;
        },

        apply: function() {
            if (!this._enable) return;

            var uniformMap = this.getOrCreateUniforms();

            uniformMap.normalBias.setFloat(this._normalBias);
            uniformMap.bias.setFloat(this._bias);
        },

        // need a isEnabled to let the ShaderGenerator to filter
        // StateAttribute from the shader compilation
        isEnabled: function() {
            return this._enable;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },

        _computeInternalHash: function() {
            return this.getTypeMember() + '_' + this.getKernelSizePCF();
        }
    }),
    'osgShadow',
    'ShadowReceiveAttribute'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowReceiveAttribute);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowTexture__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);







/**
 * ShadowTexture Attribute encapsulate Texture webgl object
 * with Shadow specificities (no need of texcoord,fragtexcoord)
 * trigger hash change when changing texture precision from float to byt
 * shadowSettings.js header for param explanations
 * @class ShadowTextureAtlas
 * @inherits TextureAttribute
 */
var ShadowTextureAtlas = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].call(this);

    this._uniforms = {};
    this._lightNumberArray = []; // default for a valid cloneType

    this._viewMatrices = [];
    this._projection = [];
    this._depthRanges = [];
    this._mapSizes = [];
    this._renderSize = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["e" /* vec2 */].create();
    this._dirtyHash = true;
    this._hash = '';
};

ShadowTextureAtlas.uniforms = {};
/** @lends Texture.prototype */

__WEBPACK_IMPORTED_MODULE_4_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    ShadowTextureAtlas,
    __WEBPACK_IMPORTED_MODULE_4_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype, {
        cloneType: function() {
            return new ShadowTextureAtlas();
        },

        getLightNumberArray: function() {
            return this._lightNumberArray;
        },

        hasLightNumber: function(lightNum) {
            return this._lightNumberArray.indexOf(lightNum) !== -1;
        },

        setLightNumberArray: function(lightNumberArray) {
            this._lightNumberArray = lightNumberArray;
            this._dirtyHash = true;
        },

        getUniformName: function(lightNumber, name) {
            var prefix = 'Shadow_' + this.getType() + lightNumber.toString();
            return 'u' + prefix + '_' + name;
        },

        setInternalFormatType: function(value) {
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.setInternalFormatType.call(this, value);
            this._dirtyHash = true;
        },

        createUniforms: function(lightNumber, uniforms) {

            uniforms['ViewRight_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4(
                this.getUniformName(lightNumber, 'ViewRight')
            );
            uniforms['ViewUp_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4(
                this.getUniformName(lightNumber, 'ViewUp')
            );
            uniforms['ViewLook_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4(
                this.getUniformName(lightNumber, 'ViewLook')
            );

            uniforms['Projection_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat3(
                this.getUniformName(lightNumber, 'projection')
            );
            uniforms['DepthRange_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat2(
                this.getUniformName(lightNumber, 'depthRange')
            );
            uniforms['MapSize_' + lightNumber] = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat4(
                this.getUniformName(lightNumber, 'mapSize')
            );
            uniforms['RenderSize_' + lightNumber] = uniforms['RenderSize'];
        },

        getOrCreateUniforms: function(unit) {

            // uniform are once per CLASS attribute, not per instance
            var obj = ShadowTextureAtlas;
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].assert(unit !== undefined || this._lightNumberArray.length !== 0);

            if (obj.uniforms[unit] !== undefined) {
                return obj.uniforms[unit];
            }

            var uniforms = (obj.uniforms[unit] = {});

            // shadowmap texture size used for texel space which is viewport independant
            var renderSizeUniform = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createFloat2(this.getUniformName(0, 'renderSize'));
            uniforms['RenderSize'] = renderSizeUniform;

            for (var i = 0, l = this._lightNumberArray.length; i < l; i++) {
                this.createUniforms(this._lightNumberArray[i], uniforms);
            }

            // Dual Uniform of texture, needs:
            // - Sampler (type of texture)
            // - Int (texture unit)
            // tells Shader Program where to find it
            var name = 'Texture' + unit;
            var uniform = __WEBPACK_IMPORTED_MODULE_3_osg_Uniform__["a" /* default */].createInt1(unit, name);
            uniforms[name] = uniform;

            return obj.uniforms[unit];
        },

        setViewMatrix: function(lightNumber, viewMatrix) {
            this._viewMatrices[lightNumber] = viewMatrix;
        },


        setProjection: function(lightNumber, projection) {
            this._projection[lightNumber] = projection;
        },

        setDepthRange: function(lighNumber, depthRange) {
            this._depthRanges[lighNumber] = depthRange;
        },

        setLightShadowMapSize: function(lightNumber, dimension) {
            this._mapSizes[lightNumber] = dimension;
        },

        apply: function(state, texUnit) {
            // Texture stuff: call parent class method
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.apply.call(this, state, texUnit);

            if (this._lightNumberArray.length === 0) {
                return;
            }

            // update Uniforms
            var uniformMap = this.getOrCreateUniforms(texUnit);

            for (var i = 0, l = this._lightNumberArray.length; i < l; i++) {
                var lightNumber = this._lightNumberArray[i];

                if (!uniformMap['ViewRight_' + lightNumber]) {
                    // enable disable uniforms and yet using getOrCreate
                    this.createUniforms(lightNumber, uniformMap);
                }

                __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowTexture__["a" /* default */].prototype._updateViewMatrixUniforms.call(this,
                    this._viewMatrices[lightNumber],
                    uniformMap['ViewRight_' + lightNumber],
                    uniformMap['ViewUp_' + lightNumber],
                    uniformMap['ViewLook_' + lightNumber]
                );

                uniformMap['Projection_' + lightNumber].setFloat3(
                    this._projection[lightNumber]
                );
                uniformMap['DepthRange_' + lightNumber].setFloat2(this._depthRanges[lightNumber]);
                uniformMap['MapSize_' + lightNumber].setFloat4(this._mapSizes[lightNumber]);
            }

            uniformMap['RenderSize'].setFloat2(this._renderSize);
        },

        setTextureSize: function(w, h) {
            this._renderSize[0] = 1.0 / w;
            this._renderSize[1] = 1.0 / h;
            __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].prototype.setTextureSize.call(this, w, h);
            this.dirty();
        },

        _computeInternalHash: function() {
            var hash = this.getTypeMember();
            for (var i = 0, l = this._lightNumberArray.length; i < l; i++) {
                hash += '_' + this._lightNumberArray[i];
            }
            hash += '_' + this._type;
            return hash;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        }
    }),
    'osgShadow',
    'ShadowTextureAtlas'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowTextureAtlas);


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(175);


/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_polyfill__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_osg_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgNameSpace__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_osg__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_osgAnimation__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgDB_osgDB__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgGA_osgGA__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgUtil_osgUtil__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgViewer_osgViewer__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShader_osgShader__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgShadow_osgShadow__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgStats_osgStats__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgText_osgText__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgWrappers_osgWrappers__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgPlugins_osgPlugins__ = __webpack_require__(258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osg", function() { return __WEBPACK_IMPORTED_MODULE_2_osg_osg__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgAnimation", function() { return __WEBPACK_IMPORTED_MODULE_3_osgAnimation_osgAnimation__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgDB", function() { return __WEBPACK_IMPORTED_MODULE_4_osgDB_osgDB__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgGA", function() { return __WEBPACK_IMPORTED_MODULE_5_osgGA_osgGA__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgUtil", function() { return __WEBPACK_IMPORTED_MODULE_6_osgUtil_osgUtil__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgViewer", function() { return __WEBPACK_IMPORTED_MODULE_7_osgViewer_osgViewer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgShader", function() { return __WEBPACK_IMPORTED_MODULE_8_osgShader_osgShader__["default"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgShadow", function() { return __WEBPACK_IMPORTED_MODULE_9_osgShadow_osgShadow__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgStats", function() { return __WEBPACK_IMPORTED_MODULE_10_osgStats_osgStats__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgText", function() { return __WEBPACK_IMPORTED_MODULE_11_osgText_osgText__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgWrappers", function() { return __WEBPACK_IMPORTED_MODULE_12_osgWrappers_osgWrappers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osgPlugins", function() { return __WEBPACK_IMPORTED_MODULE_13_osgPlugins_osgPlugins__["a"]; });















var OSG = __WEBPACK_IMPORTED_MODULE_1_osgNameSpace__["a" /* default */];

OSG.osg = __WEBPACK_IMPORTED_MODULE_2_osg_osg__["default"];
OSG.osgAnimation = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_osgAnimation__["a" /* default */];
OSG.osgDB = __WEBPACK_IMPORTED_MODULE_4_osgDB_osgDB__["a" /* default */];
OSG.osgGA = __WEBPACK_IMPORTED_MODULE_5_osgGA_osgGA__["a" /* default */];
OSG.osgUtil = __WEBPACK_IMPORTED_MODULE_6_osgUtil_osgUtil__["a" /* default */];
OSG.osgViewer = __WEBPACK_IMPORTED_MODULE_7_osgViewer_osgViewer__["a" /* default */];
OSG.osgShader = __WEBPACK_IMPORTED_MODULE_8_osgShader_osgShader__["default"];
OSG.osgShadow = __WEBPACK_IMPORTED_MODULE_9_osgShadow_osgShadow__["a" /* default */];
OSG.osgStats = __WEBPACK_IMPORTED_MODULE_10_osgStats_osgStats__["a" /* default */];
OSG.osgText = __WEBPACK_IMPORTED_MODULE_11_osgText_osgText__["a" /* default */];
OSG.osgWrappers = __WEBPACK_IMPORTED_MODULE_12_osgWrappers_osgWrappers__["a" /* default */];
OSG.osgPlugins = __WEBPACK_IMPORTED_MODULE_13_osgPlugins_osgPlugins__["a" /* default */];

// for backward compatibility
OSG.globalify = function() {
    window.osg = OSG.osg;
    window.osgAnimation = OSG.osgAnimation;
    window.osgDB = OSG.osgDB;
    window.osgGA = OSG.osgGA;
    window.osgUtil = OSG.osgUtil;
    window.osgViewer = OSG.osgViewer;
    window.osgShader = OSG.osgShader;
    window.osgShadow = OSG.osgShadow;
    window.osgStats = OSG.osgStats;
    window.osgText = OSG.osgText;
    window.osgWrappers = OSG.osgWrappers;
    window.osgPlugins = OSG.osgPlugins;
};



/* harmony default export */ __webpack_exports__["default"] = (OSG);


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// This file contains needed polyfills mainly for IE11
if (!Math.sign) {
    Math.sign = function(a) {
        return a > 0.0 ? 1.0 : a < 0.0 ? -1.0 : 0.0;
    };
}

if (!Math.log2) {
    Math.log2 = function(x) {
        return Math.log(x) * Math.LOG2E;
    };
}

if (!Math.log10) {
    Math.log10 = function(x) {
        return Math.log(x) * Math.LOG10E;
    };
}

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(str) {
        return this.slice(-str.length) === str;
    };
}

if (!String.prototype.startsWith) {
    String.prototype.startsWith = function(str) {
        return this.slice(0, str.length) === str;
    };
}

if (!Float32Array.prototype.slice) {
    var _slicePolyfill = function(start, end) {
        return new this.constructor(this.subarray(start, end));
    };

    Int8Array.prototype.slice = _slicePolyfill;
    Uint8Array.prototype.slice = _slicePolyfill;
    Uint8ClampedArray.prototype.slice = _slicePolyfill;
    Int16Array.prototype.slice = _slicePolyfill;
    Uint16Array.prototype.slice = _slicePolyfill;
    Int32Array.prototype.slice = _slicePolyfill;
    Uint32Array.prototype.slice = _slicePolyfill;
    Float32Array.prototype.slice = _slicePolyfill;
    Float64Array.prototype.slice = _slicePolyfill;
}

(function() {
    // prevent crash on old browser
    if (!window.Set) return;
    // IE11 does not support Set with constructing arguments. May 2017.
    var setTest = new window.Set(['test']);
    var hasConstructorParameterSupport = setTest.has('test');
    if (hasConstructorParameterSupport) return;

    var nativeSetConstructor = window.Set;
    window.Set = function(init) {
        var set = new nativeSetConstructor();
        if (init) {
            for (var i = 0; i < init.length; ++i) {
                set.add(init[i]);
            }
        }
        return set;
    };
})();


/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports = {"devDependencies":{"chai":"^3.5.0","eslint":"4.1.1","eslint-config-google":"^0.8.0","eslint-config-standard":"^10.2.1","eslint-plugin-import":"^2.6.0","eslint-plugin-node":"^5.1.0","eslint-plugin-prettier":"^2.3.1","eslint-plugin-promise":"^3.5.0","eslint-plugin-standard":"^3.0.1","eslint-plugin-private-variables":"*","grunt-contrib-connect":"~0.9","grunt-documentation":"*","grunt-execute":"^0.2.2","grunt-plato":"~0.2.1","grunt-release":"^0.10.0","grunt-update-submodules":"^0.4.1","jsdom":"11.0.0","jsdom-global":"3.0.2","mocha":"^2.5.3"},"peerDependencies":{"grunt":">=0.4.0"},"dependencies":{"bluebird":"^3.0.5","d3":"^4.9.1","dagre":"^0.7.4","dat.gui":"dataarts/dat.gui#v0.6.4","extend":"*","gl-matrix":"2.3.2","glob":"*","grunt":"> 1.0.0","grunt-contrib-clean":"*","grunt-contrib-copy":"*","grunt-contrib-uglify":"^3.1.0","grunt-eslint":"^20.1.0","grunt-git":"*","grunt-shell":"*","grunt-webpack":"^3.0.2","hammerjs":"^2.0.8","jquery":"^2.2.4","json-loader":"^0.5.4","path":"^0.11.14","prettier":"^1.7.0","raw-loader":"^0.5.1","webpack":"^3.7.1","webpack-dev-server":"^2.9.2","webpack-strip-block":"^0.2.0","zlibjs":"^0.3.1"},"contributors":["Paul Cheyrou-Lagrèze <tuan.kuranes@gmail.com>","Jordi Torres <jtorresfabra@gmail.com>","Matt Fontaine <tehqin@gmail.com>","Stephane Ginier <stephane.ginier@gmail.com>"],"version":"0.2.7","author":"Cedric Pinson <trigrou@trigrou.com> (http://cedricpinson.com)","license":"MIT","description":"OpenSceneGraph implementation in javascript","repository":{"url":"git@github.com:cedricpinson/osgjs.git","type":"git"},"name":"OpenSceneGraph"}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * @fileoverview gl-matrix - High performance matrix and vector operations
 * @author Brandon Jones
 * @author Colin MacKenzie IV
 * @version 2.3.2
 */

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */
// END HEADER

exports.glMatrix = __webpack_require__(27);
exports.mat2 = __webpack_require__(180);
exports.mat2d = __webpack_require__(181);
exports.mat3 = __webpack_require__(105);
exports.mat4 = __webpack_require__(182);
exports.quat = __webpack_require__(183);
exports.vec2 = __webpack_require__(184);
exports.vec3 = __webpack_require__(106);
exports.vec4 = __webpack_require__(107);

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 2x2 Matrix
 * @name mat2
 */
var mat2 = {};

/**
 * Creates a new identity mat2
 *
 * @returns {mat2} a new 2x2 matrix
 */
mat2.create = function() {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};

/**
 * Creates a new mat2 initialized with values from an existing matrix
 *
 * @param {mat2} a matrix to clone
 * @returns {mat2} a new 2x2 matrix
 */
mat2.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};

/**
 * Copy the values from one mat2 to another
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
mat2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    return out;
};

/**
 * Set a mat2 to the identity matrix
 *
 * @param {mat2} out the receiving matrix
 * @returns {mat2} out
 */
mat2.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};

/**
 * Create a new mat2 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out A new 2x2 matrix
 */
mat2.fromValues = function(m00, m01, m10, m11) {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
};

/**
 * Set the components of a mat2 to the given values
 *
 * @param {mat2} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m10 Component in column 1, row 0 position (index 2)
 * @param {Number} m11 Component in column 1, row 1 position (index 3)
 * @returns {mat2} out
 */
mat2.set = function(out, m00, m01, m10, m11) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m10;
    out[3] = m11;
    return out;
};


/**
 * Transpose the values of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
mat2.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a1 = a[1];
        out[1] = a[2];
        out[2] = a1;
    } else {
        out[0] = a[0];
        out[1] = a[2];
        out[2] = a[1];
        out[3] = a[3];
    }
    
    return out;
};

/**
 * Inverts a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
mat2.invert = function(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],

        // Calculate the determinant
        det = a0 * a3 - a2 * a1;

    if (!det) {
        return null;
    }
    det = 1.0 / det;
    
    out[0] =  a3 * det;
    out[1] = -a1 * det;
    out[2] = -a2 * det;
    out[3] =  a0 * det;

    return out;
};

/**
 * Calculates the adjugate of a mat2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the source matrix
 * @returns {mat2} out
 */
mat2.adjoint = function(out, a) {
    // Caching this value is nessecary if out == a
    var a0 = a[0];
    out[0] =  a[3];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] =  a0;

    return out;
};

/**
 * Calculates the determinant of a mat2
 *
 * @param {mat2} a the source matrix
 * @returns {Number} determinant of a
 */
mat2.determinant = function (a) {
    return a[0] * a[3] - a[2] * a[1];
};

/**
 * Multiplies two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
mat2.multiply = function (out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    return out;
};

/**
 * Alias for {@link mat2.multiply}
 * @function
 */
mat2.mul = mat2.multiply;

/**
 * Rotates a mat2 by the given angle
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
mat2.rotate = function (out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
        s = Math.sin(rad),
        c = Math.cos(rad);
    out[0] = a0 *  c + a2 * s;
    out[1] = a1 *  c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    return out;
};

/**
 * Scales the mat2 by the dimensions in the given vec2
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to rotate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2} out
 **/
mat2.scale = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
        v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    return out;
};

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.rotate(dest, dest, rad);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2} out
 */
mat2.fromRotation = function(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2.identity(dest);
 *     mat2.scale(dest, dest, vec);
 *
 * @param {mat2} out mat2 receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat2} out
 */
mat2.fromScaling = function(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    return out;
}

/**
 * Returns a string representation of a mat2
 *
 * @param {mat2} mat matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
mat2.str = function (a) {
    return 'mat2(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
};

/**
 * Returns Frobenius norm of a mat2
 *
 * @param {mat2} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
mat2.frob = function (a) {
    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2)))
};

/**
 * Returns L, D and U matrices (Lower triangular, Diagonal and Upper triangular) by factorizing the input matrix
 * @param {mat2} L the lower triangular matrix 
 * @param {mat2} D the diagonal matrix 
 * @param {mat2} U the upper triangular matrix 
 * @param {mat2} a the input matrix to factorize
 */

mat2.LDU = function (L, D, U, a) { 
    L[2] = a[2]/a[0]; 
    U[0] = a[0]; 
    U[1] = a[1]; 
    U[3] = a[3] - L[2] * U[1]; 
    return [L, D, U];       
}; 

/**
 * Adds two mat2's
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
mat2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    return out;
};

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @returns {mat2} out
 */
mat2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    return out;
};

/**
 * Alias for {@link mat2.subtract}
 * @function
 */
mat2.sub = mat2.subtract;

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat2.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3];
};

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat2} a The first matrix.
 * @param {mat2} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat2.equals = function (a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)));
};

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2} out the receiving matrix
 * @param {mat2} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2} out
 */
mat2.multiplyScalar = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    return out;
};

/**
 * Adds two mat2's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2} out the receiving vector
 * @param {mat2} a the first operand
 * @param {mat2} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2} out
 */
mat2.multiplyScalarAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    return out;
};

module.exports = mat2;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 2x3 Matrix
 * @name mat2d
 * 
 * @description 
 * A mat2d contains six elements defined as:
 * <pre>
 * [a, c, tx,
 *  b, d, ty]
 * </pre>
 * This is a short form for the 3x3 matrix:
 * <pre>
 * [a, c, tx,
 *  b, d, ty,
 *  0, 0, 1]
 * </pre>
 * The last row is ignored so the array is shorter and operations are faster.
 */
var mat2d = {};

/**
 * Creates a new identity mat2d
 *
 * @returns {mat2d} a new 2x3 matrix
 */
mat2d.create = function() {
    var out = new glMatrix.ARRAY_TYPE(6);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
};

/**
 * Creates a new mat2d initialized with values from an existing matrix
 *
 * @param {mat2d} a matrix to clone
 * @returns {mat2d} a new 2x3 matrix
 */
mat2d.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(6);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
};

/**
 * Copy the values from one mat2d to another
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */
mat2d.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    return out;
};

/**
 * Set a mat2d to the identity matrix
 *
 * @param {mat2d} out the receiving matrix
 * @returns {mat2d} out
 */
mat2d.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = 0;
    out[5] = 0;
    return out;
};

/**
 * Create a new mat2d with the given values
 *
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} A new mat2d
 */
mat2d.fromValues = function(a, b, c, d, tx, ty) {
    var out = new glMatrix.ARRAY_TYPE(6);
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
};

/**
 * Set the components of a mat2d to the given values
 *
 * @param {mat2d} out the receiving matrix
 * @param {Number} a Component A (index 0)
 * @param {Number} b Component B (index 1)
 * @param {Number} c Component C (index 2)
 * @param {Number} d Component D (index 3)
 * @param {Number} tx Component TX (index 4)
 * @param {Number} ty Component TY (index 5)
 * @returns {mat2d} out
 */
mat2d.set = function(out, a, b, c, d, tx, ty) {
    out[0] = a;
    out[1] = b;
    out[2] = c;
    out[3] = d;
    out[4] = tx;
    out[5] = ty;
    return out;
};

/**
 * Inverts a mat2d
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the source matrix
 * @returns {mat2d} out
 */
mat2d.invert = function(out, a) {
    var aa = a[0], ab = a[1], ac = a[2], ad = a[3],
        atx = a[4], aty = a[5];

    var det = aa * ad - ab * ac;
    if(!det){
        return null;
    }
    det = 1.0 / det;

    out[0] = ad * det;
    out[1] = -ab * det;
    out[2] = -ac * det;
    out[3] = aa * det;
    out[4] = (ac * aty - ad * atx) * det;
    out[5] = (ab * atx - aa * aty) * det;
    return out;
};

/**
 * Calculates the determinant of a mat2d
 *
 * @param {mat2d} a the source matrix
 * @returns {Number} determinant of a
 */
mat2d.determinant = function (a) {
    return a[0] * a[3] - a[1] * a[2];
};

/**
 * Multiplies two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
mat2d.multiply = function (out, a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
        b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    out[0] = a0 * b0 + a2 * b1;
    out[1] = a1 * b0 + a3 * b1;
    out[2] = a0 * b2 + a2 * b3;
    out[3] = a1 * b2 + a3 * b3;
    out[4] = a0 * b4 + a2 * b5 + a4;
    out[5] = a1 * b4 + a3 * b5 + a5;
    return out;
};

/**
 * Alias for {@link mat2d.multiply}
 * @function
 */
mat2d.mul = mat2d.multiply;

/**
 * Rotates a mat2d by the given angle
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */
mat2d.rotate = function (out, a, rad) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
        s = Math.sin(rad),
        c = Math.cos(rad);
    out[0] = a0 *  c + a2 * s;
    out[1] = a1 *  c + a3 * s;
    out[2] = a0 * -s + a2 * c;
    out[3] = a1 * -s + a3 * c;
    out[4] = a4;
    out[5] = a5;
    return out;
};

/**
 * Scales the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to scale the matrix by
 * @returns {mat2d} out
 **/
mat2d.scale = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
        v0 = v[0], v1 = v[1];
    out[0] = a0 * v0;
    out[1] = a1 * v0;
    out[2] = a2 * v1;
    out[3] = a3 * v1;
    out[4] = a4;
    out[5] = a5;
    return out;
};

/**
 * Translates the mat2d by the dimensions in the given vec2
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to translate
 * @param {vec2} v the vec2 to translate the matrix by
 * @returns {mat2d} out
 **/
mat2d.translate = function(out, a, v) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5],
        v0 = v[0], v1 = v[1];
    out[0] = a0;
    out[1] = a1;
    out[2] = a2;
    out[3] = a3;
    out[4] = a0 * v0 + a2 * v1 + a4;
    out[5] = a1 * v0 + a3 * v1 + a5;
    return out;
};

/**
 * Creates a matrix from a given angle
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.rotate(dest, dest, rad);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat2d} out
 */
mat2d.fromRotation = function(out, rad) {
    var s = Math.sin(rad), c = Math.cos(rad);
    out[0] = c;
    out[1] = s;
    out[2] = -s;
    out[3] = c;
    out[4] = 0;
    out[5] = 0;
    return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.scale(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {vec2} v Scaling vector
 * @returns {mat2d} out
 */
mat2d.fromScaling = function(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = v[1];
    out[4] = 0;
    out[5] = 0;
    return out;
}

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat2d.identity(dest);
 *     mat2d.translate(dest, dest, vec);
 *
 * @param {mat2d} out mat2d receiving operation result
 * @param {vec2} v Translation vector
 * @returns {mat2d} out
 */
mat2d.fromTranslation = function(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    out[4] = v[0];
    out[5] = v[1];
    return out;
}

/**
 * Returns a string representation of a mat2d
 *
 * @param {mat2d} a matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
mat2d.str = function (a) {
    return 'mat2d(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + 
                    a[3] + ', ' + a[4] + ', ' + a[5] + ')';
};

/**
 * Returns Frobenius norm of a mat2d
 *
 * @param {mat2d} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
mat2d.frob = function (a) { 
    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + 1))
}; 

/**
 * Adds two mat2d's
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
mat2d.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    return out;
};

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @returns {mat2d} out
 */
mat2d.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    return out;
};

/**
 * Alias for {@link mat2d.subtract}
 * @function
 */
mat2d.sub = mat2d.subtract;

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat2d} out the receiving matrix
 * @param {mat2d} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat2d} out
 */
mat2d.multiplyScalar = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    return out;
};

/**
 * Adds two mat2d's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat2d} out the receiving vector
 * @param {mat2d} a the first operand
 * @param {mat2d} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat2d} out
 */
mat2d.multiplyScalarAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    out[4] = a[4] + (b[4] * scale);
    out[5] = a[5] + (b[5] * scale);
    return out;
};

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat2d} a The first matrix.
 * @param {mat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat2d.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && a[4] === b[4] && a[5] === b[5];
};

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat2d} a The first matrix.
 * @param {mat2d} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat2d.equals = function (a, b) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3], a4 = a[4], a5 = a[5];
    var b0 = b[0], b1 = b[1], b2 = b[2], b3 = b[3], b4 = b[4], b5 = b[5];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)));
};

module.exports = mat2d;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 4x4 Matrix
 * @name mat4
 */
var mat4 = {
  scalar: {},
  SIMD: {},
};

/**
 * Creates a new identity mat4
 *
 * @returns {mat4} a new 4x4 matrix
 */
mat4.create = function() {
    var out = new glMatrix.ARRAY_TYPE(16);
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};

/**
 * Creates a new mat4 initialized with values from an existing matrix
 *
 * @param {mat4} a matrix to clone
 * @returns {mat4} a new 4x4 matrix
 */
mat4.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(16);
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/**
 * Copy the values from one mat4 to another
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    out[2] = a[2];
    out[3] = a[3];
    out[4] = a[4];
    out[5] = a[5];
    out[6] = a[6];
    out[7] = a[7];
    out[8] = a[8];
    out[9] = a[9];
    out[10] = a[10];
    out[11] = a[11];
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/**
 * Create a new mat4 with the given values
 *
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} A new mat4
 */
mat4.fromValues = function(m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    var out = new glMatrix.ARRAY_TYPE(16);
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
};

/**
 * Set the components of a mat4 to the given values
 *
 * @param {mat4} out the receiving matrix
 * @param {Number} m00 Component in column 0, row 0 position (index 0)
 * @param {Number} m01 Component in column 0, row 1 position (index 1)
 * @param {Number} m02 Component in column 0, row 2 position (index 2)
 * @param {Number} m03 Component in column 0, row 3 position (index 3)
 * @param {Number} m10 Component in column 1, row 0 position (index 4)
 * @param {Number} m11 Component in column 1, row 1 position (index 5)
 * @param {Number} m12 Component in column 1, row 2 position (index 6)
 * @param {Number} m13 Component in column 1, row 3 position (index 7)
 * @param {Number} m20 Component in column 2, row 0 position (index 8)
 * @param {Number} m21 Component in column 2, row 1 position (index 9)
 * @param {Number} m22 Component in column 2, row 2 position (index 10)
 * @param {Number} m23 Component in column 2, row 3 position (index 11)
 * @param {Number} m30 Component in column 3, row 0 position (index 12)
 * @param {Number} m31 Component in column 3, row 1 position (index 13)
 * @param {Number} m32 Component in column 3, row 2 position (index 14)
 * @param {Number} m33 Component in column 3, row 3 position (index 15)
 * @returns {mat4} out
 */
mat4.set = function(out, m00, m01, m02, m03, m10, m11, m12, m13, m20, m21, m22, m23, m30, m31, m32, m33) {
    out[0] = m00;
    out[1] = m01;
    out[2] = m02;
    out[3] = m03;
    out[4] = m10;
    out[5] = m11;
    out[6] = m12;
    out[7] = m13;
    out[8] = m20;
    out[9] = m21;
    out[10] = m22;
    out[11] = m23;
    out[12] = m30;
    out[13] = m31;
    out[14] = m32;
    out[15] = m33;
    return out;
};


/**
 * Set a mat4 to the identity matrix
 *
 * @param {mat4} out the receiving matrix
 * @returns {mat4} out
 */
mat4.identity = function(out) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
};

/**
 * Transpose the values of a mat4 not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.scalar.transpose = function(out, a) {
    // If we are transposing ourselves we can skip a few steps but have to cache some values
    if (out === a) {
        var a01 = a[1], a02 = a[2], a03 = a[3],
            a12 = a[6], a13 = a[7],
            a23 = a[11];

        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a01;
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a02;
        out[9] = a12;
        out[11] = a[14];
        out[12] = a03;
        out[13] = a13;
        out[14] = a23;
    } else {
        out[0] = a[0];
        out[1] = a[4];
        out[2] = a[8];
        out[3] = a[12];
        out[4] = a[1];
        out[5] = a[5];
        out[6] = a[9];
        out[7] = a[13];
        out[8] = a[2];
        out[9] = a[6];
        out[10] = a[10];
        out[11] = a[14];
        out[12] = a[3];
        out[13] = a[7];
        out[14] = a[11];
        out[15] = a[15];
    }

    return out;
};

/**
 * Transpose the values of a mat4 using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.SIMD.transpose = function(out, a) {
    var a0, a1, a2, a3,
        tmp01, tmp23,
        out0, out1, out2, out3;

    a0 = SIMD.Float32x4.load(a, 0);
    a1 = SIMD.Float32x4.load(a, 4);
    a2 = SIMD.Float32x4.load(a, 8);
    a3 = SIMD.Float32x4.load(a, 12);

    tmp01 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
    tmp23 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
    out0  = SIMD.Float32x4.shuffle(tmp01, tmp23, 0, 2, 4, 6);
    out1  = SIMD.Float32x4.shuffle(tmp01, tmp23, 1, 3, 5, 7);
    SIMD.Float32x4.store(out, 0,  out0);
    SIMD.Float32x4.store(out, 4,  out1);

    tmp01 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
    tmp23 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
    out2  = SIMD.Float32x4.shuffle(tmp01, tmp23, 0, 2, 4, 6);
    out3  = SIMD.Float32x4.shuffle(tmp01, tmp23, 1, 3, 5, 7);
    SIMD.Float32x4.store(out, 8,  out2);
    SIMD.Float32x4.store(out, 12, out3);

    return out;
};

/**
 * Transpse a mat4 using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.transpose = glMatrix.USE_SIMD ? mat4.SIMD.transpose : mat4.scalar.transpose;

/**
 * Inverts a mat4 not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.scalar.invert = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32,

        // Calculate the determinant
        det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;

    if (!det) {
        return null;
    }
    det = 1.0 / det;

    out[0] = (a11 * b11 - a12 * b10 + a13 * b09) * det;
    out[1] = (a02 * b10 - a01 * b11 - a03 * b09) * det;
    out[2] = (a31 * b05 - a32 * b04 + a33 * b03) * det;
    out[3] = (a22 * b04 - a21 * b05 - a23 * b03) * det;
    out[4] = (a12 * b08 - a10 * b11 - a13 * b07) * det;
    out[5] = (a00 * b11 - a02 * b08 + a03 * b07) * det;
    out[6] = (a32 * b02 - a30 * b05 - a33 * b01) * det;
    out[7] = (a20 * b05 - a22 * b02 + a23 * b01) * det;
    out[8] = (a10 * b10 - a11 * b08 + a13 * b06) * det;
    out[9] = (a01 * b08 - a00 * b10 - a03 * b06) * det;
    out[10] = (a30 * b04 - a31 * b02 + a33 * b00) * det;
    out[11] = (a21 * b02 - a20 * b04 - a23 * b00) * det;
    out[12] = (a11 * b07 - a10 * b09 - a12 * b06) * det;
    out[13] = (a00 * b09 - a01 * b07 + a02 * b06) * det;
    out[14] = (a31 * b01 - a30 * b03 - a32 * b00) * det;
    out[15] = (a20 * b03 - a21 * b01 + a22 * b00) * det;

    return out;
};

/**
 * Inverts a mat4 using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.SIMD.invert = function(out, a) {
  var row0, row1, row2, row3,
      tmp1,
      minor0, minor1, minor2, minor3,
      det,
      a0 = SIMD.Float32x4.load(a, 0),
      a1 = SIMD.Float32x4.load(a, 4),
      a2 = SIMD.Float32x4.load(a, 8),
      a3 = SIMD.Float32x4.load(a, 12);

  // Compute matrix adjugate
  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
  row1 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
  row0 = SIMD.Float32x4.shuffle(tmp1, row1, 0, 2, 4, 6);
  row1 = SIMD.Float32x4.shuffle(row1, tmp1, 1, 3, 5, 7);
  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
  row3 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
  row2 = SIMD.Float32x4.shuffle(tmp1, row3, 0, 2, 4, 6);
  row3 = SIMD.Float32x4.shuffle(row3, tmp1, 1, 3, 5, 7);

  tmp1   = SIMD.Float32x4.mul(row2, row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor0 = SIMD.Float32x4.mul(row1, tmp1);
  minor1 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row1, tmp1), minor0);
  minor1 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor1);
  minor1 = SIMD.Float32x4.swizzle(minor1, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(row1, row2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor0);
  minor3 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row3, tmp1));
  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor3);
  minor3 = SIMD.Float32x4.swizzle(minor3, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(row1, 2, 3, 0, 1), row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  row2   = SIMD.Float32x4.swizzle(row2, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor0);
  minor2 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row2, tmp1));
  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor2);
  minor2 = SIMD.Float32x4.swizzle(minor2, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(row0, row1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor2);
  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row2, tmp1), minor3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row3, tmp1), minor2);
  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row2, tmp1));

  tmp1   = SIMD.Float32x4.mul(row0, row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row2, tmp1));
  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor1);
  minor2 = SIMD.Float32x4.sub(minor2, SIMD.Float32x4.mul(row1, tmp1));

  tmp1   = SIMD.Float32x4.mul(row0, row2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor1);
  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row1, tmp1));
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row3, tmp1));
  minor3 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor3);

  // Compute matrix determinant
  det   = SIMD.Float32x4.mul(row0, minor0);
  det   = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(det, 2, 3, 0, 1), det);
  det   = SIMD.Float32x4.add(SIMD.Float32x4.swizzle(det, 1, 0, 3, 2), det);
  tmp1  = SIMD.Float32x4.reciprocalApproximation(det);
  det   = SIMD.Float32x4.sub(
               SIMD.Float32x4.add(tmp1, tmp1),
               SIMD.Float32x4.mul(det, SIMD.Float32x4.mul(tmp1, tmp1)));
  det   = SIMD.Float32x4.swizzle(det, 0, 0, 0, 0);
  if (!det) {
      return null;
  }

  // Compute matrix inverse
  SIMD.Float32x4.store(out, 0,  SIMD.Float32x4.mul(det, minor0));
  SIMD.Float32x4.store(out, 4,  SIMD.Float32x4.mul(det, minor1));
  SIMD.Float32x4.store(out, 8,  SIMD.Float32x4.mul(det, minor2));
  SIMD.Float32x4.store(out, 12, SIMD.Float32x4.mul(det, minor3));
  return out;
}

/**
 * Inverts a mat4 using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.invert = glMatrix.USE_SIMD ? mat4.SIMD.invert : mat4.scalar.invert;

/**
 * Calculates the adjugate of a mat4 not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.scalar.adjoint = function(out, a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

    out[0]  =  (a11 * (a22 * a33 - a23 * a32) - a21 * (a12 * a33 - a13 * a32) + a31 * (a12 * a23 - a13 * a22));
    out[1]  = -(a01 * (a22 * a33 - a23 * a32) - a21 * (a02 * a33 - a03 * a32) + a31 * (a02 * a23 - a03 * a22));
    out[2]  =  (a01 * (a12 * a33 - a13 * a32) - a11 * (a02 * a33 - a03 * a32) + a31 * (a02 * a13 - a03 * a12));
    out[3]  = -(a01 * (a12 * a23 - a13 * a22) - a11 * (a02 * a23 - a03 * a22) + a21 * (a02 * a13 - a03 * a12));
    out[4]  = -(a10 * (a22 * a33 - a23 * a32) - a20 * (a12 * a33 - a13 * a32) + a30 * (a12 * a23 - a13 * a22));
    out[5]  =  (a00 * (a22 * a33 - a23 * a32) - a20 * (a02 * a33 - a03 * a32) + a30 * (a02 * a23 - a03 * a22));
    out[6]  = -(a00 * (a12 * a33 - a13 * a32) - a10 * (a02 * a33 - a03 * a32) + a30 * (a02 * a13 - a03 * a12));
    out[7]  =  (a00 * (a12 * a23 - a13 * a22) - a10 * (a02 * a23 - a03 * a22) + a20 * (a02 * a13 - a03 * a12));
    out[8]  =  (a10 * (a21 * a33 - a23 * a31) - a20 * (a11 * a33 - a13 * a31) + a30 * (a11 * a23 - a13 * a21));
    out[9]  = -(a00 * (a21 * a33 - a23 * a31) - a20 * (a01 * a33 - a03 * a31) + a30 * (a01 * a23 - a03 * a21));
    out[10] =  (a00 * (a11 * a33 - a13 * a31) - a10 * (a01 * a33 - a03 * a31) + a30 * (a01 * a13 - a03 * a11));
    out[11] = -(a00 * (a11 * a23 - a13 * a21) - a10 * (a01 * a23 - a03 * a21) + a20 * (a01 * a13 - a03 * a11));
    out[12] = -(a10 * (a21 * a32 - a22 * a31) - a20 * (a11 * a32 - a12 * a31) + a30 * (a11 * a22 - a12 * a21));
    out[13] =  (a00 * (a21 * a32 - a22 * a31) - a20 * (a01 * a32 - a02 * a31) + a30 * (a01 * a22 - a02 * a21));
    out[14] = -(a00 * (a11 * a32 - a12 * a31) - a10 * (a01 * a32 - a02 * a31) + a30 * (a01 * a12 - a02 * a11));
    out[15] =  (a00 * (a11 * a22 - a12 * a21) - a10 * (a01 * a22 - a02 * a21) + a20 * (a01 * a12 - a02 * a11));
    return out;
};

/**
 * Calculates the adjugate of a mat4 using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
mat4.SIMD.adjoint = function(out, a) {
  var a0, a1, a2, a3;
  var row0, row1, row2, row3;
  var tmp1;
  var minor0, minor1, minor2, minor3;

  var a0 = SIMD.Float32x4.load(a, 0);
  var a1 = SIMD.Float32x4.load(a, 4);
  var a2 = SIMD.Float32x4.load(a, 8);
  var a3 = SIMD.Float32x4.load(a, 12);

  // Transpose the source matrix.  Sort of.  Not a true transpose operation
  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 0, 1, 4, 5);
  row1 = SIMD.Float32x4.shuffle(a2, a3, 0, 1, 4, 5);
  row0 = SIMD.Float32x4.shuffle(tmp1, row1, 0, 2, 4, 6);
  row1 = SIMD.Float32x4.shuffle(row1, tmp1, 1, 3, 5, 7);

  tmp1 = SIMD.Float32x4.shuffle(a0, a1, 2, 3, 6, 7);
  row3 = SIMD.Float32x4.shuffle(a2, a3, 2, 3, 6, 7);
  row2 = SIMD.Float32x4.shuffle(tmp1, row3, 0, 2, 4, 6);
  row3 = SIMD.Float32x4.shuffle(row3, tmp1, 1, 3, 5, 7);

  tmp1   = SIMD.Float32x4.mul(row2, row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor0 = SIMD.Float32x4.mul(row1, tmp1);
  minor1 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row1, tmp1), minor0);
  minor1 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor1);
  minor1 = SIMD.Float32x4.swizzle(minor1, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(row1, row2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor0);
  minor3 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row3, tmp1));
  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor3);
  minor3 = SIMD.Float32x4.swizzle(minor3, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(row1, 2, 3, 0, 1), row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  row2   = SIMD.Float32x4.swizzle(row2, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor0);
  minor2 = SIMD.Float32x4.mul(row0, tmp1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor0 = SIMD.Float32x4.sub(minor0, SIMD.Float32x4.mul(row2, tmp1));
  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row0, tmp1), minor2);
  minor2 = SIMD.Float32x4.swizzle(minor2, 2, 3, 0, 1);

  tmp1   = SIMD.Float32x4.mul(row0, row1);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor2);
  minor3 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row2, tmp1), minor3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor2 = SIMD.Float32x4.sub(SIMD.Float32x4.mul(row3, tmp1), minor2);
  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row2, tmp1));

  tmp1   = SIMD.Float32x4.mul(row0, row3);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row2, tmp1));
  minor2 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row2, tmp1), minor1);
  minor2 = SIMD.Float32x4.sub(minor2, SIMD.Float32x4.mul(row1, tmp1));

  tmp1   = SIMD.Float32x4.mul(row0, row2);
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 1, 0, 3, 2);
  minor1 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row3, tmp1), minor1);
  minor3 = SIMD.Float32x4.sub(minor3, SIMD.Float32x4.mul(row1, tmp1));
  tmp1   = SIMD.Float32x4.swizzle(tmp1, 2, 3, 0, 1);
  minor1 = SIMD.Float32x4.sub(minor1, SIMD.Float32x4.mul(row3, tmp1));
  minor3 = SIMD.Float32x4.add(SIMD.Float32x4.mul(row1, tmp1), minor3);

  SIMD.Float32x4.store(out, 0,  minor0);
  SIMD.Float32x4.store(out, 4,  minor1);
  SIMD.Float32x4.store(out, 8,  minor2);
  SIMD.Float32x4.store(out, 12, minor3);
  return out;
};

/**
 * Calculates the adjugate of a mat4 using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the source matrix
 * @returns {mat4} out
 */
 mat4.adjoint = glMatrix.USE_SIMD ? mat4.SIMD.adjoint : mat4.scalar.adjoint;

/**
 * Calculates the determinant of a mat4
 *
 * @param {mat4} a the source matrix
 * @returns {Number} determinant of a
 */
mat4.determinant = function (a) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15],

        b00 = a00 * a11 - a01 * a10,
        b01 = a00 * a12 - a02 * a10,
        b02 = a00 * a13 - a03 * a10,
        b03 = a01 * a12 - a02 * a11,
        b04 = a01 * a13 - a03 * a11,
        b05 = a02 * a13 - a03 * a12,
        b06 = a20 * a31 - a21 * a30,
        b07 = a20 * a32 - a22 * a30,
        b08 = a20 * a33 - a23 * a30,
        b09 = a21 * a32 - a22 * a31,
        b10 = a21 * a33 - a23 * a31,
        b11 = a22 * a33 - a23 * a32;

    // Calculate the determinant
    return b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;
};

/**
 * Multiplies two mat4's explicitly using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand, must be a Float32Array
 * @param {mat4} b the second operand, must be a Float32Array
 * @returns {mat4} out
 */
mat4.SIMD.multiply = function (out, a, b) {
    var a0 = SIMD.Float32x4.load(a, 0);
    var a1 = SIMD.Float32x4.load(a, 4);
    var a2 = SIMD.Float32x4.load(a, 8);
    var a3 = SIMD.Float32x4.load(a, 12);

    var b0 = SIMD.Float32x4.load(b, 0);
    var out0 = SIMD.Float32x4.add(
                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 0, 0, 0, 0), a0),
                   SIMD.Float32x4.add(
                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 1, 1, 1, 1), a1),
                       SIMD.Float32x4.add(
                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 2, 2, 2, 2), a2),
                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b0, 3, 3, 3, 3), a3))));
    SIMD.Float32x4.store(out, 0, out0);

    var b1 = SIMD.Float32x4.load(b, 4);
    var out1 = SIMD.Float32x4.add(
                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 0, 0, 0, 0), a0),
                   SIMD.Float32x4.add(
                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 1, 1, 1, 1), a1),
                       SIMD.Float32x4.add(
                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 2, 2, 2, 2), a2),
                           SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b1, 3, 3, 3, 3), a3))));
    SIMD.Float32x4.store(out, 4, out1);

    var b2 = SIMD.Float32x4.load(b, 8);
    var out2 = SIMD.Float32x4.add(
                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 0, 0, 0, 0), a0),
                   SIMD.Float32x4.add(
                       SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 1, 1, 1, 1), a1),
                       SIMD.Float32x4.add(
                               SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 2, 2, 2, 2), a2),
                               SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b2, 3, 3, 3, 3), a3))));
    SIMD.Float32x4.store(out, 8, out2);

    var b3 = SIMD.Float32x4.load(b, 12);
    var out3 = SIMD.Float32x4.add(
                   SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 0, 0, 0, 0), a0),
                   SIMD.Float32x4.add(
                        SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 1, 1, 1, 1), a1),
                        SIMD.Float32x4.add(
                            SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 2, 2, 2, 2), a2),
                            SIMD.Float32x4.mul(SIMD.Float32x4.swizzle(b3, 3, 3, 3, 3), a3))));
    SIMD.Float32x4.store(out, 12, out3);

    return out;
};

/**
 * Multiplies two mat4's explicitly not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
mat4.scalar.multiply = function (out, a, b) {
    var a00 = a[0], a01 = a[1], a02 = a[2], a03 = a[3],
        a10 = a[4], a11 = a[5], a12 = a[6], a13 = a[7],
        a20 = a[8], a21 = a[9], a22 = a[10], a23 = a[11],
        a30 = a[12], a31 = a[13], a32 = a[14], a33 = a[15];

    // Cache only the current line of the second matrix
    var b0  = b[0], b1 = b[1], b2 = b[2], b3 = b[3];
    out[0] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[1] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[2] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[3] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[4]; b1 = b[5]; b2 = b[6]; b3 = b[7];
    out[4] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[5] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[6] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[7] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[8]; b1 = b[9]; b2 = b[10]; b3 = b[11];
    out[8] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[9] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[10] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[11] = b0*a03 + b1*a13 + b2*a23 + b3*a33;

    b0 = b[12]; b1 = b[13]; b2 = b[14]; b3 = b[15];
    out[12] = b0*a00 + b1*a10 + b2*a20 + b3*a30;
    out[13] = b0*a01 + b1*a11 + b2*a21 + b3*a31;
    out[14] = b0*a02 + b1*a12 + b2*a22 + b3*a32;
    out[15] = b0*a03 + b1*a13 + b2*a23 + b3*a33;
    return out;
};

/**
 * Multiplies two mat4's using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
mat4.multiply = glMatrix.USE_SIMD ? mat4.SIMD.multiply : mat4.scalar.multiply;

/**
 * Alias for {@link mat4.multiply}
 * @function
 */
mat4.mul = mat4.multiply;

/**
 * Translate a mat4 by the given vector not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
mat4.scalar.translate = function (out, a, v) {
    var x = v[0], y = v[1], z = v[2],
        a00, a01, a02, a03,
        a10, a11, a12, a13,
        a20, a21, a22, a23;

    if (a === out) {
        out[12] = a[0] * x + a[4] * y + a[8] * z + a[12];
        out[13] = a[1] * x + a[5] * y + a[9] * z + a[13];
        out[14] = a[2] * x + a[6] * y + a[10] * z + a[14];
        out[15] = a[3] * x + a[7] * y + a[11] * z + a[15];
    } else {
        a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
        a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
        a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

        out[0] = a00; out[1] = a01; out[2] = a02; out[3] = a03;
        out[4] = a10; out[5] = a11; out[6] = a12; out[7] = a13;
        out[8] = a20; out[9] = a21; out[10] = a22; out[11] = a23;

        out[12] = a00 * x + a10 * y + a20 * z + a[12];
        out[13] = a01 * x + a11 * y + a21 * z + a[13];
        out[14] = a02 * x + a12 * y + a22 * z + a[14];
        out[15] = a03 * x + a13 * y + a23 * z + a[15];
    }

    return out;
};

/**
 * Translates a mat4 by the given vector using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
mat4.SIMD.translate = function (out, a, v) {
    var a0 = SIMD.Float32x4.load(a, 0),
        a1 = SIMD.Float32x4.load(a, 4),
        a2 = SIMD.Float32x4.load(a, 8),
        a3 = SIMD.Float32x4.load(a, 12),
        vec = SIMD.Float32x4(v[0], v[1], v[2] , 0);

    if (a !== out) {
        out[0] = a[0]; out[1] = a[1]; out[2] = a[2]; out[3] = a[3];
        out[4] = a[4]; out[5] = a[5]; out[6] = a[6]; out[7] = a[7];
        out[8] = a[8]; out[9] = a[9]; out[10] = a[10]; out[11] = a[11];
    }

    a0 = SIMD.Float32x4.mul(a0, SIMD.Float32x4.swizzle(vec, 0, 0, 0, 0));
    a1 = SIMD.Float32x4.mul(a1, SIMD.Float32x4.swizzle(vec, 1, 1, 1, 1));
    a2 = SIMD.Float32x4.mul(a2, SIMD.Float32x4.swizzle(vec, 2, 2, 2, 2));

    var t0 = SIMD.Float32x4.add(a0, SIMD.Float32x4.add(a1, SIMD.Float32x4.add(a2, a3)));
    SIMD.Float32x4.store(out, 12, t0);

    return out;
};

/**
 * Translates a mat4 by the given vector using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to translate
 * @param {vec3} v vector to translate by
 * @returns {mat4} out
 */
mat4.translate = glMatrix.USE_SIMD ? mat4.SIMD.translate : mat4.scalar.translate;

/**
 * Scales the mat4 by the dimensions in the given vec3 not using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/
mat4.scalar.scale = function(out, a, v) {
    var x = v[0], y = v[1], z = v[2];

    out[0] = a[0] * x;
    out[1] = a[1] * x;
    out[2] = a[2] * x;
    out[3] = a[3] * x;
    out[4] = a[4] * y;
    out[5] = a[5] * y;
    out[6] = a[6] * y;
    out[7] = a[7] * y;
    out[8] = a[8] * z;
    out[9] = a[9] * z;
    out[10] = a[10] * z;
    out[11] = a[11] * z;
    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/**
 * Scales the mat4 by the dimensions in the given vec3 using vectorization
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 **/
mat4.SIMD.scale = function(out, a, v) {
    var a0, a1, a2;
    var vec = SIMD.Float32x4(v[0], v[1], v[2], 0);

    a0 = SIMD.Float32x4.load(a, 0);
    SIMD.Float32x4.store(
        out, 0, SIMD.Float32x4.mul(a0, SIMD.Float32x4.swizzle(vec, 0, 0, 0, 0)));

    a1 = SIMD.Float32x4.load(a, 4);
    SIMD.Float32x4.store(
        out, 4, SIMD.Float32x4.mul(a1, SIMD.Float32x4.swizzle(vec, 1, 1, 1, 1)));

    a2 = SIMD.Float32x4.load(a, 8);
    SIMD.Float32x4.store(
        out, 8, SIMD.Float32x4.mul(a2, SIMD.Float32x4.swizzle(vec, 2, 2, 2, 2)));

    out[12] = a[12];
    out[13] = a[13];
    out[14] = a[14];
    out[15] = a[15];
    return out;
};

/**
 * Scales the mat4 by the dimensions in the given vec3 using SIMD if available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {vec3} v the vec3 to scale the matrix by
 * @returns {mat4} out
 */
mat4.scale = glMatrix.USE_SIMD ? mat4.SIMD.scale : mat4.scalar.scale;

/**
 * Rotates a mat4 by the given angle around the given axis
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
mat4.rotate = function (out, a, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2],
        len = Math.sqrt(x * x + y * y + z * z),
        s, c, t,
        a00, a01, a02, a03,
        a10, a11, a12, a13,
        a20, a21, a22, a23,
        b00, b01, b02,
        b10, b11, b12,
        b20, b21, b22;

    if (Math.abs(len) < glMatrix.EPSILON) { return null; }

    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;

    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;

    a00 = a[0]; a01 = a[1]; a02 = a[2]; a03 = a[3];
    a10 = a[4]; a11 = a[5]; a12 = a[6]; a13 = a[7];
    a20 = a[8]; a21 = a[9]; a22 = a[10]; a23 = a[11];

    // Construct the elements of the rotation matrix
    b00 = x * x * t + c; b01 = y * x * t + z * s; b02 = z * x * t - y * s;
    b10 = x * y * t - z * s; b11 = y * y * t + c; b12 = z * y * t + x * s;
    b20 = x * z * t + y * s; b21 = y * z * t - x * s; b22 = z * z * t + c;

    // Perform rotation-specific matrix multiplication
    out[0] = a00 * b00 + a10 * b01 + a20 * b02;
    out[1] = a01 * b00 + a11 * b01 + a21 * b02;
    out[2] = a02 * b00 + a12 * b01 + a22 * b02;
    out[3] = a03 * b00 + a13 * b01 + a23 * b02;
    out[4] = a00 * b10 + a10 * b11 + a20 * b12;
    out[5] = a01 * b10 + a11 * b11 + a21 * b12;
    out[6] = a02 * b10 + a12 * b11 + a22 * b12;
    out[7] = a03 * b10 + a13 * b11 + a23 * b12;
    out[8] = a00 * b20 + a10 * b21 + a20 * b22;
    out[9] = a01 * b20 + a11 * b21 + a21 * b22;
    out[10] = a02 * b20 + a12 * b21 + a22 * b22;
    out[11] = a03 * b20 + a13 * b21 + a23 * b22;

    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }
    return out;
};

/**
 * Rotates a matrix by the given angle around the X axis not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.scalar.rotateX = function (out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a10 = a[4],
        a11 = a[5],
        a12 = a[6],
        a13 = a[7],
        a20 = a[8],
        a21 = a[9],
        a22 = a[10],
        a23 = a[11];

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[0]  = a[0];
        out[1]  = a[1];
        out[2]  = a[2];
        out[3]  = a[3];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[4] = a10 * c + a20 * s;
    out[5] = a11 * c + a21 * s;
    out[6] = a12 * c + a22 * s;
    out[7] = a13 * c + a23 * s;
    out[8] = a20 * c - a10 * s;
    out[9] = a21 * c - a11 * s;
    out[10] = a22 * c - a12 * s;
    out[11] = a23 * c - a13 * s;
    return out;
};

/**
 * Rotates a matrix by the given angle around the X axis using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.SIMD.rotateX = function (out, a, rad) {
    var s = SIMD.Float32x4.splat(Math.sin(rad)),
        c = SIMD.Float32x4.splat(Math.cos(rad));

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
      out[0]  = a[0];
      out[1]  = a[1];
      out[2]  = a[2];
      out[3]  = a[3];
      out[12] = a[12];
      out[13] = a[13];
      out[14] = a[14];
      out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    var a_1 = SIMD.Float32x4.load(a, 4);
    var a_2 = SIMD.Float32x4.load(a, 8);
    SIMD.Float32x4.store(out, 4,
                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_1, c), SIMD.Float32x4.mul(a_2, s)));
    SIMD.Float32x4.store(out, 8,
                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_2, c), SIMD.Float32x4.mul(a_1, s)));
    return out;
};

/**
 * Rotates a matrix by the given angle around the X axis using SIMD if availabe and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.rotateX = glMatrix.USE_SIMD ? mat4.SIMD.rotateX : mat4.scalar.rotateX;

/**
 * Rotates a matrix by the given angle around the Y axis not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.scalar.rotateY = function (out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a00 = a[0],
        a01 = a[1],
        a02 = a[2],
        a03 = a[3],
        a20 = a[8],
        a21 = a[9],
        a22 = a[10],
        a23 = a[11];

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[4]  = a[4];
        out[5]  = a[5];
        out[6]  = a[6];
        out[7]  = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[0] = a00 * c - a20 * s;
    out[1] = a01 * c - a21 * s;
    out[2] = a02 * c - a22 * s;
    out[3] = a03 * c - a23 * s;
    out[8] = a00 * s + a20 * c;
    out[9] = a01 * s + a21 * c;
    out[10] = a02 * s + a22 * c;
    out[11] = a03 * s + a23 * c;
    return out;
};

/**
 * Rotates a matrix by the given angle around the Y axis using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.SIMD.rotateY = function (out, a, rad) {
    var s = SIMD.Float32x4.splat(Math.sin(rad)),
        c = SIMD.Float32x4.splat(Math.cos(rad));

    if (a !== out) { // If the source and destination differ, copy the unchanged rows
        out[4]  = a[4];
        out[5]  = a[5];
        out[6]  = a[6];
        out[7]  = a[7];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    var a_0 = SIMD.Float32x4.load(a, 0);
    var a_2 = SIMD.Float32x4.load(a, 8);
    SIMD.Float32x4.store(out, 0,
                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_0, c), SIMD.Float32x4.mul(a_2, s)));
    SIMD.Float32x4.store(out, 8,
                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_0, s), SIMD.Float32x4.mul(a_2, c)));
    return out;
};

/**
 * Rotates a matrix by the given angle around the Y axis if SIMD available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
 mat4.rotateY = glMatrix.USE_SIMD ? mat4.SIMD.rotateY : mat4.scalar.rotateY;

/**
 * Rotates a matrix by the given angle around the Z axis not using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.scalar.rotateZ = function (out, a, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad),
        a00 = a[0],
        a01 = a[1],
        a02 = a[2],
        a03 = a[3],
        a10 = a[4],
        a11 = a[5],
        a12 = a[6],
        a13 = a[7];

    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[8]  = a[8];
        out[9]  = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    out[0] = a00 * c + a10 * s;
    out[1] = a01 * c + a11 * s;
    out[2] = a02 * c + a12 * s;
    out[3] = a03 * c + a13 * s;
    out[4] = a10 * c - a00 * s;
    out[5] = a11 * c - a01 * s;
    out[6] = a12 * c - a02 * s;
    out[7] = a13 * c - a03 * s;
    return out;
};

/**
 * Rotates a matrix by the given angle around the Z axis using SIMD
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.SIMD.rotateZ = function (out, a, rad) {
    var s = SIMD.Float32x4.splat(Math.sin(rad)),
        c = SIMD.Float32x4.splat(Math.cos(rad));

    if (a !== out) { // If the source and destination differ, copy the unchanged last row
        out[8]  = a[8];
        out[9]  = a[9];
        out[10] = a[10];
        out[11] = a[11];
        out[12] = a[12];
        out[13] = a[13];
        out[14] = a[14];
        out[15] = a[15];
    }

    // Perform axis-specific matrix multiplication
    var a_0 = SIMD.Float32x4.load(a, 0);
    var a_1 = SIMD.Float32x4.load(a, 4);
    SIMD.Float32x4.store(out, 0,
                         SIMD.Float32x4.add(SIMD.Float32x4.mul(a_0, c), SIMD.Float32x4.mul(a_1, s)));
    SIMD.Float32x4.store(out, 4,
                         SIMD.Float32x4.sub(SIMD.Float32x4.mul(a_1, c), SIMD.Float32x4.mul(a_0, s)));
    return out;
};

/**
 * Rotates a matrix by the given angle around the Z axis if SIMD available and enabled
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to rotate
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
 mat4.rotateZ = glMatrix.USE_SIMD ? mat4.SIMD.rotateZ : mat4.scalar.rotateZ;

/**
 * Creates a matrix from a vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
mat4.fromTranslation = function(out, v) {
    out[0] = 1;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from a vector scaling
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.scale(dest, dest, vec);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {vec3} v Scaling vector
 * @returns {mat4} out
 */
mat4.fromScaling = function(out, v) {
    out[0] = v[0];
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = v[1];
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = v[2];
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from a given angle around a given axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotate(dest, dest, rad, axis);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @param {vec3} axis the axis to rotate around
 * @returns {mat4} out
 */
mat4.fromRotation = function(out, rad, axis) {
    var x = axis[0], y = axis[1], z = axis[2],
        len = Math.sqrt(x * x + y * y + z * z),
        s, c, t;

    if (Math.abs(len) < glMatrix.EPSILON) { return null; }

    len = 1 / len;
    x *= len;
    y *= len;
    z *= len;

    s = Math.sin(rad);
    c = Math.cos(rad);
    t = 1 - c;

    // Perform rotation-specific matrix multiplication
    out[0] = x * x * t + c;
    out[1] = y * x * t + z * s;
    out[2] = z * x * t - y * s;
    out[3] = 0;
    out[4] = x * y * t - z * s;
    out[5] = y * y * t + c;
    out[6] = z * y * t + x * s;
    out[7] = 0;
    out[8] = x * z * t + y * s;
    out[9] = y * z * t - x * s;
    out[10] = z * z * t + c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from the given angle around the X axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateX(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.fromXRotation = function(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad);

    // Perform axis-specific matrix multiplication
    out[0]  = 1;
    out[1]  = 0;
    out[2]  = 0;
    out[3]  = 0;
    out[4] = 0;
    out[5] = c;
    out[6] = s;
    out[7] = 0;
    out[8] = 0;
    out[9] = -s;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from the given angle around the Y axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateY(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.fromYRotation = function(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad);

    // Perform axis-specific matrix multiplication
    out[0]  = c;
    out[1]  = 0;
    out[2]  = -s;
    out[3]  = 0;
    out[4] = 0;
    out[5] = 1;
    out[6] = 0;
    out[7] = 0;
    out[8] = s;
    out[9] = 0;
    out[10] = c;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from the given angle around the Z axis
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.rotateZ(dest, dest, rad);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {Number} rad the angle to rotate the matrix by
 * @returns {mat4} out
 */
mat4.fromZRotation = function(out, rad) {
    var s = Math.sin(rad),
        c = Math.cos(rad);

    // Perform axis-specific matrix multiplication
    out[0]  = c;
    out[1]  = s;
    out[2]  = 0;
    out[3]  = 0;
    out[4] = -s;
    out[5] = c;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 1;
    out[11] = 0;
    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;
    return out;
}

/**
 * Creates a matrix from a quaternion rotation and vector translation
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @returns {mat4} out
 */
mat4.fromRotationTranslation = function (out, q, v) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        xy = x * y2,
        xz = x * z2,
        yy = y * y2,
        yz = y * z2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - (yy + zz);
    out[1] = xy + wz;
    out[2] = xz - wy;
    out[3] = 0;
    out[4] = xy - wz;
    out[5] = 1 - (xx + zz);
    out[6] = yz + wx;
    out[7] = 0;
    out[8] = xz + wy;
    out[9] = yz - wx;
    out[10] = 1 - (xx + yy);
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;

    return out;
};

/**
 * Returns the translation vector component of a transformation
 *  matrix. If a matrix is built with fromRotationTranslation,
 *  the returned vector will be the same as the translation vector
 *  originally supplied.
 * @param  {vec3} out Vector to receive translation component
 * @param  {mat4} mat Matrix to be decomposed (input)
 * @return {vec3} out
 */
mat4.getTranslation = function (out, mat) {
  out[0] = mat[12];
  out[1] = mat[13];
  out[2] = mat[14];

  return out;
};

/**
 * Returns a quaternion representing the rotational component
 *  of a transformation matrix. If a matrix is built with
 *  fromRotationTranslation, the returned quaternion will be the
 *  same as the quaternion originally supplied.
 * @param {quat} out Quaternion to receive the rotation component
 * @param {mat4} mat Matrix to be decomposed (input)
 * @return {quat} out
 */
mat4.getRotation = function (out, mat) {
  // Algorithm taken from http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
  var trace = mat[0] + mat[5] + mat[10];
  var S = 0;

  if (trace > 0) { 
    S = Math.sqrt(trace + 1.0) * 2;
    out[3] = 0.25 * S;
    out[0] = (mat[6] - mat[9]) / S;
    out[1] = (mat[8] - mat[2]) / S; 
    out[2] = (mat[1] - mat[4]) / S; 
  } else if ((mat[0] > mat[5])&(mat[0] > mat[10])) { 
    S = Math.sqrt(1.0 + mat[0] - mat[5] - mat[10]) * 2;
    out[3] = (mat[6] - mat[9]) / S;
    out[0] = 0.25 * S;
    out[1] = (mat[1] + mat[4]) / S; 
    out[2] = (mat[8] + mat[2]) / S; 
  } else if (mat[5] > mat[10]) { 
    S = Math.sqrt(1.0 + mat[5] - mat[0] - mat[10]) * 2;
    out[3] = (mat[8] - mat[2]) / S;
    out[0] = (mat[1] + mat[4]) / S; 
    out[1] = 0.25 * S;
    out[2] = (mat[6] + mat[9]) / S; 
  } else { 
    S = Math.sqrt(1.0 + mat[10] - mat[0] - mat[5]) * 2;
    out[3] = (mat[1] - mat[4]) / S;
    out[0] = (mat[8] + mat[2]) / S;
    out[1] = (mat[6] + mat[9]) / S;
    out[2] = 0.25 * S;
  }

  return out;
};

/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @returns {mat4} out
 */
mat4.fromRotationTranslationScale = function (out, q, v, s) {
    // Quaternion math
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        xy = x * y2,
        xz = x * z2,
        yy = y * y2,
        yz = y * z2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2,
        sx = s[0],
        sy = s[1],
        sz = s[2];

    out[0] = (1 - (yy + zz)) * sx;
    out[1] = (xy + wz) * sx;
    out[2] = (xz - wy) * sx;
    out[3] = 0;
    out[4] = (xy - wz) * sy;
    out[5] = (1 - (xx + zz)) * sy;
    out[6] = (yz + wx) * sy;
    out[7] = 0;
    out[8] = (xz + wy) * sz;
    out[9] = (yz - wx) * sz;
    out[10] = (1 - (xx + yy)) * sz;
    out[11] = 0;
    out[12] = v[0];
    out[13] = v[1];
    out[14] = v[2];
    out[15] = 1;

    return out;
};

/**
 * Creates a matrix from a quaternion rotation, vector translation and vector scale, rotating and scaling around the given origin
 * This is equivalent to (but much faster than):
 *
 *     mat4.identity(dest);
 *     mat4.translate(dest, vec);
 *     mat4.translate(dest, origin);
 *     var quatMat = mat4.create();
 *     quat4.toMat4(quat, quatMat);
 *     mat4.multiply(dest, quatMat);
 *     mat4.scale(dest, scale)
 *     mat4.translate(dest, negativeOrigin);
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat4} q Rotation quaternion
 * @param {vec3} v Translation vector
 * @param {vec3} s Scaling vector
 * @param {vec3} o The origin vector around which to scale and rotate
 * @returns {mat4} out
 */
mat4.fromRotationTranslationScaleOrigin = function (out, q, v, s, o) {
  // Quaternion math
  var x = q[0], y = q[1], z = q[2], w = q[3],
      x2 = x + x,
      y2 = y + y,
      z2 = z + z,

      xx = x * x2,
      xy = x * y2,
      xz = x * z2,
      yy = y * y2,
      yz = y * z2,
      zz = z * z2,
      wx = w * x2,
      wy = w * y2,
      wz = w * z2,

      sx = s[0],
      sy = s[1],
      sz = s[2],

      ox = o[0],
      oy = o[1],
      oz = o[2];

  out[0] = (1 - (yy + zz)) * sx;
  out[1] = (xy + wz) * sx;
  out[2] = (xz - wy) * sx;
  out[3] = 0;
  out[4] = (xy - wz) * sy;
  out[5] = (1 - (xx + zz)) * sy;
  out[6] = (yz + wx) * sy;
  out[7] = 0;
  out[8] = (xz + wy) * sz;
  out[9] = (yz - wx) * sz;
  out[10] = (1 - (xx + yy)) * sz;
  out[11] = 0;
  out[12] = v[0] + ox - (out[0] * ox + out[4] * oy + out[8] * oz);
  out[13] = v[1] + oy - (out[1] * ox + out[5] * oy + out[9] * oz);
  out[14] = v[2] + oz - (out[2] * ox + out[6] * oy + out[10] * oz);
  out[15] = 1;

  return out;
};

/**
 * Calculates a 4x4 matrix from the given quaternion
 *
 * @param {mat4} out mat4 receiving operation result
 * @param {quat} q Quaternion to create matrix from
 *
 * @returns {mat4} out
 */
mat4.fromQuat = function (out, q) {
    var x = q[0], y = q[1], z = q[2], w = q[3],
        x2 = x + x,
        y2 = y + y,
        z2 = z + z,

        xx = x * x2,
        yx = y * x2,
        yy = y * y2,
        zx = z * x2,
        zy = z * y2,
        zz = z * z2,
        wx = w * x2,
        wy = w * y2,
        wz = w * z2;

    out[0] = 1 - yy - zz;
    out[1] = yx + wz;
    out[2] = zx - wy;
    out[3] = 0;

    out[4] = yx - wz;
    out[5] = 1 - xx - zz;
    out[6] = zy + wx;
    out[7] = 0;

    out[8] = zx + wy;
    out[9] = zy - wx;
    out[10] = 1 - xx - yy;
    out[11] = 0;

    out[12] = 0;
    out[13] = 0;
    out[14] = 0;
    out[15] = 1;

    return out;
};

/**
 * Generates a frustum matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Number} left Left bound of the frustum
 * @param {Number} right Right bound of the frustum
 * @param {Number} bottom Bottom bound of the frustum
 * @param {Number} top Top bound of the frustum
 * @param {Number} near Near bound of the frustum
 * @param {Number} far Far bound of the frustum
 * @returns {mat4} out
 */
mat4.frustum = function (out, left, right, bottom, top, near, far) {
    var rl = 1 / (right - left),
        tb = 1 / (top - bottom),
        nf = 1 / (near - far);
    out[0] = (near * 2) * rl;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = (near * 2) * tb;
    out[6] = 0;
    out[7] = 0;
    out[8] = (right + left) * rl;
    out[9] = (top + bottom) * tb;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (far * near * 2) * nf;
    out[15] = 0;
    return out;
};

/**
 * Generates a perspective projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} fovy Vertical field of view in radians
 * @param {number} aspect Aspect ratio. typically viewport width/height
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
mat4.perspective = function (out, fovy, aspect, near, far) {
    var f = 1.0 / Math.tan(fovy / 2),
        nf = 1 / (near - far);
    out[0] = f / aspect;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = f;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = (far + near) * nf;
    out[11] = -1;
    out[12] = 0;
    out[13] = 0;
    out[14] = (2 * far * near) * nf;
    out[15] = 0;
    return out;
};

/**
 * Generates a perspective projection matrix with the given field of view.
 * This is primarily useful for generating projection matrices to be used
 * with the still experiemental WebVR API.
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {Object} fov Object containing the following values: upDegrees, downDegrees, leftDegrees, rightDegrees
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
mat4.perspectiveFromFieldOfView = function (out, fov, near, far) {
    var upTan = Math.tan(fov.upDegrees * Math.PI/180.0),
        downTan = Math.tan(fov.downDegrees * Math.PI/180.0),
        leftTan = Math.tan(fov.leftDegrees * Math.PI/180.0),
        rightTan = Math.tan(fov.rightDegrees * Math.PI/180.0),
        xScale = 2.0 / (leftTan + rightTan),
        yScale = 2.0 / (upTan + downTan);

    out[0] = xScale;
    out[1] = 0.0;
    out[2] = 0.0;
    out[3] = 0.0;
    out[4] = 0.0;
    out[5] = yScale;
    out[6] = 0.0;
    out[7] = 0.0;
    out[8] = -((leftTan - rightTan) * xScale * 0.5);
    out[9] = ((upTan - downTan) * yScale * 0.5);
    out[10] = far / (near - far);
    out[11] = -1.0;
    out[12] = 0.0;
    out[13] = 0.0;
    out[14] = (far * near) / (near - far);
    out[15] = 0.0;
    return out;
}

/**
 * Generates a orthogonal projection matrix with the given bounds
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {number} left Left bound of the frustum
 * @param {number} right Right bound of the frustum
 * @param {number} bottom Bottom bound of the frustum
 * @param {number} top Top bound of the frustum
 * @param {number} near Near bound of the frustum
 * @param {number} far Far bound of the frustum
 * @returns {mat4} out
 */
mat4.ortho = function (out, left, right, bottom, top, near, far) {
    var lr = 1 / (left - right),
        bt = 1 / (bottom - top),
        nf = 1 / (near - far);
    out[0] = -2 * lr;
    out[1] = 0;
    out[2] = 0;
    out[3] = 0;
    out[4] = 0;
    out[5] = -2 * bt;
    out[6] = 0;
    out[7] = 0;
    out[8] = 0;
    out[9] = 0;
    out[10] = 2 * nf;
    out[11] = 0;
    out[12] = (left + right) * lr;
    out[13] = (top + bottom) * bt;
    out[14] = (far + near) * nf;
    out[15] = 1;
    return out;
};

/**
 * Generates a look-at matrix with the given eye position, focal point, and up axis
 *
 * @param {mat4} out mat4 frustum matrix will be written into
 * @param {vec3} eye Position of the viewer
 * @param {vec3} center Point the viewer is looking at
 * @param {vec3} up vec3 pointing up
 * @returns {mat4} out
 */
mat4.lookAt = function (out, eye, center, up) {
    var x0, x1, x2, y0, y1, y2, z0, z1, z2, len,
        eyex = eye[0],
        eyey = eye[1],
        eyez = eye[2],
        upx = up[0],
        upy = up[1],
        upz = up[2],
        centerx = center[0],
        centery = center[1],
        centerz = center[2];

    if (Math.abs(eyex - centerx) < glMatrix.EPSILON &&
        Math.abs(eyey - centery) < glMatrix.EPSILON &&
        Math.abs(eyez - centerz) < glMatrix.EPSILON) {
        return mat4.identity(out);
    }

    z0 = eyex - centerx;
    z1 = eyey - centery;
    z2 = eyez - centerz;

    len = 1 / Math.sqrt(z0 * z0 + z1 * z1 + z2 * z2);
    z0 *= len;
    z1 *= len;
    z2 *= len;

    x0 = upy * z2 - upz * z1;
    x1 = upz * z0 - upx * z2;
    x2 = upx * z1 - upy * z0;
    len = Math.sqrt(x0 * x0 + x1 * x1 + x2 * x2);
    if (!len) {
        x0 = 0;
        x1 = 0;
        x2 = 0;
    } else {
        len = 1 / len;
        x0 *= len;
        x1 *= len;
        x2 *= len;
    }

    y0 = z1 * x2 - z2 * x1;
    y1 = z2 * x0 - z0 * x2;
    y2 = z0 * x1 - z1 * x0;

    len = Math.sqrt(y0 * y0 + y1 * y1 + y2 * y2);
    if (!len) {
        y0 = 0;
        y1 = 0;
        y2 = 0;
    } else {
        len = 1 / len;
        y0 *= len;
        y1 *= len;
        y2 *= len;
    }

    out[0] = x0;
    out[1] = y0;
    out[2] = z0;
    out[3] = 0;
    out[4] = x1;
    out[5] = y1;
    out[6] = z1;
    out[7] = 0;
    out[8] = x2;
    out[9] = y2;
    out[10] = z2;
    out[11] = 0;
    out[12] = -(x0 * eyex + x1 * eyey + x2 * eyez);
    out[13] = -(y0 * eyex + y1 * eyey + y2 * eyez);
    out[14] = -(z0 * eyex + z1 * eyey + z2 * eyez);
    out[15] = 1;

    return out;
};

/**
 * Returns a string representation of a mat4
 *
 * @param {mat4} mat matrix to represent as a string
 * @returns {String} string representation of the matrix
 */
mat4.str = function (a) {
    return 'mat4(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ', ' +
                    a[4] + ', ' + a[5] + ', ' + a[6] + ', ' + a[7] + ', ' +
                    a[8] + ', ' + a[9] + ', ' + a[10] + ', ' + a[11] + ', ' +
                    a[12] + ', ' + a[13] + ', ' + a[14] + ', ' + a[15] + ')';
};

/**
 * Returns Frobenius norm of a mat4
 *
 * @param {mat4} a the matrix to calculate Frobenius norm of
 * @returns {Number} Frobenius norm
 */
mat4.frob = function (a) {
    return(Math.sqrt(Math.pow(a[0], 2) + Math.pow(a[1], 2) + Math.pow(a[2], 2) + Math.pow(a[3], 2) + Math.pow(a[4], 2) + Math.pow(a[5], 2) + Math.pow(a[6], 2) + Math.pow(a[7], 2) + Math.pow(a[8], 2) + Math.pow(a[9], 2) + Math.pow(a[10], 2) + Math.pow(a[11], 2) + Math.pow(a[12], 2) + Math.pow(a[13], 2) + Math.pow(a[14], 2) + Math.pow(a[15], 2) ))
};

/**
 * Adds two mat4's
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
mat4.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    out[2] = a[2] + b[2];
    out[3] = a[3] + b[3];
    out[4] = a[4] + b[4];
    out[5] = a[5] + b[5];
    out[6] = a[6] + b[6];
    out[7] = a[7] + b[7];
    out[8] = a[8] + b[8];
    out[9] = a[9] + b[9];
    out[10] = a[10] + b[10];
    out[11] = a[11] + b[11];
    out[12] = a[12] + b[12];
    out[13] = a[13] + b[13];
    out[14] = a[14] + b[14];
    out[15] = a[15] + b[15];
    return out;
};

/**
 * Subtracts matrix b from matrix a
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @returns {mat4} out
 */
mat4.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    out[2] = a[2] - b[2];
    out[3] = a[3] - b[3];
    out[4] = a[4] - b[4];
    out[5] = a[5] - b[5];
    out[6] = a[6] - b[6];
    out[7] = a[7] - b[7];
    out[8] = a[8] - b[8];
    out[9] = a[9] - b[9];
    out[10] = a[10] - b[10];
    out[11] = a[11] - b[11];
    out[12] = a[12] - b[12];
    out[13] = a[13] - b[13];
    out[14] = a[14] - b[14];
    out[15] = a[15] - b[15];
    return out;
};

/**
 * Alias for {@link mat4.subtract}
 * @function
 */
mat4.sub = mat4.subtract;

/**
 * Multiply each element of the matrix by a scalar.
 *
 * @param {mat4} out the receiving matrix
 * @param {mat4} a the matrix to scale
 * @param {Number} b amount to scale the matrix's elements by
 * @returns {mat4} out
 */
mat4.multiplyScalar = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    out[2] = a[2] * b;
    out[3] = a[3] * b;
    out[4] = a[4] * b;
    out[5] = a[5] * b;
    out[6] = a[6] * b;
    out[7] = a[7] * b;
    out[8] = a[8] * b;
    out[9] = a[9] * b;
    out[10] = a[10] * b;
    out[11] = a[11] * b;
    out[12] = a[12] * b;
    out[13] = a[13] * b;
    out[14] = a[14] * b;
    out[15] = a[15] * b;
    return out;
};

/**
 * Adds two mat4's after multiplying each element of the second operand by a scalar value.
 *
 * @param {mat4} out the receiving vector
 * @param {mat4} a the first operand
 * @param {mat4} b the second operand
 * @param {Number} scale the amount to scale b's elements by before adding
 * @returns {mat4} out
 */
mat4.multiplyScalarAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    out[2] = a[2] + (b[2] * scale);
    out[3] = a[3] + (b[3] * scale);
    out[4] = a[4] + (b[4] * scale);
    out[5] = a[5] + (b[5] * scale);
    out[6] = a[6] + (b[6] * scale);
    out[7] = a[7] + (b[7] * scale);
    out[8] = a[8] + (b[8] * scale);
    out[9] = a[9] + (b[9] * scale);
    out[10] = a[10] + (b[10] * scale);
    out[11] = a[11] + (b[11] * scale);
    out[12] = a[12] + (b[12] * scale);
    out[13] = a[13] + (b[13] * scale);
    out[14] = a[14] + (b[14] * scale);
    out[15] = a[15] + (b[15] * scale);
    return out;
};

/**
 * Returns whether or not the matrices have exactly the same elements in the same position (when compared with ===)
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat4.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1] && a[2] === b[2] && a[3] === b[3] && 
           a[4] === b[4] && a[5] === b[5] && a[6] === b[6] && a[7] === b[7] && 
           a[8] === b[8] && a[9] === b[9] && a[10] === b[10] && a[11] === b[11] &&
           a[12] === b[12] && a[13] === b[13] && a[14] === b[14] && a[15] === b[15];
};

/**
 * Returns whether or not the matrices have approximately the same elements in the same position.
 *
 * @param {mat4} a The first matrix.
 * @param {mat4} b The second matrix.
 * @returns {Boolean} True if the matrices are equal, false otherwise.
 */
mat4.equals = function (a, b) {
    var a0  = a[0],  a1  = a[1],  a2  = a[2],  a3  = a[3],
        a4  = a[4],  a5  = a[5],  a6  = a[6],  a7  = a[7], 
        a8  = a[8],  a9  = a[9],  a10 = a[10], a11 = a[11], 
        a12 = a[12], a13 = a[13], a14 = a[14], a15 = a[15];

    var b0  = b[0],  b1  = b[1],  b2  = b[2],  b3  = b[3],
        b4  = b[4],  b5  = b[5],  b6  = b[6],  b7  = b[7], 
        b8  = b[8],  b9  = b[9],  b10 = b[10], b11 = b[11], 
        b12 = b[12], b13 = b[13], b14 = b[14], b15 = b[15];

    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)) &&
            Math.abs(a2 - b2) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a2), Math.abs(b2)) &&
            Math.abs(a3 - b3) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a3), Math.abs(b3)) &&
            Math.abs(a4 - b4) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a4), Math.abs(b4)) &&
            Math.abs(a5 - b5) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a5), Math.abs(b5)) &&
            Math.abs(a6 - b6) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a6), Math.abs(b6)) &&
            Math.abs(a7 - b7) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a7), Math.abs(b7)) &&
            Math.abs(a8 - b8) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a8), Math.abs(b8)) &&
            Math.abs(a9 - b9) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a9), Math.abs(b9)) &&
            Math.abs(a10 - b10) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a10), Math.abs(b10)) &&
            Math.abs(a11 - b11) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a11), Math.abs(b11)) &&
            Math.abs(a12 - b12) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a12), Math.abs(b12)) &&
            Math.abs(a13 - b13) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a13), Math.abs(b13)) &&
            Math.abs(a14 - b14) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a14), Math.abs(b14)) &&
            Math.abs(a15 - b15) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a15), Math.abs(b15)));
};



module.exports = mat4;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);
var mat3 = __webpack_require__(105);
var vec3 = __webpack_require__(106);
var vec4 = __webpack_require__(107);

/**
 * @class Quaternion
 * @name quat
 */
var quat = {};

/**
 * Creates a new identity quat
 *
 * @returns {quat} a new quaternion
 */
quat.create = function() {
    var out = new glMatrix.ARRAY_TYPE(4);
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};

/**
 * Sets a quaternion to represent the shortest rotation from one
 * vector to another.
 *
 * Both vectors are assumed to be unit length.
 *
 * @param {quat} out the receiving quaternion.
 * @param {vec3} a the initial vector
 * @param {vec3} b the destination vector
 * @returns {quat} out
 */
quat.rotationTo = (function() {
    var tmpvec3 = vec3.create();
    var xUnitVec3 = vec3.fromValues(1,0,0);
    var yUnitVec3 = vec3.fromValues(0,1,0);

    return function(out, a, b) {
        var dot = vec3.dot(a, b);
        if (dot < -0.999999) {
            vec3.cross(tmpvec3, xUnitVec3, a);
            if (vec3.length(tmpvec3) < 0.000001)
                vec3.cross(tmpvec3, yUnitVec3, a);
            vec3.normalize(tmpvec3, tmpvec3);
            quat.setAxisAngle(out, tmpvec3, Math.PI);
            return out;
        } else if (dot > 0.999999) {
            out[0] = 0;
            out[1] = 0;
            out[2] = 0;
            out[3] = 1;
            return out;
        } else {
            vec3.cross(tmpvec3, a, b);
            out[0] = tmpvec3[0];
            out[1] = tmpvec3[1];
            out[2] = tmpvec3[2];
            out[3] = 1 + dot;
            return quat.normalize(out, out);
        }
    };
})();

/**
 * Sets the specified quaternion with values corresponding to the given
 * axes. Each axis is a vec3 and is expected to be unit length and
 * perpendicular to all other specified axes.
 *
 * @param {vec3} view  the vector representing the viewing direction
 * @param {vec3} right the vector representing the local "right" direction
 * @param {vec3} up    the vector representing the local "up" direction
 * @returns {quat} out
 */
quat.setAxes = (function() {
    var matr = mat3.create();

    return function(out, view, right, up) {
        matr[0] = right[0];
        matr[3] = right[1];
        matr[6] = right[2];

        matr[1] = up[0];
        matr[4] = up[1];
        matr[7] = up[2];

        matr[2] = -view[0];
        matr[5] = -view[1];
        matr[8] = -view[2];

        return quat.normalize(out, quat.fromMat3(out, matr));
    };
})();

/**
 * Creates a new quat initialized with values from an existing quaternion
 *
 * @param {quat} a quaternion to clone
 * @returns {quat} a new quaternion
 * @function
 */
quat.clone = vec4.clone;

/**
 * Creates a new quat initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} a new quaternion
 * @function
 */
quat.fromValues = vec4.fromValues;

/**
 * Copy the values from one quat to another
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the source quaternion
 * @returns {quat} out
 * @function
 */
quat.copy = vec4.copy;

/**
 * Set the components of a quat to the given values
 *
 * @param {quat} out the receiving quaternion
 * @param {Number} x X component
 * @param {Number} y Y component
 * @param {Number} z Z component
 * @param {Number} w W component
 * @returns {quat} out
 * @function
 */
quat.set = vec4.set;

/**
 * Set a quat to the identity quaternion
 *
 * @param {quat} out the receiving quaternion
 * @returns {quat} out
 */
quat.identity = function(out) {
    out[0] = 0;
    out[1] = 0;
    out[2] = 0;
    out[3] = 1;
    return out;
};

/**
 * Sets a quat from the given angle and rotation axis,
 * then returns it.
 *
 * @param {quat} out the receiving quaternion
 * @param {vec3} axis the axis around which to rotate
 * @param {Number} rad the angle in radians
 * @returns {quat} out
 **/
quat.setAxisAngle = function(out, axis, rad) {
    rad = rad * 0.5;
    var s = Math.sin(rad);
    out[0] = s * axis[0];
    out[1] = s * axis[1];
    out[2] = s * axis[2];
    out[3] = Math.cos(rad);
    return out;
};

/**
 * Gets the rotation axis and angle for a given
 *  quaternion. If a quaternion is created with
 *  setAxisAngle, this method will return the same
 *  values as providied in the original parameter list
 *  OR functionally equivalent values.
 * Example: The quaternion formed by axis [0, 0, 1] and
 *  angle -90 is the same as the quaternion formed by
 *  [0, 0, 1] and 270. This method favors the latter.
 * @param  {vec3} out_axis  Vector receiving the axis of rotation
 * @param  {quat} q     Quaternion to be decomposed
 * @return {Number}     Angle, in radians, of the rotation
 */
quat.getAxisAngle = function(out_axis, q) {
    var rad = Math.acos(q[3]) * 2.0;
    var s = Math.sin(rad / 2.0);
    if (s != 0.0) {
        out_axis[0] = q[0] / s;
        out_axis[1] = q[1] / s;
        out_axis[2] = q[2] / s;
    } else {
        // If s is zero, return any axis (no rotation - axis does not matter)
        out_axis[0] = 1;
        out_axis[1] = 0;
        out_axis[2] = 0;
    }
    return rad;
};

/**
 * Adds two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 * @function
 */
quat.add = vec4.add;

/**
 * Multiplies two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {quat} out
 */
quat.multiply = function(out, a, b) {
    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
        bx = b[0], by = b[1], bz = b[2], bw = b[3];

    out[0] = ax * bw + aw * bx + ay * bz - az * by;
    out[1] = ay * bw + aw * by + az * bx - ax * bz;
    out[2] = az * bw + aw * bz + ax * by - ay * bx;
    out[3] = aw * bw - ax * bx - ay * by - az * bz;
    return out;
};

/**
 * Alias for {@link quat.multiply}
 * @function
 */
quat.mul = quat.multiply;

/**
 * Scales a quat by a scalar number
 *
 * @param {quat} out the receiving vector
 * @param {quat} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {quat} out
 * @function
 */
quat.scale = vec4.scale;

/**
 * Rotates a quaternion by the given angle about the X axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
quat.rotateX = function (out, a, rad) {
    rad *= 0.5; 

    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
        bx = Math.sin(rad), bw = Math.cos(rad);

    out[0] = ax * bw + aw * bx;
    out[1] = ay * bw + az * bx;
    out[2] = az * bw - ay * bx;
    out[3] = aw * bw - ax * bx;
    return out;
};

/**
 * Rotates a quaternion by the given angle about the Y axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
quat.rotateY = function (out, a, rad) {
    rad *= 0.5; 

    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
        by = Math.sin(rad), bw = Math.cos(rad);

    out[0] = ax * bw - az * by;
    out[1] = ay * bw + aw * by;
    out[2] = az * bw + ax * by;
    out[3] = aw * bw - ay * by;
    return out;
};

/**
 * Rotates a quaternion by the given angle about the Z axis
 *
 * @param {quat} out quat receiving operation result
 * @param {quat} a quat to rotate
 * @param {number} rad angle (in radians) to rotate
 * @returns {quat} out
 */
quat.rotateZ = function (out, a, rad) {
    rad *= 0.5; 

    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
        bz = Math.sin(rad), bw = Math.cos(rad);

    out[0] = ax * bw + ay * bz;
    out[1] = ay * bw - ax * bz;
    out[2] = az * bw + aw * bz;
    out[3] = aw * bw - az * bz;
    return out;
};

/**
 * Calculates the W component of a quat from the X, Y, and Z components.
 * Assumes that quaternion is 1 unit in length.
 * Any existing W component will be ignored.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate W component of
 * @returns {quat} out
 */
quat.calculateW = function (out, a) {
    var x = a[0], y = a[1], z = a[2];

    out[0] = x;
    out[1] = y;
    out[2] = z;
    out[3] = Math.sqrt(Math.abs(1.0 - x * x - y * y - z * z));
    return out;
};

/**
 * Calculates the dot product of two quat's
 *
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @returns {Number} dot product of a and b
 * @function
 */
quat.dot = vec4.dot;

/**
 * Performs a linear interpolation between two quat's
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 * @function
 */
quat.lerp = vec4.lerp;

/**
 * Performs a spherical linear interpolation between two quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {quat} out
 */
quat.slerp = function (out, a, b, t) {
    // benchmarks:
    //    http://jsperf.com/quaternion-slerp-implementations

    var ax = a[0], ay = a[1], az = a[2], aw = a[3],
        bx = b[0], by = b[1], bz = b[2], bw = b[3];

    var        omega, cosom, sinom, scale0, scale1;

    // calc cosine
    cosom = ax * bx + ay * by + az * bz + aw * bw;
    // adjust signs (if necessary)
    if ( cosom < 0.0 ) {
        cosom = -cosom;
        bx = - bx;
        by = - by;
        bz = - bz;
        bw = - bw;
    }
    // calculate coefficients
    if ( (1.0 - cosom) > 0.000001 ) {
        // standard case (slerp)
        omega  = Math.acos(cosom);
        sinom  = Math.sin(omega);
        scale0 = Math.sin((1.0 - t) * omega) / sinom;
        scale1 = Math.sin(t * omega) / sinom;
    } else {        
        // "from" and "to" quaternions are very close 
        //  ... so we can do a linear interpolation
        scale0 = 1.0 - t;
        scale1 = t;
    }
    // calculate final values
    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    
    return out;
};

/**
 * Performs a spherical linear interpolation with two control points
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a the first operand
 * @param {quat} b the second operand
 * @param {quat} c the third operand
 * @param {quat} d the fourth operand
 * @param {Number} t interpolation amount
 * @returns {quat} out
 */
quat.sqlerp = (function () {
  var temp1 = quat.create();
  var temp2 = quat.create();
  
  return function (out, a, b, c, d, t) {
    quat.slerp(temp1, a, d, t);
    quat.slerp(temp2, b, c, t);
    quat.slerp(out, temp1, temp2, 2 * t * (1 - t));
    
    return out;
  };
}());

/**
 * Calculates the inverse of a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate inverse of
 * @returns {quat} out
 */
quat.invert = function(out, a) {
    var a0 = a[0], a1 = a[1], a2 = a[2], a3 = a[3],
        dot = a0*a0 + a1*a1 + a2*a2 + a3*a3,
        invDot = dot ? 1.0/dot : 0;
    
    // TODO: Would be faster to return [0,0,0,0] immediately if dot == 0

    out[0] = -a0*invDot;
    out[1] = -a1*invDot;
    out[2] = -a2*invDot;
    out[3] = a3*invDot;
    return out;
};

/**
 * Calculates the conjugate of a quat
 * If the quaternion is normalized, this function is faster than quat.inverse and produces the same result.
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quat to calculate conjugate of
 * @returns {quat} out
 */
quat.conjugate = function (out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    out[2] = -a[2];
    out[3] = a[3];
    return out;
};

/**
 * Calculates the length of a quat
 *
 * @param {quat} a vector to calculate length of
 * @returns {Number} length of a
 * @function
 */
quat.length = vec4.length;

/**
 * Alias for {@link quat.length}
 * @function
 */
quat.len = quat.length;

/**
 * Calculates the squared length of a quat
 *
 * @param {quat} a vector to calculate squared length of
 * @returns {Number} squared length of a
 * @function
 */
quat.squaredLength = vec4.squaredLength;

/**
 * Alias for {@link quat.squaredLength}
 * @function
 */
quat.sqrLen = quat.squaredLength;

/**
 * Normalize a quat
 *
 * @param {quat} out the receiving quaternion
 * @param {quat} a quaternion to normalize
 * @returns {quat} out
 * @function
 */
quat.normalize = vec4.normalize;

/**
 * Creates a quaternion from the given 3x3 rotation matrix.
 *
 * NOTE: The resultant quaternion is not normalized, so you should be sure
 * to renormalize the quaternion yourself where necessary.
 *
 * @param {quat} out the receiving quaternion
 * @param {mat3} m rotation matrix
 * @returns {quat} out
 * @function
 */
quat.fromMat3 = function(out, m) {
    // Algorithm in Ken Shoemake's article in 1987 SIGGRAPH course notes
    // article "Quaternion Calculus and Fast Animation".
    var fTrace = m[0] + m[4] + m[8];
    var fRoot;

    if ( fTrace > 0.0 ) {
        // |w| > 1/2, may as well choose w > 1/2
        fRoot = Math.sqrt(fTrace + 1.0);  // 2w
        out[3] = 0.5 * fRoot;
        fRoot = 0.5/fRoot;  // 1/(4w)
        out[0] = (m[5]-m[7])*fRoot;
        out[1] = (m[6]-m[2])*fRoot;
        out[2] = (m[1]-m[3])*fRoot;
    } else {
        // |w| <= 1/2
        var i = 0;
        if ( m[4] > m[0] )
          i = 1;
        if ( m[8] > m[i*3+i] )
          i = 2;
        var j = (i+1)%3;
        var k = (i+2)%3;
        
        fRoot = Math.sqrt(m[i*3+i]-m[j*3+j]-m[k*3+k] + 1.0);
        out[i] = 0.5 * fRoot;
        fRoot = 0.5 / fRoot;
        out[3] = (m[j*3+k] - m[k*3+j]) * fRoot;
        out[j] = (m[j*3+i] + m[i*3+j]) * fRoot;
        out[k] = (m[k*3+i] + m[i*3+k]) * fRoot;
    }
    
    return out;
};

/**
 * Returns a string representation of a quatenion
 *
 * @param {quat} vec vector to represent as a string
 * @returns {String} string representation of the vector
 */
quat.str = function (a) {
    return 'quat(' + a[0] + ', ' + a[1] + ', ' + a[2] + ', ' + a[3] + ')';
};

/**
 * Returns whether or not the quaternions have exactly the same elements in the same position (when compared with ===)
 *
 * @param {quat} a The first quaternion.
 * @param {quat} b The second quaternion.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
quat.exactEquals = vec4.exactEquals;

/**
 * Returns whether or not the quaternions have approximately the same elements in the same position.
 *
 * @param {quat} a The first vector.
 * @param {quat} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
quat.equals = vec4.equals;

module.exports = quat;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

/* Copyright (c) 2015, Brandon Jones, Colin MacKenzie IV.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE. */

var glMatrix = __webpack_require__(27);

/**
 * @class 2 Dimensional Vector
 * @name vec2
 */
var vec2 = {};

/**
 * Creates a new, empty vec2
 *
 * @returns {vec2} a new 2D vector
 */
vec2.create = function() {
    var out = new glMatrix.ARRAY_TYPE(2);
    out[0] = 0;
    out[1] = 0;
    return out;
};

/**
 * Creates a new vec2 initialized with values from an existing vector
 *
 * @param {vec2} a vector to clone
 * @returns {vec2} a new 2D vector
 */
vec2.clone = function(a) {
    var out = new glMatrix.ARRAY_TYPE(2);
    out[0] = a[0];
    out[1] = a[1];
    return out;
};

/**
 * Creates a new vec2 initialized with the given values
 *
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} a new 2D vector
 */
vec2.fromValues = function(x, y) {
    var out = new glMatrix.ARRAY_TYPE(2);
    out[0] = x;
    out[1] = y;
    return out;
};

/**
 * Copy the values from one vec2 to another
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the source vector
 * @returns {vec2} out
 */
vec2.copy = function(out, a) {
    out[0] = a[0];
    out[1] = a[1];
    return out;
};

/**
 * Set the components of a vec2 to the given values
 *
 * @param {vec2} out the receiving vector
 * @param {Number} x X component
 * @param {Number} y Y component
 * @returns {vec2} out
 */
vec2.set = function(out, x, y) {
    out[0] = x;
    out[1] = y;
    return out;
};

/**
 * Adds two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.add = function(out, a, b) {
    out[0] = a[0] + b[0];
    out[1] = a[1] + b[1];
    return out;
};

/**
 * Subtracts vector b from vector a
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.subtract = function(out, a, b) {
    out[0] = a[0] - b[0];
    out[1] = a[1] - b[1];
    return out;
};

/**
 * Alias for {@link vec2.subtract}
 * @function
 */
vec2.sub = vec2.subtract;

/**
 * Multiplies two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.multiply = function(out, a, b) {
    out[0] = a[0] * b[0];
    out[1] = a[1] * b[1];
    return out;
};

/**
 * Alias for {@link vec2.multiply}
 * @function
 */
vec2.mul = vec2.multiply;

/**
 * Divides two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.divide = function(out, a, b) {
    out[0] = a[0] / b[0];
    out[1] = a[1] / b[1];
    return out;
};

/**
 * Alias for {@link vec2.divide}
 * @function
 */
vec2.div = vec2.divide;

/**
 * Math.ceil the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to ceil
 * @returns {vec2} out
 */
vec2.ceil = function (out, a) {
    out[0] = Math.ceil(a[0]);
    out[1] = Math.ceil(a[1]);
    return out;
};

/**
 * Math.floor the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to floor
 * @returns {vec2} out
 */
vec2.floor = function (out, a) {
    out[0] = Math.floor(a[0]);
    out[1] = Math.floor(a[1]);
    return out;
};

/**
 * Returns the minimum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.min = function(out, a, b) {
    out[0] = Math.min(a[0], b[0]);
    out[1] = Math.min(a[1], b[1]);
    return out;
};

/**
 * Returns the maximum of two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec2} out
 */
vec2.max = function(out, a, b) {
    out[0] = Math.max(a[0], b[0]);
    out[1] = Math.max(a[1], b[1]);
    return out;
};

/**
 * Math.round the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to round
 * @returns {vec2} out
 */
vec2.round = function (out, a) {
    out[0] = Math.round(a[0]);
    out[1] = Math.round(a[1]);
    return out;
};

/**
 * Scales a vec2 by a scalar number
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to scale
 * @param {Number} b amount to scale the vector by
 * @returns {vec2} out
 */
vec2.scale = function(out, a, b) {
    out[0] = a[0] * b;
    out[1] = a[1] * b;
    return out;
};

/**
 * Adds two vec2's after scaling the second operand by a scalar value
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} scale the amount to scale b by before adding
 * @returns {vec2} out
 */
vec2.scaleAndAdd = function(out, a, b, scale) {
    out[0] = a[0] + (b[0] * scale);
    out[1] = a[1] + (b[1] * scale);
    return out;
};

/**
 * Calculates the euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} distance between a and b
 */
vec2.distance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1];
    return Math.sqrt(x*x + y*y);
};

/**
 * Alias for {@link vec2.distance}
 * @function
 */
vec2.dist = vec2.distance;

/**
 * Calculates the squared euclidian distance between two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} squared distance between a and b
 */
vec2.squaredDistance = function(a, b) {
    var x = b[0] - a[0],
        y = b[1] - a[1];
    return x*x + y*y;
};

/**
 * Alias for {@link vec2.squaredDistance}
 * @function
 */
vec2.sqrDist = vec2.squaredDistance;

/**
 * Calculates the length of a vec2
 *
 * @param {vec2} a vector to calculate length of
 * @returns {Number} length of a
 */
vec2.length = function (a) {
    var x = a[0],
        y = a[1];
    return Math.sqrt(x*x + y*y);
};

/**
 * Alias for {@link vec2.length}
 * @function
 */
vec2.len = vec2.length;

/**
 * Calculates the squared length of a vec2
 *
 * @param {vec2} a vector to calculate squared length of
 * @returns {Number} squared length of a
 */
vec2.squaredLength = function (a) {
    var x = a[0],
        y = a[1];
    return x*x + y*y;
};

/**
 * Alias for {@link vec2.squaredLength}
 * @function
 */
vec2.sqrLen = vec2.squaredLength;

/**
 * Negates the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to negate
 * @returns {vec2} out
 */
vec2.negate = function(out, a) {
    out[0] = -a[0];
    out[1] = -a[1];
    return out;
};

/**
 * Returns the inverse of the components of a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to invert
 * @returns {vec2} out
 */
vec2.inverse = function(out, a) {
  out[0] = 1.0 / a[0];
  out[1] = 1.0 / a[1];
  return out;
};

/**
 * Normalize a vec2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a vector to normalize
 * @returns {vec2} out
 */
vec2.normalize = function(out, a) {
    var x = a[0],
        y = a[1];
    var len = x*x + y*y;
    if (len > 0) {
        //TODO: evaluate use of glm_invsqrt here?
        len = 1 / Math.sqrt(len);
        out[0] = a[0] * len;
        out[1] = a[1] * len;
    }
    return out;
};

/**
 * Calculates the dot product of two vec2's
 *
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {Number} dot product of a and b
 */
vec2.dot = function (a, b) {
    return a[0] * b[0] + a[1] * b[1];
};

/**
 * Computes the cross product of two vec2's
 * Note that the cross product must by definition produce a 3D vector
 *
 * @param {vec3} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @returns {vec3} out
 */
vec2.cross = function(out, a, b) {
    var z = a[0] * b[1] - a[1] * b[0];
    out[0] = out[1] = 0;
    out[2] = z;
    return out;
};

/**
 * Performs a linear interpolation between two vec2's
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the first operand
 * @param {vec2} b the second operand
 * @param {Number} t interpolation amount between the two inputs
 * @returns {vec2} out
 */
vec2.lerp = function (out, a, b, t) {
    var ax = a[0],
        ay = a[1];
    out[0] = ax + t * (b[0] - ax);
    out[1] = ay + t * (b[1] - ay);
    return out;
};

/**
 * Generates a random vector with the given scale
 *
 * @param {vec2} out the receiving vector
 * @param {Number} [scale] Length of the resulting vector. If ommitted, a unit vector will be returned
 * @returns {vec2} out
 */
vec2.random = function (out, scale) {
    scale = scale || 1.0;
    var r = glMatrix.RANDOM() * 2.0 * Math.PI;
    out[0] = Math.cos(r) * scale;
    out[1] = Math.sin(r) * scale;
    return out;
};

/**
 * Transforms the vec2 with a mat2
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2} m matrix to transform with
 * @returns {vec2} out
 */
vec2.transformMat2 = function(out, a, m) {
    var x = a[0],
        y = a[1];
    out[0] = m[0] * x + m[2] * y;
    out[1] = m[1] * x + m[3] * y;
    return out;
};

/**
 * Transforms the vec2 with a mat2d
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat2d} m matrix to transform with
 * @returns {vec2} out
 */
vec2.transformMat2d = function(out, a, m) {
    var x = a[0],
        y = a[1];
    out[0] = m[0] * x + m[2] * y + m[4];
    out[1] = m[1] * x + m[3] * y + m[5];
    return out;
};

/**
 * Transforms the vec2 with a mat3
 * 3rd vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat3} m matrix to transform with
 * @returns {vec2} out
 */
vec2.transformMat3 = function(out, a, m) {
    var x = a[0],
        y = a[1];
    out[0] = m[0] * x + m[3] * y + m[6];
    out[1] = m[1] * x + m[4] * y + m[7];
    return out;
};

/**
 * Transforms the vec2 with a mat4
 * 3rd vector component is implicitly '0'
 * 4th vector component is implicitly '1'
 *
 * @param {vec2} out the receiving vector
 * @param {vec2} a the vector to transform
 * @param {mat4} m matrix to transform with
 * @returns {vec2} out
 */
vec2.transformMat4 = function(out, a, m) {
    var x = a[0], 
        y = a[1];
    out[0] = m[0] * x + m[4] * y + m[12];
    out[1] = m[1] * x + m[5] * y + m[13];
    return out;
};

/**
 * Perform some operation over an array of vec2s.
 *
 * @param {Array} a the array of vectors to iterate over
 * @param {Number} stride Number of elements between the start of each vec2. If 0 assumes tightly packed
 * @param {Number} offset Number of elements to skip at the beginning of the array
 * @param {Number} count Number of vec2s to iterate over. If 0 iterates over entire array
 * @param {Function} fn Function to call for each vector in the array
 * @param {Object} [arg] additional argument to pass to fn
 * @returns {Array} a
 * @function
 */
vec2.forEach = (function() {
    var vec = vec2.create();

    return function(a, stride, offset, count, fn, arg) {
        var i, l;
        if(!stride) {
            stride = 2;
        }

        if(!offset) {
            offset = 0;
        }
        
        if(count) {
            l = Math.min((count * stride) + offset, a.length);
        } else {
            l = a.length;
        }

        for(i = offset; i < l; i += stride) {
            vec[0] = a[i]; vec[1] = a[i+1];
            fn(vec, vec, arg);
            a[i] = vec[0]; a[i+1] = vec[1];
        }
        
        return a;
    };
})();

/**
 * Returns a string representation of a vector
 *
 * @param {vec2} vec vector to represent as a string
 * @returns {String} string representation of the vector
 */
vec2.str = function (a) {
    return 'vec2(' + a[0] + ', ' + a[1] + ')';
};

/**
 * Returns whether or not the vectors exactly have the same elements in the same position (when compared with ===)
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec2.exactEquals = function (a, b) {
    return a[0] === b[0] && a[1] === b[1];
};

/**
 * Returns whether or not the vectors have approximately the same elements in the same position.
 *
 * @param {vec2} a The first vector.
 * @param {vec2} b The second vector.
 * @returns {Boolean} True if the vectors are equal, false otherwise.
 */
vec2.equals = function (a, b) {
    var a0 = a[0], a1 = a[1];
    var b0 = b[0], b1 = b[1];
    return (Math.abs(a0 - b0) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a0), Math.abs(b0)) &&
            Math.abs(a1 - b1) <= glMatrix.EPSILON*Math.max(1.0, Math.abs(a1), Math.abs(b1)));
};

module.exports = vec2;


/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    ArrayType: Float64Array
});


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Timer__ = __webpack_require__(21);



var TextureProfile = function(target, internalFormat, width, height) {
    this._target = target;
    this._internalFormat = internalFormat;
    this._width = width;
    this._height = height;
    this._size = 0;
    this.computeSize();
};

TextureProfile.prototype = {
    match: function(textureProfile) {
        return (
            textureProfile._target === this._target &&
            textureProfile._internalFormat === this._internalFormat &&
            textureProfile._width === this._width &&
            textureProfile._height === this._height
        );
    },
    computeSize: function() {
        var Texture = __webpack_require__(7).default;

        var numBitsPerTexel = 0;
        switch (this._internalFormat) {
            case 1:
                numBitsPerTexel = 8;
                break;
            case Texture.ALPHA:
                numBitsPerTexel = 8;
                break;
            case Texture.LUMINANCE:
                numBitsPerTexel = 8;
                break;

            case Texture.LUMINANCE_ALPHA:
                numBitsPerTexel = 16;
                break;
            case 2:
                numBitsPerTexel = 16;
                break;

            case Texture.RGB:
                numBitsPerTexel = 24;
                break;
            case 3:
                numBitsPerTexel = 24;
                break;

            case Texture.RGBA:
                numBitsPerTexel = 32;
                break;
            case 4:
                numBitsPerTexel = 32;
                break;
        }
        var size = Math.ceil(this._width * this._height * numBitsPerTexel) / 8.0;

        if (this._target === Texture.TEXTURE_CUBE_MAP) size *= 6.0;

        // add the mipmap overhead size even if not used
        size += size / 3.0;

        this._size = size;
    },

    getSize: function() {
        return this._size;
    }
};
TextureProfile.getHash = function() {
    var array = Array.prototype.slice.call(arguments);
    var hash = '';
    array.forEach(function(element) {
        hash += element;
    });
    return hash;
};

var TextureObject = function(texture, id, textureSet) {
    this._texture = texture;
    this._id = id;
    this._textureSet = textureSet;
};

TextureObject.prototype = {
    target: function() {
        return this._textureSet._profile._target;
    },
    id: function() {
        return this._id;
    },
    getTextureSet: function() {
        return this._textureSet;
    },
    reset: function() {
        this._textureObject = null;
        this._texture = undefined;
    },
    bind: function(gl) {
        gl.bindTexture(this.target(), this._id);
    }
};

var TextureObjectSet = function(profile) {
    this._profile = profile;
    this._usedTextureObjects = [];
    this._orphanedTextureObjects = [];
};

TextureObjectSet.prototype = {
    getProfile: function() {
        return this._profile;
    },
    getUsedTextureObjects: function() {
        return this._usedTextureObjects;
    },
    getOrphanedTextureObjects: function() {
        return this._orphanedTextureObjects;
    },

    takeOrGenerate: function(gl, texture) {
        var textureObject;
        if (this._orphanedTextureObjects.length > 0) {
            textureObject = this.takeFromOrphans();
            textureObject._texture = texture;
            this._usedTextureObjects.push(textureObject);
            return textureObject;
        }

        var textureID = gl.createTexture();
        textureObject = new TextureObject(texture, textureID, this);
        this._usedTextureObjects.push(textureObject);

        return textureObject;
    },

    // get texture object from pool
    takeFromOrphans: function() {
        if (this._orphanedTextureObjects.length) return this._orphanedTextureObjects.pop();

        return undefined;
    },

    // release texture object
    orphan: function(textureObject) {
        var index = this._usedTextureObjects.indexOf(textureObject);
        if (index !== -1) {
            this._orphanedTextureObjects.push(this._usedTextureObjects[index]);
            this._usedTextureObjects.splice(index, 1);
        }
    },

    flushDeletedTextureObjects: function(gl, availableTime) {
        // if no time available don't try to flush objects.
        if (availableTime <= 0.0) return availableTime;
        var nbTextures = this._orphanedTextureObjects.length;
        // Should we use a maxSizeTexturePool value?
        //var size = this.getProfile().getSize();
        // We need to test if we have time to flush
        var elapsedTime = 0.0;
        var beginTime = __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().tick();
        var i;
        for (i = 0; i < nbTextures && elapsedTime < availableTime; i++) {
            gl.deleteTexture(this._orphanedTextureObjects[i].id());
            this._orphanedTextureObjects[i].reset();
            elapsedTime = __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().deltaS(beginTime, __WEBPACK_IMPORTED_MODULE_1_osg_Timer__["a" /* default */].instance().tick());
        }
        this._orphanedTextureObjects.splice(0, i);
        return availableTime - elapsedTime;
    },

    flushAllDeletedTextureObjects: function(gl) {
        var nbTextures = this._orphanedTextureObjects.length;
        var size = this.getProfile().getSize();
        for (var i = 0, j = nbTextures; i < j; ++i) {
            gl.deleteTexture(this._orphanedTextureObjects[i].id());
            this._orphanedTextureObjects[i].reset();
        }
        this._orphanedTextureObjects.length = 0;
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].info(
            'TextureManager: released ' +
                nbTextures +
                ' with ' +
                nbTextures * size / (1024 * 1024) +
                ' MB'
        );
    },

    onLostContext: function() {
        var i, nbTextures;

        nbTextures = this._orphanedTextureObjects.length;
        for (i = 0; i < nbTextures; ++i) {
            this._orphanedTextureObjects[i].reset();
        }
        this._orphanedTextureObjects.length = 0;

        nbTextures = this._usedTextureObjects.length;
        for (i = 0; i < nbTextures; ++i) {
            this._usedTextureObjects[i].reset();
        }
        this._usedTextureObjects.length = 0;
    }
};

var TextureManager = function() {
    this._textureSetMap = {};
};

TextureManager.prototype = {
    generateTextureObject: function(gl, texture, target, internalFormat, width, height) {
        var hash = TextureProfile.getHash(target, internalFormat, width, height);

        if (this._textureSetMap[hash] === undefined) {
            this._textureSetMap[hash] = new TextureObjectSet(
                new TextureProfile(target, internalFormat, width, height)
            );
        }

        var textureSet = this._textureSetMap[hash];
        var textureObject = textureSet.takeOrGenerate(gl, texture);
        return textureObject;
    },

    updateStats: function(frameNumber, stats) {
        var totalUsed = 0;
        var totalUnused = 0;
        for (var keyTexture in this._textureSetMap) {
            var profile = this._textureSetMap[keyTexture].getProfile();
            var size = profile.getSize();
            var nbUsed = this._textureSetMap[keyTexture].getUsedTextureObjects().length;
            var nbUnused = this._textureSetMap[keyTexture].getOrphanedTextureObjects().length;
            totalUsed += nbUsed * size;
            totalUnused += nbUnused * size;
        }

        var MB = 1024 * 1024;
        stats.getCounter('textureused').set(totalUsed / MB);
        stats.getCounter('texturereserved').set(totalUnused / MB);
        stats.getCounter('texturetotal').set((totalUsed + totalUnused) / MB);
    },

    reportStats: function() {
        var total = 0;
        for (var keyTexture in this._textureSetMap) {
            var profile = this._textureSetMap[keyTexture].getProfile();
            var size = profile.getSize() / (1024 * 1024);
            var nb = this._textureSetMap[keyTexture].getUsedTextureObjects().length;
            size *= nb;
            total += size;
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].notice(
                String(size) +
                    ' MB with ' +
                    nb +
                    ' texture of ' +
                    profile._width +
                    'x' +
                    profile._height +
                    ' ' +
                    profile._internalFormat
            );
        }

        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].notice(String(total) + ' MB in total');
    },

    flushAllDeletedTextureObjects: function(gl) {
        for (var keyTexture in this._textureSetMap) {
            this._textureSetMap[keyTexture].flushAllDeletedTextureObjects(gl);
        }
    },

    onLostContext: function(gl) {
        for (var keyTexture in this._textureSetMap) {
            this._textureSetMap[keyTexture].onLostContext(gl);
        }
    },

    flushDeletedTextureObjects: function(gl, availableTimeArg) {
        var availableTime = availableTimeArg;
        for (var keyTexture in this._textureSetMap) {
            availableTime = this._textureSetMap[keyTexture].flushDeletedTextureObjects(
                gl,
                availableTime
            );
            if (availableTime <= 0.0) break;
        }
        return availableTime;
    },

    releaseTextureObject: function(textureObject) {
        if (textureObject) {
            var ts = textureObject.getTextureSet();
            ts.orphan(textureObject);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (TextureManager);


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



var BillboardAttribute = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._attributeEnable = false;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    BillboardAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'Billboard',

        cloneType: function() {
            return new BillboardAttribute();
        },

        setEnabled: function(state) {
            this._attributeEnable = state;
        },

        isEnabled: function() {
            return this._attributeEnable;
        },

        apply: function() {}
    }),
    'osg',
    'Billboard'
);

/* harmony default export */ __webpack_exports__["a"] = (BillboardAttribute);


/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);




/**
 *  Manage BlendColor attribute
 *  @class
 *  @memberOf osg
 *  @extends StateAttribute
 */
var BlendColor = function(color) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._constantColor = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].create();
    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].set(this._constantColor, 1.0, 1.0, 1.0, 1.0);
    if (color !== undefined) {
        this.setConstantColor(color);
    }
};

/**
 * @lends BlendColor.prototype
 */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    BlendColor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'BlendColor',
        cloneType: function() {
            return new BlendColor();
        },

        /**
     *
     * @param {} color
     */
        setConstantColor: function(color) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].copy(this._constantColor, color);
        },
        getConstantColor: function() {
            return this._constantColor;
        },
        apply: function(state) {
            var gl = state.getGraphicContext();
            gl.blendColor(
                this._constantColor[0],
                this._constantColor[1],
                this._constantColor[2],
                this._constantColor[3]
            );
        }
    }),
    'osg',
    'BlendColor'
);

/* harmony default export */ __webpack_exports__["a"] = (BlendColor);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



var ColorMask = function(red, green, blue, alpha) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this._red = true;
    this._green = true;
    this._blue = true;
    this._alpha = true;

    if (red !== undefined && green !== undefined && blue !== undefined)
        this.setMask(red, green, blue, alpha);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    ColorMask,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'ColorMask',
        cloneType: function() {
            return new ColorMask();
        },
        setMask: function(red, green, blue, alpha) {
            this._red = !!red;
            this._green = !!green;
            this._blue = !!blue;
            this._alpha = !!alpha;
        },
        apply: function(state) {
            state.applyColorMask(this);
        }
    }),
    'osg',
    'ColorMask'
);

/* harmony default export */ __webpack_exports__["a"] = (ColorMask);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_FindNearestParentSkeleton__ = __webpack_require__(191);





// converted from C++ probably it could be merged into RigGeometry
// it could probably inlined into RigGeometry code
var UpdateRigGeometry = function() {
    __WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].call(this);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    UpdateRigGeometry,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Object__["a" /* default */].prototype, {
        init: function(geom) {
            var finder = new __WEBPACK_IMPORTED_MODULE_3_osgAnimation_FindNearestParentSkeleton__["a" /* default */]();
            if (geom.getParents().length > 1)
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                    'A RigGeometry should not have multi parent ( ' + geom.getName() + ' )'
                );

            geom.getParents()[0].accept(finder);

            if (!finder._root) {
                __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].warn(
                    'A RigGeometry did not find a parent skeleton for RigGeometry ( ' +
                        geom.getName() +
                        ' )'
                );
                return;
            }

            geom.setSkeleton(finder._root);
            geom.setPathToSkeleton(finder._pathToRoot);
        },

        update: function(node /*, nv*/) {
            // Circular ref
            if (node && node.className() !== 'RigGeometry') return true;

            var geom = node;

            // maybe this code could simpler
            if (!geom.getSkeleton() && geom.getParents().length !== 0) this.init(geom);
            if (!geom.getSkeleton()) return true;

            if (geom.getNeedToComputeMatrix()) geom.computeMatrixFromRootSkeleton();

            geom.update();

            return true;
        }
    }),
    'osgAnimation',
    'UpdateRigGeometry'
);

/* harmony default export */ __webpack_exports__["a"] = (UpdateRigGeometry);


/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_Skeleton__ = __webpack_require__(61);




/**
 * FindNearestParentSkeleton
 */

var FindNearestParentSkeleton = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].TRAVERSE_PARENTS);
    this._root = undefined;

    // node path to skeleton (without skeleton node though)
    this._pathToRoot = undefined;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    FindNearestParentSkeleton,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (this._root) return;

            if (node.typeID === __WEBPACK_IMPORTED_MODULE_2_osgAnimation_Skeleton__["a" /* default */].typeID) {
                this._root = node;
                this._pathToRoot = this.nodePath.slice(1);
                return;
            }

            this.traverse(node);
        }
    }),
    'osgAnimation',
    'FindNearestParentSkeleton'
);

/* harmony default export */ __webpack_exports__["a"] = (FindNearestParentSkeleton);


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_SkinningAttribute__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_CollectBoneVisitor__ = __webpack_require__(193);





/**
 * Hardware implementation for rigGeometry
 *
 */
var RigTransformHardware = function() {
    this._isInitialized = false;

    // bones are sorted to be used directly by
    // computeMatrixPalette
    // means the
    this._bones = [];
};

RigTransformHardware.prototype = {
    // boneNameID contains a map: boneName: id
    // {
    //    'bone0' : 1,
    //    'bone4' : 0,
    // }
    //
    // boneMap contains a map: boneName: Bone
    // {
    //    'bone0: : Bone object,
    //    'bone1: : Bone object,
    // }
    //
    // return index / bone object
    // [
    //    Bone4 object,
    //    Bone0 object
    // ]
    computeBonePalette: function(boneMap, boneNameID) {
        var bones = this._bones;
        for (var boneName in boneMap) {
            var index = boneNameID[boneName];
            var bone = boneMap[boneName];

            if (index !== undefined) bones[index] = bone;
        }

        return bones;
    },

    init: function(geom) {
        // init the bones map

        // stop here
        // compute bonemap / index
        var mapVisitor = new __WEBPACK_IMPORTED_MODULE_3_osgAnimation_CollectBoneVisitor__["a" /* default */]();
        geom.getSkeleton().accept(mapVisitor);
        var bm = mapVisitor.getBoneMap();

        this.computeBonePalette(bm, geom._boneNameID);

        // matrix are 4x3
        var nbVec4Uniforms = this._bones.length * 3;
        var animAttrib = (this._skinningAttribute = new __WEBPACK_IMPORTED_MODULE_2_osgAnimation_SkinningAttribute__["a" /* default */]());
        animAttrib.setMatrixPalette(new Float32Array(nbVec4Uniforms * 4));
        geom.getStateSetAnimation().setAttributeAndModes(animAttrib, __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].ON);

        this._isInitialized = true;
        return true;
    },

    computeMatrixPalette: (function() {
        var mTmp = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create();

        return function(transformFromSkeletonToGeometry, invTransformFromSkeletonToGeometry) {
            var bones = this._bones;
            var matPalette = this._skinningAttribute.getMatrixPalette();
            var uniformIndex = 0;

            for (var i = 0, l = bones.length; i < l; i++) {
                var bone = bones[i];

                var invBindMatrix = bone.getInvBindMatrixInSkeletonSpace();
                var boneMatrix = bone.getMatrixInSkeletonSpace();

                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].mul(mTmp, boneMatrix, invBindMatrix);
                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].mul(mTmp, invTransformFromSkeletonToGeometry, mTmp);
                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].mul(mTmp, mTmp, transformFromSkeletonToGeometry);

                // TODO: maybe change upload order so that we can use
                // glsl constructor :
                // mat4(uBones[index], uBones[index+1], uBones[index+2], vec4(0.0, 0.0, 0.0, 1.0))
                // for faster glsl
                matPalette[uniformIndex++] = mTmp[0];
                matPalette[uniformIndex++] = mTmp[4];
                matPalette[uniformIndex++] = mTmp[8];
                matPalette[uniformIndex++] = mTmp[12];

                matPalette[uniformIndex++] = mTmp[1];
                matPalette[uniformIndex++] = mTmp[5];
                matPalette[uniformIndex++] = mTmp[9];
                matPalette[uniformIndex++] = mTmp[13];

                matPalette[uniformIndex++] = mTmp[2];
                matPalette[uniformIndex++] = mTmp[6];
                matPalette[uniformIndex++] = mTmp[10];
                matPalette[uniformIndex++] = mTmp[14];
            }
        };
    })(),

    update: function(geom) {
        if (!this._isInitialized) this.init(geom);

        this.computeMatrixPalette(
            geom.getMatrixFromSkeletonToGeometry(),
            geom.getInvMatrixFromSkeletonToGeometry()
        );
    }
};

/* harmony default export */ __webpack_exports__["a"] = (RigTransformHardware);


/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_Bone__ = __webpack_require__(41);





var CollectBoneVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);
    this._boneMap = {};
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CollectBoneVisitor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.typeID === __WEBPACK_IMPORTED_MODULE_3_osgAnimation_Bone__["a" /* default */].typeID) {
                var name = node.getName();

                if (!name) {
                    __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].warn('found Bone without name');
                } else {
                    this._boneMap[name] = node;
                }
            }

            this.traverse(node);
        },

        getBoneMap: function() {
            return this._boneMap;
        }
    }),
    'osgAnimation',
    'CollectBoneVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (CollectBoneVisitor);


/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);



var EllipsoidModel = function() {
    this._radiusEquator = EllipsoidModel.WGS_84_RADIUS_EQUATOR;
    this._radiusPolar = EllipsoidModel.WGS_84_RADIUS_POLAR;
    this.computeCoefficients();
};

EllipsoidModel.WGS_84_RADIUS_EQUATOR = 6378137.0;
EllipsoidModel.WGS_84_RADIUS_POLAR = 6356752.3142;

EllipsoidModel.prototype = {
    setRadiusEquator: function(radius) {
        this._radiusEquator = radius;
        this.computeCoefficients();
    },
    getRadiusEquator: function() {
        return this._radiusEquator;
    },
    setRadiusPolar: function(radius) {
        this._radiusPolar = radius;
        this.computeCoefficients();
    },
    getRadiusPolar: function() {
        return this._radiusPolar;
    },
    convertLatLongHeightToXYZ: function(latitude, longitude, height, result) {
        var sinLatitude = Math.sin(latitude);
        var cosLatitude = Math.cos(latitude);
        var N =
            this._radiusEquator /
            Math.sqrt(1.0 - this._eccentricitySquared * sinLatitude * sinLatitude);
        var X = (N + height) * cosLatitude * Math.cos(longitude);
        var Y = (N + height) * cosLatitude * Math.sin(longitude);
        var Z = (N * (1.0 - this._eccentricitySquared) + height) * sinLatitude;
        result[0] = X;
        result[1] = Y;
        result[2] = Z;
        return result;
    },
    convertXYZToLatLongHeight: function(X, Y, Z, result) {
        // http://www.colorado.edu/geography/gcraft/notes/datum/gif/xyzllh.gif
        var p = Math.sqrt(X * X + Y * Y);
        var theta = Math.atan2(Z * this._radiusEquator, p * this._radiusPolar);
        var eDashSquared =
            (this._radiusEquator * this._radiusEquator - this._radiusPolar * this._radiusPolar) /
            (this._radiusPolar * this._radiusPolar);

        var sinTheta = Math.sin(theta);
        var cosTheta = Math.cos(theta);

        var latitude = Math.atan(
            (Z + eDashSquared * this._radiusPolar * sinTheta * sinTheta * sinTheta) /
                (p -
                    this._eccentricitySquared *
                        this._radiusEquator *
                        cosTheta *
                        cosTheta *
                        cosTheta)
        );
        var longitude = Math.atan2(Y, X);

        var sinLatitude = Math.sin(latitude);
        var N =
            this._radiusEquator /
            Math.sqrt(1.0 - this._eccentricitySquared * sinLatitude * sinLatitude);

        var cosLat = Math.cos(latitude);
        if (cosLat === 0) cosLat = 1;
        var height = p / cosLat - N;
        result[0] = latitude;
        result[1] = longitude;
        result[2] = height;
        return result;
    },
    computeLocalUpVector: function(X, Y, Z) {
        // Note latitude is angle between normal to ellipsoid surface and XY-plane
        var latitude, longitude;
        var coord = this.convertXYZToLatLongHeight(X, Y, Z, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create());
        latitude = coord[0];
        longitude = coord[1];

        // Compute up vector
        return [
            Math.cos(longitude) * Math.cos(latitude),
            Math.sin(longitude) * Math.cos(latitude),
            Math.sin(latitude)
        ];
    },
    isWGS84: function() {
        return (
            this._radiusEquator === EllipsoidModel.WGS_84_RADIUS_EQUATOR &&
            this._radiusPolar === EllipsoidModel.WGS_84_RADIUS_POLAR
        );
    },

    computeCoefficients: function() {
        var flattening = (this._radiusEquator - this._radiusPolar) / this._radiusEquator;
        this._eccentricitySquared = 2.0 * flattening - flattening * flattening;
    },
    computeLocalToWorldTransformFromLatLongHeight: function(latitude, longitude, height, result) {
        var pos = this.convertLatLongHeightToXYZ(latitude, longitude, height, result);
        __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].fromTranslation(result, pos);
        this.computeCoordinateFrame(latitude, longitude, result);
        return result;
    },
    computeLocalToWorldTransformFromXYZ: function(X, Y, Z) {
        var lla = this.convertXYZToLatLongHeight(X, Y, Z, __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create());
        var m = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].fromTranslation(__WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].create(), __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].fromValues(X, Y, Z));
        this.computeCoordinateFrame(lla[0], lla[1], m);
        return m;
    },
    computeCoordinateFrame: (function() {
        var up = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        var east = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        var north = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
        return function(latitude, longitude, localToWorld) {
            // Compute up vector
            up[0] = Math.cos(longitude) * Math.cos(latitude);
            up[1] = Math.sin(longitude) * Math.cos(latitude);
            up[2] = Math.sin(latitude);

            // Compute east vector
            east[0] = -Math.sin(longitude);
            east[1] = -Math.cos(longitude);

            // Compute north vector = outer product up x east
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].cross(north, up, east);

            // set matrix
            __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].set(
                localToWorld,
                east[0],
                east[1],
                east[2],
                0,
                north[0],
                north[1],
                north[2],
                0,
                up[0],
                up[1],
                up[2],
                0,
                0,
                0,
                0,
                1
            );
        };
    })()
};

/* harmony default export */ __webpack_exports__["a"] = (EllipsoidModel);


/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Image__ = __webpack_require__(45);




var ImageStream = function(video) {
    __WEBPACK_IMPORTED_MODULE_2_osg_Image__["a" /* default */].call(this, video);
    this._canPlayDefered = undefined;
};

ImageStream.PAUSE = 0;
ImageStream.PLAYING = 1;

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    ImageStream,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Image__["a" /* default */].prototype, {
        isDirty: function() {
            return this._status === ImageStream.PLAYING; // video is dirty if playing
        },

        setImage: function(video) {
            __WEBPACK_IMPORTED_MODULE_2_osg_Image__["a" /* default */].prototype.setImage.call(this, video);

            this._status = ImageStream.STOP;

            // event at the end of the stream
            video.addEventListener(
                'ended',
                function() {
                    if (!this._imageObject.loop) this.stop();
                }.bind(this),
                true
            );

            this.dirty();
        },

        setLooping: function(bool) {
            this._imageObject.loop = bool;
        },

        play: function() {
            this._imageObject.play();
            this._status = ImageStream.PLAYING;
        },

        stop: function() {
            this._imageObject.pause();
            this._status = ImageStream.PAUSE;
        },

        whenReady: function() {
            if (!this._imageObject) {
                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject();
            }
            var that = this;
            return new __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a(function(resolve) {
                if (!that._canPlayDefered) {
                    that._canPlayDefered = resolve;
                    // resolve directly if the event is already fired
                    if (that._imageObject.readyState > 3) that._canPlayDefered(that);
                    else
                        that._imageObject.addEventListener(
                            'canplaythrough',
                            that._canPlayDefered.bind(that._canPlayDefered, that),
                            true
                        );
                }
            });
        }
    }),
    'osg',
    'ImageStream'
);

/* harmony default export */ __webpack_exports__["a"] = (ImageStream);


/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_KdTree__ = __webpack_require__(118);




var KdTreeBuilder = function(options) {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this);
    this._buildOptions = {
        _numVerticesProcessed: 0,
        _targetNumTrianglesPerLeaf: 50,
        _maxNumLevels: 20
    };

    if (!options) return;

    // merge options
    var perLeaf = options._targetNumTrianglesPerLeaf;
    var maxLevel = options._maxNumLevels;

    if (perLeaf !== undefined) this._buildOptions._targetNumTrianglesPerLeaf = perLeaf;
    if (maxLevel !== undefined) this._buildOptions._maxNumLevels = maxLevel;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    KdTreeBuilder,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getShape) {
                var shape = node.getShape();
                // we test if the kdTree is already built and if we can build it (null means we skip it)
                if (shape === undefined) {
                    var kdTree = new __WEBPACK_IMPORTED_MODULE_2_osg_KdTree__["a" /* default */]();
                    if (kdTree.build(this._buildOptions, node)) {
                        node.setShape(kdTree);
                    }
                }
            }
            this.traverse(node);
        }
    }),
    'osg',
    'KdTreeBuilder'
);

/* harmony default export */ __webpack_exports__["a"] = (KdTreeBuilder);


/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);



var LineWidth = function(lineWidth) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);
    this.lineWidth = 1.0;
    if (lineWidth !== undefined) {
        this.lineWidth = lineWidth;
    }
};
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    LineWidth,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'LineWidth',
        cloneType: function() {
            return new LineWidth();
        },
        apply: function(state) {
            state.getGraphicContext().lineWidth(this.lineWidth);
        }
    }),
    'osg',
    'LineWidth'
);

/* harmony default export */ __webpack_exports__["a"] = (LineWidth);


/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__ = __webpack_require__(5);




var PointSizeAttribute = function(disable) {
    __WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].call(this);

    this._enable = !disable;
    this._pointSize = 1.0;
    // careful with this option if there is lines/triangles under the stateset
    this._circleShape = false;
    this._dirtyHash = true;
    this._hash = '';
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    PointSizeAttribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_StateAttribute__["a" /* default */].prototype, {
        attributeType: 'PointSize',

        cloneType: function() {
            return new PointSizeAttribute(true);
        },

        setCircleShape: function(bool) {
            this._circleShape = bool;
            this._dirtyHash = true;
        },

        isCircleShape: function() {
            return this._circleShape;
        },

        setEnabled: function(state) {
            this._enable = state;
            this._dirtyHash = true;
        },

        isEnabled: function() {
            return this._enable;
        },

        setPointSize: function(size) {
            this._pointSize = size;
        },

        getOrCreateUniforms: function() {
            var obj = PointSizeAttribute;
            if (obj.uniforms) return obj.uniforms;

            obj.uniforms = {
                pointSize: __WEBPACK_IMPORTED_MODULE_2_osg_Uniform__["a" /* default */].createFloat(1.0, 'uPointSize')
            };

            return obj.uniforms;
        },

        getHash: function() {
            if (!this._dirtyHash) return this._hash;

            this._hash = this._computeInternalHash();
            this._dirtyHash = false;
            return this._hash;
        },

        _computeInternalHash: function() {
            return (
                this.getTypeMember() +
                (this.isEnabled() ? '1' : '0') +
                (this._circleShape ? '1' : '0')
            );
        },

        apply: function() {
            if (!this._enable) return;

            var uniforms = this.getOrCreateUniforms();
            uniforms.pointSize.setFloat(this._pointSize);
        }
    }),
    'osg',
    'PointSizeAttribute'
);

/* harmony default export */ __webpack_exports__["a"] = (PointSizeAttribute);


/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__ = __webpack_require__(18);





/**
 * PrimitiveFunctor emulates the TemplatePrimitiveFunctor class in OSG and can
 * be used to get access to the vertices that compose the things drawn by osgjs.
 *
 * You have to feed it with an object that references 3 callbacks :
 *
 * var myObject = {
 *     operatorPoint : function ( v ) { }, // Do your point operations here
 *     operatorLine : function ( v1, v2 ){ }, // Do you line operations here
 *     operatorTriangle : function ( v1, v2, v3 ) { } // Do your triangle operations here
 * };
 *
 */

var functorDrawElements = [];
var functorDrawArrays = [];

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].POINTS] = (function() {
    var v = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var end = offset + count;
        for (var i = offset; i < end; ++i) {
            var j = indexes[i] * 3;
            v[0] = vertices[j];
            v[1] = vertices[j + 1];
            v[2] = vertices[j + 2];
            cb.operatorPoint(v);
        }
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINES] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var end = offset + count;
        for (var i = offset; i < end - 1; i += 2) {
            var j = indexes[i] * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = indexes[i + 1] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINE_STRIP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var end = offset + count;
        for (var i = offset; i < end - 1; ++i) {
            var j = indexes[i] * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = indexes[i + 1] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINE_LOOP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var last = offset + count - 1;
        for (var i = offset; i < last; ++i) {
            var j = indexes[i] * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = indexes[i + 1] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
        last = indexes[last] * 3;
        v1[0] = vertices[last];
        v1[1] = vertices[last + 1];
        v1[2] = vertices[last + 2];
        var first = indexes[0] * 3;
        v2[0] = vertices[first];
        v2[1] = vertices[first + 1];
        v2[2] = vertices[first + 2];
        cb.operatorLine(v1, v2);
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLES] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var end = offset + count;
        for (var i = offset; i < end; i += 3) {
            var j = indexes[i] * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = indexes[i + 1] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = indexes[i + 2] * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            cb.operatorTriangle(v1, v2, v3);
        }
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        for (var i = 2, pos = offset; i < count; ++i, ++pos) {
            var j = indexes[pos] * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = indexes[pos + 1] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = indexes[pos + 2] * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            if (i % 2) {
                cb.operatorTriangle(v1, v3, v2);
            } else {
                cb.operatorTriangle(v1, v2, v3);
            }
        }
    };
})();

functorDrawElements[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(offset, count, indexes, cb, vertices) {
        var first = indexes[offset];
        for (var i = 2, pos = offset + 1; i < count; ++i, ++pos) {
            v1[0] = vertices[first];
            v1[1] = vertices[first + 1];
            v1[2] = vertices[first + 2];
            var j = indexes[pos] * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = indexes[pos + 1] * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            cb.operatorTriangle(v1, v2, v3);
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].POINTS] = (function() {
    var v = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = first; i < first + count; ++i) {
            var j = i * 3;
            v[0] = vertices[j];
            v[1] = vertices[j + 1];
            v[2] = vertices[j + 2];
            cb.operatorPoint(v);
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINES] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = first; i < first + count - 1; i += 2) {
            var j = i * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = (i + 1) * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINE_STRIP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = first; i < first + count - 1; ++i) {
            var j = i * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = (i + 1) * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].LINE_LOOP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        var last = first + count - 1;
        for (var i = first; i < last; ++i) {
            var j = i * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = (i + 1) * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            cb.operatorLine(v1, v2);
        }
        last = last * 3;
        v1[0] = vertices[last];
        v1[1] = vertices[last + 1];
        v1[2] = vertices[last + 2];
        first = first * 3;
        v2[0] = vertices[first];
        v2[1] = vertices[first + 1];
        v2[2] = vertices[first + 2];
        cb.operatorLine(v1, v2);
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLES] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = first; i < first + count; i += 3) {
            var j = i * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = (i + 1) * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = (i + 2) * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            cb.operatorTriangle(v1, v2, v3);
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = 2, pos = first; i < count; ++i, ++pos) {
            var j = pos * 3;
            v1[0] = vertices[j];
            v1[1] = vertices[j + 1];
            v1[2] = vertices[j + 2];
            j = (pos + 1) * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = (pos + 2) * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            if (i % 2) {
                cb.operatorTriangle(v1, v3, v2);
            } else {
                cb.operatorTriangle(v1, v2, v3);
            }
        }
    };
})();

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_1_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = (function() {
    var v1 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v2 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    var v3 = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["f" /* vec3 */].create();
    return function(first, count, cb, vertices) {
        for (var i = 2, pos = first + 1; i < count; ++i, ++pos) {
            v1[0] = vertices[first];
            v1[1] = vertices[first + 1];
            v1[2] = vertices[first + 2];
            var j = pos * 3;
            v2[0] = vertices[j];
            v2[1] = vertices[j + 1];
            v2[2] = vertices[j + 2];
            j = (pos + 1) * 3;
            v3[0] = vertices[j];
            v3[1] = vertices[j + 1];
            v3[2] = vertices[j + 2];
            cb.operatorTriangle(v1, v2, v3);
        }
    };
})();

var primitiveFunctor = function(geom, cb, vertices) {
    var primitives = geom.getPrimitiveSetList();
    if (!primitives) return;

    var cbFunctor;

    var nbPrimitives = primitives.length;
    for (var i = 0; i < nbPrimitives; i++) {
        var primitive = primitives[i];
        if (primitive instanceof __WEBPACK_IMPORTED_MODULE_2_osg_DrawElements__["a" /* default */]) {
            cbFunctor = functorDrawElements[primitive.getMode()];
            if (cbFunctor) {
                var indexes = primitive.indices.getElements();
                cbFunctor(
                    primitive.getFirst() / indexes.BYTES_PER_ELEMENT,
                    primitive.getCount(),
                    indexes,
                    cb,
                    vertices
                );
            }
        } else if (primitive instanceof __WEBPACK_IMPORTED_MODULE_3_osg_DrawArrays__["a" /* default */]) {
            cbFunctor = functorDrawArrays[primitive.getMode()];
            if (cbFunctor) {
                cbFunctor(primitive.getFirst(), primitive.getCount(), cb, vertices);
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (primitiveFunctor);


/***/ }),
/* 200 */
/***/ (function(module, exports) {

module.exports = "#define PI 3.141593\n#define saturate(_x) clamp(_x, 0., 1.)\n"

/***/ }),
/* 201 */
/***/ (function(module, exports) {

module.exports = "// approximation such as http://chilliant.blogspot.fr/2012/08/srgb-approximations-for-hlsl.html\n// introduced slightly darker colors and more slight banding in the darks.\n\n// so we stick with the reference implementation (except we don't check if color >= 0.0):\n// https://www.khronos.org/registry/gles/extensions/EXT/EXT_sRGB.txt\n#define LIN_SRGB(x) x < 0.0031308 ? x * 12.92 : 1.055 * pow(x, 1.0/2.4) - 0.055\n#define SRGB_LIN(x) x < 0.04045 ? x * (1.0 / 12.92) : pow((x + 0.055) * (1.0 / 1.055), 2.4)\n\n#pragma DECLARE_FUNCTION\nfloat linearTosRGB(const in float color) { return LIN_SRGB(color); }\n\n#pragma DECLARE_FUNCTION\nvec3 linearTosRGB(const in vec3 color) { return vec3(LIN_SRGB(color.r), LIN_SRGB(color.g), LIN_SRGB(color.b)); }\n\n#pragma DECLARE_FUNCTION\nvec4 linearTosRGB(const in vec4 color) { return vec4(LIN_SRGB(color.r), LIN_SRGB(color.g), LIN_SRGB(color.b), color.a); }\n\n#pragma DECLARE_FUNCTION NODE_NAME:sRGBToLinear\nfloat sRGBToLinear(const in float color) { return SRGB_LIN(color); }\n\n#pragma DECLARE_FUNCTION NODE_NAME:sRGBToLinear\nvec3 sRGBToLinear(const in vec3 color) { return vec3(SRGB_LIN(color.r), SRGB_LIN(color.g), SRGB_LIN(color.b)); }\n\n#pragma DECLARE_FUNCTION NODE_NAME:sRGBToLinear\nvec4 sRGBToLinear(const in vec4 color) { return vec4(SRGB_LIN(color.r), SRGB_LIN(color.g), SRGB_LIN(color.b), color.a); }\n\n//http://graphicrants.blogspot.fr/2009/04/rgbm-color-encoding.html\nvec3 RGBMToRGB( const in vec4 rgba ) {\n    const float maxRange = 8.0;\n    return rgba.rgb * maxRange * rgba.a;\n}\n\nconst mat3 LUVInverse = mat3( 6.0013, -2.700, -1.7995, -1.332, 3.1029, -5.7720, 0.3007, -1.088, 5.6268 );\n\nvec3 LUVToRGB( const in vec4 vLogLuv ) {\n    float Le = vLogLuv.z * 255.0 + vLogLuv.w;\n    vec3 Xp_Y_XYZp;\n    Xp_Y_XYZp.y = exp2((Le - 127.0) / 2.0);\n    Xp_Y_XYZp.z = Xp_Y_XYZp.y / vLogLuv.y;\n    Xp_Y_XYZp.x = vLogLuv.x * Xp_Y_XYZp.z;\n    vec3 vRGB = LUVInverse * Xp_Y_XYZp;\n    return max(vRGB, 0.0);\n}\n\n// http://graphicrants.blogspot.fr/2009/04/rgbm-color-encoding.html\n#pragma DECLARE_FUNCTION\nvec4 encodeRGBM(const in vec3 color, const in float range) {\n    if(range <= 0.0) return vec4(color, 1.0);\n    vec4 rgbm;\n    vec3 col = color / range;\n    rgbm.a = clamp( max( max( col.r, col.g ), max( col.b, 1e-6 ) ), 0.0, 1.0 );\n    rgbm.a = ceil( rgbm.a * 255.0 ) / 255.0;\n    rgbm.rgb = col / rgbm.a;\n    return rgbm;\n}\n\n#pragma DECLARE_FUNCTION\nvec3 decodeRGBM(const in vec4 color, const in float range) {\n    if(range <= 0.0) return color.rgb;\n    return range * color.rgb * color.a;\n}\n\n// https://twitter.com/pyalot/status/711956736639418369\n// https://github.com/mrdoob/three.js/issues/10331\n#pragma DECLARE_FUNCTION NODE_NAME:FrontNormal\n#define _frontNormal(normal) gl_FrontFacing ? normal : -normal\n\n#pragma DECLARE_FUNCTION NODE_NAME:Normalize\n#define _normalize(vec) normalize(vec)\n\n#pragma DECLARE_FUNCTION\nvec4 preMultAlpha(const in vec3 color, const in float alpha) { return vec4(color.rgb * alpha, alpha); }\n\n#pragma DECLARE_FUNCTION\nvec4 preMultAlpha(const in vec4 color) { return vec4(color.rgb * color.a, color.a); }\n\n#pragma DECLARE_FUNCTION\nvec4 setAlpha(const in vec3 color, const in float alpha) { return vec4(color, alpha); }\n\n#pragma DECLARE_FUNCTION\nvec4 setAlpha(const in vec3 color, const in vec4 alpha) { return vec4(color, alpha.a); }\n"

/***/ }),
/* 202 */
/***/ (function(module, exports) {

module.exports = "float getLightAttenuation(const in float dist, const in vec4 lightAttenuation) {\n    // lightAttenuation(constantEnabled, linearEnabled, quadraticEnabled)\n    // TODO find a vector alu instead of 4 scalar\n    float constant = lightAttenuation.x;\n    float linear = lightAttenuation.y * dist;\n    float quadratic = lightAttenuation.z * dist * dist;\n    return 1.0 / (constant + linear + quadratic);\n}\n\n#pragma DECLARE_FUNCTION\nvoid precomputeSpot(\n        const in vec3 normal,\n        const in vec3 viewVertex,\n                          \n        const in vec3 lightViewDirection,\n        const in vec4 lightAttenuation,\n        const in vec3 lightViewPosition,\n        const in float lightSpotCutOff,\n        const in float lightSpotBlend,\n                          \n        out float attenuation,\n        out vec3 eyeLightDir,\n        out float dotNL) {\n\n    eyeLightDir = lightViewPosition - viewVertex;\n    float dist = length(eyeLightDir);\n    eyeLightDir = dist > 0.0 ? eyeLightDir / dist : vec3( 0.0, 1.0, 0.0 );\n\n    float cosCurAngle = dot(-eyeLightDir, lightViewDirection);\n    float spot = cosCurAngle * smoothstep(0.0, 1.0, (cosCurAngle - lightSpotCutOff) / lightSpotBlend);\n\n    dotNL = dot(eyeLightDir, normal);\n    attenuation = spot * getLightAttenuation(dist, lightAttenuation);\n}\n\n#pragma DECLARE_FUNCTION\nvoid precomputePoint(\n        const in vec3 normal,\n        const in vec3 viewVertex,\n\n        const in vec4 lightAttenuation,\n        const in vec3 lightViewPosition,\n\n        out float attenuation,\n        out vec3 eyeLightDir,\n        out float dotNL) {\n\n    eyeLightDir = lightViewPosition - viewVertex;\n    float dist = length(eyeLightDir);\n\n    attenuation = getLightAttenuation(dist, lightAttenuation);\n    eyeLightDir = dist > 0.0 ? eyeLightDir / dist :  vec3( 0.0, 1.0, 0.0 );\n    dotNL = dot(eyeLightDir, normal);\n}\n\n#pragma DECLARE_FUNCTION\nvoid precomputeSun(\n        const in vec3 normal,\n        const in vec3 lightViewDirection,\n  \n        out float attenuation,\n        out vec3 eyeLightDir,\n        out float dotNL) {\n\n    attenuation = 1.0;\n    eyeLightDir = -lightViewDirection;\n    dotNL = dot(eyeLightDir, normal);\n}"

/***/ }),
/* 203 */
/***/ (function(module, exports) {

module.exports = "#pragma include \"lightCommon.glsl\"\n\n////////////////\n// COOK TORRANCE\n////////////////\nvec3 specularCookTorrance(\n        const in vec3 normal,\n        const in vec3 lightDir,\n        const in vec3 eyeVector,\n        const in float materialShininess,\n        const in vec3 materialSpecular,\n        const in vec3 lightSpecular) {\n  \n    vec3 h = normalize(eyeVector + lightDir);\n    float nh = dot(normal, h);\n    float specfac = 0.0;\n\n    if(nh > 0.0) {\n        float nv = max( dot(normal, eyeVector), 0.0 );\n        float i = pow(nh, materialShininess);\n        i = i / (0.1 + nv);\n        specfac = i;\n    }\n    // ugly way to fake an energy conservation (mainly to avoid super bright stuffs with low glossiness)\n    float att = materialShininess > 100.0 ? 1.0 : smoothstep(0.0, 1.0, materialShininess * 0.01);\n    return specfac * materialSpecular * lightSpecular * att;\n}\n\nvec3 lambert(const in float dotNL,  const in vec3 materialDiffuse, const in vec3 lightDiffuse) {\n    return dotNL * materialDiffuse * lightDiffuse;\n}\n\n#pragma DECLARE_FUNCTION\nvoid computeLightLambertCookTorrance(\n        const in vec3 normal,\n        const in vec3 eyeVector,\n        const in float dotNL,\n        const in float attenuation,\n\n        const in vec3 materialDiffuse,\n        const in vec3 materialSpecular,\n        const in float materialShininess,\n\n        const in vec3 lightDiffuse,\n        const in vec3 lightSpecular,\n        const in vec3 eyeLightDir,\n\n        out vec3 diffuseOut,\n        out vec3 specularOut,\n        out bool lighted) {\n\n    lighted = dotNL > 0.0;\n    if (lighted == false) {\n        specularOut = diffuseOut = vec3(0.0);\n        return;\n    }\n\n    specularOut = attenuation * specularCookTorrance(normal, eyeLightDir, eyeVector, materialShininess, materialSpecular, lightSpecular);\n    diffuseOut = attenuation * lambert(dotNL, materialDiffuse, lightDiffuse);\n}\n\n///////\n// HEMI\n///////\n#pragma DECLARE_FUNCTION\nvoid hemiLight(\n        const in vec3 normal,\n        const in vec3 eyeVector,\n        const in float dotNL,\n        const in float eyeLightDir,\n\n        const in vec3 materialDiffuse,\n        const in vec3 materialSpecular,\n        const in float materialShininess,\n\n        const in vec3 lightDiffuse,\n        const in vec3 lightGround,\n\n        out vec3 diffuseOut,\n        out vec3 specularOut,\n        out bool lighted) {\n\n    lighted = false;\n    float weight = 0.5 * dotNL + 0.5;\n    diffuseOut = materialDiffuse * mix(lightGround, lightDiffuse, weight);\n\n    // same cook-torrance as above for sky/ground\n    float skyWeight = 0.5 * dot(normal, normalize(eyeVector + eyeLightDir)) + 0.5;\n    float gndWeight = 0.5 * dot(normal, normalize(eyeVector - eyeLightDir)) + 0.5;\n    float skySpec = pow(skyWeight, materialShininess);\n    float skyGround = pow(gndWeight, materialShininess);\n    float divisor = (0.1 + max( dot(normal, eyeVector), 0.0 ));\n    float att = materialShininess > 100.0 ? 1.0 : smoothstep(0.0, 1.0, materialShininess * 0.01);\n    \n    specularOut = lightDiffuse * materialSpecular * weight * att * (skySpec + skyGround) / divisor;\n}\n"

/***/ }),
/* 204 */
/***/ (function(module, exports) {

module.exports = "//////////////////////////////\n// OPTIMIZED VERSION (NO IF)\n//////////////////////////////\n#pragma DECLARE_FUNCTION\nmat4 skinning( const in vec4 weights, const in vec4 bonesIndex ) {\n    mat4 outMat_1;\n    mat4 tmpMat_2;\n    highp ivec4 tmpvar_3;\n    tmpvar_3 = (3 * ivec4(bonesIndex));\n    tmpMat_2 = mat4(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);\n    vec4 tmpvar_4;\n    tmpvar_4 = -(abs(weights));\n    tmpMat_2[0] = uBones[tmpvar_3.x];\n    tmpMat_2[1] = uBones[(tmpvar_3.x + 1)];\n    tmpMat_2[2] = uBones[(tmpvar_3.x + 2)];\n    outMat_1 = ((float(\n    ((tmpvar_4.x + tmpvar_4.y) >= -((tmpvar_4.z + tmpvar_4.w)))\n    ) * mat4(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0)) + (weights.x * tmpMat_2));\n    tmpMat_2[0] = uBones[tmpvar_3.y];\n    tmpMat_2[1] = uBones[(tmpvar_3.y + 1)];\n    tmpMat_2[2] = uBones[(tmpvar_3.y + 2)];\n    outMat_1 = (outMat_1 + (weights.y * tmpMat_2));\n    tmpMat_2[0] = uBones[tmpvar_3.z];\n    tmpMat_2[1] = uBones[(tmpvar_3.z + 1)];\n    tmpMat_2[2] = uBones[(tmpvar_3.z + 2)];\n    outMat_1 = (outMat_1 + (weights.z * tmpMat_2));\n    tmpMat_2[0] = uBones[tmpvar_3.w];\n    tmpMat_2[1] = uBones[(tmpvar_3.w + 1)];\n    tmpMat_2[2] = uBones[(tmpvar_3.w + 2)];\n    outMat_1 = (outMat_1 + (weights.w * tmpMat_2));\n\n    return outMat_1;\n}\n\n//////////////////////////////\n// UN-OPTIMIZED VERSION (WITH IF)\n//////////////////////////////\n\n// //http://http.developer.nvidia.com/GPUGems/gpugems_ch04.html\n// mat4 getMat4FromVec4( const int index, inout mat4 myMat ) {\n//     // We have to use a global variable because we can't access dynamically\n//     // matrix is transpose so we should do vec * matrix\n//     myMat[0] = uBones[ index ];\n//     myMat[1] = uBones[ index + 1];\n//     myMat[2] = uBones[ index + 2];\n//     return myMat;\n// }\n\n// mat4 skinning( const in vec4 weights, const in vec4 bonesIndex ) {\n//     ivec4 idx =  3 * ivec4(bonesIndex);\n//     mat4 tmpMat = mat4(1.0);\n//     mat4 outMat = mat4(0.0);\n\n//     // we handle negative weights\n//     if(all(equal(weights, vec4(0.0)))) return tmpMat;\n\n//     if(weights.x != 0.0) outMat += weights.x * getMat4FromVec4( idx.x, tmpMat );\n//     if(weights.y != 0.0) outMat += weights.y * getMat4FromVec4( idx.y, tmpMat );\n//     if(weights.z != 0.0) outMat += weights.z * getMat4FromVec4( idx.z, tmpMat );\n//     if(weights.w != 0.0) outMat += weights.w * getMat4FromVec4( idx.w, tmpMat );\n//     return outMat;\n// }\n\n//////////////////////////////\n// UN-OPTIMIZED VERSION (NO IF)\n//////////////////////////////\n\n// mat4 skinning( const in vec4 weights, const in vec4 bonesIndex ) {\n//     ivec4 idx =  3 * ivec4(bonesIndex);\n//     mat4 tmpMat = mat4(1.0);\n\n//     // if sum is 0, return identity\n//     vec4 absWeights = -abs(weights);\n//     mat4 outMat = step(0.0, absWeights.x + absWeights.y + absWeights.z + absWeights.w) * tmpMat;\n\n//     // we handle negative weights\n//     // outMat[3][3] += weights.x + weights.y + weights.z + weights.w;\n\n//     tmpMat[0] = uBones[ idx.x ];\n//     tmpMat[1] = uBones[ idx.x + 1];\n//     tmpMat[2] = uBones[ idx.x + 2];\n//     outMat += weights.x * tmpMat;\n\n//     tmpMat[0] = uBones[ idx.y ];\n//     tmpMat[1] = uBones[ idx.y + 1];\n//     tmpMat[2] = uBones[ idx.y + 2];\n//     outMat += weights.y * tmpMat;\n\n//     tmpMat[0] = uBones[ idx.z ];\n//     tmpMat[1] = uBones[ idx.z + 1];\n//     tmpMat[2] = uBones[ idx.z + 2];\n//     outMat += weights.z * tmpMat;\n\n//     tmpMat[0] = uBones[ idx.w ];\n//     tmpMat[1] = uBones[ idx.w + 1];\n//     tmpMat[2] = uBones[ idx.w + 2];\n//     outMat += weights.w * tmpMat;\n\n//     return outMat;\n// }\n"

/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = "#pragma DECLARE_FUNCTION\nvec3 morphing(\n        const in vec4 weights,\n        const in vec3 vertex,\n        const in vec3 target0) {\n\n    return mix(vertex, target0, weights[0]);\n}\n\n#pragma DECLARE_FUNCTION\nvec3 morphing(\n        const in vec4 weights,\n        const in vec3 vertex,\n        const in vec3 target0,\n        const in vec3 target1) {\n\n    vec3 vecOut = vertex * (1.0 - ( weights[0] + weights[1]));\n    vecOut += target0 * weights[0];\n    vecOut += target1 * weights[1];\n    return vecOut;\n}\n\n#pragma DECLARE_FUNCTION\nvec3 morphing(\n        const in vec4 weights,\n        const in vec3 vertex,\n        const in vec3 target0,\n        const in vec3 target1,\n        const in vec3 target2) {\n  \n    vec3 vecOut = vertex * (1.0 - ( weights[0] + weights[1] + weights[2]));\n    vecOut += target0 * weights[0];\n    vecOut += target1 * weights[1];\n    vecOut += target2 * weights[2];\n    return vecOut;\n}\n\n#pragma DECLARE_FUNCTION\nvec3 morphing(\n        const in vec4 weights,\n        const in vec3 vertex,\n        const in vec3 target0,\n        const in vec3 target1,\n        const in vec3 target2,\n        const in vec3 target3) {\n\n    vec3 vecOut = vertex * (1.0 - ( weights[0] + weights[1] + weights[2] + weights[3]));\n    vecOut += target0 * weights[0];\n    vecOut += target1 * weights[1];\n    vecOut += target2 * weights[2];\n    vecOut += target3 * weights[3];\n    return vecOut;\n}\n"

/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = "#pragma DECLARE_FUNCTION\nvec3 textureRGB(const in sampler2D tex, const in vec2 uv) {\n    return texture2D(tex, uv.xy).rgb;\n}\n\n#pragma DECLARE_FUNCTION\nvec4 textureRGBA(const in sampler2D tex, const in vec2 uv) {\n    return texture2D(tex, uv.xy).rgba;\n}\n\n#pragma DECLARE_FUNCTION\nfloat textureIntensity(const in sampler2D tex, const in vec2 uv) {\n    return texture2D(tex, uv).r;\n}\n\n#pragma DECLARE_FUNCTION\nfloat textureAlpha(const in sampler2D tex, const in vec2 uv) {\n    return texture2D(tex, uv.xy).a;\n}\n"

/***/ }),
/* 207 */
/***/ (function(module, exports) {

module.exports = "\nfloat decodeFloatRGBA( vec4 rgba ) {\n    return dot( rgba, vec4(1.0, 1.0/255.0, 1.0/65025.0, 1.0/16581375.0) );\n}\n\nvec4 encodeFloatRGBA( float v ) {\n    vec4 enc = vec4(1.0, 255.0, 65025.0, 16581375.0) * v;\n    enc = fract(enc);\n    enc -= enc.yzww * vec4(1.0/255.0,1.0/255.0,1.0/255.0,0.0);\n    return enc;\n}\n\nvec2 decodeHalfFloatRGBA( vec4 rgba ) {\n    return vec2(rgba.x + (rgba.y / 255.0), rgba.z + (rgba.w / 255.0));\n}\n\nvec4 encodeHalfFloatRGBA( vec2 v ) {\n    const vec2 bias = vec2(1.0 / 255.0, 0.0);\n    vec4 enc;\n    enc.xy = vec2(v.x, fract(v.x * 255.0));\n    enc.xy = enc.xy - (enc.yy * bias);\n\n    enc.zw = vec2(v.y, fract(v.y * 255.0));\n    enc.zw = enc.zw - (enc.ww * bias);\n    return enc;\n}\n"

/***/ }),
/* 208 */
/***/ (function(module, exports) {

module.exports = "vec3 getScale( const in mat4 matrix ) {\n      // Only working with positive scales.\n      float xs = matrix[0][0] * matrix[0][1] * matrix[0][2] * matrix[0][3] < 0. ? -1. : 1.;\n      float ys = matrix[1][0] * matrix[1][1] * matrix[1][2] * matrix[1][3] < 0. ? -1. : 1.;\n      float zs = matrix[2][0] * matrix[2][1] * matrix[2][2] * matrix[2][3] < 0. ? -1. : 1.;\n      vec3 scale;\n      scale.x = xs * sqrt( matrix[0][0] * matrix[0][0] + matrix[0][1] * matrix[0][1] + matrix[0][2] * matrix[0][2]);\n      scale.y = ys * sqrt( matrix[1][0] * matrix[1][0] + matrix[1][1] * matrix[1][1] + matrix[1][2] * matrix[1][2]);\n      scale.z = zs * sqrt( matrix[2][0] * matrix[2][0] + matrix[2][1] * matrix[2][1] + matrix[2][2] * matrix[2][2]);\n      return scale;\n}\n\n#pragma DECLARE_FUNCTION\nvec4 billboard( const in vec3 vertex, const in mat4 modelViewMatrix, const in mat4 projectionMatrix ) {\n      vec3 scale = getScale( modelViewMatrix );\n      return projectionMatrix * ( vec4( scale.x* vertex.x , scale.y * vertex.y, scale.z * vertex.z, 1.0 ) + vec4( modelViewMatrix[ 3 ].xyz, 0.0 ) );\n}\n"

/***/ }),
/* 209 */
/***/ (function(module, exports) {

module.exports = "#pragma include \"colorEncode.glsl\"\n\n#pragma DECLARE_FUNCTION\nvec4 shadowCast(const in vec4 fragEye, const in vec2 shadowDepthRange){\n    // distance to camera (we make sure we are near 0 and in [0,1])\n    float depth = (-fragEye.z * fragEye.w - shadowDepthRange.x) / (shadowDepthRange.y - shadowDepthRange.x);\n\n#ifdef _FLOATTEX\n    return vec4(depth, 0.0, 0.0, 1.0);\n#else\n    return encodeFloatRGBA(depth);\n#endif\n}\n"

/***/ }),
/* 210 */
/***/ (function(module, exports) {

module.exports = "#ifdef _OUT_DISTANCE\n#define OPT_ARG_outDistance ,out float outDistance\n#define OPT_INSTANCE_ARG_outDistance ,outDistance\n#else\n#define OPT_ARG_outDistance\n#define OPT_INSTANCE_ARG_outDistance\n#endif\n\n#ifdef _ATLAS_SHADOW\n#define OPT_ARG_atlasSize ,const in vec4 atlasSize\n#else\n#define OPT_ARG_atlasSize\n#endif\n\n#ifdef _NORMAL_OFFSET\n#define OPT_ARG_normalBias ,const in float normalBias\n#else\n#define OPT_ARG_normalBias\n#endif\n\n#ifdef _JITTER_OFFSET\n#define OPT_ARG_jitter ,const in float jitter\n#define OPT_INSTANCE_ARG_jitter ,jitter\n#else\n#define OPT_ARG_jitter\n#define OPT_INSTANCE_ARG_jitter\n#endif\n\n#pragma include \"tapPCF.glsl\"\n\n#pragma DECLARE_FUNCTION DERIVATIVES:enable\nfloat shadowReceive(const in bool lighted,\n                    const in vec3 normalWorld,\n                    const in vec3 vertexWorld,\n\n                    const in sampler2D shadowTexture,\n\n                    const in vec2 shadowSize,\n                    const in vec3 shadowProjection,\n\n                    const in vec4 shadowViewRight,\n                    const in vec4 shadowViewUp,\n                    const in vec4 shadowViewLook,\n\n\n                    const in vec2 shadowDepthRange,\n                    const in float shadowBias\n                    OPT_ARG_atlasSize\n                    OPT_ARG_normalBias\n                    OPT_ARG_outDistance\n                    OPT_ARG_jitter) {\n\n    // 0 for early out\n    bool earlyOut = false;\n\n    // Calculate shadow amount\n    float shadow = 1.0;\n\n    if (!lighted) {\n        shadow = 0.0;\n#ifndef _OUT_DISTANCE\n        earlyOut = true;\n#endif // _OUT_DISTANCE\n    }\n\n    if (shadowDepthRange.x == shadowDepthRange.y) {\n        earlyOut = true;\n    }\n\n    vec4 shadowVertexEye;\n    vec4 shadowNormalEye;\n    float shadowReceiverZ = 0.0;\n    vec4 shadowVertexProjected;\n    vec2 shadowUV;\n    float N_Dot_L;\n    float invDepthRange;\n\n    if (!earlyOut) {\n\n        shadowVertexEye.x = dot(shadowViewRight.xyz, vertexWorld.xyz) + shadowViewRight.w;\n        shadowVertexEye.y = dot(shadowViewUp.xyz, vertexWorld.xyz) + shadowViewUp.w;\n        shadowVertexEye.z = dot(shadowViewLook.xyz, vertexWorld.xyz) + shadowViewLook.w;\n        shadowVertexEye.w = 1.0;\n\n\n        // derivated, only need z.\n        //vec3 shadowLightDir = vec3(0.0, 0.0, 1.0); // in shadow view light is camera\n        //shadowNormalEye =  shadowViewMatrix * normalFront;\n        //shadowNormalEye.x = dot(shadowViewRight.xyz, normalWorld.xyz);\n        //shadowNormalEye.y = dot(shadowViewUp.xyz, normalWorld.xyz);\n        shadowNormalEye.z = dot(shadowViewLook.xyz, normalWorld.xyz);\n        //shadowNormalEye.w = 0.0;\n\n        //N_Dot_L = dot(shadowNormalEye.xyz, shadowLightDir);\n        N_Dot_L = shadowNormalEye.z;\n\n        if (!earlyOut) {\n\n            invDepthRange = 1.0 / (shadowDepthRange.y - shadowDepthRange.x);\n\n#ifdef _NORMAL_OFFSET\n\n            // http://www.dissidentlogic.com/old/images/NormalOffsetShadows/GDC_Poster_NormalOffset.png\n            float normalOffsetScale = clamp(1.0  - N_Dot_L, 0.0 , 1.0);\n            normalOffsetScale *= abs((shadowVertexEye.z - shadowDepthRange.x) * invDepthRange);\n            normalOffsetScale *= max(shadowProjection.x, shadowProjection.y);\n            normalOffsetScale *= normalBias * invDepthRange;\n\n\n            vec4 shadowNormalShift =  vec4(normalWorld, 0.0) * normalOffsetScale;\n            shadowNormalEye.x = dot(shadowViewRight.xyz, shadowNormalShift.xyz);\n            shadowNormalEye.y = dot(shadowViewUp.xyz, shadowNormalShift.xyz);\n            shadowNormalEye.z = dot(shadowViewLook.xyz, shadowNormalShift.xyz);\n            shadowNormalEye.w = 0.0;\n\n            vec4 viewShadow = shadowVertexEye + shadowNormalEye;\n#else\n            vec4 viewShadow = shadowVertexEye;\n#endif\n\n\n            if (shadowProjection.z == 0.0){\n\n               // X, 0, 0, 0,\n               // 0, Y, 0, 0,\n               // 0, 0, -1, -1,\n               // 0, 0, -2.0*znear, 0\n               // mat4 shadowProjectionMatrix;\n               // shadowProjectionMatrix[0] = vec4(shadowProjection.x, 0.0, 0.0, 0.0 );\n               // shadowProjectionMatrix[1] = vec4(0.0, shadowProjection.y, 0.0, 0.0 );\n               // shadowProjectionMatrix[2] = vec4(0.0, 0.0, -1.0, -1.0 );\n               // shadowProjectionMatrix[3] = vec4(0.0, 0.0, -2.0*shadowDepthRange.x, 0.0 );\n               // shadowVertexProjected = shadowProjectionMatrix * shadowVertexEye;\n\n               // derivated optimisation\n               shadowVertexProjected.x = shadowProjection.x * viewShadow.x;\n               shadowVertexProjected.y = shadowProjection.y * viewShadow.y;\n\n               shadowVertexProjected.z = - viewShadow.z - (2.0 * shadowDepthRange.x * viewShadow.w);\n               shadowVertexProjected.w = - viewShadow.z;\n\n            }\n            else{\n                // lr = 1/(left-right);\n                // bt = 1/(bottom-top);\n                // nf = 1/(near-far);\n                // -2*lr,           0,               0,              0,\n                // 0,               -2*bt,           0,              0,\n                // 0,               0,               2*nf,           0.0,\n                // (left+right)*lr, (top+bottom)*bt, (far+near)*nf), 1\n                // here left = -right && top = -bottom\n                // float lr = 1.0 / (-2.0 * shadowProjection.x);\n                // float bt = 1.0 / (-2.0 * shadowProjection.y);\n                // float nf = 1.0 / (shadowDepthRange.x - shadowDepthRange.y);\n                float nfNeg = 1.0 / (shadowDepthRange.x - shadowDepthRange.y);\n                float nfPos = (shadowDepthRange.x + shadowDepthRange.y)*nfNeg;\n\n                //mat4 shadowProjectionMatrix;\n                //shadowProjectionMatrix[0] = vec4(1.0 / shadowProjection.x, 0.0,     0.0,  0.0 );\n                //shadowProjectionMatrix[1] = vec4(0.0,     1.0 / shadowProjection.y, 0.0,  0.0 );\n                //shadowProjectionMatrix[2] = vec4(0.0,     0.0, 2.0*nfNeg, 0.0 );\n                //shadowProjectionMatrix[3] = vec4(0.0,     0.0, nfPos, 1.0 );\n                //shadowdertexProjected = shadowProjectionMatrix * shadowVertexEye;\n\n                // derivated optimisation\n                shadowVertexProjected.x = viewShadow.x / shadowProjection.x;\n                shadowVertexProjected.y = viewShadow.y / shadowProjection.y;\n\n                shadowVertexProjected.z = 2.0 * nfNeg* viewShadow.z + nfPos * viewShadow.w;\n                shadowVertexProjected.w = viewShadow.w;\n\n            }\n\n\n            if (shadowVertexProjected.w < 0.0) {\n                earlyOut = true; // notably behind camera\n            }\n\n        }\n\n        if (!earlyOut) {\n\n            shadowUV.xy = shadowVertexProjected.xy / shadowVertexProjected.w;\n            shadowUV.xy = shadowUV.xy * 0.5 + 0.5;// mad like\n\n            if (any(bvec4 ( shadowUV.x > 1., shadowUV.x < 0., shadowUV.y > 1., shadowUV.y < 0.))) {\n                earlyOut = true;// limits of light frustum\n            }\n\n            // most precision near 0, make sure we are near 0 and in [0,1]\n            shadowReceiverZ = - shadowVertexEye.z;\n            shadowReceiverZ =  (shadowReceiverZ - shadowDepthRange.x) * invDepthRange;\n\n            if(shadowReceiverZ < 0.0) {\n                earlyOut = true; // notably behind camera\n            }\n\n        }\n    }\n\n    // pcf pbias to add on offset\n    vec2 shadowBiasPCF = vec2 (0.);\n\n#ifdef GL_OES_standard_derivatives\n#ifdef _RECEIVERPLANEDEPTHBIAS\n    vec2 biasUV;\n\n    vec3 texCoordDY = dFdx(shadowVertexEye.xyz);\n    vec3 texCoordDX = dFdy(shadowVertexEye.xyz);\n\n    biasUV.x = texCoordDY.y * texCoordDX.z - texCoordDX.y * texCoordDY.z;\n    biasUV.y = texCoordDX.x * texCoordDY.z - texCoordDY.x * texCoordDX.z;\n    biasUV *= 1.0 / ((texCoordDX.x * texCoordDY.y) - (texCoordDX.y * texCoordDY.x));\n\n    // Static depth biasing to make up for incorrect fractional sampling on the shadow map grid\n    float fractionalSamplingError = dot(vec2(1.0, 1.0) * shadowSize.xy, abs(biasUV));\n    float receiverDepthBias = min(fractionalSamplingError, 0.01);\n\n    shadowBiasPCF.x = biasUV.x;\n    shadowBiasPCF.y = biasUV.y;\n\n    shadowReceiverZ += receiverDepthBias;\n\n#else // _RECEIVERPLANEDEPTHBIAS\n    shadowBiasPCF.x = clamp(dFdx(shadowReceiverZ) * shadowSize.x, -1.0, 1.0 );\n    shadowBiasPCF.y = clamp(dFdy(shadowReceiverZ) * shadowSize.y, -1.0, 1.0 );\n#endif\n\n#endif // GL_OES_standard_derivatives\n\n\n    vec4 clampDimension;\n\n#ifdef _ATLAS_SHADOW\n    shadowUV.xy  = ((shadowUV.xy * atlasSize.zw ) + atlasSize.xy) * shadowSize.xy;\n\n    // clamp uv bias/filters by half pixel to avoid point filter on border\n    clampDimension.xy = atlasSize.xy + vec2(0.5);\n    clampDimension.zw = (atlasSize.xy + atlasSize.zw) - vec2(0.5);\n\n    clampDimension = clampDimension * shadowSize.xyxy;\n#else\n    clampDimension = vec4(0.0, 0.0, 1.0, 1.0);\n#endif // _RECEIVERPLANEDEPTHBIAS\n\n\n    // now that derivatives is done and we don't access any mipmapped/texgrad texture we can early out\n    // see http://teknicool.tumblr.com/post/77263472964/glsl-dynamic-branching-and-texture-samplers\n    if (earlyOut) {\n        // empty statement because of weird gpu intel bug\n    } else {\n\n        // depth bias: fighting shadow acne (depth imprecsion z-fighting)\n        // cosTheta is dot( n, l ), clamped between 0 and 1\n        // float shadowBias = 0.005*tan(acos(N_Dot_L));\n        // same but 4 cycles instead of 15\n        float depthBias = 0.05 * sqrt( 1.0 - N_Dot_L * N_Dot_L) / clamp(N_Dot_L, 0.0005, 1.0);\n\n        // That makes sure that plane perpendicular to light doesn't flicker due to\n        // selfshadowing and 1 = dot(Normal, Light) using a min bias\n        depthBias = clamp(depthBias, 0.00005, 2.0 * shadowBias);\n\n        // shadowZ must be clamped to [0,1]\n        // otherwise it's not comparable to shadow caster depth map\n        // which is clamped to [0,1]\n        // Not doing that makes ALL shadowReceiver > 1.0 black\n        // because they ALL becomes behind any point in Caster depth map\n        shadowReceiverZ = clamp(shadowReceiverZ, 0.0, 1.0 -depthBias) - depthBias;\n\n        // Now computes Shadow\n        float res = getShadowPCF(shadowTexture,\n                                 shadowSize,\n                                 shadowUV,\n                                 shadowReceiverZ,\n                                 shadowBiasPCF,\n                                 clampDimension\n                                 OPT_INSTANCE_ARG_outDistance\n                                 OPT_INSTANCE_ARG_jitter);\n#ifdef _OUT_DISTANCE\n        if (lighted) shadow = res;\n        outDistance *= shadowDepthRange.y - shadowDepthRange.x; // world space distance\n#else\n        shadow = res;\n#endif  // _OUT_DISTANCE\n    }\n\n    return shadow;\n\n}\n"

/***/ }),
/* 211 */
/***/ (function(module, exports) {

module.exports = "#pragma include \"floatFromTex.glsl\"\n\n// simulation of texture2Dshadow glsl call on HW\n// http://codeflow.org/entries/2013/feb/15/soft-shadow-mapping/\nfloat texture2DCompare(const in sampler2D depths,\n                       const in vec2 uv,\n                       const in float compare,\n                       const in vec4 clampDimension){\n    float depth = getSingleFloatFromTex(depths, clamp(uv, clampDimension.xy, clampDimension.zw));\n    return compare - depth;\n}\n\n#ifdef _JITTER_OFFSET\n#define INT_SCALE3_JITTER vec3(.1031, .1030, .0973)\n// uniform rand\nvec3 randJitter(const in vec3 p2) {\n    vec3 p3  = fract(p2.xyz * INT_SCALE3_JITTER);\n    p3 += dot(p3, p3.yzx + 19.19);\n    p3 = fract((p3.xxy + p3.yzz) * p3.zyx);\n    return p3;\n}\n#endif\n\n// simulates linear fetch like texture2d shadow\nfloat texture2DShadowLerp(\n    const in sampler2D depths,\n    const in vec2 size,\n    const in vec2 uv,\n    const in float compare,\n    const in vec4 clampDimension\n    OPT_ARG_outDistance\n    OPT_ARG_jitter){\n\n    vec2 centroidCoord = uv / size.xy;\n\n#ifdef _JITTER_OFFSET\n    if (jitter > 0.0){\n        centroidCoord += randJitter(vec3(gl_FragCoord.xy, jitter)).xy;\n    }\n#endif\n\n    centroidCoord = centroidCoord + 0.5;\n    vec2 f = fract(centroidCoord);\n    vec2 centroidUV = floor(centroidCoord) * size.xy;\n\n    vec4 fetches;\n    const vec2 shift  = vec2(1.0, 0.0);\n    fetches.x = texture2DCompare(depths, centroidUV + size.xy * shift.yy, compare, clampDimension);\n    fetches.y = texture2DCompare(depths, centroidUV + size.xy * shift.yx, compare, clampDimension);\n    fetches.z = texture2DCompare(depths, centroidUV + size.xy * shift.xy, compare, clampDimension);\n    fetches.w = texture2DCompare(depths, centroidUV + size.xy * shift.xx, compare, clampDimension);\n\n\n\n#ifdef _OUT_DISTANCE\n    float _a = mix(fetches.x, fetches.y, f.y);\n    float _b = mix(fetches.z, fetches.w, f.y);\n    outDistance = mix(_a, _b, f.x);\n#endif\n\n    vec4 st = step(fetches, vec4(0.0));\n\n    float a = mix(st.x, st.y, f.y);\n    float b = mix(st.z, st.w, f.y);\n    return mix(a, b, f.x);\n}\n"

/***/ }),
/* 212 */
/***/ (function(module, exports) {

module.exports = "#pragma include \"colorEncode.glsl\"\n\n// end Float codec\nfloat getSingleFloatFromTex(const in sampler2D depths, const in vec2 uv){\n#ifndef _FLOATTEX\n    return  decodeFloatRGBA(texture2D(depths, uv));\n#else\n    return texture2D(depths, uv).x;\n#endif\n}\n\nvec2 getDoubleFloatFromTex(const in sampler2D depths, const in vec2 uv){\n#ifndef _FLOATTEX\n    return decodeHalfFloatRGBA(texture2D(depths, uv));\n#else\n    return texture2D(depths, uv).xy;\n#endif\n}\n\nvec4 getQuadFloatFromTex(const in sampler2D depths, const in vec2 uv){\n    return texture2D(depths, uv).xyzw;\n}\n// end Float codec\n"

/***/ }),
/* 213 */
/***/ (function(module, exports) {

module.exports = "#pragma include \"shadowLinearSoft.glsl\"\n\nfloat getShadowPCF(\n    const in sampler2D depths,\n    const in vec2 size,\n    const in vec2 uv,\n    const in float compare,\n    const in vec2 biasPCF,\n    const in vec4 clampDimension\n    OPT_ARG_outDistance\n    OPT_ARG_jitter) {\n\n     float res = 0.0;\n\n     res += texture2DShadowLerp(depths, size, uv + biasPCF, compare, clampDimension OPT_INSTANCE_ARG_outDistance OPT_INSTANCE_ARG_jitter);\n\n\n#if defined(_PCFx1)\n\n#else\n\n    float dx0 = -size.x;\n    float dy0 = -size.y;\n    float dx1 = size.x;\n    float dy1 = size.y;\n\n#define TSF(o1,o2) texture2DShadowLerp(depths, size, uv + vec2(o1, o2) + biasPCF, compare, clampDimension OPT_INSTANCE_ARG_outDistance OPT_INSTANCE_ARG_jitter)\n\n    res += TSF(dx0, dx0);\n    res += TSF(dx0, .0);\n    res += TSF(dx0, dx1);\n\n#if defined(_PCFx4)\n\n    res /=4.0;\n\n#elif defined(_PCFx9)\n    res += TSF(.0, dx0);\n    res += TSF(.0, dx1);\n\n    res += TSF(dx1, dx0);\n    res += TSF(dx1, .0);\n    res += TSF(dx1, dx1);\n\n\n    res /=9.0;\n\n#elif defined(_PCFx25)\n\n    float dx02 = 2.0*dx0;\n    float dy02 = 2.0*dy0;\n    float dx2 = 2.0*dx1;\n    float dy2 = 2.0*dy1;\n\n    // complete row above\n    res += TSF(dx0, dx02);\n    res += TSF(dx0, dx2);\n\n    res += TSF(.0, dx02);\n    res += TSF(.0, dx2);\n\n    res += TSF(dx1, dx02);\n    res += TSF(dx1, dx2);\n\n    // two new col\n    res += TSF(dx02, dx02);\n    res += TSF(dx02, dx0);\n    res += TSF(dx02, .0);\n    res += TSF(dx02, dx1);\n    res += TSF(dx02, dx2);\n\n    res += TSF(dx2, dx02);\n    res += TSF(dx2, dx0);\n    res += TSF(dx2, .0);\n    res += TSF(dx2, dx1);\n    res += TSF(dx2, dx2);\n\n\n    res/=25.0;\n\n#endif\n\n#undef TSF\n\n#endif\n    return res;\n}\n/////// end Tap\n"

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_CullFace__ = __webpack_require__(47);




// To avoid to apply duplicate states we cache them and apply them only
// when there is a draw commands it means when calling state.drawGeometry
// called from Geometry.drawImplementation or state.clear

// Here what it does:
// state.applyCullFaceAttribute(cullFaceDisableAttribute);
// state.applyCullFaceAttribute(cullFaceEnableAttribute);
// state.applyCullFaceAttribute(cullFaceDisableAttribute);
// state.applyCullFaceAttribute(cullFaceEnableAttribute);
// state.drawGeometry()

//     in this case only the cullFaceEnableAttribute will be applied not the previous one

// Internal implementation use 2 buffers:
//     - buffer, it contains the required field that will be applied when executing a draw command
//     - state, that contains the last state appied to webgl, it's used to compare if a
//              change happend from the incoming attribute

var createStateBlendFunc = function() {
    return {
        buffer: {
            separate: false,
            enable: false,
            sourceFactor: __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].ONE,
            destinationFactor: __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].ZERO,
            sourceFactorAlpha: __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].ONE,
            destinationFactorAlpha: __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].ZERO
        },
        state: {
            separate: undefined,
            enable: false,
            sourceFactor: undefined,
            destinationFactor: undefined,
            sourceFactorAlpha: undefined,
            destinationFactorAlpha: undefined
        },
        changed: true
    };
};

var createStateDepth = function() {
    return {
        buffer: {
            func: __WEBPACK_IMPORTED_MODULE_0_osg_Depth__["a" /* default */].LESS,
            enable: false,
            near: 0.0,
            far: 1.0
        },
        state: {
            func: undefined,
            enable: false,
            near: undefined,
            far: undefined
        },
        changed: true
    };
};

var createStateCullFace = function() {
    return {
        buffer: {
            enable: false,
            mode: __WEBPACK_IMPORTED_MODULE_2_osg_CullFace__["a" /* default */].BACK
        },
        state: {
            enable: false,
            mode: undefined
        },
        changed: true
    };
};

var createStateScissor = function() {
    return {
        buffer: {
            enable: false,
            x: 0,
            y: 0,
            width: 640,
            height: 480
        },
        state: {
            enable: false,
            x: undefined,
            y: undefined,
            width: undefined,
            height: undefined
        },
        changed: true
    };
};

var createStateColorMask = function() {
    return {
        buffer: {
            red: true,
            green: true,
            blue: true,
            alpha: true
        },
        state: {
            red: undefined,
            green: undefined,
            blue: undefined,
            alpha: undefined
        },
        changed: true
    };
};

var createStateViewport = function() {
    return {
        buffer: {
            x: 0,
            y: 0,
            width: 640,
            height: 480
        },
        state: {
            x: undefined,
            y: undefined,
            width: undefined,
            height: undefined
        },
        changed: true
    };
};

var createStateDepthMask = function() {
    return {
        state: { value: true },
        buffer: { value: undefined },
        changed: true
    };
};

var createStateClearDepth = function() {
    return {
        buffer: { value: 1.0 },
        state: { value: undefined },
        changed: true
    };
};

var createStateClearColor = function() {
    return {
        buffer: {
            red: 0.0,
            green: 0.0,
            blue: 0.0,
            alpha: 0.0
        },
        state: {
            red: undefined,
            green: undefined,
            blue: undefined,
            alpha: undefined
        },
        changed: true
    };
};

var StateCache = function() {
    this._stateClearColor = createStateClearColor();
    this._stateClearDepth = createStateClearDepth();
    this._stateDepthMask = createStateDepthMask();
    this._stateViewport = createStateViewport();
    this._stateColorMask = createStateColorMask();
    this._stateScissor = createStateScissor();
    this._stateDepth = createStateDepth();
    this._stateCullFace = createStateCullFace();
    this._stateBlendFunc = createStateBlendFunc();
};

StateCache.prototype = {
    clearColor: function(array) {
        var data = this._stateClearColor;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.red = array[0];
        buffer.green = array[1];
        buffer.blue = array[2];
        buffer.alpha = array[3];

        if (
            state.red !== array[0] ||
            state.green !== array[1] ||
            state.blue !== array[2] ||
            state.alpha !== array[3]
        ) {
            data.changed = true;
        }
    },

    applyClearColor: function(gl) {
        var data = this._stateClearColor;
        var state = data.state;
        var buffer = data.buffer;
        data.changed = false;
        state.red = buffer.red;
        state.green = buffer.green;
        state.blue = buffer.blue;
        state.alpha = buffer.alpha;
        gl.clearColor(state.red, state.green, state.blue, state.alpha);
    },

    clearDepth: function(value) {
        var data = this._stateClearDepth;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.value = value;

        if (state.value !== value) {
            data.changed = true;
        }
    },

    applyClearDepth: function(gl) {
        var data = this._stateClearDepth;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;
        state.value = buffer.value;
        gl.clearDepth(state.value);
    },

    depthMask: function(value) {
        var data = this._stateDepthMask;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.value = value;

        if (state.value !== value) {
            data.changed = true;
        }
    },

    applyDepthMask: function(gl) {
        var data = this._stateDepthMask;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;
        state.value = buffer.value;
        gl.depthMask(state.value);
    },

    applyViewportAttribute: function(attribute) {
        this.viewport(attribute._x, attribute._y, attribute._width, attribute._height);
    },

    viewport: function(x, y, width, height) {
        var data = this._stateViewport;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.x = x;
        buffer.y = y;
        buffer.width = width;
        buffer.height = height;

        if (state.x !== x || state.y !== y || state.width !== width || state.height !== height) {
            data.changed = true;
        }
    },

    applyViewport: function(gl) {
        var data = this._stateViewport;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;
        state.x = buffer.x;
        state.y = buffer.y;
        state.width = buffer.width;
        state.height = buffer.height;
        gl.viewport(state.x, state.y, state.width, state.height);
    },

    applyColorMaskAttribute: function(attribute) {
        var data = this._stateColorMask;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.red = attribute._red;
        buffer.green = attribute._green;
        buffer.blue = attribute._blue;
        buffer.alpha = attribute._alpha;

        if (
            state.red !== attribute._red ||
            state.green !== attribute._green ||
            state.blue !== attribute._blue ||
            state.alpha !== attribute._alpha
        ) {
            data.changed = true;
        }
    },

    applyColorMask: function(gl) {
        var data = this._stateColorMask;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;
        state.red = buffer.red;
        state.green = buffer.green;
        state.blue = buffer.blue;
        state.alpha = buffer.alpha;
        gl.colorMask(state.red, state.green, state.blue, state.alpha);
    },

    applyScissorAttribute: function(attribute) {
        var enable = attribute._x !== -1;
        var data = this._stateScissor;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.enable = enable;
        buffer.x = attribute._x;
        buffer.y = attribute._y;
        buffer.width = attribute._width;
        buffer.height = attribute._height;

        if (state.enable !== enable ||
            state.x !== attribute._x ||
            state.y !== attribute._y ||
            state.width !== attribute._width ||
            state.height !== attribute._height ) {
            data.changed = true;
        }
    },

    applyScissor: function(gl) {
        var data = this._stateScissor;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        if (state.enable !== buffer.enable) {
            state.enable = buffer.enable;
            if (state.enable) {
                gl.enable(gl.SCISSOR_TEST);
            } else {
                gl.disable(gl.SCISSOR_TEST);
            }
        }

        if (!state.enable) return;

        if (
            state.x !== buffer.x ||
            state.y !== buffer.y ||
            state.width !== buffer.width ||
            state.height !== buffer.height
        ) {
            state.x = buffer.x;
            state.y = buffer.y;
            state.width = buffer.width;
            state.height = buffer.height;
            gl.scissor(state.x, state.y, state.width, state.height);
        }
    },

    applyCullFaceAttribute: function(attribute) {
        var data = this._stateCullFace;
        var buffer = data.buffer;
        var state = data.state;
        var enable = attribute._mode !== __WEBPACK_IMPORTED_MODULE_2_osg_CullFace__["a" /* default */].DISABLE;
        data.changed = false;

        buffer.enable = enable;
        buffer.mode = attribute._mode;

        if (state.enable !== enable || state.mode !== attribute._mode) {
            data.changed = true;
        }
    },

    applyCullFace: function(gl) {
        var data = this._stateCullFace;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        if (state.enable !== buffer.enable) {
            state.enable = buffer.enable;
            if (state.enable) {
                gl.enable(gl.CULL_FACE);
            } else {
                gl.disable(gl.CULL_FACE);
            }
        }

        if (!state.enable) return;

        if (state.mode !== buffer.mode) {
            state.mode = buffer.mode;
            gl.cullFace(state.mode);
        }
    },

    applyDepthAttribute: function(attribute) {
        var enable = attribute._func !== __WEBPACK_IMPORTED_MODULE_0_osg_Depth__["a" /* default */].DISABLE;
        var data = this._stateDepth;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        buffer.enable = enable;
        buffer.func = attribute._func;
        buffer.far = attribute._far;
        buffer.near = attribute._near;

        if (state.enable !== enable ||
            state.func !== attribute._func ||
            state.near !== attribute._near ||
            state.far !== attribute._far ) {
            data.changed = true;
        }

        this.depthMask(attribute._writeMask);
    },

    applyDepth: function(gl) {
        var data = this._stateDepth;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        if (state.enable !== buffer.enable) {
            state.enable = buffer.enable;
            if (state.enable) {
                gl.enable(gl.DEPTH_TEST);
            } else {
                gl.disable(gl.DEPTH_TEST);
            }
        }

        if (!state.enable) return;

        if (state.func !== buffer.func) {
            state.func = buffer.func;
            gl.depthFunc(state.func);
        }

        if (state.near !== buffer.near || state.far !== buffer.far) {
            state.far = buffer.far;
            state.near = buffer.near;
            gl.depthRange(state.near, state.far);
        }
    },

    applyBlendFuncAttribute: function(attribute) {
        var data = this._stateBlendFunc;
        var buffer = data.buffer;
        var state = data.state;
        var enable =
            attribute._sourceFactor !== __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].DISABLE &&
            attribute._destinationFactor !== __WEBPACK_IMPORTED_MODULE_1_osg_BlendFunc__["a" /* default */].DISABLE;
        data.changed = false;

        buffer.enable = enable;
        buffer.separate = attribute._separate;
        buffer.sourceFactor = attribute._sourceFactor;
        buffer.destinationFactor = attribute._destinationFactor;
        buffer.sourceFactorAlpha = attribute._sourceFactorAlpha;
        buffer.destinationFactorAlpha = attribute._destinationFactorAlpha;

        if (state.enable !== enable ||
            state.sourceFactor !== attribute._sourceFactor ||
            state.destinationFactor !== attribute._destinationFactor ||
            state.sourceFactorAlpha !== attribute._sourceFactorAlpha ||
            state.destinationFactorAlpha !== attribute._destinationFactorAlpha
        ) {
            data.changed = true;
        }
    },

    applyBlendFunc: function(gl) {
        var data = this._stateBlendFunc;
        var buffer = data.buffer;
        var state = data.state;
        data.changed = false;

        if (state.enable !== buffer.enable) {
            state.enable = buffer.enable;
            if (state.enable) {
                gl.enable(gl.BLEND);
            } else {
                gl.disable(gl.BLEND);
            }
        }

        if (!state.enable) return;

        state.separate = buffer.separate;
        if (state.separate) {
            if (
                state.sourceFactor !== buffer.sourceFactor ||
                state.destinationFactor !== buffer.destinationFactor ||
                state.sourceFactorAlpha !== buffer.sourceFactorAlpha ||
                state.destinationFactorAlpha !== buffer.destinationFactorAlpha
            ) {
                state.sourceFactor = buffer.sourceFactor;
                state.destinationFactor = buffer.destinationFactor;
                state.sourceFactorAlpha = buffer.sourceFactorAlpha;
                state.destinationFactorAlpha = buffer.destinationFactorAlpha;
                gl.blendFuncSeparate(
                    state.sourceFactor,
                    state.destinationFactor,
                    state.sourceFactorAlpha,
                    state.destinationFactorAlpha
                );
            }
        } else if (
            state.sourceFactor !== buffer.sourceFactor ||
            state.destinationFactor !== buffer.destinationFactor
        ) {
            state.sourceFactor = buffer.sourceFactor;
            state.destinationFactor = buffer.destinationFactor;
            gl.blendFunc(state.sourceFactor, state.destinationFactor);
        }
    },

    applyClearStates: function(gl) {
        if (this._stateDepthMask.changed) {
            this.applyDepthMask(gl);
        }
        if (this._stateScissor.changed) {
            this.applyScissor(gl);
        }
        if (this._stateClearColor.changed) {
            this.applyClearColor(gl);
        }
        if (this._stateClearDepth.changed) {
            this.applyClearDepth(gl);
        }
        if (this._stateColorMask.changed) {
            this.applyColorMask(gl);
        }
    },

    applyDrawStates: function(gl) {
        if (this._stateViewport.changed) {
            this.applyViewport(gl);
        }
        if (this._stateScissor.changed) {
            this.applyScissor(gl);
        }
        if (this._stateDepth.changed) {
            this.applyDepth(gl);
        }
        if (this._stateDepthMask.changed) {
            this.applyDepthMask(gl);
        }
        if (this._stateCullFace.changed) {
            this.applyCullFace(gl);
        }
        if (this._stateBlendFunc.changed) {
            this.applyBlendFunc(gl);
        }
        if (this._stateColorMask.changed) {
            this.applyColorMask(gl);
        }
    },

    clear: function(gl, mask) {
        this.applyClearStates(gl);
        gl.clear(mask);
    },

    drawGeometry: function(gl) {
        this.applyDrawStates(gl);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (StateCache);


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Image__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Texture__ = __webpack_require__(7);





/**
 * TextureCubeMap
 * @class TextureCubeMap
 * @inherits Texture
 */
var TextureCubeMap = function() {
    __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].call(this);
    this._images = {};

    // pre allocated all textures faces slots
    for (var i = 0; i < 6; i++) {
        this._images[__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X + i] = new __WEBPACK_IMPORTED_MODULE_1_osg_Image__["a" /* default */]();
    }
};

/** @lends TextureCubeMap.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeStateAttribute(
    TextureCubeMap,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].prototype, {
        setDefaultParameters: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].prototype.setDefaultParameters.call(this);
            this._textureTarget = __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP;

            this._flipY = false;
        },

        invalidate: function() {
            __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].prototype.invalidate.call(this);
            for (
                var i = __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X;
                i < __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X + 6;
                i++
            ) {
                var faceImage = this._images[i];
                if (this._images[__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X].getImage()) {
                    faceImage.dirty();
                }
            }
            this.dirty();
        },

        cloneType: function() {
            return new TextureCubeMap();
        },

        setImage: function(imageFace, img, imageFormat) {
            var face = imageFace;

            if (typeof face === 'string') face = __WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"][face];

            this._images[face].setImage(img, imageFormat);

            this.setImageFormat(imageFormat);
            this.setTextureSize(this._images[face].getWidth(), this._images[face].getHeight());

            this._textureNull = false;
            this.dirty();
        },

        getImage: function(face) {
            return this._images[face].getImage();
        },

        initCubemapContent: function(gl) {
            var internalFormat = this._internalFormat;

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_POSITIVE_X,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            this.applyTexImage2D(
                gl,
                gl.TEXTURE_CUBE_MAP_NEGATIVE_Z,
                0,
                internalFormat,
                this._textureWidth,
                this._textureHeight,
                0,
                internalFormat,
                this._type,
                null
            );

            return true;
        },

        // handle mipmap logic, if images for mipmap are provided or not
        generateMipmap: function(gl, target) {
            if (!this.hasMipmapFilter()) return;

            // manual mipmap provided
            if (this._images[__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X].hasMipmap()) {
                for (var face = 0; face < 6; face++) {
                    var faceImage = this._images[__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X + face];
                    if (!faceImage.hasMipmap()) {
                        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].error('mipmap not set correctly for TextureCubemap');
                    }

                    var internalFormat = this._internalFormat;
                    for (var level = 1; level < faceImage.getMipmap().length; level++) {
                        var size = faceImage.getMipmap()[level].getWidth();

                        this.applyTexImage2D(
                            gl,
                            gl.TEXTURE_CUBE_MAP_POSITIVE_X + face,
                            level,
                            internalFormat,
                            size,
                            size,
                            0,
                            internalFormat,
                            this._type,
                            faceImage.getMipmap()[level].getImage()
                        );
                    }
                }
            } else {
                // automatic mipmap
                gl.generateMipmap(target);
            }

            this._dirtyMipmap = false;
        },

        applyImageTarget: function(gl, internalFormat, target) {
            var faceImage = this._images[target];

            if (!faceImage.getImage()) return 0;

            if (!faceImage.isReady()) return 0;

            if (!faceImage.isDirty()) return 1;

            this.setTextureSize(faceImage.getWidth(), faceImage.getHeight());

            faceImage.setDirty(false);

            if (faceImage.isTypedArray()) {
                this.applyTexImage2D(
                    gl,
                    target,
                    0,
                    internalFormat,
                    this._textureWidth,
                    this._textureHeight,
                    0,
                    internalFormat,
                    this._type,
                    faceImage.getImage()
                );
            } else {
                this.applyTexImage2D(
                    gl,
                    target,
                    0,
                    internalFormat,
                    internalFormat,
                    this._type,
                    faceImage.getImage()
                );
            }

            // release here only if no mipmap
            if (this._unrefImageDataAfterApply && !(this.hasMipmap() && faceImage.hasMipmap())) {
                faceImage.release();
            }

            return 1;
        },

        initCubemapContentImage: function(gl) {
            var internalFormat = this._internalFormat;
            var valid = 0;
            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_POSITIVE_X);
            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_NEGATIVE_X);

            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_POSITIVE_Y);
            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_NEGATIVE_Y);

            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_POSITIVE_Z);
            valid += this.applyImageTarget(gl, internalFormat, gl.TEXTURE_CUBE_MAP_NEGATIVE_Z);

            if (valid === 6) return true;

            return false;
        },

        apply: function(state) {
            var gl = state.getGraphicContext();
            // if need to release the texture
            if (this._dirtyTextureObject) {
                this.releaseGLObjects();
                this.setGraphicContext(gl);
            }

            if (this._textureObject !== undefined && !this.isDirty()) {
                this._textureObject.bind(gl);

                // If we have modified the texture via Rtt or texSubImage2D and _need_ updated mipmaps,
                // then we must regenerate the mipmaps explicitely.
                // In all other cases, don't set this flag because it can be costly
                if (this.isDirtyMipmap()) {
                    this.generateMipmap(gl, this._textureTarget);
                }
            } else if (this._textureNull) {
                gl.bindTexture(this._textureTarget, null);
            } else {
                if (!this._textureObject) {
                    // must be called before init
                    this.computeTextureFormat();

                    this.init(state);
                }
                this._textureObject.bind(gl);

                var valid;

                // no images it's must be a cubemap filled from rtt
                if (!this._images[__WEBPACK_IMPORTED_MODULE_3_osg_Texture__["default"].TEXTURE_CUBE_MAP_POSITIVE_X].getImage()) {
                    valid = this.initCubemapContent(gl);
                } else {
                    valid = this.initCubemapContentImage(gl);
                }

                if (valid) {
                    this._dirty = false;
                    this.applyFilterParameter(gl, this._textureTarget);
                    this.generateMipmap(gl, this._textureTarget);
                }
            } // render to cubemap not yet implemented
        }
    }),
    'osg',
    'TextureCubeMap'
);

/* harmony default export */ __webpack_exports__["a"] = (TextureCubeMap);


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_DrawArrays__ = __webpack_require__(18);




// This class can be used to visit all the triangles of a geometry
var TriangleIndexFunctor = function() {};

var functorDrawElements = (TriangleIndexFunctor.functorDrawElements = []);
var functorDrawArrays = (TriangleIndexFunctor.functorDrawArrays = []);

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLES] = function(offset, count, indexes, cb) {
    var end = offset + count;
    for (var i = offset; i < end; i += 3) {
        cb(indexes[i], indexes[i + 1], indexes[i + 2]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = function(offset, count, indexes, cb) {
    for (var i = 2, j = offset; i < count; ++i, ++j) {
        if (i % 2) cb(indexes[j], indexes[j + 2], indexes[j + 1]);
        else cb(indexes[j], indexes[j + 1], indexes[j + 2]);
    }
};

functorDrawElements[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = function(offset, count, indexes, cb) {
    var first = indexes[offset];
    for (var i = 2, j = offset + 1; i < count; ++i, ++j) {
        cb(first, indexes[j], indexes[j + 1]);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLES] = function(first, count, cb) {
    for (var i = 2, pos = first; i < count; i += 3, pos += 3) {
        cb(pos, pos + 1, pos + 2);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP] = function(first, count, cb) {
    for (var i = 2, pos = first; i < count; ++i, ++pos) {
        if (i % 2) cb(pos, pos + 2, pos + 1);
        else cb(pos, pos + 1, pos + 2);
    }
};

functorDrawArrays[__WEBPACK_IMPORTED_MODULE_0_osg_primitiveSet__["a" /* default */].TRIANGLE_FAN] = function(first, count, cb) {
    for (var i = 2, pos = first + 1; i < count; ++i, ++pos) {
        cb(first, pos, pos + 1);
    }
};

TriangleIndexFunctor.prototype = {
    // You feed it with a callback that will be called for each triangle
    // (with the 3 indexes of vertices as arguments)
    init: function(geom, cb) {
        this._geom = geom;
        this._cb = cb;
    },

    apply: function() {
        var geom = this._geom;
        var primitives = geom.getPrimitiveSetList();
        if (!primitives) return;

        var cb = this._cb;
        var cbFunctor;

        var nbPrimitives = primitives.length;
        for (var i = 0; i < nbPrimitives; i++) {
            var primitive = primitives[i];
            if (primitive instanceof __WEBPACK_IMPORTED_MODULE_1_osg_DrawElements__["a" /* default */]) {
                cbFunctor = functorDrawElements[primitive.getMode()];
                if (cbFunctor) {
                    var indexes = primitive.indices.getElements();
                    cbFunctor(
                        primitive.getFirst() / indexes.BYTES_PER_ELEMENT,
                        primitive.getCount(),
                        indexes,
                        cb
                    );
                }
            } else if (primitive instanceof __WEBPACK_IMPORTED_MODULE_2_osg_DrawArrays__["a" /* default */]) {
                cbFunctor = functorDrawArrays[primitive.getMode()];
                if (cbFunctor) {
                    cbFunctor(primitive.getFirst(), primitive.getCount(), cb);
                }
            }
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (TriangleIndexFunctor);


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgAnimation_animation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgAnimation_SkinningAttribute__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_AnimationUpdateCallback__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_BasicAnimationManager__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_Bone__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgAnimation_channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgAnimation_CollectAnimationUpdateCallbackVisitor__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgAnimation_easing__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgAnimation_interpolator__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgAnimation_MorphAttribute__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgAnimation_MorphGeometry__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgAnimation_Skeleton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgAnimation_StackedMatrix__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgAnimation_StackedQuaternion__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgAnimation_StackedRotateAxis__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osgAnimation_StackedScale__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osgAnimation_StackedTranslate__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osgAnimation_UpdateBone__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osgAnimation_UpdateMatrixTransform__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osgAnimation_UpdateMorph__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osgAnimation_UpdateSkeleton__ = __webpack_require__(113);
























var osgAnimation = {};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectMix(osgAnimation, __WEBPACK_IMPORTED_MODULE_8_osgAnimation_easing__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectMix(osgAnimation, __WEBPACK_IMPORTED_MODULE_9_osgAnimation_interpolator__["a" /* default */]);
osgAnimation.Animation = __WEBPACK_IMPORTED_MODULE_1_osgAnimation_animation__["a" /* default */];
osgAnimation.SkinningAttribute = __WEBPACK_IMPORTED_MODULE_2_osgAnimation_SkinningAttribute__["a" /* default */];
osgAnimation.AnimationUpdateCallback = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_AnimationUpdateCallback__["a" /* default */];
osgAnimation.BasicAnimationManager = __WEBPACK_IMPORTED_MODULE_4_osgAnimation_BasicAnimationManager__["a" /* default */];
osgAnimation.Bone = __WEBPACK_IMPORTED_MODULE_5_osgAnimation_Bone__["a" /* default */];
osgAnimation.Channel = __WEBPACK_IMPORTED_MODULE_6_osgAnimation_channel__["a" /* default */];
osgAnimation.CollectAnimationUpdateCallbackVisitor = __WEBPACK_IMPORTED_MODULE_7_osgAnimation_CollectAnimationUpdateCallbackVisitor__["a" /* default */];
osgAnimation.MorphAttribute = __WEBPACK_IMPORTED_MODULE_10_osgAnimation_MorphAttribute__["a" /* default */];
osgAnimation.MorphGeometry = __WEBPACK_IMPORTED_MODULE_11_osgAnimation_MorphGeometry__["a" /* default */];
osgAnimation.RigGeometry = __WEBPACK_IMPORTED_MODULE_12_osgAnimation_RigGeometry__["a" /* default */];
osgAnimation.Skeleton = __WEBPACK_IMPORTED_MODULE_13_osgAnimation_Skeleton__["a" /* default */];
osgAnimation.StackedMatrix = __WEBPACK_IMPORTED_MODULE_14_osgAnimation_StackedMatrix__["a" /* default */];
osgAnimation.StackedQuaternion = __WEBPACK_IMPORTED_MODULE_15_osgAnimation_StackedQuaternion__["a" /* default */];
osgAnimation.StackedRotateAxis = __WEBPACK_IMPORTED_MODULE_16_osgAnimation_StackedRotateAxis__["a" /* default */];
osgAnimation.StackedScale = __WEBPACK_IMPORTED_MODULE_17_osgAnimation_StackedScale__["a" /* default */];
osgAnimation.StackedTranslate = __WEBPACK_IMPORTED_MODULE_18_osgAnimation_StackedTranslate__["a" /* default */];
osgAnimation.UpdateBone = __WEBPACK_IMPORTED_MODULE_19_osgAnimation_UpdateBone__["a" /* default */];
osgAnimation.UpdateMatrixTransform = __WEBPACK_IMPORTED_MODULE_20_osgAnimation_UpdateMatrixTransform__["a" /* default */];
osgAnimation.UpdateMorph = __WEBPACK_IMPORTED_MODULE_21_osgAnimation_UpdateMorph__["a" /* default */];
osgAnimation.UpdateSkeleton = __WEBPACK_IMPORTED_MODULE_22_osgAnimation_UpdateSkeleton__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgAnimation);


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var easeOutQuad = function(t) {
    return -(t * (t - 2.0));
};
var easeInQuad = function(t) {
    return t * t;
};
var easeOutCubic = function(t) {
    t = t - 1.0;
    return t * t * t + 1;
};
var easeInCubic = function(t) {
    return t * t * t;
};
var easeOutQuart = function(t) {
    t = t - 1;
    return -(t * t * t * t - 1);
};
var easeInQuart = function(t) {
    return t * t * t * t;
};
var easeOutElastic = function(t) {
    return Math.pow(2.0, -10.0 * t) * Math.sin((t - 0.3 / 4.0) * (2.0 * Math.PI) / 0.3) + 1.0;
};
//osgAnimation.EaseInElastic = function(t) { return ; };
var easeOutBounce = function(t) {
    if (t < 1 / 2.75) {
        return 7.5625 * t * t;
    } else if (t < 2 / 2.75) {
        return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
    } else if (t < 2.5 / 2.75) {
        return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
    } else {
        return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
    }
};

/* harmony default export */ __webpack_exports__["a"] = ({
    easeOutQuad: easeOutQuad,
    easeInQuad: easeInQuad,
    easeOutCubic: easeOutCubic,
    easeInCubic: easeInCubic,
    easeOutQuart: easeOutQuart,
    easeInQuart: easeInQuart,
    easeOutElastic: easeOutElastic,
    easeOutBounce: easeOutBounce,
    EaseOutQuad: easeOutQuad,
    EaseInQuad: easeInQuad,
    EaseOutCubic: easeOutCubic,
    EaseInCubic: easeInCubic,
    EaseOutQuart: easeOutQuart,
    EaseInQuart: easeInQuart,
    EaseOutElastic: easeOutElastic,
    EaseOutBounce: easeOutBounce
});


/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Object__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__ = __webpack_require__(34);







var StackedRotateAxis = function(name, axis, angle) {
    __WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].call(this);
    this._axis = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0, 0, 1);
    if (axis) __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._axis, axis);
    this._target = __WEBPACK_IMPORTED_MODULE_3_osgAnimation_target__["a" /* default */].createFloatTarget(typeof angle === 'number' ? angle : 0.0);
    if (name) this.setName(name);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    StackedRotateAxis,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Object__["a" /* default */].prototype, {
        init: function(axis, angle) {
            this.setAxis(axis);
            this.setAngle(angle);
            this._target.defaultValue = angle;
        },

        setAxis: function(axis) {
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._axis, axis);
        },

        setAngle: function(angle) {
            this._target.value = angle;
        },

        getTarget: function() {
            return this._target;
        },

        resetToDefaultValue: function() {
            this.setAngle(this._target.defaultValue);
        },

        applyToMatrix: (function() {
            var matrixTmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
            var quatTmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create();

            return function(m) {
                var axis = this._axis;
                var qtmp = quatTmp;
                var mtmp = matrixTmp;
                var angle = this._target.value;

                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].setAxisAngle(qtmp, axis, angle);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromQuat(mtmp, qtmp);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(m, m, mtmp);
            };
        })()
    }),
    'osgAnimation',
    'StackedRotateAxis'
);

/* harmony default export */ __webpack_exports__["a"] = (StackedRotateAxis);


/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgDB_Input__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgDB_readerParser__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgDB_DatabasePager__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgWrappers_serializers_osg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgWrappers_serializers_osgAnimation__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgWrappers_serializers_osgText__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgDB_Registry__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgDB_FileHelper__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgDB_requestFile__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgDB_zlib__ = __webpack_require__(132);












var osgDB = {};
osgDB.Input = __WEBPACK_IMPORTED_MODULE_1_osgDB_Input__["default"];
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectMix(osgDB, __WEBPACK_IMPORTED_MODULE_2_osgDB_readerParser__["default"]);
osgDB.DatabasePager = __WEBPACK_IMPORTED_MODULE_3_osgDB_DatabasePager__["a" /* default */];
osgDB.ObjectWrapper.serializers.osg = __WEBPACK_IMPORTED_MODULE_4_osgWrappers_serializers_osg__["a" /* default */];
osgDB.ObjectWrapper.serializers.osgAnimation = __WEBPACK_IMPORTED_MODULE_5_osgWrappers_serializers_osgAnimation__["a" /* default */];
osgDB.ObjectWrapper.serializers.osgText = __WEBPACK_IMPORTED_MODULE_6_osgWrappers_serializers_osgText__["a" /* default */];
osgDB.Registry = __WEBPACK_IMPORTED_MODULE_7_osgDB_Registry__["a" /* default */];
osgDB.FileHelper = __WEBPACK_IMPORTED_MODULE_8_osgDB_FileHelper__["a" /* default */];
osgDB.requestFile = __WEBPACK_IMPORTED_MODULE_9_osgDB_requestFile__["a" /* default */];

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectMix(osgDB, __WEBPACK_IMPORTED_MODULE_10_osgDB_zlib__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (osgDB);


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defaultOptions = {
    // prefix to built url to load resource
    prefixURL: '',

    // database URL for PagedLOD structures
    databasePath: '',

    // callback used when loading data
    progressXHRCallback: undefined,

    // replacement of readImageURL to use your own code to load Nodes
    // the function will be execute in the context of Input, see Input:readNodeURL
    readNodeURL: undefined,

    // replacement of readImageURL to use your own code to load osg.Image
    // the function will be execute in the context of Input, see Input:readImageURL
    readImageURL: undefined,

    // replacement of readBinaryArrayURL to use your own code to load binary array
    // the function will be execute in the context of Input, see Input:readBinaryArrayURL
    readBinaryArrayURL: undefined,

    imageLoadingUsePromise: true, // use promise to load image instead of returning Image
    imageOnload: undefined, // use callback when loading an image
    imageCrossOrigin: undefined // use callback when loading an image
};

/* harmony default export */ __webpack_exports__["a"] = (defaultOptions);


/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammer__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hammer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgGA_CADManipulator__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgGA_CADManipulatorStandardMouseKeyboardController__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_CADManipulatorHammerController__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgGA_FirstPersonManipulator__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgGA_FirstPersonManipulatorDeviceOrientationController__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgGA_FirstPersonManipulatorHammerController__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgGA_FirstPersonManipulatorStandardMouseKeyboardController__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgGA_FirstPersonManipulatorWebVRController__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgGA_Manipulator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgGA_OrbitManipulator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgGA_OrbitManipulatorDeviceOrientationController__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgGA_OrbitManipulatorGamePadController__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgGA_OrbitManipulatorHammerController__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgGA_OrbitManipulatorStandardMouseKeyboardController__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgGA_OrbitManipulatorWebVRController__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgGA_SwitchManipulator__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osgGA_orbitManipulatorEnums__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osgGA_Controller__ = __webpack_require__(20);




















var osgGA = {};

__WEBPACK_IMPORTED_MODULE_0_hammer___default.a.NO_MOUSEEVENTS = true; // disable hammer js mouse events

osgGA.CADManipulator = __WEBPACK_IMPORTED_MODULE_1_osgGA_CADManipulator__["a" /* default */];
osgGA.getCADManipulatorStandardMouseKeyboardController = function() {
    return __WEBPACK_IMPORTED_MODULE_2_osgGA_CADManipulatorStandardMouseKeyboardController__["a" /* default */];
};
osgGA.getCADManipulatorHammerController = function() {
    return __WEBPACK_IMPORTED_MODULE_3_osgGA_CADManipulatorHammerController__["a" /* default */];
};
osgGA.FirstPersonManipulator = __WEBPACK_IMPORTED_MODULE_4_osgGA_FirstPersonManipulator__["a" /* default */];
osgGA.getFirstPersonDeviceOrientationController = function() {
    return __WEBPACK_IMPORTED_MODULE_5_osgGA_FirstPersonManipulatorDeviceOrientationController__["a" /* default */];
};
osgGA.getFirstPersonManipulatorHammerController = function() {
    return __WEBPACK_IMPORTED_MODULE_6_osgGA_FirstPersonManipulatorHammerController__["a" /* default */];
};
osgGA.getFirstPersonStandardMouseKeyboardControllerClass = function() {
    return __WEBPACK_IMPORTED_MODULE_7_osgGA_FirstPersonManipulatorStandardMouseKeyboardController__["a" /* default */];
};
osgGA.getFirstPersonWebVRControllerClass = function() {
    return __WEBPACK_IMPORTED_MODULE_8_osgGA_FirstPersonManipulatorWebVRController__["a" /* default */];
};
osgGA.Manipulator = __WEBPACK_IMPORTED_MODULE_9_osgGA_Manipulator__["a" /* default */];
osgGA.OrbitManipulator = __WEBPACK_IMPORTED_MODULE_10_osgGA_OrbitManipulator__["a" /* default */];
osgGA.getOrbitManipulatorDeviceOrientationController = function() {
    return __WEBPACK_IMPORTED_MODULE_11_osgGA_OrbitManipulatorDeviceOrientationController__["a" /* default */];
};
osgGA.getOrbitManipulatorGamePadController = function() {
    return __WEBPACK_IMPORTED_MODULE_12_osgGA_OrbitManipulatorGamePadController__["a" /* default */];
};
osgGA.getOrbitManipulatorHammerController = function() {
    return __WEBPACK_IMPORTED_MODULE_13_osgGA_OrbitManipulatorHammerController__["a" /* default */];
};
osgGA.getOrbitManipulatorStandardMouseKeyboardController = function() {
    return __WEBPACK_IMPORTED_MODULE_14_osgGA_OrbitManipulatorStandardMouseKeyboardController__["a" /* default */];
};
osgGA.getOrbitManipulatorWebVRController = function() {
    return __WEBPACK_IMPORTED_MODULE_15_osgGA_OrbitManipulatorWebVRController__["a" /* default */];
};

osgGA.SwitchManipulator = __WEBPACK_IMPORTED_MODULE_16_osgGA_SwitchManipulator__["a" /* default */];

osgGA.OrbitManipulator.Rotate = __WEBPACK_IMPORTED_MODULE_17_osgGA_orbitManipulatorEnums__["a" /* default */].ROTATE;
osgGA.OrbitManipulator.Pan = __WEBPACK_IMPORTED_MODULE_17_osgGA_orbitManipulatorEnums__["a" /* default */].PAN;
osgGA.OrbitManipulator.Zoom = __WEBPACK_IMPORTED_MODULE_17_osgGA_orbitManipulatorEnums__["a" /* default */].ZOOM;

osgGA.Controller = __WEBPACK_IMPORTED_MODULE_18_osgGA_Controller__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgGA);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectionVisitor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_LineSegmentIntersector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgUtil_PolytopeIntersector__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_computeMatrixFromNodePath__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgGA_CADManipulatorStandardMouseKeyboardController__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgGA_CADManipulatorHammerController__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgUtil_DelayInterpolator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__ = __webpack_require__(68);















/**
 *  CADManipulator
 *  @class Provides a manipulator with rotation and zoom capacities around a pivot point.
 *  The pivot point is computed through intersections. If no intersection is computed
 *  the manipulator uses the last computed pivot point.
 *  - Mousewheel/Pinch zooms in and out on the pivot point.
 *  - Double click/tap zooms in on the pivot point.
 *  - Left click/pan rotates around the pivot point.
 *  - Center/Right click or two-finger drag moves the view.
 *  - Spacebar resets the view.
 */

var CADManipulator = function() {
    __WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__["a" /* default */].call(this);
    this._tmpHomePosition = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
    this._intersectionVisitor = new __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectionVisitor__["a" /* default */]();
    this._lineSegmentIntersector = new __WEBPACK_IMPORTED_MODULE_3_osgUtil_LineSegmentIntersector__["a" /* default */]();
    this._polytopeIntersector = undefined;
    this._usePolytopeIntersector = false;
    this._primitiveMask = __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__["a" /* default */].ALL_PRIMITIVES;
    this.init();
};

CADManipulator.Interpolator = function() {
    this._current = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
    this._target = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
    this._delta = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
    this._reset = false;
    this.reset();
    this._width = undefined;
    this._height = undefined;
};

CADManipulator.Interpolator.prototype = {
    setWidth: function(width) {
        this._width = width;
    },
    setHeight: function(height) {
        this._height = height;
    },
    reset: function() {
        for (var i = 0, l = this._current.length; i < l; i++) {
            this._current[i] = this._target[i] = 0;
        }
        this._reset = true;
    },
    update: function() {
        var d0;
        var d1;
        if (this._width === undefined) d0 = 0;
        else d0 = (this._target[0] - this._current[0]) / this._width;
        this._delta[0] = d0;
        this._current[0] = this._target[0];
        if (this._height === undefined) d1 = 0;
        else d1 = (this._target[1] - this._current[1]) / this._height;
        this._delta[1] = d1;
        this._current[1] = this._target[1];
        return this._delta;
    },
    set: function() {
        for (var i = 0, l = this._current.length; i < l; i++) {
            this._current[i] = this._target[i] = arguments[i];
        }
        this._reset = false;
    },
    isReset: function() {
        return this._reset;
    },
    getCurrent: function() {
        return this._current;
    },
    setTarget: function() {
        for (var i = 0, l = this._target.length; i < l; i++) {
            if (this._reset) {
                this._target[i] = this._current[i] = arguments[i];
            } else {
                this._target[i] = arguments[i];
            }
        }
        this._reset = false;
    },
    addTarget: function() {
        for (var i = 0; i < arguments.length; i++) {
            this._target[i] += arguments[i];
        }
    },
    getTarget: function() {
        return this._target;
    },
    getDelta: function() {
        return this._delta;
    }
};

CADManipulator.AvailableControllerList = ['StandardMouseKeyboard', 'Hammer'];
CADManipulator.ControllerList = ['StandardMouseKeyboard', 'Hammer'];

/** @lends CADManipulator.prototype */
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    CADManipulator,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__["a" /* default */].prototype, {
        init: function() {
            this._distance = 25.0;
            this._target = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            this._upz = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);
            this._right = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0);

            __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].init(this._target);

            var rot1 = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].fromRotation(__WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create(), -Math.PI, this._upz);
            var rot2 = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].fromRotation(__WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create(), Math.PI / 10.0, this._right);
            this._rotation = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();
            __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(this._rotation, rot1, rot2);
            this._time = 0.0;

            this._rotate = new CADManipulator.Interpolator();
            this._pan = new CADManipulator.Interpolator();
            this._zoom = new __WEBPACK_IMPORTED_MODULE_9_osgUtil_DelayInterpolator__["a" /* default */](1);

            this._panFactor = 1.5;
            this._rotateFactor = 1;
            this._zoomFactor = 1;

            this._inverseMatrix = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();

            this._homeEye = undefined;
            this._homeCenter = undefined;
            this._homeUp = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);

            this._orientation = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].create();
            this._pivotPoint = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();

            this._eye = undefined;

            this._zoomDir = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();

            // instance of controller
            var self = this;

            CADManipulator.ControllerList.forEach(function(value) {
                if (CADManipulator[value] !== undefined) {
                    if (self._controllerList[value]) {
                        self._controllerList[value].init();
                    } else {
                        self._controllerList[value] = new CADManipulator[value](self);
                    }
                }
            });
        },

        setViewer: function(viewer) {
            this._viewer = viewer;
        },

        reset: function() {
            this.init();
        },

        setNode: function(node) {
            this._node = node;
        },

        setPivotPoint: function(pivotPoint) {
            // First calculate offset
            __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._pivotPoint, pivotPoint);
        },

        setTarget: (function() {
            var eyePos = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            return function(target) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._target, target);
                this.getEyePosition(eyePos);
                this._distance = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].distance(target, eyePos);
            };
        })(),

        setEyePosition: function(eye) {
            __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._eye, eye);
            this._distance = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].distance(this._target, eye);
        },

        setHomePosition: function(eye, center, up) {
            this._homeEye = eye;
            this._homeCenter = center;
            this._homeUp = up;
        },

        computeHomePosition: (function() {
            var f = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var s = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var u = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var result = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();
            return function(boundStrategy) {
                var bs = this.getHomeBoundingSphere(boundStrategy);
                if (!bs) return;
                this.setDistance(this.getHomeDistance(bs));
                this.setTarget(bs.center());
                this.setPivotPoint(bs.center());

                if (this._homeEye === undefined) {
                    this._homeEye = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
                    this.getEyePosition(this._homeEye);
                }

                if (this._homeCenter === undefined) {
                    this._homeCenter = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
                    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._homeCenter, bs.center());
                }

                if (this._eye === undefined) {
                    this._eye = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
                }

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._eye, this._homeEye);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._target, this._homeCenter);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(this._upz, this._homeUp);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].copy(result, this._rotation);
                var center = this._target;
                var eye = this._eye;

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].sub(f, center, eye);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].normalize(f, f);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].cross(s, f, this._upz);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].normalize(s, s);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].cross(u, s, f);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].normalize(u, u);

                // s[0], f[0], u[0], 0.0,
                // s[1], f[1], u[1], 0.0,
                // s[2], f[2], u[2], 0.0,
                // 0,    0,    0,     1.0
                result[0] = s[0];
                result[1] = u[0];
                result[2] = -f[0];
                result[3] = 0.0;
                result[4] = s[1];
                result[5] = u[1];
                result[6] = -f[1];
                result[7] = 0.0;
                result[8] = s[2];
                result[9] = u[2];
                result[10] = -f[2];
                result[11] = 0.0;
                result[12] = 0;
                result[13] = 0;
                result[14] = 0;
                result[15] = 1.0;

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].getRotation(this._orientation, result);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].invert(this._orientation, this._orientation);
            };
        })(),

        setZoomFactor: function(f) {
            this._zoomFactor = f;
        },

        setRotateFactor: function(f) {
            this._rotateFactor = f;
        },

        setPanFactor: function(f) {
            this._panFactor = f;
        },

        setDistance: function(d) {
            this._distance = d;
        },

        // If set to true, intersections are computed against points and lines
        setUsePolytopeIntersector: function(upi) {
            this._usePolytopeIntersector = upi;
        },

        getUsePolytopeIntersector: function() {
            return this._usePolytopeIntersector;
        },

        getDistance: function() {
            return this._distance;
        },

        zoom: function(ratio) {
            this._distance = ratio;
        },

        getRotateInterpolator: function() {
            return this._rotate;
        },

        getPanInterpolator: function() {
            return this._pan;
        },

        getZoomInterpolator: function() {
            return this._zoom;
        },

        getIntersectionVisitor: function() {
            return this._intersectionVisitor;
        },

        getLineSegmentIntersector: function() {
            return this._lineSegmentIntersector;
        },

        getOrCreatePolytopeIntersector: function() {
            if (this._polytopeIntersector === undefined) {
                this._polytopeIntersector = new __WEBPACK_IMPORTED_MODULE_4_osgUtil_PolytopeIntersector__["a" /* default */]();
                this._polytopeIntersector.setIntersectionLimit(
                    __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE_PER_DRAWABLE
                );
                this._polytopeIntersector.setPrimitiveMask(
                    __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__["a" /* default */].POINT_PRIMITIVES | __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__["a" /* default */].LINE_PRIMITIVES
                );
            }
            return this._polytopeIntersector;
        },

        getTarget: function(target) {
            __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(target, this._target);
            return target;
        },

        getEyePosition: function(eye) {
            if (this._eye === undefined) this.computeEyePosition(this._target, this._distance, eye);
            else __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].copy(eye, this._eye);
        },

        computeEyePosition: (function() {
            var tmpDist = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var tmpInverse = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();
            return function(target, distance, eye) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].invert(tmpInverse, this._rotation);
                tmpDist[1] = distance;
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, tmpDist, tmpInverse);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].add(eye, target, eye);
            };
        })(),

        computePan: (function() {
            var trans = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var rotPos = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var speedTmp = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            return function(dx, dy, rotMat) {
                var speed =
                    __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].length(__WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].sub(speedTmp, this._eye, this._pivotPoint)) / this._panFactor;
                if (speed < 10) speed = 10;
                trans[0] = dx * speed / 2;
                trans[1] = dy * speed / 2;
                trans[2] = 0;
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformMat4(rotPos, trans, rotMat);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, rotPos);
            };
        })(),

        computeZoom: (function() {
            var vectorDistance = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var speedDist = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            return function(dz) {
                var zoomSpeed = dz * this._zoomFactor;
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].sub(vectorDistance, this._pivotPoint, this._eye);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].scale(speedDist, vectorDistance, zoomSpeed));
            };
        })(),

        computeRotation: (function() {
            var rightNormalized = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var right = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var dir = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var offset = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var pitchQuat = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].create();
            var yawQuat = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].create();
            var pitchyawQuat = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].create();
            var tmp = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            var rightScalar = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();

            return function(yawDelta, pitchDelta) {
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformQuat(right, this._right, this._orientation);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].normalize(rightNormalized, right);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].sub(dir, this._eye, this._pivotPoint);
                var scalar = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].dot(rightNormalized, dir);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].sub(offset, dir, __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].scale(rightScalar, rightNormalized, scalar));
                var xy = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].fromValues(-offset[0], -offset[1], 0);

                var positionPitch = Math.atan2(-offset[2], __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].length(xy));
                pitchDelta =
                    Math.max(
                        -Math.PI / 2 + 0.01,
                        Math.min(Math.PI / 2 - 0.01, positionPitch + pitchDelta)
                    ) - positionPitch;

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].setAxisAngle(pitchQuat, right, pitchDelta * this._rotateFactor);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].setAxisAngle(yawQuat, this._upz, yawDelta * this._rotateFactor);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].mul(pitchyawQuat, yawQuat, pitchQuat);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformQuat(tmp, dir, pitchyawQuat);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].add(this._eye, tmp, this._pivotPoint);

                // Find rotation offset and target
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].mul(this._orientation, yawQuat, this._orientation);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformQuat(right, this._right, this._orientation);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].setAxisAngle(pitchQuat, right, pitchDelta * this._rotateFactor);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["d" /* quat */].mul(this._orientation, pitchQuat, this._orientation);
            };
        })(),

        update: (function() {
            var rotMat = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();
            var transMat = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].create();
            return function(nv) {
                var dt = nv.getFrameStamp().getDeltaTime();

                var mouseFactor = 10;
                //Note inverted y
                var delta = this._rotate.update();
                this.computeRotation(-delta[0] * mouseFactor, delta[1] * mouseFactor);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].fromQuat(rotMat, this._orientation);

                var deltapan = this._pan.update();
                this.computePan(-deltapan[0] * mouseFactor, -deltapan[1] * mouseFactor, rotMat);

                delta = this._zoom.update(dt);
                this.computeZoom(-delta[0] / 10.0);

                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].fromTranslation(transMat, this._eye);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].mul(this._inverseMatrix, transMat, rotMat);
                __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["c" /* mat4 */].invert(this._inverseMatrix, this._inverseMatrix);
            };
        })(),
        getInverseMatrix: function() {
            return this._inverseMatrix;
        },

        computeIntersections: (function() {
            var hits = [];
            var pTrans = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].create();
            return function(pos) {
                var viewer = this._camera.getView();

                var cam = this._camera;
                var width = cam.getViewport().width();
                var height = cam.getViewport().height();
                this._rotate.setWidth(width);
                this._rotate.setHeight(height);
                this._pan.setWidth(width);
                this._pan.setHeight(height);

                var point, matrix;
                if ((this._primitiveMask & __WEBPACK_IMPORTED_MODULE_10_osgUtil_intersectionEnums__["a" /* default */].TRIANGLE_PRIMITIVES) !== 0) {
                    hits = viewer.computeIntersections(pos[0], pos[1]);

                    if (hits.length > 0) {
                        point = hits[0]._localIntersectionPoint;
                        hits[0]._nodePath.shift();
                        matrix = __WEBPACK_IMPORTED_MODULE_5_osg_computeMatrixFromNodePath__["a" /* default */].computeLocalToWorld(hits[0]._nodePath);
                        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformMat4(pTrans, point, matrix);
                        this.setPivotPoint(pTrans);
                    }
                }

                if (hits.length === 0 && this._usePolytopeIntersector) {
                    var pi = this.getOrCreatePolytopeIntersector();
                    pi.reset();
                    pi.setPolytopeFromWindowCoordinates(
                        pos[0] - 5,
                        pos[1] - 5,
                        pos[0] + 5,
                        pos[1] + 5
                    );
                    var iv = this._intersectionVisitor;
                    iv.setIntersector(pi);
                    viewer.getCamera().accept(iv);
                    hits = pi.getIntersections();
                    hits.sort(function(a, b) {
                        return a._distance - b._distance;
                    });
                    if (hits.length > 0) {
                        point = hits[0]._localIntersectionPoint;
                        hits[0]._nodePath.shift();
                        matrix = __WEBPACK_IMPORTED_MODULE_5_osg_computeMatrixFromNodePath__["a" /* default */].computeLocalToWorld(hits[0]._nodePath);
                        __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["f" /* vec3 */].transformMat4(pTrans, point, matrix);
                        this.setPivotPoint(pTrans);
                    }
                }
            };
        })(),

        getPositionRelativeToCanvas: (function() {
            var offset = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
            var pos = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
            return function(x, y) {
                var canvas = this._camera._graphicContext.canvas;
                this.getOffsetRect(canvas, offset);
                var ratioX = canvas.width / canvas.clientWidth;
                var ratioY = canvas.height / canvas.clientHeight;
                pos[0] = (x - offset[1]) * ratioX;
                pos[1] = (canvas.clientHeight - (y - offset[0])) * ratioY;
                return pos;
            };
        })(),

        getCanvasCenter: (function() {
            var offset = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
            var pos = __WEBPACK_IMPORTED_MODULE_6_osg_glMatrix__["e" /* vec2 */].create();
            return function() {
                var canvas = this._camera.getGraphicContext().canvas;
                this.getOffsetRect(canvas, offset);
                var ratioX = canvas.width / canvas.clientWidth;
                var ratioY = canvas.height / canvas.clientHeight;
                pos[0] = canvas.clientWidth / 2 * ratioX;
                pos[1] = canvas.clientHeight / 2 * ratioY;
                return pos;
            };
        })(),

        getOffsetRect: function(elem, offset) {
            var box = elem.getBoundingClientRect();
            var body = document.body;
            var docElem = document.documentElement;
            var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
            var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
            var clientTop = docElem.clientTop || body.clientTop || 0;
            var clientLeft = docElem.clientLeft || body.clientLeft || 0;
            var top = box.top + scrollTop - clientTop;
            var left = box.left + scrollLeft - clientLeft;
            offset[0] = Math.round(top);
            offset[1] = Math.round(left);
            return offset;
        }
    }),
    'osgGA',
    'CADManipulator'
);

CADManipulator.StandardMouseKeyboard = __WEBPACK_IMPORTED_MODULE_7_osgGA_CADManipulatorStandardMouseKeyboardController__["a" /* default */];
CADManipulator.Hammer = __WEBPACK_IMPORTED_MODULE_8_osgGA_CADManipulatorHammerController__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (CADManipulator);


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgGA_FirstPersonManipulatorDeviceOrientationController__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgGA_FirstPersonManipulatorHammerController__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgGA_FirstPersonManipulatorWebVRController__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgGA_FirstPersonManipulatorStandardMouseKeyboardController__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__ = __webpack_require__(70);












/**
 * Authors:
 *  Matt Fontaine <tehqin@gmail.com>
 *  Cedric Pinson <trigrou@gmail.com>
 */

/**
 *  FirstPersonManipulator
 *  @class
 */
var FirstPersonManipulator = function(boundStrategy) {
    __WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__["a" /* default */].call(this, boundStrategy);
    this.init();
};

FirstPersonManipulator.AvailableControllerList = [
    'StandardMouseKeyboard',
    'WebVR',
    'DeviceOrientation',
    'Hammer'
];
FirstPersonManipulator.ControllerList = [
    'StandardMouseKeyboard',
    'WebVR',
    'DeviceOrientation',
    'Hammer'
];

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    FirstPersonManipulator,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osgGA_Manipulator__["a" /* default */].prototype, {
        computeHomePosition: function(boundStrategy) {
            var bs = this.getHomeBoundingSphere(boundStrategy);
            if (!bs || !bs.valid()) return;

            this._distance = this.getHomeDistance(bs);
            var cen = bs.center();
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].scale(this._eye, this._direction, -this._distance);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(this._eye, cen, this._eye);
            this.setTarget(cen);
        },

        init: function() {
            this._direction = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0);
            this._eye = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 25.0, 10.0);
            this._up = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);
            this._distance = 1.0;
            this._forward = new __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__["a" /* default */](1);
            this._side = new __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__["a" /* default */](1);
            this._lookPosition = new __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__["a" /* default */](2);

            // direct pan interpolator (not based on auto-move)
            this._pan = new __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__["a" /* default */](2);
            this._zoom = new __WEBPACK_IMPORTED_MODULE_7_osgUtil_DelayInterpolator__["a" /* default */](1);

            this._stepFactor = 1.0; // meaning radius*stepFactor to move
            this._angleVertical = 0.0;
            this._angleHorizontal = 0.0;

            // tmp value use for computation
            this._tmpGetTargetDir = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();

            // vr controls
            this._vrEnable = false;
            this._vrRot = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].create(); // absolute orientation
            this._vrPos = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create(); // absolute position
            this._vrTrans = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create(); // delta translation since last update

            var self = this;

            this._controllerList = {};
            FirstPersonManipulator.ControllerList.forEach(function(value) {
                if (FirstPersonManipulator[value] !== undefined) {
                    if (self._controllerList[value]) {
                        self._controllerList[value].init();
                    } else {
                        self._controllerList[value] = new FirstPersonManipulator[value](self);
                    }
                }
            });
        },

        setDelay: function(dt) {
            this._forward.setDelay(dt);
            this._side.setDelay(dt);
            this._lookPosition.setDelay(dt);
            this._pan.setDelay(dt);
            this._zoom.setDelay(dt);
        },

        getEyePosition: function(eye) {
            eye[0] = this._eye[0];
            eye[1] = this._eye[1];
            eye[2] = this._eye[2];
            return eye;
        },

        setEyePosition: function(eye) {
            this._eye[0] = eye[0];
            this._eye[1] = eye[1];
            this._eye[2] = eye[2];
            return this;
        },

        getTarget: function(pos) {
            var dir = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].scale(this._tmpGetTargetDir, this._direction, this._distance);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(pos, this._eye, dir);
            return pos;
        },

        setTarget: function(pos) {
            var dir = this._tmpGetTargetDir;
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].sub(dir, pos, this._eye);
            dir[2] = 0.0;
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(dir, dir);
            this._angleHorizontal = Math.acos(dir[1]);
            if (dir[0] < 0.0) {
                this._angleHorizontal = -this._angleHorizontal;
            }
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].sub(dir, pos, this._eye);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(dir, dir);

            this._angleVertical = -Math.asin(dir[2]);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._direction, dir);
        },

        getLookPositionInterpolator: function() {
            return this._lookPosition;
        },
        getSideInterpolator: function() {
            return this._side;
        },
        getForwardInterpolator: function() {
            return this._forward;
        },
        getPanInterpolator: function() {
            return this._pan;
        },
        getZoomInterpolator: function() {
            return this._zoom;
        },
        getRotateInterpolator: function() {
            // for compatibility with orbit hammer controllers
            return this._lookPosition;
        },

        computeRotation: (function() {
            var first = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
            var rotMat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();

            var right = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0);
            var upy = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0);
            var upz = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);
            var LIMIT = Math.PI * 0.5;
            return function(dx, dy) {
                this._angleVertical += dy * 0.01;
                this._angleHorizontal -= dx * 0.01;
                if (this._angleVertical > LIMIT) this._angleVertical = LIMIT;
                else if (this._angleVertical < -LIMIT) this._angleVertical = -LIMIT;

                if (this._vrEnable) {
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].transformQuat(this._direction, upy, this._vrRot);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(this._direction, this._direction);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].transformQuat(this._up, upz, this._vrRot);
                } else {
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromRotation(first, -this._angleVertical, right);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromRotation(rotMat, -this._angleHorizontal, upz);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(rotMat, rotMat, first);

                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].transformMat4(this._direction, upy, rotMat);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(this._direction, this._direction);
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].transformMat4(this._up, upz, rotMat);
                }
            };
        })(),
        reset: function() {
            this.init();
        },
        setDistance: function(d) {
            this._distance = d;
        },
        getDistance: function() {
            return this._distance;
        },
        setStepFactor: function(t) {
            this._stepFactor = t;
        },

        computePosition: (function() {
            var vec = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].create();

            return function(dt) {
                this._forward.update(dt);
                this._side.update(dt);

                // TDOO why check with epsilon ?
                var factor = this._distance < 1e-3 ? 1e-3 : this._distance;

                // see comment in orbitManipulator for fov modulation speed
                var proj = this._camera.getProjectionMatrix();
                var vFov = proj[15] === 1 ? 1.0 : 2.0 / proj[5];

                // time based displacement vector
                vec[0] = this._forward.getCurrent()[0];
                vec[1] = this._side.getCurrent()[0];
                var len2 = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].sqrLen(vec);
                if (len2 > 1.0) __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].scale(vec, vec, 1.0 / Math.sqrt(len2));

                // direct displacement vectors
                var pan = this._pan.update(dt);
                var zoom = this._zoom.update(dt);

                var timeFactor = this._stepFactor * factor * vFov * dt;
                var directFactor = this._stepFactor * factor * vFov * 0.005;

                this.moveForward(vec[0] * timeFactor - zoom[0] * directFactor * 20.0);
                this.strafe(vec[1] * timeFactor - pan[0] * directFactor);
                this.strafeVertical(-pan[1] * directFactor);

                if (this._vrEnable) {
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, this._vrTrans);
                    // in case setPoseVR skips some frame (possible if tracking is lost temporarily)
                    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].init(this._vrTrans);
                }
            };
        })(),

        update: (function() {
            var tmpTarget = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();

            return function(nv) {
                var dt = nv.getFrameStamp().getDeltaTime();

                var delta = this._lookPosition.update(dt);
                this.computeRotation(-delta[0] * 0.5, -delta[1] * 0.5);
                this.computePosition(dt);

                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(tmpTarget, this._eye, this._direction);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].lookAt(this._inverseMatrix, this._eye, tmpTarget, this._up);

                this._vrEnable = false; // setPoseVR is called on each frame
            };
        })(),

        setPoseVR: function(q, pos) {
            this._vrEnable = true;
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["d" /* quat */].copy(this._vrRot, q);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].sub(this._vrTrans, pos, this._vrPos);
            __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].copy(this._vrPos, pos);
        },

        moveForward: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
            return function(distance) {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(tmp, this._direction);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].scale(tmp, tmp, distance);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, tmp);
            };
        })(),

        strafe: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
            return function(distance) {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].cross(tmp, this._direction, this._up);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(tmp, tmp);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].scale(tmp, tmp, distance);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, tmp);
            };
        })(),

        strafeVertical: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].create();
            return function(distance) {
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].normalize(tmp, this._up);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].scale(tmp, tmp, distance);
                __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].add(this._eye, this._eye, tmp);
            };
        })()
    }),
    'osgGA',
    'FirstPersonManipulator'
);

FirstPersonManipulator.DeviceOrientation = __WEBPACK_IMPORTED_MODULE_3_osgGA_FirstPersonManipulatorDeviceOrientationController__["a" /* default */];
FirstPersonManipulator.Hammer = __WEBPACK_IMPORTED_MODULE_4_osgGA_FirstPersonManipulatorHammerController__["a" /* default */];
FirstPersonManipulator.WebVR = __WEBPACK_IMPORTED_MODULE_5_osgGA_FirstPersonManipulatorWebVRController__["a" /* default */];
FirstPersonManipulator.StandardMouseKeyboard = __WEBPACK_IMPORTED_MODULE_6_osgGA_FirstPersonManipulatorStandardMouseKeyboardController__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (FirstPersonManipulator);


/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


/**
 *  OrbitManipulator
 *  @class
 */
var SwitchManipulator = function() {
    this._manipulatorList = [];
    this._currentManipulator = undefined;
};

/** @lends SwitchManipulator.prototype */
SwitchManipulator.prototype = {
    getCamera: function() {
        return this.getCurrentManipulator().getCamera();
    },
    setCamera: function(cam) {
        var cbList = this.getManipulatorList();
        for (var i = 0, nb = cbList.length; i < nb; ++i) cbList[i].setCamera(cam);
    },
    update: function(nv) {
        var manipulator = this.getCurrentManipulator();
        if (manipulator !== undefined) {
            return manipulator.update(nv);
        }
        return undefined;
    },
    getNode: function() {
        // we should add an accessor in the osgjs manipulator
        return this.getCurrentManipulator()._node;
    },
    setNode: function(node) {
        var cbList = this.getManipulatorList();
        for (var i = 0, nb = cbList.length; i < nb; ++i) cbList[i].setNode(node);
    },
    getControllerList: function() {
        return this.getCurrentManipulator().getControllerList();
    },
    getNumManipulator: function() {
        return this._manipulatorList.length;
    },
    addManipulator: function(manipulator) {
        this._manipulatorList.push(manipulator);
        if (this._currentManipulator === undefined) {
            this.setManipulatorIndex(0);
        }
    },
    getManipulatorList: function() {
        return this._manipulatorList;
    },
    setManipulatorIndex: function(index) {
        this._currentManipulator = index;
    },
    getCurrentManipulatorIndex: function() {
        return this._currentManipulator;
    },
    getCurrentManipulator: function() {
        return this._manipulatorList[this._currentManipulator];
    },
    reset: function() {
        this.getCurrentManipulator().reset();
    },
    computeHomePosition: function(useBoundingBox) {
        var manipulator = this.getCurrentManipulator();
        if (manipulator !== undefined) {
            manipulator.computeHomePosition(useBoundingBox);
        }
    },
    getInverseMatrix: function() {
        var manipulator = this.getCurrentManipulator();
        if (manipulator !== undefined) {
            return manipulator.getInverseMatrix();
        }
    },
    getHomeBound: function(boundStrategy) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('Please use getHomeBoundingSphere instead');
        return this.getHomeBoundingSphere(boundStrategy);
    },
    getHomeBoundingSphere: function(boundStrategy) {
        return this.getCurrentManipulator().getHomeBoundingSphere(boundStrategy);
    },
    getHomeDistance: function(bs) {
        return this.getCurrentManipulator().getHomeDistance(bs);
    }
};

/* harmony default export */ __webpack_exports__["a"] = (SwitchManipulator);


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgUtil_ComposerPostProcess__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgUtil_debug__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_DelayInterpolator__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_DisplayNormalVisitor__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgUtil_DisplayGeometryVisitor__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgUtil_DisplayGraph__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgUtil_IntersectFunctor__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgUtil_Intersector__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgUtil_IntersectionVisitor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgUtil_LineSegmentIntersector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgUtil_LineSegmentIntersectFunctor__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgUtil_NodeGizmo__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osgUtil_gizmoGeometry__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgUtil_PolytopeIntersector__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgUtil_PolytopeIntersectFunctor__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgUtil_SphereIntersector__ = __webpack_require__(236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osgUtil_TangentSpaceGenerator__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osgUtil_WebVRCustom__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osgUtil_WebVR__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__ = __webpack_require__(68);






















var osgUtil = {};

osgUtil.ComposerPostProcess = __WEBPACK_IMPORTED_MODULE_0_osgUtil_ComposerPostProcess__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_11_osg_utils__["a" /* default */].objectMix(osgUtil, __WEBPACK_IMPORTED_MODULE_1_osgUtil_debug__["a" /* default */]);
osgUtil.DelayInterpolator = __WEBPACK_IMPORTED_MODULE_2_osgUtil_DelayInterpolator__["a" /* default */];
osgUtil.DisplayNormalVisitor = __WEBPACK_IMPORTED_MODULE_3_osgUtil_DisplayNormalVisitor__["a" /* default */];
osgUtil.DisplayGeometryVisitor = __WEBPACK_IMPORTED_MODULE_4_osgUtil_DisplayGeometryVisitor__["a" /* default */];
osgUtil.DisplayGraph = __WEBPACK_IMPORTED_MODULE_5_osgUtil_DisplayGraph__["a" /* default */];
osgUtil.IntersectFunctor = __WEBPACK_IMPORTED_MODULE_6_osgUtil_IntersectFunctor__["a" /* default */];
osgUtil.Intersector = __WEBPACK_IMPORTED_MODULE_7_osgUtil_Intersector__["a" /* default */];
osgUtil.IntersectionVisitor = __WEBPACK_IMPORTED_MODULE_8_osgUtil_IntersectionVisitor__["a" /* default */];
osgUtil.LineSegmentIntersector = __WEBPACK_IMPORTED_MODULE_9_osgUtil_LineSegmentIntersector__["a" /* default */];
osgUtil.LineSegmentIntersectFunctor = __WEBPACK_IMPORTED_MODULE_10_osgUtil_LineSegmentIntersectFunctor__["a" /* default */];
osgUtil.NodeGizmo = __WEBPACK_IMPORTED_MODULE_12_osgUtil_NodeGizmo__["a" /* default */];
osgUtil.GizmoGeometry = __WEBPACK_IMPORTED_MODULE_13_osgUtil_gizmoGeometry__["a" /* default */];
osgUtil.WebVRCustom = __WEBPACK_IMPORTED_MODULE_18_osgUtil_WebVRCustom__["a" /* default */];
osgUtil.PolytopeIntersector = __WEBPACK_IMPORTED_MODULE_14_osgUtil_PolytopeIntersector__["a" /* default */];
osgUtil.PolytopeIntersectFunctor = __WEBPACK_IMPORTED_MODULE_15_osgUtil_PolytopeIntersectFunctor__["a" /* default */];
osgUtil.SphereIntersector = __WEBPACK_IMPORTED_MODULE_16_osgUtil_SphereIntersector__["a" /* default */];
osgUtil.TangentSpaceGenerator = __WEBPACK_IMPORTED_MODULE_17_osgUtil_TangentSpaceGenerator__["a" /* default */];
osgUtil.WebVR = __WEBPACK_IMPORTED_MODULE_19_osgUtil_WebVR__["a" /* default */];

osgUtil.NO_LIMIT = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].NO_LIMIT;
osgUtil.LIMIT_ONE_PER_DRAWABLE = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE_PER_DRAWABLE;
osgUtil.LIMIT_ONE = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].LIMIT_ONE;

osgUtil.POINT_PRIMITIVES = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].POINT_PRIMITIVES;
osgUtil.LINE_PRIMITIVES = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].LINE_PRIMITIVES;
osgUtil.TRIANGLE_PRIMITIVES = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].TRIANGLE_PRIMITIVES;
osgUtil.ALL_PRIMITIVES = __WEBPACK_IMPORTED_MODULE_20_osgUtil_intersectionEnums__["a" /* default */].ALL_PRIMITIVES;

/* harmony default export */ __webpack_exports__["a"] = (osgUtil);


/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_CullFace__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Viewport__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osgShader_ShaderProcessor__ = __webpack_require__(63);
















/*
This class creates a post-processing pipeline based on an user-defined list of passes and .glsl files.
The user can thus easily change the order or the passes without having to do the usual stuff: creating cameras, stateSets, bind textures, etc.

======================
=== simple example ===
======================

var composer = new ComposerPostProcess();
composer.setScreenSize( width, height );

composer.addInternalTexture({
    name: 'color',
    immuable: true // the texture object won't change and can be safely used with getInternalTexture
});

// the first %last will be an alias to this texture
composer.setInputTexture( 'color' );

var passes = [];
passes.push({
    func: { name: 'func', file: 'file.glsl' },

    // %last and %next can be seen as stack operators, each %next pushes a texture on the stack while %last takes the top of the stack
    // it allows more flexibility when the user want to change the order of the passes withoug having to change the inputs/outputs/filtering/colorspaces of the other passes
    // it is also better for performances in some cases because it allows the composer to collapse passes in one pass
    textures: [ '%last' ],
    uniforms: [ Uniform.createFloat( 3.8, 'factor' ) ],
    out: { name: '%next' }
});

composer.build( passes );

var color = composer.getInternalTexture( 'color' );

========================
=== advanced example ===
========================

var composer = new ComposerPostProcess();
composer.setScreenSize( width, height );

composer.addInternalTexture({
    name: 'color',
    immuable: true // immuable is used
});

composer.addInternalTexture({
    name: 'depth',
    reusable: false // besides beeing immuable, the texture won't be reused by other passes, can be useful when the texture is needed after post-processing
});

passes.push({
    func: 'func', // will deduce the file func.glsl'
    textures: [ { name: '%last', filter: 'linear' }, 'color' ], // for some reasons, we want to sample that texture in linear
    out: { name: 'pass1', divisor: 2.0 } // we want to render this pass into an half-res texture
    collapsible: false // we don't want this pass to be collapsed into the last pass
});

passes.push({
    func: 'func2',
    header: [ '#define NUM_SAMPLES 10', '#extension GL_EXTENSION_NAME : require' ],

    // %previous is a special predefined value, it will transform the pass into a feedback loop, all is needed now is to swap the textures every frames using:
    // composer.swapFeedbackLoopTextures( boolean )
    texture: [ 'color', '%previous' ],
    out: { name: '%next' }
})

passes.push({
    func: 'func3',
    texture: [ 'pass1', '%last', { name: 'pass2', uniformName: '', srgb: true, rgbm: false } ], // force srgb and rgbm, composer won't override this
    out: { name: %next', filter: 'linear' } // force the linear filter, composer won't override this
    // this pass should be collapsed into the last one, collapsible defaults to false
    collapsible: true
})

// these uniforms will be passed to every shaders created by the composer
composer.setGlobalUniforms( [ uniformTime ] );

var color = composer.getInternalTexture( 'color' );
var depth = composer.getInternalTexture( 'depth' );

*/

var ComposerPostProcess = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].call(this);

    // stuffs for syncing feedback texture uniforms
    this._feedbackSwapped = false; // called on feedack swap
    this._syncFeedbackUniforms = false; // called on resize
    this._syncOnNextFrame = false;
    this._lastXratio = 1;
    this._lastYratio = 1;

    // partial viewport and drs (dynamic resolution scaling)
    this._xViewportRatio = 1.0;
    this._yViewportRatio = 1.0;
    this._xTextureRatio = 1.0;
    this._yTextureRatio = 1.0;
    // in case of dynamic resolution scaling : true will do a final upsampling
    // to full viewport size
    this._finalPassUpScaleToScreen = true;
    // wrap uv stuffs
    this._methodWrapUV = 0;
    this._thresholdWrapUV = 1.0;
    this._texInfos = undefined;

    this._screenWidth = this._screenHeight = 0;

    this._shaderProcessor = Object(__WEBPACK_IMPORTED_MODULE_14_osgShader_ShaderProcessor__["a" /* default */])();

    this._feedbackData = {};

    this._cameras = [];
    this._stateSets = [];
    this._textureUniforms = [];

    this._programs = {};

    this._externalTextures = {};
    this._internalPasses = [];
    this._textures = {};

    this._userTextures = {};

    this._currentPoolIndex = 0;
    this._texturePool = {};

    this._firstTexture = '';

    var stateSet = this.getOrCreateStateSet();
    stateSet.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */].DISABLE));
    stateSet.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_2_osg_CullFace__["a" /* default */](__WEBPACK_IMPORTED_MODULE_2_osg_CullFace__["a" /* default */].BACK));

    this.setCullCallback(this);
};

ComposerPostProcess.VertexShader = [
    'attribute vec3 Vertex;',
    'void main(void) {',
    '  gl_Position = vec4(Vertex * 2.0 - 1.0, 1.0);',
    '}',
    '',
    '#define SHADER_NAME %name%',
    ''
].join('\n');

ComposerPostProcess.FragmentShader = [
    '#ifdef GL_FRAGMENT_PRECISION_HIGH\n precision highp float;\n#else\n precision mediump float;\n#endif',
    'uniform float uRGBMRange;',
    'vec2 gTexCoord;',
    '%uniforms%',
    '',
    '#pragma include "functions.glsl"',
    '',
    '%header%',
    '',
    '%texturesColorSpace%',
    '',
    '%functionBodies%',
    '',
    'void main() {',
    '\tgTexCoord = gl_FragCoord.xy / uTextureOutputSize.xy;',
    '\tvec4 color = %firstFunc%(%firstArg%);',
    '%optionalFuncs%',
    '%colorSpaces%',
    '\tgl_FragColor = color;',
    '}',
    '',
    '#define SHADER_NAME %name%',
    ''
].join('\n');

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    ComposerPostProcess,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */].prototype, {
        clear: function() {
            this._textures = {};
            this._internalPasses.length = 0;

            this._firstTexture = '';

            for (var tex in this._texturePool) {
                this._texturePool[tex].usage = -1;
            }

            this._feedbackData = {};

            this._cameras.length = 0;
            this._stateSets.length = 0;
            this._textureUniforms.length = 0;

            this.removeChildren();
        },

        clearShaderCache: function() {
            this._programs = {};
        },

        getGlobalXRatio: function() {
            return this._xViewportRatio * this._xTextureRatio;
        },

        getGlobalYRatio: function() {
            return this._yViewportRatio * this._yTextureRatio;
        },

        setFinalPassUpScaleToScreen: function(bool) {
            this._finalPassUpScaleToScreen = bool;
        },

        _enforceFromInputParameter: function(paramName, inputTexture) {
            var texName = inputTexture.name;
            var prevTexture = this._textures[texName];
            var prevFeedbackTexture = this._textures[texName + 'FeedbackTexture'];

            var newParam = inputTexture[paramName];
            if (newParam === undefined) {
                return;
            }

            // check possible mismatch
            if (prevTexture[paramName] !== undefined) {
                if (prevTexture[paramName] !== newParam) {
                    console.error('Mismatch on parameter ' + paramName + ' : ' + texName);
                }
            }

            prevTexture[paramName] = newParam;
            if (prevFeedbackTexture) {
                prevFeedbackTexture[paramName] = newParam;
            }
        },

        _updatePassInfoFromInputs: function(pass, passName, lastPassInfo) {
            var outTexture = this._textures[passName];

            var lastPassSrgb = lastPassInfo.srgb;

            // reset
            lastPassInfo.srgb = undefined;

            for (var i = 0; i < pass.textures.length; i++) {
                var inputTexture = pass.textures[i];
                this._renameTextureAlias(inputTexture, passName, lastPassInfo.name);

                var texInfoName = inputTexture.name;
                if (this._externalTextures[texInfoName]) {
                    continue;
                }

                this._usages[texInfoName] = (this._usages[texInfoName] || 0) + 1;

                var requestSrgb = inputTexture.srgb;

                // copy user inputs
                this._enforceFromInputParameter('filter', inputTexture);
                this._enforceFromInputParameter('rgbm', inputTexture);
                this._enforceFromInputParameter('srgb', inputTexture);

                // notify a texture to be encoded in srgb if previous pass was in linear
                var texture = this._textures[texInfoName];
                if (!texture) {
                    var orig = texInfoName.substring(0, texInfoName.indexOf('FeedbackTexture'));
                    texture = this._textures[orig];
                }

                if (lastPassSrgb !== undefined && requestSrgb !== undefined) {
                    if (lastPassSrgb !== requestSrgb) {
                        texture.encodeSRGB = true;
                    }
                }

                this._setInferredParameter('rgbmInferred', 'rgbm', outTexture, texture);
                this._setInferredParameter('srgbInferred', 'srgb', outTexture, texture);
            }

            if (lastPassInfo.srgb === undefined) {
                lastPassInfo.srgb =
                    outTexture.srgb === undefined ? outTexture.srgbInferred : outTexture.srgb;
            }
        },

        _setInferredParameter: function(paramInfer, param, dest, src) {
            if (dest[paramInfer] === undefined) {
                dest[paramInfer] = src[param] === undefined ? src[paramInfer] : src[param];
            }
        },

        _createTextureOut: function(pass, passName, isLastPass) {
            var outTexture = {
                srgb: pass.out.srgb,
                rgbm: pass.out.rgbm,
                filter: pass.out.filter,
                type: pass.out.type
            };

            // enforce : not rgbm if we are in float
            var isFloat = pass.out.type !== __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].UNSIGNED_BYTE;
            if (outTexture.rgbm === undefined && (isLastPass || isFloat)) {
                outTexture.rgbm = false;
            }

            // enforce : linear space if we have rgbm or float texture
            if (outTexture.srgb === undefined) {
                if (isLastPass) outTexture.srgb = true;
                else if (outTexture.rgbm || isFloat) outTexture.srgb = false;
            }

            return outTexture;
        },

        _processUserPasses: function(userPasses) {
            userPasses = this._internalPasses.concat(userPasses);
            var passes = this._preprocessUserPasses(userPasses);

            var numPasses = passes.length;

            var outPasses = [];

            var lastPassInfo = {
                name: this._firstTexture,
                srgb: undefined
            };

            var duplicateNames = {};

            for (var i = 0; i < numPasses; i++) {
                var pass = passes[i];

                var isLastPass = i === numPasses - 1;
                if (!isLastPass && this._collapsePasses(pass, passes[i + 1])) {
                    passes.splice(i + 1, 1);
                    numPasses--;
                    i--;

                    continue;
                }

                var passName = pass.out.name;
                var isNext = passName === '%next';

                if (isNext) {
                    passName = pass.funcs.join('_');

                    if (duplicateNames[passName]) {
                        passName += duplicateNames[passName]++;
                    } else {
                        duplicateNames[passName] = 1;
                    }
                }

                // create textures
                var outTexture = this._createTextureOut(pass, passName, isLastPass);
                this._textures[passName] = outTexture;

                this._updatePassInfoFromInputs(pass, passName, lastPassInfo);

                // feedback texture share same parameters
                if (pass.feedbackLoop) {
                    this._textures[passName + 'FeedbackTexture'] = {
                        srgb: outTexture.srgb,
                        rgbm: outTexture.rgbm,
                        srgbInferred: outTexture.srgbInferred,
                        rgbmInferred: outTexture.rgbmInferred,
                        filter: outTexture.filter
                    };
                }

                if (isNext) {
                    lastPassInfo.name = passName;
                    pass.out.name = passName;
                }

                outPasses.push(pass);
            }

            return outPasses;
        },

        // the number of textures needed by the post-processing stack can be deduced using the user data
        // each texture has an unique name from which an usage number is computed
        // each time a texture is sampled, the usage is decremented
        // when is reaches 0 it means that the texture won't be used anymore so it can be reused
        // besides the usage number, the divisor, internal type and the filtering of the texture are used to make sure it can safely be reused
        _hasFreeTexture: function(passName, filter, out) {
            // passName that directly matches a texture name
            if (passName === out.name && this._texturePool[passName]) {
                return passName;
            }

            if (out.immuable) {
                return;
            }

            for (var key in this._texturePool) {
                var poolTexture = this._texturePool[key];

                // not reusable (could be used after postprocess)
                if (!poolTexture.reusable) continue;

                // still required for a future postprocess pass
                if (poolTexture.usage > 0) continue;

                // different resolution
                if (poolTexture.texture.divisor !== out.divisor) continue;

                // different type (/!\ important, we could change type runtime, that way we cause lot of memory)
                if (poolTexture.texture.getInternalFormatType() !== out.type) continue;

                // first usage
                if (poolTexture.usage === -1) {
                    if (poolTexture.texture.getMinFilter() !== filter) {
                        poolTexture.texture.setMinFilter(filter);
                        poolTexture.texture.setMagFilter(filter);
                    }

                    return key;
                }

                // reuse
                if (poolTexture.texture.getMinFilter() === filter) {
                    return key;
                }
            }

            return;
        },

        _setOrCreateTextureKey: function(usage, passName, out) {
            var isLinear = this._textures[passName].filter === 'linear';
            var filterEnum = isLinear ? __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].LINEAR : __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].NEAREST;

            var poolKey = this._hasFreeTexture(passName, filterEnum, out);
            if (poolKey) {
                this._texturePool[poolKey].usage = usage;
                this._textures[passName].key = poolKey;
                return;
            }

            if (out.immuable) {
                poolKey = passName;
            } else {
                poolKey = 'key' + this._currentPoolIndex++;
            }

            this._texturePool[poolKey] = {
                usage: usage,
                texture: this._createTexture(passName, out.divisor, out.type, filterEnum),
                immuable: out.immuable,
                reusable: out.reusable
            };

            if (out.divisor === -1) {
                this._texturePool[poolKey].width = out.width;
                this._texturePool[poolKey].height = out.height;
            }

            this._textures[passName].key = poolKey;
        },

        _addStateSet: function(pass, stateSet) {
            for (var i = 0; i < pass.funcs.length; i++) {
                var passName = pass.funcs[i].name;

                this._stateSets[passName] = stateSet;
            }
        },

        _addTextureToStateSet: function(textureInfo, stateSet, unit, uniforms, isFeedback) {
            stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_5_osg_Uniform__["a" /* default */].createInt1(unit, textureInfo.uniformName));

            var name = textureInfo.name;
            var texture;

            if (this._textures[name] !== undefined) {
                var key = this._textures[name].key;
                texture = this._texturePool[key].texture;
            } else {
                texture = this._externalTextures[name];
            }

            this._addTextureUniforms(
                textureInfo.uniformName,
                texture,
                stateSet,
                uniforms,
                isFeedback
            );

            if (textureInfo.uniformName === 'TexturePrevious') {
                return unit;
            }

            stateSet.setTextureAttributeAndModes(unit, texture);

            return undefined;
        },

        _getUniformName: function(uniformName) {
            return 'u' + uniformName[0].toUpperCase() + uniformName.slice(1);
        },

        _addTextureUniforms: function(uniformName, texture, stateSet, uniforms, isFeedback) {
            var uName = this._getUniformName(uniformName);

            var uSize = __WEBPACK_IMPORTED_MODULE_5_osg_Uniform__["a" /* default */].createFloat2(uName + 'Size');
            var uRatio = __WEBPACK_IMPORTED_MODULE_5_osg_Uniform__["a" /* default */].createFloat2(uName + 'Ratio');

            stateSet.addUniform(uSize);
            stateSet.addUniform(uRatio);

            uniforms.push(uSize);
            uniforms.push(uRatio);

            this._textureUniforms.push({
                size: uSize,
                ratio: uRatio,
                texture: texture,
                isFeedback: !!isFeedback
            });
        },

        _checkInferredParameters: function() {
            for (var key in this._textures) {
                var tex = this._textures[key];
                if (tex.srgb === undefined) tex.srgb = tex.srgbInferred;
                if (tex.rgbm === undefined) tex.rgbm = tex.rgbmInferred;
            }
        },

        _buildPass: function(index, passes) {
            var pass = passes[index];
            var passName = pass.out.name;

            this._setOrCreateTextureKey(this._usages[passName], passName, pass.out);

            var feedbackName = pass.out.name + 'FeedbackTexture';

            if (pass.feedbackLoop) {
                this._setOrCreateTextureKey(this._usages[feedbackName], feedbackName, pass.out);
            }

            // internal pass (user texture)
            if (!pass.funcs.length) {
                var key = this._textures[passName].key;
                this._userTextures[passName] = this._texturePool[key].texture;
                return;
            }

            var stateSet = new __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__["a" /* default */]();
            this._addStateSet(pass, stateSet);

            var i;
            for (i = 0; i < pass.uniforms.length; i++) {
                stateSet.addUniform(pass.uniforms[i]);
            }

            var uniforms = [];

            var previousTextureUnit = undefined;

            for (i = 0; i < pass.textures.length; i++) {
                var texInfo = pass.textures[i];

                var isFeedback = texInfo.name === feedbackName;
                if (!isFeedback && !this._externalTextures[texInfo.name]) {
                    var poolKey = this._textures[texInfo.name].key;
                    this._texturePool[poolKey].usage--;
                }

                var unit = this._addTextureToStateSet(texInfo, stateSet, i, uniforms, isFeedback);
                if (unit !== undefined) {
                    previousTextureUnit = unit;
                }

                if (this._feedbackData[texInfo.name] === undefined) {
                    continue;
                }

                var nextPass = {
                    stateSet: stateSet,
                    textureUnit: i
                };

                this._feedbackData[texInfo.name].nextPasses.push(nextPass);
            }

            var outputTexture = undefined;
            if (index !== passes.length - 1) {
                var outputKey = this._textures[passName].key;
                outputTexture = this._texturePool[outputKey].texture;
            }

            this._addTextureUniforms('TextureOutput', outputTexture, stateSet, uniforms);

            stateSet.setAttributeAndModes(this._createProgram(pass, uniforms));

            if (pass.feedbackLoop) {
                this._feedbackData[passName] = this._createFeedbackLoopCameras(
                    passName,
                    stateSet,
                    outputTexture,
                    previousTextureUnit
                );
            } else {
                this.addChild(this._createCamera(passName, stateSet, outputTexture));
            }
        },

        _buildGraphFromPasses: function(passes) {
            for (var i = 0; i < passes.length; i++) {
                this._buildPass(i, passes);
            }
        },

        build: function(userPasses) {
            this._usages = {};

            // process array of passes
            var passes = this._processUserPasses(userPasses);

            // fallback on inferred information for srgb/rgbm/filter
            this._checkInferredParameters(passes);

            // create textures, cameras and shader
            this._buildGraphFromPasses(passes);

            this.resize(this._screenWidth, this._screenHeight);
        },

        _createFeedbackLoopCameras: function(name, stateSet, outputTexture, previousTextureUnit) {
            var previousKey = this._textures[name + 'FeedbackTexture'].key;
            var previousTexture = this._texturePool[previousKey].texture;

            var common = new __WEBPACK_IMPORTED_MODULE_1_osg_Node__["a" /* default */]();
            common.setStateSet(stateSet);

            var camera1 = this._createFeedbackLoopCamera(
                name,
                outputTexture,
                previousTexture,
                previousTextureUnit
            );
            var camera2 = this._createFeedbackLoopCamera(
                name + 'FeedbackTexture',
                previousTexture,
                outputTexture,
                previousTextureUnit
            );

            camera2.setNodeMask(0x0);

            common.addChild(camera1);
            common.addChild(camera2);

            this.addChild(common);

            var feedbackLoopData = {};
            feedbackLoopData.camera1 = camera1;
            feedbackLoopData.camera2 = camera2;
            feedbackLoopData.texture1 = outputTexture;
            feedbackLoopData.texture2 = previousTexture;
            feedbackLoopData.nextPasses = [];

            return feedbackLoopData;
        },

        _createFeedbackLoopCamera: function(cameraName, dstTexture, srcTexture, srcUnit) {
            var stateSet = new __WEBPACK_IMPORTED_MODULE_6_osg_StateSet__["a" /* default */]();
            stateSet.setTextureAttributeAndModes(srcUnit, srcTexture);

            var camera = this._createCamera(cameraName, stateSet, dstTexture);
            camera.setStateSet(stateSet);

            return camera;
        },

        _createCamera: function(name, stateSet, outputTexture) {
            var camera = new __WEBPACK_IMPORTED_MODULE_7_osg_Camera__["a" /* default */]();
            camera.setName(name);
            camera.setStateSet(stateSet);
            camera.setClearMask(0x0);
            camera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_13_osg_transformEnums__["a" /* default */].ABSOLUTE_RF);

            if (outputTexture) {
                camera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_7_osg_Camera__["a" /* default */].PRE_RENDER, 0);
                camera.attachTexture(__WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0, outputTexture);
            }

            camera.setViewport(new __WEBPACK_IMPORTED_MODULE_9_osg_Viewport__["a" /* default */]());

            var quad = __WEBPACK_IMPORTED_MODULE_12_osg_shape__["a" /* default */].createTexturedFullScreenFakeQuadGeometry();
            quad.setName('composer layer');
            camera.addChild(quad);

            this._cameras.push(camera);
            return camera;
        },

        swapFeedbackLoopTextures: function(frame0) {
            for (var key in this._feedbackData) {
                var data = this._feedbackData[key];

                data.camera1.setNodeMask(frame0 ? ~0x0 : 0x0);
                data.camera2.setNodeMask(frame0 ? 0x0 : ~0x0);

                var texture = frame0 ? data.texture1 : data.texture2;

                for (var j = 0; j < data.nextPasses.length; j++) {
                    var nextPass = data.nextPasses[j];
                    nextPass.stateSet.setTextureAttributeAndModes(nextPass.textureUnit, texture);
                }
            }

            this._feedbackSwapped = true;
        },

        _createFuncFromUserData: function(userFunc) {
            var func =
                typeof userFunc === 'string'
                    ? { name: userFunc, file: userFunc + '.glsl' }
                    : userFunc;

            // now funcs.join( '_' ) only join the name of the functions instead of every members of the object
            func.toString = function() {
                return this.name;
            };

            return func;
        },

        _createTextureInfoFromUserData: function(userData) {
            var texInfo = {
                name: '',
                uniformName: '',
                rgbm: undefined,
                srgb: undefined,
                filter: undefined
            };

            if (typeof userData === 'string') {
                texInfo.name = userData;
            } else {
                texInfo.name = userData.name;

                if (userData.uniformName) texInfo.uniformName = userData.uniformName;
                if (userData.rgbm !== undefined) texInfo.rgbm = userData.rgbm;
                if (userData.srgb !== undefined) texInfo.srgb = userData.srgb;
                if (userData.filter !== undefined) texInfo.filter = userData.filter;
            }

            return texInfo;
        },

        _preprocessUserPasses: function(userPasses) {
            var passes = [];

            for (var i = 0; i < userPasses.length; i++) {
                var userPass = userPasses[i];

                var pass = {};
                pass.funcs = [];

                if (userPass.func) {
                    pass.funcs.push(this._createFuncFromUserData(userPass.func));
                }

                pass.textures = [];

                pass.feedbackLoop = false;

                if (userPass.textures !== undefined) {
                    if (!Array.isArray(userPass.textures)) {
                        userPass.textures = [userPass.textures];
                    }

                    for (var j = 0; j < userPass.textures.length; j++) {
                        var tex = this._createTextureInfoFromUserData(userPass.textures[j]);

                        if (tex.name === '%previous') {
                            pass.feedbackLoop = true;
                        }

                        pass.textures.push(tex);
                    }
                }

                if (typeof userPass.header === 'string') {
                    pass.header = [userPass.header];
                } else {
                    pass.header = userPass.header || [];
                }

                if (userPass.uniforms !== undefined) {
                    if (Array.isArray(userPass.uniforms)) {
                        pass.uniforms = userPass.uniforms;
                    } else {
                        pass.uniforms = [userPass.uniforms];
                    }
                } else {
                    pass.uniforms = [];
                }

                pass.out = userPass.out;
                // filter/rgbm/srgb are undefined by default
                pass.out.divisor = pass.out.divisor || 1.0;

                pass.out.type = pass.out.type || __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].UNSIGNED_BYTE;
                if (pass.out.immuable === undefined) pass.out.immuable = false;
                if (pass.out.reusable === undefined) pass.out.reusable = true;

                if (pass.feedbackLoop || pass.out.divisor === -1) {
                    pass.out.immuable = true;
                    pass.out.reusable = false;
                }

                pass.collapsible = userPass.collapsible || false;
                passes.push(pass);
            }

            return passes;
        },

        _canBeCollapsed: function(currentPass, nextPass) {
            // this won't merge passes with named textures even if they are collapsible
            // is this what we want?
            return (
                currentPass.funcs.length &&
                nextPass.collapsible &&
                currentPass.out.name === '%next' &&
                currentPass.out.divisor === nextPass.out.divisor &&
                // we dont want to merge fixed size texture if the same isn't equal
                currentPass.out.width === currentPass.out.width &&
                currentPass.out.height === currentPass.out.height
            );
        },

        _collapsePasses: function(currentPass, nextPass) {
            if (!this._canBeCollapsed(currentPass, nextPass)) {
                return false;
            }

            currentPass.funcs = currentPass.funcs.concat(nextPass.funcs);
            currentPass.header = currentPass.header.concat(nextPass.header);

            currentPass.textures = this._mergeWithoutDuplicates(
                currentPass.textures,
                nextPass.textures,
                function(a, b) {
                    return a.name === b.name;
                }
            );

            currentPass.uniforms = this._mergeWithoutDuplicates(
                currentPass.uniforms,
                nextPass.uniforms,
                function(a, b) {
                    return a.getName() === b.getName();
                }
            );

            // not sure if we should collapse feedbackLoop into lastpass?
            return true;
        },

        _renameTextureAlias: function(texture, passName, lastPassName) {
            if (texture.name === '%last') {
                texture.name = lastPassName;
                texture.uniformName = texture.uniformName || 'TextureInput';
            } else if (texture.name === '%previous') {
                texture.name = passName + 'FeedbackTexture';
                texture.uniformName = texture.uniformName || 'TexturePrevious';
            } else if (!texture.uniformName) {
                texture.uniformName = texture.name;
            }
        },

        _createTexture: function(name, divisor, type, filter) {
            var texture = new __WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"]();
            texture.setTextureSize(1, 1);
            texture.setInternalFormatType(type);

            // not always necessary to have 4 channels, might be interesting to set it in pass
            texture.setInternalFormat(__WEBPACK_IMPORTED_MODULE_4_osg_Texture__["default"].RGBA);

            texture.setMinFilter(filter);
            texture.setMagFilter(filter);

            texture.divisor = divisor;
            texture.setName(name);

            return texture;
        },

        _computeHashFromPass: function(pass) {
            var hash = '';

            for (var i = 0; i < pass.funcs.length; i++) {
                hash += pass.funcs[i].name + '_' + pass.funcs[i].file + '_';
            }

            if (pass.header) {
                hash += pass.header.join('_');
            }

            for (i = 0; i < pass.textures.length; i++) {
                hash += !!pass.textures[i].rgbm + '_' + !!pass.textures[i].srgb + '_';
            }

            hash += !!pass.out.encodeSRGB + '_';
            hash += !!this._textures[pass.out.name].rgbm + '_';

            return hash;
        },

        _writeDeclarations: function(source, uniforms, textures, header) {
            var str = 'uniform sampler2D TextureInput;\n';

            var i;
            for (i = 0; i < textures.length; i++) {
                var tname = textures[i].uniformName || textures[i].name;
                str += 'uniform sampler2D ' + tname + ';\n';
            }
            for (i = 0; i < uniforms.length; i++) {
                var uniform = uniforms[i];
                str += 'uniform ' + uniform.getType() + ' ' + uniform.getName() + ';\n';
            }

            source = source.replace('%uniforms%', str);

            if (header) {
                source = source.replace('%header%', header.join('\n'));
            }

            return source;
        },

        setMethodWrapUV: function(method, threshold) {
            // hook every texture call to handle viewport/texture ratio
            // when reading out of texture assigned zone

            // 0 - do nothing
            // 1 - clamp uv
            // 2 - black color
            if (method !== undefined) this._methodWrapUV = method;
            if (threshold !== undefined) this._thresholdWrapUV = threshold;
            this._texInfos = undefined;
        },

        _getInfos: function() {
            if (this._texInfos) return this._texInfos;

            var bodySimple = 'texture2D(%tex, (uv) * %ratio)';
            var bodyNearest =
                'texture2D(%tex, (floor((uv) * %size) + 0.5) * %ratio / %size, -99999.0)';
            var bodyBias = 'texture2D(%tex, (uv) * %ratio)';

            // see setMethodWrapUV
            var val = this._thresholdWrapUV.toExponential();
            if (this._methodWrapUV === 1) {
                var replaceValue = 'min(uv, 1.0 - ' + val + ' / %size.xy)';
                bodySimple = bodySimple.replace(/(uv)/g, replaceValue);
                bodyNearest = bodyNearest.replace(/(uv)/g, replaceValue);
                bodyBias = bodyBias.replace(/(uv)/g, replaceValue);
            } else if (this._methodWrapUV === 2) {
                var prefix = 'step((uv).x, 1.0 - ' + val + ' / %size.x) *';
                prefix += 'step((uv).y, 1.0 - ' + val + ' / %size.y) * ';
                bodySimple = prefix + bodySimple;
                bodyNearest = prefix + bodyNearest;
                bodyBias = prefix + bodyBias;
            }

            this._texInfos = {
                TEXTURE_2D: {
                    signature: 'TEXTURE_2D_%tex(uv)',
                    body: bodySimple
                },
                TEXTURE_2D_NEAREST: {
                    signature: 'TEXTURE_2D_NEAREST_%tex(uv)',
                    body: bodyNearest
                },
                TEXTURE_2D_BIAS: {
                    signature: 'TEXTURE_2D_BIAS_%tex(uv, bias)',
                    body: bodyBias
                }
            };

            return this._texInfos;
        },

        _extractTextures: function(file) {
            var infos = this._getInfos();

            var lines = file.match(/TEXTURE_2D(?:_BIAS|_NEAREST)?_\w+\(/g);
            if (!lines) return {};

            var textures = {};

            for (var j = 0; j < lines.length; j++) {
                var str = lines[j].match(/((TEXTURE_2D(?:_BIAS|_NEAREST)?)_(\w+))\(/);
                var info = infos[str[2]];

                textures[str[1]] = {
                    name: str[3],
                    signature: info.signature,
                    body: info.body
                };
            }

            return textures;
        },

        _writeFunctionBodies: function(source, funcs, textures, collapsible) {
            var colorSpacesDefines = [];
            var functionBodies = '';
            var defineKeys = {};

            for (var i = 0; i < funcs.length; i++) {
                var file = this._shaderProcessor.getShaderTextPure(funcs[i].file);
                functionBodies += file + '\n';
            }

            // resolve pragma include
            var includeList = ['functions.glsl']; // included in composer main shader
            functionBodies = this._shaderProcessor.preprocess(functionBodies, 0, includeList);

            var textureDefines = this._extractTextures(functionBodies);
            if (collapsible) {
                var tex2dInfo = this._getInfos().TEXTURE_2D;
                textureDefines.TEXTURE_2D_TextureInput = {
                    name: 'TextureInput',
                    signature: tex2dInfo.signature,
                    body: tex2dInfo.body
                };
            }

            for (var key in textureDefines) {
                if (defineKeys[key]) {
                    continue;
                }

                defineKeys[key] = true;

                var defineInfo = textureDefines[key];
                var texName = defineInfo.name;

                var rgbm = false;
                // check if the textures is rgbm
                for (var j = 0; j < textures.length; j++) {
                    var inTex = textures[j];
                    if (inTex.uniformName !== texName) {
                        continue;
                    }

                    var tex = this._textures[inTex.name];
                    if (tex && tex.rgbm) {
                        rgbm = tex.rgbm;
                        break;
                    }
                }

                var code = defineInfo.body;
                if (rgbm) code = 'vec4(decodeRGBM(' + code + ', uRGBMRange), 1.0)';
                code = '#define ' + defineInfo.signature + ' (' + code + ')';

                // replace %stuff by uniform names
                var uName = this._getUniformName(texName);
                code = code.replace(/%size/g, uName + 'Size');
                code = code.replace(/%ratio/g, uName + 'Ratio');
                code = code.replace(/%tex/g, texName);

                colorSpacesDefines.push(code);
            }

            source = source.replace('%texturesColorSpace%', colorSpacesDefines.join('\n'));

            // allows multi-line defines in sub-shaders
            return source.replace('%functionBodies%', functionBodies.replace(/\\\n/g, ''));
        },

        _writeMainFunction: function(source, funcs, collapsible, textureName) {
            source = source.replace('%firstFunc%', funcs[0].name);

            var arg = collapsible ? 'TEXTURE_2D_TextureInput(gTexCoord)' : '';
            source = source.replace('%firstArg%', arg);

            var str = '';

            for (var i = 1; i < funcs.length; i++) {
                str += '\tcolor = ' + funcs[i].name + '(color);\n';
            }

            source = source.replace('%optionalFuncs%', str);

            if (this._textures[textureName].encodeSRGB === true) {
                var func = this._textures[textureName].srgb ? 'linearTosRGB' : 'sRGBToLinear';
                str = '\tcolor.rgb = ' + func + '(color.rgb);\n';
            } else {
                str = '';
            }

            if (this._textures[textureName].rgbm) {
                str += '\tcolor = encodeRGBM(color.rgb, uRGBMRange);';
            } else {
                str += '';
            }

            return source.replace('%colorSpaces%', str);
        },

        // an hash string is created using the user pass data before creating a program
        // shaders are stored inside a map using this string, so the composer knows there is no need to rebuild it if it already exists

        _removeDuplicatedUniforms: function(source) {
            var lines = source.split('\n');

            var uniforms = {};

            var numLines = lines.length;

            for (var i = 0; i < numLines; i++) {
                var match = lines[i].match(/uniform(?:\s+){1,}\w+(?:\s+){1,}(\w+)/);
                if (match === null) {
                    continue;
                }

                var name = match[1];

                if (uniforms[name] !== undefined) {
                    lines.splice(i, 1);
                    numLines--;
                    i--;
                } else {
                    uniforms[name] = true;
                }
            }

            return lines.join('\n');
        },

        _createProgram: function(pass, uniforms) {
            var hash = this._computeHashFromPass(pass);
            if (this._programs[hash] !== undefined) {
                return this._programs[hash];
            }

            var source = this._writeDeclarations(
                ComposerPostProcess.FragmentShader,
                uniforms,
                pass.textures,
                pass.header
            );

            source = this._writeFunctionBodies(source, pass.funcs, pass.textures, pass.collapsible);
            source = this._writeMainFunction(source, pass.funcs, pass.collapsible, pass.out.name);

            source = source.replace('%name%', pass.out.name);
            source = this._removeDuplicatedUniforms(source);

            var vertexSource = ComposerPostProcess.VertexShader.replace('%name%', pass.out.name);
            var program = new __WEBPACK_IMPORTED_MODULE_10_osg_Program__["a" /* default */](
                new __WEBPACK_IMPORTED_MODULE_11_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_osg_Shader__["a" /* default */].VERTEX_SHADER, vertexSource),
                new __WEBPACK_IMPORTED_MODULE_11_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_11_osg_Shader__["a" /* default */].FRAGMENT_SHADER, source)
            );

            this._programs[hash] = program;
            return program;
        },

        resize: function(width, height) {
            this.setScreenSize(width, height);

            // resize texture
            for (var key in this._texturePool) {
                var texture = this._texturePool[key].texture;

                if (this._texturePool[key].width !== undefined) {
                    texture.setTextureSize(
                        this._texturePool[key].width,
                        this._texturePool[key].height
                    );

                    continue;
                }

                texture.setTextureSize(
                    this._getTextureSize(width, texture.divisor),
                    this._getTextureSize(height, texture.divisor)
                );
            }

            this.resizeRatio();
        },

        resizeRatio: function(xViewport, yViewport, xTexture, yTexture) {
            if (xViewport !== undefined) this._xViewportRatio = xViewport;
            if (yViewport !== undefined) this._yViewportRatio = yViewport;
            if (xTexture !== undefined) this._xTextureRatio = xTexture;
            if (yTexture !== undefined) this._yTextureRatio = yTexture;

            this._resizeViewports();
            this._resizeTextureUniforms();
        },

        _resizeViewports: function() {
            var xRatio = this.getGlobalXRatio();
            var yRatio = this.getGlobalYRatio();

            var cameras = this._cameras;
            for (var i = 0; i < cameras.length; ++i) {
                var camera = cameras[i];

                var isRtt = camera.isRenderToTextureCamera();
                var divisor = 1;
                if (isRtt) {
                    var attachment = camera.getAttachments()[__WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0];
                    divisor = attachment.texture.divisor;
                }

                if (i === cameras.length - 1 && this._finalPassUpScaleToScreen) {
                    xRatio = this._xViewportRatio;
                    yRatio = this._yViewportRatio;
                }

                if (divisor === -1) {
                    continue;
                }

                var width = this._getTextureSize(this._screenWidth, divisor / xRatio);
                var height = this._getTextureSize(this._screenHeight, divisor / yRatio);

                camera.getViewport().setViewport(0, 0, width, height);
            }
        },

        _resizeTextureUniforms: function() {
            var xRatio = this.getGlobalXRatio();
            var yRatio = this.getGlobalYRatio();

            var xFinalRatio = this._finalPassUpScaleToScreen ? this._xViewportRatio : xRatio;
            var yFinalRatio = this._finalPassUpScaleToScreen ? this._yViewportRatio : yRatio;

            // we delay the uniform size/ratio of the feedback texture on next frame
            this._syncFeedbackUniforms = true;

            var tunifs = this._textureUniforms;
            for (var i = 0; i < tunifs.length; ++i) {
                var obj = tunifs[i];
                var size = obj.size.getInternalArray();
                var ratio = obj.ratio.getInternalArray();

                // feedback texture update is delayed (unless first frame)
                if (obj.isFeedback && size[0]) {
                    continue;
                }

                ratio[0] = xRatio;
                ratio[1] = yRatio;

                var texture = obj.texture;
                // final pass
                if (!texture) {
                    size[0] = this._screenWidth * xFinalRatio;
                    size[1] = this._screenHeight * yFinalRatio;
                    continue;
                }

                // external texture
                if (!texture.divisor || texture.divisor < 0) {
                    size[0] = texture.getWidth();
                    size[1] = texture.getHeight();

                    ratio[0] = ratio[1] = 1.0;
                    continue;
                }

                // don't floor/round/ceil
                // (it may be useful when we force a nearest fetch in a shader)
                size[0] = xRatio * texture.getWidth();
                size[1] = yRatio * texture.getHeight();
            }
        },

        _resizeFeedbackTextureUniforms: function() {
            var xRatio = this._lastXratio;
            var yRatio = this._lastYratio;

            var tunifs = this._textureUniforms;
            for (var i = 0; i < tunifs.length; ++i) {
                var obj = tunifs[i];
                if (!obj.isFeedback) continue;

                var size = obj.size.getInternalArray();
                var ratio = obj.ratio.getInternalArray();

                var texture = obj.texture;
                ratio[0] = xRatio;
                ratio[1] = yRatio;

                size[0] = xRatio * texture.getWidth();
                size[1] = yRatio * texture.getHeight();
            }
        },

        cull: function() {
            if (this._syncOnNextFrame) {
                this._resizeFeedbackTextureUniforms();
                this._syncOnNextFrame = false;
            }

            if (this._syncFeedbackUniforms) {
                if (this._feedbackSwapped) {
                    this._syncFeedbackUniforms = false;
                    this._syncOnNextFrame = true;
                    this._lastXratio = this.getGlobalXRatio();
                    this._lastYratio = this.getGlobalYRatio();
                }
            }

            this._feedbackSwapped = false;
            return true;
        },

        _mergeWithoutDuplicates: function(a, b, compareFunc) {
            for (var i = 0; i < b.length; i++) {
                var element = b[i];

                var add = true;

                for (var j = 0; j < a.length; j++) {
                    if (compareFunc(a[j], element)) {
                        add = false;
                        break;
                    }
                }

                if (add) {
                    a.push(element);
                }
            }

            return a;
        },

        _getTextureSize: function(size, divisor) {
            return Math.max(1.0, Math.round(size / divisor));
        },

        setScreenSize: function(width, height) {
            this._screenWidth = width;
            this._screenHeight = height;
        },

        setShaderProcessor: function(shaderProcessor) {
            this._shaderProcessor = shaderProcessor;
        },

        // textures owned by the composer, they will be cached/reused/resized unless reusable or immuable
        addInternalTexture: function(desc) {
            this._internalPasses.push({
                out: {
                    name: desc.name,
                    divisor: desc.divisor,
                    type: desc.type,
                    filter: desc.filter,
                    srgb: desc.srgb,
                    rgbm: desc.rgbm,
                    immuable: desc.immuable,
                    reusable: desc.reusable
                }
            });
        },

        // textures not owned by the composer, they won't be cached/reused/resized
        addExternalTexture: function(key, texture) {
            this._externalTextures[key] = texture;
        },

        setInputTexture: function(key) {
            this._firstTexture = key;
        },

        getCameras: function() {
            return this._cameras;
        },

        getStateSetPass: function(passName) {
            return this._stateSets[passName];
        },

        getInternalTexture: function(alias) {
            return this._userTextures[alias];
        }
    }),
    'osgUtil',
    'ComposerPostProcess'
);

/* harmony default export */ __webpack_exports__["a"] = (ComposerPostProcess);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_utils__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__ = __webpack_require__(71);




var sprintf = __WEBPACK_IMPORTED_MODULE_1_osgShader_utils__["a" /* default */].sprintf;

// Base Class for all variables Nodes
// TODO: add precision
// type {string} vec3/4/2, float, int, etc.
// prefix {string} vec3/4/2, float, int, etc.
var Variable = function(type, prefix) {
    __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].call(this);
    this._name = 'Variable';
    this._prefix = prefix;
    this._type = type;
    this._value = undefined;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Variable,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].prototype, {
        getType: function() {
            return this._type;
        },

        getVariable: function() {
            return this._prefix;
        },

        setValue: function(value) {
            this._value = value;
            return this;
        },

        toString: function() {
            var str = this._name + ' ' + this._prefix;
            if (this._type) str += ' (' + this._type + ')';
            str += ' - id:' + this._id;
            return str;
        },

        declare: function() {
            if (this._value !== undefined) {
                return sprintf('%s %s = %s;', [this._type, this.getVariable(), this._value]);
            } else {
                return sprintf('%s %s;', [this._type, this.getVariable()]);
            }
        },

        isEmpty: function() {
            return this._value === undefined && this._inputs.length === 0;
        },

        reset: function() {
            this._inputs = [];
            this._outputs = null;
            this._value = undefined;
            this._text = undefined;
        }
    }),
    'osgShader',
    'Variable'
);

// Constant Variable
// help glsl compiler and make sure no one writes in it :)
var Constant = function(type, prefix) {
    Variable.call(this, type, prefix);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Constant,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        declare: function() {
            return sprintf('const %s %s = %s;', [this._type, this.getVariable(), this._value]);
        }
    }),
    'osgShader',
    'Constant'
);

var Uniform = function(type, prefix, size) {
    Variable.call(this, type, prefix);
    this._size = size;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Uniform,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        declare: function() {
            return undefined;
        },

        globalDeclaration: function() {
            if (this._size) {
                return sprintf('uniform %s %s[%s];', [this._type, this.getVariable(), this._size]);
            } else {
                return sprintf('uniform %s %s;', [this._type, this.getVariable()]);
            }
        }
    }),
    'osgShader',
    'Uniform'
);

// Vertex Attribute Variables
var Attribute = function(type, prefix) {
    Variable.call(this, type, prefix);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Attribute,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        declare: function() {
            return undefined;
        },

        globalDeclaration: function() {
            return sprintf('attribute %s %s;', [this._type, this.getVariable()]);
        }
    }),
    'osgShader',
    'Attribute'
);

var Varying = function(type, prefix) {
    Variable.call(this, type, prefix);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Varying,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        declare: function() {
            return undefined;
        },

        globalDeclaration: function() {
            return sprintf('varying %s %s;', [this._type, this.getVariable()]);
        }
    }),
    'osgShader',
    'Varying'
);

var Sampler = function(type, prefix) {
    Variable.call(this, type, prefix);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Sampler,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        declare: function() {
            return undefined;
        },

        globalDeclaration: function() {
            return sprintf('uniform %s %s;', [this._type, this.getVariable()]);
        }
    }),
    'osgShader',
    'Sampler'
);

// Graph Root Node Abstract Class
// Derive from that for new outputs
// gl_FragDepth, etc.
var Output = function(type, wholeName) {
    Variable.call(this, type, wholeName);
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Output,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Variable.prototype, {
        _unique: true,
        isUnique: function() {
            return this._unique;
        },
        outputs: function() {
            /* do nothing for variable */
            return this;
        },
        getVariable: function() {
            return this._prefix;
        }
    }),
    'osgShader',
    'Output'
);

// Graph Root Nodes
var glFragColor = function() {
    Output.call(this, 'vec4', 'gl_FragColor');
    this._name = 'glFragColor';
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    glFragColor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Output.prototype, {}),
    'osgShader',
    'glFragColor'
);

var glPosition = function() {
    Output.call(this, 'vec4', 'gl_Position');
    this._name = 'glPosition';
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    glPosition,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Output.prototype, {}),
    'osgShader',
    'glPosition'
);

var glPointSize = function() {
    Output.call(this, 'float', 'gl_PointSize');
    this._name = 'glPointSize';
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    glPointSize,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(Output.prototype, {}),
    'osgShader',
    'glPointSize'
);

var Define = function(name) {
    __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].call(this);
    this._defineName = name;
    this._defineValue = '';
};
__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    Define,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].prototype, {
        type: 'Define',
        setValue: function(value) {
            this._defineValue = value;
            return this;
        },
        getDefines: function() {
            return ['#define ' + this._defineName + ' ' + this._defineValue];
        }
    }),
    'osgShader',
    'Define'
);

/* harmony default export */ __webpack_exports__["a"] = ({
    Output: Output,
    glPointSize: glPointSize,
    glPosition: glPosition,
    glFragColor: glFragColor,
    Sampler: Sampler,
    Variable: Variable,
    Constant: Constant,
    Attribute: Attribute,
    Varying: Varying,
    Uniform: Uniform,
    Define: Define
});


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShader_ShaderGenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowCastShaderGenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_DisplayNormalVisitor__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgUtil_DisplayGeometryVisitor__ = __webpack_require__(157);






var ShaderGeneratorProxy = function() {
    // object of shader generators
    this._generators = {};
    this.addShaderGenerator('default', new __WEBPACK_IMPORTED_MODULE_1_osgShader_ShaderGenerator__["a" /* default */]());
    this.addShaderGenerator('ShadowCast', new __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowCastShaderGenerator__["a" /* default */]());
    this.addShaderGenerator(
        'debugNormal',
        new __WEBPACK_IMPORTED_MODULE_3_osgUtil_DisplayNormalVisitor__["a" /* default */].ShaderGeneratorCompilerOffsetNormal()
    );
    this.addShaderGenerator(
        'debugTangent',
        new __WEBPACK_IMPORTED_MODULE_3_osgUtil_DisplayNormalVisitor__["a" /* default */].ShaderGeneratorCompilerOffsetTangent()
    );
    this.addShaderGenerator(
        'debugGeometry',
        new __WEBPACK_IMPORTED_MODULE_4_osgUtil_DisplayGeometryVisitor__["a" /* default */].ShaderGeneratorCompilerColorGeometry()
    );
    this.addShaderGenerator(
        'debugSkinning',
        new __WEBPACK_IMPORTED_MODULE_4_osgUtil_DisplayGeometryVisitor__["a" /* default */].ShaderGeneratorCompilerColorSkinning()
    );

    return this;
};

ShaderGeneratorProxy.prototype = {
    getShaderGenerator: function(name) {
        if (!name) return this._generators.default;

        var shaderGenerator = this._generators[name];

        if (!shaderGenerator) {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('ShaderGenerator ' + name + ' does not exist in ShaderGeneratorProxy');
            return this._generators.default;
        }

        return shaderGenerator;
    },

    // user-space facility to provide its own
    addShaderGenerator: function(name, sg) {
        this._generators[name] = sg;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ShaderGeneratorProxy);


/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__ = __webpack_require__(71);




// Abstract class
// base operator contains helper for the constructor
// it helps to do that:
// arg0 = output
// arg1 = input0 or [ inputs ]
// arg2 = input1
// ...
var BaseOperator = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].call(this);
};

BaseOperator.prototype = __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].prototype;

// Add support this syntax:
// new Add( output, input0, input1, ... )
// new Add( output, [ inputs ] )
// glsl code output = input0 + input1 +...
var Add = function() {
    BaseOperator.call(this);
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    Add,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(BaseOperator.prototype, {
        type: 'Add',

        operator: '+',

        _getFirstVariableCast: function() {
            var variable = this._inputs[0].getVariable();
            var inType = this._inputs[0].getType();
            var outType = this._outputs.getType();

            if (outType === inType) return variable;

            // upcast float
            if (inType === 'float') return outType + '(' + variable + ')';

            // downcast vector
            if (outType === 'vec3') return variable + '.rgb';
            if (outType === 'vec2') return variable + '.rg';
            if (outType === 'float') return variable + '.r';

            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('Mismatch type : ' + outType + ' with ' + inType + ', ' + variable);
            return variable;
        },

        computeShader: function() {
            // force inputs type to be all the same from the output
            var outputType = this._outputs.getType();
            var addType = '';

            if (outputType === 'vec4') addType = '.rgba';
            else if (outputType === 'vec3') addType = '.rgb';
            else if (outputType === 'vec2') addType = '.rg';

            var firstVariable = this._getFirstVariableCast();
            var str = this._outputs.getVariable() + ' = ' + firstVariable;

            for (var i = 1, l = this._inputs.length; i < l; i++) {
                var input = this._inputs[i];
                str += this.operator + input.getVariable();

                var inType = input.getType();
                if (inType !== 'float' && inType !== outputType) {
                    str += addType;
                }
            }
            str += ';';
            return str;
        }
    }),
    'osgShader',
    'Add'
);

// Mult works like Add
// glsl code output = input0 * input1 * ...
var Mult = function() {
    Add.call(this);
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    Mult,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(Add.prototype, {
        type: 'Mult',
        operator: '*'
    }),
    'osgShader',
    'Mult'
);

// basic assignement alias: output = input
// glsl code output = input0
var SetFromNode = function() {
    Add.call(this);
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    SetFromNode,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(Add.prototype, {
        type: 'SetFromNode'
    }),
    'osgShader',
    'SetFromNode'
);

// Mult Matrix * vector4
// making the cast vector4(input.xyz, 0)
// if needed
// glsl code output = matrix * vector4(vec.xyz, 0)
var MatrixMultDirection = function() {
    Add.call(this);
    this._overwriteW = true; // if set to false, we copy the input alpha in the output alpha
    this._forceComplement = true;
    this._inverseOp = false;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    MatrixMultDirection,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(Add.prototype, {
        type: 'MatrixMultDirection',
        operator: '*',
        validInputs: ['vec', 'matrix'],
        validOutputs: ['vec'],
        complement: '0.',
        setInverse: function(bool) {
            this._inverseOp = bool;
            return this;
        },
        setForceComplement: function(bool) {
            this._forceComplement = bool;
            return this;
        },
        setOverwriteW: function(bool) {
            this._overwriteW = bool;
            return this;
        },
        computeShader: function() {
            // force inputs type to be all the same from the output
            // and handle vector complement
            var vecIn = this._inputs.vec.getVariable();
            var matrix = this._inputs.matrix.getVariable();
            var vecOut = this._outputs.vec.getVariable();

            var inputType = this._inputs.vec.getType();
            var outputType = this._outputs.vec.getType();
            var matrixType = this._inputs.matrix.getType();

            var strOut = vecOut;

            if (matrixType === 'mat4') {
                strOut += ' = ';

                if (outputType !== 'vec4') strOut += outputType + '(';

                var strCasted = vecIn;
                if (this._forceComplement || inputType !== 'vec4')
                    strCasted = 'vec4(' + vecIn + '.xyz, ' + this.complement + ')';

                strOut += this._inverseOp
                    ? strCasted + this.operator + matrix
                    : matrix + this.operator + strCasted;

                if (outputType !== 'vec4') strOut += ')';

                strOut += ';';

                if (!this._overwriteW && inputType === 'vec4')
                    strOut += '\n' + vecOut + '.a = ' + vecIn + '.a;';
            } else {
                if (outputType === 'vec4') strOut += '.xyz';
                strOut += ' = ';

                var strvec3 = vecIn + '.xyz';
                strOut +=
                    (this._inverseOp
                        ? strvec3 + this.operator + matrix
                        : matrix + this.operator + strvec3) + ';';

                if (!this._overwriteW && outputType === 'vec4' && inputType === 'vec4')
                    strOut += '\n' + vecOut + '.a = ' + vecIn + '.a;';
            }

            return strOut;
        }
    }),
    'osgShader',
    'MatrixMultDirection'
);

// override only for complement.
// glsl code output = matrix * vector4(vec.xyz, 1)
var MatrixMultPosition = function() {
    MatrixMultDirection.call(this);
    this._forceComplement = false;
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    MatrixMultPosition,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(MatrixMultDirection.prototype, {
        type: 'MatrixMultPosition',
        complement: '1.'
    }),
    'osgShader',
    'MatrixMultPosition'
);

var Blend = function() {
    BaseOperator.apply(this);
    this._mode = 'MIX';
};
__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    Blend,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(BaseOperator.prototype, {
        type: 'Blend',
        mode: function(mode) {
            this._mode = mode;
            return this;
        },
        computeShader: function() {
            return this[this._mode === undefined ? 'MIX' : this._mode]();
        },
        ADD: function() {
            return (
                this._outputs.getVariable() +
                ' = ' +
                this._inputs[0].getVariable() +
                ' + (' +
                this._inputs[1].getVariable() +
                ' * ' +
                this._inputs[2].getVariable() +
                ');'
            );
        },
        MIX: function() {
            // result = val0*(1.0-t) + t*val1
            return (
                this._outputs.getVariable() +
                ' = mix(' +
                this._inputs[0].getVariable() +
                ', ' +
                this._inputs[1].getVariable() +
                ', ' +
                this._inputs[2].getVariable() +
                ');'
            );
        },
        MULTIPLY: function() {
            return (
                this._outputs.getVariable() +
                ' = ' +
                this._inputs[0].getVariable() +
                ' * mix( ' +
                this._inputs[0].getType() +
                '(1.0), ' +
                this._inputs[1].getVariable() +
                ', ' +
                this._inputs[2].getVariable() +
                ');'
            );
        }
    })
);

// For all you custom needs.
//
// call Code() with variable input/output replace
// indexed by the '%'
// getNode( 'InlineCode' ).code( '%out = %input;' ).inputs( {
//             input: this.getOrCreateConstant( 'float', 'unitFloat' ).setValue( '1.0' )
//        } ).outputs( {
//            out: this.getNode( 'glPointSize' )
// }
//
var InlineCode = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].call(this);
};

__WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].createPrototypeObject(
    InlineCode,
    __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgShader_node_Node__["a" /* default */].prototype, {
        type: 'InlineCode',
        code: function(txt) {
            this._text = txt;
            return this;
        },
        computeShader: function() {
            // merge inputs and outputs dict to search in both
            var replaceVariables = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix({}, this._inputs);
            replaceVariables = __WEBPACK_IMPORTED_MODULE_1_osg_utils__["a" /* default */].objectMix(replaceVariables, this._outputs);

            // find all %string
            var r = new RegExp('%[A-Za-z0-9_]+', 'gm');
            var text = this._text;
            var result = this._text.match(r);

            var done = new Set(); // keep trace of replaced string

            for (var i = 0; i < result.length; i++) {
                var str = result[i].substr(1);
                if (!done.has(str)) {
                    if (!replaceVariables[str]) {
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('error with inline code\n' + this._text);
                        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].error('input ' + str + ' not provided for ' + result[i]);
                    }
                    var reg = new RegExp(result[i].toString(), 'gm');
                    text = text.replace(reg, replaceVariables[str].getVariable());
                    done.add(str);
                }
            }

            return text;
        }
    }),
    'osgShader',
    'InlineCode'
);

/* harmony default export */ __webpack_exports__["a"] = ({
    BaseOperator: BaseOperator,
    Mult: Mult,
    MatrixMultPosition: MatrixMultPosition,
    MatrixMultDirection: MatrixMultDirection,
    Add: Add,
    Blend: Blend,
    InlineCode: InlineCode,
    SetFromNode: SetFromNode
});


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


var CompilerVertex = {
    _createVertexShader: function() {
        // Call to specialised inhenrited shader Compiler
        var roots = this.declareVertexMain();
        var vname = this.getVertexShaderName();
        if (vname) roots.push(this.getNode('Define', 'SHADER_NAME').setValue(vname));

        // call the graph compiler itself
        var shader = this.createShaderFromGraphs(roots);

        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug(this.getDebugIdentifier());
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].debug(shader);

        return shader;
    },

    declareVertexMain: function() {
        // Because of a weird bug on iOS, glPosition should be computed in the vertex shader before some varyings
        var roots = [this.declarePointSize(), this.declareVertexPosition()];

        this.declareVertexVaryings(roots);

        return roots;
    },

    declarePointSize: function() {
        var glPointSize = this.getNode('glPointSize');

        if (!this._pointSizeAttribute || !this._pointSizeAttribute.isEnabled()) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateConstantOne('float'))
                .outputs(glPointSize);
            return glPointSize;
        }

        this.getNode('InlineCode')
            .code('%pointSize = min(64.0, max(1.0, -%size / %position.z));')
            .inputs({
                position: this.getOrCreateViewVertex(),
                size: this.getOrCreateUniform('float', 'uPointSize')
            })
            .outputs({
                pointSize: glPointSize
            });

        return glPointSize;
    },

    declareVertexVaryings: function(roots) {
        var varyings = this._varyings;

        if (varyings.vModelVertex) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateModelVertex())
                .outputs(varyings.vModelVertex);
        }

        if (varyings.vModelNormal) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateModelNormal())
                .outputs(varyings.vModelNormal);
        }

        if (varyings.vModelTangent) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateModelTangent())
                .outputs(varyings.vModelTangent);
        }

        if (varyings.vViewVertex) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateViewVertex())
                .outputs(varyings.vViewVertex);
        }

        if (varyings.vViewNormal) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateViewNormal())
                .outputs(varyings.vViewNormal);
        }

        if (varyings.vViewTangent) {
            this.getNode('SetFromNode')
                .inputs(this.getOrCreateViewTangent())
                .outputs(varyings.vViewTangent);
        }

        if (varyings.vVertexColor) {
            this.getNode('InlineCode')
                .code('%vcolor = %venabled == 1.0 ? %acolor : vec4(1.0, 1.0, 1.0, 1.0);')
                .inputs({
                    venabled: this.getOrCreateUniform('float', 'uArrayColorEnabled'),
                    acolor: this.getOrCreateAttribute('vec4', 'Color')
                })
                .outputs({
                    vcolor: this.getOrCreateVarying('vec4', 'vVertexColor')
                });
        }

        for (var keyVarying in varyings) {
            var varying = varyings[keyVarying];
            roots.push(varying);

            var name = varying.getVariable();
            if (name.indexOf('vTexCoord') !== -1) {
                this.getNode('SetFromNode')
                    .inputs(this.getOrCreateAttribute('vec2', name.substring(1)))
                    .outputs(varying);
            }
        }
    },

    declareVertexPosition: function() {
        var glPosition = this.getNode('glPosition');
        if (this._isBillboard) this.declareVertexTransformBillboard(glPosition);
        else this.declareScreenVertex(glPosition);
        return glPosition;
    },

    declareScreenVertex: function(glPosition) {
        this.getNode('MatrixMultPosition')
            .inputs({
                matrix: this.getOrCreateProjectionMatrix(),
                vec: this.getOrCreateViewVertex()
            })
            .outputs({
                vec: glPosition
            });
    },

    declareVertexTransformBillboard: function(glPosition) {
        this.getNode('Billboard')
            .inputs({
                Vertex: this.getOrCreateAttribute('vec3', 'Vertex'),
                ModelViewMatrix: this.getOrCreateUniform('mat4', 'uModelViewMatrix'),
                ProjectionMatrix: this.getOrCreateUniform('mat4', 'uProjectionMatrix')
            })
            .outputs({
                result: glPosition
            });
    },

    getOrCreateBoneMatrix: function() {
        // reusable BoneMatrix between Vertex, Normal, Tangent
        // Manadatory: scale animations must be uniform scale
        var boneMatrix = this._variables.boneMatrix;
        if (boneMatrix) return boneMatrix;
        boneMatrix = this.createVariable('mat4', 'boneMatrix');

        var inputWeights = this.getOrCreateAttribute('vec4', 'Weights');
        var inputBones = this.getOrCreateAttribute('vec4', 'Bones');
        var matrixPalette = this.getOrCreateUniform(
            'vec4',
            'uBones',
            this._skinningAttribute.getBoneUniformSize()
        );

        this.getNode('Skinning')
            .inputs({
                weights: inputWeights,
                bonesIndex: inputBones,
                matrixPalette: matrixPalette
            })
            .outputs({
                result: boneMatrix
            });

        return boneMatrix;
    },

    getTarget: function(name, i) {
        var type = name.indexOf('Tangent') !== -1 ? 'vec4' : 'vec3';
        return this.getOrCreateAttribute(type, name + '_' + i);
    },

    morphTangentApproximation: function(inputVertex, outputVertex) {
        var normalizedMorph = this.getOrCreateLocalNormal();
        // kind of tricky, here we retrieve the normalized normal after morphing
        // if there is no rigging we do not recompute it
        if (this._skinningAttribute) {
            normalizedMorph = this.createVariable('vec3');
            this.getNode('Normalize')
                .inputs({
                    vec: this.getOrCreateMorphNormal()
                })
                .outputs({
                    result: normalizedMorph
                });
        }

        this.getNode('InlineCode')
            .code('%out = %tangent.rgb - dot(%tangent.rgb, %normal) * %normal;')
            .inputs({
                tangent: inputVertex,
                normal: normalizedMorph
            })
            .outputs({
                out: outputVertex
            });

        return outputVertex;
    },

    morphTransformVec3: function(inputVertex, outputVertex) {
        var inputs = {
            vertex: inputVertex,
            weights: this.getOrCreateUniform('vec4', 'uTargetWeights')
        };

        var numTargets = this._morphAttribute.getNumTargets();
        for (var i = 0; i < numTargets; i++) {
            inputs['target' + i] = this.getTarget(inputVertex.getVariable(), i);
        }

        this.getNode('Morphing')
            .inputs(inputs)
            .outputs({
                result: outputVertex
            });

        return outputVertex;
    },

    skinTransformVertex: function(inputVertex, outputVertex) {
        this.getNode('MatrixMultPosition')
            .setInverse(true)
            .inputs({
                matrix: this.getOrCreateBoneMatrix(),
                vec: inputVertex
            })
            .outputs({
                vec: outputVertex
            });
        return outputVertex;
    },

    skinTransformNormal: function(inputVertex, outputVertex) {
        this.getNode('MatrixMultDirection')
            .setInverse(true)
            .inputs({
                matrix: this.getOrCreateBoneMatrix(),
                vec: inputVertex
            })
            .outputs({
                vec: outputVertex
            });
        return outputVertex;
    },

    getOrCreateMorphVertex: function() {
        var vecOut = this.getVariable('morphVertex');
        if (vecOut) return vecOut;

        var inputVertex = this.getOrCreateAttribute('vec3', 'Vertex');
        if (!this._morphAttribute || !this._morphAttribute.hasTarget('Vertex')) return inputVertex;

        return this.morphTransformVec3(inputVertex, this.createVariable('vec3', 'morphVertex'));
    },

    getOrCreateMorphNormal: function() {
        var vecOut = this.getVariable('morphNormal');
        if (vecOut) return vecOut;

        var inputNormal = this.getOrCreateAttribute('vec3', 'Normal');
        if (!this._morphAttribute || !this._morphAttribute.hasTarget('Normal')) return inputNormal;

        return this.morphTransformVec3(inputNormal, this.createVariable('vec3', 'morphNormal'));
    },

    getOrCreateMorphTangent: function() {
        var vecOut = this.getVariable('morphTangent');
        if (vecOut) return vecOut;

        var inputTangent = this.getOrCreateAttribute('vec4', 'Tangent');
        var hasMorphTangent = this._morphAttribute && this._morphAttribute.hasTarget('Tangent');

        if (!hasMorphTangent) return inputTangent;

        return this.morphTransformVec3(inputTangent, this.createVariable('vec3', 'morphTangent'));

        // if ( !hasMorphTangent && !this._morphAttribute && !this._morphAttribute.hasTarget( 'Normal' ) ) return inputTangent;

        // if ( hasMorphTangent ) return this.morphTransformVec3( inputTangent, this.createVariable( 'vec3', 'morphTangent' ) );

        // // Approximate tangent morphing depending of the normal morphing (disabled as we are not sure it's worth it for now)
        // return this.morphTangentApproximation( inputTangent, this.createVariable( 'vec3', 'morphTangent' ) );
    },

    getOrCreateSkinVertex: function() {
        var vecOut = this.getVariable('skinVertex');
        if (vecOut) return vecOut;

        var inputVertex = this.getOrCreateMorphVertex();
        if (!this._skinningAttribute) return inputVertex;

        return this.skinTransformVertex(inputVertex, this.createVariable('vec3', 'skinVertex'));
    },

    getOrCreateSkinNormal: function() {
        var vecOut = this.getVariable('skinNormal');
        if (vecOut) return vecOut;

        var inputNormal = this.getOrCreateMorphNormal();
        if (!this._skinningAttribute) return inputNormal;

        return this.skinTransformNormal(inputNormal, this.createVariable('vec3', 'skinNormal'));
    },

    getOrCreateSkinTangent: function() {
        var vecOut = this.getVariable('skinTangent');
        if (vecOut) return vecOut;

        var inputTangent = this.getOrCreateMorphTangent();
        if (!this._skinningAttribute) return inputTangent;

        return this.skinTransformNormal(inputTangent, this.createVariable('vec3', 'skinTangent'));
    },

    getOrCreateLocalVertex: function() {
        return this.getOrCreateSkinVertex();
    },

    getOrCreateLocalNormal: function() {
        var vecOut = this.getVariable('localNormal');
        if (vecOut) return vecOut;

        var normal = this.getOrCreateSkinNormal();
        if (normal === this.getOrCreateAttribute('vec3', 'Normal')) return normal;

        vecOut = this.createVariable('vec3', 'localNormal');
        this.getNode('Normalize')
            .inputs({
                vec: normal
            })
            .outputs({
                result: vecOut
            });

        return vecOut;
    },

    getOrCreateLocalTangent: function() {
        var vecOut = this.getVariable('localTangent');
        if (vecOut) return vecOut;

        var inputTangent = this.getOrCreateAttribute('vec4', 'Tangent');
        var tangent = this.getOrCreateSkinTangent();
        if (tangent === inputTangent) return tangent;

        return this.normalizeAndSetAlpha(
            tangent,
            inputTangent,
            this.createVariable('vec4', 'localTangent')
        );
    },

    normalizeAndSetAlpha: function(tang3, tang4, vecOut) {
        var tangNormalized = this.createVariable('vec3');
        this.getNode('Normalize')
            .inputs({
                vec: tang3
            })
            .outputs({
                result: tangNormalized
            });

        this.getNode('SetAlpha')
            .inputs({
                color: tangNormalized,
                alpha: tang4
            })
            .outputs({
                result: vecOut
            });

        return vecOut;
    }
};

var wrapperVertexOnly = function(fn, name) {
    return function() {
        if (this._fragmentShaderMode) {
            this.logError('This function should not be called from fragment shader : ' + name);
        }
        return fn.apply(this, arguments);
    };
};

for (var fnName in CompilerVertex) {
    CompilerVertex[fnName] = wrapperVertexOnly(CompilerVertex[fnName], fnName);
}

/* harmony default export */ __webpack_exports__["a"] = (CompilerVertex);


/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Light__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_notify__ = __webpack_require__(2);



var CompilerFragment = {
    _createFragmentShader: function() {
        // Call to specialised inhenrited shader Compiler
        var roots = this.createFragmentShaderGraph();
        var fname = this.getFragmentShaderName();
        if (fname) roots.push(this.getNode('Define', 'SHADER_NAME').setValue(fname));

        var shader = this.createShaderFromGraphs(roots);

        __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].debug(this.getDebugIdentifier());
        __WEBPACK_IMPORTED_MODULE_1_osg_notify__["a" /* default */].debug(shader);

        this.cleanAfterFragment();

        return shader;
    },

    applyPointSizeCircle: function(color) {
        if (
            !this._pointSizeAttribute ||
            !this._pointSizeAttribute.isEnabled() ||
            !this._pointSizeAttribute.isCircleShape()
        ) {
            return color;
        }

        this.getNode('InlineCode')
            .code('if (length(2.0 * gl_PointCoord - 1.0) > %radius) discard;')
            .inputs({
                radius: this.getOrCreateConstantOne('float')
            })
            .outputs({
                output: color
            });

        return color;
    },

    cleanAfterFragment: function() {
        // reset for next
        this._variables = {};
        this._activeNodeMap = {};

        // clean texture cache variable (for vertex shader re-usage)
        for (var keyTexture in this._texturesByName) {
            this._texturesByName[keyTexture].variable = undefined;
        }

        for (var keyVarying in this._varyings) {
            var varying = this._varyings[keyVarying];
            varying.reset();
            this._activeNodeMap[varying.getID()] = varying;
            this._variables[keyVarying] = varying;
        }
    },

    createDefaultFragmentShaderGraph: function() {
        var fofd = this.getOrCreateConstant('vec4', 'fofd').setValue('vec4(1.0, 0.0, 1.0, 0.7)');
        var fragCol = this.getNode('glFragColor');
        this.getNode('SetFromNode')
            .inputs(fofd)
            .outputs(fragCol);
        return fragCol;
    },

    createFragmentShaderGraph: function() {
        // shader graph can have multiple output (glPointsize, varyings)
        // here named roots all outputs must be pushed inside
        var roots = [];

        // no material then return a default shader
        if (!this._material) {
            roots.push(this.createDefaultFragmentShaderGraph());
            return roots;
        }

        var finalColor =
            this._lights.length > 0 ? this.getLighting() : this.getOrCreateMaterialDiffuseColor();

        var emission = this.getOrCreateMaterialEmission();
        if (emission) {
            var emit = this.createVariable('vec3');
            this.getNode('Add')
                .inputs(finalColor, emission)
                .outputs(emit);
            finalColor = emit;
        }

        var textureColor = this.getDiffuseColorFromTextures();
        if (textureColor) {
            var texColor = this.createVariable('vec3');
            this.getNode('Mult')
                .inputs(finalColor, textureColor)
                .outputs(texColor);
            finalColor = texColor;
        }

        var alpha = this.getAlpha();

        // premult alpha
        finalColor = this.getPremultAlpha(finalColor, alpha);

        var fragColor = this.getNode('glFragColor');

        this.applyPointSizeCircle(fragColor);

        // todo add gamma corrected color, but it would also mean to handle correctly srgb texture
        // so it should be done at the same time. see osg.Tetxure to implement srgb
        this.getNode('SetAlpha')
            .inputs({
                color: finalColor,
                alpha: alpha
            })
            .outputs({
                result: fragColor
            });

        roots.push(fragColor);

        return roots;
    },

    getAlpha: function() {
        // compute alpha
        var alpha = this.createVariable('float');
        var textureTexel = this.getFirstValidTexture();

        var inputs = {
            color: this.getOrCreateMaterialDiffuseColor()
        };
        if (textureTexel) inputs.texelAlpha = textureTexel;

        var str = textureTexel ? '%alpha = %color.a * %texelAlpha.a;' : '%alpha = %color.a;';

        // Discard fragments totally transparents when rendering billboards
        if (this._isBillboard) {
            str += 'if ( %alpha == 0.0) discard;';
        }

        this.getNode('InlineCode')
            .code(str)
            .inputs(inputs)
            .outputs({
                alpha: alpha
            });

        return alpha;
    },

    getOrCreateFrontViewTangent: function() {
        var out = this._variables.frontViewTangent;
        if (out) return out;
        out = this.createVariable('vec4', 'frontViewTangent');

        this.getNode('FrontNormal')
            .inputs({ normal: this.getOrCreateViewTangent() })
            .outputs({ result: out });

        return out;
    },

    getOrCreateFrontViewNormal: function() {
        var out = this._variables.frontViewNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'frontViewNormal');

        this.getNode('FrontNormal')
            .inputs({ normal: this.getOrCreateViewNormal() })
            .outputs({ result: out });

        return out;
    },

    getOrCreateNormalizedViewEyeDirection: function() {
        var out = this._variables.eyeVector;
        if (out) return out;
        out = this.createVariable('vec3', 'eyeVector');

        this.getNode('SetFromNode')
            .inputs(this.getOrCreateViewVertex())
            .outputs(out);

        this.getNode('Normalize')
            .inputs({ vec: out })
            .outputs({ result: out });

        this.getNode('Mult')
            .inputs(out, this.createVariable('float').setValue('-1.0'))
            .outputs(out);

        return out;
    },

    getOrCreateNormalizedFrontViewNormal: function() {
        var out = this._variables.nFrontViewNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'nFrontViewNormal');

        this.getNode('Normalize')
            .inputs({ vec: this.getOrCreateFrontViewNormal() })
            .outputs({ result: out });

        return out;
    },

    getOrCreateFrontModelNormal: function() {
        var out = this._variables.frontModelNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'frontModelNormal');

        this.getNode('FrontNormal')
            .inputs({ normal: this.getOrCreateModelNormal() })
            .outputs({ result: out });

        return out;
    },

    getOrCreateNormalizedFrontModelNormal: function() {
        var out = this._variables.nFrontModelNormal;
        if (out) return out;
        out = this.createVariable('vec3', 'nFrontModelNormal');

        this.getNode('Normalize')
            .inputs({ vec: this.getOrCreateFrontModelNormal() })
            .outputs({ result: out });

        return out;
    },

    getPremultAlpha: function(finalColor, alpha) {
        if (alpha === undefined) return finalColor;

        var premultAlpha = this.createVariable('vec4');

        this.getNode('PreMultAlpha')
            .inputs({ color: finalColor, alpha: alpha })
            .outputs({ result: premultAlpha });

        return premultAlpha;
    },

    getColorsRGB: function(finalColor) {
        var finalSrgbColor = this.createVariable('vec3');
        this.getNode('LinearTosRGB')
            .inputs({ color: finalColor })
            .outputs({ color: finalSrgbColor });

        return finalSrgbColor;
    },

    multiplyDiffuseWithVertexColor: function(diffuseColor) {
        var vertexColor = this.getOrCreateVarying('vec4', 'vVertexColor');
        var vertexColorUniform = this.getOrCreateUniform('float', 'uArrayColorEnabled');
        var tmp = this.createVariable('vec4');

        var str = [
            '',
            '%color = %diffuse;',
            'if ( %hasVertexColor == 1.0)',
            '  %color *= %vertexColor;'
        ].join('\n');

        this.getNode('InlineCode')
            .code(str)
            .inputs({
                diffuse: diffuseColor,
                hasVertexColor: vertexColorUniform,
                vertexColor: vertexColor
            })
            .outputs({ color: tmp })
            .comment('diffuse color = diffuse color * vertex color');

        return tmp;
    },

    getDiffuseColorFromTextures: function() {
        var texturesInput = [];
        var textures = this._texturesByName;

        for (var keyTexture in textures) {
            var texture = textures[keyTexture];

            if (texture.shadow) continue;

            texturesInput.push(this.getTextureByName(keyTexture).variable);
        }

        // if multi texture multiply them all with diffuse
        // but if only one, return the first
        if (texturesInput.length > 1) {
            var texAccum = this.createVariable('vec3', 'texDiffuseAccum');

            this.getNode('Mult')
                .inputs(texturesInput)
                .outputs(texAccum);
            return texAccum;
        } else if (texturesInput.length === 1) {
            return texturesInput[0];
        }

        return undefined;
    },

    getFirstValidTexture: function() {
        var textures = this._textures;
        for (var i = 0, nb = textures.length; i < nb; ++i) {
            var tex = textures[i];
            if (tex) return this.getTextureByName(tex.getName()).variable;
        }
        return undefined;
    },

    _getShadowReceiveAttributeFromLightNum: function(array, lightNum) {
        // array is shadow textures or shadow receive attributes
        for (var i = 0; i < array.length; i++) {
            var shadow = array[i];
            if (shadow && shadow.getLightNumber() === lightNum) {
                return shadow;
            }
        }
    },

    _getShadowTextureFromLightNum: function(array, lightNum) {
        // array is shadow textures or shadow receive attributes
        for (var i = 0; i < array.length; i++) {
            var shadow = array[i];
            if (shadow && shadow.hasLightNumber(lightNum)) {
                return shadow;
            }
        }
    },

    getInputsFromShadow: function(shadowReceive, shadowTexture, lighted, lightNum) {
        var shadowUniforms = shadowReceive.getOrCreateUniforms();
        var tUnit = this._shadowsTextures.indexOf(shadowTexture);
        var textureUniforms = shadowTexture.getOrCreateUniforms(tUnit);

        var suffix = shadowReceive.getAtlas() ? '_' + lightNum : '';
        var inputs = {
            lighted: lighted,
            normalWorld: this.getOrCreateNormalizedFrontModelNormal(),
            vertexWorld: this.getOrCreateModelVertex(),
            shadowTexture: this.getOrCreateSampler('sampler2D', 'Texture' + tUnit),
            shadowSize: this.getOrCreateUniform(textureUniforms['RenderSize']),
            shadowProjection: this.getOrCreateUniform(textureUniforms['Projection' + suffix]),

            shadowViewRight: this.getOrCreateUniform(textureUniforms['ViewRight' + suffix]),
            shadowViewUp: this.getOrCreateUniform(textureUniforms['ViewUp' + suffix]),
            shadowViewLook: this.getOrCreateUniform(textureUniforms['ViewLook' + suffix]),

            shadowDepthRange: this.getOrCreateUniform(textureUniforms['DepthRange' + suffix]),
            shadowBias: this.getOrCreateUniform(shadowUniforms.bias)
        };

        if (shadowReceive.getAtlas())
            inputs.atlasSize = this.getOrCreateUniform(textureUniforms['MapSize' + suffix]);
        if (shadowReceive.getNormalBias())
            inputs.normalBias = this.getOrCreateUniform(shadowUniforms.normalBias);

        return inputs;
    },

    getOrCreateDistanceShadow: function(num) {
        if (!this._computeShadowOutDistance) return undefined;

        var varName = 'shadowDistance' + num;
        var distance = this.getVariable(varName);
        if (!distance) distance = this.createVariable('float', varName).setValue('0.0');
        return distance;
    },

    getOrCreateJitterShadow: function() {
        return false;
    },

    hasLightShadow: function(lightNum) {
        var shadowTexture = this._getShadowTextureFromLightNum(this._shadowsTextures, lightNum);
        var shadowReceive = this._getShadowReceiveAttributeFromLightNum(this._shadows, lightNum);
        return !!shadowTexture && !!shadowReceive;
    },

    createShadowingLight: function(light, lighted) {
        var lightNum = light.getLightNumber();
        var shadowTexture = this._getShadowTextureFromLightNum(this._shadowsTextures, lightNum);
        var shadowReceive = this._getShadowReceiveAttributeFromLightNum(this._shadows, lightNum);
        if (!shadowTexture || !shadowReceive) return undefined;

        var inputs = this.getInputsFromShadow(shadowReceive, shadowTexture, lighted, lightNum);

        var shadowedOutput = this.createVariable('float');
        var outputs = {
            result: shadowedOutput
        };

        var defines = shadowReceive.getDefines();

        var outDistance = this.getOrCreateDistanceShadow(lightNum);
        if (outDistance) {
            outputs.outDistance = outDistance;
            defines.push('#define _OUT_DISTANCE');
        }

        var doJitter = this.getOrCreateJitterShadow(lightNum);
        if (doJitter) {
            inputs.jitter = doJitter;
        }

        this.getNode('ShadowReceive')
            .inputs(inputs)
            .outputs(outputs)
            .addDefines(defines);

        return shadowedOutput;
    },

    getOrCreateMaterialNormal: function() {
        return this.getOrCreateNormalizedFrontViewNormal();
    },

    getOrCreateMaterialDiffuseColor: function() {
        var matDiffuse = this.getVariable('materialDiffuseColor');
        if (matDiffuse) return matDiffuse;
        matDiffuse = this.createVariable('vec4', 'materialDiffuseColor');

        var diffuse = this.getOrCreateUniform(this._material.getOrCreateUniforms().diffuse);
        this.getNode('Mult')
            .inputs(this.multiplyDiffuseWithVertexColor(diffuse))
            .outputs(matDiffuse);

        return matDiffuse;
    },

    getOrCreateMaterialEmission: function() {
        return this.getOrCreateUniform(this._material.getOrCreateUniforms().emission);
    },

    getOrCreateMaterialSpecularColor: function() {
        return this.getOrCreateUniform(this._material.getOrCreateUniforms().specular);
    },

    getOrCreateMaterialSpecularHardness: function() {
        return this.getOrCreateUniform(this._material.getOrCreateUniforms().shininess);
    },

    getOrCreateMaterialAmbient: function() {
        return this.getOrCreateUniform(this._material.getOrCreateUniforms().ambient);
    },

    getLighting: function() {
        if (this._lights.length === 0) return undefined;

        var res = this.getLightingSeparate();
        var output = this.createVariable('vec3');
        this.getNode('Add')
            .inputs(res.diffuse, res.specular)
            .outputs(output);

        return output;
    },

    getLightingSeparate: function() {
        if (this._lights.length === 0) return undefined;

        // return contribution of diffuse and specular lights
        var diffuseSum = [];
        var specularSum = [];

        for (var i = 0; i < this._lights.length; i++) {
            var light = this._lights[i];
            var outputs = this.getLightSeparate(light);
            diffuseSum.push(outputs.diffuseOut);
            specularSum.push(outputs.specularOut);
        }

        var finalDiffuse;
        var finalSpecular;
        if (this._lights.length === 1) {
            finalDiffuse = diffuseSum[0];
            finalSpecular = specularSum[0];
        } else {
            finalDiffuse = this.createVariable('vec3');
            this.getNode('Add')
                .inputs(diffuseSum)
                .outputs(finalDiffuse);

            finalSpecular = this.createVariable('vec3');
            this.getNode('Add')
                .inputs(specularSum)
                .outputs(finalSpecular);
        }

        return {
            diffuse: finalDiffuse,
            specular: finalSpecular
        };
    },

    getLightSeparate: function(light) {
        var precompute = this.getPrecomputeLight(light);
        var outputs = this.getLightWithPrecompute(light, precompute);

        var shadowFactor = this.createShadowingLight(light, outputs.lighted);
        if (shadowFactor) {
            this.getNode('Mult')
                .inputs(outputs.diffuseOut, shadowFactor)
                .outputs(outputs.diffuseOut);
            this.getNode('Mult')
                .inputs(outputs.specularOut, shadowFactor)
                .outputs(outputs.specularOut);
        }

        var ambient = this.getAmbientLight(light);
        if (ambient)
            this.getNode('Add')
                .inputs(outputs.diffuseOut, ambient)
                .outputs(outputs.diffuseOut);

        return {
            diffuseOut: outputs.diffuseOut,
            specularOut: outputs.specularOut,
            // below can be used re-used if needed (sss, etc...)
            lighted: outputs.lighted,
            attenuation: precompute.attenuation,
            eyeLightDir: precompute.eyeLightDir,
            dotNL: precompute.dotNL
        };
    },

    getPrecomputeLight: function(light) {
        var lightUniforms = light.getOrCreateUniforms();

        var outputs = {
            attenuation: this.createVariable('float'),
            eyeLightDir: this.createVariable('vec3'),
            dotNL: this.createVariable('float')
        };

        var inputs = {
            normal: this.getOrCreateMaterialNormal()
        };

        var nodeName;

        var lightType = light.getLightType();
        if (lightType === __WEBPACK_IMPORTED_MODULE_0_osg_Light__["a" /* default */].POINT) {
            nodeName = 'PrecomputePoint';

            inputs.viewVertex = this.getOrCreateViewVertex();
            inputs.lightAttenuation = this.getOrCreateUniform(lightUniforms.attenuation);
            inputs.lightViewPosition = this.getOrCreateUniform(lightUniforms.viewPosition);
        } else if (lightType === __WEBPACK_IMPORTED_MODULE_0_osg_Light__["a" /* default */].SPOT) {
            nodeName = 'PrecomputeSpot';

            inputs.viewVertex = this.getOrCreateViewVertex();
            inputs.lightViewDirection = this.getOrCreateUniform(lightUniforms.viewDirection);
            inputs.lightAttenuation = this.getOrCreateUniform(lightUniforms.attenuation);
            inputs.lightSpotCutOff = this.getOrCreateUniform(lightUniforms.spotCutOff);
            inputs.lightSpotBlend = this.getOrCreateUniform(lightUniforms.spotBlend);
            inputs.lightViewPosition = this.getOrCreateUniform(lightUniforms.viewPosition);
        } else {
            nodeName = 'PrecomputeSun';
            inputs.lightViewDirection = this.getOrCreateUniform(lightUniforms.viewDirection);
        }

        this.getNode(nodeName)
            .inputs(inputs)
            .outputs(outputs);
        return outputs;
    },

    getLightWithPrecompute: function(light, precompute) {
        var lightUniforms = light.getOrCreateUniforms();

        var inputs = {
            normal: this.getOrCreateMaterialNormal(),
            eyeVector: this.getOrCreateNormalizedViewEyeDirection(),
            dotNL: precompute.dotNL,
            attenuation: precompute.attenuation,

            materialDiffuse: this.getOrCreateMaterialDiffuseColor(),
            materialSpecular: this.getOrCreateMaterialSpecularColor(),
            materialShininess: this.getOrCreateMaterialSpecularHardness(),

            lightDiffuse: this.getOrCreateUniform(lightUniforms.diffuse),
            lightSpecular: this.getOrCreateUniform(lightUniforms.specular),
            eyeLightDir: precompute.eyeLightDir
        };

        var nodeName = 'ComputeLightLambertCookTorrance';
        if (light.getLightType() === __WEBPACK_IMPORTED_MODULE_0_osg_Light__["a" /* default */].HEMI) {
            inputs.lightGround = this.getOrCreateUniform(lightUniforms.ground);
            nodeName = 'HemiLight';
        }

        var outputs = this.getOutputsFromLight();
        this.getNode(nodeName)
            .inputs(inputs)
            .outputs(outputs);

        return outputs;
    },

    getAmbientLight: function(light) {
        var ambient = this.createVariable('vec3');
        var lightAmbient = this.getOrCreateUniform(light.getOrCreateUniforms().ambient);
        var materialAmbient = this.getOrCreateMaterialAmbient();
        this.getNode('Mult')
            .inputs(materialAmbient, lightAmbient)
            .outputs(ambient);
        return ambient;
    },

    getOutputsFromLight: function() {
        var outputs = {
            diffuseOut: this.createVariable('vec3'),
            specularOut: this.createVariable('vec3'),
            lighted: this.createVariable('bool')
        };

        // the light glsl function always output this boolean
        // even if no shadowmaping (so the variable ends up unused)
        outputs.lighted.silenceWarning = true;

        return outputs;
    },

    createTextureRGBA: function(texture, textureSampler, texCoord) {
        // but we could later implement srgb inside and read differents flag
        // as read only in the texture

        var texel = this.createVariable('vec4');
        this.getNode('TextureRGBA')
            .inputs({ tex: textureSampler, uv: texCoord })
            .outputs({ result: texel });

        return texel;
    }
};

var wrapperFragmentOnly = function(fn, name) {
    return function() {
        if (!this._fragmentShaderMode) {
            this.logError('This function should not be called from vertex shader : ' + name);
        }
        return fn.apply(this, arguments);
    };
};

for (var fnName in CompilerFragment) {
    CompilerFragment[fnName] = wrapperFragmentOnly(CompilerFragment[fnName], fnName);
}

/* harmony default export */ __webpack_exports__["a"] = (CompilerFragment);


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgUtil_DisplayGraphNode__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_RenderBin__ = __webpack_require__(60);



var DisplayGraphRenderer = function(selectables) {
    this._selectables = selectables;
    this._nodeList = [];
    this._linkList = [];

    this._renderBinMap = new window.Map();
    this._renderBinStack = [];

    this._generatorID = 0;
    this._refID = 0; // invalide old _instanceID if we recreate the graph

    this._uniqueEdges = new window.Set();
};

DisplayGraphRenderer.prototype = {
    getColorFromClassName: __WEBPACK_IMPORTED_MODULE_0_osgUtil_DisplayGraphNode__["a" /* default */].prototype.getColorFromClassName,

    createGraph: function(renderBin) {
        this.reset();
        this.apply(renderBin);
    },

    reset: function() {
        this._renderBinMap.clear();
        this._renderBinStack.length = 0;
        this._generatorID = 0;
        this._refID++;

        this._nodeList.length = 0;
        this._linkList.length = 0;

        this._uniqueEdges.clear();
    },

    apply: function(rb) {
        var instanceID = rb.getInstanceID();
        if (!this._renderBinMap.has(instanceID)) {
            this._renderBinMap.set(instanceID, rb);
        }

        this._renderBinStack.push(rb);

        // pre render stage if render stage node
        if (rb.getPreRenderStageList) {
            var preRenderList = rb.getPreRenderStageList();
            for (var i = 0, ni = preRenderList.length; i < ni; ++i) {
                this.apply(preRenderList[i].renderStage);
            }
        }

        // draw implementation
        // handle rs camera
        this.registerNode(rb);

        // post render stage if render stage node
        if (rb.getPostRenderStageList) {
            var postRenderList = rb.getPostRenderStageList();
            for (var j = 0, nj = postRenderList.length; j < nj; ++j) {
                this.apply(postRenderList[j].renderStage);
            }
        }

        this._renderBinStack.pop();
    },

    registerNode: function(rb) {
        var childID = rb.getInstanceID();

        this._nodeList.push(rb);

        // register bins
        var bins = rb._bins;
        bins.forEach(
            function(key, bin) {
                this.apply(bin);
            }.bind(this)
        );

        // register fine grained leafs
        if (rb._leafs.length) {
            for (var j = 0, nj = rb._leafs.length; j < nj; j++) {
                this.createNodeAndSetID(childID, rb._leafs[j]);
            }
        }

        var self = this;
        var context = {};

        var leafFunction = function(leaf) {
            self.createNodeAndSetID(this.stateGraphID, leaf);
        }.bind(context);

        var stateGraphFunction = function(sg) {
            self.createNodeAndSetID(childID, sg);
            var stateGraphID = sg._instanceID;
            var leafsPool = sg.getLeafs();
            context.stateGraphID = stateGraphID;
            leafsPool.forEach(leafFunction);
        };
        // register coarse grained leafs
        var stateGraphList = rb.getStateGraphList();
        stateGraphList.forEach(stateGraphFunction);

        // no parent no link
        if (this._renderBinStack.length < 2) return;

        var parentID = this._renderBinStack[this._renderBinStack.length - 2].getInstanceID();
        this.createLink(parentID, childID);
    },

    createLink: function(parent, child) {
        var key = parent + '+' + child;
        if (!this._uniqueEdges.has(key)) {
            this._linkList.push({
                parentNode: parent,
                childrenNode: child
            });
            this._uniqueEdges.add(key);
        }
    },

    createNodeAndSetID: function(parentID, node) {
        // register render leaf
        this._nodeList.push(node);

        // generate fake id < 0 because RenderLeaf does not inherit from Object
        if (
            node._instanceID === undefined ||
            (node._instanceID < 0 && node._refID !== this._refID)
        ) {
            node._instanceID = -1 - this._generatorID++;
            node._refID = this._refID;
        }

        this.createLink(parentID, node._instanceID);
    },

    generateRenderLeaf: function(g, node) {
        var instanceID = node._instanceID;
        var className = 'RenderLeaf';
        var geomName =
            node._geometry && node._geometry.getName()
                ? '\n' + node._geometry.getName()
                : 'Geometry';

        var label = className + ' ( ' + node._instanceID + ' )';
        label += '\n' + geomName + ' ( ' + node._geometry.getInstanceID() + ' )';

        this._selectables.set(instanceID.toString(), node);
        g.addNode(instanceID, {
            label: label,
            description: '',
            style: 'fill: ' + this.getColorFromClassName(className) + ';stroke-width: 0px;'
        });
    },

    generateStateGraph: function(g, node) {
        var instanceID = node._instanceID;
        var className = 'StateGraph';
        var label = className + ' ( ' + node._instanceID + ' )';
        label += '\n' + node._leafs._length + ' leafs';

        this._selectables.set(instanceID.toString(), node);
        g.addNode(instanceID, {
            label: label,
            description: '',
            style: 'fill: ' + this.getColorFromClassName(className) + ';stroke-width: 0px;'
        });
    },

    generateRenderStage: function(g, node) {
        var label = node.className() + ' ( ' + node._instanceID + ' )';
        if (node.getName()) label += '\n' + node.getName();
        label +=
            '\nViewport ( ' +
            node.getViewport().width() +
            ' x ' +
            node.getViewport().height() +
            ' )';

        this._selectables.set(node.getInstanceID().toString(), node);
        g.addNode(node.getInstanceID(), {
            label: label,
            description: '',
            style: 'fill: ' + this.getColorFromClassName(node.className()) + ';stroke-width: 0px;'
        });
    },

    generateRenderBin: function(g, rb) {
        var label = rb.className() + ' ( ' + rb.getInstanceID() + ' )';
        if (rb.getName()) label += '\n' + rb.getName();

        var sortMode = '';
        if (rb.getSortMode() === __WEBPACK_IMPORTED_MODULE_1_osg_RenderBin__["a" /* default */].SORT_BACK_TO_FRONT) sortMode = 'SortMode: BackToFront';

        var description = 'BinNumber: ' + rb.getBinNumber() + '\n' + sortMode;

        this._selectables.set(rb.getInstanceID().toString(), rb);
        g.addNode(rb.getInstanceID(), {
            label: label,
            description: description,
            style: 'fill: ' + this.getColorFromClassName(rb.className()) + ';stroke-width: 0px;'
        });
    },

    // Subfunction of createGraph, will iterate to create all the node and link in dagre
    generateNodeAndLink: function(g) {
        for (var i = 0, ni = this._nodeList.length; i < ni; i++) {
            var node = this._nodeList[i];

            // detect if RenderLeaf
            if (node._geometry && node._depth !== undefined) {
                this.generateRenderLeaf(g, node);
            } else if (node.className() === 'StateGraph') {
                this.generateStateGraph(g, node);
            } else if (node.className() === 'RenderStage') {
                this.generateRenderStage(g, node);
            } else {
                // it's a RenderBin
                this.generateRenderBin(g, node);
            }
        }

        for (var j = 0, nj = this._linkList.length; j < nj; j++) {
            g.addEdge(null, this._linkList[j].parentNode, this._linkList[j].childrenNode);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DisplayGraphRenderer);


/***/ }),
/* 234 */
/***/ (function(module, exports) {

if(typeof __WEBPACK_EXTERNAL_MODULE_234__ === 'undefined') {var e = new Error("Cannot find module \"undefined\""); e.code = 'MODULE_NOT_FOUND'; throw e;}
module.exports = __WEBPACK_EXTERNAL_MODULE_234__;

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Depth__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_CullFace__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgUtil_IntersectionVisitor__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgUtil_LineSegmentIntersector__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_utils__ = __webpack_require__(1);














var getCanvasCoord = function(vec, e) {
    if (('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints) && window.navigator.userAgent.indexOf('Edge') === -1 && e.type.includes('touch')) {
        var offset = e.target.getBoundingClientRect();
        vec[0] = e.changedTouches[ 0 ].clientX - offset.left;
        vec[1] = e.changedTouches[ 0 ].clientY;
    } else {
        vec[0] = e.offsetX === undefined ? e.layerX : e.offsetX;
        vec[1] = e.offsetY === undefined ? e.layerY : e.offsetY;
    }
};

var HideCullCallback = function() {};
HideCullCallback.prototype = {
    cull: function() {
        return false;
    }
};

var blendAttribute = new __WEBPACK_IMPORTED_MODULE_4_osg_BlendFunc__["a" /* default */](__WEBPACK_IMPORTED_MODULE_4_osg_BlendFunc__["a" /* default */].SRC_ALPHA, __WEBPACK_IMPORTED_MODULE_4_osg_BlendFunc__["a" /* default */].ONE_MINUS_SRC_ALPHA);

var LineCustomIntersector = function(testPlane) {
    this._testPlane = testPlane; // intersection plane or line
    this._inter = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create(); // translate distance
    __WEBPACK_IMPORTED_MODULE_9_osgUtil_LineSegmentIntersector__["a" /* default */].call(this);
};
__WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].createPrototypeObject(
    LineCustomIntersector,
    __WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_9_osgUtil_LineSegmentIntersector__["a" /* default */].prototype, {
        setTestPlane: function(testPlane) {
            this._testPlane = testPlane; // intersection plane or line
        },
        getTranslateDistance: function() {
            return this._inter;
        },
        enter: (function() {
            var axis = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
            var dir = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            return function(node) {
                if (node._nbAxis === undefined) return true;

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].init(axis);
                axis[node._nbAxis] = 1.0;
                if (!this._testPlane) {
                    // intersection line line
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].normalize(dir, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].sub(dir, this._iEnd, this._iStart));

                    var a01 = -__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].dot(dir, axis);
                    var b0 = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].dot(this._iStart, dir);
                    var det = Math.abs(1.0 - a01 * a01);

                    var b1 = -__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].dot(this._iStart, axis);
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].init(this._inter);
                    this._inter[node._nbAxis] = (a01 * b0 - b1) / det;
                } else {
                    // intersection line plane
                    var dist1 = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].dot(this._iStart, axis);
                    var dist2 = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].dot(this._iEnd, axis);
                    // ray copplanar to triangle
                    if (dist1 === dist2) return false;
                    // intersection between ray and triangle
                    var val = -dist1 / (dist2 - dist1);
                    this._inter[0] = this._iStart[0] + (this._iEnd[0] - this._iStart[0]) * val;
                    this._inter[1] = this._iStart[1] + (this._iEnd[1] - this._iStart[1]) * val;
                    this._inter[2] = this._iStart[2] + (this._iEnd[2] - this._iStart[2]) * val;
                }
                return false;
            };
        })(),
        intersectTriangle: function() {},
        intersectLine: function() {},
        intersectPoint: function() {}
    }),
    'osgUtil',
    'LineCustomIntersector'
);

// for getWorldMatrix
var _TMP_MAT = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();

// The MT node can be detected as such because they
// have a '_nbAxis' property on them (x=0, y=1, z=2)
//
// MatrixTransform _________________________________________
//           |                    |                         |
//    ____ Rotate             Translate               TranslatePlane
//   |     / | \                / | \                     / | \
//   MT   MT MT MT             MT MT MT                  MT MT MT
//   |     \ | /                \ | /                     \ | /
// FullArc  \|/                  \|/                       \|/
//       ____|_____            ___|________              ___|________
//      |          |          |            |            |            |
//   DrawArc   HideNode   DrawArrow    HideNode     DrawPlane    HideNode
//                 |                       |                         |
//              PickArc                PickArrow                  PickPlane
//
var NodeGizmo = function(viewer) {
    __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */].call(this);

    this._tmask = 1; // traversal mask when picking the scene

    // When attaching the gizmo on a node, there's 2 ways:
    // - if _autoInsertMT is true and no direct parent has an editMask
    //   we insert a matrixTransform that we are going to edit
    // - otherwise we look for the nearest MatrixTransform with an editMask on the graph
    this._autoInsertMT = false;

    this._viewer = viewer;
    this._canvas = viewer.getGraphicContext().canvas;
    this._manipulator = viewer.getManipulator();

    this._rotateNode = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
    this._translateNode = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
    this._planeNode = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();

    this._rotateInLocal = true; // local vs world space
    this._translateInLocal = true; // local vs world space
    this._showAngle = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();

    //for realtime picking
    this._downCanvasCoord = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();
    this._hoverNode = null; // the hovered x/y/z MT node
    this._keepHoverColor = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].create();

    // for editing
    this._isEditing = false;

    this._editLineOrigin = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
    this._editLineDirection = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
    this._editOffset = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

    // cached matrices when starting the editing operations
    this._editLocal = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();
    this._editWorldTrans = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();
    this._editWorldScaleRot = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();
    this._editInvWorldScaleRot = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();

    // red line, it can be useful as helpers too
    this._debugNode = new __WEBPACK_IMPORTED_MODULE_0_osg_Node__["a" /* default */]();

    this._lastDistToEye = 0.0; // see updateGizmo comment

    this._attachedNode = null;
    this._pivotOffset = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create(); // to center the gizmo and rotation pivot when inserting MT
    this.attachToNode(null);

    // Intersectors
    this._lsi = new LineCustomIntersector();
    this._origIntersect = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
    this._dstIntersect = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
    this._iv = new __WEBPACK_IMPORTED_MODULE_8_osgUtil_IntersectionVisitor__["a" /* default */]();
    this._iv.setIntersector(this._lsi);

    this._pixelsMargin = 0.0;
    if ('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints)
        this._pixelsMargin = 5.0;

    this._disabledRightMiddleButtons = false;
    this.init();
};

// picking masks
NodeGizmo.NO_PICK = 1 << 0;

NodeGizmo.PICK_ARC_X = 1 << 1;
NodeGizmo.PICK_ARC_Y = 1 << 2;
NodeGizmo.PICK_ARC_Z = 1 << 3;

NodeGizmo.PICK_ARROW_X = 1 << 4;
NodeGizmo.PICK_ARROW_Y = 1 << 5;
NodeGizmo.PICK_ARROW_Z = 1 << 6;

NodeGizmo.PICK_PLANE_X = 1 << 7;
NodeGizmo.PICK_PLANE_Y = 1 << 8;
NodeGizmo.PICK_PLANE_Z = 1 << 9;

NodeGizmo.NO_FULL_CIRCLE = 1 << 10; // don't display the full non pickable circle (visual cue)

NodeGizmo.PICK_ARC = NodeGizmo.PICK_ARC_X | NodeGizmo.PICK_ARC_Y | NodeGizmo.PICK_ARC_Z;
NodeGizmo.PICK_ARROW = NodeGizmo.PICK_ARROW_X | NodeGizmo.PICK_ARROW_Y | NodeGizmo.PICK_ARROW_Z;
NodeGizmo.PICK_PLANE = NodeGizmo.PICK_PLANE_X | NodeGizmo.PICK_PLANE_Y | NodeGizmo.PICK_PLANE_Z;

NodeGizmo.PICK_GIZMO = NodeGizmo.PICK_ARC | NodeGizmo.PICK_ARROW | NodeGizmo.PICK_PLANE;

// retrieve nearest editable node
var GetNearestEditableNode = function() {
    __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].TRAVERSE_PARENTS);
    this._editableNode = null;
};

__WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].createPrototypeObject(
    GetNearestEditableNode,
    __WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype, {
        reset: function() {
            __WEBPACK_IMPORTED_MODULE_1_osg_NodeVisitor__["a" /* default */].prototype.reset.call(this);
            this._editableNode = null;
        },
        getEditableNode: function() {
            return this._editableNode;
        },
        apply: function(node) {
            if (this._editableNode) return;

            var editMask = node.editMask;
            if (editMask && editMask & NodeGizmo.PICK_GIZMO) {
                this._editableNode = node;
                return;
            }

            this.traverse(node);
        }
    })
);

__WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].createPrototypeNode(
    NodeGizmo,
    __WEBPACK_IMPORTED_MODULE_12_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */].prototype, {
        setRotateInLocal: function(bool) {
            this._rotateInLocal = bool;
        },

        setTranslateInLocal: function(bool) {
            this._translateInLocal = bool;
        },

        setTraversalMask: function(tmask) {
            this._tmask = tmask;
        },

        setAutoMatrixTransformInsertion: function(bool) {
            this._autoInsertMT = bool;
        },

        isEditing: function() {
            return this._isEditing;
        },

        init: function() {
            this.getOrCreateStateSet().setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */](__WEBPACK_IMPORTED_MODULE_3_osg_Depth__["a" /* default */].DISABLE));
            this.getOrCreateStateSet().setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_5_osg_CullFace__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_CullFace__["a" /* default */].DISABLE));

            this.addUpdateCallback(this);
            this.addChild(this.initNodeTranslate());
            this.addChild(this.initNodeTranslatePlane());
            this.addChild(this.initNodeRotate());
            if (this._debugNode) {
                this._debugNode.addChild(__WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createDebugLineGeometry());
                this.addChild(this._debugNode);
                this._debugNode.setNodeMask(0x0);
            }

            var canvas = this._canvas;

            // For all browsers except Microsoft Edge Legacy
            if (('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints) && window.navigator.userAgent.indexOf('Edge') === -1) {
                canvas.addEventListener( 'touchmove', this.onMouseMove.bind( this ) );
                canvas.addEventListener( 'touchend', this.onMouseUp.bind( this ) );
                canvas.addEventListener( 'touchcancel', this.onMouseUp.bind( this ) );
                canvas.addEventListener( 'touchstart', this.onMouseDown.bind( this ) );
            }
            // For all browsers (So, we can use the mouse in touchable devices)
                canvas.addEventListener('mousemove', this.onMouseMove.bind(this));
                canvas.addEventListener('mousedown', this.onMouseDown.bind(this));
                canvas.addEventListener('mouseup', this.onMouseUp.bind(this));
                canvas.addEventListener('mouseout', this.onMouseUp.bind(this));
        },

        _insertEditNode: function(parent, node) {
            var mtInsert = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            mtInsert.editMask = NodeGizmo.PICK_GIZMO;
            parent.addChild(mtInsert);
            parent.removeChild(node);
            mtInsert.addChild(node);

            mtInsert._isInserted = true;

            return mtInsert;
        },

        _findEditNodeFromNodePath: function(nodepath) {
            if (!nodepath) return null;

            var node = nodepath[nodepath.length - 1];
            if (node.editMask) return node;

            if (!this._autoInsertMT) {
                for (var i = nodepath.length - 1; i >= 0; --i) {
                    var editMask = nodepath[i].editMask;
                    if (editMask && editMask & NodeGizmo.PICK_GIZMO) return nodepath[i];
                }

                return null;
            }

            var parent = nodepath[nodepath.length - 2];
            // direct parent is already an editable node
            if (parent.editMask) return parent;
            return this._insertEditNode(parent, node);
        },

        _findEditNodeFromNode: function(node) {
            if (!node) return null;
            if (node.editMask) return node;

            if (this._autoInsertMT) {
                var parents = node.getParents();
                // direct parent is already an editable node
                for (var i = 0; i < parents.length; ++i) {
                    var editMask = parents[i].editMask;
                    if (editMask && editMask & NodeGizmo.PICK_GIZMO) return parents[i];
                }

                // we have to choose an arbitrary parent here
                return this._insertEditNode(parents[0], node);
            }

            if (!this._getEditNodeVisitor) {
                this._getEditNodeVisitor = new GetNearestEditableNode();
            } else {
                this._getEditNodeVisitor.reset();
            }

            node.accept(this._getEditNodeVisitor);
            return this._getEditNodeVisitor.getEditableNode();
        },

        attachToNodePath: function(nodepath) {
            var editNode = this._findEditNodeFromNodePath(nodepath);
            this._attachEditNode(editNode, nodepath && nodepath[nodepath.length - 1]);
        },

        attachToNode: function(node) {
            var editNode = this._findEditNodeFromNode(node);
            this._attachEditNode(editNode, node);
        },

        _attachEditNode: function(editNode, userNode) {
            this._attachedNode = editNode;

            if (userNode && userNode !== editNode) {
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].copy(this._pivotOffset, userNode.getBoundingSphere().center());
            }

            this.updateGizmoMask();
        },

        updateGizmoMask: function() {
            if (!this._attachedNode) {
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].init(this._pivotOffset);
                this.setNodeMask(0x0);
                return;
            }

            var mask = this._attachedNode.editMask;

            this.setNodeMask(mask & NodeGizmo.PICK_GIZMO ? NodeGizmo.NO_PICK : 0x0);

            this._translateNode.setNodeMask(
                mask & NodeGizmo.PICK_ARROW ? NodeGizmo.PICK_ARROW : 0x0
            );
            this._rotateNode.setNodeMask(mask & NodeGizmo.PICK_ARC ? NodeGizmo.PICK_ARC : 0x0);
            this._planeNode.setNodeMask(mask & NodeGizmo.PICK_PLANE ? NodeGizmo.PICK_PLANE : 0x0);

            var transChildren = this._translateNode.getChildren();
            transChildren[0].setNodeMask(
                mask & NodeGizmo.PICK_ARROW_X ? NodeGizmo.PICK_ARROW_X : 0x0
            );
            transChildren[1].setNodeMask(
                mask & NodeGizmo.PICK_ARROW_Y ? NodeGizmo.PICK_ARROW_Y : 0x0
            );
            transChildren[2].setNodeMask(
                mask & NodeGizmo.PICK_ARROW_Z ? NodeGizmo.PICK_ARROW_Z : 0x0
            );

            // children 0 is full arc
            var rotChildren = this._rotateNode.getChildren();
            rotChildren[0].setNodeMask(mask & NodeGizmo.NO_FULL_CIRCLE ? 0x0 : NodeGizmo.NO_PICK);
            rotChildren[1].setNodeMask(mask & NodeGizmo.PICK_ARC_X ? NodeGizmo.PICK_ARC_X : 0x0);
            rotChildren[2].setNodeMask(mask & NodeGizmo.PICK_ARC_Y ? NodeGizmo.PICK_ARC_Y : 0x0);
            rotChildren[3].setNodeMask(mask & NodeGizmo.PICK_ARC_Z ? NodeGizmo.PICK_ARC_Z : 0x0);

            var planeChildren = this._planeNode.getChildren();
            planeChildren[0].setNodeMask(
                mask & NodeGizmo.PICK_PLANE_X ? NodeGizmo.PICK_PLANE_X : 0x0
            );
            planeChildren[1].setNodeMask(
                mask & NodeGizmo.PICK_PLANE_Y ? NodeGizmo.PICK_PLANE_Y : 0x0
            );
            planeChildren[2].setNodeMask(
                mask & NodeGizmo.PICK_PLANE_Z ? NodeGizmo.PICK_PLANE_Z : 0x0
            );
        },

        onNodeHovered: (function() {
            var hoverColor = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 1.0, 0.0, 1.0);

            return function(hit) {
                if (this._hoverNode)
                    this._hoverNode
                        .getStateSet()
                        .getUniform('uColor')
                        .setFloat4(this._keepHoverColor);
                if (!hit) {
                    this._hoverNode = null;
                    return;
                }

                // stop at the first X/Y/Z matrix node
                var np = hit._nodePath;
                var i = np.length - 1;
                var node = np[i];
                while (node._nbAxis === undefined) {
                    if (i === 0) return;
                    node = np[--i];
                }

                var unif = node.getStateSet().getUniform('uColor');
                this._hoverNode = node;
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].copy(this._keepHoverColor, unif.getInternalArray());
                unif.setFloat4(hoverColor);
            };
        })(),

        initNodeRotate: function() {
            var drawArcXYZ = __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createTorusGeometry(1.0, 0.01, 6, 64, Math.PI * 2);
            var drawArc = __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createTorusGeometry(1.0, 0.01, 6, 64, Math.PI);
            var pickArc = __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createTorusGeometry(1.0, 0.1, 6, 64, Math.PI);

            var mtXYZ = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtX = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtY = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtZ = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            mtX._nbAxis = 0;
            mtY._nbAxis = 1;
            mtZ._nbAxis = 2;

            var hideNode = new __WEBPACK_IMPORTED_MODULE_0_osg_Node__["a" /* default */]();
            hideNode.setCullCallback(new HideCullCallback());
            hideNode.addChild(pickArc);

            // set masks
            drawArcXYZ.setNodeMask(NodeGizmo.NO_PICK);
            drawArc.setNodeMask(NodeGizmo.NO_PICK);
            mtX.setNodeMask(NodeGizmo.PICK_ARC_X);
            mtY.setNodeMask(NodeGizmo.PICK_ARC_Y);
            mtZ.setNodeMask(NodeGizmo.PICK_ARC_Z);

            mtXYZ.addChild(drawArcXYZ);
            mtX.addChild(drawArc);
            mtY.addChild(drawArc);
            mtZ.addChild(drawArc);

            mtX.addChild(hideNode);
            mtY.addChild(hideNode);
            mtZ.addChild(hideNode);

            mtXYZ
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.2, 0.2, 0.2, 1.0), 'uColor'));
            mtX
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.0, 0.0, 1.0), 'uColor'));
            mtY
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 1.0, 0.0, 1.0), 'uColor'));
            mtZ
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 1.0, 1.0), 'uColor'));

            var showAngle = this._showAngle;
            showAngle.getOrCreateStateSet().setAttributeAndModes(blendAttribute);
            showAngle.setNodeMask(0x0);
            showAngle
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat3(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0), 'uBase'));
            showAngle.getOrCreateStateSet().addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat(0.0, 'uAngle'));
            showAngle.addChild(__WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createQuadCircleGeometry());

            var rotate = this._rotateNode;
            rotate.setNodeMask(NodeGizmo.PICK_ARC);
            rotate.addChild(mtXYZ);
            rotate.addChild(mtX);
            rotate.addChild(mtY);
            rotate.addChild(mtZ);
            rotate.addChild(showAngle);
            return rotate;
        },

        initNodeTranslate: function() {
            var aHeight = 1.5;
            var aConeHeight = 0.3;
            var pickStart = 0.5; // offset (because of the picking plane)
            var pickHeight = (aHeight - pickStart + aConeHeight) * 1.1;

            // cone arrow
            var mtCone = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(
                mtCone.getMatrix(),
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, aHeight + aConeHeight * 0.5)
            );
            mtCone.addChild(
                __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createCylinderGeometry(0.0, 0.07, aConeHeight, 32, 1, true, true)
            );
            // arrow base
            var mtArrow = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(mtArrow.getMatrix(), __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, aHeight * 0.5));
            mtArrow.addChild(
                __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createCylinderGeometry(0.01, 0.01, aHeight, 32, 1, true, true)
            );
            // draw arrow
            var drawArrow = new __WEBPACK_IMPORTED_MODULE_0_osg_Node__["a" /* default */]();
            drawArrow.addChild(mtArrow);
            drawArrow.addChild(mtCone);

            var pickArrow = __WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createCylinderGeometry(
                0.1,
                0.1,
                pickHeight,
                32,
                1,
                true,
                true
            );

            var mtX = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtY = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtZ = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            mtX._nbAxis = 0;
            mtY._nbAxis = 1;
            mtZ._nbAxis = 2;

            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mtX.getMatrix(), Math.PI * 0.5, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0));
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mtY.getMatrix(), -Math.PI * 0.5, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0));

            var hideNode = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            hideNode.setCullCallback(new HideCullCallback());
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(
                hideNode.getMatrix(),
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, pickStart + pickHeight * 0.5)
            );
            hideNode.addChild(pickArrow);

            // set masks
            drawArrow.setNodeMask(NodeGizmo.NO_PICK);
            mtX.setNodeMask(NodeGizmo.PICK_ARROW_X);
            mtY.setNodeMask(NodeGizmo.PICK_ARROW_Y);
            mtZ.setNodeMask(NodeGizmo.PICK_ARROW_Z);

            mtX.addChild(drawArrow);
            mtY.addChild(drawArrow);
            mtZ.addChild(drawArrow);

            mtX.addChild(hideNode);
            mtY.addChild(hideNode);
            mtZ.addChild(hideNode);

            mtX
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.0, 0.0, 1.0), 'uColor'));
            mtY
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 1.0, 0.0, 1.0), 'uColor'));
            mtZ
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 1.0, 1.0), 'uColor'));

            var translate = this._translateNode;
            translate.setNodeMask(NodeGizmo.PICK_ARROW);
            translate.addChild(mtX);
            translate.addChild(mtY);
            translate.addChild(mtZ);
            return translate;
        },

        initNodeTranslatePlane: function() {
            var mtPlane = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(mtPlane.getMatrix(), __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.5, 0.5, 0.0));
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(
                mtPlane.getMatrix(),
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromScaling(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create(), __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.5, 0.5, 1.0)),
                mtPlane.getMatrix()
            );
            mtPlane.addChild(__WEBPACK_IMPORTED_MODULE_10_osgUtil_gizmoGeometry__["a" /* default */].createPlaneGeometry());

            var mtX = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtY = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            var mtZ = new __WEBPACK_IMPORTED_MODULE_2_osg_MatrixTransform__["a" /* default */]();
            mtX._nbAxis = 0;
            mtY._nbAxis = 1;
            mtZ._nbAxis = 2;

            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mtX.getMatrix(), -Math.PI * 0.5, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0));
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mtY.getMatrix(), Math.PI * 0.5, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0));

            // set masks
            mtX.setNodeMask(NodeGizmo.PICK_PLANE_X);
            mtY.setNodeMask(NodeGizmo.PICK_PLANE_Y);
            mtZ.setNodeMask(NodeGizmo.PICK_PLANE_Z);

            mtX.addChild(mtPlane);
            mtY.addChild(mtPlane);
            mtZ.addChild(mtPlane);

            mtX
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.0, 0.0, 0.3), 'uColor'));
            mtY
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 1.0, 0.0, 0.3), 'uColor'));
            mtZ
                .getOrCreateStateSet()
                .addUniform(__WEBPACK_IMPORTED_MODULE_6_osg_Uniform__["a" /* default */].createFloat4(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["g" /* vec4 */].fromValues(0.0, 0.0, 1.0, 0.3), 'uColor'));

            var plane = this._planeNode;
            plane.setNodeMask(NodeGizmo.PICK_PLANE);
            plane.getOrCreateStateSet().setAttributeAndModes(blendAttribute);
            plane.addChild(mtX);
            plane.addChild(mtY);
            plane.addChild(mtZ);
            return plane;
        },

        updateArcRotation: (function() {
            var qTmp = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].create();
            var quatx = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].setAxisAngle(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].create(), [0.0, 1.0, 0.0], -Math.PI * 0.5);
            var quaty = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].setAxisAngle(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].create(), [1.0, 0.0, 0.0], -Math.PI * 0.5);
            return function(eye) {
                var rotateNode = this._rotateNode;
                var arcs = rotateNode.getChildren();
                // eye arc
                qTmp[0] = -eye[1];
                qTmp[1] = eye[0];
                qTmp[2] = 0.0;
                qTmp[3] = 1.0 + eye[2];
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].normalize(qTmp, qTmp);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromQuat(arcs[0].getMatrix(), qTmp);
                // x arc
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].setAxisAngle(qTmp, [1.0, 0.0, 0.0], Math.atan2(eye[2], eye[1]));
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].mul(qTmp, qTmp, quatx);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromQuat(arcs[1].getMatrix(), qTmp);
                // y arc
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].setAxisAngle(qTmp, [0.0, 1.0, 0.0], Math.atan2(-eye[0], -eye[2]));
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].mul(qTmp, qTmp, quaty);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromQuat(arcs[2].getMatrix(), qTmp);
                // z arc
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["d" /* quat */].setAxisAngle(qTmp, [0.0, 0.0, 1.0], Math.atan2(-eye[0], eye[1]));
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromQuat(arcs[3].getMatrix(), qTmp);

                arcs[1].dirtyBound();
                arcs[2].dirtyBound();
                arcs[3].dirtyBound();
            };
        })(),

        getTransformType: function(nodeIn) {
            // should probably be a visitor with traverse parents instead
            var node = nodeIn;
            while (node.getParents().length > 0) {
                var refFrame = node.referenceFrame;
                if (refFrame !== undefined && refFrame === __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) {
                    return __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].ABSOLUTE_RF;
                }
                node = node.getParents()[0];
            }
            return __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].RELATIVE_RF;
        },

        getAttachedNodeWorldMatrix: function() {
            var worldMat = this._attachedNode.getWorldMatrix(undefined, _TMP_MAT);
            return __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].translate(worldMat, worldMat, this._pivotOffset);
        },

        update: (function() {
            var eye = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
            var worldTrans = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
            var tmpVec = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            var tmpMat = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();

            return function() {
                if (!this._attachedNode) return;

                var ttype = this.getTransformType(this._attachedNode);
                this.setReferenceFrame(ttype);
                this.setCullingActive(ttype === __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].RELATIVE_RF);
                var worldMat = this.getAttachedNodeWorldMatrix();

                // world trans
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getTranslation(worldTrans, worldMat);

                // normalize gizmo size
                var scaleFactor = 3.0;
                if (ttype === __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].ABSOLUTE_RF) {
                    eye[0] = eye[1] = eye[2] = 0.0;
                } else {
                    // normalize gizmo size relative to screen size
                    var proj = this._viewer.getCamera().getProjectionMatrix();
                    var scaleFov = this._canvas.clientWidth * 0.023 * proj[0];
                    this._manipulator.getEyePosition(eye);
                    // while we are editing we don't normalize the gizmo
                    // it gives a better depth feedback, especially if we are editing a geometry that has
                    // a constant screen size (for example an icon)
                    this._lastDistToEye = this._isEditing
                        ? this._lastDistToEye
                        : __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].distance(worldTrans, eye);
                    scaleFactor *= this._lastDistToEye / scaleFov;
                }

                // set the position of gizmo
                var gizmoMatrix = this.getMatrix();
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(gizmoMatrix, worldTrans);

                // set scale of gizmo
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].set(tmpVec, scaleFactor, scaleFactor, scaleFactor);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(gizmoMatrix, gizmoMatrix, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromScaling(tmpMat, tmpVec));

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].sub(eye, eye, worldTrans);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].normalize(eye, eye);

                // rotate node
                if (this._rotateInLocal || this._translateInLocal) {
                    // world scale
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getScale(tmpVec, worldMat);
                    var invScale = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromScaling(tmpMat, tmpVec);
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].invert(invScale, invScale);

                    var worldRot = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(worldMat, worldMat, invScale);
                    worldRot[12] = worldRot[13] = worldRot[14] = 0.0;

                    if (this._translateInLocal) {
                        __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._translateNode.getMatrix(), worldRot);
                        __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._planeNode.getMatrix(), worldRot);
                    }

                    if (this._rotateInLocal) {
                        __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._rotateNode.getMatrix(), worldRot);
                        __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].invert(worldRot, worldRot);
                        __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(eye, eye, worldRot);
                    }
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].identity(this._rotateNode.getMatrix());
                }

                this.updateArcRotation(eye);

                this._rotateNode.dirtyBound();
                this._translateNode.dirtyBound();
                this._planeNode.dirtyBound();

                if (this._isEditing) {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._showAngle.getMatrix(), this._hoverNode.getMatrix());
                }
            };
        })(),

        computeNearestIntersection: (function() {
            var sortByRatio = function(a, b) {
                return a._ratio - b._ratio;
            };
            var coord = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();

            return function(e, tmask) {
                getCanvasCoord(coord, e);

                // canvas to webgl coord
                var viewer = this._viewer;
                var canvas = this._canvas;
                var x = coord[0] * (viewer._canvasWidth / canvas.clientWidth);
                var y =
                    (canvas.clientHeight - coord[1]) * (viewer._canvasHeight / canvas.clientHeight);

                var hits = this._viewer.computeIntersections(x, y, tmask);

                if (hits.length === 0) return undefined;

                hits.sort(sortByRatio);
                return hits[0];
            };
        })(),

        setOnlyGizmoPicking: function() {
            // enable picking only for the gizmo
            this._viewer.getCamera().addChild(this);
            this._viewer.getSceneData().setNodeMask(0x0);
            this.setNodeMask(~0x0);
        },

        setOnlyScenePicking: function() {
            this._viewer.getCamera().removeChild(this);
            this._viewer.getSceneData().setNodeMask(~0x0);
            this.setNodeMask(NodeGizmo.NO_PICK);
        },

        pickGizmo: function(e, tmask) {
            this.setOnlyGizmoPicking();
            var hit = this.computeNearestIntersection(e, tmask);
            this.setOnlyScenePicking();
            return hit;
        },

        getCanvasPositionFromWorldPoint: (function() {
            var mat = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();

            return function(worldPoint, out) {
                var cam = this._viewer.getCamera();

                var screenPoint = out;

                if (cam.getViewport()) {
                    cam.getViewport().computeWindowMatrix(mat);
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].identity(mat);
                }

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(mat, mat, cam.getProjectionMatrix());
                if (this.getReferenceFrame() === __WEBPACK_IMPORTED_MODULE_11_osg_transformEnums__["a" /* default */].RELATIVE_RF)
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(mat, mat, cam.getViewMatrix());

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(screenPoint, worldPoint, mat);

                // canvas to webgl coord
                var viewer = this._viewer;
                var canvas = this._canvas;
                screenPoint[0] = screenPoint[0] / (viewer._canvasWidth / canvas.clientWidth);
                screenPoint[1] =
                    canvas.clientHeight -
                    screenPoint[1] / (viewer._canvasHeight / canvas.clientHeight);
                return screenPoint;
            };
        })(),

        onMouseDown: function(e) {
            getCanvasCoord(this._downCanvasCoord, e);
            // When there is a mouse, the node (arrow, plane or torus) has been hovered due to there has been a mousemove event hover it
            // So, for touch devices the next lines are necessary
            if ('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints)
                this.onMouseMove(e);

            if (!this._hoverNode || !this._attachedNode) return;
            e.preventDefault();

            this._viewer.setEnableManipulator(false);

            this.saveEditMatrices();
            var nm = this._hoverNode.getParents()[0].getNodeMask();
            this._isEditing = true;

            if (nm & NodeGizmo.PICK_ARC) {
                this._translateNode.setNodeMask(0x0);
                this._planeNode.setNodeMask(0x0);
                this.startRotateEdit(e);
            } else if (nm & NodeGizmo.PICK_ARROW) {
                this._rotateNode.setNodeMask(0x0);
                this._planeNode.setNodeMask(0x0);
                this.startTranslateEdit(e);
            } else if (nm & NodeGizmo.PICK_PLANE) {
                this._rotateNode.setNodeMask(0x0);
                this._translateNode.setNodeMask(0x0);
                this.startPlaneEdit(e);
            }
        },

        saveEditMatrices: function() {
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._editLocal, this._attachedNode.getMatrix());
            // save the world translation
            var wm = this.getAttachedNodeWorldMatrix();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromTranslation(this._editWorldTrans, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(wm[12], wm[13], wm[14]));
            // save the inv of world rotation + scale
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this._editWorldScaleRot, wm);
            // removes translation
            this._editWorldScaleRot[12] = this._editWorldScaleRot[13] = this._editWorldScaleRot[14] = 0.0;
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].invert(this._editInvWorldScaleRot, this._editWorldScaleRot);
        },

        startRotateEdit: function(e) {
            var gizmoMat = this._rotateNode.getWorldMatrix(undefined, _TMP_MAT);

            // center of gizmo on screen
            var projCenter = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(projCenter, projCenter, gizmoMat);
            this.getCanvasPositionFromWorldPoint(projCenter, projCenter);

            // pick rotate gizmo
            var hit = this.pickGizmo(e, this._hoverNode.getNodeMask() | NodeGizmo.PICK_ARC);
            if (!hit) return;

            // compute tangent direction
            var sign = this._hoverNode._nbAxis === 0 ? -1.0 : 1.0;
            var tang = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            tang[0] = sign * hit._localIntersectionPoint[1];
            tang[1] = -sign * hit._localIntersectionPoint[0];
            tang[2] = hit._localIntersectionPoint[2];

            // project tangent on screen
            var projArc = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(projArc, tang, this._hoverNode.getMatrix());
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(projArc, projArc, gizmoMat);
            this.getCanvasPositionFromWorldPoint(projArc, projArc);

            var dir = this._editLineDirection;
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(dir, projArc, projCenter);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].normalize(dir, dir);

            // show angle
            this._showAngle.setNodeMask(NodeGizmo.NO_PICK);
            hit._localIntersectionPoint[2] = 0.0;
            var stateAngle = this._showAngle.getStateSet();
            stateAngle.getUniform('uAngle').setFloat(0.0);
            stateAngle
                .getUniform('uBase')
                .setVec3(__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].normalize(hit._localIntersectionPoint, hit._localIntersectionPoint));

            getCanvasCoord(this._editLineOrigin, e);
        },

        startTranslateEdit: function(e) {
            var origin = this._editLineOrigin;
            var dir = this._editLineDirection;

            // 3d origin (center of gizmo)
            var gizmoMat = this._translateNode.getWorldMatrix(undefined, _TMP_MAT);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getTranslation(origin, gizmoMat);

            // 3d direction
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].init(dir);
            dir[this._hoverNode._nbAxis] = 1.0;
            if (this._translateInLocal) {
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(dir, dir, this._editWorldScaleRot);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].normalize(dir, dir);
            }
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].add(dir, origin, dir);

            // project on canvas
            this.getCanvasPositionFromWorldPoint(origin, origin);
            this.getCanvasPositionFromWorldPoint(dir, dir);

            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(dir, dir, origin);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].normalize(dir, dir);

            var offset = this._editOffset;
            getCanvasCoord(offset, e);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(offset, offset, origin);
        },

        startPlaneEdit: function(e) {
            var origin = this._editLineOrigin; // just used to determine the 2d offset

            // 3d origin (center of gizmo)
            var gizmoMat = this._planeNode.getWorldMatrix(undefined, _TMP_MAT);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getTranslation(origin, gizmoMat);

            // project on canvas
            this.getCanvasPositionFromWorldPoint(origin, origin);

            var offset = this._editOffset;
            getCanvasCoord(offset, e);
            __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(offset, offset, origin);
        },

        drawLineCanvasDebug: function(x1, y1, x2, y2) {
            this._debugNode.setNodeMask(NodeGizmo.NO_PICK);
            var buffer = this._debugNode.getChildren()[0].getAttributes().Vertex;
            buffer.getElements()[0] = x1 / this._canvas.clientWidth * 2 - 1.0;
            buffer.getElements()[1] =
                (this._canvas.clientHeight - y1) / this._canvas.clientHeight * 2 - 1.0;
            buffer.getElements()[2] = x2 / this._canvas.clientWidth * 2 - 1.0;
            buffer.getElements()[3] =
                (this._canvas.clientHeight - y2) / this._canvas.clientHeight * 2 - 1.0;
            buffer.dirty();
        },

        setDisabledRightMiddleButtons: function (isDisabled) {
            this._disabledRightMiddleButtons = isDisabled;
        },

        getDisabledRightMiddleButtons: function () {
            return this._disabledRightMiddleButtons;
        },

        pickAndSelect: function(e) {
            this.setNodeMask(0x0);
            var hit = this.computeNearestIntersection(e, this._tmask);
            this.attachToNodePath(hit ? hit._nodePath : hit);
        },

        onMouseUp: function(e) {
            this._viewer.setEnableManipulator(true);
            if (this._debugNode) this._debugNode.setNodeMask(0x0);

            var v = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();
            getCanvasCoord(v, e);
            if (__WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].distance(v, this._downCanvasCoord) <= this._pixelsMargin) this.pickAndSelect(e);

            this._showAngle.setNodeMask(0x0);
            this._isEditing = false;
            if (!this._hoverNode) return;
            this.updateGizmoMask();

            // to deselect the _hoverNode in touch devices
            if ('ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints)
                this.onMouseMove();
        },

        onMouseMove: function (e) {
            // second condition prevents movement when user clicks on right or middle buttons
            if (!this._attachedNode || ( this.getDisabledRightMiddleButtons() && e.which > 1)) return;
            var hit;
            if (this._isEditing === false) {
                if (e)
                    hit = this.pickGizmo(e, NodeGizmo.PICK_GIZMO);
                this.onNodeHovered(hit);
                return;
            }

            if (!this._hoverNode) return;

            var par = this._hoverNode.getParents()[0];
            if (par === this._rotateNode) this.updateRotateEdit(e);
            else if (par === this._translateNode) this.updateTranslateEdit(e);
            else if (par === this._planeNode) this.updatePlaneEdit(e);
        },

        updateRotateEdit: (function() {
            var mrot = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].create();
            var vec = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();
            var vecX = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(1.0, 0.0, 0.0);
            var vecY = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 1.0, 0.0);
            var vecZ = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].fromValues(0.0, 0.0, 1.0);
            var negatePivot = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            return function(e) {
                var origin = this._editLineOrigin;
                var dir = this._editLineDirection;

                getCanvasCoord(vec, e);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(vec, vec, origin);
                var dist = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].dot(vec, dir);

                if (this._debugNode) {
                    var ox = origin[0];
                    var oy = origin[1];
                    this.drawLineCanvasDebug(ox, oy, ox + dir[0] * dist, oy + dir[1] * dist);
                }

                var minClient = Math.min(this._canvas.clientWidth, this._canvas.clientHeight);
                var angle = 7 * dist / minClient;
                angle %= Math.PI * 2;

                var nbAxis = this._hoverNode._nbAxis;
                if (nbAxis === 0) __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mrot, -angle, vecX);
                else if (nbAxis === 1) __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mrot, -angle, vecY);
                else if (nbAxis === 2) __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].fromRotation(mrot, -angle, vecZ);

                var uAngle = this._showAngle.getOrCreateStateSet().getUniform('uAngle');
                uAngle.setFloat(nbAxis === 0 ? -angle : angle);

                if (!this._rotateInLocal) {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(mrot, this._editInvWorldScaleRot, mrot);
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(mrot, mrot, this._editWorldScaleRot);
                }

                // rotate around origin pivot (geometry center)
                // the classic rotation around pivot : -T * R * T
                var attMat = this._attachedNode.getMatrix();
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].translate(attMat, this._editLocal, this._pivotOffset);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].mul(attMat, attMat, mrot);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].translate(attMat, attMat, __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].negate(negatePivot, this._pivotOffset));

                this._attachedNode.dirtyBound();
            };
        })(),

        updateTranslateEdit: (function() {
            var vec = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();
            var tra = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            return function(e) {
                var origin = this._editLineOrigin;
                var dir = this._editLineDirection;

                getCanvasCoord(vec, e);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(vec, vec, origin);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(vec, vec, this._editOffset);

                var dist = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].dot(vec, dir);
                vec[0] = origin[0] + dir[0] * dist;
                vec[1] = origin[1] + dir[1] * dist;

                if (this._debugNode) this.drawLineCanvasDebug(origin[0], origin[1], vec[0], vec[1]);

                // canvas to webgl coord
                var viewer = this._viewer;
                var canvas = this._canvas;
                var coordx = vec[0] * (viewer._canvasWidth / canvas.clientWidth);
                var coordy =
                    (canvas.clientHeight - vec[1]) * (viewer._canvasHeight / canvas.clientHeight);

                // project 2D point on the 3d line
                this._lsi.reset();
                this._lsi.setTestPlane(false);
                this._lsi.set(
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].set(this._origIntersect, coordx, coordy, 0.0),
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].set(this._dstIntersect, coordx, coordy, 1.0)
                );
                this._iv.reset();
                this._iv.setTraversalMask(this._hoverNode.getNodeMask());

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this.getMatrix(), this._editWorldTrans);

                this.setOnlyGizmoPicking();
                this._viewer._camera.accept(this._iv);
                this.setOnlyScenePicking();

                if (!this._translateInLocal) {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(
                        tra,
                        this._lsi.getTranslateDistance(),
                        this._editInvWorldScaleRot
                    );
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getScale(tra, this._editInvWorldScaleRot);

                    var inter = this._lsi.getTranslateDistance();
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].mul(tra, tra, inter);
                }

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].translate(this._attachedNode.getMatrix(), this._editLocal, tra);

                this._attachedNode.dirtyBound();
            };
        })(),

        updatePlaneEdit: (function() {
            var vec = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].create();
            var tra = __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].create();

            return function(e) {
                getCanvasCoord(vec, e);
                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["e" /* vec2 */].sub(vec, vec, this._editOffset);

                // canvas to webgl coord
                var viewer = this._viewer;
                var canvas = this._canvas;
                var coordx = vec[0] * (viewer._canvasWidth / canvas.clientWidth);
                var coordy =
                    (canvas.clientHeight - vec[1]) * (viewer._canvasHeight / canvas.clientHeight);

                // project 2D point on the 3d plane
                this._lsi.reset();
                this._lsi.setTestPlane(true);
                this._lsi.set(
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].set(this._origIntersect, coordx, coordy, 0.0),
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].set(this._dstIntersect, coordx, coordy, 1.0)
                );
                this._iv.reset();
                this._iv.setTraversalMask(this._hoverNode.getNodeMask());

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].copy(this.getMatrix(), this._editWorldTrans);

                this.setOnlyGizmoPicking();
                this._viewer._camera.accept(this._iv);
                this.setOnlyScenePicking();

                if (!this._translateInLocal) {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].transformMat4(
                        tra,
                        this._lsi.getTranslateDistance(),
                        this._editInvWorldScaleRot
                    );
                } else {
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].getScale(tra, this._editInvWorldScaleRot);
                    var inter = this._lsi.getTranslateDistance();
                    __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["f" /* vec3 */].mul(tra, tra, inter);
                }

                __WEBPACK_IMPORTED_MODULE_7_osg_glMatrix__["c" /* mat4 */].translate(this._attachedNode.getMatrix(), this._editLocal, tra);

                this._attachedNode.dirtyBound();
            };
        })()
    }),
    'osgUtil',
    'NodeGizmo'
);

/* harmony default export */ __webpack_exports__["a"] = (NodeGizmo);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgUtil_SphereIntersectFunctor__ = __webpack_require__(237);






var SphereIntersector = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__["a" /* default */].call(this);

    this._center = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._iCenter = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
    this._radius = 1.0;
    this._iRadius = 1.0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    SphereIntersector,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgUtil_Intersector__["a" /* default */].prototype, {
        set: function(center, radius) {
            // we copy iCenter and iRadius in case setCurrentTransformation is never called
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._center, center);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iCenter, center);
            this._radius = this._iRadius = radius;
            this.reset();
        },

        setCenter: function(center) {
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._center, center);
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(this._iCenter, center);
        },

        setRadius: function(radius) {
            this._radius = this._iRadius = radius;
        },

        intersectNode: function(node) {
            // TODO implement intersectBoundingBox?
            return this.intersectBoundingSphere(node.getBoundingSphere());
        },

        intersectBoundingSphere: function(bsphere) {
            if (!bsphere.valid()) return false;
            var r = this._iRadius + bsphere.radius();
            return __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrDist(bsphere.center(), this._iCenter) <= r * r;
        },

        intersect: (function() {
            var functor = new __WEBPACK_IMPORTED_MODULE_3_osgUtil_SphereIntersectFunctor__["a" /* default */]();

            return function(iv, node) {
                functor.setGeometry(node);
                functor.setIntersectionVisitor(iv);
                functor.setIntersector(this);

                functor.set(this._iCenter, this._iRadius);

                var kdtree = node.getShape();
                if (kdtree) {
                    kdtree.intersect(functor, kdtree.getNodes()[0]);
                } else {
                    // handle rig transformed vertices
                    if (node.computeTransformedVertices) {
                        functor.setVertices(node.computeTransformedVertices());
                    }

                    functor.apply(node);
                }

                functor.reset();
            };
        })(),

        setCurrentTransformation: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            return function(matrix) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].invert(matrix, matrix);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(this._iCenter, this._center, matrix);
                // Only handling analitically uniform scales.
                // For non uniform we use an approximation to avoid complexity
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].getScale(tmp, matrix);
                var x = tmp[0];
                var y = tmp[1];
                var z = tmp[2];
                var maxScale = x > y ? (x > z ? x : z) : y > z ? y : z;
                this._iRadius = this._radius * maxScale;
            };
        })()
    }),
    'osgUtil',
    'SphereIntersector'
);

/* harmony default export */ __webpack_exports__["a"] = (SphereIntersector);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__ = __webpack_require__(69);




var SphereIntersection = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].Intersection.call(this);

    this._localIntersectionNormal = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].clone(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].ONE);

    // index of vertex
    this._i1 = -1;
    this._i2 = -1;
    this._i3 = -1;

    // barycentric coordinates
    this._r1 = 0.0;
    this._r2 = 0.0;
    this._r3 = 0.0;
};

var SphereIntersectFunctor = function() {
    __WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].apply(this);

    this._center = undefined;
    this._radius = 0.0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    SphereIntersectFunctor,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osgUtil_IntersectFunctor__["a" /* default */].prototype, {
        set: function(center, radius) {
            this._center = center;
            this._radius = radius;
        },

        enter: function(bbox) {
            // Intersection sphere box, from graphic gems 2
            // https://github.com/erich666/GraphicsGems/blob/master/gems/BoxSphere.c
            var r2 = this._radius * this._radius;
            var dmin = 0;
            var bmin = bbox.getMin();
            var bmax = bbox.getMax();
            var d = 0;
            for (var i = 0; i < 3; i++) {
                if (this._center[i] < bmin[i]) {
                    d = this._center[i] - bmin[i];
                    dmin += d * d;
                } else if (this._center[i] > bmax[i]) {
                    d = this._center[i] - bmax[i];
                    dmin += d * d;
                }
            }
            return dmin <= r2;
        },

        intersectPoint: function(v0, i0) {
            var sqrDistance = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrDist(v0, this._center);
            if (sqrDistance > this._radius * this._radius) return;

            var intersection = this.initIntersection(new SphereIntersection());
            intersection._i1 = i0;
            intersection._r1 = 1.0;
            __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].copy(intersection._localIntersectionPoint, v0);
            intersection._ratio = Math.sqrt(sqrDistance) / this._radius;
        },

        intersectLine: (function() {
            var tmp = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var dir = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

            return function(v0, v1, p0, p1) {
                // https://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistPointSegment.h
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(tmp, this._center, v0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(dir, v1, v0);
                // compute ratio (projection on line)
                var r = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(tmp, dir) / __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(dir);

                // compute distance to segment
                var distToSegmentSqr = 1.0;
                if (r < 0.0) distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(tmp);
                else if (r > 1.0) distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrDist(this._center, v1);
                else distToSegmentSqr = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(tmp, tmp, dir, -r));

                if (distToSegmentSqr > this._radius * this._radius) {
                    return;
                }

                var intersection = this.initIntersection(new SphereIntersection());
                intersection._i1 = p0;
                intersection._i2 = p1;

                intersection._r1 = 1.0 - r;
                intersection._r2 = r;

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(intersection._localIntersectionPoint, v0, dir, r);
                intersection._ratio = Math.sqrt(distToSegmentSqr) / this._radius;
            };
        })(),

        //
        // \2|
        //  \|
        //   \
        // 3 |\  1
        //   |0\
        // __|__\___
        // 4 | 5 \ 6
        //
        // from http://www.geometrictools.com/Source/Distance3D.html#PointPlanar
        // js : https://github.com/stephomi/sculptgl/blob/master/src/math3d/Geometry.js#L89
        intersectTriangle: (function() {
            var edge1 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var edge2 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            var diff = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();
            return function(v0, v1, v2, i0, i1, i2) {
                if (this._limitOneIntersection && this._hit) return;
                // sphere is a 'volume' here (so if the triangle is inside the ball it will intersects)

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(edge1, v1, v0);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(edge2, v2, v0);
                var a00 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(edge1);
                var a01 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(edge1, edge2);
                var a11 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(edge2);

                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sub(diff, v0, this._center);
                var b0 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(diff, edge1);
                var b1 = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].dot(diff, edge2);
                var c = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].sqrLen(diff);
                var det = Math.abs(a00 * a11 - a01 * a01);
                if (det < 1e-10) return;

                var s = a01 * b1 - a11 * b0;
                var t = a01 * b0 - a00 * b1;
                var sqrDistance;
                var zone = 4;

                if (s + t <= det) {
                    if (s < 0.0) {
                        if (t < 0.0) {
                            // region 4
                            zone = 4;
                            if (b0 < 0.0) {
                                t = 0.0;
                                if (-b0 >= a00) {
                                    s = 1.0;
                                    sqrDistance = a00 + 2.0 * b0 + c;
                                } else {
                                    s = -b0 / a00;
                                    sqrDistance = b0 * s + c;
                                }
                            } else {
                                s = 0.0;
                                if (b1 >= 0.0) {
                                    t = 0.0;
                                    sqrDistance = c;
                                } else if (-b1 >= a11) {
                                    t = 1.0;
                                    sqrDistance = a11 + 2.0 * b1 + c;
                                } else {
                                    t = -b1 / a11;
                                    sqrDistance = b1 * t + c;
                                }
                            }
                        } else {
                            // region 3
                            zone = 3;
                            s = 0.0;
                            if (b1 >= 0.0) {
                                t = 0.0;
                                sqrDistance = c;
                            } else if (-b1 >= a11) {
                                t = 1.0;
                                sqrDistance = a11 + 2.0 * b1 + c;
                            } else {
                                t = -b1 / a11;
                                sqrDistance = b1 * t + c;
                            }
                        }
                    } else if (t < 0.0) {
                        // region 5
                        zone = 5;
                        t = 0.0;
                        if (b0 >= 0.0) {
                            s = 0.0;
                            sqrDistance = c;
                        } else if (-b0 >= a00) {
                            s = 1.0;
                            sqrDistance = a00 + 2.0 * b0 + c;
                        } else {
                            s = -b0 / a00;
                            sqrDistance = b0 * s + c;
                        }
                    } else {
                        // region 0
                        zone = 0;
                        // minimum at interior point
                        var invDet = 1.0 / det;
                        s *= invDet;
                        t *= invDet;
                        sqrDistance =
                            s * (a00 * s + a01 * t + 2.0 * b0) +
                            t * (a01 * s + a11 * t + 2.0 * b1) +
                            c;
                    }
                } else {
                    var tmp0, tmp1, numer, denom;

                    if (s < 0.0) {
                        // region 2
                        zone = 2;
                        tmp0 = a01 + b0;
                        tmp1 = a11 + b1;
                        if (tmp1 > tmp0) {
                            numer = tmp1 - tmp0;
                            denom = a00 - 2.0 * a01 + a11;
                            if (numer >= denom) {
                                s = 1.0;
                                t = 0.0;
                                sqrDistance = a00 + 2.0 * b0 + c;
                            } else {
                                s = numer / denom;
                                t = 1.0 - s;
                                sqrDistance =
                                    s * (a00 * s + a01 * t + 2.0 * b0) +
                                    t * (a01 * s + a11 * t + 2.0 * b1) +
                                    c;
                            }
                        } else {
                            s = 0.0;
                            if (tmp1 <= 0.0) {
                                t = 1.0;
                                sqrDistance = a11 + 2.0 * b1 + c;
                            } else if (b1 >= 0.0) {
                                t = 0.0;
                                sqrDistance = c;
                            } else {
                                t = -b1 / a11;
                                sqrDistance = b1 * t + c;
                            }
                        }
                    } else if (t < 0.0) {
                        // region 6
                        zone = 6;
                        tmp0 = a01 + b1;
                        tmp1 = a00 + b0;
                        if (tmp1 > tmp0) {
                            numer = tmp1 - tmp0;
                            denom = a00 - 2.0 * a01 + a11;
                            if (numer >= denom) {
                                t = 1.0;
                                s = 0.0;
                                sqrDistance = a11 + 2.0 * b1 + c;
                            } else {
                                t = numer / denom;
                                s = 1.0 - t;
                                sqrDistance =
                                    s * (a00 * s + a01 * t + 2.0 * b0) +
                                    t * (a01 * s + a11 * t + 2.0 * b1) +
                                    c;
                            }
                        } else {
                            t = 0.0;
                            if (tmp1 <= 0.0) {
                                s = 1.0;
                                sqrDistance = a00 + 2.0 * b0 + c;
                            } else if (b0 >= 0.0) {
                                s = 0.0;
                                sqrDistance = c;
                            } else {
                                s = -b0 / a00;
                                sqrDistance = b0 * s + c;
                            }
                        }
                    } else {
                        // region 1
                        zone = 1;
                        numer = a11 + b1 - a01 - b0;
                        if (numer <= 0.0) {
                            s = 0.0;
                            t = 1.0;
                            sqrDistance = a11 + 2.0 * b1 + c;
                        } else {
                            denom = a00 - 2.0 * a01 + a11;
                            if (numer >= denom) {
                                s = 1.0;
                                t = 0.0;
                                sqrDistance = a00 + 2.0 * b0 + c;
                            } else {
                                s = numer / denom;
                                t = 1.0 - s;
                                sqrDistance =
                                    s * (a00 * s + a01 * t + 2.0 * b0) +
                                    t * (a01 * s + a11 * t + 2.0 * b1) +
                                    c;
                            }
                        }
                    }
                }

                if (sqrDistance > this._radius * this._radius) return;

                var normal = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

                var intersection = this.initIntersection(new SphereIntersection());
                intersection._i1 = i0;
                intersection._i2 = i1;
                intersection._i3 = i2;

                intersection._r1 = 1 - s - t;
                intersection._r2 = s;
                intersection._r3 = t;

                // inter = v0 + edge1 * s + edge2 * t
                var inter = intersection._localIntersectionPoint;
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(inter, __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].scaleAndAdd(inter, v0, edge1, s), edge2, t);

                // normal
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].cross(intersection._localIntersectionNormal, edge1, edge2);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].normalize(normal, intersection._localIntersectionNormal);

                intersection._ratio = Math.sqrt(sqrDistance) / this._radius;
                intersection._zone = zone;
            };
        })()
    }),
    'osgUtil',
    'SphereIntersectFunctor'
);

/* harmony default export */ __webpack_exports__["a"] = (SphereIntersectFunctor);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);







var TangentSpaceGenerator = function() {
    __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].call(this);
    this._T = undefined;
    this._B = undefined;
    this._N = undefined;
    this._texCoordUnit = 0;
};

__WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].createPrototypeObject(
    TangentSpaceGenerator,
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].prototype, {
        apply: function(node) {
            if (node.getTypeID() === __WEBPACK_IMPORTED_MODULE_2_osg_Geometry__["a" /* default */].getTypeID()) this.generate(node, this._texCoordUnit);
            else this.traverse(node);
        },

        setTexCoordUnit: function(texCoordUnit) {
            this._texCoordUnit = texCoordUnit;
        },

        computePrimitiveSet: function(geometry, primitive) {
            // no indices -> exit
            if (!primitive.getIndices) return;

            var numIndices = primitive.getNumIndices();

            var vx = geometry.getAttributes().Vertex;
            var nx = geometry.getAttributes().Normal;
            var tx = geometry.getAttributes()['TexCoord' + this._texCoordUnit];

            var i;

            if (primitive.getMode() === __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__["a" /* default */].TRIANGLES) {
                for (i = 0; i < numIndices; i += 3) {
                    this.compute(primitive, vx, nx, tx, i, i + 1, i + 2);
                }
            } else if (primitive.getMode() === __WEBPACK_IMPORTED_MODULE_4_osg_primitiveSet__["a" /* default */].TRIANGLE_STRIP) {
                for (i = 0; i < numIndices - 2; ++i) {
                    if (i % 2 === 0) {
                        this.compute(primitive, vx, nx, tx, i, i + 1, i + 2);
                    } else {
                        this.compute(primitive, vx, nx, tx, i + 1, i, i + 2);
                    }
                }
            }
        },

        generate: function(geometry, texCoordUnit) {
            this._texCoordUnit = texCoordUnit;

            if (this._texCoordUnit === undefined) this._texCoordUnit = 0;

            var size = geometry.getAttributes().Vertex.getElements().length;
            this._T = new __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].Float32Array(size);
            this._B = new __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].Float32Array(size);
            this._N = new __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].Float32Array(size);

            geometry.getPrimitiveSetList().forEach(function(primitive) {
                this.computePrimitiveSet(geometry, primitive);
            }, this);

            var nbElements = size / 3;
            var tangents = new __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].Float32Array(nbElements * 4);

            var tmp0 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var tmp1 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var t3 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            for (var i = 0; i < nbElements; i++) {
                var t = this._T.subarray(i * 3, i * 3 + 3);
                var n = this._N.subarray(i * 3, i * 3 + 3);
                var b = this._B.subarray(i * 3, i * 3 + 3);

                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(n, n);

                // Gram-Schmidt orthogonalize
                // vec3 t3 = (t - n * (n * t));
                // t3.normalize();
                // finalTangent = Vec4(t3, 0.0);
                // Calculate handedness
                // finalTangent[3] = (((n ^ t) * b) < 0.0) ? -1.0 : 1.0;
                // The bitangent vector B is then given by B = (N × T) · Tw

                var nt = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].dot(n, t);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].scale(tmp1, n, nt);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].sub(tmp0, t, tmp1);
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(t3, tmp0);

                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tmp0, n, t);
                var sign = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].dot(tmp0, b);
                sign = sign < 0.0 ? -1.0 : 0.0;

                // TODO perf : cache index var id = i * 4;
                tangents[i * 4] = t3[0];
                tangents[i * 4 + 1] = t3[1];
                tangents[i * 4 + 2] = t3[2];
                tangents[i * 4 + 3] = sign;
            }

            geometry.getAttributes().Normal.setElements(this._N);
            geometry.getAttributes().Tangent = new __WEBPACK_IMPORTED_MODULE_1_osg_BufferArray__["a" /* default */]('ARRAY_BUFFER', tangents, 4);
        },

        compute: function(primitive, vx, nx, tx, ia, ib, ic) {
            var i0 = primitive.index(ia);
            var i1 = primitive.index(ib);
            var i2 = primitive.index(ic);

            // TODO perf : cache xx.getElements() but more importantly
            // subarray call have very high overhead, it's super useful
            // when you call it a few times for big array chunk, but for
            // small array extraction (each vertex) it's better to use a temporary
            // pre allocated array and simply fill it
            // then, you'll have to write in the big arrays at the end
            var P1 = vx.getElements().subarray(i0 * 3, i0 * 3 + 3);
            var P2 = vx.getElements().subarray(i1 * 3, i1 * 3 + 3);
            var P3 = vx.getElements().subarray(i2 * 3, i2 * 3 + 3);

            var N1 = nx.getElements().subarray(i0 * 3, i0 * 3 + 3);
            var N2 = nx.getElements().subarray(i1 * 3, i1 * 3 + 3);
            var N3 = nx.getElements().subarray(i2 * 3, i2 * 3 + 3);

            var uv1 = tx.getElements().subarray(i0 * 2, i0 * 2 + 2);
            var uv2 = tx.getElements().subarray(i1 * 2, i1 * 2 + 2);
            var uv3 = tx.getElements().subarray(i2 * 2, i2 * 2 + 2);

            var vz, vy;
            // TODO perf : use temporary vec
            var V = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            var B1 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var B2 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var B3 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            var T1 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var T2 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var T3 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            var v1 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var v2 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v1, P2[0] - P1[0], uv2[0] - uv1[0], uv2[1] - uv1[1]);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v2, P3[0] - P1[0], uv3[0] - uv1[0], uv3[1] - uv1[1]);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(V, v1, v2);

            if (V[0] !== 0.0) {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(V, V);
                vy = -V[1] / V[0];
                vz = -V[2] / V[0];
                T1[0] += vy;
                B1[0] += vz;
                T2[0] += vy;
                B2[0] += vz;
                T3[0] += vy;
                B3[0] += vz;
            }

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v1, P2[1] - P1[1], uv2[0] - uv1[0], uv2[1] - uv1[1]);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v2, P3[1] - P1[1], uv3[0] - uv1[0], uv3[1] - uv1[1]);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(V, v1, v2);

            if (V[0] !== 0.0) {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(V, V);
                vy = -V[1] / V[0];
                vz = -V[2] / V[0];
                T1[1] += vy;
                B1[1] += vz;
                T2[1] += vy;
                B2[1] += vz;
                T3[1] += vy;
                B3[1] += vz;
            }

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v1, P2[2] - P1[2], uv2[0] - uv1[0], uv2[1] - uv1[1]);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].set(v2, P3[2] - P1[2], uv3[0] - uv1[0], uv3[1] - uv1[1]);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(V, v1, v2);

            if (V[0] !== 0.0) {
                __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].normalize(V, V);
                vy = -V[1] / V[0];
                vz = -V[2] / V[0];
                T1[2] += vy;
                B1[2] += vz;
                T2[2] += vy;
                B2[2] += vz;
                T3[2] += vy;
                B3[2] += vz;
            }

            var tempVec = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();
            var tempVec2 = __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].create();

            var Tdst, Bdst, Ndst;

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, N1, T1);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, tempVec, N1);
            Tdst = this._T.subarray(i0 * 3, i0 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Tdst, tempVec2, Tdst);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, B1, N1);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, N1, tempVec);
            Bdst = this._B.subarray(i0 * 3, i0 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Bdst, tempVec2, Bdst);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, N2, T2);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, tempVec, N2);
            Tdst = this._T.subarray(i1 * 3, i1 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Tdst, tempVec2, Tdst);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, B2, N2);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, N2, tempVec);
            Bdst = this._B.subarray(i1 * 3, i1 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Bdst, tempVec2, Bdst);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, N3, T3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, tempVec, N3);
            Tdst = this._T.subarray(i2 * 3, i2 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Tdst, tempVec2, Tdst);

            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec, B3, N3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].cross(tempVec2, N3, tempVec);
            Bdst = this._B.subarray(i2 * 3, i2 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Bdst, tempVec2, Bdst);

            Ndst = this._N.subarray(i0 * 3, i0 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Ndst, N1, Ndst);

            Ndst = this._N.subarray(i1 * 3, i1 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Ndst, N2, Ndst);

            Ndst = this._N.subarray(i2 * 3, i2 * 3 + 3);
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["f" /* vec3 */].add(Ndst, N3, Ndst);
        }
    }),
    'osgUtil',
    'TangentSpaceGenerator'
);

/* harmony default export */ __webpack_exports__["a"] = (TangentSpaceGenerator);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__ = __webpack_require__(36);















var WebVRCustom = {};

// no smart resize, we just recreate everything
var UpdateRecreateOnResize = function(viewer, rttScene, hmdConfig, root, canvas) {
    this._viewer = viewer;
    this._rttScene = rttScene;
    this._hmdConfig = hmdConfig;
    this._root = root;
    this._canvas = canvas;
    this._width = canvas.width;
    this._height = canvas.height;
};

UpdateRecreateOnResize.prototype = {
    update: function() {
        var canvas = this._canvas;
        var width = canvas.width;
        var height = canvas.height;

        if (width !== this._width || height !== this._height) {
            this._root.removeChildren();

            var hmdConfig = this._hmdConfig;
            if (hmdConfig && hmdConfig.isCardboard) {
                hmdConfig.hResolution = width;
                hmdConfig.vResolution = height;
            }
            this._width = width;
            this._height = height;

            WebVRCustom.createScene(this._viewer, this._rttScene, hmdConfig, this._root);
        }
        return true;
    }
};

var UpdateOffsetCamera = function(rootView, offsetView) {
    this._rootView = rootView;
    this._offsetView = offsetView;
};

UpdateOffsetCamera.prototype = {
    update: function(node) {
        var nodeView = node.getViewMatrix();
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(nodeView, this._offsetView, this._rootView);
        return true;
    }
};

var setupWebVR = function(worldFactor, HMD, webVRUniforms, webVRMatrices) {
    var aspect = HMD.hResolution / (2.0 * HMD.vResolution);
    var r =
        -1.0 - 4.0 * (HMD.hScreenSize * 0.25 - HMD.lensSeparationDistance * 0.5) / HMD.hScreenSize;
    var distScale =
        HMD.distortionK[0] +
        HMD.distortionK[1] * Math.pow(r, 2) +
        HMD.distortionK[2] * Math.pow(r, 4) +
        HMD.distortionK[3] * Math.pow(r, 6);
    var fov =
        180.0 /
        Math.PI *
        2.0 *
        Math.atan2(HMD.vScreenSize * distScale, 2.0 * HMD.eyeToScreenDistance);

    var proj = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].perspective(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create(), Math.PI / 180 * fov, aspect, 0.3, 10000.0);

    var hOffset =
        4.0 * (HMD.hScreenSize * 0.25 - HMD.interpupillaryDistance * 0.5) / HMD.hScreenSize;
    var lensShift =
        4.0 * (HMD.hScreenSize * 0.25 - HMD.lensSeparationDistance * 0.5) / HMD.hScreenSize;

    var leftMat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
    var rightMat = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create();
    webVRMatrices.projectionLeft = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(
        leftMat,
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(leftMat, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(hOffset, 0.0, 0.0)),
        proj
    );
    webVRMatrices.projectionRight = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(
        rightMat,
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(rightMat, __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(-hOffset, 0.0, 0.0)),
        proj
    );
    webVRMatrices.viewLeft = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create(),
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(worldFactor * HMD.interpupillaryDistance * 0.5, 0.0, 0.0)
    );
    webVRMatrices.viewRight = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create(),
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(-worldFactor * HMD.interpupillaryDistance * 0.5, 0.0, 0.0)
    );

    webVRUniforms.lensCenterLeft = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(lensShift, 0.0);
    webVRUniforms.lensCenterRight = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(-lensShift, 0.0);
    webVRUniforms.hmdWarpParam = HMD.distortionK;
    webVRUniforms.chromAbParam = HMD.chromaAbParameter;
    webVRUniforms.scaleIn = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(1.0, 1.0 / aspect);
    webVRUniforms.scale = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(1.0 / distScale, 1.0 * aspect / distScale);
};

var getWebVRShader = function() {
    var fragmentshader = [
        '',
        '#ifdef GL_ES',
        'precision highp float;',
        '#endif',

        'uniform vec2 uScale;',
        'uniform vec2 uScaleIn;',
        'uniform vec2 uLensCenter;',
        'uniform vec4 uHmdWarpParam;',
        'uniform vec4 uChromAbParam;',
        'uniform sampler2D Texture0;',

        'varying vec2 vTexCoord0;',

        // from http://paradise.untergrund.net/tmp/demoshit/examples/js/effects/OculusRiftEffect.js
        'void main(void) {',
        '  vec2 uv = (vTexCoord0 * 2.0) - 1.0;', // range from [0,1] to [-1,1]
        '  vec2 theta = (uv - uLensCenter) * uScaleIn;',
        '  float rSq = theta.x * theta.x + theta.y * theta.y;',
        '  vec2 rvector = theta * (uHmdWarpParam.x + uHmdWarpParam.y * rSq + uHmdWarpParam.z * rSq * rSq + uHmdWarpParam.w * rSq * rSq * rSq);',
        '  vec2 rBlue = rvector * (uChromAbParam.z + uChromAbParam.w * rSq);',
        '  vec2 tcBlue = (uLensCenter + uScale * rBlue);',
        '  tcBlue = (tcBlue + 1.0) * 0.5;', // range from [-1,1] to [0,1]
        '  if (any(bvec2(clamp(tcBlue, vec2(0.0, 0.0), vec2(1.0, 1.0)) - tcBlue))) {',
        '    gl_FragColor = vec4(0.0, 0.0, 0.0, 1.0);',
        '    return;',
        '  }',
        '  vec2 tcGreen = uLensCenter + uScale * rvector;',
        '  tcGreen = (tcGreen + 1.0) * 0.5;', // range from [-1,1] to [0,1]
        '  vec2 rRed = rvector * (uChromAbParam.x + uChromAbParam.y * rSq);',
        '  vec2 tcRed = uLensCenter + uScale * rRed;',
        '  tcRed = (tcRed + 1.0) * 0.5;', // range from [-1,1] to [0,1]
        '  gl_FragColor = vec4(texture2D(Texture0, tcRed).r, texture2D(Texture0, tcGreen).g, texture2D(Texture0, tcBlue).b, 1);',
        '}',
        ''
    ].join('\n');

    return new __WEBPACK_IMPORTED_MODULE_4_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */](
            __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */].VERTEX_SHADER,
            [
                'attribute vec3 Vertex;',
                'varying vec2 vTexCoord0;',
                'void main(void) {',
                '  gl_Position = vec4(Vertex * 2.0 - 1.0, 1.0);',
                '  vTexCoord0 = Vertex.xy;',
                '}',
                '',
                '#define SHADER_NAME VRpostProcessing',
                ''
            ].join('\n')
        ),
        new __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentshader)
    );
};

var createTextureRtt = function(rttSize) {
    var rttTexture = new __WEBPACK_IMPORTED_MODULE_7_osg_Texture__["default"]();
    rttTexture.setTextureSize(rttSize[0], rttSize[1]);
    rttTexture.setMinFilter('LINEAR');
    rttTexture.setMagFilter('LINEAR');
    return rttTexture;
};

var createOrthoRtt = function(left, viewportSize, canvasSize, cardboard, texture, webVRUniforms) {
    var orthoCamera = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
    var vw = viewportSize[0];
    var vh = viewportSize[1];
    var cw = canvasSize[0];
    var ch = canvasSize[1];
    if (cardboard === true) {
        if (left) orthoCamera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0.0, 0.0, cw / 2.0, ch));
        else orthoCamera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](cw / 2.0, 0.0, cw / 2.0, ch));
    } else {
        if (left) orthoCamera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0.5 * cw - vw, 0.5 * (ch - vh), vw, vh));
        else orthoCamera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0.5 * cw, 0.5 * (ch - vh), vw, vh));
    }
    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].ortho(orthoCamera.getProjectionMatrix(), -0.5, 0.5, -0.5, 0.5, -5, 5);
    orthoCamera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].NESTED_RENDER, 0);
    orthoCamera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */].ABSOLUTE_RF);

    var stateSet = orthoCamera.getOrCreateStateSet();
    stateSet.setTextureAttributeAndModes(0, texture);
    stateSet.setAttributeAndModes(getWebVRShader());
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat2(webVRUniforms.scale, 'uScale'));
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat2(webVRUniforms.scaleIn, 'uScaleIn'));
    stateSet.addUniform(
        __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat2(
            left ? webVRUniforms.lensCenterLeft : webVRUniforms.lensCenterRight,
            'uLensCenter'
        )
    );
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat4(webVRUniforms.hmdWarpParam, 'uHmdWarpParam'));
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat4(webVRUniforms.chromAbParam, 'uChromAbParam'));

    return orthoCamera;
};

var createCameraRtt = function(texture, projMatrix) {
    var camera = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
    camera.setName('rtt camera');
    camera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0, 0, texture.getWidth(), texture.getHeight()));
    camera.setProjectionMatrix(projMatrix);
    camera.setClearColor(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.3, 0.3, 0.3, 0.0));
    camera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].POST_RENDER, 0);
    camera.attachTexture(__WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0, texture);
    camera.attachRenderBuffer(
        __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].DEPTH_ATTACHMENT,
        __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].DEPTH_COMPONENT16
    );
    camera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */].ABSOLUTE_RF);
    return camera;
};

WebVRCustom.createScene = function(viewer, rttScene, HMDconfig, rootOverride, worldFactorOverride) {
    var HMD = WebVRCustom.getDefaultConfig(HMDconfig);
    var rttSize = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(HMD.hResolution * 0.5, HMD.vResolution);
    var viewportSize = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(HMD.hResolution * 0.5, HMD.vResolution);
    var vp = viewer.getCamera().getViewport();
    var canvasSize = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["e" /* vec2 */].fromValues(vp.width(), vp.height());

    var canvas = viewer.getGraphicContext().canvas;
    if (HMD.isCardboard) {
        canvasSize[0] = canvas.width;
        canvasSize[1] = canvas.height;
    }

    var worldFactor = worldFactorOverride !== undefined ? worldFactorOverride : 1.0;
    var webVRUniforms = {};
    var webVRMatrices = {};
    setupWebVR(worldFactor, HMD, webVRUniforms, webVRMatrices);

    var rootViewMatrix = viewer.getCamera().getViewMatrix();

    var root = rootOverride || new __WEBPACK_IMPORTED_MODULE_3_osg_Node__["a" /* default */]();
    root.addUpdateCallback(new UpdateRecreateOnResize(viewer, rttScene, HMDconfig, root, canvas));

    var rttTextureLeft = createTextureRtt(rttSize);
    var rttCamLeft = createCameraRtt(rttTextureLeft, webVRMatrices.projectionLeft);
    var orthoCameraLeft = createOrthoRtt(
        true,
        viewportSize,
        canvasSize,
        HMD.isCardboard,
        rttTextureLeft,
        webVRUniforms
    );
    rttCamLeft.addUpdateCallback(new UpdateOffsetCamera(rootViewMatrix, webVRMatrices.viewLeft));

    var rttTextureRight = createTextureRtt(rttSize);
    var rttCamRight = createCameraRtt(rttTextureRight, webVRMatrices.projectionRight);
    var orthoCameraRight = createOrthoRtt(
        false,
        viewportSize,
        canvasSize,
        HMD.isCardboard,
        rttTextureRight,
        webVRUniforms
    );
    rttCamRight.addUpdateCallback(new UpdateOffsetCamera(rootViewMatrix, webVRMatrices.viewRight));

    rttCamLeft.addChild(rttScene);
    rttCamRight.addChild(rttScene);

    orthoCameraLeft.addChild(__WEBPACK_IMPORTED_MODULE_6_osg_shape__["a" /* default */].createTexturedFullScreenFakeQuadGeometry());
    orthoCameraRight.addChild(__WEBPACK_IMPORTED_MODULE_6_osg_shape__["a" /* default */].createTexturedFullScreenFakeQuadGeometry());

    root.addChild(rttCamLeft);
    root.addChild(rttCamRight);

    root.addChild(orthoCameraLeft);
    root.addChild(orthoCameraRight);

    return root;
};

WebVRCustom.getDefaultConfig = function(hmdConfig) {
    // FOV: 103.506416
    // vScreenCenter: 0.03645

    // Oculus Rift DK2
    var hmd = {
        hResolution: 1920,
        vResolution: 1080,
        hScreenSize: 0.1296,
        vScreenSize: 0.0729,
        interpupillaryDistance: 0.064,
        lensSeparationDistance: 0.0635,
        eyeToScreenDistance: 0.04,
        distortionK: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.22, 0.13, 0.02),
        chromaAbParameter: __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.996, -0.004, 1.014, 0.0),
        isCardboard: false
    };

    if (hmdConfig === 2 || hmdConfig === undefined) return hmd;

    if (hmdConfig === 1) {
        // Oculus Rift DK1
        hmd.hResolution = 1280;
        hmd.vResolution = 800;
        hmd.hScreenSize = 0.14976;
        hmd.vScreenSize = 0.0936;
        hmd.lensSeparationDistance = 0.064;
        hmd.eyeToScreenDistance = 0.041;
        hmd.distortionK = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 0.22, 0.24, 0.0);
        return hmd;
    }

    // custom param
    if (hmdConfig.hResolution !== undefined) hmd.hResolution = hmdConfig.hResolution;
    if (hmdConfig.vResolution !== undefined) hmd.vResolution = hmdConfig.vResolution;
    if (hmdConfig.hScreenSize !== undefined) hmd.hScreenSize = hmdConfig.hScreenSize;
    if (hmdConfig.vScreenSize !== undefined) hmd.vScreenSize = hmdConfig.vScreenSize;
    if (hmdConfig.interpupillaryDistance !== undefined)
        hmd.interpupillaryDistance = hmdConfig.interpupillaryDistance;
    if (hmdConfig.lensSeparationDistance !== undefined)
        hmd.lensSeparationDistance = hmdConfig.lensSeparationDistance;
    if (hmdConfig.eyeToScreenDistance !== undefined)
        hmd.eyeToScreenDistance = hmdConfig.eyeToScreenDistance;
    if (hmdConfig.distortionK !== undefined) hmd.distortionK = hmdConfig.distortionK;
    if (hmdConfig.chromaAbParameter !== undefined)
        hmd.chromaAbParameter = hmdConfig.chromaAbParameter;
    if (hmdConfig.isCardboard !== undefined) hmd.isCardboard = hmdConfig.isCardboard;

    return hmd;
};

/* harmony default export */ __webpack_exports__["a"] = (WebVRCustom);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_shape__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_Transform__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__ = __webpack_require__(36);














var UpdateRttCameraCallback = function(rootView, offsetView) {
    this._rootView = rootView;
    this._offsetView = offsetView;
};

UpdateRttCameraCallback.prototype = {
    update: function(node /*, nv */) {
        var nodeView = node.getViewMatrix();
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].mul(nodeView, this._offsetView, this._rootView);
        return true;
    }
};

var createTexture = function(size) {
    var texture = new __WEBPACK_IMPORTED_MODULE_7_osg_Texture__["default"]();
    texture.setTextureSize(size.width, size.height);
    texture.setMinFilter('LINEAR');
    texture.setMagFilter('LINEAR');
    return texture;
};

var getAssembleShader = function() {
    var fragmentShader = [
        '#ifdef GL_ES',
        '   precision highp float;',
        '#endif',
        'varying vec2 vTexCoord0;',
        'uniform sampler2D TextureLeft;',
        'uniform sampler2D TextureRight;',

        'void main() {',
        '   if (vTexCoord0.x < 0.5)',
        '       gl_FragColor = texture2D(TextureLeft, vec2(vTexCoord0.x * 2.0, vTexCoord0.y));',
        '   else',
        '       gl_FragColor = texture2D(TextureRight, vec2(vTexCoord0.x * 2.0 - 1.0, vTexCoord0.y));',
        '}'
    ].join('\n');

    return new __WEBPACK_IMPORTED_MODULE_4_osg_Program__["a" /* default */](
        new __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */](
            __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */].VERTEX_SHADER,
            [
                'attribute vec3 Vertex;',
                'varying vec2 vTexCoord0;',
                'void main(void) {',
                '  gl_Position = vec4(Vertex * 2.0 - 1.0, 1.0);',
                '  vTexCoord0 = Vertex.xy;',
                '}',
                '',
                '#define SHADER_NAME VRpostProcessing',
                ''
            ].join('\n')
        ),
        new __WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_Shader__["a" /* default */].FRAGMENT_SHADER, fragmentShader)
    );
};

// This camera will render both textures on the canvas in a single pass
var createCameraCanvas = function(leftEyeTexture, rightEyeTexture, viewport) {
    var orthoCamera = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
    orthoCamera.setViewport(viewport);
    orthoCamera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].NESTED_RENDER, 0);
    orthoCamera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */].ABSOLUTE_RF);
    __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].ortho(orthoCamera.getProjectionMatrix(), 0.0, 1.0, 0.0, 1.0, -5.0, 5.0);

    var stateSet = orthoCamera.getOrCreateStateSet();
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createInt(0, 'TextureLeft'));
    stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createInt(1, 'TextureRight'));
    stateSet.setTextureAttributeAndModes(0, leftEyeTexture);
    stateSet.setTextureAttributeAndModes(1, rightEyeTexture);
    stateSet.setAttributeAndModes(getAssembleShader());

    orthoCamera.addChild(__WEBPACK_IMPORTED_MODULE_6_osg_shape__["a" /* default */].createTexturedFullScreenFakeQuadGeometry());

    return orthoCamera;
};

// This camera will render the scene on a texture for an eye
var createCameraRtt = function(texture, projection) {
    var camera = new __WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */]();
    camera.setName('rtt camera');
    camera.setViewport(new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */](0.0, 0.0, texture.getWidth(), texture.getHeight()));
    camera.setProjectionMatrix(projection);
    camera.setClearColor(__WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["g" /* vec4 */].fromValues(0.3, 0.3, 0.3, 0.0));
    camera.setRenderOrder(__WEBPACK_IMPORTED_MODULE_0_osg_Camera__["a" /* default */].POST_RENDER, 0);
    camera.attachTexture(__WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0, texture);
    camera.attachRenderBuffer(
        __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].DEPTH_ATTACHMENT,
        __WEBPACK_IMPORTED_MODULE_1_osg_FrameBufferObject__["a" /* default */].DEPTH_COMPONENT16
    );
    camera.setReferenceFrame(__WEBPACK_IMPORTED_MODULE_8_osg_Transform__["a" /* default */].ABSOLUTE_RF);
    return camera;
};

var WebVR = {};

WebVR.createScene = function(viewer, rttScene, HMDdevice, rootOverride, worldFactorOverride) {
    var root = rootOverride || new __WEBPACK_IMPORTED_MODULE_3_osg_Node__["a" /* default */]();
    var worldFactor = worldFactorOverride !== undefined ? worldFactorOverride : 1.0;

    var left = HMDdevice.getEyeParameters('left');
    var right = HMDdevice.getEyeParameters('right');

    var frameData = new window.VRFrameData();
    HMDdevice.getFrameData(frameData);

    // Compute projections and view matrices for both eyes
    var viewLeft = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create(),
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(-worldFactor * left.offset[0], left.offset[1], left.offset[2])
    );
    var viewRight = __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].fromTranslation(
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["c" /* mat4 */].create(),
        __WEBPACK_IMPORTED_MODULE_2_osg_glMatrix__["f" /* vec3 */].fromValues(-worldFactor * right.offset[0], right.offset[1], right.offset[2])
    );

    // Each eye is rendered on a texture whose width is half of the final combined texture
    var eyeTextureSize = {
        width: Math.max(left.renderWidth, right.renderWidth),
        height: Math.max(left.renderHeight, right.renderHeight)
    };

    var leftEyeTexture = createTexture(eyeTextureSize);
    var rightEyeTexture = createTexture(eyeTextureSize);

    // Setup the render cameras for both eyes
    var camRttLeft = createCameraRtt(leftEyeTexture, frameData.leftProjectionMatrix);
    var camRttRight = createCameraRtt(rightEyeTexture, frameData.rightProjectionMatrix);

    // The viewMatrix of each eye is updated with the current viewer's camera viewMatrix
    var rootViewMatrix = viewer.getCamera().getViewMatrix();
    camRttLeft.addUpdateCallback(new UpdateRttCameraCallback(rootViewMatrix, viewLeft));
    camRttRight.addUpdateCallback(new UpdateRttCameraCallback(rootViewMatrix, viewRight));

    // Render both textures on the canvas, using the viewer's camera viewport to render on the fullscreen canvas
    var camCanvas = createCameraCanvas(
        leftEyeTexture,
        rightEyeTexture,
        viewer.getCamera().getViewport()
    );

    camRttLeft.addChild(rttScene);
    camRttRight.addChild(rttScene);

    root.addChild(camRttLeft);
    root.addChild(camRttRight);
    root.addChild(camCanvas);

    return root;
};

/* harmony default export */ __webpack_exports__["a"] = (WebVR);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgViewer_Renderer__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgViewer_View__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgViewer_Viewer__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgViewer_eventProxy_eventProxy__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgViewer_Scene__ = __webpack_require__(159);






var osgViewer = {};

osgViewer.Renderer = __WEBPACK_IMPORTED_MODULE_0_osgViewer_Renderer__["default"];
osgViewer.View = __WEBPACK_IMPORTED_MODULE_1_osgViewer_View__["default"];
osgViewer.Viewer = __WEBPACK_IMPORTED_MODULE_2_osgViewer_Viewer__["a" /* default */];
osgViewer.EventProxy = __WEBPACK_IMPORTED_MODULE_3_osgViewer_eventProxy_eventProxy__["a" /* default */];
osgViewer.Scene = __WEBPACK_IMPORTED_MODULE_4_osgViewer_Scene__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgViewer);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Options__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Timer__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_TimerGPU__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_UpdateVisitor__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_GLObject__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_VertexArrayObject__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osg_Shader__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_Program__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osgGA_OrbitManipulator__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osgViewer_eventProxy_eventProxy__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osgViewer_View__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osgViewer_webgl_utils__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osgViewer_webgl_debug__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osgStats_Stats__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osgStats_defaultStats__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osgStats_glStats__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_osgStats_browserStats__ = __webpack_require__(168);


























var Viewer = function(canvas, userOptions, error) {
    __WEBPACK_IMPORTED_MODULE_17_osgViewer_View__["default"].call(this);

    this._startTick = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick();
    this._stats = undefined;
    this._done = false;

    // keep reference so that you still have it
    // when gl context is lost
    this._canvas = canvas;

    var options = this.initOptions(userOptions);
    var gl = this.initWebGLContext(canvas, options, error);

    if (!gl) throw 'No WebGL implementation found';

    this.initDeviceEvents(options, canvas);
    this._updateVisitor = new __WEBPACK_IMPORTED_MODULE_6_osg_UpdateVisitor__["a" /* default */]();

    this.setUpView(gl.canvas, options);
    this.initStats(options, canvas);

    this._hmd = null;
    this._requestAnimationFrame = window.requestAnimationFrame.bind(window);
    this._options = options;
    this._contextLost = false;
    this._forceRestoreContext = true;
    this.renderBinded = this.render.bind(this);
};

__WEBPACK_IMPORTED_MODULE_7_osg_utils__["a" /* default */].createPrototypeObject(
    Viewer,
    __WEBPACK_IMPORTED_MODULE_7_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_17_osgViewer_View__["default"].prototype, {
        initDeviceEvents: function(options, canvas) {
            // default argument for mouse binding
            var defaultMouseEventNode = options.mouseEventNode || canvas;

            var eventsBackend = options.EventBackend || {};
            if (!options.EventBackend) options.EventBackend = eventsBackend;
            eventsBackend.StandardMouseKeyboard = options.EventBackend.StandardMouseKeyboard || {};
            var mouseEventNode =
                eventsBackend.StandardMouseKeyboard.mouseEventNode || defaultMouseEventNode;
            eventsBackend.StandardMouseKeyboard.mouseEventNode = mouseEventNode;
            eventsBackend.StandardMouseKeyboard.keyboardEventNode =
                eventsBackend.StandardMouseKeyboard.keyboardEventNode || document;

            // hammer, Only activate it if we have a touch device in order to fix problems with IE11
            if ('ontouchstart' in window) {
                eventsBackend.Hammer = eventsBackend.Hammer || {};
                eventsBackend.Hammer.eventNode =
                    eventsBackend.Hammer.eventNode || defaultMouseEventNode;
            }

            // gamepad
            eventsBackend.GamePad = eventsBackend.GamePad || {};

            this._eventProxy = this.initEventProxy(options);
        },

        initOptions: function(userOptions) {
            // use default options
            var options = new __WEBPACK_IMPORTED_MODULE_2_osg_Options__["a" /* default */]();

            if (userOptions) {
                // user options override by user options
                options.extend(userOptions);
            }

            // if url options override url options
            options.extendWithOptionsURL();

            // Activate global trace on log call
            if (options.getBoolean('traceLogCall') === true) __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].traceLogCall = true;

            // Check if Frustum culling is enabled to calculate the clip planes
            if (options.getBoolean('enableFrustumCulling') === true)
                this.getCamera()
                    .getRenderer()
                    .getCullVisitor()
                    .setEnableFrustumCulling(true);

            return options;
        },

        initWebGLContext: function(canvas, options, error) {
            // #FIXME see tojiro's blog for webgl lost context stuffs
            if (options.get('SimulateWebGLLostContext')) {
                canvas = __WEBPACK_IMPORTED_MODULE_19_osgViewer_webgl_debug__["a" /* default */].makeLostContextSimulatingCanvas(canvas);
                canvas.loseContextInNCalls(options.get('SimulateWebGLLostContext'));
                this._canvas = canvas;
            }

            var gl = __WEBPACK_IMPORTED_MODULE_18_osgViewer_webgl_utils__["a" /* default */].setupWebGL(canvas, options, error);

            //www.khronos.org/registry/webgl/specs/latest/1.0/#WEBGLCONTEXTEVENT
            canvas.addEventListener(
                'webglcontextlost',
                function(event) {
                    this.contextLost();
                    if (this._forceRestoreContext !== false) {
                        event.preventDefault();
                    }
                }.bind(this),
                false
            );

            canvas.addEventListener(
                'webglcontextrestored',
                function() {
                    this.contextRestored();
                }.bind(this),
                false
            );

            if (__WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].reportWebGLError || options.get('reportWebGLError')) {
                gl = __WEBPACK_IMPORTED_MODULE_19_osgViewer_webgl_debug__["a" /* default */].makeDebugContext(gl);
            }

            this.initWebGLCaps(gl);
            this.setGraphicContext(gl);

            return gl;
        },

        // allow user to acknowledge the context lost
        // (display a message, etc.)
        // - callback return false: no attempt to restore
        setContextLostCallback: function(callback) {
            this._contextLostCallback = callback;
            // just in case callback registration
            // happens after the context lost
            if (this._contextLost) {
                this._forceRestoreContext = callback();
            }
        },

        setContextRestoreCallback: function(callback) {
            this._contextRestoreCallback = callback;
        },

        contextLost: function() {
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('webgl context lost');
            if (this._contextLostCallback) {
                this._forceRestoreContext = this._contextLostCallback();
            }
            this._contextLost = true;
            window.cancelAnimationFrame(this._requestID);
        },

        contextRestored: function() {
            if (this._forceRestoreContext === false) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('webgl context restore not supported - please reload the page - ');
                return;
            }
            // restore is already async
            // https://www.khronos.org/registry/webgl/specs/latest/1.0/#5.15.2
            this.restoreContext();
            __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('webgl context restored');
        },

        restoreContext: function() {
            var gl = this.getGraphicContext();

            __WEBPACK_IMPORTED_MODULE_12_osg_Shader__["a" /* default */].onLostContext(gl);
            __WEBPACK_IMPORTED_MODULE_13_osg_Program__["a" /* default */].onLostContext(gl);
            __WEBPACK_IMPORTED_MODULE_10_osg_BufferArray__["a" /* default */].onLostContext(gl);
            __WEBPACK_IMPORTED_MODULE_11_osg_VertexArrayObject__["a" /* default */].onLostContext(gl);
            __WEBPACK_IMPORTED_MODULE_9_osg_FrameBufferObject__["a" /* default */].onLostContext(gl);
            __WEBPACK_IMPORTED_MODULE_14_osg_Texture__["default"].getTextureManager(gl).onLostContext(gl);

            __WEBPACK_IMPORTED_MODULE_8_osg_GLObject__["a" /* default */].onLostContext(gl);

            this.getCamera()
                .getRenderer()
                .getState()
                .resetCaches();

            // if it's a different GPU, different webglcaps
            this.initWebGLCaps(gl, true);
            this.setGraphicContext(gl);

            // different GPU caps means different timer caps
            __WEBPACK_IMPORTED_MODULE_5_osg_TimerGPU__["a" /* default */].instance(this.getGraphicContext(), true);
            if (this._stats) {
                // stats geometries needs special care
                this._stats.reset();
            }

            // ready to draw again
            this._contextLost = false;
            this._requestRedraw = true;

            // Warn users context has been restored
            if (this._contextRestoreCallback) {
                this._contextRestoreCallback(gl);
            }
            this._runImplementation();
        },

        init: function() {
            //this._done = false;
        },

        getUpdateVisitor: function() {
            return this._updateVisitor;
        },

        getState: function() {
            return this.getCamera()
                .getRenderer()
                .getState();
        },

        initStats: function(options) {
            var timerGPU = __WEBPACK_IMPORTED_MODULE_5_osg_TimerGPU__["a" /* default */].instance(this.getGraphicContext());

            if (!options.getBoolean('stats')) {
                timerGPU.disable();
                return;
            }

            this._stats = new __WEBPACK_IMPORTED_MODULE_20_osgStats_Stats__["a" /* default */](this, options);
            this._stats.addConfig(__WEBPACK_IMPORTED_MODULE_21_osgStats_defaultStats__["a" /* default */]);
            this._stats.addConfig(__WEBPACK_IMPORTED_MODULE_22_osgStats_glStats__["a" /* default */]);
            this._stats.addConfig(__WEBPACK_IMPORTED_MODULE_23_osgStats_browserStats__["a" /* default */]);

            this.getCamera().addChild(this._stats.getNode());

            timerGPU.setCallback(this.callbackTimerGPU.bind(this));
        },

        callbackTimerGPU: function(average, queryID) {
            if (this._stats) this._stats.getCounter(queryID).set(average / 1e6);
        },

        getViewerStats: function() {
            return this._stats;
        },

        renderingTraversal: function() {
            this.getState()._frameStamp = this._frameStamp;

            if (this.getScene().getSceneData())
                this.getScene()
                    .getSceneData()
                    .getBound();

            if (this.getCamera()) {
                var stats = this._stats;
                var timerGPU = __WEBPACK_IMPORTED_MODULE_5_osg_TimerGPU__["a" /* default */].instance(this.getGraphicContext());

                var renderer = this.getCamera().getRenderer();

                if (stats) stats.getCounter('cull').start();

                renderer.cull();

                if (stats) stats.getCounter('cull').end();

                timerGPU.pollQueries();
                timerGPU.start('glframe');

                if (stats) {
                    stats.getCounter('render').start();
                }

                renderer.draw();

                if (stats) {
                    stats.getCounter('render').end();
                }

                timerGPU.end('glframe');

                if (stats) {
                    var cullVisitor = renderer.getCullVisitor();
                    stats.getCounter('cullcamera').set(cullVisitor._numCamera);
                    stats.getCounter('cullmatrixtransform').set(cullVisitor._numMatrixTransform);
                    stats.getCounter('cullprojection').set(cullVisitor._numProjection);
                    stats.getCounter('cullnode').set(cullVisitor._numNode);
                    stats.getCounter('culllightsource').set(cullVisitor._numLightSource);
                    stats.getCounter('cullgeometry').set(cullVisitor._numGeometry);

                    stats.getCounter('pushstateset').set(renderer.getState()._numPushStateSet);

                    stats.getCounter('applyStateSet').set(renderer.getState()._numApply);
                }
            }
        },

        updateTraversal: function() {
            var stats = this._stats;

            if (stats) stats.getCounter('update').start();

            // update the scene
            this._updateVisitor.resetStats();
            this.getScene().updateSceneGraph(this._updateVisitor);

            if (stats)
                stats.getCounter('updatecallback').set(this._updateVisitor._numUpdateCallback);

            // Remove ExpiredSubgraphs from DatabasePager
            this.getDatabasePager().releaseGLExpiredSubgraphs(0.005);
            // In OSG this.is deferred until the draw traversal, to handle multiple contexts
            this.flushDeletedGLObjects(0.005);

            if (stats) stats.getCounter('update').end();
        },

        advance: function(simulationTime) {
            var sTime = simulationTime;

            if (sTime === undefined) sTime = Number.MAX_VALUE;

            var frameStamp = this._frameStamp;
            var previousFrameNumber = frameStamp.getFrameNumber();

            frameStamp.setFrameNumber(previousFrameNumber + 1);

            var deltaS = __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().deltaS(this._startTick, __WEBPACK_IMPORTED_MODULE_4_osg_Timer__["a" /* default */].instance().tick());
            frameStamp.setReferenceTime(deltaS);

            var lastSimulationTime = frameStamp.getSimulationTime();
            frameStamp.setSimulationTime(sTime === Number.MAX_VALUE ? deltaS : sTime); // set simul time
            frameStamp.setDeltaTime(frameStamp.getSimulationTime() - lastSimulationTime); // compute delta since last tick
        },

        beginFrame: function() {
            var stats = this._stats;

            if (stats) {
                stats.getCounter('frame').start();

                stats.getCounter('raf').tick();
                stats.getCounter('fps').frame();
            }
        },

        endFrame: function() {
            var frameNumber = this.getFrameStamp().getFrameNumber();

            // update texture stats
            if (this._stats) {
                __WEBPACK_IMPORTED_MODULE_14_osg_Texture__["default"].getTextureManager(this.getGraphicContext()).updateStats(
                    frameNumber,
                    this._stats
                );

                this._stats.getCounter('stats').start();
                this._stats.update();
                this._stats.getCounter('stats').end();

                this._stats.getCounter('frame').end();
            }
        },

        checkNeedToDoFrame: function() {
            return this._requestContinousUpdate || this._requestRedraw;
        },

        frame: function() {
            // _contextLost check for code calling viewer::frame directly
            // (likely force preload gl resource or direct render control )
            if (this._contextLost) return;

            this.beginFrame();

            this.advance();

            // update viewport if a resize occured
            var canvasSizeChanged = this.updateViewport();

            // update inputs devices
            this.updateEventProxy(this._eventProxy, this.getFrameStamp());

            // setup framestamp
            this._updateVisitor.setFrameStamp(this.getFrameStamp());
            // Update Manipulator/Event
            if (this.getManipulator()) {
                this.getManipulator().update(this._updateVisitor);
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].copy(
                    this.getCamera().getViewMatrix(),
                    this.getManipulator().getInverseMatrix()
                );
            }

            if (this.checkNeedToDoFrame() || canvasSizeChanged) {
                this._requestRedraw = false;
                this.updateTraversal();
                this.renderingTraversal();
            }

            this.endFrame();

            // submit frame to vr headset
            if (this._hmd && this._hmd.isPresenting) this._hmd.submitFrame();
        },

        setDone: function(bool) {
            this._done = bool;
        },

        done: function() {
            return this._done;
        },

        render: function() {
            if (!this.done()) {
                this._requestID = this._requestAnimationFrame(this.renderBinded, this._canvas);
                this.frame();
            }
        },

        _runImplementation: function() {
            this.render();
        },

        run: function() {
            this._runImplementation();
        },

        setVRDisplay: function(hmd) {
            this._hmd = hmd;
        },

        getVRDisplay: function() {
            return this._hmd;
        },

        setPresentVR: function(doPresentVR) {
            if (!this._hmd) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('no hmd device provided to the viewer!');
                return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.reject();
            }

            if (!this._hmd.capabilities.canPresent) return __WEBPACK_IMPORTED_MODULE_3_bluebird___default.a.reject();

            if (doPresentVR) {
                // spec is not clear if it should be done after the requestPresent promise or before
                this._requestAnimationFrame = this._hmd.requestAnimationFrame.bind(this._hmd);

                var layers = [
                    {
                        source: this.getGraphicContext().canvas
                    }
                ];
                return this._hmd.requestPresent(layers);
            } else {
                this._requestAnimationFrame = window.requestAnimationFrame.bind(window);
                return this._hmd.exitPresent();
            }
        },

        setupManipulator: function(manipulator /*, dontBindDefaultEvent */) {
            if (manipulator === undefined) {
                manipulator = new __WEBPACK_IMPORTED_MODULE_15_osgGA_OrbitManipulator__["a" /* default */]();
            }

            if (manipulator.setNode !== undefined) {
                manipulator.setNode(this.getSceneData());
            } else {
                // for backward compatibility
                manipulator.view = this;
            }

            manipulator.setCamera(this.getCamera());
            this.setManipulator(manipulator);
        },

        // updateViewport
        updateViewport: function() {
            var gl = this.getGraphicContext();
            var canvas = gl.canvas;

            var hasChanged = this.computeCanvasSize(canvas);
            if (!hasChanged) return false;

            var camera = this.getCamera();
            var vp = camera.getViewport();

            var prevWidth = vp.width();
            var prevHeight = vp.height();

            var widthChangeRatio = canvas.width / prevWidth;
            var heightChangeRatio = canvas.height / prevHeight;
            var aspectRatioChange = widthChangeRatio / heightChangeRatio;
            vp.setViewport(
                Math.round(vp.x() * widthChangeRatio),
                Math.round(vp.y() * heightChangeRatio),
                Math.round(vp.width() * widthChangeRatio),
                Math.round(vp.height() * heightChangeRatio)
            );

            if (aspectRatioChange !== 1.0) {
                __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].mul(
                    camera.getProjectionMatrix(),
                    camera.getProjectionMatrix(),
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].fromScaling(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create(), [1.0 / aspectRatioChange, 1.0, 1.0])
                );
            }

            return true;
        },

        // intialize all input devices
        initEventProxy: function(argsObject) {
            var args = argsObject || {};
            var deviceEnabled = {};

            var lists = __WEBPACK_IMPORTED_MODULE_16_osgViewer_eventProxy_eventProxy__["a" /* default */];
            var argumentEventBackend = args.EventBackend;

            // loop on each devices and try to initialize it
            for (var device in lists) {
                // check if the config has a require
                var initialize = true;
                var argDevice = {};
                if (argumentEventBackend && argumentEventBackend[device] !== undefined) {
                    var bool = argumentEventBackend[device].enable;
                    initialize = bool !== undefined ? bool : true;
                    argDevice = argumentEventBackend[device];
                }

                // extend argDevice with regular options eg:
                // var options = {
                //     EventBackend: {
                //         Hammer: {
                //             drag_max_touches: 4,
                //             transform_min_scale: 0.08,
                //             transform_min_rotation: 180,
                //             transform_always_block: true
                //         }
                //     },
                //     zoomscroll: false
                // };

                // to options merged:
                // var options = {
                //     drag_max_touches: 4,
                //     transform_min_scale: 0.08,
                //     transform_min_rotation: 180,
                //     transform_always_block: true,
                //     zoomscroll: false
                // };
                //
                var options = new __WEBPACK_IMPORTED_MODULE_2_osg_Options__["a" /* default */]();
                options.extend(argDevice).extend(argsObject);
                delete options.EventBackend;

                if (initialize) {
                    var inputDevice = new lists[device](this);
                    inputDevice.init(options);
                    deviceEnabled[device] = inputDevice;
                }
            }
            return deviceEnabled;
        },
        updateEventProxy: function(list, frameStamp) {
            for (var key in list) {
                var device = list[key];
                if (device.update) device.update(frameStamp);
            }
        },

        setManipulator: function(manipulator) {
            if (this._manipulator) this.removeEventProxy();

            if (!manipulator.getCamera()) manipulator.setCamera(this.getCamera());

            __WEBPACK_IMPORTED_MODULE_17_osgViewer_View__["default"].prototype.setManipulator.call(this, manipulator);
        },

        setEnableManipulator: function(bool) {
            if (!this._manipulator) return;

            var controllerMap = this._manipulator.getControllerList();
            for (var name in controllerMap) {
                controllerMap[name].setEnable(bool);
            }
        },

        removeEventProxy: function() {
            var list = this._eventProxy;
            for (var key in list) {
                var device = list[key];
                if (device.remove) device.remove();
            }
        },

        getEventProxy: function() {
            return this._eventProxy;
        }
    }),
    'osgViewer',
    'Viewer'
);

/* harmony default export */ __webpack_exports__["a"] = (Viewer);


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);


var GamePad = function(viewer) {
    this._viewer = viewer;
    this._type = 'GamePad';
    this._enable = true;
    this._gamepadIndex = -1;
};

GamePad.prototype = {
    setEnable: function(bool) {
        this._enable = bool;
    },

    getEnable: function() {
        return this._enable;
    },

    init: function(/*args*/) {},

    isValid: function() {
        if (!this._enable) return false;

        var manipulator = this._viewer.getManipulator();
        if (!manipulator) return false;

        var controller = manipulator.getControllerList()[this._type];
        if (!controller || !controller.isEnabled()) return false;

        return true;
    },

    getManipulatorController: function() {
        return this._viewer.getManipulator().getControllerList()[this._type];
    },

    gamepadPoll: function() {
        if (!navigator.getGamepads) return null;
        var gamepads = navigator.getGamepads();
        var gamepad = gamepads[this._gamepadIndex];
        if (gamepad) return gamepad;

        for (var i = 0, nb = gamepads.length; i < nb; ++i) {
            var gm = gamepads[i];
            // https://code.google.com/p/chromium/issues/detail?id=413805
            if (gm && gm.id && gm.id.indexOf('Unknown Gamepad') === -1) {
                this._gamepadIndex = i;
                this.onGamepadConnect(gm);
                return gm;
            }
        }
        if (this._gamepadIndex >= 0) {
            this._gamepadIndex = -1;
            this.onGamepadConnect();
        }
        return null;
    },

    onGamepadConnect: function(gamepad) {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('Detected new gamepad!', gamepad);
    },

    onGamepadDisconnect: function() {
        __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('Gamepad disconnected');
    },

    // Called in each frame
    update: function() {
        // we poll instead

        if (!this.isValid()) return;

        var gamepad = this.gamepadPoll();
        if (!gamepad) return;

        var manipulatorAdapter = this.getManipulatorController();
        //manipulatorAdapter.setEventProxy(this);
        if (manipulatorAdapter.update) {
            manipulatorAdapter.update(gamepad);
        }
    }
};
/* harmony default export */ __webpack_exports__["a"] = (GamePad);


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammer__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hammer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hammer__);


var HammerController = function(viewer) {
    this._enable = true;
    this._viewer = viewer;
    this._type = 'Hammer';

    this._eventNode = undefined;
};

HammerController.prototype = {
    setEnable: function(bool) {
        this._enable = bool;
    },

    getEnable: function() {
        return this._enable;
    },

    getHammer: function() {
        return this._hammer;
    },

    init: function(options) {
        this._eventNode = options.eventNode;
        if (this._eventNode) {
            this._hammer = new __WEBPACK_IMPORTED_MODULE_0_hammer___default.a.Manager(this._eventNode);

            // defaults: { event: 'pan', pointers: 1, direction: Hammer.DIRECTION_HORIZONTAL, threshold: 10 }
            this._hammer.add(new __WEBPACK_IMPORTED_MODULE_0_hammer___default.a.Pan());

            if (options.getBoolean('scrollwheel')) {
                //defaults: { event: 'pinch', pointers: 2, threshold: 0 }
                this._hammer.add(new __WEBPACK_IMPORTED_MODULE_0_hammer___default.a.Pinch());
            }
        }
    },

    isValid: function() {
        if (!this._enable) return false;

        var manipulator = this._viewer.getManipulator();
        if (!manipulator) return false;

        var controller = manipulator.getControllerList()[this._type];
        if (!controller || !controller.isEnabled()) return false;

        return true;
    },

    getManipulatorController: function() {
        var manip = this._viewer.getManipulator();
        return manip && manip.getControllerList()[this._type];
    },

    // use the update to set the input device to mouse controller
    // it's needed to compute size
    update: function() {
        var isValid = this.isValid();
        var manip = this.getManipulatorController();
        if (manip) manip.setValid(isValid);

        if (!isValid) return;

        // we pass directly hammer object
        this.getManipulatorController().setEventProxy(this._hammer);
    },
    remove: function() {
        if (!this.isValid()) return;
        this.getManipulatorController().removeEventProxy(this._hammer);
    }
};
/* harmony default export */ __webpack_exports__["a"] = (HammerController);


/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);


var StandardMouseKeyboard = function(viewer) {
    this._enable = true;
    this._viewer = viewer;
    this._type = 'StandardMouseKeyboard';

    this._mouseEventNode = undefined;
    this._wheelEventNode = undefined;
    this._keyboardEventNode = undefined;
    this._eventList = ['mousedown', 'mouseup', 'mouseout', 'mousemove', 'dblclick'];
    this._mousePosition = __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["e" /* vec2 */].create();
    this._eventBinded = false;
};

StandardMouseKeyboard.prototype = {
    setEnable: function(bool) {
        this._enable = bool;
    },

    getEnable: function() {
        return this._enable;
    },

    init: function(options) {
        var mouse = options.mouseEventNode;

        var mousewheel = options.wheelEventNode || mouse;
        var keyboard = options.keyboardEventNode || mouse;

        if (options.getBoolean('scrollwheel') === false) {
            mousewheel = null;
        }

        this._mouseEventNode = mouse;
        this._wheelEventNode = mousewheel;
        this._keyboardEventNode = keyboard;

        // to remove listeners, you need the exact same callback
        this._callbacks = {
            mousedown: this.mousedown.bind(this),
            mouseup: this.mouseup.bind(this),
            mouseout: this.mouseout.bind(this),
            mousemove: this.mousemove.bind(this),
            dblclick: this.dblclick.bind(this),
            mousewheel: this.mousewheel.bind(this),
            preventDefault: this.preventDefault.bind(this),
            keydown: this.keydown.bind(this),
            keyup: this.keyup.bind(this)
        };
    },

    _addOrRemoveEventListeners: function(remove) {
        var callbacks = this._callbacks;
        var cb = remove ? 'removeEventListener' : 'addEventListener';
        var cbMouse = this._mouseEventNode && this._mouseEventNode[cb].bind(this._mouseEventNode);
        var cbMousewheel =
            this._wheelEventNode && this._wheelEventNode[cb].bind(this._wheelEventNode);
        var cbKeyboard =
            this._keyboardEventNode && this._keyboardEventNode[cb].bind(this._keyboardEventNode);

        if (cbMouse) {
            for (var i = 0, l = this._eventList.length; i < l; i++) {
                var ev = this._eventList[i];
                cbMouse(ev, callbacks[ev], false);
            }
        }

        if (cbMousewheel) {
            cbMousewheel('DOMMouseScroll', callbacks.mousewheel, false);
            cbMousewheel('mousewheel', callbacks.mousewheel, false);
            cbMousewheel('MozMousePixelScroll', callbacks.preventDefault, false);
        }

        if (cbKeyboard) {
            cbKeyboard('keydown', callbacks.keydown, false);
            cbKeyboard('keyup', callbacks.keyup, false);
        }
        this._eventBinded = !remove;
    },

    addEventListeners: function() {
        return this._addOrRemoveEventListeners(false);
    },

    removeEventListeners: function() {
        return this._addOrRemoveEventListeners(true);
    },

    isValid: function() {
        if (!this._enable) return false;

        var manipulator = this._viewer.getManipulator();
        if (!manipulator) return false;

        var controller = manipulator.getControllerList()[this._type];
        if (!controller || !controller.isEnabled()) return false;

        return true;
    },

    getManipulatorController: function() {
        return this._viewer.getManipulator().getControllerList()[this._type];
    },

    keyup: function(ev) {
        if (this.isValid() && this.getManipulatorController().keyup) {
            return this.getManipulatorController().keyup(ev);
        }

        return undefined;
    },

    keydown: function(ev) {
        if (this.isValid() && this.getManipulatorController().keydown) {
            return this.getManipulatorController().keydown(ev);
        }

        return undefined;
    },

    mousedown: function(ev) {
        if (this.isValid() && this.getManipulatorController().mousedown) {
            // prevent browser to enter in scroll mode
            if (ev.button === 1) ev.preventDefault();

            return this.getManipulatorController().mousedown(ev);
        }

        return undefined;
    },

    mouseup: function(ev) {
        if (this.isValid() && this.getManipulatorController().mouseup) {
            return this.getManipulatorController().mouseup(ev);
        }

        return undefined;
    },

    mouseout: function(ev) {
        if (this.isValid() && this.getManipulatorController().mouseout) {
            return this.getManipulatorController().mouseout(ev);
        }

        return undefined;
    },

    mousemove: function(ev) {
        if (this.isValid() && this.getManipulatorController().mousemove) {
            return this.getManipulatorController().mousemove(ev);
        }

        return undefined;
    },

    dblclick: function(ev) {
        if (this.isValid() && this.getManipulatorController().dblclick) {
            return this.getManipulatorController().dblclick(ev);
        }

        return undefined;
    },

    mousewheel: function(event) {
        if (!this.isValid()) {
            return undefined;
        }

        var manipulatorAdapter = this.getManipulatorController();

        if (!manipulatorAdapter.mousewheel) {
            return undefined;
        }

        event.preventDefault();

        // from jquery
        var orgEvent = event || window.event;
        var delta = 0;
        var deltaX = 0;
        var deltaY = 0;

        // Old school scrollwheel delta
        if (event.detail) delta = -event.detail / 3;
        else if (event.wheelDelta) delta = event.wheelDelta / 120;

        // New school multidimensional scroll (touchpads) deltas
        deltaY = delta;

        // Gecko
        if (orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
            deltaY = 0;
            deltaX = -1 * delta;
        }

        // Webkit
        if (orgEvent.wheelDeltaY !== undefined) deltaY = orgEvent.wheelDeltaY / 120;
        if (orgEvent.wheelDeltaX !== undefined) deltaX = -1 * orgEvent.wheelDeltaX / 120;

        return manipulatorAdapter.mousewheel(event, delta, deltaX, deltaY);
    },

    preventDefault: function(event) {
        event.preventDefault();
    },

    getPositionRelativeToCanvas: function(e, result) {
        result = result || this._mousePosition;
        result[0] = e.offsetX === undefined ? e.layerX : e.offsetX;
        result[1] = e.target.clientHeight - (e.offsetY === undefined ? e.layerY : e.offsetY);
        return result;
    },

    // use the update to set the input device to mouse controller
    // it's needed to compute size
    update: function() {
        if (!this.isValid()) {
            return;
        }

        this.getManipulatorController().setEventProxy(this);
        if (!this._eventBinded) this.addEventListeners();
    }
};
/* harmony default export */ __webpack_exports__["a"] = (StandardMouseKeyboard);


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgUtil_webvr_1_1__ = __webpack_require__(247);




 // polyfill

var WebVR = function(viewer) {
    this._viewer = viewer;

    this._type = 'WebVR';
    this._enable = false;
    this._hmd = undefined;
    this._sensor = undefined;

    this._frameData = undefined;
    this._quat = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["d" /* quat */].create();
    this._pos = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

    this._worldScale = 1.0;
};

WebVR.prototype = {
    setWorldScale: function(val) {
        this._worldScale = val;
    },

    setEnable: function(bool) {
        this._enable = bool;
    },

    getEnable: function() {
        return this._enable;
    },

    init: function() {
        if (!navigator.getVRDisplays) return;

        var self = this;
        navigator.getVRDisplays().then(function(displays) {
            if (displays.length > 0) {
                self._hmd = displays[0];
                self._frameData = new window.VRFrameData();
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].log('Found a VR display');
                // currently it's the event proxy webvr that has the responsability of detecting vr devices
                self._viewer.setVRDisplay(self._hmd);
            }
        });
    },

    getManipulatorController: function() {
        return this._viewer.getManipulator().getControllerList()[this._type];
    },

    isValid: function() {
        if (!this._enable) return false;

        var manipulator = this._viewer.getManipulator();
        if (!manipulator) return false;

        var controller = manipulator.getControllerList()[this._type];
        if (!controller || !controller.isEnabled()) return false;

        if (!this._hmd) return false;

        return true;
    },

    update: (function() {
        var tempQuat = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["d" /* quat */].create();
        var tempPos = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].create();

        return function() {
            if (!this.isValid()) return;

            var manipulatorAdapter = this.getManipulatorController();

            // update the manipulator with the rotation of the device
            if (!manipulatorAdapter.update) return;

            this._hmd.getFrameData(this._frameData);

            var pose = this._frameData.pose;

            if (!pose) return;

            // WebVR up vector is Y
            // OSGJS up vector is Z

            var sitToStand =
                this._hmd.stageParameters && this._hmd.stageParameters.sittingToStandingTransform;

            var q = pose.orientation;
            if (q) {
                if (sitToStand) {
                    q = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].getRotation(tempQuat, sitToStand);
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["d" /* quat */].mul(q, q, pose.orientation);
                }

                this._quat[0] = q[0];
                this._quat[1] = -q[2];
                this._quat[2] = q[1];
                this._quat[3] = q[3];
            }

            var pos = pose.position;
            if (pos) {
                if (sitToStand) {
                    pos = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["f" /* vec3 */].transformMat4(tempPos, pos, sitToStand);
                }
                this._pos[0] = pos[0] * this._worldScale;
                this._pos[1] = -pos[2] * this._worldScale;
                this._pos[2] = pos[1] * this._worldScale;
            }

            manipulatorAdapter.update(this._quat, this._pos);
        };
    })(),

    getHmd: function() {
        return this._hmd;
    }
};
/* harmony default export */ __webpack_exports__["a"] = (WebVR);


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__ = __webpack_require__(0);
// Copyright 2016 The Chromium Authors. All rights reserved.
// Use of this source code is governed by a BSD-style license that can be
// found in the LICENSE file.

// Installs a shim that emulates functionality from the WebVR '1.1' spec if the
// browser only exposes WebVR '1.0'.



if ('getVRDisplays' in navigator) {
    // A lot of Chrome builds to date don't have depthNear and depthFar, even
    // though they're in the WebVR 1.0 spec. They're more necessary in 1.1.
    if (!('depthNear' in window.VRDisplay.prototype)) {
        window.VRDisplay.prototype.depthNear = 0.01;
    }

    if (!('depthFar' in window.VRDisplay.prototype)) {
        window.VRDisplay.prototype.depthFar = 10000.0;
    }

    // If the browser has a WebVR implementation but does not include the 1.1
    // functionality patch it with JS.
    if (!('VRFrameData' in window)) {
        window.VRFrameData = function() {
            this.leftProjectionMatrix = new Float32Array(16);
            this.leftViewMatrix = new Float32Array(16);
            this.rightProjectionMatrix = new Float32Array(16);
            this.rightViewMatrix = new Float32Array(16);
            this.pose = null;
        };

        window.VRDisplay.prototype.getFrameData = (function() {
            var defaultOrientation = new Float32Array([0, 0, 0, 1]);
            var defaultPosition = new Float32Array([0, 0, 0]);

            function updateEyeMatrices(projection, view, pose, parameters, vrDisplay) {
                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].perspectiveFromFieldOfView(
                    projection,
                    parameters.fieldOfView,
                    vrDisplay.depthNear,
                    vrDisplay.depthFar
                );

                var orientation = pose.orientation;
                var position = pose.position;
                if (!orientation) {
                    orientation = defaultOrientation;
                }
                if (!position) {
                    position = defaultPosition;
                }

                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].fromRotationTranslation(view, orientation, position);
                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].translate(view, view, parameters.offset);
                __WEBPACK_IMPORTED_MODULE_0_osg_glMatrix__["c" /* mat4 */].invert(view, view);
            }

            return function(frameData) {
                var pose = this.getPose();
                if (!pose) return false;

                frameData.pose = pose;
                frameData.timestamp = pose.timestamp;

                updateEyeMatrices(
                    frameData.leftProjectionMatrix,
                    frameData.leftViewMatrix,
                    pose,
                    this.getEyeParameters('left'),
                    this
                );
                updateEyeMatrices(
                    frameData.rightProjectionMatrix,
                    frameData.rightViewMatrix,
                    pose,
                    this.getEyeParameters('right'),
                    this
                );

                return true;
            };
        })();
    }
}


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DeviceOrientation = function(viewer) {
    this._viewer = viewer;
    this._type = 'DeviceOrientation';
    this._enable = false;

    // Landscape mobile orientation testing defaults
    this._deviceOrientation = undefined;
    this._screenOrientation = window.orientation || 90;
};

DeviceOrientation.prototype = {
    setEnable: function(bool) {
        this._enable = bool;
    },

    getEnable: function() {
        return this._enable;
    },

    init: function() {
        var self = this;

        // Check because Chrome send _one_ event with all angles to null
        window.addEventListener(
            'deviceorientation',
            function(rawEvtData) {
                if (rawEvtData.alpha !== null && rawEvtData.alpha !== undefined)
                    self._deviceOrientation = rawEvtData;
            },
            false
        );

        window.addEventListener(
            'orientationchange',
            function() {
                if (window.orientation !== null && window.orientation !== undefined)
                    self._screenOrientation = window.orientation;
            },
            false
        );
    },

    getManipulatorController: function() {
        return this._viewer.getManipulator().getControllerList()[this._type];
    },

    isValid: function() {
        if (!this._enable) return false;

        if (!this._deviceOrientation) return false;

        var manipulator = this._viewer.getManipulator();
        if (!manipulator) return false;

        var controller = manipulator.getControllerList()[this._type];
        if (!controller || !controller.isEnabled()) return false;

        return true;
    },

    update: function() {
        if (!this.isValid()) return;

        // update the manipulator with the rotation of the device
        var manipulatorAdapter = this.getManipulatorController();
        if (manipulatorAdapter.update) {
            manipulatorAdapter.update(this._deviceOrientation, this._screenOrientation);
        }
    }
};

/* harmony default export */ __webpack_exports__["a"] = (DeviceOrientation);


/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// jshint ignore: start

/*
 ** Copyright (c) 2012 The Khronos Group Inc.
 **
 ** Permission is hereby granted, free of charge, to any person obtaining a
 ** copy of this software and/or associated documentation files (the
 ** "Materials"), to deal in the Materials without restriction, including
 ** without limitation the rights to use, copy, modify, merge, publish,
 ** distribute, sublicense, and/or sell copies of the Materials, and to
 ** permit persons to whom the Materials are furnished to do so, subject to
 ** the following conditions:
 **
 ** The above copyright notice and this permission notice shall be included
 ** in all copies or substantial portions of the Materials.
 **
 ** THE MATERIALS ARE PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 ** EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 ** MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 ** IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 ** CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 ** TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 ** MATERIALS OR THE USE OR OTHER DEALINGS IN THE MATERIALS.
 */

// Various functions for helping debug WebGL apps.

var WebGLDebugUtils = (function() {
    /**
     * Wrapped logging function.
     * @param {string} msg Message to log.
     */
    var log = function(msg) {
        if (window.console && window.console.log) {
            window.console.log(msg);
        }
    };

    /**
     * Wrapped error logging function.
     * @param {string} msg Message to log.
     */
    var error = function(msg) {
        if (window.console && window.console.error) {
            window.console.error(msg);
        } else {
            log(msg);
        }
    };

    /**
     * Which arguments are enums based on the number of arguments to the function.
     * So
     *    'texImage2D': {
     *       9: { 0:true, 2:true, 6:true, 7:true },
     *       6: { 0:true, 2:true, 3:true, 4:true },
     *    },
     *
     * means if there are 9 arguments then 6 and 7 are enums, if there are 6
     * arguments 3 and 4 are enums
     *
     * @type {!Object.<number, !Object.<number, string>}
     */
    var glValidEnumContexts = {
        // Generic setters and getters

        enable: {
            1: {
                0: true
            }
        },
        disable: {
            1: {
                0: true
            }
        },
        getParameter: {
            1: {
                0: true
            }
        },

        // Rendering

        drawArrays: {
            3: {
                0: true
            }
        },
        drawElements: {
            4: {
                0: true,
                2: true
            }
        },

        // Shaders

        createShader: {
            1: {
                0: true
            }
        },
        getShaderParameter: {
            2: {
                1: true
            }
        },
        getProgramParameter: {
            2: {
                1: true
            }
        },
        getShaderPrecisionFormat: {
            2: {
                0: true,
                1: true
            }
        },

        // Vertex attributes

        getVertexAttrib: {
            2: {
                1: true
            }
        },
        vertexAttribPointer: {
            6: {
                2: true
            }
        },

        // Textures

        bindTexture: {
            2: {
                0: true
            }
        },
        activeTexture: {
            1: {
                0: true
            }
        },
        getTexParameter: {
            2: {
                0: true,
                1: true
            }
        },
        texParameterf: {
            3: {
                0: true,
                1: true
            }
        },
        texParameteri: {
            3: {
                0: true,
                1: true,
                2: true
            }
        },
        // texImage2D and texSubImage2D are defined below with WebGL 2 entrypoints
        copyTexImage2D: {
            8: {
                0: true,
                2: true
            }
        },
        copyTexSubImage2D: {
            8: {
                0: true
            }
        },
        generateMipmap: {
            1: {
                0: true
            }
        },
        // compressedTexImage2D and compressedTexSubImage2D are defined below with WebGL 2 entrypoints

        // Buffer objects

        bindBuffer: {
            2: {
                0: true
            }
        },
        // bufferData and bufferSubData are defined below with WebGL 2 entrypoints
        getBufferParameter: {
            2: {
                0: true,
                1: true
            }
        },

        // Renderbuffers and framebuffers

        pixelStorei: {
            2: {
                0: true,
                1: true
            }
        },
        // readPixels is defined below with WebGL 2 entrypoints
        bindRenderbuffer: {
            2: {
                0: true
            }
        },
        bindFramebuffer: {
            2: {
                0: true
            }
        },
        checkFramebufferStatus: {
            1: {
                0: true
            }
        },
        framebufferRenderbuffer: {
            4: {
                0: true,
                1: true,
                2: true
            }
        },
        framebufferTexture2D: {
            5: {
                0: true,
                1: true,
                2: true
            }
        },
        getFramebufferAttachmentParameter: {
            3: {
                0: true,
                1: true,
                2: true
            }
        },
        getRenderbufferParameter: {
            2: {
                0: true,
                1: true
            }
        },
        renderbufferStorage: {
            4: {
                0: true,
                1: true
            }
        },

        // Frame buffer operations (clear, blend, depth test, stencil)

        clear: {
            1: {
                0: {
                    enumBitwiseOr: ['COLOR_BUFFER_BIT', 'DEPTH_BUFFER_BIT', 'STENCIL_BUFFER_BIT']
                }
            }
        },
        depthFunc: {
            1: {
                0: true
            }
        },
        blendFunc: {
            2: {
                0: true,
                1: true
            }
        },
        blendFuncSeparate: {
            4: {
                0: true,
                1: true,
                2: true,
                3: true
            }
        },
        blendEquation: {
            1: {
                0: true
            }
        },
        blendEquationSeparate: {
            2: {
                0: true,
                1: true
            }
        },
        stencilFunc: {
            3: {
                0: true
            }
        },
        stencilFuncSeparate: {
            4: {
                0: true,
                1: true
            }
        },
        stencilMaskSeparate: {
            2: {
                0: true
            }
        },
        stencilOp: {
            3: {
                0: true,
                1: true,
                2: true
            }
        },
        stencilOpSeparate: {
            4: {
                0: true,
                1: true,
                2: true,
                3: true
            }
        },

        // Culling

        cullFace: {
            1: {
                0: true
            }
        },
        frontFace: {
            1: {
                0: true
            }
        },

        // ANGLE_instanced_arrays extension

        drawArraysInstancedANGLE: {
            4: {
                0: true
            }
        },
        drawElementsInstancedANGLE: {
            5: {
                0: true,
                2: true
            }
        },

        // EXT_blend_minmax extension

        blendEquationEXT: {
            1: {
                0: true
            }
        },

        // WebGL 2 Buffer objects

        bufferData: {
            3: {
                0: true,
                2: true
            }, // WebGL 1
            4: {
                0: true,
                2: true
            }, // WebGL 2
            5: {
                0: true,
                2: true
            } // WebGL 2
        },
        bufferSubData: {
            3: {
                0: true
            }, // WebGL 1
            4: {
                0: true
            }, // WebGL 2
            5: {
                0: true
            } // WebGL 2
        },
        copyBufferSubData: {
            5: {
                0: true,
                1: true
            }
        },
        getBufferSubData: {
            3: {
                0: true
            },
            4: {
                0: true
            },
            5: {
                0: true
            }
        },

        // WebGL 2 Framebuffer objects

        blitFramebuffer: {
            10: {
                8: {
                    enumBitwiseOr: ['COLOR_BUFFER_BIT', 'DEPTH_BUFFER_BIT', 'STENCIL_BUFFER_BIT']
                },
                9: true
            }
        },
        framebufferTextureLayer: {
            5: {
                0: true,
                1: true
            }
        },
        invalidateFramebuffer: {
            2: {
                0: true
            }
        },
        invalidateSubFramebuffer: {
            6: {
                0: true
            }
        },
        readBuffer: {
            1: {
                0: true
            }
        },

        // WebGL 2 Renderbuffer objects

        getInternalformatParameter: {
            3: {
                0: true,
                1: true,
                2: true
            }
        },
        renderbufferStorageMultisample: {
            5: {
                0: true,
                2: true
            }
        },

        // WebGL 2 Texture objects

        texStorage2D: {
            5: {
                0: true,
                2: true
            }
        },
        texStorage3D: {
            6: {
                0: true,
                2: true
            }
        },
        texImage2D: {
            9: {
                0: true,
                2: true,
                6: true,
                7: true
            }, // WebGL 1 & 2
            6: {
                0: true,
                2: true,
                3: true,
                4: true
            }, // WebGL 1
            10: {
                0: true,
                2: true,
                6: true,
                7: true
            } // WebGL 2
        },
        texImage3D: {
            10: {
                0: true,
                2: true,
                7: true,
                8: true
            },
            11: {
                0: true,
                2: true,
                7: true,
                8: true
            }
        },
        texSubImage2D: {
            9: {
                0: true,
                6: true,
                7: true
            }, // WebGL 1 & 2
            7: {
                0: true,
                4: true,
                5: true
            }, // WebGL 1
            10: {
                0: true,
                6: true,
                7: true
            } // WebGL 2
        },
        texSubImage3D: {
            11: {
                0: true,
                8: true,
                9: true
            },
            12: {
                0: true,
                8: true,
                9: true
            }
        },
        copyTexSubImage3D: {
            9: {
                0: true
            }
        },
        compressedTexImage2D: {
            7: {
                0: true,
                2: true
            }, // WebGL 1 & 2
            8: {
                0: true,
                2: true
            }, // WebGL 2
            9: {
                0: true,
                2: true
            } // WebGL 2
        },
        compressedTexImage3D: {
            8: {
                0: true,
                2: true
            },
            9: {
                0: true,
                2: true
            },
            10: {
                0: true,
                2: true
            }
        },
        compressedTexSubImage2D: {
            8: {
                0: true,
                6: true
            }, // WebGL 1 & 2
            9: {
                0: true,
                6: true
            }, // WebGL 2
            10: {
                0: true,
                6: true
            } // WebGL 2
        },
        compressedTexSubImage3D: {
            10: {
                0: true,
                8: true
            },
            11: {
                0: true,
                8: true
            },
            12: {
                0: true,
                8: true
            }
        },

        // WebGL 2 Vertex attribs

        vertexAttribIPointer: {
            5: {
                2: true
            }
        },

        // WebGL 2 Writing to the drawing buffer

        drawArraysInstanced: {
            4: {
                0: true
            }
        },
        drawElementsInstanced: {
            5: {
                0: true,
                2: true
            }
        },
        drawRangeElements: {
            6: {
                0: true,
                4: true
            }
        },

        // WebGL 2 Reading back pixels

        readPixels: {
            7: {
                4: true,
                5: true
            }, // WebGL 1 & 2
            8: {
                4: true,
                5: true
            } // WebGL 2
        },

        // WebGL 2 Multiple Render Targets

        clearBufferfv: {
            3: {
                0: true
            },
            4: {
                0: true
            }
        },
        clearBufferiv: {
            3: {
                0: true
            },
            4: {
                0: true
            }
        },
        clearBufferuiv: {
            3: {
                0: true
            },
            4: {
                0: true
            }
        },
        clearBufferfi: {
            4: {
                0: true
            }
        },

        // WebGL 2 Query objects

        beginQuery: {
            2: {
                0: true
            }
        },
        endQuery: {
            1: {
                0: true
            }
        },
        getQuery: {
            2: {
                0: true,
                1: true
            }
        },
        getQueryParameter: {
            2: {
                1: true
            }
        },

        // WebGL 2 Sampler objects

        samplerParameteri: {
            3: {
                1: true,
                2: true
            }
        },
        samplerParameterf: {
            3: {
                1: true
            }
        },
        getSamplerParameter: {
            2: {
                1: true
            }
        },

        // WebGL 2 Sync objects

        fenceSync: {
            2: {
                0: true,
                1: {
                    enumBitwiseOr: []
                }
            }
        },
        clientWaitSync: {
            3: {
                1: {
                    enumBitwiseOr: ['SYNC_FLUSH_COMMANDS_BIT']
                }
            }
        },
        waitSync: {
            3: {
                1: {
                    enumBitwiseOr: []
                }
            }
        },
        getSyncParameter: {
            2: {
                1: true
            }
        },

        // WebGL 2 Transform Feedback

        bindTransformFeedback: {
            2: {
                0: true
            }
        },
        beginTransformFeedback: {
            1: {
                0: true
            }
        },
        transformFeedbackVaryings: {
            3: {
                2: true
            }
        },

        // WebGL2 Uniform Buffer Objects and Transform Feedback Buffers

        bindBufferBase: {
            3: {
                0: true
            }
        },
        bindBufferRange: {
            5: {
                0: true
            }
        },
        getIndexedParameter: {
            2: {
                0: true
            }
        },
        getActiveUniforms: {
            3: {
                2: true
            }
        },
        getActiveUniformBlockParameter: {
            3: {
                2: true
            }
        }
    };

    /**
     * Map of numbers to names.
     * @type {Object}
     */
    var glEnums = null;

    /**
     * Map of names to numbers.
     * @type {Object}
     */
    var enumStringToValue = null;

    /**
     * Initializes this module. Safe to call more than once.
     * @param {!WebGLRenderingContext} ctx A WebGL context. If
     *    you have more than one context it doesn't matter which one
     *    you pass in, it is only used to pull out constants.
     */
    function init(ctx) {
        if (glEnums == null) {
            glEnums = {};
            enumStringToValue = {};
            for (var propertyName in ctx) {
                if (typeof ctx[propertyName] === 'number') {
                    glEnums[ctx[propertyName]] = propertyName;
                    enumStringToValue[propertyName] = ctx[propertyName];
                }
            }
        }
    }

    /**
     * Checks the utils have been initialized.
     */
    function checkInit() {
        if (glEnums == null) {
            throw 'WebGLDebugUtils.init(ctx) not called';
        }
    }

    /**
     * Returns true or false if value matches any WebGL enum
     * @param {*} value Value to check if it might be an enum.
     * @return {boolean} True if value matches one of the WebGL defined enums
     */
    function mightBeEnum(value) {
        checkInit();
        return glEnums[value] !== undefined;
    }

    /**
     * Gets an string version of an WebGL enum.
     *
     * Example:
     *   var str = WebGLDebugUtil.glEnumToString(ctx.getError());
     *
     * @param {number} value Value to return an enum for
     * @return {string} The string version of the enum.
     */
    function glEnumToString(value) {
        checkInit();
        var name = glEnums[value];
        return name !== undefined
            ? 'gl.' + name
            : '/*UNKNOWN WebGL ENUM*/ 0x' + value.toString(16) + '';
    }

    /**
     * Returns the string version of a WebGL argument.
     * Attempts to convert enum arguments to strings.
     * @param {string} functionName the name of the WebGL function.
     * @param {number} numArgs the number of arguments passed to the function.
     * @param {number} argumentIndx the index of the argument.
     * @param {*} value The value of the argument.
     * @return {string} The value as a string.
     */
    function glFunctionArgToString(functionName, numArgs, argumentIndex, value) {
        var funcInfo = glValidEnumContexts[functionName];
        if (funcInfo !== undefined) {
            var funcInfo = funcInfo[numArgs];
            if (funcInfo !== undefined) {
                if (funcInfo[argumentIndex]) {
                    if (
                        typeof funcInfo[argumentIndex] === 'object' &&
                        funcInfo[argumentIndex]['enumBitwiseOr'] !== undefined
                    ) {
                        var enums = funcInfo[argumentIndex]['enumBitwiseOr'];
                        var orResult = 0;
                        var orEnums = [];
                        for (var i = 0; i < enums.length; ++i) {
                            var enumValue = enumStringToValue[enums[i]];
                            if ((value & enumValue) !== 0) {
                                orResult |= enumValue;
                                orEnums.push(glEnumToString(enumValue));
                            }
                        }
                        if (orResult === value) {
                            return orEnums.join(' | ');
                        } else {
                            return glEnumToString(value);
                        }
                    } else {
                        return glEnumToString(value);
                    }
                }
            }
        }
        if (value === null) {
            return 'null';
        } else if (value === undefined) {
            return 'undefined';
        } else {
            return value.toString();
        }
    }

    /**
     * Converts the arguments of a WebGL function to a string.
     * Attempts to convert enum arguments to strings.
     *
     * @param {string} functionName the name of the WebGL function.
     * @param {number} args The arguments.
     * @return {string} The arguments as a string.
     */
    function glFunctionArgsToString(functionName, args) {
        // apparently we can't do args.join(",");
        var argStr = '';
        var numArgs = args.length;
        for (var ii = 0; ii < numArgs; ++ii) {
            argStr +=
                (ii == 0 ? '' : ', ') + glFunctionArgToString(functionName, numArgs, ii, args[ii]);
        }
        return argStr;
    }

    function makePropertyWrapper(wrapper, original, propertyName) {
        //log("wrap prop: " + propertyName);
        wrapper.__defineGetter__(propertyName, function() {
            return original[propertyName];
        });
        // TODO(gmane): this needs to handle properties that take more than
        // one value?
        wrapper.__defineSetter__(propertyName, function(value) {
            //log("set: " + propertyName);
            original[propertyName] = value;
        });
    }

    // Makes a function that calls a function on another object.
    function makeFunctionWrapper(original, functionName) {
        //log("wrap fn: " + functionName);
        var f = original[functionName];
        return function() {
            //log("call: " + functionName);
            var result = f.apply(original, arguments);
            return result;
        };
    }

    /**
     * Given a WebGL context returns a wrapped context that calls
     * gl.getError after every command and calls a function if the
     * result is not gl.NO_ERROR.
     *
     * @param {!WebGLRenderingContext} ctx The webgl context to
     *        wrap.
     * @param {!function(err, funcName, args): void} opt_onErrorFunc
     *        The function to call when gl.getError returns an
     *        error. If not specified the default function calls
     *        console.log with a message.
     * @param {!function(funcName, args): void} opt_onFunc The
     *        function to call when each webgl function is called.
     *        You can use this to log all calls for example.
     * @param {!WebGLRenderingContext} opt_err_ctx The webgl context
     *        to call getError on if different than ctx.
     */
    function makeDebugContext(ctx, opt_onErrorFunc, opt_onFunc, opt_err_ctx) {
        opt_err_ctx = opt_err_ctx || ctx;
        init(ctx);
        opt_onErrorFunc =
            opt_onErrorFunc ||
            function(err, functionName, args) {
                // apparently we can't do args.join(",");
                var argStr = '';
                var numArgs = args.length;
                for (var ii = 0; ii < numArgs; ++ii) {
                    argStr +=
                        (ii == 0 ? '' : ', ') +
                        glFunctionArgToString(functionName, numArgs, ii, args[ii]);
                }
                error(
                    'WebGL error ' +
                        glEnumToString(err) +
                        ' in ' +
                        functionName +
                        '(' +
                        argStr +
                        ')'
                );
            };

        // Holds booleans for each GL error so after we get the error ourselves
        // we can still return it to the client app.
        var glErrorShadow = {};

        // Makes a function that calls a WebGL function and then calls getError.
        function makeErrorWrapper(ctx, functionName) {
            return function() {
                if (opt_onFunc) {
                    opt_onFunc(functionName, arguments);
                }
                var result = ctx[functionName].apply(ctx, arguments);
                var err = opt_err_ctx.getError();
                if (err != 0) {
                    glErrorShadow[err] = true;
                    opt_onErrorFunc(err, functionName, arguments);
                }
                return result;
            };
        }

        // Make a an object that has a copy of every property of the WebGL context
        // but wraps all functions.
        var wrapper = {};
        for (var propertyName in ctx) {
            if (typeof ctx[propertyName] === 'function') {
                if (propertyName != 'getExtension') {
                    wrapper[propertyName] = makeErrorWrapper(ctx, propertyName);
                } else {
                    var wrapped = makeErrorWrapper(ctx, propertyName);
                    wrapper[propertyName] = function() {
                        var result = wrapped.apply(ctx, arguments);
                        if (!result) {
                            return null;
                        }
                        return makeDebugContext(result, opt_onErrorFunc, opt_onFunc, opt_err_ctx);
                    };
                }
            } else {
                makePropertyWrapper(wrapper, ctx, propertyName);
            }
        }

        // Override the getError function with one that returns our saved results.
        wrapper.getError = function() {
            for (var err in glErrorShadow) {
                if (glErrorShadow.hasOwnProperty(err)) {
                    if (glErrorShadow[err]) {
                        glErrorShadow[err] = false;
                        return err;
                    }
                }
            }
            return ctx.NO_ERROR;
        };

        return wrapper;
    }

    function resetToInitialState(ctx) {
        var isWebGL2RenderingContext = !!ctx.createTransformFeedback;

        if (isWebGL2RenderingContext) {
            ctx.bindVertexArray(null);
        }

        var numAttribs = ctx.getParameter(ctx.MAX_VERTEX_ATTRIBS);
        var tmp = ctx.createBuffer();
        ctx.bindBuffer(ctx.ARRAY_BUFFER, tmp);
        for (var ii = 0; ii < numAttribs; ++ii) {
            ctx.disableVertexAttribArray(ii);
            ctx.vertexAttribPointer(ii, 4, ctx.FLOAT, false, 0, 0);
            ctx.vertexAttrib1f(ii, 0);
            if (isWebGL2RenderingContext) {
                ctx.vertexAttribDivisor(ii, 0);
            }
        }
        ctx.deleteBuffer(tmp);

        var numTextureUnits = ctx.getParameter(ctx.MAX_TEXTURE_IMAGE_UNITS);
        for (var ii = 0; ii < numTextureUnits; ++ii) {
            ctx.activeTexture(ctx.TEXTURE0 + ii);
            ctx.bindTexture(ctx.TEXTURE_CUBE_MAP, null);
            ctx.bindTexture(ctx.TEXTURE_2D, null);
            if (isWebGL2RenderingContext) {
                ctx.bindTexture(ctx.TEXTURE_2D_ARRAY, null);
                ctx.bindTexture(ctx.TEXTURE_3D, null);
                ctx.bindSampler(ii, null);
            }
        }

        ctx.activeTexture(ctx.TEXTURE0);
        ctx.useProgram(null);
        ctx.bindBuffer(ctx.ARRAY_BUFFER, null);
        ctx.bindBuffer(ctx.ELEMENT_ARRAY_BUFFER, null);
        ctx.bindFramebuffer(ctx.FRAMEBUFFER, null);
        ctx.bindRenderbuffer(ctx.RENDERBUFFER, null);
        ctx.disable(ctx.BLEND);
        ctx.disable(ctx.CULL_FACE);
        ctx.disable(ctx.DEPTH_TEST);
        ctx.disable(ctx.DITHER);
        ctx.disable(ctx.SCISSOR_TEST);
        ctx.blendColor(0, 0, 0, 0);
        ctx.blendEquation(ctx.FUNC_ADD);
        ctx.blendFunc(ctx.ONE, ctx.ZERO);
        ctx.clearColor(0, 0, 0, 0);
        ctx.clearDepth(1);
        ctx.clearStencil(-1);
        ctx.colorMask(true, true, true, true);
        ctx.cullFace(ctx.BACK);
        ctx.depthFunc(ctx.LESS);
        ctx.depthMask(true);
        ctx.depthRange(0, 1);
        ctx.frontFace(ctx.CCW);
        ctx.hint(ctx.GENERATE_MIPMAP_HINT, ctx.DONT_CARE);
        ctx.lineWidth(1);
        ctx.pixelStorei(ctx.PACK_ALIGNMENT, 4);
        ctx.pixelStorei(ctx.UNPACK_ALIGNMENT, 4);
        ctx.pixelStorei(ctx.UNPACK_FLIP_Y_WEBGL, false);
        ctx.pixelStorei(ctx.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false);
        // TODO: Delete this IF.
        if (ctx.UNPACK_COLORSPACE_CONVERSION_WEBGL) {
            ctx.pixelStorei(ctx.UNPACK_COLORSPACE_CONVERSION_WEBGL, ctx.BROWSER_DEFAULT_WEBGL);
        }
        ctx.polygonOffset(0, 0);
        ctx.sampleCoverage(1, false);
        ctx.scissor(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.stencilFunc(ctx.ALWAYS, 0, 0xffffffff);
        ctx.stencilMask(0xffffffff);
        ctx.stencilOp(ctx.KEEP, ctx.KEEP, ctx.KEEP);
        ctx.viewport(0, 0, ctx.canvas.width, ctx.canvas.height);
        ctx.clear(ctx.COLOR_BUFFER_BIT | ctx.DEPTH_BUFFER_BIT | ctx.STENCIL_BUFFER_BIT);

        if (isWebGL2RenderingContext) {
            ctx.drawBuffers([ctx.BACK]);
            ctx.readBuffer(ctx.BACK);
            ctx.bindBuffer(ctx.COPY_READ_BUFFER, null);
            ctx.bindBuffer(ctx.COPY_WRITE_BUFFER, null);
            ctx.bindBuffer(ctx.PIXEL_PACK_BUFFER, null);
            ctx.bindBuffer(ctx.PIXEL_UNPACK_BUFFER, null);
            var numTransformFeedbacks = ctx.getParameter(
                ctx.MAX_TRANSFORM_FEEDBACK_SEPARATE_ATTRIBS
            );
            for (var ii = 0; ii < numTransformFeedbacks; ++ii) {
                ctx.bindBufferBase(ctx.TRANSFORM_FEEDBACK_BUFFER, ii, null);
            }
            var numUBOs = ctx.getParameter(ctx.MAX_UNIFORM_BUFFER_BINDINGS);
            for (var ii = 0; ii < numUBOs; ++ii) {
                ctx.bindBufferBase(ctx.UNIFORM_BUFFER, ii, null);
            }
            ctx.disable(ctx.RASTERIZER_DISCARD);
            ctx.pixelStorei(ctx.UNPACK_IMAGE_HEIGHT, 0);
            ctx.pixelStorei(ctx.UNPACK_SKIP_IMAGES, 0);
            ctx.pixelStorei(ctx.UNPACK_ROW_LENGTH, 0);
            ctx.pixelStorei(ctx.UNPACK_SKIP_ROWS, 0);
            ctx.pixelStorei(ctx.UNPACK_SKIP_PIXELS, 0);
            ctx.pixelStorei(ctx.PACK_ROW_LENGTH, 0);
            ctx.pixelStorei(ctx.PACK_SKIP_ROWS, 0);
            ctx.pixelStorei(ctx.PACK_SKIP_PIXELS, 0);
            ctx.hint(ctx.FRAGMENT_SHADER_DERIVATIVE_HINT, ctx.DONT_CARE);
        }

        // TODO: This should NOT be needed but Firefox fails with 'hint'
        while (ctx.getError());
    }

    function makeLostContextSimulatingCanvas(canvas) {
        var unwrappedContext_;
        var wrappedContext_;
        var onLost_ = [];
        var onRestored_ = [];
        var wrappedContext_ = {};
        var contextId_ = 1;
        var contextLost_ = false;
        var resourceId_ = 0;
        var resourceDb_ = [];
        var numCallsToLoseContext_ = 0;
        var numCalls_ = 0;
        var canRestore_ = false;
        var restoreTimeout_ = 0;
        var isWebGL2RenderingContext;

        // Holds booleans for each GL error so can simulate errors.
        var glErrorShadow_ = {};

        canvas.getContext = (function(f) {
            return function() {
                var ctx = f.apply(canvas, arguments);
                // Did we get a context and is it a WebGL context?
                if (
                    ctx instanceof WebGLRenderingContext ||
                    (window.WebGL2RenderingContext && ctx instanceof WebGL2RenderingContext)
                ) {
                    if (ctx != unwrappedContext_) {
                        if (unwrappedContext_) {
                            throw 'got different context';
                        }
                        isWebGL2RenderingContext =
                            window.WebGL2RenderingContext && ctx instanceof WebGL2RenderingContext;
                        unwrappedContext_ = ctx;
                        wrappedContext_ = makeLostContextSimulatingContext(unwrappedContext_);
                    }
                    return wrappedContext_;
                }
                return ctx;
            };
        })(canvas.getContext);

        function wrapEvent(listener) {
            if (typeof listener === 'function') {
                return listener;
            } else {
                return function(info) {
                    listener.handleEvent(info);
                };
            }
        }

        var addOnContextLostListener = function(listener) {
            onLost_.push(wrapEvent(listener));
        };

        var addOnContextRestoredListener = function(listener) {
            onRestored_.push(wrapEvent(listener));
        };

        function wrapAddEventListener(canvas) {
            var f = canvas.addEventListener;
            canvas.addEventListener = function(type, listener, bubble) {
                switch (type) {
                    case 'webglcontextlost':
                        addOnContextLostListener(listener);
                        break;
                    case 'webglcontextrestored':
                        addOnContextRestoredListener(listener);
                        break;
                    default:
                        f.apply(canvas, arguments);
                }
            };
        }

        wrapAddEventListener(canvas);

        canvas.loseContext = function() {
            if (!contextLost_) {
                contextLost_ = true;
                numCallsToLoseContext_ = 0;
                ++contextId_;
                while (unwrappedContext_.getError());
                clearErrors();
                glErrorShadow_[unwrappedContext_.CONTEXT_LOST_WEBGL] = true;
                var event = makeWebGLContextEvent('context lost');
                var callbacks = onLost_.slice();
                setTimeout(function() {
                    //log("numCallbacks:" + callbacks.length);
                    for (var ii = 0; ii < callbacks.length; ++ii) {
                        //log("calling callback:" + ii);
                        callbacks[ii](event);
                    }
                    if (restoreTimeout_ >= 0) {
                        setTimeout(function() {
                            canvas.restoreContext();
                        }, restoreTimeout_);
                    }
                }, 0);
            }
        };

        canvas.restoreContext = function() {
            if (contextLost_) {
                if (onRestored_.length) {
                    setTimeout(function() {
                        if (!canRestore_) {
                            throw 'can not restore. webglcontestlost listener did not call event.preventDefault';
                        }
                        freeResources();
                        resetToInitialState(unwrappedContext_);
                        contextLost_ = false;
                        numCalls_ = 0;
                        canRestore_ = false;
                        var callbacks = onRestored_.slice();
                        var event = makeWebGLContextEvent('context restored');
                        for (var ii = 0; ii < callbacks.length; ++ii) {
                            callbacks[ii](event);
                        }
                    }, 0);
                }
            }
        };

        canvas.loseContextInNCalls = function(numCalls) {
            if (contextLost_) {
                throw 'You can not ask a lost contet to be lost';
            }
            numCallsToLoseContext_ = numCalls_ + numCalls;
        };

        canvas.getNumCalls = function() {
            return numCalls_;
        };

        canvas.setRestoreTimeout = function(timeout) {
            restoreTimeout_ = timeout;
        };

        function isWebGLObject(obj) {
            //return false;
            return (
                obj instanceof WebGLBuffer ||
                obj instanceof WebGLFramebuffer ||
                obj instanceof WebGLProgram ||
                obj instanceof WebGLRenderbuffer ||
                obj instanceof WebGLShader ||
                obj instanceof WebGLTexture
            );
        }

        function checkResources(args) {
            for (var ii = 0; ii < args.length; ++ii) {
                var arg = args[ii];
                if (isWebGLObject(arg)) {
                    return arg.__webglDebugContextLostId__ == contextId_;
                }
            }
            return true;
        }

        function clearErrors() {
            var k = Object.keys(glErrorShadow_);
            for (var ii = 0; ii < k.length; ++ii) {
                delete glErrorShadow_[k[ii]];
            }
        }

        function loseContextIfTime() {
            ++numCalls_;
            if (!contextLost_) {
                if (numCallsToLoseContext_ == numCalls_) {
                    canvas.loseContext();
                }
            }
        }

        // Makes a function that simulates WebGL when out of context.
        function makeLostContextFunctionWrapper(ctx, functionName) {
            var f = ctx[functionName];
            return function() {
                // log("calling:" + functionName);
                // Only call the functions if the context is not lost.
                loseContextIfTime();
                if (!contextLost_) {
                    //if (!checkResources(arguments)) {
                    //  glErrorShadow_[wrappedContext_.INVALID_OPERATION] = true;
                    //  return;
                    //}
                    var result = f.apply(ctx, arguments);
                    return result;
                }
            };
        }

        function freeResources() {
            for (var ii = 0; ii < resourceDb_.length; ++ii) {
                var resource = resourceDb_[ii];
                if (resource instanceof WebGLBuffer) {
                    unwrappedContext_.deleteBuffer(resource);
                } else if (resource instanceof WebGLFramebuffer) {
                    unwrappedContext_.deleteFramebuffer(resource);
                } else if (resource instanceof WebGLProgram) {
                    unwrappedContext_.deleteProgram(resource);
                } else if (resource instanceof WebGLRenderbuffer) {
                    unwrappedContext_.deleteRenderbuffer(resource);
                } else if (resource instanceof WebGLShader) {
                    unwrappedContext_.deleteShader(resource);
                } else if (resource instanceof WebGLTexture) {
                    unwrappedContext_.deleteTexture(resource);
                } else if (isWebGL2RenderingContext) {
                    if (resource instanceof WebGLQuery) {
                        unwrappedContext_.deleteQuery(resource);
                    } else if (resource instanceof WebGLSampler) {
                        unwrappedContext_.deleteSampler(resource);
                    } else if (resource instanceof WebGLSync) {
                        unwrappedContext_.deleteSync(resource);
                    } else if (resource instanceof WebGLTransformFeedback) {
                        unwrappedContext_.deleteTransformFeedback(resource);
                    } else if (resource instanceof WebGLVertexArrayObject) {
                        unwrappedContext_.deleteVertexArray(resource);
                    }
                }
            }
        }

        function makeWebGLContextEvent(statusMessage) {
            return {
                statusMessage: statusMessage,
                preventDefault: function() {
                    canRestore_ = true;
                }
            };
        }

        return canvas;

        function makeLostContextSimulatingContext(ctx) {
            // copy all functions and properties to wrapper
            for (var propertyName in ctx) {
                if (typeof ctx[propertyName] === 'function') {
                    wrappedContext_[propertyName] = makeLostContextFunctionWrapper(
                        ctx,
                        propertyName
                    );
                } else {
                    makePropertyWrapper(wrappedContext_, ctx, propertyName);
                }
            }

            // Wrap a few functions specially.
            wrappedContext_.getError = function() {
                loseContextIfTime();
                if (!contextLost_) {
                    var err;
                    while ((err = unwrappedContext_.getError())) {
                        glErrorShadow_[err] = true;
                    }
                }
                for (var err in glErrorShadow_) {
                    if (glErrorShadow_[err]) {
                        delete glErrorShadow_[err];
                        return err;
                    }
                }
                return wrappedContext_.NO_ERROR;
            };

            var creationFunctions = [
                'createBuffer',
                'createFramebuffer',
                'createProgram',
                'createRenderbuffer',
                'createShader',
                'createTexture'
            ];
            if (isWebGL2RenderingContext) {
                creationFunctions.push(
                    'createQuery',
                    'createSampler',
                    'fenceSync',
                    'createTransformFeedback',
                    'createVertexArray'
                );
            }
            for (var ii = 0; ii < creationFunctions.length; ++ii) {
                var functionName = creationFunctions[ii];
                wrappedContext_[functionName] = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return null;
                        }
                        var obj = f.apply(ctx, arguments);
                        obj.__webglDebugContextLostId__ = contextId_;
                        resourceDb_.push(obj);
                        return obj;
                    };
                })(ctx[functionName]);
            }

            var functionsThatShouldReturnNull = [
                'getActiveAttrib',
                'getActiveUniform',
                'getBufferParameter',
                'getContextAttributes',
                'getAttachedShaders',
                'getFramebufferAttachmentParameter',
                'getParameter',
                'getProgramParameter',
                'getProgramInfoLog',
                'getRenderbufferParameter',
                'getShaderParameter',
                'getShaderInfoLog',
                'getShaderSource',
                'getTexParameter',
                'getUniform',
                'getUniformLocation',
                'getVertexAttrib'
            ];
            if (isWebGL2RenderingContext) {
                functionsThatShouldReturnNull.push(
                    'getInternalformatParameter',
                    'getQuery',
                    'getQueryParameter',
                    'getSamplerParameter',
                    'getSyncParameter',
                    'getTransformFeedbackVarying',
                    'getIndexedParameter',
                    'getUniformIndices',
                    'getActiveUniforms',
                    'getActiveUniformBlockParameter',
                    'getActiveUniformBlockName'
                );
            }
            for (var ii = 0; ii < functionsThatShouldReturnNull.length; ++ii) {
                var functionName = functionsThatShouldReturnNull[ii];
                wrappedContext_[functionName] = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return null;
                        }
                        return f.apply(ctx, arguments);
                    };
                })(wrappedContext_[functionName]);
            }

            var isFunctions = [
                'isBuffer',
                'isEnabled',
                'isFramebuffer',
                'isProgram',
                'isRenderbuffer',
                'isShader',
                'isTexture'
            ];
            if (isWebGL2RenderingContext) {
                isFunctions.push(
                    'isQuery',
                    'isSampler',
                    'isSync',
                    'isTransformFeedback',
                    'isVertexArray'
                );
            }
            for (var ii = 0; ii < isFunctions.length; ++ii) {
                var functionName = isFunctions[ii];
                wrappedContext_[functionName] = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return false;
                        }
                        return f.apply(ctx, arguments);
                    };
                })(wrappedContext_[functionName]);
            }

            wrappedContext_.checkFramebufferStatus = (function(f) {
                return function() {
                    loseContextIfTime();
                    if (contextLost_) {
                        return wrappedContext_.FRAMEBUFFER_UNSUPPORTED;
                    }
                    return f.apply(ctx, arguments);
                };
            })(wrappedContext_.checkFramebufferStatus);

            wrappedContext_.getAttribLocation = (function(f) {
                return function() {
                    loseContextIfTime();
                    if (contextLost_) {
                        return -1;
                    }
                    return f.apply(ctx, arguments);
                };
            })(wrappedContext_.getAttribLocation);

            wrappedContext_.getVertexAttribOffset = (function(f) {
                return function() {
                    loseContextIfTime();
                    if (contextLost_) {
                        return 0;
                    }
                    return f.apply(ctx, arguments);
                };
            })(wrappedContext_.getVertexAttribOffset);

            wrappedContext_.isContextLost = function() {
                return contextLost_;
            };

            if (isWebGL2RenderingContext) {
                wrappedContext_.getFragDataLocation = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return -1;
                        }
                        return f.apply(ctx, arguments);
                    };
                })(wrappedContext_.getFragDataLocation);

                wrappedContext_.clientWaitSync = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return wrappedContext_.WAIT_FAILED;
                        }
                        return f.apply(ctx, arguments);
                    };
                })(wrappedContext_.clientWaitSync);

                wrappedContext_.getUniformBlockIndex = (function(f) {
                    return function() {
                        loseContextIfTime();
                        if (contextLost_) {
                            return wrappedContext_.INVALID_INDEX;
                        }
                        return f.apply(ctx, arguments);
                    };
                })(wrappedContext_.getUniformBlockIndex);
            }

            return wrappedContext_;
        }
    }

    return {
        /**
         * Initializes this module. Safe to call more than once.
         * @param {!WebGLRenderingContext} ctx A WebGL context. If
         *    you have more than one context it doesn't matter which one
         *    you pass in, it is only used to pull out constants.
         */
        init: init,

        /**
         * Returns true or false if value matches any WebGL enum
         * @param {*} value Value to check if it might be an enum.
         * @return {boolean} True if value matches one of the WebGL defined enums
         */
        mightBeEnum: mightBeEnum,

        /**
         * Gets an string version of an WebGL enum.
         *
         * Example:
         *   WebGLDebugUtil.init(ctx);
         *   var str = WebGLDebugUtil.glEnumToString(ctx.getError());
         *
         * @param {number} value Value to return an enum for
         * @return {string} The string version of the enum.
         */
        glEnumToString: glEnumToString,

        /**
         * Converts the argument of a WebGL function to a string.
         * Attempts to convert enum arguments to strings.
         *
         * Example:
         *   WebGLDebugUtil.init(ctx);
         *   var str = WebGLDebugUtil.glFunctionArgToString('bindTexture', 2, 0, gl.TEXTURE_2D);
         *
         * would return 'TEXTURE_2D'
         *
         * @param {string} functionName the name of the WebGL function.
         * @param {number} numArgs The number of arguments
         * @param {number} argumentIndx the index of the argument.
         * @param {*} value The value of the argument.
         * @return {string} The value as a string.
         */
        glFunctionArgToString: glFunctionArgToString,

        /**
         * Converts the arguments of a WebGL function to a string.
         * Attempts to convert enum arguments to strings.
         *
         * @param {string} functionName the name of the WebGL function.
         * @param {number} args The arguments.
         * @return {string} The arguments as a string.
         */
        glFunctionArgsToString: glFunctionArgsToString,

        /**
         * Given a WebGL context returns a wrapped context that calls
         * gl.getError after every command and calls a function if the
         * result is not NO_ERROR.
         *
         * You can supply your own function if you want. For example, if you'd like
         * an exception thrown on any GL error you could do this
         *
         *    function throwOnGLError(err, funcName, args) {
         *      throw WebGLDebugUtils.glEnumToString(err) +
         *            " was caused by call to " + funcName;
         *    };
         *
         *    ctx = WebGLDebugUtils.makeDebugContext(
         *        canvas.getContext("webgl"), throwOnGLError);
         *
         * @param {!WebGLRenderingContext} ctx The webgl context to wrap.
         * @param {!function(err, funcName, args): void} opt_onErrorFunc The function
         *     to call when gl.getError returns an error. If not specified the default
         *     function calls console.log with a message.
         * @param {!function(funcName, args): void} opt_onFunc The
         *     function to call when each webgl function is called. You
         *     can use this to log all calls for example.
         */
        makeDebugContext: makeDebugContext,

        /**
         * Given a canvas element returns a wrapped canvas element that will
         * simulate lost context. The canvas returned adds the following functions.
         *
         * loseContext:
         *   simulates a lost context event.
         *
         * restoreContext:
         *   simulates the context being restored.
         *
         * lostContextInNCalls:
         *   loses the context after N gl calls.
         *
         * getNumCalls:
         *   tells you how many gl calls there have been so far.
         *
         * setRestoreTimeout:
         *   sets the number of milliseconds until the context is restored
         *   after it has been lost. Defaults to 0. Pass -1 to prevent
         *   automatic restoring.
         *
         * @param {!Canvas} canvas The canvas element to wrap.
         */
        makeLostContextSimulatingCanvas: makeLostContextSimulatingCanvas,

        /**
         * Resets a context to the initial state.
         * @param {!WebGLRenderingContext} ctx The webgl context to
         *     reset.
         */
        resetToInitialState: resetToInitialState
    };
})();

/* harmony default export */ __webpack_exports__["a"] = (WebGLDebugUtils);


/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgShadow_ShadowCastAttribute__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgShadow_ShadowCastCompiler__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowCastShaderGenerator__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgShadow_ShadowCasterVisitor__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowFrustumIntersection__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShadow_ShadowMap__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgShadow_ShadowMapAtlas__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgShadow_ShadowReceiveAttribute__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgShadow_ShadowSettings__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgShadow_ShadowTechnique__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgShadow_ShadowTexture__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgShadow_ShadowTextureAtlas__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgShadow_ShadowedScene__ = __webpack_require__(254);














var osgShadow = {};

osgShadow.ShadowCastAttribute = __WEBPACK_IMPORTED_MODULE_0_osgShadow_ShadowCastAttribute__["a" /* default */];
osgShadow.ShadowCastCompiler = __WEBPACK_IMPORTED_MODULE_1_osgShadow_ShadowCastCompiler__["a" /* default */];
osgShadow.ShadowReceiveAttribute = __WEBPACK_IMPORTED_MODULE_7_osgShadow_ShadowReceiveAttribute__["a" /* default */];
osgShadow.ShadowCasterVisitor = __WEBPACK_IMPORTED_MODULE_3_osgShadow_ShadowCasterVisitor__["a" /* default */];
osgShadow.ShadowFrustumIntersection = __WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowFrustumIntersection__["a" /* default */];
osgShadow.ShadowMap = __WEBPACK_IMPORTED_MODULE_5_osgShadow_ShadowMap__["a" /* default */];
osgShadow.ShadowMapAtlas = __WEBPACK_IMPORTED_MODULE_6_osgShadow_ShadowMapAtlas__["a" /* default */];
osgShadow.ShadowedScene = __WEBPACK_IMPORTED_MODULE_12_osgShadow_ShadowedScene__["a" /* default */];
osgShadow.ShadowSettings = __WEBPACK_IMPORTED_MODULE_8_osgShadow_ShadowSettings__["a" /* default */];
osgShadow.ShadowCastShaderGenerator = __WEBPACK_IMPORTED_MODULE_2_osgShadow_ShadowCastShaderGenerator__["a" /* default */];
osgShadow.ShadowTechnique = __WEBPACK_IMPORTED_MODULE_9_osgShadow_ShadowTechnique__["a" /* default */];
osgShadow.ShadowTexture = __WEBPACK_IMPORTED_MODULE_10_osgShadow_ShadowTexture__["a" /* default */];
osgShadow.ShadowTextureAtlas = __WEBPACK_IMPORTED_MODULE_11_osgShadow_ShadowTextureAtlas__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgShadow);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_Light__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_PooledResource__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_PooledArray__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Plane__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osg_utils__ = __webpack_require__(1);













/**
 * [ComputeFrustumBoundsVisitor get a scene bounds limited by a light and camera frustum]
 */
var ComputeMultiFrustumBoundsVisitor = function() {
    __WEBPACK_IMPORTED_MODULE_9_osg_NodeVisitor__["a" /* default */].call(this, __WEBPACK_IMPORTED_MODULE_9_osg_NodeVisitor__["a" /* default */].TRAVERSE_ALL_CHILDREN);

    this._pooledMatrix = new __WEBPACK_IMPORTED_MODULE_6_osg_PooledResource__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].create);

    this._matrixStack = new __WEBPACK_IMPORTED_MODULE_7_osg_PooledArray__["a" /* default */]();
    this._matrixStack.push(__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].IDENTITY);

    this._bb = new __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__["a" /* default */]();
    this._bs = new __WEBPACK_IMPORTED_MODULE_1_osg_BoundingSphere__["a" /* default */]();
};

/*
 * TODO: apply world matrix on the traverse instead of per node
 */
__WEBPACK_IMPORTED_MODULE_11_osg_utils__["a" /* default */].createPrototypeObject(
    ComputeMultiFrustumBoundsVisitor,
    __WEBPACK_IMPORTED_MODULE_11_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_9_osg_NodeVisitor__["a" /* default */].prototype, {
        reset: function(traversalMask, worldLightPos, cameraFrustum, cameraNearFar, lightFrustum) {
            this.setTraversalMask(traversalMask);

            this._cameraFrustum = cameraFrustum;
            this._lightFrustum = lightFrustum;

            // what plane to exclude from shadowedscene
            this.getCameraPlaneMaskForLightNear(
                worldLightPos,
                cameraFrustum,
                cameraNearFar ? 6 : 4
            );

            this._pooledMatrix.reset();
            this._matrixStack.reset();
            this._matrixStack.push(__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].IDENTITY);
            this._bb.init();
        },

        getBoundingBox: function() {
            return this._bb;
        },

        getCameraPlaneMaskForLightNear: function(point, cameraFrustum, len) {
            var selectorMask = 0x1;
            var resultMask = 15;
            var i;

            for (i = 0; i < len; ++i) {
                resultMask = (resultMask << 1) | 1;
            }

            var planeList = cameraFrustum.getPlanes();
            for (i = 0; i < len; ++i) {
                if (__WEBPACK_IMPORTED_MODULE_10_osg_Plane__["a" /* default */].distanceToPlane(planeList[i], point) < 0.0) {
                    // Ligth frustum source poitn is outside this plane.
                    // subsequent checks against this plane not required.
                    // as light position is behind those,
                    // and culling that would cull light near
                    resultMask ^= selectorMask;
                }
                selectorMask <<= 1;
            }
            this._cameraPlaneMaskedByLightNear = resultMask;

            cameraFrustum.setResultMask(resultMask);
            cameraFrustum.pushCurrentMask(resultMask);
            return resultMask;
        },

        applyTransform: function(transform) {
            var matrix = this._pooledMatrix.getOrCreateObject();
            __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].copy(matrix, this._matrixStack.back());
            transform.computeLocalToWorldMatrix(matrix, this);

            var bs = this._bs;
            transform.getBound().transformMat4(this._bs, matrix);

            // camera cull
            if (this._cameraFrustum.getCurrentMask() !== 0) {
                // father bounding sphere is not totally inside
                // now test this one
                if (!this._cameraFrustum.containsBoundingSphere(bs)) return; // culled
            }

            // light cull
            if (this._lightFrustum.getCurrentMask() !== 0) {
                // father bounding sphere is not totally inside
                // now test this one
                if (!this._lightFrustum.containsBoundingSphere(bs)) return; // culled
            }

            this._cameraFrustum.pushCurrentMask();
            this._lightFrustum.pushCurrentMask();

            this.pushMatrix(matrix);

            this.traverse(transform);

            this._cameraFrustum.popCurrentMask();
            this._lightFrustum.popCurrentMask();

            this.popMatrix();
        },
        applyBoundingBox: (function() {
            var bbOut = new __WEBPACK_IMPORTED_MODULE_0_osg_BoundingBox__["a" /* default */]();
            return function(bbox) {
                var matrix = this._matrixStack.back();
                if (__WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].exactEquals(matrix, __WEBPACK_IMPORTED_MODULE_5_osg_glMatrix__["c" /* mat4 */].IDENTITY)) {
                    this._bb.expandByBoundingBox(bbox);
                } else if (bbox.valid()) {
                    bbox.transformMat4(bbOut, matrix);
                    this._bb.expandByBoundingBox(bbOut);
                }
            };
        })(),

        apply: function(node) {
            var typeID = node.getTypeID();

            if (node instanceof __WEBPACK_IMPORTED_MODULE_8_osg_MatrixTransform__["a" /* default */]) {
                this.applyTransform(node);
                return;
            } else if (typeID === __WEBPACK_IMPORTED_MODULE_3_osg_Geometry__["a" /* default */].getTypeID()) {
                var bs = this._bs;
                node.getBound().transformMat4(bs, this._matrixStack.back());

                // camera cull
                if (this._cameraFrustum.getCurrentMask() !== 0) {
                    // father bounding sphere is not totally inside
                    // now test this one
                    if (!this._cameraFrustum.containsBoundingSphere(bs)) return; // culled
                }

                // light cull
                if (this._lightFrustum.getCurrentMask() !== 0) {
                    // father bounding sphere is not totally inside
                    // now test this one
                    if (!this._lightFrustum.containsBoundingSphere(bs)) return; // culled
                }

                // Visible: we enlarge the bbox
                this.applyBoundingBox(node.getBoundingBox());

                return;
            } else if (typeID === __WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */].getTypeID()) {
            } else if (typeID === __WEBPACK_IMPORTED_MODULE_4_osg_Light__["a" /* default */].getTypeID()) {
            }

            this.traverse(node);
        },

        pushMatrix: function(matrix) {
            this._matrixStack.push(matrix);
        },

        popMatrix: function() {
            this._matrixStack.pop();
        }
    }),
    'osgShadow',
    'ComputeMultiFrustumBoundsVisitor'
);

/* harmony default export */ __webpack_exports__["a"] = (ComputeMultiFrustumBoundsVisitor);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Camera__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowTechnique__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgShadow_ShadowTextureAtlas__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgShadow_ShadowMap__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__ = __webpack_require__(36);












/**
 *  ShadowMapAtlas provides an implementation of shadow textures.
 * here, one shadow
 *  @class ShadowMapAtlas
 */
var ShadowMapAtlas = function(settings) {
    this._lights = [];
    this._shadowMaps = [];
    this._viewportDimension = [];

    __WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowTechnique__["a" /* default */].apply(this, arguments);
    this._shadowSettings = settings;
    this._texture = new __WEBPACK_IMPORTED_MODULE_5_osgShadow_ShadowTextureAtlas__["a" /* default */]();
    this._textureUnitBase = 4;
    this._textureUnit = this._textureUnitBase;

    // see shadowSettings.js header for param explanations
    this._textureMagFilter = undefined;
    this._textureMinFilter = undefined;

    this._textureSize = 1024;
    this._shadowMapSize = 256;

    this._receivingStateset = undefined;

    this._shaderProcessor = undefined;

    if (settings) {
        this.setShadowSettings(settings);
        if (settings.atlasSize) this._textureSize = settings.atlasSize;
        if (settings.textureSize) this._shadowMapSize = settings.textureSize;
    }

    this._texelSizeUniform = __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat1(1.0 / this._textureSize, 'texelSize');

    var unifRenderSize = __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat2('RenderSize');
    this._renderSize = unifRenderSize.getInternalArray();
    this._renderSize[0] = this._renderSize[1] = this._textureSize;

    this._numShadowWidth = this._textureSize / this._shadowMapSize;
    this._numShadowHeight = this._textureSize / this._shadowMapSize;

    this._cameraClear = new __WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */]();
    this._cameraClear.setName('shadowAtlasCameraClear');
    this._cameraClear.setRenderOrder(__WEBPACK_IMPORTED_MODULE_2_osg_Camera__["a" /* default */].PRE_RENDER, 0);
    this._cameraClear.setClearColor(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(1.0, 1.0, 1.0, 1.0));
    this._cameraClear.setFrameBufferObject(new __WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */]());
    this._cameraClear.setClearMask(0x0);
};

/** @lends ShadowMapAtlas.prototype */
__WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].createPrototypeObject(
    ShadowMapAtlas,
    __WEBPACK_IMPORTED_MODULE_3_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowTechnique__["a" /* default */].prototype, {
        getTexture: function() {
            return this._texture;
        },

        isDirty: function(ligthtIndex) {
            if (ligthtIndex !== undefined) {
                return this._shadowMaps[ligthtIndex].isDirty();
            } else {
                for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                    if (this._shadowMaps[i].isDirty()) return true;
                }
            }
            return false;
        },
        /**
         * at which Texture unit number we start adding texture shadow
         */
        setTextureUnitBase: function(unitBase) {
            this._textureUnitBase = unitBase;
            this._textureUnit = unitBase;

            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setTextureUnitBase(unitBase);
            }
        },

        /* Sets  shadowSettings
        */
        setShadowSettings: function(shadowSettings) {
            if (!shadowSettings) return;
            this._shadowSettings = shadowSettings;

            for (var i = 0, l = this._shadowMaps.length; i < l; i++)
                this._shadowMaps[i].setShadowSettings(shadowSettings);

            this.setTextureSize(shadowSettings.textureSize);
            this.setTexturePrecision(shadowSettings.textureType);
        },

        setCastsShadowDrawTraversalMask: function(mask) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setCastsShadowDrawTraversalMask(mask);
            }
        },

        getCastsShadowDrawTraversalMask: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getCastsShadowDrawTraversalMask();
            } else if (this._shadowMaps.length !== 0) {
                return this._shadowMaps[0].getCastsShadowDrawTraversalMask();
            }
        },

        setCastsShadowBoundsTraversalMask: function(mask) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setCastsShadowBoundsTraversalMask(mask);
            }
        },

        getCastsShadowBoundsTraversalMask: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getCastsShadowDrawTraversalMask();
            } else if (this._shadowMaps.length !== 0) {
                return this._shadowMaps[0].getCastsShadowDrawTraversalMask();
            }
        },

        getNormalBias: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getNormalBias();
            } else if (this._shadowMaps.length !== 0) {
                return this._shadowMaps[0].getNormalBias();
            }
        },

        setNormalBias: function(value) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setNormalBias(value);
            }
        },

        getBias: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getBias();
            } else if (this._shadowMaps.length !== 0) {
                return this._shadowMaps[0].getBias();
            }
        },

        setBias: function(value) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setBias(value);
            }
        },

        getKernelSizePCF: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getKernelSizePCF();
            } else if (this._shadowMaps.length !== 1) {
                return this._shadowMaps[0].getKernelSizePCF();
            }
        },

        setKernelSizePCF: function(value) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setKernelSizePCF(value);
            }
        },

        setShadowedScene: function(shadowedScene) {
            __WEBPACK_IMPORTED_MODULE_4_osgShadow_ShadowTechnique__["a" /* default */].prototype.setShadowedScene.call(this, shadowedScene);
            this._receivingStateset = this._shadowedScene.getReceivingStateSet();

            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setShadowedScene(shadowedScene);
            }
        },

        setTexturePrecision: function(value) {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].setTexturePrecision(value);
            }
        },

        getTexturePrecision: function(numShadow) {
            if (numShadow !== undefined) {
                return this._shadowMaps[numShadow].getTexturePrecision();
            } else if (this._shadowMaps.length !== 1) {
                return this._shadowMaps[0].getTexturePrecision();
            }
        },

        setTextureSize: function(mapSize) {
            if (mapSize === this._textureSize) return;

            //this._textureSize = mapSize;
            //this._textureSize = settings.atlasSize;
            this._shadowMapSize = mapSize;

            this._numShadowWidth = this._textureSize / this._shadowMapSize;
            this._numShadowHeight = this._textureSize / this._shadowMapSize;

            this.dirty();
        },

        getShadowMap: function(lightNum) {
            return this._shadowMaps[lightNum];
        },

        addLight: function(light) {
            if (!light || this._lights.indexOf(light) !== -1) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn('no light or light already added');
                return -1;
            }

            var lightCount = this._lights.length;
            if (lightCount === this._numShadowWidth * this._numShadowHeight) {
                __WEBPACK_IMPORTED_MODULE_0_osg_notify__["a" /* default */].warn(
                    "can't allocate shadow for light " +
                        light.getLightNumber() +
                        ' ShadowAtlas already full '
                );
                return undefined;
            }

            this._lights.push(light);
            this._shadowSettings.setLight(light);

            var shadowMap = new __WEBPACK_IMPORTED_MODULE_6_osgShadow_ShadowMap__["a" /* default */](this._shadowSettings, this._texture);
            this._shadowMaps.push(shadowMap);

            if (this._shadowedScene) shadowMap.setShadowedScene(this._shadowedScene);

            this.recomputeViewports();

            return shadowMap;
        },

        /** initialize the ShadowedScene and local cached data structures.*/
        init: function() {
            if (!this._shadowedScene) return;

            this.initTexture();
            var lightNumberArray = [];
            for (var k = 0; k < this._lights.length; k++) {
                lightNumberArray.push(this._lights[k].getLightNumber());
            }
            this._texture.setLightNumberArray(lightNumberArray);

            this._textureUnit = this._textureUnitBase;
            this._texture.setName('ShadowTexture' + this._textureUnit);

            var unifRenderSize = __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat2('RenderSize');
            this._texelSizeUniform = __WEBPACK_IMPORTED_MODULE_9_osg_Uniform__["a" /* default */].createFloat1(1.0 / this._textureSize, 'texelSize');
            this._renderSize = unifRenderSize.getInternalArray();
            this._renderSize[0] = this._renderSize[1] = this._textureSize;

            this.recomputeViewports();
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                var shadowMap = this._shadowMaps[i];

                if (!this._shadowedScene)
                    this._shadowedScene = shadowMap.getShadowedScene(this._shadowedScene);
                if (this._shadowedScene) shadowMap.setShadowedScene(this._shadowedScene);
                shadowMap.init(this._texture, i, this._textureUnitBase);
            }
        },

        recomputeViewports: function() {
            var numViews = this._shadowMaps.length;

            var viewDivideY = numViews > 2 ? Math.sqrt(2 * Math.ceil(numViews / 2)) : numViews;
            var viewDivideX = viewDivideY;

            var mapSizeX = this._textureSize / viewDivideX;
            var mapSizeY = this._textureSize / viewDivideY;

            var numShadowWidth = this._textureSize / mapSizeX;
            var numShadowHeight = this._textureSize / mapSizeY;

            for (var i = 0; i < numViews; i++) {
                var shadowMap = this._shadowMaps[i];

                var x = mapSizeX * (i % numShadowWidth);
                var y = mapSizeY * Math.floor(i / numShadowHeight);

                if (this._viewportDimension.length <= i) {
                    this._viewportDimension.push(__WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].fromValues(x, y, mapSizeX, mapSizeY));
                } else {
                    __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].set(this._viewportDimension[i], x, y, mapSizeX, mapSizeY);
                }

                this._texture.setLightShadowMapSize(
                    this._lights[i].getLightNumber(),
                    this._viewportDimension[i]
                );

                shadowMap.dirty();
            }
        },

        valid: function() {
            // checks
            return true;
        },

        updateCameraClear: function() {
            var camera = this._cameraClear;
            var texture = this._texture;

            if (camera && texture) {
                var vp = camera.getViewport();

                if (!vp) {
                    vp = new __WEBPACK_IMPORTED_MODULE_10_osg_Viewport__["a" /* default */]();
                    camera.setViewport(vp);
                }

                // if texture size changed update the camera rtt params
                if (vp.width() !== texture.getWidth() || vp.height() !== texture.getHeight()) {
                    camera.detachAll();

                    camera.attachTexture(__WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */].COLOR_ATTACHMENT0, texture);
                    camera.attachRenderBuffer(
                        __WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */].DEPTH_ATTACHMENT,
                        __WEBPACK_IMPORTED_MODULE_8_osg_FrameBufferObject__["a" /* default */].DEPTH_COMPONENT16
                    );
                    camera.getViewport().setViewport(0, 0, texture.getWidth(), texture.getHeight());
                }
            }
        },

        updateShadowTechnique: function(nv) {
            this.updateCameraClear();
            var fbo = this._cameraClear.getFrameBufferObject();
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].updateShadowTechnique(nv, this._viewportDimension[i], fbo);
            }
        },

        // internal texture allocation
        // handle any change like resize, filter param, etc.
        initTexture: function() {
            if (!this._dirty) return;

            if (!this._texture) {
                this._texture = new __WEBPACK_IMPORTED_MODULE_5_osgShadow_ShadowTextureAtlas__["a" /* default */]();
                this._textureUnit = this._textureUnitBase;
            }

            this._texture.setTextureSize(this._textureSize, this._textureSize);
            this._texelSizeUniform.setFloat(1.0 / this._textureSize);
            this._renderSize[0] = this._textureSize;
            this._renderSize[1] = this._textureSize;

            var textureFormat;
            // luminance Float format ?
            textureFormat = __WEBPACK_IMPORTED_MODULE_7_osg_Texture__["default"].RGBA;

            __WEBPACK_IMPORTED_MODULE_6_osgShadow_ShadowMap__["a" /* default */].prototype.setTextureFiltering.call(this);
            this._texture.setInternalFormat(textureFormat);

            this._texture.setWrapS(__WEBPACK_IMPORTED_MODULE_7_osg_Texture__["default"].CLAMP_TO_EDGE);
            this._texture.setWrapT(__WEBPACK_IMPORTED_MODULE_7_osg_Texture__["default"].CLAMP_TO_EDGE);

            this._texture.dirty();
        },

        // Defines the frustum from light param.
        //
        cullShadowCasting: function(cullVisitor, bbox) {
            this._cameraClear.accept(cullVisitor);

            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                var shadowMap = this._shadowMaps[i];
                if (shadowMap.isContinuousUpdate() || shadowMap.needRedraw()) {
                    shadowMap.cullShadowCasting(cullVisitor, bbox);
                }
            }
        },

        isContinuousUpdate: function() {
            // need at least one shadow to be enabled
            // so that shadowedScene will continue shadowCasting
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                if (this._shadowMaps[i].isContinuousUpdate()) {
                    return true;
                }
            }
            return false;
        },

        needRedraw: function() {
            // need at least one shadow not dirty
            // so that shadowedScene will continue shadowCasting
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                if (this._shadowMaps[i].needRedraw()) {
                    return true;
                }
            }
            return false;
        },

        removeShadowMap: function(shadowMap) {
            if (this._shadowMaps.length > 0) {
                var idx = this._shadowMaps.indexOf(shadowMap);
                if (idx !== -1) {
                    if (this._shadowMaps[idx].valid()) {
                        this._shadowMaps[idx].cleanSceneGraph(true);
                    }
                    this._shadowMaps.splice(idx, 1);

                    var lightNumberArray = this._texture.getLightNumberArray();
                    idx = lightNumberArray.indexOf(shadowMap.getLightNumber());
                    if (idx !== -1) lightNumberArray.splice(idx, 1);

                    var light = shadowMap.getLight();
                    idx = this._lights.indexOf(light);
                    if (idx !== -1) this._lights.splice(idx, 1);

                    if (this._viewportDimension.length > idx) {
                        this._viewportDimension.splice(idx, 1);
                    }

                    this.recomputeViewports();
                }
            }
        },

        addShadowMap: function(shadowMap) {
            if (this._shadowMaps.length > 0) {
                if (this._shadowMaps.indexOf(shadowMap) !== -1) return;
            }

            this._shadowMaps.push(shadowMap);

            var light = shadowMap.getLight();
            if (this._lights.indexOf(light) === -1) {
                this._lights.push(light);
            }

            if (this._shadowedScene) shadowMap.setShadowedScene(this._shadowedScene);

            var lightNumberArray = this._texture.getLightNumberArray();
            if (lightNumberArray.indexOf(shadowMap.getLightNumber()) === -1) {
                lightNumberArray.push(light.getLightNumber());
            }

            this.recomputeViewports();
        },

        cleanReceivingStateSet: function() {
            if (this._receivingStateset) {
                if (this._texture) {
                    // remove this._texture, but not if it's not this._texture
                    if (
                        this._receivingStateset.getTextureAttribute(
                            this._textureUnit,
                            this._texture.getTypeMember()
                        ) === this._texture
                    )
                        this._receivingStateset.removeTextureAttribute(
                            this._textureUnit,
                            this._texture.getTypeMember()
                        );
                }

                for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                    this._shadowMaps[i].cleanReceivingStateSet();
                }
            }
        },
        cleanSceneGraph: function() {
            // TODO: need state
            //this._texture.releaseGLObjects();
            //this._shadowReceiveAttribute = undefined;
            this._texture = undefined;
            this._shadowedScene = undefined;
        },
        setDebug: function(enable, lightNum) {
            if (!lightNum) {
                for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                    this._shadowMaps[i].setDebug(enable);
                }
            } else {
                this._shadowMaps[lightNum].setDebug(enable);
            }
        },
        markSceneAsNoShadow: function() {
            for (var i = 0, l = this._shadowMaps.length; i < l; i++) {
                this._shadowMaps[i].markSceneAsNoShadow();
            }
        }
    }),
    'osgShadow',
    'ShadowMapAtlas'
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowMapAtlas);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_Texture__ = __webpack_require__(7);



var kernelSizeList = [
    '1Tap(4texFetch)',
    '4Tap(16texFetch)',
    '9Tap(36texFetch)',
    '16Tap(64texFetch)'
];

/**
 *  ShadowSettings provides the parameters that the ShadowTechnique should use as a guide for setting up shadowing
 *  @class ShadowSettings
 */
var ShadowSettings = function(options) {
    this.castsShadowDrawTraversalMask = 0xffffffff;
    this.castsShadowBoundsTraversalMask = 0xffffffff;

    this.textureSize = 1024;

    // important note:
    // comparison shadow is: DepthShadow > DephFragment => shadowed
    // which is d<z
    // and
    // Average( (d < z) ) != (Average( z ) < d)
    // so PCF/NONE technique cannot be prefiltered (bilinear, etc..) with HW filter
    // on gl/dx desktop there is a sampler2DShadow that allows that taking z in third param
    // we emulate that with texture2DShadowLerp
    // which is why some techniques have more texfetch than advertized.
    // http://http.developer.nvidia.com/GPUGems/gpugems_ch11.html

    // texture precision. (and bandwith implication)
    this.textureType = 'UNSIGNED_BYTE';

    this.textureFormat = __WEBPACK_IMPORTED_MODULE_1_osg_Texture__["default"].RGBA;

    // either orthogonal (non-fov) or perpsective (fov)
    this.shadowProjection = 'fov';
    // fov size: can be infered from spotlight angle
    this.fov = 50;

    // PCF algo and kernel size
    // Band kernelsize gives nxn texFetch
    // others a n*n*4 (emulating the HW shadowSampler)
    // ['4Tap(16texFetch)', '9Tap(36texFetch)', '16Tap(64texFetch)']
    this.kernelSizePCF = '4Tap(4texFetch)';

    // depth offset (shadow acne / peter panning)
    this.bias = 0.005;

    // normal exploding offset (shadow acne / peter panning)
    this.normalBias = undefined;

    // defaut shader generator name for shadow casting
    this.shadowCastShaderGeneratorName = 'ShadowCast';

    // if url options override url options
    __WEBPACK_IMPORTED_MODULE_0_osg_utils__["a" /* default */].objectMix(this, options);
};

ShadowSettings.kernelSizeList = kernelSizeList;

ShadowSettings.prototype = {
    setCastsShadowDrawTraversalMask: function(mask) {
        this.castsShadowDrawTraversalMask = mask;
    },
    getCastsShadowDrawTraversalMask: function() {
        return this.castsDrawShadowTraversalMask;
    },

    setCastsShadowBoundsTraversalMask: function(mask) {
        this.castsShadowBoundsTraversalMask = mask;
    },
    getCastsShadowBoundsTraversalMask: function() {
        return this.castsShadowBoundsTraversalMask;
    },

    setLight: function(light) {
        this.light = light;
    },
    getLight: function() {
        return this.light;
    },

    setTextureSize: function(textureSize) {
        this.textureSize = textureSize;
    },
    getTextureSize: function() {
        return this.textureSize;
    },
    setTextureType: function(tt) {
        this.textureType = tt;
    },
    getTextureType: function() {
        return this.textureType;
    },
    setTextureFormat: function(tf) {
        this.textureFormat = tf;
    },
    getTextureFormat: function() {
        return this.textureFormat;
    },
    setShadowCastShaderGeneratorName: function(n) {
        this.shadowCastShaderGeneratorName = n;
    },
    getShadowCastShaderGeneratorName: function() {
        return this.shadowCastShaderGeneratorName;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (ShadowSettings);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_Node__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osg_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osg_ComputeBoundsVisitor__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgShadow_ShadowCasterVisitor__ = __webpack_require__(170);










/**
 *  ShadowedScene provides a mechanism for decorating a scene that the needs to have shadows cast upon it.
 *  @class ShadowedScene
 *  @{@link [http://trac.openscenegraph.org/projects/osg//wiki/Support/ProgrammingGuide/osgShadow]}
 *  @{@link [http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf]};
 */
var ShadowedScene = function(settings) {
    __WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].call(this);

    // TODO: all  techniques (stencil/projTex/map/vol)
    this._shadowTechniques = [];

    this._optimizedFrustum = false;

    this._frustumReceivers = [
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create(),
        __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["g" /* vec4 */].create()
    ];

    this._tmpMat = __WEBPACK_IMPORTED_MODULE_1_osg_glMatrix__["c" /* mat4 */].create();

    this._receivingStateset = new __WEBPACK_IMPORTED_MODULE_4_osg_StateSet__["a" /* default */]();

    this._computeBoundsVisitor = new __WEBPACK_IMPORTED_MODULE_6_osg_ComputeBoundsVisitor__["default"]();

    this._castsShadowDrawTraversalMask = 0xffffffff;
    this._castsShadowBoundsTraversalMask = 0xffffffff;
    if (settings) this.setShadowSettings(settings);
};

/** @lends ShadowedScene.prototype */
__WEBPACK_IMPORTED_MODULE_5_osg_utils__["a" /* default */].createPrototypeNode(
    ShadowedScene,
    __WEBPACK_IMPORTED_MODULE_5_osg_utils__["a" /* default */].objectInherit(__WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].prototype, {
        getReceivingStateSet: function() {
            return this._receivingStateset;
        },

        getShadowTechniques: function() {
            return this._shadowTechniques;
        },

        addShadowTechnique: function(technique) {
            if (this._shadowTechniques.length > 0) {
                if (this._shadowTechniques.indexOf(technique) !== -1) return;
            }

            this._shadowTechniques.push(technique);

            if (technique.valid()) {
                technique.setShadowedScene(this);
                technique.dirty();
            }
        },
        removeShadowTechnique: function(technique) {
            if (this._shadowTechniques.length > 0) {
                var idx = this._shadowTechniques.indexOf(technique);
                if (idx !== -1) {
                    if (this._shadowTechniques[idx].valid()) {
                        this._shadowTechniques[idx].cleanSceneGraph();
                    }
                    this._shadowTechniques.splice(idx, 1);
                }
            }
        },
        /** Clean scene graph from any shadow technique specific nodes, state and drawables.*/
        cleanSceneGraph: function() {
            for (var i = 0, lt = this._shadowTechniques.length; i < lt; i++) {
                if (this._shadowTechniques[i] && this._shadowTechniques[i].valid()) {
                    this._shadowTechniques[i].cleanSceneGraph();
                }
            }
        },

        /** Dirty any cache data structures held in the attached ShadowTechnique.*/
        dirty: function() {
            for (var i = 0; i < this._shadowTechniques.length; i++)
                this._shadowTechniques[i].dirty();
        },

        nodeTraverse: function(nv) {
            __WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].prototype.traverse.call(this, nv);
        },

        setShadowSettings: function(shadowSettings) {
            this._settings = shadowSettings;

            this.setCastsShadowDrawTraversalMask(shadowSettings.castsShadowDrawTraversalMask);
            this.setCastsShadowBoundsTraversalMask(shadowSettings.castsShadowBoundsTraversalMask);

            // Overridable Visitor so that user can override the visitor to enable disable
            // in its own shadowmap implementation
            // settings.userShadowCasterVisitor:
            // - undefined means using default
            // - false means no removal visitor needed
            // - otherwise must be an instance of a class inherited from shadowCaster
            if (shadowSettings.userShadowCasterVisitor !== false) {
                this._removeNodesNeverCastingVisitor =
                    shadowSettings.userShadowCasterVisitor ||
                    new __WEBPACK_IMPORTED_MODULE_7_osgShadow_ShadowCasterVisitor__["a" /* default */](this._castsShadowTraversalMask);
            }
        },

        setCastsShadowDrawTraversalMask: function(mask) {
            this._castsShadowDrawTraversalMask = mask;
        },

        getCastsShadowDrawTraversalMask: function() {
            return this._castsDrawShadowTraversalMask;
        },

        setCastsShadowBoundsTraversalMask: function(mask) {
            this._castsShadowBoundsTraversalMask = mask;
        },

        getCastsShadowBoundsTraversalMask: function() {
            return this._castsShadowBoundsTraversalMask;
        },

        computeShadowedSceneBounds: function() {
            if (this._removeNodesNeverCastingVisitor) {
                this._removeNodesNeverCastingVisitor.setNoCastMask(
                    ~(this._castsShadowBoundsTraversalMask | this._castsShadowDrawTraversalMask)
                );
                this._removeNodesNeverCastingVisitor.reset();
                this.accept(this._removeNodesNeverCastingVisitor);
            }

            this._computeBoundsVisitor.setTraversalMask(this._castsShadowBoundsTraversalMask);
            this._computeBoundsVisitor.reset();
            this.accept(this._computeBoundsVisitor);
            var bbox = this._computeBoundsVisitor.getBoundingBox();

            if (!bbox.valid()) {
                // nothing to draw Early out.
                if (this._removeNodesNeverCastingVisitor) {
                    // remove our flags changes on any bitmask
                    // not to break things
                    this._removeNodesNeverCastingVisitor.restore();
                }

                return false;
            }

            return true;
        },

        traverse: function(nv) {
            // update the scene
            if (nv.getVisitorType() === __WEBPACK_IMPORTED_MODULE_3_osg_NodeVisitor__["a" /* default */].CULL_VISITOR) {
                var i,
                    st,
                    lt = this._shadowTechniques.length;

                // cull Shadowed Scene
                if (lt) nv.pushStateSet(this._receivingStateset);
                this.nodeTraverse(nv);
                if (lt) nv.popStateSet();

                var isDirty = false;
                for (i = 0; i < lt; i++) {
                    st = this._shadowTechniques[i];

                    // dirty check for user playing with shadows inside update traverse
                    if (!st || !st.valid()) continue;

                    if (st.isDirty()) {
                        isDirty = true;
                        st.init();
                    }

                    if (st.isContinuousUpdate() || st.needRedraw()) isDirty = true;
                }
                if (!isDirty) return;

                var hasCastingScene = this.computeShadowedSceneBounds(nv);
                if (!hasCastingScene) {
                    // no shadow but still may need to clear
                    // and makes sure shadow receiver shader
                    // uses optimized early out codepath
                    for (i = 0; i < lt; i++) {
                        st = this._shadowTechniques[i];
                        st.markSceneAsNoShadow();
                    }

                    return;
                }
                var bbox = this._computeBoundsVisitor.getBoundingBox();

                // HERE we get the shadowedScene Current World Matrix
                // to get any world transform ABOVE the shadowedScene
                var worldMatrix = nv.getCurrentModelMatrix();
                bbox.transformMat4(bbox, worldMatrix);

                // cull Casters
                for (i = 0; i < lt; i++) {
                    st = this._shadowTechniques[i];
                    if (st.isContinuousUpdate() || st.needRedraw()) {
                        st.updateShadowTechnique(nv);
                        st.cullShadowCasting(nv, bbox);
                    }
                }

                if (this._removeNodesNeverCastingVisitor) {
                    // remove our flags changes on any bitmask
                    // not to break things
                    this._removeNodesNeverCastingVisitor.restore();
                }
            } else {
                this.nodeTraverse(nv);
            }
        }
    }),
    'osgShadow',
    'ShadowedScene'
);

// same code like Node
__WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__["a" /* default */].registerApplyFunction(
    ShadowedScene.nodeTypeID,
    __WEBPACK_IMPORTED_MODULE_0_osg_CullVisitor__["a" /* default */].getApplyFunction(__WEBPACK_IMPORTED_MODULE_2_osg_Node__["a" /* default */].nodeTypeID)
);

/* harmony default export */ __webpack_exports__["a"] = (ShadowedScene);


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgStats_Stats__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgStats_BufferStats__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgStats_Graph__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgStats_TextGenerator__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgStats_Counter__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgStats_defaultStats__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgStats_browserStats__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgStats_glStats__ = __webpack_require__(167);









var osgStats = {
    Stats: __WEBPACK_IMPORTED_MODULE_0_osgStats_Stats__["a" /* default */],
    BufferStats: __WEBPACK_IMPORTED_MODULE_1_osgStats_BufferStats__["a" /* default */],
    Graph: __WEBPACK_IMPORTED_MODULE_2_osgStats_Graph__["a" /* default */],
    TextGenerator: __WEBPACK_IMPORTED_MODULE_3_osgStats_TextGenerator__["a" /* default */],
    Counter: __WEBPACK_IMPORTED_MODULE_4_osgStats_Counter__["a" /* default */],
    defaultStats: __WEBPACK_IMPORTED_MODULE_5_osgStats_defaultStats__["a" /* default */],
    browserStats: __WEBPACK_IMPORTED_MODULE_6_osgStats_browserStats__["a" /* default */],
    glStats: __WEBPACK_IMPORTED_MODULE_7_osgStats_glStats__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (osgStats);


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgText_Text__ = __webpack_require__(137);


var osgText = {};
osgText.Text = __WEBPACK_IMPORTED_MODULE_0_osgText_Text__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgText);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgWrappers_serializers_osg__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgWrappers_serializers_osgAnimation__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgWrappers_serializers_osgText__ = __webpack_require__(136);




var osgWrappers = {};

osgWrappers.osg = __WEBPACK_IMPORTED_MODULE_0_osgWrappers_serializers_osg__["a" /* default */];
osgWrappers.osgAnimation = __WEBPACK_IMPORTED_MODULE_1_osgWrappers_serializers_osgAnimation__["a" /* default */];
osgWrappers.osgText = __WEBPACK_IMPORTED_MODULE_2_osgWrappers_serializers_osgText__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgWrappers);


/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_osgPlugins_ReaderWriterGLTF__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgPlugins_ReaderWriterZIP__ = __webpack_require__(260);



var osgPlugins = {};

osgPlugins.ReaderWriterGLTF = __WEBPACK_IMPORTED_MODULE_0_osgPlugins_ReaderWriterGLTF__["a" /* default */];
osgPlugins.ReaderWriterZIP = __WEBPACK_IMPORTED_MODULE_1_osgPlugins_ReaderWriterZIP__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (osgPlugins);


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgDB_requestFile__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osgDB_Input__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgDB_Registry__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgAnimation_animation__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgAnimation_BasicAnimationManager__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_osgAnimation_Skeleton__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_osgAnimation_Bone__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_osgAnimation_StackedTranslate__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_osgAnimation_StackedQuaternion__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_osgAnimation_StackedScale__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_osgAnimation_RigGeometry__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_osgAnimation_channel__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_osg_BlendFunc__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_osg_Geometry__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_osg_Texture__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_osg_MatrixTransform__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_osg_Material__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_osg_DrawElements__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_osg_primitiveSet__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_osg_BufferArray__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_osgAnimation_UpdateBone__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_osgAnimation_UpdateMatrixTransform__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_osgDB_FileHelper__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__ = __webpack_require__(0);













var createQuatChannel = __WEBPACK_IMPORTED_MODULE_12_osgAnimation_channel__["a" /* default */].createQuatChannel;
var createVec3Channel = __WEBPACK_IMPORTED_MODULE_12_osgAnimation_channel__["a" /* default */].createVec3Channel;


















var ReaderWriterGLTF = function() {
    // Contains all the needed glTF files (.gltf, .bin, etc...)
    this._filesMap = undefined;
    this._loadedFiles = undefined;
    this._bufferViewCache = undefined;
    this._basicAnimationManager = undefined;
    this._visitedNodes = undefined;
    this._animatedNodes = undefined;
    this._skeletons = undefined;
    this._bones = undefined;
    this._skeletonToInfluenceMap = undefined;
    this._inputImgReader = undefined;
    this._localPath = '';

    this.init();
};

ReaderWriterGLTF.WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};

ReaderWriterGLTF.TYPE_TABLE = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};

ReaderWriterGLTF.TEXTURE_FORMAT = {
    6406: __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"].ALPHA,
    6407: __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"].RGB,
    6408: __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"].RGBA,
    6409: __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"].LUMINANCE,
    6410: __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"].LUMINANCE_ALPHA
};

ReaderWriterGLTF.PBR_SPEC_EXT = 'KHR_materials_pbrSpecularGlossiness';
ReaderWriterGLTF.PBR_SPEC_MODE = 'PBR_specular_glossiness';
ReaderWriterGLTF.PBR_METAL_MODE = 'PBR_metal_roughness';

ReaderWriterGLTF.ALBEDO_TEXTURE_UNIT = 2;
ReaderWriterGLTF.DIFFUSE_TEXTURE_UNIT = 2;
ReaderWriterGLTF.SPECULAR_GLOSSINESS_TEXTURE_UNIT = 3;
ReaderWriterGLTF.METALLIC_ROUGHNESS_TEXTURE_UNIT = 3;
ReaderWriterGLTF.SPECULAR_TEXTURE_UNIT = 4;
ReaderWriterGLTF.NORMAL_TEXTURE_UNIT = 5;
ReaderWriterGLTF.AO_TEXTURE_UNIT = 6;
ReaderWriterGLTF.EMISSIVE_TEXTURE_UNIT = 7;

ReaderWriterGLTF.ALBEDO_UNIFORM = 'albedoMap';
ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM = 'metallicRoughnessMap';
ReaderWriterGLTF.SPECULAR_UNIFORM = 'specularMap';
ReaderWriterGLTF.NORMAL_UNIFORM = 'normalMap';
ReaderWriterGLTF.AO_UNIFORM = 'aoMap';
ReaderWriterGLTF.EMISSIVE_UNIFORM = 'emissiveMap';

ReaderWriterGLTF.prototype = {
    init: function() {
        this._glTFJSON = undefined;
        this._bufferViewCache = {};
        this._basicAnimationManager = undefined;
        this._localPath = '';
        this._visitedNodes = {};
        this._animatedNodes = {};
        this._skeletons = {};
        this._bones = {};
        this._skeletonToInfluenceMap = {};
        this._stateSetMap = {};
        this._filesMap = new window.Map();
        this._inputReader = new __WEBPACK_IMPORTED_MODULE_2_osgDB_Input__["default"]();
    },

    loadFile: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(uri) {
        if (this._filesMap.has(uri)) return this._filesMap.get(uri);

        var ext = uri.substr(uri.lastIndexOf('.') + 1);
        var fileType = __WEBPACK_IMPORTED_MODULE_23_osgDB_FileHelper__["a" /* default */].getTypeForExtension(ext);

        var promiseFile;
        var url = this._localPath + uri;
        if (fileType === 'blob') {
            promiseFile = this._inputReader.readImageURL(url, {
                imageLoadingUsePromise: true
            });
        } else if (fileType === 'arraybuffer') {
            promiseFile = this._inputReader.readBinaryArrayURL(url, {
                fileType: fileType
            });
        }

        this._filesMap.set(uri, promiseFile);

        promiseFile.then(function(file) {
            return file;
        });
        return promiseFile;
    }),

    /**
     * Loads a osg.BufferArray from a TypeArray obtained by using a glTF accessor.
     * No memory allocation is done, the result is a subarray obtained from a glTF binary file
     * @param  {Object} accessor
     * @param  {osg.BufferArray.ARRAY_BUFFER | osg.BufferArray.ELEMENT_ARRAY_BUFFER} type WebGL buffer type
     * @param  {TypedArray} BufferType specific TypedArray type used for extraction
     * @return {osg.BufferArray} OSG readable buffer contaning the extracted data
     */
    loadAccessorBuffer: function(accessor, type) {
        var json = this._glTFJSON;
        var bufferView = json.bufferViews[accessor.bufferView];
        var buffer = json.buffers[bufferView.buffer];
        var filePromise = this.loadFile(buffer.uri);
        var self = this;
        return filePromise.then(function(data) {
            return self.assignBuffers(data, accessor, type, bufferView);
        });
    },

    assignBuffers: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(data, accessor, type, bufferView) {
        if (!data) return null;

        var TypedArray = ReaderWriterGLTF.WEBGL_COMPONENT_TYPES[accessor.componentType];
        var typedArray = null;

        if (!this._bufferViewCache[accessor.bufferView])
            this._bufferViewCache[accessor.bufferView] = data.slice(
                bufferView.byteOffset,
                bufferView.byteOffset + bufferView.byteLength
            );

        var bufferViewArray = this._bufferViewCache[accessor.bufferView];
        typedArray = new TypedArray(
            bufferViewArray,
            accessor.byteOffset,
            accessor.count * ReaderWriterGLTF.TYPE_TABLE[accessor.type]
        );

        if (type)
            return new __WEBPACK_IMPORTED_MODULE_20_osg_BufferArray__["a" /* default */](
                type,
                typedArray,
                ReaderWriterGLTF.TYPE_TABLE[accessor.type],
                true
            );
        return typedArray;
    }),

    findByKey: function(obj, key) {
        return obj && obj[key];
    },

    registerUpdateCallback: function(callbackName, node) {
        var json = this._glTFJSON;

        var animationCallback = null;
        if (json.nodes[callbackName].jointName) animationCallback = new __WEBPACK_IMPORTED_MODULE_21_osgAnimation_UpdateBone__["a" /* default */]();
        else animationCallback = new __WEBPACK_IMPORTED_MODULE_22_osgAnimation_UpdateMatrixTransform__["a" /* default */]();

        animationCallback.setName(callbackName);

        var translation = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["f" /* vec3 */].create();
        __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].getTranslation(translation, node.getMatrix());

        var rotationQuat = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["d" /* quat */].create();
        __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].getRotation(rotationQuat, node.getMatrix());

        var scale = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["f" /* vec3 */].create();
        __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].getScale(scale, node.getMatrix());

        animationCallback
            .getStackedTransforms()
            .push(new __WEBPACK_IMPORTED_MODULE_8_osgAnimation_StackedTranslate__["a" /* default */]('translation', translation));
        animationCallback
            .getStackedTransforms()
            .push(new __WEBPACK_IMPORTED_MODULE_9_osgAnimation_StackedQuaternion__["a" /* default */]('rotation', rotationQuat));
        animationCallback.getStackedTransforms().push(new __WEBPACK_IMPORTED_MODULE_10_osgAnimation_StackedScale__["a" /* default */]('scale', scale));

        node.addUpdateCallback(animationCallback);
    },

    createTextureAndSetAttrib: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(glTFTextureObject, stateSet, location, uniform) {
        if (!glTFTextureObject) return;
        var json = this._glTFJSON;
        var glTFTexture = json.textures[glTFTextureObject.index];
        if (!glTFTexture) return;

        var image = json.images[glTFTexture.source];

        if (!image) return;
        var texture = new __WEBPACK_IMPORTED_MODULE_15_osg_Texture__["default"]();
        // GLTF texture origin is correct
        texture.setFlipY(false);
        texture.setWrapS('REPEAT');
        texture.setWrapT('REPEAT');

        this.loadFile(image.uri).then(function(data) {
            if (!data) return;
            texture.setImage(data, ReaderWriterGLTF.TEXTURE_FORMAT[glTFTexture.format]);
            stateSet.setTextureAttributeAndModes(location, texture);
            if (uniform) {
                stateSet.addUniform(__WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createInt(location, uniform));
            }
            return;
        });
    }),

    /**
     * Creates a MatrixTransform node by using
     * glTF node's properties (matrix, translation, rotation, scale)
     * @param  {Object} glTFNode glTF node
     * @return {OSG.MatrixTransform} MatrixTransform node containing the glTF node transform
     */
    loadTransform: function(glTFNode) {
        var mat = __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].create();
        // The transform is given under a matrix form
        if (glTFNode.matrix) {
            __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].copy(mat, glTFNode.matrix);
            return mat;
        }
        // The transform is given under the form
        // translation, rotation, scale
        var scale = glTFNode.scale || __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["f" /* vec3 */].ONE;
        var rot = glTFNode.rotation || __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["d" /* quat */].IDENTITY;
        var trans = glTFNode.translation || __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["f" /* vec3 */].ZERO;

        __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].fromRotationTranslationScale(mat, rot, trans, scale);
        return mat;
    },

    preprocessChannel: function(glTFChannel, glTFAnim) {
        var json = this._glTFJSON;
        var promisesArray = [];

        var glTFSampler = glTFAnim.samplers[glTFChannel.sampler];

        var timeAccessor = json.accessors[glTFSampler.input];
        var valueAccessor = json.accessors[glTFSampler.output];

        var timePromise = this.loadAccessorBuffer(timeAccessor, null);
        var valuePromise = this.loadAccessorBuffer(valueAccessor, null);

        promisesArray.push(timePromise, valuePromise);

        var self = this;

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promisesArray).then(function(timeAndValue) {
            var timeKeys = timeAndValue[0];
            var valueKeys = timeAndValue[1];

            var osgChannel = null;

            if (ReaderWriterGLTF.TYPE_TABLE[valueAccessor.type] === 4) {
                osgChannel = createQuatChannel(
                    valueKeys,
                    timeKeys,
                    glTFChannel.target.node,
                    glTFChannel.target.path,
                    null
                );
            } else if (ReaderWriterGLTF.TYPE_TABLE[valueAccessor.type] === 3) {
                osgChannel = createVec3Channel(
                    valueKeys,
                    timeKeys,
                    glTFChannel.target.node,
                    glTFChannel.target.path,
                    null
                );
            }

            self._animatedNodes[glTFChannel.target.node] = true;

            return osgChannel;
        });
    },

    createAnimationFromChannels: function(channelsPromiseArray, animName) {
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(channelsPromiseArray).then(function(channels) {
            return __WEBPACK_IMPORTED_MODULE_4_osgAnimation_animation__["a" /* default */].createAnimation(channels, animName);
        });
    },

    /**
     * Loads all the solid animations registering
     * them in a BasicAnimationManager instance
     * @return {BasicAnimationManager} the animation manager containing the animations
     */
    preprocessAnimations: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function() {
        var json = this._glTFJSON;

        if (!json.animations) return;

        var animPromiseArray = [];

        var animationsObjectKeys = window.Object.keys(json.animations);
        for (var i = 0; i < animationsObjectKeys.length; ++i) {
            var glTFAnim = json.animations[animationsObjectKeys[i]];

            var channelsPromiseArray = [];
            // Creates each OSGJS channel
            for (var j = 0; j < glTFAnim.channels.length; ++j) {
                var glTFChannel = glTFAnim.channels[j];

                var osgChannel = this.preprocessChannel(glTFChannel, glTFAnim);
                channelsPromiseArray.push(osgChannel);
            }

            var animPromise = this.createAnimationFromChannels(
                channelsPromiseArray,
                animationsObjectKeys[i]
            );
            animPromiseArray.push(animPromise);
        }

        var self = this;
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(animPromiseArray).then(function(animations) {
            var animationManager = new __WEBPACK_IMPORTED_MODULE_5_osgAnimation_BasicAnimationManager__["a" /* default */]();
            animationManager.init(animations);

            self._basicAnimationManager = animationManager;
            animationManager.playAnimation(animations[0].name);
        });
    }),

    loadBone: function(boneId, skin) {
        var json = this._glTFJSON;
        var node = json.nodes[boneId];

        var self = this;

        var inverseBindMatricesAccessor = json.accessors[skin.inverseBindMatrices];
        var bonePromise = this.loadAccessorBuffer(inverseBindMatricesAccessor, null);
        return bonePromise.then(function(data) {
            // Creates the current bone
            // initializing it with initial pose
            for (var i = 0; i < skin.joints.length; ++i) {
                if (skin.joints[i] === node.jointName) break;
            }

            var boneNode = new __WEBPACK_IMPORTED_MODULE_7_osgAnimation_Bone__["a" /* default */](node.jointName);
            var invMat = data.subarray(i * 16, i * 16 + 16);
            boneNode.setInvBindMatrixInSkeletonSpace(invMat);

            self._bones[boneId] = boneNode;

            return boneNode;
        });
    },

    buildInfluenceMap: function(rootBoneId, skin) {
        if (this._skeletonToInfluenceMap[rootBoneId]) return;
        this._skeletonToInfluenceMap[rootBoneId] = {};
        for (var j = 0; j < skin.joints.length; j++) {
            var jointName = skin.joints[j];
            this._skeletonToInfluenceMap[rootBoneId][jointName] = j;
        }
    },

    mapBonesToSkin: function() {
        var json = this._glTFJSON;

        var boneToSkin = {};

        // Maps each bone ID to its skin
        var skinsKeys = window.Object.keys(json.skins);
        for (var i = 0; i < skinsKeys.length; ++i) {
            var skin = json.skins[skinsKeys[i]];

            for (var j = 0; j < skin.joints.length; ++j) {
                var jName = skin.joints[j];

                var nodesKeys = window.Object.keys(json.nodes);
                for (var k = 0; k < nodesKeys.length; ++k) {
                    var node = json.nodes[nodesKeys[k]];

                    if (node.jointName && node.jointName === jName) boneToSkin[nodesKeys[k]] = skin;
                }
            }
        }

        return boneToSkin;
    },

    preprocessBones: function(bonesToSkin) {
        var json = this._glTFJSON;
        var nodesKeys = window.Object.keys(json.nodes);
        var promises = [];
        for (var i = 0; i < nodesKeys.length; ++i) {
            var boneId = nodesKeys[i];
            var boneNode = json.nodes[boneId];
            if (!boneNode.jointName) continue;
            var bonePromise = this.loadBone(boneId, bonesToSkin[boneId]);
            promises.push(bonePromise);
        }
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promises);
    },

    preprocessSkeletons: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function() {
        var json = this._glTFJSON;
        if (!json.skins) return;
        var bonesToSkin = this.mapBonesToSkin();

        // Saves each skeleton in the skeleton maprep
        var nodesKeys = window.Object.keys(json.nodes);
        for (var j = 0; j < nodesKeys.length; ++j) {
            var nodeId = nodesKeys[j];
            var node = json.nodes[nodeId];
            var skin = json.skins[node.skin];

            if (!node.skeletons) continue;

            for (var i = 0; i < node.skeletons.length; ++i) {
                var rootBoneId = null;
                var rootJointId = node.skeletons[i];
                for (var k = 0; k < nodesKeys.length; ++k) {
                    var subnodeId = nodesKeys[k];
                    var subnode = json.nodes[subnodeId];
                    if (!subnode.jointName) continue;
                    var rootJoint = json.nodes[rootJointId];
                    if (subnode.jointName === rootJoint.jointName) {
                        rootBoneId = subnodeId;
                        break;
                    }
                }
                if (rootBoneId && !this._skeletons[rootBoneId]) {
                    this._skeletons[rootJointId] = new __WEBPACK_IMPORTED_MODULE_6_osgAnimation_Skeleton__["a" /* default */]();
                    // Adds missing bone to the boneMap
                    bonesToSkin[rootBoneId] = skin;
                }
                this.buildInfluenceMap(rootJointId, skin);
            }
        }

        return this.preprocessBones(bonesToSkin);
    }),

    loadPBRMaterial: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(materialId, glTFmaterial, geometryNode, extension) {
        var pbrMetallicRoughness = glTFmaterial.pbrMetallicRoughness;
        var osgStateSet = geometryNode.getOrCreateStateSet();

        var promises = [];
        var model = '';

        if (pbrMetallicRoughness) {
            if (pbrMetallicRoughness.baseColorTexture)
                promises.push(
                    this.createTextureAndSetAttrib(
                        pbrMetallicRoughness.baseColorTexture,
                        osgStateSet,
                        ReaderWriterGLTF.ALBEDO_TEXTURE_UNIT,
                        ReaderWriterGLTF.ALBEDO_UNIFORM
                    )
                );
            if (pbrMetallicRoughness.baseColorFactor) {
                //PBR default uniforms
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat4(pbrMetallicRoughness.baseColorFactor, 'uBaseColorFactor')
                );
            }

            if (pbrMetallicRoughness.metallicFactor !== undefined) {
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat1(pbrMetallicRoughness.metallicFactor, 'uMetallicFactor')
                );
            }
            if (pbrMetallicRoughness.roughnessFactor !== undefined) {
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat1(pbrMetallicRoughness.roughnessFactor, 'uRoughnessFactor')
                );
            }

            if (pbrMetallicRoughness.metallicRoughnessTexture)
                promises.push(
                    this.createTextureAndSetAttrib(
                        pbrMetallicRoughness.metallicRoughnessTexture,
                        osgStateSet,
                        ReaderWriterGLTF.METALLIC_ROUGHNESS_TEXTURE_UNIT,
                        ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM
                    )
                );
            model = ReaderWriterGLTF.PBR_METAL_MODE;
        }
        // SPECULAR/GLOSSINESS
        if (extension) {
            if (extension.diffuseFactor) {
                //PBR default uniforms
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat4(extension.diffuseFactor, 'uBaseColorFactor')
                );
            }
            if (extension.glossinessFactor !== undefined) {
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat1(extension.glossinessFactor, 'uGlossinessFactor')
                );
            }
            if (extension.specularFactor !== undefined) {
                osgStateSet.addUniform(
                    __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat3(extension.specularFactor, 'uSpecularFactor')
                );
            }
            if (extension.diffuseTexture) {
                promises.push(
                    this.createTextureAndSetAttrib(
                        extension.diffuseTexture,
                        osgStateSet,
                        ReaderWriterGLTF.DIFFUSE_TEXTURE_UNIT,
                        ReaderWriterGLTF.ALBEDO_UNIFORM
                    )
                );
            }
            if (extension.specularGlossinessTexture) {
                promises.push(
                    this.createTextureAndSetAttrib(
                        extension.specularGlossinessTexture,
                        osgStateSet,
                        ReaderWriterGLTF.SPECULAR_GLOSSINESS_TEXTURE_UNIT,
                        ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM
                    )
                );
            }
            model = ReaderWriterGLTF.PBR_SPEC_MODE;
        }
        if (glTFmaterial.normalTexture) {
            promises.push(
                this.createTextureAndSetAttrib(
                    glTFmaterial.normalTexture,
                    osgStateSet,
                    ReaderWriterGLTF.NORMAL_TEXTURE_UNIT,
                    ReaderWriterGLTF.NORMAL_UNIFORM
                )
            );
        }
        if (glTFmaterial.occlusionTexture) {
            promises.push(
                this.createTextureAndSetAttrib(
                    glTFmaterial.occlusionTexture,
                    osgStateSet,
                    ReaderWriterGLTF.AO_TEXTURE_UNIT,
                    ReaderWriterGLTF.AO_UNIFORM
                )
            );
        }
        if (glTFmaterial.emissiveFactor !== undefined) {
            osgStateSet.addUniform(
                __WEBPACK_IMPORTED_MODULE_24_osg_Uniform__["a" /* default */].createFloat3(glTFmaterial.emissiveFactor, 'uEmissiveFactor')
            );
        }
        if (glTFmaterial.emissiveTexture !== undefined) {
            promises.push(
                this.createTextureAndSetAttrib(
                    glTFmaterial.emissiveTexture,
                    osgStateSet,
                    ReaderWriterGLTF.EMISSIVE_TEXTURE_UNIT,
                    ReaderWriterGLTF.EMISSIVE_UNIFORM
                )
            );
        }
        // TODO:Need to check for specular glossiness extension
        geometryNode.setUserData({
            pbrWorklow: model
        });

        geometryNode.stateset = osgStateSet;
        osgStateSet.setRenderingHint('TRANSPARENT_BIN');
        osgStateSet.setRenderBinDetails(1000, 'RenderBin');
        osgStateSet.setAttributeAndModes(new __WEBPACK_IMPORTED_MODULE_13_osg_BlendFunc__["a" /* default */]('SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA'));
        this._stateSetMap[materialId] = osgStateSet;

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promises);
    }),

    loadMaterial: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(materialId, geometryNode) {
        var json = this._glTFJSON;
        var glTFmaterial = json.materials[materialId];

        if (this._stateSetMap[materialId]) {
            geometryNode.stateset = this._stateSetMap[materialId];
            return;
        }

        var extension = this.findByKey(glTFmaterial.extensions, ReaderWriterGLTF.PBR_SPEC_EXT);
        if (glTFmaterial.pbrMetallicRoughness || extension)
            return this.loadPBRMaterial(materialId, glTFmaterial, geometryNode, extension);

        var values = glTFmaterial.values;
        if (!values) return;

        // Handles basic material attributes
        var osgMaterial = new __WEBPACK_IMPORTED_MODULE_17_osg_Material__["default"]();
        var osgStateSet = geometryNode.getOrCreateStateSet();
        osgStateSet.setAttribute(osgMaterial);

        if (values.ambient) osgMaterial.setAmbient(values.ambient);
        if (values.emission) osgMaterial.setEmission(values.emission);
        if (values.shininess) osgMaterial.setShininess(values.shininess);
        if (values.specular) osgMaterial.setSpecular(values.specular);

        // Create a texture for the diffuse, if any
        if (values.diffuse) {
            if (typeof values.diffuse !== 'string') osgMaterial.setDiffuse(values.diffuse);
            else return this.createTextureAndSetAttrib(values.diffuse, osgStateSet, 0);
        }

        geometryNode.stateset = osgStateSet;
        this._stateSetMap[materialId] = osgStateSet;

        return;
    }),

    createGeometry: function(primitive, skeletonJointId) {
        var json = this._glTFJSON;
        var promisesArray = [];

        // Builds the geometry from the extracted vertices & normals
        var geom = new __WEBPACK_IMPORTED_MODULE_14_osg_Geometry__["a" /* default */]();
        var rigOrGeom = geom;

        var cbSetBuffer = function(name, buffer) {
            if (!buffer) return;

            this.getVertexAttributeList()[name] = buffer;
        };

        if (skeletonJointId) {
            rigOrGeom = new __WEBPACK_IMPORTED_MODULE_11_osgAnimation_RigGeometry__["a" /* default */]();
            rigOrGeom._boneNameID = this._skeletonToInfluenceMap[skeletonJointId];
        }

        var attributeWeight = function(data) {
            if (!data) return;

            rigOrGeom.getAttributes().Weights = data;

            var elts = rigOrGeom.getAttributes().Weights.getElements();
            for (var i = 0, l = elts.length / 4; i < l; ++i) {
                var sum = elts[i * 4] + elts[i * 4 + 1] + elts[i * 4 + 2] + elts[i * 4 + 3];
                var correc = 1.0 / sum;
                elts[i * 4] *= correc;
                elts[i * 4 + 1] *= correc;
                elts[i * 4 + 2] *= correc;
                elts[i * 4 + 3] *= correc;
            }
        };

        // Registers each glTF primitive attributes
        // into a respective geometry attribute
        var attributesKeys = window.Object.keys(primitive.attributes);
        for (var i = 0; i < attributesKeys.length; ++i) {
            var accessor = json.accessors[primitive.attributes[attributesKeys[i]]];
            var promise = this.loadAccessorBuffer(accessor, __WEBPACK_IMPORTED_MODULE_20_osg_BufferArray__["a" /* default */].ARRAY_BUFFER);

            if (attributesKeys[i].indexOf('POSITION') !== -1) {
                promise.then(cbSetBuffer.bind(geom, 'Vertex'));
            } else if (attributesKeys[i].indexOf('NORMAL') !== -1) {
                promise.then(cbSetBuffer.bind(geom, 'Normal'));
            } else if (attributesKeys[i].indexOf('TANGENT') !== -1) {
                promise.then(cbSetBuffer.bind(geom, 'Tangent'));
            } else if (attributesKeys[i].indexOf('JOINT') !== -1) {
                promise.then(cbSetBuffer.bind(rigOrGeom, 'Bones'));
            } else if (attributesKeys[i].indexOf('WEIGHT') !== -1) {
                promise.then(attributeWeight);
            } else if (attributesKeys[i].indexOf('COLOR') !== -1) {
                promise.then(cbSetBuffer.bind(geom, 'Color'));
            } else if (attributesKeys[i].indexOf('TEXCOORD') !== -1) {
                var texCoordId = attributesKeys[i].substr(9);
                promise.then(cbSetBuffer.bind(geom, 'TexCoord' + texCoordId));
            }

            promisesArray.push(promise);
        }

        var indicesAccessor = json.accessors[primitive.indices];
        var indicesPromise = this.loadAccessorBuffer(
            indicesAccessor,
            __WEBPACK_IMPORTED_MODULE_20_osg_BufferArray__["a" /* default */].ELEMENT_ARRAY_BUFFER
        );
        indicesPromise.then(function(data) {
            if (!data) return;

            var osgPrimitive = new __WEBPACK_IMPORTED_MODULE_18_osg_DrawElements__["a" /* default */](__WEBPACK_IMPORTED_MODULE_19_osg_primitiveSet__["a" /* default */].TRIANGLES, data);
            geom.getPrimitives().push(osgPrimitive);
        });

        promisesArray.push(indicesPromise);

        if (primitive.material !== undefined)
            promisesArray.push(this.loadMaterial(primitive.material, geom));

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promisesArray).then(function() {
            if (skeletonJointId) {
                rigOrGeom.setSourceGeometry(geom);
                rigOrGeom.mergeChildrenData();

                rigOrGeom.computeBoundingBox = geom.computeBoundingBox;
            }

            return rigOrGeom;
        });
    },

    loadGLTFPrimitives: function(meshId, resultMeshNode, skeletonJointId) {
        var json = this._glTFJSON;
        var mesh = json.meshes[meshId];

        var primitives = mesh.primitives;

        var promisesArray = [];
        var i;
        for (i = 0; i < primitives.length; ++i) {
            var primitive = primitives[i];
            var promiseGeom = this.createGeometry(primitive, skeletonJointId);

            promisesArray.push(promiseGeom);
        }

        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promisesArray).then(function(geoms) {
            for (i = 0; i < geoms.length; ++i) resultMeshNode.addChild(geoms[i]);

            return geoms;
        });
    },

    loadGLTFNode: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(nodeId, root) {
        if (this._visitedNodes[nodeId]) return;

        var json = this._glTFJSON;
        var glTFNode = json.nodes[nodeId];

        var currentNode = glTFNode.jointName ? this._bones[nodeId] : new __WEBPACK_IMPORTED_MODULE_16_osg_MatrixTransform__["a" /* default */]();
        currentNode.setName(nodeId);
        __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].copy(currentNode.getMatrix(), this.loadTransform(glTFNode));

        if (glTFNode.jointName && this._skeletons[glTFNode.joinName]) {
            var skeleton = this._skeletons[glTFNode.jointName];
            skeleton.addChild(currentNode);
            root.addChild(skeleton);
        }

        // Recurses on children before
        // processing the current node
        var children = glTFNode.children;
        var i;
        var promises = [];
        if (children) {
            for (i = 0; i < children.length; ++i) {
                var nodePromise = this.loadGLTFNode(children[i], currentNode);
                promises.push(nodePromise);
            }
        }
        // Loads meshes contained in the node
        // Adds RigGeometry to corresponding skeleton if any
        if (glTFNode.mesh !== undefined) {
            var meshId = glTFNode.mesh;
            if (!glTFNode.skeletons) {
                var geomPromise = this.loadGLTFPrimitives(meshId, currentNode, null);
                promises.push(geomPromise);
            } else {
                for (var j = 0; j < glTFNode.skeletons.length; ++j) {
                    var rootJointId = glTFNode.skeletons[j];
                    var skeletonNode = this._skeletons[rootJointId];
                    var meshTransformNode = new __WEBPACK_IMPORTED_MODULE_16_osg_MatrixTransform__["a" /* default */]();
                    __WEBPACK_IMPORTED_MODULE_25_osg_glMatrix__["c" /* mat4 */].copy(meshTransformNode.getMatrix(), currentNode.getMatrix());
                    var geomP = this.loadGLTFPrimitives(meshId, meshTransformNode, rootJointId);
                    skeletonNode.addChild(meshTransformNode);
                    promises.push(geomP);
                }
            }
        }
        // Loads solid animations
        // by adding an update callback
        if (this._animatedNodes[nodeId]) this.registerUpdateCallback(nodeId, currentNode);

        if (!this._skeletons[nodeId]) root.addChild(currentNode);

        this._visitedNodes[nodeId] = true;
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promises);
    }),

    readNodeURL: function(url, options) {
        var self = this;

        this.init();
        if (options && options.filesMap !== undefined && options.filesMap.size > 0) {
            // it comes from the ZIP plugin or from drag'n drop
            // So we already have all the files.
            this._filesMap = options.filesMap;
            var glTFFile = this._filesMap.get(url);
            return this.readJSON(glTFFile, url);
        }

        var index = url.lastIndexOf('/');
        this._localPath = index === -1 ? '' : url.substr(0, index + 1);
        // Else it is a usual XHR request
        var filePromise = Object(__WEBPACK_IMPORTED_MODULE_1_osgDB_requestFile__["a" /* default */])(url);
        return filePromise.then(function(file) {
            return self.readJSON(file);
        });
    },

    readJSON: __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.method(function(glTFFile, url) {
        // Creates the root node
        // adding a PI / 2 rotation arround the X-axis
        var root = new __WEBPACK_IMPORTED_MODULE_16_osg_MatrixTransform__["a" /* default */]();
        root.setName(url);

        var json = JSON.parse(glTFFile);
        if (!json) return;

        this._glTFJSON = json;

        var promisesArray = [];
        // Preprocesses animations
        var animPromise = this.preprocessAnimations();
        // Preprocesses skin animations if any
        var skeletonPromise = this.preprocessSkeletons();

        promisesArray.push(skeletonPromise, animPromise);
        var self = this;
        return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promisesArray).then(function() {
            var promises = [];
            // Loops through each scene
            // loading geometry nodes, transform nodes, etc...s
            var sceneKeys = window.Object.keys(json.scenes);
            for (var i = 0; i < sceneKeys.length; ++i) {
                var scene = json.scenes[sceneKeys[i]];

                if (!scene) continue;
                for (var j = 0; j < scene.nodes.length; ++j) {
                    var p = self.loadGLTFNode(scene.nodes[j], root);
                    promises.push(p);
                }
            }

            // Register the animation manager
            // if the glTF file contains animations
            if (self._basicAnimationManager) root.addUpdateCallback(self._basicAnimationManager);

            return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promises).then(function() {
                return root;
            });
        });
    })
};

__WEBPACK_IMPORTED_MODULE_3_osgDB_Registry__["a" /* default */].instance().addReaderWriter('gltf', new ReaderWriterGLTF());

/* harmony default export */ __webpack_exports__["a"] = (ReaderWriterGLTF);


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bluebird___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_bluebird__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_osgDB_requestFile_js__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_osg_notify__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_osgDB_Registry__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_osgDB_readerParser__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_osgDB_FileHelper__ = __webpack_require__(89);






var JSZip = window.JSZip;

var ReaderWriterZIP = function() {
    this._options = undefined;
    this._filesMap = new window.Map();
    this._fileName = ''; // The file containing the model of the archive ( gltf, glb, osgjs, b3dm, etc )
};

ReaderWriterZIP.prototype = {
    readNodeURL: function(url, options) {
        if (JSZip === undefined) {
            __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].error('You need to add JSZip as a dependency');
            return;
        }
        __WEBPACK_IMPORTED_MODULE_2_osg_notify__["a" /* default */].log('starting to read: ' + url);
        // Check if we already have the file
        var self = this;
        if (options && options.filesMap !== undefined) {
            // it comes  from drag'n drop
            if (options.filesMap.has(url)) {
                // Now url is a File
                var file = options.filesMap.get(url);
                return this.readZipFile(file).then(function() {
                    if (!self._fileName.length) return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.reject(self);

                    // At this point we have the main file name and a Map containing all the resources
                    return __WEBPACK_IMPORTED_MODULE_4_osgDB_readerParser__["default"].readNodeURL(self._fileName, {
                        filesMap: self._filesMap
                    });
                });
            }
        }

        var filePromise = Object(__WEBPACK_IMPORTED_MODULE_1_osgDB_requestFile_js__["a" /* default */])(url, {
            responseType: 'blob'
        });

        return filePromise.then(function(zfile) {
            self.readZipFile(zfile).then(function() {
                // At this point we have the main file name and a Map containing all the resources
                return __WEBPACK_IMPORTED_MODULE_4_osgDB_readerParser__["default"].readNodeURL(self._fileName, {
                    filesMap: self._filesMap
                });
            });
        });
    },

    _registerZipImage: function(fileName, type, extension, fileData) {
        var data = fileData;
        // Is an image
        if (type === 'base64') {
            data = new window.Image();
            data.src = 'data:image/' + extension + ';base64,' + fileData;
        }
        this._filesMap.set(fileName, data);
    },

    readZipFile: function(fileOrBlob) {
        return JSZip.loadAsync(fileOrBlob).then(
            function(zip) {
                var promisesArray = [];

                for (var fileName in zip.files) {
                    var extension = fileName.substr(fileName.lastIndexOf('.') + 1);
                    // Check if the file is readable by any osgDB plugin
                    var readerWriter = __WEBPACK_IMPORTED_MODULE_3_osgDB_Registry__["a" /* default */].instance().getReaderWriterForExtension(extension);
                    // We need a hack for osgjs til it is converted to a readerwriter
                    if (readerWriter !== undefined || extension === 'osgjs') {
                        // So this is the main file to read
                        this._fileName = fileName;
                    }

                    var type = __WEBPACK_IMPORTED_MODULE_5_osgDB_FileHelper__["a" /* default */].getTypeForExtension(extension);
                    // We don't need to parse this file
                    if (type === undefined) continue;
                    if (type === 'blob') type = 'base64'; // Images are base64 encoded in ZIP files

                    var p = zip
                        .file(fileName)
                        .async(type)
                        .then(this._registerZipImage.bind(this, fileName, type, extension));
                    promisesArray.push(p);
                }

                return __WEBPACK_IMPORTED_MODULE_0_bluebird___default.a.all(promisesArray);
            }.bind(this)
        );
    }
};

__WEBPACK_IMPORTED_MODULE_3_osgDB_Registry__["a" /* default */].instance().addReaderWriter('zip', new ReaderWriterZIP());

/* harmony default export */ __webpack_exports__["a"] = (ReaderWriterZIP);


/***/ })
/******/ ]);
});
//# sourceMappingURL=OSG.js.map

/***/ }),

/***/ "./dependencies/filesaver.js":
/*!***********************************!*\
  !*** ./dependencies/filesaver.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
var filesaver = ( function ( e ) {
    'use strict';
    if ( typeof e === 'undefined' || typeof navigator !== 'undefined' && /MSIE [1-9]\./.test( navigator.userAgent ) ) {
        return;
    }
    var t = e.document,
        n = function () {
            return e.URL || e.webkitURL || e;
        },
        r = t.createElementNS( 'http://www.w3.org/1999/xhtml', 'a' ),
        o = 'download' in r,
        a = function ( e ) {
            var t = new MouseEvent( 'click' );
            e.dispatchEvent( t );
        },
        i = /constructor/i.test( e.HTMLElement ) || e.safari,
        f = /CriOS\/[\d]+/.test( navigator.userAgent ),
        u = function ( t ) {
            ( e.setImmediate || e.setTimeout )( function () {
                throw t;
            }, 0 );
        },
        s = 'application/octet-stream',
        d = 1e3 * 40,
        c = function ( e ) {
            var t = function () {
                if ( typeof e === 'string' ) {
                    n().revokeObjectURL( e );
                } else {
                    e.remove();
                }
            };
            setTimeout( t, d );
        },
        l = function ( e, t, n ) {
            t = [].concat( t );
            var r = t.length;
            while ( r-- ) {
                var o = e[ 'on' + t[ r ] ];
                if ( typeof o === 'function' ) {
                    try {
                        o.call( e, n || e );
                    } catch ( a ) {
                        u( a );
                    }
                }
            }
        },
        p = function ( e ) {
            if ( /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test( e.type ) ) {
                return new Blob( [ String.fromCharCode( 65279 ), e ], {
                    type: e.type
                } );
            }
            return e;
        },
        v = function ( t, u, d ) {
            if ( !d ) {
                t = p( t );
            }
            var v = this,
                w = t.type,
                m = w === s,
                y, h = function () {
                    l( v, 'writestart progress write writeend'.split( ' ' ) );
                },
                S = function () {
                    if ( ( f || m && i ) && e.FileReader ) {
                        var r = new FileReader();
                        r.onloadend = function () {
                            var t = f ? r.result : r.result.replace( /^data:[^;]*;/, 'data:attachment/file;' );
                            var n = e.open( t, '_blank' );
                            if ( !n ) e.location.href = t;
                            t = undefined;
                            v.readyState = v.DONE;
                            h();
                        };
                        r.readAsDataURL( t );
                        v.readyState = v.INIT;
                        return;
                    }
                    if ( !y ) {
                        y = n().createObjectURL( t );
                    }
                    if ( m ) {
                        e.location.href = y;
                    } else {
                        var o = e.open( y, '_blank' );
                        if ( !o ) {
                            e.location.href = y;
                        }
                    }
                    v.readyState = v.DONE;
                    h();
                    c( y );
                };
            v.readyState = v.INIT;
            if ( o ) {
                y = n().createObjectURL( t );
                setTimeout( function () {
                    r.href = y;
                    r.download = u;
                    a( r );
                    h();
                    c( y );
                    v.readyState = v.DONE;
                } );
                return;
            }
            S();
        },
        w = v.prototype,
        m = function ( e, t, n ) {
            return new v( e, t || e.name || 'download', n );
        };
    if ( typeof navigator !== 'undefined' && navigator.msSaveOrOpenBlob ) {
        return function ( e, t, n ) {
            t = t || e.name || 'download';
            if ( !n ) {
                e = p( e );
            }
            return navigator.msSaveOrOpenBlob( e, t );
        };
    }
    w.abort = function () {};
    w.readyState = w.INIT = 0;
    w.WRITING = 1;
    w.DONE = 2;
    w.error = w.onwritestart = w.onprogress = w.onwrite = w.onabort = w.onerror = w.onwriteend = null;
    return m;
} )( ( typeof ( window ) !== 'undefined' && window ) || this.content );

//module.exports = filesaver;
if( true && module.exports)
   {module.exports.filesaver=filesaver}
else if( true && __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js") !== null && __webpack_require__(/*! !webpack amd options */ "./node_modules/webpack/buildin/amd-options.js") !== null)
    {!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return filesaver}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}

/***/ }),

/***/ "./dependencies/ol-4.3.2.js":
/*!**********************************!*\
  !*** ./dependencies/ol-4.3.2.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// OpenLayers. See https://openlayers.org/
// License: https://raw.githubusercontent.com/openlayers/openlayers/master/LICENSE.md
// Version: v4.3.2
;(function (root, factory) {
  if (true) {
    module.exports = factory();
  } else {}
}(this, function () {
  var OPENLAYERS = {};
  var k,aa=this;function r(a,b){var c=OPENLAYERS;a=a.split(".");c=c||aa;a[0]in c||!c.execScript||c.execScript("var "+a[0]);for(var d;a.length&&(d=a.shift());)a.length||void 0===b?c[d]&&c[d]!==Object.prototype[d]?c=c[d]:c=c[d]={}:c[d]=b};var ba,ca;function fa(a,b){return a>b?1:a<b?-1:0}function ha(a,b){return 0<=a.indexOf(b)}function ja(a,b,c){var d=a.length;if(a[0]<=b)return 0;if(!(b<=a[d-1]))if(0<c)for(c=1;c<d;++c){if(a[c]<b)return c-1}else if(0>c)for(c=1;c<d;++c){if(a[c]<=b)return c}else for(c=1;c<d;++c){if(a[c]==b)return c;if(a[c]<b)return a[c-1]-b<b-a[c]?c-1:c}return d-1}function ka(a,b){var c=Array.isArray(b)?b:[b],d=c.length;for(b=0;b<d;b++)a[a.length]=c[b]}
function la(a,b){for(var c=a.length>>>0,d,e=0;e<c;e++)if(d=a[e],b(d,e,a))return d;return null}function ma(a,b){var c=a.length;if(c!==b.length)return!1;for(var d=0;d<c;d++)if(a[d]!==b[d])return!1;return!0}function na(a){var b=oa,c=a.length,d=Array(a.length),e;for(e=0;e<c;e++)d[e]={index:e,value:a[e]};d.sort(function(a,c){return b(a.value,c.value)||a.index-c.index});for(e=0;e<a.length;e++)a[e]=d[e].value}function pa(a,b){var c;return a.every(function(d,e){c=e;return!b(d,e,a)})?-1:c}
function qa(a,b){var c=b||fa;return a.every(function(b,e){if(!e)return!0;b=c(a[e-1],b);return!(0<b||0===b)})};function v(a,b){a.prototype=Object.create(b.prototype);a.prototype.constructor=a}function ra(){}function w(a){return a.ip||(a.ip=++sa)}var sa=0;function ua(a){this.message="Assertion failed. See https://openlayers.org/en/v4.3.2/doc/errors/#"+a+" for details.";this.code=a;this.name="AssertionError"}v(ua,Error);function va(a,b){if(!a)throw new ua(b);};function wa(a,b,c,d){this.ca=a;this.da=b;this.ea=c;this.ha=d}function xa(a,b,c){return a.ca<=b&&b<=a.da&&a.ea<=c&&c<=a.ha}function ya(a,b){return a.ca==b.ca&&a.ea==b.ea&&a.da==b.da&&a.ha==b.ha}function za(a,b){return a.ca<=b.da&&a.da>=b.ca&&a.ea<=b.ha&&a.ha>=b.ea};function Aa(a,b,c){return Math.min(Math.max(a,b),c)}var Ba=function(){var a;"cosh"in Math?a=Math.cosh:a=function(a){a=Math.exp(a);return(a+1/a)/2};return a}();function Ca(a){va(0<a,29);return Math.pow(2,Math.ceil(Math.log(a)/Math.LN2))}function Da(a,b,c,d,e,f){var g=e-c,h=f-d;if(g||h){var l=((a-c)*g+(b-d)*h)/(g*g+h*h);1<l?(c=e,d=f):0<l&&(c+=g*l,d+=h*l)}return Ea(a,b,c,d)}function Ea(a,b,c,d){a=c-a;b=d-b;return a*a+b*b}function Fa(a){return a*Math.PI/180}function Ga(a,b){a%=b;return 0>a*b?a+b:a}
function Ha(a,b,c){return a+c*(b-a)};function Ia(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]+2*b;c[1]=a[1]+2*b;return c}function Ja(a,b,c){void 0===c&&(c=[0,0]);c[0]=a[0]*b+.5|0;c[1]=a[1]*b+.5|0;return c}function Ka(a,b){if(Array.isArray(a))return a;void 0===b?b=[a,a]:b[0]=b[1]=a;return b};function La(a){for(var b=Ma(),c=0,d=a.length;c<d;++c)Na(b,a[c]);return b}function Oa(a,b,c){return c?(c[0]=a[0]-b,c[1]=a[1]-b,c[2]=a[2]+b,c[3]=a[3]+b,c):[a[0]-b,a[1]-b,a[2]+b,a[3]+b]}function Pa(a,b){return b?(b[0]=a[0],b[1]=a[1],b[2]=a[2],b[3]=a[3],b):a.slice()}function Qa(a,b,c){b=b<a[0]?a[0]-b:a[2]<b?b-a[2]:0;a=c<a[1]?a[1]-c:a[3]<c?c-a[3]:0;return b*b+a*a}function Ra(a,b){return Sa(a,b[0],b[1])}function Ta(a,b){return a[0]<=b[0]&&b[2]<=a[2]&&a[1]<=b[1]&&b[3]<=a[3]}
function Sa(a,b,c){return a[0]<=b&&b<=a[2]&&a[1]<=c&&c<=a[3]}function Ua(a,b){var c=a[1],d=a[2],e=a[3],f=b[0];b=b[1];var g=0;f<a[0]?g|=16:f>d&&(g|=4);b<c?g|=8:b>e&&(g|=2);g||(g=1);return g}function Ma(){return[Infinity,Infinity,-Infinity,-Infinity]}function Va(a,b,c,d,e){return e?(e[0]=a,e[1]=b,e[2]=c,e[3]=d,e):[a,b,c,d]}function Wa(a){return Va(Infinity,Infinity,-Infinity,-Infinity,a)}function Xa(a,b){var c=a[0];a=a[1];return Va(c,a,c,a,b)}function Za(a,b,c,d,e){e=Wa(e);return $a(e,a,b,c,d)}
function ab(a,b){return a[0]==b[0]&&a[2]==b[2]&&a[1]==b[1]&&a[3]==b[3]}function bb(a,b){b[0]<a[0]&&(a[0]=b[0]);b[2]>a[2]&&(a[2]=b[2]);b[1]<a[1]&&(a[1]=b[1]);b[3]>a[3]&&(a[3]=b[3]);return a}function Na(a,b){b[0]<a[0]&&(a[0]=b[0]);b[0]>a[2]&&(a[2]=b[0]);b[1]<a[1]&&(a[1]=b[1]);b[1]>a[3]&&(a[3]=b[1])}function $a(a,b,c,d,e){for(;c<d;c+=e){var f=a,g=b[c],h=b[c+1];f[0]=Math.min(f[0],g);f[1]=Math.min(f[1],h);f[2]=Math.max(f[2],g);f[3]=Math.max(f[3],h)}return a}
function cb(a,b,c){var d;return(d=b.call(c,db(a)))||(d=b.call(c,eb(a)))||(d=b.call(c,fb(a)))?d:(d=b.call(c,gb(a)))?d:!1}function hb(a){var b=0;ib(a)||(b=jb(a)*kb(a));return b}function db(a){return[a[0],a[1]]}function eb(a){return[a[2],a[1]]}function lb(a){return[(a[0]+a[2])/2,(a[1]+a[3])/2]}
function mb(a,b,c,d,e){var f=b*d[0]/2;d=b*d[1]/2;b=Math.cos(c);var g=Math.sin(c);c=f*b;f*=g;b*=d;var h=d*g,l=a[0],m=a[1];a=l-c+h;d=l-c-h;g=l+c-h;c=l+c+h;h=m-f-b;l=m-f+b;var n=m+f+b;f=m+f-b;return Va(Math.min(a,d,g,c),Math.min(h,l,n,f),Math.max(a,d,g,c),Math.max(h,l,n,f),e)}function kb(a){return a[3]-a[1]}function nb(a,b,c){c=c?c:Ma();ob(a,b)&&(c[0]=a[0]>b[0]?a[0]:b[0],c[1]=a[1]>b[1]?a[1]:b[1],c[2]=a[2]<b[2]?a[2]:b[2],c[3]=a[3]<b[3]?a[3]:b[3]);return c}function gb(a){return[a[0],a[3]]}
function fb(a){return[a[2],a[3]]}function jb(a){return a[2]-a[0]}function ob(a,b){return a[0]<=b[2]&&a[2]>=b[0]&&a[1]<=b[3]&&a[3]>=b[1]}function ib(a){return a[2]<a[0]||a[3]<a[1]}function pb(a,b){var c=(a[2]-a[0])/2*(b-1);b=(a[3]-a[1])/2*(b-1);a[0]-=c;a[2]+=c;a[1]-=b;a[3]+=b}
function qb(a,b,c){a=[a[0],a[1],a[0],a[3],a[2],a[1],a[2],a[3]];b(a,a,2);var d=[a[0],a[2],a[4],a[6]],e=[a[1],a[3],a[5],a[7]];b=Math.min.apply(null,d);a=Math.min.apply(null,e);d=Math.max.apply(null,d);e=Math.max.apply(null,e);return Va(b,a,d,e,c)};var rb="function"===typeof Object.assign?Object.assign:function(a,b){if(!a||null===a)throw new TypeError("Cannot convert undefined or null to object");for(var c=Object(a),d=1,e=arguments.length;d<e;++d){var f=arguments[d];if(void 0!==f&&null!==f)for(var g in f)f.hasOwnProperty(g)&&(c[g]=f[g])}return c};function sb(a){for(var b in a)delete a[b]}function tb(a){var b=[],c;for(c in a)b.push(a[c]);return b}function ub(a){for(var b in a)return!1;return!b};/*

 Latitude/longitude spherical geodesy formulae taken from
 http://www.movable-type.co.uk/scripts/latlong.html
 Licensed under CC-BY-3.0.
*/
function vb(a){this.radius=a}vb.prototype.a=function(a){return wb(a,this.radius)};vb.prototype.b=function(a,b){return xb(a,b,this.radius)};vb.prototype.offset=function(a,b,c){var d=Fa(a[1]);b/=this.radius;var e=Math.asin(Math.sin(d)*Math.cos(b)+Math.cos(d)*Math.sin(b)*Math.cos(c));return[180*(Fa(a[0])+Math.atan2(Math.sin(c)*Math.sin(b)*Math.cos(d),Math.cos(b)-Math.sin(d)*Math.sin(e)))/Math.PI,180*e/Math.PI]};
function yb(a,b){var c=b||{},d=c.radius||6371008.8;c=c.projection||"EPSG:3857";a=a.clone().mb(c,"EPSG:4326");var e=a.T();c=0;var f;switch(e){case "Point":case "MultiPoint":break;case "LineString":case "LinearRing":b=a.V();c=zb(b,d);break;case "MultiLineString":case "Polygon":b=a.V();a=0;for(e=b.length;a<e;++a)c+=zb(b[a],d);break;case "MultiPolygon":b=a.V();a=0;for(e=b.length;a<e;++a){var g=b[a];var h=0;for(f=g.length;h<f;++h)c+=zb(g[h],d)}break;case "GeometryCollection":d=a.kd();a=0;for(e=d.length;a<
e;++a)c+=yb(d[a],b);break;default:throw Error("Unsupported geometry type: "+e);}return c}function zb(a,b){for(var c=0,d=0,e=a.length;d<e-1;++d)c+=xb(a[d],a[d+1],b);return c}function xb(a,b,c){var d=Fa(a[1]),e=Fa(b[1]),f=(e-d)/2;a=Fa(b[0]-a[0])/2;d=Math.sin(f)*Math.sin(f)+Math.sin(a)*Math.sin(a)*Math.cos(d)*Math.cos(e);return 2*c*Math.atan2(Math.sqrt(d),Math.sqrt(1-d))}
function Ab(a,b){var c=b||{},d=c.radius||6371008.8;c=c.projection||"EPSG:3857";a=a.clone().mb(c,"EPSG:4326");var e=a.T();c=0;var f;switch(e){case "Point":case "MultiPoint":case "LineString":case "MultiLineString":case "LinearRing":break;case "Polygon":b=a.V();c=Math.abs(wb(b[0],d));a=1;for(e=b.length;a<e;++a)c-=Math.abs(wb(b[a],d));break;case "MultiPolygon":b=a.V();a=0;for(e=b.length;a<e;++a){var g=b[a];c+=Math.abs(wb(g[0],d));var h=1;for(f=g.length;h<f;++h)c-=Math.abs(wb(g[h],d))}break;case "GeometryCollection":d=
a.kd();a=0;for(e=d.length;a<e;++a)c+=Ab(d[a],b);break;default:throw Error("Unsupported geometry type: "+e);}return c}function wb(a,b){for(var c=0,d=a.length,e=a[d-1][0],f=a[d-1][1],g=0;g<d;g++){var h=a[g][0],l=a[g][1];c+=Fa(h-e)*(2+Math.sin(Fa(f))+Math.sin(Fa(l)));e=h;f=l}return c*b*b/2};var Bb={};Bb.degrees=12741994*Math.PI/360;Bb.ft=.3048;Bb.m=1;Bb["us-ft"]=1200/3937;var Cb=null;function Db(a){this.qb=a.code;this.b=a.units;this.i=void 0!==a.extent?a.extent:null;this.g=void 0!==a.worldExtent?a.worldExtent:null;this.a=void 0!==a.axisOrientation?a.axisOrientation:"enu";this.c=void 0!==a.global?a.global:!1;this.f=!(!this.c||!this.i);this.l=a.getPointResolution;this.j=null;this.o=a.metersPerUnit;var b=a.code,c=Cb||window.proj4;"function"==typeof c&&(b=c.defs(b),void 0!==b&&(void 0!==b.axis&&void 0===a.axisOrientation&&(this.a=b.axis),void 0===a.metersPerUnit&&(this.o=b.to_meter),
void 0===a.units&&(this.b=b.units)))}k=Db.prototype;k.Uk=function(){return this.qb};k.G=function(){return this.i};k.jo=function(){return this.b};k.Nc=function(){return this.o||Bb[this.b]};k.Fl=function(){return this.g};k.rm=function(){return this.c};k.nq=function(a){this.c=a;this.f=!(!a||!this.i)};k.ko=function(a){this.i=a;this.f=!(!this.c||!a)};k.yq=function(a){this.g=a};k.mq=function(a){this.l=a};function Eb(a){Db.call(this,{code:a,units:"m",extent:Fb,global:!0,worldExtent:Gb,getPointResolution:function(a,c){return a/Ba(c[1]/6378137)}})}v(Eb,Db);var Hb=6378137*Math.PI,Fb=[-Hb,-Hb,Hb,Hb],Gb=[-180,-85,180,85],Ib=[new Eb("EPSG:3857"),new Eb("EPSG:102100"),new Eb("EPSG:102113"),new Eb("EPSG:900913"),new Eb("urn:ogc:def:crs:EPSG:6.18:3:3857"),new Eb("urn:ogc:def:crs:EPSG::3857"),new Eb("http://www.opengis.net/gml/srs/epsg.xml#3857")];
function Jb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c){b[e]=Hb*a[e]/180;var f=6378137*Math.log(Math.tan(Math.PI*(a[e+1]+90)/360));f>Hb?f=Hb:f<-Hb&&(f=-Hb);b[e+1]=f}return b}function Kb(a,b,c){var d=a.length;c=1<c?c:2;void 0===b&&(2<c?b=a.slice():b=Array(d));for(var e=0;e<d;e+=c)b[e]=180*a[e]/Hb,b[e+1]=360*Math.atan(Math.exp(a[e+1]/6378137))/Math.PI-90;return b};function Lb(a,b){Db.call(this,{code:a,units:"degrees",extent:Mb,axisOrientation:b,global:!0,metersPerUnit:Nb,worldExtent:Mb})}v(Lb,Db);var Mb=[-180,-90,180,90],Nb=6378137*Math.PI/180,Ob=[new Lb("CRS:84"),new Lb("EPSG:4326","neu"),new Lb("urn:ogc:def:crs:EPSG::4326","neu"),new Lb("urn:ogc:def:crs:EPSG:6.6:4326","neu"),new Lb("urn:ogc:def:crs:OGC:1.3:CRS84"),new Lb("urn:ogc:def:crs:OGC:2:84"),new Lb("http://www.opengis.net/gml/srs/epsg.xml#4326","neu"),new Lb("urn:x-ogc:def:crs:EPSG:4326","neu")];var Pb={};var Qb={};function Rb(a,b,c){a=a.qb;b=b.qb;a in Qb||(Qb[a]={});Qb[a][b]=c}function Sb(a,b){var c;a in Qb&&b in Qb[a]&&(c=Qb[a][b]);return c};var Tb=new vb(6371008.8);function Ub(a,b,c,d){a=Wb(a);var e=a.l;e?b=e(b,c):"degrees"==a.b&&!d||"degrees"==d||(e=Xb(a,Wb("EPSG:4326")),b=[c[0]-b/2,c[1],c[0]+b/2,c[1],c[0],c[1]-b/2,c[0],c[1]+b/2],b=e(b,b,2),b=(Tb.b(b.slice(0,2),b.slice(2,4))+Tb.b(b.slice(4,6),b.slice(6,8)))/2,a=d?Bb[d]:a.Nc(),void 0!==a&&(b/=a));return b}function Yb(a){a.forEach(Zb);a.forEach(function(b){a.forEach(function(a){b!==a&&Rb(b,a,$b)})})}
function ac(){Ob.forEach(function(a){Ib.forEach(function(b){Rb(a,b,Jb);Rb(b,a,Kb)})})}function Zb(a){Pb[a.qb]=a;Rb(a,a,$b)}function bc(a){return a?"string"===typeof a?Wb(a):a:Wb("EPSG:3857")}function cc(a,b,c,d){a=Wb(a);b=Wb(b);Rb(a,b,dc(c));Rb(b,a,dc(d))}function dc(a){return function(b,c,d){var e=b.length;d=void 0!==d?d:2;c=void 0!==c?c:Array(e);var f;for(f=0;f<e;f+=d){var g=a([b[f],b[f+1]]);c[f]=g[0];c[f+1]=g[1];for(g=d-1;2<=g;--g)c[f+g]=b[f+g]}return c}}
function Wb(a){var b=null;if(a instanceof Db)b=a;else if("string"===typeof a&&(b=Pb[a]||null,!b)){var c=Cb||window.proj4;"function"==typeof c&&void 0!==c.defs(a)&&(b=new Db({code:a}),Zb(b))}return b}function ec(a,b){if(a===b)return!0;var c=a.b===b.b;return a.qb===b.qb?c:Xb(a,b)===$b&&c}function fc(a,b){a=Wb(a);b=Wb(b);return Xb(a,b)}
function Xb(a,b){var c=a.qb,d=b.qb,e=Sb(c,d);if(!e){var f=Cb||window.proj4;if("function"==typeof f){var g=f.defs(c),h=f.defs(d);void 0!==g&&void 0!==h&&(g===h?Yb([b,a]):(e=f(d,c),cc(b,a,e.forward,e.inverse)),e=Sb(c,d))}}e||(e=gc);return e}function gc(a,b){if(void 0!==b&&a!==b){for(var c=0,d=a.length;c<d;++c)b[c]=a[c];a=b}return a}function $b(a,b){if(void 0!==b){for(var c=0,d=a.length;c<d;++c)b[c]=a[c];a=b}else a=a.slice();return a}function hc(a,b,c){return fc(b,c)(a,void 0,a.length)}
function ic(a,b,c){b=fc(b,c);return qb(a,b)}function jc(){Yb(Ib);Yb(Ob);ac()}jc();function kc(a,b,c,d){return void 0!==d?(d[0]=a,d[1]=b,d[2]=c,d):[a,b,c]}function lc(a){var b=a[0],c=Array(b),d=1<<b-1,e;for(e=0;e<b;++e){var f=48;a[1]&d&&(f+=1);a[2]&d&&(f+=2);c[e]=String.fromCharCode(f);d>>=1}return c.join("")};function mc(a){this.minZoom=void 0!==a.minZoom?a.minZoom:0;this.b=a.resolutions;va(qa(this.b,function(a,b){return b-a}),17);this.maxZoom=this.b.length-1;this.f=void 0!==a.origin?a.origin:null;this.c=null;void 0!==a.origins&&(this.c=a.origins,va(this.c.length==this.b.length,20));var b=a.extent;void 0===b||this.f||this.c||(this.f=gb(b));va(!this.f&&this.c||this.f&&!this.c,18);this.i=null;void 0!==a.tileSizes&&(this.i=a.tileSizes,va(this.i.length==this.b.length,19));this.g=void 0!==a.tileSize?a.tileSize:
this.i?null:256;va(!this.g&&this.i||this.g&&!this.i,22);this.v=void 0!==b?b:null;this.a=null;this.j=[0,0];void 0!==a.sizes?this.a=a.sizes.map(function(a){return new wa(Math.min(0,a[0]),Math.max(a[0]-1,-1),Math.min(0,a[1]),Math.max(a[1]-1,-1))},this):b&&nc(this,b)}var oc=[0,0,0];k=mc.prototype;k.Yf=function(a,b,c){a=pc(this,a,b);for(var d=a.ca,e=a.da;d<=e;++d)for(var f=a.ea,g=a.ha;f<=g;++f)c([b,d,f])};
function qc(a,b,c,d,e){e=a.Fa(b,e);for(b=b[0]-1;b>=a.minZoom;){if(c.call(null,b,pc(a,e,b,d)))return!0;--b}return!1}k.G=function(){return this.v};k.cj=function(){return this.maxZoom};k.dj=function(){return this.minZoom};k.Sc=function(a){return this.f?this.f:this.c[a]};k.Ca=function(a){return this.b[a]};k.ej=function(){return this.b};function rc(a,b,c,d){return b[0]<a.maxZoom?(d=a.Fa(b,d),pc(a,d,b[0]+1,c)):null}
function sc(a,b,c,d){tc(a,b[0],b[1],c,!1,oc);var e=oc[1],f=oc[2];tc(a,b[2],b[3],c,!0,oc);a=oc[1];b=oc[2];void 0!==d?(d.ca=e,d.da=a,d.ea=f,d.ha=b):d=new wa(e,a,f,b);return d}function pc(a,b,c,d){return sc(a,b,a.Ca(c),d)}function uc(a,b){var c=a.Sc(b[0]),d=a.Ca(b[0]);a=Ka(a.eb(b[0]),a.j);return[c[0]+(b[1]+.5)*a[0]*d,c[1]+(b[2]+.5)*a[1]*d]}k.Fa=function(a,b){var c=this.Sc(a[0]),d=this.Ca(a[0]),e=Ka(this.eb(a[0]),this.j),f=c[0]+a[1]*e[0]*d;a=c[1]+a[2]*e[1]*d;return Va(f,a,f+e[0]*d,a+e[1]*d,b)};
k.Me=function(a,b,c){return tc(this,a[0],a[1],b,!1,c)};function tc(a,b,c,d,e,f){var g=a.uc(d),h=d/a.Ca(g),l=a.Sc(g);a=Ka(a.eb(g),a.j);b=h*Math.floor((b-l[0])/d+(e?.5:0))/a[0];c=h*Math.floor((c-l[1])/d+(e?0:.5))/a[1];e?(b=Math.ceil(b)-1,c=Math.ceil(c)-1):(b=Math.floor(b),c=Math.floor(c));return kc(g,b,c,f)}k.kg=function(a,b,c){return tc(this,a[0],a[1],this.Ca(b),!1,c)};k.eb=function(a){return this.g?this.g:this.i[a]};k.uc=function(a,b){return Aa(ja(this.b,a,b||0),this.minZoom,this.maxZoom)};
function nc(a,b){for(var c=a.b.length,d=Array(c),e=a.minZoom;e<c;++e)d[e]=pc(a,b,e);a.a=d};function vc(a){var b=a.j;b||(b=wc(a),a.j=b);return b}function xc(a){var b={};rb(b,a?a:{});void 0===b.extent&&(b.extent=Wb("EPSG:3857").G());b.resolutions=yc(b.extent,b.maxZoom,b.tileSize);delete b.maxZoom;return new mc(b)}function yc(a,b,c){b=void 0!==b?b:42;var d=kb(a);a=jb(a);c=Ka(void 0!==c?c:256);c=Math.max(a/c[0],d/c[1]);b+=1;d=Array(b);for(a=0;a<b;++a)d[a]=c/Math.pow(2,a);return d}function wc(a,b,c){a=zc(a);b=yc(a,b,c);return new mc({extent:a,origin:gb(a),resolutions:b,tileSize:c})}
function zc(a){a=Wb(a);var b=a.G();b||(a=180*Bb.degrees/a.Nc(),b=Va(-a,-a,a,a));return b};function Cc(a){this.b=a.html;this.a=a.tileRanges?a.tileRanges:null}Cc.prototype.f=function(){return this.b};function Dc(a){return function(b){if(b)return[Aa(b[0],a[0],a[2]),Aa(b[1],a[1],a[3])]}}function Ec(a){return a};function Fc(a){function b(b){var c=a.listener,e=a.rh||a.target;a.th&&Gc(a);return c.call(e,b)}return a.sh=b}function Hc(a,b,c,d){for(var e,f=0,g=a.length;f<g;++f)if(e=a[f],e.listener===b&&e.rh===c)return d&&(e.deleteIndex=f),e}function Ic(a,b){return(a=a.jb)?a[b]:void 0}function Jc(a){var b=a.jb;b||(b=a.jb={});return b}function Kc(a,b){var c=Ic(a,b);if(c){for(var d=0,e=c.length;d<e;++d)a.removeEventListener(b,c[d].sh),sb(c[d]);c.length=0;if(c=a.jb)delete c[b],Object.keys(c).length||delete a.jb}}
function y(a,b,c,d,e){var f=Jc(a),g=f[b];g||(g=f[b]=[]);(f=Hc(g,c,d,!1))?e||(f.th=!1):(f={rh:d,th:!!e,listener:c,target:a,type:b},a.addEventListener(b,Fc(f)),g.push(f));return f}function Lc(a,b,c,d){return y(a,b,c,d,!0)}function Mc(a,b,c,d){(a=Ic(a,b))&&(c=Hc(a,c,d,!0))&&Gc(c)}function Gc(a){if(a&&a.target){a.target.removeEventListener(a.type,a.sh);var b=Ic(a.target,a.type);if(b){var c="deleteIndex"in a?a.deleteIndex:b.indexOf(a);-1!==c&&b.splice(c,1);b.length||Kc(a.target,a.type)}sb(a)}}
function Nc(a){var b=Jc(a),c;for(c in b)Kc(a,c)};function Oc(){}Oc.prototype.mc=!1;function Pc(a){a.mc||(a.mc=!0,a.ka())}Oc.prototype.ka=ra;function Qc(a){this.type=a;this.target=null}Qc.prototype.preventDefault=Qc.prototype.stopPropagation=function(){this.Dp=!0};function Rc(a){a.stopPropagation()};function Sc(){this.Va={};this.qa={};this.pa={}}v(Sc,Oc);Sc.prototype.addEventListener=function(a,b){var c=this.pa[a];c||(c=this.pa[a]=[]);-1===c.indexOf(b)&&c.push(b)};
Sc.prototype.b=function(a){var b="string"===typeof a?new Qc(a):a;a=b.type;b.target=this;var c=this.pa[a];if(c){a in this.qa||(this.qa[a]=0,this.Va[a]=0);++this.qa[a];for(var d=0,e=c.length;d<e;++d)if(!1===c[d].call(this,b)||b.Dp){var f=!1;break}--this.qa[a];if(!this.qa[a]){b=this.Va[a];for(delete this.Va[a];b--;)this.removeEventListener(a,ra);delete this.qa[a]}return f}};Sc.prototype.ka=function(){Nc(this)};function Tc(a,b){return b?b in a.pa:0<Object.keys(a.pa).length}
Sc.prototype.removeEventListener=function(a,b){var c=this.pa[a];c&&(b=c.indexOf(b),a in this.Va?(c[b]=ra,++this.Va[a]):(c.splice(b,1),c.length||delete this.pa[a]))};function Uc(){Sc.call(this);this.f=0}v(Uc,Sc);k=Uc.prototype;k.s=function(){++this.f;this.b("change")};k.L=function(){return this.f};k.J=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=y(this,a[f],b,c);return e}return y(this,a,b,c)};k.once=function(a,b,c){if(Array.isArray(a)){for(var d=a.length,e=Array(d),f=0;f<d;++f)e[f]=Lc(this,a[f],b,c);return e}return Lc(this,a,b,c)};
k.K=function(a,b,c){if(Array.isArray(a))for(var d=0,e=a.length;d<e;++d)Mc(this,a[d],b,c);else Mc(this,a,b,c)};function Vc(a){Uc.call(this);w(this);this.R={};void 0!==a&&this.H(a)}v(Vc,Uc);var Wc={};function Xc(a){return Wc.hasOwnProperty(a)?Wc[a]:Wc[a]="change:"+a}k=Vc.prototype;k.get=function(a){var b;this.R.hasOwnProperty(a)&&(b=this.R[a]);return b};k.O=function(){return Object.keys(this.R)};k.N=function(){return rb({},this.R)};function Yc(a,b,c){var d=Xc(b);a.b(new Zc(d,b,c));a.b(new Zc("propertychange",b,c))}k.set=function(a,b,c){c?this.R[a]=b:(c=this.R[a],this.R[a]=b,c!==b&&Yc(this,a,c))};
k.H=function(a,b){for(var c in a)this.set(c,a[c],b)};k.P=function(a,b){if(a in this.R){var c=this.R[a];delete this.R[a];b||Yc(this,a,c)}};function Zc(a,b,c){Qc.call(this,a);this.key=b;this.oldValue=c}v(Zc,Qc);function $c(a,b){Vc.call(this);this.c=!!(b||{}).unique;this.a=a?a:[];if(this.c)for(a=0,b=this.a.length;a<b;++a)ad(this,this.a[a],a);bd(this)}v($c,Vc);k=$c.prototype;k.clear=function(){for(;0<this.ec();)this.pop()};k.ng=function(a){var b;var c=0;for(b=a.length;c<b;++c)this.push(a[c]);return this};k.forEach=function(a,b){a=b?a.bind(b):a;b=this.a;for(var c=0,d=b.length;c<d;++c)a(b[c],c,b)};k.Hm=function(){return this.a};k.item=function(a){return this.a[a]};k.ec=function(){return this.get(cd)};
k.Se=function(a,b){this.c&&ad(this,b);this.a.splice(a,0,b);bd(this);this.b(new dd("add",b))};k.pop=function(){return this.Pg(this.ec()-1)};k.push=function(a){this.c&&ad(this,a);var b=this.ec();this.Se(b,a);return this.ec()};k.remove=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)if(b[d]===a)return this.Pg(d)};k.Pg=function(a){var b=this.a[a];this.a.splice(a,1);bd(this);this.b(new dd("remove",b));return b};
k.jq=function(a,b){var c=this.ec();if(a<c)this.c&&ad(this,b,a),c=this.a[a],this.a[a]=b,this.b(new dd("remove",c)),this.b(new dd("add",b));else{for(;c<a;++c)this.Se(c,void 0);this.Se(a,b)}};function bd(a){a.set(cd,a.a.length)}function ad(a,b,c){for(var d=0,e=a.a.length;d<e;++d)if(a.a[d]===b&&d!==c)throw new ua(58);}var cd="length";function dd(a,b){Qc.call(this,a);this.element=b}v(dd,Qc);var ed=/^#(?:[0-9a-f]{3}){1,2}$/i,fd=/^([a-z]*)$/i;function gd(a){return Array.isArray(a)?a:hd(a)}function id(a){if("string"!==typeof a){var b=a[0];b!=(b|0)&&(b=b+.5|0);var c=a[1];c!=(c|0)&&(c=c+.5|0);var d=a[2];d!=(d|0)&&(d=d+.5|0);a="rgba("+b+","+c+","+d+","+(void 0===a[3]?1:a[3])+")"}return a}
var hd=function(){var a={},b=0;return function(c){if(a.hasOwnProperty(c))var d=a[c];else{if(1024<=b){d=0;for(var e in a)d++&3||(delete a[e],--b)}d=c;fd.exec(d)&&(e=document.createElement("div"),e.style.color=d,document.body.appendChild(e),d=getComputedStyle(e).color,document.body.removeChild(e));if(ed.exec(d)){var f=d.length-1;va(3==f||6==f,54);var g=3==f?1:2;f=parseInt(d.substr(1+0*g,g),16);e=parseInt(d.substr(1+1*g,g),16);d=parseInt(d.substr(1+2*g,g),16);1==g&&(f=(f<<4)+f,e=(e<<4)+e,d=(d<<4)+d);
f=[f,e,d,1]}else d.indexOf("rgba(")?d.indexOf("rgb(")?va(!1,14):(d=d.slice(4,-1).split(",").map(Number),d.push(1),f=jd(d)):(d=d.slice(5,-1).split(",").map(Number),f=jd(d));d=f;a[c]=d;++b}return d}}();function jd(a){var b=[];b[0]=Aa(a[0]+.5|0,0,255);b[1]=Aa(a[1]+.5|0,0,255);b[2]=Aa(a[2]+.5|0,0,255);b[3]=Aa(a[3],0,1);return b};function kd(a){return"string"===typeof a||a instanceof CanvasPattern||a instanceof CanvasGradient?a:id(a)};function ld(a,b){var c=document.createElement("CANVAS");a&&(c.width=a);b&&(c.height=b);return c.getContext("2d")}function md(a,b){var c=b.parentNode;c&&c.replaceChild(a,b)}function nd(a){a&&a.parentNode&&a.parentNode.removeChild(a)};function od(a){Vc.call(this);this.element=a.element?a.element:null;this.a=this.S=null;this.v=[];this.render=a.render?a.render:ra;a.target&&this.i(a.target)}v(od,Vc);od.prototype.ka=function(){nd(this.element);Vc.prototype.ka.call(this)};od.prototype.g=function(){return this.a};
od.prototype.setMap=function(a){this.a&&nd(this.element);for(var b=0,c=this.v.length;b<c;++b)Gc(this.v[b]);this.v.length=0;if(this.a=a)(this.S?this.S:a.D).appendChild(this.element),this.render!==ra&&this.v.push(y(a,"postrender",this.render,this)),a.render()};od.prototype.i=function(a){this.S="string"===typeof a?document.getElementById(a):a};function pd(a){a=a?a:{};this.I=document.createElement("UL");this.u=document.createElement("LI");this.I.appendChild(this.u);this.u.style.display="none";this.c=void 0!==a.collapsed?a.collapsed:!0;this.l=void 0!==a.collapsible?a.collapsible:!0;this.l||(this.c=!1);var b=void 0!==a.className?a.className:"ol-attribution",c=void 0!==a.tipLabel?a.tipLabel:"Attributions",d=void 0!==a.collapseLabel?a.collapseLabel:"\u00bb";"string"===typeof d?(this.D=document.createElement("span"),this.D.textContent=d):this.D=
d;d=void 0!==a.label?a.label:"i";"string"===typeof d?(this.B=document.createElement("span"),this.B.textContent=d):this.B=d;var e=this.l&&!this.c?this.D:this.B;d=document.createElement("button");d.setAttribute("type","button");d.title=c;d.appendChild(e);y(d,"click",this.jn,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control"+(this.c&&this.l?" ol-collapsed":"")+(this.l?"":" ol-uncollapsible");c.appendChild(this.I);c.appendChild(d);od.call(this,{element:c,render:a.render?
a.render:qd,target:a.target});this.C=!0;this.o={};this.j={};this.U={}}v(pd,od);
function qd(a){if(a=a.frameState){var b,c,d,e,f,g=a.layerStatesArray,h=rb({},a.attributions),l={},m={},n=a.viewState.projection;var p=0;for(b=g.length;p<b;p++)if(e=g[p].layer.ia()){var q=w(e).toString();if(f=e.j){var t=0;for(c=f.length;t<c;t++){var u=f[t];var x=w(u).toString();if(!(x in h)){if(d=a.usedTiles[q]){var B=e.Ta(n);a:{var z=void 0;var G,E=u,ia=B,T=n;if(E.a){for(z in d)if(z in E.a){B=d[z];var R=0;for(G=E.a[z].length;R<G;++R){var U=E.a[z][R];if(za(U,B)){z=!0;break a}var ta=pc(ia,zc(T),parseInt(z,
10)),A=ta.da-ta.ca+1;if(B.ca<ta.ca||B.da>ta.da)if(za(U,new wa(Ga(B.ca,A),Ga(B.da,A),B.ea,B.ha))||B.da-B.ca+1>A&&za(U,ta)){z=!0;break a}}}z=!1}else z=!0}}else z=!1;z?(x in l&&delete l[x],z=u.b,z in m||(m[z]=!0,h[x]=u)):l[x]=u}}}}b=[h,l];p=b[0];b=b[1];for(var ea in this.o)ea in p?(this.j[ea]||(this.o[ea].style.display="",this.j[ea]=!0),delete p[ea]):ea in b?(this.j[ea]&&(this.o[ea].style.display="none",delete this.j[ea]),delete b[ea]):(nd(this.o[ea]),delete this.o[ea],delete this.j[ea]);for(ea in p)t=
document.createElement("LI"),t.innerHTML=p[ea].b,this.I.appendChild(t),this.o[ea]=t,this.j[ea]=!0;for(ea in b)t=document.createElement("LI"),t.innerHTML=b[ea].b,t.style.display="none",this.I.appendChild(t),this.o[ea]=t;ea=!ub(this.j)||!ub(a.logos);this.C!=ea&&(this.element.style.display=ea?"":"none",this.C=ea);ea&&ub(this.j)?this.element.classList.add("ol-logo-only"):this.element.classList.remove("ol-logo-only");a=a.logos;ea=this.U;for(da in ea)da in a||(nd(ea[da]),delete ea[da]);for(var Ya in a)if(b=
a[Ya],b instanceof HTMLElement&&(this.u.appendChild(b),ea[Ya]=b),!(Ya in ea)){var da=new Image;da.src=Ya;""===b?p=da:(p=document.createElement("a"),p.href=b,p.appendChild(da));this.u.appendChild(p);ea[Ya]=p}this.u.style.display=ub(a)?"none":""}else this.C&&(this.element.style.display="none",this.C=!1)}k=pd.prototype;k.jn=function(a){a.preventDefault();rd(this)};function rd(a){a.element.classList.toggle("ol-collapsed");a.c?md(a.D,a.B):md(a.B,a.D);a.c=!a.c}k.hn=function(){return this.l};
k.ln=function(a){this.l!==a&&(this.l=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.c&&rd(this))};k.kn=function(a){this.l&&this.c!==a&&rd(this)};k.gn=function(){return this.c};function sd(a){return Math.pow(a,3)}function td(a){return 1-sd(1-a)}function ud(a){return 3*a*a-2*a*a*a}function vd(a){return a};function wd(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-rotate",c=void 0!==a.label?a.label:"\u21e7";this.c=null;"string"===typeof c?(this.c=document.createElement("span"),this.c.className="ol-compass",this.c.textContent=c):(this.c=c,this.c.classList.add("ol-compass"));var d=a.tipLabel?a.tipLabel:"Reset rotation";c=document.createElement("button");c.className=b+"-reset";c.setAttribute("type","button");c.title=d;c.appendChild(this.c);y(c,"click",wd.prototype.D,this);d=document.createElement("div");
d.className=b+" ol-unselectable ol-control";d.appendChild(c);b=a.render?a.render:xd;this.l=a.resetNorth?a.resetNorth:void 0;od.call(this,{element:d,render:b,target:a.target});this.o=void 0!==a.duration?a.duration:250;this.j=void 0!==a.autoHide?a.autoHide:!0;this.u=void 0;this.j&&this.element.classList.add("ol-hidden")}v(wd,od);wd.prototype.D=function(a){a.preventDefault();this.l?this.l():(a=this.a.$())&&void 0!==a.Qa()&&(0<this.o?a.animate({rotation:0,duration:this.o,easing:td}):a.Ze(0))};
function xd(a){if(a=a.frameState){a=a.viewState.rotation;if(a!=this.u){var b="rotate("+a+"rad)";if(this.j){var c=this.element.classList.contains("ol-hidden");c||a?c&&a&&this.element.classList.remove("ol-hidden"):this.element.classList.add("ol-hidden")}this.c.style.msTransform=b;this.c.style.webkitTransform=b;this.c.style.transform=b}this.u=a}};function yd(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-zoom",c=void 0!==a.delta?a.delta:1,d=void 0!==a.zoomInLabel?a.zoomInLabel:"+",e=void 0!==a.zoomOutLabel?a.zoomOutLabel:"\u2212",f=void 0!==a.zoomInTipLabel?a.zoomInTipLabel:"Zoom in",g=void 0!==a.zoomOutTipLabel?a.zoomOutTipLabel:"Zoom out",h=document.createElement("button");h.className=b+"-in";h.setAttribute("type","button");h.title=f;h.appendChild("string"===typeof d?document.createTextNode(d):d);y(h,"click",yd.prototype.j.bind(this,
c));d=document.createElement("button");d.className=b+"-out";d.setAttribute("type","button");d.title=g;d.appendChild("string"===typeof e?document.createTextNode(e):e);y(d,"click",yd.prototype.j.bind(this,-c));c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(h);c.appendChild(d);od.call(this,{element:c,target:a.target});this.c=void 0!==a.duration?a.duration:250}v(yd,od);
yd.prototype.j=function(a,b){b.preventDefault();if(b=this.a.$()){var c=b.Pa();c&&(a=b.constrainResolution(c,a),0<this.c?(b.Kc()&&b.hd(),b.animate({resolution:a,duration:this.c,easing:td})):b.Yc(a))}};function zd(a){a=a?a:{};var b=new $c;(void 0!==a.zoom?a.zoom:1)&&b.push(new yd(a.zoomOptions));(void 0!==a.rotate?a.rotate:1)&&b.push(new wd(a.rotateOptions));(void 0!==a.attribution?a.attribution:1)&&b.push(new pd(a.attributionOptions));return b};function Ad(a){a=a?a:{};this.c=void 0!==a.className?a.className:"ol-full-screen";var b=void 0!==a.label?a.label:"\u2922";this.l="string"===typeof b?document.createTextNode(b):b;b=void 0!==a.labelActive?a.labelActive:"\u00d7";this.o="string"===typeof b?document.createTextNode(b):b;var c=a.tipLabel?a.tipLabel:"Toggle full-screen";b=document.createElement("button");b.className=this.c+"-"+Bd();b.setAttribute("type","button");b.title=c;b.appendChild(this.l);y(b,"click",this.B,this);c=document.createElement("div");
c.className=this.c+" ol-unselectable ol-control "+(Cd()?"":"ol-unsupported");c.appendChild(b);od.call(this,{element:c,target:a.target});this.D=void 0!==a.keys?a.keys:!1;this.j=a.source}v(Ad,od);
Ad.prototype.B=function(a){a.preventDefault();Cd()&&(a=this.a)&&(Bd()?document.exitFullscreen?document.exitFullscreen():document.msExitFullscreen?document.msExitFullscreen():document.mozCancelFullScreen?document.mozCancelFullScreen():document.webkitExitFullscreen&&document.webkitExitFullscreen():(a=this.j?"string"===typeof this.j?document.getElementById(this.j):this.j:a.pd(),this.D?a.mozRequestFullScreenWithKeys?a.mozRequestFullScreenWithKeys():a.webkitRequestFullscreen?a.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT):
Dd(a):Dd(a)))};Ad.prototype.u=function(){var a=this.element.firstElementChild,b=this.a;Bd()?(a.className=this.c+"-true",md(this.o,this.l)):(a.className=this.c+"-false",md(this.l,this.o));b&&b.Fd()};Ad.prototype.setMap=function(a){od.prototype.setMap.call(this,a);a&&this.v.push(y(document,Ed(),this.u,this))};
function Cd(){var a=document.body;return!!(a.webkitRequestFullscreen||a.mozRequestFullScreen&&document.mozFullScreenEnabled||a.msRequestFullscreen&&document.msFullscreenEnabled||a.requestFullscreen&&document.fullscreenEnabled)}function Bd(){return!!(document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement||document.fullscreenElement)}
function Dd(a){a.requestFullscreen?a.requestFullscreen():a.msRequestFullscreen?a.msRequestFullscreen():a.mozRequestFullScreen?a.mozRequestFullScreen():a.webkitRequestFullscreen&&a.webkitRequestFullscreen()}var Ed=function(){var a;return function(){if(!a){var b=document.body;b.webkitRequestFullscreen?a="webkitfullscreenchange":b.mozRequestFullScreen?a="mozfullscreenchange":b.msRequestFullscreen?a="MSFullscreenChange":b.requestFullscreen&&(a="fullscreenchange")}return a}}();function Fd(a){a=a?a:{};var b=document.createElement("DIV");b.className=void 0!==a.className?a.className:"ol-mouse-position";od.call(this,{element:b,render:a.render?a.render:Gd,target:a.target});y(this,Xc(Hd),this.mn,this);a.coordinateFormat&&this.uj(a.coordinateFormat);a.projection&&this.ji(a.projection);this.u=void 0!==a.undefinedHTML?a.undefinedHTML:"";this.o=b.innerHTML;this.l=this.j=this.c=null}v(Fd,od);
function Gd(a){a=a.frameState;a?this.c!=a.viewState.projection&&(this.c=a.viewState.projection,this.j=null):this.c=null;Id(this,this.l)}k=Fd.prototype;k.mn=function(){this.j=null};k.Fh=function(){return this.get(Jd)};k.ii=function(){return this.get(Hd)};k.Xl=function(a){this.l=this.a.He(a);Id(this,this.l)};k.Yl=function(){Id(this,null);this.l=null};k.setMap=function(a){od.prototype.setMap.call(this,a);a&&(a=a.a,this.v.push(y(a,"mousemove",this.Xl,this),y(a,"mouseout",this.Yl,this)))};
k.uj=function(a){this.set(Jd,a)};k.ji=function(a){this.set(Hd,Wb(a))};function Id(a,b){var c=a.u;if(b&&a.c){if(!a.j){var d=a.ii();a.j=d?Xb(a.c,d):gc}if(b=a.a.Xa(b))a.j(b,b),c=(c=a.Fh())?c(b):b.toString()}a.o&&c==a.o||(a.element.innerHTML=c,a.o=c)}var Hd="projection",Jd="coordinateFormat";function Kd(a,b,c){Qc.call(this,a);this.map=b;this.frameState=void 0!==c?c:null}v(Kd,Qc);function Ld(a,b,c,d,e){Kd.call(this,a,b,e);this.originalEvent=c;this.pixel=b.He(c);this.coordinate=b.Xa(this.pixel);this.dragging=void 0!==d?d:!1}v(Ld,Kd);Ld.prototype.preventDefault=function(){Kd.prototype.preventDefault.call(this);this.originalEvent.preventDefault()};Ld.prototype.stopPropagation=function(){Kd.prototype.stopPropagation.call(this);this.originalEvent.stopPropagation()};var Md=["experimental-webgl","webgl","webkit-3d","moz-webgl"];function Nd(a,b){var c,d,e=Md.length;for(d=0;d<e;++d)try{if(c=a.getContext(Md[d],b))return c}catch(f){}return null};var Od,Pd="undefined"!==typeof navigator?navigator.userAgent.toLowerCase():"",Qd=-1!==Pd.indexOf("firefox"),Rd=-1!==Pd.indexOf("safari")&&-1==Pd.indexOf("chrom"),Sd=-1!==Pd.indexOf("webkit")&&-1==Pd.indexOf("edge"),Td=-1!==Pd.indexOf("macintosh"),Ud=window.devicePixelRatio||1,Vd=!1,Wd=function(){if(!("HTMLCanvasElement"in window))return!1;try{var a=document.createElement("CANVAS").getContext("2d");return a?(void 0!==a.setLineDash&&(Vd=!0),!0):!1}catch(b){return!1}}(),Xd="DeviceOrientationEvent"in
window,Yd="geolocation"in navigator,Zd="ontouchstart"in window,$d="PointerEvent"in window,ae=!!navigator.msPointerEnabled,be=!1,ce,de=[];if("WebGLRenderingContext"in window)try{var ee=Nd(document.createElement("CANVAS"),{failIfMajorPerformanceCaveat:!0});ee&&(be=!0,ce=ee.getParameter(ee.MAX_TEXTURE_SIZE),de=ee.getSupportedExtensions())}catch(a){}Od=be;ca=de;ba=ce;var fe={Wq:"singleclick",Lq:"click",Mq:"dblclick",Pq:"pointerdrag",Sq:"pointermove",Oq:"pointerdown",Vq:"pointerup",Uq:"pointerover",Tq:"pointerout",Qq:"pointerenter",Rq:"pointerleave",Nq:"pointercancel"};function ie(a,b,c,d,e){Ld.call(this,a,b,c.b,d,e);this.b=c}v(ie,Ld);function je(a,b){this.b=a;this.i=b};function ke(a){je.call(this,a,{mousedown:this.tm,mousemove:this.um,mouseup:this.xm,mouseover:this.wm,mouseout:this.vm});this.a=a.f;this.f=[]}v(ke,je);function le(a,b){a=a.f;var c=b.clientX;b=b.clientY;for(var d=0,e=a.length,f;d<e&&(f=a[d]);d++){var g=Math.abs(b-f[1]);if(25>=Math.abs(c-f[0])&&25>=g)return!0}return!1}function me(a){var b=ne(a,a),c=b.preventDefault;b.preventDefault=function(){a.preventDefault();c()};b.pointerId=1;b.isPrimary=!0;b.pointerType="mouse";return b}k=ke.prototype;
k.tm=function(a){if(!le(this,a)){(1).toString()in this.a&&this.cancel(a);var b=me(a);this.a[(1).toString()]=a;oe(this.b,"pointerdown",b,a)}};k.um=function(a){if(!le(this,a)){var b=me(a);oe(this.b,"pointermove",b,a)}};k.xm=function(a){if(!le(this,a)){var b=this.a[(1).toString()];b&&b.button===a.button&&(b=me(a),oe(this.b,"pointerup",b,a),delete this.a[(1).toString()])}};k.wm=function(a){if(!le(this,a)){var b=me(a);pe(this.b,b,a)}};k.vm=function(a){if(!le(this,a)){var b=me(a);qe(this.b,b,a)}};
k.cancel=function(a){var b=me(a);this.b.cancel(b,a);delete this.a[(1).toString()]};function re(a){je.call(this,a,{MSPointerDown:this.Cm,MSPointerMove:this.Dm,MSPointerUp:this.Gm,MSPointerOut:this.Em,MSPointerOver:this.Fm,MSPointerCancel:this.Bm,MSGotPointerCapture:this.zm,MSLostPointerCapture:this.Am});this.a=a.f;this.f=["","unavailable","touch","pen","mouse"]}v(re,je);function se(a,b){var c=b;"number"===typeof b.pointerType&&(c=ne(b,b),c.pointerType=a.f[b.pointerType]);return c}k=re.prototype;
k.Cm=function(a){this.a[a.pointerId.toString()]=a;var b=se(this,a);oe(this.b,"pointerdown",b,a)};k.Dm=function(a){var b=se(this,a);oe(this.b,"pointermove",b,a)};k.Gm=function(a){var b=se(this,a);oe(this.b,"pointerup",b,a);delete this.a[a.pointerId.toString()]};k.Em=function(a){var b=se(this,a);qe(this.b,b,a)};k.Fm=function(a){var b=se(this,a);pe(this.b,b,a)};k.Bm=function(a){var b=se(this,a);this.b.cancel(b,a);delete this.a[a.pointerId.toString()]};
k.Am=function(a){this.b.b(new te("lostpointercapture",a,a))};k.zm=function(a){this.b.b(new te("gotpointercapture",a,a))};function ue(a){je.call(this,a,{pointerdown:this.vp,pointermove:this.wp,pointerup:this.zp,pointerout:this.xp,pointerover:this.yp,pointercancel:this.up,gotpointercapture:this.Gl,lostpointercapture:this.sm})}v(ue,je);k=ue.prototype;k.vp=function(a){ve(this.b,a)};k.wp=function(a){ve(this.b,a)};k.zp=function(a){ve(this.b,a)};k.xp=function(a){ve(this.b,a)};k.yp=function(a){ve(this.b,a)};k.up=function(a){ve(this.b,a)};k.sm=function(a){ve(this.b,a)};k.Gl=function(a){ve(this.b,a)};function te(a,b,c){Qc.call(this,a);this.b=b;a=c?c:{};this.buttons=we(a);this.pressure=xe(a,this.buttons);this.bubbles="bubbles"in a?a.bubbles:!1;this.cancelable="cancelable"in a?a.cancelable:!1;this.view="view"in a?a.view:null;this.detail="detail"in a?a.detail:null;this.screenX="screenX"in a?a.screenX:0;this.screenY="screenY"in a?a.screenY:0;this.clientX="clientX"in a?a.clientX:0;this.clientY="clientY"in a?a.clientY:0;this.ctrlKey="ctrlKey"in a?a.ctrlKey:!1;this.altKey="altKey"in a?a.altKey:!1;this.shiftKey=
"shiftKey"in a?a.shiftKey:!1;this.metaKey="metaKey"in a?a.metaKey:!1;this.button="button"in a?a.button:0;this.relatedTarget="relatedTarget"in a?a.relatedTarget:null;this.pointerId="pointerId"in a?a.pointerId:0;this.width="width"in a?a.width:0;this.height="height"in a?a.height:0;this.tiltX="tiltX"in a?a.tiltX:0;this.tiltY="tiltY"in a?a.tiltY:0;this.pointerType="pointerType"in a?a.pointerType:"";this.isPrimary="isPrimary"in a?a.isPrimary:!1;b.preventDefault&&(this.preventDefault=function(){b.preventDefault()})}
v(te,Qc);function we(a){if(a.buttons||ye)a=a.buttons;else switch(a.which){case 1:a=1;break;case 2:a=4;break;case 3:a=2;break;default:a=0}return a}function xe(a,b){var c=0;a.pressure?c=a.pressure:c=b?.5:0;return c}var ye=!1;try{ye=1===(new MouseEvent("click",{buttons:1})).buttons}catch(a){};function ze(a,b){je.call(this,a,{touchstart:this.Fq,touchmove:this.Eq,touchend:this.Dq,touchcancel:this.Cq});this.a=a.f;this.j=b;this.f=void 0;this.g=0;this.c=void 0}v(ze,je);k=ze.prototype;k.sj=function(){this.g=0;this.c=void 0};
function Ae(a,b,c){b=ne(b,c);b.pointerId=c.identifier+2;b.bubbles=!0;b.cancelable=!0;b.detail=a.g;b.button=0;b.buttons=1;b.width=c.webkitRadiusX||c.radiusX||0;b.height=c.webkitRadiusY||c.radiusY||0;b.pressure=c.webkitForce||c.force||.5;b.isPrimary=a.f===c.identifier;b.pointerType="touch";b.clientX=c.clientX;b.clientY=c.clientY;b.screenX=c.screenX;b.screenY=c.screenY;return b}
function Be(a,b,c){function d(){b.preventDefault()}var e=Array.prototype.slice.call(b.changedTouches),f=e.length,g;for(g=0;g<f;++g){var h=Ae(a,b,e[g]);h.preventDefault=d;c.call(a,b,h)}}
k.Fq=function(a){var b=a.touches,c=Object.keys(this.a),d=c.length;if(d>=b.length){var e=[],f;for(f=0;f<d;++f){var g=c[f];var h=this.a[g];var l;if(!(l=1==g))a:{for(var m=b.length,n=0;n<m;n++)if(l=b[n],l.identifier===g-2){l=!0;break a}l=!1}l||e.push(h.out)}for(f=0;f<e.length;++f)this.Rf(a,e[f])}b=a.changedTouches[0];c=Object.keys(this.a).length;if(!c||1===c&&(1).toString()in this.a)this.f=b.identifier,void 0!==this.c&&clearTimeout(this.c);Ce(this,a);this.g++;Be(this,a,this.qp)};
k.qp=function(a,b){this.a[b.pointerId]={target:b.target,out:b,fj:b.target};var c=this.b;b.bubbles=!0;oe(c,"pointerover",b,a);c=this.b;b.bubbles=!1;oe(c,"pointerenter",b,a);oe(this.b,"pointerdown",b,a)};k.Eq=function(a){a.preventDefault();Be(this,a,this.ym)};
k.ym=function(a,b){var c=this.a[b.pointerId];if(c){var d=c.out,e=c.fj;oe(this.b,"pointermove",b,a);d&&e!==b.target&&(d.relatedTarget=b.target,b.relatedTarget=e,d.target=e,b.target?(qe(this.b,d,a),pe(this.b,b,a)):(b.target=e,b.relatedTarget=null,this.Rf(a,b)));c.out=b;c.fj=b.target}};k.Dq=function(a){Ce(this,a);Be(this,a,this.Gq)};
k.Gq=function(a,b){oe(this.b,"pointerup",b,a);this.b.out(b,a);De(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.sj.bind(this),200))};k.Cq=function(a){Be(this,a,this.Rf)};k.Rf=function(a,b){this.b.cancel(b,a);this.b.out(b,a);De(this.b,b,a);delete this.a[b.pointerId];b.isPrimary&&(this.f=void 0,this.c=setTimeout(this.sj.bind(this),200))};
function Ce(a,b){var c=a.j.f;b=b.changedTouches[0];if(a.f===b.identifier){var d=[b.clientX,b.clientY];c.push(d);setTimeout(function(){var a=c.indexOf(d);-1<a&&c.splice(a,1)},2500)}};function Ee(a){Sc.call(this);this.g=a;this.f={};this.i={};this.a=[];$d?Fe(this,new ue(this)):ae?Fe(this,new re(this)):(a=new ke(this),Fe(this,a),Zd&&Fe(this,new ze(this,a)));a=this.a.length;for(var b,c=0;c<a;c++)b=this.a[c],Ge(this,Object.keys(b.i))}v(Ee,Sc);function Fe(a,b){var c=Object.keys(b.i);c&&(c.forEach(function(a){var c=b.i[a];c&&(this.i[a]=c.bind(b))},a),a.a.push(b))}Ee.prototype.c=function(a){var b=this.i[a.type];b&&b(a)};
function Ge(a,b){b.forEach(function(a){y(this.g,a,this.c,this)},a)}function He(a,b){b.forEach(function(a){Mc(this.g,a,this.c,this)},a)}function ne(a,b){for(var c={},d,e=0,f=Ie.length;e<f;e++)d=Ie[e][0],c[d]=a[d]||b[d]||Ie[e][1];return c}function De(a,b,c){b.bubbles=!1;oe(a,"pointerleave",b,c)}Ee.prototype.out=function(a,b){a.bubbles=!0;oe(this,"pointerout",a,b)};Ee.prototype.cancel=function(a,b){oe(this,"pointercancel",a,b)};
function qe(a,b,c){a.out(b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||De(a,b,c)}function pe(a,b,c){b.bubbles=!0;oe(a,"pointerover",b,c);var d=b.target,e=b.relatedTarget;d&&e&&d.contains(e)||(b.bubbles=!1,oe(a,"pointerenter",b,c))}function oe(a,b,c,d){a.b(new te(b,d,c))}function ve(a,b){a.b(new te(b.type,b,b))}Ee.prototype.ka=function(){for(var a=this.a.length,b,c=0;c<a;c++)b=this.a[c],He(this,Object.keys(b.i));Sc.prototype.ka.call(this)};
var Ie=[["bubbles",!1],["cancelable",!1],["view",null],["detail",null],["screenX",0],["screenY",0],["clientX",0],["clientY",0],["ctrlKey",!1],["altKey",!1],["shiftKey",!1],["metaKey",!1],["button",0],["relatedTarget",null],["buttons",0],["pointerId",0],["width",0],["height",0],["pressure",0],["tiltX",0],["tiltY",0],["pointerType",""],["hwTimestamp",0],["isPrimary",!1],["type",""],["target",null],["currentTarget",null],["which",0]];function Je(a,b){Sc.call(this);this.f=a;this.j=0;this.l=!1;this.i=[];this.D=b?b*Ud:Ud;this.c=null;a=this.f.a;this.R=0;this.u={};this.g=new Ee(a);this.a=null;this.o=y(this.g,"pointerdown",this.$l,this);this.v=y(this.g,"pointermove",this.Yp,this)}v(Je,Sc);function Ke(a,b){var c=new ie("click",a.f,b);a.b(c);a.j?(clearTimeout(a.j),a.j=0,c=new ie("dblclick",a.f,b),a.b(c)):a.j=setTimeout(function(){this.j=0;var a=new ie("singleclick",this.f,b);this.b(a)}.bind(a),250)}
function Le(a,b){"pointerup"==b.type||"pointercancel"==b.type?delete a.u[b.pointerId]:"pointerdown"==b.type&&(a.u[b.pointerId]=!0);a.R=Object.keys(a.u).length}k=Je.prototype;k.Sh=function(a){Le(this,a);var b=new ie("pointerup",this.f,a);this.b(b);this.l||a.button||Ke(this,this.c);this.R||(this.i.forEach(Gc),this.i.length=0,this.l=!1,this.c=null,Pc(this.a),this.a=null)};
k.$l=function(a){Le(this,a);var b=new ie("pointerdown",this.f,a);this.b(b);this.c=a;this.i.length||(this.a=new Ee(document),this.i.push(y(this.a,"pointermove",this.Vm,this),y(this.a,"pointerup",this.Sh,this),y(this.g,"pointercancel",this.Sh,this)))};k.Vm=function(a){if(Me(this,a)){this.l=!0;var b=new ie("pointerdrag",this.f,a,this.l);this.b(b)}a.preventDefault()};k.Yp=function(a){this.b(new ie(a.type,this.f,a,!(!this.c||!Me(this,a))))};
function Me(a,b){return Math.abs(b.clientX-a.c.clientX)>a.D||Math.abs(b.clientY-a.c.clientY)>a.D}k.ka=function(){this.v&&(Gc(this.v),this.v=null);this.o&&(Gc(this.o),this.o=null);this.i.forEach(Gc);this.i.length=0;this.a&&(Pc(this.a),this.a=null);this.g&&(Pc(this.g),this.g=null);Sc.prototype.ka.call(this)};function Ne(a,b){this.o=a;this.c=b;this.b=[];this.f=[];this.a={}}Ne.prototype.clear=function(){this.b.length=0;this.f.length=0;sb(this.a)};function Oe(a){var b=a.b,c=a.f,d=b[0];1==b.length?(b.length=0,c.length=0):(b[0]=b.pop(),c[0]=c.pop(),Pe(a,0));b=a.c(d);delete a.a[b];return d}Ne.prototype.i=function(a){va(!(this.c(a)in this.a),31);var b=this.o(a);return Infinity!=b?(this.b.push(a),this.f.push(b),this.a[this.c(a)]=!0,Qe(this,0,this.b.length-1),!0):!1};
function Pe(a,b){for(var c=a.b,d=a.f,e=c.length,f=c[b],g=d[b],h=b;b<e>>1;){var l=2*b+1,m=2*b+2;l=m<e&&d[m]<d[l]?m:l;c[b]=c[l];d[b]=d[l];b=l}c[b]=f;d[b]=g;Qe(a,h,b)}function Qe(a,b,c){var d=a.b;a=a.f;for(var e=d[c],f=a[c];c>b;){var g=c-1>>1;if(a[g]>f)d[c]=d[g],a[c]=a[g],c=g;else break}d[c]=e;a[c]=f}
function Re(a){var b=a.o,c=a.b,d=a.f,e=0,f=c.length,g;for(g=0;g<f;++g){var h=c[g];var l=b(h);Infinity==l?delete a.a[a.c(h)]:(d[e]=l,c[e++]=h)}c.length=e;d.length=e;for(b=(a.b.length>>1)-1;0<=b;b--)Pe(a,b)};function Se(a,b){Ne.call(this,function(b){return a.apply(null,b)},function(a){return a[0].fb()});this.v=b;this.j=0;this.g={}}v(Se,Ne);Se.prototype.i=function(a){var b=Ne.prototype.i.call(this,a);b&&y(a[0],"change",this.l,this);return b};Se.prototype.l=function(a){a=a.target;var b=a.getState();if(2===b||3===b||4===b||5===b)Mc(a,"change",this.l,this),a=a.fb(),a in this.g&&(delete this.g[a],--this.j),this.v()};
function Te(a,b,c){for(var d=0,e=!1,f,g,h;a.j<b&&d<c&&0<a.b.length;)g=Oe(a)[0],h=g.fb(),f=g.getState(),5===f?e=!0:0!==f||h in a.g||(a.g[h]=!0,++a.j,++d,g.load());!d&&e&&a.v()};function Ue(a){return function(b,c,d){if(void 0!==b)return b=ja(a,b,d),b=Aa(b+c,0,a.length-1),c=Math.floor(b),b!=c&&c<a.length-1?a[c]/Math.pow(a[c]/a[c+1],b-c):a[c]}}function Ve(a,b,c){return function(d,e,f){if(void 0!==d)return d=Math.max(Math.floor(Math.log(b/d)/Math.log(a)+(-f/2+.5))+e,0),void 0!==c&&(d=Math.min(d,c)),b/Math.pow(a,d)}};function We(a){if(void 0!==a)return 0}function Xe(a,b){if(void 0!==a)return a+b}function Ye(a){var b=2*Math.PI/a;return function(a,d){if(void 0!==a)return a=Math.floor((a+d)/b+.5)*b}}function Ze(){var a=Fa(5);return function(b,c){if(void 0!==b)return Math.abs(b+c)<=a?0:b+c}};function $e(a,b){a=void 0!==b?a.toFixed(b):""+a;b=a.indexOf(".");b=-1===b?a.length:b;return 2<b?a:Array(3-b).join("0")+a}function af(a){a=(""+a).split(".");for(var b=["1","3"],c=0;c<Math.max(a.length,b.length);c++){var d=parseInt(a[c]||"0",10),e=parseInt(b[c]||"0",10);if(d>e)return 1;if(e>d)return-1}return 0};function bf(a,b){a[0]+=b[0];a[1]+=b[1];return a}function cf(a,b){var c=b.vd(),d=b.xa();b=d[0];d=d[1];var e=a[0]-b;a=a[1]-d;e||a||(e=1);var f=Math.sqrt(e*e+a*a);return[b+c*e/f,d+c*a/f]}function df(a,b){var c=a[0];a=a[1];var d=b[0],e=b[1];b=d[0];d=d[1];var f=e[0];e=e[1];var g=f-b,h=e-d;c=g||h?(g*(c-b)+h*(a-d))/(g*g+h*h||0):0;0>=c?(a=b,c=d):1<=c?(a=f,c=e):(a=b+c*g,c=d+c*h);return[a,c]}
function ef(a,b,c){b=Ga(b+180,360)-180;var d=Math.abs(3600*b);c=c||0;var e=Math.pow(10,c),f=Math.floor(d/3600),g=Math.floor((d-3600*f)/60);d=Math.ceil((d-3600*f-60*g)*e)/e;60<=d&&(d=0,g+=1);60<=g&&(g=0,f+=1);return f+"\u00b0 "+$e(g)+"\u2032 "+$e(d,c)+"\u2033"+(b?" "+a.charAt(0>b?1:0):"")}function ff(a,b,c){return a?b.replace("{x}",a[0].toFixed(c)).replace("{y}",a[1].toFixed(c)):""}function gf(a,b){for(var c=!0,d=a.length-1;0<=d;--d)if(a[d]!=b[d]){c=!1;break}return c}
function hf(a,b){var c=Math.cos(b);b=Math.sin(b);var d=a[1]*c+a[0]*b;a[0]=a[0]*c-a[1]*b;a[1]=d;return a}function jf(a,b){a[0]*=b;a[1]*=b}function kf(a,b){var c=a[0]-b[0];a=a[1]-b[1];return c*c+a*a}function lf(a,b){return Math.sqrt(kf(a,b))}function mf(a,b){return kf(a,df(a,b))}function nf(a,b){return ff(a,"{x}, {y}",b)};function pf(){return!0}function qf(){return!1};function rf(){Vc.call(this);this.o=Ma();this.v=-1;this.i={};this.l=this.g=0}v(rf,Vc);k=rf.prototype;k.Db=function(a,b){b=b?b:[NaN,NaN];this.Jb(a[0],a[1],b,Infinity);return b};k.wb=function(a){return this.Pc(a[0],a[1])};k.Pc=qf;k.G=function(a){this.v!=this.f&&(this.o=this.De(this.o),this.v=this.f);var b=this.o;a?(a[0]=b[0],a[1]=b[1],a[2]=b[2],a[3]=b[3]):a=b;return a};k.Pb=function(a){return this.ae(a*a)};k.mb=function(a,b){this.Fc(fc(a,b));return this};function sf(a,b,c,d,e,f){for(var g=f?f:[],h=0;b<c;b+=d){var l=a[b],m=a[b+1];g[h++]=e[0]*l+e[2]*m+e[4];g[h++]=e[1]*l+e[3]*m+e[5]}f&&g.length!=h&&(g.length=h);return g}function tf(a,b,c,d,e,f,g){for(var h=g?g:[],l=0,m;b<c;b+=d)for(h[l++]=a[b]+e,h[l++]=a[b+1]+f,m=b+2;m<b+d;++m)h[l++]=a[m];g&&h.length!=l&&(h.length=l);return h};function uf(){rf.call(this);this.ja="XY";this.a=2;this.A=null}v(uf,rf);function vf(a){var b;"XY"==a?b=2:"XYZ"==a||"XYM"==a?b=3:"XYZM"==a&&(b=4);return b}k=uf.prototype;k.Pc=qf;k.De=function(a){return Za(this.A,0,this.A.length,this.a,a)};k.bc=function(){return this.A.slice(0,this.a)};k.ba=function(){return this.A};k.cc=function(){return this.A.slice(this.A.length-this.a)};k.dc=function(){return this.ja};
k.ae=function(a){this.l!=this.f&&(sb(this.i),this.g=0,this.l=this.f);if(0>a||this.g&&a<=this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=this.od(a);if(c.ba().length<this.A.length)return this.i[b]=c;this.g=a;return this};k.od=function(){return this};k.ma=function(){return this.a};function wf(a,b,c){a.a=vf(b);a.ja=b;a.A=c}
function xf(a,b,c,d){if(b)c=vf(b);else{for(b=0;b<d;++b)if(c.length)c=c[0];else{a.ja="XY";a.a=2;return}c=c.length;var e;2==c?e="XY":3==c?e="XYZ":4==c&&(e="XYZM");b=e}a.ja=b;a.a=c}k.Fc=function(a){this.A&&(a(this.A,this.A,this.a),this.s())};
k.rotate=function(a,b){var c=this.ba();if(c){var d=c.length,e=this.ma(),f=c?c:[],g=Math.cos(a);a=Math.sin(a);var h=b[0];b=b[1];for(var l=0,m=0;m<d;m+=e){var n=c[m]-h,p=c[m+1]-b;f[l++]=h+n*g-p*a;f[l++]=b+n*a+p*g;for(n=m+2;n<m+e;++n)f[l++]=c[n]}c&&f.length!=l&&(f.length=l);this.s()}};
k.scale=function(a,b,c){var d=b;void 0===d&&(d=a);var e=c;e||(e=lb(this.G()));if(c=this.ba()){b=c.length;var f=this.ma(),g=c?c:[],h=e[0];e=e[1];for(var l=0,m=0;m<b;m+=f){var n=c[m]-h,p=c[m+1]-e;g[l++]=h+a*n;g[l++]=e+d*p;for(n=m+2;n<m+f;++n)g[l++]=c[n]}c&&g.length!=l&&(g.length=l);this.s()}};k.translate=function(a,b){var c=this.ba();c&&(tf(c,0,c.length,this.ma(),a,b,c),this.s())};function yf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d){var h=a[b],l=a[b+1];e+=g*h-f*l;f=h;g=l}return e/2}function zf(a,b,c,d){var e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];e+=yf(a,b,h,d);b=h}return e};function Af(a,b,c,d,e,f,g){var h=a[b],l=a[b+1],m=a[c]-h,n=a[c+1]-l;if(m||n)if(f=((e-h)*m+(f-l)*n)/(m*m+n*n),1<f)b=c;else if(0<f){for(e=0;e<d;++e)g[e]=Ha(a[b+e],a[c+e],f);g.length=d;return}for(e=0;e<d;++e)g[e]=a[b+e];g.length=d}function Bf(a,b,c,d,e){var f=a[b],g=a[b+1];for(b+=d;b<c;b+=d){var h=a[b],l=a[b+1];f=Ea(f,g,h,l);f>e&&(e=f);f=h;g=l}return e}function Cf(a,b,c,d,e){var f;var g=0;for(f=c.length;g<f;++g){var h=c[g];e=Bf(a,b,h,d,e);b=h}return e}
function Df(a,b,c,d,e,f,g,h,l,m,n){if(b==c)return m;if(!e){var p=Ea(g,h,a[b],a[b+1]);if(p<m){for(n=0;n<d;++n)l[n]=a[b+n];l.length=d;return p}return m}for(var q=n?n:[NaN,NaN],t=b+d;t<c;)if(Af(a,t-d,t,d,g,h,q),p=Ea(g,h,q[0],q[1]),p<m){m=p;for(n=0;n<d;++n)l[n]=q[n];l.length=d;t+=d}else t+=d*Math.max((Math.sqrt(p)-Math.sqrt(m))/e|0,1);if(f&&(Af(a,c-d,b,d,g,h,q),p=Ea(g,h,q[0],q[1]),p<m)){m=p;for(n=0;n<d;++n)l[n]=q[n];l.length=d}return m}
function Ef(a,b,c,d,e,f,g,h,l,m,n){n=n?n:[NaN,NaN];var p;var q=0;for(p=c.length;q<p;++q){var t=c[q];m=Df(a,b,t,d,e,f,g,h,l,m,n);b=t}return m};function Ff(a,b){var c=0,d;var e=0;for(d=b.length;e<d;++e)a[c++]=b[e];return c}function Gf(a,b,c,d){var e;var f=0;for(e=c.length;f<e;++f){var g=c[f],h;for(h=0;h<d;++h)a[b++]=g[h]}return b}function Hf(a,b,c,d,e){e=e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h)b=Gf(a,b,c[h],d),e[f++]=b;e.length=f;return e};function If(a,b,c,d,e){e=void 0!==e?e:[];for(var f=0;b<c;b+=d)e[f++]=a.slice(b,b+d);e.length=f;return e}function Jf(a,b,c,d,e){e=void 0!==e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e[f++]=If(a,b,l,d,e[f]);b=l}e.length=f;return e}function Kf(a,b,c,d,e){e=void 0!==e?e:[];var f=0,g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e[f++]=Jf(a,b,l,d,e[f]);b=l[l.length-1]}e.length=f;return e};function Lf(a,b,c,d,e,f,g){var h=(c-b)/d;if(3>h){for(;b<c;b+=d)f[g++]=a[b],f[g++]=a[b+1];return g}var l=Array(h);l[0]=1;l[h-1]=1;c=[b,c-d];for(var m=0,n;0<c.length;){var p=c.pop(),q=c.pop(),t=0,u=a[q],x=a[q+1],B=a[p],z=a[p+1];for(n=q+d;n<p;n+=d){var G=Da(a[n],a[n+1],u,x,B,z);G>t&&(m=n,t=G)}t>e&&(l[(m-b)/d]=1,q+d<m&&c.push(q,m),m+d<p&&c.push(m,p))}for(n=0;n<h;++n)l[n]&&(f[g++]=a[b+n*d],f[g++]=a[b+n*d+1]);return g}
function Mf(a,b,c,d,e,f,g,h){var l;var m=0;for(l=c.length;m<l;++m){var n=c[m];a:{var p=a,q=n,t=d,u=e,x=f,B=g;if(b!=q){var z=u*Math.round(p[b]/u),G=u*Math.round(p[b+1]/u);b+=t;x[B++]=z;x[B++]=G;do{var E=u*Math.round(p[b]/u);g=u*Math.round(p[b+1]/u);b+=t;if(b==q){x[B++]=E;x[B++]=g;g=B;break a}}while(E==z&&g==G);for(;b<q;){var ia=u*Math.round(p[b]/u);var T=u*Math.round(p[b+1]/u);b+=t;if(ia!=E||T!=g){var R=E-z,U=g-G,ta=ia-z,A=T-G;R*A==U*ta&&(0>R&&ta<R||R==ta||0<R&&ta>R)&&(0>U&&A<U||U==A||0<U&&A>U)||(x[B++]=
E,x[B++]=g,z=E,G=g);E=ia;g=T}}x[B++]=E;x[B++]=g}g=B}h.push(g);b=n}return g};function Of(a,b){uf.call(this);this.c=this.j=-1;this.na(a,b)}v(Of,uf);k=Of.prototype;k.clone=function(){var a=new Of(null);Pf(a,this.ja,this.A.slice());return a};k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;this.c!=this.f&&(this.j=Math.sqrt(Bf(this.A,0,this.A.length,this.a,0)),this.c=this.f);return Df(this.A,0,this.A.length,this.a,this.j,!0,a,b,c,d)};k.Fn=function(){return yf(this.A,0,this.A.length,this.a)};k.V=function(){return If(this.A,0,this.A.length,this.a)};
k.od=function(a){var b=[];b.length=Lf(this.A,0,this.A.length,this.a,a,b,0);a=new Of(null);Pf(a,"XY",b);return a};k.T=function(){return"LinearRing"};k.Ya=function(){};k.na=function(a,b){a?(xf(this,b,a,1),this.A||(this.A=[]),this.A.length=Gf(this.A,0,a,this.a),this.s()):Pf(this,"XY",null)};function Pf(a,b,c){wf(a,b,c);a.s()};function C(a,b){uf.call(this);this.na(a,b)}v(C,uf);k=C.prototype;k.clone=function(){var a=new C(null);a.aa(this.ja,this.A.slice());return a};k.Jb=function(a,b,c,d){var e=this.A;a=Ea(a,b,e[0],e[1]);if(a<d){d=this.a;for(b=0;b<d;++b)c[b]=e[b];c.length=d;return a}return d};k.V=function(){return this.A?this.A.slice():[]};k.De=function(a){return Xa(this.A,a)};k.T=function(){return"Point"};k.Ya=function(a){return Sa(a,this.A[0],this.A[1])};
k.na=function(a,b){a?(xf(this,b,a,0),this.A||(this.A=[]),this.A.length=Ff(this.A,a),this.s()):this.aa("XY",null)};k.aa=function(a,b){wf(this,a,b);this.s()};function Qf(a,b,c,d,e){return!cb(e,function(e){return!Rf(a,b,c,d,e[0],e[1])})}function Rf(a,b,c,d,e,f){for(var g=0,h=a[c-d],l=a[c-d+1];b<c;b+=d){var m=a[b],n=a[b+1];l<=f?n>f&&0<(m-h)*(f-l)-(e-h)*(n-l)&&g++:n<=f&&0>(m-h)*(f-l)-(e-h)*(n-l)&&g--;h=m;l=n}return!!g}function Sf(a,b,c,d,e,f){if(!c.length||!Rf(a,b,c[0],d,e,f))return!1;var g;b=1;for(g=c.length;b<g;++b)if(Rf(a,c[b-1],c[b],d,e,f))return!1;return!0};function Tf(a,b,c,d,e,f,g){var h,l=e[f+1],m=[],n=c[0];var p=a[n-d];var q=a[n-d+1];for(h=b;h<n;h+=d){var t=a[h];var u=a[h+1];if(l<=q&&u<=l||q<=l&&l<=u)p=(l-q)/(u-q)*(t-p)+p,m.push(p);p=t;q=u}n=NaN;q=-Infinity;m.sort(fa);p=m[0];h=1;for(u=m.length;h<u;++h){t=m[h];var x=Math.abs(t-p);x>q&&(p=(p+t)/2,Sf(a,b,c,d,p,l)&&(n=p,q=x));p=t}isNaN(n)&&(n=e[f]);return g?(g.push(n,l),g):[n,l]};function Uf(a,b,c,d,e,f){for(var g=[a[b],a[b+1]],h=[],l;b+d<c;b+=d){h[0]=a[b+d];h[1]=a[b+d+1];if(l=e.call(f,g,h))return l;g[0]=h[0];g[1]=h[1]}return!1};function Vf(a,b,c,d,e){var f=$a(Ma(),a,b,c,d);return ob(e,f)?Ta(e,f)||f[0]>=e[0]&&f[2]<=e[2]||f[1]>=e[1]&&f[3]<=e[3]?!0:Uf(a,b,c,d,function(a,b){var c=!1,d=Ua(e,a),f=Ua(e,b);if(1===d||1===f)c=!0;else{var g=e[0],h=e[1],t=e[2],u=e[3],x=b[0];b=b[1];a=(b-a[1])/(x-a[0]);f&2&&!(d&2)&&(c=x-(b-u)/a,c=c>=g&&c<=t);c||!(f&4)||d&4||(c=b-(x-t)*a,c=c>=h&&c<=u);c||!(f&8)||d&8||(c=x-(b-h)/a,c=c>=g&&c<=t);c||!(f&16)||d&16||(c=b-(x-g)*a,c=c>=h&&c<=u)}return c}):!1}
function Wf(a,b,c,d,e){var f=c[0];if(!(Vf(a,b,f,d,e)||Rf(a,b,f,d,e[0],e[1])||Rf(a,b,f,d,e[0],e[3])||Rf(a,b,f,d,e[2],e[1])||Rf(a,b,f,d,e[2],e[3])))return!1;if(1===c.length)return!0;b=1;for(f=c.length;b<f;++b)if(Qf(a,c[b-1],c[b],d,e))return!1;return!0};function Xf(a,b,c,d){for(var e=0,f=a[c-d],g=a[c-d+1];b<c;b+=d){var h=a[b],l=a[b+1];e+=(h-f)*(l+g);f=h;g=l}return 0<e}function Yf(a,b,c,d){var e=0;d=void 0!==d?d:!1;var f;var g=0;for(f=b.length;g<f;++g){var h=b[g];e=Xf(a,e,h,c);if(!g){if(d&&e||!d&&!e)return!1}else if(d&&!e||!d&&e)return!1;e=h}return!0}
function Zf(a,b,c,d,e){e=void 0!==e?e:!1;var f;var g=0;for(f=c.length;g<f;++g){var h=c[g],l=Xf(a,b,h,d);if(g?e&&!l||!e&&l:e&&l||!e&&!l){l=a;for(var m=h,n=d;b<m-n;){var p;for(p=0;p<n;++p){var q=l[b+p];l[b+p]=l[m-n+p];l[m-n+p]=q}b+=n;m-=n}}b=h}return b}function $f(a,b,c,d){var e=0,f;var g=0;for(f=b.length;g<f;++g)e=Zf(a,e,b[g],c,d);return e};function D(a,b){uf.call(this);this.c=[];this.u=-1;this.D=null;this.I=this.B=this.C=-1;this.j=null;this.na(a,b)}v(D,uf);k=D.prototype;k.zk=function(a){this.A?ka(this.A,a.ba()):this.A=a.ba().slice();this.c.push(this.A.length);this.s()};k.clone=function(){var a=new D(null);a.aa(this.ja,this.A.slice(),this.c.slice());return a};
k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;this.B!=this.f&&(this.C=Math.sqrt(Cf(this.A,0,this.c,this.a,0)),this.B=this.f);return Ef(this.A,0,this.c,this.a,this.C,!0,a,b,c,d)};k.Pc=function(a,b){return Sf(this.Tb(),0,this.c,this.a,a,b)};k.In=function(){return zf(this.Tb(),0,this.c,this.a)};k.V=function(a){if(void 0!==a){var b=this.Tb().slice();Zf(b,0,this.c,this.a,a)}else b=this.A;return Jf(b,0,this.c,this.a)};k.sb=function(){return this.c};
function ag(a){if(a.u!=a.f){var b=lb(a.G());a.D=Tf(a.Tb(),0,a.c,a.a,b,0);a.u=a.f}return a.D}k.el=function(){return new C(ag(this))};k.kl=function(){return this.c.length};k.Kh=function(a){if(0>a||this.c.length<=a)return null;var b=new Of(null);Pf(b,this.ja,this.A.slice(a?this.c[a-1]:0,this.c[a]));return b};k.Zd=function(){var a=this.ja,b=this.A,c=this.c,d=[],e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g],l=new Of(null);Pf(l,a,b.slice(e,h));d.push(l);e=h}return d};
k.Tb=function(){if(this.I!=this.f){var a=this.A;Yf(a,this.c,this.a)?this.j=a:(this.j=a.slice(),this.j.length=Zf(this.j,0,this.c,this.a));this.I=this.f}return this.j};k.od=function(a){var b=[],c=[];b.length=Mf(this.A,0,this.c,this.a,Math.sqrt(a),b,0,c);a=new D(null);a.aa("XY",b,c);return a};k.T=function(){return"Polygon"};k.Ya=function(a){return Wf(this.Tb(),0,this.c,this.a,a)};
k.na=function(a,b){a?(xf(this,b,a,2),this.A||(this.A=[]),a=Hf(this.A,0,a,this.a,this.c),this.A.length=a.length?a[a.length-1]:0,this.s()):this.aa("XY",null,this.c)};k.aa=function(a,b,c){wf(this,a,b);this.c=c;this.s()};function bg(a,b,c,d){var e=d?d:32;d=[];var f;for(f=0;f<e;++f)ka(d,a.offset(b,c,2*Math.PI*f/e));d.push(d[0],d[1]);a=new D(null);a.aa("XY",d,[d.length]);return a}function cg(a){var b=a[0],c=a[1],d=a[2];a=a[3];b=[b,c,b,a,d,a,d,c,b,c];c=new D(null);c.aa("XY",b,[b.length]);return c}
function dg(a,b,c){var d=b?b:32,e=a.ma();b=a.ja;var f=new D(null,b);d=e*(d+1);e=Array(d);for(var g=0;g<d;g++)e[g]=0;f.aa(b,e,[e.length]);eg(f,a.xa(),a.vd(),c);return f}function eg(a,b,c,d){var e=a.ba(),f=a.ja,g=a.ma(),h=a.sb(),l=e.length/g-1;d=d?d:0;for(var m,n,p=0;p<=l;++p)n=p*g,m=d+2*Ga(p,l)*Math.PI/l,e[n]=b[0]+c*Math.cos(m),e[n+1]=b[1]+c*Math.sin(m);a.aa(f,e,h)};function F(a){Vc.call(this);a=rb({},a);this.l=[0,0];this.c=[];this.Ff=this.Ff.bind(this);this.v=bc(a.projection);fg(this,a)}v(F,Vc);
function fg(a,b){var c={};c.center=void 0!==b.center?b.center:null;var d=void 0!==b.minZoom?b.minZoom:0;var e=void 0!==b.maxZoom?b.maxZoom:28;var f=void 0!==b.zoomFactor?b.zoomFactor:2;if(void 0!==b.resolutions){e=b.resolutions;var g=e[0];var h=e[e.length-1];e=Ue(e)}else{g=bc(b.projection);h=g.G();var l=(h?Math.max(jb(h),kb(h)):360*Bb.degrees/g.Nc())/256/Math.pow(2,0),m=l/Math.pow(2,28);g=b.maxResolution;void 0!==g?d=0:g=l/Math.pow(f,d);h=b.minResolution;void 0===h&&(h=void 0!==b.maxZoom?void 0!==
b.maxResolution?g/Math.pow(f,e):l/Math.pow(f,e):m);e=d+Math.floor(Math.log(g/h)/Math.log(f));h=g/Math.pow(f,e-d);e=Ve(f,g,e-d)}a.a=g;a.i=h;a.B=f;a.j=b.resolutions;a.o=d;(void 0!==b.enableRotation?b.enableRotation:1)?(d=b.constrainRotation,d=void 0===d||!0===d?Ze():!1===d?Xe:"number"===typeof d?Ye(d):Xe):d=We;a.g={center:void 0!==b.extent?Dc(b.extent):Ec,resolution:e,rotation:d};void 0!==b.resolution?c.resolution=b.resolution:void 0!==b.zoom&&(c.resolution=a.constrainResolution(a.a,b.zoom-a.o));c.rotation=
void 0!==b.rotation?b.rotation:0;a.H(c);a.D=b}function gg(a,b){var c=rb({},a.D);void 0!==c.resolution?c.resolution=a.Pa():c.zoom=a.Qh();c.center=a.xa();c.rotation=a.Qa();return rb({},c,b)}k=F.prototype;
k.animate=function(a){var b=Date.now(),c=this.xa().slice(),d=this.Pa(),e=this.Qa(),f=arguments.length;if(1<f&&"function"===typeof arguments[f-1]){var g=arguments[f-1];--f}for(var h=[],l=0;l<f;++l){var m=arguments[l],n={start:b,complete:!1,anchor:m.anchor,duration:void 0!==m.duration?m.duration:1E3,easing:m.easing||ud};m.center&&(n.le=c,n.pe=m.center,c=n.pe);void 0!==m.zoom?(n.ne=d,n.ad=this.constrainResolution(this.a,m.zoom-this.o,0),d=n.ad):m.resolution&&(n.ne=d,n.ad=m.resolution,d=n.ad);void 0!==
m.rotation&&(n.Df=e,n.qe=e+(Ga(m.rotation-e+Math.PI,2*Math.PI)-Math.PI),e=n.qe);n.callback=g;n.le&&n.pe&&!gf(n.le,n.pe)||n.ne!==n.ad||n.Df!==n.qe?b+=n.duration:n.complete=!0;h.push(n)}this.c.push(h);hg(this,0,1);this.Ff()};k.Kc=function(){return 0<ig(this)[0]};k.cl=function(){return 0<ig(this)[1]};k.hd=function(){hg(this,0,-ig(this)[0]);for(var a=0,b=this.c.length;a<b;++a){var c=this.c[a];c[0].callback&&c[0].callback(!1)}this.c.length=0};
k.Ff=function(){void 0!==this.u&&(cancelAnimationFrame(this.u),this.u=void 0);if(this.Kc()){for(var a=Date.now(),b=!1,c=this.c.length-1;0<=c;--c){for(var d=this.c[c],e=!0,f=0,g=d.length;f<g;++f){var h=d[f];if(!h.complete){b=a-h.start;b=0<h.duration?b/h.duration:1;1<=b?(h.complete=!0,b=1):e=!1;b=h.easing(b);if(h.le){var l=h.le[0],m=h.le[1];this.set("center",[l+b*(h.pe[0]-l),m+b*(h.pe[1]-m)])}h.ne&&h.ad&&(l=1===b?h.ad:h.ne+b*(h.ad-h.ne),h.anchor&&this.set("center",jg(this,l,h.anchor)),this.set("resolution",
l));void 0!==h.Df&&void 0!==h.qe&&(b=1===b?Ga(h.qe+Math.PI,2*Math.PI)-Math.PI:h.Df+b*(h.qe-h.Df),h.anchor&&this.set("center",kg(this,b,h.anchor)),this.set("rotation",b));b=!0;if(!h.complete)break}}e&&(this.c[c]=null,hg(this,0,-1),(d=d[0].callback)&&d(!0))}this.c=this.c.filter(Boolean);b&&void 0===this.u&&(this.u=requestAnimationFrame(this.Ff))}};function kg(a,b,c){var d=a.xa();if(void 0!==d){var e=[d[0]-c[0],d[1]-c[1]];hf(e,b-a.Qa());bf(e,c)}return e}
function jg(a,b,c){var d,e=a.xa();a=a.Pa();void 0!==e&&void 0!==a&&(d=[c[0]-b*(c[0]-e[0])/a,c[1]-b*(c[1]-e[1])/a]);return d}function lg(a){var b=[100,100];a='.ol-viewport[data-view="'+w(a)+'"]';if(a=document.querySelector(a))a=getComputedStyle(a),b[0]=parseInt(a.width,10),b[1]=parseInt(a.height,10);return b}k.Gc=function(a){return this.g.center(a)};k.constrainResolution=function(a,b,c){return this.g.resolution(a,b||0,c||0)};k.constrainRotation=function(a,b){return this.g.rotation(a,b||0)};k.xa=function(){return this.get("center")};
function ig(a,b){return void 0!==b?(b[0]=a.l[0],b[1]=a.l[1],b):a.l.slice()}k.gd=function(a){a=a||lg(this);var b=this.xa();va(b,1);var c=this.Pa();va(void 0!==c,2);var d=this.Qa();va(void 0!==d,3);return mb(b,c,d,a)};k.an=function(){return this.a};k.cn=function(){return this.i};k.bn=function(){return this.Ne(this.i)};k.rq=function(a){fg(this,gg(this,{maxZoom:a}))};k.dn=function(){return this.Ne(this.a)};k.sq=function(a){fg(this,gg(this,{minZoom:a}))};k.en=function(){return this.v};k.Pa=function(){return this.get("resolution")};
k.fn=function(){return this.j};k.Ke=function(a,b){b=b||lg(this);return Math.max(jb(a)/b[0],kb(a)/b[1])};function mg(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return b/Math.pow(2,a*c)}}k.Qa=function(){return this.get("rotation")};function ng(a){var b=a.a,c=Math.log(b/a.i)/Math.log(2);return function(a){return Math.log(b/a)/Math.log(2)/c}}k.getState=function(){var a=this.xa(),b=this.v,c=this.Pa(),d=this.Qa();return{center:a.slice(),projection:void 0!==b?b:null,resolution:c,rotation:d}};
k.Qh=function(){var a,b=this.Pa();void 0!==b&&(a=this.Ne(b));return a};k.Ne=function(a){if(a>=this.i&&a<=this.a){var b=this.o||0;if(this.j){var c=ja(this.j,a,1);b+=c;if(c==this.j.length-1)return b;var d=this.j[c];c=d/this.j[c+1]}else d=this.a,c=this.B;b+=Math.log(d/a)/Math.log(c)}return b};k.Oh=function(a){return this.constrainResolution(this.a,a-this.o,0)};
k.Xf=function(a,b){b=b||{};var c=b.size;c||(c=lg(this));if(a instanceof uf)if("Circle"===a.T()){a=a.G();var d=cg(a);d.rotate(this.Qa(),lb(a))}else d=a;else va(Array.isArray(a),24),va(!ib(a),25),d=cg(a);var e=b.padding?b.padding:[0,0,0,0],f=void 0!==b.constrainResolution?b.constrainResolution:!0,g=void 0!==b.nearest?b.nearest:!1,h;void 0!==b.minResolution?h=b.minResolution:void 0!==b.maxZoom?h=this.constrainResolution(this.a,b.maxZoom-this.o,0):h=0;var l=d.ba(),m=this.Qa();a=Math.cos(-m);m=Math.sin(-m);
var n=Infinity,p=Infinity,q=-Infinity,t=-Infinity;d=d.ma();for(var u=0,x=l.length;u<x;u+=d){var B=l[u]*a-l[u+1]*m,z=l[u]*m+l[u+1]*a;n=Math.min(n,B);p=Math.min(p,z);q=Math.max(q,B);t=Math.max(t,z)}c=this.Ke([n,p,q,t],[c[0]-e[1]-e[3],c[1]-e[0]-e[2]]);c=isNaN(c)?h:Math.max(c,h);f&&(h=this.constrainResolution(c,0,0),!g&&h<c&&(h=this.constrainResolution(h,-1,0)),c=h);m=-m;h=(n+q)/2+(e[1]-e[3])/2*c;e=(p+t)/2+(e[0]-e[2])/2*c;a=[h*a-e*m,e*a+h*m];e=b.callback?b.callback:ra;void 0!==b.duration?this.animate({resolution:c,
center:a,duration:b.duration,easing:b.easing},e):(this.Yc(c),this.rb(a),setTimeout(e.bind(void 0,!0),0))};k.Fk=function(a,b,c){var d=this.Qa(),e=Math.cos(-d);d=Math.sin(-d);var f=a[0]*e-a[1]*d;a=a[1]*e+a[0]*d;var g=this.Pa();f+=(b[0]/2-c[0])*g;a+=(c[1]-b[1]/2)*g;d=-d;this.rb([f*e-a*d,a*e+f*d])};function og(a){return!!a.xa()&&void 0!==a.Pa()}k.rotate=function(a,b){void 0!==b&&(b=kg(this,a,b),this.rb(b));this.Ze(a)};k.rb=function(a){this.set("center",a);this.Kc()&&this.hd()};
function hg(a,b,c){a.l[b]+=c;a.s()}k.Yc=function(a){this.set("resolution",a);this.Kc()&&this.hd()};k.Ze=function(a){this.set("rotation",a);this.Kc()&&this.hd()};k.zq=function(a){this.Yc(this.Oh(a))};function pg(a,b,c){this.i=a;this.c=b;this.g=c;this.b=[];this.a=this.f=0}function qg(a){a.b.length=0;a.f=0;a.a=0}function rg(a){if(6>a.b.length)return!1;var b=Date.now()-a.g,c=a.b.length-3;if(a.b[c+2]<b)return!1;for(var d=c-3;0<d&&a.b[d+2]>b;)d-=3;b=a.b[c+2]-a.b[d+2];if(b<1E3/60)return!1;var e=a.b[c]-a.b[d];c=a.b[c+1]-a.b[d+1];a.f=Math.atan2(c,e);a.a=Math.sqrt(e*e+c*c)/b;return a.a>a.c};function sg(a){Vc.call(this);this.v=null;this.Ia(!0);this.handleEvent=a.handleEvent}v(sg,Vc);sg.prototype.c=function(){return this.get("active")};sg.prototype.i=function(){return this.v};sg.prototype.Ia=function(a){this.set("active",a)};sg.prototype.setMap=function(a){this.v=a};function tg(a,b,c,d){if(void 0!==b){var e=a.Qa(),f=a.xa();void 0!==e&&f&&0<d?a.animate({rotation:b,anchor:c,duration:d,easing:td}):a.rotate(b,c)}}
function ug(a,b,c,d){var e=a.Pa();b=a.constrainResolution(e,b,0);if(c&&void 0!==b&&b!==e){var f=a.xa();c=jg(a,b,c);c=a.Gc(c);c=[(b*f[0]-e*c[0])/(b-e),(b*f[1]-e*c[1])/(b-e)]}vg(a,b,c,d)}function vg(a,b,c,d){if(b){var e=a.Pa(),f=a.xa();void 0!==e&&f&&b!==e&&d?a.animate({resolution:b,anchor:c,duration:d,easing:td}):(c&&(c=jg(a,b,c),a.rb(c)),a.Yc(b))}};function wg(a){a=a?a:{};this.a=a.delta?a.delta:1;sg.call(this,{handleEvent:xg});this.g=void 0!==a.duration?a.duration:250}v(wg,sg);function xg(a){var b=!1,c=a.originalEvent;if("dblclick"==a.type){b=a.coordinate;c=c.shiftKey?-this.a:this.a;var d=a.map.$();ug(d,c,b,this.g);a.preventDefault();b=!0}return!b};function yg(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey}function zg(a){a=a.originalEvent;return a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}function Ag(a){a=a.originalEvent;return!a.button&&!(Sd&&Td&&a.ctrlKey)}function Bg(a){return"pointermove"==a.type}function Cg(a){return"singleclick"==a.type}function Dg(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&!a.shiftKey}
function Eg(a){a=a.originalEvent;return!a.altKey&&!(a.metaKey||a.ctrlKey)&&a.shiftKey}function Fg(a){a=a.originalEvent.target.tagName;return"INPUT"!==a&&"SELECT"!==a&&"TEXTAREA"!==a}function Gg(a){va(a.b,56);return"mouse"==a.b.pointerType}function Hg(a){a=a.b;return a.isPrimary&&0===a.button};function Jg(a){a=a?a:{};sg.call(this,{handleEvent:a.handleEvent?a.handleEvent:Kg});this.Hf=a.handleDownEvent?a.handleDownEvent:qf;this.Qf=a.handleDragEvent?a.handleDragEvent:ra;this.Ck=a.handleMoveEvent?a.handleMoveEvent:ra;this.Dk=a.handleUpEvent?a.handleUpEvent:qf;this.D=!1;this.ta={};this.l=[]}v(Jg,sg);function Lg(a){for(var b=a.length,c=0,d=0,e=0;e<b;e++)c+=a[e].clientX,d+=a[e].clientY;return[c/b,d/b]}
function Kg(a){if(!(a instanceof ie))return!0;var b=!1,c=a.type;if("pointerdown"===c||"pointerdrag"===c||"pointerup"===c)c=a.b,"pointerup"==a.type?delete this.ta[c.pointerId]:"pointerdown"==a.type?this.ta[c.pointerId]=c:c.pointerId in this.ta&&(this.ta[c.pointerId]=c),this.l=tb(this.ta);this.D?"pointerdrag"==a.type?this.Qf(a):"pointerup"==a.type&&(this.D=this.Dk(a)&&0<this.l.length):"pointerdown"==a.type?(this.D=a=this.Hf(a),b=this.$c(a)):"pointermove"==a.type&&this.Ck(a);return!b}
Jg.prototype.$c=function(a){return a};function Mg(a){Jg.call(this,{handleDownEvent:Ng,handleDragEvent:Og,handleUpEvent:Pg});a=a?a:{};this.a=a.kinetic;this.g=null;this.u=a.condition?a.condition:Dg;this.j=!1}v(Mg,Jg);function Og(a){var b=this.l,c=Lg(b);if(b.length==this.o){if(this.a&&this.a.b.push(c[0],c[1],Date.now()),this.g){var d=this.g[0]-c[0],e=c[1]-this.g[1];a=a.map.$();var f=a.getState();d=[d,e];jf(d,f.resolution);hf(d,f.rotation);bf(d,f.center);d=a.Gc(d);a.rb(d)}}else this.a&&qg(this.a);this.g=c;this.o=b.length}
function Pg(a){var b=a.map;a=b.$();if(this.l.length)return this.a&&qg(this.a),this.g=null,!0;if(!this.j&&this.a&&rg(this.a)){var c=this.a;c=(c.c-c.a)/c.i;var d=this.a.f,e=a.xa();e=b.Ka(e);b=b.Xa([e[0]-c*Math.cos(d),e[1]-c*Math.sin(d)]);a.animate({center:a.Gc(b),duration:500,easing:td})}hg(a,1,-1);return!1}
function Ng(a){if(0<this.l.length&&this.u(a)){var b=a.map.$();this.g=null;this.D||hg(b,1,1);ig(b)[0]&&b.rb(a.frameState.viewState.center);this.a&&qg(this.a);this.j=1<this.l.length;return!0}return!1}Mg.prototype.$c=qf;function Qg(a){a=a?a:{};Jg.call(this,{handleDownEvent:Rg,handleDragEvent:Sg,handleUpEvent:Tg});this.g=a.condition?a.condition:zg;this.a=void 0;this.j=void 0!==a.duration?a.duration:250}v(Qg,Jg);function Sg(a){if(Gg(a)){var b=a.map,c=b.$();if(c.g.rotation!==We){b=b.Mb();a=a.pixel;a=Math.atan2(b[1]/2-a[1],a[0]-b[0]/2);if(void 0!==this.a){b=a-this.a;var d=c.Qa();tg(c,d-b)}this.a=a}}}
function Tg(a){if(!Gg(a))return!0;a=a.map.$();hg(a,1,-1);var b=a.Qa(),c=this.j;b=a.constrainRotation(b,0);tg(a,b,void 0,c);return!1}function Rg(a){return Gg(a)&&Ag(a)&&this.g(a)?(hg(a.map.$(),1,1),this.a=void 0,!0):!1}Qg.prototype.$c=qf;function Ug(a){this.Ic=null;this.a=document.createElement("div");this.a.style.position="absolute";this.a.className="ol-box "+a;this.f=this.c=this.b=null}v(Ug,Oc);Ug.prototype.ka=function(){this.setMap(null)};function Vg(a){var b=a.c,c=a.f;a=a.a.style;a.left=Math.min(b[0],c[0])+"px";a.top=Math.min(b[1],c[1])+"px";a.width=Math.abs(c[0]-b[0])+"px";a.height=Math.abs(c[1]-b[1])+"px"}
Ug.prototype.setMap=function(a){if(this.b){this.b.B.removeChild(this.a);var b=this.a.style;b.left=b.top=b.width=b.height="inherit"}(this.b=a)&&this.b.B.appendChild(this.a)};function Wg(a){var b=a.c,c=a.f;b=[b,[b[0],c[1]],c,[c[0],b[1]]].map(a.b.Xa,a.b);b[4]=b[0].slice();a.Ic?a.Ic.na([b]):a.Ic=new D([b])}Ug.prototype.W=function(){return this.Ic};function Xg(a){Jg.call(this,{handleDownEvent:Yg,handleDragEvent:Zg,handleUpEvent:$g});a=a?a:{};this.a=new Ug(a.className||"ol-dragbox");this.u=void 0!==a.minArea?a.minArea:64;this.g=null;this.B=a.condition?a.condition:pf;this.o=a.boxEndCondition?a.boxEndCondition:ah}v(Xg,Jg);function ah(a,b,c){a=c[0]-b[0];b=c[1]-b[1];return a*a+b*b>=this.u}function Zg(a){if(Gg(a)){var b=this.a,c=a.pixel;b.c=this.g;b.f=c;Wg(b);Vg(b);this.b(new bh(ch,a.coordinate,a))}}Xg.prototype.W=function(){return this.a.W()};
Xg.prototype.j=ra;function $g(a){if(!Gg(a))return!0;this.a.setMap(null);this.o(a,this.g,a.pixel)&&(this.j(a),this.b(new bh(dh,a.coordinate,a)));return!1}function Yg(a){if(Gg(a)&&Ag(a)&&this.B(a)){this.g=a.pixel;this.a.setMap(a.map);var b=this.a,c=this.g;b.c=this.g;b.f=c;Wg(b);Vg(b);this.b(new bh(eh,a.coordinate,a));return!0}return!1}var eh="boxstart",ch="boxdrag",dh="boxend";function bh(a,b,c){Qc.call(this,a);this.coordinate=b;this.mapBrowserEvent=c}v(bh,Qc);function fh(a){a=a?a:{};var b=a.condition?a.condition:Eg;this.C=void 0!==a.duration?a.duration:200;this.I=void 0!==a.out?a.out:!1;Xg.call(this,{condition:b,className:a.className||"ol-dragzoom"})}v(fh,Xg);
fh.prototype.j=function(){var a=this.v,b=a.$(),c=a.Mb(),d=this.W().G();if(this.I){var e=b.gd(c);d=[a.Ka(db(d)),a.Ka(fb(d))];a=Wa(void 0);var f;var g=0;for(f=d.length;g<f;++g)Na(a,d[g]);d=b.Ke(a,c);pb(e,1/d);d=e}c=b.constrainResolution(b.Ke(d,c));e=lb(d);e=b.Gc(e);b.animate({resolution:c,center:e,duration:this.C,easing:td})};function gh(a){sg.call(this,{handleEvent:hh});a=a||{};this.a=function(a){return Dg(a)&&Fg(a)};this.g=a.condition?a.condition:this.a;this.j=void 0!==a.duration?a.duration:100;this.l=void 0!==a.pixelDelta?a.pixelDelta:128}v(gh,sg);
function hh(a){var b=!1;if("keydown"==a.type){var c=a.originalEvent.keyCode;if(this.g(a)&&(40==c||37==c||39==c||38==c)){b=a.map.$();var d=b.Pa()*this.l,e=0,f=0;40==c?f=-d:37==c?e=-d:39==c?e=d:f=d;d=[e,f];hf(d,b.Qa());c=this.j;if(e=b.xa())d=b.Gc([e[0]+d[0],e[1]+d[1]]),c?b.animate({duration:c,easing:vd,center:d}):b.rb(d);a.preventDefault();b=!0}}return!b};function ih(a){sg.call(this,{handleEvent:jh});a=a?a:{};this.g=a.condition?a.condition:Fg;this.a=a.delta?a.delta:1;this.j=void 0!==a.duration?a.duration:100}v(ih,sg);function jh(a){var b=!1;if("keydown"==a.type||"keypress"==a.type){var c=a.originalEvent.charCode;!this.g(a)||43!=c&&45!=c||(b=43==c?this.a:-this.a,c=a.map.$(),ug(c,b,void 0,this.j),a.preventDefault(),b=!0)}return!b};function kh(a){sg.call(this,{handleEvent:lh});a=a||{};this.j=0;this.D=void 0!==a.duration?a.duration:250;this.ta=void 0!==a.timeout?a.timeout:80;this.B=void 0!==a.useAnchor?a.useAnchor:!0;this.S=a.constrainResolution||!1;this.a=null;this.o=this.l=this.u=this.g=void 0}v(kh,sg);
function lh(a){var b=a.type;if("wheel"!==b&&"mousewheel"!==b)return!0;a.preventDefault();b=a.map;var c=a.originalEvent;this.B&&(this.a=a.coordinate);if("wheel"==a.type){var d=c.deltaY;Qd&&c.deltaMode===WheelEvent.DOM_DELTA_PIXEL&&(d/=Ud);c.deltaMode===WheelEvent.DOM_DELTA_LINE&&(d*=40)}else"mousewheel"==a.type&&(d=-c.wheelDeltaY,Rd&&(d/=3));if(0===d)return!1;a=Date.now();void 0===this.g&&(this.g=a);if(!this.l||400<a-this.g)this.l=4>Math.abs(d)?mh:nh;if(this.l===mh){b=b.$();this.o?clearTimeout(this.o):
hg(b,1,1);this.o=setTimeout(this.C.bind(this),400);c=b.Pa()*Math.pow(2,d/300);var e=b.i,f=b.a,g=0;c<e?(c=Math.max(c,e/1.5),g=1):c>f&&(c=Math.min(c,1.5*f),g=-1);if(this.a){var h=jg(b,c,this.a);b.rb(b.Gc(h))}b.Yc(c);!g&&this.S&&b.animate({resolution:b.constrainResolution(c,0<d?-1:1),easing:td,anchor:this.a,duration:this.D});0<g?b.animate({resolution:e,easing:td,anchor:this.a,duration:500}):0>g&&b.animate({resolution:f,easing:td,anchor:this.a,duration:500});this.g=a;return!1}this.j+=d;d=Math.max(this.ta-
(a-this.g),0);clearTimeout(this.u);this.u=setTimeout(this.I.bind(this,b),d);return!1}kh.prototype.C=function(){this.o=void 0;hg(this.v.$(),1,-1)};kh.prototype.I=function(a){a=a.$();a.Kc()&&a.hd();ug(a,-Aa(this.j,-1,1),this.a,this.D);this.l=void 0;this.j=0;this.a=null;this.u=this.g=void 0};kh.prototype.U=function(a){this.B=a;a||(this.a=null)};var mh="trackpad",nh="wheel";function oh(a){Jg.call(this,{handleDownEvent:ph,handleDragEvent:qh,handleUpEvent:rh});a=a||{};this.g=null;this.j=void 0;this.a=!1;this.o=0;this.B=void 0!==a.threshold?a.threshold:.3;this.u=void 0!==a.duration?a.duration:250}v(oh,Jg);
function qh(a){var b=0,c=this.l[0],d=this.l[1];c=Math.atan2(d.clientY-c.clientY,d.clientX-c.clientX);void 0!==this.j&&(b=c-this.j,this.o+=b,!this.a&&Math.abs(this.o)>this.B&&(this.a=!0));this.j=c;a=a.map;c=a.$();if(c.g.rotation!==We){d=a.a.getBoundingClientRect();var e=Lg(this.l);e[0]-=d.left;e[1]-=d.top;this.g=a.Xa(e);this.a&&(d=c.Qa(),a.render(),tg(c,d+b,this.g))}}
function rh(a){if(2>this.l.length){a=a.map.$();hg(a,1,-1);if(this.a){var b=a.Qa(),c=this.g,d=this.u;b=a.constrainRotation(b,0);tg(a,b,c,d)}return!1}return!0}function ph(a){return 2<=this.l.length?(a=a.map,this.g=null,this.j=void 0,this.a=!1,this.o=0,this.D||hg(a.$(),1,1),!0):!1}oh.prototype.$c=qf;function sh(a){Jg.call(this,{handleDownEvent:th,handleDragEvent:uh,handleUpEvent:vh});a=a?a:{};this.o=a.constrainResolution||!1;this.g=null;this.u=void 0!==a.duration?a.duration:400;this.a=void 0;this.j=1}v(sh,Jg);
function uh(a){var b=1,c=this.l[0],d=this.l[1],e=c.clientX-d.clientX;c=c.clientY-d.clientY;e=Math.sqrt(e*e+c*c);void 0!==this.a&&(b=this.a/e);this.a=e;a=a.map;e=a.$();d=e.Pa();var f=e.a,g=e.i;c=d*b;c>f?(b=f/d,c=f):c<g&&(b=g/d,c=g);1!=b&&(this.j=b);b=a.a.getBoundingClientRect();d=Lg(this.l);d[0]-=b.left;d[1]-=b.top;this.g=a.Xa(d);a.render();vg(e,c,this.g)}
function vh(a){if(2>this.l.length){a=a.map.$();hg(a,1,-1);var b=a.Pa();if(this.o||b<a.i||b>a.a){var c=this.g,d=this.u;b=a.constrainResolution(b,0,this.j-1);vg(a,b,c,d)}return!1}return!0}function th(a){return 2<=this.l.length?(a=a.map,this.g=null,this.a=void 0,this.j=1,this.D||hg(a.$(),1,1),!0):!1}sh.prototype.$c=qf;function wh(a){a=a?a:{};var b=new $c,c=new pg(-.005,.05,100);(void 0!==a.altShiftDragRotate?a.altShiftDragRotate:1)&&b.push(new Qg);(void 0!==a.doubleClickZoom?a.doubleClickZoom:1)&&b.push(new wg({delta:a.zoomDelta,duration:a.zoomDuration}));(void 0!==a.dragPan?a.dragPan:1)&&b.push(new Mg({kinetic:c}));(void 0!==a.pinchRotate?a.pinchRotate:1)&&b.push(new oh);(void 0!==a.pinchZoom?a.pinchZoom:1)&&b.push(new sh({constrainResolution:a.constrainResolution,duration:a.zoomDuration}));if(void 0!==a.keyboard?
a.keyboard:1)b.push(new gh),b.push(new ih({delta:a.zoomDelta,duration:a.zoomDuration}));(void 0!==a.mouseWheelZoom?a.mouseWheelZoom:1)&&b.push(new kh({constrainResolution:a.constrainResolution,duration:a.zoomDuration}));(void 0!==a.shiftDragZoom?a.shiftDragZoom:1)&&b.push(new fh({duration:a.zoomDuration}));return b};function xh(a){Vc.call(this);var b=rb({},a);b.opacity=void 0!==a.opacity?a.opacity:1;b.visible=void 0!==a.visible?a.visible:!0;b.zIndex=void 0!==a.zIndex?a.zIndex:0;b.maxResolution=void 0!==a.maxResolution?a.maxResolution:Infinity;b.minResolution=void 0!==a.minResolution?a.minResolution:0;this.H(b);this.a={layer:this,Ue:!0}}v(xh,Vc);
function yh(a){a.a.opacity=Aa(a.hc(),0,1);a.a.Ij=a.hg();a.a.visible=a.Sb();a.a.extent=a.G();a.a.zIndex=a.za();a.a.maxResolution=a.fc();a.a.minResolution=Math.max(a.gc(),0);return a.a}k=xh.prototype;k.G=function(){return this.get("extent")};k.fc=function(){return this.get("maxResolution")};k.gc=function(){return this.get("minResolution")};k.hc=function(){return this.get("opacity")};k.Sb=function(){return this.get("visible")};k.za=function(){return this.get("zIndex")};
k.xc=function(a){this.set("extent",a)};k.Bc=function(a){this.set("maxResolution",a)};k.Cc=function(a){this.set("minResolution",a)};k.yc=function(a){this.set("opacity",a)};k.zc=function(a){this.set("visible",a)};k.Wb=function(a){this.set("zIndex",a)};function zh(a){var b=a||{};a=rb({},b);delete a.layers;b=b.layers;xh.call(this,a);this.i=[];this.c={};y(this,Xc(Ch),this.Tl,this);b?Array.isArray(b)?b=new $c(b.slice(),{unique:!0}):va(b instanceof $c,43):b=new $c(void 0,{unique:!0});this.Hi(b)}v(zh,xh);k=zh.prototype;k.Ld=function(){};k.Qe=function(){this.s()};
k.Tl=function(){this.i.forEach(Gc);this.i.length=0;var a=this.wd();this.i.push(y(a,"add",this.Sl,this),y(a,"remove",this.Ul,this));for(var b in this.c)this.c[b].forEach(Gc);sb(this.c);a=a.a;var c;b=0;for(c=a.length;b<c;b++){var d=a[b];this.c[w(d).toString()]=[y(d,"propertychange",this.Qe,this),y(d,"change",this.Qe,this)]}this.s()};k.Sl=function(a){a=a.element;var b=w(a).toString();this.c[b]=[y(a,"propertychange",this.Qe,this),y(a,"change",this.Qe,this)];this.s()};
k.Ul=function(a){a=w(a.element).toString();this.c[a].forEach(Gc);delete this.c[a];this.s()};k.wd=function(){return this.get(Ch)};k.Hi=function(a){this.set(Ch,a)};
k.fg=function(a){var b=void 0!==a?a:[],c=b.length;this.wd().forEach(function(a){a.fg(b)});a=yh(this);var d;for(d=b.length;c<d;c++){var e=b[c];e.opacity*=a.opacity;e.visible=e.visible&&a.visible;e.maxResolution=Math.min(e.maxResolution,a.maxResolution);e.minResolution=Math.max(e.minResolution,a.minResolution);void 0!==a.extent&&(e.extent=void 0!==e.extent?nb(e.extent,a.extent):a.extent)}return b};k.hg=function(){return"ready"};var Ch="layers";function Dh(a){var b=rb({},a);delete b.source;xh.call(this,b);this.o=this.l=this.j=null;a.map&&this.setMap(a.map);y(this,Xc("source"),this.gm,this);this.Zc(a.source?a.source:null)}v(Dh,xh);function Eh(a,b){return a.visible&&b>=a.minResolution&&b<a.maxResolution}k=Dh.prototype;k.fg=function(a){a=a?a:[];a.push(yh(this));return a};k.ia=function(){return this.get("source")||null};k.hg=function(){var a=this.ia();return a?a.getState():"undefined"};k.io=function(){this.s()};
k.gm=function(){this.o&&(Gc(this.o),this.o=null);var a=this.ia();a&&(this.o=y(a,"change",this.io,this));this.s()};k.setMap=function(a){this.j&&(Gc(this.j),this.j=null);a||this.s();this.l&&(Gc(this.l),this.l=null);a&&(this.j=y(a,"precompose",function(a){var b=yh(this);b.Ue=!1;b.zIndex=Infinity;a.frameState.layerStatesArray.push(b);a.frameState.layerStates[w(this)]=b},this),this.l=y(this,"change",a.render,a),this.s())};k.Zc=function(a){this.set("source",a)};function Fh(){this.b={};this.a=0}Fh.prototype.clear=function(){this.b={};this.a=0};Fh.prototype.get=function(a,b,c){a=b+":"+a+":"+(c?id(c):"null");return a in this.b?this.b[a]:null};Fh.prototype.set=function(a,b,c,d){this.b[b+":"+a+":"+(c?id(c):"null")]=d;++this.a};var Gh=new Fh;var Hh=Array(6);function Ih(){return[1,0,0,1,0,0]}function Jh(a){return Kh(a,1,0,0,1,0,0)}function Lh(a,b){var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5],l=b[0],m=b[1],n=b[2],p=b[3],q=b[4];b=b[5];a[0]=c*l+e*m;a[1]=d*l+f*m;a[2]=c*n+e*p;a[3]=d*n+f*p;a[4]=c*q+e*b+g;a[5]=d*q+f*b+h;return a}function Kh(a,b,c,d,e,f,g){a[0]=b;a[1]=c;a[2]=d;a[3]=e;a[4]=f;a[5]=g;return a}function Mh(a,b){a[0]=b[0];a[1]=b[1];a[2]=b[2];a[3]=b[3];a[4]=b[4];a[5]=b[5];return a}
function Nh(a,b){var c=b[0],d=b[1];b[0]=a[0]*c+a[2]*d+a[4];b[1]=a[1]*c+a[3]*d+a[5];return b}function Oh(a,b){var c=Math.cos(b);b=Math.sin(b);Lh(a,Kh(Hh,c,b,-b,c,0,0))}function Ph(a,b,c){return Lh(a,Kh(Hh,b,0,0,c,0,0))}function Qh(a,b,c){Lh(a,Kh(Hh,1,0,0,1,b,c))}function Rh(a,b,c,d,e,f,g,h){var l=Math.sin(f);f=Math.cos(f);a[0]=d*f;a[1]=e*l;a[2]=-d*l;a[3]=e*f;a[4]=g*d*f-h*d*l+b;a[5]=g*e*l+h*e*f+c;return a}
function Sh(a){var b=a[0]*a[3]-a[1]*a[2];va(!!b,32);var c=a[0],d=a[1],e=a[2],f=a[3],g=a[4],h=a[5];a[0]=f/b;a[1]=-d/b;a[2]=-e/b;a[3]=c/b;a[4]=(e*h-f*g)/b;a[5]=-(c*h-d*g)/b;return a};function Th(a,b){this.l=b;this.c={};this.v={}}v(Th,Oc);function Uh(a){var b=a.viewState,c=a.coordinateToPixelTransform,d=a.pixelToCoordinateTransform;Rh(c,a.size[0]/2,a.size[1]/2,1/b.resolution,-1/b.resolution,-b.rotation,-b.center[0],-b.center[1]);Sh(Mh(d,c))}k=Th.prototype;k.ka=function(){for(var a in this.c)Pc(this.c[a])};function Vh(){if(32<Gh.a){var a=0,b;for(b in Gh.b){var c=Gh.b[b];a++&3||Tc(c)||(delete Gh.b[b],--Gh.a)}}}
k.Ha=function(a,b,c,d,e,f,g){function h(a,c){var f=w(a).toString(),g=b.layerStates[w(c)].Ue;if(!(f in b.skippedFeatureUids)||g)return d.call(e,a,g?c:null)}var l,m=b.viewState,n=m.resolution,p=m.projection;m=a;if(p.f){p=p.G();var q=jb(p),t=a[0];if(t<p[0]||t>p[2])m=[t+q*Math.ceil((p[0]-t)/q),a[1]]}p=b.layerStatesArray;for(q=p.length-1;0<=q;--q){var u=p[q];t=u.layer;if(Eh(u,n)&&f.call(g,t)&&(u=Wh(this,t),t.ia()&&(l=u.Ha(t.ia().u?m:a,b,c,h,e)),l))return l}};
k.Oi=function(a,b,c,d,e){return void 0!==this.Ha(a,b,c,pf,this,d,e)};function Wh(a,b){var c=w(b).toString();if(c in a.c)return a.c[c];b=b.Ld(a);a.c[c]=b;a.v[c]=y(b,"change",a.Rl,a);return b}k.Rl=function(){this.l.render()};k.Rg=ra;k.eq=function(a,b){for(var c in this.c)if(!(b&&c in b.layerStates)){a=c;var d=this.c[a];delete this.c[a];Gc(this.v[a]);delete this.v[a];Pc(d)}};function Xh(a,b){for(var c in a.c)if(!(c in b.layerStates)){b.postRenderFunctions.push(a.eq.bind(a));break}}
function oa(a,b){return a.zIndex-b.zIndex};function Yh(a,b,c,d,e){Qc.call(this,a);this.vectorContext=b;this.frameState=c;this.context=d;this.glContext=e}v(Yh,Qc);var Zh=[0,0,0,1],$h=[],ai=[0,0,0,1];function bi(a,b,c,d){b&&(a.translate(c,d),a.rotate(b),a.translate(-c,-d))};function ci(){}k=ci.prototype;k.wh=function(){};k.Cb=function(){};k.xd=function(){};k.$b=function(){};k.Ee=function(){};k.Fe=function(){};k.oc=function(){};k.pc=function(){};k.qc=function(){};k.rc=function(){};k.sc=function(){};k.tc=function(){};k.Qb=function(){};k.Na=function(){};k.Vb=function(){};k.gb=function(){};function di(a,b,c,d,e){this.f=a;this.g=b;this.c=c;this.R=d;this.Zb=e;this.M=this.b=this.a=this.Va=this.S=this.I=null;this.ta=this.U=this.v=this.C=this.B=this.D=0;this.ga=!1;this.i=this.jb=0;this.oa=!1;this.pa=0;this.ua="";this.mc=this.va=0;this.Sa=!1;this.l=this.Za=0;this.qa=this.o=this.j=null;this.u=[];this.Ib=Ih()}v(di,ci);
function ei(a,b,c){if(a.M){b=sf(b,0,c,2,a.R,a.u);c=a.f;var d=a.Ib,e=c.globalAlpha;1!=a.v&&(c.globalAlpha=e*a.v);var f=a.jb;a.ga&&(f+=a.Zb);var g;var h=0;for(g=b.length;h<g;h+=2){var l=b[h]-a.D,m=b[h+1]-a.B;a.oa&&(l=Math.round(l),m=Math.round(m));if(f||1!=a.i){var n=l+a.D,p=m+a.B;Rh(d,n,p,a.i,a.i,f,-n,-p);c.setTransform.apply(c,d)}c.drawImage(a.M,a.U,a.ta,a.pa,a.C,l,m,a.pa,a.C)}(f||1!=a.i)&&c.setTransform(1,0,0,1,0,0);1!=a.v&&(c.globalAlpha=e)}}
function fi(a,b,c,d){var e=0;if(a.qa&&""!==a.ua){a.j&&gi(a,a.j);a.o&&hi(a,a.o);var f=a.qa,g=a.f,h=a.Va;h?(h.font!=f.font&&(h.font=g.font=f.font),h.textAlign!=f.textAlign&&(h.textAlign=g.textAlign=f.textAlign),h.textBaseline!=f.textBaseline&&(h.textBaseline=g.textBaseline=f.textBaseline)):(g.font=f.font,g.textAlign=f.textAlign,g.textBaseline=f.textBaseline,a.Va={font:f.font,textAlign:f.textAlign,textBaseline:f.textBaseline});b=sf(b,e,c,d,a.R,a.u);f=a.f;g=a.Za;for(a.Sa&&(g+=a.Zb);e<c;e+=d){h=b[e]+a.va;
var l=b[e+1]+a.mc;if(g||1!=a.l){var m=Rh(a.Ib,h,l,a.l,a.l,g,-h,-l);f.setTransform.apply(f,m)}a.o&&f.strokeText(a.ua,h,l);a.j&&f.fillText(a.ua,h,l)}(g||1!=a.l)&&f.setTransform(1,0,0,1,0,0)}}function ii(a,b,c,d,e,f){var g=a.f;a=sf(b,c,d,e,a.R,a.u);g.moveTo(a[0],a[1]);b=a.length;f&&(b-=2);for(c=2;c<b;c+=2)g.lineTo(a[c],a[c+1]);f&&g.closePath();return d}function ji(a,b,c,d,e){var f;var g=0;for(f=d.length;g<f;++g)c=ii(a,b,c,d[g],e,!0);return c}k=di.prototype;
k.$b=function(a){if(ob(this.c,a.G())){if(this.a||this.b){this.a&&gi(this,this.a);this.b&&hi(this,this.b);var b=this.R;var c=this.u,d=a.ba();b=d?sf(d,0,d.length,a.ma(),b,c):null;c=b[2]-b[0];d=b[3]-b[1];c=Math.sqrt(c*c+d*d);d=this.f;d.beginPath();d.arc(b[0],b[1],c,0,2*Math.PI);this.a&&d.fill();this.b&&d.stroke()}""!==this.ua&&fi(this,a.xa(),2,2)}};k.xd=function(a){this.Na(a.Da(),a.Ea());this.Vb(a.Y());this.gb(a.Ja())};
k.Cb=function(a){switch(a.T()){case "Point":this.sc(a);break;case "LineString":this.oc(a);break;case "Polygon":this.tc(a);break;case "MultiPoint":this.qc(a);break;case "MultiLineString":this.pc(a);break;case "MultiPolygon":this.rc(a);break;case "GeometryCollection":this.Fe(a);break;case "Circle":this.$b(a)}};k.Ee=function(a,b){(a=(0,b.$a)(a))&&ob(this.c,a.G())&&(this.xd(b),this.Cb(a))};k.Fe=function(a){a=a.a;var b;var c=0;for(b=a.length;c<b;++c)this.Cb(a[c])};
k.sc=function(a){var b=a.ba();a=a.ma();this.M&&ei(this,b,b.length);""!==this.ua&&fi(this,b,b.length,a)};k.qc=function(a){var b=a.ba();a=a.ma();this.M&&ei(this,b,b.length);""!==this.ua&&fi(this,b,b.length,a)};k.oc=function(a){if(ob(this.c,a.G())){if(this.b){hi(this,this.b);var b=this.f,c=a.ba();b.beginPath();ii(this,c,0,c.length,a.ma(),!1);b.stroke()}""!==this.ua&&(a=ki(a),fi(this,a,2,2))}};
k.pc=function(a){var b=a.G();if(ob(this.c,b)){if(this.b){hi(this,this.b);b=this.f;var c=a.ba(),d=0,e=a.sb(),f=a.ma();b.beginPath();var g;var h=0;for(g=e.length;h<g;++h)d=ii(this,c,d,e[h],f,!1);b.stroke()}""!==this.ua&&(a=li(a),fi(this,a,a.length,2))}};k.tc=function(a){if(ob(this.c,a.G())){if(this.b||this.a){this.a&&gi(this,this.a);this.b&&hi(this,this.b);var b=this.f;b.beginPath();ji(this,a.Tb(),0,a.sb(),a.ma());this.a&&b.fill();this.b&&b.stroke()}""!==this.ua&&(a=ag(a),fi(this,a,2,2))}};
k.rc=function(a){if(ob(this.c,a.G())){if(this.b||this.a){this.a&&gi(this,this.a);this.b&&hi(this,this.b);var b=this.f,c=mi(a),d=0,e=a.c,f=a.ma(),g;b.beginPath();var h=0;for(g=e.length;h<g;++h)d=ji(this,c,d,e[h],f);this.a&&b.fill();this.b&&b.stroke()}""!==this.ua&&(a=ni(a),fi(this,a,a.length,2))}};function gi(a,b){var c=a.f,d=a.I;d?d.fillStyle!=b.fillStyle&&(d.fillStyle=c.fillStyle=b.fillStyle):(c.fillStyle=b.fillStyle,a.I={fillStyle:b.fillStyle})}
function hi(a,b){var c=a.f,d=a.S;d?(d.lineCap!=b.lineCap&&(d.lineCap=c.lineCap=b.lineCap),Vd&&(ma(d.lineDash,b.lineDash)||c.setLineDash(d.lineDash=b.lineDash),d.lineDashOffset!=b.lineDashOffset&&(d.lineDashOffset=c.lineDashOffset=b.lineDashOffset)),d.lineJoin!=b.lineJoin&&(d.lineJoin=c.lineJoin=b.lineJoin),d.lineWidth!=b.lineWidth&&(d.lineWidth=c.lineWidth=b.lineWidth),d.miterLimit!=b.miterLimit&&(d.miterLimit=c.miterLimit=b.miterLimit),d.strokeStyle!=b.strokeStyle&&(d.strokeStyle=c.strokeStyle=b.strokeStyle)):
(c.lineCap=b.lineCap,Vd&&(c.setLineDash(b.lineDash),c.lineDashOffset=b.lineDashOffset),c.lineJoin=b.lineJoin,c.lineWidth=b.lineWidth,c.miterLimit=b.miterLimit,c.strokeStyle=b.strokeStyle,a.S={lineCap:b.lineCap,lineDash:b.lineDash,lineDashOffset:b.lineDashOffset,lineJoin:b.lineJoin,lineWidth:b.lineWidth,miterLimit:b.miterLimit,strokeStyle:b.strokeStyle})}
k.Na=function(a,b){a?(a=a.b,this.a={fillStyle:kd(a?a:Zh)}):this.a=null;if(b){a=b.b;var c=b.g,d=b.f,e=b.i,f=b.j,g=b.c;b=b.l;this.b={lineCap:void 0!==c?c:"round",lineDash:d?d:$h,lineDashOffset:e?e:0,lineJoin:void 0!==f?f:"round",lineWidth:this.g*(void 0!==g?g:1),miterLimit:void 0!==b?b:10,strokeStyle:kd(a?a:ai)}}else this.b=null};
k.Vb=function(a){if(a){var b=a.Jc(),c=a.Y(1),d=a.Rc(),e=a.ic();this.D=b[0];this.B=b[1];this.C=e[1];this.M=c;this.v=a.i;this.U=d[0];this.ta=d[1];this.ga=a.o;this.jb=a.g;this.i=a.a*this.g;this.oa=a.v;this.pa=e[0]}else this.M=null};
k.gb=function(a){if(a){var b=a.Da();b?(b=b.b,this.j={fillStyle:kd(b?b:Zh)}):this.j=null;var c=a.Ea();if(c){b=c.b;var d=c.g,e=c.f,f=c.i,g=c.j,h=c.c;c=c.l;this.o={lineCap:void 0!==d?d:"round",lineDash:e?e:$h,lineDashOffset:f?f:0,lineJoin:void 0!==g?g:"round",lineWidth:void 0!==h?h:1,miterLimit:void 0!==c?c:10,strokeStyle:kd(b?b:ai)}}else this.o=null;b=a.a;d=a.f;e=a.c;f=a.l;g=a.i;h=a.b;c=a.Ja();var l=a.g;a=a.j;this.qa={font:void 0!==b?b:"10px sans-serif",textAlign:void 0!==l?l:"center",textBaseline:void 0!==
a?a:"middle"};this.ua=void 0!==c?c:"";this.va=void 0!==d?this.g*d:0;this.mc=void 0!==e?this.g*e:0;this.Sa=void 0!==f?f:!1;this.Za=void 0!==g?g:0;this.l=this.g*(void 0!==h?h:1)}else this.ua=""};function oi(a,b){Th.call(this,0,b);this.f=ld();this.b=this.f.canvas;this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.a=!0;this.i=Ih()}v(oi,Th);
function pi(a,b,c){var d=a.l,e=a.f;if(Tc(d,b)){var f=c.extent,g=c.pixelRatio,h=c.viewState.rotation,l=c.viewState,m=c.pixelRatio/l.resolution;a=Rh(a.i,a.b.width/2,a.b.height/2,m,-m,-l.rotation,-l.center[0],-l.center[1]);d.b(new Yh(b,new di(e,g,f,a,h),c,e,null))}}oi.prototype.T=function(){return"canvas"};
oi.prototype.Rg=function(a){if(a){var b=this.f,c=a.pixelRatio,d=Math.round(a.size[0]*c),e=Math.round(a.size[1]*c);this.b.width!=d||this.b.height!=e?(this.b.width=d,this.b.height=e):b.clearRect(0,0,d,e);c=a.viewState.rotation;Uh(a);pi(this,"precompose",a);var f=a.layerStatesArray;na(f);c&&(b.save(),bi(b,c,d/2,e/2));d=a.viewState.resolution;var g;e=0;for(g=f.length;e<g;++e){var h=f[e];var l=h.layer;l=Wh(this,l);Eh(h,d)&&"ready"==h.Ij&&l.yd(a,h)&&l.u(a,h,b)}c&&b.restore();pi(this,"postcompose",a);this.a||
(this.b.style.display="",this.a=!0);Xh(this,a);a.postRenderFunctions.push(Vh)}else this.a&&(this.b.style.display="none",this.a=!1)};oi.prototype.Ni=function(a,b,c,d,e,f){var g=b.viewState.resolution,h=b.layerStatesArray,l=h.length;a=Nh(b.pixelToCoordinateTransform,a.slice());for(--l;0<=l;--l){var m=h[l];var n=m.layer;if(Eh(m,g)&&e.call(f,n)&&(m=Wh(this,n).v(a,b,c,d)))return m}};var qi="Polygon Circle LineString Image Text Default".split(" ");function ri(){};function si(a){this.b=a};function ti(a){this.b=a}v(ti,si);ti.prototype.T=function(){return 35632};function ui(a){this.b=a}v(ui,si);ui.prototype.T=function(){return 35633};function vi(){this.b="precision mediump float;varying vec2 a;varying vec2 b;varying float c;varying float d;uniform float m;uniform vec4 n;uniform vec4 o;uniform vec2 p;void main(void){vec2 windowCenter=vec2((a.x+1.0)/2.0*p.x*d,(a.y+1.0)/2.0*p.y*d);vec2 windowOffset=vec2((b.x+1.0)/2.0*p.x*d,(b.y+1.0)/2.0*p.y*d);float radius=length(windowCenter-windowOffset);float dist=length(windowCenter-gl_FragCoord.xy);if(dist>radius+c){if(o.a==0.0){gl_FragColor=n;}else{gl_FragColor=o;}gl_FragColor.a=gl_FragColor.a-(dist-(radius+c));}else if(n.a==0.0){gl_FragColor=o;if(dist<radius-c){gl_FragColor.a=gl_FragColor.a-(radius-c-dist);}} else{gl_FragColor=n;float strokeDist=radius-c;float antialias=2.0*d;if(dist>strokeDist){gl_FragColor=o;}else if(dist>=strokeDist-antialias){float step=smoothstep(strokeDist-antialias,strokeDist,dist);gl_FragColor=mix(n,o,step);}} gl_FragColor.a=gl_FragColor.a*m;if(gl_FragColor.a<=0.0){discard;}}"}
v(vi,ti);var wi=new vi;
function xi(){this.b="varying vec2 a;varying vec2 b;varying float c;varying float d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;void main(void){mat4 offsetMatrix=i*j;a=vec4(h*vec4(e,0.0,1.0)).xy;d=l;float lineWidth=k*l;c=lineWidth/2.0;if(lineWidth==0.0){lineWidth=2.0*l;}vec2 offset;float radius=g+3.0*l;if(f==0.0){offset=vec2(-1.0,1.0);}else if(f==1.0){offset=vec2(-1.0,-1.0);}else if(f==2.0){offset=vec2(1.0,-1.0);}else{offset=vec2(1.0,1.0);}gl_Position=h*vec4(e+offset*radius,0.0,1.0)+offsetMatrix*vec4(offset*lineWidth,0.0,0.0);b=vec4(h*vec4(e.x+g,e.y,0.0,1.0)).xy;if(distance(a,b)>20000.0){gl_Position=vec4(a,0.0,1.0);}}"}
v(xi,ui);var yi=new xi;function zi(a,b){this.B=a.getUniformLocation(b,"n");this.pa=a.getUniformLocation(b,"k");this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"m");this.qa=a.getUniformLocation(b,"l");this.f=a.getUniformLocation(b,"h");this.I=a.getUniformLocation(b,"p");this.S=a.getUniformLocation(b,"o");this.j=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"e");this.R=a.getAttribLocation(b,"g")};function Ai(){return[1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1]}function Bi(a,b){a[0]=b[0];a[1]=b[1];a[4]=b[2];a[5]=b[3];a[12]=b[4];a[13]=b[5];return a};function Ci(a,b){this.origin=lb(b);this.Ib=Ih();this.Sa=Ih();this.Za=Ih();this.U=Ai();this.b=[];this.j=null;this.f=[];this.i=[];this.a=[];this.o=null;this.g=void 0}v(Ci,ci);
Ci.prototype.Ma=function(a,b,c,d,e,f,g,h,l,m,n){var p=a.b;if(this.g){var q=p.isEnabled(p.STENCIL_TEST);var t=p.getParameter(p.STENCIL_FUNC);var u=p.getParameter(p.STENCIL_VALUE_MASK);var x=p.getParameter(p.STENCIL_REF);var B=p.getParameter(p.STENCIL_WRITEMASK);var z=p.getParameter(p.STENCIL_FAIL);var G=p.getParameter(p.STENCIL_PASS_DEPTH_PASS);var E=p.getParameter(p.STENCIL_PASS_DEPTH_FAIL);p.enable(p.STENCIL_TEST);p.clear(p.STENCIL_BUFFER_BIT);p.stencilMask(255);p.stencilFunc(p.ALWAYS,1,255);p.stencilOp(p.KEEP,
p.KEEP,p.REPLACE);this.g.Ma(a,b,c,d,e,f,g,h,l,m,n);p.stencilMask(0);p.stencilFunc(p.NOTEQUAL,1,255)}Di(a,34962,this.o);Di(a,34963,this.j);f=this.Bf(p,a,e,f);var ia=Jh(this.Ib);Ph(ia,2/(c*e[0]),2/(c*e[1]));Oh(ia,-d);Qh(ia,-(b[0]-this.origin[0]),-(b[1]-this.origin[1]));b=Jh(this.Za);Ph(b,2/e[0],2/e[1]);e=Jh(this.Sa);d&&Oh(e,-d);p.uniformMatrix4fv(f.f,!1,Bi(this.U,ia));p.uniformMatrix4fv(f.i,!1,Bi(this.U,b));p.uniformMatrix4fv(f.c,!1,Bi(this.U,e));p.uniform1f(f.a,g);if(l){m?a=this.Ge(p,a,h,l,n):(p.clear(p.COLOR_BUFFER_BIT|
p.DEPTH_BUFFER_BIT),this.Ud(p,a,h,!0),a=(a=l(null))?a:void 0);var T=a}else this.Ud(p,a,h,!1);this.Cf(p,f);this.g&&(q||p.disable(p.STENCIL_TEST),p.clear(p.STENCIL_BUFFER_BIT),p.stencilFunc(t,x,u),p.stencilMask(B),p.stencilOp(z,E,G));return T};function Ei(a,b,c,d){a.drawElements(4,d-c,b.g?5125:5123,c*(b.g?4:2))};var Fi=[0,0,0,1],Gi=[],Hi=[0,0,0,1];function Ii(a,b,c,d,e,f){a=(c-a)*(f-b)-(e-a)*(d-b);return a<=Ji&&a>=-Ji?void 0:0<a}var Ji=Number.EPSILON||2.220446049250313E-16;function Ki(a){this.b=void 0!==a?a:[];this.a=Li}var Li=35044;function Mi(a,b){Ci.call(this,0,b);this.v=null;this.l=[];this.u=[];this.R=0;this.c={fillColor:null,strokeColor:null,lineDash:null,lineDashOffset:void 0,lineWidth:void 0,s:!1}}v(Mi,Ci);k=Mi.prototype;
k.$b=function(a,b){var c=a.vd(),d=a.ma();if(c){this.f.push(this.b.length);this.i.push(b);this.c.s&&(this.u.push(this.b.length),this.c.s=!1);this.R=c;a=a.ba();a=tf(a,0,2,d,-this.origin[0],-this.origin[1]);b=this.a.length;c=this.b.length;var e=b/4,f;for(f=0;2>f;f+=d)this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=0,this.a[b++]=this.R,this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=1,this.a[b++]=this.R,this.a[b++]=a[f],this.a[b++]=a[f+1],this.a[b++]=2,this.a[b++]=this.R,this.a[b++]=a[f],this.a[b++]=
a[f+1],this.a[b++]=3,this.a[b++]=this.R,this.b[c++]=e,this.b[c++]=e+1,this.b[c++]=e+2,this.b[c++]=e+2,this.b[c++]=e+3,this.b[c++]=e,e+=4}else this.c.s&&(this.l.pop(),this.l.length&&(d=this.l[this.l.length-1],this.c.fillColor=d[0],this.c.strokeColor=d[1],this.c.lineWidth=d[2],this.c.s=!1))};k.ab=function(){this.o=new Ki(this.a);this.j=new Ki(this.b);this.f.push(this.b.length);!this.u.length&&0<this.l.length&&(this.l=[]);this.b=this.a=null};
k.xb=function(a){var b=this.o,c=this.j;return function(){Ni(a,b);Ni(a,c)}};k.Bf=function(a,b,c,d){var e=Oi(b,wi,yi);if(this.v)var f=this.v;else this.v=f=new zi(a,e);b.Tc(e);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,16,0);a.enableVertexAttribArray(f.j);a.vertexAttribPointer(f.j,1,5126,!1,16,8);a.enableVertexAttribArray(f.R);a.vertexAttribPointer(f.R,1,5126,!1,16,12);a.uniform2fv(f.I,c);a.uniform1f(f.qa,d);return f};
k.Cf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.j);a.disableVertexAttribArray(b.R)};
k.Ud=function(a,b,c){if(ub(c)){var d=this.f[this.f.length-1];for(c=this.u.length-1;0<=c;--c){var e=this.u[c];var f=this.l[c];a.uniform4fv(this.v.B,f[0]);Pi(this,a,f[1],f[2]);Ei(a,b,e,d);d=e}}else{var g=this.f.length-2;f=d=this.f[g+1];for(e=this.u.length-1;0<=e;--e){var h=this.l[e];a.uniform4fv(this.v.B,h[0]);Pi(this,a,h[1],h[2]);for(h=this.u[e];0<=g&&this.f[g]>=h;){var l=this.f[g];var m=this.i[g];m=w(m).toString();c[m]&&(d!==f&&Ei(a,b,d,f),f=l);g--;d=l}d!==f&&Ei(a,b,d,f);d=f=h}}};
k.Ge=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.u.length-1;0<=f;--f){var m=this.l[f];a.uniform4fv(this.v.B,m[0]);Pi(this,a,m[1],m[2]);for(g=this.u[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||ob(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),Ei(a,b,m,l),l=d(n)))return l;h--;l=m}}};function Pi(a,b,c,d){b.uniform4fv(a.v.S,c);b.uniform1f(a.v.pa,d)}
k.Na=function(a,b){if(b){var c=b.f;this.c.lineDash=c?c:Gi;c=b.i;this.c.lineDashOffset=c?c:0;c=b.b;c instanceof CanvasGradient||c instanceof CanvasPattern?c=Hi:c=gd(c).map(function(a,b){return 3!=b?a/255:a})||Hi;b=b.c;b=void 0!==b?b:1}else c=[0,0,0,0],b=0;a=a?a.b:[0,0,0,0];a instanceof CanvasGradient||a instanceof CanvasPattern?a=Fi:a=gd(a).map(function(a,b){return 3!=b?a/255:a})||Fi;this.c.strokeColor&&ma(this.c.strokeColor,c)&&this.c.fillColor&&ma(this.c.fillColor,a)&&this.c.lineWidth===b||(this.c.s=
!0,this.c.fillColor=a,this.c.strokeColor=c,this.c.lineWidth=b,this.l.push([a,c,b]))};function Qi(){this.b="precision mediump float;varying vec2 a;varying float b;uniform float k;uniform sampler2D l;void main(void){vec4 texColor=texture2D(l,a);gl_FragColor.rgb=texColor.rgb;float alpha=texColor.a*b*k;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}v(Qi,ti);var Ri=new Qi;
function Si(){this.b="varying vec2 a;varying float b;attribute vec2 c;attribute vec2 d;attribute vec2 e;attribute float f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;void main(void){mat4 offsetMatrix=i;if(g==1.0){offsetMatrix=i*j;}vec4 offsets=offsetMatrix*vec4(e,0.0,0.0);gl_Position=h*vec4(c,0.0,1.0)+offsets;a=d;b=f;}"}v(Si,ui);var Ti=new Si;
function Ui(a,b){this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"k");this.f=a.getUniformLocation(b,"h");this.v=a.getAttribLocation(b,"e");this.u=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"c");this.D=a.getAttribLocation(b,"g");this.C=a.getAttribLocation(b,"d")};function Vi(a,b){this.j=a;this.b=b;this.a={};this.c={};this.f={};this.o=this.v=this.i=this.l=null;(this.g=ha(ca,"OES_element_index_uint"))&&b.getExtension("OES_element_index_uint");y(this.j,"webglcontextlost",this.kp,this);y(this.j,"webglcontextrestored",this.lp,this)}v(Vi,Oc);
function Di(a,b,c){var d=a.b,e=c.b,f=String(w(c));if(f in a.a)d.bindBuffer(b,a.a[f].buffer);else{var g=d.createBuffer();d.bindBuffer(b,g);var h;34962==b?h=new Float32Array(e):34963==b&&(h=a.g?new Uint32Array(e):new Uint16Array(e));d.bufferData(b,h,c.a);a.a[f]={nc:c,buffer:g}}}function Ni(a,b){var c=a.b;b=String(w(b));var d=a.a[b];c.isContextLost()||c.deleteBuffer(d.buffer);delete a.a[b]}k=Vi.prototype;
k.ka=function(){Nc(this.j);var a=this.b;if(!a.isContextLost()){for(var b in this.a)a.deleteBuffer(this.a[b].buffer);for(b in this.f)a.deleteProgram(this.f[b]);for(b in this.c)a.deleteShader(this.c[b]);a.deleteFramebuffer(this.i);a.deleteRenderbuffer(this.o);a.deleteTexture(this.v)}};k.jp=function(){return this.b};
function Wi(a){if(!a.i){var b=a.b,c=b.createFramebuffer();b.bindFramebuffer(b.FRAMEBUFFER,c);var d=Xi(b,1,1),e=b.createRenderbuffer();b.bindRenderbuffer(b.RENDERBUFFER,e);b.renderbufferStorage(b.RENDERBUFFER,b.DEPTH_COMPONENT16,1,1);b.framebufferTexture2D(b.FRAMEBUFFER,b.COLOR_ATTACHMENT0,b.TEXTURE_2D,d,0);b.framebufferRenderbuffer(b.FRAMEBUFFER,b.DEPTH_ATTACHMENT,b.RENDERBUFFER,e);b.bindTexture(b.TEXTURE_2D,null);b.bindRenderbuffer(b.RENDERBUFFER,null);b.bindFramebuffer(b.FRAMEBUFFER,null);a.i=c;
a.v=d;a.o=e}return a.i}function Yi(a,b){var c=String(w(b));if(c in a.c)return a.c[c];var d=a.b,e=d.createShader(b.T());d.shaderSource(e,b.b);d.compileShader(e);return a.c[c]=e}function Oi(a,b,c){var d=w(b)+"/"+w(c);if(d in a.f)return a.f[d];var e=a.b,f=e.createProgram();e.attachShader(f,Yi(a,b));e.attachShader(f,Yi(a,c));e.linkProgram(f);return a.f[d]=f}k.kp=function(){sb(this.a);sb(this.c);sb(this.f);this.o=this.v=this.i=this.l=null};k.lp=function(){};
k.Tc=function(a){if(a==this.l)return!1;this.b.useProgram(a);this.l=a;return!0};function Zi(a,b,c){var d=a.createTexture();a.bindTexture(a.TEXTURE_2D,d);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MAG_FILTER,a.LINEAR);a.texParameteri(a.TEXTURE_2D,a.TEXTURE_MIN_FILTER,a.LINEAR);void 0!==b&&a.texParameteri(3553,10242,b);void 0!==c&&a.texParameteri(3553,10243,c);return d}function Xi(a,b,c){var d=Zi(a,void 0,void 0);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,b,c,0,a.RGBA,a.UNSIGNED_BYTE,null);return d}
function $i(a,b){var c=Zi(a,33071,33071);a.texImage2D(a.TEXTURE_2D,0,a.RGBA,a.RGBA,a.UNSIGNED_BYTE,b);return c};function aj(a,b){Ci.call(this,0,b);this.B=this.D=void 0;this.v=[];this.u=[];this.qa=this.pa=this.height=void 0;this.Va=null;this.width=this.scale=this.rotation=this.rotateWithView=this.S=this.I=this.opacity=void 0}v(aj,Ci);k=aj.prototype;k.xb=function(a){var b=this.o,c=this.j,d=this.jg(!0),e=a.b;return function(){if(!e.isContextLost()){var f;var g=0;for(f=d.length;g<f;++g)e.deleteTexture(d[g])}Ni(a,b);Ni(a,c)}};
function bj(a,b,c,d,e){var f=a.D,g=a.B,h=a.height,l=a.pa,m=a.qa,n=a.opacity,p=a.I,q=a.S,t=a.rotateWithView?1:0,u=-a.rotation,x=a.scale,B=a.width,z=Math.cos(u);u=Math.sin(u);for(var G=a.b.length,E=a.a.length,ia,T,R,U,ta;c<d;c+=e)U=b[c]-a.origin[0],ta=b[c+1]-a.origin[1],ia=E/8,T=-x*f,R=-x*(h-g),a.a[E++]=U,a.a[E++]=ta,a.a[E++]=T*z-R*u,a.a[E++]=T*u+R*z,a.a[E++]=p/m,a.a[E++]=(q+h)/l,a.a[E++]=n,a.a[E++]=t,T=x*(B-f),R=-x*(h-g),a.a[E++]=U,a.a[E++]=ta,a.a[E++]=T*z-R*u,a.a[E++]=T*u+R*z,a.a[E++]=(p+B)/m,a.a[E++]=
(q+h)/l,a.a[E++]=n,a.a[E++]=t,T=x*(B-f),R=x*g,a.a[E++]=U,a.a[E++]=ta,a.a[E++]=T*z-R*u,a.a[E++]=T*u+R*z,a.a[E++]=(p+B)/m,a.a[E++]=q/l,a.a[E++]=n,a.a[E++]=t,T=-x*f,R=x*g,a.a[E++]=U,a.a[E++]=ta,a.a[E++]=T*z-R*u,a.a[E++]=T*u+R*z,a.a[E++]=p/m,a.a[E++]=q/l,a.a[E++]=n,a.a[E++]=t,a.b[G++]=ia,a.b[G++]=ia+1,a.b[G++]=ia+2,a.b[G++]=ia,a.b[G++]=ia+2,a.b[G++]=ia+3}function cj(a,b,c,d){var e,f=b.length;for(e=0;e<f;++e){var g=b[e];var h=w(g).toString();h in c?g=c[h]:(g=$i(d,g),c[h]=g);a[e]=g}}
k.Bf=function(a,b){var c=Oi(b,Ri,Ti);if(this.Va)var d=this.Va;else this.Va=d=new Ui(a,c);b.Tc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,32,0);a.enableVertexAttribArray(d.v);a.vertexAttribPointer(d.v,2,5126,!1,32,8);a.enableVertexAttribArray(d.C);a.vertexAttribPointer(d.C,2,5126,!1,32,16);a.enableVertexAttribArray(d.u);a.vertexAttribPointer(d.u,1,5126,!1,32,24);a.enableVertexAttribArray(d.D);a.vertexAttribPointer(d.D,1,5126,!1,32,28);return d};
k.Cf=function(a,b){a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.v);a.disableVertexAttribArray(b.C);a.disableVertexAttribArray(b.u);a.disableVertexAttribArray(b.D)};
k.Ud=function(a,b,c,d){var e=d?this.dg():this.jg();d=d?this.u:this.v;if(ub(c)){var f;c=0;var g=e.length;for(f=0;c<g;++c){a.bindTexture(3553,e[c]);var h=d[c];Ei(a,b,f,h);f=h}}else for(f=g=0,h=e.length;f<h;++f){a.bindTexture(3553,e[f]);for(var l=0<f?d[f-1]:0,m=d[f],n=l;g<this.f.length&&this.f[g]<=m;){var p=w(this.i[g]).toString();void 0!==c[p]?(n!==l&&Ei(a,b,n,l),l=n=g===this.f.length-1?m:this.f[g+1]):l=g===this.f.length-1?m:this.f[g+1];g++}n!==l&&Ei(a,b,n,l)}};
k.Ge=function(a,b,c,d,e){var f,g,h=this.f.length-1,l=this.dg();for(f=l.length-1;0<=f;--f){a.bindTexture(3553,l[f]);var m=0<f?this.u[f-1]:0;for(g=this.u[f];0<=h&&this.f[h]>=m;){var n=this.f[h];var p=this.i[h];var q=w(p).toString();if(void 0===c[q]&&p.W()&&(void 0===e||ob(e,p.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),Ei(a,b,n,g),g=d(p)))return g;g=n;h--}}};
k.ab=function(){this.qa=this.pa=this.height=this.B=this.D=void 0;this.b=null;this.scale=this.rotation=this.rotateWithView=this.S=this.I=this.opacity=void 0;this.a=null;this.width=void 0};function dj(a,b){aj.call(this,0,b);this.l=[];this.c=[];this.C=[];this.R=[]}v(dj,aj);k=dj.prototype;k.qc=function(a,b){this.f.push(this.b.length);this.i.push(b);b=a.ba();bj(this,b,0,b.length,a.ma())};k.sc=function(a,b){this.f.push(this.b.length);this.i.push(b);b=a.ba();bj(this,b,0,b.length,a.ma())};
k.ab=function(a){var b=a.b;this.v.push(this.b.length);this.u.push(this.b.length);this.o=new Ki(this.a);this.j=new Ki(this.b);var c={};cj(this.C,this.l,c,b);cj(this.R,this.c,c,b);this.c=this.l=null;aj.prototype.ab.call(this,a)};
k.Vb=function(a){var b=a.Jc(),c=a.Y(1),d=a.Ie(),e=a.yg(1),f=a.i,g=a.Rc(),h=a.o,l=a.g,m=a.ic();a=a.a;if(this.l.length){var n=this.l[this.l.length-1];w(n)!=w(c)&&(this.v.push(this.b.length),this.l.push(c))}else this.l.push(c);this.c.length?(n=this.c[this.c.length-1],w(n)!=w(e)&&(this.u.push(this.b.length),this.c.push(e))):this.c.push(e);this.D=b[0];this.B=b[1];this.height=m[1];this.pa=d[1];this.qa=d[0];this.opacity=f;this.I=g[0];this.S=g[1];this.rotation=l;this.rotateWithView=h;this.scale=a;this.width=
m[0]};k.jg=function(a){return a?this.C.concat(this.R):this.C};k.dg=function(){return this.R};function ej(a,b,c){var d=b-c;return a[0]===a[d]&&a[1]===a[d+1]&&3<(b-0)/c?!!yf(a,0,b,c):!1};function fj(){this.b="precision mediump float;varying float a;varying vec2 b;varying float c;uniform float m;uniform vec4 n;uniform vec2 o;uniform float p;void main(void){if(a>0.0){vec2 windowCoords=vec2((b.x+1.0)/2.0*o.x*p,(b.y+1.0)/2.0*o.y*p);if(length(windowCoords-gl_FragCoord.xy)>c*p){discard;}} gl_FragColor=n;float alpha=n.a*m;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}v(fj,ti);var gj=new fj;
function hj(){this.b="varying float a;varying vec2 b;varying float c;attribute vec2 d;attribute vec2 e;attribute vec2 f;attribute float g;uniform mat4 h;uniform mat4 i;uniform mat4 j;uniform float k;uniform float l;bool nearlyEquals(in float value,in float ref){float epsilon=0.000000000001;return value>=ref-epsilon&&value<=ref+epsilon;}void alongNormal(out vec2 offset,in vec2 nextP,in float turnDir,in float direction){vec2 dirVect=nextP-e;vec2 normal=normalize(vec2(-turnDir*dirVect.y,turnDir*dirVect.x));offset=k/2.0*normal*direction;}void miterUp(out vec2 offset,out float round,in bool isRound,in float direction){float halfWidth=k/2.0;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=f-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;round=0.0;if(isRound){round=1.0;}else if(miterLength>l+k){offset=halfWidth*tmpNormal*direction;}} bool miterDown(out vec2 offset,in vec4 projPos,in mat4 offsetMatrix,in float direction){bool degenerate=false;vec2 tangent=normalize(normalize(f-e)+normalize(e-d));vec2 normal=vec2(-tangent.y,tangent.x);vec2 dirVect=d-e;vec2 tmpNormal=normalize(vec2(-dirVect.y,dirVect.x));vec2 longOffset,shortOffset,longVertex;vec4 shortProjVertex;float halfWidth=k/2.0;if(length(f-e)>length(d-e)){longOffset=tmpNormal*direction*halfWidth;shortOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=f;shortProjVertex=h*vec4(d,0.0,1.0);}else{shortOffset=tmpNormal*direction*halfWidth;longOffset=normalize(vec2(dirVect.y,-dirVect.x))*direction*halfWidth;longVertex=d;shortProjVertex=h*vec4(f,0.0,1.0);}vec4 p1=h*vec4(longVertex,0.0,1.0)+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p2=projPos+offsetMatrix*vec4(longOffset,0.0,0.0);vec4 p3=shortProjVertex+offsetMatrix*vec4(-shortOffset,0.0,0.0);vec4 p4=shortProjVertex+offsetMatrix*vec4(shortOffset,0.0,0.0);float denom=(p4.y-p3.y)*(p2.x-p1.x)-(p4.x-p3.x)*(p2.y-p1.y);float firstU=((p4.x-p3.x)*(p1.y-p3.y)-(p4.y-p3.y)*(p1.x-p3.x))/denom;float secondU=((p2.x-p1.x)*(p1.y-p3.y)-(p2.y-p1.y)*(p1.x-p3.x))/denom;float epsilon=0.000000000001;if(firstU>epsilon&&firstU<1.0-epsilon&&secondU>epsilon&&secondU<1.0-epsilon){shortProjVertex.x=p1.x+firstU*(p2.x-p1.x);shortProjVertex.y=p1.y+firstU*(p2.y-p1.y);offset=shortProjVertex.xy;degenerate=true;}else{float miterLength=abs(halfWidth/dot(normal,tmpNormal));offset=normal*direction*miterLength;}return degenerate;}void squareCap(out vec2 offset,out float round,in bool isRound,in vec2 nextP,in float turnDir,in float direction){round=0.0;vec2 dirVect=e-nextP;vec2 firstNormal=normalize(dirVect);vec2 secondNormal=vec2(turnDir*firstNormal.y*direction,-turnDir*firstNormal.x*direction);vec2 hypotenuse=normalize(firstNormal-secondNormal);vec2 normal=vec2(turnDir*hypotenuse.y*direction,-turnDir*hypotenuse.x*direction);float length=sqrt(c*c*2.0);offset=normal*length;if(isRound){round=1.0;}} void main(void){bool degenerate=false;float direction=float(sign(g));mat4 offsetMatrix=i*j;vec2 offset;vec4 projPos=h*vec4(e,0.0,1.0);bool round=nearlyEquals(mod(g,2.0),0.0);a=0.0;c=k/2.0;b=projPos.xy;if(nearlyEquals(mod(g,3.0),0.0)||nearlyEquals(mod(g,17.0),0.0)){alongNormal(offset,f,1.0,direction);}else if(nearlyEquals(mod(g,5.0),0.0)||nearlyEquals(mod(g,13.0),0.0)){alongNormal(offset,d,-1.0,direction);}else if(nearlyEquals(mod(g,23.0),0.0)){miterUp(offset,a,round,direction);}else if(nearlyEquals(mod(g,19.0),0.0)){degenerate=miterDown(offset,projPos,offsetMatrix,direction);}else if(nearlyEquals(mod(g,7.0),0.0)){squareCap(offset,a,round,f,1.0,direction);}else if(nearlyEquals(mod(g,11.0),0.0)){squareCap(offset,a,round,d,-1.0,direction);}if(!degenerate){vec4 offsets=offsetMatrix*vec4(offset,0.0,0.0);gl_Position=projPos+offsets;}else{gl_Position=vec4(offset,0.0,1.0);}}"}
v(hj,ui);var ij=new hj;function jj(a,b){this.B=a.getUniformLocation(b,"n");this.pa=a.getUniformLocation(b,"k");this.S=a.getUniformLocation(b,"l");this.c=a.getUniformLocation(b,"j");this.i=a.getUniformLocation(b,"i");this.a=a.getUniformLocation(b,"m");this.qa=a.getUniformLocation(b,"p");this.f=a.getUniformLocation(b,"h");this.I=a.getUniformLocation(b,"o");this.g=a.getAttribLocation(b,"g");this.l=a.getAttribLocation(b,"d");this.o=a.getAttribLocation(b,"f");this.b=a.getAttribLocation(b,"e")};function kj(a,b){Ci.call(this,0,b);this.v=null;this.u=[];this.l=[];this.c={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0,s:!1}}v(kj,Ci);
function lj(a,b,c,d){var e,f=a.a.length,g=a.b.length,h="bevel"===a.c.lineJoin?0:"miter"===a.c.lineJoin?1:2,l="butt"===a.c.lineCap?0:"square"===a.c.lineCap?1:2,m=ej(b,c,d),n=g,p=1;for(e=0;e<c;e+=d){var q=f/7;var t=u;var u=x||[b[e],b[e+1]];if(e)if(e===c-d){if(m)var x=B;else t=t||[0,0],f=mj(a,t,u,[0,0],p*nj*(l||1),f),f=mj(a,t,u,[0,0],-p*nj*(l||1),f),a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=n,a.b[g++]=q+1,a.b[g++]=q,l&&(f=mj(a,t,u,[0,0],p*oj*l,f),f=mj(a,t,u,[0,0],-p*oj*l,f),a.b[g++]=q+2,a.b[g++]=q,
a.b[g++]=q+1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2);break}else x=[b[e+d],b[e+d+1]];else{x=[b[e+d],b[e+d+1]];if(c-0===2*d&&ma(u,x))break;if(m){t=[b[c-2*d],b[c-2*d+1]];var B=x}else{l&&(f=mj(a,[0,0],u,x,p*pj*l,f),f=mj(a,[0,0],u,x,-p*pj*l,f),a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=q+1,a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q+2);f=mj(a,[0,0],u,x,p*qj*(l||1),f);f=mj(a,[0,0],u,x,-p*qj*(l||1),f);n=f/7-1;continue}}var z=Ii(t[0],t[1],u[0],u[1],x[0],x[1])?-1:1;f=mj(a,t,u,x,z*rj*(h||1),f);f=mj(a,t,u,x,z*sj*(h||1),f);f=
mj(a,t,u,x,-z*tj*(h||1),f);0<e&&(a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=q+2,a.b[g++]=q,a.b[g++]=0<p*z?n:n-1);a.b[g++]=q;a.b[g++]=q+2;a.b[g++]=q+1;n=q+2;p=z;h&&(f=mj(a,t,u,x,z*uj*h,f),a.b[g++]=q+1,a.b[g++]=q+3,a.b[g++]=q)}m&&(q=q||f/7,z=Xf([t[0],t[1],u[0],u[1],x[0],x[1]],0,6,2)?1:-1,f=mj(a,t,u,x,z*rj*(h||1),f),mj(a,t,u,x,-z*tj*(h||1),f),a.b[g++]=q,a.b[g++]=n-1,a.b[g++]=n,a.b[g++]=q+1,a.b[g++]=q,a.b[g++]=0<p*z?n:n-1)}
function mj(a,b,c,d,e,f){a.a[f++]=b[0];a.a[f++]=b[1];a.a[f++]=c[0];a.a[f++]=c[1];a.a[f++]=d[0];a.a[f++]=d[1];a.a[f++]=e;return f}function vj(a,b,c,d){c-=b;return c<2*d?!1:c===2*d?!ma([a[b],a[b+1]],[a[b+d],a[b+d+1]]):!0}k=kj.prototype;k.oc=function(a,b){var c=a.ba();a=a.ma();vj(c,0,c.length,a)&&(c=tf(c,0,c.length,a,-this.origin[0],-this.origin[1]),this.c.s&&(this.l.push(this.b.length),this.c.s=!1),this.f.push(this.b.length),this.i.push(b),lj(this,c,c.length,a))};
k.pc=function(a,b){var c=this.b.length,d=a.sb();d.unshift(0);var e=a.ba();a=a.ma();var f;if(1<d.length){var g=1;for(f=d.length;g<f;++g)if(vj(e,d[g-1],d[g],a)){var h=tf(e,d[g-1],d[g],a,-this.origin[0],-this.origin[1]);lj(this,h,h.length,a)}}this.b.length>c&&(this.f.push(c),this.i.push(b),this.c.s&&(this.l.push(c),this.c.s=!1))};
function wj(a,b,c,d){ej(b,b.length,d)||(b.push(b[0]),b.push(b[1]));lj(a,b,b.length,d);if(c.length){var e;b=0;for(e=c.length;b<e;++b)ej(c[b],c[b].length,d)||(c[b].push(c[b][0]),c[b].push(c[b][1])),lj(a,c[b],c[b].length,d)}}function xj(a,b,c){c=void 0===c?a.b.length:c;a.f.push(c);a.i.push(b);a.c.s&&(a.l.push(c),a.c.s=!1)}k.ab=function(){this.o=new Ki(this.a);this.j=new Ki(this.b);this.f.push(this.b.length);!this.l.length&&0<this.u.length&&(this.u=[]);this.b=this.a=null};
k.xb=function(a){var b=this.o,c=this.j;return function(){Ni(a,b);Ni(a,c)}};
k.Bf=function(a,b,c,d){var e=Oi(b,gj,ij);if(this.v)var f=this.v;else this.v=f=new jj(a,e);b.Tc(e);a.enableVertexAttribArray(f.l);a.vertexAttribPointer(f.l,2,5126,!1,28,0);a.enableVertexAttribArray(f.b);a.vertexAttribPointer(f.b,2,5126,!1,28,8);a.enableVertexAttribArray(f.o);a.vertexAttribPointer(f.o,2,5126,!1,28,16);a.enableVertexAttribArray(f.g);a.vertexAttribPointer(f.g,1,5126,!1,28,24);a.uniform2fv(f.I,c);a.uniform1f(f.qa,d);return f};
k.Cf=function(a,b){a.disableVertexAttribArray(b.l);a.disableVertexAttribArray(b.b);a.disableVertexAttribArray(b.o);a.disableVertexAttribArray(b.g)};
k.Ud=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(ub(c)){var g=this.f[this.f.length-1];for(c=this.l.length-1;0<=c;--c){var h=this.l[c];var l=this.u[c];yj(this,a,l[0],l[1],l[2]);Ei(a,b,h,g);a.clear(a.DEPTH_BUFFER_BIT);g=h}}else{var m=this.f.length-2;l=g=this.f[m+1];for(h=this.l.length-1;0<=h;--h){var n=this.u[h];yj(this,a,n[0],n[1],n[2]);for(n=this.l[h];0<=m&&this.f[m]>=n;){var p=this.f[m];
var q=this.i[m];q=w(q).toString();c[q]&&(g!==l&&(Ei(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT)),l=p);m--;g=p}g!==l&&(Ei(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT));g=l=n}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
k.Ge=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.l.length-1;0<=f;--f){var m=this.u[f];yj(this,a,m[0],m[1],m[2]);for(g=this.l[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||ob(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),Ei(a,b,m,l),l=d(n)))return l;h--;l=m}}};function yj(a,b,c,d,e){b.uniform4fv(a.v.B,c);b.uniform1f(a.v.pa,d);b.uniform1f(a.v.S,e)}
k.Na=function(a,b){a=b.g;this.c.lineCap=void 0!==a?a:"round";a=b.f;this.c.lineDash=a?a:Gi;a=b.i;this.c.lineDashOffset=a?a:0;a=b.j;this.c.lineJoin=void 0!==a?a:"round";a=b.b;a instanceof CanvasGradient||a instanceof CanvasPattern?a=Hi:a=gd(a).map(function(a,b){return 3!=b?a/255:a})||Hi;var c=b.c;c=void 0!==c?c:1;b=b.l;b=void 0!==b?b:10;this.c.strokeColor&&ma(this.c.strokeColor,a)&&this.c.lineWidth===c&&this.c.miterLimit===b||(this.c.s=!0,this.c.strokeColor=a,this.c.lineWidth=c,this.c.miterLimit=b,
this.u.push([a,c,b]))};var qj=3,nj=5,pj=7,oj=11,rj=13,sj=17,tj=19,uj=23;function zj(){this.b="precision mediump float;uniform vec4 e;uniform float f;void main(void){gl_FragColor=e;float alpha=e.a*f;if(alpha==0.0){discard;}gl_FragColor.a=alpha;}"}v(zj,ti);var Aj=new zj;function Bj(){this.b="attribute vec2 a;uniform mat4 b;uniform mat4 c;uniform mat4 d;void main(void){gl_Position=b*vec4(a,0.0,1.0);}"}v(Bj,ui);var Cj=new Bj;
function Dj(a,b){this.B=a.getUniformLocation(b,"e");this.c=a.getUniformLocation(b,"d");this.i=a.getUniformLocation(b,"c");this.a=a.getUniformLocation(b,"f");this.f=a.getUniformLocation(b,"b");this.b=a.getAttribLocation(b,"a")};function Ej(a){a=a||{};this.b=void 0!==a.color?a.color:null;this.g=a.lineCap;this.f=void 0!==a.lineDash?a.lineDash:null;this.i=a.lineDashOffset;this.j=a.lineJoin;this.l=a.miterLimit;this.c=a.width;this.a=void 0}k=Ej.prototype;k.clone=function(){var a=this.b;return new Ej({color:a&&a.slice?a.slice():a||void 0,lineCap:this.g,lineDash:this.f?this.f.slice():void 0,lineDashOffset:this.i,lineJoin:this.j,miterLimit:this.l,width:this.c})};k.$o=function(){return this.b};k.gl=function(){return this.g};
k.ap=function(){return this.f};k.hl=function(){return this.i};k.il=function(){return this.j};k.nl=function(){return this.l};k.bp=function(){return this.c};k.cp=function(a){this.b=a;this.a=void 0};k.oq=function(a){this.g=a;this.a=void 0};k.setLineDash=function(a){this.f=a;this.a=void 0};k.pq=function(a){this.i=a;this.a=void 0};k.qq=function(a){this.j=a;this.a=void 0};k.tq=function(a){this.l=a;this.a=void 0};k.xq=function(a){this.c=a;this.a=void 0};function Fj(a){this.b=this.a=this.f=void 0;this.i=void 0===a?!0:a;this.c=0}function Gj(a){var b=a.b;if(b){var c=b.next,d=b.yb;c&&(c.yb=d);d&&(d.next=c);a.b=c||d;a.f===a.a?(a.b=void 0,a.f=void 0,a.a=void 0):a.f===b?a.f=a.b:a.a===b&&(a.a=d?a.b.yb:a.b);a.c--}}function Hj(a){a.b=a.f;if(a.b)return a.b.data}function Ij(a){if(a.b&&a.b.next)return a.b=a.b.next,a.b.data}function Jj(a){if(a.b&&a.b.next)return a.b.next.data}function Kj(a){if(a.b&&a.b.yb)return a.b=a.b.yb,a.b.data}
function Lj(a){if(a.b&&a.b.yb)return a.b.yb.data}function Mj(a){if(a.b)return a.b.data}Fj.prototype.concat=function(a){if(a.b){if(this.b){var b=this.b.next;this.b.next=a.f;a.f.yb=this.b;b.yb=a.a;a.a.next=b;this.c+=a.c}else this.b=a.b,this.f=a.f,this.a=a.a,this.c=a.c;a.b=void 0;a.f=void 0;a.a=void 0;a.c=0}};var Nj={ge:function(){}};
(function(a){function b(a,e,f,g,h){f=f||0;g=g||a.length-1;for(h=h||d;g>f;){if(600<g-f){var l=g-f+1,m=e-f+1,n=Math.log(l),p=.5*Math.exp(2*n/3);n=.5*Math.sqrt(n*p*(l-p)/l)*(0>m-l/2?-1:1);b(a,e,Math.max(f,Math.floor(e-m*p/l+n)),Math.min(g,Math.floor(e+(l-m)*p/l+n)),h)}l=a[e];m=f;p=g;c(a,f,e);for(0<h(a[g],l)&&c(a,f,g);m<p;){c(a,m,p);m++;for(p--;0>h(a[m],l);)m++;for(;0<h(a[p],l);)p--}0===h(a[f],l)?c(a,f,p):(p++,c(a,p,g));p<=e&&(f=p+1);e<=p&&(g=p-1)}}function c(a,b,c){var d=a[b];a[b]=a[c];a[c]=d}function d(a,
b){return a<b?-1:a>b?1:0}function e(a,b){if(!(this instanceof e))return new e(a,b);this.Pf=Math.max(4,a||9);this.kh=Math.max(2,Math.ceil(.4*this.Pf));b&&this.pk(b);this.clear()}function f(a,b){g(a,0,a.children.length,b,a)}function g(a,b,c,d,e){e||(e=u(null));e.ca=Infinity;e.ea=Infinity;e.da=-Infinity;e.ha=-Infinity;for(var f;b<c;b++)f=a.children[b],h(e,a.lb?d(f):f);return e}function h(a,b){a.ca=Math.min(a.ca,b.ca);a.ea=Math.min(a.ea,b.ea);a.da=Math.max(a.da,b.da);a.ha=Math.max(a.ha,b.ha)}function l(a,
b){return a.ca-b.ca}function m(a,b){return a.ea-b.ea}function n(a){return(a.da-a.ca)*(a.ha-a.ea)}function p(a){return a.da-a.ca+(a.ha-a.ea)}function q(a,b){return a.ca<=b.ca&&a.ea<=b.ea&&b.da<=a.da&&b.ha<=a.ha}function t(a,b){return b.ca<=a.da&&b.ea<=a.ha&&b.da>=a.ca&&b.ha>=a.ea}function u(a){return{children:a,height:1,lb:!0,ca:Infinity,ea:Infinity,da:-Infinity,ha:-Infinity}}function x(a,b,c,d,e){for(var f=[b,c],g;f.length;)c=f.pop(),b=f.pop(),c-b<=d||(g=b+Math.ceil((c-b)/d/2)*d,B(a,g,b,c,e),f.push(b,
g,g,c))}var B=b;e.prototype={all:function(){return this.fh(this.data,[])},search:function(a){var b=this.data,c=[],d=this.Ab;if(!t(a,b))return c;for(var e=[],f,g,h,l;b;){f=0;for(g=b.children.length;f<g;f++)h=b.children[f],l=b.lb?d(h):h,t(a,l)&&(b.lb?c.push(h):q(a,l)?this.fh(h,c):e.push(h));b=e.pop()}return c},load:function(a){if(!a||!a.length)return this;if(a.length<this.kh){for(var b=0,c=a.length;b<c;b++)this.Ga(a[b]);return this}a=this.hh(a.slice(),0,a.length-1,0);this.data.children.length?this.data.height===
a.height?this.mh(this.data,a):(this.data.height<a.height&&(b=this.data,this.data=a,a=b),this.jh(a,this.data.height-a.height-1,!0)):this.data=a;return this},Ga:function(a){a&&this.jh(a,this.data.height-1);return this},clear:function(){this.data=u([]);return this},remove:function(a,b){if(!a)return this;for(var c=this.data,d=this.Ab(a),e=[],f=[],g,h,l,m;c||e.length;){c||(c=e.pop(),h=e[e.length-1],g=f.pop(),m=!0);if(c.lb){a:{l=a;var n=c.children,p=b;if(p){for(var t=0;t<n.length;t++)if(p(l,n[t])){l=t;
break a}l=-1}else l=n.indexOf(l)}if(-1!==l){c.children.splice(l,1);e.push(c);this.mk(e);break}}m||c.lb||!q(c,d)?h?(g++,c=h.children[g],m=!1):c=null:(e.push(c),f.push(g),g=0,h=c,c=c.children[0])}return this},Ab:function(a){return a},Sf:l,Tf:m,toJSON:function(){return this.data},fh:function(a,b){for(var c=[];a;)a.lb?b.push.apply(b,a.children):c.push.apply(c,a.children),a=c.pop();return b},hh:function(a,b,c,d){var e=c-b+1,g=this.Pf;if(e<=g){var h=u(a.slice(b,c+1));f(h,this.Ab);return h}d||(d=Math.ceil(Math.log(e)/
Math.log(g)),g=Math.ceil(e/Math.pow(g,d-1)));h=u([]);h.lb=!1;h.height=d;e=Math.ceil(e/g);g=e*Math.ceil(Math.sqrt(g));var l;for(x(a,b,c,g,this.Sf);b<=c;b+=g){var m=Math.min(b+g-1,c);x(a,b,m,e,this.Tf);for(l=b;l<=m;l+=e){var n=Math.min(l+e-1,m);h.children.push(this.hh(a,l,n,d-1))}}f(h,this.Ab);return h},lk:function(a,b,c,d){for(var e,f,g,h,l,m,p,q;;){d.push(b);if(b.lb||d.length-1===c)break;p=q=Infinity;e=0;for(f=b.children.length;e<f;e++)g=b.children[e],l=n(g),m=(Math.max(g.da,a.da)-Math.min(g.ca,a.ca))*
(Math.max(g.ha,a.ha)-Math.min(g.ea,a.ea))-l,m<q?(q=m,p=l<p?l:p,h=g):m===q&&l<p&&(p=l,h=g);b=h||b.children[0]}return b},jh:function(a,b,c){var d=this.Ab;c=c?a:d(a);d=[];var e=this.lk(c,this.data,b,d);e.children.push(a);for(h(e,c);0<=b;)if(d[b].children.length>this.Pf)this.uk(d,b),b--;else break;this.ik(c,d,b)},uk:function(a,b){var c=a[b],d=c.children.length,e=this.kh;this.jk(c,e,d);d=this.kk(c,e,d);d=u(c.children.splice(d,c.children.length-d));d.height=c.height;d.lb=c.lb;f(c,this.Ab);f(d,this.Ab);
b?a[b-1].children.push(d):this.mh(c,d)},mh:function(a,b){this.data=u([a,b]);this.data.height=a.height+1;this.data.lb=!1;f(this.data,this.Ab)},kk:function(a,b,c){var d,e;var f=e=Infinity;for(d=b;d<=c-b;d++){var h=g(a,0,d,this.Ab);var l=g(a,d,c,this.Ab);var m=Math.max(0,Math.min(h.da,l.da)-Math.max(h.ca,l.ca))*Math.max(0,Math.min(h.ha,l.ha)-Math.max(h.ea,l.ea));h=n(h)+n(l);if(m<f){f=m;var p=d;e=h<e?h:e}else m===f&&h<e&&(e=h,p=d)}return p},jk:function(a,b,c){var d=a.lb?this.Sf:l,e=a.lb?this.Tf:m,f=this.gh(a,
b,c,d);b=this.gh(a,b,c,e);f<b&&a.children.sort(d)},gh:function(a,b,c,d){a.children.sort(d);d=this.Ab;var e=g(a,0,b,d),f=g(a,c-b,c,d),l=p(e)+p(f),m;for(m=b;m<c-b;m++){var n=a.children[m];h(e,a.lb?d(n):n);l+=p(e)}for(m=c-b-1;m>=b;m--)n=a.children[m],h(f,a.lb?d(n):n),l+=p(f);return l},ik:function(a,b,c){for(;0<=c;c--)h(b[c],a)},mk:function(a){for(var b=a.length-1,c;0<=b;b--)0===a[b].children.length?0<b?(c=a[b-1].children,c.splice(c.indexOf(a[b]),1)):this.clear():f(a[b],this.Ab)},pk:function(a){var b=
["return a"," - b",";"];this.Sf=new Function("a","b",b.join(a[0]));this.Tf=new Function("a","b",b.join(a[1]));this.Ab=new Function("a","return {minX: a"+a[0]+", minY: a"+a[1]+", maxX: a"+a[2]+", maxY: a"+a[3]+"};")}};a["default"]=e})(Nj.ge=Nj.ge||{});Nj.ge=Nj.ge.default;function Oj(a){this.a=Nj.ge(a);this.b={}}k=Oj.prototype;k.Ga=function(a,b){a={ca:a[0],ea:a[1],da:a[2],ha:a[3],value:b};this.a.Ga(a);this.b[w(b)]=a};k.load=function(a,b){for(var c=Array(b.length),d=0,e=b.length;d<e;d++){var f=a[d],g=b[d];f={ca:f[0],ea:f[1],da:f[2],ha:f[3],value:g};c[d]=f;this.b[w(g)]=f}this.a.load(c)};k.remove=function(a){a=w(a);var b=this.b[a];delete this.b[a];return null!==this.a.remove(b)};function Pj(a,b,c){var d=a.b[w(c)];ab([d.ca,d.ea,d.da,d.ha],b)||(a.remove(c),a.Ga(b,c))}
function Qj(a){return a.a.all().map(function(a){return a.value})}function Rj(a,b){return a.a.search({ca:b[0],ea:b[1],da:b[2],ha:b[3]}).map(function(a){return a.value})}k.forEach=function(a,b){return Sj(Qj(this),a,b)};function Tj(a,b,c,d){return Sj(Rj(a,b),c,d)}function Sj(a,b,c){for(var d,e=0,f=a.length;e<f&&!(d=b.call(c,a[e]));e++);return d}k.clear=function(){this.a.clear();this.b={}};k.G=function(a){var b=this.a.data;return Va(b.ca,b.ea,b.da,b.ha,a)};
k.concat=function(a){this.a.load(a.a.all());for(var b in a.b)this.b[b|0]=a.b[b|0]};function Uj(a,b){Ci.call(this,0,b);this.g=new kj(0,b);this.v=null;this.u=[];this.c=[];this.l={fillColor:null,s:!1}}v(Uj,Ci);
function Vj(a,b,c,d){var e=new Fj,f=new Oj;Wj(a,b,d,e,f,!0);b=Xj(e);if(c.length){var g,h=[];var l=0;for(g=c.length;l<g;++l){var m={list:new Fj,wc:void 0,Ug:new Oj};h.push(m);Wj(a,c[l],d,m.list,m.Ug,!1);Yj(m.list,m.Ug,!0);m.wc=Xj(m.list)}h.sort(function(a,b){return b.wc[0]===a.wc[0]?a.wc[1]-b.wc[1]:b.wc[0]-a.wc[0]});for(l=0;l<h.length;++l){c=h[l].list;g=d=Hj(c);do{if(Zj(g,f).length){var n=!0;break}g=Ij(c)}while(d!==g);!n&&ak(c,h[l].wc[0],e,b[0],f)&&(f.concat(h[l].Ug),Yj(e,f,!1))}}else Yj(e,f,!1);bk(a,
e,f)}
function Wj(a,b,c,d,e,f){var g,h=a.a.length/2,l=[],m=[];if(f===Xf(b,0,b.length,c)){var n=f=ck(a,b[0],b[1],h++);var p=c;for(g=b.length;p<g;p+=c){var q=ck(a,b[p],b[p+1],h++);m.push(dk(n,q,d));l.push([Math.min(n.x,q.x),Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]);n=q}}else for(p=b.length-c,n=f=ck(a,b[p],b[p+1],h++),p-=c,g=0;p>=g;p-=c)q=ck(a,b[p],b[p+1],h++),m.push(dk(n,q,d)),l.push([Math.min(n.x,q.x),Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]),n=q;m.push(dk(q,f,d));l.push([Math.min(n.x,q.x),
Math.min(n.y,q.y),Math.max(n.x,q.x),Math.max(n.y,q.y)]);e.load(l,m)}function Xj(a){var b=Hj(a),c=b,d=[c.Z.x,c.Z.y];do c=Ij(a),c.Z.x>d[0]&&(d=[c.Z.x,c.Z.y]);while(c!==b);return d}function Yj(a,b,c){var d=Hj(a),e=d,f=Ij(a),g=!1;do{var h=c?Ii(f.X.x,f.X.y,e.X.x,e.X.y,e.Z.x,e.Z.y):Ii(e.Z.x,e.Z.y,e.X.x,e.X.y,f.X.x,f.X.y);void 0===h?(ek(e,f,a,b),g=!0,f===d&&(d=Jj(a)),f=e,Kj(a)):e.X.Eb!==h&&(e.X.Eb=h,g=!0);e=f;f=Ij(a)}while(e!==d);return g}
function ak(a,b,c,d,e){for(var f=Hj(a);f.X.x!==b;)f=Ij(a);b=f.X;d={x:d,y:b.y,kb:-1};var g=Infinity,h;var l=Zj({Z:b,X:d},e,!0);var m=0;for(h=l.length;m<h;++m){var n=l[m],p=fk(b,d,n.Z,n.X,!0),q=Math.abs(b.x-p[0]);if(q<g&&void 0!==Ii(b.x,b.y,n.Z.x,n.Z.y,n.X.x,n.X.y)){g=q;var t={x:p[0],y:p[1],kb:-1};f=n}}if(Infinity===g)return!1;l=f.X;if(0<g&&(f=gk(b,t,f.X,e),f.length))for(t=Infinity,m=0,h=f.length;m<h;++m)if(g=f[m],n=Math.atan2(b.y-g.y,d.x-g.x),n<t||n===t&&g.x<l.x)t=n,l=g;for(f=Hj(c);f.X.x!==l.x||f.X.y!==
l.y;)f=Ij(c);d={x:b.x,y:b.y,kb:b.kb,Eb:void 0};m={x:f.X.x,y:f.X.y,kb:f.X.kb,Eb:void 0};Jj(a).Z=d;dk(b,f.X,a,e);dk(m,d,a,e);f.X=m;a.i&&a.b&&(a.f=a.b,a.a=a.b.yb);c.concat(a);return!0}
function bk(a,b,c){for(var d=!1,e=hk(b,c);3<b.c;)if(e){if(!ik(a,b,c,e,d)&&!Yj(b,c,d)&&!jk(a,b,c,!0))break}else if(!ik(a,b,c,e,d)&&!Yj(b,c,d)&&!jk(a,b,c))if(e=hk(b,c)){d=b;var f=2*d.c,g=Array(f),h=Hj(d),l=h,m=0;do g[m++]=l.Z.x,g[m++]=l.Z.y,l=Ij(d);while(l!==h);d=!Xf(g,0,f,2);Yj(b,c,d)}else{e=a;d=b;f=g=Hj(d);do{h=Zj(f,c);if(h.length){g=h[0];h=fk(f.Z,f.X,g.Z,g.X);h=ck(e,h[0],h[1],e.a.length/2);l=new Fj;m=new Oj;dk(h,f.X,l,m);f.X=h;Pj(c,[Math.min(f.Z.x,h.x),Math.min(f.Z.y,h.y),Math.max(f.Z.x,h.x),Math.max(f.Z.y,
h.y)],f);for(f=Ij(d);f!==g;)dk(f.Z,f.X,l,m),c.remove(f),Gj(d),f=Mj(d);dk(g.Z,h,l,m);g.Z=h;Pj(c,[Math.min(g.X.x,h.x),Math.min(g.X.y,h.y),Math.max(g.X.x,h.x),Math.max(g.X.y,h.y)],g);Yj(d,c,!1);bk(e,d,c);Yj(l,m,!1);bk(e,l,m);break}f=Ij(d)}while(f!==g);break}3===b.c&&(e=a.b.length,a.b[e++]=Lj(b).Z.kb,a.b[e++]=Mj(b).Z.kb,a.b[e++]=Jj(b).Z.kb)}
function ik(a,b,c,d,e){var f=a.b.length,g=Hj(b),h=Lj(b),l=g,m=Ij(b),n=Jj(b),p=!1;do{var q=l.Z;var t=l.X;var u=m.X;if(!1===t.Eb){var x=d?!gk(q,t,u,c,!0).length:e?kk(n.X,u,t,q,h.Z):kk(h.Z,q,t,u,n.X);!d&&Zj({Z:q,X:u},c).length||!x||!d&&!1!==q.Eb&&!1!==u.Eb&&Xf([h.Z.x,h.Z.y,q.x,q.y,t.x,t.y,u.x,u.y,n.X.x,n.X.y],0,10,2)!==!e||(a.b[f++]=q.kb,a.b[f++]=t.kb,a.b[f++]=u.kb,ek(l,m,b,c),m===g&&(g=n),p=!0)}h=Lj(b);l=Mj(b);m=Ij(b);n=Jj(b)}while(l!==g&&3<b.c);return p}
function jk(a,b,c,d){var e=Hj(b);Ij(b);var f=e,g=Ij(b),h=!1;do{var l=fk(f.Z,f.X,g.Z,g.X,d);if(l){h=a.b.length;var m=a.a.length/2,n=Kj(b);Gj(b);c.remove(n);var p=n===e;d?(l[0]===f.Z.x&&l[1]===f.Z.y?(Kj(b),l=f.Z,g.Z=l,c.remove(f),p=p||f===e):(l=g.X,f.X=l,c.remove(g),p=p||g===e),Gj(b)):(l=ck(a,l[0],l[1],m),f.X=l,g.Z=l,Pj(c,[Math.min(f.Z.x,f.X.x),Math.min(f.Z.y,f.X.y),Math.max(f.Z.x,f.X.x),Math.max(f.Z.y,f.X.y)],f),Pj(c,[Math.min(g.Z.x,g.X.x),Math.min(g.Z.y,g.X.y),Math.max(g.Z.x,g.X.x),Math.max(g.Z.y,
g.X.y)],g));a.b[h++]=n.Z.kb;a.b[h++]=n.X.kb;a.b[h++]=l.kb;h=!0;if(p)break}f=Lj(b);g=Ij(b)}while(f!==e);return h}function hk(a,b){var c=Hj(a),d=c;do{if(Zj(d,b).length)return!1;d=Ij(a)}while(d!==c);return!0}function ck(a,b,c,d){var e=a.a.length;a.a[e++]=b;a.a[e++]=c;return{x:b,y:c,kb:d,Eb:void 0}}
function dk(a,b,c,d){var e={Z:a,X:b},f={yb:void 0,next:void 0,data:e},g=c.b;if(g){var h=g.next;f.yb=g;f.next=h;g.next=f;h&&(h.yb=f);g===c.a&&(c.a=f)}else c.f=f,c.a=f,c.i&&(f.next=f,f.yb=f);c.b=f;c.c++;d&&d.Ga([Math.min(a.x,b.x),Math.min(a.y,b.y),Math.max(a.x,b.x),Math.max(a.y,b.y)],e);return e}function ek(a,b,c,d){Mj(c)===b&&(Gj(c),a.X=b.X,d.remove(b),Pj(d,[Math.min(a.Z.x,a.X.x),Math.min(a.Z.y,a.X.y),Math.max(a.Z.x,a.X.x),Math.max(a.Z.y,a.X.y)],a))}
function gk(a,b,c,d,e){var f,g,h=[],l=Rj(d,[Math.min(a.x,b.x,c.x),Math.min(a.y,b.y,c.y),Math.max(a.x,b.x,c.x),Math.max(a.y,b.y,c.y)]);d=0;for(f=l.length;d<f;++d)for(g in l[d]){var m=l[d][g];"object"!==typeof m||e&&!m.Eb||m.x===a.x&&m.y===a.y||m.x===b.x&&m.y===b.y||m.x===c.x&&m.y===c.y||-1!==h.indexOf(m)||!Rf([a.x,a.y,b.x,b.y,c.x,c.y],0,6,2,m.x,m.y)||h.push(m)}return h}
function Zj(a,b,c){var d=a.Z,e=a.X;b=Rj(b,[Math.min(d.x,e.x),Math.min(d.y,e.y),Math.max(d.x,e.x),Math.max(d.y,e.y)]);var f=[],g;var h=0;for(g=b.length;h<g;++h){var l=b[h];a!==l&&(c||l.Z!==e||l.X!==d)&&fk(d,e,l.Z,l.X,c)&&f.push(l)}return f}
function fk(a,b,c,d,e){var f=(d.y-c.y)*(b.x-a.x)-(d.x-c.x)*(b.y-a.y);if(f&&(d=((d.x-c.x)*(a.y-c.y)-(d.y-c.y)*(a.x-c.x))/f,c=((b.x-a.x)*(a.y-c.y)-(b.y-a.y)*(a.x-c.x))/f,!e&&d>Ji&&d<1-Ji&&c>Ji&&c<1-Ji||e&&0<=d&&1>=d&&0<=c&&1>=c))return[a.x+d*(b.x-a.x),a.y+d*(b.y-a.y)]}
function kk(a,b,c,d,e){if(void 0===b.Eb||void 0===d.Eb)return!1;var f=(c.x-d.x)*(b.y-d.y)>(c.y-d.y)*(b.x-d.x);e=(e.x-d.x)*(b.y-d.y)<(e.y-d.y)*(b.x-d.x);a=(a.x-b.x)*(d.y-b.y)>(a.y-b.y)*(d.x-b.x);c=(c.x-b.x)*(d.y-b.y)<(c.y-b.y)*(d.x-b.x);b=b.Eb?c||a:c&&a;return(d.Eb?e||f:e&&f)&&b}k=Uj.prototype;
k.rc=function(a,b){var c=a.c,d=a.ma(),e=this.b.length,f=this.g.b.length;a=a.ba();var g,h,l;var m=h=0;for(g=c.length;m<g;++m){var n=c[m];if(0<n.length){var p=tf(a,h,n[0],d,-this.origin[0],-this.origin[1]);if(p.length){var q=[];h=1;for(l=n.length;h<l;++h)if(n[h]!==n[h-1]){var t=tf(a,n[h-1],n[h],d,-this.origin[0],-this.origin[1]);q.push(t)}wj(this.g,p,q,d);Vj(this,p,q,d)}}h=n[n.length-1]}this.b.length>e&&(this.f.push(e),this.i.push(b),this.l.s&&(this.c.push(e),this.l.s=!1));this.g.b.length>f&&xj(this.g,
b,f)};k.tc=function(a,b){var c=a.sb(),d=a.ma();if(0<c.length){a=a.ba().map(Number);var e=tf(a,0,c[0],d,-this.origin[0],-this.origin[1]);if(e.length){var f=[],g;var h=1;for(g=c.length;h<g;++h)if(c[h]!==c[h-1]){var l=tf(a,c[h-1],c[h],d,-this.origin[0],-this.origin[1]);f.push(l)}this.f.push(this.b.length);this.i.push(b);this.l.s&&(this.c.push(this.b.length),this.l.s=!1);xj(this.g,b);wj(this.g,e,f,d);Vj(this,e,f,d)}}};
k.ab=function(a){this.o=new Ki(this.a);this.j=new Ki(this.b);this.f.push(this.b.length);this.g.ab(a);!this.c.length&&0<this.u.length&&(this.u=[]);this.b=this.a=null};k.xb=function(a){var b=this.o,c=this.j,d=this.g.xb(a);return function(){Ni(a,b);Ni(a,c);d()}};k.Bf=function(a,b){var c=Oi(b,Aj,Cj);if(this.v)var d=this.v;else this.v=d=new Dj(a,c);b.Tc(c);a.enableVertexAttribArray(d.b);a.vertexAttribPointer(d.b,2,5126,!1,8,0);return d};k.Cf=function(a,b){a.disableVertexAttribArray(b.b)};
k.Ud=function(a,b,c,d){var e=a.getParameter(a.DEPTH_FUNC),f=a.getParameter(a.DEPTH_WRITEMASK);d||(a.enable(a.DEPTH_TEST),a.depthMask(!0),a.depthFunc(a.NOTEQUAL));if(ub(c)){var g=this.f[this.f.length-1];for(c=this.c.length-1;0<=c;--c){var h=this.c[c];var l=this.u[c];a.uniform4fv(this.v.B,l);Ei(a,b,h,g);g=h}}else{var m=this.f.length-2;l=g=this.f[m+1];for(h=this.c.length-1;0<=h;--h){var n=this.u[h];a.uniform4fv(this.v.B,n);for(n=this.c[h];0<=m&&this.f[m]>=n;){var p=this.f[m];var q=this.i[m];q=w(q).toString();
c[q]&&(g!==l&&(Ei(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT)),l=p);m--;g=p}g!==l&&(Ei(a,b,g,l),a.clear(a.DEPTH_BUFFER_BIT));g=l=n}}d||(a.disable(a.DEPTH_TEST),a.clear(a.DEPTH_BUFFER_BIT),a.depthMask(f),a.depthFunc(e))};
k.Ge=function(a,b,c,d,e){var f,g;var h=this.f.length-2;var l=this.f[h+1];for(f=this.c.length-1;0<=f;--f){var m=this.u[f];a.uniform4fv(this.v.B,m);for(g=this.c[f];0<=h&&this.f[h]>=g;){m=this.f[h];var n=this.i[h];var p=w(n).toString();if(void 0===c[p]&&n.W()&&(void 0===e||ob(e,n.W().G()))&&(a.clear(a.COLOR_BUFFER_BIT|a.DEPTH_BUFFER_BIT),Ei(a,b,m,l),l=d(n)))return l;h--;l=m}}};
k.Na=function(a,b){a=a?a.b:[0,0,0,0];a instanceof CanvasGradient||a instanceof CanvasPattern?a=Fi:a=gd(a).map(function(a,b){return 3!=b?a/255:a})||Fi;this.l.fillColor&&ma(a,this.l.fillColor)||(this.l.fillColor=a,this.l.s=!0,this.u.push(a));b?this.g.Na(null,b):this.g.Na(null,new Ej({color:[0,0,0,0],lineWidth:0}))};function lk(a,b){this.b=b;this.a=[{x:0,y:0,width:a,height:a}];this.c={};this.f=ld(a,a);this.i=this.f.canvas}lk.prototype.get=function(a){return this.c[a]||null};
lk.prototype.add=function(a,b,c,d,e){var f;var g=0;for(f=this.a.length;g<f;++g){var h=this.a[g];if(h.width>=b+this.b&&h.height>=c+this.b)return f={offsetX:h.x+this.b,offsetY:h.y+this.b,image:this.i},this.c[a]=f,d.call(e,this.f,h.x+this.b,h.y+this.b),a=g,b+=this.b,d=c+this.b,h.width-b>h.height-d?(c={x:h.x+b,y:h.y,width:h.width-b,height:h.height},b={x:h.x,y:h.y+d,width:b,height:h.height-d},mk(this,a,c,b)):(c={x:h.x+b,y:h.y,width:h.width-b,height:d},b={x:h.x,y:h.y+d,width:h.width,height:h.height-d},
mk(this,a,c,b)),f}return null};function mk(a,b,c,d){b=[b,1];0<c.width&&0<c.height&&b.push(c);0<d.width&&0<d.height&&b.push(d);a.a.splice.apply(a.a,b)};function nk(a){a=a||{};this.a=void 0!==a.initialSize?a.initialSize:256;this.f=void 0!==a.maxSize?a.maxSize:void 0!==ba?ba:2048;this.b=void 0!==a.space?a.space:1;this.g=[new lk(this.a,this.b)];this.c=this.a;this.i=[new lk(this.c,this.b)]}function ok(a,b){var c;var d=0;for(c=a.length;d<c;++d){var e=a[d];if(e=e.get(b))return e}return null}function pk(a,b){return{offsetX:a.offsetX,offsetY:a.offsetY,image:a.image,mm:b.image}}
nk.prototype.add=function(a,b,c,d,e,f){if(b+this.b>this.f||c+this.b>this.f)return null;d=qk(this,!1,a,b,c,d,f);if(!d)return null;a=qk(this,!0,a,b,c,e?e:ra,f);return pk(d,a)};function qk(a,b,c,d,e,f,g){var h=b?a.i:a.g,l;var m=0;for(l=h.length;m<l;++m){var n=h[m];if(n=n.add(c,d,e,f,g))return n;n||m!==l-1||(b?(n=Math.min(2*a.c,a.f),a.c=n):(n=Math.min(2*a.a,a.f),a.a=n),n=new lk(n,a.b),h.push(n),++l)}return null};function rk(a,b){aj.call(this,0,b);this.c=[];this.va=[];this.mc=ld(0,0).canvas;this.R={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:0,miterLimit:void 0,fillColor:null,font:void 0,scale:void 0};this.ua="";this.ga=this.ta=this.oa=this.jb=void 0;this.C={};this.l=void 0;this.opacity=this.scale=1}v(rk,aj);k=rk.prototype;
k.Qb=function(a,b,c,d,e,f){if(this.ua){this.f.push(this.b.length);this.i.push(f);e=this.l;f=this.ua.split("\n");var g=sk(this,f),h,l,m=Math.round(g[0]*this.jb-this.ta),n=Math.round(g[1]*this.oa-this.ga),p=this.R.lineWidth/2*this.R.scale;g=0;for(h=f.length;g<h;++g){var q=0;var t=e.height*g;var u=f[g].split("");var x=0;for(l=u.length;x<l;++x){var B=e.qh;var z=u[x],G=ok(B.g,z);G?(B=ok(B.i,z),B=pk(G,B)):B=null;if(B){G=B.image;this.D=m-q;this.B=n-t;this.I=x?B.offsetX:B.offsetX-p;this.S=B.offsetY;this.height=
e.height;this.width=x&&x!==u.length-1?e.width[u[x]]:e.width[u[x]]+p;this.pa=G.height;this.qa=G.width;this.c.length?(B=this.c[this.c.length-1],w(B)!=w(G)&&(this.v.push(this.b.length),this.c.push(G))):this.c.push(G);B=a;z=b;var E=c,ia=d;for(G=z;G<E;G+=ia)bj(this,B,z,E,ia)}q+=this.width}}}};
function sk(a,b){var c=a.l,d=b.length*c.height;return[b.map(function(b){var d=0,e;var h=0;for(e=b.length;h<e;++h){var l=b[h];c.width[l]||tk(a,l);d+=c.width[l]?c.width[l]:0}return d}).reduce(function(a,b){return Math.max(a,b)}),d]}
function tk(a,b){if(1===b.length){var c=a.l,d=a.R;a=a.mc.getContext("2d");a.font=d.font;a=Math.ceil(a.measureText(b).width*d.scale);c.qh.add(b,a,c.height,function(a,c,g){a.font=d.font;a.fillStyle=d.fillColor;a.strokeStyle=d.strokeColor;a.lineWidth=d.lineWidth;a.lineCap=d.lineCap;a.lineJoin=d.lineJoin;a.miterLimit=d.miterLimit;a.textAlign="left";a.textBaseline="top";Vd&&d.lineDash&&(a.setLineDash(d.lineDash),a.lineDashOffset=d.lineDashOffset);1!==d.scale&&a.setTransform(d.scale,0,0,d.scale,0,0);d.strokeColor&&
a.strokeText(b,c,g);d.fillColor&&a.fillText(b,c,g)})&&(c.width[b]=a)}}k.ab=function(a){var b=a.b;this.v.push(this.b.length);this.u=this.v;this.o=new Ki(this.a);this.j=new Ki(this.b);cj(this.va,this.c,{},b);this.R={strokeColor:null,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:0,miterLimit:void 0,fillColor:null,font:void 0,scale:void 0};this.ua="";this.ga=this.ta=this.oa=this.jb=void 0;this.c=null;this.C={};this.l=void 0;aj.prototype.ab.call(this,a)};
k.gb=function(a){var b=this.R,c=a.Da(),d=a.Ea();if(a&&a.Ja()&&(c||d)){c?(c=c.b,b.fillColor=kd(c?c:Fi)):b.fillColor=null;d?(c=d.b,b.strokeColor=kd(c?c:Hi),b.lineWidth=d.c||1,b.lineCap=d.g||"round",b.lineDashOffset=d.i||0,b.lineJoin=d.j||"round",b.miterLimit=d.l||10,d=d.f,b.lineDash=d?d.slice():Gi):(b.strokeColor=null,b.lineWidth=0);b.font=a.a||"10px sans-serif";b.scale=a.b||1;this.ua=a.Ja();d=uk[a.g];c=uk[a.j];this.jb=void 0===d?.5:d;this.oa=void 0===c?.5:c;this.ta=a.f||0;this.ga=a.c||0;this.rotateWithView=
!!a.l;this.rotation=a.i||0;a=[];for(var e in b)if(b[e]||0===b[e])Array.isArray(b[e])?a=a.concat(b[e]):a.push(b[e]);c="";e=0;for(d=a.length;e<d;++e)c+=a[e];e=c;this.C[e]||(a=this.mc.getContext("2d"),a.font=b.font,a=Math.ceil((1.5*a.measureText("M").width+b.lineWidth/2)*b.scale),this.C[e]={qh:new nk({space:b.lineWidth+1}),width:{},height:a});this.l=this.C[e]}else this.ua=""};k.jg=function(){return this.va};k.dg=function(){return this.va};
var uk={left:0,end:0,center:.5,right:1,start:1,top:0,br:.5,$q:.2,Yq:.8,ar:.8,bottom:1};function vk(a,b,c){this.g=b;this.j=a;this.i=c;this.f={}}v(vk,ri);function wk(a,b){var c=[],d;for(d in a.f){var e=a.f[d],f;for(f in e)c.push(e[f].xb(b))}return function(){for(var a=c.length,b,d=0;d<a;d++)b=c[d].apply(this,arguments);return b}}function xk(a,b){for(var c in a.f){var d=a.f[c],e;for(e in d)d[e].ab(b)}}vk.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0";a=this.f[c];void 0===a&&(a={},this.f[c]=a);c=a[b];void 0===c&&(c=new yk[b](this.j,this.g),a[b]=c);return c};
vk.prototype.c=function(){return ub(this.f)};vk.prototype.Ma=function(a,b,c,d,e,f,g,h){var l=Object.keys(this.f).map(Number);l.sort(fa);var m,n;var p=0;for(m=l.length;p<m;++p){var q=this.f[l[p].toString()];var t=0;for(n=qi.length;t<n;++t){var u=q[qi[t]];void 0!==u&&u.Ma(a,b,c,d,e,f,g,h,void 0,!1)}}};
function zk(a,b,c,d,e,f,g,h,l,m,n){var p=Ak,q=Object.keys(a.f).map(Number);q.sort(function(a,b){return b-a});var t,u;var x=0;for(t=q.length;x<t;++x){var B=a.f[q[x].toString()];for(u=qi.length-1;0<=u;--u){var z=B[qi[u]];if(void 0!==z&&(z=z.Ma(b,c,d,e,p,f,g,h,l,m,n)))return z}}}
vk.prototype.Ha=function(a,b,c,d,e,f,g,h,l,m){var n=b.b;n.bindFramebuffer(n.FRAMEBUFFER,Wi(b));var p;void 0!==this.i&&(p=Oa(Xa(a),d*this.i));return zk(this,b,a,d,e,g,h,l,function(a){var b=new Uint8Array(4);n.readPixels(0,0,1,1,n.RGBA,n.UNSIGNED_BYTE,b);if(0<b[3]&&(a=m(a)))return a},!0,p)};
function Bk(a,b,c,d,e,f,g,h){var l=c.b;l.bindFramebuffer(l.FRAMEBUFFER,Wi(c));return void 0!==zk(a,c,b,d,e,f,g,h,function(){var a=new Uint8Array(4);l.readPixels(0,0,1,1,l.RGBA,l.UNSIGNED_BYTE,a);return 0<a[3]},!1)}var Ak=[1,1],yk={Circle:Mi,Image:dj,LineString:kj,Polygon:Uj,Text:rk};function Ck(a,b,c,d,e,f,g){this.b=a;this.f=b;this.c=f;this.i=g;this.l=e;this.j=d;this.g=c;this.a=this.o=this.v=this.u=null}v(Ck,ci);function Dk(a,b,c,d,e){var f=a.b;b=b.b(0,"Text");b.gb(a.a);b.Qb(c,0,d,e,null,null);b.ab(f);b.Ma(a.b,a.f,a.g,a.j,a.l,a.i,1,{},void 0,!1);b.xb(f)()}k=Ck.prototype;k.xd=function(a){this.Na(a.Da(),a.Ea());this.Vb(a.Y());this.gb(a.Ja())};
k.Cb=function(a){switch(a.T()){case "Point":this.sc(a,null);break;case "LineString":this.oc(a,null);break;case "Polygon":this.tc(a,null);break;case "MultiPoint":this.qc(a,null);break;case "MultiLineString":this.pc(a,null);break;case "MultiPolygon":this.rc(a,null);break;case "GeometryCollection":this.Fe(a,null);break;case "Circle":this.$b(a,null)}};k.Ee=function(a,b){(a=(0,b.$a)(a))&&ob(this.c,a.G())&&(this.xd(b),this.Cb(a))};k.Fe=function(a){a=a.a;var b;var c=0;for(b=a.length;c<b;++c)this.Cb(a[c])};
k.sc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"Image");e.Vb(this.u);e.sc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(b=a.ba(),Dk(this,d,b,b.length,a.ma()))};k.qc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"Image");e.Vb(this.u);e.qc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(b=a.ba(),Dk(this,d,b,b.length,a.ma()))};
k.oc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"LineString");e.Na(null,this.o);e.oc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(a=ki(a),Dk(this,d,a,2,2))};k.pc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"LineString");e.Na(null,this.o);e.pc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(a=li(a),Dk(this,d,a,a.length,2))};
k.tc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"Polygon");e.Na(this.v,this.o);e.tc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(a=ag(a),Dk(this,d,a,2,2))};k.rc=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"Polygon");e.Na(this.v,this.o);e.rc(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&(a=ni(a),Dk(this,d,a,a.length,2))};
k.$b=function(a,b){var c=this.b,d=new vk(1,this.c),e=d.b(0,"Circle");e.Na(this.v,this.o);e.$b(a,b);e.ab(c);e.Ma(this.b,this.f,this.g,this.j,this.l,this.i,1,{},void 0,!1);e.xb(c)();this.a&&Dk(this,d,a.xa(),2,2)};k.Vb=function(a){this.u=a};k.Na=function(a,b){this.v=a;this.o=b};k.gb=function(a){this.a=a};function Ek(){this.c=0;this.b={};this.f=this.a=null}k=Ek.prototype;k.clear=function(){this.c=0;this.b={};this.f=this.a=null};k.forEach=function(a,b){for(var c=this.a;c;)a.call(b,c.bd,c.vc,this),c=c.Lb};k.get=function(a){a=this.b[a];va(!!a,15);if(a===this.f)return a.bd;a===this.a?(this.a=this.a.Lb,this.a.Bd=null):(a.Lb.Bd=a.Bd,a.Bd.Lb=a.Lb);a.Lb=null;a.Bd=this.f;this.f=this.f.Lb=a;return a.bd};
k.pop=function(){var a=this.a;delete this.b[a.vc];a.Lb&&(a.Lb.Bd=null);this.a=a.Lb;this.a||(this.f=null);--this.c;return a.bd};k.replace=function(a,b){this.get(a);this.b[a].bd=b};k.set=function(a,b){va(!(a in this.b),16);b={vc:a,Lb:null,Bd:this.f,bd:b};this.f?this.f.Lb=b:this.a=b;this.f=b;this.b[a]=b;++this.c};function Fk(a,b){Th.call(this,0,b);this.b=document.createElement("CANVAS");this.b.style.width="100%";this.b.style.height="100%";this.b.style.display="block";this.b.className="ol-unselectable";a.insertBefore(this.b,a.childNodes[0]||null);this.R=this.D=0;this.B=ld();this.o=!0;this.f=Nd(this.b,{antialias:!0,depth:!0,failIfMajorPerformanceCaveat:!0,preserveDrawingBuffer:!1,stencil:!0});this.i=new Vi(this.b,this.f);y(this.b,"webglcontextlost",this.no,this);y(this.b,"webglcontextrestored",this.oo,this);
this.a=new Ek;this.u=null;this.j=new Ne(function(a){var b=a[1];a=a[2];var c=b[0]-this.u[0];b=b[1]-this.u[1];return 65536*Math.log(a)+Math.sqrt(c*c+b*b)/a}.bind(this),function(a){return a[0].fb()});this.C=function(){if(this.j.b.length){Re(this.j);var a=Oe(this.j);Gk(this,a[0],a[3],a[4])}return!1}.bind(this);this.g=0;Hk(this)}v(Fk,Th);
function Gk(a,b,c,d){var e=a.f,f=b.fb();if(a.a.b.hasOwnProperty(f))a=a.a.get(f),e.bindTexture(3553,a.Hb),9729!=a.Yh&&(e.texParameteri(3553,10240,9729),a.Yh=9729),9729!=a.$h&&(e.texParameteri(3553,10241,9729),a.$h=9729);else{var g=e.createTexture();e.bindTexture(3553,g);if(0<d){var h=a.B.canvas,l=a.B;a.D!==c[0]||a.R!==c[1]?(h.width=c[0],h.height=c[1],a.D=c[0],a.R=c[1]):l.clearRect(0,0,c[0],c[1]);l.drawImage(b.Y(),d,d,c[0],c[1],0,0,c[0],c[1]);e.texImage2D(3553,0,6408,6408,5121,h)}else e.texImage2D(3553,
0,6408,6408,5121,b.Y());e.texParameteri(3553,10240,9729);e.texParameteri(3553,10241,9729);e.texParameteri(3553,10242,33071);e.texParameteri(3553,10243,33071);a.a.set(f,{Hb:g,Yh:9729,$h:9729})}}function Ik(a,b,c){var d=a.l;if(Tc(d,b)){a=a.i;var e=c.viewState;d.b(new Yh(b,new Ck(a,e.center,e.resolution,e.rotation,c.size,c.extent,c.pixelRatio),c,null,a))}}k=Fk.prototype;k.ka=function(){var a=this.f;a.isContextLost()||this.a.forEach(function(b){b&&a.deleteTexture(b.Hb)});Pc(this.i);Th.prototype.ka.call(this)};
k.Ik=function(a,b){a=this.f;for(var c;1024<this.a.c-this.g;){if(c=this.a.a.bd)a.deleteTexture(c.Hb);else if(+this.a.a.vc==b.index)break;else--this.g;this.a.pop()}};k.T=function(){return"webgl"};k.no=function(a){a.preventDefault();this.a.clear();this.g=0;a=this.c;for(var b in a)a[b].ug()};k.oo=function(){Hk(this);this.l.render()};function Hk(a){a=a.f;a.activeTexture(33984);a.blendFuncSeparate(770,771,1,771);a.disable(2884);a.disable(2929);a.disable(3089);a.disable(2960)}
k.Rg=function(a){var b=this.i,c=this.f;if(c.isContextLost())return!1;if(!a)return this.o&&(this.b.style.display="none",this.o=!1),!1;this.u=a.focus;this.a.set((-a.index).toString(),null);++this.g;Ik(this,"precompose",a);var d=[],e=a.layerStatesArray;na(e);var f=a.viewState.resolution,g;var h=0;for(g=e.length;h<g;++h){var l=e[h];if(Eh(l,f)&&"ready"==l.Ij){var m=Wh(this,l.layer);m.vg(a,l,b)&&d.push(l)}}e=a.size[0]*a.pixelRatio;f=a.size[1]*a.pixelRatio;if(this.b.width!=e||this.b.height!=f)this.b.width=
e,this.b.height=f;c.bindFramebuffer(36160,null);c.clearColor(0,0,0,0);c.clear(16384);c.enable(3042);c.viewport(0,0,this.b.width,this.b.height);h=0;for(g=d.length;h<g;++h)l=d[h],m=Wh(this,l.layer),m.Qi(a,l,b);this.o||(this.b.style.display="",this.o=!0);Uh(a);1024<this.a.c-this.g&&a.postRenderFunctions.push(this.Ik.bind(this));this.j.b.length&&(a.postRenderFunctions.push(this.C),a.animate=!0);Ik(this,"postcompose",a);Xh(this,a);a.postRenderFunctions.push(Vh)};
k.Ha=function(a,b,c,d,e,f,g){if(this.f.isContextLost())return!1;var h=b.viewState,l=b.layerStatesArray,m;for(m=l.length-1;0<=m;--m){var n=l[m];var p=n.layer;if(Eh(n,h.resolution)&&f.call(g,p)&&(n=Wh(this,p).Ha(a,b,c,d,e)))return n}};k.Oi=function(a,b,c,d,e){c=!1;if(this.f.isContextLost())return!1;var f=b.viewState,g=b.layerStatesArray,h;for(h=g.length-1;0<=h;--h){var l=g[h],m=l.layer;if(Eh(l,f.resolution)&&d.call(e,m)&&(c=Wh(this,m).ef(a,b)))return!0}return c};
k.Ni=function(a,b,c,d,e){if(this.f.isContextLost())return!1;var f=b.viewState,g=b.layerStatesArray,h;for(h=g.length-1;0<=h;--h){var l=g[h];var m=l.layer;if(Eh(l,f.resolution)&&e.call(d,m)&&(l=Wh(this,m).tg(a,b,c,d)))return l}};var Jk=["canvas","webgl"];
function H(a){Vc.call(this);var b=Kk(a);this.ed=void 0!==a.loadTilesWhileAnimating?a.loadTilesWhileAnimating:!1;this.Jd=void 0!==a.loadTilesWhileInteracting?a.loadTilesWhileInteracting:!1;this.Hf=void 0!==a.pixelRatio?a.pixelRatio:Ud;this.Lf=b.logos;this.ga=function(){this.j=void 0;this.fq.call(this,Date.now())}.bind(this);this.Ib=Ih();this.Qf=Ih();this.Zb=0;this.C=this.I=this.S=this.g=this.c=null;this.a=document.createElement("DIV");this.a.className="ol-viewport"+(Zd?" ol-touch":"");this.a.style.position=
"relative";this.a.style.overflow="hidden";this.a.style.width="100%";this.a.style.height="100%";this.a.style.msTouchAction="none";this.a.style.touchAction="none";this.B=document.createElement("DIV");this.B.className="ol-overlaycontainer";this.a.appendChild(this.B);this.D=document.createElement("DIV");this.D.className="ol-overlaycontainer-stopevent";for(var c="click dblclick mousedown touchstart MSPointerDown pointerdown mousewheel wheel".split(" "),d=0,e=c.length;d<e;++d)y(this.D,c[d],Rc);this.a.appendChild(this.D);
this.va=new Je(this,a.moveTolerance);for(var f in fe)y(this.va,fe[f],this.Rh,this);this.oa=b.keyboardEventTarget;this.u=null;y(this.a,"wheel",this.rd,this);y(this.a,"mousewheel",this.rd,this);this.o=b.controls;this.l=b.interactions;this.v=b.overlays;this.zg={};this.jc=new b.hq(this.a,this);this.U=null;this.Za=[];this.Sa=new Se(this.Cl.bind(this),this.jm.bind(this));this.ta={};y(this,Xc("layergroup"),this.Ql,this);y(this,Xc("view"),this.km,this);y(this,Xc("size"),this.em,this);y(this,Xc("target"),
this.im,this);this.H(b.values);this.o.forEach(function(a){a.setMap(this)},this);y(this.o,"add",function(a){a.element.setMap(this)},this);y(this.o,"remove",function(a){a.element.setMap(null)},this);this.l.forEach(function(a){a.setMap(this)},this);y(this.l,"add",function(a){a.element.setMap(this)},this);y(this.l,"remove",function(a){a.element.setMap(null)},this);this.v.forEach(this.ph,this);y(this.v,"add",function(a){this.ph(a.element)},this);y(this.v,"remove",function(a){var b=a.element.g;void 0!==
b&&delete this.zg[b.toString()];a.element.setMap(null)},this)}v(H,Vc);k=H.prototype;k.vk=function(a){this.o.push(a)};k.wk=function(a){this.l.push(a)};k.nh=function(a){this.Mc().wd().push(a)};k.oh=function(a){this.v.push(a)};k.ph=function(a){var b=a.g;void 0!==b&&(this.zg[b.toString()]=a);a.setMap(this)};
k.ka=function(){Pc(this.va);Pc(this.jc);Mc(this.a,"wheel",this.rd,this);Mc(this.a,"mousewheel",this.rd,this);this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0);this.j&&(cancelAnimationFrame(this.j),this.j=void 0);this.We(null);Vc.prototype.ka.call(this)};k.Wd=function(a,b,c){if(this.c)return a=this.Xa(a),c=c?c:{},this.jc.Ha(a,this.c,void 0!==c.hitTolerance?c.hitTolerance*this.c.pixelRatio:0,b,null,c.layerFilter?c.layerFilter:pf,null)};
k.Yk=function(a,b){var c=null;this.Wd(a,function(a){c||(c=[]);c.push(a)},b);return c};k.Wm=function(a,b,c,d,e){if(this.c)return this.jc.Ni(a,this.c,b,void 0!==c?c:null,d?d:pf,void 0!==e?e:null)};k.lm=function(a,b){if(!this.c)return!1;a=this.Xa(a);b=b?b:{};return this.jc.Oi(a,this.c,void 0!==b.hitTolerance?b.hitTolerance*this.c.pixelRatio:0,b.layerFilter?b.layerFilter:pf,null)};k.$f=function(a){return this.Xa(this.He(a))};
k.He=function(a){var b=this.a.getBoundingClientRect();a=a.changedTouches?a.changedTouches[0]:a;return[a.clientX-b.left,a.clientY-b.top]};k.ig=function(){return this.get("target")};k.pd=function(){var a=this.ig();return void 0!==a?"string"===typeof a?document.getElementById(a):a:null};k.Xa=function(a){var b=this.c;return b?Nh(b.pixelToCoordinateTransform,a.slice()):null};k.Wk=function(){return this.o};k.rl=function(){return this.v};k.ql=function(a){a=this.zg[a.toString()];return void 0!==a?a:null};
k.dl=function(){return this.l};k.Mc=function(){return this.get("layergroup")};k.fi=function(){return this.Mc().wd()};k.Ka=function(a){var b=this.c;return b?Nh(b.coordinateToPixelTransform,a.slice(0,2)):null};k.Je=function(){return this.jc};k.Mb=function(){return this.get("size")};k.$=function(){return this.get("view")};k.El=function(){return this.a};
k.Cl=function(a,b,c,d){var e=this.c;if(!(e&&b in e.wantedTiles&&e.wantedTiles[b][a.fb()]))return Infinity;a=c[0]-e.focus[0];c=c[1]-e.focus[1];return 65536*Math.log(d)+Math.sqrt(a*a+c*c)/d};k.rd=function(a,b){a=new Ld(b||a.type,this,a);this.Rh(a)};k.Rh=function(a){if(this.c){this.U=a.coordinate;a.frameState=this.c;var b=this.l.a,c;if(!1!==this.b(a))for(c=b.length-1;0<=c;c--){var d=b[c];if(d.c()&&!d.handleEvent(a))break}}};
k.cm=function(){var a=this.c,b=this.Sa;if(b.b.length){var c=16,d=c;if(a){var e=a.viewHints;e[0]&&(c=this.ed?8:0,d=2);e[1]&&(c=this.Jd?8:0,d=2)}b.j<c&&(Re(b),Te(b,c,d))}b=this.Za;c=0;for(d=b.length;c<d;++c)b[c](this,a);b.length=0};k.em=function(){this.render()};
k.im=function(){var a;this.ig()&&(a=this.pd());if(this.u){for(var b=0,c=this.u.length;b<c;++b)Gc(this.u[b]);this.u=null}a?(a.appendChild(this.a),a=this.oa?this.oa:a,this.u=[y(a,"keydown",this.rd,this),y(a,"keypress",this.rd,this)],this.i||(this.i=this.Fd.bind(this),window.addEventListener("resize",this.i,!1))):(nd(this.a),this.i&&(window.removeEventListener("resize",this.i,!1),this.i=void 0));this.Fd()};k.jm=function(){this.render()};k.Uh=function(){this.render()};
k.km=function(){this.S&&(Gc(this.S),this.S=null);this.I&&(Gc(this.I),this.I=null);var a=this.$();a&&(this.a.setAttribute("data-view",w(a)),this.S=y(a,"propertychange",this.Uh,this),this.I=y(a,"change",this.Uh,this));this.render()};k.Ql=function(){this.C&&(this.C.forEach(Gc),this.C=null);var a=this.Mc();a&&(this.C=[y(a,"propertychange",this.render,this),y(a,"change",this.render,this)]);this.render()};k.gq=function(){this.j&&cancelAnimationFrame(this.j);this.ga()};
k.render=function(){void 0===this.j&&(this.j=requestAnimationFrame(this.ga))};k.Zp=function(a){return this.o.remove(a)};k.$p=function(a){return this.l.remove(a)};k.bq=function(a){return this.Mc().wd().remove(a)};k.cq=function(a){return this.v.remove(a)};
k.fq=function(a){var b,c=this.Mb(),d=this.$(),e=Ma(),f=this.c,g=null;if(void 0!==c&&0<c[0]&&0<c[1]&&d&&og(d)){g=ig(d,this.c?this.c.viewHints:void 0);var h=this.Mc().fg(),l={};var m=0;for(b=h.length;m<b;++m)l[w(h[m].layer)]=h[m];m=d.getState();g={animate:!1,attributions:{},coordinateToPixelTransform:this.Ib,extent:e,focus:this.U?this.U:m.center,index:this.Zb++,layerStates:l,layerStatesArray:h,logos:rb({},this.Lf),pixelRatio:this.Hf,pixelToCoordinateTransform:this.Qf,postRenderFunctions:[],size:c,skippedFeatureUids:this.ta,
tileQueue:this.Sa,time:a,usedTiles:{},viewState:m,viewHints:g,wantedTiles:{}}}g&&(g.extent=mb(m.center,m.resolution,m.rotation,g.size,e));this.c=g;this.jc.Rg(g);g&&(g.animate&&this.render(),Array.prototype.push.apply(this.Za,g.postRenderFunctions),!f||this.g&&(ib(this.g)||ab(g.extent,this.g))||(this.b(new Kd("movestart",this,f)),this.g=Wa(this.g)),!this.g||g.viewHints[0]||g.viewHints[1]||ab(g.extent,this.g)||(this.b(new Kd("moveend",this,g)),Pa(g.extent,this.g)));this.b(new Kd("postrender",this,g));
setTimeout(this.cm.bind(this),0)};k.Aj=function(a){this.set("layergroup",a)};k.Yg=function(a){this.set("size",a)};k.We=function(a){this.set("target",a)};k.wq=function(a){this.set("view",a)};k.Hj=function(a){a=w(a).toString();this.ta[a]=!0;this.render()};
k.Fd=function(){var a=this.pd();if(a){var b=getComputedStyle(a);this.Yg([a.offsetWidth-parseFloat(b.borderLeftWidth)-parseFloat(b.paddingLeft)-parseFloat(b.paddingRight)-parseFloat(b.borderRightWidth),a.offsetHeight-parseFloat(b.borderTopWidth)-parseFloat(b.paddingTop)-parseFloat(b.paddingBottom)-parseFloat(b.borderBottomWidth)])}else this.Yg(void 0)};k.Mj=function(a){a=w(a).toString();delete this.ta[a];this.render()};
function Kk(a){var b=null;void 0!==a.keyboardEventTarget&&(b="string"===typeof a.keyboardEventTarget?document.getElementById(a.keyboardEventTarget):a.keyboardEventTarget);var c={},d={};if(void 0===a.logo||"boolean"===typeof a.logo&&a.logo)d["data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAA3NCSVQICAjb4U/gAAAACXBIWXMAAAHGAAABxgEXwfpGAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAhNQTFRF////AP//AICAgP//AFVVQECA////K1VVSbbbYL/fJ05idsTYJFtbbcjbJllmZszWWMTOIFhoHlNiZszTa9DdUcHNHlNlV8XRIVdiasrUHlZjIVZjaMnVH1RlIFRkH1RkH1ZlasvYasvXVsPQH1VkacnVa8vWIVZjIFRjVMPQa8rXIVVkXsXRsNveIFVkIFZlIVVj3eDeh6GmbMvXH1ZkIFRka8rWbMvXIFVkIFVjIFVkbMvWH1VjbMvWIFVlbcvWIFVla8vVIFVkbMvWbMvVH1VkbMvWIFVlbcvWIFVkbcvVbMvWjNPbIFVkU8LPwMzNIFVkbczWIFVkbsvWbMvXIFVkRnB8bcvW2+TkW8XRIFVkIlZlJVloJlpoKlxrLl9tMmJwOWd0Omh1RXF8TneCT3iDUHiDU8LPVMLPVcLPVcPQVsPPVsPQV8PQWMTQWsTQW8TQXMXSXsXRX4SNX8bSYMfTYcfTYsfTY8jUZcfSZsnUaIqTacrVasrVa8jTa8rWbI2VbMvWbcvWdJObdcvUdszUd8vVeJaee87Yfc3WgJyjhqGnitDYjaarldPZnrK2oNbborW5o9bbo9fbpLa6q9ndrL3ArtndscDDutzfu8fJwN7gwt7gxc/QyuHhy+HizeHi0NfX0+Pj19zb1+Tj2uXk29/e3uLg3+Lh3+bl4uXj4ufl4+fl5Ofl5ufl5ujm5+jmySDnBAAAAFp0Uk5TAAECAgMEBAYHCA0NDg4UGRogIiMmKSssLzU7PkJJT1JTVFliY2hrdHZ3foSFhYeJjY2QkpugqbG1tre5w8zQ09XY3uXn6+zx8vT09vf4+Pj5+fr6/P39/f3+gz7SsAAAAVVJREFUOMtjYKA7EBDnwCPLrObS1BRiLoJLnte6CQy8FLHLCzs2QUG4FjZ5GbcmBDDjxJBXDWxCBrb8aM4zbkIDzpLYnAcE9VXlJSWlZRU13koIeW57mGx5XjoMZEUqwxWYQaQbSzLSkYGfKFSe0QMsX5WbjgY0YS4MBplemI4BdGBW+DQ11eZiymfqQuXZIjqwyadPNoSZ4L+0FVM6e+oGI6g8a9iKNT3o8kVzNkzRg5lgl7p4wyRUL9Yt2jAxVh6mQCogae6GmflI8p0r13VFWTHBQ0rWPW7ahgWVcPm+9cuLoyy4kCJDzCm6d8PSFoh0zvQNC5OjDJhQopPPJqph1doJBUD5tnkbZiUEqaCnB3bTqLTFG1bPn71kw4b+GFdpLElKIzRxxgYgWNYc5SCENVHKeUaltHdXx0dZ8uBI1hJ2UUDgq82CM2MwKeibqAvSO7MCABq0wXEPiqWEAAAAAElFTkSuQmCC"]=
"https://openlayers.org/";else{var e=a.logo;"string"===typeof e?d[e]="":e instanceof HTMLElement?d[w(e).toString()]=e:e&&(va("string"==typeof e.href,44),va("string"==typeof e.src,45),d[e.src]=e.href)}e=a.layers instanceof zh?a.layers:new zh({layers:a.layers});c.layergroup=e;c.target=a.target;c.view=void 0!==a.view?a.view:new F;e=Th;var f;void 0!==a.renderer?(Array.isArray(a.renderer)?f=a.renderer:"string"===typeof a.renderer?f=[a.renderer]:va(!1,46),0<=f.indexOf("dom")&&(f=f.concat(Jk))):f=Jk;var g;
var h=0;for(g=f.length;h<g;++h){var l=f[h];if("canvas"==l){if(Wd){e=oi;break}}else if("webgl"==l&&Od){e=Fk;break}}void 0!==a.controls?Array.isArray(a.controls)?f=new $c(a.controls.slice()):(va(a.controls instanceof $c,47),f=a.controls):f=zd();void 0!==a.interactions?Array.isArray(a.interactions)?h=new $c(a.interactions.slice()):(va(a.interactions instanceof $c,48),h=a.interactions):h=wh();void 0!==a.overlays?Array.isArray(a.overlays)?a=new $c(a.overlays.slice()):(va(a.overlays instanceof $c,49),a=
a.overlays):a=new $c;return{controls:f,interactions:h,keyboardEventTarget:b,logos:d,overlays:a,hq:e,values:c}};function Lk(a){Vc.call(this);this.g=a.id;this.o=void 0!==a.insertFirst?a.insertFirst:!0;this.v=void 0!==a.stopEvent?a.stopEvent:!0;this.c=document.createElement("DIV");this.c.className="ol-overlay-container ol-selectable";this.c.style.position="absolute";this.autoPan=void 0!==a.autoPan?a.autoPan:!1;this.j=a.autoPanAnimation||{};this.l=void 0!==a.autoPanMargin?a.autoPanMargin:20;this.a={Ce:"",Te:"",yf:"",Ef:"",visible:!0};this.i=null;y(this,Xc(Mk),this.Ll,this);y(this,Xc(Nk),this.Vl,this);y(this,Xc(Ok),
this.Zl,this);y(this,Xc(Pk),this.am,this);y(this,Xc(Qk),this.bm,this);void 0!==a.element&&this.vj(a.element);this.Bj(void 0!==a.offset?a.offset:[0,0]);this.Ej(void 0!==a.positioning?a.positioning:"top-left");void 0!==a.position&&this.Ye(a.position)}v(Lk,Vc);k=Lk.prototype;k.Yd=function(){return this.get(Mk)};k.Xm=function(){return this.g};k.Xe=function(){return this.get(Nk)};k.Lh=function(){return this.get(Ok)};k.gi=function(){return this.get(Pk)};k.Mh=function(){return this.get(Qk)};
k.Ll=function(){for(var a=this.c;a.lastChild;)a.removeChild(a.lastChild);(a=this.Yd())&&this.c.appendChild(a)};k.Vl=function(){this.i&&(nd(this.c),Gc(this.i),this.i=null);var a=this.Xe();a&&(this.i=y(a,"postrender",this.render,this),Rk(this),a=this.v?a.D:a.B,this.o?a.insertBefore(this.c,a.childNodes[0]||null):a.appendChild(this.c))};k.render=function(){Rk(this)};k.Zl=function(){Rk(this)};
k.am=function(){Rk(this);if(this.get(Pk)&&this.autoPan){var a=this.Xe();if(a&&a.pd()){var b=Sk(a.pd(),a.Mb()),c=this.Yd(),d=c.offsetWidth,e=getComputedStyle(c);d+=parseInt(e.marginLeft,10)+parseInt(e.marginRight,10);e=c.offsetHeight;var f=getComputedStyle(c);e+=parseInt(f.marginTop,10)+parseInt(f.marginBottom,10);var g=Sk(c,[d,e]);c=this.l;Ta(b,g)||(d=g[0]-b[0],e=b[2]-g[2],f=g[1]-b[1],g=b[3]-g[3],b=[0,0],0>d?b[0]=d-c:0>e&&(b[0]=Math.abs(e)+c),0>f?b[1]=f-c:0>g&&(b[1]=Math.abs(g)+c),0===b[0]&&0===b[1])||
(c=a.$().xa(),c=a.Ka(c),b=[c[0]+b[0],c[1]+b[1]],a.$().animate({center:a.Xa(b),duration:this.j.duration,easing:this.j.easing}))}}};k.bm=function(){Rk(this)};k.vj=function(a){this.set(Mk,a)};k.setMap=function(a){this.set(Nk,a)};k.Bj=function(a){this.set(Ok,a)};k.Ye=function(a){this.set(Pk,a)};function Sk(a,b){var c=a.getBoundingClientRect();a=c.left+window.pageXOffset;c=c.top+window.pageYOffset;return[a,c,a+b[0],c+b[1]]}k.Ej=function(a){this.set(Qk,a)};
function Tk(a,b){a.a.visible!==b&&(a.c.style.display=b?"":"none",a.a.visible=b)}
function Rk(a){var b=a.Xe(),c=a.gi();if(b&&b.c&&c){c=b.Ka(c);var d=b.Mb();b=a.c.style;var e=a.Lh(),f=a.Mh();Tk(a,!0);var g=e[0];e=e[1];if("bottom-right"==f||"center-right"==f||"top-right"==f)""!==a.a.Te&&(a.a.Te=b.left=""),g=d[0]-c[0]-g+"px",a.a.yf!=g&&(a.a.yf=b.right=g);else{""!==a.a.yf&&(a.a.yf=b.right="");if("bottom-center"==f||"center-center"==f||"top-center"==f)g-=a.c.offsetWidth/2;g=c[0]+g+"px";a.a.Te!=g&&(a.a.Te=b.left=g)}if("bottom-left"==f||"bottom-center"==f||"bottom-right"==f)""!==a.a.Ef&&
(a.a.Ef=b.top=""),c=d[1]-c[1]-e+"px",a.a.Ce!=c&&(a.a.Ce=b.bottom=c);else{""!==a.a.Ce&&(a.a.Ce=b.bottom="");if("center-left"==f||"center-center"==f||"center-right"==f)e-=a.c.offsetHeight/2;c=c[1]+e+"px";a.a.Ef!=c&&(a.a.Ef=b.top=c)}}else Tk(a,!1)}var Mk="element",Nk="map",Ok="offset",Pk="position",Qk="positioning";function Uk(a){function b(a){a=h.$f(a);l.a.$().rb(a);window.removeEventListener("mousemove",c);window.removeEventListener("mouseup",b)}function c(a){a=h.$f({clientX:a.clientX-n.offsetWidth/2,clientY:a.clientY+n.offsetHeight/2});m.Ye(a)}a=a?a:{};this.j=void 0!==a.collapsed?a.collapsed:!0;this.l=void 0!==a.collapsible?a.collapsible:!0;this.l||(this.j=!1);var d=void 0!==a.className?a.className:"ol-overviewmap",e=void 0!==a.tipLabel?a.tipLabel:"Overview map",f=void 0!==a.collapseLabel?a.collapseLabel:
"\u00ab";"string"===typeof f?(this.u=document.createElement("span"),this.u.textContent=f):this.u=f;f=void 0!==a.label?a.label:"\u00bb";"string"===typeof f?(this.D=document.createElement("span"),this.D.textContent=f):this.D=f;var g=this.l&&!this.j?this.u:this.D;f=document.createElement("button");f.setAttribute("type","button");f.title=e;f.appendChild(g);y(f,"click",this.qn,this);this.B=document.createElement("DIV");this.B.className="ol-overviewmap-map";var h=this.c=new H({controls:new $c,interactions:new $c,
view:a.view});a.layers&&a.layers.forEach(function(a){h.nh(a)},this);e=document.createElement("DIV");e.className="ol-overviewmap-box";e.style.boxSizing="border-box";this.o=new Lk({position:[0,0],positioning:"bottom-left",element:e});this.c.oh(this.o);e=document.createElement("div");e.className=d+" ol-unselectable ol-control"+(this.j&&this.l?" ol-collapsed":"")+(this.l?"":" ol-uncollapsible");e.appendChild(this.B);e.appendChild(f);od.call(this,{element:e,render:a.render?a.render:Vk,target:a.target});
var l=this,m=this.o,n=this.o.Yd();n.addEventListener("mousedown",function(){window.addEventListener("mousemove",c);window.addEventListener("mouseup",b)})}v(Uk,od);k=Uk.prototype;k.setMap=function(a){var b=this.a;a!==b&&(b&&((b=b.$())&&Mc(b,Xc("rotation"),this.Re,this),this.c.We(null)),od.prototype.setMap.call(this,a),a&&(this.c.We(this.B),this.v.push(y(a,"propertychange",this.Wl,this)),this.c.fi().ec()||this.c.Aj(a.Mc()),a=a.$()))&&(y(a,Xc("rotation"),this.Re,this),og(a)&&(this.c.Fd(),Wk(this)))};
k.Wl=function(a){"view"===a.key&&((a=a.oldValue)&&Mc(a,Xc("rotation"),this.Re,this),a=this.a.$(),y(a,Xc("rotation"),this.Re,this))};k.Re=function(){this.c.$().Ze(this.a.$().Qa())};function Vk(){var a=this.a,b=this.c;if(a.c&&b.c){var c=a.Mb();a=a.$().gd(c);var d=b.Mb();c=b.$().gd(d);var e=b.Ka(gb(a)),f=b.Ka(eb(a));b=Math.abs(e[0]-f[0]);e=Math.abs(e[1]-f[1]);f=d[0];d=d[1];b<.1*f||e<.1*d||b>.75*f||e>.75*d?Wk(this):Ta(c,a)||(a=this.c,c=this.a.$(),a.$().rb(c.xa()))}Xk(this)}
function Wk(a){var b=a.a;a=a.c;var c=b.Mb();b=b.$().gd(c);a=a.$();pb(b,1/(.1*Math.pow(2,Math.log(7.5)/Math.LN2/2)));a.Xf(b)}function Xk(a){var b=a.a,c=a.c;if(b.c&&c.c){var d=b.Mb(),e=b.$(),f=c.$();c=e.Qa();b=a.o;var g=a.o.Yd(),h=e.gd(d);d=f.Pa();e=db(h);f=fb(h);if(a=a.a.$().xa()){var l=[e[0]-a[0],e[1]-a[1]];hf(l,c);bf(l,a)}b.Ye(l);g&&(g.style.width=Math.abs((e[0]-f[0])/d)+"px",g.style.height=Math.abs((f[1]-e[1])/d)+"px")}}k.qn=function(a){a.preventDefault();Yk(this)};
function Yk(a){a.element.classList.toggle("ol-collapsed");a.j?md(a.u,a.D):md(a.D,a.u);a.j=!a.j;var b=a.c;a.j||b.c||(b.Fd(),Wk(a),Lc(b,"postrender",function(){Xk(this)},a))}k.pn=function(){return this.l};k.sn=function(a){this.l!==a&&(this.l=a,this.element.classList.toggle("ol-uncollapsible"),!a&&this.j&&Yk(this))};k.rn=function(a){this.l&&this.j!==a&&Yk(this)};k.nn=function(){return this.j};k.sl=function(){return this.c};function Zk(a){a=a?a:{};var b=void 0!==a.className?a.className:"ol-scale-line";this.l=document.createElement("DIV");this.l.className=b+"-inner";this.c=document.createElement("DIV");this.c.className=b+" ol-unselectable";this.c.appendChild(this.l);this.u=null;this.o=void 0!==a.minWidth?a.minWidth:64;this.j=!1;this.C=void 0;this.D="";od.call(this,{element:this.c,render:a.render?a.render:$k,target:a.target});y(this,Xc(al),this.U,this);this.I(a.units||"metric")}v(Zk,od);var bl=[1,2,5];Zk.prototype.B=function(){return this.get(al)};
function $k(a){(a=a.frameState)?this.u=a.viewState:this.u=null;cl(this)}Zk.prototype.U=function(){cl(this)};Zk.prototype.I=function(a){this.set(al,a)};
function cl(a){var b=a.u;if(b){var c=b.center,d=b.projection,e=a.B();b=Ub(d,b.resolution,c,"degrees"==e?"degrees":"m");var f=a.o*b;c="";"degrees"==e?(c=Bb.degrees,"degrees"==d.b?f*=c:b/=c,f<c/60?(c="\u2033",b*=3600):f<c?(c="\u2032",b*=60):c="\u00b0"):"imperial"==e?.9144>f?(c="in",b/=.0254):1609.344>f?(c="ft",b/=.3048):(c="mi",b/=1609.344):"nautical"==e?(b/=1852,c="nm"):"metric"==e?.001>f?(c="\u03bcm",b*=1E6):1>f?(c="mm",b*=1E3):1E3>f?c="m":(c="km",b/=1E3):"us"==e?.9144>f?(c="in",b*=39.37):1609.344>
f?(c="ft",b/=.30480061):(c="mi",b/=1609.3472):va(!1,33);for(e=3*Math.floor(Math.log(a.o*b)/Math.log(10));;){f=bl[(e%3+3)%3]*Math.pow(10,Math.floor(e/3));d=Math.round(f/b);if(isNaN(d)){a.c.style.display="none";a.j=!1;return}if(d>=a.o)break;++e}b=f+" "+c;a.D!=b&&(a.l.innerHTML=b,a.D=b);a.C!=d&&(a.l.style.width=d+"px",a.C=d);a.j||(a.c.style.display="",a.j=!0)}else a.j&&(a.c.style.display="none",a.j=!1)}var al="units";function dl(a){a=a?a:{};this.c=void 0;this.j=el;this.D=this.o=0;this.I=null;this.ta=!1;this.U=void 0!==a.duration?a.duration:200;var b=void 0!==a.className?a.className:"ol-zoomslider",c=document.createElement("button");c.setAttribute("type","button");c.className=b+"-thumb ol-unselectable";var d=document.createElement("div");d.className=b+" ol-unselectable ol-control";d.appendChild(c);this.l=new Ee(d);y(this.l,"pointerdown",this.Kl,this);y(this.l,"pointermove",this.Il,this);y(this.l,"pointerup",this.Jl,
this);y(d,"click",this.Hl,this);y(c,"click",Rc);od.call(this,{element:d,render:a.render?a.render:fl})}v(dl,od);dl.prototype.ka=function(){Pc(this.l);od.prototype.ka.call(this)};var el=0;k=dl.prototype;k.setMap=function(a){od.prototype.setMap.call(this,a);a&&a.render()};
function fl(a){if(a.frameState){if(!this.ta){var b=this.element,c=b.offsetWidth,d=b.offsetHeight,e=b.firstElementChild,f=getComputedStyle(e);b=e.offsetWidth+parseFloat(f.marginRight)+parseFloat(f.marginLeft);e=e.offsetHeight+parseFloat(f.marginTop)+parseFloat(f.marginBottom);this.I=[b,e];c>d?(this.j=1,this.D=c-b):(this.j=el,this.o=d-e);this.ta=!0}a=a.frameState.viewState.resolution;a!==this.c&&(this.c=a,gl(this,a))}}
k.Hl=function(a){var b=this.a.$();a=hl(this,Aa(1===this.j?(a.offsetX-this.I[0]/2)/this.D:(a.offsetY-this.I[1]/2)/this.o,0,1));b.animate({resolution:b.constrainResolution(a),duration:this.U,easing:td})};k.Kl=function(a){this.u||a.b.target!==this.element.firstElementChild||(hg(this.a.$(),1,1),this.B=a.clientX,this.C=a.clientY,this.u=!0)};
k.Il=function(a){if(this.u){var b=this.element.firstElementChild;this.c=hl(this,Aa(1===this.j?(a.clientX-this.B+parseInt(b.style.left,10))/this.D:(a.clientY-this.C+parseInt(b.style.top,10))/this.o,0,1));this.a.$().Yc(this.c);gl(this,this.c);this.B=a.clientX;this.C=a.clientY}};k.Jl=function(){if(this.u){var a=this.a.$();hg(a,1,-1);a.animate({resolution:a.constrainResolution(this.c),duration:this.U,easing:td});this.u=!1;this.C=this.B=void 0}};
function gl(a,b){b=1-ng(a.a.$())(b);var c=a.element.firstElementChild;1==a.j?c.style.left=a.D*b+"px":c.style.top=a.o*b+"px"}function hl(a,b){return mg(a.a.$())(1-b)};function il(a){a=a?a:{};this.c=a.extent?a.extent:null;var b=void 0!==a.className?a.className:"ol-zoom-extent",c=void 0!==a.label?a.label:"E",d=void 0!==a.tipLabel?a.tipLabel:"Fit to extent",e=document.createElement("button");e.setAttribute("type","button");e.title=d;e.appendChild("string"===typeof c?document.createTextNode(c):c);y(e,"click",this.j,this);c=document.createElement("div");c.className=b+" ol-unselectable ol-control";c.appendChild(e);od.call(this,{element:c,target:a.target})}v(il,od);
il.prototype.j=function(a){a.preventDefault();a=this.a.$();var b=this.c?this.c:a.v.G();a.Xf(b)};function jl(a){Vc.call(this);a=a?a:{};this.a=null;y(this,Xc(kl),this.Jm,this);this.og(void 0!==a.tracking?a.tracking:!1)}v(jl,Vc);k=jl.prototype;k.ka=function(){this.og(!1);Vc.prototype.ka.call(this)};
k.op=function(a){if(null!==a.alpha){var b=Fa(a.alpha);this.set(ll,b);"boolean"===typeof a.absolute&&a.absolute?this.set(ml,b):"number"===typeof a.webkitCompassHeading&&-1!=a.webkitCompassAccuracy&&this.set(ml,Fa(a.webkitCompassHeading))}null!==a.beta&&this.set(nl,Fa(a.beta));null!==a.gamma&&this.set(pl,Fa(a.gamma));this.s()};k.Qk=function(){return this.get(ll)};k.Tk=function(){return this.get(nl)};k.$k=function(){return this.get(pl)};k.Im=function(){return this.get(ml)};k.bi=function(){return this.get(kl)};
k.Jm=function(){if(Xd){var a=this.bi();a&&!this.a?this.a=y(window,"deviceorientation",this.op,this):a||null===this.a||(Gc(this.a),this.a=null)}};k.og=function(a){this.set(kl,a)};var ll="alpha",nl="beta",pl="gamma",ml="heading",kl="tracking";function ql(a){this.i=a.opacity;this.o=a.rotateWithView;this.g=a.rotation;this.a=a.scale;this.v=a.snapToPixel}k=ql.prototype;k.jf=function(){return this.i};k.kf=function(){return this.o};k.lf=function(){return this.g};k.mf=function(){return this.a};k.Le=function(){return this.v};k.zd=function(a){this.i=a};k.nf=function(a){this.g=a};k.Ad=function(a){this.a=a};function rl(a){this.D=this.u=this.c=null;this.Wa=void 0!==a.fill?a.fill:null;this.pa=[0,0];this.l=a.points;this.b=void 0!==a.radius?a.radius:a.radius1;this.f=a.radius2;this.j=void 0!==a.angle?a.angle:0;this.Ua=void 0!==a.stroke?a.stroke:null;this.C=this.qa=this.B=null;this.R=a.atlasManager;sl(this,this.R);ql.call(this,{opacity:1,rotateWithView:void 0!==a.rotateWithView?a.rotateWithView:!1,rotation:void 0!==a.rotation?a.rotation:0,scale:1,snapToPixel:void 0!==a.snapToPixel?a.snapToPixel:!0})}
v(rl,ql);k=rl.prototype;k.clone=function(){var a=new rl({fill:this.Da()?this.Da().clone():void 0,points:this.l,radius:this.b,radius2:this.f,angle:this.j,snapToPixel:this.v,stroke:this.Ea()?this.Ea().clone():void 0,rotation:this.g,rotateWithView:this.o,atlasManager:this.R});a.zd(this.i);a.Ad(this.a);return a};k.Jc=function(){return this.B};k.Zi=function(){return this.j};k.Da=function(){return this.Wa};k.yg=function(){return this.D};k.Y=function(){return this.u};k.Ie=function(){return this.C};
k.hf=function(){return 2};k.Rc=function(){return this.pa};k.$i=function(){return this.l};k.aj=function(){return this.b};k.Nh=function(){return this.f};k.ic=function(){return this.qa};k.Ea=function(){return this.Ua};k.Wh=function(){};k.load=function(){};k.Lj=function(){};
function sl(a,b){var c="",d="",e=0,f=null,g=0,h=0;if(a.Ua){var l=a.Ua.b;null===l&&(l=ai);l=kd(l);h=a.Ua.c;void 0===h&&(h=1);f=a.Ua.f;g=a.Ua.i;Vd||(f=null,g=0);d=a.Ua.j;void 0===d&&(d="round");c=a.Ua.g;void 0===c&&(c="round");e=a.Ua.l;void 0===e&&(e=10)}var m=2*(a.b+h)+1;c={strokeStyle:l,Jj:h,size:m,lineCap:c,lineDash:f,lineDashOffset:g,lineJoin:d,miterLimit:e};if(void 0===b){var n=ld(m,m);a.u=n.canvas;b=m=a.u.width;a.yh(c,n,0,0);a.Wa?a.D=a.u:(n=ld(c.size,c.size),a.D=n.canvas,a.xh(c,n,0,0))}else m=
Math.round(m),(d=!a.Wa)&&(n=a.xh.bind(a,c)),a.Ua?(e=a.Ua,void 0===e.a&&(e.a="s",e.a=e.b?"string"===typeof e.b?e.a+e.b:e.a+w(e.b).toString():e.a+"-",e.a+=","+(void 0!==e.g?e.g.toString():"-")+","+(e.f?e.f.toString():"-")+","+(void 0!==e.i?e.i:"-")+","+(void 0!==e.j?e.j:"-")+","+(void 0!==e.l?e.l.toString():"-")+","+(void 0!==e.c?e.c.toString():"-")),e=e.a):e="-",a.Wa?(f=a.Wa,void 0===f.a&&(f.a=f.b instanceof CanvasPattern||f.b instanceof CanvasGradient?w(f.b).toString():"f"+(f.b?id(f.b):"-")),f=f.a):
f="-",a.c&&e==a.c[1]&&f==a.c[2]&&a.b==a.c[3]&&a.f==a.c[4]&&a.j==a.c[5]&&a.l==a.c[6]||(a.c=["r"+e+f+(void 0!==a.b?a.b.toString():"-")+(void 0!==a.f?a.f.toString():"-")+(void 0!==a.j?a.j.toString():"-")+(void 0!==a.l?a.l.toString():"-"),e,f,a.b,a.f,a.j,a.l]),n=b.add(a.c[0],m,m,a.yh.bind(a,c),n),a.u=n.image,a.pa=[n.offsetX,n.offsetY],b=n.image.width,a.D=d?n.mm:a.u;a.B=[m/2,m/2];a.qa=[m,m];a.C=[b,b]}
k.yh=function(a,b,c,d){b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();var e=this.l;if(Infinity===e)b.arc(a.size/2,a.size/2,this.b,0,2*Math.PI,!0);else{var f=void 0!==this.f?this.f:this.b;f!==this.b&&(e*=2);for(c=0;c<=e;c++){d=2*c*Math.PI/e-Math.PI/2+this.j;var g=c%2?f:this.b;b.lineTo(a.size/2+g*Math.cos(d),a.size/2+g*Math.sin(d))}}this.Wa&&(c=this.Wa.b,null===c&&(c=Zh),b.fillStyle=kd(c),b.fill());this.Ua&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Jj,a.lineDash&&(b.setLineDash(a.lineDash),
b.lineDashOffset=a.lineDashOffset),b.lineCap=a.lineCap,b.lineJoin=a.lineJoin,b.miterLimit=a.miterLimit,b.stroke());b.closePath()};
k.xh=function(a,b,c,d){b.setTransform(1,0,0,1,0,0);b.translate(c,d);b.beginPath();c=this.l;if(Infinity===c)b.arc(a.size/2,a.size/2,this.b,0,2*Math.PI,!0);else{d=void 0!==this.f?this.f:this.b;d!==this.b&&(c*=2);var e;for(e=0;e<=c;e++){var f=2*e*Math.PI/c-Math.PI/2+this.j;var g=e%2?d:this.b;b.lineTo(a.size/2+g*Math.cos(f),a.size/2+g*Math.sin(f))}}b.fillStyle=Zh;b.fill();this.Ua&&(b.strokeStyle=a.strokeStyle,b.lineWidth=a.Jj,a.lineDash&&(b.setLineDash(a.lineDash),b.lineDashOffset=a.lineDashOffset),b.stroke());
b.closePath()};function tl(a){a=a||{};rl.call(this,{points:Infinity,fill:a.fill,radius:a.radius,snapToPixel:a.snapToPixel,stroke:a.stroke,atlasManager:a.atlasManager})}v(tl,rl);tl.prototype.clone=function(){var a=new tl({fill:this.Da()?this.Da().clone():void 0,stroke:this.Ea()?this.Ea().clone():void 0,radius:this.b,snapToPixel:this.v,atlasManager:this.R});a.zd(this.i);a.Ad(this.a);return a};tl.prototype.Xc=function(a){this.b=a;sl(this,this.R)};function ul(a){a=a||{};this.b=void 0!==a.color?a.color:null;this.a=void 0}ul.prototype.clone=function(){var a=this.b;return new ul({color:a&&a.slice?a.slice():a||void 0})};ul.prototype.f=function(){return this.b};ul.prototype.c=function(a){this.b=a;this.a=void 0};function vl(a){a=a||{};this.Ic=null;this.$a=wl;void 0!==a.geometry&&this.Ra(a.geometry);this.Wa=void 0!==a.fill?a.fill:null;this.M=void 0!==a.image?a.image:null;this.jc=a.renderer?a.renderer:null;this.Ua=void 0!==a.stroke?a.stroke:null;this.ua=void 0!==a.text?a.text:null;this.Pj=a.zIndex}k=vl.prototype;
k.clone=function(){var a=this.W();a&&a.clone&&(a=a.clone());return new vl({geometry:a,fill:this.Da()?this.Da().clone():void 0,image:this.Y()?this.Y().clone():void 0,stroke:this.Ea()?this.Ea().clone():void 0,text:this.Ja()?this.Ja().clone():void 0,zIndex:this.za()})};k.Je=function(){return this.jc};k.uq=function(a){this.jc=a};k.W=function(){return this.Ic};k.al=function(){return this.$a};k.Da=function(){return this.Wa};k.zf=function(a){this.Wa=a};k.Y=function(){return this.M};
k.Wg=function(a){this.M=a};k.Ea=function(){return this.Ua};k.Af=function(a){this.Ua=a};k.Ja=function(){return this.ua};k.Dd=function(a){this.ua=a};k.za=function(){return this.Pj};k.Ra=function(a){"function"===typeof a?this.$a=a:"string"===typeof a?this.$a=function(b){return b.get(a)}:a?a&&(this.$a=function(){return a}):this.$a=wl;this.Ic=a};k.Wb=function(a){this.Pj=a};
function xl(a){if("function"!==typeof a){if(Array.isArray(a))var b=a;else va(a instanceof vl,41),b=[a];a=function(){return b}}return a}var yl=null;function zl(){if(!yl){var a=new ul({color:"rgba(255,255,255,0.4)"}),b=new Ej({color:"#3399CC",width:1.25});yl=[new vl({image:new tl({fill:a,stroke:b,radius:5}),fill:a,stroke:b})]}return yl}
function Al(){var a={},b=[255,255,255,1],c=[0,153,255,1];a.Polygon=[new vl({fill:new ul({color:[255,255,255,.5]})})];a.MultiPolygon=a.Polygon;a.LineString=[new vl({stroke:new Ej({color:b,width:5})}),new vl({stroke:new Ej({color:c,width:3})})];a.MultiLineString=a.LineString;a.Circle=a.Polygon.concat(a.LineString);a.Point=[new vl({image:new tl({radius:6,fill:new ul({color:c}),stroke:new Ej({color:b,width:1.5})}),zIndex:Infinity})];a.MultiPoint=a.Point;a.GeometryCollection=a.Polygon.concat(a.LineString,
a.Point);return a}function wl(a){return a.W()};function Bl(a){Vc.call(this);this.a=void 0;this.c="geometry";this.g=null;this.j=void 0;this.i=null;y(this,Xc(this.c),this.Pe,this);void 0!==a&&(a instanceof rf||!a?this.Ra(a):this.H(a))}v(Bl,Vc);k=Bl.prototype;k.clone=function(){var a=new Bl(this.N());a.Wc(this.c);var b=this.W();b&&a.Ra(b.clone());(b=this.g)&&a.pg(b);return a};k.W=function(){return this.get(this.c)};k.Km=function(){return this.a};k.bl=function(){return this.c};k.Lm=function(){return this.g};k.bb=function(){return this.j};k.Ml=function(){this.s()};
k.Pe=function(){this.i&&(Gc(this.i),this.i=null);var a=this.W();a&&(this.i=y(a,"change",this.Ml,this));this.s()};k.Ra=function(a){this.set(this.c,a)};k.pg=function(a){this.j=(this.g=a)?Cl(a):void 0;this.s()};k.kc=function(a){this.a=a;this.s()};k.Wc=function(a){Mc(this,Xc(this.c),this.Pe,this);this.c=a;y(this,Xc(this.c),this.Pe,this);this.Pe()};
function Cl(a){var b;if("function"===typeof a)2==a.length?b=function(b){return a(this,b)}:b=a;else{if(Array.isArray(a))var c=a;else va(a instanceof vl,41),c=[a];b=function(){return c}}return b};var Dl=document.implementation.createDocument("","",null);function El(a,b){return Dl.createElementNS(a,b)}function Fl(a,b){return Gl(a,b,[]).join("")}function Gl(a,b,c){if(a.nodeType==Node.CDATA_SECTION_NODE||a.nodeType==Node.TEXT_NODE)b?c.push(String(a.nodeValue).replace(/(\r\n|\r|\n)/g,"")):c.push(a.nodeValue);else for(a=a.firstChild;a;a=a.nextSibling)Gl(a,b,c);return c}function Hl(a){return a instanceof Document}function Il(a){return a instanceof Node}
function Jl(a){return(new DOMParser).parseFromString(a,"application/xml")}function Kl(a,b){return function(c,d){c=a.call(b,c,d);void 0!==c&&ka(d[d.length-1],c)}}function Ll(a,b){return function(c,d){c=a.call(void 0!==b?b:this,c,d);void 0!==c&&d[d.length-1].push(c)}}function Nl(a,b){return function(c,d){c=a.call(void 0!==b?b:this,c,d);void 0!==c&&(d[d.length-1]=c)}}
function Ol(a){return function(b,c){var d=a.call(this,b,c);if(void 0!==d){c=c[c.length-1];b=b.localName;var e;b in c?e=c[b]:e=c[b]=[];e.push(d)}}}function I(a,b){return function(c,d){var e=a.call(this,c,d);void 0!==e&&(d[d.length-1][void 0!==b?b:c.localName]=e)}}function J(a,b){return function(c,d,e){a.call(void 0!==b?b:this,c,d,e);e[e.length-1].node.appendChild(c)}}
function Pl(a){var b,c;return function(d,e,f){if(!b){b={};var g={};g[d.localName]=a;b[d.namespaceURI]=g;c=Ql(d.localName)}Rl(b,c,e,f)}}function Ql(a,b){return function(c,d,e){c=d[d.length-1].node;d=a;void 0===d&&(d=e);e=b;void 0===b&&(e=c.namespaceURI);return El(e,d)}}var Sl=Ql();function Tl(a,b){for(var c=b.length,d=Array(c),e=0;e<c;++e)d[e]=a[b[e]];return d}function K(a,b,c){c=void 0!==c?c:{};var d;var e=0;for(d=a.length;e<d;++e)c[a[e]]=b;return c}
function Ul(a,b,c,d){for(b=b.firstElementChild;b;b=b.nextElementSibling){var e=a[b.namespaceURI];void 0!==e&&(e=e[b.localName])&&e.call(d,b,c)}}function L(a,b,c,d,e){d.push(a);Ul(b,c,d,e);return d.pop()}function Rl(a,b,c,d,e,f){for(var g=(void 0!==e?e:c).length,h,l,m=0;m<g;++m)h=c[m],void 0!==h&&(l=b.call(f,h,d,void 0!==e?e[m]:void 0),void 0!==l&&a[l.namespaceURI][l.localName].call(f,l,h,d))}function Vl(a,b,c,d,e,f,g){e.push(a);Rl(b,c,d,e,f,g);e.pop()};function Wl(a,b,c,d){return function(e,f,g){var h=new XMLHttpRequest;h.open("GET","function"===typeof a?a(e,f,g):a,!0);"arraybuffer"==b.T()&&(h.responseType="arraybuffer");h.onload=function(){if(!h.status||200<=h.status&&300>h.status){var a=b.T();if("json"==a||"text"==a)var e=h.responseText;else"xml"==a?(e=h.responseXML)||(e=Jl(h.responseText)):"arraybuffer"==a&&(e=h.response);e?c.call(this,b.Oa(e,{featureProjection:g}),b.ob(e),b.eg()):d.call(this)}else d.call(this)}.bind(this);h.onerror=function(){d.call(this)}.bind(this);
h.send()}}function Xl(a,b){return Wl(a,b,function(a){this.Ec(a)},ra)};function Yl(){this.i=this.defaultDataProjection=null}function Zl(a,b,c){var d;c&&(d={dataProjection:c.dataProjection?c.dataProjection:a.ob(b),featureProjection:c.featureProjection});return $l(a,d)}function $l(a,b){return rb({dataProjection:a.defaultDataProjection,featureProjection:a.i},b)}Yl.prototype.eg=function(){return null};
function am(a,b,c){var d=c?Wb(c.featureProjection):null,e=c?Wb(c.dataProjection):null,f;d&&e&&!ec(d,e)?a instanceof rf?f=(b?a.clone():a).mb(b?d:e,b?e:d):f=ic(a,e,d):f=a;if(b&&c&&void 0!==c.decimals){var g=Math.pow(10,c.decimals);f===a&&(f=f.clone());f.Fc(function(a){for(var b=0,c=a.length;b<c;++b)a[b]=Math.round(a[b]*g)/g;return a})}return f};function bm(){Yl.call(this)}v(bm,Yl);function cm(a){return"string"===typeof a?(a=JSON.parse(a))?a:null:null!==a?a:null}k=bm.prototype;k.T=function(){return"json"};k.Ub=function(a,b){return this.Uc(cm(a),Zl(this,a,b))};k.Oa=function(a,b){return this.Gg(cm(a),Zl(this,a,b))};k.Vc=function(a,b){return this.Kg(cm(a),Zl(this,a,b))};k.ob=function(a){return this.Ng(cm(a))};k.Gd=function(a,b){return JSON.stringify(this.cd(a,b))};k.Xb=function(a,b){return JSON.stringify(this.se(a,b))};
k.dd=function(a,b){return JSON.stringify(this.ue(a,b))};function dm(a,b,c,d,e,f){var g=NaN,h=NaN,l=(c-b)/d;if(1===l)g=a[b],h=a[b+1];else if(2==l)g=(1-e)*a[b]+e*a[b+d],h=(1-e)*a[b+1]+e*a[b+d+1];else if(l){h=a[b];l=a[b+1];var m=0;g=[0];var n;for(n=b+d;n<c;n+=d){var p=a[n],q=a[n+1];m+=Math.sqrt((p-h)*(p-h)+(q-l)*(q-l));g.push(m);h=p;l=q}c=e*m;l=0;m=g.length;for(n=!1;l<m;)e=l+(m-l>>1),h=+fa(g[e],c),0>h?l=e+1:(m=e,n=!h);e=n?l:~l;0>e?(c=(c-g[-e-2])/(g[-e-1]-g[-e-2]),b+=(-e-2)*d,g=Ha(a[b],a[b+d],c),h=Ha(a[b+1],a[b+d+1],c)):(g=a[b+e*d],h=a[b+e*d+1])}return f?
(f[0]=g,f[1]=h,f):[g,h]}function em(a,b,c,d,e,f){if(c==b)return null;if(e<a[b+d-1])return f?(c=a.slice(b,b+d),c[d-1]=e,c):null;if(a[c-1]<e)return f?(c=a.slice(c-d,c),c[d-1]=e,c):null;if(e==a[b+d-1])return a.slice(b,b+d);b/=d;for(c/=d;b<c;)f=b+c>>1,e<a[(f+1)*d-1]?c=f:b=f+1;c=a[b*d-1];if(e==c)return a.slice((b-1)*d,(b-1)*d+d);f=(e-c)/(a[(b+1)*d-1]-c);c=[];var g;for(g=0;g<d-1;++g)c.push(Ha(a[(b-1)*d+g],a[b*d+g],f));c.push(e);return c}
function fm(a,b,c,d,e,f){var g=0;if(f)return em(a,g,b[b.length-1],c,d,e);if(d<a[c-1])return e?(a=a.slice(0,c),a[c-1]=d,a):null;if(a[a.length-1]<d)return e?(a=a.slice(a.length-c),a[c-1]=d,a):null;e=0;for(f=b.length;e<f;++e){var h=b[e];if(g!=h){if(d<a[g+c-1])break;else if(d<=a[h-1])return em(a,g,h,c,d,!1);g=h}}return null};function M(a,b){uf.call(this);this.c=null;this.u=this.D=this.j=-1;this.na(a,b)}v(M,uf);k=M.prototype;k.xk=function(a){this.A?ka(this.A,a):this.A=a.slice();this.s()};k.clone=function(){var a=new M(null);a.aa(this.ja,this.A.slice());return a};k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;this.u!=this.f&&(this.D=Math.sqrt(Bf(this.A,0,this.A.length,this.a,0)),this.u=this.f);return Df(this.A,0,this.A.length,this.a,this.D,!1,a,b,c,d)};
k.Nk=function(a,b){return Uf(this.A,0,this.A.length,this.a,a,b)};k.Dn=function(a,b){return"XYM"!=this.ja&&"XYZM"!=this.ja?null:em(this.A,0,this.A.length,this.a,a,void 0!==b?b:!1)};k.V=function(){return If(this.A,0,this.A.length,this.a)};k.Eh=function(a,b){return dm(this.A,0,this.A.length,this.a,a,b)};k.En=function(){var a=this.A,b=this.a,c=a[0],d=a[1],e=0,f;for(f=0+b;f<this.A.length;f+=b){var g=a[f],h=a[f+1];e+=Math.sqrt((g-c)*(g-c)+(h-d)*(h-d));c=g;d=h}return e};
function ki(a){a.j!=a.f&&(a.c=a.Eh(.5,a.c),a.j=a.f);return a.c}k.od=function(a){var b=[];b.length=Lf(this.A,0,this.A.length,this.a,a,b,0);a=new M(null);a.aa("XY",b);return a};k.T=function(){return"LineString"};k.Ya=function(a){return Vf(this.A,0,this.A.length,this.a,a)};k.na=function(a,b){a?(xf(this,b,a,1),this.A||(this.A=[]),this.A.length=Gf(this.A,0,a,this.a),this.s()):this.aa("XY",null)};k.aa=function(a,b){wf(this,a,b);this.s()};function N(a,b){uf.call(this);this.c=[];this.j=this.u=-1;this.na(a,b)}v(N,uf);k=N.prototype;k.yk=function(a){this.A?ka(this.A,a.ba().slice()):this.A=a.ba().slice();this.c.push(this.A.length);this.s()};k.clone=function(){var a=new N(null);a.aa(this.ja,this.A.slice(),this.c.slice());return a};k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;this.j!=this.f&&(this.u=Math.sqrt(Cf(this.A,0,this.c,this.a,0)),this.j=this.f);return Ef(this.A,0,this.c,this.a,this.u,!1,a,b,c,d)};
k.Gn=function(a,b,c){return"XYM"!=this.ja&&"XYZM"!=this.ja||!this.A.length?null:fm(this.A,this.c,this.a,a,void 0!==b?b:!1,void 0!==c?c:!1)};k.V=function(){return Jf(this.A,0,this.c,this.a)};k.sb=function(){return this.c};k.jl=function(a){if(0>a||this.c.length<=a)return null;var b=new M(null);b.aa(this.ja,this.A.slice(a?this.c[a-1]:0,this.c[a]));return b};
k.ld=function(){var a=this.A,b=this.c,c=this.ja,d=[],e=0,f;var g=0;for(f=b.length;g<f;++g){var h=b[g],l=new M(null);l.aa(c,a.slice(e,h));d.push(l);e=h}return d};function li(a){var b=[],c=a.A,d=0,e=a.c;a=a.a;var f;var g=0;for(f=e.length;g<f;++g){var h=e[g];d=dm(c,d,h,a,.5);ka(b,d);d=h}return b}k.od=function(a){var b=[],c=[],d=this.A,e=this.c,f=this.a,g=0,h=0,l;var m=0;for(l=e.length;m<l;++m){var n=e[m];h=Lf(d,g,n,f,a,b,h);c.push(h);g=n}b.length=h;a=new N(null);a.aa("XY",b,c);return a};k.T=function(){return"MultiLineString"};
k.Ya=function(a){a:{var b=this.A,c=this.c,d=this.a,e=0,f;var g=0;for(f=c.length;g<f;++g){if(Vf(b,e,c[g],d,a)){a=!0;break a}e=c[g]}a=!1}return a};k.na=function(a,b){a?(xf(this,b,a,2),this.A||(this.A=[]),a=Hf(this.A,0,a,this.a,this.c),this.A.length=a.length?a[a.length-1]:0,this.s()):this.aa("XY",null,this.c)};k.aa=function(a,b,c){wf(this,a,b);this.c=c;this.s()};function gm(a,b){var c=a.ja,d=[],e=[],f;var g=0;for(f=b.length;g<f;++g){var h=b[g];g||(c=h.ja);ka(d,h.ba());e.push(d.length)}a.aa(c,d,e)};function O(a,b){uf.call(this);this.na(a,b)}v(O,uf);k=O.prototype;k.Ak=function(a){this.A?ka(this.A,a.ba()):this.A=a.ba().slice();this.s()};k.clone=function(){var a=new O(null);a.aa(this.ja,this.A.slice());return a};k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;var e=this.A,f=this.a,g;var h=0;for(g=e.length;h<g;h+=f){var l=Ea(a,b,e[h],e[h+1]);if(l<d){d=l;for(l=0;l<f;++l)c[l]=e[h+l];c.length=f}}return d};k.V=function(){return If(this.A,0,this.A.length,this.a)};
k.ul=function(a){var b=this.A?this.A.length/this.a:0;if(0>a||b<=a)return null;b=new C(null);b.aa(this.ja,this.A.slice(a*this.a,(a+1)*this.a));return b};k.ee=function(){var a=this.A,b=this.ja,c=this.a,d=[],e;var f=0;for(e=a.length;f<e;f+=c){var g=new C(null);g.aa(b,a.slice(f,f+c));d.push(g)}return d};k.T=function(){return"MultiPoint"};k.Ya=function(a){var b=this.A,c=this.a,d;var e=0;for(d=b.length;e<d;e+=c){var f=b[e];var g=b[e+1];if(Sa(a,f,g))return!0}return!1};
k.na=function(a,b){a?(xf(this,b,a,1),this.A||(this.A=[]),this.A.length=Gf(this.A,0,a,this.a),this.s()):this.aa("XY",null)};k.aa=function(a,b){wf(this,a,b);this.s()};function P(a,b){uf.call(this);this.c=[];this.u=-1;this.D=null;this.I=this.B=this.C=-1;this.j=null;this.na(a,b)}v(P,uf);k=P.prototype;k.Bk=function(a){if(this.A){var b=this.A.length;ka(this.A,a.ba());a=a.sb().slice();var c;var d=0;for(c=a.length;d<c;++d)a[d]+=b}else this.A=a.ba().slice(),a=a.sb().slice(),this.c.push();this.c.push(a);this.s()};k.clone=function(){for(var a=new P(null),b=this.c.length,c=Array(b),d=0;d<b;++d)c[d]=this.c[d].slice();hm(a,this.ja,this.A.slice(),c);return a};
k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;if(this.B!=this.f){var e=this.c,f=0,g=0,h;var l=0;for(h=e.length;l<h;++l){var m=e[l];g=Cf(this.A,f,m,this.a,g);f=m[m.length-1]}this.C=Math.sqrt(g);this.B=this.f}e=mi(this);f=this.c;g=this.a;l=this.C;h=0;m=[NaN,NaN];var n;var p=0;for(n=f.length;p<n;++p){var q=f[p];d=Ef(e,h,q,g,l,!0,a,b,c,d,m);h=q[q.length-1]}return d};
k.Pc=function(a,b){a:{var c=mi(this),d=this.c,e=0;if(d.length){var f;var g=0;for(f=d.length;g<f;++g){var h=d[g];if(Sf(c,e,h,this.a,a,b)){a=!0;break a}e=h[h.length-1]}}a=!1}return a};k.Hn=function(){var a=mi(this),b=this.c,c=0,d=0,e;var f=0;for(e=b.length;f<e;++f){var g=b[f];d+=zf(a,c,g,this.a);c=g[g.length-1]}return d};k.V=function(a){if(void 0!==a){var b=mi(this).slice();$f(b,this.c,this.a,a)}else b=this.A;return Kf(b,0,this.c,this.a)};
function ni(a){if(a.u!=a.f){var b=a.A,c=a.c,d=a.a,e=0,f=[],g;var h=0;for(g=c.length;h<g;++h){var l=c[h];e=Za(b,e,l[0],d);f.push((e[0]+e[2])/2,(e[1]+e[3])/2);e=l[l.length-1]}b=mi(a);c=a.c;d=a.a;h=0;g=[];l=0;for(e=c.length;l<e;++l){var m=c[l];g=Tf(b,h,m,d,f,2*l,g);h=m[m.length-1]}a.D=g;a.u=a.f}return a.D}k.fl=function(){var a=new O(null);a.aa("XY",ni(this).slice());return a};
function mi(a){if(a.I!=a.f){var b=a.A;a:{var c=a.c;var d;var e=0;for(d=c.length;e<d;++e)if(!Yf(b,c[e],a.a,void 0)){c=!1;break a}c=!0}c?a.j=b:(a.j=b.slice(),a.j.length=$f(a.j,a.c,a.a));a.I=a.f}return a.j}k.od=function(a){var b=[],c=[],d=this.A,e=this.c,f=this.a;a=Math.sqrt(a);var g=0,h=0,l;var m=0;for(l=e.length;m<l;++m){var n=e[m],p=[];h=Mf(d,g,n,f,a,b,h,p);c.push(p);g=n[n.length-1]}b.length=h;d=new P(null);hm(d,"XY",b,c);return d};
k.vl=function(a){if(0>a||this.c.length<=a)return null;if(a){var b=this.c[a-1];b=b[b.length-1]}else b=0;a=this.c[a].slice();var c=a[a.length-1];if(b){var d;var e=0;for(d=a.length;e<d;++e)a[e]-=b}e=new D(null);e.aa(this.ja,this.A.slice(b,c),a);return e};k.$d=function(){var a=this.ja,b=this.A,c=this.c,d=[],e=0,f,g;var h=0;for(f=c.length;h<f;++h){var l=c[h].slice(),m=l[l.length-1];if(e){var n=0;for(g=l.length;n<g;++n)l[n]-=e}n=new D(null);n.aa(a,b.slice(e,m),l);d.push(n);e=m}return d};k.T=function(){return"MultiPolygon"};
k.Ya=function(a){a:{var b=mi(this),c=this.c,d=this.a,e=0,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];if(Wf(b,e,h,d,a)){a=!0;break a}e=h[h.length-1]}a=!1}return a};k.na=function(a,b){if(a){xf(this,b,a,3);this.A||(this.A=[]);b=this.A;var c=this.a,d=this.c,e=0;d=d?d:[];var f=0,g;var h=0;for(g=a.length;h<g;++h)e=Hf(b,e,a[h],c,d[f]),d[f++]=e,e=e[e.length-1];d.length=f;d.length?(a=d[d.length-1],this.A.length=a.length?a[a.length-1]:0):this.A.length=0;this.s()}else hm(this,"XY",null,this.c)};
function hm(a,b,c,d){wf(a,b,c);a.c=d;a.s()}function im(a,b){var c=a.ja,d=[],e=[],f;var g=0;for(f=b.length;g<f;++g){var h=b[g];g||(c=h.ja);var l=d.length;var m=h.sb();var n;var p=0;for(n=m.length;p<n;++p)m[p]+=l;ka(d,h.ba());e.push(m)}hm(a,c,d,e)};function jm(a){a=a?a:{};Yl.call(this);this.b=a.geometryName}v(jm,bm);
function km(a,b){if(!a)return null;if("number"===typeof a.x&&"number"===typeof a.y)var c="Point";else if(a.points)c="MultiPoint";else if(a.paths)c=1===a.paths.length?"LineString":"MultiLineString";else if(a.rings){var d=a.rings,e=lm(a),f=[],g=[];c=[];var h;var l=0;for(h=d.length;l<h;++l)f.length=0,Gf(f,0,d[l],e.length),Xf(f,0,f.length,e.length)?g.push([d[l]]):c.push(d[l]);for(;c.length;){d=c.shift();e=!1;for(l=g.length-1;0<=l;l--)if(Ta((new Of(g[l][0])).G(),(new Of(d)).G())){g[l].push(d);e=!0;break}e||
g.push([d.reverse()])}a=rb({},a);1===g.length?(c="Polygon",a.rings=g[0]):(c="MultiPolygon",a.rings=g)}return am((0,mm[c])(a),!1,b)}function lm(a){var b="XY";!0===a.hasZ&&!0===a.hasM?b="XYZM":!0===a.hasZ?b="XYZ":!0===a.hasM&&(b="XYM");return b}function nm(a){a=a.ja;return{hasZ:"XYZ"===a||"XYZM"===a,hasM:"XYM"===a||"XYZM"===a}}
var mm={Point:function(a){return void 0!==a.m&&void 0!==a.z?new C([a.x,a.y,a.z,a.m],"XYZM"):void 0!==a.z?new C([a.x,a.y,a.z],"XYZ"):void 0!==a.m?new C([a.x,a.y,a.m],"XYM"):new C([a.x,a.y])},LineString:function(a){return new M(a.paths[0],lm(a))},Polygon:function(a){return new D(a.rings,lm(a))},MultiPoint:function(a){return new O(a.points,lm(a))},MultiLineString:function(a){return new N(a.paths,lm(a))},MultiPolygon:function(a){return new P(a.rings,lm(a))}},om={Point:function(a){var b=a.V(),c;a=a.ja;
"XYZ"===a?c={x:b[0],y:b[1],z:b[2]}:"XYM"===a?c={x:b[0],y:b[1],m:b[2]}:"XYZM"===a?c={x:b[0],y:b[1],z:b[2],m:b[3]}:"XY"===a?c={x:b[0],y:b[1]}:va(!1,34);return c},LineString:function(a){var b=nm(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:[a.V()]}},Polygon:function(a){var b=nm(a);return{hasZ:b.hasZ,hasM:b.hasM,rings:a.V(!1)}},MultiPoint:function(a){var b=nm(a);return{hasZ:b.hasZ,hasM:b.hasM,points:a.V()}},MultiLineString:function(a){var b=nm(a);return{hasZ:b.hasZ,hasM:b.hasM,paths:a.V()}},MultiPolygon:function(a){var b=
nm(a);a=a.V(!1);for(var c=[],d=0;d<a.length;d++)for(var e=a[d].length-1;0<=e;e--)c.push(a[d][e]);return{hasZ:b.hasZ,hasM:b.hasM,rings:c}}};k=jm.prototype;k.Uc=function(a,b){var c=km(a.geometry,b),d=new Bl;this.b&&d.Wc(this.b);d.Ra(c);b&&b.mg&&a.attributes[b.mg]&&d.kc(a.attributes[b.mg]);a.attributes&&d.H(a.attributes);return d};k.Gg=function(a,b){b=b?b:{};if(a.features){var c=[],d=a.features,e;b.mg=a.objectIdFieldName;a=0;for(e=d.length;a<e;++a)c.push(this.Uc(d[a],b));return c}return[this.Uc(a,b)]};
k.Kg=function(a,b){return km(a,b)};k.Ng=function(a){return a.spatialReference&&a.spatialReference.wkid?Wb("EPSG:"+a.spatialReference.wkid):null};function pm(a,b){return(0,om[a.T()])(am(a,!0,b),b)}k.ue=function(a,b){return pm(a,$l(this,b))};k.cd=function(a,b){b=$l(this,b);var c={},d=a.W();d&&(c.geometry=pm(d,b),b&&b.featureProjection&&(c.geometry.spatialReference={wkid:Wb(b.featureProjection).qb.split(":").pop()}));b=a.N();delete b[a.c];c.attributes=ub(b)?{}:b;return c};
k.se=function(a,b){b=$l(this,b);var c=[],d;var e=0;for(d=a.length;e<d;++e)c.push(this.cd(a[e],b));return{features:c}};function qm(a){this.lc=a};function rm(a,b){this.lc=a;this.b=Array.prototype.slice.call(arguments,1);va(2<=this.b.length,57)}v(rm,qm);function sm(a){var b=["And"].concat(Array.prototype.slice.call(arguments));rm.apply(this,b)}v(sm,rm);function tm(a,b,c){this.lc="BBOX";this.geometryName=a;this.extent=b;this.srsName=c}v(tm,qm);function um(a,b){this.lc=a;this.b=b}v(um,qm);function vm(a,b,c){um.call(this,"During",a);this.a=b;this.f=c}v(vm,um);function wm(a,b,c,d){um.call(this,a,b);this.f=c;this.a=d}v(wm,um);function xm(a,b,c){wm.call(this,"PropertyIsEqualTo",a,b,c)}v(xm,wm);function ym(a,b){wm.call(this,"PropertyIsGreaterThan",a,b)}v(ym,wm);function zm(a,b){wm.call(this,"PropertyIsGreaterThanOrEqualTo",a,b)}v(zm,wm);function Am(a,b,c,d){this.lc=a;this.geometryName=b||"the_geom";this.geometry=c;this.srsName=d}v(Am,qm);function Bm(a,b,c){Am.call(this,"Intersects",a,b,c)}v(Bm,Am);function Cm(a,b,c){um.call(this,"PropertyIsBetween",a);this.a=b;this.f=c}v(Cm,um);function Dm(a,b,c,d,e,f){um.call(this,"PropertyIsLike",a);this.c=b;this.g=void 0!==c?c:"*";this.i=void 0!==d?d:".";this.f=void 0!==e?e:"!";this.a=f}v(Dm,um);function Em(a){um.call(this,"PropertyIsNull",a)}v(Em,um);function Fm(a,b){wm.call(this,"PropertyIsLessThan",a,b)}v(Fm,wm);function Gm(a,b){wm.call(this,"PropertyIsLessThanOrEqualTo",a,b)}v(Gm,wm);function Hm(a){this.lc="Not";this.condition=a}v(Hm,qm);function Im(a,b,c){wm.call(this,"PropertyIsNotEqualTo",a,b,c)}v(Im,wm);function Jm(a){var b=["Or"].concat(Array.prototype.slice.call(arguments));rm.apply(this,b)}v(Jm,rm);function Km(a,b,c){Am.call(this,"Within",a,b,c)}v(Km,Am);function Lm(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(sm,b))}function Mm(a,b,c){return new tm(a,b,c)};function Nm(a){rf.call(this);this.a=a?a:null;Om(this)}v(Nm,rf);function Pm(a){var b=[],c;var d=0;for(c=a.length;d<c;++d)b.push(a[d].clone());return b}function Qm(a){var b;if(a.a){var c=0;for(b=a.a.length;c<b;++c)Mc(a.a[c],"change",a.s,a)}}function Om(a){var b;if(a.a){var c=0;for(b=a.a.length;c<b;++c)y(a.a[c],"change",a.s,a)}}k=Nm.prototype;k.clone=function(){var a=new Nm(null);a.yj(this.a);return a};
k.Jb=function(a,b,c,d){if(d<Qa(this.G(),a,b))return d;var e=this.a,f;var g=0;for(f=e.length;g<f;++g)d=e[g].Jb(a,b,c,d);return d};k.Pc=function(a,b){var c=this.a,d;var e=0;for(d=c.length;e<d;++e)if(c[e].Pc(a,b))return!0;return!1};k.De=function(a){Wa(a);for(var b=this.a,c=0,d=b.length;c<d;++c)bb(a,b[c].G());return a};k.kd=function(){return Pm(this.a)};
k.ae=function(a){this.l!=this.f&&(sb(this.i),this.g=0,this.l=this.f);if(0>a||this.g&&a<this.g)return this;var b=a.toString();if(this.i.hasOwnProperty(b))return this.i[b];var c=[],d=this.a,e=!1,f;var g=0;for(f=d.length;g<f;++g){var h=d[g],l=h.ae(a);c.push(l);l!==h&&(e=!0)}if(e)return a=new Nm(null),Qm(a),a.a=c,Om(a),a.s(),this.i[b]=a;this.g=a;return this};k.T=function(){return"GeometryCollection"};k.Ya=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)if(b[d].Ya(a))return!0;return!1};
k.rotate=function(a,b){for(var c=this.a,d=0,e=c.length;d<e;++d)c[d].rotate(a,b);this.s()};k.scale=function(a,b,c){c||(c=lb(this.G()));for(var d=this.a,e=0,f=d.length;e<f;++e)d[e].scale(a,b,c);this.s()};k.yj=function(a){a=Pm(a);Qm(this);this.a=a;Om(this);this.s()};k.Fc=function(a){var b=this.a,c;var d=0;for(c=b.length;d<c;++d)b[d].Fc(a);this.s()};k.translate=function(a,b){var c=this.a,d;var e=0;for(d=c.length;e<d;++e)c[e].translate(a,b);this.s()};k.ka=function(){Qm(this);rf.prototype.ka.call(this)};function Rm(a){a=a?a:{};Yl.call(this);this.defaultDataProjection=Wb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326");a.featureProjection&&(this.i=Wb(a.featureProjection));this.b=a.geometryName}v(Rm,bm);function Sm(a,b){return a?am((0,Tm[a.type])(a),!1,b):null}function Um(a,b){return(0,Vm[a.T()])(am(a,!0,b),b)}
var Tm={Point:function(a){return new C(a.coordinates)},LineString:function(a){return new M(a.coordinates)},Polygon:function(a){return new D(a.coordinates)},MultiPoint:function(a){return new O(a.coordinates)},MultiLineString:function(a){return new N(a.coordinates)},MultiPolygon:function(a){return new P(a.coordinates)},GeometryCollection:function(a,b){a=a.geometries.map(function(a){return Sm(a,b)});return new Nm(a)}},Vm={Point:function(a){return{type:"Point",coordinates:a.V()}},LineString:function(a){return{type:"LineString",
coordinates:a.V()}},Polygon:function(a,b){if(b)var c=b.rightHanded;return{type:"Polygon",coordinates:a.V(c)}},MultiPoint:function(a){return{type:"MultiPoint",coordinates:a.V()}},MultiLineString:function(a){return{type:"MultiLineString",coordinates:a.V()}},MultiPolygon:function(a,b){if(b)var c=b.rightHanded;return{type:"MultiPolygon",coordinates:a.V(c)}},GeometryCollection:function(a,b){return{type:"GeometryCollection",geometries:a.a.map(function(a){var c=rb({},b);delete c.featureProjection;return Um(a,
c)})}},Circle:function(){return{type:"GeometryCollection",geometries:[]}}};k=Rm.prototype;k.Uc=function(a,b){a="Feature"===a.type?a:{type:"Feature",geometry:a};b=Sm(a.geometry,b);var c=new Bl;this.b&&c.Wc(this.b);c.Ra(b);void 0!==a.id&&c.kc(a.id);a.properties&&c.H(a.properties);return c};k.Gg=function(a,b){if("FeatureCollection"===a.type){var c=[];a=a.features;var d;var e=0;for(d=a.length;e<d;++e)c.push(this.Uc(a[e],b))}else c=[this.Uc(a,b)];return c};k.Kg=function(a,b){return Sm(a,b)};
k.Ng=function(a){a=a.crs;var b;a?"name"==a.type?b=Wb(a.properties.name):"EPSG"==a.type?b=Wb("EPSG:"+a.properties.code):va(!1,36):b=this.defaultDataProjection;return b};k.cd=function(a,b){b=$l(this,b);var c={type:"Feature"},d=a.a;void 0!==d&&(c.id=d);(d=a.W())?c.geometry=Um(d,b):c.geometry=null;b=a.N();delete b[a.c];ub(b)?c.properties=null:c.properties=b;return c};k.se=function(a,b){b=$l(this,b);var c=[],d;var e=0;for(d=a.length;e<d;++e)c.push(this.cd(a[e],b));return{type:"FeatureCollection",features:c}};
k.ue=function(a,b){return Um(a,$l(this,b))};function Wm(){this.f=new XMLSerializer;Yl.call(this)}v(Wm,Yl);k=Wm.prototype;k.T=function(){return"xml"};k.Ub=function(a,b){return Hl(a)?Xm(this,a,b):Il(a)?this.Fg(a,b):"string"===typeof a?(a=Jl(a),Xm(this,a,b)):null};function Xm(a,b,c){a=Ym(a,b,c);return 0<a.length?a[0]:null}k.Fg=function(){return null};k.Oa=function(a,b){return Hl(a)?Ym(this,a,b):Il(a)?this.Ac(a,b):"string"===typeof a?(a=Jl(a),Ym(this,a,b)):[]};
function Ym(a,b,c){var d=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ka(d,a.Ac(b,c));return d}k.Vc=function(a,b){if(Hl(a))return null;if(Il(a))return this.kj(a,b);"string"===typeof a&&Jl(a);return null};k.kj=function(){return null};k.ob=function(a){return Hl(a)?this.Mg(a):Il(a)?this.vf(a):"string"===typeof a?(a=Jl(a),this.Mg(a)):null};k.Mg=function(){return this.defaultDataProjection};k.vf=function(){return this.defaultDataProjection};
k.Gd=function(a,b){return this.f.serializeToString(this.$g(a,b))};k.$g=function(){return null};k.Xb=function(a,b){a=this.Yb(a,b);return this.f.serializeToString(a)};k.Yb=function(){return null};k.dd=function(a,b){a=this.te(a,b);return this.f.serializeToString(a)};k.te=function(){return null};function Zm(a){a=a?a:{};this.featureType=a.featureType;this.featureNS=a.featureNS;this.srsName=a.srsName;this.schemaLocation="";this.b={};this.b["http://www.opengis.net/gml"]={featureMember:Nl(Zm.prototype.ie),featureMembers:Nl(Zm.prototype.ie)};Wm.call(this)}v(Zm,Wm);var $m=/^[\s\xa0]*$/;k=Zm.prototype;
k.ie=function(a,b){var c=a.localName,d=null;if("FeatureCollection"==c)"http://www.opengis.net/wfs"===a.namespaceURI?d=L([],this.b,a,b,this):d=L(null,this.b,a,b,this);else if("featureMembers"==c||"featureMember"==c){var e=b[0],f=e.featureType,g=e.featureNS,h;if(!f&&a.childNodes){f=[];g={};var l=0;for(h=a.childNodes.length;l<h;++l){var m=a.childNodes[l];if(1===m.nodeType){var n=m.nodeName.split(":").pop();if(-1===f.indexOf(n)){var p="",q=0;m=m.namespaceURI;for(var t in g){if(g[t]===m){p=t;break}++q}p||
(p="p"+q,g[p]=m);f.push(p+":"+n)}}}"featureMember"!=c&&(e.featureType=f,e.featureNS=g)}"string"===typeof g&&(l=g,g={},g.p0=l);e={};f=Array.isArray(f)?f:[f];for(var u in g){n={};l=0;for(h=f.length;l<h;++l)(-1===f[l].indexOf(":")?"p0":f[l].split(":")[0])===u&&(n[f[l].split(":").pop()]="featureMembers"==c?Ll(this.Eg,this):Nl(this.Eg,this));e[g[u]]=n}"featureMember"==c?d=L(void 0,e,a,b):d=L([],e,a,b)}null===d&&(d=[]);return d};
k.sf=function(a,b){var c=b[0];c.srsName=a.firstElementChild.getAttribute("srsName");if(a=L(null,this.eh,a,b,this))return am(a,!1,c)};
k.Eg=function(a,b){var c;(c=a.getAttribute("fid"))||(c=a.getAttributeNS("http://www.opengis.net/gml","id")||"");var d={},e;for(a=a.firstElementChild;a;a=a.nextElementSibling){var f=a.localName;if(0===a.childNodes.length||1===a.childNodes.length&&(3===a.firstChild.nodeType||4===a.firstChild.nodeType)){var g=Fl(a,!1);$m.test(g)&&(g=void 0);d[f]=g}else"boundedBy"!==f&&(e=f),d[f]=this.sf(a,b)}b=new Bl(d);e&&b.Wc(e);c&&b.kc(c);return b};
k.pj=function(a,b){if(a=this.rf(a,b))return b=new C(null),b.aa("XYZ",a),b};k.nj=function(a,b){if(a=L([],this.Xj,a,b,this))return new O(a)};k.mj=function(a,b){if(a=L([],this.Wj,a,b,this))return b=new N(null),gm(b,a),b};k.oj=function(a,b){if(a=L([],this.Yj,a,b,this))return b=new P(null),im(b,a),b};k.gj=function(a,b){Ul(this.ak,a,b,this)};k.Vh=function(a,b){Ul(this.Uj,a,b,this)};k.hj=function(a,b){Ul(this.bk,a,b,this)};k.tf=function(a,b){if(a=this.rf(a,b))return b=new M(null),b.aa("XYZ",a),b};
k.Jp=function(a,b){if(a=L(null,this.ve,a,b,this))return a};k.lj=function(a,b){if(a=this.rf(a,b))return b=new Of(null),Pf(b,"XYZ",a),b};k.uf=function(a,b){if((a=L([null],this.If,a,b,this))&&a[0]){b=new D(null);var c=a[0],d=[c.length],e;var f=1;for(e=a.length;f<e;++f)ka(c,a[f]),d.push(c.length);b.aa("XYZ",c,d);return b}};k.rf=function(a,b){return L(null,this.ve,a,b,this)};k.Xj={"http://www.opengis.net/gml":{pointMember:Ll(Zm.prototype.gj),pointMembers:Ll(Zm.prototype.gj)}};
k.Wj={"http://www.opengis.net/gml":{lineStringMember:Ll(Zm.prototype.Vh),lineStringMembers:Ll(Zm.prototype.Vh)}};k.Yj={"http://www.opengis.net/gml":{polygonMember:Ll(Zm.prototype.hj),polygonMembers:Ll(Zm.prototype.hj)}};k.ak={"http://www.opengis.net/gml":{Point:Ll(Zm.prototype.rf)}};k.Uj={"http://www.opengis.net/gml":{LineString:Ll(Zm.prototype.tf)}};k.bk={"http://www.opengis.net/gml":{Polygon:Ll(Zm.prototype.uf)}};k.we={"http://www.opengis.net/gml":{LinearRing:Nl(Zm.prototype.Jp)}};
k.kj=function(a,b){return(a=this.sf(a,[Zl(this,a,b?b:{})]))?a:null};k.Ac=function(a,b){var c={featureType:this.featureType,featureNS:this.featureNS};b&&rb(c,Zl(this,a,b));return this.ie(a,[c])||[]};k.vf=function(a){return Wb(this.srsName?this.srsName:a.firstElementChild.getAttribute("srsName"))};function an(a){a=Fl(a,!1);return bn(a)}function bn(a){if(a=/^\s*(true|1)|(false|0)\s*$/.exec(a))return void 0!==a[1]||!1}function cn(a){a=Fl(a,!1);a=Date.parse(a);return isNaN(a)?void 0:a/1E3}function dn(a){a=Fl(a,!1);return en(a)}function en(a){if(a=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(a))return parseFloat(a[1])}function fn(a){a=Fl(a,!1);return gn(a)}function gn(a){if(a=/^\s*(\d+)\s*$/.exec(a))return parseInt(a[1],10)}function Q(a){return Fl(a,!1).trim()}
function hn(a,b){jn(a,b?"1":"0")}function kn(a,b){a.appendChild(Dl.createTextNode(b.toPrecision()))}function ln(a,b){a.appendChild(Dl.createTextNode(b.toString()))}function jn(a,b){a.appendChild(Dl.createTextNode(b))};function mn(a){a=a?a:{};Zm.call(this,a);this.o=void 0!==a.surface?a.surface:!1;this.c=void 0!==a.curve?a.curve:!1;this.g=void 0!==a.multiCurve?a.multiCurve:!0;this.j=void 0!==a.multiSurface?a.multiSurface:!0;this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/1.0.0/gmlsf.xsd";this.hasZ=void 0!==a.hasZ?a.hasZ:!1}v(mn,Zm);k=mn.prototype;
k.Np=function(a,b){if(a=L([],this.Vj,a,b,this))return b=new N(null),gm(b,a),b};k.Op=function(a,b){if(a=L([],this.Zj,a,b,this))return b=new P(null),im(b,a),b};k.vh=function(a,b){Ul(this.Rj,a,b,this)};k.Kj=function(a,b){Ul(this.dk,a,b,this)};k.Rp=function(a,b){return L([null],this.$j,a,b,this)};k.Up=function(a,b){return L([null],this.ck,a,b,this)};k.Sp=function(a,b){return L([null],this.If,a,b,this)};k.Mp=function(a,b){return L([null],this.ve,a,b,this)};
k.qm=function(a,b){(a=L(void 0,this.we,a,b,this))&&b[b.length-1].push(a)};k.Jk=function(a,b){(a=L(void 0,this.we,a,b,this))&&(b[b.length-1][0]=a)};k.qj=function(a,b){if((a=L([null],this.ek,a,b,this))&&a[0]){b=new D(null);var c=a[0],d=[c.length],e;var f=1;for(e=a.length;f<e;++f)ka(c,a[f]),d.push(c.length);b.aa("XYZ",c,d);return b}};k.ij=function(a,b){if(a=L([null],this.Sj,a,b,this))return b=new M(null),b.aa("XYZ",a),b};
k.Ip=function(a,b){a=L([null],this.Tj,a,b,this);return Va(a[1][0],a[1][1],a[2][0],a[2][1])};k.Kp=function(a,b){var c=Fl(a,!1),d=/^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/;a=[];for(var e;e=d.exec(c);)a.push(parseFloat(e[1])),c=c.substr(e[0].length);if(""===c){b=b[0].srsName;c="enu";b&&(c=Wb(b).a);if("neu"===c)for(b=0,c=a.length;b<c;b+=3)d=a[b],a[b]=a[b+1],a[b+1]=d;b=a.length;2==b&&a.push(0);if(b)return a}};
k.Jg=function(a,b){var c=Fl(a,!1).replace(/^\s*|\s*$/g,""),d=b[0].srsName,e=a.parentNode.getAttribute("srsDimension");b="enu";d&&(b=Wb(d).a);c=c.split(/\s+/);d=2;a.getAttribute("srsDimension")?d=gn(a.getAttribute("srsDimension")):a.getAttribute("dimension")?d=gn(a.getAttribute("dimension")):e&&(d=gn(e));for(var f,g=[],h=0,l=c.length;h<l;h+=d)a=parseFloat(c[h]),e=parseFloat(c[h+1]),f=3===d?parseFloat(c[h+2]):0,"en"===b.substr(0,2)?g.push(a,e,f):g.push(e,a,f);return g};
k.ve={"http://www.opengis.net/gml":{pos:Nl(mn.prototype.Kp),posList:Nl(mn.prototype.Jg)}};k.If={"http://www.opengis.net/gml":{interior:mn.prototype.qm,exterior:mn.prototype.Jk}};
k.eh={"http://www.opengis.net/gml":{Point:Nl(Zm.prototype.pj),MultiPoint:Nl(Zm.prototype.nj),LineString:Nl(Zm.prototype.tf),MultiLineString:Nl(Zm.prototype.mj),LinearRing:Nl(Zm.prototype.lj),Polygon:Nl(Zm.prototype.uf),MultiPolygon:Nl(Zm.prototype.oj),Surface:Nl(mn.prototype.qj),MultiSurface:Nl(mn.prototype.Op),Curve:Nl(mn.prototype.ij),MultiCurve:Nl(mn.prototype.Np),Envelope:Nl(mn.prototype.Ip)}};k.Vj={"http://www.opengis.net/gml":{curveMember:Ll(mn.prototype.vh),curveMembers:Ll(mn.prototype.vh)}};
k.Zj={"http://www.opengis.net/gml":{surfaceMember:Ll(mn.prototype.Kj),surfaceMembers:Ll(mn.prototype.Kj)}};k.Rj={"http://www.opengis.net/gml":{LineString:Ll(Zm.prototype.tf),Curve:Ll(mn.prototype.ij)}};k.dk={"http://www.opengis.net/gml":{Polygon:Ll(Zm.prototype.uf),Surface:Ll(mn.prototype.qj)}};k.ek={"http://www.opengis.net/gml":{patches:Nl(mn.prototype.Rp)}};k.Sj={"http://www.opengis.net/gml":{segments:Nl(mn.prototype.Up)}};k.Tj={"http://www.opengis.net/gml":{lowerCorner:Ll(mn.prototype.Jg),upperCorner:Ll(mn.prototype.Jg)}};
k.$j={"http://www.opengis.net/gml":{PolygonPatch:Nl(mn.prototype.Sp)}};k.ck={"http://www.opengis.net/gml":{LineStringSegment:Nl(mn.prototype.Mp)}};function nn(a,b,c){var d=c[c.length-1];c=d.hasZ;d=d.srsName;b=b.V();for(var e=b.length,f=Array(e),g,h=0;h<e;++h){g=b[h];var l=h,m=c,n="enu";d&&(n=Wb(d).a);n="en"===n.substr(0,2)?g[0]+" "+g[1]:g[1]+" "+g[0];m&&(n+=" "+(g[2]||0));f[l]=n}jn(a,f.join(" "))}
k.yi=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=El(a.namespaceURI,"pos");a.appendChild(d);c=c[c.length-1];a=c.hasZ;var e=c.srsName;c="enu";e&&(c=Wb(e).a);b=b.V();c="en"===c.substr(0,2)?b[0]+" "+b[1]:b[1]+" "+b[0];a&&(c+=" "+(b[2]||0));jn(d,c)};var on={"http://www.opengis.net/gml":{lowerCorner:J(jn),upperCorner:J(jn)}};k=mn.prototype;
k.zn=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);Vl({node:a},on,Sl,[b[0]+" "+b[1],b[2]+" "+b[3]],c,["lowerCorner","upperCorner"],this)};k.vi=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=El(a.namespaceURI,"posList");a.appendChild(d);nn(d,b,c)};k.yn=function(a,b){a=b[b.length-1];b=a.node;var c=a.exteriorWritten;void 0===c&&(a.exteriorWritten=!0);return El(b.namespaceURI,void 0!==c?"interior":"exterior")};
k.cf=function(a,b,c){var d=c[c.length-1],e=d.hasZ;d=d.srsName;"PolygonPatch"!==a.nodeName&&d&&a.setAttribute("srsName",d);"Polygon"===a.nodeName||"PolygonPatch"===a.nodeName?(b=b.Zd(),Vl({node:a,hasZ:e,srsName:d},pn,this.yn,b,c,void 0,this)):"Surface"===a.nodeName&&(e=El(a.namespaceURI,"patches"),a.appendChild(e),a=El(e.namespaceURI,"PolygonPatch"),e.appendChild(a),this.cf(a,b,c))};
k.bf=function(a,b,c){var d=c[c.length-1].srsName;"LineStringSegment"!==a.nodeName&&d&&a.setAttribute("srsName",d);"LineString"===a.nodeName||"LineStringSegment"===a.nodeName?(d=El(a.namespaceURI,"posList"),a.appendChild(d),nn(d,b,c)):"Curve"===a.nodeName&&(d=El(a.namespaceURI,"segments"),a.appendChild(d),a=El(d.namespaceURI,"LineStringSegment"),d.appendChild(a),this.bf(a,b,c))};
k.xi=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.surface;f&&a.setAttribute("srsName",f);b=b.$d();Vl({node:a,hasZ:e,srsName:f,surface:d},qn,this.l,b,c,void 0,this)};k.An=function(a,b,c){var d=c[c.length-1],e=d.srsName;d=d.hasZ;e&&a.setAttribute("srsName",e);b=b.ee();Vl({node:a,hasZ:d,srsName:e},rn,Ql("pointMember"),b,c,void 0,this)};
k.wi=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.curve;f&&a.setAttribute("srsName",f);b=b.ld();Vl({node:a,hasZ:e,srsName:f,curve:d},sn,this.l,b,c,void 0,this)};k.zi=function(a,b,c){var d=El(a.namespaceURI,"LinearRing");a.appendChild(d);this.vi(d,b,c)};k.Ai=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.cf(d,b,c))};k.Bn=function(a,b,c){var d=El(a.namespaceURI,"Point");a.appendChild(d);this.yi(d,b,c)};
k.ui=function(a,b,c){var d=this.a(b,c);d&&(a.appendChild(d),this.bf(d,b,c))};k.ud=function(a,b,c){var d=c[c.length-1],e=rb({},d);e.node=a;var f;Array.isArray(b)?d.dataProjection?f=ic(b,d.featureProjection,d.dataProjection):f=b:f=am(b,!0,d);Vl(e,tn,this.a,[f],c,void 0,this)};
k.ti=function(a,b,c){var d=b.a;d&&a.setAttribute("fid",d);d=c[c.length-1];var e=d.featureNS,f=b.c;d.pb||(d.pb={},d.pb[e]={});var g=b.N();b=[];var h=[];for(m in g){var l=g[m];null!==l&&(b.push(m),h.push(l),m==f||l instanceof rf?m in d.pb[e]||(d.pb[e][m]=J(this.ud,this)):m in d.pb[e]||(d.pb[e][m]=J(jn)))}var m=rb({},d);m.node=a;Vl(m,d.pb,Ql(void 0,e),h,c,b)};
var qn={"http://www.opengis.net/gml":{surfaceMember:J(mn.prototype.Ai),polygonMember:J(mn.prototype.Ai)}},rn={"http://www.opengis.net/gml":{pointMember:J(mn.prototype.Bn)}},sn={"http://www.opengis.net/gml":{lineStringMember:J(mn.prototype.ui),curveMember:J(mn.prototype.ui)}},pn={"http://www.opengis.net/gml":{exterior:J(mn.prototype.zi),interior:J(mn.prototype.zi)}},tn={"http://www.opengis.net/gml":{Curve:J(mn.prototype.bf),MultiCurve:J(mn.prototype.wi),Point:J(mn.prototype.yi),MultiPoint:J(mn.prototype.An),
LineString:J(mn.prototype.bf),MultiLineString:J(mn.prototype.wi),LinearRing:J(mn.prototype.vi),Polygon:J(mn.prototype.cf),MultiPolygon:J(mn.prototype.xi),Surface:J(mn.prototype.cf),MultiSurface:J(mn.prototype.xi),Envelope:J(mn.prototype.zn)}},un={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"};mn.prototype.l=function(a,b){return El("http://www.opengis.net/gml",un[b[b.length-1].node.nodeName])};
mn.prototype.a=function(a,b){var c=b[b.length-1];b=c.multiSurface;var d=c.surface,e=c.curve;c=c.multiCurve;Array.isArray(a)?a="Envelope":(a=a.T(),"MultiPolygon"===a&&!0===b?a="MultiSurface":"Polygon"===a&&!0===d?a="Surface":"LineString"===a&&!0===e?a="Curve":"MultiLineString"===a&&!0===c&&(a="MultiCurve"));return El("http://www.opengis.net/gml",a)};
mn.prototype.te=function(a,b){b=$l(this,b);var c=El("http://www.opengis.net/gml","geom"),d={node:c,hasZ:this.hasZ,srsName:this.srsName,curve:this.c,surface:this.o,multiSurface:this.j,multiCurve:this.g};b&&rb(d,b);this.ud(c,a,[d]);return c};
mn.prototype.Yb=function(a,b){b=$l(this,b);var c=El("http://www.opengis.net/gml","featureMembers");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.schemaLocation);var d={srsName:this.srsName,hasZ:this.hasZ,curve:this.c,surface:this.o,multiSurface:this.j,multiCurve:this.g,featureNS:this.featureNS,featureType:this.featureType};b&&rb(d,b);b=[d];var e=b[b.length-1];d=e.featureType;var f=e.featureNS,g={};g[f]={};g[f][d]=J(this.ti,this);e=rb({},e);e.node=c;Vl(e,g,
Ql(d,f),a,b);return c};function vn(a){a=a?a:{};Zm.call(this,a);this.b["http://www.opengis.net/gml"].featureMember=Ll(Zm.prototype.ie);this.schemaLocation=a.schemaLocation?a.schemaLocation:"http://www.opengis.net/gml http://schemas.opengis.net/gml/2.1.2/feature.xsd"}v(vn,Zm);k=vn.prototype;
k.jj=function(a,b){a=Fl(a,!1).replace(/^\s*|\s*$/g,"");var c=b[0].srsName;b="enu";c&&(c=Wb(c))&&(b=c.a);a=a.trim().split(/\s+/);for(var d,e,f=[],g=0,h=a.length;g<h;g++)e=a[g].split(/,+/),c=parseFloat(e[0]),d=parseFloat(e[1]),e=3===e.length?parseFloat(e[2]):0,"en"===b.substr(0,2)?f.push(c,d,e):f.push(d,c,e);return f};k.Gp=function(a,b){a=L([null],this.Qj,a,b,this);return Va(a[1][0],a[1][1],a[1][3],a[1][4])};k.om=function(a,b){(a=L(void 0,this.we,a,b,this))&&b[b.length-1].push(a)};
k.pp=function(a,b){(a=L(void 0,this.we,a,b,this))&&(b[b.length-1][0]=a)};k.ve={"http://www.opengis.net/gml":{coordinates:Nl(vn.prototype.jj)}};k.If={"http://www.opengis.net/gml":{innerBoundaryIs:vn.prototype.om,outerBoundaryIs:vn.prototype.pp}};k.Qj={"http://www.opengis.net/gml":{coordinates:Ll(vn.prototype.jj)}};
k.eh={"http://www.opengis.net/gml":{Point:Nl(Zm.prototype.pj),MultiPoint:Nl(Zm.prototype.nj),LineString:Nl(Zm.prototype.tf),MultiLineString:Nl(Zm.prototype.mj),LinearRing:Nl(Zm.prototype.lj),Polygon:Nl(Zm.prototype.uf),MultiPolygon:Nl(Zm.prototype.oj),Box:Nl(vn.prototype.Gp)}};
k.rg=function(a,b){var c=b[b.length-1];b=c.multiSurface;var d=c.surface;c=c.multiCurve;Array.isArray(a)?a="Envelope":(a=a.T(),"MultiPolygon"===a&&!0===b?a="MultiSurface":"Polygon"===a&&!0===d?a="Surface":"MultiLineString"===a&&!0===c&&(a="MultiCurve"));return El("http://www.opengis.net/gml",a)};k.ki=function(a,b,c){var d=c[c.length-1],e=rb({},d);e.node=a;var f;Array.isArray(b)?d.dataProjection?f=ic(b,d.featureProjection,d.dataProjection):f=b:f=am(b,!0,d);Vl(e,wn,this.rg,[f],c,void 0,this)};
k.$e=function(a,b,c){var d=c[c.length-1].srsName;"LineStringSegment"!==a.nodeName&&d&&a.setAttribute("srsName",d);"LineString"===a.nodeName||"LineStringSegment"===a.nodeName?(d=xn(a.namespaceURI),a.appendChild(d),yn(d,b,c)):"Curve"===a.nodeName&&(d=El(a.namespaceURI,"segments"),a.appendChild(d),a=El(d.namespaceURI,"LineStringSegment"),d.appendChild(a),this.$e(a,b,c))};function xn(a){a=El(a,"coordinates");a.setAttribute("decimal",".");a.setAttribute("cs",",");a.setAttribute("ts"," ");return a}
function yn(a,b,c){var d=c[c.length-1];c=d.hasZ;d=d.srsName;b=b.V();for(var e=b.length,f=Array(e),g,h=0;h<e;++h)g=b[h],f[h]=zn(g,d,c);jn(a,f.join(" "))}
k.af=function(a,b,c){var d=c[c.length-1],e=d.hasZ;d=d.srsName;"PolygonPatch"!==a.nodeName&&d&&a.setAttribute("srsName",d);"Polygon"===a.nodeName||"PolygonPatch"===a.nodeName?(b=b.Zd(),Vl({node:a,hasZ:e,srsName:d},An,this.tn,b,c,void 0,this)):"Surface"===a.nodeName&&(e=El(a.namespaceURI,"patches"),a.appendChild(e),a=El(e.namespaceURI,"PolygonPatch"),e.appendChild(a),this.af(a,b,c))};
k.tn=function(a,b){a=b[b.length-1];b=a.node;var c=a.exteriorWritten;void 0===c&&(a.exteriorWritten=!0);return El(b.namespaceURI,void 0!==c?"innerBoundaryIs":"outerBoundaryIs")};k.ri=function(a,b,c){var d=El(a.namespaceURI,"LinearRing");a.appendChild(d);this.mi(d,b,c)};function zn(a,b,c){var d="enu";b&&(d=Wb(b).a);b="en"===d.substr(0,2)?a[0]+","+a[1]:a[1]+","+a[0];c&&(b+=","+(a[2]||0));return b}
k.ni=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.curve;f&&a.setAttribute("srsName",f);b=b.ld();Vl({node:a,hasZ:e,srsName:f,curve:d},Bn,this.a,b,c,void 0,this)};k.pi=function(a,b,c){var d=c[c.length-1];c=d.hasZ;var e=d.srsName;e&&a.setAttribute("srsName",e);d=xn(a.namespaceURI);a.appendChild(d);a=b.V();a=zn(a,e,c);jn(d,a)};
k.wn=function(a,b,c){var d=c[c.length-1],e=d.hasZ;(d=d.srsName)&&a.setAttribute("srsName",d);b=b.ee();Vl({node:a,hasZ:e,srsName:d},Cn,Ql("pointMember"),b,c,void 0,this)};k.xn=function(a,b,c){var d=El(a.namespaceURI,"Point");a.appendChild(d);this.pi(d,b,c)};k.li=function(a,b,c){var d=this.rg(b,c);d&&(a.appendChild(d),this.$e(d,b,c))};k.mi=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);d=xn(a.namespaceURI);a.appendChild(d);yn(d,b,c)};
k.oi=function(a,b,c){var d=c[c.length-1],e=d.hasZ,f=d.srsName;d=d.surface;f&&a.setAttribute("srsName",f);b=b.$d();Vl({node:a,hasZ:e,srsName:f,surface:d},Dn,this.a,b,c,void 0,this)};k.si=function(a,b,c){var d=this.rg(b,c);d&&(a.appendChild(d),this.af(d,b,c))};k.vn=function(a,b,c){var d=c[c.length-1].srsName;d&&a.setAttribute("srsName",d);Vl({node:a},En,Sl,[b[0]+" "+b[1],b[2]+" "+b[3]],c,["lowerCorner","upperCorner"],this)};
var wn={"http://www.opengis.net/gml":{Curve:J(vn.prototype.$e),MultiCurve:J(vn.prototype.ni),Point:J(vn.prototype.pi),MultiPoint:J(vn.prototype.wn),LineString:J(vn.prototype.$e),MultiLineString:J(vn.prototype.ni),LinearRing:J(vn.prototype.mi),Polygon:J(vn.prototype.af),MultiPolygon:J(vn.prototype.oi),Surface:J(vn.prototype.af),MultiSurface:J(vn.prototype.oi),Envelope:J(vn.prototype.vn)}},An={"http://www.opengis.net/gml":{outerBoundaryIs:J(vn.prototype.ri),innerBoundaryIs:J(vn.prototype.ri)}},Cn={"http://www.opengis.net/gml":{pointMember:J(vn.prototype.xn)}},
Bn={"http://www.opengis.net/gml":{lineStringMember:J(vn.prototype.li),curveMember:J(vn.prototype.li)}};vn.prototype.a=function(a,b){return El("http://www.opengis.net/gml",Fn[b[b.length-1].node.nodeName])};var Fn={MultiLineString:"lineStringMember",MultiCurve:"curveMember",MultiPolygon:"polygonMember",MultiSurface:"surfaceMember"},Dn={"http://www.opengis.net/gml":{surfaceMember:J(vn.prototype.si),polygonMember:J(vn.prototype.si)}},En={"http://www.opengis.net/gml":{lowerCorner:J(jn),upperCorner:J(jn)}};function Gn(a){a=a?a:{};Wm.call(this);this.defaultDataProjection=Wb("EPSG:4326");this.b=a.readExtensions}v(Gn,Wm);var Hn=[null,"http://www.topografix.com/GPX/1/0","http://www.topografix.com/GPX/1/1"];function In(a,b,c,d){a.push(parseFloat(c.getAttribute("lon")),parseFloat(c.getAttribute("lat")));"ele"in d?(a.push(d.ele),delete d.ele,b.hasZ=!0):a.push(0);"time"in d?(a.push(d.time),delete d.time,b.hasM=!0):a.push(0);return a}
function Jn(a,b,c){var d="XY",e=2;a.hasZ&&a.hasM?(d="XYZM",e=4):a.hasZ?(d="XYZ",e=3):a.hasM&&(d="XYM",e=3);if(4!==e){var f;var g=0;for(f=b.length/4;g<f;g++)b[g*e]=b[4*g],b[g*e+1]=b[4*g+1],a.hasZ&&(b[g*e+2]=b[4*g+2]),a.hasM&&(b[g*e+2]=b[4*g+3]);b.length=b.length/4*e;if(c)for(g=0,f=c.length;g<f;g++)c[g]=c[g]/4*e}return d}function Kn(a,b){var c=b[b.length-1],d=a.getAttribute("href");null!==d&&(c.link=d);Ul(Ln,a,b)}function Mn(a,b){b[b.length-1].extensionsNode_=a}
function Nn(a,b){var c=b[0];if(a=L({flatCoordinates:[],layoutOptions:{}},On,a,b)){b=a.flatCoordinates;delete a.flatCoordinates;var d=a.layoutOptions;delete a.layoutOptions;d=Jn(d,b);var e=new M(null);e.aa(d,b);am(e,!1,c);c=new Bl(e);c.H(a);return c}}
function Pn(a,b){var c=b[0];if(a=L({flatCoordinates:[],ends:[],layoutOptions:{}},Qn,a,b)){b=a.flatCoordinates;delete a.flatCoordinates;var d=a.ends;delete a.ends;var e=a.layoutOptions;delete a.layoutOptions;e=Jn(e,b,d);var f=new N(null);f.aa(e,b,d);am(f,!1,c);c=new Bl(f);c.H(a);return c}}function Rn(a,b){var c=b[0];if(b=L({},Sn,a,b)){var d={};a=In([],d,a,b);d=Jn(d,a);a=new C(a,d);am(a,!1,c);c=new Bl(a);c.H(b);return c}}
var Tn={rte:Nn,trk:Pn,wpt:Rn},Un=K(Hn,{rte:Ll(Nn),trk:Ll(Pn),wpt:Ll(Rn)}),Ln=K(Hn,{text:I(Q,"linkText"),type:I(Q,"linkType")}),On=K(Hn,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Kn,number:I(fn),extensions:Mn,type:I(Q),rtept:function(a,b){var c=L({},Vn,a,b);c&&(b=b[b.length-1],In(b.flatCoordinates,b.layoutOptions,a,c))}}),Vn=K(Hn,{ele:I(dn),time:I(cn)}),Qn=K(Hn,{name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Kn,number:I(fn),type:I(Q),extensions:Mn,trkseg:function(a,b){var c=b[b.length-1];Ul(Wn,a,b);c.ends.push(c.flatCoordinates.length)}}),
Wn=K(Hn,{trkpt:function(a,b){var c=L({},Xn,a,b);c&&(b=b[b.length-1],In(b.flatCoordinates,b.layoutOptions,a,c))}}),Xn=K(Hn,{ele:I(dn),time:I(cn)}),Sn=K(Hn,{ele:I(dn),time:I(cn),magvar:I(dn),geoidheight:I(dn),name:I(Q),cmt:I(Q),desc:I(Q),src:I(Q),link:Kn,sym:I(Q),type:I(Q),fix:I(Q),sat:I(fn),hdop:I(dn),vdop:I(dn),pdop:I(dn),ageofdgpsdata:I(dn),dgpsid:I(fn),extensions:Mn});
function Yn(a,b){b||(b=[]);for(var c=0,d=b.length;c<d;++c){var e=b[c];if(a.b){var f=e.get("extensionsNode_")||null;a.b(e,f)}e.set("extensionsNode_",void 0)}}Gn.prototype.Fg=function(a,b){if(!ha(Hn,a.namespaceURI))return null;var c=Tn[a.localName];if(!c)return null;a=c(a,[Zl(this,a,b)]);if(!a)return null;Yn(this,[a]);return a};Gn.prototype.Ac=function(a,b){return ha(Hn,a.namespaceURI)?"gpx"==a.localName&&(a=L([],Un,a,[Zl(this,a,b)]))?(Yn(this,a),a):[]:[]};
function Zn(a,b,c){a.setAttribute("href",b);b=c[c.length-1].properties;Vl({node:a},$n,Sl,[b.linkText,b.linkType],c,ao)}function bo(a,b,c){var d=c[c.length-1],e=d.node.namespaceURI,f=d.properties;a.setAttributeNS(null,"lat",b[1]);a.setAttributeNS(null,"lon",b[0]);switch(d.geometryLayout){case "XYZM":b[3]&&(f.time=b[3]);case "XYZ":b[2]&&(f.ele=b[2]);break;case "XYM":b[2]&&(f.time=b[2])}b="rtept"==a.nodeName?co[e]:eo[e];d=Tl(f,b);Vl({node:a,properties:f},fo,Sl,d,c,b)}
var ao=["text","type"],$n=K(Hn,{text:J(jn),type:J(jn)}),go=K(Hn,"name cmt desc src link number type rtept".split(" ")),ho=K(Hn,{name:J(jn),cmt:J(jn),desc:J(jn),src:J(jn),link:J(Zn),number:J(ln),type:J(jn),rtept:Pl(J(bo))}),co=K(Hn,["ele","time"]),io=K(Hn,"name cmt desc src link number type trkseg".split(" ")),lo=K(Hn,{name:J(jn),cmt:J(jn),desc:J(jn),src:J(jn),link:J(Zn),number:J(ln),type:J(jn),trkseg:Pl(J(function(a,b,c){Vl({node:a,geometryLayout:b.ja,properties:{}},jo,ko,b.V(),c)}))}),ko=Ql("trkpt"),
jo=K(Hn,{trkpt:J(bo)}),eo=K(Hn,"ele time magvar geoidheight name cmt desc src link sym type fix sat hdop vdop pdop ageofdgpsdata dgpsid".split(" ")),fo=K(Hn,{ele:J(kn),time:J(function(a,b){b=new Date(1E3*b);a.appendChild(Dl.createTextNode(b.getUTCFullYear()+"-"+$e(b.getUTCMonth()+1)+"-"+$e(b.getUTCDate())+"T"+$e(b.getUTCHours())+":"+$e(b.getUTCMinutes())+":"+$e(b.getUTCSeconds())+"Z"))}),magvar:J(kn),geoidheight:J(kn),name:J(jn),cmt:J(jn),desc:J(jn),src:J(jn),link:J(Zn),sym:J(jn),type:J(jn),fix:J(jn),
sat:J(ln),hdop:J(kn),vdop:J(kn),pdop:J(kn),ageofdgpsdata:J(kn),dgpsid:J(ln)}),mo={Point:"wpt",LineString:"rte",MultiLineString:"trk"};function no(a,b){if(a=a.W())if(a=mo[a.T()])return El(b[b.length-1].node.namespaceURI,a)}
var oo=K(Hn,{rte:J(function(a,b,c){var d=c[0],e=b.N();a={node:a,properties:e};if(b=b.W())b=am(b,!0,d),a.geometryLayout=b.ja,e.rtept=b.V();d=go[c[c.length-1].node.namespaceURI];e=Tl(e,d);Vl(a,ho,Sl,e,c,d)}),trk:J(function(a,b,c){var d=c[0],e=b.N();a={node:a,properties:e};if(b=b.W())b=am(b,!0,d),e.trkseg=b.ld();d=io[c[c.length-1].node.namespaceURI];e=Tl(e,d);Vl(a,lo,Sl,e,c,d)}),wpt:J(function(a,b,c){var d=c[0],e=c[c.length-1];e.properties=b.N();if(b=b.W())b=am(b,!0,d),e.geometryLayout=b.ja,bo(a,b.V(),
c)})});Gn.prototype.Yb=function(a,b){b=$l(this,b);var c=El("http://www.topografix.com/GPX/1/1","gpx");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.topografix.com/GPX/1/1 http://www.topografix.com/GPX/1/1/gpx.xsd");c.setAttribute("version","1.1");c.setAttribute("creator","OpenLayers");Vl({node:c},oo,no,a,[b]);return c};function po(){Yl.call(this)}v(po,Yl);function qo(a){return"string"===typeof a?a:""}k=po.prototype;k.T=function(){return"text"};k.Ub=function(a,b){return this.he(qo(a),$l(this,b))};k.Oa=function(a,b){return this.Hg(qo(a),$l(this,b))};k.Vc=function(a,b){return this.Cd(qo(a),$l(this,b))};k.ob=function(){return this.defaultDataProjection};k.Gd=function(a,b){return this.re(a,$l(this,b))};k.Xb=function(a,b){return this.ah(a,$l(this,b))};k.dd=function(a,b){return this.Hd(a,$l(this,b))};function ro(a){a=a?a:{};Yl.call(this);this.defaultDataProjection=Wb("EPSG:4326");this.b=a.altitudeMode?a.altitudeMode:"none"}v(ro,po);var so=/^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/,to=/^H.([A-Z]{3}).*?:(.*)/,uo=/^HFDTE(\d{2})(\d{2})(\d{2})/,vo=/\r\n|\r|\n/;k=ro.prototype;
k.he=function(a,b){var c=this.b,d=a.split(vo);a={};var e=[],f=2E3,g=0,h=1,l=-1,m;var n=0;for(m=d.length;n<m;++n){var p=d[n],q;if("B"==p.charAt(0)){if(q=so.exec(p)){p=parseInt(q[1],10);var t=parseInt(q[2],10),u=parseInt(q[3],10),x=parseInt(q[4],10)+parseInt(q[5],10)/6E4;"S"==q[6]&&(x=-x);var B=parseInt(q[7],10)+parseInt(q[8],10)/6E4;"W"==q[9]&&(B=-B);e.push(B,x);"none"!=c&&e.push("gps"==c?parseInt(q[11],10):"barometric"==c?parseInt(q[12],10):0);q=Date.UTC(f,g,h,p,t,u);q<l&&(q=Date.UTC(f,g,h+1,p,t,
u));e.push(q/1E3);l=q}}else"H"==p.charAt(0)&&((q=uo.exec(p))?(h=parseInt(q[1],10),g=parseInt(q[2],10)-1,f=2E3+parseInt(q[3],10)):(q=to.exec(p))&&(a[q[1]]=q[2].trim()))}if(!e.length)return null;d=new M(null);d.aa("none"==c?"XYM":"XYZM",e);b=new Bl(am(d,!1,b));b.H(a);return b};k.Hg=function(a,b){return(a=this.he(a,b))?[a]:[]};k.re=function(){};k.ah=function(){};k.Hd=function(){};k.Cd=function(){};function wo(a,b,c,d,e,f){Sc.call(this);this.j=null;this.M=a?a:new Image;null!==d&&(this.M.crossOrigin=d);this.c=f?document.createElement("CANVAS"):null;this.g=f;this.i=null;this.f=e;this.a=c;this.l=b;this.o=!1;2==this.f&&xo(this)}v(wo,Sc);function xo(a){var b=ld(1,1);try{b.drawImage(a.M,0,0),b.getImageData(0,0,1,1)}catch(c){a.o=!0}}wo.prototype.v=function(){this.f=3;this.i.forEach(Gc);this.i=null;this.b("change")};
wo.prototype.u=function(){this.f=2;this.a&&(this.M.width=this.a[0],this.M.height=this.a[1]);this.a=[this.M.width,this.M.height];this.i.forEach(Gc);this.i=null;xo(this);if(!this.o&&null!==this.g){this.c.width=this.M.width;this.c.height=this.M.height;var a=this.c.getContext("2d");a.drawImage(this.M,0,0);for(var b=a.getImageData(0,0,this.M.width,this.M.height),c=b.data,d=this.g[0]/255,e=this.g[1]/255,f=this.g[2]/255,g=0,h=c.length;g<h;g+=4)c[g]*=d,c[g+1]*=e,c[g+2]*=f;a.putImageData(b,0,0)}this.b("change")};
wo.prototype.Y=function(){return this.c?this.c:this.M};wo.prototype.load=function(){if(0==this.f){this.f=1;this.i=[Lc(this.M,"error",this.v,this),Lc(this.M,"load",this.u,this)];try{this.M.src=this.l}catch(a){this.v()}}};function yo(a){a=a||{};this.l=void 0!==a.anchor?a.anchor:[.5,.5];this.u=null;this.f=void 0!==a.anchorOrigin?a.anchorOrigin:"top-left";this.B=void 0!==a.anchorXUnits?a.anchorXUnits:"fraction";this.C=void 0!==a.anchorYUnits?a.anchorYUnits:"fraction";this.qa=void 0!==a.crossOrigin?a.crossOrigin:null;var b=void 0!==a.img?a.img:null,c=void 0!==a.imgSize?a.imgSize:null,d=a.src;va(!(void 0!==d&&b),4);va(!b||b&&c,5);void 0!==d&&d.length||!b||(d=b.src||w(b).toString());va(void 0!==d&&0<d.length,6);var e=void 0!==
a.src?0:2;this.j=void 0!==a.color?gd(a.color):null;var f=this.qa,g=this.j,h=Gh.get(d,f,g);h||(h=new wo(b,d,c,f,e,g),Gh.set(d,f,g,h));this.b=h;this.pa=void 0!==a.offset?a.offset:[0,0];this.c=void 0!==a.offsetOrigin?a.offsetOrigin:"top-left";this.R=null;this.D=void 0!==a.size?a.size:null;ql.call(this,{opacity:void 0!==a.opacity?a.opacity:1,rotation:void 0!==a.rotation?a.rotation:0,scale:void 0!==a.scale?a.scale:1,snapToPixel:void 0!==a.snapToPixel?a.snapToPixel:!0,rotateWithView:void 0!==a.rotateWithView?
a.rotateWithView:!1})}v(yo,ql);k=yo.prototype;
k.clone=function(){var a=this.Y(1);if(2===this.b.f)if("IMG"===a.tagName.toUpperCase())var b=a.cloneNode(!0);else{b=document.createElement("canvas");var c=b.getContext("2d");b.width=a.width;b.height=a.height;c.drawImage(a,0,0)}return new yo({anchor:this.l.slice(),anchorOrigin:this.f,anchorXUnits:this.B,anchorYUnits:this.C,crossOrigin:this.qa,color:this.j&&this.j.slice?this.j.slice():this.j||void 0,img:b?b:void 0,imgSize:b?this.b.a.slice():void 0,src:b?void 0:this.b.l,offset:this.pa.slice(),offsetOrigin:this.c,
size:null!==this.D?this.D.slice():void 0,opacity:this.i,scale:this.a,snapToPixel:this.v,rotation:this.g,rotateWithView:this.o})};
k.Jc=function(){if(this.u)return this.u;var a=this.l,b=this.ic();if("fraction"==this.B||"fraction"==this.C){if(!b)return null;a=this.l.slice();"fraction"==this.B&&(a[0]*=b[0]);"fraction"==this.C&&(a[1]*=b[1])}if("top-left"!=this.f){if(!b)return null;a===this.l&&(a=this.l.slice());if("top-right"==this.f||"bottom-right"==this.f)a[0]=-a[0]+b[0];if("bottom-left"==this.f||"bottom-right"==this.f)a[1]=-a[1]+b[1]}return this.u=a};k.Yo=function(){return this.j};k.Y=function(a){return this.b.Y(a)};k.Ie=function(){return this.b.a};
k.hf=function(){return this.b.f};k.yg=function(){var a=this.b;if(!a.j)if(a.o){var b=a.a[0],c=a.a[1],d=ld(b,c);d.fillRect(0,0,b,c);a.j=d.canvas}else a.j=a.M;return a.j};k.Rc=function(){if(this.R)return this.R;var a=this.pa;if("top-left"!=this.c){var b=this.ic(),c=this.b.a;if(!b||!c)return null;a=a.slice();if("top-right"==this.c||"bottom-right"==this.c)a[0]=c[0]-b[0]-a[0];if("bottom-left"==this.c||"bottom-right"==this.c)a[1]=c[1]-b[1]-a[1]}return this.R=a};k.Zo=function(){return this.b.l};
k.ic=function(){return this.D?this.D:this.b.a};k.Wh=function(a,b){return y(this.b,"change",a,b)};k.load=function(){this.b.load()};k.Lj=function(a,b){Mc(this.b,"change",a,b)};function zo(a){a=a||{};this.a=a.font;this.i=a.rotation;this.l=a.rotateWithView;this.b=a.scale;this.ua=a.text;this.g=a.textAlign;this.j=a.textBaseline;this.Wa=void 0!==a.fill?a.fill:new ul({color:"#333"});this.Ua=void 0!==a.stroke?a.stroke:null;this.f=void 0!==a.offsetX?a.offsetX:0;this.c=void 0!==a.offsetY?a.offsetY:0}k=zo.prototype;
k.clone=function(){return new zo({font:this.a,rotation:this.i,rotateWithView:this.l,scale:this.b,text:this.Ja(),textAlign:this.g,textBaseline:this.j,fill:this.Da()?this.Da().clone():void 0,stroke:this.Ea()?this.Ea().clone():void 0,offsetX:this.f,offsetY:this.c})};k.Zk=function(){return this.a};k.ol=function(){return this.f};k.pl=function(){return this.c};k.Da=function(){return this.Wa};k.ep=function(){return this.l};k.fp=function(){return this.i};k.gp=function(){return this.b};k.Ea=function(){return this.Ua};
k.Ja=function(){return this.ua};k.zl=function(){return this.g};k.Al=function(){return this.j};k.xj=function(a){this.a=a};k.Cj=function(a){this.f=a};k.Dj=function(a){this.c=a};k.zf=function(a){this.Wa=a};k.hp=function(a){this.i=a};k.bj=function(a){this.b=a};k.Af=function(a){this.Ua=a};k.Dd=function(a){this.ua=a};k.Fj=function(a){this.g=a};k.vq=function(a){this.j=a};function Ao(a){a=a?a:{};Wm.call(this);Bo||(Co=[255,255,255,1],Do=new ul({color:Co}),Eo=[20,2],Fo=Go="pixels",Ho=[64,64],Io="https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png",Jo=.5,Ko=new yo({anchor:Eo,anchorOrigin:"bottom-left",anchorXUnits:Go,anchorYUnits:Fo,crossOrigin:"anonymous",rotation:0,scale:Jo,size:Ho,src:Io}),Lo="NO_IMAGE",Mo=new Ej({color:Co,width:1}),No=new Ej({color:[51,51,51,1],width:2}),Oo=new zo({font:"bold 16px Helvetica",fill:Do,stroke:No,scale:.8}),Po=new vl({fill:Do,
image:Ko,text:Oo,stroke:Mo,zIndex:0}),Bo=[Po]);this.defaultDataProjection=Wb("EPSG:4326");this.a=a.defaultStyle?a.defaultStyle:Bo;this.c=void 0!==a.extractStyles?a.extractStyles:!0;this.j=void 0!==a.writeStyles?a.writeStyles:!0;this.b={};this.g=void 0!==a.showPointNames?a.showPointNames:!0}var Bo,Co,Do,Eo,Go,Fo,Ho,Io,Jo,Ko,Lo,Mo,No,Oo,Po;v(Ao,Wm);
var Qo=["http://www.google.com/kml/ext/2.2"],Ro=[null,"http://earth.google.com/kml/2.0","http://earth.google.com/kml/2.1","http://earth.google.com/kml/2.2","http://www.opengis.net/kml/2.2"],So={fraction:"fraction",pixels:"pixels",insetPixels:"pixels"};
function To(a,b){var c=[0,0],d="start";if(a.Y()){var e=a.Y().Ie();null===e&&(e=Ho);2==e.length&&(d=a.Y().a,c[0]=d*e[0]/2,c[1]=-d*e[1]/2,d="left")}null!==a.Ja()?(e=a.Ja(),a=e.clone(),a.xj(e.a||Oo.a),a.bj(e.b||Oo.b),a.zf(e.Da()||Oo.Da()),a.Af(e.Ea()||No)):a=Oo.clone();a.Dd(b);a.Cj(c[0]);a.Dj(c[1]);a.Fj(d);return new vl({text:a})}
function Uo(a,b,c,d,e){return function(){var f=e,g="";f&&this.W()&&(f="Point"===this.W().T());f&&(g=this.get("name"),f=f&&g);if(a)return f?(f=To(a[0],g),a.concat(f)):a;if(b){var h=Vo(b,c,d);return f?(f=To(h[0],g),h.concat(f)):h}return f?(f=To(c[0],g),c.concat(f)):c}}function Vo(a,b,c){return Array.isArray(a)?a:"string"===typeof a?(!(a in c)&&"#"+a in c&&(a="#"+a),Vo(c[a],b,c)):b}
function Wo(a){a=Fl(a,!1);if(a=/^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(a))return a=a[1],[parseInt(a.substr(6,2),16),parseInt(a.substr(4,2),16),parseInt(a.substr(2,2),16),parseInt(a.substr(0,2),16)/255]}function Xo(a){a=Fl(a,!1);for(var b=[],c=/^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s*,\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?))?\s*/i,d;d=c.exec(a);)b.push(parseFloat(d[1]),parseFloat(d[2]),d[3]?parseFloat(d[3]):0),a=a.substr(d[0].length);if(""===a)return b}
function Yo(a){var b=Fl(a,!1).trim();return a.baseURI&&"about:blank"!==a.baseURI?(new URL(b,a.baseURI)).href:b}function Zo(a){return dn(a)}function $o(a,b){return L(null,ap,a,b)}function bp(a,b){if(b=L({A:[],Oj:[]},cp,a,b)){a=b.A;b=b.Oj;var c;var d=0;for(c=Math.min(a.length,b.length);d<c;++d)a[4*d+3]=b[d];b=new M(null);b.aa("XYZM",a);return b}}function dp(a,b){var c=L({},ep,a,b);if(a=L(null,fp,a,b))return b=new M(null),b.aa("XYZ",a),b.H(c),b}
function gp(a,b){var c=L({},ep,a,b);if(a=L(null,fp,a,b))return b=new D(null),b.aa("XYZ",a,[a.length]),b.H(c),b}
function hp(a,b){a=L([],ip,a,b);if(!a)return null;if(!a.length)return new Nm(a);var c=!0,d=a[0].T(),e;var f=1;for(e=a.length;f<e;++f)if(b=a[f],b.T()!=d){c=!1;break}if(c)if("Point"==d){var g=a[0];c=g.ja;d=g.ba();f=1;for(e=a.length;f<e;++f)b=a[f],ka(d,b.ba());g=new O(null);g.aa(c,d);jp(g,a)}else"LineString"==d?(g=new N(null),gm(g,a),jp(g,a)):"Polygon"==d?(g=new P(null),im(g,a),jp(g,a)):"GeometryCollection"==d?g=new Nm(a):va(!1,37);else g=new Nm(a);return g}
function kp(a,b){var c=L({},ep,a,b);if(a=L(null,fp,a,b))return b=new C(null),b.aa("XYZ",a),b.H(c),b}function lp(a,b){var c=L({},ep,a,b);if((a=L([null],mp,a,b))&&a[0]){b=new D(null);var d=a[0],e=[d.length],f;var g=1;for(f=a.length;g<f;++g)ka(d,a[g]),e.push(d.length);b.aa("XYZ",d,e);b.H(c);return b}}
function np(a,b){b=L({},op,a,b);if(!b)return null;a="fillStyle"in b?b.fillStyle:Do;var c=b.fill;void 0===c||c||(a=null);c="imageStyle"in b?b.imageStyle:Ko;c==Lo&&(c=void 0);var d="textStyle"in b?b.textStyle:Oo,e="strokeStyle"in b?b.strokeStyle:Mo;b=b.outline;void 0===b||b||(e=null);return[new vl({fill:a,image:c,stroke:e,text:d,zIndex:void 0})]}
function jp(a,b){var c=b.length,d=Array(b.length),e=Array(b.length),f=Array(b.length),g,h,l;var m=h=l=!1;for(g=0;g<c;++g){var n=b[g];d[g]=n.get("extrude");e[g]=n.get("tessellate");f[g]=n.get("altitudeMode");m=m||void 0!==d[g];h=h||void 0!==e[g];l=l||f[g]}m&&a.set("extrude",d);h&&a.set("tessellate",e);l&&a.set("altitudeMode",f)}function pp(a,b){Ul(qp,a,b)}function rp(a,b){Ul(sp,a,b)}
var tp=K(Ro,{displayName:I(Q),value:I(Q)}),qp=K(Ro,{Data:function(a,b){var c=a.getAttribute("name");Ul(tp,a,b);a=b[b.length-1];null!==c?a[c]=a.value:null!==a.displayName&&(a[a.displayName]=a.value);delete a.value},SchemaData:function(a,b){Ul(up,a,b)}}),sp=K(Ro,{LatLonAltBox:function(a,b){if(a=L({},vp,a,b))b=b[b.length-1],b.extent=[parseFloat(a.west),parseFloat(a.south),parseFloat(a.east),parseFloat(a.north)],b.altitudeMode=a.altitudeMode,b.minAltitude=parseFloat(a.minAltitude),b.maxAltitude=parseFloat(a.maxAltitude)},
Lod:function(a,b){if(a=L({},wp,a,b))b=b[b.length-1],b.minLodPixels=parseFloat(a.minLodPixels),b.maxLodPixels=parseFloat(a.maxLodPixels),b.minFadeExtent=parseFloat(a.minFadeExtent),b.maxFadeExtent=parseFloat(a.maxFadeExtent)}}),vp=K(Ro,{altitudeMode:I(Q),minAltitude:I(dn),maxAltitude:I(dn),north:I(dn),south:I(dn),east:I(dn),west:I(dn)}),wp=K(Ro,{minLodPixels:I(dn),maxLodPixels:I(dn),minFadeExtent:I(dn),maxFadeExtent:I(dn)}),ep=K(Ro,{extrude:I(an),tessellate:I(an),altitudeMode:I(Q)}),ap=K(Ro,{coordinates:Nl(Xo)}),
mp=K(Ro,{innerBoundaryIs:function(a,b){(a=L(void 0,xp,a,b))&&b[b.length-1].push(a)},outerBoundaryIs:function(a,b){(a=L(void 0,yp,a,b))&&(b[b.length-1][0]=a)}}),cp=K(Ro,{when:function(a,b){b=b[b.length-1].Oj;a=Fl(a,!1);a=Date.parse(a);b.push(isNaN(a)?0:a)}},K(Qo,{coord:function(a,b){b=b[b.length-1].A;a=Fl(a,!1);(a=/^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i.exec(a))?b.push(parseFloat(a[1]),parseFloat(a[2]),parseFloat(a[3]),
0):b.push(0,0,0,0)}})),fp=K(Ro,{coordinates:Nl(Xo)}),zp=K(Ro,{href:I(Yo)},K(Qo,{x:I(dn),y:I(dn),w:I(dn),h:I(dn)})),Ap=K(Ro,{Icon:I(function(a,b){return(a=L({},zp,a,b))?a:null}),heading:I(dn),hotSpot:I(function(a){var b=a.getAttribute("xunits"),c=a.getAttribute("yunits");var d="insetPixels"!==b?"insetPixels"!==c?"bottom-left":"top-left":"insetPixels"!==c?"bottom-right":"top-right";return{x:parseFloat(a.getAttribute("x")),bh:So[b],y:parseFloat(a.getAttribute("y")),dh:So[c],origin:d}}),scale:I(Zo)}),
xp=K(Ro,{LinearRing:Nl($o)}),Bp=K(Ro,{color:I(Wo),scale:I(Zo)}),Cp=K(Ro,{color:I(Wo),width:I(dn)}),ip=K(Ro,{LineString:Ll(dp),LinearRing:Ll(gp),MultiGeometry:Ll(hp),Point:Ll(kp),Polygon:Ll(lp)}),Dp=K(Qo,{Track:Ll(bp)}),Fp=K(Ro,{ExtendedData:pp,Region:rp,Link:function(a,b){Ul(Ep,a,b)},address:I(Q),description:I(Q),name:I(Q),open:I(an),phoneNumber:I(Q),visibility:I(an)}),Ep=K(Ro,{href:I(Yo)}),yp=K(Ro,{LinearRing:Nl($o)}),Gp=K(Ro,{Style:I(np),key:I(Q),styleUrl:I(Yo)}),Ip=K(Ro,{ExtendedData:pp,Region:rp,
MultiGeometry:I(hp,"geometry"),LineString:I(dp,"geometry"),LinearRing:I(gp,"geometry"),Point:I(kp,"geometry"),Polygon:I(lp,"geometry"),Style:I(np),StyleMap:function(a,b){if(a=L(void 0,Hp,a,b))b=b[b.length-1],Array.isArray(a)?b.Style=a:"string"===typeof a?b.styleUrl=a:va(!1,38)},address:I(Q),description:I(Q),name:I(Q),open:I(an),phoneNumber:I(Q),styleUrl:I(Yo),visibility:I(an)},K(Qo,{MultiTrack:I(function(a,b){if(a=L([],Dp,a,b))return b=new N(null),gm(b,a),b},"geometry"),Track:I(bp,"geometry")})),
Jp=K(Ro,{color:I(Wo),fill:I(an),outline:I(an)}),up=K(Ro,{SimpleData:function(a,b){var c=a.getAttribute("name");null!==c&&(a=Q(a),b[b.length-1][c]=a)}}),op=K(Ro,{IconStyle:function(a,b){if(a=L({},Ap,a,b)){b=b[b.length-1];var c="Icon"in a?a.Icon:{},d=!("Icon"in a)||0<Object.keys(c).length,e,f=c.href;f?e=f:d&&(e=Io);f="bottom-left";var g=a.hotSpot;if(g){var h=[g.x,g.y];var l=g.bh;var m=g.dh;f=g.origin}else e===Io?(h=Eo,l=Go,m=Fo):/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(e)&&(h=[.5,0],m=l="fraction");
var n;g=c.x;var p=c.y;void 0!==g&&void 0!==p&&(n=[g,p]);var q;g=c.w;c=c.h;void 0!==g&&void 0!==c&&(q=[g,c]);var t;c=a.heading;void 0!==c&&(t=Fa(c));a=a.scale;d?(e==Io&&(q=Ho,void 0===a&&(a=Jo)),e=new yo({anchor:h,anchorOrigin:f,anchorXUnits:l,anchorYUnits:m,crossOrigin:"anonymous",offset:n,offsetOrigin:"bottom-left",rotation:t,scale:a,size:q,src:e}),b.imageStyle=e):b.imageStyle=Lo}},LabelStyle:function(a,b){(a=L({},Bp,a,b))&&(b[b.length-1].textStyle=new zo({fill:new ul({color:"color"in a?a.color:
Co}),scale:a.scale}))},LineStyle:function(a,b){(a=L({},Cp,a,b))&&(b[b.length-1].strokeStyle=new Ej({color:"color"in a?a.color:Co,width:"width"in a?a.width:1}))},PolyStyle:function(a,b){if(a=L({},Jp,a,b)){b=b[b.length-1];b.fillStyle=new ul({color:"color"in a?a.color:Co});var c=a.fill;void 0!==c&&(b.fill=c);a=a.outline;void 0!==a&&(b.outline=a)}}}),Hp=K(Ro,{Pair:function(a,b){if(a=L({},Gp,a,b)){var c=a.key;c&&"normal"==c&&((c=a.styleUrl)&&(b[b.length-1]=c),(a=a.Style)&&(b[b.length-1]=a))}}});k=Ao.prototype;
k.Dg=function(a,b){var c=K(Ro,{Document:Kl(this.Dg,this),Folder:Kl(this.Dg,this),Placemark:Ll(this.Lg,this),Style:this.Wp.bind(this),StyleMap:this.Vp.bind(this)});if(a=L([],c,a,b,this))return a};k.Lg=function(a,b){var c=L({geometry:null},Ip,a,b);if(c){var d=new Bl;a=a.getAttribute("id");null!==a&&d.kc(a);b=b[0];(a=c.geometry)&&am(a,!1,b);d.Ra(a);delete c.geometry;this.c&&d.pg(Uo(c.Style,c.styleUrl,this.a,this.b,this.g));delete c.Style;d.H(c);return d}};
k.Wp=function(a,b){var c=a.getAttribute("id");null!==c&&(b=np(a,b))&&(a=a.baseURI&&"about:blank"!==a.baseURI?(new URL("#"+c,a.baseURI)).href:"#"+c,this.b[a]=b)};k.Vp=function(a,b){var c=a.getAttribute("id");null!==c&&(b=L(void 0,Hp,a,b))&&(a=a.baseURI&&"about:blank"!==a.baseURI?(new URL("#"+c,a.baseURI)).href:"#"+c,this.b[a]=b)};k.Fg=function(a,b){return ha(Ro,a.namespaceURI)?(a=this.Lg(a,[Zl(this,a,b)]))?a:null:null};
k.Ac=function(a,b){if(!ha(Ro,a.namespaceURI))return[];var c=a.localName;if("Document"==c||"Folder"==c)return(c=this.Dg(a,[Zl(this,a,b)]))?c:[];if("Placemark"==c)return(b=this.Lg(a,[Zl(this,a,b)]))?[b]:[];if("kml"==c){c=[];for(a=a.firstElementChild;a;a=a.nextElementSibling){var d=this.Ac(a,b);d&&ka(c,d)}return c}return[]};k.Pp=function(a){if(Hl(a))return Kp(this,a);if(Il(a))return Lp(this,a);if("string"===typeof a)return a=Jl(a),Kp(this,a)};
function Kp(a,b){for(b=b.firstChild;b;b=b.nextSibling)if(b.nodeType==Node.ELEMENT_NODE){var c=Lp(a,b);if(c)return c}}function Lp(a,b){var c;for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ha(Ro,c.namespaceURI)&&"name"==c.localName)return Q(c);for(c=b.firstElementChild;c;c=c.nextElementSibling)if(b=c.localName,ha(Ro,c.namespaceURI)&&("Document"==b||"Folder"==b||"Placemark"==b||"kml"==b)&&(b=Lp(a,c)))return b}
k.Qp=function(a){var b=[];Hl(a)?ka(b,Mp(this,a)):Il(a)?ka(b,Np(this,a)):"string"===typeof a&&(a=Jl(a),ka(b,Mp(this,a)));return b};function Mp(a,b){var c=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ka(c,Np(a,b));return c}
function Np(a,b){var c,d=[];for(c=b.firstElementChild;c;c=c.nextElementSibling)if(ha(Ro,c.namespaceURI)&&"NetworkLink"==c.localName){var e=L({},Fp,c,[]);d.push(e)}for(c=b.firstElementChild;c;c=c.nextElementSibling)b=c.localName,!ha(Ro,c.namespaceURI)||"Document"!=b&&"Folder"!=b&&"kml"!=b||ka(d,Np(a,c));return d}k.Tp=function(a){var b=[];Hl(a)?ka(b,Op(this,a)):Il(a)?ka(b,this.wf(a)):"string"===typeof a&&(a=Jl(a),ka(b,Op(this,a)));return b};
function Op(a,b){var c=[];for(b=b.firstChild;b;b=b.nextSibling)b.nodeType==Node.ELEMENT_NODE&&ka(c,a.wf(b));return c}k.wf=function(a){var b,c=[];for(b=a.firstElementChild;b;b=b.nextElementSibling)if(ha(Ro,b.namespaceURI)&&"Region"==b.localName){var d=L({},sp,b,[]);c.push(d)}for(b=a.firstElementChild;b;b=b.nextElementSibling)a=b.localName,!ha(Ro,b.namespaceURI)||"Document"!=a&&"Folder"!=a&&"kml"!=a||ka(c,this.wf(b));return c};
function Pp(a,b){b=gd(b);b=[255*(4==b.length?b[3]:1),b[2],b[1],b[0]];var c;for(c=0;4>c;++c){var d=parseInt(b[c],10).toString(16);b[c]=1==d.length?"0"+d:d}jn(a,b.join(""))}function Qp(a,b,c){a={node:a};var d=b.T();if("GeometryCollection"==d){var e=b.kd();var f=Rp}else"MultiPoint"==d?(e=b.ee(),f=Sp):"MultiLineString"==d?(e=b.ld(),f=Tp):"MultiPolygon"==d?(e=b.$d(),f=Up):va(!1,39);Vl(a,Vp,f,e,c)}function Wp(a,b,c){Vl({node:a},Xp,Yp,[b],c)}
function Zp(a,b,c){var d={node:a};b.a&&a.setAttribute("id",b.a);a=b.N();var e={address:1,description:1,name:1,open:1,phoneNumber:1,styleUrl:1,visibility:1};e[b.c]=1;var f=Object.keys(a||{}).sort().filter(function(a){return!e[a]});if(0<f.length){var g=Tl(a,f);Vl(d,$p,aq,[{names:f,values:g}],c)}if(f=b.bb())if(f=f.call(b,0))f=Array.isArray(f)?f[0]:f,this.j&&(a.Style=f),(f=f.Ja())&&(a.name=f.Ja());f=bq[c[c.length-1].node.namespaceURI];a=Tl(a,f);Vl(d,$p,Sl,a,c,f);a=c[0];(b=b.W())&&(b=am(b,!0,a));Vl(d,
$p,Rp,[b],c)}function cq(a,b,c){var d=b.ba();a={node:a};a.layout=b.ja;a.stride=b.ma();b=b.N();b.coordinates=d;d=dq[c[c.length-1].node.namespaceURI];b=Tl(b,d);Vl(a,eq,Sl,b,c,d)}function fq(a,b,c){b=b.Zd();var d=b.shift();a={node:a};Vl(a,gq,hq,b,c);Vl(a,gq,iq,[d],c)}function jq(a,b){kn(a,Math.round(1E6*b)/1E6)}
var kq=K(Ro,["Document","Placemark"]),nq=K(Ro,{Document:J(function(a,b,c){Vl({node:a},lq,mq,b,c,void 0,this)}),Placemark:J(Zp)}),lq=K(Ro,{Placemark:J(Zp)}),oq=K(Ro,{Data:J(function(a,b,c){a.setAttribute("name",b.name);a={node:a};b=b.value;"object"==typeof b?(null!==b&&b.displayName&&Vl(a,oq,Sl,[b.displayName],c,["displayName"]),null!==b&&b.value&&Vl(a,oq,Sl,[b.value],c,["value"])):Vl(a,oq,Sl,[b],c,["value"])}),value:J(function(a,b){jn(a,b)}),displayName:J(function(a,b){a.appendChild(Dl.createCDATASection(b))})}),
pq={Point:"Point",LineString:"LineString",LinearRing:"LinearRing",Polygon:"Polygon",MultiPoint:"MultiGeometry",MultiLineString:"MultiGeometry",MultiPolygon:"MultiGeometry",GeometryCollection:"MultiGeometry"},qq=K(Ro,["href"],K(Qo,["x","y","w","h"])),rq=K(Ro,{href:J(jn)},K(Qo,{x:J(kn),y:J(kn),w:J(kn),h:J(kn)})),sq=K(Ro,["scale","heading","Icon","hotSpot"]),uq=K(Ro,{Icon:J(function(a,b,c){a={node:a};var d=qq[c[c.length-1].node.namespaceURI],e=Tl(b,d);Vl(a,rq,Sl,e,c,d);d=qq[Qo[0]];e=Tl(b,d);Vl(a,rq,
tq,e,c,d)}),heading:J(kn),hotSpot:J(function(a,b){a.setAttribute("x",b.x);a.setAttribute("y",b.y);a.setAttribute("xunits",b.bh);a.setAttribute("yunits",b.dh)}),scale:J(jq)}),vq=K(Ro,["color","scale"]),wq=K(Ro,{color:J(Pp),scale:J(jq)}),xq=K(Ro,["color","width"]),yq=K(Ro,{color:J(Pp),width:J(kn)}),Xp=K(Ro,{LinearRing:J(cq)}),Vp=K(Ro,{LineString:J(cq),Point:J(cq),Polygon:J(fq),GeometryCollection:J(Qp)}),bq=K(Ro,"name open visibility address phoneNumber description styleUrl Style".split(" ")),$p=K(Ro,
{ExtendedData:J(function(a,b,c){a={node:a};var d=b.names;b=b.values;for(var e=d.length,f=0;f<e;f++)Vl(a,oq,zq,[{name:d[f],value:b[f]}],c)}),MultiGeometry:J(Qp),LineString:J(cq),LinearRing:J(cq),Point:J(cq),Polygon:J(fq),Style:J(function(a,b,c){a={node:a};var d={},e=b.Da(),f=b.Ea(),g=b.Y();b=b.Ja();g instanceof yo&&(d.IconStyle=g);b&&(d.LabelStyle=b);f&&(d.LineStyle=f);e&&(d.PolyStyle=e);b=Aq[c[c.length-1].node.namespaceURI];d=Tl(d,b);Vl(a,Bq,Sl,d,c,b)}),address:J(jn),description:J(jn),name:J(jn),
open:J(hn),phoneNumber:J(jn),styleUrl:J(jn),visibility:J(hn)}),dq=K(Ro,["extrude","tessellate","altitudeMode","coordinates"]),eq=K(Ro,{extrude:J(hn),tessellate:J(hn),altitudeMode:J(jn),coordinates:J(function(a,b,c){c=c[c.length-1];var d=c.layout;c=c.stride;var e;"XY"==d||"XYM"==d?e=2:"XYZ"==d||"XYZM"==d?e=3:va(!1,34);var f,g=b.length,h="";if(0<g){h+=b[0];for(d=1;d<e;++d)h+=","+b[d];for(f=c;f<g;f+=c)for(h+=" "+b[f],d=1;d<e;++d)h+=","+b[f+d]}jn(a,h)})}),gq=K(Ro,{outerBoundaryIs:J(Wp),innerBoundaryIs:J(Wp)}),
Cq=K(Ro,{color:J(Pp)}),Aq=K(Ro,["IconStyle","LabelStyle","LineStyle","PolyStyle"]),Bq=K(Ro,{IconStyle:J(function(a,b,c){a={node:a};var d={},e=b.ic(),f=b.Ie(),g={href:b.b.l};if(e){g.w=e[0];g.h=e[1];var h=b.Jc(),l=b.Rc();l&&f&&l[0]&&l[1]!==e[1]&&(g.x=l[0],g.y=f[1]-(l[1]+e[1]));!h||h[0]===e[0]/2&&h[1]===e[1]/2||(d.hotSpot={x:h[0],bh:"pixels",y:e[1]-h[1],dh:"pixels"})}d.Icon=g;e=b.a;1!==e&&(d.scale=e);(b=b.g)&&(d.heading=b);b=sq[c[c.length-1].node.namespaceURI];d=Tl(d,b);Vl(a,uq,Sl,d,c,b)}),LabelStyle:J(function(a,
b,c){a={node:a};var d={},e=b.Da();e&&(d.color=e.b);(b=b.b)&&1!==b&&(d.scale=b);b=vq[c[c.length-1].node.namespaceURI];d=Tl(d,b);Vl(a,wq,Sl,d,c,b)}),LineStyle:J(function(a,b,c){a={node:a};var d=xq[c[c.length-1].node.namespaceURI];b=Tl({color:b.b,width:b.c},d);Vl(a,yq,Sl,b,c,d)}),PolyStyle:J(function(a,b,c){Vl({node:a},Cq,Dq,[b.b],c)})});function tq(a,b,c){return El(Qo[0],"gx:"+c)}function mq(a,b){return El(b[b.length-1].node.namespaceURI,"Placemark")}
function Rp(a,b){if(a)return El(b[b.length-1].node.namespaceURI,pq[a.T()])}var Dq=Ql("color"),zq=Ql("Data"),aq=Ql("ExtendedData"),hq=Ql("innerBoundaryIs"),Sp=Ql("Point"),Tp=Ql("LineString"),Yp=Ql("LinearRing"),Up=Ql("Polygon"),iq=Ql("outerBoundaryIs");
Ao.prototype.Yb=function(a,b){b=$l(this,b);var c=El(Ro[4],"kml");c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:gx",Qo[0]);c.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:xsi","http://www.w3.org/2001/XMLSchema-instance");c.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation","http://www.opengis.net/kml/2.2 https://developers.google.com/kml/schema/kml22gx.xsd");var d={node:c},e={};1<a.length?e.Document=a:1==a.length&&(e.Placemark=a[0]);a=kq[c.namespaceURI];
e=Tl(e,a);Vl(d,nq,Sl,e,[b],a,this);return c};Nj.Id=function(){};
(function(a){function b(a){this.nc=ArrayBuffer.isView&&ArrayBuffer.isView(a)?a:new Uint8Array(a||0);this.type=this.fa=0;this.length=this.nc.length}function c(a,b,c){var e=c.nc;var f=e[c.fa++];var g=(f&112)>>4;if(128>f)return d(a,g,b);f=e[c.fa++];g|=(f&127)<<3;if(128>f)return d(a,g,b);f=e[c.fa++];g|=(f&127)<<10;if(128>f)return d(a,g,b);f=e[c.fa++];g|=(f&127)<<17;if(128>f)return d(a,g,b);f=e[c.fa++];g|=(f&127)<<24;if(128>f)return d(a,g,b);f=e[c.fa++];if(128>f)return d(a,g|(f&1)<<31,b);throw Error("Expected varint not more than 10 bytes");
}function d(a,b,c){return c?4294967296*b+(a>>>0):4294967296*(b>>>0)+(a>>>0)}var e={read:function(a,b,c,d,e){var f=8*e-d-1;var g=(1<<f)-1,h=g>>1,l=-7;e=c?e-1:0;var m=c?-1:1,x=a[b+e];e+=m;c=x&(1<<-l)-1;x>>=-l;for(l+=f;0<l;c=256*c+a[b+e],e+=m,l-=8);f=c&(1<<-l)-1;c>>=-l;for(l+=d;0<l;f=256*f+a[b+e],e+=m,l-=8);if(0===c)c=1-h;else{if(c===g)return f?NaN:Infinity*(x?-1:1);f+=Math.pow(2,d);c-=h}return(x?-1:1)*f*Math.pow(2,c-d)},write:function(a,b,c,d,e,n){var f,g=8*n-e-1,h=(1<<g)-1,l=h>>1,m=23===e?Math.pow(2,
-24)-Math.pow(2,-77):0;n=d?0:n-1;var B=d?1:-1,z=0>b||0===b&&0>1/b?1:0;b=Math.abs(b);isNaN(b)||Infinity===b?(b=isNaN(b)?1:0,d=h):(d=Math.floor(Math.log(b)/Math.LN2),1>b*(f=Math.pow(2,-d))&&(d--,f*=2),b=1<=d+l?b+m/f:b+m*Math.pow(2,1-l),2<=b*f&&(d++,f/=2),d+l>=h?(b=0,d=h):1<=d+l?(b=(b*f-1)*Math.pow(2,e),d+=l):(b=b*Math.pow(2,l-1)*Math.pow(2,e),d=0));for(;8<=e;a[c+n]=b&255,n+=B,b/=256,e-=8);d=d<<e|b;for(g+=e;0<g;a[c+n]=d&255,n+=B,d/=256,g-=8);a[c+n-B]|=128*z}};b.c=0;b.f=1;b.b=2;b.a=5;b.prototype={Ig:function(a,
b,c){for(c=c||this.length;this.fa<c;){var d=this.La(),e=d>>3,f=this.fa;this.type=d&7;a(e,b,this);this.fa===f&&this.Aq(d)}return b},Lp:function(){var a=e.read(this.nc,this.fa,!0,23,4);this.fa+=4;return a},Hp:function(){var a=e.read(this.nc,this.fa,!0,52,8);this.fa+=8;return a},La:function(a){var b=this.nc;var d=b[this.fa++];var e=d&127;if(128>d)return e;d=b[this.fa++];e|=(d&127)<<7;if(128>d)return e;d=b[this.fa++];e|=(d&127)<<14;if(128>d)return e;d=b[this.fa++];e|=(d&127)<<21;if(128>d)return e;d=b[this.fa];
return c(e|(d&15)<<28,a,this)},Xp:function(){return this.La(!0)},je:function(){var a=this.La();return 1===a%2?(a+1)/-2:a/2},Fp:function(){return!!this.La()},Og:function(){for(var a=this.La()+this.fa,b=this.nc,c="",d=this.fa;d<a;){var e=b[d],n=null,p=239<e?4:223<e?3:191<e?2:1;if(d+p>a)break;if(1===p)128>e&&(n=e);else if(2===p){var q=b[d+1];128===(q&192)&&(n=(e&31)<<6|q&63,127>=n&&(n=null))}else if(3===p){q=b[d+1];var t=b[d+2];128===(q&192)&&128===(t&192)&&(n=(e&15)<<12|(q&63)<<6|t&63,2047>=n||55296<=
n&&57343>=n)&&(n=null)}else if(4===p){q=b[d+1];t=b[d+2];var u=b[d+3];128===(q&192)&&128===(t&192)&&128===(u&192)&&(n=(e&15)<<18|(q&63)<<12|(t&63)<<6|u&63,65535>=n||1114112<=n)&&(n=null)}null===n?(n=65533,p=1):65535<n&&(n-=65536,c+=String.fromCharCode(n>>>10&1023|55296),n=56320|n&1023);c+=String.fromCharCode(n);d+=p}this.fa=a;return c},Aq:function(a){a&=7;if(a===b.c)for(;127<this.nc[this.fa++];);else if(a===b.b)this.fa=this.La()+this.fa;else if(a===b.a)this.fa+=4;else if(a===b.f)this.fa+=8;else throw Error("Unimplemented type: "+
a);}};a["default"]=b})(Nj.Id=Nj.Id||{});Nj.Id=Nj.Id.default;Nj.Gf={};Nj.Gf.Kf=function(){};
(function(a){function b(a,b){this.layers=a.Ig(l,{},b)}function c(a,b){this.x=a;this.y=b}function d(a,b,c,d,f){this.properties={};this.extent=c;this.type=0;this.Dc=a;this.Mf=-1;this.ye=d;this.Ae=f;a.Ig(e,this,b)}function e(a,b,c){if(1==a)b.id=c.La();else if(2==a)for(a=c.La()+c.fa;c.fa<a;){var d=b.ye[c.La()],e=b.Ae[c.La()];b.properties[d]=e}else 3==a?b.type=c.La():4==a&&(b.Mf=c.fa)}function f(a,b){this.version=1;this.name=null;this.extent=4096;this.length=0;this.Dc=a;this.ye=[];this.Ae=[];this.xe=[];
a.Ig(g,this,b);this.length=this.xe.length}function g(a,b,c){15===a?b.version=c.La():1===a?b.name=c.Og():5===a?b.extent=c.La():2===a?b.xe.push(c.fa):3===a?b.ye.push(c.Og()):4===a&&b.Ae.push(h(c))}function h(a){for(var b=null,c=a.La()+a.fa;a.fa<c;)b=a.La()>>3,b=1===b?a.Og():2===b?a.Lp():3===b?a.Hp():4===b?a.Xp():5===b?a.La():6===b?a.je():7===b?a.Fp():null;return b}function l(a,b,c){3===a&&(a=new m(c,c.La()+c.fa),a.length&&(b[a.name]=a))}c.prototype={clone:function(){return new c(this.x,this.y)},add:function(a){return this.clone().hk(a)},
rotate:function(a){return this.clone().sk(a)},round:function(){return this.clone().tk()},angle:function(){return Math.atan2(this.y,this.x)},hk:function(a){this.x+=a.x;this.y+=a.y;return this},sk:function(a){var b=Math.cos(a);a=Math.sin(a);var c=a*this.x+b*this.y;this.x=b*this.x-a*this.y;this.y=c;return this},tk:function(){this.x=Math.round(this.x);this.y=Math.round(this.y);return this}};c.Zq=function(a){return a instanceof c?a:Array.isArray(a)?new c(a[0],a[1]):a};d.b=["Unknown","Point","LineString",
"Polygon"];d.prototype.Xh=function(){var a=this.Dc;a.fa=this.Mf;for(var b=a.La()+a.fa,d=1,e=0,f=0,g=0,h=[],l;a.fa<b;)if(e||(e=a.La(),d=e&7,e>>=3),e--,1===d||2===d)f+=a.je(),g+=a.je(),1===d&&(l&&h.push(l),l=[]),l.push(new c(f,g));else if(7===d)l&&l.push(l[0].clone());else throw Error("unknown command "+d);l&&h.push(l);return h};d.prototype.bbox=function(){var a=this.Dc;a.fa=this.Mf;for(var b=a.La()+a.fa,c=1,d=0,e=0,f=0,g=Infinity,h=-Infinity,l=Infinity,m=-Infinity;a.fa<b;)if(d||(d=a.La(),c=d&7,d>>=
3),d--,1===c||2===c)e+=a.je(),f+=a.je(),e<g&&(g=e),e>h&&(h=e),f<l&&(l=f),f>m&&(m=f);else if(7!==c)throw Error("unknown command "+c);return[g,l,h,m]};var m=f;f.prototype.feature=function(a){if(0>a||a>=this.xe.length)throw Error("feature index out of bounds");this.Dc.fa=this.xe[a];a=this.Dc.La()+this.Dc.fa;return new d(this.Dc,a,this.extent,this.ye,this.Ae)};var n=m;a["default"]={Kf:b,fk:d,gk:n};a.Kf=b;a.fk=d;a.gk=n})(Nj.Gf=Nj.Gf||{});function Eq(a,b,c,d,e){this.g=e;this.f=a;this.b=b;this.i=c;this.c=d}k=Eq.prototype;k.get=function(a){return this.c[a]};k.sb=function(){return this.i};k.G=function(){this.a||(this.a="Point"===this.f?Xa(this.b):Za(this.b,0,this.b.length,2));return this.a};k.lo=function(){return this.g};k.Tb=function(){return this.b};k.ba=Eq.prototype.Tb;k.W=function(){return this};k.mo=function(){return this.c};k.ae=Eq.prototype.W;k.ma=function(){return 2};k.bb=ra;k.T=function(){return this.f};function Fq(a){Yl.call(this);a=a?a:{};this.defaultDataProjection=new Db({code:"",units:"tile-pixels"});this.b=a.featureClass?a.featureClass:Eq;this.f=a.geometryName;this.c=a.layerName?a.layerName:"layer";this.g=a.layers?a.layers:null;this.a=null}v(Fq,Yl);k=Fq.prototype;k.eg=function(){return this.a};k.T=function(){return"arraybuffer"};
k.Oa=function(a,b){var c=this.g;a=new Nj.Id(a);a=new Nj.Gf.Kf(a);var d=[],e=this.b,f;for(f in a.layers)if(!c||-1!=c.indexOf(f)){var g=a.layers[f];for(var h,l=0,m=g.length;l<m;++l){h=g.feature(l);if(e===Eq){var n=void 0;var p=f,q=h.Xh(),t=[],u=[];Gq(q,u,t);var x=h.type;1===x?n=1===q.length?"Point":"MultiPoint":2===x?n=1===q.length?"LineString":"MultiLineString":3===x&&(n="Polygon");q=h.properties;q[this.c]=p;n=new this.b(n,u,t,q,h.id)}else{x=h;u=f;t=b;n=new this.b;h=x.id;p=x.properties;p[this.c]=u;
this.f&&n.Wc(this.f);u=void 0;q=x.type;if(0===q)u=null;else{x=x.Xh();var B=[],z=[];Gq(x,z,B);1===q?u=1===x.length?new C(null):new O(null):2===q?1===x.length?u=new M(null):u=new N(null):3===q&&(u=new D(null));u.aa("XY",z,B)}t=am(u,!1,$l(this,t));n.Ra(t);n.kc(h);n.H(p)}d.push(n)}this.a=g?[0,0,g.extent,g.extent]:null}return d};k.ob=function(){return this.defaultDataProjection};k.Cn=function(a){this.g=a};
function Gq(a,b,c){for(var d=0,e=0,f=a.length;e<f;++e){var g=a[e],h;var l=0;for(h=g.length;l<h;++l){var m=g[l];b.push(m.x,m.y)}d+=2*l;c.push(d)}}k.Ub=function(){};k.Vc=function(){};k.Gd=function(){};k.dd=function(){};k.Xb=function(){};function Hq(){Wm.call(this);this.defaultDataProjection=Wb("EPSG:4326")}v(Hq,Wm);function Iq(a,b){b[b.length-1].oe[a.getAttribute("k")]=a.getAttribute("v")}
var Jq=[null],Kq=K(Jq,{nd:function(a,b){b[b.length-1].td.push(a.getAttribute("ref"))},tag:Iq}),Mq=K(Jq,{node:function(a,b){var c=b[0],d=b[b.length-1],e=a.getAttribute("id"),f=[parseFloat(a.getAttribute("lon")),parseFloat(a.getAttribute("lat"))];d.ai[e]=f;a=L({oe:{}},Lq,a,b);ub(a.oe)||(f=new C(f),am(f,!1,c),c=new Bl(f),c.kc(e),c.H(a.oe),d.features.push(c))},way:function(a,b){var c=b[0],d=a.getAttribute("id");a=L({td:[],oe:{}},Kq,a,b);b=b[b.length-1];for(var e=[],f=0,g=a.td.length;f<g;f++)ka(e,b.ai[a.td[f]]);
a.td[0]==a.td[a.td.length-1]?(f=new D(null),f.aa("XY",e,[e.length])):(f=new M(null),f.aa("XY",e));am(f,!1,c);c=new Bl(f);c.kc(d);c.H(a.oe);b.features.push(c)}}),Lq=K(Jq,{tag:Iq});Hq.prototype.Ac=function(a,b){b=Zl(this,a,b);return"osm"==a.localName&&(a=L({ai:{},features:[]},Mq,a,[b]),a.features)?a.features:[]};Hq.prototype.$g=function(){};Hq.prototype.Yb=function(){};Hq.prototype.te=function(){};function Nq(a){return a.getAttributeNS("http://www.w3.org/1999/xlink","href")};function Oq(){}Oq.prototype.read=function(a){return Hl(a)?this.a(a):Il(a)?this.b(a):"string"===typeof a?(a=Jl(a),this.a(a)):null};function Pq(){}v(Pq,Oq);Pq.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};Pq.prototype.b=function(a){return(a=L({},Qq,a,[]))?a:null};
var Rq=[null,"http://www.opengis.net/ows/1.1"],Qq=K(Rq,{ServiceIdentification:I(function(a,b){return L({},Sq,a,b)}),ServiceProvider:I(function(a,b){return L({},Tq,a,b)}),OperationsMetadata:I(function(a,b){return L({},Uq,a,b)})}),Vq=K(Rq,{DeliveryPoint:I(Q),City:I(Q),AdministrativeArea:I(Q),PostalCode:I(Q),Country:I(Q),ElectronicMailAddress:I(Q)}),Wq=K(Rq,{Value:Ol(function(a){return Q(a)})}),Xq=K(Rq,{AllowedValues:I(function(a,b){return L({},Wq,a,b)})}),$q=K(Rq,{Phone:I(function(a,b){return L({},
Yq,a,b)}),Address:I(function(a,b){return L({},Vq,a,b)})}),br=K(Rq,{HTTP:I(function(a,b){return L({},ar,a,b)})}),ar=K(Rq,{Get:Ol(function(a,b){var c=Nq(a);if(c)return L({href:c},cr,a,b)}),Post:void 0}),dr=K(Rq,{DCP:I(function(a,b){return L({},br,a,b)})}),Uq=K(Rq,{Operation:function(a,b){var c=a.getAttribute("name");(a=L({},dr,a,b))&&(b[b.length-1][c]=a)}}),Yq=K(Rq,{Voice:I(Q),Facsimile:I(Q)}),cr=K(Rq,{Constraint:Ol(function(a,b){var c=a.getAttribute("name");if(c)return L({name:c},Xq,a,b)})}),er=K(Rq,
{IndividualName:I(Q),PositionName:I(Q),ContactInfo:I(function(a,b){return L({},$q,a,b)})}),Sq=K(Rq,{Title:I(Q),ServiceTypeVersion:I(Q),ServiceType:I(Q)}),Tq=K(Rq,{ProviderName:I(Q),ProviderSite:I(Nq),ServiceContact:I(function(a,b){return L({},er,a,b)})});function fr(a,b,c,d){var e;void 0!==d?e=d:e=[];for(var f=d=0;f<b;){var g=a[f++];e[d++]=a[f++];e[d++]=g;for(g=2;g<c;++g)e[d++]=a[f++]}e.length=d};function gr(a){a=a?a:{};Yl.call(this);this.defaultDataProjection=Wb("EPSG:4326");this.b=a.factor?a.factor:1E5;this.a=a.geometryLayout?a.geometryLayout:"XY"}v(gr,po);function hr(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;var f;var g=0;for(f=a.length;g<f;)for(d=0;d<b;++d,++g){var h=a[g],l=h-e[d];e[d]=h;a[g]=l}return ir(a,c?c:1E5)}function jr(a,b,c){var d,e=Array(b);for(d=0;d<b;++d)e[d]=0;a=kr(a,c?c:1E5);var f;c=0;for(f=a.length;c<f;)for(d=0;d<b;++d,++c)e[d]+=a[c],a[c]=e[d];return a}
function ir(a,b){b=b?b:1E5;var c;var d=0;for(c=a.length;d<c;++d)a[d]=Math.round(a[d]*b);b=0;for(d=a.length;b<d;++b)c=a[b],a[b]=0>c?~(c<<1):c<<1;b="";d=0;for(c=a.length;d<c;++d){for(var e,f=a[d],g="";32<=f;)e=(32|f&31)+63,g+=String.fromCharCode(e),f>>=5;g+=String.fromCharCode(f+63);b+=g}return b}
function kr(a,b){b=b?b:1E5;var c=[],d=0,e=0,f;var g=0;for(f=a.length;g<f;++g){var h=a.charCodeAt(g)-63;d|=(h&31)<<e;32>h?(c.push(d),e=d=0):e+=5}a=0;for(d=c.length;a<d;++a)e=c[a],c[a]=e&1?~(e>>1):e>>1;a=0;for(d=c.length;a<d;++a)c[a]/=b;return c}k=gr.prototype;k.he=function(a,b){a=this.Cd(a,b);return new Bl(a)};k.Hg=function(a,b){return[this.he(a,b)]};k.Cd=function(a,b){var c=vf(this.a);a=jr(a,c,this.b);fr(a,a.length,c,a);c=If(a,0,a.length,c);return am(new M(c,this.a),!1,$l(this,b))};
k.re=function(a,b){if(a=a.W())return this.Hd(a,b);va(!1,40);return""};k.ah=function(a,b){return this.re(a[0],b)};k.Hd=function(a,b){a=am(a,!0,$l(this,b));b=a.ba();a=a.ma();fr(b,b.length,a,b);return hr(b,a,this.b)};function lr(a){a=a?a:{};Yl.call(this);this.a=a.layerName;this.b=a.layers?a.layers:null;this.defaultDataProjection=Wb(a.defaultDataProjection?a.defaultDataProjection:"EPSG:4326")}v(lr,bm);function mr(a,b){var c=[],d,e;var f=0;for(e=a.length;f<e;++f){var g=a[f];0<f&&c.pop();0<=g?d=b[g]:d=b[~g].slice().reverse();c.push.apply(c,d)}a=0;for(b=c.length;a<b;++a)c[a]=c[a].slice();return c}
function nr(a,b,c,d,e,f,g){a=a.geometries;var h=[],l;var m=0;for(l=a.length;m<l;++m)h[m]=or(a[m],b,c,d,e,f,g);return h}function or(a,b,c,d,e,f,g){var h=a.type,l=pr[h];c="Point"===h||"MultiPoint"===h?l(a,c,d):l(a,b);b=new Bl;b.Ra(am(c,!1,g));void 0!==a.id&&b.kc(a.id);a=a.properties;e&&(a||(a={}),a[e]=f);a&&b.H(a);return b}
lr.prototype.Gg=function(a,b){if("Topology"==a.type){var c=null,d=null;if(a.transform){var e=a.transform;c=e.scale;d=e.translate}var f=a.arcs;if(e){e=c;var g=d,h;var l=0;for(h=f.length;l<h;++l){var m,n=f[l],p=e,q=g,t=0,u=0;var x=0;for(m=n.length;x<m;++x){var B=n[x];t+=B[0];u+=B[1];B[0]=t;B[1]=u;qr(B,p,q)}}}e=[];a=a.objects;g=this.a;for(var z in a)this.b&&-1==this.b.indexOf(z)||("GeometryCollection"===a[z].type?(l=a[z],e.push.apply(e,nr(l,f,c,d,g,z,b))):(l=a[z],e.push(or(l,f,c,d,g,z,b))));return e}return[]};
function qr(a,b,c){a[0]=a[0]*b[0]+c[0];a[1]=a[1]*b[1]+c[1]}lr.prototype.Ng=function(){return this.defaultDataProjection};
var pr={Point:function(a,b,c){a=a.coordinates;b&&c&&qr(a,b,c);return new C(a)},LineString:function(a,b){a=mr(a.arcs,b);return new M(a)},Polygon:function(a,b){var c=[],d;var e=0;for(d=a.arcs.length;e<d;++e)c[e]=mr(a.arcs[e],b);return new D(c)},MultiPoint:function(a,b,c){a=a.coordinates;var d;if(b&&c){var e=0;for(d=a.length;e<d;++e)qr(a[e],b,c)}return new O(a)},MultiLineString:function(a,b){var c=[],d;var e=0;for(d=a.arcs.length;e<d;++e)c[e]=mr(a.arcs[e],b);return new N(c)},MultiPolygon:function(a,
b){var c=[],d,e;var f=0;for(e=a.arcs.length;f<e;++f){var g=a.arcs[f];var h=[];var l=0;for(d=g.length;l<d;++l)h[l]=mr(g[l],b);c[f]=h}return new P(c)}};k=lr.prototype;k.cd=function(){};k.se=function(){};k.ue=function(){};k.Kg=function(){};k.Uc=function(){};function rr(a){a=a?a:{};this.c=a.featureType;this.a=a.featureNS;this.b=a.gmlFormat?a.gmlFormat:new mn;this.l=a.schemaLocation?a.schemaLocation:sr["1.1.0"];Wm.call(this)}v(rr,Wm);var sr={"1.1.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd","1.0.0":"http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/wfs.xsd"};
rr.prototype.Ac=function(a,b){var c={featureType:this.c,featureNS:this.a};rb(c,Zl(this,a,b?b:{}));b=[c];this.b.b["http://www.opengis.net/gml"].featureMember=Ll(Zm.prototype.ie);(a=L([],this.b.b,a,b,this.b))||(a=[]);return a};rr.prototype.j=function(a){if(Hl(a))return tr(a);if(Il(a))return L({},ur,a,[]);if("string"===typeof a)return a=Jl(a),tr(a)};rr.prototype.g=function(a){if(Hl(a))return vr(this,a);if(Il(a))return wr(this,a);if("string"===typeof a)return a=Jl(a),vr(this,a)};
function vr(a,b){for(b=b.firstChild;b;b=b.nextSibling)if(b.nodeType==Node.ELEMENT_NODE)return wr(a,b)}var xr={"http://www.opengis.net/gml":{boundedBy:I(Zm.prototype.sf,"bounds")}};function wr(a,b){var c={},d=gn(b.getAttribute("numberOfFeatures"));c.numberOfFeatures=d;return L(c,xr,b,[],a.b)}
var yr={"http://www.opengis.net/wfs":{totalInserted:I(fn),totalUpdated:I(fn),totalDeleted:I(fn)}},zr={"http://www.opengis.net/ogc":{FeatureId:Ll(function(a){return a.getAttribute("fid")})}},Ar={"http://www.opengis.net/wfs":{Feature:function(a,b){Ul(zr,a,b)}}},ur={"http://www.opengis.net/wfs":{TransactionSummary:I(function(a,b){return L({},yr,a,b)},"transactionSummary"),InsertResults:I(function(a,b){return L([],Ar,a,b)},"insertIds")}};
function tr(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return L({},ur,a,[])}var Br={"http://www.opengis.net/wfs":{PropertyName:J(jn)}};function Cr(a,b){var c=El("http://www.opengis.net/ogc","Filter"),d=El("http://www.opengis.net/ogc","FeatureId");c.appendChild(d);d.setAttribute("fid",b);a.appendChild(c)}function Dr(a,b){a=(a?a:"feature")+":";return b.indexOf(a)?a+b:b}
var Er={"http://www.opengis.net/wfs":{Insert:J(function(a,b,c){var d=c[c.length-1],e=d.gmlVersion;d=El(d.featureNS,d.featureType);a.appendChild(d);if(2===e){a=vn.prototype;(e=b.a)&&d.setAttribute("fid",e);e=c[c.length-1];var f=e.featureNS,g=b.c;e.pb||(e.pb={},e.pb[f]={});var h=b.N();b=[];var l=[];for(n in h){var m=h[n];null!==m&&(b.push(n),l.push(m),n==g||m instanceof rf?n in e.pb[f]||(e.pb[f][n]=J(a.ki,a)):n in e.pb[f]||(e.pb[f][n]=J(jn)))}var n=rb({},e);n.node=d;Vl(n,e.pb,Ql(void 0,f),l,c,b)}else mn.prototype.ti(d,
b,c)}),Update:J(function(a,b,c){var d=c[c.length-1];va(void 0!==b.a,27);var e=d.featurePrefix,f=d.featureNS;a.setAttribute("typeName",Dr(e,d.featureType));a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,f);e=b.a;if(void 0!==e){f=b.O();for(var g=[],h=0,l=f.length;h<l;h++){var m=b.get(f[h]);void 0!==m&&g.push({name:f[h],value:m})}Vl({gmlVersion:d.gmlVersion,node:a,hasZ:d.hasZ,srsName:d.srsName},Er,Ql("Property"),g,c);Cr(a,e)}}),Delete:J(function(a,b,c){c=c[c.length-1];va(void 0!==b.a,26);
var d=c.featurePrefix,e=c.featureNS;a.setAttribute("typeName",Dr(d,c.featureType));a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+d,e);b=b.a;void 0!==b&&Cr(a,b)}),Property:J(function(a,b,c){var d=El("http://www.opengis.net/wfs","Name"),e=c[c.length-1].gmlVersion;a.appendChild(d);jn(d,b.name);void 0!==b.value&&null!==b.value&&(d=El("http://www.opengis.net/wfs","Value"),a.appendChild(d),b.value instanceof rf?2===e?vn.prototype.ki(d,b.value,c):mn.prototype.ud(d,b.value,c):jn(d,b.value))}),
Native:J(function(a,b){b.Jq&&a.setAttribute("vendorId",b.Jq);void 0!==b.iq&&a.setAttribute("safeToIgnore",b.iq);void 0!==b.value&&jn(a,b.value)})}};function Fr(a,b,c){a={node:a};b=b.b;for(var d=0,e=b.length;d<e;++d){var f=b[d];Vl(a,Gr,Ql(f.lc),[f],c)}}function Hr(a,b){void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());Ir(a,b.b);Jr(a,""+b.f)}function Kr(a,b,c){a=El("http://www.opengis.net/ogc",a);jn(a,c);b.appendChild(a)}function Ir(a,b){Kr("PropertyName",a,b)}
function Jr(a,b){Kr("Literal",a,b)}function Lr(a,b){var c=El("http://www.opengis.net/gml","TimeInstant");a.appendChild(c);a=El("http://www.opengis.net/gml","timePosition");c.appendChild(a);jn(a,b)}
var Gr={"http://www.opengis.net/wfs":{Query:J(function(a,b,c){var d=c[c.length-1],e=d.featurePrefix,f=d.featureNS,g=d.propertyNames,h=d.srsName;a.setAttribute("typeName",e?Dr(e,b):b);h&&a.setAttribute("srsName",h);f&&a.setAttributeNS("http://www.w3.org/2000/xmlns/","xmlns:"+e,f);b=rb({},d);b.node=a;Vl(b,Br,Ql("PropertyName"),g,c);if(d=d.filter)g=El("http://www.opengis.net/ogc","Filter"),a.appendChild(g),Vl({node:g},Gr,Ql(d.lc),[d],c)})},"http://www.opengis.net/ogc":{During:J(function(a,b){var c=El("http://www.opengis.net/fes",
"ValueReference");jn(c,b.b);a.appendChild(c);c=El("http://www.opengis.net/gml","TimePeriod");a.appendChild(c);a=El("http://www.opengis.net/gml","begin");c.appendChild(a);Lr(a,b.a);a=El("http://www.opengis.net/gml","end");c.appendChild(a);Lr(a,b.f)}),And:J(Fr),Or:J(Fr),Not:J(function(a,b,c){b=b.condition;Vl({node:a},Gr,Ql(b.lc),[b],c)}),BBOX:J(function(a,b,c){c[c.length-1].srsName=b.srsName;Ir(a,b.geometryName);mn.prototype.ud(a,b.extent,c)}),Intersects:J(function(a,b,c){c[c.length-1].srsName=b.srsName;
Ir(a,b.geometryName);mn.prototype.ud(a,b.geometry,c)}),Within:J(function(a,b,c){c[c.length-1].srsName=b.srsName;Ir(a,b.geometryName);mn.prototype.ud(a,b.geometry,c)}),PropertyIsEqualTo:J(Hr),PropertyIsNotEqualTo:J(Hr),PropertyIsLessThan:J(Hr),PropertyIsLessThanOrEqualTo:J(Hr),PropertyIsGreaterThan:J(Hr),PropertyIsGreaterThanOrEqualTo:J(Hr),PropertyIsNull:J(function(a,b){Ir(a,b.b)}),PropertyIsBetween:J(function(a,b){Ir(a,b.b);var c=El("http://www.opengis.net/ogc","LowerBoundary");a.appendChild(c);
Jr(c,""+b.a);c=El("http://www.opengis.net/ogc","UpperBoundary");a.appendChild(c);Jr(c,""+b.f)}),PropertyIsLike:J(function(a,b){a.setAttribute("wildCard",b.g);a.setAttribute("singleChar",b.i);a.setAttribute("escapeChar",b.f);void 0!==b.a&&a.setAttribute("matchCase",b.a.toString());Ir(a,b.b);Jr(a,""+b.c)})}};
rr.prototype.o=function(a){var b=El("http://www.opengis.net/wfs","GetFeature");b.setAttribute("service","WFS");b.setAttribute("version","1.1.0");if(a){a.handle&&b.setAttribute("handle",a.handle);a.outputFormat&&b.setAttribute("outputFormat",a.outputFormat);void 0!==a.maxFeatures&&b.setAttribute("maxFeatures",a.maxFeatures);a.resultType&&b.setAttribute("resultType",a.resultType);void 0!==a.startIndex&&b.setAttribute("startIndex",a.startIndex);void 0!==a.count&&b.setAttribute("count",a.count);var c=
a.filter;if(a.bbox){va(a.geometryName,12);var d=Mm(a.geometryName,a.bbox,a.srsName);c?c=Lm(c,d):c=d}}b.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",this.l);c={node:b,srsName:a.srsName,featureNS:a.featureNS?a.featureNS:this.a,featurePrefix:a.featurePrefix,geometryName:a.geometryName,filter:c,propertyNames:a.propertyNames?a.propertyNames:[]};va(Array.isArray(a.featureTypes),11);a=a.featureTypes;c=[c];d=rb({},c[c.length-1]);d.node=b;Vl(d,Gr,Ql("Query"),a,c);return b};
rr.prototype.v=function(a,b,c,d){var e=[],f=El("http://www.opengis.net/wfs","Transaction"),g=d.version?d.version:"1.1.0",h="1.0.0"===g?2:3;f.setAttribute("service","WFS");f.setAttribute("version",g);if(d){var l=d.gmlOptions?d.gmlOptions:{};d.handle&&f.setAttribute("handle",d.handle)}f.setAttributeNS("http://www.w3.org/2001/XMLSchema-instance","xsi:schemaLocation",sr[g]);var m=d.featurePrefix?d.featurePrefix:"feature";a&&(g={node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,
hasZ:d.hasZ,srsName:d.srsName},rb(g,l),Vl(g,Er,Ql("Insert"),a,e));b&&(g={node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,hasZ:d.hasZ,srsName:d.srsName},rb(g,l),Vl(g,Er,Ql("Update"),b,e));c&&Vl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,srsName:d.srsName},Er,Ql("Delete"),c,e);d.nativeElements&&Vl({node:f,featureNS:d.featureNS,featureType:d.featureType,featurePrefix:m,gmlVersion:h,srsName:d.srsName},Er,Ql("Native"),d.nativeElements,
e);return f};rr.prototype.Mg=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.vf(a);return null};rr.prototype.vf=function(a){if(a.firstElementChild&&a.firstElementChild.firstElementChild)for(a=a.firstElementChild.firstElementChild,a=a.firstElementChild;a;a=a.nextElementSibling)if(0!==a.childNodes.length&&(1!==a.childNodes.length||3!==a.firstChild.nodeType)){var b=[{}];this.b.sf(a,b);return Wb(b.pop().srsName)}return null};function Mr(a){a=a?a:{};Yl.call(this);this.b=void 0!==a.splitCollection?a.splitCollection:!1}v(Mr,po);function Nr(a){a=a.V();return a.length?a.join(" "):""}function Or(a){a=a.V();for(var b=[],c=0,d=a.length;c<d;++c)b.push(a[c].join(" "));return b.join(",")}function Pr(a){var b=[];a=a.Zd();for(var c=0,d=a.length;c<d;++c)b.push("("+Or(a[c])+")");return b.join(",")}
function Qr(a){var b=a.T(),c=(0,Rr[b])(a);b=b.toUpperCase();if(a instanceof uf){a=a.ja;var d="";if("XYZ"===a||"XYZM"===a)d+="Z";if("XYM"===a||"XYZM"===a)d+="M";a=d;0<a.length&&(b+=" "+a)}return c.length?b+"("+c+")":b+" EMPTY"}
var Rr={Point:Nr,LineString:Or,Polygon:Pr,MultiPoint:function(a){var b=[];a=a.ee();for(var c=0,d=a.length;c<d;++c)b.push("("+Nr(a[c])+")");return b.join(",")},MultiLineString:function(a){var b=[];a=a.ld();for(var c=0,d=a.length;c<d;++c)b.push("("+Or(a[c])+")");return b.join(",")},MultiPolygon:function(a){var b=[];a=a.$d();for(var c=0,d=a.length;c<d;++c)b.push("("+Pr(a[c])+")");return b.join(",")},GeometryCollection:function(a){var b=[];a=a.kd();for(var c=0,d=a.length;c<d;++c)b.push(Qr(a[c]));return b.join(",")}};
k=Mr.prototype;k.he=function(a,b){return(a=this.Cd(a,b))?(b=new Bl,b.Ra(a),b):null};k.Hg=function(a,b){var c=[];a=this.Cd(a,b);this.b&&"GeometryCollection"==a.T()?c=a.a:c=[a];b=[];for(var d=0,e=c.length;d<e;++d)a=new Bl,a.Ra(c[d]),b.push(a);return b};k.Cd=function(a,b){a=new Sr(new Tr(a));Ur(a);return(a=Vr(a))?am(a,!1,b):null};k.re=function(a,b){return(a=a.W())?this.Hd(a,b):""};
k.ah=function(a,b){if(1==a.length)return this.re(a[0],b);for(var c=[],d=0,e=a.length;d<e;++d)c.push(a[d].W());a=new Nm(c);return this.Hd(a,b)};k.Hd=function(a,b){return Qr(am(a,!0,b))};function Tr(a){this.a=a;this.b=-1}
function Wr(a){var b=a.a.charAt(++a.b),c={position:a.b,value:b};if("("==b)c.type=2;else if(","==b)c.type=5;else if(")"==b)c.type=3;else if("0"<=b&&"9">=b||"."==b||"-"==b){c.type=4;b=a.b;var d=!1,e=!1;do{if("."==f)d=!0;else if("e"==f||"E"==f)e=!0;var f=a.a.charAt(++a.b)}while("0"<=f&&"9">=f||"."==f&&(void 0===d||!d)||!e&&("e"==f||"E"==f)||e&&("-"==f||"+"==f));a=parseFloat(a.a.substring(b,a.b--));c.value=a}else if("a"<=b&&"z">=b||"A"<=b&&"Z">=b){c.type=1;b=a.b;do f=a.a.charAt(++a.b);while("a"<=f&&"z">=
f||"A"<=f&&"Z">=f);a=a.a.substring(b,a.b--).toUpperCase();c.value=a}else{if(" "==b||"\t"==b||"\r"==b||"\n"==b)return Wr(a);if(""===b)c.type=6;else throw Error("Unexpected character: "+b);}return c}function Sr(a){this.f=a;this.a="XY"}function Ur(a){a.b=Wr(a.f)}function Xr(a,b){(b=a.b.type==b)&&Ur(a);return b}
function Vr(a){var b=a.b;if(Xr(a,1)){b=b.value;var c="XY",d=a.b;1==a.b.type&&(d=d.value,"Z"===d?c="XYZ":"M"===d?c="XYM":"ZM"===d&&(c="XYZM"),"XY"!==c&&Ur(a));a.a=c;if("GEOMETRYCOLLECTION"==b){a:{if(Xr(a,2)){b=[];do b.push(Vr(a));while(Xr(a,5));if(Xr(a,3)){a=b;break a}}else if(Yr(a)){a=[];break a}throw Error(Zr(a));}return new Nm(a)}d=$r[b];c=as[b];if(!d||!c)throw Error("Invalid geometry type: "+b);b=d.call(a);return new c(b,a.a)}throw Error(Zr(a));}k=Sr.prototype;
k.Bg=function(){if(Xr(this,2)){var a=bs(this);if(Xr(this,3))return a}else if(Yr(this))return null;throw Error(Zr(this));};k.Ag=function(){if(Xr(this,2)){var a=cs(this);if(Xr(this,3))return a}else if(Yr(this))return[];throw Error(Zr(this));};k.Cg=function(){if(Xr(this,2)){var a=ds(this);if(Xr(this,3))return a}else if(Yr(this))return[];throw Error(Zr(this));};
k.sp=function(){if(Xr(this,2)){var a;if(2==this.b.type)for(a=[this.Bg()];Xr(this,5);)a.push(this.Bg());else a=cs(this);if(Xr(this,3))return a}else if(Yr(this))return[];throw Error(Zr(this));};k.rp=function(){if(Xr(this,2)){var a=ds(this);if(Xr(this,3))return a}else if(Yr(this))return[];throw Error(Zr(this));};k.tp=function(){if(Xr(this,2)){for(var a=[this.Cg()];Xr(this,5);)a.push(this.Cg());if(Xr(this,3))return a}else if(Yr(this))return[];throw Error(Zr(this));};
function bs(a){for(var b=[],c=a.a.length,d=0;d<c;++d){var e=a.b;if(Xr(a,4))b.push(e.value);else break}if(b.length==c)return b;throw Error(Zr(a));}function cs(a){for(var b=[bs(a)];Xr(a,5);)b.push(bs(a));return b}function ds(a){for(var b=[a.Ag()];Xr(a,5);)b.push(a.Ag());return b}function Yr(a){var b=1==a.b.type&&"EMPTY"==a.b.value;b&&Ur(a);return b}function Zr(a){return"Unexpected `"+a.b.value+"` at position "+a.b.position+" in `"+a.f.a+"`"}
var as={POINT:C,LINESTRING:M,POLYGON:D,MULTIPOINT:O,MULTILINESTRING:N,MULTIPOLYGON:P},$r={POINT:Sr.prototype.Bg,LINESTRING:Sr.prototype.Ag,POLYGON:Sr.prototype.Cg,MULTIPOINT:Sr.prototype.sp,MULTILINESTRING:Sr.prototype.rp,MULTIPOLYGON:Sr.prototype.tp};function es(){this.version=void 0}v(es,Oq);es.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};es.prototype.b=function(a){this.version=a.getAttribute("version").trim();return(a=L({version:this.version},fs,a,[]))?a:null};function gs(a,b){return L({},hs,a,b)}function is(a,b){return L({},js,a,b)}function ks(a,b){if(b=gs(a,b))return a=[gn(a.getAttribute("width")),gn(a.getAttribute("height"))],b.size=a,b}
function ls(a,b){return L([],ms,a,b)}
var ns=[null,"http://www.opengis.net/wms"],fs=K(ns,{Service:I(function(a,b){return L({},os,a,b)}),Capability:I(function(a,b){return L({},ps,a,b)})}),ps=K(ns,{Request:I(function(a,b){return L({},qs,a,b)}),Exception:I(function(a,b){return L([],rs,a,b)}),Layer:I(function(a,b){return L({},ss,a,b)})}),os=K(ns,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(ls),OnlineResource:I(Nq),ContactInformation:I(function(a,b){return L({},ts,a,b)}),Fees:I(Q),AccessConstraints:I(Q),LayerLimit:I(fn),MaxWidth:I(fn),
MaxHeight:I(fn)}),ts=K(ns,{ContactPersonPrimary:I(function(a,b){return L({},us,a,b)}),ContactPosition:I(Q),ContactAddress:I(function(a,b){return L({},vs,a,b)}),ContactVoiceTelephone:I(Q),ContactFacsimileTelephone:I(Q),ContactElectronicMailAddress:I(Q)}),us=K(ns,{ContactPerson:I(Q),ContactOrganization:I(Q)}),vs=K(ns,{AddressType:I(Q),Address:I(Q),City:I(Q),StateOrProvince:I(Q),PostCode:I(Q),Country:I(Q)}),rs=K(ns,{Format:Ll(Q)}),ss=K(ns,{Name:I(Q),Title:I(Q),Abstract:I(Q),KeywordList:I(ls),CRS:Ol(Q),
EX_GeographicBoundingBox:I(function(a,b){var c=L({},ws,a,b);if(c){a=c.westBoundLongitude;b=c.southBoundLatitude;var d=c.eastBoundLongitude;c=c.northBoundLatitude;if(void 0!==a&&void 0!==b&&void 0!==d&&void 0!==c)return[a,b,d,c]}}),BoundingBox:Ol(function(a){var b=[en(a.getAttribute("minx")),en(a.getAttribute("miny")),en(a.getAttribute("maxx")),en(a.getAttribute("maxy"))],c=[en(a.getAttribute("resx")),en(a.getAttribute("resy"))];return{crs:a.getAttribute("CRS"),extent:b,res:c}}),Dimension:Ol(function(a){return{name:a.getAttribute("name"),
units:a.getAttribute("units"),unitSymbol:a.getAttribute("unitSymbol"),"default":a.getAttribute("default"),multipleValues:bn(a.getAttribute("multipleValues")),nearestValue:bn(a.getAttribute("nearestValue")),current:bn(a.getAttribute("current")),values:Q(a)}}),Attribution:I(function(a,b){return L({},xs,a,b)}),AuthorityURL:Ol(function(a,b){if(b=gs(a,b))return b.name=a.getAttribute("name"),b}),Identifier:Ol(Q),MetadataURL:Ol(function(a,b){if(b=gs(a,b))return b.type=a.getAttribute("type"),b}),DataURL:Ol(gs),
FeatureListURL:Ol(gs),Style:Ol(function(a,b){return L({},ys,a,b)}),MinScaleDenominator:I(dn),MaxScaleDenominator:I(dn),Layer:Ol(function(a,b){var c=b[b.length-1],d=L({},ss,a,b);if(d)return b=bn(a.getAttribute("queryable")),void 0===b&&(b=c.queryable),d.queryable=void 0!==b?b:!1,b=gn(a.getAttribute("cascaded")),void 0===b&&(b=c.cascaded),d.cascaded=b,b=bn(a.getAttribute("opaque")),void 0===b&&(b=c.opaque),d.opaque=void 0!==b?b:!1,b=bn(a.getAttribute("noSubsets")),void 0===b&&(b=c.noSubsets),d.noSubsets=
void 0!==b?b:!1,(b=en(a.getAttribute("fixedWidth")))||(b=c.fixedWidth),d.fixedWidth=b,(a=en(a.getAttribute("fixedHeight")))||(a=c.fixedHeight),d.fixedHeight=a,["Style","CRS","AuthorityURL"].forEach(function(a){a in c&&(d[a]=(d[a]||[]).concat(c[a]))}),"EX_GeographicBoundingBox BoundingBox Dimension Attribution MinScaleDenominator MaxScaleDenominator".split(" ").forEach(function(a){a in d||(d[a]=c[a])}),d})}),xs=K(ns,{Title:I(Q),OnlineResource:I(Nq),LogoURL:I(ks)}),ws=K(ns,{westBoundLongitude:I(dn),
eastBoundLongitude:I(dn),southBoundLatitude:I(dn),northBoundLatitude:I(dn)}),qs=K(ns,{GetCapabilities:I(is),GetMap:I(is),GetFeatureInfo:I(is)}),js=K(ns,{Format:Ol(Q),DCPType:Ol(function(a,b){return L({},zs,a,b)})}),zs=K(ns,{HTTP:I(function(a,b){return L({},As,a,b)})}),As=K(ns,{Get:I(gs),Post:I(gs)}),ys=K(ns,{Name:I(Q),Title:I(Q),Abstract:I(Q),LegendURL:Ol(ks),StyleSheetURL:I(gs),StyleURL:I(gs)}),hs=K(ns,{Format:I(Q),OnlineResource:I(Nq)}),ms=K(ns,{Keyword:Ll(Q)});function Bs(a){a=a?a:{};this.a="http://mapserver.gis.umn.edu/mapserver";this.b=new vn;this.c=a.layers?a.layers:null;Wm.call(this)}v(Bs,Wm);
Bs.prototype.Ac=function(a,b){var c={};b&&rb(c,Zl(this,a,b));c=[c];a.setAttribute("namespaceURI",this.a);var d=a.localName;b=[];if(a.childNodes.length){if("msGMLOutput"==d)for(var e=0,f=a.childNodes.length;e<f;e++){var g=a.childNodes[e];if(g.nodeType===Node.ELEMENT_NODE){var h=c[0],l=g.localName.replace("_layer","");if(!this.c||ha(this.c,l)){l+="_feature";h.featureType=l;h.featureNS=this.a;var m={};m[l]=Ll(this.b.Eg,this.b);h=K([h.featureNS,null],m);g.setAttribute("namespaceURI",this.a);(g=L([],h,
g,c,this.b))&&ka(b,g)}}}"FeatureCollection"==d&&(a=L([],this.b.b,a,[{}],this.b))&&(b=a)}return b};Bs.prototype.$g=function(){};Bs.prototype.Yb=function(){};Bs.prototype.te=function(){};function Cs(){this.f=new Pq}v(Cs,Oq);Cs.prototype.a=function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType==Node.ELEMENT_NODE)return this.b(a);return null};Cs.prototype.b=function(a){var b=a.getAttribute("version").trim(),c=this.f.b(a);if(!c)return null;c.version=b;return(c=L(c,Ds,a,[]))?c:null};function Es(a){var b=Q(a).split(" ");if(b&&2==b.length&&(a=+b[0],b=+b[1],!isNaN(a)&&!isNaN(b)))return[a,b]}
var Fs=[null,"http://www.opengis.net/wmts/1.0"],Gs=[null,"http://www.opengis.net/ows/1.1"],Ds=K(Fs,{Contents:I(function(a,b){return L({},Hs,a,b)})}),Hs=K(Fs,{Layer:Ol(function(a,b){return L({},Is,a,b)}),TileMatrixSet:Ol(function(a,b){return L({},Js,a,b)})}),Is=K(Fs,{Style:Ol(function(a,b){if(b=L({},Ks,a,b))return a="true"===a.getAttribute("isDefault"),b.isDefault=a,b}),Format:Ol(Q),TileMatrixSetLink:Ol(function(a,b){return L({},Ls,a,b)}),Dimension:Ol(function(a,b){return L({},Ms,a,b)}),ResourceURL:Ol(function(a){var b=
a.getAttribute("format"),c=a.getAttribute("template");a=a.getAttribute("resourceType");var d={};b&&(d.format=b);c&&(d.template=c);a&&(d.resourceType=a);return d})},K(Gs,{Title:I(Q),Abstract:I(Q),WGS84BoundingBox:I(function(a,b){a=L([],Ns,a,b);if(2==a.length)return La(a)}),Identifier:I(Q)})),Ks=K(Fs,{LegendURL:Ol(function(a){var b={};b.format=a.getAttribute("format");b.href=Nq(a);return b})},K(Gs,{Title:I(Q),Identifier:I(Q)})),Ls=K(Fs,{TileMatrixSet:I(Q),TileMatrixSetLimits:I(function(a,b){return L([],
Os,a,b)})}),Os=K(Fs,{TileMatrixLimits:Ll(function(a,b){return L({},Ps,a,b)})}),Ps=K(Fs,{TileMatrix:I(Q),MinTileRow:I(fn),MaxTileRow:I(fn),MinTileCol:I(fn),MaxTileCol:I(fn)}),Ms=K(Fs,{Default:I(Q),Value:Ol(Q)},K(Gs,{Identifier:I(Q)})),Ns=K(Gs,{LowerCorner:Ll(Es),UpperCorner:Ll(Es)}),Js=K(Fs,{WellKnownScaleSet:I(Q),TileMatrix:Ol(function(a,b){return L({},Qs,a,b)})},K(Gs,{SupportedCRS:I(Q),Identifier:I(Q)})),Qs=K(Fs,{TopLeftCorner:I(Es),ScaleDenominator:I(dn),TileWidth:I(fn),TileHeight:I(fn),MatrixWidth:I(fn),
MatrixHeight:I(fn)},K(Gs,{Identifier:I(Q)}));function Rs(a){Vc.call(this);a=a||{};this.a=null;this.i=gc;this.g=new vb(6378137);this.c=void 0;y(this,Xc("projection"),this.Om,this);y(this,Xc("tracking"),this.Pm,this);void 0!==a.projection&&this.ei(a.projection);void 0!==a.trackingOptions&&this.Gj(a.trackingOptions);this.Ve(void 0!==a.tracking?a.tracking:!1)}v(Rs,Vc);k=Rs.prototype;k.ka=function(){this.Ve(!1);Vc.prototype.ka.call(this)};k.Om=function(){var a=this.ci();a&&(this.i=Xb(Wb("EPSG:4326"),a),this.a&&this.set("position",this.i(this.a)))};
k.Pm=function(){if(Yd){var a=this.di();a&&void 0===this.c?this.c=navigator.geolocation.watchPosition(this.Ap.bind(this),this.Bp.bind(this),this.Ph()):a||void 0===this.c||(navigator.geolocation.clearWatch(this.c),this.c=void 0)}};
k.Ap=function(a){a=a.coords;this.set("accuracy",a.accuracy);this.set("altitude",null===a.altitude?void 0:a.altitude);this.set("altitudeAccuracy",null===a.altitudeAccuracy?void 0:a.altitudeAccuracy);this.set("heading",null===a.heading?void 0:Fa(a.heading));this.a?(this.a[0]=a.longitude,this.a[1]=a.latitude):this.a=[a.longitude,a.latitude];var b=this.i(this.a);this.set("position",b);this.set("speed",null===a.speed?void 0:a.speed);a=bg(this.g,this.a,a.accuracy);a.Fc(this.i);this.set("accuracyGeometry",
a);this.s()};k.Bp=function(a){a.type="error";this.Ve(!1);this.b(a)};k.Ok=function(){return this.get("accuracy")};k.Pk=function(){return this.get("accuracyGeometry")||null};k.Rk=function(){return this.get("altitude")};k.Sk=function(){return this.get("altitudeAccuracy")};k.Mm=function(){return this.get("heading")};k.Nm=function(){return this.get("position")};k.ci=function(){return this.get("projection")};k.xl=function(){return this.get("speed")};k.di=function(){return this.get("tracking")};k.Ph=function(){return this.get("trackingOptions")};
k.ei=function(a){this.set("projection",Wb(a))};k.Ve=function(a){this.set("tracking",a)};k.Gj=function(a){this.set("trackingOptions",a)};function Ss(a,b,c){uf.call(this);this.Vg(a,b?b:0,c)}v(Ss,uf);k=Ss.prototype;k.clone=function(){var a=new Ss(null);wf(a,this.ja,this.A.slice());a.s();return a};k.Jb=function(a,b,c,d){var e=this.A;a-=e[0];var f=b-e[1];b=a*a+f*f;if(b<d){if(b)for(d=this.vd()/Math.sqrt(b),c[0]=e[0]+d*a,c[1]=e[1]+d*f,d=2;d<this.a;++d)c[d]=e[d];else for(d=0;d<this.a;++d)c[d]=e[d];c.length=this.a;return b}return d};k.Pc=function(a,b){var c=this.A;a-=c[0];b-=c[1];return a*a+b*b<=Ts(this)};
k.xa=function(){return this.A.slice(0,this.a)};k.De=function(a){var b=this.A,c=b[this.a]-b[0];return Va(b[0]-c,b[1]-c,b[0]+c,b[1]+c,a)};k.vd=function(){return Math.sqrt(Ts(this))};function Ts(a){var b=a.A[a.a]-a.A[0];a=a.A[a.a+1]-a.A[1];return b*b+a*a}k.T=function(){return"Circle"};k.Ya=function(a){var b=this.G();return ob(a,b)?(b=this.xa(),a[0]<=b[0]&&a[2]>=b[0]||a[1]<=b[1]&&a[3]>=b[1]?!0:cb(a,this.wb,this)):!1};
k.rb=function(a){var b=this.a,c=a.slice();c[b]=c[0]+(this.A[b]-this.A[0]);var d;for(d=1;d<b;++d)c[b+d]=a[d];wf(this,this.ja,c);this.s()};k.Vg=function(a,b,c){if(a){xf(this,c,a,0);this.A||(this.A=[]);c=this.A;a=Ff(c,a);c[a++]=c[0]+b;var d;b=1;for(d=this.a;b<d;++b)c[a++]=c[b];c.length=a}else wf(this,"XY",null);this.s()};k.V=function(){};k.na=function(){};k.Xc=function(a){this.A[this.a]=this.A[0]+a;this.s()};function Us(a,b,c){for(var d=[],e=a(0),f=a(1),g=b(e),h=b(f),l=[f,e],m=[h,g],n=[1,0],p={},q=1E5,t,u,x,B,z;0<--q&&0<n.length;)x=n.pop(),e=l.pop(),g=m.pop(),f=x.toString(),f in p||(d.push(g[0],g[1]),p[f]=!0),B=n.pop(),f=l.pop(),h=m.pop(),z=(x+B)/2,t=a(z),u=b(t),Da(u[0],u[1],g[0],g[1],h[0],h[1])<c?(d.push(h[0],h[1]),f=B.toString(),p[f]=!0):(n.push(B,z,z,x),m.push(h,u,u,g),l.push(f,t,t,e));return d}function Vs(a,b,c,d,e){var f=Wb("EPSG:4326");return Us(function(d){return[a,b+(c-b)*d]},fc(f,d),e)}
function Ws(a,b,c,d,e){var f=Wb("EPSG:4326");return Us(function(d){return[b+(c-b)*d,a]},fc(f,d),e)};function Xs(a){a=a||{};this.i=this.v=null;this.j=this.g=Infinity;this.o=this.l=-Infinity;this.qa=this.pa=Infinity;this.S=this.I=-Infinity;this.va=void 0!==a.targetSize?a.targetSize:100;this.jb=void 0!==a.maxLines?a.maxLines:100;this.f=[];this.c=[];this.oa=void 0!==a.strokeStyle?a.strokeStyle:Ys;this.D=this.u=void 0;this.a=this.b=this.R=null;1==a.showLabels&&(this.ta=a.lonLabelFormatter?a.lonLabelFormatter:ef.bind(this,"EW"),this.Va=a.latLabelFormatter?a.latLabelFormatter:ef.bind(this,"NS"),this.ga=
void 0==a.lonLabelPosition?0:a.lonLabelPosition,this.U=void 0==a.latLabelPosition?1:a.latLabelPosition,this.C=void 0!==a.lonLabelStyle?a.lonLabelStyle:new zo({font:"12px Calibri,sans-serif",textBaseline:"bottom",fill:new ul({color:"rgba(0,0,0,1)"}),stroke:new Ej({color:"rgba(255,255,255,1)",width:3})}),this.B=void 0!==a.latLabelStyle?a.latLabelStyle:new zo({font:"12px Calibri,sans-serif",textAlign:"end",fill:new ul({color:"rgba(0,0,0,1)"}),stroke:new Ej({color:"rgba(255,255,255,1)",width:3})}),this.b=
[],this.a=[]);this.setMap(void 0!==a.map?a.map:null)}var Ys=new Ej({color:"rgba(0,0,0,0.2)"}),Zs=[90,45,30,20,10,5,2,1,.5,.2,.1,.05,.01,.005,.002,.001];function $s(a,b,c,d,e,f,g){var h=g;c=Vs(b,c,d,a.i,e);h=void 0!==a.f[h]?a.f[h]:new M(null);h.aa("XY",c);ob(h.G(),f)&&(a.b&&(c=g,d=h.ba(),f=[d[0],Aa(f[1]+Math.abs(f[1]-f[3])*a.ga,Math.max(f[1],d[1]),Math.min(f[3],d[d.length-1]))],c=a.b[c]?a.b[c].Xd:new C(null),c.na(f),a.b[g]={Xd:c,text:a.ta(b)}),a.f[g++]=h);return g}
function at(a,b,c,d,e,f,g){var h=g;c=Ws(b,c,d,a.i,e);h=void 0!==a.c[h]?a.c[h]:new M(null);h.aa("XY",c);ob(h.G(),f)&&(a.a&&(c=g,d=h.ba(),f=[Aa(f[0]+Math.abs(f[0]-f[2])*a.U,Math.max(f[0],d[0]),Math.min(f[2],d[d.length-2])),d[1]],c=a.a[c]?a.a[c].Xd:new C(null),c.na(f),a.a[g]={Xd:c,text:a.Va(b)}),a.c[g++]=h);return g}k=Xs.prototype;k.Qm=function(){return this.v};k.ml=function(){return this.f};k.tl=function(){return this.c};
k.Th=function(a){var b=a.vectorContext,c=a.frameState;a=c.extent;var d=c.viewState,e=d.center,f=d.projection;d=d.resolution;c=c.pixelRatio;c=d*d/(4*c*c);if(!this.i||!ec(this.i,f)){var g=Wb("EPSG:4326"),h=f.G(),l=f.g,m=ic(l,g,f),n=l[2],p=l[1],q=l[0],t=m[3],u=m[2],x=m[1];m=m[0];this.g=l[3];this.j=n;this.l=p;this.o=q;this.pa=t;this.qa=u;this.I=x;this.S=m;this.u=fc(g,f);this.D=fc(f,g);this.R=this.D(lb(h));this.i=f}f=this.R[0];g=this.R[1];h=-1;n=Math.pow(this.va*d,2);p=[];q=[];d=0;for(l=Zs.length;d<l;++d){t=
Zs[d]/2;p[0]=f-t;p[1]=g-t;q[0]=f+t;q[1]=g+t;this.u(p,p);this.u(q,q);t=Math.pow(q[0]-p[0],2)+Math.pow(q[1]-p[1],2);if(t<=n)break;h=Zs[d]}d=h;if(-1==d)this.f.length=this.c.length=0,this.b&&(this.b.length=0),this.a&&(this.a.length=0);else{f=this.D(e);e=f[0];f=f[1];g=this.jb;l=[Math.max(a[0],this.S),Math.max(a[1],this.I),Math.min(a[2],this.qa),Math.min(a[3],this.pa)];l=ic(l,this.i,"EPSG:4326");p=l[3];h=l[2];q=l[1];t=l[0];e=Math.floor(e/d)*d;u=Aa(e,this.o,this.j);n=$s(this,u,q,p,c,a,0);for(l=0;u!=this.o&&
l++<g;)u=Math.max(u-d,this.o),n=$s(this,u,q,p,c,a,n);u=Aa(e,this.o,this.j);for(l=0;u!=this.j&&l++<g;)u=Math.min(u+d,this.j),n=$s(this,u,q,p,c,a,n);this.f.length=n;this.b&&(this.b.length=n);f=Math.floor(f/d)*d;e=Aa(f,this.l,this.g);n=at(this,e,t,h,c,a,0);for(l=0;e!=this.l&&l++<g;)e=Math.max(e-d,this.l),n=at(this,e,t,h,c,a,n);e=Aa(f,this.l,this.g);for(l=0;e!=this.g&&l++<g;)e=Math.min(e+d,this.g),n=at(this,e,t,h,c,a,n);this.c.length=n;this.a&&(this.a.length=n)}b.Na(null,this.oa);a=0;for(c=this.f.length;a<
c;++a)e=this.f[a],b.Cb(e);a=0;for(c=this.c.length;a<c;++a)e=this.c[a],b.Cb(e);if(this.b)for(a=0,c=this.b.length;a<c;++a)e=this.b[a],this.C.Dd(e.text),b.gb(this.C),b.Cb(e.Xd);if(this.a)for(a=0,c=this.a.length;a<c;++a)e=this.a[a],this.B.Dd(e.text),b.gb(this.B),b.Cb(e.Xd)};k.setMap=function(a){this.v&&(this.v.K("postcompose",this.Th,this),this.v.render());a&&(a.J("postcompose",this.Th,this),a.render());this.v=a};function bt(a,b,c,d,e){Sc.call(this);this.i=e;this.extent=a;this.a=c;this.resolution=b;this.state=d}v(bt,Sc);bt.prototype.s=function(){this.b("change")};bt.prototype.G=function(){return this.extent};bt.prototype.getState=function(){return this.state};function ct(a,b,c,d,e,f,g){bt.call(this,a,b,c,0,d);this.j=e;this.M=new Image;null!==f&&(this.M.crossOrigin=f);this.c={};this.f=null;this.state=0;this.g=g}v(ct,bt);k=ct.prototype;k.Y=function(a){if(void 0!==a){var b;a=w(a);if(a in this.c)return this.c[a];ub(this.c)?b=this.M:b=this.M.cloneNode(!1);return this.c[a]=b}return this.M};k.Tm=function(){this.state=3;this.f.forEach(Gc);this.f=null;this.s()};
k.Um=function(){void 0===this.resolution&&(this.resolution=kb(this.extent)/this.M.height);this.state=2;this.f.forEach(Gc);this.f=null;this.s()};k.load=function(){if(0==this.state||3==this.state)this.state=1,this.s(),this.f=[Lc(this.M,"error",this.Tm,this),Lc(this.M,"load",this.Um,this)],this.g(this,this.j)};k.Wg=function(a){this.M=a};function dt(a,b,c,d,e,f){this.c=f?f:null;bt.call(this,a,b,c,f?0:2,d);this.f=e}v(dt,bt);dt.prototype.g=function(a){this.state=a?3:2;this.s()};dt.prototype.load=function(){0==this.state&&(this.state=1,this.s(),this.c(this.g.bind(this)))};dt.prototype.Y=function(){return this.f};function et(a,b){Sc.call(this);this.sa=a;this.state=b;this.a=null;this.key=""}v(et,Sc);et.prototype.s=function(){this.b("change")};et.prototype.fb=function(){return this.key+"/"+this.sa};function ft(a){if(!a.a)return a;var b=a.a;do{if(2==b.getState())return b;b=b.a}while(b);return a}function gt(a){if(a.a){var b=a.a;do{if(2==b.getState()){b.a=null;break}else 1==b.getState()?a=b:0==b.getState()?a.a=b.a:a=b;b=a.a}while(b)}}et.prototype.i=function(){return this.sa};et.prototype.getState=function(){return this.state};
function ht(a,b){a.state=b;a.s()};function it(a,b,c,d,e){et.call(this,a,b);this.g=c;this.M=new Image;null!==d&&(this.M.crossOrigin=d);this.c=null;this.j=e}v(it,et);k=it.prototype;k.ka=function(){1==this.state&&(jt(this),this.M.src=kt.toDataURL("image/png"));this.a&&Pc(this.a);this.state=5;this.s();et.prototype.ka.call(this)};k.Y=function(){return this.M};k.fb=function(){return this.g};k.Rm=function(){this.state=3;jt(this);this.M=kt;this.s()};k.Sm=function(){this.state=this.M.naturalWidth&&this.M.naturalHeight?2:4;jt(this);this.s()};
k.load=function(){if(0==this.state||3==this.state)this.state=1,this.s(),this.c=[Lc(this.M,"error",this.Rm,this),Lc(this.M,"load",this.Sm,this)],this.j(this,this.g)};function jt(a){a.c.forEach(Gc);a.c=null}var kt,lt=ld(1,1);lt.fillStyle="rgba(0,0,0,0)";lt.fillRect(0,0,1,1);kt=lt.canvas;function mt(a){a=a?a:{};sg.call(this,{handleEvent:pf});this.j=a.formatConstructors?a.formatConstructors:[];this.o=a.projection?Wb(a.projection):null;this.a=null;this.g=a.source||null;this.target=a.target?a.target:null}v(mt,sg);function nt(a){a=a.dataTransfer.files;var b;var c=0;for(b=a.length;c<b;++c){var d=a.item(c);var e=new FileReader;e.addEventListener("load",this.l.bind(this,d));e.readAsText(d)}}function ot(a){a.stopPropagation();a.preventDefault();a.dataTransfer.dropEffect="copy"}
mt.prototype.l=function(a,b){b=b.target.result;var c=this.v,d=this.o;d||(d=c.$().v);c=this.j;var e=[],f;var g=0;for(f=c.length;g<f;++g){var h=new c[g];var l={featureProjection:d};try{e=h.Oa(b,l)}catch(m){e=null}if(e&&0<e.length)break}this.g&&(this.g.clear(),this.g.Ec(e));this.b(new pt(qt,a,e,d))};function rt(a){var b=a.v;b&&(b=a.target?a.target:b.a,a.a=[y(b,"drop",nt,a),y(b,"dragenter",ot,a),y(b,"dragover",ot,a),y(b,"drop",ot,a)])}
mt.prototype.Ia=function(a){sg.prototype.Ia.call(this,a);a?rt(this):st(this)};mt.prototype.setMap=function(a){st(this);sg.prototype.setMap.call(this,a);this.c()&&rt(this)};function st(a){a.a&&(a.a.forEach(Gc),a.a=null)}var qt="addfeatures";function pt(a,b,c,d){Qc.call(this,a);this.features=c;this.file=b;this.projection=d}v(pt,Qc);function tt(a){a=a?a:{};Jg.call(this,{handleDownEvent:ut,handleDragEvent:vt,handleUpEvent:wt});this.o=a.condition?a.condition:Eg;this.a=this.g=void 0;this.j=0;this.u=void 0!==a.duration?a.duration:400}v(tt,Jg);
function vt(a){if(Gg(a)){var b=a.map,c=b.Mb(),d=a.pixel;a=d[0]-c[0]/2;d=c[1]/2-d[1];c=Math.atan2(d,a);a=Math.sqrt(a*a+d*d);b=b.$();b.g.rotation!==We&&void 0!==this.g&&(d=c-this.g,tg(b,b.Qa()-d));this.g=c;void 0!==this.a&&(c=this.a*(b.Pa()/a),vg(b,c));void 0!==this.a&&(this.j=this.a/a);this.a=a}}
function wt(a){if(!Gg(a))return!0;a=a.map.$();hg(a,1,-1);var b=this.j-1,c=a.Qa();c=a.constrainRotation(c,0);tg(a,c,void 0,void 0);c=a.Pa();var d=this.u;c=a.constrainResolution(c,0,b);vg(a,c,void 0,d);this.j=0;return!1}function ut(a){return Gg(a)&&this.o(a)?(hg(a.map.$(),1,1),this.a=this.g=void 0,!0):!1};function xt(a,b,c,d){this.oa=a;this.Va=b;this.overlaps=d;this.c=0;this.resolution=c;this.qa=this.pa=null;this.a=[];this.coordinates=[];this.ga={};this.U=Ih();this.b=[];this.C=null;this.jb=Ih();this.ta=Ih()}v(xt,ci);
function yt(a,b,c,d,e,f,g){var h=a.coordinates.length,l=a.Zf();g&&(c+=e);g=[b[c],b[c+1]];var m=[NaN,NaN],n=!0,p;for(p=c+e;p<d;p+=e){m[0]=b[p];m[1]=b[p+1];var q=Ua(l,m);q!==t?(n&&(a.coordinates[h++]=g[0],a.coordinates[h++]=g[1]),a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],n=!1):1===q?(a.coordinates[h++]=m[0],a.coordinates[h++]=m[1],n=!1):n=!0;g[0]=m[0];g[1]=m[1];var t=q}if(f&&n||p===c+e)a.coordinates[h++]=g[0],a.coordinates[h++]=g[1];return h}
function zt(a,b,c,d,e,f){for(var g=0,h=d.length;g<h;++g){var l=d[g];c=yt(a,b,c,l,e,!1,!1);f.push(c);c=l}return c}k=xt.prototype;
k.wh=function(a,b,c){At(this,b);var d=a.T(),e=a.ma(),f=this.coordinates.length,g;if("MultiPolygon"==d){d=mi(a);var h=[];for(var l=a.c,m=g=0,n=l.length;m<n;++m){var p=[];g=zt(this,d,g,l[m],e,p);h.push(p)}this.a.push([4,f,h,a,c,Kf])}else"Polygon"==d||"MultiLineString"==d?(h=[],d="Polygon"==d?a.Tb():a.ba(),zt(this,d,0,a.sb(),e,h),this.a.push([4,f,h,a,c,Jf])):"LineString"==d||"MultiPoint"==d?(d=a.ba(),e=yt(this,d,0,d.length,e,!1,!1),this.a.push([4,f,e,a,c,If])):"Point"==d&&(d=a.ba(),this.coordinates.push(d[0],
d[1]),e=this.coordinates.length,this.a.push([4,f,e,a,c]));Bt(this,b)};function At(a,b){a.pa=[0,b,0];a.a.push(a.pa);a.qa=[0,b,0];a.b.push(a.qa)}k.Wa=function(a,b){if(this.S){var c=Nh(this.U,this.S.slice());a.translate(c[0],c[1]);a.rotate(b)}a.fill();this.S&&a.setTransform.apply(a,this.ta)};
function Ct(a,b,c,d,e,f,g,h,l){if(a.C&&ma(d,a.U))var m=a.C;else a.C||(a.C=[]),m=sf(a.coordinates,0,a.coordinates.length,2,d,a.C),Mh(a.U,d);d=!ub(f);for(var n=0,p=g.length,q=0,t,u=a.jb,x=a.ta,B,z,G,E,ia=0,T=0,R=a.ga,U={context:b,pixelRatio:c,resolution:a.resolution,rotation:e},ta=a.a!=g||a.overlaps?0:200;n<p;){var A=g[n];switch(A[0]){case 0:var ea=A[1];d&&f[w(ea).toString()]||!ea.W()?n=A[2]:void 0===l||ob(l,ea.W().G())?++n:n=A[2]+1;break;case 1:ia>ta&&(a.Wa(b,e),ia=0);T>ta&&(b.stroke(),T=0);ia||T||
(b.beginPath(),B=z=NaN);++n;break;case 2:q=A[1];t=m[q];A=m[q+1];G=m[q+2]-t;q=m[q+3]-A;q=Math.sqrt(G*G+q*q);b.moveTo(t+q,A);b.arc(t,A,q,0,2*Math.PI,!0);++n;break;case 3:b.closePath();++n;break;case 4:q=A[1];t=A[2];G=A[4];E=6==A.length?A[5]:void 0;U.geometry=A[3];U.feature=ea;n in R||(R[n]=[]);A=R[n];E?E(m,q,t,2,A):(A[0]=m[q],A[1]=m[q+1],A.length=2);G(A,U);++n;break;case 5:q=A[1];t=A[2];var Ya=A[3];var da=A[4]*c;var Vb=A[5]*c;var Ac=A[6],ge=A[7],he=A[8],Nf=A[9];var Bc=A[10];G=A[11];E=A[12];var Ah=A[13],
Ig=A[14];for(Bc&&(G+=e);q<t;q+=2){A=m[q]-da;Bc=m[q+1]-Vb;Ah&&(A=Math.round(A),Bc=Math.round(Bc));if(1!=E||G){var of=A+da,Bh=Bc+Vb;Rh(u,of,Bh,E,E,G,-of,-Bh);b.setTransform.apply(b,u)}of=b.globalAlpha;1!=ge&&(b.globalAlpha=of*ge);Bh=Ig+he>Ya.width?Ya.width-he:Ig;var Zq=Ac+Nf>Ya.height?Ya.height-Nf:Ac;b.drawImage(Ya,he,Nf,Bh,Zq,A,Bc,Bh*c,Zq*c);1!=ge&&(b.globalAlpha=of);(1!=E||G)&&b.setTransform.apply(b,x)}++n;break;case 6:q=A[1];t=A[2];Vb=A[3];Ac=A[4]*c;ge=A[5]*c;G=A[6];E=A[7]*c;Ya=A[8];da=A[9];for((Bc=
A[10])&&(G+=e);q<t;q+=2){A=m[q]+Ac;Bc=m[q+1]+ge;if(1!=E||G)Rh(u,A,Bc,E,E,G,-A,-Bc),b.setTransform.apply(b,u);he=Vb.split("\n");Nf=he.length;1<Nf?(Ah=Math.round(1.5*b.measureText("M").width),Bc-=(Nf-1)/2*Ah):Ah=0;for(Ig=0;Ig<Nf;Ig++)of=he[Ig],da&&b.strokeText(of,A,Bc),Ya&&b.fillText(of,A,Bc),Bc+=Ah;(1!=E||G)&&b.setTransform.apply(b,x)}++n;break;case 7:if(h&&(ea=A[1],q=h(ea)))return q;++n;break;case 8:ta?ia++:a.Wa(b,e);++n;break;case 9:q=A[1];t=A[2];A=m[q];Bc=m[q+1];G=A+.5|0;E=Bc+.5|0;if(G!==B||E!==
z)b.moveTo(A,Bc),B=G,z=E;for(q+=2;q<t;q+=2)if(A=m[q],Bc=m[q+1],G=A+.5|0,E=Bc+.5|0,q==t-2||G!==B||E!==z)b.lineTo(A,Bc),B=G,z=E;++n;break;case 10:a.S=A[2];ia&&(a.Wa(b,e),ia=0,T&&(b.stroke(),T=0));b.fillStyle=A[1];++n;break;case 11:q=void 0!==A[8]?A[8]:!0;var Ml=A[9];t=A[2];T&&(b.stroke(),T=0);b.strokeStyle=A[1];b.lineWidth=q?t*c:t;b.lineCap=A[3];b.lineJoin=A[4];b.miterLimit=A[5];Vd&&(t=A[6],G=A[7],q&&c!==Ml&&(t=t.map(function(a){return a*c/Ml}),G*=c/Ml,A[6]=t,A[7]=G,A[9]=c),b.lineDashOffset=G,b.setLineDash(t));
++n;break;case 12:b.font=A[1];b.textAlign=A[2];b.textBaseline=A[3];++n;break;case 13:ta?T++:b.stroke();++n;break;default:++n}}ia&&a.Wa(b,e);T&&b.stroke()}k.Ma=function(a,b,c,d,e){Ct(this,a,b,c,d,e,this.a,void 0,void 0)};function Dt(a){var b=a.b;b.reverse();var c,d=b.length,e=-1;for(c=0;c<d;++c){var f=b[c];var g=f[0];if(7==g)e=c;else if(0==g){f[2]=c;f=a.b;for(g=c;e<g;){var h=f[e];f[e]=f[g];f[g]=h;++e;--g}e=-1}}}
function Bt(a,b){a.pa[2]=a.a.length;a.pa=null;a.qa[2]=a.b.length;a.qa=null;b=[7,b];a.a.push(b);a.b.push(b)}k.df=ra;k.Zf=function(){return this.Va};function Et(a,b,c,d){xt.call(this,a,b,c,d);this.M=this.I=null;this.R=this.u=this.v=this.o=this.l=this.B=this.D=this.j=this.g=this.i=this.f=void 0}v(Et,xt);
Et.prototype.sc=function(a,b){if(this.M){At(this,b);var c=a.ba(),d=this.coordinates.length;a=yt(this,c,0,c.length,a.ma(),!1,!1);this.a.push([5,d,a,this.M,this.f,this.i,this.g,this.j,this.D,this.B,this.l,this.o,this.v,this.u,this.R]);this.b.push([5,d,a,this.I,this.f,this.i,this.g,this.j,this.D,this.B,this.l,this.o,this.v,this.u,this.R]);Bt(this,b)}};
Et.prototype.qc=function(a,b){if(this.M){At(this,b);var c=a.ba(),d=this.coordinates.length;a=yt(this,c,0,c.length,a.ma(),!1,!1);this.a.push([5,d,a,this.M,this.f,this.i,this.g,this.j,this.D,this.B,this.l,this.o,this.v,this.u,this.R]);this.b.push([5,d,a,this.I,this.f,this.i,this.g,this.j,this.D,this.B,this.l,this.o,this.v,this.u,this.R]);Bt(this,b)}};Et.prototype.df=function(){Dt(this);this.i=this.f=void 0;this.M=this.I=null;this.R=this.u=this.o=this.l=this.B=this.D=this.j=this.v=this.g=void 0};
Et.prototype.Vb=function(a){var b=a.Jc(),c=a.ic(),d=a.yg(1),e=a.Y(1),f=a.Rc();this.f=b[0];this.i=b[1];this.I=d;this.M=e;this.g=c[1];this.j=a.i;this.D=f[0];this.B=f[1];this.l=a.o;this.o=a.g;this.v=a.a;this.u=a.v;this.R=c[0]};function Ft(a,b,c,d){xt.call(this,a,b,c,d);this.i=null;this.f={Sd:void 0,Md:void 0,Nd:null,Od:void 0,Pd:void 0,Qd:void 0,Rd:void 0,sd:void 0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}v(Ft,xt);function Gt(a,b,c,d,e){var f=a.coordinates.length;b=yt(a,b,c,d,e,!1,!1);f=[9,f,b];a.a.push(f);a.b.push(f);return d}k=Ft.prototype;
k.Zf=function(){this.i||(this.i=Pa(this.Va),0<this.c&&Oa(this.i,this.resolution*(this.c+1)/2,this.i));return this.i};function Ht(a){var b=a.f,c=b.strokeStyle,d=b.lineCap,e=b.lineDash,f=b.lineDashOffset,g=b.lineJoin,h=b.lineWidth,l=b.miterLimit;b.Sd==c&&b.Md==d&&ma(b.Nd,e)&&b.Od==f&&b.Pd==g&&b.Qd==h&&b.Rd==l||(void 0!=b.sd&&b.sd!=a.coordinates.length&&(a.a.push([13]),b.sd=a.coordinates.length),b.sd=0,a.a.push([11,c,h,d,g,l,e,f,!0,1],[1]),b.Sd=c,b.Md=d,b.Nd=e,b.Od=f,b.Pd=g,b.Qd=h,b.Rd=l)}
k.oc=function(a,b){var c=this.f,d=c.lineWidth;void 0!==c.strokeStyle&&void 0!==d&&(Ht(this),At(this,b),this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1],[1]),c=a.ba(),Gt(this,c,0,c.length,a.ma()),this.b.push([13]),Bt(this,b))};
k.pc=function(a,b){var c=this.f,d=c.lineWidth;if(void 0!==c.strokeStyle&&void 0!==d){Ht(this);At(this,b);this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1],[1]);c=a.sb();d=a.ba();a=a.ma();var e=0,f;var g=0;for(f=c.length;g<f;++g)e=Gt(this,d,e,c[g],a);this.b.push([13]);Bt(this,b)}};k.df=function(){var a=this.f;void 0!=a.sd&&a.sd!=this.coordinates.length&&this.a.push([13]);Dt(this);this.f=null};
k.Na=function(a,b){a=b.b;this.f.strokeStyle=kd(a?a:ai);a=b.g;this.f.lineCap=void 0!==a?a:"round";a=b.f;this.f.lineDash=a?a:$h;a=b.i;this.f.lineDashOffset=a?a:0;a=b.j;this.f.lineJoin=void 0!==a?a:"round";a=b.c;this.f.lineWidth=void 0!==a?a:1;b=b.l;this.f.miterLimit=void 0!==b?b:10;this.f.lineWidth>this.c&&(this.c=this.f.lineWidth,this.i=null)};function It(a,b,c,d){xt.call(this,a,b,c,d);this.i=null;this.f={uh:void 0,Sd:void 0,Md:void 0,Nd:null,Od:void 0,Pd:void 0,Qd:void 0,Rd:void 0,fillStyle:void 0,strokeStyle:void 0,lineCap:void 0,lineDash:null,lineDashOffset:void 0,lineJoin:void 0,lineWidth:void 0,miterLimit:void 0}}v(It,xt);
function Jt(a,b,c,d,e){var f=a.f,g=void 0!==f.fillStyle;f=void 0!=f.strokeStyle;var h=d.length,l=[1];a.a.push(l);a.b.push(l);for(l=0;l<h;++l){var m=d[l],n=a.coordinates.length;c=yt(a,b,c,m,e,!0,!f);c=[9,n,c];a.a.push(c);a.b.push(c);f&&(c=[3],a.a.push(c),a.b.push(c));c=m}b=[8];a.b.push(b);g&&a.a.push(b);f&&(g=[13],a.a.push(g),a.b.push(g));return c}k=It.prototype;
k.$b=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){Kt(this,a);At(this,b);this.b.push([10,id(Zh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);var e=a.ba();d=this.coordinates.length;yt(this,e,0,e.length,a.ma(),!1,!1);a=[1];d=[2,d];this.a.push(a,d);this.b.push(a,d);a=[8];this.b.push(a);void 0!==c.fillStyle&&this.a.push(a);void 0!==c.strokeStyle&&(c=[13],this.a.push(c),this.b.push(c));
Bt(this,b)}};k.tc=function(a,b){var c=this.f;Kt(this,a);At(this,b);this.b.push([10,id(Zh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);c=a.sb();var d=a.Tb();Jt(this,d,0,c,a.ma());Bt(this,b)};
k.rc=function(a,b){var c=this.f,d=c.strokeStyle;if(void 0!==c.fillStyle||void 0!==d){Kt(this,a);At(this,b);this.b.push([10,id(Zh)]);void 0!==c.strokeStyle&&this.b.push([11,c.strokeStyle,c.lineWidth,c.lineCap,c.lineJoin,c.miterLimit,c.lineDash,c.lineDashOffset,!0,1]);c=a.c;d=mi(a);a=a.ma();var e=0,f;var g=0;for(f=c.length;g<f;++g)e=Jt(this,d,e,c[g],a);Bt(this,b)}};
k.df=function(){Dt(this);this.f=null;var a=this.oa;if(a){var b=this.coordinates,c;var d=0;for(c=b.length;d<c;++d)b[d]=a*Math.round(b[d]/a)}};k.Zf=function(){this.i||(this.i=Pa(this.Va),0<this.c&&Oa(this.i,this.resolution*(this.c+1)/2,this.i));return this.i};
k.Na=function(a,b){var c=this.f;a?(a=a.b,c.fillStyle=kd(a?a:Zh)):c.fillStyle=void 0;b?(a=b.b,c.strokeStyle=kd(a?a:ai),a=b.g,c.lineCap=void 0!==a?a:"round",a=b.f,c.lineDash=a?a.slice():$h,a=b.i,c.lineDashOffset=a?a:0,a=b.j,c.lineJoin=void 0!==a?a:"round",a=b.c,c.lineWidth=void 0!==a?a:1,b=b.l,c.miterLimit=void 0!==b?b:10,c.lineWidth>this.c&&(this.c=c.lineWidth,this.i=null)):(c.strokeStyle=void 0,c.lineCap=void 0,c.lineDash=null,c.lineDashOffset=void 0,c.lineJoin=void 0,c.lineWidth=void 0,c.miterLimit=
void 0)};function Kt(a,b){var c=a.f,d=c.fillStyle,e=c.strokeStyle,f=c.lineCap,g=c.lineDash,h=c.lineDashOffset,l=c.lineJoin,m=c.lineWidth,n=c.miterLimit;if(void 0!==d&&("string"!==typeof d||c.uh!=d)){var p=[10,d];"string"!==typeof d&&(b=b.G(),p.push([b[0],b[3]]));a.a.push(p);c.uh=c.fillStyle}void 0===e||c.Sd==e&&c.Md==f&&ma(c.Nd,g)&&c.Od==h&&c.Pd==l&&c.Qd==m&&c.Rd==n||(a.a.push([11,e,m,f,l,n,g,h,!0,1]),c.Sd=e,c.Md=f,c.Nd=g,c.Od=h,c.Pd=l,c.Qd=m,c.Rd=n)};function Lt(a,b,c,d){xt.call(this,a,b,c,d);this.B=this.D=this.R=null;this.ua="";this.l=this.j=0;this.o=void 0;this.u=this.v=0;this.g=this.i=this.f=null}v(Lt,xt);
Lt.prototype.Qb=function(a,b,c,d,e,f){if(""!==this.ua&&this.g&&(this.f||this.i)){if(this.f){e=this.f;var g=this.R;if(!g||g.fillStyle!=e.fillStyle){var h=[10,e.fillStyle];this.a.push(h);this.b.push(h);g?g.fillStyle=e.fillStyle:this.R={fillStyle:e.fillStyle}}}this.i&&(e=this.i,g=this.D,g&&g.lineCap==e.lineCap&&g.lineDash==e.lineDash&&g.lineDashOffset==e.lineDashOffset&&g.lineJoin==e.lineJoin&&g.lineWidth==e.lineWidth&&g.miterLimit==e.miterLimit&&g.strokeStyle==e.strokeStyle||(h=[11,e.strokeStyle,e.lineWidth,
e.lineCap,e.lineJoin,e.miterLimit,e.lineDash,e.lineDashOffset,!1,1],this.a.push(h),this.b.push(h),g?(g.lineCap=e.lineCap,g.lineDash=e.lineDash,g.lineDashOffset=e.lineDashOffset,g.lineJoin=e.lineJoin,g.lineWidth=e.lineWidth,g.miterLimit=e.miterLimit,g.strokeStyle=e.strokeStyle):this.D={lineCap:e.lineCap,lineDash:e.lineDash,lineDashOffset:e.lineDashOffset,lineJoin:e.lineJoin,lineWidth:e.lineWidth,miterLimit:e.miterLimit,strokeStyle:e.strokeStyle}));e=this.g;g=this.B;g&&g.font==e.font&&g.textAlign==
e.textAlign&&g.textBaseline==e.textBaseline||(h=[12,e.font,e.textAlign,e.textBaseline],this.a.push(h),this.b.push(h),g?(g.font=e.font,g.textAlign=e.textAlign,g.textBaseline=e.textBaseline):this.B={font:e.font,textAlign:e.textAlign,textBaseline:e.textBaseline});At(this,f);e=this.coordinates.length;a=yt(this,a,b,c,d,!1,!1);a=[6,e,a,this.ua,this.j,this.l,this.v,this.u,!!this.f,!!this.i,this.o];this.a.push(a);this.b.push(a);Bt(this,f)}};
Lt.prototype.gb=function(a){if(a){var b=a.Da();b?(b=b.b,b=kd(b?b:Zh),this.f?this.f.fillStyle=b:this.f={fillStyle:b}):this.f=null;var c=a.Ea();if(c){b=c.b;var d=c.g,e=c.f,f=c.i,g=c.j,h=c.c;c=c.l;d=void 0!==d?d:"round";e=e?e.slice():$h;f=void 0!==f?f:0;g=void 0!==g?g:"round";h=void 0!==h?h:1;c=void 0!==c?c:10;b=kd(b?b:ai);if(this.i){var l=this.i;l.lineCap=d;l.lineDash=e;l.lineDashOffset=f;l.lineJoin=g;l.lineWidth=h;l.miterLimit=c;l.strokeStyle=b}else this.i={lineCap:d,lineDash:e,lineDashOffset:f,lineJoin:g,
lineWidth:h,miterLimit:c,strokeStyle:b}}else this.i=null;var m=a.a;b=a.f;d=a.c;e=a.l;h=a.i;c=a.b;f=a.Ja();g=a.g;l=a.j;a=void 0!==m?m:"10px sans-serif";g=void 0!==g?g:"center";l=void 0!==l?l:"middle";this.g?(m=this.g,m.font=a,m.textAlign=g,m.textBaseline=l):this.g={font:a,textAlign:g,textBaseline:l};this.ua=void 0!==f?f:"";this.j=void 0!==b?b:0;this.l=void 0!==d?d:0;this.o=void 0!==e?e:!1;this.v=void 0!==h?h:0;this.u=void 0!==c?c:1}else this.ua=""};function Mt(a,b,c,d,e){this.v=a;this.f=b;this.l=d;this.o=c;this.i=e;this.a={};this.g=ld(1,1);this.j=Ih()}v(Mt,ri);var Nt={0:[[!0]]};function Ot(a,b,c){var d,e=Math.floor(a.length/2);if(b>=e)for(d=e;d<b;d++)a[d][c]=!0;else if(b<e)for(d=b+1;d<e;d++)a[d][c]=!0}
function Pt(a){if(void 0!==Nt[a])return Nt[a];for(var b=2*a+1,c=Array(b),d=0;d<b;d++)c[d]=Array(b);b=a;for(var e=d=0;b>=d;)Ot(c,a+b,a+d),Ot(c,a+d,a+b),Ot(c,a-d,a+b),Ot(c,a-b,a+d),Ot(c,a-b,a-d),Ot(c,a-d,a-b),Ot(c,a+d,a-b),Ot(c,a+b,a-d),d++,e+=1+2*d,0<2*(e-b)+1&&(--b,e+=1-2*b);return Nt[a]=c}function Qt(a){for(var b in a.a){var c=a.a[b],d;for(d in c)c[d].df()}}
Mt.prototype.Ha=function(a,b,c,d,e,f){d=Math.round(d);var g=2*d+1,h=Rh(this.j,d+.5,d+.5,1/b,-1/b,-c,-a[0],-a[1]),l=this.g;l.canvas.width!==g||l.canvas.height!==g?(l.canvas.width=g,l.canvas.height=g):l.clearRect(0,0,g,g);if(void 0!==this.i){var m=Ma();Na(m,a);Oa(m,b*(this.i+d),m)}var n=Pt(d);return Rt(this,l,h,c,e,function(a){for(var b=l.getImageData(0,0,g,g).data,c=0;c<g;c++)for(var d=0;d<g;d++)if(n[c][d]&&0<b[4*(d*g+c)+3]){if(a=f(a))return a;l.clearRect(0,0,g,g);return}},m)};
function St(a,b){var c=a.f;a=c[0];var d=c[1],e=c[2];c=c[3];a=[a,d,a,c,e,c,e,d];sf(a,0,8,2,b,a);return a}Mt.prototype.b=function(a,b){var c=void 0!==a?a.toString():"0";a=this.a[c];void 0===a&&(a={},this.a[c]=a);c=a[b];void 0===c&&(c=new Tt[b](this.v,this.f,this.o,this.l),a[b]=c);return c};Mt.prototype.c=function(){return ub(this.a)};
Mt.prototype.Ma=function(a,b,c,d,e,f){var g=Object.keys(this.a).map(Number);g.sort(fa);var h=St(this,c);a.save();a.beginPath();a.moveTo(h[0],h[1]);a.lineTo(h[2],h[3]);a.lineTo(h[4],h[5]);a.lineTo(h[6],h[7]);a.clip();f=f?f:qi;var l,m;h=0;for(l=g.length;h<l;++h){var n=this.a[g[h].toString()];var p=0;for(m=f.length;p<m;++p){var q=n[f[p]];void 0!==q&&q.Ma(a,b,c,d,e)}}a.restore()};
function Rt(a,b,c,d,e,f,g){var h=Object.keys(a.a).map(Number);h.sort(function(a,b){return b-a});var l,m;var n=0;for(l=h.length;n<l;++n){var p=a.a[h[n].toString()];for(m=qi.length-1;0<=m;--m){var q=p[qi[m]];if(void 0!==q&&(q=Ct(q,b,1,c,d,e,q.b,f,g)))return q}}}var Tt={Circle:It,Default:xt,Image:Et,LineString:Ft,Polygon:It,Text:Lt};function Ut(a){Uc.call(this);this.a=a}v(Ut,Uc);Ut.prototype.Ha=ra;Ut.prototype.ef=qf;Ut.prototype.Uf=function(a,b,c){return function(d,e){return Vt(a,b,d,e,function(a){c[d]||(c[d]={});c[d][a.sa.toString()]=a})}};Ut.prototype.ta=function(a){2===a.target.getState()&&Wt(this)};function Xt(a,b){var c=b.getState();2!=c&&3!=c&&y(b,"change",a.ta,a);0==c&&(b.load(),c=b.getState());return 2==c}function Wt(a){var b=a.a;b.Sb()&&"ready"==b.hg()&&a.s()}
function Yt(a,b){b.Ui()&&a.postRenderFunctions.push(function(a,b,e){b=w(a).toString();b in e.usedTiles&&a.jd(e.viewState.projection,e.usedTiles[b])}.bind(null,b))}function Zt(a,b){if(b){var c;var d=0;for(c=b.length;d<c;++d){var e=b[d];a[w(e).toString()]=e}}}function $t(a,b){b=b.D;void 0!==b&&("string"===typeof b?a.logos[b]="":b&&(va("string"==typeof b.href,44),va("string"==typeof b.src,45),a.logos[b.src]=b.href))}
function au(a,b,c,d){b=w(b).toString();c=c.toString();b in a?c in a[b]?(a=a[b][c],d.ca<a.ca&&(a.ca=d.ca),d.da>a.da&&(a.da=d.da),d.ea<a.ea&&(a.ea=d.ea),d.ha>a.ha&&(a.ha=d.ha)):a[b][c]=d:(a[b]={},a[b][c]=d)}
function bu(a,b,c,d,e,f,g,h,l,m){var n=w(b).toString();n in a.wantedTiles||(a.wantedTiles[n]={});var p=a.wantedTiles[n];a=a.tileQueue;var q=c.minZoom,t,u,x;for(x=g;x>=q;--x){var B=pc(c,f,x,B);var z=c.Ca(x);for(t=B.ca;t<=B.da;++t)for(u=B.ea;u<=B.ha;++u)if(g-x<=h){var G=b.Qc(x,t,u,d,e);0==G.getState()&&(p[G.fb()]=!0,G.fb()in a.a||a.i([G,n,uc(c,G.sa),z]));l&&l.call(m,G)}else b.Zg(x,t,u,e)}};function cu(a){Ut.call(this,a);this.U=Ih()}v(cu,Ut);function du(a,b,c){var d=b.pixelRatio,e=b.size[0]*d,f=b.size[1]*d,g=b.viewState.rotation,h=gb(c),l=fb(c),m=eb(c);c=db(c);Nh(b.coordinateToPixelTransform,h);Nh(b.coordinateToPixelTransform,l);Nh(b.coordinateToPixelTransform,m);Nh(b.coordinateToPixelTransform,c);a.save();bi(a,-g,e/2,f/2);a.beginPath();a.moveTo(h[0]*d,h[1]*d);a.lineTo(l[0]*d,l[1]*d);a.lineTo(m[0]*d,m[1]*d);a.lineTo(c[0]*d,c[1]*d);a.clip();bi(a,g,e/2,f/2)}
function eu(a,b,c,d,e){var f=a.a;if(Tc(f,b)){var g=d.size[0]*d.pixelRatio,h=d.size[1]*d.pixelRatio,l=d.viewState.rotation;bi(c,-l,g/2,h/2);a=e?e:fu(a,d,0);f.b(new Yh(b,new di(c,d.pixelRatio,d.extent,a,d.viewState.rotation),d,c,null));bi(c,l,g/2,h/2)}}cu.prototype.v=function(a,b,c,d){if(this.Ha(a,b,0,pf,this))return c.call(d,this.a,null)};cu.prototype.qf=function(a,b,c,d){eu(this,"postcompose",a,b,d)};
function fu(a,b,c){var d=b.viewState,e=b.pixelRatio,f=e/d.resolution;return Rh(a.U,e*b.size[0]/2,e*b.size[1]/2,f,-f,-d.rotation,-d.center[0]+c,-d.center[1])};function gu(a,b){return w(a)-w(b)}function hu(a,b){a=.5*a/b;return a*a}function iu(a,b,c,d,e,f){var g=!1,h;if(h=c.Y()){var l=h.hf();2==l||3==l?h.Lj(e,f):(0==l&&h.load(),h.Wh(e,f),g=!0)}if(e=(0,c.$a)(b))if(d=e.ae(d),c.Je())ju(a,d,c,b);else(0,ku[d.T()])(a,d,c,b);return g}function ju(a,b,c,d){if("GeometryCollection"==b.T()){b=b.kd();for(var e=0,f=b.length;e<f;++e)ju(a,b[e],c,d)}else a.b(c.za(),"Default").wh(b,d,c.Je())}
var ku={Point:function(a,b,c,d){var e=c.Y();if(e){if(2!=e.hf())return;var f=a.b(c.za(),"Image");f.Vb(e);f.sc(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),a.Qb(b.ba(),0,2,2,b,d)},LineString:function(a,b,c,d){var e=c.Ea();if(e){var f=a.b(c.za(),"LineString");f.Na(null,e);f.oc(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),a.Qb(ki(b),0,2,2,b,d)},Polygon:function(a,b,c,d){var e=c.Da(),f=c.Ea();if(e||f){var g=a.b(c.za(),"Polygon");g.Na(e,f);g.tc(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),a.Qb(ag(b),
0,2,2,b,d)},MultiPoint:function(a,b,c,d){var e=c.Y();if(e){if(2!=e.hf())return;var f=a.b(c.za(),"Image");f.Vb(e);f.qc(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),c=b.ba(),a.Qb(c,0,c.length,b.ma(),b,d)},MultiLineString:function(a,b,c,d){var e=c.Ea();if(e){var f=a.b(c.za(),"LineString");f.Na(null,e);f.pc(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),c=li(b),a.Qb(c,0,c.length,2,b,d)},MultiPolygon:function(a,b,c,d){var e=c.Da(),f=c.Ea();if(f||e){var g=a.b(c.za(),"Polygon");g.Na(e,f);g.rc(b,d)}if(e=
c.Ja())a=a.b(c.za(),"Text"),a.gb(e),c=ni(b),a.Qb(c,0,c.length,2,b,d)},GeometryCollection:function(a,b,c,d){b=b.a;var e;var f=0;for(e=b.length;f<e;++f)(0,ku[b[f].T()])(a,b[f],c,d)},Circle:function(a,b,c,d){var e=c.Da(),f=c.Ea();if(e||f){var g=a.b(c.za(),"Circle");g.Na(e,f);g.$b(b,d)}if(e=c.Ja())a=a.b(c.za(),"Text"),a.gb(e),a.Qb(b.xa(),0,2,2,b,d)}};function lu(a){cu.call(this,a);this.c=!1;this.R=-1;this.o=NaN;this.j=Ma();this.i=this.l=null;this.g=ld()}v(lu,cu);
lu.prototype.u=function(a,b,c){var d=a.extent,e=a.pixelRatio,f=b.Ue?a.skippedFeatureUids:{},g=a.viewState,h=g.projection,l=g.rotation,m=h.G(),n=this.a.ia(),p=fu(this,a,0);eu(this,"precompose",c,a,p);var q=b.extent;(g=void 0!==q)&&du(c,a,q);var t=this.i;if(t&&!t.c()){var u=q=0,x=1!==b.opacity,B=Tc(this.a,"render");if(x||B){var z=c.canvas.width;var G=c.canvas.height;if(l){var E=Math.round(Math.sqrt(z*z+G*G));q=(E-z)/2;u=(E-G)/2;z=G=E}this.g.canvas.width=z;this.g.canvas.height=G;z=this.g}else z=c;G=
z.globalAlpha;x||(z.globalAlpha=b.opacity);z!=c&&z.translate(q,u);E=a.size[0]*e;var ia=a.size[1]*e;bi(z,-l,E/2,ia/2);t.Ma(z,e,p,l,f);if(n.u&&h.f&&!Ta(m,d)){h=d[0];n=jb(m);for(var T=0;h<m[0];)--T,p=n*T,p=fu(this,a,p),t.Ma(z,e,p,l,f),h+=n;T=0;for(h=d[2];h>m[2];)++T,p=n*T,p=fu(this,a,p),t.Ma(z,e,p,l,f),h-=n;p=fu(this,a,0)}bi(z,l,E/2,ia/2);z!=c&&(B&&eu(this,"render",z,a,p),x?(d=c.globalAlpha,c.globalAlpha=b.opacity,c.drawImage(z.canvas,-q,-u),c.globalAlpha=d):c.drawImage(z.canvas,-q,-u),z.translate(-q,
-u));x||(z.globalAlpha=G)}g&&c.restore();this.qf(c,a,b,p)};lu.prototype.Ha=function(a,b,c,d,e){if(this.i){var f=this.a,g={};return this.i.Ha(a,b.viewState.resolution,b.viewState.rotation,c,{},function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,d.call(e,a,f)})}};lu.prototype.D=function(){Wt(this)};
lu.prototype.yd=function(a){var b=this.a,c=b.ia();Zt(a.attributions,c.j);$t(a,c);var d=a.viewHints[0],e=a.viewHints[1],f=b.S,g=b.U;if(!this.c&&!f&&d||!g&&e)return!0;f=a.extent;var h=a.viewState;g=h.projection;var l=h.resolution,m=a.pixelRatio;d=b.f;var n=b.c;e=b.get(mu);void 0===e&&(e=gu);f=Oa(f,n*l);n=h.projection.G();c.u&&h.projection.f&&!Ta(n,a.extent)&&(a=Math.max(jb(f)/2,jb(n)),f[0]=n[0]-a,f[2]=n[2]+a);if(!this.c&&this.o==l&&this.R==d&&this.l==e&&Ta(this.j,f))return!0;this.i=null;this.c=!1;var p=
new Mt(.5*l/m,f,l,c.U,b.c);c.de(f,l,g);a=function(a){var c=a.bb();if(c)var d=c.call(a,l);else(c=b.bb())&&(d=c(a,l));if(d){if(d){c=!1;if(Array.isArray(d))for(var e=0,f=d.length;e<f;++e)c=iu(p,a,d[e],hu(l,m),this.D,this)||c;else c=iu(p,a,d,hu(l,m),this.D,this)||c;a=c}else a=!1;this.c=this.c||a}}.bind(this);if(e){var q=[];c.ac(f,function(a){q.push(a)},this);q.sort(e);c=0;for(g=q.length;c<g;++c)a(q[c])}else c.ac(f,a,this);Qt(p);this.o=l;this.R=d;this.l=e;this.j=f;this.i=p;return!0};function nu(){this.b="precision mediump float;varying vec2 a;uniform float f;uniform sampler2D g;void main(void){vec4 texColor=texture2D(g,a);gl_FragColor.rgb=texColor.rgb;gl_FragColor.a=texColor.a*f;}"}v(nu,ti);var ou=new nu;function pu(){this.b="varying vec2 a;attribute vec2 b;attribute vec2 c;uniform mat4 d;uniform mat4 e;void main(void){gl_Position=e*vec4(b,0.,1.);a=(d*vec4(c,0.,1.)).st;}"}v(pu,ui);var qu=new pu;
function ru(a,b){this.f=a.getUniformLocation(b,"f");this.c=a.getUniformLocation(b,"e");this.g=a.getUniformLocation(b,"d");this.i=a.getUniformLocation(b,"g");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function su(a,b){Ut.call(this,b);this.c=a;this.U=new Ki([-1,-1,0,0,1,-1,1,0,-1,1,0,1,1,1,1,1]);this.g=this.Hb=null;this.j=void 0;this.v=Ih();this.R=Ih();this.B=Ai();this.u=null}v(su,Ut);
function tu(a,b,c){var d=a.c.f;if(void 0===a.j||a.j!=c){b.postRenderFunctions.push(function(a,b,c){a.isContextLost()||(a.deleteFramebuffer(b),a.deleteTexture(c))}.bind(null,d,a.g,a.Hb));b=Xi(d,c,c);var e=d.createFramebuffer();d.bindFramebuffer(36160,e);d.framebufferTexture2D(36160,36064,3553,b,0);a.Hb=b;a.g=e;a.j=c}else d.bindFramebuffer(36160,a.g)}
su.prototype.Qi=function(a,b,c){uu(this,"precompose",c,a);Di(c,34962,this.U);var d=c.b,e=Oi(c,ou,qu);if(this.u)var f=this.u;else this.u=f=new ru(d,e);c.Tc(e)&&(d.enableVertexAttribArray(f.b),d.vertexAttribPointer(f.b,2,5126,!1,16,0),d.enableVertexAttribArray(f.a),d.vertexAttribPointer(f.a,2,5126,!1,16,8),d.uniform1i(f.i,0));d.uniformMatrix4fv(f.g,!1,Bi(this.B,this.v));d.uniformMatrix4fv(f.c,!1,Bi(this.B,this.R));d.uniform1f(f.f,b.opacity);d.bindTexture(3553,this.Hb);d.drawArrays(5,0,4);uu(this,"postcompose",
c,a)};function uu(a,b,c,d){a=a.a;if(Tc(a,b)){var e=d.viewState;a.b(new Yh(b,new Ck(c,e.center,e.resolution,e.rotation,d.size,d.extent,d.pixelRatio),d,null,c))}}su.prototype.ug=function(){this.g=this.Hb=null;this.j=void 0};function vu(a,b){su.call(this,a,b);this.o=!1;this.S=-1;this.I=NaN;this.D=Ma();this.l=this.i=this.C=null}v(vu,su);k=vu.prototype;k.Qi=function(a,b,c){this.l=b;var d=a.viewState,e=this.i,f=a.size,g=a.pixelRatio,h=this.c.f;e&&!e.c()&&(h.enable(h.SCISSOR_TEST),h.scissor(0,0,f[0]*g,f[1]*g),e.Ma(c,d.center,d.resolution,d.rotation,f,g,b.opacity,b.Ue?a.skippedFeatureUids:{}),h.disable(h.SCISSOR_TEST))};k.ka=function(){var a=this.i;a&&(wk(a,this.c.i)(),this.i=null);su.prototype.ka.call(this)};
k.Ha=function(a,b,c,d,e){if(this.i&&this.l){c=b.viewState;var f=this.a,g={};return this.i.Ha(a,this.c.i,c.center,c.resolution,c.rotation,b.size,b.pixelRatio,this.l.opacity,{},function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,d.call(e,a,f)})}};k.ef=function(a,b){if(this.i&&this.l){var c=b.viewState;return Bk(this.i,a,this.c.i,c.resolution,c.rotation,b.pixelRatio,this.l.opacity,b.skippedFeatureUids)}return!1};
k.tg=function(a,b,c,d){a=Nh(b.pixelToCoordinateTransform,a.slice());if(this.ef(a,b))return c.call(d,this.a,null)};k.Ri=function(){Wt(this)};
k.vg=function(a,b,c){function d(a){var b=a.bb();if(b)var c=b.call(a,m);else(b=e.bb())&&(c=b(a,m));if(c){if(c){b=!1;if(Array.isArray(c))for(var d=c.length-1;0<=d;--d)b=iu(q,a,c[d],hu(m,n),this.Ri,this)||b;else b=iu(q,a,c,hu(m,n),this.Ri,this)||b;a=b}else a=!1;this.o=this.o||a}}var e=this.a;b=e.ia();Zt(a.attributions,b.j);$t(a,b);var f=a.viewHints[0],g=a.viewHints[1],h=e.S,l=e.U;if(!this.o&&!h&&f||!l&&g)return!0;g=a.extent;h=a.viewState;f=h.projection;var m=h.resolution,n=a.pixelRatio;h=e.f;var p=e.c;
l=e.get(mu);void 0===l&&(l=gu);g=Oa(g,p*m);if(!this.o&&this.I==m&&this.S==h&&this.C==l&&Ta(this.D,g))return!0;this.i&&a.postRenderFunctions.push(wk(this.i,c));this.o=!1;var q=new vk(.5*m/n,g,e.c);b.de(g,m,f);if(l){var t=[];b.ac(g,function(a){t.push(a)},this);t.sort(l);t.forEach(d,this)}else b.ac(g,d,this);xk(q,c);this.I=m;this.S=h;this.C=l;this.D=g;this.i=q;return!0};function S(a){a=a?a:{};var b=rb({},a);delete b.style;delete b.renderBuffer;delete b.updateWhileAnimating;delete b.updateWhileInteracting;Dh.call(this,b);this.c=void 0!==a.renderBuffer?a.renderBuffer:100;this.v=null;this.C=void 0;this.i(a.style);this.S=void 0!==a.updateWhileAnimating?a.updateWhileAnimating:!1;this.U=void 0!==a.updateWhileInteracting?a.updateWhileInteracting:!1}v(S,Dh);S.prototype.Ld=function(a){var b=null,c=a.T();"canvas"===c?b=new lu(this):"webgl"===c&&(b=new vu(a,this));return b};
S.prototype.u=function(){return this.v};S.prototype.bb=function(){return this.C};S.prototype.i=function(a){this.v=void 0!==a?a:zl;this.C=null===a?void 0:xl(this.v);this.s()};var mu="renderOrder";function wu(){return[[-Infinity,-Infinity,Infinity,Infinity]]};function xu(a){Vc.call(this);this.c=Wb(a.projection);this.j=yu(a.attributions);this.D=a.logo;this.ta=void 0!==a.state?a.state:"ready";this.u=void 0!==a.wrapX?a.wrapX:!1}v(xu,Vc);function yu(a){if("string"===typeof a)return[new Cc({html:a})];if(a instanceof Cc)return[a];if(Array.isArray(a)){for(var b=a.length,c=Array(b),d=0;d<b;d++){var e=a[d];c[d]="string"===typeof e?new Cc({html:e}):e}return c}return null}k=xu.prototype;k.Ha=ra;k.Aa=function(){return this.j};k.ya=function(){return this.D};k.Ba=function(){return this.c};
k.getState=function(){return this.ta};k.ra=function(){this.s()};k.wa=function(a){this.j=yu(a);this.s()};function zu(a,b){a.ta=b;a.s()};function V(a){a=a||{};xu.call(this,{attributions:a.attributions,logo:a.logo,projection:void 0,state:"ready",wrapX:void 0!==a.wrapX?a.wrapX:!0});this.C=ra;this.B=a.format;this.U=void 0==a.overlaps?!0:a.overlaps;this.I=a.url;a.loader?this.C=a.loader:void 0!==this.I&&(va(this.B,7),this.C=Xl(this.I,this.B));this.ga=a.strategy?a.strategy:wu;var b=void 0!==a.useSpatialIndex?a.useSpatialIndex:!0;this.a=b?new Oj:null;this.S=new Oj;this.g={};this.l={};this.o={};this.v={};this.i=null;if(a.features instanceof
$c){var c=a.features;var d=c.a}else Array.isArray(a.features)&&(d=a.features);b||c||(c=new $c(d));d&&Au(this,d);c&&Bu(this,c)}v(V,xu);k=V.prototype;k.Bb=function(a){var b=w(a).toString();if(Cu(this,b,a)){Du(this,b,a);var c=a.W();c?(b=c.G(),this.a&&this.a.Ga(b,a)):this.g[b]=a;this.b(new Eu("addfeature",a))}this.s()};function Du(a,b,c){a.v[b]=[y(c,"change",a.Yi,a),y(c,"propertychange",a.Yi,a)]}
function Cu(a,b,c){var d=!0,e=c.a;void 0!==e?e.toString()in a.l?d=!1:a.l[e.toString()]=c:(va(!(b in a.o),30),a.o[b]=c);return d}k.Ec=function(a){Au(this,a);this.s()};function Au(a,b){var c,d=[],e=[],f=[];var g=0;for(c=b.length;g<c;g++){var h=b[g];var l=w(h).toString();Cu(a,l,h)&&e.push(h)}g=0;for(c=e.length;g<c;g++)h=e[g],l=w(h).toString(),Du(a,l,h),(b=h.W())?(l=b.G(),d.push(l),f.push(h)):a.g[l]=h;a.a&&a.a.load(d,f);g=0;for(c=e.length;g<c;g++)a.b(new Eu("addfeature",e[g]))}
function Bu(a,b){var c=!1;y(a,"addfeature",function(a){c||(c=!0,b.push(a.feature),c=!1)});y(a,"removefeature",function(a){c||(c=!0,b.remove(a.feature),c=!1)});y(b,"add",function(a){c||(c=!0,this.Bb(a.element),c=!1)},a);y(b,"remove",function(a){c||(c=!0,this.Fb(a.element),c=!1)},a);a.i=b}
k.clear=function(a){if(a){for(var b in this.v)this.v[b].forEach(Gc);this.i||(this.v={},this.l={},this.o={})}else if(this.a){this.a.forEach(this.Qg,this);for(var c in this.g)this.Qg(this.g[c])}this.i&&this.i.clear();this.a&&this.a.clear();this.S.clear();this.g={};this.b(new Eu("clear"));this.s()};k.Ah=function(a,b){if(this.a)return this.a.forEach(a,b);if(this.i)return this.i.forEach(a,b)};function Fu(a,b,c){a.ac([b[0],b[1],b[0],b[1]],function(a){if(a.W().wb(b))return c.call(void 0,a)})}
k.ac=function(a,b,c){if(this.a)return Tj(this.a,a,b,c);if(this.i)return this.i.forEach(b,c)};k.Bh=function(a,b,c){return this.ac(a,function(d){if(d.W().Ya(a)&&(d=b.call(c,d)))return d})};k.Ih=function(){return this.i};k.fe=function(){if(this.i)var a=this.i.a;else this.a&&(a=Qj(this.a),ub(this.g)||ka(a,tb(this.g)));return a};k.Hh=function(a){var b=[];Fu(this,a,function(a){b.push(a)});return b};k.ag=function(a){return Rj(this.a,a)};
k.Dh=function(a,b){var c=a[0],d=a[1],e=null,f=[NaN,NaN],g=Infinity,h=[-Infinity,-Infinity,Infinity,Infinity],l=b?b:pf;Tj(this.a,h,function(a){if(l(a)){var b=a.W(),m=g;g=b.Jb(c,d,f,g);g<m&&(e=a,a=Math.sqrt(g),h[0]=c-a,h[1]=d-a,h[2]=c+a,h[3]=d+a)}});return e};k.G=function(a){return this.a.G(a)};k.Gh=function(a){a=this.l[a.toString()];return void 0!==a?a:null};k.Wi=function(){return this.B};k.Xi=function(){return this.I};
k.Yi=function(a){a=a.target;var b=w(a).toString(),c=a.W();c?(c=c.G(),b in this.g?(delete this.g[b],this.a&&this.a.Ga(c,a)):this.a&&Pj(this.a,c,a)):b in this.g||(this.a&&this.a.remove(a),this.g[b]=a);c=a.a;void 0!==c?(c=c.toString(),b in this.o?(delete this.o[b],this.l[c]=a):this.l[c]!==a&&(Gu(this,a),this.l[c]=a)):b in this.o||(Gu(this,a),this.o[b]=a);this.s();this.b(new Eu("changefeature",a))};
k.de=function(a,b,c){var d=this.S;a=this.ga(a,b);var e;var f=0;for(e=a.length;f<e;++f){var g=a[f];Tj(d,g,function(a){return Ta(a.extent,g)})||(this.C.call(this,g,b,c),d.Ga(g,{extent:g.slice()}))}};k.Fb=function(a){var b=w(a).toString();b in this.g?delete this.g[b]:this.a&&this.a.remove(a);this.Qg(a);this.s()};k.Qg=function(a){var b=w(a).toString();this.v[b].forEach(Gc);delete this.v[b];var c=a.a;void 0!==c?delete this.l[c.toString()]:delete this.o[b];this.b(new Eu("removefeature",a))};
function Gu(a,b){for(var c in a.l)if(a.l[c]===b){delete a.l[c];break}}function Eu(a,b){Qc.call(this,a);this.feature=b}v(Eu,Qc);function Hu(a){Jg.call(this,{handleDownEvent:Iu,handleEvent:Ju,handleUpEvent:Ku});this.U=!1;this.ga=null;this.u=!1;this.Zb=a.source?a.source:null;this.Za=a.features?a.features:null;this.Hk=a.snapTolerance?a.snapTolerance:12;this.S=a.type;this.g=Lu(this.S);this.Sa=a.minPoints?a.minPoints:this.g===Mu?3:2;this.va=a.maxPoints?a.maxPoints:Infinity;this.Jd=a.finishCondition?a.finishCondition:pf;var b=a.geometryFunction;if(!b)if("Circle"===this.S)b=function(a,b){b=b?b:new Ss([NaN,NaN]);b.Vg(a[0],Math.sqrt(kf(a[0],
a[1])));return b};else{var c,d=this.g;d===Nu?c=C:d===Ou?c=M:d===Mu&&(c=D);b=function(a,b){b?d===Mu?b.na([a[0].concat([a[0][0]])]):b.na(a):b=new c(a);return b}}this.$a=b;this.I=this.B=this.a=this.C=this.j=this.o=null;this.ed=a.clickTolerance?a.clickTolerance*a.clickTolerance:36;this.oa=new S({source:new V({useSpatialIndex:!1,wrapX:a.wrapX?a.wrapX:!1}),style:a.style?a.style:Pu()});this.Ib=a.geometryName;this.Gk=a.condition?a.condition:Dg;this.Lf=a.freehand?pf:a.freehandCondition?a.freehandCondition:
Eg;y(this,Xc("active"),this.Bi,this)}v(Hu,Jg);function Pu(){var a=Al();return function(b){return a[b.W().T()]}}k=Hu.prototype;k.setMap=function(a){Jg.prototype.setMap.call(this,a);this.Bi()};function Ju(a){this.u=this.g!==Nu&&this.Lf(a);var b=!this.u;this.u&&"pointerdrag"===a.type&&null!==this.j?(Qu(this,a),b=!1):"pointermove"===a.type?b=Ru(this,a):"dblclick"===a.type&&(b=!1);return Kg.call(this,a)&&b}
function Iu(a){this.U=!this.u;return this.u?(this.ga=a.pixel,this.o||Su(this,a),!0):this.Gk(a)?(this.ga=a.pixel,!0):!1}function Ku(a){var b=!0;Ru(this,a);var c=this.g===Tu;this.U?(this.o?this.u||c?this.Vd():Uu(this,a)?this.Jd(a)&&this.Vd():Qu(this,a):(Su(this,a),this.g===Nu&&this.Vd()),b=!1):this.u&&(this.o=null,Vu(this));return b}
function Ru(a,b){if(a.ga&&(!a.u&&a.U||a.u&&!a.U)){var c=a.ga,d=b.pixel,e=c[0]-d[0];c=c[1]-d[1];e=e*e+c*c;a.U=a.u?e>a.ed:e<=a.ed}a.o?(e=b.coordinate,c=a.j.W(),a.g===Nu?d=a.a:a.g===Mu?(d=a.a[0],d=d[d.length-1],Uu(a,b)&&(e=a.o.slice())):(d=a.a,d=d[d.length-1]),d[0]=e[0],d[1]=e[1],a.$a(a.a,c),a.C&&a.C.W().na(e),c instanceof D&&a.g!==Mu?(a.B||(a.B=new Bl(new M(null))),e=c.Kh(0),b=a.B.W(),b.aa(e.ja,e.ba())):a.I&&(b=a.B.W(),b.na(a.I)),Wu(a)):(b=b.coordinate.slice(),a.C?a.C.W().na(b):(a.C=new Bl(new C(b)),
Wu(a)));return!0}function Uu(a,b){var c=!1;if(a.j){var d=!1,e=[a.o];a.g===Ou?d=a.a.length>a.Sa:a.g===Mu&&(d=a.a[0].length>a.Sa,e=[a.a[0][0],a.a[0][a.a[0].length-2]]);if(d){d=b.map;for(var f=0,g=e.length;f<g;f++){var h=e[f],l=d.Ka(h),m=b.pixel;c=m[0]-l[0];l=m[1]-l[1];if(c=Math.sqrt(c*c+l*l)<=(a.u?1:a.Hk)){a.o=h;break}}}}return c}
function Su(a,b){b=b.coordinate;a.o=b;a.g===Nu?a.a=b.slice():a.g===Mu?(a.a=[[b.slice(),b.slice()]],a.I=a.a[0]):(a.a=[b.slice(),b.slice()],a.g===Tu&&(a.I=a.a));a.I&&(a.B=new Bl(new M(a.I)));b=a.$a(a.a);a.j=new Bl;a.Ib&&a.j.Wc(a.Ib);a.j.Ra(b);Wu(a);a.b(new Xu("drawstart",a.j))}
function Qu(a,b){b=b.coordinate;var c=a.j.W(),d;if(a.g===Ou){a.o=b.slice();var e=a.a;e.length>=a.va&&(a.u?e.pop():d=!0);e.push(b.slice());a.$a(e,c)}else a.g===Mu&&(e=a.a[0],e.length>=a.va&&(a.u?e.pop():d=!0),e.push(b.slice()),d&&(a.o=e[0]),a.$a(a.a,c));Wu(a);d&&a.Vd()}
k.aq=function(){if(this.j){var a=this.j.W();if(this.g===Ou){var b=this.a;b.splice(-2,1);this.$a(b,a);2<=b.length&&(this.o=b[b.length-2].slice())}else if(this.g===Mu){b=this.a[0];b.splice(-2,1);var c=this.B.W();c.na(b);this.$a(this.a,a)}0===b.length&&(this.o=null);Wu(this)}};
k.Vd=function(){var a=Vu(this),b=this.a,c=a.W();this.g===Ou?(b.pop(),this.$a(b,c)):this.g===Mu&&(b[0].pop(),this.$a(b,c),b=c.V());"MultiPoint"===this.S?a.Ra(new O([b])):"MultiLineString"===this.S?a.Ra(new N([b])):"MultiPolygon"===this.S&&a.Ra(new P([b]));this.b(new Xu("drawend",a));this.Za&&this.Za.push(a);this.Zb&&this.Zb.Bb(a)};function Vu(a){a.o=null;var b=a.j;b&&(a.j=null,a.C=null,a.B=null,a.oa.ia().clear(!0));return b}
k.Jn=function(a){var b=a.W();this.j=a;this.a=b.V();a=this.a[this.a.length-1];this.o=a.slice();this.a.push(a.slice());Wu(this);this.b(new Xu("drawstart",this.j))};k.$c=qf;function Wu(a){var b=[];a.j&&b.push(a.j);a.B&&b.push(a.B);a.C&&b.push(a.C);a=a.oa.ia();a.clear(!0);a.Ec(b)}k.Bi=function(){var a=this.v,b=this.c();a&&b||Vu(this);this.oa.setMap(b?a:null)};
function Lu(a){var b;"Point"===a||"MultiPoint"===a?b=Nu:"LineString"===a||"MultiLineString"===a?b=Ou:"Polygon"===a||"MultiPolygon"===a?b=Mu:"Circle"===a&&(b=Tu);return b}var Nu="Point",Ou="LineString",Mu="Polygon",Tu="Circle";function Xu(a,b){Qc.call(this,a);this.feature=b}v(Xu,Qc);function Yu(a){this.a=this.j=null;this.B=!1;this.C=this.o=null;a||(a={});Jg.call(this,{handleDownEvent:Zu,handleDragEvent:$u,handleEvent:av,handleUpEvent:bv});this.u=new S({source:new V({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.boxStyle?a.boxStyle:cv(),updateWhileAnimating:!0,updateWhileInteracting:!0});this.I=new S({source:new V({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.pointerStyle?a.pointerStyle:dv(),updateWhileAnimating:!0,updateWhileInteracting:!0});a.extent&&this.g(a.extent)}v(Yu,Jg);
function av(a){if(!(a instanceof ie))return!0;if("pointermove"==a.type&&!this.D){var b=a.pixel,c=a.map,d=ev(this,b,c);d||(d=c.Xa(b));fv(this,d)}Kg.call(this,a);return!1}
function Zu(a){function b(a){var b=null,c=null;a[0]==e[0]?b=e[2]:a[0]==e[2]&&(b=e[0]);a[1]==e[1]?c=e[3]:a[1]==e[3]&&(c=e[1]);return null!==b&&null!==c?[b,c]:null}var c=a.pixel,d=a.map,e=this.G();(a=ev(this,c,d))&&e?(c=a[0]==e[0]||a[0]==e[2]?a[0]:null,d=a[1]==e[1]||a[1]==e[3]?a[1]:null,null!==c&&null!==d?this.a=gv(b(a)):null!==c?this.a=hv(b([c,e[1]]),b([c,e[3]])):null!==d&&(this.a=hv(b([e[0],d]),b([e[2],d])))):(a=d.Xa(c),this.g([a[0],a[1],a[0],a[1]]),this.a=gv(a));return!0}
function $u(a){this.a&&(a=a.coordinate,this.g(this.a(a)),fv(this,a));return!0}function bv(){this.a=null;var a=this.G();a&&hb(a)||this.g(null);return!1}function cv(){var a=Al();return function(){return a.Polygon}}function dv(){var a=Al();return function(){return a.Point}}function gv(a){return function(b){return La([a,b])}}function hv(a,b){return a[0]==b[0]?function(c){return La([a,[c[0],b[1]]])}:a[1]==b[1]?function(c){return La([a,[b[0],c[1]]])}:null}
function ev(a,b,c){function d(a,b){return mf(e,a)-mf(e,b)}var e=c.Xa(b),f=a.G();if(f){f=[[[f[0],f[1]],[f[0],f[3]]],[[f[0],f[3]],[f[2],f[3]]],[[f[2],f[3]],[f[2],f[1]]],[[f[2],f[1]],[f[0],f[1]]]];f.sort(d);f=f[0];var g=df(e,f),h=c.Ka(g);if(10>=lf(b,h))return b=c.Ka(f[0]),c=c.Ka(f[1]),b=kf(h,b),c=kf(h,c),a.B=10>=Math.sqrt(Math.min(b,c)),a.B&&(g=b>c?f[1]:f[0]),g}return null}function fv(a,b){var c=a.C;c?c.W().na(b):(c=new Bl(new C(b)),a.C=c,a.I.ia().Bb(c))}
Yu.prototype.setMap=function(a){this.u.setMap(a);this.I.setMap(a);Jg.prototype.setMap.call(this,a)};Yu.prototype.G=function(){return this.j};Yu.prototype.g=function(a){this.j=a?a:null;var b=this.o;b?a?b.Ra(cg(a)):b.Ra(void 0):(this.o=b=a?new Bl(cg(a)):new Bl({}),this.u.ia().Bb(b));this.b(new iv(this.j))};function iv(a){Qc.call(this,"extentchanged");this.extent=a}v(iv,Qc);function jv(a){Jg.call(this,{handleDownEvent:kv,handleDragEvent:lv,handleEvent:mv,handleUpEvent:nv});this.Jd=a.condition?a.condition:Hg;this.Ib=function(a){return yg(a)&&Cg(a)};this.Zb=a.deleteCondition?a.deleteCondition:this.Ib;this.ed=a.insertVertexCondition?a.insertVertexCondition:pf;this.Za=this.g=null;this.Sa=[0,0];this.B=this.I=!1;this.a=new Oj;this.oa=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.o=this.va=!1;this.j=[];this.C=new S({source:new V({useSpatialIndex:!1,wrapX:!!a.wrapX}),style:a.style?
a.style:ov(),updateWhileAnimating:!0,updateWhileInteracting:!0});this.ga={Point:this.Rn,LineString:this.Di,LinearRing:this.Di,Polygon:this.Sn,MultiPoint:this.Pn,MultiLineString:this.On,MultiPolygon:this.Qn,Circle:this.Mn,GeometryCollection:this.Nn};this.U=null;a.source?(this.U=a.source,a=new $c(this.U.fe()),y(this.U,"addfeature",this.fm,this),y(this.U,"removefeature",this.hm,this)):a=a.features;if(!a)throw Error("The modify interaction requires features or a source");this.u=a;this.u.forEach(this.sg,
this);y(this.u,"add",this.Kn,this);y(this.u,"remove",this.Ln,this);this.S=null}v(jv,Jg);k=jv.prototype;k.sg=function(a){var b=a.W();b&&b.T()in this.ga&&this.ga[b.T()].call(this,a,b);(b=this.v)&&b.c&&this.c()&&pv(this,this.Sa,b);y(a,"change",this.Ci,this)};function qv(a,b){a.B||(a.B=!0,a.b(new rv("modifystart",a.u,b)))}function sv(a,b){tv(a,b);a.g&&!a.u.ec()&&(a.C.ia().Fb(a.g),a.g=null);Mc(b,"change",a.Ci,a)}
function tv(a,b){a=a.a;var c=[];a.forEach(function(a){b===a.feature&&c.push(a)});for(var d=c.length-1;0<=d;--d)a.remove(c[d])}k.Ia=function(a){this.g&&!a&&(this.C.ia().Fb(this.g),this.g=null);Jg.prototype.Ia.call(this,a)};k.setMap=function(a){this.C.setMap(a);Jg.prototype.setMap.call(this,a)};k.fm=function(a){a.feature&&this.u.push(a.feature)};k.hm=function(a){a.feature&&this.u.remove(a.feature)};k.Kn=function(a){this.sg(a.element)};k.Ci=function(a){this.o||(a=a.target,sv(this,a),this.sg(a))};
k.Ln=function(a){sv(this,a.element)};k.Rn=function(a,b){var c=b.V();a={feature:a,geometry:b,la:[c,c]};this.a.Ga(b.G(),a)};k.Pn=function(a,b){var c=b.V(),d;var e=0;for(d=c.length;e<d;++e){var f=c[e];f={feature:a,geometry:b,depth:[e],index:e,la:[f,f]};this.a.Ga(b.G(),f)}};k.Di=function(a,b){var c=b.V(),d;var e=0;for(d=c.length-1;e<d;++e){var f=c.slice(e,e+2);var g={feature:a,geometry:b,index:e,la:f};this.a.Ga(La(f),g)}};
k.On=function(a,b){var c=b.V(),d,e;var f=0;for(e=c.length;f<e;++f){var g=c[f];var h=0;for(d=g.length-1;h<d;++h){var l=g.slice(h,h+2);var m={feature:a,geometry:b,depth:[f],index:h,la:l};this.a.Ga(La(l),m)}}};k.Sn=function(a,b){var c=b.V(),d,e;var f=0;for(e=c.length;f<e;++f){var g=c[f];var h=0;for(d=g.length-1;h<d;++h){var l=g.slice(h,h+2);var m={feature:a,geometry:b,depth:[f],index:h,la:l};this.a.Ga(La(l),m)}}};
k.Qn=function(a,b){var c=b.V(),d,e,f;var g=0;for(f=c.length;g<f;++g){var h=c[g];var l=0;for(e=h.length;l<e;++l){var m=h[l];var n=0;for(d=m.length-1;n<d;++n){var p=m.slice(n,n+2);var q={feature:a,geometry:b,depth:[l,g],index:n,la:p};this.a.Ga(La(p),q)}}}};k.Mn=function(a,b){var c=b.xa(),d={feature:a,geometry:b,index:0,la:[c,c]};a={feature:a,geometry:b,index:1,la:[c,c]};d.Wf=a.Wf=[d,a];this.a.Ga(Xa(c),d);this.a.Ga(b.G(),a)};
k.Nn=function(a,b){var c=b.a;for(b=0;b<c.length;++b)this.ga[c[b].T()].call(this,a,c[b])};function uv(a,b){var c=a.g;c?c.W().na(b):(c=new Bl(new C(b)),a.g=c,a.C.ia().Bb(c))}function vv(a,b){return a.index-b.index}
function kv(a){if(!this.Jd(a))return!1;pv(this,a.pixel,a.map);var b=a.map.Xa(a.pixel);this.j.length=0;this.B=!1;var c=this.g;if(c){var d=[];c=c.W().V();var e=La([c]);e=Rj(this.a,e);var f={};e.sort(vv);for(var g=0,h=e.length;g<h;++g){var l=e[g],m=l.la,n=w(l.feature),p=l.depth;p&&(n+="-"+p.join("-"));f[n]||(f[n]=Array(2));if("Circle"===l.geometry.T()&&1===l.index)m=wv(b,l),gf(m,c)&&!f[n][0]&&(this.j.push([l,0]),f[n][0]=l);else if(gf(m[0],c)&&!f[n][0])this.j.push([l,0]),f[n][0]=l;else if(gf(m[1],c)&&
!f[n][1]){if("LineString"!==l.geometry.T()&&"MultiLineString"!==l.geometry.T()||!f[n][0]||0!==f[n][0].index)this.j.push([l,1]),f[n][1]=l}else this.ed(a)&&w(m)in this.Za&&!f[n][0]&&!f[n][1]&&d.push([l,c])}d.length&&qv(this,a);for(a=d.length-1;0<=a;--a)this.pm.apply(this,d[a])}return!!this.g}
function lv(a){this.I=!1;qv(this,a);a=a.coordinate;for(var b=0,c=this.j.length;b<c;++b){var d=this.j[b],e=d[0],f=e.depth,g=e.geometry,h=e.la;for(d=d[1];a.length<g.ma();)a.push(h[d][a.length]);switch(g.T()){case "Point":var l=a;h[0]=h[1]=a;break;case "MultiPoint":l=g.V();l[e.index]=a;h[0]=h[1]=a;break;case "LineString":l=g.V();l[e.index+d]=a;h[d]=a;break;case "MultiLineString":l=g.V();l[f[0]][e.index+d]=a;h[d]=a;break;case "Polygon":l=g.V();l[f[0]][e.index+d]=a;h[d]=a;break;case "MultiPolygon":l=g.V();
l[f[1]][f[0]][e.index+d]=a;h[d]=a;break;case "Circle":h[0]=h[1]=a,0===e.index?(this.o=!0,g.rb(a)):(this.o=!0,g.Xc(lf(g.xa(),a))),this.o=!1}l&&(e=g,f=l,this.o=!0,e.na(f),this.o=!1)}uv(this,a)}function nv(a){for(var b,c,d=this.j.length-1;0<=d;--d)if(b=this.j[d][0],c=b.geometry,"Circle"===c.T()){var e=c.xa(),f=b.Wf[0];b=b.Wf[1];f.la[0]=f.la[1]=e;b.la[0]=b.la[1]=e;Pj(this.a,Xa(e),f);Pj(this.a,c.G(),b)}else Pj(this.a,La(b.la),b);this.B&&(this.b(new rv("modifyend",this.u,a)),this.B=!1);return!1}
function mv(a){if(!(a instanceof ie))return!0;this.S=a;var b;ig(a.map.$())[1]||"pointermove"!=a.type||this.D||(this.Sa=a.pixel,pv(this,a.pixel,a.map));this.g&&this.Zb(a)&&(b="singleclick"==a.type&&this.I?!0:this.rj());"singleclick"==a.type&&(this.I=!1);return Kg.call(this,a)&&!b}
function pv(a,b,c){function d(a,b){return xv(e,a)-xv(e,b)}var e=c.Xa(b),f=Oa(Xa(e),c.$().Pa()*a.oa);f=Rj(a.a,f);if(0<f.length){f.sort(d);var g=f[0],h=g.la,l=wv(e,g),m=c.Ka(l),n=lf(b,m);if(n<=a.oa){b={};if("Circle"===g.geometry.T()&&1===g.index)a.va=!0,uv(a,l);else for(n=c.Ka(h[0]),g=c.Ka(h[1]),c=kf(m,n),m=kf(m,g),n=Math.sqrt(Math.min(c,m)),a.va=n<=a.oa,a.va&&(l=c>m?h[1]:h[0]),uv(a,l),m=1,c=f.length;m<c;++m)if(l=f[m].la,gf(h[0],l[0])&&gf(h[1],l[1])||gf(h[0],l[1])&&gf(h[1],l[0]))b[w(l)]=!0;else break;
b[w(h)]=!0;a.Za=b;return}}a.g&&(a.C.ia().Fb(a.g),a.g=null)}function xv(a,b){var c=b.geometry;return"Circle"===c.T()&&1===b.index?(a=kf(c.xa(),a),c=Math.sqrt(a)-c.vd(),c*c):mf(a,b.la)}function wv(a,b){var c=b.geometry;return"Circle"===c.T()&&1===b.index?c.Db(a):df(a,b.la)}
k.pm=function(a,b){for(var c=a.la,d=a.feature,e=a.geometry,f=a.depth,g=a.index,h;b.length<e.ma();)b.push(0);switch(e.T()){case "MultiLineString":h=e.V();h[f[0]].splice(g+1,0,b);break;case "Polygon":h=e.V();h[f[0]].splice(g+1,0,b);break;case "MultiPolygon":h=e.V();h[f[1]][f[0]].splice(g+1,0,b);break;case "LineString":h=e.V();h.splice(g+1,0,b);break;default:return}this.o=!0;e.na(h);this.o=!1;h=this.a;h.remove(a);yv(this,e,g,f,1);a={la:[c[0],b],feature:d,geometry:e,depth:f,index:g};h.Ga(La(a.la),a);
this.j.push([a,1]);b={la:[b,c[1]],feature:d,geometry:e,depth:f,index:g+1};h.Ga(La(b.la),b);this.j.push([b,0]);this.I=!0};
k.rj=function(){if(this.S&&"pointerdrag"!=this.S.type){var a=this.S;qv(this,a);var b=this.j,c={},d,e;for(e=b.length-1;0<=e;--e){var f=b[e];var g=f[0];var h=w(g.feature);g.depth&&(h+="-"+g.depth.join("-"));h in c||(c[h]={});0===f[1]?(c[h].right=g,c[h].index=g.index):1==f[1]&&(c[h].left=g,c[h].index=g.index+1)}for(h in c){var l=c[h].right;var m=c[h].left;e=c[h].index;var n=e-1;g=void 0!==m?m:l;0>n&&(n=0);f=g.geometry;var p=d=f.V();var q=!1;switch(f.T()){case "MultiLineString":2<d[g.depth[0]].length&&
(d[g.depth[0]].splice(e,1),q=!0);break;case "LineString":2<d.length&&(d.splice(e,1),q=!0);break;case "MultiPolygon":p=p[g.depth[1]];case "Polygon":p=p[g.depth[0]],4<p.length&&(e==p.length-1&&(e=0),p.splice(e,1),q=!0,0===e&&(p.pop(),p.push(p[0]),n=p.length-1))}q&&(q=f,this.o=!0,q.na(d),this.o=!1,d=[],void 0!==m&&(this.a.remove(m),d.push(m.la[0])),void 0!==l&&(this.a.remove(l),d.push(l.la[1])),void 0!==m&&void 0!==l&&(m={depth:g.depth,feature:g.feature,geometry:g.geometry,index:n,la:d},this.a.Ga(La(m.la),
m)),yv(this,f,e,g.depth,-1),this.g&&(this.C.ia().Fb(this.g),this.g=null),b.length=0)}this.b(new rv("modifyend",this.u,a));this.B=!1;return!0}return!1};function yv(a,b,c,d,e){Tj(a.a,b.G(),function(a){a.geometry===b&&(void 0===d||void 0===a.depth||ma(a.depth,d))&&a.index>c&&(a.index+=e)})}function ov(){var a=Al();return function(){return a.Point}}function rv(a,b,c){Qc.call(this,a);this.features=b;this.mapBrowserEvent=c}v(rv,Qc);function zv(a){sg.call(this,{handleEvent:Av});a=a?a:{};this.B=a.condition?a.condition:Cg;this.D=a.addCondition?a.addCondition:qf;this.C=a.removeCondition?a.removeCondition:qf;this.I=a.toggleCondition?a.toggleCondition:Eg;this.o=a.multi?a.multi:!1;this.l=a.filter?a.filter:pf;this.j=a.hitTolerance?a.hitTolerance:0;this.g=new S({source:new V({useSpatialIndex:!1,features:a.features,wrapX:a.wrapX}),style:a.style?a.style:Bv(),updateWhileAnimating:!0,updateWhileInteracting:!0});if(a.layers)if("function"===
typeof a.layers)a=a.layers;else{var b=a.layers;a=function(a){return ha(b,a)}}else a=pf;this.u=a;this.a={};a=this.g.ia().i;y(a,"add",this.Tn,this);y(a,"remove",this.Xn,this)}v(zv,sg);k=zv.prototype;k.Un=function(){return this.g.ia().i};k.Vn=function(){return this.j};k.Wn=function(a){a=w(a);return this.a[a]};
function Av(a){if(!this.B(a))return!0;var b=this.D(a),c=this.C(a),d=this.I(a),e=!b&&!c&&!d,f=a.map,g=this.g.ia().i,h=[],l=[];if(e){sb(this.a);f.Wd(a.pixel,function(a,b){if(this.l(a,b))return l.push(a),a=w(a),this.a[a]=b,!this.o}.bind(this),{layerFilter:this.u,hitTolerance:this.j});for(e=g.ec()-1;0<=e;--e){f=g.item(e);var m=l.indexOf(f);-1<m?l.splice(m,1):(g.remove(f),h.push(f))}l.length&&g.ng(l)}else{f.Wd(a.pixel,function(a,e){if(this.l(a,e))return!b&&!d||ha(g.a,a)?(c||d)&&ha(g.a,a)&&(h.push(a),e=
w(a),delete this.a[e]):(l.push(a),a=w(a),this.a[a]=e),!this.o}.bind(this),{layerFilter:this.u,hitTolerance:this.j});for(e=h.length-1;0<=e;--e)g.remove(h[e]);g.ng(l)}(0<l.length||0<h.length)&&this.b(new Cv(Dv,l,h,a));return Bg(a)}k.Yn=function(a){this.j=a};k.setMap=function(a){var b=this.v,c=this.g.ia().i;b&&c.forEach(b.Mj,b);sg.prototype.setMap.call(this,a);this.g.setMap(a);a&&c.forEach(a.Hj,a)};
function Bv(){var a=Al();ka(a.Polygon,a.LineString);ka(a.GeometryCollection,a.LineString);return function(b){return b.W()?a[b.W().T()]:null}}k.Tn=function(a){var b=this.v;b&&b.Hj(a.element)};k.Xn=function(a){var b=this.v;b&&b.Mj(a.element)};function Cv(a,b,c,d){Qc.call(this,a);this.selected=b;this.deselected=c;this.mapBrowserEvent=d}v(Cv,Qc);var Dv="select";function Ev(a){Jg.call(this,{handleEvent:Fv,handleDownEvent:pf,handleUpEvent:Gv});a=a?a:{};this.o=a.source?a.source:null;this.S=void 0!==a.vertex?a.vertex:!0;this.B=void 0!==a.edge?a.edge:!0;this.j=a.features?a.features:null;this.oa=[];this.C={};this.U={};this.u={};this.I=null;this.g=void 0!==a.pixelTolerance?a.pixelTolerance:10;this.va=Hv.bind(this);this.a=new Oj;this.ga={Point:this.fo,LineString:this.Gi,LinearRing:this.Gi,Polygon:this.ho,MultiPoint:this.co,MultiLineString:this.bo,MultiPolygon:this.eo,
GeometryCollection:this.ao,Circle:this.$n}}v(Ev,Jg);k=Ev.prototype;k.Bb=function(a,b){b=void 0!==b?b:!0;var c=w(a),d=a.W();if(d){var e=this.ga[d.T()];e&&(this.U[c]=d.G(Ma()),e.call(this,a,d))}b&&(this.C[c]=y(a,"change",this.Zn,this))};k.Lk=function(a){this.Bb(a)};k.Mk=function(a){this.Fb(a)};k.Ei=function(a){if(a instanceof Eu)var b=a.feature;else a instanceof dd&&(b=a.element);this.Bb(b)};k.Fi=function(a){if(a instanceof Eu)var b=a.feature;else a instanceof dd&&(b=a.element);this.Fb(b)};
k.Zn=function(a){a=a.target;if(this.D){var b=w(a);b in this.u||(this.u[b]=a)}else this.Nj(a)};k.Fb=function(a,b){b=void 0!==b?b:!0;var c=w(a),d=this.U[c];if(d){var e=this.a,f=[];Tj(e,d,function(b){a===b.feature&&f.push(b)});for(d=f.length-1;0<=d;--d)e.remove(f[d])}b&&(Gc(this.C[c]),delete this.C[c])};
k.setMap=function(a){var b=this.v,c=this.oa,d;this.j?d=this.j:this.o&&(d=this.o.fe());b&&(c.forEach(Gc),c.length=0,d.forEach(this.Mk,this));Jg.prototype.setMap.call(this,a);a&&(this.j?c.push(y(this.j,"add",this.Ei,this),y(this.j,"remove",this.Fi,this)):this.o&&c.push(y(this.o,"addfeature",this.Ei,this),y(this.o,"removefeature",this.Fi,this)),d.forEach(this.Lk,this))};k.$c=qf;
function Iv(a,b,c,d){var e=d.Xa([b[0]-a.g,b[1]+a.g]),f=d.Xa([b[0]+a.g,b[1]-a.g]);e=La([e,f]);var g=Rj(a.a,e);a.S&&!a.B&&(g=g.filter(function(a){return"Circle"!==a.feature.W().T()}));var h=!1;e=!1;var l=f=null;if(0<g.length){a.I=c;g.sort(a.va);var m=g[0].la;h="Circle"===g[0].feature.W().T();if(a.S&&!a.B){if(c=d.Ka(m[0]),h=d.Ka(m[1]),c=kf(b,c),b=kf(b,h),h=Math.sqrt(Math.min(c,b)),h=h<=a.g)e=!0,f=c>b?m[1]:m[0],l=d.Ka(f)}else a.B&&(f=h?cf(c,g[0].feature.W()):df(c,m),l=d.Ka(f),lf(b,l)<=a.g&&(e=!0,a.S&&
!h&&(c=d.Ka(m[0]),h=d.Ka(m[1]),c=kf(l,c),b=kf(l,h),h=Math.sqrt(Math.min(c,b)),h=h<=a.g)))&&(f=c>b?m[1]:m[0],l=d.Ka(f));e&&(l=[Math.round(l[0]),Math.round(l[1])])}return{Bq:e,vertex:f,Kq:l}}k.Nj=function(a){this.Fb(a,!1);this.Bb(a,!1)};k.$n=function(a,b){b=dg(b).V()[0];var c;var d=0;for(c=b.length-1;d<c;++d){var e=b.slice(d,d+2);var f={feature:a,la:e};this.a.Ga(La(e),f)}};k.ao=function(a,b){var c=b.a;for(b=0;b<c.length;++b){var d=this.ga[c[b].T()];d&&d.call(this,a,c[b])}};
k.Gi=function(a,b){b=b.V();var c;var d=0;for(c=b.length-1;d<c;++d){var e=b.slice(d,d+2);var f={feature:a,la:e};this.a.Ga(La(e),f)}};k.bo=function(a,b){b=b.V();var c,d;var e=0;for(d=b.length;e<d;++e){var f=b[e];var g=0;for(c=f.length-1;g<c;++g){var h=f.slice(g,g+2);var l={feature:a,la:h};this.a.Ga(La(h),l)}}};k.co=function(a,b){var c=b.V(),d;var e=0;for(d=c.length;e<d;++e){var f=c[e];f={feature:a,la:[f,f]};this.a.Ga(b.G(),f)}};
k.eo=function(a,b){b=b.V();var c,d,e;var f=0;for(e=b.length;f<e;++f){var g=b[f];var h=0;for(d=g.length;h<d;++h){var l=g[h];var m=0;for(c=l.length-1;m<c;++m){var n=l.slice(m,m+2);var p={feature:a,la:n};this.a.Ga(La(n),p)}}}};k.fo=function(a,b){var c=b.V();a={feature:a,la:[c,c]};this.a.Ga(b.G(),a)};k.ho=function(a,b){b=b.V();var c,d;var e=0;for(d=b.length;e<d;++e){var f=b[e];var g=0;for(c=f.length-1;g<c;++g){var h=f.slice(g,g+2);var l={feature:a,la:h};this.a.Ga(La(h),l)}}};
function Fv(a){var b=Iv(this,a.pixel,a.coordinate,a.map);b.Bq&&(a.coordinate=b.vertex.slice(0,2),a.pixel=b.Kq);return Kg.call(this,a)}function Gv(){var a=tb(this.u);a.length&&(a.forEach(this.Nj,this),this.u={});return!1}function Hv(a,b){return mf(this.I,a.la)-mf(this.I,b.la)};function Jv(a){Jg.call(this,{handleDownEvent:Kv,handleDragEvent:Lv,handleMoveEvent:Mv,handleUpEvent:Nv});a=a?a:{};this.a=null;this.j=void 0!==a.features?a.features:null;if(a.layers)if("function"===typeof a.layers)var b=a.layers;else{var c=a.layers;b=function(a){return ha(c,a)}}else b=pf;this.B=b;this.o=a.hitTolerance?a.hitTolerance:0;this.g=null;y(this,Xc("active"),this.u,this)}v(Jv,Jg);
function Kv(a){this.g=Ov(this,a.pixel,a.map);if(!this.a&&this.g){this.a=a.coordinate;Mv.call(this,a);var b=this.j||new $c([this.g]);this.b(new Pv("translatestart",b,a.coordinate));return!0}return!1}function Nv(a){if(this.a){this.a=null;Mv.call(this,a);var b=this.j||new $c([this.g]);this.b(new Pv("translateend",b,a.coordinate));return!0}return!1}
function Lv(a){if(this.a){a=a.coordinate;var b=a[0]-this.a[0],c=a[1]-this.a[1],d=this.j||new $c([this.g]);d.forEach(function(a){var d=a.W();d.translate(b,c);a.Ra(d)});this.a=a;this.b(new Pv("translating",d,a))}}function Mv(a){var b=a.map.a;Ov(this,a.pixel,a.map)?(b.classList.remove(this.a?"ol-grab":"ol-grabbing"),b.classList.add(this.a?"ol-grabbing":"ol-grab")):b.classList.remove("ol-grab","ol-grabbing")}
function Ov(a,b,c){return c.Wd(b,function(a){if(!this.j||ha(this.j.a,a))return a}.bind(a),{layerFilter:a.B,hitTolerance:a.o})}Jv.prototype.C=function(){return this.o};Jv.prototype.I=function(a){this.o=a};Jv.prototype.setMap=function(a){var b=this.v;Jg.prototype.setMap.call(this,a);Qv(this,b)};Jv.prototype.u=function(){Qv(this,null)};function Qv(a,b){var c=a.v;a=a.c();c&&a||(c=c||b)&&c.a.classList.remove("ol-grab","ol-grabbing")}
function Pv(a,b,c){Qc.call(this,a);this.features=b;this.coordinate=c}v(Pv,Qc);function W(a){a=a?a:{};var b=rb({},a);delete b.gradient;delete b.radius;delete b.blur;delete b.shadow;delete b.weight;S.call(this,b);this.g=null;this.I=void 0!==a.shadow?a.shadow:250;this.B=void 0;this.D=null;y(this,Xc(Rv),this.Nl,this);this.zj(a.gradient?a.gradient:Sv);this.tj(void 0!==a.blur?a.blur:15);this.Xc(void 0!==a.radius?a.radius:8);y(this,Xc(Tv),this.lg,this);y(this,Xc(Uv),this.lg,this);this.lg();var c=a.weight?a.weight:"weight",d;"string"===typeof c?d=function(a){return a.get(c)}:d=c;this.i(function(a){a=
d(a);a=void 0!==a?Aa(a,0,1):1;var b=255*a|0,c=this.D[b];c||(c=[new vl({image:new yo({opacity:a,src:this.B})})],this.D[b]=c);return c}.bind(this));this.set(mu,null);y(this,"render",this.dm,this)}v(W,S);var Sv=["#00f","#0ff","#0f0","#ff0","#f00"];k=W.prototype;k.Ch=function(){return this.get(Tv)};k.Jh=function(){return this.get(Rv)};k.Ii=function(){return this.get(Uv)};
k.Nl=function(){for(var a=this.Jh(),b=ld(1,256),c=b.createLinearGradient(0,0,1,256),d=1/(a.length-1),e=0,f=a.length;e<f;++e)c.addColorStop(e*d,a[e]);b.fillStyle=c;b.fillRect(0,0,1,256);this.g=b.getImageData(0,0,1,256).data};k.lg=function(){var a=this.Ii(),b=this.Ch(),c=a+b+1,d=2*c;d=ld(d,d);d.shadowOffsetX=d.shadowOffsetY=this.I;d.shadowBlur=b;d.shadowColor="#000";d.beginPath();b=c-this.I;d.arc(b,b,a,0,2*Math.PI,!0);d.fill();this.B=d.canvas.toDataURL();this.D=Array(256);this.s()};
k.dm=function(a){a=a.context;var b=a.canvas;b=a.getImageData(0,0,b.width,b.height);var c=b.data,d,e;var f=0;for(d=c.length;f<d;f+=4)if(e=4*c[f+3])c[f]=this.g[e],c[f+1]=this.g[e+1],c[f+2]=this.g[e+2];a.putImageData(b,0,0)};k.tj=function(a){this.set(Tv,a)};k.zj=function(a){this.set(Rv,a)};k.Xc=function(a){this.set(Uv,a)};var Tv="blur",Rv="gradient",Uv="radius";function Vv(a){cu.call(this,a);this.o=Ih();this.g=null}v(Vv,cu);Vv.prototype.u=function(a,b,c){eu(this,"precompose",c,a,void 0);var d=this.Y();if(d){var e=b.extent,f=void 0!==e&&!Ta(e,a.extent)&&ob(e,a.extent);f&&du(c,a,e);e=this.D();var g=c.globalAlpha;c.globalAlpha=b.opacity;c.drawImage(d,0,0,+d.width,+d.height,Math.round(e[4]),Math.round(e[5]),Math.round(d.width*e[0]),Math.round(d.height*e[3]));c.globalAlpha=g;f&&c.restore()}this.qf(c,a,b)};
Vv.prototype.Ha=function(a,b,c,d,e){var f=this.a;return f.ia().Ha(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
Vv.prototype.v=function(a,b,c,d){if(this.Y()){if(this.a.ia().Ha!==ra)return cu.prototype.v.apply(this,arguments);var e=Nh(this.o,a.slice());jf(e,b.viewState.resolution/this.c);this.g||(this.g=ld(1,1));this.g.clearRect(0,0,1,1);this.g.drawImage(this.Y(),e[0],e[1],1,1,0,0,1,1);e=this.g.getImageData(0,0,1,1).data;if(0<e[3])return c.call(d,this.a,e)}};function Wv(a){Vv.call(this,a);this.M=null;this.i=Ih()}v(Wv,Vv);Wv.prototype.Y=function(){return this.M?this.M.Y():null};Wv.prototype.D=function(){return this.i};
Wv.prototype.yd=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.center,g=e.resolution,h=this.a.ia(),l=a.viewHints,m=a.extent;void 0!==b.extent&&(m=nb(m,b.extent));l[0]||l[1]||ib(m)||(b=h.Y(m,g,c,e.projection))&&Xt(this,b)&&(this.M=b);if(this.M){b=this.M;l=b.G();m=b.resolution;e=b.a;var n=c*m/(g*e);l=Rh(this.i,c*d[0]/2,c*d[1]/2,n,n,0,e*(l[0]-f[0])/m,e*(f[1]-l[3])/m);Rh(this.o,c*d[0]/2-l[4],c*d[1]/2-l[5],c/g,-c/g,0,-f[0],-f[1]);Zt(a.attributions,b.i);$t(a,h);this.c=g*c/e}return!!this.M};function Xv(a,b,c,d){var e=hc(c,b,a);c=Ub(b,d,c);b=b.Nc();void 0!==b&&(c*=b);b=a.Nc();void 0!==b&&(c/=b);b=a.G();if(!b||Ra(b,e))a=Ub(a,c,e)/c,isFinite(a)&&0<a&&(c/=a);return c}function Yv(a,b,c,d){a=c-a;b=d-b;var e=Math.sqrt(a*a+b*b);return[Math.round(c+a/e),Math.round(d+b/e)]}
function Zv(a,b,c,d,e,f,g,h,l,m,n){var p=ld(Math.round(c*a),Math.round(c*b));if(!l.length)return p.canvas;p.scale(c,c);var q=Ma();l.forEach(function(a){bb(q,a.extent)});var t=ld(Math.round(c*jb(q)/d),Math.round(c*kb(q)/d)),u=c/d;l.forEach(function(a){t.drawImage(a.image,m,m,a.image.width-2*m,a.image.height-2*m,(a.extent[0]-q[0])*u,-(a.extent[3]-q[3])*u,jb(a.extent)*u,kb(a.extent)*u)});var x=gb(g);h.c.forEach(function(a){var b=a.source,e=a.target,g=b[1][0],h=b[1][1],l=b[2][0],m=b[2][1];a=(e[0][0]-
x[0])/f;var n=-(e[0][1]-x[1])/f,u=(e[1][0]-x[0])/f,B=-(e[1][1]-x[1])/f,ea=(e[2][0]-x[0])/f,Ya=-(e[2][1]-x[1])/f;e=b[0][0];b=b[0][1];g-=e;h-=b;l-=e;m-=b;a:{g=[[g,h,0,0,u-a],[l,m,0,0,ea-a],[0,0,g,h,B-n],[0,0,l,m,Ya-n]];h=g.length;for(l=0;l<h;l++){m=l;for(var da=Math.abs(g[l][l]),Vb=l+1;Vb<h;Vb++){var Ac=Math.abs(g[Vb][l]);Ac>da&&(da=Ac,m=Vb)}if(!da){g=null;break a}da=g[m];g[m]=g[l];g[l]=da;for(m=l+1;m<h;m++)for(da=-g[m][l]/g[l][l],Vb=l;Vb<h+1;Vb++)g[m][Vb]=l==Vb?0:g[m][Vb]+da*g[l][Vb]}l=Array(h);for(m=
h-1;0<=m;m--)for(l[m]=g[m][h]/g[m][m],da=m-1;0<=da;da--)g[da][h]-=g[da][m]*l[m];g=l}g&&(p.save(),p.beginPath(),l=(a+u+ea)/3,m=(n+B+Ya)/3,h=Yv(l,m,a,n),u=Yv(l,m,u,B),ea=Yv(l,m,ea,Ya),p.moveTo(u[0],u[1]),p.lineTo(h[0],h[1]),p.lineTo(ea[0],ea[1]),p.clip(),p.transform(g[0],g[2],g[1],g[3],a,n),p.translate(q[0]-e,q[3]-b),p.scale(d/c,-d/c),p.drawImage(t.canvas,0,0),p.restore())});n&&(p.save(),p.strokeStyle="black",p.lineWidth=1,h.c.forEach(function(a){var b=a.target;a=(b[0][0]-x[0])/f;var c=-(b[0][1]-x[1])/
f,d=(b[1][0]-x[0])/f,e=-(b[1][1]-x[1])/f,g=(b[2][0]-x[0])/f;b=-(b[2][1]-x[1])/f;p.beginPath();p.moveTo(d,e);p.lineTo(a,c);p.lineTo(g,b);p.closePath();p.stroke()}),p.restore());return p.canvas};function $v(a,b,c,d,e){this.f=a;this.i=b;var f={},g=fc(this.i,this.f);this.a=function(a){var b=a[0]+"/"+a[1];f[b]||(f[b]=g(a));return f[b]};this.g=d;this.v=e*e;this.c=[];this.l=!1;this.o=this.f.f&&!!d&&!!this.f.G()&&jb(d)==jb(this.f.G());this.b=this.f.G()?jb(this.f.G()):null;this.j=this.i.G()?jb(this.i.G()):null;a=gb(c);b=fb(c);d=eb(c);c=db(c);e=this.a(a);var h=this.a(b),l=this.a(d),m=this.a(c);aw(this,a,b,d,c,e,h,l,m,10);if(this.l){var n=Infinity;this.c.forEach(function(a){n=Math.min(n,a.source[0][0],
a.source[1][0],a.source[2][0])});this.c.forEach(function(a){if(Math.max(a.source[0][0],a.source[1][0],a.source[2][0])-n>this.b/2){var b=[[a.source[0][0],a.source[0][1]],[a.source[1][0],a.source[1][1]],[a.source[2][0],a.source[2][1]]];b[0][0]-n>this.b/2&&(b[0][0]-=this.b);b[1][0]-n>this.b/2&&(b[1][0]-=this.b);b[2][0]-n>this.b/2&&(b[2][0]-=this.b);Math.max(b[0][0],b[1][0],b[2][0])-Math.min(b[0][0],b[1][0],b[2][0])<this.b/2&&(a.source=b)}},this)}f={}}
function aw(a,b,c,d,e,f,g,h,l,m){var n=La([f,g,h,l]),p=a.b?jb(n)/a.b:null,q=a.b,t=a.f.f&&.5<p&&1>p,u=!1;if(0<m){if(a.i.c&&a.j){var x=La([b,c,d,e]);u|=.25<jb(x)/a.j}!t&&a.f.c&&p&&(u|=.25<p)}if(u||!a.g||ob(n,a.g)){if(!(u||isFinite(f[0])&&isFinite(f[1])&&isFinite(g[0])&&isFinite(g[1])&&isFinite(h[0])&&isFinite(h[1])&&isFinite(l[0])&&isFinite(l[1])))if(0<m)u=!0;else return;if(0<m&&(u||(n=a.a([(b[0]+d[0])/2,(b[1]+d[1])/2]),q=t?(Ga(f[0],q)+Ga(h[0],q))/2-Ga(n[0],q):(f[0]+h[0])/2-n[0],n=(f[1]+h[1])/2-n[1],
u=q*q+n*n>a.v),u)){Math.abs(b[0]-d[0])<=Math.abs(b[1]-d[1])?(t=[(c[0]+d[0])/2,(c[1]+d[1])/2],q=a.a(t),n=[(e[0]+b[0])/2,(e[1]+b[1])/2],p=a.a(n),aw(a,b,c,t,n,f,g,q,p,m-1),aw(a,n,t,d,e,p,q,h,l,m-1)):(t=[(b[0]+c[0])/2,(b[1]+c[1])/2],q=a.a(t),n=[(d[0]+e[0])/2,(d[1]+e[1])/2],p=a.a(n),aw(a,b,t,n,e,f,q,p,l,m-1),aw(a,t,c,d,n,q,g,h,p,m-1));return}if(t){if(!a.o)return;a.l=!0}a.c.push({source:[f,h,l],target:[b,d,e]});a.c.push({source:[f,g,h],target:[b,c,d]})}}
function bw(a){var b=Ma();a.c.forEach(function(a){a=a.source;Na(b,a[0]);Na(b,a[1]);Na(b,a[2])});return b};function cw(a,b,c,d,e,f){this.v=b;this.o=a.G();var g=b.G(),h=g?nb(c,g):c;g=Xv(a,b,lb(h),d);this.j=new $v(a,b,h,this.o,.5*g);this.c=d;this.f=c;a=bw(this.j);this.l=(this.Gb=f(a,g,e))?this.Gb.a:1;this.me=this.g=null;e=2;f=[];this.Gb&&(e=0,f=this.Gb.i);bt.call(this,c,d,this.l,e,f)}v(cw,bt);cw.prototype.ka=function(){1==this.state&&(Gc(this.me),this.me=null);bt.prototype.ka.call(this)};cw.prototype.Y=function(){return this.g};
cw.prototype.ke=function(){var a=this.Gb.getState();2==a&&(this.g=Zv(jb(this.f)/this.c,kb(this.f)/this.c,this.l,this.Gb.resolution,0,this.c,this.f,this.j,[{extent:this.Gb.G(),image:this.Gb.Y()}],0));this.state=a;this.s()};cw.prototype.load=function(){if(0==this.state){this.state=1;this.s();var a=this.Gb.getState();2==a||3==a?this.ke():(this.me=y(this.Gb,"change",function(){var a=this.Gb.getState();if(2==a||3==a)Gc(this.me),this.me=null,this.ke()},this),this.Gb.load())}};function dw(a){xu.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state});this.B=void 0!==a.resolutions?a.resolutions:null;this.i=null;this.ga=0}v(dw,xu);function ew(a,b){a.B&&(b=a.B[ja(a.B,b,0)]);return b}
dw.prototype.Y=function(a,b,c,d){var e=this.c;if(e&&d&&!ec(e,d)){if(this.i){if(this.ga==this.f&&ec(this.i.v,d)&&this.i.resolution==b&&ab(this.i.G(),a))return this.i;Pc(this.i);this.i=null}this.i=new cw(e,d,a,b,c,function(a,b,c){return this.Lc(a,b,c,e)}.bind(this));this.ga=this.f;return this.i}e&&(d=e);return this.Lc(a,b,c,d)};dw.prototype.l=function(a){a=a.target;switch(a.getState()){case 1:this.b(new fw(gw,a));break;case 2:this.b(new fw(hw,a));break;case 3:this.b(new fw(iw,a))}};
function jw(a,b){a.Y().src=b}function fw(a,b){Qc.call(this,a);this.image=b}v(fw,Qc);var gw="imageloadstart",hw="imageloadend",iw="imageloaderror";function kw(a){dw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions,state:a.state});this.oa=a.canvasFunction;this.S=null;this.U=0;this.va=void 0!==a.ratio?a.ratio:1.5}v(kw,dw);kw.prototype.Lc=function(a,b,c,d){b=ew(this,b);var e=this.S;if(e&&this.U==this.f&&e.resolution==b&&e.a==c&&Ta(e.G(),a))return e;a=a.slice();pb(a,this.va);(d=this.oa(a,b,c,[jb(a)/b*c,kb(a)/b*c],d))&&(e=new dt(a,b,c,this.j,d));this.S=e;this.U=this.f;return e};function lw(a){this.a=a.source;this.Za=Ih();this.g=ld();this.o=[0,0];this.Sa=void 0==a.renderBuffer?100:a.renderBuffer;this.C=null;kw.call(this,{attributions:a.attributions,canvasFunction:this.Ek.bind(this),logo:a.logo,projection:a.projection,ratio:a.ratio,resolutions:a.resolutions,state:this.a.getState()});this.I=null;this.v=void 0;this.Si(a.style);y(this.a,"change",this.Eo,this)}v(lw,kw);k=lw.prototype;
k.Ek=function(a,b,c,d,e){var f=new Mt(.5*b/c,a,b,this.a.U,this.Sa);this.a.de(a,b,e);var g=!1;this.a.ac(a,function(a){var d;if(!(d=g)){var e;(d=a.bb())?e=d.call(a,b):this.v&&(e=this.v(a,b));if(e){var h,p=!1;Array.isArray(e)||(e=[e]);d=0;for(h=e.length;d<h;++d)p=iu(f,a,e[d],hu(b,c),this.Do,this)||p;d=p}else d=!1}g=d},this);Qt(f);if(g)return null;this.o[0]!=d[0]||this.o[1]!=d[1]?(this.g.canvas.width=d[0],this.g.canvas.height=d[1],this.o[0]=d[0],this.o[1]=d[1]):this.g.clearRect(0,0,d[0],d[1]);a=mw(this,
lb(a),b,c,d);f.Ma(this.g,c,a,0,{});this.C=f;return this.g.canvas};k.Ha=function(a,b,c,d,e,f){if(this.C){var g={};return this.C.Ha(a,b,0,d,e,function(a){var b=w(a).toString();if(!(b in g))return g[b]=!0,f(a)})}};k.Bo=function(){return this.a};k.Co=function(){return this.I};k.bb=function(){return this.v};function mw(a,b,c,d,e){c=d/c;return Rh(a.Za,e[0]/2,e[1]/2,c,-c,0,-b[0],-b[1])}k.Do=function(){this.s()};k.Eo=function(){zu(this,this.a.getState())};
k.Si=function(a){this.I=void 0!==a?a:zl;this.v=a?xl(this.I):void 0;this.s()};function nw(a,b){su.call(this,a,b);this.l=this.i=this.M=null}v(nw,su);function ow(a,b){b=b.Y();return $i(a.c.f,b)}nw.prototype.Ha=function(a,b,c,d,e){var f=this.a;return f.ia().Ha(a,b.viewState.resolution,b.viewState.rotation,c,b.skippedFeatureUids,function(a){return d.call(e,a,f)})};
nw.prototype.vg=function(a,b){var c=this.c.f,d=a.pixelRatio,e=a.viewState,f=e.center,g=e.resolution,h=e.rotation,l=this.M,m=this.Hb,n=this.a.ia(),p=a.viewHints,q=a.extent;void 0!==b.extent&&(q=nb(q,b.extent));p[0]||p[1]||ib(q)||(b=n.Y(q,g,d,e.projection))&&Xt(this,b)&&(l=b,m=ow(this,b),this.Hb&&a.postRenderFunctions.push(function(a,b){a.isContextLost()||a.deleteTexture(b)}.bind(null,c,this.Hb)));l&&(c=this.c.i.j,pw(this,c.width,c.height,d,f,g,h,l.G()),this.l=null,d=this.v,Jh(d),Ph(d,1,-1),Qh(d,0,
-1),this.M=l,this.Hb=m,Zt(a.attributions,l.i),$t(a,n));return!!l};function pw(a,b,c,d,e,f,g,h){b*=f;c*=f;a=a.R;Jh(a);Ph(a,2*d/b,2*d/c);Oh(a,-g);Qh(a,h[0]-e[0],h[1]-e[1]);Ph(a,(h[2]-h[0])/2,(h[3]-h[1])/2);Qh(a,1,1)}nw.prototype.ef=function(a,b){return void 0!==this.Ha(a,b,0,pf,this)};
nw.prototype.tg=function(a,b,c,d){if(this.M&&this.M.Y())if(this.a.ia()instanceof lw){var e=Nh(b.pixelToCoordinateTransform,a.slice());if(this.Ha(e,b,0,pf,this))return c.call(d,this.a,null)}else{e=[this.M.Y().width,this.M.Y().height];if(!this.l){var f=b.size;b=Ih();Qh(b,-1,-1);Ph(b,2/f[0],2/f[1]);Qh(b,0,f[1]);Ph(b,1,-1);f=Sh(this.R.slice());var g=Ih();Qh(g,0,e[1]);Ph(g,1,-1);Ph(g,e[0]/2,e[1]/2);Qh(g,1,1);Lh(g,f);Lh(g,b);this.l=g}a=Nh(this.l,a.slice());if(!(0>a[0]||a[0]>e[0]||0>a[1]||a[1]>e[1])&&(this.i||
(this.i=ld(1,1)),this.i.clearRect(0,0,1,1),this.i.drawImage(this.M.Y(),a[0],a[1],1,1,0,0,1,1),e=this.i.getImageData(0,0,1,1).data,0<e[3]))return c.call(d,this.a,e)}};function qw(a){Dh.call(this,a?a:{})}v(qw,Dh);qw.prototype.Ld=function(a){var b=null,c=a.T();"canvas"===c?b=new Wv(this):"webgl"===c&&(b=new nw(a,this));return b};function rw(a){Vv.call(this,a);this.context=null===this.context?null:ld();this.j=null;this.i=[];this.l=Ma();this.oa=new wa(0,0,0,0);this.B=Ih();this.S=0}v(rw,Vv);function sw(a,b){b=b.getState();a=a.a.qd();return 2==b||4==b||3==b&&!a}
rw.prototype.yd=function(a,b){var c=a.pixelRatio,d=a.size,e=a.viewState,f=e.projection,g=e.resolution;e=e.center;var h=this.a,l=h.ia(),m=l.f,n=l.Ta(f),p=n.uc(g,this.S),q=n.Ca(p),t=Math.round(g/q)||1,u=a.extent;void 0!==b.extent&&(u=nb(u,b.extent));if(ib(u))return!1;var x=sc(n,u,q);var B=n.Sc(p);var z=n.Ca(p),G=Ka(n.eb(p),n.j);B=Va(B[0]+x.ca*G[0]*z,B[1]+x.ea*G[1]*z,B[0]+(x.da+1)*G[0]*z,B[1]+(x.ha+1)*G[1]*z,void 0);z=l.Oc(c);G={};G[p]={};var E=this.Uf(l,f,G),ia=this.l,T=this.oa,R=!1,U,ta;for(U=x.ca;U<=
x.da;++U)for(ta=x.ea;ta<=x.ha;++ta){var A=l.Qc(p,U,ta,c,f);3==A.getState()&&(h.qd()?0<h.md()&&(R=!0):ht(A,2));sw(this,A)||(A=ft(A));sw(this,A)?2==A.getState()&&(G[p][A.sa.toString()]=A,R||-1!=this.i.indexOf(A)||(R=!0)):qc(n,A.sa,E,T,ia)||(A=rc(n,A.sa,T,ia))&&E(p+1,A)}U=a.viewHints;U=U[0]||U[1];if(!(this.c&&16<Date.now()-a.time&&U||!R&&this.j&&Ta(this.j,u)&&this.xf==m&&t==this.I&&(U||q*c/z*t==this.c))){if(U=this.context)ta=l.ce(p,c,f),A=Math.round((x.da-x.ca+1)*ta[0]/t),ta=Math.round((x.ha-x.ea+1)*
ta[1]/t),R=U.canvas,R.width!=A||R.height!=ta?(this.I=t,R.width=A,R.height=ta):(U.clearRect(0,0,A,ta),t=this.I);this.i.length=0;R=Object.keys(G).map(Number);R.sort(fa);var ea;T=0;for(ea=R.length;T<ea;++T){U=R[T];E=l.ce(U,c,f);A=n.Ca(U);var Ya=A/q;var da=z*l.bg(f);var Vb=G[U];for(var Ac in Vb){A=Vb[Ac];ta=n.Fa(A.sa,ia);U=(ta[0]-B[0])/q*z/t;ta=(B[3]-ta[3])/q*z/t;var ge=E[0]*Ya/t;var he=E[1]*Ya/t;this.Vf(A,a,b,U,ta,ge,he,da);this.i.push(A)}}this.xf=m;this.c=q*c/z*t;this.j=B}b=this.c/g;b=Rh(this.B,c*d[0]/
2,c*d[1]/2,b,b,0,(this.j[0]-e[0])/this.c*c,(e[1]-this.j[3])/this.c*c);Rh(this.o,c*d[0]/2-b[4],c*d[1]/2-b[5],c/g,-c/g,0,-e[0],-e[1]);au(a.usedTiles,l,p,x);bu(a,l,n,c,f,u,p,h.md());Yt(a,l);$t(a,l);return 0<this.i.length};rw.prototype.Vf=function(a,b,c,d,e,f,g,h){this.a.ia().gg(b.viewState.projection)||this.context.clearRect(d,e,f,g);(a=a.Y(this.a))&&this.context.drawImage(a,h,h,a.width-2*h,a.height-2*h,d,e,f,g)};rw.prototype.Y=function(){var a=this.context;return a?a.canvas:null};rw.prototype.D=function(){return this.B};function tw(){this.b="precision mediump float;varying vec2 a;uniform sampler2D e;void main(void){gl_FragColor=texture2D(e,a);}"}v(tw,ti);var uw=new tw;function vw(){this.b="varying vec2 a;attribute vec2 b;attribute vec2 c;uniform vec4 d;void main(void){gl_Position=vec4(b*d.xy+d.zw,0.,1.);a=c;}"}v(vw,ui);var ww=new vw;function xw(a,b){this.f=a.getUniformLocation(b,"e");this.c=a.getUniformLocation(b,"d");this.b=a.getAttribLocation(b,"b");this.a=a.getAttribLocation(b,"c")};function yw(a,b){su.call(this,a,b);this.I=uw;this.ga=ww;this.i=null;this.C=new Ki([0,0,0,1,1,0,1,1,0,1,0,0,1,1,1,0]);this.D=this.l=null;this.o=-1;this.S=[0,0]}v(yw,su);k=yw.prototype;k.ka=function(){Ni(this.c.i,this.C);su.prototype.ka.call(this)};k.Uf=function(a,b,c){var d=this.c;return function(e,f){return Vt(a,b,e,f,function(a){var b=d.a.b.hasOwnProperty(a.fb());b&&(c[e]||(c[e]={}),c[e][a.sa.toString()]=a);return b})}};k.ug=function(){su.prototype.ug.call(this);this.i=null};
k.vg=function(a,b,c){var d=this.c,e=c.b,f=a.viewState,g=f.projection,h=this.a,l=h.ia(),m=l.Ta(g),n=m.uc(f.resolution),p=m.Ca(n),q=l.ce(n,a.pixelRatio,g),t=q[0]/Ka(m.eb(n),this.S)[0],u=p/t,x=l.Oc(t)*l.bg(g),B=f.center,z=a.extent,G=sc(m,z,p);if(this.l&&ya(this.l,G)&&this.o==l.f)u=this.D;else{var E=[G.da-G.ca+1,G.ha-G.ea+1],ia=Ca(Math.max(E[0]*q[0],E[1]*q[1]));E=u*ia;var T=m.Sc(n),R=T[0]+G.ca*q[0]*u;u=T[1]+G.ea*q[1]*u;u=[R,u,R+E,u+E];tu(this,a,ia);e.viewport(0,0,ia,ia);e.clearColor(0,0,0,0);e.clear(16384);
e.disable(3042);ia=Oi(c,this.I,this.ga);c.Tc(ia);this.i||(this.i=new xw(e,ia));Di(c,34962,this.C);e.enableVertexAttribArray(this.i.b);e.vertexAttribPointer(this.i.b,2,5126,!1,16,0);e.enableVertexAttribArray(this.i.a);e.vertexAttribPointer(this.i.a,2,5126,!1,16,8);e.uniform1i(this.i.f,0);c={};c[n]={};var U=this.Uf(l,g,c),ta=h.qd();ia=!0;R=Ma();var A=new wa(0,0,0,0),ea,Ya;for(ea=G.ca;ea<=G.da;++ea)for(Ya=G.ea;Ya<=G.ha;++Ya){T=l.Qc(n,ea,Ya,t,g);if(void 0!==b.extent){var da=m.Fa(T.sa,R);if(!ob(da,b.extent))continue}da=
T.getState();(da=2==da||4==da||3==da&&!ta)||(T=ft(T));da=T.getState();if(2==da){if(d.a.b.hasOwnProperty(T.fb())){c[n][T.sa.toString()]=T;continue}}else if(4==da||3==da&&!ta)continue;ia=!1;da=qc(m,T.sa,U,A,R);da||(T=rc(m,T.sa,A,R))&&U(n+1,T)}b=Object.keys(c).map(Number);b.sort(fa);U=new Float32Array(4);var Vb;ta=0;for(A=b.length;ta<A;++ta)for(Vb in ea=c[b[ta]],ea)T=ea[Vb],da=m.Fa(T.sa,R),U[0]=2*(da[2]-da[0])/E,U[1]=2*(da[3]-da[1])/E,U[2]=2*(da[0]-u[0])/E-1,U[3]=2*(da[1]-u[1])/E-1,e.uniform4fv(this.i.c,
U),Gk(d,T,q,x*t),e.drawArrays(5,0,4);ia?(this.l=G,this.D=u,this.o=l.f):(this.D=this.l=null,this.o=-1,a.animate=!0)}au(a.usedTiles,l,n,G);var Ac=d.j;bu(a,l,m,t,g,z,n,h.md(),function(a){2!=a.getState()||d.a.b.hasOwnProperty(a.fb())||a.fb()in Ac.a||Ac.i([a,uc(m,a.sa),m.Ca(a.sa[0]),q,x*t])},this);Yt(a,l);$t(a,l);e=this.v;Jh(e);Qh(e,(Math.round(B[0]/p)*p-u[0])/(u[2]-u[0]),(Math.round(B[1]/p)*p-u[1])/(u[3]-u[1]));f.rotation&&Oh(e,f.rotation);Ph(e,a.size[0]*f.resolution/(u[2]-u[0]),a.size[1]*f.resolution/
(u[3]-u[1]));Qh(e,-.5,-.5);return!0};k.tg=function(a,b,c,d){if(this.g){a=Nh(this.v,[a[0]/b.size[0],(b.size[1]-a[1])/b.size[1]].slice());a=[a[0]*this.j,a[1]*this.j];b=this.c.i.b;b.bindFramebuffer(b.FRAMEBUFFER,this.g);var e=new Uint8Array(4);b.readPixels(a[0],a[1],1,1,b.RGBA,b.UNSIGNED_BYTE,e);if(0<e[3])return c.call(d,this.a,e)}};function zw(a){a=a?a:{};var b=rb({},a);delete b.preload;delete b.useInterimTilesOnError;Dh.call(this,b);this.Ji(void 0!==a.preload?a.preload:0);this.Ki(void 0!==a.useInterimTilesOnError?a.useInterimTilesOnError:!0)}v(zw,Dh);k=zw.prototype;k.Ld=function(a){var b=null,c=a.T();"canvas"===c?b=new rw(this):"webgl"===c&&(b=new yw(a,this));return b};k.md=function(){return this.get("preload")};k.Ji=function(a){this.set("preload",a)};k.qd=function(){return this.get("useInterimTilesOnError")};
k.Ki=function(a){this.set("useInterimTilesOnError",a)};function Aw(a){this.context=null;rw.call(this,a);this.C=!1;this.R=Ih();this.S="vector"==a.g?1:0}v(Aw,rw);var Bw={image:["Polygon","Circle","LineString","Image","Text"],hybrid:["Polygon","LineString"]},Cw={image:["Default"],hybrid:["Image","Text","Default"],vector:qi};k=Aw.prototype;k.yd=function(a,b){var c=this.a,d=c.f;this.ga!=d&&(this.i.length=0,c=c.g,this.context||"vector"==c||(this.context=ld()),this.context&&"vector"==c&&(this.context=null));this.ga=d;return rw.prototype.yd.apply(this,arguments)};
k.Vf=function(a,b){var c=a,d=this.a,e=b.pixelRatio,f=b.viewState.projection,g=d.f,h=d.get(mu)||null,l=Dw(c,d);if(l.Td||l.xf!=g||l.Sg!=h){var m=d.ia(),n=m.tileGrid,p=m.Ta(f),q=p.Ca(c.sa[0]);p=p.Fa(c.v);for(var t=0,u=c.f.length;t<u;++t){var x=c.c[c.f[t]];l.Td=!1;var B=x.f,z=n.Ca(x.sa[0]),G=n.Fa(x.sa),E=nb(p,G),ia;if("tile-pixels"==B.b){var T=ia=Ew(m,x);z=Rh(this.R,0,0,1/z*T,-1/z*T,0,-G[0],-G[3]);E=Nh(z,[E[0],E[3]]).concat(Nh(z,[E[2],E[1]]))}else if(ia=q,!ec(f,B)){var R=!0;x.qg(f)}l.Td=!1;E=new Mt(0,
E,ia,m.o,d.c);ia=hu(ia,e);z=x.c;h&&h!==l.Sg&&z.sort(h);G=0;for(T=z.length;G<T;++G){var U=z[G];R&&U.W().mb(B,f);var ta=void 0,A=U.bb();A?ta=A.call(U,q):(A=d.bb())&&(ta=A(U,q));if(ta){Array.isArray(ta)||(ta=[ta]);A=ia;var ea=E;if(ta){var Ya=!1;if(Array.isArray(ta))for(var da=0,Vb=ta.length;da<Vb;++da)Ya=iu(ea,U,ta[da],A,this.Pi,this)||Ya;else Ya=iu(ea,U,ta,A,this.Pi,this)||Ya;U=Ya}else U=!1;this.C=this.C||U;l.Td=l.Td||U}}Qt(E);B=c.sa.toString();x.j[w(d)+","+B]=E}l.xf=g;l.Sg=h}if(this.context){n=b;d=
this.a;f=Dw(c,d);g=d.f;if((e=Bw[d.g])&&f.Tg!==g)for(f.Tg=g,q=c.v,p=q[0],f=n.pixelRatio,g=d.ia(),h=g.tileGrid,R=g.Ta(n.viewState.projection),l=R.Ca(p),m=Fw(c,d),n=g.ce(p,f,n.viewState.projection),m.canvas.width=n[0],m.canvas.height=n[1],n=R.Fa(q),q=0,R=c.f.length;q<R;++q)p=c.c[c.f[q]],t=Ew(g,p),B=p.sa,x=f/l,u=Jh(this.R),"tile-pixels"==p.f.b?(x=h.Fa(B,this.l),B=h.Ca(B[0]),E=f/t*B/l,Ph(u,E,E),Qh(u,Math.round((x[0]-n[0])/B*t),Math.round((n[3]-x[3])/B*t))):(Ph(u,x,-x),Qh(u,-n[0],-n[3])),Gw(p,d,c.sa.toString()).Ma(m,
f,u,0,{},e,!0);rw.prototype.Vf.apply(this,arguments)}};
k.Ha=function(a,b,c,d,e){var f=b.viewState.resolution,g=b.viewState.rotation;c=void 0==c?0:c;var h=this.a,l={},m=this.i,n=h.ia();b=n.Ta(b.viewState.projection);var p=n.tileGrid,q;var t=0;for(q=m.length;t<q;++t){var u=m[t];var x=u.sa;var B=b.Fa(x,this.l);var z=Oa(B,c*f,z);if(Ra(z,a)){B=0;for(var G=u.f.length;B<G;++B){var E=u.c[u.f[B]];if("tile-pixels"===E.f.b){var ia=E.sa;f=p.Fa(ia,this.l);var T=gb(f);f=Ew(n,E);ia=p.Ca(ia[0]);var R=ia/f;T=[(a[0]-T[0])/R,(T[1]-a[1])/R];f*=b.Ca(x[0])/ia}else T=a;E=Gw(E,
h,u.sa.toString());var U=U||E.Ha(T,f,g,c,{},function(a){var b=w(a).toString();if(!(b in l))return l[b]=!0,d.call(e,a,h)})}}}return U};function Ew(a,b){return jb(b.G())/Ka(a.tileGrid.eb(b.sa[0]))[0]}k.Pi=function(){Wt(this)};
k.qf=function(a,b,c){var d=this.a,e=d.ia(),f=d.g,g=Cw[f],h=b.pixelRatio,l=b.viewState.rotation,m=b.size,n=Math.round(h*m[0]/2);m=Math.round(h*m[1]/2);for(var p=this.i,q=e.tileGrid,t=e.Ta(b.viewState.projection),u=[],x=[],B=p.length-1;0<=B;--B){var z=p[B];if(5!=z.getState())for(var G=z.sa,E=t.Fa(G)[0]-t.Fa(z.v)[0],ia=0,T=z.f.length;ia<T;++ia){var R=z.c[z.f[ia]],U=Ew(e,R),ta=Gw(R,d,G.toString()),A;if(!(A="vector"==f))a:{A=void 0;for(A in ta.a)for(var ea=ta.a[A],Ya=0,da=g.length;Ya<da;++Ya)if(g[Ya]in
ea){A=!0;break a}A=!1}if(A){A=R.sa[0];ea=q.Ca(A);Ya=R;R=b;if("tile-pixels"==Ya.f.b){da=this.a.ia();var Vb=da.tileGrid,Ac=Ya.sa;Ya=Vb.Ca(Ac[0])/Ew(da,Ya);da=R.viewState;var ge=R.pixelRatio,he=da.resolution/ge;Ac=Vb.Fa(Ac,this.l);Vb=da.center;Ac=gb(Ac);R=R.size;R=Rh(this.R,Math.round(ge*R[0]/2),Math.round(ge*R[1]/2),Ya/he,Ya/he,da.rotation,(Ac[0]-Vb[0])/Ya,(Vb[1]-Ac[1])/Ya)}else R=fu(this,R,0);Qh(R,E*U/ea,0);U=St(ta,R);a.save();a.globalAlpha=c.opacity;bi(a,-l,n,m);ea=0;for(Ya=u.length;ea<Ya;++ea)da=
u[ea],A<x[ea]&&(a.beginPath(),a.moveTo(U[0],U[1]),a.lineTo(U[2],U[3]),a.lineTo(U[4],U[5]),a.lineTo(U[6],U[7]),a.moveTo(da[6],da[7]),a.lineTo(da[4],da[5]),a.lineTo(da[2],da[3]),a.lineTo(da[0],da[1]),a.clip());ta.Ma(a,h,R,l,{},g);a.restore();u.push(U);x.push(A)}}}rw.prototype.qf.apply(this,arguments)};function Hw(a){a=a?a:{};var b=rb({},a);delete b.preload;delete b.useInterimTilesOnError;S.call(this,b);this.Li(a.preload?a.preload:0);this.Mi(a.useInterimTilesOnError?a.useInterimTilesOnError:!0);va(void 0==a.renderMode||"image"==a.renderMode||"hybrid"==a.renderMode||"vector"==a.renderMode,28);this.g=a.renderMode||"hybrid"}v(Hw,S);k=Hw.prototype;k.Ld=function(a){var b=null;"canvas"===a.T()&&(b=new Aw(this));return b};k.md=function(){return this.get("preload")};k.qd=function(){return this.get("useInterimTilesOnError")};
k.Li=function(a){this.set("preload",a)};k.Mi=function(a){this.set("useInterimTilesOnError",a)};function Iw(a,b,c,d){function e(){delete window[g];f.parentNode.removeChild(f)}var f=document.createElement("script"),g="olc_"+w(b);f.async=!0;f.src=a+(-1==a.indexOf("?")?"?":"&")+(d||"callback")+"="+g;var h=setTimeout(function(){e();c&&c()},1E4);window[g]=function(a){clearTimeout(h);e();b(a)};document.getElementsByTagName("head")[0].appendChild(f)};function Jw(a,b,c,d,e,f,g,h,l,m,n){et.call(this,e,0);this.D=void 0!==n?n:!1;this.R=g;this.u=h;this.v=null;this.c=b;this.j=d;this.l=f?f:e;this.f=[];this.Ed=null;this.g=0;f=d.Fa(this.l);h=this.j.G();e=this.c.G();f=h?nb(f,h):f;if(hb(f))if((h=a.G())&&(e?e=nb(e,h):e=h),d=Xv(a,c,lb(f),d.Ca(this.l[0])),!isFinite(d)||0>=d)this.state=4;else if(this.o=new $v(a,c,f,e,d*(void 0!==m?m:.5)),this.o.c.length)if(this.g=b.uc(d),c=bw(this.o),e&&(a.f?(c[1]=Aa(c[1],e[1],e[3]),c[3]=Aa(c[3],e[1],e[3])):c=nb(c,e)),hb(c)){a=
pc(b,c,this.g);for(b=a.ca;b<=a.da;b++)for(c=a.ea;c<=a.ha;c++)(m=l(this.g,b,c,g))&&this.f.push(m);this.f.length||(this.state=4)}else this.state=4;else this.state=4;else this.state=4}v(Jw,et);Jw.prototype.ka=function(){1==this.state&&(this.Ed.forEach(Gc),this.Ed=null);et.prototype.ka.call(this)};Jw.prototype.Y=function(){return this.v};
Jw.prototype.ke=function(){var a=[];this.f.forEach(function(b){b&&2==b.getState()&&a.push({extent:this.c.Fa(b.sa),image:b.Y()})},this);this.f.length=0;if(a.length){var b=this.l[0],c=this.j.eb(b),d="number"===typeof c?c:c[0];c="number"===typeof c?c:c[1];b=this.j.Ca(b);var e=this.c.Ca(this.g),f=this.j.Fa(this.l);this.v=Zv(d,c,this.R,e,this.c.G(),b,f,this.o,a,this.u,this.D);this.state=2}else this.state=3;this.s()};
Jw.prototype.load=function(){if(0==this.state){this.state=1;this.s();var a=0;this.Ed=[];this.f.forEach(function(b){var c=b.getState();if(0==c||1==c){a++;var d=y(b,"change",function(){var c=b.getState();if(2==c||3==c||4==c)Gc(d),a--,a||(this.Ed.forEach(Gc),this.Ed=null,this.ke())},this);this.Ed.push(d)}},this);this.f.forEach(function(a){0==a.getState()&&a.load()});a||setTimeout(this.ke.bind(this),0)}};function Kw(a,b){var c=/\{z\}/g,d=/\{x\}/g,e=/\{y\}/g,f=/\{-y\}/g;return function(g){if(g)return a.replace(c,g[0].toString()).replace(d,g[1].toString()).replace(e,function(){return(-g[2]-1).toString()}).replace(f,function(){var a=b.a?b.a[g[0]]:null;va(a,55);return(a.ha-a.ea+1+g[2]).toString()})}}function Lw(a,b){for(var c=a.length,d=Array(c),e=0;e<c;++e)d[e]=Kw(a[e],b);return Mw(d)}function Mw(a){return 1===a.length?a[0]:function(b,c,d){if(b)return a[Ga((b[1]<<b[0])+b[2],a.length)](b,c,d)}}
function Nw(){}function Ow(a){var b=[],c=/\{([a-z])-([a-z])\}/.exec(a);if(c){var d=c[2].charCodeAt(0),e;for(e=c[1].charCodeAt(0);e<=d;++e)b.push(a.replace(c[0],String.fromCharCode(e)));return b}if(c=c=/\{(\d+)-(\d+)\}/.exec(a)){d=parseInt(c[2],10);for(e=parseInt(c[1],10);e<=d;e++)b.push(a.replace(c[0],e.toString()));return b}b.push(a);return b};function Pw(a){Ek.call(this);this.highWaterMark=void 0!==a?a:2048}v(Pw,Ek);function Qw(a){return a.c>a.highWaterMark}Pw.prototype.jd=function(a){for(var b,c;Qw(this);){b=this.a.bd;c=b.sa[0].toString();var d;if(d=c in a)b=b.sa,d=xa(a[c],b[1],b[2]);if(d)break;else Pc(this.pop())}};function Rw(a){xu.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,state:a.state,wrapX:a.wrapX});this.va=void 0!==a.opaque?a.opaque:!1;this.Za=void 0!==a.tilePixelRatio?a.tilePixelRatio:1;this.tileGrid=void 0!==a.tileGrid?a.tileGrid:null;this.a=new Pw(a.cacheSize);this.l=[0,0];this.vc=""}v(Rw,xu);k=Rw.prototype;k.Ui=function(){return Qw(this.a)};k.jd=function(a,b){(a=this.be(a))&&a.jd(b)};
function Vt(a,b,c,d,e){b=a.be(b);if(!b)return!1;for(var f=!0,g,h,l=d.ca;l<=d.da;++l)for(var m=d.ea;m<=d.ha;++m)g=a.Rb(c,l,m),h=!1,b.b.hasOwnProperty(g)&&(g=b.get(g),(h=2===g.getState())&&(h=!1!==e(g))),h||(f=!1);return f}k.bg=function(){return 0};function Sw(a,b){a.vc!==b&&(a.vc=b,a.s())}k.Rb=function(a,b,c){return a+"/"+b+"/"+c};k.gg=function(){return this.va};k.cb=function(){return this.tileGrid};k.Ta=function(a){return this.tileGrid?this.tileGrid:vc(a)};
k.be=function(a){var b=this.c;return b&&!ec(b,a)?null:this.a};k.Oc=function(){return this.Za};k.ce=function(a,b,c){c=this.Ta(c);b=this.Oc(b);a=Ka(c.eb(a),this.l);return 1==b?a:Ja(a,b,this.l)};function Tw(a,b,c){var d=void 0!==c?c:a.c;c=a.Ta(d);if(a.u&&d.c){var e=b;b=e[0];a=uc(c,e);d=zc(d);Ra(d,a)?b=e:(e=jb(d),a[0]+=e*Math.ceil((d[0]-a[0])/e),b=c.kg(a,b))}e=b[0];d=b[1];a=b[2];if(c.minZoom>e||e>c.maxZoom)c=!1;else{var f=c.G();c=(c=f?pc(c,f,e):c.a?c.a[e]:null)?xa(c,d,a):!0}return c?b:null}
k.ra=function(){this.a.clear();this.s()};k.Zg=ra;function Uw(a,b){Qc.call(this,a);this.tile=b}v(Uw,Qc);function Vw(a){Rw.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tilePixelRatio:a.tilePixelRatio,wrapX:a.wrapX});this.tileLoadFunction=a.tileLoadFunction;this.tileUrlFunction=this.Hc?this.Hc.bind(this):Nw;this.urls=null;a.urls?this.ib(a.urls):a.url&&this.nb(a.url);a.tileUrlFunction&&this.hb(a.tileUrlFunction)}v(Vw,Rw);k=Vw.prototype;k.tb=function(){return this.tileLoadFunction};
k.ub=function(){return this.tileUrlFunction};k.vb=function(){return this.urls};k.Vi=function(a){a=a.target;switch(a.getState()){case 1:this.b(new Uw("tileloadstart",a));break;case 2:this.b(new Uw("tileloadend",a));break;case 3:this.b(new Uw("tileloaderror",a))}};k.zb=function(a){this.a.clear();this.tileLoadFunction=a;this.s()};k.hb=function(a,b){this.tileUrlFunction=a;"undefined"!==typeof b?Sw(this,b):this.s()};
k.nb=function(a){var b=this.urls=Ow(a);this.hb(this.Hc?this.Hc.bind(this):Lw(b,this.tileGrid),a)};k.ib=function(a){this.urls=a;var b=a.join("\n");this.hb(this.Hc?this.Hc.bind(this):Lw(a,this.tileGrid),b)};k.Zg=function(a,b,c){a=this.Rb(a,b,c);this.a.b.hasOwnProperty(a)&&this.a.get(a)};function X(a){Vw.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,extent:a.extent,logo:a.logo,opaque:a.opaque,projection:a.projection,state:a.state,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:Ww,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,wrapX:a.wrapX});this.crossOrigin=void 0!==a.crossOrigin?a.crossOrigin:null;this.tileClass=a.tileClass?a.tileClass:it;this.g={};this.v={};this.Sa=a.reprojectionErrorThreshold;this.I=
!1}v(X,Vw);k=X.prototype;k.Ui=function(){if(Qw(this.a))return!0;for(var a in this.g)if(Qw(this.g[a]))return!0;return!1};k.jd=function(a,b){a=this.be(a);this.a.jd(this.a==a?b:{});for(var c in this.g){var d=this.g[c];d.jd(d==a?b:{})}};k.bg=function(a){return this.c&&a&&!ec(this.c,a)?0:this.cg()};k.cg=function(){return 0};k.gg=function(a){return this.c&&a&&!ec(this.c,a)?!1:Vw.prototype.gg.call(this,a)};
k.Ta=function(a){var b=this.c;return!this.tileGrid||b&&!ec(b,a)?(b=w(a).toString(),b in this.v||(this.v[b]=vc(a)),this.v[b]):this.tileGrid};k.be=function(a){var b=this.c;if(!b||ec(b,a))return this.a;a=w(a).toString();a in this.g||(this.g[a]=new Pw(this.a.highWaterMark));return this.g[a]};function Xw(a,b,c,d,e,f,g){b=[b,c,d];e=(c=Tw(a,b,f))?a.tileUrlFunction(c,e,f):void 0;e=new a.tileClass(b,void 0!==e?0:4,void 0!==e?e:"",a.crossOrigin,a.tileLoadFunction);e.key=g;y(e,"change",a.Vi,a);return e}
k.Qc=function(a,b,c,d,e){if(this.c&&e&&!ec(this.c,e)){var f=this.be(e);c=[a,b,c];var g;a=this.Rb.apply(this,c);f.b.hasOwnProperty(a)&&(g=f.get(a));b=this.vc;if(g&&g.key==b)return g;var h=this.c,l=this.Ta(h),m=this.Ta(e),n=Tw(this,c,e);d=new Jw(h,l,e,m,c,n,this.Oc(d),this.cg(),function(a,b,c,d){return Yw(this,a,b,c,d,h)}.bind(this),this.Sa,this.I);d.key=b;g?(d.a=g,gt(d),f.replace(a,d)):f.set(a,d);return d}return Yw(this,a,b,c,d,e)};
function Yw(a,b,c,d,e,f){var g=a.Rb(b,c,d),h=a.vc;if(a.a.b.hasOwnProperty(g)){var l=a.a.get(g);if(l.key!=h){var m=l;l=Xw(a,b,c,d,e,f,h);0==m.getState()?l.a=m.a:l.a=m;gt(l);a.a.replace(g,l)}}else l=Xw(a,b,c,d,e,f,h),a.a.set(g,l);return l}k.Nb=function(a){if(this.I!=a){this.I=a;for(var b in this.g)this.g[b].clear();this.s()}};k.Ob=function(a,b){if(a=Wb(a))a=w(a).toString(),a in this.v||(this.v[a]=b)};function Ww(a,b){a.Y().src=b};function Zw(a){this.i=void 0!==a.hidpi?a.hidpi:!1;X.call(this,{cacheSize:a.cacheSize,crossOrigin:"anonymous",opaque:!0,projection:Wb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,tilePixelRatio:this.i?2:1,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.S=void 0!==a.culture?a.culture:"en-us";this.C=void 0!==a.maxZoom?a.maxZoom:-1;this.o=a.key;this.B=a.imagerySet;Iw("https://dev.virtualearth.net/REST/v1/Imagery/Metadata/"+this.B+"?uriScheme=https&include=ImageryProviders&key="+
this.o,this.oa.bind(this),void 0,"jsonp")}v(Zw,X);var $w=new Cc({html:'<a class="ol-attribution-bing-tos" href="https://www.microsoft.com/maps/product/terms.html">Terms of Use</a>'});Zw.prototype.U=function(){return this.o};Zw.prototype.ga=function(){return this.B};
Zw.prototype.oa=function(a){if(200!=a.statusCode||"OK"!=a.statusDescription||"ValidCredentials"!=a.authenticationResultCode||1!=a.resourceSets.length||1!=a.resourceSets[0].resources.length)zu(this,"error");else{var b=a.brandLogoUri;-1==b.indexOf("https")&&(b=b.replace("http","https"));var c=a.resourceSets[0].resources[0],d=-1==this.C?c.zoomMax:this.C;a=zc(this.c);var e=xc({extent:a,minZoom:c.zoomMin,maxZoom:d,tileSize:(c.imageWidth==c.imageHeight?c.imageWidth:[c.imageWidth,c.imageHeight])/(this.i?
2:1)});this.tileGrid=e;var f=this.S,g=this.i;this.tileUrlFunction=Mw(c.imageUrlSubdomains.map(function(a){var b=[0,0,0],d=c.imageUrl.replace("{subdomain}",a).replace("{culture}",f);return function(a){if(a)return kc(a[0],a[1],-a[2]-1,b),a=d,g&&(a+="&dpi=d1&device=mobile"),a.replace("{quadkey}",lc(b))}}));if(c.imageryProviders){var h=Xb(Wb("EPSG:4326"),this.c);a=c.imageryProviders.map(function(a){var b=a.attribution,c={};a.coverageAreas.forEach(function(a){var b=a.zoomMin,f=Math.min(a.zoomMax,d);a=
a.bbox;a=qb([a[1],a[0],a[3],a[2]],h);var g;for(g=b;g<=f;++g){var l=g.toString();b=pc(e,a,g);l in c?c[l].push(b):c[l]=[b]}});return new Cc({html:b,tileRanges:c})});a.push($w);this.wa(a)}this.D=b;zu(this,"ready")}};function ax(a){a=a||{};var b=void 0!==a.projection?a.projection:"EPSG:3857",c=void 0!==a.tileGrid?a.tileGrid:xc({extent:zc(b),maxZoom:a.maxZoom,minZoom:a.minZoom,tileSize:a.tileSize});X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:a.opaque,projection:b,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:c,tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,
wrapX:void 0!==a.wrapX?a.wrapX:!0})}v(ax,X);function bx(a){this.B=a.account;this.C=a.map||"";this.i=a.config||{};this.o={};ax.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,maxZoom:void 0!==a.maxZoom?a.maxZoom:18,minZoom:a.minZoom,projection:a.projection,state:"loading",wrapX:a.wrapX});cx(this)}v(bx,ax);k=bx.prototype;k.Vk=function(){return this.i};k.Hq=function(a){rb(this.i,a);cx(this)};k.kq=function(a){this.i=a||{};cx(this)};
function cx(a){var b=JSON.stringify(a.i);if(a.o[b])dx(a,a.o[b]);else{var c="https://"+a.B+".cartodb.com/api/v1/map";a.C&&(c+="/named/"+a.C);var d=new XMLHttpRequest;d.addEventListener("load",a.Pl.bind(a,b));d.addEventListener("error",a.Ol.bind(a));d.open("POST",c);d.setRequestHeader("Content-type","application/json");d.send(JSON.stringify(a.i))}}
k.Pl=function(a,b){b=b.target;if(!b.status||200<=b.status&&300>b.status){try{var c=JSON.parse(b.responseText)}catch(d){zu(this,"error");return}dx(this,c);this.o[a]=c;zu(this,"ready")}else zu(this,"error")};k.Ol=function(){zu(this,"error")};function dx(a,b){a.nb("https://"+b.cdn_url.https+"/"+a.B+"/api/v1/map/"+b.layergroupid+"/{z}/{x}/{y}.png")};function Y(a){V.call(this,{attributions:a.attributions,extent:a.extent,logo:a.logo,projection:a.projection,wrapX:a.wrapX});this.resolution=void 0;this.distance=void 0!==a.distance?a.distance:20;this.features=[];this.geometryFunction=a.geometryFunction||function(a){a=a.W();va(a instanceof C,10);return a};this.source=a.source;this.source.J("change",Y.prototype.ra,this)}v(Y,V);k=Y.prototype;k.po=function(){return this.distance};k.qo=function(){return this.source};
k.de=function(a,b,c){this.source.de(a,b,c);b!==this.resolution&&(this.clear(),this.resolution=b,ex(this),this.Ec(this.features))};k.lq=function(a){this.distance=a;this.ra()};k.ra=function(){this.clear();ex(this);this.Ec(this.features);V.prototype.ra.call(this)};
function ex(a){if(void 0!==a.resolution){a.features.length=0;for(var b=Ma(),c=a.distance*a.resolution,d=a.source.fe(),e={},f=0,g=d.length;f<g;f++){var h=d[f];w(h).toString()in e||!(h=a.geometryFunction(h))||(h=h.V(),Xa(h,b),Oa(b,c,b),h=a.source.ag(b),h=h.filter(function(a){a=w(a).toString();return a in e?!1:e[a]=!0}),a.features.push(fx(a,h)))}}}
function fx(a,b){for(var c=[0,0],d=b.length-1;0<=d;--d){var e=a.geometryFunction(b[d]);e?bf(c,e.V()):b.splice(d,1)}jf(c,1/b.length);a=new Bl(new C(c));a.set("features",b);return a};function gx(a,b){var c=[];Object.keys(b).forEach(function(a){null!==b[a]&&void 0!==b[a]&&c.push(a+"="+encodeURIComponent(b[a]))});var d=c.join("&");a=a.replace(/[?&]$/,"");a=-1===a.indexOf("?")?a+"?":a+"&";return a+d};function hx(a){a=a||{};dw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.S=void 0!==a.crossOrigin?a.crossOrigin:null;this.U=void 0!==a.hidpi?a.hidpi:!0;this.a=a.url;this.g=a.imageLoadFunction?a.imageLoadFunction:jw;this.v=a.params||{};this.M=null;this.o=[0,0];this.I=0;this.C=void 0!==a.ratio?a.ratio:1.5}v(hx,dw);k=hx.prototype;k.so=function(){return this.v};
k.Lc=function(a,b,c,d){if(void 0===this.a)return null;b=ew(this,b);c=this.U?c:1;var e=this.M;if(e&&this.I==this.f&&e.resolution==b&&e.a==c&&Ta(e.G(),a))return e;e={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};rb(e,this.v);a=a.slice();var f=(a[0]+a[2])/2,g=(a[1]+a[3])/2;if(1!=this.C){var h=this.C*jb(a)/2,l=this.C*kb(a)/2;a[0]=f-h;a[1]=g-l;a[2]=f+h;a[3]=g+l}h=b/c;l=Math.ceil(jb(a)/h);var m=Math.ceil(kb(a)/h);a[0]=f-h*l/2;a[2]=f+h*l/2;a[1]=g-h*m/2;a[3]=g+h*m/2;this.o[0]=l;this.o[1]=m;f=a;g=this.o;h=c;d=
d.qb.split(":").pop();e.SIZE=g[0]+","+g[1];e.BBOX=f.join(",");e.BBOXSR=d;e.IMAGESR=d;e.DPI=Math.round(90*h);d=this.a;f=d.replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage");f==d&&va(!1,50);e=gx(f,e);this.M=new ct(a,b,c,this.j,e,this.S,this.g);this.I=this.f;y(this.M,"change",this.l,this);return this.M};k.ro=function(){return this.g};k.to=function(){return this.a};k.uo=function(a){this.M=null;this.g=a;this.s()};
k.vo=function(a){a!=this.a&&(this.a=a,this.M=null,this.s())};k.wo=function(a){rb(this.v,a);this.M=null;this.s()};function ix(a){dw.call(this,{projection:a.projection,resolutions:a.resolutions});this.S=void 0!==a.crossOrigin?a.crossOrigin:null;this.o=void 0!==a.displayDpi?a.displayDpi:96;this.g=a.params||{};this.I=a.url;this.a=a.imageLoadFunction?a.imageLoadFunction:jw;this.U=void 0!==a.hidpi?a.hidpi:!0;this.oa=void 0!==a.metersPerUnit?a.metersPerUnit:1;this.v=void 0!==a.ratio?a.ratio:1;this.va=void 0!==a.useOverlay?a.useOverlay:!1;this.M=null;this.C=0}v(ix,dw);k=ix.prototype;k.yo=function(){return this.g};
k.Lc=function(a,b,c){b=ew(this,b);c=this.U?c:1;var d=this.M;if(d&&this.C==this.f&&d.resolution==b&&d.a==c&&Ta(d.G(),a))return d;1!=this.v&&(a=a.slice(),pb(a,this.v));var e=[jb(a)/b*c,kb(a)/b*c];if(void 0!==this.I){d=this.I;var f=lb(a),g=this.oa,h=jb(a),l=kb(a),m=e[0],n=e[1],p=.0254/this.o;e={OPERATION:this.va?"GETDYNAMICMAPOVERLAYIMAGE":"GETMAPIMAGE",VERSION:"2.0.0",LOCALE:"en",CLIENTAGENT:"ol.source.ImageMapGuide source",CLIP:"1",SETDISPLAYDPI:this.o,SETDISPLAYWIDTH:Math.round(e[0]),SETDISPLAYHEIGHT:Math.round(e[1]),
SETVIEWSCALE:n*h>m*l?h*g/(m*p):l*g/(n*p),SETVIEWCENTERX:f[0],SETVIEWCENTERY:f[1]};rb(e,this.g);d=gx(d,e);d=new ct(a,b,c,this.j,d,this.S,this.a);y(d,"change",this.l,this)}else d=null;this.M=d;this.C=this.f;return d};k.xo=function(){return this.a};k.Ao=function(a){rb(this.g,a);this.s()};k.zo=function(a){this.M=null;this.a=a;this.s()};function jx(a){var b=a.imageExtent,c=void 0!==a.crossOrigin?a.crossOrigin:null,d=a.imageLoadFunction?a.imageLoadFunction:jw;dw.call(this,{attributions:a.attributions,logo:a.logo,projection:Wb(a.projection)});this.M=new ct(b,void 0,1,this.j,a.url,c,d);this.a=a.imageSize?a.imageSize:null;y(this.M,"change",this.l,this)}v(jx,dw);jx.prototype.Lc=function(a){return ob(a,this.M.G())?this.M:null};
jx.prototype.l=function(a){if(2==this.M.getState()){var b=this.M.G(),c=this.M.Y();if(this.a){var d=this.a[0];var e=this.a[1]}else d=c.width,e=c.height;b=Math.ceil(jb(b)/(kb(b)/e));if(b!=d){b=ld(b,e);var f=b.canvas;b.drawImage(c,0,0,d,e,0,0,f.width,f.height);this.M.Wg(f)}}dw.prototype.l.call(this,a)};function kx(a){a=a||{};dw.call(this,{attributions:a.attributions,logo:a.logo,projection:a.projection,resolutions:a.resolutions});this.oa=void 0!==a.crossOrigin?a.crossOrigin:null;this.g=a.url;this.v=a.imageLoadFunction?a.imageLoadFunction:jw;this.a=a.params||{};this.o=!0;lx(this);this.U=a.serverType;this.va=void 0!==a.hidpi?a.hidpi:!0;this.M=null;this.C=[0,0];this.S=0;this.I=void 0!==a.ratio?a.ratio:1.5}v(kx,dw);var mx=[101,101];k=kx.prototype;
k.Fo=function(a,b,c,d){if(void 0!==this.g){var e=mb(a,b,0,mx),f={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.a.LAYERS};rb(f,this.a,d);d=Math.floor((e[3]-a[1])/b);f[this.o?"I":"X"]=Math.floor((a[0]-e[0])/b);f[this.o?"J":"Y"]=d;return nx(this,e,mx,1,Wb(c),f)}};k.Ho=function(){return this.a};
k.Lc=function(a,b,c,d){if(void 0===this.g)return null;b=ew(this,b);1==c||this.va&&void 0!==this.U||(c=1);var e=b/c,f=lb(a),g=mb(f,e,0,[Math.ceil(jb(a)/e),Math.ceil(kb(a)/e)]);a=mb(f,e,0,[Math.ceil(this.I*jb(a)/e),Math.ceil(this.I*kb(a)/e)]);if((f=this.M)&&this.S==this.f&&f.resolution==b&&f.a==c&&Ta(f.G(),g))return f;g={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};rb(g,this.a);this.C[0]=Math.round(jb(a)/e);this.C[1]=Math.round(kb(a)/e);d=nx(this,a,this.C,c,d,g);
this.M=new ct(a,b,c,this.j,d,this.oa,this.v);this.S=this.f;y(this.M,"change",this.l,this);return this.M};k.Go=function(){return this.v};
function nx(a,b,c,d,e,f){va(void 0!==a.g,9);f[a.o?"CRS":"SRS"]=e.qb;"STYLES"in a.a||(f.STYLES="");if(1!=d)switch(a.U){case "geoserver":d=90*d+.5|0;f.FORMAT_OPTIONS="FORMAT_OPTIONS"in f?f.FORMAT_OPTIONS+(";dpi:"+d):"dpi:"+d;break;case "mapserver":f.MAP_RESOLUTION=90*d;break;case "carmentaserver":case "qgis":f.DPI=90*d;break;default:va(!1,8)}f.WIDTH=c[0];f.HEIGHT=c[1];c=e.a;var g;a.o&&"ne"==c.substr(0,2)?g=[b[1],b[0],b[3],b[2]]:g=b;f.BBOX=g.join(",");return gx(a.g,f)}k.Io=function(){return this.g};
k.Jo=function(a){this.M=null;this.v=a;this.s()};k.Ko=function(a){a!=this.g&&(this.g=a,this.M=null,this.s())};k.Lo=function(a){rb(this.a,a);lx(this);this.M=null;this.s()};function lx(a){a.o=0<=af(a.a.VERSION||"1.3.0")};function ox(a){a=a||{};var b;void 0!==a.attributions?b=a.attributions:b=[px];ax.call(this,{attributions:b,cacheSize:a.cacheSize,crossOrigin:void 0!==a.crossOrigin?a.crossOrigin:"anonymous",opaque:void 0!==a.opaque?a.opaque:!0,maxZoom:void 0!==a.maxZoom?a.maxZoom:19,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png",wrapX:a.wrapX})}v(ox,ax);var px=new Cc({html:'&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors.'});Nj.pf={};Nj.pf.Jf=function(){};
(function(a){function b(a,b,c){if(g)return new ImageData(a,b,c);b=h.createImageData(b,c);b.data.set(a);return b}function c(a){var b=!0;try{new ImageData(10,10)}catch(n){b=!1}return function(c){var d=c.buffers,e=c.meta,f=c.width,g=c.height,h=d.length,l=d[0].byteLength;if(c.imageOps){l=Array(h);for(c=0;c<h;++c){var m=c;var n=new Uint8ClampedArray(d[c]);var E=f,ia=g;n=b?new ImageData(n,E,ia):{data:n,width:E,height:ia};l[m]=n}f=a(l,e).data}else{f=new Uint8ClampedArray(l);g=Array(h);m=Array(h);for(c=0;c<
h;++c)g[c]=new Uint8ClampedArray(d[c]),m[c]=[0,0,0,0];for(d=0;d<l;d+=4){for(c=0;c<h;++c)n=g[c],m[c][0]=n[d],m[c][1]=n[d+1],m[c][2]=n[d+2],m[c][3]=n[d+3];c=a(m,e);f[d]=c[0];f[d+1]=c[1];f[d+2]=c[2];f[d+3]=c[3]}}return f.buffer}}function d(a,b){var d=Object.keys(a.lib||{}).map(function(b){return"var "+b+" = "+a.lib[b].toString()+";"}).concat(["var __minion__ = ("+c.toString()+")(",a.operation.toString(),");",'self.addEventListener("message", function(event) {',"  var buffer = __minion__(event.data);",
"  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);","});"]);d=URL.createObjectURL(new Blob(d,{type:"text/javascript"}));d=new Worker(d);d.addEventListener("message",b);return d}function e(a,b){var d=c(a.operation);return{postMessage:function(a){setTimeout(function(){b({data:{buffer:d(a),meta:a.meta}})},0)}}}function f(a){this.Nf=!!a.nm;var b;0===a.threads?b=0:this.Nf?b=1:b=a.threads||1;var c=[];if(b)for(var f=0;f<b;++f)c[f]=d(a,this.lh.bind(this,f));else c[0]=e(a,this.lh.bind(this,
0));this.Be=c;this.Kd=[];this.qk=a.Ep||Infinity;this.ze=0;this.fd={};this.Of=null}var g=!0;try{new ImageData(10,10)}catch(l){g=!1}var h=document.createElement("canvas").getContext("2d");f.prototype.Cp=function(a,b,c){this.nk({inputs:a,Zh:b,callback:c});this.ih()};f.prototype.nk=function(a){for(this.Kd.push(a);this.Kd.length>this.qk;)this.Kd.shift().callback(null,null)};f.prototype.ih=function(){if(0===this.ze&&0<this.Kd.length){var a=this.Of=this.Kd.shift(),b=a.inputs[0].width,c=a.inputs[0].height,
d=a.inputs.map(function(a){return a.data.buffer}),e=this.Be.length;this.ze=e;if(1===e)this.Be[0].postMessage({buffers:d,meta:a.Zh,imageOps:this.Nf,width:b,height:c},d);else for(var f=4*Math.ceil(a.inputs[0].data.length/4/e),g=0;g<e;++g){for(var h=g*f,B=[],z=0,G=d.length;z<G;++z)B.push(d[g].slice(h,h+f));this.Be[g].postMessage({buffers:B,meta:a.Zh,imageOps:this.Nf,width:b,height:c},B)}}};f.prototype.lh=function(a,b){this.Xq||(this.fd[a]=b.data,--this.ze,0===this.ze&&this.rk())};f.prototype.rk=function(){var a=
this.Of,c=this.Be.length;if(1===c){var d=new Uint8ClampedArray(this.fd[0].buffer);var e=this.fd[0].meta}else{var f=a.inputs[0].data.length;d=new Uint8ClampedArray(f);e=Array(f);f=4*Math.ceil(f/4/c);for(var g=0;g<c;++g){var h=g*f;d.set(new Uint8ClampedArray(this.fd[g].buffer),h);e[g]=this.fd[g].meta}}this.Of=null;this.fd={};a.callback(null,b(d,a.inputs[0].width,a.inputs[0].height),e);this.ih()};a["default"]={Jf:f};a.Jf=f})(Nj.pf=Nj.pf||{});function qx(a){this.C=null;this.va=void 0!==a.operationType?a.operationType:"pixel";this.Sa=void 0!==a.threads?a.threads:1;this.g=rx(a.sources);for(var b=0,c=this.g.length;b<c;++b)y(this.g[b],"change",this.s,this);this.U=new Se(function(){return 1},this.s.bind(this));b=sx(this.g);c={};for(var d=0,e=b.length;d<e;++d)c[w(b[d].layer)]=b[d];this.a=null;this.I={animate:!1,attributions:{},coordinateToPixelTransform:Ih(),extent:null,focus:null,index:0,layerStates:c,layerStatesArray:b,logos:{},pixelRatio:1,
pixelToCoordinateTransform:Ih(),postRenderFunctions:[],size:[0,0],skippedFeatureUids:{},tileQueue:this.U,time:Date.now(),usedTiles:{},viewState:{rotation:0},viewHints:[],wantedTiles:{}};dw.call(this,{});a.operation&&this.v(a.operation,a.lib)}v(qx,dw);qx.prototype.v=function(a,b){this.C=new Nj.pf.Jf({operation:a,nm:"image"===this.va,Ep:1,lib:b,threads:this.Sa});this.s()};
qx.prototype.Y=function(a,b,c,d){c=!0;for(var e,f=0,g=this.g.length;f<g;++f)if(e=this.g[f].a.ia(),"ready"!==e.getState()){c=!1;break}if(!c)return null;c=rb({},this.I);c.viewState=rb({},c.viewState);e=lb(a);c.extent=a.slice();c.focus=e;c.size[0]=Math.round(jb(a)/b);c.size[1]=Math.round(kb(a)/b);f=c.viewState;f.center=e;f.projection=d;f.resolution=b;this.o=c;this.a&&(d=this.a.resolution,e=this.a.G(),b===d&&ab(a,e)||(this.a=null));if(!this.a||this.f!==this.S)a:{a=this.o;d=this.g.length;b=Array(d);for(e=
0;e<d;++e){f=this.g[e];g=a;var h=a.layerStatesArray[e];if(f.yd(g,h)){var l=g.size[0],m=g.size[1];if(tx){var n=tx.canvas;n.width!==l||n.height!==m?tx=ld(l,m):tx.clearRect(0,0,l,m)}else tx=ld(l,m);f.u(g,h,tx);f=tx.getImageData(0,0,l,m)}else f=null;if(f)b[e]=f;else break a}d={};this.b(new ux(vx,a,d));this.C.Cp(b,d,this.oa.bind(this,a))}Te(c.tileQueue,16,16);return this.a};
qx.prototype.oa=function(a,b,c,d){if(!b&&c){b=a.extent;var e=a.viewState.resolution;if(e===this.o.viewState.resolution&&ab(b,this.o.extent)){if(this.a)var f=this.a.Y().getContext("2d");else f=ld(Math.round(jb(b)/e),Math.round(kb(b)/e)),this.a=new dt(b,e,1,this.j,f.canvas);f.putImageData(c,0,0);this.s();this.S=this.f;this.b(new ux(wx,a,d))}}};var tx=null;function sx(a){return a.map(function(a){return yh(a.a)})}
function rx(a){for(var b=a.length,c=Array(b),d=0;d<b;++d){var e=d,f=a[d],g=null;f instanceof Rw?(f=new zw({source:f}),g=new rw(f)):f instanceof dw&&(f=new qw({source:f}),g=new Wv(f));c[e]=g}return c}function ux(a,b,c){Qc.call(this,a);this.extent=b.extent;this.resolution=b.viewState.resolution/b.pixelRatio;this.data=c}v(ux,Qc);qx.prototype.Lc=function(){return null};var vx="beforeoperations",wx="afteroperations";function xx(a){var b=a.layer.indexOf("-");b=yx[-1==b?a.layer:a.layer.slice(0,b)];var c=zx[a.layer];ax.call(this,{attributions:Ax,cacheSize:a.cacheSize,crossOrigin:"anonymous",maxZoom:void 0!=a.maxZoom?a.maxZoom:b.maxZoom,minZoom:void 0!=a.minZoom?a.minZoom:b.minZoom,opaque:c.opaque,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileLoadFunction:a.tileLoadFunction,url:void 0!==a.url?a.url:"https://stamen-tiles-{a-d}.a.ssl.fastly.net/"+a.layer+"/{z}/{x}/{y}."+c.Kb,wrapX:a.wrapX})}v(xx,ax);
var Ax=[new Cc({html:'Map tiles by <a href="https://stamen.com/">Stamen Design</a>, under <a href="https://creativecommons.org/licenses/by/3.0/">CC BY 3.0</a>.'}),px],zx={terrain:{Kb:"jpg",opaque:!0},"terrain-background":{Kb:"jpg",opaque:!0},"terrain-labels":{Kb:"png",opaque:!1},"terrain-lines":{Kb:"png",opaque:!1},"toner-background":{Kb:"png",opaque:!0},toner:{Kb:"png",opaque:!0},"toner-hybrid":{Kb:"png",opaque:!1},"toner-labels":{Kb:"png",opaque:!1},"toner-lines":{Kb:"png",opaque:!1},"toner-lite":{Kb:"png",
opaque:!0},watercolor:{Kb:"jpg",opaque:!0}},yx={terrain:{minZoom:4,maxZoom:18},toner:{minZoom:0,maxZoom:20},watercolor:{minZoom:1,maxZoom:16}};function Bx(a){a=a||{};X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.i=a.params||{};this.o=Ma();Sw(this,Cx(this))}v(Bx,X);function Cx(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}Bx.prototype.B=function(){return this.i};
Bx.prototype.Oc=function(a){return a};
Bx.prototype.Hc=function(a,b,c){var d=this.tileGrid;d||(d=this.Ta(c));if(!(d.b.length<=a[0])){var e=d.Fa(a,this.o),f=Ka(d.eb(a[0]),this.l);1!=b&&(f=Ja(f,b,this.l));d={F:"image",FORMAT:"PNG32",TRANSPARENT:!0};rb(d,this.i);var g=this.urls;g?(c=c.qb.split(":").pop(),d.SIZE=f[0]+","+f[1],d.BBOX=e.join(","),d.BBOXSR=c,d.IMAGESR=c,d.DPI=Math.round(d.DPI?d.DPI*b:90*b),a=(1==g.length?g[0]:g[Ga((a[1]<<a[0])+a[2],g.length)]).replace(/MapServer\/?$/,"MapServer/export").replace(/ImageServer\/?$/,"ImageServer/exportImage"),
a=gx(a,d)):a=void 0;return a}};Bx.prototype.C=function(a){rb(this.i,a);Sw(this,Cx(this))};function Dx(a){Rw.call(this,{opaque:!1,projection:a.projection,tileGrid:a.tileGrid,wrapX:void 0!==a.wrapX?a.wrapX:!0})}v(Dx,Rw);Dx.prototype.Qc=function(a,b,c){var d=this.Rb(a,b,c);if(this.a.b.hasOwnProperty(d))return this.a.get(d);var e=Ka(this.tileGrid.eb(a));a=[a,b,c];b=(b=Tw(this,a))?Tw(this,b).toString():"";e=new Ex(a,e,b);this.a.set(d,e);return e};function Ex(a,b,c){et.call(this,a,2);this.c=b;this.ua=c;this.f=null}v(Ex,et);
Ex.prototype.Y=function(){if(this.f)return this.f;var a=this.c,b=ld(a[0],a[1]);b.strokeStyle="black";b.strokeRect(.5,.5,a[0]+.5,a[1]+.5);b.fillStyle="black";b.textAlign="center";b.textBaseline="middle";b.font="24px sans-serif";b.fillText(this.ua,a[0]/2,a[1]/2);return this.f=b.canvas};Ex.prototype.load=function(){};function Fx(a){this.i=null;X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,projection:Wb("EPSG:3857"),reprojectionErrorThreshold:a.reprojectionErrorThreshold,state:"loading",tileLoadFunction:a.tileLoadFunction,wrapX:void 0!==a.wrapX?a.wrapX:!0});if(a.url)if(a.jsonp)Iw(a.url,this.wg.bind(this),this.ff.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.No.bind(this));b.addEventListener("error",this.Mo.bind(this));b.open("GET",a.url);b.send()}else a.tileJSON?
this.wg(a.tileJSON):va(!1,51)}v(Fx,X);k=Fx.prototype;k.No=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.ff();return}this.wg(b)}else this.ff()};k.Mo=function(){this.ff()};k.Bl=function(){return this.i};
k.wg=function(a){var b=Wb("EPSG:4326"),c=this.c;if(a.bounds){var d=Xb(b,c);var e=qb(a.bounds,d)}var f=a.minzoom||0;d=a.maxzoom||22;this.tileGrid=c=xc({extent:zc(c),maxZoom:d,minZoom:f});this.tileUrlFunction=Lw(a.tiles,c);if(void 0!==a.attribution&&!this.j){b=void 0!==e?e:b.G();e={};for(var g;f<=d;++f)g=f.toString(),e[g]=[pc(c,b,f)];this.wa([new Cc({html:a.attribution,tileRanges:e})])}this.i=a;zu(this,"ready")};k.ff=function(){zu(this,"error")};function Gx(a){Rw.call(this,{projection:Wb("EPSG:3857"),state:"loading"});this.v=void 0!==a.preemptive?a.preemptive:!0;this.o=Nw;this.g=void 0;this.i=a.jsonp||!1;if(a.url)if(this.i)Iw(a.url,this.xg.bind(this),this.gf.bind(this));else{var b=new XMLHttpRequest;b.addEventListener("load",this.Ro.bind(this));b.addEventListener("error",this.Qo.bind(this));b.open("GET",a.url);b.send()}else a.tileJSON?this.xg(a.tileJSON):va(!1,51)}v(Gx,Rw);k=Gx.prototype;
k.Ro=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.gf();return}this.xg(b)}else this.gf()};k.Qo=function(){this.gf()};k.yl=function(){return this.g};k.Kk=function(a,b,c,d,e){this.tileGrid?(b=this.tileGrid.Me(a,b),Hx(this.Qc(b[0],b[1],b[2],1,this.c),a,c,d,e)):!0===e?setTimeout(function(){c.call(d,null)},0):c.call(d,null)};k.gf=function(){zu(this,"error")};
k.xg=function(a){var b=Wb("EPSG:4326"),c=this.c;if(a.bounds){var d=Xb(b,c);var e=qb(a.bounds,d)}var f=a.minzoom||0;d=a.maxzoom||22;this.tileGrid=c=xc({extent:zc(c),maxZoom:d,minZoom:f});this.g=a.template;var g=a.grids;if(g){this.o=Lw(g,c);if(void 0!==a.attribution){b=void 0!==e?e:b.G();for(e={};f<=d;++f)g=f.toString(),e[g]=[pc(c,b,f)];this.wa([new Cc({html:a.attribution,tileRanges:e})])}zu(this,"ready")}else zu(this,"error")};
k.Qc=function(a,b,c,d,e){var f=this.Rb(a,b,c);if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];b=Tw(this,a,e);d=this.o(b,d,e);d=new Ix(a,void 0!==d?0:4,void 0!==d?d:"",this.tileGrid.Fa(a),this.v,this.i);this.a.set(f,d);return d};k.Zg=function(a,b,c){a=this.Rb(a,b,c);this.a.b.hasOwnProperty(a)&&this.a.get(a)};function Ix(a,b,c,d,e,f){et.call(this,a,b);this.l=c;this.f=d;this.v=e;this.c=this.j=this.g=null;this.o=f}v(Ix,et);k=Ix.prototype;k.Y=function(){return null};
k.getData=function(a){if(!this.g||!this.j)return null;var b=this.g[Math.floor((1-(a[1]-this.f[1])/(this.f[3]-this.f[1]))*this.g.length)];if("string"!==typeof b)return null;b=b.charCodeAt(Math.floor((a[0]-this.f[0])/(this.f[2]-this.f[0])*b.length));93<=b&&b--;35<=b&&b--;b-=32;a=null;b in this.j&&(b=this.j[b],this.c&&b in this.c?a=this.c[b]:a=b);return a};
function Hx(a,b,c,d,e){0==a.state&&!0===e?(Lc(a,"change",function(){c.call(d,this.getData(b))},a),Jx(a)):!0===e?setTimeout(function(){c.call(d,this.getData(b))}.bind(a),0):c.call(d,a.getData(b))}k.fb=function(){return this.l};k.Oe=function(){this.state=3;this.s()};k.Ti=function(a){this.g=a.grid;this.j=a.keys;this.c=a.data;this.state=4;this.s()};
function Jx(a){if(0==a.state)if(a.state=1,a.o)Iw(a.l,a.Ti.bind(a),a.Oe.bind(a));else{var b=new XMLHttpRequest;b.addEventListener("load",a.Po.bind(a));b.addEventListener("error",a.Oo.bind(a));b.open("GET",a.l);b.send()}}k.Po=function(a){a=a.target;if(!a.status||200<=a.status&&300>a.status){try{var b=JSON.parse(a.responseText)}catch(c){this.Oe();return}this.Ti(b)}else this.Oe()};k.Oo=function(){this.Oe()};k.load=function(){this.v&&Jx(this)};function Kx(a){a=a||{};var b=a.params||{};X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,opaque:!("TRANSPARENT"in b?b.TRANSPARENT:1),projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:a.tileClass,tileGrid:a.tileGrid,tileLoadFunction:a.tileLoadFunction,url:a.url,urls:a.urls,wrapX:void 0!==a.wrapX?a.wrapX:!0});this.B=void 0!==a.gutter?a.gutter:0;this.i=b;this.o=!0;this.C=a.serverType;this.U=void 0!==a.hidpi?
a.hidpi:!0;this.S="";Lx(this);this.ga=Ma();Mx(this);Sw(this,Nx(this))}v(Kx,X);k=Kx.prototype;
k.So=function(a,b,c,d){c=Wb(c);var e=this.tileGrid;e||(e=this.Ta(c));b=e.Me(a,b);if(!(e.b.length<=b[0])){var f=e.Ca(b[0]),g=e.Fa(b,this.ga);e=Ka(e.eb(b[0]),this.l);var h=this.B;h&&(e=Ia(e,h,this.l),g=Oa(g,f*h,g));h={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetFeatureInfo",FORMAT:"image/png",TRANSPARENT:!0,QUERY_LAYERS:this.i.LAYERS};rb(h,this.i,d);d=Math.floor((g[3]-a[1])/f);h[this.o?"I":"X"]=Math.floor((a[0]-g[0])/f);h[this.o?"J":"Y"]=d;return Ox(this,b,e,g,1,c,h)}};k.cg=function(){return this.B};
k.Rb=function(a,b,c){return this.S+X.prototype.Rb.call(this,a,b,c)};k.To=function(){return this.i};
function Ox(a,b,c,d,e,f,g){var h=a.urls;if(h){g.WIDTH=c[0];g.HEIGHT=c[1];g[a.o?"CRS":"SRS"]=f.qb;"STYLES"in a.i||(g.STYLES="");if(1!=e)switch(a.C){case "geoserver":c=90*e+.5|0;g.FORMAT_OPTIONS="FORMAT_OPTIONS"in g?g.FORMAT_OPTIONS+(";dpi:"+c):"dpi:"+c;break;case "mapserver":g.MAP_RESOLUTION=90*e;break;case "carmentaserver":case "qgis":g.DPI=90*e;break;default:va(!1,52)}f=f.a;a.o&&"ne"==f.substr(0,2)&&(a=d[0],d[0]=d[1],d[1]=a,a=d[2],d[2]=d[3],d[3]=a);g.BBOX=d.join(",");return gx(1==h.length?h[0]:h[Ga((b[1]<<
b[0])+b[2],h.length)],g)}}k.Oc=function(a){return this.U&&void 0!==this.C?a:1};function Lx(a){var b=0,c=[];if(a.urls){var d;var e=0;for(d=a.urls.length;e<d;++e)c[b++]=a.urls[e]}a.S=c.join("#")}function Nx(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
k.Hc=function(a,b,c){var d=this.tileGrid;d||(d=this.Ta(c));if(!(d.b.length<=a[0])){1==b||this.U&&void 0!==this.C||(b=1);var e=d.Ca(a[0]),f=d.Fa(a,this.ga);d=Ka(d.eb(a[0]),this.l);var g=this.B;g&&(d=Ia(d,g,this.l),f=Oa(f,e*g,f));1!=b&&(d=Ja(d,b,this.l));e={SERVICE:"WMS",VERSION:"1.3.0",REQUEST:"GetMap",FORMAT:"image/png",TRANSPARENT:!0};rb(e,this.i);return Ox(this,a,d,f,b,c,e)}};k.ib=function(a){X.prototype.ib.call(this,a);Lx(this)};k.Uo=function(a){rb(this.i,a);Lx(this);Mx(this);Sw(this,Nx(this))};
function Mx(a){a.o=0<=af(a.i.VERSION||"1.3.0")};function Px(a,b,c,d,e,f,g,h,l,m,n,p,q,t){et.call(this,a,b);this.j={};this.l={};this.c=m;this.f=[];this.u=c;this.v=f;this.g=[];this.o=[];if(f){var u=l.Fa(f),x=l.Ca(a[0]);h.Yf(u,h.uc(x),function(a){var b=nb(u,h.Fa(a));if(.5<=jb(b)/x&&.5<=kb(b)/x){b=a.toString();var c=m[b];c||(c=g(a,n,p),c=m[b]=new q(a,void 0==c?4:0,void 0==c?"":c,d,e),this.o.push(y(c,"change",t)));c.g++;this.f.push(b)}}.bind(this))}}v(Px,et);k=Px.prototype;
k.ka=function(){for(var a=0,b=this.f.length;a<b;++a){var c=this.f[a],d=this.c[c];d.g--;d.g||(delete this.c[c],Pc(d))}this.f.length=0;this.c=null;1==this.state&&(this.g.forEach(Gc),this.g.length=0);this.a&&Pc(this.a);this.state=5;this.s();this.o.forEach(Gc);this.o.length=0;et.prototype.ka.call(this)};function Fw(a,b){b=w(b).toString();b in a.j||(a.j[b]=ld());return a.j[b]}k.Y=function(a){return-1==Dw(this,a).Tg?null:Fw(this,a).canvas};
function Dw(a,b){b=w(b).toString();b in a.l||(a.l[b]={Td:!1,Sg:null,xf:-1,Tg:-1});return a.l[b]}k.fb=function(){return this.f.join("/")+"/"+this.u};
k.load=function(){var a=0;0==this.state&&ht(this,1);1==this.state&&this.f.forEach(function(b){var c=this.c[b];0==c.state&&(c.Xg(this.R),c.load());if(1==c.state){var d=y(c,"change",function(){var b=c.getState();if(2==b||3==b){--a;Gc(d);b=this.g;var f=b.indexOf(d);-1<f&&b.splice(f,1);a||this.zh()}}.bind(this));this.g.push(d);++a}}.bind(this));a||setTimeout(this.zh.bind(this),0)};
k.zh=function(){for(var a=!1,b=this.f.length,c,d=b-1;0<=d;--d)c=this.c[this.f[d]].getState(),2!=c&&(3==c&&(a=!0),--b);ht(this,0<b?2:a?3:4)};function Qx(a,b){a.Xg(Wl(b,a.o,a.np.bind(a),a.mp.bind(a)))};function Rx(a,b,c,d,e){et.call(this,a,b);this.g=0;this.l=null;this.o=d;this.c=null;this.j={};this.R=e;this.v=c}v(Rx,et);k=Rx.prototype;k.ka=function(){this.c=null;this.j={};this.state=5;this.s();et.prototype.ka.call(this)};k.G=function(){return this.l||Sx};k.Zm=function(){return this.o};k.Ym=function(){return this.c};k.fb=function(){return this.v};k.$m=function(){return this.f};function Gw(a,b,c){return a.j[w(b)+","+c]}
k.load=function(){0==this.state&&(ht(this,1),this.R(this,this.v),this.u(null,NaN,null))};k.np=function(a,b,c){this.qg(b);this.wj(a);this.hi(c)};k.mp=function(){ht(this,3)};k.hi=function(a){this.l=a};k.wj=function(a){this.c=a;ht(this,2)};k.qg=function(a){this.f=a};k.Xg=function(a){this.u=a};var Sx=[0,0,4096,4096];function Tx(a){var b=a.projection||"EPSG:3857",c=a.extent||zc(b),d=a.tileGrid||xc({extent:c,maxZoom:a.maxZoom||22,minZoom:a.minZoom,tileSize:a.tileSize||512});Vw.call(this,{attributions:a.attributions,cacheSize:void 0!==a.cacheSize?a.cacheSize:128,extent:c,logo:a.logo,opaque:!1,projection:b,state:a.state,tileGrid:d,tileLoadFunction:a.tileLoadFunction?a.tileLoadFunction:Qx,tileUrlFunction:a.tileUrlFunction,url:a.url,urls:a.urls,wrapX:void 0===a.wrapX?!0:a.wrapX});this.g=a.format?a.format:null;this.v=
{};this.o=void 0==a.overlaps?!0:a.overlaps;this.tileClass=a.tileClass?a.tileClass:Rx;this.i={};this.tileGrid||(this.tileGrid=this.Ta(Wb(a.projection||"EPSG:3857")))}v(Tx,Vw);
Tx.prototype.Qc=function(a,b,c,d,e){var f=this.Rb(a,b,c);if(this.a.b.hasOwnProperty(f))return this.a.get(f);a=[a,b,c];c=(b=Tw(this,a,e))?this.tileUrlFunction(b,d,e):void 0;d=new Px(a,void 0!==c?0:4,void 0!==c?c:"",this.g,this.tileLoadFunction,b,this.tileUrlFunction,this.tileGrid,this.Ta(e),this.v,d,e,this.tileClass,this.Vi.bind(this));this.a.set(f,d);return d};Tx.prototype.Ta=function(a){var b=a.qb,c=this.i[b];c||(c=this.tileGrid,c=this.i[b]=wc(a,void 0,c?c.eb(c.minZoom):void 0));return c};
Tx.prototype.Oc=function(a){return a};Tx.prototype.ce=function(a,b,c){a=Ka(this.Ta(c).eb(a));return[Math.round(a[0]*b),Math.round(a[1]*b)]};function Ux(a){this.l=a.matrixIds;mc.call(this,{extent:a.extent,origin:a.origin,origins:a.origins,resolutions:a.resolutions,tileSize:a.tileSize,tileSizes:a.tileSizes,sizes:a.sizes})}v(Ux,mc);Ux.prototype.o=function(){return this.l};
function Vx(a,b,c){var d=[],e=[],f=[],g=[],h=[],l=void 0!==c?c:[];c=Wb(a.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"));var m=c.Nc(),n="ne"==c.a.substr(0,2);a.TileMatrix.sort(function(a,b){return b.ScaleDenominator-a.ScaleDenominator});a.TileMatrix.forEach(function(a){var b;0<l.length?b=la(l,function(b){return a.Identifier==b.TileMatrix}):b=!0;if(b){e.push(a.Identifier);b=2.8E-4*a.ScaleDenominator/m;var c=a.TileWidth,p=a.TileHeight;n?f.push([a.TopLeftCorner[1],a.TopLeftCorner[0]]):
f.push(a.TopLeftCorner);d.push(b);g.push(c==p?c:[c,p]);h.push([a.MatrixWidth,-a.MatrixHeight])}});return new Ux({extent:b,origins:f,resolutions:d,matrixIds:e,tileSizes:g,sizes:h})};function Z(a){function b(a){a="KVP"==d?gx(a,f):a.replace(/\{(\w+?)\}/g,function(a,b){return b.toLowerCase()in f?f[b.toLowerCase()]:a});return function(b){if(b){var c={TileMatrix:e.l[b[0]],TileCol:b[1],TileRow:-b[2]-1};rb(c,g);b=a;return b="KVP"==d?gx(b,c):b.replace(/\{(\w+?)\}/g,function(a,b){return c[b]})}}}this.ga=void 0!==a.version?a.version:"1.0.0";this.B=void 0!==a.format?a.format:"image/jpeg";this.i=a.dimensions?a.dimensions:{};this.C=a.layer;this.o=a.matrixSet;this.S=a.style;var c=a.urls;void 0===
c&&void 0!==a.url&&(c=Ow(a.url));var d=this.U=void 0!==a.requestEncoding?a.requestEncoding:"KVP",e=a.tileGrid,f={layer:this.C,style:this.S,tilematrixset:this.o};"KVP"==d&&rb(f,{Service:"WMTS",Request:"GetTile",Version:this.ga,Format:this.B});var g=this.i,h=c&&0<c.length?Mw(c.map(b)):Nw;X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:a.tileClass,tileGrid:e,
tileLoadFunction:a.tileLoadFunction,tilePixelRatio:a.tilePixelRatio,tileUrlFunction:h,urls:c,wrapX:void 0!==a.wrapX?a.wrapX:!1});Sw(this,Wx(this))}v(Z,X);k=Z.prototype;k.Xk=function(){return this.i};k.Vo=function(){return this.B};k.Wo=function(){return this.C};k.ll=function(){return this.o};k.wl=function(){return this.U};k.Xo=function(){return this.S};k.Dl=function(){return this.ga};function Wx(a){var b=0,c=[],d;for(d in a.i)c[b++]=d+"-"+a.i[d];return c.join("/")}
k.Iq=function(a){rb(this.i,a);Sw(this,Wx(this))};function Xx(a){a=a||{};var b=a.size,c=b[0],d=b[1],e=[],f=256;switch(void 0!==a.tierSizeCalculation?a.tierSizeCalculation:Yx){case Yx:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),f+=f;break;case Zx:for(;c>f||d>f;)e.push([Math.ceil(c/f),Math.ceil(d/f)]),c>>=1,d>>=1;break;default:va(!1,53)}e.push([1,1]);e.reverse();f=[1];var g=[0];d=1;for(c=e.length;d<c;d++)f.push(1<<d),g.push(e[d-1][0]*e[d-1][1]+g[d-1]);f.reverse();b=[0,-b[1],b[0],0];b=new mc({extent:b,origin:gb(b),resolutions:f});(f=a.url)&&
-1==f.indexOf("{TileGroup}")&&(f+="{TileGroup}/{z}-{x}-{y}.jpg");f=Ow(f);f=Mw(f.map(function(a){return function(b){if(b){var c=b[0],d=b[1];b=-b[2]-1;var f={z:c,x:d,y:b,TileGroup:"TileGroup"+((d+b*e[c][0]+g[c])/256|0)};return a.replace(/\{(\w+?)\}/g,function(a,b){return f[b]})}}}));X.call(this,{attributions:a.attributions,cacheSize:a.cacheSize,crossOrigin:a.crossOrigin,logo:a.logo,projection:a.projection,reprojectionErrorThreshold:a.reprojectionErrorThreshold,tileClass:$x,tileGrid:b,tileUrlFunction:f})}
v(Xx,X);function $x(a,b,c,d,e){it.call(this,a,b,c,d,e);this.f=null}v($x,it);$x.prototype.Y=function(){if(this.f)return this.f;var a=it.prototype.Y.call(this);if(2==this.state){if(256==a.width&&256==a.height)return this.f=a;var b=ld(256,256);b.drawImage(a,0,0);return this.f=b.canvas}return a};var Yx="default",Zx="truncated";ua.prototype.code=ua.prototype.code;r("ol.Attribution",Cc);Cc.prototype.getHTML=Cc.prototype.f;r("ol.Collection",$c);$c.prototype.clear=$c.prototype.clear;$c.prototype.extend=$c.prototype.ng;$c.prototype.forEach=$c.prototype.forEach;$c.prototype.getArray=$c.prototype.Hm;$c.prototype.item=$c.prototype.item;$c.prototype.getLength=$c.prototype.ec;$c.prototype.insertAt=$c.prototype.Se;$c.prototype.pop=$c.prototype.pop;$c.prototype.push=$c.prototype.push;$c.prototype.remove=$c.prototype.remove;
$c.prototype.removeAt=$c.prototype.Pg;$c.prototype.setAt=$c.prototype.jq;dd.prototype.element=dd.prototype.element;r("ol.color.asArray",gd);r("ol.color.asString",id);r("ol.colorlike.asColorLike",kd);r("ol.control.defaults",zd);r("ol.coordinate.add",bf);r("ol.coordinate.createStringXY",function(a){return function(b){return nf(b,a)}});r("ol.coordinate.format",ff);r("ol.coordinate.rotate",hf);r("ol.coordinate.toStringHDMS",function(a,b){return a?ef("NS",a[1],b)+" "+ef("EW",a[0],b):""});
r("ol.coordinate.toStringXY",nf);r("ol.DeviceOrientation",jl);jl.prototype.getAlpha=jl.prototype.Qk;jl.prototype.getBeta=jl.prototype.Tk;jl.prototype.getGamma=jl.prototype.$k;jl.prototype.getHeading=jl.prototype.Im;jl.prototype.getTracking=jl.prototype.bi;jl.prototype.setTracking=jl.prototype.og;r("ol.easing.easeIn",sd);r("ol.easing.easeOut",td);r("ol.easing.inAndOut",ud);r("ol.easing.linear",vd);r("ol.easing.upAndDown",function(a){return.5>a?ud(2*a):1-ud(2*(a-.5))});
r("ol.extent.boundingExtent",La);r("ol.extent.buffer",Oa);r("ol.extent.containsCoordinate",Ra);r("ol.extent.containsExtent",Ta);r("ol.extent.containsXY",Sa);r("ol.extent.createEmpty",Ma);r("ol.extent.equals",ab);r("ol.extent.extend",bb);r("ol.extent.getArea",hb);r("ol.extent.getBottomLeft",db);r("ol.extent.getBottomRight",eb);r("ol.extent.getCenter",lb);r("ol.extent.getHeight",kb);r("ol.extent.getIntersection",nb);r("ol.extent.getSize",function(a){return[a[2]-a[0],a[3]-a[1]]});
r("ol.extent.getTopLeft",gb);r("ol.extent.getTopRight",fb);r("ol.extent.getWidth",jb);r("ol.extent.intersects",ob);r("ol.extent.isEmpty",ib);r("ol.extent.applyTransform",qb);r("ol.Feature",Bl);Bl.prototype.clone=Bl.prototype.clone;Bl.prototype.getGeometry=Bl.prototype.W;Bl.prototype.getId=Bl.prototype.Km;Bl.prototype.getGeometryName=Bl.prototype.bl;Bl.prototype.getStyle=Bl.prototype.Lm;Bl.prototype.getStyleFunction=Bl.prototype.bb;Bl.prototype.setGeometry=Bl.prototype.Ra;Bl.prototype.setStyle=Bl.prototype.pg;
Bl.prototype.setId=Bl.prototype.kc;Bl.prototype.setGeometryName=Bl.prototype.Wc;r("ol.featureloader.xhr",Xl);r("ol.Geolocation",Rs);Rs.prototype.getAccuracy=Rs.prototype.Ok;Rs.prototype.getAccuracyGeometry=Rs.prototype.Pk;Rs.prototype.getAltitude=Rs.prototype.Rk;Rs.prototype.getAltitudeAccuracy=Rs.prototype.Sk;Rs.prototype.getHeading=Rs.prototype.Mm;Rs.prototype.getPosition=Rs.prototype.Nm;Rs.prototype.getProjection=Rs.prototype.ci;Rs.prototype.getSpeed=Rs.prototype.xl;Rs.prototype.getTracking=Rs.prototype.di;
Rs.prototype.getTrackingOptions=Rs.prototype.Ph;Rs.prototype.setProjection=Rs.prototype.ei;Rs.prototype.setTracking=Rs.prototype.Ve;Rs.prototype.setTrackingOptions=Rs.prototype.Gj;r("ol.Graticule",Xs);Xs.prototype.getMap=Xs.prototype.Qm;Xs.prototype.getMeridians=Xs.prototype.ml;Xs.prototype.getParallels=Xs.prototype.tl;Xs.prototype.setMap=Xs.prototype.setMap;r("ol.has.DEVICE_PIXEL_RATIO",Ud);r("ol.has.CANVAS",Wd);r("ol.has.DEVICE_ORIENTATION",Xd);r("ol.has.GEOLOCATION",Yd);r("ol.has.TOUCH",Zd);
r("ol.has.WEBGL",Od);ct.prototype.getImage=ct.prototype.Y;ct.prototype.load=ct.prototype.load;it.prototype.getImage=it.prototype.Y;r("ol.inherits",v);r("ol.interaction.defaults",wh);r("ol.Kinetic",pg);r("ol.loadingstrategy.all",wu);r("ol.loadingstrategy.bbox",function(a){return[a]});r("ol.loadingstrategy.tile",function(a){return function(b,c){c=a.uc(c);b=pc(a,b,c);var d=[];c=[c,0,0];for(c[1]=b.ca;c[1]<=b.da;++c[1])for(c[2]=b.ea;c[2]<=b.ha;++c[2])d.push(a.Fa(c));return d}});r("ol.Map",H);
H.prototype.addControl=H.prototype.vk;H.prototype.addInteraction=H.prototype.wk;H.prototype.addLayer=H.prototype.nh;H.prototype.addOverlay=H.prototype.oh;H.prototype.forEachFeatureAtPixel=H.prototype.Wd;H.prototype.getFeaturesAtPixel=H.prototype.Yk;H.prototype.forEachLayerAtPixel=H.prototype.Wm;H.prototype.hasFeatureAtPixel=H.prototype.lm;H.prototype.getEventCoordinate=H.prototype.$f;H.prototype.getEventPixel=H.prototype.He;H.prototype.getTarget=H.prototype.ig;H.prototype.getTargetElement=H.prototype.pd;
H.prototype.getCoordinateFromPixel=H.prototype.Xa;H.prototype.getControls=H.prototype.Wk;H.prototype.getOverlays=H.prototype.rl;H.prototype.getOverlayById=H.prototype.ql;H.prototype.getInteractions=H.prototype.dl;H.prototype.getLayerGroup=H.prototype.Mc;H.prototype.getLayers=H.prototype.fi;H.prototype.getPixelFromCoordinate=H.prototype.Ka;H.prototype.getSize=H.prototype.Mb;H.prototype.getView=H.prototype.$;H.prototype.getViewport=H.prototype.El;H.prototype.renderSync=H.prototype.gq;
H.prototype.render=H.prototype.render;H.prototype.removeControl=H.prototype.Zp;H.prototype.removeInteraction=H.prototype.$p;H.prototype.removeLayer=H.prototype.bq;H.prototype.removeOverlay=H.prototype.cq;H.prototype.setLayerGroup=H.prototype.Aj;H.prototype.setSize=H.prototype.Yg;H.prototype.setTarget=H.prototype.We;H.prototype.setView=H.prototype.wq;H.prototype.updateSize=H.prototype.Fd;Ld.prototype.originalEvent=Ld.prototype.originalEvent;Ld.prototype.pixel=Ld.prototype.pixel;
Ld.prototype.coordinate=Ld.prototype.coordinate;Ld.prototype.dragging=Ld.prototype.dragging;Kd.prototype.map=Kd.prototype.map;Kd.prototype.frameState=Kd.prototype.frameState;r("ol.Object",Vc);Vc.prototype.get=Vc.prototype.get;Vc.prototype.getKeys=Vc.prototype.O;Vc.prototype.getProperties=Vc.prototype.N;Vc.prototype.set=Vc.prototype.set;Vc.prototype.setProperties=Vc.prototype.H;Vc.prototype.unset=Vc.prototype.P;Zc.prototype.key=Zc.prototype.key;Zc.prototype.oldValue=Zc.prototype.oldValue;
r("ol.Observable",Uc);r("ol.Observable.unByKey",function(a){if(Array.isArray(a))for(var b=0,c=a.length;b<c;++b)Gc(a[b]);else Gc(a)});Uc.prototype.changed=Uc.prototype.s;Uc.prototype.dispatchEvent=Uc.prototype.b;Uc.prototype.getRevision=Uc.prototype.L;Uc.prototype.on=Uc.prototype.J;Uc.prototype.once=Uc.prototype.once;Uc.prototype.un=Uc.prototype.K;r("ol.Overlay",Lk);Lk.prototype.getElement=Lk.prototype.Yd;Lk.prototype.getId=Lk.prototype.Xm;Lk.prototype.getMap=Lk.prototype.Xe;
Lk.prototype.getOffset=Lk.prototype.Lh;Lk.prototype.getPosition=Lk.prototype.gi;Lk.prototype.getPositioning=Lk.prototype.Mh;Lk.prototype.setElement=Lk.prototype.vj;Lk.prototype.setMap=Lk.prototype.setMap;Lk.prototype.setOffset=Lk.prototype.Bj;Lk.prototype.setPosition=Lk.prototype.Ye;Lk.prototype.setPositioning=Lk.prototype.Ej;r("ol.proj.METERS_PER_UNIT",Bb);r("ol.proj.setProj4",function(a){Cb=a});r("ol.proj.getPointResolution",Ub);r("ol.proj.addEquivalentProjections",Yb);
r("ol.proj.addProjection",Zb);r("ol.proj.addCoordinateTransforms",cc);r("ol.proj.fromLonLat",function(a,b){return hc(a,"EPSG:4326",void 0!==b?b:"EPSG:3857")});r("ol.proj.toLonLat",function(a,b){return hc(a,void 0!==b?b:"EPSG:3857","EPSG:4326")});r("ol.proj.get",Wb);r("ol.proj.equivalent",ec);r("ol.proj.getTransform",fc);r("ol.proj.transform",hc);r("ol.proj.transformExtent",ic);
r("ol.render.toContext",function(a,b){var c=a.canvas,d=b?b:{};b=d.pixelRatio||Ud;if(d=d.size)c.width=d[0]*b,c.height=d[1]*b,c.style.width=d[0]+"px",c.style.height=d[1]+"px";c=[0,0,c.width,c.height];d=Ph(Ih(),b,b);return new di(a,b,c,d,0)});r("ol.size.toSize",Ka);r("ol.Sphere",vb);vb.prototype.geodesicArea=vb.prototype.a;vb.prototype.haversineDistance=vb.prototype.b;r("ol.Sphere.getLength",yb);r("ol.Sphere.getArea",Ab);et.prototype.getTileCoord=et.prototype.i;et.prototype.load=et.prototype.load;
r("ol.tilegrid.createXYZ",xc);Rx.prototype.getFormat=Rx.prototype.Zm;Rx.prototype.getFeatures=Rx.prototype.Ym;Rx.prototype.getProjection=Rx.prototype.$m;Rx.prototype.setExtent=Rx.prototype.hi;Rx.prototype.setFeatures=Rx.prototype.wj;Rx.prototype.setProjection=Rx.prototype.qg;Rx.prototype.setLoader=Rx.prototype.Xg;r("ol.View",F);F.prototype.animate=F.prototype.animate;F.prototype.getAnimating=F.prototype.Kc;F.prototype.getInteracting=F.prototype.cl;F.prototype.cancelAnimations=F.prototype.hd;
F.prototype.constrainCenter=F.prototype.Gc;F.prototype.constrainResolution=F.prototype.constrainResolution;F.prototype.constrainRotation=F.prototype.constrainRotation;F.prototype.getCenter=F.prototype.xa;F.prototype.calculateExtent=F.prototype.gd;F.prototype.getMaxResolution=F.prototype.an;F.prototype.getMinResolution=F.prototype.cn;F.prototype.getMaxZoom=F.prototype.bn;F.prototype.setMaxZoom=F.prototype.rq;F.prototype.getMinZoom=F.prototype.dn;F.prototype.setMinZoom=F.prototype.sq;
F.prototype.getProjection=F.prototype.en;F.prototype.getResolution=F.prototype.Pa;F.prototype.getResolutions=F.prototype.fn;F.prototype.getResolutionForExtent=F.prototype.Ke;F.prototype.getRotation=F.prototype.Qa;F.prototype.getZoom=F.prototype.Qh;F.prototype.getZoomForResolution=F.prototype.Ne;F.prototype.getResolutionForZoom=F.prototype.Oh;F.prototype.fit=F.prototype.Xf;F.prototype.centerOn=F.prototype.Fk;F.prototype.rotate=F.prototype.rotate;F.prototype.setCenter=F.prototype.rb;
F.prototype.setResolution=F.prototype.Yc;F.prototype.setRotation=F.prototype.Ze;F.prototype.setZoom=F.prototype.zq;r("ol.xml.getAllTextContent",Fl);r("ol.xml.parse",Jl);Vi.prototype.getGL=Vi.prototype.jp;Vi.prototype.useProgram=Vi.prototype.Tc;r("ol.tilegrid.TileGrid",mc);mc.prototype.forEachTileCoord=mc.prototype.Yf;mc.prototype.getMaxZoom=mc.prototype.cj;mc.prototype.getMinZoom=mc.prototype.dj;mc.prototype.getOrigin=mc.prototype.Sc;mc.prototype.getResolution=mc.prototype.Ca;
mc.prototype.getResolutions=mc.prototype.ej;mc.prototype.getTileCoordExtent=mc.prototype.Fa;mc.prototype.getTileCoordForCoordAndResolution=mc.prototype.Me;mc.prototype.getTileCoordForCoordAndZ=mc.prototype.kg;mc.prototype.getTileSize=mc.prototype.eb;mc.prototype.getZForResolution=mc.prototype.uc;r("ol.tilegrid.WMTS",Ux);Ux.prototype.getMatrixIds=Ux.prototype.o;r("ol.tilegrid.WMTS.createFromCapabilitiesMatrixSet",Vx);r("ol.style.AtlasManager",nk);r("ol.style.Circle",tl);tl.prototype.setRadius=tl.prototype.Xc;
r("ol.style.Fill",ul);ul.prototype.clone=ul.prototype.clone;ul.prototype.getColor=ul.prototype.f;ul.prototype.setColor=ul.prototype.c;r("ol.style.Icon",yo);yo.prototype.clone=yo.prototype.clone;yo.prototype.getAnchor=yo.prototype.Jc;yo.prototype.getColor=yo.prototype.Yo;yo.prototype.getImage=yo.prototype.Y;yo.prototype.getOrigin=yo.prototype.Rc;yo.prototype.getSrc=yo.prototype.Zo;yo.prototype.getSize=yo.prototype.ic;yo.prototype.load=yo.prototype.load;r("ol.style.Image",ql);
ql.prototype.getOpacity=ql.prototype.jf;ql.prototype.getRotateWithView=ql.prototype.kf;ql.prototype.getRotation=ql.prototype.lf;ql.prototype.getScale=ql.prototype.mf;ql.prototype.getSnapToPixel=ql.prototype.Le;ql.prototype.setOpacity=ql.prototype.zd;ql.prototype.setRotation=ql.prototype.nf;ql.prototype.setScale=ql.prototype.Ad;r("ol.style.RegularShape",rl);rl.prototype.clone=rl.prototype.clone;rl.prototype.getAnchor=rl.prototype.Jc;rl.prototype.getAngle=rl.prototype.Zi;rl.prototype.getFill=rl.prototype.Da;
rl.prototype.getImage=rl.prototype.Y;rl.prototype.getOrigin=rl.prototype.Rc;rl.prototype.getPoints=rl.prototype.$i;rl.prototype.getRadius=rl.prototype.aj;rl.prototype.getRadius2=rl.prototype.Nh;rl.prototype.getSize=rl.prototype.ic;rl.prototype.getStroke=rl.prototype.Ea;r("ol.style.Stroke",Ej);Ej.prototype.clone=Ej.prototype.clone;Ej.prototype.getColor=Ej.prototype.$o;Ej.prototype.getLineCap=Ej.prototype.gl;Ej.prototype.getLineDash=Ej.prototype.ap;Ej.prototype.getLineDashOffset=Ej.prototype.hl;
Ej.prototype.getLineJoin=Ej.prototype.il;Ej.prototype.getMiterLimit=Ej.prototype.nl;Ej.prototype.getWidth=Ej.prototype.bp;Ej.prototype.setColor=Ej.prototype.cp;Ej.prototype.setLineCap=Ej.prototype.oq;Ej.prototype.setLineDash=Ej.prototype.setLineDash;Ej.prototype.setLineDashOffset=Ej.prototype.pq;Ej.prototype.setLineJoin=Ej.prototype.qq;Ej.prototype.setMiterLimit=Ej.prototype.tq;Ej.prototype.setWidth=Ej.prototype.xq;r("ol.style.Style",vl);vl.prototype.clone=vl.prototype.clone;
vl.prototype.getRenderer=vl.prototype.Je;vl.prototype.setRenderer=vl.prototype.uq;vl.prototype.getGeometry=vl.prototype.W;vl.prototype.getGeometryFunction=vl.prototype.al;vl.prototype.getFill=vl.prototype.Da;vl.prototype.setFill=vl.prototype.zf;vl.prototype.getImage=vl.prototype.Y;vl.prototype.setImage=vl.prototype.Wg;vl.prototype.getStroke=vl.prototype.Ea;vl.prototype.setStroke=vl.prototype.Af;vl.prototype.getText=vl.prototype.Ja;vl.prototype.setText=vl.prototype.Dd;vl.prototype.getZIndex=vl.prototype.za;
vl.prototype.setGeometry=vl.prototype.Ra;vl.prototype.setZIndex=vl.prototype.Wb;r("ol.style.Text",zo);zo.prototype.clone=zo.prototype.clone;zo.prototype.getFont=zo.prototype.Zk;zo.prototype.getOffsetX=zo.prototype.ol;zo.prototype.getOffsetY=zo.prototype.pl;zo.prototype.getFill=zo.prototype.Da;zo.prototype.getRotateWithView=zo.prototype.ep;zo.prototype.getRotation=zo.prototype.fp;zo.prototype.getScale=zo.prototype.gp;zo.prototype.getStroke=zo.prototype.Ea;zo.prototype.getText=zo.prototype.Ja;
zo.prototype.getTextAlign=zo.prototype.zl;zo.prototype.getTextBaseline=zo.prototype.Al;zo.prototype.setFont=zo.prototype.xj;zo.prototype.setOffsetX=zo.prototype.Cj;zo.prototype.setOffsetY=zo.prototype.Dj;zo.prototype.setFill=zo.prototype.zf;zo.prototype.setRotation=zo.prototype.hp;zo.prototype.setScale=zo.prototype.bj;zo.prototype.setStroke=zo.prototype.Af;zo.prototype.setText=zo.prototype.Dd;zo.prototype.setTextAlign=zo.prototype.Fj;zo.prototype.setTextBaseline=zo.prototype.vq;
r("ol.source.BingMaps",Zw);r("ol.source.BingMaps.TOS_ATTRIBUTION",$w);Zw.prototype.getApiKey=Zw.prototype.U;Zw.prototype.getImagerySet=Zw.prototype.ga;r("ol.source.CartoDB",bx);bx.prototype.getConfig=bx.prototype.Vk;bx.prototype.updateConfig=bx.prototype.Hq;bx.prototype.setConfig=bx.prototype.kq;r("ol.source.Cluster",Y);Y.prototype.getDistance=Y.prototype.po;Y.prototype.getSource=Y.prototype.qo;Y.prototype.setDistance=Y.prototype.lq;r("ol.source.Image",dw);fw.prototype.image=fw.prototype.image;
r("ol.source.ImageArcGISRest",hx);hx.prototype.getParams=hx.prototype.so;hx.prototype.getImageLoadFunction=hx.prototype.ro;hx.prototype.getUrl=hx.prototype.to;hx.prototype.setImageLoadFunction=hx.prototype.uo;hx.prototype.setUrl=hx.prototype.vo;hx.prototype.updateParams=hx.prototype.wo;r("ol.source.ImageCanvas",kw);r("ol.source.ImageMapGuide",ix);ix.prototype.getParams=ix.prototype.yo;ix.prototype.getImageLoadFunction=ix.prototype.xo;ix.prototype.updateParams=ix.prototype.Ao;
ix.prototype.setImageLoadFunction=ix.prototype.zo;r("ol.source.ImageStatic",jx);r("ol.source.ImageVector",lw);lw.prototype.getSource=lw.prototype.Bo;lw.prototype.getStyle=lw.prototype.Co;lw.prototype.getStyleFunction=lw.prototype.bb;lw.prototype.setStyle=lw.prototype.Si;r("ol.source.ImageWMS",kx);kx.prototype.getGetFeatureInfoUrl=kx.prototype.Fo;kx.prototype.getParams=kx.prototype.Ho;kx.prototype.getImageLoadFunction=kx.prototype.Go;kx.prototype.getUrl=kx.prototype.Io;
kx.prototype.setImageLoadFunction=kx.prototype.Jo;kx.prototype.setUrl=kx.prototype.Ko;kx.prototype.updateParams=kx.prototype.Lo;r("ol.source.OSM",ox);r("ol.source.OSM.ATTRIBUTION",px);r("ol.source.Raster",qx);qx.prototype.setOperation=qx.prototype.v;ux.prototype.extent=ux.prototype.extent;ux.prototype.resolution=ux.prototype.resolution;ux.prototype.data=ux.prototype.data;r("ol.source.Source",xu);xu.prototype.getAttributions=xu.prototype.Aa;xu.prototype.getLogo=xu.prototype.ya;
xu.prototype.getProjection=xu.prototype.Ba;xu.prototype.getState=xu.prototype.getState;xu.prototype.refresh=xu.prototype.ra;xu.prototype.setAttributions=xu.prototype.wa;r("ol.source.Stamen",xx);r("ol.source.Tile",Rw);Rw.prototype.getTileGrid=Rw.prototype.cb;Uw.prototype.tile=Uw.prototype.tile;r("ol.source.TileArcGISRest",Bx);Bx.prototype.getParams=Bx.prototype.B;Bx.prototype.updateParams=Bx.prototype.C;r("ol.source.TileDebug",Dx);r("ol.source.TileImage",X);X.prototype.setRenderReprojectionEdges=X.prototype.Nb;
X.prototype.setTileGridForProjection=X.prototype.Ob;r("ol.source.TileJSON",Fx);Fx.prototype.getTileJSON=Fx.prototype.Bl;r("ol.source.TileUTFGrid",Gx);Gx.prototype.getTemplate=Gx.prototype.yl;Gx.prototype.forDataAtCoordinateAndResolution=Gx.prototype.Kk;r("ol.source.TileWMS",Kx);Kx.prototype.getGetFeatureInfoUrl=Kx.prototype.So;Kx.prototype.getParams=Kx.prototype.To;Kx.prototype.updateParams=Kx.prototype.Uo;Vw.prototype.getTileLoadFunction=Vw.prototype.tb;Vw.prototype.getTileUrlFunction=Vw.prototype.ub;
Vw.prototype.getUrls=Vw.prototype.vb;Vw.prototype.setTileLoadFunction=Vw.prototype.zb;Vw.prototype.setTileUrlFunction=Vw.prototype.hb;Vw.prototype.setUrl=Vw.prototype.nb;Vw.prototype.setUrls=Vw.prototype.ib;r("ol.source.Vector",V);V.prototype.addFeature=V.prototype.Bb;V.prototype.addFeatures=V.prototype.Ec;V.prototype.clear=V.prototype.clear;V.prototype.forEachFeature=V.prototype.Ah;V.prototype.forEachFeatureInExtent=V.prototype.ac;V.prototype.forEachFeatureIntersectingExtent=V.prototype.Bh;
V.prototype.getFeaturesCollection=V.prototype.Ih;V.prototype.getFeatures=V.prototype.fe;V.prototype.getFeaturesAtCoordinate=V.prototype.Hh;V.prototype.getFeaturesInExtent=V.prototype.ag;V.prototype.getClosestFeatureToCoordinate=V.prototype.Dh;V.prototype.getExtent=V.prototype.G;V.prototype.getFeatureById=V.prototype.Gh;V.prototype.getFormat=V.prototype.Wi;V.prototype.getUrl=V.prototype.Xi;V.prototype.removeFeature=V.prototype.Fb;Eu.prototype.feature=Eu.prototype.feature;r("ol.source.VectorTile",Tx);
r("ol.source.WMTS",Z);Z.prototype.getDimensions=Z.prototype.Xk;Z.prototype.getFormat=Z.prototype.Vo;Z.prototype.getLayer=Z.prototype.Wo;Z.prototype.getMatrixSet=Z.prototype.ll;Z.prototype.getRequestEncoding=Z.prototype.wl;Z.prototype.getStyle=Z.prototype.Xo;Z.prototype.getVersion=Z.prototype.Dl;Z.prototype.updateDimensions=Z.prototype.Iq;
r("ol.source.WMTS.optionsFromCapabilities",function(a,b){var c=la(a.Contents.Layer,function(a){return a.Identifier==b.layer});if(null===c)return null;var d=a.Contents.TileMatrixSet;var e=1<c.TileMatrixSetLink.length?"projection"in b?pa(c.TileMatrixSetLink,function(a){var c=la(d,function(b){return b.Identifier==a.TileMatrixSet}).SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"),e=Wb(c),f=Wb(b.projection);return e&&f?ec(e,f):c==b.projection}):pa(c.TileMatrixSetLink,function(a){return a.TileMatrixSet==
b.matrixSet}):0;0>e&&(e=0);var f=c.TileMatrixSetLink[e].TileMatrixSet;var g=c.TileMatrixSetLink[e].TileMatrixSetLimits;var h=c.Format[0];"format"in b&&(h=b.format);e=pa(c.Style,function(a){return"style"in b?a.Title==b.style:a.isDefault});0>e&&(e=0);e=c.Style[e].Identifier;var l={};"Dimension"in c&&c.Dimension.forEach(function(a){var b=a.Identifier,c=a.Default;void 0===c&&(c=a.Value[0]);l[b]=c});var m=la(a.Contents.TileMatrixSet,function(a){return a.Identifier==f});var n="projection"in b?Wb(b.projection):
Wb(m.SupportedCRS.replace(/urn:ogc:def:crs:(\w+):(.*:)?(\w+)$/,"$1:$3"));var p=c.WGS84BoundingBox;if(void 0!==p){var q=Wb("EPSG:4326").G();q=p[0]==q[0]&&p[2]==q[2];var t=ic(p,"EPSG:4326",n);(p=n.G())&&(Ta(p,t)||(t=void 0))}g=Vx(m,t,g);var u=[];m=b.requestEncoding;m=void 0!==m?m:"";if("OperationsMetadata"in a&&"GetTile"in a.OperationsMetadata)for(a=a.OperationsMetadata.GetTile.DCP.HTTP.Get,t=0,p=a.length;t<p;++t){var x=la(a[t].Constraint,function(a){return"GetEncoding"==a.name}).AllowedValues.Value;
""===m&&(m=x[0]);if("KVP"===m)ha(x,"KVP")&&u.push(a[t].href);else break}u.length||(m="REST",c.ResourceURL.forEach(function(a){"tile"===a.resourceType&&(h=a.format,u.push(a.template))}));return{urls:u,layer:b.layer,matrixSet:f,format:h,projection:n,requestEncoding:m,tileGrid:g,style:e,dimensions:l,wrapX:q,crossOrigin:b.crossOrigin}});r("ol.source.XYZ",ax);r("ol.source.Zoomify",Xx);Yh.prototype.vectorContext=Yh.prototype.vectorContext;Yh.prototype.frameState=Yh.prototype.frameState;
Yh.prototype.context=Yh.prototype.context;Yh.prototype.glContext=Yh.prototype.glContext;Eq.prototype.get=Eq.prototype.get;Eq.prototype.getExtent=Eq.prototype.G;Eq.prototype.getId=Eq.prototype.lo;Eq.prototype.getGeometry=Eq.prototype.W;Eq.prototype.getProperties=Eq.prototype.mo;Eq.prototype.getType=Eq.prototype.T;r("ol.render.VectorContext",ci);Ck.prototype.setStyle=Ck.prototype.xd;Ck.prototype.drawGeometry=Ck.prototype.Cb;Ck.prototype.drawFeature=Ck.prototype.Ee;di.prototype.drawCircle=di.prototype.$b;
di.prototype.setStyle=di.prototype.xd;di.prototype.drawGeometry=di.prototype.Cb;di.prototype.drawFeature=di.prototype.Ee;r("ol.proj.common.add",jc);r("ol.proj.Projection",Db);Db.prototype.getCode=Db.prototype.Uk;Db.prototype.getExtent=Db.prototype.G;Db.prototype.getUnits=Db.prototype.jo;Db.prototype.getMetersPerUnit=Db.prototype.Nc;Db.prototype.getWorldExtent=Db.prototype.Fl;Db.prototype.isGlobal=Db.prototype.rm;Db.prototype.setGlobal=Db.prototype.nq;Db.prototype.setExtent=Db.prototype.ko;
Db.prototype.setWorldExtent=Db.prototype.yq;Db.prototype.setGetPointResolution=Db.prototype.mq;r("ol.proj.Units.METERS_PER_UNIT",Bb);r("ol.layer.Base",xh);xh.prototype.getExtent=xh.prototype.G;xh.prototype.getMaxResolution=xh.prototype.fc;xh.prototype.getMinResolution=xh.prototype.gc;xh.prototype.getOpacity=xh.prototype.hc;xh.prototype.getVisible=xh.prototype.Sb;xh.prototype.getZIndex=xh.prototype.za;xh.prototype.setExtent=xh.prototype.xc;xh.prototype.setMaxResolution=xh.prototype.Bc;
xh.prototype.setMinResolution=xh.prototype.Cc;xh.prototype.setOpacity=xh.prototype.yc;xh.prototype.setVisible=xh.prototype.zc;xh.prototype.setZIndex=xh.prototype.Wb;r("ol.layer.Group",zh);zh.prototype.getLayers=zh.prototype.wd;zh.prototype.setLayers=zh.prototype.Hi;r("ol.layer.Heatmap",W);W.prototype.getBlur=W.prototype.Ch;W.prototype.getGradient=W.prototype.Jh;W.prototype.getRadius=W.prototype.Ii;W.prototype.setBlur=W.prototype.tj;W.prototype.setGradient=W.prototype.zj;W.prototype.setRadius=W.prototype.Xc;
r("ol.layer.Image",qw);qw.prototype.getSource=qw.prototype.ia;r("ol.layer.Layer",Dh);Dh.prototype.getSource=Dh.prototype.ia;Dh.prototype.setMap=Dh.prototype.setMap;Dh.prototype.setSource=Dh.prototype.Zc;r("ol.layer.Tile",zw);zw.prototype.getPreload=zw.prototype.md;zw.prototype.getSource=zw.prototype.ia;zw.prototype.setPreload=zw.prototype.Ji;zw.prototype.getUseInterimTilesOnError=zw.prototype.qd;zw.prototype.setUseInterimTilesOnError=zw.prototype.Ki;r("ol.layer.Vector",S);S.prototype.getSource=S.prototype.ia;
S.prototype.getStyle=S.prototype.u;S.prototype.getStyleFunction=S.prototype.bb;S.prototype.setStyle=S.prototype.i;r("ol.layer.VectorTile",Hw);Hw.prototype.getPreload=Hw.prototype.md;Hw.prototype.getUseInterimTilesOnError=Hw.prototype.qd;Hw.prototype.setPreload=Hw.prototype.Li;Hw.prototype.setUseInterimTilesOnError=Hw.prototype.Mi;Hw.prototype.getSource=Hw.prototype.ia;r("ol.interaction.DoubleClickZoom",wg);r("ol.interaction.DoubleClickZoom.handleEvent",xg);r("ol.interaction.DragAndDrop",mt);
r("ol.interaction.DragAndDrop.handleEvent",pf);pt.prototype.features=pt.prototype.features;pt.prototype.file=pt.prototype.file;pt.prototype.projection=pt.prototype.projection;r("ol.interaction.DragBox",Xg);Xg.prototype.getGeometry=Xg.prototype.W;bh.prototype.coordinate=bh.prototype.coordinate;bh.prototype.mapBrowserEvent=bh.prototype.mapBrowserEvent;r("ol.interaction.DragPan",Mg);r("ol.interaction.DragRotate",Qg);r("ol.interaction.DragRotateAndZoom",tt);r("ol.interaction.DragZoom",fh);
r("ol.interaction.Draw",Hu);r("ol.interaction.Draw.handleEvent",Ju);Hu.prototype.removeLastPoint=Hu.prototype.aq;Hu.prototype.finishDrawing=Hu.prototype.Vd;Hu.prototype.extend=Hu.prototype.Jn;r("ol.interaction.Draw.createRegularPolygon",function(a,b){return function(c,d){var e=c[0];c=c[1];var f=Math.sqrt(kf(e,c));d=d?d:dg(new Ss(e),a);eg(d,e,f,b?b:Math.atan((c[1]-e[1])/(c[0]-e[0])));return d}});
r("ol.interaction.Draw.createBox",function(){return function(a,b){a=La(a);b=b||new D(null);b.na([[db(a),eb(a),fb(a),gb(a),db(a)]]);return b}});Xu.prototype.feature=Xu.prototype.feature;r("ol.interaction.Extent",Yu);Yu.prototype.getExtent=Yu.prototype.G;Yu.prototype.setExtent=Yu.prototype.g;iv.prototype.extent=iv.prototype.extent;r("ol.interaction.Interaction",sg);sg.prototype.getActive=sg.prototype.c;sg.prototype.getMap=sg.prototype.i;sg.prototype.setActive=sg.prototype.Ia;
r("ol.interaction.KeyboardPan",gh);r("ol.interaction.KeyboardPan.handleEvent",hh);r("ol.interaction.KeyboardZoom",ih);r("ol.interaction.KeyboardZoom.handleEvent",jh);r("ol.interaction.Modify",jv);r("ol.interaction.Modify.handleEvent",mv);jv.prototype.removePoint=jv.prototype.rj;rv.prototype.features=rv.prototype.features;rv.prototype.mapBrowserEvent=rv.prototype.mapBrowserEvent;r("ol.interaction.MouseWheelZoom",kh);r("ol.interaction.MouseWheelZoom.handleEvent",lh);kh.prototype.setMouseAnchor=kh.prototype.U;
r("ol.interaction.PinchRotate",oh);r("ol.interaction.PinchZoom",sh);r("ol.interaction.Pointer",Jg);r("ol.interaction.Pointer.handleEvent",Kg);r("ol.interaction.Select",zv);zv.prototype.getFeatures=zv.prototype.Un;zv.prototype.getHitTolerance=zv.prototype.Vn;zv.prototype.getLayer=zv.prototype.Wn;r("ol.interaction.Select.handleEvent",Av);zv.prototype.setHitTolerance=zv.prototype.Yn;zv.prototype.setMap=zv.prototype.setMap;Cv.prototype.selected=Cv.prototype.selected;Cv.prototype.deselected=Cv.prototype.deselected;
Cv.prototype.mapBrowserEvent=Cv.prototype.mapBrowserEvent;r("ol.interaction.Snap",Ev);Ev.prototype.addFeature=Ev.prototype.Bb;Ev.prototype.removeFeature=Ev.prototype.Fb;r("ol.interaction.Translate",Jv);Jv.prototype.getHitTolerance=Jv.prototype.C;Jv.prototype.setHitTolerance=Jv.prototype.I;Pv.prototype.features=Pv.prototype.features;Pv.prototype.coordinate=Pv.prototype.coordinate;r("ol.geom.Circle",Ss);Ss.prototype.clone=Ss.prototype.clone;Ss.prototype.getCenter=Ss.prototype.xa;
Ss.prototype.getRadius=Ss.prototype.vd;Ss.prototype.getType=Ss.prototype.T;Ss.prototype.intersectsExtent=Ss.prototype.Ya;Ss.prototype.setCenter=Ss.prototype.rb;Ss.prototype.setCenterAndRadius=Ss.prototype.Vg;Ss.prototype.setRadius=Ss.prototype.Xc;Ss.prototype.transform=Ss.prototype.mb;r("ol.geom.Geometry",rf);rf.prototype.getClosestPoint=rf.prototype.Db;rf.prototype.intersectsCoordinate=rf.prototype.wb;rf.prototype.getExtent=rf.prototype.G;rf.prototype.rotate=rf.prototype.rotate;
rf.prototype.scale=rf.prototype.scale;rf.prototype.simplify=rf.prototype.Pb;rf.prototype.transform=rf.prototype.mb;r("ol.geom.GeometryCollection",Nm);Nm.prototype.clone=Nm.prototype.clone;Nm.prototype.getGeometries=Nm.prototype.kd;Nm.prototype.getType=Nm.prototype.T;Nm.prototype.intersectsExtent=Nm.prototype.Ya;Nm.prototype.setGeometries=Nm.prototype.yj;Nm.prototype.applyTransform=Nm.prototype.Fc;Nm.prototype.translate=Nm.prototype.translate;r("ol.geom.LinearRing",Of);Of.prototype.clone=Of.prototype.clone;
Of.prototype.getArea=Of.prototype.Fn;Of.prototype.getCoordinates=Of.prototype.V;Of.prototype.getType=Of.prototype.T;Of.prototype.setCoordinates=Of.prototype.na;r("ol.geom.LineString",M);M.prototype.appendCoordinate=M.prototype.xk;M.prototype.clone=M.prototype.clone;M.prototype.forEachSegment=M.prototype.Nk;M.prototype.getCoordinateAtM=M.prototype.Dn;M.prototype.getCoordinates=M.prototype.V;M.prototype.getCoordinateAt=M.prototype.Eh;M.prototype.getLength=M.prototype.En;M.prototype.getType=M.prototype.T;
M.prototype.intersectsExtent=M.prototype.Ya;M.prototype.setCoordinates=M.prototype.na;r("ol.geom.MultiLineString",N);N.prototype.appendLineString=N.prototype.yk;N.prototype.clone=N.prototype.clone;N.prototype.getCoordinateAtM=N.prototype.Gn;N.prototype.getCoordinates=N.prototype.V;N.prototype.getLineString=N.prototype.jl;N.prototype.getLineStrings=N.prototype.ld;N.prototype.getType=N.prototype.T;N.prototype.intersectsExtent=N.prototype.Ya;N.prototype.setCoordinates=N.prototype.na;
r("ol.geom.MultiPoint",O);O.prototype.appendPoint=O.prototype.Ak;O.prototype.clone=O.prototype.clone;O.prototype.getCoordinates=O.prototype.V;O.prototype.getPoint=O.prototype.ul;O.prototype.getPoints=O.prototype.ee;O.prototype.getType=O.prototype.T;O.prototype.intersectsExtent=O.prototype.Ya;O.prototype.setCoordinates=O.prototype.na;r("ol.geom.MultiPolygon",P);P.prototype.appendPolygon=P.prototype.Bk;P.prototype.clone=P.prototype.clone;P.prototype.getArea=P.prototype.Hn;
P.prototype.getCoordinates=P.prototype.V;P.prototype.getInteriorPoints=P.prototype.fl;P.prototype.getPolygon=P.prototype.vl;P.prototype.getPolygons=P.prototype.$d;P.prototype.getType=P.prototype.T;P.prototype.intersectsExtent=P.prototype.Ya;P.prototype.setCoordinates=P.prototype.na;r("ol.geom.Point",C);C.prototype.clone=C.prototype.clone;C.prototype.getCoordinates=C.prototype.V;C.prototype.getType=C.prototype.T;C.prototype.intersectsExtent=C.prototype.Ya;C.prototype.setCoordinates=C.prototype.na;
r("ol.geom.Polygon",D);D.prototype.appendLinearRing=D.prototype.zk;D.prototype.clone=D.prototype.clone;D.prototype.getArea=D.prototype.In;D.prototype.getCoordinates=D.prototype.V;D.prototype.getInteriorPoint=D.prototype.el;D.prototype.getLinearRingCount=D.prototype.kl;D.prototype.getLinearRing=D.prototype.Kh;D.prototype.getLinearRings=D.prototype.Zd;D.prototype.getType=D.prototype.T;D.prototype.intersectsExtent=D.prototype.Ya;D.prototype.setCoordinates=D.prototype.na;
r("ol.geom.Polygon.circular",bg);r("ol.geom.Polygon.fromExtent",cg);r("ol.geom.Polygon.fromCircle",dg);r("ol.geom.SimpleGeometry",uf);uf.prototype.getFirstCoordinate=uf.prototype.bc;uf.prototype.getLastCoordinate=uf.prototype.cc;uf.prototype.getLayout=uf.prototype.dc;uf.prototype.applyTransform=uf.prototype.Fc;uf.prototype.translate=uf.prototype.translate;r("ol.format.EsriJSON",jm);jm.prototype.readFeature=jm.prototype.Ub;jm.prototype.readFeatures=jm.prototype.Oa;jm.prototype.readGeometry=jm.prototype.Vc;
jm.prototype.readProjection=jm.prototype.ob;jm.prototype.writeGeometry=jm.prototype.dd;jm.prototype.writeGeometryObject=jm.prototype.ue;jm.prototype.writeFeature=jm.prototype.Gd;jm.prototype.writeFeatureObject=jm.prototype.cd;jm.prototype.writeFeatures=jm.prototype.Xb;jm.prototype.writeFeaturesObject=jm.prototype.se;r("ol.format.Feature",Yl);r("ol.format.filter.and",Lm);
r("ol.format.filter.or",function(a){var b=[null].concat(Array.prototype.slice.call(arguments));return new (Function.prototype.bind.apply(Jm,b))});r("ol.format.filter.not",function(a){return new Hm(a)});r("ol.format.filter.bbox",Mm);r("ol.format.filter.intersects",function(a,b,c){return new Bm(a,b,c)});r("ol.format.filter.within",function(a,b,c){return new Km(a,b,c)});r("ol.format.filter.equalTo",function(a,b,c){return new xm(a,b,c)});
r("ol.format.filter.notEqualTo",function(a,b,c){return new Im(a,b,c)});r("ol.format.filter.lessThan",function(a,b){return new Fm(a,b)});r("ol.format.filter.lessThanOrEqualTo",function(a,b){return new Gm(a,b)});r("ol.format.filter.greaterThan",function(a,b){return new ym(a,b)});r("ol.format.filter.greaterThanOrEqualTo",function(a,b){return new zm(a,b)});r("ol.format.filter.isNull",function(a){return new Em(a)});r("ol.format.filter.between",function(a,b,c){return new Cm(a,b,c)});
r("ol.format.filter.like",function(a,b,c,d,e,f){return new Dm(a,b,c,d,e,f)});r("ol.format.filter.during",function(a,b,c){return new vm(a,b,c)});r("ol.format.GeoJSON",Rm);Rm.prototype.readFeature=Rm.prototype.Ub;Rm.prototype.readFeatures=Rm.prototype.Oa;Rm.prototype.readGeometry=Rm.prototype.Vc;Rm.prototype.readProjection=Rm.prototype.ob;Rm.prototype.writeFeature=Rm.prototype.Gd;Rm.prototype.writeFeatureObject=Rm.prototype.cd;Rm.prototype.writeFeatures=Rm.prototype.Xb;
Rm.prototype.writeFeaturesObject=Rm.prototype.se;Rm.prototype.writeGeometry=Rm.prototype.dd;Rm.prototype.writeGeometryObject=Rm.prototype.ue;r("ol.format.GML",mn);mn.prototype.writeFeatures=mn.prototype.Xb;mn.prototype.writeFeaturesNode=mn.prototype.Yb;r("ol.format.GML2",vn);r("ol.format.GML3",mn);mn.prototype.writeGeometryNode=mn.prototype.te;mn.prototype.writeFeatures=mn.prototype.Xb;mn.prototype.writeFeaturesNode=mn.prototype.Yb;Zm.prototype.readFeatures=Zm.prototype.Oa;r("ol.format.GPX",Gn);
Gn.prototype.readFeature=Gn.prototype.Ub;Gn.prototype.readFeatures=Gn.prototype.Oa;Gn.prototype.readProjection=Gn.prototype.ob;Gn.prototype.writeFeatures=Gn.prototype.Xb;Gn.prototype.writeFeaturesNode=Gn.prototype.Yb;r("ol.format.IGC",ro);ro.prototype.readFeature=ro.prototype.Ub;ro.prototype.readFeatures=ro.prototype.Oa;ro.prototype.readProjection=ro.prototype.ob;r("ol.format.KML",Ao);Ao.prototype.readFeature=Ao.prototype.Ub;Ao.prototype.readFeatures=Ao.prototype.Oa;Ao.prototype.readName=Ao.prototype.Pp;
Ao.prototype.readNetworkLinks=Ao.prototype.Qp;Ao.prototype.readRegion=Ao.prototype.Tp;Ao.prototype.readRegionFromNode=Ao.prototype.wf;Ao.prototype.readProjection=Ao.prototype.ob;Ao.prototype.writeFeatures=Ao.prototype.Xb;Ao.prototype.writeFeaturesNode=Ao.prototype.Yb;r("ol.format.MVT",Fq);Fq.prototype.getLastExtent=Fq.prototype.eg;Fq.prototype.readFeatures=Fq.prototype.Oa;Fq.prototype.readProjection=Fq.prototype.ob;Fq.prototype.setLayers=Fq.prototype.Cn;r("ol.format.OSMXML",Hq);
Hq.prototype.readFeatures=Hq.prototype.Oa;Hq.prototype.readProjection=Hq.prototype.ob;r("ol.format.Polyline",gr);r("ol.format.Polyline.encodeDeltas",hr);r("ol.format.Polyline.decodeDeltas",jr);r("ol.format.Polyline.encodeFloats",ir);r("ol.format.Polyline.decodeFloats",kr);gr.prototype.readFeature=gr.prototype.Ub;gr.prototype.readFeatures=gr.prototype.Oa;gr.prototype.readGeometry=gr.prototype.Vc;gr.prototype.readProjection=gr.prototype.ob;gr.prototype.writeGeometry=gr.prototype.dd;
r("ol.format.TopoJSON",lr);lr.prototype.readFeatures=lr.prototype.Oa;lr.prototype.readProjection=lr.prototype.ob;r("ol.format.WFS",rr);rr.prototype.readFeatures=rr.prototype.Oa;rr.prototype.readTransactionResponse=rr.prototype.j;rr.prototype.readFeatureCollectionMetadata=rr.prototype.g;r("ol.format.WFS.writeFilter",function(a){var b=El("http://www.opengis.net/ogc","Filter");Vl({node:b},Gr,Ql(a.lc),[a],[]);return b});rr.prototype.writeGetFeature=rr.prototype.o;rr.prototype.writeTransaction=rr.prototype.v;
rr.prototype.readProjection=rr.prototype.ob;r("ol.format.WKT",Mr);Mr.prototype.readFeature=Mr.prototype.Ub;Mr.prototype.readFeatures=Mr.prototype.Oa;Mr.prototype.readGeometry=Mr.prototype.Vc;Mr.prototype.writeFeature=Mr.prototype.Gd;Mr.prototype.writeFeatures=Mr.prototype.Xb;Mr.prototype.writeGeometry=Mr.prototype.dd;r("ol.format.WMSCapabilities",es);es.prototype.read=es.prototype.read;r("ol.format.WMSGetFeatureInfo",Bs);Bs.prototype.readFeatures=Bs.prototype.Oa;r("ol.format.WMTSCapabilities",Cs);
Cs.prototype.read=Cs.prototype.read;r("ol.format.filter.And",sm);r("ol.format.filter.Bbox",tm);r("ol.format.filter.Comparison",um);r("ol.format.filter.ComparisonBinary",wm);r("ol.format.filter.During",vm);r("ol.format.filter.EqualTo",xm);r("ol.format.filter.Filter",qm);r("ol.format.filter.GreaterThan",ym);r("ol.format.filter.GreaterThanOrEqualTo",zm);r("ol.format.filter.Intersects",Bm);r("ol.format.filter.IsBetween",Cm);r("ol.format.filter.IsLike",Dm);r("ol.format.filter.IsNull",Em);
r("ol.format.filter.LessThan",Fm);r("ol.format.filter.LessThanOrEqualTo",Gm);r("ol.format.filter.Not",Hm);r("ol.format.filter.NotEqualTo",Im);r("ol.format.filter.Or",Jm);r("ol.format.filter.Spatial",Am);r("ol.format.filter.Within",Km);r("ol.events.condition.altKeyOnly",yg);r("ol.events.condition.altShiftKeysOnly",zg);r("ol.events.condition.always",pf);r("ol.events.condition.click",function(a){return"click"==a.type});r("ol.events.condition.never",qf);r("ol.events.condition.pointerMove",Bg);
r("ol.events.condition.singleClick",Cg);r("ol.events.condition.doubleClick",function(a){return"dblclick"==a.type});r("ol.events.condition.noModifierKeys",Dg);r("ol.events.condition.platformModifierKeyOnly",function(a){a=a.originalEvent;return!a.altKey&&(Td?a.metaKey:a.ctrlKey)&&!a.shiftKey});r("ol.events.condition.shiftKeyOnly",Eg);r("ol.events.condition.targetNotEditable",Fg);r("ol.events.condition.mouseOnly",Gg);r("ol.events.condition.primaryAction",Hg);Qc.prototype.type=Qc.prototype.type;
Qc.prototype.target=Qc.prototype.target;Qc.prototype.preventDefault=Qc.prototype.preventDefault;Qc.prototype.stopPropagation=Qc.prototype.stopPropagation;r("ol.control.Attribution",pd);r("ol.control.Attribution.render",qd);pd.prototype.getCollapsible=pd.prototype.hn;pd.prototype.setCollapsible=pd.prototype.ln;pd.prototype.setCollapsed=pd.prototype.kn;pd.prototype.getCollapsed=pd.prototype.gn;r("ol.control.Control",od);od.prototype.getMap=od.prototype.g;od.prototype.setMap=od.prototype.setMap;
od.prototype.setTarget=od.prototype.i;r("ol.control.FullScreen",Ad);r("ol.control.MousePosition",Fd);r("ol.control.MousePosition.render",Gd);Fd.prototype.getCoordinateFormat=Fd.prototype.Fh;Fd.prototype.getProjection=Fd.prototype.ii;Fd.prototype.setCoordinateFormat=Fd.prototype.uj;Fd.prototype.setProjection=Fd.prototype.ji;r("ol.control.OverviewMap",Uk);r("ol.control.OverviewMap.render",Vk);Uk.prototype.getCollapsible=Uk.prototype.pn;Uk.prototype.setCollapsible=Uk.prototype.sn;
Uk.prototype.setCollapsed=Uk.prototype.rn;Uk.prototype.getCollapsed=Uk.prototype.nn;Uk.prototype.getOverviewMap=Uk.prototype.sl;r("ol.control.Rotate",wd);r("ol.control.Rotate.render",xd);r("ol.control.ScaleLine",Zk);Zk.prototype.getUnits=Zk.prototype.B;r("ol.control.ScaleLine.render",$k);Zk.prototype.setUnits=Zk.prototype.I;r("ol.control.Zoom",yd);r("ol.control.ZoomSlider",dl);r("ol.control.ZoomSlider.render",fl);r("ol.control.ZoomToExtent",il);Vc.prototype.changed=Vc.prototype.s;
Vc.prototype.dispatchEvent=Vc.prototype.b;Vc.prototype.getRevision=Vc.prototype.L;Vc.prototype.on=Vc.prototype.J;Vc.prototype.once=Vc.prototype.once;Vc.prototype.un=Vc.prototype.K;$c.prototype.get=$c.prototype.get;$c.prototype.getKeys=$c.prototype.O;$c.prototype.getProperties=$c.prototype.N;$c.prototype.set=$c.prototype.set;$c.prototype.setProperties=$c.prototype.H;$c.prototype.unset=$c.prototype.P;$c.prototype.changed=$c.prototype.s;$c.prototype.dispatchEvent=$c.prototype.b;
$c.prototype.getRevision=$c.prototype.L;$c.prototype.on=$c.prototype.J;$c.prototype.once=$c.prototype.once;$c.prototype.un=$c.prototype.K;dd.prototype.type=dd.prototype.type;dd.prototype.target=dd.prototype.target;dd.prototype.preventDefault=dd.prototype.preventDefault;dd.prototype.stopPropagation=dd.prototype.stopPropagation;jl.prototype.get=jl.prototype.get;jl.prototype.getKeys=jl.prototype.O;jl.prototype.getProperties=jl.prototype.N;jl.prototype.set=jl.prototype.set;
jl.prototype.setProperties=jl.prototype.H;jl.prototype.unset=jl.prototype.P;jl.prototype.changed=jl.prototype.s;jl.prototype.dispatchEvent=jl.prototype.b;jl.prototype.getRevision=jl.prototype.L;jl.prototype.on=jl.prototype.J;jl.prototype.once=jl.prototype.once;jl.prototype.un=jl.prototype.K;Bl.prototype.get=Bl.prototype.get;Bl.prototype.getKeys=Bl.prototype.O;Bl.prototype.getProperties=Bl.prototype.N;Bl.prototype.set=Bl.prototype.set;Bl.prototype.setProperties=Bl.prototype.H;Bl.prototype.unset=Bl.prototype.P;
Bl.prototype.changed=Bl.prototype.s;Bl.prototype.dispatchEvent=Bl.prototype.b;Bl.prototype.getRevision=Bl.prototype.L;Bl.prototype.on=Bl.prototype.J;Bl.prototype.once=Bl.prototype.once;Bl.prototype.un=Bl.prototype.K;Rs.prototype.get=Rs.prototype.get;Rs.prototype.getKeys=Rs.prototype.O;Rs.prototype.getProperties=Rs.prototype.N;Rs.prototype.set=Rs.prototype.set;Rs.prototype.setProperties=Rs.prototype.H;Rs.prototype.unset=Rs.prototype.P;Rs.prototype.changed=Rs.prototype.s;
Rs.prototype.dispatchEvent=Rs.prototype.b;Rs.prototype.getRevision=Rs.prototype.L;Rs.prototype.on=Rs.prototype.J;Rs.prototype.once=Rs.prototype.once;Rs.prototype.un=Rs.prototype.K;it.prototype.getTileCoord=it.prototype.i;it.prototype.load=it.prototype.load;H.prototype.get=H.prototype.get;H.prototype.getKeys=H.prototype.O;H.prototype.getProperties=H.prototype.N;H.prototype.set=H.prototype.set;H.prototype.setProperties=H.prototype.H;H.prototype.unset=H.prototype.P;H.prototype.changed=H.prototype.s;
H.prototype.dispatchEvent=H.prototype.b;H.prototype.getRevision=H.prototype.L;H.prototype.on=H.prototype.J;H.prototype.once=H.prototype.once;H.prototype.un=H.prototype.K;Kd.prototype.type=Kd.prototype.type;Kd.prototype.target=Kd.prototype.target;Kd.prototype.preventDefault=Kd.prototype.preventDefault;Kd.prototype.stopPropagation=Kd.prototype.stopPropagation;Ld.prototype.map=Ld.prototype.map;Ld.prototype.frameState=Ld.prototype.frameState;Ld.prototype.type=Ld.prototype.type;Ld.prototype.target=Ld.prototype.target;
Ld.prototype.preventDefault=Ld.prototype.preventDefault;Ld.prototype.stopPropagation=Ld.prototype.stopPropagation;ie.prototype.originalEvent=ie.prototype.originalEvent;ie.prototype.pixel=ie.prototype.pixel;ie.prototype.coordinate=ie.prototype.coordinate;ie.prototype.dragging=ie.prototype.dragging;ie.prototype.preventDefault=ie.prototype.preventDefault;ie.prototype.stopPropagation=ie.prototype.stopPropagation;ie.prototype.map=ie.prototype.map;ie.prototype.frameState=ie.prototype.frameState;
ie.prototype.type=ie.prototype.type;ie.prototype.target=ie.prototype.target;Zc.prototype.type=Zc.prototype.type;Zc.prototype.target=Zc.prototype.target;Zc.prototype.preventDefault=Zc.prototype.preventDefault;Zc.prototype.stopPropagation=Zc.prototype.stopPropagation;Lk.prototype.get=Lk.prototype.get;Lk.prototype.getKeys=Lk.prototype.O;Lk.prototype.getProperties=Lk.prototype.N;Lk.prototype.set=Lk.prototype.set;Lk.prototype.setProperties=Lk.prototype.H;Lk.prototype.unset=Lk.prototype.P;
Lk.prototype.changed=Lk.prototype.s;Lk.prototype.dispatchEvent=Lk.prototype.b;Lk.prototype.getRevision=Lk.prototype.L;Lk.prototype.on=Lk.prototype.J;Lk.prototype.once=Lk.prototype.once;Lk.prototype.un=Lk.prototype.K;Px.prototype.getTileCoord=Px.prototype.i;Px.prototype.load=Px.prototype.load;Rx.prototype.getTileCoord=Rx.prototype.i;Rx.prototype.load=Rx.prototype.load;F.prototype.get=F.prototype.get;F.prototype.getKeys=F.prototype.O;F.prototype.getProperties=F.prototype.N;F.prototype.set=F.prototype.set;
F.prototype.setProperties=F.prototype.H;F.prototype.unset=F.prototype.P;F.prototype.changed=F.prototype.s;F.prototype.dispatchEvent=F.prototype.b;F.prototype.getRevision=F.prototype.L;F.prototype.on=F.prototype.J;F.prototype.once=F.prototype.once;F.prototype.un=F.prototype.K;Ux.prototype.forEachTileCoord=Ux.prototype.Yf;Ux.prototype.getMaxZoom=Ux.prototype.cj;Ux.prototype.getMinZoom=Ux.prototype.dj;Ux.prototype.getOrigin=Ux.prototype.Sc;Ux.prototype.getResolution=Ux.prototype.Ca;
Ux.prototype.getResolutions=Ux.prototype.ej;Ux.prototype.getTileCoordExtent=Ux.prototype.Fa;Ux.prototype.getTileCoordForCoordAndResolution=Ux.prototype.Me;Ux.prototype.getTileCoordForCoordAndZ=Ux.prototype.kg;Ux.prototype.getTileSize=Ux.prototype.eb;Ux.prototype.getZForResolution=Ux.prototype.uc;rl.prototype.getOpacity=rl.prototype.jf;rl.prototype.getRotateWithView=rl.prototype.kf;rl.prototype.getRotation=rl.prototype.lf;rl.prototype.getScale=rl.prototype.mf;rl.prototype.getSnapToPixel=rl.prototype.Le;
rl.prototype.setOpacity=rl.prototype.zd;rl.prototype.setRotation=rl.prototype.nf;rl.prototype.setScale=rl.prototype.Ad;tl.prototype.clone=tl.prototype.clone;tl.prototype.getAngle=tl.prototype.Zi;tl.prototype.getFill=tl.prototype.Da;tl.prototype.getPoints=tl.prototype.$i;tl.prototype.getRadius=tl.prototype.aj;tl.prototype.getRadius2=tl.prototype.Nh;tl.prototype.getStroke=tl.prototype.Ea;tl.prototype.getOpacity=tl.prototype.jf;tl.prototype.getRotateWithView=tl.prototype.kf;
tl.prototype.getRotation=tl.prototype.lf;tl.prototype.getScale=tl.prototype.mf;tl.prototype.getSnapToPixel=tl.prototype.Le;tl.prototype.setOpacity=tl.prototype.zd;tl.prototype.setRotation=tl.prototype.nf;tl.prototype.setScale=tl.prototype.Ad;yo.prototype.getOpacity=yo.prototype.jf;yo.prototype.getRotateWithView=yo.prototype.kf;yo.prototype.getRotation=yo.prototype.lf;yo.prototype.getScale=yo.prototype.mf;yo.prototype.getSnapToPixel=yo.prototype.Le;yo.prototype.setOpacity=yo.prototype.zd;
yo.prototype.setRotation=yo.prototype.nf;yo.prototype.setScale=yo.prototype.Ad;xu.prototype.get=xu.prototype.get;xu.prototype.getKeys=xu.prototype.O;xu.prototype.getProperties=xu.prototype.N;xu.prototype.set=xu.prototype.set;xu.prototype.setProperties=xu.prototype.H;xu.prototype.unset=xu.prototype.P;xu.prototype.changed=xu.prototype.s;xu.prototype.dispatchEvent=xu.prototype.b;xu.prototype.getRevision=xu.prototype.L;xu.prototype.on=xu.prototype.J;xu.prototype.once=xu.prototype.once;
xu.prototype.un=xu.prototype.K;Rw.prototype.getAttributions=Rw.prototype.Aa;Rw.prototype.getLogo=Rw.prototype.ya;Rw.prototype.getProjection=Rw.prototype.Ba;Rw.prototype.getState=Rw.prototype.getState;Rw.prototype.refresh=Rw.prototype.ra;Rw.prototype.setAttributions=Rw.prototype.wa;Rw.prototype.get=Rw.prototype.get;Rw.prototype.getKeys=Rw.prototype.O;Rw.prototype.getProperties=Rw.prototype.N;Rw.prototype.set=Rw.prototype.set;Rw.prototype.setProperties=Rw.prototype.H;Rw.prototype.unset=Rw.prototype.P;
Rw.prototype.changed=Rw.prototype.s;Rw.prototype.dispatchEvent=Rw.prototype.b;Rw.prototype.getRevision=Rw.prototype.L;Rw.prototype.on=Rw.prototype.J;Rw.prototype.once=Rw.prototype.once;Rw.prototype.un=Rw.prototype.K;Vw.prototype.getTileGrid=Vw.prototype.cb;Vw.prototype.refresh=Vw.prototype.ra;Vw.prototype.getAttributions=Vw.prototype.Aa;Vw.prototype.getLogo=Vw.prototype.ya;Vw.prototype.getProjection=Vw.prototype.Ba;Vw.prototype.getState=Vw.prototype.getState;Vw.prototype.setAttributions=Vw.prototype.wa;
Vw.prototype.get=Vw.prototype.get;Vw.prototype.getKeys=Vw.prototype.O;Vw.prototype.getProperties=Vw.prototype.N;Vw.prototype.set=Vw.prototype.set;Vw.prototype.setProperties=Vw.prototype.H;Vw.prototype.unset=Vw.prototype.P;Vw.prototype.changed=Vw.prototype.s;Vw.prototype.dispatchEvent=Vw.prototype.b;Vw.prototype.getRevision=Vw.prototype.L;Vw.prototype.on=Vw.prototype.J;Vw.prototype.once=Vw.prototype.once;Vw.prototype.un=Vw.prototype.K;X.prototype.getTileLoadFunction=X.prototype.tb;
X.prototype.getTileUrlFunction=X.prototype.ub;X.prototype.getUrls=X.prototype.vb;X.prototype.setTileLoadFunction=X.prototype.zb;X.prototype.setTileUrlFunction=X.prototype.hb;X.prototype.setUrl=X.prototype.nb;X.prototype.setUrls=X.prototype.ib;X.prototype.getTileGrid=X.prototype.cb;X.prototype.refresh=X.prototype.ra;X.prototype.getAttributions=X.prototype.Aa;X.prototype.getLogo=X.prototype.ya;X.prototype.getProjection=X.prototype.Ba;X.prototype.getState=X.prototype.getState;
X.prototype.setAttributions=X.prototype.wa;X.prototype.get=X.prototype.get;X.prototype.getKeys=X.prototype.O;X.prototype.getProperties=X.prototype.N;X.prototype.set=X.prototype.set;X.prototype.setProperties=X.prototype.H;X.prototype.unset=X.prototype.P;X.prototype.changed=X.prototype.s;X.prototype.dispatchEvent=X.prototype.b;X.prototype.getRevision=X.prototype.L;X.prototype.on=X.prototype.J;X.prototype.once=X.prototype.once;X.prototype.un=X.prototype.K;Zw.prototype.setRenderReprojectionEdges=Zw.prototype.Nb;
Zw.prototype.setTileGridForProjection=Zw.prototype.Ob;Zw.prototype.getTileLoadFunction=Zw.prototype.tb;Zw.prototype.getTileUrlFunction=Zw.prototype.ub;Zw.prototype.getUrls=Zw.prototype.vb;Zw.prototype.setTileLoadFunction=Zw.prototype.zb;Zw.prototype.setTileUrlFunction=Zw.prototype.hb;Zw.prototype.setUrl=Zw.prototype.nb;Zw.prototype.setUrls=Zw.prototype.ib;Zw.prototype.getTileGrid=Zw.prototype.cb;Zw.prototype.refresh=Zw.prototype.ra;Zw.prototype.getAttributions=Zw.prototype.Aa;
Zw.prototype.getLogo=Zw.prototype.ya;Zw.prototype.getProjection=Zw.prototype.Ba;Zw.prototype.getState=Zw.prototype.getState;Zw.prototype.setAttributions=Zw.prototype.wa;Zw.prototype.get=Zw.prototype.get;Zw.prototype.getKeys=Zw.prototype.O;Zw.prototype.getProperties=Zw.prototype.N;Zw.prototype.set=Zw.prototype.set;Zw.prototype.setProperties=Zw.prototype.H;Zw.prototype.unset=Zw.prototype.P;Zw.prototype.changed=Zw.prototype.s;Zw.prototype.dispatchEvent=Zw.prototype.b;Zw.prototype.getRevision=Zw.prototype.L;
Zw.prototype.on=Zw.prototype.J;Zw.prototype.once=Zw.prototype.once;Zw.prototype.un=Zw.prototype.K;ax.prototype.setRenderReprojectionEdges=ax.prototype.Nb;ax.prototype.setTileGridForProjection=ax.prototype.Ob;ax.prototype.getTileLoadFunction=ax.prototype.tb;ax.prototype.getTileUrlFunction=ax.prototype.ub;ax.prototype.getUrls=ax.prototype.vb;ax.prototype.setTileLoadFunction=ax.prototype.zb;ax.prototype.setTileUrlFunction=ax.prototype.hb;ax.prototype.setUrl=ax.prototype.nb;ax.prototype.setUrls=ax.prototype.ib;
ax.prototype.getTileGrid=ax.prototype.cb;ax.prototype.refresh=ax.prototype.ra;ax.prototype.getAttributions=ax.prototype.Aa;ax.prototype.getLogo=ax.prototype.ya;ax.prototype.getProjection=ax.prototype.Ba;ax.prototype.getState=ax.prototype.getState;ax.prototype.setAttributions=ax.prototype.wa;ax.prototype.get=ax.prototype.get;ax.prototype.getKeys=ax.prototype.O;ax.prototype.getProperties=ax.prototype.N;ax.prototype.set=ax.prototype.set;ax.prototype.setProperties=ax.prototype.H;ax.prototype.unset=ax.prototype.P;
ax.prototype.changed=ax.prototype.s;ax.prototype.dispatchEvent=ax.prototype.b;ax.prototype.getRevision=ax.prototype.L;ax.prototype.on=ax.prototype.J;ax.prototype.once=ax.prototype.once;ax.prototype.un=ax.prototype.K;bx.prototype.setRenderReprojectionEdges=bx.prototype.Nb;bx.prototype.setTileGridForProjection=bx.prototype.Ob;bx.prototype.getTileLoadFunction=bx.prototype.tb;bx.prototype.getTileUrlFunction=bx.prototype.ub;bx.prototype.getUrls=bx.prototype.vb;bx.prototype.setTileLoadFunction=bx.prototype.zb;
bx.prototype.setTileUrlFunction=bx.prototype.hb;bx.prototype.setUrl=bx.prototype.nb;bx.prototype.setUrls=bx.prototype.ib;bx.prototype.getTileGrid=bx.prototype.cb;bx.prototype.refresh=bx.prototype.ra;bx.prototype.getAttributions=bx.prototype.Aa;bx.prototype.getLogo=bx.prototype.ya;bx.prototype.getProjection=bx.prototype.Ba;bx.prototype.getState=bx.prototype.getState;bx.prototype.setAttributions=bx.prototype.wa;bx.prototype.get=bx.prototype.get;bx.prototype.getKeys=bx.prototype.O;
bx.prototype.getProperties=bx.prototype.N;bx.prototype.set=bx.prototype.set;bx.prototype.setProperties=bx.prototype.H;bx.prototype.unset=bx.prototype.P;bx.prototype.changed=bx.prototype.s;bx.prototype.dispatchEvent=bx.prototype.b;bx.prototype.getRevision=bx.prototype.L;bx.prototype.on=bx.prototype.J;bx.prototype.once=bx.prototype.once;bx.prototype.un=bx.prototype.K;V.prototype.getAttributions=V.prototype.Aa;V.prototype.getLogo=V.prototype.ya;V.prototype.getProjection=V.prototype.Ba;
V.prototype.getState=V.prototype.getState;V.prototype.refresh=V.prototype.ra;V.prototype.setAttributions=V.prototype.wa;V.prototype.get=V.prototype.get;V.prototype.getKeys=V.prototype.O;V.prototype.getProperties=V.prototype.N;V.prototype.set=V.prototype.set;V.prototype.setProperties=V.prototype.H;V.prototype.unset=V.prototype.P;V.prototype.changed=V.prototype.s;V.prototype.dispatchEvent=V.prototype.b;V.prototype.getRevision=V.prototype.L;V.prototype.on=V.prototype.J;V.prototype.once=V.prototype.once;
V.prototype.un=V.prototype.K;Y.prototype.addFeature=Y.prototype.Bb;Y.prototype.addFeatures=Y.prototype.Ec;Y.prototype.clear=Y.prototype.clear;Y.prototype.forEachFeature=Y.prototype.Ah;Y.prototype.forEachFeatureInExtent=Y.prototype.ac;Y.prototype.forEachFeatureIntersectingExtent=Y.prototype.Bh;Y.prototype.getFeaturesCollection=Y.prototype.Ih;Y.prototype.getFeatures=Y.prototype.fe;Y.prototype.getFeaturesAtCoordinate=Y.prototype.Hh;Y.prototype.getFeaturesInExtent=Y.prototype.ag;
Y.prototype.getClosestFeatureToCoordinate=Y.prototype.Dh;Y.prototype.getExtent=Y.prototype.G;Y.prototype.getFeatureById=Y.prototype.Gh;Y.prototype.getFormat=Y.prototype.Wi;Y.prototype.getUrl=Y.prototype.Xi;Y.prototype.removeFeature=Y.prototype.Fb;Y.prototype.getAttributions=Y.prototype.Aa;Y.prototype.getLogo=Y.prototype.ya;Y.prototype.getProjection=Y.prototype.Ba;Y.prototype.getState=Y.prototype.getState;Y.prototype.refresh=Y.prototype.ra;Y.prototype.setAttributions=Y.prototype.wa;
Y.prototype.get=Y.prototype.get;Y.prototype.getKeys=Y.prototype.O;Y.prototype.getProperties=Y.prototype.N;Y.prototype.set=Y.prototype.set;Y.prototype.setProperties=Y.prototype.H;Y.prototype.unset=Y.prototype.P;Y.prototype.changed=Y.prototype.s;Y.prototype.dispatchEvent=Y.prototype.b;Y.prototype.getRevision=Y.prototype.L;Y.prototype.on=Y.prototype.J;Y.prototype.once=Y.prototype.once;Y.prototype.un=Y.prototype.K;dw.prototype.getAttributions=dw.prototype.Aa;dw.prototype.getLogo=dw.prototype.ya;
dw.prototype.getProjection=dw.prototype.Ba;dw.prototype.getState=dw.prototype.getState;dw.prototype.refresh=dw.prototype.ra;dw.prototype.setAttributions=dw.prototype.wa;dw.prototype.get=dw.prototype.get;dw.prototype.getKeys=dw.prototype.O;dw.prototype.getProperties=dw.prototype.N;dw.prototype.set=dw.prototype.set;dw.prototype.setProperties=dw.prototype.H;dw.prototype.unset=dw.prototype.P;dw.prototype.changed=dw.prototype.s;dw.prototype.dispatchEvent=dw.prototype.b;dw.prototype.getRevision=dw.prototype.L;
dw.prototype.on=dw.prototype.J;dw.prototype.once=dw.prototype.once;dw.prototype.un=dw.prototype.K;fw.prototype.type=fw.prototype.type;fw.prototype.target=fw.prototype.target;fw.prototype.preventDefault=fw.prototype.preventDefault;fw.prototype.stopPropagation=fw.prototype.stopPropagation;hx.prototype.getAttributions=hx.prototype.Aa;hx.prototype.getLogo=hx.prototype.ya;hx.prototype.getProjection=hx.prototype.Ba;hx.prototype.getState=hx.prototype.getState;hx.prototype.refresh=hx.prototype.ra;
hx.prototype.setAttributions=hx.prototype.wa;hx.prototype.get=hx.prototype.get;hx.prototype.getKeys=hx.prototype.O;hx.prototype.getProperties=hx.prototype.N;hx.prototype.set=hx.prototype.set;hx.prototype.setProperties=hx.prototype.H;hx.prototype.unset=hx.prototype.P;hx.prototype.changed=hx.prototype.s;hx.prototype.dispatchEvent=hx.prototype.b;hx.prototype.getRevision=hx.prototype.L;hx.prototype.on=hx.prototype.J;hx.prototype.once=hx.prototype.once;hx.prototype.un=hx.prototype.K;
kw.prototype.getAttributions=kw.prototype.Aa;kw.prototype.getLogo=kw.prototype.ya;kw.prototype.getProjection=kw.prototype.Ba;kw.prototype.getState=kw.prototype.getState;kw.prototype.refresh=kw.prototype.ra;kw.prototype.setAttributions=kw.prototype.wa;kw.prototype.get=kw.prototype.get;kw.prototype.getKeys=kw.prototype.O;kw.prototype.getProperties=kw.prototype.N;kw.prototype.set=kw.prototype.set;kw.prototype.setProperties=kw.prototype.H;kw.prototype.unset=kw.prototype.P;kw.prototype.changed=kw.prototype.s;
kw.prototype.dispatchEvent=kw.prototype.b;kw.prototype.getRevision=kw.prototype.L;kw.prototype.on=kw.prototype.J;kw.prototype.once=kw.prototype.once;kw.prototype.un=kw.prototype.K;ix.prototype.getAttributions=ix.prototype.Aa;ix.prototype.getLogo=ix.prototype.ya;ix.prototype.getProjection=ix.prototype.Ba;ix.prototype.getState=ix.prototype.getState;ix.prototype.refresh=ix.prototype.ra;ix.prototype.setAttributions=ix.prototype.wa;ix.prototype.get=ix.prototype.get;ix.prototype.getKeys=ix.prototype.O;
ix.prototype.getProperties=ix.prototype.N;ix.prototype.set=ix.prototype.set;ix.prototype.setProperties=ix.prototype.H;ix.prototype.unset=ix.prototype.P;ix.prototype.changed=ix.prototype.s;ix.prototype.dispatchEvent=ix.prototype.b;ix.prototype.getRevision=ix.prototype.L;ix.prototype.on=ix.prototype.J;ix.prototype.once=ix.prototype.once;ix.prototype.un=ix.prototype.K;jx.prototype.getAttributions=jx.prototype.Aa;jx.prototype.getLogo=jx.prototype.ya;jx.prototype.getProjection=jx.prototype.Ba;
jx.prototype.getState=jx.prototype.getState;jx.prototype.refresh=jx.prototype.ra;jx.prototype.setAttributions=jx.prototype.wa;jx.prototype.get=jx.prototype.get;jx.prototype.getKeys=jx.prototype.O;jx.prototype.getProperties=jx.prototype.N;jx.prototype.set=jx.prototype.set;jx.prototype.setProperties=jx.prototype.H;jx.prototype.unset=jx.prototype.P;jx.prototype.changed=jx.prototype.s;jx.prototype.dispatchEvent=jx.prototype.b;jx.prototype.getRevision=jx.prototype.L;jx.prototype.on=jx.prototype.J;
jx.prototype.once=jx.prototype.once;jx.prototype.un=jx.prototype.K;lw.prototype.getAttributions=lw.prototype.Aa;lw.prototype.getLogo=lw.prototype.ya;lw.prototype.getProjection=lw.prototype.Ba;lw.prototype.getState=lw.prototype.getState;lw.prototype.refresh=lw.prototype.ra;lw.prototype.setAttributions=lw.prototype.wa;lw.prototype.get=lw.prototype.get;lw.prototype.getKeys=lw.prototype.O;lw.prototype.getProperties=lw.prototype.N;lw.prototype.set=lw.prototype.set;lw.prototype.setProperties=lw.prototype.H;
lw.prototype.unset=lw.prototype.P;lw.prototype.changed=lw.prototype.s;lw.prototype.dispatchEvent=lw.prototype.b;lw.prototype.getRevision=lw.prototype.L;lw.prototype.on=lw.prototype.J;lw.prototype.once=lw.prototype.once;lw.prototype.un=lw.prototype.K;kx.prototype.getAttributions=kx.prototype.Aa;kx.prototype.getLogo=kx.prototype.ya;kx.prototype.getProjection=kx.prototype.Ba;kx.prototype.getState=kx.prototype.getState;kx.prototype.refresh=kx.prototype.ra;kx.prototype.setAttributions=kx.prototype.wa;
kx.prototype.get=kx.prototype.get;kx.prototype.getKeys=kx.prototype.O;kx.prototype.getProperties=kx.prototype.N;kx.prototype.set=kx.prototype.set;kx.prototype.setProperties=kx.prototype.H;kx.prototype.unset=kx.prototype.P;kx.prototype.changed=kx.prototype.s;kx.prototype.dispatchEvent=kx.prototype.b;kx.prototype.getRevision=kx.prototype.L;kx.prototype.on=kx.prototype.J;kx.prototype.once=kx.prototype.once;kx.prototype.un=kx.prototype.K;ox.prototype.setRenderReprojectionEdges=ox.prototype.Nb;
ox.prototype.setTileGridForProjection=ox.prototype.Ob;ox.prototype.getTileLoadFunction=ox.prototype.tb;ox.prototype.getTileUrlFunction=ox.prototype.ub;ox.prototype.getUrls=ox.prototype.vb;ox.prototype.setTileLoadFunction=ox.prototype.zb;ox.prototype.setTileUrlFunction=ox.prototype.hb;ox.prototype.setUrl=ox.prototype.nb;ox.prototype.setUrls=ox.prototype.ib;ox.prototype.getTileGrid=ox.prototype.cb;ox.prototype.refresh=ox.prototype.ra;ox.prototype.getAttributions=ox.prototype.Aa;
ox.prototype.getLogo=ox.prototype.ya;ox.prototype.getProjection=ox.prototype.Ba;ox.prototype.getState=ox.prototype.getState;ox.prototype.setAttributions=ox.prototype.wa;ox.prototype.get=ox.prototype.get;ox.prototype.getKeys=ox.prototype.O;ox.prototype.getProperties=ox.prototype.N;ox.prototype.set=ox.prototype.set;ox.prototype.setProperties=ox.prototype.H;ox.prototype.unset=ox.prototype.P;ox.prototype.changed=ox.prototype.s;ox.prototype.dispatchEvent=ox.prototype.b;ox.prototype.getRevision=ox.prototype.L;
ox.prototype.on=ox.prototype.J;ox.prototype.once=ox.prototype.once;ox.prototype.un=ox.prototype.K;qx.prototype.getAttributions=qx.prototype.Aa;qx.prototype.getLogo=qx.prototype.ya;qx.prototype.getProjection=qx.prototype.Ba;qx.prototype.getState=qx.prototype.getState;qx.prototype.refresh=qx.prototype.ra;qx.prototype.setAttributions=qx.prototype.wa;qx.prototype.get=qx.prototype.get;qx.prototype.getKeys=qx.prototype.O;qx.prototype.getProperties=qx.prototype.N;qx.prototype.set=qx.prototype.set;
qx.prototype.setProperties=qx.prototype.H;qx.prototype.unset=qx.prototype.P;qx.prototype.changed=qx.prototype.s;qx.prototype.dispatchEvent=qx.prototype.b;qx.prototype.getRevision=qx.prototype.L;qx.prototype.on=qx.prototype.J;qx.prototype.once=qx.prototype.once;qx.prototype.un=qx.prototype.K;ux.prototype.type=ux.prototype.type;ux.prototype.target=ux.prototype.target;ux.prototype.preventDefault=ux.prototype.preventDefault;ux.prototype.stopPropagation=ux.prototype.stopPropagation;
xx.prototype.setRenderReprojectionEdges=xx.prototype.Nb;xx.prototype.setTileGridForProjection=xx.prototype.Ob;xx.prototype.getTileLoadFunction=xx.prototype.tb;xx.prototype.getTileUrlFunction=xx.prototype.ub;xx.prototype.getUrls=xx.prototype.vb;xx.prototype.setTileLoadFunction=xx.prototype.zb;xx.prototype.setTileUrlFunction=xx.prototype.hb;xx.prototype.setUrl=xx.prototype.nb;xx.prototype.setUrls=xx.prototype.ib;xx.prototype.getTileGrid=xx.prototype.cb;xx.prototype.refresh=xx.prototype.ra;
xx.prototype.getAttributions=xx.prototype.Aa;xx.prototype.getLogo=xx.prototype.ya;xx.prototype.getProjection=xx.prototype.Ba;xx.prototype.getState=xx.prototype.getState;xx.prototype.setAttributions=xx.prototype.wa;xx.prototype.get=xx.prototype.get;xx.prototype.getKeys=xx.prototype.O;xx.prototype.getProperties=xx.prototype.N;xx.prototype.set=xx.prototype.set;xx.prototype.setProperties=xx.prototype.H;xx.prototype.unset=xx.prototype.P;xx.prototype.changed=xx.prototype.s;xx.prototype.dispatchEvent=xx.prototype.b;
xx.prototype.getRevision=xx.prototype.L;xx.prototype.on=xx.prototype.J;xx.prototype.once=xx.prototype.once;xx.prototype.un=xx.prototype.K;Uw.prototype.type=Uw.prototype.type;Uw.prototype.target=Uw.prototype.target;Uw.prototype.preventDefault=Uw.prototype.preventDefault;Uw.prototype.stopPropagation=Uw.prototype.stopPropagation;Bx.prototype.setRenderReprojectionEdges=Bx.prototype.Nb;Bx.prototype.setTileGridForProjection=Bx.prototype.Ob;Bx.prototype.getTileLoadFunction=Bx.prototype.tb;
Bx.prototype.getTileUrlFunction=Bx.prototype.ub;Bx.prototype.getUrls=Bx.prototype.vb;Bx.prototype.setTileLoadFunction=Bx.prototype.zb;Bx.prototype.setTileUrlFunction=Bx.prototype.hb;Bx.prototype.setUrl=Bx.prototype.nb;Bx.prototype.setUrls=Bx.prototype.ib;Bx.prototype.getTileGrid=Bx.prototype.cb;Bx.prototype.refresh=Bx.prototype.ra;Bx.prototype.getAttributions=Bx.prototype.Aa;Bx.prototype.getLogo=Bx.prototype.ya;Bx.prototype.getProjection=Bx.prototype.Ba;Bx.prototype.getState=Bx.prototype.getState;
Bx.prototype.setAttributions=Bx.prototype.wa;Bx.prototype.get=Bx.prototype.get;Bx.prototype.getKeys=Bx.prototype.O;Bx.prototype.getProperties=Bx.prototype.N;Bx.prototype.set=Bx.prototype.set;Bx.prototype.setProperties=Bx.prototype.H;Bx.prototype.unset=Bx.prototype.P;Bx.prototype.changed=Bx.prototype.s;Bx.prototype.dispatchEvent=Bx.prototype.b;Bx.prototype.getRevision=Bx.prototype.L;Bx.prototype.on=Bx.prototype.J;Bx.prototype.once=Bx.prototype.once;Bx.prototype.un=Bx.prototype.K;
Dx.prototype.getTileGrid=Dx.prototype.cb;Dx.prototype.refresh=Dx.prototype.ra;Dx.prototype.getAttributions=Dx.prototype.Aa;Dx.prototype.getLogo=Dx.prototype.ya;Dx.prototype.getProjection=Dx.prototype.Ba;Dx.prototype.getState=Dx.prototype.getState;Dx.prototype.setAttributions=Dx.prototype.wa;Dx.prototype.get=Dx.prototype.get;Dx.prototype.getKeys=Dx.prototype.O;Dx.prototype.getProperties=Dx.prototype.N;Dx.prototype.set=Dx.prototype.set;Dx.prototype.setProperties=Dx.prototype.H;Dx.prototype.unset=Dx.prototype.P;
Dx.prototype.changed=Dx.prototype.s;Dx.prototype.dispatchEvent=Dx.prototype.b;Dx.prototype.getRevision=Dx.prototype.L;Dx.prototype.on=Dx.prototype.J;Dx.prototype.once=Dx.prototype.once;Dx.prototype.un=Dx.prototype.K;Fx.prototype.setRenderReprojectionEdges=Fx.prototype.Nb;Fx.prototype.setTileGridForProjection=Fx.prototype.Ob;Fx.prototype.getTileLoadFunction=Fx.prototype.tb;Fx.prototype.getTileUrlFunction=Fx.prototype.ub;Fx.prototype.getUrls=Fx.prototype.vb;Fx.prototype.setTileLoadFunction=Fx.prototype.zb;
Fx.prototype.setTileUrlFunction=Fx.prototype.hb;Fx.prototype.setUrl=Fx.prototype.nb;Fx.prototype.setUrls=Fx.prototype.ib;Fx.prototype.getTileGrid=Fx.prototype.cb;Fx.prototype.refresh=Fx.prototype.ra;Fx.prototype.getAttributions=Fx.prototype.Aa;Fx.prototype.getLogo=Fx.prototype.ya;Fx.prototype.getProjection=Fx.prototype.Ba;Fx.prototype.getState=Fx.prototype.getState;Fx.prototype.setAttributions=Fx.prototype.wa;Fx.prototype.get=Fx.prototype.get;Fx.prototype.getKeys=Fx.prototype.O;
Fx.prototype.getProperties=Fx.prototype.N;Fx.prototype.set=Fx.prototype.set;Fx.prototype.setProperties=Fx.prototype.H;Fx.prototype.unset=Fx.prototype.P;Fx.prototype.changed=Fx.prototype.s;Fx.prototype.dispatchEvent=Fx.prototype.b;Fx.prototype.getRevision=Fx.prototype.L;Fx.prototype.on=Fx.prototype.J;Fx.prototype.once=Fx.prototype.once;Fx.prototype.un=Fx.prototype.K;Gx.prototype.getTileGrid=Gx.prototype.cb;Gx.prototype.refresh=Gx.prototype.ra;Gx.prototype.getAttributions=Gx.prototype.Aa;
Gx.prototype.getLogo=Gx.prototype.ya;Gx.prototype.getProjection=Gx.prototype.Ba;Gx.prototype.getState=Gx.prototype.getState;Gx.prototype.setAttributions=Gx.prototype.wa;Gx.prototype.get=Gx.prototype.get;Gx.prototype.getKeys=Gx.prototype.O;Gx.prototype.getProperties=Gx.prototype.N;Gx.prototype.set=Gx.prototype.set;Gx.prototype.setProperties=Gx.prototype.H;Gx.prototype.unset=Gx.prototype.P;Gx.prototype.changed=Gx.prototype.s;Gx.prototype.dispatchEvent=Gx.prototype.b;Gx.prototype.getRevision=Gx.prototype.L;
Gx.prototype.on=Gx.prototype.J;Gx.prototype.once=Gx.prototype.once;Gx.prototype.un=Gx.prototype.K;Kx.prototype.setRenderReprojectionEdges=Kx.prototype.Nb;Kx.prototype.setTileGridForProjection=Kx.prototype.Ob;Kx.prototype.getTileLoadFunction=Kx.prototype.tb;Kx.prototype.getTileUrlFunction=Kx.prototype.ub;Kx.prototype.getUrls=Kx.prototype.vb;Kx.prototype.setTileLoadFunction=Kx.prototype.zb;Kx.prototype.setTileUrlFunction=Kx.prototype.hb;Kx.prototype.setUrl=Kx.prototype.nb;Kx.prototype.setUrls=Kx.prototype.ib;
Kx.prototype.getTileGrid=Kx.prototype.cb;Kx.prototype.refresh=Kx.prototype.ra;Kx.prototype.getAttributions=Kx.prototype.Aa;Kx.prototype.getLogo=Kx.prototype.ya;Kx.prototype.getProjection=Kx.prototype.Ba;Kx.prototype.getState=Kx.prototype.getState;Kx.prototype.setAttributions=Kx.prototype.wa;Kx.prototype.get=Kx.prototype.get;Kx.prototype.getKeys=Kx.prototype.O;Kx.prototype.getProperties=Kx.prototype.N;Kx.prototype.set=Kx.prototype.set;Kx.prototype.setProperties=Kx.prototype.H;Kx.prototype.unset=Kx.prototype.P;
Kx.prototype.changed=Kx.prototype.s;Kx.prototype.dispatchEvent=Kx.prototype.b;Kx.prototype.getRevision=Kx.prototype.L;Kx.prototype.on=Kx.prototype.J;Kx.prototype.once=Kx.prototype.once;Kx.prototype.un=Kx.prototype.K;Eu.prototype.type=Eu.prototype.type;Eu.prototype.target=Eu.prototype.target;Eu.prototype.preventDefault=Eu.prototype.preventDefault;Eu.prototype.stopPropagation=Eu.prototype.stopPropagation;Tx.prototype.getTileLoadFunction=Tx.prototype.tb;Tx.prototype.getTileUrlFunction=Tx.prototype.ub;
Tx.prototype.getUrls=Tx.prototype.vb;Tx.prototype.setTileLoadFunction=Tx.prototype.zb;Tx.prototype.setTileUrlFunction=Tx.prototype.hb;Tx.prototype.setUrl=Tx.prototype.nb;Tx.prototype.setUrls=Tx.prototype.ib;Tx.prototype.getTileGrid=Tx.prototype.cb;Tx.prototype.refresh=Tx.prototype.ra;Tx.prototype.getAttributions=Tx.prototype.Aa;Tx.prototype.getLogo=Tx.prototype.ya;Tx.prototype.getProjection=Tx.prototype.Ba;Tx.prototype.getState=Tx.prototype.getState;Tx.prototype.setAttributions=Tx.prototype.wa;
Tx.prototype.get=Tx.prototype.get;Tx.prototype.getKeys=Tx.prototype.O;Tx.prototype.getProperties=Tx.prototype.N;Tx.prototype.set=Tx.prototype.set;Tx.prototype.setProperties=Tx.prototype.H;Tx.prototype.unset=Tx.prototype.P;Tx.prototype.changed=Tx.prototype.s;Tx.prototype.dispatchEvent=Tx.prototype.b;Tx.prototype.getRevision=Tx.prototype.L;Tx.prototype.on=Tx.prototype.J;Tx.prototype.once=Tx.prototype.once;Tx.prototype.un=Tx.prototype.K;Z.prototype.setRenderReprojectionEdges=Z.prototype.Nb;
Z.prototype.setTileGridForProjection=Z.prototype.Ob;Z.prototype.getTileLoadFunction=Z.prototype.tb;Z.prototype.getTileUrlFunction=Z.prototype.ub;Z.prototype.getUrls=Z.prototype.vb;Z.prototype.setTileLoadFunction=Z.prototype.zb;Z.prototype.setTileUrlFunction=Z.prototype.hb;Z.prototype.setUrl=Z.prototype.nb;Z.prototype.setUrls=Z.prototype.ib;Z.prototype.getTileGrid=Z.prototype.cb;Z.prototype.refresh=Z.prototype.ra;Z.prototype.getAttributions=Z.prototype.Aa;Z.prototype.getLogo=Z.prototype.ya;
Z.prototype.getProjection=Z.prototype.Ba;Z.prototype.getState=Z.prototype.getState;Z.prototype.setAttributions=Z.prototype.wa;Z.prototype.get=Z.prototype.get;Z.prototype.getKeys=Z.prototype.O;Z.prototype.getProperties=Z.prototype.N;Z.prototype.set=Z.prototype.set;Z.prototype.setProperties=Z.prototype.H;Z.prototype.unset=Z.prototype.P;Z.prototype.changed=Z.prototype.s;Z.prototype.dispatchEvent=Z.prototype.b;Z.prototype.getRevision=Z.prototype.L;Z.prototype.on=Z.prototype.J;Z.prototype.once=Z.prototype.once;
Z.prototype.un=Z.prototype.K;Xx.prototype.setRenderReprojectionEdges=Xx.prototype.Nb;Xx.prototype.setTileGridForProjection=Xx.prototype.Ob;Xx.prototype.getTileLoadFunction=Xx.prototype.tb;Xx.prototype.getTileUrlFunction=Xx.prototype.ub;Xx.prototype.getUrls=Xx.prototype.vb;Xx.prototype.setTileLoadFunction=Xx.prototype.zb;Xx.prototype.setTileUrlFunction=Xx.prototype.hb;Xx.prototype.setUrl=Xx.prototype.nb;Xx.prototype.setUrls=Xx.prototype.ib;Xx.prototype.getTileGrid=Xx.prototype.cb;
Xx.prototype.refresh=Xx.prototype.ra;Xx.prototype.getAttributions=Xx.prototype.Aa;Xx.prototype.getLogo=Xx.prototype.ya;Xx.prototype.getProjection=Xx.prototype.Ba;Xx.prototype.getState=Xx.prototype.getState;Xx.prototype.setAttributions=Xx.prototype.wa;Xx.prototype.get=Xx.prototype.get;Xx.prototype.getKeys=Xx.prototype.O;Xx.prototype.getProperties=Xx.prototype.N;Xx.prototype.set=Xx.prototype.set;Xx.prototype.setProperties=Xx.prototype.H;Xx.prototype.unset=Xx.prototype.P;Xx.prototype.changed=Xx.prototype.s;
Xx.prototype.dispatchEvent=Xx.prototype.b;Xx.prototype.getRevision=Xx.prototype.L;Xx.prototype.on=Xx.prototype.J;Xx.prototype.once=Xx.prototype.once;Xx.prototype.un=Xx.prototype.K;Jw.prototype.getTileCoord=Jw.prototype.i;Jw.prototype.load=Jw.prototype.load;Ut.prototype.changed=Ut.prototype.s;Ut.prototype.dispatchEvent=Ut.prototype.b;Ut.prototype.getRevision=Ut.prototype.L;Ut.prototype.on=Ut.prototype.J;Ut.prototype.once=Ut.prototype.once;Ut.prototype.un=Ut.prototype.K;su.prototype.changed=su.prototype.s;
su.prototype.dispatchEvent=su.prototype.b;su.prototype.getRevision=su.prototype.L;su.prototype.on=su.prototype.J;su.prototype.once=su.prototype.once;su.prototype.un=su.prototype.K;nw.prototype.changed=nw.prototype.s;nw.prototype.dispatchEvent=nw.prototype.b;nw.prototype.getRevision=nw.prototype.L;nw.prototype.on=nw.prototype.J;nw.prototype.once=nw.prototype.once;nw.prototype.un=nw.prototype.K;yw.prototype.changed=yw.prototype.s;yw.prototype.dispatchEvent=yw.prototype.b;yw.prototype.getRevision=yw.prototype.L;
yw.prototype.on=yw.prototype.J;yw.prototype.once=yw.prototype.once;yw.prototype.un=yw.prototype.K;vu.prototype.changed=vu.prototype.s;vu.prototype.dispatchEvent=vu.prototype.b;vu.prototype.getRevision=vu.prototype.L;vu.prototype.on=vu.prototype.J;vu.prototype.once=vu.prototype.once;vu.prototype.un=vu.prototype.K;cu.prototype.changed=cu.prototype.s;cu.prototype.dispatchEvent=cu.prototype.b;cu.prototype.getRevision=cu.prototype.L;cu.prototype.on=cu.prototype.J;cu.prototype.once=cu.prototype.once;
cu.prototype.un=cu.prototype.K;Vv.prototype.changed=Vv.prototype.s;Vv.prototype.dispatchEvent=Vv.prototype.b;Vv.prototype.getRevision=Vv.prototype.L;Vv.prototype.on=Vv.prototype.J;Vv.prototype.once=Vv.prototype.once;Vv.prototype.un=Vv.prototype.K;Wv.prototype.changed=Wv.prototype.s;Wv.prototype.dispatchEvent=Wv.prototype.b;Wv.prototype.getRevision=Wv.prototype.L;Wv.prototype.on=Wv.prototype.J;Wv.prototype.once=Wv.prototype.once;Wv.prototype.un=Wv.prototype.K;rw.prototype.changed=rw.prototype.s;
rw.prototype.dispatchEvent=rw.prototype.b;rw.prototype.getRevision=rw.prototype.L;rw.prototype.on=rw.prototype.J;rw.prototype.once=rw.prototype.once;rw.prototype.un=rw.prototype.K;lu.prototype.changed=lu.prototype.s;lu.prototype.dispatchEvent=lu.prototype.b;lu.prototype.getRevision=lu.prototype.L;lu.prototype.on=lu.prototype.J;lu.prototype.once=lu.prototype.once;lu.prototype.un=lu.prototype.K;Aw.prototype.changed=Aw.prototype.s;Aw.prototype.dispatchEvent=Aw.prototype.b;Aw.prototype.getRevision=Aw.prototype.L;
Aw.prototype.on=Aw.prototype.J;Aw.prototype.once=Aw.prototype.once;Aw.prototype.un=Aw.prototype.K;Yh.prototype.type=Yh.prototype.type;Yh.prototype.target=Yh.prototype.target;Yh.prototype.preventDefault=Yh.prototype.preventDefault;Yh.prototype.stopPropagation=Yh.prototype.stopPropagation;te.prototype.type=te.prototype.type;te.prototype.target=te.prototype.target;te.prototype.preventDefault=te.prototype.preventDefault;te.prototype.stopPropagation=te.prototype.stopPropagation;xh.prototype.get=xh.prototype.get;
xh.prototype.getKeys=xh.prototype.O;xh.prototype.getProperties=xh.prototype.N;xh.prototype.set=xh.prototype.set;xh.prototype.setProperties=xh.prototype.H;xh.prototype.unset=xh.prototype.P;xh.prototype.changed=xh.prototype.s;xh.prototype.dispatchEvent=xh.prototype.b;xh.prototype.getRevision=xh.prototype.L;xh.prototype.on=xh.prototype.J;xh.prototype.once=xh.prototype.once;xh.prototype.un=xh.prototype.K;zh.prototype.getExtent=zh.prototype.G;zh.prototype.getMaxResolution=zh.prototype.fc;
zh.prototype.getMinResolution=zh.prototype.gc;zh.prototype.getOpacity=zh.prototype.hc;zh.prototype.getVisible=zh.prototype.Sb;zh.prototype.getZIndex=zh.prototype.za;zh.prototype.setExtent=zh.prototype.xc;zh.prototype.setMaxResolution=zh.prototype.Bc;zh.prototype.setMinResolution=zh.prototype.Cc;zh.prototype.setOpacity=zh.prototype.yc;zh.prototype.setVisible=zh.prototype.zc;zh.prototype.setZIndex=zh.prototype.Wb;zh.prototype.get=zh.prototype.get;zh.prototype.getKeys=zh.prototype.O;
zh.prototype.getProperties=zh.prototype.N;zh.prototype.set=zh.prototype.set;zh.prototype.setProperties=zh.prototype.H;zh.prototype.unset=zh.prototype.P;zh.prototype.changed=zh.prototype.s;zh.prototype.dispatchEvent=zh.prototype.b;zh.prototype.getRevision=zh.prototype.L;zh.prototype.on=zh.prototype.J;zh.prototype.once=zh.prototype.once;zh.prototype.un=zh.prototype.K;Dh.prototype.getExtent=Dh.prototype.G;Dh.prototype.getMaxResolution=Dh.prototype.fc;Dh.prototype.getMinResolution=Dh.prototype.gc;
Dh.prototype.getOpacity=Dh.prototype.hc;Dh.prototype.getVisible=Dh.prototype.Sb;Dh.prototype.getZIndex=Dh.prototype.za;Dh.prototype.setExtent=Dh.prototype.xc;Dh.prototype.setMaxResolution=Dh.prototype.Bc;Dh.prototype.setMinResolution=Dh.prototype.Cc;Dh.prototype.setOpacity=Dh.prototype.yc;Dh.prototype.setVisible=Dh.prototype.zc;Dh.prototype.setZIndex=Dh.prototype.Wb;Dh.prototype.get=Dh.prototype.get;Dh.prototype.getKeys=Dh.prototype.O;Dh.prototype.getProperties=Dh.prototype.N;Dh.prototype.set=Dh.prototype.set;
Dh.prototype.setProperties=Dh.prototype.H;Dh.prototype.unset=Dh.prototype.P;Dh.prototype.changed=Dh.prototype.s;Dh.prototype.dispatchEvent=Dh.prototype.b;Dh.prototype.getRevision=Dh.prototype.L;Dh.prototype.on=Dh.prototype.J;Dh.prototype.once=Dh.prototype.once;Dh.prototype.un=Dh.prototype.K;S.prototype.setMap=S.prototype.setMap;S.prototype.setSource=S.prototype.Zc;S.prototype.getExtent=S.prototype.G;S.prototype.getMaxResolution=S.prototype.fc;S.prototype.getMinResolution=S.prototype.gc;
S.prototype.getOpacity=S.prototype.hc;S.prototype.getVisible=S.prototype.Sb;S.prototype.getZIndex=S.prototype.za;S.prototype.setExtent=S.prototype.xc;S.prototype.setMaxResolution=S.prototype.Bc;S.prototype.setMinResolution=S.prototype.Cc;S.prototype.setOpacity=S.prototype.yc;S.prototype.setVisible=S.prototype.zc;S.prototype.setZIndex=S.prototype.Wb;S.prototype.get=S.prototype.get;S.prototype.getKeys=S.prototype.O;S.prototype.getProperties=S.prototype.N;S.prototype.set=S.prototype.set;
S.prototype.setProperties=S.prototype.H;S.prototype.unset=S.prototype.P;S.prototype.changed=S.prototype.s;S.prototype.dispatchEvent=S.prototype.b;S.prototype.getRevision=S.prototype.L;S.prototype.on=S.prototype.J;S.prototype.once=S.prototype.once;S.prototype.un=S.prototype.K;W.prototype.getSource=W.prototype.ia;W.prototype.getStyle=W.prototype.u;W.prototype.getStyleFunction=W.prototype.bb;W.prototype.setStyle=W.prototype.i;W.prototype.setMap=W.prototype.setMap;W.prototype.setSource=W.prototype.Zc;
W.prototype.getExtent=W.prototype.G;W.prototype.getMaxResolution=W.prototype.fc;W.prototype.getMinResolution=W.prototype.gc;W.prototype.getOpacity=W.prototype.hc;W.prototype.getVisible=W.prototype.Sb;W.prototype.getZIndex=W.prototype.za;W.prototype.setExtent=W.prototype.xc;W.prototype.setMaxResolution=W.prototype.Bc;W.prototype.setMinResolution=W.prototype.Cc;W.prototype.setOpacity=W.prototype.yc;W.prototype.setVisible=W.prototype.zc;W.prototype.setZIndex=W.prototype.Wb;W.prototype.get=W.prototype.get;
W.prototype.getKeys=W.prototype.O;W.prototype.getProperties=W.prototype.N;W.prototype.set=W.prototype.set;W.prototype.setProperties=W.prototype.H;W.prototype.unset=W.prototype.P;W.prototype.changed=W.prototype.s;W.prototype.dispatchEvent=W.prototype.b;W.prototype.getRevision=W.prototype.L;W.prototype.on=W.prototype.J;W.prototype.once=W.prototype.once;W.prototype.un=W.prototype.K;qw.prototype.setMap=qw.prototype.setMap;qw.prototype.setSource=qw.prototype.Zc;qw.prototype.getExtent=qw.prototype.G;
qw.prototype.getMaxResolution=qw.prototype.fc;qw.prototype.getMinResolution=qw.prototype.gc;qw.prototype.getOpacity=qw.prototype.hc;qw.prototype.getVisible=qw.prototype.Sb;qw.prototype.getZIndex=qw.prototype.za;qw.prototype.setExtent=qw.prototype.xc;qw.prototype.setMaxResolution=qw.prototype.Bc;qw.prototype.setMinResolution=qw.prototype.Cc;qw.prototype.setOpacity=qw.prototype.yc;qw.prototype.setVisible=qw.prototype.zc;qw.prototype.setZIndex=qw.prototype.Wb;qw.prototype.get=qw.prototype.get;
qw.prototype.getKeys=qw.prototype.O;qw.prototype.getProperties=qw.prototype.N;qw.prototype.set=qw.prototype.set;qw.prototype.setProperties=qw.prototype.H;qw.prototype.unset=qw.prototype.P;qw.prototype.changed=qw.prototype.s;qw.prototype.dispatchEvent=qw.prototype.b;qw.prototype.getRevision=qw.prototype.L;qw.prototype.on=qw.prototype.J;qw.prototype.once=qw.prototype.once;qw.prototype.un=qw.prototype.K;zw.prototype.setMap=zw.prototype.setMap;zw.prototype.setSource=zw.prototype.Zc;
zw.prototype.getExtent=zw.prototype.G;zw.prototype.getMaxResolution=zw.prototype.fc;zw.prototype.getMinResolution=zw.prototype.gc;zw.prototype.getOpacity=zw.prototype.hc;zw.prototype.getVisible=zw.prototype.Sb;zw.prototype.getZIndex=zw.prototype.za;zw.prototype.setExtent=zw.prototype.xc;zw.prototype.setMaxResolution=zw.prototype.Bc;zw.prototype.setMinResolution=zw.prototype.Cc;zw.prototype.setOpacity=zw.prototype.yc;zw.prototype.setVisible=zw.prototype.zc;zw.prototype.setZIndex=zw.prototype.Wb;
zw.prototype.get=zw.prototype.get;zw.prototype.getKeys=zw.prototype.O;zw.prototype.getProperties=zw.prototype.N;zw.prototype.set=zw.prototype.set;zw.prototype.setProperties=zw.prototype.H;zw.prototype.unset=zw.prototype.P;zw.prototype.changed=zw.prototype.s;zw.prototype.dispatchEvent=zw.prototype.b;zw.prototype.getRevision=zw.prototype.L;zw.prototype.on=zw.prototype.J;zw.prototype.once=zw.prototype.once;zw.prototype.un=zw.prototype.K;Hw.prototype.getStyle=Hw.prototype.u;
Hw.prototype.getStyleFunction=Hw.prototype.bb;Hw.prototype.setStyle=Hw.prototype.i;Hw.prototype.setMap=Hw.prototype.setMap;Hw.prototype.setSource=Hw.prototype.Zc;Hw.prototype.getExtent=Hw.prototype.G;Hw.prototype.getMaxResolution=Hw.prototype.fc;Hw.prototype.getMinResolution=Hw.prototype.gc;Hw.prototype.getOpacity=Hw.prototype.hc;Hw.prototype.getVisible=Hw.prototype.Sb;Hw.prototype.getZIndex=Hw.prototype.za;Hw.prototype.setExtent=Hw.prototype.xc;Hw.prototype.setMaxResolution=Hw.prototype.Bc;
Hw.prototype.setMinResolution=Hw.prototype.Cc;Hw.prototype.setOpacity=Hw.prototype.yc;Hw.prototype.setVisible=Hw.prototype.zc;Hw.prototype.setZIndex=Hw.prototype.Wb;Hw.prototype.get=Hw.prototype.get;Hw.prototype.getKeys=Hw.prototype.O;Hw.prototype.getProperties=Hw.prototype.N;Hw.prototype.set=Hw.prototype.set;Hw.prototype.setProperties=Hw.prototype.H;Hw.prototype.unset=Hw.prototype.P;Hw.prototype.changed=Hw.prototype.s;Hw.prototype.dispatchEvent=Hw.prototype.b;Hw.prototype.getRevision=Hw.prototype.L;
Hw.prototype.on=Hw.prototype.J;Hw.prototype.once=Hw.prototype.once;Hw.prototype.un=Hw.prototype.K;sg.prototype.get=sg.prototype.get;sg.prototype.getKeys=sg.prototype.O;sg.prototype.getProperties=sg.prototype.N;sg.prototype.set=sg.prototype.set;sg.prototype.setProperties=sg.prototype.H;sg.prototype.unset=sg.prototype.P;sg.prototype.changed=sg.prototype.s;sg.prototype.dispatchEvent=sg.prototype.b;sg.prototype.getRevision=sg.prototype.L;sg.prototype.on=sg.prototype.J;sg.prototype.once=sg.prototype.once;
sg.prototype.un=sg.prototype.K;wg.prototype.getActive=wg.prototype.c;wg.prototype.getMap=wg.prototype.i;wg.prototype.setActive=wg.prototype.Ia;wg.prototype.get=wg.prototype.get;wg.prototype.getKeys=wg.prototype.O;wg.prototype.getProperties=wg.prototype.N;wg.prototype.set=wg.prototype.set;wg.prototype.setProperties=wg.prototype.H;wg.prototype.unset=wg.prototype.P;wg.prototype.changed=wg.prototype.s;wg.prototype.dispatchEvent=wg.prototype.b;wg.prototype.getRevision=wg.prototype.L;wg.prototype.on=wg.prototype.J;
wg.prototype.once=wg.prototype.once;wg.prototype.un=wg.prototype.K;mt.prototype.getActive=mt.prototype.c;mt.prototype.getMap=mt.prototype.i;mt.prototype.setActive=mt.prototype.Ia;mt.prototype.get=mt.prototype.get;mt.prototype.getKeys=mt.prototype.O;mt.prototype.getProperties=mt.prototype.N;mt.prototype.set=mt.prototype.set;mt.prototype.setProperties=mt.prototype.H;mt.prototype.unset=mt.prototype.P;mt.prototype.changed=mt.prototype.s;mt.prototype.dispatchEvent=mt.prototype.b;
mt.prototype.getRevision=mt.prototype.L;mt.prototype.on=mt.prototype.J;mt.prototype.once=mt.prototype.once;mt.prototype.un=mt.prototype.K;pt.prototype.type=pt.prototype.type;pt.prototype.target=pt.prototype.target;pt.prototype.preventDefault=pt.prototype.preventDefault;pt.prototype.stopPropagation=pt.prototype.stopPropagation;Jg.prototype.getActive=Jg.prototype.c;Jg.prototype.getMap=Jg.prototype.i;Jg.prototype.setActive=Jg.prototype.Ia;Jg.prototype.get=Jg.prototype.get;Jg.prototype.getKeys=Jg.prototype.O;
Jg.prototype.getProperties=Jg.prototype.N;Jg.prototype.set=Jg.prototype.set;Jg.prototype.setProperties=Jg.prototype.H;Jg.prototype.unset=Jg.prototype.P;Jg.prototype.changed=Jg.prototype.s;Jg.prototype.dispatchEvent=Jg.prototype.b;Jg.prototype.getRevision=Jg.prototype.L;Jg.prototype.on=Jg.prototype.J;Jg.prototype.once=Jg.prototype.once;Jg.prototype.un=Jg.prototype.K;Xg.prototype.getActive=Xg.prototype.c;Xg.prototype.getMap=Xg.prototype.i;Xg.prototype.setActive=Xg.prototype.Ia;Xg.prototype.get=Xg.prototype.get;
Xg.prototype.getKeys=Xg.prototype.O;Xg.prototype.getProperties=Xg.prototype.N;Xg.prototype.set=Xg.prototype.set;Xg.prototype.setProperties=Xg.prototype.H;Xg.prototype.unset=Xg.prototype.P;Xg.prototype.changed=Xg.prototype.s;Xg.prototype.dispatchEvent=Xg.prototype.b;Xg.prototype.getRevision=Xg.prototype.L;Xg.prototype.on=Xg.prototype.J;Xg.prototype.once=Xg.prototype.once;Xg.prototype.un=Xg.prototype.K;bh.prototype.type=bh.prototype.type;bh.prototype.target=bh.prototype.target;
bh.prototype.preventDefault=bh.prototype.preventDefault;bh.prototype.stopPropagation=bh.prototype.stopPropagation;Mg.prototype.getActive=Mg.prototype.c;Mg.prototype.getMap=Mg.prototype.i;Mg.prototype.setActive=Mg.prototype.Ia;Mg.prototype.get=Mg.prototype.get;Mg.prototype.getKeys=Mg.prototype.O;Mg.prototype.getProperties=Mg.prototype.N;Mg.prototype.set=Mg.prototype.set;Mg.prototype.setProperties=Mg.prototype.H;Mg.prototype.unset=Mg.prototype.P;Mg.prototype.changed=Mg.prototype.s;
Mg.prototype.dispatchEvent=Mg.prototype.b;Mg.prototype.getRevision=Mg.prototype.L;Mg.prototype.on=Mg.prototype.J;Mg.prototype.once=Mg.prototype.once;Mg.prototype.un=Mg.prototype.K;Qg.prototype.getActive=Qg.prototype.c;Qg.prototype.getMap=Qg.prototype.i;Qg.prototype.setActive=Qg.prototype.Ia;Qg.prototype.get=Qg.prototype.get;Qg.prototype.getKeys=Qg.prototype.O;Qg.prototype.getProperties=Qg.prototype.N;Qg.prototype.set=Qg.prototype.set;Qg.prototype.setProperties=Qg.prototype.H;Qg.prototype.unset=Qg.prototype.P;
Qg.prototype.changed=Qg.prototype.s;Qg.prototype.dispatchEvent=Qg.prototype.b;Qg.prototype.getRevision=Qg.prototype.L;Qg.prototype.on=Qg.prototype.J;Qg.prototype.once=Qg.prototype.once;Qg.prototype.un=Qg.prototype.K;tt.prototype.getActive=tt.prototype.c;tt.prototype.getMap=tt.prototype.i;tt.prototype.setActive=tt.prototype.Ia;tt.prototype.get=tt.prototype.get;tt.prototype.getKeys=tt.prototype.O;tt.prototype.getProperties=tt.prototype.N;tt.prototype.set=tt.prototype.set;
tt.prototype.setProperties=tt.prototype.H;tt.prototype.unset=tt.prototype.P;tt.prototype.changed=tt.prototype.s;tt.prototype.dispatchEvent=tt.prototype.b;tt.prototype.getRevision=tt.prototype.L;tt.prototype.on=tt.prototype.J;tt.prototype.once=tt.prototype.once;tt.prototype.un=tt.prototype.K;fh.prototype.getGeometry=fh.prototype.W;fh.prototype.getActive=fh.prototype.c;fh.prototype.getMap=fh.prototype.i;fh.prototype.setActive=fh.prototype.Ia;fh.prototype.get=fh.prototype.get;fh.prototype.getKeys=fh.prototype.O;
fh.prototype.getProperties=fh.prototype.N;fh.prototype.set=fh.prototype.set;fh.prototype.setProperties=fh.prototype.H;fh.prototype.unset=fh.prototype.P;fh.prototype.changed=fh.prototype.s;fh.prototype.dispatchEvent=fh.prototype.b;fh.prototype.getRevision=fh.prototype.L;fh.prototype.on=fh.prototype.J;fh.prototype.once=fh.prototype.once;fh.prototype.un=fh.prototype.K;Hu.prototype.getActive=Hu.prototype.c;Hu.prototype.getMap=Hu.prototype.i;Hu.prototype.setActive=Hu.prototype.Ia;Hu.prototype.get=Hu.prototype.get;
Hu.prototype.getKeys=Hu.prototype.O;Hu.prototype.getProperties=Hu.prototype.N;Hu.prototype.set=Hu.prototype.set;Hu.prototype.setProperties=Hu.prototype.H;Hu.prototype.unset=Hu.prototype.P;Hu.prototype.changed=Hu.prototype.s;Hu.prototype.dispatchEvent=Hu.prototype.b;Hu.prototype.getRevision=Hu.prototype.L;Hu.prototype.on=Hu.prototype.J;Hu.prototype.once=Hu.prototype.once;Hu.prototype.un=Hu.prototype.K;Xu.prototype.type=Xu.prototype.type;Xu.prototype.target=Xu.prototype.target;
Xu.prototype.preventDefault=Xu.prototype.preventDefault;Xu.prototype.stopPropagation=Xu.prototype.stopPropagation;Yu.prototype.getActive=Yu.prototype.c;Yu.prototype.getMap=Yu.prototype.i;Yu.prototype.setActive=Yu.prototype.Ia;Yu.prototype.get=Yu.prototype.get;Yu.prototype.getKeys=Yu.prototype.O;Yu.prototype.getProperties=Yu.prototype.N;Yu.prototype.set=Yu.prototype.set;Yu.prototype.setProperties=Yu.prototype.H;Yu.prototype.unset=Yu.prototype.P;Yu.prototype.changed=Yu.prototype.s;
Yu.prototype.dispatchEvent=Yu.prototype.b;Yu.prototype.getRevision=Yu.prototype.L;Yu.prototype.on=Yu.prototype.J;Yu.prototype.once=Yu.prototype.once;Yu.prototype.un=Yu.prototype.K;iv.prototype.type=iv.prototype.type;iv.prototype.target=iv.prototype.target;iv.prototype.preventDefault=iv.prototype.preventDefault;iv.prototype.stopPropagation=iv.prototype.stopPropagation;gh.prototype.getActive=gh.prototype.c;gh.prototype.getMap=gh.prototype.i;gh.prototype.setActive=gh.prototype.Ia;gh.prototype.get=gh.prototype.get;
gh.prototype.getKeys=gh.prototype.O;gh.prototype.getProperties=gh.prototype.N;gh.prototype.set=gh.prototype.set;gh.prototype.setProperties=gh.prototype.H;gh.prototype.unset=gh.prototype.P;gh.prototype.changed=gh.prototype.s;gh.prototype.dispatchEvent=gh.prototype.b;gh.prototype.getRevision=gh.prototype.L;gh.prototype.on=gh.prototype.J;gh.prototype.once=gh.prototype.once;gh.prototype.un=gh.prototype.K;ih.prototype.getActive=ih.prototype.c;ih.prototype.getMap=ih.prototype.i;ih.prototype.setActive=ih.prototype.Ia;
ih.prototype.get=ih.prototype.get;ih.prototype.getKeys=ih.prototype.O;ih.prototype.getProperties=ih.prototype.N;ih.prototype.set=ih.prototype.set;ih.prototype.setProperties=ih.prototype.H;ih.prototype.unset=ih.prototype.P;ih.prototype.changed=ih.prototype.s;ih.prototype.dispatchEvent=ih.prototype.b;ih.prototype.getRevision=ih.prototype.L;ih.prototype.on=ih.prototype.J;ih.prototype.once=ih.prototype.once;ih.prototype.un=ih.prototype.K;jv.prototype.getActive=jv.prototype.c;jv.prototype.getMap=jv.prototype.i;
jv.prototype.setActive=jv.prototype.Ia;jv.prototype.get=jv.prototype.get;jv.prototype.getKeys=jv.prototype.O;jv.prototype.getProperties=jv.prototype.N;jv.prototype.set=jv.prototype.set;jv.prototype.setProperties=jv.prototype.H;jv.prototype.unset=jv.prototype.P;jv.prototype.changed=jv.prototype.s;jv.prototype.dispatchEvent=jv.prototype.b;jv.prototype.getRevision=jv.prototype.L;jv.prototype.on=jv.prototype.J;jv.prototype.once=jv.prototype.once;jv.prototype.un=jv.prototype.K;rv.prototype.type=rv.prototype.type;
rv.prototype.target=rv.prototype.target;rv.prototype.preventDefault=rv.prototype.preventDefault;rv.prototype.stopPropagation=rv.prototype.stopPropagation;kh.prototype.getActive=kh.prototype.c;kh.prototype.getMap=kh.prototype.i;kh.prototype.setActive=kh.prototype.Ia;kh.prototype.get=kh.prototype.get;kh.prototype.getKeys=kh.prototype.O;kh.prototype.getProperties=kh.prototype.N;kh.prototype.set=kh.prototype.set;kh.prototype.setProperties=kh.prototype.H;kh.prototype.unset=kh.prototype.P;
kh.prototype.changed=kh.prototype.s;kh.prototype.dispatchEvent=kh.prototype.b;kh.prototype.getRevision=kh.prototype.L;kh.prototype.on=kh.prototype.J;kh.prototype.once=kh.prototype.once;kh.prototype.un=kh.prototype.K;oh.prototype.getActive=oh.prototype.c;oh.prototype.getMap=oh.prototype.i;oh.prototype.setActive=oh.prototype.Ia;oh.prototype.get=oh.prototype.get;oh.prototype.getKeys=oh.prototype.O;oh.prototype.getProperties=oh.prototype.N;oh.prototype.set=oh.prototype.set;
oh.prototype.setProperties=oh.prototype.H;oh.prototype.unset=oh.prototype.P;oh.prototype.changed=oh.prototype.s;oh.prototype.dispatchEvent=oh.prototype.b;oh.prototype.getRevision=oh.prototype.L;oh.prototype.on=oh.prototype.J;oh.prototype.once=oh.prototype.once;oh.prototype.un=oh.prototype.K;sh.prototype.getActive=sh.prototype.c;sh.prototype.getMap=sh.prototype.i;sh.prototype.setActive=sh.prototype.Ia;sh.prototype.get=sh.prototype.get;sh.prototype.getKeys=sh.prototype.O;
sh.prototype.getProperties=sh.prototype.N;sh.prototype.set=sh.prototype.set;sh.prototype.setProperties=sh.prototype.H;sh.prototype.unset=sh.prototype.P;sh.prototype.changed=sh.prototype.s;sh.prototype.dispatchEvent=sh.prototype.b;sh.prototype.getRevision=sh.prototype.L;sh.prototype.on=sh.prototype.J;sh.prototype.once=sh.prototype.once;sh.prototype.un=sh.prototype.K;zv.prototype.getActive=zv.prototype.c;zv.prototype.getMap=zv.prototype.i;zv.prototype.setActive=zv.prototype.Ia;zv.prototype.get=zv.prototype.get;
zv.prototype.getKeys=zv.prototype.O;zv.prototype.getProperties=zv.prototype.N;zv.prototype.set=zv.prototype.set;zv.prototype.setProperties=zv.prototype.H;zv.prototype.unset=zv.prototype.P;zv.prototype.changed=zv.prototype.s;zv.prototype.dispatchEvent=zv.prototype.b;zv.prototype.getRevision=zv.prototype.L;zv.prototype.on=zv.prototype.J;zv.prototype.once=zv.prototype.once;zv.prototype.un=zv.prototype.K;Cv.prototype.type=Cv.prototype.type;Cv.prototype.target=Cv.prototype.target;
Cv.prototype.preventDefault=Cv.prototype.preventDefault;Cv.prototype.stopPropagation=Cv.prototype.stopPropagation;Ev.prototype.getActive=Ev.prototype.c;Ev.prototype.getMap=Ev.prototype.i;Ev.prototype.setActive=Ev.prototype.Ia;Ev.prototype.get=Ev.prototype.get;Ev.prototype.getKeys=Ev.prototype.O;Ev.prototype.getProperties=Ev.prototype.N;Ev.prototype.set=Ev.prototype.set;Ev.prototype.setProperties=Ev.prototype.H;Ev.prototype.unset=Ev.prototype.P;Ev.prototype.changed=Ev.prototype.s;
Ev.prototype.dispatchEvent=Ev.prototype.b;Ev.prototype.getRevision=Ev.prototype.L;Ev.prototype.on=Ev.prototype.J;Ev.prototype.once=Ev.prototype.once;Ev.prototype.un=Ev.prototype.K;Jv.prototype.getActive=Jv.prototype.c;Jv.prototype.getMap=Jv.prototype.i;Jv.prototype.setActive=Jv.prototype.Ia;Jv.prototype.get=Jv.prototype.get;Jv.prototype.getKeys=Jv.prototype.O;Jv.prototype.getProperties=Jv.prototype.N;Jv.prototype.set=Jv.prototype.set;Jv.prototype.setProperties=Jv.prototype.H;Jv.prototype.unset=Jv.prototype.P;
Jv.prototype.changed=Jv.prototype.s;Jv.prototype.dispatchEvent=Jv.prototype.b;Jv.prototype.getRevision=Jv.prototype.L;Jv.prototype.on=Jv.prototype.J;Jv.prototype.once=Jv.prototype.once;Jv.prototype.un=Jv.prototype.K;Pv.prototype.type=Pv.prototype.type;Pv.prototype.target=Pv.prototype.target;Pv.prototype.preventDefault=Pv.prototype.preventDefault;Pv.prototype.stopPropagation=Pv.prototype.stopPropagation;rf.prototype.get=rf.prototype.get;rf.prototype.getKeys=rf.prototype.O;
rf.prototype.getProperties=rf.prototype.N;rf.prototype.set=rf.prototype.set;rf.prototype.setProperties=rf.prototype.H;rf.prototype.unset=rf.prototype.P;rf.prototype.changed=rf.prototype.s;rf.prototype.dispatchEvent=rf.prototype.b;rf.prototype.getRevision=rf.prototype.L;rf.prototype.on=rf.prototype.J;rf.prototype.once=rf.prototype.once;rf.prototype.un=rf.prototype.K;uf.prototype.getClosestPoint=uf.prototype.Db;uf.prototype.intersectsCoordinate=uf.prototype.wb;uf.prototype.getExtent=uf.prototype.G;
uf.prototype.rotate=uf.prototype.rotate;uf.prototype.scale=uf.prototype.scale;uf.prototype.simplify=uf.prototype.Pb;uf.prototype.transform=uf.prototype.mb;uf.prototype.get=uf.prototype.get;uf.prototype.getKeys=uf.prototype.O;uf.prototype.getProperties=uf.prototype.N;uf.prototype.set=uf.prototype.set;uf.prototype.setProperties=uf.prototype.H;uf.prototype.unset=uf.prototype.P;uf.prototype.changed=uf.prototype.s;uf.prototype.dispatchEvent=uf.prototype.b;uf.prototype.getRevision=uf.prototype.L;
uf.prototype.on=uf.prototype.J;uf.prototype.once=uf.prototype.once;uf.prototype.un=uf.prototype.K;Ss.prototype.getFirstCoordinate=Ss.prototype.bc;Ss.prototype.getLastCoordinate=Ss.prototype.cc;Ss.prototype.getLayout=Ss.prototype.dc;Ss.prototype.rotate=Ss.prototype.rotate;Ss.prototype.scale=Ss.prototype.scale;Ss.prototype.getClosestPoint=Ss.prototype.Db;Ss.prototype.intersectsCoordinate=Ss.prototype.wb;Ss.prototype.getExtent=Ss.prototype.G;Ss.prototype.simplify=Ss.prototype.Pb;Ss.prototype.get=Ss.prototype.get;
Ss.prototype.getKeys=Ss.prototype.O;Ss.prototype.getProperties=Ss.prototype.N;Ss.prototype.set=Ss.prototype.set;Ss.prototype.setProperties=Ss.prototype.H;Ss.prototype.unset=Ss.prototype.P;Ss.prototype.changed=Ss.prototype.s;Ss.prototype.dispatchEvent=Ss.prototype.b;Ss.prototype.getRevision=Ss.prototype.L;Ss.prototype.on=Ss.prototype.J;Ss.prototype.once=Ss.prototype.once;Ss.prototype.un=Ss.prototype.K;Nm.prototype.getClosestPoint=Nm.prototype.Db;Nm.prototype.intersectsCoordinate=Nm.prototype.wb;
Nm.prototype.getExtent=Nm.prototype.G;Nm.prototype.rotate=Nm.prototype.rotate;Nm.prototype.scale=Nm.prototype.scale;Nm.prototype.simplify=Nm.prototype.Pb;Nm.prototype.transform=Nm.prototype.mb;Nm.prototype.get=Nm.prototype.get;Nm.prototype.getKeys=Nm.prototype.O;Nm.prototype.getProperties=Nm.prototype.N;Nm.prototype.set=Nm.prototype.set;Nm.prototype.setProperties=Nm.prototype.H;Nm.prototype.unset=Nm.prototype.P;Nm.prototype.changed=Nm.prototype.s;Nm.prototype.dispatchEvent=Nm.prototype.b;
Nm.prototype.getRevision=Nm.prototype.L;Nm.prototype.on=Nm.prototype.J;Nm.prototype.once=Nm.prototype.once;Nm.prototype.un=Nm.prototype.K;Of.prototype.getFirstCoordinate=Of.prototype.bc;Of.prototype.getLastCoordinate=Of.prototype.cc;Of.prototype.getLayout=Of.prototype.dc;Of.prototype.rotate=Of.prototype.rotate;Of.prototype.scale=Of.prototype.scale;Of.prototype.getClosestPoint=Of.prototype.Db;Of.prototype.intersectsCoordinate=Of.prototype.wb;Of.prototype.getExtent=Of.prototype.G;
Of.prototype.simplify=Of.prototype.Pb;Of.prototype.transform=Of.prototype.mb;Of.prototype.get=Of.prototype.get;Of.prototype.getKeys=Of.prototype.O;Of.prototype.getProperties=Of.prototype.N;Of.prototype.set=Of.prototype.set;Of.prototype.setProperties=Of.prototype.H;Of.prototype.unset=Of.prototype.P;Of.prototype.changed=Of.prototype.s;Of.prototype.dispatchEvent=Of.prototype.b;Of.prototype.getRevision=Of.prototype.L;Of.prototype.on=Of.prototype.J;Of.prototype.once=Of.prototype.once;Of.prototype.un=Of.prototype.K;
M.prototype.getFirstCoordinate=M.prototype.bc;M.prototype.getLastCoordinate=M.prototype.cc;M.prototype.getLayout=M.prototype.dc;M.prototype.rotate=M.prototype.rotate;M.prototype.scale=M.prototype.scale;M.prototype.getClosestPoint=M.prototype.Db;M.prototype.intersectsCoordinate=M.prototype.wb;M.prototype.getExtent=M.prototype.G;M.prototype.simplify=M.prototype.Pb;M.prototype.transform=M.prototype.mb;M.prototype.get=M.prototype.get;M.prototype.getKeys=M.prototype.O;M.prototype.getProperties=M.prototype.N;
M.prototype.set=M.prototype.set;M.prototype.setProperties=M.prototype.H;M.prototype.unset=M.prototype.P;M.prototype.changed=M.prototype.s;M.prototype.dispatchEvent=M.prototype.b;M.prototype.getRevision=M.prototype.L;M.prototype.on=M.prototype.J;M.prototype.once=M.prototype.once;M.prototype.un=M.prototype.K;N.prototype.getFirstCoordinate=N.prototype.bc;N.prototype.getLastCoordinate=N.prototype.cc;N.prototype.getLayout=N.prototype.dc;N.prototype.rotate=N.prototype.rotate;N.prototype.scale=N.prototype.scale;
N.prototype.getClosestPoint=N.prototype.Db;N.prototype.intersectsCoordinate=N.prototype.wb;N.prototype.getExtent=N.prototype.G;N.prototype.simplify=N.prototype.Pb;N.prototype.transform=N.prototype.mb;N.prototype.get=N.prototype.get;N.prototype.getKeys=N.prototype.O;N.prototype.getProperties=N.prototype.N;N.prototype.set=N.prototype.set;N.prototype.setProperties=N.prototype.H;N.prototype.unset=N.prototype.P;N.prototype.changed=N.prototype.s;N.prototype.dispatchEvent=N.prototype.b;
N.prototype.getRevision=N.prototype.L;N.prototype.on=N.prototype.J;N.prototype.once=N.prototype.once;N.prototype.un=N.prototype.K;O.prototype.getFirstCoordinate=O.prototype.bc;O.prototype.getLastCoordinate=O.prototype.cc;O.prototype.getLayout=O.prototype.dc;O.prototype.rotate=O.prototype.rotate;O.prototype.scale=O.prototype.scale;O.prototype.getClosestPoint=O.prototype.Db;O.prototype.intersectsCoordinate=O.prototype.wb;O.prototype.getExtent=O.prototype.G;O.prototype.simplify=O.prototype.Pb;
O.prototype.transform=O.prototype.mb;O.prototype.get=O.prototype.get;O.prototype.getKeys=O.prototype.O;O.prototype.getProperties=O.prototype.N;O.prototype.set=O.prototype.set;O.prototype.setProperties=O.prototype.H;O.prototype.unset=O.prototype.P;O.prototype.changed=O.prototype.s;O.prototype.dispatchEvent=O.prototype.b;O.prototype.getRevision=O.prototype.L;O.prototype.on=O.prototype.J;O.prototype.once=O.prototype.once;O.prototype.un=O.prototype.K;P.prototype.getFirstCoordinate=P.prototype.bc;
P.prototype.getLastCoordinate=P.prototype.cc;P.prototype.getLayout=P.prototype.dc;P.prototype.rotate=P.prototype.rotate;P.prototype.scale=P.prototype.scale;P.prototype.getClosestPoint=P.prototype.Db;P.prototype.intersectsCoordinate=P.prototype.wb;P.prototype.getExtent=P.prototype.G;P.prototype.simplify=P.prototype.Pb;P.prototype.transform=P.prototype.mb;P.prototype.get=P.prototype.get;P.prototype.getKeys=P.prototype.O;P.prototype.getProperties=P.prototype.N;P.prototype.set=P.prototype.set;
P.prototype.setProperties=P.prototype.H;P.prototype.unset=P.prototype.P;P.prototype.changed=P.prototype.s;P.prototype.dispatchEvent=P.prototype.b;P.prototype.getRevision=P.prototype.L;P.prototype.on=P.prototype.J;P.prototype.once=P.prototype.once;P.prototype.un=P.prototype.K;C.prototype.getFirstCoordinate=C.prototype.bc;C.prototype.getLastCoordinate=C.prototype.cc;C.prototype.getLayout=C.prototype.dc;C.prototype.rotate=C.prototype.rotate;C.prototype.scale=C.prototype.scale;
C.prototype.getClosestPoint=C.prototype.Db;C.prototype.intersectsCoordinate=C.prototype.wb;C.prototype.getExtent=C.prototype.G;C.prototype.simplify=C.prototype.Pb;C.prototype.transform=C.prototype.mb;C.prototype.get=C.prototype.get;C.prototype.getKeys=C.prototype.O;C.prototype.getProperties=C.prototype.N;C.prototype.set=C.prototype.set;C.prototype.setProperties=C.prototype.H;C.prototype.unset=C.prototype.P;C.prototype.changed=C.prototype.s;C.prototype.dispatchEvent=C.prototype.b;
C.prototype.getRevision=C.prototype.L;C.prototype.on=C.prototype.J;C.prototype.once=C.prototype.once;C.prototype.un=C.prototype.K;D.prototype.getFirstCoordinate=D.prototype.bc;D.prototype.getLastCoordinate=D.prototype.cc;D.prototype.getLayout=D.prototype.dc;D.prototype.rotate=D.prototype.rotate;D.prototype.scale=D.prototype.scale;D.prototype.getClosestPoint=D.prototype.Db;D.prototype.intersectsCoordinate=D.prototype.wb;D.prototype.getExtent=D.prototype.G;D.prototype.simplify=D.prototype.Pb;
D.prototype.transform=D.prototype.mb;D.prototype.get=D.prototype.get;D.prototype.getKeys=D.prototype.O;D.prototype.getProperties=D.prototype.N;D.prototype.set=D.prototype.set;D.prototype.setProperties=D.prototype.H;D.prototype.unset=D.prototype.P;D.prototype.changed=D.prototype.s;D.prototype.dispatchEvent=D.prototype.b;D.prototype.getRevision=D.prototype.L;D.prototype.on=D.prototype.J;D.prototype.once=D.prototype.once;D.prototype.un=D.prototype.K;mn.prototype.readFeatures=mn.prototype.Oa;
vn.prototype.readFeatures=vn.prototype.Oa;mn.prototype.readFeatures=mn.prototype.Oa;od.prototype.get=od.prototype.get;od.prototype.getKeys=od.prototype.O;od.prototype.getProperties=od.prototype.N;od.prototype.set=od.prototype.set;od.prototype.setProperties=od.prototype.H;od.prototype.unset=od.prototype.P;od.prototype.changed=od.prototype.s;od.prototype.dispatchEvent=od.prototype.b;od.prototype.getRevision=od.prototype.L;od.prototype.on=od.prototype.J;od.prototype.once=od.prototype.once;
od.prototype.un=od.prototype.K;pd.prototype.getMap=pd.prototype.g;pd.prototype.setMap=pd.prototype.setMap;pd.prototype.setTarget=pd.prototype.i;pd.prototype.get=pd.prototype.get;pd.prototype.getKeys=pd.prototype.O;pd.prototype.getProperties=pd.prototype.N;pd.prototype.set=pd.prototype.set;pd.prototype.setProperties=pd.prototype.H;pd.prototype.unset=pd.prototype.P;pd.prototype.changed=pd.prototype.s;pd.prototype.dispatchEvent=pd.prototype.b;pd.prototype.getRevision=pd.prototype.L;pd.prototype.on=pd.prototype.J;
pd.prototype.once=pd.prototype.once;pd.prototype.un=pd.prototype.K;Ad.prototype.getMap=Ad.prototype.g;Ad.prototype.setMap=Ad.prototype.setMap;Ad.prototype.setTarget=Ad.prototype.i;Ad.prototype.get=Ad.prototype.get;Ad.prototype.getKeys=Ad.prototype.O;Ad.prototype.getProperties=Ad.prototype.N;Ad.prototype.set=Ad.prototype.set;Ad.prototype.setProperties=Ad.prototype.H;Ad.prototype.unset=Ad.prototype.P;Ad.prototype.changed=Ad.prototype.s;Ad.prototype.dispatchEvent=Ad.prototype.b;
Ad.prototype.getRevision=Ad.prototype.L;Ad.prototype.on=Ad.prototype.J;Ad.prototype.once=Ad.prototype.once;Ad.prototype.un=Ad.prototype.K;Fd.prototype.getMap=Fd.prototype.g;Fd.prototype.setMap=Fd.prototype.setMap;Fd.prototype.setTarget=Fd.prototype.i;Fd.prototype.get=Fd.prototype.get;Fd.prototype.getKeys=Fd.prototype.O;Fd.prototype.getProperties=Fd.prototype.N;Fd.prototype.set=Fd.prototype.set;Fd.prototype.setProperties=Fd.prototype.H;Fd.prototype.unset=Fd.prototype.P;Fd.prototype.changed=Fd.prototype.s;
Fd.prototype.dispatchEvent=Fd.prototype.b;Fd.prototype.getRevision=Fd.prototype.L;Fd.prototype.on=Fd.prototype.J;Fd.prototype.once=Fd.prototype.once;Fd.prototype.un=Fd.prototype.K;Uk.prototype.getMap=Uk.prototype.g;Uk.prototype.setMap=Uk.prototype.setMap;Uk.prototype.setTarget=Uk.prototype.i;Uk.prototype.get=Uk.prototype.get;Uk.prototype.getKeys=Uk.prototype.O;Uk.prototype.getProperties=Uk.prototype.N;Uk.prototype.set=Uk.prototype.set;Uk.prototype.setProperties=Uk.prototype.H;Uk.prototype.unset=Uk.prototype.P;
Uk.prototype.changed=Uk.prototype.s;Uk.prototype.dispatchEvent=Uk.prototype.b;Uk.prototype.getRevision=Uk.prototype.L;Uk.prototype.on=Uk.prototype.J;Uk.prototype.once=Uk.prototype.once;Uk.prototype.un=Uk.prototype.K;wd.prototype.getMap=wd.prototype.g;wd.prototype.setMap=wd.prototype.setMap;wd.prototype.setTarget=wd.prototype.i;wd.prototype.get=wd.prototype.get;wd.prototype.getKeys=wd.prototype.O;wd.prototype.getProperties=wd.prototype.N;wd.prototype.set=wd.prototype.set;
wd.prototype.setProperties=wd.prototype.H;wd.prototype.unset=wd.prototype.P;wd.prototype.changed=wd.prototype.s;wd.prototype.dispatchEvent=wd.prototype.b;wd.prototype.getRevision=wd.prototype.L;wd.prototype.on=wd.prototype.J;wd.prototype.once=wd.prototype.once;wd.prototype.un=wd.prototype.K;Zk.prototype.getMap=Zk.prototype.g;Zk.prototype.setMap=Zk.prototype.setMap;Zk.prototype.setTarget=Zk.prototype.i;Zk.prototype.get=Zk.prototype.get;Zk.prototype.getKeys=Zk.prototype.O;
Zk.prototype.getProperties=Zk.prototype.N;Zk.prototype.set=Zk.prototype.set;Zk.prototype.setProperties=Zk.prototype.H;Zk.prototype.unset=Zk.prototype.P;Zk.prototype.changed=Zk.prototype.s;Zk.prototype.dispatchEvent=Zk.prototype.b;Zk.prototype.getRevision=Zk.prototype.L;Zk.prototype.on=Zk.prototype.J;Zk.prototype.once=Zk.prototype.once;Zk.prototype.un=Zk.prototype.K;yd.prototype.getMap=yd.prototype.g;yd.prototype.setMap=yd.prototype.setMap;yd.prototype.setTarget=yd.prototype.i;yd.prototype.get=yd.prototype.get;
yd.prototype.getKeys=yd.prototype.O;yd.prototype.getProperties=yd.prototype.N;yd.prototype.set=yd.prototype.set;yd.prototype.setProperties=yd.prototype.H;yd.prototype.unset=yd.prototype.P;yd.prototype.changed=yd.prototype.s;yd.prototype.dispatchEvent=yd.prototype.b;yd.prototype.getRevision=yd.prototype.L;yd.prototype.on=yd.prototype.J;yd.prototype.once=yd.prototype.once;yd.prototype.un=yd.prototype.K;dl.prototype.getMap=dl.prototype.g;dl.prototype.setMap=dl.prototype.setMap;
dl.prototype.setTarget=dl.prototype.i;dl.prototype.get=dl.prototype.get;dl.prototype.getKeys=dl.prototype.O;dl.prototype.getProperties=dl.prototype.N;dl.prototype.set=dl.prototype.set;dl.prototype.setProperties=dl.prototype.H;dl.prototype.unset=dl.prototype.P;dl.prototype.changed=dl.prototype.s;dl.prototype.dispatchEvent=dl.prototype.b;dl.prototype.getRevision=dl.prototype.L;dl.prototype.on=dl.prototype.J;dl.prototype.once=dl.prototype.once;dl.prototype.un=dl.prototype.K;il.prototype.getMap=il.prototype.g;
il.prototype.setMap=il.prototype.setMap;il.prototype.setTarget=il.prototype.i;il.prototype.get=il.prototype.get;il.prototype.getKeys=il.prototype.O;il.prototype.getProperties=il.prototype.N;il.prototype.set=il.prototype.set;il.prototype.setProperties=il.prototype.H;il.prototype.unset=il.prototype.P;il.prototype.changed=il.prototype.s;il.prototype.dispatchEvent=il.prototype.b;il.prototype.getRevision=il.prototype.L;il.prototype.on=il.prototype.J;il.prototype.once=il.prototype.once;
il.prototype.un=il.prototype.K;
  return OPENLAYERS.ol;
}));



/***/ }),

/***/ "./dependencies/shpwrite.js":
/*!**********************************!*\
  !*** ./dependencies/shpwrite.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {var require;var require;(function(f){if(true){module.exports=f()}else { var g; }})(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return require(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

// when used in node, this will actually load the util module we depend on
// versus loading the builtin util module as happens otherwise
// this is a bug in node module loading as far as I am concerned
var util = require('util/');

var pSlice = Array.prototype.slice;
var hasOwn = Object.prototype.hasOwnProperty;

// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;

  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  }
  else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = stackStartFunction.name;
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function replacer(key, value) {
  if (util.isUndefined(value)) {
    return '' + value;
  }
  if (util.isNumber(value) && !isFinite(value)) {
    return value.toString();
  }
  if (util.isFunction(value) || util.isRegExp(value)) {
    return value.toString();
  }
  return value;
}

function truncate(s, n) {
  if (util.isString(s)) {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}

function getMessage(self) {
  return truncate(JSON.stringify(self.actual, replacer), 128) + ' ' +
         self.operator + ' ' +
         truncate(JSON.stringify(self.expected, replacer), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

function _deepEqual(actual, expected) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (util.isBuffer(actual) && util.isBuffer(expected)) {
    if (actual.length != expected.length) return false;

    for (var i = 0; i < actual.length; i++) {
      if (actual[i] !== expected[i]) return false;
    }

    return true;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!util.isObject(actual) && !util.isObject(expected)) {
    return actual == expected;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b) {
  if (util.isNullOrUndefined(a) || util.isNullOrUndefined(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b)) {
    return a === b;
  }
  var aIsArgs = isArguments(a),
      bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b);
  }
  var ka = objectKeys(a),
      kb = objectKeys(b),
      key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key])) return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  } else if (actual instanceof expected) {
    return true;
  } else if (expected.call({}, actual) === true) {
    return true;
  }

  return false;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (util.isString(expected)) {
    message = expected;
    expected = null;
  }

  try {
    block();
  } catch (e) {
    actual = e;
  }

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  if (!shouldThrow && expectedException(actual, expected)) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws.apply(this, [true].concat(pSlice.call(arguments)));
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/message) {
  _throws.apply(this, [false].concat(pSlice.call(arguments)));
};

assert.ifError = function(err) { if (err) {throw err;}};

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

},{"util/":107}],2:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function placeHoldersCount (b64) {
  var len = b64.length
  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // the number of equal signs (place holders)
  // if there are two placeholders, than the two characters before it
  // represent one byte
  // if there is only one, then the three characters before it represent 2 bytes
  // this is just a cheap hack to not do indexOf twice
  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
}

function byteLength (b64) {
  // base64 is 4/3 + up to two characters of the original data
  return b64.length * 3 / 4 - placeHoldersCount(b64)
}

function toByteArray (b64) {
  var i, j, l, tmp, placeHolders, arr
  var len = b64.length
  placeHolders = placeHoldersCount(b64)

  arr = new Arr(len * 3 / 4 - placeHolders)

  // if there are placeholders, only get up to the last complete 4 chars
  l = placeHolders > 0 ? len - 4 : len

  var L = 0

  for (i = 0, j = 0; i < l; i += 4, j += 3) {
    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
    arr[L++] = (tmp >> 16) & 0xFF
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  if (placeHolders === 2) {
    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[L++] = tmp & 0xFF
  } else if (placeHolders === 1) {
    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[L++] = (tmp >> 8) & 0xFF
    arr[L++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var output = ''
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    output += lookup[tmp >> 2]
    output += lookup[(tmp << 4) & 0x3F]
    output += '=='
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
    output += lookup[tmp >> 10]
    output += lookup[(tmp >> 4) & 0x3F]
    output += lookup[(tmp << 2) & 0x3F]
    output += '='
  }

  parts.push(output)

  return parts.join('')
}

},{}],3:[function(require,module,exports){

},{}],4:[function(require,module,exports){
(function (global){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')
var isArray = require('isarray')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"base64-js":2,"ieee754":33,"isarray":37}],5:[function(require,module,exports){
require('../modules/web.immediate');
module.exports = require('../modules/_core').setImmediate;
},{"../modules/_core":9,"../modules/web.immediate":25}],6:[function(require,module,exports){
module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};
},{}],7:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};
},{"./_is-object":20}],8:[function(require,module,exports){
var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};
},{}],9:[function(require,module,exports){
var core = module.exports = {version: '2.3.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
},{}],10:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};
},{"./_a-function":6}],11:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_fails":14}],12:[function(require,module,exports){
var isObject = require('./_is-object')
  , document = require('./_global').document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};
},{"./_global":15,"./_is-object":20}],13:[function(require,module,exports){
var global    = require('./_global')
  , core      = require('./_core')
  , ctx       = require('./_ctx')
  , hide      = require('./_hide')
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;
},{"./_core":9,"./_ctx":10,"./_global":15,"./_hide":16}],14:[function(require,module,exports){
module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};
},{}],15:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
},{}],16:[function(require,module,exports){
var dP         = require('./_object-dp')
  , createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};
},{"./_descriptors":11,"./_object-dp":21,"./_property-desc":22}],17:[function(require,module,exports){
module.exports = require('./_global').document && document.documentElement;
},{"./_global":15}],18:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function(){
  return Object.defineProperty(require('./_dom-create')('div'), 'a', {get: function(){ return 7; }}).a != 7;
});
},{"./_descriptors":11,"./_dom-create":12,"./_fails":14}],19:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};
},{}],20:[function(require,module,exports){
module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};
},{}],21:[function(require,module,exports){
var anObject       = require('./_an-object')
  , IE8_DOM_DEFINE = require('./_ie8-dom-define')
  , toPrimitive    = require('./_to-primitive')
  , dP             = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};
},{"./_an-object":7,"./_descriptors":11,"./_ie8-dom-define":18,"./_to-primitive":24}],22:[function(require,module,exports){
module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};
},{}],23:[function(require,module,exports){
var ctx                = require('./_ctx')
  , invoke             = require('./_invoke')
  , html               = require('./_html')
  , cel                = require('./_dom-create')
  , global             = require('./_global')
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(require('./_cof')(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};
},{"./_cof":8,"./_ctx":10,"./_dom-create":12,"./_global":15,"./_html":17,"./_invoke":19}],24:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};
},{"./_is-object":20}],25:[function(require,module,exports){
var $export = require('./_export')
  , $task   = require('./_task');
$export($export.G + $export.B, {
  setImmediate:   $task.set,
  clearImmediate: $task.clear
});
},{"./_export":13,"./_task":23}],26:[function(require,module,exports){
(function (Buffer){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

}).call(this,{"isBuffer":require("../../is-buffer/index.js")})
},{"../../is-buffer/index.js":36}],27:[function(require,module,exports){
module.exports.structure = require('./src/structure');

},{"./src/structure":31}],28:[function(require,module,exports){
var fieldSize = require('./fieldsize');

var types = {
    string: 'C',
    number: 'N',
    boolean: 'L',
    // type to use if all values of a field are null
    null: 'C'
};

module.exports.multi = multi;
module.exports.bytesPer = bytesPer;
module.exports.obj = obj;

function multi(features) {
    var fields = {};
    features.forEach(collect);
    function collect(f) { inherit(fields, f); }
    return obj(fields);
}

/**
 * @param {Object} a
 * @param {Object} b
 * @returns {Object}
 */
function inherit(a, b) {
    for (var i in b) {
        var isDef = typeof b[i] !== 'undefined' && b[i] !== null;
        if (typeof a[i] === 'undefined' || isDef) {
          a[i] = b[i];
        }
    }
    return a;
}

function obj(_) {
    var fields = {}, o = [];
    for (var p in _) fields[p] = _[p] === null ? 'null' : typeof _[p];
    for (var n in fields) {
        var t = types[fields[n]];
        if(t){
             o.push({
                name: n,
                type: t,
                size: fieldSize[t]
            });
        }
    }
    return o;
}

/**
 * @param {Array} fields
 * @returns {Array}
 */
function bytesPer(fields) {
    // deleted flag
    return fields.reduce(function(memo, f) { return memo + f.size; }, 1);
}

},{"./fieldsize":29}],29:[function(require,module,exports){
module.exports = {
    // string
    C: 254,
    // boolean
    L: 1,
    // date
    D: 8,
    // number
    N: 18,
    // number
    M: 18,
    // number, float
    F: 18,
    // number
    B: 8,
};

},{}],30:[function(require,module,exports){
/**
 * @param {string} str
 * @param {number} len
 * @param {string} char
 * @returns {string}
 */
module.exports.lpad = function lpad(str, len, char) {
    while (str.length < len) { str = char + str; } return str;
};

/**
 * @param {string} str
 * @param {number} len
 * @param {string} char
 * @returns {string}
 */
module.exports.rpad = function rpad(str, len, char) {
    while (str.length < len) { str = str + char; } return str;
};

/**
 * @param {object} view
 * @param {number} fieldLength
 * @param {string} str
 * @param {number} offset
 * @returns {number}
 */
module.exports.writeField = function writeField(view, fieldLength, str, offset) {
    for (var i = 0; i < fieldLength; i++) {
        view.setUint8(offset, str.charCodeAt(i)); offset++;
    }
    return offset;
};

},{}],31:[function(require,module,exports){
var fieldSize = require('./fieldsize'),
    lib = require('./lib'),
    fields = require('./fields');

/**
 * @param {Array} data
 * @param {Array} meta
 * @returns {Object} view
 */
module.exports = function structure(data, meta) {

    var field_meta = meta || fields.multi(data),
        fieldDescLength = (32 * field_meta.length) + 1,
        bytesPerRecord = fields.bytesPer(field_meta), // deleted flag
        buffer = new ArrayBuffer(
            // field header
            fieldDescLength +
            // header
            32 +
            // contents
            (bytesPerRecord * data.length) +
            // EOF marker
            1
    ),
        now = new Date(),
        view = new DataView(buffer);

    // version number - dBase III
    view.setUint8(0, 0x03);
    // date of last update
    view.setUint8(1, now.getFullYear() - 1900);
    view.setUint8(2, now.getMonth());
    view.setUint8(3, now.getDate());
    // number of records
    view.setUint32(4, data.length, true);

    // length of header
    var headerLength = fieldDescLength + 32;
    view.setUint16(8, headerLength, true);
    // length of each record
    view.setUint16(10, bytesPerRecord, true);

    // Terminator
    view.setInt8(32 + fieldDescLength - 1, 0x0D);

    field_meta.forEach(function(f, i) {
        // field name
        f.name.split('').slice(0, 8).forEach(function(c, x) {
            view.setInt8(32 + i * 32 + x, c.charCodeAt(0));
        });
        // field type
        view.setInt8(32 + i * 32 + 11, f.type.charCodeAt(0));
        // field length
        view.setInt8(32 + i * 32 + 16, f.size);
        if (f.type == 'N') view.setInt8(32 + i * 32 + 17, 3);
    });

    offset = fieldDescLength + 32;

    data.forEach(function(row, num) {
        // delete flag: this is not deleted
        view.setUint8(offset, 32);
        offset++;
        field_meta.forEach(function(f) {
            var val = row[f.name];
            if (val === null || typeof val === 'undefined') val = '';

            switch (f.type) {
                // boolean
                case 'L':
                    view.setUint8(offset, val ? 84 : 70);
                    offset++;
                    break;

                // date
                case 'D':
                    offset = lib.writeField(view, 8,
                        lib.lpad(val.toString(), 8, ' '), offset);
                    break;

                // number
                case 'N':
                    offset = lib.writeField(view, f.size,
                        lib.lpad(val.toString(), f.size, ' ').substr(0, 18),
                        offset);
                    break;

                // string
                case 'C':
                    offset = lib.writeField(view, f.size,
                        lib.rpad(val.toString(), f.size, ' '), offset);
                    break;

                default:
                    throw new Error('Unknown field type');
            }
        });
    });

    // EOF flag
    view.setUint8(offset, 0x1A);

    return view;
};

},{"./fields":28,"./fieldsize":29,"./lib":30}],32:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}],33:[function(require,module,exports){
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],34:[function(require,module,exports){
(function (global){
'use strict';
var Mutation = global.MutationObserver || global.WebKitMutationObserver;

var scheduleDrain;

{
  if (Mutation) {
    var called = 0;
    var observer = new Mutation(nextTick);
    var element = global.document.createTextNode('');
    observer.observe(element, {
      characterData: true
    });
    scheduleDrain = function () {
      element.data = (called = ++called % 2);
    };
  } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
    var channel = new global.MessageChannel();
    channel.port1.onmessage = nextTick;
    scheduleDrain = function () {
      channel.port2.postMessage(0);
    };
  } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
    scheduleDrain = function () {

      // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
      // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
      var scriptEl = global.document.createElement('script');
      scriptEl.onreadystatechange = function () {
        nextTick();

        scriptEl.onreadystatechange = null;
        scriptEl.parentNode.removeChild(scriptEl);
        scriptEl = null;
      };
      global.document.documentElement.appendChild(scriptEl);
    };
  } else {
    scheduleDrain = function () {
      setTimeout(nextTick, 0);
    };
  }
}

var draining;
var queue = [];
//named nextTick for less confusing stack traces
function nextTick() {
  draining = true;
  var i, oldQueue;
  var len = queue.length;
  while (len) {
    oldQueue = queue;
    queue = [];
    i = -1;
    while (++i < len) {
      oldQueue[i]();
    }
    len = queue.length;
  }
  draining = false;
}

module.exports = immediate;
function immediate(task) {
  if (queue.push(task) === 1 && !draining) {
    scheduleDrain();
  }
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],35:[function(require,module,exports){
if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}

},{}],36:[function(require,module,exports){
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
}

function isBuffer (obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer (obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
}

},{}],37:[function(require,module,exports){
var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};

},{}],38:[function(require,module,exports){
'use strict';
var utils = require('./utils');
var support = require('./support');
// private property
var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";


// public method for encoding
exports.encode = function(input) {
    var output = [];
    var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    var i = 0, len = input.length, remainingBytes = len;

    var isArray = utils.getTypeOf(input) !== "string";
    while (i < input.length) {
        remainingBytes = len - i;

        if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
        } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
        }

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = remainingBytes > 1 ? (((chr2 & 15) << 2) | (chr3 >> 6)) : 64;
        enc4 = remainingBytes > 2 ? (chr3 & 63) : 64;

        output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));

    }

    return output.join("");
};

// public method for decoding
exports.decode = function(input) {
    var chr1, chr2, chr3;
    var enc1, enc2, enc3, enc4;
    var i = 0, resultIndex = 0;

    var dataUrlPrefix = "data:";

    if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
        // This is a common error: people give a data url
        // (data:image/png;base64,iVBOR...) with a {base64: true} and
        // wonders why things don't work.
        // We can detect that the string input looks like a data url but we
        // *can't* be sure it is one: removing everything up to the comma would
        // be too dangerous.
        throw new Error("Invalid base64 input, it looks like a data url.");
    }

    input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");

    var totalLength = input.length * 3 / 4;
    if(input.charAt(input.length - 1) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if(input.charAt(input.length - 2) === _keyStr.charAt(64)) {
        totalLength--;
    }
    if (totalLength % 1 !== 0) {
        // totalLength is not an integer, the length does not match a valid
        // base64 content. That can happen if:
        // - the input is not a base64 content
        // - the input is *almost* a base64 content, with a extra chars at the
        //   beginning or at the end
        // - the input uses a base64 variant (base64url for example)
        throw new Error("Invalid base64 input, bad content length.");
    }
    var output;
    if (support.uint8array) {
        output = new Uint8Array(totalLength|0);
    } else {
        output = new Array(totalLength|0);
    }

    while (i < input.length) {

        enc1 = _keyStr.indexOf(input.charAt(i++));
        enc2 = _keyStr.indexOf(input.charAt(i++));
        enc3 = _keyStr.indexOf(input.charAt(i++));
        enc4 = _keyStr.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        output[resultIndex++] = chr1;

        if (enc3 !== 64) {
            output[resultIndex++] = chr2;
        }
        if (enc4 !== 64) {
            output[resultIndex++] = chr3;
        }

    }

    return output;
};

},{"./support":67,"./utils":69}],39:[function(require,module,exports){
'use strict';

var external = require("./external");
var DataWorker = require('./stream/DataWorker');
var DataLengthProbe = require('./stream/DataLengthProbe');
var Crc32Probe = require('./stream/Crc32Probe');
var DataLengthProbe = require('./stream/DataLengthProbe');

/**
 * Represent a compressed object, with everything needed to decompress it.
 * @constructor
 * @param {number} compressedSize the size of the data compressed.
 * @param {number} uncompressedSize the size of the data after decompression.
 * @param {number} crc32 the crc32 of the decompressed file.
 * @param {object} compression the type of compression, see lib/compressions.js.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
 */
function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
    this.compressedSize = compressedSize;
    this.uncompressedSize = uncompressedSize;
    this.crc32 = crc32;
    this.compression = compression;
    this.compressedContent = data;
}

CompressedObject.prototype = {
    /**
     * Create a worker to get the uncompressed content.
     * @return {GenericWorker} the worker.
     */
    getContentWorker : function () {
        var worker = new DataWorker(external.Promise.resolve(this.compressedContent))
        .pipe(this.compression.uncompressWorker())
        .pipe(new DataLengthProbe("data_length"));

        var that = this;
        worker.on("end", function () {
            if(this.streamInfo['data_length'] !== that.uncompressedSize) {
                throw new Error("Bug : uncompressed data size mismatch");
            }
        });
        return worker;
    },
    /**
     * Create a worker to get the compressed content.
     * @return {GenericWorker} the worker.
     */
    getCompressedWorker : function () {
        return new DataWorker(external.Promise.resolve(this.compressedContent))
        .withStreamInfo("compressedSize", this.compressedSize)
        .withStreamInfo("uncompressedSize", this.uncompressedSize)
        .withStreamInfo("crc32", this.crc32)
        .withStreamInfo("compression", this.compression)
        ;
    }
};

/**
 * Chain the given worker with other workers to compress the content with the
 * given compresion.
 * @param {GenericWorker} uncompressedWorker the worker to pipe.
 * @param {Object} compression the compression object.
 * @param {Object} compressionOptions the options to use when compressing.
 * @return {GenericWorker} the new worker compressing the content.
 */
CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
    return uncompressedWorker
    .pipe(new Crc32Probe())
    .pipe(new DataLengthProbe("uncompressedSize"))
    .pipe(compression.compressWorker(compressionOptions))
    .pipe(new DataLengthProbe("compressedSize"))
    .withStreamInfo("compression", compression);
};

module.exports = CompressedObject;

},{"./external":43,"./stream/Crc32Probe":62,"./stream/DataLengthProbe":63,"./stream/DataWorker":64}],40:[function(require,module,exports){
'use strict';

var GenericWorker = require("./stream/GenericWorker");

exports.STORE = {
    magic: "\x00\x00",
    compressWorker : function (compressionOptions) {
        return new GenericWorker("STORE compression");
    },
    uncompressWorker : function () {
        return new GenericWorker("STORE decompression");
    }
};
exports.DEFLATE = require('./flate');

},{"./flate":44,"./stream/GenericWorker":65}],41:[function(require,module,exports){
'use strict';

var utils = require('./utils');

/**
 * The following functions come from pako, from pako/lib/zlib/crc32.js
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Use ordinary array, since untyped makes no boost here
function makeTable() {
    var c, table = [];

    for(var n =0; n < 256; n++){
        c = n;
        for(var k =0; k < 8; k++){
            c = ((c&1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
        }
        table[n] = c;
    }

    return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

// That's all for the pako functions.

/**
 * Compute the crc32 of a string.
 * This is almost the same as the function crc32, but for strings. Using the
 * same function for the two use cases leads to horrible performances.
 * @param {Number} crc the starting value of the crc.
 * @param {String} str the string to use.
 * @param {Number} len the length of the string.
 * @param {Number} pos the starting position for the crc32 computation.
 * @return {Number} the computed crc32.
 */
function crc32str(crc, str, len, pos) {
    var t = crcTable, end = pos + len;

    crc = crc ^ (-1);

    for (var i = pos; i < end; i++ ) {
        crc = (crc >>> 8) ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
    }

    return (crc ^ (-1)); // >>> 0;
}

module.exports = function crc32wrapper(input, crc) {
    if (typeof input === "undefined" || !input.length) {
        return 0;
    }

    var isArray = utils.getTypeOf(input) !== "string";

    if(isArray) {
        return crc32(crc|0, input, input.length, 0);
    } else {
        return crc32str(crc|0, input, input.length, 0);
    }
};
// vim: set shiftwidth=4 softtabstop=4:

},{"./utils":69}],42:[function(require,module,exports){
'use strict';
exports.base64 = false;
exports.binary = false;
exports.dir = false;
exports.createFolders = true;
exports.date = null;
exports.compression = null;
exports.compressionOptions = null;
exports.comment = null;
exports.unixPermissions = null;
exports.dosPermissions = null;

},{}],43:[function(require,module,exports){
/* global Promise */
'use strict';

// load the global object first:
// - it should be better integrated in the system (unhandledRejection in node)
// - the environment may have a custom Promise implementation (see zone.js)
var ES6Promise = null;
if (typeof Promise !== "undefined") {
    ES6Promise = Promise;
} else {
    ES6Promise = require("lie");
}

/**
 * Let the user use/change some implementations.
 */
module.exports = {
    Promise: ES6Promise
};

},{"lie":73}],44:[function(require,module,exports){
'use strict';
var USE_TYPEDARRAY = (typeof Uint8Array !== 'undefined') && (typeof Uint16Array !== 'undefined') && (typeof Uint32Array !== 'undefined');

var pako = require("pako");
var utils = require("./utils");
var GenericWorker = require("./stream/GenericWorker");

var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";

exports.magic = "\x08\x00";

/**
 * Create a worker that uses pako to inflate/deflate.
 * @constructor
 * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
 * @param {Object} options the options to use when (de)compressing.
 */
function FlateWorker(action, options) {
    GenericWorker.call(this, "FlateWorker/" + action);

    this._pako = new pako[action]({
        raw:true,
        level : options.level || -1 // default compression
    });
    // the `meta` object from the last chunk received
    // this allow this worker to pass around metadata
    this.meta = {};

    var self = this;
    this._pako.onData = function(data) {
        self.push({
            data : data,
            meta : self.meta
        });
    };
}

utils.inherits(FlateWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
FlateWorker.prototype.processChunk = function (chunk) {
    this.meta = chunk.meta;
    this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
};

/**
 * @see GenericWorker.flush
 */
FlateWorker.prototype.flush = function () {
    GenericWorker.prototype.flush.call(this);
    this._pako.push([], true);
};
/**
 * @see GenericWorker.cleanUp
 */
FlateWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this._pako = null;
};

exports.compressWorker = function (compressionOptions) {
    return new FlateWorker("Deflate", compressionOptions);
};
exports.uncompressWorker = function () {
    return new FlateWorker("Inflate", {});
};

},{"./stream/GenericWorker":65,"./utils":69,"pako":74}],45:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('../stream/GenericWorker');
var utf8 = require('../utf8');
var crc32 = require('../crc32');
var signature = require('../signature');

/**
 * Transform an integer into a string in hexadecimal.
 * @private
 * @param {number} dec the number to convert.
 * @param {number} bytes the number of bytes to generate.
 * @returns {string} the result.
 */
var decToHex = function(dec, bytes) {
    var hex = "", i;
    for (i = 0; i < bytes; i++) {
        hex += String.fromCharCode(dec & 0xff);
        dec = dec >>> 8;
    }
    return hex;
};

/**
 * Generate the UNIX part of the external file attributes.
 * @param {Object} unixPermissions the unix permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
 *
 * TTTTsstrwxrwxrwx0000000000ADVSHR
 * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
 *     ^^^_________________________ setuid, setgid, sticky
 *        ^^^^^^^^^________________ permissions
 *                 ^^^^^^^^^^______ not used ?
 *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
 */
var generateUnixExternalFileAttr = function (unixPermissions, isDir) {

    var result = unixPermissions;
    if (!unixPermissions) {
        // I can't use octal values in strict mode, hence the hexa.
        //  040775 => 0x41fd
        // 0100664 => 0x81b4
        result = isDir ? 0x41fd : 0x81b4;
    }
    return (result & 0xFFFF) << 16;
};

/**
 * Generate the DOS part of the external file attributes.
 * @param {Object} dosPermissions the dos permissions or null.
 * @param {Boolean} isDir true if the entry is a directory, false otherwise.
 * @return {Number} a 32 bit integer.
 *
 * Bit 0     Read-Only
 * Bit 1     Hidden
 * Bit 2     System
 * Bit 3     Volume Label
 * Bit 4     Directory
 * Bit 5     Archive
 */
var generateDosExternalFileAttr = function (dosPermissions, isDir) {

    // the dir flag is already set for compatibility
    return (dosPermissions || 0)  & 0x3F;
};

/**
 * Generate the various parts used in the construction of the final zip file.
 * @param {Object} streamInfo the hash with informations about the compressed file.
 * @param {Boolean} streamedContent is the content streamed ?
 * @param {Boolean} streamingEnded is the stream finished ?
 * @param {number} offset the current offset from the start of the zip file.
 * @param {String} platform let's pretend we are this platform (change platform dependents fields)
 * @param {Function} encodeFileName the function to encode the file name / comment.
 * @return {Object} the zip parts.
 */
var generateZipParts = function(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
    var file = streamInfo['file'],
    compression = streamInfo['compression'],
    useCustomEncoding = encodeFileName !== utf8.utf8encode,
    encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
    utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
    comment = file.comment,
    encodedComment = utils.transformTo("string", encodeFileName(comment)),
    utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
    useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
    useUTF8ForComment = utfEncodedComment.length !== comment.length,
    dosTime,
    dosDate,
    extraFields = "",
    unicodePathExtraField = "",
    unicodeCommentExtraField = "",
    dir = file.dir,
    date = file.date;


    var dataInfo = {
        crc32 : 0,
        compressedSize : 0,
        uncompressedSize : 0
    };

    // if the content is streamed, the sizes/crc32 are only available AFTER
    // the end of the stream.
    if (!streamedContent || streamingEnded) {
        dataInfo.crc32 = streamInfo['crc32'];
        dataInfo.compressedSize = streamInfo['compressedSize'];
        dataInfo.uncompressedSize = streamInfo['uncompressedSize'];
    }

    var bitflag = 0;
    if (streamedContent) {
        // Bit 3: the sizes/crc32 are set to zero in the local header.
        // The correct values are put in the data descriptor immediately
        // following the compressed data.
        bitflag |= 0x0008;
    }
    if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
        // Bit 11: Language encoding flag (EFS).
        bitflag |= 0x0800;
    }


    var extFileAttr = 0;
    var versionMadeBy = 0;
    if (dir) {
        // dos or unix, we set the dos dir flag
        extFileAttr |= 0x00010;
    }
    if(platform === "UNIX") {
        versionMadeBy = 0x031E; // UNIX, version 3.0
        extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
    } else { // DOS or other, fallback to DOS
        versionMadeBy = 0x0014; // DOS, version 2.0
        extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
    }

    // date
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
    // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

    dosTime = date.getUTCHours();
    dosTime = dosTime << 6;
    dosTime = dosTime | date.getUTCMinutes();
    dosTime = dosTime << 5;
    dosTime = dosTime | date.getUTCSeconds() / 2;

    dosDate = date.getUTCFullYear() - 1980;
    dosDate = dosDate << 4;
    dosDate = dosDate | (date.getUTCMonth() + 1);
    dosDate = dosDate << 5;
    dosDate = dosDate | date.getUTCDate();

    if (useUTF8ForFileName) {
        // set the unicode path extra field. unzip needs at least one extra
        // field to correctly handle unicode path, so using the path is as good
        // as any other information. This could improve the situation with
        // other archive managers too.
        // This field is usually used without the utf8 flag, with a non
        // unicode path in the header (winrar, winzip). This helps (a bit)
        // with the messy Windows' default compressed folders feature but
        // breaks on p7zip which doesn't seek the unicode path extra field.
        // So for now, UTF-8 everywhere !
        unicodePathExtraField =
            // Version
            decToHex(1, 1) +
            // NameCRC32
            decToHex(crc32(encodedFileName), 4) +
            // UnicodeName
            utfEncodedFileName;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x70" +
            // size
            decToHex(unicodePathExtraField.length, 2) +
            // content
            unicodePathExtraField;
    }

    if(useUTF8ForComment) {

        unicodeCommentExtraField =
            // Version
            decToHex(1, 1) +
            // CommentCRC32
            decToHex(crc32(encodedComment), 4) +
            // UnicodeName
            utfEncodedComment;

        extraFields +=
            // Info-ZIP Unicode Path Extra Field
            "\x75\x63" +
            // size
            decToHex(unicodeCommentExtraField.length, 2) +
            // content
            unicodeCommentExtraField;
    }

    var header = "";

    // version needed to extract
    header += "\x0A\x00";
    // general purpose bit flag
    header += decToHex(bitflag, 2);
    // compression method
    header += compression.magic;
    // last mod file time
    header += decToHex(dosTime, 2);
    // last mod file date
    header += decToHex(dosDate, 2);
    // crc-32
    header += decToHex(dataInfo.crc32, 4);
    // compressed size
    header += decToHex(dataInfo.compressedSize, 4);
    // uncompressed size
    header += decToHex(dataInfo.uncompressedSize, 4);
    // file name length
    header += decToHex(encodedFileName.length, 2);
    // extra field length
    header += decToHex(extraFields.length, 2);


    var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;

    var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;

    return {
        fileRecord: fileRecord,
        dirRecord: dirRecord
    };
};

/**
 * Generate the EOCD record.
 * @param {Number} entriesCount the number of entries in the zip file.
 * @param {Number} centralDirLength the length (in bytes) of the central dir.
 * @param {Number} localDirLength the length (in bytes) of the local dir.
 * @param {String} comment the zip file comment as a binary string.
 * @param {Function} encodeFileName the function to encode the comment.
 * @return {String} the EOCD record.
 */
var generateCentralDirectoryEnd = function (entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
    var dirEnd = "";
    var encodedComment = utils.transformTo("string", encodeFileName(comment));

    // end of central dir signature
    dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;

    return dirEnd;
};

/**
 * Generate data descriptors for a file entry.
 * @param {Object} streamInfo the hash generated by a worker, containing informations
 * on the file entry.
 * @return {String} the data descriptors.
 */
var generateDataDescriptors = function (streamInfo) {
    var descriptor = "";
    descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo['crc32'], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo['compressedSize'], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo['uncompressedSize'], 4);

    return descriptor;
};


/**
 * A worker to concatenate other workers to create a zip file.
 * @param {Boolean} streamFiles `true` to stream the content of the files,
 * `false` to accumulate it.
 * @param {String} comment the comment to use.
 * @param {String} platform the platform to use, "UNIX" or "DOS".
 * @param {Function} encodeFileName the function to encode file names and comments.
 */
function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
    GenericWorker.call(this, "ZipFileWorker");
    // The number of bytes written so far. This doesn't count accumulated chunks.
    this.bytesWritten = 0;
    // The comment of the zip file
    this.zipComment = comment;
    // The platform "generating" the zip file.
    this.zipPlatform = platform;
    // the function to encode file names and comments.
    this.encodeFileName = encodeFileName;
    // Should we stream the content of the files ?
    this.streamFiles = streamFiles;
    // If `streamFiles` is false, we will need to accumulate the content of the
    // files to calculate sizes / crc32 (and write them *before* the content).
    // This boolean indicates if we are accumulating chunks (it will change a lot
    // during the lifetime of this worker).
    this.accumulate = false;
    // The buffer receiving chunks when accumulating content.
    this.contentBuffer = [];
    // The list of generated directory records.
    this.dirRecords = [];
    // The offset (in bytes) from the beginning of the zip file for the current source.
    this.currentSourceOffset = 0;
    // The total number of entries in this zip file.
    this.entriesCount = 0;
    // the name of the file currently being added, null when handling the end of the zip file.
    // Used for the emited metadata.
    this.currentFile = null;



    this._sources = [];
}
utils.inherits(ZipFileWorker, GenericWorker);

/**
 * @see GenericWorker.push
 */
ZipFileWorker.prototype.push = function (chunk) {

    var currentFilePercent = chunk.meta.percent || 0;
    var entriesCount = this.entriesCount;
    var remainingFiles = this._sources.length;

    if(this.accumulate) {
        this.contentBuffer.push(chunk);
    } else {
        this.bytesWritten += chunk.data.length;

        GenericWorker.prototype.push.call(this, {
            data : chunk.data,
            meta : {
                currentFile : this.currentFile,
                percent : entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
        });
    }
};

/**
 * The worker started a new source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the new source.
 */
ZipFileWorker.prototype.openedSource = function (streamInfo) {
    this.currentSourceOffset = this.bytesWritten;
    this.currentFile = streamInfo['file'].name;

    var streamedContent = this.streamFiles && !streamInfo['file'].dir;

    // don't stream folders (because they don't have any content)
    if(streamedContent) {
        var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
    } else {
        // we need to wait for the whole file before pushing anything
        this.accumulate = true;
    }
};

/**
 * The worker finished a source (an other worker).
 * @param {Object} streamInfo the streamInfo object from the finished source.
 */
ZipFileWorker.prototype.closedSource = function (streamInfo) {
    this.accumulate = false;
    var streamedContent = this.streamFiles && !streamInfo['file'].dir;
    var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);

    this.dirRecords.push(record.dirRecord);
    if(streamedContent) {
        // after the streamed file, we put data descriptors
        this.push({
            data : generateDataDescriptors(streamInfo),
            meta : {percent:100}
        });
    } else {
        // the content wasn't streamed, we need to push everything now
        // first the file record, then the content
        this.push({
            data : record.fileRecord,
            meta : {percent:0}
        });
        while(this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
        }
    }
    this.currentFile = null;
};

/**
 * @see GenericWorker.flush
 */
ZipFileWorker.prototype.flush = function () {

    var localDirLength = this.bytesWritten;
    for(var i = 0; i < this.dirRecords.length; i++) {
        this.push({
            data : this.dirRecords[i],
            meta : {percent:100}
        });
    }
    var centralDirLength = this.bytesWritten - localDirLength;

    var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);

    this.push({
        data : dirEnd,
        meta : {percent:100}
    });
};

/**
 * Prepare the next source to be read.
 */
ZipFileWorker.prototype.prepareNextSource = function () {
    this.previous = this._sources.shift();
    this.openedSource(this.previous.streamInfo);
    if (this.isPaused) {
        this.previous.pause();
    } else {
        this.previous.resume();
    }
};

/**
 * @see GenericWorker.registerPrevious
 */
ZipFileWorker.prototype.registerPrevious = function (previous) {
    this._sources.push(previous);
    var self = this;

    previous.on('data', function (chunk) {
        self.processChunk(chunk);
    });
    previous.on('end', function () {
        self.closedSource(self.previous.streamInfo);
        if(self._sources.length) {
            self.prepareNextSource();
        } else {
            self.end();
        }
    });
    previous.on('error', function (e) {
        self.error(e);
    });
    return this;
};

/**
 * @see GenericWorker.resume
 */
ZipFileWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this.previous && this._sources.length) {
        this.prepareNextSource();
        return true;
    }
    if (!this.previous && !this._sources.length && !this.generatedError) {
        this.end();
        return true;
    }
};

/**
 * @see GenericWorker.error
 */
ZipFileWorker.prototype.error = function (e) {
    var sources = this._sources;
    if(!GenericWorker.prototype.error.call(this, e)) {
        return false;
    }
    for(var i = 0; i < sources.length; i++) {
        try {
            sources[i].error(e);
        } catch(e) {
            // the `error` exploded, nothing to do
        }
    }
    return true;
};

/**
 * @see GenericWorker.lock
 */
ZipFileWorker.prototype.lock = function () {
    GenericWorker.prototype.lock.call(this);
    var sources = this._sources;
    for(var i = 0; i < sources.length; i++) {
        sources[i].lock();
    }
};

module.exports = ZipFileWorker;

},{"../crc32":41,"../signature":60,"../stream/GenericWorker":65,"../utf8":68,"../utils":69}],46:[function(require,module,exports){
'use strict';

var compressions = require('../compressions');
var ZipFileWorker = require('./ZipFileWorker');

/**
 * Find the compression to use.
 * @param {String} fileCompression the compression defined at the file level, if any.
 * @param {String} zipCompression the compression defined at the load() level.
 * @return {Object} the compression object to use.
 */
var getCompression = function (fileCompression, zipCompression) {

    var compressionName = fileCompression || zipCompression;
    var compression = compressions[compressionName];
    if (!compression) {
        throw new Error(compressionName + " is not a valid compression method !");
    }
    return compression;
};

/**
 * Create a worker to generate a zip file.
 * @param {JSZip} zip the JSZip instance at the right root level.
 * @param {Object} options to generate the zip file.
 * @param {String} comment the comment to use.
 */
exports.generateWorker = function (zip, options, comment) {

    var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
    var entriesCount = 0;
    try {

        zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir, date = file.date;

            file._compressWorker(compression, compressionOptions)
            .withStreamInfo("file", {
                name : relativePath,
                dir : dir,
                date : date,
                comment : file.comment || "",
                unixPermissions : file.unixPermissions,
                dosPermissions : file.dosPermissions
            })
            .pipe(zipFileWorker);
        });
        zipFileWorker.entriesCount = entriesCount;
    } catch (e) {
        zipFileWorker.error(e);
    }

    return zipFileWorker;
};

},{"../compressions":40,"./ZipFileWorker":45}],47:[function(require,module,exports){
'use strict';

/**
 * Representation a of zip file in js
 * @constructor
 */
function JSZip() {
    // if this constructor is used without `new`, it adds `new` before itself:
    if(!(this instanceof JSZip)) {
        return new JSZip();
    }

    if(arguments.length) {
        throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
    }

    // object containing the files :
    // {
    //   "folder/" : {...},
    //   "folder/data.txt" : {...}
    // }
    this.files = {};

    this.comment = null;

    // Where we are in the hierarchy
    this.root = "";
    this.clone = function() {
        var newObj = new JSZip();
        for (var i in this) {
            if (typeof this[i] !== "function") {
                newObj[i] = this[i];
            }
        }
        return newObj;
    };
}
JSZip.prototype = require('./object');
JSZip.prototype.loadAsync = require('./load');
JSZip.support = require('./support');
JSZip.defaults = require('./defaults');

// TODO find a better way to handle this version,
// a require('package.json').version doesn't work with webpack, see #327
JSZip.version = "3.1.3";

JSZip.loadAsync = function (content, options) {
    return new JSZip().loadAsync(content, options);
};

JSZip.external = require("./external");
module.exports = JSZip;

},{"./defaults":42,"./external":43,"./load":48,"./object":52,"./support":67}],48:[function(require,module,exports){
'use strict';
var utils = require('./utils');
var external = require("./external");
var utf8 = require('./utf8');
var utils = require('./utils');
var ZipEntries = require('./zipEntries');
var Crc32Probe = require('./stream/Crc32Probe');
var nodejsUtils = require("./nodejsUtils");

/**
 * Check the CRC32 of an entry.
 * @param {ZipEntry} zipEntry the zip entry to check.
 * @return {Promise} the result.
 */
function checkEntryCRC32(zipEntry) {
    return new external.Promise(function (resolve, reject) {
        var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
        worker.on("error", function (e) {
            reject(e);
        })
        .on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
                reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
                resolve();
            }
        })
        .resume();
    });
}

module.exports = function(data, options) {
    var zip = this;
    options = utils.extend(options || {}, {
        base64: false,
        checkCRC32: false,
        optimizedBinaryString: false,
        createFolders: false,
        decodeFileName: utf8.utf8decode
    });

    if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
    }

    return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64)
    .then(function(data) {
        var zipEntries = new ZipEntries(options);
        zipEntries.load(data);
        return zipEntries;
    }).then(function checkCRC32(zipEntries) {
        var promises = [external.Promise.resolve(zipEntries)];
        var files = zipEntries.files;
        if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
                promises.push(checkEntryCRC32(files[i]));
            }
        }
        return external.Promise.all(promises);
    }).then(function addFiles(results) {
        var zipEntries = results.shift();
        var files = zipEntries.files;
        for (var i = 0; i < files.length; i++) {
            var input = files[i];
            zip.file(input.fileNameStr, input.decompressed, {
                binary: true,
                optimizedBinaryString: true,
                date: input.date,
                dir: input.dir,
                comment : input.fileCommentStr.length ? input.fileCommentStr : null,
                unixPermissions : input.unixPermissions,
                dosPermissions : input.dosPermissions,
                createFolders: options.createFolders
            });
        }
        if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
        }

        return zip;
    });
};

},{"./external":43,"./nodejsUtils":51,"./stream/Crc32Probe":62,"./utf8":68,"./utils":69,"./zipEntries":70}],49:[function(require,module,exports){
"use strict";

var utils = require('../utils');
var GenericWorker = require('../stream/GenericWorker');

/**
 * A worker that use a nodejs stream as source.
 * @constructor
 * @param {String} filename the name of the file entry for this stream.
 * @param {Readable} stream the nodejs stream.
 */
function NodejsStreamInputAdapter(filename, stream) {
    GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
    this._upstreamEnded = false;
    this._bindStream(stream);
}

utils.inherits(NodejsStreamInputAdapter, GenericWorker);

/**
 * Prepare the stream and bind the callbacks on it.
 * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
 * @param {Stream} stream the nodejs stream to use.
 */
NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
    var self = this;
    this._stream = stream;
    stream.pause();
    stream
    .on("data", function (chunk) {
        self.push({
            data: chunk,
            meta : {
                percent : 0
            }
        });
    })
    .on("error", function (e) {
        if(self.isPaused) {
            this.generatedError = e;
        } else {
            self.error(e);
        }
    })
    .on("end", function () {
        if(self.isPaused) {
            self._upstreamEnded = true;
        } else {
            self.end();
        }
    });
};
NodejsStreamInputAdapter.prototype.pause = function () {
    if(!GenericWorker.prototype.pause.call(this)) {
        return false;
    }
    this._stream.pause();
    return true;
};
NodejsStreamInputAdapter.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if(this._upstreamEnded) {
        this.end();
    } else {
        this._stream.resume();
    }

    return true;
};

module.exports = NodejsStreamInputAdapter;

},{"../stream/GenericWorker":65,"../utils":69}],50:[function(require,module,exports){
'use strict';

var Readable = require('readable-stream').Readable;

var util = require('util');
util.inherits(NodejsStreamOutputAdapter, Readable);

/**
* A nodejs stream using a worker as source.
* @see the SourceWrapper in http://nodejs.org/api/stream.html
* @constructor
* @param {StreamHelper} helper the helper wrapping the worker
* @param {Object} options the nodejs stream options
* @param {Function} updateCb the update callback.
*/
function NodejsStreamOutputAdapter(helper, options, updateCb) {
    Readable.call(this, options);
    this._helper = helper;

    var self = this;
    helper.on("data", function (data, meta) {
        if (!self.push(data)) {
            self._helper.pause();
        }
        if(updateCb) {
            updateCb(meta);
        }
    })
    .on("error", function(e) {
        self.emit('error', e);
    })
    .on("end", function () {
        self.push(null);
    });
}


NodejsStreamOutputAdapter.prototype._read = function() {
    this._helper.resume();
};

module.exports = NodejsStreamOutputAdapter;

},{"readable-stream":53,"util":107}],51:[function(require,module,exports){
(function (Buffer){
'use strict';

module.exports = {
    /**
     * True if this is running in Nodejs, will be undefined in a browser.
     * In a browser, browserify won't include this file and the whole module
     * will be resolved an empty object.
     */
    isNode : typeof Buffer !== "undefined",
    /**
     * Create a new nodejs Buffer.
     * @param {Object} data the data to pass to the constructor.
     * @param {String} encoding the encoding to use.
     * @return {Buffer} a new Buffer.
     */
    newBuffer : function(data, encoding){
        return new Buffer(data, encoding);
    },
    /**
     * Find out if an object is a Buffer.
     * @param {Object} b the object to test.
     * @return {Boolean} true if the object is a Buffer, false otherwise.
     */
    isBuffer : function(b){
        return Buffer.isBuffer(b);
    },

    isStream : function (obj) {
        return obj &&
            typeof obj.on === "function" &&
            typeof obj.pause === "function" &&
            typeof obj.resume === "function";
    }
};

}).call(this,require("buffer").Buffer)
},{"buffer":4}],52:[function(require,module,exports){
'use strict';
var utf8 = require('./utf8');
var utils = require('./utils');
var GenericWorker = require('./stream/GenericWorker');
var StreamHelper = require('./stream/StreamHelper');
var defaults = require('./defaults');
var CompressedObject = require('./compressedObject');
var ZipObject = require('./zipObject');
var generate = require("./generate");
var nodejsUtils = require("./nodejsUtils");
var NodejsStreamInputAdapter = require("./nodejs/NodejsStreamInputAdapter");


/**
 * Add a file in the current folder.
 * @private
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
 * @param {Object} originalOptions the options of the file
 * @return {Object} the new file.
 */
var fileAdd = function(name, data, originalOptions) {
    // be sure sub folders exist
    var dataType = utils.getTypeOf(data),
        parent;


    /*
     * Correct options.
     */

    var o = utils.extend(originalOptions || {}, defaults);
    o.date = o.date || new Date();
    if (o.compression !== null) {
        o.compression = o.compression.toUpperCase();
    }

    if (typeof o.unixPermissions === "string") {
        o.unixPermissions = parseInt(o.unixPermissions, 8);
    }

    // UNX_IFDIR  0040000 see zipinfo.c
    if (o.unixPermissions && (o.unixPermissions & 0x4000)) {
        o.dir = true;
    }
    // Bit 4    Directory
    if (o.dosPermissions && (o.dosPermissions & 0x0010)) {
        o.dir = true;
    }

    if (o.dir) {
        name = forceTrailingSlash(name);
    }
    if (o.createFolders && (parent = parentFolder(name))) {
        folderAdd.call(this, parent, true);
    }

    var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
    if (!originalOptions || typeof originalOptions.binary === "undefined") {
        o.binary = !isUnicodeString;
    }


    var isCompressedEmpty = (data instanceof CompressedObject) && data.uncompressedSize === 0;

    if (isCompressedEmpty || o.dir || !data || data.length === 0) {
        o.base64 = false;
        o.binary = true;
        data = "";
        o.compression = "STORE";
        dataType = "string";
    }

    /*
     * Convert content to fit.
     */

    var zipObjectContent = null;
    if (data instanceof CompressedObject || data instanceof GenericWorker) {
        zipObjectContent = data;
    } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
        zipObjectContent = new NodejsStreamInputAdapter(name, data);
    } else {
        zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
    }

    var object = new ZipObject(name, zipObjectContent, o);
    this.files[name] = object;
    /*
    TODO: we can't throw an exception because we have async promises
    (we can have a promise of a Date() for example) but returning a
    promise is useless because file(name, data) returns the JSZip
    object for chaining. Should we break that to allow the user
    to catch the error ?

    return external.Promise.resolve(zipObjectContent)
    .then(function () {
        return object;
    });
    */
};

/**
 * Find the parent folder of the path.
 * @private
 * @param {string} path the path to use
 * @return {string} the parent folder, or ""
 */
var parentFolder = function (path) {
    if (path.slice(-1) === '/') {
        path = path.substring(0, path.length - 1);
    }
    var lastSlash = path.lastIndexOf('/');
    return (lastSlash > 0) ? path.substring(0, lastSlash) : "";
};

/**
 * Returns the path with a slash at the end.
 * @private
 * @param {String} path the path to check.
 * @return {String} the path with a trailing slash.
 */
var forceTrailingSlash = function(path) {
    // Check the name ends with a /
    if (path.slice(-1) !== "/") {
        path += "/"; // IE doesn't like substr(-1)
    }
    return path;
};

/**
 * Add a (sub) folder in the current folder.
 * @private
 * @param {string} name the folder's name
 * @param {boolean=} [createFolders] If true, automatically create sub
 *  folders. Defaults to false.
 * @return {Object} the new folder.
 */
var folderAdd = function(name, createFolders) {
    createFolders = (typeof createFolders !== 'undefined') ? createFolders : defaults.createFolders;

    name = forceTrailingSlash(name);

    // Does this folder already exist?
    if (!this.files[name]) {
        fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
        });
    }
    return this.files[name];
};

/**
* Cross-window, cross-Node-context regular expression detection
* @param  {Object}  object Anything
* @return {Boolean}        true if the object is a regular expression,
* false otherwise
*/
function isRegExp(object) {
    return Object.prototype.toString.call(object) === "[object RegExp]";
}

// return the actual prototype of JSZip
var out = {
    /**
     * @see loadAsync
     */
    load: function() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },


    /**
     * Call a callback function for each entry at this folder level.
     * @param {Function} cb the callback function:
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     */
    forEach: function(cb) {
        var filename, relativePath, file;
        for (filename in this.files) {
            if (!this.files.hasOwnProperty(filename)) {
                continue;
            }
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) { // the file is in the current root
                cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
        }
    },

    /**
     * Filter nested files/folders with the specified function.
     * @param {Function} search the predicate to use :
     * function (relativePath, file) {...}
     * It takes 2 arguments : the relative path and the file.
     * @return {Array} An array of matching elements.
     */
    filter: function(search) {
        var result = [];
        this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) { // the file matches the function
                result.push(entry);
            }

        });
        return result;
    },

    /**
     * Add a file to the zip file, or search a file.
     * @param   {string|RegExp} name The name of the file to add (if data is defined),
     * the name of the file to find (if no data) or a regex to match files.
     * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
     * @param   {Object} o     File options
     * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
     * a file (when searching by string) or an array of files (when searching by regex).
     */
    file: function(name, data, o) {
        if (arguments.length === 1) {
            if (isRegExp(name)) {
                var regexp = name;
                return this.filter(function(relativePath, file) {
                    return !file.dir && regexp.test(relativePath);
                });
            }
            else { // text
                var obj = this.files[this.root + name];
                if (obj && !obj.dir) {
                    return obj;
                } else {
                    return null;
                }
            }
        }
        else { // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
        }
        return this;
    },

    /**
     * Add a directory to the zip file, or search.
     * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
     * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
     */
    folder: function(arg) {
        if (!arg) {
            return this;
        }

        if (isRegExp(arg)) {
            return this.filter(function(relativePath, file) {
                return file.dir && arg.test(relativePath);
            });
        }

        // else, name is a new folder
        var name = this.root + arg;
        var newFolder = folderAdd.call(this, name);

        // Allow chaining by returning a new object with this folder as the root
        var ret = this.clone();
        ret.root = newFolder.name;
        return ret;
    },

    /**
     * Delete a file, or a directory and all sub-files, from the zip
     * @param {string} name the name of the file to delete
     * @return {JSZip} this JSZip object
     */
    remove: function(name) {
        name = this.root + name;
        var file = this.files[name];
        if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
                name += "/";
            }
            file = this.files[name];
        }

        if (file && !file.dir) {
            // file
            delete this.files[name];
        } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function(relativePath, file) {
                return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
                delete this.files[kids[i].name];
            }
        }

        return this;
    },

    /**
     * Generate the complete zip file
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the zip file
     */
    generate: function(options) {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
    },

    /**
     * Generate the complete zip file as an internal stream.
     * @param {Object} options the options to generate the zip file :
     * - compression, "STORE" by default.
     * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
     * @return {StreamHelper} the streamed zip file.
     */
    generateInternalStream: function(options) {
      var worker, opts = {};
      try {
          opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions : null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: 'application/zip',
              encodeFileName: utf8.utf8encode
          });

          opts.type = opts.type.toLowerCase();
          opts.compression = opts.compression.toUpperCase();

          // "binarystring" is prefered but the internals use "string".
          if(opts.type === "binarystring") {
            opts.type = "string";
          }

          if (!opts.type) {
            throw new Error("No output type specified.");
          }

          utils.checkSupport(opts.type);

          // accept nodejs `process.platform`
          if(
              opts.platform === 'darwin' ||
              opts.platform === 'freebsd' ||
              opts.platform === 'linux' ||
              opts.platform === 'sunos'
          ) {
              opts.platform = "UNIX";
          }
          if (opts.platform === 'win32') {
              opts.platform = "DOS";
          }

          var comment = opts.comment || this.comment || "";
          worker = generate.generateWorker(this, opts, comment);
      } catch (e) {
        worker = new GenericWorker("error");
        worker.error(e);
      }
      return new StreamHelper(worker, opts.type || "string", opts.mimeType);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateAsync: function(options, onUpdate) {
        return this.generateInternalStream(options).accumulate(onUpdate);
    },
    /**
     * Generate the complete zip file asynchronously.
     * @see generateInternalStream
     */
    generateNodeStream: function(options, onUpdate) {
        options = options || {};
        if (!options.type) {
            options.type = "nodebuffer";
        }
        return this.generateInternalStream(options).toNodejsStream(onUpdate);
    }
};
module.exports = out;

},{"./compressedObject":39,"./defaults":42,"./generate":46,"./nodejs/NodejsStreamInputAdapter":49,"./nodejsUtils":51,"./stream/GenericWorker":65,"./stream/StreamHelper":66,"./utf8":68,"./utils":69,"./zipObject":72}],53:[function(require,module,exports){
/*
 * This file is used by module bundlers (browserify/webpack/etc) when
 * including a stream implementation. We use "readable-stream" to get a
 * consistent behavior between nodejs versions but bundlers often have a shim
 * for "stream". Using this shim greatly improve the compatibility and greatly
 * reduce the final size of the bundle (only one stream implementation, not
 * two).
 */
module.exports = require("stream");

},{"stream":102}],54:[function(require,module,exports){
'use strict';
var DataReader = require('./DataReader');
var utils = require('../utils');

function ArrayReader(data) {
    DataReader.call(this, data);
	for(var i = 0; i < this.data.length; i++) {
		data[i] = data[i] & 0xFF;
	}
}
utils.inherits(ArrayReader, DataReader);
/**
 * @see DataReader.byteAt
 */
ArrayReader.prototype.byteAt = function(i) {
    return this.data[this.zero + i];
};
/**
 * @see DataReader.lastIndexOfSignature
 */
ArrayReader.prototype.lastIndexOfSignature = function(sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3);
    for (var i = this.length - 4; i >= 0; --i) {
        if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
        }
    }

    return -1;
};
/**
 * @see DataReader.readAndCheckSignature
 */
ArrayReader.prototype.readAndCheckSignature = function (sig) {
    var sig0 = sig.charCodeAt(0),
        sig1 = sig.charCodeAt(1),
        sig2 = sig.charCodeAt(2),
        sig3 = sig.charCodeAt(3),
        data = this.readData(4);
    return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
};
/**
 * @see DataReader.readData
 */
ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        return [];
    }
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = ArrayReader;

},{"../utils":69,"./DataReader":55}],55:[function(require,module,exports){
'use strict';
var utils = require('../utils');

function DataReader(data) {
    this.data = data; // type : see implementation
    this.length = data.length;
    this.index = 0;
    this.zero = 0;
}
DataReader.prototype = {
    /**
     * Check that the offset will not go too far.
     * @param {string} offset the additional offset to check.
     * @throws {Error} an Error if the offset is out of bounds.
     */
    checkOffset: function(offset) {
        this.checkIndex(this.index + offset);
    },
    /**
     * Check that the specifed index will not be too far.
     * @param {string} newIndex the index to check.
     * @throws {Error} an Error if the index is out of bounds.
     */
    checkIndex: function(newIndex) {
        if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + (newIndex) + "). Corrupted zip ?");
        }
    },
    /**
     * Change the index.
     * @param {number} newIndex The new index.
     * @throws {Error} if the new index is out of the data.
     */
    setIndex: function(newIndex) {
        this.checkIndex(newIndex);
        this.index = newIndex;
    },
    /**
     * Skip the next n bytes.
     * @param {number} n the number of bytes to skip.
     * @throws {Error} if the new index is out of the data.
     */
    skip: function(n) {
        this.setIndex(this.index + n);
    },
    /**
     * Get the byte at the specified index.
     * @param {number} i the index to use.
     * @return {number} a byte.
     */
    byteAt: function(i) {
        // see implementations
    },
    /**
     * Get the next number with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {number} the corresponding number.
     */
    readInt: function(size) {
        var result = 0,
            i;
        this.checkOffset(size);
        for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
        }
        this.index += size;
        return result;
    },
    /**
     * Get the next string with a given byte size.
     * @param {number} size the number of bytes to read.
     * @return {string} the corresponding string.
     */
    readString: function(size) {
        return utils.transformTo("string", this.readData(size));
    },
    /**
     * Get raw data without conversion, <size> bytes.
     * @param {number} size the number of bytes to read.
     * @return {Object} the raw data, implementation specific.
     */
    readData: function(size) {
        // see implementations
    },
    /**
     * Find the last occurence of a zip signature (4 bytes).
     * @param {string} sig the signature to find.
     * @return {number} the index of the last occurence, -1 if not found.
     */
    lastIndexOfSignature: function(sig) {
        // see implementations
    },
    /**
     * Read the signature (4 bytes) at the current position and compare it with sig.
     * @param {string} sig the expected signature
     * @return {boolean} true if the signature matches, false otherwise.
     */
    readAndCheckSignature: function(sig) {
        // see implementations
    },
    /**
     * Get the next date.
     * @return {Date} the date.
     */
    readDate: function() {
        var dostime = this.readInt(4);
        return new Date(Date.UTC(
        ((dostime >> 25) & 0x7f) + 1980, // year
        ((dostime >> 21) & 0x0f) - 1, // month
        (dostime >> 16) & 0x1f, // day
        (dostime >> 11) & 0x1f, // hour
        (dostime >> 5) & 0x3f, // minute
        (dostime & 0x1f) << 1)); // second
    }
};
module.exports = DataReader;

},{"../utils":69}],56:[function(require,module,exports){
'use strict';
var Uint8ArrayReader = require('./Uint8ArrayReader');
var utils = require('../utils');

function NodeBufferReader(data) {
    Uint8ArrayReader.call(this, data);
}
utils.inherits(NodeBufferReader, Uint8ArrayReader);

/**
 * @see DataReader.readData
 */
NodeBufferReader.prototype.readData = function(size) {
    this.checkOffset(size);
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = NodeBufferReader;

},{"../utils":69,"./Uint8ArrayReader":58}],57:[function(require,module,exports){
'use strict';
var DataReader = require('./DataReader');
var utils = require('../utils');

function StringReader(data) {
    DataReader.call(this, data);
}
utils.inherits(StringReader, DataReader);
/**
 * @see DataReader.byteAt
 */
StringReader.prototype.byteAt = function(i) {
    return this.data.charCodeAt(this.zero + i);
};
/**
 * @see DataReader.lastIndexOfSignature
 */
StringReader.prototype.lastIndexOfSignature = function(sig) {
    return this.data.lastIndexOf(sig) - this.zero;
};
/**
 * @see DataReader.readAndCheckSignature
 */
StringReader.prototype.readAndCheckSignature = function (sig) {
    var data = this.readData(4);
    return sig === data;
};
/**
 * @see DataReader.readData
 */
StringReader.prototype.readData = function(size) {
    this.checkOffset(size);
    // this will work because the constructor applied the "& 0xff" mask.
    var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = StringReader;

},{"../utils":69,"./DataReader":55}],58:[function(require,module,exports){
'use strict';
var ArrayReader = require('./ArrayReader');
var utils = require('../utils');

function Uint8ArrayReader(data) {
    ArrayReader.call(this, data);
}
utils.inherits(Uint8ArrayReader, ArrayReader);
/**
 * @see DataReader.readData
 */
Uint8ArrayReader.prototype.readData = function(size) {
    this.checkOffset(size);
    if(size === 0) {
        // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
        return new Uint8Array(0);
    }
    var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
    this.index += size;
    return result;
};
module.exports = Uint8ArrayReader;

},{"../utils":69,"./ArrayReader":54}],59:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var support = require('../support');
var ArrayReader = require('./ArrayReader');
var StringReader = require('./StringReader');
var NodeBufferReader = require('./NodeBufferReader');
var Uint8ArrayReader = require('./Uint8ArrayReader');

/**
 * Create a reader adapted to the data.
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
 * @return {DataReader} the data reader.
 */
module.exports = function (data) {
    var type = utils.getTypeOf(data);
    utils.checkSupport(type);
    if (type === "string" && !support.uint8array) {
        return new StringReader(data);
    }
    if (type === "nodebuffer") {
        return new NodeBufferReader(data);
    }
    if (support.uint8array) {
        return new Uint8ArrayReader(utils.transformTo("uint8array", data));
    }
    return new ArrayReader(utils.transformTo("array", data));
};

// vim: set shiftwidth=4 softtabstop=4:

},{"../support":67,"../utils":69,"./ArrayReader":54,"./NodeBufferReader":56,"./StringReader":57,"./Uint8ArrayReader":58}],60:[function(require,module,exports){
'use strict';
exports.LOCAL_FILE_HEADER = "PK\x03\x04";
exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
exports.DATA_DESCRIPTOR = "PK\x07\x08";

},{}],61:[function(require,module,exports){
'use strict';

var GenericWorker = require('./GenericWorker');
var utils = require('../utils');

/**
 * A worker which convert chunks to a specified type.
 * @constructor
 * @param {String} destType the destination type.
 */
function ConvertWorker(destType) {
    GenericWorker.call(this, "ConvertWorker to " + destType);
    this.destType = destType;
}
utils.inherits(ConvertWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
ConvertWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : utils.transformTo(this.destType, chunk.data),
        meta : chunk.meta
    });
};
module.exports = ConvertWorker;

},{"../utils":69,"./GenericWorker":65}],62:[function(require,module,exports){
'use strict';

var GenericWorker = require('./GenericWorker');
var crc32 = require('../crc32');
var utils = require('../utils');

/**
 * A worker which calculate the crc32 of the data flowing through.
 * @constructor
 */
function Crc32Probe() {
    GenericWorker.call(this, "Crc32Probe");
    this.withStreamInfo("crc32", 0);
}
utils.inherits(Crc32Probe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Crc32Probe.prototype.processChunk = function (chunk) {
    this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
    this.push(chunk);
};
module.exports = Crc32Probe;

},{"../crc32":41,"../utils":69,"./GenericWorker":65}],63:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('./GenericWorker');

/**
 * A worker which calculate the total length of the data flowing through.
 * @constructor
 * @param {String} propName the name used to expose the length
 */
function DataLengthProbe(propName) {
    GenericWorker.call(this, "DataLengthProbe for " + propName);
    this.propName = propName;
    this.withStreamInfo(propName, 0);
}
utils.inherits(DataLengthProbe, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
DataLengthProbe.prototype.processChunk = function (chunk) {
    if(chunk) {
        var length = this.streamInfo[this.propName] || 0;
        this.streamInfo[this.propName] = length + chunk.data.length;
    }
    GenericWorker.prototype.processChunk.call(this, chunk);
};
module.exports = DataLengthProbe;


},{"../utils":69,"./GenericWorker":65}],64:[function(require,module,exports){
'use strict';

var utils = require('../utils');
var GenericWorker = require('./GenericWorker');

// the size of the generated chunks
// TODO expose this as a public variable
var DEFAULT_BLOCK_SIZE = 16 * 1024;

/**
 * A worker that reads a content and emits chunks.
 * @constructor
 * @param {Promise} dataP the promise of the data to split
 */
function DataWorker(dataP) {
    GenericWorker.call(this, "DataWorker");
    var self = this;
    this.dataIsReady = false;
    this.index = 0;
    this.max = 0;
    this.data = null;
    this.type = "";

    this._tickScheduled = false;

    dataP.then(function (data) {
        self.dataIsReady = true;
        self.data = data;
        self.max = data && data.length || 0;
        self.type = utils.getTypeOf(data);
        if(!self.isPaused) {
            self._tickAndRepeat();
        }
    }, function (e) {
        self.error(e);
    });
}

utils.inherits(DataWorker, GenericWorker);

/**
 * @see GenericWorker.cleanUp
 */
DataWorker.prototype.cleanUp = function () {
    GenericWorker.prototype.cleanUp.call(this);
    this.data = null;
};

/**
 * @see GenericWorker.resume
 */
DataWorker.prototype.resume = function () {
    if(!GenericWorker.prototype.resume.call(this)) {
        return false;
    }

    if (!this._tickScheduled && this.dataIsReady) {
        this._tickScheduled = true;
        utils.delay(this._tickAndRepeat, [], this);
    }
    return true;
};

/**
 * Trigger a tick a schedule an other call to this function.
 */
DataWorker.prototype._tickAndRepeat = function() {
    this._tickScheduled = false;
    if(this.isPaused || this.isFinished) {
        return;
    }
    this._tick();
    if(!this.isFinished) {
        utils.delay(this._tickAndRepeat, [], this);
        this._tickScheduled = true;
    }
};

/**
 * Read and push a chunk.
 */
DataWorker.prototype._tick = function() {

    if(this.isPaused || this.isFinished) {
        return false;
    }

    var size = DEFAULT_BLOCK_SIZE;
    var data = null, nextIndex = Math.min(this.max, this.index + size);
    if (this.index >= this.max) {
        // EOF
        return this.end();
    } else {
        switch(this.type) {
            case "string":
                data = this.data.substring(this.index, nextIndex);
            break;
            case "uint8array":
                data = this.data.subarray(this.index, nextIndex);
            break;
            case "array":
            case "nodebuffer":
                data = this.data.slice(this.index, nextIndex);
            break;
        }
        this.index = nextIndex;
        return this.push({
            data : data,
            meta : {
                percent : this.max ? this.index / this.max * 100 : 0
            }
        });
    }
};

module.exports = DataWorker;

},{"../utils":69,"./GenericWorker":65}],65:[function(require,module,exports){
'use strict';

/**
 * A worker that does nothing but passing chunks to the next one. This is like
 * a nodejs stream but with some differences. On the good side :
 * - it works on IE 6-9 without any issue / polyfill
 * - it weights less than the full dependencies bundled with browserify
 * - it forwards errors (no need to declare an error handler EVERYWHERE)
 *
 * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
 * object containing anything (`percent` for example), see each worker for more
 * details. The latter is the real data (String, Uint8Array, etc).
 *
 * @constructor
 * @param {String} name the name of the stream (mainly used for debugging purposes)
 */
function GenericWorker(name) {
    // the name of the worker
    this.name = name || "default";
    // an object containing metadata about the workers chain
    this.streamInfo = {};
    // an error which happened when the worker was paused
    this.generatedError = null;
    // an object containing metadata to be merged by this worker into the general metadata
    this.extraStreamInfo = {};
    // true if the stream is paused (and should not do anything), false otherwise
    this.isPaused = true;
    // true if the stream is finished (and should not do anything), false otherwise
    this.isFinished = false;
    // true if the stream is locked to prevent further structure updates (pipe), false otherwise
    this.isLocked = false;
    // the event listeners
    this._listeners = {
        'data':[],
        'end':[],
        'error':[]
    };
    // the previous worker, if any
    this.previous = null;
}

GenericWorker.prototype = {
    /**
     * Push a chunk to the next workers.
     * @param {Object} chunk the chunk to push
     */
    push : function (chunk) {
        this.emit("data", chunk);
    },
    /**
     * End the stream.
     * @return {Boolean} true if this call ended the worker, false otherwise.
     */
    end : function () {
        if (this.isFinished) {
            return false;
        }

        this.flush();
        try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
        } catch (e) {
            this.emit("error", e);
        }
        return true;
    },
    /**
     * End the stream with an error.
     * @param {Error} e the error which caused the premature end.
     * @return {Boolean} true if this call ended the worker with an error, false otherwise.
     */
    error : function (e) {
        if (this.isFinished) {
            return false;
        }

        if(this.isPaused) {
            this.generatedError = e;
        } else {
            this.isFinished = true;

            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if(this.previous) {
                this.previous.error(e);
            }

            this.cleanUp();
        }
        return true;
    },
    /**
     * Add a callback on an event.
     * @param {String} name the name of the event (data, end, error)
     * @param {Function} listener the function to call when the event is triggered
     * @return {GenericWorker} the current object for chainability
     */
    on : function (name, listener) {
        this._listeners[name].push(listener);
        return this;
    },
    /**
     * Clean any references when a worker is ending.
     */
    cleanUp : function () {
        this.streamInfo = this.generatedError = this.extraStreamInfo = null;
        this._listeners = [];
    },
    /**
     * Trigger an event. This will call registered callback with the provided arg.
     * @param {String} name the name of the event (data, end, error)
     * @param {Object} arg the argument to call the callback with.
     */
    emit : function (name, arg) {
        if (this._listeners[name]) {
            for(var i = 0; i < this._listeners[name].length; i++) {
                this._listeners[name][i].call(this, arg);
            }
        }
    },
    /**
     * Chain a worker with an other.
     * @param {Worker} next the worker receiving events from the current one.
     * @return {worker} the next worker for chainability
     */
    pipe : function (next) {
        return next.registerPrevious(this);
    },
    /**
     * Same as `pipe` in the other direction.
     * Using an API with `pipe(next)` is very easy.
     * Implementing the API with the point of view of the next one registering
     * a source is easier, see the ZipFileWorker.
     * @param {Worker} previous the previous worker, sending events to this one
     * @return {Worker} the current worker for chainability
     */
    registerPrevious : function (previous) {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }

        // sharing the streamInfo...
        this.streamInfo = previous.streamInfo;
        // ... and adding our own bits
        this.mergeStreamInfo();
        this.previous =  previous;
        var self = this;
        previous.on('data', function (chunk) {
            self.processChunk(chunk);
        });
        previous.on('end', function () {
            self.end();
        });
        previous.on('error', function (e) {
            self.error(e);
        });
        return this;
    },
    /**
     * Pause the stream so it doesn't send events anymore.
     * @return {Boolean} true if this call paused the worker, false otherwise.
     */
    pause : function () {
        if(this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = true;

        if(this.previous) {
            this.previous.pause();
        }
        return true;
    },
    /**
     * Resume a paused stream.
     * @return {Boolean} true if this call resumed the worker, false otherwise.
     */
    resume : function () {
        if(!this.isPaused || this.isFinished) {
            return false;
        }
        this.isPaused = false;

        // if true, the worker tried to resume but failed
        var withError = false;
        if(this.generatedError) {
            this.error(this.generatedError);
            withError = true;
        }
        if(this.previous) {
            this.previous.resume();
        }

        return !withError;
    },
    /**
     * Flush any remaining bytes as the stream is ending.
     */
    flush : function () {},
    /**
     * Process a chunk. This is usually the method overridden.
     * @param {Object} chunk the chunk to process.
     */
    processChunk : function(chunk) {
        this.push(chunk);
    },
    /**
     * Add a key/value to be added in the workers chain streamInfo once activated.
     * @param {String} key the key to use
     * @param {Object} value the associated value
     * @return {Worker} the current worker for chainability
     */
    withStreamInfo : function (key, value) {
        this.extraStreamInfo[key] = value;
        this.mergeStreamInfo();
        return this;
    },
    /**
     * Merge this worker's streamInfo into the chain's streamInfo.
     */
    mergeStreamInfo : function () {
        for(var key in this.extraStreamInfo) {
            if (!this.extraStreamInfo.hasOwnProperty(key)) {
                continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
        }
    },

    /**
     * Lock the stream to prevent further updates on the workers chain.
     * After calling this method, all calls to pipe will fail.
     */
    lock: function () {
        if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
        }
        this.isLocked = true;
        if (this.previous) {
            this.previous.lock();
        }
    },

    /**
     *
     * Pretty print the workers chain.
     */
    toString : function () {
        var me = "Worker " + this.name;
        if (this.previous) {
            return this.previous + " -> " + me;
        } else {
            return me;
        }
    }
};

module.exports = GenericWorker;

},{}],66:[function(require,module,exports){
(function (Buffer){
'use strict';

var utils = require('../utils');
var ConvertWorker = require('./ConvertWorker');
var GenericWorker = require('./GenericWorker');
var base64 = require('../base64');
var support = require("../support");
var external = require("../external");

var NodejsStreamOutputAdapter = null;
if (support.nodestream) {
    try {
        NodejsStreamOutputAdapter = require('../nodejs/NodejsStreamOutputAdapter');
    } catch(e) {}
}

/**
 * Apply the final transformation of the data. If the user wants a Blob for
 * example, it's easier to work with an U8intArray and finally do the
 * ArrayBuffer/Blob conversion.
 * @param {String} resultType the name of the final type
 * @param {String} chunkType the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @param {String|Uint8Array|Buffer} content the content to transform
 * @param {String} mimeType the mime type of the content, if applicable.
 * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
 */
function transformZipOutput(resultType, chunkType, dataArray, mimeType) {
    var content = null;
    switch(resultType) {
        case "blob" :
            return utils.newBlob(dataArray, mimeType);
        case "base64" :
            content = concat(chunkType, dataArray);
            return base64.encode(content);
        default :
            content = concat(chunkType, dataArray);
            return utils.transformTo(resultType, content);
    }
}

/**
 * Concatenate an array of data of the given type.
 * @param {String} type the type of the data in the given array.
 * @param {Array} dataArray the array containing the data chunks to concatenate
 * @return {String|Uint8Array|Buffer} the concatenated data
 * @throws Error if the asked type is unsupported
 */
function concat (type, dataArray) {
    var i, index = 0, res = null, totalLength = 0;
    for(i = 0; i < dataArray.length; i++) {
        totalLength += dataArray[i].length;
    }
    switch(type) {
        case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
        case "uint8array":
            res = new Uint8Array(totalLength);
            for(i = 0; i < dataArray.length; i++) {
                res.set(dataArray[i], index);
                index += dataArray[i].length;
            }
            return res;
        case "nodebuffer":
            return Buffer.concat(dataArray);
        default:
            throw new Error("concat : unsupported type '"  + type + "'");
    }
}

/**
 * Listen a StreamHelper, accumulate its content and concatenate it into a
 * complete block.
 * @param {StreamHelper} helper the helper to use.
 * @param {Function} updateCallback a callback called on each update. Called
 * with one arg :
 * - the metadata linked to the update received.
 * @return Promise the promise for the accumulation.
 */
function accumulate(helper, updateCallback) {
    return new external.Promise(function (resolve, reject){
        var dataArray = [];
        var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
        helper
        .on('data', function (data, meta) {
            dataArray.push(data);
            if(updateCallback) {
                updateCallback(meta);
            }
        })
        .on('error', function(err) {
            dataArray = [];
            reject(err);
        })
        .on('end', function (){
            try {
                var result = transformZipOutput(resultType, chunkType, dataArray, mimeType);
                resolve(result);
            } catch (e) {
                reject(e);
            }
            dataArray = [];
        })
        .resume();
    });
}

/**
 * An helper to easily use workers outside of JSZip.
 * @constructor
 * @param {Worker} worker the worker to wrap
 * @param {String} outputType the type of data expected by the use
 * @param {String} mimeType the mime type of the content, if applicable.
 */
function StreamHelper(worker, outputType, mimeType) {
    var internalType = outputType;
    switch(outputType) {
        case "blob":
            internalType = "arraybuffer";
        break;
        case "arraybuffer":
            internalType = "uint8array";
        break;
        case "base64":
            internalType = "string";
        break;
    }

    try {
        // the type used internally
        this._internalType = internalType;
        // the type used to output results
        this._outputType = outputType;
        // the mime type
        this._mimeType = mimeType;
        utils.checkSupport(internalType);
        this._worker = worker.pipe(new ConvertWorker(internalType));
        // the last workers can be rewired without issues but we need to
        // prevent any updates on previous workers.
        worker.lock();
    } catch(e) {
        this._worker = new GenericWorker("error");
        this._worker.error(e);
    }
}

StreamHelper.prototype = {
    /**
     * Listen a StreamHelper, accumulate its content and concatenate it into a
     * complete block.
     * @param {Function} updateCb the update callback.
     * @return Promise the promise for the accumulation.
     */
    accumulate : function (updateCb) {
        return accumulate(this, updateCb);
    },
    /**
     * Add a listener on an event triggered on a stream.
     * @param {String} evt the name of the event
     * @param {Function} fn the listener
     * @return {StreamHelper} the current helper.
     */
    on : function (evt, fn) {
        var self = this;

        if(evt === "data") {
            this._worker.on(evt, function (chunk) {
                fn.call(self, chunk.data, chunk.meta);
            });
        } else {
            this._worker.on(evt, function () {
                utils.delay(fn, arguments, self);
            });
        }
        return this;
    },
    /**
     * Resume the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    resume : function () {
        utils.delay(this._worker.resume, [], this._worker);
        return this;
    },
    /**
     * Pause the flow of chunks.
     * @return {StreamHelper} the current helper.
     */
    pause : function () {
        this._worker.pause();
        return this;
    },
    /**
     * Return a nodejs stream for this helper.
     * @param {Function} updateCb the update callback.
     * @return {NodejsStreamOutputAdapter} the nodejs stream.
     */
    toNodejsStream : function (updateCb) {
        utils.checkSupport("nodestream");
        if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
        }

        return new NodejsStreamOutputAdapter(this, {
            objectMode : this._outputType !== "nodebuffer"
        }, updateCb);
    }
};


module.exports = StreamHelper;

}).call(this,require("buffer").Buffer)
},{"../base64":38,"../external":43,"../nodejs/NodejsStreamOutputAdapter":50,"../support":67,"../utils":69,"./ConvertWorker":61,"./GenericWorker":65,"buffer":4}],67:[function(require,module,exports){
(function (Buffer){
'use strict';

exports.base64 = true;
exports.array = true;
exports.string = true;
exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
exports.nodebuffer = typeof Buffer !== "undefined";
// contains true if JSZip can read/generate Uint8Array, false otherwise.
exports.uint8array = typeof Uint8Array !== "undefined";

if (typeof ArrayBuffer === "undefined") {
    exports.blob = false;
}
else {
    var buffer = new ArrayBuffer(0);
    try {
        exports.blob = new Blob([buffer], {
            type: "application/zip"
        }).size === 0;
    }
    catch (e) {
        try {
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob('application/zip').size === 0;
        }
        catch (e) {
            exports.blob = false;
        }
    }
}

try {
    exports.nodestream = !!require('readable-stream').Readable;
} catch(e) {
    exports.nodestream = false;
}

}).call(this,require("buffer").Buffer)
},{"buffer":4,"readable-stream":53}],68:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var support = require('./support');
var nodejsUtils = require('./nodejsUtils');
var GenericWorker = require('./stream/GenericWorker');

/**
 * The following functions come from pako, from pako/lib/utils/strings
 * released under the MIT license, see pako https://github.com/nodeca/pako/
 */

// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new Array(256);
for (var i=0; i<256; i++) {
  _utf8len[i] = (i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1);
}
_utf8len[254]=_utf8len[254]=1; // Invalid sequence start

// convert string to array (typed, when possible)
var string2buf = function (str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

    // count binary size
    for (m_pos = 0; m_pos < str_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }

    // allocate buffer
    if (support.uint8array) {
        buf = new Uint8Array(buf_len);
    } else {
        buf = new Array(buf_len);
    }

    // convert
    for (i=0, m_pos = 0; i < buf_len; m_pos++) {
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && (m_pos+1 < str_len)) {
            c2 = str.charCodeAt(m_pos+1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
        } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | (c >>> 6);
            buf[i++] = 0x80 | (c & 0x3f);
        } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | (c >>> 12);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        } else {
            /* four bytes */
            buf[i++] = 0xf0 | (c >>> 18);
            buf[i++] = 0x80 | (c >>> 12 & 0x3f);
            buf[i++] = 0x80 | (c >>> 6 & 0x3f);
            buf[i++] = 0x80 | (c & 0x3f);
        }
    }

    return buf;
};

// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = function(buf, max) {
    var pos;

    max = max || buf.length;
    if (max > buf.length) { max = buf.length; }

    // go back from last position, until start of sequence found
    pos = max-1;
    while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

    // Fuckup - very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) { return max; }

    // If we came to start of buffer - that means vuffer is too small,
    // return max too.
    if (pos === 0) { return max; }

    return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

// convert array to string
var buf2string = function (buf) {
    var str, i, out, c, c_len;
    var len = buf.length;

    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len*2);

    for (out=0, i=0; i<len;) {
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) { utf16buf[out++] = c; continue; }

        c_len = _utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len-1; continue; }

        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while (c_len > 1 && i < len) {
            c = (c << 6) | (buf[i++] & 0x3f);
            c_len--;
        }

        // terminated by end of string?
        if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

        if (c < 0x10000) {
            utf16buf[out++] = c;
        } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
            utf16buf[out++] = 0xdc00 | (c & 0x3ff);
        }
    }

    // shrinkBuf(utf16buf, out)
    if (utf16buf.length !== out) {
        if(utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
        } else {
            utf16buf.length = out;
        }
    }

    // return String.fromCharCode.apply(null, utf16buf);
    return utils.applyFromCharCode(utf16buf);
};


// That's all for the pako functions.


/**
 * Transform a javascript string into an array (typed if possible) of bytes,
 * UTF-8 encoded.
 * @param {String} str the string to encode
 * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
 */
exports.utf8encode = function utf8encode(str) {
    if (support.nodebuffer) {
        return nodejsUtils.newBuffer(str, "utf-8");
    }

    return string2buf(str);
};


/**
 * Transform a bytes array (or a representation) representing an UTF-8 encoded
 * string into a javascript string.
 * @param {Array|Uint8Array|Buffer} buf the data de decode
 * @return {String} the decoded string.
 */
exports.utf8decode = function utf8decode(buf) {
    if (support.nodebuffer) {
        return utils.transformTo("nodebuffer", buf).toString("utf-8");
    }

    buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);

    return buf2string(buf);
};

/**
 * A worker to decode utf8 encoded binary chunks into string chunks.
 * @constructor
 */
function Utf8DecodeWorker() {
    GenericWorker.call(this, "utf-8 decode");
    // the last bytes if a chunk didn't end with a complete codepoint.
    this.leftOver = null;
}
utils.inherits(Utf8DecodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8DecodeWorker.prototype.processChunk = function (chunk) {

    var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

    // 1st step, re-use what's left of the previous chunk
    if (this.leftOver && this.leftOver.length) {
        if(support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
        } else {
            data = this.leftOver.concat(data);
        }
        this.leftOver = null;
    }

    var nextBoundary = utf8border(data);
    var usableData = data;
    if (nextBoundary !== data.length) {
        if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
        } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
        }
    }

    this.push({
        data : exports.utf8decode(usableData),
        meta : chunk.meta
    });
};

/**
 * @see GenericWorker.flush
 */
Utf8DecodeWorker.prototype.flush = function () {
    if(this.leftOver && this.leftOver.length) {
        this.push({
            data : exports.utf8decode(this.leftOver),
            meta : {}
        });
        this.leftOver = null;
    }
};
exports.Utf8DecodeWorker = Utf8DecodeWorker;

/**
 * A worker to endcode string chunks into utf8 encoded binary chunks.
 * @constructor
 */
function Utf8EncodeWorker() {
    GenericWorker.call(this, "utf-8 encode");
}
utils.inherits(Utf8EncodeWorker, GenericWorker);

/**
 * @see GenericWorker.processChunk
 */
Utf8EncodeWorker.prototype.processChunk = function (chunk) {
    this.push({
        data : exports.utf8encode(chunk.data),
        meta : chunk.meta
    });
};
exports.Utf8EncodeWorker = Utf8EncodeWorker;

},{"./nodejsUtils":51,"./stream/GenericWorker":65,"./support":67,"./utils":69}],69:[function(require,module,exports){
'use strict';

var support = require('./support');
var base64 = require('./base64');
var nodejsUtils = require('./nodejsUtils');
var setImmediate = require('core-js/library/fn/set-immediate');
var external = require("./external");


/**
 * Convert a string that pass as a "binary string": it should represent a byte
 * array but may have > 255 char codes. Be sure to take only the first byte
 * and returns the byte array.
 * @param {String} str the string to transform.
 * @return {Array|Uint8Array} the string in a binary format.
 */
function string2binary(str) {
    var result = null;
    if (support.uint8array) {
      result = new Uint8Array(str.length);
    } else {
      result = new Array(str.length);
    }
    return stringToArrayLike(str, result);
}

/**
 * Create a new blob with the given content and the given type.
 * @param {Array[String|ArrayBuffer]} parts the content to put in the blob. DO NOT use
 * an Uint8Array because the stock browser of android 4 won't accept it (it
 * will be silently converted to a string, "[object Uint8Array]").
 * @param {String} type the mime type of the blob.
 * @return {Blob} the created blob.
 */
exports.newBlob = function(parts, type) {
    exports.checkSupport("blob");

    try {
        // Blob constructor
        return new Blob(parts, {
            type: type
        });
    }
    catch (e) {

        try {
            // deprecated, browser only, old way
            var Builder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;
            var builder = new Builder();
            for (var i = 0; i < parts.length; i++) {
                builder.append(parts[i]);
            }
            return builder.getBlob(type);
        }
        catch (e) {

            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
        }
    }


};
/**
 * The identity function.
 * @param {Object} input the input.
 * @return {Object} the same input.
 */
function identity(input) {
    return input;
}

/**
 * Fill in an array with a string.
 * @param {String} str the string to use.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
 */
function stringToArrayLike(str, array) {
    for (var i = 0; i < str.length; ++i) {
        array[i] = str.charCodeAt(i) & 0xFF;
    }
    return array;
}

/**
 * An helper for the function arrayLikeToString.
 * This contains static informations and functions that
 * can be optimized by the browser JIT compiler.
 */
var arrayToStringHelper = {
    /**
     * Transform an array of int into a string, chunk by chunk.
     * See the performances notes on arrayLikeToString.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @param {String} type the type of the array.
     * @param {Integer} chunk the chunk size.
     * @return {String} the resulting string.
     * @throws Error if the chunk is too big for the stack.
     */
    stringifyByChunk: function(array, type, chunk) {
        var result = [], k = 0, len = array.length;
        // shortcut
        if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
        }
        while (k < len) {
            if (type === "array" || type === "nodebuffer") {
                result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            }
            else {
                result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
        }
        return result.join("");
    },
    /**
     * Call String.fromCharCode on every item in the array.
     * This is the naive implementation, which generate A LOT of intermediate string.
     * This should be used when everything else fail.
     * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
     * @return {String} the result.
     */
    stringifyByChar: function(array){
        var resultStr = "";
        for(var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
        }
        return resultStr;
    },
    applyCanBeUsed : {
        /**
         * true if the browser accepts to use String.fromCharCode on Uint8Array
         */
        uint8array : (function () {
            try {
                return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
                return false;
            }
        })(),
        /**
         * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
         */
        nodebuffer : (function () {
            try {
                return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.newBuffer(1)).length === 1;
            } catch (e) {
                return false;
            }
        })()
    }
};

/**
 * Transform an array-like object to a string.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
 * @return {String} the result.
 */
function arrayLikeToString(array) {
    // Performances notes :
    // --------------------
    // String.fromCharCode.apply(null, array) is the fastest, see
    // see http://jsperf.com/converting-a-uint8array-to-a-string/2
    // but the stack is limited (and we can get huge arrays !).
    //
    // result += String.fromCharCode(array[i]); generate too many strings !
    //
    // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
    // TODO : we now have workers that split the work. Do we still need that ?
    var chunk = 65536,
        type = exports.getTypeOf(array),
        canUseApply = true;
    if (type === "uint8array") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
    } else if (type === "nodebuffer") {
        canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
    }

    if (canUseApply) {
        while (chunk > 1) {
            try {
                return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
                chunk = Math.floor(chunk / 2);
            }
        }
    }

    // no apply or chunk error : slow and painful algorithm
    // default browser on android 4.*
    return arrayToStringHelper.stringifyByChar(array);
}

exports.applyFromCharCode = arrayLikeToString;


/**
 * Copy the data from an array-like to an other array-like.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
 * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
 * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
 */
function arrayLikeToArrayLike(arrayFrom, arrayTo) {
    for (var i = 0; i < arrayFrom.length; i++) {
        arrayTo[i] = arrayFrom[i];
    }
    return arrayTo;
}

// a matrix containing functions to transform everything into everything.
var transform = {};

// string to ?
transform["string"] = {
    "string": identity,
    "array": function(input) {
        return stringToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["string"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return stringToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": function(input) {
        return stringToArrayLike(input, nodejsUtils.newBuffer(input.length));
    }
};

// array to ?
transform["array"] = {
    "string": arrayLikeToString,
    "array": identity,
    "arraybuffer": function(input) {
        return (new Uint8Array(input)).buffer;
    },
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// arraybuffer to ?
transform["arraybuffer"] = {
    "string": function(input) {
        return arrayLikeToString(new Uint8Array(input));
    },
    "array": function(input) {
        return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
    },
    "arraybuffer": identity,
    "uint8array": function(input) {
        return new Uint8Array(input);
    },
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(new Uint8Array(input));
    }
};

// uint8array to ?
transform["uint8array"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        // copy the uint8array: DO NOT propagate the original ArrayBuffer, it
        // can be way larger (the whole zip file for example).
        var copy = new Uint8Array(input.length);
        if (input.length) {
            copy.set(input, 0);
        }
        return copy.buffer;
    },
    "uint8array": identity,
    "nodebuffer": function(input) {
        return nodejsUtils.newBuffer(input);
    }
};

// nodebuffer to ?
transform["nodebuffer"] = {
    "string": arrayLikeToString,
    "array": function(input) {
        return arrayLikeToArrayLike(input, new Array(input.length));
    },
    "arraybuffer": function(input) {
        return transform["nodebuffer"]["uint8array"](input).buffer;
    },
    "uint8array": function(input) {
        return arrayLikeToArrayLike(input, new Uint8Array(input.length));
    },
    "nodebuffer": identity
};

/**
 * Transform an input into any type.
 * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
 * If no output type is specified, the unmodified input will be returned.
 * @param {String} outputType the output type.
 * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
 * @throws {Error} an Error if the browser doesn't support the requested output type.
 */
exports.transformTo = function(outputType, input) {
    if (!input) {
        // undefined, null, etc
        // an empty string won't harm.
        input = "";
    }
    if (!outputType) {
        return input;
    }
    exports.checkSupport(outputType);
    var inputType = exports.getTypeOf(input);
    var result = transform[inputType][outputType](input);
    return result;
};

/**
 * Return the type of the input.
 * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
 * @param {Object} input the input to identify.
 * @return {String} the (lowercase) type of the input.
 */
exports.getTypeOf = function(input) {
    if (typeof input === "string") {
        return "string";
    }
    if (Object.prototype.toString.call(input) === "[object Array]") {
        return "array";
    }
    if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
        return "nodebuffer";
    }
    if (support.uint8array && input instanceof Uint8Array) {
        return "uint8array";
    }
    if (support.arraybuffer && input instanceof ArrayBuffer) {
        return "arraybuffer";
    }
};

/**
 * Throw an exception if the type is not supported.
 * @param {String} type the type to check.
 * @throws {Error} an Error if the browser doesn't support the requested type.
 */
exports.checkSupport = function(type) {
    var supported = support[type.toLowerCase()];
    if (!supported) {
        throw new Error(type + " is not supported by this platform");
    }
};

exports.MAX_VALUE_16BITS = 65535;
exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

/**
 * Prettify a string read as binary.
 * @param {string} str the string to prettify.
 * @return {string} a pretty string.
 */
exports.pretty = function(str) {
    var res = '',
        code, i;
    for (i = 0; i < (str || "").length; i++) {
        code = str.charCodeAt(i);
        res += '\\x' + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
    }
    return res;
};

/**
 * Defer the call of a function.
 * @param {Function} callback the function to call asynchronously.
 * @param {Array} args the arguments to give to the callback.
 */
exports.delay = function(callback, args, self) {
    setImmediate(function () {
        callback.apply(self || null, args || []);
    });
};

/**
 * Extends a prototype with an other, without calling a constructor with
 * side effects. Inspired by nodejs' `utils.inherits`
 * @param {Function} ctor the constructor to augment
 * @param {Function} superCtor the parent constructor to use
 */
exports.inherits = function (ctor, superCtor) {
    var Obj = function() {};
    Obj.prototype = superCtor.prototype;
    ctor.prototype = new Obj();
};

/**
 * Merge the objects passed as parameters into a new one.
 * @private
 * @param {...Object} var_args All objects to merge.
 * @return {Object} a new object with the data of the others.
 */
exports.extend = function() {
    var result = {}, i, attr;
    for (i = 0; i < arguments.length; i++) { // arguments is not enumerable in some browsers
        for (attr in arguments[i]) {
            if (arguments[i].hasOwnProperty(attr) && typeof result[attr] === "undefined") {
                result[attr] = arguments[i][attr];
            }
        }
    }
    return result;
};

/**
 * Transform arbitrary content into a Promise.
 * @param {String} name a name for the content being processed.
 * @param {Object} inputData the content to process.
 * @param {Boolean} isBinary true if the content is not an unicode string
 * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
 * @param {Boolean} isBase64 true if the string content is encoded with base64.
 * @return {Promise} a promise in a format usable by JSZip.
 */
exports.prepareContent = function(name, inputData, isBinary, isOptimizedBinaryString, isBase64) {

    // if inputData is already a promise, this flatten it.
    var promise = external.Promise.resolve(inputData).then(function(data) {
        
        
        var isBlob = support.blob && (data instanceof Blob || ['[object File]', '[object Blob]'].indexOf(Object.prototype.toString.call(data)) !== -1);

        if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onload = function(e) {
                    resolve(e.target.result);
                };
                reader.onerror = function(e) {
                    reject(e.target.error);
                };
                reader.readAsArrayBuffer(data);
            });
        } else {
            return data;
        }
    });

    return promise.then(function(data) {
        var dataType = exports.getTypeOf(data);

        if (!dataType) {
            return external.Promise.reject(
                new Error("The data of '" + name + "' is in an unsupported format !")
            );
        }
        // special case : it's way easier to work with Uint8Array than with ArrayBuffer
        if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
        } else if (dataType === "string") {
            if (isBase64) {
                data = base64.decode(data);
            }
            else if (isBinary) {
                // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
                if (isOptimizedBinaryString !== true) {
                    // this is a string, not in a base64 format.
                    // Be sure that this is a correct "binary string"
                    data = string2binary(data);
                }
            }
        }
        return data;
    });
};

},{"./base64":38,"./external":43,"./nodejsUtils":51,"./support":67,"core-js/library/fn/set-immediate":5}],70:[function(require,module,exports){
'use strict';
var readerFor = require('./reader/readerFor');
var utils = require('./utils');
var sig = require('./signature');
var ZipEntry = require('./zipEntry');
var utf8 = require('./utf8');
var support = require('./support');
//  class ZipEntries {{{
/**
 * All the entries in the zip file.
 * @constructor
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntries(loadOptions) {
    this.files = [];
    this.loadOptions = loadOptions;
}
ZipEntries.prototype = {
    /**
     * Check that the reader is on the speficied signature.
     * @param {string} expectedSignature the expected signature.
     * @throws {Error} if it is an other signature.
     */
    checkSignature: function(expectedSignature) {
        if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug : unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
        }
    },
    /**
     * Check if the given signature is at the given index.
     * @param {number} askedIndex the index to check.
     * @param {string} expectedSignature the signature to expect.
     * @return {boolean} true if the signature is here, false otherwise.
     */
    isSignature: function(askedIndex, expectedSignature) {
        var currentIndex = this.reader.index;
        this.reader.setIndex(askedIndex);
        var signature = this.reader.readString(4);
        var result = signature === expectedSignature;
        this.reader.setIndex(currentIndex);
        return result;
    },
    /**
     * Read the end of the central directory.
     */
    readBlockEndOfCentral: function() {
        this.diskNumber = this.reader.readInt(2);
        this.diskWithCentralDirStart = this.reader.readInt(2);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
        this.centralDirRecords = this.reader.readInt(2);
        this.centralDirSize = this.reader.readInt(4);
        this.centralDirOffset = this.reader.readInt(4);

        this.zipCommentLength = this.reader.readInt(2);
        // warning : the encoding depends of the system locale
        // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
        // On a windows machine, this field is encoded with the localized windows code page.
        var zipComment = this.reader.readData(this.zipCommentLength);
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        // To get consistent behavior with the generation part, we will assume that
        // this is utf8 encoded unless specified otherwise.
        var decodeContent = utils.transformTo(decodeParamType, zipComment);
        this.zipComment = this.loadOptions.decodeFileName(decodeContent);
    },
    /**
     * Read the end of the Zip 64 central directory.
     * Not merged with the method readEndOfCentral :
     * The end of central can coexist with its Zip64 brother,
     * I don't want to read the wrong number of bytes !
     */
    readBlockZip64EndOfCentral: function() {
        this.zip64EndOfCentralSize = this.reader.readInt(8);
        this.reader.skip(4);
        // this.versionMadeBy = this.reader.readString(2);
        // this.versionNeeded = this.reader.readInt(2);
        this.diskNumber = this.reader.readInt(4);
        this.diskWithCentralDirStart = this.reader.readInt(4);
        this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
        this.centralDirRecords = this.reader.readInt(8);
        this.centralDirSize = this.reader.readInt(8);
        this.centralDirOffset = this.reader.readInt(8);

        this.zip64ExtensibleData = {};
        var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
        while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Read the end of the Zip 64 central directory locator.
     */
    readBlockZip64EndOfCentralLocator: function() {
        this.diskWithZip64CentralDirStart = this.reader.readInt(4);
        this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
        this.disksCount = this.reader.readInt(4);
        if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
        }
    },
    /**
     * Read the local files, based on the offset read in the central part.
     */
    readLocalFiles: function() {
        var i, file;
        for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
        }
    },
    /**
     * Read the central directory.
     */
    readCentralDir: function() {
        var file;

        this.reader.setIndex(this.centralDirOffset);
        while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
                zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
        }

        if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
                // We expected some records but couldn't find ANY.
                // This is really suspicious, as if something went wrong.
                throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
                // We found some records but not all.
                // Something is wrong but we got something for the user: no error here.
                // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
        }
    },
    /**
     * Read the end of central directory.
     */
    readEndOfCentral: function() {
        var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
        if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);

            if (isGarbage) {
                throw new Error("Can't find end of central directory : is this a zip file ? " +
                                "If it is, see http://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
                throw new Error("Corrupted zip : can't find end of central directory");
            }

        }
        this.reader.setIndex(offset);
        var endOfCentralDirOffset = offset;
        this.checkSignature(sig.CENTRAL_DIRECTORY_END);
        this.readBlockEndOfCentral();


        /* extract from the zip spec :
            4)  If one of the fields in the end of central directory
                record is too small to hold required data, the field
                should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                ZIP64 format record should be created.
            5)  The end of central directory record and the
                Zip64 end of central directory locator record must
                reside on the same disk when splitting or spanning
                an archive.
         */
        if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : Javascript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
                throw new Error("Corrupted zip : can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
                // console.warn("ZIP64 end of central directory not where expected.");
                this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
                if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                    throw new Error("Corrupted zip : can't find the ZIP64 end of central directory");
                }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
        }

        var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
        if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
        }

        var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;

        if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
                // The offsets seem wrong, but we have something at the specified offset.
                // So… we keep it.
            } else {
                // the offset is wrong, update the "zero" of the reader
                // this happens if data has been prepended (crx files for example)
                this.reader.zero = extraBytes;
            }
        } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
        }
    },
    prepareReader: function(data) {
        this.reader = readerFor(data);
    },
    /**
     * Read a zip file and create ZipEntries.
     * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
     */
    load: function(data) {
        this.prepareReader(data);
        this.readEndOfCentral();
        this.readCentralDir();
        this.readLocalFiles();
    }
};
// }}} end of ZipEntries
module.exports = ZipEntries;

},{"./reader/readerFor":59,"./signature":60,"./support":67,"./utf8":68,"./utils":69,"./zipEntry":71}],71:[function(require,module,exports){
'use strict';
var readerFor = require('./reader/readerFor');
var utils = require('./utils');
var CompressedObject = require('./compressedObject');
var crc32fn = require('./crc32');
var utf8 = require('./utf8');
var compressions = require('./compressions');
var support = require('./support');

var MADE_BY_DOS = 0x00;
var MADE_BY_UNIX = 0x03;

/**
 * Find a compression registered in JSZip.
 * @param {string} compressionMethod the method magic to find.
 * @return {Object|null} the JSZip compression object, null if none found.
 */
var findCompression = function(compressionMethod) {
    for (var method in compressions) {
        if (!compressions.hasOwnProperty(method)) {
            continue;
        }
        if (compressions[method].magic === compressionMethod) {
            return compressions[method];
        }
    }
    return null;
};

// class ZipEntry {{{
/**
 * An entry in the zip file.
 * @constructor
 * @param {Object} options Options of the current file.
 * @param {Object} loadOptions Options for loading the stream.
 */
function ZipEntry(options, loadOptions) {
    this.options = options;
    this.loadOptions = loadOptions;
}
ZipEntry.prototype = {
    /**
     * say if the file is encrypted.
     * @return {boolean} true if the file is encrypted, false otherwise.
     */
    isEncrypted: function() {
        // bit 1 is set
        return (this.bitFlag & 0x0001) === 0x0001;
    },
    /**
     * say if the file has utf-8 filename/comment.
     * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
     */
    useUTF8: function() {
        // bit 11 is set
        return (this.bitFlag & 0x0800) === 0x0800;
    },
    /**
     * Read the local part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readLocalPart: function(reader) {
        var compression, localExtraFieldsLength;

        // we already know everything from the central dir !
        // If the central dir data are false, we are doomed.
        // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
        // The less data we get here, the more reliable this should be.
        // Let's skip the whole header and dash to the data !
        reader.skip(22);
        // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
        // Strangely, the filename here is OK.
        // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
        // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
        // Search "unzip mismatching "local" filename continuing with "central" filename version" on
        // the internet.
        //
        // I think I see the logic here : the central directory is used to display
        // content and the local directory is used to extract the files. Mixing / and \
        // may be used to display \ to windows users and use / when extracting the files.
        // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
        this.fileNameLength = reader.readInt(2);
        localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
        // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
        this.fileName = reader.readData(this.fileNameLength);
        reader.skip(localExtraFieldsLength);

        if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough informations from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
        }

        compression = findCompression(this.compressionMethod);
        if (compression === null) { // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
        }
        this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
    },

    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readCentralPart: function(reader) {
        this.versionMadeBy = reader.readInt(2);
        reader.skip(2);
        // this.versionNeeded = reader.readInt(2);
        this.bitFlag = reader.readInt(2);
        this.compressionMethod = reader.readString(2);
        this.date = reader.readDate();
        this.crc32 = reader.readInt(4);
        this.compressedSize = reader.readInt(4);
        this.uncompressedSize = reader.readInt(4);
        var fileNameLength = reader.readInt(2);
        this.extraFieldsLength = reader.readInt(2);
        this.fileCommentLength = reader.readInt(2);
        this.diskNumberStart = reader.readInt(2);
        this.internalFileAttributes = reader.readInt(2);
        this.externalFileAttributes = reader.readInt(4);
        this.localHeaderOffset = reader.readInt(4);

        if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
        }

        // will be read in the local part, see the comments there
        reader.skip(fileNameLength);
        this.readExtraFields(reader);
        this.parseZIP64ExtraField(reader);
        this.fileComment = reader.readData(this.fileCommentLength);
    },

    /**
     * Parse the external file attributes and get the unix/dos permissions.
     */
    processAttributes: function () {
        this.unixPermissions = null;
        this.dosPermissions = null;
        var madeBy = this.versionMadeBy >> 8;

        // Check if we have the DOS directory flag set.
        // We look for it in the DOS and UNIX permissions
        // but some unknown platform could set it as a compatibility flag.
        this.dir = this.externalFileAttributes & 0x0010 ? true : false;

        if(madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
        }

        if(madeBy === MADE_BY_UNIX) {
            this.unixPermissions = (this.externalFileAttributes >> 16) & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
        }

        // fail safe : if the name ends with a / it probably means a folder
        if (!this.dir && this.fileNameStr.slice(-1) === '/') {
            this.dir = true;
        }
    },

    /**
     * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
     * @param {DataReader} reader the reader to use.
     */
    parseZIP64ExtraField: function(reader) {

        if (!this.extraFields[0x0001]) {
            return;
        }

        // should be something, preparing the extra reader
        var extraReader = readerFor(this.extraFields[0x0001].value);

        // I really hope that these 64bits integer can fit in 32 bits integer, because js
        // won't let us have more.
        if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
        }
        if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
        }
        if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
        }
        if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
        }
    },
    /**
     * Read the central part of a zip file and add the info in this object.
     * @param {DataReader} reader the reader to use.
     */
    readExtraFields: function(reader) {
        var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;

        if (!this.extraFields) {
            this.extraFields = {};
        }

        while (reader.index < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);

            this.extraFields[extraFieldId] = {
                id: extraFieldId,
                length: extraFieldLength,
                value: extraFieldValue
            };
        }
    },
    /**
     * Apply an UTF8 transformation if needed.
     */
    handleUTF8: function() {
        var decodeParamType = support.uint8array ? "uint8array" : "array";
        if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
        } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
                this.fileNameStr = upath;
            } else {
                // ASCII text or unsupported code page
                var fileNameByteArray =  utils.transformTo(decodeParamType, this.fileName);
                this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }

            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
                this.fileCommentStr = ucomment;
            } else {
                // ASCII text or unsupported code page
                var commentByteArray =  utils.transformTo(decodeParamType, this.fileComment);
                this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
        }
    },

    /**
     * Find the unicode path declared in the extra field, if any.
     * @return {String} the unicode path, null otherwise.
     */
    findExtraFieldUnicodePath: function() {
        var upathField = this.extraFields[0x7075];
        if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
        }
        return null;
    },

    /**
     * Find the unicode comment declared in the extra field, if any.
     * @return {String} the unicode comment, null otherwise.
     */
    findExtraFieldUnicodeComment: function() {
        var ucommentField = this.extraFields[0x6375];
        if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
                return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
                return null;
            }

            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
        }
        return null;
    }
};
module.exports = ZipEntry;

},{"./compressedObject":39,"./compressions":40,"./crc32":41,"./reader/readerFor":59,"./support":67,"./utf8":68,"./utils":69}],72:[function(require,module,exports){
'use strict';

var StreamHelper = require('./stream/StreamHelper');
var DataWorker = require('./stream/DataWorker');
var utf8 = require('./utf8');
var CompressedObject = require('./compressedObject');
var GenericWorker = require('./stream/GenericWorker');

/**
 * A simple object representing a file in the zip file.
 * @constructor
 * @param {string} name the name of the file
 * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
 * @param {Object} options the options of the file
 */
var ZipObject = function(name, data, options) {
    this.name = name;
    this.dir = options.dir;
    this.date = options.date;
    this.comment = options.comment;
    this.unixPermissions = options.unixPermissions;
    this.dosPermissions = options.dosPermissions;

    this._data = data;
    this._dataBinary = options.binary;
    // keep only the compression
    this.options = {
        compression : options.compression,
        compressionOptions : options.compressionOptions
    };
};

ZipObject.prototype = {
    /**
     * Create an internal stream for the content of this object.
     * @param {String} type the type of each chunk.
     * @return StreamHelper the stream.
     */
    internalStream: function (type) {
        var outputType = type.toLowerCase();
        var askUnicodeString = outputType === "string" || outputType === "text";
        if (outputType === "binarystring" || outputType === "text") {
            outputType = "string";
        }
        var result = this._decompressWorker();

        var isUnicodeString = !this._dataBinary;

        if (isUnicodeString && !askUnicodeString) {
            result = result.pipe(new utf8.Utf8EncodeWorker());
        }
        if (!isUnicodeString && askUnicodeString) {
            result = result.pipe(new utf8.Utf8DecodeWorker());
        }

        return new StreamHelper(result, outputType, "");
    },

    /**
     * Prepare the content in the asked type.
     * @param {String} type the type of the result.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Promise the promise of the result.
     */
    async: function (type, onUpdate) {
        return this.internalStream(type).accumulate(onUpdate);
    },

    /**
     * Prepare the content as a nodejs stream.
     * @param {String} type the type of each chunk.
     * @param {Function} onUpdate a function to call on each internal update.
     * @return Stream the stream.
     */
    nodeStream: function (type, onUpdate) {
        return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
    },

    /**
     * Return a worker for the compressed content.
     * @private
     * @param {Object} compression the compression object to use.
     * @param {Object} compressionOptions the options to use when compressing.
     * @return Worker the worker.
     */
    _compressWorker: function (compression, compressionOptions) {
        if (
            this._data instanceof CompressedObject &&
            this._data.compression.magic === compression.magic
        ) {
            return this._data.getCompressedWorker();
        } else {
            var result = this._decompressWorker();
            if(!this._dataBinary) {
                result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
        }
    },
    /**
     * Return a worker for the decompressed content.
     * @private
     * @return Worker the worker.
     */
    _decompressWorker : function () {
        if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
        } else if (this._data instanceof GenericWorker) {
            return this._data;
        } else {
            return new DataWorker(this._data);
        }
    }
};

var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
var removedFn = function () {
    throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
};

for(var i = 0; i < removedMethods.length; i++) {
    ZipObject.prototype[removedMethods[i]] = removedFn;
}
module.exports = ZipObject;

},{"./compressedObject":39,"./stream/DataWorker":64,"./stream/GenericWorker":65,"./stream/StreamHelper":66,"./utf8":68}],73:[function(require,module,exports){
'use strict';
var immediate = require('immediate');

/* istanbul ignore next */
function INTERNAL() {}

var handlers = {};

var REJECTED = ['REJECTED'];
var FULFILLED = ['FULFILLED'];
var PENDING = ['PENDING'];

module.exports = Promise;

function Promise(resolver) {
  if (typeof resolver !== 'function') {
    throw new TypeError('resolver must be a function');
  }
  this.state = PENDING;
  this.queue = [];
  this.outcome = void 0;
  if (resolver !== INTERNAL) {
    safelyResolveThenable(this, resolver);
  }
}

Promise.prototype["catch"] = function (onRejected) {
  return this.then(null, onRejected);
};
Promise.prototype.then = function (onFulfilled, onRejected) {
  if (typeof onFulfilled !== 'function' && this.state === FULFILLED ||
    typeof onRejected !== 'function' && this.state === REJECTED) {
    return this;
  }
  var promise = new this.constructor(INTERNAL);
  if (this.state !== PENDING) {
    var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
    unwrap(promise, resolver, this.outcome);
  } else {
    this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
  }

  return promise;
};
function QueueItem(promise, onFulfilled, onRejected) {
  this.promise = promise;
  if (typeof onFulfilled === 'function') {
    this.onFulfilled = onFulfilled;
    this.callFulfilled = this.otherCallFulfilled;
  }
  if (typeof onRejected === 'function') {
    this.onRejected = onRejected;
    this.callRejected = this.otherCallRejected;
  }
}
QueueItem.prototype.callFulfilled = function (value) {
  handlers.resolve(this.promise, value);
};
QueueItem.prototype.otherCallFulfilled = function (value) {
  unwrap(this.promise, this.onFulfilled, value);
};
QueueItem.prototype.callRejected = function (value) {
  handlers.reject(this.promise, value);
};
QueueItem.prototype.otherCallRejected = function (value) {
  unwrap(this.promise, this.onRejected, value);
};

function unwrap(promise, func, value) {
  immediate(function () {
    var returnValue;
    try {
      returnValue = func(value);
    } catch (e) {
      return handlers.reject(promise, e);
    }
    if (returnValue === promise) {
      handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
    } else {
      handlers.resolve(promise, returnValue);
    }
  });
}

handlers.resolve = function (self, value) {
  var result = tryCatch(getThen, value);
  if (result.status === 'error') {
    return handlers.reject(self, result.value);
  }
  var thenable = result.value;

  if (thenable) {
    safelyResolveThenable(self, thenable);
  } else {
    self.state = FULFILLED;
    self.outcome = value;
    var i = -1;
    var len = self.queue.length;
    while (++i < len) {
      self.queue[i].callFulfilled(value);
    }
  }
  return self;
};
handlers.reject = function (self, error) {
  self.state = REJECTED;
  self.outcome = error;
  var i = -1;
  var len = self.queue.length;
  while (++i < len) {
    self.queue[i].callRejected(error);
  }
  return self;
};

function getThen(obj) {
  // Make sure we only access the accessor once as required by the spec
  var then = obj && obj.then;
  if (obj && typeof obj === 'object' && typeof then === 'function') {
    return function appyThen() {
      then.apply(obj, arguments);
    };
  }
}

function safelyResolveThenable(self, thenable) {
  // Either fulfill, reject or reject with error
  var called = false;
  function onError(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.reject(self, value);
  }

  function onSuccess(value) {
    if (called) {
      return;
    }
    called = true;
    handlers.resolve(self, value);
  }

  function tryToUnwrap() {
    thenable(onSuccess, onError);
  }

  var result = tryCatch(tryToUnwrap);
  if (result.status === 'error') {
    onError(result.value);
  }
}

function tryCatch(func, value) {
  var out = {};
  try {
    out.value = func(value);
    out.status = 'success';
  } catch (e) {
    out.status = 'error';
    out.value = e;
  }
  return out;
}

Promise.resolve = resolve;
function resolve(value) {
  if (value instanceof this) {
    return value;
  }
  return handlers.resolve(new this(INTERNAL), value);
}

Promise.reject = reject;
function reject(reason) {
  var promise = new this(INTERNAL);
  return handlers.reject(promise, reason);
}

Promise.all = all;
function all(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var values = new Array(len);
  var resolved = 0;
  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    allResolver(iterable[i], i);
  }
  return promise;
  function allResolver(value, i) {
    self.resolve(value).then(resolveFromAll, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
    function resolveFromAll(outValue) {
      values[i] = outValue;
      if (++resolved === len && !called) {
        called = true;
        handlers.resolve(promise, values);
      }
    }
  }
}

Promise.race = race;
function race(iterable) {
  var self = this;
  if (Object.prototype.toString.call(iterable) !== '[object Array]') {
    return this.reject(new TypeError('must be an array'));
  }

  var len = iterable.length;
  var called = false;
  if (!len) {
    return this.resolve([]);
  }

  var i = -1;
  var promise = new this(INTERNAL);

  while (++i < len) {
    resolver(iterable[i]);
  }
  return promise;
  function resolver(value) {
    self.resolve(value).then(function (response) {
      if (!called) {
        called = true;
        handlers.resolve(promise, response);
      }
    }, function (error) {
      if (!called) {
        called = true;
        handlers.reject(promise, error);
      }
    });
  }
}

},{"immediate":34}],74:[function(require,module,exports){
// Top level file is just a mixin of submodules & constants
'use strict';

var assign    = require('./lib/utils/common').assign;

var deflate   = require('./lib/deflate');
var inflate   = require('./lib/inflate');
var constants = require('./lib/zlib/constants');

var pako = {};

assign(pako, deflate, inflate, constants);

module.exports = pako;

},{"./lib/deflate":75,"./lib/inflate":76,"./lib/utils/common":77,"./lib/zlib/constants":80}],75:[function(require,module,exports){
'use strict';


var zlib_deflate = require('./zlib/deflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');

var toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

var Z_NO_FLUSH      = 0;
var Z_FINISH        = 4;

var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_SYNC_FLUSH    = 2;

var Z_DEFAULT_COMPRESSION = -1;

var Z_DEFAULT_STRATEGY    = 0;

var Z_DEFLATED  = 8;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overriden.
 **/

/**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate(options) {
  if (!(this instanceof Deflate)) return new Deflate(options);

  this.options = utils.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY,
    to: ''
  }, options || {});

  var opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new ZStream();
  this.strm.avail_out = 0;

  var status = zlib_deflate.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK) {
    throw new Error(msg[status]);
  }

  if (opt.header) {
    zlib_deflate.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    var dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = zlib_deflate.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK) {
      throw new Error(msg[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var status, _mode;

  if (this.ended) { return false; }

  _mode = (mode === ~~mode) ? mode : ((mode === true) ? Z_FINISH : Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }
    status = zlib_deflate.deflate(strm, _mode);    /* no bad return value */

    if (status !== Z_STREAM_END && status !== Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }
    if (strm.avail_out === 0 || (strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH))) {
      if (this.options.to === 'string') {
        this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
      } else {
        this.onData(utils.shrinkBuf(strm.output, strm.next_out));
      }
    }
  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

  // Finalize on the last chunk.
  if (_mode === Z_FINISH) {
    status = zlib_deflate.deflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === Z_SYNC_FLUSH) {
    this.onEnd(Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate(input, options) {
  var deflator = new Deflate(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return deflate(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate(input, options);
}


exports.Deflate = Deflate;
exports.deflate = deflate;
exports.deflateRaw = deflateRaw;
exports.gzip = gzip;

},{"./utils/common":77,"./utils/strings":78,"./zlib/deflate":82,"./zlib/messages":87,"./zlib/zstream":89}],76:[function(require,module,exports){
'use strict';


var zlib_inflate = require('./zlib/inflate');
var utils        = require('./utils/common');
var strings      = require('./utils/strings');
var c            = require('./zlib/constants');
var msg          = require('./zlib/messages');
var ZStream      = require('./zlib/zstream');
var GZheader     = require('./zlib/gzheader');

var toString = Object.prototype.toString;

/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overriden.
 **/

/**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate(options) {
  if (!(this instanceof Inflate)) return new Inflate(options);

  this.options = utils.assign({
    chunkSize: 16384,
    windowBits: 0,
    to: ''
  }, options || {});

  var opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new ZStream();
  this.strm.avail_out = 0;

  var status  = zlib_inflate.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== c.Z_OK) {
    throw new Error(msg[status]);
  }

  this.header = new GZheader();

  zlib_inflate.inflateGetHeader(this.strm, this.header);
}

/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate.prototype.push = function (data, mode) {
  var strm = this.strm;
  var chunkSize = this.options.chunkSize;
  var dictionary = this.options.dictionary;
  var status, _mode;
  var next_out_utf8, tail, utf8str;
  var dict;

  // Flag to properly process Z_BUF_ERROR on testing inflate call
  // when we check that all output data was flushed.
  var allowBufError = false;

  if (this.ended) { return false; }
  _mode = (mode === ~~mode) ? mode : ((mode === true) ? c.Z_FINISH : c.Z_NO_FLUSH);

  // Convert data if needed
  if (typeof data === 'string') {
    // Only binary strings can be decompressed on practice
    strm.input = strings.binstring2buf(data);
  } else if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  do {
    if (strm.avail_out === 0) {
      strm.output = new utils.Buf8(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH);    /* no bad return value */

    if (status === c.Z_NEED_DICT && dictionary) {
      // Convert data if needed
      if (typeof dictionary === 'string') {
        dict = strings.string2buf(dictionary);
      } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
        dict = new Uint8Array(dictionary);
      } else {
        dict = dictionary;
      }

      status = zlib_inflate.inflateSetDictionary(this.strm, dict);

    }

    if (status === c.Z_BUF_ERROR && allowBufError === true) {
      status = c.Z_OK;
      allowBufError = false;
    }

    if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
      this.onEnd(status);
      this.ended = true;
      return false;
    }

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === c.Z_STREAM_END || (strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH))) {

        if (this.options.to === 'string') {

          next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          tail = strm.next_out - next_out_utf8;
          utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) { utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0); }

          this.onData(utf8str);

        } else {
          this.onData(utils.shrinkBuf(strm.output, strm.next_out));
        }
      }
    }

    // When no more input data, we should check that internal inflate buffers
    // are flushed. The only way to do it when avail_out = 0 - run one more
    // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
    // Here we set flag to process this error properly.
    //
    // NOTE. Deflate does not return error in this case and does not needs such
    // logic.
    if (strm.avail_in === 0 && strm.avail_out === 0) {
      allowBufError = true;
    }

  } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);

  if (status === c.Z_STREAM_END) {
    _mode = c.Z_FINISH;
  }

  // Finalize on the last chunk.
  if (_mode === c.Z_FINISH) {
    status = zlib_inflate.inflateEnd(this.strm);
    this.onEnd(status);
    this.ended = true;
    return status === c.Z_OK;
  }

  // callback interim results if Z_SYNC_FLUSH.
  if (_mode === c.Z_SYNC_FLUSH) {
    this.onEnd(c.Z_OK);
    strm.avail_out = 0;
    return true;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate.prototype.onEnd = function (status) {
  // On success - join
  if (status === c.Z_OK) {
    if (this.options.to === 'string') {
      // Glue & convert here, until we teach pako to send
      // utf8 alligned strings to onData
      this.result = this.chunks.join('');
    } else {
      this.result = utils.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/
function inflate(input, options) {
  var inflator = new Inflate(options);

  inflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) { throw inflator.msg; }

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw(input, options) {
  options = options || {};
  options.raw = true;
  return inflate(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


exports.Inflate = Inflate;
exports.inflate = inflate;
exports.inflateRaw = inflateRaw;
exports.ungzip  = inflate;

},{"./utils/common":77,"./utils/strings":78,"./zlib/constants":80,"./zlib/gzheader":83,"./zlib/inflate":85,"./zlib/messages":87,"./zlib/zstream":89}],77:[function(require,module,exports){
'use strict';


var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');


exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (source.hasOwnProperty(p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);

},{}],78:[function(require,module,exports){
// String encode/decode helpers
'use strict';


var utils = require('./common');


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safary
//
var STR_APPLY_OK = true;
var STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, [ 0 ]); } catch (__) { STR_APPLY_OK = false; }
try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var _utf8len = new utils.Buf8(256);
for (var q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
exports.string2buf = function (str) {
  var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new utils.Buf8(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper (used in 2 places)
function buf2binstring(buf, len) {
  // use fallback for big arrays to avoid stack overflow
  if (len < 65537) {
    if ((buf.subarray && STR_APPLY_UIA_OK) || (!buf.subarray && STR_APPLY_OK)) {
      return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
    }
  }

  var result = '';
  for (var i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
}


// Convert byte array to binary string
exports.buf2binstring = function (buf) {
  return buf2binstring(buf, buf.length);
};


// Convert binary string (typed, when possible)
exports.binstring2buf = function (str) {
  var buf = new utils.Buf8(str.length);
  for (var i = 0, len = buf.length; i < len; i++) {
    buf[i] = str.charCodeAt(i);
  }
  return buf;
};


// convert array to string
exports.buf2string = function (buf, max) {
  var i, out, c, c_len;
  var len = max || buf.length;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  var utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
exports.utf8border = function (buf, max) {
  var pos;

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Fuckup - very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means vuffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

},{"./common":77}],79:[function(require,module,exports){
'use strict';

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It doesn't worth to make additional optimizationa as in original.
// Small size is preferable.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;

},{}],80:[function(require,module,exports){
'use strict';


module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

},{}],81:[function(require,module,exports){
'use strict';

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.


// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;

},{}],82:[function(require,module,exports){
'use strict';

var utils   = require('../utils/common');
var trees   = require('./trees');
var adler32 = require('./adler32');
var crc32   = require('./crc32');
var msg     = require('./messages');

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
                );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/

},{"../utils/common":77,"./adler32":79,"./crc32":81,"./messages":87,"./trees":88}],83:[function(require,module,exports){
'use strict';


function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

module.exports = GZheader;

},{}],84:[function(require,module,exports){
'use strict';

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

},{}],85:[function(require,module,exports){
'use strict';


var utils         = require('../utils/common');
var adler32       = require('./adler32');
var crc32         = require('./crc32');
var inflate_fast  = require('./inffast');
var inflate_table = require('./inftrees');

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
    case HEAD:
      if (state.wrap === 0) {
        state.mode = TYPEDO;
        break;
      }
      //=== NEEDBITS(16);
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
        state.check = 0/*crc32(0L, Z_NULL, 0)*/;
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//

        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = FLAGS;
        break;
      }
      state.flags = 0;           /* expect zlib header */
      if (state.head) {
        state.head.done = false;
      }
      if (!(state.wrap & 1) ||   /* check if zlib header allowed */
        (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
        strm.msg = 'incorrect header check';
        state.mode = BAD;
        break;
      }
      if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
      len = (hold & 0x0f)/*BITS(4)*/ + 8;
      if (state.wbits === 0) {
        state.wbits = len;
      }
      else if (len > state.wbits) {
        strm.msg = 'invalid window size';
        state.mode = BAD;
        break;
      }
      state.dmax = 1 << len;
      //Tracev((stderr, "inflate:   zlib header ok\n"));
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = hold & 0x200 ? DICTID : TYPE;
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      break;
    case FLAGS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.flags = hold;
      if ((state.flags & 0xff) !== Z_DEFLATED) {
        strm.msg = 'unknown compression method';
        state.mode = BAD;
        break;
      }
      if (state.flags & 0xe000) {
        strm.msg = 'unknown header flags set';
        state.mode = BAD;
        break;
      }
      if (state.head) {
        state.head.text = ((hold >> 8) & 1);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = TIME;
      /* falls through */
    case TIME:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.time = hold;
      }
      if (state.flags & 0x0200) {
        //=== CRC4(state.check, hold)
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        hbuf[2] = (hold >>> 16) & 0xff;
        hbuf[3] = (hold >>> 24) & 0xff;
        state.check = crc32(state.check, hbuf, 4, 0);
        //===
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = OS;
      /* falls through */
    case OS:
      //=== NEEDBITS(16); */
      while (bits < 16) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if (state.head) {
        state.head.xflags = (hold & 0xff);
        state.head.os = (hold >> 8);
      }
      if (state.flags & 0x0200) {
        //=== CRC2(state.check, hold);
        hbuf[0] = hold & 0xff;
        hbuf[1] = (hold >>> 8) & 0xff;
        state.check = crc32(state.check, hbuf, 2, 0);
        //===//
      }
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = EXLEN;
      /* falls through */
    case EXLEN:
      if (state.flags & 0x0400) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length = hold;
        if (state.head) {
          state.head.extra_len = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      else if (state.head) {
        state.head.extra = null/*Z_NULL*/;
      }
      state.mode = EXTRA;
      /* falls through */
    case EXTRA:
      if (state.flags & 0x0400) {
        copy = state.length;
        if (copy > have) { copy = have; }
        if (copy) {
          if (state.head) {
            len = state.head.extra_len - state.length;
            if (!state.head.extra) {
              // Use untyped array for more conveniend processing later
              state.head.extra = new Array(state.head.extra_len);
            }
            utils.arraySet(
              state.head.extra,
              input,
              next,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              copy,
              /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
              len
            );
            //zmemcpy(state.head.extra + len, next,
            //        len + copy > state.head.extra_max ?
            //        state.head.extra_max - len : copy);
          }
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          state.length -= copy;
        }
        if (state.length) { break inf_leave; }
      }
      state.length = 0;
      state.mode = NAME;
      /* falls through */
    case NAME:
      if (state.flags & 0x0800) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          // TODO: 2 or 1 bytes?
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.name_max*/)) {
            state.head.name += String.fromCharCode(len);
          }
        } while (len && copy < have);

        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.name = null;
      }
      state.length = 0;
      state.mode = COMMENT;
      /* falls through */
    case COMMENT:
      if (state.flags & 0x1000) {
        if (have === 0) { break inf_leave; }
        copy = 0;
        do {
          len = input[next + copy++];
          /* use constant limit because in js we should not preallocate memory */
          if (state.head && len &&
              (state.length < 65536 /*state.head.comm_max*/)) {
            state.head.comment += String.fromCharCode(len);
          }
        } while (len && copy < have);
        if (state.flags & 0x0200) {
          state.check = crc32(state.check, input, copy, next);
        }
        have -= copy;
        next += copy;
        if (len) { break inf_leave; }
      }
      else if (state.head) {
        state.head.comment = null;
      }
      state.mode = HCRC;
      /* falls through */
    case HCRC:
      if (state.flags & 0x0200) {
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.check & 0xffff)) {
          strm.msg = 'header crc mismatch';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
      }
      if (state.head) {
        state.head.hcrc = ((state.flags >> 9) & 1);
        state.head.done = true;
      }
      strm.adler = state.check = 0;
      state.mode = TYPE;
      break;
    case DICTID:
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      strm.adler = state.check = zswap32(hold);
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = DICT;
      /* falls through */
    case DICT:
      if (state.havedict === 0) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        return Z_NEED_DICT;
      }
      strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
      state.mode = TYPE;
      /* falls through */
    case TYPE:
      if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case TYPEDO:
      if (state.last) {
        //--- BYTEBITS() ---//
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        state.mode = CHECK;
        break;
      }
      //=== NEEDBITS(3); */
      while (bits < 3) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.last = (hold & 0x01)/*BITS(1)*/;
      //--- DROPBITS(1) ---//
      hold >>>= 1;
      bits -= 1;
      //---//

      switch ((hold & 0x03)/*BITS(2)*/) {
      case 0:                             /* stored block */
        //Tracev((stderr, "inflate:     stored block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = STORED;
        break;
      case 1:                             /* fixed block */
        fixedtables(state);
        //Tracev((stderr, "inflate:     fixed codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = LEN_;             /* decode codes */
        if (flush === Z_TREES) {
          //--- DROPBITS(2) ---//
          hold >>>= 2;
          bits -= 2;
          //---//
          break inf_leave;
        }
        break;
      case 2:                             /* dynamic block */
        //Tracev((stderr, "inflate:     dynamic codes block%s\n",
        //        state.last ? " (last)" : ""));
        state.mode = TABLE;
        break;
      case 3:
        strm.msg = 'invalid block type';
        state.mode = BAD;
      }
      //--- DROPBITS(2) ---//
      hold >>>= 2;
      bits -= 2;
      //---//
      break;
    case STORED:
      //--- BYTEBITS() ---// /* go to byte boundary */
      hold >>>= bits & 7;
      bits -= bits & 7;
      //---//
      //=== NEEDBITS(32); */
      while (bits < 32) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
        strm.msg = 'invalid stored block lengths';
        state.mode = BAD;
        break;
      }
      state.length = hold & 0xffff;
      //Tracev((stderr, "inflate:       stored length %u\n",
      //        state.length));
      //=== INITBITS();
      hold = 0;
      bits = 0;
      //===//
      state.mode = COPY_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case COPY_:
      state.mode = COPY;
      /* falls through */
    case COPY:
      copy = state.length;
      if (copy) {
        if (copy > have) { copy = have; }
        if (copy > left) { copy = left; }
        if (copy === 0) { break inf_leave; }
        //--- zmemcpy(put, next, copy); ---
        utils.arraySet(output, input, next, copy, put);
        //---//
        have -= copy;
        next += copy;
        left -= copy;
        put += copy;
        state.length -= copy;
        break;
      }
      //Tracev((stderr, "inflate:       stored end\n"));
      state.mode = TYPE;
      break;
    case TABLE:
      //=== NEEDBITS(14); */
      while (bits < 14) {
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
      }
      //===//
      state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
      //--- DROPBITS(5) ---//
      hold >>>= 5;
      bits -= 5;
      //---//
      state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
      //--- DROPBITS(4) ---//
      hold >>>= 4;
      bits -= 4;
      //---//
//#ifndef PKZIP_BUG_WORKAROUND
      if (state.nlen > 286 || state.ndist > 30) {
        strm.msg = 'too many length or distance symbols';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracev((stderr, "inflate:       table sizes ok\n"));
      state.have = 0;
      state.mode = LENLENS;
      /* falls through */
    case LENLENS:
      while (state.have < state.ncode) {
        //=== NEEDBITS(3);
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
        //--- DROPBITS(3) ---//
        hold >>>= 3;
        bits -= 3;
        //---//
      }
      while (state.have < 19) {
        state.lens[order[state.have++]] = 0;
      }
      // We have separate tables & no pointers. 2 commented lines below not needed.
      //state.next = state.codes;
      //state.lencode = state.next;
      // Switch to use dynamic table
      state.lencode = state.lendyn;
      state.lenbits = 7;

      opts = { bits: state.lenbits };
      ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
      state.lenbits = opts.bits;

      if (ret) {
        strm.msg = 'invalid code lengths set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, "inflate:       code lengths ok\n"));
      state.have = 0;
      state.mode = CODELENS;
      /* falls through */
    case CODELENS:
      while (state.have < state.nlen + state.ndist) {
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_val < 16) {
          //--- DROPBITS(here.bits) ---//
          hold >>>= here_bits;
          bits -= here_bits;
          //---//
          state.lens[state.have++] = here_val;
        }
        else {
          if (here_val === 16) {
            //=== NEEDBITS(here.bits + 2);
            n = here_bits + 2;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            if (state.have === 0) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            len = state.lens[state.have - 1];
            copy = 3 + (hold & 0x03);//BITS(2);
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            //---//
          }
          else if (here_val === 17) {
            //=== NEEDBITS(here.bits + 3);
            n = here_bits + 3;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 3 + (hold & 0x07);//BITS(3);
            //--- DROPBITS(3) ---//
            hold >>>= 3;
            bits -= 3;
            //---//
          }
          else {
            //=== NEEDBITS(here.bits + 7);
            n = here_bits + 7;
            while (bits < n) {
              if (have === 0) { break inf_leave; }
              have--;
              hold += input[next++] << bits;
              bits += 8;
            }
            //===//
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            len = 0;
            copy = 11 + (hold & 0x7f);//BITS(7);
            //--- DROPBITS(7) ---//
            hold >>>= 7;
            bits -= 7;
            //---//
          }
          if (state.have + copy > state.nlen + state.ndist) {
            strm.msg = 'invalid bit length repeat';
            state.mode = BAD;
            break;
          }
          while (copy--) {
            state.lens[state.have++] = len;
          }
        }
      }

      /* handle error breaks in while */
      if (state.mode === BAD) { break; }

      /* check for end-of-block code (better have one) */
      if (state.lens[256] === 0) {
        strm.msg = 'invalid code -- missing end-of-block';
        state.mode = BAD;
        break;
      }

      /* build code tables -- note: do not change the lenbits or distbits
         values here (9 and 6) without reading the comments in inftrees.h
         concerning the ENOUGH constants, which depend on those values */
      state.lenbits = 9;

      opts = { bits: state.lenbits };
      ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.lenbits = opts.bits;
      // state.lencode = state.next;

      if (ret) {
        strm.msg = 'invalid literal/lengths set';
        state.mode = BAD;
        break;
      }

      state.distbits = 6;
      //state.distcode.copy(state.codes);
      // Switch to use dynamic table
      state.distcode = state.distdyn;
      opts = { bits: state.distbits };
      ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
      // We have separate tables & no pointers. 2 commented lines below not needed.
      // state.next_index = opts.table_index;
      state.distbits = opts.bits;
      // state.distcode = state.next;

      if (ret) {
        strm.msg = 'invalid distances set';
        state.mode = BAD;
        break;
      }
      //Tracev((stderr, 'inflate:       codes ok\n'));
      state.mode = LEN_;
      if (flush === Z_TREES) { break inf_leave; }
      /* falls through */
    case LEN_:
      state.mode = LEN;
      /* falls through */
    case LEN:
      if (have >= 6 && left >= 258) {
        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---
        inflate_fast(strm, _out);
        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        if (state.mode === TYPE) {
          state.back = -1;
        }
        break;
      }
      state.back = 0;
      for (;;) {
        here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if (here_bits <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if (here_op && (here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.lencode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      state.length = here_val;
      if (here_op === 0) {
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        state.mode = LIT;
        break;
      }
      if (here_op & 32) {
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.back = -1;
        state.mode = TYPE;
        break;
      }
      if (here_op & 64) {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break;
      }
      state.extra = here_op & 15;
      state.mode = LENEXT;
      /* falls through */
    case LENEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
      //Tracevv((stderr, "inflate:         length %u\n", state.length));
      state.was = state.length;
      state.mode = DIST;
      /* falls through */
    case DIST:
      for (;;) {
        here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
        here_bits = here >>> 24;
        here_op = (here >>> 16) & 0xff;
        here_val = here & 0xffff;

        if ((here_bits) <= bits) { break; }
        //--- PULLBYTE() ---//
        if (have === 0) { break inf_leave; }
        have--;
        hold += input[next++] << bits;
        bits += 8;
        //---//
      }
      if ((here_op & 0xf0) === 0) {
        last_bits = here_bits;
        last_op = here_op;
        last_val = here_val;
        for (;;) {
          here = state.distcode[last_val +
                  ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((last_bits + here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        //--- DROPBITS(last.bits) ---//
        hold >>>= last_bits;
        bits -= last_bits;
        //---//
        state.back += last_bits;
      }
      //--- DROPBITS(here.bits) ---//
      hold >>>= here_bits;
      bits -= here_bits;
      //---//
      state.back += here_bits;
      if (here_op & 64) {
        strm.msg = 'invalid distance code';
        state.mode = BAD;
        break;
      }
      state.offset = here_val;
      state.extra = (here_op) & 15;
      state.mode = DISTEXT;
      /* falls through */
    case DISTEXT:
      if (state.extra) {
        //=== NEEDBITS(state.extra);
        n = state.extra;
        while (bits < n) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
        //--- DROPBITS(state.extra) ---//
        hold >>>= state.extra;
        bits -= state.extra;
        //---//
        state.back += state.extra;
      }
//#ifdef INFLATE_STRICT
      if (state.offset > state.dmax) {
        strm.msg = 'invalid distance too far back';
        state.mode = BAD;
        break;
      }
//#endif
      //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
      state.mode = MATCH;
      /* falls through */
    case MATCH:
      if (left === 0) { break inf_leave; }
      copy = _out - left;
      if (state.offset > copy) {         /* copy from window */
        copy = state.offset - copy;
        if (copy > state.whave) {
          if (state.sane) {
            strm.msg = 'invalid distance too far back';
            state.mode = BAD;
            break;
          }
// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
        }
        if (copy > state.wnext) {
          copy -= state.wnext;
          from = state.wsize - copy;
        }
        else {
          from = state.wnext - copy;
        }
        if (copy > state.length) { copy = state.length; }
        from_source = state.window;
      }
      else {                              /* copy from output */
        from_source = output;
        from = put - state.offset;
        copy = state.length;
      }
      if (copy > left) { copy = left; }
      left -= copy;
      state.length -= copy;
      do {
        output[put++] = from_source[from++];
      } while (--copy);
      if (state.length === 0) { state.mode = LEN; }
      break;
    case LIT:
      if (left === 0) { break inf_leave; }
      output[put++] = state.length;
      left--;
      state.mode = LEN;
      break;
    case CHECK:
      if (state.wrap) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          // Use '|' insdead of '+' to make sure that result is signed
          hold |= input[next++] << bits;
          bits += 8;
        }
        //===//
        _out -= left;
        strm.total_out += _out;
        state.total += _out;
        if (_out) {
          strm.adler = state.check =
              /*UPDATE(state.check, put - _out, _out);*/
              (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

        }
        _out = left;
        // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
        if ((state.flags ? hold : zswap32(hold)) !== state.check) {
          strm.msg = 'incorrect data check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   check matches trailer\n"));
      }
      state.mode = LENGTH;
      /* falls through */
    case LENGTH:
      if (state.wrap && state.flags) {
        //=== NEEDBITS(32);
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (hold !== (state.total & 0xffffffff)) {
          strm.msg = 'incorrect length check';
          state.mode = BAD;
          break;
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        //Tracev((stderr, "inflate:   length matches trailer\n"));
      }
      state.mode = DONE;
      /* falls through */
    case DONE:
      ret = Z_STREAM_END;
      break inf_leave;
    case BAD:
      ret = Z_DATA_ERROR;
      break inf_leave;
    case MEM:
      return Z_MEM_ERROR;
    case SYNC:
      /* falls through */
    default:
      return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/

},{"../utils/common":77,"./adler32":79,"./crc32":81,"./inffast":84,"./inftrees":86}],86:[function(require,module,exports){
'use strict';


var utils = require('../utils/common');

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  var i = 0;
  /* process all codes and make table entries */
  for (;;) {
    i++;
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};

},{"../utils/common":77}],87:[function(require,module,exports){
'use strict';

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

},{}],88:[function(require,module,exports){
'use strict';


var utils = require('../utils/common');

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defailts,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;

},{"../utils/common":77}],89:[function(require,module,exports){
'use strict';


function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;

},{}],90:[function(require,module,exports){
(function (process){
'use strict';

if (!process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = nextTick;
} else {
  module.exports = process.nextTick;
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}

}).call(this,require('_process'))
},{"_process":91}],91:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],92:[function(require,module,exports){
module.exports = require("./lib/_stream_duplex.js")

},{"./lib/_stream_duplex.js":93}],93:[function(require,module,exports){
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

'use strict';

/*<replacement>*/

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var processNextTick = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

var Readable = require('./_stream_readable');
var Writable = require('./_stream_writable');

util.inherits(Duplex, Readable);

var keys = objectKeys(Writable.prototype);
for (var v = 0; v < keys.length; v++) {
  var method = keys[v];
  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  processNextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}
},{"./_stream_readable":95,"./_stream_writable":97,"core-util-is":26,"inherits":35,"process-nextick-args":90}],94:[function(require,module,exports){
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

'use strict';

module.exports = PassThrough;

var Transform = require('./_stream_transform');

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};
},{"./_stream_transform":96,"core-util-is":26,"inherits":35}],95:[function(require,module,exports){
(function (process){
'use strict';

module.exports = Readable;

/*<replacement>*/
var processNextTick = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var isArray = require('isarray');
/*</replacement>*/

/*<replacement>*/
var Buffer = require('buffer').Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = require('events');

/*<replacement>*/
var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = require('st' + 'ream');
  } catch (_) {} finally {
    if (!Stream) Stream = require('events').EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = require('buffer').Buffer;

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var debugUtil = require('util');
var debug = undefined;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var StringDecoder;

util.inherits(Readable, Stream);

var Duplex;
function ReadableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

var Duplex;
function Readable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options && typeof options.read === 'function') this._read = options.read;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;

  if (!state.objectMode && typeof chunk === 'string') {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      var skipAdd;
      if (state.decoder && !addToFront && !encoding) {
        chunk = state.decoder.write(chunk);
        skipAdd = !state.objectMode && chunk.length === 0;
      }

      if (!addToFront) state.reading = false;

      // Don't add to the buffer if we've decoded to an empty string chunk and
      // we're not in object mode
      if (!skipAdd) {
        // if we want the data now, just emit it.
        if (state.flowing && state.length === 0 && !state.sync) {
          stream.emit('data', chunk);
          stream.read(0);
        } else {
          // update the buffer info.
          state.length += state.objectMode ? 1 : chunk.length;
          if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

          if (state.needReadable) emitReadable(stream);
        }
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = require('string_decoder/').StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended) return 0;

  if (state.objectMode) return n === 0 ? 0 : 1;

  if (n === null || isNaN(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length) return state.buffer[0].length;else return state.length;
  }

  if (n <= 0) return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else {
      return state.length;
    }
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (typeof n !== 'number' || n > 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading) n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended) state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0) endReadable(this);

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    processNextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      if (state.pipesCount === 1 && state.pipes[0] === dest && src.listenerCount('data') === 1 && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error) dest.on('error', onerror);else if (isArray(dest._events.error)) dest._events.error.unshift(onerror);else dest._events.error = [onerror, dest._events.error];

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var _i = 0; _i < len; _i++) {
      dests[_i].emit('unpipe', this);
    }return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1) return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && !this._readableState.endEmitted) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        processNextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    processNextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function (ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0) return null;

  if (length === 0) ret = null;else if (objectMode) ret = list.shift();else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode) ret = list.join('');else if (list.length === 1) ret = list[0];else ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode) ret = '';else ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode) ret += buf.slice(0, cpy);else buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length) list[0] = buf.slice(cpy);else list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    processNextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function forEach(xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
}).call(this,require('_process'))
},{"./_stream_duplex":93,"_process":91,"buffer":4,"core-util-is":26,"events":32,"inherits":35,"isarray":37,"process-nextick-args":90,"string_decoder/":103,"util":3}],96:[function(require,module,exports){
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

'use strict';

module.exports = Transform;

var Duplex = require('./_stream_duplex');

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

util.inherits(Transform, Duplex);

function TransformState(stream) {
  this.afterTransform = function (er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
  this.writeencoding = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (data !== null && data !== undefined) stream.push(data);

  cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  this.once('prefinish', function () {
    if (typeof this._flush === 'function') this._flush(function (er) {
      done(stream, er);
    });else done(stream);
  });
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

function done(stream, er) {
  if (er) return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length) throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming) throw new Error('calling transform done when still transforming');

  return stream.push(null);
}
},{"./_stream_duplex":93,"core-util-is":26,"inherits":35}],97:[function(require,module,exports){
(function (process){
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

'use strict';

module.exports = Writable;

/*<replacement>*/
var processNextTick = require('process-nextick-args');
/*</replacement>*/

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
/*</replacement>*/

/*<replacement>*/
var Buffer = require('buffer').Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = require('core-util-is');
util.inherits = require('inherits');
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: require('util-deprecate')
};
/*</replacement>*/

/*<replacement>*/
var Stream;
(function () {
  try {
    Stream = require('st' + 'ream');
  } catch (_) {} finally {
    if (!Stream) Stream = require('events').EventEmitter;
  }
})();
/*</replacement>*/

var Buffer = require('buffer').Buffer;

util.inherits(Writable, Stream);

function nop() {}

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

var Duplex;
function WritableState(options, stream) {
  Duplex = Duplex || require('./_stream_duplex');

  options = options || {};

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~ ~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // create the two objects needed to store the corked requests
  // they are not a linked list, as no new elements are inserted in there
  this.corkedRequestsFree = new CorkedRequest(this);
  this.corkedRequestsFree.next = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function writableStateGetBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.')
    });
  } catch (_) {}
})();

var Duplex;
function Writable(options) {
  Duplex = Duplex || require('./_stream_duplex');

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex)) return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  processNextTick(cb, er);
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;

  if (!Buffer.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    processNextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);

  if (Buffer.isBuffer(chunk)) encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = new WriteReq(chunk, encoding, cb);
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;
  if (sync) processNextTick(cb, er);else cb(er);

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
        afterWrite(stream, state, finished, cb);
      }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    while (entry) {
      buffer[count] = entry;
      entry = entry.next;
      count += 1;
    }

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    state.corkedRequestsFree = holder.next;
    holder.next = null;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequestCount = 0;
  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else {
      prefinish(stream, state);
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;

  this.finish = function (err) {
    var entry = _this.entry;
    _this.entry = null;
    while (entry) {
      var cb = entry.callback;
      state.pendingcb--;
      cb(err);
      entry = entry.next;
    }
    if (state.corkedRequestsFree) {
      state.corkedRequestsFree.next = _this;
    } else {
      state.corkedRequestsFree = _this;
    }
  };
}
}).call(this,require('_process'))
},{"./_stream_duplex":93,"_process":91,"buffer":4,"core-util-is":26,"events":32,"inherits":35,"process-nextick-args":90,"util-deprecate":104}],98:[function(require,module,exports){
module.exports = require("./lib/_stream_passthrough.js")

},{"./lib/_stream_passthrough.js":94}],99:[function(require,module,exports){
var Stream = (function (){
  try {
    return require('st' + 'ream'); // hack to fix a circular dependency issue when used with browserify
  } catch(_){}
}());
exports = module.exports = require('./lib/_stream_readable.js');
exports.Stream = Stream || exports;
exports.Readable = exports;
exports.Writable = require('./lib/_stream_writable.js');
exports.Duplex = require('./lib/_stream_duplex.js');
exports.Transform = require('./lib/_stream_transform.js');
exports.PassThrough = require('./lib/_stream_passthrough.js');

},{"./lib/_stream_duplex.js":93,"./lib/_stream_passthrough.js":94,"./lib/_stream_readable.js":95,"./lib/_stream_transform.js":96,"./lib/_stream_writable.js":97}],100:[function(require,module,exports){
module.exports = require("./lib/_stream_transform.js")

},{"./lib/_stream_transform.js":96}],101:[function(require,module,exports){
module.exports = require("./lib/_stream_writable.js")

},{"./lib/_stream_writable.js":97}],102:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = require('events').EventEmitter;
var inherits = require('inherits');

inherits(Stream, EE);
Stream.Readable = require('readable-stream/readable.js');
Stream.Writable = require('readable-stream/writable.js');
Stream.Duplex = require('readable-stream/duplex.js');
Stream.Transform = require('readable-stream/transform.js');
Stream.PassThrough = require('readable-stream/passthrough.js');

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};

},{"events":32,"inherits":35,"readable-stream/duplex.js":92,"readable-stream/passthrough.js":98,"readable-stream/readable.js":99,"readable-stream/transform.js":100,"readable-stream/writable.js":101}],103:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var Buffer = require('buffer').Buffer;

var isBufferEncoding = Buffer.isEncoding
  || function(encoding) {
       switch (encoding && encoding.toLowerCase()) {
         case 'hex': case 'utf8': case 'utf-8': case 'ascii': case 'binary': case 'base64': case 'ucs2': case 'ucs-2': case 'utf16le': case 'utf-16le': case 'raw': return true;
         default: return false;
       }
     }


function assertEncoding(encoding) {
  if (encoding && !isBufferEncoding(encoding)) {
    throw new Error('Unknown encoding: ' + encoding);
  }
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters. CESU-8 is handled as part of the UTF-8 encoding.
//
// @TODO Handling all encodings inside a single object makes it very difficult
// to reason about this code, so it should be split up in the future.
// @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
// points as used by CESU-8.
var StringDecoder = exports.StringDecoder = function(encoding) {
  this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
  assertEncoding(encoding);
  switch (this.encoding) {
    case 'utf8':
      // CESU-8 represents each of Surrogate Pair by 3-bytes
      this.surrogateSize = 3;
      break;
    case 'ucs2':
    case 'utf16le':
      // UTF-16 represents each of Surrogate Pair by 2-bytes
      this.surrogateSize = 2;
      this.detectIncompleteChar = utf16DetectIncompleteChar;
      break;
    case 'base64':
      // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
      this.surrogateSize = 3;
      this.detectIncompleteChar = base64DetectIncompleteChar;
      break;
    default:
      this.write = passThroughWrite;
      return;
  }

  // Enough space to store all bytes of a single character. UTF-8 needs 4
  // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
  this.charBuffer = new Buffer(6);
  // Number of bytes received for the current incomplete multi-byte character.
  this.charReceived = 0;
  // Number of bytes expected for the current incomplete multi-byte character.
  this.charLength = 0;
};


// write decodes the given buffer and returns it as JS string that is
// guaranteed to not contain any partial multi-byte characters. Any partial
// character found at the end of the buffer is buffered up, and will be
// returned when calling write again with the remaining bytes.
//
// Note: Converting a Buffer containing an orphan surrogate to a String
// currently works, but converting a String to a Buffer (via `new Buffer`, or
// Buffer#write) will replace incomplete surrogates with the unicode
// replacement character. See https://codereview.chromium.org/121173009/ .
StringDecoder.prototype.write = function(buffer) {
  var charStr = '';
  // if our last write ended with an incomplete multibyte character
  while (this.charLength) {
    // determine how many remaining bytes this buffer has to offer for this char
    var available = (buffer.length >= this.charLength - this.charReceived) ?
        this.charLength - this.charReceived :
        buffer.length;

    // add the new bytes to the char buffer
    buffer.copy(this.charBuffer, this.charReceived, 0, available);
    this.charReceived += available;

    if (this.charReceived < this.charLength) {
      // still not enough chars in this buffer? wait for more ...
      return '';
    }

    // remove bytes belonging to the current character from the buffer
    buffer = buffer.slice(available, buffer.length);

    // get the character that was split
    charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding);

    // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
    var charCode = charStr.charCodeAt(charStr.length - 1);
    if (charCode >= 0xD800 && charCode <= 0xDBFF) {
      this.charLength += this.surrogateSize;
      charStr = '';
      continue;
    }
    this.charReceived = this.charLength = 0;

    // if there are no more bytes in this buffer, just emit our char
    if (buffer.length === 0) {
      return charStr;
    }
    break;
  }

  // determine and set charLength / charReceived
  this.detectIncompleteChar(buffer);

  var end = buffer.length;
  if (this.charLength) {
    // buffer the incomplete character bytes we got
    buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
    end -= this.charReceived;
  }

  charStr += buffer.toString(this.encoding, 0, end);

  var end = charStr.length - 1;
  var charCode = charStr.charCodeAt(end);
  // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
  if (charCode >= 0xD800 && charCode <= 0xDBFF) {
    var size = this.surrogateSize;
    this.charLength += size;
    this.charReceived += size;
    this.charBuffer.copy(this.charBuffer, size, 0, size);
    buffer.copy(this.charBuffer, 0, 0, size);
    return charStr.substring(0, end);
  }

  // or just emit the charStr
  return charStr;
};

// detectIncompleteChar determines if there is an incomplete UTF-8 character at
// the end of the given buffer. If so, it sets this.charLength to the byte
// length that character, and sets this.charReceived to the number of bytes
// that are available for this character.
StringDecoder.prototype.detectIncompleteChar = function(buffer) {
  // determine how many bytes we have to check at the end of this buffer
  var i = (buffer.length >= 3) ? 3 : buffer.length;

  // Figure out if one of the last i bytes of our buffer announces an
  // incomplete char.
  for (; i > 0; i--) {
    var c = buffer[buffer.length - i];

    // See http://en.wikipedia.org/wiki/UTF-8#Description

    // 110XXXXX
    if (i == 1 && c >> 5 == 0x06) {
      this.charLength = 2;
      break;
    }

    // 1110XXXX
    if (i <= 2 && c >> 4 == 0x0E) {
      this.charLength = 3;
      break;
    }

    // 11110XXX
    if (i <= 3 && c >> 3 == 0x1E) {
      this.charLength = 4;
      break;
    }
  }
  this.charReceived = i;
};

StringDecoder.prototype.end = function(buffer) {
  var res = '';
  if (buffer && buffer.length)
    res = this.write(buffer);

  if (this.charReceived) {
    var cr = this.charReceived;
    var buf = this.charBuffer;
    var enc = this.encoding;
    res += buf.slice(0, cr).toString(enc);
  }

  return res;
};

function passThroughWrite(buffer) {
  return buffer.toString(this.encoding);
}

function utf16DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 2;
  this.charLength = this.charReceived ? 2 : 0;
}

function base64DetectIncompleteChar(buffer) {
  this.charReceived = buffer.length % 3;
  this.charLength = this.charReceived ? 3 : 0;
}

},{"buffer":4}],104:[function(require,module,exports){
(function (global){

/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],105:[function(require,module,exports){
arguments[4][35][0].apply(exports,arguments)
},{"dup":35}],106:[function(require,module,exports){
module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}
},{}],107:[function(require,module,exports){
(function (process,global){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = require('./support/isBuffer');

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = require('inherits');

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./support/isBuffer":106,"_process":91,"inherits":105}],108:[function(require,module,exports){
var zip = require('./zip');

module.exports = function(gj, options) {
    zip(gj, options).then(function (base64) {
        location.href="data:application/zip;base64," + base64;
    });
};

},{"./zip":117}],109:[function(require,module,exports){
module.exports.enlarge = function enlargeExtent(extent, pt) {
    if (pt[0] < extent.xmin) extent.xmin = pt[0];
    if (pt[0] > extent.xmax) extent.xmax = pt[0];
    if (pt[1] < extent.ymin) extent.ymin = pt[1];
    if (pt[1] > extent.ymax) extent.ymax = pt[1];
    return extent;
};

module.exports.enlargeExtent = function enlargeExtent(extent, ext) {
    if (ext.xmax > extent.xmax) extent.xmax = ext.xmax;
    if (ext.xmin < extent.xmin) extent.xmin = ext.xmin;
    if (ext.ymax > extent.ymax) extent.ymax = ext.ymax;
    if (ext.ymin < extent.ymin) extent.ymin = ext.ymin;
    return extent;
};

module.exports.blank = function() {
    return {
        xmin: Number.MAX_VALUE,
        ymin: Number.MAX_VALUE,
        xmax: -Number.MAX_VALUE,
        ymax: -Number.MAX_VALUE
    };
};

},{}],110:[function(require,module,exports){
var types = require('./types').jstypes;

module.exports.geojson = geojson;
module.exports.obj = obj;

function geojson(features) {
    var fields = {};
    features.forEach(collect);
    function collect(f) { inherit(fields, f.properties); }
    return obj(fields);
}

function inherit(a, b) {
    for (var i in b) { a[i] = b[i]; }
    return a;
}

function obj(_) {
    var fields = {}, o = [];
    for (var p in _) fields[p] = typeof _[p];
    for (var n in fields) {
        o.push({
            name: n,
            type: types[fields[n]]
        });
    }
    return o;
}

},{"./types":115}],111:[function(require,module,exports){
module.exports.point = justType('Point', 'POINT');
module.exports.line = justType('LineString', 'POLYLINE');
module.exports.polygon = justType('Polygon', 'POLYGON');

// Points come as single points, no multipart
// Lines come as single lines, so we emulate multipart adding [ ] to returned coordinates
// Polygons already come as multipart

function justType(type, TYPE) {
    return function(gj) {
        var oftype = gj.features.filter(isType(type));
        var g = [];
        if (oftype.length > 0)
            g = oftype.map(justCoords);
        var f = [];
        if (oftype.length > 0)
            f = oftype.map(justProps);
        return {
            geometries: g,
            properties: f,
            type: TYPE
        };
    };
}

function justCoords(t) {
    if (t.geometry.type === 'LineString')
        return [t.geometry.coordinates];
    return t.geometry.coordinates;
}

function justProps(t) {
    return t.properties;
}

function isType(t) {
    return function(f) { return f.geometry.type === t; };
}

},{}],112:[function(require,module,exports){
var ext = require('./extent');

module.exports.write = function writePoints(coordinates, extent, shpView, shxView, _, options) {

    var contentLength = options.saveZs? 44: 28, // 8 header, 20 content
        fileLength = 100,
        shpI = 0,
        shxI = 0;

    coordinates.forEach(function writePoint(coords, i) {
        // HEADER
        // 4 record number
        // 4 content length in 16-bit words (20/2)
        shpView.setInt32(shpI, i);
        shpView.setInt32(shpI + 4, (contentLength - 8)/2);

        // record
        // (8 + 8) + 4 = 20 content length
        shpView.setInt32(shpI + 8, options.saveZs? 11: 1, true); // POINT=1, POINTZ = 11
        shpView.setFloat64(shpI + 12, coords[0], true); // X
        shpView.setFloat64(shpI + 20, coords[1], true); // Y
        if (options.saveZs) {
            shpView.setFloat64(shpI + 28, coords[2], true); // Z
            shpView.setFloat64(shpI + 36, -1.1e-38, true); // M
        }

        // index
        shxView.setInt32(shxI, fileLength / 2); // length in 16-bit words
        shxView.setInt32(shxI + 4, (contentLength - 8)/2);

        shxI += 8;
        shpI += contentLength;
        fileLength += contentLength;
    });
};

module.exports.extent = function(coordinates) {
    return coordinates.reduce(function(extent, coords) {
        return ext.enlarge(extent, coords);
    }, ext.blank());
};

module.exports.parts = function parts(geometries, TYPE) {
    return geometries.length;
};

module.exports.shxLength = function(coordinates) {
    return coordinates.length * 8;
};

module.exports.shpLength = function(coordinates, saveZs) {
    return coordinates.length * (saveZs? 44: 28);
};

},{"./extent":109}],113:[function(require,module,exports){
var ext = require('./extent'),
    types = require('./types');

module.exports.write = function writePoints(geometries, extent, shpView, shxView, TYPE, options) {

    var shpI = 0,
        shxI = 0,
        shxOffset = 100;

    geometries.forEach(writePolyLine);

    function writePolyLine(coordinates, i) {

        var flattened = justCoords(coordinates),
            noParts = parts([coordinates], TYPE),
            contentLength = (flattened.length * 16) + 48 + (noParts - 1) * 4; // does not include Z info

        var featureExtent = flattened.reduce(function(extent, c) {
            return ext.enlarge(extent, c);
        }, ext.blank());

        // INDEX
        var recordLength = (contentLength/2) + (options.saveZs? (8 + 4 * flattened.length): 0);
        shxView.setInt32(shxI, shxOffset / 2); // offset
        shxView.setInt32(shxI + 4, recordLength); // offset length

        shxI += 8;
        shxOffset += contentLength + 8;

        shpView.setInt32(shpI, i + 1); // record number
        shpView.setInt32(shpI + 4, recordLength); // length
        shpView.setInt32(shpI + 8, options.saveZs? TYPE + 10: TYPE, true); // POLYLINE/POLYGON or POLYLINEZ/POLYGONZ
        shpView.setFloat64(shpI + 12, featureExtent.xmin, true); // EXTENT
        shpView.setFloat64(shpI + 20, featureExtent.ymin, true);
        shpView.setFloat64(shpI + 28, featureExtent.xmax, true);
        shpView.setFloat64(shpI + 36, featureExtent.ymax, true);
        shpView.setInt32(shpI + 44, noParts, true);
        shpView.setInt32(shpI + 48, flattened.length, true); // POINTS
        shpView.setInt32(shpI + 52, 0, true); // The first part - index zero

        var onlyParts = coordinates.reduce(function (arr, coords) {
            if (Array.isArray(coords[0][0])) {
                arr = arr.concat(coords);
            } else {
                arr.push(coords);
            }
            return arr;
        }, []);
        for (var p = 1; p < noParts; p++) {
            shpView.setInt32( // set part index
                shpI + 52 + (p * 4),
                onlyParts.reduce(function (a, b, idx) {
                    return idx < p ? a + b.length : a;
                }, 0),
                true
            );
        }

        flattened.forEach(function writeLine(coords, i) {
            shpView.setFloat64(shpI + 56 + (i * 16) + (noParts - 1) * 4, coords[0], true); // X
            shpView.setFloat64(shpI + 56 + (i * 16) + (noParts - 1) * 4 + 8, coords[1], true); // Y
        });

        shpI += contentLength + 8;

        if (!options.saveZs)
            return;

        // calculate Z extent
        var minZ = Number.MAX_VALUE;
        var maxZ = -Number.MAX_VALUE;
        flattened.forEach(function getZ(coords) {
            minZ = (coords[2] < minZ)? coords[2]: minZ;
            maxZ = (coords[2] > maxZ)? coords[2]: maxZ;
        });
        shpView.setFloat64(shpI + 0, minZ, true);
        shpView.setFloat64(shpI + 8, maxZ, true);
        flattened.forEach(function writeZ(coords, i) {
            shpView.setFloat64(shpI + 16 + i*8, coords[2], true);
        });

        shpI += (16 + 8 * flattened.length);
        shxOffset += (16 + 8 * flattened.length);
    }
};

module.exports.shpLength = function(geometries, saveZs) {
    var numGeoms = geometries.length;
    var numPts = justCoords(geometries).length;
    var size = (56 * numGeoms) + (16 * numPts) + (saveZs? (16 * numGeoms + 8 * numPts): 0);
    return size;
};

module.exports.shxLength = function(geometries) {
    return geometries.length * 8;
};

module.exports.extent = function(coordinates) {
    return justCoords(coordinates).reduce(function(extent, c) {
        return ext.enlarge(extent, c);
    }, ext.blank());
};

function parts(geometries, TYPE) {
    var no = 1;
    if (TYPE === types.geometries.POLYGON || TYPE === types.geometries.POLYLINE)  {
        no = geometries.reduce(function (no, coords) {
            no += coords.length;
            if (Array.isArray(coords[0][0][0])) { // multi
                no += coords.reduce(function (no, rings) {
                    return no + rings.length - 1; // minus outer
                }, 0);
            }
            return no;
        }, 0);
    }
    return no;
}

module.exports.parts = parts;

function totalPoints(geometries) {
    var sum = 0;
    geometries.forEach(function(g) { sum += g.length; });
    return sum;
}

function justCoords(coords, l) {
    if (l === undefined) l = [];
    if (typeof coords[0][0] == 'object') {
        return coords.reduce(function(memo, c) {
            return memo.concat(justCoords(c));
        }, l);
    } else {
        return coords;
    }
}


},{"./extent":109,"./types":115}],114:[function(require,module,exports){
module.exports = 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137,298.257223563]],PRIMEM["Greenwich",0],UNIT["Degree",0.017453292519943295]]';

},{}],115:[function(require,module,exports){
module.exports.geometries = {
    NULL: 0,
    POINT: 1,
    POLYLINE: 3,
    POLYGON: 5,
    MULTIPOINT: 8,
    POINTZ: 11,
    POLYLINEZ: 13,
    POLYGONZ: 15,
    MULTIPOINTZ: 18,
    POINTM: 21,
    POLYLINEM: 23,
    POLYGONM: 25,
    MULTIPOINTM: 28,
    MULTIPATCH: 31,
};

},{}],116:[function(require,module,exports){
var types = require('./types'),
    dbf = require('dbf'),
    prj = require('./prj'),
    ext = require('./extent'),
    getFields = require('./fields'),
    assert = require('assert'),
    pointWriter = require('./points'),
    polyWriter = require('./poly');

var writers = {
    1: pointWriter,
    5: polyWriter,
    3: polyWriter
};

var recordHeaderLength = 8;

module.exports = write;

// Low-level writing interface
function write(rows, geometry_type, geometries, callback, options) {

    var TYPE = types.geometries[geometry_type],
        writer = writers[TYPE],
        parts = writer.parts(geometries, TYPE),
        shpLength = 100 + (parts - geometries.length) * 4 + writer.shpLength(geometries, options.saveZs),
        shxLength = 100 + writer.shxLength(geometries),
        shpBuffer = new ArrayBuffer(shpLength),
        shpView = new DataView(shpBuffer),
        shxBuffer = new ArrayBuffer(shxLength),
        shxView = new DataView(shxBuffer),
        extent = writer.extent(geometries);

    writeHeader(shpView, options.saveZs? TYPE + 10: TYPE);
    writeHeader(shxView, options.saveZs? TYPE + 10: TYPE);
    writeExtent(extent, shpView);
    writeExtent(extent, shxView);

    writer.write(geometries, extent,
        new DataView(shpBuffer, 100),
        new DataView(shxBuffer, 100),
        TYPE, options);

    shpView.setInt32(24, shpLength / 2);
    shxView.setInt32(24, (50 + geometries.length * 4));

    var dbfBuf = dbf.structure(rows);

    callback(null, {
        shp: shpView,
        shx: shxView,
        dbf: dbfBuf,
        prj: prj
    });
}

function writeHeader(view, TYPE) {
    view.setInt32(0, 9994);
    view.setInt32(28, 1000, true);
    view.setInt32(32, TYPE, true);
}

function writeExtent(extent, view) {
    view.setFloat64(36, extent.xmin, true);
    view.setFloat64(44, extent.ymin, true);
    view.setFloat64(52, extent.xmax, true);
    view.setFloat64(60, extent.ymax, true);
}

},{"./extent":109,"./fields":110,"./points":112,"./poly":113,"./prj":114,"./types":115,"assert":1,"dbf":27}],117:[function(require,module,exports){
(function (process){
var write = require('./write'),
    geojson = require('./geojson'),
    prj = require('./prj'),
    JSZip = require('jszip');

module.exports = function(gj, options) {

    var zip = new JSZip(),
        layers = zip.folder(options && options.folder ? options.folder : 'layers');

    [geojson.point(gj), geojson.line(gj), geojson.polygon(gj)]
        .forEach(function(l) {
        if (l.geometries.length && l.geometries[0].length) {
            write(
                // field definitions
                l.properties,
                // geometry type
                l.type,
                // geometries
                l.geometries,
                function(err, files) {
                    var fileName = options && options.types[l.type.toLowerCase()] ? options.types[l.type.toLowerCase()] : l.type;
                    layers.file(fileName + '.shp', files.shp.buffer, { binary: true });
                    layers.file(fileName + '.shx', files.shx.buffer, { binary: true });
                    layers.file(fileName + '.dbf', files.dbf.buffer, { binary: true });
                    if (options.wktCRS !== undefined && options.wktCRS !== '')
                        layers.file(fileName + '.prj', options.wktCRS);
                    else
                        layers.file(fileName + '.prj', prj);
                },
                options);
        }
    });

    var generateOptions = { compression:'STORE' };

    if (process.browser && !options.binaryZip) {
      generateOptions.type = 'base64';
    }
    else {
      generateOptions.type = 'nodebuffer';
    }

    return zip.generateAsync(generateOptions);
};

}).call(this,require('_process'))
},{"./geojson":111,"./prj":114,"./write":116,"_process":91,"jszip":47}],118:[function(require,module,exports){
module.exports.download = require('./src/download')
module.exports.write = require('./src/write')
module.exports.zip = require('./src/zip')

},{"./src/download":108,"./src/write":116,"./src/zip":117}]},{},[118])(118)
});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node_modules/webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../node_modules/node-libs-browser/node_modules/timers-browserify/main.js */ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./node_modules/assert/assert.js":
/*!***************************************!*\
  !*** ./node_modules/assert/assert.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:

/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
function compare(a, b) {
  if (a === b) {
    return 0;
  }

  var x = a.length;
  var y = b.length;

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i];
      y = b[i];
      break;
    }
  }

  if (x < y) {
    return -1;
  }
  if (y < x) {
    return 1;
  }
  return 0;
}
function isBuffer(b) {
  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
    return global.Buffer.isBuffer(b);
  }
  return !!(b != null && b._isBuffer);
}

// based on node assert, original notice:

// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
//
// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
//
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var util = __webpack_require__(/*! util/ */ "./node_modules/node-libs-browser/node_modules/util/util.js");
var hasOwn = Object.prototype.hasOwnProperty;
var pSlice = Array.prototype.slice;
var functionsHaveNames = (function () {
  return function foo() {}.name === 'foo';
}());
function pToString (obj) {
  return Object.prototype.toString.call(obj);
}
function isView(arrbuf) {
  if (isBuffer(arrbuf)) {
    return false;
  }
  if (typeof global.ArrayBuffer !== 'function') {
    return false;
  }
  if (typeof ArrayBuffer.isView === 'function') {
    return ArrayBuffer.isView(arrbuf);
  }
  if (!arrbuf) {
    return false;
  }
  if (arrbuf instanceof DataView) {
    return true;
  }
  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
    return true;
  }
  return false;
}
// 1. The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.

var assert = module.exports = ok;

// 2. The AssertionError is defined in assert.
// new assert.AssertionError({ message: message,
//                             actual: actual,
//                             expected: expected })

var regex = /\s*function\s+([^\(\s]*)\s*/;
// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
function getName(func) {
  if (!util.isFunction(func)) {
    return;
  }
  if (functionsHaveNames) {
    return func.name;
  }
  var str = func.toString();
  var match = str.match(regex);
  return match && match[1];
}
assert.AssertionError = function AssertionError(options) {
  this.name = 'AssertionError';
  this.actual = options.actual;
  this.expected = options.expected;
  this.operator = options.operator;
  if (options.message) {
    this.message = options.message;
    this.generatedMessage = false;
  } else {
    this.message = getMessage(this);
    this.generatedMessage = true;
  }
  var stackStartFunction = options.stackStartFunction || fail;
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, stackStartFunction);
  } else {
    // non v8 browsers so we can have a stacktrace
    var err = new Error();
    if (err.stack) {
      var out = err.stack;

      // try to strip useless frames
      var fn_name = getName(stackStartFunction);
      var idx = out.indexOf('\n' + fn_name);
      if (idx >= 0) {
        // once we have located the function frame
        // we need to strip out everything before it (and its line)
        var next_line = out.indexOf('\n', idx + 1);
        out = out.substring(next_line + 1);
      }

      this.stack = out;
    }
  }
};

// assert.AssertionError instanceof Error
util.inherits(assert.AssertionError, Error);

function truncate(s, n) {
  if (typeof s === 'string') {
    return s.length < n ? s : s.slice(0, n);
  } else {
    return s;
  }
}
function inspect(something) {
  if (functionsHaveNames || !util.isFunction(something)) {
    return util.inspect(something);
  }
  var rawname = getName(something);
  var name = rawname ? ': ' + rawname : '';
  return '[Function' +  name + ']';
}
function getMessage(self) {
  return truncate(inspect(self.actual), 128) + ' ' +
         self.operator + ' ' +
         truncate(inspect(self.expected), 128);
}

// At present only the three keys mentioned above are used and
// understood by the spec. Implementations or sub modules can pass
// other keys to the AssertionError's constructor - they will be
// ignored.

// 3. All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided.  All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.

function fail(actual, expected, message, operator, stackStartFunction) {
  throw new assert.AssertionError({
    message: message,
    actual: actual,
    expected: expected,
    operator: operator,
    stackStartFunction: stackStartFunction
  });
}

// EXTENSION! allows for well behaved errors defined elsewhere.
assert.fail = fail;

// 4. Pure assertion tests whether a value is truthy, as determined
// by !!guard.
// assert.ok(guard, message_opt);
// This statement is equivalent to assert.equal(true, !!guard,
// message_opt);. To test strictly for the value true, use
// assert.strictEqual(true, guard, message_opt);.

function ok(value, message) {
  if (!value) fail(value, true, message, '==', assert.ok);
}
assert.ok = ok;

// 5. The equality assertion tests shallow, coercive equality with
// ==.
// assert.equal(actual, expected, message_opt);

assert.equal = function equal(actual, expected, message) {
  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
};

// 6. The non-equality assertion tests for whether two objects are not equal
// with != assert.notEqual(actual, expected, message_opt);

assert.notEqual = function notEqual(actual, expected, message) {
  if (actual == expected) {
    fail(actual, expected, message, '!=', assert.notEqual);
  }
};

// 7. The equivalence assertion tests a deep equality relation.
// assert.deepEqual(actual, expected, message_opt);

assert.deepEqual = function deepEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
  }
};

assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
  if (!_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
  }
};

function _deepEqual(actual, expected, strict, memos) {
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;
  } else if (isBuffer(actual) && isBuffer(expected)) {
    return compare(actual, expected) === 0;

  // 7.2. If the expected value is a Date object, the actual value is
  // equivalent if it is also a Date object that refers to the same time.
  } else if (util.isDate(actual) && util.isDate(expected)) {
    return actual.getTime() === expected.getTime();

  // 7.3 If the expected value is a RegExp object, the actual value is
  // equivalent if it is also a RegExp object with the same source and
  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
    return actual.source === expected.source &&
           actual.global === expected.global &&
           actual.multiline === expected.multiline &&
           actual.lastIndex === expected.lastIndex &&
           actual.ignoreCase === expected.ignoreCase;

  // 7.4. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if ((actual === null || typeof actual !== 'object') &&
             (expected === null || typeof expected !== 'object')) {
    return strict ? actual === expected : actual == expected;

  // If both values are instances of typed arrays, wrap their underlying
  // ArrayBuffers in a Buffer each to increase performance
  // This optimization requires the arrays to have the same type as checked by
  // Object.prototype.toString (aka pToString). Never perform binary
  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
  // bit patterns are not identical.
  } else if (isView(actual) && isView(expected) &&
             pToString(actual) === pToString(expected) &&
             !(actual instanceof Float32Array ||
               actual instanceof Float64Array)) {
    return compare(new Uint8Array(actual.buffer),
                   new Uint8Array(expected.buffer)) === 0;

  // 7.5 For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else if (isBuffer(actual) !== isBuffer(expected)) {
    return false;
  } else {
    memos = memos || {actual: [], expected: []};

    var actualIndex = memos.actual.indexOf(actual);
    if (actualIndex !== -1) {
      if (actualIndex === memos.expected.indexOf(expected)) {
        return true;
      }
    }

    memos.actual.push(actual);
    memos.expected.push(expected);

    return objEquiv(actual, expected, strict, memos);
  }
}

function isArguments(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
}

function objEquiv(a, b, strict, actualVisitedObjects) {
  if (a === null || a === undefined || b === null || b === undefined)
    return false;
  // if one is a primitive, the other must be same
  if (util.isPrimitive(a) || util.isPrimitive(b))
    return a === b;
  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
    return false;
  var aIsArgs = isArguments(a);
  var bIsArgs = isArguments(b);
  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
    return false;
  if (aIsArgs) {
    a = pSlice.call(a);
    b = pSlice.call(b);
    return _deepEqual(a, b, strict);
  }
  var ka = objectKeys(a);
  var kb = objectKeys(b);
  var key, i;
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length !== kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] !== kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
      return false;
  }
  return true;
}

// 8. The non-equivalence assertion tests for any deep inequality.
// assert.notDeepEqual(actual, expected, message_opt);

assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, false)) {
    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
  }
};

assert.notDeepStrictEqual = notDeepStrictEqual;
function notDeepStrictEqual(actual, expected, message) {
  if (_deepEqual(actual, expected, true)) {
    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
  }
}


// 9. The strict equality assertion tests strict equality, as determined by ===.
// assert.strictEqual(actual, expected, message_opt);

assert.strictEqual = function strictEqual(actual, expected, message) {
  if (actual !== expected) {
    fail(actual, expected, message, '===', assert.strictEqual);
  }
};

// 10. The strict non-equality assertion tests for strict inequality, as
// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
  if (actual === expected) {
    fail(actual, expected, message, '!==', assert.notStrictEqual);
  }
};

function expectedException(actual, expected) {
  if (!actual || !expected) {
    return false;
  }

  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
    return expected.test(actual);
  }

  try {
    if (actual instanceof expected) {
      return true;
    }
  } catch (e) {
    // Ignore.  The instanceof check doesn't work for arrow functions.
  }

  if (Error.isPrototypeOf(expected)) {
    return false;
  }

  return expected.call({}, actual) === true;
}

function _tryBlock(block) {
  var error;
  try {
    block();
  } catch (e) {
    error = e;
  }
  return error;
}

function _throws(shouldThrow, block, expected, message) {
  var actual;

  if (typeof block !== 'function') {
    throw new TypeError('"block" argument must be a function');
  }

  if (typeof expected === 'string') {
    message = expected;
    expected = null;
  }

  actual = _tryBlock(block);

  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
            (message ? ' ' + message : '.');

  if (shouldThrow && !actual) {
    fail(actual, expected, 'Missing expected exception' + message);
  }

  var userProvidedMessage = typeof message === 'string';
  var isUnwantedException = !shouldThrow && util.isError(actual);
  var isUnexpectedException = !shouldThrow && actual && !expected;

  if ((isUnwantedException &&
      userProvidedMessage &&
      expectedException(actual, expected)) ||
      isUnexpectedException) {
    fail(actual, expected, 'Got unwanted exception' + message);
  }

  if ((shouldThrow && actual && expected &&
      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
    throw actual;
  }
}

// 11. Expected to throw an error:
// assert.throws(block, Error_opt, message_opt);

assert.throws = function(block, /*optional*/error, /*optional*/message) {
  _throws(true, block, error, message);
};

// EXTENSION! This is annoying to write outside this module.
assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
  _throws(false, block, error, message);
};

assert.ifError = function(err) { if (err) throw err; };

var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    if (hasOwn.call(obj, key)) keys.push(key);
  }
  return keys;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/base64-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/base64-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ "./node_modules/bezier-js/index.js":
/*!*****************************************!*\
  !*** ./node_modules/bezier-js/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/bezier */ "./node_modules/bezier-js/lib/bezier.js");


/***/ }),

/***/ "./node_modules/bezier-js/lib/bezier.js":
/*!**********************************************!*\
  !*** ./node_modules/bezier-js/lib/bezier.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/**
  A javascript Bezier curve library by Pomax.

  Based on http://pomax.github.io/bezierinfo

  This code is MIT licensed.
**/
(function() {
  "use strict";

  // math-inlining.
  var abs = Math.abs,
    min = Math.min,
    max = Math.max,
    cos = Math.cos,
    sin = Math.sin,
    acos = Math.acos,
    sqrt = Math.sqrt,
    pi = Math.PI,
    // a zero coordinate, which is surprisingly useful
    ZERO = { x: 0, y: 0, z: 0 };

  // quite needed
  var utils = __webpack_require__(/*! ./utils.js */ "./node_modules/bezier-js/lib/utils.js");

  // only used for outlines atm.
  var PolyBezier = __webpack_require__(/*! ./poly-bezier.js */ "./node_modules/bezier-js/lib/poly-bezier.js");

  /**
   * Bezier curve constructor. The constructor argument can be one of three things:
   *
   * 1. array/4 of {x:..., y:..., z:...}, z optional
   * 2. numerical array/8 ordered x1,y1,x2,y2,x3,y3,x4,y4
   * 3. numerical array/12 ordered x1,y1,z1,x2,y2,z2,x3,y3,z3,x4,y4,z4
   *
   */
  var Bezier = function(coords) {
    var args = coords && coords.forEach ? coords : [].slice.call(arguments);
    var coordlen = false;
    if (typeof args[0] === "object") {
      coordlen = args.length;
      var newargs = [];
      args.forEach(function(point) {
        ["x", "y", "z"].forEach(function(d) {
          if (typeof point[d] !== "undefined") {
            newargs.push(point[d]);
          }
        });
      });
      args = newargs;
    }
    var higher = false;
    var len = args.length;
    if (coordlen) {
      if (coordlen > 4) {
        if (arguments.length !== 1) {
          throw new Error(
            "Only new Bezier(point[]) is accepted for 4th and higher order curves"
          );
        }
        higher = true;
      }
    } else {
      if (len !== 6 && len !== 8 && len !== 9 && len !== 12) {
        if (arguments.length !== 1) {
          throw new Error(
            "Only new Bezier(point[]) is accepted for 4th and higher order curves"
          );
        }
      }
    }
    var _3d =
      (!higher && (len === 9 || len === 12)) ||
      (coords && coords[0] && typeof coords[0].z !== "undefined");
    this._3d = _3d;
    var points = [];
    for (var idx = 0, step = _3d ? 3 : 2; idx < len; idx += step) {
      var point = {
        x: args[idx],
        y: args[idx + 1]
      };
      if (_3d) {
        point.z = args[idx + 2];
      }
      points.push(point);
    }
    this.order = points.length - 1;
    this.points = points;
    var dims = ["x", "y"];
    if (_3d) dims.push("z");
    this.dims = dims;
    this.dimlen = dims.length;

    (function(curve) {
      var order = curve.order;
      var points = curve.points;
      var a = utils.align(points, { p1: points[0], p2: points[order] });
      for (var i = 0; i < a.length; i++) {
        if (abs(a[i].y) > 0.0001) {
          curve._linear = false;
          return;
        }
      }
      curve._linear = true;
    })(this);

    this._t1 = 0;
    this._t2 = 1;
    this.update();
  };

  var svgToBeziers = __webpack_require__(/*! ./svg-to-beziers */ "./node_modules/bezier-js/lib/svg-to-beziers.js");

  /**
   * turn an svg <path> d attribute into a sequence of Bezier segments.
   */
  Bezier.SVGtoBeziers = function(d) {
    return svgToBeziers(Bezier, d);
  };

  function getABC(n, S, B, E, t) {
    if (typeof t === "undefined") {
      t = 0.5;
    }
    var u = utils.projectionratio(t, n),
      um = 1 - u,
      C = {
        x: u * S.x + um * E.x,
        y: u * S.y + um * E.y
      },
      s = utils.abcratio(t, n),
      A = {
        x: B.x + (B.x - C.x) / s,
        y: B.y + (B.y - C.y) / s
      };
    return { A: A, B: B, C: C };
  }

  Bezier.quadraticFromPoints = function(p1, p2, p3, t) {
    if (typeof t === "undefined") {
      t = 0.5;
    }
    // shortcuts, although they're really dumb
    if (t === 0) {
      return new Bezier(p2, p2, p3);
    }
    if (t === 1) {
      return new Bezier(p1, p2, p2);
    }
    // real fitting.
    var abc = getABC(2, p1, p2, p3, t);
    return new Bezier(p1, abc.A, p3);
  };

  Bezier.cubicFromPoints = function(S, B, E, t, d1) {
    if (typeof t === "undefined") {
      t = 0.5;
    }
    var abc = getABC(3, S, B, E, t);
    if (typeof d1 === "undefined") {
      d1 = utils.dist(B, abc.C);
    }
    var d2 = d1 * (1 - t) / t;

    var selen = utils.dist(S, E),
      lx = (E.x - S.x) / selen,
      ly = (E.y - S.y) / selen,
      bx1 = d1 * lx,
      by1 = d1 * ly,
      bx2 = d2 * lx,
      by2 = d2 * ly;
    // derivation of new hull coordinates
    var e1 = { x: B.x - bx1, y: B.y - by1 },
      e2 = { x: B.x + bx2, y: B.y + by2 },
      A = abc.A,
      v1 = { x: A.x + (e1.x - A.x) / (1 - t), y: A.y + (e1.y - A.y) / (1 - t) },
      v2 = { x: A.x + (e2.x - A.x) / t, y: A.y + (e2.y - A.y) / t },
      nc1 = { x: S.x + (v1.x - S.x) / t, y: S.y + (v1.y - S.y) / t },
      nc2 = {
        x: E.x + (v2.x - E.x) / (1 - t),
        y: E.y + (v2.y - E.y) / (1 - t)
      };
    // ...done
    return new Bezier(S, nc1, nc2, E);
  };

  var getUtils = function() {
    return utils;
  };

  Bezier.getUtils = getUtils;

  Bezier.PolyBezier = PolyBezier;

  Bezier.prototype = {
    getUtils: getUtils,
    valueOf: function() {
      return this.toString();
    },
    toString: function() {
      return utils.pointsToString(this.points);
    },
    toSVG: function(relative) {
      if (this._3d) return false;
      var p = this.points,
        x = p[0].x,
        y = p[0].y,
        s = ["M", x, y, this.order === 2 ? "Q" : "C"];
      for (var i = 1, last = p.length; i < last; i++) {
        s.push(p[i].x);
        s.push(p[i].y);
      }
      return s.join(" ");
    },
    setRatios: function(ratios) {
      if (ratios.length !== this.points.length) {
        throw new Error("incorrect number of ratio values");
      }
      this.ratios = ratios;
      this._lut = []; //  invalidate any precomputed LUT
    },
    verify: function() {
      var print = this.coordDigest();
      if (print !== this._print) {
        this._print = print;
        this.update();
      }
    },
    coordDigest: function() {
      return this.points.map(function(c,pos) {
        return '' + pos + c.x + c.y + (c.z?c.z:0);
      }).join('');
    },
    update: function(newprint) {
      // invalidate any precomputed LUT
      this._lut = [];
      this.dpoints = utils.derive(this.points, this._3d);
      this.computedirection();
    },
    computedirection: function() {
      var points = this.points;
      var angle = utils.angle(points[0], points[this.order], points[1]);
      this.clockwise = angle > 0;
    },
    length: function() {
      return utils.length(this.derivative.bind(this));
    },
    _lut: [],
    getLUT: function(steps) {
      this.verify();
      steps = steps || 100;
      if (this._lut.length === steps) {
        return this._lut;
      }
      this._lut = [];
      // We want a range from 0 to 1 inclusive, so
      // we decrement and then use <= rather than <:
      steps--;
      for (var t = 0; t <= steps; t++) {
        this._lut.push(this.compute(t / steps));
      }
      return this._lut;
    },
    on: function(point, error) {
      error = error || 5;
      var lut = this.getLUT(),
        hits = [],
        c,
        t = 0;
      for (var i = 0; i < lut.length; i++) {
        c = lut[i];
        if (utils.dist(c, point) < error) {
          hits.push(c);
          t += i / lut.length;
        }
      }
      if (!hits.length) return false;
      return (t /= hits.length);
    },
    project: function(point) {
      // step 1: coarse check
      var LUT = this.getLUT(),
        l = LUT.length - 1,
        closest = utils.closest(LUT, point),
        mdist = closest.mdist,
        mpos = closest.mpos;

      // step 2: fine check
      var ft,
        t,
        p,
        d,
        t1 = (mpos - 1) / l,
        t2 = (mpos + 1) / l,
        step = 0.1 / l;
      mdist += 1;
      for (t = t1, ft = t; t < t2 + step; t += step) {
        p = this.compute(t);
        d = utils.dist(point, p);
        if (d < mdist) {
          mdist = d;
          ft = t;
        }
      }
      p = this.compute(ft);
      p.t = ft;
      p.d = mdist;
      return p;
    },
    get: function(t) {
      return this.compute(t);
    },
    point: function(idx) {
      return this.points[idx];
    },
    compute: function(t) {
      if (this.ratios) return utils.computeWithRatios(t, this.points, this.ratios, this._3d);
      return utils.compute(t, this.points, this._3d, this.ratios);
    },
    raise: function() {
      var p = this.points,
        np = [p[0]],
        i,
        k = p.length,
        pi,
        pim;
      for (var i = 1; i < k; i++) {
        pi = p[i];
        pim = p[i - 1];
        np[i] = {
          x: (k - i) / k * pi.x + i / k * pim.x,
          y: (k - i) / k * pi.y + i / k * pim.y
        };
      }
      np[k] = p[k - 1];
      return new Bezier(np);
    },
    derivative: function(t) {
      var mt = 1 - t,
        a,
        b,
        c = 0,
        p = this.dpoints[0];
      if (this.order === 2) {
        p = [p[0], p[1], ZERO];
        a = mt;
        b = t;
      }
      if (this.order === 3) {
        a = mt * mt;
        b = mt * t * 2;
        c = t * t;
      }
      var ret = {
        x: a * p[0].x + b * p[1].x + c * p[2].x,
        y: a * p[0].y + b * p[1].y + c * p[2].y
      };
      if (this._3d) {
        ret.z = a * p[0].z + b * p[1].z + c * p[2].z;
      }
      return ret;
    },
    curvature: function(t) {
      return utils.curvature(t, this.points, this._3d);
    },
    inflections: function() {
      return utils.inflections(this.points);
    },
    normal: function(t) {
      return this._3d ? this.__normal3(t) : this.__normal2(t);
    },
    __normal2: function(t) {
      var d = this.derivative(t);
      var q = sqrt(d.x * d.x + d.y * d.y);
      return { x: -d.y / q, y: d.x / q };
    },
    __normal3: function(t) {
      // see http://stackoverflow.com/questions/25453159
      var r1 = this.derivative(t),
        r2 = this.derivative(t + 0.01),
        q1 = sqrt(r1.x * r1.x + r1.y * r1.y + r1.z * r1.z),
        q2 = sqrt(r2.x * r2.x + r2.y * r2.y + r2.z * r2.z);
      r1.x /= q1;
      r1.y /= q1;
      r1.z /= q1;
      r2.x /= q2;
      r2.y /= q2;
      r2.z /= q2;
      // cross product
      var c = {
        x: r2.y * r1.z - r2.z * r1.y,
        y: r2.z * r1.x - r2.x * r1.z,
        z: r2.x * r1.y - r2.y * r1.x
      };
      var m = sqrt(c.x * c.x + c.y * c.y + c.z * c.z);
      c.x /= m;
      c.y /= m;
      c.z /= m;
      // rotation matrix
      var R = [
        c.x * c.x,
        c.x * c.y - c.z,
        c.x * c.z + c.y,
        c.x * c.y + c.z,
        c.y * c.y,
        c.y * c.z - c.x,
        c.x * c.z - c.y,
        c.y * c.z + c.x,
        c.z * c.z
      ];
      // normal vector:
      var n = {
        x: R[0] * r1.x + R[1] * r1.y + R[2] * r1.z,
        y: R[3] * r1.x + R[4] * r1.y + R[5] * r1.z,
        z: R[6] * r1.x + R[7] * r1.y + R[8] * r1.z
      };
      return n;
    },
    hull: function(t) {
      var p = this.points,
        _p = [],
        pt,
        q = [],
        idx = 0,
        i = 0,
        l = 0;
      q[idx++] = p[0];
      q[idx++] = p[1];
      q[idx++] = p[2];
      if (this.order === 3) {
        q[idx++] = p[3];
      }
      // we lerp between all points at each iteration, until we have 1 point left.
      while (p.length > 1) {
        _p = [];
        for (i = 0, l = p.length - 1; i < l; i++) {
          pt = utils.lerp(t, p[i], p[i + 1]);
          q[idx++] = pt;
          _p.push(pt);
        }
        p = _p;
      }
      return q;
    },
    split: function(t1, t2) {
      // shortcuts
      if (t1 === 0 && !!t2) {
        return this.split(t2).left;
      }
      if (t2 === 1) {
        return this.split(t1).right;
      }

      // no shortcut: use "de Casteljau" iteration.
      var q = this.hull(t1);
      var result = {
        left:
          this.order === 2
            ? new Bezier([q[0], q[3], q[5]])
            : new Bezier([q[0], q[4], q[7], q[9]]),
        right:
          this.order === 2
            ? new Bezier([q[5], q[4], q[2]])
            : new Bezier([q[9], q[8], q[6], q[3]]),
        span: q
      };

      // make sure we bind _t1/_t2 information!
      result.left._t1 = utils.map(0, 0, 1, this._t1, this._t2);
      result.left._t2 = utils.map(t1, 0, 1, this._t1, this._t2);
      result.right._t1 = utils.map(t1, 0, 1, this._t1, this._t2);
      result.right._t2 = utils.map(1, 0, 1, this._t1, this._t2);

      // if we have no t2, we're done
      if (!t2) {
        return result;
      }

      // if we have a t2, split again:
      t2 = utils.map(t2, t1, 1, 0, 1);
      var subsplit = result.right.split(t2);
      return subsplit.left;
    },
    extrema: function() {
      var dims = this.dims,
        result = {},
        roots = [],
        p,
        mfn;
      dims.forEach(
        function(dim) {
          mfn = function(v) {
            return v[dim];
          };
          p = this.dpoints[0].map(mfn);
          result[dim] = utils.droots(p);
          if (this.order === 3) {
            p = this.dpoints[1].map(mfn);
            result[dim] = result[dim].concat(utils.droots(p));
          }
          result[dim] = result[dim].filter(function(t) {
            return t >= 0 && t <= 1;
          });
          roots = roots.concat(result[dim].sort(utils.numberSort));
        }.bind(this)
      );
      roots = roots.sort(utils.numberSort).filter(function(v, idx) {
        return roots.indexOf(v) === idx;
      });
      result.values = roots;
      return result;
    },
    bbox: function() {
      var extrema = this.extrema(),
        result = {};
      this.dims.forEach(
        function(d) {
          result[d] = utils.getminmax(this, d, extrema[d]);
        }.bind(this)
      );
      return result;
    },
    overlaps: function(curve) {
      var lbbox = this.bbox(),
        tbbox = curve.bbox();
      return utils.bboxoverlap(lbbox, tbbox);
    },
    offset: function(t, d) {
      if (typeof d !== "undefined") {
        var c = this.get(t);
        var n = this.normal(t);
        var ret = {
          c: c,
          n: n,
          x: c.x + n.x * d,
          y: c.y + n.y * d
        };
        if (this._3d) {
          ret.z = c.z + n.z * d;
        }
        return ret;
      }
      if (this._linear) {
        var nv = this.normal(0);
        var coords = this.points.map(function(p) {
          var ret = {
            x: p.x + t * nv.x,
            y: p.y + t * nv.y
          };
          if (p.z && n.z) {
            ret.z = p.z + t * nv.z;
          }
          return ret;
        });
        return [new Bezier(coords)];
      }
      var reduced = this.reduce();
      return reduced.map(function(s) {
        if (s._linear) {
          return s.offset(t)[0];
        }
        return s.scale(t);
      });
    },
    simple: function() {
      if (this.order === 3) {
        var a1 = utils.angle(this.points[0], this.points[3], this.points[1]);
        var a2 = utils.angle(this.points[0], this.points[3], this.points[2]);
        if ((a1 > 0 && a2 < 0) || (a1 < 0 && a2 > 0)) return false;
      }
      var n1 = this.normal(0);
      var n2 = this.normal(1);
      var s = n1.x * n2.x + n1.y * n2.y;
      if (this._3d) {
        s += n1.z * n2.z;
      }
      var angle = abs(acos(s));
      return angle < pi / 3;
    },
    reduce: function() {
      var i,
        t1 = 0,
        t2 = 0,
        step = 0.01,
        segment,
        pass1 = [],
        pass2 = [];
      // first pass: split on extrema
      var extrema = this.extrema().values;
      if (extrema.indexOf(0) === -1) {
        extrema = [0].concat(extrema);
      }
      if (extrema.indexOf(1) === -1) {
        extrema.push(1);
      }

      for (t1 = extrema[0], i = 1; i < extrema.length; i++) {
        t2 = extrema[i];
        segment = this.split(t1, t2);
        segment._t1 = t1;
        segment._t2 = t2;
        pass1.push(segment);
        t1 = t2;
      }

      // second pass: further reduce these segments to simple segments
      pass1.forEach(function(p1) {
        t1 = 0;
        t2 = 0;
        while (t2 <= 1) {
          for (t2 = t1 + step; t2 <= 1 + step; t2 += step) {
            segment = p1.split(t1, t2);
            if (!segment.simple()) {
              t2 -= step;
              if (abs(t1 - t2) < step) {
                // we can never form a reduction
                return [];
              }
              segment = p1.split(t1, t2);
              segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
              segment._t2 = utils.map(t2, 0, 1, p1._t1, p1._t2);
              pass2.push(segment);
              t1 = t2;
              break;
            }
          }
        }
        if (t1 < 1) {
          segment = p1.split(t1, 1);
          segment._t1 = utils.map(t1, 0, 1, p1._t1, p1._t2);
          segment._t2 = p1._t2;
          pass2.push(segment);
        }
      });
      return pass2;
    },
    scale: function(d) {
      var order = this.order;
      var distanceFn = false;
      if (typeof d === "function") {
        distanceFn = d;
      }
      if (distanceFn && order === 2) {
        return this.raise().scale(distanceFn);
      }

      // TODO: add special handling for degenerate (=linear) curves.
      var clockwise = this.clockwise;
      var r1 = distanceFn ? distanceFn(0) : d;
      var r2 = distanceFn ? distanceFn(1) : d;
      var v = [this.offset(0, 10), this.offset(1, 10)];
      var o = utils.lli4(v[0], v[0].c, v[1], v[1].c);
      if (!o) {
        throw new Error("cannot scale this curve. Try reducing it first.");
      }
      // move all points by distance 'd' wrt the origin 'o'
      var points = this.points,
        np = [];

      // move end points by fixed distance along normal.
      [0, 1].forEach(
        function(t) {
          var p = (np[t * order] = utils.copy(points[t * order]));
          p.x += (t ? r2 : r1) * v[t].n.x;
          p.y += (t ? r2 : r1) * v[t].n.y;
        }.bind(this)
      );

      if (!distanceFn) {
        // move control points to lie on the intersection of the offset
        // derivative vector, and the origin-through-control vector
        [0, 1].forEach(
          function(t) {
            if (this.order === 2 && !!t) return;
            var p = np[t * order];
            var d = this.derivative(t);
            var p2 = { x: p.x + d.x, y: p.y + d.y };
            np[t + 1] = utils.lli4(p, p2, o, points[t + 1]);
          }.bind(this)
        );
        return new Bezier(np);
      }

      // move control points by "however much necessary to
      // ensure the correct tangent to endpoint".
      [0, 1].forEach(
        function(t) {
          if (this.order === 2 && !!t) return;
          var p = points[t + 1];
          var ov = {
            x: p.x - o.x,
            y: p.y - o.y
          };
          var rc = distanceFn ? distanceFn((t + 1) / order) : d;
          if (distanceFn && !clockwise) rc = -rc;
          var m = sqrt(ov.x * ov.x + ov.y * ov.y);
          ov.x /= m;
          ov.y /= m;
          np[t + 1] = {
            x: p.x + rc * ov.x,
            y: p.y + rc * ov.y
          };
        }.bind(this)
      );
      return new Bezier(np);
    },
    outline: function(d1, d2, d3, d4) {
      d2 = typeof d2 === "undefined" ? d1 : d2;
      var reduced = this.reduce(),
        len = reduced.length,
        fcurves = [],
        bcurves = [],
        p,
        alen = 0,
        tlen = this.length();

      var graduated = typeof d3 !== "undefined" && typeof d4 !== "undefined";

      function linearDistanceFunction(s, e, tlen, alen, slen) {
        return function(v) {
          var f1 = alen / tlen,
            f2 = (alen + slen) / tlen,
            d = e - s;
          return utils.map(v, 0, 1, s + f1 * d, s + f2 * d);
        };
      }

      // form curve oulines
      reduced.forEach(function(segment) {
        slen = segment.length();
        if (graduated) {
          fcurves.push(
            segment.scale(linearDistanceFunction(d1, d3, tlen, alen, slen))
          );
          bcurves.push(
            segment.scale(linearDistanceFunction(-d2, -d4, tlen, alen, slen))
          );
        } else {
          fcurves.push(segment.scale(d1));
          bcurves.push(segment.scale(-d2));
        }
        alen += slen;
      });

      // reverse the "return" outline
      bcurves = bcurves
        .map(function(s) {
          p = s.points;
          if (p[3]) {
            s.points = [p[3], p[2], p[1], p[0]];
          } else {
            s.points = [p[2], p[1], p[0]];
          }
          return s;
        })
        .reverse();

      // form the endcaps as lines
      var fs = fcurves[0].points[0],
        fe = fcurves[len - 1].points[fcurves[len - 1].points.length - 1],
        bs = bcurves[len - 1].points[bcurves[len - 1].points.length - 1],
        be = bcurves[0].points[0],
        ls = utils.makeline(bs, fs),
        le = utils.makeline(fe, be),
        segments = [ls]
          .concat(fcurves)
          .concat([le])
          .concat(bcurves),
        slen = segments.length;

      return new PolyBezier(segments);
    },
    outlineshapes: function(d1, d2, curveIntersectionThreshold) {
      d2 = d2 || d1;
      var outline = this.outline(d1, d2).curves;
      var shapes = [];
      for (var i = 1, len = outline.length; i < len / 2; i++) {
        var shape = utils.makeshape(
          outline[i],
          outline[len - i],
          curveIntersectionThreshold
        );
        shape.startcap.virtual = i > 1;
        shape.endcap.virtual = i < len / 2 - 1;
        shapes.push(shape);
      }
      return shapes;
    },
    intersects: function(curve, curveIntersectionThreshold) {
      if (!curve) return this.selfintersects(curveIntersectionThreshold);
      if (curve.p1 && curve.p2) {
        return this.lineIntersects(curve);
      }
      if (curve instanceof Bezier) {
        curve = curve.reduce();
      }
      return this.curveintersects(
        this.reduce(),
        curve,
        curveIntersectionThreshold
      );
    },
    lineIntersects: function(line) {
      var mx = min(line.p1.x, line.p2.x),
        my = min(line.p1.y, line.p2.y),
        MX = max(line.p1.x, line.p2.x),
        MY = max(line.p1.y, line.p2.y),
        self = this;
      return utils.roots(this.points, line).filter(function(t) {
        var p = self.get(t);
        return utils.between(p.x, mx, MX) && utils.between(p.y, my, MY);
      });
    },
    selfintersects: function(curveIntersectionThreshold) {
      var reduced = this.reduce();
      // "simple" curves cannot intersect with their direct
      // neighbour, so for each segment X we check whether
      // it intersects [0:x-2][x+2:last].
      var i,
        len = reduced.length - 2,
        results = [],
        result,
        left,
        right;
      for (i = 0; i < len; i++) {
        left = reduced.slice(i, i + 1);
        right = reduced.slice(i + 2);
        result = this.curveintersects(left, right, curveIntersectionThreshold);
        results = results.concat(result);
      }
      return results;
    },
    curveintersects: function(c1, c2, curveIntersectionThreshold) {
      var pairs = [];
      // step 1: pair off any overlapping segments
      c1.forEach(function(l) {
        c2.forEach(function(r) {
          if (l.overlaps(r)) {
            pairs.push({ left: l, right: r });
          }
        });
      });
      // step 2: for each pairing, run through the convergence algorithm.
      var intersections = [];
      pairs.forEach(function(pair) {
        var result = utils.pairiteration(
          pair.left,
          pair.right,
          curveIntersectionThreshold
        );
        if (result.length > 0) {
          intersections = intersections.concat(result);
        }
      });
      return intersections;
    },
    arcs: function(errorThreshold) {
      errorThreshold = errorThreshold || 0.5;
      var circles = [];
      return this._iterate(errorThreshold, circles);
    },
    _error: function(pc, np1, s, e) {
      var q = (e - s) / 4,
        c1 = this.get(s + q),
        c2 = this.get(e - q),
        ref = utils.dist(pc, np1),
        d1 = utils.dist(pc, c1),
        d2 = utils.dist(pc, c2);
      return abs(d1 - ref) + abs(d2 - ref);
    },
    _iterate: function(errorThreshold, circles) {
      var t_s = 0,
        t_e = 1,
        safety;
      // we do a binary search to find the "good `t` closest to no-longer-good"
      do {
        safety = 0;

        // step 1: start with the maximum possible arc
        t_e = 1;

        // points:
        var np1 = this.get(t_s),
          np2,
          np3,
          arc,
          prev_arc;

        // booleans:
        var curr_good = false,
          prev_good = false,
          done;

        // numbers:
        var t_m = t_e,
          prev_e = 1,
          step = 0;

        // step 2: find the best possible arc
        do {
          prev_good = curr_good;
          prev_arc = arc;
          t_m = (t_s + t_e) / 2;
          step++;

          np2 = this.get(t_m);
          np3 = this.get(t_e);

          arc = utils.getccenter(np1, np2, np3);

          //also save the t values
          arc.interval = {
            start: t_s,
            end: t_e
          };

          var error = this._error(arc, np1, t_s, t_e);
          curr_good = error <= errorThreshold;

          done = prev_good && !curr_good;
          if (!done) prev_e = t_e;

          // this arc is fine: we can move 'e' up to see if we can find a wider arc
          if (curr_good) {
            // if e is already at max, then we're done for this arc.
            if (t_e >= 1) {
              // make sure we cap at t=1
              arc.interval.end = prev_e = 1;
              prev_arc = arc;
              // if we capped the arc segment to t=1 we also need to make sure that
              // the arc's end angle is correct with respect to the bezier end point.
              if (t_e > 1) {
                var d = {
                  x: arc.x + arc.r * cos(arc.e),
                  y: arc.y + arc.r * sin(arc.e)
                };
                arc.e += utils.angle({ x: arc.x, y: arc.y }, d, this.get(1));
              }
              break;
            }
            // if not, move it up by half the iteration distance
            t_e = t_e + (t_e - t_s) / 2;
          } else {
            // this is a bad arc: we need to move 'e' down to find a good arc
            t_e = t_m;
          }
        } while (!done && safety++ < 100);

        if (safety >= 100) {
          break;
        }

        // console.log("L835: [F] arc found", t_s, prev_e, prev_arc.x, prev_arc.y, prev_arc.s, prev_arc.e);

        prev_arc = prev_arc ? prev_arc : arc;
        circles.push(prev_arc);
        t_s = prev_e;
      } while (t_e < 1);
      return circles;
    }
  };

  module.exports = Bezier;
})();


/***/ }),

/***/ "./node_modules/bezier-js/lib/normalise-svg.js":
/*!*****************************************************!*\
  !*** ./node_modules/bezier-js/lib/normalise-svg.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Normalise an SVG path to absolute coordinates
 * and full commands, rather than relative coordinates
 * and/or shortcut commands.
 */
function normalizePath(d) {
  // preprocess "d" so that we have spaces between values
  d = d
    .replace(/,/g, " ") // replace commas with spaces
    .replace(/-/g, " - ") // add spacing around minus signs
    .replace(/-\s+/g, "-") // remove spacing to the right of minus signs.
    .replace(/([a-zA-Z])/g, " $1 ");

  // set up the variables used in this function
  var instructions = d.replace(/([a-zA-Z])\s?/g, "|$1").split("|"),
    instructionLength = instructions.length,
    i,
    instruction,
    op,
    lop,
    args = [],
    alen,
    a,
    sx = 0,
    sy = 0,
    x = 0,
    y = 0,
    cx = 0,
    cy = 0,
    cx2 = 0,
    cy2 = 0,
    normalized = "";

  // we run through the instruction list starting at 1, not 0,
  // because we split up "|M x y ...." so the first element will
  // always be an empty string. By design.
  for (i = 1; i < instructionLength; i++) {
    // which instruction is this?
    instruction = instructions[i];
    op = instruction.substring(0, 1);
    lop = op.toLowerCase();

    // what are the arguments? note that we need to convert
    // all strings into numbers, or + will do silly things.
    args = instruction
      .replace(op, "")
      .trim()
      .split(" ");
    args = args
      .filter(function(v) {
        return v !== "";
      })
      .map(parseFloat);
    alen = args.length;

    // we could use a switch, but elaborate code in a "case" with
    // fallthrough is just horrid to read. So let's use ifthen
    // statements instead.

    // moveto command (plus possible lineto)
    if (lop === "m") {
      normalized += "M ";
      if (op === "m") {
        x += args[0];
        y += args[1];
      } else {
        x = args[0];
        y = args[1];
      }
      // records start position, for dealing
      // with the shape close operator ('Z')
      sx = x;
      sy = y;
      normalized += x + " " + y + " ";
      if (alen > 2) {
        for (a = 0; a < alen; a += 2) {
          if (op === "m") {
            x += args[a];
            y += args[a + 1];
          } else {
            x = args[a];
            y = args[a + 1];
          }
          normalized += ["L",x,y,''].join(" ");
        }
      }
    } else if (lop === "l") {
      // lineto commands
      for (a = 0; a < alen; a += 2) {
        if (op === "l") {
          x += args[a];
          y += args[a + 1];
        } else {
          x = args[a];
          y = args[a + 1];
        }
        normalized += ["L",x,y,''].join(" ");
      }
    } else if (lop === "h") {
      for (a = 0; a < alen; a++) {
        if (op === "h") {
          x += args[a];
        } else {
          x = args[a];
        }
        normalized += ["L",x,y,''].join(" ");
      }
    } else if (lop === "v") {
      for (a = 0; a < alen; a++) {
        if (op === "v") {
          y += args[a];
        } else {
          y = args[a];
        }
        normalized += ["L",x,y,''].join(" ");
      }
    } else if (lop === "q") {
      // quadratic curveto commands
      for (a = 0; a < alen; a += 4) {
        if (op === "q") {
          cx = x + args[a];
          cy = y + args[a + 1];
          x += args[a + 2];
          y += args[a + 3];
        } else {
          cx = args[a];
          cy = args[a + 1];
          x = args[a + 2];
          y = args[a + 3];
        }
        normalized += ["Q",cx,cy,x,y,''].join(" ");
      }
    } else if (lop === "t") {
      for (a = 0; a < alen; a += 2) {
        // reflect previous cx/cy over x/y
        cx = x + (x - cx);
        cy = y + (y - cy);
        // then get real end point
        if (op === "t") {
          x += args[a];
          y += args[a + 1];
        } else {
          x = args[a];
          y = args[a + 1];
        }
        normalized += ["Q",cx,cy,x,y,''].join(" ");
      }
    } else if (lop === "c") {
      // cubic curveto commands
      for (a = 0; a < alen; a += 6) {
        if (op === "c") {
          cx = x + args[a];
          cy = y + args[a + 1];
          cx2 = x + args[a + 2];
          cy2 = y + args[a + 3];
          x += args[a + 4];
          y += args[a + 5];
        } else {
          cx = args[a];
          cy = args[a + 1];
          cx2 = args[a + 2];
          cy2 = args[a + 3];
          x = args[a + 4];
          y = args[a + 5];
        }
        normalized += ["C",cx,cy,cx2,cy2,x,y,''].join(" ");
      }
    } else if (lop === "s") {
      for (a = 0; a < alen; a += 4) {
        // reflect previous cx2/cy2 over x/y
        cx = x + (x - cx2);
        cy = y + (y - cy2);
        // then get real control and end point
        if (op === "s") {
          cx2 = x + args[a];
          cy2 = y + args[a + 1];
          x += args[a + 2];
          y += args[a + 3];
        } else {
          cx2 = args[a];
          cy2 = args[a + 1];
          x = args[a + 2];
          y = args[a + 3];
        }
        normalized +=["C",cx,cy,cx2,cy2,x,y,''].join(" ");
      }
    } else if (lop === "z") {
      normalized += "Z ";
      // not unimportant: path closing changes the current x/y coordinate
      x = sx;
      y = sy;
    }
  }
  return normalized.trim();
}

module.exports = normalizePath;


/***/ }),

/***/ "./node_modules/bezier-js/lib/poly-bezier.js":
/*!***************************************************!*\
  !*** ./node_modules/bezier-js/lib/poly-bezier.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

(function() {
  "use strict";

  var utils = __webpack_require__(/*! ./utils.js */ "./node_modules/bezier-js/lib/utils.js");

  /**
   * Poly Bezier
   * @param {[type]} curves [description]
   */
  var PolyBezier = function(curves) {
    this.curves = [];
    this._3d = false;
    if (!!curves) {
      this.curves = curves;
      this._3d = this.curves[0]._3d;
    }
  };

  PolyBezier.prototype = {
    valueOf: function() {
      return this.toString();
    },
    toString: function() {
      return (
        "[" +
        this.curves
          .map(function(curve) {
            return utils.pointsToString(curve.points);
          })
          .join(", ") +
        "]"
      );
    },
    addCurve: function(curve) {
      this.curves.push(curve);
      this._3d = this._3d || curve._3d;
    },
    length: function() {
      return this.curves
        .map(function(v) {
          return v.length();
        })
        .reduce(function(a, b) {
          return a + b;
        });
    },
    curve: function(idx) {
      return this.curves[idx];
    },
    bbox: function() {
      var c = this.curves;
      var bbox = c[0].bbox();
      for (var i = 1; i < c.length; i++) {
        utils.expandbox(bbox, c[i].bbox());
      }
      return bbox;
    },
    offset: function(d) {
      var offset = [];
      this.curves.forEach(function(v) {
        offset = offset.concat(v.offset(d));
      });
      return new PolyBezier(offset);
    }
  };

  module.exports = PolyBezier;
})();


/***/ }),

/***/ "./node_modules/bezier-js/lib/svg-to-beziers.js":
/*!******************************************************!*\
  !*** ./node_modules/bezier-js/lib/svg-to-beziers.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var normalise = __webpack_require__(/*! ./normalise-svg.js */ "./node_modules/bezier-js/lib/normalise-svg.js");

var M = { x: false, y: false };

function makeBezier(Bezier, term, values) {
  if (term === 'Z') return;
  if (term === 'M') {
    M = {x: values[0], y: values[1]};
    return;
  }
  // ES7: new Bezier(M.x, M.y, ...values)
  var cvalues = [false, M.x, M.y].concat(values);
  var PreboundConstructor = Bezier.bind.apply(Bezier, cvalues)
  var curve = new PreboundConstructor();
  var last = values.slice(-2);
  M = { x : last[0], y: last[1] };
  return curve;
}

function convertPath(Bezier, d) {
  var terms = normalise(d).split(" "),
    term,
    matcher = new RegExp("[MLCQZ]", ""),
    segment,
    values,
    segments = [],
    ARGS = { "C": 6, "Q": 4, "L": 2, "M": 2};

  while (terms.length) {
    term = terms.splice(0,1)[0];
    if (matcher.test(term)) {
      values = terms.splice(0, ARGS[term]).map(parseFloat);
      segment = makeBezier(Bezier, term, values);
      if (segment) segments.push(segment);
    }
  }

  return new Bezier.PolyBezier(segments);
}

module.exports = convertPath;


/***/ }),

/***/ "./node_modules/bezier-js/lib/utils.js":
/*!*********************************************!*\
  !*** ./node_modules/bezier-js/lib/utils.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

(function() {
  "use strict";

  // math-inlining.
  var abs = Math.abs,
    cos = Math.cos,
    sin = Math.sin,
    acos = Math.acos,
    atan2 = Math.atan2,
    sqrt = Math.sqrt,
    pow = Math.pow,
    // cube root function yielding real roots
    crt = function(v) {
      return v < 0 ? -pow(-v, 1 / 3) : pow(v, 1 / 3);
    },
    // trig constants
    pi = Math.PI,
    tau = 2 * pi,
    quart = pi / 2,
    // float precision significant decimal
    epsilon = 0.000001,
    // extremas used in bbox calculation and similar algorithms
    nMax = Number.MAX_SAFE_INTEGER || 9007199254740991,
    nMin = Number.MIN_SAFE_INTEGER || -9007199254740991,
    // a zero coordinate, which is surprisingly useful
    ZERO = { x: 0, y: 0, z: 0 };

  // Bezier utility functions
  var utils = {
    // Legendre-Gauss abscissae with n=24 (x_i values, defined at i=n as the roots of the nth order Legendre polynomial Pn(x))
    Tvalues: [
      -0.0640568928626056260850430826247450385909,
      0.0640568928626056260850430826247450385909,
      -0.1911188674736163091586398207570696318404,
      0.1911188674736163091586398207570696318404,
      -0.3150426796961633743867932913198102407864,
      0.3150426796961633743867932913198102407864,
      -0.4337935076260451384870842319133497124524,
      0.4337935076260451384870842319133497124524,
      -0.5454214713888395356583756172183723700107,
      0.5454214713888395356583756172183723700107,
      -0.6480936519369755692524957869107476266696,
      0.6480936519369755692524957869107476266696,
      -0.7401241915785543642438281030999784255232,
      0.7401241915785543642438281030999784255232,
      -0.8200019859739029219539498726697452080761,
      0.8200019859739029219539498726697452080761,
      -0.8864155270044010342131543419821967550873,
      0.8864155270044010342131543419821967550873,
      -0.9382745520027327585236490017087214496548,
      0.9382745520027327585236490017087214496548,
      -0.9747285559713094981983919930081690617411,
      0.9747285559713094981983919930081690617411,
      -0.9951872199970213601799974097007368118745,
      0.9951872199970213601799974097007368118745
    ],

    // Legendre-Gauss weights with n=24 (w_i values, defined by a function linked to in the Bezier primer article)
    Cvalues: [
      0.1279381953467521569740561652246953718517,
      0.1279381953467521569740561652246953718517,
      0.1258374563468282961213753825111836887264,
      0.1258374563468282961213753825111836887264,
      0.121670472927803391204463153476262425607,
      0.121670472927803391204463153476262425607,
      0.1155056680537256013533444839067835598622,
      0.1155056680537256013533444839067835598622,
      0.1074442701159656347825773424466062227946,
      0.1074442701159656347825773424466062227946,
      0.0976186521041138882698806644642471544279,
      0.0976186521041138882698806644642471544279,
      0.086190161531953275917185202983742667185,
      0.086190161531953275917185202983742667185,
      0.0733464814110803057340336152531165181193,
      0.0733464814110803057340336152531165181193,
      0.0592985849154367807463677585001085845412,
      0.0592985849154367807463677585001085845412,
      0.0442774388174198061686027482113382288593,
      0.0442774388174198061686027482113382288593,
      0.0285313886289336631813078159518782864491,
      0.0285313886289336631813078159518782864491,
      0.0123412297999871995468056670700372915759,
      0.0123412297999871995468056670700372915759
    ],

    arcfn: function(t, derivativeFn) {
      var d = derivativeFn(t);
      var l = d.x * d.x + d.y * d.y;
      if (typeof d.z !== "undefined") {
        l += d.z * d.z;
      }
      return sqrt(l);
    },

    compute: function(t, points, _3d) {
      // shortcuts
      if (t === 0) {
        return points[0];
      }

      var order = points.length-1;

      if (t === 1) {
        return points[order];
      }

      var p = points;
      var mt = 1 - t;

      // constant?
      if (order === 0) {
        return points[0];
      }

      // linear?
      if (order === 1) {
        ret = {
          x: mt * p[0].x + t * p[1].x,
          y: mt * p[0].y + t * p[1].y
        };
        if (_3d) {
          ret.z = mt * p[0].z + t * p[1].z;
        }
        return ret;
      }

      // quadratic/cubic curve?
      if (order < 4) {
        var mt2 = mt * mt,
          t2 = t * t,
          a,
          b,
          c,
          d = 0;
        if (order === 2) {
          p = [p[0], p[1], p[2], ZERO];
          a = mt2;
          b = mt * t * 2;
          c = t2;
        } else if (order === 3) {
          a = mt2 * mt;
          b = mt2 * t * 3;
          c = mt * t2 * 3;
          d = t * t2;
        }
        var ret = {
          x: a * p[0].x + b * p[1].x + c * p[2].x + d * p[3].x,
          y: a * p[0].y + b * p[1].y + c * p[2].y + d * p[3].y
        };
        if (_3d) {
          ret.z = a * p[0].z + b * p[1].z + c * p[2].z + d * p[3].z;
        }
        return ret;
      }

      // higher order curves: use de Casteljau's computation
      var dCpts = JSON.parse(JSON.stringify(points));
      while (dCpts.length > 1) {
        for (var i = 0; i < dCpts.length - 1; i++) {
          dCpts[i] = {
            x: dCpts[i].x + (dCpts[i + 1].x - dCpts[i].x) * t,
            y: dCpts[i].y + (dCpts[i + 1].y - dCpts[i].y) * t
          };
          if (typeof dCpts[i].z !== "undefined") {
            dCpts[i] = dCpts[i].z + (dCpts[i + 1].z - dCpts[i].z) * t;
          }
        }
        dCpts.splice(dCpts.length - 1, 1);
      }
      return dCpts[0];
    },

    computeWithRatios: function (t, points, ratios, _3d) {
      var mt = 1 - t, r = ratios, p = points, d;
      var f1 = r[0], f2 = r[1], f3 = r[2], f4 = r[3];

      // spec for linear
      f1 *= mt;
      f2 *= t;

      if (p.length === 2) {
        d = f1 + f2;
        return {
          x: (f1 * p[0].x + f2 * p[1].x)/d,
          y: (f1 * p[0].y + f2 * p[1].y)/d,
          z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z)/d
        };
      }

      // upgrade to quadratic
      f1 *= mt;
      f2 *= 2 * mt;
      f3 *= t * t;

      if (p.length === 3) {
        d = f1 + f2 + f3;
        return {
          x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x)/d,
          y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y)/d,
          z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z)/d
        };
      }

      // upgrade to cubic
      f1 *= mt;
      f2 *= 1.5 * mt;
      f3 *= 3 * mt;
      f4 *= t * t * t;

      if (p.length === 4) {
        d = f1 + f2 + f3 + f4;
        return {
          x: (f1 * p[0].x + f2 * p[1].x + f3 * p[2].x + f4 * p[3].x)/d,
          y: (f1 * p[0].y + f2 * p[1].y + f3 * p[2].y + f4 * p[3].y)/d,
          z: !_3d ? false : (f1 * p[0].z + f2 * p[1].z + f3 * p[2].z + f4 * p[3].z)/d
        };
      }
    },

    derive: function (points, _3d) {
      var dpoints = [];
      for (var p = points, d = p.length, c = d - 1; d > 1; d--, c--) {
        var list = [];
        for (var j = 0, dpt; j < c; j++) {
          dpt = {
            x: c * (p[j + 1].x - p[j].x),
            y: c * (p[j + 1].y - p[j].y)
          };
          if (_3d) {
            dpt.z = c * (p[j + 1].z - p[j].z);
          }
          list.push(dpt);
        }
        dpoints.push(list);
        p = list;
      }
      return dpoints;
    },

    between: function(v, m, M) {
      return (
        (m <= v && v <= M) ||
        utils.approximately(v, m) ||
        utils.approximately(v, M)
      );
    },

    approximately: function(a, b, precision) {
      return abs(a - b) <= (precision || epsilon);
    },

    length: function(derivativeFn) {
      var z = 0.5,
        sum = 0,
        len = utils.Tvalues.length,
        i,
        t;
      for (i = 0; i < len; i++) {
        t = z * utils.Tvalues[i] + z;
        sum += utils.Cvalues[i] * utils.arcfn(t, derivativeFn);
      }
      return z * sum;
    },

    map: function(v, ds, de, ts, te) {
      var d1 = de - ds,
        d2 = te - ts,
        v2 = v - ds,
        r = v2 / d1;
      return ts + d2 * r;
    },

    lerp: function(r, v1, v2) {
      var ret = {
        x: v1.x + r * (v2.x - v1.x),
        y: v1.y + r * (v2.y - v1.y)
      };
      if (!!v1.z && !!v2.z) {
        ret.z = v1.z + r * (v2.z - v1.z);
      }
      return ret;
    },

    pointToString: function(p) {
      var s = p.x + "/" + p.y;
      if (typeof p.z !== "undefined") {
        s += "/" + p.z;
      }
      return s;
    },

    pointsToString: function(points) {
      return "[" + points.map(utils.pointToString).join(", ") + "]";
    },

    copy: function(obj) {
      return JSON.parse(JSON.stringify(obj));
    },

    angle: function(o, v1, v2) {
      var dx1 = v1.x - o.x,
        dy1 = v1.y - o.y,
        dx2 = v2.x - o.x,
        dy2 = v2.y - o.y,
        cross = dx1 * dy2 - dy1 * dx2,
        dot = dx1 * dx2 + dy1 * dy2;
      return atan2(cross, dot);
    },

    // round as string, to avoid rounding errors
    round: function(v, d) {
      var s = "" + v;
      var pos = s.indexOf(".");
      return parseFloat(s.substring(0, pos + 1 + d));
    },

    dist: function(p1, p2) {
      var dx = p1.x - p2.x,
        dy = p1.y - p2.y;
      return sqrt(dx * dx + dy * dy);
    },

    closest: function(LUT, point) {
      var mdist = pow(2, 63),
        mpos,
        d;
      LUT.forEach(function(p, idx) {
        d = utils.dist(point, p);
        if (d < mdist) {
          mdist = d;
          mpos = idx;
        }
      });
      return { mdist: mdist, mpos: mpos };
    },

    abcratio: function(t, n) {
      // see ratio(t) note on http://pomax.github.io/bezierinfo/#abc
      if (n !== 2 && n !== 3) {
        return false;
      }
      if (typeof t === "undefined") {
        t = 0.5;
      } else if (t === 0 || t === 1) {
        return t;
      }
      var bottom = pow(t, n) + pow(1 - t, n),
        top = bottom - 1;
      return abs(top / bottom);
    },

    projectionratio: function(t, n) {
      // see u(t) note on http://pomax.github.io/bezierinfo/#abc
      if (n !== 2 && n !== 3) {
        return false;
      }
      if (typeof t === "undefined") {
        t = 0.5;
      } else if (t === 0 || t === 1) {
        return t;
      }
      var top = pow(1 - t, n),
        bottom = pow(t, n) + top;
      return top / bottom;
    },

    lli8: function(x1, y1, x2, y2, x3, y3, x4, y4) {
      var nx =
          (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4),
        ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4),
        d = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
      if (d == 0) {
        return false;
      }
      return { x: nx / d, y: ny / d };
    },

    lli4: function(p1, p2, p3, p4) {
      var x1 = p1.x,
        y1 = p1.y,
        x2 = p2.x,
        y2 = p2.y,
        x3 = p3.x,
        y3 = p3.y,
        x4 = p4.x,
        y4 = p4.y;
      return utils.lli8(x1, y1, x2, y2, x3, y3, x4, y4);
    },

    lli: function(v1, v2) {
      return utils.lli4(v1, v1.c, v2, v2.c);
    },

    makeline: function(p1, p2) {
      var Bezier = __webpack_require__(/*! ./bezier */ "./node_modules/bezier-js/lib/bezier.js");
      var x1 = p1.x,
        y1 = p1.y,
        x2 = p2.x,
        y2 = p2.y,
        dx = (x2 - x1) / 3,
        dy = (y2 - y1) / 3;
      return new Bezier(
        x1,
        y1,
        x1 + dx,
        y1 + dy,
        x1 + 2 * dx,
        y1 + 2 * dy,
        x2,
        y2
      );
    },

    findbbox: function(sections) {
      var mx = nMax,
        my = nMax,
        MX = nMin,
        MY = nMin;
      sections.forEach(function(s) {
        var bbox = s.bbox();
        if (mx > bbox.x.min) mx = bbox.x.min;
        if (my > bbox.y.min) my = bbox.y.min;
        if (MX < bbox.x.max) MX = bbox.x.max;
        if (MY < bbox.y.max) MY = bbox.y.max;
      });
      return {
        x: { min: mx, mid: (mx + MX) / 2, max: MX, size: MX - mx },
        y: { min: my, mid: (my + MY) / 2, max: MY, size: MY - my }
      };
    },

    shapeintersections: function(
      s1,
      bbox1,
      s2,
      bbox2,
      curveIntersectionThreshold
    ) {
      if (!utils.bboxoverlap(bbox1, bbox2)) return [];
      var intersections = [];
      var a1 = [s1.startcap, s1.forward, s1.back, s1.endcap];
      var a2 = [s2.startcap, s2.forward, s2.back, s2.endcap];
      a1.forEach(function(l1) {
        if (l1.virtual) return;
        a2.forEach(function(l2) {
          if (l2.virtual) return;
          var iss = l1.intersects(l2, curveIntersectionThreshold);
          if (iss.length > 0) {
            iss.c1 = l1;
            iss.c2 = l2;
            iss.s1 = s1;
            iss.s2 = s2;
            intersections.push(iss);
          }
        });
      });
      return intersections;
    },

    makeshape: function(forward, back, curveIntersectionThreshold) {
      var bpl = back.points.length;
      var fpl = forward.points.length;
      var start = utils.makeline(back.points[bpl - 1], forward.points[0]);
      var end = utils.makeline(forward.points[fpl - 1], back.points[0]);
      var shape = {
        startcap: start,
        forward: forward,
        back: back,
        endcap: end,
        bbox: utils.findbbox([start, forward, back, end])
      };
      var self = utils;
      shape.intersections = function(s2) {
        return self.shapeintersections(
          shape,
          shape.bbox,
          s2,
          s2.bbox,
          curveIntersectionThreshold
        );
      };
      return shape;
    },

    getminmax: function(curve, d, list) {
      if (!list) return { min: 0, max: 0 };
      var min = nMax,
        max = nMin,
        t,
        c;
      if (list.indexOf(0) === -1) {
        list = [0].concat(list);
      }
      if (list.indexOf(1) === -1) {
        list.push(1);
      }
      for (var i = 0, len = list.length; i < len; i++) {
        t = list[i];
        c = curve.get(t);
        if (c[d] < min) {
          min = c[d];
        }
        if (c[d] > max) {
          max = c[d];
        }
      }
      return { min: min, mid: (min + max) / 2, max: max, size: max - min };
    },

    align: function(points, line) {
      var tx = line.p1.x,
        ty = line.p1.y,
        a = -atan2(line.p2.y - ty, line.p2.x - tx),
        d = function(v) {
          return {
            x: (v.x - tx) * cos(a) - (v.y - ty) * sin(a),
            y: (v.x - tx) * sin(a) + (v.y - ty) * cos(a)
          };
        };
      return points.map(d);
    },

    roots: function(points, line) {
      line = line || { p1: { x: 0, y: 0 }, p2: { x: 1, y: 0 } };
      var order = points.length - 1;
      var p = utils.align(points, line);
      var reduce = function(t) {
        return 0 <= t && t <= 1;
      };

      if (order === 2) {
        var a = p[0].y,
          b = p[1].y,
          c = p[2].y,
          d = a - 2 * b + c;
        if (d !== 0) {
          var m1 = -sqrt(b * b - a * c),
            m2 = -a + b,
            v1 = -(m1 + m2) / d,
            v2 = -(-m1 + m2) / d;
          return [v1, v2].filter(reduce);
        } else if (b !== c && d === 0) {
          return [(2*b - c)/(2*b - 2*c)].filter(reduce);
        }
        return [];
      }

      // see http://www.trans4mind.com/personal_development/mathematics/polynomials/cubicAlgebra.htm
      var pa = p[0].y,
        pb = p[1].y,
        pc = p[2].y,
        pd = p[3].y,
        d = -pa + 3 * pb - 3 * pc + pd,
        a = 3 * pa - 6 * pb + 3 * pc,
        b = -3 * pa + 3 * pb,
        c = pa;

      if (utils.approximately(d, 0)) {
        // this is not a cubic curve.
        if (utils.approximately(a, 0)) {
          // in fact, this is not a quadratic curve either.
          if (utils.approximately(b, 0)) {
            // in fact in fact, there are no solutions.
            return [];
          }
          // linear solution:
          return [-c / b].filter(reduce);
        }
        // quadratic solution:
        var q = sqrt(b * b - 4 * a * c),
          a2 = 2 * a;
        return [(q - b) / a2, (-b - q) / a2].filter(reduce);
      }

      // at this point, we know we need a cubic solution:

      a /= d;
      b /= d;
      c /= d;

      var p = (3 * b - a * a) / 3,
        p3 = p / 3,
        q = (2 * a * a * a - 9 * a * b + 27 * c) / 27,
        q2 = q / 2,
        discriminant = q2 * q2 + p3 * p3 * p3,
        u1,
        v1,
        x1,
        x2,
        x3;
      if (discriminant < 0) {
        var mp3 = -p / 3,
          mp33 = mp3 * mp3 * mp3,
          r = sqrt(mp33),
          t = -q / (2 * r),
          cosphi = t < -1 ? -1 : t > 1 ? 1 : t,
          phi = acos(cosphi),
          crtr = crt(r),
          t1 = 2 * crtr;
        x1 = t1 * cos(phi / 3) - a / 3;
        x2 = t1 * cos((phi + tau) / 3) - a / 3;
        x3 = t1 * cos((phi + 2 * tau) / 3) - a / 3;
        return [x1, x2, x3].filter(reduce);
      } else if (discriminant === 0) {
        u1 = q2 < 0 ? crt(-q2) : -crt(q2);
        x1 = 2 * u1 - a / 3;
        x2 = -u1 - a / 3;
        return [x1, x2].filter(reduce);
      } else {
        var sd = sqrt(discriminant);
        u1 = crt(-q2 + sd);
        v1 = crt(q2 + sd);
        return [u1 - v1 - a / 3].filter(reduce);
      }
    },

    droots: function(p) {
      // quadratic roots are easy
      if (p.length === 3) {
        var a = p[0],
          b = p[1],
          c = p[2],
          d = a - 2 * b + c;
        if (d !== 0) {
          var m1 = -sqrt(b * b - a * c),
            m2 = -a + b,
            v1 = -(m1 + m2) / d,
            v2 = -(-m1 + m2) / d;
          return [v1, v2];
        } else if (b !== c && d === 0) {
          return [(2 * b - c) / (2 * (b - c))];
        }
        return [];
      }

      // linear roots are even easier
      if (p.length === 2) {
        var a = p[0],
          b = p[1];
        if (a !== b) {
          return [a / (a - b)];
        }
        return [];
      }
    },

    curvature: function(t, points, _3d, kOnly) {
      var dpoints = utils.derive(points);
      var d1 = dpoints[0];
      var d2 = dpoints[1];
      var num, dnm, adk, dk, k=0, r=0;

      //
      // We're using the following formula for curvature:
      //
      //              x'y" - y'x"
      //   k(t) = ------------------
      //           (x'² + y'²)^(3/2)
      //
      // from https://en.wikipedia.org/wiki/Radius_of_curvature#Definition
      //
      // With it corresponding 3D counterpart:
      //
      //          sqrt( (y'z" - y"z')² + (z'x" - z"x')² + (x'y" - x"y')²)
      //   k(t) = -------------------------------------------------------
      //                     (x'² + y'² + z'²)^(3/2)
      //

      var d = utils.compute(t, d1);
      var dd = utils.compute(t, d2);
      var qdsum = d.x*d.x + d.y*d.y;
      if (_3d) {
        num = sqrt(
          pow(d.y*dd.z - dd.y*d.z, 2) +
          pow(d.z*dd.x - dd.z*d.x, 2) +
          pow(d.x*dd.y - dd.x*d.y, 2)
        );
        dnm = pow(qdsum + d.z*d.z, 3/2);
      } else {
        num = d.x*dd.y - d.y*dd.x;
        dnm = pow(qdsum, 3/2);
      }

      if (num === 0 || dnm === 0) {
        return { k:0, r:0 };
      }

      k = num/dnm;
      r = dnm/num;

      // We're also computing the derivative of kappa, because
      // there is value in knowing the rate of change for the
      // curvature along the curve. And we're just going to
      // ballpark it based on an epsilon.
      if (!kOnly) {
        // compute k'(t) based on the interval before, and after it,
        // to at least try to not introduce forward/backward pass bias.
        var pk = utils.curvature(t-0.001, points, _3d, true).k;
        var nk = utils.curvature(t+0.001, points, _3d, true).k;
        dk = ((nk-k) + (k-pk))/2;
        adk = (abs(nk-k) + abs(k-pk))/2;
      }

      return { k: k, r: r, dk: dk, adk:adk, };
    },

    inflections: function(points) {
      if (points.length < 4) return [];

      // FIXME: TODO: add in inflection abstraction for quartic+ curves?

      var p = utils.align(points, { p1: points[0], p2: points.slice(-1)[0] }),
        a = p[2].x * p[1].y,
        b = p[3].x * p[1].y,
        c = p[1].x * p[2].y,
        d = p[3].x * p[2].y,
        v1 = 18 * (-3 * a + 2 * b + 3 * c - d),
        v2 = 18 * (3 * a - b - 3 * c),
        v3 = 18 * (c - a);

      if (utils.approximately(v1, 0)) {
        if (!utils.approximately(v2, 0)) {
          var t = -v3 / v2;
          if (0 <= t && t <= 1) return [t];
        }
        return [];
      }

      var trm = v2 * v2 - 4 * v1 * v3,
        sq = Math.sqrt(trm),
        d = 2 * v1;

      if (utils.approximately(d, 0)) return [];

      return [(sq - v2) / d, -(v2 + sq) / d].filter(function(r) {
        return 0 <= r && r <= 1;
      });
    },

    bboxoverlap: function(b1, b2) {
      var dims = ["x", "y"],
        len = dims.length,
        i,
        dim,
        l,
        t,
        d;
      for (i = 0; i < len; i++) {
        dim = dims[i];
        l = b1[dim].mid;
        t = b2[dim].mid;
        d = (b1[dim].size + b2[dim].size) / 2;
        if (abs(l - t) >= d) return false;
      }
      return true;
    },

    expandbox: function(bbox, _bbox) {
      if (_bbox.x.min < bbox.x.min) {
        bbox.x.min = _bbox.x.min;
      }
      if (_bbox.y.min < bbox.y.min) {
        bbox.y.min = _bbox.y.min;
      }
      if (_bbox.z && _bbox.z.min < bbox.z.min) {
        bbox.z.min = _bbox.z.min;
      }
      if (_bbox.x.max > bbox.x.max) {
        bbox.x.max = _bbox.x.max;
      }
      if (_bbox.y.max > bbox.y.max) {
        bbox.y.max = _bbox.y.max;
      }
      if (_bbox.z && _bbox.z.max > bbox.z.max) {
        bbox.z.max = _bbox.z.max;
      }
      bbox.x.mid = (bbox.x.min + bbox.x.max) / 2;
      bbox.y.mid = (bbox.y.min + bbox.y.max) / 2;
      if (bbox.z) {
        bbox.z.mid = (bbox.z.min + bbox.z.max) / 2;
      }
      bbox.x.size = bbox.x.max - bbox.x.min;
      bbox.y.size = bbox.y.max - bbox.y.min;
      if (bbox.z) {
        bbox.z.size = bbox.z.max - bbox.z.min;
      }
    },

    pairiteration: function(c1, c2, curveIntersectionThreshold) {
      var c1b = c1.bbox(),
        c2b = c2.bbox(),
        r = 100000,
        threshold = curveIntersectionThreshold || 0.5;
      if (
        c1b.x.size + c1b.y.size < threshold &&
        c2b.x.size + c2b.y.size < threshold
      ) {
        return [
          ((r * (c1._t1 + c1._t2) / 2) | 0) / r +
            "/" +
            ((r * (c2._t1 + c2._t2) / 2) | 0) / r
        ];
      }
      var cc1 = c1.split(0.5),
        cc2 = c2.split(0.5),
        pairs = [
          { left: cc1.left, right: cc2.left },
          { left: cc1.left, right: cc2.right },
          { left: cc1.right, right: cc2.right },
          { left: cc1.right, right: cc2.left }
        ];
      pairs = pairs.filter(function(pair) {
        return utils.bboxoverlap(pair.left.bbox(), pair.right.bbox());
      });
      var results = [];
      if (pairs.length === 0) return results;
      pairs.forEach(function(pair) {
        results = results.concat(
          utils.pairiteration(pair.left, pair.right, threshold)
        );
      });
      results = results.filter(function(v, i) {
        return results.indexOf(v) === i;
      });
      return results;
    },

    getccenter: function(p1, p2, p3) {
      var dx1 = p2.x - p1.x,
        dy1 = p2.y - p1.y,
        dx2 = p3.x - p2.x,
        dy2 = p3.y - p2.y;
      var dx1p = dx1 * cos(quart) - dy1 * sin(quart),
        dy1p = dx1 * sin(quart) + dy1 * cos(quart),
        dx2p = dx2 * cos(quart) - dy2 * sin(quart),
        dy2p = dx2 * sin(quart) + dy2 * cos(quart);
      // chord midpoints
      var mx1 = (p1.x + p2.x) / 2,
        my1 = (p1.y + p2.y) / 2,
        mx2 = (p2.x + p3.x) / 2,
        my2 = (p2.y + p3.y) / 2;
      // midpoint offsets
      var mx1n = mx1 + dx1p,
        my1n = my1 + dy1p,
        mx2n = mx2 + dx2p,
        my2n = my2 + dy2p;
      // intersection of these lines:
      var arc = utils.lli8(mx1, my1, mx1n, my1n, mx2, my2, mx2n, my2n),
        r = utils.dist(arc, p1),
        // arc start/end values, over mid point:
        s = atan2(p1.y - arc.y, p1.x - arc.x),
        m = atan2(p2.y - arc.y, p2.x - arc.x),
        e = atan2(p3.y - arc.y, p3.x - arc.x),
        _;
      // determine arc direction (cw/ccw correction)
      if (s < e) {
        // if s<m<e, arc(s, e)
        // if m<s<e, arc(e, s + tau)
        // if s<e<m, arc(e, s + tau)
        if (s > m || m > e) {
          s += tau;
        }
        if (s > e) {
          _ = e;
          e = s;
          s = _;
        }
      } else {
        // if e<m<s, arc(e, s)
        // if m<e<s, arc(s, e + tau)
        // if e<s<m, arc(s, e + tau)
        if (e < m && m < s) {
          _ = e;
          e = s;
          s = _;
        } else {
          e += tau;
        }
      }
      // assign and done.
      arc.s = s;
      arc.e = e;
      arc.r = r;
      return arc;
    },

    numberSort: function(a, b) {
      return a - b;
    }
  };

  module.exports = utils;
})();


/***/ }),

/***/ "./node_modules/bluebird/js/browser/bluebird.js":
/*!******************************************************!*\
  !*** ./node_modules/bluebird/js/browser/bluebird.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2014 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:</p>
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 2.9.25
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
*/
!function(e){if(true)module.exports=e();else { var f; }}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule.js");
var Queue = _dereq_("./queue.js");
var util = _dereq_("./util.js");

function Async() {
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule =
        schedule.isStatic ? schedule(this.drainQueues) : schedule;
}

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.enableTrampoline = function() {
    if (!this._trampolineEnabled) {
        this._trampolineEnabled = true;
        this._schedule = function(fn) {
            setTimeout(fn, 0);
        };
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._normalQueue.length() > 0;
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
    }
};

Async.prototype._getDomain = function() {};

if (false) { var usingDomains, descriptor, domainGetter, EventsModule; }

function AsyncInvokeLater(fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    var domain = this._getDomain();
    if (domain !== undefined) {
        var fn = domain.bind(promise._settlePromises);
        this._normalQueue.push(fn, promise, undefined);
    } else {
        this._normalQueue._pushOne(promise);
    }
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 100);
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 0);
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            setTimeout(function() {
                promise._settlePromises();
            }, 0);
        }
    };
}

Async.prototype.invokeFirst = function (fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._normalQueue.unshift(fn, receiver, arg);
    this._queueTick();
};

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = new Async();
module.exports.firstLineError = firstLineError;

},{"./queue.js":28,"./schedule.js":31,"./util.js":38,"events":39}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    this._setBoundTo(thisArg);
    if (this._isPending()) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, ret._progress, ret, context);
    } else {
        ret._setBoundTo(thisArg);
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 131072;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~131072);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 131072) === 131072;
};

Promise.bind = function (thisArg, value) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);

    if (maybePromise instanceof Promise) {
        maybePromise._then(function(thisArg) {
            ret._setBoundTo(thisArg);
            ret._resolveCallback(value);
        }, ret._reject, ret._progress, ret, null);
    } else {
        ret._setBoundTo(thisArg);
        ret._resolveCallback(value);
    }
    return ret;
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise.js")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise.js":23}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) { var getCompiled, makeGetter, makeMethodCaller; }

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
    if (false) { var maybeCaller; }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util.js":38}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var errors = _dereq_("./errors.js");
var async = _dereq_("./async.js");
var CancellationError = errors.CancellationError;

Promise.prototype._cancel = function (reason) {
    if (!this.isCancellable()) return this;
    var parent;
    var promiseToReject = this;
    while ((parent = promiseToReject._cancellationParent) !== undefined &&
        parent.isCancellable()) {
        promiseToReject = parent;
    }
    this._unsetCancellable();
    promiseToReject._target()._rejectCallback(reason, false, true);
};

Promise.prototype.cancel = function (reason) {
    if (!this.isCancellable()) return this;
    if (reason === undefined) reason = new CancellationError();
    async.invokeLater(this._cancel, this, reason);
    return this;
};

Promise.prototype.cancellable = function () {
    if (this._cancellable()) return this;
    async.enableTrampoline();
    this._setCancellable();
    this._cancellationParent = undefined;
    return this;
};

Promise.prototype.uncancellable = function () {
    var ret = this.then();
    ret._unsetCancellable();
    return ret;
};

Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
    var ret = this._then(didFulfill, didReject, didProgress,
                         undefined, undefined);

    ret._setCancellable();
    ret._cancellationParent = undefined;
    return ret;
};
};

},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var warn;

function CapturedTrace(parent) {
    this._parent = parent;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.parent = function() {
    return this._parent;
};

CapturedTrace.prototype.hasParent = function() {
    return this._parent !== undefined;
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = CapturedTrace.parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = stackFramePattern.test(line) ||
            "    (No stack trace)" === line;
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0) {
        stack = stack.slice(i);
    }
    return stack;
}

CapturedTrace.parseStackAndMessage = function(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: cleanStack(stack)
    };
};

CapturedTrace.formatAndLogError = function(error, title) {
    if (typeof console !== "undefined") {
        var message;
        if (typeof error === "object" || typeof error === "function") {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof warn === "function") {
            warn(message);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
};

CapturedTrace.unhandledRejection = function (reason) {
    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
};

CapturedTrace.isSupported = function () {
    return typeof captureStackTrace === "function";
};

CapturedTrace.fireRejectionEvent =
function(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent(name, reason, promise);
    } catch (e) {
        globalEventFired = true;
        async.throwLater(e);
    }

    var domEventFired = false;
    if (fireDomEvent) {
        try {
            domEventFired = fireDomEvent(name.toLowerCase(), {
                reason: reason,
                promise: promise
            });
        } catch (e) {
            domEventFired = true;
            async.throwLater(e);
        }
    }

    if (!globalEventFired && !localEventFired && !domEventFired &&
        name === "unhandledRejection") {
        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
    }
};

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj.toString();
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}
CapturedTrace.setBounds = function(firstLineError, lastLineError) {
    if (!CapturedTrace.isSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit = Error.stackTraceLimit + 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow) {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

var fireDomEvent;
var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function(name, reason, promise) {
            if (name === "rejectionHandled") {
                return process.emit(name, promise);
            } else {
                return process.emit(name, reason, promise);
            }
        };
    } else {
        var customEventWorks = false;
        var anyEventWorks = true;
        try {
            var ev = new self.CustomEvent("test");
            customEventWorks = ev instanceof CustomEvent;
        } catch (e) {}
        if (!customEventWorks) {
            try {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                self.dispatchEvent(event);
            } catch (e) {
                anyEventWorks = false;
            }
        }
        if (anyEventWorks) {
            fireDomEvent = function(type, detail) {
                var event;
                if (customEventWorks) {
                    event = new self.CustomEvent(type, {
                        detail: detail,
                        bubbles: false,
                        cancelable: true
                    });
                } else if (self.dispatchEvent) {
                    event = document.createEvent("CustomEvent");
                    event.initCustomEvent(type, false, true, detail);
                }

                return event ? !self.dispatchEvent(event) : false;
            };
        }

        var toWindowMethodNameMap = {};
        toWindowMethodNameMap["unhandledRejection"] = ("on" +
            "unhandledRejection").toLowerCase();
        toWindowMethodNameMap["rejectionHandled"] = ("on" +
            "rejectionHandled").toLowerCase();

        return function(name, reason, promise) {
            var methodName = toWindowMethodNameMap[name];
            var method = self[methodName];
            if (!method) return false;
            if (name === "rejectionHandled") {
                method.call(self, promise);
            } else {
                method.call(self, reason, promise);
            }
            return true;
        };
    }
})();

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    warn = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        warn = function(message) {
            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        warn = function(message) {
            console.warn("%c" + message, "color: red");
        };
    }
}

return CapturedTrace;
};

},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util.js");
var errors = _dereq_("./errors.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var keys = _dereq_("./es5.js").keys;
var TypeError = errors.TypeError;

function CatchFilter(instances, callback, promise) {
    this._instances = instances;
    this._callback = callback;
    this._promise = promise;
}

function safePredicate(predicate, e) {
    var safeObject = {};
    var retfilter = tryCatch(predicate).call(safeObject, e);

    if (retfilter === errorObj) return retfilter;

    var safeKeys = keys(safeObject);
    if (safeKeys.length) {
        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
        return errorObj;
    }
    return retfilter;
}

CatchFilter.prototype.doFilter = function (e) {
    var cb = this._callback;
    var promise = this._promise;
    var boundTo = promise._boundTo;
    for (var i = 0, len = this._instances.length; i < len; ++i) {
        var item = this._instances[i];
        var itemIsErrorType = item === Error ||
            (item != null && item.prototype instanceof Error);

        if (itemIsErrorType && e instanceof item) {
            var ret = tryCatch(cb).call(boundTo, e);
            if (ret === errorObj) {
                NEXT_FILTER.e = ret.e;
                return NEXT_FILTER;
            }
            return ret;
        } else if (typeof item === "function" && !itemIsErrorType) {
            var shouldHandle = safePredicate(item, e);
            if (shouldHandle === errorObj) {
                e = errorObj.e;
                break;
            } else if (shouldHandle) {
                var ret = tryCatch(cb).call(boundTo, e);
                if (ret === errorObj) {
                    NEXT_FILTER.e = ret.e;
                    return NEXT_FILTER;
                }
                return ret;
            }
        }
    }
    NEXT_FILTER.e = e;
    return NEXT_FILTER;
};

return CatchFilter;
};

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace, isDebugging) {
var contextStack = [];
function Context() {
    this._trace = new CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.pop();
    }
};

function createContext() {
    if (isDebugging()) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}

Promise.prototype._peekContext = peekContext;
Promise.prototype._pushContext = Context.prototype._pushContext;
Promise.prototype._popContext = Context.prototype._popContext;

return createContext;
};

},{}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace) {
var async = _dereq_("./async.js");
var Warning = _dereq_("./errors.js").Warning;
var util = _dereq_("./util.js");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var debugging =  false || (util.isNode &&
                    (!!process.env["BLUEBIRD_DEBUG"] ||
                     "development" === "development"));

if (debugging) {
    async.disableTrampolineIfNecessary();
}

Promise.prototype._ensurePossibleRejectionHandled = function () {
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    CapturedTrace.fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._getCarriedStackTrace() || this._settledValue;
        this._setUnhandledRejectionIsNotified();
        CapturedTrace.fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 524288;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~524288);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 524288) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 2097152;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~2097152);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 2097152) > 0;
};

Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
    this._bitField = this._bitField | 1048576;
    this._fulfillmentHandler0 = capturedTrace;
};

Promise.prototype._isCarryingStackTrace = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._getCarriedStackTrace = function () {
    return this._isCarryingStackTrace()
        ? this._fulfillmentHandler0
        : undefined;
};

Promise.prototype._captureStackTrace = function () {
    if (debugging) {
        this._trace = new CapturedTrace(this._peekContext());
    }
    return this;
};

Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
    if (debugging && canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = CapturedTrace.parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
};

Promise.prototype._warn = function(message) {
    var warning = new Warning(message);
    var ctx = this._peekContext();
    if (ctx) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = CapturedTrace.parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }
    CapturedTrace.formatAndLogError(warning, "");
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    possiblyUnhandledRejection = typeof fn === "function" ? fn : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    unhandledRejectionHandled = typeof fn === "function" ? fn : undefined;
};

Promise.longStackTraces = function () {
    if (async.haveItemsQueued() &&
        debugging === false
   ) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
    }
    debugging = CapturedTrace.isSupported();
    if (debugging) {
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return debugging && CapturedTrace.isSupported();
};

if (!CapturedTrace.isSupported()) {
    Promise.longStackTraces = function(){};
    debugging = false;
}

return function() {
    return debugging;
};
};

},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var isPrimitive = util.isPrimitive;
var wrapsPrimitiveReceiver = util.wrapsPrimitiveReceiver;

module.exports = function(Promise) {
var returner = function () {
    return this;
};
var thrower = function () {
    throw this;
};

var wrapper = function (value, action) {
    if (action === 1) {
        return function () {
            throw value;
        };
    } else if (action === 2) {
        return function () {
            return value;
        };
    }
};


Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (wrapsPrimitiveReceiver && isPrimitive(value)) {
        return this._then(
            wrapper(value, 2),
            undefined,
            undefined,
            undefined,
            undefined
       );
    }
    return this._then(returner, undefined, undefined, value, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    if (wrapsPrimitiveReceiver && isPrimitive(reason)) {
        return this._then(
            wrapper(reason, 1),
            undefined,
            undefined,
            undefined,
            undefined
       );
    }
    return this._then(thrower, undefined, undefined, reason, undefined);
};
};

},{"./util.js":38}],12:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, null, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, null, INTERNAL);
};
};

},{}],13:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util.js");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
var util = _dereq_("./util.js");
var wrapsPrimitiveReceiver = util.wrapsPrimitiveReceiver;
var isPrimitive = util.isPrimitive;
var thrower = util.thrower;

function returnThis() {
    return this;
}
function throwThis() {
    throw this;
}
function return$(r) {
    return function() {
        return r;
    };
}
function throw$(r) {
    return function() {
        throw r;
    };
}
function promisedFinally(ret, reasonOrValue, isFulfilled) {
    var then;
    if (wrapsPrimitiveReceiver && isPrimitive(reasonOrValue)) {
        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
    } else {
        then = isFulfilled ? returnThis : throwThis;
    }
    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
}

function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundTo)
                    : handler();

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, reasonOrValue,
                                    promise.isFulfilled());
        }
    }

    if (promise.isRejected()) {
        NEXT_FILTER.e = reasonOrValue;
        return NEXT_FILTER;
    } else {
        return reasonOrValue;
    }
}

function tapHandler(value) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundTo, value)
                    : handler(value);

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, value, true);
        }
    }
    return value;
}

Promise.prototype._passThroughHandler = function (handler, isFinally) {
    if (typeof handler !== "function") return this.then();

    var promiseAndHandler = {
        promise: this,
        handler: handler
    };

    return this._then(
            isFinally ? finallyHandler : tapHandler,
            isFinally ? finallyHandler : undefined, undefined,
            promiseAndHandler, undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThroughHandler(handler, true);
};

Promise.prototype.tap = function (handler) {
    return this._passThroughHandler(handler, false);
};
};

},{"./util.js":38}],17:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise) {
var errors = _dereq_("./errors.js");
var TypeError = errors.TypeError;
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    var promise = this._promise = new Promise(INTERNAL);
    promise._captureStackTrace();
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
}

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._next(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    if (result === errorObj) {
        return this._promise._rejectCallback(result.e, false, true);
    }

    var value = result.value;
    if (result.done === true) {
        this._promise._resolveCallback(value);
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._throw(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise._then(
            this._next,
            this._throw,
            undefined,
            this,
            null
       );
    }
};

PromiseSpawn.prototype._throw = function (reason) {
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._next = function (value) {
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        spawn._generator = generator;
        spawn._next(undefined);
        return spawn.promise();
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) { var reject, Holder, i, callers, thenCallbacks, caller, thenCallback; }

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) { var maybePromise, i, callbacks, holder, ret; }
    }
    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util.js":38}],19:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var PENDING = {};
var EMPTY_ARRAY = [];

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    this._callback = fn;
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
    async.invoke(init, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);
function init() {this._init$(undefined, -2);}

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;
    if (values[index] === PENDING) {
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var callback = this._callback;
        var receiver = this._promise._boundTo;
        this._promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        this._promise._popContext();
        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                if (limit >= 1) this._inFlight++;
                values[index] = PENDING;
                return maybePromise._proxyPromiseArray(this, index);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }

    }
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    var limit = typeof options === "object" && options !== null
        ? options.concurrency
        : 0;
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter);
}

Promise.prototype.map = function (fn, options) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");

    return map(this, fn, options, null).promise();
};

Promise.map = function (promises, fn, options, _filter) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    return map(promises, fn, options, _filter).promise();
};


};

},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        ret._popContext();
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn, args, ctx) {
    if (typeof fn !== "function") {
        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value = util.isArray(args)
        ? tryCatch(fn).apply(ctx, args)
        : tryCatch(fn).call(ctx, args);
    ret._popContext();
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false, true);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util.js":38}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret = tryCatch(nodeback).apply(promise._boundTo, [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundTo;
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var target = promise._target();
        var newReason = target._getCarriedStackTrace();
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundTo, reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = 
Promise.prototype.nodeify = function (nodeback, options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

Promise.prototype.progressed = function (handler) {
    return this._then(undefined, undefined, handler, undefined, undefined);
};

Promise.prototype._progress = function (progressValue) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._target()._progressUnchecked(progressValue);

};

Promise.prototype._progressHandlerAt = function (index) {
    return index === 0
        ? this._progressHandler0
        : this[(index << 2) + index - 5 + 2];
};

Promise.prototype._doProgressWith = function (progression) {
    var progressValue = progression.value;
    var handler = progression.handler;
    var promise = progression.promise;
    var receiver = progression.receiver;

    var ret = tryCatch(handler).call(receiver, progressValue);
    if (ret === errorObj) {
        if (ret.e != null &&
            ret.e.name !== "StopProgressPropagation") {
            var trace = util.canAttachTrace(ret.e)
                ? ret.e : new Error(util.toString(ret.e));
            promise._attachExtraTrace(trace);
            promise._progress(ret.e);
        }
    } else if (ret instanceof Promise) {
        ret._then(promise._progress, null, null, promise, undefined);
    } else {
        promise._progress(ret);
    }
};


Promise.prototype._progressUnchecked = function (progressValue) {
    var len = this._length();
    var progress = this._progress;
    for (var i = 0; i < len; i++) {
        var handler = this._progressHandlerAt(i);
        var promise = this._promiseAt(i);
        if (!(promise instanceof Promise)) {
            var receiver = this._receiverAt(i);
            if (typeof handler === "function") {
                handler.call(receiver, progressValue, promise);
            } else if (receiver instanceof PromiseArray &&
                       !receiver._isResolved()) {
                receiver._promiseProgressed(progressValue, promise);
            }
            continue;
        }

        if (typeof handler === "function") {
            async.invoke(this._doProgressWith, this, {
                handler: handler,
                promise: promise,
                receiver: this._receiverAt(i),
                value: progressValue
            });
        } else {
            async.invoke(progress, promise, progressValue);
        }
    }
};
};

},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
};
var reflect = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var errors = _dereq_("./errors.js");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {e: null};
var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array.js")(Promise, INTERNAL,
                                    tryConvertToPromise, apiRejection);
var CapturedTrace = _dereq_("./captured_trace.js")();
var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
 /*jshint unused:false*/
var createContext =
    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
var PromiseResolver = _dereq_("./promise_resolver.js");
var nodebackForPromise = PromiseResolver._nodebackForPromise;
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function Promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
    }
    if (this.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._progressHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settledValue = undefined;
    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (typeof item === "function") {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(
                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        var catchFilter = new CatchFilter(catchInstances, fn, this);
        return this._then(undefined, catchFilter.doFilter, undefined,
            catchFilter, undefined);
    }
    return this._then(undefined, fn, undefined, undefined, undefined);
};

Promise.prototype.reflect = function () {
    return this._then(reflect, reflect, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject, didProgress) {
    if (isDebugging() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject, didProgress) {
    var promise = this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (didFulfill, didReject) {
    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
};

Promise.prototype.isCancellable = function () {
    return !this.isResolved() &&
        this._cancellable();
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = function(fn) {
    var ret = new Promise(INTERNAL);
    var result = tryCatch(fn)(nodebackForPromise(ret));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true, true);
    }
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.defer = Promise.pending = function () {
    var promise = new Promise(INTERNAL);
    return new PromiseResolver(promise);
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        var val = ret;
        ret = new Promise(INTERNAL);
        ret._fulfillUnchecked(val);
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var prev = async._schedule;
    async._schedule = fn;
    return prev;
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    didProgress,
    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var ret = haveInternalData ? internalData : new Promise(INTERNAL);

    if (!haveInternalData) {
        ret._propagateFrom(this, 4 | 1);
        ret._captureStackTrace();
    }

    var target = this._target();
    if (target !== this) {
        if (receiver === undefined) receiver = this._boundTo;
        if (!haveInternalData) ret._setIsMigrated();
    }

    var callbackIndex =
        target._addCallbacks(didFulfill, didReject, didProgress, ret, receiver);

    if (target._isResolved() && !target._isSettlePromisesQueued()) {
        async.invoke(
            target._settlePromiseAtPostResolution, target, callbackIndex);
    }

    return ret;
};

Promise.prototype._settlePromiseAtPostResolution = function (index) {
    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
    this._settlePromiseAt(index);
};

Promise.prototype._length = function () {
    return this._bitField & 131071;
};

Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
    return (this._bitField & 939524096) > 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 536870912) === 536870912;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -131072) |
        (len & 131071);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 536870912;
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 33554432;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 33554432) > 0;
};

Promise.prototype._cancellable = function () {
    return (this._bitField & 67108864) > 0;
};

Promise.prototype._setCancellable = function () {
    this._bitField = this._bitField | 67108864;
};

Promise.prototype._unsetCancellable = function () {
    this._bitField = this._bitField & (~67108864);
};

Promise.prototype._setIsMigrated = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._unsetIsMigrated = function () {
    this._bitField = this._bitField & (~4194304);
};

Promise.prototype._isMigrated = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0
        ? this._receiver0
        : this[
            index * 5 - 5 + 4];
    if (ret === undefined && this._isBound()) {
        return this._boundTo;
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return index === 0
        ? this._promise0
        : this[index * 5 - 5 + 3];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return index === 0
        ? this._fulfillmentHandler0
        : this[index * 5 - 5 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return index === 0
        ? this._rejectionHandler0
        : this[index * 5 - 5 + 1];
};

Promise.prototype._migrateCallbacks = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var progress = follower._progressHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (promise instanceof Promise) promise._setIsMigrated();
    this._addCallbacks(fulfill, reject, progress, promise, receiver);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    progress,
    promise,
    receiver
) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        if (receiver !== undefined) this._receiver0 = receiver;
        if (typeof fulfill === "function" && !this._isCarryingStackTrace())
            this._fulfillmentHandler0 = fulfill;
        if (typeof reject === "function") this._rejectionHandler0 = reject;
        if (typeof progress === "function") this._progressHandler0 = progress;
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promise;
        this[base + 4] = receiver;
        if (typeof fulfill === "function")
            this[base + 0] = fulfill;
        if (typeof reject === "function")
            this[base + 1] = reject;
        if (typeof progress === "function")
            this[base + 2] = progress;
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }
    if (index === 0) {
        this._promise0 = promiseSlotValue;
        this._receiver0 = receiver;
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promiseSlotValue;
        this[base + 4] = receiver;
    }
    this._setLength(index + 1);
};

Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
    this._setProxyHandlers(promiseArray, index);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false, true);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    var propagationFlags = 1 | (shouldBind ? 4 : 0);
    this._propagateFrom(maybePromise, propagationFlags);
    var promise = maybePromise._target();
    if (promise._isPending()) {
        var len = this._length();
        for (var i = 0; i < len; ++i) {
            promise._migrateCallbacks(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (promise._isFulfilled()) {
        this._fulfillUnchecked(promise._value());
    } else {
        this._rejectUnchecked(promise._reason(),
            promise._getCarriedStackTrace());
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
    if (!shouldNotMarkOriginatingFromRejection) {
        util.markAsOriginatingFromRejection(reason);
    }
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason, hasStack ? undefined : trace);
};

Promise.prototype._resolveFromResolver = function (resolver) {
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = tryCatch(resolver)(function(value) {
        if (promise === null) return;
        promise._resolveCallback(value);
        promise = null;
    }, function (reason) {
        if (promise === null) return;
        promise._rejectCallback(reason, synchronous);
        promise = null;
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined && r === errorObj && promise !== null) {
        promise._rejectCallback(r.e, true, true);
        promise = null;
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    if (promise._isRejected()) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY && !this._isRejected()) {
        x = tryCatch(handler).apply(this._boundTo, value);
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    promise._popContext();

    if (x === errorObj || x === promise || x === NEXT_FILTER) {
        var err = x === promise ? makeSelfResolutionError() : x.e;
        promise._rejectCallback(err, false, true);
    } else {
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._cleanValues = function () {
    if (this._cancellable()) {
        this._cancellationParent = undefined;
    }
};

Promise.prototype._propagateFrom = function (parent, flags) {
    if ((flags & 1) > 0 && parent._cancellable()) {
        this._setCancellable();
        this._cancellationParent = parent;
    }
    if ((flags & 4) > 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
};

Promise.prototype._fulfill = function (value) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._fulfillUnchecked(value);
};

Promise.prototype._reject = function (reason, carriedStackTrace) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._rejectUnchecked(reason, carriedStackTrace);
};

Promise.prototype._settlePromiseAt = function (index) {
    var promise = this._promiseAt(index);
    var isPromise = promise instanceof Promise;

    if (isPromise && promise._isMigrated()) {
        promise._unsetIsMigrated();
        return async.invoke(this._settlePromiseAt, this, index);
    }
    var handler = this._isFulfilled()
        ? this._fulfillmentHandlerAt(index)
        : this._rejectionHandlerAt(index);

    var carriedStackTrace =
        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
    var value = this._settledValue;
    var receiver = this._receiverAt(index);


    this._clearCallbackDataAtIndex(index);

    if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof PromiseArray) {
        if (!receiver._isResolved()) {
            if (this._isFulfilled()) {
                receiver._promiseFulfilled(value, promise);
            }
            else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (this._isFulfilled()) {
            promise._fulfill(value);
        } else {
            promise._reject(value, carriedStackTrace);
        }
    }

    if (index >= 4 && (index & 31) === 4)
        async.invokeLater(this._setLength, this, 0);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    if (index === 0) {
        if (!this._isCarryingStackTrace()) {
            this._fulfillmentHandler0 = undefined;
        }
        this._rejectionHandler0 =
        this._progressHandler0 =
        this._receiver0 =
        this._promise0 = undefined;
    } else {
        var base = index * 5 - 5;
        this[base + 3] =
        this[base + 4] =
        this[base + 0] =
        this[base + 1] =
        this[base + 2] = undefined;
    }
};

Promise.prototype._isSettlePromisesQueued = function () {
    return (this._bitField &
            -1073741824) === -1073741824;
};

Promise.prototype._setSettlePromisesQueued = function () {
    this._bitField = this._bitField | -1073741824;
};

Promise.prototype._unsetSettlePromisesQueued = function () {
    this._bitField = this._bitField & (~-1073741824);
};

Promise.prototype._queueSettlePromises = function() {
    async.settlePromises(this);
    this._setSettlePromisesQueued();
};

Promise.prototype._fulfillUnchecked = function (value) {
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err, undefined);
    }
    this._setFulfilled();
    this._settledValue = value;
    this._cleanValues();

    if (this._length() > 0) {
        this._queueSettlePromises();
    }
};

Promise.prototype._rejectUncheckedCheckError = function (reason) {
    var trace = util.ensureErrorObject(reason);
    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
};

Promise.prototype._rejectUnchecked = function (reason, trace) {
    if (reason === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err);
    }
    this._setRejected();
    this._settledValue = reason;
    this._cleanValues();

    if (this._isFinal()) {
        async.throwLater(function(e) {
            if ("stack" in e) {
                async.invokeFirst(
                    CapturedTrace.unhandledRejection, undefined, e);
            }
            throw e;
        }, trace === undefined ? reason : trace);
        return;
    }

    if (trace !== undefined && trace !== reason) {
        this._setCarriedStackTrace(trace);
    }

    if (this._length() > 0) {
        this._queueSettlePromises();
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._settlePromises = function () {
    this._unsetSettlePromisesQueued();
    var len = this._length();
    for (var i = 0; i < len; i++) {
        this._settlePromiseAt(i);
    }
};

Promise._makeSelfResolutionError = makeSelfResolutionError;
_dereq_("./progress.js")(Promise, PromiseArray);
_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
_dereq_("./direct_resolve.js")(Promise);
_dereq_("./synchronous_inspection.js")(Promise);
_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
Promise.Promise = Promise;
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./cancel.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
_dereq_('./nodeify.js')(Promise);
_dereq_('./call_get.js')(Promise);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./settle.js')(Promise, PromiseArray);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./timers.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._progressHandler0 = value;                                         
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
        p._settledValue = value;                                             
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
    return Promise;                                                          

};

},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection) {
var util = _dereq_("./util.js");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    var parent;
    if (values instanceof Promise) {
        parent = values;
        promise._propagateFrom(parent, 1 | 4);
    }
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        this._values = values;
        if (values._isFulfilled()) {
            values = values._value();
            if (!isArray(values)) {
                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
                this.__hardReject__(err);
                return;
            }
        } else if (values._isPending()) {
            values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
            return;
        } else {
            this._reject(values._reason());
            return;
        }
    } else if (!isArray(values)) {
        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var promise = this._promise;
    for (var i = 0; i < len; ++i) {
        var isResolved = this._isResolved();
        var maybePromise = tryConvertToPromise(values[i], promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (isResolved) {
                maybePromise._unsetRejectionIsUnhandled();
            } else if (maybePromise._isPending()) {
                maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                this._promiseFulfilled(maybePromise._value(), i);
            } else {
                this._promiseRejected(maybePromise._reason(), i);
            }
        } else if (!isResolved) {
            this._promiseFulfilled(maybePromise, i);
        }
    }
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype.__hardReject__ =
PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false, true);
};

PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
    this._promise._progress({
        index: index,
        value: progressValue
    });
};


PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

PromiseArray.prototype._promiseRejected = function (reason, index) {
    this._totalResolved++;
    this._reject(reason);
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util.js":38}],25:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors.js");
var TimeoutError = errors.TimeoutError;
var OperationalError = errors.OperationalError;
var haveGetters = util.haveGetters;
var es5 = _dereq_("./es5.js");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise) {
    return function(err, value) {
        if (promise === null) return;

        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (arguments.length > 2) {
            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
            promise._fulfill(args);
        } else {
            promise._fulfill(value);
        }

        promise = null;
    };
}


var PromiseResolver;
if (!haveGetters) {
    PromiseResolver = function (promise) {
        this.promise = promise;
        this.asCallback = nodebackForPromise(promise);
        this.callback = this.asCallback;
    };
}
else {
    PromiseResolver = function (promise) {
        this.promise = promise;
    };
}
if (haveGetters) {
    var prop = {
        get: function() {
            return nodebackForPromise(this.promise);
        }
    };
    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
}

PromiseResolver._nodebackForPromise = nodebackForPromise;

PromiseResolver.prototype.toString = function () {
    return "[object PromiseResolver]";
};

PromiseResolver.prototype.resolve =
PromiseResolver.prototype.fulfill = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._resolveCallback(value);
};

PromiseResolver.prototype.reject = function (reason) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._rejectCallback(reason);
};

PromiseResolver.prototype.progress = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._progress(value);
};

PromiseResolver.prototype.cancel = function (err) {
    this.promise.cancel(err);
};

PromiseResolver.prototype.timeout = function () {
    this.reject(new TimeoutError("timeout"));
};

PromiseResolver.prototype.isResolved = function () {
    return this.promise.isResolved();
};

PromiseResolver.prototype.toJSON = function () {
    return this.promise.toJSON();
};

module.exports = PromiseResolver;

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util.js");
var nodebackForPromise = _dereq_("./promise_resolver.js")
    ._nodebackForPromise;
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyPropsPattern =
    /^(?:length|name|arguments|caller|callee|prototype|__isPromisified__)$/;
var defaultFilter = function(name, func) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        !util.isClass(func);
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) { var parameterCount, parameterDeclaration, argumentSequence, switchCaseArgumentOrder; }

function makeNodePromisifiedClosure(callback, receiver, _, fn) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        return promise;
    }
    promisified.__isPromisified__ = true;
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        obj[promisifiedKey] = promisifier === makeNodePromisified
                ? makeNodePromisified(key, THIS, key, fn, suffix)
                : promisifier(fn, function() {
                    return makeNodePromisified(key, THIS, key, fn, suffix);
                });
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver) {
    return makeNodePromisified(callback, receiver, undefined, callback);
}

Promise.promisify = function (fn, receiver) {
    if (typeof fn !== "function") {
        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    if (isPromisified(fn)) {
        return fn;
    }
    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
    }
    options = Object(options);
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier);
            promisifyAll(value, suffix, filter, promisifier);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier);
};
};


},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var isObject = util.isObject;
var es5 = _dereq_("./es5.js");

function PropertiesPromiseArray(obj) {
    var keys = es5.keys(obj);
    var len = keys.length;
    var values = new Array(len * 2);
    for (var i = 0; i < len; ++i) {
        var key = keys[i];
        values[i] = obj[key];
        values[i + len] = key;
    }
    this.constructor$(values);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {
    this._init$(undefined, -3) ;
};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val = {};
        var keyOffset = this.length();
        for (var i = 0, len = this.length(); i < len; ++i) {
            val[this._values[i + keyOffset]] = this._values[i];
        }
        this._resolve(val);
    }
};

PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
    this._promise._progress({
        key: this._values[index + this.length()],
        value: value
    });
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 4);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype._unshiftOne = function(value) {
    var capacity = this._capacity;
    this._checkCapacity(this.length() + 1);
    var front = this._front;
    var i = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = value;
    this._front = i;
    this._length = this.length() + 1;
};

Queue.prototype.unshift = function(fn, receiver, arg) {
    this._unshiftOne(arg);
    this._unshiftOne(receiver);
    this._unshiftOne(fn);
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],29:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var isArray = _dereq_("./util.js").isArray;

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else if (!isArray(promises)) {
        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 4 | 1);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util.js":38}],30:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
function ReductionPromiseArray(promises, fn, accum, _each) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    this._preservedValues = _each === INTERNAL ? [] : null;
    this._zerothIsAccum = (accum === undefined);
    this._gotAccum = false;
    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
    this._valuesPhase = undefined;
    var maybePromise = tryConvertToPromise(accum, this._promise);
    var rejected = false;
    var isPromise = maybePromise instanceof Promise;
    if (isPromise) {
        maybePromise = maybePromise._target();
        if (maybePromise._isPending()) {
            maybePromise._proxyPromiseArray(this, -1);
        } else if (maybePromise._isFulfilled()) {
            accum = maybePromise._value();
            this._gotAccum = true;
        } else {
            this._reject(maybePromise._reason());
            rejected = true;
        }
    }
    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
    this._callback = fn;
    this._accum = accum;
    if (!rejected) async.invoke(init, this, undefined);
}
function init() {
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._init = function () {};

ReductionPromiseArray.prototype._resolveEmptyArray = function () {
    if (this._gotAccum || this._zerothIsAccum) {
        this._resolve(this._preservedValues !== null
                        ? [] : this._accum);
    }
};

ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    values[index] = value;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var isEach = preservedValues !== null;
    var gotAccum = this._gotAccum;
    var valuesPhase = this._valuesPhase;
    var valuesPhaseIndex;
    if (!valuesPhase) {
        valuesPhase = this._valuesPhase = new Array(length);
        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
            valuesPhase[valuesPhaseIndex] = 0;
        }
    }
    valuesPhaseIndex = valuesPhase[index];

    if (index === 0 && this._zerothIsAccum) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
        valuesPhase[index] = ((valuesPhaseIndex === 0)
            ? 1 : 2);
    } else if (index === -1) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
    } else {
        if (valuesPhaseIndex === 0) {
            valuesPhase[index] = 1;
        } else {
            valuesPhase[index] = 2;
            this._accum = value;
        }
    }
    if (!gotAccum) return;

    var callback = this._callback;
    var receiver = this._promise._boundTo;
    var ret;

    for (var i = this._reducingIndex; i < length; ++i) {
        valuesPhaseIndex = valuesPhase[i];
        if (valuesPhaseIndex === 2) {
            this._reducingIndex = i + 1;
            continue;
        }
        if (valuesPhaseIndex !== 1) return;
        value = values[i];
        this._promise._pushContext();
        if (isEach) {
            preservedValues.push(value);
            ret = tryCatch(callback).call(receiver, value, i, length);
        }
        else {
            ret = tryCatch(callback)
                .call(receiver, this._accum, value, i, length);
        }
        this._promise._popContext();

        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                valuesPhase[i] = 4;
                return maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }

        this._reducingIndex = i + 1;
        this._accum = ret;
    }

    this._resolve(isEach ? preservedValues : this._accum);
};

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};
};

},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
"use strict";
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
};
if (_dereq_("./util.js").isNode) {
    var version = process.versions.node.split(".").map(Number);
    schedule = (version[0] === 0 && version[1] > 10) || (version[0] > 0)
        ? global.setImmediate : process.nextTick;

    if (!schedule) {
        if (typeof setImmediate !== "undefined") {
            schedule = setImmediate;
        } else if (typeof setTimeout !== "undefined") {
            schedule = setTimeout;
        } else {
            schedule = noAsyncScheduler;
        }
    }
} else if (typeof MutationObserver !== "undefined") {
    schedule = function(fn) {
        var div = document.createElement("div");
        var observer = new MutationObserver(fn);
        observer.observe(div, {attributes: true});
        return function() { div.classList.toggle("foo"); };
    };
    schedule.isStatic = true;
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util.js":38}],32:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util.js");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 268435456;
    ret._settledValue = value;
    this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 134217728;
    ret._settledValue = reason;
    this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return new SettledPromiseArray(this).promise();
};
};

},{"./util.js":38}],33:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util.js");
var RangeError = _dereq_("./errors.js").RangeError;
var AggregateError = _dereq_("./errors.js").AggregateError;
var isArray = util.isArray;


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
    }

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            e.push(this._values[i]);
        }
        this._reject(e);
    }
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValue = promise._settledValue;
    }
    else {
        this._bitField = 0;
        this._settledValue = undefined;
    }
}

PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.isFulfilled =
Promise.prototype._isFulfilled = function () {
    return (this._bitField & 268435456) > 0;
};

PromiseInspection.prototype.isRejected =
Promise.prototype._isRejected = function () {
    return (this._bitField & 134217728) > 0;
};

PromiseInspection.prototype.isPending =
Promise.prototype._isPending = function () {
    return (this._bitField & 402653184) === 0;
};

PromiseInspection.prototype.isResolved =
Promise.prototype._isResolved = function () {
    return (this._bitField & 402653184) > 0;
};

Promise.prototype.isPending = function() {
    return this._target()._isPending();
};

Promise.prototype.isRejected = function() {
    return this._target()._isRejected();
};

Promise.prototype.isFulfilled = function() {
    return this._target()._isFulfilled();
};

Promise.prototype.isResolved = function() {
    return this._target()._isResolved();
};

Promise.prototype._value = function() {
    return this._settledValue;
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue;
};

Promise.prototype.value = function() {
    var target = this._target();
    if (!target.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return target._settledValue;
};

Promise.prototype.reason = function() {
    var target = this._target();
    if (!target.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    target._unsetRejectionIsUnhandled();
    return target._settledValue;
};


Promise.PromiseInspection = PromiseInspection;
};

},{}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) {
            return obj;
        }
        else if (isAnyBluebirdPromise(obj)) {
            var ret = new Promise(INTERNAL);
            obj._then(
                ret._fulfillUnchecked,
                ret._rejectUncheckedCheckError,
                ret._progressUnchecked,
                ret,
                null
            );
            return ret;
        }
        var then = util.tryCatch(getThen)(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function getThen(obj) {
    return obj.then;
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    return hasProp.call(obj, "_promise0");
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x,
                                        resolveFromThenable,
                                        rejectFromThenable,
                                        progressFromThenable);
    synchronous = false;
    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolveFromThenable(value) {
        if (!promise) return;
        if (x === value) {
            promise._rejectCallback(
                Promise._makeSelfResolutionError(), false, true);
        } else {
            promise._resolveCallback(value);
        }
        promise = null;
    }

    function rejectFromThenable(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }

    function progressFromThenable(value) {
        if (!promise) return;
        if (typeof promise._progress === "function") {
            promise._progress(value);
        }
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util.js":38}],36:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var TimeoutError = Promise.TimeoutError;

var afterTimeout = function (promise, message) {
    if (!promise.isPending()) return;
    if (typeof message !== "string") {
        message = "operation timed out";
    }
    var err = new TimeoutError(message);
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._cancel(err);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (value, ms) {
    if (ms === undefined) {
        ms = value;
        value = undefined;
        var ret = new Promise(INTERNAL);
        setTimeout(function() { ret._fulfill(); }, ms);
        return ret;
    }
    ms = +ms;
    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
};

Promise.prototype.delay = function (ms) {
    return delay(this, ms);
};

function successClear(value) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    return value;
}

function failureClear(reason) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret = this.then().cancellable();
    ret._cancellationParent = this;
    var handle = setTimeout(function timeoutTimeout() {
        afterTimeout(ret, message);
    }, ms);
    return ret._then(successClear, failureClear, undefined, handle, undefined);
};

};

},{"./util.js":38}],37:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext) {
    var TypeError = _dereq_("./errors.js").TypeError;
    var inherits = _dereq_("./util.js").inherits;
    var PromiseInspection = Promise.PromiseInspection;

    function inspectionMapper(inspections) {
        var len = inspections.length;
        for (var i = 0; i < len; ++i) {
            var inspection = inspections[i];
            if (inspection.isRejected()) {
                return Promise.reject(inspection.error());
            }
            inspections[i] = inspection._settledValue;
        }
        return inspections;
    }

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = Promise.defer();
        function iterator() {
            if (i >= len) return ret.resolve();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret.promise;
    }

    function disposerSuccess(value) {
        var inspection = new PromiseInspection();
        inspection._settledValue = value;
        inspection._bitField = 268435456;
        return dispose(this, inspection).thenReturn(value);
    }

    function disposerFail(reason) {
        var inspection = new PromiseInspection();
        inspection._settledValue = reason;
        inspection._bitField = 134217728;
        return dispose(this, inspection).thenThrow(reason);
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return null;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== null
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
        len--;
        var resources = new Array(len);
        for (var i = 0; i < len; ++i) {
            var resource = arguments[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var promise = Promise.settle(resources)
            .then(inspectionMapper)
            .then(function(vals) {
                promise._pushContext();
                var ret;
                try {
                    ret = fn.apply(undefined, vals);
                } finally {
                    promise._popContext();
                }
                return ret;
            })
            ._then(
                disposerSuccess, disposerFail, undefined, resources, undefined);
        resources.promise = promise;
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 262144;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 262144) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~262144);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var canEvaluate = typeof navigator == "undefined";
var haveGetters = (function(){
    try {
        var o = {};
        es5.defineProperty(o, "f", {
            get: function () {
                return 3;
            }
        });
        return o.f === 3;
    }
    catch (e) {
        return false;
    }

})();

var errorObj = {e: {}};
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return !isPrimitive(value);
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}


var wrapsPrimitiveReceiver = (function() {
    return this !== "string";
}).call("string");

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    if (es5.isES5) {
        var oProto = Object.prototype;
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && obj !== oProto) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        return function(obj) {
            var ret = [];
            /*jshint forin:false */
            for (var key in obj) {
                ret.push(key);
            }
            return ret;
        };
    }

})();

function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);
            if (es5.isES5) return keys.length > 1;
            return keys.length > 0 &&
                   !(keys.length === 1 && keys[0] === "constructor");
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function f() {}
    f.prototype = obj;
    var l = 8;
    while (l--) new f();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            es5.defineProperty(to, key, es5.getDescriptor(from, key));
        }
    }
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    haveGetters: haveGetters,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    wrapsPrimitiveReceiver: wrapsPrimitiveReceiver,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]"
};
try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5.js":14}],39:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      }
      throw TypeError('Uncaught, unspecified "error" event.');
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        len = arguments.length;
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    len = arguments.length;
    args = new Array(len - 1);
    for (i = 1; i < len; i++)
      args[i - 1] = arguments[i];

    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    var m;
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  var ret;
  if (!emitter._events || !emitter._events[type])
    ret = 0;
  else if (isFunction(emitter._events[type]))
    ret = 1;
  else
    ret = emitter._events[type].length;
  return ret;
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../../node-libs-browser/node_modules/timers-browserify/main.js */ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js").setImmediate))

/***/ }),

/***/ "./node_modules/browserify-zlib/lib/binding.js":
/*!*****************************************************!*\
  !*** ./node_modules/browserify-zlib/lib/binding.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Buffer, process) {
/* eslint camelcase: "off" */

var assert = __webpack_require__(/*! assert */ "./node_modules/assert/assert.js");

var Zstream = __webpack_require__(/*! pako/lib/zlib/zstream */ "./node_modules/pako/lib/zlib/zstream.js");
var zlib_deflate = __webpack_require__(/*! pako/lib/zlib/deflate.js */ "./node_modules/pako/lib/zlib/deflate.js");
var zlib_inflate = __webpack_require__(/*! pako/lib/zlib/inflate.js */ "./node_modules/pako/lib/zlib/inflate.js");
var constants = __webpack_require__(/*! pako/lib/zlib/constants */ "./node_modules/pako/lib/zlib/constants.js");

for (var key in constants) {
  exports[key] = constants[key];
}

// zlib modes
exports.NONE = 0;
exports.DEFLATE = 1;
exports.INFLATE = 2;
exports.GZIP = 3;
exports.GUNZIP = 4;
exports.DEFLATERAW = 5;
exports.INFLATERAW = 6;
exports.UNZIP = 7;

var GZIP_HEADER_ID1 = 0x1f;
var GZIP_HEADER_ID2 = 0x8b;

/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */
function Zlib(mode) {
  if (typeof mode !== 'number' || mode < exports.DEFLATE || mode > exports.UNZIP) {
    throw new TypeError('Bad argument');
  }

  this.dictionary = null;
  this.err = 0;
  this.flush = 0;
  this.init_done = false;
  this.level = 0;
  this.memLevel = 0;
  this.mode = mode;
  this.strategy = 0;
  this.windowBits = 0;
  this.write_in_progress = false;
  this.pending_close = false;
  this.gzip_id_bytes_read = 0;
}

Zlib.prototype.close = function () {
  if (this.write_in_progress) {
    this.pending_close = true;
    return;
  }

  this.pending_close = false;

  assert(this.init_done, 'close before init');
  assert(this.mode <= exports.UNZIP);

  if (this.mode === exports.DEFLATE || this.mode === exports.GZIP || this.mode === exports.DEFLATERAW) {
    zlib_deflate.deflateEnd(this.strm);
  } else if (this.mode === exports.INFLATE || this.mode === exports.GUNZIP || this.mode === exports.INFLATERAW || this.mode === exports.UNZIP) {
    zlib_inflate.inflateEnd(this.strm);
  }

  this.mode = exports.NONE;

  this.dictionary = null;
};

Zlib.prototype.write = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype.writeSync = function (flush, input, in_off, in_len, out, out_off, out_len) {
  return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};

Zlib.prototype._write = function (async, flush, input, in_off, in_len, out, out_off, out_len) {
  assert.equal(arguments.length, 8);

  assert(this.init_done, 'write before init');
  assert(this.mode !== exports.NONE, 'already finalized');
  assert.equal(false, this.write_in_progress, 'write already in progress');
  assert.equal(false, this.pending_close, 'close is pending');

  this.write_in_progress = true;

  assert.equal(false, flush === undefined, 'must provide flush value');

  this.write_in_progress = true;

  if (flush !== exports.Z_NO_FLUSH && flush !== exports.Z_PARTIAL_FLUSH && flush !== exports.Z_SYNC_FLUSH && flush !== exports.Z_FULL_FLUSH && flush !== exports.Z_FINISH && flush !== exports.Z_BLOCK) {
    throw new Error('Invalid flush value');
  }

  if (input == null) {
    input = Buffer.alloc(0);
    in_len = 0;
    in_off = 0;
  }

  this.strm.avail_in = in_len;
  this.strm.input = input;
  this.strm.next_in = in_off;
  this.strm.avail_out = out_len;
  this.strm.output = out;
  this.strm.next_out = out_off;
  this.flush = flush;

  if (!async) {
    // sync version
    this._process();

    if (this._checkError()) {
      return this._afterSync();
    }
    return;
  }

  // async version
  var self = this;
  process.nextTick(function () {
    self._process();
    self._after();
  });

  return this;
};

Zlib.prototype._afterSync = function () {
  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  return [avail_in, avail_out];
};

Zlib.prototype._process = function () {
  var next_expected_header_byte = null;

  // If the avail_out is left at 0, then it means that it ran out
  // of room.  If there was avail_out left over, then it means
  // that all of the input was consumed.
  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflate(this.strm, this.flush);
      break;
    case exports.UNZIP:
      if (this.strm.avail_in > 0) {
        next_expected_header_byte = this.strm.next_in;
      }

      switch (this.gzip_id_bytes_read) {
        case 0:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID1) {
            this.gzip_id_bytes_read = 1;
            next_expected_header_byte++;

            if (this.strm.avail_in === 1) {
              // The only available byte was already read.
              break;
            }
          } else {
            this.mode = exports.INFLATE;
            break;
          }

        // fallthrough
        case 1:
          if (next_expected_header_byte === null) {
            break;
          }

          if (this.strm.input[next_expected_header_byte] === GZIP_HEADER_ID2) {
            this.gzip_id_bytes_read = 2;
            this.mode = exports.GUNZIP;
          } else {
            // There is no actual difference between INFLATE and INFLATERAW
            // (after initialization).
            this.mode = exports.INFLATE;
          }

          break;
        default:
          throw new Error('invalid number of gzip magic number bytes read');
      }

    // fallthrough
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
      this.err = zlib_inflate.inflate(this.strm, this.flush

      // If data was encoded with dictionary
      );if (this.err === exports.Z_NEED_DICT && this.dictionary) {
        // Load it
        this.err = zlib_inflate.inflateSetDictionary(this.strm, this.dictionary);
        if (this.err === exports.Z_OK) {
          // And try to decode again
          this.err = zlib_inflate.inflate(this.strm, this.flush);
        } else if (this.err === exports.Z_DATA_ERROR) {
          // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
          // Make it possible for After() to tell a bad dictionary from bad
          // input.
          this.err = exports.Z_NEED_DICT;
        }
      }
      while (this.strm.avail_in > 0 && this.mode === exports.GUNZIP && this.err === exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00) {
        // Bytes remain in input buffer. Perhaps this is another compressed
        // member in the same archive, or just trailing garbage.
        // Trailing zero bytes are okay, though, since they are frequently
        // used for padding.

        this.reset();
        this.err = zlib_inflate.inflate(this.strm, this.flush);
      }
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }
};

Zlib.prototype._checkError = function () {
  // Acceptable error states depend on the type of zlib stream.
  switch (this.err) {
    case exports.Z_OK:
    case exports.Z_BUF_ERROR:
      if (this.strm.avail_out !== 0 && this.flush === exports.Z_FINISH) {
        this._error('unexpected end of file');
        return false;
      }
      break;
    case exports.Z_STREAM_END:
      // normal statuses, not fatal
      break;
    case exports.Z_NEED_DICT:
      if (this.dictionary == null) {
        this._error('Missing dictionary');
      } else {
        this._error('Bad dictionary');
      }
      return false;
    default:
      // something else.
      this._error('Zlib error');
      return false;
  }

  return true;
};

Zlib.prototype._after = function () {
  if (!this._checkError()) {
    return;
  }

  var avail_out = this.strm.avail_out;
  var avail_in = this.strm.avail_in;

  this.write_in_progress = false;

  // call the write() cb
  this.callback(avail_in, avail_out);

  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype._error = function (message) {
  if (this.strm.msg) {
    message = this.strm.msg;
  }
  this.onerror(message, this.err

  // no hope of rescue.
  );this.write_in_progress = false;
  if (this.pending_close) {
    this.close();
  }
};

Zlib.prototype.init = function (windowBits, level, memLevel, strategy, dictionary) {
  assert(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');

  assert(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
  assert(level >= -1 && level <= 9, 'invalid compression level');

  assert(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');

  assert(strategy === exports.Z_FILTERED || strategy === exports.Z_HUFFMAN_ONLY || strategy === exports.Z_RLE || strategy === exports.Z_FIXED || strategy === exports.Z_DEFAULT_STRATEGY, 'invalid strategy');

  this._init(level, windowBits, memLevel, strategy, dictionary);
  this._setDictionary();
};

Zlib.prototype.params = function () {
  throw new Error('deflateParams Not supported');
};

Zlib.prototype.reset = function () {
  this._reset();
  this._setDictionary();
};

Zlib.prototype._init = function (level, windowBits, memLevel, strategy, dictionary) {
  this.level = level;
  this.windowBits = windowBits;
  this.memLevel = memLevel;
  this.strategy = strategy;

  this.flush = exports.Z_NO_FLUSH;

  this.err = exports.Z_OK;

  if (this.mode === exports.GZIP || this.mode === exports.GUNZIP) {
    this.windowBits += 16;
  }

  if (this.mode === exports.UNZIP) {
    this.windowBits += 32;
  }

  if (this.mode === exports.DEFLATERAW || this.mode === exports.INFLATERAW) {
    this.windowBits = -1 * this.windowBits;
  }

  this.strm = new Zstream();

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.GZIP:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateInit2(this.strm, this.level, exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
      break;
    case exports.INFLATE:
    case exports.GUNZIP:
    case exports.INFLATERAW:
    case exports.UNZIP:
      this.err = zlib_inflate.inflateInit2(this.strm, this.windowBits);
      break;
    default:
      throw new Error('Unknown mode ' + this.mode);
  }

  if (this.err !== exports.Z_OK) {
    this._error('Init error');
  }

  this.dictionary = dictionary;

  this.write_in_progress = false;
  this.init_done = true;
};

Zlib.prototype._setDictionary = function () {
  if (this.dictionary == null) {
    return;
  }

  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
      this.err = zlib_deflate.deflateSetDictionary(this.strm, this.dictionary);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to set dictionary');
  }
};

Zlib.prototype._reset = function () {
  this.err = exports.Z_OK;

  switch (this.mode) {
    case exports.DEFLATE:
    case exports.DEFLATERAW:
    case exports.GZIP:
      this.err = zlib_deflate.deflateReset(this.strm);
      break;
    case exports.INFLATE:
    case exports.INFLATERAW:
    case exports.GUNZIP:
      this.err = zlib_inflate.inflateReset(this.strm);
      break;
    default:
      break;
  }

  if (this.err !== exports.Z_OK) {
    this._error('Failed to reset stream');
  }
};

exports.Zlib = Zlib;
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/browserify-zlib/lib/index.js":
/*!***************************************************!*\
  !*** ./node_modules/browserify-zlib/lib/index.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;
var Transform = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js").Transform;
var binding = __webpack_require__(/*! ./binding */ "./node_modules/browserify-zlib/lib/binding.js");
var util = __webpack_require__(/*! util */ "./node_modules/node-libs-browser/node_modules/util/util.js");
var assert = __webpack_require__(/*! assert */ "./node_modules/assert/assert.js").ok;
var kMaxLength = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").kMaxLength;
var kRangeErrorMessage = 'Cannot create final Buffer. It would be larger ' + 'than 0x' + kMaxLength.toString(16) + ' bytes';

// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
binding.Z_MIN_WINDOWBITS = 8;
binding.Z_MAX_WINDOWBITS = 15;
binding.Z_DEFAULT_WINDOWBITS = 15;

// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
binding.Z_MIN_CHUNK = 64;
binding.Z_MAX_CHUNK = Infinity;
binding.Z_DEFAULT_CHUNK = 16 * 1024;

binding.Z_MIN_MEMLEVEL = 1;
binding.Z_MAX_MEMLEVEL = 9;
binding.Z_DEFAULT_MEMLEVEL = 8;

binding.Z_MIN_LEVEL = -1;
binding.Z_MAX_LEVEL = 9;
binding.Z_DEFAULT_LEVEL = binding.Z_DEFAULT_COMPRESSION;

// expose all the zlib constants
var bkeys = Object.keys(binding);
for (var bk = 0; bk < bkeys.length; bk++) {
  var bkey = bkeys[bk];
  if (bkey.match(/^Z/)) {
    Object.defineProperty(exports, bkey, {
      enumerable: true, value: binding[bkey], writable: false
    });
  }
}

// translation table for return codes.
var codes = {
  Z_OK: binding.Z_OK,
  Z_STREAM_END: binding.Z_STREAM_END,
  Z_NEED_DICT: binding.Z_NEED_DICT,
  Z_ERRNO: binding.Z_ERRNO,
  Z_STREAM_ERROR: binding.Z_STREAM_ERROR,
  Z_DATA_ERROR: binding.Z_DATA_ERROR,
  Z_MEM_ERROR: binding.Z_MEM_ERROR,
  Z_BUF_ERROR: binding.Z_BUF_ERROR,
  Z_VERSION_ERROR: binding.Z_VERSION_ERROR
};

var ckeys = Object.keys(codes);
for (var ck = 0; ck < ckeys.length; ck++) {
  var ckey = ckeys[ck];
  codes[codes[ckey]] = ckey;
}

Object.defineProperty(exports, 'codes', {
  enumerable: true, value: Object.freeze(codes), writable: false
});

exports.Deflate = Deflate;
exports.Inflate = Inflate;
exports.Gzip = Gzip;
exports.Gunzip = Gunzip;
exports.DeflateRaw = DeflateRaw;
exports.InflateRaw = InflateRaw;
exports.Unzip = Unzip;

exports.createDeflate = function (o) {
  return new Deflate(o);
};

exports.createInflate = function (o) {
  return new Inflate(o);
};

exports.createDeflateRaw = function (o) {
  return new DeflateRaw(o);
};

exports.createInflateRaw = function (o) {
  return new InflateRaw(o);
};

exports.createGzip = function (o) {
  return new Gzip(o);
};

exports.createGunzip = function (o) {
  return new Gunzip(o);
};

exports.createUnzip = function (o) {
  return new Unzip(o);
};

// Convenience methods.
// compress/decompress a string or buffer in one step.
exports.deflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Deflate(opts), buffer, callback);
};

exports.deflateSync = function (buffer, opts) {
  return zlibBufferSync(new Deflate(opts), buffer);
};

exports.gzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gzip(opts), buffer, callback);
};

exports.gzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gzip(opts), buffer);
};

exports.deflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new DeflateRaw(opts), buffer, callback);
};

exports.deflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new DeflateRaw(opts), buffer);
};

exports.unzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Unzip(opts), buffer, callback);
};

exports.unzipSync = function (buffer, opts) {
  return zlibBufferSync(new Unzip(opts), buffer);
};

exports.inflate = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Inflate(opts), buffer, callback);
};

exports.inflateSync = function (buffer, opts) {
  return zlibBufferSync(new Inflate(opts), buffer);
};

exports.gunzip = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new Gunzip(opts), buffer, callback);
};

exports.gunzipSync = function (buffer, opts) {
  return zlibBufferSync(new Gunzip(opts), buffer);
};

exports.inflateRaw = function (buffer, opts, callback) {
  if (typeof opts === 'function') {
    callback = opts;
    opts = {};
  }
  return zlibBuffer(new InflateRaw(opts), buffer, callback);
};

exports.inflateRawSync = function (buffer, opts) {
  return zlibBufferSync(new InflateRaw(opts), buffer);
};

function zlibBuffer(engine, buffer, callback) {
  var buffers = [];
  var nread = 0;

  engine.on('error', onError);
  engine.on('end', onEnd);

  engine.end(buffer);
  flow();

  function flow() {
    var chunk;
    while (null !== (chunk = engine.read())) {
      buffers.push(chunk);
      nread += chunk.length;
    }
    engine.once('readable', flow);
  }

  function onError(err) {
    engine.removeListener('end', onEnd);
    engine.removeListener('readable', flow);
    callback(err);
  }

  function onEnd() {
    var buf;
    var err = null;

    if (nread >= kMaxLength) {
      err = new RangeError(kRangeErrorMessage);
    } else {
      buf = Buffer.concat(buffers, nread);
    }

    buffers = [];
    engine.close();
    callback(err, buf);
  }
}

function zlibBufferSync(engine, buffer) {
  if (typeof buffer === 'string') buffer = Buffer.from(buffer);

  if (!Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');

  var flushFlag = engine._finishFlushFlag;

  return engine._processChunk(buffer, flushFlag);
}

// generic zlib
// minimal 2-byte header
function Deflate(opts) {
  if (!(this instanceof Deflate)) return new Deflate(opts);
  Zlib.call(this, opts, binding.DEFLATE);
}

function Inflate(opts) {
  if (!(this instanceof Inflate)) return new Inflate(opts);
  Zlib.call(this, opts, binding.INFLATE);
}

// gzip - bigger header, same deflate compression
function Gzip(opts) {
  if (!(this instanceof Gzip)) return new Gzip(opts);
  Zlib.call(this, opts, binding.GZIP);
}

function Gunzip(opts) {
  if (!(this instanceof Gunzip)) return new Gunzip(opts);
  Zlib.call(this, opts, binding.GUNZIP);
}

// raw - no header
function DeflateRaw(opts) {
  if (!(this instanceof DeflateRaw)) return new DeflateRaw(opts);
  Zlib.call(this, opts, binding.DEFLATERAW);
}

function InflateRaw(opts) {
  if (!(this instanceof InflateRaw)) return new InflateRaw(opts);
  Zlib.call(this, opts, binding.INFLATERAW);
}

// auto-detect header.
function Unzip(opts) {
  if (!(this instanceof Unzip)) return new Unzip(opts);
  Zlib.call(this, opts, binding.UNZIP);
}

function isValidFlushFlag(flag) {
  return flag === binding.Z_NO_FLUSH || flag === binding.Z_PARTIAL_FLUSH || flag === binding.Z_SYNC_FLUSH || flag === binding.Z_FULL_FLUSH || flag === binding.Z_FINISH || flag === binding.Z_BLOCK;
}

// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.

function Zlib(opts, mode) {
  var _this = this;

  this._opts = opts = opts || {};
  this._chunkSize = opts.chunkSize || exports.Z_DEFAULT_CHUNK;

  Transform.call(this, opts);

  if (opts.flush && !isValidFlushFlag(opts.flush)) {
    throw new Error('Invalid flush flag: ' + opts.flush);
  }
  if (opts.finishFlush && !isValidFlushFlag(opts.finishFlush)) {
    throw new Error('Invalid flush flag: ' + opts.finishFlush);
  }

  this._flushFlag = opts.flush || binding.Z_NO_FLUSH;
  this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : binding.Z_FINISH;

  if (opts.chunkSize) {
    if (opts.chunkSize < exports.Z_MIN_CHUNK || opts.chunkSize > exports.Z_MAX_CHUNK) {
      throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
  }

  if (opts.windowBits) {
    if (opts.windowBits < exports.Z_MIN_WINDOWBITS || opts.windowBits > exports.Z_MAX_WINDOWBITS) {
      throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
  }

  if (opts.level) {
    if (opts.level < exports.Z_MIN_LEVEL || opts.level > exports.Z_MAX_LEVEL) {
      throw new Error('Invalid compression level: ' + opts.level);
    }
  }

  if (opts.memLevel) {
    if (opts.memLevel < exports.Z_MIN_MEMLEVEL || opts.memLevel > exports.Z_MAX_MEMLEVEL) {
      throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
  }

  if (opts.strategy) {
    if (opts.strategy != exports.Z_FILTERED && opts.strategy != exports.Z_HUFFMAN_ONLY && opts.strategy != exports.Z_RLE && opts.strategy != exports.Z_FIXED && opts.strategy != exports.Z_DEFAULT_STRATEGY) {
      throw new Error('Invalid strategy: ' + opts.strategy);
    }
  }

  if (opts.dictionary) {
    if (!Buffer.isBuffer(opts.dictionary)) {
      throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
  }

  this._handle = new binding.Zlib(mode);

  var self = this;
  this._hadError = false;
  this._handle.onerror = function (message, errno) {
    // there is no way to cleanly recover.
    // continuing only obscures problems.
    _close(self);
    self._hadError = true;

    var error = new Error(message);
    error.errno = errno;
    error.code = exports.codes[errno];
    self.emit('error', error);
  };

  var level = exports.Z_DEFAULT_COMPRESSION;
  if (typeof opts.level === 'number') level = opts.level;

  var strategy = exports.Z_DEFAULT_STRATEGY;
  if (typeof opts.strategy === 'number') strategy = opts.strategy;

  this._handle.init(opts.windowBits || exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);

  this._buffer = Buffer.allocUnsafe(this._chunkSize);
  this._offset = 0;
  this._level = level;
  this._strategy = strategy;

  this.once('end', this.close);

  Object.defineProperty(this, '_closed', {
    get: function () {
      return !_this._handle;
    },
    configurable: true,
    enumerable: true
  });
}

util.inherits(Zlib, Transform);

Zlib.prototype.params = function (level, strategy, callback) {
  if (level < exports.Z_MIN_LEVEL || level > exports.Z_MAX_LEVEL) {
    throw new RangeError('Invalid compression level: ' + level);
  }
  if (strategy != exports.Z_FILTERED && strategy != exports.Z_HUFFMAN_ONLY && strategy != exports.Z_RLE && strategy != exports.Z_FIXED && strategy != exports.Z_DEFAULT_STRATEGY) {
    throw new TypeError('Invalid strategy: ' + strategy);
  }

  if (this._level !== level || this._strategy !== strategy) {
    var self = this;
    this.flush(binding.Z_SYNC_FLUSH, function () {
      assert(self._handle, 'zlib binding closed');
      self._handle.params(level, strategy);
      if (!self._hadError) {
        self._level = level;
        self._strategy = strategy;
        if (callback) callback();
      }
    });
  } else {
    process.nextTick(callback);
  }
};

Zlib.prototype.reset = function () {
  assert(this._handle, 'zlib binding closed');
  return this._handle.reset();
};

// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
Zlib.prototype._flush = function (callback) {
  this._transform(Buffer.alloc(0), '', callback);
};

Zlib.prototype.flush = function (kind, callback) {
  var _this2 = this;

  var ws = this._writableState;

  if (typeof kind === 'function' || kind === undefined && !callback) {
    callback = kind;
    kind = binding.Z_FULL_FLUSH;
  }

  if (ws.ended) {
    if (callback) process.nextTick(callback);
  } else if (ws.ending) {
    if (callback) this.once('end', callback);
  } else if (ws.needDrain) {
    if (callback) {
      this.once('drain', function () {
        return _this2.flush(kind, callback);
      });
    }
  } else {
    this._flushFlag = kind;
    this.write(Buffer.alloc(0), '', callback);
  }
};

Zlib.prototype.close = function (callback) {
  _close(this, callback);
  process.nextTick(emitCloseNT, this);
};

function _close(engine, callback) {
  if (callback) process.nextTick(callback);

  // Caller may invoke .close after a zlib error (which will null _handle).
  if (!engine._handle) return;

  engine._handle.close();
  engine._handle = null;
}

function emitCloseNT(self) {
  self.emit('close');
}

Zlib.prototype._transform = function (chunk, encoding, cb) {
  var flushFlag;
  var ws = this._writableState;
  var ending = ws.ending || ws.ended;
  var last = ending && (!chunk || ws.length === chunk.length);

  if (chunk !== null && !Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));

  if (!this._handle) return cb(new Error('zlib binding closed'));

  // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
  // (or whatever flag was provided using opts.finishFlush).
  // If it's explicitly flushing at some other time, then we use
  // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
  // goodness.
  if (last) flushFlag = this._finishFlushFlag;else {
    flushFlag = this._flushFlag;
    // once we've flushed the last of the queue, stop flushing and
    // go back to the normal behavior.
    if (chunk.length >= ws.length) {
      this._flushFlag = this._opts.flush || binding.Z_NO_FLUSH;
    }
  }

  this._processChunk(chunk, flushFlag, cb);
};

Zlib.prototype._processChunk = function (chunk, flushFlag, cb) {
  var availInBefore = chunk && chunk.length;
  var availOutBefore = this._chunkSize - this._offset;
  var inOff = 0;

  var self = this;

  var async = typeof cb === 'function';

  if (!async) {
    var buffers = [];
    var nread = 0;

    var error;
    this.on('error', function (er) {
      error = er;
    });

    assert(this._handle, 'zlib binding closed');
    do {
      var res = this._handle.writeSync(flushFlag, chunk, // in
      inOff, // in_off
      availInBefore, // in_len
      this._buffer, // out
      this._offset, //out_off
      availOutBefore); // out_len
    } while (!this._hadError && callback(res[0], res[1]));

    if (this._hadError) {
      throw error;
    }

    if (nread >= kMaxLength) {
      _close(this);
      throw new RangeError(kRangeErrorMessage);
    }

    var buf = Buffer.concat(buffers, nread);
    _close(this);

    return buf;
  }

  assert(this._handle, 'zlib binding closed');
  var req = this._handle.write(flushFlag, chunk, // in
  inOff, // in_off
  availInBefore, // in_len
  this._buffer, // out
  this._offset, //out_off
  availOutBefore); // out_len

  req.buffer = chunk;
  req.callback = callback;

  function callback(availInAfter, availOutAfter) {
    // When the callback is used in an async write, the callback's
    // context is the `req` object that was created. The req object
    // is === this._handle, and that's why it's important to null
    // out the values after they are done being used. `this._handle`
    // can stay in memory longer than the callback and buffer are needed.
    if (this) {
      this.buffer = null;
      this.callback = null;
    }

    if (self._hadError) return;

    var have = availOutBefore - availOutAfter;
    assert(have >= 0, 'have should not go down');

    if (have > 0) {
      var out = self._buffer.slice(self._offset, self._offset + have);
      self._offset += have;
      // serve some output to the consumer.
      if (async) {
        self.push(out);
      } else {
        buffers.push(out);
        nread += out.length;
      }
    }

    // exhausted the output buffer, or used all the input create a new one.
    if (availOutAfter === 0 || self._offset >= self._chunkSize) {
      availOutBefore = self._chunkSize;
      self._offset = 0;
      self._buffer = Buffer.allocUnsafe(self._chunkSize);
    }

    if (availOutAfter === 0) {
      // Not actually done.  Need to reprocess.
      // Also, update the availInBefore to the availInAfter value,
      // so that if we have to hit it a third (fourth, etc.) time,
      // it'll have the correct byte counts.
      inOff += availInBefore - availInAfter;
      availInBefore = availInAfter;

      if (!async) return true;

      var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
      newReq.callback = callback; // this same function
      newReq.buffer = chunk;
      return;
    }

    if (!async) return false;

    // finished with the chunk.
    cb();
  }
};

util.inherits(Deflate, Zlib);
util.inherits(Inflate, Zlib);
util.inherits(Gzip, Zlib);
util.inherits(Gunzip, Zlib);
util.inherits(DeflateRaw, Zlib);
util.inherits(InflateRaw, Zlib);
util.inherits(Unzip, Zlib);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/clone/clone.js":
/*!*************************************!*\
  !*** ./node_modules/clone/clone.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
'use strict';

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
*/
function clone(parent, circular, depth, prototype) {
  var filter;
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    filter = circular.filter;
    circular = circular.circular
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth == 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
};
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
};
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
};
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
};
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
};
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if ( true && module.exports) {
  module.exports = clone;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer))

/***/ }),

/***/ "./node_modules/core-util-is/lib/util.js":
/*!***********************************************!*\
  !*** ./node_modules/core-util-is/lib/util.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


/***/ }),

/***/ "./node_modules/d3/d3.js":
/*!*******************************!*\
  !*** ./node_modules/d3/d3.js ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function() {
  var d3 = {
    version: "3.5.17"
  };
  var d3_arraySlice = [].slice, d3_array = function(list) {
    return d3_arraySlice.call(list);
  };
  var d3_document = this.document;
  function d3_documentElement(node) {
    return node && (node.ownerDocument || node.document || node).documentElement;
  }
  function d3_window(node) {
    return node && (node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView);
  }
  if (d3_document) {
    try {
      d3_array(d3_document.documentElement.childNodes)[0].nodeType;
    } catch (e) {
      d3_array = function(list) {
        var i = list.length, array = new Array(i);
        while (i--) array[i] = list[i];
        return array;
      };
    }
  }
  if (!Date.now) Date.now = function() {
    return +new Date();
  };
  if (d3_document) {
    try {
      d3_document.createElement("DIV").style.setProperty("opacity", 0, "");
    } catch (error) {
      var d3_element_prototype = this.Element.prototype, d3_element_setAttribute = d3_element_prototype.setAttribute, d3_element_setAttributeNS = d3_element_prototype.setAttributeNS, d3_style_prototype = this.CSSStyleDeclaration.prototype, d3_style_setProperty = d3_style_prototype.setProperty;
      d3_element_prototype.setAttribute = function(name, value) {
        d3_element_setAttribute.call(this, name, value + "");
      };
      d3_element_prototype.setAttributeNS = function(space, local, value) {
        d3_element_setAttributeNS.call(this, space, local, value + "");
      };
      d3_style_prototype.setProperty = function(name, value, priority) {
        d3_style_setProperty.call(this, name, value + "", priority);
      };
    }
  }
  d3.ascending = d3_ascending;
  function d3_ascending(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
  }
  d3.descending = function(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
  };
  d3.min = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && a > b) a = b;
    }
    return a;
  };
  d3.max = function(array, f) {
    var i = -1, n = array.length, a, b;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b > a) a = b;
    }
    return a;
  };
  d3.extent = function(array, f) {
    var i = -1, n = array.length, a, b, c;
    if (arguments.length === 1) {
      while (++i < n) if ((b = array[i]) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = array[i]) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    } else {
      while (++i < n) if ((b = f.call(array, array[i], i)) != null && b >= b) {
        a = c = b;
        break;
      }
      while (++i < n) if ((b = f.call(array, array[i], i)) != null) {
        if (a > b) a = b;
        if (c < b) c = b;
      }
    }
    return [ a, c ];
  };
  function d3_number(x) {
    return x === null ? NaN : +x;
  }
  function d3_numeric(x) {
    return !isNaN(x);
  }
  d3.sum = function(array, f) {
    var s = 0, n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = +array[i])) s += a;
    } else {
      while (++i < n) if (d3_numeric(a = +f.call(array, array[i], i))) s += a;
    }
    return s;
  };
  d3.mean = function(array, f) {
    var s = 0, n = array.length, a, i = -1, j = n;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) s += a; else --j;
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) s += a; else --j;
    }
    if (j) return s / j;
  };
  d3.quantile = function(values, p) {
    var H = (values.length - 1) * p + 1, h = Math.floor(H), v = +values[h - 1], e = H - h;
    return e ? v + e * (values[h] - v) : v;
  };
  d3.median = function(array, f) {
    var numbers = [], n = array.length, a, i = -1;
    if (arguments.length === 1) {
      while (++i < n) if (d3_numeric(a = d3_number(array[i]))) numbers.push(a);
    } else {
      while (++i < n) if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) numbers.push(a);
    }
    if (numbers.length) return d3.quantile(numbers.sort(d3_ascending), .5);
  };
  d3.variance = function(array, f) {
    var n = array.length, m = 0, a, d, s = 0, i = -1, j = 0;
    if (arguments.length === 1) {
      while (++i < n) {
        if (d3_numeric(a = d3_number(array[i]))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    } else {
      while (++i < n) {
        if (d3_numeric(a = d3_number(f.call(array, array[i], i)))) {
          d = a - m;
          m += d / ++j;
          s += d * (a - m);
        }
      }
    }
    if (j > 1) return s / (j - 1);
  };
  d3.deviation = function() {
    var v = d3.variance.apply(this, arguments);
    return v ? Math.sqrt(v) : v;
  };
  function d3_bisector(compare) {
    return {
      left: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) < 0) lo = mid + 1; else hi = mid;
        }
        return lo;
      },
      right: function(a, x, lo, hi) {
        if (arguments.length < 3) lo = 0;
        if (arguments.length < 4) hi = a.length;
        while (lo < hi) {
          var mid = lo + hi >>> 1;
          if (compare(a[mid], x) > 0) hi = mid; else lo = mid + 1;
        }
        return lo;
      }
    };
  }
  var d3_bisect = d3_bisector(d3_ascending);
  d3.bisectLeft = d3_bisect.left;
  d3.bisect = d3.bisectRight = d3_bisect.right;
  d3.bisector = function(f) {
    return d3_bisector(f.length === 1 ? function(d, x) {
      return d3_ascending(f(d), x);
    } : f);
  };
  d3.shuffle = function(array, i0, i1) {
    if ((m = arguments.length) < 3) {
      i1 = array.length;
      if (m < 2) i0 = 0;
    }
    var m = i1 - i0, t, i;
    while (m) {
      i = Math.random() * m-- | 0;
      t = array[m + i0], array[m + i0] = array[i + i0], array[i + i0] = t;
    }
    return array;
  };
  d3.permute = function(array, indexes) {
    var i = indexes.length, permutes = new Array(i);
    while (i--) permutes[i] = array[indexes[i]];
    return permutes;
  };
  d3.pairs = function(array) {
    var i = 0, n = array.length - 1, p0, p1 = array[0], pairs = new Array(n < 0 ? 0 : n);
    while (i < n) pairs[i] = [ p0 = p1, p1 = array[++i] ];
    return pairs;
  };
  d3.transpose = function(matrix) {
    if (!(n = matrix.length)) return [];
    for (var i = -1, m = d3.min(matrix, d3_transposeLength), transpose = new Array(m); ++i < m; ) {
      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n; ) {
        row[j] = matrix[j][i];
      }
    }
    return transpose;
  };
  function d3_transposeLength(d) {
    return d.length;
  }
  d3.zip = function() {
    return d3.transpose(arguments);
  };
  d3.keys = function(map) {
    var keys = [];
    for (var key in map) keys.push(key);
    return keys;
  };
  d3.values = function(map) {
    var values = [];
    for (var key in map) values.push(map[key]);
    return values;
  };
  d3.entries = function(map) {
    var entries = [];
    for (var key in map) entries.push({
      key: key,
      value: map[key]
    });
    return entries;
  };
  d3.merge = function(arrays) {
    var n = arrays.length, m, i = -1, j = 0, merged, array;
    while (++i < n) j += arrays[i].length;
    merged = new Array(j);
    while (--n >= 0) {
      array = arrays[n];
      m = array.length;
      while (--m >= 0) {
        merged[--j] = array[m];
      }
    }
    return merged;
  };
  var abs = Math.abs;
  d3.range = function(start, stop, step) {
    if (arguments.length < 3) {
      step = 1;
      if (arguments.length < 2) {
        stop = start;
        start = 0;
      }
    }
    if ((stop - start) / step === Infinity) throw new Error("infinite range");
    var range = [], k = d3_range_integerScale(abs(step)), i = -1, j;
    start *= k, stop *= k, step *= k;
    if (step < 0) while ((j = start + step * ++i) > stop) range.push(j / k); else while ((j = start + step * ++i) < stop) range.push(j / k);
    return range;
  };
  function d3_range_integerScale(x) {
    var k = 1;
    while (x * k % 1) k *= 10;
    return k;
  }
  function d3_class(ctor, properties) {
    for (var key in properties) {
      Object.defineProperty(ctor.prototype, key, {
        value: properties[key],
        enumerable: false
      });
    }
  }
  d3.map = function(object, f) {
    var map = new d3_Map();
    if (object instanceof d3_Map) {
      object.forEach(function(key, value) {
        map.set(key, value);
      });
    } else if (Array.isArray(object)) {
      var i = -1, n = object.length, o;
      if (arguments.length === 1) while (++i < n) map.set(i, object[i]); else while (++i < n) map.set(f.call(object, o = object[i], i), o);
    } else {
      for (var key in object) map.set(key, object[key]);
    }
    return map;
  };
  function d3_Map() {
    this._ = Object.create(null);
  }
  var d3_map_proto = "__proto__", d3_map_zero = "\x00";
  d3_class(d3_Map, {
    has: d3_map_has,
    get: function(key) {
      return this._[d3_map_escape(key)];
    },
    set: function(key, value) {
      return this._[d3_map_escape(key)] = value;
    },
    remove: d3_map_remove,
    keys: d3_map_keys,
    values: function() {
      var values = [];
      for (var key in this._) values.push(this._[key]);
      return values;
    },
    entries: function() {
      var entries = [];
      for (var key in this._) entries.push({
        key: d3_map_unescape(key),
        value: this._[key]
      });
      return entries;
    },
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key), this._[key]);
    }
  });
  function d3_map_escape(key) {
    return (key += "") === d3_map_proto || key[0] === d3_map_zero ? d3_map_zero + key : key;
  }
  function d3_map_unescape(key) {
    return (key += "")[0] === d3_map_zero ? key.slice(1) : key;
  }
  function d3_map_has(key) {
    return d3_map_escape(key) in this._;
  }
  function d3_map_remove(key) {
    return (key = d3_map_escape(key)) in this._ && delete this._[key];
  }
  function d3_map_keys() {
    var keys = [];
    for (var key in this._) keys.push(d3_map_unescape(key));
    return keys;
  }
  function d3_map_size() {
    var size = 0;
    for (var key in this._) ++size;
    return size;
  }
  function d3_map_empty() {
    for (var key in this._) return false;
    return true;
  }
  d3.nest = function() {
    var nest = {}, keys = [], sortKeys = [], sortValues, rollup;
    function map(mapType, array, depth) {
      if (depth >= keys.length) return rollup ? rollup.call(nest, array) : sortValues ? array.sort(sortValues) : array;
      var i = -1, n = array.length, key = keys[depth++], keyValue, object, setter, valuesByKey = new d3_Map(), values;
      while (++i < n) {
        if (values = valuesByKey.get(keyValue = key(object = array[i]))) {
          values.push(object);
        } else {
          valuesByKey.set(keyValue, [ object ]);
        }
      }
      if (mapType) {
        object = mapType();
        setter = function(keyValue, values) {
          object.set(keyValue, map(mapType, values, depth));
        };
      } else {
        object = {};
        setter = function(keyValue, values) {
          object[keyValue] = map(mapType, values, depth);
        };
      }
      valuesByKey.forEach(setter);
      return object;
    }
    function entries(map, depth) {
      if (depth >= keys.length) return map;
      var array = [], sortKey = sortKeys[depth++];
      map.forEach(function(key, keyMap) {
        array.push({
          key: key,
          values: entries(keyMap, depth)
        });
      });
      return sortKey ? array.sort(function(a, b) {
        return sortKey(a.key, b.key);
      }) : array;
    }
    nest.map = function(array, mapType) {
      return map(mapType, array, 0);
    };
    nest.entries = function(array) {
      return entries(map(d3.map, array, 0), 0);
    };
    nest.key = function(d) {
      keys.push(d);
      return nest;
    };
    nest.sortKeys = function(order) {
      sortKeys[keys.length - 1] = order;
      return nest;
    };
    nest.sortValues = function(order) {
      sortValues = order;
      return nest;
    };
    nest.rollup = function(f) {
      rollup = f;
      return nest;
    };
    return nest;
  };
  d3.set = function(array) {
    var set = new d3_Set();
    if (array) for (var i = 0, n = array.length; i < n; ++i) set.add(array[i]);
    return set;
  };
  function d3_Set() {
    this._ = Object.create(null);
  }
  d3_class(d3_Set, {
    has: d3_map_has,
    add: function(key) {
      this._[d3_map_escape(key += "")] = true;
      return key;
    },
    remove: d3_map_remove,
    values: d3_map_keys,
    size: d3_map_size,
    empty: d3_map_empty,
    forEach: function(f) {
      for (var key in this._) f.call(this, d3_map_unescape(key));
    }
  });
  d3.behavior = {};
  function d3_identity(d) {
    return d;
  }
  d3.rebind = function(target, source) {
    var i = 1, n = arguments.length, method;
    while (++i < n) target[method = arguments[i]] = d3_rebind(target, source, source[method]);
    return target;
  };
  function d3_rebind(target, source, method) {
    return function() {
      var value = method.apply(source, arguments);
      return value === source ? target : value;
    };
  }
  function d3_vendorSymbol(object, name) {
    if (name in object) return name;
    name = name.charAt(0).toUpperCase() + name.slice(1);
    for (var i = 0, n = d3_vendorPrefixes.length; i < n; ++i) {
      var prefixName = d3_vendorPrefixes[i] + name;
      if (prefixName in object) return prefixName;
    }
  }
  var d3_vendorPrefixes = [ "webkit", "ms", "moz", "Moz", "o", "O" ];
  function d3_noop() {}
  d3.dispatch = function() {
    var dispatch = new d3_dispatch(), i = -1, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    return dispatch;
  };
  function d3_dispatch() {}
  d3_dispatch.prototype.on = function(type, listener) {
    var i = type.indexOf("."), name = "";
    if (i >= 0) {
      name = type.slice(i + 1);
      type = type.slice(0, i);
    }
    if (type) return arguments.length < 2 ? this[type].on(name) : this[type].on(name, listener);
    if (arguments.length === 2) {
      if (listener == null) for (type in this) {
        if (this.hasOwnProperty(type)) this[type].on(name, null);
      }
      return this;
    }
  };
  function d3_dispatch_event(dispatch) {
    var listeners = [], listenerByName = new d3_Map();
    function event() {
      var z = listeners, i = -1, n = z.length, l;
      while (++i < n) if (l = z[i].on) l.apply(this, arguments);
      return dispatch;
    }
    event.on = function(name, listener) {
      var l = listenerByName.get(name), i;
      if (arguments.length < 2) return l && l.on;
      if (l) {
        l.on = null;
        listeners = listeners.slice(0, i = listeners.indexOf(l)).concat(listeners.slice(i + 1));
        listenerByName.remove(name);
      }
      if (listener) listeners.push(listenerByName.set(name, {
        on: listener
      }));
      return dispatch;
    };
    return event;
  }
  d3.event = null;
  function d3_eventPreventDefault() {
    d3.event.preventDefault();
  }
  function d3_eventSource() {
    var e = d3.event, s;
    while (s = e.sourceEvent) e = s;
    return e;
  }
  function d3_eventDispatch(target) {
    var dispatch = new d3_dispatch(), i = 0, n = arguments.length;
    while (++i < n) dispatch[arguments[i]] = d3_dispatch_event(dispatch);
    dispatch.of = function(thiz, argumentz) {
      return function(e1) {
        try {
          var e0 = e1.sourceEvent = d3.event;
          e1.target = target;
          d3.event = e1;
          dispatch[e1.type].apply(thiz, argumentz);
        } finally {
          d3.event = e0;
        }
      };
    };
    return dispatch;
  }
  d3.requote = function(s) {
    return s.replace(d3_requote_re, "\\$&");
  };
  var d3_requote_re = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var d3_subclass = {}.__proto__ ? function(object, prototype) {
    object.__proto__ = prototype;
  } : function(object, prototype) {
    for (var property in prototype) object[property] = prototype[property];
  };
  function d3_selection(groups) {
    d3_subclass(groups, d3_selectionPrototype);
    return groups;
  }
  var d3_select = function(s, n) {
    return n.querySelector(s);
  }, d3_selectAll = function(s, n) {
    return n.querySelectorAll(s);
  }, d3_selectMatches = function(n, s) {
    var d3_selectMatcher = n.matches || n[d3_vendorSymbol(n, "matchesSelector")];
    d3_selectMatches = function(n, s) {
      return d3_selectMatcher.call(n, s);
    };
    return d3_selectMatches(n, s);
  };
  if (typeof Sizzle === "function") {
    d3_select = function(s, n) {
      return Sizzle(s, n)[0] || null;
    };
    d3_selectAll = Sizzle;
    d3_selectMatches = Sizzle.matchesSelector;
  }
  d3.selection = function() {
    return d3.select(d3_document.documentElement);
  };
  var d3_selectionPrototype = d3.selection.prototype = [];
  d3_selectionPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, group, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(subnode = selector.call(node, node.__data__, i, j));
          if (subnode && "__data__" in node) subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selector(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_select(selector, this);
    };
  }
  d3_selectionPrototype.selectAll = function(selector) {
    var subgroups = [], subgroup, node;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroups.push(subgroup = d3_array(selector.call(node, node.__data__, i, j)));
          subgroup.parentNode = node;
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_selectorAll(selector) {
    return typeof selector === "function" ? selector : function() {
      return d3_selectAll(selector, this);
    };
  }
  var d3_nsXhtml = "http://www.w3.org/1999/xhtml";
  var d3_nsPrefix = {
    svg: "http://www.w3.org/2000/svg",
    xhtml: d3_nsXhtml,
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace",
    xmlns: "http://www.w3.org/2000/xmlns/"
  };
  d3.ns = {
    prefix: d3_nsPrefix,
    qualify: function(name) {
      var i = name.indexOf(":"), prefix = name;
      if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
      return d3_nsPrefix.hasOwnProperty(prefix) ? {
        space: d3_nsPrefix[prefix],
        local: name
      } : name;
    }
  };
  d3_selectionPrototype.attr = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node();
        name = d3.ns.qualify(name);
        return name.local ? node.getAttributeNS(name.space, name.local) : node.getAttribute(name);
      }
      for (value in name) this.each(d3_selection_attr(value, name[value]));
      return this;
    }
    return this.each(d3_selection_attr(name, value));
  };
  function d3_selection_attr(name, value) {
    name = d3.ns.qualify(name);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrConstant() {
      this.setAttribute(name, value);
    }
    function attrConstantNS() {
      this.setAttributeNS(name.space, name.local, value);
    }
    function attrFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttribute(name); else this.setAttribute(name, x);
    }
    function attrFunctionNS() {
      var x = value.apply(this, arguments);
      if (x == null) this.removeAttributeNS(name.space, name.local); else this.setAttributeNS(name.space, name.local, x);
    }
    return value == null ? name.local ? attrNullNS : attrNull : typeof value === "function" ? name.local ? attrFunctionNS : attrFunction : name.local ? attrConstantNS : attrConstant;
  }
  function d3_collapse(s) {
    return s.trim().replace(/\s+/g, " ");
  }
  d3_selectionPrototype.classed = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") {
        var node = this.node(), n = (name = d3_selection_classes(name)).length, i = -1;
        if (value = node.classList) {
          while (++i < n) if (!value.contains(name[i])) return false;
        } else {
          value = node.getAttribute("class");
          while (++i < n) if (!d3_selection_classedRe(name[i]).test(value)) return false;
        }
        return true;
      }
      for (value in name) this.each(d3_selection_classed(value, name[value]));
      return this;
    }
    return this.each(d3_selection_classed(name, value));
  };
  function d3_selection_classedRe(name) {
    return new RegExp("(?:^|\\s+)" + d3.requote(name) + "(?:\\s+|$)", "g");
  }
  function d3_selection_classes(name) {
    return (name + "").trim().split(/^|\s+/);
  }
  function d3_selection_classed(name, value) {
    name = d3_selection_classes(name).map(d3_selection_classedName);
    var n = name.length;
    function classedConstant() {
      var i = -1;
      while (++i < n) name[i](this, value);
    }
    function classedFunction() {
      var i = -1, x = value.apply(this, arguments);
      while (++i < n) name[i](this, x);
    }
    return typeof value === "function" ? classedFunction : classedConstant;
  }
  function d3_selection_classedName(name) {
    var re = d3_selection_classedRe(name);
    return function(node, value) {
      if (c = node.classList) return value ? c.add(name) : c.remove(name);
      var c = node.getAttribute("class") || "";
      if (value) {
        re.lastIndex = 0;
        if (!re.test(c)) node.setAttribute("class", d3_collapse(c + " " + name));
      } else {
        node.setAttribute("class", d3_collapse(c.replace(re, " ")));
      }
    };
  }
  d3_selectionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.each(d3_selection_style(priority, name[priority], value));
        return this;
      }
      if (n < 2) {
        var node = this.node();
        return d3_window(node).getComputedStyle(node, null).getPropertyValue(name);
      }
      priority = "";
    }
    return this.each(d3_selection_style(name, value, priority));
  };
  function d3_selection_style(name, value, priority) {
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleConstant() {
      this.style.setProperty(name, value, priority);
    }
    function styleFunction() {
      var x = value.apply(this, arguments);
      if (x == null) this.style.removeProperty(name); else this.style.setProperty(name, x, priority);
    }
    return value == null ? styleNull : typeof value === "function" ? styleFunction : styleConstant;
  }
  d3_selectionPrototype.property = function(name, value) {
    if (arguments.length < 2) {
      if (typeof name === "string") return this.node()[name];
      for (value in name) this.each(d3_selection_property(value, name[value]));
      return this;
    }
    return this.each(d3_selection_property(name, value));
  };
  function d3_selection_property(name, value) {
    function propertyNull() {
      delete this[name];
    }
    function propertyConstant() {
      this[name] = value;
    }
    function propertyFunction() {
      var x = value.apply(this, arguments);
      if (x == null) delete this[name]; else this[name] = x;
    }
    return value == null ? propertyNull : typeof value === "function" ? propertyFunction : propertyConstant;
  }
  d3_selectionPrototype.text = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.textContent = v == null ? "" : v;
    } : value == null ? function() {
      this.textContent = "";
    } : function() {
      this.textContent = value;
    }) : this.node().textContent;
  };
  d3_selectionPrototype.html = function(value) {
    return arguments.length ? this.each(typeof value === "function" ? function() {
      var v = value.apply(this, arguments);
      this.innerHTML = v == null ? "" : v;
    } : value == null ? function() {
      this.innerHTML = "";
    } : function() {
      this.innerHTML = value;
    }) : this.node().innerHTML;
  };
  d3_selectionPrototype.append = function(name) {
    name = d3_selection_creator(name);
    return this.select(function() {
      return this.appendChild(name.apply(this, arguments));
    });
  };
  function d3_selection_creator(name) {
    function create() {
      var document = this.ownerDocument, namespace = this.namespaceURI;
      return namespace === d3_nsXhtml && document.documentElement.namespaceURI === d3_nsXhtml ? document.createElement(name) : document.createElementNS(namespace, name);
    }
    function createNS() {
      return this.ownerDocument.createElementNS(name.space, name.local);
    }
    return typeof name === "function" ? name : (name = d3.ns.qualify(name)).local ? createNS : create;
  }
  d3_selectionPrototype.insert = function(name, before) {
    name = d3_selection_creator(name);
    before = d3_selection_selector(before);
    return this.select(function() {
      return this.insertBefore(name.apply(this, arguments), before.apply(this, arguments) || null);
    });
  };
  d3_selectionPrototype.remove = function() {
    return this.each(d3_selectionRemove);
  };
  function d3_selectionRemove() {
    var parent = this.parentNode;
    if (parent) parent.removeChild(this);
  }
  d3_selectionPrototype.data = function(value, key) {
    var i = -1, n = this.length, group, node;
    if (!arguments.length) {
      value = new Array(n = (group = this[0]).length);
      while (++i < n) {
        if (node = group[i]) {
          value[i] = node.__data__;
        }
      }
      return value;
    }
    function bind(group, groupData) {
      var i, n = group.length, m = groupData.length, n0 = Math.min(n, m), updateNodes = new Array(m), enterNodes = new Array(m), exitNodes = new Array(n), node, nodeData;
      if (key) {
        var nodeByKeyValue = new d3_Map(), keyValues = new Array(n), keyValue;
        for (i = -1; ++i < n; ) {
          if (node = group[i]) {
            if (nodeByKeyValue.has(keyValue = key.call(node, node.__data__, i))) {
              exitNodes[i] = node;
            } else {
              nodeByKeyValue.set(keyValue, node);
            }
            keyValues[i] = keyValue;
          }
        }
        for (i = -1; ++i < m; ) {
          if (!(node = nodeByKeyValue.get(keyValue = key.call(groupData, nodeData = groupData[i], i)))) {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          } else if (node !== true) {
            updateNodes[i] = node;
            node.__data__ = nodeData;
          }
          nodeByKeyValue.set(keyValue, true);
        }
        for (i = -1; ++i < n; ) {
          if (i in keyValues && nodeByKeyValue.get(keyValues[i]) !== true) {
            exitNodes[i] = group[i];
          }
        }
      } else {
        for (i = -1; ++i < n0; ) {
          node = group[i];
          nodeData = groupData[i];
          if (node) {
            node.__data__ = nodeData;
            updateNodes[i] = node;
          } else {
            enterNodes[i] = d3_selection_dataNode(nodeData);
          }
        }
        for (;i < m; ++i) {
          enterNodes[i] = d3_selection_dataNode(groupData[i]);
        }
        for (;i < n; ++i) {
          exitNodes[i] = group[i];
        }
      }
      enterNodes.update = updateNodes;
      enterNodes.parentNode = updateNodes.parentNode = exitNodes.parentNode = group.parentNode;
      enter.push(enterNodes);
      update.push(updateNodes);
      exit.push(exitNodes);
    }
    var enter = d3_selection_enter([]), update = d3_selection([]), exit = d3_selection([]);
    if (typeof value === "function") {
      while (++i < n) {
        bind(group = this[i], value.call(group, group.parentNode.__data__, i));
      }
    } else {
      while (++i < n) {
        bind(group = this[i], value);
      }
    }
    update.enter = function() {
      return enter;
    };
    update.exit = function() {
      return exit;
    };
    return update;
  };
  function d3_selection_dataNode(data) {
    return {
      __data__: data
    };
  }
  d3_selectionPrototype.datum = function(value) {
    return arguments.length ? this.property("__data__", value) : this.property("__data__");
  };
  d3_selectionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      subgroup.parentNode = (group = this[j]).parentNode;
      for (var i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_selection(subgroups);
  };
  function d3_selection_filter(selector) {
    return function() {
      return d3_selectMatches(this, selector);
    };
  }
  d3_selectionPrototype.order = function() {
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = group.length - 1, next = group[i], node; --i >= 0; ) {
        if (node = group[i]) {
          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
          next = node;
        }
      }
    }
    return this;
  };
  d3_selectionPrototype.sort = function(comparator) {
    comparator = d3_selection_sortComparator.apply(this, arguments);
    for (var j = -1, m = this.length; ++j < m; ) this[j].sort(comparator);
    return this.order();
  };
  function d3_selection_sortComparator(comparator) {
    if (!arguments.length) comparator = d3_ascending;
    return function(a, b) {
      return a && b ? comparator(a.__data__, b.__data__) : !a - !b;
    };
  }
  d3_selectionPrototype.each = function(callback) {
    return d3_selection_each(this, function(node, i, j) {
      callback.call(node, node.__data__, i, j);
    });
  };
  function d3_selection_each(groups, callback) {
    for (var j = 0, m = groups.length; j < m; j++) {
      for (var group = groups[j], i = 0, n = group.length, node; i < n; i++) {
        if (node = group[i]) callback(node, i, j);
      }
    }
    return groups;
  }
  d3_selectionPrototype.call = function(callback) {
    var args = d3_array(arguments);
    callback.apply(args[0] = this, args);
    return this;
  };
  d3_selectionPrototype.empty = function() {
    return !this.node();
  };
  d3_selectionPrototype.node = function() {
    for (var j = 0, m = this.length; j < m; j++) {
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        var node = group[i];
        if (node) return node;
      }
    }
    return null;
  };
  d3_selectionPrototype.size = function() {
    var n = 0;
    d3_selection_each(this, function() {
      ++n;
    });
    return n;
  };
  function d3_selection_enter(selection) {
    d3_subclass(selection, d3_selection_enterPrototype);
    return selection;
  }
  var d3_selection_enterPrototype = [];
  d3.selection.enter = d3_selection_enter;
  d3.selection.enter.prototype = d3_selection_enterPrototype;
  d3_selection_enterPrototype.append = d3_selectionPrototype.append;
  d3_selection_enterPrototype.empty = d3_selectionPrototype.empty;
  d3_selection_enterPrototype.node = d3_selectionPrototype.node;
  d3_selection_enterPrototype.call = d3_selectionPrototype.call;
  d3_selection_enterPrototype.size = d3_selectionPrototype.size;
  d3_selection_enterPrototype.select = function(selector) {
    var subgroups = [], subgroup, subnode, upgroup, group, node;
    for (var j = -1, m = this.length; ++j < m; ) {
      upgroup = (group = this[j]).update;
      subgroups.push(subgroup = []);
      subgroup.parentNode = group.parentNode;
      for (var i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          subgroup.push(upgroup[i] = subnode = selector.call(group.parentNode, node.__data__, i, j));
          subnode.__data__ = node.__data__;
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_selection(subgroups);
  };
  d3_selection_enterPrototype.insert = function(name, before) {
    if (arguments.length < 2) before = d3_selection_enterInsertBefore(this);
    return d3_selectionPrototype.insert.call(this, name, before);
  };
  function d3_selection_enterInsertBefore(enter) {
    var i0, j0;
    return function(d, i, j) {
      var group = enter[j].update, n = group.length, node;
      if (j != j0) j0 = j, i0 = 0;
      if (i >= i0) i0 = i + 1;
      while (!(node = group[i0]) && ++i0 < n) ;
      return node;
    };
  }
  d3.select = function(node) {
    var group;
    if (typeof node === "string") {
      group = [ d3_select(node, d3_document) ];
      group.parentNode = d3_document.documentElement;
    } else {
      group = [ node ];
      group.parentNode = d3_documentElement(node);
    }
    return d3_selection([ group ]);
  };
  d3.selectAll = function(nodes) {
    var group;
    if (typeof nodes === "string") {
      group = d3_array(d3_selectAll(nodes, d3_document));
      group.parentNode = d3_document.documentElement;
    } else {
      group = d3_array(nodes);
      group.parentNode = null;
    }
    return d3_selection([ group ]);
  };
  d3_selectionPrototype.on = function(type, listener, capture) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof type !== "string") {
        if (n < 2) listener = false;
        for (capture in type) this.each(d3_selection_on(capture, type[capture], listener));
        return this;
      }
      if (n < 2) return (n = this.node()["__on" + type]) && n._;
      capture = false;
    }
    return this.each(d3_selection_on(type, listener, capture));
  };
  function d3_selection_on(type, listener, capture) {
    var name = "__on" + type, i = type.indexOf("."), wrap = d3_selection_onListener;
    if (i > 0) type = type.slice(0, i);
    var filter = d3_selection_onFilters.get(type);
    if (filter) type = filter, wrap = d3_selection_onFilter;
    function onRemove() {
      var l = this[name];
      if (l) {
        this.removeEventListener(type, l, l.$);
        delete this[name];
      }
    }
    function onAdd() {
      var l = wrap(listener, d3_array(arguments));
      onRemove.call(this);
      this.addEventListener(type, this[name] = l, l.$ = capture);
      l._ = listener;
    }
    function removeAll() {
      var re = new RegExp("^__on([^.]+)" + d3.requote(type) + "$"), match;
      for (var name in this) {
        if (match = name.match(re)) {
          var l = this[name];
          this.removeEventListener(match[1], l, l.$);
          delete this[name];
        }
      }
    }
    return i ? listener ? onAdd : onRemove : listener ? d3_noop : removeAll;
  }
  var d3_selection_onFilters = d3.map({
    mouseenter: "mouseover",
    mouseleave: "mouseout"
  });
  if (d3_document) {
    d3_selection_onFilters.forEach(function(k) {
      if ("on" + k in d3_document) d3_selection_onFilters.remove(k);
    });
  }
  function d3_selection_onListener(listener, argumentz) {
    return function(e) {
      var o = d3.event;
      d3.event = e;
      argumentz[0] = this.__data__;
      try {
        listener.apply(this, argumentz);
      } finally {
        d3.event = o;
      }
    };
  }
  function d3_selection_onFilter(listener, argumentz) {
    var l = d3_selection_onListener(listener, argumentz);
    return function(e) {
      var target = this, related = e.relatedTarget;
      if (!related || related !== target && !(related.compareDocumentPosition(target) & 8)) {
        l.call(target, e);
      }
    };
  }
  var d3_event_dragSelect, d3_event_dragId = 0;
  function d3_event_dragSuppress(node) {
    var name = ".dragsuppress-" + ++d3_event_dragId, click = "click" + name, w = d3.select(d3_window(node)).on("touchmove" + name, d3_eventPreventDefault).on("dragstart" + name, d3_eventPreventDefault).on("selectstart" + name, d3_eventPreventDefault);
    if (d3_event_dragSelect == null) {
      d3_event_dragSelect = "onselectstart" in node ? false : d3_vendorSymbol(node.style, "userSelect");
    }
    if (d3_event_dragSelect) {
      var style = d3_documentElement(node).style, select = style[d3_event_dragSelect];
      style[d3_event_dragSelect] = "none";
    }
    return function(suppressClick) {
      w.on(name, null);
      if (d3_event_dragSelect) style[d3_event_dragSelect] = select;
      if (suppressClick) {
        var off = function() {
          w.on(click, null);
        };
        w.on(click, function() {
          d3_eventPreventDefault();
          off();
        }, true);
        setTimeout(off, 0);
      }
    };
  }
  d3.mouse = function(container) {
    return d3_mousePoint(container, d3_eventSource());
  };
  var d3_mouse_bug44083 = this.navigator && /WebKit/.test(this.navigator.userAgent) ? -1 : 0;
  function d3_mousePoint(container, e) {
    if (e.changedTouches) e = e.changedTouches[0];
    var svg = container.ownerSVGElement || container;
    if (svg.createSVGPoint) {
      var point = svg.createSVGPoint();
      if (d3_mouse_bug44083 < 0) {
        var window = d3_window(container);
        if (window.scrollX || window.scrollY) {
          svg = d3.select("body").append("svg").style({
            position: "absolute",
            top: 0,
            left: 0,
            margin: 0,
            padding: 0,
            border: "none"
          }, "important");
          var ctm = svg[0][0].getScreenCTM();
          d3_mouse_bug44083 = !(ctm.f || ctm.e);
          svg.remove();
        }
      }
      if (d3_mouse_bug44083) point.x = e.pageX, point.y = e.pageY; else point.x = e.clientX, 
      point.y = e.clientY;
      point = point.matrixTransform(container.getScreenCTM().inverse());
      return [ point.x, point.y ];
    }
    var rect = container.getBoundingClientRect();
    return [ e.clientX - rect.left - container.clientLeft, e.clientY - rect.top - container.clientTop ];
  }
  d3.touch = function(container, touches, identifier) {
    if (arguments.length < 3) identifier = touches, touches = d3_eventSource().changedTouches;
    if (touches) for (var i = 0, n = touches.length, touch; i < n; ++i) {
      if ((touch = touches[i]).identifier === identifier) {
        return d3_mousePoint(container, touch);
      }
    }
  };
  d3.behavior.drag = function() {
    var event = d3_eventDispatch(drag, "drag", "dragstart", "dragend"), origin = null, mousedown = dragstart(d3_noop, d3.mouse, d3_window, "mousemove", "mouseup"), touchstart = dragstart(d3_behavior_dragTouchId, d3.touch, d3_identity, "touchmove", "touchend");
    function drag() {
      this.on("mousedown.drag", mousedown).on("touchstart.drag", touchstart);
    }
    function dragstart(id, position, subject, move, end) {
      return function() {
        var that = this, target = d3.event.target.correspondingElement || d3.event.target, parent = that.parentNode, dispatch = event.of(that, arguments), dragged = 0, dragId = id(), dragName = ".drag" + (dragId == null ? "" : "-" + dragId), dragOffset, dragSubject = d3.select(subject(target)).on(move + dragName, moved).on(end + dragName, ended), dragRestore = d3_event_dragSuppress(target), position0 = position(parent, dragId);
        if (origin) {
          dragOffset = origin.apply(that, arguments);
          dragOffset = [ dragOffset.x - position0[0], dragOffset.y - position0[1] ];
        } else {
          dragOffset = [ 0, 0 ];
        }
        dispatch({
          type: "dragstart"
        });
        function moved() {
          var position1 = position(parent, dragId), dx, dy;
          if (!position1) return;
          dx = position1[0] - position0[0];
          dy = position1[1] - position0[1];
          dragged |= dx | dy;
          position0 = position1;
          dispatch({
            type: "drag",
            x: position1[0] + dragOffset[0],
            y: position1[1] + dragOffset[1],
            dx: dx,
            dy: dy
          });
        }
        function ended() {
          if (!position(parent, dragId)) return;
          dragSubject.on(move + dragName, null).on(end + dragName, null);
          dragRestore(dragged);
          dispatch({
            type: "dragend"
          });
        }
      };
    }
    drag.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return drag;
    };
    return d3.rebind(drag, event, "on");
  };
  function d3_behavior_dragTouchId() {
    return d3.event.changedTouches[0].identifier;
  }
  d3.touches = function(container, touches) {
    if (arguments.length < 2) touches = d3_eventSource().touches;
    return touches ? d3_array(touches).map(function(touch) {
      var point = d3_mousePoint(container, touch);
      point.identifier = touch.identifier;
      return point;
    }) : [];
  };
  var ε = 1e-6, ε2 = ε * ε, π = Math.PI, τ = 2 * π, τε = τ - ε, halfπ = π / 2, d3_radians = π / 180, d3_degrees = 180 / π;
  function d3_sgn(x) {
    return x > 0 ? 1 : x < 0 ? -1 : 0;
  }
  function d3_cross2d(a, b, c) {
    return (b[0] - a[0]) * (c[1] - a[1]) - (b[1] - a[1]) * (c[0] - a[0]);
  }
  function d3_acos(x) {
    return x > 1 ? 0 : x < -1 ? π : Math.acos(x);
  }
  function d3_asin(x) {
    return x > 1 ? halfπ : x < -1 ? -halfπ : Math.asin(x);
  }
  function d3_sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
  }
  function d3_cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
  }
  function d3_tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
  }
  function d3_haversin(x) {
    return (x = Math.sin(x / 2)) * x;
  }
  var ρ = Math.SQRT2, ρ2 = 2, ρ4 = 4;
  d3.interpolateZoom = function(p0, p1) {
    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
    if (d2 < ε2) {
      S = Math.log(w1 / w0) / ρ;
      i = function(t) {
        return [ ux0 + t * dx, uy0 + t * dy, w0 * Math.exp(ρ * t * S) ];
      };
    } else {
      var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + ρ4 * d2) / (2 * w0 * ρ2 * d1), b1 = (w1 * w1 - w0 * w0 - ρ4 * d2) / (2 * w1 * ρ2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
      S = (r1 - r0) / ρ;
      i = function(t) {
        var s = t * S, coshr0 = d3_cosh(r0), u = w0 / (ρ2 * d1) * (coshr0 * d3_tanh(ρ * s + r0) - d3_sinh(r0));
        return [ ux0 + u * dx, uy0 + u * dy, w0 * coshr0 / d3_cosh(ρ * s + r0) ];
      };
    }
    i.duration = S * 1e3;
    return i;
  };
  d3.behavior.zoom = function() {
    var view = {
      x: 0,
      y: 0,
      k: 1
    }, translate0, center0, center, size = [ 960, 500 ], scaleExtent = d3_behavior_zoomInfinity, duration = 250, zooming = 0, mousedown = "mousedown.zoom", mousemove = "mousemove.zoom", mouseup = "mouseup.zoom", mousewheelTimer, touchstart = "touchstart.zoom", touchtime, event = d3_eventDispatch(zoom, "zoomstart", "zoom", "zoomend"), x0, x1, y0, y1;
    if (!d3_behavior_zoomWheel) {
      d3_behavior_zoomWheel = "onwheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return -d3.event.deltaY * (d3.event.deltaMode ? 120 : 1);
      }, "wheel") : "onmousewheel" in d3_document ? (d3_behavior_zoomDelta = function() {
        return d3.event.wheelDelta;
      }, "mousewheel") : (d3_behavior_zoomDelta = function() {
        return -d3.event.detail;
      }, "MozMousePixelScroll");
    }
    function zoom(g) {
      g.on(mousedown, mousedowned).on(d3_behavior_zoomWheel + ".zoom", mousewheeled).on("dblclick.zoom", dblclicked).on(touchstart, touchstarted);
    }
    zoom.event = function(g) {
      g.each(function() {
        var dispatch = event.of(this, arguments), view1 = view;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.zoom", function() {
            view = this.__chart__ || {
              x: 0,
              y: 0,
              k: 1
            };
            zoomstarted(dispatch);
          }).tween("zoom:zoom", function() {
            var dx = size[0], dy = size[1], cx = center0 ? center0[0] : dx / 2, cy = center0 ? center0[1] : dy / 2, i = d3.interpolateZoom([ (cx - view.x) / view.k, (cy - view.y) / view.k, dx / view.k ], [ (cx - view1.x) / view1.k, (cy - view1.y) / view1.k, dx / view1.k ]);
            return function(t) {
              var l = i(t), k = dx / l[2];
              this.__chart__ = view = {
                x: cx - l[0] * k,
                y: cy - l[1] * k,
                k: k
              };
              zoomed(dispatch);
            };
          }).each("interrupt.zoom", function() {
            zoomended(dispatch);
          }).each("end.zoom", function() {
            zoomended(dispatch);
          });
        } else {
          this.__chart__ = view;
          zoomstarted(dispatch);
          zoomed(dispatch);
          zoomended(dispatch);
        }
      });
    };
    zoom.translate = function(_) {
      if (!arguments.length) return [ view.x, view.y ];
      view = {
        x: +_[0],
        y: +_[1],
        k: view.k
      };
      rescale();
      return zoom;
    };
    zoom.scale = function(_) {
      if (!arguments.length) return view.k;
      view = {
        x: view.x,
        y: view.y,
        k: null
      };
      scaleTo(+_);
      rescale();
      return zoom;
    };
    zoom.scaleExtent = function(_) {
      if (!arguments.length) return scaleExtent;
      scaleExtent = _ == null ? d3_behavior_zoomInfinity : [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.center = function(_) {
      if (!arguments.length) return center;
      center = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.size = function(_) {
      if (!arguments.length) return size;
      size = _ && [ +_[0], +_[1] ];
      return zoom;
    };
    zoom.duration = function(_) {
      if (!arguments.length) return duration;
      duration = +_;
      return zoom;
    };
    zoom.x = function(z) {
      if (!arguments.length) return x1;
      x1 = z;
      x0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    zoom.y = function(z) {
      if (!arguments.length) return y1;
      y1 = z;
      y0 = z.copy();
      view = {
        x: 0,
        y: 0,
        k: 1
      };
      return zoom;
    };
    function location(p) {
      return [ (p[0] - view.x) / view.k, (p[1] - view.y) / view.k ];
    }
    function point(l) {
      return [ l[0] * view.k + view.x, l[1] * view.k + view.y ];
    }
    function scaleTo(s) {
      view.k = Math.max(scaleExtent[0], Math.min(scaleExtent[1], s));
    }
    function translateTo(p, l) {
      l = point(l);
      view.x += p[0] - l[0];
      view.y += p[1] - l[1];
    }
    function zoomTo(that, p, l, k) {
      that.__chart__ = {
        x: view.x,
        y: view.y,
        k: view.k
      };
      scaleTo(Math.pow(2, k));
      translateTo(center0 = p, l);
      that = d3.select(that);
      if (duration > 0) that = that.transition().duration(duration);
      that.call(zoom.event);
    }
    function rescale() {
      if (x1) x1.domain(x0.range().map(function(x) {
        return (x - view.x) / view.k;
      }).map(x0.invert));
      if (y1) y1.domain(y0.range().map(function(y) {
        return (y - view.y) / view.k;
      }).map(y0.invert));
    }
    function zoomstarted(dispatch) {
      if (!zooming++) dispatch({
        type: "zoomstart"
      });
    }
    function zoomed(dispatch) {
      rescale();
      dispatch({
        type: "zoom",
        scale: view.k,
        translate: [ view.x, view.y ]
      });
    }
    function zoomended(dispatch) {
      if (!--zooming) dispatch({
        type: "zoomend"
      }), center0 = null;
    }
    function mousedowned() {
      var that = this, dispatch = event.of(that, arguments), dragged = 0, subject = d3.select(d3_window(that)).on(mousemove, moved).on(mouseup, ended), location0 = location(d3.mouse(that)), dragRestore = d3_event_dragSuppress(that);
      d3_selection_interrupt.call(that);
      zoomstarted(dispatch);
      function moved() {
        dragged = 1;
        translateTo(d3.mouse(that), location0);
        zoomed(dispatch);
      }
      function ended() {
        subject.on(mousemove, null).on(mouseup, null);
        dragRestore(dragged);
        zoomended(dispatch);
      }
    }
    function touchstarted() {
      var that = this, dispatch = event.of(that, arguments), locations0 = {}, distance0 = 0, scale0, zoomName = ".zoom-" + d3.event.changedTouches[0].identifier, touchmove = "touchmove" + zoomName, touchend = "touchend" + zoomName, targets = [], subject = d3.select(that), dragRestore = d3_event_dragSuppress(that);
      started();
      zoomstarted(dispatch);
      subject.on(mousedown, null).on(touchstart, started);
      function relocate() {
        var touches = d3.touches(that);
        scale0 = view.k;
        touches.forEach(function(t) {
          if (t.identifier in locations0) locations0[t.identifier] = location(t);
        });
        return touches;
      }
      function started() {
        var target = d3.event.target;
        d3.select(target).on(touchmove, moved).on(touchend, ended);
        targets.push(target);
        var changed = d3.event.changedTouches;
        for (var i = 0, n = changed.length; i < n; ++i) {
          locations0[changed[i].identifier] = null;
        }
        var touches = relocate(), now = Date.now();
        if (touches.length === 1) {
          if (now - touchtime < 500) {
            var p = touches[0];
            zoomTo(that, p, locations0[p.identifier], Math.floor(Math.log(view.k) / Math.LN2) + 1);
            d3_eventPreventDefault();
          }
          touchtime = now;
        } else if (touches.length > 1) {
          var p = touches[0], q = touches[1], dx = p[0] - q[0], dy = p[1] - q[1];
          distance0 = dx * dx + dy * dy;
        }
      }
      function moved() {
        var touches = d3.touches(that), p0, l0, p1, l1;
        d3_selection_interrupt.call(that);
        for (var i = 0, n = touches.length; i < n; ++i, l1 = null) {
          p1 = touches[i];
          if (l1 = locations0[p1.identifier]) {
            if (l0) break;
            p0 = p1, l0 = l1;
          }
        }
        if (l1) {
          var distance1 = (distance1 = p1[0] - p0[0]) * distance1 + (distance1 = p1[1] - p0[1]) * distance1, scale1 = distance0 && Math.sqrt(distance1 / distance0);
          p0 = [ (p0[0] + p1[0]) / 2, (p0[1] + p1[1]) / 2 ];
          l0 = [ (l0[0] + l1[0]) / 2, (l0[1] + l1[1]) / 2 ];
          scaleTo(scale1 * scale0);
        }
        touchtime = null;
        translateTo(p0, l0);
        zoomed(dispatch);
      }
      function ended() {
        if (d3.event.touches.length) {
          var changed = d3.event.changedTouches;
          for (var i = 0, n = changed.length; i < n; ++i) {
            delete locations0[changed[i].identifier];
          }
          for (var identifier in locations0) {
            return void relocate();
          }
        }
        d3.selectAll(targets).on(zoomName, null);
        subject.on(mousedown, mousedowned).on(touchstart, touchstarted);
        dragRestore();
        zoomended(dispatch);
      }
    }
    function mousewheeled() {
      var dispatch = event.of(this, arguments);
      if (mousewheelTimer) clearTimeout(mousewheelTimer); else d3_selection_interrupt.call(this), 
      translate0 = location(center0 = center || d3.mouse(this)), zoomstarted(dispatch);
      mousewheelTimer = setTimeout(function() {
        mousewheelTimer = null;
        zoomended(dispatch);
      }, 50);
      d3_eventPreventDefault();
      scaleTo(Math.pow(2, d3_behavior_zoomDelta() * .002) * view.k);
      translateTo(center0, translate0);
      zoomed(dispatch);
    }
    function dblclicked() {
      var p = d3.mouse(this), k = Math.log(view.k) / Math.LN2;
      zoomTo(this, p, location(p), d3.event.shiftKey ? Math.ceil(k) - 1 : Math.floor(k) + 1);
    }
    return d3.rebind(zoom, event, "on");
  };
  var d3_behavior_zoomInfinity = [ 0, Infinity ], d3_behavior_zoomDelta, d3_behavior_zoomWheel;
  d3.color = d3_color;
  function d3_color() {}
  d3_color.prototype.toString = function() {
    return this.rgb() + "";
  };
  d3.hsl = d3_hsl;
  function d3_hsl(h, s, l) {
    return this instanceof d3_hsl ? void (this.h = +h, this.s = +s, this.l = +l) : arguments.length < 2 ? h instanceof d3_hsl ? new d3_hsl(h.h, h.s, h.l) : d3_rgb_parse("" + h, d3_rgb_hsl, d3_hsl) : new d3_hsl(h, s, l);
  }
  var d3_hslPrototype = d3_hsl.prototype = new d3_color();
  d3_hslPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, this.l / k);
  };
  d3_hslPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_hsl(this.h, this.s, k * this.l);
  };
  d3_hslPrototype.rgb = function() {
    return d3_hsl_rgb(this.h, this.s, this.l);
  };
  function d3_hsl_rgb(h, s, l) {
    var m1, m2;
    h = isNaN(h) ? 0 : (h %= 360) < 0 ? h + 360 : h;
    s = isNaN(s) ? 0 : s < 0 ? 0 : s > 1 ? 1 : s;
    l = l < 0 ? 0 : l > 1 ? 1 : l;
    m2 = l <= .5 ? l * (1 + s) : l + s - l * s;
    m1 = 2 * l - m2;
    function v(h) {
      if (h > 360) h -= 360; else if (h < 0) h += 360;
      if (h < 60) return m1 + (m2 - m1) * h / 60;
      if (h < 180) return m2;
      if (h < 240) return m1 + (m2 - m1) * (240 - h) / 60;
      return m1;
    }
    function vv(h) {
      return Math.round(v(h) * 255);
    }
    return new d3_rgb(vv(h + 120), vv(h), vv(h - 120));
  }
  d3.hcl = d3_hcl;
  function d3_hcl(h, c, l) {
    return this instanceof d3_hcl ? void (this.h = +h, this.c = +c, this.l = +l) : arguments.length < 2 ? h instanceof d3_hcl ? new d3_hcl(h.h, h.c, h.l) : h instanceof d3_lab ? d3_lab_hcl(h.l, h.a, h.b) : d3_lab_hcl((h = d3_rgb_lab((h = d3.rgb(h)).r, h.g, h.b)).l, h.a, h.b) : new d3_hcl(h, c, l);
  }
  var d3_hclPrototype = d3_hcl.prototype = new d3_color();
  d3_hclPrototype.brighter = function(k) {
    return new d3_hcl(this.h, this.c, Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.darker = function(k) {
    return new d3_hcl(this.h, this.c, Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)));
  };
  d3_hclPrototype.rgb = function() {
    return d3_hcl_lab(this.h, this.c, this.l).rgb();
  };
  function d3_hcl_lab(h, c, l) {
    if (isNaN(h)) h = 0;
    if (isNaN(c)) c = 0;
    return new d3_lab(l, Math.cos(h *= d3_radians) * c, Math.sin(h) * c);
  }
  d3.lab = d3_lab;
  function d3_lab(l, a, b) {
    return this instanceof d3_lab ? void (this.l = +l, this.a = +a, this.b = +b) : arguments.length < 2 ? l instanceof d3_lab ? new d3_lab(l.l, l.a, l.b) : l instanceof d3_hcl ? d3_hcl_lab(l.h, l.c, l.l) : d3_rgb_lab((l = d3_rgb(l)).r, l.g, l.b) : new d3_lab(l, a, b);
  }
  var d3_lab_K = 18;
  var d3_lab_X = .95047, d3_lab_Y = 1, d3_lab_Z = 1.08883;
  var d3_labPrototype = d3_lab.prototype = new d3_color();
  d3_labPrototype.brighter = function(k) {
    return new d3_lab(Math.min(100, this.l + d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.darker = function(k) {
    return new d3_lab(Math.max(0, this.l - d3_lab_K * (arguments.length ? k : 1)), this.a, this.b);
  };
  d3_labPrototype.rgb = function() {
    return d3_lab_rgb(this.l, this.a, this.b);
  };
  function d3_lab_rgb(l, a, b) {
    var y = (l + 16) / 116, x = y + a / 500, z = y - b / 200;
    x = d3_lab_xyz(x) * d3_lab_X;
    y = d3_lab_xyz(y) * d3_lab_Y;
    z = d3_lab_xyz(z) * d3_lab_Z;
    return new d3_rgb(d3_xyz_rgb(3.2404542 * x - 1.5371385 * y - .4985314 * z), d3_xyz_rgb(-.969266 * x + 1.8760108 * y + .041556 * z), d3_xyz_rgb(.0556434 * x - .2040259 * y + 1.0572252 * z));
  }
  function d3_lab_hcl(l, a, b) {
    return l > 0 ? new d3_hcl(Math.atan2(b, a) * d3_degrees, Math.sqrt(a * a + b * b), l) : new d3_hcl(NaN, NaN, l);
  }
  function d3_lab_xyz(x) {
    return x > .206893034 ? x * x * x : (x - 4 / 29) / 7.787037;
  }
  function d3_xyz_lab(x) {
    return x > .008856 ? Math.pow(x, 1 / 3) : 7.787037 * x + 4 / 29;
  }
  function d3_xyz_rgb(r) {
    return Math.round(255 * (r <= .00304 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055));
  }
  d3.rgb = d3_rgb;
  function d3_rgb(r, g, b) {
    return this instanceof d3_rgb ? void (this.r = ~~r, this.g = ~~g, this.b = ~~b) : arguments.length < 2 ? r instanceof d3_rgb ? new d3_rgb(r.r, r.g, r.b) : d3_rgb_parse("" + r, d3_rgb, d3_hsl_rgb) : new d3_rgb(r, g, b);
  }
  function d3_rgbNumber(value) {
    return new d3_rgb(value >> 16, value >> 8 & 255, value & 255);
  }
  function d3_rgbString(value) {
    return d3_rgbNumber(value) + "";
  }
  var d3_rgbPrototype = d3_rgb.prototype = new d3_color();
  d3_rgbPrototype.brighter = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    var r = this.r, g = this.g, b = this.b, i = 30;
    if (!r && !g && !b) return new d3_rgb(i, i, i);
    if (r && r < i) r = i;
    if (g && g < i) g = i;
    if (b && b < i) b = i;
    return new d3_rgb(Math.min(255, r / k), Math.min(255, g / k), Math.min(255, b / k));
  };
  d3_rgbPrototype.darker = function(k) {
    k = Math.pow(.7, arguments.length ? k : 1);
    return new d3_rgb(k * this.r, k * this.g, k * this.b);
  };
  d3_rgbPrototype.hsl = function() {
    return d3_rgb_hsl(this.r, this.g, this.b);
  };
  d3_rgbPrototype.toString = function() {
    return "#" + d3_rgb_hex(this.r) + d3_rgb_hex(this.g) + d3_rgb_hex(this.b);
  };
  function d3_rgb_hex(v) {
    return v < 16 ? "0" + Math.max(0, v).toString(16) : Math.min(255, v).toString(16);
  }
  function d3_rgb_parse(format, rgb, hsl) {
    var r = 0, g = 0, b = 0, m1, m2, color;
    m1 = /([a-z]+)\((.*)\)/.exec(format = format.toLowerCase());
    if (m1) {
      m2 = m1[2].split(",");
      switch (m1[1]) {
       case "hsl":
        {
          return hsl(parseFloat(m2[0]), parseFloat(m2[1]) / 100, parseFloat(m2[2]) / 100);
        }

       case "rgb":
        {
          return rgb(d3_rgb_parseNumber(m2[0]), d3_rgb_parseNumber(m2[1]), d3_rgb_parseNumber(m2[2]));
        }
      }
    }
    if (color = d3_rgb_names.get(format)) {
      return rgb(color.r, color.g, color.b);
    }
    if (format != null && format.charAt(0) === "#" && !isNaN(color = parseInt(format.slice(1), 16))) {
      if (format.length === 4) {
        r = (color & 3840) >> 4;
        r = r >> 4 | r;
        g = color & 240;
        g = g >> 4 | g;
        b = color & 15;
        b = b << 4 | b;
      } else if (format.length === 7) {
        r = (color & 16711680) >> 16;
        g = (color & 65280) >> 8;
        b = color & 255;
      }
    }
    return rgb(r, g, b);
  }
  function d3_rgb_hsl(r, g, b) {
    var min = Math.min(r /= 255, g /= 255, b /= 255), max = Math.max(r, g, b), d = max - min, h, s, l = (max + min) / 2;
    if (d) {
      s = l < .5 ? d / (max + min) : d / (2 - max - min);
      if (r == max) h = (g - b) / d + (g < b ? 6 : 0); else if (g == max) h = (b - r) / d + 2; else h = (r - g) / d + 4;
      h *= 60;
    } else {
      h = NaN;
      s = l > 0 && l < 1 ? 0 : h;
    }
    return new d3_hsl(h, s, l);
  }
  function d3_rgb_lab(r, g, b) {
    r = d3_rgb_xyz(r);
    g = d3_rgb_xyz(g);
    b = d3_rgb_xyz(b);
    var x = d3_xyz_lab((.4124564 * r + .3575761 * g + .1804375 * b) / d3_lab_X), y = d3_xyz_lab((.2126729 * r + .7151522 * g + .072175 * b) / d3_lab_Y), z = d3_xyz_lab((.0193339 * r + .119192 * g + .9503041 * b) / d3_lab_Z);
    return d3_lab(116 * y - 16, 500 * (x - y), 200 * (y - z));
  }
  function d3_rgb_xyz(r) {
    return (r /= 255) <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
  }
  function d3_rgb_parseNumber(c) {
    var f = parseFloat(c);
    return c.charAt(c.length - 1) === "%" ? Math.round(f * 2.55) : f;
  }
  var d3_rgb_names = d3.map({
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  });
  d3_rgb_names.forEach(function(key, value) {
    d3_rgb_names.set(key, d3_rgbNumber(value));
  });
  function d3_functor(v) {
    return typeof v === "function" ? v : function() {
      return v;
    };
  }
  d3.functor = d3_functor;
  d3.xhr = d3_xhrType(d3_identity);
  function d3_xhrType(response) {
    return function(url, mimeType, callback) {
      if (arguments.length === 2 && typeof mimeType === "function") callback = mimeType, 
      mimeType = null;
      return d3_xhr(url, mimeType, response, callback);
    };
  }
  function d3_xhr(url, mimeType, response, callback) {
    var xhr = {}, dispatch = d3.dispatch("beforesend", "progress", "load", "error"), headers = {}, request = new XMLHttpRequest(), responseType = null;
    if (this.XDomainRequest && !("withCredentials" in request) && /^(http(s)?:)?\/\//.test(url)) request = new XDomainRequest();
    "onload" in request ? request.onload = request.onerror = respond : request.onreadystatechange = function() {
      request.readyState > 3 && respond();
    };
    function respond() {
      var status = request.status, result;
      if (!status && d3_xhrHasResponse(request) || status >= 200 && status < 300 || status === 304) {
        try {
          result = response.call(xhr, request);
        } catch (e) {
          dispatch.error.call(xhr, e);
          return;
        }
        dispatch.load.call(xhr, result);
      } else {
        dispatch.error.call(xhr, request);
      }
    }
    request.onprogress = function(event) {
      var o = d3.event;
      d3.event = event;
      try {
        dispatch.progress.call(xhr, request);
      } finally {
        d3.event = o;
      }
    };
    xhr.header = function(name, value) {
      name = (name + "").toLowerCase();
      if (arguments.length < 2) return headers[name];
      if (value == null) delete headers[name]; else headers[name] = value + "";
      return xhr;
    };
    xhr.mimeType = function(value) {
      if (!arguments.length) return mimeType;
      mimeType = value == null ? null : value + "";
      return xhr;
    };
    xhr.responseType = function(value) {
      if (!arguments.length) return responseType;
      responseType = value;
      return xhr;
    };
    xhr.response = function(value) {
      response = value;
      return xhr;
    };
    [ "get", "post" ].forEach(function(method) {
      xhr[method] = function() {
        return xhr.send.apply(xhr, [ method ].concat(d3_array(arguments)));
      };
    });
    xhr.send = function(method, data, callback) {
      if (arguments.length === 2 && typeof data === "function") callback = data, data = null;
      request.open(method, url, true);
      if (mimeType != null && !("accept" in headers)) headers["accept"] = mimeType + ",*/*";
      if (request.setRequestHeader) for (var name in headers) request.setRequestHeader(name, headers[name]);
      if (mimeType != null && request.overrideMimeType) request.overrideMimeType(mimeType);
      if (responseType != null) request.responseType = responseType;
      if (callback != null) xhr.on("error", callback).on("load", function(request) {
        callback(null, request);
      });
      dispatch.beforesend.call(xhr, request);
      request.send(data == null ? null : data);
      return xhr;
    };
    xhr.abort = function() {
      request.abort();
      return xhr;
    };
    d3.rebind(xhr, dispatch, "on");
    return callback == null ? xhr : xhr.get(d3_xhr_fixCallback(callback));
  }
  function d3_xhr_fixCallback(callback) {
    return callback.length === 1 ? function(error, request) {
      callback(error == null ? request : null);
    } : callback;
  }
  function d3_xhrHasResponse(request) {
    var type = request.responseType;
    return type && type !== "text" ? request.response : request.responseText;
  }
  d3.dsv = function(delimiter, mimeType) {
    var reFormat = new RegExp('["' + delimiter + "\n]"), delimiterCode = delimiter.charCodeAt(0);
    function dsv(url, row, callback) {
      if (arguments.length < 3) callback = row, row = null;
      var xhr = d3_xhr(url, mimeType, row == null ? response : typedResponse(row), callback);
      xhr.row = function(_) {
        return arguments.length ? xhr.response((row = _) == null ? response : typedResponse(_)) : row;
      };
      return xhr;
    }
    function response(request) {
      return dsv.parse(request.responseText);
    }
    function typedResponse(f) {
      return function(request) {
        return dsv.parse(request.responseText, f);
      };
    }
    dsv.parse = function(text, f) {
      var o;
      return dsv.parseRows(text, function(row, i) {
        if (o) return o(row, i - 1);
        var a = new Function("d", "return {" + row.map(function(name, i) {
          return JSON.stringify(name) + ": d[" + i + "]";
        }).join(",") + "}");
        o = f ? function(row, i) {
          return f(a(row), i);
        } : a;
      });
    };
    dsv.parseRows = function(text, f) {
      var EOL = {}, EOF = {}, rows = [], N = text.length, I = 0, n = 0, t, eol;
      function token() {
        if (I >= N) return EOF;
        if (eol) return eol = false, EOL;
        var j = I;
        if (text.charCodeAt(j) === 34) {
          var i = j;
          while (i++ < N) {
            if (text.charCodeAt(i) === 34) {
              if (text.charCodeAt(i + 1) !== 34) break;
              ++i;
            }
          }
          I = i + 2;
          var c = text.charCodeAt(i + 1);
          if (c === 13) {
            eol = true;
            if (text.charCodeAt(i + 2) === 10) ++I;
          } else if (c === 10) {
            eol = true;
          }
          return text.slice(j + 1, i).replace(/""/g, '"');
        }
        while (I < N) {
          var c = text.charCodeAt(I++), k = 1;
          if (c === 10) eol = true; else if (c === 13) {
            eol = true;
            if (text.charCodeAt(I) === 10) ++I, ++k;
          } else if (c !== delimiterCode) continue;
          return text.slice(j, I - k);
        }
        return text.slice(j);
      }
      while ((t = token()) !== EOF) {
        var a = [];
        while (t !== EOL && t !== EOF) {
          a.push(t);
          t = token();
        }
        if (f && (a = f(a, n++)) == null) continue;
        rows.push(a);
      }
      return rows;
    };
    dsv.format = function(rows) {
      if (Array.isArray(rows[0])) return dsv.formatRows(rows);
      var fieldSet = new d3_Set(), fields = [];
      rows.forEach(function(row) {
        for (var field in row) {
          if (!fieldSet.has(field)) {
            fields.push(fieldSet.add(field));
          }
        }
      });
      return [ fields.map(formatValue).join(delimiter) ].concat(rows.map(function(row) {
        return fields.map(function(field) {
          return formatValue(row[field]);
        }).join(delimiter);
      })).join("\n");
    };
    dsv.formatRows = function(rows) {
      return rows.map(formatRow).join("\n");
    };
    function formatRow(row) {
      return row.map(formatValue).join(delimiter);
    }
    function formatValue(text) {
      return reFormat.test(text) ? '"' + text.replace(/\"/g, '""') + '"' : text;
    }
    return dsv;
  };
  d3.csv = d3.dsv(",", "text/csv");
  d3.tsv = d3.dsv("	", "text/tab-separated-values");
  var d3_timer_queueHead, d3_timer_queueTail, d3_timer_interval, d3_timer_timeout, d3_timer_frame = this[d3_vendorSymbol(this, "requestAnimationFrame")] || function(callback) {
    setTimeout(callback, 17);
  };
  d3.timer = function() {
    d3_timer.apply(this, arguments);
  };
  function d3_timer(callback, delay, then) {
    var n = arguments.length;
    if (n < 2) delay = 0;
    if (n < 3) then = Date.now();
    var time = then + delay, timer = {
      c: callback,
      t: time,
      n: null
    };
    if (d3_timer_queueTail) d3_timer_queueTail.n = timer; else d3_timer_queueHead = timer;
    d3_timer_queueTail = timer;
    if (!d3_timer_interval) {
      d3_timer_timeout = clearTimeout(d3_timer_timeout);
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
    return timer;
  }
  function d3_timer_step() {
    var now = d3_timer_mark(), delay = d3_timer_sweep() - now;
    if (delay > 24) {
      if (isFinite(delay)) {
        clearTimeout(d3_timer_timeout);
        d3_timer_timeout = setTimeout(d3_timer_step, delay);
      }
      d3_timer_interval = 0;
    } else {
      d3_timer_interval = 1;
      d3_timer_frame(d3_timer_step);
    }
  }
  d3.timer.flush = function() {
    d3_timer_mark();
    d3_timer_sweep();
  };
  function d3_timer_mark() {
    var now = Date.now(), timer = d3_timer_queueHead;
    while (timer) {
      if (now >= timer.t && timer.c(now - timer.t)) timer.c = null;
      timer = timer.n;
    }
    return now;
  }
  function d3_timer_sweep() {
    var t0, t1 = d3_timer_queueHead, time = Infinity;
    while (t1) {
      if (t1.c) {
        if (t1.t < time) time = t1.t;
        t1 = (t0 = t1).n;
      } else {
        t1 = t0 ? t0.n = t1.n : d3_timer_queueHead = t1.n;
      }
    }
    d3_timer_queueTail = t0;
    return time;
  }
  function d3_format_precision(x, p) {
    return p - (x ? Math.ceil(Math.log(x) / Math.LN10) : 1);
  }
  d3.round = function(x, n) {
    return n ? Math.round(x * (n = Math.pow(10, n))) / n : Math.round(x);
  };
  var d3_formatPrefixes = [ "y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y" ].map(d3_formatPrefix);
  d3.formatPrefix = function(value, precision) {
    var i = 0;
    if (value = +value) {
      if (value < 0) value *= -1;
      if (precision) value = d3.round(value, d3_format_precision(value, precision));
      i = 1 + Math.floor(1e-12 + Math.log(value) / Math.LN10);
      i = Math.max(-24, Math.min(24, Math.floor((i - 1) / 3) * 3));
    }
    return d3_formatPrefixes[8 + i / 3];
  };
  function d3_formatPrefix(d, i) {
    var k = Math.pow(10, abs(8 - i) * 3);
    return {
      scale: i > 8 ? function(d) {
        return d / k;
      } : function(d) {
        return d * k;
      },
      symbol: d
    };
  }
  function d3_locale_numberFormat(locale) {
    var locale_decimal = locale.decimal, locale_thousands = locale.thousands, locale_grouping = locale.grouping, locale_currency = locale.currency, formatGroup = locale_grouping && locale_thousands ? function(value, width) {
      var i = value.length, t = [], j = 0, g = locale_grouping[0], length = 0;
      while (i > 0 && g > 0) {
        if (length + g + 1 > width) g = Math.max(1, width - length);
        t.push(value.substring(i -= g, i + g));
        if ((length += g + 1) > width) break;
        g = locale_grouping[j = (j + 1) % locale_grouping.length];
      }
      return t.reverse().join(locale_thousands);
    } : d3_identity;
    return function(specifier) {
      var match = d3_format_re.exec(specifier), fill = match[1] || " ", align = match[2] || ">", sign = match[3] || "-", symbol = match[4] || "", zfill = match[5], width = +match[6], comma = match[7], precision = match[8], type = match[9], scale = 1, prefix = "", suffix = "", integer = false, exponent = true;
      if (precision) precision = +precision.substring(1);
      if (zfill || fill === "0" && align === "=") {
        zfill = fill = "0";
        align = "=";
      }
      switch (type) {
       case "n":
        comma = true;
        type = "g";
        break;

       case "%":
        scale = 100;
        suffix = "%";
        type = "f";
        break;

       case "p":
        scale = 100;
        suffix = "%";
        type = "r";
        break;

       case "b":
       case "o":
       case "x":
       case "X":
        if (symbol === "#") prefix = "0" + type.toLowerCase();

       case "c":
        exponent = false;

       case "d":
        integer = true;
        precision = 0;
        break;

       case "s":
        scale = -1;
        type = "r";
        break;
      }
      if (symbol === "$") prefix = locale_currency[0], suffix = locale_currency[1];
      if (type == "r" && !precision) type = "g";
      if (precision != null) {
        if (type == "g") precision = Math.max(1, Math.min(21, precision)); else if (type == "e" || type == "f") precision = Math.max(0, Math.min(20, precision));
      }
      type = d3_format_types.get(type) || d3_format_typeDefault;
      var zcomma = zfill && comma;
      return function(value) {
        var fullSuffix = suffix;
        if (integer && value % 1) return "";
        var negative = value < 0 || value === 0 && 1 / value < 0 ? (value = -value, "-") : sign === "-" ? "" : sign;
        if (scale < 0) {
          var unit = d3.formatPrefix(value, precision);
          value = unit.scale(value);
          fullSuffix = unit.symbol + suffix;
        } else {
          value *= scale;
        }
        value = type(value, precision);
        var i = value.lastIndexOf("."), before, after;
        if (i < 0) {
          var j = exponent ? value.lastIndexOf("e") : -1;
          if (j < 0) before = value, after = ""; else before = value.substring(0, j), after = value.substring(j);
        } else {
          before = value.substring(0, i);
          after = locale_decimal + value.substring(i + 1);
        }
        if (!zfill && comma) before = formatGroup(before, Infinity);
        var length = prefix.length + before.length + after.length + (zcomma ? 0 : negative.length), padding = length < width ? new Array(length = width - length + 1).join(fill) : "";
        if (zcomma) before = formatGroup(padding + before, padding.length ? width - after.length : Infinity);
        negative += prefix;
        value = before + after;
        return (align === "<" ? negative + value + padding : align === ">" ? padding + negative + value : align === "^" ? padding.substring(0, length >>= 1) + negative + value + padding.substring(length) : negative + (zcomma ? value : padding + value)) + fullSuffix;
      };
    };
  }
  var d3_format_re = /(?:([^{])?([<>=^]))?([+\- ])?([$#])?(0)?(\d+)?(,)?(\.-?\d+)?([a-z%])?/i;
  var d3_format_types = d3.map({
    b: function(x) {
      return x.toString(2);
    },
    c: function(x) {
      return String.fromCharCode(x);
    },
    o: function(x) {
      return x.toString(8);
    },
    x: function(x) {
      return x.toString(16);
    },
    X: function(x) {
      return x.toString(16).toUpperCase();
    },
    g: function(x, p) {
      return x.toPrecision(p);
    },
    e: function(x, p) {
      return x.toExponential(p);
    },
    f: function(x, p) {
      return x.toFixed(p);
    },
    r: function(x, p) {
      return (x = d3.round(x, d3_format_precision(x, p))).toFixed(Math.max(0, Math.min(20, d3_format_precision(x * (1 + 1e-15), p))));
    }
  });
  function d3_format_typeDefault(x) {
    return x + "";
  }
  var d3_time = d3.time = {}, d3_date = Date;
  function d3_date_utc() {
    this._ = new Date(arguments.length > 1 ? Date.UTC.apply(this, arguments) : arguments[0]);
  }
  d3_date_utc.prototype = {
    getDate: function() {
      return this._.getUTCDate();
    },
    getDay: function() {
      return this._.getUTCDay();
    },
    getFullYear: function() {
      return this._.getUTCFullYear();
    },
    getHours: function() {
      return this._.getUTCHours();
    },
    getMilliseconds: function() {
      return this._.getUTCMilliseconds();
    },
    getMinutes: function() {
      return this._.getUTCMinutes();
    },
    getMonth: function() {
      return this._.getUTCMonth();
    },
    getSeconds: function() {
      return this._.getUTCSeconds();
    },
    getTime: function() {
      return this._.getTime();
    },
    getTimezoneOffset: function() {
      return 0;
    },
    valueOf: function() {
      return this._.valueOf();
    },
    setDate: function() {
      d3_time_prototype.setUTCDate.apply(this._, arguments);
    },
    setDay: function() {
      d3_time_prototype.setUTCDay.apply(this._, arguments);
    },
    setFullYear: function() {
      d3_time_prototype.setUTCFullYear.apply(this._, arguments);
    },
    setHours: function() {
      d3_time_prototype.setUTCHours.apply(this._, arguments);
    },
    setMilliseconds: function() {
      d3_time_prototype.setUTCMilliseconds.apply(this._, arguments);
    },
    setMinutes: function() {
      d3_time_prototype.setUTCMinutes.apply(this._, arguments);
    },
    setMonth: function() {
      d3_time_prototype.setUTCMonth.apply(this._, arguments);
    },
    setSeconds: function() {
      d3_time_prototype.setUTCSeconds.apply(this._, arguments);
    },
    setTime: function() {
      d3_time_prototype.setTime.apply(this._, arguments);
    }
  };
  var d3_time_prototype = Date.prototype;
  function d3_time_interval(local, step, number) {
    function round(date) {
      var d0 = local(date), d1 = offset(d0, 1);
      return date - d0 < d1 - date ? d0 : d1;
    }
    function ceil(date) {
      step(date = local(new d3_date(date - 1)), 1);
      return date;
    }
    function offset(date, k) {
      step(date = new d3_date(+date), k);
      return date;
    }
    function range(t0, t1, dt) {
      var time = ceil(t0), times = [];
      if (dt > 1) {
        while (time < t1) {
          if (!(number(time) % dt)) times.push(new Date(+time));
          step(time, 1);
        }
      } else {
        while (time < t1) times.push(new Date(+time)), step(time, 1);
      }
      return times;
    }
    function range_utc(t0, t1, dt) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = t0;
        return range(utc, t1, dt);
      } finally {
        d3_date = Date;
      }
    }
    local.floor = local;
    local.round = round;
    local.ceil = ceil;
    local.offset = offset;
    local.range = range;
    var utc = local.utc = d3_time_interval_utc(local);
    utc.floor = utc;
    utc.round = d3_time_interval_utc(round);
    utc.ceil = d3_time_interval_utc(ceil);
    utc.offset = d3_time_interval_utc(offset);
    utc.range = range_utc;
    return local;
  }
  function d3_time_interval_utc(method) {
    return function(date, k) {
      try {
        d3_date = d3_date_utc;
        var utc = new d3_date_utc();
        utc._ = date;
        return method(utc, k)._;
      } finally {
        d3_date = Date;
      }
    };
  }
  d3_time.year = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setMonth(0, 1);
    return date;
  }, function(date, offset) {
    date.setFullYear(date.getFullYear() + offset);
  }, function(date) {
    return date.getFullYear();
  });
  d3_time.years = d3_time.year.range;
  d3_time.years.utc = d3_time.year.utc.range;
  d3_time.day = d3_time_interval(function(date) {
    var day = new d3_date(2e3, 0);
    day.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    return day;
  }, function(date, offset) {
    date.setDate(date.getDate() + offset);
  }, function(date) {
    return date.getDate() - 1;
  });
  d3_time.days = d3_time.day.range;
  d3_time.days.utc = d3_time.day.utc.range;
  d3_time.dayOfYear = function(date) {
    var year = d3_time.year(date);
    return Math.floor((date - year - (date.getTimezoneOffset() - year.getTimezoneOffset()) * 6e4) / 864e5);
  };
  [ "sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday" ].forEach(function(day, i) {
    i = 7 - i;
    var interval = d3_time[day] = d3_time_interval(function(date) {
      (date = d3_time.day(date)).setDate(date.getDate() - (date.getDay() + i) % 7);
      return date;
    }, function(date, offset) {
      date.setDate(date.getDate() + Math.floor(offset) * 7);
    }, function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7) - (day !== i);
    });
    d3_time[day + "s"] = interval.range;
    d3_time[day + "s"].utc = interval.utc.range;
    d3_time[day + "OfYear"] = function(date) {
      var day = d3_time.year(date).getDay();
      return Math.floor((d3_time.dayOfYear(date) + (day + i) % 7) / 7);
    };
  });
  d3_time.week = d3_time.sunday;
  d3_time.weeks = d3_time.sunday.range;
  d3_time.weeks.utc = d3_time.sunday.utc.range;
  d3_time.weekOfYear = d3_time.sundayOfYear;
  function d3_locale_timeFormat(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_days = locale.days, locale_shortDays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    function d3_time_format(template) {
      var n = template.length;
      function format(date) {
        var string = [], i = -1, j = 0, c, p, f;
        while (++i < n) {
          if (template.charCodeAt(i) === 37) {
            string.push(template.slice(j, i));
            if ((p = d3_time_formatPads[c = template.charAt(++i)]) != null) c = template.charAt(++i);
            if (f = d3_time_formats[c]) c = f(date, p == null ? c === "e" ? " " : "0" : p);
            string.push(c);
            j = i + 1;
          }
        }
        string.push(template.slice(j, i));
        return string.join("");
      }
      format.parse = function(string) {
        var d = {
          y: 1900,
          m: 0,
          d: 1,
          H: 0,
          M: 0,
          S: 0,
          L: 0,
          Z: null
        }, i = d3_time_parse(d, template, string, 0);
        if (i != string.length) return null;
        if ("p" in d) d.H = d.H % 12 + d.p * 12;
        var localZ = d.Z != null && d3_date !== d3_date_utc, date = new (localZ ? d3_date_utc : d3_date)();
        if ("j" in d) date.setFullYear(d.y, 0, d.j); else if ("W" in d || "U" in d) {
          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
          date.setFullYear(d.y, 0, 1);
          date.setFullYear(d.y, 0, "W" in d ? (d.w + 6) % 7 + d.W * 7 - (date.getDay() + 5) % 7 : d.w + d.U * 7 - (date.getDay() + 6) % 7);
        } else date.setFullYear(d.y, d.m, d.d);
        date.setHours(d.H + (d.Z / 100 | 0), d.M + d.Z % 100, d.S, d.L);
        return localZ ? date._ : date;
      };
      format.toString = function() {
        return template;
      };
      return format;
    }
    function d3_time_parse(date, template, string, j) {
      var c, p, t, i = 0, n = template.length, m = string.length;
      while (i < n) {
        if (j >= m) return -1;
        c = template.charCodeAt(i++);
        if (c === 37) {
          t = template.charAt(i++);
          p = d3_time_parsers[t in d3_time_formatPads ? template.charAt(i++) : t];
          if (!p || (j = p(date, string, j)) < 0) return -1;
        } else if (c != string.charCodeAt(j++)) {
          return -1;
        }
      }
      return j;
    }
    d3_time_format.utc = function(template) {
      var local = d3_time_format(template);
      function format(date) {
        try {
          d3_date = d3_date_utc;
          var utc = new d3_date();
          utc._ = date;
          return local(utc);
        } finally {
          d3_date = Date;
        }
      }
      format.parse = function(string) {
        try {
          d3_date = d3_date_utc;
          var date = local.parse(string);
          return date && date._;
        } finally {
          d3_date = Date;
        }
      };
      format.toString = local.toString;
      return format;
    };
    d3_time_format.multi = d3_time_format.utc.multi = d3_time_formatMulti;
    var d3_time_periodLookup = d3.map(), d3_time_dayRe = d3_time_formatRe(locale_days), d3_time_dayLookup = d3_time_formatLookup(locale_days), d3_time_dayAbbrevRe = d3_time_formatRe(locale_shortDays), d3_time_dayAbbrevLookup = d3_time_formatLookup(locale_shortDays), d3_time_monthRe = d3_time_formatRe(locale_months), d3_time_monthLookup = d3_time_formatLookup(locale_months), d3_time_monthAbbrevRe = d3_time_formatRe(locale_shortMonths), d3_time_monthAbbrevLookup = d3_time_formatLookup(locale_shortMonths);
    locale_periods.forEach(function(p, i) {
      d3_time_periodLookup.set(p.toLowerCase(), i);
    });
    var d3_time_formats = {
      a: function(d) {
        return locale_shortDays[d.getDay()];
      },
      A: function(d) {
        return locale_days[d.getDay()];
      },
      b: function(d) {
        return locale_shortMonths[d.getMonth()];
      },
      B: function(d) {
        return locale_months[d.getMonth()];
      },
      c: d3_time_format(locale_dateTime),
      d: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      e: function(d, p) {
        return d3_time_formatPad(d.getDate(), p, 2);
      },
      H: function(d, p) {
        return d3_time_formatPad(d.getHours(), p, 2);
      },
      I: function(d, p) {
        return d3_time_formatPad(d.getHours() % 12 || 12, p, 2);
      },
      j: function(d, p) {
        return d3_time_formatPad(1 + d3_time.dayOfYear(d), p, 3);
      },
      L: function(d, p) {
        return d3_time_formatPad(d.getMilliseconds(), p, 3);
      },
      m: function(d, p) {
        return d3_time_formatPad(d.getMonth() + 1, p, 2);
      },
      M: function(d, p) {
        return d3_time_formatPad(d.getMinutes(), p, 2);
      },
      p: function(d) {
        return locale_periods[+(d.getHours() >= 12)];
      },
      S: function(d, p) {
        return d3_time_formatPad(d.getSeconds(), p, 2);
      },
      U: function(d, p) {
        return d3_time_formatPad(d3_time.sundayOfYear(d), p, 2);
      },
      w: function(d) {
        return d.getDay();
      },
      W: function(d, p) {
        return d3_time_formatPad(d3_time.mondayOfYear(d), p, 2);
      },
      x: d3_time_format(locale_date),
      X: d3_time_format(locale_time),
      y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 100, p, 2);
      },
      Y: function(d, p) {
        return d3_time_formatPad(d.getFullYear() % 1e4, p, 4);
      },
      Z: d3_time_zone,
      "%": function() {
        return "%";
      }
    };
    var d3_time_parsers = {
      a: d3_time_parseWeekdayAbbrev,
      A: d3_time_parseWeekday,
      b: d3_time_parseMonthAbbrev,
      B: d3_time_parseMonth,
      c: d3_time_parseLocaleFull,
      d: d3_time_parseDay,
      e: d3_time_parseDay,
      H: d3_time_parseHour24,
      I: d3_time_parseHour24,
      j: d3_time_parseDayOfYear,
      L: d3_time_parseMilliseconds,
      m: d3_time_parseMonthNumber,
      M: d3_time_parseMinutes,
      p: d3_time_parseAmPm,
      S: d3_time_parseSeconds,
      U: d3_time_parseWeekNumberSunday,
      w: d3_time_parseWeekdayNumber,
      W: d3_time_parseWeekNumberMonday,
      x: d3_time_parseLocaleDate,
      X: d3_time_parseLocaleTime,
      y: d3_time_parseYear,
      Y: d3_time_parseFullYear,
      Z: d3_time_parseZone,
      "%": d3_time_parseLiteralPercent
    };
    function d3_time_parseWeekdayAbbrev(date, string, i) {
      d3_time_dayAbbrevRe.lastIndex = 0;
      var n = d3_time_dayAbbrevRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseWeekday(date, string, i) {
      d3_time_dayRe.lastIndex = 0;
      var n = d3_time_dayRe.exec(string.slice(i));
      return n ? (date.w = d3_time_dayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonthAbbrev(date, string, i) {
      d3_time_monthAbbrevRe.lastIndex = 0;
      var n = d3_time_monthAbbrevRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthAbbrevLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseMonth(date, string, i) {
      d3_time_monthRe.lastIndex = 0;
      var n = d3_time_monthRe.exec(string.slice(i));
      return n ? (date.m = d3_time_monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function d3_time_parseLocaleFull(date, string, i) {
      return d3_time_parse(date, d3_time_formats.c.toString(), string, i);
    }
    function d3_time_parseLocaleDate(date, string, i) {
      return d3_time_parse(date, d3_time_formats.x.toString(), string, i);
    }
    function d3_time_parseLocaleTime(date, string, i) {
      return d3_time_parse(date, d3_time_formats.X.toString(), string, i);
    }
    function d3_time_parseAmPm(date, string, i) {
      var n = d3_time_periodLookup.get(string.slice(i, i += 2).toLowerCase());
      return n == null ? -1 : (date.p = n, i);
    }
    return d3_time_format;
  }
  var d3_time_formatPads = {
    "-": "",
    _: " ",
    "0": "0"
  }, d3_time_numberRe = /^\s*\d+/, d3_time_percentRe = /^%/;
  function d3_time_formatPad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
  }
  function d3_time_formatRe(names) {
    return new RegExp("^(?:" + names.map(d3.requote).join("|") + ")", "i");
  }
  function d3_time_formatLookup(names) {
    var map = new d3_Map(), i = -1, n = names.length;
    while (++i < n) map.set(names[i].toLowerCase(), i);
    return map;
  }
  function d3_time_parseWeekdayNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 1));
    return n ? (date.w = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberSunday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.U = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseWeekNumberMonday(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i));
    return n ? (date.W = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseFullYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 4));
    return n ? (date.y = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.y = d3_time_expandYear(+n[0]), i + n[0].length) : -1;
  }
  function d3_time_parseZone(date, string, i) {
    return /^[+-]\d{4}$/.test(string = string.slice(i, i + 5)) ? (date.Z = -string, 
    i + 5) : -1;
  }
  function d3_time_expandYear(d) {
    return d + (d > 68 ? 1900 : 2e3);
  }
  function d3_time_parseMonthNumber(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.m = n[0] - 1, i + n[0].length) : -1;
  }
  function d3_time_parseDay(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.d = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseDayOfYear(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.j = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseHour24(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.H = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMinutes(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.M = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseSeconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 2));
    return n ? (date.S = +n[0], i + n[0].length) : -1;
  }
  function d3_time_parseMilliseconds(date, string, i) {
    d3_time_numberRe.lastIndex = 0;
    var n = d3_time_numberRe.exec(string.slice(i, i + 3));
    return n ? (date.L = +n[0], i + n[0].length) : -1;
  }
  function d3_time_zone(d) {
    var z = d.getTimezoneOffset(), zs = z > 0 ? "-" : "+", zh = abs(z) / 60 | 0, zm = abs(z) % 60;
    return zs + d3_time_formatPad(zh, "0", 2) + d3_time_formatPad(zm, "0", 2);
  }
  function d3_time_parseLiteralPercent(date, string, i) {
    d3_time_percentRe.lastIndex = 0;
    var n = d3_time_percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
  }
  function d3_time_formatMulti(formats) {
    var n = formats.length, i = -1;
    while (++i < n) formats[i][0] = this(formats[i][0]);
    return function(date) {
      var i = 0, f = formats[i];
      while (!f[1](date)) f = formats[++i];
      return f[0](date);
    };
  }
  d3.locale = function(locale) {
    return {
      numberFormat: d3_locale_numberFormat(locale),
      timeFormat: d3_locale_timeFormat(locale)
    };
  };
  var d3_locale_enUS = d3.locale({
    decimal: ".",
    thousands: ",",
    grouping: [ 3 ],
    currency: [ "$", "" ],
    dateTime: "%a %b %e %X %Y",
    date: "%m/%d/%Y",
    time: "%H:%M:%S",
    periods: [ "AM", "PM" ],
    days: [ "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday" ],
    shortDays: [ "Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat" ],
    months: [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December" ],
    shortMonths: [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ]
  });
  d3.format = d3_locale_enUS.numberFormat;
  d3.geo = {};
  function d3_adder() {}
  d3_adder.prototype = {
    s: 0,
    t: 0,
    add: function(y) {
      d3_adderSum(y, this.t, d3_adderTemp);
      d3_adderSum(d3_adderTemp.s, this.s, this);
      if (this.s) this.t += d3_adderTemp.t; else this.s = d3_adderTemp.t;
    },
    reset: function() {
      this.s = this.t = 0;
    },
    valueOf: function() {
      return this.s;
    }
  };
  var d3_adderTemp = new d3_adder();
  function d3_adderSum(a, b, o) {
    var x = o.s = a + b, bv = x - a, av = x - bv;
    o.t = a - av + (b - bv);
  }
  d3.geo.stream = function(object, listener) {
    if (object && d3_geo_streamObjectType.hasOwnProperty(object.type)) {
      d3_geo_streamObjectType[object.type](object, listener);
    } else {
      d3_geo_streamGeometry(object, listener);
    }
  };
  function d3_geo_streamGeometry(geometry, listener) {
    if (geometry && d3_geo_streamGeometryType.hasOwnProperty(geometry.type)) {
      d3_geo_streamGeometryType[geometry.type](geometry, listener);
    }
  }
  var d3_geo_streamObjectType = {
    Feature: function(feature, listener) {
      d3_geo_streamGeometry(feature.geometry, listener);
    },
    FeatureCollection: function(object, listener) {
      var features = object.features, i = -1, n = features.length;
      while (++i < n) d3_geo_streamGeometry(features[i].geometry, listener);
    }
  };
  var d3_geo_streamGeometryType = {
    Sphere: function(object, listener) {
      listener.sphere();
    },
    Point: function(object, listener) {
      object = object.coordinates;
      listener.point(object[0], object[1], object[2]);
    },
    MultiPoint: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) object = coordinates[i], listener.point(object[0], object[1], object[2]);
    },
    LineString: function(object, listener) {
      d3_geo_streamLine(object.coordinates, listener, 0);
    },
    MultiLineString: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamLine(coordinates[i], listener, 0);
    },
    Polygon: function(object, listener) {
      d3_geo_streamPolygon(object.coordinates, listener);
    },
    MultiPolygon: function(object, listener) {
      var coordinates = object.coordinates, i = -1, n = coordinates.length;
      while (++i < n) d3_geo_streamPolygon(coordinates[i], listener);
    },
    GeometryCollection: function(object, listener) {
      var geometries = object.geometries, i = -1, n = geometries.length;
      while (++i < n) d3_geo_streamGeometry(geometries[i], listener);
    }
  };
  function d3_geo_streamLine(coordinates, listener, closed) {
    var i = -1, n = coordinates.length - closed, coordinate;
    listener.lineStart();
    while (++i < n) coordinate = coordinates[i], listener.point(coordinate[0], coordinate[1], coordinate[2]);
    listener.lineEnd();
  }
  function d3_geo_streamPolygon(coordinates, listener) {
    var i = -1, n = coordinates.length;
    listener.polygonStart();
    while (++i < n) d3_geo_streamLine(coordinates[i], listener, 1);
    listener.polygonEnd();
  }
  d3.geo.area = function(object) {
    d3_geo_areaSum = 0;
    d3.geo.stream(object, d3_geo_area);
    return d3_geo_areaSum;
  };
  var d3_geo_areaSum, d3_geo_areaRingSum = new d3_adder();
  var d3_geo_area = {
    sphere: function() {
      d3_geo_areaSum += 4 * π;
    },
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_areaRingSum.reset();
      d3_geo_area.lineStart = d3_geo_areaRingStart;
    },
    polygonEnd: function() {
      var area = 2 * d3_geo_areaRingSum;
      d3_geo_areaSum += area < 0 ? 4 * π + area : area;
      d3_geo_area.lineStart = d3_geo_area.lineEnd = d3_geo_area.point = d3_noop;
    }
  };
  function d3_geo_areaRingStart() {
    var λ00, φ00, λ0, cosφ0, sinφ0;
    d3_geo_area.point = function(λ, φ) {
      d3_geo_area.point = nextPoint;
      λ0 = (λ00 = λ) * d3_radians, cosφ0 = Math.cos(φ = (φ00 = φ) * d3_radians / 2 + π / 4), 
      sinφ0 = Math.sin(φ);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      φ = φ * d3_radians / 2 + π / 4;
      var dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, cosφ = Math.cos(φ), sinφ = Math.sin(φ), k = sinφ0 * sinφ, u = cosφ0 * cosφ + k * Math.cos(adλ), v = k * sdλ * Math.sin(adλ);
      d3_geo_areaRingSum.add(Math.atan2(v, u));
      λ0 = λ, cosφ0 = cosφ, sinφ0 = sinφ;
    }
    d3_geo_area.lineEnd = function() {
      nextPoint(λ00, φ00);
    };
  }
  function d3_geo_cartesian(spherical) {
    var λ = spherical[0], φ = spherical[1], cosφ = Math.cos(φ);
    return [ cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ) ];
  }
  function d3_geo_cartesianDot(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
  }
  function d3_geo_cartesianCross(a, b) {
    return [ a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0] ];
  }
  function d3_geo_cartesianAdd(a, b) {
    a[0] += b[0];
    a[1] += b[1];
    a[2] += b[2];
  }
  function d3_geo_cartesianScale(vector, k) {
    return [ vector[0] * k, vector[1] * k, vector[2] * k ];
  }
  function d3_geo_cartesianNormalize(d) {
    var l = Math.sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
    d[0] /= l;
    d[1] /= l;
    d[2] /= l;
  }
  function d3_geo_spherical(cartesian) {
    return [ Math.atan2(cartesian[1], cartesian[0]), d3_asin(cartesian[2]) ];
  }
  function d3_geo_sphericalEqual(a, b) {
    return abs(a[0] - b[0]) < ε && abs(a[1] - b[1]) < ε;
  }
  d3.geo.bounds = function() {
    var λ0, φ0, λ1, φ1, λ_, λ__, φ__, p0, dλSum, ranges, range;
    var bound = {
      point: point,
      lineStart: lineStart,
      lineEnd: lineEnd,
      polygonStart: function() {
        bound.point = ringPoint;
        bound.lineStart = ringStart;
        bound.lineEnd = ringEnd;
        dλSum = 0;
        d3_geo_area.polygonStart();
      },
      polygonEnd: function() {
        d3_geo_area.polygonEnd();
        bound.point = point;
        bound.lineStart = lineStart;
        bound.lineEnd = lineEnd;
        if (d3_geo_areaRingSum < 0) λ0 = -(λ1 = 180), φ0 = -(φ1 = 90); else if (dλSum > ε) φ1 = 90; else if (dλSum < -ε) φ0 = -90;
        range[0] = λ0, range[1] = λ1;
      }
    };
    function point(λ, φ) {
      ranges.push(range = [ λ0 = λ, λ1 = λ ]);
      if (φ < φ0) φ0 = φ;
      if (φ > φ1) φ1 = φ;
    }
    function linePoint(λ, φ) {
      var p = d3_geo_cartesian([ λ * d3_radians, φ * d3_radians ]);
      if (p0) {
        var normal = d3_geo_cartesianCross(p0, p), equatorial = [ normal[1], -normal[0], 0 ], inflection = d3_geo_cartesianCross(equatorial, normal);
        d3_geo_cartesianNormalize(inflection);
        inflection = d3_geo_spherical(inflection);
        var dλ = λ - λ_, s = dλ > 0 ? 1 : -1, λi = inflection[0] * d3_degrees * s, antimeridian = abs(dλ) > 180;
        if (antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = inflection[1] * d3_degrees;
          if (φi > φ1) φ1 = φi;
        } else if (λi = (λi + 360) % 360 - 180, antimeridian ^ (s * λ_ < λi && λi < s * λ)) {
          var φi = -inflection[1] * d3_degrees;
          if (φi < φ0) φ0 = φi;
        } else {
          if (φ < φ0) φ0 = φ;
          if (φ > φ1) φ1 = φ;
        }
        if (antimeridian) {
          if (λ < λ_) {
            if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
          } else {
            if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
          }
        } else {
          if (λ1 >= λ0) {
            if (λ < λ0) λ0 = λ;
            if (λ > λ1) λ1 = λ;
          } else {
            if (λ > λ_) {
              if (angle(λ0, λ) > angle(λ0, λ1)) λ1 = λ;
            } else {
              if (angle(λ, λ1) > angle(λ0, λ1)) λ0 = λ;
            }
          }
        }
      } else {
        point(λ, φ);
      }
      p0 = p, λ_ = λ;
    }
    function lineStart() {
      bound.point = linePoint;
    }
    function lineEnd() {
      range[0] = λ0, range[1] = λ1;
      bound.point = point;
      p0 = null;
    }
    function ringPoint(λ, φ) {
      if (p0) {
        var dλ = λ - λ_;
        dλSum += abs(dλ) > 180 ? dλ + (dλ > 0 ? 360 : -360) : dλ;
      } else λ__ = λ, φ__ = φ;
      d3_geo_area.point(λ, φ);
      linePoint(λ, φ);
    }
    function ringStart() {
      d3_geo_area.lineStart();
    }
    function ringEnd() {
      ringPoint(λ__, φ__);
      d3_geo_area.lineEnd();
      if (abs(dλSum) > ε) λ0 = -(λ1 = 180);
      range[0] = λ0, range[1] = λ1;
      p0 = null;
    }
    function angle(λ0, λ1) {
      return (λ1 -= λ0) < 0 ? λ1 + 360 : λ1;
    }
    function compareRanges(a, b) {
      return a[0] - b[0];
    }
    function withinRange(x, range) {
      return range[0] <= range[1] ? range[0] <= x && x <= range[1] : x < range[0] || range[1] < x;
    }
    return function(feature) {
      φ1 = λ1 = -(λ0 = φ0 = Infinity);
      ranges = [];
      d3.geo.stream(feature, bound);
      var n = ranges.length;
      if (n) {
        ranges.sort(compareRanges);
        for (var i = 1, a = ranges[0], b, merged = [ a ]; i < n; ++i) {
          b = ranges[i];
          if (withinRange(b[0], a) || withinRange(b[1], a)) {
            if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
            if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
          } else {
            merged.push(a = b);
          }
        }
        var best = -Infinity, dλ;
        for (var n = merged.length - 1, i = 0, a = merged[n], b; i <= n; a = b, ++i) {
          b = merged[i];
          if ((dλ = angle(a[1], b[0])) > best) best = dλ, λ0 = b[0], λ1 = a[1];
        }
      }
      ranges = range = null;
      return λ0 === Infinity || φ0 === Infinity ? [ [ NaN, NaN ], [ NaN, NaN ] ] : [ [ λ0, φ0 ], [ λ1, φ1 ] ];
    };
  }();
  d3.geo.centroid = function(object) {
    d3_geo_centroidW0 = d3_geo_centroidW1 = d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
    d3.geo.stream(object, d3_geo_centroid);
    var x = d3_geo_centroidX2, y = d3_geo_centroidY2, z = d3_geo_centroidZ2, m = x * x + y * y + z * z;
    if (m < ε2) {
      x = d3_geo_centroidX1, y = d3_geo_centroidY1, z = d3_geo_centroidZ1;
      if (d3_geo_centroidW1 < ε) x = d3_geo_centroidX0, y = d3_geo_centroidY0, z = d3_geo_centroidZ0;
      m = x * x + y * y + z * z;
      if (m < ε2) return [ NaN, NaN ];
    }
    return [ Math.atan2(y, x) * d3_degrees, d3_asin(z / Math.sqrt(m)) * d3_degrees ];
  };
  var d3_geo_centroidW0, d3_geo_centroidW1, d3_geo_centroidX0, d3_geo_centroidY0, d3_geo_centroidZ0, d3_geo_centroidX1, d3_geo_centroidY1, d3_geo_centroidZ1, d3_geo_centroidX2, d3_geo_centroidY2, d3_geo_centroidZ2;
  var d3_geo_centroid = {
    sphere: d3_noop,
    point: d3_geo_centroidPoint,
    lineStart: d3_geo_centroidLineStart,
    lineEnd: d3_geo_centroidLineEnd,
    polygonStart: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_centroid.lineStart = d3_geo_centroidLineStart;
    }
  };
  function d3_geo_centroidPoint(λ, φ) {
    λ *= d3_radians;
    var cosφ = Math.cos(φ *= d3_radians);
    d3_geo_centroidPointXYZ(cosφ * Math.cos(λ), cosφ * Math.sin(λ), Math.sin(φ));
  }
  function d3_geo_centroidPointXYZ(x, y, z) {
    ++d3_geo_centroidW0;
    d3_geo_centroidX0 += (x - d3_geo_centroidX0) / d3_geo_centroidW0;
    d3_geo_centroidY0 += (y - d3_geo_centroidY0) / d3_geo_centroidW0;
    d3_geo_centroidZ0 += (z - d3_geo_centroidZ0) / d3_geo_centroidW0;
  }
  function d3_geo_centroidLineStart() {
    var x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroid.point = nextPoint;
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), w = Math.atan2(Math.sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_centroidLineEnd() {
    d3_geo_centroid.point = d3_geo_centroidPoint;
  }
  function d3_geo_centroidRingStart() {
    var λ00, φ00, x0, y0, z0;
    d3_geo_centroid.point = function(λ, φ) {
      λ00 = λ, φ00 = φ;
      d3_geo_centroid.point = nextPoint;
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians);
      x0 = cosφ * Math.cos(λ);
      y0 = cosφ * Math.sin(λ);
      z0 = Math.sin(φ);
      d3_geo_centroidPointXYZ(x0, y0, z0);
    };
    d3_geo_centroid.lineEnd = function() {
      nextPoint(λ00, φ00);
      d3_geo_centroid.lineEnd = d3_geo_centroidLineEnd;
      d3_geo_centroid.point = d3_geo_centroidPoint;
    };
    function nextPoint(λ, φ) {
      λ *= d3_radians;
      var cosφ = Math.cos(φ *= d3_radians), x = cosφ * Math.cos(λ), y = cosφ * Math.sin(λ), z = Math.sin(φ), cx = y0 * z - z0 * y, cy = z0 * x - x0 * z, cz = x0 * y - y0 * x, m = Math.sqrt(cx * cx + cy * cy + cz * cz), u = x0 * x + y0 * y + z0 * z, v = m && -d3_acos(u) / m, w = Math.atan2(m, u);
      d3_geo_centroidX2 += v * cx;
      d3_geo_centroidY2 += v * cy;
      d3_geo_centroidZ2 += v * cz;
      d3_geo_centroidW1 += w;
      d3_geo_centroidX1 += w * (x0 + (x0 = x));
      d3_geo_centroidY1 += w * (y0 + (y0 = y));
      d3_geo_centroidZ1 += w * (z0 + (z0 = z));
      d3_geo_centroidPointXYZ(x0, y0, z0);
    }
  }
  function d3_geo_compose(a, b) {
    function compose(x, y) {
      return x = a(x, y), b(x[0], x[1]);
    }
    if (a.invert && b.invert) compose.invert = function(x, y) {
      return x = b.invert(x, y), x && a.invert(x[0], x[1]);
    };
    return compose;
  }
  function d3_true() {
    return true;
  }
  function d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener) {
    var subject = [], clip = [];
    segments.forEach(function(segment) {
      if ((n = segment.length - 1) <= 0) return;
      var n, p0 = segment[0], p1 = segment[n];
      if (d3_geo_sphericalEqual(p0, p1)) {
        listener.lineStart();
        for (var i = 0; i < n; ++i) listener.point((p0 = segment[i])[0], p0[1]);
        listener.lineEnd();
        return;
      }
      var a = new d3_geo_clipPolygonIntersection(p0, segment, null, true), b = new d3_geo_clipPolygonIntersection(p0, null, a, false);
      a.o = b;
      subject.push(a);
      clip.push(b);
      a = new d3_geo_clipPolygonIntersection(p1, segment, null, false);
      b = new d3_geo_clipPolygonIntersection(p1, null, a, true);
      a.o = b;
      subject.push(a);
      clip.push(b);
    });
    clip.sort(compare);
    d3_geo_clipPolygonLinkCircular(subject);
    d3_geo_clipPolygonLinkCircular(clip);
    if (!subject.length) return;
    for (var i = 0, entry = clipStartInside, n = clip.length; i < n; ++i) {
      clip[i].e = entry = !entry;
    }
    var start = subject[0], points, point;
    while (1) {
      var current = start, isSubject = true;
      while (current.v) if ((current = current.n) === start) return;
      points = current.z;
      listener.lineStart();
      do {
        current.v = current.o.v = true;
        if (current.e) {
          if (isSubject) {
            for (var i = 0, n = points.length; i < n; ++i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.n.x, 1, listener);
          }
          current = current.n;
        } else {
          if (isSubject) {
            points = current.p.z;
            for (var i = points.length - 1; i >= 0; --i) listener.point((point = points[i])[0], point[1]);
          } else {
            interpolate(current.x, current.p.x, -1, listener);
          }
          current = current.p;
        }
        current = current.o;
        points = current.z;
        isSubject = !isSubject;
      } while (!current.v);
      listener.lineEnd();
    }
  }
  function d3_geo_clipPolygonLinkCircular(array) {
    if (!(n = array.length)) return;
    var n, i = 0, a = array[0], b;
    while (++i < n) {
      a.n = b = array[i];
      b.p = a;
      a = b;
    }
    a.n = b = array[0];
    b.p = a;
  }
  function d3_geo_clipPolygonIntersection(point, points, other, entry) {
    this.x = point;
    this.z = points;
    this.o = other;
    this.e = entry;
    this.v = false;
    this.n = this.p = null;
  }
  function d3_geo_clip(pointVisible, clipLine, interpolate, clipStart) {
    return function(rotate, listener) {
      var line = clipLine(listener), rotatedClipStart = rotate.invert(clipStart[0], clipStart[1]);
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          clip.point = pointRing;
          clip.lineStart = ringStart;
          clip.lineEnd = ringEnd;
          segments = [];
          polygon = [];
        },
        polygonEnd: function() {
          clip.point = point;
          clip.lineStart = lineStart;
          clip.lineEnd = lineEnd;
          segments = d3.merge(segments);
          var clipStartInside = d3_geo_pointInPolygon(rotatedClipStart, polygon);
          if (segments.length) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            d3_geo_clipPolygon(segments, d3_geo_clipSort, clipStartInside, interpolate, listener);
          } else if (clipStartInside) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            interpolate(null, null, 1, listener);
            listener.lineEnd();
          }
          if (polygonStarted) listener.polygonEnd(), polygonStarted = false;
          segments = polygon = null;
        },
        sphere: function() {
          listener.polygonStart();
          listener.lineStart();
          interpolate(null, null, 1, listener);
          listener.lineEnd();
          listener.polygonEnd();
        }
      };
      function point(λ, φ) {
        var point = rotate(λ, φ);
        if (pointVisible(λ = point[0], φ = point[1])) listener.point(λ, φ);
      }
      function pointLine(λ, φ) {
        var point = rotate(λ, φ);
        line.point(point[0], point[1]);
      }
      function lineStart() {
        clip.point = pointLine;
        line.lineStart();
      }
      function lineEnd() {
        clip.point = point;
        line.lineEnd();
      }
      var segments;
      var buffer = d3_geo_clipBufferListener(), ringListener = clipLine(buffer), polygonStarted = false, polygon, ring;
      function pointRing(λ, φ) {
        ring.push([ λ, φ ]);
        var point = rotate(λ, φ);
        ringListener.point(point[0], point[1]);
      }
      function ringStart() {
        ringListener.lineStart();
        ring = [];
      }
      function ringEnd() {
        pointRing(ring[0][0], ring[0][1]);
        ringListener.lineEnd();
        var clean = ringListener.clean(), ringSegments = buffer.buffer(), segment, n = ringSegments.length;
        ring.pop();
        polygon.push(ring);
        ring = null;
        if (!n) return;
        if (clean & 1) {
          segment = ringSegments[0];
          var n = segment.length - 1, i = -1, point;
          if (n > 0) {
            if (!polygonStarted) listener.polygonStart(), polygonStarted = true;
            listener.lineStart();
            while (++i < n) listener.point((point = segment[i])[0], point[1]);
            listener.lineEnd();
          }
          return;
        }
        if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
        segments.push(ringSegments.filter(d3_geo_clipSegmentLength1));
      }
      return clip;
    };
  }
  function d3_geo_clipSegmentLength1(segment) {
    return segment.length > 1;
  }
  function d3_geo_clipBufferListener() {
    var lines = [], line;
    return {
      lineStart: function() {
        lines.push(line = []);
      },
      point: function(λ, φ) {
        line.push([ λ, φ ]);
      },
      lineEnd: d3_noop,
      buffer: function() {
        var buffer = lines;
        lines = [];
        line = null;
        return buffer;
      },
      rejoin: function() {
        if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
      }
    };
  }
  function d3_geo_clipSort(a, b) {
    return ((a = a.x)[0] < 0 ? a[1] - halfπ - ε : halfπ - a[1]) - ((b = b.x)[0] < 0 ? b[1] - halfπ - ε : halfπ - b[1]);
  }
  var d3_geo_clipAntimeridian = d3_geo_clip(d3_true, d3_geo_clipAntimeridianLine, d3_geo_clipAntimeridianInterpolate, [ -π, -π / 2 ]);
  function d3_geo_clipAntimeridianLine(listener) {
    var λ0 = NaN, φ0 = NaN, sλ0 = NaN, clean;
    return {
      lineStart: function() {
        listener.lineStart();
        clean = 1;
      },
      point: function(λ1, φ1) {
        var sλ1 = λ1 > 0 ? π : -π, dλ = abs(λ1 - λ0);
        if (abs(dλ - π) < ε) {
          listener.point(λ0, φ0 = (φ0 + φ1) / 2 > 0 ? halfπ : -halfπ);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          listener.point(λ1, φ0);
          clean = 0;
        } else if (sλ0 !== sλ1 && dλ >= π) {
          if (abs(λ0 - sλ0) < ε) λ0 -= sλ0 * ε;
          if (abs(λ1 - sλ1) < ε) λ1 -= sλ1 * ε;
          φ0 = d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1);
          listener.point(sλ0, φ0);
          listener.lineEnd();
          listener.lineStart();
          listener.point(sλ1, φ0);
          clean = 0;
        }
        listener.point(λ0 = λ1, φ0 = φ1);
        sλ0 = sλ1;
      },
      lineEnd: function() {
        listener.lineEnd();
        λ0 = φ0 = NaN;
      },
      clean: function() {
        return 2 - clean;
      }
    };
  }
  function d3_geo_clipAntimeridianIntersect(λ0, φ0, λ1, φ1) {
    var cosφ0, cosφ1, sinλ0_λ1 = Math.sin(λ0 - λ1);
    return abs(sinλ0_λ1) > ε ? Math.atan((Math.sin(φ0) * (cosφ1 = Math.cos(φ1)) * Math.sin(λ1) - Math.sin(φ1) * (cosφ0 = Math.cos(φ0)) * Math.sin(λ0)) / (cosφ0 * cosφ1 * sinλ0_λ1)) : (φ0 + φ1) / 2;
  }
  function d3_geo_clipAntimeridianInterpolate(from, to, direction, listener) {
    var φ;
    if (from == null) {
      φ = direction * halfπ;
      listener.point(-π, φ);
      listener.point(0, φ);
      listener.point(π, φ);
      listener.point(π, 0);
      listener.point(π, -φ);
      listener.point(0, -φ);
      listener.point(-π, -φ);
      listener.point(-π, 0);
      listener.point(-π, φ);
    } else if (abs(from[0] - to[0]) > ε) {
      var s = from[0] < to[0] ? π : -π;
      φ = direction * s / 2;
      listener.point(-s, φ);
      listener.point(0, φ);
      listener.point(s, φ);
    } else {
      listener.point(to[0], to[1]);
    }
  }
  function d3_geo_pointInPolygon(point, polygon) {
    var meridian = point[0], parallel = point[1], meridianNormal = [ Math.sin(meridian), -Math.cos(meridian), 0 ], polarAngle = 0, winding = 0;
    d3_geo_areaRingSum.reset();
    for (var i = 0, n = polygon.length; i < n; ++i) {
      var ring = polygon[i], m = ring.length;
      if (!m) continue;
      var point0 = ring[0], λ0 = point0[0], φ0 = point0[1] / 2 + π / 4, sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), j = 1;
      while (true) {
        if (j === m) j = 0;
        point = ring[j];
        var λ = point[0], φ = point[1] / 2 + π / 4, sinφ = Math.sin(φ), cosφ = Math.cos(φ), dλ = λ - λ0, sdλ = dλ >= 0 ? 1 : -1, adλ = sdλ * dλ, antimeridian = adλ > π, k = sinφ0 * sinφ;
        d3_geo_areaRingSum.add(Math.atan2(k * sdλ * Math.sin(adλ), cosφ0 * cosφ + k * Math.cos(adλ)));
        polarAngle += antimeridian ? dλ + sdλ * τ : dλ;
        if (antimeridian ^ λ0 >= meridian ^ λ >= meridian) {
          var arc = d3_geo_cartesianCross(d3_geo_cartesian(point0), d3_geo_cartesian(point));
          d3_geo_cartesianNormalize(arc);
          var intersection = d3_geo_cartesianCross(meridianNormal, arc);
          d3_geo_cartesianNormalize(intersection);
          var φarc = (antimeridian ^ dλ >= 0 ? -1 : 1) * d3_asin(intersection[2]);
          if (parallel > φarc || parallel === φarc && (arc[0] || arc[1])) {
            winding += antimeridian ^ dλ >= 0 ? 1 : -1;
          }
        }
        if (!j++) break;
        λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ, point0 = point;
      }
    }
    return (polarAngle < -ε || polarAngle < ε && d3_geo_areaRingSum < -ε) ^ winding & 1;
  }
  function d3_geo_clipCircle(radius) {
    var cr = Math.cos(radius), smallRadius = cr > 0, notHemisphere = abs(cr) > ε, interpolate = d3_geo_circleInterpolate(radius, 6 * d3_radians);
    return d3_geo_clip(visible, clipLine, interpolate, smallRadius ? [ 0, -radius ] : [ -π, radius - π ]);
    function visible(λ, φ) {
      return Math.cos(λ) * Math.cos(φ) > cr;
    }
    function clipLine(listener) {
      var point0, c0, v0, v00, clean;
      return {
        lineStart: function() {
          v00 = v0 = false;
          clean = 1;
        },
        point: function(λ, φ) {
          var point1 = [ λ, φ ], point2, v = visible(λ, φ), c = smallRadius ? v ? 0 : code(λ, φ) : v ? code(λ + (λ < 0 ? π : -π), φ) : 0;
          if (!point0 && (v00 = v0 = v)) listener.lineStart();
          if (v !== v0) {
            point2 = intersect(point0, point1);
            if (d3_geo_sphericalEqual(point0, point2) || d3_geo_sphericalEqual(point1, point2)) {
              point1[0] += ε;
              point1[1] += ε;
              v = visible(point1[0], point1[1]);
            }
          }
          if (v !== v0) {
            clean = 0;
            if (v) {
              listener.lineStart();
              point2 = intersect(point1, point0);
              listener.point(point2[0], point2[1]);
            } else {
              point2 = intersect(point0, point1);
              listener.point(point2[0], point2[1]);
              listener.lineEnd();
            }
            point0 = point2;
          } else if (notHemisphere && point0 && smallRadius ^ v) {
            var t;
            if (!(c & c0) && (t = intersect(point1, point0, true))) {
              clean = 0;
              if (smallRadius) {
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
              } else {
                listener.point(t[1][0], t[1][1]);
                listener.lineEnd();
                listener.lineStart();
                listener.point(t[0][0], t[0][1]);
              }
            }
          }
          if (v && (!point0 || !d3_geo_sphericalEqual(point0, point1))) {
            listener.point(point1[0], point1[1]);
          }
          point0 = point1, v0 = v, c0 = c;
        },
        lineEnd: function() {
          if (v0) listener.lineEnd();
          point0 = null;
        },
        clean: function() {
          return clean | (v00 && v0) << 1;
        }
      };
    }
    function intersect(a, b, two) {
      var pa = d3_geo_cartesian(a), pb = d3_geo_cartesian(b);
      var n1 = [ 1, 0, 0 ], n2 = d3_geo_cartesianCross(pa, pb), n2n2 = d3_geo_cartesianDot(n2, n2), n1n2 = n2[0], determinant = n2n2 - n1n2 * n1n2;
      if (!determinant) return !two && a;
      var c1 = cr * n2n2 / determinant, c2 = -cr * n1n2 / determinant, n1xn2 = d3_geo_cartesianCross(n1, n2), A = d3_geo_cartesianScale(n1, c1), B = d3_geo_cartesianScale(n2, c2);
      d3_geo_cartesianAdd(A, B);
      var u = n1xn2, w = d3_geo_cartesianDot(A, u), uu = d3_geo_cartesianDot(u, u), t2 = w * w - uu * (d3_geo_cartesianDot(A, A) - 1);
      if (t2 < 0) return;
      var t = Math.sqrt(t2), q = d3_geo_cartesianScale(u, (-w - t) / uu);
      d3_geo_cartesianAdd(q, A);
      q = d3_geo_spherical(q);
      if (!two) return q;
      var λ0 = a[0], λ1 = b[0], φ0 = a[1], φ1 = b[1], z;
      if (λ1 < λ0) z = λ0, λ0 = λ1, λ1 = z;
      var δλ = λ1 - λ0, polar = abs(δλ - π) < ε, meridian = polar || δλ < ε;
      if (!polar && φ1 < φ0) z = φ0, φ0 = φ1, φ1 = z;
      if (meridian ? polar ? φ0 + φ1 > 0 ^ q[1] < (abs(q[0] - λ0) < ε ? φ0 : φ1) : φ0 <= q[1] && q[1] <= φ1 : δλ > π ^ (λ0 <= q[0] && q[0] <= λ1)) {
        var q1 = d3_geo_cartesianScale(u, (-w + t) / uu);
        d3_geo_cartesianAdd(q1, A);
        return [ q, d3_geo_spherical(q1) ];
      }
    }
    function code(λ, φ) {
      var r = smallRadius ? radius : π - radius, code = 0;
      if (λ < -r) code |= 1; else if (λ > r) code |= 2;
      if (φ < -r) code |= 4; else if (φ > r) code |= 8;
      return code;
    }
  }
  function d3_geom_clipLine(x0, y0, x1, y1) {
    return function(line) {
      var a = line.a, b = line.b, ax = a.x, ay = a.y, bx = b.x, by = b.y, t0 = 0, t1 = 1, dx = bx - ax, dy = by - ay, r;
      r = x0 - ax;
      if (!dx && r > 0) return;
      r /= dx;
      if (dx < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dx > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = x1 - ax;
      if (!dx && r < 0) return;
      r /= dx;
      if (dx < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dx > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      r = y0 - ay;
      if (!dy && r > 0) return;
      r /= dy;
      if (dy < 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      } else if (dy > 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      }
      r = y1 - ay;
      if (!dy && r < 0) return;
      r /= dy;
      if (dy < 0) {
        if (r > t1) return;
        if (r > t0) t0 = r;
      } else if (dy > 0) {
        if (r < t0) return;
        if (r < t1) t1 = r;
      }
      if (t0 > 0) line.a = {
        x: ax + t0 * dx,
        y: ay + t0 * dy
      };
      if (t1 < 1) line.b = {
        x: ax + t1 * dx,
        y: ay + t1 * dy
      };
      return line;
    };
  }
  var d3_geo_clipExtentMAX = 1e9;
  d3.geo.clipExtent = function() {
    var x0, y0, x1, y1, stream, clip, clipExtent = {
      stream: function(output) {
        if (stream) stream.valid = false;
        stream = clip(output);
        stream.valid = true;
        return stream;
      },
      extent: function(_) {
        if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
        clip = d3_geo_clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]);
        if (stream) stream.valid = false, stream = null;
        return clipExtent;
      }
    };
    return clipExtent.extent([ [ 0, 0 ], [ 960, 500 ] ]);
  };
  function d3_geo_clipExtent(x0, y0, x1, y1) {
    return function(listener) {
      var listener_ = listener, bufferListener = d3_geo_clipBufferListener(), clipLine = d3_geom_clipLine(x0, y0, x1, y1), segments, polygon, ring;
      var clip = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          listener = bufferListener;
          segments = [];
          polygon = [];
          clean = true;
        },
        polygonEnd: function() {
          listener = listener_;
          segments = d3.merge(segments);
          var clipStartInside = insidePolygon([ x0, y1 ]), inside = clean && clipStartInside, visible = segments.length;
          if (inside || visible) {
            listener.polygonStart();
            if (inside) {
              listener.lineStart();
              interpolate(null, null, 1, listener);
              listener.lineEnd();
            }
            if (visible) {
              d3_geo_clipPolygon(segments, compare, clipStartInside, interpolate, listener);
            }
            listener.polygonEnd();
          }
          segments = polygon = ring = null;
        }
      };
      function insidePolygon(p) {
        var wn = 0, n = polygon.length, y = p[1];
        for (var i = 0; i < n; ++i) {
          for (var j = 1, v = polygon[i], m = v.length, a = v[0], b; j < m; ++j) {
            b = v[j];
            if (a[1] <= y) {
              if (b[1] > y && d3_cross2d(a, b, p) > 0) ++wn;
            } else {
              if (b[1] <= y && d3_cross2d(a, b, p) < 0) --wn;
            }
            a = b;
          }
        }
        return wn !== 0;
      }
      function interpolate(from, to, direction, listener) {
        var a = 0, a1 = 0;
        if (from == null || (a = corner(from, direction)) !== (a1 = corner(to, direction)) || comparePoints(from, to) < 0 ^ direction > 0) {
          do {
            listener.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
          } while ((a = (a + direction + 4) % 4) !== a1);
        } else {
          listener.point(to[0], to[1]);
        }
      }
      function pointVisible(x, y) {
        return x0 <= x && x <= x1 && y0 <= y && y <= y1;
      }
      function point(x, y) {
        if (pointVisible(x, y)) listener.point(x, y);
      }
      var x__, y__, v__, x_, y_, v_, first, clean;
      function lineStart() {
        clip.point = linePoint;
        if (polygon) polygon.push(ring = []);
        first = true;
        v_ = false;
        x_ = y_ = NaN;
      }
      function lineEnd() {
        if (segments) {
          linePoint(x__, y__);
          if (v__ && v_) bufferListener.rejoin();
          segments.push(bufferListener.buffer());
        }
        clip.point = point;
        if (v_) listener.lineEnd();
      }
      function linePoint(x, y) {
        x = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, x));
        y = Math.max(-d3_geo_clipExtentMAX, Math.min(d3_geo_clipExtentMAX, y));
        var v = pointVisible(x, y);
        if (polygon) ring.push([ x, y ]);
        if (first) {
          x__ = x, y__ = y, v__ = v;
          first = false;
          if (v) {
            listener.lineStart();
            listener.point(x, y);
          }
        } else {
          if (v && v_) listener.point(x, y); else {
            var l = {
              a: {
                x: x_,
                y: y_
              },
              b: {
                x: x,
                y: y
              }
            };
            if (clipLine(l)) {
              if (!v_) {
                listener.lineStart();
                listener.point(l.a.x, l.a.y);
              }
              listener.point(l.b.x, l.b.y);
              if (!v) listener.lineEnd();
              clean = false;
            } else if (v) {
              listener.lineStart();
              listener.point(x, y);
              clean = false;
            }
          }
        }
        x_ = x, y_ = y, v_ = v;
      }
      return clip;
    };
    function corner(p, direction) {
      return abs(p[0] - x0) < ε ? direction > 0 ? 0 : 3 : abs(p[0] - x1) < ε ? direction > 0 ? 2 : 1 : abs(p[1] - y0) < ε ? direction > 0 ? 1 : 0 : direction > 0 ? 3 : 2;
    }
    function compare(a, b) {
      return comparePoints(a.x, b.x);
    }
    function comparePoints(a, b) {
      var ca = corner(a, 1), cb = corner(b, 1);
      return ca !== cb ? ca - cb : ca === 0 ? b[1] - a[1] : ca === 1 ? a[0] - b[0] : ca === 2 ? a[1] - b[1] : b[0] - a[0];
    }
  }
  function d3_geo_conic(projectAt) {
    var φ0 = 0, φ1 = π / 3, m = d3_geo_projectionMutator(projectAt), p = m(φ0, φ1);
    p.parallels = function(_) {
      if (!arguments.length) return [ φ0 / π * 180, φ1 / π * 180 ];
      return m(φ0 = _[0] * π / 180, φ1 = _[1] * π / 180);
    };
    return p;
  }
  function d3_geo_conicEqualArea(φ0, φ1) {
    var sinφ0 = Math.sin(φ0), n = (sinφ0 + Math.sin(φ1)) / 2, C = 1 + sinφ0 * (2 * n - sinφ0), ρ0 = Math.sqrt(C) / n;
    function forward(λ, φ) {
      var ρ = Math.sqrt(C - 2 * n * Math.sin(φ)) / n;
      return [ ρ * Math.sin(λ *= n), ρ0 - ρ * Math.cos(λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = ρ0 - y;
      return [ Math.atan2(x, ρ0_y) / n, d3_asin((C - (x * x + ρ0_y * ρ0_y) * n * n) / (2 * n)) ];
    };
    return forward;
  }
  (d3.geo.conicEqualArea = function() {
    return d3_geo_conic(d3_geo_conicEqualArea);
  }).raw = d3_geo_conicEqualArea;
  d3.geo.albers = function() {
    return d3.geo.conicEqualArea().rotate([ 96, 0 ]).center([ -.6, 38.7 ]).parallels([ 29.5, 45.5 ]).scale(1070);
  };
  d3.geo.albersUsa = function() {
    var lower48 = d3.geo.albers();
    var alaska = d3.geo.conicEqualArea().rotate([ 154, 0 ]).center([ -2, 58.5 ]).parallels([ 55, 65 ]);
    var hawaii = d3.geo.conicEqualArea().rotate([ 157, 0 ]).center([ -3, 19.9 ]).parallels([ 8, 18 ]);
    var point, pointStream = {
      point: function(x, y) {
        point = [ x, y ];
      }
    }, lower48Point, alaskaPoint, hawaiiPoint;
    function albersUsa(coordinates) {
      var x = coordinates[0], y = coordinates[1];
      point = null;
      (lower48Point(x, y), point) || (alaskaPoint(x, y), point) || hawaiiPoint(x, y);
      return point;
    }
    albersUsa.invert = function(coordinates) {
      var k = lower48.scale(), t = lower48.translate(), x = (coordinates[0] - t[0]) / k, y = (coordinates[1] - t[1]) / k;
      return (y >= .12 && y < .234 && x >= -.425 && x < -.214 ? alaska : y >= .166 && y < .234 && x >= -.214 && x < -.115 ? hawaii : lower48).invert(coordinates);
    };
    albersUsa.stream = function(stream) {
      var lower48Stream = lower48.stream(stream), alaskaStream = alaska.stream(stream), hawaiiStream = hawaii.stream(stream);
      return {
        point: function(x, y) {
          lower48Stream.point(x, y);
          alaskaStream.point(x, y);
          hawaiiStream.point(x, y);
        },
        sphere: function() {
          lower48Stream.sphere();
          alaskaStream.sphere();
          hawaiiStream.sphere();
        },
        lineStart: function() {
          lower48Stream.lineStart();
          alaskaStream.lineStart();
          hawaiiStream.lineStart();
        },
        lineEnd: function() {
          lower48Stream.lineEnd();
          alaskaStream.lineEnd();
          hawaiiStream.lineEnd();
        },
        polygonStart: function() {
          lower48Stream.polygonStart();
          alaskaStream.polygonStart();
          hawaiiStream.polygonStart();
        },
        polygonEnd: function() {
          lower48Stream.polygonEnd();
          alaskaStream.polygonEnd();
          hawaiiStream.polygonEnd();
        }
      };
    };
    albersUsa.precision = function(_) {
      if (!arguments.length) return lower48.precision();
      lower48.precision(_);
      alaska.precision(_);
      hawaii.precision(_);
      return albersUsa;
    };
    albersUsa.scale = function(_) {
      if (!arguments.length) return lower48.scale();
      lower48.scale(_);
      alaska.scale(_ * .35);
      hawaii.scale(_);
      return albersUsa.translate(lower48.translate());
    };
    albersUsa.translate = function(_) {
      if (!arguments.length) return lower48.translate();
      var k = lower48.scale(), x = +_[0], y = +_[1];
      lower48Point = lower48.translate(_).clipExtent([ [ x - .455 * k, y - .238 * k ], [ x + .455 * k, y + .238 * k ] ]).stream(pointStream).point;
      alaskaPoint = alaska.translate([ x - .307 * k, y + .201 * k ]).clipExtent([ [ x - .425 * k + ε, y + .12 * k + ε ], [ x - .214 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      hawaiiPoint = hawaii.translate([ x - .205 * k, y + .212 * k ]).clipExtent([ [ x - .214 * k + ε, y + .166 * k + ε ], [ x - .115 * k - ε, y + .234 * k - ε ] ]).stream(pointStream).point;
      return albersUsa;
    };
    return albersUsa.scale(1070);
  };
  var d3_geo_pathAreaSum, d3_geo_pathAreaPolygon, d3_geo_pathArea = {
    point: d3_noop,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: function() {
      d3_geo_pathAreaPolygon = 0;
      d3_geo_pathArea.lineStart = d3_geo_pathAreaRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathArea.lineStart = d3_geo_pathArea.lineEnd = d3_geo_pathArea.point = d3_noop;
      d3_geo_pathAreaSum += abs(d3_geo_pathAreaPolygon / 2);
    }
  };
  function d3_geo_pathAreaRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathArea.point = function(x, y) {
      d3_geo_pathArea.point = nextPoint;
      x00 = x0 = x, y00 = y0 = y;
    };
    function nextPoint(x, y) {
      d3_geo_pathAreaPolygon += y0 * x - x0 * y;
      x0 = x, y0 = y;
    }
    d3_geo_pathArea.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  var d3_geo_pathBoundsX0, d3_geo_pathBoundsY0, d3_geo_pathBoundsX1, d3_geo_pathBoundsY1;
  var d3_geo_pathBounds = {
    point: d3_geo_pathBoundsPoint,
    lineStart: d3_noop,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_pathBoundsPoint(x, y) {
    if (x < d3_geo_pathBoundsX0) d3_geo_pathBoundsX0 = x;
    if (x > d3_geo_pathBoundsX1) d3_geo_pathBoundsX1 = x;
    if (y < d3_geo_pathBoundsY0) d3_geo_pathBoundsY0 = y;
    if (y > d3_geo_pathBoundsY1) d3_geo_pathBoundsY1 = y;
  }
  function d3_geo_pathBuffer() {
    var pointCircle = d3_geo_pathBufferCircle(4.5), buffer = [];
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointCircle = d3_geo_pathBufferCircle(_);
        return stream;
      },
      result: function() {
        if (buffer.length) {
          var result = buffer.join("");
          buffer = [];
          return result;
        }
      }
    };
    function point(x, y) {
      buffer.push("M", x, ",", y, pointCircle);
    }
    function pointLineStart(x, y) {
      buffer.push("M", x, ",", y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      buffer.push("L", x, ",", y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      buffer.push("Z");
    }
    return stream;
  }
  function d3_geo_pathBufferCircle(radius) {
    return "m0," + radius + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius + "z";
  }
  var d3_geo_pathCentroid = {
    point: d3_geo_pathCentroidPoint,
    lineStart: d3_geo_pathCentroidLineStart,
    lineEnd: d3_geo_pathCentroidLineEnd,
    polygonStart: function() {
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidRingStart;
    },
    polygonEnd: function() {
      d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
      d3_geo_pathCentroid.lineStart = d3_geo_pathCentroidLineStart;
      d3_geo_pathCentroid.lineEnd = d3_geo_pathCentroidLineEnd;
    }
  };
  function d3_geo_pathCentroidPoint(x, y) {
    d3_geo_centroidX0 += x;
    d3_geo_centroidY0 += y;
    ++d3_geo_centroidZ0;
  }
  function d3_geo_pathCentroidLineStart() {
    var x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
  }
  function d3_geo_pathCentroidLineEnd() {
    d3_geo_pathCentroid.point = d3_geo_pathCentroidPoint;
  }
  function d3_geo_pathCentroidRingStart() {
    var x00, y00, x0, y0;
    d3_geo_pathCentroid.point = function(x, y) {
      d3_geo_pathCentroid.point = nextPoint;
      d3_geo_pathCentroidPoint(x00 = x0 = x, y00 = y0 = y);
    };
    function nextPoint(x, y) {
      var dx = x - x0, dy = y - y0, z = Math.sqrt(dx * dx + dy * dy);
      d3_geo_centroidX1 += z * (x0 + x) / 2;
      d3_geo_centroidY1 += z * (y0 + y) / 2;
      d3_geo_centroidZ1 += z;
      z = y0 * x - x0 * y;
      d3_geo_centroidX2 += z * (x0 + x);
      d3_geo_centroidY2 += z * (y0 + y);
      d3_geo_centroidZ2 += z * 3;
      d3_geo_pathCentroidPoint(x0 = x, y0 = y);
    }
    d3_geo_pathCentroid.lineEnd = function() {
      nextPoint(x00, y00);
    };
  }
  function d3_geo_pathContext(context) {
    var pointRadius = 4.5;
    var stream = {
      point: point,
      lineStart: function() {
        stream.point = pointLineStart;
      },
      lineEnd: lineEnd,
      polygonStart: function() {
        stream.lineEnd = lineEndPolygon;
      },
      polygonEnd: function() {
        stream.lineEnd = lineEnd;
        stream.point = point;
      },
      pointRadius: function(_) {
        pointRadius = _;
        return stream;
      },
      result: d3_noop
    };
    function point(x, y) {
      context.moveTo(x + pointRadius, y);
      context.arc(x, y, pointRadius, 0, τ);
    }
    function pointLineStart(x, y) {
      context.moveTo(x, y);
      stream.point = pointLine;
    }
    function pointLine(x, y) {
      context.lineTo(x, y);
    }
    function lineEnd() {
      stream.point = point;
    }
    function lineEndPolygon() {
      context.closePath();
    }
    return stream;
  }
  function d3_geo_resample(project) {
    var δ2 = .5, cosMinDistance = Math.cos(30 * d3_radians), maxDepth = 16;
    function resample(stream) {
      return (maxDepth ? resampleRecursive : resampleNone)(stream);
    }
    function resampleNone(stream) {
      return d3_geo_transformPoint(stream, function(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      });
    }
    function resampleRecursive(stream) {
      var λ00, φ00, x00, y00, a00, b00, c00, λ0, x0, y0, a0, b0, c0;
      var resample = {
        point: point,
        lineStart: lineStart,
        lineEnd: lineEnd,
        polygonStart: function() {
          stream.polygonStart();
          resample.lineStart = ringStart;
        },
        polygonEnd: function() {
          stream.polygonEnd();
          resample.lineStart = lineStart;
        }
      };
      function point(x, y) {
        x = project(x, y);
        stream.point(x[0], x[1]);
      }
      function lineStart() {
        x0 = NaN;
        resample.point = linePoint;
        stream.lineStart();
      }
      function linePoint(λ, φ) {
        var c = d3_geo_cartesian([ λ, φ ]), p = project(λ, φ);
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x0 = p[0], y0 = p[1], λ0 = λ, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
        stream.point(x0, y0);
      }
      function lineEnd() {
        resample.point = point;
        stream.lineEnd();
      }
      function ringStart() {
        lineStart();
        resample.point = ringPoint;
        resample.lineEnd = ringEnd;
      }
      function ringPoint(λ, φ) {
        linePoint(λ00 = λ, φ00 = φ), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
        resample.point = linePoint;
      }
      function ringEnd() {
        resampleLineTo(x0, y0, λ0, a0, b0, c0, x00, y00, λ00, a00, b00, c00, maxDepth, stream);
        resample.lineEnd = lineEnd;
        lineEnd();
      }
      return resample;
    }
    function resampleLineTo(x0, y0, λ0, a0, b0, c0, x1, y1, λ1, a1, b1, c1, depth, stream) {
      var dx = x1 - x0, dy = y1 - y0, d2 = dx * dx + dy * dy;
      if (d2 > 4 * δ2 && depth--) {
        var a = a0 + a1, b = b0 + b1, c = c0 + c1, m = Math.sqrt(a * a + b * b + c * c), φ2 = Math.asin(c /= m), λ2 = abs(abs(c) - 1) < ε || abs(λ0 - λ1) < ε ? (λ0 + λ1) / 2 : Math.atan2(b, a), p = project(λ2, φ2), x2 = p[0], y2 = p[1], dx2 = x2 - x0, dy2 = y2 - y0, dz = dy * dx2 - dx * dy2;
        if (dz * dz / d2 > δ2 || abs((dx * dx2 + dy * dy2) / d2 - .5) > .3 || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) {
          resampleLineTo(x0, y0, λ0, a0, b0, c0, x2, y2, λ2, a /= m, b /= m, c, depth, stream);
          stream.point(x2, y2);
          resampleLineTo(x2, y2, λ2, a, b, c, x1, y1, λ1, a1, b1, c1, depth, stream);
        }
      }
    }
    resample.precision = function(_) {
      if (!arguments.length) return Math.sqrt(δ2);
      maxDepth = (δ2 = _ * _) > 0 && 16;
      return resample;
    };
    return resample;
  }
  d3.geo.path = function() {
    var pointRadius = 4.5, projection, context, projectStream, contextStream, cacheStream;
    function path(object) {
      if (object) {
        if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
        if (!cacheStream || !cacheStream.valid) cacheStream = projectStream(contextStream);
        d3.geo.stream(object, cacheStream);
      }
      return contextStream.result();
    }
    path.area = function(object) {
      d3_geo_pathAreaSum = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathArea));
      return d3_geo_pathAreaSum;
    };
    path.centroid = function(object) {
      d3_geo_centroidX0 = d3_geo_centroidY0 = d3_geo_centroidZ0 = d3_geo_centroidX1 = d3_geo_centroidY1 = d3_geo_centroidZ1 = d3_geo_centroidX2 = d3_geo_centroidY2 = d3_geo_centroidZ2 = 0;
      d3.geo.stream(object, projectStream(d3_geo_pathCentroid));
      return d3_geo_centroidZ2 ? [ d3_geo_centroidX2 / d3_geo_centroidZ2, d3_geo_centroidY2 / d3_geo_centroidZ2 ] : d3_geo_centroidZ1 ? [ d3_geo_centroidX1 / d3_geo_centroidZ1, d3_geo_centroidY1 / d3_geo_centroidZ1 ] : d3_geo_centroidZ0 ? [ d3_geo_centroidX0 / d3_geo_centroidZ0, d3_geo_centroidY0 / d3_geo_centroidZ0 ] : [ NaN, NaN ];
    };
    path.bounds = function(object) {
      d3_geo_pathBoundsX1 = d3_geo_pathBoundsY1 = -(d3_geo_pathBoundsX0 = d3_geo_pathBoundsY0 = Infinity);
      d3.geo.stream(object, projectStream(d3_geo_pathBounds));
      return [ [ d3_geo_pathBoundsX0, d3_geo_pathBoundsY0 ], [ d3_geo_pathBoundsX1, d3_geo_pathBoundsY1 ] ];
    };
    path.projection = function(_) {
      if (!arguments.length) return projection;
      projectStream = (projection = _) ? _.stream || d3_geo_pathProjectStream(_) : d3_identity;
      return reset();
    };
    path.context = function(_) {
      if (!arguments.length) return context;
      contextStream = (context = _) == null ? new d3_geo_pathBuffer() : new d3_geo_pathContext(_);
      if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
      return reset();
    };
    path.pointRadius = function(_) {
      if (!arguments.length) return pointRadius;
      pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
      return path;
    };
    function reset() {
      cacheStream = null;
      return path;
    }
    return path.projection(d3.geo.albersUsa()).context(null);
  };
  function d3_geo_pathProjectStream(project) {
    var resample = d3_geo_resample(function(x, y) {
      return project([ x * d3_degrees, y * d3_degrees ]);
    });
    return function(stream) {
      return d3_geo_projectionRadians(resample(stream));
    };
  }
  d3.geo.transform = function(methods) {
    return {
      stream: function(stream) {
        var transform = new d3_geo_transform(stream);
        for (var k in methods) transform[k] = methods[k];
        return transform;
      }
    };
  };
  function d3_geo_transform(stream) {
    this.stream = stream;
  }
  d3_geo_transform.prototype = {
    point: function(x, y) {
      this.stream.point(x, y);
    },
    sphere: function() {
      this.stream.sphere();
    },
    lineStart: function() {
      this.stream.lineStart();
    },
    lineEnd: function() {
      this.stream.lineEnd();
    },
    polygonStart: function() {
      this.stream.polygonStart();
    },
    polygonEnd: function() {
      this.stream.polygonEnd();
    }
  };
  function d3_geo_transformPoint(stream, point) {
    return {
      point: point,
      sphere: function() {
        stream.sphere();
      },
      lineStart: function() {
        stream.lineStart();
      },
      lineEnd: function() {
        stream.lineEnd();
      },
      polygonStart: function() {
        stream.polygonStart();
      },
      polygonEnd: function() {
        stream.polygonEnd();
      }
    };
  }
  d3.geo.projection = d3_geo_projection;
  d3.geo.projectionMutator = d3_geo_projectionMutator;
  function d3_geo_projection(project) {
    return d3_geo_projectionMutator(function() {
      return project;
    })();
  }
  function d3_geo_projectionMutator(projectAt) {
    var project, rotate, projectRotate, projectResample = d3_geo_resample(function(x, y) {
      x = project(x, y);
      return [ x[0] * k + δx, δy - x[1] * k ];
    }), k = 150, x = 480, y = 250, λ = 0, φ = 0, δλ = 0, δφ = 0, δγ = 0, δx, δy, preclip = d3_geo_clipAntimeridian, postclip = d3_identity, clipAngle = null, clipExtent = null, stream;
    function projection(point) {
      point = projectRotate(point[0] * d3_radians, point[1] * d3_radians);
      return [ point[0] * k + δx, δy - point[1] * k ];
    }
    function invert(point) {
      point = projectRotate.invert((point[0] - δx) / k, (δy - point[1]) / k);
      return point && [ point[0] * d3_degrees, point[1] * d3_degrees ];
    }
    projection.stream = function(output) {
      if (stream) stream.valid = false;
      stream = d3_geo_projectionRadians(preclip(rotate, projectResample(postclip(output))));
      stream.valid = true;
      return stream;
    };
    projection.clipAngle = function(_) {
      if (!arguments.length) return clipAngle;
      preclip = _ == null ? (clipAngle = _, d3_geo_clipAntimeridian) : d3_geo_clipCircle((clipAngle = +_) * d3_radians);
      return invalidate();
    };
    projection.clipExtent = function(_) {
      if (!arguments.length) return clipExtent;
      clipExtent = _;
      postclip = _ ? d3_geo_clipExtent(_[0][0], _[0][1], _[1][0], _[1][1]) : d3_identity;
      return invalidate();
    };
    projection.scale = function(_) {
      if (!arguments.length) return k;
      k = +_;
      return reset();
    };
    projection.translate = function(_) {
      if (!arguments.length) return [ x, y ];
      x = +_[0];
      y = +_[1];
      return reset();
    };
    projection.center = function(_) {
      if (!arguments.length) return [ λ * d3_degrees, φ * d3_degrees ];
      λ = _[0] % 360 * d3_radians;
      φ = _[1] % 360 * d3_radians;
      return reset();
    };
    projection.rotate = function(_) {
      if (!arguments.length) return [ δλ * d3_degrees, δφ * d3_degrees, δγ * d3_degrees ];
      δλ = _[0] % 360 * d3_radians;
      δφ = _[1] % 360 * d3_radians;
      δγ = _.length > 2 ? _[2] % 360 * d3_radians : 0;
      return reset();
    };
    d3.rebind(projection, projectResample, "precision");
    function reset() {
      projectRotate = d3_geo_compose(rotate = d3_geo_rotation(δλ, δφ, δγ), project);
      var center = project(λ, φ);
      δx = x - center[0] * k;
      δy = y + center[1] * k;
      return invalidate();
    }
    function invalidate() {
      if (stream) stream.valid = false, stream = null;
      return projection;
    }
    return function() {
      project = projectAt.apply(this, arguments);
      projection.invert = project.invert && invert;
      return reset();
    };
  }
  function d3_geo_projectionRadians(stream) {
    return d3_geo_transformPoint(stream, function(x, y) {
      stream.point(x * d3_radians, y * d3_radians);
    });
  }
  function d3_geo_equirectangular(λ, φ) {
    return [ λ, φ ];
  }
  (d3.geo.equirectangular = function() {
    return d3_geo_projection(d3_geo_equirectangular);
  }).raw = d3_geo_equirectangular.invert = d3_geo_equirectangular;
  d3.geo.rotation = function(rotate) {
    rotate = d3_geo_rotation(rotate[0] % 360 * d3_radians, rotate[1] * d3_radians, rotate.length > 2 ? rotate[2] * d3_radians : 0);
    function forward(coordinates) {
      coordinates = rotate(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    }
    forward.invert = function(coordinates) {
      coordinates = rotate.invert(coordinates[0] * d3_radians, coordinates[1] * d3_radians);
      return coordinates[0] *= d3_degrees, coordinates[1] *= d3_degrees, coordinates;
    };
    return forward;
  };
  function d3_geo_identityRotation(λ, φ) {
    return [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
  }
  d3_geo_identityRotation.invert = d3_geo_equirectangular;
  function d3_geo_rotation(δλ, δφ, δγ) {
    return δλ ? δφ || δγ ? d3_geo_compose(d3_geo_rotationλ(δλ), d3_geo_rotationφγ(δφ, δγ)) : d3_geo_rotationλ(δλ) : δφ || δγ ? d3_geo_rotationφγ(δφ, δγ) : d3_geo_identityRotation;
  }
  function d3_geo_forwardRotationλ(δλ) {
    return function(λ, φ) {
      return λ += δλ, [ λ > π ? λ - τ : λ < -π ? λ + τ : λ, φ ];
    };
  }
  function d3_geo_rotationλ(δλ) {
    var rotation = d3_geo_forwardRotationλ(δλ);
    rotation.invert = d3_geo_forwardRotationλ(-δλ);
    return rotation;
  }
  function d3_geo_rotationφγ(δφ, δγ) {
    var cosδφ = Math.cos(δφ), sinδφ = Math.sin(δφ), cosδγ = Math.cos(δγ), sinδγ = Math.sin(δγ);
    function rotation(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδφ + x * sinδφ;
      return [ Math.atan2(y * cosδγ - k * sinδγ, x * cosδφ - z * sinδφ), d3_asin(k * cosδγ + y * sinδγ) ];
    }
    rotation.invert = function(λ, φ) {
      var cosφ = Math.cos(φ), x = Math.cos(λ) * cosφ, y = Math.sin(λ) * cosφ, z = Math.sin(φ), k = z * cosδγ - y * sinδγ;
      return [ Math.atan2(y * cosδγ + z * sinδγ, x * cosδφ + k * sinδφ), d3_asin(k * cosδφ - x * sinδφ) ];
    };
    return rotation;
  }
  d3.geo.circle = function() {
    var origin = [ 0, 0 ], angle, precision = 6, interpolate;
    function circle() {
      var center = typeof origin === "function" ? origin.apply(this, arguments) : origin, rotate = d3_geo_rotation(-center[0] * d3_radians, -center[1] * d3_radians, 0).invert, ring = [];
      interpolate(null, null, 1, {
        point: function(x, y) {
          ring.push(x = rotate(x, y));
          x[0] *= d3_degrees, x[1] *= d3_degrees;
        }
      });
      return {
        type: "Polygon",
        coordinates: [ ring ]
      };
    }
    circle.origin = function(x) {
      if (!arguments.length) return origin;
      origin = x;
      return circle;
    };
    circle.angle = function(x) {
      if (!arguments.length) return angle;
      interpolate = d3_geo_circleInterpolate((angle = +x) * d3_radians, precision * d3_radians);
      return circle;
    };
    circle.precision = function(_) {
      if (!arguments.length) return precision;
      interpolate = d3_geo_circleInterpolate(angle * d3_radians, (precision = +_) * d3_radians);
      return circle;
    };
    return circle.angle(90);
  };
  function d3_geo_circleInterpolate(radius, precision) {
    var cr = Math.cos(radius), sr = Math.sin(radius);
    return function(from, to, direction, listener) {
      var step = direction * precision;
      if (from != null) {
        from = d3_geo_circleAngle(cr, from);
        to = d3_geo_circleAngle(cr, to);
        if (direction > 0 ? from < to : from > to) from += direction * τ;
      } else {
        from = radius + direction * τ;
        to = radius - .5 * step;
      }
      for (var point, t = from; direction > 0 ? t > to : t < to; t -= step) {
        listener.point((point = d3_geo_spherical([ cr, -sr * Math.cos(t), -sr * Math.sin(t) ]))[0], point[1]);
      }
    };
  }
  function d3_geo_circleAngle(cr, point) {
    var a = d3_geo_cartesian(point);
    a[0] -= cr;
    d3_geo_cartesianNormalize(a);
    var angle = d3_acos(-a[1]);
    return ((-a[2] < 0 ? -angle : angle) + 2 * Math.PI - ε) % (2 * Math.PI);
  }
  d3.geo.distance = function(a, b) {
    var Δλ = (b[0] - a[0]) * d3_radians, φ0 = a[1] * d3_radians, φ1 = b[1] * d3_radians, sinΔλ = Math.sin(Δλ), cosΔλ = Math.cos(Δλ), sinφ0 = Math.sin(φ0), cosφ0 = Math.cos(φ0), sinφ1 = Math.sin(φ1), cosφ1 = Math.cos(φ1), t;
    return Math.atan2(Math.sqrt((t = cosφ1 * sinΔλ) * t + (t = cosφ0 * sinφ1 - sinφ0 * cosφ1 * cosΔλ) * t), sinφ0 * sinφ1 + cosφ0 * cosφ1 * cosΔλ);
  };
  d3.geo.graticule = function() {
    var x1, x0, X1, X0, y1, y0, Y1, Y0, dx = 10, dy = dx, DX = 90, DY = 360, x, y, X, Y, precision = 2.5;
    function graticule() {
      return {
        type: "MultiLineString",
        coordinates: lines()
      };
    }
    function lines() {
      return d3.range(Math.ceil(X0 / DX) * DX, X1, DX).map(X).concat(d3.range(Math.ceil(Y0 / DY) * DY, Y1, DY).map(Y)).concat(d3.range(Math.ceil(x0 / dx) * dx, x1, dx).filter(function(x) {
        return abs(x % DX) > ε;
      }).map(x)).concat(d3.range(Math.ceil(y0 / dy) * dy, y1, dy).filter(function(y) {
        return abs(y % DY) > ε;
      }).map(y));
    }
    graticule.lines = function() {
      return lines().map(function(coordinates) {
        return {
          type: "LineString",
          coordinates: coordinates
        };
      });
    };
    graticule.outline = function() {
      return {
        type: "Polygon",
        coordinates: [ X(X0).concat(Y(Y1).slice(1), X(X1).reverse().slice(1), Y(Y0).reverse().slice(1)) ]
      };
    };
    graticule.extent = function(_) {
      if (!arguments.length) return graticule.minorExtent();
      return graticule.majorExtent(_).minorExtent(_);
    };
    graticule.majorExtent = function(_) {
      if (!arguments.length) return [ [ X0, Y0 ], [ X1, Y1 ] ];
      X0 = +_[0][0], X1 = +_[1][0];
      Y0 = +_[0][1], Y1 = +_[1][1];
      if (X0 > X1) _ = X0, X0 = X1, X1 = _;
      if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
      return graticule.precision(precision);
    };
    graticule.minorExtent = function(_) {
      if (!arguments.length) return [ [ x0, y0 ], [ x1, y1 ] ];
      x0 = +_[0][0], x1 = +_[1][0];
      y0 = +_[0][1], y1 = +_[1][1];
      if (x0 > x1) _ = x0, x0 = x1, x1 = _;
      if (y0 > y1) _ = y0, y0 = y1, y1 = _;
      return graticule.precision(precision);
    };
    graticule.step = function(_) {
      if (!arguments.length) return graticule.minorStep();
      return graticule.majorStep(_).minorStep(_);
    };
    graticule.majorStep = function(_) {
      if (!arguments.length) return [ DX, DY ];
      DX = +_[0], DY = +_[1];
      return graticule;
    };
    graticule.minorStep = function(_) {
      if (!arguments.length) return [ dx, dy ];
      dx = +_[0], dy = +_[1];
      return graticule;
    };
    graticule.precision = function(_) {
      if (!arguments.length) return precision;
      precision = +_;
      x = d3_geo_graticuleX(y0, y1, 90);
      y = d3_geo_graticuleY(x0, x1, precision);
      X = d3_geo_graticuleX(Y0, Y1, 90);
      Y = d3_geo_graticuleY(X0, X1, precision);
      return graticule;
    };
    return graticule.majorExtent([ [ -180, -90 + ε ], [ 180, 90 - ε ] ]).minorExtent([ [ -180, -80 - ε ], [ 180, 80 + ε ] ]);
  };
  function d3_geo_graticuleX(y0, y1, dy) {
    var y = d3.range(y0, y1 - ε, dy).concat(y1);
    return function(x) {
      return y.map(function(y) {
        return [ x, y ];
      });
    };
  }
  function d3_geo_graticuleY(x0, x1, dx) {
    var x = d3.range(x0, x1 - ε, dx).concat(x1);
    return function(y) {
      return x.map(function(x) {
        return [ x, y ];
      });
    };
  }
  function d3_source(d) {
    return d.source;
  }
  function d3_target(d) {
    return d.target;
  }
  d3.geo.greatArc = function() {
    var source = d3_source, source_, target = d3_target, target_;
    function greatArc() {
      return {
        type: "LineString",
        coordinates: [ source_ || source.apply(this, arguments), target_ || target.apply(this, arguments) ]
      };
    }
    greatArc.distance = function() {
      return d3.geo.distance(source_ || source.apply(this, arguments), target_ || target.apply(this, arguments));
    };
    greatArc.source = function(_) {
      if (!arguments.length) return source;
      source = _, source_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.target = function(_) {
      if (!arguments.length) return target;
      target = _, target_ = typeof _ === "function" ? null : _;
      return greatArc;
    };
    greatArc.precision = function() {
      return arguments.length ? greatArc : 0;
    };
    return greatArc;
  };
  d3.geo.interpolate = function(source, target) {
    return d3_geo_interpolate(source[0] * d3_radians, source[1] * d3_radians, target[0] * d3_radians, target[1] * d3_radians);
  };
  function d3_geo_interpolate(x0, y0, x1, y1) {
    var cy0 = Math.cos(y0), sy0 = Math.sin(y0), cy1 = Math.cos(y1), sy1 = Math.sin(y1), kx0 = cy0 * Math.cos(x0), ky0 = cy0 * Math.sin(x0), kx1 = cy1 * Math.cos(x1), ky1 = cy1 * Math.sin(x1), d = 2 * Math.asin(Math.sqrt(d3_haversin(y1 - y0) + cy0 * cy1 * d3_haversin(x1 - x0))), k = 1 / Math.sin(d);
    var interpolate = d ? function(t) {
      var B = Math.sin(t *= d) * k, A = Math.sin(d - t) * k, x = A * kx0 + B * kx1, y = A * ky0 + B * ky1, z = A * sy0 + B * sy1;
      return [ Math.atan2(y, x) * d3_degrees, Math.atan2(z, Math.sqrt(x * x + y * y)) * d3_degrees ];
    } : function() {
      return [ x0 * d3_degrees, y0 * d3_degrees ];
    };
    interpolate.distance = d;
    return interpolate;
  }
  d3.geo.length = function(object) {
    d3_geo_lengthSum = 0;
    d3.geo.stream(object, d3_geo_length);
    return d3_geo_lengthSum;
  };
  var d3_geo_lengthSum;
  var d3_geo_length = {
    sphere: d3_noop,
    point: d3_noop,
    lineStart: d3_geo_lengthLineStart,
    lineEnd: d3_noop,
    polygonStart: d3_noop,
    polygonEnd: d3_noop
  };
  function d3_geo_lengthLineStart() {
    var λ0, sinφ0, cosφ0;
    d3_geo_length.point = function(λ, φ) {
      λ0 = λ * d3_radians, sinφ0 = Math.sin(φ *= d3_radians), cosφ0 = Math.cos(φ);
      d3_geo_length.point = nextPoint;
    };
    d3_geo_length.lineEnd = function() {
      d3_geo_length.point = d3_geo_length.lineEnd = d3_noop;
    };
    function nextPoint(λ, φ) {
      var sinφ = Math.sin(φ *= d3_radians), cosφ = Math.cos(φ), t = abs((λ *= d3_radians) - λ0), cosΔλ = Math.cos(t);
      d3_geo_lengthSum += Math.atan2(Math.sqrt((t = cosφ * Math.sin(t)) * t + (t = cosφ0 * sinφ - sinφ0 * cosφ * cosΔλ) * t), sinφ0 * sinφ + cosφ0 * cosφ * cosΔλ);
      λ0 = λ, sinφ0 = sinφ, cosφ0 = cosφ;
    }
  }
  function d3_geo_azimuthal(scale, angle) {
    function azimuthal(λ, φ) {
      var cosλ = Math.cos(λ), cosφ = Math.cos(φ), k = scale(cosλ * cosφ);
      return [ k * cosφ * Math.sin(λ), k * Math.sin(φ) ];
    }
    azimuthal.invert = function(x, y) {
      var ρ = Math.sqrt(x * x + y * y), c = angle(ρ), sinc = Math.sin(c), cosc = Math.cos(c);
      return [ Math.atan2(x * sinc, ρ * cosc), Math.asin(ρ && y * sinc / ρ) ];
    };
    return azimuthal;
  }
  var d3_geo_azimuthalEqualArea = d3_geo_azimuthal(function(cosλcosφ) {
    return Math.sqrt(2 / (1 + cosλcosφ));
  }, function(ρ) {
    return 2 * Math.asin(ρ / 2);
  });
  (d3.geo.azimuthalEqualArea = function() {
    return d3_geo_projection(d3_geo_azimuthalEqualArea);
  }).raw = d3_geo_azimuthalEqualArea;
  var d3_geo_azimuthalEquidistant = d3_geo_azimuthal(function(cosλcosφ) {
    var c = Math.acos(cosλcosφ);
    return c && c / Math.sin(c);
  }, d3_identity);
  (d3.geo.azimuthalEquidistant = function() {
    return d3_geo_projection(d3_geo_azimuthalEquidistant);
  }).raw = d3_geo_azimuthalEquidistant;
  function d3_geo_conicConformal(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), t = function(φ) {
      return Math.tan(π / 4 + φ / 2);
    }, n = φ0 === φ1 ? Math.sin(φ0) : Math.log(cosφ0 / Math.cos(φ1)) / Math.log(t(φ1) / t(φ0)), F = cosφ0 * Math.pow(t(φ0), n) / n;
    if (!n) return d3_geo_mercator;
    function forward(λ, φ) {
      if (F > 0) {
        if (φ < -halfπ + ε) φ = -halfπ + ε;
      } else {
        if (φ > halfπ - ε) φ = halfπ - ε;
      }
      var ρ = F / Math.pow(t(φ), n);
      return [ ρ * Math.sin(n * λ), F - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = F - y, ρ = d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y);
      return [ Math.atan2(x, ρ0_y) / n, 2 * Math.atan(Math.pow(F / ρ, 1 / n)) - halfπ ];
    };
    return forward;
  }
  (d3.geo.conicConformal = function() {
    return d3_geo_conic(d3_geo_conicConformal);
  }).raw = d3_geo_conicConformal;
  function d3_geo_conicEquidistant(φ0, φ1) {
    var cosφ0 = Math.cos(φ0), n = φ0 === φ1 ? Math.sin(φ0) : (cosφ0 - Math.cos(φ1)) / (φ1 - φ0), G = cosφ0 / n + φ0;
    if (abs(n) < ε) return d3_geo_equirectangular;
    function forward(λ, φ) {
      var ρ = G - φ;
      return [ ρ * Math.sin(n * λ), G - ρ * Math.cos(n * λ) ];
    }
    forward.invert = function(x, y) {
      var ρ0_y = G - y;
      return [ Math.atan2(x, ρ0_y) / n, G - d3_sgn(n) * Math.sqrt(x * x + ρ0_y * ρ0_y) ];
    };
    return forward;
  }
  (d3.geo.conicEquidistant = function() {
    return d3_geo_conic(d3_geo_conicEquidistant);
  }).raw = d3_geo_conicEquidistant;
  var d3_geo_gnomonic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / cosλcosφ;
  }, Math.atan);
  (d3.geo.gnomonic = function() {
    return d3_geo_projection(d3_geo_gnomonic);
  }).raw = d3_geo_gnomonic;
  function d3_geo_mercator(λ, φ) {
    return [ λ, Math.log(Math.tan(π / 4 + φ / 2)) ];
  }
  d3_geo_mercator.invert = function(x, y) {
    return [ x, 2 * Math.atan(Math.exp(y)) - halfπ ];
  };
  function d3_geo_mercatorProjection(project) {
    var m = d3_geo_projection(project), scale = m.scale, translate = m.translate, clipExtent = m.clipExtent, clipAuto;
    m.scale = function() {
      var v = scale.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.translate = function() {
      var v = translate.apply(m, arguments);
      return v === m ? clipAuto ? m.clipExtent(null) : m : v;
    };
    m.clipExtent = function(_) {
      var v = clipExtent.apply(m, arguments);
      if (v === m) {
        if (clipAuto = _ == null) {
          var k = π * scale(), t = translate();
          clipExtent([ [ t[0] - k, t[1] - k ], [ t[0] + k, t[1] + k ] ]);
        }
      } else if (clipAuto) {
        v = null;
      }
      return v;
    };
    return m.clipExtent(null);
  }
  (d3.geo.mercator = function() {
    return d3_geo_mercatorProjection(d3_geo_mercator);
  }).raw = d3_geo_mercator;
  var d3_geo_orthographic = d3_geo_azimuthal(function() {
    return 1;
  }, Math.asin);
  (d3.geo.orthographic = function() {
    return d3_geo_projection(d3_geo_orthographic);
  }).raw = d3_geo_orthographic;
  var d3_geo_stereographic = d3_geo_azimuthal(function(cosλcosφ) {
    return 1 / (1 + cosλcosφ);
  }, function(ρ) {
    return 2 * Math.atan(ρ);
  });
  (d3.geo.stereographic = function() {
    return d3_geo_projection(d3_geo_stereographic);
  }).raw = d3_geo_stereographic;
  function d3_geo_transverseMercator(λ, φ) {
    return [ Math.log(Math.tan(π / 4 + φ / 2)), -λ ];
  }
  d3_geo_transverseMercator.invert = function(x, y) {
    return [ -y, 2 * Math.atan(Math.exp(x)) - halfπ ];
  };
  (d3.geo.transverseMercator = function() {
    var projection = d3_geo_mercatorProjection(d3_geo_transverseMercator), center = projection.center, rotate = projection.rotate;
    projection.center = function(_) {
      return _ ? center([ -_[1], _[0] ]) : (_ = center(), [ _[1], -_[0] ]);
    };
    projection.rotate = function(_) {
      return _ ? rotate([ _[0], _[1], _.length > 2 ? _[2] + 90 : 90 ]) : (_ = rotate(), 
      [ _[0], _[1], _[2] - 90 ]);
    };
    return rotate([ 0, 0, 90 ]);
  }).raw = d3_geo_transverseMercator;
  d3.geom = {};
  function d3_geom_pointX(d) {
    return d[0];
  }
  function d3_geom_pointY(d) {
    return d[1];
  }
  d3.geom.hull = function(vertices) {
    var x = d3_geom_pointX, y = d3_geom_pointY;
    if (arguments.length) return hull(vertices);
    function hull(data) {
      if (data.length < 3) return [];
      var fx = d3_functor(x), fy = d3_functor(y), i, n = data.length, points = [], flippedPoints = [];
      for (i = 0; i < n; i++) {
        points.push([ +fx.call(this, data[i], i), +fy.call(this, data[i], i), i ]);
      }
      points.sort(d3_geom_hullOrder);
      for (i = 0; i < n; i++) flippedPoints.push([ points[i][0], -points[i][1] ]);
      var upper = d3_geom_hullUpper(points), lower = d3_geom_hullUpper(flippedPoints);
      var skipLeft = lower[0] === upper[0], skipRight = lower[lower.length - 1] === upper[upper.length - 1], polygon = [];
      for (i = upper.length - 1; i >= 0; --i) polygon.push(data[points[upper[i]][2]]);
      for (i = +skipLeft; i < lower.length - skipRight; ++i) polygon.push(data[points[lower[i]][2]]);
      return polygon;
    }
    hull.x = function(_) {
      return arguments.length ? (x = _, hull) : x;
    };
    hull.y = function(_) {
      return arguments.length ? (y = _, hull) : y;
    };
    return hull;
  };
  function d3_geom_hullUpper(points) {
    var n = points.length, hull = [ 0, 1 ], hs = 2;
    for (var i = 2; i < n; i++) {
      while (hs > 1 && d3_cross2d(points[hull[hs - 2]], points[hull[hs - 1]], points[i]) <= 0) --hs;
      hull[hs++] = i;
    }
    return hull.slice(0, hs);
  }
  function d3_geom_hullOrder(a, b) {
    return a[0] - b[0] || a[1] - b[1];
  }
  d3.geom.polygon = function(coordinates) {
    d3_subclass(coordinates, d3_geom_polygonPrototype);
    return coordinates;
  };
  var d3_geom_polygonPrototype = d3.geom.polygon.prototype = [];
  d3_geom_polygonPrototype.area = function() {
    var i = -1, n = this.length, a, b = this[n - 1], area = 0;
    while (++i < n) {
      a = b;
      b = this[i];
      area += a[1] * b[0] - a[0] * b[1];
    }
    return area * .5;
  };
  d3_geom_polygonPrototype.centroid = function(k) {
    var i = -1, n = this.length, x = 0, y = 0, a, b = this[n - 1], c;
    if (!arguments.length) k = -1 / (6 * this.area());
    while (++i < n) {
      a = b;
      b = this[i];
      c = a[0] * b[1] - b[0] * a[1];
      x += (a[0] + b[0]) * c;
      y += (a[1] + b[1]) * c;
    }
    return [ x * k, y * k ];
  };
  d3_geom_polygonPrototype.clip = function(subject) {
    var input, closed = d3_geom_polygonClosed(subject), i = -1, n = this.length - d3_geom_polygonClosed(this), j, m, a = this[n - 1], b, c, d;
    while (++i < n) {
      input = subject.slice();
      subject.length = 0;
      b = this[i];
      c = input[(m = input.length - closed) - 1];
      j = -1;
      while (++j < m) {
        d = input[j];
        if (d3_geom_polygonInside(d, a, b)) {
          if (!d3_geom_polygonInside(c, a, b)) {
            subject.push(d3_geom_polygonIntersect(c, d, a, b));
          }
          subject.push(d);
        } else if (d3_geom_polygonInside(c, a, b)) {
          subject.push(d3_geom_polygonIntersect(c, d, a, b));
        }
        c = d;
      }
      if (closed) subject.push(subject[0]);
      a = b;
    }
    return subject;
  };
  function d3_geom_polygonInside(p, a, b) {
    return (b[0] - a[0]) * (p[1] - a[1]) < (b[1] - a[1]) * (p[0] - a[0]);
  }
  function d3_geom_polygonIntersect(c, d, a, b) {
    var x1 = c[0], x3 = a[0], x21 = d[0] - x1, x43 = b[0] - x3, y1 = c[1], y3 = a[1], y21 = d[1] - y1, y43 = b[1] - y3, ua = (x43 * (y1 - y3) - y43 * (x1 - x3)) / (y43 * x21 - x43 * y21);
    return [ x1 + ua * x21, y1 + ua * y21 ];
  }
  function d3_geom_polygonClosed(coordinates) {
    var a = coordinates[0], b = coordinates[coordinates.length - 1];
    return !(a[0] - b[0] || a[1] - b[1]);
  }
  var d3_geom_voronoiEdges, d3_geom_voronoiCells, d3_geom_voronoiBeaches, d3_geom_voronoiBeachPool = [], d3_geom_voronoiFirstCircle, d3_geom_voronoiCircles, d3_geom_voronoiCirclePool = [];
  function d3_geom_voronoiBeach() {
    d3_geom_voronoiRedBlackNode(this);
    this.edge = this.site = this.circle = null;
  }
  function d3_geom_voronoiCreateBeach(site) {
    var beach = d3_geom_voronoiBeachPool.pop() || new d3_geom_voronoiBeach();
    beach.site = site;
    return beach;
  }
  function d3_geom_voronoiDetachBeach(beach) {
    d3_geom_voronoiDetachCircle(beach);
    d3_geom_voronoiBeaches.remove(beach);
    d3_geom_voronoiBeachPool.push(beach);
    d3_geom_voronoiRedBlackNode(beach);
  }
  function d3_geom_voronoiRemoveBeach(beach) {
    var circle = beach.circle, x = circle.x, y = circle.cy, vertex = {
      x: x,
      y: y
    }, previous = beach.P, next = beach.N, disappearing = [ beach ];
    d3_geom_voronoiDetachBeach(beach);
    var lArc = previous;
    while (lArc.circle && abs(x - lArc.circle.x) < ε && abs(y - lArc.circle.cy) < ε) {
      previous = lArc.P;
      disappearing.unshift(lArc);
      d3_geom_voronoiDetachBeach(lArc);
      lArc = previous;
    }
    disappearing.unshift(lArc);
    d3_geom_voronoiDetachCircle(lArc);
    var rArc = next;
    while (rArc.circle && abs(x - rArc.circle.x) < ε && abs(y - rArc.circle.cy) < ε) {
      next = rArc.N;
      disappearing.push(rArc);
      d3_geom_voronoiDetachBeach(rArc);
      rArc = next;
    }
    disappearing.push(rArc);
    d3_geom_voronoiDetachCircle(rArc);
    var nArcs = disappearing.length, iArc;
    for (iArc = 1; iArc < nArcs; ++iArc) {
      rArc = disappearing[iArc];
      lArc = disappearing[iArc - 1];
      d3_geom_voronoiSetEdgeEnd(rArc.edge, lArc.site, rArc.site, vertex);
    }
    lArc = disappearing[0];
    rArc = disappearing[nArcs - 1];
    rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, rArc.site, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiAddBeach(site) {
    var x = site.x, directrix = site.y, lArc, rArc, dxl, dxr, node = d3_geom_voronoiBeaches._;
    while (node) {
      dxl = d3_geom_voronoiLeftBreakPoint(node, directrix) - x;
      if (dxl > ε) node = node.L; else {
        dxr = x - d3_geom_voronoiRightBreakPoint(node, directrix);
        if (dxr > ε) {
          if (!node.R) {
            lArc = node;
            break;
          }
          node = node.R;
        } else {
          if (dxl > -ε) {
            lArc = node.P;
            rArc = node;
          } else if (dxr > -ε) {
            lArc = node;
            rArc = node.N;
          } else {
            lArc = rArc = node;
          }
          break;
        }
      }
    }
    var newArc = d3_geom_voronoiCreateBeach(site);
    d3_geom_voronoiBeaches.insert(lArc, newArc);
    if (!lArc && !rArc) return;
    if (lArc === rArc) {
      d3_geom_voronoiDetachCircle(lArc);
      rArc = d3_geom_voronoiCreateBeach(lArc.site);
      d3_geom_voronoiBeaches.insert(newArc, rArc);
      newArc.edge = rArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      d3_geom_voronoiAttachCircle(lArc);
      d3_geom_voronoiAttachCircle(rArc);
      return;
    }
    if (!rArc) {
      newArc.edge = d3_geom_voronoiCreateEdge(lArc.site, newArc.site);
      return;
    }
    d3_geom_voronoiDetachCircle(lArc);
    d3_geom_voronoiDetachCircle(rArc);
    var lSite = lArc.site, ax = lSite.x, ay = lSite.y, bx = site.x - ax, by = site.y - ay, rSite = rArc.site, cx = rSite.x - ax, cy = rSite.y - ay, d = 2 * (bx * cy - by * cx), hb = bx * bx + by * by, hc = cx * cx + cy * cy, vertex = {
      x: (cy * hb - by * hc) / d + ax,
      y: (bx * hc - cx * hb) / d + ay
    };
    d3_geom_voronoiSetEdgeEnd(rArc.edge, lSite, rSite, vertex);
    newArc.edge = d3_geom_voronoiCreateEdge(lSite, site, null, vertex);
    rArc.edge = d3_geom_voronoiCreateEdge(site, rSite, null, vertex);
    d3_geom_voronoiAttachCircle(lArc);
    d3_geom_voronoiAttachCircle(rArc);
  }
  function d3_geom_voronoiLeftBreakPoint(arc, directrix) {
    var site = arc.site, rfocx = site.x, rfocy = site.y, pby2 = rfocy - directrix;
    if (!pby2) return rfocx;
    var lArc = arc.P;
    if (!lArc) return -Infinity;
    site = lArc.site;
    var lfocx = site.x, lfocy = site.y, plby2 = lfocy - directrix;
    if (!plby2) return lfocx;
    var hl = lfocx - rfocx, aby2 = 1 / pby2 - 1 / plby2, b = hl / plby2;
    if (aby2) return (-b + Math.sqrt(b * b - 2 * aby2 * (hl * hl / (-2 * plby2) - lfocy + plby2 / 2 + rfocy - pby2 / 2))) / aby2 + rfocx;
    return (rfocx + lfocx) / 2;
  }
  function d3_geom_voronoiRightBreakPoint(arc, directrix) {
    var rArc = arc.N;
    if (rArc) return d3_geom_voronoiLeftBreakPoint(rArc, directrix);
    var site = arc.site;
    return site.y === directrix ? site.x : Infinity;
  }
  function d3_geom_voronoiCell(site) {
    this.site = site;
    this.edges = [];
  }
  d3_geom_voronoiCell.prototype.prepare = function() {
    var halfEdges = this.edges, iHalfEdge = halfEdges.length, edge;
    while (iHalfEdge--) {
      edge = halfEdges[iHalfEdge].edge;
      if (!edge.b || !edge.a) halfEdges.splice(iHalfEdge, 1);
    }
    halfEdges.sort(d3_geom_voronoiHalfEdgeOrder);
    return halfEdges.length;
  };
  function d3_geom_voronoiCloseCells(extent) {
    var x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], x2, y2, x3, y3, cells = d3_geom_voronoiCells, iCell = cells.length, cell, iHalfEdge, halfEdges, nHalfEdges, start, end;
    while (iCell--) {
      cell = cells[iCell];
      if (!cell || !cell.prepare()) continue;
      halfEdges = cell.edges;
      nHalfEdges = halfEdges.length;
      iHalfEdge = 0;
      while (iHalfEdge < nHalfEdges) {
        end = halfEdges[iHalfEdge].end(), x3 = end.x, y3 = end.y;
        start = halfEdges[++iHalfEdge % nHalfEdges].start(), x2 = start.x, y2 = start.y;
        if (abs(x3 - x2) > ε || abs(y3 - y2) > ε) {
          halfEdges.splice(iHalfEdge, 0, new d3_geom_voronoiHalfEdge(d3_geom_voronoiCreateBorderEdge(cell.site, end, abs(x3 - x0) < ε && y1 - y3 > ε ? {
            x: x0,
            y: abs(x2 - x0) < ε ? y2 : y1
          } : abs(y3 - y1) < ε && x1 - x3 > ε ? {
            x: abs(y2 - y1) < ε ? x2 : x1,
            y: y1
          } : abs(x3 - x1) < ε && y3 - y0 > ε ? {
            x: x1,
            y: abs(x2 - x1) < ε ? y2 : y0
          } : abs(y3 - y0) < ε && x3 - x0 > ε ? {
            x: abs(y2 - y0) < ε ? x2 : x0,
            y: y0
          } : null), cell.site, null));
          ++nHalfEdges;
        }
      }
    }
  }
  function d3_geom_voronoiHalfEdgeOrder(a, b) {
    return b.angle - a.angle;
  }
  function d3_geom_voronoiCircle() {
    d3_geom_voronoiRedBlackNode(this);
    this.x = this.y = this.arc = this.site = this.cy = null;
  }
  function d3_geom_voronoiAttachCircle(arc) {
    var lArc = arc.P, rArc = arc.N;
    if (!lArc || !rArc) return;
    var lSite = lArc.site, cSite = arc.site, rSite = rArc.site;
    if (lSite === rSite) return;
    var bx = cSite.x, by = cSite.y, ax = lSite.x - bx, ay = lSite.y - by, cx = rSite.x - bx, cy = rSite.y - by;
    var d = 2 * (ax * cy - ay * cx);
    if (d >= -ε2) return;
    var ha = ax * ax + ay * ay, hc = cx * cx + cy * cy, x = (cy * ha - ay * hc) / d, y = (ax * hc - cx * ha) / d, cy = y + by;
    var circle = d3_geom_voronoiCirclePool.pop() || new d3_geom_voronoiCircle();
    circle.arc = arc;
    circle.site = cSite;
    circle.x = x + bx;
    circle.y = cy + Math.sqrt(x * x + y * y);
    circle.cy = cy;
    arc.circle = circle;
    var before = null, node = d3_geom_voronoiCircles._;
    while (node) {
      if (circle.y < node.y || circle.y === node.y && circle.x <= node.x) {
        if (node.L) node = node.L; else {
          before = node.P;
          break;
        }
      } else {
        if (node.R) node = node.R; else {
          before = node;
          break;
        }
      }
    }
    d3_geom_voronoiCircles.insert(before, circle);
    if (!before) d3_geom_voronoiFirstCircle = circle;
  }
  function d3_geom_voronoiDetachCircle(arc) {
    var circle = arc.circle;
    if (circle) {
      if (!circle.P) d3_geom_voronoiFirstCircle = circle.N;
      d3_geom_voronoiCircles.remove(circle);
      d3_geom_voronoiCirclePool.push(circle);
      d3_geom_voronoiRedBlackNode(circle);
      arc.circle = null;
    }
  }
  function d3_geom_voronoiClipEdges(extent) {
    var edges = d3_geom_voronoiEdges, clip = d3_geom_clipLine(extent[0][0], extent[0][1], extent[1][0], extent[1][1]), i = edges.length, e;
    while (i--) {
      e = edges[i];
      if (!d3_geom_voronoiConnectEdge(e, extent) || !clip(e) || abs(e.a.x - e.b.x) < ε && abs(e.a.y - e.b.y) < ε) {
        e.a = e.b = null;
        edges.splice(i, 1);
      }
    }
  }
  function d3_geom_voronoiConnectEdge(edge, extent) {
    var vb = edge.b;
    if (vb) return true;
    var va = edge.a, x0 = extent[0][0], x1 = extent[1][0], y0 = extent[0][1], y1 = extent[1][1], lSite = edge.l, rSite = edge.r, lx = lSite.x, ly = lSite.y, rx = rSite.x, ry = rSite.y, fx = (lx + rx) / 2, fy = (ly + ry) / 2, fm, fb;
    if (ry === ly) {
      if (fx < x0 || fx >= x1) return;
      if (lx > rx) {
        if (!va) va = {
          x: fx,
          y: y0
        }; else if (va.y >= y1) return;
        vb = {
          x: fx,
          y: y1
        };
      } else {
        if (!va) va = {
          x: fx,
          y: y1
        }; else if (va.y < y0) return;
        vb = {
          x: fx,
          y: y0
        };
      }
    } else {
      fm = (lx - rx) / (ry - ly);
      fb = fy - fm * fx;
      if (fm < -1 || fm > 1) {
        if (lx > rx) {
          if (!va) va = {
            x: (y0 - fb) / fm,
            y: y0
          }; else if (va.y >= y1) return;
          vb = {
            x: (y1 - fb) / fm,
            y: y1
          };
        } else {
          if (!va) va = {
            x: (y1 - fb) / fm,
            y: y1
          }; else if (va.y < y0) return;
          vb = {
            x: (y0 - fb) / fm,
            y: y0
          };
        }
      } else {
        if (ly < ry) {
          if (!va) va = {
            x: x0,
            y: fm * x0 + fb
          }; else if (va.x >= x1) return;
          vb = {
            x: x1,
            y: fm * x1 + fb
          };
        } else {
          if (!va) va = {
            x: x1,
            y: fm * x1 + fb
          }; else if (va.x < x0) return;
          vb = {
            x: x0,
            y: fm * x0 + fb
          };
        }
      }
    }
    edge.a = va;
    edge.b = vb;
    return true;
  }
  function d3_geom_voronoiEdge(lSite, rSite) {
    this.l = lSite;
    this.r = rSite;
    this.a = this.b = null;
  }
  function d3_geom_voronoiCreateEdge(lSite, rSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, rSite);
    d3_geom_voronoiEdges.push(edge);
    if (va) d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, va);
    if (vb) d3_geom_voronoiSetEdgeEnd(edge, rSite, lSite, vb);
    d3_geom_voronoiCells[lSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, lSite, rSite));
    d3_geom_voronoiCells[rSite.i].edges.push(new d3_geom_voronoiHalfEdge(edge, rSite, lSite));
    return edge;
  }
  function d3_geom_voronoiCreateBorderEdge(lSite, va, vb) {
    var edge = new d3_geom_voronoiEdge(lSite, null);
    edge.a = va;
    edge.b = vb;
    d3_geom_voronoiEdges.push(edge);
    return edge;
  }
  function d3_geom_voronoiSetEdgeEnd(edge, lSite, rSite, vertex) {
    if (!edge.a && !edge.b) {
      edge.a = vertex;
      edge.l = lSite;
      edge.r = rSite;
    } else if (edge.l === rSite) {
      edge.b = vertex;
    } else {
      edge.a = vertex;
    }
  }
  function d3_geom_voronoiHalfEdge(edge, lSite, rSite) {
    var va = edge.a, vb = edge.b;
    this.edge = edge;
    this.site = lSite;
    this.angle = rSite ? Math.atan2(rSite.y - lSite.y, rSite.x - lSite.x) : edge.l === lSite ? Math.atan2(vb.x - va.x, va.y - vb.y) : Math.atan2(va.x - vb.x, vb.y - va.y);
  }
  d3_geom_voronoiHalfEdge.prototype = {
    start: function() {
      return this.edge.l === this.site ? this.edge.a : this.edge.b;
    },
    end: function() {
      return this.edge.l === this.site ? this.edge.b : this.edge.a;
    }
  };
  function d3_geom_voronoiRedBlackTree() {
    this._ = null;
  }
  function d3_geom_voronoiRedBlackNode(node) {
    node.U = node.C = node.L = node.R = node.P = node.N = null;
  }
  d3_geom_voronoiRedBlackTree.prototype = {
    insert: function(after, node) {
      var parent, grandpa, uncle;
      if (after) {
        node.P = after;
        node.N = after.N;
        if (after.N) after.N.P = node;
        after.N = node;
        if (after.R) {
          after = after.R;
          while (after.L) after = after.L;
          after.L = node;
        } else {
          after.R = node;
        }
        parent = after;
      } else if (this._) {
        after = d3_geom_voronoiRedBlackFirst(this._);
        node.P = null;
        node.N = after;
        after.P = after.L = node;
        parent = after;
      } else {
        node.P = node.N = null;
        this._ = node;
        parent = null;
      }
      node.L = node.R = null;
      node.U = parent;
      node.C = true;
      after = node;
      while (parent && parent.C) {
        grandpa = parent.U;
        if (parent === grandpa.L) {
          uncle = grandpa.R;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.R) {
              d3_geom_voronoiRedBlackRotateLeft(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, grandpa);
          }
        } else {
          uncle = grandpa.L;
          if (uncle && uncle.C) {
            parent.C = uncle.C = false;
            grandpa.C = true;
            after = grandpa;
          } else {
            if (after === parent.L) {
              d3_geom_voronoiRedBlackRotateRight(this, parent);
              after = parent;
              parent = after.U;
            }
            parent.C = false;
            grandpa.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, grandpa);
          }
        }
        parent = after.U;
      }
      this._.C = false;
    },
    remove: function(node) {
      if (node.N) node.N.P = node.P;
      if (node.P) node.P.N = node.N;
      node.N = node.P = null;
      var parent = node.U, sibling, left = node.L, right = node.R, next, red;
      if (!left) next = right; else if (!right) next = left; else next = d3_geom_voronoiRedBlackFirst(right);
      if (parent) {
        if (parent.L === node) parent.L = next; else parent.R = next;
      } else {
        this._ = next;
      }
      if (left && right) {
        red = next.C;
        next.C = node.C;
        next.L = left;
        left.U = next;
        if (next !== right) {
          parent = next.U;
          next.U = node.U;
          node = next.R;
          parent.L = node;
          next.R = right;
          right.U = next;
        } else {
          next.U = parent;
          parent = next;
          node = next.R;
        }
      } else {
        red = node.C;
        node = next;
      }
      if (node) node.U = parent;
      if (red) return;
      if (node && node.C) {
        node.C = false;
        return;
      }
      do {
        if (node === this._) break;
        if (node === parent.L) {
          sibling = parent.R;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            sibling = parent.R;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.R || !sibling.R.C) {
              sibling.L.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateRight(this, sibling);
              sibling = parent.R;
            }
            sibling.C = parent.C;
            parent.C = sibling.R.C = false;
            d3_geom_voronoiRedBlackRotateLeft(this, parent);
            node = this._;
            break;
          }
        } else {
          sibling = parent.L;
          if (sibling.C) {
            sibling.C = false;
            parent.C = true;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            sibling = parent.L;
          }
          if (sibling.L && sibling.L.C || sibling.R && sibling.R.C) {
            if (!sibling.L || !sibling.L.C) {
              sibling.R.C = false;
              sibling.C = true;
              d3_geom_voronoiRedBlackRotateLeft(this, sibling);
              sibling = parent.L;
            }
            sibling.C = parent.C;
            parent.C = sibling.L.C = false;
            d3_geom_voronoiRedBlackRotateRight(this, parent);
            node = this._;
            break;
          }
        }
        sibling.C = true;
        node = parent;
        parent = parent.U;
      } while (!node.C);
      if (node) node.C = false;
    }
  };
  function d3_geom_voronoiRedBlackRotateLeft(tree, node) {
    var p = node, q = node.R, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.R = q.L;
    if (p.R) p.R.U = p;
    q.L = p;
  }
  function d3_geom_voronoiRedBlackRotateRight(tree, node) {
    var p = node, q = node.L, parent = p.U;
    if (parent) {
      if (parent.L === p) parent.L = q; else parent.R = q;
    } else {
      tree._ = q;
    }
    q.U = parent;
    p.U = q;
    p.L = q.R;
    if (p.L) p.L.U = p;
    q.R = p;
  }
  function d3_geom_voronoiRedBlackFirst(node) {
    while (node.L) node = node.L;
    return node;
  }
  function d3_geom_voronoi(sites, bbox) {
    var site = sites.sort(d3_geom_voronoiVertexOrder).pop(), x0, y0, circle;
    d3_geom_voronoiEdges = [];
    d3_geom_voronoiCells = new Array(sites.length);
    d3_geom_voronoiBeaches = new d3_geom_voronoiRedBlackTree();
    d3_geom_voronoiCircles = new d3_geom_voronoiRedBlackTree();
    while (true) {
      circle = d3_geom_voronoiFirstCircle;
      if (site && (!circle || site.y < circle.y || site.y === circle.y && site.x < circle.x)) {
        if (site.x !== x0 || site.y !== y0) {
          d3_geom_voronoiCells[site.i] = new d3_geom_voronoiCell(site);
          d3_geom_voronoiAddBeach(site);
          x0 = site.x, y0 = site.y;
        }
        site = sites.pop();
      } else if (circle) {
        d3_geom_voronoiRemoveBeach(circle.arc);
      } else {
        break;
      }
    }
    if (bbox) d3_geom_voronoiClipEdges(bbox), d3_geom_voronoiCloseCells(bbox);
    var diagram = {
      cells: d3_geom_voronoiCells,
      edges: d3_geom_voronoiEdges
    };
    d3_geom_voronoiBeaches = d3_geom_voronoiCircles = d3_geom_voronoiEdges = d3_geom_voronoiCells = null;
    return diagram;
  }
  function d3_geom_voronoiVertexOrder(a, b) {
    return b.y - a.y || b.x - a.x;
  }
  d3.geom.voronoi = function(points) {
    var x = d3_geom_pointX, y = d3_geom_pointY, fx = x, fy = y, clipExtent = d3_geom_voronoiClipExtent;
    if (points) return voronoi(points);
    function voronoi(data) {
      var polygons = new Array(data.length), x0 = clipExtent[0][0], y0 = clipExtent[0][1], x1 = clipExtent[1][0], y1 = clipExtent[1][1];
      d3_geom_voronoi(sites(data), clipExtent).cells.forEach(function(cell, i) {
        var edges = cell.edges, site = cell.site, polygon = polygons[i] = edges.length ? edges.map(function(e) {
          var s = e.start();
          return [ s.x, s.y ];
        }) : site.x >= x0 && site.x <= x1 && site.y >= y0 && site.y <= y1 ? [ [ x0, y1 ], [ x1, y1 ], [ x1, y0 ], [ x0, y0 ] ] : [];
        polygon.point = data[i];
      });
      return polygons;
    }
    function sites(data) {
      return data.map(function(d, i) {
        return {
          x: Math.round(fx(d, i) / ε) * ε,
          y: Math.round(fy(d, i) / ε) * ε,
          i: i
        };
      });
    }
    voronoi.links = function(data) {
      return d3_geom_voronoi(sites(data)).edges.filter(function(edge) {
        return edge.l && edge.r;
      }).map(function(edge) {
        return {
          source: data[edge.l.i],
          target: data[edge.r.i]
        };
      });
    };
    voronoi.triangles = function(data) {
      var triangles = [];
      d3_geom_voronoi(sites(data)).cells.forEach(function(cell, i) {
        var site = cell.site, edges = cell.edges.sort(d3_geom_voronoiHalfEdgeOrder), j = -1, m = edges.length, e0, s0, e1 = edges[m - 1].edge, s1 = e1.l === site ? e1.r : e1.l;
        while (++j < m) {
          e0 = e1;
          s0 = s1;
          e1 = edges[j].edge;
          s1 = e1.l === site ? e1.r : e1.l;
          if (i < s0.i && i < s1.i && d3_geom_voronoiTriangleArea(site, s0, s1) < 0) {
            triangles.push([ data[i], data[s0.i], data[s1.i] ]);
          }
        }
      });
      return triangles;
    };
    voronoi.x = function(_) {
      return arguments.length ? (fx = d3_functor(x = _), voronoi) : x;
    };
    voronoi.y = function(_) {
      return arguments.length ? (fy = d3_functor(y = _), voronoi) : y;
    };
    voronoi.clipExtent = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent;
      clipExtent = _ == null ? d3_geom_voronoiClipExtent : _;
      return voronoi;
    };
    voronoi.size = function(_) {
      if (!arguments.length) return clipExtent === d3_geom_voronoiClipExtent ? null : clipExtent && clipExtent[1];
      return voronoi.clipExtent(_ && [ [ 0, 0 ], _ ]);
    };
    return voronoi;
  };
  var d3_geom_voronoiClipExtent = [ [ -1e6, -1e6 ], [ 1e6, 1e6 ] ];
  function d3_geom_voronoiTriangleArea(a, b, c) {
    return (a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y);
  }
  d3.geom.delaunay = function(vertices) {
    return d3.geom.voronoi().triangles(vertices);
  };
  d3.geom.quadtree = function(points, x1, y1, x2, y2) {
    var x = d3_geom_pointX, y = d3_geom_pointY, compat;
    if (compat = arguments.length) {
      x = d3_geom_quadtreeCompatX;
      y = d3_geom_quadtreeCompatY;
      if (compat === 3) {
        y2 = y1;
        x2 = x1;
        y1 = x1 = 0;
      }
      return quadtree(points);
    }
    function quadtree(data) {
      var d, fx = d3_functor(x), fy = d3_functor(y), xs, ys, i, n, x1_, y1_, x2_, y2_;
      if (x1 != null) {
        x1_ = x1, y1_ = y1, x2_ = x2, y2_ = y2;
      } else {
        x2_ = y2_ = -(x1_ = y1_ = Infinity);
        xs = [], ys = [];
        n = data.length;
        if (compat) for (i = 0; i < n; ++i) {
          d = data[i];
          if (d.x < x1_) x1_ = d.x;
          if (d.y < y1_) y1_ = d.y;
          if (d.x > x2_) x2_ = d.x;
          if (d.y > y2_) y2_ = d.y;
          xs.push(d.x);
          ys.push(d.y);
        } else for (i = 0; i < n; ++i) {
          var x_ = +fx(d = data[i], i), y_ = +fy(d, i);
          if (x_ < x1_) x1_ = x_;
          if (y_ < y1_) y1_ = y_;
          if (x_ > x2_) x2_ = x_;
          if (y_ > y2_) y2_ = y_;
          xs.push(x_);
          ys.push(y_);
        }
      }
      var dx = x2_ - x1_, dy = y2_ - y1_;
      if (dx > dy) y2_ = y1_ + dx; else x2_ = x1_ + dy;
      function insert(n, d, x, y, x1, y1, x2, y2) {
        if (isNaN(x) || isNaN(y)) return;
        if (n.leaf) {
          var nx = n.x, ny = n.y;
          if (nx != null) {
            if (abs(nx - x) + abs(ny - y) < .01) {
              insertChild(n, d, x, y, x1, y1, x2, y2);
            } else {
              var nPoint = n.point;
              n.x = n.y = n.point = null;
              insertChild(n, nPoint, nx, ny, x1, y1, x2, y2);
              insertChild(n, d, x, y, x1, y1, x2, y2);
            }
          } else {
            n.x = x, n.y = y, n.point = d;
          }
        } else {
          insertChild(n, d, x, y, x1, y1, x2, y2);
        }
      }
      function insertChild(n, d, x, y, x1, y1, x2, y2) {
        var xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym, i = below << 1 | right;
        n.leaf = false;
        n = n.nodes[i] || (n.nodes[i] = d3_geom_quadtreeNode());
        if (right) x1 = xm; else x2 = xm;
        if (below) y1 = ym; else y2 = ym;
        insert(n, d, x, y, x1, y1, x2, y2);
      }
      var root = d3_geom_quadtreeNode();
      root.add = function(d) {
        insert(root, d, +fx(d, ++i), +fy(d, i), x1_, y1_, x2_, y2_);
      };
      root.visit = function(f) {
        d3_geom_quadtreeVisit(f, root, x1_, y1_, x2_, y2_);
      };
      root.find = function(point) {
        return d3_geom_quadtreeFind(root, point[0], point[1], x1_, y1_, x2_, y2_);
      };
      i = -1;
      if (x1 == null) {
        while (++i < n) {
          insert(root, data[i], xs[i], ys[i], x1_, y1_, x2_, y2_);
        }
        --i;
      } else data.forEach(root.add);
      xs = ys = data = d = null;
      return root;
    }
    quadtree.x = function(_) {
      return arguments.length ? (x = _, quadtree) : x;
    };
    quadtree.y = function(_) {
      return arguments.length ? (y = _, quadtree) : y;
    };
    quadtree.extent = function(_) {
      if (!arguments.length) return x1 == null ? null : [ [ x1, y1 ], [ x2, y2 ] ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = +_[0][0], y1 = +_[0][1], x2 = +_[1][0], 
      y2 = +_[1][1];
      return quadtree;
    };
    quadtree.size = function(_) {
      if (!arguments.length) return x1 == null ? null : [ x2 - x1, y2 - y1 ];
      if (_ == null) x1 = y1 = x2 = y2 = null; else x1 = y1 = 0, x2 = +_[0], y2 = +_[1];
      return quadtree;
    };
    return quadtree;
  };
  function d3_geom_quadtreeCompatX(d) {
    return d.x;
  }
  function d3_geom_quadtreeCompatY(d) {
    return d.y;
  }
  function d3_geom_quadtreeNode() {
    return {
      leaf: true,
      nodes: [],
      point: null,
      x: null,
      y: null
    };
  }
  function d3_geom_quadtreeVisit(f, node, x1, y1, x2, y2) {
    if (!f(node, x1, y1, x2, y2)) {
      var sx = (x1 + x2) * .5, sy = (y1 + y2) * .5, children = node.nodes;
      if (children[0]) d3_geom_quadtreeVisit(f, children[0], x1, y1, sx, sy);
      if (children[1]) d3_geom_quadtreeVisit(f, children[1], sx, y1, x2, sy);
      if (children[2]) d3_geom_quadtreeVisit(f, children[2], x1, sy, sx, y2);
      if (children[3]) d3_geom_quadtreeVisit(f, children[3], sx, sy, x2, y2);
    }
  }
  function d3_geom_quadtreeFind(root, x, y, x0, y0, x3, y3) {
    var minDistance2 = Infinity, closestPoint;
    (function find(node, x1, y1, x2, y2) {
      if (x1 > x3 || y1 > y3 || x2 < x0 || y2 < y0) return;
      if (point = node.point) {
        var point, dx = x - node.x, dy = y - node.y, distance2 = dx * dx + dy * dy;
        if (distance2 < minDistance2) {
          var distance = Math.sqrt(minDistance2 = distance2);
          x0 = x - distance, y0 = y - distance;
          x3 = x + distance, y3 = y + distance;
          closestPoint = point;
        }
      }
      var children = node.nodes, xm = (x1 + x2) * .5, ym = (y1 + y2) * .5, right = x >= xm, below = y >= ym;
      for (var i = below << 1 | right, j = i + 4; i < j; ++i) {
        if (node = children[i & 3]) switch (i & 3) {
         case 0:
          find(node, x1, y1, xm, ym);
          break;

         case 1:
          find(node, xm, y1, x2, ym);
          break;

         case 2:
          find(node, x1, ym, xm, y2);
          break;

         case 3:
          find(node, xm, ym, x2, y2);
          break;
        }
      }
    })(root, x0, y0, x3, y3);
    return closestPoint;
  }
  d3.interpolateRgb = d3_interpolateRgb;
  function d3_interpolateRgb(a, b) {
    a = d3.rgb(a);
    b = d3.rgb(b);
    var ar = a.r, ag = a.g, ab = a.b, br = b.r - ar, bg = b.g - ag, bb = b.b - ab;
    return function(t) {
      return "#" + d3_rgb_hex(Math.round(ar + br * t)) + d3_rgb_hex(Math.round(ag + bg * t)) + d3_rgb_hex(Math.round(ab + bb * t));
    };
  }
  d3.interpolateObject = d3_interpolateObject;
  function d3_interpolateObject(a, b) {
    var i = {}, c = {}, k;
    for (k in a) {
      if (k in b) {
        i[k] = d3_interpolate(a[k], b[k]);
      } else {
        c[k] = a[k];
      }
    }
    for (k in b) {
      if (!(k in a)) {
        c[k] = b[k];
      }
    }
    return function(t) {
      for (k in i) c[k] = i[k](t);
      return c;
    };
  }
  d3.interpolateNumber = d3_interpolateNumber;
  function d3_interpolateNumber(a, b) {
    a = +a, b = +b;
    return function(t) {
      return a * (1 - t) + b * t;
    };
  }
  d3.interpolateString = d3_interpolateString;
  function d3_interpolateString(a, b) {
    var bi = d3_interpolate_numberA.lastIndex = d3_interpolate_numberB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = [];
    a = a + "", b = b + "";
    while ((am = d3_interpolate_numberA.exec(a)) && (bm = d3_interpolate_numberB.exec(b))) {
      if ((bs = bm.index) > bi) {
        bs = b.slice(bi, bs);
        if (s[i]) s[i] += bs; else s[++i] = bs;
      }
      if ((am = am[0]) === (bm = bm[0])) {
        if (s[i]) s[i] += bm; else s[++i] = bm;
      } else {
        s[++i] = null;
        q.push({
          i: i,
          x: d3_interpolateNumber(am, bm)
        });
      }
      bi = d3_interpolate_numberB.lastIndex;
    }
    if (bi < b.length) {
      bs = b.slice(bi);
      if (s[i]) s[i] += bs; else s[++i] = bs;
    }
    return s.length < 2 ? q[0] ? (b = q[0].x, function(t) {
      return b(t) + "";
    }) : function() {
      return b;
    } : (b = q.length, function(t) {
      for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    });
  }
  var d3_interpolate_numberA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, d3_interpolate_numberB = new RegExp(d3_interpolate_numberA.source, "g");
  d3.interpolate = d3_interpolate;
  function d3_interpolate(a, b) {
    var i = d3.interpolators.length, f;
    while (--i >= 0 && !(f = d3.interpolators[i](a, b))) ;
    return f;
  }
  d3.interpolators = [ function(a, b) {
    var t = typeof b;
    return (t === "string" ? d3_rgb_names.has(b.toLowerCase()) || /^(#|rgb\(|hsl\()/i.test(b) ? d3_interpolateRgb : d3_interpolateString : b instanceof d3_color ? d3_interpolateRgb : Array.isArray(b) ? d3_interpolateArray : t === "object" && isNaN(b) ? d3_interpolateObject : d3_interpolateNumber)(a, b);
  } ];
  d3.interpolateArray = d3_interpolateArray;
  function d3_interpolateArray(a, b) {
    var x = [], c = [], na = a.length, nb = b.length, n0 = Math.min(a.length, b.length), i;
    for (i = 0; i < n0; ++i) x.push(d3_interpolate(a[i], b[i]));
    for (;i < na; ++i) c[i] = a[i];
    for (;i < nb; ++i) c[i] = b[i];
    return function(t) {
      for (i = 0; i < n0; ++i) c[i] = x[i](t);
      return c;
    };
  }
  var d3_ease_default = function() {
    return d3_identity;
  };
  var d3_ease = d3.map({
    linear: d3_ease_default,
    poly: d3_ease_poly,
    quad: function() {
      return d3_ease_quad;
    },
    cubic: function() {
      return d3_ease_cubic;
    },
    sin: function() {
      return d3_ease_sin;
    },
    exp: function() {
      return d3_ease_exp;
    },
    circle: function() {
      return d3_ease_circle;
    },
    elastic: d3_ease_elastic,
    back: d3_ease_back,
    bounce: function() {
      return d3_ease_bounce;
    }
  });
  var d3_ease_mode = d3.map({
    "in": d3_identity,
    out: d3_ease_reverse,
    "in-out": d3_ease_reflect,
    "out-in": function(f) {
      return d3_ease_reflect(d3_ease_reverse(f));
    }
  });
  d3.ease = function(name) {
    var i = name.indexOf("-"), t = i >= 0 ? name.slice(0, i) : name, m = i >= 0 ? name.slice(i + 1) : "in";
    t = d3_ease.get(t) || d3_ease_default;
    m = d3_ease_mode.get(m) || d3_identity;
    return d3_ease_clamp(m(t.apply(null, d3_arraySlice.call(arguments, 1))));
  };
  function d3_ease_clamp(f) {
    return function(t) {
      return t <= 0 ? 0 : t >= 1 ? 1 : f(t);
    };
  }
  function d3_ease_reverse(f) {
    return function(t) {
      return 1 - f(1 - t);
    };
  }
  function d3_ease_reflect(f) {
    return function(t) {
      return .5 * (t < .5 ? f(2 * t) : 2 - f(2 - 2 * t));
    };
  }
  function d3_ease_quad(t) {
    return t * t;
  }
  function d3_ease_cubic(t) {
    return t * t * t;
  }
  function d3_ease_cubicInOut(t) {
    if (t <= 0) return 0;
    if (t >= 1) return 1;
    var t2 = t * t, t3 = t2 * t;
    return 4 * (t < .5 ? t3 : 3 * (t - t2) + t3 - .75);
  }
  function d3_ease_poly(e) {
    return function(t) {
      return Math.pow(t, e);
    };
  }
  function d3_ease_sin(t) {
    return 1 - Math.cos(t * halfπ);
  }
  function d3_ease_exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  function d3_ease_circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  function d3_ease_elastic(a, p) {
    var s;
    if (arguments.length < 2) p = .45;
    if (arguments.length) s = p / τ * Math.asin(1 / a); else a = 1, s = p / 4;
    return function(t) {
      return 1 + a * Math.pow(2, -10 * t) * Math.sin((t - s) * τ / p);
    };
  }
  function d3_ease_back(s) {
    if (!s) s = 1.70158;
    return function(t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  function d3_ease_bounce(t) {
    return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
  }
  d3.interpolateHcl = d3_interpolateHcl;
  function d3_interpolateHcl(a, b) {
    a = d3.hcl(a);
    b = d3.hcl(b);
    var ah = a.h, ac = a.c, al = a.l, bh = b.h - ah, bc = b.c - ac, bl = b.l - al;
    if (isNaN(bc)) bc = 0, ac = isNaN(ac) ? b.c : ac;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hcl_lab(ah + bh * t, ac + bc * t, al + bl * t) + "";
    };
  }
  d3.interpolateHsl = d3_interpolateHsl;
  function d3_interpolateHsl(a, b) {
    a = d3.hsl(a);
    b = d3.hsl(b);
    var ah = a.h, as = a.s, al = a.l, bh = b.h - ah, bs = b.s - as, bl = b.l - al;
    if (isNaN(bs)) bs = 0, as = isNaN(as) ? b.s : as;
    if (isNaN(bh)) bh = 0, ah = isNaN(ah) ? b.h : ah; else if (bh > 180) bh -= 360; else if (bh < -180) bh += 360;
    return function(t) {
      return d3_hsl_rgb(ah + bh * t, as + bs * t, al + bl * t) + "";
    };
  }
  d3.interpolateLab = d3_interpolateLab;
  function d3_interpolateLab(a, b) {
    a = d3.lab(a);
    b = d3.lab(b);
    var al = a.l, aa = a.a, ab = a.b, bl = b.l - al, ba = b.a - aa, bb = b.b - ab;
    return function(t) {
      return d3_lab_rgb(al + bl * t, aa + ba * t, ab + bb * t) + "";
    };
  }
  d3.interpolateRound = d3_interpolateRound;
  function d3_interpolateRound(a, b) {
    b -= a;
    return function(t) {
      return Math.round(a + b * t);
    };
  }
  d3.transform = function(string) {
    var g = d3_document.createElementNS(d3.ns.prefix.svg, "g");
    return (d3.transform = function(string) {
      if (string != null) {
        g.setAttribute("transform", string);
        var t = g.transform.baseVal.consolidate();
      }
      return new d3_transform(t ? t.matrix : d3_transformIdentity);
    })(string);
  };
  function d3_transform(m) {
    var r0 = [ m.a, m.b ], r1 = [ m.c, m.d ], kx = d3_transformNormalize(r0), kz = d3_transformDot(r0, r1), ky = d3_transformNormalize(d3_transformCombine(r1, r0, -kz)) || 0;
    if (r0[0] * r1[1] < r1[0] * r0[1]) {
      r0[0] *= -1;
      r0[1] *= -1;
      kx *= -1;
      kz *= -1;
    }
    this.rotate = (kx ? Math.atan2(r0[1], r0[0]) : Math.atan2(-r1[0], r1[1])) * d3_degrees;
    this.translate = [ m.e, m.f ];
    this.scale = [ kx, ky ];
    this.skew = ky ? Math.atan2(kz, ky) * d3_degrees : 0;
  }
  d3_transform.prototype.toString = function() {
    return "translate(" + this.translate + ")rotate(" + this.rotate + ")skewX(" + this.skew + ")scale(" + this.scale + ")";
  };
  function d3_transformDot(a, b) {
    return a[0] * b[0] + a[1] * b[1];
  }
  function d3_transformNormalize(a) {
    var k = Math.sqrt(d3_transformDot(a, a));
    if (k) {
      a[0] /= k;
      a[1] /= k;
    }
    return k;
  }
  function d3_transformCombine(a, b, k) {
    a[0] += k * b[0];
    a[1] += k * b[1];
    return a;
  }
  var d3_transformIdentity = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
  };
  d3.interpolateTransform = d3_interpolateTransform;
  function d3_interpolateTransformPop(s) {
    return s.length ? s.pop() + "," : "";
  }
  function d3_interpolateTranslate(ta, tb, s, q) {
    if (ta[0] !== tb[0] || ta[1] !== tb[1]) {
      var i = s.push("translate(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ta[0], tb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ta[1], tb[1])
      });
    } else if (tb[0] || tb[1]) {
      s.push("translate(" + tb + ")");
    }
  }
  function d3_interpolateRotate(ra, rb, s, q) {
    if (ra !== rb) {
      if (ra - rb > 180) rb += 360; else if (rb - ra > 180) ra += 360;
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "rotate(", null, ")") - 2,
        x: d3_interpolateNumber(ra, rb)
      });
    } else if (rb) {
      s.push(d3_interpolateTransformPop(s) + "rotate(" + rb + ")");
    }
  }
  function d3_interpolateSkew(wa, wb, s, q) {
    if (wa !== wb) {
      q.push({
        i: s.push(d3_interpolateTransformPop(s) + "skewX(", null, ")") - 2,
        x: d3_interpolateNumber(wa, wb)
      });
    } else if (wb) {
      s.push(d3_interpolateTransformPop(s) + "skewX(" + wb + ")");
    }
  }
  function d3_interpolateScale(ka, kb, s, q) {
    if (ka[0] !== kb[0] || ka[1] !== kb[1]) {
      var i = s.push(d3_interpolateTransformPop(s) + "scale(", null, ",", null, ")");
      q.push({
        i: i - 4,
        x: d3_interpolateNumber(ka[0], kb[0])
      }, {
        i: i - 2,
        x: d3_interpolateNumber(ka[1], kb[1])
      });
    } else if (kb[0] !== 1 || kb[1] !== 1) {
      s.push(d3_interpolateTransformPop(s) + "scale(" + kb + ")");
    }
  }
  function d3_interpolateTransform(a, b) {
    var s = [], q = [];
    a = d3.transform(a), b = d3.transform(b);
    d3_interpolateTranslate(a.translate, b.translate, s, q);
    d3_interpolateRotate(a.rotate, b.rotate, s, q);
    d3_interpolateSkew(a.skew, b.skew, s, q);
    d3_interpolateScale(a.scale, b.scale, s, q);
    a = b = null;
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  }
  function d3_uninterpolateNumber(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return (x - a) / b;
    };
  }
  function d3_uninterpolateClamp(a, b) {
    b = (b -= a = +a) || 1 / b;
    return function(x) {
      return Math.max(0, Math.min(1, (x - a) / b));
    };
  }
  d3.layout = {};
  d3.layout.bundle = function() {
    return function(links) {
      var paths = [], i = -1, n = links.length;
      while (++i < n) paths.push(d3_layout_bundlePath(links[i]));
      return paths;
    };
  };
  function d3_layout_bundlePath(link) {
    var start = link.source, end = link.target, lca = d3_layout_bundleLeastCommonAncestor(start, end), points = [ start ];
    while (start !== lca) {
      start = start.parent;
      points.push(start);
    }
    var k = points.length;
    while (end !== lca) {
      points.splice(k, 0, end);
      end = end.parent;
    }
    return points;
  }
  function d3_layout_bundleAncestors(node) {
    var ancestors = [], parent = node.parent;
    while (parent != null) {
      ancestors.push(node);
      node = parent;
      parent = parent.parent;
    }
    ancestors.push(node);
    return ancestors;
  }
  function d3_layout_bundleLeastCommonAncestor(a, b) {
    if (a === b) return a;
    var aNodes = d3_layout_bundleAncestors(a), bNodes = d3_layout_bundleAncestors(b), aNode = aNodes.pop(), bNode = bNodes.pop(), sharedNode = null;
    while (aNode === bNode) {
      sharedNode = aNode;
      aNode = aNodes.pop();
      bNode = bNodes.pop();
    }
    return sharedNode;
  }
  d3.layout.chord = function() {
    var chord = {}, chords, groups, matrix, n, padding = 0, sortGroups, sortSubgroups, sortChords;
    function relayout() {
      var subgroups = {}, groupSums = [], groupIndex = d3.range(n), subgroupIndex = [], k, x, x0, i, j;
      chords = [];
      groups = [];
      k = 0, i = -1;
      while (++i < n) {
        x = 0, j = -1;
        while (++j < n) {
          x += matrix[i][j];
        }
        groupSums.push(x);
        subgroupIndex.push(d3.range(n));
        k += x;
      }
      if (sortGroups) {
        groupIndex.sort(function(a, b) {
          return sortGroups(groupSums[a], groupSums[b]);
        });
      }
      if (sortSubgroups) {
        subgroupIndex.forEach(function(d, i) {
          d.sort(function(a, b) {
            return sortSubgroups(matrix[i][a], matrix[i][b]);
          });
        });
      }
      k = (τ - padding * n) / k;
      x = 0, i = -1;
      while (++i < n) {
        x0 = x, j = -1;
        while (++j < n) {
          var di = groupIndex[i], dj = subgroupIndex[di][j], v = matrix[di][dj], a0 = x, a1 = x += v * k;
          subgroups[di + "-" + dj] = {
            index: di,
            subindex: dj,
            startAngle: a0,
            endAngle: a1,
            value: v
          };
        }
        groups[di] = {
          index: di,
          startAngle: x0,
          endAngle: x,
          value: groupSums[di]
        };
        x += padding;
      }
      i = -1;
      while (++i < n) {
        j = i - 1;
        while (++j < n) {
          var source = subgroups[i + "-" + j], target = subgroups[j + "-" + i];
          if (source.value || target.value) {
            chords.push(source.value < target.value ? {
              source: target,
              target: source
            } : {
              source: source,
              target: target
            });
          }
        }
      }
      if (sortChords) resort();
    }
    function resort() {
      chords.sort(function(a, b) {
        return sortChords((a.source.value + a.target.value) / 2, (b.source.value + b.target.value) / 2);
      });
    }
    chord.matrix = function(x) {
      if (!arguments.length) return matrix;
      n = (matrix = x) && matrix.length;
      chords = groups = null;
      return chord;
    };
    chord.padding = function(x) {
      if (!arguments.length) return padding;
      padding = x;
      chords = groups = null;
      return chord;
    };
    chord.sortGroups = function(x) {
      if (!arguments.length) return sortGroups;
      sortGroups = x;
      chords = groups = null;
      return chord;
    };
    chord.sortSubgroups = function(x) {
      if (!arguments.length) return sortSubgroups;
      sortSubgroups = x;
      chords = null;
      return chord;
    };
    chord.sortChords = function(x) {
      if (!arguments.length) return sortChords;
      sortChords = x;
      if (chords) resort();
      return chord;
    };
    chord.chords = function() {
      if (!chords) relayout();
      return chords;
    };
    chord.groups = function() {
      if (!groups) relayout();
      return groups;
    };
    return chord;
  };
  d3.layout.force = function() {
    var force = {}, event = d3.dispatch("start", "tick", "end"), timer, size = [ 1, 1 ], drag, alpha, friction = .9, linkDistance = d3_layout_forceLinkDistance, linkStrength = d3_layout_forceLinkStrength, charge = -30, chargeDistance2 = d3_layout_forceChargeDistance2, gravity = .1, theta2 = .64, nodes = [], links = [], distances, strengths, charges;
    function repulse(node) {
      return function(quad, x1, _, x2) {
        if (quad.point !== node) {
          var dx = quad.cx - node.x, dy = quad.cy - node.y, dw = x2 - x1, dn = dx * dx + dy * dy;
          if (dw * dw / theta2 < dn) {
            if (dn < chargeDistance2) {
              var k = quad.charge / dn;
              node.px -= dx * k;
              node.py -= dy * k;
            }
            return true;
          }
          if (quad.point && dn && dn < chargeDistance2) {
            var k = quad.pointCharge / dn;
            node.px -= dx * k;
            node.py -= dy * k;
          }
        }
        return !quad.charge;
      };
    }
    force.tick = function() {
      if ((alpha *= .99) < .005) {
        timer = null;
        event.end({
          type: "end",
          alpha: alpha = 0
        });
        return true;
      }
      var n = nodes.length, m = links.length, q, i, o, s, t, l, k, x, y;
      for (i = 0; i < m; ++i) {
        o = links[i];
        s = o.source;
        t = o.target;
        x = t.x - s.x;
        y = t.y - s.y;
        if (l = x * x + y * y) {
          l = alpha * strengths[i] * ((l = Math.sqrt(l)) - distances[i]) / l;
          x *= l;
          y *= l;
          t.x -= x * (k = s.weight + t.weight ? s.weight / (s.weight + t.weight) : .5);
          t.y -= y * k;
          s.x += x * (k = 1 - k);
          s.y += y * k;
        }
      }
      if (k = alpha * gravity) {
        x = size[0] / 2;
        y = size[1] / 2;
        i = -1;
        if (k) while (++i < n) {
          o = nodes[i];
          o.x += (x - o.x) * k;
          o.y += (y - o.y) * k;
        }
      }
      if (charge) {
        d3_layout_forceAccumulate(q = d3.geom.quadtree(nodes), alpha, charges);
        i = -1;
        while (++i < n) {
          if (!(o = nodes[i]).fixed) {
            q.visit(repulse(o));
          }
        }
      }
      i = -1;
      while (++i < n) {
        o = nodes[i];
        if (o.fixed) {
          o.x = o.px;
          o.y = o.py;
        } else {
          o.x -= (o.px - (o.px = o.x)) * friction;
          o.y -= (o.py - (o.py = o.y)) * friction;
        }
      }
      event.tick({
        type: "tick",
        alpha: alpha
      });
    };
    force.nodes = function(x) {
      if (!arguments.length) return nodes;
      nodes = x;
      return force;
    };
    force.links = function(x) {
      if (!arguments.length) return links;
      links = x;
      return force;
    };
    force.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return force;
    };
    force.linkDistance = function(x) {
      if (!arguments.length) return linkDistance;
      linkDistance = typeof x === "function" ? x : +x;
      return force;
    };
    force.distance = force.linkDistance;
    force.linkStrength = function(x) {
      if (!arguments.length) return linkStrength;
      linkStrength = typeof x === "function" ? x : +x;
      return force;
    };
    force.friction = function(x) {
      if (!arguments.length) return friction;
      friction = +x;
      return force;
    };
    force.charge = function(x) {
      if (!arguments.length) return charge;
      charge = typeof x === "function" ? x : +x;
      return force;
    };
    force.chargeDistance = function(x) {
      if (!arguments.length) return Math.sqrt(chargeDistance2);
      chargeDistance2 = x * x;
      return force;
    };
    force.gravity = function(x) {
      if (!arguments.length) return gravity;
      gravity = +x;
      return force;
    };
    force.theta = function(x) {
      if (!arguments.length) return Math.sqrt(theta2);
      theta2 = x * x;
      return force;
    };
    force.alpha = function(x) {
      if (!arguments.length) return alpha;
      x = +x;
      if (alpha) {
        if (x > 0) {
          alpha = x;
        } else {
          timer.c = null, timer.t = NaN, timer = null;
          event.end({
            type: "end",
            alpha: alpha = 0
          });
        }
      } else if (x > 0) {
        event.start({
          type: "start",
          alpha: alpha = x
        });
        timer = d3_timer(force.tick);
      }
      return force;
    };
    force.start = function() {
      var i, n = nodes.length, m = links.length, w = size[0], h = size[1], neighbors, o;
      for (i = 0; i < n; ++i) {
        (o = nodes[i]).index = i;
        o.weight = 0;
      }
      for (i = 0; i < m; ++i) {
        o = links[i];
        if (typeof o.source == "number") o.source = nodes[o.source];
        if (typeof o.target == "number") o.target = nodes[o.target];
        ++o.source.weight;
        ++o.target.weight;
      }
      for (i = 0; i < n; ++i) {
        o = nodes[i];
        if (isNaN(o.x)) o.x = position("x", w);
        if (isNaN(o.y)) o.y = position("y", h);
        if (isNaN(o.px)) o.px = o.x;
        if (isNaN(o.py)) o.py = o.y;
      }
      distances = [];
      if (typeof linkDistance === "function") for (i = 0; i < m; ++i) distances[i] = +linkDistance.call(this, links[i], i); else for (i = 0; i < m; ++i) distances[i] = linkDistance;
      strengths = [];
      if (typeof linkStrength === "function") for (i = 0; i < m; ++i) strengths[i] = +linkStrength.call(this, links[i], i); else for (i = 0; i < m; ++i) strengths[i] = linkStrength;
      charges = [];
      if (typeof charge === "function") for (i = 0; i < n; ++i) charges[i] = +charge.call(this, nodes[i], i); else for (i = 0; i < n; ++i) charges[i] = charge;
      function position(dimension, size) {
        if (!neighbors) {
          neighbors = new Array(n);
          for (j = 0; j < n; ++j) {
            neighbors[j] = [];
          }
          for (j = 0; j < m; ++j) {
            var o = links[j];
            neighbors[o.source.index].push(o.target);
            neighbors[o.target.index].push(o.source);
          }
        }
        var candidates = neighbors[i], j = -1, l = candidates.length, x;
        while (++j < l) if (!isNaN(x = candidates[j][dimension])) return x;
        return Math.random() * size;
      }
      return force.resume();
    };
    force.resume = function() {
      return force.alpha(.1);
    };
    force.stop = function() {
      return force.alpha(0);
    };
    force.drag = function() {
      if (!drag) drag = d3.behavior.drag().origin(d3_identity).on("dragstart.force", d3_layout_forceDragstart).on("drag.force", dragmove).on("dragend.force", d3_layout_forceDragend);
      if (!arguments.length) return drag;
      this.on("mouseover.force", d3_layout_forceMouseover).on("mouseout.force", d3_layout_forceMouseout).call(drag);
    };
    function dragmove(d) {
      d.px = d3.event.x, d.py = d3.event.y;
      force.resume();
    }
    return d3.rebind(force, event, "on");
  };
  function d3_layout_forceDragstart(d) {
    d.fixed |= 2;
  }
  function d3_layout_forceDragend(d) {
    d.fixed &= ~6;
  }
  function d3_layout_forceMouseover(d) {
    d.fixed |= 4;
    d.px = d.x, d.py = d.y;
  }
  function d3_layout_forceMouseout(d) {
    d.fixed &= ~4;
  }
  function d3_layout_forceAccumulate(quad, alpha, charges) {
    var cx = 0, cy = 0;
    quad.charge = 0;
    if (!quad.leaf) {
      var nodes = quad.nodes, n = nodes.length, i = -1, c;
      while (++i < n) {
        c = nodes[i];
        if (c == null) continue;
        d3_layout_forceAccumulate(c, alpha, charges);
        quad.charge += c.charge;
        cx += c.charge * c.cx;
        cy += c.charge * c.cy;
      }
    }
    if (quad.point) {
      if (!quad.leaf) {
        quad.point.x += Math.random() - .5;
        quad.point.y += Math.random() - .5;
      }
      var k = alpha * charges[quad.point.index];
      quad.charge += quad.pointCharge = k;
      cx += k * quad.point.x;
      cy += k * quad.point.y;
    }
    quad.cx = cx / quad.charge;
    quad.cy = cy / quad.charge;
  }
  var d3_layout_forceLinkDistance = 20, d3_layout_forceLinkStrength = 1, d3_layout_forceChargeDistance2 = Infinity;
  d3.layout.hierarchy = function() {
    var sort = d3_layout_hierarchySort, children = d3_layout_hierarchyChildren, value = d3_layout_hierarchyValue;
    function hierarchy(root) {
      var stack = [ root ], nodes = [], node;
      root.depth = 0;
      while ((node = stack.pop()) != null) {
        nodes.push(node);
        if ((childs = children.call(hierarchy, node, node.depth)) && (n = childs.length)) {
          var n, childs, child;
          while (--n >= 0) {
            stack.push(child = childs[n]);
            child.parent = node;
            child.depth = node.depth + 1;
          }
          if (value) node.value = 0;
          node.children = childs;
        } else {
          if (value) node.value = +value.call(hierarchy, node, node.depth) || 0;
          delete node.children;
        }
      }
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var childs, parent;
        if (sort && (childs = node.children)) childs.sort(sort);
        if (value && (parent = node.parent)) parent.value += node.value;
      });
      return nodes;
    }
    hierarchy.sort = function(x) {
      if (!arguments.length) return sort;
      sort = x;
      return hierarchy;
    };
    hierarchy.children = function(x) {
      if (!arguments.length) return children;
      children = x;
      return hierarchy;
    };
    hierarchy.value = function(x) {
      if (!arguments.length) return value;
      value = x;
      return hierarchy;
    };
    hierarchy.revalue = function(root) {
      if (value) {
        d3_layout_hierarchyVisitBefore(root, function(node) {
          if (node.children) node.value = 0;
        });
        d3_layout_hierarchyVisitAfter(root, function(node) {
          var parent;
          if (!node.children) node.value = +value.call(hierarchy, node, node.depth) || 0;
          if (parent = node.parent) parent.value += node.value;
        });
      }
      return root;
    };
    return hierarchy;
  };
  function d3_layout_hierarchyRebind(object, hierarchy) {
    d3.rebind(object, hierarchy, "sort", "children", "value");
    object.nodes = object;
    object.links = d3_layout_hierarchyLinks;
    return object;
  }
  function d3_layout_hierarchyVisitBefore(node, callback) {
    var nodes = [ node ];
    while ((node = nodes.pop()) != null) {
      callback(node);
      if ((children = node.children) && (n = children.length)) {
        var n, children;
        while (--n >= 0) nodes.push(children[n]);
      }
    }
  }
  function d3_layout_hierarchyVisitAfter(node, callback) {
    var nodes = [ node ], nodes2 = [];
    while ((node = nodes.pop()) != null) {
      nodes2.push(node);
      if ((children = node.children) && (n = children.length)) {
        var i = -1, n, children;
        while (++i < n) nodes.push(children[i]);
      }
    }
    while ((node = nodes2.pop()) != null) {
      callback(node);
    }
  }
  function d3_layout_hierarchyChildren(d) {
    return d.children;
  }
  function d3_layout_hierarchyValue(d) {
    return d.value;
  }
  function d3_layout_hierarchySort(a, b) {
    return b.value - a.value;
  }
  function d3_layout_hierarchyLinks(nodes) {
    return d3.merge(nodes.map(function(parent) {
      return (parent.children || []).map(function(child) {
        return {
          source: parent,
          target: child
        };
      });
    }));
  }
  d3.layout.partition = function() {
    var hierarchy = d3.layout.hierarchy(), size = [ 1, 1 ];
    function position(node, x, dx, dy) {
      var children = node.children;
      node.x = x;
      node.y = node.depth * dy;
      node.dx = dx;
      node.dy = dy;
      if (children && (n = children.length)) {
        var i = -1, n, c, d;
        dx = node.value ? dx / node.value : 0;
        while (++i < n) {
          position(c = children[i], x, d = c.value * dx, dy);
          x += d;
        }
      }
    }
    function depth(node) {
      var children = node.children, d = 0;
      if (children && (n = children.length)) {
        var i = -1, n;
        while (++i < n) d = Math.max(d, depth(children[i]));
      }
      return 1 + d;
    }
    function partition(d, i) {
      var nodes = hierarchy.call(this, d, i);
      position(nodes[0], 0, size[0], size[1] / depth(nodes[0]));
      return nodes;
    }
    partition.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return partition;
    };
    return d3_layout_hierarchyRebind(partition, hierarchy);
  };
  d3.layout.pie = function() {
    var value = Number, sort = d3_layout_pieSortByValue, startAngle = 0, endAngle = τ, padAngle = 0;
    function pie(data) {
      var n = data.length, values = data.map(function(d, i) {
        return +value.call(pie, d, i);
      }), a = +(typeof startAngle === "function" ? startAngle.apply(this, arguments) : startAngle), da = (typeof endAngle === "function" ? endAngle.apply(this, arguments) : endAngle) - a, p = Math.min(Math.abs(da) / n, +(typeof padAngle === "function" ? padAngle.apply(this, arguments) : padAngle)), pa = p * (da < 0 ? -1 : 1), sum = d3.sum(values), k = sum ? (da - n * pa) / sum : 0, index = d3.range(n), arcs = [], v;
      if (sort != null) index.sort(sort === d3_layout_pieSortByValue ? function(i, j) {
        return values[j] - values[i];
      } : function(i, j) {
        return sort(data[i], data[j]);
      });
      index.forEach(function(i) {
        arcs[i] = {
          data: data[i],
          value: v = values[i],
          startAngle: a,
          endAngle: a += v * k + pa,
          padAngle: p
        };
      });
      return arcs;
    }
    pie.value = function(_) {
      if (!arguments.length) return value;
      value = _;
      return pie;
    };
    pie.sort = function(_) {
      if (!arguments.length) return sort;
      sort = _;
      return pie;
    };
    pie.startAngle = function(_) {
      if (!arguments.length) return startAngle;
      startAngle = _;
      return pie;
    };
    pie.endAngle = function(_) {
      if (!arguments.length) return endAngle;
      endAngle = _;
      return pie;
    };
    pie.padAngle = function(_) {
      if (!arguments.length) return padAngle;
      padAngle = _;
      return pie;
    };
    return pie;
  };
  var d3_layout_pieSortByValue = {};
  d3.layout.stack = function() {
    var values = d3_identity, order = d3_layout_stackOrderDefault, offset = d3_layout_stackOffsetZero, out = d3_layout_stackOut, x = d3_layout_stackX, y = d3_layout_stackY;
    function stack(data, index) {
      if (!(n = data.length)) return data;
      var series = data.map(function(d, i) {
        return values.call(stack, d, i);
      });
      var points = series.map(function(d) {
        return d.map(function(v, i) {
          return [ x.call(stack, v, i), y.call(stack, v, i) ];
        });
      });
      var orders = order.call(stack, points, index);
      series = d3.permute(series, orders);
      points = d3.permute(points, orders);
      var offsets = offset.call(stack, points, index);
      var m = series[0].length, n, i, j, o;
      for (j = 0; j < m; ++j) {
        out.call(stack, series[0][j], o = offsets[j], points[0][j][1]);
        for (i = 1; i < n; ++i) {
          out.call(stack, series[i][j], o += points[i - 1][j][1], points[i][j][1]);
        }
      }
      return data;
    }
    stack.values = function(x) {
      if (!arguments.length) return values;
      values = x;
      return stack;
    };
    stack.order = function(x) {
      if (!arguments.length) return order;
      order = typeof x === "function" ? x : d3_layout_stackOrders.get(x) || d3_layout_stackOrderDefault;
      return stack;
    };
    stack.offset = function(x) {
      if (!arguments.length) return offset;
      offset = typeof x === "function" ? x : d3_layout_stackOffsets.get(x) || d3_layout_stackOffsetZero;
      return stack;
    };
    stack.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      return stack;
    };
    stack.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      return stack;
    };
    stack.out = function(z) {
      if (!arguments.length) return out;
      out = z;
      return stack;
    };
    return stack;
  };
  function d3_layout_stackX(d) {
    return d.x;
  }
  function d3_layout_stackY(d) {
    return d.y;
  }
  function d3_layout_stackOut(d, y0, y) {
    d.y0 = y0;
    d.y = y;
  }
  var d3_layout_stackOrders = d3.map({
    "inside-out": function(data) {
      var n = data.length, i, j, max = data.map(d3_layout_stackMaxIndex), sums = data.map(d3_layout_stackReduceSum), index = d3.range(n).sort(function(a, b) {
        return max[a] - max[b];
      }), top = 0, bottom = 0, tops = [], bottoms = [];
      for (i = 0; i < n; ++i) {
        j = index[i];
        if (top < bottom) {
          top += sums[j];
          tops.push(j);
        } else {
          bottom += sums[j];
          bottoms.push(j);
        }
      }
      return bottoms.reverse().concat(tops);
    },
    reverse: function(data) {
      return d3.range(data.length).reverse();
    },
    "default": d3_layout_stackOrderDefault
  });
  var d3_layout_stackOffsets = d3.map({
    silhouette: function(data) {
      var n = data.length, m = data[0].length, sums = [], max = 0, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o > max) max = o;
        sums.push(o);
      }
      for (j = 0; j < m; ++j) {
        y0[j] = (max - sums[j]) / 2;
      }
      return y0;
    },
    wiggle: function(data) {
      var n = data.length, x = data[0], m = x.length, i, j, k, s1, s2, s3, dx, o, o0, y0 = [];
      y0[0] = o = o0 = 0;
      for (j = 1; j < m; ++j) {
        for (i = 0, s1 = 0; i < n; ++i) s1 += data[i][j][1];
        for (i = 0, s2 = 0, dx = x[j][0] - x[j - 1][0]; i < n; ++i) {
          for (k = 0, s3 = (data[i][j][1] - data[i][j - 1][1]) / (2 * dx); k < i; ++k) {
            s3 += (data[k][j][1] - data[k][j - 1][1]) / dx;
          }
          s2 += s3 * data[i][j][1];
        }
        y0[j] = o -= s1 ? s2 / s1 * dx : 0;
        if (o < o0) o0 = o;
      }
      for (j = 0; j < m; ++j) y0[j] -= o0;
      return y0;
    },
    expand: function(data) {
      var n = data.length, m = data[0].length, k = 1 / n, i, j, o, y0 = [];
      for (j = 0; j < m; ++j) {
        for (i = 0, o = 0; i < n; i++) o += data[i][j][1];
        if (o) for (i = 0; i < n; i++) data[i][j][1] /= o; else for (i = 0; i < n; i++) data[i][j][1] = k;
      }
      for (j = 0; j < m; ++j) y0[j] = 0;
      return y0;
    },
    zero: d3_layout_stackOffsetZero
  });
  function d3_layout_stackOrderDefault(data) {
    return d3.range(data.length);
  }
  function d3_layout_stackOffsetZero(data) {
    var j = -1, m = data[0].length, y0 = [];
    while (++j < m) y0[j] = 0;
    return y0;
  }
  function d3_layout_stackMaxIndex(array) {
    var i = 1, j = 0, v = array[0][1], k, n = array.length;
    for (;i < n; ++i) {
      if ((k = array[i][1]) > v) {
        j = i;
        v = k;
      }
    }
    return j;
  }
  function d3_layout_stackReduceSum(d) {
    return d.reduce(d3_layout_stackSum, 0);
  }
  function d3_layout_stackSum(p, d) {
    return p + d[1];
  }
  d3.layout.histogram = function() {
    var frequency = true, valuer = Number, ranger = d3_layout_histogramRange, binner = d3_layout_histogramBinSturges;
    function histogram(data, i) {
      var bins = [], values = data.map(valuer, this), range = ranger.call(this, values, i), thresholds = binner.call(this, range, values, i), bin, i = -1, n = values.length, m = thresholds.length - 1, k = frequency ? 1 : 1 / n, x;
      while (++i < m) {
        bin = bins[i] = [];
        bin.dx = thresholds[i + 1] - (bin.x = thresholds[i]);
        bin.y = 0;
      }
      if (m > 0) {
        i = -1;
        while (++i < n) {
          x = values[i];
          if (x >= range[0] && x <= range[1]) {
            bin = bins[d3.bisect(thresholds, x, 1, m) - 1];
            bin.y += k;
            bin.push(data[i]);
          }
        }
      }
      return bins;
    }
    histogram.value = function(x) {
      if (!arguments.length) return valuer;
      valuer = x;
      return histogram;
    };
    histogram.range = function(x) {
      if (!arguments.length) return ranger;
      ranger = d3_functor(x);
      return histogram;
    };
    histogram.bins = function(x) {
      if (!arguments.length) return binner;
      binner = typeof x === "number" ? function(range) {
        return d3_layout_histogramBinFixed(range, x);
      } : d3_functor(x);
      return histogram;
    };
    histogram.frequency = function(x) {
      if (!arguments.length) return frequency;
      frequency = !!x;
      return histogram;
    };
    return histogram;
  };
  function d3_layout_histogramBinSturges(range, values) {
    return d3_layout_histogramBinFixed(range, Math.ceil(Math.log(values.length) / Math.LN2 + 1));
  }
  function d3_layout_histogramBinFixed(range, n) {
    var x = -1, b = +range[0], m = (range[1] - b) / n, f = [];
    while (++x <= n) f[x] = m * x + b;
    return f;
  }
  function d3_layout_histogramRange(values) {
    return [ d3.min(values), d3.max(values) ];
  }
  d3.layout.pack = function() {
    var hierarchy = d3.layout.hierarchy().sort(d3_layout_packSort), padding = 0, size = [ 1, 1 ], radius;
    function pack(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], w = size[0], h = size[1], r = radius == null ? Math.sqrt : typeof radius === "function" ? radius : function() {
        return radius;
      };
      root.x = root.y = 0;
      d3_layout_hierarchyVisitAfter(root, function(d) {
        d.r = +r(d.value);
      });
      d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
      if (padding) {
        var dr = padding * (radius ? 1 : Math.max(2 * root.r / w, 2 * root.r / h)) / 2;
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r += dr;
        });
        d3_layout_hierarchyVisitAfter(root, d3_layout_packSiblings);
        d3_layout_hierarchyVisitAfter(root, function(d) {
          d.r -= dr;
        });
      }
      d3_layout_packTransform(root, w / 2, h / 2, radius ? 1 : 1 / Math.max(2 * root.r / w, 2 * root.r / h));
      return nodes;
    }
    pack.size = function(_) {
      if (!arguments.length) return size;
      size = _;
      return pack;
    };
    pack.radius = function(_) {
      if (!arguments.length) return radius;
      radius = _ == null || typeof _ === "function" ? _ : +_;
      return pack;
    };
    pack.padding = function(_) {
      if (!arguments.length) return padding;
      padding = +_;
      return pack;
    };
    return d3_layout_hierarchyRebind(pack, hierarchy);
  };
  function d3_layout_packSort(a, b) {
    return a.value - b.value;
  }
  function d3_layout_packInsert(a, b) {
    var c = a._pack_next;
    a._pack_next = b;
    b._pack_prev = a;
    b._pack_next = c;
    c._pack_prev = b;
  }
  function d3_layout_packSplice(a, b) {
    a._pack_next = b;
    b._pack_prev = a;
  }
  function d3_layout_packIntersects(a, b) {
    var dx = b.x - a.x, dy = b.y - a.y, dr = a.r + b.r;
    return .999 * dr * dr > dx * dx + dy * dy;
  }
  function d3_layout_packSiblings(node) {
    if (!(nodes = node.children) || !(n = nodes.length)) return;
    var nodes, xMin = Infinity, xMax = -Infinity, yMin = Infinity, yMax = -Infinity, a, b, c, i, j, k, n;
    function bound(node) {
      xMin = Math.min(node.x - node.r, xMin);
      xMax = Math.max(node.x + node.r, xMax);
      yMin = Math.min(node.y - node.r, yMin);
      yMax = Math.max(node.y + node.r, yMax);
    }
    nodes.forEach(d3_layout_packLink);
    a = nodes[0];
    a.x = -a.r;
    a.y = 0;
    bound(a);
    if (n > 1) {
      b = nodes[1];
      b.x = b.r;
      b.y = 0;
      bound(b);
      if (n > 2) {
        c = nodes[2];
        d3_layout_packPlace(a, b, c);
        bound(c);
        d3_layout_packInsert(a, c);
        a._pack_prev = c;
        d3_layout_packInsert(c, b);
        b = a._pack_next;
        for (i = 3; i < n; i++) {
          d3_layout_packPlace(a, b, c = nodes[i]);
          var isect = 0, s1 = 1, s2 = 1;
          for (j = b._pack_next; j !== b; j = j._pack_next, s1++) {
            if (d3_layout_packIntersects(j, c)) {
              isect = 1;
              break;
            }
          }
          if (isect == 1) {
            for (k = a._pack_prev; k !== j._pack_prev; k = k._pack_prev, s2++) {
              if (d3_layout_packIntersects(k, c)) {
                break;
              }
            }
          }
          if (isect) {
            if (s1 < s2 || s1 == s2 && b.r < a.r) d3_layout_packSplice(a, b = j); else d3_layout_packSplice(a = k, b);
            i--;
          } else {
            d3_layout_packInsert(a, c);
            b = c;
            bound(c);
          }
        }
      }
    }
    var cx = (xMin + xMax) / 2, cy = (yMin + yMax) / 2, cr = 0;
    for (i = 0; i < n; i++) {
      c = nodes[i];
      c.x -= cx;
      c.y -= cy;
      cr = Math.max(cr, c.r + Math.sqrt(c.x * c.x + c.y * c.y));
    }
    node.r = cr;
    nodes.forEach(d3_layout_packUnlink);
  }
  function d3_layout_packLink(node) {
    node._pack_next = node._pack_prev = node;
  }
  function d3_layout_packUnlink(node) {
    delete node._pack_next;
    delete node._pack_prev;
  }
  function d3_layout_packTransform(node, x, y, k) {
    var children = node.children;
    node.x = x += k * node.x;
    node.y = y += k * node.y;
    node.r *= k;
    if (children) {
      var i = -1, n = children.length;
      while (++i < n) d3_layout_packTransform(children[i], x, y, k);
    }
  }
  function d3_layout_packPlace(a, b, c) {
    var db = a.r + c.r, dx = b.x - a.x, dy = b.y - a.y;
    if (db && (dx || dy)) {
      var da = b.r + c.r, dc = dx * dx + dy * dy;
      da *= da;
      db *= db;
      var x = .5 + (db - da) / (2 * dc), y = Math.sqrt(Math.max(0, 2 * da * (db + dc) - (db -= dc) * db - da * da)) / (2 * dc);
      c.x = a.x + x * dx + y * dy;
      c.y = a.y + x * dy - y * dx;
    } else {
      c.x = a.x + db;
      c.y = a.y;
    }
  }
  d3.layout.tree = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = null;
    function tree(d, i) {
      var nodes = hierarchy.call(this, d, i), root0 = nodes[0], root1 = wrapTree(root0);
      d3_layout_hierarchyVisitAfter(root1, firstWalk), root1.parent.m = -root1.z;
      d3_layout_hierarchyVisitBefore(root1, secondWalk);
      if (nodeSize) d3_layout_hierarchyVisitBefore(root0, sizeNode); else {
        var left = root0, right = root0, bottom = root0;
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          if (node.x < left.x) left = node;
          if (node.x > right.x) right = node;
          if (node.depth > bottom.depth) bottom = node;
        });
        var tx = separation(left, right) / 2 - left.x, kx = size[0] / (right.x + separation(right, left) / 2 + tx), ky = size[1] / (bottom.depth || 1);
        d3_layout_hierarchyVisitBefore(root0, function(node) {
          node.x = (node.x + tx) * kx;
          node.y = node.depth * ky;
        });
      }
      return nodes;
    }
    function wrapTree(root0) {
      var root1 = {
        A: null,
        children: [ root0 ]
      }, queue = [ root1 ], node1;
      while ((node1 = queue.pop()) != null) {
        for (var children = node1.children, child, i = 0, n = children.length; i < n; ++i) {
          queue.push((children[i] = child = {
            _: children[i],
            parent: node1,
            children: (child = children[i].children) && child.slice() || [],
            A: null,
            a: null,
            z: 0,
            m: 0,
            c: 0,
            s: 0,
            t: null,
            i: i
          }).a = child);
        }
      }
      return root1.children[0];
    }
    function firstWalk(v) {
      var children = v.children, siblings = v.parent.children, w = v.i ? siblings[v.i - 1] : null;
      if (children.length) {
        d3_layout_treeShift(v);
        var midpoint = (children[0].z + children[children.length - 1].z) / 2;
        if (w) {
          v.z = w.z + separation(v._, w._);
          v.m = v.z - midpoint;
        } else {
          v.z = midpoint;
        }
      } else if (w) {
        v.z = w.z + separation(v._, w._);
      }
      v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
    }
    function secondWalk(v) {
      v._.x = v.z + v.parent.m;
      v.m += v.parent.m;
    }
    function apportion(v, w, ancestor) {
      if (w) {
        var vip = v, vop = v, vim = w, vom = vip.parent.children[0], sip = vip.m, sop = vop.m, sim = vim.m, som = vom.m, shift;
        while (vim = d3_layout_treeRight(vim), vip = d3_layout_treeLeft(vip), vim && vip) {
          vom = d3_layout_treeLeft(vom);
          vop = d3_layout_treeRight(vop);
          vop.a = v;
          shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
          if (shift > 0) {
            d3_layout_treeMove(d3_layout_treeAncestor(vim, v, ancestor), v, shift);
            sip += shift;
            sop += shift;
          }
          sim += vim.m;
          sip += vip.m;
          som += vom.m;
          sop += vop.m;
        }
        if (vim && !d3_layout_treeRight(vop)) {
          vop.t = vim;
          vop.m += sim - sop;
        }
        if (vip && !d3_layout_treeLeft(vom)) {
          vom.t = vip;
          vom.m += sip - som;
          ancestor = v;
        }
      }
      return ancestor;
    }
    function sizeNode(node) {
      node.x *= size[0];
      node.y = node.depth * size[1];
    }
    tree.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return tree;
    };
    tree.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null ? sizeNode : null;
      return tree;
    };
    tree.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) == null ? null : sizeNode;
      return tree;
    };
    return d3_layout_hierarchyRebind(tree, hierarchy);
  };
  function d3_layout_treeSeparation(a, b) {
    return a.parent == b.parent ? 1 : 2;
  }
  function d3_layout_treeLeft(v) {
    var children = v.children;
    return children.length ? children[0] : v.t;
  }
  function d3_layout_treeRight(v) {
    var children = v.children, n;
    return (n = children.length) ? children[n - 1] : v.t;
  }
  function d3_layout_treeMove(wm, wp, shift) {
    var change = shift / (wp.i - wm.i);
    wp.c -= change;
    wp.s += shift;
    wm.c += change;
    wp.z += shift;
    wp.m += shift;
  }
  function d3_layout_treeShift(v) {
    var shift = 0, change = 0, children = v.children, i = children.length, w;
    while (--i >= 0) {
      w = children[i];
      w.z += shift;
      w.m += shift;
      shift += w.s + (change += w.c);
    }
  }
  function d3_layout_treeAncestor(vim, v, ancestor) {
    return vim.a.parent === v.parent ? vim.a : ancestor;
  }
  d3.layout.cluster = function() {
    var hierarchy = d3.layout.hierarchy().sort(null).value(null), separation = d3_layout_treeSeparation, size = [ 1, 1 ], nodeSize = false;
    function cluster(d, i) {
      var nodes = hierarchy.call(this, d, i), root = nodes[0], previousNode, x = 0;
      d3_layout_hierarchyVisitAfter(root, function(node) {
        var children = node.children;
        if (children && children.length) {
          node.x = d3_layout_clusterX(children);
          node.y = d3_layout_clusterY(children);
        } else {
          node.x = previousNode ? x += separation(node, previousNode) : 0;
          node.y = 0;
          previousNode = node;
        }
      });
      var left = d3_layout_clusterLeft(root), right = d3_layout_clusterRight(root), x0 = left.x - separation(left, right) / 2, x1 = right.x + separation(right, left) / 2;
      d3_layout_hierarchyVisitAfter(root, nodeSize ? function(node) {
        node.x = (node.x - root.x) * size[0];
        node.y = (root.y - node.y) * size[1];
      } : function(node) {
        node.x = (node.x - x0) / (x1 - x0) * size[0];
        node.y = (1 - (root.y ? node.y / root.y : 1)) * size[1];
      });
      return nodes;
    }
    cluster.separation = function(x) {
      if (!arguments.length) return separation;
      separation = x;
      return cluster;
    };
    cluster.size = function(x) {
      if (!arguments.length) return nodeSize ? null : size;
      nodeSize = (size = x) == null;
      return cluster;
    };
    cluster.nodeSize = function(x) {
      if (!arguments.length) return nodeSize ? size : null;
      nodeSize = (size = x) != null;
      return cluster;
    };
    return d3_layout_hierarchyRebind(cluster, hierarchy);
  };
  function d3_layout_clusterY(children) {
    return 1 + d3.max(children, function(child) {
      return child.y;
    });
  }
  function d3_layout_clusterX(children) {
    return children.reduce(function(x, child) {
      return x + child.x;
    }, 0) / children.length;
  }
  function d3_layout_clusterLeft(node) {
    var children = node.children;
    return children && children.length ? d3_layout_clusterLeft(children[0]) : node;
  }
  function d3_layout_clusterRight(node) {
    var children = node.children, n;
    return children && (n = children.length) ? d3_layout_clusterRight(children[n - 1]) : node;
  }
  d3.layout.treemap = function() {
    var hierarchy = d3.layout.hierarchy(), round = Math.round, size = [ 1, 1 ], padding = null, pad = d3_layout_treemapPadNull, sticky = false, stickies, mode = "squarify", ratio = .5 * (1 + Math.sqrt(5));
    function scale(children, k) {
      var i = -1, n = children.length, child, area;
      while (++i < n) {
        area = (child = children[i]).value * (k < 0 ? 0 : k);
        child.area = isNaN(area) || area <= 0 ? 0 : area;
      }
    }
    function squarify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), row = [], remaining = children.slice(), child, best = Infinity, score, u = mode === "slice" ? rect.dx : mode === "dice" ? rect.dy : mode === "slice-dice" ? node.depth & 1 ? rect.dy : rect.dx : Math.min(rect.dx, rect.dy), n;
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while ((n = remaining.length) > 0) {
          row.push(child = remaining[n - 1]);
          row.area += child.area;
          if (mode !== "squarify" || (score = worst(row, u)) <= best) {
            remaining.pop();
            best = score;
          } else {
            row.area -= row.pop().area;
            position(row, u, rect, false);
            u = Math.min(rect.dx, rect.dy);
            row.length = row.area = 0;
            best = Infinity;
          }
        }
        if (row.length) {
          position(row, u, rect, true);
          row.length = row.area = 0;
        }
        children.forEach(squarify);
      }
    }
    function stickify(node) {
      var children = node.children;
      if (children && children.length) {
        var rect = pad(node), remaining = children.slice(), child, row = [];
        scale(remaining, rect.dx * rect.dy / node.value);
        row.area = 0;
        while (child = remaining.pop()) {
          row.push(child);
          row.area += child.area;
          if (child.z != null) {
            position(row, child.z ? rect.dx : rect.dy, rect, !remaining.length);
            row.length = row.area = 0;
          }
        }
        children.forEach(stickify);
      }
    }
    function worst(row, u) {
      var s = row.area, r, rmax = 0, rmin = Infinity, i = -1, n = row.length;
      while (++i < n) {
        if (!(r = row[i].area)) continue;
        if (r < rmin) rmin = r;
        if (r > rmax) rmax = r;
      }
      s *= s;
      u *= u;
      return s ? Math.max(u * rmax * ratio / s, s / (u * rmin * ratio)) : Infinity;
    }
    function position(row, u, rect, flush) {
      var i = -1, n = row.length, x = rect.x, y = rect.y, v = u ? round(row.area / u) : 0, o;
      if (u == rect.dx) {
        if (flush || v > rect.dy) v = rect.dy;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dy = v;
          x += o.dx = Math.min(rect.x + rect.dx - x, v ? round(o.area / v) : 0);
        }
        o.z = true;
        o.dx += rect.x + rect.dx - x;
        rect.y += v;
        rect.dy -= v;
      } else {
        if (flush || v > rect.dx) v = rect.dx;
        while (++i < n) {
          o = row[i];
          o.x = x;
          o.y = y;
          o.dx = v;
          y += o.dy = Math.min(rect.y + rect.dy - y, v ? round(o.area / v) : 0);
        }
        o.z = false;
        o.dy += rect.y + rect.dy - y;
        rect.x += v;
        rect.dx -= v;
      }
    }
    function treemap(d) {
      var nodes = stickies || hierarchy(d), root = nodes[0];
      root.x = root.y = 0;
      if (root.value) root.dx = size[0], root.dy = size[1]; else root.dx = root.dy = 0;
      if (stickies) hierarchy.revalue(root);
      scale([ root ], root.dx * root.dy / root.value);
      (stickies ? stickify : squarify)(root);
      if (sticky) stickies = nodes;
      return nodes;
    }
    treemap.size = function(x) {
      if (!arguments.length) return size;
      size = x;
      return treemap;
    };
    treemap.padding = function(x) {
      if (!arguments.length) return padding;
      function padFunction(node) {
        var p = x.call(treemap, node, node.depth);
        return p == null ? d3_layout_treemapPadNull(node) : d3_layout_treemapPad(node, typeof p === "number" ? [ p, p, p, p ] : p);
      }
      function padConstant(node) {
        return d3_layout_treemapPad(node, x);
      }
      var type;
      pad = (padding = x) == null ? d3_layout_treemapPadNull : (type = typeof x) === "function" ? padFunction : type === "number" ? (x = [ x, x, x, x ], 
      padConstant) : padConstant;
      return treemap;
    };
    treemap.round = function(x) {
      if (!arguments.length) return round != Number;
      round = x ? Math.round : Number;
      return treemap;
    };
    treemap.sticky = function(x) {
      if (!arguments.length) return sticky;
      sticky = x;
      stickies = null;
      return treemap;
    };
    treemap.ratio = function(x) {
      if (!arguments.length) return ratio;
      ratio = x;
      return treemap;
    };
    treemap.mode = function(x) {
      if (!arguments.length) return mode;
      mode = x + "";
      return treemap;
    };
    return d3_layout_hierarchyRebind(treemap, hierarchy);
  };
  function d3_layout_treemapPadNull(node) {
    return {
      x: node.x,
      y: node.y,
      dx: node.dx,
      dy: node.dy
    };
  }
  function d3_layout_treemapPad(node, padding) {
    var x = node.x + padding[3], y = node.y + padding[0], dx = node.dx - padding[1] - padding[3], dy = node.dy - padding[0] - padding[2];
    if (dx < 0) {
      x += dx / 2;
      dx = 0;
    }
    if (dy < 0) {
      y += dy / 2;
      dy = 0;
    }
    return {
      x: x,
      y: y,
      dx: dx,
      dy: dy
    };
  }
  d3.random = {
    normal: function(µ, σ) {
      var n = arguments.length;
      if (n < 2) σ = 1;
      if (n < 1) µ = 0;
      return function() {
        var x, y, r;
        do {
          x = Math.random() * 2 - 1;
          y = Math.random() * 2 - 1;
          r = x * x + y * y;
        } while (!r || r > 1);
        return µ + σ * x * Math.sqrt(-2 * Math.log(r) / r);
      };
    },
    logNormal: function() {
      var random = d3.random.normal.apply(d3, arguments);
      return function() {
        return Math.exp(random());
      };
    },
    bates: function(m) {
      var random = d3.random.irwinHall(m);
      return function() {
        return random() / m;
      };
    },
    irwinHall: function(m) {
      return function() {
        for (var s = 0, j = 0; j < m; j++) s += Math.random();
        return s;
      };
    }
  };
  d3.scale = {};
  function d3_scaleExtent(domain) {
    var start = domain[0], stop = domain[domain.length - 1];
    return start < stop ? [ start, stop ] : [ stop, start ];
  }
  function d3_scaleRange(scale) {
    return scale.rangeExtent ? scale.rangeExtent() : d3_scaleExtent(scale.range());
  }
  function d3_scale_bilinear(domain, range, uninterpolate, interpolate) {
    var u = uninterpolate(domain[0], domain[1]), i = interpolate(range[0], range[1]);
    return function(x) {
      return i(u(x));
    };
  }
  function d3_scale_nice(domain, nice) {
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], dx;
    if (x1 < x0) {
      dx = i0, i0 = i1, i1 = dx;
      dx = x0, x0 = x1, x1 = dx;
    }
    domain[i0] = nice.floor(x0);
    domain[i1] = nice.ceil(x1);
    return domain;
  }
  function d3_scale_niceStep(step) {
    return step ? {
      floor: function(x) {
        return Math.floor(x / step) * step;
      },
      ceil: function(x) {
        return Math.ceil(x / step) * step;
      }
    } : d3_scale_niceIdentity;
  }
  var d3_scale_niceIdentity = {
    floor: d3_identity,
    ceil: d3_identity
  };
  function d3_scale_polylinear(domain, range, uninterpolate, interpolate) {
    var u = [], i = [], j = 0, k = Math.min(domain.length, range.length) - 1;
    if (domain[k] < domain[0]) {
      domain = domain.slice().reverse();
      range = range.slice().reverse();
    }
    while (++j <= k) {
      u.push(uninterpolate(domain[j - 1], domain[j]));
      i.push(interpolate(range[j - 1], range[j]));
    }
    return function(x) {
      var j = d3.bisect(domain, x, 1, k) - 1;
      return i[j](u[j](x));
    };
  }
  d3.scale.linear = function() {
    return d3_scale_linear([ 0, 1 ], [ 0, 1 ], d3_interpolate, false);
  };
  function d3_scale_linear(domain, range, interpolate, clamp) {
    var output, input;
    function rescale() {
      var linear = Math.min(domain.length, range.length) > 2 ? d3_scale_polylinear : d3_scale_bilinear, uninterpolate = clamp ? d3_uninterpolateClamp : d3_uninterpolateNumber;
      output = linear(domain, range, uninterpolate, interpolate);
      input = linear(range, domain, uninterpolate, d3_interpolate);
      return scale;
    }
    function scale(x) {
      return output(x);
    }
    scale.invert = function(y) {
      return input(y);
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(Number);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.rangeRound = function(x) {
      return scale.range(x).interpolate(d3_interpolateRound);
    };
    scale.clamp = function(x) {
      if (!arguments.length) return clamp;
      clamp = x;
      return rescale();
    };
    scale.interpolate = function(x) {
      if (!arguments.length) return interpolate;
      interpolate = x;
      return rescale();
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      d3_scale_linearNice(domain, m);
      return rescale();
    };
    scale.copy = function() {
      return d3_scale_linear(domain, range, interpolate, clamp);
    };
    return rescale();
  }
  function d3_scale_linearRebind(scale, linear) {
    return d3.rebind(scale, linear, "range", "rangeRound", "interpolate", "clamp");
  }
  function d3_scale_linearNice(domain, m) {
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    d3_scale_nice(domain, d3_scale_niceStep(d3_scale_linearTickRange(domain, m)[2]));
    return domain;
  }
  function d3_scale_linearTickRange(domain, m) {
    if (m == null) m = 10;
    var extent = d3_scaleExtent(domain), span = extent[1] - extent[0], step = Math.pow(10, Math.floor(Math.log(span / m) / Math.LN10)), err = m / span * step;
    if (err <= .15) step *= 10; else if (err <= .35) step *= 5; else if (err <= .75) step *= 2;
    extent[0] = Math.ceil(extent[0] / step) * step;
    extent[1] = Math.floor(extent[1] / step) * step + step * .5;
    extent[2] = step;
    return extent;
  }
  function d3_scale_linearTicks(domain, m) {
    return d3.range.apply(d3, d3_scale_linearTickRange(domain, m));
  }
  function d3_scale_linearTickFormat(domain, m, format) {
    var range = d3_scale_linearTickRange(domain, m);
    if (format) {
      var match = d3_format_re.exec(format);
      match.shift();
      if (match[8] === "s") {
        var prefix = d3.formatPrefix(Math.max(abs(range[0]), abs(range[1])));
        if (!match[7]) match[7] = "." + d3_scale_linearPrecision(prefix.scale(range[2]));
        match[8] = "f";
        format = d3.format(match.join(""));
        return function(d) {
          return format(prefix.scale(d)) + prefix.symbol;
        };
      }
      if (!match[7]) match[7] = "." + d3_scale_linearFormatPrecision(match[8], range);
      format = match.join("");
    } else {
      format = ",." + d3_scale_linearPrecision(range[2]) + "f";
    }
    return d3.format(format);
  }
  var d3_scale_linearFormatSignificant = {
    s: 1,
    g: 1,
    p: 1,
    r: 1,
    e: 1
  };
  function d3_scale_linearPrecision(value) {
    return -Math.floor(Math.log(value) / Math.LN10 + .01);
  }
  function d3_scale_linearFormatPrecision(type, range) {
    var p = d3_scale_linearPrecision(range[2]);
    return type in d3_scale_linearFormatSignificant ? Math.abs(p - d3_scale_linearPrecision(Math.max(abs(range[0]), abs(range[1])))) + +(type !== "e") : p - (type === "%") * 2;
  }
  d3.scale.log = function() {
    return d3_scale_log(d3.scale.linear().domain([ 0, 1 ]), 10, true, [ 1, 10 ]);
  };
  function d3_scale_log(linear, base, positive, domain) {
    function log(x) {
      return (positive ? Math.log(x < 0 ? 0 : x) : -Math.log(x > 0 ? 0 : -x)) / Math.log(base);
    }
    function pow(x) {
      return positive ? Math.pow(base, x) : -Math.pow(base, -x);
    }
    function scale(x) {
      return linear(log(x));
    }
    scale.invert = function(x) {
      return pow(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      positive = x[0] >= 0;
      linear.domain((domain = x.map(Number)).map(log));
      return scale;
    };
    scale.base = function(_) {
      if (!arguments.length) return base;
      base = +_;
      linear.domain(domain.map(log));
      return scale;
    };
    scale.nice = function() {
      var niced = d3_scale_nice(domain.map(log), positive ? Math : d3_scale_logNiceNegative);
      linear.domain(niced);
      domain = niced.map(pow);
      return scale;
    };
    scale.ticks = function() {
      var extent = d3_scaleExtent(domain), ticks = [], u = extent[0], v = extent[1], i = Math.floor(log(u)), j = Math.ceil(log(v)), n = base % 1 ? 2 : base;
      if (isFinite(j - i)) {
        if (positive) {
          for (;i < j; i++) for (var k = 1; k < n; k++) ticks.push(pow(i) * k);
          ticks.push(pow(i));
        } else {
          ticks.push(pow(i));
          for (;i++ < j; ) for (var k = n - 1; k > 0; k--) ticks.push(pow(i) * k);
        }
        for (i = 0; ticks[i] < u; i++) {}
        for (j = ticks.length; ticks[j - 1] > v; j--) {}
        ticks = ticks.slice(i, j);
      }
      return ticks;
    };
    scale.tickFormat = function(n, format) {
      if (!arguments.length) return d3_scale_logFormat;
      if (arguments.length < 2) format = d3_scale_logFormat; else if (typeof format !== "function") format = d3.format(format);
      var k = Math.max(1, base * n / scale.ticks().length);
      return function(d) {
        var i = d / pow(Math.round(log(d)));
        if (i * base < base - .5) i *= base;
        return i <= k ? format(d) : "";
      };
    };
    scale.copy = function() {
      return d3_scale_log(linear.copy(), base, positive, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  var d3_scale_logFormat = d3.format(".0e"), d3_scale_logNiceNegative = {
    floor: function(x) {
      return -Math.ceil(-x);
    },
    ceil: function(x) {
      return -Math.floor(-x);
    }
  };
  d3.scale.pow = function() {
    return d3_scale_pow(d3.scale.linear(), 1, [ 0, 1 ]);
  };
  function d3_scale_pow(linear, exponent, domain) {
    var powp = d3_scale_powPow(exponent), powb = d3_scale_powPow(1 / exponent);
    function scale(x) {
      return linear(powp(x));
    }
    scale.invert = function(x) {
      return powb(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      linear.domain((domain = x.map(Number)).map(powp));
      return scale;
    };
    scale.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    scale.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    scale.nice = function(m) {
      return scale.domain(d3_scale_linearNice(domain, m));
    };
    scale.exponent = function(x) {
      if (!arguments.length) return exponent;
      powp = d3_scale_powPow(exponent = x);
      powb = d3_scale_powPow(1 / exponent);
      linear.domain(domain.map(powp));
      return scale;
    };
    scale.copy = function() {
      return d3_scale_pow(linear.copy(), exponent, domain);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_scale_powPow(e) {
    return function(x) {
      return x < 0 ? -Math.pow(-x, e) : Math.pow(x, e);
    };
  }
  d3.scale.sqrt = function() {
    return d3.scale.pow().exponent(.5);
  };
  d3.scale.ordinal = function() {
    return d3_scale_ordinal([], {
      t: "range",
      a: [ [] ]
    });
  };
  function d3_scale_ordinal(domain, ranger) {
    var index, range, rangeBand;
    function scale(x) {
      return range[((index.get(x) || (ranger.t === "range" ? index.set(x, domain.push(x)) : NaN)) - 1) % range.length];
    }
    function steps(start, step) {
      return d3.range(domain.length).map(function(i) {
        return start + step * i;
      });
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = [];
      index = new d3_Map();
      var i = -1, n = x.length, xi;
      while (++i < n) if (!index.has(xi = x[i])) index.set(xi, domain.push(xi));
      return scale[ranger.t].apply(scale, ranger.a);
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      rangeBand = 0;
      ranger = {
        t: "range",
        a: arguments
      };
      return scale;
    };
    scale.rangePoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = (start + stop) / 2, 
      0) : (stop - start) / (domain.length - 1 + padding);
      range = steps(start + step * padding / 2, step);
      rangeBand = 0;
      ranger = {
        t: "rangePoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundPoints = function(x, padding) {
      if (arguments.length < 2) padding = 0;
      var start = x[0], stop = x[1], step = domain.length < 2 ? (start = stop = Math.round((start + stop) / 2), 
      0) : (stop - start) / (domain.length - 1 + padding) | 0;
      range = steps(start + Math.round(step * padding / 2 + (stop - start - (domain.length - 1 + padding) * step) / 2), step);
      rangeBand = 0;
      ranger = {
        t: "rangeRoundPoints",
        a: arguments
      };
      return scale;
    };
    scale.rangeBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = (stop - start) / (domain.length - padding + 2 * outerPadding);
      range = steps(start + step * outerPadding, step);
      if (reverse) range.reverse();
      rangeBand = step * (1 - padding);
      ranger = {
        t: "rangeBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeRoundBands = function(x, padding, outerPadding) {
      if (arguments.length < 2) padding = 0;
      if (arguments.length < 3) outerPadding = padding;
      var reverse = x[1] < x[0], start = x[reverse - 0], stop = x[1 - reverse], step = Math.floor((stop - start) / (domain.length - padding + 2 * outerPadding));
      range = steps(start + Math.round((stop - start - (domain.length - padding) * step) / 2), step);
      if (reverse) range.reverse();
      rangeBand = Math.round(step * (1 - padding));
      ranger = {
        t: "rangeRoundBands",
        a: arguments
      };
      return scale;
    };
    scale.rangeBand = function() {
      return rangeBand;
    };
    scale.rangeExtent = function() {
      return d3_scaleExtent(ranger.a[0]);
    };
    scale.copy = function() {
      return d3_scale_ordinal(domain, ranger);
    };
    return scale.domain(domain);
  }
  d3.scale.category10 = function() {
    return d3.scale.ordinal().range(d3_category10);
  };
  d3.scale.category20 = function() {
    return d3.scale.ordinal().range(d3_category20);
  };
  d3.scale.category20b = function() {
    return d3.scale.ordinal().range(d3_category20b);
  };
  d3.scale.category20c = function() {
    return d3.scale.ordinal().range(d3_category20c);
  };
  var d3_category10 = [ 2062260, 16744206, 2924588, 14034728, 9725885, 9197131, 14907330, 8355711, 12369186, 1556175 ].map(d3_rgbString);
  var d3_category20 = [ 2062260, 11454440, 16744206, 16759672, 2924588, 10018698, 14034728, 16750742, 9725885, 12955861, 9197131, 12885140, 14907330, 16234194, 8355711, 13092807, 12369186, 14408589, 1556175, 10410725 ].map(d3_rgbString);
  var d3_category20b = [ 3750777, 5395619, 7040719, 10264286, 6519097, 9216594, 11915115, 13556636, 9202993, 12426809, 15186514, 15190932, 8666169, 11356490, 14049643, 15177372, 8077683, 10834324, 13528509, 14589654 ].map(d3_rgbString);
  var d3_category20c = [ 3244733, 7057110, 10406625, 13032431, 15095053, 16616764, 16625259, 16634018, 3253076, 7652470, 10607003, 13101504, 7695281, 10394312, 12369372, 14342891, 6513507, 9868950, 12434877, 14277081 ].map(d3_rgbString);
  d3.scale.quantile = function() {
    return d3_scale_quantile([], []);
  };
  function d3_scale_quantile(domain, range) {
    var thresholds;
    function rescale() {
      var k = 0, q = range.length;
      thresholds = [];
      while (++k < q) thresholds[k - 1] = d3.quantile(domain, k / q);
      return scale;
    }
    function scale(x) {
      if (!isNaN(x = +x)) return range[d3.bisect(thresholds, x)];
    }
    scale.domain = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(d3_number).filter(d3_numeric).sort(d3_ascending);
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.quantiles = function() {
      return thresholds;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return y < 0 ? [ NaN, NaN ] : [ y > 0 ? thresholds[y - 1] : domain[0], y < thresholds.length ? thresholds[y] : domain[domain.length - 1] ];
    };
    scale.copy = function() {
      return d3_scale_quantile(domain, range);
    };
    return rescale();
  }
  d3.scale.quantize = function() {
    return d3_scale_quantize(0, 1, [ 0, 1 ]);
  };
  function d3_scale_quantize(x0, x1, range) {
    var kx, i;
    function scale(x) {
      return range[Math.max(0, Math.min(i, Math.floor(kx * (x - x0))))];
    }
    function rescale() {
      kx = range.length / (x1 - x0);
      i = range.length - 1;
      return scale;
    }
    scale.domain = function(x) {
      if (!arguments.length) return [ x0, x1 ];
      x0 = +x[0];
      x1 = +x[x.length - 1];
      return rescale();
    };
    scale.range = function(x) {
      if (!arguments.length) return range;
      range = x;
      return rescale();
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      y = y < 0 ? NaN : y / kx + x0;
      return [ y, y + 1 / kx ];
    };
    scale.copy = function() {
      return d3_scale_quantize(x0, x1, range);
    };
    return rescale();
  }
  d3.scale.threshold = function() {
    return d3_scale_threshold([ .5 ], [ 0, 1 ]);
  };
  function d3_scale_threshold(domain, range) {
    function scale(x) {
      if (x <= x) return range[d3.bisect(domain, x)];
    }
    scale.domain = function(_) {
      if (!arguments.length) return domain;
      domain = _;
      return scale;
    };
    scale.range = function(_) {
      if (!arguments.length) return range;
      range = _;
      return scale;
    };
    scale.invertExtent = function(y) {
      y = range.indexOf(y);
      return [ domain[y - 1], domain[y] ];
    };
    scale.copy = function() {
      return d3_scale_threshold(domain, range);
    };
    return scale;
  }
  d3.scale.identity = function() {
    return d3_scale_identity([ 0, 1 ]);
  };
  function d3_scale_identity(domain) {
    function identity(x) {
      return +x;
    }
    identity.invert = identity;
    identity.domain = identity.range = function(x) {
      if (!arguments.length) return domain;
      domain = x.map(identity);
      return identity;
    };
    identity.ticks = function(m) {
      return d3_scale_linearTicks(domain, m);
    };
    identity.tickFormat = function(m, format) {
      return d3_scale_linearTickFormat(domain, m, format);
    };
    identity.copy = function() {
      return d3_scale_identity(domain);
    };
    return identity;
  }
  d3.svg = {};
  function d3_zero() {
    return 0;
  }
  d3.svg.arc = function() {
    var innerRadius = d3_svg_arcInnerRadius, outerRadius = d3_svg_arcOuterRadius, cornerRadius = d3_zero, padRadius = d3_svg_arcAuto, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle, padAngle = d3_svg_arcPadAngle;
    function arc() {
      var r0 = Math.max(0, +innerRadius.apply(this, arguments)), r1 = Math.max(0, +outerRadius.apply(this, arguments)), a0 = startAngle.apply(this, arguments) - halfπ, a1 = endAngle.apply(this, arguments) - halfπ, da = Math.abs(a1 - a0), cw = a0 > a1 ? 0 : 1;
      if (r1 < r0) rc = r1, r1 = r0, r0 = rc;
      if (da >= τε) return circleSegment(r1, cw) + (r0 ? circleSegment(r0, 1 - cw) : "") + "Z";
      var rc, cr, rp, ap, p0 = 0, p1 = 0, x0, y0, x1, y1, x2, y2, x3, y3, path = [];
      if (ap = (+padAngle.apply(this, arguments) || 0) / 2) {
        rp = padRadius === d3_svg_arcAuto ? Math.sqrt(r0 * r0 + r1 * r1) : +padRadius.apply(this, arguments);
        if (!cw) p1 *= -1;
        if (r1) p1 = d3_asin(rp / r1 * Math.sin(ap));
        if (r0) p0 = d3_asin(rp / r0 * Math.sin(ap));
      }
      if (r1) {
        x0 = r1 * Math.cos(a0 + p1);
        y0 = r1 * Math.sin(a0 + p1);
        x1 = r1 * Math.cos(a1 - p1);
        y1 = r1 * Math.sin(a1 - p1);
        var l1 = Math.abs(a1 - a0 - 2 * p1) <= π ? 0 : 1;
        if (p1 && d3_svg_arcSweep(x0, y0, x1, y1) === cw ^ l1) {
          var h1 = (a0 + a1) / 2;
          x0 = r1 * Math.cos(h1);
          y0 = r1 * Math.sin(h1);
          x1 = y1 = null;
        }
      } else {
        x0 = y0 = 0;
      }
      if (r0) {
        x2 = r0 * Math.cos(a1 - p0);
        y2 = r0 * Math.sin(a1 - p0);
        x3 = r0 * Math.cos(a0 + p0);
        y3 = r0 * Math.sin(a0 + p0);
        var l0 = Math.abs(a0 - a1 + 2 * p0) <= π ? 0 : 1;
        if (p0 && d3_svg_arcSweep(x2, y2, x3, y3) === 1 - cw ^ l0) {
          var h0 = (a0 + a1) / 2;
          x2 = r0 * Math.cos(h0);
          y2 = r0 * Math.sin(h0);
          x3 = y3 = null;
        }
      } else {
        x2 = y2 = 0;
      }
      if (da > ε && (rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments))) > .001) {
        cr = r0 < r1 ^ cw ? 0 : 1;
        var rc1 = rc, rc0 = rc;
        if (da < π) {
          var oc = x3 == null ? [ x2, y2 ] : x1 == null ? [ x0, y0 ] : d3_geom_polygonIntersect([ x0, y0 ], [ x3, y3 ], [ x1, y1 ], [ x2, y2 ]), ax = x0 - oc[0], ay = y0 - oc[1], bx = x1 - oc[0], by = y1 - oc[1], kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2), lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
        }
        if (x1 != null) {
          var t30 = d3_svg_arcCornerTangents(x3 == null ? [ x2, y2 ] : [ x3, y3 ], [ x0, y0 ], r1, rc1, cw), t12 = d3_svg_arcCornerTangents([ x1, y1 ], [ x2, y2 ], r1, rc1, cw);
          if (rc === rc1) {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 0,", cr, " ", t30[1], "A", r1, ",", r1, " 0 ", 1 - cw ^ d3_svg_arcSweep(t30[1][0], t30[1][1], t12[1][0], t12[1][1]), ",", cw, " ", t12[1], "A", rc1, ",", rc1, " 0 0,", cr, " ", t12[0]);
          } else {
            path.push("M", t30[0], "A", rc1, ",", rc1, " 0 1,", cr, " ", t12[0]);
          }
        } else {
          path.push("M", x0, ",", y0);
        }
        if (x3 != null) {
          var t03 = d3_svg_arcCornerTangents([ x0, y0 ], [ x3, y3 ], r0, -rc0, cw), t21 = d3_svg_arcCornerTangents([ x2, y2 ], x1 == null ? [ x0, y0 ] : [ x1, y1 ], r0, -rc0, cw);
          if (rc === rc0) {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t21[1], "A", r0, ",", r0, " 0 ", cw ^ d3_svg_arcSweep(t21[1][0], t21[1][1], t03[1][0], t03[1][1]), ",", 1 - cw, " ", t03[1], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          } else {
            path.push("L", t21[0], "A", rc0, ",", rc0, " 0 0,", cr, " ", t03[0]);
          }
        } else {
          path.push("L", x2, ",", y2);
        }
      } else {
        path.push("M", x0, ",", y0);
        if (x1 != null) path.push("A", r1, ",", r1, " 0 ", l1, ",", cw, " ", x1, ",", y1);
        path.push("L", x2, ",", y2);
        if (x3 != null) path.push("A", r0, ",", r0, " 0 ", l0, ",", 1 - cw, " ", x3, ",", y3);
      }
      path.push("Z");
      return path.join("");
    }
    function circleSegment(r1, cw) {
      return "M0," + r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + -r1 + "A" + r1 + "," + r1 + " 0 1," + cw + " 0," + r1;
    }
    arc.innerRadius = function(v) {
      if (!arguments.length) return innerRadius;
      innerRadius = d3_functor(v);
      return arc;
    };
    arc.outerRadius = function(v) {
      if (!arguments.length) return outerRadius;
      outerRadius = d3_functor(v);
      return arc;
    };
    arc.cornerRadius = function(v) {
      if (!arguments.length) return cornerRadius;
      cornerRadius = d3_functor(v);
      return arc;
    };
    arc.padRadius = function(v) {
      if (!arguments.length) return padRadius;
      padRadius = v == d3_svg_arcAuto ? d3_svg_arcAuto : d3_functor(v);
      return arc;
    };
    arc.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return arc;
    };
    arc.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return arc;
    };
    arc.padAngle = function(v) {
      if (!arguments.length) return padAngle;
      padAngle = d3_functor(v);
      return arc;
    };
    arc.centroid = function() {
      var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - halfπ;
      return [ Math.cos(a) * r, Math.sin(a) * r ];
    };
    return arc;
  };
  var d3_svg_arcAuto = "auto";
  function d3_svg_arcInnerRadius(d) {
    return d.innerRadius;
  }
  function d3_svg_arcOuterRadius(d) {
    return d.outerRadius;
  }
  function d3_svg_arcStartAngle(d) {
    return d.startAngle;
  }
  function d3_svg_arcEndAngle(d) {
    return d.endAngle;
  }
  function d3_svg_arcPadAngle(d) {
    return d && d.padAngle;
  }
  function d3_svg_arcSweep(x0, y0, x1, y1) {
    return (x0 - x1) * y0 - (y0 - y1) * x0 > 0 ? 0 : 1;
  }
  function d3_svg_arcCornerTangents(p0, p1, r1, rc, cw) {
    var x01 = p0[0] - p1[0], y01 = p0[1] - p1[1], lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x1 = p0[0] + ox, y1 = p0[1] + oy, x2 = p1[0] + ox, y2 = p1[1] + oy, x3 = (x1 + x2) / 2, y3 = (y1 + y2) / 2, dx = x2 - x1, dy = y2 - y1, d2 = dx * dx + dy * dy, r = r1 - rc, D = x1 * y2 - x2 * y1, d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x3, dy0 = cy0 - y3, dx1 = cx1 - x3, dy1 = cy1 - y3;
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return [ [ cx0 - ox, cy0 - oy ], [ cx0 * r1 / r, cy0 * r1 / r ] ];
  }
  function d3_svg_line(projection) {
    var x = d3_geom_pointX, y = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, tension = .7;
    function line(data) {
      var segments = [], points = [], i = -1, n = data.length, d, fx = d3_functor(x), fy = d3_functor(y);
      function segment() {
        segments.push("M", interpolate(projection(points), tension));
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points.push([ +fx.call(this, d, i), +fy.call(this, d, i) ]);
        } else if (points.length) {
          segment();
          points = [];
        }
      }
      if (points.length) segment();
      return segments.length ? segments.join("") : null;
    }
    line.x = function(_) {
      if (!arguments.length) return x;
      x = _;
      return line;
    };
    line.y = function(_) {
      if (!arguments.length) return y;
      y = _;
      return line;
    };
    line.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return line;
    };
    line.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      return line;
    };
    line.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return line;
    };
    return line;
  }
  d3.svg.line = function() {
    return d3_svg_line(d3_identity);
  };
  var d3_svg_lineInterpolators = d3.map({
    linear: d3_svg_lineLinear,
    "linear-closed": d3_svg_lineLinearClosed,
    step: d3_svg_lineStep,
    "step-before": d3_svg_lineStepBefore,
    "step-after": d3_svg_lineStepAfter,
    basis: d3_svg_lineBasis,
    "basis-open": d3_svg_lineBasisOpen,
    "basis-closed": d3_svg_lineBasisClosed,
    bundle: d3_svg_lineBundle,
    cardinal: d3_svg_lineCardinal,
    "cardinal-open": d3_svg_lineCardinalOpen,
    "cardinal-closed": d3_svg_lineCardinalClosed,
    monotone: d3_svg_lineMonotone
  });
  d3_svg_lineInterpolators.forEach(function(key, value) {
    value.key = key;
    value.closed = /-closed$/.test(key);
  });
  function d3_svg_lineLinear(points) {
    return points.length > 1 ? points.join("L") : points + "Z";
  }
  function d3_svg_lineLinearClosed(points) {
    return points.join("L") + "Z";
  }
  function d3_svg_lineStep(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p[0] + (p = points[i])[0]) / 2, "V", p[1]);
    if (n > 1) path.push("H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepBefore(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("V", (p = points[i])[1], "H", p[0]);
    return path.join("");
  }
  function d3_svg_lineStepAfter(points) {
    var i = 0, n = points.length, p = points[0], path = [ p[0], ",", p[1] ];
    while (++i < n) path.push("H", (p = points[i])[0], "V", p[1]);
    return path.join("");
  }
  function d3_svg_lineCardinalOpen(points, tension) {
    return points.length < 4 ? d3_svg_lineLinear(points) : points[1] + d3_svg_lineHermite(points.slice(1, -1), d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineCardinalClosed(points, tension) {
    return points.length < 3 ? d3_svg_lineLinearClosed(points) : points[0] + d3_svg_lineHermite((points.push(points[0]), 
    points), d3_svg_lineCardinalTangents([ points[points.length - 2] ].concat(points, [ points[1] ]), tension));
  }
  function d3_svg_lineCardinal(points, tension) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineCardinalTangents(points, tension));
  }
  function d3_svg_lineHermite(points, tangents) {
    if (tangents.length < 1 || points.length != tangents.length && points.length != tangents.length + 2) {
      return d3_svg_lineLinear(points);
    }
    var quad = points.length != tangents.length, path = "", p0 = points[0], p = points[1], t0 = tangents[0], t = t0, pi = 1;
    if (quad) {
      path += "Q" + (p[0] - t0[0] * 2 / 3) + "," + (p[1] - t0[1] * 2 / 3) + "," + p[0] + "," + p[1];
      p0 = points[1];
      pi = 2;
    }
    if (tangents.length > 1) {
      t = tangents[1];
      p = points[pi];
      pi++;
      path += "C" + (p0[0] + t0[0]) + "," + (p0[1] + t0[1]) + "," + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      for (var i = 2; i < tangents.length; i++, pi++) {
        p = points[pi];
        t = tangents[i];
        path += "S" + (p[0] - t[0]) + "," + (p[1] - t[1]) + "," + p[0] + "," + p[1];
      }
    }
    if (quad) {
      var lp = points[pi];
      path += "Q" + (p[0] + t[0] * 2 / 3) + "," + (p[1] + t[1] * 2 / 3) + "," + lp[0] + "," + lp[1];
    }
    return path;
  }
  function d3_svg_lineCardinalTangents(points, tension) {
    var tangents = [], a = (1 - tension) / 2, p0, p1 = points[0], p2 = points[1], i = 1, n = points.length;
    while (++i < n) {
      p0 = p1;
      p1 = p2;
      p2 = points[i];
      tangents.push([ a * (p2[0] - p0[0]), a * (p2[1] - p0[1]) ]);
    }
    return tangents;
  }
  function d3_svg_lineBasis(points) {
    if (points.length < 3) return d3_svg_lineLinear(points);
    var i = 1, n = points.length, pi = points[0], x0 = pi[0], y0 = pi[1], px = [ x0, x0, x0, (pi = points[1])[0] ], py = [ y0, y0, y0, pi[1] ], path = [ x0, ",", y0, "L", d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    points.push(points[n - 1]);
    while (++i <= n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    points.pop();
    path.push("L", pi);
    return path.join("");
  }
  function d3_svg_lineBasisOpen(points) {
    if (points.length < 4) return d3_svg_lineLinear(points);
    var path = [], i = -1, n = points.length, pi, px = [ 0 ], py = [ 0 ];
    while (++i < 3) {
      pi = points[i];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path.push(d3_svg_lineDot4(d3_svg_lineBasisBezier3, px) + "," + d3_svg_lineDot4(d3_svg_lineBasisBezier3, py));
    --i;
    while (++i < n) {
      pi = points[i];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBasisClosed(points) {
    var path, i = -1, n = points.length, m = n + 4, pi, px = [], py = [];
    while (++i < 4) {
      pi = points[i % n];
      px.push(pi[0]);
      py.push(pi[1]);
    }
    path = [ d3_svg_lineDot4(d3_svg_lineBasisBezier3, px), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, py) ];
    --i;
    while (++i < m) {
      pi = points[i % n];
      px.shift();
      px.push(pi[0]);
      py.shift();
      py.push(pi[1]);
      d3_svg_lineBasisBezier(path, px, py);
    }
    return path.join("");
  }
  function d3_svg_lineBundle(points, tension) {
    var n = points.length - 1;
    if (n) {
      var x0 = points[0][0], y0 = points[0][1], dx = points[n][0] - x0, dy = points[n][1] - y0, i = -1, p, t;
      while (++i <= n) {
        p = points[i];
        t = i / n;
        p[0] = tension * p[0] + (1 - tension) * (x0 + t * dx);
        p[1] = tension * p[1] + (1 - tension) * (y0 + t * dy);
      }
    }
    return d3_svg_lineBasis(points);
  }
  function d3_svg_lineDot4(a, b) {
    return a[0] * b[0] + a[1] * b[1] + a[2] * b[2] + a[3] * b[3];
  }
  var d3_svg_lineBasisBezier1 = [ 0, 2 / 3, 1 / 3, 0 ], d3_svg_lineBasisBezier2 = [ 0, 1 / 3, 2 / 3, 0 ], d3_svg_lineBasisBezier3 = [ 0, 1 / 6, 2 / 3, 1 / 6 ];
  function d3_svg_lineBasisBezier(path, x, y) {
    path.push("C", d3_svg_lineDot4(d3_svg_lineBasisBezier1, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier1, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier2, y), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, x), ",", d3_svg_lineDot4(d3_svg_lineBasisBezier3, y));
  }
  function d3_svg_lineSlope(p0, p1) {
    return (p1[1] - p0[1]) / (p1[0] - p0[0]);
  }
  function d3_svg_lineFiniteDifferences(points) {
    var i = 0, j = points.length - 1, m = [], p0 = points[0], p1 = points[1], d = m[0] = d3_svg_lineSlope(p0, p1);
    while (++i < j) {
      m[i] = (d + (d = d3_svg_lineSlope(p0 = p1, p1 = points[i + 1]))) / 2;
    }
    m[i] = d;
    return m;
  }
  function d3_svg_lineMonotoneTangents(points) {
    var tangents = [], d, a, b, s, m = d3_svg_lineFiniteDifferences(points), i = -1, j = points.length - 1;
    while (++i < j) {
      d = d3_svg_lineSlope(points[i], points[i + 1]);
      if (abs(d) < ε) {
        m[i] = m[i + 1] = 0;
      } else {
        a = m[i] / d;
        b = m[i + 1] / d;
        s = a * a + b * b;
        if (s > 9) {
          s = d * 3 / Math.sqrt(s);
          m[i] = s * a;
          m[i + 1] = s * b;
        }
      }
    }
    i = -1;
    while (++i <= j) {
      s = (points[Math.min(j, i + 1)][0] - points[Math.max(0, i - 1)][0]) / (6 * (1 + m[i] * m[i]));
      tangents.push([ s || 0, m[i] * s || 0 ]);
    }
    return tangents;
  }
  function d3_svg_lineMonotone(points) {
    return points.length < 3 ? d3_svg_lineLinear(points) : points[0] + d3_svg_lineHermite(points, d3_svg_lineMonotoneTangents(points));
  }
  d3.svg.line.radial = function() {
    var line = d3_svg_line(d3_svg_lineRadial);
    line.radius = line.x, delete line.x;
    line.angle = line.y, delete line.y;
    return line;
  };
  function d3_svg_lineRadial(points) {
    var point, i = -1, n = points.length, r, a;
    while (++i < n) {
      point = points[i];
      r = point[0];
      a = point[1] - halfπ;
      point[0] = r * Math.cos(a);
      point[1] = r * Math.sin(a);
    }
    return points;
  }
  function d3_svg_area(projection) {
    var x0 = d3_geom_pointX, x1 = d3_geom_pointX, y0 = 0, y1 = d3_geom_pointY, defined = d3_true, interpolate = d3_svg_lineLinear, interpolateKey = interpolate.key, interpolateReverse = interpolate, L = "L", tension = .7;
    function area(data) {
      var segments = [], points0 = [], points1 = [], i = -1, n = data.length, d, fx0 = d3_functor(x0), fy0 = d3_functor(y0), fx1 = x0 === x1 ? function() {
        return x;
      } : d3_functor(x1), fy1 = y0 === y1 ? function() {
        return y;
      } : d3_functor(y1), x, y;
      function segment() {
        segments.push("M", interpolate(projection(points1), tension), L, interpolateReverse(projection(points0.reverse()), tension), "Z");
      }
      while (++i < n) {
        if (defined.call(this, d = data[i], i)) {
          points0.push([ x = +fx0.call(this, d, i), y = +fy0.call(this, d, i) ]);
          points1.push([ +fx1.call(this, d, i), +fy1.call(this, d, i) ]);
        } else if (points0.length) {
          segment();
          points0 = [];
          points1 = [];
        }
      }
      if (points0.length) segment();
      return segments.length ? segments.join("") : null;
    }
    area.x = function(_) {
      if (!arguments.length) return x1;
      x0 = x1 = _;
      return area;
    };
    area.x0 = function(_) {
      if (!arguments.length) return x0;
      x0 = _;
      return area;
    };
    area.x1 = function(_) {
      if (!arguments.length) return x1;
      x1 = _;
      return area;
    };
    area.y = function(_) {
      if (!arguments.length) return y1;
      y0 = y1 = _;
      return area;
    };
    area.y0 = function(_) {
      if (!arguments.length) return y0;
      y0 = _;
      return area;
    };
    area.y1 = function(_) {
      if (!arguments.length) return y1;
      y1 = _;
      return area;
    };
    area.defined = function(_) {
      if (!arguments.length) return defined;
      defined = _;
      return area;
    };
    area.interpolate = function(_) {
      if (!arguments.length) return interpolateKey;
      if (typeof _ === "function") interpolateKey = interpolate = _; else interpolateKey = (interpolate = d3_svg_lineInterpolators.get(_) || d3_svg_lineLinear).key;
      interpolateReverse = interpolate.reverse || interpolate;
      L = interpolate.closed ? "M" : "L";
      return area;
    };
    area.tension = function(_) {
      if (!arguments.length) return tension;
      tension = _;
      return area;
    };
    return area;
  }
  d3_svg_lineStepBefore.reverse = d3_svg_lineStepAfter;
  d3_svg_lineStepAfter.reverse = d3_svg_lineStepBefore;
  d3.svg.area = function() {
    return d3_svg_area(d3_identity);
  };
  d3.svg.area.radial = function() {
    var area = d3_svg_area(d3_svg_lineRadial);
    area.radius = area.x, delete area.x;
    area.innerRadius = area.x0, delete area.x0;
    area.outerRadius = area.x1, delete area.x1;
    area.angle = area.y, delete area.y;
    area.startAngle = area.y0, delete area.y0;
    area.endAngle = area.y1, delete area.y1;
    return area;
  };
  d3.svg.chord = function() {
    var source = d3_source, target = d3_target, radius = d3_svg_chordRadius, startAngle = d3_svg_arcStartAngle, endAngle = d3_svg_arcEndAngle;
    function chord(d, i) {
      var s = subgroup(this, source, d, i), t = subgroup(this, target, d, i);
      return "M" + s.p0 + arc(s.r, s.p1, s.a1 - s.a0) + (equals(s, t) ? curve(s.r, s.p1, s.r, s.p0) : curve(s.r, s.p1, t.r, t.p0) + arc(t.r, t.p1, t.a1 - t.a0) + curve(t.r, t.p1, s.r, s.p0)) + "Z";
    }
    function subgroup(self, f, d, i) {
      var subgroup = f.call(self, d, i), r = radius.call(self, subgroup, i), a0 = startAngle.call(self, subgroup, i) - halfπ, a1 = endAngle.call(self, subgroup, i) - halfπ;
      return {
        r: r,
        a0: a0,
        a1: a1,
        p0: [ r * Math.cos(a0), r * Math.sin(a0) ],
        p1: [ r * Math.cos(a1), r * Math.sin(a1) ]
      };
    }
    function equals(a, b) {
      return a.a0 == b.a0 && a.a1 == b.a1;
    }
    function arc(r, p, a) {
      return "A" + r + "," + r + " 0 " + +(a > π) + ",1 " + p;
    }
    function curve(r0, p0, r1, p1) {
      return "Q 0,0 " + p1;
    }
    chord.radius = function(v) {
      if (!arguments.length) return radius;
      radius = d3_functor(v);
      return chord;
    };
    chord.source = function(v) {
      if (!arguments.length) return source;
      source = d3_functor(v);
      return chord;
    };
    chord.target = function(v) {
      if (!arguments.length) return target;
      target = d3_functor(v);
      return chord;
    };
    chord.startAngle = function(v) {
      if (!arguments.length) return startAngle;
      startAngle = d3_functor(v);
      return chord;
    };
    chord.endAngle = function(v) {
      if (!arguments.length) return endAngle;
      endAngle = d3_functor(v);
      return chord;
    };
    return chord;
  };
  function d3_svg_chordRadius(d) {
    return d.radius;
  }
  d3.svg.diagonal = function() {
    var source = d3_source, target = d3_target, projection = d3_svg_diagonalProjection;
    function diagonal(d, i) {
      var p0 = source.call(this, d, i), p3 = target.call(this, d, i), m = (p0.y + p3.y) / 2, p = [ p0, {
        x: p0.x,
        y: m
      }, {
        x: p3.x,
        y: m
      }, p3 ];
      p = p.map(projection);
      return "M" + p[0] + "C" + p[1] + " " + p[2] + " " + p[3];
    }
    diagonal.source = function(x) {
      if (!arguments.length) return source;
      source = d3_functor(x);
      return diagonal;
    };
    diagonal.target = function(x) {
      if (!arguments.length) return target;
      target = d3_functor(x);
      return diagonal;
    };
    diagonal.projection = function(x) {
      if (!arguments.length) return projection;
      projection = x;
      return diagonal;
    };
    return diagonal;
  };
  function d3_svg_diagonalProjection(d) {
    return [ d.x, d.y ];
  }
  d3.svg.diagonal.radial = function() {
    var diagonal = d3.svg.diagonal(), projection = d3_svg_diagonalProjection, projection_ = diagonal.projection;
    diagonal.projection = function(x) {
      return arguments.length ? projection_(d3_svg_diagonalRadialProjection(projection = x)) : projection;
    };
    return diagonal;
  };
  function d3_svg_diagonalRadialProjection(projection) {
    return function() {
      var d = projection.apply(this, arguments), r = d[0], a = d[1] - halfπ;
      return [ r * Math.cos(a), r * Math.sin(a) ];
    };
  }
  d3.svg.symbol = function() {
    var type = d3_svg_symbolType, size = d3_svg_symbolSize;
    function symbol(d, i) {
      return (d3_svg_symbols.get(type.call(this, d, i)) || d3_svg_symbolCircle)(size.call(this, d, i));
    }
    symbol.type = function(x) {
      if (!arguments.length) return type;
      type = d3_functor(x);
      return symbol;
    };
    symbol.size = function(x) {
      if (!arguments.length) return size;
      size = d3_functor(x);
      return symbol;
    };
    return symbol;
  };
  function d3_svg_symbolSize() {
    return 64;
  }
  function d3_svg_symbolType() {
    return "circle";
  }
  function d3_svg_symbolCircle(size) {
    var r = Math.sqrt(size / π);
    return "M0," + r + "A" + r + "," + r + " 0 1,1 0," + -r + "A" + r + "," + r + " 0 1,1 0," + r + "Z";
  }
  var d3_svg_symbols = d3.map({
    circle: d3_svg_symbolCircle,
    cross: function(size) {
      var r = Math.sqrt(size / 5) / 2;
      return "M" + -3 * r + "," + -r + "H" + -r + "V" + -3 * r + "H" + r + "V" + -r + "H" + 3 * r + "V" + r + "H" + r + "V" + 3 * r + "H" + -r + "V" + r + "H" + -3 * r + "Z";
    },
    diamond: function(size) {
      var ry = Math.sqrt(size / (2 * d3_svg_symbolTan30)), rx = ry * d3_svg_symbolTan30;
      return "M0," + -ry + "L" + rx + ",0" + " 0," + ry + " " + -rx + ",0" + "Z";
    },
    square: function(size) {
      var r = Math.sqrt(size) / 2;
      return "M" + -r + "," + -r + "L" + r + "," + -r + " " + r + "," + r + " " + -r + "," + r + "Z";
    },
    "triangle-down": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + ry + "L" + rx + "," + -ry + " " + -rx + "," + -ry + "Z";
    },
    "triangle-up": function(size) {
      var rx = Math.sqrt(size / d3_svg_symbolSqrt3), ry = rx * d3_svg_symbolSqrt3 / 2;
      return "M0," + -ry + "L" + rx + "," + ry + " " + -rx + "," + ry + "Z";
    }
  });
  d3.svg.symbolTypes = d3_svg_symbols.keys();
  var d3_svg_symbolSqrt3 = Math.sqrt(3), d3_svg_symbolTan30 = Math.tan(30 * d3_radians);
  d3_selectionPrototype.transition = function(name) {
    var id = d3_transitionInheritId || ++d3_transitionId, ns = d3_transitionNamespace(name), subgroups = [], subgroup, node, transition = d3_transitionInherit || {
      time: Date.now(),
      ease: d3_ease_cubicInOut,
      delay: 0,
      duration: 250
    };
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) d3_transitionNode(node, i, ns, id, transition);
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_selectionPrototype.interrupt = function(name) {
    return this.each(name == null ? d3_selection_interrupt : d3_selection_interruptNS(d3_transitionNamespace(name)));
  };
  var d3_selection_interrupt = d3_selection_interruptNS(d3_transitionNamespace());
  function d3_selection_interruptNS(ns) {
    return function() {
      var lock, activeId, active;
      if ((lock = this[ns]) && (active = lock[activeId = lock.active])) {
        active.timer.c = null;
        active.timer.t = NaN;
        if (--lock.count) delete lock[activeId]; else delete this[ns];
        lock.active += .5;
        active.event && active.event.interrupt.call(this, this.__data__, active.index);
      }
    };
  }
  function d3_transition(groups, ns, id) {
    d3_subclass(groups, d3_transitionPrototype);
    groups.namespace = ns;
    groups.id = id;
    return groups;
  }
  var d3_transitionPrototype = [], d3_transitionId = 0, d3_transitionInheritId, d3_transitionInherit;
  d3_transitionPrototype.call = d3_selectionPrototype.call;
  d3_transitionPrototype.empty = d3_selectionPrototype.empty;
  d3_transitionPrototype.node = d3_selectionPrototype.node;
  d3_transitionPrototype.size = d3_selectionPrototype.size;
  d3.transition = function(selection, name) {
    return selection && selection.transition ? d3_transitionInheritId ? selection.transition(name) : selection : d3.selection().transition(selection);
  };
  d3.transition.prototype = d3_transitionPrototype;
  d3_transitionPrototype.select = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnode, node;
    selector = d3_selection_selector(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if ((node = group[i]) && (subnode = selector.call(node, node.__data__, i, j))) {
          if ("__data__" in node) subnode.__data__ = node.__data__;
          d3_transitionNode(subnode, i, ns, id, node[ns][id]);
          subgroup.push(subnode);
        } else {
          subgroup.push(null);
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.selectAll = function(selector) {
    var id = this.id, ns = this.namespace, subgroups = [], subgroup, subnodes, node, subnode, transition;
    selector = d3_selection_selectorAll(selector);
    for (var j = -1, m = this.length; ++j < m; ) {
      for (var group = this[j], i = -1, n = group.length; ++i < n; ) {
        if (node = group[i]) {
          transition = node[ns][id];
          subnodes = selector.call(node, node.__data__, i, j);
          subgroups.push(subgroup = []);
          for (var k = -1, o = subnodes.length; ++k < o; ) {
            if (subnode = subnodes[k]) d3_transitionNode(subnode, k, ns, id, transition);
            subgroup.push(subnode);
          }
        }
      }
    }
    return d3_transition(subgroups, ns, id);
  };
  d3_transitionPrototype.filter = function(filter) {
    var subgroups = [], subgroup, group, node;
    if (typeof filter !== "function") filter = d3_selection_filter(filter);
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if ((node = group[i]) && filter.call(node, node.__data__, i, j)) {
          subgroup.push(node);
        }
      }
    }
    return d3_transition(subgroups, this.namespace, this.id);
  };
  d3_transitionPrototype.tween = function(name, tween) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) return this.node()[ns][id].tween.get(name);
    return d3_selection_each(this, tween == null ? function(node) {
      node[ns][id].tween.remove(name);
    } : function(node) {
      node[ns][id].tween.set(name, tween);
    });
  };
  function d3_transition_tween(groups, name, value, tween) {
    var id = groups.id, ns = groups.namespace;
    return d3_selection_each(groups, typeof value === "function" ? function(node, i, j) {
      node[ns][id].tween.set(name, tween(value.call(node, node.__data__, i, j)));
    } : (value = tween(value), function(node) {
      node[ns][id].tween.set(name, value);
    }));
  }
  d3_transitionPrototype.attr = function(nameNS, value) {
    if (arguments.length < 2) {
      for (value in nameNS) this.attr(value, nameNS[value]);
      return this;
    }
    var interpolate = nameNS == "transform" ? d3_interpolateTransform : d3_interpolate, name = d3.ns.qualify(nameNS);
    function attrNull() {
      this.removeAttribute(name);
    }
    function attrNullNS() {
      this.removeAttributeNS(name.space, name.local);
    }
    function attrTween(b) {
      return b == null ? attrNull : (b += "", function() {
        var a = this.getAttribute(name), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttribute(name, i(t));
        });
      });
    }
    function attrTweenNS(b) {
      return b == null ? attrNullNS : (b += "", function() {
        var a = this.getAttributeNS(name.space, name.local), i;
        return a !== b && (i = interpolate(a, b), function(t) {
          this.setAttributeNS(name.space, name.local, i(t));
        });
      });
    }
    return d3_transition_tween(this, "attr." + nameNS, value, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.attrTween = function(nameNS, tween) {
    var name = d3.ns.qualify(nameNS);
    function attrTween(d, i) {
      var f = tween.call(this, d, i, this.getAttribute(name));
      return f && function(t) {
        this.setAttribute(name, f(t));
      };
    }
    function attrTweenNS(d, i) {
      var f = tween.call(this, d, i, this.getAttributeNS(name.space, name.local));
      return f && function(t) {
        this.setAttributeNS(name.space, name.local, f(t));
      };
    }
    return this.tween("attr." + nameNS, name.local ? attrTweenNS : attrTween);
  };
  d3_transitionPrototype.style = function(name, value, priority) {
    var n = arguments.length;
    if (n < 3) {
      if (typeof name !== "string") {
        if (n < 2) value = "";
        for (priority in name) this.style(priority, name[priority], value);
        return this;
      }
      priority = "";
    }
    function styleNull() {
      this.style.removeProperty(name);
    }
    function styleString(b) {
      return b == null ? styleNull : (b += "", function() {
        var a = d3_window(this).getComputedStyle(this, null).getPropertyValue(name), i;
        return a !== b && (i = d3_interpolate(a, b), function(t) {
          this.style.setProperty(name, i(t), priority);
        });
      });
    }
    return d3_transition_tween(this, "style." + name, value, styleString);
  };
  d3_transitionPrototype.styleTween = function(name, tween, priority) {
    if (arguments.length < 3) priority = "";
    function styleTween(d, i) {
      var f = tween.call(this, d, i, d3_window(this).getComputedStyle(this, null).getPropertyValue(name));
      return f && function(t) {
        this.style.setProperty(name, f(t), priority);
      };
    }
    return this.tween("style." + name, styleTween);
  };
  d3_transitionPrototype.text = function(value) {
    return d3_transition_tween(this, "text", value, d3_transition_text);
  };
  function d3_transition_text(b) {
    if (b == null) b = "";
    return function() {
      this.textContent = b;
    };
  }
  d3_transitionPrototype.remove = function() {
    var ns = this.namespace;
    return this.each("end.transition", function() {
      var p;
      if (this[ns].count < 2 && (p = this.parentNode)) p.removeChild(this);
    });
  };
  d3_transitionPrototype.ease = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].ease;
    if (typeof value !== "function") value = d3.ease.apply(d3, arguments);
    return d3_selection_each(this, function(node) {
      node[ns][id].ease = value;
    });
  };
  d3_transitionPrototype.delay = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].delay;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].delay = +value.call(node, node.__data__, i, j);
    } : (value = +value, function(node) {
      node[ns][id].delay = value;
    }));
  };
  d3_transitionPrototype.duration = function(value) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 1) return this.node()[ns][id].duration;
    return d3_selection_each(this, typeof value === "function" ? function(node, i, j) {
      node[ns][id].duration = Math.max(1, value.call(node, node.__data__, i, j));
    } : (value = Math.max(1, value), function(node) {
      node[ns][id].duration = value;
    }));
  };
  d3_transitionPrototype.each = function(type, listener) {
    var id = this.id, ns = this.namespace;
    if (arguments.length < 2) {
      var inherit = d3_transitionInherit, inheritId = d3_transitionInheritId;
      try {
        d3_transitionInheritId = id;
        d3_selection_each(this, function(node, i, j) {
          d3_transitionInherit = node[ns][id];
          type.call(node, node.__data__, i, j);
        });
      } finally {
        d3_transitionInherit = inherit;
        d3_transitionInheritId = inheritId;
      }
    } else {
      d3_selection_each(this, function(node) {
        var transition = node[ns][id];
        (transition.event || (transition.event = d3.dispatch("start", "end", "interrupt"))).on(type, listener);
      });
    }
    return this;
  };
  d3_transitionPrototype.transition = function() {
    var id0 = this.id, id1 = ++d3_transitionId, ns = this.namespace, subgroups = [], subgroup, group, node, transition;
    for (var j = 0, m = this.length; j < m; j++) {
      subgroups.push(subgroup = []);
      for (var group = this[j], i = 0, n = group.length; i < n; i++) {
        if (node = group[i]) {
          transition = node[ns][id0];
          d3_transitionNode(node, i, ns, id1, {
            time: transition.time,
            ease: transition.ease,
            delay: transition.delay + transition.duration,
            duration: transition.duration
          });
        }
        subgroup.push(node);
      }
    }
    return d3_transition(subgroups, ns, id1);
  };
  function d3_transitionNamespace(name) {
    return name == null ? "__transition__" : "__transition_" + name + "__";
  }
  function d3_transitionNode(node, i, ns, id, inherit) {
    var lock = node[ns] || (node[ns] = {
      active: 0,
      count: 0
    }), transition = lock[id], time, timer, duration, ease, tweens;
    function schedule(elapsed) {
      var delay = transition.delay;
      timer.t = delay + time;
      if (delay <= elapsed) return start(elapsed - delay);
      timer.c = start;
    }
    function start(elapsed) {
      var activeId = lock.active, active = lock[activeId];
      if (active) {
        active.timer.c = null;
        active.timer.t = NaN;
        --lock.count;
        delete lock[activeId];
        active.event && active.event.interrupt.call(node, node.__data__, active.index);
      }
      for (var cancelId in lock) {
        if (+cancelId < id) {
          var cancel = lock[cancelId];
          cancel.timer.c = null;
          cancel.timer.t = NaN;
          --lock.count;
          delete lock[cancelId];
        }
      }
      timer.c = tick;
      d3_timer(function() {
        if (timer.c && tick(elapsed || 1)) {
          timer.c = null;
          timer.t = NaN;
        }
        return 1;
      }, 0, time);
      lock.active = id;
      transition.event && transition.event.start.call(node, node.__data__, i);
      tweens = [];
      transition.tween.forEach(function(key, value) {
        if (value = value.call(node, node.__data__, i)) {
          tweens.push(value);
        }
      });
      ease = transition.ease;
      duration = transition.duration;
    }
    function tick(elapsed) {
      var t = elapsed / duration, e = ease(t), n = tweens.length;
      while (n > 0) {
        tweens[--n].call(node, e);
      }
      if (t >= 1) {
        transition.event && transition.event.end.call(node, node.__data__, i);
        if (--lock.count) delete lock[id]; else delete node[ns];
        return 1;
      }
    }
    if (!transition) {
      time = inherit.time;
      timer = d3_timer(schedule, 0, time);
      transition = lock[id] = {
        tween: new d3_Map(),
        time: time,
        timer: timer,
        delay: inherit.delay,
        duration: inherit.duration,
        ease: inherit.ease,
        index: i
      };
      inherit = null;
      ++lock.count;
    }
  }
  d3.svg.axis = function() {
    var scale = d3.scale.linear(), orient = d3_svg_axisDefaultOrient, innerTickSize = 6, outerTickSize = 6, tickPadding = 3, tickArguments_ = [ 10 ], tickValues = null, tickFormat_;
    function axis(g) {
      g.each(function() {
        var g = d3.select(this);
        var scale0 = this.__chart__ || scale, scale1 = this.__chart__ = scale.copy();
        var ticks = tickValues == null ? scale1.ticks ? scale1.ticks.apply(scale1, tickArguments_) : scale1.domain() : tickValues, tickFormat = tickFormat_ == null ? scale1.tickFormat ? scale1.tickFormat.apply(scale1, tickArguments_) : d3_identity : tickFormat_, tick = g.selectAll(".tick").data(ticks, scale1), tickEnter = tick.enter().insert("g", ".domain").attr("class", "tick").style("opacity", ε), tickExit = d3.transition(tick.exit()).style("opacity", ε).remove(), tickUpdate = d3.transition(tick.order()).style("opacity", 1), tickSpacing = Math.max(innerTickSize, 0) + tickPadding, tickTransform;
        var range = d3_scaleRange(scale1), path = g.selectAll(".domain").data([ 0 ]), pathUpdate = (path.enter().append("path").attr("class", "domain"), 
        d3.transition(path));
        tickEnter.append("line");
        tickEnter.append("text");
        var lineEnter = tickEnter.select("line"), lineUpdate = tickUpdate.select("line"), text = tick.select("text").text(tickFormat), textEnter = tickEnter.select("text"), textUpdate = tickUpdate.select("text"), sign = orient === "top" || orient === "left" ? -1 : 1, x1, x2, y1, y2;
        if (orient === "bottom" || orient === "top") {
          tickTransform = d3_svg_axisX, x1 = "x", y1 = "y", x2 = "x2", y2 = "y2";
          text.attr("dy", sign < 0 ? "0em" : ".71em").style("text-anchor", "middle");
          pathUpdate.attr("d", "M" + range[0] + "," + sign * outerTickSize + "V0H" + range[1] + "V" + sign * outerTickSize);
        } else {
          tickTransform = d3_svg_axisY, x1 = "y", y1 = "x", x2 = "y2", y2 = "x2";
          text.attr("dy", ".32em").style("text-anchor", sign < 0 ? "end" : "start");
          pathUpdate.attr("d", "M" + sign * outerTickSize + "," + range[0] + "H0V" + range[1] + "H" + sign * outerTickSize);
        }
        lineEnter.attr(y2, sign * innerTickSize);
        textEnter.attr(y1, sign * tickSpacing);
        lineUpdate.attr(x2, 0).attr(y2, sign * innerTickSize);
        textUpdate.attr(x1, 0).attr(y1, sign * tickSpacing);
        if (scale1.rangeBand) {
          var x = scale1, dx = x.rangeBand() / 2;
          scale0 = scale1 = function(d) {
            return x(d) + dx;
          };
        } else if (scale0.rangeBand) {
          scale0 = scale1;
        } else {
          tickExit.call(tickTransform, scale1, scale0);
        }
        tickEnter.call(tickTransform, scale0, scale1);
        tickUpdate.call(tickTransform, scale1, scale1);
      });
    }
    axis.scale = function(x) {
      if (!arguments.length) return scale;
      scale = x;
      return axis;
    };
    axis.orient = function(x) {
      if (!arguments.length) return orient;
      orient = x in d3_svg_axisOrients ? x + "" : d3_svg_axisDefaultOrient;
      return axis;
    };
    axis.ticks = function() {
      if (!arguments.length) return tickArguments_;
      tickArguments_ = d3_array(arguments);
      return axis;
    };
    axis.tickValues = function(x) {
      if (!arguments.length) return tickValues;
      tickValues = x;
      return axis;
    };
    axis.tickFormat = function(x) {
      if (!arguments.length) return tickFormat_;
      tickFormat_ = x;
      return axis;
    };
    axis.tickSize = function(x) {
      var n = arguments.length;
      if (!n) return innerTickSize;
      innerTickSize = +x;
      outerTickSize = +arguments[n - 1];
      return axis;
    };
    axis.innerTickSize = function(x) {
      if (!arguments.length) return innerTickSize;
      innerTickSize = +x;
      return axis;
    };
    axis.outerTickSize = function(x) {
      if (!arguments.length) return outerTickSize;
      outerTickSize = +x;
      return axis;
    };
    axis.tickPadding = function(x) {
      if (!arguments.length) return tickPadding;
      tickPadding = +x;
      return axis;
    };
    axis.tickSubdivide = function() {
      return arguments.length && axis;
    };
    return axis;
  };
  var d3_svg_axisDefaultOrient = "bottom", d3_svg_axisOrients = {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  };
  function d3_svg_axisX(selection, x0, x1) {
    selection.attr("transform", function(d) {
      var v0 = x0(d);
      return "translate(" + (isFinite(v0) ? v0 : x1(d)) + ",0)";
    });
  }
  function d3_svg_axisY(selection, y0, y1) {
    selection.attr("transform", function(d) {
      var v0 = y0(d);
      return "translate(0," + (isFinite(v0) ? v0 : y1(d)) + ")";
    });
  }
  d3.svg.brush = function() {
    var event = d3_eventDispatch(brush, "brushstart", "brush", "brushend"), x = null, y = null, xExtent = [ 0, 0 ], yExtent = [ 0, 0 ], xExtentDomain, yExtentDomain, xClamp = true, yClamp = true, resizes = d3_svg_brushResizes[0];
    function brush(g) {
      g.each(function() {
        var g = d3.select(this).style("pointer-events", "all").style("-webkit-tap-highlight-color", "rgba(0,0,0,0)").on("mousedown.brush", brushstart).on("touchstart.brush", brushstart);
        var background = g.selectAll(".background").data([ 0 ]);
        background.enter().append("rect").attr("class", "background").style("visibility", "hidden").style("cursor", "crosshair");
        g.selectAll(".extent").data([ 0 ]).enter().append("rect").attr("class", "extent").style("cursor", "move");
        var resize = g.selectAll(".resize").data(resizes, d3_identity);
        resize.exit().remove();
        resize.enter().append("g").attr("class", function(d) {
          return "resize " + d;
        }).style("cursor", function(d) {
          return d3_svg_brushCursor[d];
        }).append("rect").attr("x", function(d) {
          return /[ew]$/.test(d) ? -3 : null;
        }).attr("y", function(d) {
          return /^[ns]/.test(d) ? -3 : null;
        }).attr("width", 6).attr("height", 6).style("visibility", "hidden");
        resize.style("display", brush.empty() ? "none" : null);
        var gUpdate = d3.transition(g), backgroundUpdate = d3.transition(background), range;
        if (x) {
          range = d3_scaleRange(x);
          backgroundUpdate.attr("x", range[0]).attr("width", range[1] - range[0]);
          redrawX(gUpdate);
        }
        if (y) {
          range = d3_scaleRange(y);
          backgroundUpdate.attr("y", range[0]).attr("height", range[1] - range[0]);
          redrawY(gUpdate);
        }
        redraw(gUpdate);
      });
    }
    brush.event = function(g) {
      g.each(function() {
        var event_ = event.of(this, arguments), extent1 = {
          x: xExtent,
          y: yExtent,
          i: xExtentDomain,
          j: yExtentDomain
        }, extent0 = this.__chart__ || extent1;
        this.__chart__ = extent1;
        if (d3_transitionInheritId) {
          d3.select(this).transition().each("start.brush", function() {
            xExtentDomain = extent0.i;
            yExtentDomain = extent0.j;
            xExtent = extent0.x;
            yExtent = extent0.y;
            event_({
              type: "brushstart"
            });
          }).tween("brush:brush", function() {
            var xi = d3_interpolateArray(xExtent, extent1.x), yi = d3_interpolateArray(yExtent, extent1.y);
            xExtentDomain = yExtentDomain = null;
            return function(t) {
              xExtent = extent1.x = xi(t);
              yExtent = extent1.y = yi(t);
              event_({
                type: "brush",
                mode: "resize"
              });
            };
          }).each("end.brush", function() {
            xExtentDomain = extent1.i;
            yExtentDomain = extent1.j;
            event_({
              type: "brush",
              mode: "resize"
            });
            event_({
              type: "brushend"
            });
          });
        } else {
          event_({
            type: "brushstart"
          });
          event_({
            type: "brush",
            mode: "resize"
          });
          event_({
            type: "brushend"
          });
        }
      });
    };
    function redraw(g) {
      g.selectAll(".resize").attr("transform", function(d) {
        return "translate(" + xExtent[+/e$/.test(d)] + "," + yExtent[+/^s/.test(d)] + ")";
      });
    }
    function redrawX(g) {
      g.select(".extent").attr("x", xExtent[0]);
      g.selectAll(".extent,.n>rect,.s>rect").attr("width", xExtent[1] - xExtent[0]);
    }
    function redrawY(g) {
      g.select(".extent").attr("y", yExtent[0]);
      g.selectAll(".extent,.e>rect,.w>rect").attr("height", yExtent[1] - yExtent[0]);
    }
    function brushstart() {
      var target = this, eventTarget = d3.select(d3.event.target), event_ = event.of(target, arguments), g = d3.select(target), resizing = eventTarget.datum(), resizingX = !/^(n|s)$/.test(resizing) && x, resizingY = !/^(e|w)$/.test(resizing) && y, dragging = eventTarget.classed("extent"), dragRestore = d3_event_dragSuppress(target), center, origin = d3.mouse(target), offset;
      var w = d3.select(d3_window(target)).on("keydown.brush", keydown).on("keyup.brush", keyup);
      if (d3.event.changedTouches) {
        w.on("touchmove.brush", brushmove).on("touchend.brush", brushend);
      } else {
        w.on("mousemove.brush", brushmove).on("mouseup.brush", brushend);
      }
      g.interrupt().selectAll("*").interrupt();
      if (dragging) {
        origin[0] = xExtent[0] - origin[0];
        origin[1] = yExtent[0] - origin[1];
      } else if (resizing) {
        var ex = +/w$/.test(resizing), ey = +/^n/.test(resizing);
        offset = [ xExtent[1 - ex] - origin[0], yExtent[1 - ey] - origin[1] ];
        origin[0] = xExtent[ex];
        origin[1] = yExtent[ey];
      } else if (d3.event.altKey) center = origin.slice();
      g.style("pointer-events", "none").selectAll(".resize").style("display", null);
      d3.select("body").style("cursor", eventTarget.style("cursor"));
      event_({
        type: "brushstart"
      });
      brushmove();
      function keydown() {
        if (d3.event.keyCode == 32) {
          if (!dragging) {
            center = null;
            origin[0] -= xExtent[1];
            origin[1] -= yExtent[1];
            dragging = 2;
          }
          d3_eventPreventDefault();
        }
      }
      function keyup() {
        if (d3.event.keyCode == 32 && dragging == 2) {
          origin[0] += xExtent[1];
          origin[1] += yExtent[1];
          dragging = 0;
          d3_eventPreventDefault();
        }
      }
      function brushmove() {
        var point = d3.mouse(target), moved = false;
        if (offset) {
          point[0] += offset[0];
          point[1] += offset[1];
        }
        if (!dragging) {
          if (d3.event.altKey) {
            if (!center) center = [ (xExtent[0] + xExtent[1]) / 2, (yExtent[0] + yExtent[1]) / 2 ];
            origin[0] = xExtent[+(point[0] < center[0])];
            origin[1] = yExtent[+(point[1] < center[1])];
          } else center = null;
        }
        if (resizingX && move1(point, x, 0)) {
          redrawX(g);
          moved = true;
        }
        if (resizingY && move1(point, y, 1)) {
          redrawY(g);
          moved = true;
        }
        if (moved) {
          redraw(g);
          event_({
            type: "brush",
            mode: dragging ? "move" : "resize"
          });
        }
      }
      function move1(point, scale, i) {
        var range = d3_scaleRange(scale), r0 = range[0], r1 = range[1], position = origin[i], extent = i ? yExtent : xExtent, size = extent[1] - extent[0], min, max;
        if (dragging) {
          r0 -= position;
          r1 -= size + position;
        }
        min = (i ? yClamp : xClamp) ? Math.max(r0, Math.min(r1, point[i])) : point[i];
        if (dragging) {
          max = (min += position) + size;
        } else {
          if (center) position = Math.max(r0, Math.min(r1, 2 * center[i] - min));
          if (position < min) {
            max = min;
            min = position;
          } else {
            max = position;
          }
        }
        if (extent[0] != min || extent[1] != max) {
          if (i) yExtentDomain = null; else xExtentDomain = null;
          extent[0] = min;
          extent[1] = max;
          return true;
        }
      }
      function brushend() {
        brushmove();
        g.style("pointer-events", "all").selectAll(".resize").style("display", brush.empty() ? "none" : null);
        d3.select("body").style("cursor", null);
        w.on("mousemove.brush", null).on("mouseup.brush", null).on("touchmove.brush", null).on("touchend.brush", null).on("keydown.brush", null).on("keyup.brush", null);
        dragRestore();
        event_({
          type: "brushend"
        });
      }
    }
    brush.x = function(z) {
      if (!arguments.length) return x;
      x = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.y = function(z) {
      if (!arguments.length) return y;
      y = z;
      resizes = d3_svg_brushResizes[!x << 1 | !y];
      return brush;
    };
    brush.clamp = function(z) {
      if (!arguments.length) return x && y ? [ xClamp, yClamp ] : x ? xClamp : y ? yClamp : null;
      if (x && y) xClamp = !!z[0], yClamp = !!z[1]; else if (x) xClamp = !!z; else if (y) yClamp = !!z;
      return brush;
    };
    brush.extent = function(z) {
      var x0, x1, y0, y1, t;
      if (!arguments.length) {
        if (x) {
          if (xExtentDomain) {
            x0 = xExtentDomain[0], x1 = xExtentDomain[1];
          } else {
            x0 = xExtent[0], x1 = xExtent[1];
            if (x.invert) x0 = x.invert(x0), x1 = x.invert(x1);
            if (x1 < x0) t = x0, x0 = x1, x1 = t;
          }
        }
        if (y) {
          if (yExtentDomain) {
            y0 = yExtentDomain[0], y1 = yExtentDomain[1];
          } else {
            y0 = yExtent[0], y1 = yExtent[1];
            if (y.invert) y0 = y.invert(y0), y1 = y.invert(y1);
            if (y1 < y0) t = y0, y0 = y1, y1 = t;
          }
        }
        return x && y ? [ [ x0, y0 ], [ x1, y1 ] ] : x ? [ x0, x1 ] : y && [ y0, y1 ];
      }
      if (x) {
        x0 = z[0], x1 = z[1];
        if (y) x0 = x0[0], x1 = x1[0];
        xExtentDomain = [ x0, x1 ];
        if (x.invert) x0 = x(x0), x1 = x(x1);
        if (x1 < x0) t = x0, x0 = x1, x1 = t;
        if (x0 != xExtent[0] || x1 != xExtent[1]) xExtent = [ x0, x1 ];
      }
      if (y) {
        y0 = z[0], y1 = z[1];
        if (x) y0 = y0[1], y1 = y1[1];
        yExtentDomain = [ y0, y1 ];
        if (y.invert) y0 = y(y0), y1 = y(y1);
        if (y1 < y0) t = y0, y0 = y1, y1 = t;
        if (y0 != yExtent[0] || y1 != yExtent[1]) yExtent = [ y0, y1 ];
      }
      return brush;
    };
    brush.clear = function() {
      if (!brush.empty()) {
        xExtent = [ 0, 0 ], yExtent = [ 0, 0 ];
        xExtentDomain = yExtentDomain = null;
      }
      return brush;
    };
    brush.empty = function() {
      return !!x && xExtent[0] == xExtent[1] || !!y && yExtent[0] == yExtent[1];
    };
    return d3.rebind(brush, event, "on");
  };
  var d3_svg_brushCursor = {
    n: "ns-resize",
    e: "ew-resize",
    s: "ns-resize",
    w: "ew-resize",
    nw: "nwse-resize",
    ne: "nesw-resize",
    se: "nwse-resize",
    sw: "nesw-resize"
  };
  var d3_svg_brushResizes = [ [ "n", "e", "s", "w", "nw", "ne", "se", "sw" ], [ "e", "w" ], [ "n", "s" ], [] ];
  var d3_time_format = d3_time.format = d3_locale_enUS.timeFormat;
  var d3_time_formatUtc = d3_time_format.utc;
  var d3_time_formatIso = d3_time_formatUtc("%Y-%m-%dT%H:%M:%S.%LZ");
  d3_time_format.iso = Date.prototype.toISOString && +new Date("2000-01-01T00:00:00.000Z") ? d3_time_formatIsoNative : d3_time_formatIso;
  function d3_time_formatIsoNative(date) {
    return date.toISOString();
  }
  d3_time_formatIsoNative.parse = function(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
  };
  d3_time_formatIsoNative.toString = d3_time_formatIso.toString;
  d3_time.second = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 1e3) * 1e3);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 1e3);
  }, function(date) {
    return date.getSeconds();
  });
  d3_time.seconds = d3_time.second.range;
  d3_time.seconds.utc = d3_time.second.utc.range;
  d3_time.minute = d3_time_interval(function(date) {
    return new d3_date(Math.floor(date / 6e4) * 6e4);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 6e4);
  }, function(date) {
    return date.getMinutes();
  });
  d3_time.minutes = d3_time.minute.range;
  d3_time.minutes.utc = d3_time.minute.utc.range;
  d3_time.hour = d3_time_interval(function(date) {
    var timezone = date.getTimezoneOffset() / 60;
    return new d3_date((Math.floor(date / 36e5 - timezone) + timezone) * 36e5);
  }, function(date, offset) {
    date.setTime(date.getTime() + Math.floor(offset) * 36e5);
  }, function(date) {
    return date.getHours();
  });
  d3_time.hours = d3_time.hour.range;
  d3_time.hours.utc = d3_time.hour.utc.range;
  d3_time.month = d3_time_interval(function(date) {
    date = d3_time.day(date);
    date.setDate(1);
    return date;
  }, function(date, offset) {
    date.setMonth(date.getMonth() + offset);
  }, function(date) {
    return date.getMonth();
  });
  d3_time.months = d3_time.month.range;
  d3_time.months.utc = d3_time.month.utc.range;
  function d3_time_scale(linear, methods, format) {
    function scale(x) {
      return linear(x);
    }
    scale.invert = function(x) {
      return d3_time_scaleDate(linear.invert(x));
    };
    scale.domain = function(x) {
      if (!arguments.length) return linear.domain().map(d3_time_scaleDate);
      linear.domain(x);
      return scale;
    };
    function tickMethod(extent, count) {
      var span = extent[1] - extent[0], target = span / count, i = d3.bisect(d3_time_scaleSteps, target);
      return i == d3_time_scaleSteps.length ? [ methods.year, d3_scale_linearTickRange(extent.map(function(d) {
        return d / 31536e6;
      }), count)[2] ] : !i ? [ d3_time_scaleMilliseconds, d3_scale_linearTickRange(extent, count)[2] ] : methods[target / d3_time_scaleSteps[i - 1] < d3_time_scaleSteps[i] / target ? i - 1 : i];
    }
    scale.nice = function(interval, skip) {
      var domain = scale.domain(), extent = d3_scaleExtent(domain), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" && tickMethod(extent, interval);
      if (method) interval = method[0], skip = method[1];
      function skipped(date) {
        return !isNaN(date) && !interval.range(date, d3_time_scaleDate(+date + 1), skip).length;
      }
      return scale.domain(d3_scale_nice(domain, skip > 1 ? {
        floor: function(date) {
          while (skipped(date = interval.floor(date))) date = d3_time_scaleDate(date - 1);
          return date;
        },
        ceil: function(date) {
          while (skipped(date = interval.ceil(date))) date = d3_time_scaleDate(+date + 1);
          return date;
        }
      } : interval));
    };
    scale.ticks = function(interval, skip) {
      var extent = d3_scaleExtent(scale.domain()), method = interval == null ? tickMethod(extent, 10) : typeof interval === "number" ? tickMethod(extent, interval) : !interval.range && [ {
        range: interval
      }, skip ];
      if (method) interval = method[0], skip = method[1];
      return interval.range(extent[0], d3_time_scaleDate(+extent[1] + 1), skip < 1 ? 1 : skip);
    };
    scale.tickFormat = function() {
      return format;
    };
    scale.copy = function() {
      return d3_time_scale(linear.copy(), methods, format);
    };
    return d3_scale_linearRebind(scale, linear);
  }
  function d3_time_scaleDate(t) {
    return new Date(t);
  }
  var d3_time_scaleSteps = [ 1e3, 5e3, 15e3, 3e4, 6e4, 3e5, 9e5, 18e5, 36e5, 108e5, 216e5, 432e5, 864e5, 1728e5, 6048e5, 2592e6, 7776e6, 31536e6 ];
  var d3_time_scaleLocalMethods = [ [ d3_time.second, 1 ], [ d3_time.second, 5 ], [ d3_time.second, 15 ], [ d3_time.second, 30 ], [ d3_time.minute, 1 ], [ d3_time.minute, 5 ], [ d3_time.minute, 15 ], [ d3_time.minute, 30 ], [ d3_time.hour, 1 ], [ d3_time.hour, 3 ], [ d3_time.hour, 6 ], [ d3_time.hour, 12 ], [ d3_time.day, 1 ], [ d3_time.day, 2 ], [ d3_time.week, 1 ], [ d3_time.month, 1 ], [ d3_time.month, 3 ], [ d3_time.year, 1 ] ];
  var d3_time_scaleLocalFormat = d3_time_format.multi([ [ ".%L", function(d) {
    return d.getMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getMinutes();
  } ], [ "%I %p", function(d) {
    return d.getHours();
  } ], [ "%a %d", function(d) {
    return d.getDay() && d.getDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getDate() != 1;
  } ], [ "%B", function(d) {
    return d.getMonth();
  } ], [ "%Y", d3_true ] ]);
  var d3_time_scaleMilliseconds = {
    range: function(start, stop, step) {
      return d3.range(Math.ceil(start / step) * step, +stop, step).map(d3_time_scaleDate);
    },
    floor: d3_identity,
    ceil: d3_identity
  };
  d3_time_scaleLocalMethods.year = d3_time.year;
  d3_time.scale = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleLocalMethods, d3_time_scaleLocalFormat);
  };
  var d3_time_scaleUtcMethods = d3_time_scaleLocalMethods.map(function(m) {
    return [ m[0].utc, m[1] ];
  });
  var d3_time_scaleUtcFormat = d3_time_formatUtc.multi([ [ ".%L", function(d) {
    return d.getUTCMilliseconds();
  } ], [ ":%S", function(d) {
    return d.getUTCSeconds();
  } ], [ "%I:%M", function(d) {
    return d.getUTCMinutes();
  } ], [ "%I %p", function(d) {
    return d.getUTCHours();
  } ], [ "%a %d", function(d) {
    return d.getUTCDay() && d.getUTCDate() != 1;
  } ], [ "%b %d", function(d) {
    return d.getUTCDate() != 1;
  } ], [ "%B", function(d) {
    return d.getUTCMonth();
  } ], [ "%Y", d3_true ] ]);
  d3_time_scaleUtcMethods.year = d3_time.year.utc;
  d3_time.scale.utc = function() {
    return d3_time_scale(d3.scale.linear(), d3_time_scaleUtcMethods, d3_time_scaleUtcFormat);
  };
  d3.text = d3_xhrType(function(request) {
    return request.responseText;
  });
  d3.json = function(url, callback) {
    return d3_xhr(url, "application/json", d3_json, callback);
  };
  function d3_json(request) {
    return JSON.parse(request.responseText);
  }
  d3.html = function(url, callback) {
    return d3_xhr(url, "text/html", d3_html, callback);
  };
  function d3_html(request) {
    var range = d3_document.createRange();
    range.selectNode(d3_document.body);
    return range.createContextualFragment(request.responseText);
  }
  d3.xml = d3_xhrType(function(request) {
    return request.responseXML;
  });
  if (true) this.d3 = d3, !(__WEBPACK_AMD_DEFINE_FACTORY__ = (d3),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)); else {}
}();

/***/ }),

/***/ "./node_modules/earcut/src/earcut.js":
/*!*******************************************!*\
  !*** ./node_modules/earcut/src/earcut.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = earcut;

function earcut(data, holeIndices, dim) {

    dim = dim || 2;

    var hasHoles = holeIndices && holeIndices.length,
        outerLen = hasHoles ? holeIndices[0] * dim : data.length,
        outerNode = linkedList(data, 0, outerLen, dim, true),
        triangles = [];

    if (!outerNode) return triangles;

    var minX, minY, maxX, maxY, x, y, size;

    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);

    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = maxX = data[0];
        minY = maxY = data[1];

        for (var i = dim; i < outerLen; i += dim) {
            x = data[i];
            y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }

        // minX, minY and size are later used to transform coords into integers for z-order calculation
        size = Math.max(maxX - minX, maxY - minY);
    }

    earcutLinked(outerNode, triangles, dim, minX, minY, size);

    return triangles;
}

// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    var i, last;

    if (clockwise === (signedArea(data, start, end, dim) > 0)) {
        for (i = start; i < end; i += dim) last = insertNode(i, data[i], data[i + 1], last);
    } else {
        for (i = end - dim; i >= start; i -= dim) last = insertNode(i, data[i], data[i + 1], last);
    }

    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }

    return last;
}

// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;

    var p = start,
        again;
    do {
        again = false;

        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) return null;
            again = true;

        } else {
            p = p.next;
        }
    } while (again || p !== end);

    return end;
}

// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, size, pass) {
    if (!ear) return;

    // interlink polygon nodes in z-order
    if (!pass && size) indexCurve(ear, minX, minY, size);

    var stop = ear,
        prev, next;

    // iterate through ears, slicing them one by one
    while (ear.prev !== ear.next) {
        prev = ear.prev;
        next = ear.next;

        if (size ? isEarHashed(ear, minX, minY, size) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);

            removeNode(ear);

            // skipping the next vertice leads to less sliver triangles
            ear = next.next;
            stop = next.next;

            continue;
        }

        ear = next;

        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) {
                earcutLinked(filterPoints(ear), triangles, dim, minX, minY, size, 1);

            // if this didn't work, try curing all small self-intersections locally
            } else if (pass === 1) {
                ear = cureLocalIntersections(ear, triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, size, 2);

            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) {
                splitEarcut(ear, triangles, dim, minX, minY, size);
            }

            break;
        }
    }
}

// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // now make sure we don't have other points inside the potential ear
    var p = ear.next.next;

    while (p !== ear.prev) {
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }

    return true;
}

function isEarHashed(ear, minX, minY, size) {
    var a = ear.prev,
        b = ear,
        c = ear.next;

    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear

    // triangle bbox; min & max are calculated like this for speed
    var minTX = a.x < b.x ? (a.x < c.x ? a.x : c.x) : (b.x < c.x ? b.x : c.x),
        minTY = a.y < b.y ? (a.y < c.y ? a.y : c.y) : (b.y < c.y ? b.y : c.y),
        maxTX = a.x > b.x ? (a.x > c.x ? a.x : c.x) : (b.x > c.x ? b.x : c.x),
        maxTY = a.y > b.y ? (a.y > c.y ? a.y : c.y) : (b.y > c.y ? b.y : c.y);

    // z-order range for the current triangle bbox;
    var minZ = zOrder(minTX, minTY, minX, minY, size),
        maxZ = zOrder(maxTX, maxTY, minX, minY, size);

    // first look for points inside the triangle in increasing z-order
    var p = ear.nextZ;

    while (p && p.z <= maxZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.nextZ;
    }

    // then look for points in decreasing z-order
    p = ear.prevZ;

    while (p && p.z >= minZ) {
        if (p !== ear.prev && p !== ear.next &&
            pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) &&
            area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }

    return true;
}

// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    var p = start;
    do {
        var a = p.prev,
            b = p.next.next;

        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {

            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);

            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);

            p = start = b;
        }
        p = p.next;
    } while (p !== start);

    return p;
}

// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, size) {
    // look for a valid diagonal that divides the polygon into two
    var a = start;
    do {
        var b = a.next.next;
        while (b !== a.prev) {
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                var c = splitPolygon(a, b);

                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);

                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, size);
                earcutLinked(c, triangles, dim, minX, minY, size);
                return;
            }
            b = b.next;
        }
        a = a.next;
    } while (a !== start);
}

// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    var queue = [],
        i, len, start, end, list;

    for (i = 0, len = holeIndices.length; i < len; i++) {
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }

    queue.sort(compareX);

    // process holes from left to right
    for (i = 0; i < queue.length; i++) {
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }

    return outerNode;
}

function compareX(a, b) {
    return a.x - b.x;
}

// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        var b = splitPolygon(outerNode, hole);
        filterPoints(b, b.next);
    }
}

// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    var p = outerNode,
        hx = hole.x,
        hy = hole.y,
        qx = -Infinity,
        m;

    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y) {
            var x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    } while (p !== outerNode);

    if (!m) return null;

    if (hx === qx) return m.prev; // hole touches outer segment; pick lower endpoint

    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point

    var stop = m,
        mx = m.x,
        my = m.y,
        tanMin = Infinity,
        tan;

    p = m.next;

    while (p !== stop) {
        if (hx >= p.x && p.x >= mx &&
                pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {

            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential

            if ((tan < tanMin || (tan === tanMin && p.x > m.x)) && locallyInside(p, hole)) {
                m = p;
                tanMin = tan;
            }
        }

        p = p.next;
    }

    return m;
}

// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, size) {
    var p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, size);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    } while (p !== start);

    p.prevZ.nextZ = null;
    p.prevZ = null;

    sortLinked(p);
}

// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    var i, p, q, e, tail, numMerges, pSize, qSize,
        inSize = 1;

    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;

        while (p) {
            numMerges++;
            q = p;
            pSize = 0;
            for (i = 0; i < inSize; i++) {
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }

            qSize = inSize;

            while (pSize > 0 || (qSize > 0 && q)) {

                if (pSize === 0) {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                } else if (qSize === 0 || !q) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else if (p.z <= q.z) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }

                if (tail) tail.nextZ = e;
                else list = e;

                e.prevZ = tail;
                tail = e;
            }

            p = q;
        }

        tail.nextZ = null;
        inSize *= 2;

    } while (numMerges > 1);

    return list;
}

// z-order of a point given coords and size of the data bounding box
function zOrder(x, y, minX, minY, size) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) / size;
    y = 32767 * (y - minY) / size;

    x = (x | (x << 8)) & 0x00FF00FF;
    x = (x | (x << 4)) & 0x0F0F0F0F;
    x = (x | (x << 2)) & 0x33333333;
    x = (x | (x << 1)) & 0x55555555;

    y = (y | (y << 8)) & 0x00FF00FF;
    y = (y | (y << 4)) & 0x0F0F0F0F;
    y = (y | (y << 2)) & 0x33333333;
    y = (y | (y << 1)) & 0x55555555;

    return x | (y << 1);
}

// find the leftmost node of a polygon ring
function getLeftmost(start) {
    var p = start,
        leftmost = start;
    do {
        if (p.x < leftmost.x) leftmost = p;
        p = p.next;
    } while (p !== start);

    return leftmost;
}

// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 &&
           (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 &&
           (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}

// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) &&
           locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b);
}

// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}

// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}

// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    if ((equals(p1, q1) && equals(p2, q2)) ||
        (equals(p1, q2) && equals(p2, q1))) return true;
    return area(p1, q1, p2) > 0 !== area(p1, q1, q2) > 0 &&
           area(p2, q2, p1) > 0 !== area(p2, q2, q1) > 0;
}

// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    var p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i &&
                intersects(p, p.next, a, b)) return true;
        p = p.next;
    } while (p !== a);

    return false;
}

// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ?
        area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 :
        area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}

// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    var p = a,
        inside = false,
        px = (a.x + b.x) / 2,
        py = (a.y + b.y) / 2;
    do {
        if (((p.y > py) !== (p.next.y > py)) && (px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x))
            inside = !inside;
        p = p.next;
    } while (p !== a);

    return inside;
}

// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    var a2 = new Node(a.i, a.x, a.y),
        b2 = new Node(b.i, b.x, b.y),
        an = a.next,
        bp = b.prev;

    a.next = b;
    b.prev = a;

    a2.next = an;
    an.prev = a2;

    b2.next = a2;
    a2.prev = b2;

    bp.next = b2;
    b2.prev = bp;

    return b2;
}

// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    var p = new Node(i, x, y);

    if (!last) {
        p.prev = p;
        p.next = p;

    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}

function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;

    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}

function Node(i, x, y) {
    // vertice index in coordinates array
    this.i = i;

    // vertex coordinates
    this.x = x;
    this.y = y;

    // previous and next vertice nodes in a polygon ring
    this.prev = null;
    this.next = null;

    // z-order curve value
    this.z = null;

    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;

    // indicates whether this is a steiner point
    this.steiner = false;
}

// return a percentage difference between the polygon area and its triangulation area;
// used to verify correctness of triangulation
earcut.deviation = function (data, holeIndices, dim, triangles) {
    var hasHoles = holeIndices && holeIndices.length;
    var outerLen = hasHoles ? holeIndices[0] * dim : data.length;

    var polygonArea = Math.abs(signedArea(data, 0, outerLen, dim));
    if (hasHoles) {
        for (var i = 0, len = holeIndices.length; i < len; i++) {
            var start = holeIndices[i] * dim;
            var end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
            polygonArea -= Math.abs(signedArea(data, start, end, dim));
        }
    }

    var trianglesArea = 0;
    for (i = 0; i < triangles.length; i += 3) {
        var a = triangles[i] * dim;
        var b = triangles[i + 1] * dim;
        var c = triangles[i + 2] * dim;
        trianglesArea += Math.abs(
            (data[a] - data[c]) * (data[b + 1] - data[a + 1]) -
            (data[a] - data[b]) * (data[c + 1] - data[a + 1]));
    }

    return polygonArea === 0 && trianglesArea === 0 ? 0 :
        Math.abs((trianglesArea - polygonArea) / polygonArea);
};

function signedArea(data, start, end, dim) {
    var sum = 0;
    for (var i = start, j = end - dim; i < end; i += dim) {
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}

// turn a polygon in a multi-dimensional array form (e.g. as in GeoJSON) into a form Earcut accepts
earcut.flatten = function (data) {
    var dim = data[0][0].length,
        result = {vertices: [], holes: [], dimensions: dim},
        holeIndex = 0;

    for (var i = 0; i < data.length; i++) {
        for (var j = 0; j < data[i].length; j++) {
            for (var d = 0; d < dim; d++) result.vertices.push(data[i][j][d]);
        }
        if (i > 0) {
            holeIndex += data[i - 1].length;
            result.holes.push(holeIndex);
        }
    }
    return result;
};


/***/ }),

/***/ "./node_modules/file-saver/FileSaver.js":
/*!**********************************************!*\
  !*** ./node_modules/file-saver/FileSaver.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/* FileSaver.js
 * A saveAs() FileSaver implementation.
 * 1.3.2
 * 2016-06-16 18:25:19
 *
 * By Eli Grey, http://eligrey.com
 * License: MIT
 *   See https://github.com/eligrey/FileSaver.js/blob/master/LICENSE.md
 */

/*global self */
/*jslint bitwise: true, indent: 4, laxbreak: true, laxcomma: true, smarttabs: true, plusplus: true */

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */

var saveAs = saveAs || (function(view) {
	"use strict";
	// IE <10 is explicitly unsupported
	if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
		return;
	}
	var
		  doc = view.document
		  // only get URL when necessary in case Blob.js hasn't overridden it yet
		, get_URL = function() {
			return view.URL || view.webkitURL || view;
		}
		, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
		, can_use_save_link = "download" in save_link
		, click = function(node) {
			var event = new MouseEvent("click");
			node.dispatchEvent(event);
		}
		, is_safari = /constructor/i.test(view.HTMLElement) || view.safari
		, is_chrome_ios =/CriOS\/[\d]+/.test(navigator.userAgent)
		, throw_outside = function(ex) {
			(view.setImmediate || view.setTimeout)(function() {
				throw ex;
			}, 0);
		}
		, force_saveable_type = "application/octet-stream"
		// the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
		, arbitrary_revoke_timeout = 1000 * 40 // in ms
		, revoke = function(file) {
			var revoker = function() {
				if (typeof file === "string") { // file is an object URL
					get_URL().revokeObjectURL(file);
				} else { // file is a File
					file.remove();
				}
			};
			setTimeout(revoker, arbitrary_revoke_timeout);
		}
		, dispatch = function(filesaver, event_types, event) {
			event_types = [].concat(event_types);
			var i = event_types.length;
			while (i--) {
				var listener = filesaver["on" + event_types[i]];
				if (typeof listener === "function") {
					try {
						listener.call(filesaver, event || filesaver);
					} catch (ex) {
						throw_outside(ex);
					}
				}
			}
		}
		, auto_bom = function(blob) {
			// prepend BOM for UTF-8 XML and text/* types (including HTML)
			// note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
			if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
				return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
			}
			return blob;
		}
		, FileSaver = function(blob, name, no_auto_bom) {
			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			// First try a.download, then web filesystem, then object URLs
			var
				  filesaver = this
				, type = blob.type
				, force = type === force_saveable_type
				, object_url
				, dispatch_all = function() {
					dispatch(filesaver, "writestart progress write writeend".split(" "));
				}
				// on any filesys errors revert to saving with object URLs
				, fs_error = function() {
					if ((is_chrome_ios || (force && is_safari)) && view.FileReader) {
						// Safari doesn't allow downloading of blob urls
						var reader = new FileReader();
						reader.onloadend = function() {
							var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
							var popup = view.open(url, '_blank');
							if(!popup) view.location.href = url;
							url=undefined; // release reference before dispatching
							filesaver.readyState = filesaver.DONE;
							dispatch_all();
						};
						reader.readAsDataURL(blob);
						filesaver.readyState = filesaver.INIT;
						return;
					}
					// don't create more object URLs than needed
					if (!object_url) {
						object_url = get_URL().createObjectURL(blob);
					}
					if (force) {
						view.location.href = object_url;
					} else {
						var opened = view.open(object_url, "_blank");
						if (!opened) {
							// Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
							view.location.href = object_url;
						}
					}
					filesaver.readyState = filesaver.DONE;
					dispatch_all();
					revoke(object_url);
				}
			;
			filesaver.readyState = filesaver.INIT;

			if (can_use_save_link) {
				object_url = get_URL().createObjectURL(blob);
				setTimeout(function() {
					save_link.href = object_url;
					save_link.download = name;
					click(save_link);
					dispatch_all();
					revoke(object_url);
					filesaver.readyState = filesaver.DONE;
				});
				return;
			}

			fs_error();
		}
		, FS_proto = FileSaver.prototype
		, saveAs = function(blob, name, no_auto_bom) {
			return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
		}
	;
	// IE 10+ (native saveAs)
	if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
		return function(blob, name, no_auto_bom) {
			name = name || blob.name || "download";

			if (!no_auto_bom) {
				blob = auto_bom(blob);
			}
			return navigator.msSaveOrOpenBlob(blob, name);
		};
	}

	FS_proto.abort = function(){};
	FS_proto.readyState = FS_proto.INIT = 0;
	FS_proto.WRITING = 1;
	FS_proto.DONE = 2;

	FS_proto.error =
	FS_proto.onwritestart =
	FS_proto.onprogress =
	FS_proto.onwrite =
	FS_proto.onabort =
	FS_proto.onerror =
	FS_proto.onwriteend =
		null;

	return saveAs;
}(
	   typeof self !== "undefined" && self
	|| typeof window !== "undefined" && window
	|| this.content
));
// `self` is undefined in Firefox for Android content script context
// while `this` is nsIContentFrameMessageManager
// with an attribute `content` that corresponds to the window

if ( true && module.exports) {
  module.exports.saveAs = saveAs;
} else if (( true && __webpack_require__(/*! !webpack amd define */ "./node_modules/webpack/buildin/amd-define.js") !== null) && (__webpack_require__(/*! !webpack amd options */ "./node_modules/webpack/buildin/amd-options.js") !== null)) {
  !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
    return saveAs;
  }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}


/***/ }),

/***/ "./node_modules/hammerjs/hammer.js":
/*!*****************************************!*\
  !*** ./node_modules/hammerjs/hammer.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else {}

})(window, document, 'Hammer');


/***/ }),

/***/ "./node_modules/ieee754/index.js":
/*!***************************************!*\
  !*** ./node_modules/ieee754/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/*!***************************************************!*\
  !*** ./node_modules/inherits/inherits_browser.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "./node_modules/isarray/index.js":
/*!***************************************!*\
  !*** ./node_modules/isarray/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),

/***/ "./node_modules/jquery/dist/jquery.js":
/*!********************************************!*\
  !*** ./node_modules/jquery/dist/jquery.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.1.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2016-09-22T22:30Z
 */
( function( global, factory ) {

	"use strict";

	if (  true && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var document = window.document;

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};



	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var
	version = "3.1.1",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android <=4.0 only
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// As of jQuery 3.0, isNumeric is limited to
		// strings and numbers (primitives or objects)
		// that can be coerced to finite numbers (gh-2662)
		var type = jQuery.type( obj );
		return ( type === "number" || type === "string" ) &&

			// parseFloat NaNs numeric-cast false positives ("")
			// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
			// subtraction forces infinities to NaN
			!isNaN( obj - parseFloat( obj ) );
	},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {

		/* eslint-disable no-unused-vars */
		// See https://github.com/eslint/eslint/issues/6125
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android <=2.3 only (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		DOMEval( code );
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE <=9 - 11, Edge 12 - 13
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android <=4.0 only
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// https://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// CSS string/identifier serialization
	// https://drafts.csswg.org/cssom/#common-serializing-idioms
	rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
	fcssescape = function( ch, asCodePoint ) {
		if ( asCodePoint ) {

			// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
			if ( ch === "\0" ) {
				return "\uFFFD";
			}

			// Control characters and (dependent upon position) numbers get escaped as code points
			return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
		}

		// Other potentially-special ASCII characters get backslash-escaped
		return "\\" + ch;
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	},

	disabledAncestor = addCombinator(
		function( elem ) {
			return elem.disabled === true && ("form" in elem || "label" in elem);
		},
		{ dir: "parentNode", next: "legend" }
	);

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rcssescape, fcssescape );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[i] = "#" + nid + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement("fieldset");

	try {
		return !!fn( el );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}
		// release memory in IE
		el = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			a.sourceIndex - b.sourceIndex;

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					/* jshint -W018 */
					elem.isDisabled !== !disabled &&
						disabledAncestor( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( preferredDoc !== document &&
		(subWindow = document.defaultView) && subWindow.top !== subWindow ) {

		// Support: IE 11, Edge
		if ( subWindow.addEventListener ) {
			subWindow.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( subWindow.attachEvent ) {
			subWindow.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( el ) {
		el.className = "i";
		return !el.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( el ) {
		el.appendChild( document.createComment("") );
		return !el.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( el ) {
		docElem.appendChild( el ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID filter and find
	if ( support.getById ) {
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode("id");
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( (elem = elems[i++]) ) {
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See https://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( el ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// https://bugs.jquery.com/ticket/12359
			docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( el.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !el.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !el.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibling-combinator selector` fails
			if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( el ) {
			el.innerHTML = "<a href='' disabled='disabled'></a>" +
				"<select disabled='disabled'><option/></select>";

			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			el.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( el.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( el.querySelectorAll(":enabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Support: IE9-11+
			// IE's :disabled selector does not pick up the children of disabled fieldsets
			docElem.appendChild( el ).disabled = true;
			if ( el.querySelectorAll(":disabled").length !== 2 ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			el.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( el ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( el, "*" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( el, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.escape = function( sel ) {
	return (sel + "").replace( rcssescape, fcssescape );
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": createDisabledPseudo( false ),
		"disabled": createDisabledPseudo( true ),

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( skip && skip === elem.nodeName.toLowerCase() ) {
							elem = elem[ dir ] || elem;
						} else if ( (oldCache = uniqueCache[ key ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( el ) {
	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( el ) {
	el.innerHTML = "<a href='#'></a>";
	return el.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( el ) {
	el.innerHTML = "<input/>";
	el.firstChild.setAttribute( "value", "" );
	return el.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( el ) {
	return el.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;
jQuery.escapeSelector = Sizzle.escape;




var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Simple selector that can be filtered directly, removing non-Elements
	if ( risSimple.test( qualifier ) ) {
		return jQuery.filter( qualifier, elements, not );
	}

	// Complex selector, compare the two sets, removing non-Elements
	qualifier = jQuery.filter( qualifier, elements );
	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to Sizzle
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			resolve.call( undefined, value );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.call( undefined, value );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( jQuery.isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.stackTrace );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the stack, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getStackHook ) {
									process.stackTrace = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								jQuery.isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the master Deferred
			master = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						master.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( master.state() === "pending" ||
				jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return master.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
		}

		return master.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

jQuery.Deferred.exceptionHook = function( error, stack ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ jQuery.camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ jQuery.camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( jQuery.camelCase );
			} else {
				key = jQuery.camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			jQuery.contains( elem.ownerDocument, elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};




function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE <=9 only
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE <=9 only
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();
var documentElement = document.documentElement;



var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE <=9 only
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		// Make a writable jQuery.Event from the native event object
		var event = jQuery.event.fix( nativeEvent );

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: jQuery.isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
							return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
							return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (#504, #13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,

	which: function( event ) {
		var button = event.button;

		// Add which for key events
		if ( event.which == null && rkeyEvent.test( event.type ) ) {
			return event.charCode != null ? event.charCode : event.keyCode;
		}

		// Add which for click: 1 === left; 2 === middle; 3 === right
		if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
			if ( button & 1 ) {
				return 1;
			}

			if ( button & 2 ) {
				return 3;
			}

			if ( button & 4 ) {
				return 2;
			}

			return 0;
		}

		return event.which;
	}
}, jQuery.event.addProp );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	/* eslint-disable max-len */

	// See https://github.com/eslint/eslint/issues/3229
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,

	/* eslint-enable */

	// Support: IE <=10 - 11, Edge 12 - 13
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

function manipulationTarget( elem, content ) {
	if ( jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		div.style.cssText =
			"box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	jQuery.extend( support, {
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {
			computeStyleTests();
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );

	// Support: IE <=9 only
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i,
		val = 0;

	// If we already have the right measurement, avoid augmentation
	if ( extra === ( isBorderBox ? "border" : "content" ) ) {
		i = 4;

	// Otherwise initialize for horizontal or vertical properties
	} else {
		i = name === "width" ? 1 : 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var val,
		valueIsBorderBox = true,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Support: IE <=11 only
	// Running getBoundingClientRect on a disconnected node
	// in IE throws an error.
	if ( elem.getClientRects().length ) {
		val = elem.getBoundingClientRect()[ name ];
	}

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function raf() {
	if ( timerId ) {
		window.requestAnimationFrame( raf );
		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 13
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

			/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	// Go to the end state if fx are off or if document is hidden
	if ( jQuery.fx.off || document.hidden ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.requestAnimationFrame ?
			window.requestAnimationFrame( raf ) :
			window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	if ( window.cancelAnimationFrame ) {
		window.cancelAnimationFrame( timerId );
	} else {
		window.clearInterval( timerId );
	}

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnothtmlwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnothtmlwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
					return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = jQuery.isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( jQuery.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 13
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( jQuery.isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win, rect, doc,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		rect = elem.getBoundingClientRect();

		// Make sure element is not hidden (display: none)
		if ( rect.width || rect.height ) {
			doc = elem.ownerDocument;
			win = getWindow( doc );
			docElem = doc.documentElement;

			return {
				top: rect.top + win.pageYOffset - docElem.clientTop,
				left: rect.left + win.pageXOffset - docElem.clientLeft
			};
		}

		// Return zeros for disconnected and hidden elements (gh-2310)
		return rect;
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset = {
				top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
				left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
			};
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	}
} );

jQuery.parseJSON = JSON.parse;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
		return jQuery;
	}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}





return jQuery;
} );


/***/ }),

/***/ "./node_modules/js-md5/src/md5.js":
/*!****************************************!*\
  !*** ./node_modules/js-md5/src/md5.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.7.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2017
 * @license MIT
 */
(function () {
  'use strict';

  var ERROR = 'input is invalid type';
  var WINDOW = typeof window === 'object';
  var root = WINDOW ? window : {};
  if (root.JS_MD5_NO_WINDOW) {
    WINDOW = false;
  }
  var WEB_WORKER = !WINDOW && typeof self === 'object';
  var NODE_JS = !root.JS_MD5_NO_NODE_JS && typeof process === 'object' && process.versions && process.versions.node;
  if (NODE_JS) {
    root = global;
  } else if (WEB_WORKER) {
    root = self;
  }
  var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && typeof module === 'object' && module.exports;
  var AMD =  true && __webpack_require__(/*! !webpack amd options */ "./node_modules/webpack/buildin/amd-options.js");
  var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
  var HEX_CHARS = '0123456789abcdef'.split('');
  var EXTRA = [128, 32768, 8388608, -2147483648];
  var SHIFT = [0, 8, 16, 24];
  var OUTPUT_TYPES = ['hex', 'array', 'digest', 'buffer', 'arrayBuffer', 'base64'];
  var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');

  var blocks = [], buffer8;
  if (ARRAY_BUFFER) {
    var buffer = new ArrayBuffer(68);
    buffer8 = new Uint8Array(buffer);
    blocks = new Uint32Array(buffer);
  }

  if (root.JS_MD5_NO_NODE_JS || !Array.isArray) {
    Array.isArray = function (obj) {
      return Object.prototype.toString.call(obj) === '[object Array]';
    };
  }

  if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
    ArrayBuffer.isView = function (obj) {
      return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
  }

  /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */
  /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */
  var createOutputMethod = function (outputType) {
    return function (message) {
      return new Md5(true).update(message)[outputType]();
    };
  };

  /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */
  /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */
  var createMethod = function () {
    var method = createOutputMethod('hex');
    if (NODE_JS) {
      method = nodeWrap(method);
    }
    method.create = function () {
      return new Md5();
    };
    method.update = function (message) {
      return method.create().update(message);
    };
    for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
      var type = OUTPUT_TYPES[i];
      method[type] = createOutputMethod(type);
    }
    return method;
  };

  var nodeWrap = function (method) {
    var crypto = eval("require('crypto')");
    var Buffer = eval("require('buffer').Buffer");
    var nodeMethod = function (message) {
      if (typeof message === 'string') {
        return crypto.createHash('md5').update(message, 'utf8').digest('hex');
      } else {
        if (message === null || message === undefined) {
          throw ERROR;
        } else if (message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        }
      }
      if (Array.isArray(message) || ArrayBuffer.isView(message) ||
        message.constructor === Buffer) {
        return crypto.createHash('md5').update(new Buffer(message)).digest('hex');
      } else {
        return method(message);
      }
    };
    return nodeMethod;
  };

  /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */
  function Md5(sharedMemory) {
    if (sharedMemory) {
      blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      this.blocks = blocks;
      this.buffer8 = buffer8;
    } else {
      if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        this.buffer8 = new Uint8Array(buffer);
        this.blocks = new Uint32Array(buffer);
      } else {
        this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
    }
    this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
    this.finalized = this.hashed = false;
    this.first = true;
  }

  /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */
  Md5.prototype.update = function (message) {
    if (this.finalized) {
      return;
    }

    var notString, type = typeof message;
    if (type !== 'string') {
      if (type === 'object') {
        if (message === null) {
          throw ERROR;
        } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
          message = new Uint8Array(message);
        } else if (!Array.isArray(message)) {
          if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
            throw ERROR;
          }
        }
      } else {
        throw ERROR;
      }
      notString = true;
    }
    var code, index = 0, i, length = message.length, blocks = this.blocks;
    var buffer8 = this.buffer8;

    while (index < length) {
      if (this.hashed) {
        this.hashed = false;
        blocks[0] = blocks[16];
        blocks[16] = blocks[1] = blocks[2] = blocks[3] =
        blocks[4] = blocks[5] = blocks[6] = blocks[7] =
        blocks[8] = blocks[9] = blocks[10] = blocks[11] =
        blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
      }

      if (notString) {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            buffer8[i++] = message[index];
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            blocks[i >> 2] |= message[index] << SHIFT[i++ & 3];
          }
        }
      } else {
        if (ARRAY_BUFFER) {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              buffer8[i++] = code;
            } else if (code < 0x800) {
              buffer8[i++] = 0xc0 | (code >> 6);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else if (code < 0xd800 || code >= 0xe000) {
              buffer8[i++] = 0xe0 | (code >> 12);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              buffer8[i++] = 0xf0 | (code >> 18);
              buffer8[i++] = 0x80 | ((code >> 12) & 0x3f);
              buffer8[i++] = 0x80 | ((code >> 6) & 0x3f);
              buffer8[i++] = 0x80 | (code & 0x3f);
            }
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 0x80) {
              blocks[i >> 2] |= code << SHIFT[i++ & 3];
            } else if (code < 0x800) {
              blocks[i >> 2] |= (0xc0 | (code >> 6)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else if (code < 0xd800 || code >= 0xe000) {
              blocks[i >> 2] |= (0xe0 | (code >> 12)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            } else {
              code = 0x10000 + (((code & 0x3ff) << 10) | (message.charCodeAt(++index) & 0x3ff));
              blocks[i >> 2] |= (0xf0 | (code >> 18)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 12) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | ((code >> 6) & 0x3f)) << SHIFT[i++ & 3];
              blocks[i >> 2] |= (0x80 | (code & 0x3f)) << SHIFT[i++ & 3];
            }
          }
        }
      }
      this.lastByteIndex = i;
      this.bytes += i - this.start;
      if (i >= 64) {
        this.start = i - 64;
        this.hash();
        this.hashed = true;
      } else {
        this.start = i;
      }
    }
    if (this.bytes > 4294967295) {
      this.hBytes += this.bytes / 4294967296 << 0;
      this.bytes = this.bytes % 4294967296;
    }
    return this;
  };

  Md5.prototype.finalize = function () {
    if (this.finalized) {
      return;
    }
    this.finalized = true;
    var blocks = this.blocks, i = this.lastByteIndex;
    blocks[i >> 2] |= EXTRA[i & 3];
    if (i >= 56) {
      if (!this.hashed) {
        this.hash();
      }
      blocks[0] = blocks[16];
      blocks[16] = blocks[1] = blocks[2] = blocks[3] =
      blocks[4] = blocks[5] = blocks[6] = blocks[7] =
      blocks[8] = blocks[9] = blocks[10] = blocks[11] =
      blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
    }
    blocks[14] = this.bytes << 3;
    blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
    this.hash();
  };

  Md5.prototype.hash = function () {
    var a, b, c, d, bc, da, blocks = this.blocks;

    if (this.first) {
      a = blocks[0] - 680876937;
      a = (a << 7 | a >>> 25) - 271733879 << 0;
      d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
      d = (d << 12 | d >>> 20) + a << 0;
      c = (-271733879 ^ (d & (a ^ -271733879))) + blocks[2] - 1126478375;
      c = (c << 17 | c >>> 15) + d << 0;
      b = (a ^ (c & (d ^ a))) + blocks[3] - 1316259209;
      b = (b << 22 | b >>> 10) + c << 0;
    } else {
      a = this.h0;
      b = this.h1;
      c = this.h2;
      d = this.h3;
      a += (d ^ (b & (c ^ d))) + blocks[0] - 680876936;
      a = (a << 7 | a >>> 25) + b << 0;
      d += (c ^ (a & (b ^ c))) + blocks[1] - 389564586;
      d = (d << 12 | d >>> 20) + a << 0;
      c += (b ^ (d & (a ^ b))) + blocks[2] + 606105819;
      c = (c << 17 | c >>> 15) + d << 0;
      b += (a ^ (c & (d ^ a))) + blocks[3] - 1044525330;
      b = (b << 22 | b >>> 10) + c << 0;
    }

    a += (d ^ (b & (c ^ d))) + blocks[4] - 176418897;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[5] + 1200080426;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[6] - 1473231341;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[7] - 45705983;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[8] + 1770035416;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[9] - 1958414417;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[10] - 42063;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[11] - 1990404162;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (d ^ (b & (c ^ d))) + blocks[12] + 1804603682;
    a = (a << 7 | a >>> 25) + b << 0;
    d += (c ^ (a & (b ^ c))) + blocks[13] - 40341101;
    d = (d << 12 | d >>> 20) + a << 0;
    c += (b ^ (d & (a ^ b))) + blocks[14] - 1502002290;
    c = (c << 17 | c >>> 15) + d << 0;
    b += (a ^ (c & (d ^ a))) + blocks[15] + 1236535329;
    b = (b << 22 | b >>> 10) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[1] - 165796510;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[6] - 1069501632;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[11] + 643717713;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[0] - 373897302;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[5] - 701558691;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[10] + 38016083;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[15] - 660478335;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[4] - 405537848;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[9] + 568446438;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[14] - 1019803690;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[3] - 187363961;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[8] + 1163531501;
    b = (b << 20 | b >>> 12) + c << 0;
    a += (c ^ (d & (b ^ c))) + blocks[13] - 1444681467;
    a = (a << 5 | a >>> 27) + b << 0;
    d += (b ^ (c & (a ^ b))) + blocks[2] - 51403784;
    d = (d << 9 | d >>> 23) + a << 0;
    c += (a ^ (b & (d ^ a))) + blocks[7] + 1735328473;
    c = (c << 14 | c >>> 18) + d << 0;
    b += (d ^ (a & (c ^ d))) + blocks[12] - 1926607734;
    b = (b << 20 | b >>> 12) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[5] - 378558;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[8] - 2022574463;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[11] + 1839030562;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[14] - 35309556;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[1] - 1530992060;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[4] + 1272893353;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[7] - 155497632;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[10] - 1094730640;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[13] + 681279174;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[0] - 358537222;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[3] - 722521979;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[6] + 76029189;
    b = (b << 23 | b >>> 9) + c << 0;
    bc = b ^ c;
    a += (bc ^ d) + blocks[9] - 640364487;
    a = (a << 4 | a >>> 28) + b << 0;
    d += (bc ^ a) + blocks[12] - 421815835;
    d = (d << 11 | d >>> 21) + a << 0;
    da = d ^ a;
    c += (da ^ b) + blocks[15] + 530742520;
    c = (c << 16 | c >>> 16) + d << 0;
    b += (da ^ c) + blocks[2] - 995338651;
    b = (b << 23 | b >>> 9) + c << 0;
    a += (c ^ (b | ~d)) + blocks[0] - 198630844;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[5] - 57434055;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[10] - 1051523;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[15] - 30611744;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
    b = (b << 21 | b >>> 11) + c << 0;
    a += (c ^ (b | ~d)) + blocks[4] - 145523070;
    a = (a << 6 | a >>> 26) + b << 0;
    d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
    d = (d << 10 | d >>> 22) + a << 0;
    c += (a ^ (d | ~b)) + blocks[2] + 718787259;
    c = (c << 15 | c >>> 17) + d << 0;
    b += (d ^ (c | ~a)) + blocks[9] - 343485551;
    b = (b << 21 | b >>> 11) + c << 0;

    if (this.first) {
      this.h0 = a + 1732584193 << 0;
      this.h1 = b - 271733879 << 0;
      this.h2 = c - 1732584194 << 0;
      this.h3 = d + 271733878 << 0;
      this.first = false;
    } else {
      this.h0 = this.h0 + a << 0;
      this.h1 = this.h1 + b << 0;
      this.h2 = this.h2 + c << 0;
      this.h3 = this.h3 + d << 0;
    }
  };

  /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */
  Md5.prototype.hex = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;

    return HEX_CHARS[(h0 >> 4) & 0x0F] + HEX_CHARS[h0 & 0x0F] +
      HEX_CHARS[(h0 >> 12) & 0x0F] + HEX_CHARS[(h0 >> 8) & 0x0F] +
      HEX_CHARS[(h0 >> 20) & 0x0F] + HEX_CHARS[(h0 >> 16) & 0x0F] +
      HEX_CHARS[(h0 >> 28) & 0x0F] + HEX_CHARS[(h0 >> 24) & 0x0F] +
      HEX_CHARS[(h1 >> 4) & 0x0F] + HEX_CHARS[h1 & 0x0F] +
      HEX_CHARS[(h1 >> 12) & 0x0F] + HEX_CHARS[(h1 >> 8) & 0x0F] +
      HEX_CHARS[(h1 >> 20) & 0x0F] + HEX_CHARS[(h1 >> 16) & 0x0F] +
      HEX_CHARS[(h1 >> 28) & 0x0F] + HEX_CHARS[(h1 >> 24) & 0x0F] +
      HEX_CHARS[(h2 >> 4) & 0x0F] + HEX_CHARS[h2 & 0x0F] +
      HEX_CHARS[(h2 >> 12) & 0x0F] + HEX_CHARS[(h2 >> 8) & 0x0F] +
      HEX_CHARS[(h2 >> 20) & 0x0F] + HEX_CHARS[(h2 >> 16) & 0x0F] +
      HEX_CHARS[(h2 >> 28) & 0x0F] + HEX_CHARS[(h2 >> 24) & 0x0F] +
      HEX_CHARS[(h3 >> 4) & 0x0F] + HEX_CHARS[h3 & 0x0F] +
      HEX_CHARS[(h3 >> 12) & 0x0F] + HEX_CHARS[(h3 >> 8) & 0x0F] +
      HEX_CHARS[(h3 >> 20) & 0x0F] + HEX_CHARS[(h3 >> 16) & 0x0F] +
      HEX_CHARS[(h3 >> 28) & 0x0F] + HEX_CHARS[(h3 >> 24) & 0x0F];
  };

  /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */
  Md5.prototype.toString = Md5.prototype.hex;

  /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */
  Md5.prototype.digest = function () {
    this.finalize();

    var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
    return [
      h0 & 0xFF, (h0 >> 8) & 0xFF, (h0 >> 16) & 0xFF, (h0 >> 24) & 0xFF,
      h1 & 0xFF, (h1 >> 8) & 0xFF, (h1 >> 16) & 0xFF, (h1 >> 24) & 0xFF,
      h2 & 0xFF, (h2 >> 8) & 0xFF, (h2 >> 16) & 0xFF, (h2 >> 24) & 0xFF,
      h3 & 0xFF, (h3 >> 8) & 0xFF, (h3 >> 16) & 0xFF, (h3 >> 24) & 0xFF
    ];
  };

  /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */
  Md5.prototype.array = Md5.prototype.digest;

  /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */
  Md5.prototype.arrayBuffer = function () {
    this.finalize();

    var buffer = new ArrayBuffer(16);
    var blocks = new Uint32Array(buffer);
    blocks[0] = this.h0;
    blocks[1] = this.h1;
    blocks[2] = this.h2;
    blocks[3] = this.h3;
    return buffer;
  };

  /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */
  Md5.prototype.buffer = Md5.prototype.arrayBuffer;

  /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */
  Md5.prototype.base64 = function () {
    var v1, v2, v3, base64Str = '', bytes = this.array();
    for (var i = 0; i < 15;) {
      v1 = bytes[i++];
      v2 = bytes[i++];
      v3 = bytes[i++];
      base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
        BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] +
        BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] +
        BASE64_ENCODE_CHAR[v3 & 63];
    }
    v1 = bytes[i];
    base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] +
      BASE64_ENCODE_CHAR[(v1 << 4) & 63] +
      '==';
    return base64Str;
  };

  var exports = createMethod();

  if (COMMON_JS) {
    module.exports = exports;
  } else {
    /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */
    root.md5 = exports;
    if (AMD) {
      !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
        return exports;
      }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
  }
})();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js"), __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/jszip/dist/jszip.min.js":
/*!**********************************************!*\
  !*** ./node_modules/jszip/dist/jszip.min.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer, setImmediate, global, process) {var require;var require;/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

!function(e){if(true)module.exports=e();else {}}(function(){return function s(a,o,h){function u(r,e){if(!o[r]){if(!a[r]){var t="function"==typeof require&&require;if(!e&&t)return require(r,!0);if(l)return l(r,!0);var n=new Error("Cannot find module '"+r+"'");throw n.code="MODULE_NOT_FOUND",n}var i=o[r]={exports:{}};a[r][0].call(i.exports,function(e){var t=a[r][1][e];return u(t||e)},i,i.exports,s,a,o,h)}return o[r].exports}for(var l="function"==typeof require&&require,e=0;e<h.length;e++)u(h[e]);return u}({1:[function(e,t,r){"use strict";var d=e("./utils"),c=e("./support"),p="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";r.encode=function(e){for(var t,r,n,i,s,a,o,h=[],u=0,l=e.length,f=l,c="string"!==d.getTypeOf(e);u<e.length;)f=l-u,n=c?(t=e[u++],r=u<l?e[u++]:0,u<l?e[u++]:0):(t=e.charCodeAt(u++),r=u<l?e.charCodeAt(u++):0,u<l?e.charCodeAt(u++):0),i=t>>2,s=(3&t)<<4|r>>4,a=1<f?(15&r)<<2|n>>6:64,o=2<f?63&n:64,h.push(p.charAt(i)+p.charAt(s)+p.charAt(a)+p.charAt(o));return h.join("")},r.decode=function(e){var t,r,n,i,s,a,o=0,h=0,u="data:";if(e.substr(0,u.length)===u)throw new Error("Invalid base64 input, it looks like a data url.");var l,f=3*(e=e.replace(/[^A-Za-z0-9+/=]/g,"")).length/4;if(e.charAt(e.length-1)===p.charAt(64)&&f--,e.charAt(e.length-2)===p.charAt(64)&&f--,f%1!=0)throw new Error("Invalid base64 input, bad content length.");for(l=c.uint8array?new Uint8Array(0|f):new Array(0|f);o<e.length;)t=p.indexOf(e.charAt(o++))<<2|(i=p.indexOf(e.charAt(o++)))>>4,r=(15&i)<<4|(s=p.indexOf(e.charAt(o++)))>>2,n=(3&s)<<6|(a=p.indexOf(e.charAt(o++))),l[h++]=t,64!==s&&(l[h++]=r),64!==a&&(l[h++]=n);return l}},{"./support":30,"./utils":32}],2:[function(e,t,r){"use strict";var n=e("./external"),i=e("./stream/DataWorker"),s=e("./stream/Crc32Probe"),a=e("./stream/DataLengthProbe");function o(e,t,r,n,i){this.compressedSize=e,this.uncompressedSize=t,this.crc32=r,this.compression=n,this.compressedContent=i}o.prototype={getContentWorker:function(){var e=new i(n.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new a("data_length")),t=this;return e.on("end",function(){if(this.streamInfo.data_length!==t.uncompressedSize)throw new Error("Bug : uncompressed data size mismatch")}),e},getCompressedWorker:function(){return new i(n.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize",this.compressedSize).withStreamInfo("uncompressedSize",this.uncompressedSize).withStreamInfo("crc32",this.crc32).withStreamInfo("compression",this.compression)}},o.createWorkerFrom=function(e,t,r){return e.pipe(new s).pipe(new a("uncompressedSize")).pipe(t.compressWorker(r)).pipe(new a("compressedSize")).withStreamInfo("compression",t)},t.exports=o},{"./external":6,"./stream/Crc32Probe":25,"./stream/DataLengthProbe":26,"./stream/DataWorker":27}],3:[function(e,t,r){"use strict";var n=e("./stream/GenericWorker");r.STORE={magic:"\0\0",compressWorker:function(){return new n("STORE compression")},uncompressWorker:function(){return new n("STORE decompression")}},r.DEFLATE=e("./flate")},{"./flate":7,"./stream/GenericWorker":28}],4:[function(e,t,r){"use strict";var n=e("./utils");var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t){return void 0!==e&&e.length?"string"!==n.getTypeOf(e)?function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}(0|t,e,e.length,0):function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t.charCodeAt(a))];return-1^e}(0|t,e,e.length,0):0}},{"./utils":32}],5:[function(e,t,r){"use strict";r.base64=!1,r.binary=!1,r.dir=!1,r.createFolders=!0,r.date=null,r.compression=null,r.compressionOptions=null,r.comment=null,r.unixPermissions=null,r.dosPermissions=null},{}],6:[function(e,t,r){"use strict";var n=null;n="undefined"!=typeof Promise?Promise:e("lie"),t.exports={Promise:n}},{lie:37}],7:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Uint32Array,i=e("pako"),s=e("./utils"),a=e("./stream/GenericWorker"),o=n?"uint8array":"array";function h(e,t){a.call(this,"FlateWorker/"+e),this._pako=null,this._pakoAction=e,this._pakoOptions=t,this.meta={}}r.magic="\b\0",s.inherits(h,a),h.prototype.processChunk=function(e){this.meta=e.meta,null===this._pako&&this._createPako(),this._pako.push(s.transformTo(o,e.data),!1)},h.prototype.flush=function(){a.prototype.flush.call(this),null===this._pako&&this._createPako(),this._pako.push([],!0)},h.prototype.cleanUp=function(){a.prototype.cleanUp.call(this),this._pako=null},h.prototype._createPako=function(){this._pako=new i[this._pakoAction]({raw:!0,level:this._pakoOptions.level||-1});var t=this;this._pako.onData=function(e){t.push({data:e,meta:t.meta})}},r.compressWorker=function(e){return new h("Deflate",e)},r.uncompressWorker=function(){return new h("Inflate",{})}},{"./stream/GenericWorker":28,"./utils":32,pako:38}],8:[function(e,t,r){"use strict";function A(e,t){var r,n="";for(r=0;r<t;r++)n+=String.fromCharCode(255&e),e>>>=8;return n}function n(e,t,r,n,i,s){var a,o,h=e.file,u=e.compression,l=s!==O.utf8encode,f=I.transformTo("string",s(h.name)),c=I.transformTo("string",O.utf8encode(h.name)),d=h.comment,p=I.transformTo("string",s(d)),m=I.transformTo("string",O.utf8encode(d)),_=c.length!==h.name.length,g=m.length!==d.length,b="",v="",y="",w=h.dir,k=h.date,x={crc32:0,compressedSize:0,uncompressedSize:0};t&&!r||(x.crc32=e.crc32,x.compressedSize=e.compressedSize,x.uncompressedSize=e.uncompressedSize);var S=0;t&&(S|=8),l||!_&&!g||(S|=2048);var z=0,C=0;w&&(z|=16),"UNIX"===i?(C=798,z|=function(e,t){var r=e;return e||(r=t?16893:33204),(65535&r)<<16}(h.unixPermissions,w)):(C=20,z|=function(e){return 63&(e||0)}(h.dosPermissions)),a=k.getUTCHours(),a<<=6,a|=k.getUTCMinutes(),a<<=5,a|=k.getUTCSeconds()/2,o=k.getUTCFullYear()-1980,o<<=4,o|=k.getUTCMonth()+1,o<<=5,o|=k.getUTCDate(),_&&(v=A(1,1)+A(B(f),4)+c,b+="up"+A(v.length,2)+v),g&&(y=A(1,1)+A(B(p),4)+m,b+="uc"+A(y.length,2)+y);var E="";return E+="\n\0",E+=A(S,2),E+=u.magic,E+=A(a,2),E+=A(o,2),E+=A(x.crc32,4),E+=A(x.compressedSize,4),E+=A(x.uncompressedSize,4),E+=A(f.length,2),E+=A(b.length,2),{fileRecord:R.LOCAL_FILE_HEADER+E+f+b,dirRecord:R.CENTRAL_FILE_HEADER+A(C,2)+E+A(p.length,2)+"\0\0\0\0"+A(z,4)+A(n,4)+f+b+p}}var I=e("../utils"),i=e("../stream/GenericWorker"),O=e("../utf8"),B=e("../crc32"),R=e("../signature");function s(e,t,r,n){i.call(this,"ZipFileWorker"),this.bytesWritten=0,this.zipComment=t,this.zipPlatform=r,this.encodeFileName=n,this.streamFiles=e,this.accumulate=!1,this.contentBuffer=[],this.dirRecords=[],this.currentSourceOffset=0,this.entriesCount=0,this.currentFile=null,this._sources=[]}I.inherits(s,i),s.prototype.push=function(e){var t=e.meta.percent||0,r=this.entriesCount,n=this._sources.length;this.accumulate?this.contentBuffer.push(e):(this.bytesWritten+=e.data.length,i.prototype.push.call(this,{data:e.data,meta:{currentFile:this.currentFile,percent:r?(t+100*(r-n-1))/r:100}}))},s.prototype.openedSource=function(e){this.currentSourceOffset=this.bytesWritten,this.currentFile=e.file.name;var t=this.streamFiles&&!e.file.dir;if(t){var r=n(e,t,!1,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);this.push({data:r.fileRecord,meta:{percent:0}})}else this.accumulate=!0},s.prototype.closedSource=function(e){this.accumulate=!1;var t=this.streamFiles&&!e.file.dir,r=n(e,t,!0,this.currentSourceOffset,this.zipPlatform,this.encodeFileName);if(this.dirRecords.push(r.dirRecord),t)this.push({data:function(e){return R.DATA_DESCRIPTOR+A(e.crc32,4)+A(e.compressedSize,4)+A(e.uncompressedSize,4)}(e),meta:{percent:100}});else for(this.push({data:r.fileRecord,meta:{percent:0}});this.contentBuffer.length;)this.push(this.contentBuffer.shift());this.currentFile=null},s.prototype.flush=function(){for(var e=this.bytesWritten,t=0;t<this.dirRecords.length;t++)this.push({data:this.dirRecords[t],meta:{percent:100}});var r=this.bytesWritten-e,n=function(e,t,r,n,i){var s=I.transformTo("string",i(n));return R.CENTRAL_DIRECTORY_END+"\0\0\0\0"+A(e,2)+A(e,2)+A(t,4)+A(r,4)+A(s.length,2)+s}(this.dirRecords.length,r,e,this.zipComment,this.encodeFileName);this.push({data:n,meta:{percent:100}})},s.prototype.prepareNextSource=function(){this.previous=this._sources.shift(),this.openedSource(this.previous.streamInfo),this.isPaused?this.previous.pause():this.previous.resume()},s.prototype.registerPrevious=function(e){this._sources.push(e);var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.closedSource(t.previous.streamInfo),t._sources.length?t.prepareNextSource():t.end()}),e.on("error",function(e){t.error(e)}),this},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this.previous&&this._sources.length?(this.prepareNextSource(),!0):this.previous||this._sources.length||this.generatedError?void 0:(this.end(),!0))},s.prototype.error=function(e){var t=this._sources;if(!i.prototype.error.call(this,e))return!1;for(var r=0;r<t.length;r++)try{t[r].error(e)}catch(e){}return!0},s.prototype.lock=function(){i.prototype.lock.call(this);for(var e=this._sources,t=0;t<e.length;t++)e[t].lock()},t.exports=s},{"../crc32":4,"../signature":23,"../stream/GenericWorker":28,"../utf8":31,"../utils":32}],9:[function(e,t,r){"use strict";var u=e("../compressions"),n=e("./ZipFileWorker");r.generateWorker=function(e,a,t){var o=new n(a.streamFiles,t,a.platform,a.encodeFileName),h=0;try{e.forEach(function(e,t){h++;var r=function(e,t){var r=e||t,n=u[r];if(!n)throw new Error(r+" is not a valid compression method !");return n}(t.options.compression,a.compression),n=t.options.compressionOptions||a.compressionOptions||{},i=t.dir,s=t.date;t._compressWorker(r,n).withStreamInfo("file",{name:e,dir:i,date:s,comment:t.comment||"",unixPermissions:t.unixPermissions,dosPermissions:t.dosPermissions}).pipe(o)}),o.entriesCount=h}catch(e){o.error(e)}return o}},{"../compressions":3,"./ZipFileWorker":8}],10:[function(e,t,r){"use strict";function n(){if(!(this instanceof n))return new n;if(arguments.length)throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");this.files=Object.create(null),this.comment=null,this.root="",this.clone=function(){var e=new n;for(var t in this)"function"!=typeof this[t]&&(e[t]=this[t]);return e}}(n.prototype=e("./object")).loadAsync=e("./load"),n.support=e("./support"),n.defaults=e("./defaults"),n.version="3.10.1",n.loadAsync=function(e,t){return(new n).loadAsync(e,t)},n.external=e("./external"),t.exports=n},{"./defaults":5,"./external":6,"./load":11,"./object":15,"./support":30}],11:[function(e,t,r){"use strict";var u=e("./utils"),i=e("./external"),n=e("./utf8"),s=e("./zipEntries"),a=e("./stream/Crc32Probe"),l=e("./nodejsUtils");function f(n){return new i.Promise(function(e,t){var r=n.decompressed.getContentWorker().pipe(new a);r.on("error",function(e){t(e)}).on("end",function(){r.streamInfo.crc32!==n.decompressed.crc32?t(new Error("Corrupted zip : CRC32 mismatch")):e()}).resume()})}t.exports=function(e,o){var h=this;return o=u.extend(o||{},{base64:!1,checkCRC32:!1,optimizedBinaryString:!1,createFolders:!1,decodeFileName:n.utf8decode}),l.isNode&&l.isStream(e)?i.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file.")):u.prepareContent("the loaded zip file",e,!0,o.optimizedBinaryString,o.base64).then(function(e){var t=new s(o);return t.load(e),t}).then(function(e){var t=[i.Promise.resolve(e)],r=e.files;if(o.checkCRC32)for(var n=0;n<r.length;n++)t.push(f(r[n]));return i.Promise.all(t)}).then(function(e){for(var t=e.shift(),r=t.files,n=0;n<r.length;n++){var i=r[n],s=i.fileNameStr,a=u.resolve(i.fileNameStr);h.file(a,i.decompressed,{binary:!0,optimizedBinaryString:!0,date:i.date,dir:i.dir,comment:i.fileCommentStr.length?i.fileCommentStr:null,unixPermissions:i.unixPermissions,dosPermissions:i.dosPermissions,createFolders:o.createFolders}),i.dir||(h.file(a).unsafeOriginalName=s)}return t.zipComment.length&&(h.comment=t.zipComment),h})}},{"./external":6,"./nodejsUtils":14,"./stream/Crc32Probe":25,"./utf8":31,"./utils":32,"./zipEntries":33}],12:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../stream/GenericWorker");function s(e,t){i.call(this,"Nodejs stream input adapter for "+e),this._upstreamEnded=!1,this._bindStream(t)}n.inherits(s,i),s.prototype._bindStream=function(e){var t=this;(this._stream=e).pause(),e.on("data",function(e){t.push({data:e,meta:{percent:0}})}).on("error",function(e){t.isPaused?this.generatedError=e:t.error(e)}).on("end",function(){t.isPaused?t._upstreamEnded=!0:t.end()})},s.prototype.pause=function(){return!!i.prototype.pause.call(this)&&(this._stream.pause(),!0)},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(this._upstreamEnded?this.end():this._stream.resume(),!0)},t.exports=s},{"../stream/GenericWorker":28,"../utils":32}],13:[function(e,t,r){"use strict";var i=e("readable-stream").Readable;function n(e,t,r){i.call(this,t),this._helper=e;var n=this;e.on("data",function(e,t){n.push(e)||n._helper.pause(),r&&r(t)}).on("error",function(e){n.emit("error",e)}).on("end",function(){n.push(null)})}e("../utils").inherits(n,i),n.prototype._read=function(){this._helper.resume()},t.exports=n},{"../utils":32,"readable-stream":16}],14:[function(e,t,r){"use strict";t.exports={isNode:"undefined"!=typeof Buffer,newBufferFrom:function(e,t){if(Buffer.from&&Buffer.from!==Uint8Array.from)return Buffer.from(e,t);if("number"==typeof e)throw new Error('The "data" argument must not be a number');return new Buffer(e,t)},allocBuffer:function(e){if(Buffer.alloc)return Buffer.alloc(e);var t=new Buffer(e);return t.fill(0),t},isBuffer:function(e){return Buffer.isBuffer(e)},isStream:function(e){return e&&"function"==typeof e.on&&"function"==typeof e.pause&&"function"==typeof e.resume}}},{}],15:[function(e,t,r){"use strict";function s(e,t,r){var n,i=u.getTypeOf(t),s=u.extend(r||{},f);s.date=s.date||new Date,null!==s.compression&&(s.compression=s.compression.toUpperCase()),"string"==typeof s.unixPermissions&&(s.unixPermissions=parseInt(s.unixPermissions,8)),s.unixPermissions&&16384&s.unixPermissions&&(s.dir=!0),s.dosPermissions&&16&s.dosPermissions&&(s.dir=!0),s.dir&&(e=g(e)),s.createFolders&&(n=_(e))&&b.call(this,n,!0);var a="string"===i&&!1===s.binary&&!1===s.base64;r&&void 0!==r.binary||(s.binary=!a),(t instanceof c&&0===t.uncompressedSize||s.dir||!t||0===t.length)&&(s.base64=!1,s.binary=!0,t="",s.compression="STORE",i="string");var o=null;o=t instanceof c||t instanceof l?t:p.isNode&&p.isStream(t)?new m(e,t):u.prepareContent(e,t,s.binary,s.optimizedBinaryString,s.base64);var h=new d(e,o,s);this.files[e]=h}var i=e("./utf8"),u=e("./utils"),l=e("./stream/GenericWorker"),a=e("./stream/StreamHelper"),f=e("./defaults"),c=e("./compressedObject"),d=e("./zipObject"),o=e("./generate"),p=e("./nodejsUtils"),m=e("./nodejs/NodejsStreamInputAdapter"),_=function(e){"/"===e.slice(-1)&&(e=e.substring(0,e.length-1));var t=e.lastIndexOf("/");return 0<t?e.substring(0,t):""},g=function(e){return"/"!==e.slice(-1)&&(e+="/"),e},b=function(e,t){return t=void 0!==t?t:f.createFolders,e=g(e),this.files[e]||s.call(this,e,null,{dir:!0,createFolders:t}),this.files[e]};function h(e){return"[object RegExp]"===Object.prototype.toString.call(e)}var n={load:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},forEach:function(e){var t,r,n;for(t in this.files)n=this.files[t],(r=t.slice(this.root.length,t.length))&&t.slice(0,this.root.length)===this.root&&e(r,n)},filter:function(r){var n=[];return this.forEach(function(e,t){r(e,t)&&n.push(t)}),n},file:function(e,t,r){if(1!==arguments.length)return e=this.root+e,s.call(this,e,t,r),this;if(h(e)){var n=e;return this.filter(function(e,t){return!t.dir&&n.test(e)})}var i=this.files[this.root+e];return i&&!i.dir?i:null},folder:function(r){if(!r)return this;if(h(r))return this.filter(function(e,t){return t.dir&&r.test(e)});var e=this.root+r,t=b.call(this,e),n=this.clone();return n.root=t.name,n},remove:function(r){r=this.root+r;var e=this.files[r];if(e||("/"!==r.slice(-1)&&(r+="/"),e=this.files[r]),e&&!e.dir)delete this.files[r];else for(var t=this.filter(function(e,t){return t.name.slice(0,r.length)===r}),n=0;n<t.length;n++)delete this.files[t[n].name];return this},generate:function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},generateInternalStream:function(e){var t,r={};try{if((r=u.extend(e||{},{streamFiles:!1,compression:"STORE",compressionOptions:null,type:"",platform:"DOS",comment:null,mimeType:"application/zip",encodeFileName:i.utf8encode})).type=r.type.toLowerCase(),r.compression=r.compression.toUpperCase(),"binarystring"===r.type&&(r.type="string"),!r.type)throw new Error("No output type specified.");u.checkSupport(r.type),"darwin"!==r.platform&&"freebsd"!==r.platform&&"linux"!==r.platform&&"sunos"!==r.platform||(r.platform="UNIX"),"win32"===r.platform&&(r.platform="DOS");var n=r.comment||this.comment||"";t=o.generateWorker(this,r,n)}catch(e){(t=new l("error")).error(e)}return new a(t,r.type||"string",r.mimeType)},generateAsync:function(e,t){return this.generateInternalStream(e).accumulate(t)},generateNodeStream:function(e,t){return(e=e||{}).type||(e.type="nodebuffer"),this.generateInternalStream(e).toNodejsStream(t)}};t.exports=n},{"./compressedObject":2,"./defaults":5,"./generate":9,"./nodejs/NodejsStreamInputAdapter":12,"./nodejsUtils":14,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31,"./utils":32,"./zipObject":35}],16:[function(e,t,r){"use strict";t.exports=e("stream")},{stream:void 0}],17:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e);for(var t=0;t<this.data.length;t++)e[t]=255&e[t]}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data[this.zero+e]},i.prototype.lastIndexOfSignature=function(e){for(var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.length-4;0<=s;--s)if(this.data[s]===t&&this.data[s+1]===r&&this.data[s+2]===n&&this.data[s+3]===i)return s-this.zero;return-1},i.prototype.readAndCheckSignature=function(e){var t=e.charCodeAt(0),r=e.charCodeAt(1),n=e.charCodeAt(2),i=e.charCodeAt(3),s=this.readData(4);return t===s[0]&&r===s[1]&&n===s[2]&&i===s[3]},i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return[];var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],18:[function(e,t,r){"use strict";var n=e("../utils");function i(e){this.data=e,this.length=e.length,this.index=0,this.zero=0}i.prototype={checkOffset:function(e){this.checkIndex(this.index+e)},checkIndex:function(e){if(this.length<this.zero+e||e<0)throw new Error("End of data reached (data length = "+this.length+", asked index = "+e+"). Corrupted zip ?")},setIndex:function(e){this.checkIndex(e),this.index=e},skip:function(e){this.setIndex(this.index+e)},byteAt:function(){},readInt:function(e){var t,r=0;for(this.checkOffset(e),t=this.index+e-1;t>=this.index;t--)r=(r<<8)+this.byteAt(t);return this.index+=e,r},readString:function(e){return n.transformTo("string",this.readData(e))},readData:function(){},lastIndexOfSignature:function(){},readAndCheckSignature:function(){},readDate:function(){var e=this.readInt(4);return new Date(Date.UTC(1980+(e>>25&127),(e>>21&15)-1,e>>16&31,e>>11&31,e>>5&63,(31&e)<<1))}},t.exports=i},{"../utils":32}],19:[function(e,t,r){"use strict";var n=e("./Uint8ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./Uint8ArrayReader":21}],20:[function(e,t,r){"use strict";var n=e("./DataReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.byteAt=function(e){return this.data.charCodeAt(this.zero+e)},i.prototype.lastIndexOfSignature=function(e){return this.data.lastIndexOf(e)-this.zero},i.prototype.readAndCheckSignature=function(e){return e===this.readData(4)},i.prototype.readData=function(e){this.checkOffset(e);var t=this.data.slice(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./DataReader":18}],21:[function(e,t,r){"use strict";var n=e("./ArrayReader");function i(e){n.call(this,e)}e("../utils").inherits(i,n),i.prototype.readData=function(e){if(this.checkOffset(e),0===e)return new Uint8Array(0);var t=this.data.subarray(this.zero+this.index,this.zero+this.index+e);return this.index+=e,t},t.exports=i},{"../utils":32,"./ArrayReader":17}],22:[function(e,t,r){"use strict";var n=e("../utils"),i=e("../support"),s=e("./ArrayReader"),a=e("./StringReader"),o=e("./NodeBufferReader"),h=e("./Uint8ArrayReader");t.exports=function(e){var t=n.getTypeOf(e);return n.checkSupport(t),"string"!==t||i.uint8array?"nodebuffer"===t?new o(e):i.uint8array?new h(n.transformTo("uint8array",e)):new s(n.transformTo("array",e)):new a(e)}},{"../support":30,"../utils":32,"./ArrayReader":17,"./NodeBufferReader":19,"./StringReader":20,"./Uint8ArrayReader":21}],23:[function(e,t,r){"use strict";r.LOCAL_FILE_HEADER="PK",r.CENTRAL_FILE_HEADER="PK",r.CENTRAL_DIRECTORY_END="PK",r.ZIP64_CENTRAL_DIRECTORY_LOCATOR="PK",r.ZIP64_CENTRAL_DIRECTORY_END="PK",r.DATA_DESCRIPTOR="PK\b"},{}],24:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../utils");function s(e){n.call(this,"ConvertWorker to "+e),this.destType=e}i.inherits(s,n),s.prototype.processChunk=function(e){this.push({data:i.transformTo(this.destType,e.data),meta:e.meta})},t.exports=s},{"../utils":32,"./GenericWorker":28}],25:[function(e,t,r){"use strict";var n=e("./GenericWorker"),i=e("../crc32");function s(){n.call(this,"Crc32Probe"),this.withStreamInfo("crc32",0)}e("../utils").inherits(s,n),s.prototype.processChunk=function(e){this.streamInfo.crc32=i(e.data,this.streamInfo.crc32||0),this.push(e)},t.exports=s},{"../crc32":4,"../utils":32,"./GenericWorker":28}],26:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataLengthProbe for "+e),this.propName=e,this.withStreamInfo(e,0)}n.inherits(s,i),s.prototype.processChunk=function(e){if(e){var t=this.streamInfo[this.propName]||0;this.streamInfo[this.propName]=t+e.data.length}i.prototype.processChunk.call(this,e)},t.exports=s},{"../utils":32,"./GenericWorker":28}],27:[function(e,t,r){"use strict";var n=e("../utils"),i=e("./GenericWorker");function s(e){i.call(this,"DataWorker");var t=this;this.dataIsReady=!1,this.index=0,this.max=0,this.data=null,this.type="",this._tickScheduled=!1,e.then(function(e){t.dataIsReady=!0,t.data=e,t.max=e&&e.length||0,t.type=n.getTypeOf(e),t.isPaused||t._tickAndRepeat()},function(e){t.error(e)})}n.inherits(s,i),s.prototype.cleanUp=function(){i.prototype.cleanUp.call(this),this.data=null},s.prototype.resume=function(){return!!i.prototype.resume.call(this)&&(!this._tickScheduled&&this.dataIsReady&&(this._tickScheduled=!0,n.delay(this._tickAndRepeat,[],this)),!0)},s.prototype._tickAndRepeat=function(){this._tickScheduled=!1,this.isPaused||this.isFinished||(this._tick(),this.isFinished||(n.delay(this._tickAndRepeat,[],this),this._tickScheduled=!0))},s.prototype._tick=function(){if(this.isPaused||this.isFinished)return!1;var e=null,t=Math.min(this.max,this.index+16384);if(this.index>=this.max)return this.end();switch(this.type){case"string":e=this.data.substring(this.index,t);break;case"uint8array":e=this.data.subarray(this.index,t);break;case"array":case"nodebuffer":e=this.data.slice(this.index,t)}return this.index=t,this.push({data:e,meta:{percent:this.max?this.index/this.max*100:0}})},t.exports=s},{"../utils":32,"./GenericWorker":28}],28:[function(e,t,r){"use strict";function n(e){this.name=e||"default",this.streamInfo={},this.generatedError=null,this.extraStreamInfo={},this.isPaused=!0,this.isFinished=!1,this.isLocked=!1,this._listeners={data:[],end:[],error:[]},this.previous=null}n.prototype={push:function(e){this.emit("data",e)},end:function(){if(this.isFinished)return!1;this.flush();try{this.emit("end"),this.cleanUp(),this.isFinished=!0}catch(e){this.emit("error",e)}return!0},error:function(e){return!this.isFinished&&(this.isPaused?this.generatedError=e:(this.isFinished=!0,this.emit("error",e),this.previous&&this.previous.error(e),this.cleanUp()),!0)},on:function(e,t){return this._listeners[e].push(t),this},cleanUp:function(){this.streamInfo=this.generatedError=this.extraStreamInfo=null,this._listeners=[]},emit:function(e,t){if(this._listeners[e])for(var r=0;r<this._listeners[e].length;r++)this._listeners[e][r].call(this,t)},pipe:function(e){return e.registerPrevious(this)},registerPrevious:function(e){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.streamInfo=e.streamInfo,this.mergeStreamInfo(),this.previous=e;var t=this;return e.on("data",function(e){t.processChunk(e)}),e.on("end",function(){t.end()}),e.on("error",function(e){t.error(e)}),this},pause:function(){return!this.isPaused&&!this.isFinished&&(this.isPaused=!0,this.previous&&this.previous.pause(),!0)},resume:function(){if(!this.isPaused||this.isFinished)return!1;var e=this.isPaused=!1;return this.generatedError&&(this.error(this.generatedError),e=!0),this.previous&&this.previous.resume(),!e},flush:function(){},processChunk:function(e){this.push(e)},withStreamInfo:function(e,t){return this.extraStreamInfo[e]=t,this.mergeStreamInfo(),this},mergeStreamInfo:function(){for(var e in this.extraStreamInfo)Object.prototype.hasOwnProperty.call(this.extraStreamInfo,e)&&(this.streamInfo[e]=this.extraStreamInfo[e])},lock:function(){if(this.isLocked)throw new Error("The stream '"+this+"' has already been used.");this.isLocked=!0,this.previous&&this.previous.lock()},toString:function(){var e="Worker "+this.name;return this.previous?this.previous+" -> "+e:e}},t.exports=n},{}],29:[function(e,t,r){"use strict";var h=e("../utils"),i=e("./ConvertWorker"),s=e("./GenericWorker"),u=e("../base64"),n=e("../support"),a=e("../external"),o=null;if(n.nodestream)try{o=e("../nodejs/NodejsStreamOutputAdapter")}catch(e){}function l(e,o){return new a.Promise(function(t,r){var n=[],i=e._internalType,s=e._outputType,a=e._mimeType;e.on("data",function(e,t){n.push(e),o&&o(t)}).on("error",function(e){n=[],r(e)}).on("end",function(){try{var e=function(e,t,r){switch(e){case"blob":return h.newBlob(h.transformTo("arraybuffer",t),r);case"base64":return u.encode(t);default:return h.transformTo(e,t)}}(s,function(e,t){var r,n=0,i=null,s=0;for(r=0;r<t.length;r++)s+=t[r].length;switch(e){case"string":return t.join("");case"array":return Array.prototype.concat.apply([],t);case"uint8array":for(i=new Uint8Array(s),r=0;r<t.length;r++)i.set(t[r],n),n+=t[r].length;return i;case"nodebuffer":return Buffer.concat(t);default:throw new Error("concat : unsupported type '"+e+"'")}}(i,n),a);t(e)}catch(e){r(e)}n=[]}).resume()})}function f(e,t,r){var n=t;switch(t){case"blob":case"arraybuffer":n="uint8array";break;case"base64":n="string"}try{this._internalType=n,this._outputType=t,this._mimeType=r,h.checkSupport(n),this._worker=e.pipe(new i(n)),e.lock()}catch(e){this._worker=new s("error"),this._worker.error(e)}}f.prototype={accumulate:function(e){return l(this,e)},on:function(e,t){var r=this;return"data"===e?this._worker.on(e,function(e){t.call(r,e.data,e.meta)}):this._worker.on(e,function(){h.delay(t,arguments,r)}),this},resume:function(){return h.delay(this._worker.resume,[],this._worker),this},pause:function(){return this._worker.pause(),this},toNodejsStream:function(e){if(h.checkSupport("nodestream"),"nodebuffer"!==this._outputType)throw new Error(this._outputType+" is not supported by this method");return new o(this,{objectMode:"nodebuffer"!==this._outputType},e)}},t.exports=f},{"../base64":1,"../external":6,"../nodejs/NodejsStreamOutputAdapter":13,"../support":30,"../utils":32,"./ConvertWorker":24,"./GenericWorker":28}],30:[function(e,t,r){"use strict";if(r.base64=!0,r.array=!0,r.string=!0,r.arraybuffer="undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array,r.nodebuffer="undefined"!=typeof Buffer,r.uint8array="undefined"!=typeof Uint8Array,"undefined"==typeof ArrayBuffer)r.blob=!1;else{var n=new ArrayBuffer(0);try{r.blob=0===new Blob([n],{type:"application/zip"}).size}catch(e){try{var i=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);i.append(n),r.blob=0===i.getBlob("application/zip").size}catch(e){r.blob=!1}}}try{r.nodestream=!!e("readable-stream").Readable}catch(e){r.nodestream=!1}},{"readable-stream":16}],31:[function(e,t,s){"use strict";for(var o=e("./utils"),h=e("./support"),r=e("./nodejsUtils"),n=e("./stream/GenericWorker"),u=new Array(256),i=0;i<256;i++)u[i]=252<=i?6:248<=i?5:240<=i?4:224<=i?3:192<=i?2:1;u[254]=u[254]=1;function a(){n.call(this,"utf-8 decode"),this.leftOver=null}function l(){n.call(this,"utf-8 encode")}s.utf8encode=function(e){return h.nodebuffer?r.newBufferFrom(e,"utf-8"):function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=h.uint8array?new Uint8Array(o):new Array(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t}(e)},s.utf8decode=function(e){return h.nodebuffer?o.transformTo("nodebuffer",e).toString("utf-8"):function(e){var t,r,n,i,s=e.length,a=new Array(2*s);for(t=r=0;t<s;)if((n=e[t++])<128)a[r++]=n;else if(4<(i=u[n]))a[r++]=65533,t+=i-1;else{for(n&=2===i?31:3===i?15:7;1<i&&t<s;)n=n<<6|63&e[t++],i--;1<i?a[r++]=65533:n<65536?a[r++]=n:(n-=65536,a[r++]=55296|n>>10&1023,a[r++]=56320|1023&n)}return a.length!==r&&(a.subarray?a=a.subarray(0,r):a.length=r),o.applyFromCharCode(a)}(e=o.transformTo(h.uint8array?"uint8array":"array",e))},o.inherits(a,n),a.prototype.processChunk=function(e){var t=o.transformTo(h.uint8array?"uint8array":"array",e.data);if(this.leftOver&&this.leftOver.length){if(h.uint8array){var r=t;(t=new Uint8Array(r.length+this.leftOver.length)).set(this.leftOver,0),t.set(r,this.leftOver.length)}else t=this.leftOver.concat(t);this.leftOver=null}var n=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}(t),i=t;n!==t.length&&(h.uint8array?(i=t.subarray(0,n),this.leftOver=t.subarray(n,t.length)):(i=t.slice(0,n),this.leftOver=t.slice(n,t.length))),this.push({data:s.utf8decode(i),meta:e.meta})},a.prototype.flush=function(){this.leftOver&&this.leftOver.length&&(this.push({data:s.utf8decode(this.leftOver),meta:{}}),this.leftOver=null)},s.Utf8DecodeWorker=a,o.inherits(l,n),l.prototype.processChunk=function(e){this.push({data:s.utf8encode(e.data),meta:e.meta})},s.Utf8EncodeWorker=l},{"./nodejsUtils":14,"./stream/GenericWorker":28,"./support":30,"./utils":32}],32:[function(e,t,a){"use strict";var o=e("./support"),h=e("./base64"),r=e("./nodejsUtils"),u=e("./external");function n(e){return e}function l(e,t){for(var r=0;r<e.length;++r)t[r]=255&e.charCodeAt(r);return t}e("setimmediate"),a.newBlob=function(t,r){a.checkSupport("blob");try{return new Blob([t],{type:r})}catch(e){try{var n=new(self.BlobBuilder||self.WebKitBlobBuilder||self.MozBlobBuilder||self.MSBlobBuilder);return n.append(t),n.getBlob(r)}catch(e){throw new Error("Bug : can't construct the Blob.")}}};var i={stringifyByChunk:function(e,t,r){var n=[],i=0,s=e.length;if(s<=r)return String.fromCharCode.apply(null,e);for(;i<s;)"array"===t||"nodebuffer"===t?n.push(String.fromCharCode.apply(null,e.slice(i,Math.min(i+r,s)))):n.push(String.fromCharCode.apply(null,e.subarray(i,Math.min(i+r,s)))),i+=r;return n.join("")},stringifyByChar:function(e){for(var t="",r=0;r<e.length;r++)t+=String.fromCharCode(e[r]);return t},applyCanBeUsed:{uint8array:function(){try{return o.uint8array&&1===String.fromCharCode.apply(null,new Uint8Array(1)).length}catch(e){return!1}}(),nodebuffer:function(){try{return o.nodebuffer&&1===String.fromCharCode.apply(null,r.allocBuffer(1)).length}catch(e){return!1}}()}};function s(e){var t=65536,r=a.getTypeOf(e),n=!0;if("uint8array"===r?n=i.applyCanBeUsed.uint8array:"nodebuffer"===r&&(n=i.applyCanBeUsed.nodebuffer),n)for(;1<t;)try{return i.stringifyByChunk(e,r,t)}catch(e){t=Math.floor(t/2)}return i.stringifyByChar(e)}function f(e,t){for(var r=0;r<e.length;r++)t[r]=e[r];return t}a.applyFromCharCode=s;var c={};c.string={string:n,array:function(e){return l(e,new Array(e.length))},arraybuffer:function(e){return c.string.uint8array(e).buffer},uint8array:function(e){return l(e,new Uint8Array(e.length))},nodebuffer:function(e){return l(e,r.allocBuffer(e.length))}},c.array={string:s,array:n,arraybuffer:function(e){return new Uint8Array(e).buffer},uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(e)}},c.arraybuffer={string:function(e){return s(new Uint8Array(e))},array:function(e){return f(new Uint8Array(e),new Array(e.byteLength))},arraybuffer:n,uint8array:function(e){return new Uint8Array(e)},nodebuffer:function(e){return r.newBufferFrom(new Uint8Array(e))}},c.uint8array={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return e.buffer},uint8array:n,nodebuffer:function(e){return r.newBufferFrom(e)}},c.nodebuffer={string:s,array:function(e){return f(e,new Array(e.length))},arraybuffer:function(e){return c.nodebuffer.uint8array(e).buffer},uint8array:function(e){return f(e,new Uint8Array(e.length))},nodebuffer:n},a.transformTo=function(e,t){if(t=t||"",!e)return t;a.checkSupport(e);var r=a.getTypeOf(t);return c[r][e](t)},a.resolve=function(e){for(var t=e.split("/"),r=[],n=0;n<t.length;n++){var i=t[n];"."===i||""===i&&0!==n&&n!==t.length-1||(".."===i?r.pop():r.push(i))}return r.join("/")},a.getTypeOf=function(e){return"string"==typeof e?"string":"[object Array]"===Object.prototype.toString.call(e)?"array":o.nodebuffer&&r.isBuffer(e)?"nodebuffer":o.uint8array&&e instanceof Uint8Array?"uint8array":o.arraybuffer&&e instanceof ArrayBuffer?"arraybuffer":void 0},a.checkSupport=function(e){if(!o[e.toLowerCase()])throw new Error(e+" is not supported by this platform")},a.MAX_VALUE_16BITS=65535,a.MAX_VALUE_32BITS=-1,a.pretty=function(e){var t,r,n="";for(r=0;r<(e||"").length;r++)n+="\\x"+((t=e.charCodeAt(r))<16?"0":"")+t.toString(16).toUpperCase();return n},a.delay=function(e,t,r){setImmediate(function(){e.apply(r||null,t||[])})},a.inherits=function(e,t){function r(){}r.prototype=t.prototype,e.prototype=new r},a.extend=function(){var e,t,r={};for(e=0;e<arguments.length;e++)for(t in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],t)&&void 0===r[t]&&(r[t]=arguments[e][t]);return r},a.prepareContent=function(r,e,n,i,s){return u.Promise.resolve(e).then(function(n){return o.blob&&(n instanceof Blob||-1!==["[object File]","[object Blob]"].indexOf(Object.prototype.toString.call(n)))&&"undefined"!=typeof FileReader?new u.Promise(function(t,r){var e=new FileReader;e.onload=function(e){t(e.target.result)},e.onerror=function(e){r(e.target.error)},e.readAsArrayBuffer(n)}):n}).then(function(e){var t=a.getTypeOf(e);return t?("arraybuffer"===t?e=a.transformTo("uint8array",e):"string"===t&&(s?e=h.decode(e):n&&!0!==i&&(e=function(e){return l(e,o.uint8array?new Uint8Array(e.length):new Array(e.length))}(e))),e):u.Promise.reject(new Error("Can't read the data of '"+r+"'. Is it in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"))})}},{"./base64":1,"./external":6,"./nodejsUtils":14,"./support":30,setimmediate:54}],33:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),i=e("./utils"),s=e("./signature"),a=e("./zipEntry"),o=e("./support");function h(e){this.files=[],this.loadOptions=e}h.prototype={checkSignature:function(e){if(!this.reader.readAndCheckSignature(e)){this.reader.index-=4;var t=this.reader.readString(4);throw new Error("Corrupted zip or bug: unexpected signature ("+i.pretty(t)+", expected "+i.pretty(e)+")")}},isSignature:function(e,t){var r=this.reader.index;this.reader.setIndex(e);var n=this.reader.readString(4)===t;return this.reader.setIndex(r),n},readBlockEndOfCentral:function(){this.diskNumber=this.reader.readInt(2),this.diskWithCentralDirStart=this.reader.readInt(2),this.centralDirRecordsOnThisDisk=this.reader.readInt(2),this.centralDirRecords=this.reader.readInt(2),this.centralDirSize=this.reader.readInt(4),this.centralDirOffset=this.reader.readInt(4),this.zipCommentLength=this.reader.readInt(2);var e=this.reader.readData(this.zipCommentLength),t=o.uint8array?"uint8array":"array",r=i.transformTo(t,e);this.zipComment=this.loadOptions.decodeFileName(r)},readBlockZip64EndOfCentral:function(){this.zip64EndOfCentralSize=this.reader.readInt(8),this.reader.skip(4),this.diskNumber=this.reader.readInt(4),this.diskWithCentralDirStart=this.reader.readInt(4),this.centralDirRecordsOnThisDisk=this.reader.readInt(8),this.centralDirRecords=this.reader.readInt(8),this.centralDirSize=this.reader.readInt(8),this.centralDirOffset=this.reader.readInt(8),this.zip64ExtensibleData={};for(var e,t,r,n=this.zip64EndOfCentralSize-44;0<n;)e=this.reader.readInt(2),t=this.reader.readInt(4),r=this.reader.readData(t),this.zip64ExtensibleData[e]={id:e,length:t,value:r}},readBlockZip64EndOfCentralLocator:function(){if(this.diskWithZip64CentralDirStart=this.reader.readInt(4),this.relativeOffsetEndOfZip64CentralDir=this.reader.readInt(8),this.disksCount=this.reader.readInt(4),1<this.disksCount)throw new Error("Multi-volumes zip are not supported")},readLocalFiles:function(){var e,t;for(e=0;e<this.files.length;e++)t=this.files[e],this.reader.setIndex(t.localHeaderOffset),this.checkSignature(s.LOCAL_FILE_HEADER),t.readLocalPart(this.reader),t.handleUTF8(),t.processAttributes()},readCentralDir:function(){var e;for(this.reader.setIndex(this.centralDirOffset);this.reader.readAndCheckSignature(s.CENTRAL_FILE_HEADER);)(e=new a({zip64:this.zip64},this.loadOptions)).readCentralPart(this.reader),this.files.push(e);if(this.centralDirRecords!==this.files.length&&0!==this.centralDirRecords&&0===this.files.length)throw new Error("Corrupted zip or bug: expected "+this.centralDirRecords+" records in central dir, got "+this.files.length)},readEndOfCentral:function(){var e=this.reader.lastIndexOfSignature(s.CENTRAL_DIRECTORY_END);if(e<0)throw!this.isSignature(0,s.LOCAL_FILE_HEADER)?new Error("Can't find end of central directory : is this a zip file ? If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html"):new Error("Corrupted zip: can't find end of central directory");this.reader.setIndex(e);var t=e;if(this.checkSignature(s.CENTRAL_DIRECTORY_END),this.readBlockEndOfCentral(),this.diskNumber===i.MAX_VALUE_16BITS||this.diskWithCentralDirStart===i.MAX_VALUE_16BITS||this.centralDirRecordsOnThisDisk===i.MAX_VALUE_16BITS||this.centralDirRecords===i.MAX_VALUE_16BITS||this.centralDirSize===i.MAX_VALUE_32BITS||this.centralDirOffset===i.MAX_VALUE_32BITS){if(this.zip64=!0,(e=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR))<0)throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");if(this.reader.setIndex(e),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_LOCATOR),this.readBlockZip64EndOfCentralLocator(),!this.isSignature(this.relativeOffsetEndOfZip64CentralDir,s.ZIP64_CENTRAL_DIRECTORY_END)&&(this.relativeOffsetEndOfZip64CentralDir=this.reader.lastIndexOfSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.relativeOffsetEndOfZip64CentralDir<0))throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir),this.checkSignature(s.ZIP64_CENTRAL_DIRECTORY_END),this.readBlockZip64EndOfCentral()}var r=this.centralDirOffset+this.centralDirSize;this.zip64&&(r+=20,r+=12+this.zip64EndOfCentralSize);var n=t-r;if(0<n)this.isSignature(t,s.CENTRAL_FILE_HEADER)||(this.reader.zero=n);else if(n<0)throw new Error("Corrupted zip: missing "+Math.abs(n)+" bytes.")},prepareReader:function(e){this.reader=n(e)},load:function(e){this.prepareReader(e),this.readEndOfCentral(),this.readCentralDir(),this.readLocalFiles()}},t.exports=h},{"./reader/readerFor":22,"./signature":23,"./support":30,"./utils":32,"./zipEntry":34}],34:[function(e,t,r){"use strict";var n=e("./reader/readerFor"),s=e("./utils"),i=e("./compressedObject"),a=e("./crc32"),o=e("./utf8"),h=e("./compressions"),u=e("./support");function l(e,t){this.options=e,this.loadOptions=t}l.prototype={isEncrypted:function(){return 1==(1&this.bitFlag)},useUTF8:function(){return 2048==(2048&this.bitFlag)},readLocalPart:function(e){var t,r;if(e.skip(22),this.fileNameLength=e.readInt(2),r=e.readInt(2),this.fileName=e.readData(this.fileNameLength),e.skip(r),-1===this.compressedSize||-1===this.uncompressedSize)throw new Error("Bug or corrupted zip : didn't get enough information from the central directory (compressedSize === -1 || uncompressedSize === -1)");if(null===(t=function(e){for(var t in h)if(Object.prototype.hasOwnProperty.call(h,t)&&h[t].magic===e)return h[t];return null}(this.compressionMethod)))throw new Error("Corrupted zip : compression "+s.pretty(this.compressionMethod)+" unknown (inner file : "+s.transformTo("string",this.fileName)+")");this.decompressed=new i(this.compressedSize,this.uncompressedSize,this.crc32,t,e.readData(this.compressedSize))},readCentralPart:function(e){this.versionMadeBy=e.readInt(2),e.skip(2),this.bitFlag=e.readInt(2),this.compressionMethod=e.readString(2),this.date=e.readDate(),this.crc32=e.readInt(4),this.compressedSize=e.readInt(4),this.uncompressedSize=e.readInt(4);var t=e.readInt(2);if(this.extraFieldsLength=e.readInt(2),this.fileCommentLength=e.readInt(2),this.diskNumberStart=e.readInt(2),this.internalFileAttributes=e.readInt(2),this.externalFileAttributes=e.readInt(4),this.localHeaderOffset=e.readInt(4),this.isEncrypted())throw new Error("Encrypted zip are not supported");e.skip(t),this.readExtraFields(e),this.parseZIP64ExtraField(e),this.fileComment=e.readData(this.fileCommentLength)},processAttributes:function(){this.unixPermissions=null,this.dosPermissions=null;var e=this.versionMadeBy>>8;this.dir=!!(16&this.externalFileAttributes),0==e&&(this.dosPermissions=63&this.externalFileAttributes),3==e&&(this.unixPermissions=this.externalFileAttributes>>16&65535),this.dir||"/"!==this.fileNameStr.slice(-1)||(this.dir=!0)},parseZIP64ExtraField:function(){if(this.extraFields[1]){var e=n(this.extraFields[1].value);this.uncompressedSize===s.MAX_VALUE_32BITS&&(this.uncompressedSize=e.readInt(8)),this.compressedSize===s.MAX_VALUE_32BITS&&(this.compressedSize=e.readInt(8)),this.localHeaderOffset===s.MAX_VALUE_32BITS&&(this.localHeaderOffset=e.readInt(8)),this.diskNumberStart===s.MAX_VALUE_32BITS&&(this.diskNumberStart=e.readInt(4))}},readExtraFields:function(e){var t,r,n,i=e.index+this.extraFieldsLength;for(this.extraFields||(this.extraFields={});e.index+4<i;)t=e.readInt(2),r=e.readInt(2),n=e.readData(r),this.extraFields[t]={id:t,length:r,value:n};e.setIndex(i)},handleUTF8:function(){var e=u.uint8array?"uint8array":"array";if(this.useUTF8())this.fileNameStr=o.utf8decode(this.fileName),this.fileCommentStr=o.utf8decode(this.fileComment);else{var t=this.findExtraFieldUnicodePath();if(null!==t)this.fileNameStr=t;else{var r=s.transformTo(e,this.fileName);this.fileNameStr=this.loadOptions.decodeFileName(r)}var n=this.findExtraFieldUnicodeComment();if(null!==n)this.fileCommentStr=n;else{var i=s.transformTo(e,this.fileComment);this.fileCommentStr=this.loadOptions.decodeFileName(i)}}},findExtraFieldUnicodePath:function(){var e=this.extraFields[28789];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileName)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null},findExtraFieldUnicodeComment:function(){var e=this.extraFields[25461];if(e){var t=n(e.value);return 1!==t.readInt(1)?null:a(this.fileComment)!==t.readInt(4)?null:o.utf8decode(t.readData(e.length-5))}return null}},t.exports=l},{"./compressedObject":2,"./compressions":3,"./crc32":4,"./reader/readerFor":22,"./support":30,"./utf8":31,"./utils":32}],35:[function(e,t,r){"use strict";function n(e,t,r){this.name=e,this.dir=r.dir,this.date=r.date,this.comment=r.comment,this.unixPermissions=r.unixPermissions,this.dosPermissions=r.dosPermissions,this._data=t,this._dataBinary=r.binary,this.options={compression:r.compression,compressionOptions:r.compressionOptions}}var s=e("./stream/StreamHelper"),i=e("./stream/DataWorker"),a=e("./utf8"),o=e("./compressedObject"),h=e("./stream/GenericWorker");n.prototype={internalStream:function(e){var t=null,r="string";try{if(!e)throw new Error("No output type specified.");var n="string"===(r=e.toLowerCase())||"text"===r;"binarystring"!==r&&"text"!==r||(r="string"),t=this._decompressWorker();var i=!this._dataBinary;i&&!n&&(t=t.pipe(new a.Utf8EncodeWorker)),!i&&n&&(t=t.pipe(new a.Utf8DecodeWorker))}catch(e){(t=new h("error")).error(e)}return new s(t,r,"")},async:function(e,t){return this.internalStream(e).accumulate(t)},nodeStream:function(e,t){return this.internalStream(e||"nodebuffer").toNodejsStream(t)},_compressWorker:function(e,t){if(this._data instanceof o&&this._data.compression.magic===e.magic)return this._data.getCompressedWorker();var r=this._decompressWorker();return this._dataBinary||(r=r.pipe(new a.Utf8EncodeWorker)),o.createWorkerFrom(r,e,t)},_decompressWorker:function(){return this._data instanceof o?this._data.getContentWorker():this._data instanceof h?this._data:new i(this._data)}};for(var u=["asText","asBinary","asNodeBuffer","asUint8Array","asArrayBuffer"],l=function(){throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.")},f=0;f<u.length;f++)n.prototype[u[f]]=l;t.exports=n},{"./compressedObject":2,"./stream/DataWorker":27,"./stream/GenericWorker":28,"./stream/StreamHelper":29,"./utf8":31}],36:[function(e,l,t){(function(t){"use strict";var r,n,e=t.MutationObserver||t.WebKitMutationObserver;if(e){var i=0,s=new e(u),a=t.document.createTextNode("");s.observe(a,{characterData:!0}),r=function(){a.data=i=++i%2}}else if(t.setImmediate||void 0===t.MessageChannel)r="document"in t&&"onreadystatechange"in t.document.createElement("script")?function(){var e=t.document.createElement("script");e.onreadystatechange=function(){u(),e.onreadystatechange=null,e.parentNode.removeChild(e),e=null},t.document.documentElement.appendChild(e)}:function(){setTimeout(u,0)};else{var o=new t.MessageChannel;o.port1.onmessage=u,r=function(){o.port2.postMessage(0)}}var h=[];function u(){var e,t;n=!0;for(var r=h.length;r;){for(t=h,h=[],e=-1;++e<r;)t[e]();r=h.length}n=!1}l.exports=function(e){1!==h.push(e)||n||r()}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],37:[function(e,t,r){"use strict";var i=e("immediate");function u(){}var l={},s=["REJECTED"],a=["FULFILLED"],n=["PENDING"];function o(e){if("function"!=typeof e)throw new TypeError("resolver must be a function");this.state=n,this.queue=[],this.outcome=void 0,e!==u&&d(this,e)}function h(e,t,r){this.promise=e,"function"==typeof t&&(this.onFulfilled=t,this.callFulfilled=this.otherCallFulfilled),"function"==typeof r&&(this.onRejected=r,this.callRejected=this.otherCallRejected)}function f(t,r,n){i(function(){var e;try{e=r(n)}catch(e){return l.reject(t,e)}e===t?l.reject(t,new TypeError("Cannot resolve promise with itself")):l.resolve(t,e)})}function c(e){var t=e&&e.then;if(e&&("object"==typeof e||"function"==typeof e)&&"function"==typeof t)return function(){t.apply(e,arguments)}}function d(t,e){var r=!1;function n(e){r||(r=!0,l.reject(t,e))}function i(e){r||(r=!0,l.resolve(t,e))}var s=p(function(){e(i,n)});"error"===s.status&&n(s.value)}function p(e,t){var r={};try{r.value=e(t),r.status="success"}catch(e){r.status="error",r.value=e}return r}(t.exports=o).prototype.finally=function(t){if("function"!=typeof t)return this;var r=this.constructor;return this.then(function(e){return r.resolve(t()).then(function(){return e})},function(e){return r.resolve(t()).then(function(){throw e})})},o.prototype.catch=function(e){return this.then(null,e)},o.prototype.then=function(e,t){if("function"!=typeof e&&this.state===a||"function"!=typeof t&&this.state===s)return this;var r=new this.constructor(u);this.state!==n?f(r,this.state===a?e:t,this.outcome):this.queue.push(new h(r,e,t));return r},h.prototype.callFulfilled=function(e){l.resolve(this.promise,e)},h.prototype.otherCallFulfilled=function(e){f(this.promise,this.onFulfilled,e)},h.prototype.callRejected=function(e){l.reject(this.promise,e)},h.prototype.otherCallRejected=function(e){f(this.promise,this.onRejected,e)},l.resolve=function(e,t){var r=p(c,t);if("error"===r.status)return l.reject(e,r.value);var n=r.value;if(n)d(e,n);else{e.state=a,e.outcome=t;for(var i=-1,s=e.queue.length;++i<s;)e.queue[i].callFulfilled(t)}return e},l.reject=function(e,t){e.state=s,e.outcome=t;for(var r=-1,n=e.queue.length;++r<n;)e.queue[r].callRejected(t);return e},o.resolve=function(e){if(e instanceof this)return e;return l.resolve(new this(u),e)},o.reject=function(e){var t=new this(u);return l.reject(t,e)},o.all=function(e){var r=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var n=e.length,i=!1;if(!n)return this.resolve([]);var s=new Array(n),a=0,t=-1,o=new this(u);for(;++t<n;)h(e[t],t);return o;function h(e,t){r.resolve(e).then(function(e){s[t]=e,++a!==n||i||(i=!0,l.resolve(o,s))},function(e){i||(i=!0,l.reject(o,e))})}},o.race=function(e){var t=this;if("[object Array]"!==Object.prototype.toString.call(e))return this.reject(new TypeError("must be an array"));var r=e.length,n=!1;if(!r)return this.resolve([]);var i=-1,s=new this(u);for(;++i<r;)a=e[i],t.resolve(a).then(function(e){n||(n=!0,l.resolve(s,e))},function(e){n||(n=!0,l.reject(s,e))});var a;return s}},{immediate:36}],38:[function(e,t,r){"use strict";var n={};(0,e("./lib/utils/common").assign)(n,e("./lib/deflate"),e("./lib/inflate"),e("./lib/zlib/constants")),t.exports=n},{"./lib/deflate":39,"./lib/inflate":40,"./lib/utils/common":41,"./lib/zlib/constants":44}],39:[function(e,t,r){"use strict";var a=e("./zlib/deflate"),o=e("./utils/common"),h=e("./utils/strings"),i=e("./zlib/messages"),s=e("./zlib/zstream"),u=Object.prototype.toString,l=0,f=-1,c=0,d=8;function p(e){if(!(this instanceof p))return new p(e);this.options=o.assign({level:f,method:d,chunkSize:16384,windowBits:15,memLevel:8,strategy:c,to:""},e||{});var t=this.options;t.raw&&0<t.windowBits?t.windowBits=-t.windowBits:t.gzip&&0<t.windowBits&&t.windowBits<16&&(t.windowBits+=16),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new s,this.strm.avail_out=0;var r=a.deflateInit2(this.strm,t.level,t.method,t.windowBits,t.memLevel,t.strategy);if(r!==l)throw new Error(i[r]);if(t.header&&a.deflateSetHeader(this.strm,t.header),t.dictionary){var n;if(n="string"==typeof t.dictionary?h.string2buf(t.dictionary):"[object ArrayBuffer]"===u.call(t.dictionary)?new Uint8Array(t.dictionary):t.dictionary,(r=a.deflateSetDictionary(this.strm,n))!==l)throw new Error(i[r]);this._dict_set=!0}}function n(e,t){var r=new p(t);if(r.push(e,!0),r.err)throw r.msg||i[r.err];return r.result}p.prototype.push=function(e,t){var r,n,i=this.strm,s=this.options.chunkSize;if(this.ended)return!1;n=t===~~t?t:!0===t?4:0,"string"==typeof e?i.input=h.string2buf(e):"[object ArrayBuffer]"===u.call(e)?i.input=new Uint8Array(e):i.input=e,i.next_in=0,i.avail_in=i.input.length;do{if(0===i.avail_out&&(i.output=new o.Buf8(s),i.next_out=0,i.avail_out=s),1!==(r=a.deflate(i,n))&&r!==l)return this.onEnd(r),!(this.ended=!0);0!==i.avail_out&&(0!==i.avail_in||4!==n&&2!==n)||("string"===this.options.to?this.onData(h.buf2binstring(o.shrinkBuf(i.output,i.next_out))):this.onData(o.shrinkBuf(i.output,i.next_out)))}while((0<i.avail_in||0===i.avail_out)&&1!==r);return 4===n?(r=a.deflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===l):2!==n||(this.onEnd(l),!(i.avail_out=0))},p.prototype.onData=function(e){this.chunks.push(e)},p.prototype.onEnd=function(e){e===l&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=o.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Deflate=p,r.deflate=n,r.deflateRaw=function(e,t){return(t=t||{}).raw=!0,n(e,t)},r.gzip=function(e,t){return(t=t||{}).gzip=!0,n(e,t)}},{"./utils/common":41,"./utils/strings":42,"./zlib/deflate":46,"./zlib/messages":51,"./zlib/zstream":53}],40:[function(e,t,r){"use strict";var c=e("./zlib/inflate"),d=e("./utils/common"),p=e("./utils/strings"),m=e("./zlib/constants"),n=e("./zlib/messages"),i=e("./zlib/zstream"),s=e("./zlib/gzheader"),_=Object.prototype.toString;function a(e){if(!(this instanceof a))return new a(e);this.options=d.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&0<=t.windowBits&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(0<=t.windowBits&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),15<t.windowBits&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new i,this.strm.avail_out=0;var r=c.inflateInit2(this.strm,t.windowBits);if(r!==m.Z_OK)throw new Error(n[r]);this.header=new s,c.inflateGetHeader(this.strm,this.header)}function o(e,t){var r=new a(t);if(r.push(e,!0),r.err)throw r.msg||n[r.err];return r.result}a.prototype.push=function(e,t){var r,n,i,s,a,o,h=this.strm,u=this.options.chunkSize,l=this.options.dictionary,f=!1;if(this.ended)return!1;n=t===~~t?t:!0===t?m.Z_FINISH:m.Z_NO_FLUSH,"string"==typeof e?h.input=p.binstring2buf(e):"[object ArrayBuffer]"===_.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new d.Buf8(u),h.next_out=0,h.avail_out=u),(r=c.inflate(h,m.Z_NO_FLUSH))===m.Z_NEED_DICT&&l&&(o="string"==typeof l?p.string2buf(l):"[object ArrayBuffer]"===_.call(l)?new Uint8Array(l):l,r=c.inflateSetDictionary(this.strm,o)),r===m.Z_BUF_ERROR&&!0===f&&(r=m.Z_OK,f=!1),r!==m.Z_STREAM_END&&r!==m.Z_OK)return this.onEnd(r),!(this.ended=!0);h.next_out&&(0!==h.avail_out&&r!==m.Z_STREAM_END&&(0!==h.avail_in||n!==m.Z_FINISH&&n!==m.Z_SYNC_FLUSH)||("string"===this.options.to?(i=p.utf8border(h.output,h.next_out),s=h.next_out-i,a=p.buf2string(h.output,i),h.next_out=s,h.avail_out=u-s,s&&d.arraySet(h.output,h.output,i,s,0),this.onData(a)):this.onData(d.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(f=!0)}while((0<h.avail_in||0===h.avail_out)&&r!==m.Z_STREAM_END);return r===m.Z_STREAM_END&&(n=m.Z_FINISH),n===m.Z_FINISH?(r=c.inflateEnd(this.strm),this.onEnd(r),this.ended=!0,r===m.Z_OK):n!==m.Z_SYNC_FLUSH||(this.onEnd(m.Z_OK),!(h.avail_out=0))},a.prototype.onData=function(e){this.chunks.push(e)},a.prototype.onEnd=function(e){e===m.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=d.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},r.Inflate=a,r.inflate=o,r.inflateRaw=function(e,t){return(t=t||{}).raw=!0,o(e,t)},r.ungzip=o},{"./utils/common":41,"./utils/strings":42,"./zlib/constants":44,"./zlib/gzheader":47,"./zlib/inflate":49,"./zlib/messages":51,"./zlib/zstream":53}],41:[function(e,t,r){"use strict";var n="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;r.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var r=t.shift();if(r){if("object"!=typeof r)throw new TypeError(r+"must be non-object");for(var n in r)r.hasOwnProperty(n)&&(e[n]=r[n])}}return e},r.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,r,n,i){if(t.subarray&&e.subarray)e.set(t.subarray(r,r+n),i);else for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){var t,r,n,i,s,a;for(t=n=0,r=e.length;t<r;t++)n+=e[t].length;for(a=new Uint8Array(n),t=i=0,r=e.length;t<r;t++)s=e[t],a.set(s,i),i+=s.length;return a}},s={arraySet:function(e,t,r,n,i){for(var s=0;s<n;s++)e[i+s]=t[r+s]},flattenChunks:function(e){return[].concat.apply([],e)}};r.setTyped=function(e){e?(r.Buf8=Uint8Array,r.Buf16=Uint16Array,r.Buf32=Int32Array,r.assign(r,i)):(r.Buf8=Array,r.Buf16=Array,r.Buf32=Array,r.assign(r,s))},r.setTyped(n)},{}],42:[function(e,t,r){"use strict";var h=e("./common"),i=!0,s=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){s=!1}for(var u=new h.Buf8(256),n=0;n<256;n++)u[n]=252<=n?6:248<=n?5:240<=n?4:224<=n?3:192<=n?2:1;function l(e,t){if(t<65537&&(e.subarray&&s||!e.subarray&&i))return String.fromCharCode.apply(null,h.shrinkBuf(e,t));for(var r="",n=0;n<t;n++)r+=String.fromCharCode(e[n]);return r}u[254]=u[254]=1,r.string2buf=function(e){var t,r,n,i,s,a=e.length,o=0;for(i=0;i<a;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),o+=r<128?1:r<2048?2:r<65536?3:4;for(t=new h.Buf8(o),i=s=0;s<o;i++)55296==(64512&(r=e.charCodeAt(i)))&&i+1<a&&56320==(64512&(n=e.charCodeAt(i+1)))&&(r=65536+(r-55296<<10)+(n-56320),i++),r<128?t[s++]=r:(r<2048?t[s++]=192|r>>>6:(r<65536?t[s++]=224|r>>>12:(t[s++]=240|r>>>18,t[s++]=128|r>>>12&63),t[s++]=128|r>>>6&63),t[s++]=128|63&r);return t},r.buf2binstring=function(e){return l(e,e.length)},r.binstring2buf=function(e){for(var t=new h.Buf8(e.length),r=0,n=t.length;r<n;r++)t[r]=e.charCodeAt(r);return t},r.buf2string=function(e,t){var r,n,i,s,a=t||e.length,o=new Array(2*a);for(r=n=0;r<a;)if((i=e[r++])<128)o[n++]=i;else if(4<(s=u[i]))o[n++]=65533,r+=s-1;else{for(i&=2===s?31:3===s?15:7;1<s&&r<a;)i=i<<6|63&e[r++],s--;1<s?o[n++]=65533:i<65536?o[n++]=i:(i-=65536,o[n++]=55296|i>>10&1023,o[n++]=56320|1023&i)}return l(o,n)},r.utf8border=function(e,t){var r;for((t=t||e.length)>e.length&&(t=e.length),r=t-1;0<=r&&128==(192&e[r]);)r--;return r<0?t:0===r?t:r+u[e[r]]>t?r:t}},{"./common":41}],43:[function(e,t,r){"use strict";t.exports=function(e,t,r,n){for(var i=65535&e|0,s=e>>>16&65535|0,a=0;0!==r;){for(r-=a=2e3<r?2e3:r;s=s+(i=i+t[n++]|0)|0,--a;);i%=65521,s%=65521}return i|s<<16|0}},{}],44:[function(e,t,r){"use strict";t.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},{}],45:[function(e,t,r){"use strict";var o=function(){for(var e,t=[],r=0;r<256;r++){e=r;for(var n=0;n<8;n++)e=1&e?3988292384^e>>>1:e>>>1;t[r]=e}return t}();t.exports=function(e,t,r,n){var i=o,s=n+r;e^=-1;for(var a=n;a<s;a++)e=e>>>8^i[255&(e^t[a])];return-1^e}},{}],46:[function(e,t,r){"use strict";var h,c=e("../utils/common"),u=e("./trees"),d=e("./adler32"),p=e("./crc32"),n=e("./messages"),l=0,f=4,m=0,_=-2,g=-1,b=4,i=2,v=8,y=9,s=286,a=30,o=19,w=2*s+1,k=15,x=3,S=258,z=S+x+1,C=42,E=113,A=1,I=2,O=3,B=4;function R(e,t){return e.msg=n[t],t}function T(e){return(e<<1)-(4<e?9:0)}function D(e){for(var t=e.length;0<=--t;)e[t]=0}function F(e){var t=e.state,r=t.pending;r>e.avail_out&&(r=e.avail_out),0!==r&&(c.arraySet(e.output,t.pending_buf,t.pending_out,r,e.next_out),e.next_out+=r,t.pending_out+=r,e.total_out+=r,e.avail_out-=r,t.pending-=r,0===t.pending&&(t.pending_out=0))}function N(e,t){u._tr_flush_block(e,0<=e.block_start?e.block_start:-1,e.strstart-e.block_start,t),e.block_start=e.strstart,F(e.strm)}function U(e,t){e.pending_buf[e.pending++]=t}function P(e,t){e.pending_buf[e.pending++]=t>>>8&255,e.pending_buf[e.pending++]=255&t}function L(e,t){var r,n,i=e.max_chain_length,s=e.strstart,a=e.prev_length,o=e.nice_match,h=e.strstart>e.w_size-z?e.strstart-(e.w_size-z):0,u=e.window,l=e.w_mask,f=e.prev,c=e.strstart+S,d=u[s+a-1],p=u[s+a];e.prev_length>=e.good_match&&(i>>=2),o>e.lookahead&&(o=e.lookahead);do{if(u[(r=t)+a]===p&&u[r+a-1]===d&&u[r]===u[s]&&u[++r]===u[s+1]){s+=2,r++;do{}while(u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&u[++s]===u[++r]&&s<c);if(n=S-(c-s),s=c-S,a<n){if(e.match_start=t,o<=(a=n))break;d=u[s+a-1],p=u[s+a]}}}while((t=f[t&l])>h&&0!=--i);return a<=e.lookahead?a:e.lookahead}function j(e){var t,r,n,i,s,a,o,h,u,l,f=e.w_size;do{if(i=e.window_size-e.lookahead-e.strstart,e.strstart>=f+(f-z)){for(c.arraySet(e.window,e.window,f,f,0),e.match_start-=f,e.strstart-=f,e.block_start-=f,t=r=e.hash_size;n=e.head[--t],e.head[t]=f<=n?n-f:0,--r;);for(t=r=f;n=e.prev[--t],e.prev[t]=f<=n?n-f:0,--r;);i+=f}if(0===e.strm.avail_in)break;if(a=e.strm,o=e.window,h=e.strstart+e.lookahead,u=i,l=void 0,l=a.avail_in,u<l&&(l=u),r=0===l?0:(a.avail_in-=l,c.arraySet(o,a.input,a.next_in,l,h),1===a.state.wrap?a.adler=d(a.adler,o,l,h):2===a.state.wrap&&(a.adler=p(a.adler,o,l,h)),a.next_in+=l,a.total_in+=l,l),e.lookahead+=r,e.lookahead+e.insert>=x)for(s=e.strstart-e.insert,e.ins_h=e.window[s],e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+1])&e.hash_mask;e.insert&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[s+x-1])&e.hash_mask,e.prev[s&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=s,s++,e.insert--,!(e.lookahead+e.insert<x)););}while(e.lookahead<z&&0!==e.strm.avail_in)}function Z(e,t){for(var r,n;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!==r&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r)),e.match_length>=x)if(n=u._tr_tally(e,e.strstart-e.match_start,e.match_length-x),e.lookahead-=e.match_length,e.match_length<=e.max_lazy_match&&e.lookahead>=x){for(e.match_length--;e.strstart++,e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart,0!=--e.match_length;);e.strstart++}else e.strstart+=e.match_length,e.match_length=0,e.ins_h=e.window[e.strstart],e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask;else n=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++;if(n&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function W(e,t){for(var r,n,i;;){if(e.lookahead<z){if(j(e),e.lookahead<z&&t===l)return A;if(0===e.lookahead)break}if(r=0,e.lookahead>=x&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),e.prev_length=e.match_length,e.prev_match=e.match_start,e.match_length=x-1,0!==r&&e.prev_length<e.max_lazy_match&&e.strstart-r<=e.w_size-z&&(e.match_length=L(e,r),e.match_length<=5&&(1===e.strategy||e.match_length===x&&4096<e.strstart-e.match_start)&&(e.match_length=x-1)),e.prev_length>=x&&e.match_length<=e.prev_length){for(i=e.strstart+e.lookahead-x,n=u._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-x),e.lookahead-=e.prev_length-1,e.prev_length-=2;++e.strstart<=i&&(e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+x-1])&e.hash_mask,r=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h],e.head[e.ins_h]=e.strstart),0!=--e.prev_length;);if(e.match_available=0,e.match_length=x-1,e.strstart++,n&&(N(e,!1),0===e.strm.avail_out))return A}else if(e.match_available){if((n=u._tr_tally(e,0,e.window[e.strstart-1]))&&N(e,!1),e.strstart++,e.lookahead--,0===e.strm.avail_out)return A}else e.match_available=1,e.strstart++,e.lookahead--}return e.match_available&&(n=u._tr_tally(e,0,e.window[e.strstart-1]),e.match_available=0),e.insert=e.strstart<x-1?e.strstart:x-1,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}function M(e,t,r,n,i){this.good_length=e,this.max_lazy=t,this.nice_length=r,this.max_chain=n,this.func=i}function H(){this.strm=null,this.status=0,this.pending_buf=null,this.pending_buf_size=0,this.pending_out=0,this.pending=0,this.wrap=0,this.gzhead=null,this.gzindex=0,this.method=v,this.last_flush=-1,this.w_size=0,this.w_bits=0,this.w_mask=0,this.window=null,this.window_size=0,this.prev=null,this.head=null,this.ins_h=0,this.hash_size=0,this.hash_bits=0,this.hash_mask=0,this.hash_shift=0,this.block_start=0,this.match_length=0,this.prev_match=0,this.match_available=0,this.strstart=0,this.match_start=0,this.lookahead=0,this.prev_length=0,this.max_chain_length=0,this.max_lazy_match=0,this.level=0,this.strategy=0,this.good_match=0,this.nice_match=0,this.dyn_ltree=new c.Buf16(2*w),this.dyn_dtree=new c.Buf16(2*(2*a+1)),this.bl_tree=new c.Buf16(2*(2*o+1)),D(this.dyn_ltree),D(this.dyn_dtree),D(this.bl_tree),this.l_desc=null,this.d_desc=null,this.bl_desc=null,this.bl_count=new c.Buf16(k+1),this.heap=new c.Buf16(2*s+1),D(this.heap),this.heap_len=0,this.heap_max=0,this.depth=new c.Buf16(2*s+1),D(this.depth),this.l_buf=0,this.lit_bufsize=0,this.last_lit=0,this.d_buf=0,this.opt_len=0,this.static_len=0,this.matches=0,this.insert=0,this.bi_buf=0,this.bi_valid=0}function G(e){var t;return e&&e.state?(e.total_in=e.total_out=0,e.data_type=i,(t=e.state).pending=0,t.pending_out=0,t.wrap<0&&(t.wrap=-t.wrap),t.status=t.wrap?C:E,e.adler=2===t.wrap?0:1,t.last_flush=l,u._tr_init(t),m):R(e,_)}function K(e){var t=G(e);return t===m&&function(e){e.window_size=2*e.w_size,D(e.head),e.max_lazy_match=h[e.level].max_lazy,e.good_match=h[e.level].good_length,e.nice_match=h[e.level].nice_length,e.max_chain_length=h[e.level].max_chain,e.strstart=0,e.block_start=0,e.lookahead=0,e.insert=0,e.match_length=e.prev_length=x-1,e.match_available=0,e.ins_h=0}(e.state),t}function Y(e,t,r,n,i,s){if(!e)return _;var a=1;if(t===g&&(t=6),n<0?(a=0,n=-n):15<n&&(a=2,n-=16),i<1||y<i||r!==v||n<8||15<n||t<0||9<t||s<0||b<s)return R(e,_);8===n&&(n=9);var o=new H;return(e.state=o).strm=e,o.wrap=a,o.gzhead=null,o.w_bits=n,o.w_size=1<<o.w_bits,o.w_mask=o.w_size-1,o.hash_bits=i+7,o.hash_size=1<<o.hash_bits,o.hash_mask=o.hash_size-1,o.hash_shift=~~((o.hash_bits+x-1)/x),o.window=new c.Buf8(2*o.w_size),o.head=new c.Buf16(o.hash_size),o.prev=new c.Buf16(o.w_size),o.lit_bufsize=1<<i+6,o.pending_buf_size=4*o.lit_bufsize,o.pending_buf=new c.Buf8(o.pending_buf_size),o.d_buf=1*o.lit_bufsize,o.l_buf=3*o.lit_bufsize,o.level=t,o.strategy=s,o.method=r,K(e)}h=[new M(0,0,0,0,function(e,t){var r=65535;for(r>e.pending_buf_size-5&&(r=e.pending_buf_size-5);;){if(e.lookahead<=1){if(j(e),0===e.lookahead&&t===l)return A;if(0===e.lookahead)break}e.strstart+=e.lookahead,e.lookahead=0;var n=e.block_start+r;if((0===e.strstart||e.strstart>=n)&&(e.lookahead=e.strstart-n,e.strstart=n,N(e,!1),0===e.strm.avail_out))return A;if(e.strstart-e.block_start>=e.w_size-z&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):(e.strstart>e.block_start&&(N(e,!1),e.strm.avail_out),A)}),new M(4,4,8,4,Z),new M(4,5,16,8,Z),new M(4,6,32,32,Z),new M(4,4,16,16,W),new M(8,16,32,32,W),new M(8,16,128,128,W),new M(8,32,128,256,W),new M(32,128,258,1024,W),new M(32,258,258,4096,W)],r.deflateInit=function(e,t){return Y(e,t,v,15,8,0)},r.deflateInit2=Y,r.deflateReset=K,r.deflateResetKeep=G,r.deflateSetHeader=function(e,t){return e&&e.state?2!==e.state.wrap?_:(e.state.gzhead=t,m):_},r.deflate=function(e,t){var r,n,i,s;if(!e||!e.state||5<t||t<0)return e?R(e,_):_;if(n=e.state,!e.output||!e.input&&0!==e.avail_in||666===n.status&&t!==f)return R(e,0===e.avail_out?-5:_);if(n.strm=e,r=n.last_flush,n.last_flush=t,n.status===C)if(2===n.wrap)e.adler=0,U(n,31),U(n,139),U(n,8),n.gzhead?(U(n,(n.gzhead.text?1:0)+(n.gzhead.hcrc?2:0)+(n.gzhead.extra?4:0)+(n.gzhead.name?8:0)+(n.gzhead.comment?16:0)),U(n,255&n.gzhead.time),U(n,n.gzhead.time>>8&255),U(n,n.gzhead.time>>16&255),U(n,n.gzhead.time>>24&255),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,255&n.gzhead.os),n.gzhead.extra&&n.gzhead.extra.length&&(U(n,255&n.gzhead.extra.length),U(n,n.gzhead.extra.length>>8&255)),n.gzhead.hcrc&&(e.adler=p(e.adler,n.pending_buf,n.pending,0)),n.gzindex=0,n.status=69):(U(n,0),U(n,0),U(n,0),U(n,0),U(n,0),U(n,9===n.level?2:2<=n.strategy||n.level<2?4:0),U(n,3),n.status=E);else{var a=v+(n.w_bits-8<<4)<<8;a|=(2<=n.strategy||n.level<2?0:n.level<6?1:6===n.level?2:3)<<6,0!==n.strstart&&(a|=32),a+=31-a%31,n.status=E,P(n,a),0!==n.strstart&&(P(n,e.adler>>>16),P(n,65535&e.adler)),e.adler=1}if(69===n.status)if(n.gzhead.extra){for(i=n.pending;n.gzindex<(65535&n.gzhead.extra.length)&&(n.pending!==n.pending_buf_size||(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending!==n.pending_buf_size));)U(n,255&n.gzhead.extra[n.gzindex]),n.gzindex++;n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),n.gzindex===n.gzhead.extra.length&&(n.gzindex=0,n.status=73)}else n.status=73;if(73===n.status)if(n.gzhead.name){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.name.length?255&n.gzhead.name.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.gzindex=0,n.status=91)}else n.status=91;if(91===n.status)if(n.gzhead.comment){i=n.pending;do{if(n.pending===n.pending_buf_size&&(n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),F(e),i=n.pending,n.pending===n.pending_buf_size)){s=1;break}s=n.gzindex<n.gzhead.comment.length?255&n.gzhead.comment.charCodeAt(n.gzindex++):0,U(n,s)}while(0!==s);n.gzhead.hcrc&&n.pending>i&&(e.adler=p(e.adler,n.pending_buf,n.pending-i,i)),0===s&&(n.status=103)}else n.status=103;if(103===n.status&&(n.gzhead.hcrc?(n.pending+2>n.pending_buf_size&&F(e),n.pending+2<=n.pending_buf_size&&(U(n,255&e.adler),U(n,e.adler>>8&255),e.adler=0,n.status=E)):n.status=E),0!==n.pending){if(F(e),0===e.avail_out)return n.last_flush=-1,m}else if(0===e.avail_in&&T(t)<=T(r)&&t!==f)return R(e,-5);if(666===n.status&&0!==e.avail_in)return R(e,-5);if(0!==e.avail_in||0!==n.lookahead||t!==l&&666!==n.status){var o=2===n.strategy?function(e,t){for(var r;;){if(0===e.lookahead&&(j(e),0===e.lookahead)){if(t===l)return A;break}if(e.match_length=0,r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++,r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):3===n.strategy?function(e,t){for(var r,n,i,s,a=e.window;;){if(e.lookahead<=S){if(j(e),e.lookahead<=S&&t===l)return A;if(0===e.lookahead)break}if(e.match_length=0,e.lookahead>=x&&0<e.strstart&&(n=a[i=e.strstart-1])===a[++i]&&n===a[++i]&&n===a[++i]){s=e.strstart+S;do{}while(n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&n===a[++i]&&i<s);e.match_length=S-(s-i),e.match_length>e.lookahead&&(e.match_length=e.lookahead)}if(e.match_length>=x?(r=u._tr_tally(e,1,e.match_length-x),e.lookahead-=e.match_length,e.strstart+=e.match_length,e.match_length=0):(r=u._tr_tally(e,0,e.window[e.strstart]),e.lookahead--,e.strstart++),r&&(N(e,!1),0===e.strm.avail_out))return A}return e.insert=0,t===f?(N(e,!0),0===e.strm.avail_out?O:B):e.last_lit&&(N(e,!1),0===e.strm.avail_out)?A:I}(n,t):h[n.level].func(n,t);if(o!==O&&o!==B||(n.status=666),o===A||o===O)return 0===e.avail_out&&(n.last_flush=-1),m;if(o===I&&(1===t?u._tr_align(n):5!==t&&(u._tr_stored_block(n,0,0,!1),3===t&&(D(n.head),0===n.lookahead&&(n.strstart=0,n.block_start=0,n.insert=0))),F(e),0===e.avail_out))return n.last_flush=-1,m}return t!==f?m:n.wrap<=0?1:(2===n.wrap?(U(n,255&e.adler),U(n,e.adler>>8&255),U(n,e.adler>>16&255),U(n,e.adler>>24&255),U(n,255&e.total_in),U(n,e.total_in>>8&255),U(n,e.total_in>>16&255),U(n,e.total_in>>24&255)):(P(n,e.adler>>>16),P(n,65535&e.adler)),F(e),0<n.wrap&&(n.wrap=-n.wrap),0!==n.pending?m:1)},r.deflateEnd=function(e){var t;return e&&e.state?(t=e.state.status)!==C&&69!==t&&73!==t&&91!==t&&103!==t&&t!==E&&666!==t?R(e,_):(e.state=null,t===E?R(e,-3):m):_},r.deflateSetDictionary=function(e,t){var r,n,i,s,a,o,h,u,l=t.length;if(!e||!e.state)return _;if(2===(s=(r=e.state).wrap)||1===s&&r.status!==C||r.lookahead)return _;for(1===s&&(e.adler=d(e.adler,t,l,0)),r.wrap=0,l>=r.w_size&&(0===s&&(D(r.head),r.strstart=0,r.block_start=0,r.insert=0),u=new c.Buf8(r.w_size),c.arraySet(u,t,l-r.w_size,r.w_size,0),t=u,l=r.w_size),a=e.avail_in,o=e.next_in,h=e.input,e.avail_in=l,e.next_in=0,e.input=t,j(r);r.lookahead>=x;){for(n=r.strstart,i=r.lookahead-(x-1);r.ins_h=(r.ins_h<<r.hash_shift^r.window[n+x-1])&r.hash_mask,r.prev[n&r.w_mask]=r.head[r.ins_h],r.head[r.ins_h]=n,n++,--i;);r.strstart=n,r.lookahead=x-1,j(r)}return r.strstart+=r.lookahead,r.block_start=r.strstart,r.insert=r.lookahead,r.lookahead=0,r.match_length=r.prev_length=x-1,r.match_available=0,e.next_in=o,e.input=h,e.avail_in=a,r.wrap=s,m},r.deflateInfo="pako deflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./messages":51,"./trees":52}],47:[function(e,t,r){"use strict";t.exports=function(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}},{}],48:[function(e,t,r){"use strict";t.exports=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C;r=e.state,n=e.next_in,z=e.input,i=n+(e.avail_in-5),s=e.next_out,C=e.output,a=s-(t-e.avail_out),o=s+(e.avail_out-257),h=r.dmax,u=r.wsize,l=r.whave,f=r.wnext,c=r.window,d=r.hold,p=r.bits,m=r.lencode,_=r.distcode,g=(1<<r.lenbits)-1,b=(1<<r.distbits)-1;e:do{p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=m[d&g];t:for(;;){if(d>>>=y=v>>>24,p-=y,0===(y=v>>>16&255))C[s++]=65535&v;else{if(!(16&y)){if(0==(64&y)){v=m[(65535&v)+(d&(1<<y)-1)];continue t}if(32&y){r.mode=12;break e}e.msg="invalid literal/length code",r.mode=30;break e}w=65535&v,(y&=15)&&(p<y&&(d+=z[n++]<<p,p+=8),w+=d&(1<<y)-1,d>>>=y,p-=y),p<15&&(d+=z[n++]<<p,p+=8,d+=z[n++]<<p,p+=8),v=_[d&b];r:for(;;){if(d>>>=y=v>>>24,p-=y,!(16&(y=v>>>16&255))){if(0==(64&y)){v=_[(65535&v)+(d&(1<<y)-1)];continue r}e.msg="invalid distance code",r.mode=30;break e}if(k=65535&v,p<(y&=15)&&(d+=z[n++]<<p,(p+=8)<y&&(d+=z[n++]<<p,p+=8)),h<(k+=d&(1<<y)-1)){e.msg="invalid distance too far back",r.mode=30;break e}if(d>>>=y,p-=y,(y=s-a)<k){if(l<(y=k-y)&&r.sane){e.msg="invalid distance too far back",r.mode=30;break e}if(S=c,(x=0)===f){if(x+=u-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}}else if(f<y){if(x+=u+f-y,(y-=f)<w){for(w-=y;C[s++]=c[x++],--y;);if(x=0,f<w){for(w-=y=f;C[s++]=c[x++],--y;);x=s-k,S=C}}}else if(x+=f-y,y<w){for(w-=y;C[s++]=c[x++],--y;);x=s-k,S=C}for(;2<w;)C[s++]=S[x++],C[s++]=S[x++],C[s++]=S[x++],w-=3;w&&(C[s++]=S[x++],1<w&&(C[s++]=S[x++]))}else{for(x=s-k;C[s++]=C[x++],C[s++]=C[x++],C[s++]=C[x++],2<(w-=3););w&&(C[s++]=C[x++],1<w&&(C[s++]=C[x++]))}break}}break}}while(n<i&&s<o);n-=w=p>>3,d&=(1<<(p-=w<<3))-1,e.next_in=n,e.next_out=s,e.avail_in=n<i?i-n+5:5-(n-i),e.avail_out=s<o?o-s+257:257-(s-o),r.hold=d,r.bits=p}},{}],49:[function(e,t,r){"use strict";var I=e("../utils/common"),O=e("./adler32"),B=e("./crc32"),R=e("./inffast"),T=e("./inftrees"),D=1,F=2,N=0,U=-2,P=1,n=852,i=592;function L(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function s(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new I.Buf16(320),this.work=new I.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function a(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=P,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new I.Buf32(n),t.distcode=t.distdyn=new I.Buf32(i),t.sane=1,t.back=-1,N):U}function o(e){var t;return e&&e.state?((t=e.state).wsize=0,t.whave=0,t.wnext=0,a(e)):U}function h(e,t){var r,n;return e&&e.state?(n=e.state,t<0?(r=0,t=-t):(r=1+(t>>4),t<48&&(t&=15)),t&&(t<8||15<t)?U:(null!==n.window&&n.wbits!==t&&(n.window=null),n.wrap=r,n.wbits=t,o(e))):U}function u(e,t){var r,n;return e?(n=new s,(e.state=n).window=null,(r=h(e,t))!==N&&(e.state=null),r):U}var l,f,c=!0;function j(e){if(c){var t;for(l=new I.Buf32(512),f=new I.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(T(D,e.lens,0,288,l,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;T(F,e.lens,0,32,f,0,e.work,{bits:5}),c=!1}e.lencode=l,e.lenbits=9,e.distcode=f,e.distbits=5}function Z(e,t,r,n){var i,s=e.state;return null===s.window&&(s.wsize=1<<s.wbits,s.wnext=0,s.whave=0,s.window=new I.Buf8(s.wsize)),n>=s.wsize?(I.arraySet(s.window,t,r-s.wsize,s.wsize,0),s.wnext=0,s.whave=s.wsize):(n<(i=s.wsize-s.wnext)&&(i=n),I.arraySet(s.window,t,r-n,i,s.wnext),(n-=i)?(I.arraySet(s.window,t,r-n,n,0),s.wnext=n,s.whave=s.wsize):(s.wnext+=i,s.wnext===s.wsize&&(s.wnext=0),s.whave<s.wsize&&(s.whave+=i))),0}r.inflateReset=o,r.inflateReset2=h,r.inflateResetKeep=a,r.inflateInit=function(e){return u(e,15)},r.inflateInit2=u,r.inflate=function(e,t){var r,n,i,s,a,o,h,u,l,f,c,d,p,m,_,g,b,v,y,w,k,x,S,z,C=0,E=new I.Buf8(4),A=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return U;12===(r=e.state).mode&&(r.mode=13),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,f=o,c=h,x=N;e:for(;;)switch(r.mode){case P:if(0===r.wrap){r.mode=13;break}for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(2&r.wrap&&35615===u){E[r.check=0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0),l=u=0,r.mode=2;break}if(r.flags=0,r.head&&(r.head.done=!1),!(1&r.wrap)||(((255&u)<<8)+(u>>8))%31){e.msg="incorrect header check",r.mode=30;break}if(8!=(15&u)){e.msg="unknown compression method",r.mode=30;break}if(l-=4,k=8+(15&(u>>>=4)),0===r.wbits)r.wbits=k;else if(k>r.wbits){e.msg="invalid window size",r.mode=30;break}r.dmax=1<<k,e.adler=r.check=1,r.mode=512&u?10:12,l=u=0;break;case 2:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.flags=u,8!=(255&r.flags)){e.msg="unknown compression method",r.mode=30;break}if(57344&r.flags){e.msg="unknown header flags set",r.mode=30;break}r.head&&(r.head.text=u>>8&1),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=3;case 3:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.time=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,E[2]=u>>>16&255,E[3]=u>>>24&255,r.check=B(r.check,E,4,0)),l=u=0,r.mode=4;case 4:for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.head&&(r.head.xflags=255&u,r.head.os=u>>8),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0,r.mode=5;case 5:if(1024&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length=u,r.head&&(r.head.extra_len=u),512&r.flags&&(E[0]=255&u,E[1]=u>>>8&255,r.check=B(r.check,E,2,0)),l=u=0}else r.head&&(r.head.extra=null);r.mode=6;case 6:if(1024&r.flags&&(o<(d=r.length)&&(d=o),d&&(r.head&&(k=r.head.extra_len-r.length,r.head.extra||(r.head.extra=new Array(r.head.extra_len)),I.arraySet(r.head.extra,n,s,d,k)),512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,r.length-=d),r.length))break e;r.length=0,r.mode=7;case 7:if(2048&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.name+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.name=null);r.length=0,r.mode=8;case 8:if(4096&r.flags){if(0===o)break e;for(d=0;k=n[s+d++],r.head&&k&&r.length<65536&&(r.head.comment+=String.fromCharCode(k)),k&&d<o;);if(512&r.flags&&(r.check=B(r.check,n,d,s)),o-=d,s+=d,k)break e}else r.head&&(r.head.comment=null);r.mode=9;case 9:if(512&r.flags){for(;l<16;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(65535&r.check)){e.msg="header crc mismatch",r.mode=30;break}l=u=0}r.head&&(r.head.hcrc=r.flags>>9&1,r.head.done=!0),e.adler=r.check=0,r.mode=12;break;case 10:for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}e.adler=r.check=L(u),l=u=0,r.mode=11;case 11:if(0===r.havedict)return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,2;e.adler=r.check=1,r.mode=12;case 12:if(5===t||6===t)break e;case 13:if(r.last){u>>>=7&l,l-=7&l,r.mode=27;break}for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}switch(r.last=1&u,l-=1,3&(u>>>=1)){case 0:r.mode=14;break;case 1:if(j(r),r.mode=20,6!==t)break;u>>>=2,l-=2;break e;case 2:r.mode=17;break;case 3:e.msg="invalid block type",r.mode=30}u>>>=2,l-=2;break;case 14:for(u>>>=7&l,l-=7&l;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if((65535&u)!=(u>>>16^65535)){e.msg="invalid stored block lengths",r.mode=30;break}if(r.length=65535&u,l=u=0,r.mode=15,6===t)break e;case 15:r.mode=16;case 16:if(d=r.length){if(o<d&&(d=o),h<d&&(d=h),0===d)break e;I.arraySet(i,n,s,d,a),o-=d,s+=d,h-=d,a+=d,r.length-=d;break}r.mode=12;break;case 17:for(;l<14;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(r.nlen=257+(31&u),u>>>=5,l-=5,r.ndist=1+(31&u),u>>>=5,l-=5,r.ncode=4+(15&u),u>>>=4,l-=4,286<r.nlen||30<r.ndist){e.msg="too many length or distance symbols",r.mode=30;break}r.have=0,r.mode=18;case 18:for(;r.have<r.ncode;){for(;l<3;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.lens[A[r.have++]]=7&u,u>>>=3,l-=3}for(;r.have<19;)r.lens[A[r.have++]]=0;if(r.lencode=r.lendyn,r.lenbits=7,S={bits:r.lenbits},x=T(0,r.lens,0,19,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid code lengths set",r.mode=30;break}r.have=0,r.mode=19;case 19:for(;r.have<r.nlen+r.ndist;){for(;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(b<16)u>>>=_,l-=_,r.lens[r.have++]=b;else{if(16===b){for(z=_+2;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u>>>=_,l-=_,0===r.have){e.msg="invalid bit length repeat",r.mode=30;break}k=r.lens[r.have-1],d=3+(3&u),u>>>=2,l-=2}else if(17===b){for(z=_+3;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=3+(7&(u>>>=_)),u>>>=3,l-=3}else{for(z=_+7;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}l-=_,k=0,d=11+(127&(u>>>=_)),u>>>=7,l-=7}if(r.have+d>r.nlen+r.ndist){e.msg="invalid bit length repeat",r.mode=30;break}for(;d--;)r.lens[r.have++]=k}}if(30===r.mode)break;if(0===r.lens[256]){e.msg="invalid code -- missing end-of-block",r.mode=30;break}if(r.lenbits=9,S={bits:r.lenbits},x=T(D,r.lens,0,r.nlen,r.lencode,0,r.work,S),r.lenbits=S.bits,x){e.msg="invalid literal/lengths set",r.mode=30;break}if(r.distbits=6,r.distcode=r.distdyn,S={bits:r.distbits},x=T(F,r.lens,r.nlen,r.ndist,r.distcode,0,r.work,S),r.distbits=S.bits,x){e.msg="invalid distances set",r.mode=30;break}if(r.mode=20,6===t)break e;case 20:r.mode=21;case 21:if(6<=o&&258<=h){e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,R(e,c),a=e.next_out,i=e.output,h=e.avail_out,s=e.next_in,n=e.input,o=e.avail_in,u=r.hold,l=r.bits,12===r.mode&&(r.back=-1);break}for(r.back=0;g=(C=r.lencode[u&(1<<r.lenbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(g&&0==(240&g)){for(v=_,y=g,w=b;g=(C=r.lencode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,r.length=b,0===g){r.mode=26;break}if(32&g){r.back=-1,r.mode=12;break}if(64&g){e.msg="invalid literal/length code",r.mode=30;break}r.extra=15&g,r.mode=22;case 22:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.length+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}r.was=r.length,r.mode=23;case 23:for(;g=(C=r.distcode[u&(1<<r.distbits)-1])>>>16&255,b=65535&C,!((_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(0==(240&g)){for(v=_,y=g,w=b;g=(C=r.distcode[w+((u&(1<<v+y)-1)>>v)])>>>16&255,b=65535&C,!(v+(_=C>>>24)<=l);){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}u>>>=v,l-=v,r.back+=v}if(u>>>=_,l-=_,r.back+=_,64&g){e.msg="invalid distance code",r.mode=30;break}r.offset=b,r.extra=15&g,r.mode=24;case 24:if(r.extra){for(z=r.extra;l<z;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}r.offset+=u&(1<<r.extra)-1,u>>>=r.extra,l-=r.extra,r.back+=r.extra}if(r.offset>r.dmax){e.msg="invalid distance too far back",r.mode=30;break}r.mode=25;case 25:if(0===h)break e;if(d=c-h,r.offset>d){if((d=r.offset-d)>r.whave&&r.sane){e.msg="invalid distance too far back",r.mode=30;break}p=d>r.wnext?(d-=r.wnext,r.wsize-d):r.wnext-d,d>r.length&&(d=r.length),m=r.window}else m=i,p=a-r.offset,d=r.length;for(h<d&&(d=h),h-=d,r.length-=d;i[a++]=m[p++],--d;);0===r.length&&(r.mode=21);break;case 26:if(0===h)break e;i[a++]=r.length,h--,r.mode=21;break;case 27:if(r.wrap){for(;l<32;){if(0===o)break e;o--,u|=n[s++]<<l,l+=8}if(c-=h,e.total_out+=c,r.total+=c,c&&(e.adler=r.check=r.flags?B(r.check,i,c,a-c):O(r.check,i,c,a-c)),c=h,(r.flags?u:L(u))!==r.check){e.msg="incorrect data check",r.mode=30;break}l=u=0}r.mode=28;case 28:if(r.wrap&&r.flags){for(;l<32;){if(0===o)break e;o--,u+=n[s++]<<l,l+=8}if(u!==(4294967295&r.total)){e.msg="incorrect length check",r.mode=30;break}l=u=0}r.mode=29;case 29:x=1;break e;case 30:x=-3;break e;case 31:return-4;case 32:default:return U}return e.next_out=a,e.avail_out=h,e.next_in=s,e.avail_in=o,r.hold=u,r.bits=l,(r.wsize||c!==e.avail_out&&r.mode<30&&(r.mode<27||4!==t))&&Z(e,e.output,e.next_out,c-e.avail_out)?(r.mode=31,-4):(f-=e.avail_in,c-=e.avail_out,e.total_in+=f,e.total_out+=c,r.total+=c,r.wrap&&c&&(e.adler=r.check=r.flags?B(r.check,i,c,e.next_out-c):O(r.check,i,c,e.next_out-c)),e.data_type=r.bits+(r.last?64:0)+(12===r.mode?128:0)+(20===r.mode||15===r.mode?256:0),(0==f&&0===c||4===t)&&x===N&&(x=-5),x)},r.inflateEnd=function(e){if(!e||!e.state)return U;var t=e.state;return t.window&&(t.window=null),e.state=null,N},r.inflateGetHeader=function(e,t){var r;return e&&e.state?0==(2&(r=e.state).wrap)?U:((r.head=t).done=!1,N):U},r.inflateSetDictionary=function(e,t){var r,n=t.length;return e&&e.state?0!==(r=e.state).wrap&&11!==r.mode?U:11===r.mode&&O(1,t,n,0)!==r.check?-3:Z(e,t,n,n)?(r.mode=31,-4):(r.havedict=1,N):U},r.inflateInfo="pako inflate (from Nodeca project)"},{"../utils/common":41,"./adler32":43,"./crc32":45,"./inffast":48,"./inftrees":50}],50:[function(e,t,r){"use strict";var D=e("../utils/common"),F=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],N=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],U=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],P=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];t.exports=function(e,t,r,n,i,s,a,o){var h,u,l,f,c,d,p,m,_,g=o.bits,b=0,v=0,y=0,w=0,k=0,x=0,S=0,z=0,C=0,E=0,A=null,I=0,O=new D.Buf16(16),B=new D.Buf16(16),R=null,T=0;for(b=0;b<=15;b++)O[b]=0;for(v=0;v<n;v++)O[t[r+v]]++;for(k=g,w=15;1<=w&&0===O[w];w--);if(w<k&&(k=w),0===w)return i[s++]=20971520,i[s++]=20971520,o.bits=1,0;for(y=1;y<w&&0===O[y];y++);for(k<y&&(k=y),b=z=1;b<=15;b++)if(z<<=1,(z-=O[b])<0)return-1;if(0<z&&(0===e||1!==w))return-1;for(B[1]=0,b=1;b<15;b++)B[b+1]=B[b]+O[b];for(v=0;v<n;v++)0!==t[r+v]&&(a[B[t[r+v]]++]=v);if(d=0===e?(A=R=a,19):1===e?(A=F,I-=257,R=N,T-=257,256):(A=U,R=P,-1),b=y,c=s,S=v=E=0,l=-1,f=(C=1<<(x=k))-1,1===e&&852<C||2===e&&592<C)return 1;for(;;){for(p=b-S,_=a[v]<d?(m=0,a[v]):a[v]>d?(m=R[T+a[v]],A[I+a[v]]):(m=96,0),h=1<<b-S,y=u=1<<x;i[c+(E>>S)+(u-=h)]=p<<24|m<<16|_|0,0!==u;);for(h=1<<b-1;E&h;)h>>=1;if(0!==h?(E&=h-1,E+=h):E=0,v++,0==--O[b]){if(b===w)break;b=t[r+a[v]]}if(k<b&&(E&f)!==l){for(0===S&&(S=k),c+=y,z=1<<(x=b-S);x+S<w&&!((z-=O[x+S])<=0);)x++,z<<=1;if(C+=1<<x,1===e&&852<C||2===e&&592<C)return 1;i[l=E&f]=k<<24|x<<16|c-s|0}}return 0!==E&&(i[c+E]=b-S<<24|64<<16|0),o.bits=k,0}},{"../utils/common":41}],51:[function(e,t,r){"use strict";t.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},{}],52:[function(e,t,r){"use strict";var i=e("../utils/common"),o=0,h=1;function n(e){for(var t=e.length;0<=--t;)e[t]=0}var s=0,a=29,u=256,l=u+1+a,f=30,c=19,_=2*l+1,g=15,d=16,p=7,m=256,b=16,v=17,y=18,w=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0],k=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13],x=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7],S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15],z=new Array(2*(l+2));n(z);var C=new Array(2*f);n(C);var E=new Array(512);n(E);var A=new Array(256);n(A);var I=new Array(a);n(I);var O,B,R,T=new Array(f);function D(e,t,r,n,i){this.static_tree=e,this.extra_bits=t,this.extra_base=r,this.elems=n,this.max_length=i,this.has_stree=e&&e.length}function F(e,t){this.dyn_tree=e,this.max_code=0,this.stat_desc=t}function N(e){return e<256?E[e]:E[256+(e>>>7)]}function U(e,t){e.pending_buf[e.pending++]=255&t,e.pending_buf[e.pending++]=t>>>8&255}function P(e,t,r){e.bi_valid>d-r?(e.bi_buf|=t<<e.bi_valid&65535,U(e,e.bi_buf),e.bi_buf=t>>d-e.bi_valid,e.bi_valid+=r-d):(e.bi_buf|=t<<e.bi_valid&65535,e.bi_valid+=r)}function L(e,t,r){P(e,r[2*t],r[2*t+1])}function j(e,t){for(var r=0;r|=1&e,e>>>=1,r<<=1,0<--t;);return r>>>1}function Z(e,t,r){var n,i,s=new Array(g+1),a=0;for(n=1;n<=g;n++)s[n]=a=a+r[n-1]<<1;for(i=0;i<=t;i++){var o=e[2*i+1];0!==o&&(e[2*i]=j(s[o]++,o))}}function W(e){var t;for(t=0;t<l;t++)e.dyn_ltree[2*t]=0;for(t=0;t<f;t++)e.dyn_dtree[2*t]=0;for(t=0;t<c;t++)e.bl_tree[2*t]=0;e.dyn_ltree[2*m]=1,e.opt_len=e.static_len=0,e.last_lit=e.matches=0}function M(e){8<e.bi_valid?U(e,e.bi_buf):0<e.bi_valid&&(e.pending_buf[e.pending++]=e.bi_buf),e.bi_buf=0,e.bi_valid=0}function H(e,t,r,n){var i=2*t,s=2*r;return e[i]<e[s]||e[i]===e[s]&&n[t]<=n[r]}function G(e,t,r){for(var n=e.heap[r],i=r<<1;i<=e.heap_len&&(i<e.heap_len&&H(t,e.heap[i+1],e.heap[i],e.depth)&&i++,!H(t,n,e.heap[i],e.depth));)e.heap[r]=e.heap[i],r=i,i<<=1;e.heap[r]=n}function K(e,t,r){var n,i,s,a,o=0;if(0!==e.last_lit)for(;n=e.pending_buf[e.d_buf+2*o]<<8|e.pending_buf[e.d_buf+2*o+1],i=e.pending_buf[e.l_buf+o],o++,0===n?L(e,i,t):(L(e,(s=A[i])+u+1,t),0!==(a=w[s])&&P(e,i-=I[s],a),L(e,s=N(--n),r),0!==(a=k[s])&&P(e,n-=T[s],a)),o<e.last_lit;);L(e,m,t)}function Y(e,t){var r,n,i,s=t.dyn_tree,a=t.stat_desc.static_tree,o=t.stat_desc.has_stree,h=t.stat_desc.elems,u=-1;for(e.heap_len=0,e.heap_max=_,r=0;r<h;r++)0!==s[2*r]?(e.heap[++e.heap_len]=u=r,e.depth[r]=0):s[2*r+1]=0;for(;e.heap_len<2;)s[2*(i=e.heap[++e.heap_len]=u<2?++u:0)]=1,e.depth[i]=0,e.opt_len--,o&&(e.static_len-=a[2*i+1]);for(t.max_code=u,r=e.heap_len>>1;1<=r;r--)G(e,s,r);for(i=h;r=e.heap[1],e.heap[1]=e.heap[e.heap_len--],G(e,s,1),n=e.heap[1],e.heap[--e.heap_max]=r,e.heap[--e.heap_max]=n,s[2*i]=s[2*r]+s[2*n],e.depth[i]=(e.depth[r]>=e.depth[n]?e.depth[r]:e.depth[n])+1,s[2*r+1]=s[2*n+1]=i,e.heap[1]=i++,G(e,s,1),2<=e.heap_len;);e.heap[--e.heap_max]=e.heap[1],function(e,t){var r,n,i,s,a,o,h=t.dyn_tree,u=t.max_code,l=t.stat_desc.static_tree,f=t.stat_desc.has_stree,c=t.stat_desc.extra_bits,d=t.stat_desc.extra_base,p=t.stat_desc.max_length,m=0;for(s=0;s<=g;s++)e.bl_count[s]=0;for(h[2*e.heap[e.heap_max]+1]=0,r=e.heap_max+1;r<_;r++)p<(s=h[2*h[2*(n=e.heap[r])+1]+1]+1)&&(s=p,m++),h[2*n+1]=s,u<n||(e.bl_count[s]++,a=0,d<=n&&(a=c[n-d]),o=h[2*n],e.opt_len+=o*(s+a),f&&(e.static_len+=o*(l[2*n+1]+a)));if(0!==m){do{for(s=p-1;0===e.bl_count[s];)s--;e.bl_count[s]--,e.bl_count[s+1]+=2,e.bl_count[p]--,m-=2}while(0<m);for(s=p;0!==s;s--)for(n=e.bl_count[s];0!==n;)u<(i=e.heap[--r])||(h[2*i+1]!==s&&(e.opt_len+=(s-h[2*i+1])*h[2*i],h[2*i+1]=s),n--)}}(e,t),Z(s,u,e.bl_count)}function X(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),t[2*(r+1)+1]=65535,n=0;n<=r;n++)i=a,a=t[2*(n+1)+1],++o<h&&i===a||(o<u?e.bl_tree[2*i]+=o:0!==i?(i!==s&&e.bl_tree[2*i]++,e.bl_tree[2*b]++):o<=10?e.bl_tree[2*v]++:e.bl_tree[2*y]++,s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4))}function V(e,t,r){var n,i,s=-1,a=t[1],o=0,h=7,u=4;for(0===a&&(h=138,u=3),n=0;n<=r;n++)if(i=a,a=t[2*(n+1)+1],!(++o<h&&i===a)){if(o<u)for(;L(e,i,e.bl_tree),0!=--o;);else 0!==i?(i!==s&&(L(e,i,e.bl_tree),o--),L(e,b,e.bl_tree),P(e,o-3,2)):o<=10?(L(e,v,e.bl_tree),P(e,o-3,3)):(L(e,y,e.bl_tree),P(e,o-11,7));s=i,u=(o=0)===a?(h=138,3):i===a?(h=6,3):(h=7,4)}}n(T);var q=!1;function J(e,t,r,n){P(e,(s<<1)+(n?1:0),3),function(e,t,r,n){M(e),n&&(U(e,r),U(e,~r)),i.arraySet(e.pending_buf,e.window,t,r,e.pending),e.pending+=r}(e,t,r,!0)}r._tr_init=function(e){q||(function(){var e,t,r,n,i,s=new Array(g+1);for(n=r=0;n<a-1;n++)for(I[n]=r,e=0;e<1<<w[n];e++)A[r++]=n;for(A[r-1]=n,n=i=0;n<16;n++)for(T[n]=i,e=0;e<1<<k[n];e++)E[i++]=n;for(i>>=7;n<f;n++)for(T[n]=i<<7,e=0;e<1<<k[n]-7;e++)E[256+i++]=n;for(t=0;t<=g;t++)s[t]=0;for(e=0;e<=143;)z[2*e+1]=8,e++,s[8]++;for(;e<=255;)z[2*e+1]=9,e++,s[9]++;for(;e<=279;)z[2*e+1]=7,e++,s[7]++;for(;e<=287;)z[2*e+1]=8,e++,s[8]++;for(Z(z,l+1,s),e=0;e<f;e++)C[2*e+1]=5,C[2*e]=j(e,5);O=new D(z,w,u+1,l,g),B=new D(C,k,0,f,g),R=new D(new Array(0),x,0,c,p)}(),q=!0),e.l_desc=new F(e.dyn_ltree,O),e.d_desc=new F(e.dyn_dtree,B),e.bl_desc=new F(e.bl_tree,R),e.bi_buf=0,e.bi_valid=0,W(e)},r._tr_stored_block=J,r._tr_flush_block=function(e,t,r,n){var i,s,a=0;0<e.level?(2===e.strm.data_type&&(e.strm.data_type=function(e){var t,r=4093624447;for(t=0;t<=31;t++,r>>>=1)if(1&r&&0!==e.dyn_ltree[2*t])return o;if(0!==e.dyn_ltree[18]||0!==e.dyn_ltree[20]||0!==e.dyn_ltree[26])return h;for(t=32;t<u;t++)if(0!==e.dyn_ltree[2*t])return h;return o}(e)),Y(e,e.l_desc),Y(e,e.d_desc),a=function(e){var t;for(X(e,e.dyn_ltree,e.l_desc.max_code),X(e,e.dyn_dtree,e.d_desc.max_code),Y(e,e.bl_desc),t=c-1;3<=t&&0===e.bl_tree[2*S[t]+1];t--);return e.opt_len+=3*(t+1)+5+5+4,t}(e),i=e.opt_len+3+7>>>3,(s=e.static_len+3+7>>>3)<=i&&(i=s)):i=s=r+5,r+4<=i&&-1!==t?J(e,t,r,n):4===e.strategy||s===i?(P(e,2+(n?1:0),3),K(e,z,C)):(P(e,4+(n?1:0),3),function(e,t,r,n){var i;for(P(e,t-257,5),P(e,r-1,5),P(e,n-4,4),i=0;i<n;i++)P(e,e.bl_tree[2*S[i]+1],3);V(e,e.dyn_ltree,t-1),V(e,e.dyn_dtree,r-1)}(e,e.l_desc.max_code+1,e.d_desc.max_code+1,a+1),K(e,e.dyn_ltree,e.dyn_dtree)),W(e),n&&M(e)},r._tr_tally=function(e,t,r){return e.pending_buf[e.d_buf+2*e.last_lit]=t>>>8&255,e.pending_buf[e.d_buf+2*e.last_lit+1]=255&t,e.pending_buf[e.l_buf+e.last_lit]=255&r,e.last_lit++,0===t?e.dyn_ltree[2*r]++:(e.matches++,t--,e.dyn_ltree[2*(A[r]+u+1)]++,e.dyn_dtree[2*N(t)]++),e.last_lit===e.lit_bufsize-1},r._tr_align=function(e){P(e,2,3),L(e,m,z),function(e){16===e.bi_valid?(U(e,e.bi_buf),e.bi_buf=0,e.bi_valid=0):8<=e.bi_valid&&(e.pending_buf[e.pending++]=255&e.bi_buf,e.bi_buf>>=8,e.bi_valid-=8)}(e)}},{"../utils/common":41}],53:[function(e,t,r){"use strict";t.exports=function(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}},{}],54:[function(e,t,r){(function(e){!function(r,n){"use strict";if(!r.setImmediate){var i,s,t,a,o=1,h={},u=!1,l=r.document,e=Object.getPrototypeOf&&Object.getPrototypeOf(r);e=e&&e.setTimeout?e:r,i="[object process]"==={}.toString.call(r.process)?function(e){process.nextTick(function(){c(e)})}:function(){if(r.postMessage&&!r.importScripts){var e=!0,t=r.onmessage;return r.onmessage=function(){e=!1},r.postMessage("","*"),r.onmessage=t,e}}()?(a="setImmediate$"+Math.random()+"$",r.addEventListener?r.addEventListener("message",d,!1):r.attachEvent("onmessage",d),function(e){r.postMessage(a+e,"*")}):r.MessageChannel?((t=new MessageChannel).port1.onmessage=function(e){c(e.data)},function(e){t.port2.postMessage(e)}):l&&"onreadystatechange"in l.createElement("script")?(s=l.documentElement,function(e){var t=l.createElement("script");t.onreadystatechange=function(){c(e),t.onreadystatechange=null,s.removeChild(t),t=null},s.appendChild(t)}):function(e){setTimeout(c,0,e)},e.setImmediate=function(e){"function"!=typeof e&&(e=new Function(""+e));for(var t=new Array(arguments.length-1),r=0;r<t.length;r++)t[r]=arguments[r+1];var n={callback:e,args:t};return h[o]=n,i(o),o++},e.clearImmediate=f}function f(e){delete h[e]}function c(e){if(u)setTimeout(c,0,e);else{var t=h[e];if(t){u=!0;try{!function(e){var t=e.callback,r=e.args;switch(r.length){case 0:t();break;case 1:t(r[0]);break;case 2:t(r[0],r[1]);break;case 3:t(r[0],r[1],r[2]);break;default:t.apply(n,r)}}(t)}finally{f(e),u=!1}}}}function d(e){e.source===r&&"string"==typeof e.data&&0===e.data.indexOf(a)&&c(+e.data.slice(a.length))}}("undefined"==typeof self?void 0===e?this:e:self)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}]},{},[10])(10)});
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node-libs-browser/node_modules/buffer/index.js */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer, __webpack_require__(/*! ./../../node-libs-browser/node_modules/timers-browserify/main.js */ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js").setImmediate, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/lodash.escape/index.js":
/*!*********************************************!*\
  !*** ./node_modules/lodash.escape/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/makerjs/index.js":
/*!***************************************!*\
  !*** ./node_modules/makerjs/index.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
__________________________________________________________________________________________________________________________________________            
 __________________________________________________________________________________________________________________________________________           
  ________/\\\\____________/\\\\_____/\\\\\\\\\_____/\\\________/\\\__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\________________________________________          
   _______\/\\\\\\________/\\\\\\___/\\\\/////\\\\__\/\\\_____/\\\//__\/\\\///////////__\/\\\///////\\\_______________/\\\___________________         
    _______\/\\\//\\\____/\\\//\\\__/\\\/____\///\\\_\/\\\__/\\\//_____\/\\\_____________\/\\\_____\/\\\______________\///____________________        
     _______\/\\\\///\\\/\\\/_\/\\\_\/\\\_______\/\\\_\/\\\\\\//\\\_____\/\\\\\\\\\\\_____\/\\\\\\\\\\\/________________/\\\__/\\\\\\\\\\______       
      _______\/\\\__\///\\\/___\/\\\_\/\\\\\\\\\\\\\\\_\/\\\//_\//\\\____\/\\\///////______\/\\\//////\\\_______________\/\\\_\/\\\//////_______      
       _______\/\\\____\///_____\/\\\_\/\\\/////////\\\_\/\\\____\//\\\___\/\\\_____________\/\\\____\//\\\______________\/\\\_\/\\\\\\\\\\______     
        _______\/\\\_____________\/\\\_\/\\\_______\/\\\_\/\\\_____\//\\\__\/\\\_____________\/\\\_____\//\\\_________/\\_\/\\\_\////////\\\______    
         _______\/\\\_____________\/\\\_\/\\\_______\/\\\_\/\\\______\//\\\_\/\\\\\\\\\\\\\\\_\/\\\______\//\\\__/\\\_\//\\\\\\___/\\\\\\\\\\______   
          _______\///______________\///__\///________\///__\///________\///__\///////////////__\///________\///__\///___\//////___\//////////_______  
           __________________________________________________________________________________________________________________________________________ 
            __________________________________________________________________________________________________________________________________________

Maker.js
https://github.com/Microsoft/maker.js

Copyright (c) Microsoft Corporation. All rights reserved. 
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0  
 
THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE, 
MERCHANTABLITY OR NON-INFRINGEMENT. 
 
See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.

*/
/**
 * Root module for Maker.js.
 *
 * Example: get a reference to Maker.js
 * ```
 * var makerjs = require('makerjs');
 * ```
 *
 */
var MakerJs;
(function (MakerJs) {
    /**
     * Version info
     */
    MakerJs.version = 'debug';
    /**
     * Enumeration of environment types.
     */
    MakerJs.environmentTypes = {
        BrowserUI: 'browser',
        NodeJs: 'node',
        WebWorker: 'worker',
        Unknown: 'unknown'
    };
    /**
     * @private
     */
    function detectEnvironment() {
        if (('global' in this) && ('process' in this)) {
            return MakerJs.environmentTypes.NodeJs;
        }
        if (('window' in this) && ('document' in this)) {
            return MakerJs.environmentTypes.BrowserUI;
        }
        if (('WorkerGlobalScope' in this) && ('self' in this)) {
            return MakerJs.environmentTypes.WebWorker;
        }
        return MakerJs.environmentTypes.Unknown;
    }
    /**
     * Current execution environment type, should be one of environmentTypes.
     */
    MakerJs.environment = detectEnvironment();
    //units
    /**
     * String-based enumeration of unit types: imperial, metric or otherwise.
     * A model may specify the unit system it is using, if any. When importing a model, it may have different units.
     * Unit conversion function is makerjs.units.conversionScale().
     * Important: If you add to this, you must also add a corresponding conversion ratio in the unit.ts file!
     */
    MakerJs.unitType = {
        Centimeter: 'cm',
        Foot: 'foot',
        Inch: 'inch',
        Meter: 'm',
        Millimeter: 'mm'
    };
    /**
     * Numeric rounding
     *
     * Example: round to 3 decimal places
     * ```
     * makerjs.round(3.14159, .001); //returns 3.142
     * ```
     *
     * @param n The number to round off.
     * @param accuracy Optional exemplar of number of decimal places.
     */
    function round(n, accuracy) {
        if (accuracy === void 0) { accuracy = .0000001; }
        var places = 1 / accuracy;
        return Math.round(n * places) / places;
    }
    MakerJs.round = round;
    /**
     * Create a string representation of a route array.
     *
     * @param route Array of strings which are segments of a route.
     * @returns String of the flattened array.
     */
    function createRouteKey(route) {
        var converted = [];
        for (var i = 0; i < route.length; i++) {
            var element = route[i];
            var newElement;
            if (i % 2 === 0) {
                newElement = '.' + element;
            }
            else {
                newElement = JSON.stringify([element]);
            }
            converted.push(newElement);
        }
        return converted.join('');
    }
    MakerJs.createRouteKey = createRouteKey;
    /**
     * Travel along a route inside of a model to extract a specific node in its tree.
     *
     * @param modelContext Model to travel within.
     * @param routeKeyOrRoute String of a flattened route, or a string array of route segments.
     * @returns Model or Path object within the modelContext tree.
     */
    function travel(modelContext, routeKeyOrRoute) {
        if (!modelContext || !routeKeyOrRoute)
            return null;
        var route;
        if (Array.isArray(routeKeyOrRoute)) {
            route = routeKeyOrRoute;
        }
        else {
            route = JSON.parse(routeKeyOrRoute);
        }
        var props = route.slice();
        var ref = modelContext;
        var origin = modelContext.origin || [0, 0];
        while (props.length) {
            var prop = props.shift();
            ref = ref[prop];
            if (!ref)
                return null;
            if (ref.origin && props.length) {
                origin = MakerJs.point.add(origin, ref.origin);
            }
        }
        return {
            path: ref,
            offset: origin
        };
    }
    MakerJs.travel = travel;
    /**
     * @private
     */
    var clone = __webpack_require__(/*! clone */ "./node_modules/clone/clone.js");
    /**
     * Clone an object.
     *
     * @param objectToClone The object to clone.
     * @returns A new clone of the original object.
     */
    function cloneObject(objectToClone) {
        return clone(objectToClone);
    }
    MakerJs.cloneObject = cloneObject;
    /**
     * Copy the properties from one object to another object.
     *
     * Example:
     * ```
     * makerjs.extendObject({ abc: 123 }, { xyz: 789 }); //returns { abc: 123, xyz: 789 }
     * ```
     *
     * @param target The object to extend. It will receive the new properties.
     * @param other An object containing properties to merge in.
     * @returns The original object after merging.
     */
    function extendObject(target, other) {
        if (target && other) {
            for (var key in other) {
                if (typeof other[key] !== 'undefined') {
                    target[key] = other[key];
                }
            }
        }
        return target;
    }
    MakerJs.extendObject = extendObject;
    /**
     * Test to see if a variable is a function.
     *
     * @param value The object to test.
     * @returns True if the object is a function type.
     */
    function isFunction(value) {
        return typeof value === 'function';
    }
    MakerJs.isFunction = isFunction;
    /**
     * Test to see if a variable is a number.
     *
     * @param value The object to test.
     * @returns True if the object is a number type.
     */
    function isNumber(value) {
        return !isNaN(value);
    }
    MakerJs.isNumber = isNumber;
    /**
     * Test to see if a variable is an object.
     *
     * @param value The object to test.
     * @returns True if the object is an object type.
     */
    function isObject(value) {
        return typeof value === 'object';
    }
    MakerJs.isObject = isObject;
    /**
     * @private
     */
    var x = {};
    /**
     * @private
     */
    function reflectName(value) {
        for (var prop in x) {
            delete x[prop];
            return prop;
        }
    }
    /**
     * @private
     */
    function hasNamedProperty(p, value) {
        var prop = reflectName();
        return (prop in p);
    }
    /**
     * Test to see if an object implements the required properties of a point.
     *
     * @param item The item to test.
     */
    function isPoint(item) {
        return (Array.isArray(item) && item.length == 2 && !isNaN(item[0]) && !isNaN(item[1]));
    }
    MakerJs.isPoint = isPoint;
    /**
     * Test to see if an object implements the required properties of a path.
     *
     * @param item The item to test.
     */
    function isPath(item) {
        return item && item.type && item.origin;
    }
    MakerJs.isPath = isPath;
    /**
     * Test to see if an object implements the required properties of a line.
     *
     * @param item The item to test.
     */
    function isPathLine(item) {
        return isPath(item) && item.type == MakerJs.pathType.Line && item.end;
    }
    MakerJs.isPathLine = isPathLine;
    /**
     * Test to see if an object implements the required properties of a circle.
     *
     * @param item The item to test.
     */
    function isPathCircle(item) {
        return isPath(item) && item.type == MakerJs.pathType.Circle && hasNamedProperty(item, x.radius = null);
    }
    MakerJs.isPathCircle = isPathCircle;
    /**
     * Test to see if an object implements the required properties of an arc.
     *
     * @param item The item to test.
     */
    function isPathArc(item) {
        return isPath(item) && item.type == MakerJs.pathType.Arc && hasNamedProperty(item, x.radius = null) && hasNamedProperty(item, x.startAngle = null) && hasNamedProperty(item, x.endAngle = null);
    }
    MakerJs.isPathArc = isPathArc;
    /**
     * Test to see if an object implements the required properties of an arc in a bezier curve.
     *
     * @param item The item to test.
     */
    function isPathArcInBezierCurve(item) {
        return isPathArc(item) && hasNamedProperty(item, x.bezierData = null);
    }
    MakerJs.isPathArcInBezierCurve = isPathArcInBezierCurve;
    /**
     * String-based enumeration of all paths types.
     *
     * Examples: use pathType instead of string literal when creating a circle.
     * ```
     * var circle: IPathCircle = { type: pathType.Circle, origin: [0, 0], radius: 7 };   //typescript
     * var circle = { type: pathType.Circle, origin: [0, 0], radius: 7 };   //javascript
     * ```
     */
    MakerJs.pathType = {
        Line: "line",
        Circle: "circle",
        Arc: "arc",
        BezierSeed: "bezier-seed"
    };
    /**
     * Test to see if an object implements the required properties of a model.
     */
    function isModel(item) {
        return item && (item.paths || item.models);
    }
    MakerJs.isModel = isModel;
    /**
     * Test to see if an object implements the required properties of a chain.
     *
     * @param item The item to test.
     */
    function isChain(item) {
        var x = item;
        return x && x.links && Array.isArray(x.links) && isNumber(x.pathLength);
    }
    MakerJs.isChain = isChain;
})(MakerJs || (MakerJs = {}));
//CommonJs
module.exports = MakerJs;
var MakerJs;
(function (MakerJs) {
    var angle;
    (function (angle) {
        /**
         * Ensures an angle is not greater than 360
         *
         * @param angleInDegrees Angle in degrees.
         * @retiurns Same polar angle but not greater than 360 degrees.
         */
        function noRevolutions(angleInDegrees) {
            var revolutions = Math.floor(angleInDegrees / 360);
            var a = angleInDegrees - (360 * revolutions);
            return a < 0 ? a + 360 : a;
        }
        angle.noRevolutions = noRevolutions;
        /**
         * Convert an angle from degrees to radians.
         *
         * @param angleInDegrees Angle in degrees.
         * @returns Angle in radians.
         */
        function toRadians(angleInDegrees) {
            return noRevolutions(angleInDegrees) * Math.PI / 180.0;
        }
        angle.toRadians = toRadians;
        /**
         * Convert an angle from radians to degrees.
         *
         * @param angleInRadians Angle in radians.
         * @returns Angle in degrees.
         */
        function toDegrees(angleInRadians) {
            return angleInRadians * 180.0 / Math.PI;
        }
        angle.toDegrees = toDegrees;
        /**
         * Get an arc's end angle, ensured to be greater than its start angle.
         *
         * @param arc An arc path object.
         * @returns End angle of arc.
         */
        function ofArcEnd(arc) {
            //compensate for values past zero. This allows easy compute of total angle size.
            //for example 0 = 360
            if (arc.endAngle < arc.startAngle) {
                return 360 + arc.endAngle;
            }
            return arc.endAngle;
        }
        angle.ofArcEnd = ofArcEnd;
        /**
         * Get the angle in the middle of an arc's start and end angles.
         *
         * @param arc An arc path object.
         * @param ratio Optional number between 0 and 1 specifying percentage between start and end angles. Default is .5
         * @returns Middle angle of arc.
         */
        function ofArcMiddle(arc, ratio) {
            if (ratio === void 0) { ratio = .5; }
            return arc.startAngle + ofArcSpan(arc) * ratio;
        }
        angle.ofArcMiddle = ofArcMiddle;
        /**
         * Total angle of an arc between its start and end angles.
         *
         * @param arc The arc to measure.
         * @returns Angle of arc.
         */
        function ofArcSpan(arc) {
            var endAngle = angle.ofArcEnd(arc);
            var a = MakerJs.round(endAngle - arc.startAngle);
            if (a > 360) {
                return noRevolutions(a);
            }
            else {
                return a;
            }
        }
        angle.ofArcSpan = ofArcSpan;
        /**
         * Angle of a line path.
         *
         * @param line The line path to find the angle of.
         * @returns Angle of the line path, in degrees.
         */
        function ofLineInDegrees(line) {
            return noRevolutions(toDegrees(ofPointInRadians(line.origin, line.end)));
        }
        angle.ofLineInDegrees = ofLineInDegrees;
        /**
         * Angle of a line through a point, in degrees.
         *
         * @param pointToFindAngle The point to find the angle.
         * @param origin Point of origin of the angle.
         * @returns Angle of the line throught the point, in degrees.
         */
        function ofPointInDegrees(origin, pointToFindAngle) {
            return toDegrees(ofPointInRadians(origin, pointToFindAngle));
        }
        angle.ofPointInDegrees = ofPointInDegrees;
        /**
         * Angle of a line through a point, in radians.
         *
         * @param pointToFindAngle The point to find the angle.
         * @param origin Point of origin of the angle.
         * @returns Angle of the line throught the point, in radians.
         */
        function ofPointInRadians(origin, pointToFindAngle) {
            var d = MakerJs.point.subtract(pointToFindAngle, origin);
            var x = d[0];
            var y = d[1];
            return Math.atan2(-y, -x) + Math.PI;
        }
        angle.ofPointInRadians = ofPointInRadians;
        /**
         * Mirror an angle on either or both x and y axes.
         *
         * @param angleInDegrees The angle to mirror.
         * @param mirrorX Boolean to mirror on the x axis.
         * @param mirrorY Boolean to mirror on the y axis.
         * @returns Mirrored angle.
         */
        function mirror(angleInDegrees, mirrorX, mirrorY) {
            if (mirrorY) {
                angleInDegrees = 360 - angleInDegrees;
            }
            if (mirrorX) {
                angleInDegrees = (angleInDegrees < 180 ? 180 : 540) - angleInDegrees;
            }
            return angleInDegrees;
        }
        angle.mirror = mirror;
    })(angle = MakerJs.angle || (MakerJs.angle = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var point;
    (function (point) {
        /**
         * Add two points together and return the result as a new point object.
         *
         * @param a First point.
         * @param b Second point.
         * @param subtract Optional boolean to subtract instead of add.
         * @returns A new point object.
         */
        function add(a, b, subtract) {
            var newPoint = clone(a);
            if (!b)
                return newPoint;
            for (var i = 2; i--;) {
                if (subtract) {
                    newPoint[i] -= b[i];
                }
                else {
                    newPoint[i] += b[i];
                }
            }
            return newPoint;
        }
        point.add = add;
        /**
         * Get the average of two points.
         *
         * @param a First point.
         * @param b Second point.
         * @returns New point object which is the average of a and b.
         */
        function average(a, b) {
            function avg(i) {
                return (a[i] + b[i]) / 2;
            }
            return [avg(0), avg(1)];
        }
        point.average = average;
        /**
         * Clone a point into a new point.
         *
         * @param pointToClone The point to clone.
         * @returns A new point with same values as the original.
         */
        function clone(pointToClone) {
            if (!pointToClone)
                return point.zero();
            return [pointToClone[0], pointToClone[1]];
        }
        point.clone = clone;
        /**
         * From an array of points, find the closest point to a given reference point.
         *
         * @param referencePoint The reference point.
         * @param pointOptions Array of points to choose from.
         * @returns The first closest point from the pointOptions.
         */
        function closest(referencePoint, pointOptions) {
            var smallest = {
                index: 0,
                distance: -1
            };
            for (var i = 0; i < pointOptions.length; i++) {
                var distance = MakerJs.measure.pointDistance(referencePoint, pointOptions[i]);
                if (smallest.distance == -1 || distance < smallest.distance) {
                    smallest.distance = distance;
                    smallest.index = i;
                }
            }
            return pointOptions[smallest.index];
        }
        point.closest = closest;
        /**
         * Get a point from its polar coordinates.
         *
         * @param angleInRadians The angle of the polar coordinate, in radians.
         * @param radius The radius of the polar coordinate.
         * @returns A new point object.
         */
        function fromPolar(angleInRadians, radius) {
            return [
                radius * Math.cos(angleInRadians),
                radius * Math.sin(angleInRadians)
            ];
        }
        point.fromPolar = fromPolar;
        /**
         * Get a point on a circle or arc path, at a given angle.
         * @param angleInDegrees The angle at which you want to find the point, in degrees.
         * @param circle A circle or arc.
         * @returns A new point object.
         */
        function fromAngleOnCircle(angleInDegrees, circle) {
            return add(circle.origin, fromPolar(MakerJs.angle.toRadians(angleInDegrees), circle.radius));
        }
        point.fromAngleOnCircle = fromAngleOnCircle;
        /**
         * Get the two end points of an arc path.
         *
         * @param arc The arc path object.
         * @returns Array with 2 elements: [0] is the point object corresponding to the start angle, [1] is the point object corresponding to the end angle.
         */
        function fromArc(arc) {
            return [fromAngleOnCircle(arc.startAngle, arc), fromAngleOnCircle(arc.endAngle, arc)];
        }
        point.fromArc = fromArc;
        /**
         * @private
         */
        var pathEndsMap = {};
        pathEndsMap[MakerJs.pathType.Arc] = function (arc) {
            return point.fromArc(arc);
        };
        pathEndsMap[MakerJs.pathType.Line] = function (line) {
            return [line.origin, line.end];
        };
        pathEndsMap[MakerJs.pathType.BezierSeed] = pathEndsMap[MakerJs.pathType.Line];
        /**
         * Get the two end points of a path.
         *
         * @param pathContext The path object.
         * @returns Array with 2 elements: [0] is the point object corresponding to the origin, [1] is the point object corresponding to the end.
         */
        function fromPathEnds(pathContext, pathOffset) {
            var result = null;
            var fn = pathEndsMap[pathContext.type];
            if (fn) {
                result = fn(pathContext);
                if (pathOffset) {
                    result = result.map(function (p) { return add(p, pathOffset); });
                }
            }
            return result;
        }
        point.fromPathEnds = fromPathEnds;
        /**
         * @private
         */
        function verticalIntersectionPoint(verticalLine, nonVerticalSlope) {
            var x = verticalLine.origin[0];
            var y = nonVerticalSlope.slope * x + nonVerticalSlope.yIntercept;
            return [x, y];
        }
        /**
         * Calculates the intersection of slopes of two lines.
         *
         * @param lineA First line to use for slope.
         * @param lineB Second line to use for slope.
         * @param options Optional IPathIntersectionOptions.
         * @returns point of intersection of the two slopes, or null if the slopes did not intersect.
         */
        function fromSlopeIntersection(lineA, lineB, options) {
            if (options === void 0) { options = {}; }
            var slopeA = MakerJs.measure.lineSlope(lineA);
            var slopeB = MakerJs.measure.lineSlope(lineB);
            if (MakerJs.measure.isSlopeEqual(slopeA, slopeB)) {
                //check for overlap
                options.out_AreOverlapped = MakerJs.measure.isLineOverlapping(lineA, lineB, options.excludeTangents);
                return null;
            }
            var pointOfIntersection;
            if (!slopeA.hasSlope) {
                pointOfIntersection = verticalIntersectionPoint(lineA, slopeB);
            }
            else if (!slopeB.hasSlope) {
                pointOfIntersection = verticalIntersectionPoint(lineB, slopeA);
            }
            else {
                // find intersection by line equation
                var x = (slopeB.yIntercept - slopeA.yIntercept) / (slopeA.slope - slopeB.slope);
                var y = slopeA.slope * x + slopeA.yIntercept;
                pointOfIntersection = [x, y];
            }
            return pointOfIntersection;
        }
        point.fromSlopeIntersection = fromSlopeIntersection;
        /**
         * @private
         */
        function midCircle(circle, midAngle) {
            return point.add(circle.origin, point.fromPolar(MakerJs.angle.toRadians(midAngle), circle.radius));
        }
        /**
         * @private
         */
        var middleMap = {};
        middleMap[MakerJs.pathType.Arc] = function (arc, ratio) {
            var midAngle = MakerJs.angle.ofArcMiddle(arc, ratio);
            return midCircle(arc, midAngle);
        };
        middleMap[MakerJs.pathType.Circle] = function (circle, ratio) {
            return midCircle(circle, 360 * ratio);
        };
        middleMap[MakerJs.pathType.Line] = function (line, ratio) {
            function ration(a, b) {
                return a + (b - a) * ratio;
            }
            ;
            return [
                ration(line.origin[0], line.end[0]),
                ration(line.origin[1], line.end[1])
            ];
        };
        middleMap[MakerJs.pathType.BezierSeed] = function (seed, ratio) {
            return MakerJs.models.BezierCurve.computePoint(seed, ratio);
        };
        /**
         * Get the middle point of a path.
         *
         * @param pathContext The path object.
         * @param ratio Optional ratio (between 0 and 1) of point along the path. Default is .5 for middle.
         * @returns Point on the path, in the middle of the path.
         */
        function middle(pathContext, ratio) {
            if (ratio === void 0) { ratio = .5; }
            var midPoint = null;
            var fn = middleMap[pathContext.type];
            if (fn) {
                midPoint = fn(pathContext, ratio);
            }
            return midPoint;
        }
        point.middle = middle;
        /**
         * Create a clone of a point, mirrored on either or both x and y axes.
         *
         * @param pointToMirror The point to mirror.
         * @param mirrorX Boolean to mirror on the x axis.
         * @param mirrorY Boolean to mirror on the y axis.
         * @returns Mirrored point.
         */
        function mirror(pointToMirror, mirrorX, mirrorY) {
            var p = clone(pointToMirror);
            if (mirrorX) {
                p[0] = -p[0];
            }
            if (mirrorY) {
                p[1] = -p[1];
            }
            return p;
        }
        point.mirror = mirror;
        /**
         * Round the values of a point.
         *
         * @param pointContext The point to serialize.
         * @param accuracy Optional exemplar number of decimal places.
         * @returns A new point with the values rounded.
         */
        function rounded(pointContext, accuracy) {
            return [MakerJs.round(pointContext[0], accuracy), MakerJs.round(pointContext[1], accuracy)];
        }
        point.rounded = rounded;
        /**
         * Rotate a point.
         *
         * @param pointToRotate The point to rotate.
         * @param angleInDegrees The amount of rotation, in degrees.
         * @param rotationOrigin The center point of rotation.
         * @returns A new point.
         */
        function rotate(pointToRotate, angleInDegrees, rotationOrigin) {
            if (rotationOrigin === void 0) { rotationOrigin = [0, 0]; }
            var pointAngleInRadians = MakerJs.angle.ofPointInRadians(rotationOrigin, pointToRotate);
            var d = MakerJs.measure.pointDistance(rotationOrigin, pointToRotate);
            var rotatedPoint = fromPolar(pointAngleInRadians + MakerJs.angle.toRadians(angleInDegrees), d);
            return add(rotationOrigin, rotatedPoint);
        }
        point.rotate = rotate;
        /**
         * Scale a point's coordinates.
         *
         * @param pointToScale The point to scale.
         * @param scaleValue The amount of scaling.
         * @returns A new point.
         */
        function scale(pointToScale, scaleValue) {
            var p = clone(pointToScale);
            for (var i = 2; i--;) {
                p[i] *= scaleValue;
            }
            return p;
        }
        point.scale = scale;
        /**
         * Distort a point's coordinates.
         *
         * @param pointToDistort The point to distort.
         * @param scaleX The amount of x scaling.
         * @param scaleY The amount of y scaling.
         * @returns A new point.
         */
        function distort(pointToDistort, scaleX, scaleY) {
            return [pointToDistort[0] * scaleX, pointToDistort[1] * scaleY];
        }
        point.distort = distort;
        /**
         * Subtract a point from another point, and return the result as a new point. Shortcut to Add(a, b, subtract = true).
         *
         * @param a First point.
         * @param b Second point.
         * @returns A new point object.
         */
        function subtract(a, b) {
            return add(a, b, true);
        }
        point.subtract = subtract;
        /**
         * A point at 0,0 coordinates.
         * NOTE: It is important to call this as a method, with the empty parentheses.
         *
         * @returns A new point.
         */
        function zero() {
            return [0, 0];
        }
        point.zero = zero;
    })(point = MakerJs.point || (MakerJs.point = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var path;
    (function (path) {
        /**
         * @private
         */
        function copyLayer(pathA, pathB) {
            if (pathA && pathB && ('layer' in pathA)) {
                pathB.layer = pathA.layer;
            }
        }
        /**
         * Create a clone of a path. This is faster than cloneObject.
         *
         * @param pathToClone The path to clone.
         * @returns Cloned path.
         */
        function clone(pathToClone) {
            var result = null;
            switch (pathToClone.type) {
                case MakerJs.pathType.Arc:
                    var arc = pathToClone;
                    result = new MakerJs.paths.Arc(MakerJs.point.clone(arc.origin), arc.radius, arc.startAngle, arc.endAngle);
                    //carry extra props if this is an IPathArcInBezierCurve
                    if (MakerJs.isPathArcInBezierCurve(arc)) {
                        result.bezierData = arc.bezierData;
                    }
                    break;
                case MakerJs.pathType.Circle:
                    var circle = pathToClone;
                    result = new MakerJs.paths.Circle(MakerJs.point.clone(circle.origin), circle.radius);
                    break;
                case MakerJs.pathType.Line:
                    var line = pathToClone;
                    result = new MakerJs.paths.Line(MakerJs.point.clone(line.origin), MakerJs.point.clone(line.end));
                    break;
            }
            copyLayer(pathToClone, result);
            return result;
        }
        path.clone = clone;
        /**
         * @private
         */
        var mirrorMap = {};
        mirrorMap[MakerJs.pathType.Line] = function (line, origin, mirrorX, mirrorY) {
            return new MakerJs.paths.Line(origin, MakerJs.point.mirror(line.end, mirrorX, mirrorY));
        };
        mirrorMap[MakerJs.pathType.Circle] = function (circle, origin, mirrorX, mirrorY) {
            return new MakerJs.paths.Circle(origin, circle.radius);
        };
        mirrorMap[MakerJs.pathType.Arc] = function (arc, origin, mirrorX, mirrorY) {
            var startAngle = MakerJs.angle.mirror(arc.startAngle, mirrorX, mirrorY);
            var endAngle = MakerJs.angle.mirror(MakerJs.angle.ofArcEnd(arc), mirrorX, mirrorY);
            var xor = mirrorX != mirrorY;
            return new MakerJs.paths.Arc(origin, arc.radius, xor ? endAngle : startAngle, xor ? startAngle : endAngle);
        };
        mirrorMap[MakerJs.pathType.BezierSeed] = function (seed, origin, mirrorX, mirrorY) {
            var mirrored = mirrorMap[MakerJs.pathType.Line](seed, origin, mirrorX, mirrorY);
            mirrored.type = MakerJs.pathType.BezierSeed;
            mirrored.controls = seed.controls.map(function (c) { return MakerJs.point.mirror(c, mirrorX, mirrorY); });
            return mirrored;
        };
        /**
         * Create a clone of a path, mirrored on either or both x and y axes.
         *
         * @param pathToMirror The path to mirror.
         * @param mirrorX Boolean to mirror on the x axis.
         * @param mirrorY Boolean to mirror on the y axis.
         * @returns Mirrored path.
         */
        function mirror(pathToMirror, mirrorX, mirrorY) {
            var newPath = null;
            if (pathToMirror) {
                var origin = MakerJs.point.mirror(pathToMirror.origin, mirrorX, mirrorY);
                var fn = mirrorMap[pathToMirror.type];
                if (fn) {
                    newPath = fn(pathToMirror, origin, mirrorX, mirrorY);
                }
            }
            copyLayer(pathToMirror, newPath);
            return newPath;
        }
        path.mirror = mirror;
        /**
         * @private
         */
        var moveMap = {};
        moveMap[MakerJs.pathType.Line] = function (line, origin) {
            var delta = MakerJs.point.subtract(line.end, line.origin);
            line.end = MakerJs.point.add(origin, delta);
        };
        /**
         * Move a path to an absolute point.
         *
         * @param pathToMove The path to move.
         * @param origin The new origin for the path.
         * @returns The original path (for cascading).
         */
        function move(pathToMove, origin) {
            if (pathToMove) {
                var fn = moveMap[pathToMove.type];
                if (fn) {
                    fn(pathToMove, origin);
                }
                pathToMove.origin = origin;
            }
            return pathToMove;
        }
        path.move = move;
        /**
         * @private
         */
        var moveRelativeMap = {};
        moveRelativeMap[MakerJs.pathType.Line] = function (line, delta, subtract) {
            line.end = MakerJs.point.add(line.end, delta, subtract);
        };
        moveRelativeMap[MakerJs.pathType.BezierSeed] = function (seed, delta, subtract) {
            moveRelativeMap[MakerJs.pathType.Line](seed, delta, subtract);
            seed.controls = seed.controls.map(function (c) { return MakerJs.point.add(c, delta, subtract); });
        };
        /**
         * Move a path's origin by a relative amount.
         *
         * @param pathToMove The path to move.
         * @param delta The x & y adjustments as a point object.
         * @param subtract Optional boolean to subtract instead of add.
         * @returns The original path (for cascading).
         */
        function moveRelative(pathToMove, delta, subtract) {
            if (pathToMove && delta) {
                pathToMove.origin = MakerJs.point.add(pathToMove.origin, delta, subtract);
                var fn = moveRelativeMap[pathToMove.type];
                if (fn) {
                    fn(pathToMove, delta, subtract);
                }
            }
            return pathToMove;
        }
        path.moveRelative = moveRelative;
        /**
         * Move some paths relatively during a task execution, then unmove them.
         *
         * @param pathsToMove The paths to move.
         * @param deltas The x & y adjustments as a point object array.
         * @param task The function to call while the paths are temporarily moved.
         */
        function moveTemporary(pathsToMove, deltas, task) {
            var subtract = false;
            function move(pathToOffset, i) {
                if (deltas[i]) {
                    moveRelative(pathToOffset, deltas[i], subtract);
                }
            }
            pathsToMove.map(move);
            task();
            subtract = true;
            pathsToMove.map(move);
        }
        path.moveTemporary = moveTemporary;
        /**
         * @private
         */
        var rotateMap = {};
        rotateMap[MakerJs.pathType.Line] = function (line, angleInDegrees, rotationOrigin) {
            line.end = MakerJs.point.rotate(line.end, angleInDegrees, rotationOrigin);
        };
        rotateMap[MakerJs.pathType.Arc] = function (arc, angleInDegrees, rotationOrigin) {
            arc.startAngle = MakerJs.angle.noRevolutions(arc.startAngle + angleInDegrees);
            arc.endAngle = MakerJs.angle.noRevolutions(arc.endAngle + angleInDegrees);
        };
        rotateMap[MakerJs.pathType.BezierSeed] = function (seed, angleInDegrees, rotationOrigin) {
            rotateMap[MakerJs.pathType.Line](seed, angleInDegrees, rotationOrigin);
            seed.controls = seed.controls.map(function (c) { return MakerJs.point.rotate(c, angleInDegrees, rotationOrigin); });
        };
        /**
         * Rotate a path.
         *
         * @param pathToRotate The path to rotate.
         * @param angleInDegrees The amount of rotation, in degrees.
         * @param rotationOrigin The center point of rotation.
         * @returns The original path (for cascading).
         */
        function rotate(pathToRotate, angleInDegrees, rotationOrigin) {
            if (rotationOrigin === void 0) { rotationOrigin = [0, 0]; }
            if (!pathToRotate || angleInDegrees == 0)
                return pathToRotate;
            pathToRotate.origin = MakerJs.point.rotate(pathToRotate.origin, angleInDegrees, rotationOrigin);
            var fn = rotateMap[pathToRotate.type];
            if (fn) {
                fn(pathToRotate, angleInDegrees, rotationOrigin);
            }
            return pathToRotate;
        }
        path.rotate = rotate;
        /**
         * @private
         */
        var scaleMap = {};
        scaleMap[MakerJs.pathType.Line] = function (line, scaleValue) {
            line.end = MakerJs.point.scale(line.end, scaleValue);
        };
        scaleMap[MakerJs.pathType.BezierSeed] = function (seed, scaleValue) {
            scaleMap[MakerJs.pathType.Line](seed, scaleValue);
            seed.controls = seed.controls.map(function (c) { return MakerJs.point.scale(c, scaleValue); });
        };
        scaleMap[MakerJs.pathType.Circle] = function (circle, scaleValue) {
            circle.radius *= scaleValue;
        };
        scaleMap[MakerJs.pathType.Arc] = scaleMap[MakerJs.pathType.Circle];
        /**
         * Scale a path.
         *
         * @param pathToScale The path to scale.
         * @param scaleValue The amount of scaling.
         * @returns The original path (for cascading).
         */
        function scale(pathToScale, scaleValue) {
            if (!pathToScale || scaleValue == 1)
                return pathToScale;
            pathToScale.origin = MakerJs.point.scale(pathToScale.origin, scaleValue);
            var fn = scaleMap[pathToScale.type];
            if (fn) {
                fn(pathToScale, scaleValue);
            }
            return pathToScale;
        }
        path.scale = scale;
        /**
         * @private
         */
        var distortMap = {};
        distortMap[MakerJs.pathType.Arc] = function (arc, scaleX, scaleY) {
            return new MakerJs.models.EllipticArc(arc, scaleX, scaleY);
        };
        distortMap[MakerJs.pathType.Circle] = function (circle, scaleX, scaleY) {
            var ellipse = new MakerJs.models.Ellipse(circle.radius * scaleX, circle.radius * scaleY);
            ellipse.origin = MakerJs.point.distort(circle.origin, scaleX, scaleY);
            return ellipse;
        };
        distortMap[MakerJs.pathType.Line] = function (line, scaleX, scaleY) {
            return new MakerJs.paths.Line([line.origin, line.end].map(function (p) { return MakerJs.point.distort(p, scaleX, scaleY); }));
        };
        distortMap[MakerJs.pathType.BezierSeed] = function (seed, scaleX, scaleY) {
            var d = MakerJs.point.distort;
            return {
                type: MakerJs.pathType.BezierSeed,
                origin: d(seed.origin, scaleX, scaleY),
                controls: seed.controls.map(function (c) { return d(c, scaleX, scaleY); }),
                end: d(seed.end, scaleX, scaleY)
            };
        };
        /**
         * Distort a path - scale x and y individually.
         *
         * @param pathToDistort The path to distort.
         * @param scaleX The amount of x scaling.
         * @param scaleY The amount of y scaling.
         * @returns A new IModel (for circles and arcs) or IPath (for lines and bezier seeds).
         */
        function distort(pathToDistort, scaleX, scaleY) {
            if (!pathToDistort || (scaleX === 1 && scaleY === 1))
                return null;
            var fn = distortMap[pathToDistort.type];
            if (fn) {
                return fn(pathToDistort, scaleX, scaleY);
            }
            return null;
        }
        path.distort = distort;
        /**
         * Connect 2 lines at their slope intersection point.
         *
         * @param lineA First line to converge.
         * @param lineB Second line to converge.
         * @param useOriginA Optional flag to converge the origin point of lineA instead of the end point.
         * @param useOriginB Optional flag to converge the origin point of lineB instead of the end point.
         */
        function converge(lineA, lineB, useOriginA, useOriginB) {
            var p = MakerJs.point.fromSlopeIntersection(lineA, lineB);
            if (p) {
                var lines = [lineA, lineB];
                var useOrigin = [useOriginA, useOriginB];
                if (arguments.length === 2) {
                    //converge to closest
                    lines.forEach(function (line, i) {
                        useOrigin[i] = (MakerJs.point.closest(p, [line.origin, line.end]) === line.origin);
                    });
                }
                function setPoint(line, useOrigin) {
                    var setP;
                    if (useOrigin) {
                        setP = line.origin;
                    }
                    else {
                        setP = line.end;
                    }
                    setP[0] = p[0];
                    setP[1] = p[1];
                }
                lines.forEach(function (line, i) {
                    setPoint(line, useOrigin[i]);
                });
            }
            return p;
        }
        path.converge = converge;
        /**
         * Get points along a path.
         *
         * @param pathContext Path to get points from.
         * @param numberOfPoints Number of points to divide the path.
         * @returns Array of points which are on the path spread at a uniform interval.
         */
        function toPoints(pathContext, numberOfPoints) {
            //avoid division by zero when there is only one point
            if (numberOfPoints == 1) {
                return [MakerJs.point.middle(pathContext)];
            }
            var points = [];
            var base = numberOfPoints;
            if (pathContext.type != MakerJs.pathType.Circle)
                base--;
            for (var i = 0; i < numberOfPoints; i++) {
                points.push(MakerJs.point.middle(pathContext, i / base));
            }
            return points;
        }
        path.toPoints = toPoints;
        /**
         * @private
         */
        var numberOfKeyPointsMap = {};
        numberOfKeyPointsMap[MakerJs.pathType.Line] = function (line) {
            return 2;
        };
        numberOfKeyPointsMap[MakerJs.pathType.Circle] = function (circle, maxPointDistance) {
            var len = MakerJs.measure.pathLength(circle);
            if (!len)
                return 0;
            maxPointDistance = maxPointDistance || len;
            return Math.max(8, Math.ceil(len / (maxPointDistance || len)));
        };
        numberOfKeyPointsMap[MakerJs.pathType.Arc] = function (arc, maxPointDistance) {
            var len = MakerJs.measure.pathLength(arc);
            if (!len)
                return 0;
            var minPoints = Math.ceil(MakerJs.angle.ofArcSpan(arc) / 45) + 1;
            return Math.max(minPoints, Math.ceil(len / (maxPointDistance || len)));
        };
        /**
         * Get key points (a minimal a number of points) along a path.
         *
         * @param pathContext Path to get points from.
         * @param maxArcFacet Optional maximum length between points on an arc or circle.
         * @returns Array of points which are on the path.
         */
        function toKeyPoints(pathContext, maxArcFacet) {
            var fn = numberOfKeyPointsMap[pathContext.type];
            if (fn) {
                var numberOfKeyPoints = fn(pathContext, maxArcFacet);
                if (numberOfKeyPoints) {
                    return toPoints(pathContext, numberOfKeyPoints);
                }
            }
            return [];
        }
        path.toKeyPoints = toKeyPoints;
        /**
         * Center a path at [0, 0].
         *
         * @param pathToCenter The path to center.
         */
        function center(pathToCenter) {
            var m = MakerJs.measure.pathExtents(pathToCenter);
            var c = MakerJs.point.average(m.high, m.low);
            var o = MakerJs.point.subtract(pathToCenter.origin || [0, 0], c);
            move(pathToCenter, o);
            return pathToCenter;
        }
        path.center = center;
        /**
         * Move a path so its bounding box begins at [0, 0].
         *
         * @param pathToZero The path to zero.
         */
        function zero(pathToZero) {
            var m = MakerJs.measure.pathExtents(pathToZero);
            var z = MakerJs.point.subtract(pathToZero.origin || [0, 0], m.low);
            move(pathToZero, z);
            return pathToZero;
        }
        path.zero = zero;
    })(path = MakerJs.path || (MakerJs.path = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var path;
    (function (path_1) {
        /**
         * @private
         */
        var breakPathFunctionMap = {};
        breakPathFunctionMap[MakerJs.pathType.Arc] = function (arc, pointOfBreak) {
            var angleAtBreakPoint = MakerJs.angle.ofPointInDegrees(arc.origin, pointOfBreak);
            if (MakerJs.measure.isAngleEqual(angleAtBreakPoint, arc.startAngle) || MakerJs.measure.isAngleEqual(angleAtBreakPoint, arc.endAngle)) {
                return null;
            }
            function getAngleStrictlyBetweenArcAngles() {
                var startAngle = MakerJs.angle.noRevolutions(arc.startAngle);
                var endAngle = startAngle + MakerJs.angle.ofArcEnd(arc) - arc.startAngle;
                var tries = [0, 1, -1];
                for (var i = 0; i < tries.length; i++) {
                    var add = +360 * tries[i];
                    if (MakerJs.measure.isBetween(angleAtBreakPoint + add, startAngle, endAngle, true)) {
                        return arc.startAngle + angleAtBreakPoint + add - startAngle;
                    }
                }
                return null;
            }
            var angleAtBreakPointBetween = getAngleStrictlyBetweenArcAngles();
            if (angleAtBreakPointBetween == null) {
                return null;
            }
            var savedEndAngle = arc.endAngle;
            arc.endAngle = angleAtBreakPointBetween;
            //clone the original to carry other properties
            var copy = MakerJs.cloneObject(arc);
            copy.startAngle = angleAtBreakPointBetween;
            copy.endAngle = savedEndAngle;
            return copy;
        };
        breakPathFunctionMap[MakerJs.pathType.Circle] = function (circle, pointOfBreak) {
            //breaking a circle turns it into an arc
            circle.type = MakerJs.pathType.Arc;
            var arc = circle;
            var angleAtBreakPoint = MakerJs.angle.ofPointInDegrees(circle.origin, pointOfBreak);
            arc.startAngle = angleAtBreakPoint;
            arc.endAngle = angleAtBreakPoint + 360;
            return null;
        };
        breakPathFunctionMap[MakerJs.pathType.Line] = function (line, pointOfBreak) {
            if (!MakerJs.measure.isBetweenPoints(pointOfBreak, line, true)) {
                return null;
            }
            var savedEndPoint = line.end;
            line.end = pointOfBreak;
            //clone the original to carry other properties
            var copy = MakerJs.cloneObject(line);
            copy.origin = pointOfBreak;
            copy.end = savedEndPoint;
            return copy;
        };
        /**
         * Breaks a path in two. The supplied path will end at the supplied pointOfBreak,
         * a new path is returned which begins at the pointOfBreak and ends at the supplied path's initial end point.
         * For Circle, the original path will be converted in place to an Arc, and null is returned.
         *
         * @param pathToBreak The path to break.
         * @param pointOfBreak The point at which to break the path.
         * @returns A new path of the same type, when path type is line or arc. Returns null for circle.
         */
        function breakAtPoint(pathToBreak, pointOfBreak) {
            if (pathToBreak && pointOfBreak) {
                var fn = breakPathFunctionMap[pathToBreak.type];
                if (fn) {
                    var result = fn(pathToBreak, pointOfBreak);
                    if (result && ('layer' in pathToBreak)) {
                        result.layer = pathToBreak.layer;
                    }
                    return result;
                }
            }
            return null;
        }
        path_1.breakAtPoint = breakAtPoint;
    })(path = MakerJs.path || (MakerJs.path = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var paths;
    (function (paths) {
        /**
         * Class for arc path.
         */
        var Arc = (function () {
            function Arc() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                function getSpan(origin) {
                    var startAngle = MakerJs.angle.ofPointInDegrees(origin, args[clockwise ? 1 : 0]);
                    var endAngle = MakerJs.angle.ofPointInDegrees(origin, args[clockwise ? 0 : 1]);
                    if (endAngle < startAngle) {
                        endAngle += 360;
                    }
                    return {
                        origin: origin,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        size: endAngle - startAngle
                    };
                }
                switch (args.length) {
                    case 5:
                        //SVG style arc designation
                        var pointA = args[0];
                        var pointB = args[1];
                        this.radius = args[2];
                        var largeArc = args[3];
                        var clockwise = args[4];
                        var span;
                        //make sure arc can reach. if not, scale up.
                        var smallestRadius = MakerJs.measure.pointDistance(pointA, pointB) / 2;
                        if (MakerJs.round(this.radius - smallestRadius) <= 0) {
                            this.radius = smallestRadius;
                            span = getSpan(MakerJs.point.average(pointA, pointB));
                        }
                        else {
                            //find the 2 potential origins
                            var origins = MakerJs.path.intersection(new Circle(pointA, this.radius), new Circle(pointB, this.radius));
                            var spans = [];
                            for (var i = origins.intersectionPoints.length; i--;) {
                                span = getSpan(origins.intersectionPoints[i]);
                                //insert sorted by size ascending
                                if (spans.length == 0 || span.size > spans[0].size) {
                                    spans.push(span);
                                }
                                else {
                                    spans.unshift(span);
                                }
                            }
                            var index = largeArc ? 1 : 0;
                            span = spans[index];
                        }
                        this.origin = span.origin;
                        this.startAngle = span.startAngle;
                        this.endAngle = span.endAngle;
                        break;
                    case 4:
                        this.origin = args[0];
                        this.radius = args[1];
                        this.startAngle = args[2];
                        this.endAngle = args[3];
                        break;
                    case 3:
                        if (MakerJs.isPoint(args[2])) {
                            //from 3 points
                            Circle.apply(this, args);
                            var angles = [];
                            for (var i = 0; i < 3; i++) {
                                angles.push(MakerJs.angle.ofPointInDegrees(this.origin, args[i]));
                            }
                            this.startAngle = angles[0];
                            this.endAngle = angles[2];
                            //swap start and end angles if this arc does not contain the midpoint
                            if (!MakerJs.measure.isBetweenArcAngles(angles[1], this, false)) {
                                this.startAngle = angles[2];
                                this.endAngle = angles[0];
                            }
                            //do not fall through if this was 3 points
                            break;
                        }
                    //fall through to below if 2 points
                    case 2:
                        //from 2 points (and optional clockwise flag)
                        var clockwise = args[2];
                        Circle.call(this, args[0], args[1]);
                        this.startAngle = MakerJs.angle.ofPointInDegrees(this.origin, args[clockwise ? 1 : 0]);
                        this.endAngle = MakerJs.angle.ofPointInDegrees(this.origin, args[clockwise ? 0 : 1]);
                        break;
                }
                //do this after Circle.apply / Circle.call to make sure this is an arc
                this.type = MakerJs.pathType.Arc;
            }
            return Arc;
        }());
        paths.Arc = Arc;
        /**
         * Class for circle path.
         */
        var Circle = (function () {
            function Circle() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.type = MakerJs.pathType.Circle;
                switch (args.length) {
                    case 1:
                        this.origin = [0, 0];
                        this.radius = args[0];
                        break;
                    case 2:
                        if (MakerJs.isNumber(args[1])) {
                            this.origin = args[0];
                            this.radius = args[1];
                        }
                        else {
                            //Circle from 2 points
                            this.origin = MakerJs.point.average(args[0], args[1]);
                            this.radius = MakerJs.measure.pointDistance(this.origin, args[0]);
                        }
                        break;
                    default:
                        //Circle from 3 points
                        //create 2 lines with 2nd point in common
                        var lines = [
                            new Line(args[0], args[1]),
                            new Line(args[1], args[2])
                        ];
                        //create perpendicular lines
                        var perpendiculars = [];
                        for (var i = 2; i--;) {
                            var midpoint = MakerJs.point.middle(lines[i]);
                            perpendiculars.push(MakerJs.path.rotate(lines[i], 90, midpoint));
                        }
                        //find intersection of slopes of perpendiculars
                        this.origin = MakerJs.point.fromSlopeIntersection(perpendiculars[0], perpendiculars[1]);
                        //radius is distance to any of the 3 points
                        this.radius = MakerJs.measure.pointDistance(this.origin, args[0]);
                        break;
                }
            }
            return Circle;
        }());
        paths.Circle = Circle;
        /**
         * Class for line path.
         */
        var Line = (function () {
            function Line() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.type = MakerJs.pathType.Line;
                switch (args.length) {
                    case 1:
                        var points = args[0];
                        this.origin = points[0];
                        this.end = points[1];
                        break;
                    case 2:
                        this.origin = args[0];
                        this.end = args[1];
                        break;
                }
            }
            return Line;
        }());
        paths.Line = Line;
        /**
         * Class for chord, which is simply a line path that connects the endpoints of an arc.
         *
         * @param arc Arc to use as the basic for the chord.
         */
        var Chord = (function () {
            function Chord(arc) {
                var arcPoints = MakerJs.point.fromArc(arc);
                this.type = MakerJs.pathType.Line;
                this.origin = arcPoints[0];
                this.end = arcPoints[1];
            }
            return Chord;
        }());
        paths.Chord = Chord;
        /**
         * Class for a parallel line path.
         *
         * @param toLine A line to be parallel to.
         * @param distance Distance between parallel and original line.
         * @param nearPoint Any point to determine which side of the line to place the parallel.
         */
        var Parallel = (function () {
            function Parallel(toLine, distance, nearPoint) {
                this.type = MakerJs.pathType.Line;
                this.origin = MakerJs.point.clone(toLine.origin);
                this.end = MakerJs.point.clone(toLine.end);
                var angleOfLine = MakerJs.angle.ofLineInDegrees(this);
                function getNewOrigin(offsetAngle) {
                    var origin = MakerJs.point.add(toLine.origin, MakerJs.point.fromPolar(MakerJs.angle.toRadians(angleOfLine + offsetAngle), distance));
                    return {
                        origin: origin,
                        nearness: MakerJs.measure.pointDistance(origin, nearPoint)
                    };
                }
                var newOrigins = [getNewOrigin(-90), getNewOrigin(90)];
                var newOrigin = (newOrigins[0].nearness < newOrigins[1].nearness) ? newOrigins[0].origin : newOrigins[1].origin;
                MakerJs.path.move(this, newOrigin);
            }
            return Parallel;
        }());
        paths.Parallel = Parallel;
    })(paths = MakerJs.paths || (MakerJs.paths = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * Count the number of child models within a given model.
         *
         * @param modelContext The model containing other models.
         * @returns Number of child models.
         */
        function countChildModels(modelContext) {
            var count = 0;
            if (modelContext.models) {
                for (var id in modelContext.models) {
                    count++;
                }
            }
            return count;
        }
        model.countChildModels = countChildModels;
        /**
         * Get an unused id in the models map with the same prefix.
         *
         * @param modelContext The model containing the models map.
         * @param modelId The id to use directly (if unused), or as a prefix.
         */
        function getSimilarModelId(modelContext, modelId) {
            if (!modelContext.models)
                return modelId;
            var i = 0;
            var newModelId = modelId;
            while (newModelId in modelContext.models) {
                i++;
                newModelId = modelId + '_' + i;
            }
            return newModelId;
        }
        model.getSimilarModelId = getSimilarModelId;
        /**
         * Get an unused id in the paths map with the same prefix.
         *
         * @param modelContext The model containing the paths map.
         * @param pathId The id to use directly (if unused), or as a prefix.
         */
        function getSimilarPathId(modelContext, pathId) {
            if (!modelContext.paths)
                return pathId;
            var i = 0;
            var newPathId = pathId;
            while (newPathId in modelContext.paths) {
                i++;
                newPathId = pathId + '_' + i;
            }
            return newPathId;
        }
        model.getSimilarPathId = getSimilarPathId;
        /**
         * Moves all of a model's children (models and paths, recursively) in reference to a single common origin. Useful when points between children need to connect to each other.
         *
         * @param modelToOriginate The model to originate.
         * @param origin Optional offset reference point.
         */
        function originate(modelToOriginate, origin) {
            function innerOriginate(m, o) {
                if (!m)
                    return;
                var newOrigin = MakerJs.point.add(m.origin, o);
                if (m.type === MakerJs.models.BezierCurve.typeName) {
                    MakerJs.path.moveRelative(m.seed, newOrigin);
                }
                if (m.paths) {
                    for (var id in m.paths) {
                        MakerJs.path.moveRelative(m.paths[id], newOrigin);
                    }
                }
                if (m.models) {
                    for (var id in m.models) {
                        innerOriginate(m.models[id], newOrigin);
                    }
                }
                m.origin = MakerJs.point.zero();
            }
            innerOriginate(modelToOriginate, origin ? MakerJs.point.subtract([0, 0], origin) : [0, 0]);
            if (origin) {
                modelToOriginate.origin = origin;
            }
            return modelToOriginate;
        }
        model.originate = originate;
        /**
         * Center a model at [0, 0].
         *
         * @param modelToCenter The model to center.
         */
        function center(modelToCenter) {
            var m = MakerJs.measure.modelExtents(modelToCenter);
            var c = MakerJs.point.average(m.high, m.low);
            var o = MakerJs.point.subtract(modelToCenter.origin || [0, 0], c);
            modelToCenter.origin = o;
            return modelToCenter;
        }
        model.center = center;
        /**
         * Create a clone of a model, mirrored on either or both x and y axes.
         *
         * @param modelToMirror The model to mirror.
         * @param mirrorX Boolean to mirror on the x axis.
         * @param mirrorY Boolean to mirror on the y axis.
         * @returns Mirrored model.
         */
        function mirror(modelToMirror, mirrorX, mirrorY) {
            var newModel = {};
            if (!modelToMirror)
                return null;
            if (modelToMirror.origin) {
                newModel.origin = MakerJs.point.mirror(modelToMirror.origin, mirrorX, mirrorY);
            }
            if (modelToMirror.type) {
                newModel.type = modelToMirror.type;
            }
            if (modelToMirror.units) {
                newModel.units = modelToMirror.units;
            }
            if (modelToMirror.type === MakerJs.models.BezierCurve.typeName) {
                newModel.type = MakerJs.models.BezierCurve.typeName;
                newModel.seed = MakerJs.path.mirror(modelToMirror.seed, mirrorX, mirrorY);
            }
            if (modelToMirror.paths) {
                newModel.paths = {};
                for (var id in modelToMirror.paths) {
                    var pathToMirror = modelToMirror.paths[id];
                    if (!pathToMirror)
                        continue;
                    var pathMirrored = MakerJs.path.mirror(pathToMirror, mirrorX, mirrorY);
                    if (!pathMirrored)
                        continue;
                    newModel.paths[id] = pathMirrored;
                }
            }
            if (modelToMirror.models) {
                newModel.models = {};
                for (var id in modelToMirror.models) {
                    var childModelToMirror = modelToMirror.models[id];
                    if (!childModelToMirror)
                        continue;
                    var childModelMirrored = mirror(childModelToMirror, mirrorX, mirrorY);
                    if (!childModelMirrored)
                        continue;
                    newModel.models[id] = childModelMirrored;
                }
            }
            return newModel;
        }
        model.mirror = mirror;
        /**
         * Move a model to an absolute point. Note that this is also accomplished by directly setting the origin property. This function exists for cascading.
         *
         * @param modelToMove The model to move.
         * @param origin The new position of the model.
         * @returns The original model (for cascading).
         */
        function move(modelToMove, origin) {
            modelToMove.origin = MakerJs.point.clone(origin);
            return modelToMove;
        }
        model.move = move;
        /**
         * Move a model's origin by a relative amount.
         *
         * @param modelToMove The model to move.
         * @param delta The x & y adjustments as a point object.
         * @returns The original model (for cascading).
         */
        function moveRelative(modelToMove, delta) {
            if (modelToMove) {
                modelToMove.origin = MakerJs.point.add(modelToMove.origin || MakerJs.point.zero(), delta);
            }
            return modelToMove;
        }
        model.moveRelative = moveRelative;
        /**
         * Prefix the ids of paths in a model.
         *
         * @param modelToPrefix The model to prefix.
         * @param prefix The prefix to prepend on paths ids.
         * @returns The original model (for cascading).
         */
        function prefixPathIds(modelToPrefix, prefix) {
            var walkedPaths = [];
            //first collect the paths because we don't want to modify keys during an iteration on keys
            walk(modelToPrefix, {
                onPath: function (walkedPath) {
                    walkedPaths.push(walkedPath);
                }
            });
            //now modify the ids in our own iteration
            for (var i = 0; i < walkedPaths.length; i++) {
                var walkedPath = walkedPaths[i];
                delete walkedPath.modelContext.paths[walkedPath.pathId];
                walkedPath.modelContext.paths[prefix + walkedPath.pathId] = walkedPath.pathContext;
            }
            return modelToPrefix;
        }
        model.prefixPathIds = prefixPathIds;
        /**
         * Rotate a model.
         *
         * @param modelToRotate The model to rotate.
         * @param angleInDegrees The amount of rotation, in degrees.
         * @param rotationOrigin The center point of rotation.
         * @returns The original model (for cascading).
         */
        function rotate(modelToRotate, angleInDegrees, rotationOrigin) {
            if (rotationOrigin === void 0) { rotationOrigin = [0, 0]; }
            if (modelToRotate) {
                var offsetOrigin = MakerJs.point.subtract(rotationOrigin, modelToRotate.origin);
                if (modelToRotate.type === MakerJs.models.BezierCurve.typeName) {
                    MakerJs.path.rotate(modelToRotate.seed, angleInDegrees, offsetOrigin);
                }
                if (modelToRotate.paths) {
                    for (var id in modelToRotate.paths) {
                        MakerJs.path.rotate(modelToRotate.paths[id], angleInDegrees, offsetOrigin);
                    }
                }
                if (modelToRotate.models) {
                    for (var id in modelToRotate.models) {
                        rotate(modelToRotate.models[id], angleInDegrees, offsetOrigin);
                    }
                }
            }
            return modelToRotate;
        }
        model.rotate = rotate;
        /**
         * Scale a model.
         *
         * @param modelToScale The model to scale.
         * @param scaleValue The amount of scaling.
         * @param scaleOrigin Optional boolean to scale the origin point. Typically false for the root model.
         * @returns The original model (for cascading).
         */
        function scale(modelToScale, scaleValue, scaleOrigin) {
            if (scaleOrigin === void 0) { scaleOrigin = false; }
            if (scaleOrigin && modelToScale.origin) {
                modelToScale.origin = MakerJs.point.scale(modelToScale.origin, scaleValue);
            }
            if (modelToScale.type === MakerJs.models.BezierCurve.typeName) {
                MakerJs.path.scale(modelToScale.seed, scaleValue);
            }
            if (modelToScale.paths) {
                for (var id in modelToScale.paths) {
                    MakerJs.path.scale(modelToScale.paths[id], scaleValue);
                }
            }
            if (modelToScale.models) {
                for (var id in modelToScale.models) {
                    scale(modelToScale.models[id], scaleValue, true);
                }
            }
            return modelToScale;
        }
        model.scale = scale;
        /**
         * Convert a model to match a different unit system.
         *
         * @param modeltoConvert The model to convert.
         * @param destUnitType The unit system.
         * @returns The scaled model (for cascading).
         */
        function convertUnits(modeltoConvert, destUnitType) {
            var validUnitType = false;
            for (var id in MakerJs.unitType) {
                if (MakerJs.unitType[id] == destUnitType) {
                    validUnitType = true;
                    break;
                }
            }
            if (modeltoConvert.units && validUnitType) {
                var ratio = MakerJs.units.conversionScale(modeltoConvert.units, destUnitType);
                if (ratio != 1) {
                    scale(modeltoConvert, ratio);
                    //update the model with its new unit type
                    modeltoConvert.units = destUnitType;
                }
            }
            return modeltoConvert;
        }
        model.convertUnits = convertUnits;
        /**
         * Recursively walk through all paths for a given model.
         *
         * @param modelContext The model to walk.
         * @param callback Callback for each path.
         */
        function walkPaths(modelContext, callback) {
            if (modelContext.paths) {
                for (var pathId in modelContext.paths) {
                    if (!modelContext.paths[pathId])
                        continue;
                    callback(modelContext, pathId, modelContext.paths[pathId]);
                }
            }
            if (modelContext.models) {
                for (var id in modelContext.models) {
                    if (!modelContext.models[id])
                        continue;
                    walkPaths(modelContext.models[id], callback);
                }
            }
        }
        model.walkPaths = walkPaths;
        /**
         * Recursively walk through all paths for a given model.
         *
         * @param modelContext The model to walk.
         * @param pathCallback Callback for each path.
         * @param modelCallbackBeforeWalk Callback for each model prior to recursion, which can cancel the recursion if it returns false.
         * @param modelCallbackAfterWalk Callback for each model after recursion.
         */
        function walk(modelContext, options) {
            if (!modelContext)
                return;
            function walkRecursive(modelContext, layer, offset, route, routeKey) {
                var newOffset = MakerJs.point.add(modelContext.origin, offset);
                layer = layer || '';
                if (modelContext.paths) {
                    for (var pathId in modelContext.paths) {
                        var pathContext = modelContext.paths[pathId];
                        if (!pathContext)
                            continue;
                        var walkedPath = {
                            modelContext: modelContext,
                            layer: pathContext.layer || layer,
                            offset: newOffset,
                            pathContext: pathContext,
                            pathId: pathId,
                            route: route.concat(['paths', pathId]),
                            routeKey: routeKey + '.paths' + JSON.stringify([pathId])
                        };
                        if (options.onPath)
                            options.onPath(walkedPath);
                    }
                }
                if (modelContext.models) {
                    for (var modelId in modelContext.models) {
                        var childModel = modelContext.models[modelId];
                        if (!childModel)
                            continue;
                        var walkedModel = {
                            parentModel: modelContext,
                            layer: childModel.layer || layer,
                            offset: newOffset,
                            route: route.concat(['models', modelId]),
                            routeKey: routeKey + '.models' + JSON.stringify([modelId]),
                            childId: modelId,
                            childModel: childModel
                        };
                        if (options.beforeChildWalk) {
                            if (!options.beforeChildWalk(walkedModel))
                                continue;
                        }
                        walkRecursive(walkedModel.childModel, walkedModel.layer, newOffset, walkedModel.route, walkedModel.routeKey);
                        if (options.afterChildWalk) {
                            options.afterChildWalk(walkedModel);
                        }
                    }
                }
            }
            walkRecursive(modelContext, '', [0, 0], [], '');
        }
        model.walk = walk;
        /**
         * Move a model so its bounding box begins at [0, 0].
         *
         * @param modelToZero The model to zero.
         */
        function zero(modelToZero) {
            var m = MakerJs.measure.modelExtents(modelToZero);
            var z = MakerJs.point.subtract(modelToZero.origin || [0, 0], m.low);
            modelToZero.origin = z;
            return modelToZero;
        }
        model.zero = zero;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * @private
         */
        function getNonZeroSegments(pathToSegment, breakPoint) {
            var segment1 = MakerJs.cloneObject(pathToSegment);
            if (!segment1)
                return null;
            var segment2 = MakerJs.path.breakAtPoint(segment1, breakPoint);
            if (segment2) {
                var segments = [segment1, segment2];
                for (var i = 2; i--;) {
                    if (MakerJs.round(MakerJs.measure.pathLength(segments[i]), .0001) == 0) {
                        return null;
                    }
                }
                return segments;
            }
            else if (pathToSegment.type == MakerJs.pathType.Circle) {
                return [segment1];
            }
            return null;
        }
        /**
         * @private
         */
        function breakAlongForeignPath(crossedPath, overlappedSegments, foreignWalkedPath) {
            var foreignPath = foreignWalkedPath.pathContext;
            var segments = crossedPath.segments;
            if (MakerJs.measure.isPathEqual(segments[0].path, foreignPath, .0001, crossedPath.offset, foreignWalkedPath.offset)) {
                segments[0].overlapped = true;
                segments[0].duplicate = true;
                overlappedSegments.push(segments[0]);
                return;
            }
            var foreignPathEndPoints;
            for (var i = 0; i < segments.length; i++) {
                var pointsToCheck;
                var options = { path1Offset: crossedPath.offset, path2Offset: foreignWalkedPath.offset };
                var foreignIntersection = MakerJs.path.intersection(segments[i].path, foreignPath, options);
                if (foreignIntersection) {
                    pointsToCheck = foreignIntersection.intersectionPoints;
                }
                else if (options.out_AreOverlapped) {
                    segments[i].overlapped = true;
                    overlappedSegments.push(segments[i]);
                    if (!foreignPathEndPoints) {
                        //make sure endpoints are in absolute coords
                        foreignPathEndPoints = MakerJs.point.fromPathEnds(foreignPath, foreignWalkedPath.offset);
                    }
                    pointsToCheck = foreignPathEndPoints;
                }
                if (pointsToCheck) {
                    //break the path which intersected, and add the shard to the end of the array so it can also be checked in this loop for further sharding.
                    var subSegments = null;
                    var p = 0;
                    while (!subSegments && p < pointsToCheck.length) {
                        //cast absolute points to path relative space
                        subSegments = getNonZeroSegments(segments[i].path, MakerJs.point.subtract(pointsToCheck[p], crossedPath.offset));
                        p++;
                    }
                    if (subSegments) {
                        crossedPath.broken = true;
                        segments[i].path = subSegments[0];
                        if (subSegments[1]) {
                            var newSegment = {
                                path: subSegments[1],
                                pathId: segments[0].pathId,
                                overlapped: segments[i].overlapped,
                                uniqueForeignIntersectionPoints: [],
                                offset: crossedPath.offset
                            };
                            if (segments[i].overlapped) {
                                overlappedSegments.push(newSegment);
                            }
                            segments.push(newSegment);
                        }
                        //re-check this segment for another deep intersection
                        i--;
                    }
                }
            }
        }
        /**
         * @private
         */
        function addUniquePoints(pointArray, pointsToAdd) {
            var added = 0;
            function addUniquePoint(pointToAdd) {
                for (var i = 0; i < pointArray.length; i++) {
                    if (MakerJs.measure.isPointEqual(pointArray[i], pointToAdd, .000000001)) {
                        return;
                    }
                }
                pointArray.push(pointToAdd);
                added++;
            }
            for (var i = 0; i < pointsToAdd.length; i++) {
                addUniquePoint(pointsToAdd[i]);
            }
            return added;
        }
        /**
         * @private
         */
        function checkInsideForeignModel(segment, segmentOffset, modelToIntersect, modelToIntersectAtlas, farPoint) {
            if (farPoint === void 0) { farPoint = [7654321, 1234567]; }
            var origin = MakerJs.point.add(MakerJs.point.middle(segment.path), segmentOffset);
            var lineToFarPoint = new MakerJs.paths.Line(origin, farPoint);
            var measureFarPoint = MakerJs.measure.pathExtents(lineToFarPoint);
            var walkOptions = {
                onPath: function (walkedPath) {
                    if (modelToIntersectAtlas && !MakerJs.measure.isMeasurementOverlapping(measureFarPoint, modelToIntersectAtlas.pathMap[walkedPath.routeKey])) {
                        return;
                    }
                    var options = { path2Offset: walkedPath.offset };
                    var farInt = MakerJs.path.intersection(lineToFarPoint, walkedPath.pathContext, options);
                    if (farInt) {
                        var added = addUniquePoints(segment.uniqueForeignIntersectionPoints, farInt.intersectionPoints);
                        //if number of intersections is an odd number, flip the flag.
                        if (added % 2 == 1) {
                            segment.isInside = !!!segment.isInside;
                        }
                    }
                },
                beforeChildWalk: function (innerWalkedModel) {
                    if (!modelToIntersectAtlas) {
                        return true;
                    }
                    //see if there is a model measurement. if not, it is because the model does not contain paths.
                    var innerModelMeasurement = modelToIntersectAtlas.modelMap[innerWalkedModel.routeKey];
                    return innerModelMeasurement && MakerJs.measure.isMeasurementOverlapping(measureFarPoint, innerModelMeasurement);
                }
            };
            model.walk(modelToIntersect, walkOptions);
        }
        /**
         * Check to see if a path is inside of a model.
         *
         * @param pathContext The path to check.
         * @param modelContext The model to check against.
         * @param farPoint Optional point of reference which is outside the bounds of the modelContext.
         * @returns Boolean true if the path is inside of the modelContext.
         */
        function isPathInsideModel(pathContext, modelContext, pathOffset, farPoint, measureAtlas) {
            var segment = {
                path: pathContext,
                isInside: false,
                uniqueForeignIntersectionPoints: []
            };
            checkInsideForeignModel(segment, pathOffset, modelContext, measureAtlas, farPoint);
            return !!segment.isInside;
        }
        model.isPathInsideModel = isPathInsideModel;
        /**
         * Break a model's paths everywhere they intersect with another path.
         *
         * @param modelToBreak The model containing paths to be broken.
         * @param modelToIntersect Optional model containing paths to look for intersection, or else the modelToBreak will be used.
         */
        function breakPathsAtIntersections(modelToBreak, modelToIntersect) {
            var modelToBreakAtlas = new MakerJs.measure.Atlas(modelToBreak);
            modelToBreakAtlas.measureModels();
            var modelToIntersectAtlas;
            if (!modelToIntersect) {
                modelToIntersect = modelToBreak;
                modelToIntersectAtlas = modelToBreakAtlas;
            }
            else {
                modelToIntersectAtlas = new MakerJs.measure.Atlas(modelToIntersect);
                modelToIntersectAtlas.measureModels();
            }
            ;
            breakAllPathsAtIntersections(modelToBreak, modelToIntersect || modelToBreak, false, modelToBreakAtlas, modelToIntersectAtlas);
        }
        model.breakPathsAtIntersections = breakPathsAtIntersections;
        /**
         * @private
         */
        function breakAllPathsAtIntersections(modelToBreak, modelToIntersect, checkIsInside, modelToBreakAtlas, modelToIntersectAtlas, farPoint) {
            var crossedPaths = [];
            var overlappedSegments = [];
            var walkModelToBreakOptions = {
                onPath: function (outerWalkedPath) {
                    //clone this path and make it the first segment
                    var segment = {
                        path: MakerJs.cloneObject(outerWalkedPath.pathContext),
                        pathId: outerWalkedPath.pathId,
                        overlapped: false,
                        uniqueForeignIntersectionPoints: [],
                        offset: outerWalkedPath.offset
                    };
                    var thisPath = outerWalkedPath;
                    thisPath.broken = false;
                    thisPath.segments = [segment];
                    var walkModelToIntersectOptions = {
                        onPath: function (innerWalkedPath) {
                            if (outerWalkedPath.pathContext !== innerWalkedPath.pathContext && MakerJs.measure.isMeasurementOverlapping(modelToBreakAtlas.pathMap[outerWalkedPath.routeKey], modelToIntersectAtlas.pathMap[innerWalkedPath.routeKey])) {
                                breakAlongForeignPath(thisPath, overlappedSegments, innerWalkedPath);
                            }
                        },
                        beforeChildWalk: function (innerWalkedModel) {
                            //see if there is a model measurement. if not, it is because the model does not contain paths.
                            var innerModelMeasurement = modelToIntersectAtlas.modelMap[innerWalkedModel.routeKey];
                            return innerModelMeasurement && MakerJs.measure.isMeasurementOverlapping(modelToBreakAtlas.pathMap[outerWalkedPath.routeKey], innerModelMeasurement);
                        }
                    };
                    //keep breaking the segments anywhere they intersect with paths of the other model
                    model.walk(modelToIntersect, walkModelToIntersectOptions);
                    if (checkIsInside) {
                        //check each segment whether it is inside or outside
                        for (var i = 0; i < thisPath.segments.length; i++) {
                            checkInsideForeignModel(thisPath.segments[i], thisPath.offset, modelToIntersect, modelToIntersectAtlas, farPoint);
                        }
                    }
                    crossedPaths.push(thisPath);
                }
            };
            model.walk(modelToBreak, walkModelToBreakOptions);
            return { crossedPaths: crossedPaths, overlappedSegments: overlappedSegments };
        }
        /**
         * @private
         */
        function checkForEqualOverlaps(crossedPathsA, crossedPathsB, pointMatchingDistance) {
            function compareSegments(segment1, segment2) {
                if (MakerJs.measure.isPathEqual(segment1.path, segment2.path, pointMatchingDistance, segment1.offset, segment2.offset)) {
                    segment1.duplicate = segment2.duplicate = true;
                }
            }
            function compareAll(segment) {
                for (var i = 0; i < crossedPathsB.length; i++) {
                    compareSegments(crossedPathsB[i], segment);
                }
            }
            for (var i = 0; i < crossedPathsA.length; i++) {
                compareAll(crossedPathsA[i]);
            }
        }
        /**
         * @private
         */
        function addOrDeleteSegments(crossedPath, includeInside, includeOutside, keepDuplicates, atlas) {
            function addSegment(modelContext, pathIdBase, segment) {
                var id = model.getSimilarPathId(modelContext, pathIdBase);
                var newRouteKey = (id == pathIdBase) ? crossedPath.routeKey : MakerJs.createRouteKey(crossedPath.route.slice(0, -1).concat([id]));
                modelContext.paths[id] = segment.path;
                if (crossedPath.broken) {
                    //save the new segment's measurement
                    var measurement = MakerJs.measure.pathExtents(segment.path, crossedPath.offset);
                    atlas.pathMap[newRouteKey] = measurement;
                    atlas.modelsMeasured = false;
                }
                else {
                    //keep the original measurement
                    atlas.pathMap[newRouteKey] = savedMeasurement;
                }
            }
            function checkAddSegment(modelContext, pathIdBase, segment) {
                if (segment.isInside && includeInside || !segment.isInside && includeOutside) {
                    addSegment(modelContext, pathIdBase, segment);
                }
                else {
                    atlas.modelsMeasured = false;
                }
            }
            //save the original measurement
            var savedMeasurement = atlas.pathMap[crossedPath.routeKey];
            //delete the original, its segments will be added
            delete crossedPath.modelContext.paths[crossedPath.pathId];
            delete atlas.pathMap[crossedPath.routeKey];
            for (var i = 0; i < crossedPath.segments.length; i++) {
                if (crossedPath.segments[i].duplicate) {
                    if (keepDuplicates) {
                        addSegment(crossedPath.modelContext, crossedPath.pathId, crossedPath.segments[i]);
                    }
                }
                else {
                    checkAddSegment(crossedPath.modelContext, crossedPath.pathId, crossedPath.segments[i]);
                }
            }
        }
        /**
         * Combine 2 models.
         *
         * @param modelA First model to combine.
         * @param modelB Second model to combine.
         * @param includeAInsideB Flag to include paths from modelA which are inside of modelB.
         * @param includeAOutsideB Flag to include paths from modelA which are outside of modelB.
         * @param includeBInsideA Flag to include paths from modelB which are inside of modelA.
         * @param includeBOutsideA Flag to include paths from modelB which are outside of modelA.
         * @param keepDuplicates Flag to include paths which are duplicate in both models.
         * @param farPoint Optional point of reference which is outside the bounds of both models.
         */
        function combine(modelA, modelB, includeAInsideB, includeAOutsideB, includeBInsideA, includeBOutsideA, options) {
            if (includeAInsideB === void 0) { includeAInsideB = false; }
            if (includeAOutsideB === void 0) { includeAOutsideB = true; }
            if (includeBInsideA === void 0) { includeBInsideA = false; }
            if (includeBOutsideA === void 0) { includeBOutsideA = true; }
            var opts = {
                trimDeadEnds: true,
                pointMatchingDistance: .005
            };
            MakerJs.extendObject(opts, options);
            opts.measureA = opts.measureA || new MakerJs.measure.Atlas(modelA);
            opts.measureB = opts.measureB || new MakerJs.measure.Atlas(modelB);
            //make sure model measurements capture all paths
            opts.measureA.measureModels();
            opts.measureB.measureModels();
            var pathsA = breakAllPathsAtIntersections(modelA, modelB, true, opts.measureA, opts.measureB, opts.farPoint);
            var pathsB = breakAllPathsAtIntersections(modelB, modelA, true, opts.measureB, opts.measureA, opts.farPoint);
            checkForEqualOverlaps(pathsA.overlappedSegments, pathsB.overlappedSegments, opts.pointMatchingDistance);
            for (var i = 0; i < pathsA.crossedPaths.length; i++) {
                addOrDeleteSegments(pathsA.crossedPaths[i], includeAInsideB, includeAOutsideB, true, opts.measureA);
            }
            for (var i = 0; i < pathsB.crossedPaths.length; i++) {
                addOrDeleteSegments(pathsB.crossedPaths[i], includeBInsideA, includeBOutsideA, false, opts.measureB);
            }
            if (opts.trimDeadEnds) {
                var shouldKeep;
                //union
                if (!includeAInsideB && !includeBInsideA) {
                    shouldKeep = function (walkedPath) {
                        //When A and B share an outer contour, the segments marked as duplicate will not pass the "inside" test on either A or B.
                        //Duplicates were discarded from B but kept in A
                        for (var i = 0; i < pathsA.overlappedSegments.length; i++) {
                            if (pathsA.overlappedSegments[i].duplicate && walkedPath.pathContext === pathsA.overlappedSegments[i].path) {
                                return false;
                            }
                        }
                        //default - keep the path
                        return true;
                    };
                }
                model.removeDeadEnds({ models: { modelA: modelA, modelB: modelB } }, null, shouldKeep);
            }
            //pass options back to caller
            MakerJs.extendObject(options, opts);
        }
        model.combine = combine;
        /**
         * Combine 2 models, resulting in a intersection.
         *
         * @param modelA First model to combine.
         * @param modelB Second model to combine.
         */
        function combineIntersection(modelA, modelB) {
            return combine(modelA, modelB, true, false, true, false);
        }
        model.combineIntersection = combineIntersection;
        /**
         * Combine 2 models, resulting in a subtraction of B from A.
         *
         * @param modelA First model to combine.
         * @param modelB Second model to combine.
         */
        function combineSubtraction(modelA, modelB) {
            return combine(modelA, modelB, false, true, true, false);
        }
        model.combineSubtraction = combineSubtraction;
        /**
         * Combine 2 models, resulting in a union.
         *
         * @param modelA First model to combine.
         * @param modelB Second model to combine.
         */
        function combineUnion(modelA, modelB) {
            return combine(modelA, modelB, false, true, false, true);
        }
        model.combineUnion = combineUnion;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    /**
     * Collects items that share a common key.
     */
    var Collector = (function () {
        function Collector(comparer) {
            this.comparer = comparer;
            this.collections = [];
        }
        Collector.prototype.addItemToCollection = function (key, item) {
            var found = this.findCollection(key);
            if (found) {
                found.push(item);
            }
            else {
                var collection = { key: key, items: [item] };
                this.collections.push(collection);
            }
        };
        Collector.prototype.findCollection = function (key, action) {
            for (var i = 0; i < this.collections.length; i++) {
                var collection = this.collections[i];
                if (this.comparer(key, collection.key)) {
                    if (action) {
                        action(i);
                    }
                    return collection.items;
                }
            }
            return null;
        };
        Collector.prototype.removeCollection = function (key) {
            var _this = this;
            if (this.findCollection(key, function (index) { _this.collections.splice(index, 1); })) {
                return true;
            }
            return false;
        };
        Collector.prototype.removeItemFromCollection = function (key, item) {
            var collection = this.findCollection(key);
            if (!collection)
                return;
            for (var i = 0; i < collection.length; i++) {
                if (collection[i] === item) {
                    collection.splice(i, 1);
                    return true;
                }
            }
            return false;
        };
        Collector.prototype.getCollectionsOfMultiple = function (cb) {
            for (var i = 0; i < this.collections.length; i++) {
                var collection = this.collections[i];
                if (collection.items.length > 1) {
                    cb(collection.key, collection.items);
                }
            }
        };
        return Collector;
    }());
    MakerJs.Collector = Collector;
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * @private
         */
        function checkForOverlaps(refPaths, isOverlapping, overlapUnion) {
            var currIndex = 0;
            do {
                var root = refPaths[currIndex];
                do {
                    var overlaps = false;
                    for (var i = currIndex + 1; i < refPaths.length; i++) {
                        var arcRef = refPaths[i];
                        overlaps = isOverlapping(root.pathContext, arcRef.pathContext, false);
                        if (overlaps) {
                            overlapUnion(root.pathContext, arcRef.pathContext);
                            delete arcRef.modelContext.paths[arcRef.pathId];
                            refPaths.splice(i, 1);
                            break;
                        }
                    }
                } while (overlaps);
                currIndex++;
            } while (currIndex < refPaths.length);
        }
        /**
         * Simplify a model's paths by reducing redundancy: combine multiple overlapping paths into a single path. The model must be originated.
         *
         * @param modelContext The originated model to search for similar paths.
         * @param options Optional options object.
         * @returns The simplified model (for cascading).
         */
        function simplify(modelToSimplify, options) {
            function compareCircles(circleA, circleB) {
                if (Math.abs(circleA.radius - circleB.radius) <= opts.scalarMatchingDistance) {
                    var distance = MakerJs.measure.pointDistance(circleA.origin, circleB.origin);
                    return distance <= opts.pointMatchingDistance;
                }
                return false;
            }
            var similarArcs = new MakerJs.Collector(compareCircles);
            var similarCircles = new MakerJs.Collector(compareCircles);
            var similarLines = new MakerJs.Collector(MakerJs.measure.isSlopeEqual);
            var map = {};
            map[MakerJs.pathType.Arc] = function (arcRef) {
                similarArcs.addItemToCollection(arcRef.pathContext, arcRef);
            };
            map[MakerJs.pathType.Circle] = function (circleRef) {
                similarCircles.addItemToCollection(circleRef.pathContext, circleRef);
            };
            map[MakerJs.pathType.Line] = function (lineRef) {
                var slope = MakerJs.measure.lineSlope(lineRef.pathContext);
                similarLines.addItemToCollection(slope, lineRef);
            };
            var opts = {
                scalarMatchingDistance: .001,
                pointMatchingDistance: .005
            };
            MakerJs.extendObject(opts, options);
            //walk the model and collect: arcs on same center / radius, circles on same center / radius, lines on same y-intercept / slope.
            var walkOptions = {
                onPath: function (walkedPath) {
                    var fn = map[walkedPath.pathContext.type];
                    if (fn) {
                        fn(walkedPath);
                    }
                }
            };
            model.walk(modelToSimplify, walkOptions);
            //for all arcs that are similar, see if they overlap.
            //combine overlapping arcs into the first one and delete the second.
            similarArcs.getCollectionsOfMultiple(function (key, arcRefs) {
                checkForOverlaps(arcRefs, MakerJs.measure.isArcOverlapping, function (arcA, arcB) {
                    //find ends within the other
                    var aEndsInB = MakerJs.measure.isBetweenArcAngles(arcA.endAngle, arcB, false);
                    var bEndsInA = MakerJs.measure.isBetweenArcAngles(arcB.endAngle, arcA, false);
                    //check for complete circle
                    if (aEndsInB && bEndsInA) {
                        arcA.endAngle = arcA.startAngle + 360;
                        return;
                    }
                    //find the leader, in polar terms
                    var ordered = aEndsInB ? [arcA, arcB] : [arcB, arcA];
                    //save in arcA
                    arcA.startAngle = MakerJs.angle.noRevolutions(ordered[0].startAngle);
                    arcA.endAngle = ordered[1].endAngle;
                });
            });
            //for all circles that are similar, delete all but the first.
            similarCircles.getCollectionsOfMultiple(function (key, circleRefs) {
                for (var i = 1; i < circleRefs.length; i++) {
                    var circleRef = circleRefs[i];
                    delete circleRef.modelContext.paths[circleRef.pathId];
                }
            });
            //for all lines that are similar, see if they overlap.
            //combine overlapping lines into the first one and delete the second.
            similarLines.getCollectionsOfMultiple(function (slope, arcRefs) {
                checkForOverlaps(arcRefs, MakerJs.measure.isLineOverlapping, function (lineA, lineB) {
                    var box = { paths: { lineA: lineA, lineB: lineB } };
                    var m = MakerJs.measure.modelExtents(box);
                    if (!slope.hasSlope) {
                        //vertical
                        lineA.origin[1] = m.low[1];
                        lineA.end[1] = m.high[1];
                    }
                    else {
                        //non-vertical
                        if (slope.slope < 0) {
                            //downward
                            lineA.origin = [m.low[0], m.high[1]];
                            lineA.end = [m.high[0], m.low[1]];
                        }
                        else if (slope.slope > 0) {
                            //upward
                            lineA.origin = m.low;
                            lineA.end = m.high;
                        }
                        else {
                            //horizontal
                            lineA.origin[0] = m.low[0];
                            lineA.end[0] = m.high[0];
                        }
                    }
                });
            });
            return modelToSimplify;
        }
        model.simplify = simplify;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var path;
    (function (path) {
        /**
         * @private
         */
        var map = {};
        map[MakerJs.pathType.Arc] = function (arc, expansion, isolateCaps) {
            return new MakerJs.models.OvalArc(arc.startAngle, arc.endAngle, arc.radius, expansion, false, isolateCaps);
        };
        map[MakerJs.pathType.Circle] = function (circle, expansion, isolateCaps) {
            return new MakerJs.models.Ring(circle.radius + expansion, circle.radius - expansion);
        };
        map[MakerJs.pathType.Line] = function (line, expansion, isolateCaps) {
            return new MakerJs.models.Slot(line.origin, line.end, expansion, isolateCaps);
        };
        /**
         * Expand path by creating a model which surrounds it.
         *
         * @param pathToExpand Path to expand.
         * @param expansion Distance to expand.
         * @param isolateCaps Optional flag to put the end caps into a separate model named "caps".
         * @returns Model which surrounds the path.
         */
        function expand(pathToExpand, expansion, isolateCaps) {
            if (!pathToExpand)
                return null;
            var result = null;
            var fn = map[pathToExpand.type];
            if (fn) {
                result = fn(pathToExpand, expansion, isolateCaps);
                result.origin = pathToExpand.origin;
            }
            return result;
        }
        path.expand = expand;
        /**
         * Represent an arc using straight lines.
         *
         * @param arc Arc to straighten.
         * @param bevel Optional flag to bevel the angle to prevent it from being too sharp.
         * @param prefix Optional string prefix to apply to path ids.
         * @param close Optional flag to make a closed geometry by connecting the endpoints.
         * @returns Model of straight lines with same endpoints as the arc.
         */
        function straighten(arc, bevel, prefix, close) {
            var arcSpan = MakerJs.angle.ofArcSpan(arc);
            var joints = 1;
            if (arcSpan >= 270) {
                joints = 4;
            }
            else if (arcSpan > 180) {
                joints = 3;
            }
            else if (arcSpan > 150 || bevel) {
                joints = 2;
            }
            var jointAngleInRadians = MakerJs.angle.toRadians(arcSpan / joints);
            var circumscribedRadius = MakerJs.models.Polygon.circumscribedRadius(arc.radius, jointAngleInRadians);
            var ends = MakerJs.point.fromArc(arc);
            var points = [MakerJs.point.subtract(ends[0], arc.origin)];
            var a = MakerJs.angle.toRadians(arc.startAngle) + jointAngleInRadians / 2;
            for (var i = 0; i < joints; i++) {
                points.push(MakerJs.point.fromPolar(a, circumscribedRadius));
                a += jointAngleInRadians;
            }
            points.push(MakerJs.point.subtract(ends[1], arc.origin));
            var result = new MakerJs.models.ConnectTheDots(close, points);
            result.origin = arc.origin;
            if (typeof prefix === 'string' && prefix.length) {
                MakerJs.model.prefixPathIds(result, prefix);
            }
            return result;
        }
        path.straighten = straighten;
    })(path = MakerJs.path || (MakerJs.path = {}));
})(MakerJs || (MakerJs = {}));
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * Expand all paths in a model, then combine the resulting expansions.
         *
         * @param modelToExpand Model to expand.
         * @param distance Distance to expand.
         * @param joints Number of points at a joint between paths. Use 0 for round joints, 1 for pointed joints, 2 for beveled joints.
         * @returns Model which surrounds the paths of the original model.
         */
        function expandPaths(modelToExpand, distance, joints, combineOptions) {
            if (joints === void 0) { joints = 0; }
            if (combineOptions === void 0) { combineOptions = {}; }
            if (distance <= 0)
                return null;
            var result = {
                models: {
                    expansions: { models: {} },
                    caps: { models: {} }
                }
            };
            var first = true;
            var walkOptions = {
                onPath: function (walkedPath) {
                    //don't expand paths shorter than the tolerance for combine operations
                    if (combineOptions.pointMatchingDistance && MakerJs.measure.pathLength(walkedPath.pathContext) < combineOptions.pointMatchingDistance)
                        return;
                    var expandedPathModel = MakerJs.path.expand(walkedPath.pathContext, distance, true);
                    if (expandedPathModel) {
                        model.moveRelative(expandedPathModel, walkedPath.offset);
                        var newId = model.getSimilarModelId(result.models['expansions'], walkedPath.pathId);
                        model.prefixPathIds(expandedPathModel, walkedPath.pathId + '_');
                        model.originate(expandedPathModel);
                        if (!first) {
                            model.combine(result, expandedPathModel, false, true, false, true, combineOptions);
                            combineOptions.measureA.modelsMeasured = false;
                            delete combineOptions.measureB;
                        }
                        result.models['expansions'].models[newId] = expandedPathModel;
                        if (expandedPathModel.models) {
                            var caps = expandedPathModel.models['Caps'];
                            if (caps) {
                                delete expandedPathModel.models['Caps'];
                                result.models['caps'].models[newId] = caps;
                            }
                        }
                        first = false;
                    }
                }
            };
            model.walk(modelToExpand, walkOptions);
            if (joints) {
                var roundCaps = result.models['caps'];
                var straightCaps = { models: {} };
                result.models['straightcaps'] = straightCaps;
                model.simplify(roundCaps);
                //straighten each cap, optionally beveling
                for (var id in roundCaps.models) {
                    //add a model container to the straight caps
                    straightCaps.models[id] = { models: {} };
                    model.walk(roundCaps.models[id], {
                        onPath: function (walkedPath) {
                            var arc = walkedPath.pathContext;
                            //make a small closed shape using the straightened arc
                            var straightened = MakerJs.path.straighten(arc, joints == 2, walkedPath.pathId + '_', true);
                            //union this little pointy shape with the rest of the result
                            model.combine(result, straightened, false, true, false, true, combineOptions);
                            combineOptions.measureA.modelsMeasured = false;
                            delete combineOptions.measureB;
                            //replace the rounded path with the straightened model
                            straightCaps.models[id].models[walkedPath.pathId] = straightened;
                            //delete all the paths in the model containing this path
                            delete walkedPath.modelContext.paths;
                        }
                    });
                }
                //delete the round caps
                delete result.models['caps'];
            }
            return result;
        }
        model.expandPaths = expandPaths;
        /**
         * Outline a model by a specified distance. Useful for accommodating for kerf.
         *
         * @param modelToOutline Model to outline.
         * @param distance Distance to outline.
         * @param joints Number of points at a joint between paths. Use 0 for round joints, 1 for pointed joints, 2 for beveled joints.
         * @param inside Optional boolean to draw lines inside the model instead of outside.
         * @param options Options to send to combine() function.
         * @returns Model which surrounds the paths outside of the original model.
         */
        function outline(modelToOutline, distance, joints, inside, options) {
            if (joints === void 0) { joints = 0; }
            if (inside === void 0) { inside = false; }
            if (options === void 0) { options = {}; }
            var expanded = expandPaths(modelToOutline, distance, joints, options);
            if (!expanded)
                return null;
            var loops = model.findLoops(expanded);
            if (loops && loops.models) {
                function clean(modelToClean) {
                    if (!modelToClean)
                        return;
                    var walkOptions = {
                        onPath: function (walkedPath) {
                            var p = walkedPath.pathContext;
                            delete p.endPoints;
                            delete p.modelContext;
                            delete p.pathId;
                            delete p.reversed;
                        }
                    };
                    model.walk(modelToClean, walkOptions);
                }
                var i = 0;
                while (loops.models[i]) {
                    var keep;
                    if (inside) {
                        delete loops.models[i];
                        clean(loops.models[i + 1]);
                        clean(loops.models[i + 2]);
                        delete loops.models[i + 3];
                    }
                    else {
                        clean(loops.models[i]);
                        delete loops.models[i + 1];
                        delete loops.models[i + 2];
                        clean(loops.models[i + 3]);
                    }
                    i += 4;
                }
                return loops;
            }
            return null;
        }
        model.outline = outline;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var units;
    (function (units) {
        /**
         * The base type is arbitrary. Other conversions are then based off of this.
         * @private
         */
        var base = MakerJs.unitType.Millimeter;
        /**
         * Initialize all known conversions here.
         * @private
         */
        function init() {
            addBaseConversion(MakerJs.unitType.Centimeter, 10);
            addBaseConversion(MakerJs.unitType.Meter, 1000);
            addBaseConversion(MakerJs.unitType.Inch, 25.4);
            addBaseConversion(MakerJs.unitType.Foot, 25.4 * 12);
        }
        /**
         * Table of conversions. Lazy load upon first conversion.
         * @private
         */
        var table;
        /**
         * Add a conversion, and its inversion.
         * @private
         */
        function addConversion(srcUnitType, destUnitType, value) {
            function row(unitType) {
                if (!table[unitType]) {
                    table[unitType] = {};
                }
                return table[unitType];
            }
            row(srcUnitType)[destUnitType] = value;
            row(destUnitType)[srcUnitType] = 1 / value;
        }
        /**
         * Add a conversion of the base unit.
         * @private
         */
        function addBaseConversion(destUnitType, value) {
            addConversion(destUnitType, base, value);
        }
        /**
         * Get a conversion ratio between a source unit and a destination unit.
         *
         * @param srcUnitType unitType converting from.
         * @param destUnitType unitType converting to.
         * @returns Numeric ratio of the conversion.
         */
        function conversionScale(srcUnitType, destUnitType) {
            if (srcUnitType == destUnitType) {
                return 1;
            }
            //This will lazy load the table with initial conversions.
            if (!table) {
                table = {};
                init();
            }
            //look for a cached conversion in the table.
            if (!table[srcUnitType][destUnitType]) {
                //create a new conversionsand cache it in the table.
                addConversion(srcUnitType, destUnitType, table[srcUnitType][base] * table[base][destUnitType]);
            }
            return table[srcUnitType][destUnitType];
        }
        units.conversionScale = conversionScale;
    })(units = MakerJs.units || (MakerJs.units = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var measure;
    (function (measure) {
        /**
         * Find out if two angles are equal.
         *
         * @param angleA First angle.
         * @param angleB Second angle.
         * @returns true if angles are the same, false if they are not
         */
        function isAngleEqual(angleA, angleB, accuracy) {
            if (accuracy === void 0) { accuracy = .0001; }
            var a = MakerJs.angle.noRevolutions(angleA);
            var b = MakerJs.angle.noRevolutions(angleB);
            var d = MakerJs.angle.noRevolutions(MakerJs.round(b - a, accuracy));
            return d == 0;
        }
        measure.isAngleEqual = isAngleEqual;
        /**
         * @private
         */
        var pathAreEqualMap = {};
        pathAreEqualMap[MakerJs.pathType.Line] = function (lineA, lineB, withinPointDistance) {
            return (isPointEqual(lineA.origin, lineB.origin, withinPointDistance) && isPointEqual(lineA.end, lineB.end, withinPointDistance))
                || (isPointEqual(lineA.origin, lineB.end, withinPointDistance) && isPointEqual(lineA.end, lineB.origin, withinPointDistance));
        };
        pathAreEqualMap[MakerJs.pathType.Circle] = function (circleA, circleB, withinPointDistance) {
            return isPointEqual(circleA.origin, circleB.origin, withinPointDistance) && circleA.radius == circleB.radius;
        };
        pathAreEqualMap[MakerJs.pathType.Arc] = function (arcA, arcB, withinPointDistance) {
            return pathAreEqualMap[MakerJs.pathType.Circle](arcA, arcB, withinPointDistance) && isAngleEqual(arcA.startAngle, arcB.startAngle) && isAngleEqual(arcA.endAngle, arcB.endAngle);
        };
        /**
         * Find out if two paths are equal.
         *
         * @param pathA First path.
         * @param pathB Second path.
         * @returns true if paths are the same, false if they are not
         */
        function isPathEqual(pathA, pathB, withinPointDistance, pathAOffset, pathBOffset) {
            var result = false;
            if (pathA.type == pathB.type) {
                var fn = pathAreEqualMap[pathA.type];
                if (fn) {
                    function getResult() {
                        result = fn(pathA, pathB, withinPointDistance);
                    }
                    if (pathAOffset || pathBOffset) {
                        MakerJs.path.moveTemporary([pathA, pathB], [pathAOffset, pathBOffset], getResult);
                    }
                    else {
                        getResult();
                    }
                }
            }
            return result;
        }
        measure.isPathEqual = isPathEqual;
        /**
         * Find out if two points are equal.
         *
         * @param a First point.
         * @param b Second point.
         * @returns true if points are the same, false if they are not
         */
        function isPointEqual(a, b, withinDistance) {
            if (!withinDistance) {
                return a[0] == b[0] && a[1] == b[1];
            }
            else {
                if (!a || !b)
                    return false;
                var distance = measure.pointDistance(a, b);
                return distance <= withinDistance;
            }
        }
        measure.isPointEqual = isPointEqual;
        /**
         * Find out if point is on a slope.
         *
         * @param p Point to check.
         * @param b Slope.
         * @returns true if point is on the slope
         */
        function isPointOnSlope(p, slope, withinDistance) {
            if (slope.hasSlope) {
                // y = mx * b
                return MakerJs.round(p[1] - (slope.slope * p[0] + slope.yIntercept)) === 0;
            }
            else {
                //vertical slope
                return MakerJs.round(p[0] - slope.line.origin[0]) === 0;
            }
        }
        measure.isPointOnSlope = isPointOnSlope;
        /**
         * Check for slope equality.
         *
         * @param slopeA The ISlope to test.
         * @param slopeB The ISlope to check for equality.
         * @returns Boolean true if slopes are equal.
         */
        function isSlopeEqual(slopeA, slopeB) {
            if (!slopeA.hasSlope && !slopeB.hasSlope) {
                //lines are both vertical, see if x are the same
                return MakerJs.round(slopeA.line.origin[0] - slopeB.line.origin[0]) == 0;
            }
            if (slopeA.hasSlope && slopeB.hasSlope && (MakerJs.round(slopeA.slope - slopeB.slope, .00001) == 0)) {
                //lines are parallel, but not vertical, see if y-intercept is the same
                return MakerJs.round(slopeA.yIntercept - slopeB.yIntercept, .00001) == 0;
            }
            return false;
        }
        measure.isSlopeEqual = isSlopeEqual;
    })(measure = MakerJs.measure || (MakerJs.measure = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var measure;
    (function (measure) {
        /**
         * Increase a measurement by an additional measurement.
         *
         * @param baseMeasure The measurement to increase.
         * @param addMeasure The additional measurement.
         * @param addOffset Optional offset point of the additional measurement.
         * @returns The increased original measurement (for cascading).
         */
        function increase(baseMeasure, addMeasure) {
            function getExtreme(basePoint, newPoint, fn) {
                if (!newPoint)
                    return;
                for (var i = 2; i--;) {
                    if (newPoint[i] == null)
                        continue;
                    if (basePoint[i] == null) {
                        basePoint[i] = newPoint[i];
                    }
                    else {
                        basePoint[i] = fn(basePoint[i], newPoint[i]);
                    }
                }
            }
            if (addMeasure) {
                getExtreme(baseMeasure.low, addMeasure.low, Math.min);
                getExtreme(baseMeasure.high, addMeasure.high, Math.max);
            }
            return baseMeasure;
        }
        measure.increase = increase;
        /**
         * Check for arc being concave or convex towards a given point.
         *
         * @param arc The arc to test.
         * @param towardsPoint The point to test.
         * @returns Boolean true if arc is concave towards point.
         */
        function isArcConcaveTowardsPoint(arc, towardsPoint) {
            if (pointDistance(arc.origin, towardsPoint) <= arc.radius) {
                return true;
            }
            var midPointToNearPoint = new MakerJs.paths.Line(MakerJs.point.middle(arc), towardsPoint);
            var options = {};
            var intersectionPoint = MakerJs.path.intersection(midPointToNearPoint, new MakerJs.paths.Chord(arc), options);
            if (intersectionPoint || options.out_AreOverlapped) {
                return true;
            }
            return false;
        }
        measure.isArcConcaveTowardsPoint = isArcConcaveTowardsPoint;
        /**
         * Check for arc overlapping another arc.
         *
         * @param arcA The arc to test.
         * @param arcB The arc to check for overlap.
         * @param excludeTangents Boolean to exclude exact endpoints and only look for deep overlaps.
         * @returns Boolean true if arcA is overlapped with arcB.
         */
        function isArcOverlapping(arcA, arcB, excludeTangents) {
            var pointsOfIntersection = [];
            function checkAngles(a, b) {
                function checkAngle(n) {
                    return measure.isBetweenArcAngles(n, a, excludeTangents);
                }
                return checkAngle(b.startAngle) || checkAngle(b.endAngle);
            }
            return checkAngles(arcA, arcB) || checkAngles(arcB, arcA) || (arcA.startAngle == arcB.startAngle && arcA.endAngle == arcB.endAngle);
        }
        measure.isArcOverlapping = isArcOverlapping;
        /**
         * Check if a given number is between two given limits.
         *
         * @param valueInQuestion The number to test.
         * @param limitA First limit.
         * @param limitB Second limit.
         * @param exclusive Flag to exclude equaling the limits.
         * @returns Boolean true if value is between (or equal to) the limits.
         */
        function isBetween(valueInQuestion, limitA, limitB, exclusive) {
            if (exclusive) {
                return Math.min(limitA, limitB) < valueInQuestion && valueInQuestion < Math.max(limitA, limitB);
            }
            else {
                return Math.min(limitA, limitB) <= valueInQuestion && valueInQuestion <= Math.max(limitA, limitB);
            }
        }
        measure.isBetween = isBetween;
        /**
         * Check if a given angle is between an arc's start and end angles.
         *
         * @param angleInQuestion The angle to test.
         * @param arc Arc to test against.
         * @param exclusive Flag to exclude equaling the start or end angles.
         * @returns Boolean true if angle is between (or equal to) the arc's start and end angles.
         */
        function isBetweenArcAngles(angleInQuestion, arc, exclusive) {
            var startAngle = MakerJs.angle.noRevolutions(arc.startAngle);
            var span = MakerJs.angle.ofArcSpan(arc);
            var endAngle = startAngle + span;
            angleInQuestion = MakerJs.angle.noRevolutions(angleInQuestion);
            //computed angles will not be negative, but the arc may have specified a negative angle, so check against one revolution forward and backward
            return (isBetween(angleInQuestion, startAngle, endAngle, exclusive) || isBetween(angleInQuestion, startAngle + 360, endAngle + 360, exclusive) || isBetween(angleInQuestion, startAngle - 360, endAngle - 360, exclusive));
        }
        measure.isBetweenArcAngles = isBetweenArcAngles;
        /**
         * Check if a given point is between a line's end points.
         *
         * @param pointInQuestion The point to test.
         * @param line Line to test against.
         * @param exclusive Flag to exclude equaling the origin or end points.
         * @returns Boolean true if point is between (or equal to) the line's origin and end points.
         */
        function isBetweenPoints(pointInQuestion, line, exclusive) {
            for (var i = 2; i--;) {
                if (MakerJs.round(line.origin[i] - line.end[i], .000001) == 0) {
                    continue;
                }
                var origin_value = MakerJs.round(line.origin[i]);
                var end_value = MakerJs.round(line.end[i]);
                if (!isBetween(MakerJs.round(pointInQuestion[i]), origin_value, end_value, exclusive))
                    return false;
            }
            return true;
        }
        measure.isBetweenPoints = isBetweenPoints;
        /**
         * Check if a given bezier seed is simply a line.
         *
         * @param seed The bezier seed to test.
         * @returns Boolean true if bezier seed has control points on the line slope and between the line endpoints.
         */
        function isBezierSeedLinear(seed) {
            //create a slope from the endpoints
            var slope = lineSlope(seed);
            for (var i = 0; i < seed.controls.length; i++) {
                if (!(measure.isPointOnSlope(seed.controls[i], slope) && isBetweenPoints(seed.controls[i], seed, false))) {
                    return false;
                }
            }
            return true;
        }
        measure.isBezierSeedLinear = isBezierSeedLinear;
        /**
         * Check for line overlapping another line.
         *
         * @param lineA The line to test.
         * @param lineB The line to check for overlap.
         * @param excludeTangents Boolean to exclude exact endpoints and only look for deep overlaps.
         * @returns Boolean true if lineA is overlapped with lineB.
         */
        function isLineOverlapping(lineA, lineB, excludeTangents) {
            var pointsOfIntersection = [];
            function checkPoints(index, a, b) {
                function checkPoint(p) {
                    return measure.isBetweenPoints(p, a, excludeTangents);
                }
                return checkPoint(b.origin) || checkPoint(b.end);
            }
            return checkPoints(0, lineA, lineB) || checkPoints(1, lineB, lineA);
        }
        measure.isLineOverlapping = isLineOverlapping;
        /**
         * Check for measurement overlapping another measurement.
         *
         * @param measureA The measurement to test.
         * @param measureB The measurement to check for overlap.
         * @returns Boolean true if measureA is overlapped with measureB.
         */
        function isMeasurementOverlapping(measureA, measureB) {
            for (var i = 2; i--;) {
                if (!(MakerJs.round(measureA.low[i] - measureB.high[i]) <= 0 && MakerJs.round(measureA.high[i] - measureB.low[i]) >= 0))
                    return false;
            }
            return true;
        }
        measure.isMeasurementOverlapping = isMeasurementOverlapping;
        /**
         * Gets the slope of a line.
         */
        function lineSlope(line) {
            var dx = line.end[0] - line.origin[0];
            if (MakerJs.round(dx) == 0) {
                return {
                    line: line,
                    hasSlope: false
                };
            }
            var dy = line.end[1] - line.origin[1];
            var slope = dy / dx;
            var yIntercept = line.origin[1] - slope * line.origin[0];
            return {
                line: line,
                hasSlope: true,
                slope: slope,
                yIntercept: yIntercept
            };
        }
        measure.lineSlope = lineSlope;
        /**
         * Calculates the distance between two points.
         *
         * @param a First point.
         * @param b Second point.
         * @returns Distance between points.
         */
        function pointDistance(a, b) {
            var dx = b[0] - a[0];
            var dy = b[1] - a[1];
            return Math.sqrt(dx * dx + dy * dy);
        }
        measure.pointDistance = pointDistance;
        /**
         * @private
         */
        function getExtremePoint(a, b, fn) {
            return [
                fn(a[0], b[0]),
                fn(a[1], b[1])
            ];
        }
        /**
         * @private
         */
        var pathExtentsMap = {};
        pathExtentsMap[MakerJs.pathType.Line] = function (line) {
            return {
                low: getExtremePoint(line.origin, line.end, Math.min),
                high: getExtremePoint(line.origin, line.end, Math.max)
            };
        };
        pathExtentsMap[MakerJs.pathType.Circle] = function (circle) {
            var r = circle.radius;
            return {
                low: MakerJs.point.add(circle.origin, [-r, -r]),
                high: MakerJs.point.add(circle.origin, [r, r])
            };
        };
        pathExtentsMap[MakerJs.pathType.Arc] = function (arc) {
            var r = arc.radius;
            var arcPoints = MakerJs.point.fromArc(arc);
            function extremeAngle(xyAngle, value, fn) {
                var extremePoint = getExtremePoint(arcPoints[0], arcPoints[1], fn);
                for (var i = 2; i--;) {
                    if (isBetweenArcAngles(xyAngle[i], arc, false)) {
                        extremePoint[i] = value + arc.origin[i];
                    }
                }
                return extremePoint;
            }
            return {
                low: extremeAngle([180, 270], -r, Math.min),
                high: extremeAngle([360, 90], r, Math.max)
            };
        };
        /**
         * Calculates the smallest rectangle which contains a path.
         *
         * @param pathToMeasure The path to measure.
         * @returns object with low and high points.
         */
        function pathExtents(pathToMeasure, addOffset) {
            if (pathToMeasure) {
                var fn = pathExtentsMap[pathToMeasure.type];
                if (fn) {
                    var m = fn(pathToMeasure);
                    if (addOffset) {
                        m.high = MakerJs.point.add(m.high, addOffset);
                        m.low = MakerJs.point.add(m.low, addOffset);
                    }
                    return m;
                }
            }
            return { low: null, high: null };
        }
        measure.pathExtents = pathExtents;
        /**
         * @private
         */
        var pathLengthMap = {};
        pathLengthMap[MakerJs.pathType.Line] = function (line) {
            return pointDistance(line.origin, line.end);
        };
        pathLengthMap[MakerJs.pathType.Circle] = function (circle) {
            return 2 * Math.PI * circle.radius;
        };
        pathLengthMap[MakerJs.pathType.Arc] = function (arc) {
            var value = pathLengthMap[MakerJs.pathType.Circle](arc);
            var pct = MakerJs.angle.ofArcSpan(arc) / 360;
            value *= pct;
            return value;
        };
        pathLengthMap[MakerJs.pathType.BezierSeed] = function (seed) {
            return MakerJs.models.BezierCurve.computeLength(seed);
        };
        /**
         * Measures the length of a path.
         *
         * @param pathToMeasure The path to measure.
         * @returns Length of the path.
         */
        function pathLength(pathToMeasure) {
            if (pathToMeasure) {
                var fn = pathLengthMap[pathToMeasure.type];
                if (fn) {
                    return fn(pathToMeasure);
                }
            }
            return 0;
        }
        measure.pathLength = pathLength;
        /**
         * Measures the length of all paths in a model.
         *
         * @param modelToMeasure The model containing paths to measure.
         * @returns Length of all paths in the model.
         */
        function modelPathLength(modelToMeasure) {
            var total = 0;
            MakerJs.model.walk(modelToMeasure, {
                onPath: function (walkedPath) {
                    total += pathLength(walkedPath.pathContext);
                }
            });
            return total;
        }
        measure.modelPathLength = modelPathLength;
        /**
         * @private
         */
        function cloneMeasure(measureToclone) {
            return { high: [measureToclone.high[0], measureToclone.high[1]], low: [measureToclone.low[0], measureToclone.low[1]] };
        }
        /**
         * Measures the smallest rectangle which contains a model.
         *
         * @param modelToMeasure The model to measure.
         * @param atlas Optional atlas to save measurements.
         * @returns object with low and high points.
         */
        function modelExtents(modelToMeasure, atlas) {
            function increaseParentModel(childRoute, childMeasurement) {
                if (!childMeasurement)
                    return;
                //to get the parent route, just traverse backwards 2 to remove id and 'paths' / 'models'
                var parentRoute = childRoute.slice(0, -2);
                var parentRouteKey = MakerJs.createRouteKey(parentRoute);
                if (!(parentRouteKey in atlas.modelMap)) {
                    //just start with the known size
                    atlas.modelMap[parentRouteKey] = cloneMeasure(childMeasurement);
                }
                else {
                    measure.increase(atlas.modelMap[parentRouteKey], childMeasurement);
                }
            }
            if (!atlas)
                atlas = new measure.Atlas(modelToMeasure);
            var walkOptions = {
                onPath: function (walkedPath) {
                    //trust that the path measurement is good
                    if (!(walkedPath.routeKey in atlas.pathMap)) {
                        atlas.pathMap[walkedPath.routeKey] = measure.pathExtents(walkedPath.pathContext, walkedPath.offset);
                    }
                    increaseParentModel(walkedPath.route, atlas.pathMap[walkedPath.routeKey]);
                },
                afterChildWalk: function (walkedModel) {
                    //model has been updated by all its children, update parent
                    increaseParentModel(walkedModel.route, atlas.modelMap[walkedModel.routeKey]);
                }
            };
            MakerJs.model.walk(modelToMeasure, walkOptions);
            atlas.modelsMeasured = true;
            var m = atlas.modelMap[''];
            function avg(dim) {
                return (m.low[dim] + m.high[dim]) / 2;
            }
            if (m) {
                m.center = [avg(0), avg(1)];
            }
            return m;
        }
        measure.modelExtents = modelExtents;
        /**
         * A list of maps of measurements.
         *
         * @param modelToMeasure The model to measure.
         * @param atlas Optional atlas to save measurements.
         * @returns object with low and high points.
         */
        var Atlas = (function () {
            /**
             * Constructor.
             * @param modelContext The model to measure.
             */
            function Atlas(modelContext) {
                this.modelContext = modelContext;
                /**
                 * Flag that models have been measured.
                 */
                this.modelsMeasured = false;
                /**
                 * Map of model measurements, mapped by routeKey.
                 */
                this.modelMap = {};
                /**
                 * Map of path measurements, mapped by routeKey.
                 */
                this.pathMap = {};
            }
            Atlas.prototype.measureModels = function () {
                if (!this.modelsMeasured) {
                    modelExtents(this.modelContext, this);
                }
            };
            return Atlas;
        }());
        measure.Atlas = Atlas;
        /**
         * @private
         */
        var equilateral = Math.sqrt(3) / 2;
        /**
         * @private
         */
        function sideToAltitude(sideLength) {
            return sideLength * equilateral;
        }
        /**
         * @private
         */
        function altitudeToSide(altitude) {
            return altitude / equilateral;
        }
        /**
         * @private
         */
        function loopIndex(base, i) {
            if (i >= base)
                return i - base;
            if (i < 0)
                return i + base;
            return i;
        }
        /**
         * @private
         */
        function yAtX(slope, x) {
            return slope.slope * x + slope.yIntercept;
        }
        /**
         * @private
         */
        function pointOnSlopeAtX(line, x) {
            var slope = lineSlope(line);
            return [x, yAtX(slope, x)];
        }
        /**
         * @private
         */
        function isCircular(bounds) {
            for (var i = 1; i < 3; i++) {
                if (!measure.isPointEqual(bounds[0].center, bounds[i].center, .000001) || !(MakerJs.round(bounds[0].width - bounds[i].width) === 0)) {
                    return false;
                }
            }
            return true;
        }
        /**
         * @private
         */
        function getAngledBounds(index, modelToMeasure, rotateModel, rotatePaths) {
            MakerJs.model.rotate(modelToMeasure, rotateModel);
            var m = modelExtents(modelToMeasure);
            var yDistance = m.high[1] - m.low[1];
            var xDistance = m.high[0] - m.low[0];
            var result = {
                index: index,
                rotation: rotatePaths,
                center: MakerJs.point.rotate(m.center, rotatePaths),
                //model is sideways, so width is based on Y, height is based on X
                width: yDistance,
                height: xDistance,
                bottom: new MakerJs.paths.Line(m.low, [m.high[0], m.low[1]]),
                middle: new MakerJs.paths.Line([m.low[0], m.center[1]], [m.high[0], m.center[1]]),
                top: new MakerJs.paths.Line(m.high, [m.low[0], m.high[1]])
            };
            [result.top, result.middle, result.bottom].forEach(function (line) { return MakerJs.path.rotate(line, rotatePaths); });
            return result;
        }
        /**
         * @private
         */
        function hexSolution(lines, bounds) {
            var tip = lines[1].origin;
            var tipX = tip[0];
            var left = lines[3].origin[0];
            var right = lines[0].origin[0];
            //see if left edge is in bounds if right edge is on the hex boundary
            var altRight = tipX - right;
            if ((right - left) > 2 * altRight)
                return null;
            //see if right edge is in bounds if left edge is on the hex boundary
            var altLeft = (tipX - left) / 3;
            if (altRight < altLeft)
                return null;
            var altitudeViaSide = Math.min(altLeft, altRight);
            var radiusViaSide = altitudeToSide(altitudeViaSide);
            //find peaks, then find highest peak
            var peakPoints = [MakerJs.point.fromSlopeIntersection(lines[1], lines[2]), MakerJs.point.fromSlopeIntersection(lines[4], lines[5])];
            var peakRadii = peakPoints.map(function (p) { return Math.abs(p[1] - tip[1]); });
            var peakNum = (peakRadii[0] > peakRadii[1]) ? 0 : 1; //top = 0, bottom = 1
            var radiusViaPeak = peakRadii[peakNum];
            if (radiusViaPeak > radiusViaSide) {
                var altitudeViaPeak = sideToAltitude(radiusViaPeak);
                var peakX = tipX - 2 * altitudeViaPeak;
                //see if it will contain right side
                if (right > peakX + altitudeViaPeak)
                    return null;
                //see if it will contain left side
                if (left < peakX - altitudeViaPeak)
                    return null;
                //at this point, [tipX - 2 * altitudeViaPeak, tip[1]] is a solution for origin.
                //but we want to best center the result by sliding along the boundary middle, balancing the smallest gap
                var leftGap = left - peakX + altitudeViaPeak;
                var peakGap = 2 * altitudeViaPeak - bounds[peakNum + 1].width;
                var minHalfGap = Math.min(leftGap, peakGap) / 2;
                return {
                    origin: pointOnSlopeAtX(bounds[2 - peakNum].middle, peakX + minHalfGap),
                    radius: radiusViaPeak,
                    type: 'peak ' + peakNum
                };
            }
            else {
                return {
                    origin: [tipX - 2 * altitudeViaSide, tip[1]],
                    radius: radiusViaSide,
                    type: 'side'
                };
            }
        }
        /**
         * Measures the minimum bounding hexagon surrounding a model. The hexagon is oriented such that the right and left sides are vertical, and the top and bottom are pointed.
         *
         * @param modelToMeasure The model to measure.
         * @returns IBoundingHex object which is a hexagon model, with an additional radius property.
         */
        function boundingHexagon(modelToMeasure) {
            var originalMeasure = modelExtents(modelToMeasure);
            var clone = MakerJs.cloneObject(modelToMeasure);
            var bounds = [];
            var scratch = { paths: {} };
            MakerJs.model.center(clone);
            function result(radius, origin1, notes) {
                return {
                    radius: radius,
                    paths: new MakerJs.models.Polygon(6, radius, 30).paths,
                    origin: MakerJs.point.add(origin1, MakerJs.point.subtract(originalMeasure.center, modelToMeasure.origin)),
                    //models: { scratch: scratch },
                    notes: notes
                };
            }
            var boundRotations = [[90, -90], [-60, -30], [-60, 30]];
            while (boundRotations.length) {
                var rotation = boundRotations.shift();
                var bound = getAngledBounds(bounds.length, clone, rotation[0], rotation[1]);
                var side = altitudeToSide(bound.width / 2);
                if (side >= bound.height) {
                    return result(side, bound.center, 'solved by bound ' + bounds.length);
                }
                bounds.push(bound);
            }
            //model.rotate(clone, 30);
            //scratch.models = { clone: clone };
            //check for a circular solution
            if (isCircular(bounds)) {
                return result(altitudeToSide(bounds[0].width / 2), bounds[0].center, 'solved as circular');
            }
            var perimeters = bounds.map(function (b) { return b.top; }).concat(bounds.map(function (b) { return b.bottom; }));
            perimeters.forEach(function (p, i) {
                scratch.paths[i] = p;
                //converge alternate lines to form two triangles
                MakerJs.path.converge(perimeters[loopIndex(6, i + 2)], p, true);
            });
            bounds.forEach(function (b, i) {
                scratch.paths['m' + i] = b.middle;
            });
            var boundCopy = bounds.slice();
            var solution;
            //solve a hexagon for every tip, keeping the smallest one
            for (var i = 0; i < 6; i++) {
                //rotate the scratch area so that we always reference the tip at polar 0
                if (i > 0) {
                    perimeters.push(perimeters.shift());
                    boundCopy.push(boundCopy.shift());
                    MakerJs.model.rotate(scratch, -60);
                }
                var s = hexSolution(perimeters, boundCopy);
                if (s) {
                    if (!solution || s.radius < solution.radius) {
                        solution = s;
                        solution.index = i;
                    }
                }
            }
            var p = MakerJs.point.rotate(solution.origin, solution.index * 60);
            return result(solution.radius, p, 'solved by ' + solution.index + ' as ' + solution.type);
        }
        measure.boundingHexagon = boundingHexagon;
    })(measure = MakerJs.measure || (MakerJs.measure = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter) {
        /**
         * Try to get the unit system from a model
         * @private
         */
        function tryGetModelUnits(itemToExport) {
            if (MakerJs.isModel(itemToExport)) {
                return itemToExport.units;
            }
        }
        exporter.tryGetModelUnits = tryGetModelUnits;
        /**
         * Class to traverse an item 's models or paths and ultimately render each path.
         * @private
         */
        var Exporter = (function () {
            /**
             * @param map Object containing properties: property name is the type of path, e.g. "line", "circle"; property value
             * is a function to render a path. Function parameters are path and point.
             * @param fixPoint Optional function to modify a point prior to export. Function parameter is a point; function must return a point.
             * @param fixPath Optional function to modify a path prior to output. Function parameters are path and offset point; function must return a path.
             */
            function Exporter(map, fixPoint, fixPath, beginModel, endModel) {
                this.map = map;
                this.fixPoint = fixPoint;
                this.fixPath = fixPath;
                this.beginModel = beginModel;
                this.endModel = endModel;
            }
            /**
             * Export a path.
             *
             * @param pathToExport The path to export.
             * @param offset The offset position of the path.
             */
            Exporter.prototype.exportPath = function (id, pathToExport, offset, layer) {
                if (pathToExport) {
                    var fn = this.map[pathToExport.type];
                    if (fn) {
                        fn(id, this.fixPath ? this.fixPath(pathToExport, offset) : pathToExport, offset, layer);
                    }
                }
            };
            /**
             * Export a model.
             *
             * @param modelToExport The model to export.
             * @param offset The offset position of the model.
             */
            Exporter.prototype.exportModel = function (modelId, modelToExport, offset) {
                if (this.beginModel) {
                    this.beginModel(modelId, modelToExport);
                }
                var newOffset = MakerJs.point.add((this.fixPoint ? this.fixPoint(modelToExport.origin) : modelToExport.origin), offset);
                if (modelToExport.paths) {
                    for (var id in modelToExport.paths) {
                        var currPath = modelToExport.paths[id];
                        if (!currPath)
                            continue;
                        this.exportPath(id, currPath, newOffset, currPath.layer || modelToExport.layer);
                    }
                }
                if (modelToExport.models) {
                    for (var id in modelToExport.models) {
                        var currModel = modelToExport.models[id];
                        if (!currModel)
                            continue;
                        this.exportModel(id, currModel, newOffset);
                    }
                }
                if (this.endModel) {
                    this.endModel(modelToExport);
                }
            };
            /**
             * Export an object.
             *
             * @param item The object to export. May be a path, an array of paths, a model, or an array of models.
             * @param offset The offset position of the object.
             */
            Exporter.prototype.exportItem = function (itemId, itemToExport, origin) {
                if (MakerJs.isModel(itemToExport)) {
                    this.exportModel(itemId, itemToExport, origin);
                }
                else if (MakerJs.isPath(itemToExport)) {
                    this.exportPath(itemId, itemToExport, origin, null);
                }
                else {
                    for (var id in itemToExport) {
                        this.exportItem(id, itemToExport[id], origin);
                    }
                }
            };
            return Exporter;
        }());
        exporter.Exporter = Exporter;
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var importer;
    (function (importer) {
        /**
         * Create a numeric array from a string of numbers. The numbers may be delimited by anything non-numeric.
         *
         * Example:
         * ```
         * var n = makerjs.importer.parseNumericList('5, 10, 15.20 25-30-35 4e1 .5');
         * ```
         *
         * @param s The string of numbers.
         * @returns Array of numbers.
         */
        function parseNumericList(s) {
            var result = [];
            //http://stackoverflow.com/questions/638565/parsing-scientific-notation-sensibly
            var re = /[\.-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?/g;
            var matches;
            while ((matches = re.exec(s)) !== null) {
                if (matches.index === re.lastIndex) {
                    re.lastIndex++;
                }
                result.push(parseFloat(matches[0]));
            }
            return result;
        }
        importer.parseNumericList = parseNumericList;
    })(importer = MakerJs.importer || (MakerJs.importer = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter_1) {
        /**
         * Renders an item in AutoDesk DFX file format.
         *
         * @param itemToExport Item to render: may be a path, an array of paths, or a model object.
         * @param options Rendering options object.
         * @param options.units String of the unit system. May be omitted. See makerjs.unitType for possible values.
         * @returns String of DXF content.
         */
        function toDXF(itemToExport, options) {
            //DXF format documentation:
            //http://images.autodesk.com/adsk/files/acad_dxf0.pdf
            if (options === void 0) { options = {}; }
            var opts = {};
            MakerJs.extendObject(opts, options);
            if (MakerJs.isModel(itemToExport)) {
                var modelToExport = itemToExport;
                if (modelToExport.exporterOptions) {
                    MakerJs.extendObject(opts, modelToExport.exporterOptions['toDXF']);
                }
            }
            var dxf = [];
            function append(value) {
                dxf.push(value);
            }
            function defaultLayer(pathContext, layer) {
                return pathContext.layer || layer || 0;
            }
            var map = {};
            map[MakerJs.pathType.Line] = function (id, line, origin, layer) {
                append("0");
                append("LINE");
                append("8");
                append(defaultLayer(line, layer));
                append("10");
                append(line.origin[0] + origin[0]);
                append("20");
                append(line.origin[1] + origin[1]);
                append("11");
                append(line.end[0] + origin[0]);
                append("21");
                append(line.end[1] + origin[1]);
            };
            map[MakerJs.pathType.Circle] = function (id, circle, origin, layer) {
                append("0");
                append("CIRCLE");
                append("8");
                append(defaultLayer(circle, layer));
                append("10");
                append(circle.origin[0] + origin[0]);
                append("20");
                append(circle.origin[1] + origin[1]);
                append("40");
                append(circle.radius);
            };
            map[MakerJs.pathType.Arc] = function (id, arc, origin, layer) {
                append("0");
                append("ARC");
                append("8");
                append(defaultLayer(arc, layer));
                append("10");
                append(arc.origin[0] + origin[0]);
                append("20");
                append(arc.origin[1] + origin[1]);
                append("40");
                append(arc.radius);
                append("50");
                append(arc.startAngle);
                append("51");
                append(arc.endAngle);
            };
            //TODO - handle scenario if any bezier seeds get passed
            //map[pathType.BezierSeed]
            function section(sectionFn) {
                append("0");
                append("SECTION");
                sectionFn();
                append("0");
                append("ENDSEC");
            }
            function header() {
                var units = dxfUnit[opts.units];
                append("2");
                append("HEADER");
                append("9");
                append("$INSUNITS");
                append("70");
                append(units);
            }
            function entities() {
                append("2");
                append("ENTITIES");
                var exporter = new exporter_1.Exporter(map);
                exporter.exportItem('entities', itemToExport, MakerJs.point.zero());
            }
            //fixup options
            if (!opts.units) {
                var units = exporter_1.tryGetModelUnits(itemToExport);
                if (units) {
                    opts.units = units;
                }
            }
            //also pass back to options parameter
            MakerJs.extendObject(options, opts);
            //begin dxf output
            if (opts.units) {
                section(header);
            }
            section(entities);
            append("0");
            append("EOF");
            return dxf.join('\n');
        }
        exporter_1.toDXF = toDXF;
        /**
         * @private
         */
        var dxfUnit = {};
        //DXF format documentation:
        //http://images.autodesk.com/adsk/files/acad_dxf0.pdf
        //Default drawing units for AutoCAD DesignCenter blocks:
        //0 = Unitless; 1 = Inches; 2 = Feet; 3 = Miles; 4 = Millimeters; 5 = Centimeters; 6 = Meters; 7 = Kilometers; 8 = Microinches;
        dxfUnit[''] = 0;
        dxfUnit[MakerJs.unitType.Inch] = 1;
        dxfUnit[MakerJs.unitType.Foot] = 2;
        dxfUnit[MakerJs.unitType.Millimeter] = 4;
        dxfUnit[MakerJs.unitType.Centimeter] = 5;
        dxfUnit[MakerJs.unitType.Meter] = 6;
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var solvers;
    (function (solvers) {
        /**
         * Solves for the angle of a triangle when you know lengths of 3 sides.
         *
         * @param lengthA Length of side of triangle, opposite of the angle you are trying to find.
         * @param lengthB Length of any other side of the triangle.
         * @param lengthC Length of the remaining side of the triangle.
         * @returns Angle opposite of the side represented by the first parameter.
         */
        function solveTriangleSSS(lengthA, lengthB, lengthC) {
            return MakerJs.angle.toDegrees(Math.acos((lengthB * lengthB + lengthC * lengthC - lengthA * lengthA) / (2 * lengthB * lengthC)));
        }
        solvers.solveTriangleSSS = solveTriangleSSS;
        /**
         * Solves for the length of a side of a triangle when you know length of one side and 2 angles.
         *
         * @param oppositeAngleInDegrees Angle which is opposite of the side you are trying to find.
         * @param lengthOfSideBetweenAngles Length of one side of the triangle which is between the provided angles.
         * @param otherAngleInDegrees An other angle of the triangle.
         * @returns Length of the side of the triangle which is opposite of the first angle parameter.
         */
        function solveTriangleASA(oppositeAngleInDegrees, lengthOfSideBetweenAngles, otherAngleInDegrees) {
            var angleOppositeSide = 180 - oppositeAngleInDegrees - otherAngleInDegrees;
            return (lengthOfSideBetweenAngles * Math.sin(MakerJs.angle.toRadians(oppositeAngleInDegrees))) / Math.sin(MakerJs.angle.toRadians(angleOppositeSide));
        }
        solvers.solveTriangleASA = solveTriangleASA;
    })(solvers = MakerJs.solvers || (MakerJs.solvers = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var path;
    (function (path) {
        /**
         * @private
         */
        var map = {};
        map[MakerJs.pathType.Arc] = {};
        map[MakerJs.pathType.Circle] = {};
        map[MakerJs.pathType.Line] = {};
        map[MakerJs.pathType.Arc][MakerJs.pathType.Arc] = function (arc1, arc2, options, swapOffsets) {
            var result = null;
            moveTemp([arc1, arc2], options, swapOffsets, function () {
                var angles = circleToCircle(arc1, arc2, options);
                if (angles) {
                    var arc1Angles = getAnglesWithinArc(angles[0], arc1, options);
                    var arc2Angles = getAnglesWithinArc(angles[1], arc2, options);
                    if (arc1Angles && arc2Angles) {
                        //must correspond to the same angle indexes
                        if (arc1Angles.length === 1 || arc2Angles.length === 1) {
                            for (var i1 = 0; i1 < arc1Angles.length; i1++) {
                                for (var i2 = 0; i2 < arc2Angles.length; i2++) {
                                    var p1 = MakerJs.point.fromAngleOnCircle(arc1Angles[i1], arc1);
                                    var p2 = MakerJs.point.fromAngleOnCircle(arc2Angles[i2], arc2);
                                    //if they do not correspond then they don't intersect
                                    if (MakerJs.measure.isPointEqual(p1, p2, .0001)) {
                                        result = {
                                            intersectionPoints: [p1],
                                            path1Angles: [arc1Angles[i1]],
                                            path2Angles: [arc2Angles[i2]]
                                        };
                                        return;
                                    }
                                }
                            }
                        }
                        else {
                            result = {
                                intersectionPoints: pointsFromAnglesOnCircle(arc1Angles, arc1),
                                path1Angles: arc1Angles,
                                path2Angles: arc2Angles
                            };
                        }
                    }
                }
                else {
                    if (options.out_AreOverlapped) {
                        //overlapped for circle, reset and see if arcs actually overlap.
                        options.out_AreOverlapped = MakerJs.measure.isArcOverlapping(arc1, arc2, options.excludeTangents);
                    }
                }
            });
            return result;
        };
        map[MakerJs.pathType.Arc][MakerJs.pathType.Circle] = function (arc, circle, options, swapOffsets) {
            var result = null;
            moveTemp([arc, circle], options, swapOffsets, function () {
                var angles = circleToCircle(arc, circle, options);
                if (angles) {
                    var arcAngles = getAnglesWithinArc(angles[0], arc, options);
                    if (arcAngles) {
                        var circleAngles;
                        //if both point are on arc, use both on circle
                        if (arcAngles.length == 2) {
                            circleAngles = angles[1];
                        }
                        else {
                            //use the corresponding point on circle 
                            var index = findCorrespondingAngleIndex(angles, arcAngles);
                            circleAngles = [angles[1][index]];
                        }
                        result = {
                            intersectionPoints: pointsFromAnglesOnCircle(arcAngles, arc),
                            path1Angles: arcAngles,
                            path2Angles: circleAngles
                        };
                    }
                }
            });
            return result;
        };
        map[MakerJs.pathType.Arc][MakerJs.pathType.Line] = function (arc, line, options, swapOffsets) {
            var result = null;
            moveTemp([arc, line], options, swapOffsets, function () {
                var angles = lineToCircle(line, arc, options);
                if (angles) {
                    var arcAngles = getAnglesWithinArc(angles, arc, options);
                    if (arcAngles) {
                        result = {
                            intersectionPoints: pointsFromAnglesOnCircle(arcAngles, arc),
                            path1Angles: arcAngles
                        };
                    }
                }
            });
            return result;
        };
        map[MakerJs.pathType.Circle][MakerJs.pathType.Arc] = function (circle, arc, options) {
            var result = map[MakerJs.pathType.Arc][MakerJs.pathType.Circle](arc, circle, options, true);
            if (result) {
                return swapAngles(result);
            }
            return null;
        };
        map[MakerJs.pathType.Circle][MakerJs.pathType.Circle] = function (circle1, circle2, options, swapOffsets) {
            var result = null;
            moveTemp([circle1, circle2], options, swapOffsets, function () {
                var angles = circleToCircle(circle1, circle2, options);
                if (angles) {
                    result = {
                        intersectionPoints: pointsFromAnglesOnCircle(angles[0], circle1),
                        path1Angles: angles[0],
                        path2Angles: angles[1]
                    };
                }
            });
            return result;
        };
        map[MakerJs.pathType.Circle][MakerJs.pathType.Line] = function (circle, line, options, swapOffsets) {
            var result = null;
            moveTemp([circle, line], options, swapOffsets, function () {
                var angles = lineToCircle(line, circle, options);
                if (angles) {
                    result = {
                        intersectionPoints: pointsFromAnglesOnCircle(angles, circle),
                        path1Angles: angles
                    };
                }
            });
            return result;
        };
        map[MakerJs.pathType.Line][MakerJs.pathType.Arc] = function (line, arc, options) {
            var result = map[MakerJs.pathType.Arc][MakerJs.pathType.Line](arc, line, options, true);
            if (result) {
                return swapAngles(result);
            }
            return null;
        };
        map[MakerJs.pathType.Line][MakerJs.pathType.Circle] = function (line, circle, options) {
            var result = map[MakerJs.pathType.Circle][MakerJs.pathType.Line](circle, line, options, true);
            if (result) {
                return swapAngles(result);
            }
            return null;
        };
        map[MakerJs.pathType.Line][MakerJs.pathType.Line] = function (line1, line2, options, swapOffsets) {
            var result = null;
            moveTemp([line1, line2], options, swapOffsets, function () {
                var intersectionPoint = MakerJs.point.fromSlopeIntersection(line1, line2, options);
                if (intersectionPoint) {
                    //we have the point of intersection of endless lines, now check to see if the point is between both segemnts
                    if (MakerJs.measure.isBetweenPoints(intersectionPoint, line1, options.excludeTangents) && MakerJs.measure.isBetweenPoints(intersectionPoint, line2, options.excludeTangents)) {
                        result = {
                            intersectionPoints: [intersectionPoint]
                        };
                    }
                }
            });
            return result;
        };
        /**
         * @private
         */
        function moveTemp(pathsToOffset, options, swapOffsets, task) {
            var offsets = swapOffsets ? [options.path2Offset, options.path1Offset] : [options.path1Offset, options.path2Offset];
            path.moveTemporary(pathsToOffset, offsets, task);
        }
        ;
        /**
         * @private
         */
        function swapAngles(result) {
            var temp = result.path1Angles;
            if (result.path2Angles) {
                result.path1Angles = result.path2Angles;
            }
            else {
                delete result.path1Angles;
            }
            if (temp) {
                result.path2Angles = temp;
            }
            return result;
        }
        /**
         * Find the point(s) where 2 paths intersect.
         *
         * @param path1 First path to find intersection.
         * @param path2 Second path to find intersection.
         * @param options Optional IPathIntersectionOptions.
         * @returns IPathIntersection object, with points(s) of intersection (and angles, when a path is an arc or circle); or null if the paths did not intersect.
         */
        function intersection(path1, path2, options) {
            if (options === void 0) { options = {}; }
            if (path1 && path2) {
                var fn = map[path1.type][path2.type];
                if (fn) {
                    return fn(path1, path2, options);
                }
            }
            return null;
        }
        path.intersection = intersection;
        /**
         * @private
         */
        function findCorrespondingAngleIndex(circleAngles, arcAngle) {
            for (var i = 0; i < circleAngles.length; i++) {
                if (circleAngles[i][0] == arcAngle[0])
                    return i;
            }
        }
        /**
         * @private
         */
        function pointsFromAnglesOnCircle(anglesInDegrees, circle) {
            var result = [];
            for (var i = 0; i < anglesInDegrees.length; i++) {
                result.push(MakerJs.point.fromAngleOnCircle(anglesInDegrees[i], circle));
            }
            return result;
        }
        /**
         * @private
         */
        function getAnglesWithinArc(angles, arc, options) {
            if (!angles)
                return null;
            var anglesWithinArc = [];
            for (var i = 0; i < angles.length; i++) {
                if (MakerJs.measure.isBetweenArcAngles(angles[i], arc, options.excludeTangents)) {
                    anglesWithinArc.push(angles[i]);
                }
            }
            if (anglesWithinArc.length == 0)
                return null;
            return anglesWithinArc;
        }
        /**
         * @private
         */
        function lineToCircle(line, circle, options) {
            var radius = MakerJs.round(circle.radius);
            //clone the line
            var clonedLine = new MakerJs.paths.Line(MakerJs.point.subtract(line.origin, circle.origin), MakerJs.point.subtract(line.end, circle.origin));
            //get angle of line
            var lineAngleNormal = MakerJs.angle.ofLineInDegrees(line);
            //use the positive horizontal angle
            var lineAngle = (lineAngleNormal >= 180) ? lineAngleNormal - 360 : lineAngleNormal;
            //rotate the line to horizontal
            path.rotate(clonedLine, -lineAngle, MakerJs.point.zero());
            //remember how to undo the rotation we just did
            function unRotate(resultAngle) {
                var unrotated = resultAngle + lineAngle;
                return MakerJs.round(MakerJs.angle.noRevolutions(unrotated));
            }
            //line is horizontal, get the y value from any point
            var lineY = MakerJs.round(clonedLine.origin[1]);
            var lineYabs = Math.abs(lineY);
            //if y is greater than radius, there is no intersection
            if (lineYabs > radius) {
                return null;
            }
            var anglesOfIntersection = [];
            //if horizontal Y is the same as the radius, we know it's 90 degrees
            if (lineYabs == radius) {
                if (options.excludeTangents) {
                    return null;
                }
                anglesOfIntersection.push(unRotate(lineY > 0 ? 90 : 270));
            }
            else {
                function intersectionBetweenEndpoints(x, angleOfX) {
                    if (MakerJs.measure.isBetween(MakerJs.round(x), MakerJs.round(clonedLine.origin[0]), MakerJs.round(clonedLine.end[0]), options.excludeTangents)) {
                        anglesOfIntersection.push(unRotate(angleOfX));
                    }
                }
                //find angle where line intersects
                var intersectRadians = Math.asin(lineY / radius);
                var intersectDegrees = MakerJs.angle.toDegrees(intersectRadians);
                //line may intersect in 2 places
                var intersectX = Math.cos(intersectRadians) * radius;
                intersectionBetweenEndpoints(-intersectX, 180 - intersectDegrees);
                intersectionBetweenEndpoints(intersectX, intersectDegrees);
            }
            if (anglesOfIntersection.length > 0) {
                return anglesOfIntersection;
            }
            return null;
        }
        /**
         * @private
         */
        function circleToCircle(circle1, circle2, options) {
            //see if circles are the same
            if (circle1.radius == circle2.radius && MakerJs.measure.isPointEqual(circle1.origin, circle2.origin, .0001)) {
                options.out_AreOverlapped = true;
                return null;
            }
            //get offset from origin
            var offset = MakerJs.point.subtract(MakerJs.point.zero(), circle1.origin);
            //clone circle1 and move to origin
            var c1 = new MakerJs.paths.Circle(MakerJs.point.zero(), circle1.radius);
            //clone circle2 and move relative to circle1
            var c2 = new MakerJs.paths.Circle(MakerJs.point.subtract(circle2.origin, circle1.origin), circle2.radius);
            //rotate circle2 to horizontal, c2 will be to the right of the origin.
            var c2Angle = MakerJs.angle.ofPointInDegrees(MakerJs.point.zero(), c2.origin);
            path.rotate(c2, -c2Angle, MakerJs.point.zero());
            function unRotate(resultAngle) {
                var unrotated = resultAngle + c2Angle;
                return MakerJs.angle.noRevolutions(unrotated);
            }
            //get X of c2 origin
            var x = c2.origin[0];
            //see if c2 is outside of c1
            if (MakerJs.round(x - c2.radius) > c1.radius) {
                return null;
            }
            //see if c2 is within c1
            if (MakerJs.round(x + c2.radius) < c1.radius) {
                return null;
            }
            //see if c1 is within c2
            if (MakerJs.round(x - c2.radius) < -c1.radius) {
                return null;
            }
            //see if circles are tangent interior
            if (MakerJs.round(c2.radius - x - c1.radius) == 0) {
                if (options.excludeTangents) {
                    return null;
                }
                return [[unRotate(180)], [unRotate(180)]];
            }
            //see if circles are tangent exterior
            if (MakerJs.round(x - c2.radius - c1.radius) == 0) {
                if (options.excludeTangents) {
                    return null;
                }
                return [[unRotate(0)], [unRotate(180)]];
            }
            function bothAngles(oneAngle) {
                return [unRotate(oneAngle), unRotate(MakerJs.angle.mirror(oneAngle, false, true))];
            }
            var c1IntersectionAngle = MakerJs.solvers.solveTriangleSSS(c2.radius, c1.radius, x);
            var c2IntersectionAngle = MakerJs.solvers.solveTriangleSSS(c1.radius, x, c2.radius);
            return [bothAngles(c1IntersectionAngle), bothAngles(180 - c2IntersectionAngle)];
        }
    })(path = MakerJs.path || (MakerJs.path = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var path;
    (function (path) {
        /**
         * @private
         */
        var propertyNamesMap = {};
        propertyNamesMap[MakerJs.pathType.Arc] = function (arc) {
            return ['startAngle', 'endAngle'];
        };
        propertyNamesMap[MakerJs.pathType.Line] = function (line) {
            return ['origin', 'end'];
        };
        /**
         * @private
         */
        function getPointProperties(pathToInspect) {
            var points = MakerJs.point.fromPathEnds(pathToInspect);
            if (points) {
                function pointProperty(index) {
                    return { point: points[index], propertyName: propertyNames[index] };
                }
                var propertyNames = null;
                var fn = propertyNamesMap[pathToInspect.type];
                if (fn) {
                    propertyNames = fn(pathToInspect);
                    return [pointProperty(0), pointProperty(1)];
                }
            }
            return null;
        }
        /**
         * @private
         */
        function getMatchingPointProperties(pathA, pathB, options) {
            var pathAProperties = getPointProperties(pathA);
            var pathBProperties = getPointProperties(pathB);
            var result = null;
            function makeMatch(pathContext, pointProperties, index) {
                return {
                    path: pathContext,
                    isStart: index == 0,
                    propertyName: pointProperties[index].propertyName,
                    point: pointProperties[index].point,
                    oppositePoint: pointProperties[1 - index].point
                };
            }
            function check(iA, iB) {
                if (MakerJs.measure.isPointEqual(pathAProperties[iA].point, pathBProperties[iB].point, .0001)) {
                    result = [
                        makeMatch(pathA, pathAProperties, iA),
                        makeMatch(pathB, pathBProperties, iB)
                    ];
                    return true;
                }
                return false;
            }
            check(0, 0) || check(0, 1) || check(1, 0) || check(1, 1);
            return result;
        }
        /**
         * @private
         */
        function populateShardPointsFromReferenceCircle(filletRadius, center, properties, options) {
            var referenceCircle = new MakerJs.paths.Circle(center, filletRadius);
            //get reference circle intersection points
            for (var i = 0; i < 2; i++) {
                var circleIntersection = path.intersection(referenceCircle, properties[i].path);
                if (!circleIntersection) {
                    return false;
                }
                properties[i].shardPoint = circleIntersection.intersectionPoints[0];
                if (MakerJs.measure.isPointEqual(properties[i].point, circleIntersection.intersectionPoints[0], .0001)) {
                    if (circleIntersection.intersectionPoints.length > 1) {
                        properties[i].shardPoint = circleIntersection.intersectionPoints[1];
                    }
                    else {
                        return false;
                    }
                }
            }
            return true;
        }
        /**
         * @private
         */
        function cloneAndBreakPath(pathToShard, shardPoint) {
            var shardStart = path.clone(pathToShard);
            var shardEnd = path.breakAtPoint(shardStart, shardPoint);
            return [shardStart, shardEnd];
        }
        /**
         * @private
         */
        var guidePathMap = {};
        guidePathMap[MakerJs.pathType.Arc] = function (arc, filletRadius, nearPoint, shardPoint, isStart) {
            var guideRadius = arc.radius;
            //see if the guideline should be external or internal to the context arc.
            var guideArcShard = cloneAndBreakPath(arc, shardPoint)[isStart ? 0 : 1];
            if (guideArcShard) {
                if (MakerJs.measure.isArcConcaveTowardsPoint(guideArcShard, nearPoint)) {
                    guideRadius -= filletRadius;
                }
                else {
                    guideRadius += filletRadius;
                }
                return new MakerJs.paths.Arc(arc.origin, guideRadius, arc.startAngle, arc.endAngle);
            }
            return null;
        };
        guidePathMap[MakerJs.pathType.Line] = function (line, filletRadius, nearPoint, shardPoint, isStart) {
            return new MakerJs.paths.Parallel(line, filletRadius, nearPoint);
        };
        /**
         * @private
         */
        function getGuidePath(context, filletRadius, nearPoint) {
            var result = null;
            var fn = guidePathMap[context.path.type];
            if (fn) {
                result = fn(context.path, filletRadius, nearPoint, context.shardPoint, context.isStart);
            }
            return result;
        }
        /**
         * @private
         */
        var filletResultMap = {};
        filletResultMap[MakerJs.pathType.Arc] = function (arc, propertyName, filletRadius, filletCenter) {
            var guideLine = new MakerJs.paths.Line(arc.origin, filletCenter);
            var guideLineAngle = MakerJs.angle.ofLineInDegrees(guideLine);
            var filletAngle = guideLineAngle;
            //the context is an arc and the fillet is an arc so they will be tangent. If the fillet is external to the arc then the tangent is opposite.
            if (!MakerJs.measure.isArcConcaveTowardsPoint(arc, filletCenter)) {
                filletAngle += 180;
            }
            return {
                filletAngle: MakerJs.angle.noRevolutions(filletAngle),
                clipPath: function () {
                    arc[propertyName] = guideLineAngle;
                }
            };
        };
        filletResultMap[MakerJs.pathType.Line] = function (line, propertyName, filletRadius, filletCenter) {
            //make a small vertical line
            var guideLine = new MakerJs.paths.Line([0, 0], [0, 1]);
            //rotate this vertical line the same angle as the line context. It will be perpendicular.
            var lineAngle = MakerJs.angle.ofLineInDegrees(line);
            path.rotate(guideLine, lineAngle, [0, 0]);
            path.moveRelative(guideLine, filletCenter);
            //get the intersection point of the slopes of the context line and the perpendicular line. This is where the fillet meets the line.
            var intersectionPoint = MakerJs.point.fromSlopeIntersection(line, guideLine);
            if (intersectionPoint) {
                return {
                    filletAngle: MakerJs.angle.ofPointInDegrees(filletCenter, intersectionPoint),
                    clipPath: function () {
                        line[propertyName] = intersectionPoint;
                    }
                };
            }
            return null;
        };
        /**
         * @private
         */
        function getFilletResult(context, filletRadius, filletCenter) {
            var result = null;
            var fn = filletResultMap[context.path.type];
            if (fn) {
                result = fn(context.path, context.propertyName, filletRadius, filletCenter);
            }
            if (!testFilletResult(context, result)) {
                result = null;
            }
            return result;
        }
        /**
         * @private
         */
        function getDogboneResult(context, filletCenter) {
            var result = {
                filletAngle: MakerJs.angle.ofPointInDegrees(filletCenter, context.shardPoint),
                clipPath: function () {
                    context.path[context.propertyName] = context.shardPoint;
                }
            };
            if (!testFilletResult(context, result)) {
                result = null;
            }
            return result;
        }
        /**
         * @private
         */
        function testFilletResult(context, result) {
            var test = false;
            if (result) {
                //temporarily clip the path.
                var originalValue = context.path[context.propertyName];
                result.clipPath();
                //don't allow a fillet which effectivly eliminates the path.
                if (MakerJs.measure.pathLength(context.path) > 0) {
                    test = true;
                }
                //revert the clipping we just did.
                context.path[context.propertyName] = originalValue;
            }
            return test;
        }
        /**
         * @private
         */
        function getLineRatio(lines) {
            var totalLength = 0;
            var lengths = [];
            for (var i = 0; i < lines.length; i++) {
                var length = MakerJs.measure.pathLength(lines[i]);
                lengths.push(length);
                totalLength += length;
            }
            return lengths[0] / totalLength;
        }
        /**
         * Adds a round corner to the outside angle between 2 lines. The lines must meet at one point.
         *
         * @param lineA First line to fillet, which will be modified to fit the fillet.
         * @param lineB Second line to fillet, which will be modified to fit the fillet.
         * @returns Arc path object of the new fillet.
         */
        function dogbone(lineA, lineB, filletRadius, options) {
            if (MakerJs.isPathLine(lineA) && MakerJs.isPathLine(lineB) && filletRadius && filletRadius > 0) {
                var opts = {
                    pointMatchingDistance: .005
                };
                MakerJs.extendObject(opts, options);
                //first find the common point
                var commonProperty = getMatchingPointProperties(lineA, lineB, options);
                if (commonProperty) {
                    //get the ratio comparison of the two lines
                    var ratio = getLineRatio([lineA, lineB]);
                    //draw a line between the two endpoints, and get the bisection point at the ratio
                    var span = new MakerJs.paths.Line(commonProperty[0].oppositePoint, commonProperty[1].oppositePoint);
                    var midRatioPoint = MakerJs.point.middle(span, ratio);
                    //use the bisection theorem to get the angle bisecting the lines
                    var bisectionAngle = MakerJs.angle.ofPointInDegrees(commonProperty[0].point, midRatioPoint);
                    var center = MakerJs.point.add(commonProperty[0].point, MakerJs.point.fromPolar(MakerJs.angle.toRadians(bisectionAngle), filletRadius));
                    if (!populateShardPointsFromReferenceCircle(filletRadius, center, commonProperty, opts)) {
                        return null;
                    }
                    //get the angles of the fillet and a function which clips the path to the fillet.
                    var results = [];
                    for (var i = 0; i < 2; i++) {
                        var result = getDogboneResult(commonProperty[i], center);
                        if (!result) {
                            return null;
                        }
                        results.push(result);
                    }
                    var filletArc = new MakerJs.paths.Arc(center, filletRadius, results[0].filletAngle, results[1].filletAngle);
                    //make sure midpoint of fillet is outside of the angle
                    if (MakerJs.round(MakerJs.angle.noRevolutions(MakerJs.angle.ofArcMiddle(filletArc))) == MakerJs.round(bisectionAngle)) {
                        filletArc.startAngle = results[1].filletAngle;
                        filletArc.endAngle = results[0].filletAngle;
                    }
                    //clip the paths and return the fillet arc.
                    results[0].clipPath();
                    results[1].clipPath();
                    return filletArc;
                }
            }
            return null;
        }
        path.dogbone = dogbone;
        /**
         * Adds a round corner to the inside angle between 2 paths. The paths must meet at one point.
         *
         * @param pathA First path to fillet, which will be modified to fit the fillet.
         * @param pathB Second path to fillet, which will be modified to fit the fillet.
         * @param filletRadius Radius of the fillet.
         * @param options Optional IPointMatchOptions object to specify pointMatchingDistance.
         * @returns Arc path object of the new fillet.
         */
        function fillet(pathA, pathB, filletRadius, options) {
            if (pathA && pathB && filletRadius && filletRadius > 0) {
                var opts = {
                    pointMatchingDistance: .005
                };
                MakerJs.extendObject(opts, options);
                //first find the common point
                var commonProperty = getMatchingPointProperties(pathA, pathB, options);
                if (commonProperty) {
                    //since arcs can curl beyond, we need a local reference point. 
                    //An intersection with a circle of the same radius as the desired fillet should suffice.
                    if (!populateShardPointsFromReferenceCircle(filletRadius, commonProperty[0].point, commonProperty, opts)) {
                        return null;
                    }
                    //get "parallel" guidelines
                    var guidePaths = [];
                    for (var i = 0; i < 2; i++) {
                        var otherPathShardPoint = commonProperty[1 - i].shardPoint;
                        if (!otherPathShardPoint) {
                            return null;
                        }
                        var guidePath = getGuidePath(commonProperty[i], filletRadius, otherPathShardPoint);
                        guidePaths.push(guidePath);
                    }
                    //the center of the fillet is the point where the guidelines intersect.
                    var intersectionPoint = path.intersection(guidePaths[0], guidePaths[1]);
                    if (intersectionPoint) {
                        var center;
                        //if guidelines intersect in more than one place, choose the closest one.
                        if (intersectionPoint.intersectionPoints.length == 1) {
                            center = intersectionPoint.intersectionPoints[0];
                        }
                        else {
                            center = MakerJs.point.closest(commonProperty[0].point, intersectionPoint.intersectionPoints);
                        }
                        //get the angles of the fillet and a function which clips the path to the fillet.
                        var results = [];
                        for (var i = 0; i < 2; i++) {
                            var result = getFilletResult(commonProperty[i], filletRadius, center);
                            if (!result) {
                                return null;
                            }
                            results.push(result);
                        }
                        //the two paths may actually be on the same line
                        if (MakerJs.round(results[0].filletAngle - results[1].filletAngle) == 0)
                            return null;
                        var filletArc = new MakerJs.paths.Arc(center, filletRadius, results[0].filletAngle, results[1].filletAngle);
                        var filletSpan = MakerJs.angle.ofArcSpan(filletArc);
                        //the algorithm is only valid for fillet less than 180 degrees
                        if (filletSpan == 180) {
                            return null;
                        }
                        if (filletSpan > 180) {
                            //swap to make smallest angle
                            filletArc.startAngle = results[1].filletAngle;
                            filletArc.endAngle = results[0].filletAngle;
                        }
                        //clip the paths and return the fillet arc.
                        results[0].clipPath();
                        results[1].clipPath();
                        return filletArc;
                    }
                }
            }
            return null;
        }
        path.fillet = fillet;
    })(path = MakerJs.path || (MakerJs.path = {}));
})(MakerJs || (MakerJs = {}));
(function (MakerJs) {
    var chain;
    (function (chain) {
        /**
         * Adds a fillet between each link in a chain. Each path will be cropped to fit a fillet, and all fillets will be returned as paths in a returned model object.
         *
         * @param chainToFillet The chain to add fillets to.
         * @param filletRadius Radius of the fillet.
         * @returns Model object containing paths which fillet the joints in the chain.
         */
        function fillet(chainToFillet, filletRadius) {
            var result = { paths: {} };
            var added = 0;
            var links = chainToFillet.links;
            function add(i1, i2) {
                var f = MakerJs.path.fillet(links[i1].walkedPath.pathContext, links[i2].walkedPath.pathContext, filletRadius);
                if (f) {
                    result.paths['fillet' + added] = f;
                    added++;
                }
            }
            for (var i = 1; i < links.length; i++) {
                add(i - 1, i);
            }
            if (chainToFillet.endless) {
                add(i - 1, 0);
            }
            if (!added)
                return null;
            return result;
        }
        chain.fillet = fillet;
    })(chain = MakerJs.chain || (MakerJs.chain = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var kit;
    (function (kit) {
        //construct a model
        /**
         * Helper function to use the JavaScript "apply" function in conjunction with the "new" keyword.
         *
         * @param ctor The constructor for the class which is an IKit.
         * @param args The array of parameters passed to the constructor.
         * @returns A new instance of the class, which implements the IModel interface.
         */
        function construct(ctor, args) {
            function F() {
                return ctor.apply(this, args);
            }
            F.prototype = ctor.prototype;
            return new F();
        }
        kit.construct = construct;
        /**
         * Extract just the initial sample values from a kit.
         *
         * @param ctor The constructor for the class which is an IKit.
         * @returns Array of the inital sample values provided in the metaParameters array.
         */
        function getParameterValues(ctor) {
            var parameters = [];
            var metaParams = ctor.metaParameters;
            if (metaParams) {
                for (var i = 0; i < metaParams.length; i++) {
                    var value = metaParams[i].value;
                    if (Array.isArray(value)) {
                        value = value[0];
                    }
                    parameters.push(value);
                }
            }
            return parameters;
        }
        kit.getParameterValues = getParameterValues;
    })(kit = MakerJs.kit || (MakerJs.kit = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * @private
         */
        function getOpposedLink(linkedPaths, pathContext) {
            if (linkedPaths[0].walkedPath.pathContext === pathContext) {
                return linkedPaths[1];
            }
            return linkedPaths[0];
        }
        /**
         * @private
         */
        function followLinks(connections, chainFound, chainNotFound) {
            function followLink(currLink, chain, firstLink) {
                while (currLink) {
                    chain.links.push(currLink);
                    chain.pathLength += currLink.pathLength;
                    var next = currLink.reversed ? 0 : 1;
                    var nextPoint = currLink.endPoints[next];
                    var items = connections.findCollection(nextPoint);
                    if (!items || items.length === 0) {
                        break;
                    }
                    var nextLink = getOpposedLink(items, currLink.walkedPath.pathContext);
                    //remove the first 2 items, which should be currlink and nextlink
                    items.splice(0, 2);
                    if (!nextLink) {
                        break;
                    }
                    if (nextLink.walkedPath.pathContext === firstLink.walkedPath.pathContext) {
                        chain.endless = true;
                        break;
                    }
                    currLink = nextLink;
                }
            }
            for (var i = 0; i < connections.collections.length; i++) {
                var linkedPaths = connections.collections[i].items;
                if (linkedPaths && linkedPaths.length > 0) {
                    var chain = {
                        links: [],
                        pathLength: 0
                    };
                    followLink(linkedPaths[0], chain, linkedPaths[0]);
                    if (chain.endless) {
                        chainFound(chain);
                    }
                    else {
                        //need to go in reverse
                        chain.links.reverse();
                        var firstLink = chain.links[0];
                        chain.links.map(function (link) { link.reversed = !link.reversed; });
                        //remove the last link, it will be added in the call
                        chain.pathLength -= chain.links[chain.links.length - 1].pathLength;
                        var currLink = chain.links.pop();
                        followLink(currLink, chain, firstLink);
                        if (chain.links.length > 1) {
                            chainFound(chain);
                        }
                        else {
                            chainNotFound(chain.links[0].walkedPath);
                        }
                    }
                    //if there were more than 2 paths on this point, follow those too.
                    if (linkedPaths.length > 0) {
                        i--;
                    }
                }
            }
        }
        /**
         * Find a single chain within a model, across all layers. Shorthand of findChains; useful when you know there is only one chain to find in your model.
         *
         * @param modelContext The model to search for a chain.
         * @returns A chain object or null if chains were not found.
         */
        function findSingleChain(modelContext) {
            var singleChain = null;
            findChains(modelContext, function (chains, loose, layer) {
                singleChain = chains[0];
            }, { byLayers: false });
            return singleChain;
        }
        model.findSingleChain = findSingleChain;
        /**
         * Find paths that have common endpoints and form chains.
         *
         * @param modelContext The model to search for chains.
         * @param options Optional options object.
         */
        function findChains(modelContext, callback, options) {
            var opts = {
                pointMatchingDistance: .005
            };
            MakerJs.extendObject(opts, options);
            function comparePoint(pointA, pointB) {
                var distance = MakerJs.measure.pointDistance(pointA, pointB);
                return distance <= opts.pointMatchingDistance;
            }
            var connectionMap = {};
            var chainsByLayer = {};
            var ignored = {};
            var walkOptions = {
                onPath: function (walkedPath) {
                    var layer = opts.byLayers ? walkedPath.layer : '';
                    if (!connectionMap[layer]) {
                        connectionMap[layer] = new MakerJs.Collector(comparePoint);
                    }
                    var connections = connectionMap[layer];
                    var pathLength = MakerJs.measure.pathLength(walkedPath.pathContext);
                    //circles are loops by nature
                    if (walkedPath.pathContext.type === MakerJs.pathType.Circle ||
                        (walkedPath.pathContext.type === MakerJs.pathType.Arc && MakerJs.round(MakerJs.angle.ofArcSpan(walkedPath.pathContext) - 360) === 0) ||
                        (walkedPath.pathContext.type === MakerJs.pathType.BezierSeed && MakerJs.measure.isPointEqual(walkedPath.pathContext.origin, walkedPath.pathContext.end, opts.pointMatchingDistance))) {
                        var chain = {
                            links: [{
                                    walkedPath: walkedPath,
                                    reversed: null,
                                    endPoints: null,
                                    pathLength: pathLength
                                }],
                            endless: true,
                            pathLength: pathLength
                        };
                        //store circles so that layers fire grouped
                        if (!chainsByLayer[layer]) {
                            chainsByLayer[layer] = [];
                        }
                        chainsByLayer[layer].push(chain);
                    }
                    else {
                        //don't add lines which are shorter than the tolerance
                        if (pathLength < opts.pointMatchingDistance) {
                            if (!ignored[layer]) {
                                ignored[layer] = [];
                            }
                            ignored[layer].push(walkedPath);
                            return;
                        }
                        //gather both endpoints from all non-circle segments
                        var endPoints = MakerJs.point.fromPathEnds(walkedPath.pathContext, walkedPath.offset);
                        for (var i = 0; i < 2; i++) {
                            var link = {
                                walkedPath: walkedPath,
                                endPoints: endPoints,
                                reversed: i != 0,
                                pathLength: pathLength
                            };
                            connections.addItemToCollection(endPoints[i], link);
                        }
                    }
                }
            };
            if (opts.shallow) {
                walkOptions.beforeChildWalk = function () { return false; };
            }
            model.walk(modelContext, walkOptions);
            for (var layer in connectionMap) {
                var connections = connectionMap[layer];
                var loose = [];
                if (!chainsByLayer[layer]) {
                    chainsByLayer[layer] = [];
                }
                //follow paths to find loops
                followLinks(connections, function (chain) {
                    chainsByLayer[layer].push(chain);
                }, function (walkedPath) {
                    loose.push(walkedPath);
                });
                //sort to return largest chains first
                chainsByLayer[layer].sort(function (a, b) { return b.pathLength - a.pathLength; });
                callback(chainsByLayer[layer], loose, layer, ignored[layer]);
            }
        }
        model.findChains = findChains;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
(function (MakerJs) {
    var chain;
    (function (chain) {
        /**
         * Shift the links of an endless chain.
         *
         * @param chainContext Chain to cycle through. Must be endless.
         * @param amount Optional number of links to shift. May be negative to cycle backwards.
         * @returns The chainContext for cascading.
         */
        function cycle(chainContext, amount) {
            if (amount === void 0) { amount = 1; }
            if (!chainContext.endless)
                return;
            var n = Math.abs(amount);
            for (var i = 0; i < n; i++) {
                if (amount < 0) {
                    //remove from beginning, add to end
                    chainContext.links.push(chainContext.links.shift());
                }
                else {
                    //remove from end, add to beginning
                    chainContext.links.unshift(chainContext.links.pop());
                }
            }
            return chainContext;
        }
        chain.cycle = cycle;
        /**
         * Reverse the links of a chain.
         *
         * @param chainContext Chain to reverse.
         * @returns The chainContext for cascading.
         */
        function reverse(chainContext) {
            chainContext.links.reverse();
            chainContext.links.forEach(function (link) { return link.reversed = !link.reversed; });
            return chainContext;
        }
        chain.reverse = reverse;
        /**
         * Set the beginning of an endless chain to a known routeKey of a path.
         *
         * @param chainContext Chain to cycle through. Must be endless.
         * @param routeKey RouteKey of the desired path to start the chain with.
         * @returns The chainContext for cascading.
         */
        function startAt(chainContext, routeKey) {
            if (!chainContext.endless)
                return;
            var index = -1;
            for (var i = 0; i < chainContext.links.length; i++) {
                if (chainContext.links[i].walkedPath.routeKey == routeKey) {
                    index = i;
                    break;
                }
            }
            if (index > 0) {
                cycle(chainContext, index);
            }
            return chainContext;
        }
        chain.startAt = startAt;
        /**
         * @private
         */
        function removeDuplicateEnds(endless, points) {
            if (!endless || points.length < 2)
                return;
            if (MakerJs.measure.isPointEqual(points[0], points[points.length - 1], .00001)) {
                points.pop();
            }
        }
        /**
         * Get points along a chain of paths.
         *
         * @param chainContext Chain of paths to get points from.
         * @param distance Distance along the chain between points.
         * @param maxPoints Maximum number of points to retrieve.
         * @returns Array of points which are on the chain spread at a uniform interval.
         */
        function toPoints(chainContext, distance, maxPoints) {
            var result = [];
            var t = 0;
            for (var i = 0; i < chainContext.links.length; i++) {
                var link = chainContext.links[i];
                var wp = link.walkedPath;
                var len = link.pathLength;
                while (MakerJs.round(len - t) > 0) {
                    var r = t / len;
                    if (link.reversed) {
                        r = 1 - r;
                    }
                    result.push(MakerJs.point.add(MakerJs.point.middle(wp.pathContext, r), wp.offset));
                    if (maxPoints && result.length >= maxPoints)
                        return result;
                    t += distance;
                }
                t -= len;
            }
            removeDuplicateEnds(chainContext.endless, result);
            return result;
        }
        chain.toPoints = toPoints;
        /**
         * Get key points (a minimal a number of points) along a chain of paths.
         *
         * @param chainContext Chain of paths to get points from.
         * @param maxArcFacet The maximum length between points on an arc or circle.
         * @returns Array of points which are on the chain.
         */
        function toKeyPoints(chainContext, maxArcFacet) {
            var result = [];
            for (var i = 0; i < chainContext.links.length; i++) {
                var link = chainContext.links[i];
                var wp = link.walkedPath;
                var keyPoints = MakerJs.path.toKeyPoints(wp.pathContext, maxArcFacet);
                if (keyPoints.length > 0) {
                    if (link.reversed) {
                        keyPoints.reverse();
                    }
                    if (i > 0) {
                        keyPoints.shift();
                    }
                    var offsetPathPoints = keyPoints.map(function (p) { return MakerJs.point.add(p, wp.offset); });
                    result.push.apply(result, offsetPathPoints);
                }
            }
            removeDuplicateEnds(chainContext.endless, result);
            return result;
        }
        chain.toKeyPoints = toKeyPoints;
    })(chain = MakerJs.chain || (MakerJs.chain = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var model;
    (function (model) {
        /**
         * @private
         */
        function getOpposedLink(linkedPaths, pathContext) {
            if (linkedPaths[0].path === pathContext) {
                return linkedPaths[1];
            }
            return linkedPaths[0];
        }
        /**
         * @private
         */
        function getFirstPathFromModel(modelContext) {
            if (!modelContext.paths)
                return null;
            for (var pathId in modelContext.paths) {
                return modelContext.paths[pathId];
            }
            return null;
        }
        /**
         * @private
         */
        function collectLoop(loop, loops, detach) {
            loops.push(loop);
            if (detach) {
                detachLoop(loop);
            }
        }
        /**
         * @private
         */
        function follow(connections, loops, detach) {
            //for a given point, follow the paths that connect to each other to form loops
            for (var i = 0; i < connections.collections.length; i++) {
                var linkedPaths = connections.collections[i].items;
                if (linkedPaths && linkedPaths.length > 0) {
                    var loopModel = {
                        paths: {},
                        insideCount: 0
                    };
                    var firstLink = linkedPaths[0];
                    var currLink = firstLink;
                    while (true) {
                        var currPath = currLink.path;
                        currPath.reversed = currLink.reversed;
                        var id = model.getSimilarPathId(loopModel, currPath.pathId);
                        loopModel.paths[id] = currPath;
                        var items = connections.findCollection(currLink.nextConnection);
                        if (!items || items.length == 0)
                            break;
                        var nextLink = getOpposedLink(items, currLink.path);
                        //remove the first 2 items, which should be currlink and nextlink
                        items.splice(0, 2);
                        if (!nextLink)
                            break;
                        currLink = nextLink;
                        if (currLink.path === firstLink.path) {
                            //loop is closed
                            collectLoop(loopModel, loops, detach);
                            break;
                        }
                    }
                }
            }
        }
        /**
         * Find paths that have common endpoints and form loops.
         *
         * @param modelContext The model to search for loops.
         * @param options Optional options object.
         * @returns A new model with child models ranked according to their containment within other found loops. The paths of models will be IPathDirectionalWithPrimeContext.
         */
        function findLoops(modelContext, options) {
            var loops = [];
            var result = { models: {} };
            var opts = {
                pointMatchingDistance: .005
            };
            MakerJs.extendObject(opts, options);
            function spin(callback) {
                for (var i = 0; i < loops.length; i++) {
                    callback(loops[i]);
                }
            }
            function getModelByDepth(depth) {
                var id = depth.toString();
                if (!(id in result.models)) {
                    var newModel = { models: {} };
                    result.models[id] = newModel;
                }
                return result.models[id];
            }
            function comparePoint(pointA, pointB) {
                var distance = MakerJs.measure.pointDistance(pointA, pointB);
                return distance <= opts.pointMatchingDistance;
            }
            var connections = new MakerJs.Collector(comparePoint);
            //todo: remove dead ends first
            model.originate(modelContext);
            //find loops by looking at all paths in this model
            var walkOptions = {
                onPath: function (walkedPath) {
                    var safePath = MakerJs.path.clone(walkedPath.pathContext);
                    safePath.pathId = walkedPath.pathId;
                    safePath.modelContext = modelContext;
                    //circles are loops by nature
                    if (safePath.type == MakerJs.pathType.Circle || (safePath.type == MakerJs.pathType.Arc && MakerJs.angle.ofArcSpan(walkedPath.pathContext) == 360)) {
                        var loopModel = {
                            paths: {},
                            insideCount: 0
                        };
                        loopModel.paths[walkedPath.pathId] = safePath;
                        collectLoop(loopModel, loops, opts.removeFromOriginal);
                    }
                    else {
                        //gather both endpoints from all non-circle segments
                        safePath.endPoints = MakerJs.point.fromPathEnds(safePath);
                        //don't add lines which are shorter than the tolerance
                        if (safePath.type == MakerJs.pathType.Line) {
                            var distance = MakerJs.measure.pointDistance(safePath.endPoints[0], safePath.endPoints[1]);
                            if (distance < opts.pointMatchingDistance) {
                                return;
                            }
                        }
                        for (var i = 2; i--;) {
                            var linkedPath = {
                                path: safePath,
                                nextConnection: safePath.endPoints[1 - i],
                                reversed: i != 0
                            };
                            connections.addItemToCollection(safePath.endPoints[i], linkedPath);
                        }
                    }
                }
            };
            model.walk(modelContext, walkOptions);
            //follow paths to find loops
            follow(connections, loops, opts.removeFromOriginal);
            //now we have all loops, we need to see which are inside of each other
            spin(function (firstLoop) {
                var firstPath = getFirstPathFromModel(firstLoop);
                if (!firstPath)
                    return;
                spin(function (secondLoop) {
                    if (firstLoop === secondLoop)
                        return;
                    if (model.isPathInsideModel(firstPath, secondLoop)) {
                        firstLoop.insideCount++;
                    }
                });
            });
            //now we can group similar loops by their nested level
            spin(function (loop) {
                var depthModel = getModelByDepth(loop.insideCount);
                var id = model.countChildModels(depthModel).toString();
                delete loop.insideCount;
                depthModel.models[id] = loop;
            });
            return result;
        }
        model.findLoops = findLoops;
        /**
         * Remove all paths in a loop model from the model(s) which contained them.
         *
         * @param loopToDetach The model to search for loops.
         */
        function detachLoop(loopToDetach) {
            for (var id in loopToDetach.paths) {
                var pathDirectionalWithOriginalContext = loopToDetach.paths[id];
                var primeModel = pathDirectionalWithOriginalContext.modelContext;
                if (primeModel && primeModel.paths && pathDirectionalWithOriginalContext.pathId) {
                    delete primeModel.paths[pathDirectionalWithOriginalContext.pathId];
                }
            }
        }
        model.detachLoop = detachLoop;
        /**
         * @private
         */
        var DeadEndFinder = (function () {
            function DeadEndFinder(pointMatchingDistance, keep) {
                this.pointMatchingDistance = pointMatchingDistance;
                this.keep = keep;
                pointMatchingDistance = pointMatchingDistance || .005;
                function comparePoint(pointA, pointB) {
                    var distance = MakerJs.measure.pointDistance(pointA, pointB);
                    return distance <= pointMatchingDistance;
                }
                this.pointMap = new MakerJs.Collector(comparePoint);
            }
            DeadEndFinder.prototype.removePathRef = function (pathRef) {
                var _this = this;
                var removePath = function (p) {
                    var pathRefs = _this.pointMap.findCollection(p);
                    for (var i = 0; i < pathRefs.length; i++) {
                        if (pathRefs[i] === pathRef) {
                            pathRefs.splice(i, 1);
                            return;
                        }
                    }
                };
                for (var i = 2; i--;) {
                    removePath(pathRef.endPoints[i]);
                }
            };
            DeadEndFinder.prototype.removeDeadEnd = function () {
                var _this = this;
                var found = false;
                for (var i = 0; i < this.pointMap.collections.length; i++) {
                    var pathRefs = this.pointMap.collections[i].items;
                    if (pathRefs.length % 2 == 0)
                        continue;
                    if (pathRefs.length == 1) {
                        var pathRef = pathRefs[0];
                        this.removePathRef(pathRef);
                        delete pathRef.modelContext.paths[pathRef.pathId];
                        found = true;
                    }
                    else if (this.keep) {
                        //allow caller to decide to keep each path
                        pathRefs.map(function (pathRef, i) {
                            if (!_this.keep(pathRef)) {
                                _this.removePathRef(pathRef);
                                delete pathRef.modelContext.paths[pathRef.pathId];
                                found = true;
                            }
                        });
                    }
                }
                return found;
            };
            return DeadEndFinder;
        }());
        /**
         * Remove paths from a model which have endpoints that do not connect to other paths.
         *
         * @param modelContext The model to search for dead ends.
         * @param options Optional options object.
         * @returns The input model (for cascading).
         */
        function removeDeadEnds(modelContext, pointMatchingDistance, keep) {
            var deadEndFinder = new DeadEndFinder(pointMatchingDistance, keep);
            var walkOptions = {
                onPath: function (walkedPath) {
                    var endPoints = MakerJs.point.fromPathEnds(walkedPath.pathContext, walkedPath.offset);
                    if (!endPoints)
                        return;
                    var pathRef = walkedPath;
                    pathRef.endPoints = endPoints;
                    for (var i = 2; i--;) {
                        deadEndFinder.pointMap.addItemToCollection(endPoints[i], pathRef);
                    }
                }
            };
            model.walk(modelContext, walkOptions);
            while (deadEndFinder.removeDeadEnd())
                ;
            return modelContext;
        }
        model.removeDeadEnds = removeDeadEnds;
    })(model = MakerJs.model || (MakerJs.model = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter) {
        /**
         * Class for an XML tag.
         * @private
         */
        var XmlTag = (function () {
            /**
             * @param name Name of the XML tag.
             * @param attrs Optional attributes for the tag.
             */
            function XmlTag(name, attrs) {
                this.name = name;
                this.attrs = attrs;
                /**
                 * Text between the opening and closing tags.
                 */
                this.innerText = '';
            }
            /**
             * Escapes certain characters within a string so that it can appear in a tag or its attribute.
             *
             * @returns Escaped string.
             */
            XmlTag.escapeString = function (value) {
                var escape = {
                    '&': '&amp;',
                    '<': '&lt;',
                    '>': '&gt;',
                    '"': '&quot;'
                };
                for (var code in escape) {
                    //.split then .join is a 'replace'
                    value = value.split(code).join(escape[code]);
                }
                return value;
            };
            /**
             * Get the opening tag.
             *
             * @param selfClose Flag to determine if opening tag should be self closing.
             */
            XmlTag.prototype.getOpeningTag = function (selfClose) {
                var attrs = '';
                function outputAttr(attrName, attrValue) {
                    if (attrValue == null || typeof attrValue === 'undefined')
                        return;
                    if (typeof attrValue === 'string') {
                        attrValue = XmlTag.escapeString(attrValue);
                    }
                    attrs += ' ' + attrName + '="' + attrValue + '"';
                }
                for (var name in this.attrs) {
                    outputAttr(name, this.attrs[name]);
                }
                return '<' + this.name + attrs + (selfClose ? '/' : '') + '>';
            };
            /**
             * Get the inner text.
             */
            XmlTag.prototype.getInnerText = function () {
                if (this.innerTextEscaped) {
                    return this.innerText;
                }
                else {
                    return XmlTag.escapeString(this.innerText);
                }
            };
            /**
             * Get the closing tag.
             */
            XmlTag.prototype.getClosingTag = function () {
                return '</' + this.name + '>';
            };
            /**
             * Output the entire tag as a string.
             */
            XmlTag.prototype.toString = function () {
                var selfClose = !this.innerText;
                if (selfClose) {
                    return this.getOpeningTag(true);
                }
                else {
                    return this.getOpeningTag(false) + this.getInnerText() + this.getClosingTag();
                }
            };
            return XmlTag;
        }());
        exporter.XmlTag = XmlTag;
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter) {
        /**
         * @private
         */
        function wrap(prefix, content, condition) {
            if (condition) {
                return prefix + '(' + content + ')';
            }
            else {
                return content;
            }
        }
        /**
         * @private
         */
        function facetSizeToResolution(arcOrCircle, facetSize) {
            if (!facetSize)
                return;
            var circle = new MakerJs.paths.Circle([0, 0], arcOrCircle.radius);
            var length = MakerJs.measure.pathLength(circle);
            if (!length)
                return;
            return length / facetSize;
        }
        /**
         * @private
         */
        function pathsToOpenJsCad(modelContext, facetSize) {
            var head = '';
            var tail = '';
            var first = true;
            var exit = false;
            var reverseTail = false;
            var beginMap = {};
            beginMap[MakerJs.pathType.Circle] = function (circle, dirPath) {
                var circleOptions = {
                    center: MakerJs.point.rounded(circle.origin),
                    radius: circle.radius,
                    resolution: facetSizeToResolution(circle, facetSize)
                };
                head = wrap('CAG.circle', JSON.stringify(circleOptions), true);
                exit = true;
            };
            beginMap[MakerJs.pathType.Line] = function (line, dirPath) {
                head = wrap('new CSG.Path2D', JSON.stringify(dirPath.reversed ? [dirPath.endPoints[1], dirPath.endPoints[0]] : dirPath.endPoints), true);
            };
            beginMap[MakerJs.pathType.Arc] = function (arc, dirPath) {
                var endAngle = MakerJs.angle.ofArcEnd(arc);
                if (dirPath.reversed) {
                    reverseTail = true;
                }
                var arcOptions = {
                    center: MakerJs.point.rounded(arc.origin),
                    radius: arc.radius,
                    startangle: arc.startAngle,
                    endangle: endAngle,
                    resolution: facetSizeToResolution(arc, facetSize)
                };
                head = wrap('new CSG.Path2D.arc', JSON.stringify(arcOptions), true);
            };
            var appendMap = {};
            appendMap[MakerJs.pathType.Line] = function (line, dirPath) {
                var reverse = (reverseTail != dirPath.reversed);
                var endPoint = MakerJs.point.rounded(dirPath.endPoints[reverse ? 0 : 1]);
                append(wrap('.appendPoint', JSON.stringify(endPoint), true));
            };
            appendMap[MakerJs.pathType.Arc] = function (arc, dirPath) {
                var reverse = (reverseTail != dirPath.reversed);
                var endAngle = MakerJs.angle.ofArcEnd(arc);
                var arcOptions = {
                    radius: arc.radius,
                    clockwise: reverse,
                    large: Math.abs(endAngle - arc.startAngle) > 180,
                    resolution: facetSizeToResolution(arc, facetSize)
                };
                var endPoint = MakerJs.point.rounded(dirPath.endPoints[reverse ? 0 : 1]);
                append(wrap('.appendArc', JSON.stringify(endPoint) + ',' + JSON.stringify(arcOptions), true));
            };
            function append(s) {
                if (reverseTail) {
                    tail = s + tail;
                }
                else {
                    tail += s;
                }
            }
            for (var pathId in modelContext.paths) {
                var pathContext = modelContext.paths[pathId];
                var fn = first ? beginMap[pathContext.type] : appendMap[pathContext.type];
                if (fn) {
                    fn(pathContext, pathContext);
                }
                if (exit) {
                    return head;
                }
                first = false;
            }
            return head + tail + '.close().innerToCAG()';
        }
        /**
         * Creates a string of JavaScript code for execution with the OpenJsCad engine.
         *
         * @param modelToExport Model object to export.
         * @param options Export options object.
         * @param options.extrusion Height of 3D extrusion.
         * @param options.resolution Size of facets.
         * @returns String of JavaScript containing a main() function for OpenJsCad.
         */
        function toOpenJsCad(modelToExport, options) {
            if (!modelToExport)
                return '';
            var all = '';
            var depth = 0;
            var depthModel;
            var opts = {
                extrusion: 1,
                pointMatchingDistance: .005,
                functionName: 'main'
            };
            MakerJs.extendObject(opts, options);
            if (modelToExport.exporterOptions) {
                MakerJs.extendObject(opts, modelToExport.exporterOptions['toOpenJsCad']);
            }
            //pass options back into calling object
            MakerJs.extendObject(options, opts);
            if (opts && opts.modelMap) {
                all = exportFromOptionsMap(modelToExport, opts.modelMap);
            }
            if (!all) {
                var result = [];
                var loops = MakerJs.model.findLoops(modelToExport, opts);
                while (depthModel = loops.models[depth]) {
                    var union = '';
                    for (var modelId in depthModel.models) {
                        var subModel = depthModel.models[modelId];
                        union += wrap('.union', pathsToOpenJsCad(subModel, opts.facetSize), union);
                    }
                    var operator = (depth % 2 == 0) ? '.union' : '.subtract';
                    result.push(wrap(operator, union, result.length));
                    depth++;
                }
                var extrudeOptions = { offset: [0, 0, opts.extrusion] };
                result.push(wrap('.extrude', JSON.stringify(extrudeOptions), true));
                all = 'return ' + result.join('');
            }
            return 'function ' + opts.functionName + '(){' + all + ';}';
        }
        exporter.toOpenJsCad = toOpenJsCad;
        function exportFromOptionsMap(modelToExport, optionsMap) {
            if (!modelToExport.models)
                return;
            var result = [];
            var union = [];
            var i = 0;
            for (var key in optionsMap) {
                var fName = 'f' + i;
                var options = optionsMap[key];
                options.functionName = fName;
                var childModel = modelToExport.models[key];
                if (childModel) {
                    result.push(toOpenJsCad(childModel, options));
                    union.push('(' + fName + '())');
                }
                i++;
            }
            if (!result.length)
                return;
            result.push('return ' + union.join('.union'));
            return result.join(' ');
        }
        /**
         * Executes a JavaScript string with the OpenJsCad engine - converts 2D to 3D.
         *
         * @param modelToExport Model object to export.
         * @param options Export options object.
         * @param options.extrusion Height of 3D extrusion.
         * @param options.resolution Size of facets.
         * @returns String of STL format of 3D object.
         */
        function toSTL(modelToExport, options) {
            if (options === void 0) { options = {}; }
            if (!modelToExport)
                return '';
            var container;
            switch (MakerJs.environment) {
                case MakerJs.environmentTypes.BrowserUI:
                    if (!('CAG' in window) || !('CSG' in window)) {
                        throw "OpenJsCad library not found. Download http://microsoft.github.io/maker.js/external/OpenJsCad/csg.js and http://microsoft.github.io/maker.js/external/OpenJsCad/formats.js to your website and add script tags.";
                    }
                    container = window;
                    break;
                case MakerJs.environmentTypes.NodeJs:
                    //this can throw if not found
                    container = __webpack_require__(/*! openjscad-csg */ "./node_modules/openjscad-csg/index.js");
                    break;
                case MakerJs.environmentTypes.WebWorker:
                    if (!('CAG' in self) || !('CSG' in self)) {
                        throw "OpenJsCad library not found. Download http://microsoft.github.io/maker.js/external/OpenJsCad/csg.js and http://microsoft.github.io/maker.js/external/OpenJsCad/formats.js to your website and add an importScripts statement.";
                    }
                    container = self;
                    break;
            }
            var script = toOpenJsCad(modelToExport, options);
            script += 'return ' + options.functionName + '();';
            var f = new Function('CAG', 'CSG', script);
            var csg = f(container.CAG, container.CSG);
            return csg.toStlString();
        }
        exporter.toSTL = toSTL;
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter) {
        /**
         * Injects drawing into a PDFKit document.
         *
         * @param modelToExport Model object to export.
         * @param options Export options object.
         * @returns String of PDF file contents.
         */
        function toPDF(doc, modelToExport, options) {
            if (!modelToExport)
                return;
            //fixup options
            var opts = {
                origin: [0, 0],
                stroke: "#000"
            };
            MakerJs.extendObject(opts, options);
            //try to get the unit system from the itemToExport
            var scale = 1;
            var exportUnits = opts.units || modelToExport.units;
            if (exportUnits) {
                //convert to inch
                scale = MakerJs.units.conversionScale(exportUnits, MakerJs.unitType.Inch);
            }
            else {
                //assume pixels, convert to inch
                scale = 1 / 100;
            }
            //from inch to PDF PPI
            scale *= 72;
            //TODO scale each element without a whole clone
            var scaledModel = MakerJs.model.scale(MakerJs.cloneObject(modelToExport), scale);
            var size = MakerJs.measure.modelExtents(scaledModel);
            var left = -size.low[0];
            var offset = [left, size.high[1]];
            offset = MakerJs.point.add(offset, options.origin);
            MakerJs.model.findChains(scaledModel, function (chains, loose, layer) {
                function single(walkedPath) {
                    var pathData = exporter.pathToSVGPathData(walkedPath.pathContext, walkedPath.offset, offset);
                    doc.path(pathData).stroke(opts.stroke);
                }
                chains.map(function (chain) {
                    if (chain.links.length > 1) {
                        var pathData = exporter.chainToSVGPathData(chain, offset);
                        doc.path(pathData).stroke(opts.stroke);
                    }
                    else {
                        var walkedPath = chain.links[0].walkedPath;
                        if (walkedPath.pathContext.type === MakerJs.pathType.Circle) {
                            var fixedPath;
                            MakerJs.path.moveTemporary([walkedPath.pathContext], [walkedPath.offset], function () {
                                fixedPath = MakerJs.path.mirror(walkedPath.pathContext, false, true);
                            });
                            MakerJs.path.moveRelative(fixedPath, offset);
                            //TODO use only chainToSVGPathData instead of circle, so that we can use fill
                            doc.circle(fixedPath.origin[0], fixedPath.origin[1], walkedPath.pathContext.radius).stroke(opts.stroke);
                        }
                        else {
                            single(walkedPath);
                        }
                    }
                });
                loose.map(single);
            }, { byLayers: false });
        }
        exporter.toPDF = toPDF;
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var exporter;
    (function (exporter) {
        /**
         * @private
         */
        var chainLinkToPathDataMap = {};
        chainLinkToPathDataMap[MakerJs.pathType.Arc] = function (arc, endPoint, reversed, d) {
            d.push('A');
            svgArcData(d, arc.radius, endPoint, MakerJs.angle.ofArcSpan(arc) > 180, reversed ? (arc.startAngle > arc.endAngle) : (arc.startAngle < arc.endAngle));
        };
        chainLinkToPathDataMap[MakerJs.pathType.Line] = function (line, endPoint, reversed, d) {
            d.push('L', MakerJs.round(endPoint[0]), MakerJs.round(endPoint[1]));
        };
        chainLinkToPathDataMap[MakerJs.pathType.BezierSeed] = function (seed, endPoint, reversed, d) {
            svgBezierData(d, seed, reversed);
        };
        /**
         * @private
         */
        function svgCoords(p) {
            return MakerJs.point.mirror(p, false, true);
        }
        /**
         * Convert a chain to SVG path data.
         */
        function chainToSVGPathData(chain, offset) {
            function offsetPoint(p) {
                return MakerJs.point.add(p, offset);
            }
            var first = chain.links[0];
            var firstPoint = offsetPoint(svgCoords(first.endPoints[first.reversed ? 1 : 0]));
            var d = ['M', MakerJs.round(firstPoint[0]), MakerJs.round(firstPoint[1])];
            for (var i = 0; i < chain.links.length; i++) {
                var link = chain.links[i];
                var pathContext = link.walkedPath.pathContext;
                var fn = chainLinkToPathDataMap[pathContext.type];
                if (fn) {
                    var fixedPath;
                    MakerJs.path.moveTemporary([pathContext], [link.walkedPath.offset], function () {
                        fixedPath = MakerJs.path.mirror(pathContext, false, true);
                    });
                    MakerJs.path.moveRelative(fixedPath, offset);
                    fn(fixedPath, offsetPoint(svgCoords(link.endPoints[link.reversed ? 0 : 1])), link.reversed, d);
                }
            }
            if (chain.endless) {
                d.push('Z');
            }
            return d.join(' ');
        }
        exporter.chainToSVGPathData = chainToSVGPathData;
        /**
         * @private
         */
        function startSvgPathData(start, d) {
            return ["M", MakerJs.round(start[0]), MakerJs.round(start[1])].concat(d);
        }
        /**
         * @private
         */
        var svgPathDataMap = {};
        svgPathDataMap[MakerJs.pathType.Line] = function (line) {
            return startSvgPathData(line.origin, MakerJs.point.rounded(line.end));
        };
        svgPathDataMap[MakerJs.pathType.Circle] = function (circle) {
            return startSvgPathData(circle.origin, svgCircleData(circle.radius));
        };
        svgPathDataMap[MakerJs.pathType.Arc] = function (arc) {
            var arcPoints = MakerJs.point.fromArc(arc);
            if (MakerJs.measure.isPointEqual(arcPoints[0], arcPoints[1])) {
                return svgPathDataMap[MakerJs.pathType.Circle](arc);
            }
            else {
                var r = MakerJs.round(arc.radius);
                var d = ['A'];
                svgArcData(d, r, arcPoints[1], MakerJs.angle.ofArcSpan(arc) > 180, arc.startAngle > arc.endAngle);
                return startSvgPathData(arcPoints[0], d);
            }
        };
        svgPathDataMap[MakerJs.pathType.BezierSeed] = function (seed) {
            var d = [];
            svgBezierData(d, seed);
            return startSvgPathData(seed.origin, d);
        };
        /**
         * Convert a path to SVG path data.
         */
        function pathToSVGPathData(pathToExport, offset, offset2) {
            var fn = svgPathDataMap[pathToExport.type];
            if (fn) {
                var fixedPath;
                MakerJs.path.moveTemporary([pathToExport], [offset], function () {
                    fixedPath = MakerJs.path.mirror(pathToExport, false, true);
                });
                MakerJs.path.moveRelative(fixedPath, offset2);
                var d = fn(fixedPath);
                return d.join(' ');
            }
            return '';
        }
        exporter.pathToSVGPathData = pathToSVGPathData;
        /**
         * @private
         */
        function getBezierModelsWithPaths(modelToExport) {
            var beziers = [];
            function checkIsBezierWithPaths(walkedModel) {
                var b = walkedModel.childModel;
                if (b.type && b.type === MakerJs.models.BezierCurve.typeName && b.paths) {
                    beziers.push(walkedModel);
                }
            }
            var options = {
                beforeChildWalk: function (walkedModel) {
                    checkIsBezierWithPaths(walkedModel);
                    return true;
                }
            };
            var rootModel = {
                childId: '',
                childModel: modelToExport,
                layer: '',
                offset: modelToExport.origin,
                parentModel: null,
                route: [],
                routeKey: ''
            };
            checkIsBezierWithPaths(rootModel);
            MakerJs.model.walk(modelToExport, options);
            return beziers;
        }
        /**
         * @private
         */
        function getPathDataByLayer(modelToExport, offset, options) {
            var pathDataByLayer = {};
            var beziers = getBezierModelsWithPaths(modelToExport);
            var tempKey = 'tempPaths';
            beziers.forEach(function (walkedModel) {
                var b = walkedModel.childModel;
                //use seeds as path, hide the arc paths from findChains()
                var bezierSeeds = MakerJs.models.BezierCurve.getBezierSeeds(b);
                if (bezierSeeds.length > 0) {
                    b[tempKey] = b.paths;
                    var newPaths = {};
                    bezierSeeds.forEach(function (seed, i) {
                        newPaths['seed_' + i] = seed;
                    });
                    b.paths = newPaths;
                }
            });
            MakerJs.model.findChains(modelToExport, function (chains, loose, layer) {
                function single(walkedPath) {
                    var pathData = pathToSVGPathData(walkedPath.pathContext, walkedPath.offset, offset);
                    pathDataByLayer[layer].push(pathData);
                }
                pathDataByLayer[layer] = [];
                chains.map(function (chain) {
                    if (chain.links.length > 1) {
                        var pathData = chainToSVGPathData(chain, offset);
                        pathDataByLayer[layer].push(pathData);
                    }
                    else {
                        single(chain.links[0].walkedPath);
                    }
                });
                loose.map(single);
            }, options);
            //revert
            beziers.forEach(function (walkedModel) {
                var b = walkedModel.childModel;
                if (tempKey in b) {
                    b.paths = b[tempKey];
                    delete b[tempKey];
                }
            });
            return pathDataByLayer;
        }
        /**
         * Convert a model to SVG path data.
         *
         * @param modelToExport Model to export.
         * @param byLayers Boolean flag (default true) to return a map of path data by layer.
         * @param origin Optional reference origin.
         * @returns String of SVG path data (if byLayers is false) or an object map of path data by layer .
         */
        function toSVGPathData(modelToExport, byLayers, origin) {
            if (byLayers === void 0) { byLayers = true; }
            var size = MakerJs.measure.modelExtents(modelToExport);
            if (!origin) {
                origin = [-size.low[0], size.high[1]];
            }
            var pathDataArrayByLayer = getPathDataByLayer(modelToExport, origin, { byLayers: byLayers });
            var pathDataStringByLayer = {};
            for (var layer in pathDataArrayByLayer) {
                pathDataStringByLayer[layer] = pathDataArrayByLayer[layer].join(' ');
            }
            return byLayers ? pathDataStringByLayer : pathDataStringByLayer[''];
        }
        exporter.toSVGPathData = toSVGPathData;
        /**
         * Renders an item in SVG markup.
         *
         * @param itemToExport Item to render: may be a path, an array of paths, or a model object.
         * @param options Rendering options object.
         * @param options.annotate Boolean to indicate that the id's of paths should be rendered as SVG text elements.
         * @param options.origin point object for the rendered reference origin.
         * @param options.scale Number to scale the SVG rendering.
         * @param options.stroke String color of the rendered paths.
         * @param options.strokeWidth String numeric width and optional units of the rendered paths.
         * @param options.units String of the unit system. May be omitted. See makerjs.unitType for possible values.
         * @param options.useSvgPathOnly Boolean to use SVG path elements instead of line, circle etc.
         * @returns String of XML / SVG content.
         */
        function toSVG(itemToExport, options) {
            function append(value, layer, forcePush) {
                if (forcePush === void 0) { forcePush = false; }
                if (!forcePush && typeof layer == "string" && layer.length > 0) {
                    if (!(layer in layers)) {
                        layers[layer] = [];
                    }
                    layers[layer].push(value);
                }
                else {
                    elements.push(value);
                }
            }
            function createElement(tagname, attrs, layer, innerText, forcePush) {
                if (innerText === void 0) { innerText = null; }
                if (forcePush === void 0) { forcePush = false; }
                attrs['vector-effect'] = 'non-scaling-stroke';
                var tag = new exporter.XmlTag(tagname, attrs);
                if (innerText) {
                    tag.innerText = innerText;
                }
                append(tag.toString(), layer, forcePush);
            }
            function fixPoint(pointToFix) {
                //in DXF Y increases upward. in SVG, Y increases downward
                var pointMirroredY = svgCoords(pointToFix);
                return MakerJs.point.scale(pointMirroredY, opts.scale);
            }
            function fixPath(pathToFix, origin) {
                //mirror creates a copy, so we don't modify the original
                var mirrorY = MakerJs.path.mirror(pathToFix, false, true);
                return MakerJs.path.moveRelative(MakerJs.path.scale(mirrorY, opts.scale), origin);
            }
            //fixup options
            var opts = {
                annotate: false,
                origin: null,
                scale: 1,
                stroke: "#000",
                strokeWidth: '0.25mm',
                fill: "none",
                fontSize: '9pt',
                useSvgPathOnly: true,
                viewBox: true
            };
            MakerJs.extendObject(opts, options);
            var modelToExport;
            var itemToExportIsModel = MakerJs.isModel(itemToExport);
            if (itemToExportIsModel) {
                modelToExport = itemToExport;
                if (modelToExport.exporterOptions) {
                    MakerJs.extendObject(opts, modelToExport.exporterOptions['toSVG']);
                }
            }
            var elements = [];
            var layers = {};
            //measure the item to move it into svg area
            if (itemToExportIsModel) {
                modelToExport = itemToExport;
            }
            else if (Array.isArray(itemToExport)) {
                //issue: this won't handle an array of models
                var paths = {};
                itemToExport.forEach(function (p, i) { paths[i] = p; });
                modelToExport = { paths: paths };
            }
            else if (MakerJs.isPath(itemToExport)) {
                modelToExport = { paths: { modelToMeasure: itemToExport } };
            }
            var size = MakerJs.measure.modelExtents(modelToExport);
            //try to get the unit system from the itemToExport
            if (!opts.units) {
                var unitSystem = exporter.tryGetModelUnits(itemToExport);
                if (unitSystem) {
                    opts.units = unitSystem;
                }
            }
            //convert unit system (if it exists) into SVG's units. scale if necessary.
            var useSvgUnit = exporter.svgUnit[opts.units];
            if (useSvgUnit && opts.viewBox) {
                opts.scale *= useSvgUnit.scaleConversion;
            }
            if (size && !opts.origin) {
                var left = -size.low[0] * opts.scale;
                opts.origin = [left, size.high[1] * opts.scale];
            }
            //also pass back to options parameter
            MakerJs.extendObject(options, opts);
            //begin svg output
            var svgAttrs;
            if (size && opts.viewBox) {
                var width = MakerJs.round(size.high[0] - size.low[0]) * opts.scale;
                var height = MakerJs.round(size.high[1] - size.low[1]) * opts.scale;
                var viewBox = [0, 0, width, height];
                var unit = useSvgUnit ? useSvgUnit.svgUnitType : '';
                svgAttrs = {
                    width: width + unit,
                    height: height + unit,
                    viewBox: viewBox.join(' ')
                };
            }
            var svgTag = new exporter.XmlTag('svg', MakerJs.extendObject(svgAttrs || {}, opts.svgAttrs));
            append(svgTag.getOpeningTag(false));
            var svgGroup = new exporter.XmlTag('g', {
                id: 'svgGroup',
                stroke: opts.stroke,
                "stroke-width": opts.strokeWidth,
                "stroke-linecap": "round",
                "fill": opts.fill,
                "fill-rule": "evenodd",
                "font-size": opts.fontSize
            });
            append(svgGroup.getOpeningTag(false));
            if (opts.useSvgPathOnly) {
                var pathDataByLayer = getPathDataByLayer(modelToExport, opts.origin, { byLayers: true });
                for (var layer in pathDataByLayer) {
                    var pathData = pathDataByLayer[layer].join(' ');
                    createElement("path", { "d": pathData }, layer, null, true);
                }
            }
            else {
                function drawText(id, textPoint) {
                    createElement("text", {
                        "id": id + "_text",
                        "x": textPoint[0],
                        "y": textPoint[1]
                    }, null, id);
                }
                function drawPath(id, x, y, d, layer, textPoint) {
                    createElement("path", {
                        "id": id,
                        "d": ["M", MakerJs.round(x), MakerJs.round(y)].concat(d).join(" ")
                    }, layer);
                    if (opts.annotate) {
                        drawText(id, textPoint);
                    }
                }
                function circleInPaths(id, center, radius, layer) {
                    var d = svgCircleData(radius);
                    drawPath(id, center[0], center[1], d, layer, center);
                }
                var map = {};
                map[MakerJs.pathType.Line] = function (id, line, origin, layer) {
                    var start = line.origin;
                    var end = line.end;
                    createElement("line", {
                        "id": id,
                        "x1": MakerJs.round(start[0]),
                        "y1": MakerJs.round(start[1]),
                        "x2": MakerJs.round(end[0]),
                        "y2": MakerJs.round(end[1])
                    }, layer);
                    if (opts.annotate) {
                        drawText(id, MakerJs.point.middle(line));
                    }
                };
                map[MakerJs.pathType.Circle] = function (id, circle, origin, layer) {
                    var center = circle.origin;
                    createElement("circle", {
                        "id": id,
                        "r": circle.radius,
                        "cx": MakerJs.round(center[0]),
                        "cy": MakerJs.round(center[1])
                    }, layer);
                    if (opts.annotate) {
                        drawText(id, center);
                    }
                };
                map[MakerJs.pathType.Arc] = function (id, arc, origin, layer) {
                    var arcPoints = MakerJs.point.fromArc(arc);
                    if (MakerJs.measure.isPointEqual(arcPoints[0], arcPoints[1])) {
                        circleInPaths(id, arc.origin, arc.radius, layer);
                    }
                    else {
                        var d = ['A'];
                        svgArcData(d, arc.radius, arcPoints[1], MakerJs.angle.ofArcSpan(arc) > 180, arc.startAngle > arc.endAngle);
                        drawPath(id, arcPoints[0][0], arcPoints[0][1], d, layer, MakerJs.point.middle(arc));
                    }
                };
                map[MakerJs.pathType.BezierSeed] = function (id, seed, origin, layer) {
                    var d = [];
                    svgBezierData(d, seed);
                    drawPath(id, seed.origin[0], seed.origin[1], d, layer, MakerJs.point.middle(seed));
                };
                function beginModel(id, modelContext) {
                    modelGroup.attrs = { id: id };
                    append(modelGroup.getOpeningTag(false), modelContext.layer);
                }
                function endModel(modelContext) {
                    append(modelGroup.getClosingTag(), modelContext.layer);
                }
                var modelGroup = new exporter.XmlTag('g');
                var exp = new exporter.Exporter(map, fixPoint, fixPath, beginModel, endModel);
                exp.exportItem('0', itemToExport, opts.origin);
                //export layers as groups
                for (var layer in layers) {
                    var layerGroup = new exporter.XmlTag('g', { id: layer });
                    for (var i = 0; i < layers[layer].length; i++) {
                        layerGroup.innerText += layers[layer][i];
                    }
                    layerGroup.innerTextEscaped = true;
                    append(layerGroup.toString());
                }
            }
            append(svgGroup.getClosingTag());
            append(svgTag.getClosingTag());
            return elements.join('');
        }
        exporter.toSVG = toSVG;
        /**
         * @private
         */
        function svgCircleData(radius) {
            var r = MakerJs.round(radius);
            var d = ['m', -r, 0];
            function halfCircle(sign) {
                d.push('a');
                svgArcData(d, r, [2 * r * sign, 0]);
            }
            halfCircle(1);
            halfCircle(-1);
            d.push('z');
            return d;
        }
        /**
         * @private
         */
        function svgBezierData(d, seed, reversed) {
            if (seed.controls.length === 1) {
                d.push('Q', MakerJs.round(seed.controls[0][0]), MakerJs.round(seed.controls[0][1]));
            }
            else {
                var controls = reversed ? [seed.controls[1], seed.controls[0]] : seed.controls;
                d.push('C', MakerJs.round(controls[0][0]), MakerJs.round(controls[0][1]), MakerJs.round(controls[1][0]), MakerJs.round(controls[1][1]));
            }
            var final = reversed ? seed.origin : seed.end;
            d.push(MakerJs.round(final[0]), MakerJs.round(final[1]));
        }
        /**
         * @private
         */
        function svgArcData(d, radius, endPoint, largeArc, decreasing) {
            var r = MakerJs.round(radius);
            var end = endPoint;
            d.push(r, r);
            d.push(0); //0 = x-axis rotation
            d.push(largeArc ? 1 : 0); //large arc=1, small arc=0
            d.push(decreasing ? 0 : 1); //sweep-flag 0=decreasing, 1=increasing 
            d.push(MakerJs.round(end[0]), MakerJs.round(end[1]));
        }
        /**
         * Map of MakerJs unit system to SVG unit system
         */
        exporter.svgUnit = {};
        //SVG Coordinate Systems, Transformations and Units documentation:
        //http://www.w3.org/TR/SVG/coords.html
        //The supported length unit identifiers are: em, ex, px, pt, pc, cm, mm, in, and percentages.
        exporter.svgUnit[MakerJs.unitType.Inch] = { svgUnitType: "in", scaleConversion: 1 };
        exporter.svgUnit[MakerJs.unitType.Millimeter] = { svgUnitType: "mm", scaleConversion: 1 };
        exporter.svgUnit[MakerJs.unitType.Centimeter] = { svgUnitType: "cm", scaleConversion: 1 };
        //Add conversions for all unitTypes
        exporter.svgUnit[MakerJs.unitType.Foot] = { svgUnitType: "in", scaleConversion: 12 };
        exporter.svgUnit[MakerJs.unitType.Meter] = { svgUnitType: "cm", scaleConversion: 100 };
    })(exporter = MakerJs.exporter || (MakerJs.exporter = {}));
})(MakerJs || (MakerJs = {}));
(function (MakerJs) {
    var importer;
    (function (importer) {
        function fromSVGPathData(pathData, options) {
            if (options === void 0) { options = {}; }
            var result = {};
            function addPath(p) {
                if (!result.paths) {
                    result.paths = {};
                }
                result.paths['p_' + ++pathCount] = p;
            }
            function addModel(m) {
                if (!result.models) {
                    result.models = {};
                }
                result.models['p_' + ++pathCount] = m;
            }
            function getPoint(cmd, offset) {
                if (offset === void 0) { offset = 0; }
                var p = MakerJs.point.mirror([cmd.data[0 + offset], cmd.data[1 + offset]], false, true);
                if (cmd.absolute) {
                    return p;
                }
                else {
                    return MakerJs.point.add(p, cmd.from);
                }
            }
            function lineTo(cmd, end) {
                if (!MakerJs.measure.isPointEqual(cmd.from, end)) {
                    addPath(new MakerJs.paths.Line(cmd.from, end));
                }
                return end;
            }
            var map = {};
            map['M'] = function (cmd) {
                firstPoint = getPoint(cmd);
                return firstPoint;
            };
            map['Z'] = function (cmd) {
                return lineTo(cmd, firstPoint);
            };
            map['H'] = function (cmd) {
                var end = MakerJs.point.clone(cmd.from);
                if (cmd.absolute) {
                    end[0] = cmd.data[0];
                }
                else {
                    end[0] += cmd.data[0];
                }
                return lineTo(cmd, end);
            };
            map['V'] = function (cmd) {
                var end = MakerJs.point.clone(cmd.from);
                //subtract to mirror on y axis: SVG coords
                if (cmd.absolute) {
                    end[1] = -cmd.data[0];
                }
                else {
                    end[1] -= cmd.data[0];
                }
                return lineTo(cmd, end);
            };
            map['L'] = function (cmd) {
                var end = getPoint(cmd);
                return lineTo(cmd, end);
            };
            map['A'] = function (cmd) {
                var rx = cmd.data[0];
                var ry = cmd.data[1];
                var rotation = cmd.data[2];
                var large = cmd.data[3] === 1;
                var decreasing = cmd.data[4] === 1;
                var end = getPoint(cmd, 5);
                var elliptic = rx !== ry;
                //first, rotate so we are dealing with a zero angle x-axis
                var xAxis = new MakerJs.paths.Line(cmd.from, MakerJs.point.rotate(end, rotation, cmd.from));
                //next, un-distort any ellipse back into a circle in terms of x axis
                if (elliptic) {
                    xAxis = MakerJs.path.distort(xAxis, 1, rx / ry);
                }
                //now create an arc, making sure we use the large and decreasing flags
                var arc = new MakerJs.paths.Arc(xAxis.origin, xAxis.end, rx, large, decreasing);
                if (elliptic) {
                    //scale up if radius was insufficient.
                    if (rx < arc.radius) {
                        var scaleUp = arc.radius / rx;
                        rx *= scaleUp;
                        ry *= scaleUp;
                    }
                    //create an elliptical arc, this will re-distort
                    var e = new MakerJs.models.EllipticArc(arc, 1, ry / rx, options.bezierAccuracy);
                    //un-rotate back to where it should be.
                    MakerJs.model.rotate(e, -rotation, cmd.from);
                    addModel(e);
                }
                else {
                    //just use the arc
                    //un-rotate back to where it should be.
                    MakerJs.path.rotate(arc, -rotation, cmd.from);
                    addPath(arc);
                }
                return end;
            };
            map['C'] = function (cmd) {
                var control1 = getPoint(cmd, 0);
                var control2 = getPoint(cmd, 2);
                var end = getPoint(cmd, 4);
                addModel(new MakerJs.models.BezierCurve(cmd.from, control1, control2, end, options.bezierAccuracy));
                return end;
            };
            map['S'] = function (cmd) {
                var control1;
                var prevControl2;
                if (cmd.prev.command === 'C') {
                    prevControl2 = getPoint(cmd.prev, 2);
                    control1 = MakerJs.point.rotate(prevControl2, 180, cmd.from);
                }
                else if (cmd.prev.command === 'S') {
                    prevControl2 = getPoint(cmd.prev, 0);
                    control1 = MakerJs.point.rotate(prevControl2, 180, cmd.from);
                }
                else {
                    control1 = cmd.from;
                }
                var control2 = getPoint(cmd, 0);
                var end = getPoint(cmd, 2);
                addModel(new MakerJs.models.BezierCurve(cmd.from, control1, control2, end, options.bezierAccuracy));
                return end;
            };
            map['Q'] = function (cmd) {
                var control = getPoint(cmd, 0);
                var end = getPoint(cmd, 2);
                addModel(new MakerJs.models.BezierCurve(cmd.from, control, end, options.bezierAccuracy));
                return end;
            };
            map['T'] = function (cmd) {
                var control;
                var prevControl;
                if (cmd.prev.command === 'Q') {
                    prevControl = getPoint(cmd.prev, 0);
                    control = MakerJs.point.rotate(prevControl, 180, cmd.from);
                }
                else if (cmd.prev.command === 'T') {
                    prevControl = getPoint(cmd.prev, 2); //see below *
                    control = MakerJs.point.rotate(prevControl, 180, cmd.from);
                }
                else {
                    control = cmd.from;
                }
                //* save the control point in the data list, will be accessible from index 2
                var p = MakerJs.point.mirror(control, false, true);
                cmd.data.push.apply(cmd.data, p);
                var end = getPoint(cmd, 0);
                addModel(new MakerJs.models.BezierCurve(cmd.from, control, end, options.bezierAccuracy));
                return end;
            };
            var firstPoint = [0, 0];
            var currPoint = [0, 0];
            var pathCount = 0;
            var prevCommand;
            var regexpCommands = /([achlmqstvz])([0-9e\.\+-\s]*)/ig;
            var commandMatches;
            while ((commandMatches = regexpCommands.exec(pathData)) !== null) {
                if (commandMatches.index === regexpCommands.lastIndex) {
                    regexpCommands.lastIndex++;
                }
                var command = commandMatches[1]; //0 = command and data, 1 = command, 2 = data
                var dataString = commandMatches[2];
                var currCmd = {
                    command: command.toUpperCase(),
                    data: [],
                    from: currPoint,
                    prev: prevCommand
                };
                if (command === currCmd.command) {
                    currCmd.absolute = true;
                }
                currCmd.data = importer.parseNumericList(dataString);
                var fn = map[currCmd.command];
                if (fn) {
                    currPoint = fn(currCmd);
                }
                prevCommand = currCmd;
            }
            return result;
        }
        importer.fromSVGPathData = fromSVGPathData;
    })(importer = MakerJs.importer || (MakerJs.importer = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var hasLib = false;
        function ensureBezierLib() {
            if (hasLib)
                return;
            try {
                var lib = Bezier.prototype;
                hasLib = true;
            }
            catch (e) {
                throw "Bezier library not found. If you are using Node, try running 'npm install' or if you are in the browser, download http://pomax.github.io/bezierjs/bezier.js to your website and add a script tag.";
            }
        }
        /**
         * @private
         */
        var scratch;
        /**
         * @private
         */
        function getScratch(seed) {
            var points = [seed.origin];
            points.push.apply(points, seed.controls);
            points.push(seed.end);
            var bezierJsPoints = points.map(function (p) {
                var bp = {
                    x: p[0], y: p[1]
                };
                return bp;
            });
            if (!scratch) {
                ensureBezierLib();
                scratch = new Bezier(bezierJsPoints);
            }
            else {
                scratch.points = bezierJsPoints;
                scratch.update();
            }
            return scratch;
        }
        /**
         * @private
         */
        function BezierToSeed(b, range) {
            var points = b.points.map(function (p) { return [p.x, p.y]; });
            var seed = new BezierSeed(points);
            if (range) {
                seed.parentRange = range;
            }
            return seed;
        }
        /**
         * @private
         */
        function seedToBezier(seed) {
            var coords = [];
            coords.push.apply(coords, seed.origin);
            coords.push.apply(coords, seed.controls[0]);
            if (seed.controls.length > 1) {
                coords.push.apply(coords, seed.controls[1]);
            }
            coords.push.apply(coords, seed.end);
            ensureBezierLib();
            return new Bezier(coords);
        }
        /**
         * @private
         */
        function getArcs(b, accuracy) {
            var arcs = b.arcs(accuracy);
            return arcs.map(function (a) {
                var arc = new MakerJs.paths.Arc([a.x, a.y], a.r, MakerJs.angle.toDegrees(a.s), MakerJs.angle.toDegrees(a.e));
                arc.bezierData = { startT: a.interval.start, endT: a.interval.end };
                return arc;
            });
        }
        /**
         * @private
         * Class for bezier seed.
         */
        var BezierSeed = (function () {
            function BezierSeed() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.type = MakerJs.pathType.BezierSeed;
                switch (args.length) {
                    case 1:
                        var points = args[0];
                        this.origin = points[0];
                        if (points.length === 3) {
                            this.controls = [points[1]];
                            this.end = points[2];
                        }
                        else if (points.length === 4) {
                            this.controls = [points[1], points[2]];
                            this.end = points[3];
                        }
                        else {
                            this.end = points[1];
                        }
                        break;
                    case 3:
                        if (Array.isArray(args[1])) {
                            this.controls = args[1];
                        }
                        else {
                            this.controls = [args[1]];
                        }
                        this.end = args[2];
                        break;
                    case 4:
                        this.controls = [args[1], args[2]];
                        this.end = args[3];
                        break;
                }
            }
            return BezierSeed;
        }());
        var BezierCurve = (function () {
            function BezierCurve() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = this;
                this.type = BezierCurve.typeName;
                var isLeaf = false;
                var isArrayArg0 = Array.isArray(args[0]);
                switch (args.length) {
                    case 2:
                        if (isArrayArg0) {
                            this.accuracy = args[1];
                        }
                        else {
                            //seed
                            this.seed = args[0];
                            if (typeof args[1] === "boolean") {
                                isLeaf = args[1];
                            }
                            else {
                                this.accuracy = args[1];
                            }
                            break;
                        }
                    //fall through to point array
                    case 1:
                        if (isArrayArg0) {
                            var points = args[0];
                            this.seed = new BezierSeed(points);
                        }
                        else {
                            this.seed = args[0];
                        }
                        break;
                    default:
                        switch (args.length) {
                            case 4:
                                if (MakerJs.isPoint(args[3])) {
                                    this.seed = new BezierSeed(args);
                                    break;
                                }
                                else {
                                    this.accuracy = args[3];
                                    //fall through
                                }
                            case 3:
                                if (isArrayArg0) {
                                    this.seed = new BezierSeed(args.slice(0, 3));
                                }
                                else {
                                    this.seed = args[0];
                                    isLeaf = args[1];
                                    this.accuracy = args[2];
                                }
                                break;
                            case 5:
                                this.accuracy = args[4];
                                this.seed = new BezierSeed(args.slice(0, 4));
                                break;
                        }
                        break;
                }
                this.paths = {};
                if (MakerJs.measure.isBezierSeedLinear(this.seed)) {
                    //use a line and exit
                    this.paths = {
                        'Line': new MakerJs.paths.Line(MakerJs.point.clone(this.seed.origin), MakerJs.point.clone(this.seed.end))
                    };
                    return;
                }
                var b = seedToBezier(this.seed);
                if (!isLeaf) {
                    //breaking the bezier into its extrema will make the models better correspond to rectangular measurements.
                    //however, the potential drawback is that these broken curves will not get reconciled to this overall curve.
                    var extrema = b.extrema().values;
                    //remove leading zero
                    if (extrema.length > 0 && extrema[0] === 0) {
                        extrema.shift();
                    }
                    //remove ending 1
                    if (extrema.length > 0 && extrema[extrema.length - 1] === 1) {
                        extrema.pop();
                    }
                    if (extrema.length === 0) {
                        isLeaf = true;
                    }
                    else {
                        //need to create children
                        //this will not contain paths, but will contain other curves
                        this.models = {};
                        var childSeeds = [];
                        if (extrema.length === 1) {
                            var split = b.split(extrema[0]);
                            childSeeds.push(BezierToSeed(split.left, { startT: 0, endT: extrema[0] }), BezierToSeed(split.right, { startT: extrema[0], endT: 1 }));
                        }
                        else {
                            //add 0 and 1 endings
                            extrema.unshift(0);
                            extrema.push(1);
                            for (var i = 1; i < extrema.length; i++) {
                                //get the bezier between 
                                childSeeds.push(BezierToSeed(b.split(extrema[i - 1], extrema[i]), { startT: extrema[i - 1], endT: extrema[i] }));
                            }
                        }
                        childSeeds.forEach(function (seed, i) {
                            _this.models['Curve_' + (1 + i)] = new BezierCurve(seed, true, _this.accuracy);
                        });
                    }
                }
                if (isLeaf) {
                    this.paths = {};
                    //use arcs
                    if (!this.accuracy) {
                        //get a default accuracy relative to the size of the bezier
                        var len = b.length();
                        //set the default to be a combination of fast rendering and good smoothing.
                        this.accuracy = len / 1000;
                    }
                    var arcs = getArcs(b, this.accuracy);
                    var i = 0;
                    arcs.forEach(function (arc) {
                        var span = MakerJs.angle.ofArcSpan(arc);
                        if (span === 0 || span === 360)
                            return;
                        _this.paths['Arc_' + (1 + i)] = arc;
                        i++;
                    });
                }
            }
            BezierCurve.getBezierSeeds = function (curve, options) {
                if (options === void 0) { options = {}; }
                options.shallow = true;
                var b = seedToBezier(curve.seed);
                var seeds = [];
                MakerJs.model.findChains(curve, function (chains, loose, layer) {
                    if (chains.length === 0) {
                        //if this is a linear curve then look if line ends are the same as bezier ends.
                        if (loose.length === 1 && loose[0].pathContext.type === MakerJs.pathType.Line) {
                            var line = loose[0].pathContext;
                            if (MakerJs.measure.isPointEqual(line.origin, curve.seed.origin) && MakerJs.measure.isPointEqual(line.end, curve.seed.end)) {
                                seeds.push(curve.seed);
                            }
                        }
                    }
                    else if (chains.length === 1) {
                        //check if endpoints are 0 and 1
                        var chain = chains[0];
                        var chainEnds = [chain.links[0], chain.links[chain.links.length - 1]];
                        var chainReversed = false;
                        //put them in bezier t order
                        if (chainEnds[0].walkedPath.pathContext.bezierData.startT > chainEnds[1].walkedPath.pathContext.bezierData.startT) {
                            chainEnds.reverse();
                            chainReversed = true;
                        }
                        var intact = true;
                        for (var i = 2; i--;) {
                            var chainEnd = chainEnds[i];
                            var arc = chainEnd.walkedPath.pathContext;
                            var reversed = (chainReversed !== chainEnd.reversed);
                            var chainEndPoint = chainEnd.endPoints[reversed ? 1 - i : i];
                            var trueEndpoint = b.compute(i === 0 ? arc.bezierData.startT : arc.bezierData.endT);
                            if (!MakerJs.measure.isPointEqual(chainEndPoint, [trueEndpoint.x, trueEndpoint.y], .00001)) {
                                intact = false;
                                break;
                            }
                        }
                        if (intact) {
                            seeds.push(curve.seed);
                        }
                    }
                    else {
                        //TODO: find bezier seeds from a split chain
                    }
                }, options);
                return seeds;
            };
            BezierCurve.computeLength = function (seed) {
                var b = seedToBezier(seed);
                return b.length();
            };
            BezierCurve.computePoint = function (seed, t) {
                var s = getScratch(seed);
                var computedPoint = s.compute(t);
                return [computedPoint.x, computedPoint.y];
            };
            return BezierCurve;
        }());
        BezierCurve.typeName = 'BezierCurve';
        models.BezierCurve = BezierCurve;
        BezierCurve.metaParameters = [
            {
                title: "points", type: "select", value: [
                    [[100, 0], [-80, -60], [100, 220], [100, 60]],
                    [[0, 0], [100, 0], [100, 100]],
                    [[0, 0], [20, 0], [80, 100], [100, 100]]
                ]
            }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        /**
         * @private
         * Our maximum circular arc span for accurate representation by a cubic curve.
         */
        var maxBezierArcspan = 45;
        /**
         * @private
         */
        function controlYForCircularCubic(arcSpanInRadians) {
            //from http://pomax.github.io/bezierinfo/#circles_cubic
            return 4 * (Math.tan(arcSpanInRadians / 4) / 3);
        }
        /**
         * @private
         */
        function controlPointsForCircularCubic(arc) {
            var arcSpan = MakerJs.angle.ofArcSpan(arc);
            //compute y for radius of 1
            var y = controlYForCircularCubic(MakerJs.angle.toRadians(arcSpan));
            //multiply by radius
            var c1 = [arc.radius, arc.radius * y];
            //get second control point by mirroring, then rotating
            var c2 = MakerJs.point.rotate(MakerJs.point.mirror(c1, false, true), arcSpan, [0, 0]);
            //rotate again to start angle, then offset by arc's origin
            return [c1, c2].map(function (p) { return MakerJs.point.add(arc.origin, MakerJs.point.rotate(p, arc.startAngle, [0, 0])); });
        }
        /**
         * @private
         */
        function bezierSeedFromArc(arc) {
            var span = MakerJs.angle.ofArcSpan(arc);
            if (span <= 90) {
                var endPoints = MakerJs.point.fromPathEnds(arc);
                var controls = controlPointsForCircularCubic(arc);
                return {
                    type: MakerJs.pathType.BezierSeed,
                    origin: endPoints[0],
                    controls: controls,
                    end: endPoints[1]
                };
            }
            return null;
        }
        var Ellipse = (function () {
            function Ellipse() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = this;
                this.models = {};
                var n = 360 / maxBezierArcspan;
                var accuracy;
                var isPointArgs0 = MakerJs.isPoint(args[0]);
                var realArgs = function (numArgs) {
                    switch (numArgs) {
                        case 2:
                            if (isPointArgs0) {
                                //origin, radius
                                _this.origin = args[0];
                            }
                            break;
                        case 3:
                            //origin, rx, ry
                            _this.origin = args[0];
                            break;
                        case 4:
                            //cx, cy, rx, ry
                            _this.origin = [args[0], args[1]];
                            break;
                    }
                    //construct a bezier approximation for an arc with radius of 1.
                    var a = 360 / n;
                    var arc = new MakerJs.paths.Arc([0, 0], 1, 0, a);
                    //clone and rotate to complete a circle
                    for (var i = 0; i < n; i++) {
                        var seed = bezierSeedFromArc(arc);
                        switch (numArgs) {
                            case 1:
                                //radius
                                seed = MakerJs.path.scale(seed, args[0]);
                                break;
                            case 2:
                                if (isPointArgs0) {
                                    //origin, radius
                                    seed = MakerJs.path.scale(seed, args[1]);
                                }
                                else {
                                    //rx, ry
                                    seed = MakerJs.path.distort(seed, args[0], args[1]);
                                }
                                break;
                            case 3:
                                //origin, rx, ry
                                seed = MakerJs.path.distort(seed, args[1], args[2]);
                                break;
                            case 4:
                                //cx, cy, rx, ry
                                seed = MakerJs.path.distort(seed, args[2], args[3]);
                                break;
                        }
                        _this.models['Curve_' + (1 + i)] = new models.BezierCurve(seed, accuracy);
                        arc.startAngle += a;
                        arc.endAngle += a;
                    }
                };
                switch (args.length) {
                    case 2:
                        realArgs(2);
                        break;
                    case 3:
                        if (isPointArgs0) {
                            realArgs(3);
                        }
                        else {
                            accuracy = args[2];
                            realArgs(2);
                        }
                        break;
                    case 4:
                        if (isPointArgs0) {
                            accuracy = args[3];
                            realArgs(3);
                        }
                        else {
                            realArgs(4);
                        }
                        break;
                    case 5:
                        accuracy = args[4];
                        realArgs(4);
                        break;
                }
            }
            return Ellipse;
        }());
        models.Ellipse = Ellipse;
        Ellipse.metaParameters = [
            { title: "radiusX", type: "range", min: 1, max: 50, value: 50 },
            { title: "radiusY", type: "range", min: 1, max: 50, value: 25 }
        ];
        var EllipticArc = (function () {
            function EllipticArc() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.models = {};
                var arc;
                var accuracy;
                var distortX;
                var distortY;
                if (MakerJs.isPathArc(args[0])) {
                    arc = args[0];
                    distortX = args[1];
                    distortY = args[2];
                    accuracy = args[3];
                }
                else {
                    arc = new MakerJs.paths.Arc([0, 0], 1, args[0], args[1]);
                    distortX = args[2];
                    distortY = args[3];
                    accuracy = args[4];
                }
                var span = MakerJs.angle.ofArcSpan(arc);
                //split into equal chunks, no larger than max chunk size
                var count = Math.ceil(span / maxBezierArcspan);
                var subSpan = span / count;
                var subArc = MakerJs.path.clone(arc);
                for (var i = 0; i < count; i++) {
                    subArc.startAngle = arc.startAngle + (i * subSpan);
                    subArc.endAngle = subArc.startAngle + subSpan;
                    var seed = bezierSeedFromArc(subArc);
                    seed = MakerJs.path.distort(seed, distortX, distortY);
                    this.models['Curve_' + (1 + i)] = new models.BezierCurve(seed, accuracy);
                }
            }
            return EllipticArc;
        }());
        models.EllipticArc = EllipticArc;
        EllipticArc.metaParameters = [
            { title: "startAngle", type: "range", min: 0, max: 90, value: 0 },
            { title: "endAngle", type: "range", min: 90, max: 360, value: 180 },
            { title: "radiusX", type: "range", min: 1, max: 50, value: 50 },
            { title: "radiusY", type: "range", min: 1, max: 50, value: 25 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        /**
         * @private
         */
        function getPoints(arg) {
            var coords;
            if (Array.isArray(arg)) {
                if (MakerJs.isPoint(arg[0])) {
                    return arg;
                }
                coords = arg;
            }
            else {
                coords = MakerJs.importer.parseNumericList(arg);
            }
            var points = [];
            for (var i = 0; i < coords.length; i += 2) {
                points.push([coords[i], coords[i + 1]]);
            }
            return points;
        }
        var ConnectTheDots = (function () {
            function ConnectTheDots() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var _this = this;
                this.paths = {};
                var isClosed;
                var points;
                switch (args.length) {
                    case 1:
                        isClosed = true;
                        points = getPoints(args[0]);
                        break;
                    case 2:
                        isClosed = args[0];
                        points = getPoints(args[1]);
                        break;
                }
                var connect = function (a, b, skipZeroDistance) {
                    if (skipZeroDistance === void 0) { skipZeroDistance = false; }
                    if (skipZeroDistance && MakerJs.measure.pointDistance(points[a], points[b]) == 0)
                        return;
                    _this.paths["ShapeLine" + i] = new MakerJs.paths.Line(points[a], points[b]);
                };
                for (var i = 1; i < points.length; i++) {
                    connect(i - 1, i);
                }
                if (isClosed && points.length > 2) {
                    connect(points.length - 1, 0, true);
                }
            }
            return ConnectTheDots;
        }());
        models.ConnectTheDots = ConnectTheDots;
        ConnectTheDots.metaParameters = [
            { title: "closed", type: "bool", value: true },
            {
                title: "points", type: "select", value: [
                    [[0, 0], [40, 40], [60, 20], [100, 100], [60, 60], [40, 80]],
                    [[0, 0], [100, 0], [50, 87]],
                    [-10, 0, 10, 0, 0, 20],
                    '-10 0 10 0 0 20',
                ]
            }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Polygon = (function () {
            function Polygon(numberOfSides, radius, firstCornerAngleInDegrees, circumscribed) {
                this.paths = {};
                this.paths = new models.ConnectTheDots(true, Polygon.getPoints(numberOfSides, radius, firstCornerAngleInDegrees, circumscribed)).paths;
            }
            Polygon.circumscribedRadius = function (radius, angleInRadians) {
                return radius / Math.cos(angleInRadians / 2);
            };
            Polygon.getPoints = function (numberOfSides, radius, firstCornerAngleInDegrees, circumscribed) {
                if (firstCornerAngleInDegrees === void 0) { firstCornerAngleInDegrees = 0; }
                if (circumscribed === void 0) { circumscribed = false; }
                var points = [];
                var a1 = MakerJs.angle.toRadians(firstCornerAngleInDegrees);
                var a = 2 * Math.PI / numberOfSides;
                if (circumscribed) {
                    radius = Polygon.circumscribedRadius(radius, a);
                }
                for (var i = 0; i < numberOfSides; i++) {
                    points.push(MakerJs.point.fromPolar(a * i + a1, radius));
                }
                return points;
            };
            return Polygon;
        }());
        models.Polygon = Polygon;
        Polygon.metaParameters = [
            { title: "number of sides", type: "range", min: 3, max: 24, value: 6 },
            { title: "radius", type: "range", min: 1, max: 100, value: 50 },
            { title: "offset angle", type: "range", min: 0, max: 180, value: 0 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Holes = (function () {
            /**
             * Create an array of circles of the same radius from an array of center points.
             *
             * Example:
             * ```
             * //Create some holes from an array of points
             * var makerjs = require('makerjs');
             * var model = new makerjs.models.Holes(10, [[0, 0],[50, 0],[25, 40]]);
             * var svg = makerjs.exporter.toSVG(model);
             * document.write(svg);
             * ```
             *
             * @param holeRadius Hole radius.
             * @param points Array of points for origin of each hole.
             * @param ids Optional array of corresponding path ids for the holes.
             */
            function Holes(holeRadius, points, ids) {
                this.paths = {};
                for (var i = 0; i < points.length; i++) {
                    var id = ids ? ids[i] : i.toString();
                    this.paths[id] = new MakerJs.paths.Circle(points[i], holeRadius);
                }
            }
            return Holes;
        }());
        models.Holes = Holes;
        Holes.metaParameters = [
            { title: "holeRadius", type: "range", min: .1, max: 10, step: .1, value: 1 },
            {
                title: "points", type: "select", value: [
                    [[0, 0], [10, 10], [20, 20], [30, 30], [40, 40], [50, 50], [60, 60], [70, 70], [80, 80]],
                    [[0, 0], [0, 25], [0, 50], [0, 75], [0, 100], [25, 50], [50, 50], [75, 50], [100, 100], [100, 75], [100, 50], [100, 25], [100, 0]]
                ]
            }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var BoltCircle = (function () {
            function BoltCircle(boltRadius, holeRadius, boltCount, firstBoltAngleInDegrees) {
                if (firstBoltAngleInDegrees === void 0) { firstBoltAngleInDegrees = 0; }
                this.paths = {};
                var points = models.Polygon.getPoints(boltCount, boltRadius, firstBoltAngleInDegrees);
                var ids = points.map(function (p, i) { return "bolt " + i; });
                this.paths = new models.Holes(holeRadius, points, ids).paths;
            }
            return BoltCircle;
        }());
        models.BoltCircle = BoltCircle;
        BoltCircle.metaParameters = [
            { title: "bolt circle radius", type: "range", min: 1, max: 100, value: 50 },
            { title: "hole radius", type: "range", min: 1, max: 50, value: 5 },
            { title: "bolt count", type: "range", min: 3, max: 24, value: 12 },
            { title: "offset angle", type: "range", min: 0, max: 180, value: 0 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var BoltRectangle = (function () {
            function BoltRectangle(width, height, holeRadius) {
                this.paths = {};
                var points = [[0, 0], [width, 0], [width, height], [0, height]];
                var ids = ["BottomLeft_bolt", "BottomRight_bolt", "TopRight_bolt", "TopLeft_bolt"];
                this.paths = new models.Holes(holeRadius, points, ids).paths;
            }
            return BoltRectangle;
        }());
        models.BoltRectangle = BoltRectangle;
        BoltRectangle.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 100 },
            { title: "height", type: "range", min: 1, max: 100, value: 50 },
            { title: "hole radius", type: "range", min: 1, max: 50, value: 5 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Dogbone = (function () {
            /**
             * Create a dogbone from width, height, corner radius, style, and bottomless flag.
             *
             * Example:
             * ```
             * var d = new makerjs.models.Dogbone(50, 100, 5);
             * ```
             *
             * @param width Width of the rectangle.
             * @param height Height of the rectangle.
             * @param radius Corner radius.
             * @param style Optional corner style: 0 (default) for dogbone, 1 for vertical, -1 for horizontal.
             * @param bottomless Optional flag to omit the bottom line and bottom corners (default false).
             */
            function Dogbone(width, height, radius, style, bottomless) {
                if (style === void 0) { style = 0; }
                if (bottomless === void 0) { bottomless = false; }
                this.paths = {};
                var maxSide = Math.min(height, width) / 2;
                var maxRadius;
                switch (style) {
                    case -1: //horizontal
                    case 1:
                        maxRadius = maxSide / 2;
                        break;
                    case 0: //equal
                    default:
                        maxRadius = maxSide * Math.SQRT2 / 2;
                        break;
                }
                radius = Math.min(radius, maxRadius);
                var ax;
                var ay;
                var lx;
                var ly;
                var apexes;
                switch (style) {
                    case -1:
                        ax = 0;
                        ay = radius;
                        lx = 0;
                        ly = radius * 2;
                        apexes = [180, 0, 0, 180];
                        break;
                    case 1:
                        ax = radius;
                        ay = 0;
                        lx = radius * 2;
                        ly = 0;
                        apexes = [270, 270, 90, 90];
                        break;
                    case 0:
                    default:
                        ax = ay = radius / Math.SQRT2;
                        lx = ly = ax * 2;
                        apexes = [225, 315, 45, 135];
                        break;
                }
                if (bottomless) {
                    this.paths['Left'] = new MakerJs.paths.Line([0, 0], [0, height - ly]);
                    this.paths['Right'] = new MakerJs.paths.Line([width, 0], [width, height - ly]);
                }
                else {
                    this.paths['Left'] = new MakerJs.paths.Line([0, ly], [0, height - ly]);
                    this.paths['Right'] = new MakerJs.paths.Line([width, ly], [width, height - ly]);
                    this.paths['Bottom'] = new MakerJs.paths.Line([lx, 0], [width - lx, 0]);
                    this.paths["BottomLeft"] = new MakerJs.paths.Arc([ax, ay], radius, apexes[0] - 90, apexes[0] + 90);
                    this.paths["BottomRight"] = new MakerJs.paths.Arc([width - ax, ay], radius, apexes[1] - 90, apexes[1] + 90);
                }
                this.paths["TopRight"] = new MakerJs.paths.Arc([width - ax, height - ay], radius, apexes[2] - 90, apexes[2] + 90);
                this.paths["TopLeft"] = new MakerJs.paths.Arc([ax, height - ay], radius, apexes[3] - 90, apexes[3] + 90);
                this.paths['Top'] = new MakerJs.paths.Line([lx, height], [width - lx, height]);
            }
            return Dogbone;
        }());
        models.Dogbone = Dogbone;
        Dogbone.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 },
            { title: "radius", type: "range", min: 0, max: 50, value: 5 },
            { title: "style", type: "select", value: [0, 1, -1] },
            { title: "bottomless", type: "bool", value: false }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Dome = (function () {
            function Dome(width, height, radius) {
                this.paths = {};
                var w2 = width / 2;
                if (radius < 0)
                    radius = 0;
                if (radius === void 0)
                    radius = w2;
                radius = Math.min(radius, w2);
                radius = Math.min(radius, height);
                var wt = Math.max(w2 - radius, 0);
                var hr = Math.max(height - radius, 0);
                this.paths["Bottom"] = new MakerJs.paths.Line([-w2, 0], [w2, 0]);
                if (hr) {
                    this.paths["Left"] = new MakerJs.paths.Line([-w2, 0], [-w2, hr]);
                    this.paths["Right"] = new MakerJs.paths.Line([w2, 0], [w2, hr]);
                }
                if (radius > 0) {
                    this.paths["TopLeft"] = new MakerJs.paths.Arc([-wt, hr], radius, 90, 180);
                    this.paths["TopRight"] = new MakerJs.paths.Arc([wt, hr], radius, 0, 90);
                }
                if (wt) {
                    this.paths["Top"] = new MakerJs.paths.Line([-wt, height], [wt, height]);
                }
            }
            return Dome;
        }());
        models.Dome = Dome;
        Dome.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 },
            { title: "radius", type: "range", min: 0, max: 50, value: 25 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var RoundRectangle = (function () {
            function RoundRectangle() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.paths = {};
                var width;
                var height;
                var radius = 0;
                switch (args.length) {
                    case 3:
                        width = args[0];
                        height = args[1];
                        radius = args[2];
                        break;
                    case 2:
                        radius = args[1];
                    //fall through to 1
                    case 1:
                        var m = MakerJs.measure.modelExtents(args[0]);
                        this.origin = MakerJs.point.subtract(m.low, [radius, radius]);
                        width = m.high[0] - m.low[0] + 2 * radius;
                        height = m.high[1] - m.low[1] + 2 * radius;
                        break;
                }
                var maxRadius = Math.min(height, width) / 2;
                radius = Math.min(radius, maxRadius);
                var wr = width - radius;
                var hr = height - radius;
                if (radius > 0) {
                    this.paths["BottomLeft"] = new MakerJs.paths.Arc([radius, radius], radius, 180, 270);
                    this.paths["BottomRight"] = new MakerJs.paths.Arc([wr, radius], radius, 270, 0);
                    this.paths["TopRight"] = new MakerJs.paths.Arc([wr, hr], radius, 0, 90);
                    this.paths["TopLeft"] = new MakerJs.paths.Arc([radius, hr], radius, 90, 180);
                }
                if (wr - radius > 0) {
                    this.paths["Bottom"] = new MakerJs.paths.Line([radius, 0], [wr, 0]);
                    this.paths["Top"] = new MakerJs.paths.Line([wr, height], [radius, height]);
                }
                if (hr - radius > 0) {
                    this.paths["Right"] = new MakerJs.paths.Line([width, radius], [width, hr]);
                    this.paths["Left"] = new MakerJs.paths.Line([0, hr], [0, radius]);
                }
            }
            return RoundRectangle;
        }());
        models.RoundRectangle = RoundRectangle;
        RoundRectangle.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 },
            { title: "radius", type: "range", min: 0, max: 50, value: 11 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Oval = (function () {
            function Oval(width, height) {
                this.paths = {};
                this.paths = new models.RoundRectangle(width, height, Math.min(height / 2, width / 2)).paths;
            }
            return Oval;
        }());
        models.Oval = Oval;
        Oval.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var OvalArc = (function () {
            function OvalArc(startAngle, endAngle, sweepRadius, slotRadius, selfIntersect, isolateCaps) {
                if (selfIntersect === void 0) { selfIntersect = false; }
                if (isolateCaps === void 0) { isolateCaps = false; }
                var _this = this;
                this.paths = {};
                var capRoot;
                if (isolateCaps) {
                    capRoot = { models: {} };
                    this.models = { 'Caps': capRoot };
                }
                if (slotRadius <= 0 || sweepRadius <= 0)
                    return;
                startAngle = MakerJs.angle.noRevolutions(startAngle);
                endAngle = MakerJs.angle.noRevolutions(endAngle);
                if (MakerJs.round(startAngle - endAngle) == 0)
                    return;
                if (endAngle < startAngle)
                    endAngle += 360;
                var addCap = function (id, tiltAngle, offsetStartAngle, offsetEndAngle) {
                    var capModel;
                    if (isolateCaps) {
                        capModel = { paths: {} };
                        capRoot.models[id] = capModel;
                    }
                    else {
                        capModel = _this;
                    }
                    return capModel.paths[id] = new MakerJs.paths.Arc(MakerJs.point.fromPolar(MakerJs.angle.toRadians(tiltAngle), sweepRadius), slotRadius, tiltAngle + offsetStartAngle, tiltAngle + offsetEndAngle);
                };
                var addSweep = function (id, offsetRadius) {
                    return _this.paths[id] = new MakerJs.paths.Arc([0, 0], sweepRadius + offsetRadius, startAngle, endAngle);
                };
                addSweep("Outer", slotRadius);
                var hasInner = (sweepRadius - slotRadius) > 0;
                if (hasInner) {
                    addSweep("Inner", -slotRadius);
                }
                var caps = [];
                caps.push(addCap("StartCap", startAngle, 180, 0));
                caps.push(addCap("EndCap", endAngle, 0, 180));
                //the distance between the cap origins
                var d = MakerJs.measure.pointDistance(caps[0].origin, caps[1].origin);
                if ((d / 2) < slotRadius) {
                    //the caps intersect
                    var int = MakerJs.path.intersection(caps[0], caps[1]);
                    if (int) {
                        if (!hasInner || !selfIntersect) {
                            caps[0].startAngle = int.path1Angles[0];
                            caps[1].endAngle = int.path2Angles[0];
                        }
                        if (!selfIntersect && hasInner && int.intersectionPoints.length == 2) {
                            addCap("StartCap2", startAngle, 180, 0).endAngle = int.path1Angles[1];
                            addCap("EndCap2", endAngle, 0, 180).startAngle = int.path2Angles[1] + 360;
                        }
                    }
                }
            }
            return OvalArc;
        }());
        models.OvalArc = OvalArc;
        OvalArc.metaParameters = [
            { title: "start angle", type: "range", min: -360, max: 360, step: 1, value: 180 },
            { title: "end angle", type: "range", min: -360, max: 360, step: 1, value: 0 },
            { title: "sweep", type: "range", min: 0, max: 100, step: 1, value: 50 },
            { title: "radius", type: "range", min: 0, max: 100, step: 1, value: 15 },
            { title: "self intersect", type: "bool", value: false }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Rectangle = (function () {
            function Rectangle() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                this.paths = {};
                var width;
                var height;
                if (args.length === 2 && !MakerJs.isObject(args[0])) {
                    width = args[0];
                    height = args[1];
                }
                else {
                    var margin = 0;
                    var m;
                    if (MakerJs.isModel(args[0])) {
                        m = MakerJs.measure.modelExtents(args[0]);
                        if (args.length === 2) {
                            margin = args[1];
                        }
                    }
                    else {
                        //use measurement
                        m = args[0];
                    }
                    this.origin = MakerJs.point.subtract(m.low, [margin, margin]);
                    width = m.high[0] - m.low[0] + 2 * margin;
                    height = m.high[1] - m.low[1] + 2 * margin;
                }
                this.paths = new models.ConnectTheDots(true, [[0, 0], [width, 0], [width, height], [0, height]]).paths;
            }
            return Rectangle;
        }());
        models.Rectangle = Rectangle;
        Rectangle.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Ring = (function () {
            function Ring(outerRadius, innerRadius) {
                this.paths = {};
                var radii = {
                    "Ring_outer": outerRadius,
                    "Ring_inner": innerRadius
                };
                for (var id in radii) {
                    this.paths[id] = new MakerJs.paths.Circle(MakerJs.point.zero(), radii[id]);
                }
            }
            return Ring;
        }());
        models.Ring = Ring;
        Ring.metaParameters = [
            { title: "outer radius", type: "range", min: 0, max: 100, step: 1, value: 50 },
            { title: "inner radius", type: "range", min: 0, max: 100, step: 1, value: 20 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var SCurve = (function () {
            function SCurve(width, height) {
                this.paths = {};
                function findRadius(x, y) {
                    return x + (y * y - x * x) / (2 * x);
                }
                var h2 = height / 2;
                var w2 = width / 2;
                var radius;
                var startAngle;
                var endAngle;
                var arcOrigin;
                if (width > height) {
                    radius = findRadius(h2, w2);
                    startAngle = 270;
                    endAngle = 360 - MakerJs.angle.toDegrees(Math.acos(w2 / radius));
                    arcOrigin = [0, radius];
                }
                else {
                    radius = findRadius(w2, h2);
                    startAngle = 180 - MakerJs.angle.toDegrees(Math.asin(h2 / radius));
                    endAngle = 180;
                    arcOrigin = [radius, 0];
                }
                var curve = new MakerJs.paths.Arc(arcOrigin, radius, startAngle, endAngle);
                this.paths['curve_start'] = curve;
                this.paths['curve_end'] = MakerJs.path.moveRelative(MakerJs.path.mirror(curve, true, true), [width, height]);
            }
            return SCurve;
        }());
        models.SCurve = SCurve;
        SCurve.metaParameters = [
            { title: "width", type: "range", min: 1, max: 100, value: 50 },
            { title: "height", type: "range", min: 1, max: 100, value: 100 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Slot = (function () {
            function Slot(origin, endPoint, radius, isolateCaps) {
                if (isolateCaps === void 0) { isolateCaps = false; }
                var _this = this;
                this.paths = {};
                var capRoot;
                if (isolateCaps) {
                    capRoot = { models: {} };
                    this.models = { 'Caps': capRoot };
                }
                var addCap = function (id, capPath) {
                    var capModel;
                    if (isolateCaps) {
                        capModel = { paths: {} };
                        capRoot.models[id] = capModel;
                    }
                    else {
                        capModel = _this;
                    }
                    capModel.paths[id] = capPath;
                };
                var a = MakerJs.angle.ofPointInDegrees(origin, endPoint);
                var len = MakerJs.measure.pointDistance(origin, endPoint);
                this.paths['Top'] = new MakerJs.paths.Line([0, radius], [len, radius]);
                this.paths['Bottom'] = new MakerJs.paths.Line([0, -radius], [len, -radius]);
                addCap('StartCap', new MakerJs.paths.Arc([0, 0], radius, 90, 270));
                addCap('EndCap', new MakerJs.paths.Arc([len, 0], radius, 270, 90));
                MakerJs.model.rotate(this, a, [0, 0]);
                this.origin = origin;
            }
            return Slot;
        }());
        models.Slot = Slot;
        Slot.metaParameters = [
            {
                title: "origin", type: "select", value: [
                    [0, 0],
                    [10, 0],
                    [10, 10]
                ]
            },
            {
                title: "end", type: "select", value: [
                    [80, 0],
                    [0, 30],
                    [10, 30]
                ]
            },
            { title: "radius", type: "range", min: 1, max: 50, value: 10 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Square = (function () {
            function Square(side) {
                this.paths = {};
                this.paths = new models.Rectangle(side, side).paths;
            }
            return Square;
        }());
        models.Square = Square;
        Square.metaParameters = [
            { title: "side", type: "range", min: 1, max: 100, value: 100 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Star = (function () {
            function Star(numberOfPoints, outerRadius, innerRadius, skipPoints) {
                if (skipPoints === void 0) { skipPoints = 2; }
                this.paths = {};
                if (!innerRadius) {
                    innerRadius = outerRadius * Star.InnerRadiusRatio(numberOfPoints, skipPoints);
                }
                var outerPoints = models.Polygon.getPoints(numberOfPoints, outerRadius);
                var innerPoints = models.Polygon.getPoints(numberOfPoints, innerRadius, 180 / numberOfPoints);
                var allPoints = [];
                for (var i = 0; i < numberOfPoints; i++) {
                    allPoints.push(outerPoints[i]);
                    allPoints.push(innerPoints[i]);
                }
                var model = new models.ConnectTheDots(true, allPoints);
                this.paths = model.paths;
                delete model.paths;
            }
            Star.InnerRadiusRatio = function (numberOfPoints, skipPoints) {
                //formula from http://www.jdawiseman.com/papers/easymath/surds_star_inner_radius.html
                //Cos(Pi()*m/n) / Cos(Pi()*(m-1)/n)
                if (numberOfPoints > 0 && skipPoints > 1 && skipPoints < numberOfPoints / 2) {
                    return Math.cos(Math.PI * skipPoints / numberOfPoints) / Math.cos(Math.PI * (skipPoints - 1) / numberOfPoints);
                }
                return 0;
            };
            return Star;
        }());
        models.Star = Star;
        Star.metaParameters = [
            { title: "number of sides", type: "range", min: 3, max: 24, value: 8 },
            { title: "outer radius", type: "range", min: 1, max: 100, value: 50 },
            { title: "inner radius", type: "range", min: 0, max: 100, value: 15 },
            { title: "skip points (when inner radius is zero)", type: "range", min: 0, max: 12, value: 2 }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
var MakerJs;
(function (MakerJs) {
    var models;
    (function (models) {
        var Text = (function () {
            function Text(font, text, fontSize, combine, centerCharacterOrigin, bezierAccuracy) {
                if (combine === void 0) { combine = false; }
                if (centerCharacterOrigin === void 0) { centerCharacterOrigin = false; }
                var _this = this;
                this.models = {};
                var charIndex = 0;
                var combineOptions = {};
                var cb = function (glyph, x, y, _fontSize, options) {
                    var charModel = {};
                    var firstPoint;
                    var currPoint;
                    var pathCount = 0;
                    function addPath(p) {
                        if (!charModel.paths) {
                            charModel.paths = {};
                        }
                        charModel.paths['p_' + ++pathCount] = p;
                    }
                    function addModel(m) {
                        if (!charModel.models) {
                            charModel.models = {};
                        }
                        charModel.models['p_' + ++pathCount] = m;
                    }
                    var p = glyph.getPath(0, 0, _fontSize);
                    p.commands.map(function (command, i) {
                        var points = [[command.x, command.y], [command.x1, command.y1], [command.x2, command.y2]].map(function (p) {
                            if (p[0] !== void 0) {
                                return MakerJs.point.mirror(p, false, true);
                            }
                        });
                        switch (command.type) {
                            case 'M':
                                firstPoint = points[0];
                                break;
                            case 'Z':
                                points[0] = firstPoint;
                            //fall through to line
                            case 'L':
                                if (!MakerJs.measure.isPointEqual(currPoint, points[0])) {
                                    addPath(new MakerJs.paths.Line(currPoint, points[0]));
                                }
                                break;
                            case 'C':
                                addModel(new models.BezierCurve(currPoint, points[1], points[2], points[0], bezierAccuracy));
                                break;
                            case 'Q':
                                addModel(new models.BezierCurve(currPoint, points[1], points[0], bezierAccuracy));
                                break;
                        }
                        currPoint = points[0];
                    });
                    charModel.origin = [x, 0];
                    if (centerCharacterOrigin && (charModel.paths || charModel.models)) {
                        var m = MakerJs.measure.modelExtents(charModel);
                        if (m) {
                            var w = m.high[0] - m.low[0];
                            MakerJs.model.originate(charModel, [m.low[0] + w / 2, 0]);
                        }
                    }
                    if (combine && charIndex > 0) {
                        MakerJs.model.combine(_this, charModel, false, true, false, true, combineOptions);
                        delete combineOptions.measureB;
                        //TODO - optimize for left to right 
                        combineOptions.measureA.modelsMeasured = false;
                    }
                    _this.models[charIndex] = charModel;
                    charIndex++;
                };
                font.forEachGlyph(text, 0, 0, fontSize, null, cb);
            }
            return Text;
        }());
        models.Text = Text;
        Text.metaParameters = [
            { title: "font", type: "font", value: '*' },
            { title: "text", type: "text", value: 'Hello' },
            { title: "font size", type: "range", min: 10, max: 200, value: 72 },
            { title: "combine", type: "bool", value: false },
            { title: "center character origin", type: "bool", value: false }
        ];
    })(models = MakerJs.models || (MakerJs.models = {}));
})(MakerJs || (MakerJs = {}));
MakerJs.version = "0.9.39";
﻿var Bezier = __webpack_require__(/*! bezier-js */ "./node_modules/bezier-js/index.js");


/***/ }),

/***/ "./node_modules/mgrs/mgrs.js":
/*!***********************************!*\
  !*** ./node_modules/mgrs/mgrs.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {




/**
 * UTM zones are grouped, and assigned to one of a group of 6
 * sets.
 *
 * {int} @private
 */
var NUM_100K_SETS = 6;

/**
 * The column letters (for easting) of the lower left value, per
 * set.
 *
 * {string} @private
 */
var SET_ORIGIN_COLUMN_LETTERS = 'AJSAJS';

/**
 * The row letters (for northing) of the lower left value, per
 * set.
 *
 * {string} @private
 */
var SET_ORIGIN_ROW_LETTERS = 'AFAFAF';

var A = 65; // A
var I = 73; // I
var O = 79; // O
var V = 86; // V
var Z = 90; // Z

/**
 * Conversion of lat/lon to MGRS.
 *
 * @param {object} ll Object literal with lat and lon properties on a
 *     WGS84 ellipsoid.
 * @param {int} accuracy Accuracy in digits (5 for 1 m, 4 for 10 m, 3 for
 *      100 m, 4 for 1000 m or 5 for 10000 m). Optional, default is 5.
 * @return {string} the MGRS string for the given location and accuracy.
 */
exports.forward = function(ll, accuracy) {
  accuracy = accuracy || 5; // default accuracy 1m
  return encode(LLtoUTM({
    lat: ll[1],
    lon: ll[0]
  }), accuracy);
};

/**
 * Conversion of MGRS to lat/lon.
 *
 * @param {string} mgrs MGRS string.
 * @return {array} An array with left (longitude), bottom (latitude), right
 *     (longitude) and top (latitude) values in WGS84, representing the
 *     bounding box for the provided MGRS reference.
 */
exports.inverse = function(mgrs) {
  var bbox = UTMtoLL(decode(mgrs.toUpperCase()));
  return [bbox.left, bbox.bottom, bbox.right, bbox.top];
};

exports.toPoint = function(mgrsStr) {
  var llbbox = exports.inverse(mgrsStr);
  return [(llbbox[2] + llbbox[0]) / 2, (llbbox[3] + llbbox[1]) / 2];
};
/**
 * Conversion from degrees to radians.
 *
 * @private
 * @param {number} deg the angle in degrees.
 * @return {number} the angle in radians.
 */
function degToRad(deg) {
  return (deg * (Math.PI / 180.0));
}

/**
 * Conversion from radians to degrees.
 *
 * @private
 * @param {number} rad the angle in radians.
 * @return {number} the angle in degrees.
 */
function radToDeg(rad) {
  return (180.0 * (rad / Math.PI));
}

/**
 * Converts a set of Longitude and Latitude co-ordinates to UTM
 * using the WGS84 ellipsoid.
 *
 * @private
 * @param {object} ll Object literal with lat and lon properties
 *     representing the WGS84 coordinate to be converted.
 * @return {object} Object literal containing the UTM value with easting,
 *     northing, zoneNumber and zoneLetter properties, and an optional
 *     accuracy property in digits. Returns null if the conversion failed.
 */
function LLtoUTM(ll) {
  var Lat = ll.lat;
  var Long = ll.lon;
  var a = 6378137.0; //ellip.radius;
  var eccSquared = 0.00669438; //ellip.eccsq;
  var k0 = 0.9996;
  var LongOrigin;
  var eccPrimeSquared;
  var N, T, C, A, M;
  var LatRad = degToRad(Lat);
  var LongRad = degToRad(Long);
  var LongOriginRad;
  var ZoneNumber;
  // (int)
  ZoneNumber = Math.floor((Long + 180) / 6) + 1;

  //Make sure the longitude 180.00 is in Zone 60
  if (Long === 180) {
    ZoneNumber = 60;
  }

  // Special zone for Norway
  if (Lat >= 56.0 && Lat < 64.0 && Long >= 3.0 && Long < 12.0) {
    ZoneNumber = 32;
  }

  // Special zones for Svalbard
  if (Lat >= 72.0 && Lat < 84.0) {
    if (Long >= 0.0 && Long < 9.0) {
      ZoneNumber = 31;
    }
    else if (Long >= 9.0 && Long < 21.0) {
      ZoneNumber = 33;
    }
    else if (Long >= 21.0 && Long < 33.0) {
      ZoneNumber = 35;
    }
    else if (Long >= 33.0 && Long < 42.0) {
      ZoneNumber = 37;
    }
  }

  LongOrigin = (ZoneNumber - 1) * 6 - 180 + 3; //+3 puts origin
  // in middle of
  // zone
  LongOriginRad = degToRad(LongOrigin);

  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  N = a / Math.sqrt(1 - eccSquared * Math.sin(LatRad) * Math.sin(LatRad));
  T = Math.tan(LatRad) * Math.tan(LatRad);
  C = eccPrimeSquared * Math.cos(LatRad) * Math.cos(LatRad);
  A = Math.cos(LatRad) * (LongRad - LongOriginRad);

  M = a * ((1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256) * LatRad - (3 * eccSquared / 8 + 3 * eccSquared * eccSquared / 32 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(2 * LatRad) + (15 * eccSquared * eccSquared / 256 + 45 * eccSquared * eccSquared * eccSquared / 1024) * Math.sin(4 * LatRad) - (35 * eccSquared * eccSquared * eccSquared / 3072) * Math.sin(6 * LatRad));

  var UTMEasting = (k0 * N * (A + (1 - T + C) * A * A * A / 6.0 + (5 - 18 * T + T * T + 72 * C - 58 * eccPrimeSquared) * A * A * A * A * A / 120.0) + 500000.0);

  var UTMNorthing = (k0 * (M + N * Math.tan(LatRad) * (A * A / 2 + (5 - T + 9 * C + 4 * C * C) * A * A * A * A / 24.0 + (61 - 58 * T + T * T + 600 * C - 330 * eccPrimeSquared) * A * A * A * A * A * A / 720.0)));
  if (Lat < 0.0) {
    UTMNorthing += 10000000.0; //10000000 meter offset for
    // southern hemisphere
  }

  return {
    northing: Math.round(UTMNorthing),
    easting: Math.round(UTMEasting),
    zoneNumber: ZoneNumber,
    zoneLetter: getLetterDesignator(Lat)
  };
}

/**
 * Converts UTM coords to lat/long, using the WGS84 ellipsoid. This is a convenience
 * class where the Zone can be specified as a single string eg."60N" which
 * is then broken down into the ZoneNumber and ZoneLetter.
 *
 * @private
 * @param {object} utm An object literal with northing, easting, zoneNumber
 *     and zoneLetter properties. If an optional accuracy property is
 *     provided (in meters), a bounding box will be returned instead of
 *     latitude and longitude.
 * @return {object} An object literal containing either lat and lon values
 *     (if no accuracy was provided), or top, right, bottom and left values
 *     for the bounding box calculated according to the provided accuracy.
 *     Returns null if the conversion failed.
 */
function UTMtoLL(utm) {

  var UTMNorthing = utm.northing;
  var UTMEasting = utm.easting;
  var zoneLetter = utm.zoneLetter;
  var zoneNumber = utm.zoneNumber;
  // check the ZoneNummber is valid
  if (zoneNumber < 0 || zoneNumber > 60) {
    return null;
  }

  var k0 = 0.9996;
  var a = 6378137.0; //ellip.radius;
  var eccSquared = 0.00669438; //ellip.eccsq;
  var eccPrimeSquared;
  var e1 = (1 - Math.sqrt(1 - eccSquared)) / (1 + Math.sqrt(1 - eccSquared));
  var N1, T1, C1, R1, D, M;
  var LongOrigin;
  var mu, phi1Rad;

  // remove 500,000 meter offset for longitude
  var x = UTMEasting - 500000.0;
  var y = UTMNorthing;

  // We must know somehow if we are in the Northern or Southern
  // hemisphere, this is the only time we use the letter So even
  // if the Zone letter isn't exactly correct it should indicate
  // the hemisphere correctly
  if (zoneLetter < 'N') {
    y -= 10000000.0; // remove 10,000,000 meter offset used
    // for southern hemisphere
  }

  // There are 60 zones with zone 1 being at West -180 to -174
  LongOrigin = (zoneNumber - 1) * 6 - 180 + 3; // +3 puts origin
  // in middle of
  // zone

  eccPrimeSquared = (eccSquared) / (1 - eccSquared);

  M = y / k0;
  mu = M / (a * (1 - eccSquared / 4 - 3 * eccSquared * eccSquared / 64 - 5 * eccSquared * eccSquared * eccSquared / 256));

  phi1Rad = mu + (3 * e1 / 2 - 27 * e1 * e1 * e1 / 32) * Math.sin(2 * mu) + (21 * e1 * e1 / 16 - 55 * e1 * e1 * e1 * e1 / 32) * Math.sin(4 * mu) + (151 * e1 * e1 * e1 / 96) * Math.sin(6 * mu);
  // double phi1 = ProjMath.radToDeg(phi1Rad);

  N1 = a / Math.sqrt(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad));
  T1 = Math.tan(phi1Rad) * Math.tan(phi1Rad);
  C1 = eccPrimeSquared * Math.cos(phi1Rad) * Math.cos(phi1Rad);
  R1 = a * (1 - eccSquared) / Math.pow(1 - eccSquared * Math.sin(phi1Rad) * Math.sin(phi1Rad), 1.5);
  D = x / (N1 * k0);

  var lat = phi1Rad - (N1 * Math.tan(phi1Rad) / R1) * (D * D / 2 - (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * eccPrimeSquared) * D * D * D * D / 24 + (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * eccPrimeSquared - 3 * C1 * C1) * D * D * D * D * D * D / 720);
  lat = radToDeg(lat);

  var lon = (D - (1 + 2 * T1 + C1) * D * D * D / 6 + (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * eccPrimeSquared + 24 * T1 * T1) * D * D * D * D * D / 120) / Math.cos(phi1Rad);
  lon = LongOrigin + radToDeg(lon);

  var result;
  if (utm.accuracy) {
    var topRight = UTMtoLL({
      northing: utm.northing + utm.accuracy,
      easting: utm.easting + utm.accuracy,
      zoneLetter: utm.zoneLetter,
      zoneNumber: utm.zoneNumber
    });
    result = {
      top: topRight.lat,
      right: topRight.lon,
      bottom: lat,
      left: lon
    };
  }
  else {
    result = {
      lat: lat,
      lon: lon
    };
  }
  return result;
}

/**
 * Calculates the MGRS letter designator for the given latitude.
 *
 * @private
 * @param {number} lat The latitude in WGS84 to get the letter designator
 *     for.
 * @return {char} The letter designator.
 */
function getLetterDesignator(lat) {
  //This is here as an error flag to show that the Latitude is
  //outside MGRS limits
  var LetterDesignator = 'Z';

  if ((84 >= lat) && (lat >= 72)) {
    LetterDesignator = 'X';
  }
  else if ((72 > lat) && (lat >= 64)) {
    LetterDesignator = 'W';
  }
  else if ((64 > lat) && (lat >= 56)) {
    LetterDesignator = 'V';
  }
  else if ((56 > lat) && (lat >= 48)) {
    LetterDesignator = 'U';
  }
  else if ((48 > lat) && (lat >= 40)) {
    LetterDesignator = 'T';
  }
  else if ((40 > lat) && (lat >= 32)) {
    LetterDesignator = 'S';
  }
  else if ((32 > lat) && (lat >= 24)) {
    LetterDesignator = 'R';
  }
  else if ((24 > lat) && (lat >= 16)) {
    LetterDesignator = 'Q';
  }
  else if ((16 > lat) && (lat >= 8)) {
    LetterDesignator = 'P';
  }
  else if ((8 > lat) && (lat >= 0)) {
    LetterDesignator = 'N';
  }
  else if ((0 > lat) && (lat >= -8)) {
    LetterDesignator = 'M';
  }
  else if ((-8 > lat) && (lat >= -16)) {
    LetterDesignator = 'L';
  }
  else if ((-16 > lat) && (lat >= -24)) {
    LetterDesignator = 'K';
  }
  else if ((-24 > lat) && (lat >= -32)) {
    LetterDesignator = 'J';
  }
  else if ((-32 > lat) && (lat >= -40)) {
    LetterDesignator = 'H';
  }
  else if ((-40 > lat) && (lat >= -48)) {
    LetterDesignator = 'G';
  }
  else if ((-48 > lat) && (lat >= -56)) {
    LetterDesignator = 'F';
  }
  else if ((-56 > lat) && (lat >= -64)) {
    LetterDesignator = 'E';
  }
  else if ((-64 > lat) && (lat >= -72)) {
    LetterDesignator = 'D';
  }
  else if ((-72 > lat) && (lat >= -80)) {
    LetterDesignator = 'C';
  }
  return LetterDesignator;
}

/**
 * Encodes a UTM location as MGRS string.
 *
 * @private
 * @param {object} utm An object literal with easting, northing,
 *     zoneLetter, zoneNumber
 * @param {number} accuracy Accuracy in digits (1-5).
 * @return {string} MGRS string for the given UTM location.
 */
function encode(utm, accuracy) {
  var seasting = "" + utm.easting,
    snorthing = "" + utm.northing;

  return utm.zoneNumber + utm.zoneLetter + get100kID(utm.easting, utm.northing, utm.zoneNumber) + seasting.substr(seasting.length - 5, accuracy) + snorthing.substr(snorthing.length - 5, accuracy);
}

/**
 * Get the two letter 100k designator for a given UTM easting,
 * northing and zone number value.
 *
 * @private
 * @param {number} easting
 * @param {number} northing
 * @param {number} zoneNumber
 * @return the two letter 100k designator for the given UTM location.
 */
function get100kID(easting, northing, zoneNumber) {
  var setParm = get100kSetForZone(zoneNumber);
  var setColumn = Math.floor(easting / 100000);
  var setRow = Math.floor(northing / 100000) % 20;
  return getLetter100kID(setColumn, setRow, setParm);
}

/**
 * Given a UTM zone number, figure out the MGRS 100K set it is in.
 *
 * @private
 * @param {number} i An UTM zone number.
 * @return {number} the 100k set the UTM zone is in.
 */
function get100kSetForZone(i) {
  var setParm = i % NUM_100K_SETS;
  if (setParm === 0) {
    setParm = NUM_100K_SETS;
  }

  return setParm;
}

/**
 * Get the two-letter MGRS 100k designator given information
 * translated from the UTM northing, easting and zone number.
 *
 * @private
 * @param {number} column the column index as it relates to the MGRS
 *        100k set spreadsheet, created from the UTM easting.
 *        Values are 1-8.
 * @param {number} row the row index as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM northing value. Values
 *        are from 0-19.
 * @param {number} parm the set block, as it relates to the MGRS 100k set
 *        spreadsheet, created from the UTM zone. Values are from
 *        1-60.
 * @return two letter MGRS 100k code.
 */
function getLetter100kID(column, row, parm) {
  // colOrigin and rowOrigin are the letters at the origin of the set
  var index = parm - 1;
  var colOrigin = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(index);
  var rowOrigin = SET_ORIGIN_ROW_LETTERS.charCodeAt(index);

  // colInt and rowInt are the letters to build to return
  var colInt = colOrigin + column - 1;
  var rowInt = rowOrigin + row;
  var rollover = false;

  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
    rollover = true;
  }

  if (colInt === I || (colOrigin < I && colInt > I) || ((colInt > I || colOrigin < I) && rollover)) {
    colInt++;
  }

  if (colInt === O || (colOrigin < O && colInt > O) || ((colInt > O || colOrigin < O) && rollover)) {
    colInt++;

    if (colInt === I) {
      colInt++;
    }
  }

  if (colInt > Z) {
    colInt = colInt - Z + A - 1;
  }

  if (rowInt > V) {
    rowInt = rowInt - V + A - 1;
    rollover = true;
  }
  else {
    rollover = false;
  }

  if (((rowInt === I) || ((rowOrigin < I) && (rowInt > I))) || (((rowInt > I) || (rowOrigin < I)) && rollover)) {
    rowInt++;
  }

  if (((rowInt === O) || ((rowOrigin < O) && (rowInt > O))) || (((rowInt > O) || (rowOrigin < O)) && rollover)) {
    rowInt++;

    if (rowInt === I) {
      rowInt++;
    }
  }

  if (rowInt > V) {
    rowInt = rowInt - V + A - 1;
  }

  var twoLetter = String.fromCharCode(colInt) + String.fromCharCode(rowInt);
  return twoLetter;
}

/**
 * Decode the UTM parameters from a MGRS string.
 *
 * @private
 * @param {string} mgrsString an UPPERCASE coordinate string is expected.
 * @return {object} An object literal with easting, northing, zoneLetter,
 *     zoneNumber and accuracy (in meters) properties.
 */
function decode(mgrsString) {

  if (mgrsString && mgrsString.length === 0) {
    throw ("MGRSPoint coverting from nothing");
  }

  var length = mgrsString.length;

  var hunK = null;
  var sb = "";
  var testChar;
  var i = 0;

  // get Zone number
  while (!(/[A-Z]/).test(testChar = mgrsString.charAt(i))) {
    if (i >= 2) {
      throw ("MGRSPoint bad conversion from: " + mgrsString);
    }
    sb += testChar;
    i++;
  }

  var zoneNumber = parseInt(sb, 10);

  if (i === 0 || i + 3 > length) {
    // A good MGRS string has to be 4-5 digits long,
    // ##AAA/#AAA at least.
    throw ("MGRSPoint bad conversion from: " + mgrsString);
  }

  var zoneLetter = mgrsString.charAt(i++);

  // Should we check the zone letter here? Why not.
  if (zoneLetter <= 'A' || zoneLetter === 'B' || zoneLetter === 'Y' || zoneLetter >= 'Z' || zoneLetter === 'I' || zoneLetter === 'O') {
    throw ("MGRSPoint zone letter " + zoneLetter + " not handled: " + mgrsString);
  }

  hunK = mgrsString.substring(i, i += 2);

  var set = get100kSetForZone(zoneNumber);

  var east100k = getEastingFromChar(hunK.charAt(0), set);
  var north100k = getNorthingFromChar(hunK.charAt(1), set);

  // We have a bug where the northing may be 2000000 too low.
  // How
  // do we know when to roll over?

  while (north100k < getMinNorthing(zoneLetter)) {
    north100k += 2000000;
  }

  // calculate the char index for easting/northing separator
  var remainder = length - i;

  if (remainder % 2 !== 0) {
    throw ("MGRSPoint has to have an even number \nof digits after the zone letter and two 100km letters - front \nhalf for easting meters, second half for \nnorthing meters" + mgrsString);
  }

  var sep = remainder / 2;

  var sepEasting = 0.0;
  var sepNorthing = 0.0;
  var accuracyBonus, sepEastingString, sepNorthingString, easting, northing;
  if (sep > 0) {
    accuracyBonus = 100000.0 / Math.pow(10, sep);
    sepEastingString = mgrsString.substring(i, i + sep);
    sepEasting = parseFloat(sepEastingString) * accuracyBonus;
    sepNorthingString = mgrsString.substring(i + sep);
    sepNorthing = parseFloat(sepNorthingString) * accuracyBonus;
  }

  easting = sepEasting + east100k;
  northing = sepNorthing + north100k;

  return {
    easting: easting,
    northing: northing,
    zoneLetter: zoneLetter,
    zoneNumber: zoneNumber,
    accuracy: accuracyBonus
  };
}

/**
 * Given the first letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the easting value that
 * should be added to the other, secondary easting value.
 *
 * @private
 * @param {char} e The first letter from a two-letter MGRS 100´k zone.
 * @param {number} set The MGRS table set for the zone number.
 * @return {number} The easting value for the given letter and set.
 */
function getEastingFromChar(e, set) {
  // colOrigin is the letter at the origin of the set for the
  // column
  var curCol = SET_ORIGIN_COLUMN_LETTERS.charCodeAt(set - 1);
  var eastingValue = 100000.0;
  var rewindMarker = false;

  while (curCol !== e.charCodeAt(0)) {
    curCol++;
    if (curCol === I) {
      curCol++;
    }
    if (curCol === O) {
      curCol++;
    }
    if (curCol > Z) {
      if (rewindMarker) {
        throw ("Bad character: " + e);
      }
      curCol = A;
      rewindMarker = true;
    }
    eastingValue += 100000.0;
  }

  return eastingValue;
}

/**
 * Given the second letter from a two-letter MGRS 100k zone, and given the
 * MGRS table set for the zone number, figure out the northing value that
 * should be added to the other, secondary northing value. You have to
 * remember that Northings are determined from the equator, and the vertical
 * cycle of letters mean a 2000000 additional northing meters. This happens
 * approx. every 18 degrees of latitude. This method does *NOT* count any
 * additional northings. You have to figure out how many 2000000 meters need
 * to be added for the zone letter of the MGRS coordinate.
 *
 * @private
 * @param {char} n Second letter of the MGRS 100k zone
 * @param {number} set The MGRS table set number, which is dependent on the
 *     UTM zone number.
 * @return {number} The northing value for the given letter and set.
 */
function getNorthingFromChar(n, set) {

  if (n > 'V') {
    throw ("MGRSPoint given invalid Northing " + n);
  }

  // rowOrigin is the letter at the origin of the set for the
  // column
  var curRow = SET_ORIGIN_ROW_LETTERS.charCodeAt(set - 1);
  var northingValue = 0.0;
  var rewindMarker = false;

  while (curRow !== n.charCodeAt(0)) {
    curRow++;
    if (curRow === I) {
      curRow++;
    }
    if (curRow === O) {
      curRow++;
    }
    // fixing a bug making whole application hang in this loop
    // when 'n' is a wrong character
    if (curRow > V) {
      if (rewindMarker) { // making sure that this loop ends
        throw ("Bad character: " + n);
      }
      curRow = A;
      rewindMarker = true;
    }
    northingValue += 100000.0;
  }

  return northingValue;
}

/**
 * The function getMinNorthing returns the minimum northing value of a MGRS
 * zone.
 *
 * Ported from Geotrans' c Lattitude_Band_Value structure table.
 *
 * @private
 * @param {char} zoneLetter The MGRS zone to get the min northing for.
 * @return {number}
 */
function getMinNorthing(zoneLetter) {
  var northing;
  switch (zoneLetter) {
  case 'C':
    northing = 1100000.0;
    break;
  case 'D':
    northing = 2000000.0;
    break;
  case 'E':
    northing = 2800000.0;
    break;
  case 'F':
    northing = 3700000.0;
    break;
  case 'G':
    northing = 4600000.0;
    break;
  case 'H':
    northing = 5500000.0;
    break;
  case 'J':
    northing = 6400000.0;
    break;
  case 'K':
    northing = 7300000.0;
    break;
  case 'L':
    northing = 8200000.0;
    break;
  case 'M':
    northing = 9100000.0;
    break;
  case 'N':
    northing = 0.0;
    break;
  case 'P':
    northing = 800000.0;
    break;
  case 'Q':
    northing = 1700000.0;
    break;
  case 'R':
    northing = 2600000.0;
    break;
  case 'S':
    northing = 3500000.0;
    break;
  case 'T':
    northing = 4400000.0;
    break;
  case 'U':
    northing = 5300000.0;
    break;
  case 'V':
    northing = 6200000.0;
    break;
  case 'W':
    northing = 7000000.0;
    break;
  case 'X':
    northing = 7900000.0;
    break;
  default:
    northing = -1.0;
  }
  if (northing >= 0.0) {
    return northing;
  }
  else {
    throw ("Invalid zone letter: " + zoneLetter);
  }

}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/buffer/index.js":
/*!*********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/buffer/index.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(/*! base64-js */ "./node_modules/base64-js/index.js")
var ieee754 = __webpack_require__(/*! ieee754 */ "./node_modules/ieee754/index.js")
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js")

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/events/events.js":
/*!**********************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/events/events.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/string_decoder/lib/string_decoder.js":
/*!******************************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/string_decoder/lib/string_decoder.js ***!
  \******************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(/*! safe-buffer */ "./node_modules/safe-buffer/index.js").Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/timers-browserify/main.js":
/*!*******************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/timers-browserify/main.js ***!
  \*******************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(/*! setimmediate */ "./node_modules/setimmediate/setImmediate.js");
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/util/support/isBufferBrowser.js":
/*!*************************************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/util/support/isBufferBrowser.js ***!
  \*************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),

/***/ "./node_modules/node-libs-browser/node_modules/util/util.js":
/*!******************************************************************!*\
  !*** ./node_modules/node-libs-browser/node_modules/util/util.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors ||
  function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for (var i = 0; i < keys.length; i++) {
      descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    }
    return descriptors;
  };

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  if (typeof process !== 'undefined' && process.noDeprecation === true) {
    return fn;
  }

  // Allow for deprecating things in the process of starting up.
  if (typeof process === 'undefined') {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(/*! ./support/isBuffer */ "./node_modules/node-libs-browser/node_modules/util/support/isBufferBrowser.js");

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;

exports.promisify = function promisify(original) {
  if (typeof original !== 'function')
    throw new TypeError('The "original" argument must be of type Function');

  if (kCustomPromisifiedSymbol && original[kCustomPromisifiedSymbol]) {
    var fn = original[kCustomPromisifiedSymbol];
    if (typeof fn !== 'function') {
      throw new TypeError('The "util.promisify.custom" argument must be of type Function');
    }
    Object.defineProperty(fn, kCustomPromisifiedSymbol, {
      value: fn, enumerable: false, writable: false, configurable: true
    });
    return fn;
  }

  function fn() {
    var promiseResolve, promiseReject;
    var promise = new Promise(function (resolve, reject) {
      promiseResolve = resolve;
      promiseReject = reject;
    });

    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }
    args.push(function (err, value) {
      if (err) {
        promiseReject(err);
      } else {
        promiseResolve(value);
      }
    });

    try {
      original.apply(this, args);
    } catch (err) {
      promiseReject(err);
    }

    return promise;
  }

  Object.setPrototypeOf(fn, Object.getPrototypeOf(original));

  if (kCustomPromisifiedSymbol) Object.defineProperty(fn, kCustomPromisifiedSymbol, {
    value: fn, enumerable: false, writable: false, configurable: true
  });
  return Object.defineProperties(
    fn,
    getOwnPropertyDescriptors(original)
  );
}

exports.promisify.custom = kCustomPromisifiedSymbol

function callbackifyOnRejected(reason, cb) {
  // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
  // Because `null` is a special error value in callbacks which means "no error
  // occurred", we error-wrap so the callback consumer can distinguish between
  // "the promise rejected with null" or "the promise fulfilled with undefined".
  if (!reason) {
    var newReason = new Error('Promise was rejected with a falsy value');
    newReason.reason = reason;
    reason = newReason;
  }
  return cb(reason);
}

function callbackify(original) {
  if (typeof original !== 'function') {
    throw new TypeError('The "original" argument must be of type Function');
  }

  // We DO NOT return the promise as it gives the user a false sense that
  // the promise is actually somehow related to the callback's execution
  // and that the callback throwing will reject the promise.
  function callbackified() {
    var args = [];
    for (var i = 0; i < arguments.length; i++) {
      args.push(arguments[i]);
    }

    var maybeCb = args.pop();
    if (typeof maybeCb !== 'function') {
      throw new TypeError('The last argument must be of type Function');
    }
    var self = this;
    var cb = function() {
      return maybeCb.apply(self, arguments);
    };
    // In true node style we process the callback on `nextTick` with all the
    // implications (stack, `uncaughtException`, `async_hooks`)
    original.apply(this, args)
      .then(function(ret) { process.nextTick(cb, null, ret) },
            function(rej) { process.nextTick(callbackifyOnRejected, rej, cb) });
  }

  Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
  Object.defineProperties(callbackified,
                          getOwnPropertyDescriptors(original));
  return callbackified;
}
exports.callbackify = callbackify;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/numeric/numeric-1.2.6.js":
/*!***********************************************!*\
  !*** ./node_modules/numeric/numeric-1.2.6.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var numeric = ( false)?(undefined):(exports);
if(typeof global !== "undefined") { global.numeric = numeric; }

numeric.version = "1.2.6";

// 1. Utility functions
numeric.bench = function bench (f,interval) {
    var t1,t2,n,i;
    if(typeof interval === "undefined") { interval = 15; }
    n = 0.5;
    t1 = new Date();
    while(1) {
        n*=2;
        for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
        while(i>0) { f(); i--; }
        t2 = new Date();
        if(t2-t1 > interval) break;
    }
    for(i=n;i>3;i-=4) { f(); f(); f(); f(); }
    while(i>0) { f(); i--; }
    t2 = new Date();
    return 1000*(3*n-1)/(t2-t1);
}

numeric._myIndexOf = (function _myIndexOf(w) {
    var n = this.length,k;
    for(k=0;k<n;++k) if(this[k]===w) return k;
    return -1;
});
numeric.myIndexOf = (Array.prototype.indexOf)?Array.prototype.indexOf:numeric._myIndexOf;

numeric.Function = Function;
numeric.precision = 4;
numeric.largeArray = 50;

numeric.prettyPrint = function prettyPrint(x) {
    function fmtnum(x) {
        if(x === 0) { return '0'; }
        if(isNaN(x)) { return 'NaN'; }
        if(x<0) { return '-'+fmtnum(-x); }
        if(isFinite(x)) {
            var scale = Math.floor(Math.log(x) / Math.log(10));
            var normalized = x / Math.pow(10,scale);
            var basic = normalized.toPrecision(numeric.precision);
            if(parseFloat(basic) === 10) { scale++; normalized = 1; basic = normalized.toPrecision(numeric.precision); }
            return parseFloat(basic).toString()+'e'+scale.toString();
        }
        return 'Infinity';
    }
    var ret = [];
    function foo(x) {
        var k;
        if(typeof x === "undefined") { ret.push(Array(numeric.precision+8).join(' ')); return false; }
        if(typeof x === "string") { ret.push('"'+x+'"'); return false; }
        if(typeof x === "boolean") { ret.push(x.toString()); return false; }
        if(typeof x === "number") {
            var a = fmtnum(x);
            var b = x.toPrecision(numeric.precision);
            var c = parseFloat(x.toString()).toString();
            var d = [a,b,c,parseFloat(b).toString(),parseFloat(c).toString()];
            for(k=1;k<d.length;k++) { if(d[k].length < a.length) a = d[k]; }
            ret.push(Array(numeric.precision+8-a.length).join(' ')+a);
            return false;
        }
        if(x === null) { ret.push("null"); return false; }
        if(typeof x === "function") { 
            ret.push(x.toString());
            var flag = false;
            for(k in x) { if(x.hasOwnProperty(k)) { 
                if(flag) ret.push(',\n');
                else ret.push('\n{');
                flag = true; 
                ret.push(k); 
                ret.push(': \n'); 
                foo(x[k]); 
            } }
            if(flag) ret.push('}\n');
            return true;
        }
        if(x instanceof Array) {
            if(x.length > numeric.largeArray) { ret.push('...Large Array...'); return true; }
            var flag = false;
            ret.push('[');
            for(k=0;k<x.length;k++) { if(k>0) { ret.push(','); if(flag) ret.push('\n '); } flag = foo(x[k]); }
            ret.push(']');
            return true;
        }
        ret.push('{');
        var flag = false;
        for(k in x) { if(x.hasOwnProperty(k)) { if(flag) ret.push(',\n'); flag = true; ret.push(k); ret.push(': \n'); foo(x[k]); } }
        ret.push('}');
        return true;
    }
    foo(x);
    return ret.join('');
}

numeric.parseDate = function parseDate(d) {
    function foo(d) {
        if(typeof d === 'string') { return Date.parse(d.replace(/-/g,'/')); }
        if(!(d instanceof Array)) { throw new Error("parseDate: parameter must be arrays of strings"); }
        var ret = [],k;
        for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
        return ret;
    }
    return foo(d);
}

numeric.parseFloat = function parseFloat_(d) {
    function foo(d) {
        if(typeof d === 'string') { return parseFloat(d); }
        if(!(d instanceof Array)) { throw new Error("parseFloat: parameter must be arrays of strings"); }
        var ret = [],k;
        for(k=0;k<d.length;k++) { ret[k] = foo(d[k]); }
        return ret;
    }
    return foo(d);
}

numeric.parseCSV = function parseCSV(t) {
    var foo = t.split('\n');
    var j,k;
    var ret = [];
    var pat = /(([^'",]*)|('[^']*')|("[^"]*")),/g;
    var patnum = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/;
    var stripper = function(n) { return n.substr(0,n.length-1); }
    var count = 0;
    for(k=0;k<foo.length;k++) {
      var bar = (foo[k]+",").match(pat),baz;
      if(bar.length>0) {
          ret[count] = [];
          for(j=0;j<bar.length;j++) {
              baz = stripper(bar[j]);
              if(patnum.test(baz)) { ret[count][j] = parseFloat(baz); }
              else ret[count][j] = baz;
          }
          count++;
      }
    }
    return ret;
}

numeric.toCSV = function toCSV(A) {
    var s = numeric.dim(A);
    var i,j,m,n,row,ret;
    m = s[0];
    n = s[1];
    ret = [];
    for(i=0;i<m;i++) {
        row = [];
        for(j=0;j<m;j++) { row[j] = A[i][j].toString(); }
        ret[i] = row.join(', ');
    }
    return ret.join('\n')+'\n';
}

numeric.getURL = function getURL(url) {
    var client = new XMLHttpRequest();
    client.open("GET",url,false);
    client.send();
    return client;
}

numeric.imageURL = function imageURL(img) {
    function base64(A) {
        var n = A.length, i,x,y,z,p,q,r,s;
        var key = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        var ret = "";
        for(i=0;i<n;i+=3) {
            x = A[i];
            y = A[i+1];
            z = A[i+2];
            p = x >> 2;
            q = ((x & 3) << 4) + (y >> 4);
            r = ((y & 15) << 2) + (z >> 6);
            s = z & 63;
            if(i+1>=n) { r = s = 64; }
            else if(i+2>=n) { s = 64; }
            ret += key.charAt(p) + key.charAt(q) + key.charAt(r) + key.charAt(s);
            }
        return ret;
    }
    function crc32Array (a,from,to) {
        if(typeof from === "undefined") { from = 0; }
        if(typeof to === "undefined") { to = a.length; }
        var table = [0x00000000, 0x77073096, 0xEE0E612C, 0x990951BA, 0x076DC419, 0x706AF48F, 0xE963A535, 0x9E6495A3,
                     0x0EDB8832, 0x79DCB8A4, 0xE0D5E91E, 0x97D2D988, 0x09B64C2B, 0x7EB17CBD, 0xE7B82D07, 0x90BF1D91, 
                     0x1DB71064, 0x6AB020F2, 0xF3B97148, 0x84BE41DE, 0x1ADAD47D, 0x6DDDE4EB, 0xF4D4B551, 0x83D385C7,
                     0x136C9856, 0x646BA8C0, 0xFD62F97A, 0x8A65C9EC, 0x14015C4F, 0x63066CD9, 0xFA0F3D63, 0x8D080DF5, 
                     0x3B6E20C8, 0x4C69105E, 0xD56041E4, 0xA2677172, 0x3C03E4D1, 0x4B04D447, 0xD20D85FD, 0xA50AB56B, 
                     0x35B5A8FA, 0x42B2986C, 0xDBBBC9D6, 0xACBCF940, 0x32D86CE3, 0x45DF5C75, 0xDCD60DCF, 0xABD13D59, 
                     0x26D930AC, 0x51DE003A, 0xC8D75180, 0xBFD06116, 0x21B4F4B5, 0x56B3C423, 0xCFBA9599, 0xB8BDA50F,
                     0x2802B89E, 0x5F058808, 0xC60CD9B2, 0xB10BE924, 0x2F6F7C87, 0x58684C11, 0xC1611DAB, 0xB6662D3D,
                     0x76DC4190, 0x01DB7106, 0x98D220BC, 0xEFD5102A, 0x71B18589, 0x06B6B51F, 0x9FBFE4A5, 0xE8B8D433,
                     0x7807C9A2, 0x0F00F934, 0x9609A88E, 0xE10E9818, 0x7F6A0DBB, 0x086D3D2D, 0x91646C97, 0xE6635C01, 
                     0x6B6B51F4, 0x1C6C6162, 0x856530D8, 0xF262004E, 0x6C0695ED, 0x1B01A57B, 0x8208F4C1, 0xF50FC457, 
                     0x65B0D9C6, 0x12B7E950, 0x8BBEB8EA, 0xFCB9887C, 0x62DD1DDF, 0x15DA2D49, 0x8CD37CF3, 0xFBD44C65, 
                     0x4DB26158, 0x3AB551CE, 0xA3BC0074, 0xD4BB30E2, 0x4ADFA541, 0x3DD895D7, 0xA4D1C46D, 0xD3D6F4FB, 
                     0x4369E96A, 0x346ED9FC, 0xAD678846, 0xDA60B8D0, 0x44042D73, 0x33031DE5, 0xAA0A4C5F, 0xDD0D7CC9, 
                     0x5005713C, 0x270241AA, 0xBE0B1010, 0xC90C2086, 0x5768B525, 0x206F85B3, 0xB966D409, 0xCE61E49F, 
                     0x5EDEF90E, 0x29D9C998, 0xB0D09822, 0xC7D7A8B4, 0x59B33D17, 0x2EB40D81, 0xB7BD5C3B, 0xC0BA6CAD, 
                     0xEDB88320, 0x9ABFB3B6, 0x03B6E20C, 0x74B1D29A, 0xEAD54739, 0x9DD277AF, 0x04DB2615, 0x73DC1683, 
                     0xE3630B12, 0x94643B84, 0x0D6D6A3E, 0x7A6A5AA8, 0xE40ECF0B, 0x9309FF9D, 0x0A00AE27, 0x7D079EB1, 
                     0xF00F9344, 0x8708A3D2, 0x1E01F268, 0x6906C2FE, 0xF762575D, 0x806567CB, 0x196C3671, 0x6E6B06E7, 
                     0xFED41B76, 0x89D32BE0, 0x10DA7A5A, 0x67DD4ACC, 0xF9B9DF6F, 0x8EBEEFF9, 0x17B7BE43, 0x60B08ED5, 
                     0xD6D6A3E8, 0xA1D1937E, 0x38D8C2C4, 0x4FDFF252, 0xD1BB67F1, 0xA6BC5767, 0x3FB506DD, 0x48B2364B, 
                     0xD80D2BDA, 0xAF0A1B4C, 0x36034AF6, 0x41047A60, 0xDF60EFC3, 0xA867DF55, 0x316E8EEF, 0x4669BE79, 
                     0xCB61B38C, 0xBC66831A, 0x256FD2A0, 0x5268E236, 0xCC0C7795, 0xBB0B4703, 0x220216B9, 0x5505262F, 
                     0xC5BA3BBE, 0xB2BD0B28, 0x2BB45A92, 0x5CB36A04, 0xC2D7FFA7, 0xB5D0CF31, 0x2CD99E8B, 0x5BDEAE1D, 
                     0x9B64C2B0, 0xEC63F226, 0x756AA39C, 0x026D930A, 0x9C0906A9, 0xEB0E363F, 0x72076785, 0x05005713, 
                     0x95BF4A82, 0xE2B87A14, 0x7BB12BAE, 0x0CB61B38, 0x92D28E9B, 0xE5D5BE0D, 0x7CDCEFB7, 0x0BDBDF21, 
                     0x86D3D2D4, 0xF1D4E242, 0x68DDB3F8, 0x1FDA836E, 0x81BE16CD, 0xF6B9265B, 0x6FB077E1, 0x18B74777, 
                     0x88085AE6, 0xFF0F6A70, 0x66063BCA, 0x11010B5C, 0x8F659EFF, 0xF862AE69, 0x616BFFD3, 0x166CCF45, 
                     0xA00AE278, 0xD70DD2EE, 0x4E048354, 0x3903B3C2, 0xA7672661, 0xD06016F7, 0x4969474D, 0x3E6E77DB, 
                     0xAED16A4A, 0xD9D65ADC, 0x40DF0B66, 0x37D83BF0, 0xA9BCAE53, 0xDEBB9EC5, 0x47B2CF7F, 0x30B5FFE9, 
                     0xBDBDF21C, 0xCABAC28A, 0x53B39330, 0x24B4A3A6, 0xBAD03605, 0xCDD70693, 0x54DE5729, 0x23D967BF, 
                     0xB3667A2E, 0xC4614AB8, 0x5D681B02, 0x2A6F2B94, 0xB40BBE37, 0xC30C8EA1, 0x5A05DF1B, 0x2D02EF8D];
     
        var crc = -1, y = 0, n = a.length,i;

        for (i = from; i < to; i++) {
            y = (crc ^ a[i]) & 0xFF;
            crc = (crc >>> 8) ^ table[y];
        }
     
        return crc ^ (-1);
    }

    var h = img[0].length, w = img[0][0].length, s1, s2, next,k,length,a,b,i,j,adler32,crc32;
    var stream = [
                  137, 80, 78, 71, 13, 10, 26, 10,                           //  0: PNG signature
                  0,0,0,13,                                                  //  8: IHDR Chunk length
                  73, 72, 68, 82,                                            // 12: "IHDR" 
                  (w >> 24) & 255, (w >> 16) & 255, (w >> 8) & 255, w&255,   // 16: Width
                  (h >> 24) & 255, (h >> 16) & 255, (h >> 8) & 255, h&255,   // 20: Height
                  8,                                                         // 24: bit depth
                  2,                                                         // 25: RGB
                  0,                                                         // 26: deflate
                  0,                                                         // 27: no filter
                  0,                                                         // 28: no interlace
                  -1,-2,-3,-4,                                               // 29: CRC
                  -5,-6,-7,-8,                                               // 33: IDAT Chunk length
                  73, 68, 65, 84,                                            // 37: "IDAT"
                  // RFC 1950 header starts here
                  8,                                                         // 41: RFC1950 CMF
                  29                                                         // 42: RFC1950 FLG
                  ];
    crc32 = crc32Array(stream,12,29);
    stream[29] = (crc32>>24)&255;
    stream[30] = (crc32>>16)&255;
    stream[31] = (crc32>>8)&255;
    stream[32] = (crc32)&255;
    s1 = 1;
    s2 = 0;
    for(i=0;i<h;i++) {
        if(i<h-1) { stream.push(0); }
        else { stream.push(1); }
        a = (3*w+1+(i===0))&255; b = ((3*w+1+(i===0))>>8)&255;
        stream.push(a); stream.push(b);
        stream.push((~a)&255); stream.push((~b)&255);
        if(i===0) stream.push(0);
        for(j=0;j<w;j++) {
            for(k=0;k<3;k++) {
                a = img[k][i][j];
                if(a>255) a = 255;
                else if(a<0) a=0;
                else a = Math.round(a);
                s1 = (s1 + a )%65521;
                s2 = (s2 + s1)%65521;
                stream.push(a);
            }
        }
        stream.push(0);
    }
    adler32 = (s2<<16)+s1;
    stream.push((adler32>>24)&255);
    stream.push((adler32>>16)&255);
    stream.push((adler32>>8)&255);
    stream.push((adler32)&255);
    length = stream.length - 41;
    stream[33] = (length>>24)&255;
    stream[34] = (length>>16)&255;
    stream[35] = (length>>8)&255;
    stream[36] = (length)&255;
    crc32 = crc32Array(stream,37);
    stream.push((crc32>>24)&255);
    stream.push((crc32>>16)&255);
    stream.push((crc32>>8)&255);
    stream.push((crc32)&255);
    stream.push(0);
    stream.push(0);
    stream.push(0);
    stream.push(0);
//    a = stream.length;
    stream.push(73);  // I
    stream.push(69);  // E
    stream.push(78);  // N
    stream.push(68);  // D
    stream.push(174); // CRC1
    stream.push(66);  // CRC2
    stream.push(96);  // CRC3
    stream.push(130); // CRC4
    return 'data:image/png;base64,'+base64(stream);
}

// 2. Linear algebra with Arrays.
numeric._dim = function _dim(x) {
    var ret = [];
    while(typeof x === "object") { ret.push(x.length); x = x[0]; }
    return ret;
}

numeric.dim = function dim(x) {
    var y,z;
    if(typeof x === "object") {
        y = x[0];
        if(typeof y === "object") {
            z = y[0];
            if(typeof z === "object") {
                return numeric._dim(x);
            }
            return [x.length,y.length];
        }
        return [x.length];
    }
    return [];
}

numeric.mapreduce = function mapreduce(body,init) {
    return Function('x','accum','_s','_k',
            'if(typeof accum === "undefined") accum = '+init+';\n'+
            'if(typeof x === "number") { var xi = x; '+body+'; return accum; }\n'+
            'if(typeof _s === "undefined") _s = numeric.dim(x);\n'+
            'if(typeof _k === "undefined") _k = 0;\n'+
            'var _n = _s[_k];\n'+
            'var i,xi;\n'+
            'if(_k < _s.length-1) {\n'+
            '    for(i=_n-1;i>=0;i--) {\n'+
            '        accum = arguments.callee(x[i],accum,_s,_k+1);\n'+
            '    }'+
            '    return accum;\n'+
            '}\n'+
            'for(i=_n-1;i>=1;i-=2) { \n'+
            '    xi = x[i];\n'+
            '    '+body+';\n'+
            '    xi = x[i-1];\n'+
            '    '+body+';\n'+
            '}\n'+
            'if(i === 0) {\n'+
            '    xi = x[i];\n'+
            '    '+body+'\n'+
            '}\n'+
            'return accum;'
            );
}
numeric.mapreduce2 = function mapreduce2(body,setup) {
    return Function('x',
            'var n = x.length;\n'+
            'var i,xi;\n'+setup+';\n'+
            'for(i=n-1;i!==-1;--i) { \n'+
            '    xi = x[i];\n'+
            '    '+body+';\n'+
            '}\n'+
            'return accum;'
            );
}


numeric.same = function same(x,y) {
    var i,n;
    if(!(x instanceof Array) || !(y instanceof Array)) { return false; }
    n = x.length;
    if(n !== y.length) { return false; }
    for(i=0;i<n;i++) {
        if(x[i] === y[i]) { continue; }
        if(typeof x[i] === "object") { if(!same(x[i],y[i])) return false; }
        else { return false; }
    }
    return true;
}

numeric.rep = function rep(s,v,k) {
    if(typeof k === "undefined") { k=0; }
    var n = s[k], ret = Array(n), i;
    if(k === s.length-1) {
        for(i=n-2;i>=0;i-=2) { ret[i+1] = v; ret[i] = v; }
        if(i===-1) { ret[0] = v; }
        return ret;
    }
    for(i=n-1;i>=0;i--) { ret[i] = numeric.rep(s,v,k+1); }
    return ret;
}


numeric.dotMMsmall = function dotMMsmall(x,y) {
    var i,j,k,p,q,r,ret,foo,bar,woo,i0,k0,p0,r0;
    p = x.length; q = y.length; r = y[0].length;
    ret = Array(p);
    for(i=p-1;i>=0;i--) {
        foo = Array(r);
        bar = x[i];
        for(k=r-1;k>=0;k--) {
            woo = bar[q-1]*y[q-1][k];
            for(j=q-2;j>=1;j-=2) {
                i0 = j-1;
                woo += bar[j]*y[j][k] + bar[i0]*y[i0][k];
            }
            if(j===0) { woo += bar[0]*y[0][k]; }
            foo[k] = woo;
        }
        ret[i] = foo;
    }
    return ret;
}
numeric._getCol = function _getCol(A,j,x) {
    var n = A.length, i;
    for(i=n-1;i>0;--i) {
        x[i] = A[i][j];
        --i;
        x[i] = A[i][j];
    }
    if(i===0) x[0] = A[0][j];
}
numeric.dotMMbig = function dotMMbig(x,y){
    var gc = numeric._getCol, p = y.length, v = Array(p);
    var m = x.length, n = y[0].length, A = new Array(m), xj;
    var VV = numeric.dotVV;
    var i,j,k,z;
    --p;
    --m;
    for(i=m;i!==-1;--i) A[i] = Array(n);
    --n;
    for(i=n;i!==-1;--i) {
        gc(y,i,v);
        for(j=m;j!==-1;--j) {
            z=0;
            xj = x[j];
            A[j][i] = VV(xj,v);
        }
    }
    return A;
}

numeric.dotMV = function dotMV(x,y) {
    var p = x.length, q = y.length,i;
    var ret = Array(p), dotVV = numeric.dotVV;
    for(i=p-1;i>=0;i--) { ret[i] = dotVV(x[i],y); }
    return ret;
}

numeric.dotVM = function dotVM(x,y) {
    var i,j,k,p,q,r,ret,foo,bar,woo,i0,k0,p0,r0,s1,s2,s3,baz,accum;
    p = x.length; q = y[0].length;
    ret = Array(q);
    for(k=q-1;k>=0;k--) {
        woo = x[p-1]*y[p-1][k];
        for(j=p-2;j>=1;j-=2) {
            i0 = j-1;
            woo += x[j]*y[j][k] + x[i0]*y[i0][k];
        }
        if(j===0) { woo += x[0]*y[0][k]; }
        ret[k] = woo;
    }
    return ret;
}

numeric.dotVV = function dotVV(x,y) {
    var i,n=x.length,i1,ret = x[n-1]*y[n-1];
    for(i=n-2;i>=1;i-=2) {
        i1 = i-1;
        ret += x[i]*y[i] + x[i1]*y[i1];
    }
    if(i===0) { ret += x[0]*y[0]; }
    return ret;
}

numeric.dot = function dot(x,y) {
    var d = numeric.dim;
    switch(d(x).length*1000+d(y).length) {
    case 2002:
        if(y.length < 10) return numeric.dotMMsmall(x,y);
        else return numeric.dotMMbig(x,y);
    case 2001: return numeric.dotMV(x,y);
    case 1002: return numeric.dotVM(x,y);
    case 1001: return numeric.dotVV(x,y);
    case 1000: return numeric.mulVS(x,y);
    case 1: return numeric.mulSV(x,y);
    case 0: return x*y;
    default: throw new Error('numeric.dot only works on vectors and matrices');
    }
}

numeric.diag = function diag(d) {
    var i,i1,j,n = d.length, A = Array(n), Ai;
    for(i=n-1;i>=0;i--) {
        Ai = Array(n);
        i1 = i+2;
        for(j=n-1;j>=i1;j-=2) {
            Ai[j] = 0;
            Ai[j-1] = 0;
        }
        if(j>i) { Ai[j] = 0; }
        Ai[i] = d[i];
        for(j=i-1;j>=1;j-=2) {
            Ai[j] = 0;
            Ai[j-1] = 0;
        }
        if(j===0) { Ai[0] = 0; }
        A[i] = Ai;
    }
    return A;
}
numeric.getDiag = function(A) {
    var n = Math.min(A.length,A[0].length),i,ret = Array(n);
    for(i=n-1;i>=1;--i) {
        ret[i] = A[i][i];
        --i;
        ret[i] = A[i][i];
    }
    if(i===0) {
        ret[0] = A[0][0];
    }
    return ret;
}

numeric.identity = function identity(n) { return numeric.diag(numeric.rep([n],1)); }
numeric.pointwise = function pointwise(params,body,setup) {
    if(typeof setup === "undefined") { setup = ""; }
    var fun = [];
    var k;
    var avec = /\[i\]$/,p,thevec = '';
    var haveret = false;
    for(k=0;k<params.length;k++) {
        if(avec.test(params[k])) {
            p = params[k].substring(0,params[k].length-3);
            thevec = p;
        } else { p = params[k]; }
        if(p==='ret') haveret = true;
        fun.push(p);
    }
    fun[params.length] = '_s';
    fun[params.length+1] = '_k';
    fun[params.length+2] = (
            'if(typeof _s === "undefined") _s = numeric.dim('+thevec+');\n'+
            'if(typeof _k === "undefined") _k = 0;\n'+
            'var _n = _s[_k];\n'+
            'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
            'if(_k < _s.length-1) {\n'+
            '    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee('+params.join(',')+',_s,_k+1);\n'+
            '    return ret;\n'+
            '}\n'+
            setup+'\n'+
            'for(i=_n-1;i!==-1;--i) {\n'+
            '    '+body+'\n'+
            '}\n'+
            'return ret;'
            );
    return Function.apply(null,fun);
}
numeric.pointwise2 = function pointwise2(params,body,setup) {
    if(typeof setup === "undefined") { setup = ""; }
    var fun = [];
    var k;
    var avec = /\[i\]$/,p,thevec = '';
    var haveret = false;
    for(k=0;k<params.length;k++) {
        if(avec.test(params[k])) {
            p = params[k].substring(0,params[k].length-3);
            thevec = p;
        } else { p = params[k]; }
        if(p==='ret') haveret = true;
        fun.push(p);
    }
    fun[params.length] = (
            'var _n = '+thevec+'.length;\n'+
            'var i'+(haveret?'':', ret = Array(_n)')+';\n'+
            setup+'\n'+
            'for(i=_n-1;i!==-1;--i) {\n'+
            body+'\n'+
            '}\n'+
            'return ret;'
            );
    return Function.apply(null,fun);
}
numeric._biforeach = (function _biforeach(x,y,s,k,f) {
    if(k === s.length-1) { f(x,y); return; }
    var i,n=s[k];
    for(i=n-1;i>=0;i--) { _biforeach(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
});
numeric._biforeach2 = (function _biforeach2(x,y,s,k,f) {
    if(k === s.length-1) { return f(x,y); }
    var i,n=s[k],ret = Array(n);
    for(i=n-1;i>=0;--i) { ret[i] = _biforeach2(typeof x==="object"?x[i]:x,typeof y==="object"?y[i]:y,s,k+1,f); }
    return ret;
});
numeric._foreach = (function _foreach(x,s,k,f) {
    if(k === s.length-1) { f(x); return; }
    var i,n=s[k];
    for(i=n-1;i>=0;i--) { _foreach(x[i],s,k+1,f); }
});
numeric._foreach2 = (function _foreach2(x,s,k,f) {
    if(k === s.length-1) { return f(x); }
    var i,n=s[k], ret = Array(n);
    for(i=n-1;i>=0;i--) { ret[i] = _foreach2(x[i],s,k+1,f); }
    return ret;
});

/*numeric.anyV = numeric.mapreduce('if(xi) return true;','false');
numeric.allV = numeric.mapreduce('if(!xi) return false;','true');
numeric.any = function(x) { if(typeof x.length === "undefined") return x; return numeric.anyV(x); }
numeric.all = function(x) { if(typeof x.length === "undefined") return x; return numeric.allV(x); }*/

numeric.ops2 = {
        add: '+',
        sub: '-',
        mul: '*',
        div: '/',
        mod: '%',
        and: '&&',
        or:  '||',
        eq:  '===',
        neq: '!==',
        lt:  '<',
        gt:  '>',
        leq: '<=',
        geq: '>=',
        band: '&',
        bor: '|',
        bxor: '^',
        lshift: '<<',
        rshift: '>>',
        rrshift: '>>>'
};
numeric.opseq = {
        addeq: '+=',
        subeq: '-=',
        muleq: '*=',
        diveq: '/=',
        modeq: '%=',
        lshifteq: '<<=',
        rshifteq: '>>=',
        rrshifteq: '>>>=',
        bandeq: '&=',
        boreq: '|=',
        bxoreq: '^='
};
numeric.mathfuns = ['abs','acos','asin','atan','ceil','cos',
                    'exp','floor','log','round','sin','sqrt','tan',
                    'isNaN','isFinite'];
numeric.mathfuns2 = ['atan2','pow','max','min'];
numeric.ops1 = {
        neg: '-',
        not: '!',
        bnot: '~',
        clone: ''
};
numeric.mapreducers = {
        any: ['if(xi) return true;','var accum = false;'],
        all: ['if(!xi) return false;','var accum = true;'],
        sum: ['accum += xi;','var accum = 0;'],
        prod: ['accum *= xi;','var accum = 1;'],
        norm2Squared: ['accum += xi*xi;','var accum = 0;'],
        norminf: ['accum = max(accum,abs(xi));','var accum = 0, max = Math.max, abs = Math.abs;'],
        norm1: ['accum += abs(xi)','var accum = 0, abs = Math.abs;'],
        sup: ['accum = max(accum,xi);','var accum = -Infinity, max = Math.max;'],
        inf: ['accum = min(accum,xi);','var accum = Infinity, min = Math.min;']
};

(function () {
    var i,o;
    for(i=0;i<numeric.mathfuns2.length;++i) {
        o = numeric.mathfuns2[i];
        numeric.ops2[o] = o;
    }
    for(i in numeric.ops2) {
        if(numeric.ops2.hasOwnProperty(i)) {
            o = numeric.ops2[i];
            var code, codeeq, setup = '';
            if(numeric.myIndexOf.call(numeric.mathfuns2,i)!==-1) {
                setup = 'var '+o+' = Math.'+o+';\n';
                code = function(r,x,y) { return r+' = '+o+'('+x+','+y+')'; };
                codeeq = function(x,y) { return x+' = '+o+'('+x+','+y+')'; };
            } else {
                code = function(r,x,y) { return r+' = '+x+' '+o+' '+y; };
                if(numeric.opseq.hasOwnProperty(i+'eq')) {
                    codeeq = function(x,y) { return x+' '+o+'= '+y; };
                } else {
                    codeeq = function(x,y) { return x+' = '+x+' '+o+' '+y; };                    
                }
            }
            numeric[i+'VV'] = numeric.pointwise2(['x[i]','y[i]'],code('ret[i]','x[i]','y[i]'),setup);
            numeric[i+'SV'] = numeric.pointwise2(['x','y[i]'],code('ret[i]','x','y[i]'),setup);
            numeric[i+'VS'] = numeric.pointwise2(['x[i]','y'],code('ret[i]','x[i]','y'),setup);
            numeric[i] = Function(
                    'var n = arguments.length, i, x = arguments[0], y;\n'+
                    'var VV = numeric.'+i+'VV, VS = numeric.'+i+'VS, SV = numeric.'+i+'SV;\n'+
                    'var dim = numeric.dim;\n'+
                    'for(i=1;i!==n;++i) { \n'+
                    '  y = arguments[i];\n'+
                    '  if(typeof x === "object") {\n'+
                    '      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n'+
                    '      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n'+
                    '  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n'+
                    '  else '+codeeq('x','y')+'\n'+
                    '}\nreturn x;\n');
            numeric[o] = numeric[i];
            numeric[i+'eqV'] = numeric.pointwise2(['ret[i]','x[i]'], codeeq('ret[i]','x[i]'),setup);
            numeric[i+'eqS'] = numeric.pointwise2(['ret[i]','x'], codeeq('ret[i]','x'),setup);
            numeric[i+'eq'] = Function(
                    'var n = arguments.length, i, x = arguments[0], y;\n'+
                    'var V = numeric.'+i+'eqV, S = numeric.'+i+'eqS\n'+
                    'var s = numeric.dim(x);\n'+
                    'for(i=1;i!==n;++i) { \n'+
                    '  y = arguments[i];\n'+
                    '  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n'+
                    '  else numeric._biforeach(x,y,s,0,S);\n'+
                    '}\nreturn x;\n');
        }
    }
    for(i=0;i<numeric.mathfuns2.length;++i) {
        o = numeric.mathfuns2[i];
        delete numeric.ops2[o];
    }
    for(i=0;i<numeric.mathfuns.length;++i) {
        o = numeric.mathfuns[i];
        numeric.ops1[o] = o;
    }
    for(i in numeric.ops1) {
        if(numeric.ops1.hasOwnProperty(i)) {
            setup = '';
            o = numeric.ops1[i];
            if(numeric.myIndexOf.call(numeric.mathfuns,i)!==-1) {
                if(Math.hasOwnProperty(o)) setup = 'var '+o+' = Math.'+o+';\n';
            }
            numeric[i+'eqV'] = numeric.pointwise2(['ret[i]'],'ret[i] = '+o+'(ret[i]);',setup);
            numeric[i+'eq'] = Function('x',
                    'if(typeof x !== "object") return '+o+'x\n'+
                    'var i;\n'+
                    'var V = numeric.'+i+'eqV;\n'+
                    'var s = numeric.dim(x);\n'+
                    'numeric._foreach(x,s,0,V);\n'+
                    'return x;\n');
            numeric[i+'V'] = numeric.pointwise2(['x[i]'],'ret[i] = '+o+'(x[i]);',setup);
            numeric[i] = Function('x',
                    'if(typeof x !== "object") return '+o+'(x)\n'+
                    'var i;\n'+
                    'var V = numeric.'+i+'V;\n'+
                    'var s = numeric.dim(x);\n'+
                    'return numeric._foreach2(x,s,0,V);\n');
        }
    }
    for(i=0;i<numeric.mathfuns.length;++i) {
        o = numeric.mathfuns[i];
        delete numeric.ops1[o];
    }
    for(i in numeric.mapreducers) {
        if(numeric.mapreducers.hasOwnProperty(i)) {
            o = numeric.mapreducers[i];
            numeric[i+'V'] = numeric.mapreduce2(o[0],o[1]);
            numeric[i] = Function('x','s','k',
                    o[1]+
                    'if(typeof x !== "object") {'+
                    '    xi = x;\n'+
                    o[0]+';\n'+
                    '    return accum;\n'+
                    '}'+
                    'if(typeof s === "undefined") s = numeric.dim(x);\n'+
                    'if(typeof k === "undefined") k = 0;\n'+
                    'if(k === s.length-1) return numeric.'+i+'V(x);\n'+
                    'var xi;\n'+
                    'var n = x.length, i;\n'+
                    'for(i=n-1;i!==-1;--i) {\n'+
                    '   xi = arguments.callee(x[i]);\n'+
                    o[0]+';\n'+
                    '}\n'+
                    'return accum;\n');
        }
    }
}());

numeric.truncVV = numeric.pointwise(['x[i]','y[i]'],'ret[i] = round(x[i]/y[i])*y[i];','var round = Math.round;');
numeric.truncVS = numeric.pointwise(['x[i]','y'],'ret[i] = round(x[i]/y)*y;','var round = Math.round;');
numeric.truncSV = numeric.pointwise(['x','y[i]'],'ret[i] = round(x/y[i])*y[i];','var round = Math.round;');
numeric.trunc = function trunc(x,y) {
    if(typeof x === "object") {
        if(typeof y === "object") return numeric.truncVV(x,y);
        return numeric.truncVS(x,y);
    }
    if (typeof y === "object") return numeric.truncSV(x,y);
    return Math.round(x/y)*y;
}

numeric.inv = function inv(x) {
    var s = numeric.dim(x), abs = Math.abs, m = s[0], n = s[1];
    var A = numeric.clone(x), Ai, Aj;
    var I = numeric.identity(m), Ii, Ij;
    var i,j,k,x;
    for(j=0;j<n;++j) {
        var i0 = -1;
        var v0 = -1;
        for(i=j;i!==m;++i) { k = abs(A[i][j]); if(k>v0) { i0 = i; v0 = k; } }
        Aj = A[i0]; A[i0] = A[j]; A[j] = Aj;
        Ij = I[i0]; I[i0] = I[j]; I[j] = Ij;
        x = Aj[j];
        for(k=j;k!==n;++k)    Aj[k] /= x; 
        for(k=n-1;k!==-1;--k) Ij[k] /= x;
        for(i=m-1;i!==-1;--i) {
            if(i!==j) {
                Ai = A[i];
                Ii = I[i];
                x = Ai[j];
                for(k=j+1;k!==n;++k)  Ai[k] -= Aj[k]*x;
                for(k=n-1;k>0;--k) { Ii[k] -= Ij[k]*x; --k; Ii[k] -= Ij[k]*x; }
                if(k===0) Ii[0] -= Ij[0]*x;
            }
        }
    }
    return I;
}

numeric.det = function det(x) {
    var s = numeric.dim(x);
    if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: det() only works on square matrices'); }
    var n = s[0], ret = 1,i,j,k,A = numeric.clone(x),Aj,Ai,alpha,temp,k1,k2,k3;
    for(j=0;j<n-1;j++) {
        k=j;
        for(i=j+1;i<n;i++) { if(Math.abs(A[i][j]) > Math.abs(A[k][j])) { k = i; } }
        if(k !== j) {
            temp = A[k]; A[k] = A[j]; A[j] = temp;
            ret *= -1;
        }
        Aj = A[j];
        for(i=j+1;i<n;i++) {
            Ai = A[i];
            alpha = Ai[j]/Aj[j];
            for(k=j+1;k<n-1;k+=2) {
                k1 = k+1;
                Ai[k] -= Aj[k]*alpha;
                Ai[k1] -= Aj[k1]*alpha;
            }
            if(k!==n) { Ai[k] -= Aj[k]*alpha; }
        }
        if(Aj[j] === 0) { return 0; }
        ret *= Aj[j];
    }
    return ret*A[j][j];
}

numeric.transpose = function transpose(x) {
    var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
    for(j=0;j<n;j++) ret[j] = Array(m);
    for(i=m-1;i>=1;i-=2) {
        A1 = x[i];
        A0 = x[i-1];
        for(j=n-1;j>=1;--j) {
            Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
            --j;
            Bj = ret[j]; Bj[i] = A1[j]; Bj[i-1] = A0[j];
        }
        if(j===0) {
            Bj = ret[0]; Bj[i] = A1[0]; Bj[i-1] = A0[0];
        }
    }
    if(i===0) {
        A0 = x[0];
        for(j=n-1;j>=1;--j) {
            ret[j][0] = A0[j];
            --j;
            ret[j][0] = A0[j];
        }
        if(j===0) { ret[0][0] = A0[0]; }
    }
    return ret;
}
numeric.negtranspose = function negtranspose(x) {
    var i,j,m = x.length,n = x[0].length, ret=Array(n),A0,A1,Bj;
    for(j=0;j<n;j++) ret[j] = Array(m);
    for(i=m-1;i>=1;i-=2) {
        A1 = x[i];
        A0 = x[i-1];
        for(j=n-1;j>=1;--j) {
            Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
            --j;
            Bj = ret[j]; Bj[i] = -A1[j]; Bj[i-1] = -A0[j];
        }
        if(j===0) {
            Bj = ret[0]; Bj[i] = -A1[0]; Bj[i-1] = -A0[0];
        }
    }
    if(i===0) {
        A0 = x[0];
        for(j=n-1;j>=1;--j) {
            ret[j][0] = -A0[j];
            --j;
            ret[j][0] = -A0[j];
        }
        if(j===0) { ret[0][0] = -A0[0]; }
    }
    return ret;
}

numeric._random = function _random(s,k) {
    var i,n=s[k],ret=Array(n), rnd;
    if(k === s.length-1) {
        rnd = Math.random;
        for(i=n-1;i>=1;i-=2) {
            ret[i] = rnd();
            ret[i-1] = rnd();
        }
        if(i===0) { ret[0] = rnd(); }
        return ret;
    }
    for(i=n-1;i>=0;i--) ret[i] = _random(s,k+1);
    return ret;
}
numeric.random = function random(s) { return numeric._random(s,0); }

numeric.norm2 = function norm2(x) { return Math.sqrt(numeric.norm2Squared(x)); }

numeric.linspace = function linspace(a,b,n) {
    if(typeof n === "undefined") n = Math.max(Math.round(b-a)+1,1);
    if(n<2) { return n===1?[a]:[]; }
    var i,ret = Array(n);
    n--;
    for(i=n;i>=0;i--) { ret[i] = (i*b+(n-i)*a)/n; }
    return ret;
}

numeric.getBlock = function getBlock(x,from,to) {
    var s = numeric.dim(x);
    function foo(x,k) {
        var i,a = from[k], n = to[k]-a, ret = Array(n);
        if(k === s.length-1) {
            for(i=n;i>=0;i--) { ret[i] = x[i+a]; }
            return ret;
        }
        for(i=n;i>=0;i--) { ret[i] = foo(x[i+a],k+1); }
        return ret;
    }
    return foo(x,0);
}

numeric.setBlock = function setBlock(x,from,to,B) {
    var s = numeric.dim(x);
    function foo(x,y,k) {
        var i,a = from[k], n = to[k]-a;
        if(k === s.length-1) { for(i=n;i>=0;i--) { x[i+a] = y[i]; } }
        for(i=n;i>=0;i--) { foo(x[i+a],y[i],k+1); }
    }
    foo(x,B,0);
    return x;
}

numeric.getRange = function getRange(A,I,J) {
    var m = I.length, n = J.length;
    var i,j;
    var B = Array(m), Bi, AI;
    for(i=m-1;i!==-1;--i) {
        B[i] = Array(n);
        Bi = B[i];
        AI = A[I[i]];
        for(j=n-1;j!==-1;--j) Bi[j] = AI[J[j]];
    }
    return B;
}

numeric.blockMatrix = function blockMatrix(X) {
    var s = numeric.dim(X);
    if(s.length<4) return numeric.blockMatrix([X]);
    var m=s[0],n=s[1],M,N,i,j,Xij;
    M = 0; N = 0;
    for(i=0;i<m;++i) M+=X[i][0].length;
    for(j=0;j<n;++j) N+=X[0][j][0].length;
    var Z = Array(M);
    for(i=0;i<M;++i) Z[i] = Array(N);
    var I=0,J,ZI,k,l,Xijk;
    for(i=0;i<m;++i) {
        J=N;
        for(j=n-1;j!==-1;--j) {
            Xij = X[i][j];
            J -= Xij[0].length;
            for(k=Xij.length-1;k!==-1;--k) {
                Xijk = Xij[k];
                ZI = Z[I+k];
                for(l = Xijk.length-1;l!==-1;--l) ZI[J+l] = Xijk[l];
            }
        }
        I += X[i][0].length;
    }
    return Z;
}

numeric.tensor = function tensor(x,y) {
    if(typeof x === "number" || typeof y === "number") return numeric.mul(x,y);
    var s1 = numeric.dim(x), s2 = numeric.dim(y);
    if(s1.length !== 1 || s2.length !== 1) {
        throw new Error('numeric: tensor product is only defined for vectors');
    }
    var m = s1[0], n = s2[0], A = Array(m), Ai, i,j,xi;
    for(i=m-1;i>=0;i--) {
        Ai = Array(n);
        xi = x[i];
        for(j=n-1;j>=3;--j) {
            Ai[j] = xi * y[j];
            --j;
            Ai[j] = xi * y[j];
            --j;
            Ai[j] = xi * y[j];
            --j;
            Ai[j] = xi * y[j];
        }
        while(j>=0) { Ai[j] = xi * y[j]; --j; }
        A[i] = Ai;
    }
    return A;
}

// 3. The Tensor type T
numeric.T = function T(x,y) { this.x = x; this.y = y; }
numeric.t = function t(x,y) { return new numeric.T(x,y); }

numeric.Tbinop = function Tbinop(rr,rc,cr,cc,setup) {
    var io = numeric.indexOf;
    if(typeof setup !== "string") {
        var k;
        setup = '';
        for(k in numeric) {
            if(numeric.hasOwnProperty(k) && (rr.indexOf(k)>=0 || rc.indexOf(k)>=0 || cr.indexOf(k)>=0 || cc.indexOf(k)>=0) && k.length>1) {
                setup += 'var '+k+' = numeric.'+k+';\n';
            }
        }
    }
    return Function(['y'],
            'var x = this;\n'+
            'if(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n'+
            setup+'\n'+
            'if(x.y) {'+
            '  if(y.y) {'+
            '    return new numeric.T('+cc+');\n'+
            '  }\n'+
            '  return new numeric.T('+cr+');\n'+
            '}\n'+
            'if(y.y) {\n'+
            '  return new numeric.T('+rc+');\n'+
            '}\n'+
            'return new numeric.T('+rr+');\n'
    );
}

numeric.T.prototype.add = numeric.Tbinop(
        'add(x.x,y.x)',
        'add(x.x,y.x),y.y',
        'add(x.x,y.x),x.y',
        'add(x.x,y.x),add(x.y,y.y)');
numeric.T.prototype.sub = numeric.Tbinop(
        'sub(x.x,y.x)',
        'sub(x.x,y.x),neg(y.y)',
        'sub(x.x,y.x),x.y',
        'sub(x.x,y.x),sub(x.y,y.y)');
numeric.T.prototype.mul = numeric.Tbinop(
        'mul(x.x,y.x)',
        'mul(x.x,y.x),mul(x.x,y.y)',
        'mul(x.x,y.x),mul(x.y,y.x)',
        'sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))');

numeric.T.prototype.reciprocal = function reciprocal() {
    var mul = numeric.mul, div = numeric.div;
    if(this.y) {
        var d = numeric.add(mul(this.x,this.x),mul(this.y,this.y));
        return new numeric.T(div(this.x,d),div(numeric.neg(this.y),d));
    }
    return new T(div(1,this.x));
}
numeric.T.prototype.div = function div(y) {
    if(!(y instanceof numeric.T)) y = new numeric.T(y);
    if(y.y) { return this.mul(y.reciprocal()); }
    var div = numeric.div;
    if(this.y) { return new numeric.T(div(this.x,y.x),div(this.y,y.x)); }
    return new numeric.T(div(this.x,y.x));
}
numeric.T.prototype.dot = numeric.Tbinop(
        'dot(x.x,y.x)',
        'dot(x.x,y.x),dot(x.x,y.y)',
        'dot(x.x,y.x),dot(x.y,y.x)',
        'sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))'
        );
numeric.T.prototype.transpose = function transpose() {
    var t = numeric.transpose, x = this.x, y = this.y;
    if(y) { return new numeric.T(t(x),t(y)); }
    return new numeric.T(t(x));
}
numeric.T.prototype.transjugate = function transjugate() {
    var t = numeric.transpose, x = this.x, y = this.y;
    if(y) { return new numeric.T(t(x),numeric.negtranspose(y)); }
    return new numeric.T(t(x));
}
numeric.Tunop = function Tunop(r,c,s) {
    if(typeof s !== "string") { s = ''; }
    return Function(
            'var x = this;\n'+
            s+'\n'+
            'if(x.y) {'+
            '  '+c+';\n'+
            '}\n'+
            r+';\n'
    );
}

numeric.T.prototype.exp = numeric.Tunop(
        'return new numeric.T(ex)',
        'return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))',
        'var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;');
numeric.T.prototype.conj = numeric.Tunop(
        'return new numeric.T(x.x);',
        'return new numeric.T(x.x,numeric.neg(x.y));');
numeric.T.prototype.neg = numeric.Tunop(
        'return new numeric.T(neg(x.x));',
        'return new numeric.T(neg(x.x),neg(x.y));',
        'var neg = numeric.neg;');
numeric.T.prototype.sin = numeric.Tunop(
        'return new numeric.T(numeric.sin(x.x))',
        'return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));');
numeric.T.prototype.cos = numeric.Tunop(
        'return new numeric.T(numeric.cos(x.x))',
        'return x.exp().add(x.neg().exp()).div(2);');
numeric.T.prototype.abs = numeric.Tunop(
        'return new numeric.T(numeric.abs(x.x));',
        'return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));',
        'var mul = numeric.mul;');
numeric.T.prototype.log = numeric.Tunop(
        'return new numeric.T(numeric.log(x.x));',
        'var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\n'+
        'return new numeric.T(numeric.log(r.x),theta.x);');
numeric.T.prototype.norm2 = numeric.Tunop(
        'return numeric.norm2(x.x);',
        'var f = numeric.norm2Squared;\n'+
        'return Math.sqrt(f(x.x)+f(x.y));');
numeric.T.prototype.inv = function inv() {
    var A = this;
    if(typeof A.y === "undefined") { return new numeric.T(numeric.inv(A.x)); }
    var n = A.x.length, i, j, k;
    var Rx = numeric.identity(n),Ry = numeric.rep([n,n],0);
    var Ax = numeric.clone(A.x), Ay = numeric.clone(A.y);
    var Aix, Aiy, Ajx, Ajy, Rix, Riy, Rjx, Rjy;
    var i,j,k,d,d1,ax,ay,bx,by,temp;
    for(i=0;i<n;i++) {
        ax = Ax[i][i]; ay = Ay[i][i];
        d = ax*ax+ay*ay;
        k = i;
        for(j=i+1;j<n;j++) {
            ax = Ax[j][i]; ay = Ay[j][i];
            d1 = ax*ax+ay*ay;
            if(d1 > d) { k=j; d = d1; }
        }
        if(k!==i) {
            temp = Ax[i]; Ax[i] = Ax[k]; Ax[k] = temp;
            temp = Ay[i]; Ay[i] = Ay[k]; Ay[k] = temp;
            temp = Rx[i]; Rx[i] = Rx[k]; Rx[k] = temp;
            temp = Ry[i]; Ry[i] = Ry[k]; Ry[k] = temp;
        }
        Aix = Ax[i]; Aiy = Ay[i];
        Rix = Rx[i]; Riy = Ry[i];
        ax = Aix[i]; ay = Aiy[i];
        for(j=i+1;j<n;j++) {
            bx = Aix[j]; by = Aiy[j];
            Aix[j] = (bx*ax+by*ay)/d;
            Aiy[j] = (by*ax-bx*ay)/d;
        }
        for(j=0;j<n;j++) {
            bx = Rix[j]; by = Riy[j];
            Rix[j] = (bx*ax+by*ay)/d;
            Riy[j] = (by*ax-bx*ay)/d;
        }
        for(j=i+1;j<n;j++) {
            Ajx = Ax[j]; Ajy = Ay[j];
            Rjx = Rx[j]; Rjy = Ry[j];
            ax = Ajx[i]; ay = Ajy[i];
            for(k=i+1;k<n;k++) {
                bx = Aix[k]; by = Aiy[k];
                Ajx[k] -= bx*ax-by*ay;
                Ajy[k] -= by*ax+bx*ay;
            }
            for(k=0;k<n;k++) {
                bx = Rix[k]; by = Riy[k];
                Rjx[k] -= bx*ax-by*ay;
                Rjy[k] -= by*ax+bx*ay;
            }
        }
    }
    for(i=n-1;i>0;i--) {
        Rix = Rx[i]; Riy = Ry[i];
        for(j=i-1;j>=0;j--) {
            Rjx = Rx[j]; Rjy = Ry[j];
            ax = Ax[j][i]; ay = Ay[j][i];
            for(k=n-1;k>=0;k--) {
                bx = Rix[k]; by = Riy[k];
                Rjx[k] -= ax*bx - ay*by;
                Rjy[k] -= ax*by + ay*bx;
            }
        }
    }
    return new numeric.T(Rx,Ry);
}
numeric.T.prototype.get = function get(i) {
    var x = this.x, y = this.y, k = 0, ik, n = i.length;
    if(y) {
        while(k<n) {
            ik = i[k];
            x = x[ik];
            y = y[ik];
            k++;
        }
        return new numeric.T(x,y);
    }
    while(k<n) {
        ik = i[k];
        x = x[ik];
        k++;
    }
    return new numeric.T(x);
}
numeric.T.prototype.set = function set(i,v) {
    var x = this.x, y = this.y, k = 0, ik, n = i.length, vx = v.x, vy = v.y;
    if(n===0) {
        if(vy) { this.y = vy; }
        else if(y) { this.y = undefined; }
        this.x = x;
        return this;
    }
    if(vy) {
        if(y) { /* ok */ }
        else {
            y = numeric.rep(numeric.dim(x),0);
            this.y = y;
        }
        while(k<n-1) {
            ik = i[k];
            x = x[ik];
            y = y[ik];
            k++;
        }
        ik = i[k];
        x[ik] = vx;
        y[ik] = vy;
        return this;
    }
    if(y) {
        while(k<n-1) {
            ik = i[k];
            x = x[ik];
            y = y[ik];
            k++;
        }
        ik = i[k];
        x[ik] = vx;
        if(vx instanceof Array) y[ik] = numeric.rep(numeric.dim(vx),0);
        else y[ik] = 0;
        return this;
    }
    while(k<n-1) {
        ik = i[k];
        x = x[ik];
        k++;
    }
    ik = i[k];
    x[ik] = vx;
    return this;
}
numeric.T.prototype.getRows = function getRows(i0,i1) {
    var n = i1-i0+1, j;
    var rx = Array(n), ry, x = this.x, y = this.y;
    for(j=i0;j<=i1;j++) { rx[j-i0] = x[j]; }
    if(y) {
        ry = Array(n);
        for(j=i0;j<=i1;j++) { ry[j-i0] = y[j]; }
        return new numeric.T(rx,ry);
    }
    return new numeric.T(rx);
}
numeric.T.prototype.setRows = function setRows(i0,i1,A) {
    var j;
    var rx = this.x, ry = this.y, x = A.x, y = A.y;
    for(j=i0;j<=i1;j++) { rx[j] = x[j-i0]; }
    if(y) {
        if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
        for(j=i0;j<=i1;j++) { ry[j] = y[j-i0]; }
    } else if(ry) {
        for(j=i0;j<=i1;j++) { ry[j] = numeric.rep([x[j-i0].length],0); }
    }
    return this;
}
numeric.T.prototype.getRow = function getRow(k) {
    var x = this.x, y = this.y;
    if(y) { return new numeric.T(x[k],y[k]); }
    return new numeric.T(x[k]);
}
numeric.T.prototype.setRow = function setRow(i,v) {
    var rx = this.x, ry = this.y, x = v.x, y = v.y;
    rx[i] = x;
    if(y) {
        if(!ry) { ry = numeric.rep(numeric.dim(rx),0); this.y = ry; }
        ry[i] = y;
    } else if(ry) {
        ry = numeric.rep([x.length],0);
    }
    return this;
}

numeric.T.prototype.getBlock = function getBlock(from,to) {
    var x = this.x, y = this.y, b = numeric.getBlock;
    if(y) { return new numeric.T(b(x,from,to),b(y,from,to)); }
    return new numeric.T(b(x,from,to));
}
numeric.T.prototype.setBlock = function setBlock(from,to,A) {
    if(!(A instanceof numeric.T)) A = new numeric.T(A);
    var x = this.x, y = this.y, b = numeric.setBlock, Ax = A.x, Ay = A.y;
    if(Ay) {
        if(!y) { this.y = numeric.rep(numeric.dim(this),0); y = this.y; }
        b(x,from,to,Ax);
        b(y,from,to,Ay);
        return this;
    }
    b(x,from,to,Ax);
    if(y) b(y,from,to,numeric.rep(numeric.dim(Ax),0));
}
numeric.T.rep = function rep(s,v) {
    var T = numeric.T;
    if(!(v instanceof T)) v = new T(v);
    var x = v.x, y = v.y, r = numeric.rep;
    if(y) return new T(r(s,x),r(s,y));
    return new T(r(s,x));
}
numeric.T.diag = function diag(d) {
    if(!(d instanceof numeric.T)) d = new numeric.T(d);
    var x = d.x, y = d.y, diag = numeric.diag;
    if(y) return new numeric.T(diag(x),diag(y));
    return new numeric.T(diag(x));
}
numeric.T.eig = function eig() {
    if(this.y) { throw new Error('eig: not implemented for complex matrices.'); }
    return numeric.eig(this.x);
}
numeric.T.identity = function identity(n) { return new numeric.T(numeric.identity(n)); }
numeric.T.prototype.getDiag = function getDiag() {
    var n = numeric;
    var x = this.x, y = this.y;
    if(y) { return new n.T(n.getDiag(x),n.getDiag(y)); }
    return new n.T(n.getDiag(x));
}

// 4. Eigenvalues of real matrices

numeric.house = function house(x) {
    var v = numeric.clone(x);
    var s = x[0] >= 0 ? 1 : -1;
    var alpha = s*numeric.norm2(x);
    v[0] += alpha;
    var foo = numeric.norm2(v);
    if(foo === 0) { /* this should not happen */ throw new Error('eig: internal error'); }
    return numeric.div(v,foo);
}

numeric.toUpperHessenberg = function toUpperHessenberg(me) {
    var s = numeric.dim(me);
    if(s.length !== 2 || s[0] !== s[1]) { throw new Error('numeric: toUpperHessenberg() only works on square matrices'); }
    var m = s[0], i,j,k,x,v,A = numeric.clone(me),B,C,Ai,Ci,Q = numeric.identity(m),Qi;
    for(j=0;j<m-2;j++) {
        x = Array(m-j-1);
        for(i=j+1;i<m;i++) { x[i-j-1] = A[i][j]; }
        if(numeric.norm2(x)>0) {
            v = numeric.house(x);
            B = numeric.getBlock(A,[j+1,j],[m-1,m-1]);
            C = numeric.tensor(v,numeric.dot(v,B));
            for(i=j+1;i<m;i++) { Ai = A[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Ai[k] -= 2*Ci[k-j]; }
            B = numeric.getBlock(A,[0,j+1],[m-1,m-1]);
            C = numeric.tensor(numeric.dot(B,v),v);
            for(i=0;i<m;i++) { Ai = A[i]; Ci = C[i]; for(k=j+1;k<m;k++) Ai[k] -= 2*Ci[k-j-1]; }
            B = Array(m-j-1);
            for(i=j+1;i<m;i++) B[i-j-1] = Q[i];
            C = numeric.tensor(v,numeric.dot(v,B));
            for(i=j+1;i<m;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        }
    }
    return {H:A, Q:Q};
}

numeric.epsilon = 2.220446049250313e-16;

numeric.QRFrancis = function(H,maxiter) {
    if(typeof maxiter === "undefined") { maxiter = 10000; }
    H = numeric.clone(H);
    var H0 = numeric.clone(H);
    var s = numeric.dim(H),m=s[0],x,v,a,b,c,d,det,tr, Hloc, Q = numeric.identity(m), Qi, Hi, B, C, Ci,i,j,k,iter;
    if(m<3) { return {Q:Q, B:[ [0,m-1] ]}; }
    var epsilon = numeric.epsilon;
    for(iter=0;iter<maxiter;iter++) {
        for(j=0;j<m-1;j++) {
            if(Math.abs(H[j+1][j]) < epsilon*(Math.abs(H[j][j])+Math.abs(H[j+1][j+1]))) {
                var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[j,j]),maxiter);
                var QH2 = numeric.QRFrancis(numeric.getBlock(H,[j+1,j+1],[m-1,m-1]),maxiter);
                B = Array(j+1);
                for(i=0;i<=j;i++) { B[i] = Q[i]; }
                C = numeric.dot(QH1.Q,B);
                for(i=0;i<=j;i++) { Q[i] = C[i]; }
                B = Array(m-j-1);
                for(i=j+1;i<m;i++) { B[i-j-1] = Q[i]; }
                C = numeric.dot(QH2.Q,B);
                for(i=j+1;i<m;i++) { Q[i] = C[i-j-1]; }
                return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,j+1))};
            }
        }
        a = H[m-2][m-2]; b = H[m-2][m-1];
        c = H[m-1][m-2]; d = H[m-1][m-1];
        tr = a+d;
        det = (a*d-b*c);
        Hloc = numeric.getBlock(H, [0,0], [2,2]);
        if(tr*tr>=4*det) {
            var s1,s2;
            s1 = 0.5*(tr+Math.sqrt(tr*tr-4*det));
            s2 = 0.5*(tr-Math.sqrt(tr*tr-4*det));
            Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
                                           numeric.mul(Hloc,s1+s2)),
                               numeric.diag(numeric.rep([3],s1*s2)));
        } else {
            Hloc = numeric.add(numeric.sub(numeric.dot(Hloc,Hloc),
                                           numeric.mul(Hloc,tr)),
                               numeric.diag(numeric.rep([3],det)));
        }
        x = [Hloc[0][0],Hloc[1][0],Hloc[2][0]];
        v = numeric.house(x);
        B = [H[0],H[1],H[2]];
        C = numeric.tensor(v,numeric.dot(v,B));
        for(i=0;i<3;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<m;k++) Hi[k] -= 2*Ci[k]; }
        B = numeric.getBlock(H, [0,0],[m-1,2]);
        C = numeric.tensor(numeric.dot(B,v),v);
        for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=0;k<3;k++) Hi[k] -= 2*Ci[k]; }
        B = [Q[0],Q[1],Q[2]];
        C = numeric.tensor(v,numeric.dot(v,B));
        for(i=0;i<3;i++) { Qi = Q[i]; Ci = C[i]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        var J;
        for(j=0;j<m-2;j++) {
            for(k=j;k<=j+1;k++) {
                if(Math.abs(H[k+1][k]) < epsilon*(Math.abs(H[k][k])+Math.abs(H[k+1][k+1]))) {
                    var QH1 = numeric.QRFrancis(numeric.getBlock(H,[0,0],[k,k]),maxiter);
                    var QH2 = numeric.QRFrancis(numeric.getBlock(H,[k+1,k+1],[m-1,m-1]),maxiter);
                    B = Array(k+1);
                    for(i=0;i<=k;i++) { B[i] = Q[i]; }
                    C = numeric.dot(QH1.Q,B);
                    for(i=0;i<=k;i++) { Q[i] = C[i]; }
                    B = Array(m-k-1);
                    for(i=k+1;i<m;i++) { B[i-k-1] = Q[i]; }
                    C = numeric.dot(QH2.Q,B);
                    for(i=k+1;i<m;i++) { Q[i] = C[i-k-1]; }
                    return {Q:Q,B:QH1.B.concat(numeric.add(QH2.B,k+1))};
                }
            }
            J = Math.min(m-1,j+3);
            x = Array(J-j);
            for(i=j+1;i<=J;i++) { x[i-j-1] = H[i][j]; }
            v = numeric.house(x);
            B = numeric.getBlock(H, [j+1,j],[J,m-1]);
            C = numeric.tensor(v,numeric.dot(v,B));
            for(i=j+1;i<=J;i++) { Hi = H[i]; Ci = C[i-j-1]; for(k=j;k<m;k++) Hi[k] -= 2*Ci[k-j]; }
            B = numeric.getBlock(H, [0,j+1],[m-1,J]);
            C = numeric.tensor(numeric.dot(B,v),v);
            for(i=0;i<m;i++) { Hi = H[i]; Ci = C[i]; for(k=j+1;k<=J;k++) Hi[k] -= 2*Ci[k-j-1]; }
            B = Array(J-j);
            for(i=j+1;i<=J;i++) B[i-j-1] = Q[i];
            C = numeric.tensor(v,numeric.dot(v,B));
            for(i=j+1;i<=J;i++) { Qi = Q[i]; Ci = C[i-j-1]; for(k=0;k<m;k++) Qi[k] -= 2*Ci[k]; }
        }
    }
    throw new Error('numeric: eigenvalue iteration does not converge -- increase maxiter?');
}

numeric.eig = function eig(A,maxiter) {
    var QH = numeric.toUpperHessenberg(A);
    var QB = numeric.QRFrancis(QH.H,maxiter);
    var T = numeric.T;
    var n = A.length,i,k,flag = false,B = QB.B,H = numeric.dot(QB.Q,numeric.dot(QH.H,numeric.transpose(QB.Q)));
    var Q = new T(numeric.dot(QB.Q,QH.Q)),Q0;
    var m = B.length,j;
    var a,b,c,d,p1,p2,disc,x,y,p,q,n1,n2;
    var sqrt = Math.sqrt;
    for(k=0;k<m;k++) {
        i = B[k][0];
        if(i === B[k][1]) {
            // nothing
        } else {
            j = i+1;
            a = H[i][i];
            b = H[i][j];
            c = H[j][i];
            d = H[j][j];
            if(b === 0 && c === 0) continue;
            p1 = -a-d;
            p2 = a*d-b*c;
            disc = p1*p1-4*p2;
            if(disc>=0) {
                if(p1<0) x = -0.5*(p1-sqrt(disc));
                else     x = -0.5*(p1+sqrt(disc));
                n1 = (a-x)*(a-x)+b*b;
                n2 = c*c+(d-x)*(d-x);
                if(n1>n2) {
                    n1 = sqrt(n1);
                    p = (a-x)/n1;
                    q = b/n1;
                } else {
                    n2 = sqrt(n2);
                    p = c/n2;
                    q = (d-x)/n2;
                }
                Q0 = new T([[q,-p],[p,q]]);
                Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
            } else {
                x = -0.5*p1;
                y = 0.5*sqrt(-disc);
                n1 = (a-x)*(a-x)+b*b;
                n2 = c*c+(d-x)*(d-x);
                if(n1>n2) {
                    n1 = sqrt(n1+y*y);
                    p = (a-x)/n1;
                    q = b/n1;
                    x = 0;
                    y /= n1;
                } else {
                    n2 = sqrt(n2+y*y);
                    p = c/n2;
                    q = (d-x)/n2;
                    x = y/n2;
                    y = 0;
                }
                Q0 = new T([[q,-p],[p,q]],[[x,y],[y,-x]]);
                Q.setRows(i,j,Q0.dot(Q.getRows(i,j)));
            }
        }
    }
    var R = Q.dot(A).dot(Q.transjugate()), n = A.length, E = numeric.T.identity(n);
    for(j=0;j<n;j++) {
        if(j>0) {
            for(k=j-1;k>=0;k--) {
                var Rk = R.get([k,k]), Rj = R.get([j,j]);
                if(numeric.neq(Rk.x,Rj.x) || numeric.neq(Rk.y,Rj.y)) {
                    x = R.getRow(k).getBlock([k],[j-1]);
                    y = E.getRow(j).getBlock([k],[j-1]);
                    E.set([j,k],(R.get([k,j]).neg().sub(x.dot(y))).div(Rk.sub(Rj)));
                } else {
                    E.setRow(j,E.getRow(k));
                    continue;
                }
            }
        }
    }
    for(j=0;j<n;j++) {
        x = E.getRow(j);
        E.setRow(j,x.div(x.norm2()));
    }
    E = E.transpose();
    E = Q.transjugate().dot(E);
    return { lambda:R.getDiag(), E:E };
};

// 5. Compressed Column Storage matrices
numeric.ccsSparse = function ccsSparse(A) {
    var m = A.length,n,foo, i,j, counts = [];
    for(i=m-1;i!==-1;--i) {
        foo = A[i];
        for(j in foo) {
            j = parseInt(j);
            while(j>=counts.length) counts[counts.length] = 0;
            if(foo[j]!==0) counts[j]++;
        }
    }
    var n = counts.length;
    var Ai = Array(n+1);
    Ai[0] = 0;
    for(i=0;i<n;++i) Ai[i+1] = Ai[i] + counts[i];
    var Aj = Array(Ai[n]), Av = Array(Ai[n]);
    for(i=m-1;i!==-1;--i) {
        foo = A[i];
        for(j in foo) {
            if(foo[j]!==0) {
                counts[j]--;
                Aj[Ai[j]+counts[j]] = i;
                Av[Ai[j]+counts[j]] = foo[j];
            }
        }
    }
    return [Ai,Aj,Av];
}
numeric.ccsFull = function ccsFull(A) {
    var Ai = A[0], Aj = A[1], Av = A[2], s = numeric.ccsDim(A), m = s[0], n = s[1], i,j,j0,j1,k;
    var B = numeric.rep([m,n],0);
    for(i=0;i<n;i++) {
        j0 = Ai[i];
        j1 = Ai[i+1];
        for(j=j0;j<j1;++j) { B[Aj[j]][i] = Av[j]; }
    }
    return B;
}
numeric.ccsTSolve = function ccsTSolve(A,b,x,bj,xj) {
    var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, max = Math.max,n=0;
    if(typeof bj === "undefined") x = numeric.rep([m],0);
    if(typeof bj === "undefined") bj = numeric.linspace(0,x.length-1);
    if(typeof xj === "undefined") xj = [];
    function dfs(j) {
        var k;
        if(x[j] !== 0) return;
        x[j] = 1;
        for(k=Ai[j];k<Ai[j+1];++k) dfs(Aj[k]);
        xj[n] = j;
        ++n;
    }
    var i,j,j0,j1,k,l,l0,l1,a;
    for(i=bj.length-1;i!==-1;--i) { dfs(bj[i]); }
    xj.length = n;
    for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
    for(i=bj.length-1;i!==-1;--i) { j = bj[i]; x[j] = b[j]; }
    for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        j0 = Ai[j];
        j1 = max(Ai[j+1],j0);
        for(k=j0;k!==j1;++k) { if(Aj[k] === j) { x[j] /= Av[k]; break; } }
        a = x[j];
        for(k=j0;k!==j1;++k) {
            l = Aj[k];
            if(l !== j) x[l] -= a*Av[k];
        }
    }
    return x;
}
numeric.ccsDFS = function ccsDFS(n) {
    this.k = Array(n);
    this.k1 = Array(n);
    this.j = Array(n);
}
numeric.ccsDFS.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv) {
    var m = 0,foo,n=xj.length;
    var k = this.k, k1 = this.k1, j = this.j,km,k11;
    if(x[J]!==0) return;
    x[J] = 1;
    j[0] = J;
    k[0] = km = Ai[J];
    k1[0] = k11 = Ai[J+1];
    while(1) {
        if(km >= k11) {
            xj[n] = j[m];
            if(m===0) return;
            ++n;
            --m;
            km = k[m];
            k11 = k1[m];
        } else {
            foo = Pinv[Aj[km]];
            if(x[foo] === 0) {
                x[foo] = 1;
                k[m] = km;
                ++m;
                j[m] = foo;
                km = Ai[foo];
                k1[m] = k11 = Ai[foo+1];
            } else ++km;
        }
    }
}
numeric.ccsLPSolve = function ccsLPSolve(A,B,x,xj,I,Pinv,dfs) {
    var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, n=0;
    var Bi = B[0], Bj = B[1], Bv = B[2];
    
    var i,i0,i1,j,J,j0,j1,k,l,l0,l1,a;
    i0 = Bi[I];
    i1 = Bi[I+1];
    xj.length = 0;
    for(i=i0;i<i1;++i) { dfs.dfs(Pinv[Bj[i]],Ai,Aj,x,xj,Pinv); }
    for(i=xj.length-1;i!==-1;--i) { x[xj[i]] = 0; }
    for(i=i0;i!==i1;++i) { j = Pinv[Bj[i]]; x[j] = Bv[i]; }
    for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        j0 = Ai[j];
        j1 = Ai[j+1];
        for(k=j0;k<j1;++k) { if(Pinv[Aj[k]] === j) { x[j] /= Av[k]; break; } }
        a = x[j];
        for(k=j0;k<j1;++k) {
            l = Pinv[Aj[k]];
            if(l !== j) x[l] -= a*Av[k];
        }
    }
    return x;
}
numeric.ccsLUP1 = function ccsLUP1(A,threshold) {
    var m = A[0].length-1;
    var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
    var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
    var x = numeric.rep([m],0), xj = numeric.rep([m],0);
    var i,j,k,j0,j1,a,e,c,d,K;
    var sol = numeric.ccsLPSolve, max = Math.max, abs = Math.abs;
    var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
    var dfs = new numeric.ccsDFS(m);
    if(typeof threshold === "undefined") { threshold = 1; }
    for(i=0;i<m;++i) {
        sol(L,A,x,xj,i,Pinv,dfs);
        a = -1;
        e = -1;
        for(j=xj.length-1;j!==-1;--j) {
            k = xj[j];
            if(k <= i) continue;
            c = abs(x[k]);
            if(c > a) { e = k; a = c; }
        }
        if(abs(x[i])<threshold*a) {
            j = P[i];
            a = P[e];
            P[i] = a; Pinv[a] = i;
            P[e] = j; Pinv[j] = e;
            a = x[i]; x[i] = x[e]; x[e] = a;
        }
        a = Li[i];
        e = Ui[i];
        d = x[i];
        Lj[a] = P[i];
        Lv[a] = 1;
        ++a;
        for(j=xj.length-1;j!==-1;--j) {
            k = xj[j];
            c = x[k];
            xj[j] = 0;
            x[k] = 0;
            if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
            else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
        }
        Li[i+1] = a;
        Ui[i+1] = e;
    }
    for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
    return {L:L, U:U, P:P, Pinv:Pinv};
}
numeric.ccsDFS0 = function ccsDFS0(n) {
    this.k = Array(n);
    this.k1 = Array(n);
    this.j = Array(n);
}
numeric.ccsDFS0.prototype.dfs = function dfs(J,Ai,Aj,x,xj,Pinv,P) {
    var m = 0,foo,n=xj.length;
    var k = this.k, k1 = this.k1, j = this.j,km,k11;
    if(x[J]!==0) return;
    x[J] = 1;
    j[0] = J;
    k[0] = km = Ai[Pinv[J]];
    k1[0] = k11 = Ai[Pinv[J]+1];
    while(1) {
        if(isNaN(km)) throw new Error("Ow!");
        if(km >= k11) {
            xj[n] = Pinv[j[m]];
            if(m===0) return;
            ++n;
            --m;
            km = k[m];
            k11 = k1[m];
        } else {
            foo = Aj[km];
            if(x[foo] === 0) {
                x[foo] = 1;
                k[m] = km;
                ++m;
                j[m] = foo;
                foo = Pinv[foo];
                km = Ai[foo];
                k1[m] = k11 = Ai[foo+1];
            } else ++km;
        }
    }
}
numeric.ccsLPSolve0 = function ccsLPSolve0(A,B,y,xj,I,Pinv,P,dfs) {
    var Ai = A[0], Aj = A[1], Av = A[2],m = Ai.length-1, n=0;
    var Bi = B[0], Bj = B[1], Bv = B[2];
    
    var i,i0,i1,j,J,j0,j1,k,l,l0,l1,a;
    i0 = Bi[I];
    i1 = Bi[I+1];
    xj.length = 0;
    for(i=i0;i<i1;++i) { dfs.dfs(Bj[i],Ai,Aj,y,xj,Pinv,P); }
    for(i=xj.length-1;i!==-1;--i) { j = xj[i]; y[P[j]] = 0; }
    for(i=i0;i!==i1;++i) { j = Bj[i]; y[j] = Bv[i]; }
    for(i=xj.length-1;i!==-1;--i) {
        j = xj[i];
        l = P[j];
        j0 = Ai[j];
        j1 = Ai[j+1];
        for(k=j0;k<j1;++k) { if(Aj[k] === l) { y[l] /= Av[k]; break; } }
        a = y[l];
        for(k=j0;k<j1;++k) y[Aj[k]] -= a*Av[k];
        y[l] = a;
    }
}
numeric.ccsLUP0 = function ccsLUP0(A,threshold) {
    var m = A[0].length-1;
    var L = [numeric.rep([m+1],0),[],[]], U = [numeric.rep([m+1], 0),[],[]];
    var Li = L[0], Lj = L[1], Lv = L[2], Ui = U[0], Uj = U[1], Uv = U[2];
    var y = numeric.rep([m],0), xj = numeric.rep([m],0);
    var i,j,k,j0,j1,a,e,c,d,K;
    var sol = numeric.ccsLPSolve0, max = Math.max, abs = Math.abs;
    var P = numeric.linspace(0,m-1),Pinv = numeric.linspace(0,m-1);
    var dfs = new numeric.ccsDFS0(m);
    if(typeof threshold === "undefined") { threshold = 1; }
    for(i=0;i<m;++i) {
        sol(L,A,y,xj,i,Pinv,P,dfs);
        a = -1;
        e = -1;
        for(j=xj.length-1;j!==-1;--j) {
            k = xj[j];
            if(k <= i) continue;
            c = abs(y[P[k]]);
            if(c > a) { e = k; a = c; }
        }
        if(abs(y[P[i]])<threshold*a) {
            j = P[i];
            a = P[e];
            P[i] = a; Pinv[a] = i;
            P[e] = j; Pinv[j] = e;
        }
        a = Li[i];
        e = Ui[i];
        d = y[P[i]];
        Lj[a] = P[i];
        Lv[a] = 1;
        ++a;
        for(j=xj.length-1;j!==-1;--j) {
            k = xj[j];
            c = y[P[k]];
            xj[j] = 0;
            y[P[k]] = 0;
            if(k<=i) { Uj[e] = k; Uv[e] = c;   ++e; }
            else     { Lj[a] = P[k]; Lv[a] = c/d; ++a; }
        }
        Li[i+1] = a;
        Ui[i+1] = e;
    }
    for(j=Lj.length-1;j!==-1;--j) { Lj[j] = Pinv[Lj[j]]; }
    return {L:L, U:U, P:P, Pinv:Pinv};
}
numeric.ccsLUP = numeric.ccsLUP0;

numeric.ccsDim = function ccsDim(A) { return [numeric.sup(A[1])+1,A[0].length-1]; }
numeric.ccsGetBlock = function ccsGetBlock(A,i,j) {
    var s = numeric.ccsDim(A),m=s[0],n=s[1];
    if(typeof i === "undefined") { i = numeric.linspace(0,m-1); }
    else if(typeof i === "number") { i = [i]; }
    if(typeof j === "undefined") { j = numeric.linspace(0,n-1); }
    else if(typeof j === "number") { j = [j]; }
    var p,p0,p1,P = i.length,q,Q = j.length,r,jq,ip;
    var Bi = numeric.rep([n],0), Bj=[], Bv=[], B = [Bi,Bj,Bv];
    var Ai = A[0], Aj = A[1], Av = A[2];
    var x = numeric.rep([m],0),count=0,flags = numeric.rep([m],0);
    for(q=0;q<Q;++q) {
        jq = j[q];
        var q0 = Ai[jq];
        var q1 = Ai[jq+1];
        for(p=q0;p<q1;++p) {
            r = Aj[p];
            flags[r] = 1;
            x[r] = Av[p];
        }
        for(p=0;p<P;++p) {
            ip = i[p];
            if(flags[ip]) {
                Bj[count] = p;
                Bv[count] = x[i[p]];
                ++count;
            }
        }
        for(p=q0;p<q1;++p) {
            r = Aj[p];
            flags[r] = 0;
        }
        Bi[q+1] = count;
    }
    return B;
}

numeric.ccsDot = function ccsDot(A,B) {
    var Ai = A[0], Aj = A[1], Av = A[2];
    var Bi = B[0], Bj = B[1], Bv = B[2];
    var sA = numeric.ccsDim(A), sB = numeric.ccsDim(B);
    var m = sA[0], n = sA[1], o = sB[1];
    var x = numeric.rep([m],0), flags = numeric.rep([m],0), xj = Array(m);
    var Ci = numeric.rep([o],0), Cj = [], Cv = [], C = [Ci,Cj,Cv];
    var i,j,k,j0,j1,i0,i1,l,p,a,b;
    for(k=0;k!==o;++k) {
        j0 = Bi[k];
        j1 = Bi[k+1];
        p = 0;
        for(j=j0;j<j1;++j) {
            a = Bj[j];
            b = Bv[j];
            i0 = Ai[a];
            i1 = Ai[a+1];
            for(i=i0;i<i1;++i) {
                l = Aj[i];
                if(flags[l]===0) {
                    xj[p] = l;
                    flags[l] = 1;
                    p = p+1;
                }
                x[l] = x[l] + Av[i]*b;
            }
        }
        j0 = Ci[k];
        j1 = j0+p;
        Ci[k+1] = j1;
        for(j=p-1;j!==-1;--j) {
            b = j0+j;
            i = xj[j];
            Cj[b] = i;
            Cv[b] = x[i];
            flags[i] = 0;
            x[i] = 0;
        }
        Ci[k+1] = Ci[k]+p;
    }
    return C;
}

numeric.ccsLUPSolve = function ccsLUPSolve(LUP,B) {
    var L = LUP.L, U = LUP.U, P = LUP.P;
    var Bi = B[0];
    var flag = false;
    if(typeof Bi !== "object") { B = [[0,B.length],numeric.linspace(0,B.length-1),B]; Bi = B[0]; flag = true; }
    var Bj = B[1], Bv = B[2];
    var n = L[0].length-1, m = Bi.length-1;
    var x = numeric.rep([n],0), xj = Array(n);
    var b = numeric.rep([n],0), bj = Array(n);
    var Xi = numeric.rep([m+1],0), Xj = [], Xv = [];
    var sol = numeric.ccsTSolve;
    var i,j,j0,j1,k,J,N=0;
    for(i=0;i<m;++i) {
        k = 0;
        j0 = Bi[i];
        j1 = Bi[i+1];
        for(j=j0;j<j1;++j) { 
            J = LUP.Pinv[Bj[j]];
            bj[k] = J;
            b[J] = Bv[j];
            ++k;
        }
        bj.length = k;
        sol(L,b,x,bj,xj);
        for(j=bj.length-1;j!==-1;--j) b[bj[j]] = 0;
        sol(U,x,b,xj,bj);
        if(flag) return b;
        for(j=xj.length-1;j!==-1;--j) x[xj[j]] = 0;
        for(j=bj.length-1;j!==-1;--j) {
            J = bj[j];
            Xj[N] = J;
            Xv[N] = b[J];
            b[J] = 0;
            ++N;
        }
        Xi[i+1] = N;
    }
    return [Xi,Xj,Xv];
}

numeric.ccsbinop = function ccsbinop(body,setup) {
    if(typeof setup === "undefined") setup='';
    return Function('X','Y',
            'var Xi = X[0], Xj = X[1], Xv = X[2];\n'+
            'var Yi = Y[0], Yj = Y[1], Yv = Y[2];\n'+
            'var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\n'+
            'var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\n'+
            'var x = numeric.rep([m],0),y = numeric.rep([m],0);\n'+
            'var xk,yk,zk;\n'+
            'var i,j,j0,j1,k,p=0;\n'+
            setup+
            'for(i=0;i<n;++i) {\n'+
            '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) {\n'+
            '    k = Xj[j];\n'+
            '    x[k] = 1;\n'+
            '    Zj[p] = k;\n'+
            '    ++p;\n'+
            '  }\n'+
            '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) {\n'+
            '    k = Yj[j];\n'+
            '    y[k] = Yv[j];\n'+
            '    if(x[k] === 0) {\n'+
            '      Zj[p] = k;\n'+
            '      ++p;\n'+
            '    }\n'+
            '  }\n'+
            '  Zi[i+1] = p;\n'+
            '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n'+
            '  j0 = Zi[i]; j1 = Zi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) {\n'+
            '    k = Zj[j];\n'+
            '    xk = x[k];\n'+
            '    yk = y[k];\n'+
            body+'\n'+
            '    Zv[j] = zk;\n'+
            '  }\n'+
            '  j0 = Xi[i]; j1 = Xi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n'+
            '  j0 = Yi[i]; j1 = Yi[i+1];\n'+
            '  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n'+
            '}\n'+
            'return [Zi,Zj,Zv];'
            );
};

(function() {
    var k,A,B,C;
    for(k in numeric.ops2) {
        if(isFinite(eval('1'+numeric.ops2[k]+'0'))) A = '[Y[0],Y[1],numeric.'+k+'(X,Y[2])]';
        else A = 'NaN';
        if(isFinite(eval('0'+numeric.ops2[k]+'1'))) B = '[X[0],X[1],numeric.'+k+'(X[2],Y)]';
        else B = 'NaN';
        if(isFinite(eval('1'+numeric.ops2[k]+'0')) && isFinite(eval('0'+numeric.ops2[k]+'1'))) C = 'numeric.ccs'+k+'MM(X,Y)';
        else C = 'NaN';
        numeric['ccs'+k+'MM'] = numeric.ccsbinop('zk = xk '+numeric.ops2[k]+'yk;');
        numeric['ccs'+k] = Function('X','Y',
                'if(typeof X === "number") return '+A+';\n'+
                'if(typeof Y === "number") return '+B+';\n'+
                'return '+C+';\n'
                );
    }
}());

numeric.ccsScatter = function ccsScatter(A) {
    var Ai = A[0], Aj = A[1], Av = A[2];
    var n = numeric.sup(Aj)+1,m=Ai.length;
    var Ri = numeric.rep([n],0),Rj=Array(m), Rv = Array(m);
    var counts = numeric.rep([n],0),i;
    for(i=0;i<m;++i) counts[Aj[i]]++;
    for(i=0;i<n;++i) Ri[i+1] = Ri[i] + counts[i];
    var ptr = Ri.slice(0),k,Aii;
    for(i=0;i<m;++i) {
        Aii = Aj[i];
        k = ptr[Aii];
        Rj[k] = Ai[i];
        Rv[k] = Av[i];
        ptr[Aii]=ptr[Aii]+1;
    }
    return [Ri,Rj,Rv];
}

numeric.ccsGather = function ccsGather(A) {
    var Ai = A[0], Aj = A[1], Av = A[2];
    var n = Ai.length-1,m = Aj.length;
    var Ri = Array(m), Rj = Array(m), Rv = Array(m);
    var i,j,j0,j1,p;
    p=0;
    for(i=0;i<n;++i) {
        j0 = Ai[i];
        j1 = Ai[i+1];
        for(j=j0;j!==j1;++j) {
            Rj[p] = i;
            Ri[p] = Aj[j];
            Rv[p] = Av[j];
            ++p;
        }
    }
    return [Ri,Rj,Rv];
}

// The following sparse linear algebra routines are deprecated.

numeric.sdim = function dim(A,ret,k) {
    if(typeof ret === "undefined") { ret = []; }
    if(typeof A !== "object") return ret;
    if(typeof k === "undefined") { k=0; }
    if(!(k in ret)) { ret[k] = 0; }
    if(A.length > ret[k]) ret[k] = A.length;
    var i;
    for(i in A) {
        if(A.hasOwnProperty(i)) dim(A[i],ret,k+1);
    }
    return ret;
};

numeric.sclone = function clone(A,k,n) {
    if(typeof k === "undefined") { k=0; }
    if(typeof n === "undefined") { n = numeric.sdim(A).length; }
    var i,ret = Array(A.length);
    if(k === n-1) {
        for(i in A) { if(A.hasOwnProperty(i)) ret[i] = A[i]; }
        return ret;
    }
    for(i in A) {
        if(A.hasOwnProperty(i)) ret[i] = clone(A[i],k+1,n);
    }
    return ret;
}

numeric.sdiag = function diag(d) {
    var n = d.length,i,ret = Array(n),i1,i2,i3;
    for(i=n-1;i>=1;i-=2) {
        i1 = i-1;
        ret[i] = []; ret[i][i] = d[i];
        ret[i1] = []; ret[i1][i1] = d[i1];
    }
    if(i===0) { ret[0] = []; ret[0][0] = d[i]; }
    return ret;
}

numeric.sidentity = function identity(n) { return numeric.sdiag(numeric.rep([n],1)); }

numeric.stranspose = function transpose(A) {
    var ret = [], n = A.length, i,j,Ai;
    for(i in A) {
        if(!(A.hasOwnProperty(i))) continue;
        Ai = A[i];
        for(j in Ai) {
            if(!(Ai.hasOwnProperty(j))) continue;
            if(typeof ret[j] !== "object") { ret[j] = []; }
            ret[j][i] = Ai[j];
        }
    }
    return ret;
}

numeric.sLUP = function LUP(A,tol) {
    throw new Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.");
};

numeric.sdotMM = function dotMM(A,B) {
    var p = A.length, q = B.length, BT = numeric.stranspose(B), r = BT.length, Ai, BTk;
    var i,j,k,accum;
    var ret = Array(p),reti;
    for(i=p-1;i>=0;i--) {
        reti = [];
        Ai = A[i];
        for(k=r-1;k>=0;k--) {
            accum = 0;
            BTk = BT[k];
            for(j in Ai) {
                if(!(Ai.hasOwnProperty(j))) continue;
                if(j in BTk) { accum += Ai[j]*BTk[j]; }
            }
            if(accum) reti[k] = accum;
        }
        ret[i] = reti;
    }
    return ret;
}

numeric.sdotMV = function dotMV(A,x) {
    var p = A.length, Ai, i,j;
    var ret = Array(p), accum;
    for(i=p-1;i>=0;i--) {
        Ai = A[i];
        accum = 0;
        for(j in Ai) {
            if(!(Ai.hasOwnProperty(j))) continue;
            if(x[j]) accum += Ai[j]*x[j];
        }
        if(accum) ret[i] = accum;
    }
    return ret;
}

numeric.sdotVM = function dotMV(x,A) {
    var i,j,Ai,alpha;
    var ret = [], accum;
    for(i in x) {
        if(!x.hasOwnProperty(i)) continue;
        Ai = A[i];
        alpha = x[i];
        for(j in Ai) {
            if(!Ai.hasOwnProperty(j)) continue;
            if(!ret[j]) { ret[j] = 0; }
            ret[j] += alpha*Ai[j];
        }
    }
    return ret;
}

numeric.sdotVV = function dotVV(x,y) {
    var i,ret=0;
    for(i in x) { if(x[i] && y[i]) ret+= x[i]*y[i]; }
    return ret;
}

numeric.sdot = function dot(A,B) {
    var m = numeric.sdim(A).length, n = numeric.sdim(B).length;
    var k = m*1000+n;
    switch(k) {
    case 0: return A*B;
    case 1001: return numeric.sdotVV(A,B);
    case 2001: return numeric.sdotMV(A,B);
    case 1002: return numeric.sdotVM(A,B);
    case 2002: return numeric.sdotMM(A,B);
    default: throw new Error('numeric.sdot not implemented for tensors of order '+m+' and '+n);
    }
}

numeric.sscatter = function scatter(V) {
    var n = V[0].length, Vij, i, j, m = V.length, A = [], Aj;
    for(i=n-1;i>=0;--i) {
        if(!V[m-1][i]) continue;
        Aj = A;
        for(j=0;j<m-2;j++) {
            Vij = V[j][i];
            if(!Aj[Vij]) Aj[Vij] = [];
            Aj = Aj[Vij];
        }
        Aj[V[j][i]] = V[j+1][i];
    }
    return A;
}

numeric.sgather = function gather(A,ret,k) {
    if(typeof ret === "undefined") ret = [];
    if(typeof k === "undefined") k = [];
    var n,i,Ai;
    n = k.length;
    for(i in A) {
        if(A.hasOwnProperty(i)) {
            k[n] = parseInt(i);
            Ai = A[i];
            if(typeof Ai === "number") {
                if(Ai) {
                    if(ret.length === 0) {
                        for(i=n+1;i>=0;--i) ret[i] = [];
                    }
                    for(i=n;i>=0;--i) ret[i].push(k[i]);
                    ret[n+1].push(Ai);
                }
            } else gather(Ai,ret,k);
        }
    }
    if(k.length>n) k.pop();
    return ret;
}

// 6. Coordinate matrices
numeric.cLU = function LU(A) {
    var I = A[0], J = A[1], V = A[2];
    var p = I.length, m=0, i,j,k,a,b,c;
    for(i=0;i<p;i++) if(I[i]>m) m=I[i];
    m++;
    var L = Array(m), U = Array(m), left = numeric.rep([m],Infinity), right = numeric.rep([m],-Infinity);
    var Ui, Uj,alpha;
    for(k=0;k<p;k++) {
        i = I[k];
        j = J[k];
        if(j<left[i]) left[i] = j;
        if(j>right[i]) right[i] = j;
    }
    for(i=0;i<m-1;i++) { if(right[i] > right[i+1]) right[i+1] = right[i]; }
    for(i=m-1;i>=1;i--) { if(left[i]<left[i-1]) left[i-1] = left[i]; }
    var countL = 0, countU = 0;
    for(i=0;i<m;i++) {
        U[i] = numeric.rep([right[i]-left[i]+1],0);
        L[i] = numeric.rep([i-left[i]],0);
        countL += i-left[i]+1;
        countU += right[i]-i+1;
    }
    for(k=0;k<p;k++) { i = I[k]; U[i][J[k]-left[i]] = V[k]; }
    for(i=0;i<m-1;i++) {
        a = i-left[i];
        Ui = U[i];
        for(j=i+1;left[j]<=i && j<m;j++) {
            b = i-left[j];
            c = right[i]-i;
            Uj = U[j];
            alpha = Uj[b]/Ui[a];
            if(alpha) {
                for(k=1;k<=c;k++) { Uj[k+b] -= alpha*Ui[k+a]; }
                L[j][i-left[j]] = alpha;
            }
        }
    }
    var Ui = [], Uj = [], Uv = [], Li = [], Lj = [], Lv = [];
    var p,q,foo;
    p=0; q=0;
    for(i=0;i<m;i++) {
        a = left[i];
        b = right[i];
        foo = U[i];
        for(j=i;j<=b;j++) {
            if(foo[j-a]) {
                Ui[p] = i;
                Uj[p] = j;
                Uv[p] = foo[j-a];
                p++;
            }
        }
        foo = L[i];
        for(j=a;j<i;j++) {
            if(foo[j-a]) {
                Li[q] = i;
                Lj[q] = j;
                Lv[q] = foo[j-a];
                q++;
            }
        }
        Li[q] = i;
        Lj[q] = i;
        Lv[q] = 1;
        q++;
    }
    return {U:[Ui,Uj,Uv], L:[Li,Lj,Lv]};
};

numeric.cLUsolve = function LUsolve(lu,b) {
    var L = lu.L, U = lu.U, ret = numeric.clone(b);
    var Li = L[0], Lj = L[1], Lv = L[2];
    var Ui = U[0], Uj = U[1], Uv = U[2];
    var p = Ui.length, q = Li.length;
    var m = ret.length,i,j,k;
    k = 0;
    for(i=0;i<m;i++) {
        while(Lj[k] < i) {
            ret[i] -= Lv[k]*ret[Lj[k]];
            k++;
        }
        k++;
    }
    k = p-1;
    for(i=m-1;i>=0;i--) {
        while(Uj[k] > i) {
            ret[i] -= Uv[k]*ret[Uj[k]];
            k--;
        }
        ret[i] /= Uv[k];
        k--;
    }
    return ret;
};

numeric.cgrid = function grid(n,shape) {
    if(typeof n === "number") n = [n,n];
    var ret = numeric.rep(n,-1);
    var i,j,count;
    if(typeof shape !== "function") {
        switch(shape) {
        case 'L':
            shape = function(i,j) { return (i>=n[0]/2 || j<n[1]/2); }
            break;
        default:
            shape = function(i,j) { return true; };
            break;
        }
    }
    count=0;
    for(i=1;i<n[0]-1;i++) for(j=1;j<n[1]-1;j++) 
        if(shape(i,j)) {
            ret[i][j] = count;
            count++;
        }
    return ret;
}

numeric.cdelsq = function delsq(g) {
    var dir = [[-1,0],[0,-1],[0,1],[1,0]];
    var s = numeric.dim(g), m = s[0], n = s[1], i,j,k,p,q;
    var Li = [], Lj = [], Lv = [];
    for(i=1;i<m-1;i++) for(j=1;j<n-1;j++) {
        if(g[i][j]<0) continue;
        for(k=0;k<4;k++) {
            p = i+dir[k][0];
            q = j+dir[k][1];
            if(g[p][q]<0) continue;
            Li.push(g[i][j]);
            Lj.push(g[p][q]);
            Lv.push(-1);
        }
        Li.push(g[i][j]);
        Lj.push(g[i][j]);
        Lv.push(4);
    }
    return [Li,Lj,Lv];
}

numeric.cdotMV = function dotMV(A,x) {
    var ret, Ai = A[0], Aj = A[1], Av = A[2],k,p=Ai.length,N;
    N=0;
    for(k=0;k<p;k++) { if(Ai[k]>N) N = Ai[k]; }
    N++;
    ret = numeric.rep([N],0);
    for(k=0;k<p;k++) { ret[Ai[k]]+=Av[k]*x[Aj[k]]; }
    return ret;
}

// 7. Splines

numeric.Spline = function Spline(x,yl,yr,kl,kr) { this.x = x; this.yl = yl; this.yr = yr; this.kl = kl; this.kr = kr; }
numeric.Spline.prototype._at = function _at(x1,p) {
    var x = this.x;
    var yl = this.yl;
    var yr = this.yr;
    var kl = this.kl;
    var kr = this.kr;
    var x1,a,b,t;
    var add = numeric.add, sub = numeric.sub, mul = numeric.mul;
    a = sub(mul(kl[p],x[p+1]-x[p]),sub(yr[p+1],yl[p]));
    b = add(mul(kr[p+1],x[p]-x[p+1]),sub(yr[p+1],yl[p]));
    t = (x1-x[p])/(x[p+1]-x[p]);
    var s = t*(1-t);
    return add(add(add(mul(1-t,yl[p]),mul(t,yr[p+1])),mul(a,s*(1-t))),mul(b,s*t));
}
numeric.Spline.prototype.at = function at(x0) {
    if(typeof x0 === "number") {
        var x = this.x;
        var n = x.length;
        var p,q,mid,floor = Math.floor,a,b,t;
        p = 0;
        q = n-1;
        while(q-p>1) {
            mid = floor((p+q)/2);
            if(x[mid] <= x0) p = mid;
            else q = mid;
        }
        return this._at(x0,p);
    }
    var n = x0.length, i, ret = Array(n);
    for(i=n-1;i!==-1;--i) ret[i] = this.at(x0[i]);
    return ret;
}
numeric.Spline.prototype.diff = function diff() {
    var x = this.x;
    var yl = this.yl;
    var yr = this.yr;
    var kl = this.kl;
    var kr = this.kr;
    var n = yl.length;
    var i,dx,dy;
    var zl = kl, zr = kr, pl = Array(n), pr = Array(n);
    var add = numeric.add, mul = numeric.mul, div = numeric.div, sub = numeric.sub;
    for(i=n-1;i!==-1;--i) {
        dx = x[i+1]-x[i];
        dy = sub(yr[i+1],yl[i]);
        pl[i] = div(add(mul(dy, 6),mul(kl[i],-4*dx),mul(kr[i+1],-2*dx)),dx*dx);
        pr[i+1] = div(add(mul(dy,-6),mul(kl[i], 2*dx),mul(kr[i+1], 4*dx)),dx*dx);
    }
    return new numeric.Spline(x,zl,zr,pl,pr);
}
numeric.Spline.prototype.roots = function roots() {
    function sqr(x) { return x*x; }
    function heval(y0,y1,k0,k1,x) {
        var A = k0*2-(y1-y0);
        var B = -k1*2+(y1-y0);
        var t = (x+1)*0.5;
        var s = t*(1-t);
        return (1-t)*y0+t*y1+A*s*(1-t)+B*s*t;
    }
    var ret = [];
    var x = this.x, yl = this.yl, yr = this.yr, kl = this.kl, kr = this.kr;
    if(typeof yl[0] === "number") {
        yl = [yl];
        yr = [yr];
        kl = [kl];
        kr = [kr];
    }
    var m = yl.length,n=x.length-1,i,j,k,y,s,t;
    var ai,bi,ci,di, ret = Array(m),ri,k0,k1,y0,y1,A,B,D,dx,cx,stops,z0,z1,zm,t0,t1,tm;
    var sqrt = Math.sqrt;
    for(i=0;i!==m;++i) {
        ai = yl[i];
        bi = yr[i];
        ci = kl[i];
        di = kr[i];
        ri = [];
        for(j=0;j!==n;j++) {
            if(j>0 && bi[j]*ai[j]<0) ri.push(x[j]);
            dx = (x[j+1]-x[j]);
            cx = x[j];
            y0 = ai[j];
            y1 = bi[j+1];
            k0 = ci[j]/dx;
            k1 = di[j+1]/dx;
            D = sqr(k0-k1+3*(y0-y1)) + 12*k1*y0;
            A = k1+3*y0+2*k0-3*y1;
            B = 3*(k1+k0+2*(y0-y1));
            if(D<=0) {
                z0 = A/B;
                if(z0>x[j] && z0<x[j+1]) stops = [x[j],z0,x[j+1]];
                else stops = [x[j],x[j+1]];
            } else {
                z0 = (A-sqrt(D))/B;
                z1 = (A+sqrt(D))/B;
                stops = [x[j]];
                if(z0>x[j] && z0<x[j+1]) stops.push(z0);
                if(z1>x[j] && z1<x[j+1]) stops.push(z1);
                stops.push(x[j+1]);
            }
            t0 = stops[0];
            z0 = this._at(t0,j);
            for(k=0;k<stops.length-1;k++) {
                t1 = stops[k+1];
                z1 = this._at(t1,j);
                if(z0 === 0) {
                    ri.push(t0); 
                    t0 = t1;
                    z0 = z1;
                    continue;
                }
                if(z1 === 0 || z0*z1>0) {
                    t0 = t1;
                    z0 = z1;
                    continue;
                }
                var side = 0;
                while(1) {
                    tm = (z0*t1-z1*t0)/(z0-z1);
                    if(tm <= t0 || tm >= t1) { break; }
                    zm = this._at(tm,j);
                    if(zm*z1>0) {
                        t1 = tm;
                        z1 = zm;
                        if(side === -1) z0*=0.5;
                        side = -1;
                    } else if(zm*z0>0) {
                        t0 = tm;
                        z0 = zm;
                        if(side === 1) z1*=0.5;
                        side = 1;
                    } else break;
                }
                ri.push(tm);
                t0 = stops[k+1];
                z0 = this._at(t0, j);
            }
            if(z1 === 0) ri.push(t1);
        }
        ret[i] = ri;
    }
    if(typeof this.yl[0] === "number") return ret[0];
    return ret;
}
numeric.spline = function spline(x,y,k1,kn) {
    var n = x.length, b = [], dx = [], dy = [];
    var i;
    var sub = numeric.sub,mul = numeric.mul,add = numeric.add;
    for(i=n-2;i>=0;i--) { dx[i] = x[i+1]-x[i]; dy[i] = sub(y[i+1],y[i]); }
    if(typeof k1 === "string" || typeof kn === "string") { 
        k1 = kn = "periodic";
    }
    // Build sparse tridiagonal system
    var T = [[],[],[]];
    switch(typeof k1) {
    case "undefined":
        b[0] = mul(3/(dx[0]*dx[0]),dy[0]);
        T[0].push(0,0);
        T[1].push(0,1);
        T[2].push(2/dx[0],1/dx[0]);
        break;
    case "string":
        b[0] = add(mul(3/(dx[n-2]*dx[n-2]),dy[n-2]),mul(3/(dx[0]*dx[0]),dy[0]));
        T[0].push(0,0,0);
        T[1].push(n-2,0,1);
        T[2].push(1/dx[n-2],2/dx[n-2]+2/dx[0],1/dx[0]);
        break;
    default:
        b[0] = k1;
        T[0].push(0);
        T[1].push(0);
        T[2].push(1);
        break;
    }
    for(i=1;i<n-1;i++) {
        b[i] = add(mul(3/(dx[i-1]*dx[i-1]),dy[i-1]),mul(3/(dx[i]*dx[i]),dy[i]));
        T[0].push(i,i,i);
        T[1].push(i-1,i,i+1);
        T[2].push(1/dx[i-1],2/dx[i-1]+2/dx[i],1/dx[i]);
    }
    switch(typeof kn) {
    case "undefined":
        b[n-1] = mul(3/(dx[n-2]*dx[n-2]),dy[n-2]);
        T[0].push(n-1,n-1);
        T[1].push(n-2,n-1);
        T[2].push(1/dx[n-2],2/dx[n-2]);
        break;
    case "string":
        T[1][T[1].length-1] = 0;
        break;
    default:
        b[n-1] = kn;
        T[0].push(n-1);
        T[1].push(n-1);
        T[2].push(1);
        break;
    }
    if(typeof b[0] !== "number") b = numeric.transpose(b);
    else b = [b];
    var k = Array(b.length);
    if(typeof k1 === "string") {
        for(i=k.length-1;i!==-1;--i) {
            k[i] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(T)),b[i]);
            k[i][n-1] = k[i][0];
        }
    } else {
        for(i=k.length-1;i!==-1;--i) {
            k[i] = numeric.cLUsolve(numeric.cLU(T),b[i]);
        }
    }
    if(typeof y[0] === "number") k = k[0];
    else k = numeric.transpose(k);
    return new numeric.Spline(x,y,y,k,k);
}

// 8. FFT
numeric.fftpow2 = function fftpow2(x,y) {
    var n = x.length;
    if(n === 1) return;
    var cos = Math.cos, sin = Math.sin, i,j;
    var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
    j = n/2;
    for(i=n-1;i!==-1;--i) {
        --j;
        xo[j] = x[i];
        yo[j] = y[i];
        --i;
        xe[j] = x[i];
        ye[j] = y[i];
    }
    fftpow2(xe,ye);
    fftpow2(xo,yo);
    j = n/2;
    var t,k = (-6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
    for(i=n-1;i!==-1;--i) {
        --j;
        if(j === -1) j = n/2-1;
        t = k*i;
        ci = cos(t);
        si = sin(t);
        x[i] = xe[j] + ci*xo[j] - si*yo[j];
        y[i] = ye[j] + ci*yo[j] + si*xo[j];
    }
}
numeric._ifftpow2 = function _ifftpow2(x,y) {
    var n = x.length;
    if(n === 1) return;
    var cos = Math.cos, sin = Math.sin, i,j;
    var xe = Array(n/2), ye = Array(n/2), xo = Array(n/2), yo = Array(n/2);
    j = n/2;
    for(i=n-1;i!==-1;--i) {
        --j;
        xo[j] = x[i];
        yo[j] = y[i];
        --i;
        xe[j] = x[i];
        ye[j] = y[i];
    }
    _ifftpow2(xe,ye);
    _ifftpow2(xo,yo);
    j = n/2;
    var t,k = (6.2831853071795864769252867665590057683943387987502116419/n),ci,si;
    for(i=n-1;i!==-1;--i) {
        --j;
        if(j === -1) j = n/2-1;
        t = k*i;
        ci = cos(t);
        si = sin(t);
        x[i] = xe[j] + ci*xo[j] - si*yo[j];
        y[i] = ye[j] + ci*yo[j] + si*xo[j];
    }
}
numeric.ifftpow2 = function ifftpow2(x,y) {
    numeric._ifftpow2(x,y);
    numeric.diveq(x,x.length);
    numeric.diveq(y,y.length);
}
numeric.convpow2 = function convpow2(ax,ay,bx,by) {
    numeric.fftpow2(ax,ay);
    numeric.fftpow2(bx,by);
    var i,n = ax.length,axi,bxi,ayi,byi;
    for(i=n-1;i!==-1;--i) {
        axi = ax[i]; ayi = ay[i]; bxi = bx[i]; byi = by[i];
        ax[i] = axi*bxi-ayi*byi;
        ay[i] = axi*byi+ayi*bxi;
    }
    numeric.ifftpow2(ax,ay);
}
numeric.T.prototype.fft = function fft() {
    var x = this.x, y = this.y;
    var n = x.length, log = Math.log, log2 = log(2),
        p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
    var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
    var k, c = (-3.141592653589793238462643383279502884197169399375105820/n),t;
    var a = numeric.rep([m],0), b = numeric.rep([m],0),nhalf = Math.floor(n/2);
    for(k=0;k<n;k++) a[k] = x[k];
    if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
    cx[0] = 1;
    for(k=1;k<=m/2;k++) {
        t = c*k*k;
        cx[k] = cos(t);
        cy[k] = sin(t);
        cx[m-k] = cos(t);
        cy[m-k] = sin(t)
    }
    var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
    X = X.mul(Y);
    numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
    X = X.mul(Y);
    X.x.length = n;
    X.y.length = n;
    return X;
}
numeric.T.prototype.ifft = function ifft() {
    var x = this.x, y = this.y;
    var n = x.length, log = Math.log, log2 = log(2),
        p = Math.ceil(log(2*n-1)/log2), m = Math.pow(2,p);
    var cx = numeric.rep([m],0), cy = numeric.rep([m],0), cos = Math.cos, sin = Math.sin;
    var k, c = (3.141592653589793238462643383279502884197169399375105820/n),t;
    var a = numeric.rep([m],0), b = numeric.rep([m],0),nhalf = Math.floor(n/2);
    for(k=0;k<n;k++) a[k] = x[k];
    if(typeof y !== "undefined") for(k=0;k<n;k++) b[k] = y[k];
    cx[0] = 1;
    for(k=1;k<=m/2;k++) {
        t = c*k*k;
        cx[k] = cos(t);
        cy[k] = sin(t);
        cx[m-k] = cos(t);
        cy[m-k] = sin(t)
    }
    var X = new numeric.T(a,b), Y = new numeric.T(cx,cy);
    X = X.mul(Y);
    numeric.convpow2(X.x,X.y,numeric.clone(Y.x),numeric.neg(Y.y));
    X = X.mul(Y);
    X.x.length = n;
    X.y.length = n;
    return X.div(n);
}

//9. Unconstrained optimization
numeric.gradient = function gradient(f,x) {
    var n = x.length;
    var f0 = f(x);
    if(isNaN(f0)) throw new Error('gradient: f(x) is a NaN!');
    var max = Math.max;
    var i,x0 = numeric.clone(x),f1,f2, J = Array(n);
    var div = numeric.div, sub = numeric.sub,errest,roundoff,max = Math.max,eps = 1e-3,abs = Math.abs, min = Math.min;
    var t0,t1,t2,it=0,d1,d2,N;
    for(i=0;i<n;i++) {
        var h = max(1e-6*f0,1e-8);
        while(1) {
            ++it;
            if(it>20) { throw new Error("Numerical gradient fails"); }
            x0[i] = x[i]+h;
            f1 = f(x0);
            x0[i] = x[i]-h;
            f2 = f(x0);
            x0[i] = x[i];
            if(isNaN(f1) || isNaN(f2)) { h/=16; continue; }
            J[i] = (f1-f2)/(2*h);
            t0 = x[i]-h;
            t1 = x[i];
            t2 = x[i]+h;
            d1 = (f1-f0)/h;
            d2 = (f0-f2)/h;
            N = max(abs(J[i]),abs(f0),abs(f1),abs(f2),abs(t0),abs(t1),abs(t2),1e-8);
            errest = min(max(abs(d1-J[i]),abs(d2-J[i]),abs(d1-d2))/N,h/N);
            if(errest>eps) { h/=16; }
            else break;
            }
    }
    return J;
}

numeric.uncmin = function uncmin(f,x0,tol,gradient,maxit,callback,options) {
    var grad = numeric.gradient;
    if(typeof options === "undefined") { options = {}; }
    if(typeof tol === "undefined") { tol = 1e-8; }
    if(typeof gradient === "undefined") { gradient = function(x) { return grad(f,x); }; }
    if(typeof maxit === "undefined") maxit = 1000;
    x0 = numeric.clone(x0);
    var n = x0.length;
    var f0 = f(x0),f1,df0;
    if(isNaN(f0)) throw new Error('uncmin: f(x0) is a NaN!');
    var max = Math.max, norm2 = numeric.norm2;
    tol = max(tol,numeric.epsilon);
    var step,g0,g1,H1 = options.Hinv || numeric.identity(n);
    var dot = numeric.dot, inv = numeric.inv, sub = numeric.sub, add = numeric.add, ten = numeric.tensor, div = numeric.div, mul = numeric.mul;
    var all = numeric.all, isfinite = numeric.isFinite, neg = numeric.neg;
    var it=0,i,s,x1,y,Hy,Hs,ys,i0,t,nstep,t1,t2;
    var msg = "";
    g0 = gradient(x0);
    while(it<maxit) {
        if(typeof callback === "function") { if(callback(it,x0,f0,g0,H1)) { msg = "Callback returned true"; break; } }
        if(!all(isfinite(g0))) { msg = "Gradient has Infinity or NaN"; break; }
        step = neg(dot(H1,g0));
        if(!all(isfinite(step))) { msg = "Search direction has Infinity or NaN"; break; }
        nstep = norm2(step);
        if(nstep < tol) { msg="Newton step smaller than tol"; break; }
        t = 1;
        df0 = dot(g0,step);
        // line search
        x1 = x0;
        while(it < maxit) {
            if(t*nstep < tol) { break; }
            s = mul(step,t);
            x1 = add(x0,s);
            f1 = f(x1);
            if(f1-f0 >= 0.1*t*df0 || isNaN(f1)) {
                t *= 0.5;
                ++it;
                continue;
            }
            break;
        }
        if(t*nstep < tol) { msg = "Line search step size smaller than tol"; break; }
        if(it === maxit) { msg = "maxit reached during line search"; break; }
        g1 = gradient(x1);
        y = sub(g1,g0);
        ys = dot(y,s);
        Hy = dot(H1,y);
        H1 = sub(add(H1,
                mul(
                        (ys+dot(y,Hy))/(ys*ys),
                        ten(s,s)    )),
                div(add(ten(Hy,s),ten(s,Hy)),ys));
        x0 = x1;
        f0 = f1;
        g0 = g1;
        ++it;
    }
    return {solution: x0, f: f0, gradient: g0, invHessian: H1, iterations:it, message: msg};
}

// 10. Ode solver (Dormand-Prince)
numeric.Dopri = function Dopri(x,y,f,ymid,iterations,msg,events) {
    this.x = x;
    this.y = y;
    this.f = f;
    this.ymid = ymid;
    this.iterations = iterations;
    this.events = events;
    this.message = msg;
}
numeric.Dopri.prototype._at = function _at(xi,j) {
    function sqr(x) { return x*x; }
    var sol = this;
    var xs = sol.x;
    var ys = sol.y;
    var k1 = sol.f;
    var ymid = sol.ymid;
    var n = xs.length;
    var x0,x1,xh,y0,y1,yh,xi;
    var floor = Math.floor,h;
    var c = 0.5;
    var add = numeric.add, mul = numeric.mul,sub = numeric.sub, p,q,w;
    x0 = xs[j];
    x1 = xs[j+1];
    y0 = ys[j];
    y1 = ys[j+1];
    h  = x1-x0;
    xh = x0+c*h;
    yh = ymid[j];
    p = sub(k1[j  ],mul(y0,1/(x0-xh)+2/(x0-x1)));
    q = sub(k1[j+1],mul(y1,1/(x1-xh)+2/(x1-x0)));
    w = [sqr(xi - x1) * (xi - xh) / sqr(x0 - x1) / (x0 - xh),
         sqr(xi - x0) * sqr(xi - x1) / sqr(x0 - xh) / sqr(x1 - xh),
         sqr(xi - x0) * (xi - xh) / sqr(x1 - x0) / (x1 - xh),
         (xi - x0) * sqr(xi - x1) * (xi - xh) / sqr(x0-x1) / (x0 - xh),
         (xi - x1) * sqr(xi - x0) * (xi - xh) / sqr(x0-x1) / (x1 - xh)];
    return add(add(add(add(mul(y0,w[0]),
                           mul(yh,w[1])),
                           mul(y1,w[2])),
                           mul( p,w[3])),
                           mul( q,w[4]));
}
numeric.Dopri.prototype.at = function at(x) {
    var i,j,k,floor = Math.floor;
    if(typeof x !== "number") {
        var n = x.length, ret = Array(n);
        for(i=n-1;i!==-1;--i) {
            ret[i] = this.at(x[i]);
        }
        return ret;
    }
    var x0 = this.x;
    i = 0; j = x0.length-1;
    while(j-i>1) {
        k = floor(0.5*(i+j));
        if(x0[k] <= x) i = k;
        else j = k;
    }
    return this._at(x,i);
}

numeric.dopri = function dopri(x0,x1,y0,f,tol,maxit,event) {
    if(typeof tol === "undefined") { tol = 1e-6; }
    if(typeof maxit === "undefined") { maxit = 1000; }
    var xs = [x0], ys = [y0], k1 = [f(x0,y0)], k2,k3,k4,k5,k6,k7, ymid = [];
    var A2 = 1/5;
    var A3 = [3/40,9/40];
    var A4 = [44/45,-56/15,32/9];
    var A5 = [19372/6561,-25360/2187,64448/6561,-212/729];
    var A6 = [9017/3168,-355/33,46732/5247,49/176,-5103/18656];
    var b = [35/384,0,500/1113,125/192,-2187/6784,11/84];
    var bm = [0.5*6025192743/30085553152,
              0,
              0.5*51252292925/65400821598,
              0.5*-2691868925/45128329728,
              0.5*187940372067/1594534317056,
              0.5*-1776094331/19743644256,
              0.5*11237099/235043384];
    var c = [1/5,3/10,4/5,8/9,1,1];
    var e = [-71/57600,0,71/16695,-71/1920,17253/339200,-22/525,1/40];
    var i = 0,er,j;
    var h = (x1-x0)/10;
    var it = 0;
    var add = numeric.add, mul = numeric.mul, y1,erinf;
    var max = Math.max, min = Math.min, abs = Math.abs, norminf = numeric.norminf,pow = Math.pow;
    var any = numeric.any, lt = numeric.lt, and = numeric.and, sub = numeric.sub;
    var e0, e1, ev;
    var ret = new numeric.Dopri(xs,ys,k1,ymid,-1,"");
    if(typeof event === "function") e0 = event(x0,y0);
    while(x0<x1 && it<maxit) {
        ++it;
        if(x0+h>x1) h = x1-x0;
        k2 = f(x0+c[0]*h,                add(y0,mul(   A2*h,k1[i])));
        k3 = f(x0+c[1]*h,            add(add(y0,mul(A3[0]*h,k1[i])),mul(A3[1]*h,k2)));
        k4 = f(x0+c[2]*h,        add(add(add(y0,mul(A4[0]*h,k1[i])),mul(A4[1]*h,k2)),mul(A4[2]*h,k3)));
        k5 = f(x0+c[3]*h,    add(add(add(add(y0,mul(A5[0]*h,k1[i])),mul(A5[1]*h,k2)),mul(A5[2]*h,k3)),mul(A5[3]*h,k4)));
        k6 = f(x0+c[4]*h,add(add(add(add(add(y0,mul(A6[0]*h,k1[i])),mul(A6[1]*h,k2)),mul(A6[2]*h,k3)),mul(A6[3]*h,k4)),mul(A6[4]*h,k5)));
        y1 = add(add(add(add(add(y0,mul(k1[i],h*b[0])),mul(k3,h*b[2])),mul(k4,h*b[3])),mul(k5,h*b[4])),mul(k6,h*b[5]));
        k7 = f(x0+h,y1);
        er = add(add(add(add(add(mul(k1[i],h*e[0]),mul(k3,h*e[2])),mul(k4,h*e[3])),mul(k5,h*e[4])),mul(k6,h*e[5])),mul(k7,h*e[6]));
        if(typeof er === "number") erinf = abs(er);
        else erinf = norminf(er);
        if(erinf > tol) { // reject
            h = 0.2*h*pow(tol/erinf,0.25);
            if(x0+h === x0) {
                ret.msg = "Step size became too small";
                break;
            }
            continue;
        }
        ymid[i] = add(add(add(add(add(add(y0,
                mul(k1[i],h*bm[0])),
                mul(k3   ,h*bm[2])),
                mul(k4   ,h*bm[3])),
                mul(k5   ,h*bm[4])),
                mul(k6   ,h*bm[5])),
                mul(k7   ,h*bm[6]));
        ++i;
        xs[i] = x0+h;
        ys[i] = y1;
        k1[i] = k7;
        if(typeof event === "function") {
            var yi,xl = x0,xr = x0+0.5*h,xi;
            e1 = event(xr,ymid[i-1]);
            ev = and(lt(e0,0),lt(0,e1));
            if(!any(ev)) { xl = xr; xr = x0+h; e0 = e1; e1 = event(xr,y1); ev = and(lt(e0,0),lt(0,e1)); }
            if(any(ev)) {
                var xc, yc, en,ei;
                var side=0, sl = 1.0, sr = 1.0;
                while(1) {
                    if(typeof e0 === "number") xi = (sr*e1*xl-sl*e0*xr)/(sr*e1-sl*e0);
                    else {
                        xi = xr;
                        for(j=e0.length-1;j!==-1;--j) {
                            if(e0[j]<0 && e1[j]>0) xi = min(xi,(sr*e1[j]*xl-sl*e0[j]*xr)/(sr*e1[j]-sl*e0[j]));
                        }
                    }
                    if(xi <= xl || xi >= xr) break;
                    yi = ret._at(xi, i-1);
                    ei = event(xi,yi);
                    en = and(lt(e0,0),lt(0,ei));
                    if(any(en)) {
                        xr = xi;
                        e1 = ei;
                        ev = en;
                        sr = 1.0;
                        if(side === -1) sl *= 0.5;
                        else sl = 1.0;
                        side = -1;
                    } else {
                        xl = xi;
                        e0 = ei;
                        sl = 1.0;
                        if(side === 1) sr *= 0.5;
                        else sr = 1.0;
                        side = 1;
                    }
                }
                y1 = ret._at(0.5*(x0+xi),i-1);
                ret.f[i] = f(xi,yi);
                ret.x[i] = xi;
                ret.y[i] = yi;
                ret.ymid[i-1] = y1;
                ret.events = ev;
                ret.iterations = it;
                return ret;
            }
        }
        x0 += h;
        y0 = y1;
        e0 = e1;
        h = min(0.8*h*pow(tol/erinf,0.25),4*h);
    }
    ret.iterations = it;
    return ret;
}

// 11. Ax = b
numeric.LU = function(A, fast) {
  fast = fast || false;

  var abs = Math.abs;
  var i, j, k, absAjk, Akk, Ak, Pk, Ai;
  var max;
  var n = A.length, n1 = n-1;
  var P = new Array(n);
  if(!fast) A = numeric.clone(A);

  for (k = 0; k < n; ++k) {
    Pk = k;
    Ak = A[k];
    max = abs(Ak[k]);
    for (j = k + 1; j < n; ++j) {
      absAjk = abs(A[j][k]);
      if (max < absAjk) {
        max = absAjk;
        Pk = j;
      }
    }
    P[k] = Pk;

    if (Pk != k) {
      A[k] = A[Pk];
      A[Pk] = Ak;
      Ak = A[k];
    }

    Akk = Ak[k];

    for (i = k + 1; i < n; ++i) {
      A[i][k] /= Akk;
    }

    for (i = k + 1; i < n; ++i) {
      Ai = A[i];
      for (j = k + 1; j < n1; ++j) {
        Ai[j] -= Ai[k] * Ak[j];
        ++j;
        Ai[j] -= Ai[k] * Ak[j];
      }
      if(j===n1) Ai[j] -= Ai[k] * Ak[j];
    }
  }

  return {
    LU: A,
    P:  P
  };
}

numeric.LUsolve = function LUsolve(LUP, b) {
  var i, j;
  var LU = LUP.LU;
  var n   = LU.length;
  var x = numeric.clone(b);
  var P   = LUP.P;
  var Pi, LUi, LUii, tmp;

  for (i=n-1;i!==-1;--i) x[i] = b[i];
  for (i = 0; i < n; ++i) {
    Pi = P[i];
    if (P[i] !== i) {
      tmp = x[i];
      x[i] = x[Pi];
      x[Pi] = tmp;
    }

    LUi = LU[i];
    for (j = 0; j < i; ++j) {
      x[i] -= x[j] * LUi[j];
    }
  }

  for (i = n - 1; i >= 0; --i) {
    LUi = LU[i];
    for (j = i + 1; j < n; ++j) {
      x[i] -= x[j] * LUi[j];
    }

    x[i] /= LUi[i];
  }

  return x;
}

numeric.solve = function solve(A,b,fast) { return numeric.LUsolve(numeric.LU(A,fast), b); }

// 12. Linear programming
numeric.echelonize = function echelonize(A) {
    var s = numeric.dim(A), m = s[0], n = s[1];
    var I = numeric.identity(m);
    var P = Array(m);
    var i,j,k,l,Ai,Ii,Z,a;
    var abs = Math.abs;
    var diveq = numeric.diveq;
    A = numeric.clone(A);
    for(i=0;i<m;++i) {
        k = 0;
        Ai = A[i];
        Ii = I[i];
        for(j=1;j<n;++j) if(abs(Ai[k])<abs(Ai[j])) k=j;
        P[i] = k;
        diveq(Ii,Ai[k]);
        diveq(Ai,Ai[k]);
        for(j=0;j<m;++j) if(j!==i) {
            Z = A[j]; a = Z[k];
            for(l=n-1;l!==-1;--l) Z[l] -= Ai[l]*a;
            Z = I[j];
            for(l=m-1;l!==-1;--l) Z[l] -= Ii[l]*a;
        }
    }
    return {I:I, A:A, P:P};
}

numeric.__solveLP = function __solveLP(c,A,b,tol,maxit,x,flag) {
    var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
    var m = c.length, n = b.length,y;
    var unbounded = false, cb,i0=0;
    var alpha = 1.0;
    var f0,df0,AT = numeric.transpose(A), svd = numeric.svd,transpose = numeric.transpose,leq = numeric.leq, sqrt = Math.sqrt, abs = Math.abs;
    var muleq = numeric.muleq;
    var norm = numeric.norminf, any = numeric.any,min = Math.min;
    var all = numeric.all, gt = numeric.gt;
    var p = Array(m), A0 = Array(n),e=numeric.rep([n],1), H;
    var solve = numeric.solve, z = sub(b,dot(A,x)),count;
    var dotcc = dot(c,c);
    var g;
    for(count=i0;count<maxit;++count) {
        var i,j,d;
        for(i=n-1;i!==-1;--i) A0[i] = div(A[i],z[i]);
        var A1 = transpose(A0);
        for(i=m-1;i!==-1;--i) p[i] = (/*x[i]+*/sum(A1[i]));
        alpha = 0.25*abs(dotcc/dot(c,p));
        var a1 = 100*sqrt(dotcc/dot(p,p));
        if(!isFinite(alpha) || alpha>a1) alpha = a1;
        g = add(c,mul(alpha,p));
        H = dot(A1,A0);
        for(i=m-1;i!==-1;--i) H[i][i] += 1;
        d = solve(H,div(g,alpha),true);
        var t0 = div(z,dot(A,d));
        var t = 1.0;
        for(i=n-1;i!==-1;--i) if(t0[i]<0) t = min(t,-0.999*t0[i]);
        y = sub(x,mul(d,t));
        z = sub(b,dot(A,y));
        if(!all(gt(z,0))) return { solution: x, message: "", iterations: count };
        x = y;
        if(alpha<tol) return { solution: y, message: "", iterations: count };
        if(flag) {
            var s = dot(c,g), Ag = dot(A,g);
            unbounded = true;
            for(i=n-1;i!==-1;--i) if(s*Ag[i]<0) { unbounded = false; break; }
        } else {
            if(x[m-1]>=0) unbounded = false;
            else unbounded = true;
        }
        if(unbounded) return { solution: y, message: "Unbounded", iterations: count };
    }
    return { solution: x, message: "maximum iteration count exceeded", iterations:count };
}

numeric._solveLP = function _solveLP(c,A,b,tol,maxit) {
    var m = c.length, n = b.length,y;
    var sum = numeric.sum, log = numeric.log, mul = numeric.mul, sub = numeric.sub, dot = numeric.dot, div = numeric.div, add = numeric.add;
    var c0 = numeric.rep([m],0).concat([1]);
    var J = numeric.rep([n,1],-1);
    var A0 = numeric.blockMatrix([[A                   ,   J  ]]);
    var b0 = b;
    var y = numeric.rep([m],0).concat(Math.max(0,numeric.sup(numeric.neg(b)))+1);
    var x0 = numeric.__solveLP(c0,A0,b0,tol,maxit,y,false);
    var x = numeric.clone(x0.solution);
    x.length = m;
    var foo = numeric.inf(sub(b,dot(A,x)));
    if(foo<0) { return { solution: NaN, message: "Infeasible", iterations: x0.iterations }; }
    var ret = numeric.__solveLP(c, A, b, tol, maxit-x0.iterations, x, true);
    ret.iterations += x0.iterations;
    return ret;
};

numeric.solveLP = function solveLP(c,A,b,Aeq,beq,tol,maxit) {
    if(typeof maxit === "undefined") maxit = 1000;
    if(typeof tol === "undefined") tol = numeric.epsilon;
    if(typeof Aeq === "undefined") return numeric._solveLP(c,A,b,tol,maxit);
    var m = Aeq.length, n = Aeq[0].length, o = A.length;
    var B = numeric.echelonize(Aeq);
    var flags = numeric.rep([n],0);
    var P = B.P;
    var Q = [];
    var i;
    for(i=P.length-1;i!==-1;--i) flags[P[i]] = 1;
    for(i=n-1;i!==-1;--i) if(flags[i]===0) Q.push(i);
    var g = numeric.getRange;
    var I = numeric.linspace(0,m-1), J = numeric.linspace(0,o-1);
    var Aeq2 = g(Aeq,I,Q), A1 = g(A,J,P), A2 = g(A,J,Q), dot = numeric.dot, sub = numeric.sub;
    var A3 = dot(A1,B.I);
    var A4 = sub(A2,dot(A3,Aeq2)), b4 = sub(b,dot(A3,beq));
    var c1 = Array(P.length), c2 = Array(Q.length);
    for(i=P.length-1;i!==-1;--i) c1[i] = c[P[i]];
    for(i=Q.length-1;i!==-1;--i) c2[i] = c[Q[i]];
    var c4 = sub(c2,dot(c1,dot(B.I,Aeq2)));
    var S = numeric._solveLP(c4,A4,b4,tol,maxit);
    var x2 = S.solution;
    if(x2!==x2) return S;
    var x1 = dot(B.I,sub(beq,dot(Aeq2,x2)));
    var x = Array(c.length);
    for(i=P.length-1;i!==-1;--i) x[P[i]] = x1[i];
    for(i=Q.length-1;i!==-1;--i) x[Q[i]] = x2[i];
    return { solution: x, message:S.message, iterations: S.iterations };
}

numeric.MPStoLP = function MPStoLP(MPS) {
    if(MPS instanceof String) { MPS.split('\n'); }
    var state = 0;
    var states = ['Initial state','NAME','ROWS','COLUMNS','RHS','BOUNDS','ENDATA'];
    var n = MPS.length;
    var i,j,z,N=0,rows = {}, sign = [], rl = 0, vars = {}, nv = 0;
    var name;
    var c = [], A = [], b = [];
    function err(e) { throw new Error('MPStoLP: '+e+'\nLine '+i+': '+MPS[i]+'\nCurrent state: '+states[state]+'\n'); }
    for(i=0;i<n;++i) {
        z = MPS[i];
        var w0 = z.match(/\S*/g);
        var w = [];
        for(j=0;j<w0.length;++j) if(w0[j]!=="") w.push(w0[j]);
        if(w.length === 0) continue;
        for(j=0;j<states.length;++j) if(z.substr(0,states[j].length) === states[j]) break;
        if(j<states.length) {
            state = j;
            if(j===1) { name = w[1]; }
            if(j===6) return { name:name, c:c, A:numeric.transpose(A), b:b, rows:rows, vars:vars };
            continue;
        }
        switch(state) {
        case 0: case 1: err('Unexpected line');
        case 2: 
            switch(w[0]) {
            case 'N': if(N===0) N = w[1]; else err('Two or more N rows'); break;
            case 'L': rows[w[1]] = rl; sign[rl] = 1; b[rl] = 0; ++rl; break;
            case 'G': rows[w[1]] = rl; sign[rl] = -1;b[rl] = 0; ++rl; break;
            case 'E': rows[w[1]] = rl; sign[rl] = 0;b[rl] = 0; ++rl; break;
            default: err('Parse error '+numeric.prettyPrint(w));
            }
            break;
        case 3:
            if(!vars.hasOwnProperty(w[0])) { vars[w[0]] = nv; c[nv] = 0; A[nv] = numeric.rep([rl],0); ++nv; }
            var p = vars[w[0]];
            for(j=1;j<w.length;j+=2) {
                if(w[j] === N) { c[p] = parseFloat(w[j+1]); continue; }
                var q = rows[w[j]];
                A[p][q] = (sign[q]<0?-1:1)*parseFloat(w[j+1]);
            }
            break;
        case 4:
            for(j=1;j<w.length;j+=2) b[rows[w[j]]] = (sign[rows[w[j]]]<0?-1:1)*parseFloat(w[j+1]);
            break;
        case 5: /*FIXME*/ break;
        case 6: err('Internal error');
        }
    }
    err('Reached end of file without ENDATA');
}
// seedrandom.js version 2.0.
// Author: David Bau 4/2/2011
//
// Defines a method Math.seedrandom() that, when called, substitutes
// an explicitly seeded RC4-based algorithm for Math.random().  Also
// supports automatic seeding from local or network sources of entropy.
//
// Usage:
//
//   <script src=http://davidbau.com/encode/seedrandom-min.js></script>
//
//   Math.seedrandom('yipee'); Sets Math.random to a function that is
//                             initialized using the given explicit seed.
//
//   Math.seedrandom();        Sets Math.random to a function that is
//                             seeded using the current time, dom state,
//                             and other accumulated local entropy.
//                             The generated seed string is returned.
//
//   Math.seedrandom('yowza', true);
//                             Seeds using the given explicit seed mixed
//                             together with accumulated entropy.
//
//   <script src="http://bit.ly/srandom-512"></script>
//                             Seeds using physical random bits downloaded
//                             from random.org.
//
//   <script src="https://jsonlib.appspot.com/urandom?callback=Math.seedrandom">
//   </script>                 Seeds using urandom bits from call.jsonlib.com,
//                             which is faster than random.org.
//
// Examples:
//
//   Math.seedrandom("hello");            // Use "hello" as the seed.
//   document.write(Math.random());       // Always 0.5463663768140734
//   document.write(Math.random());       // Always 0.43973793770592234
//   var rng1 = Math.random;              // Remember the current prng.
//
//   var autoseed = Math.seedrandom();    // New prng with an automatic seed.
//   document.write(Math.random());       // Pretty much unpredictable.
//
//   Math.random = rng1;                  // Continue "hello" prng sequence.
//   document.write(Math.random());       // Always 0.554769432473455
//
//   Math.seedrandom(autoseed);           // Restart at the previous seed.
//   document.write(Math.random());       // Repeat the 'unpredictable' value.
//
// Notes:
//
// Each time seedrandom('arg') is called, entropy from the passed seed
// is accumulated in a pool to help generate future seeds for the
// zero-argument form of Math.seedrandom, so entropy can be injected over
// time by calling seedrandom with explicit data repeatedly.
//
// On speed - This javascript implementation of Math.random() is about
// 3-10x slower than the built-in Math.random() because it is not native
// code, but this is typically fast enough anyway.  Seeding is more expensive,
// especially if you use auto-seeding.  Some details (timings on Chrome 4):
//
// Our Math.random()            - avg less than 0.002 milliseconds per call
// seedrandom('explicit')       - avg less than 0.5 milliseconds per call
// seedrandom('explicit', true) - avg less than 2 milliseconds per call
// seedrandom()                 - avg about 38 milliseconds per call
//
// LICENSE (BSD):
//
// Copyright 2010 David Bau, all rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
// 
//   1. Redistributions of source code must retain the above copyright
//      notice, this list of conditions and the following disclaimer.
//
//   2. Redistributions in binary form must reproduce the above copyright
//      notice, this list of conditions and the following disclaimer in the
//      documentation and/or other materials provided with the distribution.
// 
//   3. Neither the name of this module nor the names of its contributors may
//      be used to endorse or promote products derived from this software
//      without specific prior written permission.
// 
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS
// "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT
// LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR
// A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT
// OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
// SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT
// LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE,
// DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY
// THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
// (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE
// OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
//
/**
 * All code is in an anonymous closure to keep the global namespace clean.
 *
 * @param {number=} overflow 
 * @param {number=} startdenom
 */

// Patched by Seb so that seedrandom.js does not pollute the Math object.
// My tests suggest that doing Math.trouble = 1 makes Math lookups about 5%
// slower.
numeric.seedrandom = { pow:Math.pow, random:Math.random };

(function (pool, math, width, chunks, significance, overflow, startdenom) {


//
// seedrandom()
// This is the seedrandom function described above.
//
math['seedrandom'] = function seedrandom(seed, use_entropy) {
  var key = [];
  var arc4;

  // Flatten the seed string or build one from local entropy if needed.
  seed = mixkey(flatten(
    use_entropy ? [seed, pool] :
    arguments.length ? seed :
    [new Date().getTime(), pool, window], 3), key);

  // Use the seed to initialize an ARC4 generator.
  arc4 = new ARC4(key);

  // Mix the randomness into accumulated entropy.
  mixkey(arc4.S, pool);

  // Override Math.random

  // This function returns a random double in [0, 1) that contains
  // randomness in every bit of the mantissa of the IEEE 754 value.

  math['random'] = function random() {  // Closure to return a random double:
    var n = arc4.g(chunks);             // Start with a numerator n < 2 ^ 48
    var d = startdenom;                 //   and denominator d = 2 ^ 48.
    var x = 0;                          //   and no 'extra last byte'.
    while (n < significance) {          // Fill up all significant digits by
      n = (n + x) * width;              //   shifting numerator and
      d *= width;                       //   denominator and generating a
      x = arc4.g(1);                    //   new least-significant-byte.
    }
    while (n >= overflow) {             // To avoid rounding up, before adding
      n /= 2;                           //   last byte, shift everything
      d /= 2;                           //   right using integer math until
      x >>>= 1;                         //   we have exactly the desired bits.
    }
    return (n + x) / d;                 // Form the number within [0, 1).
  };

  // Return the seed that was used
  return seed;
};

//
// ARC4
//
// An ARC4 implementation.  The constructor takes a key in the form of
// an array of at most (width) integers that should be 0 <= x < (width).
//
// The g(count) method returns a pseudorandom integer that concatenates
// the next (count) outputs from ARC4.  Its return value is a number x
// that is in the range 0 <= x < (width ^ count).
//
/** @constructor */
function ARC4(key) {
  var t, u, me = this, keylen = key.length;
  var i = 0, j = me.i = me.j = me.m = 0;
  me.S = [];
  me.c = [];

  // The empty key [] is treated as [0].
  if (!keylen) { key = [keylen++]; }

  // Set up S using the standard key scheduling algorithm.
  while (i < width) { me.S[i] = i++; }
  for (i = 0; i < width; i++) {
    t = me.S[i];
    j = lowbits(j + t + key[i % keylen]);
    u = me.S[j];
    me.S[i] = u;
    me.S[j] = t;
  }

  // The "g" method returns the next (count) outputs as one number.
  me.g = function getnext(count) {
    var s = me.S;
    var i = lowbits(me.i + 1); var t = s[i];
    var j = lowbits(me.j + t); var u = s[j];
    s[i] = u;
    s[j] = t;
    var r = s[lowbits(t + u)];
    while (--count) {
      i = lowbits(i + 1); t = s[i];
      j = lowbits(j + t); u = s[j];
      s[i] = u;
      s[j] = t;
      r = r * width + s[lowbits(t + u)];
    }
    me.i = i;
    me.j = j;
    return r;
  };
  // For robust unpredictability discard an initial batch of values.
  // See http://www.rsa.com/rsalabs/node.asp?id=2009
  me.g(width);
}

//
// flatten()
// Converts an object tree to nested arrays of strings.
//
/** @param {Object=} result 
  * @param {string=} prop
  * @param {string=} typ */
function flatten(obj, depth, result, prop, typ) {
  result = [];
  typ = typeof(obj);
  if (depth && typ == 'object') {
    for (prop in obj) {
      if (prop.indexOf('S') < 5) {    // Avoid FF3 bug (local/sessionStorage)
        try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
      }
    }
  }
  return (result.length ? result : obj + (typ != 'string' ? '\0' : ''));
}

//
// mixkey()
// Mixes a string seed into a key that is an array of integers, and
// returns a shortened string seed that is equivalent to the result key.
//
/** @param {number=} smear 
  * @param {number=} j */
function mixkey(seed, key, smear, j) {
  seed += '';                         // Ensure the seed is a string
  smear = 0;
  for (j = 0; j < seed.length; j++) {
    key[lowbits(j)] =
      lowbits((smear ^= key[lowbits(j)] * 19) + seed.charCodeAt(j));
  }
  seed = '';
  for (j in key) { seed += String.fromCharCode(key[j]); }
  return seed;
}

//
// lowbits()
// A quick "n mod width" for width a power of 2.
//
function lowbits(n) { return n & (width - 1); }

//
// The following constants are related to IEEE 754 limits.
//
startdenom = math.pow(width, chunks);
significance = math.pow(2, significance);
overflow = significance * 2;

//
// When seedrandom.js is loaded, we immediately mix a few bits
// from the built-in RNG into the entropy pool.  Because we do
// not want to intefere with determinstic PRNG state later,
// seedrandom will not call math.random on its own again after
// initialization.
//
mixkey(math.random(), pool);

// End anonymous scope, and pass initial values.
}(
  [],   // pool: entropy pool starts empty
  numeric.seedrandom, // math: package containing random, pow, and seedrandom
  256,  // width: each RC4 output is 0 <= x < 256
  6,    // chunks: at least six RC4 outputs for each double
  52    // significance: there are 52 significant digits in a double
  ));
/* This file is a slightly modified version of quadprog.js from Alberto Santini.
 * It has been slightly modified by Sébastien Loisel to make sure that it handles
 * 0-based Arrays instead of 1-based Arrays.
 * License is in resources/LICENSE.quadprog */
(function(exports) {

function base0to1(A) {
    if(typeof A !== "object") { return A; }
    var ret = [], i,n=A.length;
    for(i=0;i<n;i++) ret[i+1] = base0to1(A[i]);
    return ret;
}
function base1to0(A) {
    if(typeof A !== "object") { return A; }
    var ret = [], i,n=A.length;
    for(i=1;i<n;i++) ret[i-1] = base1to0(A[i]);
    return ret;
}

function dpori(a, lda, n) {
    var i, j, k, kp1, t;

    for (k = 1; k <= n; k = k + 1) {
        a[k][k] = 1 / a[k][k];
        t = -a[k][k];
        //~ dscal(k - 1, t, a[1][k], 1);
        for (i = 1; i < k; i = i + 1) {
            a[i][k] = t * a[i][k];
        }

        kp1 = k + 1;
        if (n < kp1) {
            break;
        }
        for (j = kp1; j <= n; j = j + 1) {
            t = a[k][j];
            a[k][j] = 0;
            //~ daxpy(k, t, a[1][k], 1, a[1][j], 1);
            for (i = 1; i <= k; i = i + 1) {
                a[i][j] = a[i][j] + (t * a[i][k]);
            }
        }
    }

}

function dposl(a, lda, n, b) {
    var i, k, kb, t;

    for (k = 1; k <= n; k = k + 1) {
        //~ t = ddot(k - 1, a[1][k], 1, b[1], 1);
        t = 0;
        for (i = 1; i < k; i = i + 1) {
            t = t + (a[i][k] * b[i]);
        }

        b[k] = (b[k] - t) / a[k][k];
    }

    for (kb = 1; kb <= n; kb = kb + 1) {
        k = n + 1 - kb;
        b[k] = b[k] / a[k][k];
        t = -b[k];
        //~ daxpy(k - 1, t, a[1][k], 1, b[1], 1);
        for (i = 1; i < k; i = i + 1) {
            b[i] = b[i] + (t * a[i][k]);
        }
    }
}

function dpofa(a, lda, n, info) {
    var i, j, jm1, k, t, s;

    for (j = 1; j <= n; j = j + 1) {
        info[1] = j;
        s = 0;
        jm1 = j - 1;
        if (jm1 < 1) {
            s = a[j][j] - s;
            if (s <= 0) {
                break;
            }
            a[j][j] = Math.sqrt(s);
        } else {
            for (k = 1; k <= jm1; k = k + 1) {
                //~ t = a[k][j] - ddot(k - 1, a[1][k], 1, a[1][j], 1);
                t = a[k][j];
                for (i = 1; i < k; i = i + 1) {
                    t = t - (a[i][j] * a[i][k]);
                }
                t = t / a[k][k];
                a[k][j] = t;
                s = s + t * t;
            }
            s = a[j][j] - s;
            if (s <= 0) {
                break;
            }
            a[j][j] = Math.sqrt(s);
        }
        info[1] = 0;
    }
}

function qpgen2(dmat, dvec, fddmat, n, sol, crval, amat,
    bvec, fdamat, q, meq, iact, nact, iter, work, ierr) {

    var i, j, l, l1, info, it1, iwzv, iwrv, iwrm, iwsv, iwuv, nvl, r, iwnbv,
        temp, sum, t1, tt, gc, gs, nu,
        t1inf, t2min,
        vsmall, tmpa, tmpb,
        go;

    r = Math.min(n, q);
    l = 2 * n + (r * (r + 5)) / 2 + 2 * q + 1;

    vsmall = 1.0e-60;
    do {
        vsmall = vsmall + vsmall;
        tmpa = 1 + 0.1 * vsmall;
        tmpb = 1 + 0.2 * vsmall;
    } while (tmpa <= 1 || tmpb <= 1);

    for (i = 1; i <= n; i = i + 1) {
        work[i] = dvec[i];
    }
    for (i = n + 1; i <= l; i = i + 1) {
        work[i] = 0;
    }
    for (i = 1; i <= q; i = i + 1) {
        iact[i] = 0;
    }

    info = [];

    if (ierr[1] === 0) {
        dpofa(dmat, fddmat, n, info);
        if (info[1] !== 0) {
            ierr[1] = 2;
            return;
        }
        dposl(dmat, fddmat, n, dvec);
        dpori(dmat, fddmat, n);
    } else {
        for (j = 1; j <= n; j = j + 1) {
            sol[j] = 0;
            for (i = 1; i <= j; i = i + 1) {
                sol[j] = sol[j] + dmat[i][j] * dvec[i];
            }
        }
        for (j = 1; j <= n; j = j + 1) {
            dvec[j] = 0;
            for (i = j; i <= n; i = i + 1) {
                dvec[j] = dvec[j] + dmat[j][i] * sol[i];
            }
        }
    }

    crval[1] = 0;
    for (j = 1; j <= n; j = j + 1) {
        sol[j] = dvec[j];
        crval[1] = crval[1] + work[j] * sol[j];
        work[j] = 0;
        for (i = j + 1; i <= n; i = i + 1) {
            dmat[i][j] = 0;
        }
    }
    crval[1] = -crval[1] / 2;
    ierr[1] = 0;

    iwzv = n;
    iwrv = iwzv + n;
    iwuv = iwrv + r;
    iwrm = iwuv + r + 1;
    iwsv = iwrm + (r * (r + 1)) / 2;
    iwnbv = iwsv + q;

    for (i = 1; i <= q; i = i + 1) {
        sum = 0;
        for (j = 1; j <= n; j = j + 1) {
            sum = sum + amat[j][i] * amat[j][i];
        }
        work[iwnbv + i] = Math.sqrt(sum);
    }
    nact = 0;
    iter[1] = 0;
    iter[2] = 0;

    function fn_goto_50() {
        iter[1] = iter[1] + 1;

        l = iwsv;
        for (i = 1; i <= q; i = i + 1) {
            l = l + 1;
            sum = -bvec[i];
            for (j = 1; j <= n; j = j + 1) {
                sum = sum + amat[j][i] * sol[j];
            }
            if (Math.abs(sum) < vsmall) {
                sum = 0;
            }
            if (i > meq) {
                work[l] = sum;
            } else {
                work[l] = -Math.abs(sum);
                if (sum > 0) {
                    for (j = 1; j <= n; j = j + 1) {
                        amat[j][i] = -amat[j][i];
                    }
                    bvec[i] = -bvec[i];
                }
            }
        }

        for (i = 1; i <= nact; i = i + 1) {
            work[iwsv + iact[i]] = 0;
        }

        nvl = 0;
        temp = 0;
        for (i = 1; i <= q; i = i + 1) {
            if (work[iwsv + i] < temp * work[iwnbv + i]) {
                nvl = i;
                temp = work[iwsv + i] / work[iwnbv + i];
            }
        }
        if (nvl === 0) {
            return 999;
        }

        return 0;
    }

    function fn_goto_55() {
        for (i = 1; i <= n; i = i + 1) {
            sum = 0;
            for (j = 1; j <= n; j = j + 1) {
                sum = sum + dmat[j][i] * amat[j][nvl];
            }
            work[i] = sum;
        }

        l1 = iwzv;
        for (i = 1; i <= n; i = i + 1) {
            work[l1 + i] = 0;
        }
        for (j = nact + 1; j <= n; j = j + 1) {
            for (i = 1; i <= n; i = i + 1) {
                work[l1 + i] = work[l1 + i] + dmat[i][j] * work[j];
            }
        }

        t1inf = true;
        for (i = nact; i >= 1; i = i - 1) {
            sum = work[i];
            l = iwrm + (i * (i + 3)) / 2;
            l1 = l - i;
            for (j = i + 1; j <= nact; j = j + 1) {
                sum = sum - work[l] * work[iwrv + j];
                l = l + j;
            }
            sum = sum / work[l1];
            work[iwrv + i] = sum;
            if (iact[i] < meq) {
                // continue;
                break;
            }
            if (sum < 0) {
                // continue;
                break;
            }
            t1inf = false;
            it1 = i;
        }

        if (!t1inf) {
            t1 = work[iwuv + it1] / work[iwrv + it1];
            for (i = 1; i <= nact; i = i + 1) {
                if (iact[i] < meq) {
                    // continue;
                    break;
                }
                if (work[iwrv + i] < 0) {
                    // continue;
                    break;
                }
                temp = work[iwuv + i] / work[iwrv + i];
                if (temp < t1) {
                    t1 = temp;
                    it1 = i;
                }
            }
        }

        sum = 0;
        for (i = iwzv + 1; i <= iwzv + n; i = i + 1) {
            sum = sum + work[i] * work[i];
        }
        if (Math.abs(sum) <= vsmall) {
            if (t1inf) {
                ierr[1] = 1;
                // GOTO 999
                return 999;
            } else {
                for (i = 1; i <= nact; i = i + 1) {
                    work[iwuv + i] = work[iwuv + i] - t1 * work[iwrv + i];
                }
                work[iwuv + nact + 1] = work[iwuv + nact + 1] + t1;
                // GOTO 700
                return 700;
            }
        } else {
            sum = 0;
            for (i = 1; i <= n; i = i + 1) {
                sum = sum + work[iwzv + i] * amat[i][nvl];
            }
            tt = -work[iwsv + nvl] / sum;
            t2min = true;
            if (!t1inf) {
                if (t1 < tt) {
                    tt = t1;
                    t2min = false;
                }
            }

            for (i = 1; i <= n; i = i + 1) {
                sol[i] = sol[i] + tt * work[iwzv + i];
                if (Math.abs(sol[i]) < vsmall) {
                    sol[i] = 0;
                }
            }

            crval[1] = crval[1] + tt * sum * (tt / 2 + work[iwuv + nact + 1]);
            for (i = 1; i <= nact; i = i + 1) {
                work[iwuv + i] = work[iwuv + i] - tt * work[iwrv + i];
            }
            work[iwuv + nact + 1] = work[iwuv + nact + 1] + tt;

            if (t2min) {
                nact = nact + 1;
                iact[nact] = nvl;

                l = iwrm + ((nact - 1) * nact) / 2 + 1;
                for (i = 1; i <= nact - 1; i = i + 1) {
                    work[l] = work[i];
                    l = l + 1;
                }

                if (nact === n) {
                    work[l] = work[n];
                } else {
                    for (i = n; i >= nact + 1; i = i - 1) {
                        if (work[i] === 0) {
                            // continue;
                            break;
                        }
                        gc = Math.max(Math.abs(work[i - 1]), Math.abs(work[i]));
                        gs = Math.min(Math.abs(work[i - 1]), Math.abs(work[i]));
                        if (work[i - 1] >= 0) {
                            temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                        } else {
                            temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
                        }
                        gc = work[i - 1] / temp;
                        gs = work[i] / temp;

                        if (gc === 1) {
                            // continue;
                            break;
                        }
                        if (gc === 0) {
                            work[i - 1] = gs * temp;
                            for (j = 1; j <= n; j = j + 1) {
                                temp = dmat[j][i - 1];
                                dmat[j][i - 1] = dmat[j][i];
                                dmat[j][i] = temp;
                            }
                        } else {
                            work[i - 1] = temp;
                            nu = gs / (1 + gc);
                            for (j = 1; j <= n; j = j + 1) {
                                temp = gc * dmat[j][i - 1] + gs * dmat[j][i];
                                dmat[j][i] = nu * (dmat[j][i - 1] + temp) - dmat[j][i];
                                dmat[j][i - 1] = temp;

                            }
                        }
                    }
                    work[l] = work[nact];
                }
            } else {
                sum = -bvec[nvl];
                for (j = 1; j <= n; j = j + 1) {
                    sum = sum + sol[j] * amat[j][nvl];
                }
                if (nvl > meq) {
                    work[iwsv + nvl] = sum;
                } else {
                    work[iwsv + nvl] = -Math.abs(sum);
                    if (sum > 0) {
                        for (j = 1; j <= n; j = j + 1) {
                            amat[j][nvl] = -amat[j][nvl];
                        }
                        bvec[nvl] = -bvec[nvl];
                    }
                }
                // GOTO 700
                return 700;
            }
        }

        return 0;
    }

    function fn_goto_797() {
        l = iwrm + (it1 * (it1 + 1)) / 2 + 1;
        l1 = l + it1;
        if (work[l1] === 0) {
            // GOTO 798
            return 798;
        }
        gc = Math.max(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
        gs = Math.min(Math.abs(work[l1 - 1]), Math.abs(work[l1]));
        if (work[l1 - 1] >= 0) {
            temp = Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
        } else {
            temp = -Math.abs(gc * Math.sqrt(1 + gs * gs / (gc * gc)));
        }
        gc = work[l1 - 1] / temp;
        gs = work[l1] / temp;

        if (gc === 1) {
            // GOTO 798
            return 798;
        }
        if (gc === 0) {
            for (i = it1 + 1; i <= nact; i = i + 1) {
                temp = work[l1 - 1];
                work[l1 - 1] = work[l1];
                work[l1] = temp;
                l1 = l1 + i;
            }
            for (i = 1; i <= n; i = i + 1) {
                temp = dmat[i][it1];
                dmat[i][it1] = dmat[i][it1 + 1];
                dmat[i][it1 + 1] = temp;
            }
        } else {
            nu = gs / (1 + gc);
            for (i = it1 + 1; i <= nact; i = i + 1) {
                temp = gc * work[l1 - 1] + gs * work[l1];
                work[l1] = nu * (work[l1 - 1] + temp) - work[l1];
                work[l1 - 1] = temp;
                l1 = l1 + i;
            }
            for (i = 1; i <= n; i = i + 1) {
                temp = gc * dmat[i][it1] + gs * dmat[i][it1 + 1];
                dmat[i][it1 + 1] = nu * (dmat[i][it1] + temp) - dmat[i][it1 + 1];
                dmat[i][it1] = temp;
            }
        }

        return 0;
    }

    function fn_goto_798() {
        l1 = l - it1;
        for (i = 1; i <= it1; i = i + 1) {
            work[l1] = work[l];
            l = l + 1;
            l1 = l1 + 1;
        }

        work[iwuv + it1] = work[iwuv + it1 + 1];
        iact[it1] = iact[it1 + 1];
        it1 = it1 + 1;
        if (it1 < nact) {
            // GOTO 797
            return 797;
        }

        return 0;
    }

    function fn_goto_799() {
        work[iwuv + nact] = work[iwuv + nact + 1];
        work[iwuv + nact + 1] = 0;
        iact[nact] = 0;
        nact = nact - 1;
        iter[2] = iter[2] + 1;

        return 0;
    }

    go = 0;
    while (true) {
        go = fn_goto_50();
        if (go === 999) {
            return;
        }
        while (true) {
            go = fn_goto_55();
            if (go === 0) {
                break;
            }
            if (go === 999) {
                return;
            }
            if (go === 700) {
                if (it1 === nact) {
                    fn_goto_799();
                } else {
                    while (true) {
                        fn_goto_797();
                        go = fn_goto_798();
                        if (go !== 797) {
                            break;
                        }
                    }
                    fn_goto_799();
                }
            }
        }
    }

}

function solveQP(Dmat, dvec, Amat, bvec, meq, factorized) {
    Dmat = base0to1(Dmat);
    dvec = base0to1(dvec);
    Amat = base0to1(Amat);
    var i, n, q,
        nact, r,
        crval = [], iact = [], sol = [], work = [], iter = [],
        message;

    meq = meq || 0;
    factorized = factorized ? base0to1(factorized) : [undefined, 0];
    bvec = bvec ? base0to1(bvec) : [];

    // In Fortran the array index starts from 1
    n = Dmat.length - 1;
    q = Amat[1].length - 1;

    if (!bvec) {
        for (i = 1; i <= q; i = i + 1) {
            bvec[i] = 0;
        }
    }
    for (i = 1; i <= q; i = i + 1) {
        iact[i] = 0;
    }
    nact = 0;
    r = Math.min(n, q);
    for (i = 1; i <= n; i = i + 1) {
        sol[i] = 0;
    }
    crval[1] = 0;
    for (i = 1; i <= (2 * n + (r * (r + 5)) / 2 + 2 * q + 1); i = i + 1) {
        work[i] = 0;
    }
    for (i = 1; i <= 2; i = i + 1) {
        iter[i] = 0;
    }

    qpgen2(Dmat, dvec, n, n, sol, crval, Amat,
        bvec, n, q, meq, iact, nact, iter, work, factorized);

    message = "";
    if (factorized[1] === 1) {
        message = "constraints are inconsistent, no solution!";
    }
    if (factorized[1] === 2) {
        message = "matrix D in quadratic function is not positive definite!";
    }

    return {
        solution: base1to0(sol),
        value: base1to0(crval),
        unconstrained_solution: base1to0(dvec),
        iterations: base1to0(iter),
        iact: base1to0(iact),
        message: message
    };
}
exports.solveQP = solveQP;
}(numeric));
/*
Shanti Rao sent me this routine by private email. I had to modify it
slightly to work on Arrays instead of using a Matrix object.
It is apparently translated from http://stitchpanorama.sourceforge.net/Python/svd.py
*/

numeric.svd= function svd(A) {
    var temp;
//Compute the thin SVD from G. H. Golub and C. Reinsch, Numer. Math. 14, 403-420 (1970)
	var prec= numeric.epsilon; //Math.pow(2,-52) // assumes double prec
	var tolerance= 1.e-64/prec;
	var itmax= 50;
	var c=0;
	var i=0;
	var j=0;
	var k=0;
	var l=0;
	
	var u= numeric.clone(A);
	var m= u.length;
	
	var n= u[0].length;
	
	if (m < n) throw "Need more rows than columns"
	
	var e = new Array(n);
	var q = new Array(n);
	for (i=0; i<n; i++) e[i] = q[i] = 0.0;
	var v = numeric.rep([n,n],0);
//	v.zero();
	
 	function pythag(a,b)
 	{
		a = Math.abs(a)
		b = Math.abs(b)
		if (a > b)
			return a*Math.sqrt(1.0+(b*b/a/a))
		else if (b == 0.0) 
			return a
		return b*Math.sqrt(1.0+(a*a/b/b))
	}

	//Householder's reduction to bidiagonal form

	var f= 0.0;
	var g= 0.0;
	var h= 0.0;
	var x= 0.0;
	var y= 0.0;
	var z= 0.0;
	var s= 0.0;
	
	for (i=0; i < n; i++)
	{	
		e[i]= g;
		s= 0.0;
		l= i+1;
		for (j=i; j < m; j++) 
			s += (u[j][i]*u[j][i]);
		if (s <= tolerance)
			g= 0.0;
		else
		{	
			f= u[i][i];
			g= Math.sqrt(s);
			if (f >= 0.0) g= -g;
			h= f*g-s
			u[i][i]=f-g;
			for (j=l; j < n; j++)
			{
				s= 0.0
				for (k=i; k < m; k++) 
					s += u[k][i]*u[k][j]
				f= s/h
				for (k=i; k < m; k++) 
					u[k][j]+=f*u[k][i]
			}
		}
		q[i]= g
		s= 0.0
		for (j=l; j < n; j++) 
			s= s + u[i][j]*u[i][j]
		if (s <= tolerance)
			g= 0.0
		else
		{	
			f= u[i][i+1]
			g= Math.sqrt(s)
			if (f >= 0.0) g= -g
			h= f*g - s
			u[i][i+1] = f-g;
			for (j=l; j < n; j++) e[j]= u[i][j]/h
			for (j=l; j < m; j++)
			{	
				s=0.0
				for (k=l; k < n; k++) 
					s += (u[j][k]*u[i][k])
				for (k=l; k < n; k++) 
					u[j][k]+=s*e[k]
			}	
		}
		y= Math.abs(q[i])+Math.abs(e[i])
		if (y>x) 
			x=y
	}
	
	// accumulation of right hand gtransformations
	for (i=n-1; i != -1; i+= -1)
	{	
		if (g != 0.0)
		{
		 	h= g*u[i][i+1]
			for (j=l; j < n; j++) 
				v[j][i]=u[i][j]/h
			for (j=l; j < n; j++)
			{	
				s=0.0
				for (k=l; k < n; k++) 
					s += u[i][k]*v[k][j]
				for (k=l; k < n; k++) 
					v[k][j]+=(s*v[k][i])
			}	
		}
		for (j=l; j < n; j++)
		{
			v[i][j] = 0;
			v[j][i] = 0;
		}
		v[i][i] = 1;
		g= e[i]
		l= i
	}
	
	// accumulation of left hand transformations
	for (i=n-1; i != -1; i+= -1)
	{	
		l= i+1
		g= q[i]
		for (j=l; j < n; j++) 
			u[i][j] = 0;
		if (g != 0.0)
		{
			h= u[i][i]*g
			for (j=l; j < n; j++)
			{
				s=0.0
				for (k=l; k < m; k++) s += u[k][i]*u[k][j];
				f= s/h
				for (k=i; k < m; k++) u[k][j]+=f*u[k][i];
			}
			for (j=i; j < m; j++) u[j][i] = u[j][i]/g;
		}
		else
			for (j=i; j < m; j++) u[j][i] = 0;
		u[i][i] += 1;
	}
	
	// diagonalization of the bidiagonal form
	prec= prec*x
	for (k=n-1; k != -1; k+= -1)
	{
		for (var iteration=0; iteration < itmax; iteration++)
		{	// test f splitting
			var test_convergence = false
			for (l=k; l != -1; l+= -1)
			{	
				if (Math.abs(e[l]) <= prec)
				{	test_convergence= true
					break 
				}
				if (Math.abs(q[l-1]) <= prec)
					break 
			}
			if (!test_convergence)
			{	// cancellation of e[l] if l>0
				c= 0.0
				s= 1.0
				var l1= l-1
				for (i =l; i<k+1; i++)
				{	
					f= s*e[i]
					e[i]= c*e[i]
					if (Math.abs(f) <= prec)
						break
					g= q[i]
					h= pythag(f,g)
					q[i]= h
					c= g/h
					s= -f/h
					for (j=0; j < m; j++)
					{	
						y= u[j][l1]
						z= u[j][i]
						u[j][l1] =  y*c+(z*s)
						u[j][i] = -y*s+(z*c)
					} 
				}	
			}
			// test f convergence
			z= q[k]
			if (l== k)
			{	//convergence
				if (z<0.0)
				{	//q[k] is made non-negative
					q[k]= -z
					for (j=0; j < n; j++)
						v[j][k] = -v[j][k]
				}
				break  //break out of iteration loop and move on to next k value
			}
			if (iteration >= itmax-1)
				throw 'Error: no convergence.'
			// shift from bottom 2x2 minor
			x= q[l]
			y= q[k-1]
			g= e[k-1]
			h= e[k]
			f= ((y-z)*(y+z)+(g-h)*(g+h))/(2.0*h*y)
			g= pythag(f,1.0)
			if (f < 0.0)
				f= ((x-z)*(x+z)+h*(y/(f-g)-h))/x
			else
				f= ((x-z)*(x+z)+h*(y/(f+g)-h))/x
			// next QR transformation
			c= 1.0
			s= 1.0
			for (i=l+1; i< k+1; i++)
			{	
				g= e[i]
				y= q[i]
				h= s*g
				g= c*g
				z= pythag(f,h)
				e[i-1]= z
				c= f/z
				s= h/z
				f= x*c+g*s
				g= -x*s+g*c
				h= y*s
				y= y*c
				for (j=0; j < n; j++)
				{	
					x= v[j][i-1]
					z= v[j][i]
					v[j][i-1] = x*c+z*s
					v[j][i] = -x*s+z*c
				}
				z= pythag(f,h)
				q[i-1]= z
				c= f/z
				s= h/z
				f= c*g+s*y
				x= -s*g+c*y
				for (j=0; j < m; j++)
				{
					y= u[j][i-1]
					z= u[j][i]
					u[j][i-1] = y*c+z*s
					u[j][i] = -y*s+z*c
				}
			}
			e[l]= 0.0
			e[k]= f
			q[k]= x
		} 
	}
		
	//vt= transpose(v)
	//return (u,q,vt)
	for (i=0;i<q.length; i++) 
	  if (q[i] < prec) q[i] = 0
	  
	//sort eigenvalues	
	for (i=0; i< n; i++)
	{	 
	//writeln(q)
	 for (j=i-1; j >= 0; j--)
	 {
	  if (q[j] < q[i])
	  {
	//  writeln(i,'-',j)
	   c = q[j]
	   q[j] = q[i]
	   q[i] = c
	   for(k=0;k<u.length;k++) { temp = u[k][i]; u[k][i] = u[k][j]; u[k][j] = temp; }
	   for(k=0;k<v.length;k++) { temp = v[k][i]; v[k][i] = v[k][j]; v[k][j] = temp; }
//	   u.swapCols(i,j)
//	   v.swapCols(i,j)
	   i = j	   
	  }
	 }	
	}
	
	return {U:u,S:q,V:v}
};


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/openjscad-csg/index.js":
/*!*********************************************!*\
  !*** ./node_modules/openjscad-csg/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var csg = __webpack_require__(/*! ./src/csg.js */ "./node_modules/openjscad-csg/src/csg.js");
__webpack_require__(/*! ./src/formats.js */ "./node_modules/openjscad-csg/src/formats.js");

module.exports = csg;

/***/ }),

/***/ "./node_modules/openjscad-csg/src/csg.js":
/*!***********************************************!*\
  !*** ./node_modules/openjscad-csg/src/csg.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*

## IMPORTANT NOTE --- IMPORTANT 
The master for this file is located at:
https://github.com/joostn/openjscad/tree/gh-pages
That is the gh-pages branch of the joostn/openjscad project
If contributing from openjscad.org, please do NOT edit this local file but make pull requests against
above joostn/gh-pages branch.
## IMPORTANT NOTE --- IMPORTANT NOTE


## License

Copyright (c) 2014 bebbi (elghatta@gmail.com)
Copyright (c) 2013 Eduard Bespalov (edwbes@gmail.com)
Copyright (c) 2012 Joost Nieuwenhuijse (joost@newhouse.nl)
Copyright (c) 2011 Evan Wallace (http://evanw.github.com/csg.js/)
Copyright (c) 2012 Alexandre Girard (https://github.com/alx)

All code released under MIT license

## Overview

For an overview of the CSG process see the original csg.js code:
http://evanw.github.com/csg.js/

CSG operations through BSP trees suffer from one problem: heavy fragmentation
of polygons. If two CSG solids of n polygons are unified, the resulting solid may have
in the order of n*n polygons, because each polygon is split by the planes of all other
polygons. After a few operations the number of polygons explodes.

This version of CSG.js solves the problem in 3 ways:

1. Every polygon split is recorded in a tree (CSG.PolygonTreeNode). This is a separate
tree, not to be confused with the CSG tree. If a polygon is split into two parts but in
the end both fragments have not been discarded by the CSG operation, we can retrieve
the original unsplit polygon from the tree, instead of the two fragments.

This does not completely solve the issue though: if a polygon is split multiple times
the number of fragments depends on the order of subsequent splits, and we might still
end up with unncessary splits:
Suppose a polygon is first split into A and B, and then into A1, B1, A2, B2. Suppose B2 is
discarded. We will end up with 2 polygons: A and B1. Depending on the actual split boundaries
we could still have joined A and B1 into one polygon. Therefore a second approach is used as well:

2. After CSG operations all coplanar polygon fragments are joined by a retesselating
operation. See CSG.reTesselated(). Retesselation is done through a
linear sweep over the polygon surface. The sweep line passes over the y coordinates
of all vertices in the polygon. Polygons are split at each sweep line, and the fragments
are joined horizontally and vertically into larger polygons (making sure that we
will end up with convex polygons).
This still doesn't solve the problem completely: due to floating point imprecisions
we may end up with small gaps between polygons, and polygons may not be exactly coplanar
anymore, and as a result the retesselation algorithm may fail to join those polygons.
Therefore:

3. A canonicalization algorithm is implemented: it looks for vertices that have
approximately the same coordinates (with a certain tolerance, say 1e-5) and replaces
them with the same vertex. If polygons share a vertex they will actually point to the
same CSG.Vertex instance. The same is done for polygon planes. See CSG.canonicalized().


Performance improvements to the original CSG.js:

Replaced the flip() and invert() methods by flipped() and inverted() which don't
modify the source object. This allows to get rid of all clone() calls, so that
multiple polygons can refer to the same CSG.Plane instance etc.

The original union() used an extra invert(), clipTo(), invert() sequence just to remove the
coplanar front faces from b; this is now combined in a single b.clipTo(a, true) call.

Detection whether a polygon is in front or in back of a plane: for each polygon
we are caching the coordinates of the bounding sphere. If the bounding sphere is
in front or in back of the plane we don't have to check the individual vertices
anymore.


Other additions to the original CSG.js:

CSG.Vector class has been renamed into CSG.Vector3D

Classes for 3D lines, 2D vectors, 2D lines, and methods to find the intersection of
a line and a plane etc.

Transformations: CSG.transform(), CSG.translate(), CSG.rotate(), CSG.scale()

Expanding or contracting a solid: CSG.expand() and CSG.contract(). Creates nice
smooth corners.

The vertex normal has been removed since it complicates retesselation. It's not needed
for solid CAD anyway.

*/

(function(module) {

    var _CSGDEBUG = false;

    function fnNumberSort(a, b) {
        return a - b;
    }

    // # class CSG
    // Holds a binary space partition tree representing a 3D solid. Two solids can
    // be combined using the `union()`, `subtract()`, and `intersect()` methods.
    var CSG = function() {
        this.polygons = [];
        this.properties = new CSG.Properties();
        this.isCanonicalized = true;
        this.isRetesselated = true;
    };

    CSG.defaultResolution2D = 32;
    CSG.defaultResolution3D = 12;

    // Construct a CSG solid from a list of `CSG.Polygon` instances.
    CSG.fromPolygons = function(polygons) {
        var csg = new CSG();
        csg.polygons = polygons;
        csg.isCanonicalized = false;
        csg.isRetesselated = false;
        return csg;
    };

    // Construct a CSG solid from generated slices.
    // Look at CSG.Polygon.prototype.solidFromSlices for details
    CSG.fromSlices = function(options) {
        return (new CSG.Polygon.createFromPoints([
            [0, 0, 0],
            [1, 0, 0],
            [1, 1, 0],
            [0, 1, 0]
        ])).solidFromSlices(options);
    };

    // create from an untyped object with identical property names:
    CSG.fromObject = function(obj) {
        var polygons = obj.polygons.map(function(p) {
            return CSG.Polygon.fromObject(p);
        });
        var csg = CSG.fromPolygons(polygons);
        csg = csg.canonicalized();
        return csg;
    };

    // Reconstruct a CSG from the output of toCompactBinary()
    CSG.fromCompactBinary = function(bin) {
        if (bin['class'] != "CSG") throw new Error("Not a CSG");
        var planes = [],
            planeData = bin.planeData,
            numplanes = planeData.length / 4,
            arrayindex = 0,
            x, y, z, w, normal, plane;
        for (var planeindex = 0; planeindex < numplanes; planeindex++) {
            x = planeData[arrayindex++];
            y = planeData[arrayindex++];
            z = planeData[arrayindex++];
            w = planeData[arrayindex++];
            normal = CSG.Vector3D.Create(x, y, z);
            plane = new CSG.Plane(normal, w);
            planes.push(plane);
        }

        var vertices = [],
            vertexData = bin.vertexData,
            numvertices = vertexData.length / 3,
            pos, vertex;
        arrayindex = 0;
        for (var vertexindex = 0; vertexindex < numvertices; vertexindex++) {
            x = vertexData[arrayindex++];
            y = vertexData[arrayindex++];
            z = vertexData[arrayindex++];
            pos = CSG.Vector3D.Create(x, y, z);
            vertex = new CSG.Vertex(pos);
            vertices.push(vertex);
        }

        var shareds = bin.shared.map(function(shared) {
            return CSG.Polygon.Shared.fromObject(shared);
        });

        var polygons = [],
            numpolygons = bin.numPolygons,
            numVerticesPerPolygon = bin.numVerticesPerPolygon,
            polygonVertices = bin.polygonVertices,
            polygonPlaneIndexes = bin.polygonPlaneIndexes,
            polygonSharedIndexes = bin.polygonSharedIndexes,
            numpolygonvertices, polygonvertices, shared, polygon; //already defined plane,
        arrayindex = 0;
        for (var polygonindex = 0; polygonindex < numpolygons; polygonindex++) {
            numpolygonvertices = numVerticesPerPolygon[polygonindex];
            polygonvertices = [];
            for (var i = 0; i < numpolygonvertices; i++) {
                polygonvertices.push(vertices[polygonVertices[arrayindex++]]);
            }
            plane = planes[polygonPlaneIndexes[polygonindex]];
            shared = shareds[polygonSharedIndexes[polygonindex]];
            polygon = new CSG.Polygon(polygonvertices, shared, plane);
            polygons.push(polygon);
        }
        var csg = CSG.fromPolygons(polygons);
        csg.isCanonicalized = true;
        csg.isRetesselated = true;
        return csg;
    };

    CSG.prototype = {
        toPolygons: function() {
            return this.polygons;
        },

        // Return a new CSG solid representing space in either this solid or in the
        // solid `csg`. Neither this solid nor the solid `csg` are modified.
        //
        //     A.union(B)
        //
        //     +-------+            +-------+
        //     |       |            |       |
        //     |   A   |            |       |
        //     |    +--+----+   =   |       +----+
        //     +----+--+    |       +----+       |
        //          |   B   |            |       |
        //          |       |            |       |
        //          +-------+            +-------+
        //
        union: function(csg) {
            var csgs;
            if (csg instanceof Array) {
                csgs = csg.slice(0);
                csgs.push(this);
            } else {
                csgs = [this, csg];
            }

            // combine csg pairs in a way that forms a balanced binary tree pattern
            for (var i = 1; i < csgs.length; i += 2) {
                csgs.push(csgs[i-1].unionSub(csgs[i]));
            }

            return csgs[i - 1].reTesselated().canonicalized();
        },

        unionSub: function(csg, retesselate, canonicalize) {
            if (!this.mayOverlap(csg)) {
                return this.unionForNonIntersecting(csg);
            } else {
                var a = new CSG.Tree(this.polygons);
                var b = new CSG.Tree(csg.polygons);
                a.clipTo(b, false);

                // b.clipTo(a, true); // ERROR: this doesn't work
                b.clipTo(a);
                b.invert();
                b.clipTo(a);
                b.invert();

                var newpolygons = a.allPolygons().concat(b.allPolygons());
                var result = CSG.fromPolygons(newpolygons);
                result.properties = this.properties._merge(csg.properties);
                if (retesselate) result = result.reTesselated();
                if (canonicalize) result = result.canonicalized();
                return result;
            }
        },

        // Like union, but when we know that the two solids are not intersecting
        // Do not use if you are not completely sure that the solids do not intersect!
        unionForNonIntersecting: function(csg) {
            var newpolygons = this.polygons.concat(csg.polygons);
            var result = CSG.fromPolygons(newpolygons);
            result.properties = this.properties._merge(csg.properties);
            result.isCanonicalized = this.isCanonicalized && csg.isCanonicalized;
            result.isRetesselated = this.isRetesselated && csg.isRetesselated;
            return result;
        },

        // Return a new CSG solid representing space in this solid but not in the
        // solid `csg`. Neither this solid nor the solid `csg` are modified.
        //
        //     A.subtract(B)
        //
        //     +-------+            +-------+
        //     |       |            |       |
        //     |   A   |            |       |
        //     |    +--+----+   =   |    +--+
        //     +----+--+    |       +----+
        //          |   B   |
        //          |       |
        //          +-------+
        //
        subtract: function(csg) {
            var csgs;
            if (csg instanceof Array) {
                csgs = csg;
            } else {
                csgs = [csg];
            }
            var result = this;
            for (var i = 0; i < csgs.length; i++) {
                var islast = (i == (csgs.length - 1));
                result = result.subtractSub(csgs[i], islast, islast);
            }
            return result;
        },

        subtractSub: function(csg, retesselate, canonicalize) {
            var a = new CSG.Tree(this.polygons);
            var b = new CSG.Tree(csg.polygons);
            a.invert();
            a.clipTo(b);
            b.clipTo(a, true);
            a.addPolygons(b.allPolygons());
            a.invert();
            var result = CSG.fromPolygons(a.allPolygons());
            result.properties = this.properties._merge(csg.properties);
            if (retesselate) result = result.reTesselated();
            if (canonicalize) result = result.canonicalized();
            return result;
        },

        // Return a new CSG solid representing space both this solid and in the
        // solid `csg`. Neither this solid nor the solid `csg` are modified.
        //
        //     A.intersect(B)
        //
        //     +-------+
        //     |       |
        //     |   A   |
        //     |    +--+----+   =   +--+
        //     +----+--+    |       +--+
        //          |   B   |
        //          |       |
        //          +-------+
        //
        intersect: function(csg) {
            var csgs;
            if (csg instanceof Array) {
                csgs = csg;
            } else {
                csgs = [csg];
            }
            var result = this;
            for (var i = 0; i < csgs.length; i++) {
                var islast = (i == (csgs.length - 1));
                result = result.intersectSub(csgs[i], islast, islast);
            }
            return result;
        },

        intersectSub: function(csg, retesselate, canonicalize) {
            var a = new CSG.Tree(this.polygons);
            var b = new CSG.Tree(csg.polygons);
            a.invert();
            b.clipTo(a);
            b.invert();
            a.clipTo(b);
            b.clipTo(a);
            a.addPolygons(b.allPolygons());
            a.invert();
            var result = CSG.fromPolygons(a.allPolygons());
            result.properties = this.properties._merge(csg.properties);
            if (retesselate) result = result.reTesselated();
            if (canonicalize) result = result.canonicalized();
            return result;
        },

        // Return a new CSG solid with solid and empty space switched. This solid is
        // not modified.
        invert: function() {
            var flippedpolygons = this.polygons.map(function(p) {
                return p.flipped();
            });
            return CSG.fromPolygons(flippedpolygons);
            // TODO: flip properties?
        },

        // Affine transformation of CSG object. Returns a new CSG object
        transform1: function(matrix4x4) {
            var newpolygons = this.polygons.map(function(p) {
                return p.transform(matrix4x4);
            });
            var result = CSG.fromPolygons(newpolygons);
            result.properties = this.properties._transform(matrix4x4);
            result.isRetesselated = this.isRetesselated;
            return result;
        },

        transform: function(matrix4x4) {
            var ismirror = matrix4x4.isMirroring();
            var transformedvertices = {};
            var transformedplanes = {};
            var newpolygons = this.polygons.map(function(p) {
                var newplane;
                var plane = p.plane;
                var planetag = plane.getTag();
                if (planetag in transformedplanes) {
                    newplane = transformedplanes[planetag];
                } else {
                    newplane = plane.transform(matrix4x4);
                    transformedplanes[planetag] = newplane;
                }
                var newvertices = p.vertices.map(function(v) {
                    var newvertex;
                    var vertextag = v.getTag();
                    if (vertextag in transformedvertices) {
                        newvertex = transformedvertices[vertextag];
                    } else {
                        newvertex = v.transform(matrix4x4);
                        transformedvertices[vertextag] = newvertex;
                    }
                    return newvertex;
                });
                if (ismirror) newvertices.reverse();
                return new CSG.Polygon(newvertices, p.shared, newplane);
            });
            var result = CSG.fromPolygons(newpolygons);
            result.properties = this.properties._transform(matrix4x4);
            result.isRetesselated = this.isRetesselated;
            result.isCanonicalized = this.isCanonicalized;
            return result;
        },

        toString: function() {
            var result = "CSG solid:\n";
            this.polygons.map(function(p) {
                result += p.toString();
            });
            return result;
        },

        // Expand the solid
        // resolution: number of points per 360 degree for the rounded corners
        expand: function(radius, resolution) {
            var result = this.expandedShell(radius, resolution, true);
            result = result.reTesselated();
            result.properties = this.properties; // keep original properties
            return result;
        },

        // Contract the solid
        // resolution: number of points per 360 degree for the rounded corners
        contract: function(radius, resolution) {
            var expandedshell = this.expandedShell(radius, resolution, false);
            var result = this.subtract(expandedshell);
            result = result.reTesselated();
            result.properties = this.properties; // keep original properties
            return result;
        },

        // cut the solid at a plane, and stretch the cross-section found along plane normal
        stretchAtPlane: function(normal, point, length) {
            var plane = CSG.Plane.fromNormalAndPoint(normal, point);
            var onb = new CSG.OrthoNormalBasis(plane);
            var crosssect = this.sectionCut(onb);
            var midpiece = crosssect.extrudeInOrthonormalBasis(onb, length);
            var piece1 = this.cutByPlane(plane);
            var piece2 = this.cutByPlane(plane.flipped());
            var result = piece1.union([midpiece, piece2.translate(plane.normal.times(length))]);
            return result;
        },


        // Create the expanded shell of the solid:
        // All faces are extruded to get a thickness of 2*radius
        // Cylinders are constructed around every side
        // Spheres are placed on every vertex
        // unionWithThis: if true, the resulting solid will be united with 'this' solid;
        //   the result is a true expansion of the solid
        //   If false, returns only the shell
        expandedShell: function(radius, resolution, unionWithThis) {
            var csg = this.reTesselated();
            var result;
            if (unionWithThis) {
                result = csg;
            } else {
                result = new CSG();
            }

            // first extrude all polygons:
            csg.polygons.map(function(polygon) {
                var extrudevector = polygon.plane.normal.unit().times(2 * radius);
                var translatedpolygon = polygon.translate(extrudevector.times(-0.5));
                var extrudedface = translatedpolygon.extrude(extrudevector);
                result = result.unionSub(extrudedface, false, false);
            });

            // Make a list of all unique vertex pairs (i.e. all sides of the solid)
            // For each vertex pair we collect the following:
            //   v1: first coordinate
            //   v2: second coordinate
            //   planenormals: array of normal vectors of all planes touching this side
            var vertexpairs = {}; // map of 'vertex pair tag' to {v1, v2, planenormals}
            csg.polygons.map(function(polygon) {
                var numvertices = polygon.vertices.length;
                var prevvertex = polygon.vertices[numvertices - 1];
                var prevvertextag = prevvertex.getTag();
                for (var i = 0; i < numvertices; i++) {
                    var vertex = polygon.vertices[i];
                    var vertextag = vertex.getTag();
                    var vertextagpair;
                    if (vertextag < prevvertextag) {
                        vertextagpair = vertextag + "-" + prevvertextag;
                    } else {
                        vertextagpair = prevvertextag + "-" + vertextag;
                    }
                    var obj;
                    if (vertextagpair in vertexpairs) {
                        obj = vertexpairs[vertextagpair];
                    } else {
                        obj = {
                            v1: prevvertex,
                            v2: vertex,
                            planenormals: []
                        };
                        vertexpairs[vertextagpair] = obj;
                    }
                    obj.planenormals.push(polygon.plane.normal);

                    prevvertextag = vertextag;
                    prevvertex = vertex;
                }
            });

            // now construct a cylinder on every side
            // The cylinder is always an approximation of a true cylinder: it will have <resolution> polygons
            // around the sides. We will make sure though that the cylinder will have an edge at every
            // face that touches this side. This ensures that we will get a smooth fill even
            // if two edges are at, say, 10 degrees and the resolution is low.
            // Note: the result is not retesselated yet but it really should be!
            for (var vertextagpair in vertexpairs) {
                var vertexpair = vertexpairs[vertextagpair],
                    startpoint = vertexpair.v1.pos,
                    endpoint = vertexpair.v2.pos,
                    // our x,y and z vectors:
                    zbase = endpoint.minus(startpoint).unit(),
                    xbase = vertexpair.planenormals[0].unit(),
                    ybase = xbase.cross(zbase),

                    // make a list of angles that the cylinder should traverse:
                    angles = [];

                // first of all equally spaced around the cylinder:
                for (var i = 0; i < resolution; i++) {
                    angles.push(i * Math.PI * 2 / resolution);
                }

                // and also at every normal of all touching planes:
                for (var i = 0, iMax = vertexpair.planenormals.length; i < iMax; i++) {
                    var planenormal = vertexpair.planenormals[i],
                        si = ybase.dot(planenormal),
                        co = xbase.dot(planenormal),
                        angle = Math.atan2(si, co);

                    if (angle < 0) angle += Math.PI * 2;
                    angles.push(angle);
                    angle = Math.atan2(-si, -co);
                    if (angle < 0) angle += Math.PI * 2;
                    angles.push(angle);
                }

                // this will result in some duplicate angles but we will get rid of those later.
                // Sort:
                angles = angles.sort(fnNumberSort);

                // Now construct the cylinder by traversing all angles:
                var numangles = angles.length,
                    prevp1, prevp2,
                    startfacevertices = [],
                    endfacevertices = [],
                    polygons = [];
                for (var i = -1; i < numangles; i++) {
                    var angle = angles[(i < 0) ? (i + numangles) : i],
                        si = Math.sin(angle),
                        co = Math.cos(angle),
                        p = xbase.times(co * radius).plus(ybase.times(si * radius)),
                        p1 = startpoint.plus(p),
                        p2 = endpoint.plus(p),
                        skip = false;
                    if (i >= 0) {
                        if (p1.distanceTo(prevp1) < 1e-5) {
                            skip = true;
                        }
                    }
                    if (!skip) {
                        if (i >= 0) {
                            startfacevertices.push(new CSG.Vertex(p1));
                            endfacevertices.push(new CSG.Vertex(p2));
                            var polygonvertices = [
                                new CSG.Vertex(prevp2),
                                new CSG.Vertex(p2),
                                new CSG.Vertex(p1),
                                new CSG.Vertex(prevp1)
                            ];
                            var polygon = new CSG.Polygon(polygonvertices);
                            polygons.push(polygon);
                        }
                        prevp1 = p1;
                        prevp2 = p2;
                    }
                }
                endfacevertices.reverse();
                polygons.push(new CSG.Polygon(startfacevertices));
                polygons.push(new CSG.Polygon(endfacevertices));
                var cylinder = CSG.fromPolygons(polygons);
                result = result.unionSub(cylinder, false, false);
            }

            // make a list of all unique vertices
            // For each vertex we also collect the list of normals of the planes touching the vertices
            var vertexmap = {};
            csg.polygons.map(function(polygon) {
                polygon.vertices.map(function(vertex) {
                    var vertextag = vertex.getTag();
                    var obj;
                    if (vertextag in vertexmap) {
                        obj = vertexmap[vertextag];
                    } else {
                        obj = {
                            pos: vertex.pos,
                            normals: []
                        };
                        vertexmap[vertextag] = obj;
                    }
                    obj.normals.push(polygon.plane.normal);
                });
            });

            // and build spheres at each vertex
            // We will try to set the x and z axis to the normals of 2 planes
            // This will ensure that our sphere tesselation somewhat matches 2 planes
            for (var vertextag in vertexmap) {
                var vertexobj = vertexmap[vertextag];
                // use the first normal to be the x axis of our sphere:
                var xaxis = vertexobj.normals[0].unit();
                // and find a suitable z axis. We will use the normal which is most perpendicular to the x axis:
                var bestzaxis = null;
                var bestzaxisorthogonality = 0;
                for (var i = 1; i < vertexobj.normals.length; i++) {
                    var normal = vertexobj.normals[i].unit();
                    var cross = xaxis.cross(normal);
                    var crosslength = cross.length();
                    if (crosslength > 0.05) {
                        if (crosslength > bestzaxisorthogonality) {
                            bestzaxisorthogonality = crosslength;
                            bestzaxis = normal;
                        }
                    }
                }
                if (!bestzaxis) {
                    bestzaxis = xaxis.randomNonParallelVector();
                }
                var yaxis = xaxis.cross(bestzaxis).unit();
                var zaxis = yaxis.cross(xaxis);
                var sphere = CSG.sphere({
                    center: vertexobj.pos,
                    radius: radius,
                    resolution: resolution,
                    axes: [xaxis, yaxis, zaxis]
                });
                result = result.unionSub(sphere, false, false);
            }

            return result;
        },

        canonicalized: function() {
            if (this.isCanonicalized) {
                return this;
            } else {
                var factory = new CSG.fuzzyCSGFactory();
                var result = factory.getCSG(this);
                result.isCanonicalized = true;
                result.isRetesselated = this.isRetesselated;
                result.properties = this.properties; // keep original properties
                return result;
            }
        },

        reTesselated: function() {
            if (this.isRetesselated) {
                return this;
            } else {
                var csg = this;
                var polygonsPerPlane = {};
                var isCanonicalized = csg.isCanonicalized;
                var fuzzyfactory = new CSG.fuzzyCSGFactory();
                csg.polygons.map(function(polygon) {
                    var plane = polygon.plane;
                    var shared = polygon.shared;
                    if (!isCanonicalized) {
                        // in order to identify to polygons having the same plane, we need to canonicalize the planes
                        // We don't have to do a full canonizalization (including vertices), to save time only do the planes and the shared data:
                        plane = fuzzyfactory.getPlane(plane);
                        shared = fuzzyfactory.getPolygonShared(shared);
                    }
                    var tag = plane.getTag() + "/" + shared.getTag();
                    if (!(tag in polygonsPerPlane)) {
                        polygonsPerPlane[tag] = [polygon];
                    } else {
                        polygonsPerPlane[tag].push(polygon);
                    }
                });
                var destpolygons = [];
                for (var planetag in polygonsPerPlane) {
                    var sourcepolygons = polygonsPerPlane[planetag];
                    if (sourcepolygons.length < 2) {
                        destpolygons = destpolygons.concat(sourcepolygons);
                    } else {
                        var retesselayedpolygons = [];
                        CSG.reTesselateCoplanarPolygons(sourcepolygons, retesselayedpolygons);
                        destpolygons = destpolygons.concat(retesselayedpolygons);
                    }
                }
                var result = CSG.fromPolygons(destpolygons);
                result.isRetesselated = true;
                // result = result.canonicalized();
                result.properties = this.properties; // keep original properties
                return result;
            }
        },

        // returns an array of two CSG.Vector3Ds (minimum coordinates and maximum coordinates)
        getBounds: function() {
            if (!this.cachedBoundingBox) {
                var minpoint = new CSG.Vector3D(0, 0, 0);
                var maxpoint = new CSG.Vector3D(0, 0, 0);
                var polygons = this.polygons;
                var numpolygons = polygons.length;
                for (var i = 0; i < numpolygons; i++) {
                    var polygon = polygons[i];
                    var bounds = polygon.boundingBox();
                    if (i === 0) {
                        minpoint = bounds[0];
                        maxpoint = bounds[1];
                    } else {
                        minpoint = minpoint.min(bounds[0]);
                        maxpoint = maxpoint.max(bounds[1]);
                    }
                }
                this.cachedBoundingBox = [minpoint, maxpoint];
            }
            return this.cachedBoundingBox;
        },

        // returns true if there is a possibility that the two solids overlap
        // returns false if we can be sure that they do not overlap
        mayOverlap: function(csg) {
            if ((this.polygons.length === 0) || (csg.polygons.length === 0)) {
                return false;
            } else {
                var mybounds = this.getBounds();
                var otherbounds = csg.getBounds();
                if (mybounds[1].x < otherbounds[0].x) return false;
                if (mybounds[0].x > otherbounds[1].x) return false;
                if (mybounds[1].y < otherbounds[0].y) return false;
                if (mybounds[0].y > otherbounds[1].y) return false;
                if (mybounds[1].z < otherbounds[0].z) return false;
                if (mybounds[0].z > otherbounds[1].z) return false;
                return true;
            }
        },

        // Cut the solid by a plane. Returns the solid on the back side of the plane
        cutByPlane: function(plane) {
            if (this.polygons.length === 0) {
                return new CSG();
            }
            // Ideally we would like to do an intersection with a polygon of inifinite size
            // but this is not supported by our implementation. As a workaround, we will create
            // a cube, with one face on the plane, and a size larger enough so that the entire
            // solid fits in the cube.
            // find the max distance of any vertex to the center of the plane:
            var planecenter = plane.normal.times(plane.w);
            var maxdistance = 0;
            this.polygons.map(function(polygon) {
                polygon.vertices.map(function(vertex) {
                    var distance = vertex.pos.distanceToSquared(planecenter);
                    if (distance > maxdistance) maxdistance = distance;
                });
            });
            maxdistance = Math.sqrt(maxdistance);
            maxdistance *= 1.01; // make sure it's really larger
            // Now build a polygon on the plane, at any point farther than maxdistance from the plane center:
            var vertices = [];
            var orthobasis = new CSG.OrthoNormalBasis(plane);
            vertices.push(new CSG.Vertex(orthobasis.to3D(new CSG.Vector2D(maxdistance, -maxdistance))));
            vertices.push(new CSG.Vertex(orthobasis.to3D(new CSG.Vector2D(-maxdistance, -maxdistance))));
            vertices.push(new CSG.Vertex(orthobasis.to3D(new CSG.Vector2D(-maxdistance, maxdistance))));
            vertices.push(new CSG.Vertex(orthobasis.to3D(new CSG.Vector2D(maxdistance, maxdistance))));
            var polygon = new CSG.Polygon(vertices, null, plane.flipped());

            // and extrude the polygon into a cube, backwards of the plane:
            var cube = polygon.extrude(plane.normal.times(-maxdistance));

            // Now we can do the intersection:
            var result = this.intersect(cube);
            result.properties = this.properties; // keep original properties
            return result;
        },

        // Connect a solid to another solid, such that two CSG.Connectors become connected
        //   myConnector: a CSG.Connector of this solid
        //   otherConnector: a CSG.Connector to which myConnector should be connected
        //   mirror: false: the 'axis' vectors of the connectors should point in the same direction
        //           true: the 'axis' vectors of the connectors should point in opposite direction
        //   normalrotation: degrees of rotation between the 'normal' vectors of the two
        //                   connectors
        connectTo: function(myConnector, otherConnector, mirror, normalrotation) {
            var matrix = myConnector.getTransformationTo(otherConnector, mirror, normalrotation);
            return this.transform(matrix);
        },

        // set the .shared property of all polygons
        // Returns a new CSG solid, the original is unmodified!
        setShared: function(shared) {
            var polygons = this.polygons.map(function(p) {
                return new CSG.Polygon(p.vertices, shared, p.plane);
            });
            var result = CSG.fromPolygons(polygons);
            result.properties = this.properties; // keep original properties
            result.isRetesselated = this.isRetesselated;
            result.isCanonicalized = this.isCanonicalized;
            return result;
        },

        setColor: function(args) {
            var newshared = CSG.Polygon.Shared.fromColor.apply(this, arguments);
            return this.setShared(newshared);
        },

        toCompactBinary: function() {
            var csg = this.canonicalized(),
                numpolygons = csg.polygons.length,
                numpolygonvertices = 0,
                numvertices = 0,
                vertexmap = {},
                vertices = [],
                numplanes = 0,
                planemap = {},
                polygonindex = 0,
                planes = [],
                shareds = [],
                sharedmap = {},
                numshared = 0;
            // for (var i = 0, iMax = csg.polygons.length; i < iMax; i++) {
            //  var p = csg.polygons[i];
            //  for (var j = 0, jMax = p.length; j < jMax; j++) {
            //      ++numpolygonvertices;
            //      var vertextag = p[j].getTag();
            //      if(!(vertextag in vertexmap)) {
            //          vertexmap[vertextag] = numvertices++;
            //          vertices.push(p[j]);
            //      }
            //  }
            csg.polygons.map(function(p) {
                p.vertices.map(function(v) {
                    ++numpolygonvertices;
                    var vertextag = v.getTag();
                    if (!(vertextag in vertexmap)) {
                        vertexmap[vertextag] = numvertices++;
                        vertices.push(v);
                    }
                });

                var planetag = p.plane.getTag();
                if (!(planetag in planemap)) {
                    planemap[planetag] = numplanes++;
                    planes.push(p.plane);
                }
                var sharedtag = p.shared.getTag();
                if (!(sharedtag in sharedmap)) {
                    sharedmap[sharedtag] = numshared++;
                    shareds.push(p.shared);
                }
            });
            var numVerticesPerPolygon = new Uint32Array(numpolygons),
                polygonSharedIndexes = new Uint32Array(numpolygons),
                polygonVertices = new Uint32Array(numpolygonvertices),
                polygonPlaneIndexes = new Uint32Array(numpolygons),
                vertexData = new Float64Array(numvertices * 3),
                planeData = new Float64Array(numplanes * 4),
                polygonVerticesIndex = 0;
            for (var polygonindex = 0; polygonindex < numpolygons; ++polygonindex) {
                var p = csg.polygons[polygonindex];
                numVerticesPerPolygon[polygonindex] = p.vertices.length;
                p.vertices.map(function(v) {
                    var vertextag = v.getTag();
                    var vertexindex = vertexmap[vertextag];
                    polygonVertices[polygonVerticesIndex++] = vertexindex;
                });
                var planetag = p.plane.getTag();
                var planeindex = planemap[planetag];
                polygonPlaneIndexes[polygonindex] = planeindex;
                var sharedtag = p.shared.getTag();
                var sharedindex = sharedmap[sharedtag];
                polygonSharedIndexes[polygonindex] = sharedindex;
            }
            var verticesArrayIndex = 0;
            vertices.map(function(v) {
                var pos = v.pos;
                vertexData[verticesArrayIndex++] = pos._x;
                vertexData[verticesArrayIndex++] = pos._y;
                vertexData[verticesArrayIndex++] = pos._z;
            });
            var planesArrayIndex = 0;
            planes.map(function(p) {
                var normal = p.normal;
                planeData[planesArrayIndex++] = normal._x;
                planeData[planesArrayIndex++] = normal._y;
                planeData[planesArrayIndex++] = normal._z;
                planeData[planesArrayIndex++] = p.w;
            });
            var result = {
                "class": "CSG",
                numPolygons: numpolygons,
                numVerticesPerPolygon: numVerticesPerPolygon,
                polygonPlaneIndexes: polygonPlaneIndexes,
                polygonSharedIndexes: polygonSharedIndexes,
                polygonVertices: polygonVertices,
                vertexData: vertexData,
                planeData: planeData,
                shared: shareds
            };
            return result;
        },

        // For debugging
        // Creates a new solid with a tiny cube at every vertex of the source solid
        toPointCloud: function(cuberadius) {
            var csg = this.reTesselated();

            var result = new CSG();

            // make a list of all unique vertices
            // For each vertex we also collect the list of normals of the planes touching the vertices
            var vertexmap = {};
            csg.polygons.map(function(polygon) {
                polygon.vertices.map(function(vertex) {
                    vertexmap[vertex.getTag()] = vertex.pos;
                });
            });

            for (var vertextag in vertexmap) {
                var pos = vertexmap[vertextag];
                var cube = CSG.cube({
                    center: pos,
                    radius: cuberadius
                });
                result = result.unionSub(cube, false, false);
            }
            result = result.reTesselated();
            return result;
        },

        // Get the transformation that transforms this CSG such that it is lying on the z=0 plane,
        // as flat as possible (i.e. the least z-height).
        // So that it is in an orientation suitable for CNC milling
        getTransformationAndInverseTransformationToFlatLying: function() {
            if (this.polygons.length === 0) {
                return new CSG.Matrix4x4(); // unity
            } else {
                // get a list of unique planes in the CSG:
                var csg = this.canonicalized();
                var planemap = {};
                csg.polygons.map(function(polygon) {
                    planemap[polygon.plane.getTag()] = polygon.plane;
                });
                // try each plane in the CSG and find the plane that, when we align it flat onto z=0,
                // gives the least height in z-direction.
                // If two planes give the same height, pick the plane that originally had a normal closest
                // to [0,0,-1].
                var xvector = new CSG.Vector3D(1, 0, 0);
                var yvector = new CSG.Vector3D(0, 1, 0);
                var zvector = new CSG.Vector3D(0, 0, 1);
                var z0connectorx = new CSG.Connector([0, 0, 0], [0, 0, -1], xvector);
                var z0connectory = new CSG.Connector([0, 0, 0], [0, 0, -1], yvector);
                var isfirst = true;
                var minheight = 0;
                var maxdotz = 0;
                var besttransformation, bestinversetransformation;
                for (var planetag in planemap) {
                    var plane = planemap[planetag];
                    var pointonplane = plane.normal.times(plane.w);
                    var transformation, inversetransformation;
                    // We need a normal vecrtor for the transformation
                    // determine which is more perpendicular to the plane normal: x or y?
                    // we will align this as much as possible to the x or y axis vector
                    var xorthogonality = plane.normal.cross(xvector).length();
                    var yorthogonality = plane.normal.cross(yvector).length();
                    if (xorthogonality > yorthogonality) {
                        // x is better:
                        var planeconnector = new CSG.Connector(pointonplane, plane.normal, xvector);
                        transformation = planeconnector.getTransformationTo(z0connectorx, false, 0);
                        inversetransformation = z0connectorx.getTransformationTo(planeconnector, false, 0);
                    } else {
                        // y is better:
                        var planeconnector = new CSG.Connector(pointonplane, plane.normal, yvector);
                        transformation = planeconnector.getTransformationTo(z0connectory, false, 0);
                        inversetransformation = z0connectory.getTransformationTo(planeconnector, false, 0);
                    }
                    var transformedcsg = csg.transform(transformation);
                    var dotz = -plane.normal.dot(zvector);
                    var bounds = transformedcsg.getBounds();
                    var zheight = bounds[1].z - bounds[0].z;
                    var isbetter = isfirst;
                    if (!isbetter) {
                        if (zheight < minheight) {
                            isbetter = true;
                        } else if (zheight == minheight) {
                            if (dotz > maxdotz) isbetter = true;
                        }
                    }
                    if (isbetter) {
                        // translate the transformation around the z-axis and onto the z plane:
                        var translation = new CSG.Vector3D([-0.5 * (bounds[1].x + bounds[0].x), -0.5 * (bounds[1].y + bounds[0].y), -bounds[0].z]);
                        transformation = transformation.multiply(CSG.Matrix4x4.translation(translation));
                        inversetransformation = CSG.Matrix4x4.translation(translation.negated()).multiply(inversetransformation);
                        minheight = zheight;
                        maxdotz = dotz;
                        besttransformation = transformation;
                        bestinversetransformation = inversetransformation;
                    }
                    isfirst = false;
                }
                return [besttransformation, bestinversetransformation];
            }
        },

        getTransformationToFlatLying: function() {
            var result = this.getTransformationAndInverseTransformationToFlatLying();
            return result[0];
        },

        lieFlat: function() {
            var transformation = this.getTransformationToFlatLying();
            return this.transform(transformation);
        },

        // project the 3D CSG onto a plane
        // This returns a 2D CAG with the 'shadow' shape of the 3D solid when projected onto the
        // plane represented by the orthonormal basis
        projectToOrthoNormalBasis: function(orthobasis) {
            var EPS = 1e-5;
            var cags = [];
            this.polygons.filter(function(p) {
                    // only return polys in plane, others may disturb result
                    return p.plane.normal.minus(orthobasis.plane.normal).lengthSquared() < EPS*EPS;
                })
                .map(function(polygon) {
                    var cag = polygon.projectToOrthoNormalBasis(orthobasis);
                    if (cag.sides.length > 0) {
                        cags.push(cag);
                    }
            });
            var result = new CAG().union(cags);
            return result;
        },

        sectionCut: function(orthobasis) {
            var EPS = 1e-5;
            var plane1 = orthobasis.plane;
            var plane2 = orthobasis.plane.flipped();
            plane1 = new CSG.Plane(plane1.normal, plane1.w);
            plane2 = new CSG.Plane(plane2.normal, plane2.w + 5*EPS);
            var cut3d = this.cutByPlane(plane1);
            cut3d = cut3d.cutByPlane(plane2);
            return cut3d.projectToOrthoNormalBasis(orthobasis);
        },

        /*
         fixTJunctions:

         Suppose we have two polygons ACDB and EDGF:

          A-----B
          |     |
          |     E--F
          |     |  |
          C-----D--G

         Note that vertex E forms a T-junction on the side BD. In this case some STL slicers will complain
         that the solid is not watertight. This is because the watertightness check is done by checking if
         each side DE is matched by another side ED.

         This function will return a new solid with ACDB replaced by ACDEB

         Note that this can create polygons that are slightly non-convex (due to rounding errors). Therefore the result should
         not be used for further CSG operations!
         */
        fixTJunctions: function() {
            var csg = this.canonicalized();
            var sidemap = {};
            for (var polygonindex = 0; polygonindex < csg.polygons.length; polygonindex++) {
                var polygon = csg.polygons[polygonindex];
                var numvertices = polygon.vertices.length;
                if (numvertices >= 3) // should be true
                {
                    var vertex = polygon.vertices[0];
                    var vertextag = vertex.getTag();
                    for (var vertexindex = 0; vertexindex < numvertices; vertexindex++) {
                        var nextvertexindex = vertexindex + 1;
                        if (nextvertexindex == numvertices) nextvertexindex = 0;
                        var nextvertex = polygon.vertices[nextvertexindex];
                        var nextvertextag = nextvertex.getTag();
                        var sidetag = vertextag + "/" + nextvertextag;
                        var reversesidetag = nextvertextag + "/" + vertextag;
                        if (reversesidetag in sidemap) {
                            // this side matches the same side in another polygon. Remove from sidemap:
                            var ar = sidemap[reversesidetag];
                            ar.splice(-1, 1);
                            if (ar.length === 0) {
                                delete sidemap[reversesidetag];
                            }
                        } else {
                            var sideobj = {
                                vertex0: vertex,
                                vertex1: nextvertex,
                                polygonindex: polygonindex
                            };
                            if (!(sidetag in sidemap)) {
                                sidemap[sidetag] = [sideobj];
                            } else {
                                sidemap[sidetag].push(sideobj);
                            }
                        }
                        vertex = nextvertex;
                        vertextag = nextvertextag;
                    }
                }
            }
            // now sidemap contains 'unmatched' sides
            // i.e. side AB in one polygon does not have a matching side BA in another polygon
            var vertextag2sidestart = {};
            var vertextag2sideend = {};
            var sidestocheck = {};
            var sidemapisempty = true;
            for (var sidetag in sidemap) {
                sidemapisempty = false;
                sidestocheck[sidetag] = true;
                sidemap[sidetag].map(function(sideobj) {
                    var starttag = sideobj.vertex0.getTag();
                    var endtag = sideobj.vertex1.getTag();
                    if (starttag in vertextag2sidestart) {
                        vertextag2sidestart[starttag].push(sidetag);
                    } else {
                        vertextag2sidestart[starttag] = [sidetag];
                    }
                    if (endtag in vertextag2sideend) {
                        vertextag2sideend[endtag].push(sidetag);
                    } else {
                        vertextag2sideend[endtag] = [sidetag];
                    }
                });
            }

            if (!sidemapisempty) {
                // make a copy of the polygons array, since we are going to modify it:
                var polygons = csg.polygons.slice(0);

                function addSide(vertex0, vertex1, polygonindex) {
                    var starttag = vertex0.getTag();
                    var endtag = vertex1.getTag();
                    if (starttag == endtag) throw new Error("Assertion failed");
                    var newsidetag = starttag + "/" + endtag;
                    var reversesidetag = endtag + "/" + starttag;
                    if (reversesidetag in sidemap) {
                        // we have a matching reverse oriented side.
                        // Instead of adding the new side, cancel out the reverse side:
                        // console.log("addSide("+newsidetag+") has reverse side:");
                        deleteSide(vertex1, vertex0, null);
                        return null;
                    }
                    //  console.log("addSide("+newsidetag+")");
                    var newsideobj = {
                        vertex0: vertex0,
                        vertex1: vertex1,
                        polygonindex: polygonindex
                    };
                    if (!(newsidetag in sidemap)) {
                        sidemap[newsidetag] = [newsideobj];
                    } else {
                        sidemap[newsidetag].push(newsideobj);
                    }
                    if (starttag in vertextag2sidestart) {
                        vertextag2sidestart[starttag].push(newsidetag);
                    } else {
                        vertextag2sidestart[starttag] = [newsidetag];
                    }
                    if (endtag in vertextag2sideend) {
                        vertextag2sideend[endtag].push(newsidetag);
                    } else {
                        vertextag2sideend[endtag] = [newsidetag];
                    }
                    return newsidetag;
                }

                function deleteSide(vertex0, vertex1, polygonindex) {
                    var starttag = vertex0.getTag();
                    var endtag = vertex1.getTag();
                    var sidetag = starttag + "/" + endtag;
                    // console.log("deleteSide("+sidetag+")");
                    if (!(sidetag in sidemap)) throw new Error("Assertion failed");
                    var idx = -1;
                    var sideobjs = sidemap[sidetag];
                    for (var i = 0; i < sideobjs.length; i++) {
                        var sideobj = sideobjs[i];
                        if (sideobj.vertex0 != vertex0) continue;
                        if (sideobj.vertex1 != vertex1) continue;
                        if (polygonindex !== null) {
                            if (sideobj.polygonindex != polygonindex) continue;
                        }
                        idx = i;
                        break;
                    }
                    if (idx < 0) throw new Error("Assertion failed");
                    sideobjs.splice(idx, 1);
                    if (sideobjs.length === 0) {
                        delete sidemap[sidetag];
                    }
                    idx = vertextag2sidestart[starttag].indexOf(sidetag);
                    if (idx < 0) throw new Error("Assertion failed");
                    vertextag2sidestart[starttag].splice(idx, 1);
                    if (vertextag2sidestart[starttag].length === 0) {
                        delete vertextag2sidestart[starttag];
                    }

                    idx = vertextag2sideend[endtag].indexOf(sidetag);
                    if (idx < 0) throw new Error("Assertion failed");
                    vertextag2sideend[endtag].splice(idx, 1);
                    if (vertextag2sideend[endtag].length === 0) {
                        delete vertextag2sideend[endtag];
                    }
                }


                while (true) {
                    var sidemapisempty = true;
                    for (var sidetag in sidemap) {
                        sidemapisempty = false;
                        sidestocheck[sidetag] = true;
                    }
                    if (sidemapisempty) break;
                    var donesomething = false;
                    while (true) {
                        var sidetagtocheck = null;
                        for (var sidetag in sidestocheck) {
                            sidetagtocheck = sidetag;
                            break;
                        }
                        if (sidetagtocheck === null) break; // sidestocheck is empty, we're done!
                        var donewithside = true;
                        if (sidetagtocheck in sidemap) {
                            var sideobjs = sidemap[sidetagtocheck];
                            if (sideobjs.length === 0) throw new Error("Assertion failed");
                            var sideobj = sideobjs[0];
                            for (var directionindex = 0; directionindex < 2; directionindex++) {
                                var startvertex = (directionindex === 0) ? sideobj.vertex0 : sideobj.vertex1;
                                var endvertex = (directionindex === 0) ? sideobj.vertex1 : sideobj.vertex0;
                                var startvertextag = startvertex.getTag();
                                var endvertextag = endvertex.getTag();
                                var matchingsides = [];
                                if (directionindex === 0) {
                                    if (startvertextag in vertextag2sideend) {
                                        matchingsides = vertextag2sideend[startvertextag];
                                    }
                                } else {
                                    if (startvertextag in vertextag2sidestart) {
                                        matchingsides = vertextag2sidestart[startvertextag];
                                    }
                                }
                                for (var matchingsideindex = 0; matchingsideindex < matchingsides.length; matchingsideindex++) {
                                    var matchingsidetag = matchingsides[matchingsideindex];
                                    var matchingside = sidemap[matchingsidetag][0];
                                    var matchingsidestartvertex = (directionindex === 0) ? matchingside.vertex0 : matchingside.vertex1;
                                    var matchingsideendvertex = (directionindex === 0) ? matchingside.vertex1 : matchingside.vertex0;
                                    var matchingsidestartvertextag = matchingsidestartvertex.getTag();
                                    var matchingsideendvertextag = matchingsideendvertex.getTag();
                                    if (matchingsideendvertextag != startvertextag) throw new Error("Assertion failed");
                                    if (matchingsidestartvertextag == endvertextag) {
                                        // matchingside cancels sidetagtocheck
                                        deleteSide(startvertex, endvertex, null);
                                        deleteSide(endvertex, startvertex, null);
                                        donewithside = false;
                                        directionindex = 2; // skip reverse direction check
                                        donesomething = true;
                                        break;
                                    } else {
                                        var startpos = startvertex.pos;
                                        var endpos = endvertex.pos;
                                        var checkpos = matchingsidestartvertex.pos;
                                        var direction = checkpos.minus(startpos);
                                        // Now we need to check if endpos is on the line startpos-checkpos:
                                        var t = endpos.minus(startpos).dot(direction) / direction.dot(direction);
                                        if ((t > 0) && (t < 1)) {
                                            var closestpoint = startpos.plus(direction.times(t));
                                            var distancesquared = closestpoint.distanceToSquared(endpos);
                                            if (distancesquared < 1e-10) {
                                                // Yes it's a t-junction! We need to split matchingside in two:
                                                var polygonindex = matchingside.polygonindex;
                                                var polygon = polygons[polygonindex];
                                                // find the index of startvertextag in polygon:
                                                var insertionvertextag = matchingside.vertex1.getTag();
                                                var insertionvertextagindex = -1;
                                                for (var i = 0; i < polygon.vertices.length; i++) {
                                                    if (polygon.vertices[i].getTag() == insertionvertextag) {
                                                        insertionvertextagindex = i;
                                                        break;
                                                    }
                                                }
                                                if (insertionvertextagindex < 0) throw new Error("Assertion failed");
                                                // split the side by inserting the vertex:
                                                var newvertices = polygon.vertices.slice(0);
                                                newvertices.splice(insertionvertextagindex, 0, endvertex);
                                                var newpolygon = new CSG.Polygon(newvertices, polygon.shared /*polygon.plane*/ );
                                                polygons[polygonindex] = newpolygon;

                                                // remove the original sides from our maps:
                                                // deleteSide(sideobj.vertex0, sideobj.vertex1, null);
                                                deleteSide(matchingside.vertex0, matchingside.vertex1, polygonindex);
                                                var newsidetag1 = addSide(matchingside.vertex0, endvertex, polygonindex);
                                                var newsidetag2 = addSide(endvertex, matchingside.vertex1, polygonindex);
                                                if (newsidetag1 !== null) sidestocheck[newsidetag1] = true;
                                                if (newsidetag2 !== null) sidestocheck[newsidetag2] = true;
                                                donewithside = false;
                                                directionindex = 2; // skip reverse direction check
                                                donesomething = true;
                                                break;
                                            } // if(distancesquared < 1e-10)
                                        } // if( (t > 0) && (t < 1) )
                                    } // if(endingstidestartvertextag == endvertextag)
                                } // for matchingsideindex
                            } // for directionindex
                        } // if(sidetagtocheck in sidemap)
                        if (donewithside) {
                            delete sidestocheck[sidetag];
                        }
                    }
                    if (!donesomething) break;
                }
                var newcsg = CSG.fromPolygons(polygons);
                newcsg.properties = csg.properties;
                newcsg.isCanonicalized = true;
                newcsg.isRetesselated = true;
                csg = newcsg;
            } // if(!sidemapisempty)
            var sidemapisempty = true;
            for (var sidetag in sidemap) {
                sidemapisempty = false;
                break;
            }
            if (!sidemapisempty) {
                // throw new Error("!sidemapisempty");
            OpenJsCad.log("!sidemapisempty");
            }
            return csg;
        },

        toTriangles: function() {
            var polygons = [];
            this.polygons.forEach(function(poly) {
                var firstVertex = poly.vertices[0];
                for (var i = poly.vertices.length - 3; i >= 0; i--) {
                    polygons.push(new CSG.Polygon([
                            firstVertex, poly.vertices[i + 1], poly.vertices[i + 2]
                        ],
                        poly.shared, poly.plane));
                }
            });
            return polygons;
        },

        // features: string, or array containing 1 or more strings of: 'volume', 'area'
        // more could be added here (Fourier coeff, moments)
        getFeatures: function(features) {
            if (!(features instanceof Array)) {
                features = [features];
            }
            var result = this.toTriangles().map(function(triPoly) {
                    return triPoly.getTetraFeatures(features);
                })
                .reduce(function(pv, v) {
                    return v.map(function(feat, i) {
                        return feat + (pv === 0 ? 0 : pv[i]);
                    });
                }, 0);
            return (result.length == 1) ? result[0] : result;
        }
    };

    // Parse an option from the options object
    // If the option is not present, return the default value
    CSG.parseOption = function(options, optionname, defaultvalue) {
        var result = defaultvalue;
        if (options) {
            if (optionname in options) {
                result = options[optionname];
            }
        }
        return result;
    };

    // Parse an option and force into a CSG.Vector3D. If a scalar is passed it is converted
    // into a vector with equal x,y,z
    CSG.parseOptionAs3DVector = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        result = new CSG.Vector3D(result);
        return result;
    };

    CSG.parseOptionAs3DVectorList = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        return result.map(function(res) {
            return new CSG.Vector3D(res);
        });
    };

    // Parse an option and force into a CSG.Vector2D. If a scalar is passed it is converted
    // into a vector with equal x,y
    CSG.parseOptionAs2DVector = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        result = new CSG.Vector2D(result);
        return result;
    };

    CSG.parseOptionAsFloat = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        if (typeof(result) == "string") {
            result = Number(result);
        }
        if (isNaN(result) || typeof(result) != "number") {
            throw new Error("Parameter " + optionname + " should be a number");
        }
        return result;
    };

    CSG.parseOptionAsInt = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        result = Number(Math.floor(result));
        if (isNaN(result)) {
            throw new Error("Parameter " + optionname + " should be a number");
        }
        return result;
    };

    CSG.parseOptionAsBool = function(options, optionname, defaultvalue) {
        var result = CSG.parseOption(options, optionname, defaultvalue);
        if (typeof(result) == "string") {
            if (result == "true") result = true;
            else if (result == "false") result = false;
            else if (result == 0) result = false;
        }
        result = !!result;
        return result;
    };

    // Construct an axis-aligned solid cuboid.
    // Parameters:
    //   center: center of cube (default [0,0,0])
    //   radius: radius of cube (default [1,1,1]), can be specified as scalar or as 3D vector
    //
    // Example code:
    //
    //     var cube = CSG.cube({
    //       center: [0, 0, 0],
    //       radius: 1
    //     });
    CSG.cube = function(options) {
        var c, r;
        options = options || {};
        if (('corner1' in options) || ('corner2' in options)) {
            if (('center' in options) || ('radius' in options)) {
                throw new Error("cube: should either give a radius and center parameter, or a corner1 and corner2 parameter")
            }
            corner1 = CSG.parseOptionAs3DVector(options, "corner1", [0, 0, 0]);
            corner2 = CSG.parseOptionAs3DVector(options, "corner2", [1, 1, 1]);
            c = corner1.plus(corner2).times(0.5);
            r = corner2.minus(corner1).times(0.5);
        } else {
            c = CSG.parseOptionAs3DVector(options, "center", [0, 0, 0]);
            r = CSG.parseOptionAs3DVector(options, "radius", [1, 1, 1]);
        }
        r = r.abs(); // negative radii make no sense
        var result = CSG.fromPolygons([
            [
                [0, 4, 6, 2],
                [-1, 0, 0]
            ],
            [
                [1, 3, 7, 5],
                [+1, 0, 0]
            ],
            [
                [0, 1, 5, 4],
                [0, -1, 0]
            ],
            [
                [2, 6, 7, 3],
                [0, +1, 0]
            ],
            [
                [0, 2, 3, 1],
                [0, 0, -1]
            ],
            [
                [4, 5, 7, 6],
                [0, 0, +1]
            ]
        ].map(function(info) {
            //var normal = new CSG.Vector3D(info[1]);
            //var plane = new CSG.Plane(normal, 1);
            var vertices = info[0].map(function(i) {
                var pos = new CSG.Vector3D(
                    c.x + r.x * (2 * !!(i & 1) - 1), c.y + r.y * (2 * !!(i & 2) - 1), c.z + r.z * (2 * !!(i & 4) - 1));
                return new CSG.Vertex(pos);
            });
            return new CSG.Polygon(vertices, null /* , plane */ );
        }));
        result.properties.cube = new CSG.Properties();
        result.properties.cube.center = new CSG.Vector3D(c);
        // add 6 connectors, at the centers of each face:
        result.properties.cube.facecenters = [
            new CSG.Connector(new CSG.Vector3D([r.x, 0, 0]).plus(c), [1, 0, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([-r.x, 0, 0]).plus(c), [-1, 0, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, r.y, 0]).plus(c), [0, 1, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, -r.y, 0]).plus(c), [0, -1, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, 0, r.z]).plus(c), [0, 0, 1], [1, 0, 0]),
            new CSG.Connector(new CSG.Vector3D([0, 0, -r.z]).plus(c), [0, 0, -1], [1, 0, 0])
        ];
        return result;
    };

    // Construct a solid sphere
    //
    // Parameters:
    //   center: center of sphere (default [0,0,0])
    //   radius: radius of sphere (default 1), must be a scalar
    //   resolution: determines the number of polygons per 360 degree revolution (default 12)
    //   axes: (optional) an array with 3 vectors for the x, y and z base vectors
    //
    // Example usage:
    //
    //     var sphere = CSG.sphere({
    //       center: [0, 0, 0],
    //       radius: 2,
    //       resolution: 32,
    //     });
    CSG.sphere = function(options) {
        options = options || {};
        var center = CSG.parseOptionAs3DVector(options, "center", [0, 0, 0]);
        var radius = CSG.parseOptionAsFloat(options, "radius", 1);
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution3D);
        var xvector, yvector, zvector;
        if ('axes' in options) {
            xvector = options.axes[0].unit().times(radius);
            yvector = options.axes[1].unit().times(radius);
            zvector = options.axes[2].unit().times(radius);
        } else {
            xvector = new CSG.Vector3D([1, 0, 0]).times(radius);
            yvector = new CSG.Vector3D([0, -1, 0]).times(radius);
            zvector = new CSG.Vector3D([0, 0, 1]).times(radius);
        }
        if (resolution < 4) resolution = 4;
        var qresolution = Math.round(resolution / 4);
        var prevcylinderpoint;
        var polygons = [];
        for (var slice1 = 0; slice1 <= resolution; slice1++) {
            var angle = Math.PI * 2.0 * slice1 / resolution;
            var cylinderpoint = xvector.times(Math.cos(angle)).plus(yvector.times(Math.sin(angle)));
            if (slice1 > 0) {
                // cylinder vertices:
                var vertices = [];
                var prevcospitch, prevsinpitch;
                for (var slice2 = 0; slice2 <= qresolution; slice2++) {
                    var pitch = 0.5 * Math.PI * slice2 / qresolution;
                    var cospitch = Math.cos(pitch);
                    var sinpitch = Math.sin(pitch);
                    if (slice2 > 0) {
                        vertices = [];
                        vertices.push(new CSG.Vertex(center.plus(prevcylinderpoint.times(prevcospitch).minus(zvector.times(prevsinpitch)))));
                        vertices.push(new CSG.Vertex(center.plus(cylinderpoint.times(prevcospitch).minus(zvector.times(prevsinpitch)))));
                        if (slice2 < qresolution) {
                            vertices.push(new CSG.Vertex(center.plus(cylinderpoint.times(cospitch).minus(zvector.times(sinpitch)))));
                        }
                        vertices.push(new CSG.Vertex(center.plus(prevcylinderpoint.times(cospitch).minus(zvector.times(sinpitch)))));
                        polygons.push(new CSG.Polygon(vertices));
                        vertices = [];
                        vertices.push(new CSG.Vertex(center.plus(prevcylinderpoint.times(prevcospitch).plus(zvector.times(prevsinpitch)))));
                        vertices.push(new CSG.Vertex(center.plus(cylinderpoint.times(prevcospitch).plus(zvector.times(prevsinpitch)))));
                        if (slice2 < qresolution) {
                            vertices.push(new CSG.Vertex(center.plus(cylinderpoint.times(cospitch).plus(zvector.times(sinpitch)))));
                        }
                        vertices.push(new CSG.Vertex(center.plus(prevcylinderpoint.times(cospitch).plus(zvector.times(sinpitch)))));
                        vertices.reverse();
                        polygons.push(new CSG.Polygon(vertices));
                    }
                    prevcospitch = cospitch;
                    prevsinpitch = sinpitch;
                }
            }
            prevcylinderpoint = cylinderpoint;
        }
        var result = CSG.fromPolygons(polygons);
        result.properties.sphere = new CSG.Properties();
        result.properties.sphere.center = new CSG.Vector3D(center);
        result.properties.sphere.facepoint = center.plus(xvector);
        return result;
    };

    // Construct a solid cylinder.
    //
    // Parameters:
    //   start: start point of cylinder (default [0, -1, 0])
    //   end: end point of cylinder (default [0, 1, 0])
    //   radius: radius of cylinder (default 1), must be a scalar
    //   resolution: determines the number of polygons per 360 degree revolution (default 12)
    //
    // Example usage:
    //
    //     var cylinder = CSG.cylinder({
    //       start: [0, -1, 0],
    //       end: [0, 1, 0],
    //       radius: 1,
    //       resolution: 16
    //     });
    CSG.cylinder = function(options) {
        var s = CSG.parseOptionAs3DVector(options, "start", [0, -1, 0]);
        var e = CSG.parseOptionAs3DVector(options, "end", [0, 1, 0]);
        var r = CSG.parseOptionAsFloat(options, "radius", 1);
        var rEnd = CSG.parseOptionAsFloat(options, "radiusEnd", r);
        var rStart = CSG.parseOptionAsFloat(options, "radiusStart", r);
        var alpha = CSG.parseOptionAsFloat(options, "sectorAngle", 360);
        alpha = alpha > 360 ? alpha % 360 : alpha;

        if ((rEnd < 0) || (rStart < 0)) {
            throw new Error("Radius should be non-negative");
        }
        if ((rEnd === 0) && (rStart === 0)) {
            throw new Error("Either radiusStart or radiusEnd should be positive");
        }

        var slices = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
        var ray = e.minus(s);
        var axisZ = ray.unit(); //, isY = (Math.abs(axisZ.y) > 0.5);
        var axisX = axisZ.randomNonParallelVector().unit();

        //  var axisX = new CSG.Vector3D(isY, !isY, 0).cross(axisZ).unit();
        var axisY = axisX.cross(axisZ).unit();
        var start = new CSG.Vertex(s);
        var end = new CSG.Vertex(e);
        var polygons = [];

        function point(stack, slice, radius) {
            var angle = slice * Math.PI * alpha / 180;
            var out = axisX.times(Math.cos(angle)).plus(axisY.times(Math.sin(angle)));
            var pos = s.plus(ray.times(stack)).plus(out.times(radius));
            return new CSG.Vertex(pos);
        }
        if (alpha > 0) {
            for (var i = 0; i < slices; i++) {
                var t0 = i / slices,
                    t1 = (i + 1) / slices;
                if (rEnd == rStart) {
                    polygons.push(new CSG.Polygon([start, point(0, t0, rEnd), point(0, t1, rEnd)]));
                    polygons.push(new CSG.Polygon([point(0, t1, rEnd), point(0, t0, rEnd), point(1, t0, rEnd), point(1, t1, rEnd)]));
                    polygons.push(new CSG.Polygon([end, point(1, t1, rEnd), point(1, t0, rEnd)]));
                } else {
                    if (rStart > 0) {
                        polygons.push(new CSG.Polygon([start, point(0, t0, rStart), point(0, t1, rStart)]));
                        polygons.push(new CSG.Polygon([point(0, t0, rStart), point(1, t0, rEnd), point(0, t1, rStart)]));
                    }
                    if (rEnd > 0) {
                        polygons.push(new CSG.Polygon([end, point(1, t1, rEnd), point(1, t0, rEnd)]));
                        polygons.push(new CSG.Polygon([point(1, t0, rEnd), point(1, t1, rEnd), point(0, t1, rStart)]));
                    }
                }
            }
            if (alpha < 360) {
                polygons.push(new CSG.Polygon([start, end, point(0, 0, rStart)]));
                polygons.push(new CSG.Polygon([point(0, 0, rStart), end, point(1, 0, rEnd)]));
                polygons.push(new CSG.Polygon([start, point(0, 1, rStart), end]));
                polygons.push(new CSG.Polygon([point(0, 1, rStart), point(1, 1, rEnd), end]));
            }
        }
        var result = CSG.fromPolygons(polygons);
        result.properties.cylinder = new CSG.Properties();
        result.properties.cylinder.start = new CSG.Connector(s, axisZ.negated(), axisX);
        result.properties.cylinder.end = new CSG.Connector(e, axisZ, axisX);
        var cylCenter = s.plus(ray.times(0.5));
        var fptVec = axisX.rotate(s, axisZ, -alpha / 2).times((rStart + rEnd) / 2);
        var fptVec90 = fptVec.cross(axisZ);
        // note this one is NOT a face normal for a cone. - It's horizontal from cyl perspective
        result.properties.cylinder.facepointH = new CSG.Connector(cylCenter.plus(fptVec), fptVec, axisZ);
        result.properties.cylinder.facepointH90 = new CSG.Connector(cylCenter.plus(fptVec90), fptVec90, axisZ);
        return result;
    };

    // Like a cylinder, but with rounded ends instead of flat
    //
    // Parameters:
    //   start: start point of cylinder (default [0, -1, 0])
    //   end: end point of cylinder (default [0, 1, 0])
    //   radius: radius of cylinder (default 1), must be a scalar
    //   resolution: determines the number of polygons per 360 degree revolution (default 12)
    //   normal: a vector determining the starting angle for tesselation. Should be non-parallel to start.minus(end)
    //
    // Example usage:
    //
    //     var cylinder = CSG.roundedCylinder({
    //       start: [0, -1, 0],
    //       end: [0, 1, 0],
    //       radius: 1,
    //       resolution: 16
    //     });
    CSG.roundedCylinder = function(options) {
        var p1 = CSG.parseOptionAs3DVector(options, "start", [0, -1, 0]);
        var p2 = CSG.parseOptionAs3DVector(options, "end", [0, 1, 0]);
        var radius = CSG.parseOptionAsFloat(options, "radius", 1);
        var direction = p2.minus(p1);
        var defaultnormal;
        if (Math.abs(direction.x) > Math.abs(direction.y)) {
            defaultnormal = new CSG.Vector3D(0, 1, 0);
        } else {
            defaultnormal = new CSG.Vector3D(1, 0, 0);
        }
        var normal = CSG.parseOptionAs3DVector(options, "normal", defaultnormal);
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution3D);
        if (resolution < 4) resolution = 4;
        var polygons = [];
        var qresolution = Math.floor(0.25 * resolution);
        var length = direction.length();
        if (length < 1e-10) {
            return CSG.sphere({
                center: p1,
                radius: radius,
                resolution: resolution
            });
        }
        var zvector = direction.unit().times(radius);
        var xvector = zvector.cross(normal).unit().times(radius);
        var yvector = xvector.cross(zvector).unit().times(radius);
        var prevcylinderpoint;
        for (var slice1 = 0; slice1 <= resolution; slice1++) {
            var angle = Math.PI * 2.0 * slice1 / resolution;
            var cylinderpoint = xvector.times(Math.cos(angle)).plus(yvector.times(Math.sin(angle)));
            if (slice1 > 0) {
                // cylinder vertices:
                var vertices = [];
                vertices.push(new CSG.Vertex(p1.plus(cylinderpoint)));
                vertices.push(new CSG.Vertex(p1.plus(prevcylinderpoint)));
                vertices.push(new CSG.Vertex(p2.plus(prevcylinderpoint)));
                vertices.push(new CSG.Vertex(p2.plus(cylinderpoint)));
                polygons.push(new CSG.Polygon(vertices));
                var prevcospitch, prevsinpitch;
                for (var slice2 = 0; slice2 <= qresolution; slice2++) {
                    var pitch = 0.5 * Math.PI * slice2 / qresolution;
                    //var pitch = Math.asin(slice2/qresolution);
                    var cospitch = Math.cos(pitch);
                    var sinpitch = Math.sin(pitch);
                    if (slice2 > 0) {
                        vertices = [];
                        vertices.push(new CSG.Vertex(p1.plus(prevcylinderpoint.times(prevcospitch).minus(zvector.times(prevsinpitch)))));
                        vertices.push(new CSG.Vertex(p1.plus(cylinderpoint.times(prevcospitch).minus(zvector.times(prevsinpitch)))));
                        if (slice2 < qresolution) {
                            vertices.push(new CSG.Vertex(p1.plus(cylinderpoint.times(cospitch).minus(zvector.times(sinpitch)))));
                        }
                        vertices.push(new CSG.Vertex(p1.plus(prevcylinderpoint.times(cospitch).minus(zvector.times(sinpitch)))));
                        polygons.push(new CSG.Polygon(vertices));
                        vertices = [];
                        vertices.push(new CSG.Vertex(p2.plus(prevcylinderpoint.times(prevcospitch).plus(zvector.times(prevsinpitch)))));
                        vertices.push(new CSG.Vertex(p2.plus(cylinderpoint.times(prevcospitch).plus(zvector.times(prevsinpitch)))));
                        if (slice2 < qresolution) {
                            vertices.push(new CSG.Vertex(p2.plus(cylinderpoint.times(cospitch).plus(zvector.times(sinpitch)))));
                        }
                        vertices.push(new CSG.Vertex(p2.plus(prevcylinderpoint.times(cospitch).plus(zvector.times(sinpitch)))));
                        vertices.reverse();
                        polygons.push(new CSG.Polygon(vertices));
                    }
                    prevcospitch = cospitch;
                    prevsinpitch = sinpitch;
                }
            }
            prevcylinderpoint = cylinderpoint;
        }
        var result = CSG.fromPolygons(polygons);
        var ray = zvector.unit();
        var axisX = xvector.unit();
        result.properties.roundedCylinder = new CSG.Properties();
        result.properties.roundedCylinder.start = new CSG.Connector(p1, ray.negated(), axisX);
        result.properties.roundedCylinder.end = new CSG.Connector(p2, ray, axisX);
        result.properties.roundedCylinder.facepoint = p1.plus(xvector);
        return result;
    };

    // Construct an axis-aligned solid rounded cuboid.
    // Parameters:
    //   center: center of cube (default [0,0,0])
    //   radius: radius of cube (default [1,1,1]), can be specified as scalar or as 3D vector
    //   roundradius: radius of rounded corners (default 0.2), must be a scalar
    //   resolution: determines the number of polygons per 360 degree revolution (default 8)
    //
    // Example code:
    //
    //     var cube = CSG.roundedCube({
    //       center: [0, 0, 0],
    //       radius: 1,
    //       roundradius: 0.2,
    //       resolution: 8,
    //     });
    CSG.roundedCube = function(options) {
        var EPS = 1e-5;
        var minRR = 1e-2; //minroundradius 1e-3 gives rounding errors already
        var center, cuberadius;
        options = options || {};
        if (('corner1' in options) || ('corner2' in options)) {
            if (('center' in options) || ('radius' in options)) {
                throw new Error("roundedCube: should either give a radius and center parameter, or a corner1 and corner2 parameter");
            }
            corner1 = CSG.parseOptionAs3DVector(options, "corner1", [0, 0, 0]);
            corner2 = CSG.parseOptionAs3DVector(options, "corner2", [1, 1, 1]);
            center = corner1.plus(corner2).times(0.5);
            cuberadius = corner2.minus(corner1).times(0.5);
        } else {
            center = CSG.parseOptionAs3DVector(options, "center", [0, 0, 0]);
            cuberadius = CSG.parseOptionAs3DVector(options, "radius", [1, 1, 1]);
        }
        cuberadius = cuberadius.abs(); // negative radii make no sense
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution3D);
        if (resolution < 4) resolution = 4;
        if (resolution%2 == 1 && resolution < 8) resolution = 8; // avoid ugly
        var roundradius = CSG.parseOptionAs3DVector(options, "roundradius", [0.2, 0.2, 0.2]);
        // slight hack for now - total radius stays ok
        roundradius = CSG.Vector3D.Create(Math.max(roundradius.x, minRR), Math.max(roundradius.y, minRR), Math.max(roundradius.z, minRR));
        var innerradius = cuberadius.minus(roundradius);
        if (innerradius.x < 0 || innerradius.y < 0 || innerradius.z < 0) {
            throw('roundradius <= radius!');
        }
        var res = CSG.sphere({radius:1, resolution:resolution});
        res = res.scale(roundradius);
        innerradius.x > EPS && (res = res.stretchAtPlane([1, 0, 0], [0, 0, 0], 2*innerradius.x));
        innerradius.y > EPS && (res = res.stretchAtPlane([0, 1, 0], [0, 0, 0], 2*innerradius.y));
        innerradius.z > EPS && (res = res.stretchAtPlane([0, 0, 1], [0, 0, 0], 2*innerradius.z));
        res = res.translate([-innerradius.x+center.x, -innerradius.y+center.y, -innerradius.z+center.z]);
        res = res.reTesselated();
        res.properties.roundedCube = new CSG.Properties();
        res.properties.roundedCube.center = new CSG.Vertex(center);
        res.properties.roundedCube.facecenters = [
            new CSG.Connector(new CSG.Vector3D([cuberadius.x, 0, 0]).plus(center), [1, 0, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([-cuberadius.x, 0, 0]).plus(center), [-1, 0, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, cuberadius.y, 0]).plus(center), [0, 1, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, -cuberadius.y, 0]).plus(center), [0, -1, 0], [0, 0, 1]),
            new CSG.Connector(new CSG.Vector3D([0, 0, cuberadius.z]).plus(center), [0, 0, 1], [1, 0, 0]),
            new CSG.Connector(new CSG.Vector3D([0, 0, -cuberadius.z]).plus(center), [0, 0, -1], [1, 0, 0])
        ];
        return res;
    };

    /**
     * polyhedron accepts openscad style arguments. I.e. define face vertices clockwise looking from outside
     */
    CSG.polyhedron = function(options) {
        options = options || {};
        if (('points' in options) !== ('faces' in options)) {
            throw new Error("polyhedron needs 'points' and 'faces' arrays");
        }
        var vertices = CSG.parseOptionAs3DVectorList(options, "points", [
                [1, 1, 0],
                [1, -1, 0],
                [-1, -1, 0],
                [-1, 1, 0],
                [0, 0, 1]
            ])
            .map(function(pt) {
                return new CSG.Vertex(pt);
            });
        var faces = CSG.parseOption(options, "faces", [
                [0, 1, 4],
                [1, 2, 4],
                [2, 3, 4],
                [3, 0, 4],
                [1, 0, 3],
                [2, 1, 3]
            ]);
        // openscad convention defines inward normals - so we have to invert here
        faces.forEach(function(face) {
            face.reverse();
        });
        var polygons = faces.map(function(face) {
            return new CSG.Polygon(face.map(function(idx) {
                return vertices[idx];
            }));
        });

        // TODO: facecenters as connectors? probably overkill. Maybe centroid
        // the re-tesselation here happens because it's so easy for a user to
        // create parametrized polyhedrons that end up with 1-2 dimensional polygons.
        // These will create infinite loops at CSG.Tree()
        return CSG.fromPolygons(polygons).reTesselated();
    };

    CSG.IsFloat = function(n) {
        return (!isNaN(n)) || (n === Infinity) || (n === -Infinity);
    };

    // solve 2x2 linear equation:
    // [ab][x] = [u]
    // [cd][y]   [v]
    CSG.solve2Linear = function(a, b, c, d, u, v) {
        var det = a * d - b * c;
        var invdet = 1.0 / det;
        var x = u * d - b * v;
        var y = -u * c + a * v;
        x *= invdet;
        y *= invdet;
        return [x, y];
    };

    // # class Vector3D
    // Represents a 3D vector.
    //
    // Example usage:
    //
    //     new CSG.Vector3D(1, 2, 3);
    //     new CSG.Vector3D([1, 2, 3]);
    //     new CSG.Vector3D({ x: 1, y: 2, z: 3 });
    //     new CSG.Vector3D(1, 2); // assumes z=0
    //     new CSG.Vector3D([1, 2]); // assumes z=0
    CSG.Vector3D = function(x, y, z) {
        if (arguments.length == 3) {
            this._x = parseFloat(x);
            this._y = parseFloat(y);
            this._z = parseFloat(z);
        } else if (arguments.length == 2) {
            this._x = parseFloat(x);
            this._y = parseFloat(y);
            this._z = 0;
        } else {
            var ok = true;
            if (arguments.length == 1) {
                if (typeof(x) == "object") {
                    if (x instanceof CSG.Vector3D) {
                        this._x = x._x;
                        this._y = x._y;
                        this._z = x._z;
                    } else if (x instanceof CSG.Vector2D) {
                        this._x = x._x;
                        this._y = x._y;
                        this._z = 0;
                    } else if (x instanceof Array) {
                        if ((x.length < 2) || (x.length > 3)) {
                            ok = false;
                        } else {
                            this._x = parseFloat(x[0]);
                            this._y = parseFloat(x[1]);
                            if (x.length == 3) {
                                this._z = parseFloat(x[2]);
                            } else {
                                this._z = 0;
                            }
                        }
                    } else if (('x' in x) && ('y' in x)) {
                        this._x = parseFloat(x.x);
                        this._y = parseFloat(x.y);
                        if ('z' in x) {
                            this._z = parseFloat(x.z);
                        } else {
                            this._z = 0;
                        }
                    } else ok = false;
                } else {
                    var v = parseFloat(x);
                    this._x = v;
                    this._y = v;
                    this._z = v;
                }
            } else ok = false;
            if (ok) {
                if ((!CSG.IsFloat(this._x)) || (!CSG.IsFloat(this._y)) || (!CSG.IsFloat(this._z))) ok = false;
            }
            if (!ok) {
                throw new Error("wrong arguments");
            }
        }
    };

    // This does the same as new CSG.Vector3D(x,y,z) but it doesn't go through the constructor
    // and the parameters are not validated. Is much faster.
    CSG.Vector3D.Create = function(x, y, z) {
        var result = Object.create(CSG.Vector3D.prototype);
        result._x = x;
        result._y = y;
        result._z = z;
        return result;
    };

    CSG.Vector3D.prototype = {
        get x() {
            return this._x;
        },
        get y() {
            return this._y;
        },
        get z() {
            return this._z;
        },

        set x(v) {
            throw new Error("Vector3D is immutable");
        },
        set y(v) {
            throw new Error("Vector3D is immutable");
        },
        set z(v) {
            throw new Error("Vector3D is immutable");
        },

        clone: function() {
            return CSG.Vector3D.Create(this._x, this._y, this._z);
        },

        negated: function() {
            return CSG.Vector3D.Create(-this._x, -this._y, -this._z);
        },

        abs: function() {
            return CSG.Vector3D.Create(Math.abs(this._x), Math.abs(this._y), Math.abs(this._z));
        },

        plus: function(a) {
            return CSG.Vector3D.Create(this._x + a._x, this._y + a._y, this._z + a._z);
        },

        minus: function(a) {
            return CSG.Vector3D.Create(this._x - a._x, this._y - a._y, this._z - a._z);
        },

        times: function(a) {
            return CSG.Vector3D.Create(this._x * a, this._y * a, this._z * a);
        },

        dividedBy: function(a) {
            return CSG.Vector3D.Create(this._x / a, this._y / a, this._z / a);
        },

        dot: function(a) {
            return this._x * a._x + this._y * a._y + this._z * a._z;
        },

        lerp: function(a, t) {
            return this.plus(a.minus(this).times(t));
        },

        lengthSquared: function() {
            return this.dot(this);
        },

        length: function() {
            return Math.sqrt(this.lengthSquared());
        },

        unit: function() {
            return this.dividedBy(this.length());
        },

        cross: function(a) {
            return CSG.Vector3D.Create(
                this._y * a._z - this._z * a._y, this._z * a._x - this._x * a._z, this._x * a._y - this._y * a._x);
        },

        distanceTo: function(a) {
            return this.minus(a).length();
        },

        distanceToSquared: function(a) {
            return this.minus(a).lengthSquared();
        },

        equals: function(a) {
            return (this._x == a._x) && (this._y == a._y) && (this._z == a._z);
        },

        // Right multiply by a 4x4 matrix (the vector is interpreted as a row vector)
        // Returns a new CSG.Vector3D
        multiply4x4: function(matrix4x4) {
            return matrix4x4.leftMultiply1x3Vector(this);
        },

        transform: function(matrix4x4) {
            return matrix4x4.leftMultiply1x3Vector(this);
        },

        toString: function() {
            return "(" + this._x.toFixed(2) + ", " + this._y.toFixed(2) + ", " + this._z.toFixed(2) + ")";
        },

        // find a vector that is somewhat perpendicular to this one
        randomNonParallelVector: function() {
            var abs = this.abs();
            if ((abs._x <= abs._y) && (abs._x <= abs._z)) {
                return CSG.Vector3D.Create(1, 0, 0);
            } else if ((abs._y <= abs._x) && (abs._y <= abs._z)) {
                return CSG.Vector3D.Create(0, 1, 0);
            } else {
                return CSG.Vector3D.Create(0, 0, 1);
            }
        },

        min: function(p) {
            return CSG.Vector3D.Create(
                Math.min(this._x, p._x), Math.min(this._y, p._y), Math.min(this._z, p._z));
        },

        max: function(p) {
            return CSG.Vector3D.Create(
                Math.max(this._x, p._x), Math.max(this._y, p._y), Math.max(this._z, p._z));
        }
    };

    // # class Vertex
    // Represents a vertex of a polygon. Use your own vertex class instead of this
    // one to provide additional features like texture coordinates and vertex
    // colors. Custom vertex classes need to provide a `pos` property
    // `flipped()`, and `interpolate()` methods that behave analogous to the ones
    // defined by `CSG.Vertex`.
    CSG.Vertex = function(pos) {
        this.pos = pos;
    };

    // create from an untyped object with identical property names:
    CSG.Vertex.fromObject = function(obj) {
        var pos = new CSG.Vector3D(obj.pos);
        return new CSG.Vertex(pos);
    };

    CSG.Vertex.prototype = {
        // Return a vertex with all orientation-specific data (e.g. vertex normal) flipped. Called when the
        // orientation of a polygon is flipped.
        flipped: function() {
            return this;
        },

        getTag: function() {
            var result = this.tag;
            if (!result) {
                result = CSG.getTag();
                this.tag = result;
            }
            return result;
        },

        // Create a new vertex between this vertex and `other` by linearly
        // interpolating all properties using a parameter of `t`. Subclasses should
        // override this to interpolate additional properties.
        interpolate: function(other, t) {
            var newpos = this.pos.lerp(other.pos, t);
            return new CSG.Vertex(newpos);
        },

        // Affine transformation of vertex. Returns a new CSG.Vertex
        transform: function(matrix4x4) {
            var newpos = this.pos.multiply4x4(matrix4x4);
            return new CSG.Vertex(newpos);
        },

        toString: function() {
            return this.pos.toString();
        }
    };

    // # class Plane
    // Represents a plane in 3D space.
    CSG.Plane = function(normal, w) {
        this.normal = normal;
        this.w = w;
    };

    // create from an untyped object with identical property names:
    CSG.Plane.fromObject = function(obj) {
        var normal = new CSG.Vector3D(obj.normal);
        var w = parseFloat(obj.w);
        return new CSG.Plane(normal, w);
    };

    // `CSG.Plane.EPSILON` is the tolerance used by `splitPolygon()` to decide if a
    // point is on the plane.
    CSG.Plane.EPSILON = 1e-5;

    CSG.Plane.fromVector3Ds = function(a, b, c) {
        var n = b.minus(a).cross(c.minus(a)).unit();
        return new CSG.Plane(n, n.dot(a));
    };

    // like fromVector3Ds, but allow the vectors to be on one point or one line
    // in such a case a random plane through the given points is constructed
    CSG.Plane.anyPlaneFromVector3Ds = function(a, b, c) {
        var v1 = b.minus(a);
        var v2 = c.minus(a);
        if (v1.length() < 1e-5) {
            v1 = v2.randomNonParallelVector();
        }
        if (v2.length() < 1e-5) {
            v2 = v1.randomNonParallelVector();
        }
        var normal = v1.cross(v2);
        if (normal.length() < 1e-5) {
            // this would mean that v1 == v2.negated()
            v2 = v1.randomNonParallelVector();
            normal = v1.cross(v2);
        }
        normal = normal.unit();
        return new CSG.Plane(normal, normal.dot(a));
    };

    CSG.Plane.fromPoints = function(a, b, c) {
        a = new CSG.Vector3D(a);
        b = new CSG.Vector3D(b);
        c = new CSG.Vector3D(c);
        return CSG.Plane.fromVector3Ds(a, b, c);
    };

    CSG.Plane.fromNormalAndPoint = function(normal, point) {
        normal = new CSG.Vector3D(normal);
        point = new CSG.Vector3D(point);
        normal = normal.unit();
        var w = point.dot(normal);
        return new CSG.Plane(normal, w);
    };

    CSG.Plane.prototype = {
        flipped: function() {
            return new CSG.Plane(this.normal.negated(), -this.w);
        },

        getTag: function() {
            var result = this.tag;
            if (!result) {
                result = CSG.getTag();
                this.tag = result;
            }
            return result;
        },

        equals: function(n) {
            return this.normal.equals(n.normal) && this.w == n.w;
        },

        transform: function(matrix4x4) {
            var ismirror = matrix4x4.isMirroring();
            // get two vectors in the plane:
            var r = this.normal.randomNonParallelVector();
            var u = this.normal.cross(r);
            var v = this.normal.cross(u);
            // get 3 points in the plane:
            var point1 = this.normal.times(this.w);
            var point2 = point1.plus(u);
            var point3 = point1.plus(v);
            // transform the points:
            point1 = point1.multiply4x4(matrix4x4);
            point2 = point2.multiply4x4(matrix4x4);
            point3 = point3.multiply4x4(matrix4x4);
            // and create a new plane from the transformed points:
            var newplane = CSG.Plane.fromVector3Ds(point1, point2, point3);
            if (ismirror) {
                // the transform is mirroring
                // We should mirror the plane:
                newplane = newplane.flipped();
            }
            return newplane;
        },

        // Returns object:
        // .type:
        //   0: coplanar-front
        //   1: coplanar-back
        //   2: front
        //   3: back
        //   4: spanning
        // In case the polygon is spanning, returns:
        // .front: a CSG.Polygon of the front part
        // .back: a CSG.Polygon of the back part
        splitPolygon: function(polygon) {
            var result = {
                type: null,
                front: null,
                back: null
            };
            // cache in local vars (speedup):
            var planenormal = this.normal;
            var vertices = polygon.vertices;
            var numvertices = vertices.length;
            if (polygon.plane.equals(this)) {
                result.type = 0;
            } else {
                var EPS = CSG.Plane.EPSILON;
                var thisw = this.w;
                var hasfront = false;
                var hasback = false;
                var vertexIsBack = [];
                var MINEPS = -EPS;
                for (var i = 0; i < numvertices; i++) {
                    var t = planenormal.dot(vertices[i].pos) - thisw;
                    var isback = (t < 0);
                    vertexIsBack.push(isback);
                    if (t > EPS) hasfront = true;
                    if (t < MINEPS) hasback = true;
                }
                if ((!hasfront) && (!hasback)) {
                    // all points coplanar
                    var t = planenormal.dot(polygon.plane.normal);
                    result.type = (t >= 0) ? 0 : 1;
                } else if (!hasback) {
                    result.type = 2;
                } else if (!hasfront) {
                    result.type = 3;
                } else {
                    // spanning
                    result.type = 4;
                    var frontvertices = [],
                        backvertices = [];
                    var isback = vertexIsBack[0];
                    for (var vertexindex = 0; vertexindex < numvertices; vertexindex++) {
                        var vertex = vertices[vertexindex];
                        var nextvertexindex = vertexindex + 1;
                        if (nextvertexindex >= numvertices) nextvertexindex = 0;
                        var nextisback = vertexIsBack[nextvertexindex];
                        if (isback == nextisback) {
                            // line segment is on one side of the plane:
                            if (isback) {
                                backvertices.push(vertex);
                            } else {
                                frontvertices.push(vertex);
                            }
                        } else {
                            // line segment intersects plane:
                            var point = vertex.pos;
                            var nextpoint = vertices[nextvertexindex].pos;
                            var intersectionpoint = this.splitLineBetweenPoints(point, nextpoint);
                            var intersectionvertex = new CSG.Vertex(intersectionpoint);
                            if (isback) {
                                backvertices.push(vertex);
                                backvertices.push(intersectionvertex);
                                frontvertices.push(intersectionvertex);
                            } else {
                                frontvertices.push(vertex);
                                frontvertices.push(intersectionvertex);
                                backvertices.push(intersectionvertex);
                            }
                        }
                        isback = nextisback;
                    } // for vertexindex
                    // remove duplicate vertices:
                    var EPS_SQUARED = CSG.Plane.EPSILON * CSG.Plane.EPSILON;
                    if (backvertices.length >= 3) {
                        var prevvertex = backvertices[backvertices.length - 1];
                        for (var vertexindex = 0; vertexindex < backvertices.length; vertexindex++) {
                            var vertex = backvertices[vertexindex];
                            if (vertex.pos.distanceToSquared(prevvertex.pos) < EPS_SQUARED) {
                                backvertices.splice(vertexindex, 1);
                                vertexindex--;
                            }
                            prevvertex = vertex;
                        }
                    }
                    if (frontvertices.length >= 3) {
                        var prevvertex = frontvertices[frontvertices.length - 1];
                        for (var vertexindex = 0; vertexindex < frontvertices.length; vertexindex++) {
                            var vertex = frontvertices[vertexindex];
                            if (vertex.pos.distanceToSquared(prevvertex.pos) < EPS_SQUARED) {
                                frontvertices.splice(vertexindex, 1);
                                vertexindex--;
                            }
                            prevvertex = vertex;
                        }
                    }
                    if (frontvertices.length >= 3) {
                        result.front = new CSG.Polygon(frontvertices, polygon.shared, polygon.plane);
                    }
                    if (backvertices.length >= 3) {
                        result.back = new CSG.Polygon(backvertices, polygon.shared, polygon.plane);
                    }
                }
            }
            return result;
        },

        // robust splitting of a line by a plane
        // will work even if the line is parallel to the plane
        splitLineBetweenPoints: function(p1, p2) {
            var direction = p2.minus(p1);
            var labda = (this.w - this.normal.dot(p1)) / this.normal.dot(direction);
            if (isNaN(labda)) labda = 0;
            if (labda > 1) labda = 1;
            if (labda < 0) labda = 0;
            var result = p1.plus(direction.times(labda));
            return result;
        },

        // returns CSG.Vector3D
        intersectWithLine: function(line3d) {
            return line3d.intersectWithPlane(this);
        },

        // intersection of two planes
        intersectWithPlane: function(plane) {
            return CSG.Line3D.fromPlanes(this, plane);
        },

        signedDistanceToPoint: function(point) {
            var t = this.normal.dot(point) - this.w;
            return t;
        },

        toString: function() {
            return "[normal: " + this.normal.toString() + ", w: " + this.w + "]";
        },

        mirrorPoint: function(point3d) {
            var distance = this.signedDistanceToPoint(point3d);
            var mirrored = point3d.minus(this.normal.times(distance * 2.0));
            return mirrored;
        }
    };


    // # class Polygon
    // Represents a convex polygon. The vertices used to initialize a polygon must
    // be coplanar and form a convex loop. They do not have to be `CSG.Vertex`
    // instances but they must behave similarly (duck typing can be used for
    // customization).
    //
    // Each convex polygon has a `shared` property, which is shared between all
    // polygons that are clones of each other or were split from the same polygon.
    // This can be used to define per-polygon properties (such as surface color).
    //
    // The plane of the polygon is calculated from the vertex coordinates
    // To avoid unnecessary recalculation, the plane can alternatively be
    // passed as the third argument
    CSG.Polygon = function(vertices, shared, plane) {
        this.vertices = vertices;
        if (!shared) shared = CSG.Polygon.defaultShared;
        this.shared = shared;
        //var numvertices = vertices.length;

        if (arguments.length >= 3) {
            this.plane = plane;
        } else {
            this.plane = CSG.Plane.fromVector3Ds(vertices[0].pos, vertices[1].pos, vertices[2].pos);
        }

        if (_CSGDEBUG) {
            this.checkIfConvex();
        }
    };

    // create from an untyped object with identical property names:
    CSG.Polygon.fromObject = function(obj) {
        var vertices = obj.vertices.map(function(v) {
            return CSG.Vertex.fromObject(v);
        });
        var shared = CSG.Polygon.Shared.fromObject(obj.shared);
        var plane = CSG.Plane.fromObject(obj.plane);
        return new CSG.Polygon(vertices, shared, plane);
    };

    CSG.Polygon.prototype = {
        // check whether the polygon is convex (it should be, otherwise we will get unexpected results)
        checkIfConvex: function() {
            if (!CSG.Polygon.verticesConvex(this.vertices, this.plane.normal)) {
                CSG.Polygon.verticesConvex(this.vertices, this.plane.normal);
                throw new Error("Not convex!");
            }
        },

        setColor: function(args) {
            var newshared = CSG.Polygon.Shared.fromColor.apply(this, arguments);
            this.shared = newshared;
            return this;
        },

        getSignedVolume: function() {
            var signedVolume = 0;
            for (var i = 0; i < this.vertices.length - 2; i++) {
                signedVolume += this.vertices[0].pos.dot(this.vertices[i+1].pos
                    .cross(this.vertices[i+2].pos));
            }
            signedVolume /= 6;
            return signedVolume;
        },

        // Note: could calculate vectors only once to speed up
        getArea: function() {
            var polygonArea = 0;
            for (var i = 0; i < this.vertices.length - 2; i++) {
                polygonArea += this.vertices[i+1].pos.minus(this.vertices[0].pos)
                    .cross(this.vertices[i+2].pos.minus(this.vertices[i+1].pos)).length();
            }
            polygonArea /= 2;
            return polygonArea;
        },


        // accepts array of features to calculate
        // returns array of results
        getTetraFeatures: function(features) {
            var result = [];
            features.forEach(function(feature) {
                if (feature == 'volume') {
                    result.push(this.getSignedVolume());
                } else if (feature == 'area') {
                    result.push(this.getArea());
                }
            }, this);
            return result;
        },

        // Extrude a polygon into the direction offsetvector
        // Returns a CSG object
        extrude: function(offsetvector) {
            var newpolygons = [];

            var polygon1 = this;
            var direction = polygon1.plane.normal.dot(offsetvector);
            if (direction > 0) {
                polygon1 = polygon1.flipped();
            }
            newpolygons.push(polygon1);
            var polygon2 = polygon1.translate(offsetvector);
            var numvertices = this.vertices.length;
            for (var i = 0; i < numvertices; i++) {
                var sidefacepoints = [];
                var nexti = (i < (numvertices - 1)) ? i + 1 : 0;
                sidefacepoints.push(polygon1.vertices[i].pos);
                sidefacepoints.push(polygon2.vertices[i].pos);
                sidefacepoints.push(polygon2.vertices[nexti].pos);
                sidefacepoints.push(polygon1.vertices[nexti].pos);
                var sidefacepolygon = CSG.Polygon.createFromPoints(sidefacepoints, this.shared);
                newpolygons.push(sidefacepolygon);
            }
            polygon2 = polygon2.flipped();
            newpolygons.push(polygon2);
            return CSG.fromPolygons(newpolygons);
        },

        translate: function(offset) {
            return this.transform(CSG.Matrix4x4.translation(offset));
        },

        // returns an array with a CSG.Vector3D (center point) and a radius
        boundingSphere: function() {
            if (!this.cachedBoundingSphere) {
                var box = this.boundingBox();
                var middle = box[0].plus(box[1]).times(0.5);
                var radius3 = box[1].minus(middle);
                var radius = radius3.length();
                this.cachedBoundingSphere = [middle, radius];
            }
            return this.cachedBoundingSphere;
        },

        // returns an array of two CSG.Vector3Ds (minimum coordinates and maximum coordinates)
        boundingBox: function() {
            if (!this.cachedBoundingBox) {
                var minpoint, maxpoint;
                var vertices = this.vertices;
                var numvertices = vertices.length;
                if (numvertices === 0) {
                    minpoint = new CSG.Vector3D(0, 0, 0);
                } else {
                    minpoint = vertices[0].pos;
                }
                maxpoint = minpoint;
                for (var i = 1; i < numvertices; i++) {
                    var point = vertices[i].pos;
                    minpoint = minpoint.min(point);
                    maxpoint = maxpoint.max(point);
                }
                this.cachedBoundingBox = [minpoint, maxpoint];
            }
            return this.cachedBoundingBox;
        },

        flipped: function() {
            var newvertices = this.vertices.map(function(v) {
                return v.flipped();
            });
            newvertices.reverse();
            var newplane = this.plane.flipped();
            return new CSG.Polygon(newvertices, this.shared, newplane);
        },

        // Affine transformation of polygon. Returns a new CSG.Polygon
        transform: function(matrix4x4) {
            var newvertices = this.vertices.map(function(v) {
                return v.transform(matrix4x4);
            });
            var newplane = this.plane.transform(matrix4x4);
            if (matrix4x4.isMirroring()) {
                // need to reverse the vertex order
                // in order to preserve the inside/outside orientation:
                newvertices.reverse();
            }
            return new CSG.Polygon(newvertices, this.shared, newplane);
        },

        toString: function() {
            var result = "Polygon plane: " + this.plane.toString() + "\n";
            this.vertices.map(function(vertex) {
                result += "  " + vertex.toString() + "\n";
            });
            return result;
        },

        // project the 3D polygon onto a plane
        projectToOrthoNormalBasis: function(orthobasis) {
            var points2d = this.vertices.map(function(vertex) {
                return orthobasis.to2D(vertex.pos);
            });
            var result = CAG.fromPointsNoCheck(points2d);
            var area = result.area();
            if (Math.abs(area) < 1e-5) {
                // the polygon was perpendicular to the orthnormal plane. The resulting 2D polygon would be degenerate
                // return an empty area instead:
                result = new CAG();
            } else if (area < 0) {
                result = result.flipped();
            }
            return result;
        },

        /**
         * Creates solid from slices (CSG.Polygon) by generating walls
         * @param {Object} options Solid generating options
         *  - numslices {Number} Number of slices to be generated
         *  - callback(t, slice) {Function} Callback function generating slices.
         *          arguments: t = [0..1], slice = [0..numslices - 1]
         *          return: CSG.Polygon or null to skip
         *  - loop {Boolean} no flats, only walls, it's used to generate solids like a tor
         */
        solidFromSlices: function(options) {
            var polygons = [],
                csg = null,
                prev = null,
                bottom = null,
                top = null,
                numSlices = 2,
                bLoop = false,
                fnCallback,
                flipped = null;

            if (options) {
                bLoop = Boolean(options['loop']);

                if (options.numslices)
                    numSlices = options.numslices;

                if (options.callback)
                    fnCallback = options.callback;
            }
            if (!fnCallback) {
                var square = new CSG.Polygon.createFromPoints([
                    [0, 0, 0],
                    [1, 0, 0],
                    [1, 1, 0],
                    [0, 1, 0]
                ]);
                fnCallback = function(t, slice) {
                    return t == 0 || t == 1 ? square.translate([0, 0, t]) : null;
                }
            }
            for (var i = 0, iMax = numSlices - 1; i <= iMax; i++) {
                csg = fnCallback.call(this, i / iMax, i);
                if (csg) {
                    if (!(csg instanceof CSG.Polygon)) {
                        throw new Error("CSG.Polygon.solidFromSlices callback error: CSG.Polygon expected");
                    }
                    csg.checkIfConvex();

                    if (prev) { //generate walls
                        if (flipped === null) { //not generated yet
                            flipped = prev.plane.signedDistanceToPoint(csg.vertices[0].pos) < 0;
                        }
                        this._addWalls(polygons, prev, csg, flipped);

                    } else { //the first - will be a bottom
                        bottom = csg;
                    }
                    prev = csg;
                } //callback can return null to skip that slice
            }
            top = csg;

            if (bLoop) {
                var bSameTopBottom = bottom.vertices.length == top.vertices.length &&
                    bottom.vertices.every(function(v, index) {
                        return v.pos.equals(top.vertices[index].pos)
                    });
                //if top and bottom are not the same -
                //generate walls between them
                if (!bSameTopBottom) {
                    this._addWalls(polygons, top, bottom, flipped);
                } //else - already generated
            } else {
                //save top and bottom
                //TODO: flip if necessary
                polygons.unshift(flipped ? bottom : bottom.flipped());
                polygons.push(flipped ? top.flipped() : top);
            }
            return CSG.fromPolygons(polygons);
        },
        /**
         *
         * @param walls Array of wall polygons
         * @param bottom Bottom polygon
         * @param top Top polygon
         */
        _addWalls: function(walls, bottom, top, bFlipped) {
            var bottomPoints = bottom.vertices.slice(0), //make a copy
                topPoints = top.vertices.slice(0), //make a copy
                color = top.shared || null;

            //check if bottom perimeter is closed
            if (!bottomPoints[0].pos.equals(bottomPoints[bottomPoints.length - 1].pos)) {
                bottomPoints.push(bottomPoints[0]);
            }

            //check if top perimeter is closed
            if (!topPoints[0].pos.equals(topPoints[topPoints.length - 1].pos)) {
                topPoints.push(topPoints[0]);
            }
            if (bFlipped) {
                bottomPoints = bottomPoints.reverse();
                topPoints = topPoints.reverse();
            }

            var iTopLen = topPoints.length - 1,
                iBotLen = bottomPoints.length - 1,
                iExtra = iTopLen - iBotLen, //how many extra triangles we need
                bMoreTops = iExtra > 0,
                bMoreBottoms = iExtra < 0;

            var aMin = []; //indexes to start extra triangles (polygon with minimal square)
            //init - we need exactly /iExtra/ small triangles
            for (var i = Math.abs(iExtra); i > 0; i--) {
                aMin.push({
                    len: Infinity,
                    index: -1
                });
            }

            var len;
            if (bMoreBottoms) {
                for (var i = 0; i < iBotLen; i++) {
                    len = bottomPoints[i].pos.distanceToSquared(bottomPoints[i + 1].pos);
                    //find the element to replace
                    for (var j = aMin.length - 1; j >= 0; j--) {
                        if (aMin[j].len > len) {
                            aMin[j].len = len;
                            aMin.index = j;
                            break;
                        }
                    } //for
                }
            } else if (bMoreTops) {
                for (var i = 0; i < iTopLen; i++) {
                    len = topPoints[i].pos.distanceToSquared(topPoints[i + 1].pos);
                    //find the element to replace
                    for (var j = aMin.length - 1; j >= 0; j--) {
                        if (aMin[j].len > len) {
                            aMin[j].len = len;
                            aMin.index = j;
                            break;
                        }
                    } //for
                }
            } //if
            //sort by index
            aMin.sort(fnSortByIndex);
            var getTriangle = function addWallsPutTriangle(pointA, pointB, pointC, color) {
                return new CSG.Polygon([pointA, pointB, pointC], color);
                //return bFlipped ? triangle.flipped() : triangle;
            };

            var bpoint = bottomPoints[0],
                tpoint = topPoints[0],
                secondPoint,
                nBotFacet, nTopFacet; //length of triangle facet side
            for (var iB = 0, iT = 0, iMax = iTopLen + iBotLen; iB + iT < iMax;) {
                if (aMin.length) {
                    if (bMoreTops && iT == aMin[0].index) { //one vertex is on the bottom, 2 - on the top
                        secondPoint = topPoints[++iT];
                        //console.log('<<< extra top: ' + secondPoint + ', ' + tpoint + ', bottom: ' + bpoint);
                        walls.push(getTriangle(
                            secondPoint, tpoint, bpoint, color
                        ));
                        tpoint = secondPoint;
                        aMin.shift();
                        continue;
                    } else if (bMoreBottoms && iB == aMin[0].index) {
                        secondPoint = bottomPoints[++iB];
                        walls.push(getTriangle(
                            tpoint, bpoint, secondPoint, color
                        ));
                        bpoint = secondPoint;
                        aMin.shift();
                        continue;
                    }
                }
                //choose the shortest path
                if (iB < iBotLen) { //one vertex is on the top, 2 - on the bottom
                    nBotFacet = tpoint.pos.distanceToSquared(bottomPoints[iB + 1].pos);
                } else {
                    nBotFacet = Infinity;
                }
                if (iT < iTopLen) { //one vertex is on the bottom, 2 - on the top
                    nTopFacet = bpoint.pos.distanceToSquared(topPoints[iT + 1].pos);
                } else {
                    nTopFacet = Infinity;
                }
                if (nBotFacet <= nTopFacet) {
                    secondPoint = bottomPoints[++iB];
                    walls.push(getTriangle(
                        tpoint, bpoint, secondPoint, color
                    ));
                    bpoint = secondPoint;
                } else if (iT < iTopLen) { //nTopFacet < Infinity
                    secondPoint = topPoints[++iT];
                    //console.log('<<< top: ' + secondPoint + ', ' + tpoint + ', bottom: ' + bpoint);
                    walls.push(getTriangle(
                        secondPoint, tpoint, bpoint, color
                    ));
                    tpoint = secondPoint;
                };
            }
            return walls;
        }
    };

    CSG.Polygon.verticesConvex = function(vertices, planenormal) {
        var numvertices = vertices.length;
        if (numvertices > 2) {
            var prevprevpos = vertices[numvertices - 2].pos;
            var prevpos = vertices[numvertices - 1].pos;
            for (var i = 0; i < numvertices; i++) {
                var pos = vertices[i].pos;
                if (!CSG.Polygon.isConvexPoint(prevprevpos, prevpos, pos, planenormal)) {
                    return false;
                }
                prevprevpos = prevpos;
                prevpos = pos;
            }
        }
        return true;
    };

    // Create a polygon from the given points
    CSG.Polygon.createFromPoints = function(points, shared, plane) {
        var normal;
        if (arguments.length < 3) {
            // initially set a dummy vertex normal:
            normal = new CSG.Vector3D(0, 0, 0);
        } else {
            normal = plane.normal;
        }
        var vertices = [];
        points.map(function(p) {
            var vec = new CSG.Vector3D(p);
            var vertex = new CSG.Vertex(vec);
            vertices.push(vertex);
        });
        var polygon;
        if (arguments.length < 3) {
            polygon = new CSG.Polygon(vertices, shared);
        } else {
            polygon = new CSG.Polygon(vertices, shared, plane);
        }
        return polygon;
    };

    // calculate whether three points form a convex corner
    //  prevpoint, point, nextpoint: the 3 coordinates (CSG.Vector3D instances)
    //  normal: the normal vector of the plane
    CSG.Polygon.isConvexPoint = function(prevpoint, point, nextpoint, normal) {
        var crossproduct = point.minus(prevpoint).cross(nextpoint.minus(point));
        var crossdotnormal = crossproduct.dot(normal);
        return (crossdotnormal >= 0);
    };

    CSG.Polygon.isStrictlyConvexPoint = function(prevpoint, point, nextpoint, normal) {
        var crossproduct = point.minus(prevpoint).cross(nextpoint.minus(point));
        var crossdotnormal = crossproduct.dot(normal);
        return (crossdotnormal >= 1e-5);
    };

    // # class CSG.Polygon.Shared
    // Holds the shared properties for each polygon (currently only color)
    // Constructor expects a 4 element array [r,g,b,a], values from 0 to 1, or null
    CSG.Polygon.Shared = function(color) {
        if(color !== null)
        {
            if (color.length != 4) {
                throw new Error("Expecting 4 element array");
            }
        }
        this.color = color;
    };

    CSG.Polygon.Shared.fromObject = function(obj) {
        return new CSG.Polygon.Shared(obj.color);
    };

    // Create CSG.Polygon.Shared from a color, can be called as follows:
    // var s = CSG.Polygon.Shared.fromColor(r,g,b [,a])
    // var s = CSG.Polygon.Shared.fromColor([r,g,b [,a]])
    CSG.Polygon.Shared.fromColor = function(args) {
        var color;
        if(arguments.length == 1) {
            color = arguments[0].slice(); // make deep copy
        }
        else {
            color = [];
            for(var i=0; i < arguments.length; i++) {
                color.push(arguments[i]);
            }
        }
        if(color.length == 3) {
            color.push(1);
        } else if(color.length != 4) {
            throw new Error("setColor expects either an array with 3 or 4 elements, or 3 or 4 parameters.");
        }
        return new CSG.Polygon.Shared(color);
    };

    CSG.Polygon.Shared.prototype = {
        getTag: function() {
            var result = this.tag;
            if (!result) {
                result = CSG.getTag();
                this.tag = result;
            }
            return result;
        },
        // get a string uniquely identifying this object
        getHash: function() {
            if (!this.color) return "null";
            return this.color.join("/");
        }
    };

    CSG.Polygon.defaultShared = new CSG.Polygon.Shared(null);

    // # class PolygonTreeNode
    // This class manages hierarchical splits of polygons
    // At the top is a root node which doesn hold a polygon, only child PolygonTreeNodes
    // Below that are zero or more 'top' nodes; each holds a polygon. The polygons can be in different planes
    // splitByPlane() splits a node by a plane. If the plane intersects the polygon, two new child nodes
    // are created holding the splitted polygon.
    // getPolygons() retrieves the polygon from the tree. If for PolygonTreeNode the polygon is split but
    // the two split parts (child nodes) are still intact, then the unsplit polygon is returned.
    // This ensures that we can safely split a polygon into many fragments. If the fragments are untouched,
    //  getPolygons() will return the original unsplit polygon instead of the fragments.
    // remove() removes a polygon from the tree. Once a polygon is removed, the parent polygons are invalidated
    // since they are no longer intact.
    // constructor creates the root node:
    CSG.PolygonTreeNode = function() {
        this.parent = null;
        this.children = [];
        this.polygon = null;
        this.removed = false;
    };

    CSG.PolygonTreeNode.prototype = {
        // fill the tree with polygons. Should be called on the root node only; child nodes must
        // always be a derivate (split) of the parent node.
        addPolygons: function(polygons) {
            if (!this.isRootNode())
            // new polygons can only be added to root node; children can only be splitted polygons
                throw new Error("Assertion failed");
            var _this = this;
            polygons.map(function(polygon) {
                _this.addChild(polygon);
            });
        },

        // remove a node
        // - the siblings become toplevel nodes
        // - the parent is removed recursively
        remove: function() {
            if (!this.removed) {
                this.removed = true;

                if (_CSGDEBUG) {
                    if (this.isRootNode()) throw new Error("Assertion failed"); // can't remove root node
                    if (this.children.length) throw new Error("Assertion failed"); // we shouldn't remove nodes with children
                }

                // remove ourselves from the parent's children list:
                var parentschildren = this.parent.children;
                var i = parentschildren.indexOf(this);
                if (i < 0) throw new Error("Assertion failed");
                parentschildren.splice(i, 1);

                // invalidate the parent's polygon, and of all parents above it:
                this.parent.recursivelyInvalidatePolygon();
            }
        },

        isRemoved: function() {
            return this.removed;
        },

        isRootNode: function() {
            return !this.parent;
        },

        // invert all polygons in the tree. Call on the root node
        invert: function() {
            if (!this.isRootNode()) throw new Error("Assertion failed"); // can only call this on the root node
            this.invertSub();
        },

        getPolygon: function() {
            if (!this.polygon) throw new Error("Assertion failed"); // doesn't have a polygon, which means that it has been broken down
            return this.polygon;
        },

        getPolygons: function(result) {
            var children = [this];
            var queue = [children];
            var i, j, l, node;
            for (i = 0; i < queue.length; ++i ) { // queue size can change in loop, don't cache length
                children = queue[i];
                for (j = 0, l = children.length; j < l; j++) { // ok to cache length
                    node = children[j];
                    if (node.polygon) {
                        // the polygon hasn't been broken yet. We can ignore the children and return our polygon:
                        result.push(node.polygon);
                    } else {
                        // our polygon has been split up and broken, so gather all subpolygons from the children
                        queue.push(node.children);
                    }
                }
            }
        },

        // split the node by a plane; add the resulting nodes to the frontnodes and backnodes array
        // If the plane doesn't intersect the polygon, the 'this' object is added to one of the arrays
        // If the plane does intersect the polygon, two new child nodes are created for the front and back fragments,
        //  and added to both arrays.
        splitByPlane: function(plane, coplanarfrontnodes, coplanarbacknodes, frontnodes, backnodes) {
            if (this.children.length) {
                var queue = [this.children], i, j, l, node, nodes;
                for (i = 0; i < queue.length; i++) { // queue.length can increase, do not cache
                    nodes = queue[i];
                    for (j = 0, l = nodes.length; j < l; j++) { // ok to cache length
                        node = nodes[j];
                        if (node.children.length) {
                            queue.push(node.children);
                        } else {
                            // no children. Split the polygon:
                            node._splitByPlane(plane, coplanarfrontnodes, coplanarbacknodes, frontnodes, backnodes);
                        }
                    }
                }
            } else {
                this._splitByPlane(plane, coplanarfrontnodes, coplanarbacknodes, frontnodes, backnodes);
            }
        },

        // only to be called for nodes with no children
        _splitByPlane: function (plane, coplanarfrontnodes, coplanarbacknodes, frontnodes, backnodes) {
            var polygon = this.polygon;
            if (polygon) {
                var bound = polygon.boundingSphere();
                var sphereradius = bound[1] + 1e-4;
                var planenormal = plane.normal;
                var spherecenter = bound[0];
                var d = planenormal.dot(spherecenter) - plane.w;
                if (d > sphereradius) {
                    frontnodes.push(this);
                } else if (d < -sphereradius) {
                    backnodes.push(this);
                } else {
                    var splitresult = plane.splitPolygon(polygon);
                    switch (splitresult.type) {
                        case 0:
                            // coplanar front:
                            coplanarfrontnodes.push(this);
                            break;

                        case 1:
                            // coplanar back:
                            coplanarbacknodes.push(this);
                            break;

                        case 2:
                            // front:
                            frontnodes.push(this);
                            break;

                        case 3:
                            // back:
                            backnodes.push(this);
                            break;

                        case 4:
                            // spanning:
                            if (splitresult.front) {
                                var frontnode = this.addChild(splitresult.front);
                                frontnodes.push(frontnode);
                            }
                            if (splitresult.back) {
                                var backnode = this.addChild(splitresult.back);
                                backnodes.push(backnode);
                            }
                            break;
                    }
                }
            }
        },


        // PRIVATE methods from here:
        // add child to a node
        // this should be called whenever the polygon is split
        // a child should be created for every fragment of the split polygon
        // returns the newly created child
        addChild: function(polygon) {
            var newchild = new CSG.PolygonTreeNode();
            newchild.parent = this;
            newchild.polygon = polygon;
            this.children.push(newchild);
            return newchild;
        },

        invertSub: function() {
            var children = [this];
            var queue = [children];
            var i, j, l, node;
            for (i = 0; i < queue.length; i++) {
                children = queue[i];
                for (j = 0, l = children.length; j < l; j++) {
                    node = children[j];
                    if (node.polygon) {
                        node.polygon = node.polygon.flipped();
                    }
                    queue.push(node.children);
                }
            }
        },

        recursivelyInvalidatePolygon: function() {
            var node = this;
            while (node.polygon) {
                node.polygon = null;
                if (node.parent) {
                    node = node.parent;
                }
            }
        }
    };



    // # class Tree
    // This is the root of a BSP tree
    // We are using this separate class for the root of the tree, to hold the PolygonTreeNode root
    // The actual tree is kept in this.rootnode
    CSG.Tree = function(polygons) {
        this.polygonTree = new CSG.PolygonTreeNode();
        this.rootnode = new CSG.Node(null);
        if (polygons) this.addPolygons(polygons);
    };

    CSG.Tree.prototype = {
        invert: function() {
            this.polygonTree.invert();
            this.rootnode.invert();
        },

        // Remove all polygons in this BSP tree that are inside the other BSP tree
        // `tree`.
        clipTo: function(tree, alsoRemovecoplanarFront) {
            alsoRemovecoplanarFront = alsoRemovecoplanarFront ? true : false;
            this.rootnode.clipTo(tree, alsoRemovecoplanarFront);
        },

        allPolygons: function() {
            var result = [];
            this.polygonTree.getPolygons(result);
            return result;
        },

        addPolygons: function(polygons) {
            var _this = this;
            var polygontreenodes = polygons.map(function(p) {
                return _this.polygonTree.addChild(p);
            });
            this.rootnode.addPolygonTreeNodes(polygontreenodes);
        }
    };

    // # class Node
    // Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
    // by picking a polygon to split along.
    // Polygons are not stored directly in the tree, but in PolygonTreeNodes, stored in
    // this.polygontreenodes. Those PolygonTreeNodes are children of the owning
    // CSG.Tree.polygonTree
    // This is not a leafy BSP tree since there is
    // no distinction between internal and leaf nodes.
    CSG.Node = function(parent) {
        this.plane = null;
        this.front = null;
        this.back = null;
        this.polygontreenodes = [];
        this.parent = parent;
    };

    CSG.Node.prototype = {
        // Convert solid space to empty space and empty space to solid space.
        invert: function() {
            var queue = [this];
            var i, node;
            for (var i = 0; i < queue.length; i++) {
                node = queue[i];
                if(node.plane) node.plane = node.plane.flipped();
                if(node.front) queue.push(node.front);
                if(node.back) queue.push(node.back);
                var temp = node.front;
                node.front = node.back;
                node.back = temp;
            }
        },

        // clip polygontreenodes to our plane
        // calls remove() for all clipped PolygonTreeNodes
        clipPolygons: function(polygontreenodes, alsoRemovecoplanarFront) {
            var args = {'node': this, 'polygontreenodes': polygontreenodes }
            var node;
            var stack = [];

            do {
                node = args.node;
                polygontreenodes = args.polygontreenodes;

                // begin "function"
                if(node.plane) {
                    var backnodes = [];
                    var frontnodes = [];
                    var coplanarfrontnodes = alsoRemovecoplanarFront ? backnodes : frontnodes;
                    var plane = node.plane;
                    var numpolygontreenodes = polygontreenodes.length;
                    for(i = 0; i < numpolygontreenodes; i++) {
                        var node1 = polygontreenodes[i];
                        if(!node1.isRemoved()) {
                            node1.splitByPlane(plane, coplanarfrontnodes, backnodes, frontnodes, backnodes);
                        }
                    }

                    if(node.front && (frontnodes.length > 0)) {
                        stack.push({'node': node.front, 'polygontreenodes': frontnodes});
                    }
                    var numbacknodes = backnodes.length;
                    if (node.back && (numbacknodes > 0)) {
                        stack.push({'node': node.back, 'polygontreenodes': backnodes});
                    } else {
                        // there's nothing behind this plane. Delete the nodes behind this plane:
                        for (var i = 0; i < numbacknodes; i++) {
                            backnodes[i].remove();
                        }
                    }
                }
                args = stack.pop();
            } while (typeof(args) !== 'undefined');
        },

        // Remove all polygons in this BSP tree that are inside the other BSP tree
        // `tree`.
        clipTo: function(tree, alsoRemovecoplanarFront) {
            var node = this, stack = [];
            do {
                if(node.polygontreenodes.length > 0) {
                    tree.rootnode.clipPolygons(node.polygontreenodes, alsoRemovecoplanarFront);
                }
                if(node.front) stack.push(node.front);
                if(node.back) stack.push(node.back);
                node = stack.pop();
            } while(typeof(node) !== 'undefined');
        },

        addPolygonTreeNodes: function(polygontreenodes) {
            var args = {'node': this, 'polygontreenodes': polygontreenodes };
            var node;
            var stack = [];
            do {
                node = args.node;
                polygontreenodes = args.polygontreenodes;

                if (polygontreenodes.length === 0) {
                    args = stack.pop();
                    continue;
                }
                var _this = node;
                if (!node.plane) {
                    var bestplane = polygontreenodes[0].getPolygon().plane;
                    node.plane = bestplane;
                }
                var frontnodes = [];
                var backnodes = [];

                for (var i = 0, n = polygontreenodes.length ; i < n; ++i) {
                    polygontreenodes[i].splitByPlane(_this.plane, _this.polygontreenodes, backnodes, frontnodes, backnodes);
                }

                if (frontnodes.length > 0) {
                    if (!node.front) node.front = new CSG.Node(node);
                    stack.push({'node': node.front, 'polygontreenodes': frontnodes});
                }
                if (backnodes.length > 0) {
                    if (!node.back) node.back = new CSG.Node(node);
                    stack.push({'node': node.back, 'polygontreenodes': backnodes});
                }

                args = stack.pop();
            } while (typeof(args) !== 'undefined');
        },

        getParentPlaneNormals: function(normals, maxdepth) {
            if (maxdepth > 0) {
                if (this.parent) {
                    normals.push(this.parent.plane.normal);
                    this.parent.getParentPlaneNormals(normals, maxdepth - 1);
                }
            }
        }
    };

    //////////
    // # class Matrix4x4:
    // Represents a 4x4 matrix. Elements are specified in row order
    CSG.Matrix4x4 = function(elements) {
        if (arguments.length >= 1) {
            this.elements = elements;
        } else {
            // if no arguments passed: create unity matrix
            this.elements = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
        }
    };

    CSG.Matrix4x4.prototype = {
        plus: function(m) {
            var r = [];
            for (var i = 0; i < 16; i++) {
                r[i] = this.elements[i] + m.elements[i];
            }
            return new CSG.Matrix4x4(r);
        },

        minus: function(m) {
            var r = [];
            for (var i = 0; i < 16; i++) {
                r[i] = this.elements[i] - m.elements[i];
            }
            return new CSG.Matrix4x4(r);
        },

        // right multiply by another 4x4 matrix:
        multiply: function(m) {
            // cache elements in local variables, for speedup:
            var this0 = this.elements[0];
            var this1 = this.elements[1];
            var this2 = this.elements[2];
            var this3 = this.elements[3];
            var this4 = this.elements[4];
            var this5 = this.elements[5];
            var this6 = this.elements[6];
            var this7 = this.elements[7];
            var this8 = this.elements[8];
            var this9 = this.elements[9];
            var this10 = this.elements[10];
            var this11 = this.elements[11];
            var this12 = this.elements[12];
            var this13 = this.elements[13];
            var this14 = this.elements[14];
            var this15 = this.elements[15];
            var m0 = m.elements[0];
            var m1 = m.elements[1];
            var m2 = m.elements[2];
            var m3 = m.elements[3];
            var m4 = m.elements[4];
            var m5 = m.elements[5];
            var m6 = m.elements[6];
            var m7 = m.elements[7];
            var m8 = m.elements[8];
            var m9 = m.elements[9];
            var m10 = m.elements[10];
            var m11 = m.elements[11];
            var m12 = m.elements[12];
            var m13 = m.elements[13];
            var m14 = m.elements[14];
            var m15 = m.elements[15];

            var result = [];
            result[0] = this0 * m0 + this1 * m4 + this2 * m8 + this3 * m12;
            result[1] = this0 * m1 + this1 * m5 + this2 * m9 + this3 * m13;
            result[2] = this0 * m2 + this1 * m6 + this2 * m10 + this3 * m14;
            result[3] = this0 * m3 + this1 * m7 + this2 * m11 + this3 * m15;
            result[4] = this4 * m0 + this5 * m4 + this6 * m8 + this7 * m12;
            result[5] = this4 * m1 + this5 * m5 + this6 * m9 + this7 * m13;
            result[6] = this4 * m2 + this5 * m6 + this6 * m10 + this7 * m14;
            result[7] = this4 * m3 + this5 * m7 + this6 * m11 + this7 * m15;
            result[8] = this8 * m0 + this9 * m4 + this10 * m8 + this11 * m12;
            result[9] = this8 * m1 + this9 * m5 + this10 * m9 + this11 * m13;
            result[10] = this8 * m2 + this9 * m6 + this10 * m10 + this11 * m14;
            result[11] = this8 * m3 + this9 * m7 + this10 * m11 + this11 * m15;
            result[12] = this12 * m0 + this13 * m4 + this14 * m8 + this15 * m12;
            result[13] = this12 * m1 + this13 * m5 + this14 * m9 + this15 * m13;
            result[14] = this12 * m2 + this13 * m6 + this14 * m10 + this15 * m14;
            result[15] = this12 * m3 + this13 * m7 + this14 * m11 + this15 * m15;
            return new CSG.Matrix4x4(result);
        },

        clone: function() {
            var elements = this.elements.map(function(p) {
                return p;
            });
            return new CSG.Matrix4x4(elements);
        },

        // Right multiply the matrix by a CSG.Vector3D (interpreted as 3 row, 1 column)
        // (result = M*v)
        // Fourth element is taken as 1
        rightMultiply1x3Vector: function(v) {
            var v0 = v._x;
            var v1 = v._y;
            var v2 = v._z;
            var v3 = 1;
            var x = v0 * this.elements[0] + v1 * this.elements[1] + v2 * this.elements[2] + v3 * this.elements[3];
            var y = v0 * this.elements[4] + v1 * this.elements[5] + v2 * this.elements[6] + v3 * this.elements[7];
            var z = v0 * this.elements[8] + v1 * this.elements[9] + v2 * this.elements[10] + v3 * this.elements[11];
            var w = v0 * this.elements[12] + v1 * this.elements[13] + v2 * this.elements[14] + v3 * this.elements[15];
            // scale such that fourth element becomes 1:
            if (w != 1) {
                var invw = 1.0 / w;
                x *= invw;
                y *= invw;
                z *= invw;
            }
            return new CSG.Vector3D(x, y, z);
        },

        // Multiply a CSG.Vector3D (interpreted as 3 column, 1 row) by this matrix
        // (result = v*M)
        // Fourth element is taken as 1
        leftMultiply1x3Vector: function(v) {
            var v0 = v._x;
            var v1 = v._y;
            var v2 = v._z;
            var v3 = 1;
            var x = v0 * this.elements[0] + v1 * this.elements[4] + v2 * this.elements[8] + v3 * this.elements[12];
            var y = v0 * this.elements[1] + v1 * this.elements[5] + v2 * this.elements[9] + v3 * this.elements[13];
            var z = v0 * this.elements[2] + v1 * this.elements[6] + v2 * this.elements[10] + v3 * this.elements[14];
            var w = v0 * this.elements[3] + v1 * this.elements[7] + v2 * this.elements[11] + v3 * this.elements[15];
            // scale such that fourth element becomes 1:
            if (w != 1) {
                var invw = 1.0 / w;
                x *= invw;
                y *= invw;
                z *= invw;
            }
            return new CSG.Vector3D(x, y, z);
        },

        // Right multiply the matrix by a CSG.Vector2D (interpreted as 2 row, 1 column)
        // (result = M*v)
        // Fourth element is taken as 1
        rightMultiply1x2Vector: function(v) {
            var v0 = v.x;
            var v1 = v.y;
            var v2 = 0;
            var v3 = 1;
            var x = v0 * this.elements[0] + v1 * this.elements[1] + v2 * this.elements[2] + v3 * this.elements[3];
            var y = v0 * this.elements[4] + v1 * this.elements[5] + v2 * this.elements[6] + v3 * this.elements[7];
            var z = v0 * this.elements[8] + v1 * this.elements[9] + v2 * this.elements[10] + v3 * this.elements[11];
            var w = v0 * this.elements[12] + v1 * this.elements[13] + v2 * this.elements[14] + v3 * this.elements[15];
            // scale such that fourth element becomes 1:
            if (w != 1) {
                var invw = 1.0 / w;
                x *= invw;
                y *= invw;
                z *= invw;
            }
            return new CSG.Vector2D(x, y);
        },

        // Multiply a CSG.Vector2D (interpreted as 2 column, 1 row) by this matrix
        // (result = v*M)
        // Fourth element is taken as 1
        leftMultiply1x2Vector: function(v) {
            var v0 = v.x;
            var v1 = v.y;
            var v2 = 0;
            var v3 = 1;
            var x = v0 * this.elements[0] + v1 * this.elements[4] + v2 * this.elements[8] + v3 * this.elements[12];
            var y = v0 * this.elements[1] + v1 * this.elements[5] + v2 * this.elements[9] + v3 * this.elements[13];
            var z = v0 * this.elements[2] + v1 * this.elements[6] + v2 * this.elements[10] + v3 * this.elements[14];
            var w = v0 * this.elements[3] + v1 * this.elements[7] + v2 * this.elements[11] + v3 * this.elements[15];
            // scale such that fourth element becomes 1:
            if (w != 1) {
                var invw = 1.0 / w;
                x *= invw;
                y *= invw;
                z *= invw;
            }
            return new CSG.Vector2D(x, y);
        },

        // determine whether this matrix is a mirroring transformation
        isMirroring: function() {
            var u = new CSG.Vector3D(this.elements[0], this.elements[4], this.elements[8]);
            var v = new CSG.Vector3D(this.elements[1], this.elements[5], this.elements[9]);
            var w = new CSG.Vector3D(this.elements[2], this.elements[6], this.elements[10]);

            // for a true orthogonal, non-mirrored base, u.cross(v) == w
            // If they have an opposite direction then we are mirroring
            var mirrorvalue = u.cross(v).dot(w);
            var ismirror = (mirrorvalue < 0);
            return ismirror;
        }
    };

    // return the unity matrix
    CSG.Matrix4x4.unity = function() {
        return new CSG.Matrix4x4();
    };

    // Create a rotation matrix for rotating around the x axis
    CSG.Matrix4x4.rotationX = function(degrees) {
        var radians = degrees * Math.PI * (1.0 / 180.0);
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);
        var els = [
            1, 0, 0, 0, 0, cos, sin, 0, 0, -sin, cos, 0, 0, 0, 0, 1
        ];
        return new CSG.Matrix4x4(els);
    };

    // Create a rotation matrix for rotating around the y axis
    CSG.Matrix4x4.rotationY = function(degrees) {
        var radians = degrees * Math.PI * (1.0 / 180.0);
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);
        var els = [
            cos, 0, -sin, 0, 0, 1, 0, 0, sin, 0, cos, 0, 0, 0, 0, 1
        ];
        return new CSG.Matrix4x4(els);
    };

    // Create a rotation matrix for rotating around the z axis
    CSG.Matrix4x4.rotationZ = function(degrees) {
        var radians = degrees * Math.PI * (1.0 / 180.0);
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);
        var els = [
            cos, sin, 0, 0, -sin, cos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1
        ];
        return new CSG.Matrix4x4(els);
    };

    // Matrix for rotation about arbitrary point and axis
    CSG.Matrix4x4.rotation = function(rotationCenter, rotationAxis, degrees) {
        rotationCenter = new CSG.Vector3D(rotationCenter);
        rotationAxis = new CSG.Vector3D(rotationAxis);
        var rotationPlane = CSG.Plane.fromNormalAndPoint(rotationAxis, rotationCenter);
        var orthobasis = new CSG.OrthoNormalBasis(rotationPlane);
        var transformation = CSG.Matrix4x4.translation(rotationCenter.negated());
        transformation = transformation.multiply(orthobasis.getProjectionMatrix());
        transformation = transformation.multiply(CSG.Matrix4x4.rotationZ(degrees));
        transformation = transformation.multiply(orthobasis.getInverseProjectionMatrix());
        transformation = transformation.multiply(CSG.Matrix4x4.translation(rotationCenter));
        return transformation;
    };

    // Create an affine matrix for translation:
    CSG.Matrix4x4.translation = function(v) {
        // parse as CSG.Vector3D, so we can pass an array or a CSG.Vector3D
        var vec = new CSG.Vector3D(v);
        var els = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, vec.x, vec.y, vec.z, 1];
        return new CSG.Matrix4x4(els);
    };

    // Create an affine matrix for mirroring into an arbitrary plane:
    CSG.Matrix4x4.mirroring = function(plane) {
        var nx = plane.normal.x;
        var ny = plane.normal.y;
        var nz = plane.normal.z;
        var w = plane.w;
        var els = [
            (1.0 - 2.0 * nx * nx), (-2.0 * ny * nx), (-2.0 * nz * nx), 0,
            (-2.0 * nx * ny), (1.0 - 2.0 * ny * ny), (-2.0 * nz * ny), 0,
            (-2.0 * nx * nz), (-2.0 * ny * nz), (1.0 - 2.0 * nz * nz), 0,
            (2.0 * nx * w), (2.0 * ny * w), (2.0 * nz * w), 1
        ];
        return new CSG.Matrix4x4(els);
    };

    // Create an affine matrix for scaling:
    CSG.Matrix4x4.scaling = function(v) {
        // parse as CSG.Vector3D, so we can pass an array or a CSG.Vector3D
        var vec = new CSG.Vector3D(v);
        var els = [
            vec.x, 0, 0, 0, 0, vec.y, 0, 0, 0, 0, vec.z, 0, 0, 0, 0, 1
        ];
        return new CSG.Matrix4x4(els);
    };

    ///////////////////////////////////////////////////
    // # class Vector2D:
    // Represents a 2 element vector
    CSG.Vector2D = function(x, y) {
        if (arguments.length == 2) {
            this._x = parseFloat(x);
            this._y = parseFloat(y);
        } else {
            var ok = true;
            if (arguments.length == 1) {
                if (typeof(x) == "object") {
                    if (x instanceof CSG.Vector2D) {
                        this._x = x._x;
                        this._y = x._y;
                    } else if (x instanceof Array) {
                        this._x = parseFloat(x[0]);
                        this._y = parseFloat(x[1]);
                    } else if (('x' in x) && ('y' in x)) {
                        this._x = parseFloat(x.x);
                        this._y = parseFloat(x.y);
                    } else ok = false;
                } else {
                    var v = parseFloat(x);
                    this._x = v;
                    this._y = v;
                }
            } else ok = false;
            if (ok) {
                if ((!CSG.IsFloat(this._x)) || (!CSG.IsFloat(this._y))) ok = false;
            }
            if (!ok) {
                throw new Error("wrong arguments");
            }
        }
    };

    CSG.Vector2D.fromAngle = function(radians) {
        return CSG.Vector2D.fromAngleRadians(radians);
    };

    CSG.Vector2D.fromAngleDegrees = function(degrees) {
        var radians = Math.PI * degrees / 180;
        return CSG.Vector2D.fromAngleRadians(radians);
    };

    CSG.Vector2D.fromAngleRadians = function(radians) {
        return CSG.Vector2D.Create(Math.cos(radians), Math.sin(radians));
    };

    // This does the same as new CSG.Vector2D(x,y) but it doesn't go through the constructor
    // and the parameters are not validated. Is much faster.
    CSG.Vector2D.Create = function(x, y) {
        var result = Object.create(CSG.Vector2D.prototype);
        result._x = x;
        result._y = y;
        return result;
    };

    CSG.Vector2D.prototype = {
        get x() {
            return this._x;
        },
        get y() {
            return this._y;
        },

        set x(v) {
            throw new Error("Vector2D is immutable");
        },
        set y(v) {
            throw new Error("Vector2D is immutable");
        },

        // extend to a 3D vector by adding a z coordinate:
        toVector3D: function(z) {
            return new CSG.Vector3D(this._x, this._y, z);
        },

        equals: function(a) {
            return (this._x == a._x) && (this._y == a._y);
        },

        clone: function() {
            return CSG.Vector2D.Create(this._x, this._y);
        },

        negated: function() {
            return CSG.Vector2D.Create(-this._x, -this._y);
        },

        plus: function(a) {
            return CSG.Vector2D.Create(this._x + a._x, this._y + a._y);
        },

        minus: function(a) {
            return CSG.Vector2D.Create(this._x - a._x, this._y - a._y);
        },

        times: function(a) {
            return CSG.Vector2D.Create(this._x * a, this._y * a);
        },

        dividedBy: function(a) {
            return CSG.Vector2D.Create(this._x / a, this._y / a);
        },

        dot: function(a) {
            return this._x * a._x + this._y * a._y;
        },

        lerp: function(a, t) {
            return this.plus(a.minus(this).times(t));
        },

        length: function() {
            return Math.sqrt(this.dot(this));
        },

        distanceTo: function(a) {
            return this.minus(a).length();
        },

        distanceToSquared: function(a) {
            return this.minus(a).lengthSquared();
        },

        lengthSquared: function() {
            return this.dot(this);
        },

        unit: function() {
            return this.dividedBy(this.length());
        },

        cross: function(a) {
            return this._x * a._y - this._y * a._x;
        },

        // returns the vector rotated by 90 degrees clockwise
        normal: function() {
            return CSG.Vector2D.Create(this._y, -this._x);
        },

        // Right multiply by a 4x4 matrix (the vector is interpreted as a row vector)
        // Returns a new CSG.Vector2D
        multiply4x4: function(matrix4x4) {
            return matrix4x4.leftMultiply1x2Vector(this);
        },

        transform: function(matrix4x4) {
            return matrix4x4.leftMultiply1x2Vector(this);
        },

        angle: function() {
            return this.angleRadians();
        },

        angleDegrees: function() {
            var radians = this.angleRadians();
            return 180 * radians / Math.PI;
        },

        angleRadians: function() {
            // y=sin, x=cos
            return Math.atan2(this._y, this._x);
        },

        min: function(p) {
            return CSG.Vector2D.Create(
                Math.min(this._x, p._x), Math.min(this._y, p._y));
        },

        max: function(p) {
            return CSG.Vector2D.Create(
                Math.max(this._x, p._x), Math.max(this._y, p._y));
        },

        toString: function() {
            return "(" + this._x.toFixed(2) + ", " + this._y.toFixed(2) + ")";
        },

        abs: function() {
            return CSG.Vector2D.Create(Math.abs(this._x), Math.abs(this._y));
        },
    };


    // # class Line2D
    // Represents a directional line in 2D space
    // A line is parametrized by its normal vector (perpendicular to the line, rotated 90 degrees counter clockwise)
    // and w. The line passes through the point <normal>.times(w).
    // normal must be a unit vector!
    // Equation: p is on line if normal.dot(p)==w
    CSG.Line2D = function(normal, w) {
        normal = new CSG.Vector2D(normal);
        w = parseFloat(w);
        var l = normal.length();
        // normalize:
        w *= l;
        normal = normal.times(1.0 / l);
        this.normal = normal;
        this.w = w;
    };

    CSG.Line2D.fromPoints = function(p1, p2) {
        p1 = new CSG.Vector2D(p1);
        p2 = new CSG.Vector2D(p2);
        var direction = p2.minus(p1);
        var normal = direction.normal().negated().unit();
        var w = p1.dot(normal);
        return new CSG.Line2D(normal, w);
    };

    CSG.Line2D.prototype = {
        // same line but opposite direction:
        reverse: function() {
            return new CSG.Line2D(this.normal.negated(), -this.w);
        },

        equals: function(l) {
            return (l.normal.equals(this.normal) && (l.w == this.w));
        },

        origin: function() {
            return this.normal.times(this.w);
        },

        direction: function() {
            return this.normal.normal();
        },

        xAtY: function(y) {
            // (py == y) && (normal * p == w)
            // -> px = (w - normal._y * y) / normal.x
            var x = (this.w - this.normal._y * y) / this.normal.x;
            return x;
        },

        absDistanceToPoint: function(point) {
            point = new CSG.Vector2D(point);
            var point_projected = point.dot(this.normal);
            var distance = Math.abs(point_projected - this.w);
            return distance;
        },
        /*FIXME: has error - origin is not defined, the method is never used
         closestPoint: function(point) {
             point = new CSG.Vector2D(point);
             var vector = point.dot(this.direction());
             return origin.plus(vector);
         },
         */

        // intersection between two lines, returns point as Vector2D
        intersectWithLine: function(line2d) {
            var point = CSG.solve2Linear(this.normal.x, this.normal.y, line2d.normal.x, line2d.normal.y, this.w, line2d.w);
            point = new CSG.Vector2D(point); // make  vector2d
            return point;
        },

        transform: function(matrix4x4) {
            var origin = new CSG.Vector2D(0, 0);
            var pointOnPlane = this.normal.times(this.w);
            var neworigin = origin.multiply4x4(matrix4x4);
            var neworiginPlusNormal = this.normal.multiply4x4(matrix4x4);
            var newnormal = neworiginPlusNormal.minus(neworigin);
            var newpointOnPlane = pointOnPlane.multiply4x4(matrix4x4);
            var neww = newnormal.dot(newpointOnPlane);
            return new CSG.Line2D(newnormal, neww);
        }
    };

    // # class Line3D
    // Represents a line in 3D space
    // direction must be a unit vector
    // point is a random point on the line
    CSG.Line3D = function(point, direction) {
        point = new CSG.Vector3D(point);
        direction = new CSG.Vector3D(direction);
        this.point = point;
        this.direction = direction.unit();
    };

    CSG.Line3D.fromPoints = function(p1, p2) {
        p1 = new CSG.Vector3D(p1);
        p2 = new CSG.Vector3D(p2);
        var direction = p2.minus(p1);
        return new CSG.Line3D(p1, direction);
    };

    CSG.Line3D.fromPlanes = function(p1, p2) {
        var direction = p1.normal.cross(p2.normal);
        var l = direction.length();
        if (l < 1e-10) {
            throw new Error("Parallel planes");
        }
        direction = direction.times(1.0 / l);

        var mabsx = Math.abs(direction.x);
        var mabsy = Math.abs(direction.y);
        var mabsz = Math.abs(direction.z);
        var origin;
        if ((mabsx >= mabsy) && (mabsx >= mabsz)) {
            // direction vector is mostly pointing towards x
            // find a point p for which x is zero:
            var r = CSG.solve2Linear(p1.normal.y, p1.normal.z, p2.normal.y, p2.normal.z, p1.w, p2.w);
            origin = new CSG.Vector3D(0, r[0], r[1]);
        } else if ((mabsy >= mabsx) && (mabsy >= mabsz)) {
            // find a point p for which y is zero:
            var r = CSG.solve2Linear(p1.normal.x, p1.normal.z, p2.normal.x, p2.normal.z, p1.w, p2.w);
            origin = new CSG.Vector3D(r[0], 0, r[1]);
        } else {
            // find a point p for which z is zero:
            var r = CSG.solve2Linear(p1.normal.x, p1.normal.y, p2.normal.x, p2.normal.y, p1.w, p2.w);
            origin = new CSG.Vector3D(r[0], r[1], 0);
        }
        return new CSG.Line3D(origin, direction);
    };


    CSG.Line3D.prototype = {
        intersectWithPlane: function(plane) {
            // plane: plane.normal * p = plane.w
            // line: p=line.point + labda * line.direction
            var labda = (plane.w - plane.normal.dot(this.point)) / plane.normal.dot(this.direction);
            var point = this.point.plus(this.direction.times(labda));
            return point;
        },

        clone: function(line) {
            return new CSG.Line3D(this.point.clone(), this.direction.clone());
        },

        reverse: function() {
            return new CSG.Line3D(this.point.clone(), this.direction.negated());
        },

        transform: function(matrix4x4) {
            var newpoint = this.point.multiply4x4(matrix4x4);
            var pointPlusDirection = this.point.plus(this.direction);
            var newPointPlusDirection = pointPlusDirection.multiply4x4(matrix4x4);
            var newdirection = newPointPlusDirection.minus(newpoint);
            return new CSG.Line3D(newpoint, newdirection);
        },

        closestPointOnLine: function(point) {
            point = new CSG.Vector3D(point);
            var t = point.minus(this.point).dot(this.direction) / this.direction.dot(this.direction);
            var closestpoint = this.point.plus(this.direction.times(t));
            return closestpoint;
        },

        distanceToPoint: function(point) {
            point = new CSG.Vector3D(point);
            var closestpoint = this.closestPointOnLine(point);
            var distancevector = point.minus(closestpoint);
            var distance = distancevector.length();
            return distance;
        },

        equals: function(line3d) {
            if (!this.direction.equals(line3d.direction)) return false;
            var distance = this.distanceToPoint(line3d.point);
            if (distance > 1e-8) return false;
            return true;
        }
    };


    // # class OrthoNormalBasis
    // Reprojects points on a 3D plane onto a 2D plane
    // or from a 2D plane back onto the 3D plane
    CSG.OrthoNormalBasis = function(plane, rightvector) {
        if (arguments.length < 2) {
            // choose an arbitrary right hand vector, making sure it is somewhat orthogonal to the plane normal:
            rightvector = plane.normal.randomNonParallelVector();
        } else {
            rightvector = new CSG.Vector3D(rightvector);
        }
        this.v = plane.normal.cross(rightvector).unit();
        this.u = this.v.cross(plane.normal);
        this.plane = plane;
        this.planeorigin = plane.normal.times(plane.w);
    };

    // Get an orthonormal basis for the standard XYZ planes.
    // Parameters: the names of two 3D axes. The 2d x axis will map to the first given 3D axis, the 2d y 
    // axis will map to the second.
    // Prepend the axis with a "-" to invert the direction of this axis.
    // For example: CSG.OrthoNormalBasis.GetCartesian("-Y","Z")
    //   will return an orthonormal basis where the 2d X axis maps to the 3D inverted Y axis, and
    //   the 2d Y axis maps to the 3D Z axis.
    CSG.OrthoNormalBasis.GetCartesian = function(xaxisid, yaxisid) {
        var axisid = xaxisid + "/" + yaxisid;
        var planenormal, rightvector;
        if (axisid == "X/Y") {
            planenormal = [0, 0, 1];
            rightvector = [1, 0, 0];
        } else if (axisid == "Y/-X") {
            planenormal = [0, 0, 1];
            rightvector = [0, 1, 0];
        } else if (axisid == "-X/-Y") {
            planenormal = [0, 0, 1];
            rightvector = [-1, 0, 0];
        } else if (axisid == "-Y/X") {
            planenormal = [0, 0, 1];
            rightvector = [0, -1, 0];
        } else if (axisid == "-X/Y") {
            planenormal = [0, 0, -1];
            rightvector = [-1, 0, 0];
        } else if (axisid == "-Y/-X") {
            planenormal = [0, 0, -1];
            rightvector = [0, -1, 0];
        } else if (axisid == "X/-Y") {
            planenormal = [0, 0, -1];
            rightvector = [1, 0, 0];
        } else if (axisid == "Y/X") {
            planenormal = [0, 0, -1];
            rightvector = [0, 1, 0];
        } else if (axisid == "X/Z") {
            planenormal = [0, -1, 0];
            rightvector = [1, 0, 0];
        } else if (axisid == "Z/-X") {
            planenormal = [0, -1, 0];
            rightvector = [0, 0, 1];
        } else if (axisid == "-X/-Z") {
            planenormal = [0, -1, 0];
            rightvector = [-1, 0, 0];
        } else if (axisid == "-Z/X") {
            planenormal = [0, -1, 0];
            rightvector = [0, 0, -1];
        } else if (axisid == "-X/Z") {
            planenormal = [0, 1, 0];
            rightvector = [-1, 0, 0];
        } else if (axisid == "-Z/-X") {
            planenormal = [0, 1, 0];
            rightvector = [0, 0, -1];
        } else if (axisid == "X/-Z") {
            planenormal = [0, 1, 0];
            rightvector = [1, 0, 0];
        } else if (axisid == "Z/X") {
            planenormal = [0, 1, 0];
            rightvector = [0, 0, 1];
        } else if (axisid == "Y/Z") {
            planenormal = [1, 0, 0];
            rightvector = [0, 1, 0];
        } else if (axisid == "Z/-Y") {
            planenormal = [1, 0, 0];
            rightvector = [0, 0, 1];
        } else if (axisid == "-Y/-Z") {
            planenormal = [1, 0, 0];
            rightvector = [0, -1, 0];
        } else if (axisid == "-Z/Y") {
            planenormal = [1, 0, 0];
            rightvector = [0, 0, -1];
        } else if (axisid == "-Y/Z") {
            planenormal = [-1, 0, 0];
            rightvector = [0, -1, 0];
        } else if (axisid == "-Z/-Y") {
            planenormal = [-1, 0, 0];
            rightvector = [0, 0, -1];
        } else if (axisid == "Y/-Z") {
            planenormal = [-1, 0, 0];
            rightvector = [0, 1, 0];
        } else if (axisid == "Z/Y") {
            planenormal = [-1, 0, 0];
            rightvector = [0, 0, 1];
        } else {
            throw new Error("CSG.OrthoNormalBasis.GetCartesian: invalid combination of axis identifiers. Should pass two string arguments from [X,Y,Z,-X,-Y,-Z], being two different axes.");
        }
        return new CSG.OrthoNormalBasis(new CSG.Plane(new CSG.Vector3D(planenormal), 0), new CSG.Vector3D(rightvector));
    };

    /*
    // test code for CSG.OrthoNormalBasis.GetCartesian()
    CSG.OrthoNormalBasis.GetCartesian_Test=function() {
      var axisnames=["X","Y","Z","-X","-Y","-Z"];
      var axisvectors=[[1,0,0], [0,1,0], [0,0,1], [-1,0,0], [0,-1,0], [0,0,-1]];
      for(var axis1=0; axis1 < 3; axis1++) {
        for(var axis1inverted=0; axis1inverted < 2; axis1inverted++) {
          var axis1name=axisnames[axis1+3*axis1inverted];
          var axis1vector=axisvectors[axis1+3*axis1inverted];
          for(var axis2=0; axis2 < 3; axis2++) {
            if(axis2 != axis1) {
              for(var axis2inverted=0; axis2inverted < 2; axis2inverted++) {
                var axis2name=axisnames[axis2+3*axis2inverted];
                var axis2vector=axisvectors[axis2+3*axis2inverted];
                var orthobasis=CSG.OrthoNormalBasis.GetCartesian(axis1name, axis2name);
                var test1=orthobasis.to3D(new CSG.Vector2D([1,0]));
                var test2=orthobasis.to3D(new CSG.Vector2D([0,1]));
                var expected1=new CSG.Vector3D(axis1vector);
                var expected2=new CSG.Vector3D(axis2vector);
                var d1=test1.distanceTo(expected1);
                var d2=test2.distanceTo(expected2);
                if( (d1 > 0.01) || (d2 > 0.01) ) {
                  throw new Error("Wrong!");
      }}}}}}
      throw new Error("OK");
    };
    */

    // The z=0 plane, with the 3D x and y vectors mapped to the 2D x and y vector
    CSG.OrthoNormalBasis.Z0Plane = function() {
        var plane = new CSG.Plane(new CSG.Vector3D([0, 0, 1]), 0);
        return new CSG.OrthoNormalBasis(plane, new CSG.Vector3D([1, 0, 0]));
    };

    CSG.OrthoNormalBasis.prototype = {
        getProjectionMatrix: function() {
            return new CSG.Matrix4x4([
                this.u.x, this.v.x, this.plane.normal.x, 0,
                this.u.y, this.v.y, this.plane.normal.y, 0,
                this.u.z, this.v.z, this.plane.normal.z, 0,
                0, 0, -this.plane.w, 1
            ]);
        },

        getInverseProjectionMatrix: function() {
            var p = this.plane.normal.times(this.plane.w);
            return new CSG.Matrix4x4([
                this.u.x, this.u.y, this.u.z, 0,
                this.v.x, this.v.y, this.v.z, 0,
                this.plane.normal.x, this.plane.normal.y, this.plane.normal.z, 0,
                p.x, p.y, p.z, 1
            ]);
        },

        to2D: function(vec3) {
            return new CSG.Vector2D(vec3.dot(this.u), vec3.dot(this.v));
        },

        to3D: function(vec2) {
            return this.planeorigin.plus(this.u.times(vec2.x)).plus(this.v.times(vec2.y));
        },

        line3Dto2D: function(line3d) {
            var a = line3d.point;
            var b = line3d.direction.plus(a);
            var a2d = this.to2D(a);
            var b2d = this.to2D(b);
            return CSG.Line2D.fromPoints(a2d, b2d);
        },

        line2Dto3D: function(line2d) {
            var a = line2d.origin();
            var b = line2d.direction().plus(a);
            var a3d = this.to3D(a);
            var b3d = this.to3D(b);
            return CSG.Line3D.fromPoints(a3d, b3d);
        },

        transform: function(matrix4x4) {
            // todo: this may not work properly in case of mirroring
            var newplane = this.plane.transform(matrix4x4);
            var rightpoint_transformed = this.u.transform(matrix4x4);
            var origin_transformed = new CSG.Vector3D(0, 0, 0).transform(matrix4x4);
            var newrighthandvector = rightpoint_transformed.minus(origin_transformed);
            var newbasis = new CSG.OrthoNormalBasis(newplane, newrighthandvector);
            return newbasis;
        }
    };

    function insertSorted(array, element, comparefunc) {
        var leftbound = 0;
        var rightbound = array.length;
        while (rightbound > leftbound) {
            var testindex = Math.floor((leftbound + rightbound) / 2);
            var testelement = array[testindex];
            var compareresult = comparefunc(element, testelement);
            if (compareresult > 0) // element > testelement
            {
                leftbound = testindex + 1;
            } else {
                rightbound = testindex;
            }
        }
        array.splice(leftbound, 0, element);
    }

    // Get the x coordinate of a point with a certain y coordinate, interpolated between two
    // points (CSG.Vector2D).
    // Interpolation is robust even if the points have the same y coordinate
    CSG.interpolateBetween2DPointsForY = function(point1, point2, y) {
        var f1 = y - point1.y;
        var f2 = point2.y - point1.y;
        if (f2 < 0) {
            f1 = -f1;
            f2 = -f2;
        }
        var t;
        if (f1 <= 0) {
            t = 0.0;
        } else if (f1 >= f2) {
            t = 1.0;
        } else if (f2 < 1e-10) {
            t = 0.5;
        } else {
            t = f1 / f2;
        }
        var result = point1.x + t * (point2.x - point1.x);
        return result;
    };

    // Retesselation function for a set of coplanar polygons. See the introduction at the top of
    // this file.
    CSG.reTesselateCoplanarPolygons = function(sourcepolygons, destpolygons) {
        var EPS = 1e-5;

        var numpolygons = sourcepolygons.length;
        if (numpolygons > 0) {
            var plane = sourcepolygons[0].plane;
            var shared = sourcepolygons[0].shared;
            var orthobasis = new CSG.OrthoNormalBasis(plane);
            var polygonvertices2d = []; // array of array of CSG.Vector2D
            var polygontopvertexindexes = []; // array of indexes of topmost vertex per polygon
            var topy2polygonindexes = {};
            var ycoordinatetopolygonindexes = {};

            var xcoordinatebins = {};
            var ycoordinatebins = {};

            // convert all polygon vertices to 2D
            // Make a list of all encountered y coordinates
            // And build a map of all polygons that have a vertex at a certain y coordinate:
            var ycoordinateBinningFactor = 1.0 / EPS * 10;
            for (var polygonindex = 0; polygonindex < numpolygons; polygonindex++) {
                var poly3d = sourcepolygons[polygonindex];
                var vertices2d = [];
                var numvertices = poly3d.vertices.length;
                var minindex = -1;
                if (numvertices > 0) {
                    var miny, maxy, maxindex;
                    for (var i = 0; i < numvertices; i++) {
                        var pos2d = orthobasis.to2D(poly3d.vertices[i].pos);
                        // perform binning of y coordinates: If we have multiple vertices very
                        // close to each other, give them the same y coordinate:
                        var ycoordinatebin = Math.floor(pos2d.y * ycoordinateBinningFactor);
                        var newy;
                        if (ycoordinatebin in ycoordinatebins) {
                            newy = ycoordinatebins[ycoordinatebin];
                        } else if (ycoordinatebin + 1 in ycoordinatebins) {
                            newy = ycoordinatebins[ycoordinatebin + 1];
                        } else if (ycoordinatebin - 1 in ycoordinatebins) {
                            newy = ycoordinatebins[ycoordinatebin - 1];
                        } else {
                            newy = pos2d.y;
                            ycoordinatebins[ycoordinatebin] = pos2d.y;
                        }
                        pos2d = CSG.Vector2D.Create(pos2d.x, newy);
                        vertices2d.push(pos2d);
                        var y = pos2d.y;
                        if ((i === 0) || (y < miny)) {
                            miny = y;
                            minindex = i;
                        }
                        if ((i === 0) || (y > maxy)) {
                            maxy = y;
                            maxindex = i;
                        }
                        if (!(y in ycoordinatetopolygonindexes)) {
                            ycoordinatetopolygonindexes[y] = {};
                        }
                        ycoordinatetopolygonindexes[y][polygonindex] = true;
                    }
                    if (miny >= maxy) {
                        // degenerate polygon, all vertices have same y coordinate. Just ignore it from now:
                        vertices2d = [];
                        numvertices = 0;
                        minindex = -1;
                    } else {
                        if (!(miny in topy2polygonindexes)) {
                            topy2polygonindexes[miny] = [];
                        }
                        topy2polygonindexes[miny].push(polygonindex);
                    }
                } // if(numvertices > 0)
                // reverse the vertex order:
                vertices2d.reverse();
                minindex = numvertices - minindex - 1;
                polygonvertices2d.push(vertices2d);
                polygontopvertexindexes.push(minindex);
            }
            var ycoordinates = [];
            for (var ycoordinate in ycoordinatetopolygonindexes) ycoordinates.push(ycoordinate);
            ycoordinates.sort(fnNumberSort);

            // Now we will iterate over all y coordinates, from lowest to highest y coordinate
            // activepolygons: source polygons that are 'active', i.e. intersect with our y coordinate
            //   Is sorted so the polygons are in left to right order
            // Each element in activepolygons has these properties:
            //        polygonindex: the index of the source polygon (i.e. an index into the sourcepolygons
            //                      and polygonvertices2d arrays)
            //        leftvertexindex: the index of the vertex at the left side of the polygon (lowest x)
            //                         that is at or just above the current y coordinate
            //        rightvertexindex: dito at right hand side of polygon
            //        topleft, bottomleft: coordinates of the left side of the polygon crossing the current y coordinate
            //        topright, bottomright: coordinates of the right hand side of the polygon crossing the current y coordinate
            var activepolygons = [];
            var prevoutpolygonrow = [];
            for (var yindex = 0; yindex < ycoordinates.length; yindex++) {
                var newoutpolygonrow = [];
                var ycoordinate_as_string = ycoordinates[yindex];
                var ycoordinate = Number(ycoordinate_as_string);

                // update activepolygons for this y coordinate:
                // - Remove any polygons that end at this y coordinate
                // - update leftvertexindex and rightvertexindex (which point to the current vertex index
                //   at the the left and right side of the polygon
                // Iterate over all polygons that have a corner at this y coordinate:
                var polygonindexeswithcorner = ycoordinatetopolygonindexes[ycoordinate_as_string];
                for (var activepolygonindex = 0; activepolygonindex < activepolygons.length; ++activepolygonindex) {
                    var activepolygon = activepolygons[activepolygonindex];
                    var polygonindex = activepolygon.polygonindex;
                    if (polygonindexeswithcorner[polygonindex]) {
                        // this active polygon has a corner at this y coordinate:
                        var vertices2d = polygonvertices2d[polygonindex];
                        var numvertices = vertices2d.length;
                        var newleftvertexindex = activepolygon.leftvertexindex;
                        var newrightvertexindex = activepolygon.rightvertexindex;
                        // See if we need to increase leftvertexindex or decrease rightvertexindex:
                        while (true) {
                            var nextleftvertexindex = newleftvertexindex + 1;
                            if (nextleftvertexindex >= numvertices) nextleftvertexindex = 0;
                            if (vertices2d[nextleftvertexindex].y != ycoordinate) break;
                            newleftvertexindex = nextleftvertexindex;
                        }
                        var nextrightvertexindex = newrightvertexindex - 1;
                        if (nextrightvertexindex < 0) nextrightvertexindex = numvertices - 1;
                        if (vertices2d[nextrightvertexindex].y == ycoordinate) {
                            newrightvertexindex = nextrightvertexindex;
                        }
                        if ((newleftvertexindex != activepolygon.leftvertexindex) && (newleftvertexindex == newrightvertexindex)) {
                            // We have increased leftvertexindex or decreased rightvertexindex, and now they point to the same vertex
                            // This means that this is the bottom point of the polygon. We'll remove it:
                            activepolygons.splice(activepolygonindex, 1);
                            --activepolygonindex;
                        } else {
                            activepolygon.leftvertexindex = newleftvertexindex;
                            activepolygon.rightvertexindex = newrightvertexindex;
                            activepolygon.topleft = vertices2d[newleftvertexindex];
                            activepolygon.topright = vertices2d[newrightvertexindex];
                            var nextleftvertexindex = newleftvertexindex + 1;
                            if (nextleftvertexindex >= numvertices) nextleftvertexindex = 0;
                            activepolygon.bottomleft = vertices2d[nextleftvertexindex];
                            var nextrightvertexindex = newrightvertexindex - 1;
                            if (nextrightvertexindex < 0) nextrightvertexindex = numvertices - 1;
                            activepolygon.bottomright = vertices2d[nextrightvertexindex];
                        }
                    } // if polygon has corner here
                } // for activepolygonindex
                var nextycoordinate;
                if (yindex >= ycoordinates.length - 1) {
                    // last row, all polygons must be finished here:
                    activepolygons = [];
                    nextycoordinate = null;
                } else // yindex < ycoordinates.length-1
                {
                    nextycoordinate = Number(ycoordinates[yindex + 1]);
                    var middleycoordinate = 0.5 * (ycoordinate + nextycoordinate);
                    // update activepolygons by adding any polygons that start here:
                    var startingpolygonindexes = topy2polygonindexes[ycoordinate_as_string];
                    for (var polygonindex_key in startingpolygonindexes) {
                        var polygonindex = startingpolygonindexes[polygonindex_key];
                        var vertices2d = polygonvertices2d[polygonindex];
                        var numvertices = vertices2d.length;
                        var topvertexindex = polygontopvertexindexes[polygonindex];
                        // the top of the polygon may be a horizontal line. In that case topvertexindex can point to any point on this line.
                        // Find the left and right topmost vertices which have the current y coordinate:
                        var topleftvertexindex = topvertexindex;
                        while (true) {
                            var i = topleftvertexindex + 1;
                            if (i >= numvertices) i = 0;
                            if (vertices2d[i].y != ycoordinate) break;
                            if (i == topvertexindex) break; // should not happen, but just to prevent endless loops
                            topleftvertexindex = i;
                        }
                        var toprightvertexindex = topvertexindex;
                        while (true) {
                            var i = toprightvertexindex - 1;
                            if (i < 0) i = numvertices - 1;
                            if (vertices2d[i].y != ycoordinate) break;
                            if (i == topleftvertexindex) break; // should not happen, but just to prevent endless loops
                            toprightvertexindex = i;
                        }
                        var nextleftvertexindex = topleftvertexindex + 1;
                        if (nextleftvertexindex >= numvertices) nextleftvertexindex = 0;
                        var nextrightvertexindex = toprightvertexindex - 1;
                        if (nextrightvertexindex < 0) nextrightvertexindex = numvertices - 1;
                        var newactivepolygon = {
                            polygonindex: polygonindex,
                            leftvertexindex: topleftvertexindex,
                            rightvertexindex: toprightvertexindex,
                            topleft: vertices2d[topleftvertexindex],
                            topright: vertices2d[toprightvertexindex],
                            bottomleft: vertices2d[nextleftvertexindex],
                            bottomright: vertices2d[nextrightvertexindex],
                        };
                        insertSorted(activepolygons, newactivepolygon, function(el1, el2) {
                            var x1 = CSG.interpolateBetween2DPointsForY(
                                el1.topleft, el1.bottomleft, middleycoordinate);
                            var x2 = CSG.interpolateBetween2DPointsForY(
                                el2.topleft, el2.bottomleft, middleycoordinate);
                            if (x1 > x2) return 1;
                            if (x1 < x2) return -1;
                            return 0;
                        });
                    } // for(var polygonindex in startingpolygonindexes)
                } //  yindex < ycoordinates.length-1
                //if( (yindex == ycoordinates.length-1) || (nextycoordinate - ycoordinate > EPS) )
                if (true) {
                    // Now activepolygons is up to date
                    // Build the output polygons for the next row in newoutpolygonrow:
                    for (var activepolygon_key in activepolygons) {
                        var activepolygon = activepolygons[activepolygon_key];
                        var polygonindex = activepolygon.polygonindex;
                        var vertices2d = polygonvertices2d[polygonindex];
                        var numvertices = vertices2d.length;

                        var x = CSG.interpolateBetween2DPointsForY(activepolygon.topleft, activepolygon.bottomleft, ycoordinate);
                        var topleft = CSG.Vector2D.Create(x, ycoordinate);
                        x = CSG.interpolateBetween2DPointsForY(activepolygon.topright, activepolygon.bottomright, ycoordinate);
                        var topright = CSG.Vector2D.Create(x, ycoordinate);
                        x = CSG.interpolateBetween2DPointsForY(activepolygon.topleft, activepolygon.bottomleft, nextycoordinate);
                        var bottomleft = CSG.Vector2D.Create(x, nextycoordinate);
                        x = CSG.interpolateBetween2DPointsForY(activepolygon.topright, activepolygon.bottomright, nextycoordinate);
                        var bottomright = CSG.Vector2D.Create(x, nextycoordinate);
                        var outpolygon = {
                            topleft: topleft,
                            topright: topright,
                            bottomleft: bottomleft,
                            bottomright: bottomright,
                            leftline: CSG.Line2D.fromPoints(topleft, bottomleft),
                            rightline: CSG.Line2D.fromPoints(bottomright, topright)
                        };
                        if (newoutpolygonrow.length > 0) {
                            var prevoutpolygon = newoutpolygonrow[newoutpolygonrow.length - 1];
                            var d1 = outpolygon.topleft.distanceTo(prevoutpolygon.topright);
                            var d2 = outpolygon.bottomleft.distanceTo(prevoutpolygon.bottomright);
                            if ((d1 < EPS) && (d2 < EPS)) {
                                // we can join this polygon with the one to the left:
                                outpolygon.topleft = prevoutpolygon.topleft;
                                outpolygon.leftline = prevoutpolygon.leftline;
                                outpolygon.bottomleft = prevoutpolygon.bottomleft;
                                newoutpolygonrow.splice(newoutpolygonrow.length - 1, 1);
                            }
                        }
                        newoutpolygonrow.push(outpolygon);
                    } // for(activepolygon in activepolygons)
                    if (yindex > 0) {
                        // try to match the new polygons against the previous row:
                        var prevcontinuedindexes = {};
                        var matchedindexes = {};
                        for (var i = 0; i < newoutpolygonrow.length; i++) {
                            var thispolygon = newoutpolygonrow[i];
                            for (var ii = 0; ii < prevoutpolygonrow.length; ii++) {
                                if (!matchedindexes[ii]) // not already processed?
                                {
                                    // We have a match if the sidelines are equal or if the top coordinates
                                    // are on the sidelines of the previous polygon
                                    var prevpolygon = prevoutpolygonrow[ii];
                                    if (prevpolygon.bottomleft.distanceTo(thispolygon.topleft) < EPS) {
                                        if (prevpolygon.bottomright.distanceTo(thispolygon.topright) < EPS) {
                                            // Yes, the top of this polygon matches the bottom of the previous:
                                            matchedindexes[ii] = true;
                                            // Now check if the joined polygon would remain convex:
                                            var d1 = thispolygon.leftline.direction().x - prevpolygon.leftline.direction().x;
                                            var d2 = thispolygon.rightline.direction().x - prevpolygon.rightline.direction().x;
                                            var leftlinecontinues = Math.abs(d1) < EPS;
                                            var rightlinecontinues = Math.abs(d2) < EPS;
                                            var leftlineisconvex = leftlinecontinues || (d1 >= 0);
                                            var rightlineisconvex = rightlinecontinues || (d2 >= 0);
                                            if (leftlineisconvex && rightlineisconvex) {
                                                // yes, both sides have convex corners:
                                                // This polygon will continue the previous polygon
                                                thispolygon.outpolygon = prevpolygon.outpolygon;
                                                thispolygon.leftlinecontinues = leftlinecontinues;
                                                thispolygon.rightlinecontinues = rightlinecontinues;
                                                prevcontinuedindexes[ii] = true;
                                            }
                                            break;
                                        }
                                    }
                                } // if(!prevcontinuedindexes[ii])
                            } // for ii
                        } // for i
                        for (var ii = 0; ii < prevoutpolygonrow.length; ii++) {
                            if (!prevcontinuedindexes[ii]) {
                                // polygon ends here
                                // Finish the polygon with the last point(s):
                                var prevpolygon = prevoutpolygonrow[ii];
                                prevpolygon.outpolygon.rightpoints.push(prevpolygon.bottomright);
                                if (prevpolygon.bottomright.distanceTo(prevpolygon.bottomleft) > EPS) {
                                    // polygon ends with a horizontal line:
                                    prevpolygon.outpolygon.leftpoints.push(prevpolygon.bottomleft);
                                }
                                // reverse the left half so we get a counterclockwise circle:
                                prevpolygon.outpolygon.leftpoints.reverse();
                                var points2d = prevpolygon.outpolygon.rightpoints.concat(prevpolygon.outpolygon.leftpoints);
                                var vertices3d = [];
                                points2d.map(function(point2d) {
                                    var point3d = orthobasis.to3D(point2d);
                                    var vertex3d = new CSG.Vertex(point3d);
                                    vertices3d.push(vertex3d);
                                });
                                var polygon = new CSG.Polygon(vertices3d, shared, plane);
                                destpolygons.push(polygon);
                            }
                        }
                    } // if(yindex > 0)
                    for (var i = 0; i < newoutpolygonrow.length; i++) {
                        var thispolygon = newoutpolygonrow[i];
                        if (!thispolygon.outpolygon) {
                            // polygon starts here:
                            thispolygon.outpolygon = {
                                leftpoints: [],
                                rightpoints: []
                            };
                            thispolygon.outpolygon.leftpoints.push(thispolygon.topleft);
                            if (thispolygon.topleft.distanceTo(thispolygon.topright) > EPS) {
                                // we have a horizontal line at the top:
                                thispolygon.outpolygon.rightpoints.push(thispolygon.topright);
                            }
                        } else {
                            // continuation of a previous row
                            if (!thispolygon.leftlinecontinues) {
                                thispolygon.outpolygon.leftpoints.push(thispolygon.topleft);
                            }
                            if (!thispolygon.rightlinecontinues) {
                                thispolygon.outpolygon.rightpoints.push(thispolygon.topright);
                            }
                        }
                    }
                    prevoutpolygonrow = newoutpolygonrow;
                }
            } // for yindex
        } // if(numpolygons > 0)
    };

    ////////////////////////////////
    // ## class fuzzyFactory
    // This class acts as a factory for objects. We can search for an object with approximately
    // the desired properties (say a rectangle with width 2 and height 1)
    // The lookupOrCreate() method looks for an existing object (for example it may find an existing rectangle
    // with width 2.0001 and height 0.999. If no object is found, the user supplied callback is
    // called, which should generate a new object. The new object is inserted into the database
    // so it can be found by future lookupOrCreate() calls.
    // Constructor:
    //   numdimensions: the number of parameters for each object
    //     for example for a 2D rectangle this would be 2
    //   tolerance: The maximum difference for each parameter allowed to be considered a match
    CSG.fuzzyFactory = function(numdimensions, tolerance) {
        this.lookuptable = {};
        this.multiplier = 1.0 / tolerance;
    };

    CSG.fuzzyFactory.prototype = {
        // var obj = f.lookupOrCreate([el1, el2, el3], function(elements) {/* create the new object */});
        // Performs a fuzzy lookup of the object with the specified elements.
        // If found, returns the existing object
        // If not found, calls the supplied callback function which should create a new object with
        // the specified properties. This object is inserted in the lookup database.
        lookupOrCreate: function(els, creatorCallback) {
            var hash = "";
            var multiplier = this.multiplier;
            els.forEach(function(el) {
                var valueQuantized = Math.round(el * multiplier);
                hash += valueQuantized + "/";
            });
            if (hash in this.lookuptable) {
                return this.lookuptable[hash];
            } else {
                var object = creatorCallback(els);
                var hashparts = els.map(function(el) {
                    var q0 = Math.floor(el * multiplier);
                    var q1 = q0 + 1;
                    return ["" + q0 + "/", "" + q1 + "/"];
                });
                var numelements = els.length;
                var numhashes = 1 << numelements;
                for (var hashmask = 0; hashmask < numhashes; ++hashmask) {
                    var hashmask_shifted = hashmask;
                    hash = "";
                    hashparts.forEach(function(hashpart) {
                        hash += hashpart[hashmask_shifted & 1];
                        hashmask_shifted >>= 1;
                    });
                    this.lookuptable[hash] = object;
                }
                return object;
            }
        },
    };


    //////////////////////////////////////
    CSG.fuzzyCSGFactory = function() {
        this.vertexfactory = new CSG.fuzzyFactory(3, 1e-5);
        this.planefactory = new CSG.fuzzyFactory(4, 1e-5);
        this.polygonsharedfactory = {};
    };

    CSG.fuzzyCSGFactory.prototype = {
        getPolygonShared: function(sourceshared) {
            var hash = sourceshared.getHash();
            if (hash in this.polygonsharedfactory) {
                return this.polygonsharedfactory[hash];
            } else {
                this.polygonsharedfactory[hash] = sourceshared;
                return sourceshared;
            }
        },

        getVertex: function(sourcevertex) {
            var elements = [sourcevertex.pos._x, sourcevertex.pos._y, sourcevertex.pos._z];
            var result = this.vertexfactory.lookupOrCreate(elements, function(els) {
                return sourcevertex;
            });
            return result;
        },

        getPlane: function(sourceplane) {
            var elements = [sourceplane.normal._x, sourceplane.normal._y, sourceplane.normal._z, sourceplane.w];
            var result = this.planefactory.lookupOrCreate(elements, function(els) {
                return sourceplane;
            });
            return result;
        },

        getPolygon: function(sourcepolygon) {
            var newplane = this.getPlane(sourcepolygon.plane);
            var newshared = this.getPolygonShared(sourcepolygon.shared);
            var _this = this;
            var newvertices = sourcepolygon.vertices.map(function(vertex) {
                return _this.getVertex(vertex);
            });
            // two vertices that were originally very close may now have become
            // truly identical (referring to the same CSG.Vertex object).
            // Remove duplicate vertices:
            var newvertices_dedup = [];
            if(newvertices.length > 0) {
                var prevvertextag = newvertices[newvertices.length-1].getTag();
                newvertices.forEach(function(vertex) {
                    var vertextag = vertex.getTag();
                    if(vertextag != prevvertextag)
                    {
                        newvertices_dedup.push(vertex);
                    }
                    prevvertextag = vertextag;
                });
            }
            // If it's degenerate, remove all vertices:
            if(newvertices_dedup.length < 3) {
                newvertices_dedup = [];
            }
            return new CSG.Polygon(newvertices_dedup, newshared, newplane);
        },

        getCSG: function(sourcecsg) {
            var _this = this;
            var newpolygons = [];
            sourcecsg.polygons.forEach(function(polygon) {
                var newpolygon = _this.getPolygon(polygon);
                // see getPolygon above: we may get a polygon with no vertices, discard it:
                if(newpolygon.vertices.length >= 3)
                {
                    newpolygons.push(newpolygon);
                }
            });
            return CSG.fromPolygons(newpolygons);
        }
    };

    //////////////////////////////////////
    // Tag factory: we can request a unique tag through CSG.getTag()
    CSG.staticTag = 1;

    CSG.getTag = function() {
        return CSG.staticTag++;
    };

    //////////////////////////////////////
    // # Class Properties
    // This class is used to store properties of a solid
    // A property can for example be a CSG.Vertex, a CSG.Plane or a CSG.Line3D
    // Whenever an affine transform is applied to the CSG solid, all its properties are
    // transformed as well.
    // The properties can be stored in a complex nested structure (using arrays and objects)
    CSG.Properties = function() {};

    CSG.Properties.prototype = {
        _transform: function(matrix4x4) {
            var result = new CSG.Properties();
            CSG.Properties.transformObj(this, result, matrix4x4);
            return result;
        },
        _merge: function(otherproperties) {
            var result = new CSG.Properties();
            CSG.Properties.cloneObj(this, result);
            CSG.Properties.addFrom(result, otherproperties);
            return result;
        }
    };

    CSG.Properties.transformObj = function(source, result, matrix4x4) {
        for (var propertyname in source) {
            if (propertyname == "_transform") continue;
            if (propertyname == "_merge") continue;
            var propertyvalue = source[propertyname];
            var transformed = propertyvalue;
            if (typeof(propertyvalue) == "object") {
                if (('transform' in propertyvalue) && (typeof(propertyvalue.transform) == "function")) {
                    transformed = propertyvalue.transform(matrix4x4);
                } else if (propertyvalue instanceof Array) {
                    transformed = [];
                    CSG.Properties.transformObj(propertyvalue, transformed, matrix4x4);
                } else if (propertyvalue instanceof CSG.Properties) {
                    transformed = new CSG.Properties();
                    CSG.Properties.transformObj(propertyvalue, transformed, matrix4x4);
                }
            }
            result[propertyname] = transformed;
        }
    };

    CSG.Properties.cloneObj = function(source, result) {
        for (var propertyname in source) {
            if (propertyname == "_transform") continue;
            if (propertyname == "_merge") continue;
            var propertyvalue = source[propertyname];
            var cloned = propertyvalue;
            if (typeof(propertyvalue) == "object") {
                if (propertyvalue instanceof Array) {
                    cloned = [];
                    for (var i = 0; i < propertyvalue.length; i++) {
                        cloned.push(propertyvalue[i]);
                    }
                } else if (propertyvalue instanceof CSG.Properties) {
                    cloned = new CSG.Properties();
                    CSG.Properties.cloneObj(propertyvalue, cloned);
                }
            }
            result[propertyname] = cloned;
        }
    };

    CSG.Properties.addFrom = function(result, otherproperties) {
        for (var propertyname in otherproperties) {
            if (propertyname == "_transform") continue;
            if (propertyname == "_merge") continue;
            if ((propertyname in result) &&
                (typeof(result[propertyname]) == "object") &&
                (result[propertyname] instanceof CSG.Properties) &&
                (typeof(otherproperties[propertyname]) == "object") &&
                (otherproperties[propertyname] instanceof CSG.Properties)) {
                CSG.Properties.addFrom(result[propertyname], otherproperties[propertyname]);
            } else if (!(propertyname in result)) {
                result[propertyname] = otherproperties[propertyname];
            }
        }
    };

    //////////////////////////////////////
    // # class Connector
    // A connector allows to attach two objects at predefined positions
    // For example a servo motor and a servo horn:
    // Both can have a Connector called 'shaft'
    // The horn can be moved and rotated such that the two connectors match
    // and the horn is attached to the servo motor at the proper position.
    // Connectors are stored in the properties of a CSG solid so they are
    // ge the same transformations applied as the solid
    CSG.Connector = function(point, axisvector, normalvector) {
        this.point = new CSG.Vector3D(point);
        this.axisvector = new CSG.Vector3D(axisvector).unit();
        this.normalvector = new CSG.Vector3D(normalvector).unit();
    };

    CSG.Connector.prototype = {
        normalized: function() {
            var axisvector = this.axisvector.unit();
            // make the normal vector truly normal:
            var n = this.normalvector.cross(axisvector).unit();
            var normalvector = axisvector.cross(n);
            return new CSG.Connector(this.point, axisvector, normalvector);
        },

        transform: function(matrix4x4) {
            var point = this.point.multiply4x4(matrix4x4);
            var axisvector = this.point.plus(this.axisvector).multiply4x4(matrix4x4).minus(point);
            var normalvector = this.point.plus(this.normalvector).multiply4x4(matrix4x4).minus(point);
            return new CSG.Connector(point, axisvector, normalvector);
        },

        // Get the transformation matrix to connect this Connector to another connector
        //   other: a CSG.Connector to which this connector should be connected
        //   mirror: false: the 'axis' vectors of the connectors should point in the same direction
        //           true: the 'axis' vectors of the connectors should point in opposite direction
        //   normalrotation: degrees of rotation between the 'normal' vectors of the two
        //                   connectors
        getTransformationTo: function(other, mirror, normalrotation) {
            mirror = mirror ? true : false;
            normalrotation = normalrotation ? Number(normalrotation) : 0;
            var us = this.normalized();
            other = other.normalized();
            // shift to the origin:
            var transformation = CSG.Matrix4x4.translation(this.point.negated());
            // construct the plane crossing through the origin and the two axes:
            var axesplane = CSG.Plane.anyPlaneFromVector3Ds(
                new CSG.Vector3D(0, 0, 0), us.axisvector, other.axisvector);
            var axesbasis = new CSG.OrthoNormalBasis(axesplane);
            var angle1 = axesbasis.to2D(us.axisvector).angle();
            var angle2 = axesbasis.to2D(other.axisvector).angle();
            var rotation = 180.0 * (angle2 - angle1) / Math.PI;
            if (mirror) rotation += 180.0;
            transformation = transformation.multiply(axesbasis.getProjectionMatrix());
            transformation = transformation.multiply(CSG.Matrix4x4.rotationZ(rotation));
            transformation = transformation.multiply(axesbasis.getInverseProjectionMatrix());
            var usAxesAligned = us.transform(transformation);
            // Now we have done the transformation for aligning the axes.
            // We still need to align the normals:
            var normalsplane = CSG.Plane.fromNormalAndPoint(other.axisvector, new CSG.Vector3D(0, 0, 0));
            var normalsbasis = new CSG.OrthoNormalBasis(normalsplane);
            angle1 = normalsbasis.to2D(usAxesAligned.normalvector).angle();
            angle2 = normalsbasis.to2D(other.normalvector).angle();
            rotation = 180.0 * (angle2 - angle1) / Math.PI;
            rotation += normalrotation;
            transformation = transformation.multiply(normalsbasis.getProjectionMatrix());
            transformation = transformation.multiply(CSG.Matrix4x4.rotationZ(rotation));
            transformation = transformation.multiply(normalsbasis.getInverseProjectionMatrix());
            // and translate to the destination point:
            transformation = transformation.multiply(CSG.Matrix4x4.translation(other.point));
            // var usAligned = us.transform(transformation);
            return transformation;
        },

        axisLine: function() {
            return new CSG.Line3D(this.point, this.axisvector);
        },

        // creates a new Connector, with the connection point moved in the direction of the axisvector
        extend: function(distance) {
            var newpoint = this.point.plus(this.axisvector.unit().times(distance));
            return new CSG.Connector(newpoint, this.axisvector, this.normalvector);
        }
    };

    CSG.ConnectorList = function(connectors) {
        this.connectors_ = connectors ? connectors.slice() : [];
    };

    CSG.ConnectorList.defaultNormal = [0, 0, 1];

    CSG.ConnectorList.fromPath2D = function(path2D, arg1, arg2) {
        if (arguments.length === 3) {
            return CSG.ConnectorList._fromPath2DTangents(path2D, arg1, arg2);
        } else if (arguments.length == 2) {
            return CSG.ConnectorList._fromPath2DExplicit(path2D, arg1);
        } else {
            throw("call with path2D and either 2 direction vectors, or a function returning direction vectors");
        }
    };

    /*
     * calculate the connector axisvectors by calculating the "tangent" for path2D.
     * This is undefined for start and end points, so axis for these have to be manually
     * provided.
     */
    CSG.ConnectorList._fromPath2DTangents = function(path2D, start, end) {
        // path2D
        var axis;
        var pathLen = path2D.points.length;
        var result = new CSG.ConnectorList([new CSG.Connector(path2D.points[0],
            start, CSG.ConnectorList.defaultNormal)]);
        // middle points
        path2D.points.slice(1, pathLen - 1).forEach(function(p2, i) {
            axis = path2D.points[i + 2].minus(path2D.points[i]).toVector3D(0);
            result.appendConnector(new CSG.Connector(p2.toVector3D(0), axis,
              CSG.ConnectorList.defaultNormal));
        }, this);
        result.appendConnector(new CSG.Connector(path2D.points[pathLen - 1], end,
          CSG.ConnectorList.defaultNormal));
        result.closed = path2D.closed;
        return result;
    };

    /*
     * angleIsh: either a static angle, or a function(point) returning an angle
     */
    CSG.ConnectorList._fromPath2DExplicit = function(path2D, angleIsh) {
        function getAngle(angleIsh, pt, i) {
            if (typeof angleIsh == 'function') {
                angleIsh = angleIsh(pt, i);
            }
            return angleIsh;
        }
        var result = new CSG.ConnectorList(
            path2D.points.map(function(p2, i) {
                return new CSG.Connector(p2.toVector3D(0),
                    CSG.Vector3D.Create(1, 0, 0).rotateZ(getAngle(angleIsh, p2, i)),
                      CSG.ConnectorList.defaultNormal);
            }, this)
        );
        result.closed = path2D.closed;
        return result;
    };


    CSG.ConnectorList.prototype = {
        setClosed: function(bool) {
            this.closed = !!closed;
        },
        appendConnector: function(conn) {
            this.connectors_.push(conn);
        },
        /*
         * arguments: cagish: a cag or a function(connector) returning a cag
         *            closed: whether the 3d path defined by connectors location
         *              should be closed or stay open
         *              Note: don't duplicate connectors in the path
         * TODO: consider an option "maySelfIntersect" to close & force union all single segments
         */
        followWith: function(cagish) {
            this.verify();
            function getCag(cagish, connector) {
                if (typeof cagish == "function") {
                    cagish = cagish(connector.point, connector.axisvector, connector.normalvector);
                }
                return cagish;
            }

            var polygons = [], currCag;
            var prevConnector = this.connectors_[this.connectors_.length - 1];
            var prevCag = getCag(cagish, prevConnector);
            // add walls
            this.connectors_.forEach(function(connector, notFirst) {
                currCag = getCag(cagish, connector);
                if (notFirst || this.closed) {
                    polygons.push.apply(polygons, prevCag._toWallPolygons({
                        toConnector1: prevConnector, toConnector2: connector, cag: currCag}));
                } else {
                    // it is the first, and shape not closed -> build start wall
                    polygons.push.apply(polygons,
                        currCag._toPlanePolygons({toConnector: connector, flipped: true}));
                }
                if (notFirst == this.connectors_.length - 1 && !this.closed) {
                    // build end wall
                    polygons.push.apply(polygons,
                        currCag._toPlanePolygons({toConnector: connector}));
                }
                prevCag = currCag;
                prevConnector = connector;
            }, this);
            return CSG.fromPolygons(polygons).reTesselated().canonicalized();
        },
        /*
         * general idea behind these checks: connectors need to have smooth transition from one to another
         * TODO: add a check that 2 follow-on CAGs are not intersecting
         */
        verify: function() {
            var connI, connI1, dPosToAxis, axisToNextAxis;
            for (var i = 0; i < this.connectors_.length - 1; i++) {
                connI = this.connectors_[i], connI1 = this.connectors_[i + 1];
                if (connI1.point.minus(connI.point).dot(connI.axisvector) <= 0) {
                    throw("Invalid ConnectorList. Each connectors position needs to be within a <90deg range of previous connectors axisvector");
                }
                if (connI.axisvector.dot(connI1.axisvector) <= 0) {
                    throw("invalid ConnectorList. No neighboring connectors axisvectors may span a >=90deg angle");
                }
            }
        }
    };

    //////////////////////////////////////
    // # Class Path2D
    CSG.Path2D = function(points, closed) {
        closed = !!closed;
        points = points || [];
        // re-parse the points into CSG.Vector2D
        // and remove any duplicate points
        var prevpoint = null;
        if (closed && (points.length > 0)) {
            prevpoint = new CSG.Vector2D(points[points.length - 1]);
        }
        var newpoints = [];
        points.map(function(point) {
            point = new CSG.Vector2D(point);
            var skip = false;
            if (prevpoint !== null) {
                var distance = point.distanceTo(prevpoint);
                skip = distance < 1e-5;
            }
            if (!skip) newpoints.push(point);
            prevpoint = point;
        });
        this.points = newpoints;
        this.closed = closed;
    };

    /*
    Construct a (part of a) circle. Parameters:
      options.center: the center point of the arc (CSG.Vector2D or array [x,y])
      options.radius: the circle radius (float)
      options.startangle: the starting angle of the arc, in degrees
        0 degrees corresponds to [1,0]
        90 degrees to [0,1]
        and so on
      options.endangle: the ending angle of the arc, in degrees
      options.resolution: number of points per 360 degree of rotation
      options.maketangent: adds two extra tiny line segments at both ends of the circle
        this ensures that the gradients at the edges are tangent to the circle
    Returns a CSG.Path2D. The path is not closed (even if it is a 360 degree arc).
    close() the resulting path if you want to create a true circle.
    */
    CSG.Path2D.arc = function(options) {
        var center = CSG.parseOptionAs2DVector(options, "center", 0);
        var radius = CSG.parseOptionAsFloat(options, "radius", 1);
        var startangle = CSG.parseOptionAsFloat(options, "startangle", 0);
        var endangle = CSG.parseOptionAsFloat(options, "endangle", 360);
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
        var maketangent = CSG.parseOptionAsBool(options, "maketangent", false);
        // no need to make multiple turns:
        while (endangle - startangle >= 720) {
            endangle -= 360;
        }
        while (endangle - startangle <= -720) {
            endangle += 360;
        }
        var points = [],
            point;
        var absangledif = Math.abs(endangle - startangle);
        if (absangledif < 1e-5) {
            point = CSG.Vector2D.fromAngle(startangle / 180.0 * Math.PI).times(radius);
            points.push(point.plus(center));
        } else {
            var numsteps = Math.floor(resolution * absangledif / 360) + 1;
            var edgestepsize = numsteps * 0.5 / absangledif; // step size for half a degree
            if (edgestepsize > 0.25) edgestepsize = 0.25;
            var numsteps_mod = maketangent ? (numsteps + 2) : numsteps;
            for (var i = 0; i <= numsteps_mod; i++) {
                var step = i;
                if (maketangent) {
                    step = (i - 1) * (numsteps - 2 * edgestepsize) / numsteps + edgestepsize;
                    if (step < 0) step = 0;
                    if (step > numsteps) step = numsteps;
                }
                var angle = startangle + step * (endangle - startangle) / numsteps;
                point = CSG.Vector2D.fromAngle(angle / 180.0 * Math.PI).times(radius);
                points.push(point.plus(center));
            }
        }
        return new CSG.Path2D(points, false);
    };

    CSG.Path2D.prototype = {
        concat: function(otherpath) {
            if (this.closed || otherpath.closed) {
                throw new Error("Paths must not be closed");
            }
            var newpoints = this.points.concat(otherpath.points);
            return new CSG.Path2D(newpoints);
        },

        appendPoint: function(point) {
            if (this.closed) {
                throw new Error("Path must not be closed");
            }
            point = new CSG.Vector2D(point); // cast to Vector2D
            var newpoints = this.points.concat([point]);
            return new CSG.Path2D(newpoints);
        },

        appendPoints: function(points) {
            if (this.closed) {
                throw new Error("Path must not be closed");
            }
            var newpoints = this.points;
            points.forEach(function(point) {
                newpoints.push(new CSG.Vector2D(point)); // cast to Vector2D
            })
            return new CSG.Path2D(newpoints);
        },

        close: function() {
            return new CSG.Path2D(this.points, true);
        },

        // Extrude the path by following it with a rectangle (upright, perpendicular to the path direction)
        // Returns a CSG solid
        //   width: width of the extrusion, in the z=0 plane
        //   height: height of the extrusion in the z direction
        //   resolution: number of segments per 360 degrees for the curve in a corner
        rectangularExtrude: function(width, height, resolution) {
            var cag = this.expandToCAG(width / 2, resolution);
            var result = cag.extrude({
                offset: [0, 0, height]
            });
            return result;
        },

        // Expand the path to a CAG
        // This traces the path with a circle with radius pathradius
        expandToCAG: function(pathradius, resolution) {
            var sides = [];
            var numpoints = this.points.length;
            var startindex = 0;
            if (this.closed && (numpoints > 2)) startindex = -1;
            var prevvertex;
            for (var i = startindex; i < numpoints; i++) {
                var pointindex = i;
                if (pointindex < 0) pointindex = numpoints - 1;
                var point = this.points[pointindex];
                var vertex = new CAG.Vertex(point);
                if (i > startindex) {
                    var side = new CAG.Side(prevvertex, vertex);
                    sides.push(side);
                }
                prevvertex = vertex;
            }
            var shellcag = CAG.fromSides(sides);
            var expanded = shellcag.expandedShell(pathradius, resolution);
            return expanded;
        },

        innerToCAG: function() {
            if (!this.closed) throw new Error("The path should be closed!");
            return CAG.fromPoints(this.points);
        },

        transform: function(matrix4x4) {
            var newpoints = this.points.map(function(point) {
                return point.multiply4x4(matrix4x4);
            });
            return new CSG.Path2D(newpoints, this.closed);
        },

        appendBezier: function(controlpoints, options) {
            if (arguments.length < 2) {
                options = {};
            }
            if (this.closed) {
                throw new Error("Path must not be closed");
            }
            if (!(controlpoints instanceof Array)) {
                throw new Error("appendBezier: should pass an array of control points")
            }
            if (controlpoints.length < 1) {
                throw new Error("appendBezier: need at least 1 control point")
            }
            if (this.points.length < 1) {
                throw new Error("appendBezier: path must already contain a point (the endpoint of the path is used as the starting point for the bezier curve)");
            }
            var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
            if (resolution < 4) resolution = 4;
            var factorials = [];
            var controlpoints_parsed = [];
            controlpoints_parsed.push(this.points[this.points.length - 1]); // start at the previous end point
            for (var i = 0; i < controlpoints.length; ++i) {
                var p = controlpoints[i];
                if (p === null) {
                    // we can pass null as the first control point. In that case a smooth gradient is ensured:
                    if (i != 0) {
                        throw new Error("appendBezier: null can only be passed as the first control point");
                    }
                    if (controlpoints.length < 2) {
                        throw new Error("appendBezier: null can only be passed if there is at least one more control point");
                    }
                    var lastBezierControlPoint;
                    if ('lastBezierControlPoint' in this) {
                        lastBezierControlPoint = this.lastBezierControlPoint;
                    } else {
                        if (this.points.length < 2) {
                            throw new Error("appendBezier: null is passed as a control point but this requires a previous bezier curve or at least two points in the existing path");
                        }
                        lastBezierControlPoint = this.points[this.points.length - 2];
                    }
                    // mirror the last bezier control point:
                    p = this.points[this.points.length - 1].times(2).minus(lastBezierControlPoint);
                } else {
                    p = new CSG.Vector2D(p); // cast to Vector2D
                }
                controlpoints_parsed.push(p);
            }
            var bezier_order = controlpoints_parsed.length - 1;
            var fact = 1;
            for (var i = 0; i <= bezier_order; ++i) {
                if (i > 0) fact *= i;
                factorials.push(fact);
            }
            var binomials = [];
            for (var i = 0; i <= bezier_order; ++i) {
                var binomial = factorials[bezier_order] / (factorials[i] * factorials[bezier_order - i]);
                binomials.push(binomial);
            }
            var getPointForT = function(t) {
                var t_k = 1; // = pow(t,k)
                var one_minus_t_n_minus_k = Math.pow(1 - t, bezier_order); // = pow( 1-t, bezier_order - k)
                var inv_1_minus_t = (t != 1) ? (1 / (1 - t)) : 1;
                var point = new CSG.Vector2D(0, 0);
                for (var k = 0; k <= bezier_order; ++k) {
                    if (k == bezier_order) one_minus_t_n_minus_k = 1;
                    var bernstein_coefficient = binomials[k] * t_k * one_minus_t_n_minus_k;
                    point = point.plus(controlpoints_parsed[k].times(bernstein_coefficient));
                    t_k *= t;
                    one_minus_t_n_minus_k *= inv_1_minus_t;
                }
                return point;
            };
            var newpoints = [];
            var newpoints_t = [];
            var numsteps = bezier_order + 1;
            for (var i = 0; i < numsteps; ++i) {
                var t = i / (numsteps - 1);
                var point = getPointForT(t);
                newpoints.push(point);
                newpoints_t.push(t);
            }
            // subdivide each segment until the angle at each vertex becomes small enough:
            var subdivide_base = 1;
            var maxangle = Math.PI * 2 / resolution; // segments may have differ no more in angle than this
            var maxsinangle = Math.sin(maxangle);
            while (subdivide_base < newpoints.length - 1) {
                var dir1 = newpoints[subdivide_base].minus(newpoints[subdivide_base - 1]).unit();
                var dir2 = newpoints[subdivide_base + 1].minus(newpoints[subdivide_base]).unit();
                var sinangle = dir1.cross(dir2); // this is the sine of the angle
                if (Math.abs(sinangle) > maxsinangle) {
                    // angle is too big, we need to subdivide
                    var t0 = newpoints_t[subdivide_base - 1];
                    var t1 = newpoints_t[subdivide_base + 1];
                    var t0_new = t0 + (t1 - t0) * 1 / 3;
                    var t1_new = t0 + (t1 - t0) * 2 / 3;
                    var point0_new = getPointForT(t0_new);
                    var point1_new = getPointForT(t1_new);
                    // remove the point at subdivide_base and replace with 2 new points:
                    newpoints.splice(subdivide_base, 1, point0_new, point1_new);
                    newpoints_t.splice(subdivide_base, 1, t0_new, t1_new);
                    // re - evaluate the angles, starting at the previous junction since it has changed:
                    subdivide_base--;
                    if (subdivide_base < 1) subdivide_base = 1;
                } else {
                    ++subdivide_base;
                }
            }
            // append to the previous points, but skip the first new point because it is identical to the last point:
            newpoints = this.points.concat(newpoints.slice(1));
            var result = new CSG.Path2D(newpoints);
            result.lastBezierControlPoint = controlpoints_parsed[controlpoints_parsed.length - 2];
            return result;
        },

        /*
         options:
         .resolution // smoothness of the arc (number of segments per 360 degree of rotation)
         // to create a circular arc:
         .radius
         // to create an elliptical arc:
         .xradius
         .yradius
         .xaxisrotation  // the rotation (in degrees) of the x axis of the ellipse with respect to the x axis of our coordinate system
         // this still leaves 4 possible arcs between the two given points. The following two flags select which one we draw:
         .clockwise // = true | false (default is false). Two of the 4 solutions draw clockwise with respect to the center point, the other 2 counterclockwise
         .large     // = true | false (default is false). Two of the 4 solutions are an arc longer than 180 degrees, the other two are <= 180 degrees
         This implementation follows the SVG arc specs. For the details see
         http://www.w3.org/TR/SVG/paths.html#PathDataEllipticalArcCommands
         */
        appendArc: function(endpoint, options) {
            if (arguments.length < 2) {
                options = {};
            }
            if (this.closed) {
                throw new Error("Path must not be closed");
            }
            if (this.points.length < 1) {
                throw new Error("appendArc: path must already contain a point (the endpoint of the path is used as the starting point for the arc)");
            }
            var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
            if (resolution < 4) resolution = 4;
            var xradius, yradius;
            if (('xradius' in options) || ('yradius' in options)) {
                if ('radius' in options) {
                    throw new Error("Should either give an xradius and yradius parameter, or a radius parameter");
                }
                xradius = CSG.parseOptionAsFloat(options, "xradius", 0);
                yradius = CSG.parseOptionAsFloat(options, "yradius", 0);
            } else {
                xradius = CSG.parseOptionAsFloat(options, "radius", 0);
                yradius = xradius;
            }
            var xaxisrotation = CSG.parseOptionAsFloat(options, "xaxisrotation", 0);
            var clockwise = CSG.parseOptionAsBool(options, "clockwise", false);
            var largearc = CSG.parseOptionAsBool(options, "large", false);
            var startpoint = this.points[this.points.length - 1];
            endpoint = new CSG.Vector2D(endpoint);

            var sweep_flag = !clockwise;
            var newpoints = [];
            if ((xradius == 0) || (yradius == 0)) {
                // http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes:
                // If rx = 0 or ry = 0, then treat this as a straight line from (x1, y1) to (x2, y2) and stop
                newpoints.push(endpoint);
            } else {
                xradius = Math.abs(xradius);
                yradius = Math.abs(yradius);

                // see http://www.w3.org/TR/SVG/implnote.html#ArcImplementationNotes :
                var phi = xaxisrotation * Math.PI / 180.0;
                var cosphi = Math.cos(phi);
                var sinphi = Math.sin(phi);
                var minushalfdistance = startpoint.minus(endpoint).times(0.5);
                // F.6.5.1:
                var start_translated = new CSG.Vector2D(cosphi * minushalfdistance.x + sinphi * minushalfdistance.y, -sinphi * minushalfdistance.x + cosphi * minushalfdistance.y);
                // F.6.6.2:
                var biglambda = start_translated.x * start_translated.x / (xradius * xradius) + start_translated.y * start_translated.y / (yradius * yradius);
                if (biglambda > 1) {
                    // F.6.6.3:
                    var sqrtbiglambda = Math.sqrt(biglambda);
                    xradius *= sqrtbiglambda;
                    yradius *= sqrtbiglambda;
                }
                // F.6.5.2:
                var multiplier1 = Math.sqrt((xradius * xradius * yradius * yradius - xradius * xradius * start_translated.y * start_translated.y - yradius * yradius * start_translated.x * start_translated.x) / (xradius * xradius * start_translated.y * start_translated.y + yradius * yradius * start_translated.x * start_translated.x));
                if (sweep_flag == largearc) multiplier1 = -multiplier1;
                var center_translated = new CSG.Vector2D(xradius * start_translated.y / yradius, -yradius * start_translated.x / xradius).times(multiplier1);
                // F.6.5.3:
                var center = new CSG.Vector2D(cosphi * center_translated.x - sinphi * center_translated.y, sinphi * center_translated.x + cosphi * center_translated.y).plus((startpoint.plus(endpoint)).times(0.5));
                // F.6.5.5:
                var vec1 = new CSG.Vector2D((start_translated.x - center_translated.x) / xradius, (start_translated.y - center_translated.y) / yradius);
                var vec2 = new CSG.Vector2D((-start_translated.x - center_translated.x) / xradius, (-start_translated.y - center_translated.y) / yradius);
                var theta1 = vec1.angleRadians();
                var theta2 = vec2.angleRadians();
                var deltatheta = theta2 - theta1;
                deltatheta = deltatheta % (2 * Math.PI);
                if ((!sweep_flag) && (deltatheta > 0)) {
                    deltatheta -= 2 * Math.PI;
                } else if ((sweep_flag) && (deltatheta < 0)) {
                    deltatheta += 2 * Math.PI;
                }

                // Ok, we have the center point and angle range (from theta1, deltatheta radians) so we can create the ellipse
                var numsteps = Math.ceil(Math.abs(deltatheta) / (2 * Math.PI) * resolution) + 1;
                if (numsteps < 1) numsteps = 1;
                for (var step = 1; step <= numsteps; step++) {
                    var theta = theta1 + step / numsteps * deltatheta;
                    var costheta = Math.cos(theta);
                    var sintheta = Math.sin(theta);
                    // F.6.3.1:
                    var point = new CSG.Vector2D(cosphi * xradius * costheta - sinphi * yradius * sintheta, sinphi * xradius * costheta + cosphi * yradius * sintheta).plus(center);
                    newpoints.push(point);
                }
            }
            newpoints = this.points.concat(newpoints);
            var result = new CSG.Path2D(newpoints);
            return result;
        },
    };

    // Add several convenience methods to the classes that support a transform() method:
    CSG.addTransformationMethodsToPrototype = function(prot) {
        prot.mirrored = function(plane) {
            return this.transform(CSG.Matrix4x4.mirroring(plane));
        };

        prot.mirroredX = function() {
            var plane = new CSG.Plane(CSG.Vector3D.Create(1, 0, 0), 0);
            return this.mirrored(plane);
        };

        prot.mirroredY = function() {
            var plane = new CSG.Plane(CSG.Vector3D.Create(0, 1, 0), 0);
            return this.mirrored(plane);
        };

        prot.mirroredZ = function() {
            var plane = new CSG.Plane(CSG.Vector3D.Create(0, 0, 1), 0);
            return this.mirrored(plane);
        };

        prot.translate = function(v) {
            return this.transform(CSG.Matrix4x4.translation(v));
        };

        prot.scale = function(f) {
            return this.transform(CSG.Matrix4x4.scaling(f));
        };

        prot.rotateX = function(deg) {
            return this.transform(CSG.Matrix4x4.rotationX(deg));
        };

        prot.rotateY = function(deg) {
            return this.transform(CSG.Matrix4x4.rotationY(deg));
        };

        prot.rotateZ = function(deg) {
            return this.transform(CSG.Matrix4x4.rotationZ(deg));
        };

        prot.rotate = function(rotationCenter, rotationAxis, degrees) {
            return this.transform(CSG.Matrix4x4.rotation(rotationCenter, rotationAxis, degrees));
        };

        prot.rotateEulerAngles = function(alpha, beta, gamma, position) {
            position = position || [0,0,0];

            var Rz1 = CSG.Matrix4x4.rotationZ(alpha);
            var Rx  = CSG.Matrix4x4.rotationX(beta);
            var Rz2 = CSG.Matrix4x4.rotationZ(gamma);
            var T   = CSG.Matrix4x4.translation(new CSG.Vector3D(position));

            return this.transform(Rz2.multiply(Rx).multiply(Rz1).multiply(T));
        };
    };

    // TODO: consider generalization and adding to addTransformationMethodsToPrototype
    CSG.addCenteringToPrototype = function(prot, axes) {
        prot.center = function(cAxes) {
            cAxes = Array.prototype.map.call(arguments, function(a) {
                return a.toLowerCase();
            });
            // no args: center on all axes
            if (!cAxes.length) {
                cAxes = axes.slice();
            }
            var b = this.getBounds();
            return this.translate(axes.map(function(a) {
                return cAxes.indexOf(a) > -1 ?
                    -(b[0][a] + b[1][a])/2 : 0;
            }));
        };
    };

    //////////////////
    // CAG: solid area geometry: like CSG but 2D
    // Each area consists of a number of sides
    // Each side is a line between 2 points
    var CAG = function() {
        this.sides = [];
    };

    // Construct a CAG from a list of `CAG.Side` instances.
    CAG.fromSides = function(sides) {
        var cag = new CAG();
        cag.sides = sides;
        return cag;
    };

    // Construct a CAG from a list of points (a polygon)
    // Rotation direction of the points is not relevant. Points can be a convex or concave polygon.
    // Polygon must not self intersect
    CAG.fromPoints = function(points) {
        var numpoints = points.length;
        if (numpoints < 3) throw new Error("CAG shape needs at least 3 points");
        var sides = [];
        var prevpoint = new CSG.Vector2D(points[numpoints - 1]);
        var prevvertex = new CAG.Vertex(prevpoint);
        points.map(function(p) {
            var point = new CSG.Vector2D(p);
            var vertex = new CAG.Vertex(point);
            var side = new CAG.Side(prevvertex, vertex);
            sides.push(side);
            prevvertex = vertex;
        });
        var result = CAG.fromSides(sides);
        if (result.isSelfIntersecting()) {
            throw new Error("Polygon is self intersecting!");
        }
        var area = result.area();
        if (Math.abs(area) < 1e-5) {
            throw new Error("Degenerate polygon!");
        }
        if (area < 0) {
            result = result.flipped();
        }
        result = result.canonicalized();
        return result;
    };

    // Like CAG.fromPoints but does not check if it's a valid polygon.
    // Points should rotate counter clockwise
    CAG.fromPointsNoCheck = function(points) {
        var sides = [];
        var prevpoint = new CSG.Vector2D(points[points.length - 1]);
        var prevvertex = new CAG.Vertex(prevpoint);
        points.map(function(p) {
            var point = new CSG.Vector2D(p);
            var vertex = new CAG.Vertex(point);
            var side = new CAG.Side(prevvertex, vertex);
            sides.push(side);
            prevvertex = vertex;
        });
        return CAG.fromSides(sides);
    };

    // Converts a CSG to a CAG. The CSG must consist of polygons with only z coordinates +1 and -1
    // as constructed by CAG._toCSGWall(-1, 1). This is so we can use the 3D union(), intersect() etc
    CAG.fromFakeCSG = function(csg) {
        var sides = csg.polygons.map(function(p) {
            return CAG.Side._fromFakePolygon(p);
            })
            .filter(function(s) {
                return s !== null;
        });
        return CAG.fromSides(sides);
    };

    // see if the line between p0start and p0end intersects with the line between p1start and p1end
    // returns true if the lines strictly intersect, the end points are not counted!
    CAG.linesIntersect = function(p0start, p0end, p1start, p1end) {
        if (p0end.equals(p1start) || p1end.equals(p0start)) {
            var d = p1end.minus(p1start).unit().plus(p0end.minus(p0start).unit()).length();
            if (d < 1e-5) {
                return true;
            }
        } else {
            var d0 = p0end.minus(p0start);
            var d1 = p1end.minus(p1start);
            if (Math.abs(d0.cross(d1)) < 1e-9) return false; // lines are parallel
            var alphas = CSG.solve2Linear(-d0.x, d1.x, -d0.y, d1.y, p0start.x - p1start.x, p0start.y - p1start.y);
            if ((alphas[0] > 1e-6) && (alphas[0] < 0.999999) && (alphas[1] > 1e-5) && (alphas[1] < 0.999999)) return true;
            //    if( (alphas[0] >= 0) && (alphas[0] <= 1) && (alphas[1] >= 0) && (alphas[1] <= 1) ) return true;
        }
        return false;
    };

    /* Construct a circle
    options:
      center: a 2D center point
      radius: a scalar
      resolution: number of sides per 360 degree rotation
    returns a CAG object
    */
    CAG.circle = function(options) {
        options = options || {};
        var center = CSG.parseOptionAs2DVector(options, "center", [0, 0]);
        var radius = CSG.parseOptionAsFloat(options, "radius", 1);
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
        var sides = [];
        var prevvertex;
        for (var i = 0; i <= resolution; i++) {
            var radians = 2 * Math.PI * i / resolution;
            var point = CSG.Vector2D.fromAngleRadians(radians).times(radius).plus(center);
            var vertex = new CAG.Vertex(point);
            if (i > 0) {
                sides.push(new CAG.Side(prevvertex, vertex));
            }
            prevvertex = vertex;
        }
        return CAG.fromSides(sides);
    };

    /* Construct a rectangle
    options:
      center: a 2D center point
      radius: a 2D vector with width and height
      returns a CAG object
    */
    CAG.rectangle = function(options) {
        options = options || {};
        var c, r;
        if (('corner1' in options) || ('corner2' in options)) {
            if (('center' in options) || ('radius' in options)) {
                throw new Error("rectangle: should either give a radius and center parameter, or a corner1 and corner2 parameter")
            }
            corner1 = CSG.parseOptionAs2DVector(options, "corner1", [0, 0]);
            corner2 = CSG.parseOptionAs2DVector(options, "corner2", [1, 1]);
            c = corner1.plus(corner2).times(0.5);
            r = corner2.minus(corner1).times(0.5);
        } else {
            c = CSG.parseOptionAs2DVector(options, "center", [0, 0]);
            r = CSG.parseOptionAs2DVector(options, "radius", [1, 1]);
        }
        r = r.abs(); // negative radii make no sense
        var rswap = new CSG.Vector2D(r.x, -r.y);
        var points = [
            c.plus(r), c.plus(rswap), c.minus(r), c.minus(rswap)
        ];
        return CAG.fromPoints(points);
    };

    //     var r = CSG.roundedRectangle({
    //       center: [0, 0],
    //       radius: [2, 1],
    //       roundradius: 0.2,
    //       resolution: 8,
    //     });
    CAG.roundedRectangle = function(options) {
        options = options || {};
        var center, radius;
        if (('corner1' in options) || ('corner2' in options)) {
            if (('center' in options) || ('radius' in options)) {
                throw new Error("roundedRectangle: should either give a radius and center parameter, or a corner1 and corner2 parameter")
            }
            corner1 = CSG.parseOptionAs2DVector(options, "corner1", [0, 0]);
            corner2 = CSG.parseOptionAs2DVector(options, "corner2", [1, 1]);
            center = corner1.plus(corner2).times(0.5);
            radius = corner2.minus(corner1).times(0.5);
        } else {
            center = CSG.parseOptionAs2DVector(options, "center", [0, 0]);
            radius = CSG.parseOptionAs2DVector(options, "radius", [1, 1]);
        }
        radius = radius.abs(); // negative radii make no sense
        var roundradius = CSG.parseOptionAsFloat(options, "roundradius", 0.2);
        var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution2D);
        var maxroundradius = Math.min(radius.x, radius.y);
        maxroundradius -= 0.1;
        roundradius = Math.min(roundradius, maxroundradius);
        roundradius = Math.max(0, roundradius);
        radius = new CSG.Vector2D(radius.x - roundradius, radius.y - roundradius);
        var rect = CAG.rectangle({
            center: center,
            radius: radius
        });
        if (roundradius > 0) {
            rect = rect.expand(roundradius, resolution);
        }
        return rect;
    };

    // Reconstruct a CAG from the output of toCompactBinary()
    CAG.fromCompactBinary = function(bin) {
        if (bin['class'] != "CAG") throw new Error("Not a CAG");
        var vertices = [];
        var vertexData = bin.vertexData;
        var numvertices = vertexData.length / 2;
        var arrayindex = 0;
        for (var vertexindex = 0; vertexindex < numvertices; vertexindex++) {
            var x = vertexData[arrayindex++];
            var y = vertexData[arrayindex++];
            var pos = new CSG.Vector2D(x, y);
            var vertex = new CAG.Vertex(pos);
            vertices.push(vertex);
        }

        var sides = [];
        var numsides = bin.sideVertexIndices.length / 2;
        arrayindex = 0;
        for (var sideindex = 0; sideindex < numsides; sideindex++) {
            var vertexindex0 = bin.sideVertexIndices[arrayindex++];
            var vertexindex1 = bin.sideVertexIndices[arrayindex++];
            var side = new CAG.Side(vertices[vertexindex0], vertices[vertexindex1]);
            sides.push(side);
        }
        var cag = CAG.fromSides(sides);
        cag.isCanonicalized = true;
        return cag;
    };

    function fnSortByIndex(a, b) {
        return a.index - b.index;
    }

    CAG.prototype = {
        toString: function() {
            var result = "CAG (" + this.sides.length + " sides):\n";
            this.sides.map(function(side) {
                result += "  " + side.toString() + "\n";
            });
            return result;
        },

        _toCSGWall: function(z0, z1) {
            var polygons = this.sides.map(function(side) {
                return side.toPolygon3D(z0, z1);
            });
            return CSG.fromPolygons(polygons);
        },

        _toVector3DPairs: function(m) {
            // transform m
            var pairs = this.sides.map(function(side) {
                var p0 = side.vertex0.pos, p1 = side.vertex1.pos;
                return [CSG.Vector3D.Create(p0.x, p0.y, 0),
                    CSG.Vector3D.Create(p1.x, p1.y, 0)];
            });
            if (typeof m != 'undefined') {
                pairs = pairs.map(function(pair) {
                    return pair.map(function(v) {
                        return v.transform(m);
                    });
                });
            }
            return pairs;
        },

        /*
         * transform a cag into the polygons of a corresponding 3d plane, positioned per options
         * Accepts a connector for plane positioning, or optionally
         * single translation, axisVector, normalVector arguments
         * (toConnector has precedence over single arguments if provided)
         */
        _toPlanePolygons: function(options) {
            var flipped = options.flipped || false;
            // reference connector for transformation
            var origin = [0, 0, 0], defaultAxis = [0, 0, 1], defaultNormal = [0, 1, 0];
            var thisConnector = new CSG.Connector(origin, defaultAxis, defaultNormal);
            // translated connector per options
            var translation = options.translation || origin;
            var axisVector = options.axisVector || defaultAxis;
            var normalVector = options.normalVector || defaultNormal;
            // will override above if options has toConnector
            var toConnector = options.toConnector ||
                new CSG.Connector(translation, axisVector, normalVector);
            // resulting transform
            var m = thisConnector.getTransformationTo(toConnector, false, 0);
            // create plane as a (partial non-closed) CSG in XY plane
            var bounds = this.getBounds();
            bounds[0] = bounds[0].minus(new CSG.Vector2D(1, 1));
            bounds[1] = bounds[1].plus(new CSG.Vector2D(1, 1));
            var csgshell = this._toCSGWall(-1, 1);
            var csgplane = CSG.fromPolygons([new CSG.Polygon([
                new CSG.Vertex(new CSG.Vector3D(bounds[0].x, bounds[0].y, 0)),
                new CSG.Vertex(new CSG.Vector3D(bounds[1].x, bounds[0].y, 0)),
                new CSG.Vertex(new CSG.Vector3D(bounds[1].x, bounds[1].y, 0)),
                new CSG.Vertex(new CSG.Vector3D(bounds[0].x, bounds[1].y, 0))
            ])]);
            if (flipped) {
                csgplane = csgplane.invert();
            }
            // intersectSub -> prevent premature retesselate/canonicalize
            csgplane = csgplane.intersectSub(csgshell);
            // only keep the polygons in the z plane:
            var polys = csgplane.polygons.filter(function(polygon) {
                return Math.abs(polygon.plane.normal.z) > 0.99;
            });
            // finally, position the plane per passed transformations
            return polys.map(function(poly) {
                return poly.transform(m);
            });
        },


        /*
         * given 2 connectors, this returns all polygons of a "wall" between 2
         * copies of this cag, positioned in 3d space as "bottom" and
         * "top" plane per connectors toConnector1, and toConnector2, respectively 
         */
        _toWallPolygons: function(options) {
            // normals are going to be correct as long as toConn2.point - toConn1.point
            // points into cag normal direction (check in caller)
            // arguments: options.toConnector1, options.toConnector2, options.cag
            //     walls go from toConnector1 to toConnector2
            //     optionally, target cag to point to - cag needs to have same number of sides as this!
            var origin = [0, 0, 0], defaultAxis = [0, 0, 1], defaultNormal = [0, 1, 0];
            var thisConnector = new CSG.Connector(origin, defaultAxis, defaultNormal);
            // arguments:
            var toConnector1 = options.toConnector1;
            // var toConnector2 = new CSG.Connector([0, 0, -30], defaultAxis, defaultNormal);
            var toConnector2 = options.toConnector2;
            if (!(toConnector1 instanceof CSG.Connector && toConnector2 instanceof CSG.Connector)) {
                throw('could not parse CSG.Connector arguments toConnector1 or toConnector2');
            }
            if (options.cag) {
                if (options.cag.sides.length != this.sides.length) {
                    throw('target cag needs same sides count as start cag');
                }
            }
            // target cag is same as this unless specified
            var toCag = options.cag || this;
            var m1 = thisConnector.getTransformationTo(toConnector1, false, 0);
            var m2 = thisConnector.getTransformationTo(toConnector2, false, 0);
            var vps1 = this._toVector3DPairs(m1);
            var vps2 = toCag._toVector3DPairs(m2);

            var polygons = [];
            vps1.forEach(function(vp1, i) {
                polygons.push(new CSG.Polygon([
                    new CSG.Vertex(vps2[i][1]), new CSG.Vertex(vps2[i][0]), new CSG.Vertex(vp1[0])]));
                polygons.push(new CSG.Polygon([
                    new CSG.Vertex(vps2[i][1]), new CSG.Vertex(vp1[0]), new CSG.Vertex(vp1[1])]));
            });
            return polygons;
        },

        union: function(cag) {
            var cags;
            if (cag instanceof Array) {
                cags = cag;
            } else {
                cags = [cag];
            }
            var r = this._toCSGWall(-1, 1);
            var r = r.union(
                cags.map(function(cag) {
                    return cag._toCSGWall(-1, 1).reTesselated();
                }), false, false)
            return CAG.fromFakeCSG(r).canonicalized();
        },

        subtract: function(cag) {
            var cags;
            if (cag instanceof Array) {
                cags = cag;
            } else {
                cags = [cag];
            }
            var r = this._toCSGWall(-1, 1);
            cags.map(function(cag) {
                r = r.subtractSub(cag._toCSGWall(-1, 1), false, false);
            });
            r = r.reTesselated();
            r = r.canonicalized();
            r = CAG.fromFakeCSG(r);
            r = r.canonicalized();
            return r;
        },

        intersect: function(cag) {
            var cags;
            if (cag instanceof Array) {
                cags = cag;
            } else {
                cags = [cag];
            }
            var r = this._toCSGWall(-1, 1);
            cags.map(function(cag) {
                r = r.intersectSub(cag._toCSGWall(-1, 1), false, false);
            });
            r = r.reTesselated();
            r = r.canonicalized();
            r = CAG.fromFakeCSG(r);
            r = r.canonicalized();
            return r;
        },

        transform: function(matrix4x4) {
            var ismirror = matrix4x4.isMirroring();
            var newsides = this.sides.map(function(side) {
                return side.transform(matrix4x4);
            });
            var result = CAG.fromSides(newsides);
            if (ismirror) {
                result = result.flipped();
            }
            return result;
        },

        // see http://local.wasp.uwa.edu.au/~pbourke/geometry/polyarea/ :
        // Area of the polygon. For a counter clockwise rotating polygon the area is positive, otherwise negative
        // Note(bebbi): this looks wrong. See polygon getArea()
        area: function() {
            var polygonArea = 0;
            this.sides.map(function(side) {
                polygonArea += side.vertex0.pos.cross(side.vertex1.pos);
            });
            polygonArea *= 0.5;
            return polygonArea;
        },

        flipped: function() {
            var newsides = this.sides.map(function(side) {
                return side.flipped();
            });
            newsides.reverse();
            return CAG.fromSides(newsides);
        },

        getBounds: function() {
            var minpoint;
            if (this.sides.length === 0) {
                minpoint = new CSG.Vector2D(0, 0);
            } else {
                minpoint = this.sides[0].vertex0.pos;
            }
            var maxpoint = minpoint;
            this.sides.map(function(side) {
                minpoint = minpoint.min(side.vertex0.pos);
                minpoint = minpoint.min(side.vertex1.pos);
                maxpoint = maxpoint.max(side.vertex0.pos);
                maxpoint = maxpoint.max(side.vertex1.pos);
            });
            return [minpoint, maxpoint];
        },

        isSelfIntersecting: function(debug) {
            var numsides = this.sides.length;
            for (var i = 0; i < numsides; i++) {
                var side0 = this.sides[i];
                for (var ii = i + 1; ii < numsides; ii++) {
                    var side1 = this.sides[ii];
                    if (CAG.linesIntersect(side0.vertex0.pos, side0.vertex1.pos, side1.vertex0.pos, side1.vertex1.pos)) {
                        if (debug) { OpenJsCad.log(side0); OpenJsCad.log(side1);}
                        return true;
                    }
                }
            }
            return false;
        },

        expandedShell: function(radius, resolution) {
            resolution = resolution || 8;
            if (resolution < 4) resolution = 4;
            var cags = [];
            var pointmap = {};
            var cag = this.canonicalized();
            cag.sides.map(function(side) {
                var d = side.vertex1.pos.minus(side.vertex0.pos);
                var dl = d.length();
                if (dl > 1e-5) {
                    d = d.times(1.0 / dl);
                    var normal = d.normal().times(radius);
                    var shellpoints = [
                        side.vertex1.pos.plus(normal),
                        side.vertex1.pos.minus(normal),
                        side.vertex0.pos.minus(normal),
                        side.vertex0.pos.plus(normal)
                    ];
                    //      var newcag = CAG.fromPointsNoCheck(shellpoints);
                    var newcag = CAG.fromPoints(shellpoints);
                    cags.push(newcag);
                    for (var step = 0; step < 2; step++) {
                        var p1 = (step === 0) ? side.vertex0.pos : side.vertex1.pos;
                        var p2 = (step === 0) ? side.vertex1.pos : side.vertex0.pos;
                        var tag = p1.x + " " + p1.y;
                        if (!(tag in pointmap)) {
                            pointmap[tag] = [];
                        }
                        pointmap[tag].push({
                            "p1": p1,
                            "p2": p2
                        });
                    }
                }
            });
            for (var tag in pointmap) {
                var m = pointmap[tag];
                var angle1, angle2;
                var pcenter = m[0].p1;
                if (m.length == 2) {
                    var end1 = m[0].p2;
                    var end2 = m[1].p2;
                    angle1 = end1.minus(pcenter).angleDegrees();
                    angle2 = end2.minus(pcenter).angleDegrees();
                    if (angle2 < angle1) angle2 += 360;
                    if (angle2 >= (angle1 + 360)) angle2 -= 360;
                    if (angle2 < angle1 + 180) {
                        var t = angle2;
                        angle2 = angle1 + 360;
                        angle1 = t;
                    }
                    angle1 += 90;
                    angle2 -= 90;
                } else {
                    angle1 = 0;
                    angle2 = 360;
                }
                var fullcircle = (angle2 > angle1 + 359.999);
                if (fullcircle) {
                    angle1 = 0;
                    angle2 = 360;
                }
                if (angle2 > (angle1 + 1e-5)) {
                    var points = [];
                    if (!fullcircle) {
                        points.push(pcenter);
                    }
                    var numsteps = Math.round(resolution * (angle2 - angle1) / 360);
                    if (numsteps < 1) numsteps = 1;
                    for (var step = 0; step <= numsteps; step++) {
                        var angle = angle1 + step / numsteps * (angle2 - angle1);
                        if (step == numsteps) angle = angle2; // prevent rounding errors
                        var point = pcenter.plus(CSG.Vector2D.fromAngleDegrees(angle).times(radius));
                        if ((!fullcircle) || (step > 0)) {
                            points.push(point);
                        }
                    }
                    var newcag = CAG.fromPointsNoCheck(points);
                    cags.push(newcag);
                }
            }
            var result = new CAG();
            result = result.union(cags);
            return result;
        },

        expand: function(radius, resolution) {
            var result = this.union(this.expandedShell(radius, resolution));
            return result;
        },

        contract: function(radius, resolution) {
            var result = this.subtract(this.expandedShell(radius, resolution));
            return result;
        },

        // extrude the CAG in a certain plane. 
        // Giving just a plane is not enough, multiple different extrusions in the same plane would be possible
        // by rotating around the plane's origin. An additional right-hand vector should be specified as well,
        // and this is exactly a CSG.OrthoNormalBasis.
        // orthonormalbasis: characterizes the plane in which to extrude
        // depth: thickness of the extruded shape. Extrusion is done from the plane towards above (unless 
        // symmetrical option is set, see below)
        //
        // options:
        //   {symmetrical: true}  // extrude symmetrically in two directions about the plane
        extrudeInOrthonormalBasis: function(orthonormalbasis, depth, options) {
            // first extrude in the regular Z plane:
            if (!(orthonormalbasis instanceof CSG.OrthoNormalBasis)) {
                throw new Error("extrudeInPlane: the first parameter should be a CSG.OrthoNormalBasis");
            }
            var extruded = this.extrude({
                offset: [0, 0, depth]
            });
            if(CSG.parseOptionAsBool(options, "symmetrical", false))
            {
                extruded = extruded.translate([0,0,-depth/2]);
            }
            var matrix = orthonormalbasis.getInverseProjectionMatrix();
            extruded = extruded.transform(matrix);
            return extruded;
        },

        // Extrude in a standard cartesian plane, specified by two axis identifiers. Each identifier can be
        // one of ["X","Y","Z","-X","-Y","-Z"]
        // The 2d x axis will map to the first given 3D axis, the 2d y axis will map to the second.
        // See CSG.OrthoNormalBasis.GetCartesian for details.
        extrudeInPlane: function(axis1, axis2, depth, options) {
            return this.extrudeInOrthonormalBasis(CSG.OrthoNormalBasis.GetCartesian(axis1, axis2), depth, options);
        },

        // extruded=cag.extrude({offset: [0,0,10], twistangle: 360, twiststeps: 100});
        // linear extrusion of 2D shape, with optional twist
        // The 2d shape is placed in in z=0 plane and extruded into direction <offset> (a CSG.Vector3D)
        // The final face is rotated <twistangle> degrees. Rotation is done around the origin of the 2d shape (i.e. x=0, y=0)
        // twiststeps determines the resolution of the twist (should be >= 1)
        // returns a CSG object
        extrude: function(options) {
            if (this.sides.length == 0) {
                // empty!
                return new CSG();
            }
            var offsetVector = CSG.parseOptionAs3DVector(options, "offset", [0, 0, 1]);
            var twistangle = CSG.parseOptionAsFloat(options, "twistangle", 0);
            var twiststeps = CSG.parseOptionAsInt(options, "twiststeps", CSG.defaultResolution3D);
            if (offsetVector.z == 0) {
                throw('offset cannot be orthogonal to Z axis');
            }
            if (twistangle == 0 || twiststeps < 1) {
                twiststeps = 1;
            }
            var normalVector = CSG.Vector3D.Create(0, 1, 0);

            var polygons = [];
            // bottom and top
            polygons = polygons.concat(this._toPlanePolygons({translation: [0, 0, 0],
                normalVector: normalVector, flipped: !(offsetVector.z < 0)}));
            polygons = polygons.concat(this._toPlanePolygons({translation: offsetVector,
                normalVector: normalVector.rotateZ(twistangle), flipped: offsetVector.z < 0}));
            // walls
            for (var i = 0; i < twiststeps; i++) {
                var c1 = new CSG.Connector(offsetVector.times(i / twiststeps), [0, 0, offsetVector.z],
                    normalVector.rotateZ(i * twistangle/twiststeps));
                var c2 = new CSG.Connector(offsetVector.times((i + 1) / twiststeps), [0, 0, offsetVector.z],
                    normalVector.rotateZ((i + 1) * twistangle/twiststeps));
                polygons = polygons.concat(this._toWallPolygons({toConnector1: c1, toConnector2: c2}));
            }

            return CSG.fromPolygons(polygons);
        },

        /*
         * extrude CAG to 3d object by rotating the origin around the y axis
         * (and turning everything into XY plane)
         * arguments: options dict with angle and resolution, both optional
         */
        rotateExtrude: function(options) {
            var alpha = CSG.parseOptionAsFloat(options, "angle", 360);
            var resolution = CSG.parseOptionAsInt(options, "resolution", CSG.defaultResolution3D);

            var EPS = 1e-5;

            alpha = alpha > 360 ? alpha % 360 : alpha;
            var origin = [0, 0, 0];
            var axisV = CSG.Vector3D.Create(0, 1, 0);
            var normalV = [0, 0, 1];
            var polygons = [];
            // planes only needed if alpha > 0
            var connS = new CSG.Connector(origin, axisV, normalV);
            if (alpha > 0 && alpha < 360) {
                // we need to rotate negative to satisfy wall function condition of
                // building in the direction of axis vector
                var connE = new CSG.Connector(origin, axisV.rotateZ(-alpha), normalV);
                polygons = polygons.concat(
                    this._toPlanePolygons({toConnector: connS, flipped: true}));
                polygons = polygons.concat(
                    this._toPlanePolygons({toConnector: connE}));
            }
            var connT1 = connS, connT2;
            var step = alpha/resolution;
            for (var a = step; a <= alpha + EPS; a += step) {
                connT2 = new CSG.Connector(origin, axisV.rotateZ(-a), normalV);
                polygons = polygons.concat(this._toWallPolygons(
                    {toConnector1: connT1, toConnector2: connT2}));
                connT1 = connT2;
            }
            return CSG.fromPolygons(polygons).reTesselated();
        },

        // check if we are a valid CAG (for debugging)
        // NOTE(bebbi) uneven side count doesn't work because rounding with EPS isn't taken into account
        check: function() {
            var EPS = 1e-5;
            var errors = [];
            if (this.isSelfIntersecting(true)) {
                errors.push("Self intersects");
            }
            var pointcount = {};
            this.sides.map(function(side) {
                function mappoint(p) {
                    var tag = p.x + " " + p.y;
                    if (!(tag in pointcount)) pointcount[tag] = 0;
                    pointcount[tag] ++;
                }
                mappoint(side.vertex0.pos);
                mappoint(side.vertex1.pos);
            });
            for (var tag in pointcount) {
                var count = pointcount[tag];
                if (count & 1) {
                    errors.push("Uneven number of sides (" + count + ") for point " + tag);
                }
            }
            var area = this.area();
            if (area < EPS*EPS) {
                errors.push("Area is " + area);
            }
            if (errors.length > 0) {
                var ertxt = "";
                errors.map(function(err) {
                    ertxt += err + "\n";
                });
                throw new Error(ertxt);
            }
        },

        canonicalized: function() {
            if (this.isCanonicalized) {
                return this;
            } else {
                var factory = new CAG.fuzzyCAGFactory();
                var result = factory.getCAG(this);
                result.isCanonicalized = true;
                return result;
            }
        },

        toCompactBinary: function() {
            var cag = this.canonicalized();
            var numsides = cag.sides.length;
            var vertexmap = {};
            var vertices = [];
            var numvertices = 0;
            var sideVertexIndices = new Uint32Array(2 * numsides);
            var sidevertexindicesindex = 0;
            cag.sides.map(function(side) {
                [side.vertex0, side.vertex1].map(function(v) {
                    var vertextag = v.getTag();
                    var vertexindex;
                    if (!(vertextag in vertexmap)) {
                        vertexindex = numvertices++;
                        vertexmap[vertextag] = vertexindex;
                        vertices.push(v);
                    } else {
                        vertexindex = vertexmap[vertextag];
                    }
                    sideVertexIndices[sidevertexindicesindex++] = vertexindex;
                });
            });
            var vertexData = new Float64Array(numvertices * 2);
            var verticesArrayIndex = 0;
            vertices.map(function(v) {
                var pos = v.pos;
                vertexData[verticesArrayIndex++] = pos._x;
                vertexData[verticesArrayIndex++] = pos._y;
            });
            var result = {
                'class': "CAG",
                sideVertexIndices: sideVertexIndices,
                vertexData: vertexData
            };
            return result;
        },

        getOutlinePaths: function() {
            var cag = this.canonicalized();
            var sideTagToSideMap = {};
            var startVertexTagToSideTagMap = {};
            cag.sides.map(function(side) {
                var sidetag = side.getTag();
                sideTagToSideMap[sidetag] = side;
                var startvertextag = side.vertex0.getTag();
                if (!(startvertextag in startVertexTagToSideTagMap)) {
                    startVertexTagToSideTagMap[startvertextag] = [];
                }
                startVertexTagToSideTagMap[startvertextag].push(sidetag);
            });
            var paths = [];
            while (true) {
                var startsidetag = null;
                for (var aVertexTag in startVertexTagToSideTagMap) {
                    var sidesForThisVertex = startVertexTagToSideTagMap[aVertexTag];
                    startsidetag = sidesForThisVertex[0];
                    sidesForThisVertex.splice(0, 1);
                    if (sidesForThisVertex.length === 0) {
                        delete startVertexTagToSideTagMap[aVertexTag];
                    }
                    break;
                }
                if (startsidetag === null) break; // we've had all sides
                var connectedVertexPoints = [];
                var sidetag = startsidetag;
                var thisside = sideTagToSideMap[sidetag];
                var startvertextag = thisside.vertex0.getTag();
                while (true) {
                    connectedVertexPoints.push(thisside.vertex0.pos);
                    var nextvertextag = thisside.vertex1.getTag();
                    if (nextvertextag == startvertextag) break; // we've closed the polygon
                    if (!(nextvertextag in startVertexTagToSideTagMap)) {
                        throw new Error("Area is not closed!");
                    }
                    var nextpossiblesidetags = startVertexTagToSideTagMap[nextvertextag];
                    var nextsideindex = -1;
                    if (nextpossiblesidetags.length == 1) {
                        nextsideindex = 0;
                    } else {
                        // more than one side starting at the same vertex. This means we have
                        // two shapes touching at the same corner
                        var bestangle = null;
                        var thisangle = thisside.direction().angleDegrees();
                        for (var sideindex = 0; sideindex < nextpossiblesidetags.length; sideindex++) {
                            var nextpossiblesidetag = nextpossiblesidetags[sideindex];
                            var possibleside = sideTagToSideMap[nextpossiblesidetag];
                            var angle = possibleside.direction().angleDegrees();
                            var angledif = angle - thisangle;
                            if (angledif < -180) angledif += 360;
                            if (angledif >= 180) angledif -= 360;
                            if ((nextsideindex < 0) || (angledif > bestangle)) {
                                nextsideindex = sideindex;
                                bestangle = angledif;
                            }
                        }
                    }
                    var nextsidetag = nextpossiblesidetags[nextsideindex];
                    nextpossiblesidetags.splice(nextsideindex, 1);
                    if (nextpossiblesidetags.length === 0) {
                        delete startVertexTagToSideTagMap[nextvertextag];
                    }
                    thisside = sideTagToSideMap[nextsidetag];
                } // inner loop
                var path = new CSG.Path2D(connectedVertexPoints, true);
                paths.push(path);
            } // outer loop
            return paths;
        },

        /*
        cag = cag.overCutInsideCorners(cutterradius);

        Using a CNC router it's impossible to cut out a true sharp inside corner. The inside corner
        will be rounded due to the radius of the cutter. This function compensates for this by creating
        an extra cutout at each inner corner so that the actual cut out shape will be at least as large
        as needed.
        */
        overCutInsideCorners: function(cutterradius) {
            var cag = this.canonicalized();
            // for each vertex determine the 'incoming' side and 'outgoing' side:
            var pointmap = {}; // tag => {pos: coord, from: [], to: []}
            cag.sides.map(function(side) {
                if (!(side.vertex0.getTag() in pointmap)) {
                    pointmap[side.vertex0.getTag()] = {
                        pos: side.vertex0.pos,
                        from: [],
                        to: []
                    };
                }
                pointmap[side.vertex0.getTag()].to.push(side.vertex1.pos);
                if (!(side.vertex1.getTag() in pointmap)) {
                    pointmap[side.vertex1.getTag()] = {
                        pos: side.vertex1.pos,
                        from: [],
                        to: []
                    };
                }
                pointmap[side.vertex1.getTag()].from.push(side.vertex0.pos);
            });
            // overcut all sharp corners:
            var cutouts = [];
            for (var pointtag in pointmap) {
                var pointobj = pointmap[pointtag];
                if ((pointobj.from.length == 1) && (pointobj.to.length == 1)) {
                    // ok, 1 incoming side and 1 outgoing side:
                    var fromcoord = pointobj.from[0];
                    var pointcoord = pointobj.pos;
                    var tocoord = pointobj.to[0];
                    var v1 = pointcoord.minus(fromcoord).unit();
                    var v2 = tocoord.minus(pointcoord).unit();
                    var crossproduct = v1.cross(v2);
                    var isInnerCorner = (crossproduct < 0.001);
                    if (isInnerCorner) {
                        // yes it's a sharp corner:
                        var alpha = v2.angleRadians() - v1.angleRadians() + Math.PI;
                        if (alpha < 0) {
                            alpha += 2 * Math.PI;
                        } else if (alpha >= 2 * Math.PI) {
                            alpha -= 2 * Math.PI;
                        }
                        var midvector = v2.minus(v1).unit();
                        var circlesegmentangle = 30 / 180 * Math.PI; // resolution of the circle: segments of 30 degrees
                        // we need to increase the radius slightly so that our imperfect circle will contain a perfect circle of cutterradius
                        var radiuscorrected = cutterradius / Math.cos(circlesegmentangle / 2);
                        var circlecenter = pointcoord.plus(midvector.times(radiuscorrected));
                        // we don't need to create a full circle; a pie is enough. Find the angles for the pie:
                        var startangle = alpha + midvector.angleRadians();
                        var deltaangle = 2 * (Math.PI - alpha);
                        var numsteps = 2 * Math.ceil(deltaangle / circlesegmentangle / 2); // should be even
                        // build the pie:
                        var points = [circlecenter];
                        for (var i = 0; i <= numsteps; i++) {
                            var angle = startangle + i / numsteps * deltaangle;
                            var p = CSG.Vector2D.fromAngleRadians(angle).times(radiuscorrected).plus(circlecenter);
                            points.push(p);
                        }
                        cutouts.push(CAG.fromPoints(points));
                    }
                }
            }
            var result = cag.subtract(cutouts);
            return result;
        }
    };

    CAG.Vertex = function(pos) {
        this.pos = pos;
    };

    CAG.Vertex.prototype = {
        toString: function() {
            return "(" + this.pos.x.toFixed(2) + "," + this.pos.y.toFixed(2) + ")";
        },
        getTag: function() {
            var result = this.tag;
            if (!result) {
                result = CSG.getTag();
                this.tag = result;
            }
            return result;
        }
    };

    CAG.Side = function(vertex0, vertex1) {
        if (!(vertex0 instanceof CAG.Vertex)) throw new Error("Assertion failed");
        if (!(vertex1 instanceof CAG.Vertex)) throw new Error("Assertion failed");
        this.vertex0 = vertex0;
        this.vertex1 = vertex1;
    };

    CAG.Side._fromFakePolygon = function(polygon) {
        polygon.vertices.forEach(function(v) {
            if (!((v.pos.z >= -1.001) && (v.pos.z < -0.999)) && !((v.pos.z >= 0.999) && (v.pos.z < 1.001))) {
                throw("Assertion failed: _fromFakePolygon expects abs z values of 1");
            }
        })
        // this can happen based on union, seems to be residuals -
        // return null and handle in caller
        if (polygon.vertices.length < 4) {
            return null;
        }
        var reverse = false;
        var vert1Indices = [];
        var pts2d = polygon.vertices.filter(function(v, i) {
            if (v.pos.z > 0) {
                vert1Indices.push(i);
                return true;
            }
        })
        .map(function(v) {
            return new CSG.Vector2D(v.pos.x, v.pos.y);
        });
        if (pts2d.length != 2) {
            throw('Assertion failed: _fromFakePolygon: not enough points found')
        }
        var d = vert1Indices[1] - vert1Indices[0];
        if (d == 1 || d == 3) {
            if (d == 1) {
                pts2d.reverse();
            }
        } else {
            throw('Assertion failed: _fromFakePolygon: unknown index ordering');
        }
        var result = new CAG.Side(new CAG.Vertex(pts2d[0]), new CAG.Vertex(pts2d[1]));
        return result;
    };

    CAG.Side.prototype = {
        toString: function() {
            return this.vertex0 + " -> " + this.vertex1;
        },

        toPolygon3D: function(z0, z1) {
            var vertices = [
                new CSG.Vertex(this.vertex0.pos.toVector3D(z0)),
                new CSG.Vertex(this.vertex1.pos.toVector3D(z0)),
                new CSG.Vertex(this.vertex1.pos.toVector3D(z1)),
                new CSG.Vertex(this.vertex0.pos.toVector3D(z1))
            ];
            return new CSG.Polygon(vertices);
        },

        transform: function(matrix4x4) {
            var newp1 = this.vertex0.pos.transform(matrix4x4);
            var newp2 = this.vertex1.pos.transform(matrix4x4);
            return new CAG.Side(new CAG.Vertex(newp1), new CAG.Vertex(newp2));
        },

        flipped: function() {
            return new CAG.Side(this.vertex1, this.vertex0);
        },

        direction: function() {
            return this.vertex1.pos.minus(this.vertex0.pos);
        },

        getTag: function() {
            var result = this.tag;
            if (!result) {
                result = CSG.getTag();
                this.tag = result;
            }
            return result;
        },

        lengthSquared: function() {
            var x = this.vertex1.pos.x - this.vertex0.pos.x,
                y = this.vertex1.pos.y - this.vertex0.pos.y;
            return x * x + y * y;
        },

        length: function() {
            return Math.sqrt(this.lengthSquared());
        }
    };

    //////////////////////////////////////
    CAG.fuzzyCAGFactory = function() {
        this.vertexfactory = new CSG.fuzzyFactory(2, 1e-5);
    };

    CAG.fuzzyCAGFactory.prototype = {
        getVertex: function(sourcevertex) {
            var elements = [sourcevertex.pos._x, sourcevertex.pos._y];
            var result = this.vertexfactory.lookupOrCreate(elements, function(els) {
                return sourcevertex;
            });
            return result;
        },

        getSide: function(sourceside) {
            var vertex0 = this.getVertex(sourceside.vertex0);
            var vertex1 = this.getVertex(sourceside.vertex1);
            return new CAG.Side(vertex0, vertex1);
        },

        getCAG: function(sourcecag) {
            var _this = this;
            var newsides = sourcecag.sides.map(function(side) {
                return _this.getSide(side);
            })
            // remove bad sides (mostly a user input issue)
            .filter(function(side) {
                return side.length() > 1e-5;
            });
            return CAG.fromSides(newsides);
        }
    };

    //////////////////////////////////////
    CSG.addTransformationMethodsToPrototype(CSG.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Vector2D.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Vector3D.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Vertex.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Plane.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Polygon.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Line3D.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Connector.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Path2D.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.Line2D.prototype);
    CSG.addTransformationMethodsToPrototype(CAG.prototype);
    CSG.addTransformationMethodsToPrototype(CAG.Side.prototype);
    CSG.addTransformationMethodsToPrototype(CSG.OrthoNormalBasis.prototype);

    CSG.addCenteringToPrototype(CSG.prototype, ['x', 'y', 'z']);
    CSG.addCenteringToPrototype(CAG.prototype, ['x', 'y']);

    /*
    2D polygons are now supported through the CAG class.
    With many improvements (see documentation):
      - shapes do no longer have to be convex
      - union/intersect/subtract is supported
      - expand / contract are supported

    But we'll keep CSG.Polygon2D as a stub for backwards compatibility
    */
    CSG.Polygon2D = function(points) {
        var cag = CAG.fromPoints(points);
        this.sides = cag.sides;
    };
    CSG.Polygon2D.prototype = CAG.prototype;



    module.CSG = CSG;
    module.CAG = CAG;
})(this); //module to export to


/***/ }),

/***/ "./node_modules/openjscad-csg/src/formats.js":
/*!***************************************************!*\
  !*** ./node_modules/openjscad-csg/src/formats.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
## License

Copyright (c) 2014 bebbi (elghatta@gmail.com)
Copyright (c) 2013 Eduard Bespalov (edwbes@gmail.com)
Copyright (c) 2012 Joost Nieuwenhuijse (joost@newhouse.nl)
Copyright (c) 2011 Evan Wallace (http://evanw.github.com/csg.js/)
Copyright (c) 2012 Alexandre Girard (https://github.com/alx)

All code released under MIT license

*/

var csgjs = __webpack_require__(/*! ./csg.js */ "./node_modules/openjscad-csg/src/csg.js");
var CSG = csgjs.CSG;
var CAG = csgjs.CAG;

////////////////////////////////////////////
// X3D Export
////////////////////////////////////////////

CSG.prototype.toX3D = function() {
    // materialPolygonLists
    // key: a color string (e.g. "0 1 1" for yellow)
    // value: an array of strings specifying polygons of this color
    //        (as space-separated indices into vertexCoords)
    var materialPolygonLists = {},
        // list of coordinates (as "x y z" strings)
        vertexCoords = [],
        // map to look up the index in vertexCoords of a given vertex
        vertexTagToCoordIndexMap = {};

    this.polygons.map(function(p) {
        var red = 0,
            green = 0,
            blue = 1; // default color is blue
        if (p.shared && p.shared.color) {
            red = p.shared.color[0];
            green = p.shared.color[1];
            blue = p.shared.color[2];
        }

        var polygonVertexIndices = [],
            numvertices = p.vertices.length,
            vertex;
        for (var i = 0; i < numvertices; i++) {
            vertex = p.vertices[i];
            if (!(vertex.getTag() in vertexTagToCoordIndexMap)) {
                vertexCoords.push(vertex.pos._x.toString() + " " +
                    vertex.pos._y.toString() + " " +
                    vertex.pos._z.toString()
                );
                vertexTagToCoordIndexMap[vertex.getTag()] = vertexCoords.length - 1;
            }
            polygonVertexIndices.push(vertexTagToCoordIndexMap[vertex.getTag()]);
        }

        var polygonString = polygonVertexIndices.join(" ");

        var colorString = red.toString() + " " + green.toString() + " " + blue.toString();
        if (!(colorString in materialPolygonLists)) {
            materialPolygonLists[colorString] = [];
        }
        // add this polygonString to the list of colorString-colored polygons
        materialPolygonLists[colorString].push(polygonString);
    });


    // create output document
    var docType = document.implementation.createDocumentType("X3D",
        'ISO//Web3D//DTD X3D 3.1//EN" "http://www.web3d.org/specifications/x3d-3.1.dtd', null);
    var exportDoc = document.implementation.createDocument(null, "X3D", docType);
    exportDoc.insertBefore(
        exportDoc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"'),
        exportDoc.doctype);

    var exportRoot = exportDoc.getElementsByTagName("X3D")[0];
    exportRoot.setAttribute("profile", "Interchange");
    exportRoot.setAttribute("version", "3.1");
    exportRoot.setAttribute("xsd:noNamespaceSchemaLocation", "http://www.web3d.org/specifications/x3d-3.1.xsd");
    exportRoot.setAttribute("xmlns:xsd", "http://www.w3.org/2001/XMLSchema-instance");

    var exportScene = exportDoc.createElement("Scene");
    exportRoot.appendChild(exportScene);

    /*
        For each color, create a shape made of an appropriately colored
        material which contains all polygons that are this color.

        The first shape will contain the definition of all vertices,
        (<Coordinate DEF="coords_mesh"/>), which will be referenced by
        subsequent shapes.
      */
    var coordsMeshDefined = false;
    for (var colorString in materialPolygonLists) {
        var polygonList = materialPolygonLists[colorString];
        var shape = exportDoc.createElement("Shape");
        exportScene.appendChild(shape);

        var appearance = exportDoc.createElement("Appearance");
        shape.appendChild(appearance);

        var material = exportDoc.createElement("Material");
        appearance.appendChild(material);
        material.setAttribute("diffuseColor", colorString);
        material.setAttribute("ambientIntensity", "1.0");

        var ifs = exportDoc.createElement("IndexedFaceSet");
        shape.appendChild(ifs);
        ifs.setAttribute("solid", "true");
        ifs.setAttribute("coordIndex", polygonList.join(" -1 ") + " -1");

        var coordinate = exportDoc.createElement("Coordinate");
        ifs.appendChild(coordinate);
        if (coordsMeshDefined) {
            coordinate.setAttribute("USE", "coords_mesh");
        } else {
            coordinate.setAttribute("DEF", "coords_mesh");
            coordinate.setAttribute("point", vertexCoords.join(" "));
            coordsMeshDefined = true;
        }
    }

    var x3dstring = (new XMLSerializer()).serializeToString(exportDoc);
    return new Blob([x3dstring], {
        type: "model/x3d+xml"
    });
};

////////////////////////////////////////////
// STL Binary Export
////////////////////////////////////////////

// see http://en.wikipedia.org/wiki/STL_%28file_format%29#Binary_STL
CSG.prototype.toStlBinary = function() {
    // first check if the host is little-endian:
    var buffer = new ArrayBuffer(4);
    var int32buffer = new Int32Array(buffer, 0, 1);
    var int8buffer = new Int8Array(buffer, 0, 4);
    int32buffer[0] = 0x11223344;
    if (int8buffer[0] != 0x44) {
        throw new Error("Binary STL output is currently only supported on little-endian (Intel) processors");
    }

    var numtriangles = 0;
    this.polygons.map(function(p) {
        var numvertices = p.vertices.length;
        var thisnumtriangles = (numvertices >= 3) ? numvertices - 2 : 0;
        numtriangles += thisnumtriangles;
    });
    var headerarray = new Uint8Array(80);
    for (var i = 0; i < 80; i++) {
        headerarray[i] = 65;
    }
    var ar1 = new Uint32Array(1);
    ar1[0] = numtriangles;
    // write the triangles to allTrianglesBuffer:
    var allTrianglesBuffer = new ArrayBuffer(50 * numtriangles);
    var allTrianglesBufferAsInt8 = new Int8Array(allTrianglesBuffer);
    // a tricky problem is that a Float32Array must be aligned at 4-byte boundaries (at least in certain browsers)
    // while each triangle takes 50 bytes. Therefore we write each triangle to a temporary buffer, and copy that
    // into allTrianglesBuffer:
    var triangleBuffer = new ArrayBuffer(50);
    var triangleBufferAsInt8 = new Int8Array(triangleBuffer);
    // each triangle consists of 12 floats:
    var triangleFloat32array = new Float32Array(triangleBuffer, 0, 12);
    // and one uint16:
    var triangleUint16array = new Uint16Array(triangleBuffer, 48, 1);
    var byteoffset = 0;
    this.polygons.map(function(p) {
        var numvertices = p.vertices.length;
        for (var i = 0; i < numvertices - 2; i++) {
            var normal = p.plane.normal;
            triangleFloat32array[0] = normal._x;
            triangleFloat32array[1] = normal._y;
            triangleFloat32array[2] = normal._z;
            var arindex = 3;
            for (var v = 0; v < 3; v++) {
                var vv = v + ((v > 0) ? i : 0);
                var vertexpos = p.vertices[vv].pos;
                triangleFloat32array[arindex++] = vertexpos._x;
                triangleFloat32array[arindex++] = vertexpos._y;
                triangleFloat32array[arindex++] = vertexpos._z;
            }
            triangleUint16array[0] = 0;
            // copy the triangle into allTrianglesBuffer:
            allTrianglesBufferAsInt8.set(triangleBufferAsInt8, byteoffset);
            byteoffset += 50;
        }
    });
    return new Blob([headerarray.buffer, ar1.buffer, allTrianglesBuffer], {
        type: "application/sla"
    });
};

////////////////////////////////////////////
// STL String Export
////////////////////////////////////////////

CSG.prototype.toStlString = function() {
    var result = "solid csg.js\n";
    this.polygons.map(function(p) {
        result += p.toStlString();
    });
    result += "endsolid csg.js\n";
    return result;
};

CSG.Vector3D.prototype.toStlString = function() {
    return this._x + " " + this._y + " " + this._z;
};

CSG.Vertex.prototype.toStlString = function() {
    return "vertex " + this.pos.toStlString() + "\n";
};

CSG.Polygon.prototype.toStlString = function() {
    var result = "";
    if (this.vertices.length >= 3) // should be!
    {
        // STL requires triangular polygons. If our polygon has more vertices, create
        // multiple triangles:
        var firstVertexStl = this.vertices[0].toStlString();
        for (var i = 0; i < this.vertices.length - 2; i++) {
            result += "facet normal " + this.plane.normal.toStlString() + "\nouter loop\n";
            result += firstVertexStl;
            result += this.vertices[i + 1].toStlString();
            result += this.vertices[i + 2].toStlString();
            result += "endloop\nendfacet\n";
        }
    }
    return result;
};

////////////////////////////////////////////
// DXF Export
////////////////////////////////////////////

CAG.PathsToDxf = function(paths) {
    var str = "999\nDXF generated by OpenJsCad\n";
    str += "  0\nSECTION\n  2\nHEADER\n";
    str += "  0\nENDSEC\n";
    str += "  0\nSECTION\n  2\nTABLES\n";
    str += "  0\nTABLE\n  2\nLTYPE\n  70\n1\n";
    str += "  0\nLTYPE\n  2\nCONTINUOUS\n  3\nSolid Line\n  72\n65\n  73\n0\n  40\n0.0\n";
    str += "  0\nENDTAB\n";
    str += "  0\nTABLE\n  2\nLAYER\n  70\n1\n";
    str += "  0\nLAYER\n  2\nOpenJsCad\n  62\n7\n  6\ncontinuous\n";
    str += "  0\nENDTAB\n";
    str += "  0\nTABLE\n  2\nSTYLE\n  70\n0\n  0\nENDTAB\n";
    str += "  0\nTABLE\n  2\nVIEW\n  70\n0\n  0\nENDTAB\n";
    str += "  0\nENDSEC\n";
    str += "  0\nSECTION\n  2\nBLOCKS\n";
    str += "  0\nENDSEC\n";
    str += "  0\nSECTION\n  2\nENTITIES\n";
    paths.map(function(path) {
        var numpoints_closed = path.points.length + (path.closed ? 1 : 0);
        str += "  0\nLWPOLYLINE\n  8\nOpenJsCad\n  90\n" + numpoints_closed + "\n  70\n" + (path.closed ? 1 : 0) + "\n";
        for (var pointindex = 0; pointindex < numpoints_closed; pointindex++) {
            var pointindexwrapped = pointindex;
            if (pointindexwrapped >= path.points.length) pointindexwrapped -= path.points.length;
            var point = path.points[pointindexwrapped];
            str += " 10\n" + point.x + "\n 20\n" + point.y + "\n 30\n0.0\n";
        }
    });
    str += "  0\nENDSEC\n  0\nEOF\n";
    return new Blob([str], {
        type: "application/dxf"
    });
};

CAG.prototype.toDxf = function() {
    var paths = this.getOutlinePaths();
    return CAG.PathsToDxf(paths);
};

////////////////////////////////////////////
// AMF Export
////////////////////////////////////////////

CSG.prototype.toAMFString = function(m) {
    var result = "<?xml version=\"1.0\" encoding=\"UTF-8\"?>\n<amf"+(m&&m.unit?" unit=\"+m.unit\"":"")+">\n";
    for(var k in m) {
        result += "<metadata type=\""+k+"\">"+m[k]+"</metadata>\n";
    }
    result += "<object id=\"0\">\n<mesh>\n<vertices>\n";

    this.polygons.map(function(p) {                  // first we dump all vertices of all polygons
        for(var i=0; i<p.vertices.length; i++) {
            result += p.vertices[i].toAMFString();
        }
    });
    result += "</vertices>\n";

    var n = 0;
    this.polygons.map(function(p) {                  // then we dump all polygons
        result += "<volume>\n";
        if(p.vertices.length<3)
            return;
        var r = 1, g = 0.4, b = 1, a = 1, colorSet = false;
        if(p.shared && p.shared.color) {
            r = p.shared.color[0];
            g = p.shared.color[1];
            b = p.shared.color[2];
            a = p.shared.color[3];
            colorSet = true;
        } else if(p.color) {
            r = p.color[0];
            g = p.color[1];
            b = p.color[2];
            if(p.color.length()>3) a = p.color[3];
                colorSet = true;
        }
        result += "<color><r>"+r+"</r><g>"+g+"</g><b>"+b+"</b>"+(a!==undefined?"<a>"+a+"</a>":"")+"</color>";

        for(var i=0; i<p.vertices.length-2; i++) {      // making sure they are all triangles (triangular polygons)
            result += "<triangle>";
            result += "<v1>" + (n) + "</v1>";
            result += "<v2>" + (n+i+1) + "</v2>";
            result += "<v3>" + (n+i+2) + "</v3>";
            result += "</triangle>\n";
        }
        n += p.vertices.length;
        result += "</volume>\n";
    });
    result += "</mesh>\n</object>\n";
    result += "</amf>\n";
    return result;
};

CSG.Vector3D.prototype.toAMFString = function() {
    return "<x>" + this._x + "</x><y>" + this._y + "</y><z>" + this._z + "</z>";
};

CSG.Vertex.prototype.toAMFString = function() {
   return "<vertex><coordinates>" + this.pos.toAMFString() + "</coordinates></vertex>\n";
};



/***/ }),

/***/ "./node_modules/pako/lib/utils/common.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/utils/common.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var TYPED_OK =  (typeof Uint8Array !== 'undefined') &&
                (typeof Uint16Array !== 'undefined') &&
                (typeof Int32Array !== 'undefined');

function _has(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

exports.assign = function (obj /*from1, from2, from3, ...*/) {
  var sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    var source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (var p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// reduce buffer size, avoiding mem copy
exports.shrinkBuf = function (buf, size) {
  if (buf.length === size) { return buf; }
  if (buf.subarray) { return buf.subarray(0, size); }
  buf.length = size;
  return buf;
};


var fnTyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    if (src.subarray && dest.subarray) {
      dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
      return;
    }
    // Fallback to ordinary array
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    var i, l, len, pos, chunk, result;

    // calculate data length
    len = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      len += chunks[i].length;
    }

    // join chunks
    result = new Uint8Array(len);
    pos = 0;
    for (i = 0, l = chunks.length; i < l; i++) {
      chunk = chunks[i];
      result.set(chunk, pos);
      pos += chunk.length;
    }

    return result;
  }
};

var fnUntyped = {
  arraySet: function (dest, src, src_offs, len, dest_offs) {
    for (var i = 0; i < len; i++) {
      dest[dest_offs + i] = src[src_offs + i];
    }
  },
  // Join array of chunks to single array.
  flattenChunks: function (chunks) {
    return [].concat.apply([], chunks);
  }
};


// Enable/Disable typed arrays use, for testing
//
exports.setTyped = function (on) {
  if (on) {
    exports.Buf8  = Uint8Array;
    exports.Buf16 = Uint16Array;
    exports.Buf32 = Int32Array;
    exports.assign(exports, fnTyped);
  } else {
    exports.Buf8  = Array;
    exports.Buf16 = Array;
    exports.Buf32 = Array;
    exports.assign(exports, fnUntyped);
  }
};

exports.setTyped(TYPED_OK);


/***/ }),

/***/ "./node_modules/pako/lib/zlib/adler32.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/zlib/adler32.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function adler32(adler, buf, len, pos) {
  var s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
}


module.exports = adler32;


/***/ }),

/***/ "./node_modules/pako/lib/zlib/constants.js":
/*!*************************************************!*\
  !*** ./node_modules/pako/lib/zlib/constants.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  //Z_MEM_ERROR:     -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};


/***/ }),

/***/ "./node_modules/pako/lib/zlib/crc32.js":
/*!*********************************************!*\
  !*** ./node_modules/pako/lib/zlib/crc32.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
function makeTable() {
  var c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
}

// Create table on load. Just 255 signed longs. Not a problem.
var crcTable = makeTable();


function crc32(crc, buf, len, pos) {
  var t = crcTable,
      end = pos + len;

  crc ^= -1;

  for (var i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
}


module.exports = crc32;


/***/ }),

/***/ "./node_modules/pako/lib/zlib/deflate.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/zlib/deflate.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils   = __webpack_require__(/*! ../utils/common */ "./node_modules/pako/lib/utils/common.js");
var trees   = __webpack_require__(/*! ./trees */ "./node_modules/pako/lib/zlib/trees.js");
var adler32 = __webpack_require__(/*! ./adler32 */ "./node_modules/pako/lib/zlib/adler32.js");
var crc32   = __webpack_require__(/*! ./crc32 */ "./node_modules/pako/lib/zlib/crc32.js");
var msg     = __webpack_require__(/*! ./messages */ "./node_modules/pako/lib/zlib/messages.js");

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
var Z_NO_FLUSH      = 0;
var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
//var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
//var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;


/* compression levels */
//var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var Z_DEFAULT_COMPRESSION = -1;


var Z_FILTERED            = 1;
var Z_HUFFMAN_ONLY        = 2;
var Z_RLE                 = 3;
var Z_FIXED               = 4;
var Z_DEFAULT_STRATEGY    = 0;

/* Possible values of the data_type field (though see inflate()) */
//var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;


/* The deflate compression method */
var Z_DEFLATED  = 8;

/*============================================================================*/


var MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_MEM_LEVEL = 8;


var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
var LITERALS      = 256;
/* number of literal bytes 0..255 */
var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
var D_CODES       = 30;
/* number of distance codes */
var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
var MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

var MIN_MATCH = 3;
var MAX_MATCH = 258;
var MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

var PRESET_DICT = 0x20;

var INIT_STATE = 42;
var EXTRA_STATE = 69;
var NAME_STATE = 73;
var COMMENT_STATE = 91;
var HCRC_STATE = 103;
var BUSY_STATE = 113;
var FINISH_STATE = 666;

var BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
var BS_BLOCK_DONE     = 2; /* block flush performed */
var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
var BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

function err(strm, errorCode) {
  strm.msg = msg[errorCode];
  return errorCode;
}

function rank(f) {
  return ((f) << 1) - ((f) > 4 ? 9 : 0);
}

function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */
function flush_pending(strm) {
  var s = strm.state;

  //_tr_flush_bits(s);
  var len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
  strm.next_out += len;
  s.pending_out += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
}


function flush_block_only(s, last) {
  trees._tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
}


function put_byte(s, b) {
  s.pending_buf[s.pending++] = b;
}


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
function putShortMSB(s, b) {
//  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
}


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
function read_buf(strm, buf, start, size) {
  var len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  utils.arraySet(buf, strm.input, strm.next_in, len, start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
}


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
function longest_match(s, cur_match) {
  var chain_length = s.max_chain_length;      /* max hash chain length */
  var scan = s.strstart; /* current string */
  var match;                       /* matched string */
  var len;                           /* length of current match */
  var best_len = s.prev_length;              /* best match length so far */
  var nice_match = s.nice_match;             /* stop if match long enough */
  var limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  var _win = s.window; // shortcut

  var wmask = s.w_mask;
  var prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  var strend = s.strstart + MAX_MATCH;
  var scan_end1  = _win[scan + best_len - 1];
  var scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
}


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
function fill_window(s) {
  var _w_size = s.w_size;
  var p, n, m, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;

      /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */

      n = s.hash_size;
      p = n;
      do {
        m = s.head[--p];
        s.head[p] = (m >= _w_size ? m - _w_size : 0);
      } while (--n);

      n = _w_size;
      p = n;
      do {
        m = s.prev[--p];
        s.prev[p] = (m >= _w_size ? m - _w_size : 0);
        /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */
      } while (--n);

      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + 1]) & s.hash_mask;
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */
function deflate_stored(s, flush) {
  /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */
  var max_block_size = 0xffff;

  if (max_block_size > s.pending_buf_size - 5) {
    max_block_size = s.pending_buf_size - 5;
  }

  /* Copy as much as possible from input to output: */
  for (;;) {
    /* Fill the window as much as possible: */
    if (s.lookahead <= 1) {

      //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
      //  s->block_start >= (long)s->w_size, "slide too late");
//      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
//        s.block_start >= s.w_size)) {
//        throw  new Error("slide too late");
//      }

      fill_window(s);
      if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }

      if (s.lookahead === 0) {
        break;
      }
      /* flush the current block */
    }
    //Assert(s->block_start >= 0L, "block gone");
//    if (s.block_start < 0) throw new Error("block gone");

    s.strstart += s.lookahead;
    s.lookahead = 0;

    /* Emit a stored block if pending_buf will be full: */
    var max_start = s.block_start + max_block_size;

    if (s.strstart === 0 || s.strstart >= max_start) {
      /* strstart == 0 is possible when wraparound on 16-bit machine */
      s.lookahead = s.strstart - max_start;
      s.strstart = max_start;
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/


    }
    /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */
    if (s.strstart - s.block_start >= (s.w_size - MIN_LOOKAHEAD)) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }

  s.insert = 0;

  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }

  if (s.strstart > s.block_start) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_NEED_MORE;
}

/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
function deflate_fast(s, flush) {
  var hash_head;        /* head of the hash chain */
  var bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + 1]) & s.hash_mask;

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
function deflate_slow(s, flush) {
  var hash_head;          /* head of hash chain */
  var bflush;              /* set if current block must be flushed */

  var max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
}


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
function deflate_rle(s, flush) {
  var bflush;            /* set if current block must be flushed */
  var prev;              /* byte at distance one to match */
  var scan, strend;      /* scan goes up to strend for length of run */

  var _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = trees._tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
function deflate_huff(s, flush) {
  var bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.last_lit) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
}

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {
  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

var configuration_table;

configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
function lm_init(s) {
  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
}


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new utils.Buf16(HEAP_SIZE * 2);
  this.dyn_dtree  = new utils.Buf16((2 * D_CODES + 1) * 2);
  this.bl_tree    = new utils.Buf16((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new utils.Buf16(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new utils.Buf16(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.l_buf = 0;          /* buffer index for literals or lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.last_lit = 0;      /* running index in l_buf */

  this.d_buf = 0;
  /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


function deflateResetKeep(strm) {
  var s;

  if (!strm || !strm.state) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status = (s.wrap ? INIT_STATE : BUSY_STATE);
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = Z_NO_FLUSH;
  trees._tr_init(s);
  return Z_OK;
}


function deflateReset(strm) {
  var ret = deflateResetKeep(strm);
  if (ret === Z_OK) {
    lm_init(strm.state);
  }
  return ret;
}


function deflateSetHeader(strm, head) {
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  if (strm.state.wrap !== 2) { return Z_STREAM_ERROR; }
  strm.state.gzhead = head;
  return Z_OK;
}


function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR;
  }
  var wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED) {
    return err(strm, Z_STREAM_ERROR);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  var s = new DeflateState();

  strm.state = s;
  s.strm = strm;

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new utils.Buf8(s.w_size * 2);
  s.head = new utils.Buf16(s.hash_size);
  s.prev = new utils.Buf16(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  s.pending_buf_size = s.lit_bufsize * 4;

  //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
  //s->pending_buf = (uchf *) overlay;
  s.pending_buf = new utils.Buf8(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
  s.d_buf = 1 * s.lit_bufsize;

  //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
  s.l_buf = (1 + 2) * s.lit_bufsize;

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
}

function deflateInit(strm, level) {
  return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
}


function deflate(strm, flush) {
  var old_flush, s;
  var beg, val; // for gzip header write only

  if (!strm || !strm.state ||
    flush > Z_BLOCK || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
  }

  s = strm.state;

  if (!strm.output ||
      (!strm.input && strm.avail_in !== 0) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR : Z_STREAM_ERROR);
  }

  s.strm = strm; /* just in case */
  old_flush = s.last_flush;
  s.last_flush = flush;

  /* Write the header */
  if (s.status === INIT_STATE) {

    if (s.wrap === 2) { // GZIP header
      strm.adler = 0;  //crc32(0L, Z_NULL, 0);
      put_byte(s, 31);
      put_byte(s, 139);
      put_byte(s, 8);
      if (!s.gzhead) { // s->gzhead == Z_NULL
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, 0);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, OS_CODE);
        s.status = BUSY_STATE;
      }
      else {
        put_byte(s, (s.gzhead.text ? 1 : 0) +
                    (s.gzhead.hcrc ? 2 : 0) +
                    (!s.gzhead.extra ? 0 : 4) +
                    (!s.gzhead.name ? 0 : 8) +
                    (!s.gzhead.comment ? 0 : 16)
        );
        put_byte(s, s.gzhead.time & 0xff);
        put_byte(s, (s.gzhead.time >> 8) & 0xff);
        put_byte(s, (s.gzhead.time >> 16) & 0xff);
        put_byte(s, (s.gzhead.time >> 24) & 0xff);
        put_byte(s, s.level === 9 ? 2 :
                    (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                     4 : 0));
        put_byte(s, s.gzhead.os & 0xff);
        if (s.gzhead.extra && s.gzhead.extra.length) {
          put_byte(s, s.gzhead.extra.length & 0xff);
          put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
        }
        if (s.gzhead.hcrc) {
          strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
        }
        s.gzindex = 0;
        s.status = EXTRA_STATE;
      }
    }
    else // DEFLATE header
    {
      var header = (Z_DEFLATED + ((s.w_bits - 8) << 4)) << 8;
      var level_flags = -1;

      if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
        level_flags = 0;
      } else if (s.level < 6) {
        level_flags = 1;
      } else if (s.level === 6) {
        level_flags = 2;
      } else {
        level_flags = 3;
      }
      header |= (level_flags << 6);
      if (s.strstart !== 0) { header |= PRESET_DICT; }
      header += 31 - (header % 31);

      s.status = BUSY_STATE;
      putShortMSB(s, header);

      /* Save the adler32 of the preset dictionary: */
      if (s.strstart !== 0) {
        putShortMSB(s, strm.adler >>> 16);
        putShortMSB(s, strm.adler & 0xffff);
      }
      strm.adler = 1; // adler32(0L, Z_NULL, 0);
    }
  }

//#ifdef GZIP
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */

      while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            break;
          }
        }
        put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
        s.gzindex++;
      }
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (s.gzindex === s.gzhead.extra.length) {
        s.gzindex = 0;
        s.status = NAME_STATE;
      }
    }
    else {
      s.status = NAME_STATE;
    }
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.gzindex = 0;
        s.status = COMMENT_STATE;
      }
    }
    else {
      s.status = COMMENT_STATE;
    }
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      beg = s.pending;  /* start of bytes to update crc */
      //int val;

      do {
        if (s.pending === s.pending_buf_size) {
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          flush_pending(strm);
          beg = s.pending;
          if (s.pending === s.pending_buf_size) {
            val = 1;
            break;
          }
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);

      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      if (val === 0) {
        s.status = HCRC_STATE;
      }
    }
    else {
      s.status = HCRC_STATE;
    }
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
      }
      if (s.pending + 2 <= s.pending_buf_size) {
        put_byte(s, strm.adler & 0xff);
        put_byte(s, (strm.adler >> 8) & 0xff);
        strm.adler = 0; //crc32(0L, Z_NULL, 0);
        s.status = BUSY_STATE;
      }
    }
    else {
      s.status = BUSY_STATE;
    }
  }
//#endif

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH) {
    return err(strm, Z_BUF_ERROR);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR);
  }

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH && s.status !== FINISH_STATE)) {
    var bstate = (s.strategy === Z_HUFFMAN_ONLY) ? deflate_huff(s, flush) :
      (s.strategy === Z_RLE ? deflate_rle(s, flush) :
        configuration_table[s.level].func(s, flush));

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        trees._tr_align(s);
      }
      else if (flush !== Z_BLOCK) { /* FULL_FLUSH or SYNC_FLUSH */

        trees._tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK;
      }
    }
  }
  //Assert(strm->avail_out > 0, "bug2");
  //if (strm.avail_out <= 0) { throw new Error("bug2");}

  if (flush !== Z_FINISH) { return Z_OK; }
  if (s.wrap <= 0) { return Z_STREAM_END; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK : Z_STREAM_END;
}

function deflateEnd(strm) {
  var status;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  status = strm.state.status;
  if (status !== INIT_STATE &&
    status !== EXTRA_STATE &&
    status !== NAME_STATE &&
    status !== COMMENT_STATE &&
    status !== HCRC_STATE &&
    status !== BUSY_STATE &&
    status !== FINISH_STATE
  ) {
    return err(strm, Z_STREAM_ERROR);
  }

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
}


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
function deflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var s;
  var str, n;
  var wrap;
  var avail;
  var next;
  var input;
  var tmpDict;

  if (!strm/*== Z_NULL*/ || !strm.state/*== Z_NULL*/) {
    return Z_STREAM_ERROR;
  }

  s = strm.state;
  wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    tmpDict = new utils.Buf8(s.w_size);
    utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  avail = strm.avail_in;
  next = strm.next_in;
  input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    str = s.strstart;
    n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = ((s.ins_h << s.hash_shift) ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK;
}


exports.deflateInit = deflateInit;
exports.deflateInit2 = deflateInit2;
exports.deflateReset = deflateReset;
exports.deflateResetKeep = deflateResetKeep;
exports.deflateSetHeader = deflateSetHeader;
exports.deflate = deflate;
exports.deflateEnd = deflateEnd;
exports.deflateSetDictionary = deflateSetDictionary;
exports.deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/


/***/ }),

/***/ "./node_modules/pako/lib/zlib/inffast.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/zlib/inffast.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
var BAD = 30;       /* got a data error -- remain here until reset */
var TYPE = 12;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
module.exports = function inflate_fast(strm, start) {
  var state;
  var _in;                    /* local strm.input */
  var last;                   /* have enough input while in < last */
  var _out;                   /* local strm.output */
  var beg;                    /* inflate()'s initial strm.output */
  var end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  var dmax;                   /* maximum distance from zlib header */
//#endif
  var wsize;                  /* window size or zero if not using window */
  var whave;                  /* valid bytes in the window */
  var wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  var s_window;               /* allocated sliding window, if wsize != 0 */
  var hold;                   /* local strm.hold */
  var bits;                   /* local strm.bits */
  var lcode;                  /* local strm.lencode */
  var dcode;                  /* local strm.distcode */
  var lmask;                  /* mask for first level of length codes */
  var dmask;                  /* mask for first level of distance codes */
  var here;                   /* retrieved table entry */
  var op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  var len;                    /* match length, unused bytes */
  var dist;                   /* match distance */
  var from;                   /* where to copy match from */
  var from_source;


  var input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};


/***/ }),

/***/ "./node_modules/pako/lib/zlib/inflate.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/zlib/inflate.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils         = __webpack_require__(/*! ../utils/common */ "./node_modules/pako/lib/utils/common.js");
var adler32       = __webpack_require__(/*! ./adler32 */ "./node_modules/pako/lib/zlib/adler32.js");
var crc32         = __webpack_require__(/*! ./crc32 */ "./node_modules/pako/lib/zlib/crc32.js");
var inflate_fast  = __webpack_require__(/*! ./inffast */ "./node_modules/pako/lib/zlib/inffast.js");
var inflate_table = __webpack_require__(/*! ./inftrees */ "./node_modules/pako/lib/zlib/inftrees.js");

var CODES = 0;
var LENS = 1;
var DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/


/* Allowed flush values; see deflate() and inflate() below for details */
//var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var Z_FINISH        = 4;
var Z_BLOCK         = 5;
var Z_TREES         = 6;


/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */
var Z_OK            = 0;
var Z_STREAM_END    = 1;
var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var Z_STREAM_ERROR  = -2;
var Z_DATA_ERROR    = -3;
var Z_MEM_ERROR     = -4;
var Z_BUF_ERROR     = -5;
//var Z_VERSION_ERROR = -6;

/* The deflate compression method */
var Z_DEFLATED  = 8;


/* STATES ====================================================================*/
/* ===========================================================================*/


var    HEAD = 1;       /* i: waiting for magic header */
var    FLAGS = 2;      /* i: waiting for method and flags (gzip) */
var    TIME = 3;       /* i: waiting for modification time (gzip) */
var    OS = 4;         /* i: waiting for extra flags and operating system (gzip) */
var    EXLEN = 5;      /* i: waiting for extra length (gzip) */
var    EXTRA = 6;      /* i: waiting for extra bytes (gzip) */
var    NAME = 7;       /* i: waiting for end of file name (gzip) */
var    COMMENT = 8;    /* i: waiting for end of comment (gzip) */
var    HCRC = 9;       /* i: waiting for header crc (gzip) */
var    DICTID = 10;    /* i: waiting for dictionary check value */
var    DICT = 11;      /* waiting for inflateSetDictionary() call */
var        TYPE = 12;      /* i: waiting for type bits, including last-flag bit */
var        TYPEDO = 13;    /* i: same, but skip check to exit inflate on new block */
var        STORED = 14;    /* i: waiting for stored size (length and complement) */
var        COPY_ = 15;     /* i/o: same as COPY below, but only first time in */
var        COPY = 16;      /* i/o: waiting for input or output to copy stored block */
var        TABLE = 17;     /* i: waiting for dynamic block table lengths */
var        LENLENS = 18;   /* i: waiting for code length code lengths */
var        CODELENS = 19;  /* i: waiting for length/lit and distance code lengths */
var            LEN_ = 20;      /* i: same as LEN below, but only first time in */
var            LEN = 21;       /* i: waiting for length/lit/eob code */
var            LENEXT = 22;    /* i: waiting for length extra bits */
var            DIST = 23;      /* i: waiting for distance code */
var            DISTEXT = 24;   /* i: waiting for distance extra bits */
var            MATCH = 25;     /* o: waiting for output space to copy string */
var            LIT = 26;       /* o: waiting for output space to write literal */
var    CHECK = 27;     /* i: waiting for 32-bit check value */
var    LENGTH = 28;    /* i: waiting for 32-bit length (gzip) */
var    DONE = 29;      /* finished check, done -- remain here until reset */
var    BAD = 30;       /* got a data error -- remain here until reset */
var    MEM = 31;       /* got an inflate() memory error -- remain here until reset */
var    SYNC = 32;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

var MAX_WBITS = 15;
/* 32K LZ77 window */
var DEF_WBITS = MAX_WBITS;


function zswap32(q) {
  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
}


function InflateState() {
  this.mode = 0;             /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib) */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
  this.work = new utils.Buf16(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}

function inflateResetKeep(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
  state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK;
}

function inflateReset(strm) {
  var state;

  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

}

function inflateReset2(strm, windowBits) {
  var wrap;
  var state;

  /* get the state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 1;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
}

function inflateInit2(strm, windowBits) {
  var ret;
  var state;

  if (!strm) { return Z_STREAM_ERROR; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.window = null/*Z_NULL*/;
  ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
}

function inflateInit(strm) {
  return inflateInit2(strm, DEF_WBITS);
}


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
var virgin = true;

var lenfix, distfix; // We have no pointers in JS, so keep tables separate

function fixedtables(state) {
  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    var sym;

    lenfix = new utils.Buf32(512);
    distfix = new utils.Buf32(32);

    /* literal/length table */
    sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inflate_table(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inflate_table(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
}


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
function updatewindow(strm, src, end, copy) {
  var dist;
  var state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new utils.Buf8(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    utils.arraySet(state.window, src, end - copy, dist, state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      utils.arraySet(state.window, src, end - copy, copy, 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
}

function inflate(strm, flush) {
  var state;
  var input, output;          // input/output buffers
  var next;                   /* next input INDEX */
  var put;                    /* next output INDEX */
  var have, left;             /* available input and output */
  var hold;                   /* bit buffer */
  var bits;                   /* bits in bit buffer */
  var _in, _out;              /* save starting available input and output */
  var copy;                   /* number of stored or match bytes to copy */
  var from;                   /* where to copy match bytes from */
  var from_source;
  var here = 0;               /* current decoding table entry */
  var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //var last;                   /* parent table entry */
  var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  var len;                    /* length to copy for repeats, bits to drop */
  var ret;                    /* return code */
  var hbuf = new utils.Buf8(4);    /* buffer for gzip header crc calculation */
  var opts;

  var n; // temporary var for NEED_BITS

  var order = /* permutation of code lengths */
    [ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ];


  if (!strm || !strm.state || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        state.flags = 0;           /* expect zlib header */
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        else if (len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }
        state.dmax = 1 << len;
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if (state.flags & 0x0200) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if (state.flags & 0x0200) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if (state.flags & 0x0200) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Array(state.head.extra_len);
              }
              utils.arraySet(
                state.head.extra,
                input,
                next,
                // extra field is limited to 65536 bytes
                // - no need for additional size check
                copy,
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if (state.flags & 0x0200) {
              state.check = crc32(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if (state.flags & 0x0200) {
            state.check = crc32(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          utils.arraySet(output, input, next, copy, put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inflate_fast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if (_out) {
            strm.adler = state.check =
                /*UPDATE(state.check, put - _out, _out);*/
                (state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if (hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
      state.mode = MEM;
      return Z_MEM_ERROR;
    }
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if (state.wrap && _out) {
    strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH) && ret === Z_OK) {
    ret = Z_BUF_ERROR;
  }
  return ret;
}

function inflateEnd(strm) {

  if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
    return Z_STREAM_ERROR;
  }

  var state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK;
}

function inflateGetHeader(strm, head) {
  var state;

  /* check state */
  if (!strm || !strm.state) { return Z_STREAM_ERROR; }
  state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK;
}

function inflateSetDictionary(strm, dictionary) {
  var dictLength = dictionary.length;

  var state;
  var dictid;
  var ret;

  /* check state */
  if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) { return Z_STREAM_ERROR; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK;
}

exports.inflateReset = inflateReset;
exports.inflateReset2 = inflateReset2;
exports.inflateResetKeep = inflateResetKeep;
exports.inflateInit = inflateInit;
exports.inflateInit2 = inflateInit2;
exports.inflate = inflate;
exports.inflateEnd = inflateEnd;
exports.inflateGetHeader = inflateGetHeader;
exports.inflateSetDictionary = inflateSetDictionary;
exports.inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/


/***/ }),

/***/ "./node_modules/pako/lib/zlib/inftrees.js":
/*!************************************************!*\
  !*** ./node_modules/pako/lib/zlib/inftrees.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var utils = __webpack_require__(/*! ../utils/common */ "./node_modules/pako/lib/utils/common.js");

var MAXBITS = 15;
var ENOUGH_LENS = 852;
var ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

var CODES = 0;
var LENS = 1;
var DISTS = 2;

var lbase = [ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
];

var lext = [ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
];

var dbase = [ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
];

var dext = [ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
];

module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts)
{
  var bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  var len = 0;               /* a code's length in bits */
  var sym = 0;               /* index of code symbols */
  var min = 0, max = 0;          /* minimum and maximum code lengths */
  var root = 0;              /* number of index bits for root table */
  var curr = 0;              /* number of index bits for current table */
  var drop = 0;              /* code bits to drop for sub-table */
  var left = 0;                   /* number of prefix codes available */
  var used = 0;              /* code entries in table used */
  var huff = 0;              /* Huffman code */
  var incr;              /* for incrementing code, index */
  var fill;              /* index for replicating entries */
  var low;               /* low bits for current root entry */
  var mask;              /* mask for low root bits */
  var next;             /* next available space in table */
  var base = null;     /* base value table to use */
  var base_index = 0;
//  var shoextra;    /* extra bits table to use */
  var end;                    /* use base and extra for symbol > end */
  var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  var extra = null;
  var extra_index = 0;

  var here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES) {
    base = extra = work;    /* dummy value--not used */
    end = 19;

  } else if (type === LENS) {
    base = lbase;
    base_index -= 257;
    extra = lext;
    extra_index -= 257;
    end = 256;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    end = -1;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS && used > ENOUGH_LENS) ||
    (type === DISTS && used > ENOUGH_DISTS)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] < end) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] > end) {
      here_op = extra[extra_index + work[sym]];
      here_val = base[base_index + work[sym]];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS && used > ENOUGH_LENS) ||
        (type === DISTS && used > ENOUGH_DISTS)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


/***/ }),

/***/ "./node_modules/pako/lib/zlib/messages.js":
/*!************************************************!*\
  !*** ./node_modules/pako/lib/zlib/messages.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

module.exports = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};


/***/ }),

/***/ "./node_modules/pako/lib/zlib/trees.js":
/*!*********************************************!*\
  !*** ./node_modules/pako/lib/zlib/trees.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

var utils = __webpack_require__(/*! ../utils/common */ "./node_modules/pako/lib/utils/common.js");

/* Public constants ==========================================================*/
/* ===========================================================================*/


//var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var Z_FIXED               = 4;
//var Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
var Z_BINARY              = 0;
var Z_TEXT                = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var Z_UNKNOWN             = 2;

/*============================================================================*/


function zero(buf) { var len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

var STORED_BLOCK = 0;
var STATIC_TREES = 1;
var DYN_TREES    = 2;
/* The three kinds of block type */

var MIN_MATCH    = 3;
var MAX_MATCH    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

var LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */

var LITERALS      = 256;
/* number of literal bytes 0..255 */

var L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */

var D_CODES       = 30;
/* number of distance codes */

var BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */

var HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */

var MAX_BITS      = 15;
/* All codes must not exceed MAX_BITS bits */

var Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

var MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

var END_BLOCK   = 256;
/* end of block literal code */

var REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

var REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

var REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
var extra_lbits =   /* extra bits for each length code */
  [0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];

var extra_dbits =   /* extra bits for each distance code */
  [0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];

var extra_blbits =  /* extra bits for each bit length code */
  [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];

var bl_order =
  [16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var static_ltree  = new Array((L_CODES + 2) * 2);
zero(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

var static_dtree  = new Array(D_CODES * 2);
zero(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

var _dist_code    = new Array(DIST_CODE_LEN);
zero(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

var _length_code  = new Array(MAX_MATCH - MIN_MATCH + 1);
zero(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

var base_length   = new Array(LENGTH_CODES);
zero(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

var base_dist     = new Array(D_CODES);
zero(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


var static_l_desc;
var static_d_desc;
var static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



function d_code(dist) {
  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
}


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
function put_short(s, w) {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
}


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
function send_bits(s, value, length) {
  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
}


function send_code(s, c, tree) {
  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
}


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
function bi_reverse(code, len) {
  var res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
}


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
function bi_flush(s) {
  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
}


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
function gen_bitlen(s, desc)
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
  var tree            = desc.dyn_tree;
  var max_code        = desc.max_code;
  var stree           = desc.stat_desc.static_tree;
  var has_stree       = desc.stat_desc.has_stree;
  var extra           = desc.stat_desc.extra_bits;
  var base            = desc.stat_desc.extra_base;
  var max_length      = desc.stat_desc.max_length;
  var h;              /* heap index */
  var n, m;           /* iterate over the tree elements */
  var bits;           /* bit length */
  var xbits;          /* extra bits */
  var f;              /* frequency */
  var overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Trace((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
}


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
function gen_codes(tree, max_code, bl_count)
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
  var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
  var code = 0;              /* running code value */
  var bits;                  /* bit index */
  var n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS; bits++) {
    next_code[bits] = code = (code + bl_count[bits - 1]) << 1;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    var len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
}


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
function tr_static_init() {
  var n;        /* iterates over tree elements */
  var bits;     /* bit counter */
  var length;   /* length value */
  var code;     /* code value */
  var dist;     /* distance index */
  var bl_count = new Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES, MAX_BITS);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES, MAX_BL_BITS);

  //static_init_done = true;
}


/* ===========================================================================
 * Initialize a new block.
 */
function init_block(s) {
  var n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.last_lit = s.matches = 0;
}


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
function bi_windup(s)
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
}

/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */
function copy_block(s, buf, len, header)
//DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
  bi_windup(s);        /* align on byte boundary */

  if (header) {
    put_short(s, len);
    put_short(s, ~len);
  }
//  while (len--) {
//    put_byte(s, *buf++);
//  }
  utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
  s.pending += len;
}

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
function smaller(tree, n, m, depth) {
  var _n2 = n * 2;
  var _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
}

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
function pqdownheap(s, tree, k)
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
  var v = s.heap[k];
  var j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
}


// inlined manually
// var SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
function compress_block(s, ltree, dtree)
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
  var dist;           /* distance of matched string */
  var lc;             /* match length or unmatched char (if dist == 0) */
  var lx = 0;         /* running index in l_buf */
  var code;           /* the code to send */
  var extra;          /* number of extra bits to send */

  if (s.last_lit !== 0) {
    do {
      dist = (s.pending_buf[s.d_buf + lx * 2] << 8) | (s.pending_buf[s.d_buf + lx * 2 + 1]);
      lc = s.pending_buf[s.l_buf + lx];
      lx++;

      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
      //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
      //       "pendingBuf overflow");

    } while (lx < s.last_lit);
  }

  send_code(s, END_BLOCK, ltree);
}


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
function build_tree(s, desc)
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
  var tree     = desc.dyn_tree;
  var stree    = desc.stat_desc.static_tree;
  var has_stree = desc.stat_desc.has_stree;
  var elems    = desc.stat_desc.elems;
  var n, m;          /* iterate over heap elements */
  var max_code = -1; /* largest code with non zero frequency */
  var node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
}


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
function scan_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
function send_tree(s, tree, max_code)
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
  var n;                     /* iterates over all tree elements */
  var prevlen = -1;          /* last emitted length */
  var curlen;                /* length of current code */

  var nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  var count = 0;             /* repeat count of the current code */
  var max_count = 7;         /* max repeat count */
  var min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
}


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
function build_bl_tree(s) {
  var max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
}


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
function send_all_trees(s, lcodes, dcodes, blcodes)
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
  var rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
function detect_data_type(s) {
  /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  var black_mask = 0xf3ffc07f;
  var n;

  /* Check for non-textual ("black-listed") bytes. */
  for (n = 0; n <= 31; n++, black_mask >>>= 1) {
    if ((black_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("white-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
}


var static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
function _tr_init(s)
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
}


/* ===========================================================================
 * Send a stored block
 */
function _tr_stored_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  copy_block(s, buf, stored_len, true); /* with header */
}


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
function _tr_align(s) {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
}


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */
function _tr_flush_block(s, buf, stored_len, last)
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
  var opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  var max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->last_lit));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
}

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
function _tr_tally(s, dist, lc)
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
  //var out_length, in_length, dcode;

  s.pending_buf[s.d_buf + s.last_lit * 2]     = (dist >>> 8) & 0xff;
  s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;

  s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
  s.last_lit++;

  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility

//#ifdef TRUNCATE_BLOCK
//  /* Try to guess if it is profitable to stop the current block here */
//  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
//    /* Compute an upper bound for the compressed length */
//    out_length = s.last_lit*8;
//    in_length = s.strstart - s.block_start;
//
//    for (dcode = 0; dcode < D_CODES; dcode++) {
//      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
//    }
//    out_length >>>= 3;
//    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
//    //       s->last_lit, in_length, out_length,
//    //       100L - out_length*100L/in_length));
//    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
//      return true;
//    }
//  }
//#endif

  return (s.last_lit === s.lit_bufsize - 1);
  /* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */
}

exports._tr_init  = _tr_init;
exports._tr_stored_block = _tr_stored_block;
exports._tr_flush_block  = _tr_flush_block;
exports._tr_tally = _tr_tally;
exports._tr_align = _tr_align;


/***/ }),

/***/ "./node_modules/pako/lib/zlib/zstream.js":
/*!***********************************************!*\
  !*** ./node_modules/pako/lib/zlib/zstream.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

module.exports = ZStream;


/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/proj4/lib/Point.js":
/*!*****************************************!*\
  !*** ./node_modules/proj4/lib/Point.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var mgrs = __webpack_require__(/*! mgrs */ "./node_modules/mgrs/mgrs.js");

function Point(x, y, z) {
  if (!(this instanceof Point)) {
    return new Point(x, y, z);
  }
  if (Array.isArray(x)) {
    this.x = x[0];
    this.y = x[1];
    this.z = x[2] || 0.0;
  }else if(typeof x === 'object'){
    this.x = x.x;
    this.y = x.y;
    this.z = x.z || 0.0;
  } else if (typeof x === 'string' && typeof y === 'undefined') {
    var coords = x.split(',');
    this.x = parseFloat(coords[0], 10);
    this.y = parseFloat(coords[1], 10);
    this.z = parseFloat(coords[2], 10) || 0.0;
  }
  else {
    this.x = x;
    this.y = y;
    this.z = z || 0.0;
  }
  console.warn('proj4.Point will be removed in version 3, use proj4.toPoint');
}

Point.fromMGRS = function(mgrsStr) {
  return new Point(mgrs.toPoint(mgrsStr));
};
Point.prototype.toMGRS = function(accuracy) {
  return mgrs.forward([this.x, this.y], accuracy);
};
module.exports = Point;

/***/ }),

/***/ "./node_modules/proj4/lib/Proj.js":
/*!****************************************!*\
  !*** ./node_modules/proj4/lib/Proj.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var parseCode = __webpack_require__(/*! ./parseCode */ "./node_modules/proj4/lib/parseCode.js");
var extend = __webpack_require__(/*! ./extend */ "./node_modules/proj4/lib/extend.js");
var projections = __webpack_require__(/*! ./projections */ "./node_modules/proj4/lib/projections.js");
var deriveConstants = __webpack_require__(/*! ./deriveConstants */ "./node_modules/proj4/lib/deriveConstants.js");

function Projection(srsCode,callback) {
  if (!(this instanceof Projection)) {
    return new Projection(srsCode);
  }
  callback = callback || function(error){
    if(error){
      throw error;
    }
  };
  var json = parseCode(srsCode);
  if(typeof json !== 'object'){
    callback(srsCode);
    return;
  }
  var modifiedJSON = deriveConstants(json);
  var ourProj = Projection.projections.get(modifiedJSON.projName);
  if(ourProj){
    extend(this, modifiedJSON);
    extend(this, ourProj);
    this.init();
    callback(null, this);
  }else{
    callback(srsCode);
  }
}
Projection.projections = projections;
Projection.projections.start();
module.exports = Projection;


/***/ }),

/***/ "./node_modules/proj4/lib/adjust_axis.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/adjust_axis.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(crs, denorm, point) {
  var xin = point.x,
    yin = point.y,
    zin = point.z || 0.0;
  var v, t, i;
  for (i = 0; i < 3; i++) {
    if (denorm && i === 2 && point.z === undefined) {
      continue;
    }
    if (i === 0) {
      v = xin;
      t = 'x';
    }
    else if (i === 1) {
      v = yin;
      t = 'y';
    }
    else {
      v = zin;
      t = 'z';
    }
    switch (crs.axis[i]) {
    case 'e':
      point[t] = v;
      break;
    case 'w':
      point[t] = -v;
      break;
    case 'n':
      point[t] = v;
      break;
    case 's':
      point[t] = -v;
      break;
    case 'u':
      if (point[t] !== undefined) {
        point.z = v;
      }
      break;
    case 'd':
      if (point[t] !== undefined) {
        point.z = -v;
      }
      break;
    default:
      //console.log("ERROR: unknow axis ("+crs.axis[i]+") - check definition of "+crs.projName);
      return null;
    }
  }
  return point;
};


/***/ }),

/***/ "./node_modules/proj4/lib/common/adjust_lat.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/common/adjust_lat.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var HALF_PI = Math.PI/2;
var sign = __webpack_require__(/*! ./sign */ "./node_modules/proj4/lib/common/sign.js");

module.exports = function(x) {
  return (Math.abs(x) < HALF_PI) ? x : (x - (sign(x) * Math.PI));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/adjust_lon.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/common/adjust_lon.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var TWO_PI = Math.PI * 2;
// SPI is slightly greater than Math.PI, so values that exceed the -180..180
// degree range by a tiny amount don't get wrapped. This prevents points that
// have drifted from their original location along the 180th meridian (due to
// floating point error) from changing their sign.
var SPI = 3.14159265359;
var sign = __webpack_require__(/*! ./sign */ "./node_modules/proj4/lib/common/sign.js");

module.exports = function(x) {
  return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/asinz.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/asinz.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  if (Math.abs(x) > 1) {
    x = (x > 1) ? 1 : -1;
  }
  return Math.asin(x);
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/e0fn.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/e0fn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  return (1 - 0.25 * x * (1 + x / 16 * (3 + 1.25 * x)));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/e1fn.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/e1fn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  return (0.375 * x * (1 + 0.25 * x * (1 + 0.46875 * x)));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/e2fn.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/e2fn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  return (0.05859375 * x * x * (1 + 0.75 * x));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/e3fn.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/e3fn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  return (x * x * x * (35 / 3072));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/gN.js":
/*!*********************************************!*\
  !*** ./node_modules/proj4/lib/common/gN.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(a, e, sinphi) {
  var temp = e * sinphi;
  return a / Math.sqrt(1 - temp * temp);
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/imlfn.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/imlfn.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(ml, e0, e1, e2, e3) {
  var phi;
  var dphi;

  phi = ml / e0;
  for (var i = 0; i < 15; i++) {
    dphi = (ml - (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi))) / (e0 - 2 * e1 * Math.cos(2 * phi) + 4 * e2 * Math.cos(4 * phi) - 6 * e3 * Math.cos(6 * phi));
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }

  //..reportError("IMLFN-CONV:Latitude failed to converge after 15 iterations");
  return NaN;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/iqsfnz.js":
/*!*************************************************!*\
  !*** ./node_modules/proj4/lib/common/iqsfnz.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var HALF_PI = Math.PI/2;

module.exports = function(eccent, q) {
  var temp = 1 - (1 - eccent * eccent) / (2 * eccent) * Math.log((1 - eccent) / (1 + eccent));
  if (Math.abs(Math.abs(q) - temp) < 1.0E-6) {
    if (q < 0) {
      return (-1 * HALF_PI);
    }
    else {
      return HALF_PI;
    }
  }
  //var phi = 0.5* q/(1-eccent*eccent);
  var phi = Math.asin(0.5 * q);
  var dphi;
  var sin_phi;
  var cos_phi;
  var con;
  for (var i = 0; i < 30; i++) {
    sin_phi = Math.sin(phi);
    cos_phi = Math.cos(phi);
    con = eccent * sin_phi;
    dphi = Math.pow(1 - con * con, 2) / (2 * cos_phi) * (q / (1 - eccent * eccent) - sin_phi / (1 - con * con) + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }

  //console.log("IQSFN-CONV:Latitude failed to converge after 30 iterations");
  return NaN;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/mlfn.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/mlfn.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(e0, e1, e2, e3, phi) {
  return (e0 * phi - e1 * Math.sin(2 * phi) + e2 * Math.sin(4 * phi) - e3 * Math.sin(6 * phi));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/msfnz.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/msfnz.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(eccent, sinphi, cosphi) {
  var con = eccent * sinphi;
  return cosphi / (Math.sqrt(1 - con * con));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/phi2z.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/phi2z.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var HALF_PI = Math.PI/2;
module.exports = function(eccent, ts) {
  var eccnth = 0.5 * eccent;
  var con, dphi;
  var phi = HALF_PI - 2 * Math.atan(ts);
  for (var i = 0; i <= 15; i++) {
    con = eccent * Math.sin(phi);
    dphi = HALF_PI - 2 * Math.atan(ts * (Math.pow(((1 - con) / (1 + con)), eccnth))) - phi;
    phi += dphi;
    if (Math.abs(dphi) <= 0.0000000001) {
      return phi;
    }
  }
  //console.log("phi2z has NoConvergence");
  return -9999;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/pj_enfn.js":
/*!**************************************************!*\
  !*** ./node_modules/proj4/lib/common/pj_enfn.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var C00 = 1;
var C02 = 0.25;
var C04 = 0.046875;
var C06 = 0.01953125;
var C08 = 0.01068115234375;
var C22 = 0.75;
var C44 = 0.46875;
var C46 = 0.01302083333333333333;
var C48 = 0.00712076822916666666;
var C66 = 0.36458333333333333333;
var C68 = 0.00569661458333333333;
var C88 = 0.3076171875;

module.exports = function(es) {
  var en = [];
  en[0] = C00 - es * (C02 + es * (C04 + es * (C06 + es * C08)));
  en[1] = es * (C22 - es * (C04 + es * (C06 + es * C08)));
  var t = es * es;
  en[2] = t * (C44 - es * (C46 + es * C48));
  t *= es;
  en[3] = t * (C66 - es * C68);
  en[4] = t * es * C88;
  return en;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/pj_inv_mlfn.js":
/*!******************************************************!*\
  !*** ./node_modules/proj4/lib/common/pj_inv_mlfn.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var pj_mlfn = __webpack_require__(/*! ./pj_mlfn */ "./node_modules/proj4/lib/common/pj_mlfn.js");
var EPSLN = 1.0e-10;
var MAX_ITER = 20;
module.exports = function(arg, es, en) {
  var k = 1 / (1 - es);
  var phi = arg;
  for (var i = MAX_ITER; i; --i) { /* rarely goes over 2 iterations */
    var s = Math.sin(phi);
    var t = 1 - es * s * s;
    //t = this.pj_mlfn(phi, s, Math.cos(phi), en) - arg;
    //phi -= t * (t * Math.sqrt(t)) * k;
    t = (pj_mlfn(phi, s, Math.cos(phi), en) - arg) * (t * Math.sqrt(t)) * k;
    phi -= t;
    if (Math.abs(t) < EPSLN) {
      return phi;
    }
  }
  //..reportError("cass:pj_inv_mlfn: Convergence error");
  return phi;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/pj_mlfn.js":
/*!**************************************************!*\
  !*** ./node_modules/proj4/lib/common/pj_mlfn.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(phi, sphi, cphi, en) {
  cphi *= sphi;
  sphi *= sphi;
  return (en[0] * phi - cphi * (en[1] + sphi * (en[2] + sphi * (en[3] + sphi * en[4]))));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/qsfnz.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/qsfnz.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(eccent, sinphi) {
  var con;
  if (eccent > 1.0e-7) {
    con = eccent * sinphi;
    return ((1 - eccent * eccent) * (sinphi / (1 - con * con) - (0.5 / eccent) * Math.log((1 - con) / (1 + con))));
  }
  else {
    return (2 * sinphi);
  }
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/sign.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/sign.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(x) {
  return x<0 ? -1 : 1;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/srat.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/common/srat.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(esinp, exp) {
  return (Math.pow((1 - esinp) / (1 + esinp), exp));
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/toPoint.js":
/*!**************************************************!*\
  !*** ./node_modules/proj4/lib/common/toPoint.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (array){
  var out = {
    x: array[0],
    y: array[1]
  };
  if (array.length>2) {
    out.z = array[2];
  }
  if (array.length>3) {
    out.m = array[3];
  }
  return out;
};

/***/ }),

/***/ "./node_modules/proj4/lib/common/tsfnz.js":
/*!************************************************!*\
  !*** ./node_modules/proj4/lib/common/tsfnz.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var HALF_PI = Math.PI/2;

module.exports = function(eccent, phi, sinphi) {
  var con = eccent * sinphi;
  var com = 0.5 * eccent;
  con = Math.pow(((1 - con) / (1 + con)), com);
  return (Math.tan(0.5 * (HALF_PI - phi)) / con);
};

/***/ }),

/***/ "./node_modules/proj4/lib/constants/Datum.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/constants/Datum.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.wgs84 = {
  towgs84: "0,0,0",
  ellipse: "WGS84",
  datumName: "WGS84"
};
exports.ch1903 = {
  towgs84: "674.374,15.056,405.346",
  ellipse: "bessel",
  datumName: "swiss"
};
exports.ggrs87 = {
  towgs84: "-199.87,74.79,246.62",
  ellipse: "GRS80",
  datumName: "Greek_Geodetic_Reference_System_1987"
};
exports.nad83 = {
  towgs84: "0,0,0",
  ellipse: "GRS80",
  datumName: "North_American_Datum_1983"
};
exports.nad27 = {
  nadgrids: "@conus,@alaska,@ntv2_0.gsb,@ntv1_can.dat",
  ellipse: "clrk66",
  datumName: "North_American_Datum_1927"
};
exports.potsdam = {
  towgs84: "606.0,23.0,413.0",
  ellipse: "bessel",
  datumName: "Potsdam Rauenberg 1950 DHDN"
};
exports.carthage = {
  towgs84: "-263.0,6.0,431.0",
  ellipse: "clark80",
  datumName: "Carthage 1934 Tunisia"
};
exports.hermannskogel = {
  towgs84: "653.0,-212.0,449.0",
  ellipse: "bessel",
  datumName: "Hermannskogel"
};
exports.ire65 = {
  towgs84: "482.530,-130.596,564.557,-1.042,-0.214,-0.631,8.15",
  ellipse: "mod_airy",
  datumName: "Ireland 1965"
};
exports.rassadiran = {
  towgs84: "-133.63,-157.5,-158.62",
  ellipse: "intl",
  datumName: "Rassadiran"
};
exports.nzgd49 = {
  towgs84: "59.47,-5.04,187.44,0.47,-0.1,1.024,-4.5993",
  ellipse: "intl",
  datumName: "New Zealand Geodetic Datum 1949"
};
exports.osgb36 = {
  towgs84: "446.448,-125.157,542.060,0.1502,0.2470,0.8421,-20.4894",
  ellipse: "airy",
  datumName: "Airy 1830"
};
exports.s_jtsk = {
  towgs84: "589,76,480",
  ellipse: 'bessel',
  datumName: 'S-JTSK (Ferro)'
};
exports.beduaram = {
  towgs84: '-106,-87,188',
  ellipse: 'clrk80',
  datumName: 'Beduaram'
};
exports.gunung_segara = {
  towgs84: '-403,684,41',
  ellipse: 'bessel',
  datumName: 'Gunung Segara Jakarta'
};
exports.rnb72 = {
  towgs84: "106.869,-52.2978,103.724,-0.33657,0.456955,-1.84218,1",
  ellipse: "intl",
  datumName: "Reseau National Belge 1972"
};

/***/ }),

/***/ "./node_modules/proj4/lib/constants/Ellipsoid.js":
/*!*******************************************************!*\
  !*** ./node_modules/proj4/lib/constants/Ellipsoid.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.MERIT = {
  a: 6378137.0,
  rf: 298.257,
  ellipseName: "MERIT 1983"
};
exports.SGS85 = {
  a: 6378136.0,
  rf: 298.257,
  ellipseName: "Soviet Geodetic System 85"
};
exports.GRS80 = {
  a: 6378137.0,
  rf: 298.257222101,
  ellipseName: "GRS 1980(IUGG, 1980)"
};
exports.IAU76 = {
  a: 6378140.0,
  rf: 298.257,
  ellipseName: "IAU 1976"
};
exports.airy = {
  a: 6377563.396,
  b: 6356256.910,
  ellipseName: "Airy 1830"
};
exports.APL4 = {
  a: 6378137,
  rf: 298.25,
  ellipseName: "Appl. Physics. 1965"
};
exports.NWL9D = {
  a: 6378145.0,
  rf: 298.25,
  ellipseName: "Naval Weapons Lab., 1965"
};
exports.mod_airy = {
  a: 6377340.189,
  b: 6356034.446,
  ellipseName: "Modified Airy"
};
exports.andrae = {
  a: 6377104.43,
  rf: 300.0,
  ellipseName: "Andrae 1876 (Den., Iclnd.)"
};
exports.aust_SA = {
  a: 6378160.0,
  rf: 298.25,
  ellipseName: "Australian Natl & S. Amer. 1969"
};
exports.GRS67 = {
  a: 6378160.0,
  rf: 298.2471674270,
  ellipseName: "GRS 67(IUGG 1967)"
};
exports.bessel = {
  a: 6377397.155,
  rf: 299.1528128,
  ellipseName: "Bessel 1841"
};
exports.bess_nam = {
  a: 6377483.865,
  rf: 299.1528128,
  ellipseName: "Bessel 1841 (Namibia)"
};
exports.clrk66 = {
  a: 6378206.4,
  b: 6356583.8,
  ellipseName: "Clarke 1866"
};
exports.clrk80 = {
  a: 6378249.145,
  rf: 293.4663,
  ellipseName: "Clarke 1880 mod."
};
exports.clrk58 = {
  a: 6378293.645208759,
  rf: 294.2606763692654,
  ellipseName: "Clarke 1858"
};
exports.CPM = {
  a: 6375738.7,
  rf: 334.29,
  ellipseName: "Comm. des Poids et Mesures 1799"
};
exports.delmbr = {
  a: 6376428.0,
  rf: 311.5,
  ellipseName: "Delambre 1810 (Belgium)"
};
exports.engelis = {
  a: 6378136.05,
  rf: 298.2566,
  ellipseName: "Engelis 1985"
};
exports.evrst30 = {
  a: 6377276.345,
  rf: 300.8017,
  ellipseName: "Everest 1830"
};
exports.evrst48 = {
  a: 6377304.063,
  rf: 300.8017,
  ellipseName: "Everest 1948"
};
exports.evrst56 = {
  a: 6377301.243,
  rf: 300.8017,
  ellipseName: "Everest 1956"
};
exports.evrst69 = {
  a: 6377295.664,
  rf: 300.8017,
  ellipseName: "Everest 1969"
};
exports.evrstSS = {
  a: 6377298.556,
  rf: 300.8017,
  ellipseName: "Everest (Sabah & Sarawak)"
};
exports.fschr60 = {
  a: 6378166.0,
  rf: 298.3,
  ellipseName: "Fischer (Mercury Datum) 1960"
};
exports.fschr60m = {
  a: 6378155.0,
  rf: 298.3,
  ellipseName: "Fischer 1960"
};
exports.fschr68 = {
  a: 6378150.0,
  rf: 298.3,
  ellipseName: "Fischer 1968"
};
exports.helmert = {
  a: 6378200.0,
  rf: 298.3,
  ellipseName: "Helmert 1906"
};
exports.hough = {
  a: 6378270.0,
  rf: 297.0,
  ellipseName: "Hough"
};
exports.intl = {
  a: 6378388.0,
  rf: 297.0,
  ellipseName: "International 1909 (Hayford)"
};
exports.kaula = {
  a: 6378163.0,
  rf: 298.24,
  ellipseName: "Kaula 1961"
};
exports.lerch = {
  a: 6378139.0,
  rf: 298.257,
  ellipseName: "Lerch 1979"
};
exports.mprts = {
  a: 6397300.0,
  rf: 191.0,
  ellipseName: "Maupertius 1738"
};
exports.new_intl = {
  a: 6378157.5,
  b: 6356772.2,
  ellipseName: "New International 1967"
};
exports.plessis = {
  a: 6376523.0,
  rf: 6355863.0,
  ellipseName: "Plessis 1817 (France)"
};
exports.krass = {
  a: 6378245.0,
  rf: 298.3,
  ellipseName: "Krassovsky, 1942"
};
exports.SEasia = {
  a: 6378155.0,
  b: 6356773.3205,
  ellipseName: "Southeast Asia"
};
exports.walbeck = {
  a: 6376896.0,
  b: 6355834.8467,
  ellipseName: "Walbeck"
};
exports.WGS60 = {
  a: 6378165.0,
  rf: 298.3,
  ellipseName: "WGS 60"
};
exports.WGS66 = {
  a: 6378145.0,
  rf: 298.25,
  ellipseName: "WGS 66"
};
exports.WGS7 = {
  a: 6378135.0,
  rf: 298.26,
  ellipseName: "WGS 72"
};
exports.WGS84 = {
  a: 6378137.0,
  rf: 298.257223563,
  ellipseName: "WGS 84"
};
exports.sphere = {
  a: 6370997.0,
  b: 6370997.0,
  ellipseName: "Normal Sphere (r=6370997)"
};

/***/ }),

/***/ "./node_modules/proj4/lib/constants/PrimeMeridian.js":
/*!***********************************************************!*\
  !*** ./node_modules/proj4/lib/constants/PrimeMeridian.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.greenwich = 0.0; //"0dE",
exports.lisbon = -9.131906111111; //"9d07'54.862\"W",
exports.paris = 2.337229166667; //"2d20'14.025\"E",
exports.bogota = -74.080916666667; //"74d04'51.3\"W",
exports.madrid = -3.687938888889; //"3d41'16.58\"W",
exports.rome = 12.452333333333; //"12d27'8.4\"E",
exports.bern = 7.439583333333; //"7d26'22.5\"E",
exports.jakarta = 106.807719444444; //"106d48'27.79\"E",
exports.ferro = -17.666666666667; //"17d40'W",
exports.brussels = 4.367975; //"4d22'4.71\"E",
exports.stockholm = 18.058277777778; //"18d3'29.8\"E",
exports.athens = 23.7163375; //"23d42'58.815\"E",
exports.oslo = 10.722916666667; //"10d43'22.5\"E"

/***/ }),

/***/ "./node_modules/proj4/lib/constants/units.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/constants/units.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.ft = {to_meter: 0.3048};
exports['us-ft'] = {to_meter: 1200 / 3937};


/***/ }),

/***/ "./node_modules/proj4/lib/core.js":
/*!****************************************!*\
  !*** ./node_modules/proj4/lib/core.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var proj = __webpack_require__(/*! ./Proj */ "./node_modules/proj4/lib/Proj.js");
var transform = __webpack_require__(/*! ./transform */ "./node_modules/proj4/lib/transform.js");
var wgs84 = proj('WGS84');

function transformer(from, to, coords) {
  var transformedArray;
  if (Array.isArray(coords)) {
    transformedArray = transform(from, to, coords);
    if (coords.length === 3) {
      return [transformedArray.x, transformedArray.y, transformedArray.z];
    }
    else {
      return [transformedArray.x, transformedArray.y];
    }
  }
  else {
    return transform(from, to, coords);
  }
}

function checkProj(item) {
  if (item instanceof proj) {
    return item;
  }
  if (item.oProj) {
    return item.oProj;
  }
  return proj(item);
}
function proj4(fromProj, toProj, coord) {
  fromProj = checkProj(fromProj);
  var single = false;
  var obj;
  if (typeof toProj === 'undefined') {
    toProj = fromProj;
    fromProj = wgs84;
    single = true;
  }
  else if (typeof toProj.x !== 'undefined' || Array.isArray(toProj)) {
    coord = toProj;
    toProj = fromProj;
    fromProj = wgs84;
    single = true;
  }
  toProj = checkProj(toProj);
  if (coord) {
    return transformer(fromProj, toProj, coord);
  }
  else {
    obj = {
      forward: function(coords) {
        return transformer(fromProj, toProj, coords);
      },
      inverse: function(coords) {
        return transformer(toProj, fromProj, coords);
      }
    };
    if (single) {
      obj.oProj = toProj;
    }
    return obj;
  }
}
module.exports = proj4;

/***/ }),

/***/ "./node_modules/proj4/lib/datum.js":
/*!*****************************************!*\
  !*** ./node_modules/proj4/lib/datum.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var HALF_PI = Math.PI/2;
var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var PJD_GRIDSHIFT = 3;
var PJD_WGS84 = 4; // WGS84 or equivalent
var PJD_NODATUM = 5; // WGS84 or equivalent
var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
var AD_C = 1.0026000;
var COS_67P5 = 0.38268343236508977;
var datum = function(proj) {
  if (!(this instanceof datum)) {
    return new datum(proj);
  }
  this.datum_type = PJD_WGS84; //default setting
  if (!proj) {
    return;
  }
  if (proj.datumCode && proj.datumCode === 'none') {
    this.datum_type = PJD_NODATUM;
  }
  if (proj.datum_params) {
    for (var i = 0; i < proj.datum_params.length; i++) {
      proj.datum_params[i] = parseFloat(proj.datum_params[i]);
    }
    if (proj.datum_params[0] !== 0 || proj.datum_params[1] !== 0 || proj.datum_params[2] !== 0) {
      this.datum_type = PJD_3PARAM;
    }
    if (proj.datum_params.length > 3) {
      if (proj.datum_params[3] !== 0 || proj.datum_params[4] !== 0 || proj.datum_params[5] !== 0 || proj.datum_params[6] !== 0) {
        this.datum_type = PJD_7PARAM;
        proj.datum_params[3] *= SEC_TO_RAD;
        proj.datum_params[4] *= SEC_TO_RAD;
        proj.datum_params[5] *= SEC_TO_RAD;
        proj.datum_params[6] = (proj.datum_params[6] / 1000000.0) + 1.0;
      }
    }
  }
  // DGR 2011-03-21 : nadgrids support
  this.datum_type = proj.grids ? PJD_GRIDSHIFT : this.datum_type;

  this.a = proj.a; //datum object also uses these values
  this.b = proj.b;
  this.es = proj.es;
  this.ep2 = proj.ep2;
  this.datum_params = proj.datum_params;
  if (this.datum_type === PJD_GRIDSHIFT) {
    this.grids = proj.grids;
  }
};
datum.prototype = {


  /****************************************************************/
  // cs_compare_datums()
  //   Returns TRUE if the two datums match, otherwise FALSE.
  compare_datums: function(dest) {
    if (this.datum_type !== dest.datum_type) {
      return false; // false, datums are not equal
    }
    else if (this.a !== dest.a || Math.abs(this.es - dest.es) > 0.000000000050) {
      // the tolerence for es is to ensure that GRS80 and WGS84
      // are considered identical
      return false;
    }
    else if (this.datum_type === PJD_3PARAM) {
      return (this.datum_params[0] === dest.datum_params[0] && this.datum_params[1] === dest.datum_params[1] && this.datum_params[2] === dest.datum_params[2]);
    }
    else if (this.datum_type === PJD_7PARAM) {
      return (this.datum_params[0] === dest.datum_params[0] && this.datum_params[1] === dest.datum_params[1] && this.datum_params[2] === dest.datum_params[2] && this.datum_params[3] === dest.datum_params[3] && this.datum_params[4] === dest.datum_params[4] && this.datum_params[5] === dest.datum_params[5] && this.datum_params[6] === dest.datum_params[6]);
    }
    else if (this.datum_type === PJD_GRIDSHIFT || dest.datum_type === PJD_GRIDSHIFT) {
      //alert("ERROR: Grid shift transformations are not implemented.");
      //return false
      //DGR 2012-07-29 lazy ...
      return this.nadgrids === dest.nadgrids;
    }
    else {
      return true; // datums are equal
    }
  }, // cs_compare_datums()

  /*
   * The function Convert_Geodetic_To_Geocentric converts geodetic coordinates
   * (latitude, longitude, and height) to geocentric coordinates (X, Y, Z),
   * according to the current ellipsoid parameters.
   *
   *    Latitude  : Geodetic latitude in radians                     (input)
   *    Longitude : Geodetic longitude in radians                    (input)
   *    Height    : Geodetic height, in meters                       (input)
   *    X         : Calculated Geocentric X coordinate, in meters    (output)
   *    Y         : Calculated Geocentric Y coordinate, in meters    (output)
   *    Z         : Calculated Geocentric Z coordinate, in meters    (output)
   *
   */
  geodetic_to_geocentric: function(p) {
    var Longitude = p.x;
    var Latitude = p.y;
    var Height = p.z ? p.z : 0; //Z value not always supplied
    var X; // output
    var Y;
    var Z;

    var Error_Code = 0; //  GEOCENT_NO_ERROR;
    var Rn; /*  Earth radius at location  */
    var Sin_Lat; /*  Math.sin(Latitude)  */
    var Sin2_Lat; /*  Square of Math.sin(Latitude)  */
    var Cos_Lat; /*  Math.cos(Latitude)  */

    /*
     ** Don't blow up if Latitude is just a little out of the value
     ** range as it may just be a rounding issue.  Also removed longitude
     ** test, it should be wrapped by Math.cos() and Math.sin().  NFW for PROJ.4, Sep/2001.
     */
    if (Latitude < -HALF_PI && Latitude > -1.001 * HALF_PI) {
      Latitude = -HALF_PI;
    }
    else if (Latitude > HALF_PI && Latitude < 1.001 * HALF_PI) {
      Latitude = HALF_PI;
    }
    else if ((Latitude < -HALF_PI) || (Latitude > HALF_PI)) {
      /* Latitude out of range */
      //..reportError('geocent:lat out of range:' + Latitude);
      return null;
    }

    if (Longitude > Math.PI) {
      Longitude -= (2 * Math.PI);
    }
    Sin_Lat = Math.sin(Latitude);
    Cos_Lat = Math.cos(Latitude);
    Sin2_Lat = Sin_Lat * Sin_Lat;
    Rn = this.a / (Math.sqrt(1.0e0 - this.es * Sin2_Lat));
    X = (Rn + Height) * Cos_Lat * Math.cos(Longitude);
    Y = (Rn + Height) * Cos_Lat * Math.sin(Longitude);
    Z = ((Rn * (1 - this.es)) + Height) * Sin_Lat;

    p.x = X;
    p.y = Y;
    p.z = Z;
    return Error_Code;
  }, // cs_geodetic_to_geocentric()


  geocentric_to_geodetic: function(p) {
    /* local defintions and variables */
    /* end-criterium of loop, accuracy of sin(Latitude) */
    var genau = 1e-12;
    var genau2 = (genau * genau);
    var maxiter = 30;

    var P; /* distance between semi-minor axis and location */
    var RR; /* distance between center and location */
    var CT; /* sin of geocentric latitude */
    var ST; /* cos of geocentric latitude */
    var RX;
    var RK;
    var RN; /* Earth radius at location */
    var CPHI0; /* cos of start or old geodetic latitude in iterations */
    var SPHI0; /* sin of start or old geodetic latitude in iterations */
    var CPHI; /* cos of searched geodetic latitude */
    var SPHI; /* sin of searched geodetic latitude */
    var SDPHI; /* end-criterium: addition-theorem of sin(Latitude(iter)-Latitude(iter-1)) */
    var At_Pole; /* indicates location is in polar region */
    var iter; /* # of continous iteration, max. 30 is always enough (s.a.) */

    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0.0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;

    At_Pole = false;
    P = Math.sqrt(X * X + Y * Y);
    RR = Math.sqrt(X * X + Y * Y + Z * Z);

    /*      special cases for latitude and longitude */
    if (P / this.a < genau) {

      /*  special case, if P=0. (X=0., Y=0.) */
      At_Pole = true;
      Longitude = 0.0;

      /*  if (X,Y,Z)=(0.,0.,0.) then Height becomes semi-minor axis
       *  of ellipsoid (=center of mass), Latitude becomes PI/2 */
      if (RR / this.a < genau) {
        Latitude = HALF_PI;
        Height = -this.b;
        return;
      }
    }
    else {
      /*  ellipsoidal (geodetic) longitude
       *  interval: -PI < Longitude <= +PI */
      Longitude = Math.atan2(Y, X);
    }

    /* --------------------------------------------------------------
     * Following iterative algorithm was developped by
     * "Institut for Erdmessung", University of Hannover, July 1988.
     * Internet: www.ife.uni-hannover.de
     * Iterative computation of CPHI,SPHI and Height.
     * Iteration of CPHI and SPHI to 10**-12 radian resp.
     * 2*10**-7 arcsec.
     * --------------------------------------------------------------
     */
    CT = Z / RR;
    ST = P / RR;
    RX = 1.0 / Math.sqrt(1.0 - this.es * (2.0 - this.es) * ST * ST);
    CPHI0 = ST * (1.0 - this.es) * RX;
    SPHI0 = CT * RX;
    iter = 0;

    /* loop to find sin(Latitude) resp. Latitude
     * until |sin(Latitude(iter)-Latitude(iter-1))| < genau */
    do {
      iter++;
      RN = this.a / Math.sqrt(1.0 - this.es * SPHI0 * SPHI0);

      /*  ellipsoidal (geodetic) height */
      Height = P * CPHI0 + Z * SPHI0 - RN * (1.0 - this.es * SPHI0 * SPHI0);

      RK = this.es * RN / (RN + Height);
      RX = 1.0 / Math.sqrt(1.0 - RK * (2.0 - RK) * ST * ST);
      CPHI = ST * (1.0 - RK) * RX;
      SPHI = CT * RX;
      SDPHI = SPHI * CPHI0 - CPHI * SPHI0;
      CPHI0 = CPHI;
      SPHI0 = SPHI;
    }
    while (SDPHI * SDPHI > genau2 && iter < maxiter);

    /*      ellipsoidal (geodetic) latitude */
    Latitude = Math.atan(SPHI / Math.abs(CPHI));

    p.x = Longitude;
    p.y = Latitude;
    p.z = Height;
    return p;
  }, // cs_geocentric_to_geodetic()

  /** Convert_Geocentric_To_Geodetic
   * The method used here is derived from 'An Improved Algorithm for
   * Geocentric to Geodetic Coordinate Conversion', by Ralph Toms, Feb 1996
   */
  geocentric_to_geodetic_noniter: function(p) {
    var X = p.x;
    var Y = p.y;
    var Z = p.z ? p.z : 0; //Z value not always supplied
    var Longitude;
    var Latitude;
    var Height;

    var W; /* distance from Z axis */
    var W2; /* square of distance from Z axis */
    var T0; /* initial estimate of vertical component */
    var T1; /* corrected estimate of vertical component */
    var S0; /* initial estimate of horizontal component */
    var S1; /* corrected estimate of horizontal component */
    var Sin_B0; /* Math.sin(B0), B0 is estimate of Bowring aux variable */
    var Sin3_B0; /* cube of Math.sin(B0) */
    var Cos_B0; /* Math.cos(B0) */
    var Sin_p1; /* Math.sin(phi1), phi1 is estimated latitude */
    var Cos_p1; /* Math.cos(phi1) */
    var Rn; /* Earth radius at location */
    var Sum; /* numerator of Math.cos(phi1) */
    var At_Pole; /* indicates location is in polar region */

    X = parseFloat(X); // cast from string to float
    Y = parseFloat(Y);
    Z = parseFloat(Z);

    At_Pole = false;
    if (X !== 0.0) {
      Longitude = Math.atan2(Y, X);
    }
    else {
      if (Y > 0) {
        Longitude = HALF_PI;
      }
      else if (Y < 0) {
        Longitude = -HALF_PI;
      }
      else {
        At_Pole = true;
        Longitude = 0.0;
        if (Z > 0.0) { /* north pole */
          Latitude = HALF_PI;
        }
        else if (Z < 0.0) { /* south pole */
          Latitude = -HALF_PI;
        }
        else { /* center of earth */
          Latitude = HALF_PI;
          Height = -this.b;
          return;
        }
      }
    }
    W2 = X * X + Y * Y;
    W = Math.sqrt(W2);
    T0 = Z * AD_C;
    S0 = Math.sqrt(T0 * T0 + W2);
    Sin_B0 = T0 / S0;
    Cos_B0 = W / S0;
    Sin3_B0 = Sin_B0 * Sin_B0 * Sin_B0;
    T1 = Z + this.b * this.ep2 * Sin3_B0;
    Sum = W - this.a * this.es * Cos_B0 * Cos_B0 * Cos_B0;
    S1 = Math.sqrt(T1 * T1 + Sum * Sum);
    Sin_p1 = T1 / S1;
    Cos_p1 = Sum / S1;
    Rn = this.a / Math.sqrt(1.0 - this.es * Sin_p1 * Sin_p1);
    if (Cos_p1 >= COS_67P5) {
      Height = W / Cos_p1 - Rn;
    }
    else if (Cos_p1 <= -COS_67P5) {
      Height = W / -Cos_p1 - Rn;
    }
    else {
      Height = Z / Sin_p1 + Rn * (this.es - 1.0);
    }
    if (At_Pole === false) {
      Latitude = Math.atan(Sin_p1 / Cos_p1);
    }

    p.x = Longitude;
    p.y = Latitude;
    p.z = Height;
    return p;
  }, // geocentric_to_geodetic_noniter()

  /****************************************************************/
  // pj_geocentic_to_wgs84( p )
  //  p = point to transform in geocentric coordinates (x,y,z)
  geocentric_to_wgs84: function(p) {

    if (this.datum_type === PJD_3PARAM) {
      // if( x[io] === HUGE_VAL )
      //    continue;
      p.x += this.datum_params[0];
      p.y += this.datum_params[1];
      p.z += this.datum_params[2];

    }
    else if (this.datum_type === PJD_7PARAM) {
      var Dx_BF = this.datum_params[0];
      var Dy_BF = this.datum_params[1];
      var Dz_BF = this.datum_params[2];
      var Rx_BF = this.datum_params[3];
      var Ry_BF = this.datum_params[4];
      var Rz_BF = this.datum_params[5];
      var M_BF = this.datum_params[6];
      // if( x[io] === HUGE_VAL )
      //    continue;
      var x_out = M_BF * (p.x - Rz_BF * p.y + Ry_BF * p.z) + Dx_BF;
      var y_out = M_BF * (Rz_BF * p.x + p.y - Rx_BF * p.z) + Dy_BF;
      var z_out = M_BF * (-Ry_BF * p.x + Rx_BF * p.y + p.z) + Dz_BF;
      p.x = x_out;
      p.y = y_out;
      p.z = z_out;
    }
  }, // cs_geocentric_to_wgs84

  /****************************************************************/
  // pj_geocentic_from_wgs84()
  //  coordinate system definition,
  //  point to transform in geocentric coordinates (x,y,z)
  geocentric_from_wgs84: function(p) {

    if (this.datum_type === PJD_3PARAM) {
      //if( x[io] === HUGE_VAL )
      //    continue;
      p.x -= this.datum_params[0];
      p.y -= this.datum_params[1];
      p.z -= this.datum_params[2];

    }
    else if (this.datum_type === PJD_7PARAM) {
      var Dx_BF = this.datum_params[0];
      var Dy_BF = this.datum_params[1];
      var Dz_BF = this.datum_params[2];
      var Rx_BF = this.datum_params[3];
      var Ry_BF = this.datum_params[4];
      var Rz_BF = this.datum_params[5];
      var M_BF = this.datum_params[6];
      var x_tmp = (p.x - Dx_BF) / M_BF;
      var y_tmp = (p.y - Dy_BF) / M_BF;
      var z_tmp = (p.z - Dz_BF) / M_BF;
      //if( x[io] === HUGE_VAL )
      //    continue;

      p.x = x_tmp + Rz_BF * y_tmp - Ry_BF * z_tmp;
      p.y = -Rz_BF * x_tmp + y_tmp + Rx_BF * z_tmp;
      p.z = Ry_BF * x_tmp - Rx_BF * y_tmp + z_tmp;
    } //cs_geocentric_from_wgs84()
  }
};

/** point object, nothing fancy, just allows values to be
    passed back and forth by reference rather than by value.
    Other point classes may be used as long as they have
    x and y properties, which will get modified in the transform method.
*/
module.exports = datum;


/***/ }),

/***/ "./node_modules/proj4/lib/datum_transform.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/datum_transform.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var PJD_GRIDSHIFT = 3;
var PJD_NODATUM = 5; // WGS84 or equivalent
var SRS_WGS84_SEMIMAJOR = 6378137; // only used in grid shift transforms
var SRS_WGS84_ESQUARED = 0.006694379990141316; //DGR: 2012-07-29
module.exports = function(source, dest, point) {
  var wp, i, l;

  function checkParams(fallback) {
    return (fallback === PJD_3PARAM || fallback === PJD_7PARAM);
  }
  // Short cut if the datums are identical.
  if (source.compare_datums(dest)) {
    return point; // in this case, zero is sucess,
    // whereas cs_compare_datums returns 1 to indicate TRUE
    // confusing, should fix this
  }

  // Explicitly skip datum transform by setting 'datum=none' as parameter for either source or dest
  if (source.datum_type === PJD_NODATUM || dest.datum_type === PJD_NODATUM) {
    return point;
  }

  //DGR: 2012-07-29 : add nadgrids support (begin)
  var src_a = source.a;
  var src_es = source.es;

  var dst_a = dest.a;
  var dst_es = dest.es;

  var fallback = source.datum_type;
  // If this datum requires grid shifts, then apply it to geodetic coordinates.
  if (fallback === PJD_GRIDSHIFT) {
    if (this.apply_gridshift(source, 0, point) === 0) {
      source.a = SRS_WGS84_SEMIMAJOR;
      source.es = SRS_WGS84_ESQUARED;
    }
    else {
      // try 3 or 7 params transformation or nothing ?
      if (!source.datum_params) {
        source.a = src_a;
        source.es = source.es;
        return point;
      }
      wp = 1;
      for (i = 0, l = source.datum_params.length; i < l; i++) {
        wp *= source.datum_params[i];
      }
      if (wp === 0) {
        source.a = src_a;
        source.es = source.es;
        return point;
      }
      if (source.datum_params.length > 3) {
        fallback = PJD_7PARAM;
      }
      else {
        fallback = PJD_3PARAM;
      }
    }
  }
  if (dest.datum_type === PJD_GRIDSHIFT) {
    dest.a = SRS_WGS84_SEMIMAJOR;
    dest.es = SRS_WGS84_ESQUARED;
  }
  // Do we need to go through geocentric coordinates?
  if (source.es !== dest.es || source.a !== dest.a || checkParams(fallback) || checkParams(dest.datum_type)) {
    //DGR: 2012-07-29 : add nadgrids support (end)
    // Convert to geocentric coordinates.
    source.geodetic_to_geocentric(point);
    // CHECK_RETURN;
    // Convert between datums
    if (checkParams(source.datum_type)) {
      source.geocentric_to_wgs84(point);
      // CHECK_RETURN;
    }
    if (checkParams(dest.datum_type)) {
      dest.geocentric_from_wgs84(point);
      // CHECK_RETURN;
    }
    // Convert back to geodetic coordinates
    dest.geocentric_to_geodetic(point);
    // CHECK_RETURN;
  }
  // Apply grid shift to destination if required
  if (dest.datum_type === PJD_GRIDSHIFT) {
    this.apply_gridshift(dest, 1, point);
    // CHECK_RETURN;
  }

  source.a = src_a;
  source.es = src_es;
  dest.a = dst_a;
  dest.es = dst_es;

  return point;
};



/***/ }),

/***/ "./node_modules/proj4/lib/defs.js":
/*!****************************************!*\
  !*** ./node_modules/proj4/lib/defs.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var globals = __webpack_require__(/*! ./global */ "./node_modules/proj4/lib/global.js");
var parseProj = __webpack_require__(/*! ./projString */ "./node_modules/proj4/lib/projString.js");
var wkt = __webpack_require__(/*! ./wkt */ "./node_modules/proj4/lib/wkt.js");

function defs(name) {
  /*global console*/
  var that = this;
  if (arguments.length === 2) {
    var def = arguments[1];
    if (typeof def === 'string') {
      if (def.charAt(0) === '+') {
        defs[name] = parseProj(arguments[1]);
      }
      else {
        defs[name] = wkt(arguments[1]);
      }
    } else {
      defs[name] = def;
    }
  }
  else if (arguments.length === 1) {
    if (Array.isArray(name)) {
      return name.map(function(v) {
        if (Array.isArray(v)) {
          defs.apply(that, v);
        }
        else {
          defs(v);
        }
      });
    }
    else if (typeof name === 'string') {
      if (name in defs) {
        return defs[name];
      }
    }
    else if ('EPSG' in name) {
      defs['EPSG:' + name.EPSG] = name;
    }
    else if ('ESRI' in name) {
      defs['ESRI:' + name.ESRI] = name;
    }
    else if ('IAU2000' in name) {
      defs['IAU2000:' + name.IAU2000] = name;
    }
    else {
      console.log(name);
    }
    return;
  }


}
globals(defs);
module.exports = defs;


/***/ }),

/***/ "./node_modules/proj4/lib/deriveConstants.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/deriveConstants.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Datum = __webpack_require__(/*! ./constants/Datum */ "./node_modules/proj4/lib/constants/Datum.js");
var Ellipsoid = __webpack_require__(/*! ./constants/Ellipsoid */ "./node_modules/proj4/lib/constants/Ellipsoid.js");
var extend = __webpack_require__(/*! ./extend */ "./node_modules/proj4/lib/extend.js");
var datum = __webpack_require__(/*! ./datum */ "./node_modules/proj4/lib/datum.js");
var EPSLN = 1.0e-10;
// ellipoid pj_set_ell.c
var SIXTH = 0.1666666666666666667;
/* 1/6 */
var RA4 = 0.04722222222222222222;
/* 17/360 */
var RA6 = 0.02215608465608465608;
module.exports = function(json) {
  // DGR 2011-03-20 : nagrids -> nadgrids
  if (json.datumCode && json.datumCode !== 'none') {
    var datumDef = Datum[json.datumCode];
    if (datumDef) {
      json.datum_params = datumDef.towgs84 ? datumDef.towgs84.split(',') : null;
      json.ellps = datumDef.ellipse;
      json.datumName = datumDef.datumName ? datumDef.datumName : json.datumCode;
    }
  }
  if (!json.a) { // do we have an ellipsoid?
    var ellipse = Ellipsoid[json.ellps] ? Ellipsoid[json.ellps] : Ellipsoid.WGS84;
    extend(json, ellipse);
  }
  if (json.rf && !json.b) {
    json.b = (1.0 - 1.0 / json.rf) * json.a;
  }
  if (json.rf === 0 || Math.abs(json.a - json.b) < EPSLN) {
    json.sphere = true;
    json.b = json.a;
  }
  json.a2 = json.a * json.a; // used in geocentric
  json.b2 = json.b * json.b; // used in geocentric
  json.es = (json.a2 - json.b2) / json.a2; // e ^ 2
  json.e = Math.sqrt(json.es); // eccentricity
  if (json.R_A) {
    json.a *= 1 - json.es * (SIXTH + json.es * (RA4 + json.es * RA6));
    json.a2 = json.a * json.a;
    json.b2 = json.b * json.b;
    json.es = 0;
  }
  json.ep2 = (json.a2 - json.b2) / json.b2; // used in geocentric
  if (!json.k0) {
    json.k0 = 1.0; //default value
  }
  //DGR 2010-11-12: axis
  if (!json.axis) {
    json.axis = "enu";
  }

  if (!json.datum) {
    json.datum = datum(json);
  }
  return json;
};


/***/ }),

/***/ "./node_modules/proj4/lib/extend.js":
/*!******************************************!*\
  !*** ./node_modules/proj4/lib/extend.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(destination, source) {
  destination = destination || {};
  var value, property;
  if (!source) {
    return destination;
  }
  for (property in source) {
    value = source[property];
    if (value !== undefined) {
      destination[property] = value;
    }
  }
  return destination;
};


/***/ }),

/***/ "./node_modules/proj4/lib/global.js":
/*!******************************************!*\
  !*** ./node_modules/proj4/lib/global.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(defs) {
  defs('EPSG:4326', "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees");
  defs('EPSG:4269', "+title=NAD83 (long/lat) +proj=longlat +a=6378137.0 +b=6356752.31414036 +ellps=GRS80 +datum=NAD83 +units=degrees");
  defs('EPSG:3857', "+title=WGS 84 / Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +no_defs");

  defs.WGS84 = defs['EPSG:4326'];
  defs['EPSG:3785'] = defs['EPSG:3857']; // maintain backward compat, official code is 3857
  defs.GOOGLE = defs['EPSG:3857'];
  defs['EPSG:900913'] = defs['EPSG:3857'];
  defs['EPSG:102113'] = defs['EPSG:3857'];
};


/***/ }),

/***/ "./node_modules/proj4/lib/includedProjections.js":
/*!*******************************************************!*\
  !*** ./node_modules/proj4/lib/includedProjections.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var projs = [
  __webpack_require__(/*! ./projections/tmerc */ "./node_modules/proj4/lib/projections/tmerc.js"),
  __webpack_require__(/*! ./projections/utm */ "./node_modules/proj4/lib/projections/utm.js"),
  __webpack_require__(/*! ./projections/sterea */ "./node_modules/proj4/lib/projections/sterea.js"),
  __webpack_require__(/*! ./projections/stere */ "./node_modules/proj4/lib/projections/stere.js"),
  __webpack_require__(/*! ./projections/somerc */ "./node_modules/proj4/lib/projections/somerc.js"),
  __webpack_require__(/*! ./projections/omerc */ "./node_modules/proj4/lib/projections/omerc.js"),
  __webpack_require__(/*! ./projections/lcc */ "./node_modules/proj4/lib/projections/lcc.js"),
  __webpack_require__(/*! ./projections/krovak */ "./node_modules/proj4/lib/projections/krovak.js"),
  __webpack_require__(/*! ./projections/cass */ "./node_modules/proj4/lib/projections/cass.js"),
  __webpack_require__(/*! ./projections/laea */ "./node_modules/proj4/lib/projections/laea.js"),
  __webpack_require__(/*! ./projections/aea */ "./node_modules/proj4/lib/projections/aea.js"),
  __webpack_require__(/*! ./projections/gnom */ "./node_modules/proj4/lib/projections/gnom.js"),
  __webpack_require__(/*! ./projections/cea */ "./node_modules/proj4/lib/projections/cea.js"),
  __webpack_require__(/*! ./projections/eqc */ "./node_modules/proj4/lib/projections/eqc.js"),
  __webpack_require__(/*! ./projections/poly */ "./node_modules/proj4/lib/projections/poly.js"),
  __webpack_require__(/*! ./projections/nzmg */ "./node_modules/proj4/lib/projections/nzmg.js"),
  __webpack_require__(/*! ./projections/mill */ "./node_modules/proj4/lib/projections/mill.js"),
  __webpack_require__(/*! ./projections/sinu */ "./node_modules/proj4/lib/projections/sinu.js"),
  __webpack_require__(/*! ./projections/moll */ "./node_modules/proj4/lib/projections/moll.js"),
  __webpack_require__(/*! ./projections/eqdc */ "./node_modules/proj4/lib/projections/eqdc.js"),
  __webpack_require__(/*! ./projections/vandg */ "./node_modules/proj4/lib/projections/vandg.js"),
  __webpack_require__(/*! ./projections/aeqd */ "./node_modules/proj4/lib/projections/aeqd.js")
];
module.exports = function(proj4){
  projs.forEach(function(proj){
    proj4.Proj.projections.add(proj);
  });
};

/***/ }),

/***/ "./node_modules/proj4/lib/index.js":
/*!*****************************************!*\
  !*** ./node_modules/proj4/lib/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var proj4 = __webpack_require__(/*! ./core */ "./node_modules/proj4/lib/core.js");
proj4.defaultDatum = 'WGS84'; //default datum
proj4.Proj = __webpack_require__(/*! ./Proj */ "./node_modules/proj4/lib/Proj.js");
proj4.WGS84 = new proj4.Proj('WGS84');
proj4.Point = __webpack_require__(/*! ./Point */ "./node_modules/proj4/lib/Point.js");
proj4.toPoint = __webpack_require__(/*! ./common/toPoint */ "./node_modules/proj4/lib/common/toPoint.js");
proj4.defs = __webpack_require__(/*! ./defs */ "./node_modules/proj4/lib/defs.js");
proj4.transform = __webpack_require__(/*! ./transform */ "./node_modules/proj4/lib/transform.js");
proj4.mgrs = __webpack_require__(/*! mgrs */ "./node_modules/mgrs/mgrs.js");
proj4.version = __webpack_require__(/*! ../package.json */ "./node_modules/proj4/package.json").version;
__webpack_require__(/*! ./includedProjections */ "./node_modules/proj4/lib/includedProjections.js")(proj4);
module.exports = proj4;

/***/ }),

/***/ "./node_modules/proj4/lib/parseCode.js":
/*!*********************************************!*\
  !*** ./node_modules/proj4/lib/parseCode.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var defs = __webpack_require__(/*! ./defs */ "./node_modules/proj4/lib/defs.js");
var wkt = __webpack_require__(/*! ./wkt */ "./node_modules/proj4/lib/wkt.js");
var projStr = __webpack_require__(/*! ./projString */ "./node_modules/proj4/lib/projString.js");
function testObj(code){
  return typeof code === 'string';
}
function testDef(code){
  return code in defs;
}
function testWKT(code){
  var codeWords = ['GEOGCS','GEOCCS','PROJCS','LOCAL_CS'];
  return codeWords.reduce(function(a,b){
    return a+1+code.indexOf(b);
  },0);
}
function testProj(code){
  return code[0] === '+';
}
function parse(code){
  if (testObj(code)) {
    //check to see if this is a WKT string
    if (testDef(code)) {
      return defs[code];
    }
    else if (testWKT(code)) {
      return wkt(code);
    }
    else if (testProj(code)) {
      return projStr(code);
    }
  }else{
    return code;
  }
}

module.exports = parse;

/***/ }),

/***/ "./node_modules/proj4/lib/projString.js":
/*!**********************************************!*\
  !*** ./node_modules/proj4/lib/projString.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var D2R = 0.01745329251994329577;
var PrimeMeridian = __webpack_require__(/*! ./constants/PrimeMeridian */ "./node_modules/proj4/lib/constants/PrimeMeridian.js");
var units = __webpack_require__(/*! ./constants/units */ "./node_modules/proj4/lib/constants/units.js");

module.exports = function(defData) {
  var self = {};
  var paramObj = {};
  defData.split("+").map(function(v) {
    return v.trim();
  }).filter(function(a) {
    return a;
  }).forEach(function(a) {
    var split = a.split("=");
    split.push(true);
    paramObj[split[0].toLowerCase()] = split[1];
  });
  var paramName, paramVal, paramOutname;
  var params = {
    proj: 'projName',
    datum: 'datumCode',
    rf: function(v) {
      self.rf = parseFloat(v);
    },
    lat_0: function(v) {
      self.lat0 = v * D2R;
    },
    lat_1: function(v) {
      self.lat1 = v * D2R;
    },
    lat_2: function(v) {
      self.lat2 = v * D2R;
    },
    lat_ts: function(v) {
      self.lat_ts = v * D2R;
    },
    lon_0: function(v) {
      self.long0 = v * D2R;
    },
    lon_1: function(v) {
      self.long1 = v * D2R;
    },
    lon_2: function(v) {
      self.long2 = v * D2R;
    },
    alpha: function(v) {
      self.alpha = parseFloat(v) * D2R;
    },
    lonc: function(v) {
      self.longc = v * D2R;
    },
    x_0: function(v) {
      self.x0 = parseFloat(v);
    },
    y_0: function(v) {
      self.y0 = parseFloat(v);
    },
    k_0: function(v) {
      self.k0 = parseFloat(v);
    },
    k: function(v) {
      self.k0 = parseFloat(v);
    },
    a: function(v) {
      self.a = parseFloat(v);
    },
    b: function(v) {
      self.b = parseFloat(v);
    },
    r_a: function() {
      self.R_A = true;
    },
    zone: function(v) {
      self.zone = parseInt(v, 10);
    },
    south: function() {
      self.utmSouth = true;
    },
    towgs84: function(v) {
      self.datum_params = v.split(",").map(function(a) {
        return parseFloat(a);
      });
    },
    to_meter: function(v) {
      self.to_meter = parseFloat(v);
    },
    units: function(v) {
      self.units = v;
      if (units[v]) {
        self.to_meter = units[v].to_meter;
      }
    },
    from_greenwich: function(v) {
      self.from_greenwich = v * D2R;
    },
    pm: function(v) {
      self.from_greenwich = (PrimeMeridian[v] ? PrimeMeridian[v] : parseFloat(v)) * D2R;
    },
    nadgrids: function(v) {
      if (v === '@null') {
        self.datumCode = 'none';
      }
      else {
        self.nadgrids = v;
      }
    },
    axis: function(v) {
      var legalAxis = "ewnsud";
      if (v.length === 3 && legalAxis.indexOf(v.substr(0, 1)) !== -1 && legalAxis.indexOf(v.substr(1, 1)) !== -1 && legalAxis.indexOf(v.substr(2, 1)) !== -1) {
        self.axis = v;
      }
    }
  };
  for (paramName in paramObj) {
    paramVal = paramObj[paramName];
    if (paramName in params) {
      paramOutname = params[paramName];
      if (typeof paramOutname === 'function') {
        paramOutname(paramVal);
      }
      else {
        self[paramOutname] = paramVal;
      }
    }
    else {
      self[paramName] = paramVal;
    }
  }
  if(typeof self.datumCode === 'string' && self.datumCode !== "WGS84"){
    self.datumCode = self.datumCode.toLowerCase();
  }
  return self;
};


/***/ }),

/***/ "./node_modules/proj4/lib/projections.js":
/*!***********************************************!*\
  !*** ./node_modules/proj4/lib/projections.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var projs = [
  __webpack_require__(/*! ./projections/merc */ "./node_modules/proj4/lib/projections/merc.js"),
  __webpack_require__(/*! ./projections/longlat */ "./node_modules/proj4/lib/projections/longlat.js")
];
var names = {};
var projStore = [];

function add(proj, i) {
  var len = projStore.length;
  if (!proj.names) {
    console.log(i);
    return true;
  }
  projStore[len] = proj;
  proj.names.forEach(function(n) {
    names[n.toLowerCase()] = len;
  });
  return this;
}

exports.add = add;

exports.get = function(name) {
  if (!name) {
    return false;
  }
  var n = name.toLowerCase();
  if (typeof names[n] !== 'undefined' && projStore[names[n]]) {
    return projStore[names[n]];
  }
};
exports.start = function() {
  projs.forEach(add);
};


/***/ }),

/***/ "./node_modules/proj4/lib/projections/aea.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/projections/aea.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var EPSLN = 1.0e-10;
var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var qsfnz = __webpack_require__(/*! ../common/qsfnz */ "./node_modules/proj4/lib/common/qsfnz.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");
exports.init = function() {

  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e3 = Math.sqrt(this.es);

  this.sin_po = Math.sin(this.lat1);
  this.cos_po = Math.cos(this.lat1);
  this.t1 = this.sin_po;
  this.con = this.sin_po;
  this.ms1 = msfnz(this.e3, this.sin_po, this.cos_po);
  this.qs1 = qsfnz(this.e3, this.sin_po, this.cos_po);

  this.sin_po = Math.sin(this.lat2);
  this.cos_po = Math.cos(this.lat2);
  this.t2 = this.sin_po;
  this.ms2 = msfnz(this.e3, this.sin_po, this.cos_po);
  this.qs2 = qsfnz(this.e3, this.sin_po, this.cos_po);

  this.sin_po = Math.sin(this.lat0);
  this.cos_po = Math.cos(this.lat0);
  this.t3 = this.sin_po;
  this.qs0 = qsfnz(this.e3, this.sin_po, this.cos_po);

  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
    this.ns0 = (this.ms1 * this.ms1 - this.ms2 * this.ms2) / (this.qs2 - this.qs1);
  }
  else {
    this.ns0 = this.con;
  }
  this.c = this.ms1 * this.ms1 + this.ns0 * this.qs1;
  this.rh = this.a * Math.sqrt(this.c - this.ns0 * this.qs0) / this.ns0;
};

/* Albers Conical Equal Area forward equations--mapping lat,long to x,y
  -------------------------------------------------------------------*/
exports.forward = function(p) {

  var lon = p.x;
  var lat = p.y;

  this.sin_phi = Math.sin(lat);
  this.cos_phi = Math.cos(lat);

  var qs = qsfnz(this.e3, this.sin_phi, this.cos_phi);
  var rh1 = this.a * Math.sqrt(this.c - this.ns0 * qs) / this.ns0;
  var theta = this.ns0 * adjust_lon(lon - this.long0);
  var x = rh1 * Math.sin(theta) + this.x0;
  var y = this.rh - rh1 * Math.cos(theta) + this.y0;

  p.x = x;
  p.y = y;
  return p;
};


exports.inverse = function(p) {
  var rh1, qs, con, theta, lon, lat;

  p.x -= this.x0;
  p.y = this.rh - p.y + this.y0;
  if (this.ns0 >= 0) {
    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
    con = -1;
  }
  theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p.x, con * p.y);
  }
  con = rh1 * this.ns0 / this.a;
  if (this.sphere) {
    lat = Math.asin((this.c - con * con) / (2 * this.ns0));
  }
  else {
    qs = (this.c - con * con) / this.ns0;
    lat = this.phi1z(this.e3, qs);
  }

  lon = adjust_lon(theta / this.ns0 + this.long0);
  p.x = lon;
  p.y = lat;
  return p;
};

/* Function to compute phi1, the latitude for the inverse of the
   Albers Conical Equal-Area projection.
-------------------------------------------*/
exports.phi1z = function(eccent, qs) {
  var sinphi, cosphi, con, com, dphi;
  var phi = asinz(0.5 * qs);
  if (eccent < EPSLN) {
    return phi;
  }

  var eccnts = eccent * eccent;
  for (var i = 1; i <= 25; i++) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    con = eccent * sinphi;
    com = 1 - con * con;
    dphi = 0.5 * com * com / cosphi * (qs / (1 - eccnts) - sinphi / com + 0.5 / eccent * Math.log((1 - con) / (1 + con)));
    phi = phi + dphi;
    if (Math.abs(dphi) <= 1e-7) {
      return phi;
    }
  }
  return null;
};
exports.names = ["Albers_Conic_Equal_Area", "Albers", "aea"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/aeqd.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/aeqd.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var mlfn = __webpack_require__(/*! ../common/mlfn */ "./node_modules/proj4/lib/common/mlfn.js");
var e0fn = __webpack_require__(/*! ../common/e0fn */ "./node_modules/proj4/lib/common/e0fn.js");
var e1fn = __webpack_require__(/*! ../common/e1fn */ "./node_modules/proj4/lib/common/e1fn.js");
var e2fn = __webpack_require__(/*! ../common/e2fn */ "./node_modules/proj4/lib/common/e2fn.js");
var e3fn = __webpack_require__(/*! ../common/e3fn */ "./node_modules/proj4/lib/common/e3fn.js");
var gN = __webpack_require__(/*! ../common/gN */ "./node_modules/proj4/lib/common/gN.js");
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");
var imlfn = __webpack_require__(/*! ../common/imlfn */ "./node_modules/proj4/lib/common/imlfn.js");
exports.init = function() {
  this.sin_p12 = Math.sin(this.lat0);
  this.cos_p12 = Math.cos(this.lat0);
};

exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var sinphi = Math.sin(p.y);
  var cosphi = Math.cos(p.y);
  var dlon = adjust_lon(lon - this.long0);
  var e0, e1, e2, e3, Mlp, Ml, tanphi, Nl1, Nl, psi, Az, G, H, GH, Hs, c, kp, cos_c, s, s2, s3, s4, s5;
  if (this.sphere) {
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      //North Pole case
      p.x = this.x0 + this.a * (HALF_PI - lat) * Math.sin(dlon);
      p.y = this.y0 - this.a * (HALF_PI - lat) * Math.cos(dlon);
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      //South Pole case
      p.x = this.x0 + this.a * (HALF_PI + lat) * Math.sin(dlon);
      p.y = this.y0 + this.a * (HALF_PI + lat) * Math.cos(dlon);
      return p;
    }
    else {
      //default case
      cos_c = this.sin_p12 * sinphi + this.cos_p12 * cosphi * Math.cos(dlon);
      c = Math.acos(cos_c);
      kp = c / Math.sin(c);
      p.x = this.x0 + this.a * kp * cosphi * Math.sin(dlon);
      p.y = this.y0 + this.a * kp * (this.cos_p12 * sinphi - this.sin_p12 * cosphi * Math.cos(dlon));
      return p;
    }
  }
  else {
    e0 = e0fn(this.es);
    e1 = e1fn(this.es);
    e2 = e2fn(this.es);
    e3 = e3fn(this.es);
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      //North Pole case
      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
      p.x = this.x0 + (Mlp - Ml) * Math.sin(dlon);
      p.y = this.y0 - (Mlp - Ml) * Math.cos(dlon);
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      //South Pole case
      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
      Ml = this.a * mlfn(e0, e1, e2, e3, lat);
      p.x = this.x0 + (Mlp + Ml) * Math.sin(dlon);
      p.y = this.y0 + (Mlp + Ml) * Math.cos(dlon);
      return p;
    }
    else {
      //Default case
      tanphi = sinphi / cosphi;
      Nl1 = gN(this.a, this.e, this.sin_p12);
      Nl = gN(this.a, this.e, sinphi);
      psi = Math.atan((1 - this.es) * tanphi + this.es * Nl1 * this.sin_p12 / (Nl * cosphi));
      Az = Math.atan2(Math.sin(dlon), this.cos_p12 * Math.tan(psi) - this.sin_p12 * Math.cos(dlon));
      if (Az === 0) {
        s = Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      }
      else if (Math.abs(Math.abs(Az) - Math.PI) <= EPSLN) {
        s = -Math.asin(this.cos_p12 * Math.sin(psi) - this.sin_p12 * Math.cos(psi));
      }
      else {
        s = Math.asin(Math.sin(dlon) * Math.cos(psi) / Math.sin(Az));
      }
      G = this.e * this.sin_p12 / Math.sqrt(1 - this.es);
      H = this.e * this.cos_p12 * Math.cos(Az) / Math.sqrt(1 - this.es);
      GH = G * H;
      Hs = H * H;
      s2 = s * s;
      s3 = s2 * s;
      s4 = s3 * s;
      s5 = s4 * s;
      c = Nl1 * s * (1 - s2 * Hs * (1 - Hs) / 6 + s3 / 8 * GH * (1 - 2 * Hs) + s4 / 120 * (Hs * (4 - 7 * Hs) - 3 * G * G * (1 - 7 * Hs)) - s5 / 48 * GH);
      p.x = this.x0 + c * Math.sin(Az);
      p.y = this.y0 + c * Math.cos(Az);
      return p;
    }
  }


};

exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var rh, z, sinz, cosz, lon, lat, con, e0, e1, e2, e3, Mlp, M, N1, psi, Az, cosAz, tmp, A, B, D, Ee, F;
  if (this.sphere) {
    rh = Math.sqrt(p.x * p.x + p.y * p.y);
    if (rh > (2 * HALF_PI * this.a)) {
      return;
    }
    z = rh / this.a;

    sinz = Math.sin(z);
    cosz = Math.cos(z);

    lon = this.long0;
    if (Math.abs(rh) <= EPSLN) {
      lat = this.lat0;
    }
    else {
      lat = asinz(cosz * this.sin_p12 + (p.y * sinz * this.cos_p12) / rh);
      con = Math.abs(this.lat0) - HALF_PI;
      if (Math.abs(con) <= EPSLN) {
        if (this.lat0 >= 0) {
          lon = adjust_lon(this.long0 + Math.atan2(p.x, - p.y));
        }
        else {
          lon = adjust_lon(this.long0 - Math.atan2(-p.x, p.y));
        }
      }
      else {
        /*con = cosz - this.sin_p12 * Math.sin(lat);
        if ((Math.abs(con) < EPSLN) && (Math.abs(p.x) < EPSLN)) {
          //no-op, just keep the lon value as is
        } else {
          var temp = Math.atan2((p.x * sinz * this.cos_p12), (con * rh));
          lon = adjust_lon(this.long0 + Math.atan2((p.x * sinz * this.cos_p12), (con * rh)));
        }*/
        lon = adjust_lon(this.long0 + Math.atan2(p.x * sinz, rh * this.cos_p12 * cosz - p.y * this.sin_p12 * sinz));
      }
    }

    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    e0 = e0fn(this.es);
    e1 = e1fn(this.es);
    e2 = e2fn(this.es);
    e3 = e3fn(this.es);
    if (Math.abs(this.sin_p12 - 1) <= EPSLN) {
      //North pole case
      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      M = Mlp - rh;
      lat = imlfn(M / this.a, e0, e1, e2, e3);
      lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
      p.x = lon;
      p.y = lat;
      return p;
    }
    else if (Math.abs(this.sin_p12 + 1) <= EPSLN) {
      //South pole case
      Mlp = this.a * mlfn(e0, e1, e2, e3, HALF_PI);
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      M = rh - Mlp;

      lat = imlfn(M / this.a, e0, e1, e2, e3);
      lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
      p.x = lon;
      p.y = lat;
      return p;
    }
    else {
      //default case
      rh = Math.sqrt(p.x * p.x + p.y * p.y);
      Az = Math.atan2(p.x, p.y);
      N1 = gN(this.a, this.e, this.sin_p12);
      cosAz = Math.cos(Az);
      tmp = this.e * this.cos_p12 * cosAz;
      A = -tmp * tmp / (1 - this.es);
      B = 3 * this.es * (1 - A) * this.sin_p12 * this.cos_p12 * cosAz / (1 - this.es);
      D = rh / N1;
      Ee = D - A * (1 + A) * Math.pow(D, 3) / 6 - B * (1 + 3 * A) * Math.pow(D, 4) / 24;
      F = 1 - A * Ee * Ee / 2 - D * Ee * Ee * Ee / 6;
      psi = Math.asin(this.sin_p12 * Math.cos(Ee) + this.cos_p12 * Math.sin(Ee) * cosAz);
      lon = adjust_lon(this.long0 + Math.asin(Math.sin(Az) * Math.sin(Ee) / Math.cos(psi)));
      lat = Math.atan((1 - this.es * F * this.sin_p12 / Math.sin(psi)) * Math.tan(psi) / (1 - this.es));
      p.x = lon;
      p.y = lat;
      return p;
    }
  }

};
exports.names = ["Azimuthal_Equidistant", "aeqd"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/cass.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/cass.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var mlfn = __webpack_require__(/*! ../common/mlfn */ "./node_modules/proj4/lib/common/mlfn.js");
var e0fn = __webpack_require__(/*! ../common/e0fn */ "./node_modules/proj4/lib/common/e0fn.js");
var e1fn = __webpack_require__(/*! ../common/e1fn */ "./node_modules/proj4/lib/common/e1fn.js");
var e2fn = __webpack_require__(/*! ../common/e2fn */ "./node_modules/proj4/lib/common/e2fn.js");
var e3fn = __webpack_require__(/*! ../common/e3fn */ "./node_modules/proj4/lib/common/e3fn.js");
var gN = __webpack_require__(/*! ../common/gN */ "./node_modules/proj4/lib/common/gN.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var adjust_lat = __webpack_require__(/*! ../common/adjust_lat */ "./node_modules/proj4/lib/common/adjust_lat.js");
var imlfn = __webpack_require__(/*! ../common/imlfn */ "./node_modules/proj4/lib/common/imlfn.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
exports.init = function() {
  if (!this.sphere) {
    this.e0 = e0fn(this.es);
    this.e1 = e1fn(this.es);
    this.e2 = e2fn(this.es);
    this.e3 = e3fn(this.es);
    this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
  }
};



/* Cassini forward equations--mapping lat,long to x,y
  -----------------------------------------------------------------------*/
exports.forward = function(p) {

  /* Forward equations
      -----------------*/
  var x, y;
  var lam = p.x;
  var phi = p.y;
  lam = adjust_lon(lam - this.long0);

  if (this.sphere) {
    x = this.a * Math.asin(Math.cos(phi) * Math.sin(lam));
    y = this.a * (Math.atan2(Math.tan(phi), Math.cos(lam)) - this.lat0);
  }
  else {
    //ellipsoid
    var sinphi = Math.sin(phi);
    var cosphi = Math.cos(phi);
    var nl = gN(this.a, this.e, sinphi);
    var tl = Math.tan(phi) * Math.tan(phi);
    var al = lam * Math.cos(phi);
    var asq = al * al;
    var cl = this.es * cosphi * cosphi / (1 - this.es);
    var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);

    x = nl * al * (1 - asq * tl * (1 / 6 - (8 - tl + 8 * cl) * asq / 120));
    y = ml - this.ml0 + nl * sinphi / cosphi * asq * (0.5 + (5 - tl + 6 * cl) * asq / 24);


  }

  p.x = x + this.x0;
  p.y = y + this.y0;
  return p;
};

/* Inverse equations
  -----------------*/
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var x = p.x / this.a;
  var y = p.y / this.a;
  var phi, lam;

  if (this.sphere) {
    var dd = y + this.lat0;
    phi = Math.asin(Math.sin(dd) * Math.cos(x));
    lam = Math.atan2(Math.tan(x), Math.cos(dd));
  }
  else {
    /* ellipsoid */
    var ml1 = this.ml0 / this.a + y;
    var phi1 = imlfn(ml1, this.e0, this.e1, this.e2, this.e3);
    if (Math.abs(Math.abs(phi1) - HALF_PI) <= EPSLN) {
      p.x = this.long0;
      p.y = HALF_PI;
      if (y < 0) {
        p.y *= -1;
      }
      return p;
    }
    var nl1 = gN(this.a, this.e, Math.sin(phi1));

    var rl1 = nl1 * nl1 * nl1 / this.a / this.a * (1 - this.es);
    var tl1 = Math.pow(Math.tan(phi1), 2);
    var dl = x * this.a / nl1;
    var dsq = dl * dl;
    phi = phi1 - nl1 * Math.tan(phi1) / rl1 * dl * dl * (0.5 - (1 + 3 * tl1) * dl * dl / 24);
    lam = dl * (1 - dsq * (tl1 / 3 + (1 + 3 * tl1) * tl1 * dsq / 15)) / Math.cos(phi1);

  }

  p.x = adjust_lon(lam + this.long0);
  p.y = adjust_lat(phi);
  return p;

};
exports.names = ["Cassini", "Cassini_Soldner", "cass"];

/***/ }),

/***/ "./node_modules/proj4/lib/projections/cea.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/projections/cea.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var qsfnz = __webpack_require__(/*! ../common/qsfnz */ "./node_modules/proj4/lib/common/qsfnz.js");
var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var iqsfnz = __webpack_require__(/*! ../common/iqsfnz */ "./node_modules/proj4/lib/common/iqsfnz.js");
/*
  reference:  
    "Cartographic Projection Procedures for the UNIX Environment-
    A User's Manual" by Gerald I. Evenden,
    USGS Open File Report 90-284and Release 4 Interim Reports (2003)
*/
exports.init = function() {
  //no-op
  if (!this.sphere) {
    this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
  }
};


/* Cylindrical Equal Area forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var x, y;
  /* Forward equations
      -----------------*/
  var dlon = adjust_lon(lon - this.long0);
  if (this.sphere) {
    x = this.x0 + this.a * dlon * Math.cos(this.lat_ts);
    y = this.y0 + this.a * Math.sin(lat) / Math.cos(this.lat_ts);
  }
  else {
    var qs = qsfnz(this.e, Math.sin(lat));
    x = this.x0 + this.a * this.k0 * dlon;
    y = this.y0 + this.a * qs * 0.5 / this.k0;
  }

  p.x = x;
  p.y = y;
  return p;
};

/* Cylindrical Equal Area inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var lon, lat;

  if (this.sphere) {
    lon = adjust_lon(this.long0 + (p.x / this.a) / Math.cos(this.lat_ts));
    lat = Math.asin((p.y / this.a) * Math.cos(this.lat_ts));
  }
  else {
    lat = iqsfnz(this.e, 2 * p.y * this.k0 / this.a);
    lon = adjust_lon(this.long0 + p.x / (this.a * this.k0));
  }

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["cea"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/eqc.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/projections/eqc.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var adjust_lat = __webpack_require__(/*! ../common/adjust_lat */ "./node_modules/proj4/lib/common/adjust_lat.js");
exports.init = function() {

  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  this.lat0 = this.lat0 || 0;
  this.long0 = this.long0 || 0;
  this.lat_ts = this.lat_ts || 0;
  this.title = this.title || "Equidistant Cylindrical (Plate Carre)";

  this.rc = Math.cos(this.lat_ts);
};


// forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
exports.forward = function(p) {

  var lon = p.x;
  var lat = p.y;

  var dlon = adjust_lon(lon - this.long0);
  var dlat = adjust_lat(lat - this.lat0);
  p.x = this.x0 + (this.a * dlon * this.rc);
  p.y = this.y0 + (this.a * dlat);
  return p;
};

// inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
exports.inverse = function(p) {

  var x = p.x;
  var y = p.y;

  p.x = adjust_lon(this.long0 + ((x - this.x0) / (this.a * this.rc)));
  p.y = adjust_lat(this.lat0 + ((y - this.y0) / (this.a)));
  return p;
};
exports.names = ["Equirectangular", "Equidistant_Cylindrical", "eqc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/eqdc.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/eqdc.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var e0fn = __webpack_require__(/*! ../common/e0fn */ "./node_modules/proj4/lib/common/e0fn.js");
var e1fn = __webpack_require__(/*! ../common/e1fn */ "./node_modules/proj4/lib/common/e1fn.js");
var e2fn = __webpack_require__(/*! ../common/e2fn */ "./node_modules/proj4/lib/common/e2fn.js");
var e3fn = __webpack_require__(/*! ../common/e3fn */ "./node_modules/proj4/lib/common/e3fn.js");
var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var mlfn = __webpack_require__(/*! ../common/mlfn */ "./node_modules/proj4/lib/common/mlfn.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var adjust_lat = __webpack_require__(/*! ../common/adjust_lat */ "./node_modules/proj4/lib/common/adjust_lat.js");
var imlfn = __webpack_require__(/*! ../common/imlfn */ "./node_modules/proj4/lib/common/imlfn.js");
var EPSLN = 1.0e-10;
exports.init = function() {

  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  // Standard Parallels cannot be equal and on opposite sides of the equator
  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }
  this.lat2 = this.lat2 || this.lat1;
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2);
  this.e = Math.sqrt(this.es);
  this.e0 = e0fn(this.es);
  this.e1 = e1fn(this.es);
  this.e2 = e2fn(this.es);
  this.e3 = e3fn(this.es);

  this.sinphi = Math.sin(this.lat1);
  this.cosphi = Math.cos(this.lat1);

  this.ms1 = msfnz(this.e, this.sinphi, this.cosphi);
  this.ml1 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat1);

  if (Math.abs(this.lat1 - this.lat2) < EPSLN) {
    this.ns = this.sinphi;
  }
  else {
    this.sinphi = Math.sin(this.lat2);
    this.cosphi = Math.cos(this.lat2);
    this.ms2 = msfnz(this.e, this.sinphi, this.cosphi);
    this.ml2 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat2);
    this.ns = (this.ms1 - this.ms2) / (this.ml2 - this.ml1);
  }
  this.g = this.ml1 + this.ms1 / this.ns;
  this.ml0 = mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
  this.rh = this.a * (this.g - this.ml0);
};


/* Equidistant Conic forward equations--mapping lat,long to x,y
  -----------------------------------------------------------*/
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var rh1;

  /* Forward equations
      -----------------*/
  if (this.sphere) {
    rh1 = this.a * (this.g - lat);
  }
  else {
    var ml = mlfn(this.e0, this.e1, this.e2, this.e3, lat);
    rh1 = this.a * (this.g - ml);
  }
  var theta = this.ns * adjust_lon(lon - this.long0);
  var x = this.x0 + rh1 * Math.sin(theta);
  var y = this.y0 + this.rh - rh1 * Math.cos(theta);
  p.x = x;
  p.y = y;
  return p;
};

/* Inverse equations
  -----------------*/
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y = this.rh - p.y + this.y0;
  var con, rh1, lat, lon;
  if (this.ns >= 0) {
    rh1 = Math.sqrt(p.x * p.x + p.y * p.y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(p.x * p.x + p.y * p.y);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2(con * p.x, con * p.y);
  }

  if (this.sphere) {
    lon = adjust_lon(this.long0 + theta / this.ns);
    lat = adjust_lat(this.g - rh1 / this.a);
    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    var ml = this.g - rh1 / this.a;
    lat = imlfn(ml, this.e0, this.e1, this.e2, this.e3);
    lon = adjust_lon(this.long0 + theta / this.ns);
    p.x = lon;
    p.y = lat;
    return p;
  }

};
exports.names = ["Equidistant_Conic", "eqdc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/gauss.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/gauss.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var FORTPI = Math.PI/4;
var srat = __webpack_require__(/*! ../common/srat */ "./node_modules/proj4/lib/common/srat.js");
var HALF_PI = Math.PI/2;
var MAX_ITER = 20;
exports.init = function() {
  var sphi = Math.sin(this.lat0);
  var cphi = Math.cos(this.lat0);
  cphi *= cphi;
  this.rc = Math.sqrt(1 - this.es) / (1 - this.es * sphi * sphi);
  this.C = Math.sqrt(1 + this.es * cphi * cphi / (1 - this.es));
  this.phic0 = Math.asin(sphi / this.C);
  this.ratexp = 0.5 * this.C * this.e;
  this.K = Math.tan(0.5 * this.phic0 + FORTPI) / (Math.pow(Math.tan(0.5 * this.lat0 + FORTPI), this.C) * srat(this.e * sphi, this.ratexp));
};

exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;

  p.y = 2 * Math.atan(this.K * Math.pow(Math.tan(0.5 * lat + FORTPI), this.C) * srat(this.e * Math.sin(lat), this.ratexp)) - HALF_PI;
  p.x = this.C * lon;
  return p;
};

exports.inverse = function(p) {
  var DEL_TOL = 1e-14;
  var lon = p.x / this.C;
  var lat = p.y;
  var num = Math.pow(Math.tan(0.5 * lat + FORTPI) / this.K, 1 / this.C);
  for (var i = MAX_ITER; i > 0; --i) {
    lat = 2 * Math.atan(num * srat(this.e * Math.sin(p.y), - 0.5 * this.e)) - HALF_PI;
    if (Math.abs(lat - p.y) < DEL_TOL) {
      break;
    }
    p.y = lat;
  }
  /* convergence failed */
  if (!i) {
    return null;
  }
  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["gauss"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/gnom.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/gnom.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var EPSLN = 1.0e-10;
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");

/*
  reference:
    Wolfram Mathworld "Gnomonic Projection"
    http://mathworld.wolfram.com/GnomonicProjection.html
    Accessed: 12th November 2009
  */
exports.init = function() {

  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  this.sin_p14 = Math.sin(this.lat0);
  this.cos_p14 = Math.cos(this.lat0);
  // Approximation for projecting points to the horizon (infinity)
  this.infinity_dist = 1000 * this.a;
  this.rc = 1;
};


/* Gnomonic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
exports.forward = function(p) {
  var sinphi, cosphi; /* sin and cos value        */
  var dlon; /* delta longitude value      */
  var coslon; /* cos of longitude        */
  var ksp; /* scale factor          */
  var g;
  var x, y;
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
      -----------------*/
  dlon = adjust_lon(lon - this.long0);

  sinphi = Math.sin(lat);
  cosphi = Math.cos(lat);

  coslon = Math.cos(dlon);
  g = this.sin_p14 * sinphi + this.cos_p14 * cosphi * coslon;
  ksp = 1;
  if ((g > 0) || (Math.abs(g) <= EPSLN)) {
    x = this.x0 + this.a * ksp * cosphi * Math.sin(dlon) / g;
    y = this.y0 + this.a * ksp * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon) / g;
  }
  else {

    // Point is in the opposing hemisphere and is unprojectable
    // We still need to return a reasonable point, so we project 
    // to infinity, on a bearing 
    // equivalent to the northern hemisphere equivalent
    // This is a reasonable approximation for short shapes and lines that 
    // straddle the horizon.

    x = this.x0 + this.infinity_dist * cosphi * Math.sin(dlon);
    y = this.y0 + this.infinity_dist * (this.cos_p14 * sinphi - this.sin_p14 * cosphi * coslon);

  }
  p.x = x;
  p.y = y;
  return p;
};


exports.inverse = function(p) {
  var rh; /* Rho */
  var sinc, cosc;
  var c;
  var lon, lat;

  /* Inverse equations
      -----------------*/
  p.x = (p.x - this.x0) / this.a;
  p.y = (p.y - this.y0) / this.a;

  p.x /= this.k0;
  p.y /= this.k0;

  if ((rh = Math.sqrt(p.x * p.x + p.y * p.y))) {
    c = Math.atan2(rh, this.rc);
    sinc = Math.sin(c);
    cosc = Math.cos(c);

    lat = asinz(cosc * this.sin_p14 + (p.y * sinc * this.cos_p14) / rh);
    lon = Math.atan2(p.x * sinc, rh * this.cos_p14 * cosc - p.y * this.sin_p14 * sinc);
    lon = adjust_lon(this.long0 + lon);
  }
  else {
    lat = this.phic0;
    lon = 0;
  }

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["gnom"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/krovak.js":
/*!******************************************************!*\
  !*** ./node_modules/proj4/lib/projections/krovak.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
exports.init = function() {
  this.a = 6377397.155;
  this.es = 0.006674372230614;
  this.e = Math.sqrt(this.es);
  if (!this.lat0) {
    this.lat0 = 0.863937979737193;
  }
  if (!this.long0) {
    this.long0 = 0.7417649320975901 - 0.308341501185665;
  }
  /* if scale not set default to 0.9999 */
  if (!this.k0) {
    this.k0 = 0.9999;
  }
  this.s45 = 0.785398163397448; /* 45 */
  this.s90 = 2 * this.s45;
  this.fi0 = this.lat0;
  this.e2 = this.es;
  this.e = Math.sqrt(this.e2);
  this.alfa = Math.sqrt(1 + (this.e2 * Math.pow(Math.cos(this.fi0), 4)) / (1 - this.e2));
  this.uq = 1.04216856380474;
  this.u0 = Math.asin(Math.sin(this.fi0) / this.alfa);
  this.g = Math.pow((1 + this.e * Math.sin(this.fi0)) / (1 - this.e * Math.sin(this.fi0)), this.alfa * this.e / 2);
  this.k = Math.tan(this.u0 / 2 + this.s45) / Math.pow(Math.tan(this.fi0 / 2 + this.s45), this.alfa) * this.g;
  this.k1 = this.k0;
  this.n0 = this.a * Math.sqrt(1 - this.e2) / (1 - this.e2 * Math.pow(Math.sin(this.fi0), 2));
  this.s0 = 1.37008346281555;
  this.n = Math.sin(this.s0);
  this.ro0 = this.k1 * this.n0 / Math.tan(this.s0);
  this.ad = this.s90 - this.uq;
};

/* ellipsoid */
/* calculate xy from lat/lon */
/* Constants, identical to inverse transform function */
exports.forward = function(p) {
  var gfi, u, deltav, s, d, eps, ro;
  var lon = p.x;
  var lat = p.y;
  var delta_lon = adjust_lon(lon - this.long0);
  /* Transformation */
  gfi = Math.pow(((1 + this.e * Math.sin(lat)) / (1 - this.e * Math.sin(lat))), (this.alfa * this.e / 2));
  u = 2 * (Math.atan(this.k * Math.pow(Math.tan(lat / 2 + this.s45), this.alfa) / gfi) - this.s45);
  deltav = -delta_lon * this.alfa;
  s = Math.asin(Math.cos(this.ad) * Math.sin(u) + Math.sin(this.ad) * Math.cos(u) * Math.cos(deltav));
  d = Math.asin(Math.cos(u) * Math.sin(deltav) / Math.cos(s));
  eps = this.n * d;
  ro = this.ro0 * Math.pow(Math.tan(this.s0 / 2 + this.s45), this.n) / Math.pow(Math.tan(s / 2 + this.s45), this.n);
  p.y = ro * Math.cos(eps) / 1;
  p.x = ro * Math.sin(eps) / 1;

  if (!this.czech) {
    p.y *= -1;
    p.x *= -1;
  }
  return (p);
};

/* calculate lat/lon from xy */
exports.inverse = function(p) {
  var u, deltav, s, d, eps, ro, fi1;
  var ok;

  /* Transformation */
  /* revert y, x*/
  var tmp = p.x;
  p.x = p.y;
  p.y = tmp;
  if (!this.czech) {
    p.y *= -1;
    p.x *= -1;
  }
  ro = Math.sqrt(p.x * p.x + p.y * p.y);
  eps = Math.atan2(p.y, p.x);
  d = eps / Math.sin(this.s0);
  s = 2 * (Math.atan(Math.pow(this.ro0 / ro, 1 / this.n) * Math.tan(this.s0 / 2 + this.s45)) - this.s45);
  u = Math.asin(Math.cos(this.ad) * Math.sin(s) - Math.sin(this.ad) * Math.cos(s) * Math.cos(d));
  deltav = Math.asin(Math.cos(s) * Math.sin(d) / Math.cos(u));
  p.x = this.long0 - deltav / this.alfa;
  fi1 = u;
  ok = 0;
  var iter = 0;
  do {
    p.y = 2 * (Math.atan(Math.pow(this.k, - 1 / this.alfa) * Math.pow(Math.tan(u / 2 + this.s45), 1 / this.alfa) * Math.pow((1 + this.e * Math.sin(fi1)) / (1 - this.e * Math.sin(fi1)), this.e / 2)) - this.s45);
    if (Math.abs(fi1 - p.y) < 0.0000000001) {
      ok = 1;
    }
    fi1 = p.y;
    iter += 1;
  } while (ok === 0 && iter < 15);
  if (iter >= 15) {
    return null;
  }

  return (p);
};
exports.names = ["Krovak", "krovak"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/laea.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/laea.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var HALF_PI = Math.PI/2;
var FORTPI = Math.PI/4;
var EPSLN = 1.0e-10;
var qsfnz = __webpack_require__(/*! ../common/qsfnz */ "./node_modules/proj4/lib/common/qsfnz.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
/*
  reference
    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
  */

exports.S_POLE = 1;
exports.N_POLE = 2;
exports.EQUIT = 3;
exports.OBLIQ = 4;


/* Initialize the Lambert Azimuthal Equal Area projection
  ------------------------------------------------------*/
exports.init = function() {
  var t = Math.abs(this.lat0);
  if (Math.abs(t - HALF_PI) < EPSLN) {
    this.mode = this.lat0 < 0 ? this.S_POLE : this.N_POLE;
  }
  else if (Math.abs(t) < EPSLN) {
    this.mode = this.EQUIT;
  }
  else {
    this.mode = this.OBLIQ;
  }
  if (this.es > 0) {
    var sinphi;

    this.qp = qsfnz(this.e, 1);
    this.mmf = 0.5 / (1 - this.es);
    this.apa = this.authset(this.es);
    switch (this.mode) {
    case this.N_POLE:
      this.dd = 1;
      break;
    case this.S_POLE:
      this.dd = 1;
      break;
    case this.EQUIT:
      this.rq = Math.sqrt(0.5 * this.qp);
      this.dd = 1 / this.rq;
      this.xmf = 1;
      this.ymf = 0.5 * this.qp;
      break;
    case this.OBLIQ:
      this.rq = Math.sqrt(0.5 * this.qp);
      sinphi = Math.sin(this.lat0);
      this.sinb1 = qsfnz(this.e, sinphi) / this.qp;
      this.cosb1 = Math.sqrt(1 - this.sinb1 * this.sinb1);
      this.dd = Math.cos(this.lat0) / (Math.sqrt(1 - this.es * sinphi * sinphi) * this.rq * this.cosb1);
      this.ymf = (this.xmf = this.rq) / this.dd;
      this.xmf *= this.dd;
      break;
    }
  }
  else {
    if (this.mode === this.OBLIQ) {
      this.sinph0 = Math.sin(this.lat0);
      this.cosph0 = Math.cos(this.lat0);
    }
  }
};

/* Lambert Azimuthal Equal Area forward equations--mapping lat,long to x,y
  -----------------------------------------------------------------------*/
exports.forward = function(p) {

  /* Forward equations
      -----------------*/
  var x, y, coslam, sinlam, sinphi, q, sinb, cosb, b, cosphi;
  var lam = p.x;
  var phi = p.y;

  lam = adjust_lon(lam - this.long0);

  if (this.sphere) {
    sinphi = Math.sin(phi);
    cosphi = Math.cos(phi);
    coslam = Math.cos(lam);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      y = (this.mode === this.EQUIT) ? 1 + cosphi * coslam : 1 + this.sinph0 * sinphi + this.cosph0 * cosphi * coslam;
      if (y <= EPSLN) {
        return null;
      }
      y = Math.sqrt(2 / y);
      x = y * cosphi * Math.sin(lam);
      y *= (this.mode === this.EQUIT) ? sinphi : this.cosph0 * sinphi - this.sinph0 * cosphi * coslam;
    }
    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        coslam = -coslam;
      }
      if (Math.abs(phi + this.phi0) < EPSLN) {
        return null;
      }
      y = FORTPI - phi * 0.5;
      y = 2 * ((this.mode === this.S_POLE) ? Math.cos(y) : Math.sin(y));
      x = y * Math.sin(lam);
      y *= coslam;
    }
  }
  else {
    sinb = 0;
    cosb = 0;
    b = 0;
    coslam = Math.cos(lam);
    sinlam = Math.sin(lam);
    sinphi = Math.sin(phi);
    q = qsfnz(this.e, sinphi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinb = q / this.qp;
      cosb = Math.sqrt(1 - sinb * sinb);
    }
    switch (this.mode) {
    case this.OBLIQ:
      b = 1 + this.sinb1 * sinb + this.cosb1 * cosb * coslam;
      break;
    case this.EQUIT:
      b = 1 + cosb * coslam;
      break;
    case this.N_POLE:
      b = HALF_PI + phi;
      q = this.qp - q;
      break;
    case this.S_POLE:
      b = phi - HALF_PI;
      q = this.qp + q;
      break;
    }
    if (Math.abs(b) < EPSLN) {
      return null;
    }
    switch (this.mode) {
    case this.OBLIQ:
    case this.EQUIT:
      b = Math.sqrt(2 / b);
      if (this.mode === this.OBLIQ) {
        y = this.ymf * b * (this.cosb1 * sinb - this.sinb1 * cosb * coslam);
      }
      else {
        y = (b = Math.sqrt(2 / (1 + cosb * coslam))) * sinb * this.ymf;
      }
      x = this.xmf * b * cosb * sinlam;
      break;
    case this.N_POLE:
    case this.S_POLE:
      if (q >= 0) {
        x = (b = Math.sqrt(q)) * sinlam;
        y = coslam * ((this.mode === this.S_POLE) ? b : -b);
      }
      else {
        x = y = 0;
      }
      break;
    }
  }

  p.x = this.a * x + this.x0;
  p.y = this.a * y + this.y0;
  return p;
};

/* Inverse equations
  -----------------*/
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var x = p.x / this.a;
  var y = p.y / this.a;
  var lam, phi, cCe, sCe, q, rho, ab;

  if (this.sphere) {
    var cosz = 0,
      rh, sinz = 0;

    rh = Math.sqrt(x * x + y * y);
    phi = rh * 0.5;
    if (phi > 1) {
      return null;
    }
    phi = 2 * Math.asin(phi);
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      sinz = Math.sin(phi);
      cosz = Math.cos(phi);
    }
    switch (this.mode) {
    case this.EQUIT:
      phi = (Math.abs(rh) <= EPSLN) ? 0 : Math.asin(y * sinz / rh);
      x *= sinz;
      y = cosz * rh;
      break;
    case this.OBLIQ:
      phi = (Math.abs(rh) <= EPSLN) ? this.phi0 : Math.asin(cosz * this.sinph0 + y * sinz * this.cosph0 / rh);
      x *= sinz * this.cosph0;
      y = (cosz - Math.sin(phi) * this.sinph0) * rh;
      break;
    case this.N_POLE:
      y = -y;
      phi = HALF_PI - phi;
      break;
    case this.S_POLE:
      phi -= HALF_PI;
      break;
    }
    lam = (y === 0 && (this.mode === this.EQUIT || this.mode === this.OBLIQ)) ? 0 : Math.atan2(x, y);
  }
  else {
    ab = 0;
    if (this.mode === this.OBLIQ || this.mode === this.EQUIT) {
      x /= this.dd;
      y *= this.dd;
      rho = Math.sqrt(x * x + y * y);
      if (rho < EPSLN) {
        p.x = 0;
        p.y = this.phi0;
        return p;
      }
      sCe = 2 * Math.asin(0.5 * rho / this.rq);
      cCe = Math.cos(sCe);
      x *= (sCe = Math.sin(sCe));
      if (this.mode === this.OBLIQ) {
        ab = cCe * this.sinb1 + y * sCe * this.cosb1 / rho;
        q = this.qp * ab;
        y = rho * this.cosb1 * cCe - y * this.sinb1 * sCe;
      }
      else {
        ab = y * sCe / rho;
        q = this.qp * ab;
        y = rho * cCe;
      }
    }
    else if (this.mode === this.N_POLE || this.mode === this.S_POLE) {
      if (this.mode === this.N_POLE) {
        y = -y;
      }
      q = (x * x + y * y);
      if (!q) {
        p.x = 0;
        p.y = this.phi0;
        return p;
      }
      ab = 1 - q / this.qp;
      if (this.mode === this.S_POLE) {
        ab = -ab;
      }
    }
    lam = Math.atan2(x, y);
    phi = this.authlat(Math.asin(ab), this.apa);
  }


  p.x = adjust_lon(this.long0 + lam);
  p.y = phi;
  return p;
};

/* determine latitude from authalic latitude */
exports.P00 = 0.33333333333333333333;
exports.P01 = 0.17222222222222222222;
exports.P02 = 0.10257936507936507936;
exports.P10 = 0.06388888888888888888;
exports.P11 = 0.06640211640211640211;
exports.P20 = 0.01641501294219154443;

exports.authset = function(es) {
  var t;
  var APA = [];
  APA[0] = es * this.P00;
  t = es * es;
  APA[0] += t * this.P01;
  APA[1] = t * this.P10;
  t *= es;
  APA[0] += t * this.P02;
  APA[1] += t * this.P11;
  APA[2] = t * this.P20;
  return APA;
};

exports.authlat = function(beta, APA) {
  var t = beta + beta;
  return (beta + APA[0] * Math.sin(t) + APA[1] * Math.sin(t + t) + APA[2] * Math.sin(t + t + t));
};
exports.names = ["Lambert Azimuthal Equal Area", "Lambert_Azimuthal_Equal_Area", "laea"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/lcc.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/projections/lcc.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var EPSLN = 1.0e-10;
var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var tsfnz = __webpack_require__(/*! ../common/tsfnz */ "./node_modules/proj4/lib/common/tsfnz.js");
var HALF_PI = Math.PI/2;
var sign = __webpack_require__(/*! ../common/sign */ "./node_modules/proj4/lib/common/sign.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var phi2z = __webpack_require__(/*! ../common/phi2z */ "./node_modules/proj4/lib/common/phi2z.js");
exports.init = function() {

  // array of:  r_maj,r_min,lat1,lat2,c_lon,c_lat,false_east,false_north
  //double c_lat;                   /* center latitude                      */
  //double c_lon;                   /* center longitude                     */
  //double lat1;                    /* first standard parallel              */
  //double lat2;                    /* second standard parallel             */
  //double r_maj;                   /* major axis                           */
  //double r_min;                   /* minor axis                           */
  //double false_east;              /* x offset in meters                   */
  //double false_north;             /* y offset in meters                   */

  if (!this.lat2) {
    this.lat2 = this.lat1;
  } //if lat2 is not defined
  if (!this.k0) {
    this.k0 = 1;
  }
  this.x0 = this.x0 || 0;
  this.y0 = this.y0 || 0;
  // Standard Parallels cannot be equal and on opposite sides of the equator
  if (Math.abs(this.lat1 + this.lat2) < EPSLN) {
    return;
  }

  var temp = this.b / this.a;
  this.e = Math.sqrt(1 - temp * temp);

  var sin1 = Math.sin(this.lat1);
  var cos1 = Math.cos(this.lat1);
  var ms1 = msfnz(this.e, sin1, cos1);
  var ts1 = tsfnz(this.e, this.lat1, sin1);

  var sin2 = Math.sin(this.lat2);
  var cos2 = Math.cos(this.lat2);
  var ms2 = msfnz(this.e, sin2, cos2);
  var ts2 = tsfnz(this.e, this.lat2, sin2);

  var ts0 = tsfnz(this.e, this.lat0, Math.sin(this.lat0));

  if (Math.abs(this.lat1 - this.lat2) > EPSLN) {
    this.ns = Math.log(ms1 / ms2) / Math.log(ts1 / ts2);
  }
  else {
    this.ns = sin1;
  }
  if (isNaN(this.ns)) {
    this.ns = sin1;
  }
  this.f0 = ms1 / (this.ns * Math.pow(ts1, this.ns));
  this.rh = this.a * this.f0 * Math.pow(ts0, this.ns);
  if (!this.title) {
    this.title = "Lambert Conformal Conic";
  }
};


// Lambert Conformal conic forward equations--mapping lat,long to x,y
// -----------------------------------------------------------------
exports.forward = function(p) {

  var lon = p.x;
  var lat = p.y;

  // singular cases :
  if (Math.abs(2 * Math.abs(lat) - Math.PI) <= EPSLN) {
    lat = sign(lat) * (HALF_PI - 2 * EPSLN);
  }

  var con = Math.abs(Math.abs(lat) - HALF_PI);
  var ts, rh1;
  if (con > EPSLN) {
    ts = tsfnz(this.e, lat, Math.sin(lat));
    rh1 = this.a * this.f0 * Math.pow(ts, this.ns);
  }
  else {
    con = lat * this.ns;
    if (con <= 0) {
      return null;
    }
    rh1 = 0;
  }
  var theta = this.ns * adjust_lon(lon - this.long0);
  p.x = this.k0 * (rh1 * Math.sin(theta)) + this.x0;
  p.y = this.k0 * (this.rh - rh1 * Math.cos(theta)) + this.y0;

  return p;
};

// Lambert Conformal Conic inverse equations--mapping x,y to lat/long
// -----------------------------------------------------------------
exports.inverse = function(p) {

  var rh1, con, ts;
  var lat, lon;
  var x = (p.x - this.x0) / this.k0;
  var y = (this.rh - (p.y - this.y0) / this.k0);
  if (this.ns > 0) {
    rh1 = Math.sqrt(x * x + y * y);
    con = 1;
  }
  else {
    rh1 = -Math.sqrt(x * x + y * y);
    con = -1;
  }
  var theta = 0;
  if (rh1 !== 0) {
    theta = Math.atan2((con * x), (con * y));
  }
  if ((rh1 !== 0) || (this.ns > 0)) {
    con = 1 / this.ns;
    ts = Math.pow((rh1 / (this.a * this.f0)), con);
    lat = phi2z(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  }
  else {
    lat = -HALF_PI;
  }
  lon = adjust_lon(theta / this.ns + this.long0);

  p.x = lon;
  p.y = lat;
  return p;
};

exports.names = ["Lambert Tangential Conformal Conic Projection", "Lambert_Conformal_Conic", "Lambert_Conformal_Conic_2SP", "lcc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/longlat.js":
/*!*******************************************************!*\
  !*** ./node_modules/proj4/lib/projections/longlat.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

exports.init = function() {
  //no-op for longlat
};

function identity(pt) {
  return pt;
}
exports.forward = identity;
exports.inverse = identity;
exports.names = ["longlat", "identity"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/merc.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/merc.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var R2D = 57.29577951308232088;
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var FORTPI = Math.PI/4;
var tsfnz = __webpack_require__(/*! ../common/tsfnz */ "./node_modules/proj4/lib/common/tsfnz.js");
var phi2z = __webpack_require__(/*! ../common/phi2z */ "./node_modules/proj4/lib/common/phi2z.js");
exports.init = function() {
  var con = this.b / this.a;
  this.es = 1 - con * con;
  if(!('x0' in this)){
    this.x0 = 0;
  }
  if(!('y0' in this)){
    this.y0 = 0;
  }
  this.e = Math.sqrt(this.es);
  if (this.lat_ts) {
    if (this.sphere) {
      this.k0 = Math.cos(this.lat_ts);
    }
    else {
      this.k0 = msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts));
    }
  }
  else {
    if (!this.k0) {
      if (this.k) {
        this.k0 = this.k;
      }
      else {
        this.k0 = 1;
      }
    }
  }
};

/* Mercator forward equations--mapping lat,long to x,y
  --------------------------------------------------*/

exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  // convert to radians
  if (lat * R2D > 90 && lat * R2D < -90 && lon * R2D > 180 && lon * R2D < -180) {
    return null;
  }

  var x, y;
  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
    return null;
  }
  else {
    if (this.sphere) {
      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
      y = this.y0 + this.a * this.k0 * Math.log(Math.tan(FORTPI + 0.5 * lat));
    }
    else {
      var sinphi = Math.sin(lat);
      var ts = tsfnz(this.e, lat, sinphi);
      x = this.x0 + this.a * this.k0 * adjust_lon(lon - this.long0);
      y = this.y0 - this.a * this.k0 * Math.log(ts);
    }
    p.x = x;
    p.y = y;
    return p;
  }
};


/* Mercator inverse equations--mapping x,y to lat/long
  --------------------------------------------------*/
exports.inverse = function(p) {

  var x = p.x - this.x0;
  var y = p.y - this.y0;
  var lon, lat;

  if (this.sphere) {
    lat = HALF_PI - 2 * Math.atan(Math.exp(-y / (this.a * this.k0)));
  }
  else {
    var ts = Math.exp(-y / (this.a * this.k0));
    lat = phi2z(this.e, ts);
    if (lat === -9999) {
      return null;
    }
  }
  lon = adjust_lon(this.long0 + x / (this.a * this.k0));

  p.x = lon;
  p.y = lat;
  return p;
};

exports.names = ["Mercator", "Popular Visualisation Pseudo Mercator", "Mercator_1SP", "Mercator_Auxiliary_Sphere", "merc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/mill.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/mill.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
/*
  reference
    "New Equal-Area Map Projections for Noncircular Regions", John P. Snyder,
    The American Cartographer, Vol 15, No. 4, October 1988, pp. 341-355.
  */


/* Initialize the Miller Cylindrical projection
  -------------------------------------------*/
exports.init = function() {
  //no-op
};


/* Miller Cylindrical forward equations--mapping lat,long to x,y
    ------------------------------------------------------------*/
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
      -----------------*/
  var dlon = adjust_lon(lon - this.long0);
  var x = this.x0 + this.a * dlon;
  var y = this.y0 + this.a * Math.log(Math.tan((Math.PI / 4) + (lat / 2.5))) * 1.25;

  p.x = x;
  p.y = y;
  return p;
};

/* Miller Cylindrical inverse equations--mapping x,y to lat/long
    ------------------------------------------------------------*/
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;

  var lon = adjust_lon(this.long0 + p.x / this.a);
  var lat = 2.5 * (Math.atan(Math.exp(0.8 * p.y / this.a)) - Math.PI / 4);

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Miller_Cylindrical", "mill"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/moll.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/moll.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var EPSLN = 1.0e-10;
exports.init = function() {};

/* Mollweide forward equations--mapping lat,long to x,y
    ----------------------------------------------------*/
exports.forward = function(p) {

  /* Forward equations
      -----------------*/
  var lon = p.x;
  var lat = p.y;

  var delta_lon = adjust_lon(lon - this.long0);
  var theta = lat;
  var con = Math.PI * Math.sin(lat);

  /* Iterate using the Newton-Raphson method to find theta
      -----------------------------------------------------*/
  for (var i = 0; true; i++) {
    var delta_theta = -(theta + Math.sin(theta) - con) / (1 + Math.cos(theta));
    theta += delta_theta;
    if (Math.abs(delta_theta) < EPSLN) {
      break;
    }
  }
  theta /= 2;

  /* If the latitude is 90 deg, force the x coordinate to be "0 + false easting"
       this is done here because of precision problems with "cos(theta)"
       --------------------------------------------------------------------------*/
  if (Math.PI / 2 - Math.abs(lat) < EPSLN) {
    delta_lon = 0;
  }
  var x = 0.900316316158 * this.a * delta_lon * Math.cos(theta) + this.x0;
  var y = 1.4142135623731 * this.a * Math.sin(theta) + this.y0;

  p.x = x;
  p.y = y;
  return p;
};

exports.inverse = function(p) {
  var theta;
  var arg;

  /* Inverse equations
      -----------------*/
  p.x -= this.x0;
  p.y -= this.y0;
  arg = p.y / (1.4142135623731 * this.a);

  /* Because of division by zero problems, 'arg' can not be 1.  Therefore
       a number very close to one is used instead.
       -------------------------------------------------------------------*/
  if (Math.abs(arg) > 0.999999999999) {
    arg = 0.999999999999;
  }
  theta = Math.asin(arg);
  var lon = adjust_lon(this.long0 + (p.x / (0.900316316158 * this.a * Math.cos(theta))));
  if (lon < (-Math.PI)) {
    lon = -Math.PI;
  }
  if (lon > Math.PI) {
    lon = Math.PI;
  }
  arg = (2 * theta + Math.sin(2 * theta)) / Math.PI;
  if (Math.abs(arg) > 1) {
    arg = 1;
  }
  var lat = Math.asin(arg);

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Mollweide", "moll"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/nzmg.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/nzmg.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var SEC_TO_RAD = 4.84813681109535993589914102357e-6;
/*
  reference
    Department of Land and Survey Technical Circular 1973/32
      http://www.linz.govt.nz/docs/miscellaneous/nz-map-definition.pdf
    OSG Technical Report 4.1
      http://www.linz.govt.nz/docs/miscellaneous/nzmg.pdf
  */

/**
 * iterations: Number of iterations to refine inverse transform.
 *     0 -> km accuracy
 *     1 -> m accuracy -- suitable for most mapping applications
 *     2 -> mm accuracy
 */
exports.iterations = 1;

exports.init = function() {
  this.A = [];
  this.A[1] = 0.6399175073;
  this.A[2] = -0.1358797613;
  this.A[3] = 0.063294409;
  this.A[4] = -0.02526853;
  this.A[5] = 0.0117879;
  this.A[6] = -0.0055161;
  this.A[7] = 0.0026906;
  this.A[8] = -0.001333;
  this.A[9] = 0.00067;
  this.A[10] = -0.00034;

  this.B_re = [];
  this.B_im = [];
  this.B_re[1] = 0.7557853228;
  this.B_im[1] = 0;
  this.B_re[2] = 0.249204646;
  this.B_im[2] = 0.003371507;
  this.B_re[3] = -0.001541739;
  this.B_im[3] = 0.041058560;
  this.B_re[4] = -0.10162907;
  this.B_im[4] = 0.01727609;
  this.B_re[5] = -0.26623489;
  this.B_im[5] = -0.36249218;
  this.B_re[6] = -0.6870983;
  this.B_im[6] = -1.1651967;

  this.C_re = [];
  this.C_im = [];
  this.C_re[1] = 1.3231270439;
  this.C_im[1] = 0;
  this.C_re[2] = -0.577245789;
  this.C_im[2] = -0.007809598;
  this.C_re[3] = 0.508307513;
  this.C_im[3] = -0.112208952;
  this.C_re[4] = -0.15094762;
  this.C_im[4] = 0.18200602;
  this.C_re[5] = 1.01418179;
  this.C_im[5] = 1.64497696;
  this.C_re[6] = 1.9660549;
  this.C_im[6] = 2.5127645;

  this.D = [];
  this.D[1] = 1.5627014243;
  this.D[2] = 0.5185406398;
  this.D[3] = -0.03333098;
  this.D[4] = -0.1052906;
  this.D[5] = -0.0368594;
  this.D[6] = 0.007317;
  this.D[7] = 0.01220;
  this.D[8] = 0.00394;
  this.D[9] = -0.0013;
};

/**
    New Zealand Map Grid Forward  - long/lat to x/y
    long/lat in radians
  */
exports.forward = function(p) {
  var n;
  var lon = p.x;
  var lat = p.y;

  var delta_lat = lat - this.lat0;
  var delta_lon = lon - this.long0;

  // 1. Calculate d_phi and d_psi    ...                          // and d_lambda
  // For this algorithm, delta_latitude is in seconds of arc x 10-5, so we need to scale to those units. Longitude is radians.
  var d_phi = delta_lat / SEC_TO_RAD * 1E-5;
  var d_lambda = delta_lon;
  var d_phi_n = 1; // d_phi^0

  var d_psi = 0;
  for (n = 1; n <= 10; n++) {
    d_phi_n = d_phi_n * d_phi;
    d_psi = d_psi + this.A[n] * d_phi_n;
  }

  // 2. Calculate theta
  var th_re = d_psi;
  var th_im = d_lambda;

  // 3. Calculate z
  var th_n_re = 1;
  var th_n_im = 0; // theta^0
  var th_n_re1;
  var th_n_im1;

  var z_re = 0;
  var z_im = 0;
  for (n = 1; n <= 6; n++) {
    th_n_re1 = th_n_re * th_re - th_n_im * th_im;
    th_n_im1 = th_n_im * th_re + th_n_re * th_im;
    th_n_re = th_n_re1;
    th_n_im = th_n_im1;
    z_re = z_re + this.B_re[n] * th_n_re - this.B_im[n] * th_n_im;
    z_im = z_im + this.B_im[n] * th_n_re + this.B_re[n] * th_n_im;
  }

  // 4. Calculate easting and northing
  p.x = (z_im * this.a) + this.x0;
  p.y = (z_re * this.a) + this.y0;

  return p;
};


/**
    New Zealand Map Grid Inverse  -  x/y to long/lat
  */
exports.inverse = function(p) {
  var n;
  var x = p.x;
  var y = p.y;

  var delta_x = x - this.x0;
  var delta_y = y - this.y0;

  // 1. Calculate z
  var z_re = delta_y / this.a;
  var z_im = delta_x / this.a;

  // 2a. Calculate theta - first approximation gives km accuracy
  var z_n_re = 1;
  var z_n_im = 0; // z^0
  var z_n_re1;
  var z_n_im1;

  var th_re = 0;
  var th_im = 0;
  for (n = 1; n <= 6; n++) {
    z_n_re1 = z_n_re * z_re - z_n_im * z_im;
    z_n_im1 = z_n_im * z_re + z_n_re * z_im;
    z_n_re = z_n_re1;
    z_n_im = z_n_im1;
    th_re = th_re + this.C_re[n] * z_n_re - this.C_im[n] * z_n_im;
    th_im = th_im + this.C_im[n] * z_n_re + this.C_re[n] * z_n_im;
  }

  // 2b. Iterate to refine the accuracy of the calculation
  //        0 iterations gives km accuracy
  //        1 iteration gives m accuracy -- good enough for most mapping applications
  //        2 iterations bives mm accuracy
  for (var i = 0; i < this.iterations; i++) {
    var th_n_re = th_re;
    var th_n_im = th_im;
    var th_n_re1;
    var th_n_im1;

    var num_re = z_re;
    var num_im = z_im;
    for (n = 2; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      num_re = num_re + (n - 1) * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
      num_im = num_im + (n - 1) * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
    }

    th_n_re = 1;
    th_n_im = 0;
    var den_re = this.B_re[1];
    var den_im = this.B_im[1];
    for (n = 2; n <= 6; n++) {
      th_n_re1 = th_n_re * th_re - th_n_im * th_im;
      th_n_im1 = th_n_im * th_re + th_n_re * th_im;
      th_n_re = th_n_re1;
      th_n_im = th_n_im1;
      den_re = den_re + n * (this.B_re[n] * th_n_re - this.B_im[n] * th_n_im);
      den_im = den_im + n * (this.B_im[n] * th_n_re + this.B_re[n] * th_n_im);
    }

    // Complex division
    var den2 = den_re * den_re + den_im * den_im;
    th_re = (num_re * den_re + num_im * den_im) / den2;
    th_im = (num_im * den_re - num_re * den_im) / den2;
  }

  // 3. Calculate d_phi              ...                                    // and d_lambda
  var d_psi = th_re;
  var d_lambda = th_im;
  var d_psi_n = 1; // d_psi^0

  var d_phi = 0;
  for (n = 1; n <= 9; n++) {
    d_psi_n = d_psi_n * d_psi;
    d_phi = d_phi + this.D[n] * d_psi_n;
  }

  // 4. Calculate latitude and longitude
  // d_phi is calcuated in second of arc * 10^-5, so we need to scale back to radians. d_lambda is in radians.
  var lat = this.lat0 + (d_phi * SEC_TO_RAD * 1E5);
  var lon = this.long0 + d_lambda;

  p.x = lon;
  p.y = lat;

  return p;
};
exports.names = ["New_Zealand_Map_Grid", "nzmg"];

/***/ }),

/***/ "./node_modules/proj4/lib/projections/omerc.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/omerc.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var tsfnz = __webpack_require__(/*! ../common/tsfnz */ "./node_modules/proj4/lib/common/tsfnz.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var phi2z = __webpack_require__(/*! ../common/phi2z */ "./node_modules/proj4/lib/common/phi2z.js");
var HALF_PI = Math.PI/2;
var FORTPI = Math.PI/4;
var EPSLN = 1.0e-10;

/* Initialize the Oblique Mercator  projection
    ------------------------------------------*/
exports.init = function() {
  this.no_off = this.no_off || false;
  this.no_rot = this.no_rot || false;

  if (isNaN(this.k0)) {
    this.k0 = 1;
  }
  var sinlat = Math.sin(this.lat0);
  var coslat = Math.cos(this.lat0);
  var con = this.e * sinlat;

  this.bl = Math.sqrt(1 + this.es / (1 - this.es) * Math.pow(coslat, 4));
  this.al = this.a * this.bl * this.k0 * Math.sqrt(1 - this.es) / (1 - con * con);
  var t0 = tsfnz(this.e, this.lat0, sinlat);
  var dl = this.bl / coslat * Math.sqrt((1 - this.es) / (1 - con * con));
  if (dl * dl < 1) {
    dl = 1;
  }
  var fl;
  var gl;
  if (!isNaN(this.longc)) {
    //Central point and azimuth method

    if (this.lat0 >= 0) {
      fl = dl + Math.sqrt(dl * dl - 1);
    }
    else {
      fl = dl - Math.sqrt(dl * dl - 1);
    }
    this.el = fl * Math.pow(t0, this.bl);
    gl = 0.5 * (fl - 1 / fl);
    this.gamma0 = Math.asin(Math.sin(this.alpha) / dl);
    this.long0 = this.longc - Math.asin(gl * Math.tan(this.gamma0)) / this.bl;

  }
  else {
    //2 points method
    var t1 = tsfnz(this.e, this.lat1, Math.sin(this.lat1));
    var t2 = tsfnz(this.e, this.lat2, Math.sin(this.lat2));
    if (this.lat0 >= 0) {
      this.el = (dl + Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
    }
    else {
      this.el = (dl - Math.sqrt(dl * dl - 1)) * Math.pow(t0, this.bl);
    }
    var hl = Math.pow(t1, this.bl);
    var ll = Math.pow(t2, this.bl);
    fl = this.el / hl;
    gl = 0.5 * (fl - 1 / fl);
    var jl = (this.el * this.el - ll * hl) / (this.el * this.el + ll * hl);
    var pl = (ll - hl) / (ll + hl);
    var dlon12 = adjust_lon(this.long1 - this.long2);
    this.long0 = 0.5 * (this.long1 + this.long2) - Math.atan(jl * Math.tan(0.5 * this.bl * (dlon12)) / pl) / this.bl;
    this.long0 = adjust_lon(this.long0);
    var dlon10 = adjust_lon(this.long1 - this.long0);
    this.gamma0 = Math.atan(Math.sin(this.bl * (dlon10)) / gl);
    this.alpha = Math.asin(dl * Math.sin(this.gamma0));
  }

  if (this.no_off) {
    this.uc = 0;
  }
  else {
    if (this.lat0 >= 0) {
      this.uc = this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
    }
    else {
      this.uc = -1 * this.al / this.bl * Math.atan2(Math.sqrt(dl * dl - 1), Math.cos(this.alpha));
    }
  }

};


/* Oblique Mercator forward equations--mapping lat,long to x,y
    ----------------------------------------------------------*/
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var dlon = adjust_lon(lon - this.long0);
  var us, vs;
  var con;
  if (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN) {
    if (lat > 0) {
      con = -1;
    }
    else {
      con = 1;
    }
    vs = this.al / this.bl * Math.log(Math.tan(FORTPI + con * this.gamma0 * 0.5));
    us = -1 * con * HALF_PI * this.al / this.bl;
  }
  else {
    var t = tsfnz(this.e, lat, Math.sin(lat));
    var ql = this.el / Math.pow(t, this.bl);
    var sl = 0.5 * (ql - 1 / ql);
    var tl = 0.5 * (ql + 1 / ql);
    var vl = Math.sin(this.bl * (dlon));
    var ul = (sl * Math.sin(this.gamma0) - vl * Math.cos(this.gamma0)) / tl;
    if (Math.abs(Math.abs(ul) - 1) <= EPSLN) {
      vs = Number.POSITIVE_INFINITY;
    }
    else {
      vs = 0.5 * this.al * Math.log((1 - ul) / (1 + ul)) / this.bl;
    }
    if (Math.abs(Math.cos(this.bl * (dlon))) <= EPSLN) {
      us = this.al * this.bl * (dlon);
    }
    else {
      us = this.al * Math.atan2(sl * Math.cos(this.gamma0) + vl * Math.sin(this.gamma0), Math.cos(this.bl * dlon)) / this.bl;
    }
  }

  if (this.no_rot) {
    p.x = this.x0 + us;
    p.y = this.y0 + vs;
  }
  else {

    us -= this.uc;
    p.x = this.x0 + vs * Math.cos(this.alpha) + us * Math.sin(this.alpha);
    p.y = this.y0 + us * Math.cos(this.alpha) - vs * Math.sin(this.alpha);
  }
  return p;
};

exports.inverse = function(p) {
  var us, vs;
  if (this.no_rot) {
    vs = p.y - this.y0;
    us = p.x - this.x0;
  }
  else {
    vs = (p.x - this.x0) * Math.cos(this.alpha) - (p.y - this.y0) * Math.sin(this.alpha);
    us = (p.y - this.y0) * Math.cos(this.alpha) + (p.x - this.x0) * Math.sin(this.alpha);
    us += this.uc;
  }
  var qp = Math.exp(-1 * this.bl * vs / this.al);
  var sp = 0.5 * (qp - 1 / qp);
  var tp = 0.5 * (qp + 1 / qp);
  var vp = Math.sin(this.bl * us / this.al);
  var up = (vp * Math.cos(this.gamma0) + sp * Math.sin(this.gamma0)) / tp;
  var ts = Math.pow(this.el / Math.sqrt((1 + up) / (1 - up)), 1 / this.bl);
  if (Math.abs(up - 1) < EPSLN) {
    p.x = this.long0;
    p.y = HALF_PI;
  }
  else if (Math.abs(up + 1) < EPSLN) {
    p.x = this.long0;
    p.y = -1 * HALF_PI;
  }
  else {
    p.y = phi2z(this.e, ts);
    p.x = adjust_lon(this.long0 - Math.atan2(sp * Math.cos(this.gamma0) - vp * Math.sin(this.gamma0), Math.cos(this.bl * us / this.al)) / this.bl);
  }
  return p;
};

exports.names = ["Hotine_Oblique_Mercator", "Hotine Oblique Mercator", "Hotine_Oblique_Mercator_Azimuth_Natural_Origin", "Hotine_Oblique_Mercator_Azimuth_Center", "omerc"];

/***/ }),

/***/ "./node_modules/proj4/lib/projections/poly.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/poly.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var e0fn = __webpack_require__(/*! ../common/e0fn */ "./node_modules/proj4/lib/common/e0fn.js");
var e1fn = __webpack_require__(/*! ../common/e1fn */ "./node_modules/proj4/lib/common/e1fn.js");
var e2fn = __webpack_require__(/*! ../common/e2fn */ "./node_modules/proj4/lib/common/e2fn.js");
var e3fn = __webpack_require__(/*! ../common/e3fn */ "./node_modules/proj4/lib/common/e3fn.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var adjust_lat = __webpack_require__(/*! ../common/adjust_lat */ "./node_modules/proj4/lib/common/adjust_lat.js");
var mlfn = __webpack_require__(/*! ../common/mlfn */ "./node_modules/proj4/lib/common/mlfn.js");
var EPSLN = 1.0e-10;
var gN = __webpack_require__(/*! ../common/gN */ "./node_modules/proj4/lib/common/gN.js");
var MAX_ITER = 20;
exports.init = function() {
  /* Place parameters in static storage for common use
      -------------------------------------------------*/
  this.temp = this.b / this.a;
  this.es = 1 - Math.pow(this.temp, 2); // devait etre dans tmerc.js mais n y est pas donc je commente sinon retour de valeurs nulles
  this.e = Math.sqrt(this.es);
  this.e0 = e0fn(this.es);
  this.e1 = e1fn(this.es);
  this.e2 = e2fn(this.es);
  this.e3 = e3fn(this.es);
  this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0); //si que des zeros le calcul ne se fait pas
};


/* Polyconic forward equations--mapping lat,long to x,y
    ---------------------------------------------------*/
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var x, y, el;
  var dlon = adjust_lon(lon - this.long0);
  el = dlon * Math.sin(lat);
  if (this.sphere) {
    if (Math.abs(lat) <= EPSLN) {
      x = this.a * dlon;
      y = -1 * this.a * this.lat0;
    }
    else {
      x = this.a * Math.sin(el) / Math.tan(lat);
      y = this.a * (adjust_lat(lat - this.lat0) + (1 - Math.cos(el)) / Math.tan(lat));
    }
  }
  else {
    if (Math.abs(lat) <= EPSLN) {
      x = this.a * dlon;
      y = -1 * this.ml0;
    }
    else {
      var nl = gN(this.a, this.e, Math.sin(lat)) / Math.tan(lat);
      x = nl * Math.sin(el);
      y = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat) - this.ml0 + nl * (1 - Math.cos(el));
    }

  }
  p.x = x + this.x0;
  p.y = y + this.y0;
  return p;
};


/* Inverse equations
  -----------------*/
exports.inverse = function(p) {
  var lon, lat, x, y, i;
  var al, bl;
  var phi, dphi;
  x = p.x - this.x0;
  y = p.y - this.y0;

  if (this.sphere) {
    if (Math.abs(y + this.a * this.lat0) <= EPSLN) {
      lon = adjust_lon(x / this.a + this.long0);
      lat = 0;
    }
    else {
      al = this.lat0 + y / this.a;
      bl = x * x / this.a / this.a + al * al;
      phi = al;
      var tanphi;
      for (i = MAX_ITER; i; --i) {
        tanphi = Math.tan(phi);
        dphi = -1 * (al * (phi * tanphi + 1) - phi - 0.5 * (phi * phi + bl) * tanphi) / ((phi - al) / tanphi - 1);
        phi += dphi;
        if (Math.abs(dphi) <= EPSLN) {
          lat = phi;
          break;
        }
      }
      lon = adjust_lon(this.long0 + (Math.asin(x * Math.tan(phi) / this.a)) / Math.sin(lat));
    }
  }
  else {
    if (Math.abs(y + this.ml0) <= EPSLN) {
      lat = 0;
      lon = adjust_lon(this.long0 + x / this.a);
    }
    else {

      al = (this.ml0 + y) / this.a;
      bl = x * x / this.a / this.a + al * al;
      phi = al;
      var cl, mln, mlnp, ma;
      var con;
      for (i = MAX_ITER; i; --i) {
        con = this.e * Math.sin(phi);
        cl = Math.sqrt(1 - con * con) * Math.tan(phi);
        mln = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, phi);
        mlnp = this.e0 - 2 * this.e1 * Math.cos(2 * phi) + 4 * this.e2 * Math.cos(4 * phi) - 6 * this.e3 * Math.cos(6 * phi);
        ma = mln / this.a;
        dphi = (al * (cl * ma + 1) - ma - 0.5 * cl * (ma * ma + bl)) / (this.es * Math.sin(2 * phi) * (ma * ma + bl - 2 * al * ma) / (4 * cl) + (al - ma) * (cl * mlnp - 2 / Math.sin(2 * phi)) - mlnp);
        phi -= dphi;
        if (Math.abs(dphi) <= EPSLN) {
          lat = phi;
          break;
        }
      }

      //lat=phi4z(this.e,this.e0,this.e1,this.e2,this.e3,al,bl,0,0);
      cl = Math.sqrt(1 - this.es * Math.pow(Math.sin(lat), 2)) * Math.tan(lat);
      lon = adjust_lon(this.long0 + Math.asin(x * cl / this.a) / Math.sin(lat));
    }
  }

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Polyconic", "poly"];

/***/ }),

/***/ "./node_modules/proj4/lib/projections/sinu.js":
/*!****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/sinu.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var adjust_lat = __webpack_require__(/*! ../common/adjust_lat */ "./node_modules/proj4/lib/common/adjust_lat.js");
var pj_enfn = __webpack_require__(/*! ../common/pj_enfn */ "./node_modules/proj4/lib/common/pj_enfn.js");
var MAX_ITER = 20;
var pj_mlfn = __webpack_require__(/*! ../common/pj_mlfn */ "./node_modules/proj4/lib/common/pj_mlfn.js");
var pj_inv_mlfn = __webpack_require__(/*! ../common/pj_inv_mlfn */ "./node_modules/proj4/lib/common/pj_inv_mlfn.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");
exports.init = function() {
  /* Place parameters in static storage for common use
    -------------------------------------------------*/


  if (!this.sphere) {
    this.en = pj_enfn(this.es);
  }
  else {
    this.n = 1;
    this.m = 0;
    this.es = 0;
    this.C_y = Math.sqrt((this.m + 1) / this.n);
    this.C_x = this.C_y / (this.m + 1);
  }

};

/* Sinusoidal forward equations--mapping lat,long to x,y
  -----------------------------------------------------*/
exports.forward = function(p) {
  var x, y;
  var lon = p.x;
  var lat = p.y;
  /* Forward equations
    -----------------*/
  lon = adjust_lon(lon - this.long0);

  if (this.sphere) {
    if (!this.m) {
      lat = this.n !== 1 ? Math.asin(this.n * Math.sin(lat)) : lat;
    }
    else {
      var k = this.n * Math.sin(lat);
      for (var i = MAX_ITER; i; --i) {
        var V = (this.m * lat + Math.sin(lat) - k) / (this.m + Math.cos(lat));
        lat -= V;
        if (Math.abs(V) < EPSLN) {
          break;
        }
      }
    }
    x = this.a * this.C_x * lon * (this.m + Math.cos(lat));
    y = this.a * this.C_y * lat;

  }
  else {

    var s = Math.sin(lat);
    var c = Math.cos(lat);
    y = this.a * pj_mlfn(lat, s, c, this.en);
    x = this.a * lon * c / Math.sqrt(1 - this.es * s * s);
  }

  p.x = x;
  p.y = y;
  return p;
};

exports.inverse = function(p) {
  var lat, temp, lon, s;

  p.x -= this.x0;
  lon = p.x / this.a;
  p.y -= this.y0;
  lat = p.y / this.a;

  if (this.sphere) {
    lat /= this.C_y;
    lon = lon / (this.C_x * (this.m + Math.cos(lat)));
    if (this.m) {
      lat = asinz((this.m * lat + Math.sin(lat)) / this.n);
    }
    else if (this.n !== 1) {
      lat = asinz(Math.sin(lat) / this.n);
    }
    lon = adjust_lon(lon + this.long0);
    lat = adjust_lat(lat);
  }
  else {
    lat = pj_inv_mlfn(p.y / this.a, this.es, this.en);
    s = Math.abs(lat);
    if (s < HALF_PI) {
      s = Math.sin(lat);
      temp = this.long0 + p.x * Math.sqrt(1 - this.es * s * s) / (this.a * Math.cos(lat));
      //temp = this.long0 + p.x / (this.a * Math.cos(lat));
      lon = adjust_lon(temp);
    }
    else if ((s - EPSLN) < HALF_PI) {
      lon = this.long0;
    }
  }
  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Sinusoidal", "sinu"];

/***/ }),

/***/ "./node_modules/proj4/lib/projections/somerc.js":
/*!******************************************************!*\
  !*** ./node_modules/proj4/lib/projections/somerc.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/*
  references:
    Formules et constantes pour le Calcul pour la
    projection cylindrique conforme à axe oblique et pour la transformation entre
    des systèmes de référence.
    http://www.swisstopo.admin.ch/internet/swisstopo/fr/home/topics/survey/sys/refsys/switzerland.parsysrelated1.31216.downloadList.77004.DownloadFile.tmp/swissprojectionfr.pdf
  */
exports.init = function() {
  var phy0 = this.lat0;
  this.lambda0 = this.long0;
  var sinPhy0 = Math.sin(phy0);
  var semiMajorAxis = this.a;
  var invF = this.rf;
  var flattening = 1 / invF;
  var e2 = 2 * flattening - Math.pow(flattening, 2);
  var e = this.e = Math.sqrt(e2);
  this.R = this.k0 * semiMajorAxis * Math.sqrt(1 - e2) / (1 - e2 * Math.pow(sinPhy0, 2));
  this.alpha = Math.sqrt(1 + e2 / (1 - e2) * Math.pow(Math.cos(phy0), 4));
  this.b0 = Math.asin(sinPhy0 / this.alpha);
  var k1 = Math.log(Math.tan(Math.PI / 4 + this.b0 / 2));
  var k2 = Math.log(Math.tan(Math.PI / 4 + phy0 / 2));
  var k3 = Math.log((1 + e * sinPhy0) / (1 - e * sinPhy0));
  this.K = k1 - this.alpha * k2 + this.alpha * e / 2 * k3;
};


exports.forward = function(p) {
  var Sa1 = Math.log(Math.tan(Math.PI / 4 - p.y / 2));
  var Sa2 = this.e / 2 * Math.log((1 + this.e * Math.sin(p.y)) / (1 - this.e * Math.sin(p.y)));
  var S = -this.alpha * (Sa1 + Sa2) + this.K;

  // spheric latitude
  var b = 2 * (Math.atan(Math.exp(S)) - Math.PI / 4);

  // spheric longitude
  var I = this.alpha * (p.x - this.lambda0);

  // psoeudo equatorial rotation
  var rotI = Math.atan(Math.sin(I) / (Math.sin(this.b0) * Math.tan(b) + Math.cos(this.b0) * Math.cos(I)));

  var rotB = Math.asin(Math.cos(this.b0) * Math.sin(b) - Math.sin(this.b0) * Math.cos(b) * Math.cos(I));

  p.y = this.R / 2 * Math.log((1 + Math.sin(rotB)) / (1 - Math.sin(rotB))) + this.y0;
  p.x = this.R * rotI + this.x0;
  return p;
};

exports.inverse = function(p) {
  var Y = p.x - this.x0;
  var X = p.y - this.y0;

  var rotI = Y / this.R;
  var rotB = 2 * (Math.atan(Math.exp(X / this.R)) - Math.PI / 4);

  var b = Math.asin(Math.cos(this.b0) * Math.sin(rotB) + Math.sin(this.b0) * Math.cos(rotB) * Math.cos(rotI));
  var I = Math.atan(Math.sin(rotI) / (Math.cos(this.b0) * Math.cos(rotI) - Math.sin(this.b0) * Math.tan(rotB)));

  var lambda = this.lambda0 + I / this.alpha;

  var S = 0;
  var phy = b;
  var prevPhy = -1000;
  var iteration = 0;
  while (Math.abs(phy - prevPhy) > 0.0000001) {
    if (++iteration > 20) {
      //...reportError("omercFwdInfinity");
      return;
    }
    //S = Math.log(Math.tan(Math.PI / 4 + phy / 2));
    S = 1 / this.alpha * (Math.log(Math.tan(Math.PI / 4 + b / 2)) - this.K) + this.e * Math.log(Math.tan(Math.PI / 4 + Math.asin(this.e * Math.sin(phy)) / 2));
    prevPhy = phy;
    phy = 2 * Math.atan(Math.exp(S)) - Math.PI / 2;
  }

  p.x = lambda;
  p.y = phy;
  return p;
};

exports.names = ["somerc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/stere.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/stere.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var sign = __webpack_require__(/*! ../common/sign */ "./node_modules/proj4/lib/common/sign.js");
var msfnz = __webpack_require__(/*! ../common/msfnz */ "./node_modules/proj4/lib/common/msfnz.js");
var tsfnz = __webpack_require__(/*! ../common/tsfnz */ "./node_modules/proj4/lib/common/tsfnz.js");
var phi2z = __webpack_require__(/*! ../common/phi2z */ "./node_modules/proj4/lib/common/phi2z.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
exports.ssfn_ = function(phit, sinphi, eccen) {
  sinphi *= eccen;
  return (Math.tan(0.5 * (HALF_PI + phit)) * Math.pow((1 - sinphi) / (1 + sinphi), 0.5 * eccen));
};

exports.init = function() {
  this.coslat0 = Math.cos(this.lat0);
  this.sinlat0 = Math.sin(this.lat0);
  if (this.sphere) {
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
      this.k0 = 0.5 * (1 + sign(this.lat0) * Math.sin(this.lat_ts));
    }
  }
  else {
    if (Math.abs(this.coslat0) <= EPSLN) {
      if (this.lat0 > 0) {
        //North pole
        //trace('stere:north pole');
        this.con = 1;
      }
      else {
        //South pole
        //trace('stere:south pole');
        this.con = -1;
      }
    }
    this.cons = Math.sqrt(Math.pow(1 + this.e, 1 + this.e) * Math.pow(1 - this.e, 1 - this.e));
    if (this.k0 === 1 && !isNaN(this.lat_ts) && Math.abs(this.coslat0) <= EPSLN) {
      this.k0 = 0.5 * this.cons * msfnz(this.e, Math.sin(this.lat_ts), Math.cos(this.lat_ts)) / tsfnz(this.e, this.con * this.lat_ts, this.con * Math.sin(this.lat_ts));
    }
    this.ms1 = msfnz(this.e, this.sinlat0, this.coslat0);
    this.X0 = 2 * Math.atan(this.ssfn_(this.lat0, this.sinlat0, this.e)) - HALF_PI;
    this.cosX0 = Math.cos(this.X0);
    this.sinX0 = Math.sin(this.X0);
  }
};

// Stereographic forward equations--mapping lat,long to x,y
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;
  var sinlat = Math.sin(lat);
  var coslat = Math.cos(lat);
  var A, X, sinX, cosX, ts, rh;
  var dlon = adjust_lon(lon - this.long0);

  if (Math.abs(Math.abs(lon - this.long0) - Math.PI) <= EPSLN && Math.abs(lat + this.lat0) <= EPSLN) {
    //case of the origine point
    //trace('stere:this is the origin point');
    p.x = NaN;
    p.y = NaN;
    return p;
  }
  if (this.sphere) {
    //trace('stere:sphere case');
    A = 2 * this.k0 / (1 + this.sinlat0 * sinlat + this.coslat0 * coslat * Math.cos(dlon));
    p.x = this.a * A * coslat * Math.sin(dlon) + this.x0;
    p.y = this.a * A * (this.coslat0 * sinlat - this.sinlat0 * coslat * Math.cos(dlon)) + this.y0;
    return p;
  }
  else {
    X = 2 * Math.atan(this.ssfn_(lat, sinlat, this.e)) - HALF_PI;
    cosX = Math.cos(X);
    sinX = Math.sin(X);
    if (Math.abs(this.coslat0) <= EPSLN) {
      ts = tsfnz(this.e, lat * this.con, this.con * sinlat);
      rh = 2 * this.a * this.k0 * ts / this.cons;
      p.x = this.x0 + rh * Math.sin(lon - this.long0);
      p.y = this.y0 - this.con * rh * Math.cos(lon - this.long0);
      //trace(p.toString());
      return p;
    }
    else if (Math.abs(this.sinlat0) < EPSLN) {
      //Eq
      //trace('stere:equateur');
      A = 2 * this.a * this.k0 / (1 + cosX * Math.cos(dlon));
      p.y = A * sinX;
    }
    else {
      //other case
      //trace('stere:normal case');
      A = 2 * this.a * this.k0 * this.ms1 / (this.cosX0 * (1 + this.sinX0 * sinX + this.cosX0 * cosX * Math.cos(dlon)));
      p.y = A * (this.cosX0 * sinX - this.sinX0 * cosX * Math.cos(dlon)) + this.y0;
    }
    p.x = A * cosX * Math.sin(dlon) + this.x0;
  }
  //trace(p.toString());
  return p;
};


//* Stereographic inverse equations--mapping x,y to lat/long
exports.inverse = function(p) {
  p.x -= this.x0;
  p.y -= this.y0;
  var lon, lat, ts, ce, Chi;
  var rh = Math.sqrt(p.x * p.x + p.y * p.y);
  if (this.sphere) {
    var c = 2 * Math.atan(rh / (0.5 * this.a * this.k0));
    lon = this.long0;
    lat = this.lat0;
    if (rh <= EPSLN) {
      p.x = lon;
      p.y = lat;
      return p;
    }
    lat = Math.asin(Math.cos(c) * this.sinlat0 + p.y * Math.sin(c) * this.coslat0 / rh);
    if (Math.abs(this.coslat0) < EPSLN) {
      if (this.lat0 > 0) {
        lon = adjust_lon(this.long0 + Math.atan2(p.x, - 1 * p.y));
      }
      else {
        lon = adjust_lon(this.long0 + Math.atan2(p.x, p.y));
      }
    }
    else {
      lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(c), rh * this.coslat0 * Math.cos(c) - p.y * this.sinlat0 * Math.sin(c)));
    }
    p.x = lon;
    p.y = lat;
    return p;
  }
  else {
    if (Math.abs(this.coslat0) <= EPSLN) {
      if (rh <= EPSLN) {
        lat = this.lat0;
        lon = this.long0;
        p.x = lon;
        p.y = lat;
        //trace(p.toString());
        return p;
      }
      p.x *= this.con;
      p.y *= this.con;
      ts = rh * this.cons / (2 * this.a * this.k0);
      lat = this.con * phi2z(this.e, ts);
      lon = this.con * adjust_lon(this.con * this.long0 + Math.atan2(p.x, - 1 * p.y));
    }
    else {
      ce = 2 * Math.atan(rh * this.cosX0 / (2 * this.a * this.k0 * this.ms1));
      lon = this.long0;
      if (rh <= EPSLN) {
        Chi = this.X0;
      }
      else {
        Chi = Math.asin(Math.cos(ce) * this.sinX0 + p.y * Math.sin(ce) * this.cosX0 / rh);
        lon = adjust_lon(this.long0 + Math.atan2(p.x * Math.sin(ce), rh * this.cosX0 * Math.cos(ce) - p.y * this.sinX0 * Math.sin(ce)));
      }
      lat = -1 * phi2z(this.e, Math.tan(0.5 * (HALF_PI + Chi)));
    }
  }
  p.x = lon;
  p.y = lat;

  //trace(p.toString());
  return p;

};
exports.names = ["stere", "Stereographic_South_Pole", "Polar Stereographic (variant B)"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/sterea.js":
/*!******************************************************!*\
  !*** ./node_modules/proj4/lib/projections/sterea.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var gauss = __webpack_require__(/*! ./gauss */ "./node_modules/proj4/lib/projections/gauss.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
exports.init = function() {
  gauss.init.apply(this);
  if (!this.rc) {
    return;
  }
  this.sinc0 = Math.sin(this.phic0);
  this.cosc0 = Math.cos(this.phic0);
  this.R2 = 2 * this.rc;
  if (!this.title) {
    this.title = "Oblique Stereographic Alternative";
  }
};

exports.forward = function(p) {
  var sinc, cosc, cosl, k;
  p.x = adjust_lon(p.x - this.long0);
  gauss.forward.apply(this, [p]);
  sinc = Math.sin(p.y);
  cosc = Math.cos(p.y);
  cosl = Math.cos(p.x);
  k = this.k0 * this.R2 / (1 + this.sinc0 * sinc + this.cosc0 * cosc * cosl);
  p.x = k * cosc * Math.sin(p.x);
  p.y = k * (this.cosc0 * sinc - this.sinc0 * cosc * cosl);
  p.x = this.a * p.x + this.x0;
  p.y = this.a * p.y + this.y0;
  return p;
};

exports.inverse = function(p) {
  var sinc, cosc, lon, lat, rho;
  p.x = (p.x - this.x0) / this.a;
  p.y = (p.y - this.y0) / this.a;

  p.x /= this.k0;
  p.y /= this.k0;
  if ((rho = Math.sqrt(p.x * p.x + p.y * p.y))) {
    var c = 2 * Math.atan2(rho, this.R2);
    sinc = Math.sin(c);
    cosc = Math.cos(c);
    lat = Math.asin(cosc * this.sinc0 + p.y * sinc * this.cosc0 / rho);
    lon = Math.atan2(p.x * sinc, rho * this.cosc0 * cosc - p.y * this.sinc0 * sinc);
  }
  else {
    lat = this.phic0;
    lon = 0;
  }

  p.x = lon;
  p.y = lat;
  gauss.inverse.apply(this, [p]);
  p.x = adjust_lon(p.x + this.long0);
  return p;
};

exports.names = ["Stereographic_North_Pole", "Oblique_Stereographic", "Polar_Stereographic", "sterea","Oblique Stereographic Alternative"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/tmerc.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/tmerc.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var e0fn = __webpack_require__(/*! ../common/e0fn */ "./node_modules/proj4/lib/common/e0fn.js");
var e1fn = __webpack_require__(/*! ../common/e1fn */ "./node_modules/proj4/lib/common/e1fn.js");
var e2fn = __webpack_require__(/*! ../common/e2fn */ "./node_modules/proj4/lib/common/e2fn.js");
var e3fn = __webpack_require__(/*! ../common/e3fn */ "./node_modules/proj4/lib/common/e3fn.js");
var mlfn = __webpack_require__(/*! ../common/mlfn */ "./node_modules/proj4/lib/common/mlfn.js");
var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var sign = __webpack_require__(/*! ../common/sign */ "./node_modules/proj4/lib/common/sign.js");
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");

exports.init = function() {
  this.e0 = e0fn(this.es);
  this.e1 = e1fn(this.es);
  this.e2 = e2fn(this.es);
  this.e3 = e3fn(this.es);
  this.ml0 = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, this.lat0);
};

/**
    Transverse Mercator Forward  - long/lat to x/y
    long/lat in radians
  */
exports.forward = function(p) {
  var lon = p.x;
  var lat = p.y;

  var delta_lon = adjust_lon(lon - this.long0);
  var con;
  var x, y;
  var sin_phi = Math.sin(lat);
  var cos_phi = Math.cos(lat);

  if (this.sphere) {
    var b = cos_phi * Math.sin(delta_lon);
    if ((Math.abs(Math.abs(b) - 1)) < 0.0000000001) {
      return (93);
    }
    else {
      x = 0.5 * this.a * this.k0 * Math.log((1 + b) / (1 - b));
      con = Math.acos(cos_phi * Math.cos(delta_lon) / Math.sqrt(1 - b * b));
      if (lat < 0) {
        con = -con;
      }
      y = this.a * this.k0 * (con - this.lat0);
    }
  }
  else {
    var al = cos_phi * delta_lon;
    var als = Math.pow(al, 2);
    var c = this.ep2 * Math.pow(cos_phi, 2);
    var tq = Math.tan(lat);
    var t = Math.pow(tq, 2);
    con = 1 - this.es * Math.pow(sin_phi, 2);
    var n = this.a / Math.sqrt(con);
    var ml = this.a * mlfn(this.e0, this.e1, this.e2, this.e3, lat);

    x = this.k0 * n * al * (1 + als / 6 * (1 - t + c + als / 20 * (5 - 18 * t + Math.pow(t, 2) + 72 * c - 58 * this.ep2))) + this.x0;
    y = this.k0 * (ml - this.ml0 + n * tq * (als * (0.5 + als / 24 * (5 - t + 9 * c + 4 * Math.pow(c, 2) + als / 30 * (61 - 58 * t + Math.pow(t, 2) + 600 * c - 330 * this.ep2))))) + this.y0;

  }
  p.x = x;
  p.y = y;
  return p;
};

/**
    Transverse Mercator Inverse  -  x/y to long/lat
  */
exports.inverse = function(p) {
  var con, phi;
  var delta_phi;
  var i;
  var max_iter = 6;
  var lat, lon;

  if (this.sphere) {
    var f = Math.exp(p.x / (this.a * this.k0));
    var g = 0.5 * (f - 1 / f);
    var temp = this.lat0 + p.y / (this.a * this.k0);
    var h = Math.cos(temp);
    con = Math.sqrt((1 - h * h) / (1 + g * g));
    lat = asinz(con);
    if (temp < 0) {
      lat = -lat;
    }
    if ((g === 0) && (h === 0)) {
      lon = this.long0;
    }
    else {
      lon = adjust_lon(Math.atan2(g, h) + this.long0);
    }
  }
  else { // ellipsoidal form
    var x = p.x - this.x0;
    var y = p.y - this.y0;

    con = (this.ml0 + y / this.k0) / this.a;
    phi = con;
    for (i = 0; true; i++) {
      delta_phi = ((con + this.e1 * Math.sin(2 * phi) - this.e2 * Math.sin(4 * phi) + this.e3 * Math.sin(6 * phi)) / this.e0) - phi;
      phi += delta_phi;
      if (Math.abs(delta_phi) <= EPSLN) {
        break;
      }
      if (i >= max_iter) {
        return (95);
      }
    } // for()
    if (Math.abs(phi) < HALF_PI) {
      var sin_phi = Math.sin(phi);
      var cos_phi = Math.cos(phi);
      var tan_phi = Math.tan(phi);
      var c = this.ep2 * Math.pow(cos_phi, 2);
      var cs = Math.pow(c, 2);
      var t = Math.pow(tan_phi, 2);
      var ts = Math.pow(t, 2);
      con = 1 - this.es * Math.pow(sin_phi, 2);
      var n = this.a / Math.sqrt(con);
      var r = n * (1 - this.es) / con;
      var d = x / (n * this.k0);
      var ds = Math.pow(d, 2);
      lat = phi - (n * tan_phi * ds / r) * (0.5 - ds / 24 * (5 + 3 * t + 10 * c - 4 * cs - 9 * this.ep2 - ds / 30 * (61 + 90 * t + 298 * c + 45 * ts - 252 * this.ep2 - 3 * cs)));
      lon = adjust_lon(this.long0 + (d * (1 - ds / 6 * (1 + 2 * t + c - ds / 20 * (5 - 2 * c + 28 * t - 3 * cs + 8 * this.ep2 + 24 * ts))) / cos_phi));
    }
    else {
      lat = HALF_PI * sign(y);
      lon = this.long0;
    }
  }
  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Transverse_Mercator", "Transverse Mercator", "tmerc"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/utm.js":
/*!***************************************************!*\
  !*** ./node_modules/proj4/lib/projections/utm.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var D2R = 0.01745329251994329577;
var tmerc = __webpack_require__(/*! ./tmerc */ "./node_modules/proj4/lib/projections/tmerc.js");
exports.dependsOn = 'tmerc';
exports.init = function() {
  if (!this.zone) {
    return;
  }
  this.lat0 = 0;
  this.long0 = ((6 * Math.abs(this.zone)) - 183) * D2R;
  this.x0 = 500000;
  this.y0 = this.utmSouth ? 10000000 : 0;
  this.k0 = 0.9996;

  tmerc.init.apply(this);
  this.forward = tmerc.forward;
  this.inverse = tmerc.inverse;
};
exports.names = ["Universal Transverse Mercator System", "utm"];


/***/ }),

/***/ "./node_modules/proj4/lib/projections/vandg.js":
/*!*****************************************************!*\
  !*** ./node_modules/proj4/lib/projections/vandg.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var adjust_lon = __webpack_require__(/*! ../common/adjust_lon */ "./node_modules/proj4/lib/common/adjust_lon.js");
var HALF_PI = Math.PI/2;
var EPSLN = 1.0e-10;
var asinz = __webpack_require__(/*! ../common/asinz */ "./node_modules/proj4/lib/common/asinz.js");
/* Initialize the Van Der Grinten projection
  ----------------------------------------*/
exports.init = function() {
  //this.R = 6370997; //Radius of earth
  this.R = this.a;
};

exports.forward = function(p) {

  var lon = p.x;
  var lat = p.y;

  /* Forward equations
    -----------------*/
  var dlon = adjust_lon(lon - this.long0);
  var x, y;

  if (Math.abs(lat) <= EPSLN) {
    x = this.x0 + this.R * dlon;
    y = this.y0;
  }
  var theta = asinz(2 * Math.abs(lat / Math.PI));
  if ((Math.abs(dlon) <= EPSLN) || (Math.abs(Math.abs(lat) - HALF_PI) <= EPSLN)) {
    x = this.x0;
    if (lat >= 0) {
      y = this.y0 + Math.PI * this.R * Math.tan(0.5 * theta);
    }
    else {
      y = this.y0 + Math.PI * this.R * -Math.tan(0.5 * theta);
    }
    //  return(OK);
  }
  var al = 0.5 * Math.abs((Math.PI / dlon) - (dlon / Math.PI));
  var asq = al * al;
  var sinth = Math.sin(theta);
  var costh = Math.cos(theta);

  var g = costh / (sinth + costh - 1);
  var gsq = g * g;
  var m = g * (2 / sinth - 1);
  var msq = m * m;
  var con = Math.PI * this.R * (al * (g - msq) + Math.sqrt(asq * (g - msq) * (g - msq) - (msq + asq) * (gsq - msq))) / (msq + asq);
  if (dlon < 0) {
    con = -con;
  }
  x = this.x0 + con;
  //con = Math.abs(con / (Math.PI * this.R));
  var q = asq + g;
  con = Math.PI * this.R * (m * q - al * Math.sqrt((msq + asq) * (asq + 1) - q * q)) / (msq + asq);
  if (lat >= 0) {
    //y = this.y0 + Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 + con;
  }
  else {
    //y = this.y0 - Math.PI * this.R * Math.sqrt(1 - con * con - 2 * al * con);
    y = this.y0 - con;
  }
  p.x = x;
  p.y = y;
  return p;
};

/* Van Der Grinten inverse equations--mapping x,y to lat/long
  ---------------------------------------------------------*/
exports.inverse = function(p) {
  var lon, lat;
  var xx, yy, xys, c1, c2, c3;
  var a1;
  var m1;
  var con;
  var th1;
  var d;

  /* inverse equations
    -----------------*/
  p.x -= this.x0;
  p.y -= this.y0;
  con = Math.PI * this.R;
  xx = p.x / con;
  yy = p.y / con;
  xys = xx * xx + yy * yy;
  c1 = -Math.abs(yy) * (1 + xys);
  c2 = c1 - 2 * yy * yy + xx * xx;
  c3 = -2 * c1 + 1 + 2 * yy * yy + xys * xys;
  d = yy * yy / c3 + (2 * c2 * c2 * c2 / c3 / c3 / c3 - 9 * c1 * c2 / c3 / c3) / 27;
  a1 = (c1 - c2 * c2 / 3 / c3) / c3;
  m1 = 2 * Math.sqrt(-a1 / 3);
  con = ((3 * d) / a1) / m1;
  if (Math.abs(con) > 1) {
    if (con >= 0) {
      con = 1;
    }
    else {
      con = -1;
    }
  }
  th1 = Math.acos(con) / 3;
  if (p.y >= 0) {
    lat = (-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  }
  else {
    lat = -(-m1 * Math.cos(th1 + Math.PI / 3) - c2 / 3 / c3) * Math.PI;
  }

  if (Math.abs(xx) < EPSLN) {
    lon = this.long0;
  }
  else {
    lon = adjust_lon(this.long0 + Math.PI * (xys - 1 + Math.sqrt(1 + 2 * (xx * xx - yy * yy) + xys * xys)) / 2 / xx);
  }

  p.x = lon;
  p.y = lat;
  return p;
};
exports.names = ["Van_der_Grinten_I", "VanDerGrinten", "vandg"];

/***/ }),

/***/ "./node_modules/proj4/lib/transform.js":
/*!*********************************************!*\
  !*** ./node_modules/proj4/lib/transform.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var D2R = 0.01745329251994329577;
var R2D = 57.29577951308232088;
var PJD_3PARAM = 1;
var PJD_7PARAM = 2;
var datum_transform = __webpack_require__(/*! ./datum_transform */ "./node_modules/proj4/lib/datum_transform.js");
var adjust_axis = __webpack_require__(/*! ./adjust_axis */ "./node_modules/proj4/lib/adjust_axis.js");
var proj = __webpack_require__(/*! ./Proj */ "./node_modules/proj4/lib/Proj.js");
var toPoint = __webpack_require__(/*! ./common/toPoint */ "./node_modules/proj4/lib/common/toPoint.js");
module.exports = function transform(source, dest, point) {
  var wgs84;
  if (Array.isArray(point)) {
    point = toPoint(point);
  }
  function checkNotWGS(source, dest) {
    return ((source.datum.datum_type === PJD_3PARAM || source.datum.datum_type === PJD_7PARAM) && dest.datumCode !== "WGS84");
  }

  // Workaround for datum shifts towgs84, if either source or destination projection is not wgs84
  if (source.datum && dest.datum && (checkNotWGS(source, dest) || checkNotWGS(dest, source))) {
    wgs84 = new proj('WGS84');
    transform(source, wgs84, point);
    source = wgs84;
  }
  // DGR, 2010/11/12
  if (source.axis !== "enu") {
    adjust_axis(source, false, point);
  }
  // Transform source points to long/lat, if they aren't already.
  if (source.projName === "longlat") {
    point.x *= D2R; // convert degrees to radians
    point.y *= D2R;
  }
  else {
    if (source.to_meter) {
      point.x *= source.to_meter;
      point.y *= source.to_meter;
    }
    source.inverse(point); // Convert Cartesian to longlat
  }
  // Adjust for the prime meridian if necessary
  if (source.from_greenwich) {
    point.x += source.from_greenwich;
  }

  // Convert datums if needed, and if possible.
  point = datum_transform(source.datum, dest.datum, point);

  // Adjust for the prime meridian if necessary
  if (dest.from_greenwich) {
    point.x -= dest.from_greenwich;
  }

  if (dest.projName === "longlat") {
    // convert radians to decimal degrees
    point.x *= R2D;
    point.y *= R2D;
  }
  else { // else project
    dest.forward(point);
    if (dest.to_meter) {
      point.x /= dest.to_meter;
      point.y /= dest.to_meter;
    }
  }

  // DGR, 2010/11/12
  if (dest.axis !== "enu") {
    adjust_axis(dest, true, point);
  }

  return point;
};

/***/ }),

/***/ "./node_modules/proj4/lib/wkt.js":
/*!***************************************!*\
  !*** ./node_modules/proj4/lib/wkt.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var D2R = 0.01745329251994329577;
var extend = __webpack_require__(/*! ./extend */ "./node_modules/proj4/lib/extend.js");

function mapit(obj, key, v) {
  obj[key] = v.map(function(aa) {
    var o = {};
    sExpr(aa, o);
    return o;
  }).reduce(function(a, b) {
    return extend(a, b);
  }, {});
}

function sExpr(v, obj) {
  var key;
  if (!Array.isArray(v)) {
    obj[v] = true;
    return;
  }
  else {
    key = v.shift();
    if (key === 'PARAMETER') {
      key = v.shift();
    }
    if (v.length === 1) {
      if (Array.isArray(v[0])) {
        obj[key] = {};
        sExpr(v[0], obj[key]);
      }
      else {
        obj[key] = v[0];
      }
    }
    else if (!v.length) {
      obj[key] = true;
    }
    else if (key === 'TOWGS84') {
      obj[key] = v;
    }
    else {
      obj[key] = {};
      if (['UNIT', 'PRIMEM', 'VERT_DATUM'].indexOf(key) > -1) {
        obj[key] = {
          name: v[0].toLowerCase(),
          convert: v[1]
        };
        if (v.length === 3) {
          obj[key].auth = v[2];
        }
      }
      else if (key === 'SPHEROID') {
        obj[key] = {
          name: v[0],
          a: v[1],
          rf: v[2]
        };
        if (v.length === 4) {
          obj[key].auth = v[3];
        }
      }
      else if (['GEOGCS', 'GEOCCS', 'DATUM', 'VERT_CS', 'COMPD_CS', 'LOCAL_CS', 'FITTED_CS', 'LOCAL_DATUM'].indexOf(key) > -1) {
        v[0] = ['name', v[0]];
        mapit(obj, key, v);
      }
      else if (v.every(function(aa) {
        return Array.isArray(aa);
      })) {
        mapit(obj, key, v);
      }
      else {
        sExpr(v, obj[key]);
      }
    }
  }
}

function rename(obj, params) {
  var outName = params[0];
  var inName = params[1];
  if (!(outName in obj) && (inName in obj)) {
    obj[outName] = obj[inName];
    if (params.length === 3) {
      obj[outName] = params[2](obj[outName]);
    }
  }
}

function d2r(input) {
  return input * D2R;
}

function cleanWKT(wkt) {
  if (wkt.type === 'GEOGCS') {
    wkt.projName = 'longlat';
  }
  else if (wkt.type === 'LOCAL_CS') {
    wkt.projName = 'identity';
    wkt.local = true;
  }
  else {
    if (typeof wkt.PROJECTION === "object") {
      wkt.projName = Object.keys(wkt.PROJECTION)[0];
    }
    else {
      wkt.projName = wkt.PROJECTION;
    }
  }
  if (wkt.UNIT) {
    wkt.units = wkt.UNIT.name.toLowerCase();
    if (wkt.units === 'metre') {
      wkt.units = 'meter';
    }
    if (wkt.UNIT.convert) {
      wkt.to_meter = parseFloat(wkt.UNIT.convert, 10);
    }
  }

  if (wkt.GEOGCS) {
    //if(wkt.GEOGCS.PRIMEM&&wkt.GEOGCS.PRIMEM.convert){
    //  wkt.from_greenwich=wkt.GEOGCS.PRIMEM.convert*D2R;
    //}
    if (wkt.GEOGCS.DATUM) {
      wkt.datumCode = wkt.GEOGCS.DATUM.name.toLowerCase();
    }
    else {
      wkt.datumCode = wkt.GEOGCS.name.toLowerCase();
    }
    if (wkt.datumCode.slice(0, 2) === 'd_') {
      wkt.datumCode = wkt.datumCode.slice(2);
    }
    if (wkt.datumCode === 'new_zealand_geodetic_datum_1949' || wkt.datumCode === 'new_zealand_1949') {
      wkt.datumCode = 'nzgd49';
    }
    if (wkt.datumCode === "wgs_1984") {
      if (wkt.PROJECTION === 'Mercator_Auxiliary_Sphere') {
        wkt.sphere = true;
      }
      wkt.datumCode = 'wgs84';
    }
    if (wkt.datumCode.slice(-6) === '_ferro') {
      wkt.datumCode = wkt.datumCode.slice(0, - 6);
    }
    if (wkt.datumCode.slice(-8) === '_jakarta') {
      wkt.datumCode = wkt.datumCode.slice(0, - 8);
    }
    if (~wkt.datumCode.indexOf('belge')) {
      wkt.datumCode = "rnb72";
    }
    if (wkt.GEOGCS.DATUM && wkt.GEOGCS.DATUM.SPHEROID) {
      wkt.ellps = wkt.GEOGCS.DATUM.SPHEROID.name.replace('_19', '').replace(/[Cc]larke\_18/, 'clrk');
      if (wkt.ellps.toLowerCase().slice(0, 13) === "international") {
        wkt.ellps = 'intl';
      }

      wkt.a = wkt.GEOGCS.DATUM.SPHEROID.a;
      wkt.rf = parseFloat(wkt.GEOGCS.DATUM.SPHEROID.rf, 10);
    }
    if (~wkt.datumCode.indexOf('osgb_1936')) {
      wkt.datumCode = "osgb36";
    }
  }
  if (wkt.b && !isFinite(wkt.b)) {
    wkt.b = wkt.a;
  }

  function toMeter(input) {
    var ratio = wkt.to_meter || 1;
    return parseFloat(input, 10) * ratio;
  }
  var renamer = function(a) {
    return rename(wkt, a);
  };
  var list = [
    ['standard_parallel_1', 'Standard_Parallel_1'],
    ['standard_parallel_2', 'Standard_Parallel_2'],
    ['false_easting', 'False_Easting'],
    ['false_northing', 'False_Northing'],
    ['central_meridian', 'Central_Meridian'],
    ['latitude_of_origin', 'Latitude_Of_Origin'],
    ['latitude_of_origin', 'Central_Parallel'],
    ['scale_factor', 'Scale_Factor'],
    ['k0', 'scale_factor'],
    ['latitude_of_center', 'Latitude_of_center'],
    ['lat0', 'latitude_of_center', d2r],
    ['longitude_of_center', 'Longitude_Of_Center'],
    ['longc', 'longitude_of_center', d2r],
    ['x0', 'false_easting', toMeter],
    ['y0', 'false_northing', toMeter],
    ['long0', 'central_meridian', d2r],
    ['lat0', 'latitude_of_origin', d2r],
    ['lat0', 'standard_parallel_1', d2r],
    ['lat1', 'standard_parallel_1', d2r],
    ['lat2', 'standard_parallel_2', d2r],
    ['alpha', 'azimuth', d2r],
    ['srsCode', 'name']
  ];
  list.forEach(renamer);
  if (!wkt.long0 && wkt.longc && (wkt.projName === 'Albers_Conic_Equal_Area' || wkt.projName === "Lambert_Azimuthal_Equal_Area")) {
    wkt.long0 = wkt.longc;
  }
  if (!wkt.lat_ts && wkt.lat1 && (wkt.projName === 'Stereographic_South_Pole' || wkt.projName === 'Polar Stereographic (variant B)')) {
    wkt.lat0 = d2r(wkt.lat1 > 0 ? 90 : -90);
    wkt.lat_ts = wkt.lat1;
  }
}
module.exports = function(wkt, self) {
  var lisp = JSON.parse(("," + wkt).replace(/\s*\,\s*([A-Z_0-9]+?)(\[)/g, ',["$1",').slice(1).replace(/\s*\,\s*([A-Z_0-9]+?)\]/g, ',"$1"]').replace(/,\["VERTCS".+/,''));
  var type = lisp.shift();
  var name = lisp.shift();
  lisp.unshift(['name', name]);
  lisp.unshift(['type', type]);
  lisp.unshift('output');
  var obj = {};
  sExpr(lisp, obj);
  cleanWKT(obj.output);
  return extend(self, obj.output);
};


/***/ }),

/***/ "./node_modules/proj4/package.json":
/*!*****************************************!*\
  !*** ./node_modules/proj4/package.json ***!
  \*****************************************/
/*! exports provided: name, version, description, main, directories, scripts, repository, author, license, jam, devDependencies, dependencies, _resolved, _integrity, _from, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"name\":\"proj4\",\"version\":\"2.3.6\",\"description\":\"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.\",\"main\":\"lib/index.js\",\"directories\":{\"test\":\"test\",\"doc\":\"docs\"},\"scripts\":{\"test\":\"./node_modules/istanbul/lib/cli.js test ./node_modules/mocha/bin/_mocha test/test.js\"},\"repository\":{\"type\":\"git\",\"url\":\"git://github.com/proj4js/proj4js.git\"},\"author\":\"\",\"license\":\"MIT\",\"jam\":{\"main\":\"dist/proj4.js\",\"include\":[\"dist/proj4.js\",\"README.md\",\"AUTHORS\",\"LICENSE.md\"]},\"devDependencies\":{\"grunt-cli\":\"~0.1.13\",\"grunt\":\"~0.4.2\",\"grunt-contrib-connect\":\"~0.6.0\",\"grunt-contrib-jshint\":\"~0.8.0\",\"chai\":\"~1.8.1\",\"mocha\":\"~1.17.1\",\"grunt-mocha-phantomjs\":\"~0.4.0\",\"browserify\":\"~3.24.5\",\"grunt-browserify\":\"~1.3.0\",\"grunt-contrib-uglify\":\"~0.3.2\",\"curl\":\"git://github.com/cujojs/curl.git\",\"istanbul\":\"~0.2.4\",\"tin\":\"~0.4.0\"},\"dependencies\":{\"mgrs\":\"0.0.0\"},\"_resolved\":\"https://registry.npmjs.org/proj4/-/proj4-2.3.6.tgz\",\"_integrity\":\"sha512-9vNelMpWCE3kMlDA92fLkoM42P+ECSDwuiaQBExD+vEn/7lkFzLwEfarkx9vvSkPGPE93Tq5jYQQ7/DSStZ/ZA==\",\"_from\":\"proj4@2.3.6\"}");

/***/ }),

/***/ "./node_modules/readable-stream/duplex.js":
/*!************************************************!*\
  !*** ./node_modules/readable-stream/duplex.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js")


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_duplex.js":
/*!************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_duplex.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

module.exports = Duplex;

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}
/*</replacement>*/


/*<replacement>*/
var util = __webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Readable = __webpack_require__(/*! ./_stream_readable */ "./node_modules/readable-stream/lib/_stream_readable.js");
var Writable = __webpack_require__(/*! ./_stream_writable */ "./node_modules/readable-stream/lib/_stream_writable.js");

util.inherits(Duplex, Readable);

forEach(objectKeys(Writable.prototype), function(method) {
  if (!Duplex.prototype[method])
    Duplex.prototype[method] = Writable.prototype[method];
});

function Duplex(options) {
  if (!(this instanceof Duplex))
    return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false)
    this.readable = false;

  if (options && options.writable === false)
    this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false)
    this.allowHalfOpen = false;

  this.once('end', onend);
}

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended)
    return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  process.nextTick(this.end.bind(this));
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_passthrough.js":
/*!*****************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_passthrough.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.

module.exports = PassThrough;

var Transform = __webpack_require__(/*! ./_stream_transform */ "./node_modules/readable-stream/lib/_stream_transform.js");

/*<replacement>*/
var util = __webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough))
    return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function(chunk, encoding, cb) {
  cb(null, chunk);
};


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_readable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_readable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(/*! isarray */ "./node_modules/isarray/index.js");
/*</replacement>*/


/*<replacement>*/
var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;
/*</replacement>*/

Readable.ReadableState = ReadableState;

var EE = __webpack_require__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;

/*<replacement>*/
if (!EE.listenerCount) EE.listenerCount = function(emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

var Stream = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js");

/*<replacement>*/
var util = __webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var StringDecoder;


/*<replacement>*/
var debug = __webpack_require__(/*! util */ 1);
if (debug && debug.debuglog) {
  debug = debug.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/


util.inherits(Readable, Stream);

function ReadableState(options, stream) {
  var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.buffer = [];
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;


  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.readableObjectMode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // when piping, we only care about 'readable' events that happen
  // after read()ing all the bytes and not getting any pushback.
  this.ranOut = false;

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder)
      StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/node-libs-browser/node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  if (!(this instanceof Readable))
    return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  Stream.call(this);
}

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function(chunk, encoding) {
  var state = this._readableState;

  if (util.isString(chunk) && !state.objectMode) {
    encoding = encoding || state.defaultEncoding;
    if (encoding !== state.encoding) {
      chunk = new Buffer(chunk, encoding);
      encoding = '';
    }
  }

  return readableAddChunk(this, state, chunk, encoding, false);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function(chunk) {
  var state = this._readableState;
  return readableAddChunk(this, state, chunk, '', true);
};

function readableAddChunk(stream, state, chunk, encoding, addToFront) {
  var er = chunkInvalid(state, chunk);
  if (er) {
    stream.emit('error', er);
  } else if (util.isNullOrUndefined(chunk)) {
    state.reading = false;
    if (!state.ended)
      onEofChunk(stream, state);
  } else if (state.objectMode || chunk && chunk.length > 0) {
    if (state.ended && !addToFront) {
      var e = new Error('stream.push() after EOF');
      stream.emit('error', e);
    } else if (state.endEmitted && addToFront) {
      var e = new Error('stream.unshift() after end event');
      stream.emit('error', e);
    } else {
      if (state.decoder && !addToFront && !encoding)
        chunk = state.decoder.write(chunk);

      if (!addToFront)
        state.reading = false;

      // if we want the data now, just emit it.
      if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
      } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront)
          state.buffer.unshift(chunk);
        else
          state.buffer.push(chunk);

        if (state.needReadable)
          emitReadable(stream);
      }

      maybeReadMore(stream, state);
    }
  } else if (!addToFront) {
    state.reading = false;
  }

  return needMoreData(state);
}



// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended &&
         (state.needReadable ||
          state.length < state.highWaterMark ||
          state.length === 0);
}

// backwards compatibility.
Readable.prototype.setEncoding = function(enc) {
  if (!StringDecoder)
    StringDecoder = __webpack_require__(/*! string_decoder/ */ "./node_modules/node-libs-browser/node_modules/string_decoder/lib/string_decoder.js").StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 128MB
var MAX_HWM = 0x800000;
function roundUpToNextPowerOf2(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2
    n--;
    for (var p = 1; p < 32; p <<= 1) n |= n >> p;
    n++;
  }
  return n;
}

function howMuchToRead(n, state) {
  if (state.length === 0 && state.ended)
    return 0;

  if (state.objectMode)
    return n === 0 ? 0 : 1;

  if (isNaN(n) || util.isNull(n)) {
    // only flow one buffer at a time
    if (state.flowing && state.buffer.length)
      return state.buffer[0].length;
    else
      return state.length;
  }

  if (n <= 0)
    return 0;

  // If we're asking for more than the target buffer level,
  // then raise the water mark.  Bump up to the next highest
  // power of 2, to prevent increasing it excessively in tiny
  // amounts.
  if (n > state.highWaterMark)
    state.highWaterMark = roundUpToNextPowerOf2(n);

  // don't have that much.  return null, unless we've ended.
  if (n > state.length) {
    if (!state.ended) {
      state.needReadable = true;
      return 0;
    } else
      return state.length;
  }

  return n;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function(n) {
  debug('read', n);
  var state = this._readableState;
  var nOrig = n;

  if (!util.isNumber(n) || n > 0)
    state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 &&
      state.needReadable &&
      (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended)
      endReadable(this);
    else
      emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0)
      endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  }

  if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0)
      state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
  }

  // If _read pushed data synchronously, then `reading` will be false,
  // and we need to re-evaluate how much data we can return to the user.
  if (doRead && !state.reading)
    n = howMuchToRead(nOrig, state);

  var ret;
  if (n > 0)
    ret = fromList(n, state);
  else
    ret = null;

  if (util.isNull(ret)) {
    state.needReadable = true;
    n = 0;
  }

  state.length -= n;

  // If we have nothing in the buffer, then we want to know
  // as soon as we *do* get something into the buffer.
  if (state.length === 0 && !state.ended)
    state.needReadable = true;

  // If we tried to read() past the EOF, then emit end on the next tick.
  if (nOrig !== n && state.ended && state.length === 0)
    endReadable(this);

  if (!util.isNull(ret))
    this.emit('data', ret);

  return ret;
};

function chunkInvalid(state, chunk) {
  var er = null;
  if (!util.isBuffer(chunk) &&
      !util.isString(chunk) &&
      !util.isNullOrUndefined(chunk) &&
      !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}


function onEofChunk(stream, state) {
  if (state.decoder && !state.ended) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync)
      process.nextTick(function() {
        emitReadable_(stream);
      });
    else
      emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}


// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    process.nextTick(function() {
      maybeReadMore_(stream, state);
    });
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended &&
         state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;
    else
      len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function(n) {
  this.emit('error', new Error('not implemented'));
};

Readable.prototype.pipe = function(dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) &&
              dest !== process.stdout &&
              dest !== process.stderr;

  var endFn = doEnd ? onend : cleanup;
  if (state.endEmitted)
    process.nextTick(endFn);
  else
    src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable) {
    debug('onunpipe');
    if (readable === src) {
      cleanup();
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', cleanup);
    src.removeListener('data', ondata);

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain &&
        (!dest._writableState || dest._writableState.needDrain))
      ondrain();
  }

  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    var ret = dest.write(chunk);
    if (false === ret) {
      debug('false write response, pause',
            src._readableState.awaitDrain);
      src._readableState.awaitDrain++;
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EE.listenerCount(dest, 'error') === 0)
      dest.emit('error', er);
  }
  // This is a brutally ugly hack to make sure that our error handler
  // is attached before any userland ones.  NEVER DO THIS.
  if (!dest._events || !dest._events.error)
    dest.on('error', onerror);
  else if (isArray(dest._events.error))
    dest._events.error.unshift(onerror);
  else
    dest._events.error = [onerror, dest._events.error];



  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function() {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain)
      state.awaitDrain--;
    if (state.awaitDrain === 0 && EE.listenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}


Readable.prototype.unpipe = function(dest) {
  var state = this._readableState;

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0)
    return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes)
      return this;

    if (!dest)
      dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest)
      dest.emit('unpipe', this);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++)
      dests[i].emit('unpipe', this);
    return this;
  }

  // try to find the right one.
  var i = indexOf(state.pipes, dest);
  if (i === -1)
    return this;

  state.pipes.splice(i, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1)
    state.pipes = state.pipes[0];

  dest.emit('unpipe', this);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function(ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  // If listening to data, and it has not explicitly been paused,
  // then call resume to start the flow of data on the next tick.
  if (ev === 'data' && false !== this._readableState.flowing) {
    this.resume();
  }

  if (ev === 'readable' && this.readable) {
    var state = this._readableState;
    if (!state.readableListening) {
      state.readableListening = true;
      state.emittedReadable = false;
      state.needReadable = true;
      if (!state.reading) {
        var self = this;
        process.nextTick(function() {
          debug('readable nexttick read 0');
          self.read(0);
        });
      } else if (state.length) {
        emitReadable(this, state);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function() {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    if (!state.reading) {
      debug('resume read 0');
      this.read(0);
    }
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    process.nextTick(function() {
      resume_(stream, state);
    });
  }
}

function resume_(stream, state) {
  state.resumeScheduled = false;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading)
    stream.read(0);
}

Readable.prototype.pause = function() {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  if (state.flowing) {
    do {
      var chunk = stream.read();
    } while (null !== chunk && state.flowing);
  }
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function(stream) {
  var state = this._readableState;
  var paused = false;

  var self = this;
  stream.on('end', function() {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length)
        self.push(chunk);
    }

    self.push(null);
  });

  stream.on('data', function(chunk) {
    debug('wrapped data');
    if (state.decoder)
      chunk = state.decoder.write(chunk);
    if (!chunk || !state.objectMode && !chunk.length)
      return;

    var ret = self.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (util.isFunction(stream[i]) && util.isUndefined(this[i])) {
      this[i] = function(method) { return function() {
        return stream[method].apply(stream, arguments);
      }}(i);
    }
  }

  // proxy certain important events.
  var events = ['error', 'close', 'destroy', 'pause', 'resume'];
  forEach(events, function(ev) {
    stream.on(ev, self.emit.bind(self, ev));
  });

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  self._read = function(n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return self;
};



// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
function fromList(n, state) {
  var list = state.buffer;
  var length = state.length;
  var stringMode = !!state.decoder;
  var objectMode = !!state.objectMode;
  var ret;

  // nothing in the list, definitely empty.
  if (list.length === 0)
    return null;

  if (length === 0)
    ret = null;
  else if (objectMode)
    ret = list.shift();
  else if (!n || n >= length) {
    // read it all, truncate the array.
    if (stringMode)
      ret = list.join('');
    else
      ret = Buffer.concat(list, length);
    list.length = 0;
  } else {
    // read just some of it.
    if (n < list[0].length) {
      // just take a part of the first list item.
      // slice is the same for buffers and strings.
      var buf = list[0];
      ret = buf.slice(0, n);
      list[0] = buf.slice(n);
    } else if (n === list[0].length) {
      // first list is a perfect match
      ret = list.shift();
    } else {
      // complex case.
      // we have enough to cover it, but it spans past the first buffer.
      if (stringMode)
        ret = '';
      else
        ret = new Buffer(n);

      var c = 0;
      for (var i = 0, l = list.length; i < l && c < n; i++) {
        var buf = list[0];
        var cpy = Math.min(n - c, buf.length);

        if (stringMode)
          ret += buf.slice(0, cpy);
        else
          buf.copy(ret, c, 0, cpy);

        if (cpy < buf.length)
          list[0] = buf.slice(cpy);
        else
          list.shift();

        c += cpy;
      }
    }
  }

  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0)
    throw new Error('endReadable called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    process.nextTick(function() {
      // Check that we didn't get one last unshift.
      if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
      }
    });
  }
}

function forEach (xs, f) {
  for (var i = 0, l = xs.length; i < l; i++) {
    f(xs[i], i);
  }
}

function indexOf (xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_transform.js":
/*!***************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_transform.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.


// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.

module.exports = Transform;

var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

/*<replacement>*/
var util = __webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

util.inherits(Transform, Duplex);


function TransformState(options, stream) {
  this.afterTransform = function(er, data) {
    return afterTransform(stream, er, data);
  };

  this.needTransform = false;
  this.transforming = false;
  this.writecb = null;
  this.writechunk = null;
}

function afterTransform(stream, er, data) {
  var ts = stream._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb)
    return stream.emit('error', new Error('no writecb in Transform class'));

  ts.writechunk = null;
  ts.writecb = null;

  if (!util.isNullOrUndefined(data))
    stream.push(data);

  if (cb)
    cb(er);

  var rs = stream._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    stream._read(rs.highWaterMark);
  }
}


function Transform(options) {
  if (!(this instanceof Transform))
    return new Transform(options);

  Duplex.call(this, options);

  this._transformState = new TransformState(options, this);

  // when the writable side finishes, then flush out anything remaining.
  var stream = this;

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  this.once('prefinish', function() {
    if (util.isFunction(this._flush))
      this._flush(function(er) {
        done(stream, er);
      });
    else
      done(stream);
  });
}

Transform.prototype.push = function(chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function(chunk, encoding, cb) {
  throw new Error('not implemented');
};

Transform.prototype._write = function(chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform ||
        rs.needReadable ||
        rs.length < rs.highWaterMark)
      this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function(n) {
  var ts = this._transformState;

  if (!util.isNull(ts.writechunk) && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};


function done(stream, er) {
  if (er)
    return stream.emit('error', er);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  var ws = stream._writableState;
  var ts = stream._transformState;

  if (ws.length)
    throw new Error('calling transform done when ws.length != 0');

  if (ts.transforming)
    throw new Error('calling transform done when still transforming');

  return stream.push(null);
}


/***/ }),

/***/ "./node_modules/readable-stream/lib/_stream_writable.js":
/*!**************************************************************!*\
  !*** ./node_modules/readable-stream/lib/_stream_writable.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, cb), and it'll handle all
// the drain event emission and buffering.

module.exports = Writable;

/*<replacement>*/
var Buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js").Buffer;
/*</replacement>*/

Writable.WritableState = WritableState;


/*<replacement>*/
var util = __webpack_require__(/*! core-util-is */ "./node_modules/core-util-is/lib/util.js");
util.inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");
/*</replacement>*/

var Stream = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js");

util.inherits(Writable, Stream);

function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
}

function WritableState(options, stream) {
  var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  options = options || {};

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var defaultHwm = options.objectMode ? 16 : 16 * 1024;
  this.highWaterMark = (hwm || hwm === 0) ? hwm : defaultHwm;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (stream instanceof Duplex)
    this.objectMode = this.objectMode || !!options.writableObjectMode;

  // cast to ints.
  this.highWaterMark = ~~this.highWaterMark;

  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function(er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.buffer = [];

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;
}

function Writable(options) {
  var Duplex = __webpack_require__(/*! ./_stream_duplex */ "./node_modules/readable-stream/lib/_stream_duplex.js");

  // Writable ctor is applied to Duplexes, though they're not
  // instanceof Writable, they're instanceof Readable.
  if (!(this instanceof Writable) && !(this instanceof Duplex))
    return new Writable(options);

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function() {
  this.emit('error', new Error('Cannot pipe. Not readable.'));
};


function writeAfterEnd(stream, state, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  process.nextTick(function() {
    cb(er);
  });
}

// If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  if (!util.isBuffer(chunk) &&
      !util.isString(chunk) &&
      !util.isNullOrUndefined(chunk) &&
      !state.objectMode) {
    var er = new TypeError('Invalid non-string/buffer chunk');
    stream.emit('error', er);
    process.nextTick(function() {
      cb(er);
    });
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function(chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;

  if (util.isFunction(encoding)) {
    cb = encoding;
    encoding = null;
  }

  if (util.isBuffer(chunk))
    encoding = 'buffer';
  else if (!encoding)
    encoding = state.defaultEncoding;

  if (!util.isFunction(cb))
    cb = function() {};

  if (state.ended)
    writeAfterEnd(this, state, cb);
  else if (validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function() {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function() {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing &&
        !state.corked &&
        !state.finished &&
        !state.bufferProcessing &&
        state.buffer.length)
      clearBuffer(this, state);
  }
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode &&
      state.decodeStrings !== false &&
      util.isString(chunk)) {
    chunk = new Buffer(chunk, encoding);
  }
  return chunk;
}

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, chunk, encoding, cb) {
  chunk = decodeChunk(state, chunk, encoding);
  if (util.isBuffer(chunk))
    encoding = 'buffer';
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret)
    state.needDrain = true;

  if (state.writing || state.corked)
    state.buffer.push(new WriteReq(chunk, encoding, cb));
  else
    doWrite(stream, state, false, len, chunk, encoding, cb);

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev)
    stream._writev(chunk, state.onwrite);
  else
    stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  if (sync)
    process.nextTick(function() {
      state.pendingcb--;
      cb(er);
    });
  else {
    state.pendingcb--;
    cb(er);
  }

  stream._writableState.errorEmitted = true;
  stream.emit('error', er);
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er)
    onwriteError(stream, state, sync, er, cb);
  else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(stream, state);

    if (!finished &&
        !state.corked &&
        !state.bufferProcessing &&
        state.buffer.length) {
      clearBuffer(stream, state);
    }

    if (sync) {
      process.nextTick(function() {
        afterWrite(stream, state, finished, cb);
      });
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished)
    onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}


// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;

  if (stream._writev && state.buffer.length > 1) {
    // Fast case, write everything using _writev()
    var cbs = [];
    for (var c = 0; c < state.buffer.length; c++)
      cbs.push(state.buffer[c].callback);

    // count the one we are adding, as well.
    // TODO(isaacs) clean this up
    state.pendingcb++;
    doWrite(stream, state, true, state.length, state.buffer, '', function(err) {
      for (var i = 0; i < cbs.length; i++) {
        state.pendingcb--;
        cbs[i](err);
      }
    });

    // Clear buffer
    state.buffer = [];
  } else {
    // Slow case, write chunks one-by-one
    for (var c = 0; c < state.buffer.length; c++) {
      var entry = state.buffer[c];
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);

      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        c++;
        break;
      }
    }

    if (c < state.buffer.length)
      state.buffer = state.buffer.slice(c);
    else
      state.buffer.length = 0;
  }

  state.bufferProcessing = false;
}

Writable.prototype._write = function(chunk, encoding, cb) {
  cb(new Error('not implemented'));

};

Writable.prototype._writev = null;

Writable.prototype.end = function(chunk, encoding, cb) {
  var state = this._writableState;

  if (util.isFunction(chunk)) {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (util.isFunction(encoding)) {
    cb = encoding;
    encoding = null;
  }

  if (!util.isNullOrUndefined(chunk))
    this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished)
    endWritable(this, state, cb);
};


function needFinish(stream, state) {
  return (state.ending &&
          state.length === 0 &&
          !state.finished &&
          !state.writing);
}

function prefinish(stream, state) {
  if (!state.prefinished) {
    state.prefinished = true;
    stream.emit('prefinish');
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(stream, state);
  if (need) {
    if (state.pendingcb === 0) {
      prefinish(stream, state);
      state.finished = true;
      stream.emit('finish');
    } else
      prefinish(stream, state);
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished)
      process.nextTick(cb);
    else
      stream.once('finish', cb);
  }
  state.ended = true;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/passthrough.js":
/*!*****************************************************!*\
  !*** ./node_modules/readable-stream/passthrough.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_passthrough.js */ "./node_modules/readable-stream/lib/_stream_passthrough.js")


/***/ }),

/***/ "./node_modules/readable-stream/readable.js":
/*!**************************************************!*\
  !*** ./node_modules/readable-stream/readable.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = __webpack_require__(/*! ./lib/_stream_readable.js */ "./node_modules/readable-stream/lib/_stream_readable.js");
exports.Stream = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js");
exports.Readable = exports;
exports.Writable = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js");
exports.Duplex = __webpack_require__(/*! ./lib/_stream_duplex.js */ "./node_modules/readable-stream/lib/_stream_duplex.js");
exports.Transform = __webpack_require__(/*! ./lib/_stream_transform.js */ "./node_modules/readable-stream/lib/_stream_transform.js");
exports.PassThrough = __webpack_require__(/*! ./lib/_stream_passthrough.js */ "./node_modules/readable-stream/lib/_stream_passthrough.js");
if (!process.browser && process.env.READABLE_STREAM === 'disable') {
  module.exports = __webpack_require__(/*! stream */ "./node_modules/stream-browserify/index.js");
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/readable-stream/transform.js":
/*!***************************************************!*\
  !*** ./node_modules/readable-stream/transform.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_transform.js */ "./node_modules/readable-stream/lib/_stream_transform.js")


/***/ }),

/***/ "./node_modules/readable-stream/writable.js":
/*!**************************************************!*\
  !*** ./node_modules/readable-stream/writable.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./lib/_stream_writable.js */ "./node_modules/readable-stream/lib/_stream_writable.js")


/***/ }),

/***/ "./node_modules/safe-buffer/index.js":
/*!*******************************************!*\
  !*** ./node_modules/safe-buffer/index.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(/*! buffer */ "./node_modules/node-libs-browser/node_modules/buffer/index.js")
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ "./node_modules/screenfull/dist/screenfull.js":
/*!****************************************************!*\
  !*** ./node_modules/screenfull/dist/screenfull.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*!
* screenfull
* v3.0.0 - 2015-11-24
* (c) Sindre Sorhus; MIT License
*/
(function () {
	'use strict';

	var isCommonjs =  true && module.exports;
	var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;

	var fn = (function () {
		var val;
		var valLength;

		var fnMap = [
			[
				'requestFullscreen',
				'exitFullscreen',
				'fullscreenElement',
				'fullscreenEnabled',
				'fullscreenchange',
				'fullscreenerror'
			],
			// new WebKit
			[
				'webkitRequestFullscreen',
				'webkitExitFullscreen',
				'webkitFullscreenElement',
				'webkitFullscreenEnabled',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			// old WebKit (Safari 5.1)
			[
				'webkitRequestFullScreen',
				'webkitCancelFullScreen',
				'webkitCurrentFullScreenElement',
				'webkitCancelFullScreen',
				'webkitfullscreenchange',
				'webkitfullscreenerror'

			],
			[
				'mozRequestFullScreen',
				'mozCancelFullScreen',
				'mozFullScreenElement',
				'mozFullScreenEnabled',
				'mozfullscreenchange',
				'mozfullscreenerror'
			],
			[
				'msRequestFullscreen',
				'msExitFullscreen',
				'msFullscreenElement',
				'msFullscreenEnabled',
				'MSFullscreenChange',
				'MSFullscreenError'
			]
		];

		var i = 0;
		var l = fnMap.length;
		var ret = {};

		for (; i < l; i++) {
			val = fnMap[i];
			if (val && val[1] in document) {
				for (i = 0, valLength = val.length; i < valLength; i++) {
					ret[fnMap[0][i]] = val[i];
				}
				return ret;
			}
		}

		return false;
	})();

	var screenfull = {
		request: function (elem) {
			var request = fn.requestFullscreen;

			elem = elem || document.documentElement;

			// Work around Safari 5.1 bug: reports support for
			// keyboard in fullscreen even though it doesn't.
			// Browser sniffing, since the alternative with
			// setTimeout is even worse.
			if (/5\.1[\.\d]* Safari/.test(navigator.userAgent)) {
				elem[request]();
			} else {
				elem[request](keyboardAllowed && Element.ALLOW_KEYBOARD_INPUT);
			}
		},
		exit: function () {
			document[fn.exitFullscreen]();
		},
		toggle: function (elem) {
			if (this.isFullscreen) {
				this.exit();
			} else {
				this.request(elem);
			}
		},
		raw: fn
	};

	if (!fn) {
		if (isCommonjs) {
			module.exports = false;
		} else {
			window.screenfull = false;
		}

		return;
	}

	Object.defineProperties(screenfull, {
		isFullscreen: {
			get: function () {
				return Boolean(document[fn.fullscreenElement]);
			}
		},
		element: {
			enumerable: true,
			get: function () {
				return document[fn.fullscreenElement];
			}
		},
		enabled: {
			enumerable: true,
			get: function () {
				// Coerce to boolean in case of old WebKit
				return Boolean(document[fn.fullscreenEnabled]);
			}
		}
	});

	if (isCommonjs) {
		module.exports = screenfull;
	} else {
		window.screenfull = screenfull;
	}
})();


/***/ }),

/***/ "./node_modules/setimmediate/setImmediate.js":
/*!***************************************************!*\
  !*** ./node_modules/setimmediate/setImmediate.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js"), __webpack_require__(/*! ./../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/stream-browserify/index.js":
/*!*************************************************!*\
  !*** ./node_modules/stream-browserify/index.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(/*! events */ "./node_modules/node-libs-browser/node_modules/events/events.js").EventEmitter;
var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js");

inherits(Stream, EE);
Stream.Readable = __webpack_require__(/*! readable-stream/readable.js */ "./node_modules/readable-stream/readable.js");
Stream.Writable = __webpack_require__(/*! readable-stream/writable.js */ "./node_modules/readable-stream/writable.js");
Stream.Duplex = __webpack_require__(/*! readable-stream/duplex.js */ "./node_modules/readable-stream/duplex.js");
Stream.Transform = __webpack_require__(/*! readable-stream/transform.js */ "./node_modules/readable-stream/transform.js");
Stream.PassThrough = __webpack_require__(/*! readable-stream/passthrough.js */ "./node_modules/readable-stream/passthrough.js");

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),

/***/ "./node_modules/utf8/utf8.js":
/*!***********************************!*\
  !*** ./node_modules/utf8/utf8.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*! https://mths.be/utf8js v3.0.0 by @mathias */
;(function(root) {

	var stringFromCharCode = String.fromCharCode;

	// Taken from https://mths.be/punycode
	function ucs2decode(string) {
		var output = [];
		var counter = 0;
		var length = string.length;
		var value;
		var extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	// Taken from https://mths.be/punycode
	function ucs2encode(array) {
		var length = array.length;
		var index = -1;
		var value;
		var output = '';
		while (++index < length) {
			value = array[index];
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
		}
		return output;
	}

	function checkScalarValue(codePoint) {
		if (codePoint >= 0xD800 && codePoint <= 0xDFFF) {
			throw Error(
				'Lone surrogate U+' + codePoint.toString(16).toUpperCase() +
				' is not a scalar value'
			);
		}
	}
	/*--------------------------------------------------------------------------*/

	function createByte(codePoint, shift) {
		return stringFromCharCode(((codePoint >> shift) & 0x3F) | 0x80);
	}

	function encodeCodePoint(codePoint) {
		if ((codePoint & 0xFFFFFF80) == 0) { // 1-byte sequence
			return stringFromCharCode(codePoint);
		}
		var symbol = '';
		if ((codePoint & 0xFFFFF800) == 0) { // 2-byte sequence
			symbol = stringFromCharCode(((codePoint >> 6) & 0x1F) | 0xC0);
		}
		else if ((codePoint & 0xFFFF0000) == 0) { // 3-byte sequence
			checkScalarValue(codePoint);
			symbol = stringFromCharCode(((codePoint >> 12) & 0x0F) | 0xE0);
			symbol += createByte(codePoint, 6);
		}
		else if ((codePoint & 0xFFE00000) == 0) { // 4-byte sequence
			symbol = stringFromCharCode(((codePoint >> 18) & 0x07) | 0xF0);
			symbol += createByte(codePoint, 12);
			symbol += createByte(codePoint, 6);
		}
		symbol += stringFromCharCode((codePoint & 0x3F) | 0x80);
		return symbol;
	}

	function utf8encode(string) {
		var codePoints = ucs2decode(string);
		var length = codePoints.length;
		var index = -1;
		var codePoint;
		var byteString = '';
		while (++index < length) {
			codePoint = codePoints[index];
			byteString += encodeCodePoint(codePoint);
		}
		return byteString;
	}

	/*--------------------------------------------------------------------------*/

	function readContinuationByte() {
		if (byteIndex >= byteCount) {
			throw Error('Invalid byte index');
		}

		var continuationByte = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		if ((continuationByte & 0xC0) == 0x80) {
			return continuationByte & 0x3F;
		}

		// If we end up here, it’s not a continuation byte
		throw Error('Invalid continuation byte');
	}

	function decodeSymbol() {
		var byte1;
		var byte2;
		var byte3;
		var byte4;
		var codePoint;

		if (byteIndex > byteCount) {
			throw Error('Invalid byte index');
		}

		if (byteIndex == byteCount) {
			return false;
		}

		// Read first byte
		byte1 = byteArray[byteIndex] & 0xFF;
		byteIndex++;

		// 1-byte sequence (no continuation bytes)
		if ((byte1 & 0x80) == 0) {
			return byte1;
		}

		// 2-byte sequence
		if ((byte1 & 0xE0) == 0xC0) {
			byte2 = readContinuationByte();
			codePoint = ((byte1 & 0x1F) << 6) | byte2;
			if (codePoint >= 0x80) {
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 3-byte sequence (may include unpaired surrogates)
		if ((byte1 & 0xF0) == 0xE0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			codePoint = ((byte1 & 0x0F) << 12) | (byte2 << 6) | byte3;
			if (codePoint >= 0x0800) {
				checkScalarValue(codePoint);
				return codePoint;
			} else {
				throw Error('Invalid continuation byte');
			}
		}

		// 4-byte sequence
		if ((byte1 & 0xF8) == 0xF0) {
			byte2 = readContinuationByte();
			byte3 = readContinuationByte();
			byte4 = readContinuationByte();
			codePoint = ((byte1 & 0x07) << 0x12) | (byte2 << 0x0C) |
				(byte3 << 0x06) | byte4;
			if (codePoint >= 0x010000 && codePoint <= 0x10FFFF) {
				return codePoint;
			}
		}

		throw Error('Invalid UTF-8 detected');
	}

	var byteArray;
	var byteCount;
	var byteIndex;
	function utf8decode(byteString) {
		byteArray = ucs2decode(byteString);
		byteCount = byteArray.length;
		byteIndex = 0;
		var codePoints = [];
		var tmp;
		while ((tmp = decodeSymbol()) !== false) {
			codePoints.push(tmp);
		}
		return ucs2encode(codePoints);
	}

	/*--------------------------------------------------------------------------*/

	root.version = '3.0.0';
	root.encode = utf8encode;
	root.decode = utf8decode;

}( false ? undefined : exports));


/***/ }),

/***/ "./node_modules/webpack/buildin/amd-define.js":
/*!***************************************!*\
  !*** (webpack)/buildin/amd-define.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),

/***/ "./node_modules/webpack/buildin/amd-options.js":
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(this, {}))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/zipcelx/lib/module.js":
/*!********************************************!*\
  !*** ./node_modules/zipcelx/lib/module.js ***!
  \********************************************/
/*! exports provided: default, generateXMLWorksheet */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateXMLWorksheet", function() { return generateXMLWorksheet; });
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! lodash.escape */ "./node_modules/lodash.escape/index.js");
/* harmony import */ var lodash_escape__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_escape__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! jszip */ "./node_modules/jszip/dist/jszip.min.js");
/* harmony import */ var jszip__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(jszip__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! file-saver */ "./node_modules/file-saver/FileSaver.js");
/* harmony import */ var file_saver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(file_saver__WEBPACK_IMPORTED_MODULE_2__);




const CELL_TYPE_STRING = 'string';
const CELL_TYPE_NUMBER = 'number';
const validTypes = [CELL_TYPE_STRING, CELL_TYPE_NUMBER];

const MISSING_KEY_FILENAME = 'Zipclex config missing property filename';
const INVALID_TYPE_FILENAME = 'Zipclex filename can only be of type string';
const INVALID_TYPE_SHEET = 'Zipcelx sheet data is not of type array';
const INVALID_TYPE_SHEET_DATA = 'Zipclex sheet data childs is not of type array';

const WARNING_INVALID_TYPE = 'Invalid type supplied in cell config, falling back to "string"';

const childValidator = (array) => {
  return array.every(item => Array.isArray(item));
};

var validator = (config) => {
  if (!config.filename) {
    console.error(MISSING_KEY_FILENAME);
    return false;
  }

  if (typeof config.filename !== 'string') {
    console.error(INVALID_TYPE_FILENAME);
    return false;
  }

  if (!Array.isArray(config.sheet.data)) {
    console.error(INVALID_TYPE_SHEET);
    return false;
  }

  if (!childValidator(config.sheet.data)) {
    console.error(INVALID_TYPE_SHEET_DATA);
    return false;
  }

  return true;
};

const generateColumnLetter = (colIndex) => {
  if (typeof colIndex !== 'number') {
    return '';
  }

  const prefix = Math.floor(colIndex / 26);
  const letter = String.fromCharCode(97 + (colIndex % 26)).toUpperCase();
  if (prefix === 0) {
    return letter;
  }
  return generateColumnLetter(prefix - 1) + letter;
};

var generatorCellNumber = (index, rowNumber) => (
  `${generateColumnLetter(index)}${rowNumber}`
);

var generatorStringCell = (index, value, rowIndex) => (`<c r="${generatorCellNumber(index, rowIndex)}" t="inlineStr"><is><t>${lodash_escape__WEBPACK_IMPORTED_MODULE_0___default()(value)}</t></is></c>`);

var generatorNumberCell = (index, value, rowIndex) => (`<c r="${generatorCellNumber(index, rowIndex)}"><v>${value}</v></c>`);

var formatCell = (cell, index, rowIndex) => {
  if (validTypes.indexOf(cell.type) === -1) {
    console.warn(WARNING_INVALID_TYPE);
    cell.type = CELL_TYPE_STRING;
  }

  return (
    cell.type === CELL_TYPE_STRING
    ? generatorStringCell(index, cell.value, rowIndex)
    : generatorNumberCell(index, cell.value, rowIndex)
  );
};

var formatRow = (row, index) => {
  // To ensure the row number starts as in excel.
  const rowIndex = index + 1;
  const rowCells = row
  .map((cell, cellIndex) => formatCell(cell, cellIndex, rowIndex))
  .join('');

  return `<row r="${rowIndex}">${rowCells}</row>`;
};

var generatorRows = rows => (
  rows
  .map((row, index) => formatRow(row, index))
  .join('')
);

var workbookXML = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main"><workbookPr/><sheets><sheet state="visible" name="Sheet1" sheetId="1" r:id="rId3"/></sheets><definedNames/><calcPr/></workbook>`;

var workbookXMLRels = `<?xml version="1.0" ?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">
<Relationship Id="rId3" Target="worksheets/sheet1.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"/>
</Relationships>`;

var rels = `<?xml version="1.0" encoding="UTF-8" standalone="yes"?>
<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>`;

var contentTypes = `<?xml version="1.0" ?>
<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">
<Default ContentType="application/xml" Extension="xml"/>
<Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels"/>
<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet1.xml"/>
<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/>
</Types>`;

var templateSheet = `<?xml version="1.0" ?>
<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main"><sheetData>{placeholder}</sheetData></worksheet>`;

const generateXMLWorksheet = (rows) => {
  const XMLRows = generatorRows(rows);
  return templateSheet.replace('{placeholder}', XMLRows);
};

var zipcelx = (config) => {
  if (!validator(config)) {
    throw new Error('Validation failed.');
  }

  const zip = new jszip__WEBPACK_IMPORTED_MODULE_1___default.a();
  const xl = zip.folder('xl');
  xl.file('workbook.xml', workbookXML);
  xl.file('_rels/workbook.xml.rels', workbookXMLRels);
  zip.file('_rels/.rels', rels);
  zip.file('[Content_Types].xml', contentTypes);

  const worksheet = generateXMLWorksheet(config.sheet.data);
  xl.file('worksheets/sheet1.xml', worksheet);

  return zip.generateAsync({ type: 'blob' })
    .then((blob) => {
      file_saver__WEBPACK_IMPORTED_MODULE_2___default.a.saveAs(blob, `${config.filename}.xlsx`);
    });
};

/* harmony default export */ __webpack_exports__["default"] = (zipcelx);



/***/ }),

/***/ "./sources/PointCloudViz.js":
/*!**********************************!*\
  !*** ./sources/PointCloudViz.js ***!
  \**********************************/
/*! exports provided: Viewer, Manipulator, DB, Tools, App, Node, GIS, Renderer, Utils, DataAccess, Section, Pano, Plugins, Workflow, Jobs, RenderTools, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! PointCloudVizNS */ "./sources/PointCloudVizNS.js");
/* harmony import */ var PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _pcvizViewer_pcvizViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./pcvizViewer/pcvizViewer */ "./sources/pcvizViewer/pcvizViewer.js");
/* harmony import */ var _pcvizViewer_pcvizViewer__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_pcvizViewer_pcvizViewer__WEBPACK_IMPORTED_MODULE_1__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Viewer", function() { return _pcvizViewer_pcvizViewer__WEBPACK_IMPORTED_MODULE_1___default.a; });
/* harmony import */ var _pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js");
/* harmony import */ var _pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_2__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Manipulator", function() { return _pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_2___default.a; });
/* harmony import */ var _pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./pcvizDB/pcvizDB */ "./sources/pcvizDB/pcvizDB.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DB", function() { return _pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _pcvizTools_pcvizTools__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./pcvizTools/pcvizTools */ "./sources/pcvizTools/pcvizTools.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tools", function() { return _pcvizTools_pcvizTools__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _pcvizApp_pcvizApp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./pcvizApp/pcvizApp */ "./sources/pcvizApp/pcvizApp.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "App", function() { return _pcvizApp_pcvizApp__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _pcvizNode_pcvizNode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./pcvizNode/pcvizNode */ "./sources/pcvizNode/pcvizNode.js");
/* harmony import */ var _pcvizNode_pcvizNode__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_pcvizNode_pcvizNode__WEBPACK_IMPORTED_MODULE_6__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Node", function() { return _pcvizNode_pcvizNode__WEBPACK_IMPORTED_MODULE_6___default.a; });
/* harmony import */ var _pcvizGIS_pcvizGIS__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./pcvizGIS/pcvizGIS */ "./sources/pcvizGIS/pcvizGIS.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GIS", function() { return _pcvizGIS_pcvizGIS__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _pcvizGISRenderer_pcvizGISRenderer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./pcvizGISRenderer/pcvizGISRenderer */ "./sources/pcvizGISRenderer/pcvizGISRenderer.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Renderer", function() { return _pcvizGISRenderer_pcvizGISRenderer__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _pcvizUtils_pcvizUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./pcvizUtils/pcvizUtils */ "./sources/pcvizUtils/pcvizUtils.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Utils", function() { return _pcvizUtils_pcvizUtils__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _pcvizDataAccess_pcvizDataAccess__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./pcvizDataAccess/pcvizDataAccess */ "./sources/pcvizDataAccess/pcvizDataAccess.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DataAccess", function() { return _pcvizDataAccess_pcvizDataAccess__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _pcvizSection_pcvizSection__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./pcvizSection/pcvizSection */ "./sources/pcvizSection/pcvizSection.js");
/* harmony import */ var _pcvizSection_pcvizSection__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_pcvizSection_pcvizSection__WEBPACK_IMPORTED_MODULE_11__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Section", function() { return _pcvizSection_pcvizSection__WEBPACK_IMPORTED_MODULE_11___default.a; });
/* harmony import */ var _pcvizPano_pcvizPano__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./pcvizPano/pcvizPano */ "./sources/pcvizPano/pcvizPano.js");
/* harmony import */ var _pcvizPano_pcvizPano__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_pcvizPano_pcvizPano__WEBPACK_IMPORTED_MODULE_12__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "Pano", function() { return _pcvizPano_pcvizPano__WEBPACK_IMPORTED_MODULE_12___default.a; });
/* harmony import */ var _pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./pcvizPlugins/pcvizPlugins */ "./sources/pcvizPlugins/pcvizPlugins.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Plugins", function() { return _pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _pcvizWorkflow_pcvizWorkflow__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pcvizWorkflow/pcvizWorkflow */ "./sources/pcvizWorkflow/pcvizWorkflow.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Workflow", function() { return _pcvizWorkflow_pcvizWorkflow__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _pcvizJobs_pcvizJobs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./pcvizJobs/pcvizJobs */ "./sources/pcvizJobs/pcvizJobs.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Jobs", function() { return _pcvizJobs_pcvizJobs__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _pcvizRenderTools_pcvizRenderTools__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./pcvizRenderTools/pcvizRenderTools */ "./sources/pcvizRenderTools/pcvizRenderTools.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RenderTools", function() { return _pcvizRenderTools_pcvizRenderTools__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_17__);


/** @namespace PointCloudViz */




















PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Viewer = _pcvizViewer_pcvizViewer__WEBPACK_IMPORTED_MODULE_1___default.a;
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Manipulator = _pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_2___default.a;
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.DB = _pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_3__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Tools = _pcvizTools_pcvizTools__WEBPACK_IMPORTED_MODULE_4__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.App = _pcvizApp_pcvizApp__WEBPACK_IMPORTED_MODULE_5__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Node = _pcvizNode_pcvizNode__WEBPACK_IMPORTED_MODULE_6___default.a;
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.GIS = _pcvizGIS_pcvizGIS__WEBPACK_IMPORTED_MODULE_7__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Renderer = _pcvizGISRenderer_pcvizGISRenderer__WEBPACK_IMPORTED_MODULE_8__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Utils = _pcvizUtils_pcvizUtils__WEBPACK_IMPORTED_MODULE_9__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.DataAccess = _pcvizDataAccess_pcvizDataAccess__WEBPACK_IMPORTED_MODULE_10__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Section = _pcvizSection_pcvizSection__WEBPACK_IMPORTED_MODULE_11___default.a;
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Pano = _pcvizPano_pcvizPano__WEBPACK_IMPORTED_MODULE_12___default.a;
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Plugins = _pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_13__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Workflow = _pcvizWorkflow_pcvizWorkflow__WEBPACK_IMPORTED_MODULE_14__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.Jobs = _pcvizJobs_pcvizJobs__WEBPACK_IMPORTED_MODULE_15__["default"];
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.RenderTools = _pcvizRenderTools_pcvizRenderTools__WEBPACK_IMPORTED_MODULE_16__["default"];

const namespaces = [ 'pcvizViewer', 'pcvizDB', 'pcvizTools', 'pcvizApp', 'pcvizNode', 'pcvizUtils', 'pcvizGIS', 'pcvizGISRenderer',
    'pcvizDataAccess', 'pcvizSection', 'pcvizPano', 'pcvizManipulator', 'pcvizPlugins', 'pcvizWorkflow', 'pcvizJobs', 'pcvizRenderTools'
];

// for backward compatibility
PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a.globalify = function () {
    OSG__WEBPACK_IMPORTED_MODULE_17___default.a.globalify();
    namespaces.forEach( function ( namespace ) {
        window[ namespace ] = PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a[ namespace ];
    } );
};



/* harmony default export */ __webpack_exports__["default"] = (PointCloudVizNS__WEBPACK_IMPORTED_MODULE_0___default.a);


/***/ }),

/***/ "./sources/PointCloudVizNS.js":
/*!************************************!*\
  !*** ./sources/PointCloudVizNS.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var version = __webpack_require__( /*! version */ "./sources/version.js" );
module.exports = version;


/***/ }),

/***/ "./sources/pcvizApp/Application.js":
/*!*****************************************!*\
  !*** ./sources/pcvizApp/Application.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Application; });
/* harmony import */ var pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/pcvizDB */ "./sources/pcvizDB/pcvizDB.js");


/**
 * Define a pointcloudviz Application
 * @class
 * @memberof pcvizApp
 */
class Application {
    constructor( project ) {
        this._project = project;
        this._jobSite = undefined;

        this._resourcesPath = '';
        this._views = [];

        const registry = pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].Registry.getInstance();
        registry.registerController( 'Object', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ObjectController );
        registry.registerController( 'Layer', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].LayerController );
        registry.registerController( 'SelectionObject', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].SelectionController );
        registry.registerController( 'Symbol', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].SymbolController );
        registry.registerController( 'View', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ViewController );
        registry.registerController( 'UserPreferences', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].UserPreferencesController );
        registry.registerController( 'Application', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ApplicationController );
        registry.registerController( 'Mount', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].MountController );
        registry.registerController( 'Upload', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].UploadController );
        registry.registerController( 'BlobStorage', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].BlobStorageController );
        registry.registerController( 'Error', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ErrorController );
        registry.registerController( 'ImageSelection', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ImageSelectionController );
        registry.registerController( 'Workspace', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].WorkspaceController );
        registry.registerController( 'ModelLibrary', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ModelLibraryController );
        registry.registerController( 'Configuration', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ConfigurationController );
        registry.registerController( 'OverwriteSymbology', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].OverwriteSymbologyController );
        registry.registerController( 'ScanSelection', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].ScanSelectionController );
        registry.registerController( 'C2CLink', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].C2CLinkManager );
        registry.registerController( 'PointVisibilityManager', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].PointVisibilityManagerController );
        registry.registerController( 'Plugins', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].PluginsController );
        registry.registerController( 'OverwriteVisibility', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].OverwriteVisibilityController );
        registry.registerController( 'TargetColor', pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].TargetColorManager );

        registry.getController( 'Application' ).registerApplication( this );
    }

    /**
     * Method to run the application (NOTE this method is not used currently)
     * @method
     * @memberof pcvizApp.Application
     */
    run() {
        const views = pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].Registry.getInstance().getController( 'View' ).getViews();
        for ( let i = 0; i < views.length; i++ )
            this.runView( views[ i ] );
    }

    getProject() {
        return this._project;
    }

    setProject( project ) {
        this._project = project;
        pcvizDB_pcvizDB__WEBPACK_IMPORTED_MODULE_0__["default"].Registry.getInstance().getController( 'OverwriteSymbology' ).setProject( this._project );
    }

    getJobSite() {
        return this._jobSite;
    }

    setJobSite( jobSite ) {
        this._jobSite = jobSite;
    }

    getAppObject() {
        return this._project ? this._project : this._jobSite;
    }

    /**
     * Method to run an application view
     * @method
     * @memberof pcvizApp.Application
     * @param {pcvizApp.View} view the view to be run
     */
    runView( view ) {
        return new Promise( ( resolve, reject ) => {
            if ( this._project ) {
                view.setProjection( this._project.getProjection() );
            }
            view.setResourcesPath( this._resourcesPath );
            view.run().then( ( result ) => {
                resolve( result );
            } ).catch( ( error ) => {
                reject( error );
            } );
            this._views.push( view );
        } );
    }

    /**
     * Remove a view to the application (This method is not used)
     * @method
     * @memberof pcvizApp.Application
     * @param {pcvizApp.View} view the view to be added
     */
    removeView( view ) {
        const keys = window.Object.keys( this._views );

        for ( let i = 0; i < keys.length; i++ ) {
            if ( this._views[ keys[ i ] ] instanceof view )
                delete this._views[ keys[ i ] ];
        }
    }

    setResourcesPath( path ) {
        this._resourcesPath = path;
    }

    destroy() {
        this._project = undefined;
        this._jobSite = undefined;
        this._views.forEach( function ( view ) {
            view.destroy();
        } );
    }
}


/***/ }),

/***/ "./sources/pcvizApp/BaseSceneView.js":
/*!*******************************************!*\
  !*** ./sources/pcvizApp/BaseSceneView.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizViewer_Viewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizViewer/Viewer */ "./sources/pcvizViewer/Viewer.js");
/* harmony import */ var pcvizViewer_Viewer__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizViewer_Viewer__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizNode/SceneNode */ "./sources/pcvizNode/SceneNode.js");
/* harmony import */ var pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizNode_EDLNode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizNode/EDLNode */ "./sources/pcvizNode/EDLNode.js");
/* harmony import */ var pcvizNode_EDLNode__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_EDLNode__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizNode_HUDNode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizNode/HUDNode */ "./sources/pcvizNode/HUDNode.js");
/* harmony import */ var pcvizNode_HUDNode__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_HUDNode__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizNode_Switch__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizNode/Switch */ "./sources/pcvizNode/Switch.js");
/* harmony import */ var pcvizNode_Switch__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_Switch__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizNode_ClampProjectionCallback__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizNode/ClampProjectionCallback */ "./sources/pcvizNode/ClampProjectionCallback.js");
/* harmony import */ var pcvizNode_ClampProjectionCallback__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_ClampProjectionCallback__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizDB/PointCloudDBPager */ "./sources/pcvizDB/PointCloudDBPager.js");
/* harmony import */ var pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pcvizUtils_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizUtils/ComputeBoundingVisitor */ "./sources/pcvizUtils/ComputeBoundingVisitor.js");
/* harmony import */ var pcvizUtils_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js");
/* harmony import */ var pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pcvizSceneModes_ModeManipulator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizSceneModes/ModeManipulator */ "./sources/pcvizSceneModes/ModeManipulator.js");
/* harmony import */ var pcvizSceneModes_ModeManipulator__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pcvizSceneModes_ModeManipulator__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var pcvizSceneModes_NormalMode__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizSceneModes/NormalMode */ "./sources/pcvizSceneModes/NormalMode.js");
/* harmony import */ var pcvizSceneModes_NormalMode__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(pcvizSceneModes_NormalMode__WEBPACK_IMPORTED_MODULE_12__);

const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;



















const BaseSceneView = function ( canvas, renderSettings, options ) {
    if ( typeof canvas === 'string' || canvas instanceof String )
        canvas = document.getElementById( canvas );

    this._manipulatorMode = pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_10___default.a.CAD_MANIPULATOR;

    this._canvas = canvas;

    this._rootNode = new osg.Node();

    this._switchNode = new pcvizNode_Switch__WEBPACK_IMPORTED_MODULE_5___default.a();
    this._switchNode.setName( 'EDLSwitchNode' );
    this._noEdlNode = new osg.Node();
    this._noEdlNode.setName( 'noEDLNode' );
    this._edlNode = new pcvizNode_EDLNode__WEBPACK_IMPORTED_MODULE_3___default.a();
    this._edlNode.setName( 'EDLNode' );
    this._hudNode = new pcvizNode_HUDNode__WEBPACK_IMPORTED_MODULE_4___default.a();
    this._hudNode.setName( 'HUDNode' );

    this._sceneNode = new pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2___default.a();
    this._sceneNode.setName( 'SceneNode' );

    this._rootNode.addChild( this._switchNode );
    this._rootNode.addChild( this._hudNode );
    this._switchNode.addChild( this._noEdlNode );
    this._switchNode.addChild( this._edlNode );
    this._edlNode.setScene( this._sceneNode );
    this._noEdlNode.addChild( this._sceneNode );

    this._viewer = new pcvizViewer_Viewer__WEBPACK_IMPORTED_MODULE_1___default.a( this._canvas, options );
    this._viewer.setDatabasePager( new pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_7___default.a() );
    this._viewer.getDatabasePager().setMaxRequestsPerFrame( 1 );
    this._viewer.setPickingEnabled( false );

    this._edlNode.setSSAORendering( renderSettings ? renderSettings.get( 'SSAOOn' ) : false );
    this._edlNode.setEDLRadius( renderSettings ? renderSettings.get( 'edlRadius' ) : 1.0 );
    this._edlNode.setEDLExp( renderSettings ? renderSettings.get( 'edlContrast' ) : 1.0 );
    this._edlNode.setViewportDimensions( this._viewer.getCamera().getViewport().width(), this._viewer.getCamera().getViewport().height() );
    this._edlNode.setViewer( this._viewer ); // required for the clamp projection callback

    this._hudNode.setViewportDimensions( this._viewer.getCamera().getViewport().width(), this._viewer.getCamera().getViewport().height() );
    this._hudNode.setViewer( this._viewer );

    this._viewer.setPointCloudScene( this._sceneNode.getPointCloudScene() );
    this._viewer.setToolsNode( this._sceneNode.getToolsNode() );
    this._viewer.setHUDNode( this._hudNode );
    this._viewer.setEDLNode( this._edlNode );
    this._viewer.setEDLSwitchNode( this._switchNode );
    this._viewer.setSceneData( this._rootNode );
    this._viewer.getCamera().setClampProjectionMatrixCallback( pcvizNode_ClampProjectionCallback__WEBPACK_IMPORTED_MODULE_6___default.a.getClampProjectionCallback( this._viewer ) );

    this._viewer.setEDLRendering( renderSettings ? renderSettings.get( 'edlOn' ) : false );

    // set field of view
    const perspective = osg.mat4.getPerspective( osg.mat4.create(), this._viewer.getCamera().getProjectionMatrix() );
    osg.mat4.perspective( this._viewer.getCamera().getProjectionMatrix(), renderSettings ? renderSettings.get( 'fieldOfView' ) * Math.PI / 180.0 : 1.0, perspective.aspectRatio, perspective.zNear, perspective.zFar );

    // set level of detail
    const lodScale = renderSettings ? renderSettings.get( 'levelOfDetail' ) : 2.0;
    this._viewer.getCamera().getRenderer().getCullVisitor().setLODScale( ( 3.0 - lodScale ) * window.devicePixelRatio );
    this._viewer.computeLodFactor( lodScale );

    this._pickingElement = undefined;

    // camera manipulator undefined by default, run method will configure it if required
    this._cameraManipulator = undefined;

    // scene center: the center of the first layer loaded (offset)
    this._center = undefined;

    this._layerRenderer3D = undefined;

    this._userPreferencesCtrl = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_8___default.a.getController( 'UserPreferences' );

    this._savedEye = undefined;
    this._savedCenter = undefined;
    this._savedUp = undefined;

    this._viewer.setSceneView( this );

    // Initialazing manipulator modeSetup
    this._modeManipulator = new pcvizSceneModes_ModeManipulator__WEBPACK_IMPORTED_MODULE_11___default.a();

    // Normal mode
    const normalMode = new pcvizSceneModes_NormalMode__WEBPACK_IMPORTED_MODULE_12___default.a( pcvizManipulator_pcvizManipulator__WEBPACK_IMPORTED_MODULE_10___default.a.CAD_MANIPULATOR, undefined, undefined );
    this._modeManipulator.addMode( normalMode.getId(), normalMode );

    this._layerGroupNodes = new Map();
    this.registerSymbols();
};

BaseSceneView.prototype = {

    getAppObject() {},

    getSceneNode() {
        return this._sceneNode;
    },

    getViewer() {
        return this._viewer;
    },

    getLayerRenderer() {
        return this._layerRenderer3D;
    },

    getCenter() {
        return this._center;
    },

    resetManipulator() {
        this._viewer.resetState();
    },

    /**
     * Method to calculate the scene view 3D extent
     * @param {Boolean} addCenter to use the viewer center as the center of scene
     * @param {boolean} sceneWithoutTools to get a scene extent without the info from the tools extents
     * @returns {Array} an array of min x,y,z and max x,y,z
     */
    calculateSceneExtent( addCenter, sceneWithoutTools ) { // Maybe we will need to add another refactor for SceneViews?
        const boundingVisitor = new pcvizUtils_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_9___default.a();
        let node = this.getSceneNode(); // we will analyze the whole scene
        if ( sceneWithoutTools )
            node = node.getTransformNode();

        node.accept( boundingVisitor );
        const bbox = boundingVisitor.getBounding();

        let min = bbox.getMin();
        let max = bbox.getMax();

        if ( addCenter ) {
            osg.vec3.add( min, min, this._viewer.getCenter() );
            osg.vec3.add( max, max, this._viewer.getCenter() );
        }

        let extentScene = [
            min[ 0 ],
            min[ 1 ],
            min[ 2 ],
            max[ 0 ],
            max[ 1 ],
            max[ 2 ],
        ];

        return extentScene;
    },

    getManipulatorMode() {
        return this._manipulatorMode;
    },


    setRenderErrorCB( fn ) {
        this._renderErrorCB = fn;
    },

    getRenderErrorCB() {
        return this._renderErrorCB;
    },

    registerSymbols() {},

    getCurrentManipulatorModeKey: function () {
        return this._modeManipulator.getCurrentMode();
    }

};

/* harmony default export */ __webpack_exports__["default"] = (BaseSceneView);


/***/ }),

/***/ "./sources/pcvizApp/JobSiteSceneView.js":
/*!**********************************************!*\
  !*** ./sources/pcvizApp/JobSiteSceneView.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizNode_Group__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizNode/Group */ "./sources/pcvizNode/Group.js");
/* harmony import */ var pcvizApp_JobSiteView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizApp/JobSiteView */ "./sources/pcvizApp/JobSiteView.js");
/* harmony import */ var pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizApp/BaseSceneView */ "./sources/pcvizApp/BaseSceneView.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGISRenderer_LayerRenderer3D__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizGISRenderer/LayerRenderer3D */ "./sources/pcvizGISRenderer/LayerRenderer3D.js");
/* harmony import */ var pcvizGISRenderer_LayerRenderer3D__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_LayerRenderer3D__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizGISRenderer/Model3DSymbol3D */ "./sources/pcvizGISRenderer/Model3DSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizGISRenderer/LineSymbol3D */ "./sources/pcvizGISRenderer/LineSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var pcvizGISRenderer_FillSymbol3D__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizGISRenderer/FillSymbol3D */ "./sources/pcvizGISRenderer/FillSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_FillSymbol3D__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_FillSymbol3D__WEBPACK_IMPORTED_MODULE_12__);

const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;


















const JobSiteSceneView = function ( canvas, jobSite ) {
    pcvizApp_JobSiteView__WEBPACK_IMPORTED_MODULE_2__["default"].call( this, jobSite );
    pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_3__["default"].call( this, canvas, undefined ); // Common initialization for Scene Views

    this._rootNode.setName( 'JobSiteViewNode' );

    this._viewer.getCamera().setClearColor( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_BACKGROUND_COLOR );

    this.setRenderErrorCB( ( err ) => { console.error( `Error job site scene view: ${err}` ); } );
};

JobSiteSceneView.prototype = osg.objectInherit( pcvizApp_JobSiteView__WEBPACK_IMPORTED_MODULE_2__["default"].prototype, osg.objectInherit( pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_3__["default"].prototype, {

    getAppObject() {
        return this.getJobSite();
    },

    registerSymbols: function () {
        const symbolRegistry = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default.a.getController( 'Symbol' );
        symbolRegistry.registerSymbol( '3D', 'Point', pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_9___default.a );
        symbolRegistry.registerSymbol( '3D', 'Model3D', pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_10___default.a );
        symbolRegistry.registerSymbol( '3D', 'Line', pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_11___default.a );
        symbolRegistry.registerSymbol( '3D', 'Fill', pcvizGISRenderer_FillSymbol3D__WEBPACK_IMPORTED_MODULE_12___default.a );
    },

    refreshCenter() {
        if ( this._center !== undefined ) {
            return false;
        }
        let extent = this._jobSite.getProjectedExtent();
        this._center = this.getViewer().getBoundingFromExtent( new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_6__["default"]( extent[ 0 ], extent[ 3 ], extent[ 1 ], extent[ 4 ], extent[ 2 ], extent[ 5 ] ) ).center();

        this._viewer.setCenter( this._center );
        this._layerRenderer3D.setCenter( this._center );

        let transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];

        this._sceneNode.getTransformNode().setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
    },

    run() {
        return new Promise( ( resolve, reject ) => {
            if ( this._layerRenderer3D === undefined ) {
                this._layerRenderer3D = new pcvizGISRenderer_LayerRenderer3D__WEBPACK_IMPORTED_MODULE_8___default.a();
            }

            this.refreshCenter();

            this._viewer.setupManipulator( this._viewer.getOrCreateManipulator() );
            this._viewer.getManipulator().computeHomePosition();

            this._toolBar.forEach( ( tool ) => {
                this._viewer.addTool( tool );
            } );

            this.drawLayers().then( () => {
                this.resetManipulator();
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );

            this._viewer.run();
        } );
    },

    drawLayers() {
        return new Promise( ( resolve, reject ) => {
            let layers = this._jobSite.getAllLayers();

            this.startLoading( layers.length );

            let promises = [];

            layers.forEach( ( layer ) => {
                let snapshot = this._jobSite.getSnapshotByLayer( layer );
                promises.push( this.drawLayer( layer, snapshot ) );
            } );

            Promise.all( promises ).then( () => {
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    },

    /**
     * Method to draw a layer in the view
     * @param {Layer} layer
     * @param {object} snapshot in json format with the upper matrix to be placed
     * @returns {Promise}
     */
    drawLayer( layer, snapshot ) {
        return new Promise( ( resolve, reject ) => {
            let sceneNode = this.getSceneNode();
            let layerRenderer = this.getLayerRenderer();
            let parentNode = sceneNode.getTransformNode();

            if ( snapshot ) {
                let group = new pcvizNode_Group__WEBPACK_IMPORTED_MODULE_1__["default"]();
                group.setName( snapshot.uuid );
                if ( snapshot.transformMatrix ) {
                    osg.mat4.transpose( group.getMatrix(), snapshot.transformMatrix );
                    group.setMatrix( group.getMatrix() );
                }
                // Storing group node by layerId, as each group node can be only above from the corresponding layer node.
                this._layerGroupNodes.set( snapshot.layerId, group );
                parentNode.addChild( group );
                parentNode = group;
            }

            let openPromise = new Promise( ( resolve ) => { resolve(); } );
            if ( !layer.isOpen() ) {
                openPromise = layer.open();
            }

            openPromise.then( () => {

                if ( !layer.getCenter() )
                    layer.computeCenter();

                layer.render( layerRenderer, sceneNode, parentNode ).then( () => {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } ).finally( () => {
                    this.progressLoading( 1, true );
                } );
            } );
        } );
    },

    areAllLayersRendered() {
        let layers = this._jobSite.getAllLayers();
        return layers.every( layer => layer.isRendered() );
    },

    zoomToLayer( layerId, options ) {
        const layer = this._jobSite.getLayerById( layerId );

        if ( !layer ) {
            return;
        }

        this._viewer.zoomToLayer( layer, options );
    },

    zoomToFeature( layer, feature, options ) {
        this._viewer.zoomToFeature( layer, feature, options );
    },

    setEnableIntersections( enableIntersections, type ) {
        this._layerRenderer3D.getLayerNodesByType( type ).forEach( ( node, layerKey ) => {
            if ( enableIntersections )
                node.setNodeMask( layerKey._visible ? ~0x0 : 0x0 );
            else
                node.setNodeMask( layerKey._visible ? ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.TRAVERSAL_MASK_IV : 0x0 );
        } );
    },

    deleteLayer( layer ) {
        let layerNode = this._layerRenderer3D.getNodeFromLayer( layer );

        if ( layerNode === undefined ) {
            return;
        }

        const parentLayerNode = layerNode._parents[ 0 ];
        parentLayerNode.removeChild( layerNode );

        // removes MatrixTransform
        if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].POINTCLOUD ) {
            parentLayerNode._parents[ 0 ].removeChild( parentLayerNode );
        }

        this._layerRenderer3D.removeLayerNode( layer );
    }
} ) );

/* harmony default export */ __webpack_exports__["default"] = (JobSiteSceneView);


/***/ }),

/***/ "./sources/pcvizApp/JobSiteTableView.js":
/*!**********************************************!*\
  !*** ./sources/pcvizApp/JobSiteTableView.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobSiteTableView; });
/* harmony import */ var _JobSiteView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./JobSiteView */ "./sources/pcvizApp/JobSiteView.js");




/**
 * Defines the Table View core class to refresh layer as it is done in other views
 * @class
 * @memberof pcvizApp
 * @extends pcvizApp.View
 */
class JobSiteTableView extends _JobSiteView__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( jobSite ) {
        super( jobSite );
    }
    refresh() {
        return new Promise( ( resolve ) => {
            this.endLoading();
            resolve();
        } );
    }
}


/***/ }),

/***/ "./sources/pcvizApp/JobSiteView.js":
/*!*****************************************!*\
  !*** ./sources/pcvizApp/JobSiteView.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

const View = __webpack_require__( /*! pcvizApp/View */ "./sources/pcvizApp/View.js" );
const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

const osg = OSG.osg;

const JobSiteView = function ( jobSite ) {
    View.call( this );
    this._jobSite = jobSite;
};

JobSiteView.prototype = osg.objectInherit( View.prototype, {

    getJobSite() {
        return this._jobSite;
    },

    setJobSite( jobSite ) {
        this._jobSite = jobSite;
    },

    destroy() {
        View.prototype.destroy();
        this._jobSite = undefined;
    },

    refreshLayer: function () {},
    zoomToFeature: function () {},
} );

/* harmony default export */ __webpack_exports__["default"] = (JobSiteView);


/***/ }),

/***/ "./sources/pcvizApp/ProjectView.js":
/*!*****************************************!*\
  !*** ./sources/pcvizApp/ProjectView.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const View = __webpack_require__( /*! pcvizApp/View */ "./sources/pcvizApp/View.js" );
const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

const osg = OSG.osg;

/**
 * The view that renders the 3D scene with a project
 * @class
 * @extends pcvizApp.View
 * @memberof pcvizApp
 */
const ProjectView = function ( project ) {
    View.call( this );
    this._layerActions = {
        add: {},
        delete: {}
    };

    this._project = project;
};

ProjectView.prototype = osg.objectInherit( View.prototype, {

    addLayer: function ( layer, parentId ) {
        if ( this._layerActions.add[ layer.getType() ] !== undefined )
            return this._layerActions.add[ layer.getType() ]( layer, parentId );
    },

    deleteLayer: function ( type, id, layer ) {
        if ( this._layerActions.delete[ type ] !== undefined )
            return this._layerActions.delete[ type ]( id, layer );
    },

    getProject: function () {
        return this._project;
    },

    registerLayerAction: function ( eventType, layerType, fn ) {
        this._layerActions[ eventType ][ layerType ] = fn;
    },

    refreshLayer: function () {},

    refreshLayerGroup: function () {},

    setProject: function ( project ) {
        this._project = project;
    },

    destroy: function () {
        View.prototype.destroy();
        this._project = undefined;
    },

    // query parameters methods
    zoomToLayerAfterInitialize: function () {},

    zoomToFeatureAfterInitialize: function () {},

    // view actions
    zoomToLayer: function () {},

    zoomToFeature: function () {},
} );

module.exports = ProjectView;


/***/ }),

/***/ "./sources/pcvizApp/SceneView.js":
/*!***************************************!*\
  !*** ./sources/pcvizApp/SceneView.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizApp/BaseSceneView */ "./sources/pcvizApp/BaseSceneView.js");
/* harmony import */ var pcvizTools_LayerTransformTool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizTools/LayerTransformTool */ "./sources/pcvizTools/LayerTransformTool.js");
/* harmony import */ var pcvizTools_CursorTool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizTools/CursorTool */ "./sources/pcvizTools/CursorTool.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3__);

const ProjectView = __webpack_require__( /*! pcvizApp/ProjectView */ "./sources/pcvizApp/ProjectView.js" );


const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );

const LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
const Envelope = __webpack_require__( /*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js" ).default;
const LayerGroup = __webpack_require__( /*! pcvizGIS/LayerGroup */ "./sources/pcvizGIS/LayerGroup.js" ).default;
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
const SerializerLayerVisitor = __webpack_require__( /*! pcvizGIS/SerializerLayerVisitor */ "./sources/pcvizGIS/SerializerLayerVisitor.js" ).default;

const LayerRenderer3D = __webpack_require__( /*! pcvizGISRenderer/LayerRenderer3D */ "./sources/pcvizGISRenderer/LayerRenderer3D.js" );
const pcvizGISRenderer = __webpack_require__( /*! pcvizGISRenderer/pcvizGISRenderer */ "./sources/pcvizGISRenderer/pcvizGISRenderer.js" ).default;
const PanoramaSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PanoramaSymbol3D */ "./sources/pcvizGISRenderer/PanoramaSymbol3D.js" );
const PlanarImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PlanarImageSymbol3D */ "./sources/pcvizGISRenderer/PlanarImageSymbol3D.js" );

const Group = __webpack_require__( /*! pcvizNode/Group */ "./sources/pcvizNode/Group.js" ).default;
const PlanarImage = __webpack_require__( /*! pcvizNode/PlanarImage */ "./sources/pcvizNode/PlanarImage.js" );

const pcvizManipulator = __webpack_require__( /*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js" );

const PanoramaMode = __webpack_require__( /*! pcvizSceneModes/PanoramaMode */ "./sources/pcvizSceneModes/PanoramaMode.js" );
const PlanarImageMode = __webpack_require__( /*! pcvizSceneModes/PlanarImageMode */ "./sources/pcvizSceneModes/PlanarImageMode.js" );
const ControlPointMode = __webpack_require__( /*! pcvizSceneModes/ControlPointMode */ "./sources/pcvizSceneModes/ControlPointMode.js" );
const RegionMode = __webpack_require__( /*! pcvizSceneModes/RegionMode */ "./sources/pcvizSceneModes/RegionMode.js" );

const ControlPointTool = __webpack_require__( /*! pcvizTools/ControlPointTool */ "./sources/pcvizTools/ControlPointTool.js" );
const RegionTool = __webpack_require__( /*! pcvizTools/RegionTool */ "./sources/pcvizTools/RegionTool.js" );

const FindImagesTool = __webpack_require__( /*! pcvizTools/FindImagesTool */ "./sources/pcvizTools/FindImagesTool.js" );


const CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );


const WorkspaceCategories = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" ).default;

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
const osg = OSG.osg;
const osgDB = OSG.osgDB;
const osgUtil = OSG.osgUtil;

const PoseConfig = function () {
    this.eye = osg.vec3.fromValues( parseFloat( Utils.getVariableFromURL( 'eye0' ) ), parseFloat( Utils.getVariableFromURL( 'eye1' ) ), parseFloat( Utils.getVariableFromURL( 'eye2' ) ) );
    this.target = osg.vec3.fromValues( parseFloat( Utils.getVariableFromURL( 'target0' ) ), parseFloat( Utils.getVariableFromURL( 'target1' ) ), parseFloat( Utils.getVariableFromURL( 'target2' ) ) );
    this.matrix = [];
    this.orientation = [];

    if ( !isNaN( parseFloat( Utils.getVariableFromURL( 'm0' ) ) ) )
        for ( var i = 0; i < 16; i++ )
            this.matrix[ i ] = parseFloat( Utils.getVariableFromURL( 'm' + i ) );

    if ( !isNaN( parseFloat( Utils.getVariableFromURL( 'quat0' ) ) ) )
        for ( var o = 0; o < 4; o++ )
            this.orientation[ o ] = parseFloat( Utils.getVariableFromURL( 'quat' + o ) );
};

/**
 * The view that renders the 3D scene with a project
 * @class
 * @extends pcvizApp.ProjectView
 * @memberof pcvizApp
 */
const SceneView = function ( canvas, project, opt ) {
    ProjectView.call( this, project );

    this._defaultOptions = {
        enableFrustumCulling: true,
    };

    let options = opt;
    if ( options === undefined ) {
        options = this._defaultOptions;
    }

    let renderSettings = ( this._project ) ? this._project.getCurrentRenderSettings() : undefined;

    pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_0__["default"].call( this, canvas, renderSettings, opt ); // Common initialization for Scene Views

    this._rootNode.setName( 'SceneViewNode' );

    if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default.a.isDevelopment() && !pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default.a.isSite() ) { // Comment second condition to show Stats and Debug Graph in Site
        options.stats = false;
        options.statsShowGraph = true;

        window.addEventListener( 'keyup', this.onKeyUpEvent.bind( this ) );

        options.debugGraph = true;
    }

    this._viewer.getDatabasePager().pushOnAddedDataCallback( ( data ) => {
        if ( data.getParents()[ 0 ].options || data.getParents()[ 0 ].getDatabaseOptions() ) {
            // Here we only access if data parent is a CollagePLOD or PagedLOD used by 3D Models.
            // Pointclouds has PontCloudPLOD parents, and avoids this if clause.
            let layer = data.getParents()[ 0 ].options ? data.getParents()[ 0 ].options.layer : data.getParents()[ 0 ].getDatabaseOptions().layer;
            if ( layer && VectorLayerUtils.is3DModelLayer( layer ) ) {
                let modelSymbol = layer.getFeatureRenderer().getSymbol();
                modelSymbol.refreshRenderMode( data, modelSymbol.getRenderMode() );
            }
            return;
        }
        Registry.getController( 'PointVisibilityManager' ).notifyProcessNewGeometries( data.getInstanceID() ); // Notify new CPLFMZ geometry is loaded in the scene graph. For PLFMZ is notified in PointCloudRenderer.
    } );
    this.configureForMobileDevices( this._viewer );

    // save the pose passed from arguments
    this._poseConfig = new PoseConfig();

    // Init layer actions
    this.registerLayerActions();
    this.registerUserPreferences();

    // Panorama mode
    let panoramaMode = new PanoramaMode( pcvizManipulator.PANORAMA_MANIPULATOR, undefined, undefined );
    // Planar image mode
    let planarImageMode = new PlanarImageMode( pcvizManipulator.PLANAR_IMAGE_MANIPULATOR, undefined, undefined );
    // Photog control point tool
    let cpt = new ControlPointTool( this );
    cpt.setProject( project );
    let controlPointMode = new ControlPointMode( pcvizManipulator.CONTROL_POINT_MANIPULATOR, undefined, cpt );
    // Region mode
    let regTool = new RegionTool( this );
    regTool.setProject( project );
    let regMode = new RegionMode( pcvizManipulator.REGION_MANIPULATOR, undefined, regTool );
    // Scan layer transform
    let ltTool = new pcvizTools_LayerTransformTool__WEBPACK_IMPORTED_MODULE_1__["default"]( this );
    ltTool.setProject( project );
    // Find images tool
    let fiTool = new FindImagesTool( this );
    fiTool.setProject( project );
    // 3D cursor tool
    let cursorTool = new pcvizTools_CursorTool__WEBPACK_IMPORTED_MODULE_2__["default"]( this );
    cursorTool.setProject( project );

    this._modeManipulator.addMode( panoramaMode.getId(), panoramaMode );
    this._modeManipulator.addMode( planarImageMode.getId(), planarImageMode );
    this._modeManipulator.addMode( controlPointMode.getId(), controlPointMode );
    this._modeManipulator.addMode( regMode.getId(), regMode );

    this._planarImages = new Map();

    // controllers
    this._workspaceController = Registry.getInstance().getController( 'Workspace' );
    this._viewController = Registry.getInstance().getController( 'View' );
};

SceneView.prototype = osg.objectInherit( ProjectView.prototype, osg.objectInherit( pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, {

    getAppObject() {
        return this.getProject();
    },

    registerSymbols: function () {
        var symbolRegistry = Registry.getController( 'Symbol' );
        symbolRegistry.registerSymbol( '3D', 'Point', pcvizGISRenderer.PointSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'PointMarker', pcvizGISRenderer.PointMarkerSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'MultiPoint', pcvizGISRenderer.MultiPointSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'MultiPointMarker', pcvizGISRenderer.MultiPointMarkerSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Line', pcvizGISRenderer.LineSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'LineMarker', pcvizGISRenderer.LineMarkerSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Fill', pcvizGISRenderer.FillSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'FillMarker', pcvizGISRenderer.FillMarkerSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Panorama', pcvizGISRenderer.PanoramaSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'PlanarImage', pcvizGISRenderer.PlanarImageSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Model3D', pcvizGISRenderer.Model3DSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'MultiModel3D', pcvizGISRenderer.MultiModel3DSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'StationSymbol', pcvizGISRenderer.StationSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Target', pcvizGISRenderer.TargetSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Volume', pcvizGISRenderer.VolumeSymbol3D );
        symbolRegistry.registerSymbol( '3D', 'Machinery', pcvizGISRenderer.MachineryMarkerSymbol3D );
    },

    registerUserPreferences: function () {
        if ( this._userPreferencesCtrl.getPreference( Utils.BACKGROUND_COLOR_KEY ) !== undefined )
            this._viewer.getCamera().setClearColor( this._userPreferencesCtrl.getPreference( Utils.BACKGROUND_COLOR_KEY ) );

        this._userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.BACKGROUND_COLOR_KEY, this.setBackgroundColor.bind( this ) );
    },

    setBackgroundColor: function ( backgroundColor ) {
        this._viewer.getCamera().setClearColor( backgroundColor );
        if ( this._edlNode.getEDLSceneCamera() !== undefined )
            this._edlNode.getEDLSceneCamera().setClearColor( backgroundColor );
    },

    run: function ( /*opt, project*/) {
        var defer = P.defer();

        this.configureForMobileDevices( this._viewer );

        this._viewer.setupManipulator( this._viewer.getOrCreateManipulator() );

        this.configureManipulatorPose( this._viewer.getManipulator() );

        var viewer = this._viewer;

        // add tools in the viewer to update them each frame if required

        this._toolBar.forEach( function ( tool ) {
            viewer.addTool( tool );
        } );

        if ( this._project === undefined ) {
            defer.reject();
            return defer.promise;
        }

        this.drawLayers().then( function ( result ) {
            defer.resolve( result );
        } ).catch( function ( result ) {
            defer.reject( result );
        } );
        this._viewer.run();

        return defer.promise;
    },

    drawOrthophotoOrDSM: function ( directory, photogLayer, type, width, height, x, y ) {

        var node = this._planarImages.get( type );

        var far = this._userPreferencesCtrl.getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY ) * Utils.BOUNDING_FACTOR;
        var fovX = 2.0 * Math.atan( ( 0.5 * width ) / far );
        var fovY = 2.0 * Math.atan( ( 0.5 * height ) / far );

        if ( node ) {
            // reset the texture, image url and FOV values because it can be a different version of the dsm or a different region
            node._lastTextureUrl = undefined;

            node.setFieldOfViewValues( fovX, fovY );

            node.setImageURL( directory.path, photogLayer );
            node.enableMultiResolution( true ); // enable again the multiresolution because the setImageURL method disables it
            node.setNodeMask( Utils.VISIBILITY_MASK );
        } else {
            // create planarimage node and set url
            node = new PlanarImage();

            node.setFieldOfViewValues( fovX, fovY );

            node.setImageURL( directory.path, photogLayer );
            node.enableMultiResolution( true );
            this._sceneNode.addChild( node );

            node.setDepth( true, false ); // optional
            this._planarImages.set( type, node );
        }

        if ( x !== undefined ) {
            var position = [ x + width / 2 - this._center[ 0 ], y + height / 2 - this._center[ 1 ], 0 ];
            node.setPosition( position ); // sets the image in its location
            node.computeRotationTranslation();
        }

        var config = {
            position: [ 0, 0, 10 ],
            forward: [ 0, 0, -1 ],
            up: [ 0, 1, 0 ],
            fovy: fovY
        };
        this.setManipulatorMode( pcvizManipulator.PLANAR_IMAGE_MANIPULATOR, config );

        var frustum = {};
        var factor = 15;
        frustum.left = -fovX * factor;
        frustum.right = fovX * factor;
        frustum.bottom = -fovY * factor;
        frustum.top = fovY * factor;

        this._viewer.getOrCreatePlanarImageManipulator().setOrthoFrustum( frustum );

        // self._view.setImagePriority( self._view.getImagePriority() );

        this._viewer.getOrCreatePlanarImageManipulator().setEnableOrtho( true );
        this._viewer.getOrCreatePlanarImageManipulator().updateOrthoFrustum();
    },

    hideOrthophotoOrDSM: function ( type ) {
        var node = this._planarImages.get( type );
        if ( node ) {
            node._dirty = true;
            osgDB.Registry.instance().getReaderWriterForExtension( 'planarimage' )._lowResGeometry = undefined;
            node.setNodeMask( 0x0 );
        }

        this._viewer.getOrCreatePlanarImageManipulator().setEnableOrtho( false );
        this.setManipulatorMode( pcvizManipulator.CAD_MANIPULATOR, {} );
    },

    isVisibleOrthophotoOrDSM: function ( key ) {
        if ( this._planarImages.get( key ) )
            return this._planarImages.get( key ).getNodeMask() !== 0x0;
        return false;
    },

    /**
     * Sets the camera parameters for the manipulator.
     * @param {vec3} eye    The camera position.
     * @param {vec3} target The point the camera aims to.
     * @param {vec3} up     The camera up vector. If `undefined`, the vector (0,0,1) will be used. Some manipulators don't use it.
     */
    setPose: function ( eye, target, up ) {
        this._poseConfig.eye = eye;
        this._poseConfig.target = target;
        this._poseConfig.up = up;
        if ( this._viewer !== undefined && this._cameraManipulator !== undefined ) {
            this.configureManipulatorPose( this._cameraManipulator );
        }
    },

    /* method to know if the user is using a ios browser*/
    isIOSDevice: function () {
        let iosNavigatorPlatform = [
            'iPad Simulator',
            'iPhone Simulator',
            'iPod Simulator',
            'iPad',
            'iPhone',
            'iPod'
        ].includes( navigator.platform );
        return ( iosNavigatorPlatform || ( navigator.userAgent.includes( 'Mac' ) && 'ontouchend' in document ) );
    },

    setPresentVR: function ( value ) {
        this._vrmode = value;
        if ( this._viewer === undefined )
            return;

        let setUpVR = () => {
            this._viewer.setPresentVR( value );
            this._viewer.getEventProxy().DeviceOrientation.setEnable( value );

            // To set current orientation in mobile devices
            if ( window.orientation !== null && window.orientation !== undefined ) {
                this._viewer.getEventProxy().DeviceOrientation._screenOrientation = window.orientation;
                return;
            }

            // Legacy Edge Microsoft Surface
            if ( window.screen.msOrientation === 'landscape-primary' )
                this._viewer.getEventProxy().DeviceOrientation._screenOrientation = 0;

            if ( window.screen.msOrientation === 'portrait-primary' )
                this._viewer.getEventProxy().DeviceOrientation._screenOrientation = 270;

            if ( window.screen.msOrientation === 'portrait-secondary' )
                this._viewer.getEventProxy().DeviceOrientation._screenOrientation = 90;

            // Chrome browser Microsoft Surface
            if ( window.screen.orientation !== null && window.screen.orientation !== undefined &&
                window.screen.orientation.angle !== null && window.screen.orientation.angle !== undefined ) {
                this._viewer.getEventProxy().DeviceOrientation._screenOrientation = window.screen.orientation.angle;
            }
        };

        if ( this.isIOSDevice() && DeviceMotionEvent !== undefined && DeviceMotionEvent.requestPermission !== undefined ) {
            // for IOS devices we should request permissions to the device motion event to subscribe to the sensor mobile listeners
            DeviceMotionEvent.requestPermission().then( response => {
                console.log( response );
                setUpVR();
            } );
            return;
        }
        setUpVR();
    },

    /**
     * Sets the manipulator mode. Depending the mode, a `config` object is required.
     * @param {int} manipulatorMode    A `pcvizManipulator` constant indicating the new mode.
     * @param {object} config An object with the position and or forward and up vectors to configure the camera for panoramas and planar images.
     */
    setManipulatorMode: function ( manipulatorMode, config ) {
        if ( this._manipulatorMode === manipulatorMode ) {
            if ( !config.position )
                return;
        }

        this._manipulatorMode = manipulatorMode;
        this._modeManipulator.setCurrentMode( manipulatorMode, this, config );
        this._viewController.refreshUI();
        const event = new CustomEvent( 'changeManipulator', { detail: manipulatorMode } );
        document.dispatchEvent( event );
    },

    getCurrentManipulatorMode: function () {
        return this._modeManipulator.getMode( this._modeManipulator.getCurrentMode() );
    },

    getCurrentTool: function () {

        return this.getCurrentManipulatorMode().getTool();
    },

    getImageMode: function () {
        if ( this._manipulatorMode === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR )
            return PlanarImageSymbol3D.getImageNodeInstance().getImageMode();
        return PanoramaSymbol3D.getImageNodeInstance().getImageMode();
    },

    setImageMode: function ( mode ) {
        if ( this._manipulatorMode === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR )
            PlanarImageSymbol3D.getImageNodeInstance().setImageMode( mode );
        else
            PanoramaSymbol3D.getImageNodeInstance().setImageMode( mode );
    },

    setImagePriority: function ( imageInFront ) {
        if ( this._manipulatorMode === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR )
            PlanarImageSymbol3D.getImageNodeInstance().setDepth( imageInFront, false );
        else
            PanoramaSymbol3D.getImageNodeInstance().setDepth( imageInFront, false );
        if ( this._viewer !== undefined ) {
            var renderSettings = this._project.getCurrentRenderSettings();
            var edlOn = renderSettings ? renderSettings.get( 'edlOn' ) : false;
            if ( imageInFront )
                edlOn = false;
            this._viewer.setEDLRendering( edlOn );
        }
    },

    getImagePriority: function () {
        if ( this._manipulatorMode === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR )
            return PlanarImageSymbol3D.getImageNodeInstance().getSeeAlways();
        return PanoramaSymbol3D.getImageNodeInstance().getSeeAlways();
    },

    getSavedView: function ( avoidExtraInfo ) {
        var viewMatrix = this._viewer.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        var projMatrix = this._viewer.getCamera().getProjectionMatrix();
        var persParams = {}; // fovy, aspectRatio, zNear, zFar
        osg.mat4.getPerspective( persParams, projMatrix );

        var viewData = {
            sceneCenter: this._center ? [ this._center[ 0 ], this._center[ 1 ], this._center[ 2 ] ] : undefined,
            manipulatorMode: this.getManipulatorMode(),
            imageMode: this.getImageMode(),
            poseEye: [ eye[ 0 ], eye[ 1 ], eye[ 2 ] ],
            poseTarget: [ center[ 0 ], center[ 1 ], center[ 2 ] ],
            poseUp: [ up[ 0 ], up[ 1 ], up[ 2 ] ],
            posePerspective: persParams,
            isOrtho: this._viewer.getIsOrtho(),
            layersData: this._project.getLayersData()
        };

        if ( this.getManipulator() === undefined ) {
            this.setManipulator( this._viewer.getManipulator() );
            var pivotPoint = osg.vec3.create64();
            osg.vec3.copy( pivotPoint, this.getManipulator()._pivotPoint );
            viewData[ 'manipulatorPivotPoint' ] = pivotPoint;
        }

        if ( viewData.isOrtho && this._manipulatorMode !== pcvizManipulator.PLANAR_IMAGE_MANIPULATOR ) {
            var orthoManip = this._viewer.getManipulator();
            var targetOrtho = orthoManip.getTarget( osg.vec3.create() );
            var frustumOrtho = {};
            frustumOrtho = orthoManip.getOrthoFrustum();

            viewData.targetOrtho = [ targetOrtho[ 0 ], targetOrtho[ 1 ], targetOrtho[ 2 ] ];
            viewData.frustumTop = frustumOrtho.top;
            viewData.frustumBottom = frustumOrtho.bottom;
            viewData.frustumRight = frustumOrtho.right;
            viewData.frustumLeft = frustumOrtho.left;
            viewData.version = 2;
        }

        if ( viewData.imageMode ) {
            if ( this._manipulatorMode === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR )
                viewData.planarImageMode = true;
            else if ( this._manipulatorMode === pcvizManipulator.PANORAMA_MANIPULATOR ) {
                viewData.panoramaMode = true;
                var imageManipulator = this._viewer.getOrCreatePanoramaManipulator();
                viewData.zoomOffset = imageManipulator.getZoomOffset().slice();
            }
            if ( viewData.planarImageMode || viewData.panoramaMode ) {
                viewData.imagePriority = this.getImagePriority();
                var frustum = {};
                osg.mat4.getFrustum( frustum, projMatrix );
                viewData.frustumTop = frustum.top;
                viewData.frustumBottom = frustum.bottom;
                viewData.frustumRight = frustum.right;
                viewData.frustumLeft = frustum.left;
            }
        }

        if ( avoidExtraInfo ) {
            delete viewData.layersData;
            return viewData;
        }

        var layersData = {
            styleArray: this._project.getLayersData()
        };
        viewData[ 'layersData' ] = layersData;

        if ( this.getProject().getProjectDataset() !== undefined ) {
            var tocStr = this.getProject().getProjectDataset().getDriver().getConfiguration().toc;
            if ( tocStr === '' ) // this happens in embed mode
                return undefined;
            layersData[ 'toc' ] = JSON.parse( tocStr );
        }

        // save selection
        var selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );
        var selObject = selectionObjectController.getSelectionObject();
        if ( !selObject || !selObject.getFeature || !selObject.getFeature() )
            return viewData;

        var feature = selObject.getFeature();
        viewData.featureID = feature.getId();
        viewData.layerID = feature.getLayerId();
        return viewData;
    },

    restoreLayerData: function ( layerData ) {
        var layer = this.getProject().getLayerById( layerData.id );
        if ( !layer ) // layer might have been removed
            return;

        if ( layer.getType() === LayerType.POINTCLOUD ) {
            var props = layer.getProperties( 'styleGroup' );
            if ( props === undefined )
                layer.initializePropertySet( this.getProject() );
            props = layer.getProperties( 'styleGroup' );

            props.forEach( function ( prop ) {
                var originName = ( prop.field === 'pointSizeFactor' ) ? 'pointSize' : prop.field;
                layer.setProperty( prop.field, layerData.style.PointCloudSymbolizer[ originName ] );
                prop.value = layerData.style.PointCloudSymbolizer[ prop.field ];
            } );
        } else if ( layer.getType() === LayerType.VECTOR ) {
            layer.setStyle( JSON.parse( JSON.stringify( layerData.style ) ) );
            layer.dirtyLabels(); // in case labeling style has changed
            layer.updateSymbolRendererAndRefreshLayerInViews();
        }
        // TODO: RasterLayer
    },

    setSavedView: function ( viewData, infoTool, afterInit ) {
        if ( afterInit ) {
            this._viewer.setZoomNamedView( viewData );
            return;
        }
        var poseEye, poseTarget, targetOrtho;
        if ( viewData.sceneCenter && this._center ) {
            var centerDif = [ viewData.sceneCenter[ 0 ] - this._center[ 0 ], viewData.sceneCenter[ 1 ] - this._center[ 1 ], viewData.sceneCenter[ 2 ] - this._center[ 2 ] ];
            poseEye = [ viewData.poseEye[ 0 ] + centerDif[ 0 ], viewData.poseEye[ 1 ] + centerDif[ 1 ], viewData.poseEye[ 2 ] + centerDif[ 2 ] ];
            poseTarget = [ viewData.poseTarget[ 0 ] + centerDif[ 0 ], viewData.poseTarget[ 1 ] + centerDif[ 1 ], viewData.poseTarget[ 2 ] + centerDif[ 2 ] ];
            if ( viewData.isOrtho )
                targetOrtho = [ viewData.targetOrtho[ 0 ] + centerDif[ 0 ], viewData.targetOrtho[ 1 ] + centerDif[ 1 ], viewData.targetOrtho[ 2 ] + centerDif[ 2 ] ];
        }

        var self = this;
        this._savedEye = poseEye ? poseEye.slice() : viewData.poseEye.slice();
        this._savedCenter = poseTarget ? poseTarget.slice() : viewData.poseTarget.slice();
        this._savedUp = viewData.poseUp.slice();

        var viewDir = osg.vec3.sub( osg.vec3.create(), this._savedCenter, this._savedEye );

        var config = {
            position: this._savedEye // force change even if manipulator is the same
        };
        if ( viewData.panoramaMode ) {
            config.direction = viewDir;
        }
        if ( viewData.planarImageMode ) {
            config.forward = viewDir;
            config.up = viewData.poseUp.slice();
            config.fovy = viewData.posePerspective.fovy;
        }

        this.setManipulatorMode( viewData.manipulatorMode, config );
        // enabling/disabling ortho
        if ( viewData.isOrtho !== undefined && viewData.manipulatorMode === pcvizManipulator.CAD_MANIPULATOR )
            this._viewer.setEnableOrtho( viewData.isOrtho );
        this.setImageMode( viewData.imageMode );
        this.setPose( viewData.poseEye, viewData.poseTarget, viewData.poseUp );

        if ( viewData.manipulatorPivotPoint !== undefined )
            this.getManipulator().setPivotPoint( viewData.manipulatorPivotPoint );

        if ( viewData.isOrtho ) {
            const orthoManip = this._viewer.getManipulator();
            orthoManip.setHomePosition( viewData.poseEye, viewData.poseTarget, viewData.poseUp );
            orthoManip.setTarget( targetOrtho ? targetOrtho : viewData.targetOrtho );

            let frustumLeft = viewData.frustumLeft;
            let frustumRight = viewData.frustumRight;
            let frustumTop = viewData.frustumTop;
            let frustumBottom = viewData.frustumBottom;

            if ( viewData.version === undefined || viewData.version < 2 ) {
                const viewWidth = Math.abs( viewData.frustumRight - viewData.frustumLeft );
                const viewHeight = Math.abs( viewData.frustumTop - viewData.frustumBottom );
                const viewAspect = viewWidth / viewHeight;

                const aspect = this._viewer.getCamera().getViewport().width() / this._viewer.getCamera().getViewport().height();
                if ( viewAspect < aspect ) {
                    var incWidth = ( ( viewWidth * aspect ) - viewWidth ) / 2;
                    frustumLeft = viewData.frustumLeft - incWidth;
                    frustumRight = viewData.frustumRight + incWidth;
                }

                frustumTop = frustumRight;
                frustumBottom = frustumLeft;
            }

            this._viewer.setEnableOrtho( viewData.isOrtho );
            orthoManip.setOrthoFrustum( {
                top: frustumTop,
                bottom: frustumBottom,
                right: frustumRight,
                left: frustumLeft
            } );
            orthoManip.computeFrustum();
            orthoManip.computeZoom( 0.00000001 );

            orthoManip.setHomePosition( poseEye ? poseEye.slice() : viewData.poseEye, poseTarget ? poseTarget.slice() : viewData.poseTarget, viewData.poseUp );
            const distance = osg.vec3.distance( viewData.poseEye, viewData.poseTarget );
            this._viewer.resetManipulatorTarget( viewData.poseTarget, distance );
        }

        if ( ( viewData.planarImageMode || viewData.panoramaMode ) && !viewData.featureID ) {
            var imageManipulator = viewData.panoramaMode ? this._viewer.getOrCreatePanoramaManipulator() : this._viewer.getOrCreatePlanarImageManipulator();
            imageManipulator.setFrustum( viewData.frustumTop, viewData.frustumBottom, viewData.frustumRight, viewData.frustumLeft, viewData.posePerspective.zNear, viewData.posePerspective.zFar );
            if ( viewData.panoramaMode )
                imageManipulator.setZoomOffset( viewData.zoomOffset[ 0 ], viewData.zoomOffset[ 1 ] );
        }

        // restore visibility and style
        if ( viewData.layersData && this.getProject().getProjectDataset() !== undefined ) {
            // regenerating toc
            var tocView = this._viewController.getView( 'TOC' );
            if ( tocView ) {
                var mainLayerGroup = tocView.getTOC();
                this.setAllLayersInvisible( mainLayerGroup ); // those layers not the in saved view should be invisible
                this.getProject().synchronizeTableOfContents( mainLayerGroup, viewData.layersData.toc, true );

                // updating the toc structure on the TocView
                var serializer = new SerializerLayerVisitor();
                mainLayerGroup.accept( serializer );
                this.getProject().getProjectDataset().updateTableOfContents( serializer.getJSONObject() );
            }

            viewData.layersData.styleArray.forEach( function ( layerData ) {
                self.restoreLayerData( layerData );
            } );
        }

        // restore selection
        if ( !viewData.featureID )
            return;

        var layer = this._project.getLayerById( viewData.layerID );
        if ( !layer )
            return;

        var query = layer.getFeature( viewData.featureID );
        if ( !query )
            return;


        query.then( function ( f ) {
            infoTool.setSelectedFeature( f ).then( () => {
                if ( viewData.planarImageMode ) {
                    infoTool.setImageManipulatorPosition( viewDir );
                }
                if ( viewData.planarImageMode || viewData.panoramaMode ) {
                    imageManipulator = viewData.panoramaMode ? self._viewer.getOrCreatePanoramaManipulator() : self._viewer.getOrCreatePlanarImageManipulator();
                    var aspectRatioOffset = ( self._viewer.getCamera().getViewport().width() / self._viewer.getCamera().getViewport().height() ) / viewData.posePerspective.aspectRatio;
                    if ( aspectRatioOffset < 1 )
                        imageManipulator.setFrustum( viewData.frustumTop, viewData.frustumBottom, viewData.frustumRight * aspectRatioOffset, viewData.frustumLeft * aspectRatioOffset, viewData.posePerspective.zNear, viewData.posePerspective.zFar );
                    else
                        imageManipulator.setFrustum( viewData.frustumTop / aspectRatioOffset, viewData.frustumBottom / aspectRatioOffset, viewData.frustumRight, viewData.frustumLeft, viewData.posePerspective.zNear, viewData.posePerspective.zFar );
                    self.setImagePriority( viewData.imagePriority );
                    var symbol = layer.getFeatureRenderer().getSymbol();
                    symbol.getImageNode().enableMultiResolution( viewData.imageMode );

                    self.setManipulatorMode( viewData.manipulatorMode, config );
                }
            } );

        } ).catch( function () {} );
    },

    setAllLayersInvisible: function ( tocLayer ) {
        if ( !tocLayer )
            return;

        var children = tocLayer.getChildren ? tocLayer.getChildren() : undefined;

        if ( !children ) {
            tocLayer.setVisible( false );
            tocLayer.setPreviousVisible( false );
            return;
        }

        var self = this;
        children.forEach( function ( childLayer ) {
            self.setAllLayersInvisible( childLayer );
        } );
    },

    setSavedViewFromNamedView: function ( namedView, infoTool, afterInit ) {
        var viewData = {
            sceneCenter: [ 0, 0, 0 ], // Verity named views use absolute coordinates
            isOrtho: ( namedView.projection !== 'perspective' ),
            manipulatorMode: 0,
            imageMode: false,
            poseEye: namedView.parameters.eye.slice(),
            poseTarget: namedView.parameters.center.slice(),
            poseUp: namedView.parameters.up.slice(),
            posePerspective: {
                zNear: namedView.parameters.zNear,
                zFar: namedView.parameters.zFar,
            }
        };

        if ( viewData.isOrtho ) {
            viewData.targetOrtho = namedView.parameters.targetOrtho.slice();
            viewData.frustumBottom = namedView.parameters.frustumBottom;
            viewData.frustumLeft = namedView.parameters.frustumLeft;
            viewData.frustumRight = namedView.parameters.frustumRight;
            viewData.frustumTop = namedView.parameters.frustumTop;
        } else {
            viewData.posePerspective.fovy = namedView.parameters.fovy;
            viewData.posePerspective.aspectRatio = namedView.parameters.aspectRatio;
        }

        this.setSavedView( viewData, infoTool, afterInit );
    },

    setViewFromVerity: function ( verityView, transform ) {
        // We are understanding views are ortho
        let viewData = {
            sceneCenter: [ transform[ 12 ], transform[ 13 ], transform[ 14 ] ],
            isOrtho: true,
            manipulatorMode: 0,
            imageMode: false,
            poseEye: verityView.CameraLocation.slice(),
            poseTarget: verityView.FocalPoint.slice(),
            poseUp: verityView.CameraUpDirection.slice(),
        };

        viewData.targetOrtho = verityView.FocalPoint.slice();
        viewData.frustumBottom = -verityView.ViewRectangleInfo.ViewHeightAtFocalPoint;
        viewData.frustumLeft = -verityView.ViewRectangleInfo.ViewWidthAtFocalPoint;
        viewData.frustumRight = verityView.ViewRectangleInfo.ViewWidthAtFocalPoint;
        viewData.frustumTop = verityView.ViewRectangleInfo.ViewHeightAtFocalPoint;

        this.setSavedView( viewData );
    },

    configureManipulatorPose: function ( manipulator ) {
        if ( !isNaN( this._poseConfig.eye[ 0 ] ) && !isNaN( this._poseConfig.target[ 0 ] ) ) {
            if ( this._poseConfig.up )
                manipulator.setHomePosition( this._poseConfig.eye, this._poseConfig.target, this._poseConfig.up );
            else
                manipulator.setHomePosition( this._poseConfig.eye, this._poseConfig.target, osg.vec3.fromValues32( 0, 0, 1 ) );
        } else {
            manipulator.computeHomePosition();
        }
    },

    configureForMobileDevices: function ( viewer ) {
        var mobileDevice = /(iPad|iPhone|iPod|Android)/g.test( navigator.userAgent );
        // viewer is missing the useVR getter using it directly for now
        if ( mobileDevice ) {
            // Disable requests while touching
            viewer.getDatabasePager().setTargetMaximumNumberOfPageLOD( 10 );
            viewer._canvas.addEventListener( 'touchmove', function ( /*ev*/) {
                viewer.getDatabasePager().setAcceptNewDatabaseRequests( false );
            } );
            viewer._canvas.addEventListener( 'touchend', function ( /*ev*/) {
                viewer.getDatabasePager().setAcceptNewDatabaseRequests( true );
            } );
        }
    },

    getPointCloudScene: function () {
        return this._sceneNode.getPointCloudScene();
    },

    setManipulator: function ( manipulator ) {
        this._cameraManipulator = manipulator;
        if ( this._viewer !== undefined ) {
            this._viewer.setupManipulator( manipulator );
        }
    },

    getManipulator: function () {
        return this._cameraManipulator;
    },

    /**
     * force refresh sceneView , with the posibility of doing some actions before the requestDraw
     *
     * @method
     * @memberof pcvizApp.SceneView
     */
    forceRequestRedraw: function ( resetShaderCache = false ) {

        if ( resetShaderCache ) {
            this._viewer.getState().getShaderGeneratorProxy().getShaderGenerator( 'PointShader' ).resetCache();
        }
        this._viewer.requestRedraw();

    },

    getShadersCache: function () {
        return this._viewer.getState().getShaderGeneratorProxy().getShaderGenerator( 'PointShader' ).getCache();
    },


    /**
     * refresh sceneView when a layer is updated
     * @method
     * @memberof pcvizApp.SceneView
     * @param  {Layer} layer the layer that is updated
     */
    refreshLayer: function ( layer ) {
        let defer = P.defer();
        let self = this;

        let layerType = layer.getType();
        let node = this._layerRenderer3D.getNodeFromLayer( layer );

        let parentNode;
        if ( node )
            parentNode = node._parents[ 0 ];
        else {
            let group = layer.getParent();
            // group must be defined
            parentNode = this._layerGroupNodes.get( group.getId() );
            if ( !parentNode ) {
                parentNode = new Group();
                this._layerGroupNodes.set( group.getId(), parentNode );
                // FIXME: parentNode should be added to its relative parent group node
                this._sceneNode.getTransformNode().addChild( parentNode );
            }
        }

        if ( layerType === LayerType.VECTOR ) {
            // it can not exists when a layer has not been rendered yet (because it has been just created)
            let previousSymbolGraph = layer.getFeatureRenderer() ? layer.getFeatureRenderer().getSymbolGraph() : undefined;

            parentNode.removeChild( node );

            this._layerRenderer3D.removeLayerNode( layer );

            // When the first feature is added to a layer, its center will change and, at this moment, the scene center may still be (0,0,0)
            let centerRefreshed = self.refreshCenter();
            layer.render( this._layerRenderer3D, this._sceneNode, parentNode ).then( function ( featuresNode ) {
                if ( centerRefreshed )
                    self.resetManipulator();

                if ( featuresNode !== undefined ) {
                    defer.resolve();
                } else {
                    if ( previousSymbolGraph )
                        parentNode.addChild( previousSymbolGraph );
                    defer.reject( 'Layer not refreshed' );
                }
            } );
        } else if ( layerType === LayerType.POINTCLOUD || layerType === LayerType.RASTER ) {
            // TODO: manage errors var previousPointCloudGraph = node);
            if ( node ) {
                parentNode = parentNode._parents[ 0 ];

                let matrixTransform = node._parents[ 0 ];
                matrixTransform.removeChild( node );

                if ( node.cleanNode )
                    node.cleanNode();

                matrixTransform._parents[ 0 ].removeChild( matrixTransform );
                matrixTransform.releaseGLObjects();
                matrixTransform = null;
            }

            this._layerRenderer3D.removeLayerNode( layer );

            layer.render( this._layerRenderer3D, this._sceneNode, parentNode ).then( function () {
                self._viewer.getCamera()
                    .getRenderer()
                    .getState()
                    .resetCaches();

                self._viewer.getState().getShaderGeneratorProxy().getShaderGenerator( 'PointShader' ).resetCache();

                // TODO: manage errors
                /*    if ( (self._layerRenderer3D.getNodeFromLayer( layer ) === undefined || self._layerRenderer3D.getNodeFromLayer( layer ) === previousPointCloudGraph) && previousPointCloudGraph )
                    {
                        // add node
                        defer.reject( 'Layer not refreshed' );
                    }*/
                defer.resolve();
            } );
        }
        return defer.promise;
    },

    /**
     * Refresh sceneView when a layerGroup is updated
     * @method
     * @memberof pcvizApp.SceneView
     * @param  {LayerGroup} layerGroup the layerGroup that is updated
     */
    refreshLayerGroup: function ( layerGroup ) {
        var defer = P.defer();

        // Rendering the station layers
        let lDataCacheObj = this._workspaceController.getWorkspaceDataCache().getDataCacheObject( layerGroup.getId() );
        if ( lDataCacheObj !== undefined ) {
            layerGroup.render( this.getLayerRenderer() );
        }
        defer.resolve();
        return defer.promise;
    },

    /**
     * Recomputes the center of the scene if it has not been set yet.
     * @method
     * @memberof pcvizApp.SceneView
     * @returns {boolean} `true` if the manipulator needs to be reset. Ohterwise, it returns `false`
     */
    refreshCenter: function () {
        if ( this._center !== undefined )
            return false;
        if ( this._viewController.getCenter() !== undefined )
            this._center = this._viewController.getCenter();
        else {
            var extent = this.getProject().getProjectedExtent();
            this._center = this.getViewer().getBoundingFromExtent( new Envelope( extent[ 0 ], extent[ 3 ], extent[ 1 ], extent[ 4 ], extent[ 2 ], extent[ 5 ] ) ).center();
            this._viewController.setCenter( this._center );
        }
        this._viewer.setCenter( this._center );
        this._layerRenderer3D.setCenter( this._center );
        // update transform
        var transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];
        this._sceneNode.getTransformNode().setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
        return true;
    },

    drawLayers: function ( forbiddenResetZoom ) {
        return new Promise( ( resolve ) => {
            let layers = this._project.getAllLayers();
            this.startLoading( layers.length );

            this.renderChildrenLayers( this._project.getProjectDataset()._tableOfContents.layerGroup.children, this._sceneNode.getTransformNode(), forbiddenResetZoom );

            // Drawing the layer Group
            this.drawLayerGroups();

            if ( layers.length === 0 ) {
                resolve();
                return;
            }

            if ( this._center !== undefined ) { // This could be undefined if any layer could be loaded because the user doesn't have any permissions
                let transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];

                this._sceneNode.getTransformNode().setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
            }

            let allLayersOpened = true;
            let layersOpened = [];

            for ( let i = 0; i < layers.length; i++ ) {
                const isLayerOpen = layers[ i ].isOpen();
                allLayersOpened = allLayersOpened && isLayerOpen;

                if ( !layers[ i ].isOpen() )
                    this.progressLoading( 1, true );
                layersOpened.push( { loaded: isLayerOpen } );
            }
            resolve( layersOpened );
        } );
    },

    refreshGrid: function ( resetZoom ) {
        let oldExtent = this._project.getUnprojectedExtent();
        this._project.refreshExtent();
        this.getTool( 'grid' ).buildGrid( this._project );
        let newExtent = this._project.getUnprojectedExtent();
        if ( resetZoom && !Utils.isEqualExtent( oldExtent, newExtent ) ) {
            // Special case for avoid resetManipulator when user is inside a panorama
            if ( this._manipulatorMode === pcvizManipulator.PANORAMA_MANIPULATOR && PanoramaSymbol3D.getImageNodeInstance().getImageMode() )
                return;
            this.resetManipulator();
        }
    },

    drawLayerGroup: function ( lgObj, wksStylesConfig, layersToCommitChanges, index, stationsLength ) {
        lgObj.open().then( () => {
            // Check if the user has change some style in a layer group and restoring it
            let lgConfig = wksStylesConfig.find( config => config.id === lgObj.getId() );
            if ( lgConfig )
                lgObj.setStyle( lgConfig.symbol );

            // Support for previous projects where user has change some configuration.
            // We need ovewrite saved style to avoid using old core-configuration non-configurable by user settings.
            let overwriteOldStyle = false;
            if ( lgConfig && lgObj.getStyle() && lgObj.getStyle().PointSymbolizer ) {
                if ( lgObj.getStyle().PointSymbolizer.stationSymbolizer && lgObj.getStyle().PointSymbolizer.stationSymbolizer.PointSymbolizer ) {
                    const stationSymbolizer = lgObj.getStyle().PointSymbolizer.stationSymbolizer.PointSymbolizer;
                    if ( stationSymbolizer.marker !== '/assets/stationFloorMarker.png' ) {
                        stationSymbolizer.marker = '/assets/stationFloorMarker.png';
                        overwriteOldStyle = true;
                    }
                    if ( !stationSymbolizer.currentMarker ) {
                        stationSymbolizer.currentMarker = '/assets/station-at-location.png';
                        overwriteOldStyle = true;
                    }
                    if ( !stationSymbolizer.surveyMarker ) {
                        stationSymbolizer.surveyMarker = '/assets/surveyed.png';
                        overwriteOldStyle = true;
                    }
                    if ( !stationSymbolizer.surveyedCurrentMarker ) {
                        stationSymbolizer.surveyedCurrentMarker = 'assets/surveyed-at-location.png';
                        overwriteOldStyle = true;
                    }
                    if ( !stationSymbolizer.billboard ) {
                        stationSymbolizer.billboard = true;
                        overwriteOldStyle = true;
                    }
                }

                if ( lgObj.getStyle().PointSymbolizer.floorSymbolizer && lgObj.getStyle().PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
                    const floorSymbolizer = lgObj.getStyle().PointSymbolizer.floorSymbolizer.PointSymbolizer;
                    if ( floorSymbolizer.marker !== '/assets/targetMarker.svg' ) {
                        floorSymbolizer.marker = '/assets/targetMarker.svg';
                        overwriteOldStyle = true;
                    }
                    // Special cases for Site old symbology. Billboard property can't be changed by UI, and curent symbols deactivate it.
                    // So if we are in Collage Site and billboard remains activated, is an old symbol version.
                    if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default.a.isSite() && floorSymbolizer.billboard ) {
                        floorSymbolizer.billboard = false;
                        floorSymbolizer.autoScale = false;
                        delete floorSymbolizer.minScale;
                        delete floorSymbolizer.currentMarker;
                        delete floorSymbolizer.surveyMarker;
                        delete floorSymbolizer.surveyedCurrentMarker;
                        overwriteOldStyle = true;
                    }
                }

                if ( overwriteOldStyle ) {
                    layersToCommitChanges.push( lgObj );
                }
            }

            if ( this._layerRenderer3D === undefined )
                this._layerRenderer3D = new LayerRenderer3D( this._center );
            lgObj.render( this.getLayerRenderer() );

            if ( layersToCommitChanges.length && ( index === undefined || index === stationsLength - 1 ) )
                this.commitChangesLayerGroups( layersToCommitChanges );
        } );
    },
    drawLayerGroups: function () {
        let wksStylesConfig = this.getProject().getProjectDataset().getDriver().getConfigExtData().wksStyles;

        // Rendering the station layers
        let stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let stations = this._workspaceController.getWorkspaceDataCache().findElementsByCategory( stationCat );
        let layersToCommitChanges = [];
        stations.forEach( ( stationElement, index ) => {
            let lgObj = stationElement.getLayerGroupObj();

            this.drawLayerGroup( lgObj, wksStylesConfig, layersToCommitChanges, index, stations.length );
        } );

        Registry.getInstance().getController( 'ScanSelection' ).registerListener( ListenerController.PROJECT, ( args ) => {
            if ( args && args.length && args[ 0 ] ) {
                let previousUuid = args[ 0 ];
                let stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
                let stations = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );
                let station = stations.find( ( stationElement ) => {
                    return stationElement._workspaceObj.uuid === previousUuid;
                } );

                // It is possible that the previous station was not in the workspace because the user was creating it.
                if ( station ) {
                    let previousStationLayer = station.getLayerGroupObj();
                    this.refreshLayerGroup( previousStationLayer );
                }
            }
            let currentStationLayer = Registry.getInstance().getController( 'ScanSelection' ).getCurrentStationLayer();
            if ( currentStationLayer )
                this.refreshLayerGroup( currentStationLayer );

            this._viewer.requestRedraw();
        }, 'SceneView', 'currentStation' );
    },

    forceUpdateOldStyles: function ( layer ) {

        if ( !layer.isOpen() ) {
            return;
        }

        let layerStyle = layer.getStyle();
        let overwriteOldStyle = false;
        if ( VectorLayerUtils.isTargetLayer( layer ) ) {
            if ( layerStyle.PointSymbolizer && layerStyle.PointSymbolizer.floorSymbolizer ) {
                let targetFloorSymbolizer = layerStyle.PointSymbolizer.floorSymbolizer.PointSymbolizer;
                if ( targetFloorSymbolizer.marker !== '/assets/targetMarker.svg' ) {
                    targetFloorSymbolizer.marker = '/assets/targetMarker.svg';
                    overwriteOldStyle = true;
                }
                if ( targetFloorSymbolizer.selectionMarker !== '/assets/targetMarker.svg' ) {
                    targetFloorSymbolizer.selectionMarker = '/assets/targetMarker.svg';
                    overwriteOldStyle = true;
                }
            }
        }

        if ( overwriteOldStyle ) {
            layer.setStyle( layerStyle );
            layer.commitChanges( true, this.getProject() );
        }

    },

    commitChangesLayerGroups: function ( layers ) {
        let layer = layers.pop();
        layer.commitChanges( true, this.getProject() ).then( () => {
            if ( layers.length )
                this.commitChangesLayerGroups( layers );
        } );
    },

    renderChildrenLayers: function ( children, node, forbiddenResetZoom ) {
        for ( var i = 0; i < children.length; i++ ) {
            if ( children[ i ].layerGroup ) {
                const group = this.renderLayerGroup( children[ i ].layerGroup, node );
                this.renderChildrenLayers( children[ i ].layerGroup.children, group, forbiddenResetZoom );
            } else {
                this.drawLayer( this._project.getLayerById( children[ i ].id ), !forbiddenResetZoom, node );
            }
        }
    },

    renderLayerGroup: function ( layerGroup, parentNode ) {
        const group = new Group();
        group.setName( layerGroup.name );
        if ( layerGroup.transformMatrix && !CRSUtils.isEcefPoint( layerGroup.transformMatrix[ 3 ], layerGroup.transformMatrix[ 7 ], layerGroup.transformMatrix[ 11 ] ) ) {
            osg.mat4.transpose( group.getMatrix(), layerGroup.transformMatrix );
            group.setMatrix( group.getMatrix() );
        }
        this._layerGroupNodes.set( layerGroup.id, group );
        parentNode.addChild( group );

        // Adding group to workspace cache
        this._workspaceController.getWorkspaceDataCache().updateOrCreateDataCacheObject( layerGroup.id, undefined, group, undefined );
        return group;
    },

    ensureLayerGroupTree: function ( layerGroup ) {
        const parentNode = this._layerGroupNodes.get( layerGroup.getId() );
        if ( !parentNode ) {
            return;
        }
        const children = layerGroup.getChildren();
        for ( let child of children ) {
            if ( child.getType() === 'LayerGroup' ) {
                let group = this._layerGroupNodes.get( child.getId() );
                if ( !group ) {
                    let childData = { id: child.getId(), name: child.getName(), transformMatrix: child.getTransformMatrix() };
                    group = this.renderLayerGroup( childData, parentNode );
                }
                this.ensureLayerGroupTree( child );
            }
        }
    },

    drawLayer: function ( layer, resetManipulator, parentNode ) {
        var self = this;
        if ( this._layerRenderer3D === undefined )
            this._layerRenderer3D = new LayerRenderer3D( this._center );

        if ( !layer.getCenter() )
            layer.computeCenter();

        var centerRefreshed = this.refreshCenter();

        this.forceUpdateOldStyles( layer ); // DEPRECATE when no needed

        layer.render( this._layerRenderer3D, this._sceneNode, parentNode ).then( function () {
            // Manipulator is reset to recompute the scene home position if resetManipulator is true
            // resetManipulator is true when we're drawing the layers for the first time or when the scene is empty and the first layer is added.
            if ( resetManipulator || centerRefreshed ) {
                self.resetManipulator();
            }

            self.progressLoading( 1, resetManipulator );

            if ( layer.getCategory && layer.getCategory() === VectorLayerUtils.Categories.PLANAR_IMAGE ) {
                self._userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.PLANAR_IMAGE_DISTANCE_KEY, function () {
                    layer.getFeatureRenderer().getSymbol().setCamerasInvalidation( true );
                    self.refreshLayer( layer );
                } );
            }
            self._viewer.requestRedraw();
        }, () => {
            self.progressLoading( 1 );
        } );
    },

    // find scene graph node for any layer
    findLayerNode: function ( layer ) {

        if ( layer instanceof LayerGroup )
            return this._layerGroupNodes.get( layer.getId() );

        return this._layerRenderer3D.getNodeFromLayer( layer );
    },

    findTransformGroupLayerNode: function ( layer ) {

        var layerNode = this.findLayerNode( layer );

        var foundTGroup;
        var self = this;

        // first, check if it's a StationSet
        var stationSetCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.StationSet ).name;
        var stationsSetCache = this._workspaceController.getWorkspaceDataCache().findElementsByCategory( stationSetCat );
        stationsSetCache.forEach( function ( stationSetDataCacheObj ) {

            if ( stationSetDataCacheObj.getOsgNodeObj() === layerNode )
                foundTGroup = layerNode;
        } );
        if ( foundTGroup )
            return foundTGroup;

        // then check Stations and children
        var stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        var stationsCache = this._workspaceController.getWorkspaceDataCache().findElementsByCategory( stationCat );
        stationsCache.forEach( function ( stationDataCacheObj ) {

            var foundGroup = self.findTransformGroupLayerImpl( stationDataCacheObj.getOsgNodeObj(), layerNode );
            if ( foundGroup )
                foundTGroup = foundGroup;
        } );

        return foundTGroup;
    },


    findTransformGroupLayerImpl: function ( parent, layerNode ) {

        if ( parent === layerNode || this.hasChildLayer( parent, layerNode ) ) {
            return parent;
        }
    },

    /**
     * Checks if the parent osg.Node has the layerNode (osg.Node) under its children tree (searching recursively)
     * @method
     * @memberof pcvizApp.SceneView
     * @param  {osg.Node}   parent the node to search in its children
     * @param {osg.Node}    layerNode the node relative to a layer to be found
     * @return {boolean}    returns true if the parent has the layerNode under its children tree
     */
    hasChildLayer: function ( parent, layerNode ) {

        var children = parent.getChildren();
        if ( !children || children.length === 0 )
            return false;

        var foundChild = false;
        var self = this;
        children.forEach( function ( child ) {

            if ( child === layerNode || self.hasChildLayer( child, layerNode ) )
                foundChild = true;
        } );
        return foundChild;
    },

    getOrCreateGroupNode: function ( parentId, newGroupId, name ) {
        let groupNode = this._layerGroupNodes.get( newGroupId );
        if ( groupNode )
            return groupNode;

        let parentNode = this._layerGroupNodes.get( parentId );
        if ( !parentNode )
            return undefined;

        groupNode = new Group();
        groupNode.setName( name );
        this._layerGroupNodes.set( newGroupId, groupNode );
        parentNode.addChild( groupNode );

        return groupNode;
    },

    registerLayerActions: function () {

        let self = this;

        let onAddLayer = function ( layer, parentId ) {

            let groupId = parentId;
            if ( !groupId ) {
                let group = layer.getParent();
                groupId = group.getId();
            }
            // when a layer has been added, it must have a group (object)
            let groupNode = self._layerGroupNodes.get( groupId );
            if ( !groupNode ) {
                groupNode = new Group();
                self._layerGroupNodes.set( groupId, groupNode );
                self._sceneNode.getTransformNode().addChild( groupNode ); // it should be added to its parent layergroup node
            }

            self.drawLayer( layer, undefined, groupNode );

        };

        let onDeleteLayer = function ( id, layer ) {

            let layerNode = self._layerRenderer3D.getNodeFromLayer( layer );
            if ( layerNode !== undefined ) { //Now, we can remove layers that have not been rendered (Lidar layers before processing scans)
                let mt = layerNode._parents[ 0 ];
                mt.removeChild( layerNode );
                mt._parents[ 0 ].removeChild( mt ); // removes MatrixTransform
                self._layerRenderer3D.removeLayerNode( layer );
            }

            // DISABLE resetting the scene center to undefined for "empty scenes": we don't take into account 3D models and other potential data
            // The only problem of avoiding the reset is that adding new layers located far away will cause precision issues. In that case it's better to create a new project

            // if ( self._sceneNode.getPointCloudScene().getPointCloudNodes().length === 0 && self._sceneNode.getVectorLayerScene().getNumFeaturesNodes() === 0 ) {
            //     self._center = undefined;
            //     self._viewer.setCenter( self._center );
            // }
        };

        let onDeleteVectorLayer = function ( id, layer ) {
            let layerNode = self._layerRenderer3D.getNodeFromLayer( layer );
            if ( layerNode !== undefined ) {
                layerNode._parents[ 0 ].removeChild( layerNode );

                self._layerRenderer3D.removeLayerNode( layer );
            }
            // DISABLE resetting the scene center. See comment above.

            // if ( self._sceneNode.getPointCloudScene().getPointCloudNodes().length === 0 && self._sceneNode.getVectorLayerScene().getNumFeaturesNodes() === 0 ) {
            //     self._center = undefined;
            //     self._viewer.setCenter( self._center );
            // }
        };

        let onDeleteLayerGroup = ( id, layer ) => {
            let wsDataCacheObject = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( layer.getId() );
            let osgNode = wsDataCacheObject.getOsgNodeObj();
            let parent = osgNode.getParents();
            parent[ 0 ].removeChild( osgNode );


            // 1: delete possible childs of layer mapped in the _layerGroupNodes map
            let deleteChildIfNeeded = ( instanceId ) => {
                this._layerGroupNodes.forEach( ( value, key, map ) => {
                    if ( value.getInstanceID() === instanceId )
                        map.delete( key );
                } );
            };

            for ( let child of this._layerGroupNodes.get( id ).children ) {
                deleteChildIfNeeded( child.getInstanceID() );
            }

            // 2: delete the layer itself from the _layerGroupNodes map
            this._layerGroupNodes.delete( id );
        };

        this.registerLayerAction( 'add', 'PointCloud', onAddLayer );
        this.registerLayerAction( 'delete', 'PointCloud', onDeleteLayer );
        this.registerLayerAction( 'add', 'RasterLayer', onAddLayer );
        this.registerLayerAction( 'delete', 'RasterLayer', onDeleteLayer );
        this.registerLayerAction( 'add', 'VectorLayer', onAddLayer );
        this.registerLayerAction( 'delete', 'VectorLayer', onDeleteVectorLayer );
        this.registerLayerAction( 'delete', 'LayerGroup', onDeleteLayerGroup );

    },

    saveCameraInfo: function ( eye, center, up ) {
        this._savedEye = osg.vec3.create64();
        osg.vec3.copy( this._savedEye, eye );
        this._savedCenter = osg.vec3.create64();
        osg.vec3.copy( this._savedCenter, center );
        this._savedUp = osg.vec3.create64();
        osg.vec3.copy( this._savedUp, up );
    },

    hasSavedCameraInfo: function () {
        return this._savedEye;
    },

    destroy: function () {
        this._rootNode.accept( Utils.getReleaseGLObjectVisitor() );
        osg.RenderBin.clean();
        osg.RenderStage.clean();
        osg.StateGraph.pooledStateGraph.clean();
        this._toolBar.forEach( function ( tool ) {
            tool._viewer = undefined;
        } );
        this._viewer.destroy();
    },

    areAllLayersRendered: function () {
        var layers = this._project.getAllLayers();

        if ( layers.length === 0 ) {
            return true;
        }

        var out = true;
        for ( var i = 0; i < layers.length; i++ ) {
            out = out && ( layers[ i ].isRendered() || ( layers[ i ].permissions && layers[ i ].permissions.viewPermission === false ) || layers[ i ].isIncomplete() ); // For PointClouds and Rasters we need to check if they are incomplete
            if ( !out )
                break;
        }


        return out;
    },
    zoomToLayerAfterInitialize: function ( layer, options ) {
        this.getViewer().setZoomLayer( layer );
        this.getViewer().setZoomOptions( options );
    },

    zoomToFeatureAfterInitialize: function ( layer, feature, options ) {
        this.getViewer().setZoomLayer( layer );
        this.getViewer().setZoomFeature( feature );
        this.getViewer().setZoomOptions( options );
    },

    zoomToExtentAfterInitialize: function ( extent, options ) {
        this.getViewer().setZoomExtent( extent );
        this.getViewer().setZoomOptions( options );
    },

    zoomToSavedViewAfterInitialize: function ( name ) {
        var extData = this.getProject().getExtData();
        if ( !extData || !extData.savedViews ) {
            console.log( 'No saved views in project' );
            return;
        }

        var foundView = extData.savedViews.find( function ( savedView ) {
            return ( savedView.name === name );
        } );

        if ( foundView ) {
            this.getViewer().setZoomNamedView( foundView.viewData );
            return;
        }
        console.log( 'Saved view <' + name + '> not found in project' );
    },

    changeViewPointAfterInitialize: function ( options ) {
        this.getViewer().setZoomOptions( options );
    },

    // view actions
    zoomToLayer: function ( layer, options ) {
        this.getViewer().zoomToLayer( layer, options );
    },

    zoomToFeature: function ( layer, feature, options ) {
        this.getViewer().zoomToFeature( layer, feature, options );
    },

    zoomToExtent: function ( extent, options ) {
        this.getViewer().zoomToExtent( extent, options );
    },

    changeViewPoint: function ( options ) {
        this.getViewer().changeViewPoint( options, {} );
    },

    // WARN: be careful if you call this method having a map view
    resetCenter: function () {
        this._center = undefined;
        this._viewController.setCenter( this._center );
    },

    setEnableIntersections: function ( enableIntersections, type ) {
        this._layerRenderer3D.getLayerNodesByType( type ).forEach( function ( node, layerKey ) {
            if ( enableIntersections )
                node.setNodeMask( layerKey._visible ? ~0x0 : 0x0 );
            else
                node.setNodeMask( layerKey._visible ? ~Utils.TRAVERSAL_MASK_IV : 0x0 );
        } );

    },

    disableAllIntersectionsExceptControlPoints() {
        this.setEnableIntersections( false, LayerType.VECTOR );
        this.setEnableIntersections( false, LayerType.POINTCLOUD );
        this.setEnableIntersections( false, LayerType.RASTER );

        let controlPointsLayers = this._project.getControlPointsLayers();
        if ( controlPointsLayers !== undefined && controlPointsLayers.length )
            controlPointsLayers.forEach( layer => {
                let layerNode = this.getLayerRenderer().getNodeFromLayer( layer );
                if ( layerNode )
                    layerNode.setNodeMask( ~0x0 );
            } );
    },

    enableAllIntersections() {
        this.setEnableIntersections( true, LayerType.VECTOR );
        this.setEnableIntersections( true, LayerType.POINTCLOUD );
        this.setEnableIntersections( true, LayerType.RASTER );
    },

    clearSceneNodeTransformNode: function () {
        this._sceneNode.getTransformNode().accept( Utils.getReleaseGLObjectVisitor() );

        this._sceneNode.getTransformNode().removeChildren();
        // We need to remove any pointer to the nodes. So, reset _layerNodes map in _layerRenderer3D
        if ( this._layerRenderer3D ) {
            this._layerRenderer3D.initLayerNodes();
        }
    },

    onKeyUpEvent: function ( ev ) {
        if ( ev.key === 'D' ) { // D key
            // toggle stats
            if ( this._viewer.getViewerStats() ) {
                this._viewer.resetViewerStats();
                let children = this._viewer.getCamera().getChildren();
                let statsNode = children.find( ( child ) => { return child.getName() === 'osgStats'; } );
                this._viewer.getCamera().removeChild( statsNode );
            } else {
                this._viewer._options.extend( { 'stats': true } );
                this._viewer.initStats( this._viewer._options );
            }
        }
        /*else if ( ev.key === 'G' ) { // G key
                   // toggle DebugGraph
                   const elementsByClass = document.getElementsByClassName( 'osgDebugButton' );
                   if ( !elementsByClass[ 0 ] || elementsByClass[ 0 ].style.display === 'none' )
                       osgUtil.DisplayGraph.instance().refreshGraph();
                   else {
                       osgUtil.DisplayGraph.instance().reset();
                       osgUtil.DisplayGraph.instance().focusOnScene();
                   }
               }*/
        else if ( ev.key === 'g' ) { // g key
            osgUtil.DisplayGraph.instance().refreshGraph( true ); // true param for only generating the graph structure and avoid render it
        }
        /* else if ( ev.key === 's' ) { // Only necessary because the button is not visible due to its zindex value -> Now the button is visible
                    osgUtil.DisplayGraph.instance().focusOnScene();
                }*/

        ev.stopPropagation();
    }



    // FIXME: When we want to do something after a reorder event, implement it. (See how we manage the layer actions events)
    // addEventListeners: function () {
    //     var self = this;
    //     document.body.addEventListener( 'reorder', function ( /*ev*/) {
    //         console.log( 'reorder' );
    //     } );
    // }

    /* endLoading: function ( resetManipulator ) {
        View.prototype.endLoading.call( this, resetManipulator );
        if ( MagnetAPI.isDevelopment() && !MagnetAPI.isSite() )
            osgUtil.DisplayGraph.instance().refreshGraph();
    } */

} ) );

/* harmony default export */ __webpack_exports__["default"] = (SceneView);


/***/ }),

/***/ "./sources/pcvizApp/TableView.js":
/*!***************************************!*\
  !*** ./sources/pcvizApp/TableView.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TableView; });
/* harmony import */ var pcvizApp_ProjectView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizApp/ProjectView */ "./sources/pcvizApp/ProjectView.js");
/* harmony import */ var pcvizApp_ProjectView__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizApp_ProjectView__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_1__);






/**
 * Defines the Table View core class to refresh layer as it is done in other views
 * @class
 * @memberof pcvizApp
 * @extends pcvizApp.View
 */
class TableView extends pcvizApp_ProjectView__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor( project ) {
        super( project );
    }

    /* Now this is managed in the UI classes 
     registerLayerActions() {

         var self = this;

         this.registerLayerAction( 'add', 'PointCloud', function ( layer ) {
             console.log( 'added pointcloud' + layer );
             //self.endLoading();
         } );

         this.registerLayerAction( 'delete', 'PointCloud', function ( id ) {
             //  self.deleteLayerById( self._toc, id );
             console.log( 'deleted pointcloud' + id );
             // self.endLoading();
         } );

         this.registerLayerAction( 'add', 'VectorLayer', function ( layer ) {
             // self._toc.addLayerToGroup( layer, layer.getCategory() );
             console.log( 'added vectorlayer' + layer );
             //  self.endLoading();
         } );

         this.registerLayerAction( 'delete', 'VectorLayer', function ( id ) {
             console.log( 'delete vectorlayer' + id );
             //    self.endLoading();
         } );
     } */

    refreshLayer() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_1___default.a.defer();
        this.endLoading();
        defer.resolve();
        return defer.promise;
    }

}


/***/ }),

/***/ "./sources/pcvizApp/TocView.js":
/*!*************************************!*\
  !*** ./sources/pcvizApp/TocView.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ProjectView = __webpack_require__( /*! pcvizApp/ProjectView */ "./sources/pcvizApp/ProjectView.js" );
var LayerGroup = __webpack_require__( /*! pcvizGIS/LayerGroup */ "./sources/pcvizGIS/LayerGroup.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;

/**
 * Defines the project's TOC
 * @class
 * @memberof pcvizApp
 * @extends pcvizApp.ProjectView
 */
var TocView = function ( project ) {
    ProjectView.call( this, project );
    this._toc = new LayerGroup();
    this._toc.acceptChildren( true );
    var self = this;
    // We pass the parent TOC, the method 'getTableOfContents' knows what to do if a
    // LayerGroup is passed or if its undefined.
    // This is implemented in this way to avoid too many changes in the TocWidgetController at this point.
    project.getTableOfContents( this._toc ).then( function ( /*tableOfContents*/) {
        self.endLoading();
    } );
    // Init layer actions
    this.registerLayerActions();

};

TocView.prototype = osg.objectInherit( ProjectView.prototype, {

    /**
     * set the TOC LayerGroup
     * @method
     * @memberof pcvizApp.TocView
     * @param {toc} group of layer
     */
    setToc: function ( toc ) {
        this._toc = toc;
    },

    /**
     * Get the TOC LayerGroup
     * @method
     * @memberof pcvizApp.TocView
     * @return {pcvizGIS.LayerGroup} the layers structured
     */
    getTOC: function () {
        return this._toc;
    },

    /**
     * Delete Layer by name NOT USED
     * @method
     * @param {layer} group of layer
     * @param {name} name to delete
     * @memberof pcvizApp.TocView
     * @return {pcvizGIS.LayerGroup} the layers structured
     */
    deleteLayerByName: function ( layer, name ) {
        for ( var i = 0; i < layer.getChildren().length; i++ ) {
            if ( layer.getChildren()[ i ]._name === name ) {
                layer.getChildren().splice( i, 1 );
                // TODO: if layer doesn't have any more childs, delete layer
                break;
            }
            if ( layer.getChildren()[ i ].getChildren && layer.getChildren()[ i ].getChildren().length > 0 )
                this.deleteLayerByName( layer.getChildren()[ i ], name );
        }
        this.endLoading();
    },

    /**
     * Delete Layer by id
     * @method
     * @param {layer} group of layer
     * @param {name} name to delete
     * @memberof pcvizApp.TocView
     * @return {pcvizGIS.LayerGroup} the layers structured
     */
    deleteLayerById: function ( layer, id ) {
        for ( var i = 0; i < layer.getChildren().length; i++ ) {
            var child = layer.getChildren()[ i ];
            if ( child.getId() === id ) {
                layer.getChildren().splice( i, 1 );
                // TODO: if layer doesn't have any more childs, delete layer
                break;
            }
            if ( child.getChildren && child.getChildren().length > 0 )
                this.deleteLayerById( child, id );
        }
    },

    /**
     * delete point cloud Layer to the toc NOT USED
     * @method
     * @param {string} Name to delete
     * @memberof pcvizApp.TocView
     * @return {pcvizGIS.LayerGroup} the layers structured
     */
    deletePointCloudLayer: function ( name ) {
        this.deleteLayerByName( this._toc, name );
    },


    /**
     * delete vector layer to the toc NOT USED
     * @method
     * @param {string} Name to delete
     * @memberof pcvizApp.TocView
     * @return {pcvizGIS.LayerGroup} the layers structured
     */
    deleteVectorLayer: function ( name ) {
        this.deleteLayerByName( this._toc, name );
    },

    /**
     * updates the toc with the UI changes
     * @method
     * @memberof pcvizApp.TocView
     */
    updateTableOfContents: function () {
        this._project.updateTableOfContentsConfiguration( this._toc );
    },

    registerLayerActions: function () {

        var self = this;

        var onDeleteLayer = function ( id ) {
            self.deleteLayerById( self._toc, id );
            self.updateTableOfContents();
            self.endLoading();
        };

        this.registerLayerAction( 'add', LayerType.POINTCLOUD, function ( layer, parentId ) {
            self._toc.addLayerToGroup( layer, LayerType.POINTCLOUD, 'PointClouds', parentId );
            self.updateTableOfContents();
            self.endLoading();
        } );

        this.registerLayerAction( 'delete', LayerType.POINTCLOUD, onDeleteLayer );

        this.registerLayerAction( 'add', LayerType.VECTOR, function ( layer, parentId ) {
            self._toc.addLayerToGroup( layer, layer.getCategory(), undefined, parentId );
            self.updateTableOfContents();
            self.endLoading();
        } );

        this.registerLayerAction( 'delete', LayerType.VECTOR, onDeleteLayer );

        this.registerLayerAction( 'add', LayerType.RASTER, function ( layer, parentId ) {
            self._toc.addLayerToGroup( layer, LayerType.RASTER, 'RasterLayers', parentId );
            self.updateTableOfContents();
            self.endLoading();
        } );
        this.registerLayerAction( 'delete', LayerType.RASTER, onDeleteLayer );

        this.registerLayerAction( 'delete', LayerType.GROUP, onDeleteLayer );
    }

    // FIXME: When we want to do something after a reorder event, implement it. (See how we manage the layer actions events)
    // addEventListeners: function () {
    //     var self = this;
    //     document.body.addEventListener( 'reorder', function ( /*ev*/) {
    //         console.log( 'reorder' );
    //     } );
    // }
} );

module.exports = TocView;


/***/ }),

/***/ "./sources/pcvizApp/View.js":
/*!**********************************!*\
  !*** ./sources/pcvizApp/View.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ToolBar = __webpack_require__( /*! pcvizTools/ToolBar */ "./sources/pcvizTools/ToolBar.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

// TODO refactor all of the View extending objects in prototype-based OO pattern to new Java Script classes
var View = function () {
    this._toolBar = new ToolBar();

    this._resourcesPath = '';

    this._isLoading = false;
    this._progress = 0;
    this._maxProgress = 0;

    this._startLoadingCallback = undefined;
    this._endLoadingCallback = undefined;
};

View.prototype = {
    getViewer: function () {
        return this._viewer;
    },

    getRootNode: function () {
        return this._rootNode;
    },

    addTool: function ( tool, group ) {
        this._toolBar.addTool( tool, group );
    },

    getToolbar: function () {
        return this._toolBar;
    },

    getTool: function ( tool ) {
        return this._toolBar.getTool( tool );
    },

    run: function () {
        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    setProjection: function ( projection ) {
        this._projection = projection;
    },

    setResourcesPath: function ( path ) {
        this._resourcesPath = path;
    },

    setStartLoading: function ( callBack ) {
        this._startLoadingCallback = callBack;
    },

    setEndLoading: function ( callBack ) {
        this._endLoadingCallback = callBack;
    },

    isLoading: function () {
        return this._isLoading;
    },

    startLoading: function ( maxProgress ) {
        this._isLoading = true;
        this._maxProgress = maxProgress;
        this._progress = 0;
        if ( this._startLoadingCallback )
            this._startLoadingCallback();
    },

    addLoading: function () {
        this._maxProgress++;
    },

    progressLoading: function ( step, resetManipulator ) {
        this._progress += step;
        if ( this._progress >= this._maxProgress ) {
            this._isLoading = false;
            this.endLoading( resetManipulator );
        }
    },

    endLoading: function ( resetManipulator ) {
        if ( this._endLoadingCallback )
            this._endLoadingCallback( resetManipulator );
    },

    destroy: function () {
        this._toolBar = undefined;
    },

    // query parameters methods
    zoomToExtentAfterInitialize: function ( /*extent, options*/) {},

    zoomToSavedViewAfterInitialize: function ( /*name*/) {},

    changeViewPointAfterInitialize: function ( /*options*/) {},

    // view actions
    zoomToExtent: function ( /*extent*/) {},

    changeViewPoint: function ( /*options*/) {}
};

module.exports = View;


/***/ }),

/***/ "./sources/pcvizApp/pcvizApp.js":
/*!**************************************!*\
  !*** ./sources/pcvizApp/pcvizApp.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizApp_Application__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizApp/Application */ "./sources/pcvizApp/Application.js");
/* harmony import */ var pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizApp/BaseSceneView */ "./sources/pcvizApp/BaseSceneView.js");
/* harmony import */ var pcvizApp_SceneView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizApp/SceneView */ "./sources/pcvizApp/SceneView.js");
/* harmony import */ var pcvizApp_JobSiteView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizApp/JobSiteView */ "./sources/pcvizApp/JobSiteView.js");
/* harmony import */ var pcvizApp_JobSiteSceneView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizApp/JobSiteSceneView */ "./sources/pcvizApp/JobSiteSceneView.js");
/* harmony import */ var _JobSiteTableView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./JobSiteTableView */ "./sources/pcvizApp/JobSiteTableView.js");


const View = __webpack_require__( /*! pcvizApp/View */ "./sources/pcvizApp/View.js" );

const ProjectView = __webpack_require__( /*! pcvizApp/ProjectView */ "./sources/pcvizApp/ProjectView.js" );

const TocView = __webpack_require__( /*! pcvizApp/TocView */ "./sources/pcvizApp/TocView.js" );
const TableView = __webpack_require__( /*! pcvizApp/TableView */ "./sources/pcvizApp/TableView.js" ).default;




/** @namespace pcvizApp */
const pcvizApp = {};
pcvizApp.Application = pcvizApp_Application__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizApp.View = View;
pcvizApp.BaseSceneView = pcvizApp_BaseSceneView__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizApp.ProjectView = ProjectView;
pcvizApp.SceneView = pcvizApp_SceneView__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizApp.TocView = TocView;
pcvizApp.TableView = TableView;
pcvizApp.JobSiteView = pcvizApp_JobSiteView__WEBPACK_IMPORTED_MODULE_3__["default"];
pcvizApp.JobSiteSceneView = pcvizApp_JobSiteSceneView__WEBPACK_IMPORTED_MODULE_4__["default"];
pcvizApp.JobSiteTableView = _JobSiteTableView__WEBPACK_IMPORTED_MODULE_5__["default"];

/* harmony default export */ __webpack_exports__["default"] = (pcvizApp);


/***/ }),

/***/ "./sources/pcvizDB/ApplicationController.js":
/*!**************************************************!*\
  !*** ./sources/pcvizDB/ApplicationController.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A singleton controller to update views when layers are changed
 * @class
 * @memberof pcvizDB
 */
var ApplicationController = function () {
    this._app = undefined;
};

ApplicationController.prototype = {

    /**
     * Registers the application to be accessed from any class.
     * @method
     * @memberof pcvizDB.ApplicationController
     * @param  {Application} app The application.
     */
    registerApplication: function ( app ) {
        this._app = app;
    },

    /**
     * Return the registered application
     * @method
     * @memberof pcvizDB.ApplicationController
     * @return {Application} The application
     */
    getApplication: function () {
        return this._app;
    }
};

module.exports = ApplicationController;


/***/ }),

/***/ "./sources/pcvizDB/BaseListener.js":
/*!*****************************************!*\
  !*** ./sources/pcvizDB/BaseListener.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
class BaseListener {
    constructor() {
        this._listeners = new Map();
    }

    on( action, fn ) {
        if ( !this._listeners.has( action ) ) {
            this._listeners.set( action, new Set() );
        }
        this._listeners.get( action ).add( fn );
    }

    notify( action, ...args ) {
        if ( !this._listeners.has( action ) ) {
            return;
        }
        for ( let fn of this._listeners.get( action ) ) {
            fn( ...args );
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = (BaseListener);


/***/ }),

/***/ "./sources/pcvizDB/BlobStorageController.js":
/*!**************************************************!*\
  !*** ./sources/pcvizDB/BlobStorageController.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


/**
 * A singleton controller to manage blob storage
 * @class
 * @memberof pcvizDB
 */
class BlobStorageController {
    constructor() {
        this.storage = new Map();
    }

    addBlob( key, blob ) {
        this.storage.set( key, blob );
    }

    getBlob( key ) {
        return this.storage.get( key );
    }

    hasBlob( key ) {
        return this.storage.has( key );
    }

    removeBlob( key ) {
        URL.revokeObjectURL( this.storage.get( key ) ); // remove from browser internal blob cache
        this.storage.delete( key );
    }

    clear() {
        this.storage.clear();
    }
}

/* harmony default export */ __webpack_exports__["default"] = (BlobStorageController);


/***/ }),

/***/ "./sources/pcvizDB/C2CLinkManager.js":
/*!*******************************************!*\
  !*** ./sources/pcvizDB/C2CLinkManager.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizRenderTools_StationLinkTool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizRenderTools/StationLinkTool */ "./sources/pcvizRenderTools/StationLinkTool.js");





const REGISTRATION_METHOD = {
    'OCCBS': 'OCCBS',
    'RESECTION': 'RESECTION',
    'C2C': 'C2C'
};

/**
 * A singleton controller to manage c2c links
 * 
 * @class
 * @memberof pcvizDB
 */
class C2CLinkManager {
    constructor() {
        this._isInitiated = false;
        this._initiatedStationCallbacks = false;
        this._backupLinkArray = undefined;
    }

    isInitiated() {
        return this._isInitiated;
    }

    setView3D( view3D ) {
        this._view3D = view3D;
    }

    init( workflow, view3D ) {

        if ( view3D )
            this._view3D = view3D;
        this._registrationObject = workflow.getRegistrationObject();

        // link Array {
        //     name: string,
        //     fixedStation: stationObject,
        //     movingStation: stationObject,
        //     report: json
        //     edgeInformation: properties from naoki's process
        // }

        this._linkArray = [];
        if ( this._registrationObject.linkArray !== undefined ) {
            this._linkArray = this._registrationObject.linkArray;
        }

        this._linkIconsTypes = [ {
                img: 'assets/link-',
                type: 'link',
                click: ( index, hit ) => {

                    switch ( workflow.getState() ) {
                    case workflow.SCANSTATE.C2C_REMOVING_LINKS: // RemovingLinks click behaviour
                        if ( !this._linksSelectedArray.includes( index ) ) {
                            this._linksSelectedArray.push( index );
                        } else {
                            this._linksSelectedArray.splice( this._linksSelectedArray.indexOf( index ), 1 );
                        }

                        this._linkSelected = undefined;
                        if ( this._refreshCB )
                            this._refreshCB();
                        this.drawLinksSelection();
                        break;
                    case workflow.SCANSTATE.REGISTRATION_MANUAL:
                        break;
                    default: // Default behaviour in c2c
                        this._linkSelected = { link: this._linkArray[ index ], hit: hit };
                        if ( this._refreshCB )
                            this._refreshCB();
                        this.drawLinks();
                        break;
                    }
                },
                clickTemporal: ( index ) => {
                    this._temporalLinks.splice( index, 1 );
                    this.drawTemporalLinks();
                }
            } //If we want to add new buttons, we have to add a data structure like behind
            // ,
            // {
            //     img: 'assets/trash.png',
            //     type: 'remove',
            //     click: ( index ) => {
            //         this.removeLink( index );
            //     }
            // }

        ];

        this._linksSelectedArray = [];
        this._linkSelected = undefined;

        if ( this._view3D ) {
            this._stationLinkTool = new pcvizRenderTools_StationLinkTool__WEBPACK_IMPORTED_MODULE_1__["default"]( this._view3D );
            this._stationLinkTool.setLinkIconsTypes( this._linkIconsTypes );
            this._isInitiated = true;
        }


        this._selectedBundle = undefined;

        if ( !this._initiatedStationCallbacks )
            this.initStationCallbacks( workflow );

    }

    initStationCallbacks( workflow ) {
        document.addEventListener( 'removeStationLinks', ( e ) => {
            let originalLinkArrayLength = this._linkArray.length;
            this._linkArray = this._linkArray.filter( ( link, index ) => {
                const isValid = link[ 'fixedStation' ].uuid !== e.detail.stationUuid && link[ 'movingStation' ].uuid !== e.detail.stationUuid;
                if ( !isValid ) {
                    if ( index < this._registrationObject.selectedLink )
                        this._registrationObject.selectedLink--;
                    if ( this._registrationObject.tmpLinkIndex !== undefined && index <= this._registrationObject.tmpLinkIndex )
                        this._registrationObject.tmpLinkIndex--;
                }
                return isValid;
            } );
            if ( originalLinkArrayLength === this._linkArray.length )
                return;
            this.saveLinks();
            // PUT request to avoid losing these changes if the user lefts the app just after removing a station
            workflow.writeToProject( e.detail.project ).then( () => {} ).catch( () => { console.error( 'Error saving updated links and bundles' ); } );
        }, false );

        document.addEventListener( 'updateStationLinks', ( e ) => {
            this._linkArray.forEach( ( link ) => {
                if ( link[ 'fixedStation' ].uuid === e.detail.station.uuid )
                    link[ 'fixedStation' ] = e.detail.station;
                else if ( link[ 'movingStation' ].uuid === e.detail.station.uuid )
                    link[ 'movingStation' ] = e.detail.station;
            } );

            this.saveLinks();
            // PUT request to avoid losing these changes if the user lefts the app just after removing a station
            workflow.writeToProject( e.detail.project ).then( () => {} ).catch( () => { console.error( 'Error saving updated links and bundles' ); } );
        }, false );
        this._initiatedStationCallbacks = true;
    }
    // TODO: setRegistrationObject

    setRefreshCallback( fn ) {
        this._refreshCB = fn;
    }

    drawLinksSelection() {
        this._isRenderingLinksSelection = true;
        this._linkArray.forEach( ( link, linkIndex ) => {
            link.linkType = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.REGISTRATION_COLOR_TYPE.UNSELECTED;
            if ( this._linksSelectedArray.includes( linkIndex ) )
                link.linkType = this.computeLinkColor( link.report ? link.report[ 'point_to_plane_rms' ] : undefined );
        } );
        this._stationLinkTool.setLinkArray( this._linkArray );
        this._stationLinkTool.drawLinks();
        this._stationLinkTool.setUpEventListeners();
    }

    clearLinksSelection() {
        this._isRenderingLinksSelection = false;
        this.refreshLinkColors();
        this._linksSelectedArray = [];
        this._stationLinkTool.removeEventListeners();
    }

    drawLinks( index ) {
        this._stationLinkTool.setLinkArray( this._linkArray );
        this._stationLinkTool.drawLinks( index );
        this._stationLinkTool.setUpEventListeners();
    }

    isRenderingLinks() {
        return this._stationLinkTool.isRenderingLinks();
    }

    isRenderingLinksSelected() {
        return this._isRenderingLinksSelection;
    }

    removeEventListeners() {
        this._stationLinkTool.removeEventListeners();
    }

    getLinkArray() {
        return this._linkArray;
    }

    updateLinkArray() {
        if ( this._registrationObject.linkArray !== undefined ) {
            this._linkArray = this._registrationObject.linkArray;
        }
    }

    removeLink( index ) {
        this._linkArray.splice( index, 1 );
        if ( this._linksSelectedArray.includes( index ) )
            this._linksSelectedArray.splice( this._linksSelectedArray.indexOf( index ), 1 );
        this.drawLinks();
        this.saveLinks();
        this.clearBackupLinkArray();
    }

    clearLinks() {
        this._stationLinkTool.clearLinks();
        this._stationLinkTool.removeEventListeners();
    }

    saveLinks() {
        this._registrationObject.linkArray = this._linkArray;

        // Generate bundles (IMPROVEMENT save only the UUIDs if we are not going to use the whole object)
        //reset always if(!this._registrationObject.bundles)
        this._registrationObject.bundles = [];
        this._registrationObject.processedBundles = []; // bundles split by unprocessed links (bundles taking into account only the processed links)
        if ( !this._linkArray.length )
            return;
        this._registrationObject.bundles[ 0 ] = [ this.getParsedStationForBundle( this._linkArray[ 0 ].fixedStation ), this.getParsedStationForBundle( this._linkArray[ 0 ].movingStation ) ];

        let firstProcessedLink = this._linkArray.find( link => { return link.report; } );
        if ( firstProcessedLink )
            this._registrationObject.processedBundles[ 0 ] = [ this.getParsedStationForBundle( firstProcessedLink.fixedStation ), this.getParsedStationForBundle( firstProcessedLink.movingStation ) ];

        let existsInBundle, existsInProcessedBundle;

        const isSameStation = ( staToFind ) => { return ( sta ) => sta.uuid === staToFind; };
        for ( let i = 1; i < this._linkArray.length; i++ ) {
            existsInBundle = false;
            existsInProcessedBundle = false;

            for ( let j = 0; j < this._registrationObject.bundles.length; j++ ) {

                if ( this._registrationObject.bundles[ j ].some( isSameStation( this._linkArray[ i ][ 'fixedStation' ].uuid ) ) ) {
                    this._registrationObject.bundles[ j ].push( this.getParsedStationForBundle( this._linkArray[ i ][ 'movingStation' ] ) );
                    existsInBundle = true;
                } else if ( this._registrationObject.bundles[ j ].some( isSameStation( this._linkArray[ i ][ 'movingStation' ].uuid ) ) ) {
                    this._registrationObject.bundles[ j ].push( this.getParsedStationForBundle( this._linkArray[ i ][ 'fixedStation' ] ) );
                    existsInBundle = true;
                }
            }
            if ( !existsInBundle )
                this._registrationObject.bundles.push( [ this.getParsedStationForBundle( this._linkArray[ i ].fixedStation ), this.getParsedStationForBundle( this._linkArray[ i ].movingStation ) ] );

            if ( !this._linkArray[ i ].report || this._linkArray[ i ] === firstProcessedLink ) // If there isn't report, this link has not been processed
                continue;

            for ( let j = 0; j < this._registrationObject.processedBundles.length; j++ ) {

                if ( this._registrationObject.processedBundles[ j ].some( isSameStation( this._linkArray[ i ][ 'fixedStation' ].uuid ) ) ) {
                    //save it in order
                    let index = this._registrationObject.processedBundles[ j ].findIndex( isSameStation( this._linkArray[ i ][ 'fixedStation' ].uuid ) );
                    this._registrationObject.processedBundles[ j ].splice( index + 1, 0, this.getParsedStationForBundle( this._linkArray[ i ][ 'movingStation' ] ) );
                    existsInProcessedBundle = true;
                } else if ( this._registrationObject.processedBundles[ j ].some( isSameStation( this._linkArray[ i ][ 'movingStation' ].uuid ) ) ) {
                    let index = this._registrationObject.processedBundles[ j ].findIndex( isSameStation( this._linkArray[ i ][ 'movingStation' ].uuid ) );
                    //save it in order
                    this._registrationObject.processedBundles[ j ].splice( index, 0, this.getParsedStationForBundle( this._linkArray[ i ][ 'fixedStation' ] ) );
                    existsInProcessedBundle = true;
                }
            }

            if ( !existsInProcessedBundle )
                this._registrationObject.processedBundles.push( [ this.getParsedStationForBundle( this._linkArray[ i ].fixedStation ), this.getParsedStationForBundle( this._linkArray[ i ].movingStation ) ] );
        }

        const isInBundle = ( bundle ) => {
            return ( sta ) => {
                return bundle.find( ( sta2 ) => { return sta.uuid === sta2.uuid; } );
            };
        };
        // We need to check if there are bundles that share any station and join them
        for ( let k = 0; k < this._registrationObject.bundles.length - 1; k++ ) {
            let kBundle = this._registrationObject.bundles[ k ];

            for ( let m = k + 1; m < this._registrationObject.bundles.length; m++ ) {
                if ( kBundle.find( isInBundle( this._registrationObject.bundles[ m ] ) ) ) {
                    kBundle = kBundle.concat( this._registrationObject.bundles[ m ] );
                    this._registrationObject.bundles.splice( m, 1 );
                    m--;
                    let auxBundle = [];
                    for ( let l = 0; l < kBundle.length; l++ )
                        if ( !auxBundle.find( isSameStation( kBundle[ l ].uuid ) ) )
                            auxBundle.push( kBundle[ l ] );
                    this._registrationObject.bundles[ k ] = auxBundle;
                }
            }

        }

        for ( let k = 0; k < this._registrationObject.processedBundles.length; k++ ) {
            let kBundle = this._registrationObject.processedBundles[ k ];
            for ( let m = 0; m < this._registrationObject.processedBundles.length; m++ ) {
                if ( m === k )
                    continue;
                if ( kBundle.find( isInBundle( this._registrationObject.processedBundles[ m ] ) ) ) {
                    kBundle = kBundle.concat( this._registrationObject.processedBundles[ m ] );

                    let auxBundle = [];
                    for ( let l = 0; l < kBundle.length; l++ )
                        if ( !auxBundle.find( isSameStation( kBundle[ l ].uuid ) ) )
                            auxBundle.push( kBundle[ l ] );

                    if ( m > k ) {
                        this._registrationObject.processedBundles.splice( m, 1 );
                        m--;
                        this._registrationObject.processedBundles[ k ] = auxBundle;
                    } else {
                        this._registrationObject.processedBundles.splice( k, 1 );
                        k--;
                        this._registrationObject.processedBundles[ m ] = auxBundle;
                    }
                }
            }
        }
    }

    /** This method stores a clone of the _linksArray to allow undo of Optimize&Bundle
        This backup is stored on browser's Memory (not in the DB neither in the filestorage) */
    backupLinkArray() {
        this._backupLinkArray = JSON.parse( JSON.stringify( this._linkArray ) );
    }

    clearBackupLinkArray() {
        this._backupLinkArray = undefined;
    }

    restoreLinkArrayFromBackup() {
        this._linkArray = this._backupLinkArray.slice();
    }

    hasBackupLinkArray() {
        return this._backupLinkArray !== undefined;
    }

    computeLinkColor( value ) {
        const low = this._registrationObject.low;
        const high = this._registrationObject.high;
        return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getRegistrationColorType( value, low, high );
    }

    refreshLinkColors() {
        for ( let link of this._linkArray ) {
            link.linkType = this.computeLinkColor( link.report ? link.report[ 'point_to_plane_rms' ] : undefined );
        }
        this.drawLinks();
        this.saveLinks();
    }

    getLinkSelectedMenu() {
        return this._linkSelected;
    }

    clearLinkSelectedMenu() {
        this._linkSelected = undefined;
    }

    getLinksSelectedArray() {
        return this._linksSelectedArray;
    }

    initTemporalLinks() {
        this._temporalLinks = [];
    }

    getTemporalLinks() {
        return this._temporalLinks;
    }

    drawTemporalLinks() {
        this._stationLinkTool.setTemporalLinkArray( this._temporalLinks );
        this._stationLinkTool.drawLinks( undefined, true );
    }

    clearTemporalLinksNode() {
        this._stationLinkTool.clearTemporalLinksNode();
    }

    updateLinkEdgeProperties( element ) {
        delete element.fixedStationUuid;
        delete element.movingStationUuid;
        return element;
    }

    // TODO
    reset() {}

    // TODO
    notify( /*callback*/) {}

    getEdges( newEdgeObject, secondarySelectedBundle ) {
        let edges = {
            properties: {},
            edges: []
        };
        let prop = {};
        // adding edges
        this._linkArray.forEach( ( link ) => {
            if ( this.isLinkInSelectedProcessedBundle( link ) || this.isLinkInBundle( link, secondarySelectedBundle ) ) {
                let edge = {
                    fixedStationUuid: link.fixedStation.uuid,
                    movingStationUuid: link.movingStation.uuid
                };
                if ( link.edgeInformation )
                    Object.assign( edge, link.edgeInformation );
                edges.edges.push( edge );
                if ( prop.rootStationUuid === undefined )
                    this.setRootStation( prop, link );
            }
        } );
        if ( newEdgeObject ) {
            const newEdge = newEdgeObject.edges[ 0 ];
            if ( !edges.edges.find( ( edge ) => { return edge.fixedStationUuid === newEdge.fixedStationUuid && edge.movingStationUuid === newEdge.movingStationUuid; } ) ) {
                edges.edges.push( newEdge );
                if ( prop.rootStationUuid === undefined )
                    prop.rootStationUuid = newEdgeObject.properties.rootStationUuid;
            }
        }
        // adding root nodes, for now the first node of a bundle it is the root node of this bundle
        if ( edges.edges.length > 0 ) {
            if ( prop.rootStationUuid === undefined )
                prop.rootStationUuid = edges.edges[ 0 ].fixedStationUuid;
            edges.properties = prop;
        }
        return edges;
    }

    getEdge( fixed, moving ) {
        let edges = {
            properties: {},
            edges: []
        };
        // adding edges
        let link = this._linkArray.find( ( element ) =>
            ( element.fixedStation.uuid === fixed && element.movingStation.uuid === moving ) ||
            ( element.fixedStation.uuid === moving && element.movingStation.uuid === fixed ) );

        if ( link ) {
            let edge = {
                fixedStationUuid: link.fixedStation.uuid,
                movingStationUuid: link.movingStation.uuid
            };
            // adding root nodes, for default the first node of a bundle it is the root node of this bundle
            let prop = {};
            prop.rootStationUuid = edge.fixedStationUuid;
            this.setRootStation( prop, link );
            edges.properties = prop;
            if ( link.edgeInformation )
                Object.assign( edge, link.edgeInformation );
            edges.edges.push( edge );
        }

        return edges;
    }

    setSelectedBundle( bundle ) {
        this._selectedBundle = bundle;
    }

    isLinkInSelectedBundle( link ) {
        if ( this._selectedBundle && this._selectedBundle.some( ( sta ) => sta.uuid === link[ 'fixedStation' ].uuid ) ) {
            return true;
        }
        return false;
    }

    isLinkInSelectedProcessedBundle( link ) {
        if ( this._selectedBundle && this._selectedBundle.some( ( sta ) => sta.uuid === link[ 'fixedStation' ].uuid ) &&
            this._selectedBundle.some( ( sta ) => sta.uuid === link[ 'movingStation' ].uuid ) ) {
            return true;
        }
        return false;
    }

    isLinkInBundle( link, bundle ) {
        if ( bundle && bundle.some( ( sta ) => sta.uuid === link[ 'fixedStation' ].uuid ) &&
            bundle.some( ( sta ) => sta.uuid === link[ 'movingStation' ].uuid ) ) {
            return true;
        }
        return false;
    }

    setRootStation( prop, link ) {

        let rootStation = this.getRootStation( link );
        if ( rootStation )
            prop.rootStationUuid = rootStation.uuid;
    }

    // This is for reducing size in old projects (In new projects, the stations in the links would have been parsed with the next function)
    getParsedStationForBundle( station ) {
        let stationCopy = Object.assign( {}, station );
        delete stationCopy.children;
        delete stationCopy.properties;
        return stationCopy;
    }

    getParsedStationForLink( station ) {
        let stationCopy = Object.assign( {}, station );
        delete stationCopy.properties;
        delete stationCopy.children;
        return stationCopy;
    }

    getRootStation( link ) {
        // If the station has been localized by OCCBS or RESECTION, set it as the root one
        const movingStation = link.movingStation;
        const fixedStation = link.fixedStation;
        if ( fixedStation.surveyRegistrationInfo !== undefined )
            if ( ( REGISTRATION_METHOD.OCCBS === fixedStation.surveyRegistrationInfo.method ) || ( REGISTRATION_METHOD.RESECTION === fixedStation.surveyRegistrationInfo.method ) ) {
                return fixedStation;
            }

        if ( movingStation.surveyRegistrationInfo !== undefined )
            if ( ( REGISTRATION_METHOD.OCCBS === movingStation.surveyRegistrationInfo.method ) || ( REGISTRATION_METHOD.RESECTION === movingStation.surveyRegistrationInfo.method ) ) {
                return movingStation;
            }

        // if not, we need to get the station in the bigger bundle

        const fixedBundle = this._registrationObject.processedBundles.find( ( bundle ) => {
            return bundle.find( ( sta ) => { return sta.uuid === fixedStation.uuid; } );
        } );

        const movingBundle = this._registrationObject.processedBundles.find( ( bundle ) => {
            return bundle.find( ( sta ) => { return sta.uuid === movingStation.uuid; } );
        } );
        if ( movingBundle && ( !fixedBundle || fixedBundle.length < movingBundle.length ) ) {
            return movingStation;
        }

    }
}

/* harmony default export */ __webpack_exports__["default"] = (C2CLinkManager);


/***/ }),

/***/ "./sources/pcvizDB/ConfigurationController.js":
/*!****************************************************!*\
  !*** ./sources/pcvizDB/ConfigurationController.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var version__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! version */ "./sources/version.js");
/* harmony import */ var version__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(version__WEBPACK_IMPORTED_MODULE_1__);



/**
 * A singleton controller to manage and load configuration
 * @class
 * @memberof pcvizDB
 */
class ConfigurationController extends pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this.app = '';
        this.env = '';
        this.fileUrl = '/assets/core-configuration.json'; // default url
        this.configuration = {};
    }

    configApp( app, env, fileUrl = '' ) {
        this.app = app;
        this.env = env;
        this.fileUrl = fileUrl || this.fileUrl;

        return new Promise( ( resolve ) => {
            const hasVersionParams = /[?&]v=/.test( this.fileUrl );
            const queryDelimiter = this.fileUrl.includes( '?' ) ? '&' : '?';
            const versionParam = hasVersionParams ? '' : `${queryDelimiter}v=${version__WEBPACK_IMPORTED_MODULE_1___default.a.version}`;
            this.getFile( `${this.fileUrl}${versionParam}` )
                .then( response => {
                    this.configuration = this.parseConfiguration( this.app, response );
                    this.notify();
                    resolve( this.configuration );
                } )
                .catch( () => {
                    this.configuration = {};
                    resolve( this.configuration ); // no throw error if file not found
                } );
        } );
    }

    getFile( url ) {
        return new Promise( ( resolve, reject ) => {
            let xhr = new XMLHttpRequest();
            xhr.open( 'GET', url );

            xhr.onload = () => {
                if ( xhr.readyState === XMLHttpRequest.DONE && ( xhr.status >= 200 && xhr.status < 300 ) ) {
                    resolve( JSON.parse( xhr.responseText ) );
                } else {
                    reject( xhr.statusText );
                }
            };
            xhr.onerror = () => reject( xhr.statusText );
            xhr.send();
        } );
    }

    parseConfiguration( key, data ) {
        let result = {};

        // check 'extends'
        if ( data[ key ].extends ) {
            const extended = data[ key ].extends;

            if ( !data[ extended ] ) {
                console.error( 'UiConfiguration - no extended node found' );
                return {};
            }

            // parse extended config
            let parsed = this.parseConfiguration( extended, data );
            if ( parsed !== {} ) {
                result = parsed;
            } else {
                result = data[ extended ];
            }

        }

        //
        this.mergeConfiguration( result, data[ key ] );

        return result;
    }

    mergeConfiguration( target, source ) {
        for ( const key in source ) {
            if ( typeof source[ key ] !== 'object' ) {
                target[ key ] = source[ key ];
                continue;
            }

            if ( target[ key ] ) {
                this.mergeConfiguration( target[ key ], source[ key ] );
            } else {
                target[ key ] = source[ key ];
            }
        }
    }

    getConfig() {
        return this.configuration;
    }

    isConfigLoaded() {
        return this.configuration !== undefined && this.configuration !== {};
    }

    getCategories() {
        if ( !this.isConfigLoaded() ) {
            return undefined;
        }

        return this.configuration.categories;
    }
}

/* harmony default export */ __webpack_exports__["default"] = (ConfigurationController);


/***/ }),

/***/ "./sources/pcvizDB/ConversionInfo.js":
/*!*******************************************!*\
  !*** ./sources/pcvizDB/ConversionInfo.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;


var ConversionInfo = function () {
    this.mUVAdjustment = new Array( 0x2000 );
    // upper 3 bits
    this.SIGN_MASK = 0xe000;
    this.XSIGN_MASK = 0x8000;
    this.YSIGN_MASK = 0x4000;
    this.ZSIGN_MASK = 0x2000;

    // middle 6 bits - xbits
    this.TOP_MASK = 0x1f80;

    // lower 7 bits - ybits
    this.BOTTOM_MASK = 0x007f;

    for ( var idx = 0; idx < 0x2000; idx++ ) {
        var xbits = idx >> 7;
        var ybits = idx & this.BOTTOM_MASK;

        // map the numbers back to the triangle (0,0)-(0,127)-(127,0)
        if ( ( xbits + ybits ) >= 127 ) {
            xbits = 127 - xbits;
            ybits = 127 - ybits;
        }

        // convert to 3D vectors
        var x = xbits;
        var y = ybits;
        var z = ( 126 - xbits - ybits );

        // calculate the amount of normalization required
        this.mUVAdjustment[ idx ] = 1.0 / Math.sqrt( y * y + z * z + x * x );
        //assert( _finite( mUVAdjustment[idx]));
    }
};

var Float16ToFloat = function ( float16 ) {
    const sign = ( ( float16 & 0x8000 ) >> 15 ) ? -1 : 1;
    const exponent = ( float16 & 0x7C00 ) >> 10;
    const fraction = float16 & 0x03FF;

    switch ( true ) {
    case exponent === 0:
        return sign * Math.pow( 2, -14 ) * ( fraction / Math.pow( 2, 10 ) );
    case exponent === 0x1F:
        return fraction ? NaN : ( sign * Infinity );
    default:
        return sign * Math.pow( 2, exponent - 15 ) * ( 1 + ( fraction / Math.pow( 2, 10 ) ) );
    }
};

var R5G6B5ToR8G8B8 = function ( u16R5G6B5 ) {
    const r = ( u16R5G6B5 & 0xF800 ) >> 11;
    const g = ( u16R5G6B5 & 0x07E0 ) >> 5;
    const b = ( u16R5G6B5 & 0x001F );
    return [ ( r * 255 + 15 ) / 31,
        ( g * 255 + 31 ) / 63,
        ( b * 255 + 15 ) / 31
    ];
};

ConversionInfo.ExtensionID = 'Extension';
ConversionInfo.DesignationID = 'Designation';
//var ChildrenDataID = 'ChildrenData';
//var StoreInformationID = 'StoreInformation';
//var DecimationCounterID = 'DecimationCounter';

ConversionInfo.IntensityArrayID = 'IntensityArray';
ConversionInfo.ClassificationArrayID = 'ClassificationArray';
ConversionInfo.DistanceArrayID = 'DistanceArray';
ConversionInfo.NormalArrayID = 'NormalArray';
ConversionInfo.NormalVec3ArrayID = 'NormalVec3Array';

ConversionInfo.CompressedPointArrayID = 'CompressedPointArray'; // Not "CompressedPointFloat32Array", for compatibility
ConversionInfo.CompressedPointFloat24ArrayID = 'CompressedPointFloat24Array';
ConversionInfo.CompressedPointFloat16ArrayID = 'CompressedPointFloat16Array';
ConversionInfo.CompressedColorArrayID = 'CompressedColorArray';
ConversionInfo.CompressedColorR5G6B5ArrayID = 'CompressedColorR5G6B5Array';
// New attribute created for Jav
ConversionInfo.CompressedNormalVec3ArrayID = 'CompressedNormalVec3Array';

// Extended VERITY Attributes
ConversionInfo.ElementID = 'ElementTag';
ConversionInfo.NumHeatMaps = 'NumHeatMaps';
ConversionInfo.HeatMap = 'HeatMap_';


ConversionInfo.prototype = {
    unpackVector: function ( mVec ) {
        // if we do a straightforward backward transform
        // we will get points on the plane X0,Y0,Z0
        // however we need points on a sphere that goes through 
        // these points.
        // therefore we need to adjust x,y,z so that x^2+y^2+z^2=1

        // by normalizing the vector. We have already precalculated 
        // the amount by which we need to scale, so all we do is a 
        // table lookup and a multiplication

        // get the x and y bits
        var xbits = ( ( mVec & this.TOP_MASK ) >> 7 );
        var ybits = ( mVec & this.BOTTOM_MASK );

        // map the numbers back to the triangle (0,0)-(0,126)-(126,0)
        if ( ( xbits + ybits ) >= 127 ) {
            xbits = 127 - xbits;
            ybits = 127 - ybits;
        }

        // do the inverse transform and normalization
        // costs 3 extra multiplies and 2 subtracts. No big deal.         
        var uvadj = this.mUVAdjustment[ mVec & ~this.SIGN_MASK ];

        var v = osg.vec3.create32();

        v[ 0 ] = uvadj * xbits;
        v[ 1 ] = uvadj * ybits;
        v[ 2 ] = uvadj * ( 126 - xbits - ybits );

        // set all the sign bits
        if ( mVec & this.XSIGN_MASK ) v[ 0 ] = -v[ 0 ];
        if ( mVec & this.YSIGN_MASK ) v[ 1 ] = -v[ 1 ];
        if ( mVec & this.ZSIGN_MASK ) v[ 2 ] = -v[ 2 ];

        return v;

    },
    apply: function ( type, geometry, attrInfoMap, options ) {
        this[ type ]( geometry, attrInfoMap, options );
    }
};

ConversionInfo.prototype[ ConversionInfo.CompressedPointArrayID ] = function ( geometry, attrInfoMap ) {
    const f32array = new Float32Array( attrInfoMap.get( ConversionInfo.CompressedPointArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3, true );
    geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, f32array.length / 3 ) );
};

ConversionInfo.prototype[ ConversionInfo.CompressedPointFloat24ArrayID ] = function ( geometry, attrInfoMap ) {
    const u8ArrayOfF24 = new Uint8Array( attrInfoMap.get( ConversionInfo.CompressedPointFloat24ArrayID ).arrayBuffer.buffer );
    const numOfFloat = u8ArrayOfF24.length / 3; //(3 bytes for each float)
    let f32array = new Float32Array( numOfFloat );
    for ( let index = 0; index < f32array.length; ++index ) {
        let data = new Uint8Array( 4 );
        data[ 0 ] = 0;
        data[ 1 ] = u8ArrayOfF24[ index * 3 + 0 ];
        data[ 2 ] = u8ArrayOfF24[ index * 3 + 1 ];
        data[ 3 ] = u8ArrayOfF24[ index * 3 + 2 ];
        f32array[ index ] = ( new Float32Array( data.buffer ) )[ 0 ];
    }
    geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3, true );
    geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, f32array.length / 3 ) );
};

ConversionInfo.prototype[ ConversionInfo.CompressedPointFloat16ArrayID ] = function ( geometry, attrInfoMap ) {
    const u16ArrayOfF16 = new Uint16Array( attrInfoMap.get( ConversionInfo.CompressedPointFloat16ArrayID ).arrayBuffer.buffer );
    let f32array = new Float32Array( u16ArrayOfF16.length );
    for ( let index = 0; index < f32array.length; ++index ) {
        f32array[ index ] = Float16ToFloat( u16ArrayOfF16[ index ] );
    }
    geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3, true );
    geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, f32array.length / 3 ) );
};

ConversionInfo.prototype[ ConversionInfo.CompressedColorArrayID ] = function ( geometry, attrInfoMap ) {
    const u8array = new Uint8Array( attrInfoMap.get( ConversionInfo.CompressedColorArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 3, true );
    geometry.getAttributes().Color.setNormalize( true );
};

ConversionInfo.prototype[ ConversionInfo.CompressedColorR5G6B5ArrayID ] = function ( geometry, attrInfoMap ) {
    const u16R5G6B5array = new Uint16Array( attrInfoMap.get( ConversionInfo.CompressedColorR5G6B5ArrayID ).arrayBuffer.buffer );
    let u8array = new Uint8Array( u16R5G6B5array.length * 3 );
    for ( let index = 0; index < u16R5G6B5array.length; ++index ) {
        let rgb = R5G6B5ToR8G8B8( u16R5G6B5array[ index ] );
        u8array[ index * 3 + 0 ] = rgb[ 0 ];
        u8array[ index * 3 + 1 ] = rgb[ 1 ];
        u8array[ index * 3 + 2 ] = rgb[ 2 ];
    }
    geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 3, true );
    geometry.getAttributes().Color.setNormalize( true );
};

ConversionInfo.prototype[ ConversionInfo.IntensityArrayID ] = function ( geometry, attrInfoMap ) {
    var u16array = new Uint16Array( attrInfoMap.get( ConversionInfo.IntensityArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Intensity = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u16array, 1, true );
};

ConversionInfo.prototype[ ConversionInfo.ClassificationArrayID ] = function ( geometry, attrInfoMap ) {
    var u8array = attrInfoMap.get( ConversionInfo.ClassificationArrayID ).arrayBuffer;
    geometry.getAttributes().Classification = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 1, true );
};

ConversionInfo.prototype[ ConversionInfo.DistanceArrayID ] = function ( geometry, attrInfoMap ) {
    var f32array = new Float32Array( attrInfoMap.get( ConversionInfo.DistanceArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Distance = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 1, true );
};

ConversionInfo.prototype[ ConversionInfo.NormalVec3ArrayID ] = function ( geometry, attrInfoMap ) {
    var f32array = new Float32Array( attrInfoMap.get( ConversionInfo.NormalVec3ArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Normal = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3, true );
};

ConversionInfo.prototype[ ConversionInfo.NormalArrayID ] = function ( geometry, attrInfoMap ) {
    //console.log(attrInfoMap[NormalArrayID].arrayBuffer.buffer.length);
    var u16array = new Uint16Array( attrInfoMap.get( ConversionInfo.NormalArrayID ).arrayBuffer.buffer );
    var f32array = new Float32Array( u16array.length * 3 );
    for ( var i = 0, len = u16array.length; i < len; i++ ) {
        var v = this.unpackVector( u16array[ i ] );
        var idx = i * 3;
        f32array[ idx ] = v[ 0 ];
        f32array[ idx + 1 ] = v[ 1 ];
        f32array[ idx + 2 ] = v[ 2 ];
    }
    //var f32array = new Float32Array( attrInfoMap.get( ConversionInfo.CompressedPointArrayID ).arrayBuffer.buffer );
    geometry.getAttributes().Normal = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3 );
};

ConversionInfo.prototype[ ConversionInfo.CompressedNormalVec3ArrayID ] = function ( geometry, attrInfoMap ) {
    const attrInfo = attrInfoMap.get( ConversionInfo.CompressedNormalVec3ArrayID );
    if ( !attrInfo ) {
        console.warn( 'ConversionInfo: Failed to get CompressedNormalVec3ArrayID from attributes' );
        return;
    }

    const u8array = new Uint8Array( attrInfo.arrayBuffer.buffer );
    const normal32array = new Float32Array( u8array.length );

    for ( let i = 0, len = u8array.length; i < len / 3; i++ ) {
        const idx = i * 3;
        let packed = 0;
        packed |= u8array[ idx ];
        packed |= u8array[ idx + 1 ] << 8;
        packed |= u8array[ idx + 2 ] << 16;

        const MAX_VALUE_16_BIT = 0xfff; //0x0FFF is max value of 16 bit in hex
        const unpackedA = packed & MAX_VALUE_16_BIT;
        const unpackedB = ( packed >> 12 ) & MAX_VALUE_16_BIT;

        const u16array = new Uint16Array( [ unpackedA, unpackedB ] );

        // 2025-03-24 Convert back to [-1, 1] range
        let x = ( u16array[ 0 ] / 4095 ) * 2 - 1;

        const signZ = u16array[ 1 ] > 2047 ? -1 : 1;

        const intAs15Bits = u16array[ 1 ] - ( u16array[ 1 ] >= 2047 ? 2047 : 0 );

        let y = ( intAs15Bits / 2047 ) * 2 - 1;

        // 2025-03-24 Reconstruct z component
        let z = 1 - Math.abs( x ) - Math.abs( y );

        // 2025-03-24 Account for noise of decompression flipping the sign of very small values of z
        // Because  of normalization, the z should not be negative here
        // If z is negative it's because it started so close to zero that the decompression stretched it negative
        // In that case, we just set z to 0 because we can't know its original value and it was so close to 0 anyway
        if ( z < 0 ) {
            const auxX = x;
            x = ( 1 - Math.abs( y ) ) * ( auxX >= 0 ? 1 : -1 );
            y = ( 1 - Math.abs( auxX ) ) * ( y >= 0 ? 1 : -1 );
            z = 0;
        }

        z *= signZ;

        // 2025-03-24 Normalize
        const length = Math.sqrt( x * x + y * y + z * z );

        normal32array[ idx ] = x / length;
        normal32array[ idx + 1 ] = y / length;
        normal32array[ idx + 2 ] = z / length;
    }

    geometry.getAttributes().Normal = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, normal32array, 3 );
};

// JUST IN CASE WE NEED IT 
// ConversionInfo.prototype[ ConversionInfo.PointArrayID ] = function ( geometry, attrInfoMap, options ) {
//     var buf = attrInfoMap.get(ConversionInfo.PointArrayID).arrayBuffer;
//     var array = new DataView( buf );
//     var size = array.byteLength / 8;
//     var f32array = new Float32Array( size );
//     for(var i = 0, len = size; i < len; i+=3) {
//         f32array[i]   = array.getFloat64( i * 8, true ) - options.Capabilities.lidarStats.center[0];
//         f32array[i+1] = array.getFloat64( ( i + 1 ) * 8, true ) - options.Capabilities.lidarStats.center[1];
//         f32array[i+2] = array.getFloat64( ( i + 2 ) * 8, true ) - options.Capabilities.lidarStats.center[2];
//     }
//     geometry.attributes[ 'Vertex' ] = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3 );
//     geometry.primitives = [ new osg.DrawArrays( osg.primitiveSet.POINTS, 0, f32array.length/3 ) ];
// };
// ConversionInfo.prototype[ ConversionInfo.ColorArrayID ] = function( geometry, attrInfoMap, options ) {
//         var buf = attrInfoMap.get(ConversionInfo.ColorArrayID).arrayBuffer;
//         var array = new DataView( buf );
//         var size = array.byteLength / 2;
//         var f32array = new Float32Array( size );
//         for(var i = 0, len = size; i < len; i+=3) {
//             f32array[i]   = ( array.getUint16( i * 2, true ) / options.Capabilities.lidarStats.maxr);
//             f32array[i+1] = ( array.getUint16( ( i + 1 ) * 2, true ) / options.Capabilities.lidarStats.maxg);
//             f32array[i+2] = ( array.getUint16( ( i + 2 ) * 2, true) / options.Capabilities.lidarStats.maxb);
//         }
//         geometry.attributes[ 'Color' ] = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 3 );
// };

// Verity extended Attributes
ConversionInfo.prototype[ ConversionInfo.ElementID ] = function ( geometry, attrInfoMap /*, options */ ) {
    var u16array = new Uint16Array( attrInfoMap.get( ConversionInfo.ElementID ).arrayBuffer.buffer );
    geometry.getAttributes().ElementID = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u16array, 1, true );
};

ConversionInfo.prototype.fillHeatMap = function ( geometry, attrInfoMap, heatmapID ) {
    var f32array = new Float32Array( attrInfoMap.get( heatmapID ).arrayBuffer.buffer );
    geometry.getAttributes()[ heatmapID ] = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, f32array, 1, true );
};

ConversionInfo.prototype[ ConversionInfo.NumHeatMaps ] = function ( geometry, attrInfoMap /*, options */ ) {
    var u8array = new Uint8Array( attrInfoMap.get( ConversionInfo.NumHeatMaps ).arrayBuffer.buffer );
    geometry.getAttributes().NumHeatMaps = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 1, true );
    var numHeatMaps = u8array[ 0 ];
    for ( var i = 0; i < numHeatMaps; i++ ) {
        this.fillHeatMap( geometry, attrInfoMap, ConversionInfo.HeatMap + i.toString() );
    }
};

module.exports = ConversionInfo;


/***/ }),

/***/ "./sources/pcvizDB/ErrorController.js":
/*!********************************************!*\
  !*** ./sources/pcvizDB/ErrorController.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A singleton controller to manage errors
 * IMPROVEMENT: We could group errors by a key in a Map, and notify a specific group with a specific function.
 * @class
 * @memberof pcvizDB
 */
class ErrorController {
    constructor() {
        this._errors = [];
    }

    addError( key ) {
        this._errors.push( key );
    }

    removeError( key ) {
        var index = this._errors.findIndex( key );
        this._errors.splice( index, 1 );
    }

    hasErrors() {
        return this._errors.length > 0;
    }

    reset() {
        this._errors = [];
    }

    notify( callback ) {
        callback( this._errors );
        this.reset();
    }
}

module.exports = ErrorController;


/***/ }),

/***/ "./sources/pcvizDB/ImageSelectionController.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizDB/ImageSelectionController.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__);


/**
 * A controller to manage the selected images (extends from ListenerController)
 *
 * @class
 * @memberof pcvizDB
 */

class ImageSelectionController extends pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();

        this.selectedImages = this.getInitSelectedImages();
        this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION = 'ChangedImageSel';
    }

    getSelectedImages() {
        return this.selectedImages;
    }

    get visibleImages() {
        return this.selectedImages.visibleImages;
    }

    get measuredImages() {
        return this.selectedImages.measuredImages;
    }

    get skippedImages() {
        return this.selectedImages.skippedImages;
    }

    get inspectedImages() {
        return this.selectedImages.inspectedImages;
    }

    get disabledImages() {
        return this.selectedImages.disabledImages;
    }

    setSelectedImages( images ) {
        this.selectedImages = {
            visibleImages: images.visibleImages || this.selectedImages.visibleImages,
            measuredImages: images.measuredImages || this.selectedImages.measuredImages,
            skippedImages: images.skippedImages || this.selectedImages.skippedImages,
            inspectedImages: images.inspectedImages || this.selectedImages.inspectedImages,
            disabledImages: images.disabledImages || this.selectedImages.disabledImages,
        };
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    set visibleImages( images ) {
        this.selectedImages.visibleImages = images || [];
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    set measuredImages( images ) {
        this.selectedImages.measuredImages = images || [];
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    set skippedImages( images ) {
        this.selectedImages.skippedImages = images || [];
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    set inspectedImages( images ) {
        this.selectedImages.inspectedImages = images || [];
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    set disabledImages( images ) {
        this.selectedImages.disabledImages = images || [];
        this.notify( this.NOTIF_TYPE_CHANGED_IMAGE_SELECTION );
    }

    /**
     * This function resets the controller in order to load properly a new project.
     *
     * @method
     * @memberof pcvizDB.SelectionController
     */
    reset() {
        this.selectedImages = this.getInitSelectedImages();
        super.reset();
    }

    getInitSelectedImages() {
        return {
            visibleImages: [],
            measuredImages: [],
            skippedImages: [],
            inspectedImages: [],
            disabledImages: [],
        };
    }
}

/* harmony default export */ __webpack_exports__["default"] = (ImageSelectionController);


/***/ }),

/***/ "./sources/pcvizDB/Input.js":
/*!**********************************!*\
  !*** ./sources/pcvizDB/Input.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Options = __webpack_require__( /*! pcvizDB/Options */ "./sources/pcvizDB/Options.js" );
var PLFMZReaderParser = __webpack_require__( /*! pcvizDB/PLFMZReaderParser */ "./sources/pcvizDB/PLFMZReaderParser.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;
var osgInput = OSG.osgDB.Input;
var TimeStampCache = __webpack_require__( /*! pcvizUtils/TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
/**
 *  Input
 *  @class
 *  @memberof pcvizDB
 */
var Input = function ( json, identifier ) {
    this._json = json;
    var map = identifier;
    if ( map === undefined ) {
        map = {};
    }
    this._objectRegistry = {};
    this.readPointCloudURL = [];
    this.readPointCloudURL[ 'cplfmz' ] = this._readPointCloudCompactPLFMZ.bind( this );
    this._parser = new PLFMZReaderParser();
    this.setOptions( osg.objectMix( {}, Options ) );

    this._maxRequestsInQueue = 0;
    this._requests = [];
    this._request = undefined;
};

Input.prototype = {

    setOptions: function ( options ) {
        this._defaultOptions = options;
    },
    getOptions: function () {
        return this._defaultOptions;
    },
    setProgressXHRCallback: function ( func ) {
        this._defaultOptions.progressXHRCallback = func;
    },
    setReadPointCloudURLCallback: function ( func ) {
        this._defaultOptions.readPointCloudURL = func;
    },
    // used to override the type from pathname
    // typically if you want to create proxy object
    registerObject: function ( fullyQualifiedObjectname, constructor ) {
        this._objectRegistry[ fullyQualifiedObjectname ] = constructor;
    },

    getJSON: function () {
        return this._json;
    },

    setJSON: function ( json ) {
        this._json = json;
        return this;
    },

    setDataPrefixURL: function ( prefix ) {
        this._defaultOptions.dataPrefixURL = prefix;
    },
    getDataPrefixURL: function () {
        return this._defaultOptions.dataPrefixURL;
    },
    setServerPrefixURL: function ( prefix ) {
        this._defaultOptions.serverPrefixURL = prefix;
    },

    getServerPrefixURL: function () {
        return this._defaultOptions.serverPrefixURL;
    },

    //  TO REMOVE?? (and remove the calls to this method)
    computeDataURL: function ( url ) {

        if ( typeof this._defaultOptions.dataPrefixURL === 'string' &&
            this._defaultOptions.dataPrefixURL.length > 0 ) {

            return this._defaultOptions.dataPrefixURL + url;
        }

        return url;
    },

    // Remove? It isn't being used
    computeServerURL: function ( url ) {

        if ( typeof this._defaultOptions.serverPrefixURL === 'string' &&
            this._defaultOptions.serverPrefixURL.length > 0 ) {

            return this._defaultOptions.serverPrefixURL + url;
        }

        return url;
    },

    _readPointCloudCompactPLFMZ: function ( url, opt ) {

        var input = this;

        var options = opt;
        if ( options === undefined ) {
            options = input._defaultOptions;
        }

        // Add cplfmz version option
        options.version = 'cplfmz';

        // hook reader
        if ( options.readPointCloudURL ) {
            // be carefull if you plan to call hook the call and after
            // call the original readPointCloudURL, you will need to remove
            // from options the readPointCloudURL if you dont want an infinte
            // recursion call
            return options.readPointCloudURL.call( input, url, options );
        }

        url = input.computeDataURL( url );
        var defer = P.defer();

        osgDB.readNodeURL( url, options ).then( function ( data ) {
            defer.resolve( data );
        } );

        return defer.promise;

    },

    setMaxRequestsInQueue: function ( value ) {
        this._maxRequestsInQueue = value;
    },

    request: function ( url, options, withoutCredentials ) {
        var defer = P.defer();
        var self = this;

        var request = new XMLHttpRequest();
        request.open( 'GET', url, true );

        this._requests.push( request );
        if ( this._maxRequestsInQueue && this._requests.length > this._maxRequestsInQueue ) {
            var abortRequest = this._requests.shift();
            abortRequest.abort();
        }

        // handle responseType
        if ( options && options.responseType )
            request.responseType = options.responseType;

        if ( options && options.progress ) {
            request.addEventListener( 'progress', options.progress, false );
        }

        if ( !withoutCredentials ) {
            request.withCredentials = true;
        }
        request.addEventListener( 'error', function () {
            self.removeRequestFromQueue( this );
            defer.reject();
        }, false );

        request.addEventListener( 'abort', function ( /*oEvent */) {
            defer.reject( 'aborted request' );
        } );

        if ( options && options.headers ) {
            for ( var header in options.headers ) {
                request.setRequestHeader( header, options.headers[ header ] );
            }
        }

        request.addEventListener( 'load', function ( /*oEvent */) {
            if ( this.readyState !== XMLHttpRequest.DONE )
                return;

            try {
                if ( this.status >= 200 && this.status < 300 ) {
                    if ( this.responseType === 'arraybuffer' ) {
                        defer.resolve( this.response );
                        return;
                    }
                    defer.resolve( this.responseText );
                    return;
                }
                defer.reject( {
                    status: this.status,
                    response: this.response
                } );
            } finally {
                self.removeRequestFromQueue( this );
            }
        } );

        this._request = request;
        request.send( null );
        return defer.promise;
    },

    requestMountUrl: function ( url, options, replaceEndRequest ) {
        var defer = P.defer();
        var self = this;

        this._input = new Input();
        var promiseRequest = ( replaceEndRequest !== undefined ? replaceEndRequest : this._input.request );
        if ( options.layer === undefined ) {
            promiseRequest.call( self._input, url, options ).then( function ( response ) {
                defer.resolve( response );
            } );
            return defer.promise;
        }

        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( options.layer.getId() ).getMountObject().then( function ( mount ) {

            var computeTimeStamp = function ( url, m ) {
                var timeStampString = '?ts=' + TimeStampCache.getTimeStamp( url, options.urlTimeStampCacheKey );
                if ( m.appendQuery )
                    timeStampString += '&' + m.appendQuery;
                return timeStampString;
            };

            var computeFinalURL = function ( url, timeStampString, m ) {
                var finalURL = url + timeStampString;
                if ( Utils.isRelativeURL( url ) )
                    finalURL = m.mountPoint + '/' + url + timeStampString;
                return finalURL;
            };

            var remountAndRequest = function () {
                mountController.getMountObject( options.layer.getId() ).mountObject().then( function ( mo ) {
                    if ( mo.appendQuery )
                        options.appendQuery = mo.appendQuery;
                    promiseRequest.call( self._input, computeFinalURL( url, computeTimeStamp( url, mo ), mo ), options ).then( function ( response ) {
                        defer.resolve( response );
                    } );
                } ).catch( function ( error ) {
                    Registry.getController( 'Error' ).addError( error );
                    defer.reject( error );
                } );
            };

            promiseRequest.call( self._input, computeFinalURL( url, computeTimeStamp( url, mount ), mount ), options ).then( function ( response ) {
                if ( response.getImage !== undefined && response.getImage() === osgInput.imageFallback ) {
                    remountAndRequest();
                } else {
                    defer.resolve( response );
                }
            } ).catch( function ( error ) {
                // error is undefined when comes from l.161 request.addEventListener( 'error'
                if ( error && error.status === 403 ) {
                    remountAndRequest();
                } else {
                    defer.reject( error );
                }
            } );
            if ( options.requests )
                options.requests.push( self._input.getRequest() );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    getRequest: function () {
        var request = this._request;
        this._request = undefined;
        return request;
    },

    removeRequestFromQueue: function ( request ) {
        var index = this._requests.indexOf( request );
        this._requests.splice( index, 1 );
    },

};

module.exports = Input;


/***/ }),

/***/ "./sources/pcvizDB/LayerController.js":
/*!********************************************!*\
  !*** ./sources/pcvizDB/LayerController.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var TableView = __webpack_require__( /*! pcvizApp/TableView */ "./sources/pcvizApp/TableView.js" ).default;

/**
 * A singleton controller to update views when layers are changed
 * @class
 * @memberof pcvizDB
 */
var LayerController = function () {
    this._views = [];
};

LayerController.prototype = {

    /**
     * Registers a view that is notified when a layer is changed.
     * Currently, it only works with the 3D view. There must be another controller
     * to manage the registry of views. Then, this controller would make use of it.
     * @method
     * @memberof pcvizDB.LayerController
     * @param  {SceneView} view The 3D view to be notified
     */
    registerView: function ( view ) {
        this._views.push( view );
    },

    /**
     * Updates the layer style notifying the views. It only works with pointclouds.
     * @method
     * @memberof pcvizDB.LayerController
     * @param  {Layer} layer    The layer to be updated
     * @param  {string} property The name of the property to be updated
     * @param  {Any} value    The new value of the property
     */
    updateLayerStyle: function ( layer, property, value ) {
        for ( var i = 0; i < this._views.length; i++ )
            if ( this._views[ i ].getLayerRenderer && this._views[ i ].getLayerRenderer() !== undefined )
                this._views[ i ].getLayerRenderer().updateStyle( layer, property, value );
    },

    /**
     * Refresh the layer passed in all views registered
     * @method
     * @memberof pcvizDB.LayerController
     * @param  {Layer} layer    The layer to refresh
     */
    refreshLayerInAllViews: function ( layer ) {
        var defer = P.defer();
        var promises = [];
        for ( var i = 0; i < this._views.length; i++ )
            if ( ( this._views[ i ] instanceof TableView && layer.getDirtyFeatures && layer.getDirtyFeatures() ) || ( this._views[ i ].getLayerRenderer && this._views[ i ].getLayerRenderer() !== undefined ) )
                promises.push( this._views[ i ].refreshLayer( layer ) );

        Promise.all( promises ).then( function () {
            defer.resolve();
        } ).catch( function () {
            defer.resolve(); // Now we don't differenciate if some layer has not been refreshed. We only want to know when this function has finished
        } );

        return defer.promise;
    },

    /**
     * Refresh the layerGroup passed in all views registered
     * @method
     * @memberof pcvizDB.LayerController
     * @param  {LayerGroup} layer    The layerGroup to refresh
     */
    refreshLayerGroupInAllViews: function ( layerGroup ) {
        var defer = P.defer();
        var promises = [];
        for ( var i = 0; i < this._views.length; i++ )
            promises.push( this._views[ i ].refreshLayerGroup( layerGroup ) );

        Promise.all( promises ).then( function () {
            defer.resolve();
        } ).catch( function () {
            defer.resolve();
        } );

        return defer.promise;
    },

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.LayerController
     */
    reset: function () {
        this._views.length = 0;
    }
};

module.exports = LayerController;


/***/ }),

/***/ "./sources/pcvizDB/ListenerController.js":
/*!***********************************************!*\
  !*** ./sources/pcvizDB/ListenerController.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A controller base class that implements a listener map that manages different levels of
 * scope for those listeners. Listeners whose level is not `APPLICATION` are removed when
 * calling to `reset()`. Usually to load a new project or reload the current one.
 * @class
 * @property {Map} _listeners The listeners map.
 */
var ListenerController = function () {
    this._listeners = new Map();
    this.getOrCreateListenerArray( ListenerController.APPLICATION );
};

ListenerController.APPLICATION = 0;
ListenerController.PROJECT = 1;

ListenerController.prototype = {

    /**
     * Registers a listener to be notified when `notify` function is called. The listener level
     * must be set. It may be a listener that works at application or project level.
     * @method
     * @memberof pcvizDB.ListenerController
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @param  {Function|object} functionData    The function that is executed or an object that includes the function and a key (string) associated.
     * @param  {string} id   An optional id for the listener. If provided, it prevents multiple listeners with the same id. If provided, the element is stored as a pair {fn, id} instead of only the fn.
     */
    registerListener: function ( level, functionData, id ) {
        var lArray = this.getOrCreateListenerArray( level );
        var foundFunc;
        if ( id ) {
            foundFunc = lArray.find( function ( lElement ) {
                return ( lElement.id && lElement.id === id );
            } );
        }
        if ( functionData.function )
            console.error( 'function property is not supported' );
        if ( foundFunc ) // overwrite listener (if id is the same, we assume that 'key' is the same one, it means that different keys should use different ids)
            foundFunc.func = functionData.func ? functionData.func : functionData; // Takes into account 'func' used in UnitController and UserPreferencesController
        else if ( id )
            lArray.push( {
                func: functionData.func ? functionData.func : functionData, // Takes into account 'func' used in UnitController and UserPreferencesController
                id: id,
                key: functionData.key // Takes into account 'key' used in UnitController and UserPreferencesController
            } );
        else
            lArray.push( functionData );
    },

    /**
     * Helper function that creates a new scope level or returns it if it exists.
     * @method
     * @memberof pcvizDB.ListenerController
     * @param  {Any} key The key that is used to identify the scope level.
     * @return {Array}   The listener array.
     */
    getOrCreateListenerArray: function ( key ) {
        if ( this._listeners.get( key ) === undefined )
            this._listeners.set( key, [] );
        return this._listeners.get( key );
    },

    /**
     * Notifies all registered listeners. Arguments passed to this function will be
     * forwarded to all listener functions.
     * @method
     * @memberof pcvizDB.ListenerController
     * @param {Any} arguments All arguments passed to this function will be
     * forwarded to all listener functions.
     */
    notify: function () {
        var self = this;
        var args = arguments;
        this._listeners.forEach( function ( listenerArray ) {
            listenerArray.forEach( function ( listener ) {
                if ( listener.func )
                    listener.func.apply( self, args );
                else
                    listener.apply( self, args );
            } );
        } );
    },

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.ListenerController
     */
    reset: function () {
        this._listeners.forEach( function ( value, level, map ) {
            if ( level !== ListenerController.APPLICATION )
                map.delete( level );
        } );
    },

    /**
     * Helper function that concatenates all listeners arrays and return a single array.
     * @method
     * @memberof pcvizDB.ListenerController
     * @return {Array} An array with all registered listener functions.
     */
    getArrayFromListenerMap: function () {
        var array = [];
        this._listeners.forEach( function ( listenerArray ) {
            array = array.concat( listenerArray );
        } );
        return array;
    },

    /**
     * Function to remove a listener function.
     * @method
     * @memberof pcvizDB.ListenerController
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @param  {string} id   The id of the listener to be removed.
     */
    removeListener: function ( level, id ) {
        let listenersLevel = this._listeners.get( level );
        if ( !listenersLevel ) {
            return;
        }
        listenersLevel = listenersLevel.filter( ( listener ) => {
            return listener.id === undefined || listener.id !== id;
        } );
        this._listeners.set( level, listenersLevel );
    }
};

module.exports = ListenerController;


/***/ }),

/***/ "./sources/pcvizDB/ModelLibraryController.js":
/*!***************************************************!*\
  !*** ./sources/pcvizDB/ModelLibraryController.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


class ModelLibraryController {
    constructor() {
        this._modelLibraryMap = new Map();
    }

    addModel( key, model ) {
        this._modelLibraryMap.set( key, model );
    }

    getModel( key ) {
        return this._modelLibraryMap.get( key );
    }
}

/* harmony default export */ __webpack_exports__["default"] = (ModelLibraryController);


/***/ }),

/***/ "./sources/pcvizDB/MountController.js":
/*!********************************************!*\
  !*** ./sources/pcvizDB/MountController.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var MountObject = __webpack_require__( /*! pcvizDB/MountObject */ "./sources/pcvizDB/MountObject.js" );

/**
 * A singleton controller to manage mount system
 * @class
 * @memberof pcvizDB
 */
var MountController = function () {
    this._objectsMount = new Map();
};

MountController.prototype = {
    addMountObject: function ( key, object ) {
        if ( this._objectsMount.get( key ) )
            return;

        this._objectsMount.set( key, new MountObject( object ) );
    },

    getMountObject: function ( key ) {
        return this._objectsMount.get( key );
    },

    clear: function () {
        this._objectsMount.clear();
    }
};

module.exports = MountController;


/***/ }),

/***/ "./sources/pcvizDB/MountObject.js":
/*!****************************************!*\
  !*** ./sources/pcvizDB/MountObject.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
const TimeStampCache = __webpack_require__( /*! pcvizUtils/TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js" );
const MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );

/**
 * A object to manage the new mount system for catalog objects
 * @class
 * @memberof pcvizDB
 */
const MountObject = function ( object ) {
    this._object = object;
    this._mountObject = undefined;

    this.mountObject();
};

MountObject.prototype = {
    setObject: function ( object ) {
        this._object = object;
    },

    getObject: function () {
        return this._object;
    },

    getMountObject: function ( force ) {
        let defer = P.defer();

        //
        if ( this._object === undefined ) {
            defer.reject();
            return defer.promise;
        }

        if ( force ) {
            this._mountObject = undefined;
        }

        if ( this._mountObject !== undefined ) {
            defer.resolve( this._mountObject );
            return defer.promise;
        }

        return this.mountObject();
    },

    mountObject: function () {
        let defer = P.defer();
        let self = this;
        let request = new XMLHttpRequest();
        // TODO: When backend supports links in layers, remove hardcoded url
        let link = this._object._layerObject.links[ 0 ].href;
        let timeStampString = '?tsccw=' + TimeStampCache.getTimeStamp( link );
        let url = link + timeStampString;
        request.open( 'POST', url );
        request.onload = function () {
            if ( this.readyState === XMLHttpRequest.DONE && ( this.status >= 200 && this.status < 300 ) ) {
                self._mountObject = JSON.parse( request.responseText );
                defer.resolve( self._mountObject );
            }
            if ( this.status === 429 ) {
                defer.reject( JSON.parse( request.responseText.code ) );
            }
        };
        request.onerror = function () {
            defer.reject();
        };
        request.setRequestHeader( 'Authorization', MagnetAPI.getAuthorizationHeader() );
        request.setRequestHeader( 'Accept', 'application/json' );
        request.setRequestHeader( 'Content-Type', 'application/json; charset=UTF-8' );

        request.withCredentials = true;

        request.send();
        return defer.promise;
    }

};

module.exports = MountObject;


/***/ }),

/***/ "./sources/pcvizDB/ObjectController.js":
/*!*********************************************!*\
  !*** ./sources/pcvizDB/ObjectController.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;

/**
 * A controller to manage changes in objects.
 * @class
 * @memberof pcvizDB
 * @property {Array} _objects An array with the objects to be updated.
 * @property {Function} _updatedFinishCallbacks An array of callback functions that are executed when objects are updated.
 * @property {Integer} _delay The delay between executions of the interval function.
 * @property {Integer} _interval The interval id.
 */
var ObjectController = function () {
    ListenerController.call( this );
    this._objects = [];

    this._delay = 15000;
    this._interval = undefined;

    this.startInterval();
};

ObjectController.prototype = osg.objectInherit( ListenerController.prototype, {

    /**
     * Registers an object in the controller to be updated in the
     * update interval.
     * @method
     * @memberof pcvizDB.ObjectController
     * @param  {PropertySet} object The object to be registered and later updated.
     */
    registerObject: function ( object ) {
        if ( this._objects.indexOf( object ) === -1 )
            this._objects.push( object );
    },

    /**
     * Starts the interval that will loop through the registered objects.
     * This objects will be updated every `_delay` miliseconds.
     * @method
     * @memberof pcvizDB.ObjectController
     */
    startInterval: function () {
        var self = this;

        this._interval = setInterval( function () {
            var ruleFlag = false;

            if ( self._objects.length > 0 ) {
                var objects = [];
                var promises = [];
                for ( var i = 0; i < self._objects.length; i++ ) {
                    objects.push( self._objects[ i ] );
                    if ( self._objects[ i ]._dirty[ 'RuleSymbolizer' ] )
                        ruleFlag = true;
                    promises.push( self._objects[ i ].ensureUpdateCallback() );
                }
                Promise.all( promises ).then( function () {
                    self.updateFinish( objects, ruleFlag );
                } ).catch( function () {
                    self.updateFinish( objects );
                } );
                self._objects.length = 0;
            }
        }, this._delay );
    },

    /**
     * Registers a callback that will be executed when the objects are updated.
     * @param {Function} cb The callback function.
     * @method
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @memberof pcvizDB.ObjectController
     */
    addUpdatedFinishCallback: function ( level, cb ) {
        this.registerListener( level, cb );
    },

    /**
     * Executes the previously set update callback function
     * @method
     * @memberof pcvizDB.ObjectController
     */
    updateFinish: function ( objs, flag ) {
        this.notify( objs, flag );
    },

    /**
     * Stops the interval function
     * @method
     * @memberof pcvizDB.ObjectController
     */
    stopInterval: function () {
        this._interval = clearInterval( this._interval );
    },

    /**
     * Sets the delay time of the interval.
     * @method
     * @memberof pcvizDB.ObjectController
     */
    setDelay: function ( delay ) {
        this._delay = delay;
        this.stopInterval();
        this.startInterval();
    },

    /**
     * Gets if the ObjectController is dirty.
     * @method
     * @memberof pcvizDB.ObjectController
     * @return {Boolean} `true` if the controller has objects to update. `false` otherwise.
     */
    isDirty: function () {
        return this._objects.length > 0;
    },

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.ObjectController
     */
    reset: function () {
        this.stopInterval();
        this._objects.length = 0;
        ListenerController.prototype.reset.call( this );
        this.startInterval();
    }
} );

module.exports = ObjectController;


/***/ }),

/***/ "./sources/pcvizDB/Options.js":
/*!************************************!*\
  !*** ./sources/pcvizDB/Options.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {

    var defaultOptions = {

        // prefix to built url to load resource
        dataPrefixURL: '',

        serverPrefixURL: '',

        // callback used when loading data
        progressXHRCallback: undefined,

        // replacement of readImageURL to use your own code to load Nodes
        // the function will be execute in the context of Input, see Input:readNodeURL
        readPointCloudURL: undefined,
    };

    return defaultOptions;

}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ "./sources/pcvizDB/OverwriteSymbologyController.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizDB/OverwriteSymbologyController.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizTools_BufferTool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizTools/BufferTool */ "./sources/pcvizTools/BufferTool.js");
/* harmony import */ var pcvizTools_BufferTool__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_BufferTool__WEBPACK_IMPORTED_MODULE_4__);







/**
 * A controller to manage the overwritten symbologies
 *
 * @class
 * @memberof pcvizDB
 */

class OverwriteSymbologyController extends pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        var self = this;
        var configurationController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Configuration' );
        configurationController.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a.APPLICATION, function () {
            self._overwriteSymbologies = configurationController.getConfig().overwriteSymbologies;
        }, 'OverwriteSymbology' );

        if ( configurationController.isConfigLoaded() )
            this._overwriteSymbologies = configurationController.getConfig().overwriteSymbologies;
        this._project = undefined;
    }

    getSymbology( id ) {
        if ( this._overwriteSymbologies )
            return this._overwriteSymbologies.find( symbology => {
                return symbology.id === id;
            } );
    }

    /**
     * Applies the overwritten symbologies whose 'id' is in the 'ids' array
     * @method
     * @memberof pcvizDB.OverwriteSymbologyController
     * @param {Array} ids The ids of the symbologies to be applied
     * @param {Array} args If exist, each element should correspond to the layer Id that is going to be affected by symbology in same index of the ids array
     * @param {boolean} avoidStore It avoids saving current styles in DB and to commit the symbology changes for vector layers (this is used in a specific case, it should not be used always)
     * @return {Promise} p Resolves when all layers have been refreshed
     */
    runOverwrittenSymbology( ids, args, avoidStore ) {
        return new Promise( ( resolve, reject ) => {
            let self = this;
            this._propertiesOverwritten = new Set(); // it is a Set because we want unique values
            this.saveCurrentStyles( avoidStore ).then( function () {
                let promises = [];
                let overwrittenIds = [];

                // We have LayerType.POINTCLOUD , LayerType.VECTOR 
                // We have not any other cases by now, so the code has a simple if                 

                self._project.getAllLayers().forEach( layer => {
                    let overwritten = false;
                    let layerType = layer.getType();

                    // Improve: check if the layer is opened
                    for ( var i = 0; i < ids.length; i++ ) {
                        // Read it 
                        let symbology = self.getSymbology( ids[ i ] );
                        if ( symbology && self.compatibleSymbology( layer, symbology, args ? args[ i ] : undefined ) ) {
                            symbology = JSON.parse( JSON.stringify( self.getSymbology( ids[ i ] ) ) ); // deep clone to make a copy

                            overwritten = true;
                            // Update layer style
                            if ( layerType === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].POINTCLOUD ) {
                                for ( let property in symbology.PointCloudSymbolizer ) {
                                    layer.setStylePropertyAndDirty( property, symbology.PointCloudSymbolizer[ property ] );
                                    self._propertiesOverwritten.add( property );
                                }
                            }
                            if ( layerType === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].VECTOR ) {
                                for ( let property in symbology.Symbolizer ) {
                                    // we use Symbolizer for every geometryType to simplify code
                                    let parsedSymbology = symbology.Symbolizer[ property ];
                                    if ( symbology.needParseProperties )
                                        parsedSymbology = self.getParsedSymbology( property, symbology, layer );
                                    let styleProperty;
                                    if ( typeof parsedSymbology === 'object' ) {
                                        styleProperty = layer.getCategoryRenderer().getStyleProperty( layer.getStyle(), property );
                                        if ( styleProperty ) // it can be undefined (for instance when overriding rules if layer has never had rules)
                                            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getController( 'Configuration' ).mergeConfiguration( styleProperty, parsedSymbology );
                                    }
                                    layer.getCategoryRenderer().setStyleProperty( layer.getStyle(), property, styleProperty ? styleProperty : parsedSymbology );
                                    if ( !avoidStore )
                                        layer.dirtyProperty( property );
                                }
                            }

                            overwrittenIds.push( layer.getId() );
                        }
                    }
                    // Refresh the layer (TODO: avoid refresh in TableView) 
                    // We have LayerType.POINTCLOUD or not (  LayerType.VECTOR by now  )
                    if ( overwritten ) {
                        if ( layerType === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].POINTCLOUD ) {
                            let sceneView = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' );

                            // instead sceneView.refreshLayer promise, now we just force redraw
                            sceneView.forceRequestRedraw( true ); // includes reset pointcloud shader cache

                        } else {
                            promises.push( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Layer' ).refreshLayerInAllViews( layer ) );
                        }
                    }
                } );
                //loop over all layers 

                // save only the original layer style of the overriden layer style
                self._previousStyles = self._previousStyles.filter( function ( layerDataStyle ) {
                    return overwrittenIds.includes( layerDataStyle.id );
                } );

                // consume promises & notify interested Tools
                self.symbologySetUnsetLastStep.bind( self )( promises, resolve, reject, ids, avoidStore );

            } ).catch( () => {
                console.warn( 'overrideSymbology > Styles could not be saved in OverwriteSymbologyController.' );
                reject();
            } );

        } );
    }

    restoreSymbology( refreshPointCloudLayers ) {
        return new Promise( ( resolve, reject ) => {
            let self = this;
            if ( !self._previousStyles )
                self._previousStyles = self.getPreviousStylesFromDB();

            if ( !self._propertiesOverwritten )
                self._propertiesOverwritten = new Set( self.getPropertiesOverwrittenFromDB() );

            let promises = [];

            const layerSetPropertiesIfValid = ( layer, layerData, propertiesArray ) => {
                // filter de valids !
                propertiesArray = propertiesArray.filter( p => p !== 'classificationVisibility' || layerData.style.PointCloudSymbolizer[ p ] !== null );
                propertiesArray.forEach( p => { layer.setStylePropertyAndDirty( p, layerData.style.PointCloudSymbolizer[ p ] ); } );
            };

            const restoreSimbologyForPointCloudLayer = ( layer, layerData ) => {
                if ( self._propertiesOverwritten.size ) {
                    // case 1.- Only restore the properties overwritten by the symbologies applied. (ClearEdge request)                    
                    // 'SET' to array                                    
                    layerSetPropertiesIfValid( layer, layerData, Array.from( self._propertiesOverwritten ) );
                } else {
                    // case 2.- For projects that are in C2C state before _propertiesOverwritten changes are deployed.
                    // { alpha:value, drawingRule: rgb, etc }  to array
                    layerSetPropertiesIfValid( layer, layerData, Object.keys( layerData.style.PointCloudSymbolizer ) );
                }

                // refresh layers (flag: if you are going to apply another symbology maybe you don't want to refresh every layer each time)
                if ( refreshPointCloudLayers ) {
                    let sceneView = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' );
                    // instead sceneView.refreshLayer promise, now we just force redraw
                    sceneView.forceRequestRedraw( true ); // includes reset pointcloud shader cache                 
                }
            };

            const restoreSimbologyForOtherLayersType = ( layer, layerData ) => {
                let symbolizer = layer.getCategoryRenderer().getBaseSymbolizer( layerData.style );
                for ( let property in symbolizer ) {
                    layer.getCategoryRenderer().setStyleProperty( layer.getStyle(), property, symbolizer[ property ] );
                    layer.dirtyProperty( property );
                }

                //If it hadn't rules, we need to empty the RuleSymbolizer because maybe it was overwritten with rules
                if ( !Object.keys( symbolizer ).includes( 'RuleSymbolizer' ) ) {
                    layer.getCategoryRenderer().setStyleProperty( layer.getStyle(), 'RuleSymbolizer', { 'rules': [] } );
                    layer.dirtyProperty( 'RuleSymbolizer' );
                }

                promises.push( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Layer' ).refreshLayerInAllViews( layer ) );
            };

            let restoreFunctionsMap = new Map();
            restoreFunctionsMap.set( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].POINTCLOUD, restoreSimbologyForPointCloudLayer );
            restoreFunctionsMap.set( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].VECTOR, restoreSimbologyForOtherLayersType );

            // set previous style for each layer we changed with previous styles
            // layer might have been removed, clean previousStyles layerData array 
            let previousStyles = self._previousStyles.filter( layerData => self._project.getLayerById( layerData.id ) !== undefined );
            previousStyles.forEach( function ( layerData ) {
                let layer = self._project.getLayerById( layerData.id );
                restoreFunctionsMap.get( layer.getType() )( layer, layerData );
            } );

            // clear previous styles
            self._previousStyles = [];
            self._propertiesOverwritten.clear();
            // bind to avoid context lost
            self.symbologySetUnsetLastStep.bind( self )( promises, resolve, reject );
        } );
    }

    /**
     * Consume all promise-layers style changes, then some final actions
     * @method
     * @memberof pcvizDB.OverwriteSymbologyController     
     * @param {promises} array  of promises  to consume
     * @param {resolve} function resolve function
     * @param {reject} function reject function
     * @param {toNotify} any to send to listeners connected 
     * 
     */
    symbologySetUnsetLastStep( promises, resolve, reject, toNotify, avoidStore ) {
        let self = this;

        if ( !avoidStore )
            promises.push( self.updatePreviousStylesInDB() );

        Promise.all( promises ).then( () => {
            resolve();
            if ( toNotify ) {
                self.notify( toNotify ); // ids for 'set' case
            }
            let view3D = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' );
            let bufferTool = view3D.getTool( 'buffer' );
            if ( view3D.getLayerRenderer() ) {
                bufferTool.setData( Array.from( view3D.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].POINTCLOUD ).values() ), pcvizTools_BufferTool__WEBPACK_IMPORTED_MODULE_4___default.a.ON_POINTCLOUDS );
                bufferTool.setData( Array.from( view3D.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].VECTOR ).values() ), pcvizTools_BufferTool__WEBPACK_IMPORTED_MODULE_4___default.a.ON_FEATURES );
            }

        }, reject );
    }

    setProject( project ) {
        this._project = project;
    }

    compatibleSymbology( layer, symbology, arg ) {
        if ( layer.getType() !== symbology.layerType )
            return false;
        if ( layer.getCategory && symbology.category && layer.getCategory() !== symbology.category )
            return false;
        // to apply to the selected/unselected object
        //if(symbology.selectedObject && layer !== Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject())
        //return false;
        if ( arg !== undefined )
            return layer.getId() === arg;
        return true;
    }

    getAllSymbologies() {
        return this._overwriteSymbologies;
    }

    saveCurrentStyles( avoidStore ) {
        this._previousStyles = this._project.getLayersData();
        if ( avoidStore )
            return Promise.resolve();
        return this.updatePreviousStylesInDB();
    }

    getPreviousStylesFromDB() {
        var extData = this._project.getExtData();
        if ( !extData || !extData.previousStyles ) {
            return [];
        }
        return extData.previousStyles;
    }

    getPropertiesOverwrittenFromDB() {
        let extData = this._project.getExtData();
        if ( !extData || !extData.pointcloudPropsOverwritten ) {
            return [];
        }
        return extData.pointcloudPropsOverwritten;
    }

    updatePreviousStylesInDB() {
        var extData = this._project.getExtData();
        if ( !extData )
            extData = {};
        extData.previousStyles = this._previousStyles;
        extData.pointcloudPropsOverwritten = [ ...this._propertiesOverwritten ];
        return this._project.setExtensibleData( extData ); // Be careful: promise
    }




    getParsedSymbology( property, symbology, layer ) {
        let stringToParse = symbology.needParseProperties[ 0 ]; // now, we are going to parse only first property
        let propertyValue = symbology.Symbolizer[ property ];

        let keysArray = stringToParse.split( '.' );

        propertyValue = keysArray.reduce( ( value, key ) => {
            return value[ key ];
        }, propertyValue );
        if ( propertyValue.as === 'PointCloud' ) {
            // find station of layer
            let parentLayer = layer.getParent();
            if ( !parentLayer.getParentStation )
                return undefined;
            let stationLayerGroup = parentLayer.getParentStation();
            // find pointcloud
            let pointcloudLayerParent = stationLayerGroup.hasPointcloud(); // this method returns false or the pointcloud layer Parent
            if ( !pointcloudLayerParent )
                return undefined;
            let pointcloudLayer = pointcloudLayerParent.getChildren().find( ( childLayer ) => childLayer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_3__["default"].POINTCLOUD );
            // return symbology parsed with property value from pointcloud
            let parsedPropertyValue = pointcloudLayer.getStyleProperty( propertyValue.property );
            if ( propertyValue.property === 'fixedColor' ) // specific case because we need to convert color system
            {
                parsedPropertyValue = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.fullhexToRgb( parsedPropertyValue, 1.0, true );
            }

            // asign new property value in the property symbology object and return whole object
            let parsedProp = symbology.Symbolizer[ property ];
            let auxProp = parsedProp;

            for ( let i = 0; i < keysArray.length - 1; i++ ) {
                auxProp = auxProp[ keysArray[ i ] ];
            }

            auxProp[ keysArray[ keysArray.length - 1 ] ] = parsedPropertyValue;
            return parsedProp;
        }
    }


}

/* harmony default export */ __webpack_exports__["default"] = (OverwriteSymbologyController);


/***/ }),

/***/ "./sources/pcvizDB/OverwriteVisibilityController.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDB/OverwriteVisibilityController.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * A controller to manage the overwritten visibility
 *
 * @class
 * @memberof pcvizDB
 */

class OverwriteVisibilityController {
    constructor() {
        this._project = undefined;
        this._previousStationsVisibility = new Map();
        this._previousLayersVisibility = new Map();
    }

    setPreviousStationVisibility( id, isVisible ) {
        this._previousStationsVisibility.set( id, isVisible );
    }

    getPreviousStationVisibility( id ) {
        return this._previousStationsVisibility.get( id );
    }

    getAllPreviousStationsVisibility() {
        return this._previousStationsVisibility;
    }

    setPreviousLayerVisibility( id, isVisible ) {
        this._previousLayersVisibility.set( id, isVisible );
    }

    getPreviousLayerVisibility( id ) {
        return this._previousLayersVisibility.get( id );
    }

    getAllPreviousLayersVisibility() {
        return this._previousLayersVisibility;
    }

    clearAll() {
        this._previousStationsVisibility.clear();
        this._previousLayersVisibility.clear();
    }

    setProject( project ) {
        this._project = project;
    }

    getPreviousVisibilityFromDB() {
        console.warn( 'To implement' );
    }

    updatePreviousVisibilityInDB() {
        console.warn( 'To implement' );
    }

    // We could implement this function here
    restoreVisibility() {}


}

/* harmony default export */ __webpack_exports__["default"] = (OverwriteVisibilityController);


/***/ }),

/***/ "./sources/pcvizDB/PLFMZReaderParser.js":
/*!**********************************************!*\
  !*** ./sources/pcvizDB/PLFMZReaderParser.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Serializer = __webpack_require__( /*! pcvizDB/Serializer */ "./sources/pcvizDB/Serializer.js" );

var ChildrenDataID = 'ChildrenData';

var PLFMZReaderParser = function () {
    this._reader = new Serializer();

};

var AttributeInformation = function () {
    this.name = '';
    this.dataType = undefined;
    this.dataTypeSize = undefined;
    this.dataTypeNumElements = 0.0;
    this.arraySize = 0;
    this.frameNumberOfLastTraversal = 0;
    this.start = undefined;
    this.arrayBuffer = undefined;
};

var PLFMZHeader = function () {
    this.format = [];
    this.version = 0;
    this.numAttributes = 0;
    this.attributeInformationStart = 0;
};

var CPLFMZHeader = function () {
    this.format = [];
    this.version = 0;
    this.numAttributes = 0;
    this.numAttributesPerBlock = 0;
    this.numChildren = 0;
    this.attributeInformationStart = 0;
};

var Extent = function () {
    this.minExtent = [];
    this.maxExtent = [];
};

var PLFMZ = function () {
    this.header = new PLFMZHeader();
    this.attributesInformation = new Map();
    this.childrenData = [];
    this.extent = new Extent();
    this.designation = [];
};

var CPLFMZ = function () {
    this.header = new CPLFMZHeader();
    this.attributesInformation = new Map();
    this.childrenAttributesInformation = [];
    this.designation = [];
};

PLFMZReaderParser.prototype = {

    computeCenter: function ( min, max ) {
        var center = new Float64Array( 3 );
        center[ 0 ] = ( min[ 0 ] + max[ 0 ] ) / 2.0;
        center[ 1 ] = ( min[ 1 ] + max[ 1 ] ) / 2.0;
        center[ 2 ] = ( min[ 2 ] + max[ 2 ] ) / 2.0;
        return center;
    },
    parseBuffer: function ( u8array ) {
        //console.log('parsing PLFMZ unpacked data');
        var plfmz = new PLFMZ();
        this._reader.setBuffer( u8array );
        plfmz.header.format = this._reader.deserializeStringArray( 4 );
        plfmz.header.version = this._reader.deserializeUint32Value();
        plfmz.header.numAttributes = this._reader.deserializeUint32Value();
        plfmz.header.attributeInformationStart = this._reader.deserializeUint32Value();

        var nextAttrStart = plfmz.header.attributeInformationStart;
        //var attrInfoArray = reader.deserializeArray( plfmz.header.attributeInformationStart ); // remaining data should be the attributes information
        for ( var i = 0, len = plfmz.header.numAttributes; i < len; ++i ) {
            this._reader.seekg( nextAttrStart );

            var attributeInformation = new AttributeInformation();
            attributeInformation.name = this._reader.deserializeString();
            attributeInformation.dataType = this._reader.deserializeUint32Value();
            attributeInformation.dataTypeSize = this._reader.deserializeUint32Value();
            attributeInformation.dataTypeNumElements = this._reader.deserializeUint32Value();
            attributeInformation.arraySize = this._reader.deserializeUint32Value();
            attributeInformation.start = this._reader.deserializeUint32Value();
            nextAttrStart = this._reader.getg();

            this._reader.seekg( attributeInformation.start );
            attributeInformation.arrayBuffer = this._reader.deserializeArray( attributeInformation.arraySize * attributeInformation.dataTypeSize );
            plfmz.attributesInformation.set( attributeInformation.name, attributeInformation );

        }
        plfmz.childrenData = this.parseChildrenData( plfmz.attributesInformation.get( ChildrenDataID ).arrayBuffer );
        var u8arrayExtension = plfmz.attributesInformation.get( 'Extension' ).arrayBuffer;
        this.parseExtension( u8arrayExtension, plfmz.extent );
        var u8arrayDesignation = plfmz.attributesInformation.get( 'Designation' ).arrayBuffer;
        plfmz.designation = this.parseDesignation( u8arrayDesignation );
        return plfmz;
    },



    parseCompactBuffer: function ( u8array ) {
        //console.log('parsing PLFMZ unpacked data');
        var cplfmz = new CPLFMZ();
        this._reader.setBuffer( u8array );
        cplfmz.header.format = this._reader.deserializeStringArray( 8 );
        cplfmz.header.version = this._reader.deserializeUint32Value();
        cplfmz.header.numAttributes = this._reader.deserializeUint32Value();
        cplfmz.header.numAttributesPerBlock = this._reader.deserializeUint32Value();
        cplfmz.header.numChildren = this._reader.deserializeUint32Value();
        cplfmz.header.attributeInformationStart = this._reader.deserializeUint32Value();


        var nextAttrStart = cplfmz.header.attributeInformationStart;
        // Parent info
        nextAttrStart = this.parseAttributeInformation( nextAttrStart, cplfmz.header.numAttributes, cplfmz.attributesInformation );
        // Children attribute information
        cplfmz.childrenAttributesInformation.push( new Map() );
        nextAttrStart = this.parseAttributeInformation( nextAttrStart, cplfmz.header.numAttributesPerBlock, cplfmz.childrenAttributesInformation[ 0 ] );

        for ( var i = 1, len = cplfmz.header.numChildren; i < len; ++i ) {
            // Children attribute information
            cplfmz.childrenAttributesInformation.push( new Map() );
            nextAttrStart = this.parseChildrenAttributeInformation( nextAttrStart, cplfmz.childrenAttributesInformation[ 0 ], cplfmz.childrenAttributesInformation[ i ] );
        }

        return cplfmz;
    },

    parseChildrenAttributeInformation: function ( nextAttrStart, firstChildrenAttributesInformation, childrenAttributesInformation ) {

        var that = this;
        firstChildrenAttributesInformation.forEach( function ( value, key ) {
            that._reader.seekg( nextAttrStart );
            var attributeInformation = new AttributeInformation();
            attributeInformation.name = key;
            attributeInformation.dataType = value.dataType;
            attributeInformation.dataTypeSize = value.dataTypeSize;
            attributeInformation.dataTypeNumElements = value.dataTypeNumElements;
            attributeInformation.arraySize = that._reader.deserializeUint32Value();
            attributeInformation.start = that._reader.deserializeUint32Value();
            nextAttrStart = that._reader.getg();
            that._reader.seekg( attributeInformation.start );
            attributeInformation.arrayBuffer = that._reader.deserializeArray( attributeInformation.arraySize * attributeInformation.dataTypeSize );
            childrenAttributesInformation.set( attributeInformation.name, attributeInformation );

        } );

        return nextAttrStart;

    },

    parseAttributeInformation: function ( nextAttrStart, numAtttributes, attributesInformation ) {

        for ( var i = 0, len = numAtttributes; i < len; ++i ) {
            this._reader.seekg( nextAttrStart );
            var attributeInformation = new AttributeInformation();
            attributeInformation.name = this._reader.deserializeString();
            attributeInformation.dataType = this._reader.deserializeUint32Value();
            attributeInformation.dataTypeSize = this._reader.deserializeUint32Value();
            attributeInformation.dataTypeNumElements = this._reader.deserializeUint32Value();
            attributeInformation.arraySize = this._reader.deserializeUint32Value();
            attributeInformation.start = this._reader.deserializeUint32Value();
            nextAttrStart = this._reader.getg();

            this._reader.seekg( attributeInformation.start );
            attributeInformation.arrayBuffer = this._reader.deserializeArray( attributeInformation.arraySize * attributeInformation.dataTypeSize );
            //if  ( attributeInformation.name !== 'PointArray' && attributeInformation.name !== 'ColorArray' )
            attributesInformation.set( attributeInformation.name, attributeInformation );
        }
        return nextAttrStart;
    },

    parseChildrenData: function ( u8array ) {
        //var reader = new Serializer( u8array );
        var len = u8array.byteLength / 64; // <- 64 is the size in bytes of the ChildData native structure
        var offset = 48; // <- the first 48 bytes are for the children extension
        var dsgLen = 16; /// <- dsg are 4 unsigned int = 16 bytes
        var childrenData = [];
        for ( var i = 0; i < len; i++ ) {
            var dsg = new Uint32Array( u8array.buffer.slice( offset, offset + dsgLen ) );
            offset += 64;
            childrenData.push( {
                designation: dsg
            } );
        }
        return childrenData;
    },

    parseExtension: function ( u8array, extent ) {
        if ( extent === undefined )
            extent = new Extent();
        var f64Array = new Float64Array( u8array.buffer );
        extent.minExtent = [ f64Array[ 0 ], f64Array[ 1 ], f64Array[ 2 ] ];
        extent.maxExtent = [ f64Array[ 3 ], f64Array[ 4 ], f64Array[ 5 ] ];
        return extent;
    },
    parseDesignation: function ( u8array ) {
        var dsg = new Uint32Array( u8array.buffer );
        return dsg;
    },
    parseLeaf: function ( u8array ) {
        var leaf = String.fromCharCode( u8array );
        return leaf;
    }
};

module.exports = PLFMZReaderParser;


/***/ }),

/***/ "./sources/pcvizDB/PluginsController.js":
/*!**********************************************!*\
  !*** ./sources/pcvizDB/PluginsController.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PluginsController; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizPlugins/pcvizPlugins */ "./sources/pcvizPlugins/pcvizPlugins.js");



const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;

class PluginsController {
    constructor() {}

    setUpPlugins() {
        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'cplfmz' ) ) {
            osgDB.Registry.instance().addReaderWriter( 'cplfmz', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterCPLFMZ() );
        }

        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'plfmz' ) ) {
            osgDB.Registry.instance().addReaderWriter( 'plfmz', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterPLFMZ() );
        }
        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'jpg' ) ) {
            var rwFeatureImage = new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterFeatureImage();
            osgDB.Registry.instance().addReaderWriter( 'jpg', rwFeatureImage );
            osgDB.Registry.instance().addReaderWriter( 'JPG', rwFeatureImage );
            osgDB.Registry.instance().addReaderWriter( 'png', rwFeatureImage );
            osgDB.Registry.instance().addReaderWriter( 'PNG', rwFeatureImage );
        }
        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'panorama' ) ) {
            osgDB.Registry.instance().addReaderWriter( 'panorama', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterTiledPanorama() );
        }
        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'planarimage' ) ) {
            osgDB.Registry.instance().addReaderWriter( 'planarimage', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterTiledPlanarImage() );
        }

        if ( !osgDB.Registry.instance().getReaderWriterForExtension( 'osgjsc' ) ) {
            osgDB.Registry.instance().addReaderWriter( 'osgjsc', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriterOSGJSC() );
        }
        if ( !osgDB.Registry.instance().getReaderWriterForExtension( '3dt' ) ) {
            osgDB.Registry.instance().addReaderWriter( '3dt', new pcvizPlugins_pcvizPlugins__WEBPACK_IMPORTED_MODULE_1__["default"].ReaderWriter3DTiles() );
        }
    }

    removePlugins() {
        osgDB.Registry.instance().plugins.delete( 'cplfmz' );
        osgDB.Registry.instance().plugins.delete( 'plfmz' );
        osgDB.Registry.instance().plugins.delete( 'jpg' );
        osgDB.Registry.instance().plugins.delete( 'jpeg' );
        osgDB.Registry.instance().plugins.delete( 'JPG' );
        osgDB.Registry.instance().plugins.delete( 'JPEG' );
        osgDB.Registry.instance().plugins.delete( 'png' );
        osgDB.Registry.instance().plugins.delete( 'PNG' );
        osgDB.Registry.instance().plugins.delete( 'panorama' );
        osgDB.Registry.instance().plugins.delete( 'planarimage' );
        osgDB.Registry.instance().plugins.delete( 'osgjsc' );
        osgDB.Registry.instance().plugins.delete( '3dt' );
    }
}


/***/ }),

/***/ "./sources/pcvizDB/PointCloudDBPager.js":
/*!**********************************************!*\
  !*** ./sources/pcvizDB/PointCloudDBPager.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Jordi torres <jordi.torres@mirage-tech.com>
 */


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var PLFMZReaderParser = __webpack_require__( /*! pcvizDB/PLFMZReaderParser */ "./sources/pcvizDB/PLFMZReaderParser.js" );
var ConversionInfo = __webpack_require__( /*! pcvizDB/ConversionInfo */ "./sources/pcvizDB/ConversionInfo.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;

/**
 *  PointCloudDBPager
 *  @class
 *  @memberof pcvizDB
 */
var PointCloudDBPager = function () {
    osgDB.DatabasePager.call( this );
    this._targetMaximumNumberOfPagedLOD = 75;
    this._maxRequestsPerFrame = 10;
    this._parser = new PLFMZReaderParser();
    this._conversionInfo = new ConversionInfo();

    this._onAddedDataCallbacks = [];
    this._processRequestFinishCallback = undefined;
    this._processRequestStartCallback = undefined;
};

var PointCloudDatabaseRequest = function () {
    this._loadedModel = undefined;
    this._group = undefined;
    this._url = [];
    this._prefixurl = '';
    this._function = undefined;
    this._timeStamp = 0.0;
    this._groupExpired = false;
    this._priority = 0.0;
    this._finished = false;
    this._requests = [];
    this._options = undefined;
};

var PointCloudExpirePagedLODVisitor = function () {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._childrenList = [];
};

var sortByTimeStamp = function ( r1, r2 ) {
    return r2._timeStamp - r1._timeStamp;
};

const sortByPriorityAndTime = function ( r1, r2 ) {
    // user priority dominates
    if ( r1._userPriority !== undefined ) {
        let difference = ( ( r2._userPriority !== undefined ) ? r2._userPriority - r1._userPriority : -1 );
        if ( difference !== 0 ) // if user priorities are the same, continue to apply the time or area priority
            return difference;
    } else if ( r2._userPriority !== undefined )
        return 1;

    // Ask for newer requests first.
    let value = r2._timeStamp - r1._timeStamp;
    // Ask for the greater priority if the timestamp is the same.
    if ( value === 0 ) {
        value = r2._priority - r1._priority;
    }
    return value;
};

PointCloudExpirePagedLODVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {

    apply: function ( node ) {
        if ( node.getTypeID() === osg.PagedLOD.getTypeID() ) {
            this._childrenList.push( node );
            this._markRequestsExpired( node );
        }
        this.traverse( node );
    },

    removeExpiredChildrenAndFindPagedLODs: function ( plod, expiryTime, expiryFrame, removedChildren ) {
        if ( !plod.children.length ) return false;

        var sizeBefore = removedChildren.length;
        plod.removeExpiredChildren( expiryTime, expiryFrame, removedChildren );
        for ( var i = sizeBefore; i < removedChildren.length; i++ ) {
            removedChildren[ i ].accept( this );
        }
        return sizeBefore !== removedChildren.length;
    },

    _markRequestsExpired: function ( plod ) {
        var numRanges = plod._perRangeDataList.length;
        var request;
        for ( var i = 0; i < numRanges; i++ ) {
            request = plod.getDatabaseRequest( i );
            if ( request !== undefined ) {
                for ( var h = request._requests.length - 1; h >= 0; h-- ) {
                    var xhr = request._requests.pop();
                    xhr.abort();
                }
                request._groupExpired = true;
                // FIXME: I think the next 4 lines are not necessary because of _promises doesn't exist
                if ( request._promises ) {
                    for ( var j = 0; j < request._promises.length; j++ )
                        request._promises[ j ].resolve();
                }
                request._promises = undefined;
                request._loadedModel = null;
            }
        }
    }
} );

PointCloudDBPager.prototype = osg.objectInherit( osgDB.DatabasePager.prototype, {

    requestNodeFile: function ( func, url, node, timestamp, priority, options ) {
        // Check if we are currently accepting requests.
        if ( !this._acceptNewRequests ) return undefined;

        // We don't need to determine if the dbrequest is in the queue
        // That is already done in the PagedLOD, so we just create the request
        var dbrequest = new PointCloudDatabaseRequest();
        dbrequest._group = node;
        dbrequest._function = func;

        if ( url.constructor === Array )
            dbrequest._url = url;
        else
            dbrequest._prefixurl = url;
        dbrequest._timeStamp = timestamp;
        dbrequest._priority = priority;
        dbrequest._options = options;
        dbrequest._userPriority = node._userPriority;
        this._pendingRequests.push( dbrequest );
        return dbrequest;
    },

    takeRequests: function () {
        if ( this._loading ) return; // this condition is never true
        if ( this._pendingRequests.length ) {
            this.processRequestStart();
            var numRequests = Math.min( this._maxRequestsPerFrame, this._pendingRequests.length );
            // a NEGATIVE value means r1 has HIGHER priority than r2
            this._pendingRequests.sort( sortByPriorityAndTime );
            for ( var i = 0; i < numRequests; i++ ) {
                this.processRequest( this._pendingRequests.shift() );
            }
        }
    },

    /**
     * Overwrites DatabasePager.addLoadedDataToSceneGraph.
     * @method
     * @memberof pcvizDB.PointCloudDBPager
     */
    addLoadedDataToSceneGraph: function ( frameStamp, availableTime ) {
        if ( !this._pendingNodes.length || availableTime <= 0.0 ) return 0.0;

        // Prune the list of database requests.
        var elapsedTime = 0.0;
        var beginTime = osg.Timer.instance().tick();
        this._pendingNodes.sort( sortByTimeStamp );

        for ( var i = 0; i < this._pendingNodes.length; i++ ) {
            if ( elapsedTime > availableTime ) return 0.0;

            var request = this._pendingNodes.shift();
            var frameNumber = frameStamp.getFrameNumber();
            var timeStamp = frameStamp.getSimulationTime();

            // If the request is not expired, then add/register new childs
            if ( request._groupExpired === false ) {
                var plod = request._group;
                plod.setTimeStamp( plod.children.length, timeStamp );
                plod.setFrameNumber( plod.children.length, frameNumber );
                plod.addChildNode( request._loadedModel );

                this.notifyOnAddedData( request._loadedModel );

                // Register PagedLODs.
                if ( !this._activePagedLODList.has( plod ) ) {
                    this.registerPagedLODs( plod, frameNumber );
                } else {
                    this.registerPagedLODs( request._loadedModel, frameNumber );
                }
            } else {
                // Clean the request
                request._loadedModel = undefined;
                request = undefined;
            }
            elapsedTime = osg.Timer.instance().deltaS( beginTime, osg.Timer.instance().tick() );
        }
        availableTime -= elapsedTime;
        return availableTime;
    },

    pushOnAddedDataCallback: function ( fn ) {
        this._onAddedDataCallbacks.push( fn );
    },

    notifyOnAddedData: function ( data ) {
        for ( let callback of this._onAddedDataCallbacks ) {
            callback( data );
        }
    },

    processRequest: function ( dbrequest ) {

        //this._loading = true;
        var that = this;
        // Check if the request is valid;
        if ( dbrequest._groupExpired ) {
            //Notify.log( 'DatabasePager::processRequest() Request expired.' );
            this.processRequestFinish();
            return;
        }

        var ext = dbrequest._prefixurl.substring( dbrequest._prefixurl.lastIndexOf( '.' ) + 1 );
        this._downloadingRequestsNumber++;
        if ( ext === 'cplfmz' ) {
            // Compact PointCloud
            var options = dbrequest._options;
            options.responseType = 'arraybuffer';
            options.requests = dbrequest._requests;
            osgDB.readNodeURL( dbrequest._prefixurl, options ).then( function ( child ) {
                that._downloadingRequestsNumber--;
                dbrequest._loadedModel = child;
                dbrequest._finished = true;
                that._pendingNodes.push( dbrequest );
                that.processRequestFinish();

            } ).catch( function ( /*reason*/) {
                that._downloadingRequestsNumber--;
                dbrequest._finished = true;
                that.processRequestFinish();
            } );
        } else {
            if ( dbrequest._function !== undefined ) {
                this.loadNodeFromFunction( dbrequest._function, dbrequest._group ).then( function (
                    child
                ) {
                    that._downloadingRequestsNumber--;
                    dbrequest._loadedModel = child;
                    that._pendingNodes.push( dbrequest );
                    dbrequest._finished = true;
                    that.processRequestFinish();
                } ).catch( function ( /*reason*/) {
                    that._downloadingRequestsNumber--;
                    dbrequest._finished = true;
                    that.processRequestFinish();
                } );
                return;
            }

            osgDB.readNodeURL( dbrequest._prefixurl, dbrequest._options ).then( function ( child ) {
                that._downloadingRequestsNumber--;
                dbrequest._loadedModel = child;
                that._pendingNodes.push( dbrequest );
                that.processRequestFinish();
            } );
        }
    },

    processRequestFinish: function () {
        this._loading = false;
        if ( this._processRequestFinishCallback )
            this._processRequestFinishCallback();
    },

    setProcessRequestFinish: function ( callBack ) {
        this._processRequestFinishCallback = callBack;
    },

    processRequestStart: function () {
        if ( this._processRequestStartCallback )
            this._processRequestStartCallback();
    },

    setProcessRequestStart: function ( callBack ) {
        this._processRequestStartCallback = callBack;
    },

    removeExpiredChildren: function ( numToPrune, expiryTime, expiryFrame, availableTime ) {
        // Iterate over the activePagedLODList to remove expired children
        // We need to control the time spent in remove childs.
        var elapsedTime = 0.0;
        var beginTime = osg.Timer.instance().tick();
        var that = this;
        var removedChildren = [];
        var expiredPagedLODVisitor = new PointCloudExpirePagedLODVisitor();

        this._activePagedLODList.forEach( function ( plod ) {
            // Check if we have time, else return 0
            //if ( elapsedTime > availableTime ) return 0.0;
            if ( numToPrune < 0 ) return availableTime;
            // See if plod is still active, so we don't have to prune
            if ( expiryFrame < plod.getFrameNumberOfLastTraversal() ) return availableTime;
            expiredPagedLODVisitor.removeExpiredChildrenAndFindPagedLODs( plod, expiryTime, expiryFrame, removedChildren );
            for ( var i = 0; i < expiredPagedLODVisitor._childrenList.length; i++ ) {
                that._activePagedLODList.delete( expiredPagedLODVisitor._childrenList[ i ] );
                numToPrune--;
            }
            // Add to the remove list all the childs deleted
            for ( i = 0; i < removedChildren.length; i++ ) {
                that._childrenToRemoveList.add( removedChildren[ i ] );
            }
            expiredPagedLODVisitor._childrenList.length = 0;
            removedChildren.length = 0;
            elapsedTime = osg.Timer.instance().deltaS( beginTime, osg.Timer.instance().tick() );
        } );
        availableTime -= elapsedTime;
        return availableTime;
    },

    isIdle: function () {
        return this._pendingRequests.length === 0 && this._pendingNodes.length === 0 && this._downloadingRequestsNumber === 0;
    }

} );

module.exports = PointCloudDBPager;


/***/ }),

/***/ "./sources/pcvizDB/PointVisibilityManagerController.js":
/*!*************************************************************!*\
  !*** ./sources/pcvizDB/PointVisibilityManagerController.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointVisibilityManagerController; });
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__);


/**
 * A controller to manage the point visibility manager.
 * @class
 * @memberof pcvizDB
 */
class PointVisibilityManagerController extends pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._geomToProcess = new Map();
        this._geomToUpdate = [];
        this._processMutex = false;
    }

    pushNodeToProcess( id, geom ) {
        let geomList = this.getGeomToProcess( id );
        if ( !geomList ) {
            geomList = [];
        }
        geomList.push( geom );
        this._geomToProcess.set( id, geomList );
    }

    pushNodeToUpdate( geom ) {
        this._geomToUpdate.push( geom );
    }

    getGeomToProcess( id ) {
        return this._geomToProcess.get( id );
    }

    getGeomToUpdate() {
        return this._geomToUpdate;
    }

    clearGeomToProcess( id ) {
        if ( !id ) {
            this._geomToProcess.clear();
            return;
        }
        this._geomToProcess.delete( id );
    }

    clearGeomToUpdate() {
        this._geomToUpdate = [];
    }

    enableProcessGeometries() {
        this._processMutex = true;
        this.notifyProcessNewGeometries();
    }

    notifyProcessNewGeometries( id ) {
        if ( this._processMutex ) {
            this.notify( 'processGeometriesStacked', id );
        }
    }

    notifyVisibilityUpdated() {
        this.notify( 'visibilityUpdated' );
    }

    notifyUpdateGeometries() {
        this.notify( 'updateGeometriesStacked' );
    }

    notifyNewCloudSelection() {
        this.notify( 'onCloudSelection' );
    }

    /**
     * Adds a callback to be executed when notify is called.
     * @method
     * @memberof pcvizDB.PointVisibilityManagerController
     * @override
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @param {String} key The key of the preference associated with the callback.
     * @param {Function} fn The callback to be executed.
     * @param {String} id The callback identifier.
     */
    registerListener( level, key, fn, id ) {
        super.registerListener( level, {
            'key': key,
            'func': fn
        }, id );
    }

    /**
     * Executes the registered callbacks associated with the key indicated.
     * @method
     * @memberof pcvizDB.PointVisibilityManagerController
     * @override
     * @param {String} key The key of the preference whose callbacks have to be executed.
     * @param {Any} args All arguments passed to this function will be
     * forwarded to all listener functions.
     */
    notify( key, args ) {
        let keyListeners = this.getArrayFromListenerMap().filter( function ( listener ) {
            return listener.key === key;
        } );
        for ( let i = 0; i < keyListeners.length; i++ )
            keyListeners[ i ].func( args );
    }

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.VisibilityManagerController
     */
    reset() {
        super.reset();
        this.clearGeomToProcess();
        this.clearGeomToUpdate();
    }
}


/***/ }),

/***/ "./sources/pcvizDB/Registry.js":
/*!*************************************!*\
  !*** ./sources/pcvizDB/Registry.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Registry Base Class
 *  @class
 *  @memberof pcvizDB
 */
var Registry = {
    getInstance: function () {
        if ( !Registry.instance ) {
            Registry.instance = this;
            Registry.instance.controllers = new Map();
        }
        return Registry.instance;
    },

    registerController: function ( name, controllerClass ) {
        if ( !Registry.instance.controllers.get( name ) )
            Registry.instance.controllers.set( name, new controllerClass() );
    },

    getController: function ( name ) {
        return Registry.instance.controllers.get( name );
    },

    unregisterAllControllers: function () {
        Registry.instance.controllers.clear();
    },

    /**
     * Resets all controllers. Useful when loading a new project.
     * @method
     * @memberof pcvizDB.Registry
     */
    resetControllers: function () {
        Registry.instance.controllers.forEach( function ( controller ) {
            if ( controller.reset )
                controller.reset();
        } );
    }
};

module.exports = Registry;


/***/ }),

/***/ "./sources/pcvizDB/ScanSelectionController.js":
/*!****************************************************!*\
  !*** ./sources/pcvizDB/ScanSelectionController.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");




/**
 * A controller to manage the current station (or other selected objects) for the scan workflow.
 * @class
 * @memberof pcvizDB
 */
class ScanSelectionController extends pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._currentStation = undefined;
        this._scannerStatus = JSON.parse( window.localStorage.getItem( 'ngStorage-scannerStatus' ) );
        this.notify( 'scannerStatus' );
        this._scannerType = JSON.parse( window.localStorage.getItem( 'ngStorage-scannerType' ) );
    }

    getCurrentStation() {
        return this._currentStation;
    }

    // TODO check if station is uuid or object
    setCurrentStation( station ) {
        let previousCurrentStation = this._currentStation;
        this._currentStation = station;
        this.notify( 'currentStation', [ previousCurrentStation ] );
    }

    getCurrentStationLayer() {
        if ( !this._currentStation )
            return;

        let station = this.existsCurrentStationInWorkspace();
        if ( station ) // station can be undefined when just adding new station (because it is not in the workspace yet)
            return station.getLayerGroupObj();
    }


    getScannerStatus() {
        return this._scannerStatus;
    }

    setScannerStatus( status ) {
        this._scannerStatus = status;
        this.notify( 'scannerStatus' );
    }

    /**
     * Sets the scanner connected.
     * @method
     * @memberof pcvizDB.ScanSelectionController
     * @param {string} type the new scanner connected, it should be one of the defined by ScanSelectionController.SCANNER_TYPES
     */
    setScannerType( type ) {
        this._scannerType = type;
    }

    getScannerType() {
        return this._scannerType;
    }

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.ScanSelectionController
     */
    reset() {
        this._currentStation = undefined;
        this._scannerStatus = JSON.parse( window.localStorage.getItem( 'ngStorage-scannerStatus' ) );
        super.reset( this );
    }

    registerListener( level, fn, id, key ) {
        super.registerListener.call( this, level, {
            'key': key,
            'func': fn
        }, id );
    }

    notify( key, args ) {
        var keyListeners = this.getArrayFromListenerMap().filter( function ( listener ) {
            return listener.key === key;
        } );
        for ( var i = 0; i < keyListeners.length; i++ )
            keyListeners[ i ].func( args );
    }

    // returns the station workspace object if exists
    existsCurrentStationInWorkspace() {
        let stationCat = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__["default"].Station ).name;
        let stations = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );
        return stations.find( ( stationElement ) => {
            return stationElement._workspaceObj.uuid === this._currentStation;
        } );

    }

}

ScanSelectionController.SCANNER_TYPES = {
    GTL: 'GTL',
    GLS: 'GLS',
    GT: 'GT',
    RASTER: 'Raster', // Also called 'ESN'
    CRP1: 'CR-P1' // New scanner
};

/* harmony default export */ __webpack_exports__["default"] = (ScanSelectionController);


/***/ }),

/***/ "./sources/pcvizDB/SelectionController.js":
/*!************************************************!*\
  !*** ./sources/pcvizDB/SelectionController.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var pcvizUtils = __webpack_require__( /*! pcvizUtils/pcvizUtils */ "./sources/pcvizUtils/pcvizUtils.js" ).default;
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;

/**
 * A controller to manage the selected object.
 * @class
 * @memberof pcvizDB
 * @property {SelectionObject} _selectionObject The selected object.
 */
var SelectionController = function () {
    ListenerController.call( this );
    this._selectionObject = undefined;
};

SelectionController.prototype = osg.objectInherit( ListenerController.prototype, {

    createSelectionObject: function ( type ) {
        if ( this._selectionObject === undefined || this._selectionObject.getSelectionType() !== SelectionObject[ type ] ) {

            type = SelectionObject.getTypeFromString( type );
            switch ( type ) {
            case SelectionObject.PointCloud:
                this._selectionObject = new pcvizUtils.PointCloudSelectionObject();
                break;
            case SelectionObject.VectorLayer:
                this._selectionObject = new pcvizUtils.VectorLayerSelectionObject();
                break;
            case SelectionObject.RasterLayer:
                this._selectionObject = new pcvizUtils.RasterLayerSelectionObject();
                break;
            case SelectionObject.LayerGroup:
                this._selectionObject = new pcvizUtils.LayerGroupSelectionObject();
                break;
            }
        }
        this._selectionObject.clear();
        return this._selectionObject;
    },

    getSelectionObject: function () {
        return this._selectionObject;
    },

    setSelectionObject: function ( selectionObject ) {
        this._selectionObject = selectionObject;
        this.notify();
    },

    notify: function () {
        var self = this;
        if ( this._selectionObject !== undefined )
            ListenerController.prototype.notify.call( self, self._selectionObject );
    },

    /**
     * This function resets the controller in order to load properly a new project.
     * @method
     * @memberof pcvizDB.SelectionController
     */
    reset: function () {
        this._selectionObject = undefined;
        ListenerController.prototype.reset.call( this );
    }
} );

module.exports = SelectionController;


/***/ }),

/***/ "./sources/pcvizDB/Serializer.js":
/*!***************************************!*\
  !*** ./sources/pcvizDB/Serializer.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var string = String;

var Serializer = function () {
    this._u8array = undefined;
    this._goffset = 0;
    this._poffset = 0;
    this._littleEndian = !this.isBigEndian();
    this._view = undefined;
};

Serializer.prototype = {
    isBigEndian: function () {
        var a = new Uint8Array( [ 0x12, 0x34 ] );
        var b = new Uint16Array( a.buffer );
        return ( ( b[ 0 ] ).toString( 16 ) === '1234' );
    },
    setBuffer: function ( buffer ) {
        this._u8array = buffer;
        this._goffset = 0;
        this._poffset = 0;
        this._view = new DataView( buffer );
    },
    seekg: function ( offset ) {
        this._goffset = offset;
    },
    seekp: function ( offset ) {
        this._poffset = offset;
    },
    getg: function () {
        return this._goffset;
    },
    getp: function () {
        return this._poffset;
    },
    getByte: function () {
        return this._u8array[ this._goffset++ ];
    },
    isNotFinished: function () {
        return ( this._goffset < this._u8array.byteLength );
    },
    deserializeValue: function ( sizeInBytes ) {
        var value = 0;
        for ( var i = 0; i < sizeInBytes; i++ ) {
            var v = this.deserializeUint8Value();
            if ( !this._littleEndian )
                value |= ( v << 8 * ( sizeInBytes - i - 1 ) );
            else
                value |= ( v << 8 * i );
        }
        return value;
    },
    deserializeUint64Value: function () {
        return ( this.deserializeValue( 4 ) << 32 ) | this.deserializeValue( 4 );
    },
    deserializeUint32Value: function () {
        var value = this._view.getUint32( this._goffset, this._littleEndian );
        this._goffset += 4;
        return value;
    },
    deserializeUint16Value: function () {
        var value = this._view.getUint16( this._goffset, this._littleEndian );
        this._goffset += 2;
        return value;
    },
    deserializeUint8Value: function () {
        var value = this._view.getUint8( this._goffset, this._littleEndian );
        this._goffset += 1;
        return value;
    },
    deserializeFloat32Value: function () {
        var value = this._view.getFloat32( this._goffset, this._littleEndian );
        this._goffset += 4;
        return value;
    },
    deserializeFloat64Value: function () {
        var value = this._view.getFloat64( this._goffset, this._littleEndian );
        this._goffset += 8;
        return value;
    },
    deserializeString: function () {
        var stringLength = this.deserializeUint32Value();
        return this.deserializeStringArray( stringLength );
    },
    deserializeArray: function ( size ) {
        var array = new Uint8Array( this._u8array.slice( this._goffset, this._goffset + size ) );
        this._goffset += size;
        return array;
    },
    deserializeStringArray: function ( size ) {
        var str = this._arrayToString( size );
        this._goffset += size;
        return str;
    },
    _arrayToString: function ( size ) {

        var str = '';
        for ( var i = this._goffset, len = this._goffset + size; i < len; i++ ) {
            str += string.fromCharCode( this._view.getUint8( i ) );
        }
        return str;
    },
    deserializeString0: function () { // for 0-delimited strings
        var str = '';
        for ( var i = this._goffset; i < this._u8array.byteLength; i++ ) {
            var c = this._view.getUint8( i );
            this._goffset++;
            if ( c === 0 )
                break;
            str += string.fromCharCode( c );
        }
        return str;
    },
    deserialize0Array16: function () { // for 0-delimited arrays
        var cArray = [];
        for ( var i = this._goffset; i < this._u8array.byteLength; i += 2 ) {
            var c1 = this._view.getUint8( i );
            var c2 = this._view.getUint8( i + 1 );
            this._goffset += 2;
            if ( c1 === 0 && c2 === 0 )
                break;
            cArray.push( c1 );
            cArray.push( c2 );
        }
        return cArray;
    }
};

module.exports = Serializer;


/***/ }),

/***/ "./sources/pcvizDB/SymbolController.js":
/*!*********************************************!*\
  !*** ./sources/pcvizDB/SymbolController.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A singleton controller to register symbols to views
 * @class
 * @memberof pcvizDB
 */
var SymbolController = function () {
    this._views = new Map();
};

SymbolController.prototype = {

    /**
     * Registers a symbol to a view
     * @method
     * @memberof pcvizDB.SymbolController
     * @param {String} viewName The view name.
     * @param {String} symbolName The symbol name.
     * @param {LayerRenderer} symbolClass The symbol class to be registered;
     */
    registerSymbol: function ( viewName, symbolName, symbolClass ) {
        if ( !this._views.has( viewName ) ) {
            this._views.set( viewName, new Map() );
        }
        this._views.get( viewName ).set( symbolName, symbolClass );
    },

    /**
     * Return a symbol instance of the registered symbol in the indicated view.
     * @method
     * @memberof pcvizDB.SymbolController
     * @param  {String} viewName   The view name.
     * @param  {String} symbolName The symbol name.
     * @return {LayerRenderer}            The symbol instance used to render features.
     */
    getSymbol: function ( viewName, symbolName ) {
        if ( this._views.has( viewName ) && this._views.get( viewName ).has( symbolName ) ) {
            var symbolClass = this._views.get( viewName ).get( symbolName );
            return new symbolClass();
        } else {
            throw 'Symbol not registered';
        }
    },

    /**
     * This function resets the controller in order to load properly a new project.
     * FIXME: This function doesn't work as expected. Each 'symbolClass' doesn't have the reset method. They are not an instance of the relative symbol class.
     * To get an instance you should call to getSymbol (with the according key) but this function would create a new instance, so if you want to reset the
     * instances that were created in the renderers, you can't do it nowadays here.
     * Note that this function is used to reset the panorama and planar image symbols.
     * @method
     * @memberof pcvizDB.SymbolController
     */
    reset: function () {
        this._views.forEach( function ( view ) {
            view.forEach( function ( symbolClass ) {
                if ( symbolClass.reset )
                    symbolClass.reset();
            } );
        } );
        this._views.clear();
    }
};

module.exports = SymbolController;


/***/ }),

/***/ "./sources/pcvizDB/TargetColorManager.js":
/*!***********************************************!*\
  !*** ./sources/pcvizDB/TargetColorManager.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TargetColorManager; });
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");



class TargetColorManager {
    constructor() {
        this._view = undefined;
        this._isInitiated = false;
        this._registrationObject = undefined;
    }

    isInitiated() {
        return this._isInitiated;
    }

    init( workflow, view ) {
        this._view = view;

        this._registrationObject = workflow.getRegistrationObject();

        this._isInitiated = true;
    }

    updateAllTargetLayers() {
        const targetLayers = this._view.getProject().getAllLayers().filter( ( layer ) => pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTargetLayer( layer ) );
        targetLayers.forEach( ( layer ) => {
            this.updateTargetColor( layer );
        } );
    }

    updateTargetColor( targetLayer ) {
        if ( !targetLayer.isOpen() ) {
            return;
        }

        let stationLayer = targetLayer.getParent();
        if ( stationLayer.getCategory() !== 'Station' ) {
            return;
        }

        const stationSurveyRegistrationInfo = this.getStationSurveyRegistration( stationLayer );
        let style = targetLayer.getStyle();
        let currentColor = this.getPointStyleColor( style );

        let newColor = this.getTargetColor( stationSurveyRegistrationInfo ? stationSurveyRegistrationInfo.rmsValue : undefined );
        newColor[ 3 ] = currentColor[ 3 ];
        this.setPointStyleColor( style, newColor, targetLayer );

        targetLayer.updateSymbolRendererAndRefreshLayerInViews();
    }

    getPointStyleColor( style ) {
        let color = style.PointSymbolizer.color;
        if ( style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
            color = style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color;
        }
        return color;
    }

    setPointStyleColor( style, color, layer ) {
        style.PointSymbolizer.color = color;
        if ( style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
            style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color = color;
        }
        layer.setStyle( style );
        layer.commitChanges( true, this._view.getProject() );
    }

    getStationSurveyRegistration( stationLayer ) {
        const stationSurveyRegistrationInfo = stationLayer.getWorkspaceObject().surveyRegistrationInfo;
        return stationSurveyRegistrationInfo;
    }

    getTargetColor( value ) {
        // lowTarget & highTarget will be initialized by the UI (collage-front) when finishing importation process.
        const low = this._registrationObject.lowTarget;
        const high = this._registrationObject.highTarget;
        const type = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getRegistrationColorType( value, low, high );
        return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.REGISTRATION_COLOR[ type ];
    }
}


/***/ }),

/***/ "./sources/pcvizDB/UnitController.js":
/*!*******************************************!*\
  !*** ./sources/pcvizDB/UnitController.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" ); // This is necessary to use the decimals User Preference
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" ); // This is necessary to use the decimals User Preference

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;

/**
 * This controller is used to manage the units
 * @class
 * @memberof pcvizDB
 * @extends ListenerController
 * @property {Map} _currentUnit The current units used in the app.
 * @property {Object} _unitTextsTranslations The translations for the unit short labels.
 */
var UnitController = function () {
    ListenerController.call( this );

    this._currentUnits = new Map();

    this._unitTextsTranslations = {
        'UNIT_SERVICE': {
            'MM': 'mm',
            'CM': 'cm',
            'M': 'm',
            'KM': 'km',
            'INCHES': 'in',
            'INTERNATIONAL_FEET': 'ift',
            'US_FEET': 'sft',
            'YARD': 'yd',
            'MILE': 'mi',

            'MM2': 'mm²',
            'CM2': 'cm²',
            'M2': 'm²',
            'KM2': 'km²',
            'INCHES2': 'sq in',
            'INTERNATIONAL_FEET2': 'sq ift',
            'US_FEET2': 'sq sft',
            'YARD2': 'sq yd',
            'MILE2': 'sq mi',

            'MM3': 'mm³',
            'CM3': 'cm³',
            'M3': 'm³',
            'KM3': 'km³',
            'INCHES3': 'cu in',
            'INTERNATIONAL_FEET3': 'cu ift',
            'US_FEET3': 'cu sft',
            'YARD3': 'cu yd',
            'MILE3': 'cu mi'
        }
    };

    this.init();
};

// ids
UnitController.MILIMETERS = 'mm';
UnitController.CENTIMETERS = 'cm';
UnitController.METERS = 'm';
UnitController.KILOMETERS = 'km';
UnitController.INCHES = 'in';
UnitController.INTERNATIONAL_FEET = 'ift';
UnitController.US_FEET = 'sft';
UnitController.YARDS = 'yd';
UnitController.MILES = 'mi';

// types
UnitController.DISTANCE_TYPE = 'distance';
UnitController.AREA_TYPE = 'area';
UnitController.VOLUME_TYPE = 'volume';

UnitController.AREA_POW = 2;
UnitController.VOLUME_POW = 3;

// unit conversor
UnitController.conversionFactor = {
    [ UnitController.MILIMETERS ]: 0.001,
    [ UnitController.CENTIMETERS ]: 0.01,
    [ UnitController.METERS ]: 1,
    [ UnitController.KILOMETERS ]: 1000,
    [ UnitController.INCHES ]: 0.0254,
    [ UnitController.INTERNATIONAL_FEET ]: 0.3048,
    [ UnitController.US_FEET ]: 0.3048006096,
    [ UnitController.YARDS ]: 0.9144,
    [ UnitController.MILES ]: 1609.344,
};

UnitController._distanceUnits = [ {
    id: UnitController.MILIMETERS,
    label: 'UNIT_SERVICE.MM_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.MILIMETERS ],
    text: 'MM',
    mapScale: 'metric',
    precision: 4 // this is for the decimal part
}, {
    id: UnitController.CENTIMETERS,
    label: 'UNIT_SERVICE.CM_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.CENTIMETERS ],
    text: 'CM',
    mapScale: 'metric',
    precision: 4
}, {
    id: UnitController.METERS,
    label: 'UNIT_SERVICE.M_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.METERS ],
    text: 'M',
    mapScale: 'metric',
    precision: 4
}, {
    id: UnitController.KILOMETERS,
    label: 'UNIT_SERVICE.KM_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.KILOMETERS ],
    text: 'KM',
    mapScale: 'metric',
    precision: 4
}, {
    id: UnitController.INCHES,
    label: 'UNIT_SERVICE.INCHES_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.INCHES ],
    text: 'INCHES',
    mapScale: 'us',
    precision: 4
}, {
    id: UnitController.INTERNATIONAL_FEET,
    label: 'UNIT_SERVICE.INTERNATIONAL_FEET_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.INTERNATIONAL_FEET ],
    text: 'INTERNATIONAL_FEET',
    mapScale: 'us',
    precision: 4
}, {
    id: UnitController.US_FEET,
    label: 'UNIT_SERVICE.US_FEET_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.US_FEET ],
    text: 'US_FEET',
    mapScale: 'us',
    precision: 10
}, {
    id: UnitController.YARDS,
    label: 'UNIT_SERVICE.YARD_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.YARDS ],
    text: 'YARD',
    mapScale: 'us',
    precision: 4
}, {
    id: UnitController.MILES,
    label: 'UNIT_SERVICE.MILE_LONG',
    fromMeters: UnitController.conversionFactor[ UnitController.MILES ],
    text: 'MILE',
    mapScale: 'us',
    precision: 4
} ];

UnitController._areaUnits = [ {
    id: UnitController.MILIMETERS,
    label: 'UNIT_SERVICE.MM2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.MILIMETERS ], UnitController.AREA_POW ),
    text: 'MM2',
    precision: 4 // this is for the decimal part
}, {
    id: UnitController.CENTIMETERS,
    label: 'UNIT_SERVICE.CM2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.CENTIMETERS ], UnitController.AREA_POW ),
    text: 'CM2',
    precision: 4
}, {
    id: UnitController.METERS,
    label: 'UNIT_SERVICE.M2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.METERS ], UnitController.AREA_POW ),
    text: 'M2',
    precision: 4
}, {
    id: UnitController.KILOMETERS,
    label: 'UNIT_SERVICE.KM2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.KILOMETERS ], UnitController.AREA_POW ),
    text: 'KM2',
    precision: 4
}, {
    id: UnitController.INCHES,
    label: 'UNIT_SERVICE.INCHES2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.INCHES ], UnitController.AREA_POW ),
    text: 'INCHES2',
    precision: 4
}, {
    id: UnitController.INTERNATIONAL_FEET,
    label: 'UNIT_SERVICE.INTERNATIONAL_FEET2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.INTERNATIONAL_FEET ], UnitController.AREA_POW ),
    text: 'INTERNATIONAL_FEET2',
    precision: 4
}, {
    id: UnitController.US_FEET,
    label: 'UNIT_SERVICE.US_FEET2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.US_FEET ], UnitController.AREA_POW ),
    text: 'US_FEET2',
    precision: 10
}, {
    id: UnitController.YARDS,
    label: 'UNIT_SERVICE.YARD2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.YARDS ], UnitController.AREA_POW ),
    text: 'YARD2',
    precision: 4
}, {
    id: UnitController.MILES,
    label: 'UNIT_SERVICE.MILE2_LONG',
    fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.MILES ], UnitController.AREA_POW ),
    text: 'MILE2',
    precision: 4
} ];


UnitController._volumeUnits = [ {
        id: UnitController.MILLIMETERS,
        label: 'UNIT_SERVICE.MM3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.MILIMETERS ], UnitController.VOLUME_POW ),
        text: 'MM3',
        precision: 4
    },
    {
        id: UnitController.CENTIMETERS,
        label: 'UNIT_SERVICE.CM3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.CENTIMETERS ], UnitController.VOLUME_POW ),
        text: 'CM3',
        precision: 4
    },
    {
        id: UnitController.METERS,
        label: 'UNIT_SERVICE.M3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.METERS ], UnitController.VOLUME_POW ),
        text: 'M3',
        precision: 4
    },
    {
        id: UnitController.KILOMETERS,
        label: 'UNIT_SERVICE.KM3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.KILOMETERS ], UnitController.VOLUME_POW ),
        text: 'KM3',
        precision: 4
    },
    {
        id: UnitController.INCHES,
        label: 'UNIT_SERVICE.INCHES3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.INCHES ], UnitController.VOLUME_POW ),
        text: 'INCHES3',
        precision: 4
    },
    {
        id: UnitController.INTERNATIONAL_FEET,
        label: 'UNIT_SERVICE.INTERNATIONAL_FEET3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.INTERNATIONAL_FEET ], UnitController.VOLUME_POW ),
        text: 'INTERNATIONAL_FEET3',
        precision: 4
    },
    {
        id: UnitController.US_FEET,
        label: 'UNIT_SERVICE.US_FEET3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.US_FEET ], UnitController.VOLUME_POW ),
        text: 'US_FEET3',
        precision: 10
    },
    {
        id: UnitController.YARDS,
        label: 'UNIT_SERVICE.YARD3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.YARDS ], UnitController.VOLUME_POW ),
        text: 'YARD3',
        precision: 4
    },
    {
        id: UnitController.MILES,
        label: 'UNIT_SERVICE.MILE3_LONG',
        fromMeters: Math.pow( UnitController.conversionFactor[ UnitController.MILES ], UnitController.VOLUME_POW ),
        text: 'MILE3',
        precision: 4
    }
];

UnitController.prototype = osg.objectInherit( ListenerController.prototype, {

    init: function () {
        // Sets the default values for units
        this._currentUnits.set( UnitController.DISTANCE_TYPE, UnitController._distanceUnits[ 2 ] );
        this._currentUnits.set( UnitController.AREA_TYPE, UnitController._areaUnits[ 2 ] );
        this._currentUnits.set( UnitController.VOLUME_TYPE, UnitController._volumeUnits[ 2 ] );
    },

    /**
     * Returns the current unit for a measure's type.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param  {String} key The measure's name
     * @return {Object}     The value of the unit for the given key.
     */
    getCurrentUnit: function ( key ) {
        return this._currentUnits.get( key );
    },
    /**
     * Returns an array-copy of application - distance units 
     * @method
     * @memberof pcvizDB.UserPreferencesController     
     * @return {Array}   Distance units array
     */
    getDistanceUnits: function () {
        return UnitController._distanceUnits.slice();
    },

    /**
     * Returns an array-copy of application - area units 
     * @method
     * @memberof pcvizDB.UserPreferencesController     
     * @return {Array}   Area units array
     */
    getAreaUnits: function () { return UnitController._areaUnits.slice(); },

    /**
     * Registers a unit in the controller.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param {String} key  The measure name.
     * @param {Object} unit The unit value.
     */
    registerUnit: function ( key, unit ) {
        this._currentUnits.set( key, unit );
        this.notify( key ); // notify that the units are changed (this can be moved to the functions that call to registerUnit)
    },

    /**
     * Adds a callback to be executed when notify is called.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @param {String} key The key of the preference associated with the callback.
     * @param {Function} cb The callback to be executed.
     */
    registerListener: function ( level, key, fn, id ) {
        ListenerController.prototype.registerListener.call( this, level, {
            'key': key,
            'func': fn
        }, id );
    },

    /**
     * Executes the registered callbacks associated with the key indicated.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @override
     * @param {String} key The key of the measure whose callbacks have to be executed.
     */
    notify: function ( key ) {
        var keyListeners = this.getArrayFromListenerMap().filter( function ( listener ) {
            return listener.key === key;
        } );
        for ( var i = 0; i < keyListeners.length; i++ )
            keyListeners[ i ].func( this._currentUnits.get( key ) );
    },

    getUnitDistanceByLabel: function ( label ) {
        return this.searchUnitByLabel( label, UnitController._distanceUnits );
    },

    getUnitDistance: function ( id ) {
        return this.searchUnit( id, UnitController._distanceUnits );
    },

    convertFloatArrayToDistanceUnit: function ( floatArray ) {
        var currentUnit = this.getCurrentUnit( UnitController.DISTANCE_TYPE );
        if ( currentUnit.id === UnitController.METERS )
            return;
        for ( var i = 0, len = floatArray.length; i < len; i++ ) {
            floatArray[ i ] = ( floatArray[ i ] / currentUnit.fromMeters );
        }
    },

    convertPointArrayToDistanceUnit: function ( floatArray, arrayDimension ) {
        var currentUnit = this.getCurrentUnit( UnitController.DISTANCE_TYPE );
        if ( currentUnit.id === UnitController.METERS )
            return;
        floatArray.forEach( function ( point ) {
            for ( var dim = 0; dim < arrayDimension; dim++ ) {
                point[ dim ] = ( point[ dim ] / currentUnit.fromMeters );
            }
        } );
    },

    convertToDistanceUnitWithoutLabel: function ( value ) {
        var currentUnit = this.getCurrentUnit( UnitController.DISTANCE_TYPE );
        var to = parseFloat( currentUnit.fromMeters );
        var result = value;
        if ( currentUnit.id !== UnitController.METERS )
            result = value / to;
        return result;
    },

    convertFromDistanceUnitWithoutLabel: function ( value ) {
        var currentUnit = this.getCurrentUnit( UnitController.DISTANCE_TYPE );
        var to = parseFloat( currentUnit.fromMeters );
        var result = value;
        if ( currentUnit.id !== UnitController.METERS )
            result = value * to;
        return result;
    },

    getUnitAreaByLabel: function ( label ) {
        return this.searchUnitByLabel( label, UnitController._areaUnits );
    },

    getUnitArea: function ( id ) {
        return this.searchUnit( id, UnitController._areaUnits );
    },

    getUnitVolumeByLabel: function ( label ) {
        return this.searchUnitByLabel( label, UnitController._volumeUnits );
    },

    getUnitVolume: function ( id ) {
        return this.searchUnit( id, UnitController._volumeUnits );
    },

    // Convert to Units function by type (Distance, Area, Volume)
    convertToUserUnit: function ( value, measureType ) {
        const currentUnit = this.getCurrentUnit( measureType );
        const unitText = this._unitTextsTranslations[ 'UNIT_SERVICE' ][ currentUnit.text ];
        if ( value === undefined ) {
            return `-- ${unitText}`;
        }
        const to = parseFloat( currentUnit.fromMeters );
        let result = parseFloat( value );
        if ( currentUnit.id !== UnitController.METERS )
            result = ( parseFloat( value ) / to );
        const resultFormatted = result.toFixed( Registry.getController( 'UserPreferences' ).getPreference( Utils.NUMBER_OF_DECIMALS_KEY ) );
        return `${resultFormatted} ${unitText}`;
    },

    // Distance function
    convertToDistanceUnit: function ( value ) {
        return this.convertToUserUnit( value, UnitController.DISTANCE_TYPE );
    },

    // Area function
    convertToAreaUnit: function ( value ) {
        return this.convertToUserUnit( value, UnitController.AREA_TYPE );
    },

    // Volume function
    convertToVolumeUnit: function ( value ) {
        return this.convertToUserUnit( value, UnitController.VOLUME_TYPE );
    },

    searchUnitByLabel: function ( label, units ) {
        return units.find( function ( unit ) {
            return ( unit.label === label );
        } );
    },

    searchUnit: function ( id, units ) {
        return units.find( function ( unit ) {
            return ( unit.id === id );
        } );
    },

    setCurrentUnitByLabel: function ( label, type ) {
        let unit;
        switch ( type ) {
        case UnitController.DISTANCE_TYPE:
            unit = this.getUnitDistanceByLabel( label );
            break;
        case UnitController.AREA_TYPE:
            unit = this.getUnitAreaByLabel( label );
            break;
        case UnitController.VOLUME_TYPE:
            unit = this.getUnitVolumeByLabel( label );
            break;
        default:
            console.error( 'Error. Incorrect units type used' );
            return;
        }
        this.registerUnit( type, unit );
    },


    setUnitTextsTranslations: function ( unitTextsTranslations ) {
        this._unitTextsTranslations = unitTextsTranslations;
    },

    convertToCustomUnit: function ( value, unitId ) {
        var customUnit = this.searchUnit( unitId, UnitController._distanceUnits );
        var to = parseFloat( customUnit.fromMeters );
        var result = value;
        if ( customUnit.id !== UnitController.METERS )
            result = value / to;
        return result;
    },

    convertFromCustomUnit: function ( value, unitId ) {
        var customUnit = this.searchUnit( unitId, UnitController._distanceUnits );
        var to = parseFloat( customUnit.fromMeters );
        var result = value;
        if ( customUnit.id !== UnitController.METERS )
            result = value * to;
        return result;
    }

    // TODO: We could implement getCurrentDistanceUnit, getCurrentAreaUnit

} );

module.exports = UnitController;


/***/ }),

/***/ "./sources/pcvizDB/UploadController.js":
/*!*********************************************!*\
  !*** ./sources/pcvizDB/UploadController.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");
/* harmony import */ var pcvizDataAccess_Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/Uploaders/FileUploader */ "./sources/pcvizDataAccess/Uploaders/FileUploader.js");





const MAX_CHUNK_SIZE = 5242880;
const MS_PER_DAY = 1000 * 60 * 60 * 24;

//TODO. Solve the input/output from internal jobs array and external config.upload object 
class UploadController {
    constructor() {
        this._uploadQueue = [];
        this._uploadJobs = []; // store external 'config' uploads

        this._getUploadJobs = () => {
            return JSON.parse( localStorage.getItem( 'ngStorage-uploadJobs' ) );
        };

        this._storeNewJob = ( job ) => {
            let localStorageJobs = this._getUploadJobs();
            localStorageJobs.push( job );
            this._setUploadJobs( localStorageJobs );
        };

        this._setUploadJobs = ( localStorageJobs ) => {
            localStorage.setItem( 'ngStorage-uploadJobs', JSON.stringify( localStorageJobs ) );
        };

        if ( !this._getUploadJobs() )
            this._setUploadJobs( [] );
    }

    sendUploadToQueue( job ) {
        this._uploadQueue.push( job );
    }

    // job is an external 'config' object {...,  upload:{} }
    pushUploadJob( job ) {
        this._uploadJobs.push( job );
        this._storeNewJob( job.upload );
    }

    removeUploadJob( job ) {
        const queuedJobIndex = this._uploadJobs.findIndex( function ( uploadJob ) {
            return job.uploadId === uploadJob.upload.uploadId;
        } );
        if ( queuedJobIndex !== -1 ) {
            this._uploadJobs.splice( queuedJobIndex, 1 );
        }
        this.removeInLocalStorage( job );
    }

    removeFromQueue( job ) {
        const queuedJobIndex = this._uploadQueue.indexOf( job );
        if ( queuedJobIndex !== -1 ) {
            this._uploadQueue.splice( queuedJobIndex, 1 );
        }
    }

    removeInLocalStorage( job ) {
        let localStorageJobs = this._getUploadJobs();

        const elementIndex = localStorageJobs.findIndex( function ( uploadJob ) {
            return uploadJob.uploadId === job.uploadId;
        } );
        if ( elementIndex !== -1 )
            localStorageJobs.splice( elementIndex, 1 );

        this._setUploadJobs( localStorageJobs );
    }

    checkQueuedUploads() {
        const job = this._uploadQueue.shift();
        if ( job ) {
            // TODO: Call resume in job object when Job class is implemented
            let cb = job.resumeCallback;
            job.resumeCallback = undefined;

            if ( cb )
                cb();
        }
    }

    isCurrentlyUploading() {
        return this._getUploadJobs().some( function ( job ) {
            return ( job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].UPLOADING || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].PAUSED ) && ( job.updatedAt && job.updatedAt > ( Date.now() - 10000 ) );
        } );
    }

    isCurrentlyPending() {
        return this._getUploadJobs().some( function ( job ) {
            return job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].QUEUED;
        } );
    }

    updateInLocalStorage( job ) {
        let localStorageJobs = this._getUploadJobs();

        const elementIndex = localStorageJobs.findIndex( function ( uploadJob ) {
            return uploadJob.id === job.id;
        } );
        localStorageJobs[ elementIndex ] = job;
        this._setUploadJobs( localStorageJobs );
    }

    jobExists( config ) {
        return this._getUploadJobs().some( function ( job ) {
            return config.uploadId === job.uploadId;
        } );
    }

    // This function returns the job from localStorage
    jobExistsId( config ) {

        // We need to find the uploadJob from the array because we need the 'pause', 'cancel' and 'resume' functions
        const uploadJob = this._uploadJobs.find( function ( job ) {
            return config.id === job.upload.id;
        } );
        if ( uploadJob ) {
            let jobInLocalStorage = this._getUploadJobs().find( function ( job ) {
                return config.id === job.id;
            } );
            if ( jobInLocalStorage ) {
                jobInLocalStorage.pause = uploadJob.upload.pause;
                jobInLocalStorage.cancel = uploadJob.upload.cancel;
                jobInLocalStorage.resume = uploadJob.upload.resume;
                return jobInLocalStorage;
            }
        }
    }

    getJob( uploadId ) {
        return this._getUploadJobs().find( function ( job ) {
            return job.uploadId === uploadId;
        } );
    }

    getJobs() {
        let copyUploadJobs = this._getUploadJobs().slice();
        copyUploadJobs = copyUploadJobs.filter( function ( job ) {
            return ( Date.now() - new Date( job.createdAt ) <= MS_PER_DAY * 3 );
        } );
        this._setUploadJobs( copyUploadJobs );

        this._uploadJobs = this._uploadJobs.filter( function ( job ) {
            return ( Date.now() - new Date( job.upload.createdAt ) <= MS_PER_DAY * 3 );
        } );
        // We return the array to not miss the object connection
        return this._uploadJobs;
    }

    getCurrentUploadingSessionId() {
        const job = this._getUploadJobs().find( function ( job ) {
            return job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].UPLOADING || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].PAUSED;
        } );
        return job ? job.sessionId : null;
    }

    initUploadJobsFromLocalStorage() {
        let self = this;
        this._getUploadJobs().forEach( ( job ) => {
            if ( job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].UPLOADING || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].QUEUED || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].PAUSED || !job.status ) {
                if ( ( job.sessionId === window.sessionStorage.tabId ) || ( !job.updatedAt || job.updatedAt < ( Date.now() - 10000 ) ) )
                    job.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].INCOMPLETE;
            }

            if ( job.filesInfo )
                job.filesInfo.forEach( self.updateProgress );
            self.updateJobProgress( job );

            self._uploadJobs.push( {
                upload: job
            } );

            let fileUploader = new pcvizDataAccess_Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_1__["default"]( { 'upload': job } );
            job.cancel = fileUploader.cancel.bind( fileUploader );

            if ( job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].PAUSED )
                job.resume = fileUploader.resume.bind( fileUploader );

            this.updateInLocalStorage( job );
        } );

        setTimeout( () => {
            this._getUploadJobs().forEach( ( job ) => {
                if ( ( !job.updatedAt || job.updatedAt < ( Date.now() - 6000 ) ) && ( job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].UPLOADING || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].QUEUED || job.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].PAUSED || !job.status ) ) {
                    job.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_0__["default"].INCOMPLETE;
                    this.updateInLocalStorage( job );
                }
            } );
        }, 6000 );
    }

    updateProgress( fileInfo ) {
        if ( fileInfo.progress >= 100 )
            return;
        if ( !fileInfo.progressParts )
            return;
        let progress = 0;
        fileInfo.progressParts.forEach( function ( partProgress, index, array ) {
            if ( partProgress !== MAX_CHUNK_SIZE && index !== fileInfo.totalParts )
                array[ index ] = 0;
            progress += array[ index ];
        } );
        fileInfo.progress = ( progress / fileInfo.size ) * 100;
    }

    updateJobProgress( job ) {
        if ( job.progress >= 100 )
            return;
        let progress = 0;
        if ( job.filesInfo ) {
            job.filesInfo.forEach( function ( fileInfo ) {
                progress += fileInfo.progress || 0;
            } );
            job.progress = progress / job.filesInfo.length;
        } else
            job.progress = 0;
    }

    getJobProgress( jobId ) {
        const job = this._getUploadJobs().find( function ( job ) {
            return job.uploadId && job.uploadId === jobId;
        } );

        return job ? job.progress : undefined;
    }

    getJobStatus( jobId ) {
        const job = this._uploadJobs.find( function ( job ) {
            return job.upload.uploadId && job.upload.uploadId === jobId;
        } );

        return job ? job.upload.status : undefined;
    }

}

/* harmony default export */ __webpack_exports__["default"] = (UploadController);


/***/ }),

/***/ "./sources/pcvizDB/UserPreferencesController.js":
/*!******************************************************!*\
  !*** ./sources/pcvizDB/UserPreferencesController.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var pcvizDBUtils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;

/**
 * This controller is used to manage the user preferences
 * @class
 * @memberof pcvizDB
 * @extends ListenerController
 * @property {Map} _preferences The user preferences.
 * @property {Array<Object>} _listeners A list of callbacks that may be executed when the notify function is called.
 */
var UserPreferencesController = function () {
    ListenerController.call( this );
    this._preferences = new Map();
    this.init();
};

UserPreferencesController.prototype = osg.objectInherit( ListenerController.prototype, {

    _getFromLocalStorage: function ( key ) {
        key = 'ngStorage-' + key;
        var value = window.localStorage.getItem( key );
        return typeof value === 'string' ? JSON.parse( value ) : value;
    },

    _setToLocalStorage: function ( key, value ) {
        key = 'ngStorage-' + key;
        window.localStorage.setItem( key, JSON.stringify( value ) );
    },

    init: function () {
        if ( !this._getFromLocalStorage( pcvizDBUtils.SELECTION_COLOR_KEY ) )
            this._setToLocalStorage( pcvizDBUtils.SELECTION_COLOR_KEY, pcvizDBUtils.DEFAULT_SELECTION_COLOR );
        this.registerPreference( pcvizDBUtils.SELECTION_COLOR_KEY, this._getFromLocalStorage( pcvizDBUtils.SELECTION_COLOR_KEY ) );

        if ( !this._getFromLocalStorage( pcvizDBUtils.BACKGROUND_COLOR_KEY ) ) {
            this._setToLocalStorage( pcvizDBUtils.BACKGROUND_COLOR_KEY, pcvizDBUtils.DEFAULT_BACKGROUND_COLOR );
        }
        this.registerPreference( pcvizDBUtils.BACKGROUND_COLOR_KEY, this._getFromLocalStorage( pcvizDBUtils.BACKGROUND_COLOR_KEY ) );
        this.notify( pcvizDBUtils.BACKGROUND_COLOR_KEY );

        if ( !this._getFromLocalStorage( pcvizDBUtils.SECTION_BACKGROUND_COLOR_KEY ) ) {
            this._setToLocalStorage( pcvizDBUtils.SECTION_BACKGROUND_COLOR_KEY, pcvizDBUtils.DEFAULT_SECTION_BACKGROUND_COLOR );
        }
        this.registerPreference( pcvizDBUtils.SECTION_BACKGROUND_COLOR_KEY, this._getFromLocalStorage( pcvizDBUtils.SECTION_BACKGROUND_COLOR_KEY ) );
        this.notify( pcvizDBUtils.SECTION_BACKGROUND_COLOR_KEY );

        if ( !this._getFromLocalStorage( pcvizDBUtils.SECTION_GRID_COLOR_KEY ) ) {
            this._setToLocalStorage( pcvizDBUtils.SECTION_GRID_COLOR_KEY, pcvizDBUtils.DEFAULT_SECTION_GRID_COLOR );
        }
        this.registerPreference( pcvizDBUtils.SECTION_GRID_COLOR_KEY, this._getFromLocalStorage( pcvizDBUtils.SECTION_GRID_COLOR_KEY ) );
        this.notify( pcvizDBUtils.SECTION_GRID_COLOR_KEY );

        if ( !this._getFromLocalStorage( pcvizDBUtils.PICKING_CIRCLE_COLOR_KEY ) )
            this._setToLocalStorage( pcvizDBUtils.PICKING_CIRCLE_COLOR_KEY, pcvizDBUtils.DEFAULT_PICKING_CIRCLE_COLOR );
        this.registerPreference( pcvizDBUtils.PICKING_CIRCLE_COLOR_KEY, this._getFromLocalStorage( pcvizDBUtils.PICKING_CIRCLE_COLOR_KEY ) );

        if ( !this._getFromLocalStorage( pcvizDBUtils.NUMBER_OF_DECIMALS_KEY ) )
            this._setToLocalStorage( pcvizDBUtils.NUMBER_OF_DECIMALS_KEY, pcvizDBUtils.DEFAULT_NUMBER_OF_DECIMALS );
        this.registerPreference( pcvizDBUtils.NUMBER_OF_DECIMALS_KEY, this._getFromLocalStorage( pcvizDBUtils.NUMBER_OF_DECIMALS_KEY ) );

        if ( this._getFromLocalStorage( pcvizDBUtils.GRID_ON_KEY ) === null ) // we need to check "null", since it can also return a valid boolean value "false"
            this._setToLocalStorage( pcvizDBUtils.GRID_ON_KEY, false );
        this.registerPreference( pcvizDBUtils.GRID_ON_KEY, this._getFromLocalStorage( pcvizDBUtils.GRID_ON_KEY ) );

        if ( this._getFromLocalStorage( pcvizDBUtils.GRID_LABEL_ON_KEY ) === null ) // we need to check "null", since it can also return a valid boolean value "false"
            this._setToLocalStorage( pcvizDBUtils.GRID_LABEL_ON_KEY, false );
        this.registerPreference( pcvizDBUtils.GRID_LABEL_ON_KEY, this._getFromLocalStorage( pcvizDBUtils.GRID_LABEL_ON_KEY ) );

        if ( !this._getFromLocalStorage( pcvizDBUtils.LAYERS_ORDER ) )
            this._setToLocalStorage( pcvizDBUtils.LAYERS_ORDER, pcvizDBUtils.DEFAULT_LAYERS_ORDER );
        this.registerPreference( pcvizDBUtils.LAYERS_ORDER, this._getFromLocalStorage( pcvizDBUtils.LAYERS_ORDER ) );

        if ( !this._getFromLocalStorage( pcvizDBUtils.PROJECTS_ORDER ) )
            this._setToLocalStorage( pcvizDBUtils.PROJECTS_ORDER, pcvizDBUtils.DEFAULT_PROJECTS_ORDER );
        this.registerPreference( pcvizDBUtils.PROJECTS_ORDER, this._getFromLocalStorage( pcvizDBUtils.PROJECTS_ORDER ) );

        if ( !this._getFromLocalStorage( pcvizDBUtils.PLANAR_IMAGE_DISTANCE_KEY ) )
            this._setToLocalStorage( pcvizDBUtils.PLANAR_IMAGE_DISTANCE_KEY, pcvizDBUtils.DEFAULT_PLANAR_IMAGE_DISTANCE );
        this.registerPreference( pcvizDBUtils.PLANAR_IMAGE_DISTANCE_KEY, this._getFromLocalStorage( pcvizDBUtils.PLANAR_IMAGE_DISTANCE_KEY ) );

        if ( ( pcvizDBUtils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) && pcvizDBUtils.isEdge() && MagnetAPI.isSite() ) {
            if ( !this._getFromLocalStorage( pcvizDBUtils.MOUSE_OR_TOUCH_KEY ) )
                this._setToLocalStorage( pcvizDBUtils.MOUSE_OR_TOUCH_KEY, pcvizDBUtils.DEFAULT_MOUSE_OR_TOUCH_KEY );
            this.registerPreference( pcvizDBUtils.MOUSE_OR_TOUCH_KEY, this._getFromLocalStorage( pcvizDBUtils.MOUSE_OR_TOUCH_KEY ) );
        }

        if ( MagnetAPI.isSite() ) {
            if ( !this._getFromLocalStorage( pcvizDBUtils.REGIST_ALGO_VER_KEY ) )
                this._setToLocalStorage( pcvizDBUtils.REGIST_ALGO_VER_KEY, pcvizDBUtils.DEFAULT_REGIST_ALGO_VER );
            this.registerPreference( pcvizDBUtils.REGIST_ALGO_VER_KEY, this._getFromLocalStorage( pcvizDBUtils.REGIST_ALGO_VER_KEY ) );

            /*
            if ( !this._getFromLocalStorage( pcvizDBUtils.USER_INTERFACE_VER_KEY ) )
                    this._setToLocalStorage( pcvizDBUtils.USER_INTERFACE_VER_KEY, pcvizDBUtils.DEFAULT_USER_INTERFACE_VER );
                this.registerPreference( pcvizDBUtils.USER_INTERFACE_VER_KEY, this._getFromLocalStorage( pcvizDBUtils.USER_INTERFACE_VER_KEY ) );
            */

            if ( ( this._getFromLocalStorage( pcvizDBUtils.DELETE_LAYERS_KEY ) ) === null )
                this._setToLocalStorage( pcvizDBUtils.DELETE_LAYERS_KEY, pcvizDBUtils.DEFAULT_DELETE_LAYERS );
            this.registerPreference( pcvizDBUtils.DELETE_LAYERS_KEY, this._getFromLocalStorage( pcvizDBUtils.DELETE_LAYERS_KEY ) );

            if ( ( this._getFromLocalStorage( pcvizDBUtils.BACKGROUND_PROCESSING_KEY ) ) === null )
                this._setToLocalStorage( pcvizDBUtils.BACKGROUND_PROCESSING_KEY, pcvizDBUtils.DEFAULT_BACKGROUND_PROCESSING );
            this.registerPreference( pcvizDBUtils.BACKGROUND_PROCESSING_KEY, this._getFromLocalStorage( pcvizDBUtils.BACKGROUND_PROCESSING_KEY ) );

            if ( ( this._getFromLocalStorage( pcvizDBUtils.VERITY_AS_BUILT_KEY ) ) === null )
                this._setToLocalStorage( pcvizDBUtils.VERITY_AS_BUILT_KEY, pcvizDBUtils.DEFAULT_VERITY_AS_BUILT );
            this.registerPreference( pcvizDBUtils.VERITY_AS_BUILT_KEY, this._getFromLocalStorage( pcvizDBUtils.VERITY_AS_BUILT_KEY ) );

            if ( ( this._getFromLocalStorage( pcvizDBUtils.VERITY_AS_DESIGN_KEY ) ) === null )
                this._setToLocalStorage( pcvizDBUtils.VERITY_AS_DESIGN_KEY, pcvizDBUtils.DEFAULT_VERITY_AS_DESIGN );
            this.registerPreference( pcvizDBUtils.VERITY_AS_DESIGN_KEY, this._getFromLocalStorage( pcvizDBUtils.VERITY_AS_DESIGN_KEY ) );

            if ( ( this._getFromLocalStorage( pcvizDBUtils.VERITY_SMARTPOINTS_KEY ) ) === null )
                this._setToLocalStorage( pcvizDBUtils.VERITY_SMARTPOINTS_KEY, pcvizDBUtils.DEFAULT_VERITY_SMARTPOINTS );
            let veritySmartpointsObj = this._getFromLocalStorage( pcvizDBUtils.VERITY_SMARTPOINTS_KEY );

            this.registerPreference( pcvizDBUtils.VERITY_HEATMAP_STEPS_KEY, veritySmartpointsObj[ pcvizDBUtils.VERITY_HEATMAP_STEPS_KEY ] );

            this.registerPreference( pcvizDBUtils.VERITY_HEATMAP_GRADIENT_STYLE_KEY, veritySmartpointsObj[ pcvizDBUtils.VERITY_HEATMAP_GRADIENT_STYLE_KEY ] );

            this.registerPreference( pcvizDBUtils.VERITY_HEATMAP_TOLERANCE_KEY, veritySmartpointsObj[ pcvizDBUtils.VERITY_HEATMAP_TOLERANCE_KEY ] );

            this.registerPreference( pcvizDBUtils.VERITY_HEATMAP_GRADIENT_RANGE_KEY, veritySmartpointsObj[ pcvizDBUtils.VERITY_HEATMAP_GRADIENT_RANGE_KEY ] );
        }

        this.registerPreference( pcvizDBUtils.BATTERY_SAVER, this._getFromLocalStorage( pcvizDBUtils.BATTERY_SAVER ) !== null ? this._getFromLocalStorage( pcvizDBUtils.BATTERY_SAVER ) : pcvizDBUtils.DEFAULT_BATTERY_SAVER );
        if ( this._getFromLocalStorage( pcvizDBUtils.AUTOMATIC_LOD_KEY ) === null )
            this._setToLocalStorage( pcvizDBUtils.AUTOMATIC_LOD_KEY, false ); // set by default to false
        this.registerPreference( pcvizDBUtils.AUTOMATIC_LOD_KEY, this._getFromLocalStorage( pcvizDBUtils.AUTOMATIC_LOD_KEY ) );
    },

    /**
     * Returns a preference by its key name.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param  {String} key The preference name
     * @return {Object}     The value of the preference which name is equall to key.
     */
    getPreference: function ( key ) {
        return this._preferences.get( key );
    },

    /**
     * Registers a preference in the controller.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param {String} key  The preference name.
     * @param {Object} preference The preference value.
     */
    registerPreference: function ( key, preference ) {
        this._preferences.set( key, preference );
    },

    /**
     * Adds a callback to be executed when notify is called.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @param  {Integer}   level The listener scope level. Use static variables: `ListenerController.APPLICATION` or `ListenerController.PROJECT`.
     * @param {String} key The key of the preference associated with the callback.
     * @param {Function} cb The callback to be executed.
     */
    registerListener: function ( level, key, fn, id ) {
        ListenerController.prototype.registerListener.call( this, level, {
            'key': key,
            'func': fn
        }, id );
    },

    /**
     * Executes the registered callbacks associated with the key indicated.
     * @method
     * @memberof pcvizDB.UserPreferencesController
     * @override
     * @param {String} key The key of the preference whose callbacks have to be executed.
     */
    notify: function ( key ) {
        var keyListeners = this.getArrayFromListenerMap().filter( function ( listener ) {
            return listener.key === key;
        } );
        for ( var i = 0; i < keyListeners.length; i++ )
            keyListeners[ i ].func( this._preferences.get( key ) );
    }
} );

module.exports = UserPreferencesController;


/***/ }),

/***/ "./sources/pcvizDB/Utils.js":
/*!**********************************!*\
  !*** ./sources/pcvizDB/Utils.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var earcut = __webpack_require__( /*! earcut */ "./node_modules/earcut/src/earcut.js" );

/**
 * Provide a set of utility functions
 * @class
 * @memberof pcvizDB
 */
var Utils = {};
var osg = OSG.osg;

Utils.TRAVERSAL_MASK_IV = 1 << 2;
Utils.VISIBILITY_MASK = 0xffffff;

// Default user preferences
Utils.DEFAULT_SELECTION_COLOR = osg.vec4.fromValues32( 212.0 / 255.0, 170.0 / 255.0, 0.0, 0.5 );
Utils.DEFAULT_BACKGROUND_COLOR = osg.vec4.fromValues32( 68 / 255, 68 / 255, 68 / 255, 1.0 );
Utils.DEFAULT_SECTION_BACKGROUND_COLOR = osg.vec4.fromValues32( 255 / 255, 255 / 255, 255 / 255, 1.0 );
Utils.DEFAULT_SECTION_GRID_COLOR = '#808080';
Utils.DEFAULT_PICKING_CIRCLE_COLOR = '#0000FF';
Utils.DEFAULT_REPORT_PICK_POINT_COLOR = '#FF0000';
Utils.HEATMAP_PICK_POINT_COLOR = '#00FFFF';
Utils.DEFAULT_NUMBER_OF_DECIMALS = 3;
Utils.DEFAULT_LAYERS_ORDER = '-created_at';
Utils.DEFAULT_PROJECTS_ORDER = ''; // This orders by last opened by default
Utils.DEFAULT_PLANAR_IMAGE_DISTANCE = 1.5;
Utils.TOUCH_PRIORITY = 0;
Utils.MOUSE_PRIORITY = 1;
Utils.DEFAULT_MOUSE_OR_TOUCH_KEY = Utils.TOUCH_PRIORITY;
Utils.OLD_ALGORITHMS = false;
Utils.NEW_ALGORITHMS = true;
Utils.DEFAULT_REGIST_ALGO_VER = Utils.OLD_ALGORITHMS;
Utils.CURRENT_UI = 'current';
Utils.NEW_UI = 'new';
Utils.DEFAULT_USER_INTERFACE_VER = Utils.CURRENT_UI;
Utils.DEFAULT_BATTERY_SAVER = false;
Utils.DEFAULT_DELETE_LAYERS = true;
Utils.DEFAULT_BACKGROUND_PROCESSING = true;
Utils.DEFAULT_VERITY_AS_BUILT = true;
Utils.DEFAULT_VERITY_AS_DESIGN = true;
Utils.DEFAULT_VERITY_HEATMAP_STEPS = 1;
Utils.DEFAULT_VERITY_HEATMAP_GRADIENT_STYLE = 0; // Smooth
Utils.DEFAULT_VERITY_HEATMAP_TOLERANCE = 0.012; // 12mm, 0.5in
Utils.DEFAULT_VERITY_HEATMAP_GRADIENT_RANGE = 1.0;

Utils.BOUNDING_FACTOR = 1;

// User preferences constants
Utils.SELECTION_COLOR_KEY = 'selectionColor';
Utils.BACKGROUND_COLOR_KEY = 'backgroundColor';
Utils.SECTION_BACKGROUND_COLOR_KEY = 'sectionBackgroundColor';
Utils.SECTION_GRID_COLOR_KEY = 'sectionGridColor';
Utils.PICKING_CIRCLE_COLOR_KEY = 'pickingCircleColor';
Utils.NUMBER_OF_DECIMALS_KEY = 'numberOfDecimals';
Utils.GRID_ON_KEY = 'gridOn';
Utils.GRID_LABEL_ON_KEY = 'gridLabelOn';
Utils.LAYERS_ORDER = 'layersOrder';
Utils.PROJECTS_ORDER = 'projectsOrder';
Utils.PLANAR_IMAGE_DISTANCE_KEY = 'planarImageDistance';
Utils.MOUSE_OR_TOUCH_KEY = 'mouseOrTouch';
Utils.REGIST_ALGO_VER_KEY = 'registrationAlgorithms';
Utils.USER_INTERFACE_VER_KEY = 'userInterface';
Utils.BATTERY_SAVER = 'batterySaver';
Utils.AUTOMATIC_LOD_KEY = 'automaticLOD';
Utils.DELETE_LAYERS_KEY = 'automaticDeleteOrphanLayers';
Utils.BACKGROUND_PROCESSING_KEY = 'backgroundProcessing';
Utils.VERITY_AS_BUILT_KEY = 'verityAsBuilt';
Utils.VERITY_AS_DESIGN_KEY = 'verityAsDesign';
Utils.VERITY_SMARTPOINTS_KEY = 'veritySmartpoints';
Utils.VERITY_HEATMAP_STEPS_KEY = 'heatmapSteps';
Utils.VERITY_HEATMAP_GRADIENT_STYLE_KEY = 'heatmapGradientStyle';
Utils.VERITY_HEATMAP_TOLERANCE_KEY = 'heatmapTolerance';
Utils.VERITY_HEATMAP_GRADIENT_RANGE_KEY = 'heatmapMultiplier';

Utils.DEFAULT_VERITY_SMARTPOINTS = {
    [ Utils.VERITY_HEATMAP_STEPS_KEY ]: Utils.DEFAULT_VERITY_HEATMAP_STEPS,
    [ Utils.VERITY_HEATMAP_GRADIENT_STYLE_KEY ]: Utils.DEFAULT_VERITY_HEATMAP_GRADIENT_STYLE,
    [ Utils.VERITY_HEATMAP_TOLERANCE_KEY ]: Utils.DEFAULT_VERITY_HEATMAP_TOLERANCE,
    [ Utils.VERITY_HEATMAP_GRADIENT_RANGE_KEY ]: Utils.DEFAULT_VERITY_HEATMAP_GRADIENT_RANGE
};

Utils.DEFAULT_EXTENT = [ -160, -100, -40, 160, 100, 40 ];

// Default symbolizers style properties
Utils.DEFAULT_POINTSYMBOLIZER_SIZE = 15.0;
Utils.DEFAULT_LINESYMBOLIZER_WIDTH = 5.0;
Utils.DEFAULT_ANNOTATION_COLOR = [ 65, 82, 181, 1.0 ]; //dark blue
Utils.DEFAULT_PANORAMA_COLOR = [ 37, 202, 74, 1.0 ]; //green
Utils.DEFAULT_TRAJECTORY_COLOR = [ 147, 16, 136, 1.0 ]; //purple
Utils.DEFAULT_PLANAR_IMAGE_COLOR = [ 145, 36, 13, 1.0 ]; //burgundy
Utils.DEFAULT_PLANAR_IMAGE_LINE_COLOR = [ 241, 160, 25, 1.0 ]; //yellow
Utils.DEFAULT_PLANAR_IMAGE_FILL_COLOR = [ 0, 147, 213, 1.0 ]; //light blue
Utils.DEFAULT_PLANAR_IMAGE_LINE_WIDTH = 2.0;
Utils.DEFAULT_CONTROL_POINT_COLOR = [ 238, 0, 4, 1.0 ]; // red
Utils.CONTROL_POINT_LABELS_COLOR = [ 255, 255, 255, 1.0 ];
Utils.DEFAULT_MODEL3D_COLOR = [ 255, 255, 255, 1.0 ];
Utils.DEFAULT_MACHINERY_COLOR = [ 255, 255, 255, 1.0 ];
Utils.DEFAULT_MACHINERY_SIZE = 40.0;
Utils.DEFAULT_SITE_POINT_COLOR = [ 238, 98, 4, 1.0 ]; // orange
Utils.DEFAULT_SITE_LINE_COLOR = [ 231, 101, 167, 1.0 ]; //pink
Utils.DEFAULT_SITE_POLYGON_COLOR = [ 67, 105, 12, 1.0 ]; //dark green
Utils.DEFAULT_SITE_MULTIPOINT_COLOR = [ 118, 71, 23, 1.0 ]; //brown
Utils.DEFAULT_SITE_PANORAMA_COLOR = [ 139, 41, 209, 1.0 ]; //blueviolet

Utils.BACKGROUND_COLOR_SITE_C2C = [ 235, 235, 235, 1.0 ];

// Topcon Design System - Colors
Utils.DARK_YELLOW_3 = [ 0.945, 0.627, 0.098, 1 ];
Utils.LIGHT_BLUE_3 = [ 0, 0.576, 0.835, 1 ];

// Colors for tools
Utils.AREA_COLOR = [ 0.247, 0.318, 0.71, 0.5 ];

// Render bins (rendering order)
Utils.RENDERBIN_IMAGE_BACK = 8; // when image in back
Utils.RENDERBIN_IMAGE_BACK_TYPE = 'RenderBin';
Utils.RENDERBIN_3DMODEL = 9; // 3D Tiles/models
Utils.RENDERBIN_3DMODEL_TYPE = 'RenderBin';
Utils.RENDERBIN_SCENE_TYPE = 'RenderBin';
Utils.RENDERBIN_SCENE = 10; // point clouds
Utils.RENDERBIN_IMAGE_FRONT = 11; // when image in front
Utils.RENDERBIN_IMAGE_FRONT_TYPE = 'RenderBin';
Utils.RENDERBIN_SKETCH_PTS = 11;
Utils.RENDERBIN_SKETCH_PTS_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_SKETCH_LINES = 13;
Utils.RENDERBIN_SKETCH_LINES_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_STATION_MARKERSYMBOL = 90;
Utils.RENDERBIN_LINEARROWS = 100; // draws always
Utils.RENDERBIN_LINEARROWS_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_SYMBOL3D = 100; // draws always when selected
Utils.RENDERBIN_SYMBOL3D_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_MARKERSYMBOL3D = 101;
Utils.RENDERBIN_MARKERSYMBOL3D_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_SELECTED_VERT = 101;
Utils.RENDERBIN_SELECTED_VERT_TYPE = 'DepthSortedBin';
Utils.RENDERBIN_CUSTOMTEXT = 1000; // draws always in some cases
Utils.RENDERBIN_CUSTOMTEXT_DISTANCE = 1010; // above other texts
Utils.RENDERBIN_CUSTOMTEXT_ANGLE = 1020; // above measures if needed
Utils.RENDERBIN_CUSTOMTEXT_WHILE_MEASURING = 1030; // while measuring, above all previous measures or angles

Utils.RENDERBIN_CUSTOMTEXT_TYPE = 'DepthSortedBin';

Utils.RENDERBIN_CROSS_BOX = 10000;
Utils.RENDERBIN_CROSS_BOX_TYPE = 'DepthSortedBin';

Utils.GLOBAL_ZOOM = 'global';
Utils.TOP_GLOBAL_ZOOM = 'top_global';
Utils.FRONT_GLOBAL_ZOOM = 'front_global';
Utils.RIGHT_GLOBAL_ZOOM = 'right_global';
Utils.BOTTOM_GLOBAL_ZOOM = 'bottom_global';
Utils.BACK_GLOBAL_ZOOM = 'back_global';
Utils.LEFT_GLOBAL_ZOOM = 'left_global';

Utils.TOP_LOCAL_ZOOM = 'top_local';
Utils.FRONT_LOCAL_ZOOM = 'front_local';
Utils.RIGHT_LOCAL_ZOOM = 'right_local';
Utils.BOTTOM_LOCAL_ZOOM = 'bottom_local';
Utils.BACK_LOCAL_ZOOM = 'back_local';
Utils.LEFT_LOCAL_ZOOM = 'left_local';

Utils.TOP_VIEW = 'top_view';
Utils.FRONT_VIEW = 'front_view';
Utils.RIGHT_VIEW = 'right_view';
Utils.BOTTOM_VIEW = 'bottom_view';
Utils.BACK_VIEW = 'back_view';
Utils.LEFT_VIEW = 'left_view';
Utils.ISOMETRIC_VIEW = 'isometric_view';


// Automatic attributes for Vector layers
Utils.LENGTH_ATTR = 'length';
Utils.AREA_ATTR = 'area';
Utils.CENTROID_X_ATTR = 'centroid(x)';
Utils.CENTROID_Y_ATTR = 'centroid(y)';
Utils.CENTROID_Z_ATTR = 'centroid(z)';

// Page size for feature pagination
Utils.PAGE_SIZE = 100;
Utils.DEFAULT_PAGE_SIZE = 100;
Utils.VERITY_PAGE_SIZE = 5;

Utils.SCREENSHOT_WIDTH = 800;
Utils.SCREENSHOT_HEIGHT = 600;

Utils.RASTER_CW = 'CWXYZ';

Utils.CAMERA_PRE_RENDER = osg.Camera.PRE_RENDER;
Utils.TRANSFORM_ABSOLUTE_RF = osg.Transform.ABSOLUTE_RF;

Utils.SURFACE_RENDER_MODES = {
    SMOOTH: 0,
    FLAT: 1,
    WIREFRAME: 2
};

Utils.REGISTRATION_COLOR_TYPE = {
    NONE: 'none',
    HIGH: 'high',
    MEDIUM: 'medium',
    LOW: 'low',
    UNSELECTED: 'unselected'
};

Utils.REGISTRATION_COLOR = {
    none: [ 0.0, 0.0, 1.0, 1.0 ],
    high: [ 0.0, 1.0, 0.0, 1.0 ],
    medium: [ 1.0, 1.0, 0.0, 1.0 ],
    low: [ 1.0, 0.0, 0.0, 1.0 ],
    unselected: [ 0.5, 0.5, 0.5, 1.0 ]
};

Utils.lookUpClassification = function ( classId ) {
    var classNum = classId % 16;
    return 'CLASS_' + ( '0' + classNum ).slice( -2 );
};

Utils.isRelativeURL = function ( url ) {
    var r = new RegExp( '^(?:[a-z]+:)?//', 'i' );
    return !r.test( url );
};

Utils.sanitizeUrlInPlace = function ( url ) {
    return url.replace( /([^:]\/)\/+/g, '$1' );
};

Utils.getVariableFromURL = function ( name, defaultName ) {
    name = name.replace( /[\[]/, '\\[' ).replace( /[\]]/, '\\]' );
    var regex = new RegExp( '[\\?&]' + name + '=([^&#]*)' ),
        results = regex.exec( location.search );
    return results == null ? defaultName : decodeURIComponent( results[ 1 ].replace( /\+/g, ' ' ) );
};

Utils.createBoxFromExtent = function ( extent, color ) {
    const min = [ extent[ 0 ], extent[ 1 ], extent[ 2 ] ];
    const max = [ extent[ 3 ], extent[ 4 ], extent[ 5 ] ];

    // Calculate the 8 corners from the bounding box.
    const corner1 = osg.vec3.fromValues( min[ 0 ], min[ 1 ], min[ 2 ] );
    const corner2 = osg.vec3.fromValues( max[ 0 ], min[ 1 ], min[ 2 ] );
    const corner3 = osg.vec3.fromValues( max[ 0 ], max[ 1 ], min[ 2 ] );
    const corner4 = osg.vec3.fromValues( min[ 0 ], max[ 1 ], min[ 2 ] );
    const corner5 = osg.vec3.fromValues( min[ 0 ], min[ 1 ], max[ 2 ] );
    const corner6 = osg.vec3.fromValues( max[ 0 ], min[ 1 ], max[ 2 ] );
    const corner7 = osg.vec3.fromValues( max[ 0 ], max[ 1 ], max[ 2 ] );
    const corner8 = osg.vec3.fromValues( min[ 0 ], max[ 1 ], max[ 2 ] );

    const corners = [ corner1, corner2, corner3, corner4, corner5, corner6, corner7, corner8 ];

    return this.createGeometry3DBoundingBox( corners, color );
};

Utils.createBoxFromNode = function ( node, color ) {
    const corners = this.getTransformedBoundingBox( node, osg.mat4.create() );

    return this.createGeometry3DBoundingBox( corners, color );
};

Utils.getVertexShader = function () {
    return [
        '#ifdef GL_ES',
        '    precision highp float;',
        '#endif',
        'attribute vec3 Vertex;',
        'attribute vec4 Color;',
        'uniform mat4 uModelViewMatrix;',
        'uniform mat4 uProjectionMatrix;',
        '',
        'varying vec4 FragColor;',
        '',
        'void main(void) {',
        '    gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);',
        '    FragColor = Color;',
        '}'
    ].join( '\n' );
};

Utils.getFragmentShader = function () {
    return [
        '#ifdef GL_ES',
        '    precision highp float;',
        '#endif',
        'varying vec4 FragColor;',

        'void main(void) {',
        '    gl_FragColor = FragColor;',
        '}'
    ].join( '\n' );
};

Utils.createGeometry3DBoundingBox = function ( boxCorners, color ) {

    const vShader = this.getVertexShader();

    const fShader = this.getFragmentShader();

    const program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vShader ),
        new osg.Shader( 'FRAGMENT_SHADER', fShader ) );

    const vertices = new Float32Array( 3 * 8 );
    const colors = new Float32Array( 4 * 8 );

    if ( color === undefined ) {
        color = [ 1.0, 0.0, 0.0, 1.0 ]; // red by default
    }

    for ( let i = 0, j = 0, k = 0; i < boxCorners.length; i++, j += 3, k += 4 ) {
        vertices[ j + 0 ] = boxCorners[ i ][ 0 ];
        vertices[ j + 1 ] = boxCorners[ i ][ 1 ];
        vertices[ j + 2 ] = boxCorners[ i ][ 2 ];

        // Red color in RGB
        colors[ k + 0 ] = color[ 0 ];
        colors[ k + 1 ] = color[ 1 ];
        colors[ k + 2 ] = color[ 2 ];
        colors[ k + 3 ] = color[ 3 ];
    }

    const wireBbox = new osg.Geometry();
    wireBbox.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
    wireBbox.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );

    const indices = [
        0, 1,
        0, 3,
        3, 2,
        1, 2,

        0, 4,
        3, 7,
        1, 5,
        2, 6,

        4, 5,
        4, 7,
        7, 6,
        5, 6
    ];

    const indexes = new Uint16Array( indices );
    const wPrimitive = new osg.DrawElements( osg.primitiveSet.LINES, new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes ) );
    wireBbox.getPrimitives().push( wPrimitive );
    wireBbox.getOrCreateStateSet().setAttributeAndModes( program );

    const lineWidth = new osg.LineWidth( 5.0 );
    wireBbox.getOrCreateStateSet().setAttributeAndModes( lineWidth, osg.StateAttribute.ON );
    wireBbox.getOrCreateStateSet().setRenderBinDetails( 11, 'DepthSortedBin' );

    return wireBbox;
};

Utils.getTransformedBoundingBox = function ( node, transformMatrix ) {
    const bbox = new osg.BoundingBox();
    node.computeBoundingBox( bbox );

    const min = bbox.getMin();
    const max = bbox.getMax();

    // Calculate the 8 corners from the bounding box.
    const corner1 = osg.vec3.fromValues( min[ 0 ], min[ 1 ], min[ 2 ] );
    const corner2 = osg.vec3.fromValues( max[ 0 ], min[ 1 ], min[ 2 ] );
    const corner3 = osg.vec3.fromValues( max[ 0 ], max[ 1 ], min[ 2 ] );
    const corner4 = osg.vec3.fromValues( min[ 0 ], max[ 1 ], min[ 2 ] );
    const corner5 = osg.vec3.fromValues( min[ 0 ], min[ 1 ], max[ 2 ] );
    const corner6 = osg.vec3.fromValues( max[ 0 ], min[ 1 ], max[ 2 ] );
    const corner7 = osg.vec3.fromValues( max[ 0 ], max[ 1 ], max[ 2 ] );
    const corner8 = osg.vec3.fromValues( min[ 0 ], max[ 1 ], max[ 2 ] );

    osg.vec3.transformMat4( corner1, corner1, transformMatrix );
    osg.vec3.transformMat4( corner2, corner2, transformMatrix );
    osg.vec3.transformMat4( corner3, corner3, transformMatrix );
    osg.vec3.transformMat4( corner4, corner4, transformMatrix );
    osg.vec3.transformMat4( corner5, corner5, transformMatrix );
    osg.vec3.transformMat4( corner6, corner6, transformMatrix );
    osg.vec3.transformMat4( corner7, corner7, transformMatrix );
    osg.vec3.transformMat4( corner8, corner8, transformMatrix );

    const geomBounding = [ corner1, corner2, corner3, corner4, corner5, corner6, corner7, corner8 ];

    return geomBounding;
};

Utils.getScreenBoundingBox = function ( node, cam ) {
    const nodePath = this.computeNodePath( node );

    // Accumulate Model*View*Projection matrix
    const mat = osg.mat4.create();
    osg.mat4.multiply( mat, mat, cam.getViewport() ? cam.getViewport().computeWindowMatrix( osg.mat4.create() ) : osg.mat4.create() );
    osg.mat4.multiply( mat, mat, cam.getProjectionMatrix() );
    osg.mat4.multiply( mat, mat, cam.getViewMatrix() );
    osg.mat4.multiply( mat, mat, osg.computeLocalToWorld( nodePath ) );

    // Calculate bbox corners in screen coordinates
    const nodeBounding = this.getTransformedBoundingBox( node, mat );

    return nodeBounding;
};

Utils.transformExtent = function ( xFormMat, minPt, maxPt ) {
    // apply transformation to extent
    let newMin = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
    let newMax = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];
    this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], minPt[ 1 ], minPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], minPt[ 1 ], maxPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], maxPt[ 1 ], minPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], maxPt[ 1 ], maxPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], minPt[ 1 ], minPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], minPt[ 1 ], maxPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], maxPt[ 1 ], minPt[ 2 ], newMin, newMax );
    this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], maxPt[ 1 ], maxPt[ 2 ], newMin, newMax );

    minPt[ 0 ] = newMin[ 0 ];
    minPt[ 1 ] = newMin[ 1 ];
    minPt[ 2 ] = newMin[ 2 ];
    maxPt[ 0 ] = newMax[ 0 ];
    maxPt[ 1 ] = newMax[ 1 ];
    maxPt[ 2 ] = newMax[ 2 ];
};

Utils.accumulateTransformedExtent = function ( xFormMat, x, y, z, newMin, newMax ) {

    let pt = osg.vec3.fromValues( x, y, z );
    osg.vec3.transformMat4( pt, pt, xFormMat );
    newMin[ 0 ] = Math.min( pt[ 0 ], newMin[ 0 ] );
    newMin[ 1 ] = Math.min( pt[ 1 ], newMin[ 1 ] );
    newMin[ 2 ] = Math.min( pt[ 2 ], newMin[ 2 ] );
    newMax[ 0 ] = Math.max( pt[ 0 ], newMax[ 0 ] );
    newMax[ 1 ] = Math.max( pt[ 1 ], newMax[ 1 ] );
    newMax[ 2 ] = Math.max( pt[ 2 ], newMax[ 2 ] );
};

Utils.projectToScreen = function ( cam, hit ) {
    if ( hit === undefined )
        return;

    if ( cam === undefined )
        return;

    var mat = osg.mat4.create();
    osg.mat4.multiply( mat, mat, cam.getViewport() ? cam.getViewport().computeWindowMatrix( osg.mat4.create() ) : osg.mat4.create() );
    osg.mat4.multiply( mat, mat, cam.getProjectionMatrix() );
    osg.mat4.multiply( mat, mat, cam.getViewMatrix() );
    // Node 0 in nodepath is the Camera of the Viewer, so we take next child
    osg.mat4.multiply( mat, mat, osg.computeLocalToWorld( hit._nodePath.slice( 1 ) ) );

    var pt = [ 0.0, 0.0, 0.0 ];
    osg.vec3.transformMat4( pt, hit._localIntersectionPoint, mat );
    return pt;
};

Utils.projectPointToScreen = function ( cam, point ) {
    if ( point === undefined )
        return;

    if ( cam === undefined )
        return;

    var mat = osg.mat4.create();
    osg.mat4.multiply( mat, mat, cam.getViewport() ? cam.getViewport().computeWindowMatrix( osg.mat4.create() ) : osg.mat4.create() );
    osg.mat4.multiply( mat, mat, cam.getProjectionMatrix() );
    osg.mat4.multiply( mat, mat, cam.getViewMatrix() );

    var pt = [ 0.0, 0.0, 0.0 ];
    osg.vec3.transformMat4( pt, point, mat );
    return pt;
};

Utils.computeLocalToWorld = function ( nodePath, ignoreCameras ) {
    return osg.computeLocalToWorld( nodePath, ignoreCameras );
};

Utils.normalizeVec3 = function ( out, vec ) {
    return osg.vec3.normalize( out, vec );
};

Utils.addVec3 = function ( out, vec, vecSec ) {
    return osg.vec3.add( out, vec, vecSec );
};

Utils.subVec3 = function ( out, vec, vecSec ) {
    return osg.vec3.sub( out, vec, vecSec );
};

Utils.crossVec3 = function ( out, vec, vecSec ) {
    return osg.vec3.cross( out, vec, vecSec );
};

Utils.dotVec3 = function ( vec, vecSec ) {
    return osg.vec3.dot( vec, vecSec );
};

Utils.scaleVec3 = function ( out, vec, vecSec ) {
    return osg.vec3.scale( out, vec, vecSec );
};

Utils.transformVec3ByMat4 = function ( out, point, transformMatrix ) {
    return osg.vec3.transformMat4( out, point, transformMatrix );
};

Utils.transformVec4ByMat4 = function ( out, point, transformMatrix ) {
    return osg.vec4.transformMat4( out, point, transformMatrix );
};

Utils.translateMat4 = function ( mat, translation ) {
    return osg.mat4.fromTranslation( mat, translation );
};

Utils.transposeMat4 = function ( out, mat ) {
    return osg.mat4.transpose( out, mat );
};

Utils.mulMat4 = function ( out, mat, matMul ) {
    return osg.mat4.mul( out, mat, matMul );
};

Utils.invertMat4 = function ( out, mat ) {
    return osg.mat4.invert( out, mat );
};

Utils.getTranslationFromMat4 = function ( translation, mat ) {
    return osg.mat4.getTranslation( translation, mat );
};

Utils.getLookAtMat4 = function ( eye, center, up, matrix, distance ) {
    return osg.mat4.getLookAt( eye, center, up, matrix, distance );
};

Utils.mat4Ortho = function ( mat, left, right, bottom, top, zNear, zFar ) {
    return osg.mat4.ortho( mat, left, right, bottom, top, zNear, zFar );
};

Utils.createViewport = function ( x, y, w, h ) {
    return new osg.Viewport( x, y, w, h );
};

Utils.timerInstanceTick = function () {
    return osg.Timer.instance().tick();
};

Utils.timerInstanceDeltaS = function ( t0, t1 ) {
    return osg.Timer.instance().deltaS( t0, t1 );
};

Utils.getWindowSize = function () {
    var myWidth = 0,
        myHeight = 0;

    if ( typeof ( window.innerWidth ) === 'number' ) {
        //Non-IE
        myWidth = window.innerWidth;
        myHeight = window.innerHeight;
    } else if ( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) {
        //IE 6+ in 'standards compliant mode'
        myWidth = document.documentElement.clientWidth;
        myHeight = document.documentElement.clientHeight;
    } else if ( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) {
        //IE 4 compatible
        myWidth = document.body.clientWidth;
        myHeight = document.body.clientHeight;
    }
    return {
        'w': myWidth,
        'h': myHeight
    };
};

Utils.getSizeFactor = function ( sizeFactor, devicePixelRatio ) {

    var size = this.getWindowSize();
    var sf = sizeFactor * 500.0 * devicePixelRatio;
    //var result = ( sf - ( ( 1.0 - ( size.h / 1080.0 ) ) * 700 ) );
    var result = sf * size.h / 1080.0;

    return result;
};

Utils.hexToRgb = function ( hex ) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace( shorthandRegex, function ( m, r, g, b ) {
        return r + r + g + g + b + b;
    } );

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex );
    return result ? {
        r: parseInt( result[ 1 ], 16 ),
        g: parseInt( result[ 2 ], 16 ),
        b: parseInt( result[ 3 ], 16 )
    } : null;
};


Utils.fullhexToRgb = function ( hex, alpha, toFloat ) {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec( hex );
    if ( !result )
        return null;
    let colorRGB = [
        parseInt( result[ 1 ], 16 ),
        parseInt( result[ 2 ], 16 ),
        parseInt( result[ 3 ], 16 ),
        alpha
    ];
    if ( !toFloat )
        return colorRGB;
    return [ colorRGB[ 0 ] / 255.0, colorRGB[ 1 ] / 255.0, colorRGB[ 2 ] / 255.0, colorRGB[ 3 ] ];
};

/**
 * Method to convert a color from rgba to full hexadecimal
 * @memberof pcvizDB.Utils
 * @param {Array} rgba an array that contains four elements: component red, component green, component blue and alpha
 * @return {string} the string that represents this color in full hexadecimal
 */
Utils.RgbTofullhex = function ( rgba ) {
    var fullHex = '#';
    var padding = 2;

    var rgb = [];
    rgb[ 0 ] = ( parseInt( rgba[ 0 ] * 255 ) ).toString( 16 );
    rgb[ 1 ] = ( parseInt( rgba[ 1 ] * 255 ) ).toString( 16 );
    rgb[ 2 ] = ( parseInt( rgba[ 2 ] * 255 ) ).toString( 16 );

    while ( rgb[ 0 ].length < padding ) {
        rgb[ 0 ] = '0' + rgb[ 0 ];
    }

    while ( rgb[ 1 ].length < padding ) {
        rgb[ 1 ] = '0' + rgb[ 1 ];
    }

    while ( rgb[ 2 ].length < padding ) {
        rgb[ 2 ] = '0' + rgb[ 2 ];
    }

    fullHex += rgb[ 0 ];
    fullHex += rgb[ 1 ];
    fullHex += rgb[ 2 ];
    return fullHex;
};

/**
 * Method to convert a color from rgba (int) to full hexadecimal
 * @memberof pcvizDB.Utils
 * @param {Array} rgba an array that contains four elements: component red, component green, component blue and alpha
 * @return {string} the string that represents this color in full hexadecimal
 */
Utils.RGBIntToFullHex = function ( rgba ) {
    var fullHex = '#';
    var padding = 2;

    var rgb = [];
    rgb[ 0 ] = ( parseInt( rgba[ 0 ] ) ).toString( 16 );
    rgb[ 1 ] = ( parseInt( rgba[ 1 ] ) ).toString( 16 );
    rgb[ 2 ] = ( parseInt( rgba[ 2 ] ) ).toString( 16 );

    while ( rgb[ 0 ].length < padding ) {
        rgb[ 0 ] = '0' + rgb[ 0 ];
    }

    while ( rgb[ 1 ].length < padding ) {
        rgb[ 1 ] = '0' + rgb[ 1 ];
    }

    while ( rgb[ 2 ].length < padding ) {
        rgb[ 2 ] = '0' + rgb[ 2 ];
    }

    fullHex += rgb[ 0 ];
    fullHex += rgb[ 1 ];
    fullHex += rgb[ 2 ];
    return fullHex;
};

Utils.generateRandomRGBIntColor = function () {
    return ( new Array( Math.floor( Math.random() * 255 ), Math.floor( Math.random() * 255 ), Math.floor( Math.random() * 255 ), 1.0 ) );
};

Utils.generateRandomRGBColor = function () {
    return ( osg.vec4.fromValues32( Math.random(), Math.random(), Math.random(), 1.0 ) );
};

Utils.RGBIntToFloatColor = function ( color ) {
    return osg.vec4.fromValues32( color[ 0 ] / 255, color[ 1 ] / 255, color[ 2 ] / 255, color[ 3 ] );
};

Utils.arrayEquals = function ( array1, array2 ) {
    if ( !array1 || !array2 )
        return false;

    // compare lengths - can save a lot of time
    if ( array1.length !== array2.length )
        return false;

    for ( var i = 0, l = array1.length; i < l; i++ ) {
        if ( array1[ i ] instanceof Array && array2[ i ] instanceof Array ) {
            if ( !Utils.arrayEquals( array1[ i ], array2[ i ] ) )
                return false;
        } else if ( array1[ i ] !== array2[ i ] ) {
            return false;
        }
    }
    return true;
};

Utils.generateUUID = function () {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace( /[xy]/g, function ( c ) {
        var r = ( d + Math.random() * 16 ) % 16 | 0;
        d = Math.floor( d / 16 );
        return ( c === 'x' ? r : ( r & 0x3 | 0x8 ) ).toString( 16 );
    } );
    return uuid;
};

Utils.removeBrowserSelection = function () {
    // This lines of code remove all selection from the browser.
    // This avoids the canvas panning bug when 'something' was being selected and didn't work (at least, in Chrome).
    var sel = window.getSelection ? window.getSelection() : document.selection;
    if ( !sel )
        return;

    if ( sel.removeAllRanges ) {
        sel.removeAllRanges();
    } else if ( sel.empty ) {
        sel.empty();
    }
};


Utils.blobFromDataURL = function ( dataURL ) {

    var binStr = atob( dataURL.split( ',' )[ 1 ] ),
        len = binStr.length,
        arr = new Uint8Array( len );


    for ( var i = 0; i < len; i++ ) {
        arr[ i ] = binStr.charCodeAt( i );
    }

    return new Blob( [ arr ], {
        type: 'image/jpg'
    } );
};

Utils.parseData = function ( data ) {

    var result = {};
    var apiList = data.split( ',' );
    for ( var i = 0; i < apiList.length; i++ ) {
        var pair = apiList[ i ].substring( 1, apiList[ i ].length - 1 );
        var obj = pair.split( '":"' );
        if ( obj.length === 2 )
            result[ obj[ 0 ] ] = obj[ 1 ];
    }

    return result;
};

Utils.isNotZero = function ( value ) {
    return Math.abs( value ) > Number.EPSILON;
};

Utils.clamp = function ( value, min, max ) {
    return Math.max( min, Math.min( max, value ) );
};

Utils.parseJSON = function ( text ) {
    try {
        return JSON.parse( text );
    } catch ( err ) {
        if ( text )
            return text;
        return '';
    }
};

Utils.degreesToRadians = function ( degress ) {
    return ( degress * Math.PI / 180 );
};

/**
 * Gets Heading Pitch and Roll angle from a quat
 * @param {quat} quat  quaternion
 */
Utils.getHPRfromQuat = function ( quat ) {
    // From: http://guardian.curtin.edu.au/cga/faq/angles.html
    // Except OSG exchanges pitch & roll from what is listed on that page
    var qx = quat.x();
    var qy = quat.y();
    var qz = quat.z();
    var qw = quat.w();

    var sqx = qx * qx;
    var sqy = qy * qy;
    var sqz = qz * qz;
    var sqw = qw * qw;

    var term1 = 2 * ( qx * qy + qw * qz );
    var term2 = sqw + sqx - sqy - sqz;
    var term3 = -2 * ( qx * qz - qw * qy );
    var term4 = 2 * ( qw * qx + qy * qz );
    var term5 = sqw - sqx - sqy + sqz;

    var heading = Math.atan2( term1, term2 );
    var pitch = Math.atan2( term4, term5 );
    var roll = Math.asin( term3 );

    return osg.vec3.fromValues( heading, pitch, roll );
};

/**
 * Creates a matrix from  Heading Pitch and Roll angles
 * @param {float} x position X
 * @param {float} y position y
 * @param {float} z position z
 * @param {float} h position heading angle
 * @param {float} p position pitch angle
 * @param {float} r position roll angle
 */
Utils.createMatrixFromHPR = function ( x, y, z, h, p, r ) {
    var mxR = osg.mat4.create();
    osg.mat4.rotateY( mxR, osg.mat4.create(), Utils.degreesToRadians( r ) );

    var mxP = osg.mat4.create();
    osg.mat4.rotateX( mxP, osg.mat4.create(), Utils.degreesToRadians( p ) );

    var mxH = osg.mat4.create();
    osg.mat4.rotateZ( mxH, osg.mat4.create(), Utils.degreesToRadians( h ) );

    var mxT = osg.mat4.create();
    osg.mat4.translate( mxT, osg.mat4.create(), osg.vec3.fromValues( x, y, z ) );

    var out = osg.mat4.create();
    osg.mat4.multiply( out, mxP, mxH );
    osg.mat4.multiply( out, out, mxT );
    osg.mat4.multiply( out, out, mxR );

    return out;
};

/**
 * Rotates the sphere depending on the  yaw, pitch and roll values.
 * If one of these parameters are not provided, it will use the cached values.
 * // TODO: Get only the quat rotation from feature not euler angles
 * @param {float} yaw   Yaw angle.
 * @param {float} pitch Pitch angle.
 * @param {float} roll  Roll angle.
 */
Utils.getRotationFromYawPitchRoll = function ( yaw, pitch, roll ) {
    var _yaw, _pitch, _roll;
    if ( yaw === undefined || pitch === undefined || roll === undefined ) {
        return;
    }
    _yaw = roll;
    _pitch = pitch;
    _roll = roll;

    var _rotationQuat = osg.quat.create();
    Utils.makeRotateFromEuler( _rotationQuat, Math.toRadians( roll ), Math.toRadians( pitch ), Math.toRadians( yaw ), 'XYZ' );
    osg.quat.rotateZ( _rotationQuat, _rotationQuat, Math.PI / 2.0 );
    osg.quat.rotateY( _rotationQuat, _rotationQuat, Math.PI );
    return osg.mat4.fromQuat( osg.mat4.create(), _rotationQuat );
};


/**
 * Makes rotation from euler angles
 * @param {quat} q quaternion to rotate
 * @param {float} x angle.
 * @param {float} y angle.
 * @param {float} z angle.
 * @param {string} order  can be XYZ, YXZ, ZXY, ZYX, YZX or  XZY. The order to apply the Euler angles
 */
Utils.makeRotateFromEuler = function ( q, x, y, z, order ) {

    // http://www.mathworks.com/matlabcentral/fileexchange/
    // 20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
    // content/SpinCalc.m

    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );
    // (the first component in this pdf is our last quat component and vice-versa) https://ntrs.nasa.gov/api/citations/19770024290/downloads/19770024290.pdf
    if ( order === 'XYZ' ) { // 123

        q[ 0 ] = s1 * c2 * c3 + c1 * s2 * s3;
        q[ 1 ] = c1 * s2 * c3 - s1 * c2 * s3;
        q[ 2 ] = c1 * c2 * s3 + s1 * s2 * c3;
        q[ 3 ] = c1 * c2 * c3 - s1 * s2 * s3;
        return q;
    }
    if ( order === 'YXZ' ) { // 213

        q[ 0 ] = c1 * s2 * c3 + s1 * c2 * s3;
        q[ 1 ] = s1 * c2 * c3 - c1 * s2 * s3;
        q[ 2 ] = c1 * c2 * s3 - s1 * s2 * c3;
        q[ 3 ] = c1 * c2 * c3 + s1 * s2 * s3;
        return q;
    }
    if ( order === 'ZXY' ) { // 312

        q[ 0 ] = c1 * s2 * c3 - s1 * c2 * s3;
        q[ 1 ] = c1 * c2 * s3 + s1 * s2 * c3;
        q[ 2 ] = s1 * c2 * c3 + c1 * s2 * s3;
        q[ 3 ] = c1 * c2 * c3 - s1 * s2 * s3;
        return q;
    }
    if ( order === 'ZYX' ) { // 321

        q[ 0 ] = c1 * c2 * s3 - s1 * s2 * c3;
        q[ 1 ] = c1 * s2 * c3 + s1 * c2 * s3;
        q[ 2 ] = s1 * c2 * c3 - c1 * s2 * s3;
        q[ 3 ] = c1 * c2 * c3 + s1 * s2 * s3;
        return q;
    }
    if ( order === 'YZX' ) { // 231

        q[ 0 ] = c1 * c2 * s3 + s1 * s2 * c3;
        q[ 1 ] = s1 * c2 * c3 + c1 * s2 * s3;
        q[ 2 ] = c1 * s2 * c3 - s1 * c2 * s3;
        q[ 3 ] = c1 * c2 * c3 - s1 * s2 * s3;
        return q;
    }
    if ( order === 'XZY' ) { // 132 

        q[ 0 ] = s1 * c2 * c3 - c1 * s2 * s3;
        q[ 1 ] = c1 * c2 * s3 - s1 * s2 * c3;
        q[ 2 ] = c1 * s2 * c3 + s1 * c2 * s3;
        q[ 3 ] = c1 * c2 * c3 + s1 * s2 * s3;
        return q;
    }
    return q;
};

// From:
// https://stackoverflow.com/questions/50011864/changing-xyz-order-when-converting-euler-angles-to-quaternions
// https://glmatrix.net/docs/quat.js.html#line459
Utils.glMatrixFromEuler = function ( q, x, y, z ) {
    var c1 = Math.cos( x / 2 );
    var c2 = Math.cos( y / 2 );
    var c3 = Math.cos( z / 2 );
    var s1 = Math.sin( x / 2 );
    var s2 = Math.sin( y / 2 );
    var s3 = Math.sin( z / 2 );

    q[ 0 ] = s1 * c2 * c3 - c1 * s2 * s3;
    q[ 1 ] = c1 * s2 * c3 + s1 * c2 * s3;
    q[ 2 ] = c1 * c2 * s3 - s1 * s2 * c3;
    q[ 3 ] = c1 * c2 * c3 + s1 * s2 * s3;

    return q;
};

//  https://en.wikipedia.org/wiki/Conversion_between_quaternions_and_Euler_angles#Source_Code_2
/**
 * Makes rotation from euler angles
 * @param {vec3} angles output Euler angles 0 = roll, 1 = pitch, 2 = yaw
 * @param {quat} q quaternion input
 */
Utils.makeEulerFromQuat = function ( angles, q ) {

    // roll (x-axis rotation)
    var sinrCosp = 2 * ( q[ 3 ] * q[ 0 ] + q[ 1 ] * q[ 2 ] );
    var cosrCosp = 1 - 2 * ( q[ 0 ] * q[ 0 ] + q[ 1 ] * q[ 1 ] );
    angles[ 0 ] = Math.atan2( sinrCosp, cosrCosp );

    // pitch (y-axis rotation)
    var sinp = 2 * ( q[ 3 ] * q[ 1 ] - q[ 2 ] * q[ 0 ] );
    if ( Math.abs( sinp ) >= 1 )
        angles[ 1 ] = ( sinp < 0 ) ? -0.5 * Math.PI : 0.5 * Math.PI;
    else
        angles[ 1 ] = Math.asin( sinp );

    // yaw (z-axis rotation)
    var sinyCosp = 2 * ( q[ 3 ] * q[ 2 ] + q[ 0 ] * q[ 1 ] );
    var cosyCosp = 1 - 2 * ( q[ 1 ] * q[ 1 ] + q[ 2 ] * q[ 2 ] );
    angles[ 2 ] = Math.atan2( sinyCosp, cosyCosp );
};

/**
 * Creates the geometry of a textured fragment of a sphere. Only `radius`, `widthSegments` and `heightSegments`
 * are mandatory. Leaving the rest undefined will return a full sphere.
 * @param  {float} radius         The radius of the spheres.
 * @param  {int} widthSegments  The number of horizontal subdivisions.
 * @param  {int} heightSegments The number of vertical subdivisions.
 * @param  {float} [phiStart]       The phi angle in which the fragment starts. Defaults to `0`.
 * @param  {float} [phiLength]      The length in phi of the fragment. Defaults to `2 * PI`.
 * @param  {float} [thetaStart]     The theta angle in which the fragment starts. Defaults to `0`.
 * @param  {float} [thetaLength]    the length in theta of the fragment. Defaults to `PI`.
 * @return {geometry}                The geometry of the fragment of a sphere.
 */
Utils.createTexturedSphereFragment = function ( radius, widthSegments, heightSegments, phiStart, phiLength, thetaStart, thetaLength ) {

    // If phiStart, phiLength, thetaStart, thetaLength are undefined it defaults to a full sphere.
    phiStart = phiStart ? phiStart : 0.0;
    phiLength = phiLength ? phiLength : Math.PI * 2;
    thetaStart = thetaStart ? thetaStart : 0.0;
    thetaLength = thetaLength ? thetaLength : Math.PI;
    var segmentsX = Math.max( 3, Math.floor( widthSegments ) || 8 );
    var segmentsY = Math.max( 2, Math.floor( heightSegments ) || 6 );
    var nbPrim = segmentsX * segmentsY * 4;
    var fullVerticesList = new Float32Array( nbPrim * 3 );
    var fullNormalsList = new Float32Array( nbPrim * 3 );
    var fullUVList = new Float32Array( nbPrim * 2 );
    var indexes = new Uint16Array( segmentsX * segmentsY * 6 );
    var vtxCount = 0;
    var triCount = 0;

    var v1 = new Float32Array( 3 );
    var v2 = new Float32Array( 3 );
    var v3 = new Float32Array( 3 );
    var v4 = new Float32Array( 3 );
    var n1 = new Float32Array( 3 );
    var n2 = new Float32Array( 3 );
    var n3 = new Float32Array( 3 );
    var n4 = new Float32Array( 3 );
    var uv1 = new Float32Array( 2 );
    var uv2 = new Float32Array( 2 );
    var uv3 = new Float32Array( 2 );
    var uv4 = new Float32Array( 2 );

    var getCoordAndUvSphere = function ( u, v, coord, norm, uv ) {
        coord[ 0 ] = -radius * Math.cos( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
        coord[ 1 ] = radius * Math.cos( thetaStart + v * thetaLength );
        coord[ 2 ] = radius * Math.sin( phiStart + u * phiLength ) * Math.sin( thetaStart + v * thetaLength );
        osg.vec3.normalize( norm, coord );
        uv[ 0 ] = u;
        uv[ 1 ] = 1 - v;
    };

    for ( var y = 0; y < segmentsY; y++ ) {
        for ( var x = 0; x < segmentsX; x++ ) {
            getCoordAndUvSphere( ( x + 1 ) / segmentsX, y / segmentsY, v1, n1, uv1 );
            getCoordAndUvSphere( x / segmentsX, y / segmentsY, v2, n2, uv2 );
            getCoordAndUvSphere( x / segmentsX, ( y + 1 ) / segmentsY, v3, n3, uv3 );
            getCoordAndUvSphere( ( x + 1 ) / segmentsX, ( y + 1 ) / segmentsY, v4, n4, uv4 );

            var idv = vtxCount * 3;
            fullVerticesList[ idv ] = v1[ 0 ];
            fullVerticesList[ idv + 1 ] = v1[ 2 ];
            fullVerticesList[ idv + 2 ] = v1[ 1 ];
            fullVerticesList[ idv + 3 ] = v2[ 0 ];
            fullVerticesList[ idv + 4 ] = v2[ 2 ];
            fullVerticesList[ idv + 5 ] = v2[ 1 ];
            fullVerticesList[ idv + 6 ] = v3[ 0 ];
            fullVerticesList[ idv + 7 ] = v3[ 2 ];
            fullVerticesList[ idv + 8 ] = v3[ 1 ];

            fullNormalsList[ idv ] = -n1[ 0 ];
            fullNormalsList[ idv + 1 ] = -n1[ 2 ];
            fullNormalsList[ idv + 2 ] = -n1[ 1 ];
            fullNormalsList[ idv + 3 ] = -n2[ 0 ];
            fullNormalsList[ idv + 4 ] = -n2[ 2 ];
            fullNormalsList[ idv + 5 ] = -n2[ 1 ];
            fullNormalsList[ idv + 6 ] = -n3[ 0 ];
            fullNormalsList[ idv + 7 ] = -n3[ 2 ];
            fullNormalsList[ idv + 8 ] = -n3[ 1 ];

            var idu = vtxCount * 2;
            fullUVList[ idu ] = uv1[ 0 ];
            fullUVList[ idu + 1 ] = uv1[ 1 ];
            fullUVList[ idu + 2 ] = uv2[ 0 ];
            fullUVList[ idu + 3 ] = uv2[ 1 ];
            fullUVList[ idu + 4 ] = uv3[ 0 ];
            fullUVList[ idu + 5 ] = uv3[ 1 ];

            vtxCount += 3;

            idv = vtxCount * 3;
            fullVerticesList[ idv ] = v4[ 0 ];
            fullVerticesList[ idv + 1 ] = v4[ 2 ];
            fullVerticesList[ idv + 2 ] = v4[ 1 ];
            fullNormalsList[ idv ] = -n4[ 0 ];
            fullNormalsList[ idv + 1 ] = -n4[ 2 ];
            fullNormalsList[ idv + 2 ] = -n4[ 1 ];

            idu = vtxCount * 2;
            fullUVList[ idu ] = uv4[ 0 ];
            fullUVList[ idu + 1 ] = uv4[ 1 ];

            var iStart = triCount * 3;
            var tristart = vtxCount - 3;
            indexes[ iStart ] = tristart;
            indexes[ iStart + 1 ] = tristart + 1;
            indexes[ iStart + 2 ] = tristart + 2;
            indexes[ iStart + 3 ] = tristart;
            indexes[ iStart + 4 ] = tristart + 2;
            indexes[ iStart + 5 ] = tristart + 3;
            triCount += 2;
            vtxCount += 1;
        }
    }
    var g = new osg.Geometry();
    g.getAttributes().Vertex = new osg.BufferArray( 'ARRAY_BUFFER', fullVerticesList, 3 );
    g.getAttributes().Normal = new osg.BufferArray( 'ARRAY_BUFFER', fullNormalsList, 3 );
    g.getAttributes().TexCoord0 = new osg.BufferArray( 'ARRAY_BUFFER', fullUVList, 2 );
    g.getPrimitives().push( new osg.DrawElements( osg.primitiveSet.TRIANGLES, new osg.BufferArray( 'ELEMENT_ARRAY_BUFFER', indexes, 1 ) ) );

    return g;
};

var addPoint = function ( vertexes, normal, uvs, vertexCount, i, j, ndivs, uPoint ) {
    vertexes[ 3 * vertexCount + 0 ] = uPoint[ 0 ];
    vertexes[ 3 * vertexCount + 1 ] = uPoint[ 1 ];
    vertexes[ 3 * vertexCount + 2 ] = uPoint[ 2 ];
    normal[ 3 * vertexCount + 0 ] = 0;
    normal[ 3 * vertexCount + 1 ] = 0;
    normal[ 3 * vertexCount + 2 ] = 1;
    uvs[ 2 * vertexCount + 0 ] = i / ndivs;
    uvs[ 2 * vertexCount + 1 ] = j / ndivs;
};

Utils.createTexturedQuadGeometryFragment = function ( fovx, fovy, principalPointX, principalPointY, cameraSensorWidth, cameraSensorHeight, xStart, yStart, length, far, distortionParams ) {
    var distance = Registry.getController( 'UserPreferences' ).getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY ) * Utils.BOUNDING_FACTOR;

    far = far ? far : distance;
    xStart = xStart ? xStart : 0;
    yStart = yStart ? yStart : 0;
    length = length ? length : 1;
    var halfWidth = far * Math.tan( fovx / 2 );
    var halfHeight = far * Math.tan( fovy / 2 );
    var xOffsetPercent = ( principalPointX - ( cameraSensorWidth / 2.0 ) ) / cameraSensorWidth;
    var yOffsetPercent = ( principalPointY - ( cameraSensorHeight / 2.0 ) ) / cameraSensorHeight;
    var offsetX = halfWidth * 2.0 * xOffsetPercent;
    var offsetY = halfHeight * 2.0 * yOffsetPercent;
    var tileOffsetX = halfWidth * 2 * xStart;
    var tileOffsetY = halfHeight * 2 * yStart;

    var ndivs = distortionParams ? 4 : 1;
    var subTileLengthX = ( halfWidth * 2 * length ) / ndivs;
    var subTileLengthY = ( halfHeight * 2 * length ) / ndivs;

    var g = new osg.Geometry();

    var nVertices = 6 * ndivs * ndivs;
    var vertexes = new Float32Array( nVertices * 3 );
    var normal = new Float32Array( nVertices * 3 );
    var uvs = new Float32Array( nVertices * 2 );

    var vertexCount = 0;
    for ( var j = 0; j < ndivs; j++ ) {
        for ( var i = 0; i < ndivs; i++ ) {
            var pt1 = [ -halfWidth - offsetX + tileOffsetX + subTileLengthX * i, -halfHeight + offsetY + tileOffsetY + subTileLengthY * j, -far ];
            var uPoint1 = Utils.undistortPoint( [ pt1[ 0 ], pt1[ 1 ], pt1[ 2 ] ], distortionParams );
            var pt2 = [ -halfWidth - offsetX + tileOffsetX + subTileLengthX * i, -halfHeight + offsetY + tileOffsetY + subTileLengthY * ( j + 1 ), -far ];
            var uPoint2 = Utils.undistortPoint( [ pt2[ 0 ], pt2[ 1 ], pt2[ 2 ] ], distortionParams );
            var pt3 = [ -halfWidth - offsetX + tileOffsetX + subTileLengthX * ( i + 1 ), -halfHeight + offsetY + tileOffsetY + subTileLengthY * j, -far ];
            var uPoint3 = Utils.undistortPoint( [ pt3[ 0 ], pt3[ 1 ], pt3[ 2 ] ], distortionParams );
            var pt4 = [ -halfWidth - offsetX + tileOffsetX + subTileLengthX * ( i + 1 ), -halfHeight + offsetY + tileOffsetY + subTileLengthY * ( j + 1 ), -far ];
            var uPoint4 = Utils.undistortPoint( [ pt4[ 0 ], pt4[ 1 ], pt4[ 2 ] ], distortionParams );

            addPoint( vertexes, normal, uvs, vertexCount++, i + 1, j + 1, ndivs, uPoint4 );
            addPoint( vertexes, normal, uvs, vertexCount++, i, j + 1, ndivs, uPoint2 );
            addPoint( vertexes, normal, uvs, vertexCount++, i, j, ndivs, uPoint1 );

            addPoint( vertexes, normal, uvs, vertexCount++, i + 1, j, ndivs, uPoint3 );
            addPoint( vertexes, normal, uvs, vertexCount++, i + 1, j + 1, ndivs, uPoint4 );
            addPoint( vertexes, normal, uvs, vertexCount++, i, j, ndivs, uPoint1 );
        }
    }

    g.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertexes, 3 );
    g.getAttributes().Normal = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, normal, 3 );
    g.getAttributes().TexCoord0 = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, uvs, 2 );

    g.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.TRIANGLES, 0, vertexCount ) );

    return g;
};

Utils.cleaupFileCharacters = function ( data ) {
    return data.replace( /[^\x20-\x7E]/g, '' );
};

Utils.cleanUpFileNameCharacters = function ( fileName ) {
    return fileName.normalize( 'NFKC' ).replace( /[\ |&;$%@"<>+,\(\)]/g, '_' );
};

var ReleaseGLObjectVisitor = function () {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
};

ReleaseGLObjectVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        this.traverse( node );
        node.releaseGLObjects();
        node.removeChildren();
    }
} );

ReleaseGLObjectVisitor.instance = new ReleaseGLObjectVisitor();

Utils.getReleaseGLObjectVisitor = function () {
    return ReleaseGLObjectVisitor.instance;
};

Utils.selectionComesFromMe = function ( selectionObject, element ) {

    var userData = selectionObject.getUserData();

    if ( !userData || !userData.origin )
        return false;

    var found = userData.origin.find( function ( originElement ) {
        return ( originElement === element );
    } );
    return found;
};

Utils.splitCSVLine = function ( line ) {
    if ( line.indexOf( ' ' ) !== -1 ) // If there aren't any spaces, we don't need to replace (in that case a space was added wrongly at the end)
        line = line.replace( /\s+/g, ' ' ); // The replace is to avoid double spaces
    if ( line.indexOf( ' ' ) !== -1 || line.indexOf( ';' ) !== -1 || line.indexOf( '\t' ) !== -1 )
        return line.split( /\t| |;/ );
    // We do this separately because if there is another delimiter, maybe the ',' is used in float numbers
    return line.split( /,/ );
};

Utils.setPageSize = function ( value ) {
    Utils.PAGE_SIZE = value;
};

Utils.setBoundingFactor = function ( value ) {
    Utils.BOUNDING_FACTOR = value;
};

Utils.getOrderedFiles = function ( files, compareField = 'name' ) {
    return files.slice().sort( ( aa, bb ) => {
        if ( aa[ compareField ] < bb[ compareField ] ) {
            return -1;
        }
        if ( aa[ compareField ] > bb[ compareField ] ) {
            return 1;
        }
        return 0;
    } );
};
/**
 * Calculates the distorted coordinates of a 3D point based on distortion params
 * @param  {vec3D} point The 3D location to convert.
 * @param  {DistortionParams} dParams Distortion parameters to apply.
 */
Utils.distortPoint = function ( point, dParams ) {

    if ( !dParams )
        return point;

    var x = point[ 0 ] / ( point[ 2 ] );
    var y = point[ 1 ] / ( point[ 2 ] );
    var x2 = x * x;
    var y2 = y * y;
    var xy = x * y;
    var r2 = x2 + y2;

    var fx = ( dParams.K1 * r2 + dParams.K2 * r2 * r2 + dParams.K3 * r2 * r2 * r2 ) + dParams.P1 * ( r2 + 2 * x2 ) + dParams.P2 * ( 2 * xy );
    var fy = ( dParams.K1 * r2 + dParams.K2 * r2 * r2 + dParams.K3 * r2 * r2 * r2 ) + dParams.P2 * ( r2 + 2 * y2 ) + dParams.P1 * ( 2 * xy );

    return [ point[ 0 ] + point[ 0 ] * fx, point[ 1 ] + point[ 1 ] * fy, point[ 2 ] ];
};

Utils.searchDistance = function ( pt1, pt2 ) { // 'diamond' distance

    return ( ( pt1[ 0 ] < pt2[ 0 ] ) ? pt2[ 0 ] - pt1[ 0 ] : pt1[ 0 ] - pt2[ 0 ] ) + ( ( pt1[ 1 ] < pt2[ 1 ] ) ? pt2[ 1 ] - pt1[ 1 ] : pt1[ 1 ] - pt2[ 1 ] );
};

/**
 * Implementation of undistortion by gradient descent method on stretch factor from center (this assumes no tangential distortion)
 * @param  {vec3D} point The 3D location to convert.
 * @param  {DistortionParams} dParams Distortion parameters to apply.
 */
Utils.undistortPoint = function ( point, dParams ) {

    if ( !dParams )
        return point;

    var error = Number.MAX_VALUE;
    var maxError = 1e-12;
    var factor = 1.0; // initial stretch factor
    var searchRadius = 0.2;
    var errors = [ 0, 0 ];
    var undistortedPt;

    var minError;
    var minErrorIndex;
    var previous = -1;
    var initialized = false;

    while ( error > maxError && searchRadius > maxError ) { // iterative approximation

        undistortedPt = this.distortPoint( [ point[ 0 ] * ( factor + searchRadius ), point[ 1 ] * ( factor + searchRadius ), point[ 2 ] ], dParams );
        errors[ 0 ] = this.searchDistance( undistortedPt, point );
        undistortedPt = this.distortPoint( [ point[ 0 ] * ( factor - searchRadius ), point[ 1 ] * ( factor - searchRadius ), point[ 2 ] ], dParams );
        errors[ 1 ] = this.searchDistance( undistortedPt, point );

        minError = error;
        minErrorIndex = -1;
        if ( errors[ 0 ] < minError ) {
            minError = errors[ 0 ];
            minErrorIndex = 0;
        }
        if ( errors[ 1 ] < minError ) {
            minError = errors[ 1 ];
            minErrorIndex = 1;
        }

        error = minError;

        if ( minErrorIndex === -1 || minErrorIndex === previous ) {
            searchRadius /= 2;
            previous = -1;
            continue;
        }

        switch ( minErrorIndex ) {
        case 0:
            factor += searchRadius;
            if ( initialized )
                previous = 1;
            break;

        case 1:
            factor -= searchRadius;
            if ( initialized )
                previous = 0;
            break;
        }
        initialized = true;
    }

    return [ point[ 0 ] * factor, point[ 1 ] * factor, point[ 2 ] ];
};

Utils.isTouchEnabled = function () {
    return ( 'ontouchstart' in window );
};

Utils.isEdge = function () {
    return ( window.navigator.userAgent.indexOf( 'Edge' ) !== -1 );
};

Utils.isTouchByTouchPoints = function () {
    return navigator.maxTouchPoints || navigator.msMaxTouchPoints;
};

Utils.computeNodePath = function ( node ) {
    var nodePath = [];
    while ( node && node.getParents() && node.getParents().length > 0 ) {
        nodePath.push( node.getParents()[ 0 ] );
        node = node.getParents()[ 0 ];
    }
    return nodePath.reverse();
};

Utils.getNodePathToParent = function ( node, parentType ) {
    const nodePath = this.computeNodePath( node );
    for ( var i = 0; i < nodePath.length; i++ ) {
        if ( nodePath[ i ] instanceof parentType ) {
            return nodePath.slice( i );
        }
    }
    if ( node instanceof parentType ) {
        return [ node ];
    }

    return;
};

Utils.getPolygonTriangIndexes = function ( vertices ) {
    var minX = vertices[ 0 ],
        maxX = vertices[ 0 ],
        minY = vertices[ 1 ],
        maxY = vertices[ 1 ],
        minZ = vertices[ 2 ],
        maxZ = vertices[ 2 ];
    for ( var j = 3; j < vertices.length; j = j + 3 ) {
        minX = Math.min( vertices[ j ], minX );
        maxX = Math.max( vertices[ j ], maxX );

        minY = Math.min( vertices[ j + 1 ], minY );
        maxY = Math.max( vertices[ j + 1 ], maxY );

        minZ = Math.min( vertices[ j + 2 ], minZ );
        maxZ = Math.max( vertices[ j + 2 ], maxZ );

    }
    var minAxisVariation = Math.min( Math.min( Math.abs( maxX - minX ), Math.abs( maxY - minY ) ), Math.min( Math.abs( maxX - minX ), Math.abs( maxZ - minZ ) ) );
    var changeIndex;
    var modifiedVerts = vertices.slice();

    if ( minAxisVariation === Math.abs( maxY - minY ) )
        changeIndex = 1;
    else if ( minAxisVariation === Math.abs( maxX - minX ) )
        changeIndex = 0;

    if ( changeIndex !== undefined )
        for ( j = 0; j < vertices.length; j = j + 3 ) {
            modifiedVerts[ j + 2 ] = vertices[ j + changeIndex ];
            modifiedVerts[ j + changeIndex ] = vertices[ j + 2 ];
        }

    return new Uint16Array( earcut( modifiedVerts, null, 3 ) );
};

// gisObj argument is expected to be a Layer: VectorLayer, WorkspaceLayerGroup
Utils.getAccumulateTransformations = function ( gisObj ) {
    // accumulate transformations
    let xFormMat;
    while ( gisObj ) {
        let objXForm;
        if ( gisObj.getTransformMatrix )
            objXForm = gisObj.getTransformMatrix();
        if ( objXForm ) {
            if ( !xFormMat )
                xFormMat = osg.mat4.create();
            osg.mat4.multiply( xFormMat, objXForm, xFormMat );
        }
        gisObj = gisObj.getParent();
    }
    if ( xFormMat ) {
        osg.mat4.transpose( xFormMat, xFormMat );
    }
    return xFormMat;
};

Utils.formatUndefinedValue = function ( data ) {

    return data || '';

};

// It gives priority to a hit from a vectorlayer over pointclouds
// And it gives priority to hits on the selected layer
Utils.getPriorHit = function ( hits, selectedLayer ) {
    let userData, hitLayer, hit;
    for ( let j = 0; j < hits.length && hitLayer === undefined; j++ ) {
        for ( let i = hits[ j ]._nodePath.length - 1; i >= 0; i-- ) {
            userData = hits[ j ]._nodePath[ i ].getUserData();
            if ( hit === undefined && userData !== undefined && userData.featureIds !== undefined ) {
                hit = hits[ j ];
                if ( hitLayer )
                    break;
            }
            if ( hits[ j ]._nodePath[ i ].Layer ) {
                if ( selectedLayer && hits[ j ]._nodePath[ i ].Layer.getId() === selectedLayer.getId() )
                    hitLayer = hits[ j ];
                break;
            }
        }
    }
    if ( hitLayer )
        hit = hitLayer;
    else if ( hit === undefined )
        hit = hits[ 0 ];
    return hit;
};

Utils.findLayerInNodePath = function ( nodePath ) {
    const layerNode = nodePath.findLast( ( node ) => node.Layer );
    return layerNode ? layerNode.Layer : undefined;
};

Utils.getFeatureId = function ( nodePath, featureIndex ) {
    let fid;
    for ( let i = nodePath.length - 1; i >= 0; i-- ) {
        let userData = nodePath[ i ].getUserData();
        if ( userData !== undefined ) {
            if ( userData.featureIds && userData.featureIds[ featureIndex ] ) {
                fid = userData.featureIds[ featureIndex ];
                break;
            } else if ( userData.featureId ) {
                fid = userData.featureId;
                break;
            }
        }
    }
    return fid;
};

Utils.getRegistrationColorType = function ( value, low, high ) {
    let result = Utils.REGISTRATION_COLOR_TYPE.NONE;
    if ( !value ) {
        return result;
    }
    if ( value < low )
        result = Utils.REGISTRATION_COLOR_TYPE.HIGH;
    else if ( value >= low && value < high )
        result = Utils.REGISTRATION_COLOR_TYPE.MEDIUM;
    else if ( value >= high )
        result = Utils.REGISTRATION_COLOR_TYPE.LOW;
    return result;
};

Utils.getViewCanvasSize = function () {
    const viewsController = Registry.getInstance().getController( 'View' );
    let view = viewsController.getView( '3D' );
    let viewSize = [ view.getViewer().getCanvasWidth(), view.getViewer().getCanvasHeight() ];
    if ( viewSize[ 0 ] <= 1 ) { // Getting map view canvas size if 3D view is hidden
        view = viewsController.getView( 'Map' );
        viewSize = view.getMapViewer().getSize();
    }
    return viewSize;
};

Utils.isEqualExtent = function ( extent1, extent2 ) {
    if ( !extent1 && !extent2 ) {
        return true;
    }
    return Utils.arrayEquals( extent1, extent2 );
};

module.exports = Utils;


/***/ }),

/***/ "./sources/pcvizDB/ViewController.js":
/*!*******************************************!*\
  !*** ./sources/pcvizDB/ViewController.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This controller is used to retrieve the views in the application.
 * @class
 * @memberof pcvizDB
 * @property {Map} _views The views of the application.
 * @property {Array<function>} _refreshPanoramaModeCbs A list of callbacks to be executed when the panorama mode changes.
 */
var ViewController = function () {
    this._viewsPriority = [ 'Section', 'TOC' ];

    this._views = new Map();

    this._refreshUICbs = [];

    this._center = undefined; // global center used in views that render layers as osg nodes
};

ViewController.prototype = {

    /**
     * Returns an array with the registered views.
     * @method
     * @memberof pcvizDB.ViewController
     * @return {Array<View>} The registered views.
     */
    getViews: function () {
        const viewsPriority = this._viewsPriority || [];
        const firstViews = viewsPriority.map( key => this._views.get( key ) ).filter( view => !!view );
        const otherViews = Array.from( this._views, el => el[ 1 ] ).filter( view => !firstViews.includes( view ) );

        return firstViews.concat( otherViews );
    },

    /**
     * Returns a view by its key name.
     * @method
     * @memberof pcvizDB.ViewController
     * @param  {String} key The view name: `3D` or `Map`
     * @return {View}     The selected view.
     */
    getView: function ( key ) {
        return this._views.get( key );
    },

    /**
     * Registers a view in the controller.
     * @method
     * @memberof pcvizDB.ViewController
     * @param {String} key  The view name.
     * @param {View} view The view.
     */
    addView: function ( key, view ) {
        this._views.set( key, view );
    },

    /**
     * Adds a callback to be executed when refreshUI is called.
     * @method
     * @memberof pcvizDB.ViewController
     * @param {Function} cb The callback to be executed.
     */
    addRefreshUICallback: function ( cb ) {
        this._refreshUICbs.push( cb );
    },

    /**
     * Executes all registered callbacks to refresh UI.
     * @method
     * @memberof pcvizDB.ViewController
     */
    refreshUI: function () {
        for ( var i = 0; i < this._refreshUICbs.length; i++ )
            this._refreshUICbs[ i ].call();
    },

    reset: function () {
        this._views.clear();
        this._refreshUICbs.length = 0;
    },

    // Query parameters methods
    zoomToLayerAfterInitialize: function ( layer, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToLayerAfterInitialize( layer, options );
    },

    zoomToFeatureAfterInitialize: function ( layer, feature, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToFeatureAfterInitialize( layer, feature, options );
    },

    zoomToExtentAfterInitialize: function ( extent, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToExtentAfterInitialize( extent, options );
    },

    zoomToSavedViewAfterInitialize: function ( name ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToSavedViewAfterInitialize( name );
    },

    changeViewPointAfterInitialize: function ( options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].changeViewPointAfterInitialize( options );
    },

    // view actions
    zoomToLayer: function ( layer, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToLayer( layer, options );
    },

    zoomToFeature: function ( layer, feature, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToFeature( layer, feature, options );
    },

    zoomToExtent: function ( extent, options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].zoomToExtent( extent, options );
    },

    changeViewPoint: function ( options ) {
        if ( this.getViews().length > 0 )
            for ( var i = 0; i < this.getViews().length; i++ )
                this.getViews()[ i ].changeViewPoint( options );
    },

    setCenter: function ( center ) {
        this._center = center;
    },

    getCenter: function () {
        return this._center;
    }

};

module.exports = ViewController;


/***/ }),

/***/ "./sources/pcvizDB/WizardController.js":
/*!*********************************************!*\
  !*** ./sources/pcvizDB/WizardController.js ***!
  \*********************************************/
/*! exports provided: WIZARD_ACTION_BUTTON, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIZARD_ACTION_BUTTON", function() { return WIZARD_ACTION_BUTTON; });
/* harmony import */ var pcvizDB_BaseListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/BaseListener */ "./sources/pcvizDB/BaseListener.js");


const WIZARD_ACTION_BUTTON = {
    PREVIOUS: 'WIZARD.PREVIOUS',
    NEXT: 'WIZARD.NEXT',
    START: 'WIZARD.START',
    CLOSE: 'WIZARD.CLOSE',
    CANCEL: 'WIZARD.CANCEL',
    SKIP: 'WIZARD.SKIP',
    CALCULATE: 'WIZARD.CALCULATE'
};

class WizardController extends pcvizDB_BaseListener__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( maxStep ) {
        super();
        this._currentStep = 1;
        this._maxStep = maxStep || Number.MAX_VALUE;
    }

    setMaximumStep( maxStep ) {
        this._maxStep = maxStep;
    }

    getCurrentStep() {
        return this._currentStep;
    }

    isStep( step ) {
        return this._currentStep === step;
    }

    isLastStep() {
        return this._currentStep >= this._maxStep;
    }

    previousStep() {
        this._currentStep = Math.max( this._currentStep - 1, 0 );
        this.notify( 'previousStep' );
    }

    nextStep() {
        this._currentStep = Math.min( this._currentStep + 1, this._maxStep );
        this.notify( 'nextStep' );
    }

    close() {
        this.notify( 'close' );
    }
}

/* harmony default export */ __webpack_exports__["default"] = (WizardController);


/***/ }),

/***/ "./sources/pcvizDB/WorkspaceController.js":
/*!************************************************!*\
  !*** ./sources/pcvizDB/WorkspaceController.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceController; });
/* harmony import */ var _ListenerController__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var _ListenerController__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_ListenerController__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js");
/* harmony import */ var pcvizGIS_WorkspaceDataCache__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/WorkspaceDataCache */ "./sources/pcvizGIS/WorkspaceDataCache.js");
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");










class WorkspaceController extends _ListenerController__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._workspaceDataCache = new pcvizGIS_WorkspaceDataCache__WEBPACK_IMPORTED_MODULE_6__["default"]();
        this._version = 1;

        this._tmpWorkspace = undefined;
    }

    setVersion( version ) {
        this._version = version;
    }

    getWorkspace() {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getDriver( 'da.project' ).getWorkspace();
    }

    setWorkspace( workspace ) {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getDriver( 'da.project' ).setWorkspace( workspace );
    }

    fetchWorkspace( project, version = 1 ) {
        return new Promise( ( resolve, reject ) => {
            pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getDriver( 'da.project' ).fetchWorkspace( project, version ).then( workspace => {
                // adding elements to workspaceDataCache
                this.fillWorkspaceDataCache( workspace );
                resolve( workspace );
                this.notify( workspace );
            }, reject );
        } );
    }

    uploadWorkspace() {
        let project = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Application' ).getApplication().getProject();
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getDriver( 'da.project' ).uploadWorkspace( project, this._version );
    }

    getOrCreateWorkspace( project, version = 1 ) {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getDriver( 'da.project' ).getOrCreateWorkspace( project, version );
    }

    getWorkspaceDataCache() {
        return this._workspaceDataCache;
    }

    fillWorkspaceDataCache( workspace ) {
        let wsVisitor = new pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_5__["default"]();
        wsVisitor.apply( workspace.workspace );
        let elements = wsVisitor.getAllElements();

        if ( elements.length < 1 )
            return;

        elements.forEach( element => {
            this.getWorkspaceDataCache().updateOrCreateDataCacheObject( element.uuid, element, undefined, undefined );
        } );
    }

    uploadDownloadWorkspaceFile( downloadWorkspaceJson ) {
        if ( typeof downloadWorkspaceJson !== 'string' ) {
            downloadWorkspaceJson = JSON.stringify( downloadWorkspaceJson );
        }
        let project = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Application' ).getApplication().getProject();
        let workspaceProjectFilePath = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/';

        return project.getProjectDataset().getDriver().uploadObjectFile( project, downloadWorkspaceJson, pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default.a.WORKSPACE_PROJECT_FILE_PATH, workspaceProjectFilePath, 'application/json', pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_3___default.a.NO_CACHE, 'attachment' );
    }

    /**
     * Creates the workspace json to download the necessary data
     * @method
     * @memberof pcvizDB.WorkspaceController
     * @param {Object} workspace    the workspace that contains the workspace original
     * @param {Array} selectedObjects   its elements are workspace elements to be downloaded (their children will be downloaded)
     * @param {Array} [layersObjects] if this array exists, only the layers in this array will be downloaded
     * @param {Array} [unselectedObjects] if this array exists, its elements won't be downloaded
     * @param {boolean} [mode]    this flag indicates if the method should use the layersObject or the unselectedObjects
     *                          to include or not some layers in the JSON
     * @param {JSON} [options]  options for the json (it can include the next keys: 'primitiveLayers', 'TTTL', 'tiledImages', 'CL3', 'CLR'
     *                          and their values should be: true or false)
     * @return {JSON} the workspace json created
     */
    createDownloadWorkspaceJson( workspace, selectedObjects, layersObjects, unselectedObjects, mode, options ) {
        let addScan,
            addStation;
        let layersObjectsUuids = layersObjects ? layersObjects.map( layerObj => layerObj.uuid ) : undefined;
        let wsVisitor = new pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_5__["default"]();
        wsVisitor.apply( workspace.workspace );

        let workspaceProjectJson = {
            stations: []
        };

        addScan = ( scan ) => {
            // First, find the parent station object
            let stationObject = scan;
            while ( stationObject.category !== pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Station ].name ) {
                stationObject = wsVisitor.getParent( stationObject );
            }
            // Adds the station to the workspaceProject.json file
            let stationNode = addStation( stationObject, false );
            let foundScan = stationNode.scans.find( existingScan => scan.uuid === existingScan.uuid );
            if ( foundScan ) {
                return foundScan;
            }

            // If the scan does not exist yet, we create its definition node
            let scanNode = {
                uuid: scan.uuid,
                layers: []
            };

            // We check if its layers are selected
            let childrenLayers = scan.children;
            if ( childrenLayers ) { // Check this because there are scans without children layers.

                if ( layersObjects && mode === WorkspaceController.SELECT_MODE ) {
                    let filteredChild = scan.children.filter( child => layersObjectsUuids.indexOf( child.uuid ) !== -1 );
                    if ( filteredChild.length ) {
                        childrenLayers = filteredChild;
                    }
                }

                if ( unselectedObjects && unselectedObjects.length && mode === WorkspaceController.UNSELECT_MODE ) {
                    let filteredChild = scan.children.filter( child => unselectedObjects.includes( child ) === false );
                    childrenLayers = filteredChild;
                }
                // If there aren't any selected layers, we add all layers
                childrenLayers.forEach( layer => {
                    scanNode.layers.push( layer.uuid );
                } );
            }

            stationNode.scans.push( scanNode );

            return scanNode;
        };

        addStation = ( station, addChildren ) => {
            // First, we check if the station is already added
            let foundStation = workspaceProjectJson.stations.find( existingStation => station.uuid === existingStation.uuid );
            if ( foundStation ) {
                return foundStation;
            }

            // If the station node does not exist yet, we create its definition node
            let stationNode = {
                uuid: station.uuid,
                scans: []
            };
            workspaceProjectJson.stations.push( stationNode );

            // We add the children if the argument is true
            if ( !addChildren ) {
                return stationNode;
            }
            let scanFolder = station.children.find( child => child.category === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].ScansFolder ].name );
            if ( !scanFolder || !scanFolder.children ) {
                return stationNode;
            }
            scanFolder.children.forEach( child => {

                if ( unselectedObjects === undefined || unselectedObjects.includes( child ) === false )
                    addScan( child );
            } );
            return stationNode;
        };

        if ( selectedObjects ) {
            if ( selectedObjects.some( obj => obj.category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.TIN || obj.category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.MODEL3D ) ) {
                workspaceProjectJson.layers = [];
            }

            selectedObjects.forEach( obj => {
                if ( obj.category === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Station ].name ) {
                    addStation( obj, true );
                    return;
                }
                if ( obj.category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.TIN || obj.category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.MODEL3D ) {
                    workspaceProjectJson.layers.push( obj );
                    return;
                }
                addScan( obj );
            } );
        }
        if ( options )
            workspaceProjectJson.options = options;
        return workspaceProjectJson;
    }

    ensureWorkspace( project, version = 1 ) {
        if ( !project.isScanProject() ) {
            return Promise.resolve();
        }
        return new Promise( ( resolve, reject ) => {
            this.getOrCreateWorkspace( project, version ).then( ( workspace ) => {
                this.fillWorkspaceDataCache( workspace );
                resolve();
            } ).catch( ( error ) => {
                reject( { data: JSON.stringify( error ), status: '500' } );
            } );
        } );
    }

    // Functions to manage a temporal workspace
    initTempWorkspace( workflow ) {
        this._tmpWorkspace = workflow.getTmpWorkspace();
    }

    stashWorkspace() {
        this._tmpWorkspace.stashWorkspace = JSON.stringify( this.getWorkspace() );
    }

    stashPopWorkspace() {
        return this._tmpWorkspace.stashWorkspace;
    }

    emptyWorkspace() {
        delete this._tmpWorkspace.stashWorkspace;
    }

    stashPopAndApplyWorkspace() {
        return new Promise( ( resolve, reject ) => {
            let stashWS = this.stashPopWorkspace();
            if ( stashWS === undefined ) {
                resolve();
                return;
            }
            stashWS = JSON.parse( stashWS );

            if ( stashWS === undefined ) {
                resolve();
                return;
            }

            // apply workspace file
            this.setWorkspace( stashWS );

            // uploading the new workspace
            this.uploadWorkspace().then( () => {
                this.emptyWorkspace();
                resolve();
            } ).catch( reject );
        } );
    }

}

WorkspaceController.SELECT_MODE = 0;
WorkspaceController.UNSELECT_MODE = 1;


/***/ }),

/***/ "./sources/pcvizDB/pcvizDB.js":
/*!************************************!*\
  !*** ./sources/pcvizDB/pcvizDB.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_BaseListener__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/BaseListener */ "./sources/pcvizDB/BaseListener.js");
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Input */ "./sources/pcvizDB/Input.js");
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Serializer */ "./sources/pcvizDB/Serializer.js");
/* harmony import */ var pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_PLFMZReaderParser__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/PLFMZReaderParser */ "./sources/pcvizDB/PLFMZReaderParser.js");
/* harmony import */ var pcvizDB_PLFMZReaderParser__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_PLFMZReaderParser__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_ConversionInfo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/ConversionInfo */ "./sources/pcvizDB/ConversionInfo.js");
/* harmony import */ var pcvizDB_ConversionInfo__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ConversionInfo__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizDB/PointCloudDBPager */ "./sources/pcvizDB/PointCloudDBPager.js");
/* harmony import */ var pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pcvizDB_LayerController__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizDB/LayerController */ "./sources/pcvizDB/LayerController.js");
/* harmony import */ var pcvizDB_LayerController__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_LayerController__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizDB_ObjectController__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizDB/ObjectController */ "./sources/pcvizDB/ObjectController.js");
/* harmony import */ var pcvizDB_ObjectController__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ObjectController__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pcvizDB_SelectionController__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizDB/SelectionController */ "./sources/pcvizDB/SelectionController.js");
/* harmony import */ var pcvizDB_SelectionController__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_SelectionController__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var pcvizDB_SymbolController__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizDB/SymbolController */ "./sources/pcvizDB/SymbolController.js");
/* harmony import */ var pcvizDB_SymbolController__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_SymbolController__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var pcvizDB_ViewController__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! pcvizDB/ViewController */ "./sources/pcvizDB/ViewController.js");
/* harmony import */ var pcvizDB_ViewController__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ViewController__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var pcvizDB_ApplicationController__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! pcvizDB/ApplicationController */ "./sources/pcvizDB/ApplicationController.js");
/* harmony import */ var pcvizDB_ApplicationController__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ApplicationController__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var pcvizDB_UserPreferencesController__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! pcvizDB/UserPreferencesController */ "./sources/pcvizDB/UserPreferencesController.js");
/* harmony import */ var pcvizDB_UserPreferencesController__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_UserPreferencesController__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! pcvizDB/UnitController */ "./sources/pcvizDB/UnitController.js");
/* harmony import */ var pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var pcvizDB_MountController__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! pcvizDB/MountController */ "./sources/pcvizDB/MountController.js");
/* harmony import */ var pcvizDB_MountController__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_MountController__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var pcvizDB_MountObject__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! pcvizDB/MountObject */ "./sources/pcvizDB/MountObject.js");
/* harmony import */ var pcvizDB_MountObject__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_MountObject__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var pcvizDB_UploadController__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! pcvizDB/UploadController */ "./sources/pcvizDB/UploadController.js");
/* harmony import */ var pcvizDB_BlobStorageController__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! pcvizDB/BlobStorageController */ "./sources/pcvizDB/BlobStorageController.js");
/* harmony import */ var pcvizDB_ErrorController__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! pcvizDB/ErrorController */ "./sources/pcvizDB/ErrorController.js");
/* harmony import */ var pcvizDB_ErrorController__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ErrorController__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var pcvizDB_ImageSelectionController__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! pcvizDB/ImageSelectionController */ "./sources/pcvizDB/ImageSelectionController.js");
/* harmony import */ var pcvizDB_WorkspaceController__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! pcvizDB/WorkspaceController */ "./sources/pcvizDB/WorkspaceController.js");
/* harmony import */ var pcvizDB_ModelLibraryController__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! pcvizDB/ModelLibraryController */ "./sources/pcvizDB/ModelLibraryController.js");
/* harmony import */ var pcvizDB_ConfigurationController__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! pcvizDB/ConfigurationController */ "./sources/pcvizDB/ConfigurationController.js");
/* harmony import */ var pcvizDB_OverwriteSymbologyController__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! pcvizDB/OverwriteSymbologyController */ "./sources/pcvizDB/OverwriteSymbologyController.js");
/* harmony import */ var pcvizDB_ScanSelectionController__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! pcvizDB/ScanSelectionController */ "./sources/pcvizDB/ScanSelectionController.js");
/* harmony import */ var pcvizDB_C2CLinkManager__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! pcvizDB/C2CLinkManager */ "./sources/pcvizDB/C2CLinkManager.js");
/* harmony import */ var pcvizDB_PointVisibilityManagerController__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! pcvizDB/PointVisibilityManagerController */ "./sources/pcvizDB/PointVisibilityManagerController.js");
/* harmony import */ var pcvizDB_WizardController__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! pcvizDB/WizardController */ "./sources/pcvizDB/WizardController.js");
/* harmony import */ var pcvizDB_PluginsController__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! pcvizDB/PluginsController */ "./sources/pcvizDB/PluginsController.js");
/* harmony import */ var pcvizDB_OverwriteVisibilityController__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! pcvizDB/OverwriteVisibilityController */ "./sources/pcvizDB/OverwriteVisibilityController.js");
/* harmony import */ var pcvizDB_TargetColorManager__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! pcvizDB/TargetColorManager */ "./sources/pcvizDB/TargetColorManager.js");




































/** @namespace pcvizDB */
const pcvizDB = {
    BaseListener: pcvizDB_BaseListener__WEBPACK_IMPORTED_MODULE_0__["default"],
    Input: (pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default()),
    Serializer: (pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2___default()),
    PLFMZReaderParser: (pcvizDB_PLFMZReaderParser__WEBPACK_IMPORTED_MODULE_3___default()),
    ConversionInfo: (pcvizDB_ConversionInfo__WEBPACK_IMPORTED_MODULE_4___default()),
    Utils: (pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default()),
    PointCloudDBPager: (pcvizDB_PointCloudDBPager__WEBPACK_IMPORTED_MODULE_6___default()),
    Registry: (pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_7___default()),
    ListenerController: (pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_8___default()),
    LayerController: (pcvizDB_LayerController__WEBPACK_IMPORTED_MODULE_9___default()),
    ObjectController: (pcvizDB_ObjectController__WEBPACK_IMPORTED_MODULE_10___default()),
    SelectionController: (pcvizDB_SelectionController__WEBPACK_IMPORTED_MODULE_11___default()),
    SymbolController: (pcvizDB_SymbolController__WEBPACK_IMPORTED_MODULE_12___default()),
    ViewController: (pcvizDB_ViewController__WEBPACK_IMPORTED_MODULE_13___default()),
    ApplicationController: (pcvizDB_ApplicationController__WEBPACK_IMPORTED_MODULE_14___default()),
    UserPreferencesController: (pcvizDB_UserPreferencesController__WEBPACK_IMPORTED_MODULE_15___default()),
    UnitController: (pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_16___default()),
    MountController: (pcvizDB_MountController__WEBPACK_IMPORTED_MODULE_17___default()),
    MountObject: (pcvizDB_MountObject__WEBPACK_IMPORTED_MODULE_18___default()),
    UploadController: pcvizDB_UploadController__WEBPACK_IMPORTED_MODULE_19__["default"],
    BlobStorageController: pcvizDB_BlobStorageController__WEBPACK_IMPORTED_MODULE_20__["default"],
    ErrorController: (pcvizDB_ErrorController__WEBPACK_IMPORTED_MODULE_21___default()),
    ImageSelectionController: pcvizDB_ImageSelectionController__WEBPACK_IMPORTED_MODULE_22__["default"],
    WorkspaceController: pcvizDB_WorkspaceController__WEBPACK_IMPORTED_MODULE_23__["default"],
    ModelLibraryController: pcvizDB_ModelLibraryController__WEBPACK_IMPORTED_MODULE_24__["default"],
    ConfigurationController: pcvizDB_ConfigurationController__WEBPACK_IMPORTED_MODULE_25__["default"],
    OverwriteSymbologyController: pcvizDB_OverwriteSymbologyController__WEBPACK_IMPORTED_MODULE_26__["default"],
    ScanSelectionController: pcvizDB_ScanSelectionController__WEBPACK_IMPORTED_MODULE_27__["default"],
    C2CLinkManager: pcvizDB_C2CLinkManager__WEBPACK_IMPORTED_MODULE_28__["default"],
    PointVisibilityManagerController: pcvizDB_PointVisibilityManagerController__WEBPACK_IMPORTED_MODULE_29__["default"],
    WizardController: pcvizDB_WizardController__WEBPACK_IMPORTED_MODULE_30__["default"],
    PluginsController: pcvizDB_PluginsController__WEBPACK_IMPORTED_MODULE_31__["default"],
    OverwriteVisibilityController: pcvizDB_OverwriteVisibilityController__WEBPACK_IMPORTED_MODULE_32__["default"],
    WIZARD_ACTION_BUTTON: pcvizDB_WizardController__WEBPACK_IMPORTED_MODULE_30__["WIZARD_ACTION_BUTTON"],
    TargetColorManager: pcvizDB_TargetColorManager__WEBPACK_IMPORTED_MODULE_33__["default"]
};

/* harmony default export */ __webpack_exports__["default"] = (pcvizDB);


/***/ }),

/***/ "./sources/pcvizDataAccess/CollageWebFileBrowser.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/CollageWebFileBrowser.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var FileBrowser = __webpack_require__( /*! pcvizDataAccess/FileBrowser */ "./sources/pcvizDataAccess/FileBrowser.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );

/**
 *  File Browser for Collage Web Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var CollageWebFileBrowser = function () {
    //  FileBrowser.call( this );
    BaseDriver.call( this );

    this._currentFolder = ''; // current folder path
    this._currentResponse = undefined;
    this._currentFiles = [];
};

var PAGE_SIZE = 20;
CollageWebFileBrowser.DEFAULT_PAGE_SIZE = 20;

CollageWebFileBrowser.OBJECT_TYPE = {
    LAYER: 'layers',
    PROJECT: 'projects'
};

CollageWebFileBrowser.CLOUDFRONT_LIMIT = 2e+10;

CollageWebFileBrowser.prototype = Utils.objectInherit( FileBrowser.prototype, Utils.objectInherit( BaseDriver.prototype, {

    /**
     * Returns an array of files and/or folders (each file or folder is a JSON object
     * with 'name', 'kind', 'path', 'href' [ and 'size' only for files] attributes)
     * @method
     * @memberof pcvizDataAccess.FileBrowser
     * @return {array}
     */
    list: function ( object, objectType, folder, next, returnAccumulate ) {

        var url;
        // To continue get files from the same folder if there are more than _currentFiles
        // we could define url as in the else clause and concat url += '&continuationToken=' + continuation;
        // But, a simpler option:
        if ( next )
            url = this._currentResponse.nextPage;
        else {
            var objectId = ( object.id ? object.id : object.getId() ); //getId();
            // for testing %2Fsubfolder

            // We need put the 'folder' parameter athough it would be empty to get the folders also (in addition to the files)
            url = this.getResource( objectType + 'Files', objectId ) + 'files?pageSize=' + PAGE_SIZE + '&folder';
            if ( folder )
                url += '=' + folder;
            if ( !returnAccumulate )
                this._currentFiles = [];
            this._currentFolder = folder;
        }

        var self = this;
        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                self._currentResponse = UtilsDB.parseJSON( response );
                self._currentFiles = self._currentFiles.concat( self._currentResponse.files );

                if ( returnAccumulate === undefined || returnAccumulate === true )
                    resolve( self._currentFiles );
                else
                    resolve( self._currentResponse.files );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );

    },

    download: function ( file ) {

        var url = file.href;
        // We also could build the url as (in that case we need the object and the object type as arguments):
        // var url = this.getServerUrl() + '/catalog/collage/' + objectType + '/' + objectId + '/files/'+filePath;

        // Gets the url to download the file
        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                var location = UtilsDB.parseJSON( response ).location;

                // Downloads the file from the location
                var link = document.createElement( 'a' );
                link.href = location;
                link.download = location.substring( location.lastIndexOf( '/' ) + 1 );
                link.download = link.download.substring( 0, link.download.indexOf( '?' ) );

                link.target = '_blank';

                document.body.appendChild( link );
                link.click();

                resolve();
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    /**
     * Retrieves the file object and resolves it.
     */
    retrieve: function ( file ) {
        var self = this;
        var url = file.href;
        // We also could build the url as (in that case we need the object and the object type as arguments):
        // var url = this.getServerUrl() + '/catalog/collage/' + objectType + '/' + objectId + '/files/'+filePath;

        // Gets the url to download the file
        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                var location = UtilsDB.parseJSON( response ).location;
                self.request( {
                    method: HTTPMethod.GET,
                    url: location,
                    success: function ( fileData ) {
                        resolve( fileData );
                    },
                    error: function ( errorFileData ) {
                        resolve( errorFileData, true );
                    },
                    responseType: file.responseType,
                    useToken: false
                } );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    delete: function ( file ) {

        // We also could build the url as (in that case we need the object and the object type as arguments):
        // var filePath = element.path + '/' + element.name;
        // var url = this.getServerUrl() + '/catalog/collage/' + objectType + '/' + objectId + '/files/'+filePath;

        var url = file.href;

        return this.request( {
            method: HTTPMethod.DELETE,
            url: url,
            success: function ( response, resolve ) {
                resolve( UtilsDB.parseJSON( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    /**
     * Returns if the current list of files and/or folders has a next page.
     * @method
     * @memberof pcvizDataAccess.CollageWebFileBrowser
     * @return {boolean} true if there is another page, false in other case
     */
    isEnabledNextPage: function () {
        return this._currentResponse && this._currentResponse.nextPage !== undefined;
    },

    isFolder: function ( objectInfo ) {
        return objectInfo.kind === 'D';
    },

    getCurrentFolder: function () {
        return this._currentFolder;
    },

    setPageSize: function ( size ) {
        PAGE_SIZE = size;
    },

    clearCurrentFiles: function () {
        this._currentFiles = [];
    }

} ) );


module.exports = CollageWebFileBrowser;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js":
/*!**********************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/SpatialDataIterator */ "./sources/pcvizDataAccess/DataIterators/SpatialDataIterator.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  CollageDataIterator Base Class of all the Collage Data Iterators (pointcloud, vector, etc.)
 *  @class
 *  @memberof pcvizDataAccess
 */
var CollageDataIterator = function ( collageDriver, layerObject ) {
    SpatialDataIterator.call( this, layerObject );
    this._collageDriver = collageDriver;
    this._dirtyConfiguration = false;
};

CollageDataIterator.prototype = Utils.objectInherit( SpatialDataIterator.prototype, {
    /**
     *
     *  @method
     *  Method for initialize the data from the server, can be overriden if required by
     *  specific iterators
     *  @return {promise}
     */
    initIterator: function () {
        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    reset: function () {

    },

    getMinX: function () {
        return this._layerObject.minx;
    },

    getMaxX: function () {
        return this._layerObject.maxx;
    },

    getMinY: function () {
        return this._layerObject.miny;
    },

    getMaxY: function () {
        return this._layerObject.maxy;
    },

    getMinZ: function () {
        return this._layerObject.minz;
    },

    getMaxZ: function () {
        return this._layerObject.maxz;
    },

    getId: function () {
        return this._layerObject.id;
    },

    getName: function () {
        return this._layerObject.name;
    },

    getType: function () {
        return this._layerObject.layerType;
    },

    /**
     * @method
     * Get the category
     * @memberof pcvizDataAccess.CollageDataIterator
     * @return {string}  the category of the layer
     */
    getCategory: function () {
        return this._layerObject.category.split( '/' ).pop();
    },

    getConfiguration: function () {
        return this._layerObject.configuration;
    },

    getConfigurationAttribute: function ( name ) {
        return this.getConfiguration()[ name ];
    },

    setConfiguration: function ( config ) {
        this._dirtyConfiguration = true;
        this._layerObject.configuration = config;
    },

    setConfigurationAttribute: function ( name, value ) {
        this.getConfiguration()[ name ] = value;
    },

    isConfigurationDirty: function () {
        return this._dirtyConfiguration;
    },

    clearDirtyConfiguration: function () {
        this._dirtyConfiguration = false;
    },

    /**
     * @method
     * Gets the spatial reference of a CollageDataIterator
     * @memberof pcvizDataAccess.CollageDataIterator
     * @return {string}  the epsg projecttion of the layer
     */
    getSpatialReference: function () {
        return this._layerObject.horizProjectionEPSG;
    },

} );

module.exports = CollageDataIterator;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/CollageVectorDataIterator.js":
/*!****************************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/CollageVectorDataIterator.js ***!
  \****************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var CollageDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/CollageDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var Point = __webpack_require__( /*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js" ).default;
var MultiPoint = __webpack_require__( /*! pcvizGIS/MultiPoint */ "./sources/pcvizGIS/MultiPoint.js" ).default;
var LineString = __webpack_require__( /*! pcvizGIS/LineString */ "./sources/pcvizGIS/LineString.js" ).default;
var Polygon = __webpack_require__( /*! pcvizGIS/Polygon */ "./sources/pcvizGIS/Polygon.js" ).default;
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

/**
 *  FeatureJSON Auxiliar Class for passing basic information around
 *  @class
 *  @memberof pcvizDataAccess
 */
var FeatureJSON = function () {
    this.name = '';
    this.description = '';
    /* jshint ignore:start */
    this.the_geom = null;
    /* jshint ignore:end */
};

/**
 *  CollageVectorDataIterator Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var CollageVectorDataIterator = function ( collageDriver, layerObject ) {
    CollageDataIterator.call( this, collageDriver, layerObject );
    this._collageDriver = collageDriver;

    this._totalCount = undefined;

    // geoJSON driver
    this._geoJSONDriver = undefined;
    this._geoJSONDataIterator = undefined; // the current used

    this._geoJSONDataIterators = new Map(); // there is one for each filter


    this._featureFunctions = {};
    this._featureFunctions[ VectorLayerUtils.ADD_FEATURE ] = this._collageDriver.addFeature.bind( this._collageDriver );
    this._featureFunctions[ VectorLayerUtils.UPDATE_FEATURE ] = this._collageDriver.updateFeature.bind( this._collageDriver );
    this._featureFunctions[ VectorLayerUtils.DELETE_FEATURE ] = this._collageDriver.deleteFeature.bind( this._collageDriver );

};

CollageVectorDataIterator.prototype = Utils.objectInherit( CollageDataIterator.prototype, {
    /**
     *
     *  @method
     *  Method for initialize the data from the server
     *  @override
     *  @return {promise}
     */
    initIterator: function ( configPage ) {

        this._geoJSONDataIterators.clear();

        if ( !configPage ) {
            configPage = {
                'page': 1,
                'page_size': this._layerObject.category === VectorLayerUtils.Categories.VERITY_REPORT ? UtilsDB.VERITY_PAGE_SIZE : UtilsDB.PAGE_SIZE
            };

            return this.initPages( configPage );
        }

        return this.initPage( configPage );
    },

    clone: function () {
        var cloned = new CollageVectorDataIterator( this._collageDriver, this._layerObject );

        cloned._totalCount = this._totalCount;
        cloned._geoJSONDriver = this._geoJSONDriver;
        cloned._geoJSONDataIterator = this._geoJSONDataIterator;

        cloned._geoJSONDataIterators = this._geoJSONDataIterators;
        return cloned;
    },

    initPages: function ( configPage ) {
        var defer = P.defer();
        var self = this;

        this.initPage( configPage ).then( function () {
            if ( self._totalCount / configPage[ 'page_size' ] > configPage.page ) {
                configPage.page++;
                self.initPages( configPage ).then( function () {
                    defer.resolve();
                } ).catch( function () {
                    defer.reject();
                } );
            } else {
                defer.resolve();
            }
        } ).catch( function () {
            defer.reject();

        } );

        return defer.promise;
    },


    initPage: function ( configPage ) {
        var defer = P.defer();
        var self = this;

        this._collageDriver.getFeatures( this._layerObject.id, configPage ).then( function ( page ) {
            self._totalCount = page.count;
            // if there is not initialized the geoJSON driver
            if ( self._geoJSONDriver === undefined ) {
                // getting the driver from registry
                self._geoJSONDriver = DriverRegistry.getInstance().getDriver( 'da.geoJSON' );
                // setting up the driver from data
            }
            var configId = JSON.parse( JSON.stringify( configPage ) );
            configId.id = self._layerObject.id;
            self._geoJSONDriver.openFromData( page.results, configId );
            self._geoJSONDriver.getSourceLayerById( configId ).then( function ( dataIterator ) {
                self._geoJSONDataIterator = dataIterator;

                self._geoJSONDataIterators.set( JSON.stringify( configPage ), dataIterator );

                defer.resolve();
            } );
        } ).catch( function () {
            defer.reject();
        } );
        return defer.promise;
    },

    getFeatureId: function () {
        var out;
        if ( this._geoJSONDataIterator !== undefined ) {
            out = this._geoJSONDataIterator.getFeatureId();
        }
        return out;
    },

    getDataByName: function ( colName ) {
        var out;
        if ( this._geoJSONDataIterator !== undefined ) {
            out = this._geoJSONDataIterator.getDataByName( colName );
        }
        return out;
    },

    getDataByIndex: function ( index ) {
        var out;
        if ( this._geoJSONDataIterator !== undefined ) {
            // Since the order of the properties and the featureDefinition properties can be
            // in different order we need to query the featureDefinition index to retrieve the
            // the correct name of the index.
            out = this._geoJSONDataIterator.getDataByName( this.getFieldName( index ) );
        }
        return out;
    },

    next: function () {
        if ( this._geoJSONDataIterator !== undefined ) {
            return this._geoJSONDataIterator.next();
        }
        return false;
    },

    moveToLastIndex: function () {
        if ( this._geoJSONDataIterator !== undefined ) {
            return this._geoJSONDataIterator.moveToLastIndex();
        }
        return false;
    },

    moveToPreviousIndex: function () {
        if ( this._geoJSONDataIterator !== undefined ) {
            return this._geoJSONDataIterator.moveToPrevious();
        }
        return false;
    },

    reset: function () {
        if ( this._geoJSONDataIterator !== undefined ) {
            this._geoJSONDataIterator.reset();
        }
    },

    /**
     * Return the total count of features in the layer
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @return {int} the count of features in the layer
     */
    totalSize: function () {
        return this._totalCount;
    },

    /**
     * Return the count of features that are on the current page
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @return {int} the count of features that are on the current page
     */
    size: function () {
        if ( this._geoJSONDataIterator !== undefined )
            return this._geoJSONDataIterator.size();
        return 0;
    },

    hasFilter: function ( filter ) {
        return ( this._geoJSONDataIterators.get( JSON.stringify( filter ) ) !== undefined );
    },

    setByFilter: function ( filter ) {
        this._geoJSONDataIterator = this._geoJSONDataIterators.get( JSON.stringify( filter ) );
    },

    /**
     * Gets the number of fields for each feature. It is suposse that all the features have the same number of fields
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @return {int} the number of fields for each feature
     */
    getNumFields: function () {
        var out;
        if ( this._layerObject !== undefined && this._layerObject.featureDefinition !== undefined ) {
            out = this._layerObject.featureDefinition.length;
        }
        return out;
    },

    getFieldName: function ( index ) {
        var out;
        if ( this._layerObject !== undefined && this._layerObject.featureDefinition !== undefined ) {
            out = this._layerObject.featureDefinition[ index ].field;
        }
        return out;
    },

    getFieldType: function ( index ) {
        var out;
        if ( this._layerObject !== undefined && this._layerObject.featureDefinition !== undefined ) {
            out = this._layerObject.featureDefinition[ index ].type;
        }
        return out;
    },

    getField: function ( index ) {
        var out;
        if ( this._layerObject !== undefined && this._layerObject.featureDefinition !== undefined ) {
            out = this._layerObject.featureDefinition[ index ];
        }
        return out;
    },

    getFieldIndex: function ( colName ) {
        var out;
        if ( this._layerObject.featureDefinition !== undefined ) {
            for ( var i = 0, j = this._layerObject.featureDefinition.length; i < j; i++ ) {
                if ( this._layerObject.featureDefinition[ i ].field === colName ) {
                    out = i;
                    break;
                }
            }
        }
        return out;
    },

    getGeometry: function () {
        var geometry;
        if ( this._geoJSONDataIterator !== undefined ) {
            geometry = this._geoJSONDataIterator.getGeometry();
        }

        return geometry;
    },

    getGeometryType: function () {
        var geomType;

        // if there aren't any features (REVIEW when we have a method to get the attributes for the FeatureDefinition)
        switch ( this._layerObject.geometryType ) {

        case 'Point':
            geomType = FeatureDefinition.POINT;
            break;
            // if it is line string type
        case 'LineString':
            geomType = FeatureDefinition.LINE;
            break;
            // if it is polygon type
        case 'Polygon':
            geomType = FeatureDefinition.POLYGON;
            break;
            // if it is multipoint type
        case 'MultiPoint':
            geomType = FeatureDefinition.MULTIPOINT;
            break;
        }
        return geomType;
    },

    /**************************************************************/
    /*  EDITION
    /**************************************************************/
    /**
     * Get a JSON object from a Geometry object
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {pcvizGIS.Feature} f the feature which geometry we want convert it
     * @return {object} the geometry
     */
    getGeometryFromFeature: function ( f ) {
        var geometry = f.getGeometry();
        var geomJSON = {};
        var i;

        if ( geometry instanceof Point ) {
            geomJSON[ 'type' ] = 'Point';
            if ( geometry.getCoordinateDimension() === 2 )
                geomJSON[ 'coordinates' ] = [ geometry.getX(), geometry.getY(), 0 ];
            else
                geomJSON[ 'coordinates' ] = [ geometry.getX(), geometry.getY(), geometry.getZ() ];
        } else if ( geometry instanceof LineString ) {
            geomJSON[ 'type' ] = 'LineString';
            geomJSON[ 'coordinates' ] = [];
            for ( i = 0; i < geometry.getNumPoints(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getX( i ), geometry.getY( i ), 0 ];
                else
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getX( i ), geometry.getY( i ), geometry.getZ( i ) ];
            }
        } else if ( geometry instanceof Polygon ) {
            geomJSON[ 'type' ] = 'Polygon';
            geomJSON[ 'coordinates' ] = [];
            var ring = geometry.getExteriorRing();
            // We call closeRings to avoid a possible error
            ring.closeRings();
            geomJSON[ 'coordinates' ][ 0 ] = [];
            for ( i = 0; i < ring.getNumPoints(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ 0 ][ i ] = [ ring.getX( i ), ring.getY( i ), 0 ];
                else
                    geomJSON[ 'coordinates' ][ 0 ][ i ] = [ ring.getX( i ), ring.getY( i ), ring.getZ( i ) ];
            }
            for ( var j = 0; j < geometry.getNumInteriorRings(); j++ ) {
                var jRing = geometry.getInteriorRing( j );
                // We call closeRings to avoid a possible error
                jRing.closeRings();
                geomJSON[ 'coordinates' ][ j + 1 ] = [];
                for ( i = 0; i < jRing.getNumPoints(); i++ ) {
                    if ( geometry.getCoordinateDimension() === 2 )
                        geomJSON[ 'coordinates' ][ j + 1 ][ i ] = [ jRing.getX( i ), jRing.getY( i ), 0 ];
                    else
                        geomJSON[ 'coordinates' ][ j + 1 ][ i ] = [ jRing.getX( i ), jRing.getY( i ), jRing.getZ( i ) ];
                }
            }
        } else if ( geometry instanceof MultiPoint ) {
            geomJSON[ 'type' ] = 'MultiPoint';
            geomJSON[ 'coordinates' ] = [];
            for ( i = 0; i < geometry.getNumGeometries(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getGeometry( i ).getX(), geometry.getGeometry( i ).getY(), 0 ];
                else
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getGeometry( i ).getX(), geometry.getGeometry( i ).getY(), geometry.getGeometry( i ).getZ() ];
            }
        }
        return geomJSON;
    },

    getGeoJSONfeature: function ( f ) {

        var fjson = new FeatureJSON();

        var properties = f._attributes;
        var featureDefinition = f.getLayer().getFeatureDefinition();

        for ( var i = 0; i < featureDefinition.getNumFields(); i++ ) {
            /* This is ok as long as the order in the attributes matches the field definition */
            fjson[ featureDefinition.getFieldName( i ) ] = properties[ i ];
        }
        /* jshint ignore:start */
        fjson.the_geom = this.getGeometryFromFeature( f );
        /* jshint ignore:end */

        return fjson;
    },

    /**
     * Adds a feature in json format
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {Feature} feature  the feature to be added
     */
    addGeoJSONFeature: function ( geoJSONfeature ) {
        var defer = P.defer();
        var self = this;
        if ( !geoJSONfeature ) {
            defer.reject();
            return defer.promise;
        }

        if ( Array.isArray( geoJSONfeature ) ) {
            geoJSONfeature = {
                'features': geoJSONfeature
            };
        }

        this._collageDriver.addFeature( geoJSONfeature, this._layerObject.id ).then( function () {
            self.initIterator().then( function () {
                defer.resolve();
            } ).catch( function () {
                defer.reject();
            } );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    /**
     * Updates the iterator (It can add/update/delete a feature)
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param  {string} method the method name (it can be: 'add','update', 'delete')
     * @param  {Feature} feature the feature to be added/updated/deleted
     */
    update: function ( method, feature ) {
        if ( !method || !feature )
            return this.initIterator();
        var defer = P.defer();
        var geoJSONfeature = this.getGeoJSONfeature( feature );
        var self = this;

        this._featureFunctions[ method ]( this._layerObject.id, feature, geoJSONfeature ).then( function ( response ) {
            // reloading the data
            self.initIterator().then( function () {
                defer.resolve( response );
            } ).catch( function () {
                defer.reject();
            } );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    /**
     * Returns the GeoJSON object with all layer features
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @return {JSON} The GeoJSON object
     */
    getGeoJSONObject: function ( page ) {
        return this._geoJSONDataIterator.getGeoDriver().getGeoObject( page );
    }

} );

module.exports = CollageVectorDataIterator;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/DataIterator.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/DataIterator.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  DataIterator Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var DataIterator = function ( layerObject ) {
    this._layerObject = layerObject;
    this._dirtyAttributes = {};
    this.clear();
};

DataIterator.prototype = {

    /**
     * Sets all attributes not dirty.
     * @method
     * @memberof pcvizDataAccess.DataIterator
     */
    clear: function () {
        for ( var attr in this._layerObject )
            this._dirtyAttributes[ attr ] = false;
    },

    /**
     * @method
     * Return the value of a field by column name
     * @memberof pcvizDataAccess.DataIterator
     * @param  {Object} colName The name of the column to search
     * @return {object} the element find or undefined if the element is not find
     */
    getDataByName: function ( /*colName*/) {
        console.log( 'DataIterator.getDataByName: Not implemented' );
        return undefined;
    },


    /**
     * @method
     * Return the value of a column by id (position)
     * @memberof pcvizDataAccess.DataIterator
     * @param  {Object} index of the column to search
     * @return {object} the element find or undefined if the element is not find
     */
    getDataByIndex: function ( /*index*/) {
        console.log( 'DataIterator.getDataByIndex: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Move the iterator to the next feature
     * @memberof pcvizDataAccess.DataIterator
     */
    next: function () {
        console.log( 'DataIterator.next: Not implemented' );
    },


    /**
     * @method
     * Reset the iterator to the first element
     * @memberof pcvizDataAccess.DataIterator
     */
    reset: function () {
        console.log( 'DataIterator.reset: Not implemented' );
    },

    /**
     * @method
     * Return the number of elements
     * @memberof pcvizDataAccess.DataIterator
     * @return {int} the number of elements
     */
    size: function () {
        console.log( 'DataIterator.size: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the num of fields of each feature ( all the features have the same num of fields )
     * Return the number of elements
     * @memberof pcvizDataAccess.DataIterator
     * @return {int} Number of fields
     */
    getNumFields: function () {
        console.log( 'DataIterator.getNumFields: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the field search by id (position)
     * @param {int} the position of the element to retrieve
     * @memberof pcvizDataAccess.DataIterator
     * @return {string}  the name of the column
     */
    getFieldName: function ( /*index*/) {
        console.log( 'DataIterator.getFieldName: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the field search by name
     * @param {int} the name of the element to retrieve
     * @memberof pcvizDataAccess.DataIterator
     * @return {string}  the id of the column
     */
    getFieldIndex: function ( /*colName*/) {
        console.log( 'DataIterator.getFieldIndex: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the id
     * @memberof pcvizDataAccess.DataIterator
     * @return {string}  the id of the feature
     */
    getFeatureId: function () {
        console.log( 'DataIterator.getFeatureId: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the type
     * @memberof pcvizDataAccess.DataIterator
     * @return {object}  the type of the layer
     */
    getType: function () {
        console.log( 'DataIterator.getType: Not implemented' );
        return undefined;
    },

    /**
     * @method
     * Get the category
     * @memberof pcvizDataAccess.DataIterator
     * @return {object}  the category of the layer
     */
    getCategory: function () {
        console.log( 'DataIterator.getCategory: Not implemented' );
        return undefined;
    },

    /**
     * Adds a feature
     * @method
     * @memberof pcvizDataAccess.DataIterator
     * @param {Feature} f  the feature to be added
     */
    addFeature: function ( /*f*/) {
        console.log( 'DataIterator.addFeature: Not implemented' );
        return undefined;
    },

    /**
     * Deletes a feature
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param  {Feature} f the feature to be deleted
     */
    updateFeature: function ( /*f*/) {
        console.log( 'DataIterator.updateFeature: Not implemented' );
        return undefined;
    },

    /**
     * Updates a feature
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param  {Feature} f the feature to be updated
     */
    deleteFeature: function ( /*f*/) {
        console.log( 'DataIterator.deleteFeature: Not implemented' );
        return undefined;
    },

    /**
     * Return layer object base
     * @method
     * @memberof pcvizDataAccess.DataIterator
     * @return {object} base layer object base
     */
    getLayerObject: function () {
        return this._layerObject;
    },

    /**
     * Gets the value of an attribute
     * @method
     * @memberof pcvizDataAccess.DataIterator
     * @param  {string} name The attribute name.
     * @return {any}      The attribute value.
     */
    getAttribute: function ( name ) {
        return this._layerObject[ name ];
    },

    /**
     * Sets the value of an attribute.
     * @method
     * @memberof pcvizDataAccess.DataIterator
     * @param {string} name  The attribute name.
     * @param {any} value The attribute value.
     */
    setAttribute: function ( name, value ) {
        if ( this._layerObject[ name ] !== value ) {
            this._layerObject[ name ] = value;
            this._dirtyAttributes[ name ] = true;
        }
    },

    /**
     * Returns a `JSON` object containing the keys and values
     * of the object dirty attributes.
     * @method
     * @memberof pcvizDataAccess.DataIterator
     * @return {JSON} The dirty attributes.
     */
    getDirtyAttributes: function () {
        var json = {};
        for ( var key in this._dirtyAttributes )
            if ( this._dirtyAttributes[ key ] )
                json[ key ] = this.getAttribute( key );
        return json;
    }

};

module.exports = DataIterator;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/GeoJSONDataIterator.js":
/*!**********************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/GeoJSONDataIterator.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/SpatialDataIterator */ "./sources/pcvizDataAccess/DataIterators/SpatialDataIterator.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Point = __webpack_require__( /*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js" ).default;
var Polygon = __webpack_require__( /*! pcvizGIS/Polygon */ "./sources/pcvizGIS/Polygon.js" ).default;
var LineString = __webpack_require__( /*! pcvizGIS/LineString */ "./sources/pcvizGIS/LineString.js" ).default;
var LinearRing = __webpack_require__( /*! pcvizGIS/LinearRing */ "./sources/pcvizGIS/LinearRing.js" ).default;
var MultiPoint = __webpack_require__( /*! pcvizGIS/MultiPoint */ "./sources/pcvizGIS/MultiPoint.js" ).default;
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

// FIXME: check that features.length > 0 in functions which use features[0]
// getGeometryType, getNumFields, getFieldName, getFieldIndex

/**
 * Class to make the parse
 * @class
 * @memberof pcvizDataAccess
 */
var GeoJSONFeature = function () {
    this.id = -1;
    this.type = 'Feature';
    this.properties = {};
    this.geometry = undefined;
};

/**
 *  GeoJSONDataIterator Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var GeoJSONDataIterator = function ( GeoDriver, layerObject ) {
    SpatialDataIterator.call( this, layerObject );
    this._geoDriver = GeoDriver;
    this._currentPos = -1; // the default pos it is -1, an invalid position. This is to make the iteration well using next.
};

GeoJSONDataIterator.prototype = Utils.objectInherit( SpatialDataIterator.prototype, {

    getDataByName: function ( colName ) {
        // getting the data of current column indexed by name, using the current pos of the iterator
        return this._layerObject.features[ this._currentPos ].properties[ colName ];
    },

    getDataByIndex: function ( index ) {
        var obj;
        var properties = this._layerObject.features[ this._currentPos ].properties;
        var keys = window.Object.keys( properties );

        // iterate over the data column to find the current index to retrive the data
        for ( var i = 0; i < keys.length; i++ ) {
            if ( i === index ) {
                obj = properties[ keys[ i ] ];
                break;
            }
        }

        return obj;
    },

    next: function () {
        // increment the iterator.
        var out = false;
        if ( this._currentPos < this.size() - 1 ) {
            this._currentPos++;
            out = true;
        }
        return out;
    },

    moveToLastIndex: function () {
        this._currentPos = this.size() - 1;
    },

    moveToPrevious: function () {
        if ( this._currentPos > 0 ) {
            this._currentPos--;
            return true;
        }
        return false;
    },

    reset: function () {
        // reset the current position of the iterator
        this._currentPos = -1;
    },

    size: function () {
        // return the count of features on geoJSON object
        return this._layerObject.features.length;
    },

    getNumFields: function () {
        // getting the number of fields for each feature. It is suposse that all the features have the same number of fields
        if ( this._layerObject.features.length > 0 )
            return window.Object.keys( this._layerObject.features[ 0 ].properties ).length;
        else
            return 0;
    },

    getFieldName: function ( index ) {
        var out;
        if ( this._layerObject.features.length > 0 ) {
            var keys = window.Object.keys( this._layerObject.features[ 0 ].properties );
            keys.forEach( function ( item, i ) {
                if ( i === index )
                    out = item;
            } );
        }
        return out;
    },

    //TODO
    getFieldType: function ( /*index*/) {
        // We can't get the type from the geoJSON. So, we need receive this information from the database.
    },

    getFieldIndex: function ( colName ) {
        var out;
        if ( this._layerObject.features.length > 0 ) {
            var keys = window.Object.keys( this._layerObject.features[ 0 ].properties );
            keys.forEach( function ( item, i ) {
                if ( item === colName )
                    out = i;
            } );
        }
        return out;
    },

    /**
     * Get a Geometry object from a JSON object
     * @method
     * @memberof pcvizDataAccess.GeoJSONDataIterator
     * @return {pcvizGIS.Feature} the geometry
     */
    getGeometry: function () {

        var geometry;
        // depending of the type of geometry the method retuns a certain geometry (point, lineString, polygon, multipoint)
        var g = this._layerObject.features[ this._currentPos ].geometry;
        switch ( g.type ) {
            // If it is point type
        case 'Point':
            geometry = new Point(); // creating the point geometry
            geometry.setX( g.coordinates[ 0 ] ); // setting up the coordinates
            geometry.setY( g.coordinates[ 1 ] );
            if ( g.coordinates.length === 3 ) { // the Z coordinate it is only set if is necessary
                geometry.setZ( g.coordinates[ 2 ] );
            } else if ( g.coordinates.length === 2 )
                geometry.setCoordinateDimension( 2 );
            break;
            // if it is line string type
        case 'LineString':
            geometry = new LineString(); // creating the line string geometry for the ring
            for ( var i = 0; i < g.coordinates.length; i++ ) {
                var pls = new Point();
                pls.setX( g.coordinates[ i ][ 0 ] );
                pls.setY( g.coordinates[ i ][ 1 ] );
                if ( g.coordinates[ i ].length === 3 ) {
                    pls.setZ( g.coordinates[ i ][ 2 ] );
                } else if ( g.coordinates[ i ].length === 2 ) //If any point has only two coordinates, the coordinate dimension of the geometry is 2
                    geometry.setCoordinateDimension( 2 );
                geometry.addPoint( pls ); // adding the point to ring
            }
            break;
            // if it is polygon type
        case 'Polygon':
            geometry = new Polygon(); // creating the polygon geometry
            for ( var iRing = 0; iRing < g.coordinates.length; iRing++ ) {
                var ring = new LinearRing(); // creating the line ring
                for ( var iPoint = 0; iPoint < g.coordinates[ iRing ].length; iPoint++ ) {
                    var plr = new Point();

                    plr.setX( g.coordinates[ iRing ][ iPoint ][ 0 ] );
                    plr.setY( g.coordinates[ iRing ][ iPoint ][ 1 ] );
                    if ( g.coordinates[ iRing ][ iPoint ].length === 3 ) {
                        plr.setZ( g.coordinates[ iRing ][ iPoint ][ 2 ] );
                    } else if ( g.coordinates[ iRing ][ iPoint ].length === 2 ) //If any point has only two coordinates, the coordinate dimension of the geometry is 2
                        geometry.setCoordinateDimension( 2 );
                    ring.addPoint( plr ); // adding points to the ring
                }
                // We call closeRings to avoid a possible error
                ring.closeRings();
                // If it's the exterior ring, check that the winding order is correct. If it isn't correct, reverse it.
                if ( iRing === 0 ) {
                    if ( !ring.isClockwise() )
                        ring.reverseWindingOrder();
                }
                // If it's an interior ring, check that the winding order is correct. If it isn't correct, reverse it.
                else if ( iRing > 0 ) {
                    if ( ring.isClockwise() )
                        ring.reverseWindingOrder();
                }
                geometry.addRing( ring ); // adding the ring to the geometry
            }

            break;

            // if it is multipoint type
        case 'MultiPoint':
            geometry = new MultiPoint(); // creating the multipoint geometry
            for ( var iPoints = 0; iPoints < g.coordinates.length; iPoints++ ) {
                var p = new Point( g.coordinates[ iPoints ][ 0 ], g.coordinates[ iPoints ][ 1 ] );
                if ( g.coordinates[ iPoints ].length === 3 ) { // the Z coordinate it is only set if is necessary
                    p.setZ( g.coordinates[ iPoints ][ 2 ] );
                } else if ( g.coordinates[ iPoints ].length === 2 ) //If any point has only two coordinates, the coordinate dimension of the geometry is 2
                    geometry.setCoordinateDimension( 2 );
                geometry.addGeometry( p );
            }

            break;

            // Someday we can add more cases for other collection types
        }

        return geometry;
    },

    /**
     * Get the Geometry type from a JSON object
     * @method
     * @memberof pcvizDataAccess.GeoJSONDataIterator
     * @return {pcvizGIS.Feature} the geometry
     */
    getGeometryType: function () {
        // We only support layerObjects of the same feature
        // So it is safe to get the geometry for the first element.
        var type;
        if ( this._layerObject.features.length > 0 ) {
            var g = this._layerObject.features[ 0 ].geometry;

            switch ( g.type ) {

            case 'Point':
                type = FeatureDefinition.POINT;
                break;
                // if it is line string type
            case 'LineString':
                type = FeatureDefinition.LINE;
                break;
                // if it is polygon type
            case 'Polygon':
                type = FeatureDefinition.POLYGON;
                break;
                // if it is multipoint type
            case 'MultiPoint':
                type = FeatureDefinition.MULTIPOINT;
                break;
            }
        }
        return type;
    },

    /**
     * @method
     * Get the spatial reference. the spatial reference for geoJSON it is a string or a link to a file
     * this method does not parse the geoJSON epsg.
     * @memberof pcvizDataAccess.GeoJSONDataIterator
     * @return {Object} spatial reference
     */
    getSpatialReference: function () {

        return this._layerObject.crs;
    },
    setSpatialReference: function ( crs ) {

        this._layerObject.crs = crs;
    },

    getFeatureId: function () {
        return this._layerObject.features[ this._currentPos ].id;
    },

    getFeature: function () {
        return this._layerObject.features[ this._currentPos ];
    },

    /**
     * Get a JSON object from a Geometry object
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param {pcvizGIS.Feature} f the feature which geometry we want convert it
     * @return {object} the geometry
     */
    getGeometryFromFeature: function ( f ) {
        var geometry = f.getGeometry();
        var geomJSON = {};
        var i;

        if ( geometry instanceof Point ) {
            geomJSON[ 'type' ] = 'Point';
            if ( geometry.getCoordinateDimension() === 2 )
                geomJSON[ 'coordinates' ] = [ geometry.getX(), geometry.getY() ];
            else
                geomJSON[ 'coordinates' ] = [ geometry.getX(), geometry.getY(), geometry.getZ() ];
        } else if ( geometry instanceof LineString ) {
            geomJSON[ 'type' ] = 'LineString';
            geomJSON[ 'coordinates' ] = [];
            for ( i = 0; i < geometry.getNumPoints(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getX( i ), geometry.getY( i ) ];
                else
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getX( i ), geometry.getY( i ), geometry.getZ( i ) ];
            }
        } else if ( geometry instanceof Polygon ) {
            geomJSON[ 'type' ] = 'Polygon';
            geomJSON[ 'coordinates' ] = [];
            var ring = geometry.getExteriorRing();
            // We call closeRings to avoid a possible error
            ring.closeRings();
            geomJSON[ 'coordinates' ][ 0 ] = [];
            for ( i = 0; i < ring.getNumPoints(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ 0 ][ i ] = [ ring.getX( i ), ring.getY( i ) ];
                else
                    geomJSON[ 'coordinates' ][ 0 ][ i ] = [ ring.getX( i ), ring.getY( i ), ring.getZ( i ) ];
            }
            for ( var j = 0; j < geometry.getNumInteriorRings(); j++ ) {
                var jRing = geometry.getInteriorRing( j );
                // We call closeRings to avoid a possible error
                jRing.closeRings();
                geomJSON[ 'coordinates' ][ j + 1 ] = [];
                for ( i = 0; i < jRing.getNumPoints(); i++ ) {
                    if ( geometry.getCoordinateDimension() === 2 )
                        geomJSON[ 'coordinates' ][ j + 1 ][ i ] = [ jRing.getX( i ), jRing.getY( i ) ];
                    else
                        geomJSON[ 'coordinates' ][ j + 1 ][ i ] = [ jRing.getX( i ), jRing.getY( i ), jRing.getZ( i ) ];
                }
            }
        } else if ( geometry instanceof MultiPoint ) {
            geomJSON[ 'type' ] = 'MultiPoint';
            geomJSON[ 'coordinates' ] = [];
            for ( i = 0; i < geometry.getNumGeometries(); i++ ) {
                if ( geometry.getCoordinateDimension() === 2 )
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getGeometry( i ).getX(), geometry.getGeometry( i ).getY() ];
                else
                    geomJSON[ 'coordinates' ][ i ] = [ geometry.getGeometry( i ).getX(), geometry.getGeometry( i ).getY(), geometry.getGeometry( i ).getZ() ];
            }
        }
        return geomJSON;
    },

    /**
     * Adds a feature
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param {Feature} f  the feature to be added
     */
    addFeature: function ( f ) {
        //FIXME: we use here a promise because of this method in CollageCloudVectorDataIterator needs to use a promise.
        var defer = P.defer();

        var geoJSONFeature = new GeoJSONFeature();

        geoJSONFeature.id = f.getId();

        var properties = this._layerObject.features[ 0 ].properties;
        var keys = window.Object.keys( properties );
        for ( var i = 0; i < keys.length; i++ ) {
            geoJSONFeature.properties[ keys[ i ] ] = f.getAttributeByName( keys[ i ] );
        }

        geoJSONFeature.geometry = this.getGeometryFromFeature( f );

        this._layerObject.features[ this._layerObject.features.length ] = geoJSONFeature;

        defer.resolve();
        return defer.promise;
    },

    /**
     * Deletes a feature
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param  {Feature} f the feature to be deleted
     */
    deleteFeature: function ( f ) {
        //FIXME: we use here a promise because of this method in CollageCloudVectorDataIterator needs to use a promise.
        var defer = P.defer();

        for ( var i = 0; i < this._layerObject.features.length; i++ ) {
            if ( this._layerObject.features[ i ].id === f.getId() ) {
                this._layerObject.features.splice( i, 1 );
                break;
            }
        }

        defer.resolve();
        return defer.promise;
    },

    /**
     * Updates a feature
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @param  {Feature} f the feature to be updated
     */
    updateFeature: function ( f ) {

        //FIXME: we use here a promise because of this method in CollageCloudVectorDataIterator needs to use a promise.
        var defer = P.defer();

        var properties = this._layerObject.features[ 0 ].properties;
        var keys = window.Object.keys( properties );

        for ( var i = 0; i < this._layerObject.features.length; i++ ) {
            if ( this._layerObject.features[ i ].id === f.getId() ) {

                // Set the properties and geometry (I think that the id and the type can't change)
                for ( var j = 0; j < keys.length; j++ ) {
                    this._layerObject.features[ i ].properties[ keys[ j ] ] = f.getAttributeByName( keys[ j ] );
                }

                this._layerObject.features[ i ].geometry = this.getGeometryFromFeature( f );

                break;
            }
        }

        defer.resolve();
        return defer.promise;
    },

    /**
     * Returns the GeoDriver
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @return {GeoDriver} The GeoDriver
     */
    getGeoDriver: function () {
        return this._geoDriver;
    }

} );

module.exports = GeoJSONDataIterator;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/SpatialDataIterator.js":
/*!**********************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/SpatialDataIterator.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/DataIterator */ "./sources/pcvizDataAccess/DataIterators/DataIterator.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
/**
 *  SpatialDataIterator Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var SpatialDataIterator = function ( layerObject ) {
    DataIterator.call( this, layerObject );
};

SpatialDataIterator.prototype = Utils.objectInherit( DataIterator.prototype, {

    /**
     * @method
     * Get the spatial reference
     * @memberof pcvizDataAccess.SpatialDriver
     * @return {Object} geometry
     */
    getGeometry: function () {
        console.log( 'SpatialDataIterator.getGeometry: Not implemented' );
    },
    /**
     * @method
     * Get the spatial reference
     * @memberof pcvizDataAccess.SpatialDataIterator
     * @return {Object} spatial reference
     */
    getSpatialReference: function () {
        console.log( 'SpatialDataIterator.getSpatialReference: Not implemented' );
    },

    /**
     * Get the geometry type
     * @memberof pcvizDataAccess.SpatialDataIterator
     * @return {Integer} [description]
     */
    getGeometryType: function () {
        console.log( 'SpatialDataIterator.getGeometryType: Not implemented' );
    }

} );

module.exports = SpatialDataIterator;


/***/ }),

/***/ "./sources/pcvizDataAccess/DataIterators/WorkspaceLayerGroupDataIterator.js":
/*!**********************************************************************************!*\
  !*** ./sources/pcvizDataAccess/DataIterators/WorkspaceLayerGroupDataIterator.js ***!
  \**********************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceLayerGroupDataIterator; });
/* harmony import */ var pcvizDataAccess_DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/DataIterators/CollageDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js");
/* harmony import */ var pcvizDataAccess_DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js");



class WorkspaceLayerGroupDataIterator extends pcvizDataAccess_DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor( collageDriver, layerObject ) {
        super( collageDriver, layerObject );

        this._currentPos = -1;
    }

    /**
     * Currently, workspace objects don't have a featureDefinition
     * It may be implemented in the future
     */
    getNumFields() {
        if ( !this._layerObject || !this._layerObject.featureDefinition ) {
            return undefined;
        }
        return this._layerObject.featureDefinition.length;
    }

    getField( index ) {
        if ( !this._layerObject || !this._layerObject.featureDefinition ) {
            return undefined;
        }
        return this._layerObject.featureDefinition[ index ];
    }

    next() {
        let out = false;
        if ( this._currentPos < this.size() - 1 ) {
            this._currentPos++;
            out = true;
        }
        return out;
    }

    /**
     * Retu
     */
    getFeatureId() {
        return 1;
    }

    /**
     * Returns the number of features of the virtual LayerGroup
     */
    totalSize() {
        return 1;
    }

    /**
     * Returns the number of features of the virtual LayerGroup
     */
    size() {
        return 1;
    }

    /**
     * Returns the geometry of the feature of the virtual LayerGroup
     */
    getGeometry() {
        return new pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_1__["default"]( 0.0, 0.0, 0.0 );
    }

    reset() {
        this._currentPos = -1;
    }
}


/***/ }),

/***/ "./sources/pcvizDataAccess/DriverRegistry.js":
/*!***************************************************!*\
  !*** ./sources/pcvizDataAccess/DriverRegistry.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Driver registry Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var DriverRegistry = {
    /*
    createInstance: function () {
        return object;
    },/**/

    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizDataAccess.DriverRegistry
     * @return {Object} The `Registry` instance.
     */
    getInstance: function () {
        if ( !DriverRegistry.instance ) {
            DriverRegistry.instance = this;
            DriverRegistry.instance.drivers = new Map();
        }
        return DriverRegistry.instance;
    },

    /**
     * Registers a driver.
     * @method
     * @memberof pcvizDataAccess.DriverRegistry
     * @param  {string} name           The name of the driver.
     * @param  {Driver} driverInstance The driver instance.
     */
    registerDriver: function ( name, driverInstance ) {
        if ( DriverRegistry.instance.drivers.get( name ) !== undefined )
            console.log( 'the driver already exists' );
        DriverRegistry.instance.drivers.set( name, driverInstance );
    },

    /**
     * Gets a driver.
     * @method
     * @memberof pcvizDataAccess.DriverRegistry
     * @param  {string} name The name of the driver.
     * @return {Driver}      The driver instance.
     */
    getDriver: function ( name ) {
        return DriverRegistry.instance.drivers.get( name );
    },

    /**
     * Clears the list of registered drivers.
     * @method [name]
     * @memberof pcvizDataAccess.DriverRegistry
     */
    unregisterAllDrivers: function () {
        DriverRegistry.instance.drivers.clear();
    },

    resetDrivers: function () {
        DriverRegistry.instance.drivers.forEach( function ( driver ) {
            driver.reset();
        } );
    }

};


module.exports = DriverRegistry;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js":
/*!********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

let SpatialDataBaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/SpatialDataBaseDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const SiteEntryPoints = __webpack_require__( /*! pcvizDataAccess/EntryPoints */ "./sources/pcvizDataAccess/EntryPoints.js" ).SiteEntryPoints;

/**
 *  BaseDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var BaseDriver = function () {
    SpatialDataBaseDriver.call( this );

    this._open = false;
    this._serverUrl = '';

    // for login
    this._user = undefined;
    this._pass = undefined;
    this._loginEnabled = true;
    this._storageUrl = undefined;

    // Project Data
    this._projectId = undefined;

    // Layer data
    this._layerType = undefined; // this data is fixed and never chages. It is retrive after login phase

    this._catalogObjectType = undefined;

    // hardcode the mirage default entry points
    // Default entry points
    this._currentEntryPoint = SiteEntryPoints;

    // to indicate if the application is working againts local or magnet server
    this._magnetAPI = undefined;

    // hardcode the layer type. for now there are only two
    this._layerType = [ {
        id: 1,
        name: 'PointCloud',
    }, {
        id: 2,
        name: 'VectorLayer',
    }, {
        id: 4,
        name: 'RasterLayer',
    } ];
};

BaseDriver.MAX_AGE = 'max-age=604800';
BaseDriver.NO_CACHE = 'no-cache';

BaseDriver.prototype = Utils.objectInherit( SpatialDataBaseDriver.prototype, {

    /**
     * Performs an HTTP request. This function needs a configuration object as an argument.
     * Function must always return the promise from the `request` method.
     *
     * Attribute | Description
     * ---|:---
     * `method` | A string indicating the HTTP method to be performed. Use `HTTPMethod` constant.
     * `url` | The url to be requested
     * `data` | A string with the data to be sent as the body request. A JSON object must be converted to string previously.
     * `success` | A callback function with the response text as a parameter that is executed when the request has been completed succesfully. The object returned by this function will be sent as the resolved object of the promise.
     * `error` | A callback function with the response text that is executed when there has been an error in the request. The object returned by this function will be sent as the reject object of the promise.
     * `useToken` | Sets if token must be used in the request. Default to `true`.
     *
     * ## Examples
     * ### Simple request
     * Functions that use the `request` method must return the promise that it returns.
     * ```
     * function simpleRequest() {
     *     return this.request( {
     *         method: HTTPMethod.GET,
     *         url: myURL
     *     } );
     * }
     * ```
     * Functions that call this functions can process that promise as always.
     * ```
     * function useSimpleRequest() {
     *     simpleRequest().then( function () {
     *         // Promise resolved.
     *     } ).catch( function () {
     *         // Error in promise
     *     } );
     * }
     * ```
     * ### Using *success* and *error*
     * In order to pass an object when resolving the request, `success` and/or `error` callbacks must be defined.
     *
     * These functions have the response in text (as it comes from the request), and the proper callback function
     * to resolve/reject the promise.
     *
     * If one or both of these callback functions are not set the promise will be resolved or rejected automatically
     * when the request is done.
     * ```
     * function fullRequest() {
     *     return this.request( {
     *         method: HTTPMethod.GET,
     *         url: myURL,
     *         success: function ( response, resolve ) {
     *             resolve( JSON.parse( response ) );
     *         } ),
     *         error: function ( response, reject ) {
     *             resolve( JSON.parse( response ) );
     *         } ),
     *     } );
     * }
     * ```
     * Functions that call these functions can process that promise as always and use the resolved/rejected object.
     * ```
     * function useFullRequest() {
     *     simpleRequest().then( function ( object ) {
     *         // Promise resolved.
     *     } ).catch( function ( object ) {
     *         // Error in promise
     *     } );
     * }
     * ```
     *
     * ### Performing POST requests
     * In order to pass data in the body of a POST request, `data` attribute must be used as text.
     * ```
     * function postRequest() {
     *     var json = {
     *         key: "value"
     *     };
     *     return this.request( {
     *         method: HTTPMethod.POST,
     *         url: myURL,
     *         data: JSON.parse( json );
     *     } );
     * }
     * ```
     * @method
     * @memberof pcvizDataAccess.BaseDriver
     * @param  {object} config A configuration object described above.
     * @return {Promise}        A promise that is resolved when the request has been completed succesfully and rejected when an error occurs.
     */
    request: function ( config ) {
        let defer = P.defer();

        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if ( this.readyState === XMLHttpRequest.DONE && ( this.status >= 200 && this.status < 300 ) ) {
                if ( config.success ) {
                    var response = ( this.responseType === 'blob' ) ? new Blob( [ this.response ], {
                        type: 'application/octet-stream'
                    } ) : this.responseText;
                    config.success( response, function ( out, reject ) {
                        if ( reject ) {
                            defer.reject( out );
                            return;
                        }
                        defer.resolve( out );
                    } );
                } else
                    defer.resolve();
            } else if ( this.readyState === XMLHttpRequest.DONE && !( this.status >= 200 && this.status < 300 ) ) {
                if ( config.error ) {
                    config.error( this.responseText, function ( out ) {
                        defer.reject( out );
                    } );
                } else {
                    defer.reject( {
                        status: this.status,
                        data: this.response
                    } );
                }
            }
        };

        xmlhttp.onerror = function () {
            defer.reject();
        };

        xmlhttp.onabort = function () {
            defer.reject();
        };

        xmlhttp.upload.onprogress = config.progress;

        xmlhttp.open( config.method, config.url, true );

        var useToken = config.useToken !== undefined ? config.useToken : true;
        if ( useToken && this._magnetAPI.getAuthorizationToken() !== undefined ) // this is possible if the driver is runnig with no login for test
            xmlhttp.setRequestHeader( 'Authorization', this._magnetAPI.getAuthorizationHeader() );

        xmlhttp.setRequestHeader( 'Accept', 'application/json; version=2' );
        xmlhttp.setRequestHeader( 'Content-Type', config.contentType ? config.contentType : 'application/json; charset=UTF-8' );
        if ( config.responseType )
            xmlhttp.responseType = config.responseType;
        if ( config.contentDisposition )
            xmlhttp.setRequestHeader( 'Content-Disposition', config.contentDisposition );
        if ( config.headers ) {
            for ( var key in config.headers ) {
                xmlhttp.setRequestHeader( key, config.headers[ key ] );
            }
        }
        xmlhttp.send( config.data );

        return defer.promise;
    },

    login: function () {
        if ( this._magnetAPI.getAuthorizationToken() !== undefined ) {
            var defer = P.defer();
            defer.resolve();
            return defer.promise;
        }

        var self = this;
        var data = {
            username: this._user,
            password: this._pass
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getServerUrl() + '/api/users/login',
            data: JSON.stringify( data ),
            success: function ( response, resolve ) {
                self._magnetAPI.setAuthorizationToken( JSON.parse( response ).token );
                self._magnetAPI.setAuthorizationType();
                resolve();
            },
            useToken: false
        } );
    },

    setLoginEnabled: function ( enabled ) {
        this._loginEnabled = enabled;
    },
    isLoginEnabled: function () {
        return this._loginEnabled;
    },

    setCredentials: function ( user, pass ) {
        this._user = user;
        this._pass = pass;
    },

    getUserId: function () {
        if ( this._magnetAPI === undefined )
            return undefined;
        return this._magnetAPI.getUserId();
    },

    getAuthorizationToken: function () {
        if ( this._magnetAPI === undefined )
            return undefined;
        return this._magnetAPI.getAuthorizationToken();
    },

    getAuthorizationHeader: function () {
        if ( this._magnetAPI === undefined )
            return undefined;
        return this._magnetAPI.getAuthorizationHeader();
    },

    getServerUrl: function () {
        return this._serverUrl;
    },

    setServerUrl: function ( url ) {
        this._serverUrl = url;
    },

    getStorageUrl: function () {
        return this._storageUrl;
    },

    setStorageUrl: function ( url ) {
        this._storageUrl = url;
    },

    open: function ( connectionString /*, mode*/ ) {

        var defer = P.defer();

        if ( this._open )
            this.close();

        this._open = true;

        if ( !this._loginEnabled ) {
            defer.resolve();
            return defer.promise;
        }

        this._serverUrl = connectionString;

        this.login().then( function () {
            defer.resolve();
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    isOpen: function () {
        return this._open;
    },

    setCurrentEntryPoints: function ( entryPoints ) {
        this._currentEntryPoint = entryPoints;
    },

    setMagnetAPI: function ( magnetAPIconnecting ) {
        this._magnetAPI = magnetAPIconnecting;
    },

    isConnectingFromMagnet: function () {
        var result = false;
        if ( this._magnetAPI !== undefined )
            result = this._magnetAPI.isConnectingFromMagnet();
        return result;
    },

    getResource: function ( resource, id, replaceVars ) {

        var entryPoint = this.getEntryPoint( resource, id );
        if ( replaceVars ) {
            for ( let key in replaceVars ) {
                entryPoint = entryPoint.replace( `{${key}}`, replaceVars[ key ] );
            }
        }

        return this.getServerUrl() + entryPoint;
    },

    entryPointExists: function ( resource ) {
        return this._currentEntryPoint[ resource ] !== undefined;
    },

    getStorageResource: function ( resource, id ) {
        var entryPoint = this.getEntryPoint( resource, id );

        return this.getStorageUrl() + entryPoint;
    },

    getEntryPoint: function ( resource, id ) {
        var urlId = '';
        if ( id !== undefined )
            urlId = id + '/';
        var entryPoint = this._currentEntryPoint[ resource ] + urlId;
        if ( !this.isConnectingFromMagnet() && this._magnetAPI !== undefined && this._magnetAPI.getUserId() !== undefined )
            entryPoint = entryPoint.replace( '{user_id}', this._magnetAPI.getUserId() );
        return entryPoint;
    },

    /**
     * Get layer type from server
     * @method
     * @memberof pcvizDataAccess.BaseDriver
     * @return {Promise}  return all layer type
     */
    getLayerTypeFromServer: function () {
        var defer = P.defer();
        defer.resolve( this._layerType );
        return defer.promise;
    },

    /**
     * Set project id
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} projectId Id of the project
     */
    setProjectId: function ( projectId ) {
        this._projectId = projectId;
    },


    /**
     * get Project id
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {int} Project id
     */
    getProjectId: function () {
        return this._projectId;
    },

    /**
     * Uploads the  thumbnail for an object to a certain URL
     * @method
     * @memberof pcvizDataAccess.BaseDriver
     * @param  {string} url of the thumbnail
     * @param  {object} thumbnail the image to upload
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    uploadThumbnail: function ( url, thumbnail ) {
        return this.request( {
            method: HTTPMethod.PUT,
            url: url,
            data: thumbnail,
            useToken: false,
            contentType: 'image/jpeg',
            headers: {
                'cache-control': BaseDriver.MAX_AGE
            }
        } );
    },

    getObjectFile: function ( object, filePath, noJSON ) {
        let self = this;
        let objectId = object.getId();
        let urlResource = self.getResource( `${self._catalogObjectType}Files`, objectId );
        urlResource = `${urlResource}files/${filePath}`;

        return this.request( {
            method: HTTPMethod.GET,
            url: urlResource,
            success: function ( response, resolve ) {
                self.getFile( JSON.parse( response ).location ).then( function ( fileData ) {
                    if ( noJSON ) {
                        resolve( fileData );
                        return;
                    }
                    resolve( JSON.parse( fileData ) );
                }, function ( error ) {
                    resolve( error, true );
                } );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    /**
     * Uploads a file to the object storage
     * @method
     * @memberof pcvizDataAccess.BaseDriver
     * @param  {Object} object the object
     * @param  {Object} file the file to be uploaded
     * @param  {string} fileName the name of the file that is going to be uploaded
     * @param  {string} contentType the type of the file that is going to be uploaded
     * @return {Promise}              The promise that is resolved when the request is complete.
     */
    uploadObjectFile: function ( object, file, fileName, filePath, contentType, maxAge, contentDisposition ) {

        let objectId = object.getId();

        let postData = {
            filePath: filePath + fileName,
            contentType: contentType,
            cacheControl: maxAge !== undefined ? maxAge : BaseDriver.MAX_AGE
        };

        let self = this;
        let urlResource = self.getResource( `${self._catalogObjectType}Files`, objectId );
        urlResource = `${urlResource}files/`;

        return this.request( {
            method: HTTPMethod.POST,
            url: urlResource,
            data: JSON.stringify( postData ),
            success: function ( response, resolve ) {
                let config = JSON.parse( response );
                self.uploadFile( config[ 0 ].uploadUrl, file, contentType, postData.cacheControl, contentDisposition ).then( function () {
                    resolve( true );
                } ).catch( function () {
                    resolve( false );
                } );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    getFile: function ( url ) {
        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            useToken: false,
            success: function ( response, resolve ) {
                resolve( response );
            }
        } );
    },

    uploadFile: function ( url, file, contentType, maxAge, contentDisposition ) {
        return this.request( {
            method: HTTPMethod.PUT,
            url: url,
            data: file,
            useToken: false,
            contentType: contentType,
            contentDisposition: contentDisposition,
            headers: {
                'cache-control': maxAge !== undefined ? maxAge : BaseDriver.MAX_AGE
            }
        } );
    }


} );

module.exports = BaseDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/CategoryDriver.js":
/*!************************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/CategoryDriver.js ***!
  \************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Category = __webpack_require__( /*! pcvizGIS/Category */ "./sources/pcvizGIS/Category.js" ).default;

/**
 *  Category collage cloud sub driver
 *  @class
 *  @memberof pcvizDataAccess
 */
var CategoryDriver = function () {
    BaseDriver.call( this );
};

CategoryDriver.prototype = Utils.objectInherit( BaseDriver.prototype, {

    /**
     * Get the available categories as a tree nested by inheritance
     * THIS METHOD ASSUMES THAT parents come before children in the category list
     * @method
     * @memberof pcvizDataAccess.CategoryDriver
     */
    getCategoryTreeFromServer: function () {
        var self = this;

        return this.request( {
            method: HTTPMethod.GET,
            url: self.getResource( 'categories' ),
            success: function ( response, resolve ) {
                var categoryList = Utils.parseResponse( response ).results;
                resolve( Category.computeCategoryTree( categoryList ) );
            }
        } );
    },

    /**
     * Get the available categories as a flat list.
     * @method
     * @memberof pcvizDataAccess.CategoryDriver
     */
    getCategoryListFromServer: function () {
        var self = this;

        return this.request( {
            method: HTTPMethod.GET,
            url: self.getResource( 'categories' ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ).results );
            }
        } );
    },
    /**
     * Get the System categories as a flat list.
     * @method
     * @memberof pcvizDataAccess.CategoryDriver
     */
    getSystemCategoryListFromServer: function () {
        return new Promise( ( resolve ) => {
            this.getSystemCategories().then( ( response => resolve( response.results ) ) );
        } );
    },
    /**
     * Create a category from the give category
     * @method
     * @param {ojbect} category
     * @memberof pcvizDataAccess.CategoryDriver
     */
    createCategory: function ( category ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'categories' ),
            data: JSON.stringify( category ),
            success: function ( response, resolve ) {
                var id = JSON.parse( response ).id;
                resolve( id );
            }
        } );
    },

    /**
     * Update a category from the give category
     * @method
     * @param {ojbect} category
     * @memberof pcvizDataAccess.CategoryDriver
     */
    updateCategory: function ( category ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.PUT,
            url: self.getResource( 'categories', category.id ),
            data: JSON.stringify( category ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            },
            error: function ( response, reject ) {
                reject( JSON.parse( response ) );
            }
        } );
    },

    /**
     * Removes a category
     * @method
     * @param {int} category ID
     * @memberof pcvizDataAccess.CategoryDriver
     */
    deleteCategory: function ( categoryID ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.DELETE,
            url: self.getResource( 'categories', categoryID ),
        } );
    },

    /**
     * Get the System categories 
     * @method
     * @memberof pcvizDataAccess.CategoryDriver
     */
    getSystemCategories: function () {
        const categoriesResource = this.getResource( 'categories' );

        return this.request( {
            method: HTTPMethod.GET,
            url: `${categoriesResource}?system=true`,
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            }
        } );
    },

} );

DriverRegistry.getInstance().registerDriver( 'da.category', new CategoryDriver() );

module.exports = CategoryDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/JobDriver.js":
/*!*******************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/JobDriver.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js");
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _BaseDriver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var _BaseDriver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_BaseDriver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__);







class JobDriver extends _BaseDriver__WEBPACK_IMPORTED_MODULE_2___default.a {

    constructor() {
        super();
    }

    create( pipeline, createAndStart ) {
        let queryParam = createAndStart ? '?action=create_and_start' : '';
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default.a.POST,
            url: this.getResource( 'jobs' ) + queryParam,
            data: JSON.stringify( pipeline ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            }
        } );
    }

    start( jobId ) {
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default.a.POST,
            url: this.getResource( 'jobs', jobId ) + 'start/',
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            }
        } );
    }

    cancel( jobId ) {
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default.a.POST,
            url: this.getResource( 'jobs', jobId ) + 'cancel/',
            success: ( response, resolve ) => {
                resolve( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.parseJSON( response ) );
            }
        } );
    }

    estimate( pipeline ) {
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default.a.POST,
            url: this.getResource( 'jobs' ) + 'estimate/',
            data: JSON.stringify( pipeline ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            }
        } );
    }

    getJob( jobId ) {
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_1___default.a.GET,
            url: this.getResource( 'jobs', jobId ),
            success: ( response, resolve ) => {
                resolve( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.parseJSON( response ) );
            }
        } );
    }
}

pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().registerDriver( 'da.job', new JobDriver() );

/* harmony default export */ __webpack_exports__["default"] = (JobDriver);


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/JobSiteDriver.js":
/*!***********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/JobSiteDriver.js ***!
  \***********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobSiteDriver; });
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js");
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2__);






class JobSiteDriver extends pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor() {
        super();

        this._jobSiteData = undefined;
        this._catalogObjectType = 'sites';

        // Delete unnecesary attributes from BaseDriver (this sholdn't be on BaseDriver, just in ProjectDriver)
        delete this._layerType;
        delete this._projectId;
        delete this._extent;
    }

    /**
     * Set JobSite id
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @param  {int} jobSiteId Id of the jobSite
     */
    setJobSiteId( jobSiteId ) {
        this._jobSiteId = jobSiteId;
    }

    /**
     * get JobSite id
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {int} JobSite id
     */
    getJobSiteId() {
        return this._jobSiteId;
    }

    /**
     * Get description to a job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {String}  Description of the job site
     */
    getDescription() {
        let result;
        if ( this._jobSiteData !== undefined )
            result = this._jobSiteData.description;
        return result;
    }

    /**
     * Get name´s job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {string} Name of the job site
     */
    getName() {
        let result;
        if ( this._jobSiteData !== undefined )
            result = this._jobSiteData.name;
        return result;
    }

    /**
     * Get the type of the snapshot
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {string} type of the snaspshot
     */
    getSnapshotType() {
        return this._jobSiteData !== undefined ? this._jobSiteData.snapshotType : '';
    }

    /**
     * Get sample distance value
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {number} distance value
     */
    getSampleDistance() {
        return this._jobSiteData !== undefined ? this._jobSiteData.sampleDistance : 0;
    }

    /**
     * Get the geoid
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {string | null} geoid value
     */
    getGeoid() {
        return this._jobSiteData !== undefined && this._jobSiteData.geoid ? this._jobSiteData.geoid : null;
    }

    /**
     * Get the Coordinate reference system
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {string | null} CRS value
     */
    getHorizProjectionEPSG() {
        return this._jobSiteData !== undefined && this._jobSiteData.horizProjectionEPSG ? this._jobSiteData.horizProjectionEPSG : null;
    }

    /**
     * Get the ToC information
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @return {object | null} ToC information
     */
    getToc() {
        return this._jobSiteData !== undefined && this._jobSiteData.configuration ? this._jobSiteData.configuration.toc : null;
    }

    /**
     * Set thumbnail for the job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @param  {int} jobSiteId Job Site id
     * @param  {string} thumbnail URL where the thumbnail is
     * @return {Promise} The promise that is resolve when the request is complete.
     */
    setThumbnail( jobSiteId, thumbnail ) {
        const filePath = `thumbnails/${ jobSiteId }.jpg`;

        const postData = {
            filePath: filePath,
            contentType: 'image/jpeg',
            cacheControl: pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default.a.MAX_AGE
        };

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.POST,
            url: `${ this.getResource( 'sitesFiles', jobSiteId ) }files/`,
            data: JSON.stringify( postData ),
            success: ( response, resolve ) => {
                const config = JSON.parse( response );
                const storeUrl = `${ this.getResource( 'sitesFiles', jobSiteId) }files/${ postData.filePath }?ts=${ Date.now() }`;
                this.uploadThumbnailAndUpdate( jobSiteId, config[ 0 ].uploadUrl, thumbnail, storeUrl ).then( () => {
                    resolve();
                } ).catch( () => {
                    resolve( undefined, true );
                } );
            }
        } );
    }

    uploadThumbnailAndUpdate( jobSiteId, uploadUrl, thumbnail, storeUrl ) {
        return new Promise( ( resolve, reject ) => {
            this.uploadThumbnail( uploadUrl, thumbnail ).then( () => {
                this._jobSiteData.thumbnail = storeUrl ? storeUrl : uploadUrl;
                this.updateJobSiteData( jobSiteId, [ 'thumbnail' ] ).then( () => {
                    resolve();
                } ).catch( () => {
                    reject();
                } );
            } ).catch( () => {
                reject();
            } );
        } );

    }

    open( connectionString ) {
        return new Promise( ( resolve, reject ) => {
            if ( this._open )
                this.close();

            if ( this._jobSiteData && this._jobSiteData.id !== this._jobSiteId ) {
                this.reset();
            }

            this._open = true;

            if ( !this._loginEnabled ) {
                this.refreshJobSiteData( this._jobSiteId, connectionString ).then( function () {
                    resolve();
                } );
                return;
            }

            this._serverUrl = connectionString;

            this.login().then( () => {
                if ( this._jobSiteData ) {
                    resolve();
                    return;
                }

                this.updateAccess().then( () => {
                        this.refreshJobSiteData( this._jobSiteId ).then( () => {
                                resolve();
                            },
                            ( error ) => {
                                reject( error );
                            } );
                    },
                    ( error ) => {
                        reject( error );
                    } );
            }, ( error ) => {
                reject( error );
            } );
        } );
    }

    getJobSiteObject() {
        return this._jobSiteData;
    }

    refreshJobSiteData( jobSiteId, url ) {
        const self = this;
        let useToken = false;
        if ( jobSiteId === undefined ) {
            jobSiteId = this._jobSiteId;
        }
        if ( url === undefined ) {
            url = this.getResource( 'sites', jobSiteId );
            useToken = true;
        }

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.GET,
            url: url,
            success: function ( response, resolve ) {
                self._jobSiteData = JSON.parse( response );
                resolve();
            },
            useToken: useToken
        } );
    }

    /**
     * Updates the last access date for the current jobsite
     * @returns Promise with the server response
     */
    updateAccess() {
        const options = {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.GET,
            url: this.getResource( 'sites', this._jobSiteId ) + 'open/'
        };

        return this.request( options );
    }

    /**
     * Add project to a job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     * @param  {int} jobSiteId id of the job site
     * @param  {int} projectId id of the project
     * @return {Promise} The promise that is resolve when the request is complete.
     */
    addProjectToJobSite( jobSiteId, projectId ) {
        const url = `${ this.getResource( 'sites', jobSiteId ) }projects/`;
        const data = { project: projectId };

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.POST,
            url: url,
            data: JSON.stringify( data ),
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    }

    /**
     * Delete project from a job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    deleteProjectFromJobSite( jobSiteId, projectId ) {
        const url = `${ this.getResource( 'sites', jobSiteId ) }projects/${ projectId }/`;

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.DELETE,
            url: url,
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    }

    /**
     * Deletes a reference data layer from a specific job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    deleteReferenceDataLayerFromJobSite( jobSiteId, layerId ) {
        const url = `${ this.getResource( 'sites', jobSiteId ) }layers/${ layerId }/`;

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.DELETE,
            url: url,
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    }

    /**
     * Method to update all the changes made on job site data
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    updateJobSiteData( jobSiteId, fieldsToUpload ) {
        const url = this.getResource( 'sites', jobSiteId );
        let updatedData = {};

        fieldsToUpload.forEach( ( field ) => {
            updatedData[ field ] = this._jobSiteData[ field ];
        } );
        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.PATCH,
            data: JSON.stringify( updatedData ),
            url,
        } );
    }

    /**
     * Method to remove a snapshot from a job site
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    deleteSnapshot( jobSiteId, snapshotUuid ) {
        const url = `${ this.getResource( 'sites', jobSiteId ) }snapshots/${ snapshotUuid }`;

        return this.request( {
            url,
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.DELETE,
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    }

    reset() {
        pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.reset.call( this );
        this._jobSiteData = undefined;
    }

    /**
     * Method to update the TOC on the server
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    updateTocConfiguration( toc ) {
        const url = this.getResource( 'siteConfigurations', this._jobSiteData.configuration.id );
        const data = JSON.stringify( {
            toc
        } );

        return this.request( {
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.PATCH,
            data,
            url,
        } );
    }
}

pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().registerDriver( 'da.site', new JobSiteDriver() );


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/LayerDriver.js":
/*!*********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/LayerDriver.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );
var CollageDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/CollageDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js" );
var CollageVectorDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/CollageVectorDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageVectorDataIterator.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  Layer collage cloud sub driver
 *  @class
 *  @memberof pcvizDataAccess
 */
var LayerDriver = function () {
    BaseDriver.call( this );
    this._catalogObjectType = 'layers';
};

LayerDriver.prototype = Utils.objectInherit( BaseDriver.prototype, {


    getSourceLayerById: function ( id, filter ) {
        var defer = P.defer();

        if ( id === undefined )
            defer.resolve( undefined );

        var layerUrl = this.getResource( 'layers', id );

        // retrieving layer from server
        if ( layerUrl !== undefined ) {
            var self = this;

            this.getLayerFromServer( layerUrl ).then( function ( l ) {
                // depending of the type of the layer we create the necessary data iterator
                var iterator;
                switch ( l.layerType ) {
                case 'PointCloud':
                case 'RasterLayer':
                    iterator = new CollageDataIterator( self, l );
                    iterator.initIterator().then( function () {
                        defer.resolve( iterator );
                    } );
                    break;
                case 'VectorLayer':
                    iterator = new CollageVectorDataIterator( self, l );
                    iterator.initIterator( filter ).then( function () {
                        defer.resolve( iterator );
                    } ).catch( function () {
                        defer.reject();
                    } );
                    break;
                }
            } ).catch( function ( response ) {
                defer.reject( response );
            } );

            // depending of the type of the layer. The method return a specific data iterator

            return defer.promise;
        }
    },

    /**
     * Get layer from server
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {string} url of the layer
     * @param {int} layerId
     * @return {Promise}  return the layer
     */
    getLayerFromServer: function ( url, layerId ) {
        var urlRest = this.getResource( 'layers', layerId );
        if ( url === undefined )
            url = urlRest;

        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                resolve( UtilsDB.parseJSON( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    createLayer: function ( layerJSON ) {
        var self = this;
        var configuration = layerJSON.configuration;
        delete layerJSON.configuration;

        return this.request( {
            method: HTTPMethod.POST,
            url: this.getResource( 'layers' ),
            data: JSON.stringify( layerJSON ),
            success: function ( response, resolve ) {
                var layerObject = JSON.parse( response );
                if ( !configuration ) {
                    resolve( layerObject );
                    return;
                }
                self.createLayerConfiguration( configuration, layerObject.id, true ).then( function () {
                    resolve( layerObject );
                }, function ( error ) {
                    resolve( error, true );
                } );
            },
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    },

    /**
     * creates a source layer on the server
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {object} layer definition
     * @return {Promise}  return the iterator of the layer when it is success or undefined if it is reject
     */
    createSourceLayer: function ( layerDefinition ) {
        var self = this;
        var defer = P.defer();
        var layerJSON = layerDefinition.getJSONObject();

        this.createLayer( layerJSON ).then( function ( layerObject ) {
            // the server returns the created layer data
            // we get the id
            var id = layerObject.id;
            // use this id to retrive the layer created from the server
            self.getLayerFromServer( undefined, id ).then( function ( layer ) {
                // we use this layer to create the iterator over
                var iterator = new CollageVectorDataIterator( self, layer );
                iterator.initIterator( undefined ).then( function () {
                    defer.resolve( iterator );
                } ).catch( function () {
                    defer.resolve( undefined );
                } );
            } ).catch( function () {
                defer.resolve( undefined );
            } );
        } ).catch( function ( error ) {
            defer.reject( error );
        } );

        return defer.promise;
    },

    /**
     * Delete source layer from server
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} Id of the layer
     * @return {Promise}  return if the method fails return the response from the server
     */
    deleteSourceLayer: function ( id ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.DELETE,
            url: self.getResource( 'layers', id ),
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) ); // This method is not being used at this moment. So check it when we use it.
            }
        } );
    },

    /**
     * Updates the source layer in the database.
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {DataIterator} dataIterator The data iterator.
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    updateSourceLayer: function ( dataIterator ) {
        var self = this;
        var json = dataIterator.getDirtyAttributes();

        return this.request( {
            method: HTTPMethod.PUT,
            url: self.getResource( 'layers', dataIterator.getLayerObject().id ),
            data: JSON.stringify( json ),
            success: function ( response, resolve ) {
                resolve( UtilsDB.parseJSON( response ) );
                dataIterator.clear();
            }
        } );
    },

    /**
     * Creates layer configuration
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {Object} layerConfig layer config file
     * @param  {int} layerID id of the layer
     * @param  {Object} defaultLayerConfiguration base configuration
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    createLayerConfiguration: function ( layerConfig, layerId, defaultLayerConfiguration, user ) {
        var self = this;

        function replacer( key, value ) {
            var symbolizersColorProperties = [ 'color', 'strokeColor', 'fillColor' ];
            if ( symbolizersColorProperties.indexOf( key ) >= 0 ) {
                return [].slice.call( value );
            }

            return value;
        }

        if ( !this._magnetAPI.isAnonymous() )
            return this.request( {
                method: HTTPMethod.POST,
                url: self.getResource( 'layerConfigurations' ),
                data: JSON.stringify( layerConfig, replacer ),
                success: function ( response, resolve ) {
                    var promise;
                    var config = JSON.parse( response );
                    if ( defaultLayerConfiguration )
                        promise = self.createDefaultLayerConfiguration( config.id, layerId );
                    else
                        promise = DriverRegistry.getInstance().getDriver( 'da.project' ).addLayerConfigurationToProject( config.id, layerId, user );

                    promise.then( function () {
                        resolve( config );
                    } ).catch( function () {
                        resolve( undefined, true );
                    } );
                }
            } );

        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    /**
     * Creates the default layer configuration
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} configurationID if of the configuration
     * @param  {int} layerId Id of the layer
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    createDefaultLayerConfiguration: function ( configurationId, layerId ) {
        var json = {
            layerConfiguration: configurationId
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: this.getResource( 'layers', layerId ) + 'configuration/',
            data: JSON.stringify( json )
        } );
    },

    /**
     * Set the thumbnail to the layer
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {Object} layer the layer object
     * @param  {string} thumbnail url of the layer thumbnail
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    setLayerThumbnail: function ( layer, thumbnail ) {
        var self = this;
        var layerId = layer.getId();
        var filePath = 'thumbnails/' + layerId + '.jpg';

        var postData = {
            filePath: filePath,
            contentType: 'image/jpeg',
            cacheControl: BaseDriver.MAX_AGE
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'layersFiles', layerId ) + 'files/',
            data: JSON.stringify( postData ),
            success: function ( response, resolve ) {
                var config = JSON.parse( response );
                var storeUrl = self.getResource( 'layersFiles', layerId ) + 'files/' + postData.filePath + '?ts=' + Date.now();
                self.uploadThumbnailAndUpdate( layer, config[ 0 ].uploadUrl, thumbnail, storeUrl ).then( function () {
                    resolve();
                } ).catch( function () {
                    resolve( undefined, true );
                } );
            }
        } );
    },

    uploadThumbnailAndUpdate( layer, uploadUrl, thumbnail, storeUrl ) {
        var self = this;
        var defer = P.defer();

        self.uploadThumbnail( uploadUrl, thumbnail ).then( function () {
            var url = storeUrl ? storeUrl : uploadUrl;
            layer.getDataset().setAttribute( 'thumbnail', url );
            layer.commitChanges().then( function () {
                defer.resolve();
            } ).catch( function () {
                defer.reject();
            } );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },
    /**
     * Gets the layer configuration of the project, It could be the user configuration or the layer configuration
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {int} index  the index of the layer in the layerTree array
     * @param {bool} avoidUserConfiguration  to avoid user configuration
     */
    getLayerConfigurationById: function ( id ) {
        // FIXME: Why use here da.project???
        var layer = DriverRegistry.getInstance().getDriver( 'da.project' ).getLayerByIndex( DriverRegistry.getInstance().getDriver( 'da.project' ).getLayerIndexById( id ) );
        var result = {};
        // If you open the layer without a project this will be undefined
        if ( !layer )
            return result;

        if ( layer.userConfiguration !== undefined && layer.userConfiguration !== null ) {
            if ( layer.userConfiguration.style === null && layer.configuration !== undefined && layer.configuration !== null ) {
                result = layer.configuration;
                result.id = layer.userConfiguration.id;
            } else {
                result = layer.userConfiguration;
            }
        } else if ( layer.configuration !== undefined && layer.configuration !== null ) {
            result = layer.configuration;
        }
        if ( !result.name )
            result.name = layer.name;
        if ( !result.description )
            result.description = layer.description;
        return result;
    },

    getDefaultLayerConfigurationById: function ( id ) {
        var layer = DriverRegistry.getInstance().getDriver( 'da.project' ).getLayerByIndex( DriverRegistry.getInstance().getDriver( 'da.project' ).getLayerIndexById( id ) );
        if ( !layer )
            return;
        return layer.configuration;
    },

    /**
     * update the layer configuration
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} layerId layer to associate to the configuration
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    updateLayerConfiguration: function ( configuration, layerId, user ) {
        var json = configuration;

        if ( !json.id ) {
            return this.createLayerConfiguration( json, layerId, user );
        }

        if ( !this._magnetAPI.isAnonymous() )
            return this.request( {
                url: this.getResource( 'layerConfigurations', json.id ),
                method: HTTPMethod.PUT,
                data: JSON.stringify( json ),
                success: function ( response, resolve ) {
                    resolve( UtilsDB.parseJSON( response ) );
                }
            } );

        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },



    /**
     * Get a source layer list which layer's type is the type indicated and the current user has permission to access them.
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     */
    getSourceLayersByType: function ( filter ) {

        var url = this.getResource( 'layersList' );
        if ( filter !== undefined )
            url += filter;

        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                resolve( Utils.parseResponse( response ) );
            },
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    },

    /**
     * Get the group id
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {string} name of the group
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    getGroupId: function ( name ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.GET,
            url: self.getResource( 'users', this._magnetAPI.getUserId() ),
            success: function ( response, resolve ) {
                var groups = JSON.parse( response ).groups;
                var groupID = -1;
                for ( var i = 0; i < groups.length; i++ )
                    if ( groups[ i ].name === name )
                        groupID = groups[ i ].id;
                resolve( groupID );
            }
        } );
    },

    /**
     * Get a source layer list for the given group id (e.g. Public) and layer type filter.
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     */
    getSourceLayersByGroup: function ( name, filter ) {
        var self = this;
        var defer = P.defer();

        if ( this.isConnectingFromMagnet() ) {
            self.request( {
                method: HTTPMethod.GET,
                url: this.getResource( 'layersList' ),
                success: function ( response, resolve ) {
                    var out = Utils.parseResponse( response );
                    resolve( out );
                    defer.resolve( out );
                },
                error: function ( response, reject ) {
                    reject();
                    defer.reject();
                }
            } );
            return defer.promise;
        }
        this.getGroupId( 'public' ).then( function ( id ) {

                var url = self.getResource( 'groups', id ) + 'layers/';
                if ( filter !== undefined )
                    url += filter;

                self.request( {
                    method: HTTPMethod.GET,
                    url: url,
                    success: function ( response, resolve ) {
                        resolve( UtilsDB.parseJSON( response ) ); // it is not being used in magnet
                        defer.resolve( UtilsDB.parseJSON( response ) );
                    },
                    error: function ( response, reject ) {
                        reject();
                        defer.reject();
                    }
                } );
            },
            function () {
                defer.reject();
            } );

        return defer.promise;
    },

    /**
     * get features of the layer
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} layerId layer id to retrieve the features
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    getFeatures: function ( layerId, config ) {
        let url = this.getResource( 'layers', layerId ) + 'features/';
        const projectDriver = DriverRegistry.getInstance().getDriver( 'da.project' );
        const projectId = projectDriver && projectDriver.getProjectId();
        url = projectId ? `${url}?projectId=${projectId}` : url;
        if ( config ) {
            url += projectId ? '&' : '?';
            url += `page=${config.page}&page_size=${config['page_size']}`;
        }

        return this.request( {
            method: HTTPMethod.GET,
            url: url,
            success: function ( response, resolve ) {
                resolve( UtilsDB.parseJSON( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },


    /**
     * Adds a feature in the server
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param {object} feature  a single feature or an array of features (use {features: featureArray} )
     * @param {int} layerId the id of the layer where is going to be added the feature
     * @return {Promise} A promise that is resolved when the feature has been added succesfully.
     */
    addFeature: function ( layerId, feature, featureData ) {
        return this.request( {
            method: HTTPMethod.POST,
            url: this.getResource( 'layers', layerId ) + 'features/',
            data: JSON.stringify( featureData ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },


    /**
     * Updates a feature in the server
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param {JSON} feature  a json with the information of the feature to be updated
     * @param {int} layerId the id of the layer where is going to be updated the feature
     * @param {int} featureId the id of the feature which is going to be updated
     * @return {Promise} A promise that is resolved when the feature has been updated succesfully.
     */
    updateFeature: function ( layerId, feature, featureData ) {
        return this.request( {
            method: HTTPMethod.PUT,
            url: this.getResource( 'layers', layerId ) + 'features/' + feature.getId() + '/',
            data: JSON.stringify( featureData ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    /**
     * Deletes a feature in the server
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param {Feature} feature the feature to be deleted
     * @param {int} layerId the id of the layer where is going to be deleted the feature
     * @return {Promise} A promise that is resolved when the feature has been deleted succesfully.
     */
    deleteFeature: function ( layerId, feature ) {
        return this.request( {
            method: HTTPMethod.DELETE,
            url: this.getResource( 'layers', layerId ) + 'features/' + feature.getId() + '/'
        } );
    },

    /**
     * Uploads a file to the layer storage
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param  {Object} layer the layer object
     * @param  {Object} file the file to be uploaded
     * @param  {string} fileName the name of the file that is going to be uploaded
     * @param  {string} contentType the type of the file that is going to be uploaded
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    uploadLayerFile: function ( layer, file, fileName, filePath, contentType, maxAge, contentDisposition ) {
        var self = this;
        var layerId = layer.getId ? layer.getId() : layer.id;

        var postData = {
            filePath: filePath + fileName,
            contentType: contentType,
            cacheControl: maxAge !== undefined ? maxAge : BaseDriver.MAX_AGE
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'layersFiles', layerId ) + 'files/',
            data: JSON.stringify( postData ),
            success: function ( response, resolve ) {
                var config = JSON.parse( response );
                self.uploadFile( config[ 0 ].uploadUrl, file, contentType, postData.cacheControl, contentDisposition ).then( function () {
                    resolve( true );
                } ).catch( function () {
                    resolve( false );
                } );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    launchWorkflowJob: function ( layerId, data, jobName ) {
        const urlJob = `${this.getResource( 'layers', layerId )}workflows/${jobName}`;

        return this.request( {
            method: HTTPMethod.POST,
            url: urlJob,
            data: JSON.stringify( data ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            },
            error: ( response, reject ) => {
                reject( response );
            }
        } );
    },
} );

DriverRegistry.getInstance().registerDriver( 'da.layer', new LayerDriver() );

module.exports = LayerDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloud/ProjectDriver.js":
/*!***********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloud/ProjectDriver.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Workflow = __webpack_require__( /*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js" );
var TimeStampCache = __webpack_require__( /*! pcvizUtils/TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js" );

/**
 *  Project collage cloud sub driver
 *  @class
 *  @memberof pcvizDataAccess
 */
var ProjectDriver = function () {
    BaseDriver.call( this );

    this._projectData = undefined;
    this._catalogObjectType = 'projects';
    this._workspace = undefined;
    this.waitForSetExtensibleData = new Set();
};

ProjectDriver.prototype = Utils.objectInherit( BaseDriver.prototype, {

    /**
     * Gets the number of source layers
     * @memberof pcvizDataAccess.LayerDriver
     * @method
     * @return {int} number of layers
     */
    getNumSourceLayers: function () {
        let layersLength;
        if ( this._projectData !== undefined )
            layersLength = this._projectData.layerTree.length;
        return layersLength;
    },

    /**
     * Gets the layer information of the project (the parsed json structure of the layerTree)
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} index  the index in the layerTree
     * @return {object} layer
     */
    getLayerByIndex: function ( index ) {
        var result;
        if ( this._projectData !== undefined ) {

            var keys = window.Object.keys( this._projectData.layerTree );
            result = this._projectData.layerTree[ keys[ index ] ];
        }
        return result;
    },

    /**
     * Get layer index by name
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {string} name of the layer
     * @return {int} index of the layer
     */
    getLayerIndexByName: function ( name ) {
        var result;
        if ( this._projectData !== undefined ) {
            var cont = -1;
            var find = this._projectData.layerTree.find( function ( layer ) {
                cont++;
                return ( layer.name === name );
            } );
            if ( find )
                result = cont;
        }
        return result;
    },

    /**
     * Get layer id by name
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {string} name of the layer
     * @return {int} layer id
     */
    getLayerIdByName: function ( name ) {
        var result;
        if ( this._projectData !== undefined ) {
            var find = this._projectData.layerTree.find( function ( layer ) {
                return ( layer.name === name );
            } );
            if ( find )
                result = find.id;
        }
        return result;
    },

    /**
     * Get layer index by Id
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} id of the layer
     * @return {int} index of the layer
     */
    getLayerIndexById: function ( id ) {
        var result;
        if ( this._projectData !== undefined ) {
            var cont = -1;
            var find = this._projectData.layerTree.find( function ( layer ) {
                cont++;
                return ( layer.id === id );
            } );
            if ( find )
                result = cont;
        }
        return result;
    },

    /**
     * Get layer type by index
     * @method
     * @memberof pcvizDataAccess.ProjectDriver
     * @param {int} index of the layer
     * @return {object} layer type
     */
    getLayerTypeByIndex: function ( index ) {
        var result;
        if ( this._projectData !== undefined ) {

            var keys = window.Object.keys( this._projectData.layerTree );
            result = this._projectData.layerTree[ keys[ index ] ].layerType;
        }
        return result;
    },

    /**
     * Get layer name by index
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} index of the layer
     * @return {string} layer name
     */
    getLayerNameByIndex: function ( index ) {
        var result;
        if ( this._projectData !== undefined ) {
            var keys = window.Object.keys( this._projectData.layerTree );
            result = this._projectData.layerTree[ keys[ index ] ].name;
        }

        return result;
    },

    /**
     * Get layer id by index
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} index of the layer
     * @return {int} layer id
     */
    getLayerIdByIndex: function ( index ) {
        var result;
        if ( this._projectData !== undefined ) {
            var keys = window.Object.keys( this._projectData.layerTree );
            result = this._projectData.layerTree[ keys[ index ] ].id;
        }

        return result;
    },

    /**
     * Get source layer by index
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} index of the layer
     * @param {object} filter to apply for search
     * @return {Promise}  return the layer iterator depeding of layer type
     */
    getSourceLayerByIndex: function ( /* index, filter*/) {
        // Not implemented and not used now
    },

    /**
     * Get source layer by name
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {string} name of the layer
     * @param {object} filter to apply for search
     * @return {Promise}  return the layer iterator depeding of layer type
     */
    getSourceLayerByName: function ( name, filter ) {
        return DriverRegistry.getInstance().getDriver( 'da.layer' ).getSourceLayerById( this.getLayerIdByName( name ), filter );
    },

    /**
     * Get source layer by id
     * @method
     * @memberof pcvizDataAccess.LayerDriver
     * @param {int} id of the layer
     * @param {object} filter to apply for search
     * @return {Promise}  return the layer iterator depeding of layer type
     */
    getSourceLayerById: function ( id, filter ) {
        return DriverRegistry.getInstance().getDriver( 'da.layer' ).getSourceLayerById( id, filter );
    },

    /**
     * Add layer to a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} idProject id of the project
     * @param  {int} layerId layer id to associate to the layer project
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    addLayerToProject: function ( idProject, idLayer ) {
        var self = this;
        var ljson = {
            layer: idLayer
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'projects', idProject ) + 'layers/',
            data: JSON.stringify( ljson ),
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    },

    /**
     * Delete layer from a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} idProject id of the project
     * @param  {int} layerId layer id to delete from the layer project
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    deleteLayerFromProject: function ( idProject, idLayer ) {
        var self = this;

        return this.request( {
            method: HTTPMethod.DELETE,
            url: self.getResource( 'projects', idProject ) + 'layers/' + idLayer + '/',
            error: function ( response, reject ) {
                reject( response );
            }
        } );
    },

    /**
     * Set description to a project (This function is not used)
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} projectId Project id
     * @param  {string} desc Description of the project
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    setDescription: function ( projectId, desc ) {
        var defer = P.defer();
        if ( this._projectData !== undefined ) {
            this._projectData.description = desc;

            this.updateProjectData( projectId, [ 'description' ] ).then( function () {
                defer.resolve();
            }, function () {
                defer.reject();
            } );
        }
        return defer.promise;
    },

    /**
     * Get description to a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {String}  Description of the project
     */
    getDescription: function () {
        var result;
        if ( this._projectData !== undefined )
            result = this._projectData.description;
        return result;
    },

    /**
     * Get name´s project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {string} Name of the project
     */
    getName: function () {
        var result;
        if ( this._projectData !== undefined )
            result = this._projectData.name;
        return result;
    },

    /**
     * Set extensible data to a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} projectId Project id
     * @param  {object} desc Object with extensible data of the project
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    setExtensibleData: function ( projectId, extData ) {
        if ( this._projectData === undefined ) {
            return Promise.reject();
        }

        this._projectData.data = JSON.stringify( extData );

        // FIXME: We only need to send the 'data' but this is a 'fix' because of a PATCH problem
        const updatePromise = this.updateProjectData( projectId, [ 'data', 'horizProjectionEPSG' ] );

        this.waitForSetExtensibleData.add( updatePromise );

        return updatePromise.finally( () => {
            this.waitForSetExtensibleData.delete( updatePromise );
        } );
    },

    /**
     * Get extensible data of a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {Object}  Object with extensible data of the project
     */
    getExtensibleData: function () {
        var result;
        if ( this._projectData !== undefined && this._projectData.data !== undefined )
            result = JSON.parse( this._projectData.data );
        return result;
    },

    /**
     * Set thumbnail for the project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} projectId Project id
     * @param  {string} thumbnail URL where the thumbnail is
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    setThumbnail: function ( projectId, thumbnail ) {
        var self = this;

        var filePath = 'thumbnails/' + projectId + '.jpg';

        var postData = {
            filePath: filePath,
            contentType: 'image/jpeg',
            cacheControl: BaseDriver.MAX_AGE
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'projectsFiles', projectId ) + 'files/',
            data: JSON.stringify( postData ),
            success: function ( response, resolve ) {
                var config = JSON.parse( response );
                var storeUrl = self.getResource( 'projectsFiles', projectId ) + 'files/' + postData.filePath + '?ts=' + Date.now();
                self.uploadThumbnailAndUpdate( projectId, config[ 0 ].uploadUrl, thumbnail, storeUrl ).then( function () {
                    resolve();
                } ).catch( function () {
                    resolve( undefined, true );
                } );
            }
        } );
    },

    uploadThumbnailAndUpdate: function ( projectId, uploadUrl, thumbnail, storeUrl ) {
        var self = this;
        var defer = P.defer();

        this.uploadThumbnail( uploadUrl, thumbnail ).then( function () {
            self._projectData.thumbnail = storeUrl ? storeUrl : uploadUrl;
            self.updateProjectData( projectId, [ 'thumbnail' ] ).then( function () {
                defer.resolve();
            } ).catch( function () {
                defer.reject();
            } );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    open: function ( connectionString ) {

        const defer = P.defer();

        if ( this._open )
            this.close();

        if ( this._projectData && this._projectData.id !== this._projectId ) {
            this.reset();
        }

        this._open = true;

        if ( !this._loginEnabled ) {
            this.refreshProjectData( this._projectId, connectionString ).then( () => {
                defer.resolve();
            } );
            return defer.promise;
        }

        this._serverUrl = connectionString;

        this.login().then( () => {
            if ( !this._projectData ) {
                this.updateAccess().then( () => {
                    this.refreshProjectData( this._projectId ).then( () => {
                        this.getLayerTypeFromServer().then( () => {
                            defer.resolve();
                        } ).catch( ( error ) => {
                            defer.reject( error );
                        } );
                    } ).catch( ( error ) => {
                        defer.reject( error );
                    } );
                } ).catch( ( error ) => {
                    defer.reject( error );
                } );
            } else {
                defer.resolve();
            }
        }, ( error ) => {
            defer.reject( error );
        } );

        return defer.promise;
    },

    /**
     * Donwload thumbnail of the project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {string} thumbnail URL where the thumbnail is
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    downloadThumbnail: function ( url ) {
        return this.request( {
            method: HTTPMethod.GET,
            url: url
        } );
    },

    /**
     * get thumbnail of the project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {JSGON} a Json to all the information to show the thumbnail
     */
    getThumbnail: function () {
        var result;
        if ( this._projectData !== undefined )
            result = this._projectData.thumbnail;
        return result;
    },

    /**
     * Set creators to a project (This function is not used)
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {int} projectId Id of the project
     * @param  {string} creatorUserId
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    setCreator: function ( projectId, creatorUserId ) {
        var defer = P.defer();
        if ( this._projectData !== undefined ) {
            this._projectData.creatorUserId = creatorUserId;
            this.updateProjectData( projectId, [ 'creatorUserId' ] ).then( function () {
                defer.resolve();
            }, function () {
                defer.reject();
            } );
        }
        return defer.promise;
    },

    /**
     * get creators to a project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {string}  the creator
     */
    getCreator: function () {
        var result;
        if ( this._projectData !== undefined ) {
            result = this._projectData.creatorUserId;
        }
        return result;
    },



    /**
     * get horizontal projection
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {string} horizontal projection
     */
    getProjectHorizProjection: function () {
        return this._projectData.horizProjectionEPSG;
    },

    // Method to store the projection in server
    setProjectHorizProjection: function ( projection ) {
        this._projectData.horizProjectionEPSG = projection;
        var json = {
            'horizProjectionEPSG': this._projectData.horizProjectionEPSG
        };
        return this.request( {
            method: HTTPMethod.PATCH,
            url: this.getResource( 'projects', this._projectId ),
            data: JSON.stringify( json ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            },
            error: function ( response, reject ) {
                reject( UtilsDB.parseJSON( response ) );
            }
        } );
    },

    /**
     * get vertical projection
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {string} vertical projection
     */
    getProjectGeoid: function () {
        return this._projectData.geoid;
    },

    /**
     * get project type
     * @method
     * @memberof pcvizDataAccess.ProjectDriver
     * @return  {integer} projectType
     */
    getProjectType: function () {
        return this._projectData.projectType;
    },

    getProjectAccessLevel: function () {
        return this._projectData.accessLevel;
    },

    /**
     * Creates a configuration for the project in the server.
     * @param  {Object} settings An object with settings to be attached to the configuration. As to v0.10.0, configuration only parses `renderSettings`.
     * @return {Promise} A promise that is resolved when the configuration object is created and rejected if an error occurs.
     */
    createConfiguration: function ( settings ) {
        var self = this;
        var url = this.getResource( 'projectConfigurations' );
        if ( !this._magnetAPI.isAnonymous() )
            return this.request( {
                method: HTTPMethod.POST,
                // url: self.getResource( 'projectConfigurations' ),
                url: url,
                data: JSON.stringify( settings ),
                success: function ( response, resolve ) {
                    var configuration = JSON.parse( response );
                    self.addConfigurationToProject( configuration.id ).then( function () {
                        self._projectData.configuration = configuration;
                        resolve( configuration );
                    } ).catch( function () {
                        resolve( undefined, true );
                    } );
                },
                error: function ( response, reject ) {
                    reject( UtilsDB.parseJSON( response ) );
                }
            } );

        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    /**
     * get configuration from the project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param avoidUserConfiguration bool true to not evaluate userConfiguratio
     * @return {object} configuration of the project
     */
    getConfiguration: function ( avoidUserConfiguration ) {
        if ( !this._projectData )
            return;
        if ( !avoidUserConfiguration && this._projectData.userConfiguration ) {
            this.ensureRenderSettingsConfiguration( this._projectData.userConfiguration );
            this.ensureTableOfContentsConfiguration( this._projectData.userConfiguration );
            this.ensureExtDataConfiguration( this._projectData.userConfiguration );
            return this._projectData.userConfiguration;
        }
        return this._projectData.configuration;
    },

    setConfiguration: function ( configuration ) {
        if ( this._projectData.userConfiguration.id === configuration.id ) {
            this._projectData.userConfiguration.renderSettings = configuration.renderSettings;
            this._projectData.userConfiguration.toc = configuration.toc;
            this._projectData.userConfiguration.data = configuration.data;
        } else if ( this._projectData.configuration.id === configuration.id ) {
            this._projectData.configuration.renderSettings = configuration.renderSettings;
            this._projectData.configuration.toc = configuration.toc;
            this._projectData.configuration.data = configuration.data;
        }
    },

    getConfigExtData: function () {
        var result;
        var config = this.getConfiguration();
        if ( config ) {
            result = ( config.data ) ? JSON.parse( config.data ) : {};
        }
        return result;
    },

    updateConfigExtData: function ( extDataObject, configurationId ) {
        return new Promise( ( resolve, reject ) => {

            this.updateConfiguration( 'data', JSON.stringify( extDataObject ), configurationId ).then( configuration => {
                this.setConfiguration( configuration );
                resolve();
            }, reject );
        } );
    },

    ensureRenderSettingsConfiguration: function ( configuration ) {
        if ( configuration.renderSettings || !this._projectData.configuration )
            return;
        configuration.renderSettings = {};
        Object.assign( configuration.renderSettings, this._projectData.configuration.renderSettings );
        configuration.renderSettings.id = undefined;
    },

    ensureTableOfContentsConfiguration: function ( configuration ) {
        if ( configuration.toc || !this._projectData.configuration )
            return;
        // it should be a string so it's ok to assign it directly
        configuration.toc = this._projectData.configuration.toc;
    },

    ensureExtDataConfiguration: function ( configuration ) {
        if ( this._projectData.configuration )
            configuration.data = this._projectData.configuration.data;

        if ( !configuration.data || configuration.data.length === 0 )
            configuration.data = JSON.stringify( { wksStyles: [] } );
    },

    /**
     * Adds a configuration to a project in the server.
     * @param  {Integer} configurationId The id of the configuration object to be attached to the project.
     * @return {Promise} A promise that is resolved when the object is attached succesfully, and reject if an error occurs.
     */
    addConfigurationToProject: function ( configurationId ) {
        var self = this;

        var json = {
            projectConfiguration: configurationId
        };

        return this.request( {
            method: HTTPMethod.POST,
            url: self.getResource( 'projects', this._projectId ) + 'configuration/',
            data: JSON.stringify( json ),
            success: function ( response, resolve ) {
                resolve( JSON.parse( response ) );
            },
            error: function ( response, reject ) {
                reject( JSON.parse( response ) );
            }
        } );
    },

    /**
     * get render settings for the project
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @return {object} render settings of the project
     */
    getRenderSettings: function () {
        var result;
        var config = this.getConfiguration();
        if ( config ) {
            result = config.renderSettings;
        }
        return result;
    },

    /**
     * Creates the render settings object in the server by creating the configuration object.
     * @param  {Object} settingsObject The settings object with the render settings parameters.
     * @return {Promise} A promise that is resolved if the render settings and configuration objects have been created succesfully.
     */
    createRenderSettings: function ( settingsObject ) {
        var self = this;

        var defer = P.defer();

        var json = {
            renderSettings: settingsObject
        };

        // Currently, configuration object from a project can not be created with out a
        // renderSettings. So, a project with no configuration has no renderSettings.
        // In the future, when other settings like culture settings may be present but no renderSettings,
        // so there will be necessary to check it.
        if ( this._projectData && this._projectData.configuration ) {
            defer.resolve();
            return defer.promise;
        }
        this.createConfiguration( json ).then( function ( configuration ) {
            self._renderSettings = configuration.renderSettings;
            defer.resolve();
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },


    /**
     * Updates the project render settings in the server.
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {Object} settingsObject  The object with the render settings parameters.
     * @param  {Integer} configurationId The id of the configuration object.
     * @return {Promise} A promise that is resolved when the settings object has been updated succesfully.
     */
    updateRenderSettings: function ( settingsObject, configurationId ) {
        return this.updateConfiguration( 'renderSettings', settingsObject, configurationId );
    },

    /**
     * Gets the stored table of contents
     * @method
     * @memberof pcvizDataAccess.ProjectDriver
     */
    getTableOfContents: function () {
        var result;
        var config = this.getConfiguration();
        if ( config ) {
            result = ( config.toc ) ? JSON.parse( config.toc ) : {};
        }
        return result;
    },

    /**
     * Updates the project table of contents in the server.
     * @method
     * @memberof pcvizDataAccess.ProjectDriver
     * @param  {Object} tableOfContentsObject  The object with the table of contents.
     * @param  {Integer} configurationId The id of the configuration object.
     * @return {Promise} A promise that is resolved when the settings object has been updated succesfully.
     */
    updateTableOfContents: function ( tableOfContentsObject, configurationId ) {
        return this.updateConfiguration( 'toc', JSON.stringify( tableOfContentsObject ), configurationId );
    },

    /**
     * Updates the project render settings in the server.
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {Object} settingsObject  The object with the render settings parameters.
     * @param  {Integer} configurationId The id of the configuration object.
     * @return {Promise} A promise that is resolved when the settings object has been updated succesfully.
     */
    updateConfiguration: function ( key, data, configurationId ) {
        var self = this;
        var json = {};
        json[ key ] = data;

        if ( !this._magnetAPI.isAnonymous() )
            return this.request( {
                method: HTTPMethod.PUT,
                url: self.getResource( 'projectConfigurations', configurationId ),
                data: JSON.stringify( json ),
                success: function ( response, resolve ) {
                    resolve( JSON.parse( response ) );
                },
                error: function ( response, reject ) {
                    reject( UtilsDB.parseJSON( response ) );
                }
            } );

        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    updateAccess: function () {
        var self = this;

        return this.request( {
            method: HTTPMethod.GET,
            url: self.getResource( 'projects', this._projectId ) + 'open/'
        } );
    },

    getProjectData: function ( attribute ) {
        return this._projectData[ attribute ];
    },

    getProjectObject: function () {
        return this._projectData;
    },

    refreshProjectDataDelayed: function ( projectId, url, useToken, attempt = 1 ) {
        const delay = 250;
        return new Promise( resolve => setTimeout( resolve, delay ) )
            .then( () => this.refreshProjectData( projectId, url, useToken, attempt ) );
    },

    refreshProjectData: function ( projectId, url, useToken = false, attempt = 1 ) {
        const maxAttempts = 10;
        const hasAttempts = attempt <= maxAttempts;
        const shouldDelay = () => hasAttempts && this.waitForSetExtensibleData.size;
        attempt++;

        if ( url === undefined ) {
            url = this.getResource( 'projects', projectId );
            useToken = true;
        }

        if ( shouldDelay() ) {
            return this.refreshProjectDataDelayed( projectId, url, useToken, attempt );
        }

        return this.request( {
            method: HTTPMethod.GET,
            url,
            useToken,
            success: ( response, resolve ) => {
                if ( shouldDelay() ) {
                    this.refreshProjectDataDelayed( projectId, url, useToken, attempt ).then( resolve );
                } else {
                    this._projectData = JSON.parse( response );
                    resolve();
                }
            },
        } );
    },

    /**
     * Method to update all the changes made on project data
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     */
    updateProjectData: function ( projectId, fieldsToUpload ) {
        var self = this;
        var updatedData = {};

        fieldsToUpload.forEach( function ( field ) {
            updatedData[ field ] = self._projectData[ field ];
        } );
        return this.request( {
            method: HTTPMethod.PATCH,
            url: self.getResource( 'projects', projectId ),
            data: JSON.stringify( updatedData ),
        } );
    },

    /**
     * Add layer configuration to the layer AQUI O EN PROJECT?
     * @method
     * @memberof pcvizDataAccess.CollageCloudDriver
     * @param  {Object} configurationId the id of the configuration to apply
     * @param  {int} layerId layer to associate to the configuration
     * @return {Promise}              The promise that is resolve when the request is complete.
     */
    addLayerConfigurationToProject: function ( configurationId, layerId, user ) {
        var json = {
            layerConfiguration: configurationId,
        };
        if ( user !== undefined ) {
            json[ 'user' ] = user;
        }

        return this.request( {
            method: HTTPMethod.POST,
            url: this.getResource( 'projects', this._projectId ) + 'layers/' + layerId + '/configuration/',
            data: JSON.stringify( json )
        } );
    },

    getWorkspace: function () {
        return this._workspace;
    },

    setWorkspace: function ( workspace ) {
        this._workspace = workspace;
    },

    fetchWorkspace: function ( project, version = 1 ) {
        var self = this;
        return new Promise( ( resolve, reject ) => {

            let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + version + '/' + Workflow.WORKSPACE_FILE_PATH;

            // We need to invalidate the cached file (We NEVER want to get a cached file)
            TimeStampCache.createTimeStamp( workspaceFilePath );

            var timeStampString = '?ts=' + TimeStampCache.getTimeStamp( workspaceFilePath );

            self.getObjectFile( project, workspaceFilePath + timeStampString ).then( workspace => {
                self._workspace = workspace;
                resolve( workspace );
            }, reject );
        } );
    },

    uploadWorkspace: function ( project, version = 1 ) {
        var self = this;
        return new Promise( ( resolve, reject ) => {
            let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + version + '/';
            self.getOrCreateWorkspace( project, version ).then( workspaceFile => {
                self.uploadObjectFile( project, JSON.stringify( workspaceFile ), Workflow.WORKSPACE_FILE_PATH, workspaceFilePath, 'application/json', BaseDriver.NO_CACHE, 'attachment' ).then( () => {
                    // We need to invalidate the cached file
                    TimeStampCache.createTimeStamp( workspaceFilePath + Workflow.WORKSPACE_FILE_PATH );
                    resolve();
                }, reject );
                // We need to invalidate the cached file
                //TimeStampCache.createTimeStamp( workspaceFilePath + Workflow.WORKSPACE_FILE_PATH );
            } );
        } );
    },

    getOrCreateWorkspace: function ( project, version = 1 ) {
        var self = this;
        return new Promise( ( resolve, reject ) => {
            if ( project.getWorkspace() ) {
                resolve( project.getWorkspace() );
                return;
            }
            self.fetchWorkspace( project, version ).then( resolve, error => {
                if ( error.status === 404 ) {
                    self._workspace = {
                        version: 1,
                        workspace: {
                            category: 'GLS Project',
                            type: 'ScanProject',
                            name: project.getName(),
                            catalogObjectId: project.getId(),
                            uuid: UtilsDB.generateUUID(),
                            children: []
                        }
                    };
                    let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + version + '/';
                    self.uploadObjectFile( project, JSON.stringify( self._workspace ), Workflow.WORKSPACE_FILE_PATH, workspaceFilePath, 'application/json', BaseDriver.NO_CACHE, 'attachment' ).then( () => {
                        // We need to invalidate the cached file
                        TimeStampCache.createTimeStamp( workspaceFilePath + Workflow.WORKSPACE_FILE_PATH );
                        resolve( self._workspace );
                    }, reject );
                    return;
                }
                reject( error );
            } );
        } );
    },

    launchWorkflowJob: function ( projectId, data, jobName ) {
        const urlJob = `${this.getResource( 'projects', projectId )}workflows/${jobName}`;

        return this.request( {
            method: HTTPMethod.POST,
            url: urlJob,
            data: JSON.stringify( data ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            },
            error: ( response, reject ) => {
                reject( response );
            }
        } );
    },

    reset: function () {
        BaseDriver.prototype.reset.call( this );
        this._projectData = undefined;
    }
} );

DriverRegistry.getInstance().registerDriver( 'da.project', new ProjectDriver() );


module.exports = ProjectDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/CollageCloudDriver.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/CollageCloudDriver.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDataBaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/SpatialDataBaseDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js" );
var CategoryDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/CategoryDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/CategoryDriver.js" );
var ProjectDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/ProjectDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/ProjectDriver.js" );
var LayerDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/LayerDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/LayerDriver.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var HTTPMethod = __webpack_require__( /*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );



/**
 *  CollageCloudDriver Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var CollageCloudDriver = function () {
    SpatialDataBaseDriver.call( this );
    CategoryDriver.call( this );
    ProjectDriver.call( this );
    LayerDriver.call( this );
};



CollageCloudDriver.prototype = Utils.objectInherit( CategoryDriver.prototype,

    Utils.objectInherit( ProjectDriver.prototype,
        Utils.objectInherit( LayerDriver.prototype, {

            // NOTE: in future itterations maybe each driver must be implement his own reset method.
            reset: function () {
                SpatialDataBaseDriver.prototype.reset.call( this );
                this._count = 0;
                this._open = false;
                this._currentCollagePage = undefined;
                this._geoDriver = undefined;
                this._previous = undefined;
                this._next = undefined;
                //  this._serverUrl = ''; // TODO: check if we want to reset all drivers. In that case we would need to configure all them when the project is started.

                this._user = undefined;
                this._pass = undefined;
                this._loginEnabled = true;

                this._projectId = undefined;
                this._projectData = undefined;

                this._layerType = undefined;
                this._layer = undefined;
            },

            getReport: function ( scopeVar ) {
                var defer = P.defer();
                if ( !this.entryPointExists( 'reports' ) ) {
                    defer.resolve( {
                        site: {
                            storageSize: 0,
                        },
                        company: {
                            storageSize: 0,
                        },
                        licences: {
                            maxstorage: 1000000000000,
                        }
                    } );
                    return defer.promise;
                }

                let url = this.getResource( 'reports' );
                if ( scopeVar ) {
                    url = url + '?scope=' + scopeVar + '&user=' + JSON.parse( window.localStorage[ 'ngStorage-currentUser' ] ).username;
                }
                return this.request( {
                    'url': url,
                    'method': HTTPMethod.GET,
                    'success': function ( response, resolve ) {
                        resolve( JSON.parse( response ) );
                    },
                    'error': function ( response, reject ) {
                        reject( UtilsDB.parseJSON( response ) );
                    }
                } );
            }

        } ) ) );


// Register driver
DriverRegistry.getInstance().registerDriver( 'da.collage', new CollageCloudDriver() );

module.exports = CollageCloudDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/DataBaseDriver.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/DataBaseDriver.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/SpatialDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDriver.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
/**
 *  DataBaseDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var DataBaseDriver = function () {
    SpatialDriver.call( this );
};

DataBaseDriver.prototype = Utils.objectInherit( SpatialDriver.prototype, {

    executeQuery: function ( /*query*/) {
        return false;
    }

} );

module.exports = DataBaseDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/Driver.js":
/*!***************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/Driver.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Driver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var Driver = function () {

};

Driver.prototype = {

    /**
     * @method
     * Open a driver and prepare all to be use
     * @memberof pcvizDataAccess.Driver
     * @param  {Object} connectionString The string to initialize the driver
     * @param  {Object} mode is to specify the way to use the connection string
     * @return {object} true if success false if something was wrong
     */
    open: function ( /*connetionString, mode*/) {
        return false;
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if driver is ok.false if driver is not ok
     */
    isOpen: function () {
        return false;
    },

    /**
     * @method
     * Close the driver
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if success .false if something was wrong driver is not ok
     */
    close: function () {
        return false;
    },

    /**
     * @method
     * Clean the driver
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if success .false if something was wrong driver is not ok
     */
    flush: function () {
        return false;
    },

    reset: function () {}

};

module.exports = Driver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/GeoJSONDriver.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/GeoJSONDriver.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDataBaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/SpatialDataBaseDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js" );
var GeoJSONDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/GeoJSONDataIterator */ "./sources/pcvizDataAccess/DataIterators/GeoJSONDataIterator.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );

/**
 *  GeoJSONDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var GeoJSONDriver = function () {
    SpatialDataBaseDriver.call( this );
    this._count = 0;
    this._open = false;

    this._geoObjs = new Map();
};

GeoJSONDriver.prototype = Utils.objectInherit( SpatialDataBaseDriver.prototype, {

    // FIXME: If you are going to use this function, check what to do with the _geoObjs
    open: function ( connectionString /*, mode*/ ) {
        var defer = P.defer();
        var self = this;
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if ( this.readyState === 4 && this.status === 200 ) {

                // self._geoObj = JSON.parse( this.responseText );
                self._open = true;
                defer.resolve( true );
            }
        };
        xmlhttp.open( 'GET', connectionString, true );
        xmlhttp.send();

        return defer.promise;
    },

    // Don't call to this method without config unless you are sure there's only one layer with one page
    openFromData: function ( geoJSONData, config ) {
        var defer = P.defer();
        if ( geoJSONData !== undefined ) {
            this._geoObjs.set( JSON.stringify( config ), geoJSONData );
            this._open = true;
            defer.resolve( this._open );
        }
        return defer.promise;
    },

    isOpen: function () {
        return this._open;
    },

    getNumSourceLayers: function () {
        return 1; // all geoJSON files has only one layer
    },

    /**
     * @method
     * Return the sourceLayer using the id. the geoJSON only has one layer, this function always return this unique layer
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @return {object} Object Iterator for GeoJSON data
     */
    getSourceLayerById: function ( configPageId /*, id*/ ) {
        return this.getSourceLayer( configPageId );
    },

    // This function is not used
    getSourceLayerByName: function ( /*name*/) {
        //  return this.getSourceLayerById();
    },

    getSourceLayer: function ( configPageId ) {
        //FIX ME: we use here a promise because the API for this method on CollageCloudDriver needs to use a promise.
        var defer = P.defer();
        var geoIterator;
        if ( this._geoObjs.get( JSON.stringify( configPageId ) ) )
            geoIterator = new GeoJSONDataIterator( this, this._geoObjs.get( JSON.stringify( configPageId ) ) );
        defer.resolve( geoIterator ); // This could return undefined if the layer hasn't been opened correctly
        return defer.promise;
    },

    /**
     * Getter for geoJSON object
     * @method
     * @memberof pcvizDataAccess.GeoJSONDriver
     * @return {object} The geoJSON object
     */
    getGeoObject: function ( pag ) {
        return this._geoObjs.get( JSON.stringify( pag ) );
    },

} );


// Register driver
DriverRegistry.getInstance().registerDriver( 'da.geoJSON', new GeoJSONDriver() );

module.exports = GeoJSONDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js":
/*!*******************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/HTTPMethod.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var HTTPMethod = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE'
};
module.exports = HTTPMethod;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js":
/*!******************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DataBaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/DataBaseDriver */ "./sources/pcvizDataAccess/Drivers/DataBaseDriver.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
/**
 *  DataBaseDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var SpatialDataBaseDriver = function () {
    DataBaseDriver.call( this );
    this._iterator = undefined; // SapatialDataIterator
};

SpatialDataBaseDriver.prototype = Utils.objectInherit( DataBaseDriver.prototype, {

    getNumSourceLayers: function () {
        // return num layers
    },
    /**
     * It returns an iterator over the layer applying a filter
     * if filter is undefined it returns an iterator over the whole layer.
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {int} index of the layer on the layer tree
     * @param  {filter} filter
     * @return {Promise} [description]
     */
    getSourceLayerByIndex: function ( /*index, filter*/) {
        // return layer searching by index applying an specific filter
    },
    /**
     * It returns an iterator over the layer applying a filter
     * if filter is undefined it returns an iterator over the whole layer.
     * @param  {string} Name of the layer
     * @param  {filter} filter
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @return {Promise} [description]
     */
    getSourceLayerByName: function ( /*name, filter*/) {
        // return layer searching by name applying an specific filter
    },
    /**
     * It returns an iterator over the layer applying a filter
     * if filter is undefined it returns an iterator over the whole layer.
     * @param  {int} id of the layer
     * @param  {filter} filter
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @return {Promise} [description]
     */
    getSourceLayerById: function ( /*id, filter*/) {
        // return layer searching by id applying an specific filter
    },
    /**
     * Get the position of a layer by name
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {string} name the name of the layer
     * @return {int}      the position of the layer
     */
    getLayerIndexByName: function ( /*name*/) {
        return undefined;
    },

    /**
     * Get the index of a layer in the layer array by its id.
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {string} id The id of the layer
     * @return {int}      The index of the layer
     */
    getLayerIndexById: function ( /*id*/) {
        return undefined;
    },
    /**
     * Get the type of a layer in the layer array by its index.
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {string} index of the layer
     * @return {string }  The type of the layer
     */
    getLayerTypeByIndex: function ( /*index*/) {

    },
    /**
     * Get the type of a layer in the layer array by its index.
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {string} index of the layer
     * @return {string }  The name of the layer
     */
    getLayerNameByIndex: function ( /*index*/) {

    },
    /**
     * Get the Id of a layer in the layer array by its index.
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param  {string} index of the layer
     * @return {int }  The id of the layer
     */
    getLayerIdByIndex: function ( /*index*/) {

    },

    /**
     * create source layer on a server
     * @method
     * @memberof pcvizDataAccess.SpatialDataBaseDriver
     * @param {layer} f  the feature to be added
     * @return {layer }  The created layer
     */
    createSourceLayer: function () {
        console.log( 'SpatialDataBaseDriver.createSourceLayer: Not implemented' );
        return undefined;
    },
    /**
     * Delete source layer from a server
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {Feature} f  the feature to be added
     */
    deleteSourceLayer: function () {
        console.log( 'SpatialDataBaseDriver.deleteSourceLayer: Not implemented' );
        return undefined;
    },
    /**
     * Update source layer on a server
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {Feature} f  the feature to be added
     */
    updateSourceLayer: function () {
        console.log( 'SpatialDataBaseDriver.updateSourceLayer: Not implemented' );
        return undefined;
    },
    /**
     * Add the association between the layer and the project
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {int} idProject the id of the project
     * @param {int} idLayer the id of the layer
     */
    addLayerToProject: function ( /*idProject, idLayer*/) {
        console.log( 'SpatialDataBaseDriver.addLayerToProject: Not implemented' );
        return undefined;
    },
    /**
     * Delete the association between the layer and the project
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param {int} idProject the id of the project
     * @param {int} idLayer the id of the layer
     */
    deleteLayerFromProject: function ( /*idProject, idLayer*/) {
        console.log( 'SpatialDataBaseDriver.deleteLayerFromProject: Not implemented' );
        return undefined;
    },

    reset: function () {
        DataBaseDriver.prototype.reset.call( this );
        this._iterator = undefined;
    }

} );

module.exports = SpatialDataBaseDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/SpatialDriver.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/SpatialDriver.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Driver = __webpack_require__( /*! pcvizDataAccess/Drivers/Driver */ "./sources/pcvizDataAccess/Drivers/Driver.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
/**
 *  SpatialDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var SpatialDriver = function () {
    Driver.call( this );
    this._extent = undefined;
    this._spatialReference = undefined;
};

SpatialDriver.prototype = Utils.objectInherit( Driver.prototype, {
    /**
     * @method
     * Setup the extension
     * @memberof pcvizDataAccess.SpatialDriver
     * @param  {Object} minX minimum X of the extent
     * @param  {Object} minY minimum Y of the extent
     * @param  {Object} maxX maximum X of the extent
     * @param  {Object} maxY maximum Y of the extent
     * @param  {Object} minZ minimum Z of the extent
     * @param  {Object} maxZ maximum Z of the extent
     */
    setExtension: function ( /*minX, minY, maxX, maxY, minZ, maxZ*/) {
        console.log( 'SpatialDriver.setExtension: Not implemented' );
    },

    /**
     * @method
     * get the extension
     * @memberof pcvizDataAccess.SpatialDriver
     * @return {Object} the extent object
     */
    getExtension: function ( /*minX, minY, maxX, maxY, minZ, maxZ*/) {
        return this._extent;
    },

    /**
     * @method
     * get all the extent using a sql query
     * @memberof pcvizDataAccess.SpatialDriver
     * @param  {Object} minX minimum X of the extent
     * @param  {Object} minY minimum Y of the extent
     * @param  {Object} maxX maximum X of the extent
     * @param  {Object} maxY maximum Y of the extent
     * @param  {Object} minZ minimum Z of the extent
     * @param  {Object} maxZ maximum Z of the extent
     * @return {Object} the result extent
     */
    queryExtension: function ( /*minX, minY, maxX, maxY, minZ, maxZ*/) {
        console.log( 'SpatialDriver.queryExtension: Not implemented' );
        return false;
    },

    /**
     * @method
     * Set the spatial reference
     * @memberof pcvizDataAccess.SpatialDriver
     * @param  {Object} spatial reference
     */
    setSpatialReference: function ( spatialReference ) {
        this._spatialReference = spatialReference;
    },

    /**
     * @method
     * Get the spatial reference
     * @memberof pcvizDataAccess.SpatialDriver
     * @return {Object} spatial reference
     */
    getSpatialReference: function () {
        return this._spatialReference;
    },

    reset: function () {
        Driver.prototype.reset.call( this );
        this._extent = undefined;
        this._spatialReference = undefined;
    }


} );

module.exports = SpatialDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/UAV/CSVDriver.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/UAV/CSVDriver.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var UAVDriverBase = __webpack_require__( /*! pcvizDataAccess/Drivers/UAV/UAVDriverBase */ "./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;


/**
 *  CSVDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var CSVDriver = function () {
    UAVDriverBase.call( this );
    this._open = false;
    this._data = undefined;
    this._name = undefined;
    this.description = undefined;
    this._version = '0';

};

CSVDriver.prototype = Utils.objectInherit( UAVDriverBase.prototype, {

    parseData: function ( csv ) {

        this._data = {
            'type': 'FeatureCollection',
            'features': [],
            'crs': {
                'type': 'name',
                'properties': {}
            }
        };

        this._data.crs.properties.definition = 'EPSG:4326';
        this._data.crs.properties.name = 'EPSG:4326';

        var allTextLines = csv.split( /\r\n|\n/ );
        var lines = [];
        var featureId = 0;
        for ( var i = 0; i < allTextLines.length; i++ ) {
            var data = UtilsDB.splitCSVLine( allTextLines[ i ] );

            var tarr = [];
            for ( var j = 0; j < data.length; j++ ) {
                tarr.push( data[ j ] );
            }
            var properties = {};
            var photoElement = this.parsePhotoElement( tarr, JSON.parse( JSON.stringify( properties ) ) );
            photoElement.id = featureId;
            featureId++;
            this._data.features.push( photoElement );
            lines.push( tarr );
        }

        return this._data;
    },

    findElement: function ( /*node, id*/) {

    },

    parsePhotoElement: function ( element, properties ) {
        // must be implemented

        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': osg.vec3.create()
            },
            'properties': properties
        };

        // parse ImagePath
        var ImagePath = element[ 0 ];
        var str = this.sanitizePath( ImagePath );
        if ( str.lastIndexOf( '//' ) !== -1 )
            str = str.substring( str.lastIndexOf( '//' ) + 2 );
        feature.properties[ 'file_name' ] = str;

        feature.geometry.coordinates[ 0 ] = Number.parseFloat( element[ 1 ] );
        feature.geometry.coordinates[ 1 ] = Number.parseFloat( element[ 2 ] );
        feature.geometry.coordinates[ 2 ] = Number.parseFloat( element[ 3 ] );

        feature.properties.x = feature.geometry.coordinates[ 0 ];
        feature.properties.y = feature.geometry.coordinates[ 1 ];
        feature.properties.z = feature.geometry.coordinates[ 2 ];

        return feature;
    },


    /**
     * Method to use when there are different version for the same file format.
     * for now we don´t use this method
     */
    acceptFile: function ( /*data*/) {
        return true;
    },
} );


// Register driver
DriverRegistry.getInstance().registerDriver( 'da.UAVCsv', new CSVDriver() );
module.exports = CSVDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js":
/*!**************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var SpatialDataBaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/SpatialDataBaseDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var GeoJSONDataIterator = __webpack_require__( /*! pcvizDataAccess/DataIterators/GeoJSONDataIterator */ "./sources/pcvizDataAccess/DataIterators/GeoJSONDataIterator.js" );

var xmlHttpRequestStatusOK = 200;

/**
 *  UAVDriverBase Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var UAVDriverBase = function () {
    SpatialDataBaseDriver.call( this );
    this._open = false;
    this._data = undefined;
    this._name = undefined;
    this.description = undefined;
    this._version = '0';

};

UAVDriverBase.prototype = Utils.objectInherit( SpatialDataBaseDriver.prototype, {
    open: function ( connectionString ) {
        var defer = P.defer();
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if ( this.readyState === XMLHttpRequest.DONE && this.status === xmlHttpRequestStatusOK ) {
                defer.resolve( this.openFromData( this.responseText ) );
            }
        };
        xmlhttp.open( 'GET', connectionString, true );
        xmlhttp.send();

        return defer.promise;
    },

    openFromData: function ( uavXmlData ) {
        var defer = P.defer();
        if ( uavXmlData !== undefined ) {
            this._data = this.parseData( uavXmlData );
            this._open = true;
            defer.resolve( this._open );
        }
        return defer.promise;
    },

    isOpen: function () {
        return this._open;
    },

    parseData: function ( /*data*/) {
        // must be implemented
    },

    findElement: function ( node, id ) {
        var element;
        var find = false;
        for ( var i = 0; i < node.childNodes.length; i++ ) {
            element = node.childNodes[ i ];
            if ( element.tagName === id ) {
                find = true;
                break;
            }
        }
        if ( !find )
            return;

        return {
            id: element.tagName,
            value: element.textContent
        };
    },

    parsePhotoElement: function ( /*element, properties*/) {
        // must be implemented
    },

    getSourceLayer: function () {
        return new GeoJSONDataIterator( this, this._data );
    },

    getSpatialReference: function () {
        var spatialRef = this._data.crs.properties;
        return ( ( spatialRef.name !== undefined ) ? spatialRef.name : spatialRef.definition );
    },


    getFile: function ( connectionString ) {
        var defer = P.defer();
        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if ( this.readyState === XMLHttpRequest.DONE && this.status === xmlHttpRequestStatusOK ) {

                defer.resolve( this.responseText );
            }
        };
        xmlhttp.open( 'GET', connectionString, true );
        xmlhttp.send();

        return defer.promise;
    },

    /**
     * Method to use when there are different version for the same file format.
     * for now we don´t use this method
     */
    acceptFile: function ( /*data*/) {
        return true;
    },

    sanitizePath: function ( cad ) {
        return cad.replace( /\\/g, '//' );
    }
} );

module.exports = UAVDriverBase;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/UAV/XMLBlockDriver.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/UAV/XMLBlockDriver.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var UAVDriverBase = __webpack_require__( /*! pcvizDataAccess/Drivers/UAV/UAVDriverBase */ "./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
/**
 *  XMLBlockDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var XMLBlockDriver = function () {
    UAVDriverBase.call( this );
    this._version = '3.2';

};

XMLBlockDriver.prototype = Utils.objectInherit( UAVDriverBase.prototype, {


    parseData: function ( data ) {
        this._data = {
            'type': 'FeatureCollection',
            'features': [],
            'crs': {
                'type': 'name',
                'properties': {}
            }
        };

        data = UtilsDB.cleaupFileCharacters( data );

        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString( data, 'text/xml' );

        // getting Block
        var block = xmlDoc.getElementsByTagName( 'Block' )[ 0 ];
        var srsIdtag = this.findElement( block, 'SRSId' );
        var srsId = Number.parseInt( srsIdtag.value );

        // getting spatial reference
        var spatialReferenceSystems = xmlDoc.getElementsByTagName( 'SpatialReferenceSystems' )[ 0 ];
        var crs = spatialReferenceSystems.getElementsByTagName( 'SRS' );

        var spatialRef;
        for ( var k = 0; k < crs.length; k++ ) {
            spatialRef = crs[ k ];
            var id = Number.parseInt( this.findElement( crs[ k ], 'Id' ).value );
            if ( id === srsId )
                break;
        }
        if ( spatialRef !== undefined ) {
            // parse Definition
            var Definition = this.findElement( spatialRef, 'Definition' );
            this._data.crs.properties.definition = Definition.value;
            // name Definition
            var Name = this.findElement( spatialRef, 'Name' );
            this._data.crs.properties.name = Name.value;
        }

        // parse Name
        var blockName = this.findElement( block, 'Name' );
        this._name = blockName.value;

        // parse Description
        var blockDescription = this.findElement( block, 'Description' );
        this._description = blockDescription.value;

        // getting photogroup
        var photoGroup = xmlDoc.getElementsByTagName( 'Photogroup' );
        for ( var i = 0; i < photoGroup.length; i++ ) {
            var pGroup = photoGroup[ i ];

            var properties = {};

            // parse Name
            var photoGroupName = this.findElement( pGroup, 'Name' );
            properties[ photoGroupName.id ] = photoGroupName.value;

            // getting ImageDimensions
            var imageDimensions = pGroup.getElementsByTagName( 'ImageDimensions' )[ 0 ];
            // parse Width
            var photoGroupWidth = this.findElement( imageDimensions, 'Width' );
            var width = Number.parseInt( photoGroupWidth.value );
            properties.width = width;
            // parse Height
            var photoGroupHeight = this.findElement( imageDimensions, 'Height' );
            var height = Number.parseInt( photoGroupHeight.value );
            properties.height = height;

            // parse CameraModelType
            var photoGroupCameraModelType = this.findElement( pGroup, 'CameraModelType' );
            if ( photoGroupCameraModelType )
                properties.cameraModelType = photoGroupCameraModelType.value;

            // parse Description
            var photoGroupDescription = this.findElement( pGroup, 'Description' );
            if ( photoGroupDescription )
                properties.description = photoGroupDescription.value;
            // parse SensorSize
            var photoGroupSensorSize = this.findElement( pGroup, 'SensorSize' );
            var sensorSize = 35.9;
            if ( photoGroupSensorSize && photoGroupSensorSize.id !== undefined )
                sensorSize = Number.parseFloat( photoGroupSensorSize.value );

            // parse FocalLength
            var photoGroupFocalLength = this.findElement( pGroup, 'FocalLength' );
            if ( photoGroupFocalLength ) {
                properties.flen = Number.parseFloat( photoGroupFocalLength.value );
            }
            // parse CameraOrientation
            var photoGroupCameraOrientation = this.findElement( pGroup, 'CameraOrientation' );
            if ( photoGroupCameraOrientation )
                properties.cameraOrientation = photoGroupCameraOrientation.value;

            var aspect = width / height;
            properties.sensorWidth = sensorSize;
            properties.sensorHeight = sensorSize / aspect;

            properties.principalPointX = '';
            properties.principalPointY = '';

            // getting ImageDimensions
            var principalPoint = pGroup.getElementsByTagName( 'PrincipalPoint' )[ 0 ];
            if ( principalPoint ) {
                // parse Width
                var principalPointX = this.findElement( principalPoint, 'x' );
                properties.principalPointX = ( Number.parseFloat( principalPointX.value ) * properties.sensorWidth ) / width;
                // parse Height
                var principalPointY = this.findElement( principalPoint, 'y' );
                properties.principalPointY = ( Number.parseFloat( principalPointY.value ) * properties.sensorHeight ) / height;
            }
            // getting Photos
            var photos = pGroup.getElementsByTagName( 'Photo' );
            for ( var j = 0; j < photos.length; j++ ) {
                this._data.features.push( this.parsePhotoElement( photos[ j ], JSON.parse( JSON.stringify( properties ) ) ) );
            }
        }

        return this._data;
    },

    parsePhotoElement: function ( element, properties ) {
        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': osg.vec3.create()
            },
            'properties': properties
        };

        // parse Id
        var Id = this.findElement( element, 'Id' );
        feature.properties[ 'id' ] = Number.parseInt( Id.value );

        // parse ImagePath
        var ImagePath = this.findElement( element, 'ImagePath' );
        var str = this.sanitizePath( ImagePath.value );
        if ( str.lastIndexOf( '//' ) !== -1 ) {
            str = str.substring( str.lastIndexOf( '//' ) + 2 );
        }
        feature.properties[ 'file_name' ] = str;

        var rotationElement = element.getElementsByTagName( 'Rotation' )[ 0 ];
        if ( rotationElement ) {
            // parse Rotation
            var rotation = osg.mat3.create();
            if ( this.findElement( rotationElement, 'Omega' ) ) {

                var omega = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Omega' ).value );
                var phi = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Phi' ).value );
                var kappa = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Kappa' ).value );

                rotation[ 0 ] = Math.cos( phi ) * Math.cos( kappa );
                rotation[ 1 ] = ( Math.cos( omega ) * Math.sin( kappa ) ) + ( Math.sin( omega ) * Math.sin( phi ) * Math.cos( kappa ) );
                rotation[ 2 ] = ( Math.sin( omega ) * Math.sin( kappa ) ) - ( Math.cos( omega ) * Math.sin( phi ) * Math.cos( kappa ) );

                rotation[ 3 ] = -Math.cos( phi ) * Math.sin( kappa );
                rotation[ 4 ] = ( Math.cos( omega ) * Math.cos( kappa ) ) - ( Math.sin( omega ) * Math.sin( phi ) * Math.sin( kappa ) );
                rotation[ 5 ] = ( Math.sin( omega ) * Math.cos( kappa ) ) + ( Math.cos( omega ) * Math.sin( phi ) * Math.sin( kappa ) );

                rotation[ 6 ] = Math.sin( phi );
                rotation[ 7 ] = -Math.sin( omega ) * Math.cos( phi );
                rotation[ 8 ] = Math.cos( omega ) * Math.cos( phi );

                rotation = osg.mat3.transpose( rotation, rotation );

            } else if ( this.findElement( rotationElement, 'Yaw' ) ) {

                var yaw = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Yaw' ).value );
                var pitch = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Pitch' ).value );
                var roll = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Roll' ).value );

                rotation[ 0 ] = Math.cos( roll ) * Math.cos( yaw ) - Math.sin( roll ) * Math.sin( pitch ) * Math.sin( yaw );
                rotation[ 1 ] = ( -Math.cos( roll ) * Math.sin( yaw ) ) - ( Math.cos( yaw ) * Math.sin( roll ) * Math.sin( pitch ) );
                rotation[ 2 ] = Math.cos( pitch ) * Math.sin( roll );

                rotation[ 3 ] = Math.cos( yaw ) * Math.sin( roll ) + Math.cos( roll ) * Math.sin( pitch ) * Math.sin( yaw );
                rotation[ 4 ] = ( Math.cos( roll ) * Math.cos( yaw ) * Math.sin( pitch ) ) - ( Math.sin( roll ) * Math.sin( yaw ) );
                rotation[ 5 ] = -Math.cos( roll ) * Math.cos( pitch );

                rotation[ 6 ] = Math.cos( pitch ) * Math.sin( yaw );
                rotation[ 7 ] = Math.cos( pitch ) * Math.cos( yaw );
                rotation[ 8 ] = Math.sin( pitch );

                rotation = osg.mat3.transpose( rotation, rotation );

            } else if ( this.findElement( rotationElement, 'Heading' ) ) {
                // this case is deprecated by context capture. It is implemented to prevent old Files

                var headingDep = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Heading' ).value );
                var rollDep = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Roll' ).value );
                var pitchDep = UtilsDB.degreesToRadians( this.findElement( rotationElement, 'Pitch' ).value );

                rotation[ 0 ] = Math.cos( headingDep ) * Math.cos( rollDep ) + Math.sin( headingDep ) * Math.sin( pitchDep ) * Math.sin( rollDep );
                rotation[ 1 ] = ( -Math.sin( headingDep ) * Math.cos( rollDep ) ) + ( Math.cos( headingDep ) * Math.sin( pitchDep ) * Math.sin( rollDep ) );
                rotation[ 2 ] = Math.cos( pitchDep ) * Math.sin( rollDep );

                rotation[ 3 ] = Math.sin( headingDep ) * Math.cos( pitchDep );
                rotation[ 4 ] = Math.cos( headingDep ) * Math.cos( pitchDep );
                rotation[ 5 ] = Math.sin( pitchDep );

                rotation[ 6 ] = Math.cos( headingDep ) * Math.sin( rollDep ) - Math.sin( headingDep ) * Math.sin( pitchDep ) * Math.cos( rollDep );
                rotation[ 7 ] = -Math.sin( headingDep ) * Math.sin( rollDep ) - Math.cos( headingDep ) * Math.sin( pitchDep ) * Math.cos( rollDep );
                rotation[ 8 ] = Math.cos( pitchDep ) * Math.cos( rollDep );

                rotation = osg.mat3.transpose( rotation, rotation );
            } else {

                var matrixNames = [ 'M_00', 'M_10', 'M_20', 'M_01', 'M_11', 'M_21', 'M_02', 'M_12', 'M_22' ];
                for ( var i = 0; i < matrixNames.length; i++ ) {
                    rotation[ i ] = Number.parseFloat( this.findElement( rotationElement, matrixNames[ i ] ).value );
                }
            }
            var rotNew = [];
            if ( properties.cameraOrientation === 'XLeftYDown' ) {
                osg.mat3.scale( rotNew, rotation, [ 1, -1 ] );
                // scale Z -1
                rotNew[ 6 ] = -rotNew[ 6 ];
                rotNew[ 7 ] = -rotNew[ 7 ];
                rotNew[ 8 ] = -rotNew[ 8 ];

            }

            if ( properties.cameraOrientation === 'XDownYRight' ) {
                rotNew[ 0 ] = -rotation[ 3 ];
                rotNew[ 1 ] = -rotation[ 4 ];
                rotNew[ 2 ] = -rotation[ 5 ];

                rotNew[ 3 ] = -rotation[ 0 ];
                rotNew[ 4 ] = -rotation[ 1 ];
                rotNew[ 5 ] = -rotation[ 2 ];

                rotNew[ 6 ] = -rotation[ 6 ];
                rotNew[ 7 ] = -rotation[ 7 ];
                rotNew[ 8 ] = -rotation[ 8 ];

                rotNew[ 1 ] = -rotNew[ 1 ];
                rotNew[ 3 ] = -rotNew[ 3 ];
            }

            if ( rotNew.length === 0 )
                rotNew = rotation;

            var quat = osg.quat.create();
            osg.quat.fromMat3( quat, rotNew );
            osg.quat.multiply( quat, quat, [ 1, 0, 0, 0 ] );

            feature.properties[ 'quatX' ] = -quat[ 0 ];
            feature.properties[ 'quatY' ] = quat[ 1 ];
            feature.properties[ 'quatZ' ] = quat[ 2 ];
            feature.properties[ 'quatW' ] = quat[ 3 ];

        }

        var centerElement = element.getElementsByTagName( 'Center' )[ 0 ];
        // parse Rotation
        feature.geometry.coordinates[ 0 ] = Number.parseFloat( this.findElement( centerElement, 'x' ).value );
        feature.geometry.coordinates[ 1 ] = Number.parseFloat( this.findElement( centerElement, 'y' ).value );
        feature.geometry.coordinates[ 2 ] = Number.parseFloat( this.findElement( centerElement, 'z' ).value );

        feature.properties.x = feature.geometry.coordinates[ 0 ];
        feature.properties.y = feature.geometry.coordinates[ 1 ];
        feature.properties.z = feature.geometry.coordinates[ 2 ];

        feature.properties.fovW = 2.0 * Math.atan( ( 0.5 * properties.sensorWidth ) / properties.flen );
        feature.properties.fovH = 2.0 * Math.atan( ( 0.5 * properties.sensorHeight ) / properties.flen );

        feature.properties.sensorWidth = properties.sensorWidth;
        feature.properties.sensorHeight = properties.sensorHeight;

        return feature;
    },

    acceptFile: function ( data ) {
        data = UtilsDB.cleaupFileCharacters( data );

        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString( data, 'text/xml' );

        // getting Block
        var block = xmlDoc.getElementsByTagName( 'Block' )[ 0 ];
        return ( block !== undefined );
    }

} );


// Register driver
DriverRegistry.getInstance().registerDriver( 'da.UAVBlock', new XMLBlockDriver() );
module.exports = XMLBlockDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/Drivers/UAV/XMLPhotoScanDriver.js":
/*!*******************************************************************!*\
  !*** ./sources/pcvizDataAccess/Drivers/UAV/XMLPhotoScanDriver.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var UAVDriverBase = __webpack_require__( /*! pcvizDataAccess/Drivers/UAV/UAVDriverBase */ "./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  XMLPhotoScanDriver Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var XMLPhotoScanDriver = function () {
    UAVDriverBase.call( this );
    this._version = '1.2.0';

};

XMLPhotoScanDriver.prototype = Utils.objectInherit( UAVDriverBase.prototype, {


    parseData: function ( data ) {
        this._data = {
            'type': 'FeatureCollection',
            'features': [],
            'crs': {
                'type': 'name',
                'properties': {}
            }
        };

        data = UtilsDB.cleaupFileCharacters( data );

        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString( data, 'text/xml' );

        var Definition = this.findElement( xmlDoc.childNodes[ 0 ], 'reference' );
        if ( Definition )
            this._data.crs.properties.definition = Definition.value;

        var camera = xmlDoc.getElementsByTagName( 'camera' )[ 0 ];
        if ( camera !== undefined ) {
            var child = camera.children[ 0 ];
            var properties = {};
            this._data.features.push( this.parsePhotoElement( child, JSON.parse( JSON.stringify( properties ) ) ) );
        }

        return this._data;
    },

    parsePhotoElement: function ( element, properties ) {
        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': osg.vec3.create()
            },
            'properties': properties
        };
        feature.geometry.coordinates[ 0 ] = Number.parseFloat( element.getAttribute( 'x' ) );
        feature.geometry.coordinates[ 1 ] = Number.parseFloat( element.getAttribute( 'y' ) );
        feature.geometry.coordinates[ 2 ] = Number.parseFloat( element.getAttribute( 'z' ) );

        feature.properties.x = feature.geometry.coordinates[ 0 ];
        feature.properties.y = feature.geometry.coordinates[ 1 ];
        feature.properties.z = feature.geometry.coordinates[ 2 ];

        return feature;
    },

    acceptFile: function ( data ) {
        data = UtilsDB.cleaupFileCharacters( data );

        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString( data, 'text/xml' );

        // getting Block
        var reference = xmlDoc.getElementsByTagName( 'reference' )[ 0 ];
        return ( reference !== undefined );
    }

} );


// Register driver
DriverRegistry.getInstance().registerDriver( 'da.UAVPhotoScan', new XMLPhotoScanDriver() );
module.exports = XMLPhotoScanDriver;


/***/ }),

/***/ "./sources/pcvizDataAccess/EntryPoints.js":
/*!************************************************!*\
  !*** ./sources/pcvizDataAccess/EntryPoints.js ***!
  \************************************************/
/*! exports provided: MagnetEntryPoints, SiteEntryPoints */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MagnetEntryPoints", function() { return MagnetEntryPoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SiteEntryPoints", function() { return SiteEntryPoints; });
const SiteEntryPoints = {
    'login': '/api/users/login',
    'refresh': '/api/users/refresh',
    'users': '/api/users/',
    'groups': '/api/groups/',
    'projectsList': '/api/projects/',
    'projects': '/api/projects/',
    'projectsFiles': '/api/projects/',
    'layersList': '/api/layers/',
    'layers': '/api/layers/',
    'layersFiles': '/api/layers/',
    'layerConfigurations': '/api/layer-configurations/',
    'projectConfigurations': '/api/project-configurations/',
    'categories': '/api/categories/',
    'reports': undefined,
    'processes': '/api/processes/',
    'jobs': '/api/jobs/',
    'singlePartUpload': '/api/{type}/', // For Collage Site
    'multiPartUpload': undefined, // For Collage Site
    'anonymous-code': '/anonymous-code/',
    'preferences': '/preferences/',
    'events': '/api/events/',
    'cloudId': '/api/cloud-id', // Back has requested that we remove the last slash
    'verityInstances': '/api/projects/{projectId}/verity/instances/{uuid}',
    'verity': '/api/verity/',
    'sites': '/api/sites/', // this is only required for driver test, in real time the entry point is taken from the environment configuration
    'sitesFiles': '/api/sites/',
    'siteConfigurations': '/api/site-configurations/',

};

const MagnetEntryPoints = { // the ones with /mirage prefix go through the proxy to Mirage API
    'login': '/mirage/api/users/login',
    'refresh': '/mirage/api/users/refresh',
    'users': '/users/',
    'groups': '/mirage/api/groups/',
    'projects': '/catalog/collage/projects/',
    'projectsFiles': '/catalog/collage/projects/',
    'projectsList': '/catalog/collage/projects/',
    'layers': '/catalog/collage/layers/',
    'layersFiles': '/catalog/collage/layers/',
    'layersList': '/catalog/collage/layers/',
    'reports': '/report',
    'layerConfigurations': '/catalog/collage-common/layer-configurations/',
    'projectConfigurations': '/catalog/collage-common/project-configurations/',
    'categories': '/catalog/collage/categories/',
    'processes': '/processes/',
    'jobs': '/jobs/',
    'singlePartUpload': '/catalog/collage/{type}/',
    'multiPartUpload': '/catalog/collage/{type}/',
    'anonymous-code': '/anonymous-code/',
    'preferences': '/preferences/',
    'events': '/events',
    'cloudId': undefined,
    'sites': '/catalog/collage/sites/',
    'sitesFiles': '/catalog/collage/sites/',
    'latestDashboardElements': '/dashboard',
    'siteConfigurations': '/catalog/collage-common/site-configurations/',
};




/***/ }),

/***/ "./sources/pcvizDataAccess/ExporterRegistry.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizDataAccess/ExporterRegistry.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Exporter registry Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterRegistry = {

    SOURCE_2D: 'Source2D',
    SOURCE_3D: 'Source3D',
    SOURCE_VECTOR: 'SourceVector',
    SOURCE_POINT_CLOUD: 'SourcePointCloud',
    EVENT_LOG: 'EventLog',
    WORKFLOW_SETTINGS: 'WorkflowSettings',

    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizDataAccess.ExporterRegistry
     * @return {Object} The `Registry` instance.
     */
    getInstance: function () {
        if ( !ExporterRegistry.instance ) {
            ExporterRegistry.instance = this;
            ExporterRegistry.instance.exporters = new Map();
        }
        return ExporterRegistry.instance;
    },

    /**
     * Registers an exporter.
     * @method
     * @memberof pcvizDataAccess.ExporterRegistry
     * @param  {string} name           The name of the exporter.
     * @param  {Exporter} exporterInstance The exporter instance.
     */
    registerExporter: function ( name, exporterInstance ) {
        if ( ExporterRegistry.instance.exporters.get( name ) !== undefined )
            console.log( 'the exporter already exists' );
        ExporterRegistry.instance.exporters.set( name, exporterInstance );
    },

    /**
     * Gets an exporter.
     * @method
     * @memberof pcvizDataAccess.ExporterRegistry
     * @param  {string} name The name of the exporter.
     * @return {Exporter}      The exporter instance.
     */
    getExporter: function ( name ) {
        return ExporterRegistry.instance.exporters.get( name );
    },

    /**
     * @method
     * Gets naming info about the format supported by exporters
     * @memberof pcvizDataAccess.ExporterRegistry
     * @return an array of objects with info about formats supported by the Exporter
     */
    getFormatInfo: function ( sourceArray ) {
        var formatInfo = [];
        var self = this;

        var numSourceProps = 0;
        if ( sourceArray !== undefined )
            numSourceProps = sourceArray.length;

        ExporterRegistry.instance.exporters.forEach( function ( exporter ) {
            var supportedSources = exporter.getSupportedSources();

            // count supported source types
            var numPropsSupported = 0;
            supportedSources.forEach( function ( support ) {
                if ( self.contains( sourceArray, support ) )
                    numPropsSupported++;
            } );
            if ( numPropsSupported === numSourceProps ) {
                var infos = exporter.getExporterInfo();
                infos.forEach( function ( info ) {
                    if ( !self.containsValue( formatInfo, info ) )
                        formatInfo.push( info );
                } );
            }
        } );

        return formatInfo;
    },

    /**
     * Clears the list of registered drivers.
     * @method [name]
     * @memberof pcvizDataAccess.ExporterRegistry
     */
    unregisterAllExporters: function () {
        ExporterRegistry.instance.exporters.clear();
    },

    contains: function ( objArray, obj ) {
        var exists = false;
        objArray.forEach( function ( format ) {
            if ( format === obj )
                exists = true;
        } );
        return exists;
    },

    containsValue: function ( objArray, obj ) {
        var exists = false;
        objArray.forEach( function ( format ) {
            if ( format.value === obj.value )
                exists = true;
        } );
        return exists;
    }

};


module.exports = ExporterRegistry;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/Exporter.js":
/*!*******************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/Exporter.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var utf8 = __webpack_require__( /*! utf8 */ "./node_modules/utf8/utf8.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var CollageWebFileBrowser = __webpack_require__( /*! pcvizDataAccess/CollageWebFileBrowser */ "./sources/pcvizDataAccess/CollageWebFileBrowser.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );

/**
 *  Exporter Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var Exporter = function () {
    this._cwFileBrowser = new CollageWebFileBrowser();
    this._cwFileBrowser.setMagnetAPI( MagnetAPI );
};

Exporter.prototype = {

    isBlobSaveSupported: function () {
        return ( window.Blob );
    },

    downloadTextData: function ( options, useStorage = MagnetAPI.isSite() ) {
        if ( useStorage ) {
            options.filename = options.filename.replace( /[\ |&;$%@"<>+,\(\)]/g, '_' );
            let cwCatalogObject = options.layer ? options.layer : options.project;
            let dataset = options.layer ? options.layer.getDataset() : options.project.getProjectDataset();
            dataset.getDriver().uploadObjectFile( cwCatalogObject, options.textData, options.filename, 'tmp/', options.mimeType, BaseDriver.NO_CACHE, 'attachment' ).then( () => {
                var path = dataset.getDriver().getServerUrl() + dataset.getDriver().getEntryPoint( options.layer ? 'layersFiles' : 'projectsFiles', cwCatalogObject.getId() ) + 'files/' + 'tmp/' + options.filename;
                this._cwFileBrowser.download( { 'href': path } ).then( () => {
                    options.promise.resolve();
                } );
            } );
            return;
        }
        if ( this.isBlobSaveSupported() ) {
            // if Blob saving is supported, use this API
            var b = new Blob( [ options.textData ], {
                type: options.mimeType
            } );
            var link = document.createElement( 'a' );

            var src = URL.createObjectURL( b );
            // Downloads the file from the location
            link.href = src;
            link.download = options.filename;
            link.target = '_blank';

            document.body.appendChild( link );
            link.click();

            options.promise.resolve();
        } else {
            // use data URI href
            var result = 'data:' + options.mimeType + ',' +
                ( options.encodeURI ? encodeURIComponent( options.textData ) : options.textData );
            options.promise.resolve( result );
        }
    },

    transformPointData: function ( pointContainer, options ) {
        if ( !options.layer )
            return;
        var sourceCRS = options.layer.getProjection();
        if ( !sourceCRS )
            return;
        if ( !options.destinationCRS )
            return;
        var destinCRS = options.destinationCRS;

        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length ) {
                for ( var iPt = 0; iPt < pointSeg.points.length; iPt++ ) {
                    CRSUtils.transform( sourceCRS, destinCRS, pointSeg.points[ iPt ], false, options.geoid );
                }
            }
        } );
    },

    /**
     * @method
     * Changes spaces for invalid XML characters in atribute names
     * @memberof pcvizDataAccess.Driver
     */
    cleanAttributeNames: function ( featureCollection ) {
        if ( !featureCollection.features )
            return;

        featureCollection.features.forEach( function ( feature ) {
            for ( var key in feature.properties ) {
                var newKey = key.replace( /[ |&;$%@"'<>\(\)+-,:!?=]/g, '_' );
                if ( newKey !== key ) {
                    feature.properties[ newKey ] = feature.properties[ key ];
                    delete feature.properties[ key ];
                }
            }
        } );
    },

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.Driver
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [];
    },

    /**
     * @method
     * Finds if the exporter handles itself the downloading
     * @memberof pcvizDataAccess.Driver
     * @return true or false
     */
    getHandlesDownload: function () {
        return this.isBlobSaveSupported();
    },

    /**
     * @method
     * Gets the file extension for the provided format
     * @memberof pcvizDataAccess.Driver
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return false;
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.Driver
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'None',
            value: 'None'
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function () {
        return false;
    },

    /**
     * @method
     * Close the driver
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if success .false if something was wrong driver is not ok
     */
    writePointCloud: function () {
        return false;
    },

    /**
     * @method
     * Encode every attribute name of type string into UTF 8
     * @memberof pcvizDataAccess.Driver
     */
    convertAttributeNamesToUtf8: function ( featureCollection ) {
        featureCollection.features.forEach( function ( feature ) {
            for ( var key in feature.properties ) {
                if ( typeof feature.properties[ key ] === 'string' && !Date.parse( feature.properties[ key ] ) ) {
                    feature.properties[ key ] = utf8.encode( feature.properties[ key ] );
                }
            }
        } );
    },

};

module.exports = Exporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterENZ.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterENZ.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
const ImageUtils = __webpack_require__( /*! pcvizUtils/ImageUtils */ "./sources/pcvizUtils/ImageUtils.js" ).default;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterENZ Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterENZ = function () {
    Exporter.call( this );
    var _cFormat = 'ENZ';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterENZ.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterENZ
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        // supports both exporting 2D profiles and 3D pointsets
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterENZ
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.csv'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter 
     * @memberof pcvizDataAccess.ExporterENZ
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.ENZ',
            value: this._cFormat,
            formatAllowsUnitTransform: true
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterENZ
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, pointContainer, options ) {

        if ( format !== this._cFormat )
            return '';

        if ( pointContainer.features === undefined )
            return '';

        var defer = P.defer();

        var ptsStream = '';
        let name;
        pointContainer.features.forEach( function ( feature ) {
            name = feature.properties.name;
            if ( name === undefined && feature.properties[ 'file_name' ] )
                name = ImageUtils.getFileNameFromPath( feature.properties[ 'file_name' ], options.layer.getCategory() );
            ptsStream += name + ',' + feature.geometry.coordinates[ 0 ] + ',' + feature.geometry.coordinates[ 1 ] + ',' + feature.geometry.coordinates[ 2 ] + '\n';
        } );

        filename = filename.replace( '.csv', ' ' + this._cFormat + ' .csv' );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: ptsStream,
            mimeType: 'text/csv;charset=utf-8',
            encodeURI: true,
            layer: options.layer
        } );

        return defer.promise;
    }

} );

// Register exporter 
var exporter = new ExporterENZ();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterENZ;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterEventLog.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterEventLog.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var filesaver = __webpack_require__( /*! filesaver */ "./dependencies/filesaver.js" ).filesaver;

/**
 *  ExporterEventLog Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterEventLog = function () {
    Exporter.call( this );
    var _cFormat = 'CSV';
    var _valueSeparator = ',';

    var self = this;
    self._cFormat = _cFormat;
    self._valueSeparator = _valueSeparator;
};

ExporterEventLog.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.Driver
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.EVENT_LOG ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.Driver
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.csv';
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.Driver
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.CSV',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, eventList, options ) {
        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        var separator = this._valueSeparator;
        var eventStream = '\ufeff'; // BOM  byte-order-mark

        // headers
        if ( options.headers && options.headers instanceof Array ) {
            eventStream += options.headers.join( separator ) + '\n';
        }

        // body
        eventList.forEach( function ( event ) {
            eventStream +=
                event.timeFormat + separator +
                event.user + separator +
                event.role + separator +
                event.action + separator +
                event.affectedObject + separator +
                event.affectedUser + separator +
                event.affectedGroup + separator +
                event.permissionsChange +
                '\n';
        } );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: eventStream,
            mimeType: 'text/csv;charset=utf-8',
            encodeURI: true
        } );

        return defer.promise;
    },

    downloadTextData: function ( options ) {
        if ( this.isBlobSaveSupported() ) {
            // if Blob saving is supported, use this API
            var b = new Blob( [ options.textData ], {
                type: options.mimeType
            } );
            filesaver( b, options.filename, true );
            options.promise.resolve();
        } else {
            // use data URI href
            var result = 'data:' + options.mimeType + ',' +
                ( options.encodeURI ? encodeURIComponent( options.textData ) : options.textData );
            options.promise.resolve( result );
        }
    }
} );

// Register exporter
var exporter = new ExporterEventLog();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterEventLog;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterEventLogExcel.js":
/*!********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterEventLogExcel.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var zipcelx = __webpack_require__( /*! zipcelx */ "./node_modules/zipcelx/lib/module.js" ).default;

/**
 *  ExporterEventLogExcel Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterEventLogExcel = function () {
    Exporter.call( this );
    var _cFormat = 'Excel';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterEventLogExcel.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.Driver
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.EVENT_LOG ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.Driver
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.xlsx';
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.Driver
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.EXCEL',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, eventList, options ) {

        if ( format !== this._cFormat )
            return '';

        // remove Excel file extension
        if ( filename.substring( filename.length - 5 ) === this.getFileExtension() )
            filename = filename.substring( 0, filename.length - 5 );

        var config = {
            filename: filename,
            sheet: {
                data: []
            }
        };

        var rows = config.sheet.data;
        var row;

        // headers
        if ( options.headers && options.headers instanceof Array ) {
            row = [];
            for ( var iHeader = 0; iHeader < options.headers.length; iHeader++ )
                row.push( {
                    value: options.headers[ iHeader ],
                    type: 'string'
                } );
            rows.push( row );
        }

        eventList.forEach( function ( event ) {
            row = [];
            row.push( {
                value: event.timeFormat,
                type: 'string'
            } );
            row.push( {
                value: event.user,
                type: 'string'
            } );
            row.push( {
                value: event.role,
                type: 'string'
            } );
            row.push( {
                value: event.action,
                type: 'string'
            } );
            row.push( {
                value: event.affectedObject,
                type: 'string'
            } );
            row.push( {
                value: event.affectedUser,
                type: 'string'
            } );
            row.push( {
                value: event.affectedGroup,
                type: 'string'
            } );
            row.push( {
                value: event.permissionsChange,
                type: 'string'
            } );
            rows.push( row );
        } );

        return zipcelx( config );
    },

} );

// Register exporter
var exporter = new ExporterEventLogExcel();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterEventLogExcel;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterGML.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterGML.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OpenLayers = __webpack_require__( /*! OpenLayers */ "./dependencies/ol-4.3.2.js" );

/**
 *  ExporterGML Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterGML = function () {
    Exporter.call( this );
    var _cFormat = 'GML';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterGML.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterGML
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterGML
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.gml'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.ExporterGML
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.GML',
            value: this._cFormat
        } ];
    },

    swapVertex: function ( vertex ) {
        var swap = vertex[ 0 ];
        vertex[ 0 ] = vertex[ 1 ];
        vertex[ 1 ] = swap;
    },

    swapFeatures: function ( features ) {
        var self = this;

        // we need to swap coordinate order for WGS84 GML exporting (lat, lon)
        // and store in a different feature collection object to avoid overwriting
        var featureCollection = JSON.parse( JSON.stringify( features ) );
        featureCollection.features.forEach( function ( feature ) {
            switch ( feature.geometry.type ) {
            case 'Polygon':
                var ringArray = feature.geometry.coordinates;
                ringArray.forEach( function ( ring ) {
                    ring.forEach( function ( vertex ) {
                        self.swapVertex( vertex );
                    } );
                } );
                break;
            case 'LineString':
            case 'MultiPoint':
                var coordArray = feature.geometry.coordinates;
                coordArray.forEach( function ( vertex ) {
                    self.swapVertex( vertex );
                } );
                break;
            case 'Point':
                var vertex = feature.geometry.coordinates;
                self.swapVertex( vertex );
            }
        } );
        return featureCollection;
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterGML
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, originalFeatureCollection, expOptions ) {

        if ( format !== this._cFormat )
            return '';

        var self = this;
        var defer = P.defer();

        var featureCollection = originalFeatureCollection;

        var sourceCRS = expOptions.layer.getProjection();
        var destinCRS = expOptions.destinationCRS;
        featureCollection = CRSUtils.transformFeatureCollection( featureCollection, sourceCRS, destinCRS, expOptions.geoid );

        this.cleanAttributeNames( featureCollection );

        var epsgCode = destinCRS;
        if ( !epsgCode )
            epsgCode = sourceCRS;

        if ( !epsgCode )
            epsgCode = CRSUtils.cEpsgWGS84;
        else if ( epsgCode.substring( 0, 5 ) !== CRSUtils.cEpsgPrefix )
            epsgCode = CRSUtils.cEpsgPrefix + epsgCode;

        if ( epsgCode === CRSUtils.cEpsgWGS84 ) {
            featureCollection = self.swapFeatures( originalFeatureCollection );
        }

        // we need to get the projection first
        const { Projection } = window.PointCloudVizMap.default.Map;
        Projection.getProjection( epsgCode ).then( function ( olProjection ) {
            // converto to OL features
            var featuresOL = ( new OpenLayers.format.GeoJSON() ).readFeatures( featureCollection, {
                dataProjection: olProjection,
                featureProjection: olProjection
            } );

            var format = new OpenLayers.format.GML( {
                srsName: epsgCode,
                featureType: featureCollection.features[ 0 ].geometry.type,
                featureNS: 'MagnetCollage'
            } );
            var gml = format.writeFeatures( featuresOL, {
                dataProjection: olProjection,
                featureProjection: olProjection
            } );

            var xml = '<?xml version="1.0" standalone="no"?>\r\n' +
                '<ogr:FeatureCollection  xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"  xsi:schemaLocation=""  xmlns:ogr="http://ogr.maptools.org/"   xmlns:gml="http://www.opengis.net/gml">' +
                gml + '</ogr:FeatureCollection>';

            self.downloadTextData( {
                promise: defer,
                filename: filename,
                textData: xml,
                mimeType: 'application/gml+xml;charset=utf-8',
                encodeURI: false,
                layer: expOptions.layer
            } );

        }, function () {
            console.error( 'Could not find OpenLayers projection' );
            defer.reject();
        } );

        return defer.promise;
    }

} );

// Register exporter
var exporter = new ExporterGML();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterGML;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterGeoJSON.js":
/*!**************************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterGeoJSON.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterGeoJSON Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterGeoJSON = function () {
    Exporter.call( this );
    var _cFormat = 'GeoJSON';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterGeoJSON.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterGeoJSON
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterGeoJSON
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.geojson'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter 
     * @memberof pcvizDataAccess.ExporterGeoJSON
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.GeoJSON',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterGeoJSON
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, featureCollection, expOptions ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        var sourceCRS = expOptions.layer.getProjection();
        var destinCRS = expOptions.destinationCRS;
        featureCollection = CRSUtils.transformFeatureCollection( featureCollection, sourceCRS, destinCRS, expOptions.geoid );

        // specify CRS
        var epsgCode = destinCRS;
        if ( !epsgCode )
            epsgCode = sourceCRS;

        if ( epsgCode ) {
            if ( epsgCode.substring( 0, 5 ) === CRSUtils.cEpsgPrefix )
                epsgCode = epsgCode.substring( 5, epsgCode.length );
            featureCollection.crs = {
                type: 'name',
                properties: {
                    name: 'urn:ogc:def:crs:EPSG::' + epsgCode
                }
            };
        }

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: JSON.stringify( featureCollection ),
            mimeType: 'application/vnd.geo+json;charset=utf-8',
            encodeURI: true,
            layer: expOptions.layer
        } );

        return defer.promise;
    }

} );

// Register exporter 
var exporter = new ExporterGeoJSON();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterGeoJSON;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterKML.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterKML.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OpenLayers = __webpack_require__( /*! OpenLayers */ "./dependencies/ol-4.3.2.js" );

/**
 *  ExporterKML Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterKML = function () {
    Exporter.call( this );
    var _cFormat = 'KML';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterKML.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterKML
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterKML
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.kml'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.ExporterKML
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.KML',
            value: this._cFormat
        } ];
    },

    createKMLStyle: function ( color, type ) {
        var colorHex = color[ 0 ] + color[ 1 ] * 256 + color[ 2 ] * 256 * 256 + Math.round( color[ 3 ] * 255 ) * 256 * 256 * 256;
        var colorStr = colorHex.toString( 16 );

        var kmlStyle = '<Style id="CollageExportedStyle">';
        switch ( type ) {
        case FeatureDefinition.POINT:
        case FeatureDefinition.MULTIPOINT:
            kmlStyle = kmlStyle + '<IconStyle> <color>' + colorStr + '</color> <Icon> <href>http://maps.google.com/mapfiles/kml/paddle/wht-circle.png</href> </Icon> </IconStyle>';
            break;
        case FeatureDefinition.LINE:
            kmlStyle = kmlStyle + '<LineStyle> <color>' + colorStr + '</color> <width > 2 </width> </LineStyle>';
            break;
        case FeatureDefinition.POLYGON:
            kmlStyle = kmlStyle + '<PolyStyle> <color>' + colorStr + '</color> </PolyStyle>';
        }
        kmlStyle = kmlStyle + '</Style>';
        return kmlStyle;
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterKML
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, featureCollection, options ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        // project to WGS84, but apply geoid
        var sourceCRS = options.layer.getProjection();
        var destinCRS = CRSUtils.cEpsgWGS84;
        featureCollection = CRSUtils.transformFeatureCollection( featureCollection, sourceCRS, destinCRS, options.geoid );

        // converto to OL features
        var featuresOL = ( new OpenLayers.format.GeoJSON() ).readFeatures( featureCollection );

        var outFormat = new OpenLayers.format.KML( {
            featureProjection: CRSUtils.cEpsgWGS84
        } );

        var kml = outFormat.writeFeatures( featuresOL );

        //add style description
        var geomType = options.layer.getGeometryType();
        var baseSymbolizer = options.layer.getCategoryRenderer().getBaseSymbolizer( options.layer.getStyle() );
        if ( baseSymbolizer && baseSymbolizer.RuleSymbolizer && baseSymbolizer.RuleSymbolizer.rules.length > 0 ) { // apply symbol rules
            var symbol = options.layer.getFeatureRenderer( '3D' ).getSymbol();

            for ( var iFeature = 0; iFeature < featureCollection.features.length; iFeature++ ) {
                var attributes = featureCollection.features[ iFeature ].properties;
                // add id as attribute
                attributes[ 'id' ] = featureCollection.features[ iFeature ].id;

                symbol.evaluateRules( attributes );
                var colorFeature = symbol.getColor();
                var colorInt = [ 0, 0, 0, 0 ];
                colorInt[ 0 ] = Math.round( colorFeature[ 0 ] * 255 );
                colorInt[ 1 ] = Math.round( colorFeature[ 1 ] * 255 );
                colorInt[ 2 ] = Math.round( colorFeature[ 2 ] * 255 );
                colorInt[ 3 ] = colorFeature[ 3 ];

                var kmlStyleFeature = this.createKMLStyle( colorInt, geomType );

                kml = kml.replace( /<ExtendedData>/, kmlStyleFeature + '<CW_ExtendedData>' ); //  style definition
            }
            kml = kml.replace( /<CW_ExtendedData>/g, '<ExtendedData>' ); // restore tags

        } else { // single color

            var color = [ 0, 1, 0, 1 ];
            if ( options.layer !== undefined )
                color = options.layer.getBaseColor( options.layer.getStyle() );

            var kmlStyle = this.createKMLStyle( color, geomType );

            kml = kml.replace( /<Placemark/, '<Document>' + kmlStyle + '<Placemark' ); //  style definition
            kml = kml.replace( /><ExtendedData>/g, '><styleUrl>#CollageExportedStyle</styleUrl><ExtendedData>' ); // style reference
            kml = kml.replace( /<\/kml>/, '</Document></kml>' ); // style reference
        }

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: '<?xml version="1.0" standalone="no"?>\r\n' + kml,
            mimeType: 'application/vnd.google-earth.kml+xml;charset=utf-8',
            encodeURI: false,
            layer: options.layer
        } );

        return defer.promise;
    }

} );

// Register exporter
var exporter = new ExporterKML();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterKML;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterMaker.js":
/*!************************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterMaker.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var makerjs = __webpack_require__( /*! makerjs */ "./node_modules/makerjs/index.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterMaker Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterMaker = function () {
    Exporter.call( this );

    var _cDXFFormat = 'DXF';
    var _cSVGFormat = 'SVG';

    var self = this;
    self._cDXFFormat = _cDXFFormat;
    self._cSVGFormat = _cSVGFormat;
};

ExporterMaker.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterMaker
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.SOURCE_2D, ExporterRegistry.instance.SOURCE_3D,
            ExporterRegistry.instance.SOURCE_VECTOR, ExporterRegistry.instance.SOURCE_POINT_CLOUD
        ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterMaker
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function ( format ) {
        if ( format === this._cSVGFormat )
            return '.svg';
        return '.dxf';
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.ExporterMaker
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.DXF',
            value: this._cDXFFormat
        }, {
            label: 'EXPORT_LAYER_DIALOG.SVG',
            value: this._cSVGFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterMaker
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, features, options ) {

        if ( format !== this._cSVGFormat && format !== this._cDXFFormat )
            return '';

        var defer = P.defer();

        var bFeaturesAreVectors = true;
        if ( options !== undefined && options.filter !== undefined && ExporterRegistry.contains( options.filter, ExporterRegistry.SOURCE_POINT_CLOUD ) )
            bFeaturesAreVectors = false;

        var modelList = ( bFeaturesAreVectors ) ? this.getModelsFromFeatures( format, features, options ) :
            this.getModelsFromPointSegments( format, features, options );

        if ( format === this._cSVGFormat ) {
            var svg = makerjs.exporter.toSVG( modelList, {
                units: makerjs.unitType.Meter,
                width: '1280px', // to view as image
                height: '720px',
                useSvgPathOnly: false,
                customScale: 1.0
            } );

            //add SVG name spaces
            if ( !svg.match( /^<svg[^>]+xmlns="http\:\/\/www\.w3\.org\/2000\/svg"/ ) ) {
                svg = svg.replace( /^<svg/, '<svg xmlns="http://www.w3.org/2000/svg"' );
            }

            this.downloadTextData( {
                promise: defer,
                filename: filename,
                textData: '<?xml version="1.0" standalone="no"?>\r\n' + svg,
                mimeType: 'image/svg+xml;utf8',
                encodeURI: false,
                layer: options.layer,
                project: options.project
            } );

            return defer.promise;
        }

        // DXF exporting

        var dxf = makerjs.exporter.toDXF( modelList, {
            // no options
        } );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: dxf,
            mimeType: 'text/plain;charset=utf-8',
            encodeURI: true,
            layer: options.layer,
            project: options.project
        } );

        return defer.promise;
    },

    getModelsFromFeatures: function ( format, featureCollection, options ) {



        var sourceCRS = options.layer.getProjection();
        var destinCRS = options.destinationCRS;
        featureCollection = CRSUtils.transformFeatureCollection( featureCollection, sourceCRS, destinCRS, options.geoid );

        var modelList = {}; // list of models, one per feature
        modelList.models = {};
        var offset;

        // calculate extent for SVG point sizing
        var maxSize = 0;
        if ( featureCollection.features.length > 0 && format === this._cSVGFormat ) {
            var minX = Number.MAX_VALUE;
            var maxX = Number.MIN_VALUE;
            var minY = Number.MAX_VALUE;
            var maxY = Number.MIN_VALUE;
            for ( var iGeometry = 0; iGeometry < featureCollection.features.length; iGeometry++ ) {
                var geom = featureCollection.features[ iGeometry ].geometry;
                if ( geom.type === 'Point' ) {
                    minX = Math.min( minX, geom.coordinates[ 0 ] );
                    maxX = Math.max( maxX, geom.coordinates[ 0 ] );
                    minY = Math.min( minY, geom.coordinates[ 1 ] );
                    maxY = Math.max( maxY, geom.coordinates[ 1 ] );
                } else if ( geom.type === 'MultiPoint' ) {
                    for ( var imPoints = 0; imPoints < geom.coordinates.length; imPoints++ ) {
                        minX = Math.min( minX, geom.coordinates[ imPoints ][ 0 ] );
                        maxX = Math.max( maxX, geom.coordinates[ imPoints ][ 0 ] );
                        minY = Math.min( minY, geom.coordinates[ imPoints ][ 1 ] );
                        maxY = Math.max( maxY, geom.coordinates[ imPoints ][ 1 ] );
                    }
                }
            }
            maxSize = Math.max( maxX - minX, maxY - minY );
        }

        for ( var iGeom = 0; iGeom < featureCollection.features.length; iGeom++ ) {

            var geometry = featureCollection.features[ iGeom ].geometry;

            var pathList = {}; // per-feature paths
            var nPaths = 0;
            switch ( geometry.type ) {

            case 'Point':
                if ( offset === undefined ) {
                    offset = ( format === this._cSVGFormat ) ? [ geometry.coordinates[ 0 ], geometry.coordinates[ 1 ] ] : [ 0, 0 ];
                }

                var newCircle = {
                    type: 'circle',
                    origin: [ geometry.coordinates[ 0 ] - offset[ 0 ], geometry.coordinates[ 1 ] - offset[ 1 ], geometry.coordinates[ 2 ] ],
                    radius: ( ( format === this._cDXFFormat ) ? 0 : 0.005 * maxSize )
                };

                pathList[ nPaths ] = newCircle;
                nPaths++;
                break;

            case 'MultiPoint':
                if ( offset === undefined && geometry.coordinates.length > 0 ) {
                    offset = ( format === this._cSVGFormat ) ? [ geometry.coordinates[ 0 ][ 0 ], geometry.coordinates[ 0 ][ 1 ] ] : [ 0, 0 ];
                }

                for ( var iPoints = 0; iPoints < geometry.coordinates.length; iPoints++ ) {
                    var newPoint = {
                        type: 'circle',
                        origin: [ geometry.coordinates[ iPoints ][ 0 ] - offset[ 0 ], geometry.coordinates[ iPoints ][ 1 ] - offset[ 1 ], geometry.coordinates[ iPoints ][ 2 ] ],
                        radius: ( ( format === this._cDXFFormat ) ? 0 : 0.005 * maxSize )
                    };

                    pathList[ nPaths ] = newPoint;
                    nPaths++;
                }
                break;

            case 'LineString':
                if ( offset === undefined && geometry.coordinates.length > 0 ) {
                    offset = ( format === this._cSVGFormat ) ? [ geometry.coordinates[ 0 ][ 0 ], geometry.coordinates[ 0 ][ 1 ] ] : [ 0, 0 ];
                }

                for ( var i = 0; i < geometry.coordinates.length - 1; i++ ) {
                    var newLine = {
                        type: 'line',
                        origin: [ geometry.coordinates[ i ][ 0 ] - offset[ 0 ], geometry.coordinates[ i ][ 1 ] - offset[ 1 ], geometry.coordinates[ i ][ 2 ] ],
                        end: [ geometry.coordinates[ i + 1 ][ 0 ] - offset[ 0 ], geometry.coordinates[ i + 1 ][ 1 ] - offset[ 1 ], geometry.coordinates[ i + 1 ][ 2 ] ],
                    };
                    pathList[ nPaths ] = newLine;
                    nPaths++;
                }
                break;

            case 'Polygon':
                for ( var iRing = 0; iRing < geometry.coordinates.length; iRing++ ) {
                    var ring = geometry.coordinates[ iRing ];
                    if ( offset === undefined && ring.length > 0 ) {
                        offset = ( format === this._cSVGFormat ) ? [ ring[ 0 ][ 0 ], ring[ 0 ][ 1 ] ] : [ 0, 0 ];
                    }

                    for ( var iLine = 0; iLine < ring.length - 1; iLine++ ) {

                        var newPath = {
                            type: 'line',
                            origin: [ ring[ iLine ][ 0 ] - offset[ 0 ], ring[ iLine ][ 1 ] - offset[ 1 ], ring[ iLine ][ 2 ] ],
                            end: [ ring[ iLine + 1 ][ 0 ] - offset[ 0 ], ring[ iLine + 1 ][ 1 ] - offset[ 1 ], ring[ iLine + 1 ][ 2 ] ]
                        };
                        pathList[ nPaths ] = newPath;
                        nPaths++;
                    }
                }
                break;
            }
            var newModel = {
                'paths': pathList
            }; // one model per feature
            modelList.models[ iGeom ] = newModel;
        }
        return modelList;
    },

    getModelsFromPointSegments: function ( format, pointContainer, options ) {

        var ptFactor = 1;
        if ( options !== undefined && options.filter !== undefined && ExporterRegistry.contains( options.filter, ExporterRegistry.SOURCE_2D ) )
            ptFactor = 2; // in 2D segments, points are one single vector with all XY coordinates instead of an array of Vec3

        if ( ptFactor === 1 )
            this.transformPointData( pointContainer, options );

        var modelList = {}; // list of models, one per feature
        modelList.models = {};
        var iGeom = 0;

        var self = this;

        var maxSize = 0;
        // calculate extent for SVG point sizing
        if ( format === this._cSVGFormat ) {
            pointContainer.forEach( function ( pntSeg ) {
                if ( pntSeg.points !== undefined && pntSeg.colors !== undefined && pntSeg.points.length <= pntSeg.colors.length * ptFactor ) {
                    if ( ptFactor === 2 ) {
                        maxSize = Math.max( maxSize, pntSeg.xmax - pntSeg.xmin );
                        maxSize = Math.max( maxSize, pntSeg.ymax - pntSeg.ymin );
                    } else {
                        var minX = Number.MAX_VALUE;
                        var maxX = Number.MIN_VALUE;
                        var minY = Number.MAX_VALUE;
                        var maxY = Number.MIN_VALUE;
                        for ( var iPt2 = 0; iPt2 < pntSeg.points.length; iPt2++ ) {
                            var pt = pntSeg.points[ iPt2 ];
                            minX = Math.min( minX, pt[ 0 ] );
                            maxX = Math.max( maxX, pt[ 0 ] );
                            minY = Math.min( minY, pt[ 1 ] );
                            maxY = Math.max( maxY, pt[ 1 ] );
                        }
                        maxSize = Math.max( maxX - minX, maxY - minY );
                    }
                }
            } );
        }

        var offset;

        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor ) {
                for ( var iPt = 0; iPt < pointSeg.points.length; iPt += ptFactor ) {

                    var newCircle = {
                        type: 'circle',
                        radius: ( ( format === self._cDXFFormat ) ? 0 : 0.001 * maxSize )
                    };

                    if ( ptFactor === 2 )
                        newCircle.origin = [ pointSeg.points[ iPt ], pointSeg.points[ iPt + 1 ], 0.0 ];
                    else {
                        if ( offset === undefined ) {
                            offset = ( format === self._cSVGFormat ) ? [ pointSeg.points[ iPt ][ 0 ], pointSeg.points[ iPt ][ 1 ] ] : [ 0, 0 ];
                        }
                        newCircle.origin = [ pointSeg.points[ iPt ][ 0 ] - offset[ 0 ], pointSeg.points[ iPt ][ 1 ] - offset[ 1 ], pointSeg.points[ iPt ][ 2 ] ];
                    }

                    var newModel = {};
                    var pathList = {};
                    pathList[ 0 ] = newCircle;
                    newModel.paths = pathList;
                    modelList.models[ iGeom ] = newModel;
                    iGeom++;
                }
            }
        } );
        return modelList;

    }

} );

// Register exporter
var exporterMaker = new ExporterMaker();
ExporterRegistry.getInstance().registerExporter( exporterMaker._cSVGFormat, exporterMaker );
ExporterRegistry.getInstance().registerExporter( exporterMaker._cDXFFormat, exporterMaker );

module.exports = exporterMaker;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterNEZ.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterNEZ.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
const ImageUtils = __webpack_require__( /*! pcvizUtils/ImageUtils */ "./sources/pcvizUtils/ImageUtils.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterNEZ Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterNEZ = function () {
    Exporter.call( this );
    var _cFormat = 'NEZ';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterNEZ.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterNEZ
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        // supports both exporting 3D profiles and vectors
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterNEZ
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.csv'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter 
     * @memberof pcvizDataAccess.ExporterNEZ
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.NEZ',
            value: this._cFormat,
            formatAllowsUnitTransform: true
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterNEZ
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, pointContainer, options ) {
        if ( format !== this._cFormat )
            return '';

        if ( pointContainer.features === undefined )
            return '';

        var defer = P.defer();

        var ptsStream = '';
        let name;
        pointContainer.features.forEach( function ( feature ) {
            name = feature.properties.name;
            if ( name === undefined && feature.properties[ 'file_name' ] )
                name = ImageUtils.getFileNameFromPath( feature.properties[ 'file_name' ], options.layer.getCategory() );
            ptsStream += name + ',' + feature.geometry.coordinates[ 1 ] + ',' + feature.geometry.coordinates[ 0 ] + ',' + feature.geometry.coordinates[ 2 ] + '\n';
        } );

        filename = filename.replace( '.csv', ' ' + this._cFormat + ' .csv' );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: ptsStream,
            mimeType: 'text/csv;charset=utf-8',
            encodeURI: true,
            layer: options.layer
        } );

        return defer.promise;
    }

} );

// Register exporter 
var exporter = new ExporterNEZ();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterNEZ;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterPLY.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterPLY.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterPLY Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterPLY = function () {
    Exporter.call( this );
    var _cFormat = 'PLY';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterPLY.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterPLY
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        // supports both exporting 2D profiles and 3D pointsets
        return [ ExporterRegistry.instance.SOURCE_2D, ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_POINT_CLOUD ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterPLY
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.ply'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter 
     * @memberof pcvizDataAccess.ExporterPLY
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.PLY',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterPLY
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, pointContainer, options ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        var ptFactor = 1;
        if ( options !== undefined && options.filter !== undefined && ExporterRegistry.contains( options.filter, ExporterRegistry.SOURCE_2D ) )
            ptFactor = 2; // in 2D segments, points are one single vector with all XY coordinates instead of an array of Vec3

        if ( ptFactor === 1 )
            this.transformPointData( pointContainer, options );

        var totalPoints = 0;
        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor )
                totalPoints += pointSeg.colors.length;
        } );

        var ptsStream = 'ply\n';
        ptsStream += 'format ascii 1.0\nelement vertex ';
        ptsStream += totalPoints + '\n';
        ptsStream += 'property float x\n';
        ptsStream += 'property float y\n';
        ptsStream += 'property float z\n';
        //property float intensity  (not supported for now)
        ptsStream += 'property uchar diffuse_red\n';
        ptsStream += 'property uchar diffuse_green\n';
        ptsStream += 'property uchar diffuse_blue\n';
        ptsStream += 'end_header\n';

        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor ) {
                for ( var iPt = 0, iCol = 0; iPt < pointSeg.points.length; iPt += ptFactor, iCol++ ) {
                    if ( ptFactor === 2 )
                        ptsStream += ( pointSeg.points[ iPt ] ) + ' 0.0 ' + pointSeg.points[ iPt + 1 ] + ' ';
                    else
                        ptsStream += pointSeg.points[ iPt ][ 0 ] + ' ' + pointSeg.points[ iPt ][ 1 ] + ' ' + pointSeg.points[ iPt ][ 2 ] + ' ';
                    //ptsStream += '0 '; // intensity not supported for now
                    ptsStream += pointSeg.colors[ iCol ][ 0 ] + ' ' + pointSeg.colors[ iCol ][ 1 ] + ' ' + pointSeg.colors[ iCol ][ 2 ] + '\n';
                }
            }
        } );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: ptsStream,
            mimeType: 'application/ply;charset=utf-8',
            encodeURI: true,
            project: options.project
        } );

        return defer.promise;
    }

} );

// Register exporter 
var exporter = new ExporterPLY();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterPLY;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterPTS.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterPTS.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterPTS Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterPTS = function () {
    Exporter.call( this );
    var _cFormat = 'PTS';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterPTS.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterPTS
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        // supports both exporting 2D profiles and 3D pointsets
        return [ ExporterRegistry.instance.SOURCE_2D, ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_POINT_CLOUD ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterPTS
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.pts'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.ExporterPTS
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.PTS',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterPTS
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, pointContainer, options ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        var ptFactor = 1;
        if ( options !== undefined && options.filter !== undefined && ExporterRegistry.contains( options.filter, ExporterRegistry.SOURCE_2D ) )
            ptFactor = 2; // in 2D segments, points are one single vector with all XY coordinates instead of an array of Vec3

        if ( ptFactor === 1 )
            this.transformPointData( pointContainer, options );

        var totalPoints = 0;
        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor )
                totalPoints += pointSeg.colors.length;
        } );

        var ptsStream = totalPoints + '\n';

        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor ) {
                for ( var iPt = 0, iCol = 0; iPt < pointSeg.points.length; iPt += ptFactor, iCol++ ) {
                    if ( ptFactor === 2 )
                        ptsStream += ( pointSeg.points[ iPt ] ) + ' 0.0 ' + pointSeg.points[ iPt + 1 ] + ' ';
                    else
                        ptsStream += pointSeg.points[ iPt ][ 0 ] + ' ' + pointSeg.points[ iPt ][ 1 ] + ' ' + pointSeg.points[ iPt ][ 2 ] + ' ';
                    ptsStream += '0 '; // intensity not supported for now
                    ptsStream += pointSeg.colors[ iCol ][ 0 ] + ' ' + pointSeg.colors[ iCol ][ 1 ] + ' ' + pointSeg.colors[ iCol ][ 2 ] + '\n';
                }
            }
        } );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: ptsStream,
            mimeType: 'application/pts;charset=utf-8',
            encodeURI: true,
            project: options.project
        } );

        return defer.promise;
    }

} );

// Register exporter
var exporter = new ExporterPTS();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterPTS;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterSHP.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterSHP.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var shpwrite = __webpack_require__( /*! shpwrite */ "./dependencies/shpwrite.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );

/**
 *  ExporterSHP Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterSHP = function () {
    Exporter.call( this );
    var _cFormat = 'SHP';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterSHP.prototype = Utils.objectInherit( Exporter.prototype, {

    download: function ( filename, defer, featureIterator, expOptions ) {

        var blobSupported = this.isBlobSaveSupported();
        if ( blobSupported )
            expOptions.binaryZip = true; // do not encode as base64

        // Convert strings to utf-8
        this.convertAttributeNamesToUtf8( featureIterator );
        var self = this;

        // Export
        shpwrite.zip( featureIterator, expOptions ).then( function ( zipData ) {
            var useStorage = MagnetAPI.isSite();
            if ( useStorage ) {
                filename = filename.replace( /[\ |&;$%@"<>+,\(\)]/g, '_' );
                expOptions.layer.getDataset().getDriver().uploadObjectFile( expOptions.layer, zipData, filename, 'tmp/', 'octet/stream', BaseDriver.NO_CACHE, 'attachment' ).then( () => {
                    var path = expOptions.layer.getDriver().getServerUrl() + expOptions.layer.getDriver().getEntryPoint( 'layersFiles', expOptions.layer.getId() ) + 'files/' + 'tmp/' + filename;
                    self._cwFileBrowser.download( { 'href': path } ).then( () => {
                        defer.resolve();
                    } );
                } );
                return;
            }

            if ( blobSupported ) {
                var b = new Blob( [ zipData ], {
                    type: {
                        type: 'octet/stream'
                    }
                } );
                var src = URL.createObjectURL( b );
                // Downloads the file from the location
                var link = document.createElement( 'a' );
                link.href = src;
                link.download = filename;
                link.target = '_blank';

                document.body.appendChild( link );
                link.click();
                defer.resolve();
            } else {
                var result = 'data:application/zip;base64,' + zipData;
                defer.resolve( result );
            }
        } );
    },

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterSHP
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        return [ ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_VECTOR ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterSHP
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.zip';
    },

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.ExporterSHP
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.SHP',
            value: this._cFormat
        } ];
    },

    /**
     * @method
     * Write features
     * @memberof pcvizDataAccess.ExporterSHP
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, featureCollection, expOptions ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        if ( expOptions.name === undefined )
            expOptions.name = filename;

        var options = {
            saveZs: true,
            folder: expOptions.name,
            types: {
                point: expOptions.name,
                polyline: expOptions.name,
                polygon: expOptions.name
            },
            layer: expOptions.layer
        };


        var sourceCRS = expOptions.layer.getProjection();
        var destinCRS = expOptions.destinationCRS;
        var geoid = expOptions.geoid;
        var transform = false;
        if ( geoid || ( sourceCRS && destinCRS && sourceCRS !== destinCRS ) )
            transform = true;

        // transform multipoints in points (SHP exporter does not support multipoints for now)
        var newFeatureArray = [];
        var newFeatureCollection = {
            type: 'FeatureCollection'
        }; // do not overwrite original

        // check field names to be 8 chars max and not repeated
        if ( featureCollection.features.length > 0 ) {
            var oldProps = Object.keys( featureCollection.features[ 0 ].properties );
            var newProps = this.fixFieldNames( oldProps );
            for ( var iProp = 0; iProp < oldProps.length; iProp++ ) {
                if ( oldProps[ iProp ] !== newProps[ iProp ] ) {
                    // substitute property names
                    for ( var f = 0; f < featureCollection.features.length; f++ ) {
                        var fProps = featureCollection.features[ f ].properties;
                        fProps[ newProps[ iProp ] ] = fProps[ oldProps[ iProp ] ];
                        delete fProps[ oldProps[ iProp ] ];
                    }
                }
            }
        }

        featureCollection.features.forEach( function ( feature ) {
            if ( feature.geometry.type === 'MultiPoint' ) {
                feature.geometry.coordinates.forEach( function ( point ) {
                    var newFeature = {
                        geometry: {
                            coordinates: point.slice(), //clone
                            type: 'Point'
                        },
                        properties: feature.properties
                    };
                    if ( transform )
                        CRSUtils.transformGeoJSONFeature( newFeature, sourceCRS, destinCRS, geoid );
                    newFeatureArray.push( newFeature );
                } );
            } else { // points, lines or polygons
                if ( transform ) {
                    var newFeature = JSON.parse( JSON.stringify( feature ) ); // clone
                    CRSUtils.transformGeoJSONFeature( newFeature, sourceCRS, destinCRS, geoid );
                    newFeatureArray.push( newFeature );
                } else
                    newFeatureArray.push( feature );
            }
        } );
        newFeatureCollection.features = newFeatureArray;
        featureCollection = newFeatureCollection;

        // get WKT CRS info for PRJ file
        var epsgCode = destinCRS;
        if ( !epsgCode )
            epsgCode = sourceCRS;

        var self = this;

        if ( epsgCode ) {
            if ( epsgCode.substring( 0, 5 ) === CRSUtils.cEpsgPrefix )
                epsgCode = epsgCode.substring( 5, epsgCode.length );

            CRSUtils.getWTKProjectionInfo( epsgCode ).then( function ( wkt ) {
                options.wktCRS = wkt;
                self.download( filename, defer, featureCollection, options );
            }, function ( response ) {
                console.error( 'Failed to get WKT projection string for ' + epsgCode + ': ' + response );
                self.download( filename, defer, featureCollection, options );
            } );
        } else {
            self.download( filename, defer, featureCollection, options );
        }

        return defer.promise;
    },

    nextChar: function nextChar( c ) {
        var chara = 'a'.charCodeAt( 0 );
        var charz = 'z'.charCodeAt( 0 );
        var charA = 'A'.charCodeAt( 0 );
        var charZ = 'Z'.charCodeAt( 0 );
        var charC = c.charCodeAt( c.length - 1 );

        if ( charC < charA )
            return charA;
        if ( charC > charZ && charC < chara )
            return chara;
        if ( charC > charz )
            return charz;

        if ( charC === charZ )
            return charA;
        if ( charC === charz )
            return chara;

        return charC + 1;
    },

    fixFieldNames: function ( origList ) {
        // first, create array with max 8 characters per field name
        var list = [];
        origList.forEach( function ( fieldName ) {
            list.push( fieldName.substring( 0, 8 ) );
        } );

        for ( var i = 1, c = list.length; i < c; i++ ) {
            if ( list[ i ].length < 8 )
                continue; // no repetitions are possible with less than 8 chars
            var repeated;
            do {
                repeated = false;
                for ( var j = 0; j < i; j++ ) {
                    if ( list[ j ].length < 8 )
                        continue;

                    if ( list[ i ] === list[ j ] ) {
                        list[ i ] = list[ i ].substring( 0, 7 ).concat( String.fromCharCode( this.nextChar( list[ j ] ) ) );
                        repeated = true;
                        break;
                    }
                }
            }
            while ( repeated );
        }

        return list;
    }

} );

// Register exporter
var exporter = new ExporterSHP();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterSHP;


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterWorkflowSettingsTXT.js":
/*!**************************************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterWorkflowSettingsTXT.js ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDataAccess_Exporters_Exporter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js");
/* harmony import */ var pcvizDataAccess_Exporters_Exporter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Exporters_Exporter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_ExporterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js");
/* harmony import */ var pcvizDataAccess_ExporterRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_ExporterRegistry__WEBPACK_IMPORTED_MODULE_1__);



var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterWorkflowSettingsTXT Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
class ExporterWorkflowSettingsTXT extends pcvizDataAccess_Exporters_Exporter__WEBPACK_IMPORTED_MODULE_0___default.a {

    constructor() {
        super();

        // attributes
        this.cFormat = 'WorkflowSettingsTXT';

        // inline format functions
        this.formatGroupName = ( groupName ) => `== ${groupName} ==`;
        this.formatPropNameValue = ( propName, propValue ) => `    ${propName}: ${propValue}`;
        this.formatTitle = ( title ) => `*** ${title} ***`;
    }

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.Driver
     * @return array of strings with supported source properties
     */
    getSupportedSources() {
        return [ pcvizDataAccess_ExporterRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.instance.WORKFLOW_SETTINGS ];
    }

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.Driver
     * @return extension string including dot ('.xxx')
     */
    getFileExtension() {
        return '.txt';
    }

    /**
     * @method
     * Gets naming info about the exporter
     * @memberof pcvizDataAccess.Driver
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo() {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.TXT',
            value: this.cFormat
        } ];
    }

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.Driver
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures( filename, format, workflowSettings, options ) {
        if ( format !== this.cFormat )
            return '';

        var defer = P.defer();

        let file = '';

        // title
        if ( options.title ) {
            file += this.formatTitle( options.title ) + '\n';
        }

        // formats
        for ( let groupName in workflowSettings ) {
            if ( workflowSettings.hasOwnProperty( groupName ) ) {
                let groupString = this.formatGroupName( groupName ) + '\n';

                const groupList = workflowSettings[ groupName ];

                for ( let propName in groupList ) {
                    if ( groupList.hasOwnProperty( propName ) ) {
                        groupString += this.formatPropNameValue( propName, groupList[ propName ] ) + '\n';
                    }
                }

                file += groupString;
            }
        }

        //
        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: file,
            mimeType: 'text/plain;charset=utf-8',
            encodeURI: true
        } );

        return defer.promise;
    }

}

// Register exporter
const exporter = new ExporterWorkflowSettingsTXT();
pcvizDataAccess_ExporterRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().registerExporter( exporter.cFormat, exporter );

/* harmony default export */ __webpack_exports__["default"] = (ExporterWorkflowSettingsTXT);


/***/ }),

/***/ "./sources/pcvizDataAccess/Exporters/ExporterXYZ.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Exporters/ExporterXYZ.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Exporter = __webpack_require__( /*! pcvizDataAccess/Exporters/Exporter */ "./sources/pcvizDataAccess/Exporters/Exporter.js" );
var ExporterRegistry = __webpack_require__( /*! pcvizDataAccess/ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  ExporterXYZ Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ExporterXYZ = function () {
    Exporter.call( this );
    var _cFormat = 'XYZ';

    var self = this;
    self._cFormat = _cFormat;
};

ExporterXYZ.prototype = Utils.objectInherit( Exporter.prototype, {

    /**
     * @method
     * Finds the supported sources
     * @memberof pcvizDataAccess.ExporterXYZ
     * @return array of strings with supported source properties
     */
    getSupportedSources: function () {
        // supports both exporting 2D profiles and 3D pointsets
        return [ ExporterRegistry.instance.SOURCE_2D, ExporterRegistry.instance.SOURCE_3D, ExporterRegistry.instance.SOURCE_POINT_CLOUD ];
    },

    /**
     * @method
     * Gtes the file extension for the provided format
     * @memberof pcvizDataAccess.ExporterXYZ
     * @return extension string including dot ('.xxx')
     */
    getFileExtension: function () {
        return '.xyz'; // not really used in this case
    },

    /**
     * @method
     * Gets naming info about the exporter 
     * @memberof pcvizDataAccess.ExporterXYZ
     * @return an array of objects with info about formats supported by the Exporter
     */
    getExporterInfo: function () {
        return [ {
            label: 'EXPORT_LAYER_DIALOG.XYZ',
            value: this._cFormat,
            formatAllowsUnitTransform: true
        } ];
    },

    /**
     * @method
     * Check if the driver is open to be use
     * @memberof pcvizDataAccess.ExporterXYZ
     * @return {object} true if driver is ok.false if driver is not ok
     */
    writeFeatures: function ( filename, format, pointContainer, options ) {

        if ( format !== this._cFormat )
            return '';

        var defer = P.defer();

        var ptFactor = 1;
        if ( options !== undefined && options.filter !== undefined && ExporterRegistry.contains( options.filter, ExporterRegistry.SOURCE_2D ) )
            ptFactor = 2; // in 2D segments, points are one single vector with all XY coordinates instead of an array of Vec3

        if ( ptFactor === 1 )
            this.transformPointData( pointContainer, options );

        var ptsStream = '';

        pointContainer.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined && pointSeg.colors !== undefined && pointSeg.points.length <= pointSeg.colors.length * ptFactor ) {
                for ( var iPt = 0, iCol = 0; iPt < pointSeg.points.length; iPt += ptFactor, iCol++ ) {
                    if ( ptFactor === 2 )
                        ptsStream += ( pointSeg.points[ iPt ] ) + ' 0.0 ' + pointSeg.points[ iPt + 1 ] + ' ';
                    else
                        ptsStream += pointSeg.points[ iPt ][ 0 ] + ' ' + pointSeg.points[ iPt ][ 1 ] + ' ' + pointSeg.points[ iPt ][ 2 ] + ' ';
                    //ptsStream += '0 '; // intensity not supported for now
                    ptsStream += pointSeg.colors[ iCol ][ 0 ] + ' ' + pointSeg.colors[ iCol ][ 1 ] + ' ' + pointSeg.colors[ iCol ][ 2 ] + '\n';
                }
            }
        } );

        this.downloadTextData( {
            promise: defer,
            filename: filename,
            textData: ptsStream,
            mimeType: 'application/xyz;charset=utf-8',
            encodeURI: true,
            project: options.project
        } );

        return defer.promise;
    }

} );

// Register exporter 
var exporter = new ExporterXYZ();
ExporterRegistry.getInstance().registerExporter( exporter._cFormat, exporter );

module.exports = ExporterXYZ;


/***/ }),

/***/ "./sources/pcvizDataAccess/FileBrowser.js":
/*!************************************************!*\
  !*** ./sources/pcvizDataAccess/FileBrowser.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  File Browser Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var FileBrowser = function () {

};

FileBrowser.prototype = {

    /**
     * Returns an array of files and/or folders (each file or folder is a JSON object)
     * @method
     * @memberof pcvizDataAccess.FileBrowser
     * @return {array} The files and/or folders
     */
    list: function () {

    },

    /**
     * Downloads a file
     * @method
     * @memberof pcvizDataAccess.FileBrowser
     */
    download: function () {

    },

    retrieve: function () {

    },

    retrieveList: function ( fileList ) {
        var self = this;
        var promises = [];
        fileList.forEach( function ( fileInfo ) {
            promises.push( self.retrieve( fileInfo ) );
        } );
        return P.all( promises );
    },

    /**
     * Deletes a file
     * @method
     * @memberof pcvizDataAccess.FileBrowser
     */
    delete: function () {

    }

};


module.exports = FileBrowser;


/***/ }),

/***/ "./sources/pcvizDataAccess/ImporterRegistry.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizDataAccess/ImporterRegistry.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// var P = require( 'bluebird' );

/**
 *  Importer registry Base Class
 *  @class
 *  @memberof pcvizDataAccess
 */
var ImporterRegistry = {

    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizDataAccess.ImporterRegistry
     * @return {Object} The `Registry` instance.
     */
    getInstance: function () {
        if ( !ImporterRegistry.instance ) {
            ImporterRegistry.instance = this;
            ImporterRegistry.instance.importers = new Map();
        }
        return ImporterRegistry.instance;
    },

    /**
     * Registers an importer.
     * @method
     * @memberof pcvizDataAccess.ImporterRegistry
     * @param  {string} name           The name of the importer.
     * @param  {Importer} importerInstance The importer instance.
     */
    registerImporter: function ( name, importerInstance ) {
        if ( ImporterRegistry.instance.importers.get( name ) !== undefined )
            console.log( 'the importer already exists' );
        ImporterRegistry.instance.importers.set( name, importerInstance );
    },

    /**
     * Gets an importer.
     * @method
     * @memberof pcvizDataAccess.ImporterRegistry
     * @param  {string} name The name of the importer.
     * @return {Importer}      The importer instance.
     */
    getImporter: function ( name ) {
        return ImporterRegistry.instance.importers.get( name );
    },

    /**
     * Gets an importer from uri. It uses the extension of the uri to get the importer.
     * @method
     * @memberof pcvizDataAccess.ImporterRegistry
     * @param  {string} name The name of the importer.
     * @return {Importer}      The importer instance.
     */
    getImporterFromData: function ( file, data ) {
        var result;
        var find = false;
        ImporterRegistry.instance.importers.forEach( function ( importer ) {
            if ( find )
                return;
            if ( importer.acceptFileExtension( file ) ) {
                if ( importer.acceptFile( data ) ) {
                    find = true;
                    result = importer;
                    return;
                }
            }
        } );
        return result;
    },

    getImporterFromFormat: function ( formatId ) {
        var importer;
        ImporterRegistry.instance.importers.forEach( function ( imp ) {
            if ( importer ) return;
            if ( imp.getId() === formatId ) {
                importer = imp;
            }
        } );
        return importer;
    },

    /**
     * @method
     * Gets naming info about the format supported by importers
     * @memberof pcvizDataAccess.ImporterRegistry
     * @return an array of objects with info about formats supported by the Importer
     */
    getFormatInfo: function ( sourceArray ) {
        var formatInfo = [];
        var self = this;

        var numSourceProps = 0;
        if ( sourceArray !== undefined )
            numSourceProps = sourceArray.length;

        ImporterRegistry.instance.importers.forEach( function ( importer ) {
            var supportedSources = importer.getSupportedSources();

            // count supported source types
            var numPropsSupported = 0;
            supportedSources.forEach( function ( support ) {
                if ( self.contains( sourceArray, support ) )
                    numPropsSupported++;
            } );
            if ( numPropsSupported === numSourceProps ) {
                var infos = importer.getImporterInfo();
                infos.forEach( function ( info ) {
                    if ( !self.containsValue( formatInfo, info ) )
                        formatInfo.push( info );
                } );
            }
        } );

        return formatInfo;
    },

    /**
     * Clears the list of registered drivers.
     * @method [name]
     * @memberof pcvizDataAccess.ImporterRegistry
     */
    unregisterAllImporters: function () {
        ImporterRegistry.instance.importers.clear();
    },

    contains: function ( objArray, obj ) {
        var exists = false;
        objArray.forEach( function ( format ) {
            if ( format === obj )
                exists = true;
        } );
        return exists;
    },

    containsValue: function ( objArray, obj ) {
        var exists = false;
        objArray.forEach( function ( format ) {
            if ( format.value === obj.value )
                exists = true;
        } );
        return exists;
    }

};


module.exports = ImporterRegistry;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/CSVImporter.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/CSVImporter.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var ImporterBase = __webpack_require__( /*! pcvizDataAccess/Importers/ImporterBase */ "./sources/pcvizDataAccess/Importers/ImporterBase.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  Importer for Falcon 8 and Sirius pro files
 *  @class
 *  @memberof pcvizDataAccess
 */
var CSVImporter = function () {
    ImporterBase.call( this );
    this._id = 'UAVCsv';
    this._acceptsExtensions = [ 'csv' ];
    this._type = 'UAV:Csv';
    this._driverId = 'da.UAVCsv';
};

CSVImporter.NUM_METADATA_FIELDS = 7;

CSVImporter.prototype = Utils.objectInherit( ImporterBase.prototype, {

    getEPSG: function ( dataItt ) {
        var defer = P.defer();
        var spatialRef = dataItt.getSpatialReference().properties;

        var out = {
            ori: spatialRef.definition,
            dest: undefined
        };
        dataItt.next();
        var geo = dataItt.getGeometry();
        out.dest = 'EPSG:' + CRSUtils.latLonToEPSG( geo.getX(), geo.getY() );
        dataItt.reset();
        defer.resolve( out );
        return defer.promise;

    },

    getNumFields: function ( row ) {
        return UtilsDB.splitCSVLine( row ).length;
    },

    acceptFile: function ( data ) {
        var firstLine = data.substring( 0, data.indexOf( '\n' ) );

        var numFields = this.getNumFields( firstLine );

        if ( numFields === CSVImporter.NUM_METADATA_FIELDS ) {
            return this;
        }
        return;
    }
} );
// Register exporter
var importer = new CSVImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );
module.exports = CSVImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/EXIFImporter.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/EXIFImporter.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var ImporterBase = __webpack_require__( /*! pcvizDataAccess/Importers/ImporterBase */ "./sources/pcvizDataAccess/Importers/ImporterBase.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );

/**
 *  Importer for DJI
 *  @class
 *  @memberof pcvizDataAccess
 */
var EXIFImporter = function () {
    ImporterBase.call( this );
    this._id = 'UAVExif';
    // Importers don't parse data from JPGs because they are not included in VectorJobAdapter._dataFiles
    // JPGs are included in _acceptsExtensions to set EXIF (DJI) layers as valid with no external data file.
    this._acceptsExtensions = [ 'jpg', 'jpeg' ];
    this._type = 'UAV:Exif';
    this._driverId = 'da.UAVExif';
    this._options = [];
};

EXIFImporter.prototype = Utils.objectInherit( ImporterBase.prototype, {} );

// Register exporter
var importer = new EXIFImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );
module.exports = EXIFImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/ImporterBase.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/ImporterBase.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );



/**
 *  Importers base class
 *  @class
 *  @memberof pcvizDataAccess
 *  @property {Array<String>} _acceptsExtensions The extensions of the files that are used to import data.
 */
var ImporterBase = function () {
    this._id = '';
    this._xmlUrl = undefined;
    this._acceptsExtensions = [ 'xml' ];
    this._type = 'UAV:Xml';
    this._driverId = 'da.UAVBlock';
    this._metadataHeaders = 'FileName;Y;X;Z;Omega;Phi;Kappa';
    this._isFinal = false;
    this._options = [ 'OnlyImagesInMetadataFiles' ];
};

ImporterBase.prototype = {

    /**
     * @method
     * Gets naming info about the importer
     * @memberof pcvizDataAccess.Driver
     * @return an array of objects with info about formats supported by the Exporter
     */
    getImporterInfo: function () {
        return [ {
            label: 'IMPORT_LAYER_DIALOG.UAVXml', // now we don´t use this label
            value: this._id
        } ];
    },

    hasOption: function ( value ) {
        return this._options.some( option => value === option );
    },

    getExtensions: function () {
        return this._acceptsExtensions;
    },

    getType: function () {
        return this._type;
    },

    getId: function () {
        return this._id;
    },

    getIsFinal: function () {
        return this._isFinal;
    },

    getMetadataHeaders: function () {
        return this._metadataHeaders;
    },

    acceptFileExtension: function ( url ) {
        var ext = url.substring( url.lastIndexOf( '.' ) + 1 ).toLowerCase();
        var find = this._acceptsExtensions.find( function ( extension ) {
            return ( extension === ext );
        } );
        return ( find !== undefined );
    },

    acceptFile: function ( data ) {
        var driver = DriverRegistry.getInstance().getDriver( this._driverId );
        if ( !driver )
            return;
        if ( driver.acceptFile( data ) ) {
            return this;
        }
        return;
    },

    findPropertyField: function ( id, itt ) {
        var field;
        var numProperties = itt.getNumFields();
        for ( var i = 0; i < numProperties; i++ ) {
            var name = itt.getFieldName( i );
            if ( name === id ) {
                field = itt.getDataByIndex( i );
                break;
            }
        }
        return field;
    },

    getGeoJsonFeatureFromIterator: function ( /*itt, oriEPSG, destEPSG*/) {
        // must be implemented
    },

    getDestEPSG: function () {

    },
    /**
     * @method
     * creates a vector layer and fill all the features
     * @memberof pcvizDataAccess.Driver
     * @param layer to add the features
     * @param data to itterate over them
     * @return promise
     */
    importVectorLayerFromDataIterator: function ( vectorItt, dataItt, filter, oriEPSG, destEPSG ) {
        var defer = P.defer();
        var self = this;
        CRSUtils.getProjectionInfo( destEPSG.substring( destEPSG.lastIndexOf( ':' ) + 1 ), CRSUtils.FORMAT.PROJ4 ).then( function ( epsgDef ) {
            CRSUtils.defProj4( destEPSG, epsgDef );
            dataItt.reset();

            var featureList = [];
            var cont = -1;
            while ( dataItt.next() ) {
                cont++;
                var feature = self.getGeoJsonFeatureFromIterator( dataItt, oriEPSG, destEPSG );
                if ( filter !== undefined ) {
                    var featureFind = false;
                    for ( var i = 0; i < filter.length; i++ ) {
                        if ( filter[ i ] === feature.id ) {
                            featureFind = true;
                            filter.splice( i, 1 );
                            break;
                        }
                    }
                    if ( featureFind )
                        featureList.push( feature );
                    continue;
                }
            }

            var uploadFeaturesArray = [];
            var size = 200;

            while ( featureList.length > 0 )
                uploadFeaturesArray.push( featureList.splice( 0, size ) );

            self.addFeatures( vectorItt, uploadFeaturesArray ).then( function () {
                defer.resolve();
            } ).catch( function () {
                defer.reject();
            } );
        } );

        return defer.promise;
    },

    /**
     * add features to layer. The method recieves and array of arrays of features.
     * @method
     * @memberof pcvizDataAccess.CollageVectorDataIterator
     * @param  {CollageVectorDataIterator} vectorItt the feature vector data iterator
     * @param  {Array} featureList Array of array of features
     */
    addFeatures: function ( vectorItt, featureList ) {
        var defer = P.defer();
        var self = this;
        if ( featureList.length === 0 ) {
            defer.resolve();
            return defer.promise;
        }
        var feature = featureList[ 0 ]; // getting the first array
        vectorItt.addGeoJSONFeature( feature ).then( function () {
            featureList = featureList.slice( 1 ); // popping the top array
            if ( featureList.length > 0 ) {
                self.addFeatures( vectorItt, featureList ).then( function () {
                    defer.resolve();
                } );
            } else {
                defer.resolve();
            }
        }, function () {
            defer.reject();
        } );

        return defer.promise;
    },

    /**
     * @method
     * returns a geo JSON vector data iterator
     * @memberof pcvizDataAccess.Driver
     * @param url to get the file
     * @return promise
     */
    getDataIteratorFromURL: function ( url ) {
        var defer = P.defer();
        var driver = DriverRegistry.getInstance().getDriver( this._driverId );
        driver.open( url ).then( function () {

            if ( driver.isOpen() ) {
                defer.resolve( driver.getSourceLayer() );
            }
        } );

        return defer.promise;
    },

    /**
     * @method
     * returns a geo JSON vector data iterator
     * @memberof pcvizDataAccess.Driver
     * @param data to get the file
     * @return promise
     */
    getDataIteratorFromData: function ( data ) {
        var defer = P.defer();
        var driver = DriverRegistry.getInstance().getDriver( this._driverId );
        driver.openFromData( data ).then( function () {

            if ( driver.isOpen() ) {
                defer.resolve( driver.getSourceLayer() );
            }
        } );

        return defer.promise;
    },

    containsImage: function ( dataIterator, name ) {
        dataIterator.reset();
        var find = false;
        while ( dataIterator.next() ) {
            var property = this.findPropertyField( 'file_name', dataIterator );
            property = property.substring( property.lastIndexOf( '/' ) + 1 );
            if ( property === name ) {
                find = true;
                break;
            }
        }
        if ( find )
            return dataIterator.getFeature();

        return undefined;
    },


    updateImagePath: function ( dataIterator, feature ) {
        return dataIterator.update( VectorLayerUtils.UPDATE_FEATURE, feature );
    },

    getEPSG: function ( /*dataItt*/) {
        // must be implemented
    }
};

module.exports = ImporterBase;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/Pix4DImporter.js":
/*!************************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/Pix4DImporter.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var CSVImporter = __webpack_require__( /*! pcvizDataAccess/Importers/CSVImporter */ "./sources/pcvizDataAccess/Importers/CSVImporter.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );

/**
 *  Importer for Pix4D generated UAVs
 *  @class
 *  @memberof pcvizDataAccess
 */
var Pix4DImporter = function () {
    CSVImporter.call( this );
    this._id = 'UAVPix4D';
    this._acceptsExtensions = [ 'txt' ];
    this._type = 'UAV:Txt';
    this._driverId = 'da.UAVCsv'; // CSV driver is reused
    this._metadataHeaders = 'FileName;X;Y;Z;Omega;Phi;Kappa';
    this._isFinal = true;
};

Pix4DImporter.prototype = Utils.objectInherit( CSVImporter.prototype, {} );
// Register exporter
var importer = new Pix4DImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );
module.exports = Pix4DImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/SimpleCSVImporter.js":
/*!****************************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/SimpleCSVImporter.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var CSVImporter = __webpack_require__( /*! pcvizDataAccess/Importers/CSVImporter */ "./sources/pcvizDataAccess/Importers/CSVImporter.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );

/**
 *  Importer for Simple CSV files (filename, x, y, z)
 *  @class
 *  @memberof pcvizDataAccess
 */
var SimpleCSVImporter = function ( id, metaHeaders ) {
    CSVImporter.call( this );
    this._id = id !== undefined ? id : 'UAVSimpleCsv';
    this._acceptsExtensions = [ 'csv', 'txt' ];
    this._type = 'UAV:Csv'; //¿?
    this._driverId = 'da.UAVCsv'; // CSV driver is reused
    this._metadataHeaders = metaHeaders !== undefined ? metaHeaders : 'FileName;Y;X;Z';
};

SimpleCSVImporter.NUM_METADATA_FIELDS = 4;

SimpleCSVImporter.prototype = Utils.objectInherit( CSVImporter.prototype, {

    acceptFile: function ( data ) {
        var firstLine = data.substring( 0, data.indexOf( '\n' ) );

        var numFields = this.getNumFields( firstLine );

        if ( numFields === SimpleCSVImporter.NUM_METADATA_FIELDS ) {
            return this;
        }
        return;
    }
} );
// Register importers
var importer = new SimpleCSVImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );

var importerXY = new SimpleCSVImporter( 'UAVSimpleCsvReversed', 'FileName;X;Y;Z' );
ImporterRegistry.getInstance().registerImporter( importerXY._id, importerXY );

module.exports = SimpleCSVImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/XMLBlockImporter.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/XMLBlockImporter.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var ImporterBase = __webpack_require__( /*! pcvizDataAccess/Importers/ImporterBase */ "./sources/pcvizDataAccess/Importers/ImporterBase.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;


/**
 *  Importer for Blocks format from contextCapture
 *  @class
 *  @memberof pcvizDataAccess
 */
var XMLBlockImporter = function () {
    ImporterBase.call( this );
    this._id = 'UAVBlock';
    this._type = 'UAV:Xml';
    this._driverId = 'da.UAVBlock';
    this._acceptsExtensions = [ 'xml' ];
};

XMLBlockImporter.prototype = Utils.objectInherit( ImporterBase.prototype, {

    getGeoJsonFeatureFromIterator: function ( itt, oriEPSG, destEPSG ) {
        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [ 0, 0, 0 ]
            },
            'properties': {

            }
        };
        feature[ 'id' ] = this.findPropertyField( 'id', itt );
        var geo = itt.getGeometry();
        var originalPoint = [ geo.getX(), geo.getY(), geo.getZ() ];

        var pUTM = CRSUtils.transform( oriEPSG, destEPSG, [ originalPoint[ 0 ], originalPoint[ 1 ], originalPoint[ 2 ] ] );

        feature.geometry.coordinates = pUTM;

        var attitude = osg.quat.fromValues( this.findPropertyField( 'quatX', itt ), this.findPropertyField( 'quatY', itt ), this.findPropertyField( 'quatZ', itt ), this.findPropertyField( 'quatW', itt ) );
        if ( oriEPSG !== destEPSG ) {
            attitude = CRSUtils.reprojectOrientation( originalPoint, attitude, oriEPSG, destEPSG );
        }

        feature.properties[ 'file_name' ] = this.findPropertyField( 'file_name', itt );
        feature.properties[ 'x' ] = pUTM[ 0 ];
        feature.properties[ 'y' ] = pUTM[ 1 ];
        feature.properties[ 'z' ] = pUTM[ 2 ];
        feature.properties[ 'quatX' ] = attitude[ 0 ];
        feature.properties[ 'quatY' ] = attitude[ 1 ];
        feature.properties[ 'quatZ' ] = attitude[ 2 ];
        feature.properties[ 'quatW' ] = attitude[ 3 ];
        feature.properties[ 'fovH' ] = this.findPropertyField( 'fovH', itt );
        feature.properties[ 'fovW' ] = this.findPropertyField( 'fovW', itt );
        feature.properties[ 'sensorWidth' ] = this.findPropertyField( 'sensorWidth', itt );
        feature.properties[ 'sensorHeight' ] = this.findPropertyField( 'sensorHeight', itt );

        var ppX = this.findPropertyField( 'principalPointX', itt );
        var ppY = this.findPropertyField( 'principalPointY', itt );
        if ( ppX === '' )
            ppX = feature.properties[ 'sensorWidth' ] / 2.0;
        if ( ppY === '' )
            ppY = feature.properties[ 'sensorHeight' ] / 2.0;
        feature.properties[ 'principalPointX' ] = ppX;
        feature.properties[ 'principalPointY' ] = ppY;

        // RESTORE THIS TO USE Omega Phi Kappa (the images don´t show right)
        // feature.properties[ 'w[rad]' ] = -this.findPropertyField( 'w[rad]', itt );
        // feature.properties[ 'p[rad]' ] = this.findPropertyField( 'p[rad]', itt );
        // feature.properties[ 'k[rad]' ] = this.findPropertyField( 'k[rad]', itt );

        return feature;
    },

    getEPSG: function ( dataItt ) {
        var defer = P.defer();
        var spatialRef = dataItt.getSpatialReference().properties;

        var useDefinition = spatialRef.definition.startsWith( 'EPSG:' );

        var out = {
            ori: ( useDefinition ) ? spatialRef.definition : spatialRef.name,
            dest: undefined
        };

        if ( !useDefinition ) {
            dataItt.next();
            var geo = dataItt.getGeometry();
            var p = CRSUtils.transform( spatialRef.definition, CRSUtils.WGS_84, [ geo.getX(), geo.getY(), geo.getZ() ] );
            out.dest = 'EPSG:' + CRSUtils.latLonToEPSG( p[ 1 ], p[ 0 ] );
            dataItt.reset();
            defer.resolve( out );
            return defer.promise;
        }

        var epsgORI = out.ori.substring( out.ori.lastIndexOf( ':' ) + 1 );

        CRSUtils.getProjectionInfo( epsgORI, CRSUtils.FORMAT.PROJ4 ).then( function ( epsgDef ) {
            CRSUtils.defProj4( out.ori, epsgDef );
            dataItt.next();
            var geo = dataItt.getGeometry();
            var p = CRSUtils.transform( out.ori, CRSUtils.WGS_84, [ geo.getX(), geo.getY(), geo.getZ() ] );
            out.dest = 'EPSG:' + CRSUtils.latLonToEPSG( p[ 1 ], p[ 0 ] );
            dataItt.reset();
            defer.resolve( out );
        } );
        return defer.promise;
    }

} );

// Register exporter
var importer = new XMLBlockImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );
module.exports = XMLBlockImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Importers/XMLPhotoScanImporter.js":
/*!*******************************************************************!*\
  !*** ./sources/pcvizDataAccess/Importers/XMLPhotoScanImporter.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var ImporterBase = __webpack_require__( /*! pcvizDataAccess/Importers/ImporterBase */ "./sources/pcvizDataAccess/Importers/ImporterBase.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  Importer for Blocks format from contextCapture
 *  @class
 *  @memberof pcvizDataAccess
 */
var XMLPhotoScanImporter = function () {
    ImporterBase.call( this );
    this._id = 'UAVPhotoScan';
    this._type = 'UAV:Xml';
    this._driverId = 'da.UAVPhotoScan';
    this._acceptsExtensions = [ 'xml' ];
};

XMLPhotoScanImporter.prototype = Utils.objectInherit( ImporterBase.prototype, {

    getGeoJsonFeatureFromIterator: function ( /*itt, oriEPSG, destEPSG*/) {
        var feature = {
            'type': 'Feature',
            'geometry': {
                'type': 'Point',
                'coordinates': [ 0, 0, 0 ]
            },
            'properties': {

            }
        };

        return feature;
    },

    getEPSG: function ( dataItt ) {
        var defer = P.defer();
        var spatialRef = dataItt.getSpatialReference().properties;

        var out = {
            ori: undefined,
            dest: undefined
        };

        dataItt.next();
        var geo = dataItt.getGeometry();
        var p = CRSUtils.transform( spatialRef.definition, CRSUtils.WGS_84, [ geo.getX(), geo.getY(), geo.getZ() ] );
        out.dest = 'EPSG:' + CRSUtils.latLonToEPSG( p[ 1 ], p[ 0 ] );
        dataItt.reset();

        defer.resolve( out );
        return defer.promise;
    }

} );

// Register exporter
var importer = new XMLPhotoScanImporter();
ImporterRegistry.getInstance().registerImporter( importer._id, importer );
module.exports = XMLPhotoScanImporter;


/***/ }),

/***/ "./sources/pcvizDataAccess/Uploaders/FileUploadHandler.js":
/*!****************************************************************!*\
  !*** ./sources/pcvizDataAccess/Uploaders/FileUploadHandler.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1__);





class FileUploadHandler extends pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor() {
        super();
        this._uploadDefinition = undefined;

        this._fileName = undefined;

        this._onFileUploadResolve = undefined;
        this._onFileUploadReject = undefined;

        this._pausePromise = undefined;
        this._resumeFn = undefined;

        this._callbacks = [];
    }

    setUploadDefinition( uploadDefinition ) {
        this._uploadDefinition = uploadDefinition;
    }

    upload() {
        return new Promise( ( resolve, reject ) => {
            let fileInfo = this._uploadDefinition.fileInfo;
            this._onFileUploadResolve = resolve;
            this._onFileUploadReject = reject;

            let file = this._uploadDefinition.file;
            if ( !fileInfo.progress ) {
                fileInfo.progress = 0;
            }

            const name = file.alias || file.name;

            // TODO: Do all things related to names in Job object or FileUploader, not here
            // This must be config agnostic
            this._fileName = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.cleanUpFileNameCharacters( name );

            // TODO: Check if useFilePath is used or is legacy code -> Now it is being used for creating stations uploading pointclouds
            if ( this._uploadDefinition.config.upload.useFilePath && file.path ) {
                this._fileName = file.path;
            }

            var fileIndex = this._uploadDefinition.config.upload.filesInfo.findIndex( file => {
                return this._uploadDefinition.file.name === file.name && this._uploadDefinition.file.size === file.size;
            } );

            this._uploadDefinition.config.upload.urls[ fileIndex ] = {
                filePath: this._uploadDefinition.config.upload.prefix + this._fileName,
                size: this._uploadDefinition.file.size
            };

            this._uploadFile();
        } );
    }

    _uploadFile() {
        throw 'FileUploadHandler: _uploadFile not implemented';
    }

    reset() {
        this._uploadDefinition = undefined;
        this._fileName = undefined;
        this._onFileUploadResolve = undefined;
        this._onFileUploadReject = undefined;
        this._pausePromise = undefined;
        this._resumeFn = undefined;
        this._callbacks.length = 0;
    }

    getPausePromise() {
        return this._pausePromise;
    }

    _resolveUploadFile() {
        this._uploadDefinition.fileInfo.completed = true;
        this._onFileUploadResolve( this._uploadDefinition );
    }

    _rejectUploadFile( file ) {
        // We check that the reject is executed for the right upload by name.
        // FIXME: If the file uploading has the same name as the file that was being uploaded when the upload was aborted, an incorrect behaviour will happen.
        if ( this._onFileUploadReject && ( !file || file.name === undefined || file.name === this._uploadDefinition.fileInfo.name ) ) {
            this._onFileUploadReject( this._uploadDefinition );
            this._onFileUploadReject = undefined;
        }
    }

    pause() {
        this._pausePromise = new Promise( resolve => this._resumeFn = resolve );
    }

    resume() {
        if ( this._resumeFn ) {
            this._resumeFn();
        }
    }

    on( action, fn ) {
        this._callbacks[ action ] = fn;
    }

    _notify( action, ...args ) {
        if ( action in this._callbacks ) {
            this._callbacks[ action ]( ...args );
        }
    }
}

/* harmony default export */ __webpack_exports__["default"] = (FileUploadHandler);


/***/ }),

/***/ "./sources/pcvizDataAccess/Uploaders/FileUploader.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizDataAccess/Uploaders/FileUploader.js ***!
  \***********************************************************/
/*! exports provided: MAX_CONCURRENT_UPLOADS, MAX_CHUNK_SIZE, MAX_SINGLE_PART_SIZE, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_CONCURRENT_UPLOADS", function() { return MAX_CONCURRENT_UPLOADS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_CHUNK_SIZE", function() { return MAX_CHUNK_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SINGLE_PART_SIZE", function() { return MAX_SINGLE_PART_SIZE; });
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");






const MAX_CONCURRENT_UPLOADS = 6;
const MAX_CHUNK_SIZE = 5242880;
const MAX_SINGLE_PART_SIZE = 30000000; // 30 MB

class FileUploader {
    constructor( config ) {
        this._callbacks = {};
        this._uploadingCount = 0;
        this._cancelUploadImages = false;

        this._activeUploads = undefined;
        this._failure = undefined;

        this._files = config.files;
        this._filesInfo = config.upload.filesInfo;

        this._onSuccess = undefined;
        this._onReject = undefined;
        this._fileUploadHandler = undefined;

        this._previousStatus = undefined;

        this._config = config; // TODO: Remove when job is implemented
    }

    uploadFiles() {
        return new Promise( ( resolve, reject ) => {
            this._uploadingCount++;

            // TODO: Job must execute pause and cancel function. Currently this is attatched
            // to the config object
            this._config.upload.cancel = this.cancel.bind( this );
            this._config.upload.pause = this.pause.bind( this );

            this._cancelUploadImages = false;
            this._uploadList = this._getUploadFilesList();
            this._startUploadFiles( /*list, config, config.maxConcurrentUploads, config.preCallback*/).then( () => {
                this._finishUpload();
                resolve();
            }, () => {
                this._finishUpload( true );
                reject();
            } );

        } );
    }

    _getUploadFilesList() {
        let list = [];
        this._filesInfo.forEach( ( fileInfo, index ) => {
            let file = this._files.find( file => fileInfo.name === file.name );
            if ( file === undefined )
                return;
            if ( !fileInfo.mustUpload )
                return;
            list.push( {
                config: this._config, // TODO: Do we need this?
                url: this._config.upload.urls ? this._config.upload.urls[ index ] : undefined, // Do we need this?
                file: file,
                fileInfo: fileInfo
            } );
        } );
        return list;
    }

    _startUploadFiles() {
        if ( !this._config.upload.urls )
            this._config.upload.urls = [];
        return new Promise( ( resolve, reject ) => {
            this._config.upload.startedAt = new Date();
            this._onSuccess = resolve;
            this._onError = reject;
            this._activeUploads = [];
            this._failure = false;
            // this._config.fileAbort = new Promise(); // TODO: Do we need this?

            // Save an updateAt value to know when a upload has stopped because of a tab closed
            this._checkInterval = setInterval( () => {
                this._config.upload.updatedAt = Date.now();
                pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( this._config.upload );
            }, 5000 );


            if ( this._getUploadController().isCurrentlyUploading() ) {
                this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].QUEUED );
                this._sendToQueue( this._config );
                return;
            }

            this._popFiles();
        } );
    }

    _popFiles() {
        // TODO: _globalConcurrentUploads is not a member of this class. Iterate active uploads?
        if ( this._fileUploadHandler && this._fileUploadHandler._globalConcurrentUploads === MAX_CONCURRENT_UPLOADS && this._uploadList.length > 0 ) {
            this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].QUEUED );
            this._sendToQueue( this._config );
            return;
        }
        if ( this._uploadList.length > 0 ) {
            let pausePromise = this._config.upload.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].PAUSED ? this._fileUploadHandler.getPausePromise() : Promise.resolve(); // TODO: Refactor this.
            pausePromise.then( () => {
                this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].UPLOADING );
                let uploadDefinition = this._uploadList.shift();
                this._activeUploads.push( uploadDefinition );

                this._fileUploadHandler = this._getFileUploadHandler( uploadDefinition );
                this._fileUploadHandler.upload().then( resolvedUpload => {
                    this._continueUploading( resolvedUpload );
                }, rejectedUpload => {
                    this._stopUploading( rejectedUpload );
                } );
            } );
        }
        if ( this._activeUploads.length === 0 && this._uploadList.length === 0 ) {
            this._onSuccess();
        }
    }

    _continueUploading( resolvedUpload ) {
        if ( this._failure ) {
            return;
        }
        this._activeUploads.splice( this._activeUploads.indexOf( resolvedUpload ), 1 );
        this._popFiles();
    }

    _stopUploading( rejectedUpload ) {
        this._activeUploads.splice( this._activeUploads.indexOf( rejectedUpload ), 1 );
        this._failure = true;
        if ( this._onError ) {
            this._onError();
            this._onError = undefined;
        }
    }

    _getFileUploadHandler( uploadDefinition ) {
        // Depends on the file size, the upload handler will be single part or multi part
        //    multipart: better for large files, can be resumed if upload fails. Worse for small files, one connection for each part.
        //    singlepart: better for small files, only one connection per file. Worse for large files if upload fails by unstable connection.
        let multiPartHandlerEnabled = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.collage' ).entryPointExists( 'multiPartUpload' );
        let driverId, fileUploadHandler;
        if ( multiPartHandlerEnabled && uploadDefinition.file.size >= MAX_SINGLE_PART_SIZE ) {
            driverId = 'da.multiPart';
        } else {
            driverId = 'da.singlePart';
        }
        fileUploadHandler = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( driverId );
        fileUploadHandler.reset( true );
        fileUploadHandler.setUploadDefinition( uploadDefinition );
        fileUploadHandler.on( 'progress', () => {
            this._computeStatistics();
            this._notify( 'progress' );
        } );
        return fileUploadHandler;
    }

    _computeStatistics() {
        let progress = 0;
        let loaded = 0;
        let size = 0;
        this._filesInfo.forEach( function ( fileInformation ) {
            progress += fileInformation.progress || 0;
            loaded += fileInformation.loaded || 0;
            size += fileInformation.size || 0;
        } );

        // compute total progress
        this._config.upload.progress = progress / this._filesInfo.length;

        // compute remaining time
        if ( this._config.upload.isIncomplete ) {
            // we have a loaded value from last uploaded attempt
            if ( loaded ) {
                this._config.upload.resumingLoadedSize = loaded;
            } else {
                this._config.upload.resumingLoadedSize = 0;
            }
            this._config.upload.isIncomplete = false;
        }

        loaded -= this._config.upload.resumingLoadedSize || 0; // if has value, substract size loaded before resuming

        let timeElapsed = new Date() - this._config.upload.startedAt;
        let uploadSpeed = loaded / timeElapsed; // upload speed in ms
        this._config.upload.remainingTime = Math.trunc( ( size - loaded ) / uploadSpeed ) || 0;

        //
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( this._config.upload );
    }

    _finishUpload( error ) {
        // Use config data to send notification
        this._config.upload.status = error ? pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].INCOMPLETE : pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].UPLOADED;
        this._config.upload.isIncomplete = !!error;
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( this._config.upload );

        var cancelled = this._config.files.every( function ( file ) {
            return file.cancelled;
        } );
        cancelled = cancelled || this._cancelUploadImages; // TODO: Check if this is being used.
        this._config.endedAt = new Date().toISOString();
        this._uploadingCount--;
        this._checkInterval = clearInterval( this._checkInterval );

        this._getUploadController().checkQueuedUploads();
    }

    _sendToQueue() {
        this._config.resumeCallback = this._popFiles.bind( this ); // TODO: This should be done in Job object ( when class is implemented )
        this._getUploadController().sendUploadToQueue( this._config );
    }

    _updateProgress( fileInfo ) {
        // This function is only useful for multipart upload
        if ( fileInfo.progress >= 100 )
            return;
        if ( !fileInfo.progressParts )
            return;
        let progress = 0;
        fileInfo.progressParts.forEach( ( partProgress, index, array ) => {
            if ( partProgress !== MAX_CHUNK_SIZE && index !== fileInfo.totalParts )
                array[ index ] = 0;
            progress += array[ index ];
        } );
        fileInfo.progress = ( progress / fileInfo.size ) * 100;
    }

    cancel() {
        // If a job is cancelled when it is queued, it must be removed from it.
        this._getUploadController().removeFromQueue( this._config );
        this._cancelUploadImages = true;
        this._filesInfo.forEach( ( fileInfo, index ) => {
            this._updateProgress( fileInfo );
            if ( this._files && this._files[ index ] )
                this._files[ index ].cancelled = true;
        } );

        // TODO: Remove use of config object.
        // If a job is cancelled when it is paused, it must be resumed to properly cancel the part upload.
        if ( this._fileUploadHandler )
            this._fileUploadHandler.resume();

        this._previousStatus = this._config.upload.status;
        this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].CANCELLING );

        /*  This 'cancelling' status will be shown on the label inside the box-upload html component
         with the right text 'cancelling' because it is possible we need to wait some seconds for big files
         specially on c.site. 
        
         We will change this status in 1 second, just to let the user view the cancelling message

         C.web is fast doing the cancelation but C.site can spend much more time 
         The multipart load is relatively fast doing the efetive cancelation 
         On c.site , the cancel is not possible by now (september 23) and spend some time to finish (7 secs x 1.7 Gb SCZ)
         TODO: review why we can't have the multipart application on c.site.         */

        setTimeout( () => {
            this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].INCOMPLETE );
        }, 1000 );

        this._notify( 'cancel', this._config );
    }

    pause() {
        if ( this._config.upload.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].PAUSED ) {
            // TODO: Perform this check in job container object
            return;
        }
        this._previousStatus = this._config.upload.status;
        this.setStatus( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"].PAUSED );
        this._fileUploadHandler.pause();
        this._config.upload.resume = this.resume.bind( this );
    }

    resume() {
        this._config.upload.startedAt = new Date();
        this._fileUploadHandler.resume();
        this.setStatus( this._previousStatus );
    }

    setStatus( status ) {
        this._config.upload.status = status; // Use callback to set status instead of config object
        this._notify( 'status' );

        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( this._config.upload );
    }

    on( action, fn ) {
        this._callbacks[ action ] = fn;
    }

    _notify( action, ...args ) {
        if ( action in this._callbacks ) {
            this._callbacks[ action ]( ...args );
        }
    }

    _getUploadController() {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' );
    }
}

/* harmony default export */ __webpack_exports__["default"] = (FileUploader);


/***/ }),

/***/ "./sources/pcvizDataAccess/Uploaders/MultiPartUploadHandler.js":
/*!*********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Uploaders/MultiPartUploadHandler.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js");
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/ObjectType */ "./sources/pcvizGIS/ObjectType.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");
/* harmony import */ var _FileUploadHandler__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./FileUploadHandler */ "./sources/pcvizDataAccess/Uploaders/FileUploadHandler.js");
/* harmony import */ var _FileUploader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./FileUploader */ "./sources/pcvizDataAccess/Uploaders/FileUploader.js");
/* harmony import */ var js_md5__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! js-md5 */ "./node_modules/js-md5/src/md5.js");
/* harmony import */ var js_md5__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(js_md5__WEBPACK_IMPORTED_MODULE_8__);












class MultiPartUploadHandler extends _FileUploadHandler__WEBPACK_IMPORTED_MODULE_6__["default"] {
    constructor() {
        super();

        this._globalConcurrentUploads = 0;

        this._multipartUploadConfig = undefined;
        this._currentPart = 0;
        this._uploadedParts = 0;
        this._failure = undefined;
    }

    _uploadFile() {
        this._startMultipartUpload( this._uploadDefinition.config.upload.object, this._fileName, this._uploadDefinition.config.upload.prefix ).then( multipartUploadConfig => {
            this._multipartUploadConfig = multipartUploadConfig;
            this._failure = false;
            this._uploadDefinition.fileInfo.totalParts = Math.ceil( this._uploadDefinition.file.size / _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CHUNK_SIZE"] );

            this._uploadPartFromFile();
        }, this._rejectUploadFile.bind( this ) );
    }

    _startMultipartUpload( object, fileName, prefix ) {
        let replaceVars = {
            type: object.layerType ? pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_3__["default"].LAYER : pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_3__["default"].PROJECT
        };

        return this.request( {
            url: this.getResource( 'multiPartUpload', object.id, replaceVars ) + 'uploads/' + prefix + fileName,
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.POST,
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            }
        } );
    }

    _uploadPartFromFile() {
        let fileBlob = this._uploadDefinition.file;
        let fileInfo = this._uploadDefinition.fileInfo;

        if ( this._globalConcurrentUploads === _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CONCURRENT_UPLOADS"] && this._currentPart < fileInfo.totalParts ) {
            this._uploadDefinition.config.resumeCallback = this._uploadPartFromFile;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).sendUploadToQueue( this._uploadDefinition.config );
            return;
        }

        while ( this._currentPart < fileInfo.totalParts && this._globalConcurrentUploads < _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CONCURRENT_UPLOADS"] ) {
            let partNumber = this._currentPart + 1;

            let start = this._currentPart * _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CHUNK_SIZE"];
            let end = Math.min( fileBlob.size, ( partNumber ) * _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CHUNK_SIZE"] );
            let blobPart = fileBlob.slice( start, end );
            this._globalConcurrentUploads++;
            let alreadyUploadedPart = this._findPartInMultipartUploadConfig( partNumber );
            this._uploadPart( this._multipartUploadConfig.actions.signparts, partNumber, blobPart, this._uploadDefinition.file, alreadyUploadedPart ).then( () => {
                this._continuePartUpload();
            } ).catch( ( file ) => {
                this._stopPartUpload( file );
            } );
            this._currentPart++;
        }
        if ( this._uploadedParts === fileInfo.totalParts ) {
            this._completeMultipartUpload( this._multipartUploadConfig.actions.complete ).then( () => {
                this._resolveUploadFile();
            }, () => {
                this._rejectUploadFile();
            } );
        }
    }

    _uploadPart( signURL, index, data, file, alreadyUploadedPart ) {
        return new Promise( ( resolve, reject ) => {
            if ( file.cancelled ) {
                reject( file );
                this._notify( 'cancel', this._config );
                return;
            }

            var fileData = this._uploadDefinition.config.upload.filesInfo.find( fileInfo => fileInfo.name === file.name );
            if ( alreadyUploadedPart ) {
                this._checkUploadedPartIntegrity( alreadyUploadedPart, data ).then( () => {
                    this._computeUploadProgress( this._uploadDefinition.file, fileData, index, _FileUploader__WEBPACK_IMPORTED_MODULE_7__["MAX_CHUNK_SIZE"] );
                    resolve();
                } ).catch( () => {
                    reject();
                } );
                return;
            }

            var pausePromise = this._uploadDefinition.config.upload.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_5__["default"].PAUSED ? this._pausePromise : Promise.resolve();
            pausePromise.then( () => {
                this._signPart( signURL, index ).then( url => {

                    var promise = this.request( {
                        url: url,
                        method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.PUT,
                        useToken: false,
                        headers: {
                            'cache-control': pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_4___default.a.MAX_AGE
                        },
                        data: data,
                        progress: ev => {
                            this._computeUploadProgress( file, fileData, index, ev.loaded );
                        }

                    } );

                    promise.then( () => {
                        if ( file.cancelled ) {
                            reject( file );
                            this._notify( 'cancel', this._config );
                            return;
                        }
                        resolve( url );
                    }, () => {
                        reject();
                    } );
                }, () => {
                    reject();
                } );
            } );
        } );
    }

    _signPart( signURL, index ) {
        var data = {
            partNumbers: [ index ]
        };
        return this.request( {
            url: signURL,
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.POST,
            data: JSON.stringify( data ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ).parts[ 0 ].url );
            }
        } );
    }

    _completeMultipartUpload( completeURL ) {
        return this.request( {
            url: completeURL,
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_2___default.a.POST,
            success: ( response, resolve ) => {
                resolve();
            }
        } );
    }

    _continuePartUpload() {
        if ( this._failure )
            return;

        this._globalConcurrentUploads--;
        this._uploadedParts++;
        this._uploadPartFromFile();
    }

    _stopPartUpload( file ) {
        // We check that the reject is executed for the right upload by name.
        // FIXME: If the file uploading has the same name as the file that was being uploaded when the upload was aborted, an incorrect behaviour will happen.
        if ( !file || file.name === undefined || file.name === this._uploadDefinition.fileInfo.name )
            this._failure = true;
        this._globalConcurrentUploads--;
        this._rejectUploadFile( file );
    }

    _findPartInMultipartUploadConfig( partNumber ) {
        return this._multipartUploadConfig.parts.find( part => part.partNumber === partNumber );
    }

    _checkUploadedPartIntegrity( uploadedPart, blob ) {
        return new Promise( function ( resolve, reject ) {
            var fileReader = new FileReader();
            fileReader.onload = function () {
                var blobMD5 = js_md5__WEBPACK_IMPORTED_MODULE_8___default()( this.result ); // result is the arraybuffer
                if ( uploadedPart.size === blob.size && uploadedPart.md5 === blobMD5 )
                    resolve();
                else
                    reject();
            };
            fileReader.readAsArrayBuffer( blob );
        } );
    }

    _computeUploadProgress( file, fileData, index, loaded ) {
        if ( !fileData.progressParts )
            fileData.progressParts = [];
        if ( file.cancelled )
            return;
        var totalLoaded = 0;
        fileData.progressParts[ index ] = loaded;
        fileData.progressParts.forEach( partLoaded => {
            totalLoaded += partLoaded;
        } );
        fileData.progress = ( totalLoaded / file.size ) * 100;
        fileData.loaded = totalLoaded;
        this._notify( 'progress' );
    }

    reset( force ) {
        if ( !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).isCurrentlyUploading() || force ) {
            super.reset();
            this._globalConcurrentUploads = 0;

            this._multipartUploadConfig = undefined;
            this._currentPart = 0;
            this._uploadedParts = 0;
            this._failure = undefined;
        }
    }
}

pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().registerDriver( 'da.multiPart', new MultiPartUploadHandler() );

/* harmony default export */ __webpack_exports__["default"] = (MultiPartUploadHandler);


/***/ }),

/***/ "./sources/pcvizDataAccess/Uploaders/SinglePartUploadHandler.js":
/*!**********************************************************************!*\
  !*** ./sources/pcvizDataAccess/Uploaders/SinglePartUploadHandler.js ***!
  \**********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDataAccess/Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js");
/* harmony import */ var pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");
/* harmony import */ var _FileUploadHandler__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./FileUploadHandler */ "./sources/pcvizDataAccess/Uploaders/FileUploadHandler.js");
/* harmony import */ var pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/ObjectType */ "./sources/pcvizGIS/ObjectType.js");










class SinglePartUploadHandler extends _FileUploadHandler__WEBPACK_IMPORTED_MODULE_5__["default"] {
    constructor() {
        super();
    }

    _uploadFile() {
        let object = this._uploadDefinition.config.upload.object; // Use object id
        let config = this._uploadDefinition.config;
        let file = this._uploadDefinition.file;

        var completeFileName = config.upload.prefix + this._fileName;

        var files = [ {
            'filePath': completeFileName,
            'contentType': file.type,
        } ];

        var fileData = config.upload.filesInfo.find( info => info.name === file.name );

        var pausePromise = config.upload.status === pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_4__["default"].PAUSED ? this._pausePromise : Promise.resolve();
        pausePromise.then( () => {
            this._getUploadUrl( object, files ).then( filesUrl => {
                var fileUrl = filesUrl.find( url => url.filePath === completeFileName );

                if ( !fileUrl ) {
                    return;
                }

                var promise = this.request( {
                    url: fileUrl.uploadUrl,
                    method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_3___default.a.PUT,
                    useToken: false,
                    headers: {
                        'cache-control': pcvizDataAccess_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2___default.a.MAX_AGE,
                        'Content-Type': 'application/octet-stream'
                    },
                    data: file,
                    progress: ev => {
                        if ( file.cancelled )
                            return;

                        fileData.progress = ( ev.loaded / ev.total ) * 100;
                        fileData.loaded = ev.loaded;
                        this._notify( 'progress' );
                    }
                } );

                promise.then( () => {
                    if ( file.cancelled ) {
                        this._rejectUploadFile();
                        this._notify( 'cancel', this._config );
                        return;
                    }
                    this._resolveUploadFile();
                }, this._rejectUploadFile.bind( this ) );
            }, this._rejectUploadFile.bind( this ) );
        } );
    }

    _getUploadUrl( object, files ) {
        let data = files;

        let replaceVars = {
            type: object.layerType ? pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_6__["default"].LAYER : pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_6__["default"].PROJECT
        };
        return this.request( {
            url: this.getResource( 'singlePartUpload', object.id, replaceVars ) + 'files',
            method: pcvizDataAccess_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_3___default.a.POST,
            data: JSON.stringify( data ),
            success: ( response, resolve ) => {
                resolve( JSON.parse( response ) );
            }
        } );
    }

    reset( force ) {
        if ( !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Upload' ).isCurrentlyUploading() || force ) {
            super.reset();
        }
    }
}

pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().registerDriver( 'da.singlePart', new SinglePartUploadHandler() );

/* harmony default export */ __webpack_exports__["default"] = (SinglePartUploadHandler);


/***/ }),

/***/ "./sources/pcvizDataAccess/pcvizDataAccess.js":
/*!****************************************************!*\
  !*** ./sources/pcvizDataAccess/pcvizDataAccess.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Drivers_Driver__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Drivers/Driver */ "./sources/pcvizDataAccess/Drivers/Driver.js");
/* harmony import */ var _Drivers_Driver__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Drivers_Driver__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var _DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js");
/* harmony import */ var _Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Drivers_SpatialDriver__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Drivers/SpatialDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDriver.js");
/* harmony import */ var _Drivers_SpatialDriver__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Drivers_SpatialDriver__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Drivers_DataBaseDriver__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Drivers/DataBaseDriver */ "./sources/pcvizDataAccess/Drivers/DataBaseDriver.js");
/* harmony import */ var _Drivers_DataBaseDriver__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Drivers_DataBaseDriver__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Drivers_SpatialDataBaseDriver__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Drivers/SpatialDataBaseDriver */ "./sources/pcvizDataAccess/Drivers/SpatialDataBaseDriver.js");
/* harmony import */ var _Drivers_SpatialDataBaseDriver__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Drivers_SpatialDataBaseDriver__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Drivers_GeoJSONDriver__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./Drivers/GeoJSONDriver */ "./sources/pcvizDataAccess/Drivers/GeoJSONDriver.js");
/* harmony import */ var _Drivers_GeoJSONDriver__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_Drivers_GeoJSONDriver__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Drivers_CollageCloudDriver__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Drivers/CollageCloudDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloudDriver.js");
/* harmony import */ var _Drivers_CollageCloudDriver__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Drivers_CollageCloudDriver__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Drivers_CollageCloud_CategoryDriver__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./Drivers/CollageCloud/CategoryDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/CategoryDriver.js");
/* harmony import */ var _Drivers_CollageCloud_CategoryDriver__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Drivers_CollageCloud_CategoryDriver__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Drivers_CollageCloud_LayerDriver__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./Drivers/CollageCloud/LayerDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/LayerDriver.js");
/* harmony import */ var _Drivers_CollageCloud_LayerDriver__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Drivers_CollageCloud_LayerDriver__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Drivers_CollageCloud_ProjectDriver__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Drivers/CollageCloud/ProjectDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/ProjectDriver.js");
/* harmony import */ var _Drivers_CollageCloud_ProjectDriver__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Drivers_CollageCloud_ProjectDriver__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _Drivers_CollageCloud_JobDriver__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Drivers/CollageCloud/JobDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/JobDriver.js");
/* harmony import */ var _Drivers_UAV_UAVDriverBase__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./Drivers/UAV/UAVDriverBase */ "./sources/pcvizDataAccess/Drivers/UAV/UAVDriverBase.js");
/* harmony import */ var _Drivers_UAV_UAVDriverBase__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_Drivers_UAV_UAVDriverBase__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _Drivers_UAV_XMLBlockDriver__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./Drivers/UAV/XMLBlockDriver */ "./sources/pcvizDataAccess/Drivers/UAV/XMLBlockDriver.js");
/* harmony import */ var _Drivers_UAV_XMLBlockDriver__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_Drivers_UAV_XMLBlockDriver__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Drivers_UAV_XMLPhotoScanDriver__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./Drivers/UAV/XMLPhotoScanDriver */ "./sources/pcvizDataAccess/Drivers/UAV/XMLPhotoScanDriver.js");
/* harmony import */ var _Drivers_UAV_XMLPhotoScanDriver__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_Drivers_UAV_XMLPhotoScanDriver__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _Drivers_UAV_CSVDriver__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Drivers/UAV/CSVDriver */ "./sources/pcvizDataAccess/Drivers/UAV/CSVDriver.js");
/* harmony import */ var _Drivers_UAV_CSVDriver__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_Drivers_UAV_CSVDriver__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _Drivers_CollageCloud_JobSiteDriver__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./Drivers/CollageCloud/JobSiteDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/JobSiteDriver.js");
/* harmony import */ var _DataIterators_DataIterator__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./DataIterators/DataIterator */ "./sources/pcvizDataAccess/DataIterators/DataIterator.js");
/* harmony import */ var _DataIterators_DataIterator__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_DataIterators_DataIterator__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _DataIterators_SpatialDataIterator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./DataIterators/SpatialDataIterator */ "./sources/pcvizDataAccess/DataIterators/SpatialDataIterator.js");
/* harmony import */ var _DataIterators_SpatialDataIterator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_DataIterators_SpatialDataIterator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _DataIterators_GeoJSONDataIterator__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./DataIterators/GeoJSONDataIterator */ "./sources/pcvizDataAccess/DataIterators/GeoJSONDataIterator.js");
/* harmony import */ var _DataIterators_GeoJSONDataIterator__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_DataIterators_GeoJSONDataIterator__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./DataIterators/CollageDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageDataIterator.js");
/* harmony import */ var _DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _DataIterators_CollageVectorDataIterator__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./DataIterators/CollageVectorDataIterator */ "./sources/pcvizDataAccess/DataIterators/CollageVectorDataIterator.js");
/* harmony import */ var _DataIterators_CollageVectorDataIterator__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_DataIterators_CollageVectorDataIterator__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _DataIterators_WorkspaceLayerGroupDataIterator__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./DataIterators/WorkspaceLayerGroupDataIterator */ "./sources/pcvizDataAccess/DataIterators/WorkspaceLayerGroupDataIterator.js");
/* harmony import */ var _Exporters_ExporterSHP__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./Exporters/ExporterSHP */ "./sources/pcvizDataAccess/Exporters/ExporterSHP.js");
/* harmony import */ var _Exporters_ExporterSHP__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterSHP__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _Exporters_ExporterMaker__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./Exporters/ExporterMaker */ "./sources/pcvizDataAccess/Exporters/ExporterMaker.js");
/* harmony import */ var _Exporters_ExporterMaker__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterMaker__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _Exporters_ExporterGeoJSON__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Exporters/ExporterGeoJSON */ "./sources/pcvizDataAccess/Exporters/ExporterGeoJSON.js");
/* harmony import */ var _Exporters_ExporterGeoJSON__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterGeoJSON__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _Exporters_ExporterKML__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./Exporters/ExporterKML */ "./sources/pcvizDataAccess/Exporters/ExporterKML.js");
/* harmony import */ var _Exporters_ExporterKML__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterKML__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _Exporters_ExporterGML__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./Exporters/ExporterGML */ "./sources/pcvizDataAccess/Exporters/ExporterGML.js");
/* harmony import */ var _Exporters_ExporterGML__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterGML__WEBPACK_IMPORTED_MODULE_27__);
/* harmony import */ var _Exporters_ExporterPTS__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./Exporters/ExporterPTS */ "./sources/pcvizDataAccess/Exporters/ExporterPTS.js");
/* harmony import */ var _Exporters_ExporterPTS__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterPTS__WEBPACK_IMPORTED_MODULE_28__);
/* harmony import */ var _Exporters_ExporterPLY__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./Exporters/ExporterPLY */ "./sources/pcvizDataAccess/Exporters/ExporterPLY.js");
/* harmony import */ var _Exporters_ExporterPLY__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterPLY__WEBPACK_IMPORTED_MODULE_29__);
/* harmony import */ var _Exporters_ExporterXYZ__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./Exporters/ExporterXYZ */ "./sources/pcvizDataAccess/Exporters/ExporterXYZ.js");
/* harmony import */ var _Exporters_ExporterXYZ__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterXYZ__WEBPACK_IMPORTED_MODULE_30__);
/* harmony import */ var _Exporters_ExporterEventLog__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./Exporters/ExporterEventLog */ "./sources/pcvizDataAccess/Exporters/ExporterEventLog.js");
/* harmony import */ var _Exporters_ExporterEventLog__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterEventLog__WEBPACK_IMPORTED_MODULE_31__);
/* harmony import */ var _Exporters_ExporterEventLogExcel__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./Exporters/ExporterEventLogExcel */ "./sources/pcvizDataAccess/Exporters/ExporterEventLogExcel.js");
/* harmony import */ var _Exporters_ExporterEventLogExcel__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterEventLogExcel__WEBPACK_IMPORTED_MODULE_32__);
/* harmony import */ var _Exporters_ExporterWorkflowSettingsTXT__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./Exporters/ExporterWorkflowSettingsTXT */ "./sources/pcvizDataAccess/Exporters/ExporterWorkflowSettingsTXT.js");
/* harmony import */ var _Exporters_ExporterENZ__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./Exporters/ExporterENZ */ "./sources/pcvizDataAccess/Exporters/ExporterENZ.js");
/* harmony import */ var _Exporters_ExporterENZ__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterENZ__WEBPACK_IMPORTED_MODULE_34__);
/* harmony import */ var _Exporters_ExporterNEZ__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./Exporters/ExporterNEZ */ "./sources/pcvizDataAccess/Exporters/ExporterNEZ.js");
/* harmony import */ var _Exporters_ExporterNEZ__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(_Exporters_ExporterNEZ__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var _ExporterRegistry__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./ExporterRegistry */ "./sources/pcvizDataAccess/ExporterRegistry.js");
/* harmony import */ var _ExporterRegistry__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(_ExporterRegistry__WEBPACK_IMPORTED_MODULE_36__);
/* harmony import */ var _Importers_ImporterBase__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./Importers/ImporterBase */ "./sources/pcvizDataAccess/Importers/ImporterBase.js");
/* harmony import */ var _Importers_ImporterBase__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(_Importers_ImporterBase__WEBPACK_IMPORTED_MODULE_37__);
/* harmony import */ var _Importers_XMLBlockImporter__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./Importers/XMLBlockImporter */ "./sources/pcvizDataAccess/Importers/XMLBlockImporter.js");
/* harmony import */ var _Importers_XMLBlockImporter__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(_Importers_XMLBlockImporter__WEBPACK_IMPORTED_MODULE_38__);
/* harmony import */ var _Importers_XMLPhotoScanImporter__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Importers/XMLPhotoScanImporter */ "./sources/pcvizDataAccess/Importers/XMLPhotoScanImporter.js");
/* harmony import */ var _Importers_XMLPhotoScanImporter__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(_Importers_XMLPhotoScanImporter__WEBPACK_IMPORTED_MODULE_39__);
/* harmony import */ var _Importers_CSVImporter__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./Importers/CSVImporter */ "./sources/pcvizDataAccess/Importers/CSVImporter.js");
/* harmony import */ var _Importers_CSVImporter__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(_Importers_CSVImporter__WEBPACK_IMPORTED_MODULE_40__);
/* harmony import */ var _Importers_SimpleCSVImporter__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./Importers/SimpleCSVImporter */ "./sources/pcvizDataAccess/Importers/SimpleCSVImporter.js");
/* harmony import */ var _Importers_SimpleCSVImporter__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(_Importers_SimpleCSVImporter__WEBPACK_IMPORTED_MODULE_41__);
/* harmony import */ var _Importers_Pix4DImporter__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./Importers/Pix4DImporter */ "./sources/pcvizDataAccess/Importers/Pix4DImporter.js");
/* harmony import */ var _Importers_Pix4DImporter__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(_Importers_Pix4DImporter__WEBPACK_IMPORTED_MODULE_42__);
/* harmony import */ var _Importers_EXIFImporter__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./Importers/EXIFImporter */ "./sources/pcvizDataAccess/Importers/EXIFImporter.js");
/* harmony import */ var _Importers_EXIFImporter__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(_Importers_EXIFImporter__WEBPACK_IMPORTED_MODULE_43__);
/* harmony import */ var _ImporterRegistry__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js");
/* harmony import */ var _ImporterRegistry__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(_ImporterRegistry__WEBPACK_IMPORTED_MODULE_44__);
/* harmony import */ var _Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./Uploaders/FileUploader */ "./sources/pcvizDataAccess/Uploaders/FileUploader.js");
/* harmony import */ var _Uploaders_FileUploadHandler__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./Uploaders/FileUploadHandler */ "./sources/pcvizDataAccess/Uploaders/FileUploadHandler.js");
/* harmony import */ var _Uploaders_SinglePartUploadHandler__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./Uploaders/SinglePartUploadHandler */ "./sources/pcvizDataAccess/Uploaders/SinglePartUploadHandler.js");
/* harmony import */ var _Uploaders_MultiPartUploadHandler__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Uploaders/MultiPartUploadHandler */ "./sources/pcvizDataAccess/Uploaders/MultiPartUploadHandler.js");
/* harmony import */ var _Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./Drivers/HTTPMethod */ "./sources/pcvizDataAccess/Drivers/HTTPMethod.js");
/* harmony import */ var _Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(_Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_49__);
/* harmony import */ var _FileBrowser__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./FileBrowser */ "./sources/pcvizDataAccess/FileBrowser.js");
/* harmony import */ var _FileBrowser__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(_FileBrowser__WEBPACK_IMPORTED_MODULE_50__);
/* harmony import */ var _CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./CollageWebFileBrowser */ "./sources/pcvizDataAccess/CollageWebFileBrowser.js");
/* harmony import */ var _CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_51___default = /*#__PURE__*/__webpack_require__.n(_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_51__);
/* harmony import */ var _EntryPoints__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./EntryPoints */ "./sources/pcvizDataAccess/EntryPoints.js");


/** @namespace pcvizDataAccess */
let DataAccess = {};

// Drivers


















DataAccess.Driver = _Drivers_Driver__WEBPACK_IMPORTED_MODULE_0___default.a;
DataAccess.DriverRegistry = _DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a;
DataAccess.BaseDriver = _Drivers_CollageCloud_BaseDriver__WEBPACK_IMPORTED_MODULE_2___default.a;
DataAccess.SpatialDriver = _Drivers_SpatialDriver__WEBPACK_IMPORTED_MODULE_3___default.a;
DataAccess.DataBaseDriver = _Drivers_DataBaseDriver__WEBPACK_IMPORTED_MODULE_4___default.a;
DataAccess.SpatialDataBaseDriver = _Drivers_SpatialDataBaseDriver__WEBPACK_IMPORTED_MODULE_5___default.a;
DataAccess.GeoJSONDriver = _Drivers_GeoJSONDriver__WEBPACK_IMPORTED_MODULE_6___default.a;
DataAccess.CollageCloudDriver = _Drivers_CollageCloudDriver__WEBPACK_IMPORTED_MODULE_7___default.a;
DataAccess.CategoryDriver = _Drivers_CollageCloud_CategoryDriver__WEBPACK_IMPORTED_MODULE_8___default.a;
DataAccess.LayerDriver = _Drivers_CollageCloud_LayerDriver__WEBPACK_IMPORTED_MODULE_9___default.a;
DataAccess.ProjectDriver = _Drivers_CollageCloud_ProjectDriver__WEBPACK_IMPORTED_MODULE_10___default.a;
DataAccess.JobDriver = _Drivers_CollageCloud_JobDriver__WEBPACK_IMPORTED_MODULE_11__["default"];
DataAccess.UAVDriverBase = _Drivers_UAV_UAVDriverBase__WEBPACK_IMPORTED_MODULE_12___default.a;
DataAccess.XMLBlockDriver = _Drivers_UAV_XMLBlockDriver__WEBPACK_IMPORTED_MODULE_13___default.a;
DataAccess.XMLPhotoScanDriver = _Drivers_UAV_XMLPhotoScanDriver__WEBPACK_IMPORTED_MODULE_14___default.a;
DataAccess.CSVDriver = _Drivers_UAV_CSVDriver__WEBPACK_IMPORTED_MODULE_15___default.a;
DataAccess.JobSiteDriver = _Drivers_CollageCloud_JobSiteDriver__WEBPACK_IMPORTED_MODULE_16__["default"];

// Iterators







DataAccess.DataIterator = _DataIterators_DataIterator__WEBPACK_IMPORTED_MODULE_17___default.a;
DataAccess.SpatialDataIterator = _DataIterators_SpatialDataIterator__WEBPACK_IMPORTED_MODULE_18___default.a;
DataAccess.GeoJSONDataIterator = _DataIterators_GeoJSONDataIterator__WEBPACK_IMPORTED_MODULE_19___default.a;
DataAccess.CollageDataIterator = _DataIterators_CollageDataIterator__WEBPACK_IMPORTED_MODULE_20___default.a;
DataAccess.CollageVectorDataIterator = _DataIterators_CollageVectorDataIterator__WEBPACK_IMPORTED_MODULE_21___default.a;
DataAccess.WorkspaceLayerGroupDataIterator = _DataIterators_WorkspaceLayerGroupDataIterator__WEBPACK_IMPORTED_MODULE_22__["default"];

// Exporters















DataAccess.ExporterSHP = _Exporters_ExporterSHP__WEBPACK_IMPORTED_MODULE_23___default.a;
DataAccess.ExporterMaker = _Exporters_ExporterMaker__WEBPACK_IMPORTED_MODULE_24___default.a;
DataAccess.ExporterGeoJSON = _Exporters_ExporterGeoJSON__WEBPACK_IMPORTED_MODULE_25___default.a;
DataAccess.ExporterKML = _Exporters_ExporterKML__WEBPACK_IMPORTED_MODULE_26___default.a;
DataAccess.ExporterGML = _Exporters_ExporterGML__WEBPACK_IMPORTED_MODULE_27___default.a;
DataAccess.ExporterPTS = _Exporters_ExporterPTS__WEBPACK_IMPORTED_MODULE_28___default.a;
DataAccess.ExporterPLY = _Exporters_ExporterPLY__WEBPACK_IMPORTED_MODULE_29___default.a;
DataAccess.ExporterXYZ = _Exporters_ExporterXYZ__WEBPACK_IMPORTED_MODULE_30___default.a;
DataAccess.ExporterEventLog = _Exporters_ExporterEventLog__WEBPACK_IMPORTED_MODULE_31___default.a;
DataAccess.ExporterEventLogExcel = _Exporters_ExporterEventLogExcel__WEBPACK_IMPORTED_MODULE_32___default.a;
DataAccess.ExporterWorkflowSettingsTXT = _Exporters_ExporterWorkflowSettingsTXT__WEBPACK_IMPORTED_MODULE_33__["default"];
DataAccess.ExporterENZ = _Exporters_ExporterENZ__WEBPACK_IMPORTED_MODULE_34___default.a;
DataAccess.ExporterNEZ = _Exporters_ExporterNEZ__WEBPACK_IMPORTED_MODULE_35___default.a;
DataAccess.ExporterRegistry = _ExporterRegistry__WEBPACK_IMPORTED_MODULE_36___default.a;


// importers









DataAccess.ImporterBase = _Importers_ImporterBase__WEBPACK_IMPORTED_MODULE_37___default.a;
DataAccess.XMLBlockImporter = _Importers_XMLBlockImporter__WEBPACK_IMPORTED_MODULE_38___default.a;
DataAccess.XMLPhotoScanImporter = _Importers_XMLPhotoScanImporter__WEBPACK_IMPORTED_MODULE_39___default.a;
DataAccess.CSVImporter = _Importers_CSVImporter__WEBPACK_IMPORTED_MODULE_40___default.a;
DataAccess.SimpleCSVImporter = _Importers_SimpleCSVImporter__WEBPACK_IMPORTED_MODULE_41___default.a;
DataAccess.Pix4DImporter = _Importers_Pix4DImporter__WEBPACK_IMPORTED_MODULE_42___default.a;
DataAccess.EXIFImporter = _Importers_EXIFImporter__WEBPACK_IMPORTED_MODULE_43___default.a;
DataAccess.ImporterRegistry = _ImporterRegistry__WEBPACK_IMPORTED_MODULE_44___default.a;

// Uploaders




DataAccess.FileUploader = _Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_45__["default"];
DataAccess.FileUploadHandler = _Uploaders_FileUploadHandler__WEBPACK_IMPORTED_MODULE_46__["default"];
DataAccess.SinglePartUploadHandler = _Uploaders_SinglePartUploadHandler__WEBPACK_IMPORTED_MODULE_47__["default"];
DataAccess.MultiPartUploadHandler = _Uploaders_MultiPartUploadHandler__WEBPACK_IMPORTED_MODULE_48__["default"];

// Utils

DataAccess.HTTPMethod = _Drivers_HTTPMethod__WEBPACK_IMPORTED_MODULE_49___default.a;





DataAccess.FileBrowser = _FileBrowser__WEBPACK_IMPORTED_MODULE_50___default.a;
DataAccess.CollageWebFileBrowser = _CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_51___default.a;


DataAccess.SiteEntryPoints = _EntryPoints__WEBPACK_IMPORTED_MODULE_52__["SiteEntryPoints"];
DataAccess.MagnetEntryPoints = _EntryPoints__WEBPACK_IMPORTED_MODULE_52__["MagnetEntryPoints"];

/* harmony default export */ __webpack_exports__["default"] = (DataAccess); /**/


/***/ }),

/***/ "./sources/pcvizGIS/Category.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/Category.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Category; });
/* harmony import */ var _VectorLayerUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);





/**
 * Category static methods
 * @memberof pcvizGIS
 */

class Category {

    static findCategoryById( id, node ) {
        if ( node.id === id )
            return node;

        for ( let iChild = 0; iChild < node.nodes.length; iChild++ ) {
            let result = Category.findCategoryById( id, node.nodes[ iChild ] );
            if ( result !== undefined )
                return result;
        }
        return undefined;
    }

    static computeCategoryTree( remoteCategoryList ) {
        Category.FromServer = remoteCategoryList;

        // Feature and Annotation from server
        Category.FEATURE = remoteCategoryList.find( function ( category ) {
            return category.name === _VectorLayerUtils__WEBPACK_IMPORTED_MODULE_0__["default"].Categories.FEATURE && category.systemObject;
        } );
        Category.ANNOTATION = remoteCategoryList.find( function ( category ) {
            return category.name === _VectorLayerUtils__WEBPACK_IMPORTED_MODULE_0__["default"].Categories.ANNOTATION && category.systemObject;
        } );

        let categoryList = remoteCategoryList;
        let categoryTree = [];

        let notAdded = categoryList.length;

        while ( notAdded > 0 ) {
            // add list nodes to tree following inheritance
            for ( let i = 0; i < categoryList.length; i++ ) {
                if ( categoryList[ i ].added )
                    continue;

                // find parent
                let parentNode;
                if ( categoryList[ i ].baseCategory !== null )
                    for ( let iNode = 0; iNode < categoryTree.length; iNode++ ) {
                        parentNode = Category.findCategoryById( categoryList[ i ].baseCategory, categoryTree[ iNode ] );
                        if ( parentNode !== undefined )
                            break;
                    }
                categoryList[ i ].nodes = []; // initialize children
                if ( parentNode !== undefined ) {
                    parentNode.nodes.push( categoryList[ i ] );
                    categoryList[ i ].added = true;
                    notAdded--;
                    continue;
                }
                // no parent
                categoryTree.push( categoryList[ i ] );
                categoryList[ i ].added = true;
                notAdded--;
            }
        }
        return categoryTree;
    }

    static isAnnotation( categoryId ) {
        let category;
        let isAnnotation = false;
        let baseCategory = categoryId;

        function getCategoryById( id ) {
            return Category.FromServer.find( function ( cat ) {
                return cat.id === id;
            } );
        }

        while ( baseCategory && baseCategory !== Category.FEATURE.id ) { // Annotation inherits from Feature
            category = getCategoryById( baseCategory );
            isAnnotation = category.id === Category.ANNOTATION.id;
            baseCategory = category.baseCategory;
        }
        return isAnnotation;
    }


    static createCategory( category ) {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).createCategory( category );
    }

    static updateCategory( category ) {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).updateCategory( category );
    }

    static deleteCategory( categoryID ) {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).deleteCategory( categoryID );
    }

    // get categories as tree from server
    static getCategoryTreeFromServer() {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).getCategoryTreeFromServer();
    }

    // get category list from the server
    static getCategoryListFromServer() {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).getCategoryListFromServer();
    }

    // get system category list from the server
    static getSystemCategoryListFromServer() {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).getSystemCategoryListFromServer();
    }

    // get system category list from the server
    static getSystemCategories() {
        return pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.category' ).getSystemCategories();
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/CollageDataset.js":
/*!********************************************!*\
  !*** ./sources/pcvizGIS/CollageDataset.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CollageDataset; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/Dataset */ "./sources/pcvizGIS/Dataset.js");





/**
 * Defines a subclass of Dataset for PointCloudLayers
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.Dataset
 */
class CollageDataset extends pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_2__["default"] {
    constructor( dataSource ) {
        super( dataSource );
        this._driver = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.layer' );

        this._sourceLayerName = '';
        this._sourceLayerId = -1;

        this._dataIterator = undefined;

    }

    setSourceLayerName( name ) {
        this._sourceLayerName = name;
    }

    setSourceLayerId( id ) {
        this._sourceLayerId = id;
    }

    open() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;

        function resolve( iterator ) {
            self._dataIterator = iterator;
            var result = self.initializeDataset( self._dataIterator );
            if ( result === undefined ) {
                console.log( 'CollageDataset.open: Error initializing the dataset' );
                defer.reject();
            } else {
                result.dataIterator = iterator;
                defer.resolve( result );
            }
        }

        this.openDriver().then( function ( open ) {

            if ( open ) {
                if ( self._dataIterator !== undefined ) {
                    resolve( self._dataIterator );
                    return defer.promise;
                }
                // We call ever to getSourceLayer.  this._sourceLayerId should be different than -1.
                self._driver.getSourceLayerById( self._sourceLayerId ).then( function ( iterator ) {
                    resolve( iterator );
                } ).catch( function ( response ) {
                    defer.reject( response );
                } );
            } else {
                console.log( 'CollageDataset.open: Error opening the dataset' );
                defer.reject();
            }

        } ).catch( function () {
            console.log( 'CollageDataset.open: Exception opening the dataset' );
            defer.reject();
        } );

        return defer.promise;
    }

    initializeDataset( /*dataIterator*/) {
        console.log( 'CollageDataset.initializeCollageDataset: not implemented' );
        return undefined;
    }

    close() {
        return this.closeDriver();
    }

    init() {
        return this.initDriver();
    }

    // For PointClouds or RasterLayers, you must call this method without 'filter'
    getDataIterator( filter ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        if ( filter ) {
            // We check that hasFilter function exists because CollagDataIterator doesn't have this function
            if ( this._dataIterator.hasFilter && this._dataIterator.hasFilter( filter ) ) {
                var cloned = this._dataIterator.clone();
                cloned.setByFilter( filter ); // If the iterator has the hasFilter function, it should have the setByFilter function 

                cloned.reset();

                defer.resolve( cloned );
            } else
                self._driver.getSourceLayerById( self._sourceLayerId, filter ).then( function ( iterator ) {
                    self._dataIterator._geoJSONDataIterators.set( JSON.stringify( filter ), iterator._geoJSONDataIterator );
                    self.initializeDataset( iterator );
                    defer.resolve( iterator );
                } );
        } else {
            // We need to reset each time the data iterator is requested as if it was a "new one"
            // Problem is behaviour must be the same on both cases, filtering or using the cached one
            this._dataIterator.reset();
            defer.resolve( this._dataIterator );
        }
        return defer.promise;
    }

    hasDataIterator() {
        return !!this._dataIterator;
    }

    getId() {
        if ( !this._dataIterator )
            return this._sourceLayerId;
        return this._dataIterator.getId();
    }

    getLayerObject() {
        return this._dataIterator.getLayerObject();
    }

    getMinX() {
        return this._dataIterator.getMinX();
    }

    getMaxX() {
        return this._dataIterator.getMaxX();
    }

    getMinY() {
        return this._dataIterator.getMinY();
    }

    getMaxY() {
        return this._dataIterator.getMaxY();
    }

    getMinZ() {
        return this._dataIterator.getMinZ();
    }

    getMaxZ() {
        return this._dataIterator.getMaxZ();
    }

    getType() {
        return this._dataIterator.getType();
    }

    getCategory() {
        return this._dataIterator.getCategory();
    }


    getConfiguration() {
        return this._dataIterator.getConfiguration();
    }

    getConfigurationAttribute( name ) {
        return this._dataIterator.getConfigurationAttribute( name );
    }

    setConfiguration( config ) {
        // FIXME: Why da.project?
        var layer = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.project' ).getLayerByIndex( pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.project' ).getLayerIndexById( this._sourceLayerId ) );
        if ( layer )
            layer.userConfiguration = config;
        this._dataIterator.setConfiguration( config );
    }

    setConfigurationAttribute( name, value ) {
        this._dataIterator.setConfigurationAttribute( name, value );
    }

    getStyle() {
        var style;
        var config = this.getConfiguration();
        if ( config !== undefined && config.style !== undefined )
            style = config.style.symbolizers;
        return style;
    }

    setStyle( style ) {
        var config = this.getConfiguration();
        config.style.symbolizers = style;
        this.setConfiguration( config );
    }

    /**
     * Sets the value of an attribute.
     * @method
     * @memberof pcvizGIS.PointCloudDataset
     * @param {string} name  The attribute name.
     * @param {any} value The attribute value.
     */
    setAttribute( name, value ) {
        this._dataIterator.setAttribute( name, value );
    }

    /**
     * Gets the value of an attribute
     * @method
     * @memberof pcvizGIS.PointCloudDataset
     * @param  {string} name The attribute name.
     * @return {any}      The attribute value.
     */
    getAttribute( name ) {
        return this._dataIterator.getAttribute( name );
    }

    /**
     * This function commits the changes to the database.
     * @method
     * @memberof pcvizGIS.CollageDataset
     * @return {Promise} The promise from the driver.
     */
    commitChanges() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var promises = [];

        if ( Object.keys( this._dataIterator.getDirtyAttributes() ).length )
            promises.push( this._driver.updateSourceLayer( this._dataIterator ) );
        if ( this._dataIterator.isConfigurationDirty() )
            promises.push( this._driver.updateLayerConfiguration( this._dataIterator.getConfiguration(), this._dataIterator.getLayerObject().id )
                /*.then( function ( configuration ) {
                               self.setStyle( configuration.style.symbolizers );  THIS DOES NOT SEEM NECESSARY and IT OVERWRITES LOCAL REFERENCES TO STYLES IN LAYER PROPERTIES
                           } ) */
            );

        if ( promises.length <= 0 ) {
            defer.resolve();
            return defer.promise;
        }

        Promise.all( promises ).then( function () {
            defer.resolve();
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/Curve.js":
/*!***********************************!*\
  !*** ./sources/pcvizGIS/Curve.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Curve; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js");
/* harmony import */ var pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js");





/**
 * Implements a Curve geometry.
 * @class
 * @memberof pcvizGIS
 * @extends Geometry
 */
class Curve extends pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();
        this._points = [];
        this._transformedPoints = [];
        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].CURVE;
    }


    getNumPoints() {
        return this._points.length;
    }

    // PAY ATTENTION: If you use this function, you will have a Point Geometry with the correct coordinates of the relative point in this Curve.
    // But, if you modify the Point object, the coordinates in this Curve won't be modified. So, to modify the points of this Curve use the setters, please.
    getPoint( i ) {
        // check that points[ i ] exists
        if ( i >= 0 && i < this.getNumPoints() ) {
            var p = new pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_2__["default"]();
            p.setXYZM( this._points[ i ] );
            return p;
        }
    }

    getX( i ) {
        // check that points[ i ] exists
        if ( i >= 0 && i < this.getNumPoints() )
            return this._points[ i ][ 0 ];
        else
            return 0.0;
    }

    getY( i ) {
        // check that points[ i ] exists
        if ( i >= 0 && i < this.getNumPoints() )
            return this._points[ i ][ 1 ];
        else
            return 0.0;
    }

    getZ( i ) {
        // check that points[ i ] exists
        if ( i >= 0 && i < this.getNumPoints() )
            return this._points[ i ][ 2 ];
        else
            return 0.0;
    }

    getM( i ) {
        // check that points[ i ] exists
        if ( i >= 0 && i < this.getNumPoints() )
            return this._points[ i ][ 3 ];
        else
            return 0.0;
    }

    // Setters
    setX( i, value ) {
        this._points[ i ][ 0 ] = value;
    }

    setY( i, value ) {
        this._points[ i ][ 1 ] = value;
    }

    setZ( i, value ) {
        this._points[ i ][ 2 ] = value;
    }

    setM( i, value ) {
        this._points[ i ][ 3 ] = value;
    }

    /**
     * Add a point at the end of the curve.
     * @method
     * @memberof pcvizGIS.Curve
     * @param {pcvizGIS.Point} point the point to be added
     */
    addPoint( point ) {
        this._points.push( point.getXYZM() );
        this._transformedPoints.push( [] );
        this.dirtyEnvelope();
    }

    /**
     * Insert a point at the specific position in the curve
     * @method
     * @memberof pcvizGIS.Curve
     * @param  {pcvizGIS.Point} point the point to be added
     * @param  {integer} i     the position
     */
    insertPoint( point, i ) {
        this._points.splice( i, 0, point.getXYZM() );
        this._transformedPoints.splice( i, 0, [] );
        this.dirtyEnvelope();
    }

    addPointFromCoordinates( x, y, z, m ) {
        this._points.push( [ x, y, z, m ] );
        this._transformedPoints.push( [] );
        this.dirtyEnvelope();
    }

    removeLastPoint() {
        this._points.pop();
        this._transformedPoints.pop();
        this.dirtyEnvelope();
    }

    removePointAt( position ) {
        this._points.splice( position, 1 );
        this._transformedPoints.splice( position, 1 );
        this.dirtyEnvelope();
    }

    getDimension() {
        return 1;
    }

    length() {}

    valueAt( /* distance */) {}

    reversePoints() {
        for ( var i = 0; i < this.getNumPoints() / 2; i++ ) {
            var point = [];
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._points[ i ], point );

            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._points[ this.getNumPoints() - i - 1 ], this._points[ i ] );
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( point, this._points[ this.getNumPoints() - i - 1 ] );
        }
    }

    /**
     * Checks if a curve is closed. A curve is closed if its first point is
     * equal to its end point.
     * @method
     * @memberof pcvizGIS.Curve
     * @return {boolean} TRUE if curve is closed, else FALSE
     */
    isClosed() {
        if ( this.getNumPoints() > 3 && this._points[ 0 ][ 0 ] === this._points[ this.getNumPoints() - 1 ][ 0 ] &&
            this._points[ 0 ][ 1 ] === this._points[ this.getNumPoints() - 1 ][ 1 ] &&
            this._points[ 0 ][ 2 ] === this._points[ this.getNumPoints() - 1 ][ 2 ] ) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Returns if a (closed) curve forms a convex shape.
     * @method
     * @memberof pcvizGIS.Curve
     * @return {boolean} true if the curve forms a convex shape, else false
     */
    isConvex() {
        var convex = true;
        var p1 = [],
            p2 = [],
            p3 = [];
        var positive = false;
        var negative = false;

        if ( this.getNumPoints() >= 2 ) {
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._points[ 0 ], p1 );
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._points[ 1 ], p2 );
            var i = 2;
            while ( i < this.getNumPoints() ) {
                pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._points[ i ], p3 );

                var crossproduct = ( p2[ 0 ] - p1[ 0 ] ) * ( p3[ 1 ] - p2[ 1 ] ) -
                    ( p2[ 1 ] - p1[ 1 ] ) * ( p3[ 0 ] - p2[ 0 ] );

                if ( crossproduct > 0 ) {
                    positive = true;
                }
                if ( crossproduct < 0 ) {
                    negative = true;
                }
                if ( positive && negative ) {
                    convex = false;
                    break;
                }

                pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( p2, p1 );
                pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( p3, p2 );

                i++;
            }
        }
        return convex;
    }

    //TODO
    curveToLineString() {}

    clone() {}

    /**
     * Copy the curve passed to this curve.
     * @param  {Curve} curve the curve (or an object that inherits from this class) to be copied in this curve (or object that inherits from this class)
     * @method
     * @memberof pcvizGIS.Curve
     */
    copy( curve ) {
        pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.copy.call( this, curve );

        this._points = [];
        this._transformedPoints = [];
        for ( var p = 0; p < curve._points.length; p++ ) {
            this._points[ p ] = curve._points[ p ].slice( 0 );
            this._transformedPoints.push( [] );
        }
    }

    clear() {
        this._points = [];
        this._transformedPoints = [];
        this.dirtyEnvelope();
    }

    // The 'selected' property field is used to highlight the selected vertex
    changeSelectedPropertyField( vertex ) {
        this.changePropertyField( 'curvePoints', 'selected', vertex );
    }

    initializePropertySet() {
        var self = this;
        var transformedPoint = [];

        this.clearProperties();

        this.addPropertyField( {
            id: 'curvePoints',
            label: 'VECTOR_LAYER_PROPERTIES.POINTS',
            type: 'PointArrayField',
            selected: self.getSelectedVertex(),
            editable: function () {
                return self._isEditable;
            },
            get: function () {
                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() )
                    return self._points;

                var crsData = this.prepareCRS( layer, project );

                for ( var i = 0; i < self.getNumPoints(); i++ ) {
                    self._transformPoint( transformedPoint, self._points[ i ], self._transformedPoints[ i ], crsData );
                }

                return self._transformedPoints;
            },
            set: function ( value, index ) {
                // FIXME: This way to set a vertex must be changed when vertex edition branch
                // is merged into master because it implements methods to set its points.
                // Below it is set (temporarily) accessing directly to curve properties.

                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() ) {
                    self._points[ index ][ 0 ] = value[ 0 ];
                    self._points[ index ][ 1 ] = value[ 1 ];
                    self._points[ index ][ 2 ] = value[ 2 ];
                } else {
                    var crsData = this.prepareCRS( layer, project );
                    crsData.addGeoid = true; // revert geoid correction
                    self._transformPoint( transformedPoint, value, self._points[ index ], crsData );
                }

                if ( self._geometryEditedCallback )
                    self._geometryEditedCallback();
            },
            isDirty: function () {
                if ( !self._isEditable )
                    return self._dirty[ 'curvePoints' ];
                else
                    return true;
            }
        } );
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/DataCacheObject.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/DataCacheObject.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataCacheObject; });


class DataCacheObject {
    constructor() {
        this._workspaceObj = undefined;
        this._layerGroupObj = undefined;
        this._osgNodeObj = undefined;
    }

    /**
     * Set WorkspaceObj
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @param {Object} obj the workspaceObject to be set
     */
    setWorkspaceObj( obj ) {
        this._workspaceObj = obj;
    }

    /**
     * Get WorkspaceObj
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @return {Object} the WorkspaceObj
     */
    getWorkspaceObj() {
        return this._workspaceObj;
    }

    /**
     * Set TocObjNode
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @param {Object} obj the LayerGroupObject to be set
     */
    setLayerGroupObj( obj ) {
        this._layerGroupObj = obj;
    }

    /**
     * Get TocObjNode
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @return {Object} the TocObjNode
     */
    getLayerGroupObj() {
        return this._layerGroupObj;
    }

    /**
     * Set OsgNodeObj
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @param {Object} obj the osg.Node instance to be set
     */
    setOsgNodeObj( obj ) {
        this._osgNodeObj = obj;
    }

    /**
     * Get OsgNodeObj
     * @method
     * @memberof pcvizGIS.DataCacheObject
     * @return {Object} the osg.Node instance
     */
    getOsgNodeObj() {
        return this._osgNodeObj;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/DataSource.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/DataSource.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return DataSource; });


/**
 * Defines the connection information for a specific source of data 
 * @class
 * @memberof pcvizGIS
 * @property {string} _uri the uri where is the source of data
 * @property {string} _driverId the id of the driver used to get the data
 */
class DataSource {
    constructor( uri, driverId ) {
        this._uri = ( uri !== undefined ) ? uri : '';
        this._driverId = ( driverId !== undefined ) ? driverId : '';

        this._user = undefined;
        this._password = undefined;
    }

    //Getters

    getURI() {
        return this._uri;
    }

    getDriverId() {
        return this._driverId;
    }

    getUser() {
        return this._user;
    }

    getPassword() {
        return this._password;
    }

    setCredentials( user, pass ) {
        this._user = user;
        this._password = pass;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Dataset.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/Dataset.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Dataset; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);



/**
 * Specifies an abstract class whose objects can be configured for iterating/accessing the data.
 * @class
 * @memberof pcvizGIS
 */
class Dataset {
    constructor( dataSource ) {
        this._dataSource = dataSource;
        this._driver = undefined;

        this._srs = undefined;
        this._extent = undefined;
        this._dirty = true;
    }

    // Abstract methods
    open() {}

    close() {}

    init() {}

    // Methods that aren't implemented: getSpatialReference, setSpatialReference, getExtent, setExtent, setMetadata, getMetadata

    // Getters and setters
    getDriver() {
        return this._driver;
    }

    getDataSource() {
        return this._dataSource;
    }

    getDataSourceURI() {
        return this._dataSource.getURI();
    }

    setDirty( value ) {
        this._dirty = value;
    }

    isDirty() {
        return this._dirty;
    }

    // Methods that aren't implemented: providerOpened

    /**
     * Method to open the driver connection
     * @method
     * @memberof pcvizGIS.Dataset
     * @return {Promise} true if is open, else false
     */
    openDriver() {

        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();

        if ( this._driver === undefined ) {
            console.log( 'Driver not initialized' );
            defer.resolve( false );
            return defer.promise;
        }
        if ( this._driver.isOpen() && !this.isDirty() ) {
            defer.resolve( true );
            return defer.promise;
        }

        var bOk = this.init();

        var self = this;
        this._driver.open( this._dataSource.getURI() ).then( function () {
            if ( !self._driver.isOpen() ) {
                console.log( 'Unable to open datasource ' + self._dataSource.getURI() );
                defer.resolve( false );
            } else
                defer.resolve( bOk );
        } ).catch( function ( error ) {
            defer.reject( error );
        } );

        return defer.promise;
    }

    /**
     * Method to close the driver connection
     * @method
     * @memberof pcvizGIS.Dataset
     * @return {boolean} true if the driver connection is closed or false if there aren't any driver
     */
    closeDriver() {
        if ( this._driver === undefined ) {
            console.log( 'Driver not initialized' );
            return false;
        }
        if ( this._driver.isOpen() ) {
            this._driver.close(); // I think this method isn't implemented.
            this._dirty = true;
        }
        return true;
    }

    /**
     * Method to initialize the driver
     * @method
     * @memberof pcvizGIS.Dataset
     * @return {boolean} true if is init, else false
     */
    initDriver() {
        if ( !this.isDirty() )
            return true;

        this.setDirty( false );

        if ( this._driver === undefined ) {
            console.log( 'Driver not initialized' );
            return false;
        }

        // setProviderSpatialReference( _srs ); // This method isn't implemented.

        return true;
    }

    /**
     * Sets the value of an attribute.
     * *This must be implemented by the classes that inherit from `Dataset`.*
     * @abstract
     * @method
     * @memberof pcvizGIS.Dataset
     * @param {string} name  The attribute name.
     * @param {any} value The attribute value.
     */
    setAttribute( /*name, value */) {
        console.log( 'setAttribute not implemented ' );
        return undefined;
    }

    /**
     * Gets the value of an attribute
     * *This must be implemented by the classes that inherit from `Dataset`.*
     * @abstract
     * @method
     * @memberof pcvizGIS.Dataset
     * @param  {string} name The attribute name.
     * @return {any}      The attribute value.
     */
    getAttribute( /* name */) {
        console.log( 'getAttribute not implemented ' );
        return undefined;
    }

    /**
     * This function commits the changes to the database.
     * *This must be implemented by the classes that inherit from `Dataset`.*
     * @abstract
     * @method
     * @memberof pcvizGIS.Dataset
     * @return {Promise} The promise from the driver.
     */
    commitChanges() {
        console.log( 'commit Changes not implemented ' );
        return undefined;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Envelope.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/Envelope.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Envelope; });
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);



/**
 * Defines an envelope structure
 * @class
 * @memberof pcvizGIS
 */
class Envelope {
    constructor( minX, maxX, minY, maxY, minZ, maxZ ) {
        this._minX = ( minX !== undefined ) ? minX : 0;
        this._maxX = ( maxX !== undefined ) ? maxX : 0;
        this._minY = ( minY !== undefined ) ? minY : 0;
        this._maxY = ( maxY !== undefined ) ? maxY : 0;
        this._minZ = ( minZ !== undefined ) ? minZ : 0;
        this._maxZ = ( maxZ !== undefined ) ? maxZ : 0;
    }

    // Setters and Getters

    setMinX( minX ) {
        this._minX = minX;
    }

    getMinX() {
        return this._minX;
    }

    setMaxX( maxX ) {
        this._maxX = maxX;
    }

    getMaxX() {
        return this._maxX;
    }

    setMinY( minY ) {
        this._minY = minY;
    }

    getMinY() {
        return this._minY;
    }

    setMaxY( maxY ) {
        this._maxY = maxY;
    }

    getMaxY() {
        return this._maxY;
    }

    setMinZ( minZ ) {
        this._minZ = minZ;
    }

    getMinZ() {
        return this._minZ;
    }

    setMaxZ( maxZ ) {
        this._maxZ = maxZ;
    }

    getMaxZ() {
        return this._maxZ;
    }

    /**
     * Update this envelope merging it with the passed envelope.
     * @method
     * @memberof  pcvizGIS.Envelope
     * @param  {Envelope} other the other envelope that is going to be merged with this envelope
     */
    merge( other ) {
        if ( this.isValid() ) {
            this._minX = Math.min( this._minX, other.getMinX() );
            this._maxX = Math.max( this._maxX, other.getMaxX() );
            this._minY = Math.min( this._minY, other.getMinY() );
            this._maxY = Math.max( this._maxY, other.getMaxY() );
            this._minZ = Math.min( this._minZ, other.getMinZ() );
            this._maxZ = Math.max( this._maxZ, other.getMaxZ() );
        } else {
            this._minX = other.getMinX();
            this._maxX = other.getMaxX();
            this._minY = other.getMinY();
            this._maxY = other.getMaxY();
            this._minZ = other.getMinZ();
            this._maxZ = other.getMaxZ();
        }
    }

    /**
     * Check if the envelope has some component value different than the default value.
     * @method
     * @memberof  pcvizGIS.Envelope
     * @return  {boolean} return if the envelope has some component value different than the default value
     */
    isValid() {
        return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._minX ) || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._minY ) || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._maxX ) || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._maxY ) || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._minZ ) || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.isNotZero( this._maxZ );
    }

    /**
     * Reset the envelope setting all the components to the default value
     * @method
     * @memberof pcvizGIS.Envelope
     */
    clear() {
        this._minX = 0;
        this._maxX = 0;
        this._minY = 0;
        this._maxY = 0;
        this._minZ = 0;
        this._maxZ = 0;
    }

    /**
     * Copy the envelope passed to this envelope.
     * @param  {Envelope} other the envelope to be copied in this envelope
     * @method
     * @memberof pcvizGIS.Envelope
     */
    copy( other ) {
        this._minX = other.getMinX();
        this._maxX = other.getMaxX();
        this._minY = other.getMinY();
        this._maxY = other.getMaxY();
        this._minZ = other.getMinZ();
        this._maxZ = other.getMaxZ();
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/Expression.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/Expression.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Expression; });


/**
 * Interface for Expression
 * @class
 * @memberof pcvizGIS
 */
class Expression {

    static evaluateExpression( expression, feature ) {
        if ( !expression )
            return undefined;

        if ( expression.constant !== undefined )
            return expression.constant;

        if ( expression.field ) { // chose access to attributes for Map or 3D features
            if ( expression.field === 'Id' )
                return feature.getId ? feature.getId() : feature.id;
            return feature.getAttributeByName ? feature.getAttributeByName( expression.field ) :
                ( feature.getProperties ? feature.getProperties()[ expression.field ] : feature[ expression.field ] );
        }

        var left, right;
        if ( expression.aritmOp ) {
            left = this.evaluateExpression( expression.leftExp, feature );
            if ( left === undefined )
                return undefined;
            right = this.evaluateExpression( expression.rightExp, feature );
            if ( right === undefined )
                return undefined;
            if ( left === false || left === null ) // zero values are interpreted as false
                left = 0;
            if ( right === false || right === null )
                right = 0;

            switch ( expression.aritmOp ) {
            case '=':
                return ( left === right );
            case '!=':
                return ( left !== right );
            case '<':
                return ( left < right );
            case '>':
                return ( left > right );
            case '<=':
                return ( left <= right );
            case '>=':
                return ( left >= right );
            case '+':
                return ( left + right );
            case '--':
                return ( left - right );
            case '*':
                return ( left * right );
            case '/':
                return ( left / right );
            case '~': // 'left' contains substring 'right'
                return ( left.toString().toLowerCase().indexOf( right.toString().toLowerCase() ) !== -1 );
            case 'IN': // 'right' array contains item 'left'
                return right.toString().split( ',' ).map( function ( item ) {
                    return parseInt( item );
                } ).includes( left );
            }
        }

        if ( expression.logicOp ) {
            left = this.evaluateExpression( expression.leftExp, feature );
            if ( left === undefined && expression.logicOp !== '!' )
                return undefined;
            right = this.evaluateExpression( expression.rightExp, feature );
            if ( right === undefined )
                return undefined;

            switch ( expression.logicOp ) {
            case '!':
                return ( !right );
            case '&':
                return ( left && right );
            case '|':
                return ( left || right );
            }
        }

        return false;
    }

    static expressionToString( expression ) {
        if ( !expression )
            return '';

        if ( expression.constant !== undefined )
            return expression.constant.toString();

        if ( expression.field ) // chose access to attributes for Map or 3D features
            return '[' + expression.field + ']';

        var left = this.expressionToString( expression.leftExp );
        var right = this.expressionToString( expression.rightExp );

        if ( left === 'Invalid' || right === 'Invalid' )
            return 'Invalid';

        var outText = '';
        if ( expression.aritmOp ) {
            if ( expression.leftExp ) {
                outText = left + ' ';
            }
            outText += expression.aritmOp + ' ';
            outText += right;
        }

        if ( expression.logicOp ) {
            if ( expression.leftExp ) {
                outText = left + ' ';
            }
            outText += expression.logicOp;
            outText += ' ';
            outText += right;
        }

        if ( outText.length > 0 )
            return outText;

        return 'Invalid';
    }

    static stringToExpression( text ) {
        // limited parsing for simple expressions
        var expr;
        var self = this;

        // first, check logical operators
        var pos;
        var logicOps = [ '!', '&', '|' ];
        for ( var iOp = 0; iOp < logicOps.length; iOp++ ) {
            pos = text.indexOf( logicOps[ iOp ] );
            if ( pos !== -1 && ( iOp !== 0 || pos !== text.indexOf( '!=' ) ) ) { // avoid confusion with '!='
                expr = {
                    logicOp: logicOps[ iOp ]
                };
                return self.splitExpression( expr, text, pos, logicOps[ iOp ].length, iOp === 0 );
            }
        }

        // then comparison operators
        var compOps = [ '!=', '<=', '>=', '=', '<', '>', '~', 'IN' ];
        for ( iOp = 0; iOp < compOps.length; iOp++ ) {
            pos = text.indexOf( compOps[ iOp ] );
            if ( pos !== -1 ) {
                expr = {
                    aritmOp: compOps[ iOp ]
                };
                return self.splitExpression( expr, text, pos, compOps[ iOp ].length, false );
            }
        }

        var aritOps = [ '+', '--', '*', '/' ];
        for ( iOp = 0; iOp < aritOps.length; iOp++ ) {
            pos = text.indexOf( aritOps[ iOp ] );
            if ( pos !== -1 ) {
                expr = {
                    aritmOp: aritOps[ iOp ]
                };
                return self.splitExpression( expr, text, pos, aritOps[ iOp ].length, false );
            }
        }

        // atomic expression
        pos = text.indexOf( '[' );
        if ( pos !== -1 ) { // detected beginning of field name
            var pos2 = text.indexOf( ']' );
            if ( pos2 !== -1 && pos2 > pos ) { // detected end of field name
                return {
                    field: text.substring( pos + 1, pos2 ).trim()
                };
            }
            return undefined;
        }

        // constant expression
        var constantStr = text.trim();
        if ( constantStr === '' )
            return undefined;

        if ( constantStr === 'true' )
            return {
                constant: true
            };
        if ( constantStr === 'false' )
            return {
                constant: false
            };

        var num = Number( constantStr ); // try parsing a number
        if ( !isNaN( num ) )
            return {
                constant: num
            };

        // otherwise, return as string
        return {
            constant: constantStr
        };
    }

    static splitExpression( expr, text, pos, opLength, rightOnly ) {
        var rightExp = this.stringToExpression( text.substring( pos + opLength, text.length ) );
        if ( !rightExp )
            return undefined;
        expr.rightExp = rightExp;
        if ( rightOnly )
            return expr;

        var leftExp = this.stringToExpression( text.substring( 0, pos ) );
        if ( !leftExp )
            return undefined;
        expr.leftExp = leftExp;

        return expr;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Feature.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/Feature.js ***!
  \*************************************/
/*! exports provided: Feature, FeatureIterator */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Feature", function() { return Feature; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FeatureIterator", function() { return FeatureIterator; });
/* harmony import */ var pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js");
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__);









/**
 * Defines a Feature object with its attributes (including geometry)
 * @class
 * @memberof pcvizGIS
 */
class Feature extends pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2___default.a {
    constructor( layer ) {
        super();

        this._attributes = [];
        this._geometry = undefined;
        this._expandingGeometry = false;
        this._id = -1;
        this._layer = ( layer !== undefined ) ? layer : undefined;

        this._editMode = false; // When this flag is true, not commit changes

        this.setUpdateCallback( this.commitChanges );

        this._invisibleProperties = [];
    }


    // Setters and Getters

    setGeometry( geometry ) {
        // var i = this._layer.getFeatureDefinition().getGeomFieldIndex();
        // this._attributes[ i ] = geometry;
        this._geometry = geometry;
    }

    getGeometry() {
        // var i = this._layer.getFeatureDefinition().getGeomFieldIndex();
        // return this._attributes[ i ];
        return this._geometry;
    }

    /*
     * Get the value of the field in position 'i'
     * @method
     * @memberof pcvizGIS.Feature
     * @param  {int} i the number of the field to be gotten
     * @return {}   the value of the attribute
     */
    getAttribute( i ) {
        return this._attributes[ i ];
    }

    /*
     * Set the value of the field in position 'i'
     * @method
     * @memberof pcvizGIS.Feature
     * @param {int} i     the number of the field to be set
     * @param {} value the value to be assigned to the attribute
     */
    setAttribute( i, value ) {
        this._attributes[ i ] = value;
    }

    getNumAttributes() {
        return this._attributes.length;
    }

    setAttributes( attributes ) {
        this._attributes = attributes;
    }

    getAttributes() {
        return this._attributes;
    }

    getId() {
        return this._id;
    }

    setId( id ) {
        this._id = id;
    }

    setAttributeByName( name, value ) {
        var i = this._layer.getFeatureDefinition().getFieldIndex( name );
        this._attributes[ i ] = value;
    }

    setAttributesByNameArray( nameArray, valueArray ) {
        for ( let i = 0; i < nameArray.length; i++ ) {
            this.setAttributeByName( nameArray[ i ], valueArray[ i ] );
        }
    }

    getAttributeByName( name ) {
        var i = this._layer.getFeatureDefinition().getFieldIndex( name );
        return this._attributes[ i ];
    }

    getLayer() {
        return this._layer;
    }

    getLayerId() {
        return this._layer.getId();
    }

    getLayerCategory() {
        return this._layer.getCategory();
    }

    setLayer( layer ) {
        this._layer = layer;
    }

    enableEditMode() {
        this._editMode = true;
    }

    setEditableGeometry( isEditableGeometry ) {
        this._geometry.setEditable( isEditableGeometry );
    }

    disableEditMode() {
        this._editMode = false;
        this._geometry.setEditable( false );
    }

    isEnabledEditMode() {
        return this._editMode;
    }

    /**
     * Copy the feature passed to this feature.
     * @param  {Feature} f the feature to be copied in this feature
     * @method
     * @memberof pcvizGIS.Feature
     */
    copy( f ) {
        this._id = f._id;

        if ( this._geometry === undefined )
            this._geometry = f._geometry.clone();
        else
            this._geometry.copy( f._geometry );

        this._layer = f._layer;
        for ( var i = 0; i < f.getAttributes().length; i++ )
            this._attributes[ i ] = f.getAttributes()[ i ];
    }

    /*
     * Private method for configuring the PropertyField of the feature definition attribute defined of index 'i'
     * @method
     * @memberof pcvizGIS.Feature
     * @param {int} i     the number of the field to be configured
     */
    _addFeatureDefinitionPropertyFieldByIndex( i, isControlPoint ) {
        var featureDefinition = this._layer.getFeatureDefinition();

        var self = this;
        this.addPropertyField( {
            id: featureDefinition.getFieldName( i ).toLowerCase(),
            label: isControlPoint && this.isCoordinateField( featureDefinition.getFieldName( i ) ) ? `${featureDefinition.getFieldName( i )}_CONTROLPOINT` : featureDefinition.getFieldName( i ),
            type: featureDefinition.getFieldType( i ),
            get: function () {
                if ( ( featureDefinition.getFieldName( i ) !== 'centroid(x)' && featureDefinition.getFieldName( i ) !== 'centroid(y)' && featureDefinition.getFieldName( i ) !== 'centroid(z)' ) || ( self.getAttributeByName( featureDefinition.getFieldName( i ) ) === undefined ) )
                    return self.getAttributeByName( featureDefinition.getFieldName( i ) );
                else {
                    // If it is a centroid value and its value is not undefined, we try to reproject the value
                    var layer = self.getLayer();
                    var project = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getController( 'Application' ).getApplication().getProject();
                    if ( !layer.getProjection() || !project.getProjection() )
                        return self.getAttributeByName( featureDefinition.getFieldName( i ) );


                    var p = new pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_0__["default"]( self.getAttributeByName( 'centroid(x)' ), self.getAttributeByName( 'centroid(y)' ), self.getAttributeByName( 'centroid(z)' ) );
                    var crsData = p.prepareCRS( layer, project );
                    var transformedPoint = [];
                    p._transformPoint( transformedPoint, p._xyzm, transformedPoint, crsData );


                    if ( featureDefinition.getFieldName( i ) === 'centroid(x)' )
                        return transformedPoint[ 0 ];
                    if ( featureDefinition.getFieldName( i ) === 'centroid(y)' )
                        return transformedPoint[ 1 ];
                    if ( featureDefinition.getFieldName( i ) === 'centroid(z)' )
                        return transformedPoint[ 2 ];
                }
            },
            set: function ( value ) {
                self.setAttributeByName( featureDefinition.getFieldName( i ), value );
            },
            visible: function () {
                var find = self._invisibleProperties.find( element => {
                    const property = self.getProperties()[ i ];
                    const isFound = property ? element === property.field : false;
                    return isFound;
                } );
                if ( find )
                    return false;

                return featureDefinition.getFieldValue( i, 'visible' );
            },
            editable: function () {
                return featureDefinition.getFieldValue( i, 'editable' ) || self.getId() === -1;
            },
            order: featureDefinition.getFieldValue( i, 'order' ),
            isDirty: function () {
                if ( self.getId() !== -1 && !self._editMode )
                    return self._dirty[ featureDefinition.getFieldName( i ).toLowerCase() ];
                else
                    return true;
            },
            convertUnit: function () {
                return pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isAutomaticAttributeMeasure( featureDefinition, i ) && self.getAttributeByName( featureDefinition.getFieldName( i ) ) !== undefined;
            },
            unitType: featureDefinition.getFieldName( i ) === 'area' ? 'area' : 'distance',
            translate: featureDefinition.getFieldName( i ).toLowerCase() === 'targettype'
        } );
    }

    initializePropertySet() {
        this.clearProperties();

        const isImage = ( this.getLayerCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.PLANAR_IMAGE || this.getLayerCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.PANORAMA );
        const isControlPoint = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isControlPoint( this.getLayerCategory() );

        // Iterate over the feature definition to show the values on the property bag
        var featureDefinition = this._layer.getFeatureDefinition();
        if ( featureDefinition ) {
            for ( var i = 0, j = featureDefinition.getNumFields(); i < j; i++ ) {
                if ( !this.isSphereFieldVisible( featureDefinition.getFieldName( i ) ) ) continue;

                if ( this.hasBadSurfaceValue( featureDefinition, i ) ) continue;

                if ( !isImage || featureDefinition.getFieldName( i ) === 'file_name' || featureDefinition.getFieldName( i ) === 'sequence_id' || featureDefinition.getFieldName( i ) === 'frame_id' )
                    this._addFeatureDefinitionPropertyFieldByIndex( i, isControlPoint );
            }
        }

        var self = this;
        this.addPropertyField( {
            id: 'geometry',
            label: 'VECTOR_LAYER_PROPERTIES.GEOMETRY',
            type: 'GeometryField',
            expanded: self._expandingGeometry,
            editable: function () {
                return false;
            },
            get: self.getGeometry
        } );

        this.getGeometry().initializePropertySet();
    }

    isSphereFieldVisible( fieldName ) {
        const isTarget = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTarget( this.getLayerCategory() );
        const isSphereTarget = isTarget && this.getAttributeByName( 'TargetType' ) === 'Sphere';
        if ( isSphereTarget ) return true;

        const sphereFieldNames = [ 'FittingPoints', 'SurfaceThickness', 'PositionDeviation', 'PointDrift', 'Radius' ];
        const isSphereName = sphereFieldNames.includes( fieldName );

        return !isSphereName;
    }

    hasBadSurfaceValue( featureDefinition, fieldIndex ) {
        try {
            const surfaceNames = [ 'designSurface', 'existingSurface' ];
            const fieldName = featureDefinition.getFieldName( fieldIndex );
            const fieldValue = this._attributes[ fieldIndex ];

            return surfaceNames.includes( fieldName ) && fieldValue.startsWith( '/data/' );
        } catch ( e ) {
            return false;
        }
    }

    commitChanges() {
        if ( this.getId() !== -1 && !this._editMode )
            return this._layer.update( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].UPDATE_FEATURE, this );
        else
            return undefined;
    }

    setExpandingGeometry( expanded ) {
        this._expandingGeometry = expanded;
    }

    setInvisibleProperties( invisibleProperties ) {
        this._invisibleProperties = invisibleProperties;
    }

    isCoordinateField( fieldName ) {
        return [ 'X', 'Y', 'Z' ].includes( fieldName );
    }

}

/**
 * Defines a Feature Iterator
 * @class
 * @memberof pcvizGIS
 */
class FeatureIterator {
    constructor( geoIterator, layer ) {
        this._geoIterator = geoIterator;
        this._layer = layer;
        this._currentFeature = undefined;
        this._index = -1;
        this._previousFeature = undefined;
        this.reset();
    }

    /**
     * Move the iterator to the next feature
     * @method
     * @memberof pcvizGIS.FeatureIterator
     * @return {boolean} returns false if you can't get more features, else return true
     */
    next() {
        if ( this._index < this._geoIterator.size() - 1 ) {
            this._index++;
            if ( this._currentFeature )
                this._previousFeature = this._currentFeature;
            this._currentFeature = new Feature( this._layer );
            var out = this._geoIterator.next();
            //there are no more features to iterate
            if ( !out ) return false;
            for ( var i = 0; i < this._geoIterator.getNumFields(); i++ ) {
                this._currentFeature.setAttribute( i, this._geoIterator.getDataByIndex( i ) );
            }
            var geometry = this._geoIterator.getGeometry();
            this._currentFeature.setGeometry( geometry );
            var id = this._geoIterator.getFeatureId();
            this._currentFeature.setId( id );
            return true;
        }
        return false;
    }

    moveTo( id ) {
        while ( this.next() ) {
            if ( this._currentFeature.getId() === id )
                return true;
        }
        return false; // Not found feature
    }

    previous() {
        return this._previousFeature;
    }

    moveToLastIndex() {
        // First, we move the iterator to the previous position to the last one
        // because the 'next' function (that we need to call to init the feature) moves the iterator to the last one
        this._index = this._geoIterator.size() - 2;
        this._geoIterator.moveToLastIndex();
        this._geoIterator.moveToPreviousIndex();
        this.next();
    }

    /**
     * gets the number of features in the layer.
     * @memberof pcvizGIS.FeatureIterator
     * @return {int} total number of features in the layer
     */
    getTotalNumFeatures() {
        return this._geoIterator.totalSize();
    }

    /**
     * gets the number of features in the current FeatureIterator.
     * @memberof pcvizGIS.FeatureIterator
     * @return {int} number of features in this FeatureIterator
     */
    getSize() {
        return this._geoIterator.size();
    }

    /**
     * get the current index of the feature
     * @memberof pcvizGIS.FeatureIterator
     * @return {Integer} [description]
     */
    getIndex() {
        return this._index;
    }

    /**
     * Get the current feature
     * @method
     * @memberof pcvizGIS.FeatureIterator
     * @return {pcvizGIS.Feature} the feature being iterated
     */
    get() {
        return this._currentFeature;
    }

    /**
     * Set the position to 0 and reset the geoJSONDataIterator
     * @method
     * @memberof pcvizGIS.FeatureIterator
     */
    reset() {
        this._index = -1;
        this._geoIterator.reset();
    }

    /**
     * Returns the internal data iterator
     * @method
     * @memberof pcvizGIS.FeatureIterator
     * @return {DataIterator} The internal data iterator
     */
    getInternalDataIterator() {
        return this._geoIterator;
    }

}


// We could add a method to Validate the Feature.


/***/ }),

/***/ "./sources/pcvizGIS/FeatureCategory.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/FeatureCategory.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FeatureCategory; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var pcvizGIS_Expression__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/Expression */ "./sources/pcvizGIS/Expression.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_9__);











var osg = OSG__WEBPACK_IMPORTED_MODULE_9___default.a.osg;

const VectorLayerSymbolizer = {
    PointSymbolizer: 'PointSymbolizer',
    LineSymbolizer: 'LineSymbolizer',
    PolygonSymbolizer: 'PolygonSymbolizer'
};

VectorLayerSymbolizer[ pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT ] = VectorLayerSymbolizer.PointSymbolizer;
VectorLayerSymbolizer[ pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ] = VectorLayerSymbolizer.PointSymbolizer;
VectorLayerSymbolizer[ pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ] = VectorLayerSymbolizer.LineSymbolizer;
VectorLayerSymbolizer[ pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ] = VectorLayerSymbolizer.PolygonSymbolizer;


class FeatureCategory {
    constructor( layer ) {
        this._translateFields = new Set( [ 'name', 'description', 'frame_id', 'sequence_id', 'area', 'length', 'centroid(x)', 'centroid(y)', 'centroid(z)', 'file_name' ] );

        this._layer = layer;
    }

    render( layerRenderer, parentNode ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        layerRenderer.renderVectorLayer( this._layer, parentNode ).then( function ( featuresNode ) {

            layerRenderer.setNodeToLayer( self._layer, featuresNode );

            if ( featuresNode !== undefined ) {
                featuresNode.id = self._layer.getId();
                featuresNode.Layer = self._layer;
                var transCenter = [ layerRenderer.getCenter()[ 0 ], layerRenderer.getCenter()[ 1 ], layerRenderer.getCenter()[ 2 ] ];


                if ( layerRenderer.getFeatureRendererId() === '3D' ) {
                    featuresNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
                    parentNode.addChild( featuresNode );

                    featuresNode.bufferAttribute.setGlobalCenter( layerRenderer.getCenter() );


                    var nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.computeNodePath( parentNode );
                    var mt = osg.computeLocalToWorld( nodePath, true );
                    featuresNode.bufferAttribute._auxMat = mt;
                }
            }

            // self is necessary because the setVisibilityCallback is executed after the setVisible call in TocWidget
            self._layer.setVisible( self._layer.isVisible() );
            self._layer.setRendered( true );

            defer.resolve( featuresNode );
        } );
        return defer.promise;
    }

    ensureConfiguration( configuration ) {
        if ( !configuration.style )
            if ( !this._layer._dataset._dataIterator.getLayerObject().configuration ) {
                configuration.style = {
                    symbolizers: {}
                };
            } else {
                configuration.style = this._layer._dataset._dataIterator.getLayerObject().configuration.style;
            }

        // add config to old planar image layers
        this.additionalPlanarImageConfiguration( configuration.style.symbolizers );

        if ( configuration.style.symbolizers[ VectorLayerSymbolizer[ this._layer.getGeometryType() ] ] ) {
            var category = this._layer.getCategory();
            if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTarget( category ) && ( !configuration.style.symbolizers.PointSymbolizer || !configuration.style.symbolizers.PointSymbolizer.floorSymbolizer ) )
                this.configureDefaultStyle( configuration.style.symbolizers );

            this.ensureLabellingConfiguration( configuration );
            return configuration;
        }

        configuration.style.symbolizers[ VectorLayerSymbolizer[ this._layer.getGeometryType() ] ] = {};

        this.configureDefaultStyle( configuration.style.symbolizers );
        this.ensureLabellingConfiguration( configuration );

        return configuration;
    }

    configureDefaultStyle( configuration, isRule ) {

        var category = this._layer.getCategory();
        if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isAnnotation( category ) ) {
            this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_ANNOTATION_COLOR, isRule );
        } else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isPanorama( category ) ) {
            this.configureLayerStyle( configuration, pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8___default.a.isSite() ? pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_SITE_PANORAMA_COLOR : pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_PANORAMA_COLOR, isRule );
            if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8___default.a.isSite() )
                configuration.PointSymbolizer.depthDisabled = true;
        } else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTrajectory( category ) ) {
            this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_TRAJECTORY_COLOR, isRule );
        } else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isPlanarImage( category ) ) {
            this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_PLANAR_IMAGE_COLOR, isRule );
        } else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isMachinery( category ) ) {
            this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_MACHINERY_COLOR, isRule );
            configuration.PointSymbolizer.size = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_MACHINERY_SIZE;
        } else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isControlPoint( category ) ) {
            this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_CONTROL_POINT_COLOR, isRule );
            configuration.PointSymbolizer.showLabels = true;
            configuration.PointSymbolizer.labelsColor = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.CONTROL_POINT_LABELS_COLOR;
            configuration.PointSymbolizer.depthDisabled = true;
        } else {
            if ( !pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_8___default.a.isSite() )
                this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.generateRandomRGBIntColor(), isRule );
            else {
                if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT )
                    this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_SITE_POINT_COLOR, isRule );
                else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE )
                    this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_SITE_LINE_COLOR, isRule );
                else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON )
                    this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_SITE_POLYGON_COLOR, isRule );
                else
                    this.configureLayerStyle( configuration, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_SITE_MULTIPOINT_COLOR, isRule );
            }
        }

        if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTarget( category ) )
            this.configureTargetStyle( configuration );
    }

    ensureLabellingConfiguration( configuration ) {

        var symbolizer = configuration.style.symbolizers[ VectorLayerSymbolizer[ this._layer.getGeometryType() ] ];

        if ( symbolizer.showLabels === undefined )
            symbolizer.showLabels = false;

        // configure default labelling field
        var labelField = symbolizer.labelField;
        if ( !labelField || labelField.length === 0 ) {
            // use first string field
            var stringAttribs = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].getStringFields( this._layer.getFeatureDefinition() );
            this.configureLayerLabelling( configuration, ( stringAttribs.length > 0 ) ? stringAttribs[ 0 ] : '' );
        }
    }

    configureLayerStyle( configuration, color, isRule ) {
        if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.PointSymbolizer ) {
            if ( !configuration.PointSymbolizer )
                configuration.PointSymbolizer = {};
            configuration.PointSymbolizer.color = color;
            configuration.PointSymbolizer.size = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_POINTSYMBOLIZER_SIZE;
        } else if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.LineSymbolizer ) {
            if ( !configuration.LineSymbolizer )
                configuration.LineSymbolizer = {};
            configuration.LineSymbolizer.strokeColor = color;
            configuration.LineSymbolizer.strokeWidth = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_LINESYMBOLIZER_WIDTH;
        } else if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.PolygonSymbolizer ) {
            if ( !configuration.PolygonSymbolizer )
                configuration.PolygonSymbolizer = {};
            configuration.PolygonSymbolizer.fillColor = color;
        }

        if ( !isRule ) // additional symbolizers must only be present in root style, not rules
            this.additionalPlanarImageConfiguration( configuration );
    }

    additionalPlanarImageConfiguration( configuration ) {
        // additional symbolizers for planar images
        var category = this._layer.getCategory();
        if ( !pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isPlanarImage( category ) )
            return;

        if ( !configuration.LineSymbolizer ) {
            configuration.LineSymbolizer = {};
            configuration.LineSymbolizer.strokeColor = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_PLANAR_IMAGE_LINE_COLOR;
            configuration.LineSymbolizer.strokeWidth = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_PLANAR_IMAGE_LINE_WIDTH;
        }

        if ( !configuration.PolygonSymbolizer ) {
            configuration.PolygonSymbolizer = {};
            configuration.PolygonSymbolizer.fillColor = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.DEFAULT_PLANAR_IMAGE_FILL_COLOR;
        }
    }

    configureTargetStyle( configuration ) {
        this._layer.setIcon( 'target' );
        const categories = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getController( 'Configuration' ).getCategories();
        let targetConfiguration;
        if ( !categories || !categories.Target ) {
            targetConfiguration = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_7__["default"].Target ].style;
        } else
            targetConfiguration = categories.Target;

        configuration.PointSymbolizer = JSON.parse( JSON.stringify( targetConfiguration.PointSymbolizer ) ); //a deep copy is necessary
    }

    configureLayerLabelling( configuration, labelField ) {
        if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.PointSymbolizer ) {
            configuration.style.symbolizers.PointSymbolizer.labelField = labelField;
        } else if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.LineSymbolizer ) {
            configuration.style.symbolizers.LineSymbolizer.labelField = labelField;
        } else if ( VectorLayerSymbolizer[ this._layer.getGeometryType() ] === VectorLayerSymbolizer.PolygonSymbolizer ) {
            configuration.style.symbolizers.PolygonSymbolizer.labelField = labelField;
        }
    }

    /**
     * Method to get the base symbolizer of a layer depending of the feature type
     * @memberof pcvizGIS.FeatureCategory
     * @return {Symbolizer}
     */
    getBaseSymbolizer( style ) {
        var symbolizer;
        if ( !style ) {
            return symbolizer;
        }

        // set up a default style
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) {
            symbolizer = style.PointSymbolizer;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            symbolizer = style.LineSymbolizer;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ) {
            symbolizer = style.PolygonSymbolizer;
        }
        return symbolizer;
    }

    /**
     * Method to get the base color of a layer depending of the feature type
     * @memberof pcvizGIS.FeatureCategory
     * @return {Color} color array with the values [r,g,b,a]
     */
    getBaseColor( style ) {
        var color;
        if ( !style ) {
            return color;
        }

        // set up a default style
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) {
            color = style.PointSymbolizer.color;
            // overwrite for special symbols
            if ( style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
                var colorFloor = style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color;
                color = [ 255 * colorFloor[ 0 ], 255 * colorFloor[ 1 ], 255 * colorFloor[ 2 ], colorFloor[ 3 ] ];
            }

        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            color = style.LineSymbolizer.strokeColor;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ) {
            color = style.PolygonSymbolizer.fillColor;
        }

        return color;
    }

    /**
     * Method to set the base color of a layer depending of the feature type
     * @memberof pcvizGIS.FeatureCategory
     * @param {Color} color array with the values [r,g,b,a]
     */
    setBaseColor( style, color ) {
        if ( !style ) {
            return;
        }

        // set up a default style
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) {
            style.PointSymbolizer.color = color;
            if ( style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
                var colorFloor = [ color[ 0 ] / 255, color[ 1 ] / 255, color[ 2 ] / 255, color[ 3 ] ];
                style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color = colorFloor;
            }
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            style.LineSymbolizer.strokeColor = color;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ) {
            style.PolygonSymbolizer.fillColor = color;
        }
        this._layer.setStyle( this._layer.getStyle() );
    }

    getLineColor( style ) {
        return style.LineSymbolizer.strokeColor;
    }

    setLineColor( style, color ) {
        style.LineSymbolizer.strokeColor = color;
        this._layer.setStyle( this._layer.getStyle() );
    }

    getFillColor( style ) {
        return style.PolygonSymbolizer.fillColor;
    }

    setFillColor( style, color ) {
        style.PolygonSymbolizer.fillColor = color;
        this._layer.setStyle( this._layer.getStyle() );
    }

    getBaseSize( style ) {
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT &&
            style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {

            return style.PointSymbolizer.floorSymbolizer.PointSymbolizer.size;
        }

        return this.getStyleProperty( style, 'size' );
    }

    setBaseSize( style, size ) {
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT &&
            style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
            style.PointSymbolizer.floorSymbolizer.PointSymbolizer.size = size;
            return;
        }

        return this.setStyleProperty( style, 'size', size );
    }

    getSizeRange( style ) {
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT &&
            style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer ) {
            return [ 0.2, 10.0 ];
        }

        return [ 1.0, 50.0 ];
    }

    getStyleProperty( style, property ) {
        var value;
        if ( !style ) {
            return value;
        }

        // set up a default style
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) {
            value = style.PointSymbolizer[ property ];
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            value = style.LineSymbolizer[ property ];
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ) {
            value = style.PolygonSymbolizer[ property ];
        }
        return value;
    }

    setStyleProperty( style, property, value ) {
        if ( !style ) {
            return;
        }

        // set up a default style
        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) {
            style.PointSymbolizer[ property ] = value;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            style.LineSymbolizer[ property ] = value;
        } else if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ) {
            style.PolygonSymbolizer[ property ] = value;
        }
        this._layer.setStyle( this._layer.getStyle() );
    }

    addStyleProperties( styleGroup, style ) {

        var self = this;

        var baseSymbolizer = this.getBaseSymbolizer( style );
        if ( baseSymbolizer && baseSymbolizer.RuleSymbolizer && baseSymbolizer.RuleSymbolizer.rules.length > 0 ) { // create properties for rules
            baseSymbolizer.RuleSymbolizer.rules.forEach( function ( rule, index ) {
                // keep the same ID in the style rule and the field
                if ( !rule.id )
                    rule.id = 'ruleGroup' + index.toString();

                var ruleGroup = self._layer.addPropertyField( {
                    id: rule.id,
                    label: 'VECTOR_LAYER_PROPERTIES.RULE',
                    type: 'GroupField',
                    group: styleGroup,
                    editable: function () { return rule.id.startsWith( 'ruleGroup' ); }
                } );
                self.addStyleProperties( ruleGroup, rule );
            } );

            return; // do not show base symbol
        }

        if ( style.expression ) {
            this._layer.addPropertyField( {
                id: styleGroup.field + '_condition',
                label: 'VECTOR_LAYER_PROPERTIES.CONDITION',
                type: 'ExpressionField',
                editable: function () {
                    return !self._layer._editMode && styleGroup.editable();
                },
                get: function () {
                    return pcvizGIS_Expression__WEBPACK_IMPORTED_MODULE_3__["default"].expressionToString( style.expression );
                },
                set: function ( value ) { // we assume the expression is validated in the UI

                    style.expression = pcvizGIS_Expression__WEBPACK_IMPORTED_MODULE_3__["default"].stringToExpression( value );
                    self._layer.setStyle( self._layer.getStyle() ); // save style change

                    self._layer.updateSymbolRendererAndRefreshLayerInViews();
                },
                group: styleGroup
            } );
        }

        if ( this._layer.getCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.MODEL3D ) {
            this._layer.addPropertyField( {
                id: styleGroup.field + 'useBaseColor',
                label: 'VECTOR_LAYER_PROPERTIES.USE_BASE_COLOR',
                type: 'BooleanField',
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return style.PolygonSymbolizer.useModelColor;
                },
                set: function ( value ) {
                    self.setStyleProperty( style, 'useModelColor', value );
                    self._layer.updateSymbolRendererAndRefreshLayerInViews();
                },
                group: styleGroup
            } );
        }

        if ( ![ pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.MACHINERY, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VOLUME ].includes( this._layer.getCategory() ) ) {
            // marker Color R G B property
            this._layer.addPropertyField( { // TODO: Maybe we need to check and refactor all this properties fields.
                id: styleGroup.field + '_baseColor',
                label: 'VECTOR_LAYER_PROPERTIES.COLOR',
                type: 'ColorField',
                editable: function () {
                    return !self._layer._editMode && !( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].is3DModelLayer( self._layer ) && style.PolygonSymbolizer.useModelColor );
                },
                get: function () {
                    return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.RGBIntToFullHex( self.getBaseColor( style ) );
                },
                set: function ( value ) {
                    var color = self.getBaseColor( style );
                    let rgb = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.fullhexToRgb( value, color[ 3 ] );
                    self.setBaseColor( style, rgb );

                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup
            } );
        }

        if ( ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) && ( ![ pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.MODEL3D, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VERITY_REPORT, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.TIN, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VERITY_MODEL, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VOLUME ].includes( this._layer.getCategory() ) ) ) {
            // pointSize property
            this._layer.addPropertyField( {
                id: styleGroup.field + '_pointSize',
                label: 'VECTOR_LAYER_PROPERTIES.POINTSIZE',
                type: 'FloatField',
                decimals: 1,
                valueRange: self.getSizeRange( style ),
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return self.getBaseSize( style );
                },
                set: function ( value ) {
                    self.setBaseSize( style, value );

                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup
            } );
        }

        if ( this._layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].LINE ) {
            // lineWidth property
            this._layer.addPropertyField( {
                id: styleGroup.field + '_strokeWidth',
                label: 'VECTOR_LAYER_PROPERTIES.LINEWIDTH',
                type: 'FloatField',
                decimals: 1,
                valueRange: [ 1.0, 15.0 ],
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return self.getStyleProperty( style, 'strokeWidth' );
                },
                set: function ( value ) {
                    self.setStyleProperty( style, 'strokeWidth', value );
                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup
            } );
        }

    }

    initializePropertySet( layer ) {
        var self = this;
        pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_6__["default"].prototype.initializePropertySet.call( layer, layer );
        layer.addPropertyField( {
            id: 'geometryType',
            label: 'VECTOR_LAYER_PROPERTIES.GEOMETRY_TYPE',
            type: 'CharField',
            editable: function () {
                return false;
            },
            get: function () {
                var nativeType = self._layer.getFeatureDefinition().getGeomFieldTypeAsString();
                switch ( nativeType ) {
                case 'POINT':
                    return 'VECTOR_LAYER_PROPERTIES.GEOMETRY_TYPE_POINT';
                case 'MULTIPOINT':
                    return 'VECTOR_LAYER_PROPERTIES.GEOMETRY_TYPE_MULTIPOINT';
                case 'LINE':
                    return 'VECTOR_LAYER_PROPERTIES.GEOMETRY_TYPE_LINE';
                case 'POLYGON':
                    return 'VECTOR_LAYER_PROPERTIES.GEOMETRY_TYPE_POLYGON';
                }
            },
            group: 'baseGroup',
            translate: true // only if not editable
        } );

        var styleGroup = layer.addPropertyField( {
            id: 'styleGroup',
            label: 'VECTOR_LAYER_PROPERTIES.STYLE',
            type: 'GroupField',
            // This set function is for the add rule button
            set: function () {
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
        } );

        this.addStyleProperties( styleGroup, layer.getStyle() ); // base/rule properties


        var style = layer.getStyle();

        if ( ( layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].POINT || layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"].MULTIPOINT ) && ( ![ pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.MODEL3D, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VERITY_REPORT, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.TIN, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VERITY_MODEL, pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].Categories.VOLUME ].includes( layer.getCategory() ) ) ) {

            // target autoscale
            if ( style.PointSymbolizer.floorSymbolizer && style.PointSymbolizer.floorSymbolizer.PointSymbolizer )

                layer.addPropertyField( {
                    id: 'autoscaleFloor',
                    label: 'STATION_PROPERTIES.AUTOSCALE',
                    type: 'BooleanField',
                    group: styleGroup.field,
                    editable: () => {
                        return true;
                    },
                    get: () => {
                        return style.PointSymbolizer.floorSymbolizer.PointSymbolizer.autoScale;
                    },
                    set: value => {
                        style.PointSymbolizer.floorSymbolizer.PointSymbolizer.autoScale = value;
                        self._layer.setStyle( self._layer.getStyle() );
                        self._layer.updateSymbolRendererAndRefreshLayerInViews();
                    }
                } );
        }

        // common properties (outside rules)
        // additional properties for planar image layers
        if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isPlanarImage( layer.getCategory() ) ) {
            // lineWidth property
            layer.addPropertyField( {
                id: 'strokeWidth',
                label: 'VECTOR_LAYER_PROPERTIES.LINEWIDTH',
                type: 'FloatField',
                decimals: 1,
                valueRange: [ 1.0, 15.0 ],
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return style.LineSymbolizer[ 'strokeWidth' ];
                },
                set: function ( value ) {
                    self._layer.getFeatureRenderer().getSymbol().setCamerasInvalidation( true );
                    style.LineSymbolizer[ 'strokeWidth' ] = value;
                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup.field
            } );

            layer.addPropertyField( {
                id: 'lineColor',
                label: 'VECTOR_LAYER_PROPERTIES.LINE_COLOR',
                type: 'ColorField',
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.RGBIntToFullHex( self.getLineColor( style ) );
                },
                set: function ( value ) {
                    var color = self.getLineColor( style );
                    let rgb = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.fullhexToRgb( value, color[ 3 ] );
                    self.setLineColor( style, rgb );
                    self._layer.getFeatureRenderer().getSymbol().setCamerasInvalidation( true );

                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup.field
            } );

            layer.addPropertyField( {
                id: 'fillColor',
                label: 'VECTOR_LAYER_PROPERTIES.FILL_COLOR',
                type: 'ColorField',
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.RGBIntToFullHex( self.getFillColor( style ) );
                },
                set: function ( value ) {
                    var color = self.getFillColor( style );
                    let rgb = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.fullhexToRgb( value, color[ 3 ] );
                    self.setFillColor( style, rgb );
                    self._layer.getFeatureRenderer().getSymbol().setCamerasInvalidation( true );

                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
                },
                group: styleGroup.field
            } );
        }

        if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_1__["default"].isTarget( layer.getCategory() ) && layer.getParent().getCategory() === 'Station' ) {
            layer.addPropertyField( {
                id: 'autorotate',
                label: 'STATION_PROPERTIES.AUTOROTATE',
                type: 'BooleanField',
                group: styleGroup.field,
                editable: () => {
                    return true;
                },
                get: () => {
                    return style.PointSymbolizer.floorSymbolizer.PointSymbolizer.billboard;
                },
                set: value => {
                    style.PointSymbolizer.floorSymbolizer.PointSymbolizer.billboard = value;
                    self._layer.setStyle( self._layer.getStyle() );
                    self._layer.updateSymbolRendererAndRefreshLayerInViews();
                }
            } );
        }

        var stringAttribs = layer.getTranslatedAttributeNames( { onlyVisible: true } );

        if ( stringAttribs.length > 0 ) {
            layer.addPropertyField( {
                id: 'showLabels',
                label: 'VECTOR_LAYER_PROPERTIES.SHOWLABELS',
                type: 'BooleanField',
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    return self.getStyleProperty( self._layer.getStyle(), 'showLabels' );
                },
                set: function ( value ) {
                    self.setStyleProperty( self._layer.getStyle(), 'showLabels', value );
                    self._layer._dirtyLabels = true;
                    self._layer.updateSymbolRendererAndRefreshLayerInViews(); // TODO: We need to wait
                },
                group: styleGroup.field
            } );

            layer.addPropertyField( {
                id: 'labelField',
                label: 'VECTOR_LAYER_PROPERTIES.LABELFIELD',
                type: 'CharField',
                valueRange: stringAttribs,
                translate: true,
                editable: function () {
                    return !self._layer._editMode;
                },
                get: function () {
                    var labelField = self.getStyleProperty( self._layer.getStyle(), 'labelField' );
                    var translatedFields = self._layer.convertFieldNamesForward( [ labelField ] );
                    return translatedFields[ 0 ];
                },
                set: function ( value ) {
                    self.setLabelFieldValue( value );
                },
                group: styleGroup.field
            } );

            this.defaultLabelField( stringAttribs );
        }

        // Alpha property
        layer.addPropertyField( {
            id: 'alpha',
            label: 'VECTOR_LAYER_PROPERTIES.ALPHA',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 0.0, 1.0 ],
            editable: function () {
                return !self._layer._editMode;
            },
            get: function () {
                var color = self.getBaseColor( self._layer.getStyle() );
                return color[ 3 ];
            },
            set: function ( value ) {
                var color = self.getBaseColor( self._layer.getStyle() );
                color[ 3 ] = value;
                self.setBaseColor( self._layer.getStyle(), color );

                self._layer._dirtyLabels = true;
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
            group: styleGroup.field
        } );
    }

    setLabelFieldValue( value ) {
        this.setStyleProperty( this._layer.getStyle(), 'labelField', this._layer.convertFieldNameBackward( value ) );
        this._layer._dirtyLabels = true;
        this._layer.updateSymbolRendererAndRefreshLayerInViews(); // TODO: We need to wait
    }

    defaultLabelField( stringAttribs ) {
        const labelField = this.getStyleProperty( this._layer.getStyle(), 'labelField' );
        const translatedFields = this._layer.convertFieldNamesForward( [ labelField ] );
        const isFieldVisible = stringAttribs.find( attrib => attrib === labelField || attrib === translatedFields[ 0 ] );

        if ( isFieldVisible )
            return;

        this.setLabelFieldValue( stringAttribs[ 0 ] );
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/FeatureDefinition.js":
/*!***********************************************!*\
  !*** ./sources/pcvizGIS/FeatureDefinition.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FeatureDefinition; });


class Field {
    constructor( name, type ) {
        this._name = ( name !== undefined ) ? name : '';
        this._type = ( type !== undefined ) ? type : '';
    }

    getType() {
        return this._type;
    }

    getName() {
        return this._name;
    }

    setType( type ) {
        this._type = type;
    }

    setName( name ) {
        this._name = name;
    }

    set( field, value ) {
        this[ field ] = value;
    }

    get( fieldName ) {
        return this[ fieldName ];
    }

    setAllExtraAttributes( field ) {
        var attributes = [ 'visible', 'order', 'mandatory', 'editable', 'valueRange' ];
        var self = this;
        attributes.map( function ( attribute ) {
            if ( field[ attribute ] !== undefined ) {
                self[ '_' + attribute ] = field[ attribute ];
            }
        } );
    }

    getExtraAttribute( name ) {
        return ( this[ '_' + name ] );
    }

}



/**
 * Specifies the feature's definition
 * @class
 * @memberof pcvizGIS
 */


class FeatureDefinition {
    constructor() {
        this._fields = [];
    }

    // Attributes Setters and Getters

    getField( i ) {
        return this._fields[ i ];
    }

    getFields() {
        return this._fields;
    }

    getFieldValue( i, name ) {
        return this._fields[ i ][ '_' + name ];
    }

    setField( i, field ) {
        this._fields[ i ] = field;
    }

    setFields( fields ) {
        this._fields = fields;
    }

    getFieldName( i ) {
        return this._fields[ i ]._name;
    }

    getFieldType( i ) {
        return this._fields[ i ]._type;
    }

    getFieldIndex( fieldName ) {
        for ( var i = 0; i < this.getNumFields(); i++ ) {
            if ( this._fields[ i ].getName() === fieldName )
                return i;
        }

        return -1;
    }

    getNumFields() {
        return this._fields.length;
    }

    getGeomField() {
        for ( var i = 0; i < this.getNumFields(); i++ )
            if ( this._fields[ i ].getType() & FeatureDefinition.GEOMETRIC )
                return this._fields[ i ];
    }

    getGeomFieldType() {
        return this.getGeomField().getType();
    }

    getGeomFieldTypeAsString() {
        var geomTypeString = '';
        if ( this.getGeomField().getType() === FeatureDefinition.POINT )
            geomTypeString = 'POINT';
        else if ( this.getGeomField().getType() === FeatureDefinition.LINE )
            geomTypeString = 'LINE';
        else if ( this.getGeomField().getType() === FeatureDefinition.MULTIPOINT )
            geomTypeString = 'MULTIPOINT';
        else if ( this.getGeomField().getType() === FeatureDefinition.POLYGON )
            geomTypeString = 'POLYGON';
        return geomTypeString;
    }

    getGeomFieldIndex() {
        for ( var i = 0; i < this.getNumFields(); i++ )
            if ( this._fields[ i ].getType() & FeatureDefinition.GEOMETRIC )
                return i;
    }

    createField( fieldValues ) {
        var field = new Field( fieldValues.field, fieldValues.type );
        field.setAllExtraAttributes( fieldValues );
        this._fields.push( field );
    }

    createFieldByNameAndType( name, type ) {
        this._fields.push( new Field( name, type ) );
    }

    deleteField( i ) {
        if ( i < 0 || i >= this.getNumFields() )
            return;
        this._fields.splice( i, 1 );
    }


    setFieldName( i, name ) {
        this._fields[ i ].setName( name );
    }

    setFieldType( i, type ) {
        this._fields[ i ].setType( type );
    }

    setGeomType( type ) {
        this.getGeomField().setType( type );
    }


}

// Types
FeatureDefinition.INTEGER = 0x00;
FeatureDefinition.REAL = 0x01;
FeatureDefinition.TEXT = 0x02;
FeatureDefinition.TIMESTAMP = 0x03;
FeatureDefinition.BOOLEAN = 0x04;
FeatureDefinition.ENUMERATED = 0x05;
FeatureDefinition.ARRAY = 0x06;

FeatureDefinition.GEOMETRIC = 0x10;

FeatureDefinition.POINT = 0x08 | FeatureDefinition.GEOMETRIC;
FeatureDefinition.LINE = 0x09 | FeatureDefinition.GEOMETRIC;
FeatureDefinition.MULTIPOINT = 0x0A | FeatureDefinition.GEOMETRIC;
FeatureDefinition.POLYGON = 0x0B | FeatureDefinition.GEOMETRIC;
FeatureDefinition.COLLECTION = 0x0C | FeatureDefinition.GEOMETRIC;


/***/ }),

/***/ "./sources/pcvizGIS/FeatureRenderer.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/FeatureRenderer.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FeatureRenderer; });


/**
 * Base class for feature renderers.
 * @class
 * @memberof pcvizGIS
 */
class FeatureRenderer {
    constructor() {
        this._symbol = undefined;
        this._sceneGraph = undefined;
    }


    /**
     * Sets the symbol to render the features
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @param {Symbol} symbol
     */
    setSymbol( symbol ) {
        this._symbol = symbol;
    }

    /**
     * gets the Symbol
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @return Symbol
     */
    getSymbol() {
        return this._symbol;
    }

    /**
     * render de layer meaning that it is symbolized and added to the final sceneGraph
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @param the feature to be rendered
     */
    renderLayer( /* layer */) {}

    /**
     * Render a single feature and return the resulting graph
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @return {Object} [description]
     */
    renderFeature( /* feature */) {}

    /**
     * Returns the generated scene graph (it contains the geometry and sometimes a marker).
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @return {Node} [description]
     */
    getSceneGraph() {}

    /**
     * Returns the generated scene graph (it contains the _sceneGraph node and the _labelsNode node).
     * @method
     * @memberof pcvizGIS.FeatureRenderer
     * @return {Node} [description]
     */
    getSymbolGraph() {}

}


/***/ }),

/***/ "./sources/pcvizGIS/FilterLayerVisitor.js":
/*!************************************************!*\
  !*** ./sources/pcvizGIS/FilterLayerVisitor.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return FilterLayerVisitor; });
/* harmony import */ var pcvizGIS_LayerVisitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/LayerVisitor */ "./sources/pcvizGIS/LayerVisitor.js");




/**
 * Class for serilize Layers in a storable (json) data structure
 * @class
 * @memberof pcvizGIS
 */
class FilterLayerVisitor extends pcvizGIS_LayerVisitor__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( filterFunction ) {
        super();
        this._filterFunction = filterFunction;
    }


    /**
     * visit Layer Group implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayerGroup( layerGroup ) {
        this._filterFunction( layerGroup );
        layerGroup.traverse( this );
    }

    /**
     * visit Layer implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayer( layer ) {
        this._filterFunction( layer );
        layer.traverse( this );
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Geoid.js":
/*!***********************************!*\
  !*** ./sources/pcvizGIS/Geoid.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Geoid; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Input */ "./sources/pcvizDB/Input.js");
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Serializer */ "./sources/pcvizDB/Serializer.js");
/* harmony import */ var pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2__);





// FOR TESTING: Do not remove
//var Exporter = require( 'pcvizDataAccess/Exporters/Exporter' );

class Geoid {
    constructor() {
        this._NoDataVal = 20000; // defined as MAX_HEIGHT in GeoSDK Geoid lib
        this._valid = false;
    }

    isValid() {
        return this._valid;
    }

    // returns a promise
    readFromURL( url ) {
        var input = new pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default.a();
        var options = {
            responseType: 'arraybuffer'
        };

        var self = this;

        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();

        input.request( url, options, true ).then( function ( response ) {
            var result = self.parseGFF( response );
            self._valid = result;
            defer.resolve( result );

        } ).catch( function () {
            // error getting geoid data
            console.error( 'Could not read Geoid GFF file' );
            defer.resolve( false );
        } );

        return defer.promise;
    }

    compareArray16( cArray, str, init ) {
        for ( var iChar = init; iChar < str.length; iChar++ ) {
            if ( cArray[ 2 * iChar ] !== str[ iChar ] && cArray[ 2 * iChar + 1 ] !== 0 ) // compare ASCII array with 16bit representation
                return false;
        }
        return true;
    }

    array16ToString( cArray ) {
        var str = '';
        for ( var iChar = 0; iChar < cArray.length; iChar += 2 ) {
            str += String.fromCharCode( cArray[ iChar ] );
        }
        return str;
    }

    parseName( reader ) {
        if ( this._gffVersion === 1 )
            return reader.deserializeString0();

        var name = reader.deserialize0Array16();
        return this.array16ToString( name );
    }

    parseGFF( arraybuffer ) {
        var reader = new pcvizDB_Serializer__WEBPACK_IMPORTED_MODULE_2___default.a();
        reader.setBuffer( arraybuffer );

        // header
        this._gffVersion = 1;
        var magic = reader.deserializeString0();
        if ( magic !== '0JFFB' ) {
            reader.seekg( 0 );
            magic = reader.deserialize0Array16();
            if ( magic.length < 14 || !this.compareArray16( magic, '0JFFB', 2 ) )
                return false; // not valid 
            if ( magic[ 12 ] !== 0 || magic[ 13 ] !== 2 ) // version not supported 
                return false;
            this._gffVersion = 2;
        }

        if ( this._gffVersion === 1 ) { // skip version
            var foo = reader.deserializeString0();
            foo = reader.deserializeString0();
        }

        this.parseName( reader ); // root name

        reader.getByte(); // k

        this.name = this.parseName( reader ); // geoid name
        reader.deserializeUint32Value(); // root dims

        // values
        var error = 'No error';
        while ( reader.isNotFinished() ) {
            try {
                this.parseValue( reader );
            } catch ( err ) { // no more values
                error = err;
                break;
            }
        }

        // check results
        if ( !this.Data || !this.NX || !this.NY || !this.Region )
            return false;

        if ( this.Region.data[ 2 ] > Math.PI )
            this.Region.data[ 2 ] -= 2 * Math.PI; // normalize longitude origin to [-pi, pi]

        return true;
    }

    parseValue( reader ) {
        reader.getByte(); // v
        var valName = this.parseName( reader );
        var value = {};

        value.dims = reader.deserializeUint32Value();
        value.type = reader.deserializeUint32Value();
        value.size = reader.deserializeUint32Value();

        switch ( value.type ) {
            default: value.data = reader.deserializeArray( value.dims * value.size );
            break;
        case 1: // floats
                value.data = new Float32Array( value.size / 4 );
            for ( var ifl = 0; ifl < value.size / 4; ifl++ ) {
                value.data[ ifl ] = reader.deserializeFloat32Value();
            }
            /*if ( valName === 'Data' ) {  // FOR TESTING: DO NOT REMOVE
                var csvStream = '';

                for ( var ifl2 = 0; ifl2 < value.size / 4; ifl2++ ) {
                    if ( value.data[ ifl2 ] !== 20000 ) {
                        csvStream += ifl2 % 1201 + ', ' + ifl2 / 1801 + '\n';
                    }
                }

                Exporter.prototype.downloadTextData( {
                    promise: P.defer(),
                    filename: 'test.csv',
                    textData: csvStream,
                    mimeType: 'application/pts;charset=utf-8',
                    encodeURI: true
                } );
            }*/
            break;
        case 4: // doubles
                value.data = new Float64Array( value.dims );
            for ( var id = 0; id < value.dims; id++ ) {
                value.data[ id ] = reader.deserializeFloat64Value();
            }
            break;
        case 2: // integer
                if ( value.dims === 1 )
                    value.data = reader.deserializeValue( value.size );
                else {
                    value.data = [];
                    for ( var i = 0; i < value.dims; i++ )
                        value.data[ i ] = reader.deserializeValue( value.size );
                }
            break;

        case 5: // string
                if ( value.dims === 1 )
                    value.data = this.parseName( reader );
                else {
                    value.data = [];
                    for ( var d = 0; d < value.dims; d++ )
                        value.data[ d ] = this.parseName( reader );
                }
            break;
        }

        this[ valName ] = value;
    }

    getGridHeight( col, row ) {
        var colN = ( col < 0 ) ? 0 : ( ( col >= this.NX.data ) ? this.NX.data - 1 : col );
        var rowN = ( row < 0 ) ? 0 : ( ( row >= this.NY.data ) ? this.NY.data - 1 : row );

        var value = this.getGridValue( colN, rowN );
        if ( value === this._NoDataVal ) {
            // try neighbors
            var interpVal = 0;
            var nNeighbors = 0;
            for ( var iCol = colN - 1; iCol <= colN + 1; iCol++ )
                for ( var iRow = rowN - 1; iRow <= rowN + 1; iRow++ ) {
                    if ( iCol === colN && iRow === rowN )
                        continue;
                    if ( iCol < 0 || iCol >= this.NX.data || iRow < 0 || iRow >= this.NY.data )
                        continue;
                    var nValue = this.getGridValue( iCol, iRow );
                    if ( nValue !== this._NoDataVal ) {
                        interpVal += nValue;
                        nNeighbors++;
                    }
                }
            if ( nNeighbors > 0 )
                value = interpVal / nNeighbors;
            else
                value = 0; // use zero as correction, if we have no data
        }

        return value;
    }

    getGridValue( col, row ) {
        return this.Data.data[ col + row * this.NX.data ];
    }

    // x must be normalized longitude (in radians, from -pi to pi)
    // y must be normalized latitude (in radians, from -pi/2 to pi/2)
    getHeight( x, y ) {

        if ( !this._valid )
            return 0.0;

        var crossesPi = ( this.Region.data[ 2 ] + this.Region.data[ 3 ] > Math.PI );

        // find neighbors
        var deltaX = this.Region.data[ 3 ] / ( this.NX.data - 1 );
        var deltaY = this.Region.data[ 1 ] / ( this.NY.data - 1 );
        var xf = ( x + ( crossesPi ? Math.PI : 0.0 ) - this.Region.data[ 2 ] ) / deltaX;

        // If origin in NW
        let yf;
        if ( this.RegGeoidMath.data.includes( 'NW' ) ) {
            yf = ( this.Region.data[ 0 ] + this.Region.data[ 1 ] - y ) / deltaY;
        } else {
            // Origin is in SW
            yf = ( y - this.Region.data[ 0 ] ) / deltaY;
        }

        let col = Math.floor( xf ); // PostX
        let row = Math.floor( yf ); // PostY
        xf -= col;
        yf -= row;

        // Since April 2025, added bilinear interpolation for Japan new geoid
        // GRID3x3 -> Cubic spline interpolation
        // GRID2x2 -> Bilinear interpolation
        if ( this.RegGeoidMath.data.includes( 'GRID3x3' ) ) {
            return this.getCubicSplineInterpolation( col, row, xf, yf );
        }
        return this.getBilinearInterpolation( col, row, xf, yf );
    }

    getBilinearInterpolation( col, row, xf, yf ) {
        let y1 = this.getGridHeight( col, row );
        let y2 = this.getGridHeight( col, row + 1 );
        let x1 = this.getGridHeight( col + 1, row );
        let x2 = this.getGridHeight( col + 1, row + 1 );

        let upperY = y1 + yf * ( y2 - y1 );
        let lowerY = x1 + yf * ( x2 - x1 );

        let height = upperY + xf * ( lowerY - upperY );

        return height;
    }

    getCubicSplineInterpolation( col, row, xf, yf ) {
        /*
        Cubic Spline implemented by Salvador
        */
        let p00 = this.getGridHeight( col - 1, row - 1 );
        let p01 = this.getGridHeight( col + 0, row - 1 );
        let p02 = this.getGridHeight( col + 1, row - 1 );
        let p03 = this.getGridHeight( col + 2, row - 1 );
        let p10 = this.getGridHeight( col - 1, row + 0 );
        let p11 = this.getGridHeight( col + 0, row + 0 );
        let p12 = this.getGridHeight( col + 1, row + 0 );
        let p13 = this.getGridHeight( col + 2, row + 0 );
        let p20 = this.getGridHeight( col - 1, row + 1 );
        let p21 = this.getGridHeight( col + 0, row + 1 );
        let p22 = this.getGridHeight( col + 1, row + 1 );
        let p23 = this.getGridHeight( col + 2, row + 1 );
        let p30 = this.getGridHeight( col - 1, row + 2 );
        let p31 = this.getGridHeight( col + 0, row + 2 );
        let p32 = this.getGridHeight( col + 1, row + 2 );
        let p33 = this.getGridHeight( col + 2, row + 2 );

        let yf2 = yf * yf;
        let xf2 = xf * xf;
        let xf3 = xf * xf2;

        let x00 = p03 - p02 - p00 + p01;
        let x01 = p00 - p01 - x00;
        let x02 = p02 - p00;
        let x0 = x00 * xf3 + x01 * xf2 + x02 * xf + p01;

        let x10 = p13 - p12 - p10 + p11;
        let x11 = p10 - p11 - x10;
        let x12 = p12 - p10;
        let x1 = x10 * xf3 + x11 * xf2 + x12 * xf + p11;

        let x20 = p23 - p22 - p20 + p21;
        let x21 = p20 - p21 - x20;
        let x22 = p22 - p20;
        let x2 = x20 * xf3 + x21 * xf2 + x22 * xf + p21;

        let x30 = p33 - p32 - p30 + p31;
        let x31 = p30 - p31 - x30;
        let x32 = p32 - p30;
        let x3 = x30 * xf3 + x31 * xf2 + x32 * xf + p31;

        let y0 = x3 - x2 - x0 + x1;
        let y1 = x0 - x1 - y0;
        let y2 = x2 - x0;

        let height = y0 * yf * yf2 + y1 * yf2 + y2 * yf + x1;
        return height;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/Geometry.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/Geometry.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Geometry; });
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js");
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__);









/**
 * Defines a general geometry
 * @class
 * @memberof pcvizGIS
 */
class Geometry extends pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._type = -1;
        this._spatialReference = undefined;

        this._is3D = true;

        this._envelope = new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_2__["default"]();
        this._envelopeComputed = false;

        this._geometryEditedCallback = undefined;

        this._isEditable = false;
    }



    // Setters and Getters

    setType( type ) {
        this._type = type;
    }

    getType() {
        return this._type;
    }

    getDimension() {}

    getCoordinateDimension() {
        return ( this._is3D ? 3 : 2 );
    }

    setCoordinateDimension( value ) {
        if ( value === 2 )
            this._is3D = false;
        else if ( value === 3 )
            this._is3D = true;
    }

    getGeometryName() {}

    setSpatialReference( spatialReference ) {
        this._spatialReference = spatialReference;
    }

    getSpatialReference() {
        return this._spatialReference;
    }

    prepareCRS( layer, project ) {
        // Defines layer's projection and project's projection
        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1___default.a.defProj4( layer.getProjection(), layer.getProj4() );
        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1___default.a.defProj4( project.getProjection(), project.getProj4() );

        return {
            sourceProjection: layer.getProjection(),
            destinationProjection: project.getProjection(),
            geoid: project.getGeoid()
        };
    }

    getEnvelope() {
        if ( !this._envelopeComputed ) {
            this.computeEnvelope( this._envelope );
            this._envelopeComputed = true;
        }
        return this._envelope;
    }

    computeEnvelope( /* envelope */) {}

    dirtyEnvelope() {
        if ( this._envelopeComputed === true )
            this._envelopeComputed = false;
    }

    clone() {}

    /**
     * Copy the geometry passed to this geometry.
     * @param  {Geometry} g the geometry (or an object that inherits from this class) to be copied in this geometry (or object that inherits from this class)
     * @method
     * @memberof pcvizGIS.Geometry
     */
    copy( g ) {
        this._is3D = g._is3D;

        this._envelope.copy( g._envelope );
        this._envelopeComputed = g._envelopeComputed;
    }

    clear() {}

    setGeometryEditedCallback( callBack ) {
        this._geometryEditedCallback = callBack;
    }

    setEditable( isEditable ) {
        this._isEditable = isEditable;
    }

    getSelectedVertex() {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'SelectionObject' ).getSelectionObject().getVertex();
    }

    getLayerSelected() {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'SelectionObject' ).getSelectionObject().getLayer();
    }

    getProject() {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getController( 'Application' ).getApplication().getProject();
    }

    _transformPoint( transformedPoint, originalPoint, destinationPoint, crsData ) {
        transformedPoint[ 0 ] = originalPoint[ 0 ];
        transformedPoint[ 1 ] = originalPoint[ 1 ];
        transformedPoint[ 2 ] = originalPoint[ 2 ];
        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_1___default.a.transform( crsData.sourceProjection, crsData.destinationProjection, transformedPoint, true, crsData.geoid, crsData.addGeoid );

        destinationPoint[ 0 ] = transformedPoint[ 0 ];
        destinationPoint[ 1 ] = transformedPoint[ 1 ];
        destinationPoint[ 2 ] = transformedPoint[ 2 ];
    }

}

Geometry.POINT = 0;
Geometry.CURVE = 1;
Geometry.LINE_STRING = 2;
Geometry.LINEAR_RING = 3;
Geometry.SURFACE = 4;
Geometry.POLYGON = 5;

Geometry.GEOMETRY_COLLECTION = 6;
Geometry.MULTIPOINT = 7;


/***/ }),

/***/ "./sources/pcvizGIS/GeometryCollection.js":
/*!************************************************!*\
  !*** ./sources/pcvizGIS/GeometryCollection.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GeometryCollection; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");



/**
 * Implements a collection of basic geometry objects
 * @class
 * @memberof pcvizGIS
 * @extends Geometry
 */
class GeometryCollection extends pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();

        this._geoms = [];
        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION;
    }


    // Setters and Getters 

    /**
     * Add a geometry at the end of the collection.
     * @method
     * @memberof pcvizGIS.GeometryCollection
     * @param {pcvizGIS.Geometry} geometry the geometry to be added
     */
    addGeometry( geometry ) {
        this._geoms.push( geometry );
        this.dirtyEnvelope();
    }

    /**
     * Insert a geometry at the specific position in the collection
     * @method
     * @memberof pcvizGIS.GeometryCollection
     * @param  {pcvizGIS.Geometry} geometry the geometry to be added
     * @param  {integer} position     the position
     */
    insertGeometry( geometry, position ) {
        this._geoms.splice( position, 0, geometry );
        this.dirtyEnvelope();
    }

    getNumGeometries() {
        return this._geoms.length;
    }

    getGeometry( i ) {
        return this._geoms[ i ];
    }

    removeGeometryAt( i ) {
        this._geoms.splice( i, 1 );
        this.dirtyEnvelope();
    }

    getGeometryName() {
        return 'GeometryCollection';
    }

    computeEnvelope( envelope ) {
        var extentSet = false;

        for ( var i = 0; i < this.getNumGeometries(); i++ ) {
            if ( !extentSet ) {
                envelope.copy( this._geoms[ i ].getEnvelope() );
                extentSet = true;
            } else {
                envelope.merge( this._geoms[ i ].getEnvelope() );
            }
        }
        return envelope;
    }

    clone() {}

    /**
     * Copy the geometry collection passed to this geometry collection.
     * @param  {GeometryCollection} collection the geometry collection (or an object that inherits from this class) to be copied in this geometry collection (or object that inherits from this class)
     * @method
     * @memberof pcvizGIS.GeometryCollection
     */
    copy( collection ) {
        pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.copy.call( this, collection );

        this._geoms.length = 0;
        for ( var i = 0; i < collection._geoms.length; i++ ) {
            this._geoms[ i ] = collection._geoms[ i ].clone();
        }
    }


    //getLength, getArea
}


/***/ }),

/***/ "./sources/pcvizGIS/GeometryType.js":
/*!******************************************!*\
  !*** ./sources/pcvizGIS/GeometryType.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


const GeometryType = {
    POINT: 'Point',
    MULTIPOINT: 'MultiPoint',
    LINESTRING: 'LineString',
    POLYGON: 'Polygon',
    ALL: 'All'
};

/* harmony default export */ __webpack_exports__["default"] = (GeometryType);


/***/ }),

/***/ "./sources/pcvizGIS/GroundControlPoints.js":
/*!*************************************************!*\
  !*** ./sources/pcvizGIS/GroundControlPoints.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GroundControlPoints; });
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0__);

class GroundControlPoints {
    constructor( points ) {
        this._points = points;
        this._projection = undefined;
        this._proj4 = undefined;
    }

    set points( points ) {
        this._points = points;
    }

    get points() {
        return this._points;
    }

    get geoJSON() {
        let geoJSON = {
            type: 'FeatureCollection',
            features: []
        };
        for ( const point of this._points ) {
            geoJSON.features.push( {
                type: 'Feature',
                id: point.name,
                geometry: {
                    type: 'Point',
                    coordinates: point.position.slice()
                },
                layer: this,
                properties: point
            } );
        }
        return geoJSON;
    }

    getProjection() {
        return this._projection;
    }

    getProj4() {
        return this._proj4;
    }

    ensureCRS() {
        return new Promise( ( resolve, reject ) => {
            let promises = [];
            let epsgs = [];
            this._points.forEach( controlPoint => {
                if ( !controlPoint.epsg ) {
                    return;
                }
                let epsgCode = controlPoint.epsg.substring( 5 );
                epsgs.push( controlPoint.epsg );
                promises.push( pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0___default.a.getProjectionInfo( epsgCode, pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0___default.a.FORMAT.PROJ4 ) );
            } );

            Promise.all( promises ).then( projectionInfoArray => {
                if ( projectionInfoArray.length && !this._projection ) {
                    this._projection = epsgs[ 0 ];
                    this._proj4 = projectionInfoArray[ 0 ];
                }
                for ( const [ index, projectionInfo ] of projectionInfoArray.entries() ) {
                    pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_0___default.a.defProj4( epsgs[ index ], projectionInfo );
                }
                resolve();
            }, reject );
        } );
    }

    getFeature( id ) {
        return new Promise( () => {
            return this._points.find( point => {
                return point.id === id;
            } );
        } );
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/JobSite.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/JobSite.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobSite; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_LayerSet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerSet */ "./sources/pcvizGIS/LayerSet.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__);


const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;





class JobSite extends pcvizGIS_LayerSet__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor( jobSiteDataset ) {
        super();
        this._jobSiteDataset = jobSiteDataset;

        this._layersData = undefined;
        this._projectsData = undefined;
    }

    /**
     * Gets job site dataset
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getJobSiteDataset() {
        return this._jobSiteDataset;
    }

    getDataset() {
        return this.getJobSiteDataset();
    }

    /**
     * Gets the id
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getId() {
        return this._jobSiteDataset.getDriver().getJobSiteId();
    }

    /**
     * Sets the id
     * @method
     * @memberof pcvizGIS.JobSite
     * @param {string} id The job site id.
     */
    setId( id ) {
        this._jobSiteDataset.getDriver().setJobSiteId( id );
    }

    /**
     * Gets the name
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getName() {
        return this._jobSiteDataset.getDriver().getName();
    }

    /**
     * Gets the description
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getDescription() {
        return this._jobSiteDataset.getDriver().getDescription();
    }

    /**
     * Gets sample distance value
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getSampleDistance() {
        return this._jobSiteDataset.getDriver().getSampleDistance();
    }

    /**
     * Gets the snapshot type
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getSnapshotType() {
        return this._jobSiteDataset.getDriver().getSnapshotType();
    }

    /**
     * Gets the generic data of the job site
     * @method
     * @memberof pcvizGIS.JobSite
     */
    getGenericData() {
        return {
            name: this.getName(),
            description: this.getDescription(),
            sampleDistance: this.getSampleDistance(),
            snapshotType: this.getSnapshotType(),
            geoid: this.getGeoidID(),
            horizProjectionEPSG: this.getProjection(),
        };
    }

    /**
     * Get the ToC information
     * @method
     * @memberof pcvizDataAccess.JobSiteDriver
     */
    getToc() {
        return this._jobSiteDataset.getDriver().getToc();
    }

    /**
     * Method to add an existing project to this job site
     * @method
     * @memberof pcvizGIS.JobSite
     * @param {projectId} projectId the project to be added
     */
    addProject( projectId ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.addProject( projectId ).then( () => {
                this.refreshJobSite();
                resolve( this.findProjectById( projectId ) );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Method to delete an existing project from this job site
     * @method
     * @memberof pcvizGIS.JobSite
     * @param {projectId} projectId the project to be deleted
     */
    deleteProject( projectId ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.deleteProject( projectId ).then( () => {
                this.refreshJobSite();
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Method to delete an existing reference data layer from this job site
     * @method
     * @memberof pcvizGIS.JobSite
     * @param {layerId} layerId the id of the layer to be deleted
     */
    deleteReferenceDataLayer( layerId ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.deleteReferenceDataLayer( layerId ).then( () => {
                this.refreshJobSite();
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Method to delete a snapshot from the job site
     * @method
     * @memberof pcvizGIS.JobSite
     * @param {string} snapshotUuid the snapshot to be deleted
     */
    deleteSnapshot( snapshotUuid ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.deleteSnapshot( snapshotUuid ).then( () => {
                this.refreshJobSite();
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Method to update the job site
     * @param {number} jobSiteId the id of the job site
     * @param {oject} fieldsToUpload params to be updated and its new values
     * @returns {Promise}
     */

    updateJobSiteData( jobSiteId, fieldsToUpload ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.updateJobSiteData( jobSiteId, fieldsToUpload ).then( () => {
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    updateTocConfiguration( toc ) {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.updateTocConfiguration( toc ).then( () => {
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Refresh the job site data
     */
    refreshData() {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.getDriver().refreshJobSiteData().then( () => {
                this.refreshJobSite();
                this.refreshLocationData();
                resolve();
            } ).catch( ( error ) => {
                console.error( 'Error in promise (JobSite.refreshData)' );
                reject( error );
            } );
        } );
    }

    /**
     * Open the job site using the job site dataset given
     * @method
     * @memberof pcvizGIS.JobSite
     */
    open() {
        return new Promise( ( resolve, reject ) => {
            this._jobSiteDataset.open().then( () => {
                this.refreshJobSite().then( () => {
                    this.setLayersVisibility();
                    // Set projection
                    this._projection = this._jobSiteDataset.getDriver().getHorizProjectionEPSG();

                    if ( !this._projection ) {
                        this.refreshExtent( undefined, undefined, undefined, this.transformSnapshotLayerExtent.bind( this ) );
                        resolve();
                        return;
                    }

                    // Getting proj4 projection & geoid
                    pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getProjectionInfo( this._projection.substring( 5 ), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.FORMAT.PROJ4 ).then( ( proj4 ) => {
                        this._proj4 = proj4;
                        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.initGeoidList().then( () => {
                            this._geoid = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getGeoidByID( this._jobSiteDataset.getDriver().getGeoid() );
                            this.refreshExtent( undefined, undefined, undefined, this.transformSnapshotLayerExtent.bind( this ) );
                            resolve();
                        } ).catch( ( error ) => {
                            console.error( 'Error in promise (JobSite.open, initGeoidList)' );
                            reject( error );
                        } );
                    } );
                } );
            } ).catch( ( error ) => {
                console.error( 'Error in promise (JobSite.open)' );
                reject( error );
            } );
        } );
    }

    transformSnapshotLayerExtent( layer, minPt, maxPt ) {
        let snapshot = this.getSnapshotByLayer( layer );

        if ( !snapshot || !snapshot.transformMatrix )
            return;

        let mat = osg.mat4.create();
        osg.mat4.transpose( mat, snapshot.transformMatrix );

        pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.transformExtent( mat, minPt, maxPt );
    }

    refreshJobSite() {
        return new Promise( ( resolve ) => {
            const jobSiteObject = this._jobSiteDataset.getJobSiteObject();
            this._layersData = [ ...jobSiteObject.snapshots, ...jobSiteObject.layers ]; // TODO: Back should give us all the layers in the same array.
            this._projectsData = jobSiteObject.projects;
            this.refreshLayers().then( () => {
                resolve();
            } );
        } );
    }

    /**
     * Instantiates all layers and save them in _layers array.
     * Maybe this implementation could be equal in projects, so test it in LayerSet parent after CS release.
     * @method
     * @memberof  pcvizGIS.JobSite
     */
    refreshLayers() {
        return new Promise( ( resolve ) => {
            this._layers = [];
            let promises = [];
            let layerIndex = 0;
            for ( let i = 0; i < this.getNumLayers(); i++ ) {
                let layerInstance = this.instantiateLayer( this._layersData[ i ] );
                if ( !layerInstance ) {
                    continue;
                }
                this._layers[ layerIndex++ ] = layerInstance;
                promises.push( layerInstance.open() );
            }

            Promise.all( promises ).then( function ( layersOk ) {
                resolve( layersOk );
            } );
        } );
    }

    /**
     * refresh geoid and projection values
     */
    refreshLocationData() {
        super.setGeoid( this._jobSiteDataset.getDriver().getGeoid() );
        super.setProjection( this._jobSiteDataset.getDriver().getHorizProjectionEPSG() );
    }

    instantiateLayer( layerObject ) {
        let layerType = layerObject.dataType ? layerObject.dataType : layerObject.layerType; // TODO: Refactor back end side to use the same property name in both cases
        let layerId = layerObject.layerId ? layerObject.layerId : layerObject.id;

        if ( !layerId ) {
            return;
        }

        return super.instantiateLayer( layerId, layerType, this._jobSiteDataset.getDataSource() );
    }

    findProjectById( projectId ) {
        return this._projectsData.find( projectData => projectData.id === projectId );
    }

    getNumLayers() {
        return this._layersData.length;
    }

    getProjectsData() {
        return this._projectsData;
    }

    getLayersData() {
        return this._layersData;
    }

    reset() {
        return this._jobSiteDataset.getDriver().reset();
    }

    getLayerById( layerId ) {
        return this._layers.find( layer => layer.getId() === layerId );
    }

    setLayersVisibility() {
        const toc = this.getToc();
        if ( !this._layers || !this._layers.length || !toc ) {
            return;
        }

        for ( const layer of this._layers ) {
            const layerInfo = this.getLayerInfoFromToc( toc, layer );

            const isVisible = layerInfo ? layerInfo.visible : false;

            layer.setVisible( isVisible );
        }
    }

    getLayerInfoFromToc( toc, layer ) {
        const layerId = layer.getId();

        if ( !layerId ) {
            return;
        }

        for ( const element of toc ) {
            const selectedLayer = element.children.find( snapshot => snapshot.layerId === layerId );

            if ( selectedLayer ) {
                return selectedLayer;
            }
        }
    }

    getSnapshotByLayer( layer ) {
        const layerId = layer.getId();
        return this._layersData.find( ( snapshot ) => snapshot.layerId === layerId );
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/JobSiteDataset.js":
/*!********************************************!*\
  !*** ./sources/pcvizGIS/JobSiteDataset.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobSiteDataset; });
/* harmony import */ var pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Dataset */ "./sources/pcvizGIS/Dataset.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_2__);





/**
 * Defines a subclass of Dataset for JobSite
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.Dataset
 */
class JobSiteDataset extends pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataSource ) {
        super( dataSource );
        this._driver = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( dataSource.getDriverId() );
    }

    addProject( projectId ) {
        return new Promise( ( resolve, reject ) => {
            this._driver.addProjectToJobSite( this._driver.getJobSiteId(), projectId ).then( () => {
                this._driver.refreshJobSiteData( this._driver.getJobSiteId() ).then( function () {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    deleteProject( projectId ) {
        return new Promise( ( resolve, reject ) => {
            this._driver.deleteProjectFromJobSite( this._driver.getJobSiteId(), projectId ).then( () => {
                this._driver.refreshJobSiteData( this._driver.getJobSiteId() ).then( function () {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    deleteReferenceDataLayer( layerId ) {
        return new Promise( ( resolve, reject ) => {
            this._driver.deleteReferenceDataLayerFromJobSite( this._driver.getJobSiteId(), layerId ).then( () => {
                this._driver.refreshJobSiteData( this._driver.getJobSiteId() ).then( function () {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    open() {
        return new Promise( ( resolve, reject ) => {
            this.openDriver().then( ( result ) => {
                resolve( result );
            } ).catch( ( error ) => {
                console.error( 'Error in promise (JobSiteDataset.open)' );
                reject( error );
            } );
        } );
    }

    deleteSnapshot( snapshotUuid ) {
        return new Promise( ( resolve, reject ) => {
            this._driver.deleteSnapshot( this._driver.getJobSiteId(), snapshotUuid ).then( () => {
                this._driver.refreshJobSiteData( this._driver.getJobSiteId() ).then( function () {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    close() {
        return this.closeDriver();
    }

    init() {
        if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_2___default.a.getAuthorizationToken() === undefined && this.getDataSource().getUser() !== undefined ) {
            this.getDriver().setCredentials( this.getDataSource().getUser(), this.getDataSource().getPassword() );
        }
        return this.initDriver();
    }

    getJobSiteObject() {
        return this._driver.getJobSiteObject();
    }

    updateTocConfiguration( toc ) {
        return new Promise( ( resolve, reject ) => {
            this._driver.updateTocConfiguration( toc ).then( () => {
                this._driver.refreshJobSiteData( this._driver.getJobSiteId() ).then( function () {
                    resolve();
                } ).catch( ( error ) => {
                    reject( error );
                } );
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Layer.js":
/*!***********************************!*\
  !*** ./sources/pcvizGIS/Layer.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Layer; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js");
/* harmony import */ var pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");











var osg = OSG__WEBPACK_IMPORTED_MODULE_1___default.a.osg;

/**
 * Specifies a layer of the project.
 * @class
 * @memberof pcvizGIS
 * @extends pcvizUtils.PropertySet
 */
class Layer extends pcvizUtils_PropertySet__WEBPACK_IMPORTED_MODULE_2___default.a {
    constructor( dataset, description ) {
        super();

        this._id = '';

        if ( description !== undefined )
            this._description = description;

        this._visible = true;
        this._visibilityCallbacks = new Map();
        this._visibleMask = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.VISIBILITY_MASK;

        this._previousVisible = true;

        this._index = -1;

        this._dataset = dataset;

        this._center = undefined;

        this._style = undefined;

        this._configuration = undefined;

        this._icon = '';

        this.setUpdateCallback( this.commitChanges );

        this._isSuccessLoaded = false;

        this._open = false;

        this._extent = undefined; // Cached value

        this._rendered = false;

        this._mountObject = undefined;

        this._parent = undefined;

        this._wksUUID = undefined; // uuid of workspace node, set by Project.synchronizeWorkspace. To be used when searching in WorkspaceDataCache

        // This is an optimization to avoid querying the _dataset.(get/set)Attribute each time
        this._layerObject = undefined;
    }

    /**
     * Gets the id
     * @method
     * @memberof pcvizGIS.Layer
     */
    getId() {
        return this._dataset.getId();
    }

    /**
     * Get the layer's name
     * @method
     * @memberof pcvizGIS.Layer
     * @return {string} The name of the layer
     */
    getName() {
        return this._layerObject ? this._layerObject.name : this._dataset.getConfigurationAttribute( 'name' );
    }


    /**
     * Get the layer's description
     * @method
     * @memberof pcvizGIS.Layer
     * @return {string} The description of the layer
     */
    getDescription() {
        return this._dataset.getConfigurationAttribute( 'description' );
    }

    /**
     * Get the layer's type
     * @method
     * @memberof pcvizGIS.Layer
     * @return {string} The type of the layer
     */
    getType() {
        return this._dataset.getAttribute( 'layerType' );
    }

    /**
     * Set the layer's name
     * @method
     * @memberof pcvizGIS.Layer
     * @param {string} name The name of the layer
     */
    setName( name ) {
        this._dataset.setConfigurationAttribute( 'name', name );
    }

    /**
     * Set the layer's description
     * @method
     * @memberof pcvizGIS.Layer
     * @param {string} name The description of the layer
     */
    setDescription( description ) {
        this._dataset.setConfigurationAttribute( 'description', description );
    }

    /**
     * Set the layer's type
     * @method
     * @memberof pcvizGIS.Layer
     * @param {string} type The type of the layer
     */
    setType( type ) {
        this._dataset.setAttribute( 'layerType', type );
    }

    /**
     * Get the layer's horizontal projection
     * @method
     * @memberof pcvizGIS.Layer
     */
    getHorizProjectionEPSG() {
        return this._dataset.getAttribute( 'horizProjectionEPSG' );
    }

    /**
     * Get the layer's vertical projection
     * @method
     * @memberof pcvizGIS.Layer
     */
    getVertiProjectionEPSG() {
        return this._dataset.getAttribute( 'vertiProjectionEPSG' );
    }

    /**
     * Get the layer's creation date
     * @method
     * @memberof pcvizGIS.Layer
     */
    getCreatedAt() {
        return this._dataset.getAttribute( 'createdAt' );
    }

    /**
     * Get the user who created the layer (Collage ID)
     * @method
     * @memberof pcvizGIS.Layer
     */
    getCreatedBy() {
        return this._dataset.getAttribute( 'creatorUserId' );
    }

    /**
     * Get the platform user ID of the layer creator
     * @method
     * @memberof pcvizGIS.Layer
     */
    getCreatedByIdInPlatform() {
        return this._layerObject.creatorUserId;
    }

    getAccessLevel() {
        return this._layerObject.accessLevel;
    }

    /**
     * Get the layer's update date at the server
     * @method
     * @memberof pcvizGIS.Layer
     */
    getUpdatedAt() {
        return this._dataset.getAttribute( 'updatedAt' );
    }

    /**
     * Get the layer's MinX
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMinX() {
        return this._dataset.getMinX();
    }

    /**
     * Get the layer's MaxX
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMaxX() {
        return this._dataset.getMaxX();
    }

    /**
     * Get the layer's MaxX
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMinY() {
        return this._dataset.getMinY();
    }

    /**
     * Get the layer's MaxY
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMaxY() {
        return this._dataset.getMaxY();
    }

    /**
     * Get the layer's MinZ
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMinZ() {
        return this._dataset.getMinZ();
    }

    /**
     * Get the layer's MaxZ
     * @method
     * @memberof pcvizGIS.Layer
     */
    getMaxZ() {
        return this._dataset.getMaxZ();
    }

    setIcon( icon ) {
        this._icon = icon;
    }

    getIcon() {
        return this._icon;
    }

    /**
     * Sets the relative center of the layer
     * @method
     * @memberof pcvizGIS.Layer
     * @param {Array} center The layer center.
     */
    setCenter( center ) {
        this._center = center;
    }

    /**
     * Gets the relative center of the layer
     * @method
     * @memberof pcvizGIS.Layer
     * @return {Array} The layer center.
     */
    getCenter() {
        return this._center;
    }

    /**
     * Compute the relative center of the layer
     * @method
     * @memberof pcvizGIS.Layer
     * @return {Array} The layer center.
     */
    computeCenter( onlyReturn ) {

        var envelope = this.getExtent();
        if ( !envelope || ( !envelope.isValid() && !onlyReturn ) )
            return;

        let center = osg.vec3.create64();
        center[ 0 ] = ( envelope.getMinX() + envelope.getMaxX() ) / 2.0;
        center[ 1 ] = ( envelope.getMinY() + envelope.getMaxY() ) / 2.0;
        center[ 2 ] = ( envelope.getMinZ() + envelope.getMaxZ() ) / 2.0;
        if ( onlyReturn )
            return center;
        this._center = center;
    }

    /**
     * Checks if a layer is visible
     * @method
     * @memberof pcvizGIS.Layer
     * @return {Boolean} `true` if the layer is visible
     */
    isVisible() {
        return this._visible;
    }

    setVisible( value, options ) {
        this._visible = value;
        // if ( this._visibilityCallback !== undefined ) {
        this._visibilityCallbacks.forEach( visibilityCB => {
            visibilityCB( value, options );
        } );
    }

    setVisibilityCallback( id, fn ) {
        this._visibilityCallbacks.set( id, fn );
    }

    setPreviousVisible( value ) {
        this._previousVisible = value;
    }

    getPreviousVisible() {
        return this._previousVisible;
    }

    getIndex() {
        return this._index;
    }

    setIndex( index ) {
        this._index = index;
    }

    getUrl() {
        return this._url;
    }

    setUrl( url ) {
        this._url = url;
    }

    render( /*layerRenderer, parent*/) {}

    open() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        var out = {
            loaded: true,
            error: undefined
        };
        this._dataset.open().then( function ( result ) {
            if ( result.valid === true ) {
                self._open = true;
                self._layerObject = self._dataset.getLayerObject();
                var configuration = self.ensureConfiguration( self._dataset.getDriver().getLayerConfigurationById( self.getId() ) );
                self.setConfiguration( configuration );
                self.initializeExtent();
                self.computeCenter();
                var mountController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getController( 'Mount' );
                if ( mountController )
                    mountController.addMountObject( self.getId(), self );
            }
            if ( self.getProjection() ) {
                pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getProjectionInfo( self.getProjection().substring( 5 ), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.FORMAT.PROJ4 ).then( function ( proj4 ) {
                    pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.defProj4( self.getProjection(), proj4 );
                    self._proj4 = proj4;
                    defer.resolve( out );
                } );
            } else {
                defer.resolve( out );
            }
        } ).catch( function ( error ) {
            console.error( 'Error in promise (Layer.open) ' + error );
            self.setSuccessLoaded( false );
            out.loaded = false;
            out.error = error;
            defer.resolve( out );
        } );

        return defer.promise;
    }

    isOpen() {
        return this._open;
    }

    close() {}

    getDriver() {}

    getDataset() {
        return this._dataset;
    }

    getDataSourceURI() {
        return this._dataset.getDataSource().getURI();
    }

    ensureConfiguration( /*configuration*/) {
        console.log( 'Error: Layer.ensureConfiguration not implemented.' );
    }

    getStyle() {
        return this._dataset.getStyle();
    }

    /**
     * This function configures the style from an external source, like the project or the ui
     * @method
     * @memberof pcvizGIS.Layer
     * @param style, style object
     */
    setStyle( style ) {
        this._dataset.setStyle( style );
    }

    /**
     * This function sets the configuration from an external source, like the project or the ui
     * @method
     * @memberof pcvizGIS.Layer
     * @param {Configuration}, config    the configuration object
     */
    setConfiguration( config ) {
        this._dataset.setConfiguration( config );
    }

    /**
     * This function is called when its attributes are dirty. This is the update callback.
     * @method
     * @memberof pcvizGIS.Layer
     * @return {Promise} The promise from the driver when the layer is updated in the dataset.
     */
    commitChanges() {
        return this._dataset.commitChanges();
    }

    getProjection() {
        return this._layerObject.horizProjectionEPSG;
    }

    getProj4() {
        return this._proj4;
    }

    getTranslatedTypeString() {
        switch ( this.getType() ) {
        case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].POINTCLOUD:
            return ( 'TITLE_LAYER_PROPERTY_BAG.TYPE_POINTCLOUD' );
        case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR:
            return ( 'TITLE_LAYER_PROPERTY_BAG.TYPE_VECTORLAYER' );
        case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].RASTER:
            return ( 'TITLE_LAYER_PROPERTY_BAG.TYPE_RASTERLAYER' );
        case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].GROUP:
            return ( 'TITLE_LAYER_PROPERTY_BAG.TYPE_GROUPLAYER' );
        }
    }

    initializePropertySet() {
        var self = this;

        this.clearProperties();

        var baseGroup = this.addPropertyField( {
            id: 'baseGroup',
            label: self.getTranslatedTypeString(),
            type: 'GroupField',
            translate: true
        } );

        this.addPropertyField( {
            id: 'name',
            label: 'VECTOR_LAYER_PROPERTIES.NAME',
            type: 'TextField',
            get: self.getName,
            set: self.setName,
            group: baseGroup,
            translate: this._type === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].GROUP ? true : false,
            editable: function () {
                return false;
            }
        } );

        this.addPropertyField( {
            id: 'description',
            label: 'VECTOR_LAYER_PROPERTIES.DESCRIPTION',
            type: 'TextField',
            get: self.getDescription,
            set: self.setDescription,
            group: baseGroup,
            editable: function () {
                return ( self.getType() !== pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].GROUP );
            }
        } );

        this.addPropertyField( {
            id: 'type',
            label: 'VECTOR_LAYER_PROPERTIES.TYPE',
            type: 'CharField',
            editable: function () {
                return false;
            },
            get: function () {
                switch ( self.getType() ) {
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].POINTCLOUD:
                    return ( 'VECTOR_LAYER_PROPERTIES.TYPE_POINTCLOUD' );
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR:
                    return ( 'VECTOR_LAYER_PROPERTIES.TYPE_VECTORLAYER' );
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].RASTER:
                    return ( 'VECTOR_LAYER_PROPERTIES.TYPE_RASTERLAYER' );
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_6__["default"].GROUP:
                    return ( 'VECTOR_LAYER_PROPERTIES.TYPE_GROUPLAYER' );
                }
            },
            group: baseGroup,
            translate: true // only if not editable
        } );
    }

    /**
     * Gets if the layer was loaded ok
     * @method
     * @memberof pcvizGIS.Layer
     */
    isSuccessLoaded() {
        return this._isSuccessLoaded;
    }

    /**
     * sets the layer is loaded ok
     * @method
     * @memberof pcvizGIS.Layer
     */
    setSuccessLoaded( value ) {
        this._isSuccessLoaded = value;
    }

    getExtent() {
        return this._extent;
    }

    /**
     * Init the extent with the values computed in the database
     * @method
     * @memberof  pcvizGIS.Layer
     */
    initializeExtent() {
        this._extent = new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_7__["default"]();

        this._extent.setMinX( this.getMinX() );
        this._extent.setMinY( this.getMinY() );
        this._extent.setMinZ( this.getMinZ() );

        this._extent.setMaxX( this.getMaxX() );
        this._extent.setMaxY( this.getMaxY() );
        this._extent.setMaxZ( this.getMaxZ() );
    }

    /**
     * Visitor pattern accept method
     * @method
     * @memberof pcvizGIS.Layer
     * @param LayerVisitor
     */
    accept( layerVisitor ) {
        layerVisitor.apply( this );
    }

    /**
     * Traverse children (for use in the Visitor Pattern)
     * @method
     * @memberof pcvizGIS.Layer
     * @param LayerVisitor
     */
    traverse( /*layerVisitor*/) {
        /* nothing to traverse */
    }

    setRendered( rendered ) {
        this._rendered = rendered;
    }

    isRendered() {
        return this._rendered;
    }

    getMountObject() {
        return this._mountObject;
    }

    setVisibleMask( mask ) {
        this._visibleMask = mask;
    }

    isIncomplete() {
        return false;
    }

    setParent( parent ) {
        this._parent = parent;
    }

    getParent() {
        return this._parent;
    }

    getWksUUID() {
        return this._wksUUID;
    }

    setWksUUID( uuid ) {
        this._wksUUID = uuid;
    }

    canRemoveData() {
        return false;
    }

    removeData() {
        console.log( 'Error: Layer.removeData not implemented.' );
    }

    getStorageUrl() {
        return this._layerObject.storageUrl;
    }

    getProjectsCount() {
        return this._layerObject.projectsCount;
    }

    getLayerObject() {
        return this._layerObject;
    }

    setLayerObject( layerObject ) {
        this._layerObject = layerObject;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/LayerDefinition.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/LayerDefinition.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerDefinition; });
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");




/**
 * Specifies a layer definition to create/update a layer on a server.
 * @class
 * @memberof pcvizGIS
 */
class LayerDefinition {
    constructor() {
        this._id = undefined;
        this._name = '';
        this._description = '';
        this._layerType = '';
        this._category = undefined;
        this._geometryType = '';
        this._storageURL = undefined;
        this._url = undefined;
        this._coordinateSystem = undefined;

        this._horizProjectionEPSG = '';

        this._extent = new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_0__["default"]( 0, 0, 0, 0, 0, 0 );

        this._attributes = {};
    }

    /**
     * Gets the id
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    getId() {
        return this._id;
    }

    /**
     * Sets the id
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} id The layer id.
     */
    setId( id ) {
        this._id = id;
    }

    /**
     * Get the layer's name
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The name of the layer
     */
    getName() {
        return this._name;
    }

    /**
     * Set the layer's name
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The name of the layer
     */
    setName( name ) {
        this._name = name;
    }

    /**
     * Get the layer's description
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The description of the layer
     */
    getDescription() {
        return this._description;
    }

    /**
     * Set the layer's description
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The description of the layer
     */
    setDescription( description ) {
        this._description = description;
    }

    /**
     * Get the layer's type
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The description of the layer
     */
    getLayerType() {
        return this._layerType;
    }

    /**
     * Set the layer's type
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The description of the layer
     */
    setLayerType( layerType ) {
        this._layerType = layerType;
    }


    /**
     * Get the layer's category
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The description of the layer
     */
    getLayerCategory() {
        return this._category;
    }

    /**
     * Set the layer's category
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The description of the layer
     */
    setLayerCategory( layerCategory ) {
        this._category = layerCategory;
    }

    /**
     * Get the layer's storage url, only for vector layers
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The storage url of the layer
     */
    getStorageURL() {
        return this._storageURL;
    }

    /**
     * Set the layer's storage url, only for vector layers
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The storage url of the layer
     */
    setStorageURL( storageUrl ) {
        this._storageURL = storageUrl;
    }

    /**
     * Set the layer's url, only for model 3d vector layer
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The url of the model 3D root file
     */
    setUrl( url ) {
        this._url = url;
    }

    /**
     * Get the layer's geometry type
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @return {string} The description of the layer
     */
    getLayerGeometryType() {
        return this._geometryType;
    }

    /**
     * Set the layer's geometry type
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The description of the layer
     */
    setLayerGeometryType( layerGeometryType ) {
        this._geometryType = layerGeometryType;
    }

    getHorizProjectionEPSG() {
        return this._horizProjectionEPSG;
    }

    setHorizProjectionEPSG( proj ) {
        this._horizProjectionEPSG = proj;
    }

    setExtent( extent ) {
        this._extent = extent;
    }

    setCoordinateSystem( coordinateSystem ) {
        this._coordinateSystem = coordinateSystem;
    }

    getCoordinateSystem() {
        return this._coordinateSystem;
    }

    addAttribute( name, type, editable, order, visible ) {
        var attribute = {
            'type': type,
            'editable': editable,
            'order': order,
            'visible': visible
        };

        this._attributes[ name ] = attribute;
    }

    getGeometryTypeString( type ) {
        var result = '';
        switch ( type ) {
        case pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POINT:
            result = 'Point';
            break;
        case pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].LINE:
            result = 'Line';
            break;
        case pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].MULTIPOINT:
            result = 'Multipoint';
            break;
        case pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON:
            result = 'Polygon';
            break;
        case pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].COLLECTION:
            result = 'Collection';
            break;
        }
        return result;
    }

    /**
     * Set the layer's geometry type
     * @method
     * @memberof pcvizGIS.LayerDefinition
     * @param {string} name The description of the layer
     */
    getJSONObject() {
        var ljson = {};

        if ( this._id !== undefined )
            ljson.id = this.getId();

        ljson.name = this.getName();

        ljson.description = this.getDescription();

        ljson.layerType = this.getLayerType();

        ljson.category = this.getLayerCategory();

        if ( this._storageURL )
            ljson.storageUrl = this._storageURL;

        if ( this._url )
            ljson.url = this._url;

        // now geometryType is a string. (the conversion isn't necessary)
        ljson.geometryType = this.getLayerGeometryType(); // this.getGeometryTypeString( this.getLayerGeometryType() );

        // FIXME: When the server fix this, remove the condition
        if ( this.getHorizProjectionEPSG() !== '' )
            ljson.horizProjectionEPSG = this.getHorizProjectionEPSG();

        if ( this._extent !== undefined ) {
            ljson.minx = this._extent.getMinX();
            ljson.miny = this._extent.getMinY();
            ljson.minz = this._extent.getMinZ();
            ljson.maxx = this._extent.getMaxX();
            ljson.maxy = this._extent.getMaxY();
            ljson.maxz = this._extent.getMaxZ();
        }

        if ( this._coordinateSystem ) {
            ljson.coordinateSystem = this.getCoordinateSystem();
        }

        // adding extra attributes.
        var keys = window.Object.keys( this._attributes );
        if ( keys.length > 0 ) {
            ljson.attributes = this._attributes;
        }

        return ljson;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/LayerGroup.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/LayerGroup.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerGroup; });
/* harmony import */ var pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_FilterLayerVisitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/FilterLayerVisitor */ "./sources/pcvizGIS/FilterLayerVisitor.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__);






const osg = OSG__WEBPACK_IMPORTED_MODULE_3___default.a.osg;



var count = 0;
const DEPRECATED_LAYERGROUP_NAMES = [ 'Model3DVectorLayer' ];

/**
 * Define a layer that contains a group of layers
 * @class
 * @memberof pcvizGIS
 * @extends Layer
 */
class LayerGroup extends pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();

        this._name = '';
        this._description = '';
        this._type = pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].GROUP;
        this._children = [];
        this._category = '';
        this._acceptsChildren = false;
        this._id = -1;
        this._transformMatrix = undefined;
        this._layerGroupClass = undefined;
        this._style = undefined;

        this._featureRenderer = undefined;

        this._applyChildrenProperties = true;

        this._hideSymbol = false;
        this._showSymbolCallbacks = new Map();
    }

    open() {
        return Promise.resolve();
    }

    getLayerGroupClass() {
        return this._layerGroupClass;
    }

    /**
     * Add a child to the group
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {Layer} child the layer to be added
     */
    addChild( child ) {
        this._children.push( child );
        if ( !child._children )
            this.setIcon( child.getIcon() );
        // Setting up parent
        child.setParent( this );
    }

    removeChild( child ) {
        let foundIndex = this._children.indexOf( child );
        if ( foundIndex !== -1 ) {
            this._children.splice( foundIndex, 1 );
        }
    }

    replaceChild( child, replace ) {
        let foundIndex = this._children.indexOf( child );
        if ( foundIndex !== -1 ) {
            this._children.splice( foundIndex, 1, replace );
        }
    }

    /**
     * Method to update the index of the layer's childs and their respective childs (if they have).
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param  {Layer} layer the layer to update its childs' indexes
     */
    updateIndex( layer ) {
        for ( var i = 0; i < layer.getChildren().length; i++ ) {
            if ( layer.getChildren()[ i ].getIndex() !== -1 ) {
                layer.getChildren()[ i ].setIndex( count );
                count++;
            }
            if ( layer.getChildren()[ i ].getChildren && layer.getChildren()[ i ].getChildren().length > 0 )
                this.updateIndex( layer.getChildren()[ i ] );
        }
    }

    /**
     * Set the category of the layer group
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {string} category the category
     */
    setCategory( category ) {
        this._category = category;
    }

    /**
     * Get the category of the layer group
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {string} the category
     */
    getCategory() {
        return this._category;
    }

    /**
     * Get the children array
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {Array} the layer's childs in an Array
     */
    getChildren() {
        return this._children;
    }

    acceptChildren( b ) {
        this._acceptsChildren = b;
    }

    /**
     * Gets the LayerGroup name.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {string} The group name.
     */
    getName() {
        return this._name;
    }

    /**
     * Sets the LayerGroup name.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {string} name The group name.
     */
    setName( name ) {
        this._name = name;
    }

    /**
     * Gets the LayerGroup description.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {string} The group description.
     */
    getDescription() {
        return this._description;
    }

    /**
     * Sets the LayerGroup description.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {string} description The group description.
     */
    setDescription( description ) {
        this._description = description;
    }

    /**
     * Gets the LayerGroup type.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {string} The group type.
     */
    getType() {
        return this._type;
    }

    /**
     * Sets the LayerGroup type.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {string} type The group type.
     */
    setType( type ) {
        this._type = type;
    }

    /**
     * Gets the LayerGroup id.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @return {string} The group type.
     */
    getId() {
        return this._id;
    }

    /**
     * Sets the LayerGroup id.
     * @method
     * @memberof pcvizGIS.LayerGroup
     * @param {string} type The group type.
     */
    setId( id ) {
        this._id = id;
    }

    getTransformMatrix() {
        return this._transformMatrix;
    }

    setTransformMatrix( matrix ) {
        if ( !matrix ) {
            return;
        }
        if ( !this._transformMatrix ) {
            this._transformMatrix = osg.mat4.create64();
        }
        osg.mat4.copy( this._transformMatrix, matrix );
    }

    getStyle() {
        return this._style;
    }

    setStyle( style ) {
        this._style = style;
    }

    getFeatureRenderer() {
        return this._featureRenderer;
    }

    setFeatureRenderer( featureRenderer ) {
        this._featureRenderer = featureRenderer;
    }

    /**
     * This function is called when its attributes are dirty. Currently, LayerGroup information
     * is not stored in database. This override avoids Layer default behaviour.
     * @method
     * @memberof pcvizGIS.LayerGroup
     */
    commitChanges() {}


    render( layerRenderer ) {
        if ( !layerRenderer )
            return;

        layerRenderer.renderLayerGroup( this ).then( ( symbolNode ) => {
            // This code is used for rendering Station LayerGroups. Review if you are rendering other type of LayerGroup.
            if ( symbolNode === undefined )
                return;
            let transCenter = [ layerRenderer.getCenter()[ 0 ], layerRenderer.getCenter()[ 1 ], layerRenderer.getCenter()[ 2 ] ];
            if ( layerRenderer.getFeatureRendererId() === '3D' || layerRenderer.getFeatureRendererId() === 'Map' ) {
                symbolNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
            }
        } );

    }

    updateSymbolRendererAndRefreshLayerInViews() {
        // this._featureRenderer is undefined when you've just created the layer (because it hasn't been rendered yet)
        if ( this.getFeatureRenderer() !== undefined )
            this.getFeatureRenderer().getSymbol().configure( this.getStyle() );
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getInstance().getController( 'Layer' ).refreshLayerGroupInAllViews( this );
    }

    initializePropertySet( project ) {
        pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.initializePropertySet.call( this );

        var propertyFields = {};

        function addToPropertyFields( child, properties, arr ) {
            for ( var j = 0; j < properties.length; j++ ) {
                var property = properties[ j ];
                if ( [ 'name', 'description', 'type', 'baseGroup' ].indexOf( property.field ) === -1 && property.field.indexOf( 'ruleGroup' ) === -1 ) {
                    if ( arr[ property.field ] !== undefined ) {
                        arr[ property.field ].objs.push( child );
                    } else {
                        arr[ property.field ] = {
                            label: property.label,
                            type: property.type,
                            objs: [ child ],
                            decimals: property.decimals,
                            children: property.type === 'GroupField' ? {} : undefined,
                            getUnit: property.getUnit
                        };
                    }
                    if ( property.type === 'GroupField' )
                        addToPropertyFields( child, child.getProperties( property.field ), arr[ property.field ].children );
                }
            }
        }

        if ( !this._applyChildrenProperties ) {
            return;
        }

        for ( var i = 0; i < this._children.length; i++ ) {
            var child = this._children[ i ];
            if ( child.isOpen() ) {
                child.initializePropertySet( project );
                addToPropertyFields( child, child.getProperties(), propertyFields );
            }
        }

        var self = this;

        function addPropertyField( key, property, group ) {
            if ( property.type === 'GroupField' ) {
                var g = self.addPropertyField( {
                    id: key,
                    label: property.label,
                    multiple: true,
                    children: property.objs,
                    type: 'GroupField'
                } );
                for ( var k in property.children )
                    addPropertyField( k, property.children[ k ], g );
            } else {
                var propertyField = {
                    id: key,
                    label: property.label,
                    type: property.type,
                    multiple: true,
                    children: property.objs,
                    group: group,
                    decimals: property.decimals,
                    getUnit: property.getUnit
                };
                self.addPropertyField( propertyField );
            }

        }
        for ( var key in propertyFields )
            addPropertyField( key, propertyFields[ key ] );
    }

    /**
     * Add layer to the toc
     * @method
     * @param {layer} Layer to add
     * @param {Category} Category layer
     * @memberof pcvizGIS.LayerGroup
     */
    addLayerToGroup( layer, category, groupName, parentId ) {

        var layerGroup;
        if ( parentId ) // if parentId is provided, use group with that Id
            layerGroup = this.findElement( parentId, this._children );
        else {
            if ( groupName === undefined )
                groupName = category;
            layerGroup = this._children.find( function ( layer ) {
                return ( layer.getName() === groupName );
            } );
        }
        if ( !layerGroup ) {
            layerGroup = new LayerGroup();
            layerGroup.setName( groupName );
            layerGroup.setId( groupName + 'Group' + Math.floor( Math.random() * 10000 ) );
            layerGroup.setIcon( layer.getIcon() );
            layerGroup.acceptChildren( true );
            this.addChild( layerGroup );
        }
        var layerExists = layerGroup._children.find( function ( existingLayer ) {
            return ( layer.getId() === existingLayer.getId() );
        } );
        if ( !layerExists )
            layerGroup.addChild( layer );
        else
            // layer can be refreshed, ensure set its parent (same approach than on synchronizeWorkspace function)
            layer.setParent( layerGroup );
        this.sortLayers();
    }

    findElement( id, children ) {

        if ( !children )
            return false;

        var foundGroup = false;
        for ( var i = 0; i < children.length; i++ ) {
            if ( children[ i ]._id === id ) {
                foundGroup = children[ i ];
                break;
            }
            var foundRec = this.findElement( id, children[ i ]._children );
            if ( foundRec ) {
                foundGroup = foundRec;
                break;
            }
        }
        return foundGroup;
    }

    /**
     * Cleans layer groups that are empty or deprecated
     * @method
     * @memberof pcvizGIS.LayerGroup
     */
    cleanGroups() {
        var filterLayerVisitor = new pcvizGIS_FilterLayerVisitor__WEBPACK_IMPORTED_MODULE_2__["default"]( function ( layer ) {
            if ( !layer._children ) return;
            // Remove first deprecated layer groups
            layer._children = layer._children.filter( function ( layerToFilter ) {
                return ( !layerToFilter._children ||
                    !DEPRECATED_LAYERGROUP_NAMES.includes( layerToFilter.getName() ) );
            } );
            layer._children = layer._children.filter( function ( layerToFilter ) {
                // do not remove empty workspace groups
                if ( layerToFilter.getLayerGroupClass && layerToFilter.getLayerGroupClass() === 'WorkspaceLayerGroup' )
                    return true;
                // check if it is a leaf node or if it is a layergroup with children
                return ( !layerToFilter._children || layerToFilter._children.length !== 0 );
            } );
        } );
        this.accept( filterLayerVisitor );
    }

    /**
     * Sorts layers alphabetically of group and children. PointCloud layer groups are always
     * show first.
     * @method
     * @memberof pcvizGIS.LayerGroup
     */
    sortLayers() {
        var filterLayerVisitor = new pcvizGIS_FilterLayerVisitor__WEBPACK_IMPORTED_MODULE_2__["default"]( function ( layer ) {
            if ( !layer._children )
                return;
            layer._children.sort( function ( child1, child2 ) {
                if ( child1.getName() === 'PointClouds' && child1 instanceof LayerGroup )
                    return -1;
                if ( child2.getName() === 'PointClouds' && child2 instanceof LayerGroup )
                    return 1;
                return child1.getName().localeCompare( child2.getName() );
            } );
        } );
        this.accept( filterLayerVisitor );
    }

    /**
     * Traverse children (for use in the Visitor Pattern)
     * @method
     * @memberof pcvizGIS.Layer
     * @param LayerVisitor
     */
    traverse( layerVisitor ) {
        this._children.forEach( function ( layer ) {
            layer.accept( layerVisitor );
        } );
    }

    /**
     * Deselect all
     * @method
     * @memberof pcvizGIS.LayerGroup
     */
    deselectAll() {

    }

    setSymbolVisibility( showSymbol ) {
        this._hideSymbol = !showSymbol;
        this._showSymbolCallbacks.forEach( callback => {
            callback( showSymbol );
        } );
    }

    setShowSymbolCallback( id, fn ) {
        this._showSymbolCallbacks.set( id, fn );
    }

    isSymbolHidden() {
        return this._hideSymbol;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/LayerRenderer.js":
/*!*******************************************!*\
  !*** ./sources/pcvizGIS/LayerRenderer.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerRenderer; });


/**
 * Abstract class which methods are implemented in the LayerRenderer class.
 * @class
 * @memberof pcvizGIS
 */
class LayerRenderer {

    renderVectorLayer( /*layer*/) {

    }

    renderPointCloudLayer( /*layer*/) {

    }

    renderRasterLayer( /*layer*/) {

    }

    updateStyle( /*layer, property, value */) {

    }
}


/***/ }),

/***/ "./sources/pcvizGIS/LayerSet.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/LayerSet.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerSet; });
/* harmony import */ var pcvizGIS_VectorLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/VectorLayer */ "./sources/pcvizGIS/VectorLayer.js");
/* harmony import */ var pcvizGIS_VectorDataset__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/VectorDataset */ "./sources/pcvizGIS/VectorDataset.js");
/* harmony import */ var pcvizGIS_PointCloudLayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/PointCloudLayer */ "./sources/pcvizGIS/PointCloudLayer.js");
/* harmony import */ var pcvizGIS_PointCloudDataset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/PointCloudDataset */ "./sources/pcvizGIS/PointCloudDataset.js");
/* harmony import */ var pcvizGIS_RasterLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/RasterLayer */ "./sources/pcvizGIS/RasterLayer.js");
/* harmony import */ var pcvizGIS_RasterDataset__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/RasterDataset */ "./sources/pcvizGIS/RasterDataset.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_7__);











const EXTENT_MAX_VALUES = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];

class LayerSet {
    constructor() {
        this._layers = [];

        this._projection = undefined;
        this._proj4 = '';

        this._dataCRS = undefined;
        this._dataCRSProj4 = undefined;

        this._extent = undefined;
        this._extentCRS = undefined;
        this._extentDirty = false;

        this._geoid = undefined;
    }

    getDataset() {} // implemented by children class

    getId() {} // implemented by children class

    setId() {} // implemented by children class

    getName() {} // implemented by children class

    getDescription() {} // implemented by children class

    getToc() {} // implemented by children class

    getAllLayers() {
        return this._layers;
    }

    /**
     * Instantiates all layers and save them in _layers array
     * @method
     * @memberof  pcvizGIS.LayerSet
     */
    refreshLayers() {}

    /**
     * Instantiate and return the layer at the specified index
     * @method
     * @memberof pcvizGIS.LayerSet
     * @param  {int} layerId for the layer
     * @param  {string} layerType for the layer
     * @param  {DataSource} dataSource from the dataset
     * @return {Layer}   the layer of the _layers Array at the specified position
     */

    instantiateLayer( layerId, layerType, dataSource ) {
        let resultLayer;

        switch ( layerType ) {
        case 'VectorLayer':
            const vectorDataset = new pcvizGIS_VectorDataset__WEBPACK_IMPORTED_MODULE_1__["default"]( dataSource );
            vectorDataset.setSourceLayerId( layerId );
            resultLayer = new pcvizGIS_VectorLayer__WEBPACK_IMPORTED_MODULE_0__["default"]( vectorDataset );
            break;
        case 'PointCloud':
            const pointCloudDataset = new pcvizGIS_PointCloudDataset__WEBPACK_IMPORTED_MODULE_3__["default"]( dataSource );
            pointCloudDataset.setSourceLayerId( layerId );
            resultLayer = new pcvizGIS_PointCloudLayer__WEBPACK_IMPORTED_MODULE_2__["default"]( pointCloudDataset );
            break;
        case 'RasterLayer':
            const rasterDataset = new pcvizGIS_RasterDataset__WEBPACK_IMPORTED_MODULE_5__["default"]( dataSource );
            rasterDataset.setSourceLayerId( layerId );
            resultLayer = new pcvizGIS_RasterLayer__WEBPACK_IMPORTED_MODULE_4__["default"]( rasterDataset );
        }
        return resultLayer;
    }

    /**
     * Gets the coordinate reference system
     * @method
     * @memberof pcvizGIS.LayerSet
     */
    getProjection() {
        return this._projection;
    }

    /**
     * sets the coordinate reference system
     * @method
     * @param {string} projection the projection relative to this project
     */
    setProjection( projection ) {
        if ( this._projection === projection ) {
            return;
        }

        this._projection = projection;
        this._dataCRS = undefined;
        this._proj4 = '';

        if ( this._projection ) {
            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.getProjectionInfo( this._projection.substring( 5 ), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.FORMAT.PROJ4 ).then( ( proj4 ) => {
                this._proj4 = proj4;
                this.refreshExtent();
            } );
        } else {
            this.refreshExtent();
        }
    }

    getProj4() {
        return this._proj4;
    }

    getDataCRS() {
        return this._dataCRS;
    }

    getDataCRSProj4() {
        return this._dataCRSProj4;
    }

    /**
     * Gets the geoid
     * @method
     * @memberof pcvizGIS.LayerSet
     */
    getGeoid() {
        return this._geoid;
    }

    getGeoidID() {
        if ( !this._geoid )
            return '';

        return this._geoid.geoidID;
    }

    /**
     * Sets the geoid
     * @method
     * @memberof pcvizGIS.LayerSet
     * @param {string} geoidID hte id of the selected geoid
     */
    setGeoid( geoidID ) {
        if ( this._geoid && this._geoid.geoidID === geoidID ) {
            return;
        }

        this._geoid = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.getGeoidByID( geoidID );
    }

    isExtentValid( extent ) {
        if ( !extent ) {
            extent = this._extentCRS.slice();
        }
        if ( extent[ 3 ] < extent[ 0 ] || extent[ 4 ] < extent[ 1 ] || extent[ 5 ] < extent[ 2 ] ) {
            return false;
        }
        return true;
    }

    /**
     * Gets the layer set extent projected.
     * @method
     * @memberof pcvizGIS.LayerSet
     * @return {extent} a sliced coords array [6]
     *
     */
    getProjectedExtent() {
        let extent = this._extentCRS.slice();

        if ( !this.isExtentValid( extent ) ) {
            extent = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_7___default.a.DEFAULT_EXTENT;
        }

        return extent;
    }

    /**
     * Gets the layer set extent unprojected.
     * @method
     * @memberof pcvizGIS.LayerSet
     * @return {extent} a sliced coords array [6]
     */
    getUnprojectedExtent() {
        let extent = this._extent.slice();

        if ( !this.isExtentValid( extent ) )
            extent = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_7___default.a.DEFAULT_EXTENT;

        return extent;
    }

    ensureDataCRS() {
        if ( this._projection ) {
            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.defProj4( this._projection, this._proj4 );
        }

        for ( let i = 0; i < this._layers.length; i++ ) {
            if ( this._dataCRS ) {
                break;
            }

            const layer = this._layers[ i ];

            if ( !layer.isOpen() || !layer.getProjection() ) {
                continue;
            }

            this._dataCRS = layer.getProjection();
            this._dataCRSProj4 = layer.getProj4();
            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.defProj4( this._dataCRS, this._dataCRSProj4 );
        }
    }

    refreshExtent( extProject, extProjectCRS, skipRasterExtent, transformFn ) {

        let extentWGS84 = [ ...EXTENT_MAX_VALUES ];
        let extent = extProject ? extProject : [ ...EXTENT_MAX_VALUES ];
        let extentCRS = extProjectCRS ? extProjectCRS : [ ...EXTENT_MAX_VALUES ];

        this.ensureDataCRS();

        let allLayersOpened = true;
        for ( let il = 0; il < this._layers.length; il++ ) {
            let layer = this._layers[ il ];
            if ( !layer.isOpen() ) {
                allLayersOpened = false;
                continue;
            }

            // Don't use the extent of the raster layer because it sometimes is defined in pixels
            if ( skipRasterExtent && layer.getType() === 'RasterLayer' )
                continue;

            let minA = [ 0, 0, 0 ];
            let maxA = [ 0, 0, 0 ];
            minA[ 0 ] = layer.getMinX();
            minA[ 1 ] = layer.getMinY();
            minA[ 2 ] = layer.getMinZ();
            maxA[ 0 ] = layer.getMaxX();
            maxA[ 1 ] = layer.getMaxY();
            maxA[ 2 ] = layer.getMaxZ();

            // don't count empty vector layers
            if ( minA[ 0 ] === 0 && minA[ 1 ] === 0 && minA[ 2 ] === 0 && maxA[ 0 ] === 0 && maxA[ 1 ] === 0 && maxA[ 2 ] === 0 )
                continue;

            // apply transformations
            if ( transformFn ) {
                transformFn( layer, minA, maxA );
            }

            // reproject layer extent to WGS84
            let minReproj = [ minA[ 0 ], minA[ 1 ], minA[ 2 ] ];
            let maxReproj = [ maxA[ 0 ], maxA[ 1 ], maxA[ 2 ] ];
            if ( this._dataCRS ) {
                pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.transform( layer.getProjection(), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.WGS_84, minReproj );
                pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.transform( layer.getProjection(), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.WGS_84, maxReproj );

                if ( maxReproj[ 1 ] < minReproj[ 1 ] ) { // invert lat
                    let lat = minReproj[ 1 ];
                    minReproj[ 1 ] = maxReproj[ 1 ];
                    maxReproj[ 1 ] = lat;
                }
                extentWGS84[ 0 ] = Math.min( minReproj[ 0 ], extentWGS84[ 0 ] );
                extentWGS84[ 1 ] = Math.min( minReproj[ 1 ], extentWGS84[ 1 ] );
                extentWGS84[ 2 ] = Math.min( minReproj[ 2 ], extentWGS84[ 2 ] );
                extentWGS84[ 3 ] = Math.max( maxReproj[ 0 ], extentWGS84[ 3 ] );
                extentWGS84[ 4 ] = Math.max( maxReproj[ 1 ], extentWGS84[ 4 ] );
                extentWGS84[ 5 ] = Math.max( maxReproj[ 2 ], extentWGS84[ 5 ] );
            }

            // Extent without CRS (and transformations if we have)
            extent[ 0 ] = Math.min( minA[ 0 ], extent[ 0 ] );
            extent[ 1 ] = Math.min( minA[ 1 ], extent[ 1 ] );
            extent[ 2 ] = Math.min( minA[ 2 ], extent[ 2 ] );
            extent[ 3 ] = Math.max( maxA[ 0 ], extent[ 3 ] );
            extent[ 4 ] = Math.max( maxA[ 1 ], extent[ 4 ] );
            extent[ 5 ] = Math.max( maxA[ 2 ], extent[ 5 ] );

            // now for the set of layers CRS
            if ( this._projection === pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.WGS_84 ) {
                extentCRS = extentWGS84.slice(); // copies it
                continue;
            }

            // Extent with CRS
            let ilExtentCRS = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.reprojectExtent( minA.concat( maxA ), layer.getProjection(), this._projection );

            extentCRS[ 0 ] = Math.min( ilExtentCRS[ 0 ], extentCRS[ 0 ] );
            extentCRS[ 1 ] = Math.min( ilExtentCRS[ 1 ], extentCRS[ 1 ] );
            extentCRS[ 2 ] = Math.min( ilExtentCRS[ 2 ], extentCRS[ 2 ] );
            extentCRS[ 3 ] = Math.max( ilExtentCRS[ 3 ], extentCRS[ 3 ] );
            extentCRS[ 4 ] = Math.max( ilExtentCRS[ 4 ], extentCRS[ 4 ] );
            extentCRS[ 5 ] = Math.max( ilExtentCRS[ 5 ], extentCRS[ 5 ] );
        }

        this.setExtent( extentWGS84, extent, extentCRS );
        if ( allLayersOpened )
            this._extentDirty = false;
    }

    /**
     * Sets the se of layers extent. For now, it only affects which geoid files are loaded
     * @method
     * @memberof pcvizGIS.LayerSet
     * @param {extentWGS84} extent in WGS84 crs from the layer set
     * @param {extent} extent from the layer set
     * @param {extentCRS} extent projected from the layer set
     */
    setExtent( extentWGS84, extent, extentCRS ) {
        if ( this._geoid ) { // load geoid files for layers set extent
            const normLonOrigin = extentWGS84[ 0 ] * Math.PI / 180.0;
            const normLatOrigin = extentWGS84[ 1 ] * Math.PI / 180.0;
            const normLonDelta = ( extentWGS84[ 3 ] - extentWGS84[ 0 ] ) * Math.PI / 180.0;
            const normLatDelta = ( extentWGS84[ 4 ] - extentWGS84[ 1 ] ) * Math.PI / 180.0;

            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_6___default.a.loadGeoidFiles( this._geoid, [ normLatOrigin, normLatDelta, normLonOrigin, normLonDelta ] );
        }
        // set 3D grid extent unpeojected & projected
        this._extent = extent;
        this._extentCRS = extentCRS;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/LayerType.js":
/*!***************************************!*\
  !*** ./sources/pcvizGIS/LayerType.js ***!
  \***************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


const LayerType = {};

LayerType.POINTCLOUD = 'PointCloud';
LayerType.VECTOR = 'VectorLayer';
LayerType.RASTER = 'RasterLayer';
// Group is not a type in the DB
LayerType.GROUP = 'LayerGroup';

/* harmony default export */ __webpack_exports__["default"] = (LayerType);


/***/ }),

/***/ "./sources/pcvizGIS/LayerVisitor.js":
/*!******************************************!*\
  !*** ./sources/pcvizGIS/LayerVisitor.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerVisitor; });


/**
 * Base class for creating visitors for layers
 * @class
 * @memberof pcvizGIS
 */
class LayerVisitor {
    constructor() {
        this._layerNodePath = [];
    }

    /**
     * visits a Layer
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    apply( layer ) {
        this.pushLayerNode( layer );
        if ( layer.getChildren ) {
            this.applyLayerGroup( layer );
            return;
        }
        this.applyLayer( layer );
        this.popLayerNode();
    }

    /**
     * visit Layer Group implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayerGroup( layerGroup ) {
        layerGroup.traverse( this );
    }

    /**
     * visit Layer implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayer( layer ) {
        layer.traverse( this );
    }

    pushLayerNode( layer ) {
        this._layerNodePath.push( layer );
    }

    popLayerNode() {
        this._layerNodePath.splice( -1, 1 );
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/LineString.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/LineString.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LineString; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_Curve__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Curve */ "./sources/pcvizGIS/Curve.js");
/* harmony import */ var pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js");





/**
 * Implements a LineString geometry
 * @class
 * @memberof pcvizGIS
 * @extends Curve
 */
class LineString extends pcvizGIS_Curve__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor() {
        super();
        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING;
    }

    // Warn: we are suposing that the geometry is 3D
    length() {
        var length = 0.0;
        for ( var i = 1; i < this.getNumPoints(); i++ ) {
            length += pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_2__["distance"]( this._points[ i ], this._points[ i - 1 ] );
        }
        return length;
    }

    // distance is not between 0 and 1, it is a real distance
    valueAt( distance ) {
        var length = 0;
        var i;

        if ( distance < 0 )
            return;

        var deltaX, deltaY, deltaZ, segLength;
        for ( i = 0; i < this.getNumPoints() - 1; i++ ) {

            deltaX = this._points[ i + 1 ][ 0 ] - this._points[ i ][ 0 ];
            deltaY = this._points[ i + 1 ][ 1 ] - this._points[ i ][ 1 ];
            deltaZ = this._points[ i + 1 ][ 2 ] - this._points[ i ][ 2 ];

            segLength = Math.sqrt( deltaX * deltaX + deltaY * deltaY + deltaZ * deltaZ );

            if ( segLength > 0 ) {
                if ( ( length <= distance ) && ( ( length + segLength ) >= distance ) ) {
                    var ratio = ( distance - length ) / segLength;
                    var point = [];
                    point[ 0 ] = ( this._points[ i ][ 0 ] * ( 1 - ratio ) + this._points[ i + 1 ][ 0 ] * ratio );
                    point[ 1 ] = ( this._points[ i ][ 1 ] * ( 1 - ratio ) + this._points[ i + 1 ][ 1 ] * ratio );
                    point[ 2 ] = ( this._points[ i ][ 2 ] * ( 1 - ratio ) + this._points[ i + 1 ][ 2 ] * ratio );
                    return point;
                }
                length += segLength;
            }
        }
        return;
    }


    /**
     * Get the portion of the linestring extracted to new one. The input distances
     * (maybe present as ratio of length of linestring) set begin and end of
     * extracted portion.
     * 
     * @method
     * @memberof  pcvizGIS.LineString
     * @param {float} distanceFrom The distance from the origin of linestring, where the subline should begins
     * @param {float} distanceTo The distance from the origin of linestring, where the subline should ends
     * @param {boolean} asRatio The flag indicating that distances are the ratio of the linestring length.
     *
     * @return {LineString} a new linestring or undefined on failure.
     **/
    getSubLine( distanceFrom, distanceTo, asRatio ) {
        var newLineString = new LineString();
        var length = 0;
        var i;

        newLineString.setSpatialReference( this.getSpatialReference() );

        var len = this.length();
        if ( asRatio === true ) {
            //convert to real distance
            distanceFrom *= len;
            distanceTo *= len;
        }

        if ( distanceFrom < 0 )
            distanceFrom = 0;
        if ( distanceTo > len )
            distanceTo = len;

        if ( distanceFrom > distanceTo || distanceFrom >= len ) {
            return undefined;
        }

        var deltaX, deltaY, deltaZ, segLength;
        var x, y, z, ratio;

        //get first point

        if ( distanceFrom === 0 ) {
            newLineString.addPoint( this.getPoint( 0 ) );
            i = 0;
        } else {
            for ( i = 0; i < this.getNumPoints(); i++ ) {

                deltaX = this._points[ i + 1 ][ 0 ] - this._points[ i ][ 0 ];
                deltaY = this._points[ i + 1 ][ 1 ] - this._points[ i ][ 1 ];
                deltaZ = this._points[ i + 1 ][ 2 ] - this._points[ i ][ 2 ];
                segLength = Math.sqrt( deltaX * deltaX + deltaY * deltaY + deltaZ * deltaZ );

                if ( segLength > 0 ) {
                    if ( ( length <= distanceFrom ) && ( ( length + segLength ) >=
                            distanceFrom ) ) {
                        ratio = ( distanceFrom - length ) / segLength;

                        x = this._points[ i ][ 0 ] * ( 1 - ratio ) +
                            this._points[ i + 1 ][ 0 ] * ratio;
                        y = this._points[ i ][ 1 ] * ( 1 - ratio ) +
                            this._points[ i + 1 ][ 1 ] * ratio;
                        z = this._points[ i ][ 2 ] * ( 1 - ratio ) +
                            this._points[ i + 1 ][ 2 ] * ratio;

                        newLineString.addPointFromCoordinates( x, y, z );

                        //check if distanceTo is in same segment
                        // if yes, add new point and return the new LineString
                        if ( ( length <= distanceTo ) && ( ( length + segLength ) >= distanceTo ) ) {
                            ratio = ( distanceTo - length ) / segLength;

                            x = this._points[ i ][ 0 ] * ( 1 - ratio ) +
                                this._points[ i + 1 ][ 0 ] * ratio;
                            y = this._points[ i ][ 1 ] * ( 1 - ratio ) +
                                this._points[ i + 1 ][ 1 ] * ratio;
                            z = this._points[ i ][ 2 ] * ( 1 - ratio ) +
                                this._points[ i + 1 ][ 2 ] * ratio;

                            newLineString.addPointFromCoordinates( x, y, z );

                            if ( newLineString.getNumPoints() < 2 ) {
                                newLineString = undefined;
                            }

                            return newLineString;
                        }
                        i++;
                        length += segLength;
                        break;
                    }

                    length += segLength;
                }
            }
        }
        //add points
        for ( ; i < this.getNumPoints() - 1; i++ ) {
            newLineString.addPointFromCoordinates( this._points[ i ][ 0 ], this._points[ i ][ 1 ], this._points[ i ][ 2 ] );

            deltaX = this._points[ i + 1 ][ 0 ] - this._points[ i ][ 0 ];
            deltaY = this._points[ i + 1 ][ 1 ] - this._points[ i ][ 1 ];
            deltaZ = this._points[ i + 1 ][ 2 ] - this._points[ i ][ 2 ];
            segLength = Math.sqrt( deltaX * deltaX + deltaY * deltaY + deltaZ * deltaZ );

            if ( segLength > 0 ) {
                if ( ( length <= distanceTo ) && ( ( length + segLength ) >= distanceTo ) ) {
                    ratio = ( distanceTo - length ) / segLength;

                    x = this._points[ i ][ 0 ] * ( 1 - ratio ) +
                        this._points[ i + 1 ][ 0 ] * ratio;
                    y = this._points[ i ][ 1 ] * ( 1 - ratio ) +
                        this._points[ i + 1 ][ 1 ] * ratio;

                    z = this._points[ i ][ 2 ] * ( 1 - ratio ) +
                        this._points[ i + 1 ][ 2 ] * ratio;

                    newLineString.addPointFromCoordinates( x, y, z );

                    return newLineString;
                }

                length += segLength;
            }
        }

        newLineString.addPointFromCoordinates( this._points[ this.getNumPoints() - 1 ][ 0 ], this._points[ this.getNumPoints() - 1 ][ 1 ], this._points[ this.getNumPoints() - 1 ][ 2 ] );

        if ( newLineString.getNumPoints() < 2 ) {
            newLineString = undefined;
        }

        return newLineString;
    }

    /** 
     * Add a segment of another linestring to the end of this line string. 
     * If the startVertex is larger than the endVertex then the vertices 
     * will be reversed as they are copied.
     *
     * @method
     * @memberof  pcvizGIS.LineString
     * @param {LineString} lineString the other LineString.
     * @param {int} startVertex the first vertex to copy, defaults to 0 to start
     * with the first vertex in the other linestring.
     * @param {int} endVertex the last vertex to copy, defaults to -1 indicating
     * the last vertex of the other line string.
     */
    addSubLineString( lineString, startVertex, endVertex ) {
        if ( startVertex === undefined )
            startVertex = 0;
        if ( endVertex === undefined )
            endVertex = -1;

        var lineStringNumPoints = lineString.getNumPoints();
        if ( lineStringNumPoints === 0 )
            return;

        // Check arguments
        if ( endVertex === -1 )
            endVertex = lineStringNumPoints - 1;

        if ( startVertex < 0 || endVertex < 0 ||
            startVertex >= lineStringNumPoints ||
            endVertex >= lineStringNumPoints ) {
            return;
        }

        // Copy the points
        var i;
        if ( endVertex >= startVertex ) {
            for ( i = startVertex; i < ( endVertex + 1 ); i++ ) {
                this.addPoint( lineString.getPoint( i ) );
            }
        } else {
            for ( i = 0; i < ( endVertex - startVertex + 1 ); i++ ) {
                this.addPoint( lineString.getPoint( startVertex - i ) );
            }
        }

        this.dirtyEnvelope();
    }

    getGeometryName() {
        return 'LineString';
    }

    computeEnvelope( envelope ) {
        var minX, minY, maxX, maxY, minZ, maxZ;

        if ( this.isEmpty() ) {
            envelope.clear();
            return envelope;
        }

        minX = maxX = this._points[ 0 ][ 0 ];
        minY = maxY = this._points[ 0 ][ 1 ];
        if ( this._is3D )
            minZ = maxZ = this._points[ 0 ][ 2 ];
        else
            minZ = maxZ = 0;

        for ( var i = 1; i < this.getNumPoints(); i++ ) {
            maxX = Math.max( maxX, this._points[ i ][ 0 ] );
            maxY = Math.max( maxY, this._points[ i ][ 1 ] );
            minX = Math.min( minX, this._points[ i ][ 0 ] );
            minY = Math.min( minY, this._points[ i ][ 1 ] );

            if ( this._is3D ) {
                minZ = Math.min( minZ, this._points[ i ][ 2 ] );
                maxZ = Math.max( maxZ, this._points[ i ][ 2 ] );
            }
        }

        envelope.setMinX( minX );
        envelope.setMaxX( maxX );
        envelope.setMinY( minY );
        envelope.setMaxY( maxY );
        envelope.setMinZ( minZ );
        envelope.setMaxZ( maxZ );

        return envelope;
    }

    getArea() {
        return this.getLinearArea();
    }

    // 2D (OGR implementation)
    getLinearArea() {
        var areaSum;
        var i;

        if ( this.getNumPoints() < 2 )
            return 0;

        areaSum = this._points[ 0 ][ 0 ] * ( this._points[ 1 ][ 1 ] - this._points[ this.getNumPoints() - 1 ][ 1 ] );

        for ( i = 1; i < this.getNumPoints() - 1; i++ ) {
            areaSum += this._points[ i ][ 0 ] * ( this._points[ i + 1 ][ 1 ] - this._points[ i - 1 ][ 1 ] );
        }

        areaSum += this._points[ this.getNumPoints() - 1 ][ 0 ] * ( this._points[ 0 ][ 1 ] - this._points[ this.getNumPoints() - 2 ][ 1 ] );

        return 0.5 * Math.abs( areaSum );
    }

    // Nowadays the centroid shown doesn't take account the projections. TODO: fix for 2D geometries (it works with 3D)
    getCentroid() {
        var centroid = [ 0, 0, 0 ];
        var segmentLength;
        var segmentCenterWeight = [],
            centerWeight = [ 0, 0, 0 ];
        var x1, y1, z1, x2, y2, z2;
        var totalLength = 0.0;
        for ( var i = 0; i < this.getNumPoints() - 1; i++ ) {
            x1 = this._points[ i ][ 0 ];
            y1 = this._points[ i ][ 1 ];
            z1 = this._points[ i ][ 2 ];
            x2 = this._points[ i + 1 ][ 0 ];
            y2 = this._points[ i + 1 ][ 1 ];
            z2 = this._points[ i + 1 ][ 2 ];

            segmentLength = Math.sqrt( ( x2 - x1 ) * ( x2 - x1 ) + ( y2 - y1 ) * ( y2 - y1 ) + ( z2 - z1 ) * ( z2 - z1 ) );

            segmentCenterWeight[ 0 ] = ( x2 + x1 ) / 2 * segmentLength;
            segmentCenterWeight[ 1 ] = ( y2 + y1 ) / 2 * segmentLength;
            segmentCenterWeight[ 2 ] = ( z2 + z1 ) / 2 * segmentLength;

            centerWeight[ 0 ] += segmentCenterWeight[ 0 ];
            centerWeight[ 1 ] += segmentCenterWeight[ 1 ];
            centerWeight[ 2 ] += segmentCenterWeight[ 2 ];

            totalLength += segmentLength; // We could call to this.length(); but this way allow to avoid repeat the loop and the square root operations.
        }

        if ( totalLength !== 0 ) {
            centroid[ 0 ] = centerWeight[ 0 ] / totalLength;
            centroid[ 1 ] = centerWeight[ 1 ] / totalLength;
            centroid[ 2 ] = centerWeight[ 2 ] / totalLength;
        }

        return centroid;
    }

    isEmpty() {
        return ( this.getNumPoints() === 0 );
    }

    clone() {
        var copy = new LineString();
        copy.copy( this );
        return copy;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/LinearRing.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/LinearRing.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LinearRing; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js");
/* harmony import */ var pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/LineString */ "./sources/pcvizGIS/LineString.js");





/**
 * Implements a LinearRing geometry
 * @class
 * @memberof pcvizGIS
 * @extends LineString
 */
class LinearRing extends pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"] {
    constructor() {
        super();
        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].LINEAR_RING;

        this._renderingPoints = [];
        this._transformedRenderingPoints = [];
    }

    length() {
        if ( this.isClosed() )
            return pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.length.call( this );

        var length = pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.length.call( this );
        length += pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["distance"]( this._points[ 0 ], this._points[ this._points.length - 1 ] );
        return length;
    }

    getCentroid() {
        if ( this.isClosed() )
            return pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.getCentroid.call( this );

        this.closeRings();
        var centroid = pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.getCentroid.call( this );
        this.removeLastPoint();
        return centroid;
    }

    //relative to Z axis (OGR implementation)
    isClockwise() {

        var i, v, next;
        var dx0, dy0, dx1, dy1, crossproduct;
        var useFallback = false;

        if ( this.getNumPoints() < 2 )
            return true;

        /* Find the lowest rightmost vertex */
        v = 0;
        for ( i = 1; i < this.getNumPoints() - 1; i++ ) {
            /* => v < end */
            if ( this._points[ i ][ 1 ] < this._points[ v ][ 1 ] ||
                ( this._points[ i ][ 1 ] === this._points[ v ][ 1 ] &&
                    this._points[ i ][ 0 ] > this._points[ v ][ 0 ] ) ) {
                v = i;
                useFallback = false;
            } else if ( this._points[ i ][ 1 ] === this._points[ v ][ 1 ] &&
                this._points[ i ][ 0 ] === this._points[ v ][ 0 ] ) {
                /* Two vertex with same coordinates are the lowest rightmost */
                /* vertex! We cannot use that point as the pivot (#5342) */
                useFallback = true;
            }
        }

        var epsilon = 0.00001;
        /* previous */
        next = v - 1;
        if ( next < 0 ) {
            next = this.getNumPoints() - 1 - 1;
        }

        if ( pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["epsilonEqual"]( this._points[ next ][ 0 ], this._points[ v ][ 0 ], epsilon ) &&
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["epsilonEqual"]( this._points[ next ][ 1 ], this._points[ v ][ 1 ], epsilon ) ) {
            /* Don't try to be too clever by retrying with a next point */
            /* This can lead to false results as in the case of #3356 */
            useFallback = true;
        }

        dx0 = this._points[ next ][ 0 ] - this._points[ v ][ 0 ];
        dy0 = this._points[ next ][ 1 ] - this._points[ v ][ 1 ];

        /* following */
        next = v + 1;
        if ( next >= this.getNumPoints() - 1 ) {
            next = 0;
        }

        if ( pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["epsilonEqual"]( this._points[ next ][ 0 ], this._points[ v ][ 0 ], epsilon ) &&
            pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["epsilonEqual"]( this._points[ next ][ 1 ], this._points[ v ][ 1 ], epsilon ) ) {
            /* Don't try to be too clever by retrying with a next point */
            /* This can lead to false results as in the case of #3356 */
            useFallback = true;
        }

        dx1 = this._points[ next ][ 0 ] - this._points[ v ][ 0 ];
        dy1 = this._points[ next ][ 1 ] - this._points[ v ][ 1 ];

        crossproduct = dx1 * dy0 - dx0 * dy1;

        if ( !useFallback ) {
            if ( crossproduct > 0 ) /* CCW */
                return false;
            else if ( crossproduct < 0 ) /* CW */
                return true;
        }

        /* ok, this is a degenerate case : the extent of the polygon is less than EPSILON */
        /* or 2 nearly identical points were found */
        /* Try with Green Formula as a fallback, but this is not a guarantee */
        /* as we'll probably be affected by numerical instabilities */
        //?¿
        var dfSum = this._points[ 0 ][ 0 ] * ( this._points[ 1 ][ 1 ] - this._points[ this.getNumPoints() - 1 ][ 1 ] );

        for ( i = 1; i < this.getNumPoints() - 1; i++ ) {
            dfSum += this._points[ i ][ 0 ] * ( this._points[ i + 1 ][ 1 ] - this._points[ i - 1 ][ 1 ] );
        }

        dfSum += this._points[ this.getNumPoints() - 1 ][ 0 ] * ( this._points[ 0 ][ 1 ] - this._points[ this.getNumPoints() - 2 ][ 1 ] );

        return dfSum < 0;
    }

    closeRings() {
        if ( this.getNumPoints() < 2 )
            return;
        // WARN: the getters check that the value passed is correct
        if ( this.getX( 0 ) !== this.getX( this.getNumPoints() - 1 ) ||
            this.getY( 0 ) !== this.getY( this.getNumPoints() - 1 ) ||
            this.getZ( 0 ) !== this.getZ( this.getNumPoints() - 1 ) ) {
            var firstPoint = this.getPoint( 0 );
            this.addPoint( firstPoint );
        }
    }

    reverseWindingOrder() {
        this.reversePoints();
    }

    // 2D (OGR implementation)
    isPointInRing( point, testEnvelope ) {
        if ( testEnvelope === undefined )
            testEnvelope = true;

        // Checking
        if ( point === undefined )
            return false;

        var numPoints = this.getNumPoints();

        if ( numPoints < 4 )
            return false;

        var x = point.getX();
        var y = point.getY();

        // Check if point is inside envelope of the ring
        if ( testEnvelope ) {
            var extent = this.getEnvelope();
            if ( !( x >= extent.getMinX() && x <= extent.getMaxX() &&
                    y >= extent.getMinY() && y <= extent.getMaxY() ) ) {
                return false;
            }
        }

        // For every point p in ring, test if ray starting from given point crosses segment (p - 1, p)
        var numCrossings = 0;

        var prevDiffX = this.getX( 0 ) - x;
        var prevDiffY = this.getY( 0 ) - y;

        for ( var i = 1; i < numPoints; i++ ) {
            var x1 = this.getX( i ) - x;
            var y1 = this.getY( i ) - y;

            var x2 = prevDiffX;
            var y2 = prevDiffY;

            if ( ( ( y1 > 0 ) && ( y2 <= 0 ) ) || ( ( y2 > 0 ) && ( y1 <= 0 ) ) ) {
                // Check if ray intersects with segment of the ring
                var intersection = ( x1 * y2 - x2 * y1 ) / ( y2 - y1 );
                if ( 0.0 < intersection ) {
                    // Count intersections
                    numCrossings++;
                }
            }

            prevDiffX = x1;
            prevDiffY = y1;
        }

        // If numCrossings number is even, given point is outside the ring,
        // when the crossings number is odd, the point is inside the ring.
        return ( ( numCrossings % 2 ) === 1 ? true : false );

    }

    // 2D (OGR implementation)
    isPointOnRingBoundary( point, testEnvelope ) {

        if ( testEnvelope === undefined )
            testEnvelope = true;

        if ( point === undefined ) {
            return false;
        }

        var numPoints = this.getNumPoints();

        // Simple validation
        if ( numPoints < 4 )
            return false;

        var testX = point.getX();
        var testY = point.getY();

        // Fast test if point is inside extent of the ring
        if ( testEnvelope ) {
            var extent = this.getEnvelope();
            if ( !( testX >= extent.getMinX() && testX <= extent.getMaxX() &&
                    testY >= extent.getMinY() && testY <= extent.getMaxY() ) ) {
                return false;
            }
        }

        var prevDiffX = this.getX( 0 ) - testX;
        var prevDiffY = this.getY( 0 ) - testY;

        for ( var i = 1; i < numPoints; i++ ) {
            var x1 = this.getX( i ) - testX;
            var y1 = this.getY( i ) - testY;

            var x2 = prevDiffX;
            var y2 = prevDiffY;

            /* If the point is on the segment, return immediately. */
            /* FIXME? If the test point is not exactly identical to one of */
            /* the vertices of the ring, but somewhere on a segment, there's */
            /* little chance that we get 0. So that should be tested against some */
            /* epsilon. */

            if ( x1 * y2 - x2 * y1 === 0 ) {
                /* If iPoint and iPointPrev are the same, go on */
                if ( !( x1 === x2 && y1 === y2 ) ) {
                    return true;
                }
            }

            prevDiffX = x1;
            prevDiffY = y1;
        }

        return false;
    }

    getGeometryName() {
        return 'LinearRing';
    }

    clone() {
        var copy = new LinearRing();
        copy.copy( this );
        return copy;
    }

    getRenderingPoints() {
        return this._renderingPoints;
    }

    // Methods overwritten to mantain the _renderingPoints array
    setX( i, value ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.setX.call( this, i, value );
        if ( this._renderingPoints[ i ] )
            this._renderingPoints[ i ][ 0 ] = value;
    }

    setY( i, value ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.setY.call( this, i, value );
        if ( this._renderingPoints[ i ] )
            this._renderingPoints[ i ][ 1 ] = value;
    }

    setZ( i, value ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.setZ.call( this, i, value );
        if ( this._renderingPoints[ i ] )
            this._renderingPoints[ i ][ 2 ] = value;
    }

    setM( i, value ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.setM.call( this, i, value );
        if ( this._renderingPoints[ i ] )
            this._renderingPoints[ i ][ 3 ] = value;
    }

    addPoint( point ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.addPoint.call( this, point );

        if ( this.isClosed() )
            return;
        this._renderingPoints.push( point.getXYZM() );
        this._transformedRenderingPoints.push( [] );
    }

    insertPoint( point, position ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.insertPoint.call( this, point, position );

        if ( this.isClosed() )
            return;
        this._renderingPoints.splice( position, 0, point.getXYZM() );
        this._transformedRenderingPoints.splice( position, 0, [] );
    }

    addPointFromCoordinates( x, y, z, m ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.addPointFromCoordinates.call( this, x, y, z, m );

        if ( this.isClosed() )
            return;
        this._renderingPoints.push( [ x, y, z, m ] );
        this._transformedRenderingPoints.push( [] );
    }

    removeLastPoint() {
        var isClosed = this.isClosed();
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.removeLastPoint.call( this );

        if ( !isClosed ) {
            this._renderingPoints.pop();
            this._transformedRenderingPoints.pop();
        }
    }

    removePointAt( position ) {
        var isClosed = this.isClosed();

        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.removePointAt.call( this, position );
        this._renderingPoints.splice( position, 1 );
        this._transformedRenderingPoints.splice( position, 1 );

        if ( isClosed && position === 0 ) {
            this._points.pop();
            this.closeRings();
        }
    }

    reversePoints() {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.reversePoints.call( this );
        this._renderingPoints = this._points.slice();
        if ( this.isClosed )
            this._renderingPoints.pop();
    }

    /**
     * Copy the linear ring passed to this linear ring.
     * @param  {LinearRing} lRing the linear ring to be copied in this linear ring
     * @method
     * @memberof pcvizGIS.LinearRing
     */
    copy( lRing ) {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.copy.call( this, lRing );
        this._renderingPoints = [];
        this._transformedRenderingPoints = [];
        for ( var p = 0; p < lRing._renderingPoints.length; p++ ) {
            this._renderingPoints[ p ] = lRing._renderingPoints[ p ].slice( 0 );
            this._transformedRenderingPoints.push( [] );
        }
    }

    clear() {
        pcvizGIS_LineString__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.clear.call( this );
        this._renderingPoints = [];
        this._transformedRenderingPoints = [];
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Model3DCategory.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/Model3DCategory.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Model3DCategory; });
/* harmony import */ var pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/FeatureCategory */ "./sources/pcvizGIS/FeatureCategory.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_4__);







var osg = OSG__WEBPACK_IMPORTED_MODULE_4___default.a.osg;

class Model3DCategory extends pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( layer ) {
        super( layer );

        switch ( layer.getCategory() ) {
        case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__["default"].Categories.TIN:
            this._layer.setIcon( 'tin' );
            break;
        case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__["default"].Categories.VOLUME:
            this._layer.setIcon( 'volume' );
            break;
        default:
            this._layer.setIcon( '3d-model' );
        }

    }

    render( layerRenderer, parentNode ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_1___default.a.defer();
        var self = this;
        //   parent.getModel3DLayerScene().setCenter( layerRenderer.getCenter() );
        layerRenderer.renderVectorLayer( this._layer ).then( function ( modelNode ) {

            // FIXME: At this moment we need to set the modelNode to the current parentNode
            /* var modelNodeExists = layerRenderer.getNodeFromLayer( self._layer );
             if ( modelNodeExists )
                 modelNode = modelNodeExists;
             else*/
            if ( parentNode ) // when refreshing layer in map, this value is not send as argument
                parentNode.addChild( modelNode );

            modelNode.bufferAttribute.setGlobalCenter( layerRenderer.getCenter() );

            const nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.computeNodePath( parentNode );
            const mt = osg.computeLocalToWorld( nodePath, true );
            modelNode.bufferAttribute._auxMat = mt;

            layerRenderer.setNodeToLayer( self._layer, modelNode );

            if ( modelNode !== undefined ) {
                var transCenter = [ layerRenderer.getCenter()[ 0 ], layerRenderer.getCenter()[ 1 ], layerRenderer.getCenter()[ 2 ] ];
                modelNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );

                modelNode.id = self._layer.getId();
                modelNode.Layer = self._layer;
            }

            // self is necessary because the setVisibilityCallback is executed after the setVisible call in TocWidget
            self._layer.setVisible( self._layer.isVisible() );
            self._layer.setRendered( true );

            defer.resolve( modelNode );
        } );
        return defer.promise;
    }

    ensureConfiguration( configuration ) {
        if ( !configuration.style )
            if ( !this._layer._dataset._dataIterator.getLayerObject().configuration ) {
                configuration.style = {
                    symbolizers: {}
                };
            } else {
                configuration.style = this._layer._dataset._dataIterator.getLayerObject().configuration.style;
            }

        if ( configuration.style.symbolizers !== undefined && configuration.style.symbolizers[ 'PolygonSymbolizer' ] ) {
            this.ensureLabellingConfiguration( configuration );
            return configuration;
        }

        configuration.style.symbolizers[ 'PolygonSymbolizer' ] = {};
        configuration.style.symbolizers.PolygonSymbolizer.color = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.DEFAULT_MODEL3D_COLOR;
        configuration.style.symbolizers.PolygonSymbolizer.alpha = 1.0;
        configuration.style.symbolizers.PolygonSymbolizer.fillColor = [ 255, 255, 255, 1 ];

        this.ensureLabellingConfiguration( configuration );
        return configuration;
    }

    ensureLabellingConfiguration( configuration ) {

        var symbolizer = configuration.style.symbolizers[ 'PolygonSymbolizer' ];
        if ( symbolizer.showLabels === undefined )
            symbolizer.showLabels = false;

        // configure default labelling field
        var labelField = symbolizer.labelField;
        if ( !labelField || labelField.length === 0 ) {
            // use first visible string field
            var stringAttribs = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__["default"].getStringFields( this._layer._featureDefinition, undefined, { onlyVisible: true } );
            configuration.style.symbolizers.PolygonSymbolizer.labelField = ( stringAttribs.length > 0 ) ? stringAttribs[ 0 ] : '';
        }
    }

    initializePropertySet() {
        var layer = this._layer;
        pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.initializePropertySet.call( this, layer );

        if ( layer.getCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__["default"].Categories.MODEL3D || pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_3__["default"].isTIN( layer.getCategory() ) ) {
            layer.addPropertyField( {
                id: 'surfaceMode',
                label: 'VECTOR_LAYER_PROPERTIES.SURFACE',
                type: 'CharField',
                valueRange: [ 'VECTOR_LAYER_PROPERTIES.SURFACE_SMOOTH', 'VECTOR_LAYER_PROPERTIES.SURFACE_FLAT', 'VECTOR_LAYER_PROPERTIES.SURFACE_WIREFRAME' ],
                get: function () {
                    let renderMode = layer.getFeatureRenderer().getSymbol().getRenderMode();
                    switch ( renderMode ) {
                    case pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.SMOOTH:
                        return 'VECTOR_LAYER_PROPERTIES.SURFACE_SMOOTH';
                    case pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.FLAT:
                        return 'VECTOR_LAYER_PROPERTIES.SURFACE_FLAT';
                    case pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.WIREFRAME:
                        return 'VECTOR_LAYER_PROPERTIES.SURFACE_WIREFRAME';
                    }
                },
                set: function ( value ) {
                    switch ( value ) {
                    case 'VECTOR_LAYER_PROPERTIES.SURFACE_SMOOTH':
                        layer.getFeatureRenderer().getSymbol().changeRenderMode( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.SMOOTH );
                        break;
                    case 'VECTOR_LAYER_PROPERTIES.SURFACE_FLAT':
                        layer.getFeatureRenderer().getSymbol().changeRenderMode( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.FLAT );
                        break;
                    case 'VECTOR_LAYER_PROPERTIES.SURFACE_WIREFRAME':
                        layer.getFeatureRenderer().getSymbol().changeRenderMode( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.SURFACE_RENDER_MODES.WIREFRAME );
                        break;
                    }
                },
                group: 'baseGroup',
                translate: true
            } );
        }

        layer.removePropertyField( 'styleGroup', 'styleGroup_pointSize' );
        layer.removePropertyField( 'styleGroup', 'strokeWidth' );
    }

    getStyleProperty( style, property ) {
        return style.PolygonSymbolizer[ property ];
    }

    setStyleProperty( style, property, value ) {
        style.PolygonSymbolizer[ property ] = value;
        this._layer.setStyle( style );
    }
    configureLayerStyle( configuration, color ) {
        if ( !configuration.PolygonSymbolizer )
            configuration.PolygonSymbolizer = {};
        configuration.PolygonSymbolizer.fillColor = color;
    }

    /**
     * Method to get the base symbolizer of a layer depending of the feature type
     * @memberof pcvizGIS.FeatureCategory
     * @return {Symbolizer}
     */
    getBaseSymbolizer( style ) {
        var symbolizer;
        if ( !style ) {
            return symbolizer;
        }

        return style.PolygonSymbolizer;
    }

    /**
     * Method to get the base color of a layer depending of the feature type
     * @memberof pcvizGIS.Model3DCategory
     * @return {Color} color array with the values [r,g,b,a]
     */
    getBaseColor( style ) {
        var color;
        if ( !style ) {
            return color;
        }

        color = style.PolygonSymbolizer.fillColor;
        return color;
    }

    /**
     * Method to set the base color of a layer depending of the feature type
     * @memberof pcvizGIS.Model3DCategory
     * @param {Color} color array with the values [r,g,b,a]
     */
    setBaseColor( style, color ) {
        if ( !style ) {
            return;
        }
        style.PolygonSymbolizer.fillColor = color;
        this._layer.setStyle( this._layer.getStyle() );
        return;
    }

    drawAsBuilt( guid, matrixTransform, featureId, featureTransform ) {
        if ( !this._layer.getFeatureRenderer().getSymbol().drawAsBuilt )
            return;
        this._layer.getFeatureRenderer().getSymbol().drawAsBuilt( guid, matrixTransform, featureId, featureTransform );
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/MultiPoint.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/MultiPoint.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MultiPoint; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/GeometryCollection */ "./sources/pcvizGIS/GeometryCollection.js");




/**
 * Implements a collection of Point
 * @class
 * @memberof pcvizGIS
 * @extends GeometryCollection
 */
class MultiPoint extends pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor() {

        super();

        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].MULTIPOINT;

        this._points = [];
        this._transformedPoints = [];
    }


    addGeometry( geometry ) {
        pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.addGeometry.call( this, geometry );
        this._points.push( geometry._xyzm );
        this._transformedPoints.push( [] );
    }

    insertGeometry( geometry, position ) {
        pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.insertGeometry.call( this, geometry, position );
        this._points.splice( position, 0, geometry._xyzm );
        this._transformedPoints.splice( position, 0, [] );
    }

    removeGeometryAt( position ) {
        pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.removeGeometryAt.call( this, position );
        this._points.splice( position, 1 );
        this._transformedPoints.splice( position, 1 );
    }

    // Getters

    getDimension() {
        return 0;
    }

    getGeometryName() {
        return 'MultiPoint';
    }

    // Nowadays this function doesn't take account the projections.
    getCentroid() {
        var centroid = [ 0, 0, 0 ];
        var i;
        for ( i = 0; i < this._points.length; i++ ) {
            centroid[ 0 ] += this._points[ i ][ 0 ];
            centroid[ 1 ] += this._points[ i ][ 1 ];
            centroid[ 2 ] += this._points[ i ][ 2 ];
        }
        if ( i !== 0 ) {
            centroid[ 0 ] = centroid[ 0 ] / i;
            centroid[ 1 ] = centroid[ 1 ] / i;
            centroid[ 2 ] = centroid[ 2 ] / i;
        }
        return centroid;
    }

    getNumPoints() {
        return this.getNumGeometries();
    }

    getPoint( index ) {
        return this.getGeometry( index );
    }

    // The 'selected' property field is used to highlight the selected vertex
    changeSelectedPropertyField( vertex ) {
        this.changePropertyField( 'multiPoint', 'selected', vertex );
    }

    initializePropertySet() {
        var self = this;
        var transformedPoint = [];

        this.clearProperties();

        this.addPropertyField( {
            id: 'multiPoint',
            label: 'VECTOR_LAYER_PROPERTIES.POINTS',
            type: 'PointArrayField',
            selected: self.getSelectedVertex(),
            editable: function () {
                return self._isEditable;
            },
            get: ( function () {
                return function () {
                    var layer = self.getLayerSelected();
                    var project = self.getProject();

                    if ( !layer.getProjection() || !project.getProjection() )
                        return self._points;

                    var crsData = this.prepareCRS( layer, project );

                    for ( var i = 0; i < self.getNumPoints(); i++ ) {
                        self._transformPoint( transformedPoint, self._points[ i ], self._transformedPoints[ i ], crsData );
                    }

                    return self._transformedPoints;
                };
            } )(),
            set: function ( value, index ) {
                // FIXME: This way to set a vertex must be changed when vertex edition branch
                // is merged into master because it implements methods to set its points.
                // Below it is set (temporarily) accessing directly to curve properties.

                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() ) {
                    self.getGeometry( index )._xyzm = value;
                    self._points[ index ][ 0 ] = value[ 0 ];
                    self._points[ index ][ 1 ] = value[ 1 ];
                    self._points[ index ][ 2 ] = value[ 2 ];
                } else {
                    var crsData = this.prepareCRS( layer, project );
                    crsData.addGeoid = true; // revert geoid correction

                    self._transformPoint( transformedPoint, value, self._points[ index ], crsData );

                    self.getGeometry( index )._xyzm[ 0 ] = transformedPoint[ 0 ];
                    self.getGeometry( index )._xyzm[ 1 ] = transformedPoint[ 1 ];
                    self.getGeometry( index )._xyzm[ 2 ] = transformedPoint[ 2 ];
                }

                if ( self._geometryEditedCallback )
                    self._geometryEditedCallback();
            },
            isDirty: function () {
                if ( !self._isEditable )
                    return self._dirty[ 'multiPoint' ];
                else
                    return true;
            }
        } );
    }

    clone() {
        var copy = new MultiPoint();
        copy.copy( this );
        return copy;
    }

    /**
     * Copy the multipoint passed to this multipoint.
     * @param  {MultiPoint} multipoint the multipoint to be copied in this multipoint
     * @method
     * @memberof pcvizGIS.MultiPoint
     */
    copy( multipoint ) {
        pcvizGIS_GeometryCollection__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.copy.call( this, multipoint );

        this._points = [];
        this._transformedPoints = [];
        for ( var p = 0; p < multipoint._points.length; p++ ) {
            this._points[ p ] = multipoint._points[ p ].slice( 0 );
            this._transformedPoints.push( [] );
        }
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/ObjectType.js":
/*!****************************************!*\
  !*** ./sources/pcvizGIS/ObjectType.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


const ObjectType = {
    LAYER: 'layers',
    PROJECT: 'projects'
};

/* harmony default export */ __webpack_exports__["default"] = (ObjectType);


/***/ }),

/***/ "./sources/pcvizGIS/Point.js":
/*!***********************************!*\
  !*** ./sources/pcvizGIS/Point.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Point; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js");




/**
 * Implements a Point geometry
 * @class
 * @memberof pcvizGIS
 * @extends Geometry
 */
class Point extends pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( x, y, z, m ) {
        super();
        this._xyzm = [];
        this._xyzm[ 0 ] = x;
        this._xyzm[ 1 ] = y;
        this._xyzm[ 2 ] = z;
        this._xyzm[ 3 ] = m;

        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].POINT;
    }

    transformGeometryUsingUnitFactor( factor ) {

        if ( factor === 1 ) return; // meters to meters ...  return

        this._xyzm[ 0 ] *= factor;
        this._xyzm[ 1 ] *= factor;
        this._xyzm[ 2 ] *= factor;

        this.dirtyEnvelope();
    }


    // Setters and Getters of the coordinates

    setX( x ) {
        this._xyzm[ 0 ] = x;
        this.dirtyEnvelope();
    }

    getX() {
        return this._xyzm[ 0 ];
    }

    setY( y ) {
        this._xyzm[ 1 ] = y;
        this.dirtyEnvelope();
    }

    getY() {
        return this._xyzm[ 1 ];
    }

    setZ( z ) {
        this._xyzm[ 2 ] = z;
        this.dirtyEnvelope();
    }

    getZ() {
        return this._xyzm[ 2 ];
    }

    setM( m ) {
        this._xyzm[ 3 ] = m;
        this.dirtyEnvelope();
    }

    getM() {
        return this._xyzm[ 3 ];
    }

    setXYZM( xyzm ) {
        pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( xyzm, this._xyzm );
        this.dirtyEnvelope();
    }

    getXYZM() {
        var xyzm = [];
        pcvizGIS_Utils__WEBPACK_IMPORTED_MODULE_1__["copyVec4"]( this._xyzm, xyzm );
        return xyzm;
    }

    clone() {
        var copy = new Point();
        copy.copy( this );
        return copy;
    }

    /**
     * Copy the point passed to this point.
     * @param  {Point} point the point to be copied in this point
     * @method
     * @memberof pcvizGIS.Point
     */
    copy( point ) {
        pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.copy.call( this, point );

        this._xyzm = [];
        this._xyzm = point._xyzm.slice( 0 );
    }

    /**
     * Reset the components
     * @method
     * @memberof pcvizGIS.Point
     */
    clear() {
        this._xyzm[ 0 ] = this._xyzm[ 1 ] = this._xyzm[ 2 ] = this._xyzm[ 3 ] = 0;
        this.dirtyEnvelope();
    }

    getDimension() {
        return 0;
    }

    getGeometryName() {
        return 'Point';
    }

    computeEnvelope( envelope ) {
        envelope.setMinX( this._xyzm[ 0 ] );
        envelope.setMaxX( this._xyzm[ 0 ] );
        envelope.setMinY( this._xyzm[ 1 ] );
        envelope.setMaxY( this._xyzm[ 1 ] );
        if ( this.getCoordinateDimension() === 3 ) {
            envelope.setMinZ( this._xyzm[ 2 ] );
            envelope.setMaxZ( this._xyzm[ 2 ] );
        }
        return envelope;
    }

    // The 'selected' property field is used to highlight the selected vertex
    changeSelectedPropertyField( selected ) {
        this.changePropertyField( 'point', 'selected', selected );
    }

    initializePropertySet() {
        var self = this;
        var transformedPoint = [];

        this.clearProperties();

        this.addPropertyField( {
            id: 'point',
            type: 'Point',
            editable: function () {
                return self._isEditable;
            },
            selected: self.getSelectedVertex(),
            get: function () {
                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() )
                    return self._xyzm;

                var crsData = this.prepareCRS( layer, project );
                self._transformPoint( transformedPoint, self._xyzm, transformedPoint, crsData );

                return transformedPoint;
            },
            set: function ( value ) {
                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() )
                    self._xyzm = value;
                else {
                    var crsData = this.prepareCRS( layer, project );
                    crsData.addGeoid = true; // revert geoid correction
                    self._transformPoint( transformedPoint, value, self._xyzm, crsData );
                }

                if ( self._geometryEditedCallback )
                    self._geometryEditedCallback();
            },
            isDirty: function () {
                if ( !self._isEditable )
                    return self._dirty[ 'point' ];
                else
                    return true;
            }
        } );
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/PointCloudDataset.js":
/*!***********************************************!*\
  !*** ./sources/pcvizGIS/PointCloudDataset.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointCloudDataset; });
/* harmony import */ var pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/CollageDataset */ "./sources/pcvizGIS/CollageDataset.js");



/**
 * Defines a subclass of Dataset for PointCloudLayers
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.CollageDataset
 */
class PointCloudDataset extends pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__["default"] {

    initializeDataset( dataIterator ) {
        /* do nothing but valid */
        return {
            valid: true,
            data: undefined,
            iterator: dataIterator
        };
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/PointCloudLayer.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/PointCloudLayer.js ***!
  \*********************************************/
/*! exports provided: Sources, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Sources", function() { return Sources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointCloudLayer; });
/* harmony import */ var pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_6__);









var osg = OSG__WEBPACK_IMPORTED_MODULE_6___default.a.osg;

const Sources = {
    JAVELIN: 'Javelin',
    UNKNOWN: 'Unknown'
};

/**
 * Specifies a point cloud layer, that is a subclass from Layer
 * @memberof pcvizGIS
 * @extends pcvizGIS.Layer
 * @class
 * @param {pcvizGIS.PointCloudDataset} dataset the dataset associated to this layer
 */
class PointCloudLayer extends pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataset ) {
        super( dataset );

        this._minX = -1;
        this._maxX = -1;
        this._minY = -1;
        this._maxY = -1;
        this._minZ = -1;
        this._maxZ = -1;

        this._currentDistanceUnit = undefined;
        this._geoidHeight = undefined;

        this._hasExtraAttributes = false;
    }

    static addHeatmapElevationProperties( symbolizer ) {
        // New heatmap-elevation: setting default values here
        symbolizer.elevationPolicy = 'POINTCLOUD_LAYER_PROPERTIES.ELEVATION_POLICY_STEPPED';
        symbolizer.refElevation = null;
        symbolizer.hideAboveBelow = false;
        symbolizer.hideAboveBelowSize = 1; // values in meters (take into account the system unit in other place the UI)
        symbolizer.tolerance = 0.05; // values in meters (take into account the system unit in other place)
        symbolizer.incSize = 0.010; // values in meters (take into account the system unit in other place)
        symbolizer.numIntervals = null;
        symbolizer.repeatIntervals = false;
        symbolizer.planeNormal = JSON.stringify( [ 0, 0, 1 ] );
        symbolizer.planeConstant = 0;
    }

    static buildDefaultSymbolizer() {
        let symbolizer = {};
        symbolizer.pointSize = 3.0;
        symbolizer.geometry = 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_CIRCLE';
        symbolizer.sizePolicy = 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED';
        let randomColor = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.generateRandomRGBIntColor();
        let randomColorHex = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RGBIntToFullHex( randomColor );
        symbolizer.fixedColor = randomColorHex;

        symbolizer.lightOn = false;
        symbolizer.maxIntensity = null;
        symbolizer.minIntensity = null;
        symbolizer.maxZ = null;
        symbolizer.minZ = null;
        symbolizer.repeatRange = false;
        symbolizer.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB';
        symbolizer.maxDistance = 6.0;
        symbolizer.alpha = 1.0;

        PointCloudLayer.addHeatmapElevationProperties( symbolizer );
        return symbolizer;
    }

    getUrl() {
        return this._layerObject.url;
    }

    getDataOrigin() {
        return this._layerObject.dataOrigin;
    }

    getPoints() {
        return this._layerObject.points;
    }

    getMinRed() {
        return this._layerObject.minRed;
    }

    getMaxRed() {
        return this._layerObject.maxRed;
    }

    getMinGreen() {
        return this._layerObject.minGreen;
    }

    getMaxGreen() {
        return this._layerObject.maxGreen;
    }

    getMinBlue() {
        return this._layerObject.minBlue;
    }

    getMaxBlue() {
        return this._layerObject.maxBlue;
    }

    getMinIntensity() {
        return this._layerObject.minIntensity;
    }

    getMaxIntensity() {
        return this._layerObject.maxIntensity;
    }

    getMinClass() {
        return this._layerObject.minClass;
    }

    getMaxClass() {
        return this._layerObject.maxClass;
    }

    getFixedColor() {
        return this._layerObject.fixedColor;
    }

    getMajorVersion() {
        return this._layerObject.majorVersion;
    }

    getMinVersion() {
        return this._layerObject.minVersion;
    }

    getPatchVersion() {
        return this._layerObject.patchVersion;
    }

    getAlgorithm() {
        return this._layerObject.algorithm;
    }

    getDataDriver() {
        return this._layerObject.dataDriver;
    }

    getCapturedIn() {
        return this._layerObject.capturedIn;
    }

    getType() {
        return this.isOpen() ? super.getType() : pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].POINTCLOUD;
    }

    getIcon() {
        if ( this._icon.length === 0 )
            this._icon = this.getType();
        return this._icon;
    }

    setExtraAttributes( value ) {
        this._hasExtraAttributes = value;
    }

    hasExtraAttributes() {
        return this._hasExtraAttributes;
    }

    isIncomplete() {
        return this.isOpen() ? this._dataset.getAttribute( 'incomplete' ) : false;
    }

    render( layerRenderer, parent, parentNode ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();
        var self = this;
        parent.getPointCloudScene().setCenter( layerRenderer.getCenter() );
        layerRenderer.renderPointCloudLayer( this ).then( function () {

            var pointCloudNode = layerRenderer.getPointCloudSceneGraph( self );
            if ( !pointCloudNode ) {
                defer.resolve();
                return;
            }

            layerRenderer.setNodeToLayer( self, pointCloudNode );

            if ( pointCloudNode !== undefined ) {
                pointCloudNode.Id = self.getId();

                // Move the pointcloud according to center (Maybe we move this to other place)
                var transform = new osg.MatrixTransform();
                var center = [ pointCloudNode.PointCloudCenter[ 0 ], pointCloudNode.PointCloudCenter[ 1 ], pointCloudNode.PointCloudCenter[ 2 ] ];
                transform.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), center ) );
                transform.addChild( pointCloudNode );

                parentNode.addChild( transform );

                var nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.computeNodePath( parentNode );
                var modelMat = osg.computeLocalToWorld( nodePath, true );

                parent.getPointCloudScene().addPointCloudNode( pointCloudNode, modelMat ); // This doesn't add the node to the graph. Now, this is used to store some global pointcloud values


                pointCloudNode.bufferAttribute.setParentNode( parentNode );
                pointCloudNode.bufferAttribute.setGlobalCenter( layerRenderer.getCenter() );
                pointCloudNode.drawingRuleAttribute.setGlobalCenter( layerRenderer.getCenter() );
                pointCloudNode.drawingRuleAttribute.setParentNode( parentNode );

                pointCloudNode.drawingRuleAttribute._dirty = true;
            }

            if ( layerRenderer.getFeatureRendererId() !== 'Map' ) {
                self.setVisibilityCallback( layerRenderer.getFeatureRendererId(), function ( value ) {
                    pointCloudNode.setNodeMask( value ? self._visibleMask : 0x0 );
                } );
            }

            // this is necessary because the setVisibilityCallback is executed after the setVisible call in TocWidget
            self.setVisible( self.isVisible() );
            self.setRendered( true );
            self.setExtraAttributes( pointCloudNode.hasExtraAttributes );

            // set here the Heatmap style by default (for Verity). Fixme: hasExtraAttributes should be stored in the database, not rediscovered in rendering
            if ( pointCloudNode.hasExtraAttributes ) {
                self.setStyleProperty( 'drawingRule', 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_HEATMAP' );
                self.setStyleProperty( 'heatMap', 0 );
            }

            defer.resolve();
        } );
        return defer.promise;
    }

    ensureConfiguration( configuration ) {
        if ( configuration.style ) {
            // translate legacy property values
            var symbol = configuration.style.symbolizers.PointCloudSymbolizer;
            switch ( symbol.drawingRule ) {
            case 'RGB':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB';
                break;
            case 'Grayscale':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE';
                break;
            case 'Classification':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED';
                break;
            case 'Elevation':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION';
                break;
            case 'FixedColor':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR';
                break;
            case 'Categorized':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CATEGORIZED';
                break;
            case 'Heatmap Elevation':
                symbol.drawingRule = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION_HEATMAP';
                break;
            }
            switch ( symbol.geometry ) {
            case 'Square':
                symbol.geometry = 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_SQUARE';
                break;
            case 'Circle':
                symbol.geometry = 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_CIRCLE';
                break;
            case 'Oriented circle':
                symbol.geometry = 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_ORIENTED';
                break;
            }
            switch ( symbol.sizePolicy ) {
            case 'Fixed':
                symbol.sizePolicy = 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED';
                break;
            case 'Automatic':
                symbol.sizePolicy = 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC';
                break;
            }

            if ( symbol.elevationPolicy === undefined )
                // add default heatmap elevation config (for existing layers)
                PointCloudLayer.addHeatmapElevationProperties( symbol );

            return configuration;
        }
        // Note that there isn't default values for classification.

        // The layer has a default configuration
        if ( this._dataset.getLayerObject().configuration ) {
            configuration.style = this._dataset.getLayerObject().configuration.style;
            this.ensureStyle( configuration.style );
            return configuration;
        }

        // The layer does not have default configuration
        configuration.style = {
            symbolizers: {
                PointCloudSymbolizer: PointCloudLayer.buildDefaultSymbolizer( this )
            }
        };
        this.ensureStyle( configuration.style );
        return configuration;
    }

    ensureStyle( style ) {
        if ( !style.symbolizers || !style.symbolizers.PointCloudSymbolizer )
            return;

        var symbolizer = style.symbolizers.PointCloudSymbolizer;
        if ( symbolizer.maxIntensity === null )
            symbolizer.maxIntensity = this.getMaxIntensity();
        if ( symbolizer.minIntensity === null )
            symbolizer.minIntensity = this.getMinIntensity();
        if ( symbolizer.maxZ === null )
            symbolizer.maxZ = this.getMaxZ();
        if ( symbolizer.minZ === null )
            symbolizer.minZ = this.getMinZ();
    }

    close() {
        return this._dataset.close();
    }

    getDriver() {
        return this._dataset.getDriver();
    }

    getStyleProperty( property ) {
        return this.getStyle().PointCloudSymbolizer[ property ];
    }

    /**
     * This function set a layer property 
     * @method     
     * @param property , string 
     * @param value , string      
     */

    setStyleProperty( property, value ) {
        let style = this.getStyle();
        style.PointCloudSymbolizer[ property ] = value;
        this.setStyle( style );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Layer' ).updateLayerStyle( this, property, value );
    }
    /**
     * This function set a layer property and set it as dirty 
     * @method     
     * @param property , string 
     * @param value , string      
     */
    setStylePropertyAndDirty( property, value ) {
        this.setStyleProperty( property, value );
        this.dirtyProperty( property );
    }

    getPointCloudSceneData( project ) {
        var minZ = Number.MAX_VALUE;
        var maxZ = -Number.MAX_VALUE;
        var minIntensity = Number.MAX_VALUE;
        var maxIntensity = -Number.MAX_VALUE;
        var layers = project.getAllLayers().filter( function ( layer ) {
            return layer instanceof PointCloudLayer && layer.isOpen();
        } );

        for ( var i = 0; i < layers.length; i++ ) {
            let minExtentLayer = [ 0, 0, 0 ];
            let maxExtentLayer = [ 0, 0, 0 ];
            minExtentLayer[ 0 ] = layers[ i ].getMinX();
            minExtentLayer[ 1 ] = layers[ i ].getMinY();
            minExtentLayer[ 2 ] = layers[ i ].getMinZ();
            maxExtentLayer[ 0 ] = layers[ i ].getMaxX();
            maxExtentLayer[ 1 ] = layers[ i ].getMaxY();
            maxExtentLayer[ 2 ] = layers[ i ].getMaxZ();

            // Apply Transform matrices
            project.transformLayerExtent( layers[ i ], minExtentLayer, maxExtentLayer );

            minZ = Math.min( minZ, minExtentLayer[ 2 ] );
            maxZ = Math.max( maxZ, maxExtentLayer[ 2 ] );
            minIntensity = Math.min( minIntensity, layers[ i ].getMinIntensity() );
            maxIntensity = Math.max( maxIntensity, layers[ i ].getMaxIntensity() );
        }
        return {
            'minZ': minZ,
            'maxZ': maxZ,
            'minIntensity': minIntensity,
            'maxIntensity': maxIntensity
        };
    }

    canRemoveData() {
        return true;
    }

    removeData() {
        return new Promise( ( resolve, reject ) => {
            let pathsToDelete = [
                this.getWksUUID(),
                'process/tttl',
            ];
            this._dataset.setAttribute( 'url', null );
            this._dataset.setAttribute( 'incomplete', true );
            this.commitChanges().then( () => {
                resolve( pathsToDelete );
            }, reject );
        } );
    }

    initializePropertySet( project ) {
        pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.initializePropertySet.call( this );

        var self = this;

        var styleGroup = this.addPropertyField( {
            id: 'styleGroup',
            label: 'POINTCLOUD_LAYER_PROPERTIES.STYLE',
            type: 'GroupField'
        } );

        var drawingRuleOptions = [ 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION'
        ];
        if ( self.getMaxClass() - self.getMinClass() > 0 ) {
            drawingRuleOptions.push( 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED' );
        }
        drawingRuleOptions.push( 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR' );
        if ( self.hasExtraAttributes() ) {
            drawingRuleOptions.push( 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_HEATMAP' );
        }

        this.addPropertyField( {
            id: 'drawingRule',
            label: 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE',
            type: 'CharField',
            // removed Classification and Categorized DR (https://tps-jira.topcon.com/browse/COLW-448)
            valueRange: drawingRuleOptions,
            get: function () {
                return self.getStyleProperty( 'drawingRule' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'drawingRule', value );
            },
            editable: () => {
                return !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten ||
                    !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten.has( 'drawingRule' );
            },
            group: styleGroup
        } );

        var pointCloudSceneData = this.getPointCloudSceneData( project );
        // FIXME: Check the if inside the get function. If the DB has the right values, it may be unnecessary.
        this.addPropertyField( {
            id: 'maxIntensity',
            label: 'POINTCLOUD_LAYER_PROPERTIES.MAX_INTENSITY',
            type: 'IntegerField',
            valueRange: [ pointCloudSceneData.minIntensity, pointCloudSceneData.maxIntensity ],
            visible: function () {
                return ( self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE' ||
                    self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS' );
            },
            get: function () {
                var maxIntensity = self.getStyleProperty( 'maxIntensity' );
                if ( maxIntensity >= pointCloudSceneData.minIntensity && maxIntensity <= pointCloudSceneData.maxIntensity )
                    return maxIntensity;

                return pointCloudSceneData.maxIntensity;
            },
            set: function ( value ) {
                self.setStyleProperty( 'maxIntensity', value );
            },
            group: styleGroup
        } );

        // FIXME: Check the if inside the get function. If the DB has the right values, it may be unnecessary.
        this.addPropertyField( {
            id: 'minIntensity',
            label: 'POINTCLOUD_LAYER_PROPERTIES.MIN_INTENSITY',
            type: 'IntegerField',
            valueRange: [ pointCloudSceneData.minIntensity, pointCloudSceneData.maxIntensity ],
            visible: function () {
                return ( self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE' ||
                    self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS' );
            },
            get: function () {
                var minIntensity = self.getStyleProperty( 'minIntensity' );
                if ( minIntensity >= pointCloudSceneData.minIntensity && minIntensity <= pointCloudSceneData.maxIntensity )
                    return minIntensity;

                return pointCloudSceneData.minIntensity;
            },
            set: function ( value ) {
                self.setStyleProperty( 'minIntensity', value );
            },
            group: styleGroup
        } );

        self._currentDistanceUnit = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Units' ).getCurrentUnit( 'distance' );
        var crsParams = {
            sourceCRS: project.getDataCRS(),
            sourceProj4: project.getDataCRSProj4(),
            destinationGeoid: project.getGeoid()
        };

        const projectExtent = project.getUnprojectedExtent();
        const center = [ ( projectExtent[ 0 ] + projectExtent[ 3 ] ) / 2, ( projectExtent[ 1 ] + projectExtent[ 4 ] ) / 2, ( projectExtent[ 2 ] + projectExtent[ 5 ] ) / 2 ];
        self._geoidHeight = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_5___default.a.getGeoidCorrection( center, crsParams );

        // FIXME: Check the if inside the get function. If the DB has the right values, it may be unnecessary.
        this.addPropertyField( {
            id: 'maxZ',
            label: 'POINTCLOUD_LAYER_PROPERTIES.MAX_Z',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ ( pointCloudSceneData.minZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters,
                ( pointCloudSceneData.maxZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters
            ],
            visible: function () {
                return self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION';
            },
            get: function () {
                var maxZ = self.getStyleProperty( 'maxZ' );
                if ( maxZ <= pointCloudSceneData.maxZ && maxZ >= pointCloudSceneData.minZ )
                    return ( maxZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters;

                self.setStyleProperty( 'maxZ', pointCloudSceneData.maxZ );
                return ( pointCloudSceneData.maxZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters;
            },
            set: function ( value ) {
                var internalVal = value * self._currentDistanceUnit.fromMeters + self._geoidHeight;
                self.setStyleProperty( 'maxZ', internalVal );
            },
            getUnit: function () {
                return self._currentDistanceUnit.text;
            },
            group: styleGroup
        } );

        // FIXME: Check the if inside the get function. If the DB has the right values, it may be unnecessary.
        this.addPropertyField( {
            id: 'minZ',
            label: 'POINTCLOUD_LAYER_PROPERTIES.MIN_Z',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ ( pointCloudSceneData.minZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters,
                ( pointCloudSceneData.maxZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters
            ],
            visible: function () {
                return self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION';
            },
            get: function () {
                var minZ = self.getStyleProperty( 'minZ' );
                if ( minZ <= pointCloudSceneData.maxZ && minZ >= pointCloudSceneData.minZ )
                    return ( minZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters;

                self.setStyleProperty( 'minZ', pointCloudSceneData.minZ );
                return ( pointCloudSceneData.minZ - self._geoidHeight ) / self._currentDistanceUnit.fromMeters;
            },
            set: function ( value ) {
                var internalVal = value * self._currentDistanceUnit.fromMeters + self._geoidHeight;
                self.setStyleProperty( 'minZ', internalVal );
            },
            getUnit: function () {
                return self._currentDistanceUnit.text;
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'repeatRange',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'BooleanField',
            visible: function () {
                return self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION';
            },
            get: function () {
                return self.getStyleProperty( 'repeatRange' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'repeatRange', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'fixedColor',
            label: 'POINTCLOUD_LAYER_PROPERTIES.FIXED_COLOR',
            type: 'ColorField',
            visible: function () {
                return self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR';
            },
            get: function () {
                return self.getStyleProperty( 'fixedColor' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'fixedColor', value );
            },
            editable: () => {
                return !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten ||
                    !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten.has( 'fixedColor' );
            },
            group: styleGroup
        } );


        var drawingOptions;
        var classificationColorArray;
        var min;
        var max;
        drawingOptions = [ 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS'
        ];
        classificationColorArray = new Float32Array(
            [ 0.0, 0.0, 0.0, 1.0,
                0.0, 0.0, 0.0, 1.0,
                0.61, 0.33, 0.25, 1.0,
                0.18, 0.90, 0.28, 1.0,
                0.05, 0.71, 0.2, 1.0,
                0.05, 0.49, 0.13, 1.0,
                0.5, 0.5, 0.75, 1.0,
                1.0, 1.0, 1.0, 1.0,
                0.7, 0.0, 0.7, 1.0,
                0.0, 0.70, 1.0, 1.0,
                1.0, 0.5, 0.0, 1.0,
                1.0, 0.5, 0.5, 1.0,
                1.0, 1.0, 0.0, 1.0,
                0.5, 0.0, 1.0, 1.0,
                0.5, 0.5, 1.0, 1.0,
                0.0, 1.0, 0.5, 1.0
            ] );

        min = self.getMinClass();
        max = self.getMaxClass();

        // Returns true if the i element of the ClassificationArray is marked as active, else returns false
        function isCategoryVisible( i ) {
            var classificationVisibility = self.getStyleProperty( 'classificationVisibility' );
            if ( classificationVisibility !== undefined && classificationVisibility !== null )
                return ( JSON.parse( classificationVisibility )[ i ] === 1.0 ) ? true : false;
            return true; // If the classificationVisibility is not set, we assume that all are visible
        }

        function createPropertyFieldFromClassification( i ) {
            self.addPropertyField( {
                id: pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.lookUpClassification( i ),
                label: pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.lookUpClassification( i ),
                type: 'ClassificationField',
                visible: function () {
                    return self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CATEGORIZED' ||
                        self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED';
                },
                valueRange: [ 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB',
                    'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE',
                    'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED',
                    'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION',
                    'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS'
                ],

                get: function ( prop ) {
                    var val;
                    switch ( prop ) {
                    case 'active':
                        val = isCategoryVisible( i );
                        break;
                    case 'drawingRule':
                        // FIXME: (Now it is not used)    val = drawingOptions[ node.DrawingRuleArray[ i ] ];
                        val = 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED';
                        break;
                    case 'color':
                        val = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RgbTofullhex( [ classificationColorArray[ i * 4 ], classificationColorArray[ i * 4 + 1 ], classificationColorArray[ i * 4 + 2 ], classificationColorArray[ i * 4 + 3 ] ] );
                        break;
                    }
                    return val;
                },
                set: function ( value ) {
                    if ( value.active !== isCategoryVisible( i ) ) {
                        var classificationVisibility = self.getStyleProperty( 'classificationVisibility' );
                        var previous;
                        if ( classificationVisibility !== undefined && classificationVisibility !== null )
                            previous = JSON.parse( classificationVisibility );
                        if ( !previous )
                            previous = [ 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1 ];
                        previous[ i ] = previous[ i ] ? 0 : 1;
                        self.setStyleProperty( 'classificationVisibility', JSON.stringify( previous ) );
                    } // else if ( value.color !== Utils.RgbTofullhex( [ classificationColorArray[ i * 4 ], classificationColorArray[ i * 4 + 1 ], classificationColorArray[ i * 4 + 2 ], classificationColorArray[ i * 4 + 3 ] ] ) ) {
                    //  node.changeColorClassification( i, value.color );
                    // FIXME: (Now we can't allow to change the colour)
                    // } else if ( value.drawingRule !== undefined /* && value.drawingRule !== drawingOptions[ node.DrawingRuleArray[ i ] ]*/ ) {
                    //node.changeDrawingRuleClassification( i, getIntFromDrawingRuleString( value.drawingRule ) );
                    // FIXME: (Now we can't allow to change the drawing rule)
                    // }
                },
                group: styleGroup
            } );
        }

        if ( min !== max || min !== 0 )
            for ( var i = min; i <= max; i++ ) {
                createPropertyFieldFromClassification( i );
            }

        this.addPropertyField( {
            id: 'heatMap',
            label: 'POINTCLOUD_LAYER_PROPERTIES.HEATMAP_ID',
            type: 'IntegerField',
            valueRange: [ 0, 4 ], // TODO: We need to read it from the database. For now we use 5 (0 to 4) possible values (the same as the generated test data)
            visible: function () {
                return ( self.getProperty( 'drawingRule' ) === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_HEATMAP' );
            },
            get: function () {
                var heatMap = self.getStyleProperty( 'heatMap' );
                return heatMap;
            },
            set: function ( value ) {
                self.setStyleProperty( 'heatMap', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'geometry',
            label: 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY',
            type: 'CharField',
            valueRange: [ 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_SQUARE',
                'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_CIRCLE',
                'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_ORIENTED'
            ],
            get: function () {
                return self.getStyleProperty( 'geometry' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'geometry', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'sizePolicy',
            label: 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY',
            type: 'CharField',
            valueRange: [ 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED', 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC' ],
            get: function () {
                return self.getStyleProperty( 'sizePolicy' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'sizePolicy', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'maxDistance',
            label: 'POINTCLOUD_LAYER_PROPERTIES.MAX_DISTANCE',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 0.0, 6.0 ],
            visible: function () {
                return self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC';
            },
            get: function () {
                return self.getStyleProperty( 'maxDistance' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'maxDistance', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'pointSize',
            label: 'POINTCLOUD_LAYER_PROPERTIES.POINT_SIZE',
            type: 'FloatField',
            valueRange: [ 1, 10 ],
            decimals: 1,
            visible: function () {
                return self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED';
            },
            get: function () {
                if ( self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED' )
                    return self.getStyleProperty( 'pointSize' );
                return null;
            },
            set: function ( value ) {
                if ( self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED' ) {
                    self.setStyleProperty( 'pointSize', value );
                }
            },
            group: styleGroup
        } );


        this.addPropertyField( {
            id: 'pointSizeFactor',
            label: 'POINTCLOUD_LAYER_PROPERTIES.POINT_SIZE_FACTOR',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 1, 10 ],
            visible: function () {
                return self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC';
            },
            get: function () {
                if ( self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC' )
                    return self.getStyleProperty( 'pointSize' );
                return null;
            },
            set: function ( value ) {
                if ( self.getProperty( 'sizePolicy' ) === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC' ) {
                    self.setStyleProperty( 'pointSize', value );
                }
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'lightOn',
            label: 'POINTCLOUD_LAYER_PROPERTIES.LIGHT',
            type: 'BooleanField',
            get: function () {
                return self.getStyleProperty( 'lightOn' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'lightOn', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'alpha',
            label: 'POINTCLOUD_LAYER_PROPERTIES.ALPHA',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 0.0, 1.0 ],
            get: function () {
                return self.getStyleProperty( 'alpha' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'alpha', value );
            },
            editable: () => {
                return !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten ||
                    !pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' )._propertiesOverwritten.has( 'alpha' );
            },
            group: styleGroup
        } );

        // For CRE heatmap elevation (change labels if used)
        this.addPropertyField( {
            id: 'hideAboveBelow',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'BooleanField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'hideAboveBelow' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'hideAboveBelow', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'hideAboveBelowSize',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'FloatField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'hideAboveBelowSize' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'hideAboveBelowSize', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'refElevation',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'FloatField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'refElevation' );
            },
            set: ( value ) => {
                this.setStyleProperty( 'refElevation', value );
                // If using refElevation we should reset planeNormal and planeConstant
                this.setProperty( 'planeNormal', [ 0, 0, 1 ] );
                this.setProperty( 'planeConstant', 0 );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'incSize',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'FloatField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'incSize' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'incSize', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'tolerance',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'FloatField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'tolerance' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'tolerance', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'elevationPolicy',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'CharField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'elevationPolicy' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'elevationPolicy', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'repeatIntervals',
            label: 'POINTCLOUD_LAYER_PROPERTIES.REPEAT_RANGE',
            type: 'BooleanField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'repeatIntervals' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'repeatIntervals', value );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'planeNormal',
            label: '', // not needed because it is not shown
            type: 'ArrayField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'planeNormal' ); // For returning real value JSON.parse( self.getStyleProperty( 'planeNormal' ) );
            },
            set: function ( value ) {
                self.setStyleProperty( 'planeNormal', JSON.stringify( value ) );
            },
            group: styleGroup
        } );

        this.addPropertyField( {
            id: 'planeConstant',
            label: '', // not needed because it is not shown
            type: 'FloatField',
            visible: function () {
                return false;
            },
            get: function () {
                return self.getStyleProperty( 'planeConstant' );
            },
            set: function ( value ) {
                self.setStyleProperty( 'planeConstant', value );
            },
            group: styleGroup
        } );

    }

    // Methods that aren't implemented: getDriverSpatialReference, setDriverSpatialReference

}


/***/ }),

/***/ "./sources/pcvizGIS/Polygon.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/Polygon.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Polygon; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var pcvizGIS_Surface__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/Surface */ "./sources/pcvizGIS/Surface.js");




/**
 * Implements a Polygon geometry.
 * @class
 * @memberof pcvizGIS
 * @extends Surface
 */
class Polygon extends pcvizGIS_Surface__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor() {
        super();
        this._innerRings = [];
        this._outerRing = undefined;

        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON;
    }


    getGeometryName() {
        return 'Polygon';
    }

    getExteriorRing() {
        if ( this._outerRing !== undefined )
            return this._outerRing;
        else
            return undefined;
    }

    getInteriorRing( i ) {
        if ( i < 0 || i >= this._innerRings.length )
            return undefined;
        else
            return this._innerRings[ i ];
    }

    getNumInteriorRings() {
        return ( this._innerRings.length );
    }

    addRing( newRing ) {
        // We force to set an outerRing because the isClockwise function only works with Z-axis
        if ( newRing.isClockwise() || this._outerRing === undefined ) {
            this._outerRing = newRing;
            this.dirtyEnvelope();
        } else
            this._innerRings.push( newRing );
    }

    getNumCurves() {
        if ( this._outerRing !== undefined )
            return 1 + this._innerRings.length;
        else
            return 0;
    }

    closeRings() {
        this._outerRing.closeRings();
        for ( var i = 0; i < this._innerRings.length; i++ )
            this._innerRings[ i ].closeRings();
    }

    getArea() {
        var area = 0.0;

        if ( this.getExteriorRing() !== undefined ) {
            area = this.getExteriorRing().getArea();

            for ( var i = 0; i < this._innerRings.length; i++ ) {
                area -= this.getInteriorRing( i ).getArea();
            }
        }
        return area;
    }

    clone() {
        var copy = new Polygon();
        copy.copy( this );
        return copy;
    }

    /**
     * Copy the polygon passed to this polygon.
     * @param  {Polygon} polygon the polygon to be copied in this polygon
     * @method
     * @memberof pcvizGIS.Polygon
     */
    copy( polygon ) {
        pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.copy.call( this, polygon );

        if ( this._outerRing === undefined )
            this._outerRing = polygon._outerRing.clone();
        else
            this._outerRing.copy( polygon._outerRing );

        this._innerRings = [];
        for ( var i = 0; i < polygon._innerRings.length; i++ ) {
            this._innerRings[ i ] = polygon._innerRings[ i ].clone();
        }
    }

    clear() {}

    removeExteriorRing() {
        this._outerRing = undefined;
        this.dirtyEnvelope();
    }

    removeInteriorRing( i ) {
        this._innerRings.splice( i, 1 );
    }

    isPointOnSurface( point ) {
        if ( point === undefined )
            return;

        if ( this._outerRing.isPointInRing( point ) ) {
            // check that the point isn't in any interior ring (if a point is on the surface of an interior ring, it isn't on the polygon's surface)
            for ( var i = 0; i < this.getNumInteriorRings(); i++ ) {
                if ( this._innerRings[ i ].isPointInRing( point ) ) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }

    // Nowadays the centroid shown doesn't take account the projections.
    getCentroid() {

        // For exterior ring
        // Now we get the centroid based on the perimeter, but we could implement the computation based on the area
        return this._outerRing.getCentroid();
    }


    computeEnvelope( envelope ) {

        if ( this._outerRing !== undefined )
            envelope.copy( this._outerRing.getEnvelope() );
        else
            envelope.clear();

        return envelope;
    }

    // The 'selected' property field is used to highlight the selected vertex
    // FIXME: This only works for the exterior ring
    changeSelectedPropertyField( vertex ) {
        this.changePropertyField( 'exteriorRing', 'selected', vertex );
    }

    initializePropertySet() {
        var self = this;
        var transformedPoint = [];

        this.clearProperties();

        this.addPropertyField( {
            id: 'exteriorRing',
            label: 'VECTOR_LAYER_PROPERTIES.EXTERIOR_RING',
            type: 'PointArrayField',
            editable: function () {
                return self._isEditable;
            },
            selected: self.getSelectedVertex(),
            get: function () {
                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() )
                    return self.getExteriorRing().getRenderingPoints();

                var crsData = this.prepareCRS( layer, project );

                for ( var i = 0; i < self.getExteriorRing().getRenderingPoints().length; i++ ) {
                    self._transformPoint( transformedPoint,
                        self.getExteriorRing().getRenderingPoints()[ i ],
                        self.getExteriorRing()._transformedRenderingPoints[ i ],
                        crsData );
                }

                return self.getExteriorRing()._transformedRenderingPoints;
            },
            set: function ( value, index ) {
                // FIXME: This way to set a vertex must be changed when vertex edition branch
                // is merged into master because it implements methods to set its points.
                // Below it is set (temporarily) accessing directly to curve properties.

                var layer = self.getLayerSelected();
                var project = self.getProject();

                if ( !layer.getProjection() || !project.getProjection() ) {
                    if ( index === 0 && this.getExteriorRing().isClosed() )
                        self.getExteriorRing()._points[ self.getExteriorRing()._points.length - 1 ] = value;
                    self.getExteriorRing()._points[ index ] = value;

                    self.getExteriorRing()._renderingPoints[ index ] = value;

                } else {
                    var crsData = this.prepareCRS( layer, project );
                    crsData.addGeoid = true; // revert geoid correction

                    self._transformPoint( transformedPoint, value, transformedPoint, crsData );

                    if ( index === 0 && this.getExteriorRing().isClosed() ) {
                        self.getExteriorRing()._points[ self.getExteriorRing()._points.length - 1 ][ 0 ] = transformedPoint[ 0 ];
                        self.getExteriorRing()._points[ self.getExteriorRing()._points.length - 1 ][ 1 ] = transformedPoint[ 1 ];
                        self.getExteriorRing()._points[ self.getExteriorRing()._points.length - 1 ][ 2 ] = transformedPoint[ 2 ];
                    }
                    self.getExteriorRing()._points[ index ][ 0 ] = transformedPoint[ 0 ];
                    self.getExteriorRing()._points[ index ][ 1 ] = transformedPoint[ 1 ];
                    self.getExteriorRing()._points[ index ][ 2 ] = transformedPoint[ 2 ];

                    self.getExteriorRing()._renderingPoints[ index ][ 0 ] = transformedPoint[ 0 ];
                    self.getExteriorRing()._renderingPoints[ index ][ 1 ] = transformedPoint[ 1 ];
                    self.getExteriorRing()._renderingPoints[ index ][ 2 ] = transformedPoint[ 2 ];
                }

                if ( self._geometryEditedCallback )
                    self._geometryEditedCallback();
            },
            isDirty: function () {
                if ( !self._isEditable )
                    return self._dirty[ 'exteriorRing' ];
                else
                    return true;
            }
        } );
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Project.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/Project.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Project; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_WorkspaceDataset__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/WorkspaceDataset */ "./sources/pcvizGIS/WorkspaceDataset.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_LayerGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/LayerGroup */ "./sources/pcvizGIS/LayerGroup.js");
/* harmony import */ var pcvizGIS_WorkspaceLayerGroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/WorkspaceLayerGroup */ "./sources/pcvizGIS/WorkspaceLayerGroup.js");
/* harmony import */ var pcvizGIS_SerializerLayerVisitor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/SerializerLayerVisitor */ "./sources/pcvizGIS/SerializerLayerVisitor.js");
/* harmony import */ var pcvizGIS_Settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/Settings */ "./sources/pcvizGIS/Settings.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizGIS_WorkspaceExtentVisitor__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizGIS/WorkspaceExtentVisitor */ "./sources/pcvizGIS/WorkspaceExtentVisitor.js");
/* harmony import */ var pcvizGIS_LayerSet__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! pcvizGIS/LayerSet */ "./sources/pcvizGIS/LayerSet.js");


















const LAYERGROUP_CLASSES = {
    'WorkspaceLayerGroup': pcvizGIS_WorkspaceLayerGroup__WEBPACK_IMPORTED_MODULE_4__["default"]
};

/**
 * Specifies a project
 * @class
 * @memberof pcvizGIS
 * @property {string} _id The project id;
 * @property {Array} _layers Stores the layers in an Array of Layer objects
 * @property {string} _projection the projection relative to the Project
 * @property {pcvizGIS.ProjectDataset} _projectDataSet the dataset associated to this project
 * @property {object} _currentSettings the current values for the render settings of this project
 */
class Project extends pcvizGIS_LayerSet__WEBPACK_IMPORTED_MODULE_13__["default"] {
    constructor( projectDataSet ) {
        super();
        /* old */
        this._id = undefined;
        /****************************/

        this._projectDataSet = projectDataSet;
        this._currentSettings = undefined;
    }

    getDataset() {
        return this.getProjectDataset();
    }

    /**
     * Open the project using the project dataset given
     * @method
     * @memberof pcvizGIS.Project
     */
    open() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        this._projectDataSet.open().then( function () {
            self._projection = self._projectDataSet.getDriver().getProjectHorizProjection();
            self.initCurrentRenderSettings();

            self.refreshLayers().then( function ( layersOk ) {
                pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default.a.getInstance().getController( 'Workspace' ).ensureWorkspace( self ).then( () => {
                    if ( self._projection ) {
                        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default.a.getProjectionInfo( self._projection.substring( 5 ), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default.a.FORMAT.PROJ4 ).then( function ( proj4 ) {
                            self._proj4 = proj4;
                            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default.a.initGeoidList().then( function () {
                                self._geoid = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default.a.getGeoidByID( self._projectDataSet.getDriver().getProjectGeoid() );
                                self.refreshExtent();
                                defer.resolve( layersOk );
                            } ).catch( function ( error ) {
                                defer.reject( error );
                            } );
                        } );
                    } else {
                        self.refreshExtent(); // calculate extent with no CRS
                        defer.resolve( layersOk );
                    }
                } ).catch( ( error ) => defer.reject( error ) );
            } );
        } ).catch( function ( error ) {
            console.error( 'Error in promise (Project.open)' );
            defer.reject( error );
        } );

        return defer.promise;
    }

    projectDataExtentToProjectCRS( extentProjectData ) {

        return pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_8___default.a.reprojectExtent( extentProjectData, this._dataCRS, this._projection );
    }

    // manually recalculate extent
    refreshExtent() {

        let extentProject, extentProjectCRS;

        // include workspace extent
        if ( this.getWorkspace() ) {
            const wsVisitor = new pcvizGIS_WorkspaceExtentVisitor__WEBPACK_IMPORTED_MODULE_12__["default"]();
            wsVisitor.apply( this.getWorkspace().workspace );
            const wksExtent = wsVisitor.getExtent();

            if ( wksExtent[ 0 ] < wksExtent[ 3 ] ) { // valid
                extentProject = wksExtent;
                extentProjectCRS = wksExtent;
            }
        }

        let skipRasterExtent = this.isScanProject();

        return super.refreshExtent( extentProject, extentProjectCRS, skipRasterExtent, this.transformLayerExtent );
    }

    /**
     * Gets project dataset
     * @method
     * @memberof pcvizGIS.Project
     */
    getProjectDataset() {
        return this._projectDataSet;
    }

    /**
     * Gets the id
     * @method
     * @memberof pcvizGIS.Project
     */
    getId() {
        return this._projectDataSet.getDriver().getProjectId();
    }

    /**
     * Sets the id
     * @method
     * @memberof pcvizGIS.Project
     * @param {string} id The project id.
     */
    setId( id ) {
        this._projectDataSet.getDriver().setProjectId( id );
    }

    /**
     * Gets the project name
     * @method
     * @memberof pcvizGIS.Project
     */
    getName() {
        return this._projectDataSet.getDriver().getName();
    }

    /**
     * Gets the extensible data object, which includes saved views
     * @method
     * @memberof pcvizGIS.Project
     */
    getExtData() {
        if ( !this._projectDataSet )
            return undefined;
        return this._projectDataSet.getDriver().getExtensibleData();
    }

    /**
     * Sets and saves the extensible data object, which includes saved views
     * Returns promise
     * @method
     * @memberof pcvizGIS.Project
     * @param {object} extensible data to set/save.
     */
    setExtensibleData( extData ) {
        if ( !this._projectDataSet ) { // this happens in testing
            var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
            defer.resolve();
            return defer.promise;
        }
        return this._projectDataSet.getDriver().setExtensibleData( this._projectDataSet.getDriver().getProjectId(), extData );
    }

    /**
     * Gets the platform id of the creator user
     * @method
     * @memberof pcvizGIS.Project
     */
    getCreatedByIdInPlatform() {
        return this._projectDataSet.getDriver()._projectData.creatorUserId;
    }

    getAccessLevel() {
        return this._projectDataSet.getDriver().getProjectAccessLevel();
    }

    /**
     * Instantiates all layers and save them in _layers array
     * @method
     * @memberof  pcvizGIS.Project
     */
    refreshLayers() {
        return new Promise( ( resolve ) => {
            let promises = [];
            for ( let i = 0; i < this.getNumLayers(); i++ ) {
                let layerInstance = this.instantiateLayer( i );
                if ( !layerInstance ) {
                    continue;
                }
                this._layers[ i ] = layerInstance;

                this.openByTableOfContent( layerInstance, promises );
            }

            Promise.all( promises ).then( function ( layersOk ) {
                resolve( layersOk );
            } );
        } );
    }

    /**
     * Instantiates the layer indicated and save it in _layers array
     * @param  {integer} i the index of the layer to be instantiated
     * @method
     * @memberof pcvizGIS.Project
     */
    refreshLayer( i ) {
        this._layers.splice( i, 0, this.instantiateLayer( i ) );
    }

    /**
     * Set layers
     * @method
     * @memberof pcvizGIS.Project
     * @param {Array<Layer>} layers The layer array to be set.
     */
    setLayers( /*layers*/) {
        /*this._layers = layers;

        var event = new CustomEvent( 'resetLayers', {
            'detail': {
                layers: layers
            }
        } );
        document.body.dispatchEvent( event );
        /**/
        console.error( 'Method not implemented' );
    }

    /**
     * Delete all layers
     * @method
     * @memberof pcvizGIS.Project
     */
    deleteAllLayers() {
        /*this._layers = [];

        // update this._toc
        //^this.createTOC();

        var event = new CustomEvent( 'deleteAllLayers' );
        document.body.dispatchEvent( event );/**/
        console.error( 'Method not implemented' );
    }

    /**
     * Delete a layer by id
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} id The id of the layer to be deleted
     * @returns {promise} Returns a promise that resolves to `true` when the layer is deleted
     */
    deleteLayer( id, deleteSourceLayer ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var index = this.getIndexById( id );
        var self = this;
        this._projectDataSet.deleteLayer( id, deleteSourceLayer ).then( function () {
            // Computing index because this function is called to delete some layers without waiting the resolve
            index = self._layers.findIndex( ( layer ) => {
                return layer.getId() === id;
            } );
            self._layers.splice( index, 1 );
            self.refreshExtent();
            defer.resolve();
        }, function ( response ) {
            defer.reject( response );
        } );

        // Do we want to send an event?
        /*
            var dispatchEvent = function () {
                var event = new CustomEvent( 'deleteLayer', {
                    'detail': {
                        layerId: id,
                        layerName: name,
                        layerType: type,
                        layerIndex: i
                    }
                } );
                document.body.dispatchEvent( event );
            };

            dispatchEvent();
        */
        return defer.promise;
    }

    /**
     * Delete a layer by name
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} name the name of the layer to be deleted
     */
    deleteLayerByName( /*name*/) {
        console.error( 'Method not implemented' );
    }

    /**
     * Method to create a layer
     * @method
     * @memberof pcvizGIS.Project
     * @param {LayerDefinition} layerDefinition the layerDefinition of the layer to be created
     * @return {Layer} the new Layer object
     */
    createLayer( layerDefinition ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        this._projectDataSet.createLayer( layerDefinition ).then( function ( newLayerId ) {
            self.refreshLayer( self._projectDataSet.getDriver().getLayerIndexById( newLayerId ) );
            defer.resolve( self.getLayerById( newLayerId ) );
        }, function ( response ) {
            defer.reject( response );
        } );
        return defer.promise;
    }

    /**
     * Method to add an existing layer to this project
     * @method
     * @memberof pcvizGIS.Project
     * @param {Layer} layer the layer to be added
     */
    addLayer( idLayer ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();

        /* var dispatchEvent = function () {
            var event = new CustomEvent( 'addLayer', {
                'detail': {
                    layer: layer,
                    renderer: undefined
                }
            } );
            document.body.dispatchEvent( event );
        }; dispatchEvent();*/

        var self = this;

        this._projectDataSet.addLayer( idLayer ).then( function () {
            self.refreshLayer( self._projectDataSet.getDriver().getLayerIndexById( idLayer ) );
            self._extentDirty = true; // it can not be refreshed here, because new layer is not loaded yet
            defer.resolve( self.getLayerById( idLayer ) );
        }, function ( response ) {
            defer.reject( response );
        } );
        return defer.promise;
    }


    // get source layers from server which this user has access to them
    getSourceLayersByType( filter ) {
        return this._projectDataSet.getSourceLayersByType( filter );
    }

    // get source layers from server which this user has access to them
    getSourceLayersByGroup( id, filter ) {
        return this._projectDataSet.getSourceLayersByGroup( id, filter );
    }

    /**
     * Return the number of layers
     * @method
     * @memberof pcvizGIS.Project
     * @return {int} the length of the _layers Array
     */
    getNumLayers() {
        return this._projectDataSet.getDriver().getNumSourceLayers();
    }

    /**
     * Get the position of a layer by name
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} name the name of the layer
     * @return {int}      the position of the layer
     */
    getIndexByName( name ) {
        return this._projectDataSet.getDriver().getLayerIndexByName( name );
    }

    /**
     * Get the index of a layer in the layer array by its id.
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} id The id of the layer
     * @return {int}      The index of the layer
     */
    getIndexById( id ) {
        return this._projectDataSet.getDriver().getLayerIndexById( id );
    }

    /**
     * Instantiate and return the layer at the specified index
     * @method
     * @memberof pcvizGIS.Project
     * @param  {int} i the index
     * @return {Layer}   the layer of the _layers Array at the specified position
     */
    instantiateLayer( i ) {
        let layerTreeObject = this._projectDataSet.getDriver().getLayerByIndex( i );

        let layerInstance = super.instantiateLayer( layerTreeObject.id, layerTreeObject.layerType, this._projectDataSet.getDataSource() );

        if ( layerInstance ) {
            layerInstance.setLayerObject( layerTreeObject );
        }

        return layerInstance;
    }

    /**
     * Return the layer at the specified index
     * @method
     * @memberof pcvizGIS.Project
     * @param  {int} i the index
     * @return {Layer}   the layer of the _layers Array at the specified position
     */
    getLayer( i ) {
        return this._layers[ i ];
    }

    /**
     * Get a layer by name
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} name the layer's name
     * @return {Layer}      the layer with  name
     */
    getLayerByName( name ) {
        var i = this.getIndexByName( name );
        if ( i === -1 )
            return undefined;
        return this._layers[ i ];
    }

    /**
     * Get a layer by it id
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} id The layer id
     * @return {Layer}      the layer with the given id
     */
    getLayerById( id ) {
        var i = this.getIndexById( id );
        if ( i === undefined )
            return undefined;
        return this._layers[ i ];
    }

    /**
     * Get a layer whose name contains the given suffix
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} suffix The matching suffix
     * @return {Layer}      the layer with the given suffix in the name
     */
    getLayerBySuffix( suffix ) {
        var layers = this.getAllLayers();

        return layers.find( function ( layer ) {
            return layer.getName().endsWith( suffix );
        } );
    }

    /**
     * Get all the layers
     * @method
     * @memberof pcvizGIS.Project
     * @return {Array<Layer>} the project's layers
     */
    getAllLayers() {
        if ( this._extentDirty )
            this.refreshExtent();

        return super.getAllLayers();
    }

    /**
     * Set the projection
     * @method
     * @memberof pcvizGIS.Project
     * @param {string} projection the projection relative to this project
     */
    setProjection( projection, setToServer ) {
        super.setProjection( projection );

        if ( setToServer )
            this._projectDataSet.getDriver().setProjectHorizProjection( projection ); // Be careful, this executes a promise.
    }

    /**
     * Get the render settings from the server which name is the indicated
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} name the name of the render settings to get
     * @return {object}      the render settings from the server which name is the indicated
     */
    getRenderSettings() {
        return this._projectDataSet.getRenderSettings();
    }

    /**
     * Initialize the object which saves the current render settings.
     * We init the properties with the value in the URL, or a value in the server, or a default value (this is the priority order)
     * @method
     * @memberof pcvizGIS.Project
     */
    initCurrentRenderSettings() {
        this._currentSettings = new pcvizGIS_Settings__WEBPACK_IMPORTED_MODULE_6__["default"]( this._projectDataSet );
    }

    /**
     * Get the object which saves the current render settings.
     * @method
     * @memberof pcvizGIS.Project
     * @return {object}  the object which has the current render settings
     */
    getCurrentRenderSettings() {
        return this._currentSettings ? this._currentSettings.getRenderSettings() : undefined;
    }

    /**
     * Get the object which saves the current viewer settings.
     * @method
     * @memberof pcvizGIS.Project
     * @return {object}  the object which has the current viewer settings
     */
    getCurrentViewerSettings() {
        return this._currentSettings.getViewerSettings();
    }

    /**
     * Gets the project extent projected.
     * @method
     * @memberof pcvizGIS.Project
     * @param  {boolean} needRefresh default to false
     * @return {extentWGS84} a sliced coords array [6]
     *
     * This function was redesigned to include some extra-function calls, bringing all the code here
     * We use 'needRefresh' to calculate extents again
     * We return in any case a copy (slice) of _extentProjectCRS
     */
    getProjectedExtent( needRefresh = false ) {

        if ( needRefresh ) {
            //Lets  recalculate extents ( for example from GridTools)
            this.refreshExtent();
        }

        return super.getProjectedExtent();
    }

    /**
     * Transform min and max of layer extent applying parent transformations
     * @method
     * @memberof pcvizGIS.Project
     * @param {object} layer
     * @param {vec3} min extent values
     * @param {vec3} max extent values
     */
    transformLayerExtent( layer, minA, maxA ) {
        var group = layer.getParent();
        if ( group && group.transformExtent )
            group.transformExtent( minA, maxA );
    }

    /**
     * Gets the table of contents from the configuration
     * If it doesn't have any predefined configuration it creates the initial TOC
     * @method
     * @memberof pcvizGIS.Project
     */
    getTableOfContents( tableOfContents ) {
        let toc = ( tableOfContents ) ? tableOfContents : new pcvizGIS_LayerGroup__WEBPACK_IMPORTED_MODULE_3__["default"]();
        let layers = this.getAllLayers();

        return new Promise( ( resolve ) => {
            this.synchronizeTableOfContents( toc );

            let layersAdded = [];
            if ( this.getWorkspace() ) {
                this.synchronizeWorkspace( toc, this.getWorkspace().workspace, layers, layersAdded );
            }

            this.addOtherLayersToTOC( toc, layers, layersAdded );

            toc.cleanGroups();
            this.updateTableOfContentsConfiguration( toc );

            this.refreshExtent();

            resolve();
        } );
    }

    synchronizeWorkspace( layerGroup, node, layers, layersAdded ) {
        let childNode = layerGroup._children.find( child => child.getId() === node.uuid );

        if ( [ pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].POINTCLOUD, pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR, pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].RASTER ].includes( node.type ) ) {
            let layer = layers.find( layer => layer.getId() === node.catalogObjectId );
            if ( !layer ) {
                console.warn( `Layer ${node.catalogObjectId} not found in the project` );
                return;
            }
            if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR ) {
                layer.setCategory( node.category );
            }
            if ( childNode ) {
                return;
            }

            let layerExists = layerGroup._children.find( child => layer && child.getId() === layer.getId() );
            if ( layer ) {
                layersAdded.push( layer );
                if ( !layerExists )
                    layerGroup.addChild( layer );
                // layer refreshed, add its parent
                layer.setParent( layerGroup );
                layer.setWksUUID( node.uuid );
            }
            return;
        }

        if ( !childNode ) {
            // create TOC node
            let wsDataset = new pcvizGIS_WorkspaceDataset__WEBPACK_IMPORTED_MODULE_1__["default"]( this._projectDataSet.getDataSource() );
            wsDataset.setSourceLayerId( node.uuid );
            childNode = new pcvizGIS_WorkspaceLayerGroup__WEBPACK_IMPORTED_MODULE_4__["default"]( wsDataset );
            childNode.setName( node.name || node.category );
            childNode.setCategory( node.category );
            childNode.setIcon( node.category );
            childNode.setId( node.uuid );
            childNode.acceptChildren( true );
            layerGroup.addChild( childNode );
        }
        childNode.setTransformMatrix( node.transformMatrix );

        if ( childNode.getStyle() === undefined ) // FIX this should only be set for Stations or use the right style for each "category"
            childNode.setStyle( this.createLayerGroupStyle() );

        // Adding LayerGroup to workspace cache
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().updateOrCreateDataCacheObject( childNode.getId(), undefined, undefined, childNode );

        if ( node.children )
            node.children.forEach( child => {
                this.synchronizeWorkspace( childNode, child, layers, layersAdded );
            } );
    }

    openByTableOfContent( layer, promises ) {
        //Check layer visibility to open layers
        let toc = this._projectDataSet.getTableOfContents().layerGroup;
        if ( !toc ) {
            promises.push( layer.open() );
            return;
        }
        let tocLayer = this.searchLayerInTocById( toc, layer.getId() );
        if ( !tocLayer ) {
            promises.push( layer.open() );
            return;
        }

        if ( tocLayer.visible ) {
            promises.push( layer.open() );
        }
    }

    /**
     * Get TOC layer configuration
     * @method
     * @memberof pcvizGIS.Project
     * @param  {string} id The id of the layer
     * @return {int}      The index of the layer
     */
    searchLayerInTocById( toc, id ) {
        if ( toc.id === id ) {
            return toc;
        }
        if ( toc.children === undefined ) {
            return;
        }
        for ( let child of toc.children ) {
            let res = this.searchLayerInTocById( child.layerGroup ? child.layerGroup : child, id );
            if ( res ) {
                return res;
            }
        }
    }

    addOtherLayersToTOC( toc, layers, layersAdded ) {
        let i;
        for ( i = 0; i < layers.length; i++ ) {
            if ( layersAdded === undefined || ( !layersAdded.includes( layers[ i ] ) ) ) {
                let layer = layers[ i ];

                switch ( layer.getType() ) {
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR:
                    toc.addLayerToGroup( layer, layer.getCategory(), undefined );
                    break;
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].POINTCLOUD:
                    toc.addLayerToGroup( layer, layer.getType(), 'PointClouds' );
                    break;
                case pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].RASTER:
                    toc.addLayerToGroup( layer, layer.getType(), 'RasterLayers' );
                    break;
                default:
                    toc.addLayerToGroup( layer, layer.getType(), undefined );
                    break;
                }
            }
        }
    }

    createLayerGroup( layerData ) {
        if ( layerData.class ) {
            let wsDataset = new pcvizGIS_WorkspaceDataset__WEBPACK_IMPORTED_MODULE_1__["default"]( this._projectDataSet.getDataSource() );
            wsDataset.setSourceLayerId( layerData.id );
            return new LAYERGROUP_CLASSES[ layerData.class ]( wsDataset );
        }
        return new pcvizGIS_LayerGroup__WEBPACK_IMPORTED_MODULE_3__["default"]();
    }

    createLayerGroupStyle() {
        const categories = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default.a.getInstance().getController( 'Configuration' ).getCategories();

        if ( !categories || !categories.Station ) {
            return pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_11__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_11__["default"].Station ].style;
        }

        // We return a copy of the symbol object. Because if we return the original object
        // all workspace layers will have the same instance of the object
        return JSON.parse( JSON.stringify( categories.Station ) );
    }


    /**
     * Updates the tableOfContents in the configuration
     * @method
     * @memberof pcvizGIS.Project
     * @param tableOfContents table of contents to store
     */
    updateTableOfContentsConfiguration( tableOfContents ) {
        var self = this;
        var serializer = new pcvizGIS_SerializerLayerVisitor__WEBPACK_IMPORTED_MODULE_5__["default"]();
        tableOfContents.accept( serializer );
        this._projectDataSet.updateTableOfContents( serializer.getJSONObject() ).then( function ( configuration ) {
            if ( configuration !== undefined )
                self._projectDataSet._driver.setConfiguration( configuration );
        } );
    }

    /**
     * Synchronizes toc with the database table of contents
     * @method
     * @memberof pcvizGIS.Project
     * @param tableOfContents table of contents to synchornize
     */
    synchronizeTableOfContents( tableOfContents, datasetTableOfContents, keepCurrentLayers ) {
        if ( !tableOfContents )
            return;

        var dsTableOfContents = ( datasetTableOfContents ) ? datasetTableOfContents.layerGroup : this._projectDataSet.getTableOfContents().layerGroup;

        if ( !dsTableOfContents ) { // It's a layer leaf or it's invalid
            if ( !datasetTableOfContents ) // It's invalid
                return;
            var gisLayer = this._layers.find( function ( layer ) {
                return ( layer.getId() === datasetTableOfContents.id );
            } );
            if ( gisLayer ) {
                gisLayer.setIndex( datasetTableOfContents.index );
                gisLayer.setVisible( datasetTableOfContents.visible );
                gisLayer.setPreviousVisible( datasetTableOfContents.previousVisible );

                // Initialize category by parent's name in case a vector layer is not open, and it is outside the Workspace.
                if ( gisLayer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR && !gisLayer.isOpen() && !tableOfContents.getLayerGroupClass() ) {
                    gisLayer.setCategory( tableOfContents.getName() );

                    switch ( gisLayer.getCategory() ) { // From Model3DCategory
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.MODEL3D:
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.VERITY_REPORT:
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.VERITY_MODEL:
                        gisLayer.setIcon( '3d-model' );
                        break;
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.TIN:
                        gisLayer.setIcon( 'tin' );
                        break;
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.VOLUME:
                        gisLayer.setIcon( 'volume' );
                        break;
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.TARGET:
                        gisLayer.setIcon( 'target' );
                        break;
                    default:
                        break;
                    }

                }
                if ( keepCurrentLayers ) {
                    return;
                }
                let gisLayerExists = tableOfContents.getChildren().find( l => l.getId() === datasetTableOfContents.id );
                if ( gisLayerExists ) {
                    tableOfContents.replaceChild( gisLayerExists, gisLayer );
                    return;
                }
                tableOfContents.addChild( gisLayer );
            }
            return;
        }

        var self = this;
        // children should exist at this point
        if ( dsTableOfContents.children ) {
            dsTableOfContents.children.forEach( function ( dataLayer ) {
                if ( !dataLayer.layerGroup ) {
                    self.synchronizeTableOfContents( tableOfContents, dataLayer, keepCurrentLayers );
                    return;
                }

                var gisLayer = tableOfContents.getChildren().find( l => l.getId() === dataLayer.layerGroup.id );
                if ( !gisLayer ) {
                    // is a layerGroup that is not in tableOfContents
                    gisLayer = self.createLayerGroup( dataLayer.layerGroup );
                    gisLayer.setName( dataLayer.layerGroup.name );
                    gisLayer.setId( dataLayer.layerGroup.id );
                    gisLayer.setCategory( dataLayer.layerGroup.category );
                    gisLayer.setIcon( dataLayer.layerGroup.category );
                    gisLayer.setIndex( dataLayer.layerGroup.index );
                    gisLayer.setVisible( dataLayer.layerGroup.visible );
                    gisLayer.setSymbolVisibility( !dataLayer.layerGroup.hideSymbol );
                    // FIXME: TransformMatrix should not be stored in the TOC, so
                    // it should not be set here
                    gisLayer.setTransformMatrix( dataLayer.layerGroup.transformMatrix );
                    gisLayer.acceptChildren( true );
                    if ( !keepCurrentLayers )
                        tableOfContents.addChild( gisLayer );
                }
                self.synchronizeTableOfContents( gisLayer, dataLayer, keepCurrentLayers );
            } );
        }
    }

    getWorkspace() {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default.a.getInstance().getController( 'Workspace' ).getWorkspace();
    }

    setWorkspace( workspace ) {
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_10___default.a.getInstance().getController( 'Workspace' ).setWorkspace( workspace );
    }

    // scan projects

    isScanProject() {
        return this._projectDataSet.getDriver().getProjectType() === Project.SCAN_TYPE;
    }

    getType() {
        return this._projectDataSet.getDriver().getProjectType();
    }

    getLayersData() {
        let layersData = [];
        for ( var i = 0; i < this.getNumLayers(); i++ ) {
            const layer = this.getLayer( i );
            if ( !layer.isOpen() ) {
                continue;
            }
            const layerData = {
                id: layer.getId(),
                style: pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_9___default.a.parseJSON( JSON.stringify( layer.getStyle() ) )
            };
            layersData.push( layerData );
        }
        return layersData;
    }

    getControlPointsLayer() {
        return this._layers.find( function ( layer ) {
            if ( layer.isSuccessLoaded() )
                return pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].isControlPoint( layer.getCategory() );
        } );
    }

    getControlPointsLayers() {
        return this._layers.filter( function ( layer ) {
            if ( layer.isSuccessLoaded() )
                return pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].isControlPoint( layer.getCategory() );
        } );
    }

    getUuid() {
        return this._projectDataSet.getDriver().getProjectData( 'uid' );
    }

    reset() {
        this._projectDataSet.getDriver().reset();
    }
}

Project.COLLAGE_TYPE = 1;
Project.SCAN_TYPE = 3;


/***/ }),

/***/ "./sources/pcvizGIS/ProjectDataset.js":
/*!********************************************!*\
  !*** ./sources/pcvizGIS/ProjectDataset.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProjectDataset; });
/* harmony import */ var pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Dataset */ "./sources/pcvizGIS/Dataset.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3__);






/**
 * Defines a subclass of Dataset for Project
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.Dataset
 */
class ProjectDataset extends pcvizGIS_Dataset__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataSource ) {
        super( dataSource );
        this._driver = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( dataSource.getDriverId() );

        this._sourceLayerName = '';
        // this._token = undefined;

        this._renderSettings = undefined;
        this._tableOfContents = undefined;
    }

    open() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_2___default.a.defer();
        var self = this;
        this.openDriver().then( function ( result ) {
            self._renderSettings = self._driver.getRenderSettings();
            self._tableOfContents = self._driver.getTableOfContents();
            defer.resolve( result );
        } ).catch( function ( error ) {
            console.error( 'Error in promise (ProjectDataset.open)' );
            defer.reject( error );
        } );

        return defer.promise;
    }

    close() {
        return this.closeDriver();
    }

    init() {
        if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_3___default.a.getAuthorizationToken() === undefined && this.getDataSource().getUser() !== undefined ) {
            this.getDriver().setCredentials( this.getDataSource().getUser(), this.getDataSource().getPassword() );
        }
        return this.initDriver();
    }

    // This function is not used
    getDataIterator() {
        //return this._driver.getSourceLayerByName( this._sourceLayerName );
    }

    deleteLayer( id, deleteSourceLayer ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_2___default.a.defer();

        var self = this;
        this._driver.deleteLayerFromProject( this._driver.getProjectId(), id ).then( function () {
            self._driver.refreshProjectData( self._driver.getProjectId() ).then( function () {
                if ( deleteSourceLayer ) {
                    self._driver.deleteSourceLayer( id ).then( function () {
                        defer.resolve();
                    } ).catch( function () {
                        defer.reject();
                    } );
                } else
                    defer.resolve();
            }, function ( response ) {
                defer.reject( response );
            } );

        }, function ( response ) {
            defer.reject( response );
        } );

        return defer.promise;
    }

    createLayer( layerDefinition ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_2___default.a.defer();
        var self = this;

        pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getDriver( 'da.layer' ).createSourceLayer( layerDefinition ).then( function ( iterator ) {
            if ( iterator ) {
                self._driver.addLayerToProject( self._driver.getProjectId(), iterator.getId() ).then( function () {
                    self._driver.refreshProjectData( self._driver.getProjectId() ).then( function () {
                        defer.resolve( iterator.getId() );
                    } );
                }, function ( response ) {
                    defer.reject( response );
                } );
            } else
                defer.reject();
        }, function ( response ) {
            defer.reject( response );
        } );

        return defer.promise;
    }

    addLayer( idLayer ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_2___default.a.defer();
        var self = this;

        this._driver.addLayerToProject( this._driver.getProjectId(), idLayer ).then( function () {
            self._driver.refreshProjectData( self._driver.getProjectId() ).then( function () {
                defer.resolve();
            }, function ( response ) {
                defer.reject( response );
            } );
        }, function ( response ) {
            defer.reject( response );
        } );

        return defer.promise;
    }

    getSourceLayersByType( filter ) {
        return this._driver.getSourceLayersByType( filter );
    }

    getSourceLayersByGroup( id, filter ) {
        return this._driver.getSourceLayersByGroup( id, filter );
    }

    getRenderSettings() {
        var renderSettings;
        if ( this._renderSettings !== undefined )
            renderSettings = this._renderSettings;
        return renderSettings;
    }

    /**
     * Stores the settings in the server. If the project has no configuration,
     * a new one is created.
     * @method
     * @memberof pcvizGIS.ProjectDataset
     * @param  {Object} settingsObject The settings object.
     * @return {Promise} The promise that is resolved or rejected when commiting changes.
     */
    updateRenderSettings( settingsObject ) {
        if ( this._driver.getConfiguration() )
            return this._driver.updateRenderSettings( settingsObject, this._driver.getConfiguration().id );
        return this._driver.createRenderSettings( settingsObject );
    }

    /**
     * Gets the stored table of contents
     * @method
     * @memberof pcvizGIS.ProjectDataset
     */
    getTableOfContents() {
        return this._driver.getTableOfContents();
    }

    /**
     * Stores the table of contents in the server.
     * @method
     * @memberof pcvizGIS.ProjectDataset
     * @param  {Object} tableOfContentsObject The toc object.
     * @return {Promise} The promise that is resolved or rejected when commiting changes.
     */
    updateTableOfContents( tableOfContentsObject ) {
        this._tableOfContents = tableOfContentsObject;

        // TODO: review if it's necessary to pass the configuration id (it's already there) For now I'm leaving it
        //       as it is to avoid too many code changes at this point
        return this._driver.updateTableOfContents( tableOfContentsObject, this._driver.getConfiguration().id );
    }

    getProjectObject() {
        return this._driver.getProjectObject();
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/RasterDataset.js":
/*!*******************************************!*\
  !*** ./sources/pcvizGIS/RasterDataset.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RasterDataset; });
/* harmony import */ var pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/CollageDataset */ "./sources/pcvizGIS/CollageDataset.js");



/**
 * Defines a subclass of Dataset for Raster Layers
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.CollageDataset
 */
class RasterDataset extends pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__["default"] {

    initializeDataset( dataIterator ) {
        /* do nothing but valid */
        return {
            valid: true,
            data: undefined,
            iterator: dataIterator
        };
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/RasterLayer.js":
/*!*****************************************!*\
  !*** ./sources/pcvizGIS/RasterLayer.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RasterLayer; });
/* harmony import */ var pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_2__);






/**
 * Specifies a raster layer, that is a subclass from Layer
 * @memberof pcvizGIS
 * @extends pcvizGIS.Layer
 * @class
 * @param {pcvizGIS.RasterDataset} dataset the dataset associated to this layer
 */
class RasterLayer extends pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataset ) {
        super( dataset );

        this._minX = -1;
        this._maxX = -1;
        this._minY = -1;
        this._maxY = -1;
        this._minZ = -1;
        this._maxZ = -1;
    }

    static buildDefaultSymbolizer() {
        var symbolizer = {};
        return symbolizer;
    }


    getSource() {
        return this._layerObject.source;
    }

    getSourceParams() {
        return this._layerObject.sourceParams;
    }

    getSourceType() {
        return this._layerObject.sourceType;
    }

    getDataDriver() {
        return this._layerObject.dataDriver;
    }

    getIcon() {
        if ( this._icon.length === 0 )
            this._icon = this.getType();
        return this._icon;
    }

    isIncomplete() {
        return this._dataset.getAttribute( 'incomplete' );
    }

    render( layerRenderer, parent, parentNode ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_2___default.a.defer();
        var self = this;
        layerRenderer.renderRasterLayer( this ).then( function () {

            var rasterNode = layerRenderer.getRasterSceneGraph( self );
            if ( !rasterNode ) {
                defer.resolve();
                return;
            }

            layerRenderer.setNodeToLayer( self, rasterNode.children[ 0 ] );
            parentNode.addChild( rasterNode );

            // this is necessary because the setVisibilityCallback is executed after the setVisible call in TocWidget
            self.setVisible( self.isVisible() );
            self.setRendered( true );

            defer.resolve();
        }, ( error ) => {
            defer.reject( error );
        } );
        return defer.promise;
    }

    ensureConfiguration( configuration ) {
        if ( configuration.style ) {
            return configuration;
        }
        // Note that there isn't default values for classification.

        // The layer has a default configuration
        if ( this._dataset.getLayerObject().configuration ) {
            configuration.style = this._dataset.getLayerObject().configuration.style;
            this.ensureStyle( configuration.style );
            return configuration;
        }

        // The layer does not have default configuration
        configuration.style = {};
        this.ensureStyle( configuration.style );
        return configuration;
    }

    ensureStyle( style ) {
        if ( !style.symbolizers )
            return;
    }

    close() {
        return this._dataset.close();
    }

    getDriver() {
        return this._dataset.getDriver();
    }

    getStyleProperty( /*property*/) {
        // nothing to set (yet)
        return;
    }

    setStyleProperty( property, value ) {
        var style = this.getStyle();
        // TODO: Update simbolizer if required
        this.setStyle( style );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Layer' ).updateLayerStyle( this, property, value );
    }

    canRemoveData() {
        return false;
    }

    removeData() {
        // nothing to remove
    }

    initializePropertySet( /*project*/) {
        pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.initializePropertySet.call( this );
        // Properties: source, sourceParams and sourceType

        this.addPropertyField( {
            id: 'source',
            label: 'RASTER_LAYER_PROPERTIES.SOURCE',
            type: 'TextField',
            visible: () => {
                return true;
            },
            editable: () => {
                return false;
            },
            get: () => {
                return this.getSource();
            },
            set: () => {},
            group: 'baseGroup'
        } );


        this.addPropertyField( {
            id: 'sourceParams',
            label: 'RASTER_LAYER_PROPERTIES.SOURCE_PARAMS',
            type: 'TextField',
            visible: () => {
                return true;
            },
            editable: () => {
                return false;
            },
            get: () => {
                return this.getSourceParams();
            },
            set: () => {},
            group: 'baseGroup'
        } );


        this.addPropertyField( {
            id: 'sourceType',
            label: 'RASTER_LAYER_PROPERTIES.SOURCE_TYPE',
            type: 'TextField',
            visible: () => {
                return true;
            },
            editable: () => {
                return false;
            },
            get: () => {
                return this.getSourceType();
            },
            set: () => {},
            group: 'baseGroup'
        } );

    }

    // Methods that aren't implemented: getDriverSpatialReference, setDriverSpatialReference

}


/***/ }),

/***/ "./sources/pcvizGIS/ScanControlPointType.js":
/*!**************************************************!*\
  !*** ./sources/pcvizGIS/ScanControlPointType.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


const ScanControlPointType = {
    ENZ: 'ENZ',
    NEZ: 'NEZ',
    XYZ: 'XYZ'
};

/* harmony default export */ __webpack_exports__["default"] = (ScanControlPointType);


/***/ }),

/***/ "./sources/pcvizGIS/SerializerLayerVisitor.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGIS/SerializerLayerVisitor.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SerializerLayerVisitor; });
/* harmony import */ var pcvizGIS_LayerVisitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/LayerVisitor */ "./sources/pcvizGIS/LayerVisitor.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");





/**
 * Class for serilize Layers in a storable (json) data structure
 * @class
 * @memberof pcvizGIS
 */
class SerializerLayerVisitor extends pcvizGIS_LayerVisitor__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();
        this._layerTree = undefined; //this.computeLayerGroupJSONObject( new LayerGroup() );
        this._layerTreePath = [];
    }
    /**
     * visit Layer Group implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayerGroup( layerGroup ) {
        // TODO: push pop
        var jsonObject = this.computeLayerGroupJSONObject( layerGroup );
        this.pushJSONObjectAndTraverseLayer( jsonObject, layerGroup );
    }

    /**
     * visit Layer implementation. To be overriden by subclasses
     * @method
     * @memberof pcvizGIS.LayerDefinition
     */
    applyLayer( layer ) {
        var jsonObject = this.computeLayerJSONObject( layer );
        this.pushJSONObjectAndTraverseLayer( jsonObject, layer );
    }

    computeLayerGroupJSONObject( layerGroup ) {
        var jsonObject = {
            layerGroup: this.computeLayerJSONObject( layerGroup )
        };
        jsonObject.layerGroup.children = [];
        // FIXME: Transform matrix should not be serialized here to avoid
        // duplication. It is already in the workspace.json file
        if ( layerGroup.getTransformMatrix() ) {
            jsonObject.layerGroup.transformMatrix = Array.from( layerGroup.getTransformMatrix() );
        }
        if ( layerGroup.getCategory() ) {
            jsonObject.layerGroup.category = layerGroup.getCategory().slice();
        }
        jsonObject.layerGroup.class = layerGroup.getLayerGroupClass();
        return jsonObject;
    }

    computeLayerJSONObject( layer ) {
        var jsonObject = {
            name: ( layer._type === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].GROUP || layer.isOpen() ) ? layer.getName() : '',
            id: layer.getId(),
            visible: layer.isVisible(),
            previousVisible: layer.getPreviousVisible(),
            index: layer.getIndex()
        };
        if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].GROUP )
            Object.assign( jsonObject, { 'hideSymbol': layer.isSymbolHidden() } );

        return jsonObject;
    }

    pushJSONObjectAndTraverseLayer( jsonObject, layer ) {
        if ( !this._layerTree ) {
            // first traversed object
            this._layerTree = jsonObject;
        }

        if ( this._layerTreePath.length !== 0 ) {
            var parentJSONObject = this._layerTreePath[ this._layerTreePath.length - 1 ];

            if ( parentJSONObject.layerGroup ) // if it's a layer group then add it to the path
                parentJSONObject.layerGroup.children.push( jsonObject );
        }


        this._layerTreePath.push( jsonObject );
        layer.traverse( this );
        this._layerTreePath.splice( -1, 1 );
    }

    getJSONObject() {
        return this._layerTree;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/Settings.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/Settings.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Settings; });
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);




/**
 * Class to manage the project render settings
 * @class
 * @memberof pcvizGIS
 */
class RenderSettings {

    constructor( dataset ) {
        this._dataset = dataset;
        this._settingsObject = dataset.getRenderSettings();

        if ( !this._settingsObject ) {
            this._settingsObject = {
                levelOfDetail: 2.0,
                edlOn: true,
                SSAOOn: false,
                edlRadius: 1.0,
                edlContrast: 0.08,
                fieldOfView: 35.0
            };
        }
        if ( this._settingsObject.SSAOOn === undefined )
            this._settingsObject.SSAOOn = false;

        this.parseSettingsFromURL();
    }

    /**
     * Parses the settings from the URL.
     * @method
     * @memberof pcvizGIS.RenderSettings
     */
    parseSettingsFromURL() {
        this._settingsObject.levelOfDetail = parseFloat( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'LevelOfDetail', this._settingsObject.levelOfDetail ) );
        this._settingsObject.edlOn = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'edlOn', this._settingsObject.edlOn.toString() ) !== 'false';
        this._settingsObject.SSAOOn = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'SSAOOn', this._settingsObject.SSAOOn.toString() ) !== 'false';
        this._settingsObject.edlRadius = parseFloat( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'EdlRadius', this._settingsObject.edlRadius ) );
        this._settingsObject.edlContrast = parseFloat( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'EdlContrast', this._settingsObject.edlContrast ) );
        this._settingsObject.fieldOfView = parseFloat( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.getVariableFromURL( 'FieldOfView', this._settingsObject.fieldOfView ) );
    }

    /**
     * Gets the value of an attribute of the settings.
     * @param  {String} key The attribute name.
     * @return {any} The attribute value.
     */
    get( key ) {
        return this._settingsObject[ key ];
    }

    /**
     * Sets the value of an attribute of the settings.
     * @param  {String} key   The attribute name.
     * @param  {any} value The attribute value.
     */
    set( key, value ) {
        this._settingsObject[ key ] = value;
    }

    /**
     * Stores the changes in the database.
     * @return {Promise}  The promise that is resolved or rejected when commiting changes.
     */
    commitChanges() {
        return this._dataset.updateRenderSettings( this._settingsObject );
    }
}


/**
 * Class to manage the viewer settings
 * @class
 * @memberof pcvizGIS
 */
class ViewerSettings {
    constructor() {
        if ( !this._settingsObject ) {
            this._settingsObject = {
                mobileFullScreen: false
            };
        }
    }

    /**
     * Gets the value of an attribute of the settings.
     * @param  {String} key The attribute name.
     * @return {any} The attribute value.
     */
    get( key ) {
        return this._settingsObject[ key ];
    }

    /**
     * Sets the value of an attribute of the settings.
     * @param  {String} key   The attribute name.
     * @param  {any} value The attribute value.
     */
    set( key, value ) {
        this._settingsObject[ key ] = value;
    }

}


/**
 * Class to manage the project settings.
 * @class
 * @memberof pcvizGIS
 */
class Settings {
    constructor( dataset ) {
        this._dataset = dataset;

        this._renderSettings = new RenderSettings( dataset );
        this._culture = {}; // nowadays, this var is not used
        this._viewerSettings = new ViewerSettings();
    }

    /**
     * Returns the render settings.
     * @method
     * @memberof pcvizGIS.Settings
     * @return {RenderSettings}  The render settings object.
     */
    getRenderSettings() {
        return this._renderSettings;
    }

    /**
     * Returns the viewer settings.
     * @method
     * @memberof pcvizGIS.Settings
     * @return {ViewerSettings}  The viewer settings object.
     */
    getViewerSettings() {
        return this._viewerSettings;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/SpatialReference.js":
/*!**********************************************!*\
  !*** ./sources/pcvizGIS/SpatialReference.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SpatialReference; });


/**
 * Spatial Reference System (Not used now)
 * @class
 * @memberof pcvizGIS
 */
class SpatialReference {
    constructor() {
        this._crsHorizontal = 0;
        this._crsVertical = 0;
    }
    // Setters and Getters

    setCoordinateSystem( horizontalEPSGCode, verticalEPSGCode ) {
        this._crsHorizontal = horizontalEPSGCode;
        this._crsVertical = ( verticalEPSGCode !== undefined ) ? verticalEPSGCode : 0;
    }

    getCoordinateSystem() {
        return this._crsHorizontal;
    }

    getHorizontalCoordinateSystem() {
        return this._crsHorizontal;
    }

    getVerticalCoordinateSystem() {
        return this._crsVertical;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/StationCategory.js":
/*!*********************************************!*\
  !*** ./sources/pcvizGIS/StationCategory.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StationCategory; });
/* harmony import */ var pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/FeatureCategory */ "./sources/pcvizGIS/FeatureCategory.js");
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_5__);









var osg = OSG__WEBPACK_IMPORTED_MODULE_5___default.a.osg;

class StationCategory extends pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( layer ) {
        super( layer );
    }

    getGeometryType() {
        return pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POINT; // used to initialize base style
    }

    initializePropertySet( stationWksObj ) {
        var layer = this._layer;
        var self = this;

        var style = layer.getStyle();

        let categoryId = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ stationWksObj.getWorkspaceObject().category ] ).name;

        // Adding translation
        let trans = osg.vec3.create();
        layer.addPropertyField( {
            id: 'translateCal',
            label: 'SCAN_PROPERTIES.TRANSLATION',
            type: 'Point',
            group: categoryId,
            editable: () => {
                return false;
            },
            get: () => {
                var mat = stationWksObj.getTransformMatrix();
                var transposed = osg.mat4.create();
                if ( !pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_4___default.a.isEcefPoint( mat[ 3 ], mat[ 7 ], mat[ 11 ] ) )
                    osg.mat4.transpose( transposed, mat );
                osg.mat4.getTranslation( trans, transposed ? transposed : mat );
                return trans;
            }
        } );

        // Adding rotation in euler angles
        let angles = osg.vec3.create();
        layer.addPropertyField( {
            id: 'eulerRot',
            label: 'SCAN_PROPERTIES.EULER_ANGLES',
            type: 'Point',
            group: categoryId,
            editable: () => {
                return false;
            },
            get: () => {
                var mat = stationWksObj.getTransformMatrix();

                var transposed = osg.mat4.create();
                if ( !pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_4___default.a.isEcefPoint( mat[ 3 ], mat[ 7 ], mat[ 11 ] ) )
                    osg.mat4.transpose( transposed, mat );

                var rotQuad = osg.mat4.getRotation( osg.quat.create(), transposed ? transposed : mat );
                pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.makeEulerFromQuat( angles, rotQuad );
                return angles;
            }
        } );

        // STYLE

        var styleGroup = layer.addPropertyField( {
            id: 'styleGroupNoRules', // because the id is != 'styleGroup', the button to add rules will not appear
            label: 'VECTOR_LAYER_PROPERTIES.STYLE',
            type: 'GroupField',
            group: categoryId
        } );

        layer.addPropertyField( {
            id: 'stationColor',
            label: 'VECTOR_LAYER_PROPERTIES.COLOR',
            type: 'ColorField',
            editable: () => {
                return true;
            },
            get: () => {
                return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.RgbTofullhex( style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color );
            },
            set: value => {
                var symb = style.PointSymbolizer.floorSymbolizer.PointSymbolizer;
                var color = symb.color;
                let rgb = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.fullhexToRgb( value, color[ 3 ], true );
                symb.color = rgb;

                style.PointSymbolizer.stationSymbolizer.PointSymbolizer.color = rgb;
                style.PointSymbolizer.color = rgb;

                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
            group: styleGroup.field
        } );

        layer.addPropertyField( {
            id: 'stationSize',
            label: 'STATION_PROPERTIES.STATION_SIZE',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 0.1, 10.0 ],
            editable: () => {
                return true;
            },
            get: () => {
                return style.PointSymbolizer.stationSymbolizer.PointSymbolizer.size;
            },
            set: value => {
                style.PointSymbolizer.stationSymbolizer.PointSymbolizer.size = value;

                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
            group: styleGroup.field
        } );

        layer.addPropertyField( {
            id: 'autoscaleStation',
            label: 'STATION_PROPERTIES.AUTOSCALE_STATION',
            type: 'BooleanField',
            group: styleGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                return style.PointSymbolizer.stationSymbolizer.PointSymbolizer.autoScale;
            },
            set: value => {
                style.PointSymbolizer.stationSymbolizer.PointSymbolizer.autoScale = value;
                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews();
            }
        } );

        layer.addPropertyField( {
            id: 'floorSize',
            label: 'STATION_PROPERTIES.FLOOR_SIZE',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 1.0, 10.0 ],
            editable: () => {
                return true;
            },
            get: () => {
                return style.PointSymbolizer.floorSymbolizer.PointSymbolizer.size;
            },
            set: value => {
                style.PointSymbolizer.floorSymbolizer.PointSymbolizer.size = value;

                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
            group: styleGroup.field
        } );

        layer.addPropertyField( {
            id: 'autoscaleFloor',
            label: 'STATION_PROPERTIES.AUTOSCALE_FLOOR',
            type: 'BooleanField',
            group: styleGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                return style.PointSymbolizer.floorSymbolizer.PointSymbolizer.autoScale;
            },
            set: value => {
                style.PointSymbolizer.floorSymbolizer.PointSymbolizer.autoScale = value;
                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews();
            }
        } );

        layer.addPropertyField( {
            id: 'StationsShowLabels',
            label: 'VECTOR_LAYER_PROPERTIES.SHOWLABELS',
            type: 'BooleanField',
            group: styleGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                if ( style === undefined )
                    return false;
                return style.PointSymbolizer.showLabels;
            },
            set: value => {
                style.PointSymbolizer.showLabels = value;
                self._layer._dirtyLabels = true;
                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews();
            }
        } );

        // Alpha property
        layer.addPropertyField( {
            id: 'alpha',
            label: 'VECTOR_LAYER_PROPERTIES.ALPHA',
            type: 'FloatField',
            group: styleGroup.field,
            decimals: 1,
            valueRange: [ 0.0, 1.0 ],
            editable: () => {
                return !self._layer._editMode;
            },
            get: () => {
                var style = self._layer.getStyle();
                var color = style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color;
                return color[ 3 ];
            },
            set: value => {
                var style = self._layer.getStyle();
                style.PointSymbolizer.floorSymbolizer.PointSymbolizer.color[ 3 ] = value;
                style.PointSymbolizer.color[ 3 ] = value; // for label

                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            }
        } );

        // target decoration

        var targetGroup = layer.addPropertyField( {
            id: 'targetGroup',
            label: 'STATION_PROPERTIES.TARGET_GROUP',
            type: 'GroupField',
            group: styleGroup.field,
            visible: () => layer.getWorkspaceObjectProperties().backsight.backsightTarget ? true : false
        } );

        // show decorator
        layer.addPropertyField( {
            id: 'StationsShowDecorator',
            label: 'VECTOR_LAYER_PROPERTIES.SHOWDECORATOR',
            type: 'BooleanField',
            group: targetGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                if ( style === undefined )
                    return false;
                return style.PointSymbolizer.showDecorator;
            },
            set: value => {
                style.PointSymbolizer.showDecorator = value;
                self._layer._dirtyLabels = true;
                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews();
            }
        } );

        layer.addPropertyField( {
            id: 'targetLineColor',
            label: 'VECTOR_LAYER_PROPERTIES.COLOR',
            type: 'ColorField',
            group: targetGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.RGBIntToFullHex( style.PointSymbolizer.targetDecorator.LineSymbolizer.strokeColor );
            },
            set: value => {
                var symb = style.PointSymbolizer.targetDecorator.LineSymbolizer;
                var color = symb.strokeColor;
                let rgb = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.fullhexToRgb( value, color[ 3 ] );
                symb.strokeColor = rgb;

                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            }
        } );

        layer.addPropertyField( {
            id: 'targetLineWidth',
            label: 'VECTOR_LAYER_PROPERTIES.LINEWIDTH',
            type: 'FloatField',
            decimals: 1,
            valueRange: [ 1.0, 15.0 ],
            group: targetGroup.field,
            editable: () => {
                return true;
            },
            get: () => {
                return style.PointSymbolizer.targetDecorator.LineSymbolizer.strokeWidth;
            },
            set: value => {
                style.PointSymbolizer.targetDecorator.LineSymbolizer.strokeWidth = value;

                self._layer.setStyle( self._layer.getStyle() );
                self._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            }
        } );


    }

    getStyleProperty( style, property ) {
        return style.PointSymbolizer[ property ];
    }

    setStyleProperty( style, property, value ) {
        style.PointSymbolizer[ property ] = value;
        this._layer.setStyle( style );
    }
    configureLayerStyle( configuration, color ) {
        if ( !configuration.PointSymbolizer )
            configuration.PointSymbolizer = {};
        configuration.PointSymbolizer.color = color;
    }

    /**
     * Method to get the base symbolizer of a layer depending of the feature type
     * @memberof pcvizGIS.FeatureCategory
     * @return {Symbolizer}
     */
    getBaseSymbolizer( style ) {
        var symbolizer;
        if ( !style ) {
            return symbolizer;
        }

        return style.PointSymbolizer;
    }

    /**
     * Method to get the base color of a layer depending of the feature type
     * @memberof pcvizGIS.Model3DCategory
     * @return {Color} color array with the values [r,g,b,a]
     */
    getBaseColor( style ) {
        var color;
        if ( !style ) {
            return color;
        }

        color = style.PointSymbolizer.color;
        return color;
    }

    /**
     * Method to set the base color of a layer depending of the feature type
     * @memberof pcvizGIS.Model3DCategory
     * @param {Color} color array with the values [r,g,b,a]
     */
    setBaseColor( style, color ) {
        if ( !style ) {
            return;
        }
        style.PointSymbolizer.color = color;
        this._layer.setStyle( this._layer.getStyle() );
        return;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/Surface.js":
/*!*************************************!*\
  !*** ./sources/pcvizGIS/Surface.js ***!
  \*************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Surface; });
/* harmony import */ var pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js");



/**
 * Surface 
 * @class
 * @memberof pcvizGIS
 * @extends Geometry
 */

class Surface extends pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();
        this._type = pcvizGIS_Geometry__WEBPACK_IMPORTED_MODULE_0__["default"].SURFACE;
    }

    getArea() {}

    getDimension() {
        return 2;
    }

    getNumCurves() {}
}


/***/ }),

/***/ "./sources/pcvizGIS/Symbol.js":
/*!************************************!*\
  !*** ./sources/pcvizGIS/Symbol.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var Expression = __webpack_require__( /*! pcvizGIS/Expression */ "./sources/pcvizGIS/Expression.js" ).default;

/**
 * Interface for Symbol
 * @class
 * @memberof pcvizGIS
 */
var Symbol = function () {
    this._color = new Float32Array( 4 );
    this._selectionColor = undefined;
    this._editingColor = new Float32Array( 4 );
    this._showLabels = undefined;
    this._labelField = undefined;
};

Symbol.prototype = {

    configure: function ( /*style*/) {
        console.log( 'Symbol.configure: Not implemented' );
    },

    configureSymbolizers: function ( /* style or rule */) {
        console.log( 'Symbol.configureSymbolizers: Not implemented' );
    },

    configureAsInvisible: function () {
        console.log( 'Symbol.configureAsInvisible: Not implemented' );
    },

    configureLabels: function ( style ) {
        if ( !style )
            return;

        var symbolizer;
        if ( style.LineSymbolizer )
            symbolizer = style.LineSymbolizer;
        if ( style.PointSymbolizer )
            symbolizer = style.PointSymbolizer;
        if ( style.PolygonSymbolizer )
            symbolizer = style.PolygonSymbolizer;

        if ( !symbolizer )
            return;

        if ( symbolizer.showLabels !== undefined )
            this._showLabels = symbolizer.showLabels;
        if ( symbolizer.labelField )
            this._labelField = symbolizer.labelField;
    },

    setColor: function ( color ) {
        this._color = color;
    },
    getColor: function () {
        return this._color;
    },

    updateColor: function () {
        console.log( 'Symbol.updateColor: Not implemented' );
    },

    applyAlpha: function ( saveAlpha ) {
        if ( saveAlpha ) // default symbolizer (provides layer's alpha)
            this._alpha = this._color[ 3 ];
        else // rule symbolizer, modulate with layer's alpha
            this._color[ 3 ] = this._alpha;
    },

    /**
     * Set the selection color. By default, we're using the selection color of user's preferences.
     * But, if this method is called, the selection color used will be this.
     * @method
     * @memberof pcvizGIS.Symbol
     * @param {Array} color the color to be set as selection color
     */
    setSelectionColor: function ( color ) {
        Utils.copyVec4( color, this._selectionColor );
    },

    /**
     * Returns the color to be used as selection color. If there's a selection color assigned in this Symbol returns it,
     * else returns the value stored in user's preferences.
     * @method
     * @memberof pcvizGIS.Symbol
     * @return {Array} the color to be used in the selected feature
     */
    getSelectionColor: function () {
        return ( this._selectionColor === undefined ) ? Registry.getController( 'UserPreferences' ).getPreference( UtilsDB.SELECTION_COLOR_KEY ) : this._selectionColor;
    },

    setSelectionStrokeColor: function ( color ) {
        Utils.copyVec4( color, this._selectionStrokeColor );
    },
    getSelectionStrokeColor: function () {
        return this._selectionStrokeColor;
    },
    setEditingColor: function ( color ) {
        Utils.copyVec4( color, this._editingColor );
    },
    getEditingColor: function () {
        return this._editingColor;
    },

    // labelling

    setShowLabels: function ( showLabels ) {
        this._showLabels = showLabels;
    },

    getShowLabels: function () {
        return this._showLabels;
    },

    setLabelField: function ( fieldName ) {
        this._labelField = fieldName;
    },

    getLabelField: function () {
        return this._labelField;
    },

    // used both in Marker symbols and non-markers for labeling
    getMarkerPosition: function () {},


    // symbolization rules
    evaluateRule: function ( rule, feature ) {
        var condition = true;
        if ( rule.expression )
            condition = Expression.evaluateExpression( rule.expression, feature );

        if ( condition )
            this.configureSymbolizers( rule );

        return condition; // whether this rule was applied or not
    },

    evaluateRules: function ( feature ) {
        if ( !this._rules || !this._rules.rules || this._rules.rules.length < 1 )
            return;

        var self = this;
        var anyRule = false;
        this._rules.rules.forEach( function ( rule ) {
            if ( !anyRule )
                anyRule = self.evaluateRule( rule, feature );
        } );

        if ( !anyRule ) // no rule applied
            this.configureAsInvisible();
    }

};

/**
 * Point Symbol
 * @class
 * @memberof pcvizGIS
 */
var PointSymbol = function () {

    this._size = 1.0;
};

PointSymbol.prototype = Utils.objectInherit( Symbol.prototype, {

    setSize: function ( size ) {
        this._size = size;
    },
    getSize: function () {
        return this._size;
    },

} );

/**
 * Marker Symbol
 * @class
 * @memberof pcvizGIS
 */

var MarkerSymbol = function () {
    this._imageURL = '/assets/annotation-marker_48x48.png';
    this._selectionImageURL = '/assets/annotation-marker_48x48_selected.png';
    this._editingImageURL = '/assets/annotation-marker_48x48_selected.png'; // TODO: We need the edit marker image
    this._extraImageURL = new Map();
    this._isAutoScaled = true;
    this._isBillboard = true;
};

MarkerSymbol.prototype = Utils.objectInherit( Symbol.prototype, {

    setImageURL: function ( URL ) {
        this._imageURL = URL;
    },
    getImageURL: function () {
        return this._imageURL;
    },
    setSelectionImageURL: function ( URL ) {
        this._selectionImageURL = URL;
    },
    getSelectionImageURL: function () {
        return this._selectionImageURL;
    },
    setEditingImageURL: function ( url ) {
        this._editingImageURL = url;
    },
    getEditingImageURL: function () {
        return this._editingImageURL;
    },
    setBillboardEnabled: function ( value ) {
        this._isBillboard = value;
    },
    isBillboardEnabled: function () {
        return this._isBillboard;
    },
    setAutoScaleEnabled: function ( value ) {
        this._isAutoScaled = value;
    },
    isAutoScaleEnabled: function () {
        return this._isAutoScaled;
    },
    getExtraImageUrl: function () {
        return this._extraImageURL;
    }

} );


/**
 * Line Symbol
 * @class
 * @memberof pcvizGIS
 */
var LineSymbol = function () {
    this._lineWidth = 1.0;
};

LineSymbol.prototype = Utils.objectInherit( Symbol.prototype, {

    setLineWidth: function ( width ) {
        this._lineWidth = width;
    },

    getLineWidth: function () {
        return this._lineWidth;
    }

} );

/**
 * Fill Symbol
 * @class
 * @memberof pcvizGIS
 */
var FillSymbol = function () {
    this._strokeColor = undefined;
};

FillSymbol.prototype = Utils.objectInherit( Symbol.prototype, {

    getStrokeColor: function () {
        return this._strokeColor;
    },

    setStrokeColor: function ( color ) {
        this._strokeColor = color;
    }

} );

module.exports = {
    Symbol: Symbol,
    PointSymbol: PointSymbol,
    MarkerSymbol: MarkerSymbol,
    LineSymbol: LineSymbol,
    FillSymbol: FillSymbol
};


/***/ }),

/***/ "./sources/pcvizGIS/Utils.js":
/*!***********************************!*\
  !*** ./sources/pcvizGIS/Utils.js ***!
  \***********************************/
/*! exports provided: objectMix, objectInherit, copyVec3, copyVec4, distance, epsilonEqual, parseResponse */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objectMix", function() { return objectMix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objectInherit", function() { return objectInherit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyVec3", function() { return copyVec3; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyVec4", function() { return copyVec4; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distance", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "epsilonEqual", function() { return epsilonEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseResponse", function() { return parseResponse; });


/**
 * Utilities for pcvizGIS library
 * @memberof pcvizGIS
 */

// Objects' functions

function objectMix( obj, properties, test ) {
    for ( var key in properties ) {
        if ( !( test && obj[ key ] ) ) {
            obj[ key ] = properties[ key ];
        }
    }
    return obj;
}
function objectInherit( base ) {
    function F() {}
    F.prototype = base;
    var obj = new F();

    for ( var i = 1; i < arguments.length; i++ ) {
        objectMix( obj, arguments[ i ], false );
    }
    return obj;
}


// Vectors' functions
// TODO: use gl functions
function copyVec3( a, r ) {
    r[ 0 ] = a[ 0 ];
    r[ 1 ] = a[ 1 ];
    r[ 2 ] = a[ 2 ];
    return r;
}

function copyVec4( a, r ) {
    r[ 0 ] = a[ 0 ];
    r[ 1 ] = a[ 1 ];
    r[ 2 ] = a[ 2 ];
    r[ 3 ] = a[ 3 ];
    return r;
}

function distance( a, b ) {
    var x = a[ 0 ] - b[ 0 ];
    var y = a[ 1 ] - b[ 1 ];
    var z = a[ 2 ] - b[ 2 ];
    return Math.sqrt( x * x + y * y + z * z );
}


function epsilonEqual( a, b, eps ) {
    return ( Math.abs( a - b ) < eps );
}

function parseResponse( response ) {
    var out = JSON.parse( response );
    // this is because the response from the magnet platform does not come paginated
    if ( out.results === undefined ) {
        out = {
            results: out
        };
    }
    return out;
}


/***/ }),

/***/ "./sources/pcvizGIS/VectorDataset.js":
/*!*******************************************!*\
  !*** ./sources/pcvizGIS/VectorDataset.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VectorDataset; });
/* harmony import */ var pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/CollageDataset */ "./sources/pcvizGIS/CollageDataset.js");
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");




/**
 * Defines a subclass of Dataset for VectorLayers
 * @class
 * @memberof pcvizGIS
 * @param {pcvizGIS.DataSource} dataSource the data source associated to this dataset
 * @extends pcvizGIS.Dataset
 */
class VectorDataset extends pcvizGIS_CollageDataset__WEBPACK_IMPORTED_MODULE_0__["default"] {

    /**
     * Adds/Updates/Deletes a feature
     * @method
     * @memberof pcvizGIS.VectorDataset
     * @param  {string} method the method name (it can be: 'add','update', 'delete')
     * @param  {Feature} feature the feature to be updated
     */
    update( method, feature ) {
        return this._dataIterator.update( method, feature );
    }

    setSourceLayerName( name ) {
        this._sourceLayerName = name;
    }

    setSourceLayerId( id ) {
        this._sourceLayerId = id;
    }

    initializeDataset( dataIterator ) {
        if ( dataIterator.getNumFields() <= 0 )
            return undefined; // the function who calls waits an object or undefined

        var featureDefinition = new pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"]();

        for ( var i = 0; i < dataIterator.getNumFields(); i++ ) {
            featureDefinition.createField( dataIterator.getField( i ) );
        }

        featureDefinition.createFieldByNameAndType( 'geometry', dataIterator.getGeometryType() );
        return {
            valid: true,
            data: featureDefinition,
            iterator: dataIterator
        };
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/VectorLayer.js":
/*!*****************************************!*\
  !*** ./sources/pcvizGIS/VectorLayer.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VectorLayer; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/Feature */ "./sources/pcvizGIS/Feature.js");
/* harmony import */ var pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizGIS/FeatureCategory */ "./sources/pcvizGIS/FeatureCategory.js");
/* harmony import */ var pcvizGIS_Model3DCategory__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizGIS/Model3DCategory */ "./sources/pcvizGIS/Model3DCategory.js");
/* harmony import */ var pcvizGIS_VolumeCategory__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizGIS/VolumeCategory */ "./sources/pcvizGIS/VolumeCategory.js");

















/**
 * Specifies a vector layer, that is a subclass from Layer
 * @class
 * @memberof pcvizGIS
 * @extends pcvizGIS.Layer
 * @param {pcvizGIS.VectorDataset} dataset the dataset associated to this layer
 * @property {pcvizGIS.FeatureDefinition} _featureDefinition It represents the structure of the features that are contained in the layer.
 * @property {string} _category The category which the layer belongs to.
 */
class VectorLayer extends pcvizGIS_Layer__WEBPACK_IMPORTED_MODULE_6__["default"] {
    constructor( dataset ) {
        super( dataset );

        this._featureDefinition = undefined;
        this._featureRenderer = new Map();
        this._featureRendererDefaultId = '3D';
        // Default Value
        this._category = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.FEATURE;

        // Default Z value to render 2D layers.
        this._defaultZ = 0.0;

        this._selectedFeatureIds = new Set();

        this._editMode = false; // it shows if the layer is being edited by the LayerEdition Tool
        this._translateFields = new Set( [ 'name', 'description', 'frame_id', 'sequence_id', 'area', 'length', 'centroid(x)', 'centroid(y)', 'centroid(z)', 'file_name' ] );

        this._dirtyFeatures = true;
        this._dirtyLabels = true;

        this._categoryRenderer = undefined;

    }

    setCategoryRenderer( categoryRendenderer ) {
        this._categoryRenderer = categoryRendenderer;
    }

    getCategoryRenderer() {
        return this._categoryRenderer;
    }

    setFeatureDefinition( featureDefinition ) {
        this._featureDefinition = featureDefinition;
    }

    getFeatureDefinition() {
        return this._featureDefinition;
    }

    /*
      Trasform a layer feature that has data definition entered by the user using the dialog 
      in which the x, y and z need to be converted to meters from current units            
      @param {feature} a single feature definition            
    */
    transformFeatureFromUnitsToMeters( feature ) {
        this._transformFeatureUsingUnits( feature, true );
    }
    /*
      Trasform a layer feature that has data definition entered by the user using the dialog 
      in which the x, y and z need to be converted from meters to current unit 
      @param {feature} a single feature definition            
    */
    transformFeatureFromMetersToUnits( feature ) {
        this._transformFeatureUsingUnits( feature, false );
    }
    /*
      Trasform a layer feature from / to meters / current units  
      we don't use an 'if' condition to exit if we are going to tranform from meters to meters  (less code)  
      @param {feature} a single feature definition           
      @param {fromUnitToMeters} boolean 
    */
    _transformFeatureUsingUnits( feature, fromUnitsToMeters ) {
        let geoTypeString = this._category;
        let vectorTypes = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories;
        // Posible values : 'Control point' 'Annotation'   'Point' , 'LineString'  'Polygon', 'MultiPoint':                        
        if ( ![ vectorTypes.ANNOTATION, vectorTypes.CONTROL_POINT ].includes( geoTypeString ) ) {
            console.warn( 'TranformFeatureUsingUnits for: ' + geoTypeString + ', still not implemented' );
            return;
        }

        const unitController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Units' );
        let currentUnit = unitController.getCurrentUnit( 'distance' );
        let factor = 1 / currentUnit.fromMeters;
        if ( fromUnitsToMeters ) factor = 1 / factor;
        if ( factor === 1 ) return; // meters to meters ...  return

        // transformUsingUnitFactor implemented by now in vectorTypes.ANNOTATION, vectorTypes.CONTROL_POINT 
        feature.getGeometry().transformGeometryUsingUnitFactor( factor );
    }

    update( method, feature ) {

        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();

        var self = this;
        this._dataset.update( method, feature ).then( ( response ) => {
            this._dirtyFeatures = true;
            // This event is used in the map
            if ( method ) {
                var event = new CustomEvent( method + 'Feature', {
                    'detail': {
                        layer: self,
                        feature: feature
                    }
                } );
                document.body.dispatchEvent( event );
            }
            defer.resolve( response );
        } ).catch( function () {
            self._dirtyFeatures = false;
            defer.reject();
        } );

        return defer.promise;
    }

    /**
     * Add feature to the selected features group
     * @method
     * @memberof pcvizGIS.VectorLayer
     * @param  {int} featureId the id of the feature
     */
    selectFeature( featureId ) {
        this._selectedFeatureIds.add( featureId );
    }

    /**
     * Add several features  to the selected features in the layer
     * @method
     * @memberof pcvizGIS.VectorLayer
     * @param  {Array} featureIds it must to be a Set containing feature Ids
     */
    selectFeatures( featureIds ) {
        this._selectedFeatureIds = new Set( this._selectedFeatureIds, featureIds );
    }

    /**
     * Remove feature from the selected features group
     * @method
     * @memberof pcvizGIS.VectorLayer
     * @param  {int} featureId the id of the feature
     */
    deselectFeature( featureId ) {
        this._selectedFeatureIds.delete( featureId );
    }

    /**
     * Remove all features from the selection group
     * @method
     * @memberof pcvizGIS.VectorLayer
     */
    deselectAll() {
        this._selectedFeatureIds.clear();
    }

    /**
     * Get the selected features
     * @method
     * @memberof pcvizGIS.VectorLayer
     * @return {Set} Set containing the ids of the selected features in the layer.
     */
    getSelectedFeatures() {
        return this._selectedFeatureIds;
    }

    /**
     * To deprecate? Please, use 'layer.getFeatureDefinition().getGeomFieldType();'
     * @method
     * @memberof  pcvizGIS.VectorLayer
     * @return {int} the value that represents the geometry type of the layer
     */
    getGeometryType() {
        return this.getFeatureDefinition().getGeomFieldType();
    }

    setCategory( category ) {
        this._category = category;
    }

    getCategory() {
        return this._category;
    }

    getIcon() {
        if ( this._icon.length === 0 ) {
            if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].isPanorama( this._category ) )
                this._icon = this._category;
            else if ( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].isAnnotation( this._category, this._featureDefinition ) )
                this._icon = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.ANNOTATION;
            else
                this._icon = this.isOpen() ? this.getType() : 'VectorLayer';
        }
        return this._icon;
    }

    getUrl() {
        return this._layerObject.url;
    }

    render( layerRenderer, parent, parentNode ) {
        return this.getCategoryRenderer() ? this.getCategoryRenderer().render( layerRenderer, /* parent,*/ parentNode ) : Promise.resolve();
    }

    setFeatureRenderer( featureRenderer, id ) {
        this._featureRenderer.set( id, featureRenderer );

        var self = this;

        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getController( 'UserPreferences' ).registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1___default.a.PROJECT, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.SELECTION_COLOR_KEY, function () {
            var selectionObject = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'SelectionObject' ).getSelectionObject();
            if ( !selectionObject )
                return;
            if ( selectionObject.getLayer() === self ) {
                var feature = selectionObject.getFeature(); // if the layer is equal to this, the getFeature function exists
                if ( feature !== undefined && !feature.isEnabledEditMode() ) {
                    featureRenderer.getSymbol().deselectFeature( feature );
                    featureRenderer.getSymbol().selectFeature( feature );
                }
            }
        } );
    }

    getFeatureRenderer( id ) {
        if ( id === undefined )
            return this._featureRenderer.get( this._featureRendererDefaultId );
        return this._featureRenderer.get( id );
    }

    setDefaultFeatureRendererId( id ) {
        this._featureRendererDefaultId = id;
    }

    /**
     * Init the extent merging the envelope of each feature in the layer.
     * @method
     * @memberof  pcvizGIS.VectorLayer
     * @param  {CollageVectorDataIterator} dataIterator the iterator that has a GeoJSONDataIterator with the features
     */
    calculateExtent( dataIterator ) {
        this._extent = new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_4__["default"]();

        var featureIterator = new pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_5__["FeatureIterator"]( dataIterator, this );
        var feature;
        var g;

        while ( featureIterator.next() ) {
            feature = featureIterator.get();
            g = feature.getGeometry();
            this._extent.merge( g.getEnvelope() );
        }
    }

    open() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        var out = {
            loaded: true,
            error: undefined
        };
        this._dataset.open().then( function ( result ) {
                result.dataIterator.reset();
                self._category = self._dataset.getCategory();
                self.initializeExtent();

                if ( result !== undefined && result.valid === true ) {
                    self._open = true;
                    self._layerObject = self._dataset.getLayerObject();
                    self.setFeatureDefinition( result.data );
                    var mountController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Mount' );
                    if ( mountController )
                        mountController.addMountObject( self.getId(), self );

                    // if it is needed to add new categories with new format file.
                    // Add here, and create a new XXXCategory class. See Model3DCategory
                    switch ( self.getCategory() ) {
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.MODEL3D:
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.VERITY_REPORT:
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.TIN:
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.VERITY_MODEL:
                        self.setCategoryRenderer( new pcvizGIS_Model3DCategory__WEBPACK_IMPORTED_MODULE_11__["default"]( self ) );
                        break;
                    case pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.VOLUME:
                        self.setCategoryRenderer( new pcvizGIS_VolumeCategory__WEBPACK_IMPORTED_MODULE_12__["default"]( self ) );
                        break;
                    default:
                        self.setCategoryRenderer( new pcvizGIS_FeatureCategory__WEBPACK_IMPORTED_MODULE_10__["default"]( self ) );
                    }

                    var configuration;
                    configuration = self.ensureConfiguration( self._dataset.getDriver().getLayerConfigurationById( self.getId() ) );

                    self.setConfiguration( configuration );
                    self.setSuccessLoaded( true );
                    if ( self.getProjection() ) {
                        pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9___default.a.getProjectionInfo( self.getProjection().substring( 5 ), pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9___default.a.FORMAT.PROJ4 ).then( function ( proj4 ) {
                            self._proj4 = proj4;
                            pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_9___default.a.defProj4( self.getProjection(), proj4 );
                            defer.resolve( out );
                        } ).catch( function () {
                            // in case of error loading the projection ignore it
                            defer.resolve( out );
                        } );
                    } else {
                        defer.resolve( out );
                    }
                } else
                    defer.resolve( false );
            } )
            .catch( function ( error ) {
                console.log( 'Error in promise (VectorLayer.open) ' + error );
                self.setSuccessLoaded( false );
                out.loaded = false;
                out.error = error;
                defer.resolve( out );
            } );
        return defer.promise;
    }

    close() {
        return this._dataset.close();
    }

    getDriver() {
        return this._dataset.getDriver();
    }

    getFeatures( filter ) {
        const defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        const self = this;
        const openLayerPromise = this.isOpen() ? bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.resolve() : this.open();
        openLayerPromise.then( () => {
            // ! Currently changing getDataIterator to throw an error on no iterator or returning undefined can cause several errors on different places
            if ( !this._dataset.hasDataIterator() ) {
                defer.reject( new Error( 'Missing data iterator' ) );
            } else {
                this._dataset.getDataIterator( filter ).then( ( dataIterator ) => {
                    defer.resolve( new pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_5__["FeatureIterator"]( dataIterator, self ) );
                } );
            }
        } );
        return defer.promise;
    }

    // Convenience method to get a single feature by its id. It should be removed
    // when we implement the filter mechanism
    getFeature( id, config ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        if ( !config )
            config = {
                'page': 1,
                'page_size': this.getCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.VERITY_REPORT ? pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.VERITY_PAGE_SIZE : pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.PAGE_SIZE
            };
        var self = this;
        this.getFeatures( config ).then( function ( featureIterator ) {
            var found = false;
            featureIterator.reset();
            while ( featureIterator.next() ) {
                var f = featureIterator.get();
                if ( f.getId() === id ) {
                    defer.resolve( f );
                    found = true;
                    break;
                }
            }
            if ( !found ) {
                if ( featureIterator.getTotalNumFeatures() / config[ 'page_size' ] > config.page ) {
                    config.page++;
                    self.getFeature( id, config ).then( function ( feature ) {
                        defer.resolve( feature );
                    } ).catch( function () {
                        defer.reject();
                    } );
                } else
                    defer.reject();
            }
        } );
        return defer.promise;
    }

    /**
     * Method to get a single feature by an attribute (it will return the first found feature that passes the validation).
     * @param {string} attributeName
     * @param {*} attributeValue
     * @returns {pcvizGIS.Feature}
     */
    getFeatureByAttribute( attributeName, attributeValue ) {
        if ( !attributeName ) {
            console.error( 'Missing required argument when calling VectorLayer.getFeatureByAttribute function' );
            return;
        }
        return new Promise( ( resolve, reject ) => {
            const config = {
                'page': 1,
                'page_size': this.getCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.VERITY_REPORT ? pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.VERITY_PAGE_SIZE : pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.PAGE_SIZE
            };
            this.getFeatures( config ).then( ( featureIterator ) => {
                let found = false;
                featureIterator.reset();
                while ( featureIterator.next() ) {
                    const feature = featureIterator.get();
                    if ( feature.getAttributeByName( attributeName ) === attributeValue ) {
                        resolve( feature );
                        found = true;
                        break;
                    }
                }
                if ( !found ) {
                    if ( featureIterator.getTotalNumFeatures() / config[ 'page_size' ] > config.page ) {
                        config.page++;
                        this.getFeatureByAttribute( attributeName, attributeValue ).then( ( feature ) => {
                            resolve( feature );
                        } ).catch( function () {
                            reject();
                        } );
                    } else
                        reject();
                }
            } );
        } );
    }

    // return JSON
    getAllFeaturesByPages( page, geoJsonConcat ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;

        if ( page === undefined )
            page = 1;

        var config = {
            'page': page,
            'page_size': pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.PAGE_SIZE
        };
        this.getFeatures( config ).then( function ( featureIterator ) {
            var collageVectorDataIterator = featureIterator.getInternalDataIterator();
            var configId = config;
            configId.id = self.getId();
            var geoJsonObject = collageVectorDataIterator.getGeoJSONObject( configId );
            if ( geoJsonConcat === undefined )
                geoJsonConcat = {
                    'features': [],
                    'type': 'FeatureCollection'
                };

            geoJsonConcat.features = geoJsonConcat.features.concat( geoJsonObject.features );

            if ( featureIterator.getTotalNumFeatures() / pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.PAGE_SIZE > page ) {
                page++;
                self.getAllFeaturesByPages( page, geoJsonConcat ).then( function ( geoJsonObject ) {
                    defer.resolve( geoJsonObject );
                } );
            } else
                defer.resolve( geoJsonConcat );
        } );

        return defer.promise;
    }

    ensureConfiguration( configuration ) {
        return this.getCategoryRenderer().ensureConfiguration( configuration );
    }

    canRemoveData() {
        // Currently, only panorama layers can be emptied
        return pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].isPanorama( this._category );
    }

    removeData() {
        if ( !this.canRemoveData() ) {
            return Promise.resolve();
        }

        return new Promise( ( resolve, reject ) => {
            let pathsToDelete = [
                'images',
            ];
            this._dataset.setAttribute( 'storageUrl', '' );
            this._dataset.setAttribute( 'incomplete', true );
            this.commitChanges().then( () => {
                this.getFeatures().then( featureIterator => {
                    let promises = [];
                    featureIterator.reset();
                    while ( featureIterator.next() ) {
                        var feature = featureIterator.get();
                        promises.push( this.update( pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].DELETE_FEATURE, feature ) );
                    }
                    Promise.all( promises ).then( () => {
                        resolve( pathsToDelete );
                    }, reject );
                }, reject );
            }, reject );
        } );
    }

    initializePropertySet() {
        this.getCategoryRenderer().initializePropertySet( this );
    }

    // TODO: Returns a promise when refreshLayerInAllViews has been finished
    // Be careful when calling to this method
    updateSymbolRendererAndRefreshLayerInViews() {
        // this._featureRenderer is undefined when you've just created the layer (because it hasn't been rendered yet)
        if ( this.getFeatureRenderer( this._featureRendererDefaultId ) !== undefined )
            this.getFeatureRenderer( this._featureRendererDefaultId ).getSymbol().configure( this.getStyle() );
        return pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Layer' ).refreshLayerInAllViews( this );
    }

    setDefaultZ( zvalue ) {
        this._defaultZ = zvalue;
    }

    getDefaultZ() {
        return this._defaultZ;
    }

    setEditMode( value ) {
        this._editMode = value;
    }

    getDirtyFeatures() {
        return this._dirtyFeatures;
    }

    getDirtyLabels() {
        return this._dirtyLabels;
    }

    clearDirtyFlags() {
        this._dirtyFeatures = false;
        this._dirtyLabels = false;
        if ( this._category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].Categories.PLANAR_IMAGE )
            this.getFeatureRenderer().getSymbol().setCamerasInvalidation( false );
    }

    dirtyFeatures() {
        this._dirtyFeatures = true;
    }

    dirtyLabels() {
        this._dirtyLabels = true;
    }

    clearDirtyFeatures() {
        this._dirtyFeatures = false;
    }

    getTranslatedAttributeNames( options ) {

        var stringAttribs = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].getStringFields( this.getFeatureDefinition(), this.getCategory(), options );
        stringAttribs = this.convertFieldNamesForward( stringAttribs );

        return stringAttribs;
    }
    convertFieldNamesForward( names ) {
        var newNames = [];

        var self = this;
        names.forEach( function ( name ) {
            if ( self._translateFields.has( name ) || pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].CategoriesToAddFeaturePropertiesLabel.includes( self.getCategory() ) )
                newNames.push( 'FEATURE_PROPERTIES.' + name );
            else
                newNames.push( name );
        } );
        return newNames;
    }

    convertFieldNameBackward( name ) {
        var prefixLength = 'FEATURE_PROPERTIES.'.length;
        if ( name.length > prefixLength ) {
            var originalName = name.substring( prefixLength );
            if ( this._translateFields.has( originalName ) || pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_8__["default"].CategoriesToAddFeaturePropertiesLabel.includes( this.getCategory() ) )
                return originalName;
        }
        return name;
    }

    addStyleRule() {

        var style = this.getStyle();
        var baseSymbolizer = this.getCategoryRenderer().getBaseSymbolizer( style );
        if ( !baseSymbolizer )
            return false;

        if ( !baseSymbolizer.RuleSymbolizer )
            baseSymbolizer.RuleSymbolizer = {
                version: 1,
                rules: []
            };

        // find an index that is not taken

        // add rule in style
        var newRule = {
            expression: {
                constant: true
            }
        };
        this.getCategoryRenderer().configureDefaultStyle( newRule, true ); // add default symbol
        baseSymbolizer.RuleSymbolizer.rules.push( newRule );

        this.setStyle( style ); // refresh

        return true;
    }
    deleteStyleRule( ruleName ) {
        var style = this.getStyle();
        var baseSymbolizer = this.getCategoryRenderer().getBaseSymbolizer( style );
        if ( !baseSymbolizer || !baseSymbolizer.RuleSymbolizer )
            return false;

        // delete rule in style
        var ruleIndex = this.findRuleIndex( baseSymbolizer, ruleName );
        if ( ruleIndex === -1 )
            return false;
        baseSymbolizer.RuleSymbolizer.rules.splice( ruleIndex, 1 );

        this.setStyle( style ); // refresh

        return true;
    }

    findRuleIndex( baseSymbolizer, ruleName ) {
        return baseSymbolizer.RuleSymbolizer.rules.findIndex( function ( rule ) {
            return rule.id === ruleName;
        } );
    }

    setBaseColor( style, color ) {
        this.getCategoryRenderer().setBaseColor( style, color );
    }

    getBaseColor( style ) {
        return this.getCategoryRenderer().getBaseColor( style );
    }

    refreshLayerObject() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;
        var layerUrl = this.getDriver().getResource( 'layers', this.getId() );
        this.getDriver().getLayerFromServer( layerUrl ).then( function ( outLayer ) {
            self._dataset.getDataIterator().then( function ( dataIterator ) {
                var configuration = dataIterator.getLayerObject().configuration; // The configuration is set when the layer is opened. So, if we set a new layerObject, we need to set the configuration object again.
                dataIterator._layerObject = outLayer;

                dataIterator.getLayerObject().configuration = configuration;
                self._layerObject = self._dataset.getLayerObject();

                self.initializeExtent();
                defer.resolve();
            } );
        } );

        return defer.promise;
    }

    getNextFeature( id, config, nextTarget ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();
        var self = this;

        config = config || { page: 1, 'page_size': pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.PAGE_SIZE };
        nextTarget = nextTarget || false;

        this.getFeatures( config ).then( featureIterator => {
            featureIterator.reset();
            while ( featureIterator.next() ) {
                let f = featureIterator.get();

                if ( nextTarget ) {
                    return defer.resolve( f );
                }

                if ( f.getId() === id ) {
                    nextTarget = true;
                }
            }

            if ( featureIterator.getTotalNumFeatures() === 0 ) {
                return defer.resolve( [] );
            }

            if ( featureIterator.getTotalNumFeatures() / config[ 'page_size' ] > config.page ) {
                config.page++;
            } else {
                // end of layer features, force reset config and get first feature by default
                config = { page: 1, 'page_size': 1 };
                nextTarget = true;
            }

            return defer.resolve( self.getNextFeature( id, config, nextTarget ) );
        } );

        return defer.promise;
    }

    isIncomplete() {
        return this.isOpen() ? this._dataset.getAttribute( 'incomplete' ) : false;
    }

    getType() {
        return this.isOpen() ? super.getType() : pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].VECTOR;
    }

    getImageSrcByMount( feature, force, onMountCallback, onErrorCallback ) {
        return new Promise( ( resolve, reject ) => {
            const mountController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'Mount' );
            mountController.getMountObject( feature.getLayer().getId() ).getMountObject( force )
                .then( ( mount ) => {
                    const storageUrl = feature.getLayer().getDataset().getAttribute( 'storageUrl' );
                    if ( !storageUrl ) {
                        onErrorCallback();
                        return;
                    }

                    const token = '/files/';
                    const database = storageUrl.slice( storageUrl.lastIndexOf( token ) + token.length, storageUrl.length );
                    let fileName = feature.getAttributeByName( 'file_name' );

                    if ( fileName.includes( '.planarimage' ) || fileName.includes( '.panorama' ) ) {
                        fileName = `${fileName}/0/0/0.jpg`;
                    }

                    const src = `${mount.mountPoint}/${database}${fileName}?${mount.appendQuery}`;
                    onMountCallback( src );
                    resolve( src );
                } )
                .catch( ( error ) => {
                    pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getController( 'Error' ).addError( error );
                    if ( onErrorCallback ) {
                        onErrorCallback( error );
                    }
                    reject();
                } );
        } );
    }

    /**
     * Gets the coordinate system for layers of type Control Point.
     *
     * @returns {(string|undefined)} The Control Point layer coordinate system type (NEZ, EZN, XYZ). Or undefined when not setted.
     */
    getCoordinateSystem() {
        return this._layerObject ? this._layerObject.coordinateSystem : undefined;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/VectorLayerUtils.js":
/*!**********************************************!*\
  !*** ./sources/pcvizGIS/VectorLayerUtils.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VectorLayerUtils; });
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3__);






class VectorLayerUtils {

    // It depends on the category and the feature definition
    static isAnnotation( category, featureDefinition ) {
        if ( featureDefinition && featureDefinition.getFieldIndex( 'name' ) !== -1 && featureDefinition.getFieldIndex( 'description' ) !== -1 ) {
            return true;
        }

        return ( category === VectorLayerUtils.Categories.ANNOTATION || category === VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE );
    }

    static getCoordinateLabels( coordinateSystem, defaultValue = [ 'X(E)', 'Y(N)' ] ) {
        if ( coordinateSystem === 'XYZ' ) return Array.from( coordinateSystem );
        // Here we only handle the renaming of labels, so XYZ for both cases is renamed to ENZ.
        // Switching columns will be handled on the UI side where required.
        if ( coordinateSystem === 'ENZ' || coordinateSystem === 'NEZ' ) return Array.from( 'ENZ' );
        return defaultValue;
    }

    static getStringFields( featureDefinition, category, options, types ) {
        var fields = featureDefinition.getFields();
        var stringFields = [];
        var stringFieldTypes = [];

        const coordinateLabels = this.getCoordinateLabels( options && options.coordinateSystem );

        fields.forEach( function ( field ) {
            var type = field.getType();
            if ( ( type === 'TextField' || type === 'FloatField' || type === 'CharField' || type === 'IntegerField' || type === 'BooleanField' ) &&
                ( !options || !options.onlyVisible || field.getExtraAttribute( 'visible' ) ) ) {

                if ( category === VectorLayerUtils.Categories.CONTROL_POINT ) {
                    var projection = options && options.projectProjection;
                    let coordLabel;
                    switch ( field.getName() ) {
                    case 'X':
                        coordLabel = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getCoordLabel( projection, 0 ) === 'X' && options && options.overwriteControlPointLabels ? coordinateLabels[ 0 ] : pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getCoordLabel( projection, 0 );
                        stringFields.push( coordLabel );
                        if ( types )
                            stringFieldTypes.push( type );
                        return;

                    case 'Y':
                        coordLabel = pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getCoordLabel( projection, 1 ) === 'Y' && options && options.overwriteControlPointLabels ? coordinateLabels[ 1 ] : pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getCoordLabel( projection, 1 );
                        stringFields.push( coordLabel );
                        if ( types )
                            stringFieldTypes.push( type );
                        return;

                    case 'Z':
                        stringFields.push( pcvizUtils_CRSUtils__WEBPACK_IMPORTED_MODULE_3___default.a.getCoordLabel( projection, 2 ) );
                        if ( types )
                            stringFieldTypes.push( type );
                        return;

                    }
                }

                stringFields.push( field.getName() );
                if ( types )
                    stringFieldTypes.push( type );
            }
        } );


        if ( category === VectorLayerUtils.Categories.PLANAR_IMAGE || category === VectorLayerUtils.Categories.PANORAMA ) {
            var attribs = [ 'file_name' ];
            var fieldTypes = [ 'TextField' ];

            if ( stringFields.indexOf( 'sequence_id' ) !== -1 ) {
                attribs.push( 'sequence_id' );
                if ( types )
                    fieldTypes.push( 'IntegerField' );
            }
            if ( stringFields.indexOf( 'frame_id' ) !== -1 ) {
                attribs.push( 'frame_id' );
                if ( types )
                    fieldTypes.push( 'IntegerField' );
            }

            if ( types )
                return {
                    'fields': attribs,
                    'fieldTypes': fieldTypes
                };
            return attribs;
        }

        if ( types )
            return {
                'fields': stringFields,
                'fieldTypes': stringFieldTypes
            };
        return stringFields;
    }

    // Be careful if you use this function with a Panorama or Planar Image!
    static getStringFieldTypes( featureDefinition, options ) {
        var fields = featureDefinition.getFields();
        var stringFieldTypes = [];
        fields.forEach( function ( field ) {
            var type = field.getType();
            if ( ( type === 'TextField' || type === 'FloatField' || type === 'CharField' || type === 'IntegerField' || type === 'BooleanField' ) &&
                ( !options || !options.onlyVisible || field.getExtraAttribute( 'visible' ) ) )
                stringFieldTypes.push( type );
        } );
        return stringFieldTypes;
    }

    // BY CATEGORY (string)
    static isPanorama( category ) {
        return ( category === VectorLayerUtils.Categories.PANORAMA );
    }

    static isTrajectory( category ) {
        return ( category === VectorLayerUtils.Categories.TRAJECTORY );
    }

    static isPlanarImage( category ) {
        return ( category === VectorLayerUtils.Categories.PLANAR_IMAGE );
    }

    static isTarget( category ) {
        return ( category === VectorLayerUtils.Categories.TARGET );
    }

    static isEditable( category ) {
        return category !== VectorLayerUtils.Categories.PANORAMA && category !== VectorLayerUtils.Categories.PLANAR_IMAGE && category !== VectorLayerUtils.Categories.TRAJECTORY &&
            category !== VectorLayerUtils.Categories.MODEL3D && category !== VectorLayerUtils.Categories.VERITY_REPORT && category !== VectorLayerUtils.Categories.TIN && category !== VectorLayerUtils.Categories.VERITY_MODEL &&
            category !== VectorLayerUtils.Categories.VOLUME;
    }

    // Model3D and Verity report layers have models
    static isModel( category ) {
        return [ VectorLayerUtils.Categories.MODEL3D, VectorLayerUtils.Categories.VERITY_REPORT, VectorLayerUtils.Categories.TIN, VectorLayerUtils.Categories.VERITY_MODEL, VectorLayerUtils.Categories.VOLUME ].includes( category );
    }

    static isControlPoint( category ) {
        return ( category === VectorLayerUtils.Categories.CONTROL_POINT );
    }

    static isReferencePlane( category ) {
        return ( category === VectorLayerUtils.Categories.REFERENCE_PLANE );
    }

    static isReferencePolygon( category ) {
        return ( category === VectorLayerUtils.Categories.REFERENCE_POLYGON );
    }

    static isTIN( category ) {
        return ( category === VectorLayerUtils.Categories.TIN );
    }

    static isVolume( category ) {
        return ( category === VectorLayerUtils.Categories.VOLUME );
    }

    static isVerityModel( category ) {
        return ( category === VectorLayerUtils.Categories.VERITY_MODEL );
    }

    static isMachinery( category ) {
        return ( category === VectorLayerUtils.Categories.MACHINERY );
    }

    static isTargetLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            VectorLayerUtils.isTarget( layer.getCategory() );
    }

    static isPlaneLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            VectorLayerUtils.isReferencePlane( layer.getCategory() );
    }

    static isPolygonLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            layer.getGeometryType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON;
    }

    static isTINLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            VectorLayerUtils.isTIN( layer.getCategory() );
    }

    static isVolumeLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            VectorLayerUtils.isVolume( layer.getCategory() );
    }

    // this method is strictly for MODEL3d category
    static is3DModelLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR && layer.getCategory() === VectorLayerUtils.Categories.MODEL3D;
    }

    static isDesignDataLayer( layer ) {
        return layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_2__["default"].VECTOR &&
            ( layer.getCategory() === VectorLayerUtils.Categories.MODEL3D || VectorLayerUtils.isTIN( layer.getCategory() ) ||
                VectorLayerUtils.isReferencePlane( layer.getCategory() ) || VectorLayerUtils.isReferencePolygon( layer.getCategory() ) );
    }

    // BY FEATUREDEFINITION
    static hasAutomaticAttributes( featureDefinition ) {
        // for Points it returns false
        if ( featureDefinition.getFieldIndex( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.CENTROID_X_ATTR ) === -1 || featureDefinition.getFieldIndex( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.CENTROID_Y_ATTR ) === -1 ||
            featureDefinition.getFieldIndex( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.CENTROID_Z_ATTR ) === -1 )
            return false;

        if ( ( featureDefinition.getGeomField().getType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].LINE || featureDefinition.getGeomField().getType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON ) &&
            featureDefinition.getFieldIndex( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.LENGTH_ATTR ) === -1 )
            return false;

        if ( featureDefinition.getGeomField().getType() === pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON && featureDefinition.getFieldIndex( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.AREA_ATTR ) === -1 )
            return false;

        return true;
    }

    static isAutomaticAttributeMeasure( featureDefinition, i ) {
        return [ pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.LENGTH_ATTR, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.AREA_ATTR ].includes( featureDefinition.getFieldName( i ) );
    }

    static addPlanarImageAttrsToDefinition( layerDefinition ) {

        var attributes = [];
        var attributeX = {
            'name': 'quatX',
            'type': 'FloatField',
            'editable': 0,
            'order': 13,
            'visible': 0
        };
        var attributeY = {
            'name': 'quatY',
            'type': 'FloatField',
            'editable': 0,
            'order': 14,
            'visible': 0
        };
        var attributeZ = {
            'name': 'quatZ',
            'type': 'FloatField',
            'editable': 0,
            'order': 15,
            'visible': 0
        };
        var attributeW = {
            'name': 'quatW',
            'type': 'FloatField',
            'editable': 0,
            'order': 16,
            'visible': 0
        };
        var principalPointX = {
            'name': 'principalPointX',
            'type': 'FloatField',
            'editable': 0,
            'order': 17,
            'visible': 0
        };
        var principalPointY = {
            'name': 'principalPointY',
            'type': 'FloatField',
            'editable': 0,
            'order': 18,
            'visible': 0
        };
        var sensorWidth = {
            'name': 'sensorWidth',
            'type': 'FloatField',
            'editable': 0,
            'order': 19,
            'visible': 0
        };
        var sensorHeight = {
            'name': 'sensorHeight',
            'type': 'FloatField',
            'editable': 0,
            'order': 20,
            'visible': 0
        };
        var fovW = {
            'name': 'fovW',
            'type': 'FloatField',
            'editable': 0,
            'order': 21,
            'visible': 0
        };
        var fovH = {
            'name': 'fovH',
            'type': 'FloatField',
            'editable': 0,
            'order': 22,
            'visible': 0
        };
        var width = {
            'name': 'width',
            'type': 'FloatField',
            'editable': 0,
            'order': 23,
            'visible': 0
        };
        var height = {
            'name': 'height',
            'type': 'FloatField',
            'editable': 0,
            'order': 24,
            'visible': 0
        };
        var dateTime = {
            'name': 'dateTime',
            'type': 'TextField',
            'editable': 0,
            'order': 25,
            'visible': 0
        };
        var cameraDevice = {
            'name': 'cameraDevice',
            'type': 'TextField',
            'editable': 0,
            'order': 26,
            'visible': 0
        };
        var fileSize = {
            'name': 'fileSize',
            'type': 'IntegerField',
            'editable': 0,
            'order': 27,
            'visible': 0
        };
        var k1 = {
            'name': 'k1',
            'type': 'FloatField',
            'editable': 0,
            'order': 28,
            'visible': 0
        };
        var k2 = {
            'name': 'k2',
            'type': 'FloatField',
            'editable': 0,
            'order': 29,
            'visible': 0
        };
        var k3 = {
            'name': 'k3',
            'type': 'FloatField',
            'editable': 0,
            'order': 30,
            'visible': 0
        };
        var p1 = {
            'name': 'p1',
            'type': 'FloatField',
            'editable': 0,
            'order': 31,
            'visible': 0
        };
        var p2 = {
            'name': 'p2',
            'type': 'FloatField',
            'editable': 0,
            'order': 32,
            'visible': 0
        };
        var validPose = {
            'name': 'validPose',
            'type': 'BooleanField',
            'editable': 0,
            'order': 33,
            'visible': 0
        };

        attributes.push( attributeX );
        attributes.push( attributeY );
        attributes.push( attributeZ );
        attributes.push( attributeW );
        attributes.push( principalPointX );
        attributes.push( principalPointY );
        attributes.push( sensorWidth );
        attributes.push( sensorHeight );
        attributes.push( fovW );
        attributes.push( fovH );
        attributes.push( width );
        attributes.push( height );
        attributes.push( dateTime );
        attributes.push( cameraDevice );
        attributes.push( fileSize );
        attributes.push( k1 );
        attributes.push( k2 );
        attributes.push( k3 );
        attributes.push( p1 );
        attributes.push( p2 );
        attributes.push( validPose );

        attributes.forEach( function ( att ) {
            layerDefinition.addAttribute( att.name, att.type, att.editable, att.order, att.visible );
        } );

        return layerDefinition;
    }

    static addTargetAttrsToDefinition( layerDefinition ) {
        const attributes = [];
        let index = 0;

        const name = {
            'name': 'name',
            'type': 'TextField',
            'editable': 0,
            'order': ++index,
        };

        // LocalTarX
        const localX = {
            'name': 'LocalTarX',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index,
        };

        // LocalTarY
        const localY = {
            'name': 'LocalTarY',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // LocalTarZ
        const localZ = {
            'name': 'LocalTarZ',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // GlobalTarX
        const globalX = {
            'name': 'GlobalTarX',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // GlobalTarY
        const globalY = {
            'name': 'GlobalTarY',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // GlobalTarZ
        const globalZ = {
            'name': 'GlobalTarZ',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // GridTarX
        const gridX = {
            'name': 'GridTarX',
            'type': 'FloatField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // GridTarY
        const gridY = {
            'name': 'GridTarY',
            'type': 'FloatField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // GridTarZ
        const gridZ = {
            'name': 'GridTarZ',
            'type': 'FloatField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // TarH
        const tarH = {
            'name': 'TarH',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index,
        };

        // TarV
        const tarV = {
            'name': 'TarV',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // TarRange
        const tarRange = {
            'name': 'TarRange',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // TarHeight
        const tarHeight = {
            'name': 'TarHeight',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // H
        const h = {
            'name': 'H',
            'type': 'FloatField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // TargetTypeId
        const targetTypeId = {
            'name': 'TargetTypeId',
            'type': 'IntegerField',
            'editable': 0,
            'order': ++index
        };

        // TargetType;
        const targetType = {
            'name': 'TargetType',
            'type': 'TextField',
            'editable': 0,
            'order': ++index
        };

        // TarSize
        const tarSize = {
            'name': 'TarSize',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        // TargetVersion
        const targetVersion = {
            'name': 'TargetVersion',
            'type': 'TextField',
            'editable': 0,
            'order': ++index
        };

        // target file contents
        const fileContents = {
            'name': 'TargetFileContents',
            'type': 'TextField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // target guid
        const guid = {
            'name': 'guid',
            'type': 'TextField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        // target prism offset (or constant)
        const prismConstant = {
            'name': 'PrismConstant',
            'type': 'FloatField',
            'editable': 0,
            'visible': false,
            'order': ++index
        };

        const fittingPoints = {
            'name': 'FittingPoints',
            'type': 'IntegerField',
            'editable': 0,
            'order': ++index
        };

        const surfaceThickness = {
            'name': 'SurfaceThickness',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        const positionDeviation = {
            'name': 'PositionDeviation',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        const pointDrift = {
            'name': 'PointDrift',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };

        const radius = {
            'name': 'Radius',
            'type': 'FloatField',
            'editable': 0,
            'order': ++index
        };


        attributes.push( name );
        attributes.push( localX );
        attributes.push( localY );
        attributes.push( localZ );
        attributes.push( globalX );
        attributes.push( globalY );
        attributes.push( globalZ );
        attributes.push( gridX );
        attributes.push( gridY );
        attributes.push( gridZ );
        attributes.push( tarH );
        attributes.push( tarV );
        attributes.push( tarRange );
        attributes.push( tarHeight );
        attributes.push( h );
        attributes.push( targetTypeId );
        attributes.push( targetType );
        attributes.push( tarSize );
        attributes.push( targetVersion );
        attributes.push( fileContents );
        attributes.push( guid );
        attributes.push( prismConstant );
        attributes.push( fittingPoints );
        attributes.push( surfaceThickness );
        attributes.push( positionDeviation );
        attributes.push( pointDrift );
        attributes.push( radius );

        attributes.forEach( function ( att ) {
            layerDefinition.addAttribute( att.name, att.type, att.editable, att.order, att.visible );
        } );

        return layerDefinition;

    }

}
// To be removed as soon as we have categories from database

VectorLayerUtils.Categories = {
    FEATURE: 'Feature',
    ANNOTATION: 'Annotation',
    PANORAMA: 'Panorama',
    PLANAR_IMAGE: 'Planar image',
    TRAJECTORY: 'Trajectory',
    MODEL3D: '3D model',
    TARGET: 'Target',
    VERITY_REPORT: 'Verity report',
    CONTROL_POINT: 'Control point',
    REFERENCE_PLANE: 'Reference plane',
    REFERENCE_POLYGON: 'Reference polygon',
    TIN: 'TIN',
    VERITY_MODEL: 'Verity Model',
    VOLUME: 'Volume',
    MACHINERY: 'Machinery',
    4: 'Planar image'
};

VectorLayerUtils.CategoriesToHide = [
    VectorLayerUtils.Categories.PANORAMA,
    VectorLayerUtils.Categories.PLANAR_IMAGE,
    VectorLayerUtils.Categories.TRAJECTORY,
    VectorLayerUtils.Categories.MODEL3D,
    VectorLayerUtils.Categories.TARGET,
    VectorLayerUtils.Categories.VERITY_REPORT,
    VectorLayerUtils.Categories.CONTROL_POINT,
    VectorLayerUtils.Categories.REFERENCE_PLANE,
    VectorLayerUtils.Categories.REFERENCE_POLYGON,
    VectorLayerUtils.Categories.TIN,
    VectorLayerUtils.Categories.VERITY_MODEL,
    VectorLayerUtils.Categories.VOLUME,
    VectorLayerUtils.Categories.MACHINERY,
];

VectorLayerUtils.CategoriesToAddFeaturePropertiesLabel = [
    VectorLayerUtils.Categories.TIN,
    VectorLayerUtils.Categories.VOLUME,
    VectorLayerUtils.Categories.REFERENCE_PLANE,
    VectorLayerUtils.Categories.REFERENCE_POLYGON,
    VectorLayerUtils.Categories.TARGET,
    VectorLayerUtils.Categories.MACHINERY
];

// development
VectorLayerUtils.Categories.CAMERA_POSE = 'CameraPose';
VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE = 'Annotation with camera pose';

// String constants
VectorLayerUtils.ADD_FEATURE = 'add';
VectorLayerUtils.UPDATE_FEATURE = 'update';
VectorLayerUtils.DELETE_FEATURE = 'delete';


/***/ }),

/***/ "./sources/pcvizGIS/VolumeCategory.js":
/*!********************************************!*\
  !*** ./sources/pcvizGIS/VolumeCategory.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VolumeCategory; });
/* harmony import */ var _Model3DCategory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Model3DCategory */ "./sources/pcvizGIS/Model3DCategory.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _pcvizUtils_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../pcvizUtils/VectorLayerSelectionObject */ "./sources/pcvizUtils/VectorLayerSelectionObject.js");
/* harmony import */ var _pcvizUtils_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_pcvizUtils_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_2__);




class VolumeCategory extends _Model3DCategory__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( layer ) {
        super( layer );
        this._selectionObjectCtrl = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'SelectionObject' );
        this._feature = {};
        this.getFeature();
    }

    initializePropertySet() {
        _Model3DCategory__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.initializePropertySet.call(
            this,
            this._layer
        );
        let style = this._layer.getStyle();

        this._layer.addPropertyField( {
            id: 'tolerance',
            label: 'VECTOR_LAYER_PROPERTIES.TOLERANCE',
            type: 'FloatField',
            valueRange: [ 0, this._layer.getMaxZ() - this._layer.getMinZ() ],
            get: () => {
                return this.getStyleProperty( style, 'tolerance' );
            },
            set: ( value ) => {
                this.setStyleProperty( style, 'tolerance', value );
                this._layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            },
            group: 'styleGroup',
            translate: true
        } );

        const selectionObject = this._selectionObjectCtrl.getSelectionObject();

        if ( selectionObject instanceof _pcvizUtils_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_2___default.a ) {
            selectionObject.setFeature( this._feature );
        }
    }

    getFeature() {
        this._layer.getFeature( 1 ).then( ( feature ) => {
            this._feature = feature;
        } );
    }

    ensureConfiguration( configuration ) {
        super.ensureConfiguration( configuration );
        if ( configuration.style.symbolizers.PolygonSymbolizer.tolerance !== undefined )
            return configuration;
        configuration.style.symbolizers.PolygonSymbolizer.tolerance = 1.0; // default value
        return configuration;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceCategories.js":
/*!*************************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceCategories.js ***!
  \*************************************************/
/*! exports provided: default, WorkspaceStationTypes */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceCategories; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WorkspaceStationTypes", function() { return WorkspaceStationTypes; });


class WorkspaceCategories {

    /**
     * Get categories info
     * @method
     * @memberof pcvizGIS.WorkspaceCategories
     * @return {Object} the categories object with pairs (key, properties)
     */
    static getAllCategoryProps() {
        return WorkspaceCategories.Categories;
    }

    /**
     * Get info for a specific category
     * @method
     * @memberof pcvizGIS.WorkspaceCategories
     * @param {String} key requested key
     * @return {Object} obj the category properties for the requested key
     */
    static getCategoryProps( key ) {
        return WorkspaceCategories.Categories[ key ];
    }

    /**
     * Get all category keys
     * @method
     * @memberof pcvizGIS.WorkspaceCategories
     * @return {Array} list of available categories
     */
    static getCategoryKeys() {
        return Object.keys( WorkspaceCategories.Categories );
    }
}


/**
 * Configuration of categories
 * Categories should have an attribute called `fields` with an array of objects that
 * define the behavior of the properties object in the PropertyBag. The definition of
 * this object is the following:
 *
 * `name` | The key of the attribute in the properties object. For nested objects, the backslach (`/`) is
 * used as a separator. See `backsight/backsight` below.
 *
 * `visible` | (optional) A boolean value to define the visibility of the property. Default is `true`.
 *
 * `editable` | (optional) A boolean value to define if the property is editable. Default is `true`.
 *
 * `type` | (optional) The type of the property is detected but it is limited to `CharField`, `FloatField`,
 * `BooleanField`, `Point` and `GroupField`. Currently, arrays are detected as Points.
 *
 * `order` | (optional) The order value to sort the properties.
 *
 * `translate` | (optional) The translation label used if the property name needs translation.
 *
 * Note that all values are optionals. If none of them is needed to be changed, there is no need to add the
 * property here.
 *
 */
WorkspaceCategories.Categories = {
    GLS_PROJECT: {
        name: 'GLS Project',
        canCreate: false, // can not be created in UI
        icon: 'scanner-folder',
        fields: [ {
                name: 'testField1',
                visible: true,
                editable: false,
                type: 'TextField'
            },
            {
                name: 'testField1',
                visible: true,
                editable: true,
                type: 'FloatField'
            }
        ]
    },
    STATION_SET: {
        name: 'StationSet',
        canCreate: true,
        icon: 'scanner-folder',
    },
    STATION: {
        name: 'Station',
        canCreate: true,
        icon: 'scanners',
        fields: [ {
                name: 'type',
                editable: false,
                // type: 'CharField', // optional
                order: 0,
                translate: 'SCAN_PROPERTIES.TYPE'
            },
            {
                name: 'backsight',
                // type: 'GroupField', // optional
                translate: 'SCAN_PROPERTIES.BACKSIGHT'
            },
            {
                name: 'backsight/backsight',
                // visible: true, // optional
                editable: false,
                translate: 'SCAN_PROPERTIES.BACKSIGHT_COORD'
            },
            {
                name: 'backsight/backsightGlobal',
                visible: false,
            },
            {
                name: 'backsight/backsightGrid',
                visible: false,
            },
            {
                name: 'backsight/backsightPoint',
                editable: false,
                translate: 'SCAN_PROPERTIES.BACKSIGHT_POINT'
            },
            {
                name: 'backsight/backsightHeight',
                editable: false,
                translate: 'SCAN_PROPERTIES.BACKSIGHT_HEIGHT'
            },
            {
                name: 'backsight/backsightTarget',
                editable: false,
                translate: 'SCAN_PROPERTIES.BACKSIGHT_TARGET'
            },
            {
                name: 'backsight/backsightd',
                visible: false,
            },
            {
                name: 'occupation',
                // type: 'GroupField', // optional
                translate: 'SCAN_PROPERTIES.OCCUPATION'
            },
            {
                name: 'occupation/occupationGlobal',
                visible: false,
            },
            {
                name: 'occupation/occupationGlobalPosition',
                visible: false,
            },
            {
                name: 'occupation/occupationGrid',
                visible: false,
            },
            {
                name: 'occupation/occupationGridPosition',
                visible: false,
            },
            {
                name: 'occupation/occupationLocalPosition',
                visible: false,
            },
            {
                name: 'occupation/occupationPositionD',
                visible: false,
            },
            {
                name: 'occupation/occupationPoint',
                editable: false,
                translate: 'SCAN_PROPERTIES.OCCUPATION_POINT_NAME'
            },
            {
                name: 'occupation/occupationPosition',
                editable: false,
                translate: 'SCAN_PROPERTIES.OCCUPATION_POSITION'
            },
            {
                name: 'occupation/occHeight',
                editable: false,
                translate: 'SCAN_PROPERTIES.OCCUPATION_HEIGHT'
            },
            {
                name: 'instrumentHeight',
                visible: false,
            },
            {
                name: 'rodHeight',
                visible: false,
            },
            {
                name: 'translation',
                visible: false,
            }
        ],
    },
    SCAN_FOLDER: {
        name: 'ScansFolder',
        canCreate: true,
    },
    PRIMITIVE_FOLDER: {
        name: 'PrimitiveFolder',
        canCreate: true,
    },
    GENERIC_FOLDER: {
        name: 'Folder',
        canCreate: true,
    },
    SCAN: {
        name: 'Scan',
        canCreate: false,
        icon: 'pointcloud'
    },
    POINTCLOUD: {
        name: 'PointCloud',
        canCreate: false
    },
    PANORAMA: {
        name: 'Panorama',
        canCreate: false
    },
    TARGET: {
        name: 'Target',
        canCreate: true,
    },
    VERITY_REPORT: {
        name: 'Verity report',
        canCreate: false
    },
    PRIMITIVES: {
        name: 'Primitives',
        canCreate: false
    },
    PLANES: {
        name: 'Planes',
        canCreate: false
    }
};

WorkspaceCategories[ 'GLS Project' ] = 'GLS_PROJECT';
WorkspaceCategories.StationSet = 'STATION_SET';
WorkspaceCategories.Station = 'STATION';
WorkspaceCategories.ScansFolder = 'SCAN_FOLDER';
WorkspaceCategories.Scan = 'SCAN';
WorkspaceCategories.PointCloud = 'POINTCLOUD';
WorkspaceCategories.Panorama = 'PANORAMA';
WorkspaceCategories.Target = 'TARGET';
WorkspaceCategories.VerityReport = 'VERITY_REPORT';
WorkspaceCategories.Primitives = 'PRIMITIVES';
WorkspaceCategories.Planes = 'PLANES';

const WorkspaceStationTypes = { GLS: 'GlsStation', CR: 'CrStation' };


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceDataCache.js":
/*!************************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceDataCache.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceDataCache; });
/* harmony import */ var pcvizGIS_DataCacheObject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/DataCacheObject */ "./sources/pcvizGIS/DataCacheObject.js");




/**
 * Define a cache to relate workspace objects, OSG nodes and TOC nodes
 * @class
 * @memberof pcvizGIS
 */
class WorkspaceDataCache {
    constructor() {
        this._dataCacheMap = new Map();
    }

    /**
     * Add DataCacheObject to the map
     * @method
     * @memberof pcvizGIS.WorkspaceDataCache
     * @param {key} uuid to use as a key on the map     
     */
    addDataCacheObject( key, dataCacheObject ) {
        this._dataCacheMap.set( key, dataCacheObject );
    }

    /**
     * Add DataCacheObject by objects
     * @method
     * @memberof pcvizGIS.WorkspaceDataCache
     * @param {key} uuid to use as a key on the map
     * @param {object} WorkspaceObj to set
     * @param {object} osgObj to set
     * @param {object} tocObj to set     
     */
    addDataCacheObjectByObjects( key, workspaceObj, osgObj, tocObj ) {
        let dataCacheObj = new pcvizGIS_DataCacheObject__WEBPACK_IMPORTED_MODULE_0__["default"]();
        dataCacheObj.setWorkspaceObj( workspaceObj );
        dataCacheObj.setOsgNodeObj( osgObj );
        dataCacheObj.setLayerGroupObj( tocObj );

        this._dataCacheMap.set( key, dataCacheObj );
    }

    updateOrCreateDataCacheObject( key, workspaceObj, osgObj, tocObj ) {
        let cacheObj = this.getDataCacheObject( key );
        // checking if exist
        if ( cacheObj === undefined ) {
            this.addDataCacheObjectByObjects( key, workspaceObj, osgObj, tocObj );
            return;
        }
        if ( workspaceObj !== undefined )
            cacheObj.setWorkspaceObj( workspaceObj );
        if ( osgObj !== undefined )
            cacheObj.setOsgNodeObj( osgObj );
        if ( tocObj !== undefined )
            cacheObj.setLayerGroupObj( tocObj );

    }

    /**
     * Get DataCacheObject from the map
     * @method
     * @memberof pcvizGIS.WorkspaceDataCache
     * @param {key} the uuid of the object
     * @return {Object} the object retrieved
     */
    getDataCacheObject( key ) {
        let obj = this._dataCacheMap.get( key );
        return obj;
    }

    /**
     * Remove DataCacheObject from the map
     * @method
     * @memberof pcvizGIS.WorkspaceDataCache
     * @param {key} the uuid of the object
     * @return {Bool} the result of the operation 
     */
    removeDataCacheObject( key ) {
        return this._dataCacheMap.delete( key );
    }

    findElementsByCategory( category ) {
        let elementsArray = [];

        this._dataCacheMap.forEach( function ( element ) {
            let wsObject = element.getWorkspaceObj();
            if ( wsObject !== undefined && wsObject.category === category )
                elementsArray.push( element );
        } );

        return elementsArray;
    }

    getDataCacheObjectById( id ) {
        let layer;
        this._dataCacheMap.forEach( element => {
            let layerObject = element.getLayerGroupObj();
            if ( layerObject !== undefined && layerObject.getId() === id )
                layer = element;
        } );

        return layer;
    }

    // not used
    getDataCacheMap() {
        return this._dataCacheMap;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceDataset.js":
/*!**********************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceDataset.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceDataset; });
/* harmony import */ var pcvizGIS_VectorDataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/VectorDataset */ "./sources/pcvizGIS/VectorDataset.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var pcvizDataAccess_DataIterators_WorkspaceLayerGroupDataIterator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDataAccess/DataIterators/WorkspaceLayerGroupDataIterator */ "./sources/pcvizDataAccess/DataIterators/WorkspaceLayerGroupDataIterator.js");





class WorkspaceDataset extends pcvizGIS_VectorDataset__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataSource ) {
        super( dataSource );
    }

    open() {
        return new Promise( ( resolve, reject ) => {
            this.openDriver().then( () => {
                this.getDataIterator().then( iterator => {
                    resolve( this.initializeDataset( iterator ) );
                } );
            }, () => {
                console.log( 'CollageDataset.open: Exception opening the dataset' );
                reject();
            } );
        } );

    }

    getDataIterator() {
        return new Promise( ( resolve, reject ) => {
            let layerObject = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( this._sourceLayerId ).getWorkspaceObj();
            let dataIterator = new pcvizDataAccess_DataIterators_WorkspaceLayerGroupDataIterator__WEBPACK_IMPORTED_MODULE_3__["default"]( this._driver, layerObject );
            dataIterator.initIterator().then( () => {
                resolve( dataIterator );
            }, reject );
        } );
    }

    initializeDataset( dataIterator ) {
        if ( dataIterator.getNumFields() <= 0 )
            return undefined; // the function who calls waits an object or undefined

        var featureDefinition = new pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_2__["default"]();

        for ( var i = 0; i < dataIterator.getNumFields(); i++ ) {
            featureDefinition.createField( dataIterator.getField( i ) );
        }

        // featureDefinition.createFieldByNameAndType( 'geometry', dataIterator.getGeometryType() );
        return {
            valid: true,
            data: featureDefinition,
            iterator: dataIterator
        };
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceExtentVisitor.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceExtentVisitor.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceExtentVisitor; });
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_2__);





var osg = OSG__WEBPACK_IMPORTED_MODULE_2___default.a.osg;
var mat4 = osg.mat4;

/**
 * Workspace visitor to get the workspace extent
 * @class
 * @memberof pcvizGIS
 */
class WorkspaceExtentVisitor {
    constructor() {
        this.clear();

        this._stationCategory = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Station ).name;
        this._scanCategory = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].PointCloud ).name;
        this._panoCategory = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Panorama ).name;
        this._wsDataCache = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache();
    }

    apply( node ) {

        var objXForm = mat4.create(); // identity as default
        if ( node.transformMatrix ) {
            objXForm = mat4.copy( objXForm, node.transformMatrix );
            osg.mat4.transpose( objXForm, objXForm );
        }

        mat4.multiply( objXForm, this._xFormMatStack[ this._xFormMatStack.length - 1 ], objXForm );

        // transform and accumulate extent
        let minExt;
        let maxExt;
        switch ( node.category ) {
            // other than point cloud and panorama layers, only stations have extent for now
        case this._stationCategory:
            minExt = [ -0.1, -0.1, -node.properties.instrumentHeight ];
            maxExt = [ 0.1, 0.1, 0 ];
            break;

        case this._scanCategory:
        case this._panoCategory:
            // as layers, these are already included in Project.refreshExtent
            // and it's not easy to find the layer object from here, since it is not assigned yet to the cache
            break;
        }
        if ( minExt && maxExt )
            this.accumulateExtent( minExt, maxExt, objXForm );

        this.traverse( node, objXForm );
    }

    traverse( node, objXForm ) {
        if ( !node || !node.children ) {
            return;
        }

        this._xFormMatStack.push( objXForm );
        for ( let childNode of node.children ) {
            this.apply( childNode );
        }
        this._xFormMatStack.pop();
    }

    clear() {
        this._xFormMatStack = [ mat4.create() ]; // for extent traversal
        this._minExt = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
        this._maxExt = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];
    }

    getExtent() {
        return [ this._minExt[ 0 ], this._minExt[ 1 ], this._minExt[ 2 ], this._maxExt[ 0 ], this._maxExt[ 1 ], this._maxExt[ 2 ] ];
    }

    accumulateExtent( minPt, maxPt, xFormMat ) {

        this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], minPt[ 1 ], minPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], minPt[ 1 ], maxPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], maxPt[ 1 ], minPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, minPt[ 0 ], maxPt[ 1 ], maxPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], minPt[ 1 ], minPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], minPt[ 1 ], maxPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], maxPt[ 1 ], minPt[ 2 ] );
        this.accumulateTransformedExtent( xFormMat, maxPt[ 0 ], maxPt[ 1 ], maxPt[ 2 ] );
    }

    accumulateTransformedExtent( xFormMat, x, y, z ) {

        var pt = osg.vec3.fromValues( x, y, z );
        osg.vec3.transformMat4( pt, pt, xFormMat );
        this._minExt[ 0 ] = ( pt[ 0 ] < this._minExt[ 0 ] ) ? pt[ 0 ] : this._minExt[ 0 ];
        this._minExt[ 1 ] = ( pt[ 1 ] < this._minExt[ 1 ] ) ? pt[ 1 ] : this._minExt[ 1 ];
        this._minExt[ 2 ] = ( pt[ 2 ] < this._minExt[ 2 ] ) ? pt[ 2 ] : this._minExt[ 2 ];
        this._maxExt[ 0 ] = ( pt[ 0 ] > this._maxExt[ 0 ] ) ? pt[ 0 ] : this._maxExt[ 0 ];
        this._maxExt[ 1 ] = ( pt[ 1 ] > this._maxExt[ 1 ] ) ? pt[ 1 ] : this._maxExt[ 1 ];
        this._maxExt[ 2 ] = ( pt[ 2 ] > this._maxExt[ 2 ] ) ? pt[ 2 ] : this._maxExt[ 2 ];
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceIterator.js":
/*!***********************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceIterator.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceIterator; });
/* harmony import */ var pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js");



/**
 * Workspace iterator to itereate over the elementes 
 * @class
 * @memberof pcvizGIS
 */
class WorkspaceIterator {
    constructor( workspace, type ) {

        this._index = -1;
        this._wsElementArray = [];
        this._wsVisitor = undefined;
        this.refreshWorkspaceVisitor( workspace );

        if ( type === undefined )
            return;

        this._currentWorkspaceCategory = type;
        this.updateInternalArray();
    }

    refreshWorkspaceVisitor( workspace ) {
        if ( this._wsVisitor === undefined ) {
            this._wsVisitor = new pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_0__["default"]();
        }
        this._wsVisitor.clear();
        this._wsVisitor.apply( workspace.workspace );
    }

    setWorkspaceCategory( type ) {
        this._currentWorkspaceCategory = type;
    }

    getWorkspaceCategory() {
        return this._currentWorkspaceCategory;
    }

    updateInternalArray() {
        this._wsElementArray = this._wsVisitor.getElementsByType( this._currentWorkspaceCategory );
    }

    reset() {
        this._index = -1;
    }

    size() {
        if ( this._wsElementArray !== undefined )
            return this._wsElementArray.length;
        return 0;
    }

    get() {
        if ( this._wsElementArray === undefined )
            return undefined;
        return this._wsElementArray[ this._index ];
    }

    next() {
        if ( this._wsElementArray === undefined )
            return false;
        if ( this._index < this._wsElementArray.length - 1 ) {
            this._index++;
            return true;
        }
        return false;
    }

    previous() {
        if ( this._wsElementArray === undefined )
            return false;
        if ( this._index > 0 ) {
            this._index--;
            return true;
        }
        return false;
    }

    synchronizeIterator( id ) {
        this.reset();
        while ( this.next( true ) ) { // This parameter is used in the 'next' function of a child class (WorkspaceSelectionObjectIterator)
            let obj = this.get();
            if ( obj.uuid === id )
                break;
        }
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceLayerGroup.js":
/*!*************************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceLayerGroup.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceLayerGroup; });
/* harmony import */ var _LayerGroup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./LayerGroup */ "./sources/pcvizGIS/LayerGroup.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizGIS_StationCategory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/StationCategory */ "./sources/pcvizGIS/StationCategory.js");
/* harmony import */ var pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/Feature */ "./sources/pcvizGIS/Feature.js");
/* harmony import */ var pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_9__);











var osg = OSG__WEBPACK_IMPORTED_MODULE_9___default.a.osg;

/**
 * An extended LayerGroup class that stores data in the workspace.json file
 * @class
 * @memberof pcvizGIS
 * @extends LayerGroup
 */
class WorkspaceLayerGroup extends _LayerGroup__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( dataset ) {
        super();
        this._layerGroupClass = 'WorkspaceLayerGroup';

        this._dataset = dataset;
        this._featureDefinition = undefined;
        this._categoryRenderer = undefined;
        this._translateFields = []; // TO DO

        this._applyChildrenProperties = false;

        this._instrumentHeight = undefined;
    }

    setFeatureDefinition( featureDefinition ) {
        this._featureDefinition = featureDefinition;
    }

    open() {
        return new Promise( ( resolve ) => {
            let out = {
                loaded: true,
                error: undefined
            };
            this._dataset.open().then( result => {
                if ( result.valid ) {
                    this._open = true;
                    this.setFeatureDefinition( result.data );
                    this._categoryRenderer = ( this.isStation() ) ? new pcvizGIS_StationCategory__WEBPACK_IMPORTED_MODULE_4__["default"]( this ) : undefined;
                    this.setSuccessLoaded( true );
                    resolve( out );
                } else {
                    resolve( false );
                }
            }, error => {
                this.setSuccessLoaded( false );
                out.loaded = false;
                out.error = error;
                resolve( out );
            } );
        } );
    }

    commitChanges( avoidUpload, project ) {
        return new Promise( ( resolve, reject ) => {
            let promises = [];

            // update style in project configuration
            if ( this._project || project ) {
                if ( project && !this._project )
                    this._project = project;
                // overwrite config array 
                let newConfig = { id: this.getId(), symbol: this.getStyle() };
                let extData = this._project.getProjectDataset().getDriver().getConfigExtData();
                let wksSymbolConfig = extData.wksStyles;
                let currentSymbolConfigIndex = wksSymbolConfig.findIndex( config => config.id === newConfig.id );

                if ( currentSymbolConfigIndex !== -1 )
                    wksSymbolConfig[ currentSymbolConfigIndex ] = newConfig;
                else
                    wksSymbolConfig.push( newConfig );

                promises.push( this._project.getProjectDataset().getDriver().updateConfigExtData( extData, this._project.getProjectDataset().getDriver().getConfiguration().id ) );
            }

            if ( !this.getTransformMatrix() ) {
                Promise.all( promises ).then( resolve );
                return;
            }
            let workspaceCachedObject = this.getWorkspaceObject();
            workspaceCachedObject.transformMatrix = Array.from( this.getTransformMatrix() );
            if ( this._instrumentHeight !== undefined )
                workspaceCachedObject.properties.occupation.occHeight = this._instrumentHeight;
            if ( avoidUpload ) {
                Promise.all( promises ).then( resolve );
                return;
            }
            promises.push( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).uploadWorkspace() );
            Promise.allSettled( promises ).then( resolve, reject );
        } );

    }

    getSelectedFeatures() {
        return undefined;
    }

    getFeatures( filter ) {
        return new Promise( ( resolve, reject ) => {
            this._dataset.getDataIterator( filter ).then( dataIterator => {
                resolve( new pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_5__["FeatureIterator"]( dataIterator, this ) );
            }, reject );
        } );
    }

    getGeometryType() {
        if ( this._categoryRenderer )
            return this._categoryRenderer.getGeometryType();
        return pcvizGIS_FeatureDefinition__WEBPACK_IMPORTED_MODULE_6__["default"].POINT;
    }

    getFeatureDefinition() {
        return this._featureDefinition;
    }

    getCategoryRenderer() {
        return this._categoryRenderer;
    }

    getTranslatedAttributeNames( options ) {

        var stringAttribs = pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].getStringFields( this.getFeatureDefinition(), this.getCategory(), options );
        stringAttribs = this.convertFieldNamesForward( stringAttribs );

        return stringAttribs;
    }
    convertFieldNamesForward( names ) {
        var newNames = [];

        var self = this;
        names.forEach( function ( name ) {
            if ( self._translateFields.has( name ) )
                newNames.push( 'FEATURE_PROPERTIES.' + name );
            else
                newNames.push( name );
        } );
        return newNames;
    }

    initializePropertySet( project ) {
        super.initializePropertySet( project );
        this._project = project; // keep if for persisting wks styles

        let properties = this.getWorkspaceObjectProperties();
        if ( properties )
            this.addLayerGroupPropertyToPropertyBag( properties, pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ this.getWorkspaceObject().category ] ) );

        if ( this._categoryRenderer )
            this._categoryRenderer.initializePropertySet( this );
    }

    addLayerGroupPropertyToPropertyBag( property, categoryProperties, parentGroup, propertyId, path ) {
        if ( !propertyId ) {
            propertyId = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ this.getWorkspaceObject().category ] ).name;
        }
        if ( path ) {
            path = path.slice();
            path.push( propertyId );
        } else {
            path = [];
        }

        let propertyField = categoryProperties && categoryProperties.fields ? categoryProperties.fields.find( field => field.name === path.join( '/' ) ) : undefined;

        // This needs to be checked before Object because
        // Array is also an instance of Object
        if ( property instanceof Array ) {
            this.addPropertyField( {
                id: propertyId,
                label: propertyField && propertyField.translate ? propertyField.translate : propertyId,
                type: propertyField && propertyField.type ? propertyField.type : 'Point',
                order: propertyField ? propertyField.order : undefined,
                visible: propertyField && propertyField.visible !== undefined ? () => propertyField.visible : undefined,
                editable: propertyField && propertyField.editable !== undefined ? () => propertyField.editable : undefined,
                group: parentGroup,
                get: () => {
                    return this.getWorkspaceValueFromPath( path );
                },
                set: value => {
                    this.setWorkspaceValueFromPath( path, value );
                }
            } );
            return;
        }

        if ( property instanceof Object ) {
            this.addPropertyField( {
                id: propertyId,
                label: propertyField && propertyField.translate ? propertyField.translate : propertyId[ 0 ].toUpperCase() + propertyId.slice( 1 ),
                type: 'GroupField',
                order: propertyField ? propertyField.order : undefined,
                translate: propertyField && propertyField.translate ? true : undefined,
                group: parentGroup
            } );

            for ( let key in property ) {
                this.addLayerGroupPropertyToPropertyBag( property[ key ], categoryProperties, propertyId, key, path );
            }
            return;
        }

        this.addPropertyField( {
            id: propertyId,
            label: propertyField && propertyField.translate ? propertyField.translate : propertyId,
            type: propertyField && propertyField.type ? propertyField.type : this.getLayerGroupPropertyType( property ),
            order: propertyField ? propertyField.order : undefined,
            visible: propertyField && propertyField.visible !== undefined ? () => propertyField.visible : undefined,
            editable: propertyField && propertyField.editable !== undefined ? () => propertyField.editable : undefined,
            group: parentGroup,
            get: () => {
                return this.getWorkspaceValueFromPath( path );
            },
            set: value => {
                this.setWorkspaceValueFromPath( path, value );
            }
        } );
    }

    getLayerGroupPropertyType( property ) {
        let propertyType;
        switch ( typeof property ) {
        case 'string':
            propertyType = 'CharField';
            break;
        case 'number':
            propertyType = 'FloatField';
            break;
        case 'boolean':
            propertyType = 'BooleanField';
            break;
        }
        return propertyType;
    }

    getWorkspaceObject() {
        const dataCacheObj = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( this._id );
        if ( !dataCacheObj ) {
            // This should not occur but it is appropriate to check if exists
            console.error( `Data cache object not found ${this._id}` );
            return;
        }
        return dataCacheObj.getWorkspaceObj();
    }

    getWorkspaceObjectProperties() {
        let workspaceObject = this.getWorkspaceObject();
        if ( !workspaceObject ) {
            return undefined;
        }
        return workspaceObject.properties;
    }

    getWorkspaceValueFromPath( path ) {
        let propertiesValue = this.getWorkspaceObjectProperties();
        path.forEach( key => {
            propertiesValue = propertiesValue[ key ];
        } );
        return propertiesValue;
    }

    setWorkspaceValueFromPath( path, value ) {
        let propertiesValue = this.getWorkspaceObjectProperties();
        path.forEach( ( key, index ) => {
            if ( index !== path.length - 1 ) {
                propertiesValue = propertiesValue[ key ];
                return;
            }
            propertiesValue[ key ] = value;
        } );
    }

    setWorkspaceObjectProperties( newProperties ) {
        let workspaceObject = this.getWorkspaceObject();
        if ( !workspaceObject ) {
            return;
        }
        workspaceObject.properties = newProperties;
    }


    setIcon( category ) {
        if ( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ category ] && pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ category ] ).icon )
            this._icon = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"][ category ] ).icon;
    }

    canRemoveData() {
        return false;
    }

    isStation() {
        return ( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Station ].name === this.getWorkspaceObject().category );
    }

    setOccHeight( height ) {
        this._instrumentHeight = height;
    }


    /** There can be WorkspaceLayerGroup that isn't Stations. For example the Scans WorkspaceLayerGroups */
    getParentStation() {
        return this._findParentStationLayerGroup( this );
    }

    _findParentStationLayerGroup( layerGroup ) {
        if ( layerGroup.isStation() ) {
            return layerGroup;
        }
        if ( layerGroup.getParent() ) {
            return this._findParentStationLayerGroup( layerGroup.getParent() );
        }

        return undefined;
    }

    transformExtent( minPt, maxPt ) {
        // accumulate transformations
        let xFormMat = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.getAccumulateTransformations( this );

        if ( !xFormMat )
            return;

        pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.transformExtent( xFormMat, minPt, maxPt );
    }

    computeCenter( onlyReturn ) {

        if ( onlyReturn )
            return osg.vec3.create64();
        console.error( 'Layer group does not have extent. So we can not compute its center' );
        return;
    }

    // Method to be used when the WorkspaceLayerGroup is a Station
    // According to isIncomplete flag, this method will return the scans whose pointcloud has an 'incomplete' value equal to the argument.
    hasPointcloud( isIncomplete = false, scanUuid = undefined ) {
        let scansFolder = this.getChildren().find( ( child ) => {
            return child.getCategory() === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].ScansFolder ].name;
        } );
        if ( !scansFolder )
            return false;
        let scans = scansFolder.getChildren().filter( ( child ) => {
            return child.getCategory() === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Categories[ pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Scan ].name;
        } );
        if ( scanUuid !== undefined )
            scans = scans.filter( scan => ( scan.getId() === scanUuid ) );
        return scans.find( ( scan ) => {
            let pointcloud = scan.getChildren().find( ( child ) => {
                return child.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_8__["default"].POINTCLOUD;
            } );
            return pointcloud !== undefined && ( pointcloud.isIncomplete() === isIncomplete );
        } );
    }

    // Method to be used when the WorkspaceLayerGroup is a Station
    hasIncompletePointcloud() {
        return this.hasPointcloud( true );
    }

    // Method to be used when the WorkspaceLayerGroup is a Station
    // Returns the target layer of this station
    getTargetLayer() {
        if ( !this.isStation() ) {
            console.error( 'Trying to ask for a Target to an element that does not support it' );
            return;
        }
        let targetLayer = this.getChildren().find( layer => {
            return layer.getCategory() === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_7__["default"].Categories.TARGET;
        } );
        return targetLayer;
    }

}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceSelectionObjectIterator.js":
/*!**************************************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceSelectionObjectIterator.js ***!
  \**************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceSelectionObjectIterator; });
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_SelectionObject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js");
/* harmony import */ var pcvizUtils_SelectionObject__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_SelectionObject__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_WorkspaceIterator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/WorkspaceIterator */ "./sources/pcvizGIS/WorkspaceIterator.js");
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");









/**
 * Workspace iterator to itereate over the elementes 
 * @class
 * @memberof pcvizGIS
 */
class WorkspaceSelectionObjectIterator extends pcvizGIS_WorkspaceIterator__WEBPACK_IMPORTED_MODULE_5__["default"] {
    constructor( workspace, type ) {
        super( workspace, type );
        // save selection
        this._selectionObjectController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'SelectionObject' );
        this._currentSO = this._selectionObjectController.getSelectionObject();

        this._selectionObjectController.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2___default.a.PROJECT, this.selectionObjectCB.bind( this ) );
    }

    selectionObjectCB( selectionObject ) {
        // avoid reentry from self generated events
        if ( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.selectionComesFromMe( selectionObject, this ) )
            return;

        let layer = selectionObject.getLayer();
        if ( layer === undefined )
            return;

        if ( layer.getType() !== pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_4__["default"].GROUP )
            return;

        // if the current layer category is the same category type I will update the current object pointer
        if ( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_6__["default"][ layer.getCategory() ] === this.getWorkspaceCategory() ) {
            this.synchronizeIterator( layer.getId() );
            return;
        }
        // if the current layer category type is different I will update the internal array and point to the object selected
        this.setWorkspaceCategory( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_6__["default"][ layer.getCategory() ] );
        this.updateInternalArray();
        this.synchronizeIterator( layer.getId() );
    }

    next( avoidUpdate ) {
        let out = super.next();
        // update selection object 
        if ( out && !avoidUpdate )
            this.updateSelectionObject();
        return out;
    }

    previous() {
        let out = super.previous();
        // update selecition object
        if ( out )
            this.updateSelectionObject();
        return out;
    }

    updateSelectionObject() {

        // getting the current object
        let wsObject = this.get();

        // searching on the dataCache
        let wsdataCache = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache();

        // retrieving the layer
        let dataCacheObject = wsdataCache.getDataCacheObject( wsObject.uuid );
        if ( dataCacheObject === undefined )
            return;

        let layer = dataCacheObject.getLayerGroupObj();
        if ( layer === undefined )
            return;

        // adding to the selection object
        let selectionObject = this._selectionObjectController.createSelectionObject( pcvizUtils_SelectionObject__WEBPACK_IMPORTED_MODULE_3___default.a.LayerGroup );
        selectionObject.setLayer( layer );

        var userData = {
            origin: [ this ]
        };

        selectionObject.setUserData( userData );

        // notifying the new selection object
        this._selectionObjectController.setSelectionObject( selectionObject );
        this._selectionObject = selectionObject;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/WorkspaceVisitor.js":
/*!**********************************************!*\
  !*** ./sources/pcvizGIS/WorkspaceVisitor.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return WorkspaceVisitor; });
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");



/**
 * Workspace visitot to get elements from the workspace data
 * @class
 * @memberof pcvizGIS
 */
class WorkspaceVisitor {
    constructor() {
        this._allElements = [];
        this._parentsMap = new Map();
    }

    apply( node ) {
        this._allElements.push( node );
        this.traverse( node );
    }

    traverse( node ) {
        if ( !node || !node.children ) {
            return;
        }
        for ( let childNode of node.children ) {
            this._parentsMap.set( childNode.uuid, node );
            this.apply( childNode );
        }
    }

    clear() {
        this._allElements = [];
        this._parentsMap.clear();
    }

    getScans() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Scan );
    }

    getScansSorted() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Scan ).sort( ( a, b ) => a.directory.localeCompare( b.directory ) );
    }

    getStations() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Station );
    }

    getStationsSorted() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Station ).sort( ( a, b ) => a.name.localeCompare( b.name ) );
    }

    getScansFolder() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].ScansFolder );
    }

    getPointclouds() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].PointCloud );
    }

    getPanoramas() {
        return this.getElementsByType( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].Panorama );
    }

    getAllElements() {
        return this._allElements;
    }

    getParent( node ) {
        return this._parentsMap.get( node.uuid );
    }

    getElementsByType( type ) {
        if ( type === undefined )
            return;
        if ( type === 'All' )
            return this._allElements;
        let elements = [];
        let categoryId = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].getCategoryProps( type ).name;
        this._allElements.forEach( ( element ) => {
            if ( element.category === categoryId )
                elements.push( element );
        } );

        return elements;
    }

    getElementByCatalogId( id ) {
        return this._allElements.find( ( element ) => {
            return ( element.catalogObjectId === id );
        } );
    }

    getElementById( id ) {
        return this._allElements.find( ( element ) => {
            return ( element.uuid === id );
        } );
    }

    getScansWithoutCrStation() {
        let elements = [];
        const stations = this.getStations();
        const scansFolderId = pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["default"].ScansFolder ).name;

        for ( let station of stations ) {
            if ( station.properties.type === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["WorkspaceStationTypes"].LIGHTHOUSE || station.properties.type === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_0__["WorkspaceStationTypes"].CR )
                continue;
            let scansFolder = station.children.find( ( child ) => child.category === scansFolderId );

            if ( scansFolder.children )
                elements.push( ...scansFolder.children );
        }

        return elements;
    }
}


/***/ }),

/***/ "./sources/pcvizGIS/pcvizGIS.js":
/*!**************************************!*\
  !*** ./sources/pcvizGIS/pcvizGIS.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Category */ "./sources/pcvizGIS/Category.js");
/* harmony import */ var _Geometry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./Geometry */ "./sources/pcvizGIS/Geometry.js");
/* harmony import */ var _SpatialReference__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./SpatialReference */ "./sources/pcvizGIS/SpatialReference.js");
/* harmony import */ var _Envelope__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var _GeometryCollection__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GeometryCollection */ "./sources/pcvizGIS/GeometryCollection.js");
/* harmony import */ var _Point__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./Point */ "./sources/pcvizGIS/Point.js");
/* harmony import */ var _MultiPoint__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./MultiPoint */ "./sources/pcvizGIS/MultiPoint.js");
/* harmony import */ var _Curve__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./Curve */ "./sources/pcvizGIS/Curve.js");
/* harmony import */ var _LineString__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./LineString */ "./sources/pcvizGIS/LineString.js");
/* harmony import */ var _LinearRing__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./LinearRing */ "./sources/pcvizGIS/LinearRing.js");
/* harmony import */ var _Surface__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./Surface */ "./sources/pcvizGIS/Surface.js");
/* harmony import */ var _Polygon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./Polygon */ "./sources/pcvizGIS/Polygon.js");
/* harmony import */ var _GeometryType__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./GeometryType */ "./sources/pcvizGIS/GeometryType.js");
/* harmony import */ var _ScanControlPointType__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./ScanControlPointType */ "./sources/pcvizGIS/ScanControlPointType.js");
/* harmony import */ var _GroundControlPoints__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./GroundControlPoints */ "./sources/pcvizGIS/GroundControlPoints.js");
/* harmony import */ var _Layer__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./Layer */ "./sources/pcvizGIS/Layer.js");
/* harmony import */ var _LayerType__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var _ObjectType__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./ObjectType */ "./sources/pcvizGIS/ObjectType.js");
/* harmony import */ var _LayerDefinition__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js");
/* harmony import */ var _LayerGroup__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./LayerGroup */ "./sources/pcvizGIS/LayerGroup.js");
/* harmony import */ var _WorkspaceLayerGroup__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./WorkspaceLayerGroup */ "./sources/pcvizGIS/WorkspaceLayerGroup.js");
/* harmony import */ var _PointCloudLayer__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./PointCloudLayer */ "./sources/pcvizGIS/PointCloudLayer.js");
/* harmony import */ var _VectorLayer__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./VectorLayer */ "./sources/pcvizGIS/VectorLayer.js");
/* harmony import */ var _RasterLayer__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./RasterLayer */ "./sources/pcvizGIS/RasterLayer.js");
/* harmony import */ var _FeatureCategory__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./FeatureCategory */ "./sources/pcvizGIS/FeatureCategory.js");
/* harmony import */ var _Model3DCategory__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./Model3DCategory */ "./sources/pcvizGIS/Model3DCategory.js");
/* harmony import */ var _VolumeCategory__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./VolumeCategory */ "./sources/pcvizGIS/VolumeCategory.js");
/* harmony import */ var _StationCategory__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./StationCategory */ "./sources/pcvizGIS/StationCategory.js");
/* harmony import */ var _VectorLayerUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");
/* harmony import */ var _LayerRenderer__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./LayerRenderer */ "./sources/pcvizGIS/LayerRenderer.js");
/* harmony import */ var _LayerVisitor__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ./LayerVisitor */ "./sources/pcvizGIS/LayerVisitor.js");
/* harmony import */ var _SerializerLayerVisitor__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ./SerializerLayerVisitor */ "./sources/pcvizGIS/SerializerLayerVisitor.js");
/* harmony import */ var _WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ./WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js");
/* harmony import */ var _WorkspaceExtentVisitor__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ./WorkspaceExtentVisitor */ "./sources/pcvizGIS/WorkspaceExtentVisitor.js");
/* harmony import */ var _WorkspaceDataCache__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ./WorkspaceDataCache */ "./sources/pcvizGIS/WorkspaceDataCache.js");
/* harmony import */ var _DataCacheObject__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ./DataCacheObject */ "./sources/pcvizGIS/DataCacheObject.js");
/* harmony import */ var _WorkspaceCategories__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ./WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var _WorkspaceIterator__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ./WorkspaceIterator */ "./sources/pcvizGIS/WorkspaceIterator.js");
/* harmony import */ var _WorkspaceSelectionObjectIterator__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ./WorkspaceSelectionObjectIterator */ "./sources/pcvizGIS/WorkspaceSelectionObjectIterator.js");
/* harmony import */ var _Feature__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ./Feature */ "./sources/pcvizGIS/Feature.js");
/* harmony import */ var _FeatureDefinition__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ./FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js");
/* harmony import */ var _DataSource__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ./DataSource */ "./sources/pcvizGIS/DataSource.js");
/* harmony import */ var _Dataset__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ./Dataset */ "./sources/pcvizGIS/Dataset.js");
/* harmony import */ var _VectorDataset__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ./VectorDataset */ "./sources/pcvizGIS/VectorDataset.js");
/* harmony import */ var _PointCloudDataset__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ./PointCloudDataset */ "./sources/pcvizGIS/PointCloudDataset.js");
/* harmony import */ var _ProjectDataset__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ./ProjectDataset */ "./sources/pcvizGIS/ProjectDataset.js");
/* harmony import */ var _JobSiteDataset__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ./JobSiteDataset */ "./sources/pcvizGIS/JobSiteDataset.js");
/* harmony import */ var _WorkspaceDataset__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ./WorkspaceDataset */ "./sources/pcvizGIS/WorkspaceDataset.js");
/* harmony import */ var _Project__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ./Project */ "./sources/pcvizGIS/Project.js");
/* harmony import */ var _Settings__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ./Settings */ "./sources/pcvizGIS/Settings.js");
/* harmony import */ var _JobSite__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ./JobSite */ "./sources/pcvizGIS/JobSite.js");
/* harmony import */ var _LayerSet__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ./LayerSet */ "./sources/pcvizGIS/LayerSet.js");
/* harmony import */ var _Expression__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ./Expression */ "./sources/pcvizGIS/Expression.js");
/* harmony import */ var _Geoid__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ./Geoid */ "./sources/pcvizGIS/Geoid.js");
/* harmony import */ var _Utils__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ./Utils */ "./sources/pcvizGIS/Utils.js");


























































var Symbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).Symbol;
var FillSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).FillSymbol;
var LineSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).LineSymbol;
var PointSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).PointSymbol;
var MarkerSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).MarkerSymbol;






/** @namespace pcvizGIS */
let pcvizGIS = {};
pcvizGIS.Category = _Category__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizGIS.Geometry = _Geometry__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizGIS.SpatialReference = _SpatialReference__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizGIS.Envelope = _Envelope__WEBPACK_IMPORTED_MODULE_3__["default"];
pcvizGIS.GeometryCollection = _GeometryCollection__WEBPACK_IMPORTED_MODULE_4__["default"];
pcvizGIS.Point = _Point__WEBPACK_IMPORTED_MODULE_5__["default"];
pcvizGIS.MultiPoint = _MultiPoint__WEBPACK_IMPORTED_MODULE_6__["default"];
pcvizGIS.Curve = _Curve__WEBPACK_IMPORTED_MODULE_7__["default"];
pcvizGIS.LineString = _LineString__WEBPACK_IMPORTED_MODULE_8__["default"];
pcvizGIS.LinearRing = _LinearRing__WEBPACK_IMPORTED_MODULE_9__["default"];
pcvizGIS.Surface = _Surface__WEBPACK_IMPORTED_MODULE_10__["default"];
pcvizGIS.Polygon = _Polygon__WEBPACK_IMPORTED_MODULE_11__["default"];
pcvizGIS.GeometryType = _GeometryType__WEBPACK_IMPORTED_MODULE_12__["default"];
pcvizGIS.ScanControlPointType = _ScanControlPointType__WEBPACK_IMPORTED_MODULE_13__["default"];
pcvizGIS.GroundControlPoints = _GroundControlPoints__WEBPACK_IMPORTED_MODULE_14__["default"];

pcvizGIS.Layer = _Layer__WEBPACK_IMPORTED_MODULE_15__["default"];
pcvizGIS.LayerType = _LayerType__WEBPACK_IMPORTED_MODULE_16__["default"];
pcvizGIS.ObjectType = _ObjectType__WEBPACK_IMPORTED_MODULE_17__["default"];
pcvizGIS.LayerDefinition = _LayerDefinition__WEBPACK_IMPORTED_MODULE_18__["default"];
pcvizGIS.LayerGroup = _LayerGroup__WEBPACK_IMPORTED_MODULE_19__["default"];
pcvizGIS.WorkspaceLayerGroup = _WorkspaceLayerGroup__WEBPACK_IMPORTED_MODULE_20__["default"];
pcvizGIS.PointCloudLayer = _PointCloudLayer__WEBPACK_IMPORTED_MODULE_21__["default"];
pcvizGIS.VectorLayer = _VectorLayer__WEBPACK_IMPORTED_MODULE_22__["default"];
pcvizGIS.RasterLayer = _RasterLayer__WEBPACK_IMPORTED_MODULE_23__["default"];
pcvizGIS.FeatureCategory = _FeatureCategory__WEBPACK_IMPORTED_MODULE_24__["default"];
pcvizGIS.Model3DCategory = _Model3DCategory__WEBPACK_IMPORTED_MODULE_25__["default"];
pcvizGIS.VolumeCategory = _VolumeCategory__WEBPACK_IMPORTED_MODULE_26__["default"];
pcvizGIS.StationCategory = _StationCategory__WEBPACK_IMPORTED_MODULE_27__["default"];
pcvizGIS.VectorLayerUtils = _VectorLayerUtils__WEBPACK_IMPORTED_MODULE_28__["default"];
pcvizGIS.LayerRenderer = _LayerRenderer__WEBPACK_IMPORTED_MODULE_29__["default"];
pcvizGIS.LayerVisitor = _LayerVisitor__WEBPACK_IMPORTED_MODULE_30__["default"];
pcvizGIS.SerializerLayerVisitor = _SerializerLayerVisitor__WEBPACK_IMPORTED_MODULE_31__["default"];
pcvizGIS.WorkspaceVisitor = _WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_32__["default"];
pcvizGIS.WorkspaceExtentVisitor = _WorkspaceExtentVisitor__WEBPACK_IMPORTED_MODULE_33__["default"];
pcvizGIS.WorkspaceDataCache = _WorkspaceDataCache__WEBPACK_IMPORTED_MODULE_34__["default"];
pcvizGIS.DataCacheObject = _DataCacheObject__WEBPACK_IMPORTED_MODULE_35__["default"];
pcvizGIS.WorkspaceCategories = _WorkspaceCategories__WEBPACK_IMPORTED_MODULE_36__["default"];
pcvizGIS.WorkspaceStationTypes = _WorkspaceCategories__WEBPACK_IMPORTED_MODULE_36__["WorkspaceStationTypes"];
pcvizGIS.WorkspaceIterator = _WorkspaceIterator__WEBPACK_IMPORTED_MODULE_37__["default"];
pcvizGIS.WorkspaceSelectionObjectIterator = _WorkspaceSelectionObjectIterator__WEBPACK_IMPORTED_MODULE_38__["default"];

pcvizGIS.Feature = _Feature__WEBPACK_IMPORTED_MODULE_39__["Feature"];
pcvizGIS.FeatureIterator = _Feature__WEBPACK_IMPORTED_MODULE_39__["FeatureIterator"];
pcvizGIS.FeatureDefinition = _FeatureDefinition__WEBPACK_IMPORTED_MODULE_40__["default"];

pcvizGIS.DataSource = _DataSource__WEBPACK_IMPORTED_MODULE_41__["default"];
pcvizGIS.Dataset = _Dataset__WEBPACK_IMPORTED_MODULE_42__["default"];
pcvizGIS.VectorDataset = _VectorDataset__WEBPACK_IMPORTED_MODULE_43__["default"];
pcvizGIS.PointCloudDataset = _PointCloudDataset__WEBPACK_IMPORTED_MODULE_44__["default"];
pcvizGIS.ProjectDataset = _ProjectDataset__WEBPACK_IMPORTED_MODULE_45__["default"];
pcvizGIS.JobSiteDataset = _JobSiteDataset__WEBPACK_IMPORTED_MODULE_46__["default"];
pcvizGIS.WorkspaceDataset = _WorkspaceDataset__WEBPACK_IMPORTED_MODULE_47__["default"];
pcvizGIS.Project = _Project__WEBPACK_IMPORTED_MODULE_48__["default"];
pcvizGIS.Settings = _Settings__WEBPACK_IMPORTED_MODULE_49__["default"];
pcvizGIS.JobSite = _JobSite__WEBPACK_IMPORTED_MODULE_50__["default"];
pcvizGIS.LayerSet = _LayerSet__WEBPACK_IMPORTED_MODULE_51__["default"];

pcvizGIS.Symbol = Symbol;
pcvizGIS.FillSymbol = FillSymbol;
pcvizGIS.LineSymbol = LineSymbol;
pcvizGIS.PointSymbol = PointSymbol;
pcvizGIS.MarkerSymbol = MarkerSymbol;
pcvizGIS.Expression = _Expression__WEBPACK_IMPORTED_MODULE_52__["default"];

pcvizGIS.Geoid = _Geoid__WEBPACK_IMPORTED_MODULE_53__["default"];
pcvizGIS.Utils = _Utils__WEBPACK_IMPORTED_MODULE_54__;

/* harmony default export */ __webpack_exports__["default"] = (pcvizGIS);


/***/ }),

/***/ "./sources/pcvizGISRenderer/FillMarkerSymbol3D.js":
/*!********************************************************!*\
  !*** ./sources/pcvizGISRenderer/FillMarkerSymbol3D.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).MarkerSymbol3D;
var FillSymbol3D = __webpack_require__( /*! pcvizGISRenderer/FillSymbol3D */ "./sources/pcvizGISRenderer/FillSymbol3D.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var FillMarkerSymbol3D = function () {
    MarkerSymbol3D.call( this );
    this._fillSymbol3D = new FillSymbol3D();
};


FillMarkerSymbol3D.prototype = osg.objectInherit( MarkerSymbol3D.prototype, {

    getColor: function () {
        return this._fillSymbol3D.getColor();
    },

    configure: function ( style ) {
        if ( style && style.PolygonSymbolizer ) {
            this._rules = undefined;
            if ( style.PolygonSymbolizer.RuleSymbolizer )
                this._rules = style.PolygonSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.marker )
                this._imageURL = style.PolygonSymbolizer.marker;

            this._fillSymbol3D.configureSymbolizers( style, saveAlpha );
        }
    },

    configureAsInvisible: function () {
        this._fillSymbol3D.configureAsInvisible();
    },

    setStateSet: function () {
        MarkerSymbol3D.prototype.setStateSet.call( this );
        this._sceneGraph.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );
    },

    getMarkerPosition: function ( feature, layer ) {
        return FillSymbol3D.prototype.getMarkerPosition( feature, layer );
    },

    getMarkerVerticesUserData: function () {
        return [ 0, 0, 0, 0, 0, 0 ];
    },

    renderFeature: function ( feature, layer, selectedFeatures, center, sceneGraph, childIndex ) {
        this._fillSymbol3D.setFeatureInvalidation( this._invalidateFeatures );
        this._fillSymbol3D._invalidateLabels = this._invalidateLabels;
        this._fillSymbol3D._highlightFeature = this._highlightFeature;

        return ( this._fillSymbol3D.renderFeature( feature, layer, selectedFeatures, center, sceneGraph, childIndex ) );
    },

    getShaderInfo: function () {
        return this._fillSymbol3D.getShaderInfo();
    },

} );

module.exports = FillMarkerSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/FillSymbol3D.js":
/*!**************************************************!*\
  !*** ./sources/pcvizGISRenderer/FillSymbol3D.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var FillSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).FillSymbol;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var FillSymbol3D = function () {
    Symbol3D.call( this );
    FillSymbol.call( this );
};

FillSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, osg.objectInherit( FillSymbol.prototype, {

    configure: function ( style ) {
        if ( style && style.PolygonSymbolizer ) {
            this._rules = undefined;
            if ( style.PolygonSymbolizer.RuleSymbolizer )
                this._rules = style.PolygonSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.fillColor ) {
                this._color = Utils.RGBIntToFloatColor( style.PolygonSymbolizer.fillColor );
                this.applyAlpha( saveAlpha );
            }
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    getFeatureGeometry: function ( feature ) {
        // TODO: draw all rings
        return feature.getGeometry().getExteriorRing();
    },

    getNumPoints: function ( gisGeometry ) {
        var numPoints = gisGeometry.getNumPoints();
        if ( gisGeometry.isClosed() )
            numPoints--;
        return numPoints;
    },

    createPrimitive: function ( vertices, verticesUserData ) {
        // get indices from tessellation

        var indexes = Utils.getPolygonTriangIndexes( vertices );
        var gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes );
        for ( var i = 0; i < indexes.length; i++ )
            verticesUserData.push( indexes[ i ] );
        return ( new osg.DrawElements( osg.primitiveSet.TRIANGLES, gIndexes ) );
    },

    setStateSet: function () {
        Symbol3D.prototype.setStateSet.call( this );
        this._sceneGraph.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );
    },

    getMarkerPosition: function ( feature, layer ) {
        var xMax, yMax, zMax, xMin, yMin, zMin;

        var envelope = feature.getGeometry().getEnvelope();
        xMax = envelope.getMaxX();
        yMax = envelope.getMaxY();
        zMax = envelope.getMaxZ();

        xMin = envelope.getMinX();
        yMin = envelope.getMinY();
        zMin = envelope.getMinZ();

        var z = ( feature.getGeometry().getCoordinateDimension() === 3 ) ? zMax : layer.getDefaultZ();
        return ( osg.vec3.fromValues( ( xMax + xMin ) / 2.0, ( yMax + yMin ) / 2.0, z ) );
    }

} ) );

module.exports = FillSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/ImageSymbol3D.js":
/*!***************************************************!*\
  !*** ./sources/pcvizGISRenderer/ImageSymbol3D.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var PointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var ImageUtils = __webpack_require__( /*! pcvizUtils/ImageUtils */ "./sources/pcvizUtils/ImageUtils.js" ).default;
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 * This symbol has a child node with an image as a texture.
 * @class
 * @extends pcvizGISRenderer.PointSymbol3D
 * @memberof pcvizGISRenderer
 */
var ImageSymbol3D = function () {
    PointSymbol3D.call( this );
    this._name = 'ImageSymbol3D';

    this._groupNode = undefined;
    this._groupNodeName = 'ImageGroupNode';
    this._imageNode = undefined;
    this._imageNodeName = 'ImageNode';
};

ImageSymbol3D.prototype = osg.objectInherit( PointSymbol3D.prototype, {

    initSceneGraph: function ( layer ) {
        Symbol3D.prototype.initSceneGraph.call( this, layer );
        this._sceneGraph.setName( this._name );

        if ( this._invalidateFeatures && this._groupNode ) {
            this._groupNode.releaseGLObjects();
            this._groupNode.removeChildren();
        }
        if ( !this._groupNode ) {
            this._groupNode = new osg.Node();
            this._groupNode.setName( this._groupNodeName );
        }
        this._symbolNode.addChild( this._groupNode );
    },

    prepareGeometryData: function ( feature, featureIterator, layer, center, selectedFeatures, selectionColor ) {
        PointSymbol3D.prototype.prepareGeometryData.call( this, feature, featureIterator, layer, center, selectedFeatures, selectionColor );
        if ( this._groupNode.getNumChildren() === 0 && this._imageNode && this._imageNode.getImageMode() ) {
            this._groupNode.addChild( this._imageNode );
        }
    },

    selectFeature: function ( feature ) {
        Symbol3D.prototype.selectFeature.call( this, feature );
        if ( !this._imageNode )
            this._imageNode = this.getImageNode();

        if ( this._groupNode.getNumChildren() === 0 ) {
            this._groupNode.addChild( this._imageNode );

            // if there was an image (panorama) selected from other layer, and another one is selected without exiting imageMode,
            // it is necessary to remove the imageNode from the groupNode of the previous selected layer
            if ( this._imageNode.getParents() && this._imageNode.getParents().length > 1 ) {
                this._imageNode.getParents()[ 0 ].removeChildren();
            }
        }

        this.setAttributesFromFeatureData( feature );

        if ( feature.getAttributeByName( 'file_type' ) )
            this._imageNode.setImageFormat( feature.getAttributeByName( 'file_type' ) );
        var storageUrl = feature.getLayer().getDataset().getAttribute( 'storageUrl' );
        var token = '/files/';
        var database = storageUrl.slice( storageUrl.lastIndexOf( token ) + token.length, storageUrl.length );
        this._imageNode.setImageURL( database + feature.getAttributeByName( 'file_name' ), feature.getLayer() );

        var center = feature.getLayer().getCenter();
        var point = feature.getGeometry();
        var position = [ point.getX() - center[ 0 ], point.getY() - center[ 1 ], point.getZ() - center[ 2 ] ];
        this._imageNode.setPosition( position );

        if ( feature.getAttributeByName( 'quatX' ) === undefined && feature.getAttributeByName( 'attitude(z)=pan' ) !== undefined ) // old panoramas
            this.setRotationFromFeatureDataOldPanoramas( feature );
        else
            ImageUtils.setFeatureRotationInQuat( feature, this._imageNode.getRotationQuat() );

        this._imageNode.computeRotationTranslation();
        this._imageNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
        this._imageNode.setUserData( {
            featureId: feature.getId(),
            layerId: feature.getLayer().getId()
        } );

        if ( !this._imageNode.getImageMode() )
            this._imageNode.setDepth( false, true );

        if ( this.setSymbolizer )
            this.setSymbolizer();
    },

    enableIntersection: function ( enable ) {
        this._imageNode.setNodeMask( enable ? Utils.VISIBILITY_MASK : ~Utils.TRAVERSAL_MASK_IV );
    },

    deselectFeature: function ( feature ) {
        Symbol3D.prototype.deselectFeature.call( this, feature );
        if ( this._imageNode )
            this._imageNode.deselect();

    },

    /**
     * This method override its parent method. Instead of returning the `_sceneGraph`, it returns
     * `_symbolNode` because it contains `_sceneGraph` with the points and `_panoNode` with the
     * panorama sphere.
     * @method
     * @memberof pcvizGISRenderer.ImageSymbol3D
     * @return {osg.Node} The symbol node.
     */
    getSceneGraph: function () {
        return this._symbolNode;
    },

    /**
     * This method is overriden by extending classes if they need to manage attributes from
     * the feature selected.
     * @method
     * @memberof pcvizGISRenderer.ImageSymbol3D
     * @param {object} feature The feature to extract its attributes.
     */
    setAttributesFromFeatureData: function ( /*feature*/) {},

    /**
     * This method must be orverriden by extending classes in case the feature has no quaternion parameters.
     * It must compute the rotation quaternion.
     * @method
     * @memberof pcvizGISRenderer.ImageSymbol3D
     * @param  {Feature} feature The feature with the rotation parameters.
     */
    setRotationFromFeatureData: function ( /*feature*/) {
        console.log( 'Error: not implemented. ( ImageSymbol3D.setRotationFromFeatureData )' );
    },

    /**
     * This method must be orverriden by extending classes tho return the image node.
     * It must resturn the image node.
     * @method
     * @memberof pcvizGISRenderer.ImageSymbol3D
     */
    getImageNode: function () {
        console.log( 'Error: not implemented. ( ImageSymbol3D.getImageNode )' );
    },

    setImageMode: function ( value ) {
        this._imageNode.setImageMode( value );
        this._imageNode.enableMultiResolution( value );
    },


} );

module.exports = ImageSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/LayerRenderer3D.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizGISRenderer/LayerRenderer3D.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var LayerRenderer = __webpack_require__( /*! pcvizGIS/LayerRenderer */ "./sources/pcvizGIS/LayerRenderer.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var PointCloudRenderer = __webpack_require__( /*! pcvizGISRenderer/PointCloudRenderer */ "./sources/pcvizGISRenderer/PointCloudRenderer.js" );
var RasterRenderer = __webpack_require__( /*! pcvizGISRenderer/RasterRenderer */ "./sources/pcvizGISRenderer/RasterRenderer.js" );
var SingleSymbolRenderer = __webpack_require__( /*! pcvizGISRenderer/SingleSymbolRenderer */ "./sources/pcvizGISRenderer/SingleSymbolRenderer.js" ).default;

var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var WorkspaceVisitor = __webpack_require__( /*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js" ).default;


/**
 * A class to render the layers using osg Nodes.
 * @class
 * @memberof pcvizGISRenderer
 */
var LayerRenderer3D = function ( center ) {

    this._pointCloudRenderer = undefined;
    this._model3DVectorLayerRenderer = undefined;
    this._rasterRenderer = undefined;
    this.initLayerNodes();

    // the center of the first layer loaded (offset)
    this._center = osg.vec3.create64();
    if ( center !== undefined )
        this._center = center;

    this._featureRendererId = '3D';
};

LayerRenderer3D.prototype = osg.objectInherit( LayerRenderer.prototype, {

    setCenter: function ( center ) {
        this._center = center;
    },

    getCenter: function () {
        return this._center;
    },

    initLayerNodes: function () {
        this._layerNodes = new Map();
        this._layerNodes.set( LayerType.VECTOR, new Map() );
        this._layerNodes.set( LayerType.POINTCLOUD, new Map() );
        this._layerNodes.set( LayerType.RASTER, new Map() );

        if ( this._pointCloudRenderer !== undefined )
            this._pointCloudRenderer._pointCloudSceneGraph = new Map();
    },

    /**
     * Renderer for the vector layers.
     * @method
     * @memberof pcvizGISRenderer.LayerRenderer3D
     * @param {pcvizGIS.VectorLayer} layer the layer to be rendered
     * @return {osg.Node} the OSG node/graph generated by the renderer to be added to the main scene graph to render the layer
     */
    renderVectorLayer: function ( layer ) {
        return new Promise( ( resolve, reject ) => {
            layer.setCenter( this._center );

            if ( !layer.isOpen() ) {
                reject();
                return;
            }

            let featureRenderer = ( layer.getFeatureRenderer( this._featureRendererId ) === undefined ) ? new SingleSymbolRenderer() : layer.getFeatureRenderer( this._featureRendererId );
            if ( featureRenderer.getSymbol() === undefined ) {
                let symbol = Registry.getController( 'Symbol' ).getSymbol( this._featureRendererId, this.getSymbolType( layer ) );
                symbol.configure( layer.getStyle() );
                featureRenderer.setSymbol( symbol );
            }

            featureRenderer.getSymbol().configure( layer.getStyle() );
            layer.setVisibilityCallback( this._featureRendererId, function ( value ) {
                let mask = layer._visibleMask;
                if ( featureRenderer.getSymbolGraph().getNodeMask() )
                    mask = featureRenderer.getSymbolGraph().getNodeMask();
                featureRenderer.getSymbolGraph().setNodeMask( value ? mask : 0x0 );
            } );

            featureRenderer.renderLayer( layer ).then( function () {
                // Adding layer object and osg object to the cache
                // Only for scan projects
                let ws = Registry.getInstance().getController( 'Workspace' );
                if ( ws.getWorkspace() !== undefined ) {
                    let wsVisitor = new WorkspaceVisitor();
                    wsVisitor.apply( ws.getWorkspace().workspace );
                    let element = wsVisitor.getElementByCatalogId( layer.getId() );
                    if ( element ) {
                        let elementObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( element.uuid );
                        if ( elementObj !== undefined ) {
                            elementObj.setOsgNodeObj( featureRenderer.getSceneGraph().getChild( 0 ) );
                            elementObj.setLayerGroupObj( layer );
                        }
                    }
                }
                layer.clearDirtyFlags();
                resolve( featureRenderer.getSymbolGraph() );
            } );
            layer.setFeatureRenderer( featureRenderer, this._featureRendererId );
        } );
    },

    // for symbolization, layers with name and description are treated as annotation
    getEquivalentCategory: function ( layer ) {

        if ( VectorLayerUtils.isAnnotation( layer.getCategory(), layer.getFeatureDefinition() ) )
            return VectorLayerUtils.Categories.ANNOTATION;

        return layer.getCategory();
    },

    getSymbolType: function ( layer ) {
        var symbol;

        if ( layer.getCategory() === VectorLayerUtils.Categories.VERITY_MODEL ) {
            return 'MultiModel3D';
        }

        if ( layer.getCategory() === VectorLayerUtils.Categories.VOLUME )
            return 'Volume';

        if ( layer.getType() === LayerType.MODEL3D || [ VectorLayerUtils.Categories.MODEL3D, VectorLayerUtils.Categories.VERITY_REPORT, VectorLayerUtils.Categories.TIN ].includes( layer.getCategory() ) ) // FIXME remove when the server migrattion is finished
            return 'Model3D';

        // for now we use a default name for Layer Group, fix this when we introduce the feature renderer
        if ( layer.getType() === LayerType.GROUP )
            return 'StationSymbol';

        switch ( layer.getGeometryType() ) {
        case FeatureDefinition.POINT:
            symbol = this.getPointSymbol( layer );
            break;
        case FeatureDefinition.MULTIPOINT:
            symbol = this.getMultiPointSymbol( layer );
            break;
        case FeatureDefinition.LINE:
            symbol = this.getLineSymbol( layer );
            break;
        case FeatureDefinition.POLYGON:
            symbol = this.getFillSymbol( layer );
            break;
        default:
            break;
        }
        return symbol;
    },

    getPointSymbol: function ( layer ) {
        // That code will be removed as soon as we can get the symbols from the database
        // based on the layer category.
        var symbol;
        var category = this.getEquivalentCategory( layer );

        switch ( category ) {
        case VectorLayerUtils.Categories.FEATURE:
            symbol = 'Point';
            break;
        case VectorLayerUtils.Categories.ANNOTATION:
        case VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE:
            symbol = 'PointMarker';
            break;
        case VectorLayerUtils.Categories.PANORAMA:
            symbol = 'Panorama';
            break;
        case VectorLayerUtils.Categories.PLANAR_IMAGE:
            symbol = 'PlanarImage';
            break;
        case VectorLayerUtils.Categories.TARGET:
            symbol = 'Target';
            break;
        case VectorLayerUtils.Categories.MACHINERY:
            symbol = 'Machinery';
            break;
        default:
            symbol = 'Point';
        }
        return symbol;
    },

    getMultiPointSymbol: function ( layer ) {
        // That code will be removed as soon as we can get the symbols from the database
        // based on the layer category.
        var symbol;
        var category = this.getEquivalentCategory( layer );

        switch ( category ) {
        case VectorLayerUtils.Categories.FEATURE:
            symbol = 'MultiPoint';
            break;
        case VectorLayerUtils.Categories.ANNOTATION:
        case VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE:
            symbol = 'MultiPointMarker';
            break;
        case VectorLayerUtils.Categories.PANORAMA:
            symbol = 'MultiPointMarker';
            break;
        default:
            symbol = 'MultiPoint';
            break;
        }
        return symbol;
    },

    getLineSymbol: function ( layer ) {
        // That code will be removed as soon as we can get the symbols from the database
        // based on the layer category.
        var symbol;
        var category = this.getEquivalentCategory( layer );

        switch ( category ) {
        case VectorLayerUtils.Categories.FEATURE:
            symbol = 'Line';
            break;
            // We need support for complex symbols
        case VectorLayerUtils.Categories.ANNOTATION:
        case VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE:
            symbol = 'LineMarker';
            break;
        default:
            symbol = 'Line';
            break;
        }
        return symbol;
    },

    getFillSymbol: function ( layer ) {
        // That code will be removed as soon as we can get the symbols from the database
        // based on the layer category.
        var symbol;
        var category = this.getEquivalentCategory( layer );

        switch ( category ) {
        case VectorLayerUtils.Categories.FEATURE:
            symbol = 'Fill';
            break;
            // We need support for complex symbols
        case VectorLayerUtils.Categories.ANNOTATION:
        case VectorLayerUtils.Categories.ANNOTATION_CAMERA_POSE:
            symbol = 'FillMarker';
            break;
        default:
            symbol = 'Fill';
            break;
        }
        return symbol;
    },

    /**
     *
     * @method
     * @memberof pcvizGISRenderer.LayerRenderer3D
     * @param {pcvizGIS.PointCloudLayer} layer the layer to be rendered
     */
    renderPointCloudLayer: function ( layer ) {
        return this.getPointCloudRenderer().renderLayer( layer );
    },

    getPointCloudRenderer: function () {
        if ( this._pointCloudRenderer === undefined )
            this._pointCloudRenderer = new PointCloudRenderer();
        return this._pointCloudRenderer;
    },

    /**
     *
     * @method
     * @memberof pcvizGISRenderer.LayerRenderer3D
     */
    renderRasterLayer: function ( layer ) {
        layer.setCenter( this._center );
        if ( this._rasterRenderer === undefined )
            this._rasterRenderer = new RasterRenderer();

        return this._rasterRenderer.renderLayer( layer );
    },

    getPointCloudSceneGraph: function ( layer ) {
        return this._pointCloudRenderer.getSceneGraph( layer );
    },
    getModel3DSceneGraph: function () {
        return this._model3DVectorLayerRenderer.getSceneGraph();
    },
    getRasterSceneGraph: function ( layer ) {
        return this._rasterRenderer.getSceneGraph( layer );
    },

    setNodeToLayer: function ( layer, node ) {
        this._layerNodes.get( layer.getType() ).set( layer, node );
    },

    getNodeFromLayer: function ( layer ) {
        let layerKey = this.getLayerFromMap( layer ); // We need to search for the layer key because the layer object can be a different one. (TODO Maybe it is more appropriate to use layerId.)
        // Sometimes layerKey doesn't exist because the layer has not been rendered yet. This happens when creating new vector layers.
        if ( layerKey )
            return this._layerNodes.get( layer.getType() ).get( layerKey );
    },

    removeLayerNode: function ( layer ) {
        this._layerNodes.get( layer.getType() ).delete( this.getLayerFromMap( layer ) );
        if ( layer.getType() === LayerType.POINTCLOUD )
            this.getPointCloudRenderer()._pointCloudSceneGraph.delete( layer );
    },

    getLayerFromMap: function ( layer ) {
        return [ ...this._layerNodes.get( layer.getType() ).keys() ].find( l => l.getId() === layer.getId() );
    },

    resetLayerMasks: function () {
        this._layerNodes.get( LayerType.VECTOR ).forEach( function ( node, layerKey ) {
            node.setNodeMask( layerKey._visible ? Utils.VISIBILITY_MASK : 0x0 );
        } );
        this._layerNodes.get( LayerType.POINTCLOUD ).forEach( function ( node, layerKey ) {
            node.setNodeMask( layerKey._visible ? Utils.VISIBILITY_MASK : 0x0 );
        } );
        this._layerNodes.get( LayerType.RASTER ).forEach( function ( node, layerKey ) {
            node.setNodeMask( layerKey._visible ? Utils.VISIBILITY_MASK : 0x0 );
        } );
    },

    getAllLayerNodes: function () {
        return new Map( [ ...this._layerNodes.get( LayerType.VECTOR ), ...this._layerNodes.get( LayerType.POINTCLOUD ), ...this._layerNodes.get( LayerType.RASTER ) ] );
    },

    getLayerNodesByType: function ( type ) {
        return this._layerNodes.get( type );
    },

    updateStyle: function ( layer, property, value ) {
        let node = this.getNodeFromLayer( layer );
        if ( node )
            node.updateStyle( property, value, this._featureRendererId );
    },

    getFeatureRendererId: function () {
        return this._featureRendererId;
    },

    renderLayerGroup: function ( layer ) {
        return new Promise( ( resolve ) => {


            layer.setCenter( this._center );
            // Getting the data cache object
            let wsDataCacheObject = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( layer.getId() );
            // Getting osg node
            let osgNode = wsDataCacheObject.getOsgNodeObj();
            //Creating the feature renderer, for now we use the singleSymbolrenderer.
            // let featureRenderer = new SingleSymbolRenderer();
            var featureRenderer = ( layer.getFeatureRenderer( this._featureRendererId ) === undefined ) ? new SingleSymbolRenderer() : layer.getFeatureRenderer( this._featureRendererId );
            // Setting up the symbol

            if ( featureRenderer.getSymbol() === undefined ) {
                let symbol = Registry.getController( 'Symbol' ).getSymbol( this._featureRendererId, this.getSymbolType( layer ) );
                featureRenderer.setSymbol( symbol );
            }
            // FIXME: At this moment we need to set again the node to the symbol
            featureRenderer.getSymbol().setNode( osgNode );
            featureRenderer.getSymbol().configure( layer.getStyle() );

            const wksObj = wsDataCacheObject.getWorkspaceObj();

            // Visibility callback configure
            layer.setVisibilityCallback( this._featureRendererId, ( value ) => {
                var mask = layer._visibleMask;
                if ( featureRenderer.getSymbolGraph().getNodeMask() )
                    mask = featureRenderer.getSymbolGraph().getNodeMask();

                const showSymbol = value && !wksObj.fake;
                featureRenderer.getSymbolGraph().setNodeMask( showSymbol ? mask : 0x0 ); // Check if it is better to remove this line
                featureRenderer.getSymbol().getNode().setNodeMask( value ? mask : 0x0 ); //getNode() getChildren 'Symbol3D_root'
            } );

            layer.setShowSymbolCallback( this._featureRendererId, ( showSymbol ) => {
                let mask = layer._visibleMask;
                if ( featureRenderer.getSymbolGraph().getNodeMask() )
                    mask = featureRenderer.getSymbolGraph().getNodeMask();
                featureRenderer.getSymbolGraph().setNodeMask( showSymbol ? mask : 0x0 );
            } );

            // rendering the layer
            featureRenderer.renderLayer( layer ).then( () => {
                // layer.clearDirtyFlags();
                // defer.resolve( featureRenderer.getSymbolGraph() );
                layer.setVisible( layer.isVisible() );

                const showSymbol = !wksObj.fake && !layer.isSymbolHidden();
                layer.setSymbolVisibility( showSymbol );
                resolve( featureRenderer.getSymbolGraph() );
            } );
            layer.setFeatureRenderer( featureRenderer );
        } );
    }
} );

module.exports = LayerRenderer3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/LineMarkerSymbol3D.js":
/*!********************************************************!*\
  !*** ./sources/pcvizGISRenderer/LineMarkerSymbol3D.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).MarkerSymbol3D;
var LineSymbol3D = __webpack_require__( /*! pcvizGISRenderer/LineSymbol3D */ "./sources/pcvizGISRenderer/LineSymbol3D.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var LineMarkerSymbol3D = function () {
    MarkerSymbol3D.call( this );
    this._lineSymbol3D = new LineSymbol3D();
};

LineMarkerSymbol3D.prototype = osg.objectInherit( MarkerSymbol3D.prototype, {

    getColor: function () {
        return this._lineSymbol3D.getColor();
    },

    getGeometryFeature: function ( feature ) {
        var features = this.getVisitorFeatureNodes( feature );
        return features.find( function ( fNode ) {
            return ( !( fNode instanceof osg.AutoTransform ) && fNode.getUserData().vertices );
        } );
    },

    getVisualGeometryFeature: function ( feature ) {
        var features = this.getVisitorFeatureNodes( feature );
        return features.find( function ( fNode ) {
            return ( !( fNode instanceof osg.AutoTransform ) && !( fNode.getUserData().vertices ) );
        } );
    },

    configure: function ( style ) {
        if ( style && style.LineSymbolizer ) {
            this._rules = undefined;
            if ( style.LineSymbolizer.RuleSymbolizer )
                this._rules = style.LineSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.LineSymbolizer ) {
            if ( style.LineSymbolizer.marker )
                this._imageURL = style.LineSymbolizer.marker;

            this._lineSymbol3D.configureSymbolizers( style, saveAlpha );
        }
    },

    configureAsInvisible: function () {
        this._lineSymbol3D.configureAsInvisible();
    },

    setStateSet: function () {
        MarkerSymbol3D.prototype.setStateSet.call( this );
        var lineWidth = new osg.LineWidth( this._lineSymbol3D._lineWidth );
        this._sceneGraph.getOrCreateStateSet().setAttributeAndModes( lineWidth, osg.StateAttribute.ON );
    },

    getMarkerPosition: function ( feature, layer ) {
        return LineSymbol3D.prototype.getMarkerPosition( feature, layer );
    },

    getMarkerVerticesUserData: function () {
        return [
            [ 0, 0 ],
            [ 0, 0 ]
        ];
    },

    renderFeature: function ( feature, layer, selectedFeatures, center, sceneGraph, childIndex, page, pageSize ) {
        this._lineSymbol3D.setFeatureInvalidation( this._invalidateFeatures );
        this._lineSymbol3D._invalidateLabels = this._invalidateLabels;
        this._lineSymbol3D._highlightFeature = this._highlightFeature;

        return ( this._lineSymbol3D.renderFeature( feature, layer, selectedFeatures, center, this._sceneGraph, childIndex, page, pageSize ) );
    },

    getShaderInfo: function () {
        return this._lineSymbol3D.getShaderInfo();
    },

    updateStateSet: function ( stateSet ) {
        var update = MarkerSymbol3D.prototype.updateStateSet.call( this, stateSet );
        this._lineSymbol3D.updateStateSet( stateSet, true );
        return update;
    },

    getSLineVShaderHeader: function () {
        return this._lineSymbol3D.getSLineVShaderHeader();
    },

    getSLineVShaderBody: function () {
        return this._lineSymbol3D.getSLineVShaderBody();
    }

} );

module.exports = LineMarkerSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/LineSymbol3D.js":
/*!**************************************************!*\
  !*** ./sources/pcvizGISRenderer/LineSymbol3D.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var LineSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).LineSymbol;
var UtilsGIS = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
var FindFeatureVisitor = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).FindFeatureVisitor;

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var VisualGeometryData = function () {
    this.geometry = undefined;
    this.vertices = [];
    this.colors = new Float32Array( 4 );
    this.featureIds = [];
};


var HideCullCallback = function () {};
HideCullCallback.prototype = {
    cull: function () {
        return false;
    }
};


var LineSymbol3D = function () {
    Symbol3D.call( this );
    LineSymbol.call( this );

    this._sketchTool = new SketchTool( undefined );
};

LineSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, osg.objectInherit( LineSymbol.prototype, {

    configure: function ( style ) {
        if ( style && style.LineSymbolizer ) {
            this._rules = undefined;
            if ( style.LineSymbolizer.RuleSymbolizer )
                this._rules = style.LineSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.LineSymbolizer ) {
            if ( style.LineSymbolizer.strokeColor ) {
                this._color = Utils.RGBIntToFloatColor( style.LineSymbolizer.strokeColor );
                this.applyAlpha( saveAlpha );
            }
            if ( style.LineSymbolizer.strokeWidth )
                this._lineWidth = style.LineSymbolizer.strokeWidth;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    getOrCreateVisualGeometryData: function () {
        var visualGeometryData = new VisualGeometryData();
        return visualGeometryData;
    },

    updateVerticesUserData: function ( verticesUserData, i ) {
        verticesUserData.push( [ i, i + 1 ] );
    },

    createPrimitive: function ( vertices ) {
        return ( new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, 0, vertices.length / 3 ) );
    },

    setStateSet: function () {
        Symbol3D.prototype.setStateSet.call( this );
        var lineWidth = new osg.LineWidth( this._lineWidth );
        this._sceneGraph.getOrCreateStateSet().setAttributeAndModes( lineWidth, osg.StateAttribute.ON );
    },

    assignUserData: function ( geometryData, layerId ) {
        // featureIds and verticesUserData arrays must have one element per segment line. At this moment, they have one more element because they have one per point.
        // Now there isn't any problem. But, we remove the last element with the following lines.
        geometryData.featureIds.pop();
        geometryData.verticesUserData.pop();

        Symbol3D.prototype.assignUserData.call( this, geometryData, layerId );
    },

    pushVertex: function ( vertices, visualVertices, layer, point, i, center ) {
        var pointPos = point.getXYZM();
        var z = ( point.getCoordinateDimension() === 3 ) ? pointPos[ 2 ] : layer.getDefaultZ();

        var vIndex = i * 3;
        this.translateVertex( vertices, pointPos, center, vIndex, z );

        this.translateVertexScreenLine( visualVertices, pointPos, center, i, z );
    },

    translateVertexScreenLine: function ( vertices, pointPos, center, i, z ) {
        vertices[ i ] = [ pointPos[ 0 ] - center[ 0 ], pointPos[ 1 ] - center[ 1 ], z - center[ 2 ] ];
    },

    pushColorScreenLine: function ( colors, selectedFeatures, fId ) {
        if ( selectedFeatures.has( fId ) ) {
            UtilsGIS.copyVec4( this.getSelectionColor(), colors );
            return;
        }
        UtilsGIS.copyVec4( this._color, colors );
    },

    getGeometryFeature: function ( feature ) {
        var fv = new FindFeatureVisitor( feature );
        this._sceneGraph.accept( fv );
        var features = fv.getFeatureNodes();
        return features.find( function ( fNode ) {
            return ( fNode.getUserData().vertices );
        } );
    },

    getVisualGeometryFeature: function ( feature ) {
        var fv = new FindFeatureVisitor( feature );
        this._sceneGraph.accept( fv );
        var features = fv.getFeatureNodes();
        return features.find( function ( fNode ) {
            return !( fNode.getUserData().vertices );
        } );
    },

    _setFeatureColor: function ( feature, color ) {
        var fv = new FindFeatureVisitor( feature );
        this._sceneGraph.accept( fv );
        var fNodes = fv.getFeatureNodes();
        for ( var i = 0, j = fNodes.length; i < j; i++ ) {

            this.configureDepthTest( color, fNodes[ i ] );

            var colorBuffer = fNodes[ i ].getAttributes().Color;
            var colors = colorBuffer.getElements();
            this.saveColor( colors );
            for ( var c = 0; c < colors.length; c += 4 ) {
                colors[ c ] = color[ 0 ];
                colors[ c + 1 ] = color[ 1 ];
                colors[ c + 2 ] = color[ 2 ];
                colors[ c + 3 ] = color[ 3 ];
            }
            colorBuffer.dirty();
        }
    },

    renderFeature: function ( feature, layer, selectedFeatures, center, sceneGraph, childIndex, page, pageSize, childIndexCustom ) {

        // init variables
        var gisGeometry = this.getFeatureGeometry( feature );
        var numPoints = this.getNumPoints( gisGeometry );

        var geometryData;
        var visualGeometryData;

        if ( this._invalidateFeatures ) {
            geometryData = this.getOrCreateFeatureGeometry( gisGeometry, numPoints );
            visualGeometryData = this.getOrCreateVisualGeometryData();
        }

        var selectionColor = this.getSelectionColor();
        if ( this._rules )
            this.evaluateRules( feature );

        var screenLine;
        var simpleLine;

        if ( !sceneGraph )
            sceneGraph = this._sceneGraph;

        // Iterate over each point of the geometry
        if ( this._invalidateFeatures ) {
            for ( var i = 0; i < numPoints; i++ ) {
                this.pushVertex( geometryData.vertices, visualGeometryData.vertices, layer, gisGeometry.getPoint( i ), i, center );
                this.pushColor( geometryData.colors, selectedFeatures, feature.getId(), i, selectionColor );

                geometryData.featureIds.push( feature.getId() );
                visualGeometryData.featureIds.push( feature.getId() );

                this.updateVerticesUserData( geometryData.verticesUserData, i );
            }

            this.pushColorScreenLine( visualGeometryData.colors, selectedFeatures, feature.getId() );

            screenLine = visualGeometryData.geometry;
            screenLine = this._sketchTool.drawScreenLines( visualGeometryData.vertices, false, visualGeometryData.colors, this._lineWidth, false, true ).segments;

            screenLine.setUserData( {
                featureIds: visualGeometryData.featureIds
            } );

            screenLine.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

            sceneGraph.addChild( screenLine );

            // simple line
            simpleLine = geometryData.geometry;
            simpleLine.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, geometryData.vertices, 3 );
            simpleLine.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, geometryData.colors, 4 );

            simpleLine.getPrimitives().push( this.createPrimitive( geometryData.vertices ) );
            simpleLine.setCullCallback( new HideCullCallback() );

            // set the userData for picking
            this.assignUserData( geometryData, layer.getId() );

            return {
                geometry: simpleLine,
                cNodes: 2
            };
        }

        // only invalidate symbology
        if ( childIndexCustom !== undefined )
            childIndex = childIndexCustom + ( ( page - 1 ) * pageSize );
        screenLine = sceneGraph.getChild( childIndex );
        var colorVector = screenLine.getAttributes().Color.getElements();
        var numColors = colorVector.length / 4;
        for ( var iColor = 0; iColor < numColors; iColor++ ) {
            this.pushColor( colorVector, selectedFeatures, feature.getId(), iColor, selectionColor );
        }
        screenLine.getAttributes().Color.dirty();
        screenLine.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( this._lineWidth, 'lineWidth' ) );


        simpleLine = sceneGraph.getChild( childIndex + 1 );
        colorVector = simpleLine.getAttributes().Color.getElements();
        numColors = colorVector.length / 4;
        for ( iColor = 0; iColor < numColors; iColor++ ) {
            this.pushColor( colorVector, selectedFeatures, feature.getId(), iColor, selectionColor );
        }
        simpleLine.getAttributes().Color.dirty();
        return {
            geometry: undefined,
            cNodes: 2
        }; // no new node to add
    },

    getMarkerPosition: function ( feature, layer ) {
        var xMax, yMax, zMax, xMin, yMin, zMin;

        var envelope = feature.getGeometry().getEnvelope();
        xMax = envelope.getMaxX();
        yMax = envelope.getMaxY();
        zMax = envelope.getMaxZ();

        xMin = envelope.getMinX();
        yMin = envelope.getMinY();
        zMin = envelope.getMinZ();

        var z = ( feature.getGeometry().getCoordinateDimension() === 3 ) ? zMax : layer.getDefaultZ();
        return ( osg.vec3.fromValues( ( xMax + xMin ) / 2.0, ( yMax + yMin ) / 2.0, z ) );
    },

    getShaderInfo: function () {
        return {
            attributeNormal: false,
            attributeColor: true,
            uniformColor: false,
            varyingPos: true, // needed for buffers 
            varyingColor: true,
            screenLine: true
        };
    },

    updateStateSet: function ( stateSet, fromMarker ) {
        if ( !fromMarker )
            Symbol3D.prototype.updateStateSet.call( this, stateSet );

        stateSet.addUniform( osg.Uniform.createFloat1( this._lineWidth, 'lineWidth' ) );


        var aspect = 1;
        if ( this._sketchTool.getViewer() !== undefined )
            aspect = this._sketchTool.getViewer().getCanvas().width / this._sketchTool.getViewer().getCanvas().height;
        stateSet.addUniform( osg.Uniform.createFloat1( aspect, 'aspect' ) ); // adding aspect uniform
    },

    getSLineVShaderHeader: function () {
        var screenLineVHeader = [
            'attribute float Directions;', // current direction 1 or -1
            'attribute vec3 NextVertex;', // next vertex
            'attribute vec3 PreviousVertex;', // previous vertex
            'uniform float aspect;', // aspect ratio
            'uniform float lineWidth;'
        ];
        return screenLineVHeader;
    },

    getSLineVShaderBody: function () {
        var screenLineVBody = [
            '   vec2 aspectVec = vec2(aspect, 1.0);',
            '   mat4 projViewModel = uProjectionMatrix * uModelViewMatrix; //projection * view * model;',
            '   vec4 previousProjected = projViewModel * vec4(PreviousVertex, 1.0);',
            '   vec4 currentProjected = projViewModel * vec4(Vertex);',
            '   vec4 nextProjected = projViewModel * vec4(NextVertex, 1.0);',

            '   //get 2D screen space with W divide',
            '   vec2 currentScreen = currentProjected.xy / (currentProjected.w) * aspectVec;',
            '   vec2 previousScreen = previousProjected.xy / (previousProjected.w) * aspectVec;',
            '   vec2 nextScreen = nextProjected.xy / (nextProjected.w) * aspectVec;',
            '   float thickness = lineWidth * 0.001;',

            '   //starting point uses (NextVertex - Vertex)',
            '   vec2 dir = vec2(0.0, 0.0);',
            '   if (Vertex.xyz == PreviousVertex) {',
            '       dir = normalize(nextScreen - currentScreen);',
            '   } ',
            '   //ending point uses (Vertex - PreviousVertex)',
            '   else if (Vertex.xyz == NextVertex) {',
            '       dir = normalize(currentScreen - previousScreen);',
            '   }',
            '   //somewhere in middle, needs a join',
            '   else {',
            '       //get directions from (C - B) and (B - A)',
            '       vec2 dirAB = currentScreen - previousScreen;',
            '       vec2 dirBC = nextScreen - currentScreen;',
            '       float lenLine = length( dirAB + dirBC );',
            '       dirAB = normalize( dirAB );',
            '       dirBC = normalize( dirBC );',
            '       //now compute the miter join normal and length',
            '       vec2 miterNormal = normalize(dirAB + dirBC);',
            '       float cosAng = abs(dot(dirAB, miterNormal));',
            '       dir = (cosAng < 0.05 )? dirAB : miterNormal;',
            '       // limit small angles to avoid infinite spikes',
            '       float scaleFactor = (cosAng < 0.05 )? 1.0 : max(0.3, cosAng);',
            '       thickness = ( lenLine < 0.01 ) ? thickness: thickness / scaleFactor;',
            '    }',
            '    vec2 normal = vec2(-dir.y, dir.x);',
            '    thickness *= currentProjected.w;',
            '    normal *= thickness;',
            '    normal.x /= aspect;',
            '    vec4 offset = vec4(normal * Directions, 0.0, 0.0);',
            '    gl_Position = currentProjected + offset;',
            '    gl_PointSize = 1.0;'
        ];
        return screenLineVBody;
    }

} ) );

module.exports = LineSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/MachineryMarkerSymbol3D.js":
/*!*************************************************************!*\
  !*** ./sources/pcvizGISRenderer/MachineryMarkerSymbol3D.js ***!
  \*************************************************************/
/*! exports provided: STATUS_SITELINK3D, STATUS_TELEMATICS, MACHINE_TYPES, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_SITELINK3D", function() { return STATUS_SITELINK3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS_TELEMATICS", function() { return STATUS_TELEMATICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MACHINE_TYPES", function() { return MACHINE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MachineryMarkerSymbol3D; });
/* harmony import */ var pcvizGISRenderer_Symbol3D__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js");
/* harmony import */ var pcvizGISRenderer_Symbol3D__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_Symbol3D__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGISRenderer/PositionMarkerSymbol3D */ "./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizNode_Group__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizNode/Group */ "./sources/pcvizNode/Group.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_7__);











const osg = OSG__WEBPACK_IMPORTED_MODULE_7___default.a.osg;
const osgText = OSG__WEBPACK_IMPORTED_MODULE_7___default.a.osgText;

const STATUS_SITELINK3D = [ {
        name: 'not-reporting',
        icon: '/assets/machinery/yellow_pin.svg'
    },
    {
        name: 'reporting',
        icon: '/assets/machinery/blue_pin.svg'
    },
];

const STATUS_TELEMATICS = [ {
        name: 'not-active',
        icon: '/assets/machinery/grey_light.svg'
    },
    {
        name: 'active',
        icon: '/assets/machinery/green_light.svg'
    },
    {
        name: 'not-available',
        icon: '/assets/machinery/red_light.svg'
    },
];

const MACHINE_TYPES = [ {
        name: 'bulldozer',
        icon: '/assets/machinery/bulldozer.svg'
    },
    {
        name: 'excavator',
        icon: '/assets/machinery/excavator.svg'
    },
    {
        name: 'motorgrader',
        icon: '/assets/machinery/motorgrader.svg'
    },
    {
        name: 'surveyor',
        icon: '/assets/machinery/range_pole.svg'
    },
    {
        name: 'truck',
        icon: '/assets/machinery/truck.svg'
    },
];

class MachineryMarkerSymbol3D extends pcvizGISRenderer_Symbol3D__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();

        this._basePinMS = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["MarkerSymbol3D"]();
        this._basePinMS.createQuad = this.createQuadPin;
        this._basePinMS._renderBin = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RENDERBIN_MARKERSYMBOL3D;

        this._machineMS = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["MarkerSymbol3D"]();
        this._machineMS.createQuad = this.createQuadMachine;
        this._machineMS._renderBin = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RENDERBIN_MARKERSYMBOL3D;

        this._dotMS = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["MarkerSymbol3D"]();
        this._dotMS.createQuad = this.createQuadDot;
        this._dotMS._renderBin = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RENDERBIN_MARKERSYMBOL3D;


        this._machineryGroup = new osg.Node();
        this._machineryGroup.setName( 'machinery marker' );

        this._isSelected = false;
        this._alpha = 1.0;
        this._size = 1.0;
        this._styleChanged = false;
        this._labelField = 'name';
    }

    setNode( node ) {
        this._node = node;
        if ( this._symbolNode ) {
            this._node.addChild( this._symbolNode );

            this._symbolNode.addChild( this._sceneGraph );
            this._symbolNode.addChild( this._labelsNode );
        }
    }

    getNode() {
        return this._node;
    }

    configure( style ) {
        let styleChanged = false;
        if ( style.PointSymbolizer ) {
            if ( style.PointSymbolizer.color !== undefined ) {
                this._color = style.PointSymbolizer.color;
                this._color[ 3 ] = this._alpha;
                styleChanged = true;
            }
            const iconSize = style.PointSymbolizer.size / 15.0;
            if ( this._size !== iconSize ) {
                this._size = iconSize; // Default value of size applied in layer style.
                styleChanged = true;
            }
            if ( this._labelField !== style.PointSymbolizer.labelField ) {
                this._labelField = style.PointSymbolizer.labelField;
                styleChanged = true;
            }
        }
        this._styleChanged = styleChanged;
        this.configureSymbolizers();
        this.configureLabels( style );
    }

    configureSymbolizers() {
        let pinStyle = {
            PointSymbolizer: {
                marker: STATUS_SITELINK3D[ 0 ].icon,
                billboard: true,
                autoScale: true,
                size: 5 * this._size,
                color: [ 1.0, 1.0, 1.0, 1.0 ]
            }
        };
        this._basePinMS.configure( pinStyle );

        // Different states status_sl3d
        STATUS_SITELINK3D.forEach( ( statusSitelink ) => {
            this._basePinMS.getExtraImageUrl().set( statusSitelink.name, statusSitelink.icon );
            this._basePinMS.getExtraTextures().set( statusSitelink.name, new osg.Texture() );
        } );

        let machineStyle = {
            PointSymbolizer: {
                marker: MACHINE_TYPES[ 0 ].icon,
                billboard: true,
                autoScale: true,
                size: 2 * this._size,
                color: [ 1.0, 1.0, 1.0, 1.0 ]
            }
        };
        this._machineMS.configure( machineStyle );

        // Different states machine_type
        MACHINE_TYPES.forEach( ( machineType ) => {
            this._machineMS.getExtraImageUrl().set( machineType.name, machineType.icon );
            this._machineMS.getExtraTextures().set( machineType.name, new osg.Texture() );
        } );

        let dotStyle = {
            PointSymbolizer: {
                marker: STATUS_TELEMATICS[ 0 ].icon,
                billboard: true,
                autoScale: true,
                size: 0.7 * this._size,
                color: [ 1.0, 1.0, 1.0, 1.0 ]
            }
        };
        this._dotMS.configure( dotStyle );

        // Different states status_telematics
        STATUS_TELEMATICS.forEach( ( statusTelematics ) => {
            this._dotMS.getExtraImageUrl().set( statusTelematics.name, statusTelematics.icon );
            this._dotMS.getExtraTextures().set( statusTelematics.name, new osg.Texture() );
        } );
    }


    initSceneGraph( layer ) {
        if ( !this._symbolNode ) {
            this._sceneGraph = new osg.MatrixTransform();
            this._sceneGraph.setName( 'Symbol3D_scenegraph' );

            this._labelsNode = new osg.Node(); // Investigate if it is convenient to convert this into a MT
            this._labelsNode.setName( 'Symbol3D_labels' );
            this._labelsNode.setNodeMask( ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.TRAVERSAL_MASK_IV );

            this._symbolNode = new pcvizNode_Group__WEBPACK_IMPORTED_MODULE_5__["default"]();
            this._symbolNode.setName( 'Symbol3D_root' );

            this._symbolNode.addChild( this._sceneGraph );
            this._symbolNode.addChild( this._labelsNode );

            if ( this._node ) {
                this._node.addChild( this._symbolNode );
                this._node._dirtyFeatures = true;
            } else
                layer._dirtyFeatures = true;

            this._symbolNode.bufferAttribute = this.initBufferAttribute( layer );
        }
        // If the layergroup is rendered again, the _node can be one new
        if ( this._node )
            this._node.Layer = layer;

        if ( layer.getDirtyFeatures !== undefined && layer.getDirtyLabels !== undefined ) {
            this._invalidateFeatures = layer.getDirtyFeatures();
            if ( this._invalidateFeatures )
                this._invalidateLabels = true;
            else
                this._invalidateLabels = layer.getDirtyLabels();
        }

        if ( this._invalidateFeatures ) {
            this._sceneGraph.releaseGLObjects();
            this._sceneGraph.removeChildren();
        }
        if ( this._invalidateLabels || this._highlightFeature ) {
            this._labelsNode.releaseGLObjects();
            this._labelsNode.removeChildren();
        }

        this._sceneGraph.addChild( this._machineryGroup );
    }

    cleanSymbol() {
        this._symbolNode.removeChildren();
    }

    renderPage( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        if ( page === 1 ) {
            this._machineryGroup.removeChildren();
        }

        while ( featureIterator.next() ) {

            const feature = featureIterator.get();

            let featurePosition = feature.getGeometry().getXYZM();

            const pinMarkerNode = this.create2DMarker( this._basePinMS, 'pin_' + feature.getId(), center, featurePosition, feature.getAttributeByName( 'status_sl3d' ) );
            const machineMarkerNode = this.create2DMarker( this._machineMS, 'machine_' + feature.getId(), center, featurePosition, feature.getAttributeByName( 'machine_type' ) );
            const dotMarkerNode = this.create2DMarker( this._dotMS, 'dot_' + feature.getId(), center, featurePosition, feature.getAttributeByName( 'status_telematics' ) );

            const verticesUserDataAT = this.getMarkerVerticesUserData( featureIterator.getIndex() );
            this._basePinMS.assignUserDataToMarker( pinMarkerNode, verticesUserDataAT, feature.getId(), layer.getId() );
            this._machineMS.assignUserDataToMarker( machineMarkerNode, verticesUserDataAT, feature.getId(), layer.getId() );
            this._dotMS.assignUserDataToMarker( dotMarkerNode, verticesUserDataAT, feature.getId(), layer.getId() );

            const isSelectedFeature = selectedFeatures ? selectedFeatures.has( feature.getId() ) : false;
            this.configureSelectedStateSet( this._basePinMS, isSelectedFeature, pinMarkerNode );
            this.configureSelectedStateSet( this._machineMS, isSelectedFeature, machineMarkerNode );
            this.configureSelectedStateSet( this._dotMS, isSelectedFeature, dotMarkerNode );

            this._machineryGroup.addChild( pinMarkerNode );
            this._machineryGroup.addChild( machineMarkerNode );
            this._machineryGroup.addChild( dotMarkerNode );

            // Drawing label
            this.drawLabel( feature, featurePosition, layer.getCenter(), selectedFeatures );
        }
    }

    configureSelectedStateSet( symbol, selectedFeature, markerNode ) {
        let selcolor = osg.vec4.create();
        if ( selectedFeature )
            osg.vec4.copy( selcolor, this.getSelectionColor() );
        else {
            osg.vec4.copy( selcolor, symbol._color );
            selcolor[ 3 ] = this._alpha;
        }

        let selColorUniform = osg.Uniform.createFloat4( selcolor, 'color' );
        markerNode.getOrCreateStateSet().addUniform( selColorUniform );
    }

    getMarkerVerticesUserData( i ) {
        return pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.getMarkerVerticesUserData( i );
    }

    create2DMarker( symbol, name, center, position, state ) {
        let model2DMarker = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getInstance().getController( 'ModelLibrary' ).getModel( name );

        // reuse model unless we need to recreate it (this is not working because invalidateFeatures is always true)
        if ( !this._invalidateFeatures && !this._styleChanged && model2DMarker !== undefined ) {
            return model2DMarker;
        }

        let customState = ( state != null && symbol.getExtraTextures().has( state ) ) ? state : undefined;
        model2DMarker = symbol.renderMarker( position, undefined, undefined, center, undefined, undefined, customState );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getInstance().getController( 'ModelLibrary' ).addModel( name, model2DMarker );

        return model2DMarker;
    }

    createQuadPin( markerSize ) {
        let quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, 0, 0, markerSize, 0, 0, 0, markerSize, 0 );
        return quad;
    }

    createQuadMachine( markerSize ) {
        let machinePosMarker = markerSize * 1.15; // Marker original position value (23) / Symbol size coeficent (2) * Autoscale always on multiplier (10)
        let quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, machinePosMarker, 1.0, markerSize, 0, 0, 0, markerSize, 0 );
        return quad;
    }

    createQuadDot( markerSize ) {
        let dotPosMarker = markerSize * 1.85; // Marker original position value (13) / Symbol size coeficent (0.7) * Autoscale always on multiplier (10)
        let quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, dotPosMarker, 1.0, markerSize, 0, 0, 0, markerSize, 0 );
        return quad;
    }

    renderLabel( feature, _, position, center ) {
        let value = feature.getAttributeByName( this._labelField );

        let localPos = new osg.vec3.create64();
        osg.vec3.sub( localPos, position, center );
        let text;
        if ( value )
            text = new pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_6___default.a( value.toString() );
        else
            text = new pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_6___default.a( '' );
        text.setPosition( localPos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( 5 );
        text.setVerticalLabelOffset( 3 );
        let depth = new osg.Depth( osg.Depth.ALWAYS );
        text.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

        let outlineColor = osg.vec4.fromValues32( 60, 60, 60, 0.8 * this._color[ 3 ] );
        // use white outline for dark colors
        if ( 0.2126 * this._color[ 0 ] + 0.7152 * this._color[ 1 ] + 0.0722 * this._color[ 2 ] < 0.5 )
            outlineColor = osg.vec4.fromValues32( 255, 255, 255, 0.8 * this._color[ 3 ] );

        text.setColor( this._color );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( outlineColor );
        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    }

}


/***/ }),

/***/ "./sources/pcvizGISRenderer/MarkerSymbol3D.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGISRenderer/MarkerSymbol3D.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var MarkerSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).MarkerSymbol;
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;

/**
 * Specifies a base class to render symbols with a marker in a 3D view.
 * @class
 * @memberof pcvizGISRenderer
 * @extends Symbol3D
 * @extends MarkerSymbol
 */
var MarkerSymbol3D = function () {
    Symbol3D.call( this );
    MarkerSymbol.call( this );

    this._editingTexture = new osg.Texture();
    this._selectionTexture = new osg.Texture();
    this._texture = new osg.Texture();

    this._extraTextures = new Map();

    this._markerSize = 45.0 * window.devicePixelRatio; // TODO: Get the size from the Symbolizer in LayerRenderer3D (Before, we need adapt the values in Server)
    this._markerSizeHeight = undefined;
    this._defaultStateSet = undefined;
    this._selectedStateSet = undefined;
    this._editingStateSet = undefined;
    this._extraStateSets = new Map();
    this._color = [ 1.0, 1.0, 1.0, 1.0 ]; // if we want the marker with his color We should use the white color for the symbol
    this._disableRuleConfig = false;

    this._renderBin = Utils.RENDERBIN_MARKERSYMBOL3D;
};


var FindFeatureVisitor = function ( f ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._featureNodes = [];
    this._feature = f;
};

FindFeatureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        var fid = this._feature.getId();
        var userData = node.getUserData();
        if ( userData !== undefined ) {
            for ( var i = 0; i < userData.featureIds.length; i++ ) {
                if ( fid === userData.featureIds[ i ] ) {
                    this._featureNodes.push( node );
                    break;
                }
            }
        }
        this.traverse( node );
    },
    getFeatureNodes: function () {
        return this._featureNodes;
    }
} );


MarkerSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, osg.objectInherit( MarkerSymbol.prototype, {

    getExtraTextures: function () {
        return this._extraTextures;
    },

    setDisableRuleConfig: function ( disable ) {
        this._disableRuleConfig = disable;
    },

    configure: function ( style ) {
        // TODO: Refactor children classes to use this styles
        if ( style && style.PointSymbolizer ) {

            if ( !this._disableRuleConfig ) {
                if ( style.PointSymbolizer.billboard !== undefined )
                    this._isBillboard = style.PointSymbolizer.billboard;
                if ( style.PointSymbolizer.autoScale !== undefined )
                    this._isAutoScaled = style.PointSymbolizer.autoScale;
            }

            if ( style.PointSymbolizer.marker ) {
                this._imageURL = style.PointSymbolizer.marker;
                if ( style.PointSymbolizer.selectionMarker )
                    this._selectionImageURL = style.PointSymbolizer.selectionMarker;
                this._markerSize = this._isAutoScaled ? 10 * style.PointSymbolizer.size : style.PointSymbolizer.size;
                if ( style.PointSymbolizer.heightSize ) {
                    this._markerSizeHeight = this._isAutoScaled ? 10 * style.PointSymbolizer.heightSize : style.PointSymbolizer.heightSize;
                }
            }

            if ( style.PointSymbolizer.color !== undefined )
                this._color = style.PointSymbolizer.color;
        }
    },

    renderMarker: function ( position, featureId, selectedFeatures, center, centered, stateSet, extraState ) {
        // Initial implementation with Autotransform nodes
        // We will see if we need more perf in the future.

        var quad = this.createQuad( this._markerSize, centered );
        var at = new osg.AutoTransform();
        at.addChild( quad );
        var markerPosition = osg.vec3.fromValues( position[ 0 ] - center[ 0 ], position[ 1 ] - center[ 1 ], position[ 2 ] - center[ 2 ] );
        at.setPosition( markerPosition );
        at.setAutoRotateToScreen( this._isBillboard );
        at.setAutoScaleToScreen( this._isAutoScaled );
        // Change texture for selected features
        var ss = ( selectedFeatures && selectedFeatures.has( featureId ) ) ? this.getOrCreateSelectedStateSet() : this.getOrCreateStateSet( stateSet );
        if ( extraState )
            ss = this.getOrCreateExtraStateSet( extraState );
        at.setStateSet( ss );

        this.updateColor();

        return at;
    },

    assignUserDataToMarker: function ( markerNode, verticesUserData, featureId, layerId ) {
        // we need put twice the feature's id because the marker is composed of two triangles.
        var featureIds = new Uint16Array( [ featureId, featureId ] );

        markerNode.setUserData( {
            vertices: verticesUserData,
            featureIds: featureIds,
            layerId: layerId
        } );
    },

    getMarkerVerticesUserData: function () {},

    createQuad: function ( markerSize, centered ) {
        if ( markerSize === undefined )
            markerSize = this._markerSize;

        var quad;
        if ( centered )
            quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, -markerSize / 2.0, 0, markerSize, 0, 0, 0, markerSize, 0 );
        else
            quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, 0, 0, markerSize, 0, 0, 0, this._markerSizeHeight ? this._markerSizeHeight : markerSize, 0 );

        return quad;
    },

    renderPage: function ( featureIterator, page, pageSize, layer, center, selectedFeatures, childIndex ) {

        if ( featureIterator.getSize() > 0 ) {
            if ( childIndex === undefined )
                childIndex = 0;
            while ( featureIterator.next() ) {
                var feature = featureIterator.get();

                if ( this._rules )
                    this.evaluateRules( feature );

                var result = this.renderFeature( feature, layer, selectedFeatures, center, this._sceneGraph, childIndex, page, pageSize );
                var geometry = result.geometry;
                childIndex += result.cNodes;
                var position = this.getMarkerPosition( feature, layer );

                // add the geometry to the graph
                if ( this._invalidateFeatures ) {
                    this._sceneGraph.addChild( geometry );

                    // Draw the marker
                    var markerNode = this.renderMarker( position, feature.getId(), selectedFeatures, center );

                    var verticesUserDataAT = this.getMarkerVerticesUserData();
                    this.assignUserDataToMarker( markerNode, verticesUserDataAT, feature.getId(), layer.getId() );

                    this._sceneGraph.addChild( markerNode );
                } else // refresh marker color
                    this.overwriteMarkerStateSet( feature, selectedFeatures, childIndex, this._sceneGraph );

                childIndex++; // count marker node

                this.drawLabel( feature, position, layer.getCenter(), selectedFeatures );
            }
        }
    },

    getGeometryFeature: function ( feature ) {
        var features = this.getVisitorFeatureNodes( feature );

        return features.find( function ( fNode ) {
            return !( fNode instanceof osg.AutoTransform );
        } );
    },

    getVisitorFeatureNodes: function ( feature, overrideNodeMask ) {
        var fv = new FindFeatureVisitor( feature );
        if ( overrideNodeMask ) {
            fv.setNodeMaskOverride( 1 ); // To avoid skip nodes with nodeMask 0
        }
        this._sceneGraph.accept( fv );
        return fv.getFeatureNodes();
    },

    setGeometryFeatureVisibility: function ( feature, visible ) {
        let osgObjs = this.getVisitorFeatureNodes( feature, true ); // We take both, geometry and autotransform marker
        osgObjs.forEach( ( obj ) => obj.setNodeMask( ( visible ) ? ~0x0 : 0x0 ) );
    },

    selectFeature: function ( feature ) {
        this._setFeatureColor( feature, this.getSelectionColor(), this.getOrCreateSelectedStateSet() );
    },

    deselectFeature: function ( feature ) {
        this.restoreColor();
        this._setFeatureColor( feature, this._color, this.getOrCreateStateSet() );
    },

    editFeature: function ( feature ) {
        this._setFeatureColor( feature, this._editingColor, this.getOrCreateEditStateSet() );
    },

    _setFeatureColor: function ( feature, color, stateset ) {
        var features = this.getVisitorFeatureNodes( feature );
        for ( var i = 0, j = features.length; i < j; i++ ) {
            if ( features[ i ] instanceof osg.AutoTransform ) {
                features[ i ].setStateSet( stateset );
            } else {
                // It is a Geometry
                var colorBuffer = features[ i ].getAttributes().Color;
                var colors = colorBuffer.getElements();
                this.saveColor( colors );
                for ( var c = 0; c < colors.length; c += 4 ) {
                    colors[ c ] = color[ 0 ];
                    colors[ c + 1 ] = color[ 1 ];
                    colors[ c + 2 ] = color[ 2 ];
                    colors[ c + 3 ] = color[ 3 ];
                }
                colorBuffer.dirty();
            }

            this.configureDepthTest( color, features[ i ] );
        }
    },

    updateStateSet: function ( stateSet ) {
        stateSet.addUniform( osg.Uniform.createInt1( 0, 'Texture0' ) );
        var update = Symbol3D.prototype.updateStateSet.call( this, stateSet );
        if ( !update )
            return false;

        this.getOrCreateStateSet().setAttributeAndModes( this._textureProgram, osg.StateAttribute.ON );
        if ( this._selectedStateSet )
            this._selectedStateSet.setAttributeAndModes( this._textureProgram, osg.StateAttribute.ON );
        if ( this._editingStateSet )
            this._editingStateSet.setAttributeAndModes( this._textureProgram, osg.StateAttribute.ON );

        if ( this._extraStateSets.size )
            this._extraStateSets.forEach( ( stateSet ) => {
                stateSet.setAttributeAndModes( this._textureProgram, osg.StateAttribute.ON );

            } );

        return true;
    },

    initStateSet: function ( stateSet, imageURL, texture ) {
        var self = this;
        if ( texture.getImage() === undefined ) {
            osgDB.readImageURL( imageURL ).then( function ( image ) {
                texture.setImage( image );
                texture.setWrapT( osg.Texture.CLAMP_TO_EDGE );
                texture.setWrapS( osg.Texture.CLAMP_TO_EDGE );
                texture.setMinFilter( 'LINEAR_MIPMAP_LINEAR' );
                texture.setMagFilter( 'LINEAR' );
                stateSet.setTextureAttributeAndModes( 0, texture, osg.StateAttribute.ON );
                stateSet.addUniform( osg.Uniform.createInt1( 0, 'Texture0' ) );
                stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );

                var depth = new osg.Depth( osg.Depth.ALWAYS );
                depth.setWriteMask( false ); // avoid weird effect with EDL
                stateSet.setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

                stateSet.setRenderBinDetails( self._renderBin, Utils.RENDERBIN_MARKERSYMBOL3D_TYPE );
                self._generateTextureProgram();
                stateSet.setAttributeAndModes( self._textureProgram, osg.StateAttribute.ON );
            } );
        }

    },

    getOrCreateSelectedStateSet: function () {
        if ( this._selectedStateSet === undefined ) {
            this._selectedStateSet = new osg.StateSet();
            this.initStateSet( this._selectedStateSet, this._selectionImageURL, this._selectionTexture );
        }
        return this._selectedStateSet;
    },

    getOrCreateStateSet: function ( stateSet ) {
        if ( stateSet ) {
            if ( this._texture.getImage() !== undefined ) {
                stateSet.setTextureAttributeAndModes( 0, this._texture, osg.StateAttribute.ON );
                stateSet.addUniform( osg.Uniform.createInt1( 0, 'Texture0' ) );
                stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );

                var depth = new osg.Depth( osg.Depth.ALWAYS );
                stateSet.setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

                stateSet.setRenderBinDetails( this._renderBin, Utils.RENDERBIN_MARKERSYMBOL3D_TYPE );
                stateSet.setAttributeAndModes( this._textureProgram, osg.StateAttribute.ON );
            } else
                this.initStateSet( stateSet, this._imageURL, this._texture );
            return stateSet;
        }

        if ( this._defaultStateSet === undefined ) {
            this._defaultStateSet = new osg.StateSet();
            this.initStateSet( this._defaultStateSet, this._imageURL, this._texture );
        }
        return this._defaultStateSet;
    },

    getOrCreateEditStateSet: function () {
        if ( this._editingStateSet === undefined ) {
            this._editingStateSet = new osg.StateSet();
            this.initStateSet( this._editingStateSet, this._editingImageURL, this._editingTexture );
        }
        return this._editingStateSet;
    },

    getOrCreateExtraStateSet: function ( key ) {
        if ( this._extraStateSets.get( key ) === undefined ) {
            this._extraStateSets[ key ] = new osg.StateSet();
            this.initStateSet( this._extraStateSets[ key ], this._extraImageURL.get( key ), this._extraTextures.get( key ) );
        }
        return this._extraStateSets[ key ];
    },

    overwriteMarkerStateSet: function ( feature, selectedFeatures, childIndex, sceneGraph ) {
        var node = sceneGraph.getChild( childIndex );

        if ( this._highlightFeature && !selectedFeatures.has( feature.getId() ) ) {
            node.setNodeMask( 0x0 );
        } else {
            var ss = ( selectedFeatures.has( feature.getId() ) ) ? this.getOrCreateSelectedStateSet() : this.getOrCreateStateSet();
            node.setStateSet( ss );
            node.setNodeMask( Utils.VISIBILITY_MASK );
        }
    },

    updateColor: function () {
        let colorUniform = this.getColorUniform();
        if ( !colorUniform )
            return;
        let color = osg.vec4.create();
        osg.vec4.copy( color, this._color );
        colorUniform.setVec4( color );

    }

} ) );

module.exports = {
    MarkerSymbol3D: MarkerSymbol3D,
    FindFeatureVisitor: FindFeatureVisitor
};


/***/ }),

/***/ "./sources/pcvizGISRenderer/Model3DSymbol3D.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizGISRenderer/Model3DSymbol3D.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var Model3DNode = __webpack_require__( /*! pcvizNode/Model3DNode */ "./sources/pcvizNode/Model3DNode.js" );
var BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );

var MODEL3D_FORMAT_OTHER = 0;
var MODEL3D_FORMAT_OSGJS = 1;
var MODEL3D_FORMAT_3DT = 2;
var MODEL3D_FORMAT_3MX = 3;

var Model3DSymbol3D = function () {
    Symbol3D.call( this );
    this._input = new Input();
    this._alpha = 1.0;

    this._identifierMap = {};
    this._lastBufferMode = BufferAttribute.POINT;
    this._fileFormat = MODEL3D_FORMAT_OSGJS;
    this._hasClipBox = false;
    this._modulateTexture = false;
    this._modulateMaterial = false;

    this._isVerity = false;
    this._renderMode = Utils.SURFACE_RENDER_MODES.SMOOTH;
    this._useModelColor = false;
};

var FindFeatureVisitor = function ( f ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._featureNode = undefined;
    this._modelNode = undefined;
    this._feature = f;
};

FindFeatureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        var fid = this._feature.getId();
        var userData = node.getUserData();
        if ( userData !== undefined ) {
            if ( fid === userData.featureId ) {
                if ( node.getParents().length > 0 &&
                    node.getParents()[ 0 ].getParents().length > 0 )
                    this._modelNode = node;
                this._featureNode = node.getParents()[ 0 ].getParents()[ 0 ];
                return;
            }
        }
        this.traverse( node );
    },
    getFeatureNode: function () {
        return this._featureNode;
    },
    getModelNode: function () {
        return this._modelNode;
    }
} );

let GeometryVisitor = function ( fn, ...params ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._fn = fn;
    this._params = [ ...params ];
};

GeometryVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        if ( node.getTypeID() === osg.Geometry.getTypeID() ) {
            this._fn( node, ...this._params );
        }
        this.traverse( node );
    }
} );

Model3DSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, {

    configure: function ( style ) {
        if ( style && style.PolygonSymbolizer ) {
            this._rules = undefined;
            if ( style.PolygonSymbolizer.RuleSymbolizer )
                this._rules = style.PolygonSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.fillColor ) {
                this._color = Utils.RGBIntToFloatColor( style.PolygonSymbolizer.fillColor );
                this.applyAlpha( saveAlpha );
            }
            if ( style.PolygonSymbolizer.useModelColor !== undefined ) {
                this._useModelColor = style.PolygonSymbolizer.useModelColor;
            }
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    selectFeature: function ( /*feature*/) {},

    deselectFeature: function ( /*feature*/) {},

    editFeature: function ( /*feature*/) {},

    setRenderBin: function ( stateSet ) { // called by base Symbol3D.setStateSet
        stateSet.setRenderBinDetails( Utils.RENDERBIN_3DMODEL, Utils.RENDERBIN_3DMODEL_TYPE );
    },

    setColorUniform: function ( stateSet, model ) { // called by base Symbol3D.setStateSet and rendering
        if ( !stateSet )
            stateSet = model.getOrCreateStateSet();
        var color = osg.vec4.create();
        osg.vec4.copy( color, this._color );
        stateSet.addUniform( osg.Uniform.createFloat4( color, 'color' ) );

        var defaultMaterial = osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 );
        stateSet.addUniform( osg.Uniform.createFloat4( defaultMaterial, 'uMaterialDiffuse' ) );

        stateSet.addUniform( osg.Uniform.createFloat1( this._useModelColor ? 1.0 : 0.0, 'useModelColor' ) );
    },

    detectFileFormat: function ( fileName ) {
        this._fileFormat = MODEL3D_FORMAT_OTHER;
        if ( fileName.endsWith( '.3dt' ) )
            this._fileFormat = MODEL3D_FORMAT_3DT;
        else if ( fileName.endsWith( '.obj.osgjsc' ) /*|| fileName.endsWith( '.cem.osgjsc' )*/ ) //?
            this._fileFormat = MODEL3D_FORMAT_OSGJS;
        else if ( fileName.endsWith( '.3mx.osgjsc' ) )
            this._fileFormat = MODEL3D_FORMAT_3MX;
    },

    getShaderInfo: function () {
        return {
            attributeNormal: true,
            attributeColor: true,
            uniformUseModelColor: true,
            uniformColor: true,
            varyingPos: true,
            varyingColor: true,
            modulateTexture: ( this._fileFormat === MODEL3D_FORMAT_3DT ) ||
                ( this._fileFormat === MODEL3D_FORMAT_3MX ) || this._modulateTexture,
            modulateMaterial: ( this._fileFormat !== MODEL3D_FORMAT_3DT ) && this._modulateMaterial,
            flatShading: ( this._renderMode === Utils.SURFACE_RENDER_MODES.FLAT )
        };
    },

    _generateVaryingColor: function () {

        let shaderInfo = this.getShaderInfo();

        let varColorShader = [
            '  litColor = color;'
        ];

        if ( this._fileFormat === MODEL3D_FORMAT_3DT ) {
            return varColorShader;
        }

        if ( shaderInfo.uniformUseModelColor ) {
            varColorShader = [
                '  litColor = ( useModelColor > 0.0) ? Color : color;'
            ];
        }
        if ( shaderInfo.flatShading ) {
            // To use this color the blend color in fragmentShader
            if ( shaderInfo.modulateMaterial ) {
                varColorShader = varColorShader.concat( [
                    '  // Blend color and material ',
                    '  litColor *= uMaterialDiffuse;'
                ] );
            }
        } else {
            if ( shaderInfo.modulateMaterial )
                varColorShader = varColorShader.concat( [
                    '  // Blend color and material ',
                    '  vec4 blendColor = uMaterialDiffuse * litColor;',
                    '  float ambientFactor = 0.5;',
                    '  float diffuseFactor = 1.0;'
                ] );
            else
                varColorShader = varColorShader.concat( [
                    '  vec4 blendColor = litColor;',
                    '  float ambientFactor = 0.3;',
                    '  float diffuseFactor = 0.8;'
                ] );

            varColorShader = varColorShader.concat( [
                '  float lightFactor = 0.5 * abs(Normal.x  * 0.0    + Normal.y * 0.8660 + Normal.z * 0.5);',
                '  lightFactor += 0.5 * abs(Normal.x  * 0.7071 + Normal.y *  0.0    + Normal.z * 0.7071);',
                '  lightFactor = ambientFactor + diffuseFactor * lightFactor; // add ambient component ',
                '  litColor = vec4(lightFactor * blendColor.r, lightFactor * blendColor.g, lightFactor * blendColor.b, blendColor.a);'
            ] );
        }

        return varColorShader;
    },

    createOptions: function () {
        var opt = {};
        opt.request = this._input.requestMountUrl;
        return opt;
    },

    /**
     *
     * @method
     * @memberof pcvizGISRenderer.Model3DVectorLayerRenderer
     * @param {pcvizGIS.Model3DVectorLayer} layer the layer to be rendered
     */
    renderLayer: function ( layer ) {

        var hideAsDesignedFind = layer.getFeatureDefinition().getFields().find( function ( field ) {
            return ( field.getName() === 'hideAsDesigned' );
        } );
        this._isVerity = ( hideAsDesignedFind !== undefined );

        this.setupClipBox( layer );

        var defer = P.defer();

        this.initSceneGraph( layer );
        var selectedFeatures = layer.getSelectedFeatures();

        var page = 1;
        var pageSize = layer.getCategory() === VectorLayerUtils.Categories.VERITY_REPORT ? Utils.VERITY_PAGE_SIZE : Utils.PAGE_SIZE;
        if ( layer.getCategory() === VectorLayerUtils.Categories.MODEL3D || layer.getCategory() === VectorLayerUtils.Categories.TIN ) {
            this._renderMode = Utils.SURFACE_RENDER_MODES.FLAT;
        }
        this.renderPage( page, pageSize, layer, selectedFeatures ).then( function () {

            defer.resolve();
        } );

        return defer.promise;
    },

    setupClipBox: function ( layer ) {
        var clipBoxField = layer.getFeatureDefinition().getFields().find( function ( field ) {
            return ( field.getName() === 'clipbox' );
        } );
        this._hasClipBox = ( clipBoxField !== undefined );
    },

    setHighlightFeature: function ( flag ) {
        this._highlightFeature = flag;

        if ( !this._isVerity )
            return;

        if ( !this._highlightFeature ) {
            this._symbolNode.bufferAttribute.setEnabled( false );
            return;
        }

        // activate box buffer
        this._symbolNode.bufferAttribute.setEnabled( true );
        this._symbolNode.bufferAttribute.setBufferMode( BufferAttribute.BOX );
        this._symbolNode.bufferAttribute.setUseBaseColor( true );
        this._symbolNode.bufferAttribute.setOnlyBuffer( true );
        this._symbolNode.bufferAttribute.setRange( 0 );
    },

    getGeometryFeature: function ( feature, overrideNodeMask, onlyModel ) {
        var fv = new FindFeatureVisitor( feature );
        if ( overrideNodeMask ) {
            fv.setNodeMaskOverride( 1 ); // To avoid skip nodes with nodeMask 0
        }
        this._sceneGraph.accept( fv );
        if ( onlyModel ) { // To get the original Model3DNode instead a parent matrix transform
            return fv.getModelNode();
        }
        return fv.getFeatureNode();
    },

    renderPage: function ( page, pageSize, layer, selectedFeatures ) {
        var feature;

        var defer = P.defer();
        var self = this;
        layer.getFeatures( {
            'page': page,
            'page_size': pageSize
        } ).then( function ( featureIterator ) {
            var url;

            if ( self._invalidateFeatures ) {
                var mountController = Registry.getInstance().getController( 'Mount' );
                mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {
                    var stateSetInit = true;
                    featureIterator.reset();
                    let storageUrl = layer.getDataset().getAttribute( 'storageUrl' );
                    let token = '/files/';
                    let database = storageUrl.slice( storageUrl.lastIndexOf( token ) + token.length, storageUrl.length );
                    while ( featureIterator.next() ) {
                        feature = featureIterator.get();

                        var fileName = feature.getAttributeByName( 'file_name' );
                        url = mount.mountPoint + '/' + database + fileName;

                        // init stateSet once after format is detected
                        if ( stateSetInit ) {
                            self.detectFileFormat( fileName );
                            self.setStateSet();
                            stateSetInit = false;
                        }

                        self.renderFeature( layer, feature, url, selectedFeatures );

                        // Drawing labels
                        if ( self._showLabels ) {
                            self.drawOrRemoveLabel( feature, layer, selectedFeatures, page );
                        }
                    }

                    //continue with next pages
                    if ( featureIterator.getTotalNumFeatures() / pageSize > page ) {
                        page++;
                        self.renderPage( page, pageSize, layer, selectedFeatures ).then( function () {
                            defer.resolve();
                        } );
                    } else
                        defer.resolve();

                } ).catch( function ( error ) {
                    Registry.getController( 'Error' ).addError( error );
                    defer.reject( error );
                } );

                return defer.promise;
            }

            featureIterator.reset();
            while ( featureIterator.next() ) {
                feature = featureIterator.get();
                var selectionColor = self.getSelectionColor();

                var node = self.getGeometryFeature( feature );
                if ( !node )
                    continue;


                if ( node ) {
                    var hideAsDesigned = feature.getAttributeByName( 'hideAsDesigned' );
                    var hideAsBuilt = feature.getAttributeByName( 'hideAsBuilt' );

                    var color = self.applyColor( feature, selectedFeatures, selectionColor, node );
                    if ( !hideAsBuilt ) {
                        var asBuiltNode = node.getChild( hideAsDesigned ? 0 : 1 );
                        if ( asBuiltNode )
                            self.setAsBuiltColor( color, feature, selectedFeatures, asBuiltNode );
                    }
                    if ( self.setDynamicUniforms )
                        self.setDynamicUniforms( node, layer );

                    // refresh loading priority
                    var lodNode = node.getChild( 0 );
                    if ( lodNode && !( lodNode instanceof osg.PagedLOD ) )
                        lodNode = lodNode.getChild( 0 );
                    if ( lodNode instanceof osg.PagedLOD )
                        lodNode._userPriority = ( selectedFeatures.has( feature.getId() ) ) ? 100 : 50;
                    else
                        console.log( 'Model3DSymbol3D:renderPage: child node should be a PagedLOD' );

                    self.applyClipBox( layer, feature, selectedFeatures );
                }

                // Drawing labels
                if ( self._invalidateLabels ) {
                    if ( self._showLabels ) {
                        self.drawOrRemoveLabel( feature, layer, selectedFeatures, page );
                    } else {
                        self.removeLabels();
                    }
                }
            }

            if ( featureIterator.getTotalNumFeatures() / pageSize > page ) {
                page++;
                self.renderPage( page, pageSize, layer, selectedFeatures ).then( function () {
                    defer.resolve();
                } );
            } else
                defer.resolve();

        } );

        return defer.promise;
    },

    renderFeature: function ( layer, feature, url, selectedFeatures ) {

        var mt = new osg.MatrixTransform();
        this.setColorUniform( undefined, mt, layer );
        let name = 'feature root node id: ' + feature.getId();
        mt.setName( name );
        let sameFeatureNodes = this._sceneGraph.getChildren().filter( ( node ) => {
            return node.getName() === name;
        } );
        if ( sameFeatureNodes.length ) {
            sameFeatureNodes.forEach( ( node ) => {
                // node.releaseGLObjects(); // check if this is needed
                this._sceneGraph.removeChild( node );
            } );
        }
        this._sceneGraph.addChild( mt );
        var selectionColor = this.getSelectionColor();
        var color = this.applyColor( feature, selectedFeatures, selectionColor, mt );

        var pagedLOD = new osg.PagedLOD();
        pagedLOD.setRangeMode( osg.Lod.PIXEL_SIZE_ON_SCREEN );

        pagedLOD._level = 0;
        pagedLOD._col = 0;
        pagedLOD._row = 0;
        pagedLOD.setUserData( {
            maxLevel: undefined
        } );
        // setting this user priority will give models more priority to upload than point clouds
        pagedLOD._userPriority = ( selectedFeatures.has( feature.getId() ) ) ? 100 : 50;
        pagedLOD.setFunction( 0, this.loadModel3D.bind( this, layer, url, undefined, feature, mt ) );
        pagedLOD.setRange( 0, 0, Number.MAX_VALUE );


        if ( this._fileFormat !== MODEL3D_FORMAT_OSGJS ) {
            mt.addChild( pagedLOD );
            return;
        }

        var hideAsDesigned = feature.getAttributeByName( 'hideAsDesigned' );
        var hideAsBuilt = feature.getAttributeByName( 'hideAsBuilt' );

        // make designed element visible/invisible
        if ( !hideAsDesigned )
            mt.addChild( pagedLOD );

        // as-built copy (if visible)
        var asBuiltXFormStr = feature.getAttributeByName( 'transformation' );
        var asBuiltXForm = asBuiltXFormStr ? JSON.parse( asBuiltXFormStr ) : [];
        if ( asBuiltXForm.length && asBuiltXForm.length === 16 && !hideAsBuilt ) {
            var matrix = osg.mat4.create64();
            for ( var i = 0; i < 16; i++ ) // transpose
                matrix[ i ] = asBuiltXForm[ Math.floor( i / 4 ) + 4 * ( i % 4 ) ];

            var mtAsBuilt = new osg.MatrixTransform();
            mtAsBuilt.setMatrix( matrix );
            mtAsBuilt.addChild( pagedLOD );
            mt.addChild( mtAsBuilt );

            var nodePath = Utils.computeNodePath( mtAsBuilt );
            nodePath.push( mtAsBuilt );
            var modelMat = osg.computeLocalToWorld( nodePath, true );
            var modelMatrixUniform = osg.Uniform.createMat4( modelMat, 'uModelMatrix' );
            var asBuiltStateSet = mtAsBuilt.getOrCreateStateSet();
            asBuiltStateSet.addUniform( modelMatrixUniform );

            this.setAsBuiltColor( color, feature, selectedFeatures, mtAsBuilt );
        }

        this.applyClipBox( layer, feature, selectedFeatures );
    },

    applyClipBox: function ( layer, feature, selectedFeatures ) {
        if ( this._hasClipBox && this._highlightFeature && selectedFeatures.has( feature.getId() ) ) {
            // Getting scene center

            var sceneView = Registry.getInstance().getController( 'View' ).getView( '3D' );
            var globalCenter = sceneView.getCenter();

            var clipBoxStr = feature.getAttributeByName( 'clipbox' );
            var clipBox;
            if ( clipBoxStr )
                clipBox = JSON.parse( clipBoxStr );

            // Applying the globalCenter
            if ( clipBox.center )
                clipBox.center = osg.vec3.fromValues64( clipBox.center[ 0 ] - globalCenter[ 0 ], clipBox.center[ 1 ] - globalCenter[ 1 ], clipBox.center[ 2 ] - globalCenter[ 2 ] );

            // overwrite with expanded bounding box, if not defined
            var invalidClipBox = ( !clipBox || !clipBox.center || !clipBox.axisX || !clipBox.axisY || !clipBox.axisZ );


            if ( invalidClipBox ) {
                clipBox = {};
                const geom = feature.getGeometry();
                const pt1 = geom.getPoint( 0 );
                const pt2 = geom.getPoint( 1 );
                let box = [ 0, 0, 0, 0, 0, 0 ];
                var expandFactor = 2.0; // can be changed
                box[ 0 ] = Math.min( pt1.getX(), pt2.getX() );
                box[ 1 ] = Math.min( pt1.getY(), pt2.getY() );
                box[ 2 ] = Math.min( pt1.getZ(), pt2.getZ() );
                box[ 3 ] = Math.max( pt1.getX(), pt2.getX() );
                box[ 4 ] = Math.max( pt1.getY(), pt2.getY() );
                box[ 5 ] = Math.max( pt1.getZ(), pt2.getZ() );
                clipBox.axisX = [ expandFactor * ( box[ 3 ] - box[ 0 ] ), 0, 0 ];
                clipBox.axisY = [ 0, expandFactor * ( box[ 4 ] - box[ 1 ] ), 0 ];
                clipBox.axisZ = [ 0, 0, expandFactor * ( box[ 5 ] - box[ 2 ] ) ];
                var originOffset = 0.5 * ( expandFactor - 1.0 );
                clipBox.center = [ box[ 0 ] - originOffset * ( box[ 3 ] - box[ 0 ] ), box[ 1 ] - originOffset * ( box[ 4 ] - box[ 1 ] ), box[ 2 ] - originOffset * ( box[ 5 ] - box[ 2 ] ) ];
                this._symbolNode.bufferAttribute._boxMin = [
                    box[ 0 ] - originOffset * ( box[ 3 ] - box[ 0 ] ),
                    box[ 1 ] - originOffset * ( box[ 4 ] - box[ 1 ] ),
                    box[ 2 ] - originOffset * ( box[ 5 ] - box[ 2 ] )
                ];
                this._symbolNode.bufferAttribute._boxMax = [
                    box[ 3 ] + originOffset * ( box[ 3 ] - box[ 0 ] ),
                    box[ 4 ] + originOffset * ( box[ 4 ] - box[ 1 ] ),
                    box[ 5 ] + originOffset * ( box[ 5 ] - box[ 2 ] )
                ];
            }

            // apply buffer attributes

            var boxVectors = [];
            boxVectors.push( clipBox.axisX );
            boxVectors.push( clipBox.axisY );
            boxVectors.push( clipBox.axisZ );
            this._symbolNode.bufferAttribute.setBoxBuffer( clipBox.center, boxVectors );

            if ( invalidClipBox )
                return;
            clipBox.center = osg.vec3.fromValues64( clipBox.center[ 0 ] + globalCenter[ 0 ], clipBox.center[ 1 ] + globalCenter[ 1 ], clipBox.center[ 2 ] + globalCenter[ 2 ] ); // We need to use the center at it was

            // Compute boxMin and boxMax from clipbox
            let endAxisX = osg.vec3.add( osg.vec3.create64(), clipBox.center, clipBox.axisX );
            let endAxisY = osg.vec3.add( osg.vec3.create64(), clipBox.center, clipBox.axisY );
            let endAxisZ = osg.vec3.add( osg.vec3.create64(), clipBox.center, clipBox.axisZ );

            let maxX = Math.max( endAxisX[ 0 ], Math.max( endAxisY[ 0 ], endAxisZ[ 0 ] ) );
            let maxY = Math.max( endAxisX[ 1 ], Math.max( endAxisY[ 1 ], endAxisZ[ 1 ] ) );
            let maxZ = Math.max( endAxisX[ 2 ], Math.max( endAxisY[ 2 ], endAxisZ[ 2 ] ) );

            let minFromEndAxisZero = Math.min( endAxisX[ 0 ], Math.min( endAxisY[ 0 ], endAxisZ[ 0 ] ) );
            let minFromEndAxisOne = Math.min( endAxisX[ 1 ], Math.min( endAxisY[ 1 ], endAxisZ[ 1 ] ) );
            let minFromEndAxisTwo = Math.min( endAxisX[ 2 ], Math.min( endAxisY[ 2 ], endAxisZ[ 2 ] ) );

            this._symbolNode.bufferAttribute._boxMin = [ Math.min( clipBox.center[ 0 ], minFromEndAxisZero ),
                Math.min( clipBox.center[ 1 ], minFromEndAxisOne ),
                Math.min( clipBox.center[ 2 ], minFromEndAxisTwo )
            ];

            this._symbolNode.bufferAttribute._boxMax = [ Math.max( maxX, clipBox.center[ 0 ] ),
                Math.max( maxY, clipBox.center[ 1 ] ),
                Math.max( maxZ, clipBox.center[ 2 ] )
            ];

        }
    },

    setAsBuiltColor: function ( color, feature, selectedFeatures, asBuiltNode ) {
        var originalColor = this._color;
        let featureId = feature.getId ? feature.getId() : feature; // When called from MultiModel3D, feature is the feature Id
        // test color: blend predefined color with feature's alpha
        if ( this._highlightFeature )
            this._color = ( selectedFeatures.has( featureId ) ) ? [ 0, 1, 1, 1 * color[ 3 ] ] : [ 0, 1, 1, 0 ];
        else
            this._color = [ 0, 0, 0, 0 ]; // as built should only be shown for highlighted feature
        this.setColorUniform( undefined, asBuiltNode );

        // We need to restore the color to render again the model (that is not 'as built') (This occurs in Verity viewer)
        this._color = originalColor;
    },

    applyColor: function ( feature, selectedFeatures, selectionColor, node ) {
        if ( this._rules )
            this.evaluateRules( feature );
        let color = [ 0, 0, 0, 0 ];
        this.pushColor( color, selectedFeatures, feature.getId(), 0, selectionColor );
        color[ 3 ] *= this._alpha;

        const osgStateSet = node.getOrCreateStateSet();
        const colorUniform = osgStateSet.getUniform( 'color' );
        colorUniform.setVec4( color );

        const useModelColorUniform = osgStateSet.getUniform( 'useModelColor' );
        if ( selectedFeatures.has( feature.getId() ) ) {
            useModelColorUniform.setFloat( 0.0 ); // When model is selected, avoid to use model color.
        } else {
            useModelColorUniform.setFloat( this._useModelColor ? 1.0 : 0.0 );
        }

        return color;
    },

    getRenderMode: function () {
        return this._renderMode;
    },

    changeRenderMode: function ( renderMode ) {
        let previousRenderMode = this._renderMode;
        this._renderMode = renderMode;

        if ( previousRenderMode === Utils.SURFACE_RENDER_MODES.WIREFRAME || renderMode === Utils.SURFACE_RENDER_MODES.WIREFRAME ) {
            this.refreshRenderMode( this._sceneGraph, renderMode );
        }

        this.updateStateSet( this._sceneGraph.getOrCreateStateSet(), true );
    },

    refreshRenderMode: function ( node, renderMode ) {
        let geomVisitor = new GeometryVisitor( this.changeGeometryPrimitives.bind( this ), renderMode );
        node.accept( geomVisitor );
    },

    changeGeometryPrimitives: function ( geom, renderMode ) {
        let newPrimitives;
        if ( renderMode === Utils.SURFACE_RENDER_MODES.WIREFRAME ) {
            let userData = geom.getUserData();
            let originalPrimitives = geom.getPrimitives();
            if ( userData === undefined ) {
                userData = {};
            }
            userData.originalPrimitives = originalPrimitives;
            geom.setUserData( userData );

            newPrimitives = this.createWireframePrimitives( originalPrimitives );
            geom.getOrCreateStateSet().setAttributeAndModes( new osg.LineWidth( 2.0 ), osg.StateAttribute.ON );
        }
        if ( renderMode === Utils.SURFACE_RENDER_MODES.SMOOTH || renderMode === Utils.SURFACE_RENDER_MODES.FLAT ) {
            let userData = geom.getUserData();
            newPrimitives = geom._primitives;
            if ( userData && userData.originalPrimitives ) {
                newPrimitives = userData.originalPrimitives;
                delete userData.originalPrimitives;
                geom.setUserData( userData );
            }
        }
        geom._primitives = newPrimitives;
    },

    createWireframePrimitives: function ( oldPrimitives ) {
        let newPrimitives = [];
        for ( let primitive of oldPrimitives ) {
            let newPrimitive = primitive; // by default, we use the same primitive

            let finalIndexes = [];

            let isDrawElements = ( primitive instanceof osg.DrawElements );
            let first = isDrawElements ? primitive.offset : primitive.first;
            let indices = [];
            if ( isDrawElements ) {
                indices = primitive.getIndices().getElements();
            }

            switch ( primitive.mode ) {
            case osg.primitiveSet.TRIANGLES:
                for ( let i = first; i < ( first + primitive.count ); i += 3 ) {
                    finalIndexes.push( isDrawElements ? indices[ i ] : i );
                    finalIndexes.push( isDrawElements ? indices[ i + 1 ] : i + 1 );
                    finalIndexes.push( isDrawElements ? indices[ i + 1 ] : i + 1 );
                    finalIndexes.push( isDrawElements ? indices[ i + 2 ] : i + 2 );
                    finalIndexes.push( isDrawElements ? indices[ i + 2 ] : i + 2 );
                    finalIndexes.push( isDrawElements ? indices[ i ] : i );
                }
                break;
            case osg.primitiveSet.TRIANGLE_STRIP:
                for ( let i = first; i < ( first + primitive.count ); i++ ) {
                    finalIndexes.push( isDrawElements ? indices[ i ] : i );
                    finalIndexes.push( isDrawElements ? indices[ i + ( 1 + i % 2 ) ] : i + ( 1 + i % 2 ) );
                    finalIndexes.push( isDrawElements ? indices[ i + ( 1 + i % 2 ) ] : i + ( 1 + i % 2 ) );
                    finalIndexes.push( isDrawElements ? indices[ i + ( 2 - i % 2 ) ] : i + ( 2 - i % 2 ) );
                    finalIndexes.push( isDrawElements ? indices[ i + ( 2 - i % 2 ) ] : i + ( 2 - i % 2 ) );
                    finalIndexes.push( isDrawElements ? indices[ i ] : i );
                }
                break;
            case osg.primitiveSet.TRIANGLE_FAN:
                for ( let i = first; i < ( first + primitive.count ); i++ ) {
                    finalIndexes.push( isDrawElements ? indices[ first ] : first );
                    finalIndexes.push( isDrawElements ? indices[ i + 1 ] : i + 1 );
                    finalIndexes.push( isDrawElements ? indices[ i + 1 ] : i + 1 );
                    finalIndexes.push( isDrawElements ? indices[ i + 2 ] : i + 2 );
                    finalIndexes.push( isDrawElements ? indices[ i + 2 ] : i + 2 );
                    finalIndexes.push( isDrawElements ? indices[ first ] : first );
                }
                break;
            default:
                break;
            }

            if ( finalIndexes.length > 0 ) {
                let gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, new Uint16Array( finalIndexes ), 1 );
                newPrimitive = new osg.DrawElements( osg.primitiveSet.LINES, gIndexes );
            }

            newPrimitives.push( newPrimitive );
        }
        return newPrimitives;
    },

    loadModel3D: function ( layer, url, options, feature, mt ) {
        var defer = P.defer();
        var self = this;
        var opt = options || this.createOptions();
        opt.layer = layer;
        var rootBounds = feature.getAttributeByName( 'rootBounds' );
        if ( rootBounds !== undefined ) {
            var jBounds = JSON.parse( rootBounds );
            opt.rootBounds = jBounds;
        }
        // Getting the base path. It is important because the 3D tile loader use it
        var databasePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );
        opt.databasePath = databasePath;
        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {
            opt.appendQuery = mount.appendQuery;

            P.resolve( osgDB.readNodeURL( url, opt ) )
                .then( function ( model3D ) {
                    var modelNode = new Model3DNode( layer );
                    modelNode.addModelNode( model3D );
                    if ( self._fileFormat === MODEL3D_FORMAT_3DT ) {
                        model3D.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( true, 'useTexture0' ) );
                    }
                    // Disabled cull face for all 3D models
                    var cullFaceMode = new osg.CullFace();
                    cullFaceMode.setMode( osg.CullFace.DISABLE );
                    model3D.getOrCreateStateSet().setAttributeAndModes( cullFaceMode );

                    self._modulateTexture = model3D.getUserData() && model3D.getUserData().enableTexture;
                    self._modulateMaterial = model3D.getUserData() && model3D.getUserData().enableMaterial;
                    if ( self._modulateTexture || self._modulateMaterial ) {
                        self.updateStateSet( self._sceneGraph.getOrCreateStateSet(), true );
                    }

                    // setting user data
                    if ( feature !== undefined ) {

                        var numPoints = feature.getGeometry().getNumPoints();
                        var geometryData = self.getOrCreateFeatureGeometry( feature.getGeometry(), numPoints );

                        modelNode.setUserData( {
                            vertices: geometryData.verticesUserData,
                            featureId: feature.getId(),
                            layerId: layer.getId()
                        } );
                    }

                    // calculating relative position for the model
                    var relativePosition = self.getRelativePosition( model3D, modelNode, layer, feature );

                    mt.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), relativePosition ) );
                    mt.dirtyBound();

                    // return node to add to pagedLOD and relative priority to download
                    defer.resolve( modelNode );
                } ).catch( function ( error ) {
                    Registry.getController( 'Error' ).addError( error );
                    defer.reject( error );
                } );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    getCenter: function ( feature ) {
        var bb = new osg.BoundingBox();
        var geometry = feature.getGeometry();
        for ( var i = 0; i < geometry.getNumPoints(); i++ ) {
            var point = geometry.getPoint( i );
            bb.expandByVec3( osg.vec3.fromValues64( point.getX(), point.getY(), point.getZ() ) );
        }
        var result = osg.vec3.create64();
        var min = bb.getMin();
        var max = bb.getMax();
        result[ 0 ] = ( min[ 0 ] + max[ 0 ] ) * 0.5;
        result[ 1 ] = ( min[ 1 ] + max[ 1 ] ) * 0.5;
        result[ 2 ] = ( min[ 2 ] + max[ 2 ] ) * 0.5;

        return result;
    },


    getRelativePosition: function ( model3D, modelNode, layer, feature ) {
        var center;
        var relativePosition;
        if ( model3D.originalBounding ) {
            var originalCenter = model3D.originalBounding.center();
            //This is only for backwards compatibility. Previously, all C3DTiles layers had a UTM projection but the data was in ECEF
            if ( ( layer.getHorizProjectionEPSG() !== 'EPSG:4978' ) && CRSUtils.isEcefPoint( originalCenter[ 0 ], originalCenter[ 1 ], originalCenter[ 2 ] ) ) {
                var positionOri = CRSUtils.transform( 'EPSG:4978', CRSUtils.WGS_84, [ originalCenter[ 0 ], originalCenter[ 1 ], originalCenter[ 2 ] ] );
                center = CRSUtils.transform( CRSUtils.WGS_84, layer.getHorizProjectionEPSG(), [ positionOri[ 0 ], positionOri[ 1 ], positionOri[ 2 ] ] );
                relativePosition = osg.vec3.fromValues64( center[ 0 ] - layer.getCenter()[ 0 ], center[ 1 ] - layer.getCenter()[ 1 ], center[ 2 ] - layer.getCenter()[ 2 ] );
                modelNode.applyRotation( model3D.originalBounding );
            } else
                relativePosition = osg.vec3.fromValues64( originalCenter[ 0 ] - layer.getCenter()[ 0 ], originalCenter[ 1 ] - layer.getCenter()[ 1 ], originalCenter[ 2 ] - layer.getCenter()[ 2 ] );

            return relativePosition;
        }
        center = this.getCenter( feature );
        relativePosition = osg.vec3.fromValues64( -layer.getCenter()[ 0 ], -layer.getCenter()[ 1 ], -layer.getCenter()[ 2 ] );
        // REVIEW: Uncomment this to change Y up
        // var matrixRotate = osg.mat4.create();
        // osg.mat4.fromRotation( matrixRotate, ( -90 * Math.PI ) / 180, osg.vec3.fromValues( 1, 0, 0 ) );
        // modelNode.setMatrix( matrixRotate );

        return relativePosition;
    },

    getMarkerPosition: function ( featureIterator, layerCenter ) {
        var geometry = featureIterator.getGeometry();
        var min = geometry.getPoint( 0 );
        var max = geometry.getPoint( 1 );

        var centerObject = osg.vec3.fromValues( ( max.getX() + min.getX() ) / 2.0, ( max.getY() + min.getY() ) / 2.0, ( max.getZ() + min.getZ() ) / 2.0 );
        var pos = osg.vec3.fromValues64( centerObject[ 0 ] - layerCenter[ 0 ], centerObject[ 1 ] - layerCenter[ 1 ], centerObject[ 2 ] - layerCenter[ 2 ] );
        return pos;
    },
    removeLabels: function () {
        // delete labels graph
        this._labelsNode.removeChildren();
    },

    addLabel: function ( feature, selectedFeatures, position ) {
        var labelNode = this.renderLabel( feature, selectedFeatures, position, [ 0, 0, 0 ], 0 );
        if ( labelNode )
            this._labelsNode.addChild( labelNode );
    },

    drawOrRemoveLabel( feature, layer, selectedFeatures, page ) {
        if ( page === 1 ) {
            this.removeLabels();
        }
        const pos = this.getMarkerPosition( feature, layer.getCenter() );
        this.addLabel( feature, selectedFeatures, pos );
    }

} );

module.exports = Model3DSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/MultiModel3DSymbol3D.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizGISRenderer/MultiModel3DSymbol3D.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osgDB = OSG.osgDB;
const osg = OSG.osg;
const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const Model3DSymbol3D = __webpack_require__( /*! pcvizGISRenderer/Model3DSymbol3D */ "./sources/pcvizGISRenderer/Model3DSymbol3D.js" );
const Model3DNode = __webpack_require__( /*! pcvizNode/Model3DNode */ "./sources/pcvizNode/Model3DNode.js" );

var FindInstancesVisitor = function () {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._instances = new Map();
};

FindInstancesVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        const userData = node.getUserData();
        if ( userData ) {
            const instanceGuid = userData.find( ( e ) => e.Name === 'instanceGuid' );
            if ( instanceGuid ) {
                this._instances.set( instanceGuid.Value, node );
            }
        }
        this.traverse( node );
    },

    getInstancesMap: function () {
        return this._instances;
    },

    clearInstanceMap: function () {
        this._instances.clear();
    }

} );

var MultiModel3DSymbol3D = function () {
    Model3DSymbol3D.call( this );
    this._rootModel = undefined;
    this._findInstancesVisitor = new FindInstancesVisitor();
    this._asBuiltModels = undefined;
};

// This needs more testing
var FindFeatureVisitor = function ( f ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._featureNode = undefined;
    this._feature = f;
};

FindFeatureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        const fid = this._feature.getAttributeByName( 'instanceGuid' );
        const userData = node.getUserData();
        if ( userData !== undefined ) {
            if ( fid === userData.instanceGuid ) {
                if ( node.getParents().length > 0 &&
                    node.getParents()[ 0 ].getParents().length > 0 )
                    this._featureNode = node.getParents()[ 0 ].getParents()[ 0 ];
                return;
            }
        }
        this.traverse( node );
    },

    getFeatureNode: function () {
        return this._featureNode;
    }
} );

MultiModel3DSymbol3D.prototype = osg.objectInherit( Model3DSymbol3D.prototype, {
    initSceneGraph: function ( layer ) {
        Model3DSymbol3D.prototype.initSceneGraph.call( this, layer );
        this._asBuiltModels = new osg.Node();
        this._asBuiltModels.setName( 'MultiModel AsBuilt Group' );
    },

    getGeometryFeature: function ( feature, overrideNodeMask ) {
        var fv = new FindFeatureVisitor( feature );
        if ( overrideNodeMask ) {
            fv.setNodeMaskOverride( 1 ); // To avoid skip nodes with nodeMask 0
        }
        this._sceneGraph.accept( fv );
        return fv.getFeatureNode();
    },

    renderPage: function ( page, pageSize, layer, selectedFeatures ) {
        var feature;

        var defer = P.defer();
        var self = this;
        layer.getFeatures( {
            'page': page,
            'page_size': pageSize
        } ).then( function ( featureIterator ) {
            var url;

            var mountController = Registry.getInstance().getController( 'Mount' );
            mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {
                var stateSetInit = true;
                featureIterator.reset();
                let storageUrl = layer.getDataset().getAttribute( 'storageUrl' );
                let token = '/files/';
                let database = storageUrl.slice( storageUrl.lastIndexOf( token ) + token.length, storageUrl.length );
                if ( featureIterator.next() ) {
                    feature = featureIterator.get();

                    var fileName = feature.getAttributeByName( 'file_name' );
                    url = mount.mountPoint + '/' + database + fileName;

                    // init stateSet once after format is detected
                    if ( stateSetInit ) {
                        self.detectFileFormat( fileName );
                        self.setStateSet();
                        stateSetInit = false;
                    }

                    self.renderFeature( layer, feature, url, selectedFeatures );
                }

                defer.resolve();
            } ).catch( function ( error ) {
                Registry.getController( 'Error' ).addError( error );
                defer.reject( error );
            } );

        } );

        return defer.promise;
    },

    loadModel3D: function ( layer, url, options, feature, mt ) {
        var defer = P.defer();
        var self = this;
        var opt = options || this.createOptions();
        opt.layer = layer;
        var rootBounds = feature.getAttributeByName( 'rootBounds' );
        if ( rootBounds !== undefined ) {
            var jBounds = JSON.parse( rootBounds );
            opt.rootBounds = jBounds;
        }
        // Getting the base path. It is important because the 3D tile loader use it
        var databasePath = url.substring( 0, url.lastIndexOf( '/' ) + 1 );
        opt.databasePath = databasePath;
        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {
            opt.appendQuery = mount.appendQuery;

            P.resolve( osgDB.readNodeURL( url, opt ) )
                .then( function ( model3D ) {
                    self._rootModel = model3D;
                    var modelNode = new Model3DNode( layer );
                    modelNode.addModelNode( model3D );
                    modelNode.addChild( self._asBuiltModels );

                    // Disabled cull face for all 3D models
                    var cullFaceMode = new osg.CullFace();
                    cullFaceMode.setMode( osg.CullFace.DISABLE );
                    model3D.getOrCreateStateSet().setAttributeAndModes( cullFaceMode );

                    self._modulateTexture = model3D.getUserData() && model3D.getUserData().enableTexture;
                    self._modulateMaterial = model3D.getUserData() && model3D.getUserData().enableMaterial;
                    if ( self._modulateTexture || self._modulateMaterial ) {
                        self.updateStateSet( self._sceneGraph.getOrCreateStateSet(), true );
                    }

                    // setting user data
                    if ( feature !== undefined ) {

                        var numPoints = feature.getGeometry().getNumPoints();
                        var geometryData = self.getOrCreateFeatureGeometry( feature.getGeometry(), numPoints );

                        modelNode.setUserData( {
                            vertices: geometryData.verticesUserData,
                            featureId: feature.getId(),
                            layerId: layer.getId()
                        } );
                    }

                    // calculating relative position for the model
                    var relativePosition = self.getRelativePosition( model3D, modelNode, layer, feature );

                    mt.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), relativePosition ) );
                    mt.dirtyBound();

                    self.setInstancesMap();

                    // return node to add to pagedLOD and relative priority to download
                    defer.resolve( modelNode );
                } ).catch( function ( error ) {
                    Registry.getController( 'Error' ).addError( error );
                    defer.reject( error );
                } );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    getInstancesMap: function () {
        return this._findInstancesVisitor.getInstancesMap();
    },

    setInstancesMap: function () {
        this._findInstancesVisitor.clearInstanceMap();
        this._rootModel.accept( this._findInstancesVisitor );
    },

    selectFeature: function ( f ) {
        let instanceGuid = f.getAttributeByName( 'instanceGuid' );
        let node = this.getInstancesMap().get( instanceGuid );
        let osgStateSet = node.getOrCreateStateSet();
        let colorUniform = osgStateSet.getUniform( 'color' );
        let selColor = osg.vec4.create();
        osg.vec4.copy( selColor, this.getSelectionColor() );
        if ( !colorUniform ) {
            osgStateSet.addUniform( osg.Uniform.createFloat4( selColor, 'color' ) );
            return;
        }
        colorUniform.setVec4( selColor );
    },

    deselectFeature: function ( f ) {
        let instanceGuid = f.getAttributeByName( 'instanceGuid' );
        let node = this.getInstancesMap().get( instanceGuid );
        let osgStateSet = node.getOrCreateStateSet();
        let colorUniform = osgStateSet.getUniform( 'color' );
        if ( colorUniform ) {
            colorUniform.setVec4( this._color );
        }
    },

    drawAsBuilt: function ( featureInstanceGuid, asBuiltTransform, featureId, featureTransform ) {
        // For now, we are going to remove previous as-built nodes here before rendering the current one
        this._asBuiltModels.removeChildren();
        const node = this.getInstancesMap().get( featureInstanceGuid );

        const foundOsgMT = this.findNodeInChildren( node );
        if ( !foundOsgMT )
            return;

        let mt = new osg.MatrixTransform();
        let asBuiltTransformTranspose = asBuiltTransform.slice();
        osg.mat4.transpose( asBuiltTransformTranspose, asBuiltTransformTranspose );

        osg.mat4.mul( mt.getMatrix(), asBuiltTransformTranspose, featureTransform );
        this._asBuiltModels.addChild( mt );
        mt.addChild( foundOsgMT ); // we add the MT and not directly the Node with the Geometry because we need the transform with tiny decimals

        // render blue and highlight
        this.highlightFeature( featureInstanceGuid );
        let color = [ 0, 0, 0, this._alpha ];
        this.setAsBuiltColor( color, featureId, new Set( [ featureId ] ), mt );
    },

    //helper function
    findNodeInChildren: function ( node ) {
        if ( !node.getChildren() )
            return undefined;
        let osgNode = node.getChildren().find( ( child ) => child.getTypeID() === osg.Node.typeID );
        if ( osgNode )
            return node;
        for ( let child of node.getChildren() ) {
            osgNode = this.findNodeInChildren( child );
            if ( osgNode )
                return osgNode;
        }
    },

    highlightFeature: function ( featureInstanceGuid ) {
        this._highlightFeature = true;

        this.getInstancesMap().forEach( ( instance, instanceGuid ) => {
            if ( instanceGuid !== featureInstanceGuid )
                instance.setNodeMask( 0 );
            else
                instance.setNodeMask( ~0x0 );
        } );
    },

    setHighlightFeature: function ( flag ) {
        this._highlightFeature = flag;
        if ( !flag )
            this.getInstancesMap().forEach( ( instance ) => {
                instance.setNodeMask( ~0x0 );
            } );
    },

    clearAsBuiltModels: function () {
        this._asBuiltModels.removeChildren();
    },

    setVisibilityAsBuiltModels: function ( visible ) {
        this._asBuiltModels.setNodeMask( visible ? ~0x0 : 0x0 );
    },

    setVisibilityAsDesignedModels: function ( visible ) {
        this._rootModel.setNodeMask( visible ? ~0x0 : 0x0 );
    },

    getShaderInfo() {
        let shaderInfo = super.getShaderInfo();
        shaderInfo.uniformUseModelColor = false;
        shaderInfo.attributeColor = false;

        return shaderInfo;
    }
} );

module.exports = MultiModel3DSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/MultiPointMarkerSymbol3D.js":
/*!**************************************************************!*\
  !*** ./sources/pcvizGISRenderer/MultiPointMarkerSymbol3D.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).MarkerSymbol3D;
var MultiPointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MultiPointSymbol3D */ "./sources/pcvizGISRenderer/MultiPointSymbol3D.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var MultiPointMarkerSymbol3D = function () {
    MarkerSymbol3D.call( this );
    this._multiPointSymbol3D = new MultiPointSymbol3D();
};


MultiPointMarkerSymbol3D.prototype = osg.objectInherit( MarkerSymbol3D.prototype, {

    getColor: function () {
        return this._multiPointSymbol3D.getColor();
    },

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PointSymbolizer ) {
            if ( style.PointSymbolizer.marker )
                this._imageURL = style.PointSymbolizer.marker;

            this._multiPointSymbol3D.configureSymbolizers( style, saveAlpha );
        }
    },

    configureAsInvisible: function () {
        this._multiPointSymbol3D.configureAsInvisible();
    },

    setStateSet: function () {
        MarkerSymbol3D.prototype.setStateSet.call( this );
    },

    getShaderInfo: function () {
        return this._multiPointSymbol3D.getShaderInfo();
    },

    getMarkerPosition: function ( geometry, layer ) {
        return MultiPointSymbol3D.prototype.getMarkerPosition( geometry, layer );
    },

    getMarkerVerticesUserData: function ( i ) {
        return [ i, i ];
    },

    getMarkersFeature: function ( feature ) {
        var fNodes = this.getVisitorFeatureNodes( feature );

        return fNodes.filter( function ( fNode ) {
            return ( fNode instanceof osg.AutoTransform );
        } );
    },

    drawMarkersFeature: function ( feature, layer, selectedFeatures, center ) {
        var geometryCollection = feature.getGeometry();
        var numPoints = geometryCollection.getNumGeometries();

        for ( var i = 0; i < numPoints; i++ ) {

            var position = this.getMarkerPosition( geometryCollection.getGeometry( i ), layer );
            var markerNode = this.renderMarker( position, feature.getId(), selectedFeatures, center );

            var verticesUserDataAT = this.getMarkerVerticesUserData( i );
            this.assignUserDataToMarker( markerNode, verticesUserDataAT, feature.getId(), layer.getId() );

            this._sceneGraph.addChild( markerNode );
        }
    },

    renderFeature: function ( feature, layer, selectedFeatures, center, sceneGraph, childIndex ) {
        this._multiPointSymbol3D._invalidateFeatures = this._invalidateFeatures;
        this._multiPointSymbol3D._invalidateLabels = this._invalidateLabels;
        this._multiPointSymbol3D._highlightFeature = this._highlightFeature;

        return this._multiPointSymbol3D.renderFeature( feature, layer, selectedFeatures, center, sceneGraph, childIndex );
    },

    renderPage: function ( featureIterator, page, pageSize, layer, center, selectedFeatures, childIndex ) {


        if ( featureIterator.getSize() > 0 ) {
            if ( !childIndex )
                childIndex = 0;

            while ( featureIterator.next() ) {

                var feature = featureIterator.get();
                var geometryCollection = feature.getGeometry();
                var numPoints = geometryCollection.getNumGeometries();

                if ( this._rules )
                    this.evaluateRules( feature );

                var result = this.renderFeature( feature, layer, selectedFeatures, center, this._sceneGraph, childIndex );
                var geometry = result.geometry;
                childIndex += result.cNodes;

                // add the geometry to the graph
                if ( this._invalidateFeatures ) {
                    this._sceneGraph.addChild( geometry );

                    // Draw Markers
                    this.drawMarkersFeature( feature, layer, selectedFeatures, center );
                } else {
                    // refresh markers color
                    for ( var iMarker = 0; iMarker < numPoints; iMarker++ )
                        this.overwriteMarkerStateSet( feature, selectedFeatures, childIndex + iMarker, this._sceneGraph );
                }

                childIndex += numPoints; // count point markers to skip children

                // Draw the labels
                if ( this._showLabels && ( this._invalidateLabels || this._highlightFeature ) ) {

                    for ( var i = 0; i < numPoints; i++ ) {
                        var position = this.getMarkerPosition( geometryCollection.getGeometry( i ), layer );
                        this.drawLabel( feature, position, layer.getCenter(), selectedFeatures );
                    }
                }
            }
        }
    }

} );

module.exports = MultiPointMarkerSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/MultiPointSymbol3D.js":
/*!********************************************************!*\
  !*** ./sources/pcvizGISRenderer/MultiPointSymbol3D.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var PointSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).PointSymbol;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;


var MultiPointSymbol3D = function () {
    Symbol3D.call( this );
    PointSymbol.call( this );
    this._size = 15.0;
};


MultiPointSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, osg.objectInherit( PointSymbol.prototype, {

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PointSymbolizer ) {
            if ( style.PointSymbolizer.color ) {
                this._color = Utils.RGBIntToFloatColor( style.PointSymbolizer.color );
                this.applyAlpha( saveAlpha );
            }
            if ( style.PointSymbolizer.size )
                this._size = style.PointSymbolizer.size;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    updateVerticesUserData: function ( verticesUserData, i ) {
        verticesUserData.push( i );
    },

    createPrimitive: function ( vertices ) {
        return ( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, vertices.length / 3 ) );
    },

    getSize: function () {
        return this._size;
    },

    getMarkerPosition: function ( object, layer ) {
        if ( object.getXYZM ) // it's a geometry
            return this.getGeometryPosition( object, layer );

        // object is a feature
        var geometryCollection = object.getGeometry();
        var numPoints = geometryCollection.getNumGeometries();

        var avPos = [ 0, 0, 0 ];
        for ( var i = 0; i < numPoints; i++ ) {
            var position = this.getGeometryPosition( geometryCollection.getGeometry( i ), layer );
            avPos[ 0 ] += position[ 0 ];
            avPos[ 1 ] += position[ 1 ];
            avPos[ 2 ] += position[ 2 ];
        }
        avPos[ 0 ] /= numPoints;
        avPos[ 1 ] /= numPoints;
        avPos[ 2 ] /= numPoints;
        return avPos;
    },

    getGeometryPosition: function ( geometry, layer ) {
        var position = geometry.getXYZM();
        position[ 2 ] = ( geometry.getCoordinateDimension() === 3 ) ? position[ 2 ] : layer.getDefaultZ();
        return position;
    },

    getShaderInfo: function () {
        return {
            attributeNormal: false,
            attributeColor: true,
            attributePointSize: true,
            uniformColor: false,
            varyingPos: true, // needed for buffers 
            varyingColor: true,
            pointCircle: true
        };
    },

} ) );

module.exports = MultiPointSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/PanoramaSymbol3D.js":
/*!******************************************************!*\
  !*** ./sources/pcvizGISRenderer/PanoramaSymbol3D.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/ImageSymbol3D */ "./sources/pcvizGISRenderer/ImageSymbol3D.js" );
var SpherePano = __webpack_require__( /*! pcvizPano/SpherePano */ "./sources/pcvizPano/SpherePano.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Light = osg.Light;


var FindFeatureVisitor = function ( f ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._featureNode = undefined;
    this._feature = f;
};

FindFeatureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        var fid = this._feature.getId();
        var userData = node.getUserData();
        if ( userData !== undefined ) {
            if ( fid === userData.featureId ) {
                this._featureNode = node;
                return;
            }
        }
        this.traverse( node );
    },
    getFeatureNode: function () {
        return this._featureNode;
    }
} );

/**
 * This symbol has a child node with an image as a texture.
 * @class
 * @extends pcvizGISRenderer.ImageSymbol3D
 * @memberof pcvizGISRenderer
 */
var PanoramaSymbol3D = function () {
    ImageSymbol3D.call( this );
    this._name = 'PanoramaSymbol3D';
    this._groupNodeName = 'PanoramaGroupNode';
    this._imageNodeName = 'PanoramaSphere';
    this._selectionColor = new Float32Array( 4 ); // To make point invisible when selected.
    this._onPanoramaMode = false;


    this._fakeLight = new Light( 0, true );
    this._sphereNodes = undefined;
};

PanoramaSymbol3D.prototype = osg.objectInherit( ImageSymbol3D.prototype, {

    setRotationFromFeatureDataOldPanoramas: function ( feature ) {
        this._yaw = feature.getAttributeByName( 'attitude(z)=pan' );
        this._pitch = feature.getAttributeByName( 'attitude(y)=pitch' );
        this._roll = feature.getAttributeByName( 'attitude(x)=roll' );
        this._imageNode.setRotationFromYawPitchRoll( this._yaw, this._pitch, this._roll );
    },

    getImageNode: function () {
        return PanoramaSymbol3D.getImageNodeInstance();
    },

    renderFeature: function ( feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount ) {
        vertexCount = ImageSymbol3D.prototype.renderFeature.call( this, feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount );


        if ( this._invalidateFeatures ) {

            var index = featureIterator.getIndex();
            var translationMT = new osg.AutoTransform();
            translationMT.setAutoScaleToScreen( true );
            translationMT.setMaximumScale( 5 );
            translationMT.setMinimumScale( 0.1 );

            var sphere = Utils.createTexturedSphereFragment( 0.65, 5, 5 ); // TODO optimize using a simple sphere
            var material = new osg.Material();
            material.setDiffuse( [ this._color[ 0 ], this._color[ 1 ], this._color[ 2 ], 0.0 ] );
            sphere.getOrCreateStateSet()
                .setAttributeAndModes( material );

            translationMT.addChild( sphere );
            translationMT.setPosition( [ this._geometryData.vertices[ index * 3 ], this._geometryData.vertices[ index * 3 + 1 ], this._geometryData.vertices[ index * 3 + 2 ] ] );
            this._sphereNodes.addChild( translationMT );

            sphere.setUserData( {
                featureId: feature.getId(),
                layerId: layer.getId()
            } );

            let stateSet = sphere.getOrCreateStateSet();
            stateSet.setAttributeAndModes( this._fakeLight );
            stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );
            var depth = new osg.Depth( osg.Depth.ALWAYS );
            depth.setWriteMask( false ); // avoid sphere surface with EDL
            stateSet.setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

            if ( selectedFeatures.size > 0 ) {
                this._sphereNodes.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
            }
        }

        return vertexCount;
    },

    initSceneGraph: function ( layer ) {
        ImageSymbol3D.prototype.initSceneGraph.call( this, layer );
        if ( !this._sphereNodes ) {
            this._sphereNodes = new osg.MatrixTransform();
            this._sphereNodes.setName( 'spherePickPanoramaSymbol' );
            this._sphereNodes.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_SYMBOL3D, Utils.RENDERBIN_SYMBOL3D_TYPE );
            this._symbolNode.addChild( this._sphereNodes );
        }

        if ( this._invalidateFeatures ) {
            this._sphereNodes.releaseGLObjects();
            this._sphereNodes.removeChildren();
        }
    },

    getOnPanoramaMode: function () {
        return this._onPanoramaMode;
    },

    setOnPanoramaMode: function ( value ) {
        this._onPanoramaMode = value;

        // Enter on panorama mode will disable intersections with this panorama.
        // Exit from panorama mode will enable again intersection with this panorama.
        this.enableIntersections( !value );
    },

    enableIntersections: function ( value ) {
        this._sphereNodes.setNodeMask( value ? Utils.VISIBILITY_MASK : ~Utils.TRAVERSAL_MASK_IV );
    },

    selectFeature: function ( feature ) {
        ImageSymbol3D.prototype.selectFeature.call( this, feature );

        // Uncomment if we want to manage the mask by panorama
        // (Now it is for the whole set of panoramas because we don't know if a scan can have more than one. In that case it should be difficult to pick a panorama of another layer)
        /*var fv = new FindFeatureVisitor( feature );
        this._sphereNodes.accept( fv );
        var featureSphere = fv.getFeatureNode();
        if ( !featureSphere )
            return;*/
    },

    deselectFeature: function ( feature ) {
        ImageSymbol3D.prototype.deselectFeature.call( this, feature );

        // Same comment as previous function
        /*var fv = new FindFeatureVisitor( feature );
        this._sphereNodes.accept( fv );
        var featureSphere = fv.getFeatureNode();
        if ( !featureSphere )
            return;*/
    },

    setCenterTransform: function ( center, layerCenter ) {
        let differenceCenter = osg.vec3.sub( osg.vec3.create64(), center, layerCenter );
        this._sceneGraph.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
        this._sphereNodes.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
    }

} );

// Single instace of the Panorama Sphere
PanoramaSymbol3D.imageNode = undefined;

// This static method is used to retrieve the Panorama Sphere instance without a PanoramaSymbol3D object.
PanoramaSymbol3D.getImageNodeInstance = function () {
    if ( !PanoramaSymbol3D.imageNode )
        PanoramaSymbol3D.imageNode = new SpherePano();
    return PanoramaSymbol3D.imageNode;
};

PanoramaSymbol3D.reset = function () {
    PanoramaSymbol3D.imageNode = undefined;
};

module.exports = PanoramaSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/PlanarImageSymbol3D.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizGISRenderer/PlanarImageSymbol3D.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/ImageSymbol3D */ "./sources/pcvizGISRenderer/ImageSymbol3D.js" );
var PointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js" );
var PlanarImage = __webpack_require__( /*! pcvizNode/PlanarImage */ "./sources/pcvizNode/PlanarImage.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var ImageUtils = __webpack_require__( /*! pcvizUtils/ImageUtils */ "./sources/pcvizUtils/ImageUtils.js" ).default;
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var PlanarImageSymbol3D = function () {
    ImageSymbol3D.call( this );
    this._name = 'PlanarImageSymbol3D';
    this._groupNodeName = 'PlanarImageGroupNode';
    this._imageNodeName = 'PlanarImage';

    this._sketchTool = new SketchTool( undefined );
    // Now, we add the camera symbols in a subgraph. So, they are not coloured as the symbol rules. They can not be picked,
    this._camerasNode = undefined;
    this._invalidateCameras = true;

    // will be overwritten by symbolizers
    this._lineColor = [ 1.0, 0.0, 0.0, 1.0 ];
    this._fillColor = [ 0.0, 0.0, 1.0, 1.0 ];
    this._lineWidth = Utils.DEFAULT_LINESYMBOLIZER_WIDTH;

    var self = this;

    Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.PLANAR_IMAGE_DISTANCE_KEY, function ( distance ) {
        if ( self._imageNode )
            self._imageNode.setDistance( distance * Utils.BOUNDING_FACTOR );
    } );

    document.addEventListener( 'cleanPlanarImage', function ( /*e*/) {
        self._imageNode._dirty = true;
    }, false );
};

PlanarImageSymbol3D.prototype = osg.objectInherit( ImageSymbol3D.prototype, {

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {

        PointSymbol3D.prototype.configureSymbolizers.call( this, style, saveAlpha );

        // lines symbolization
        if ( style && style.LineSymbolizer ) {
            if ( style.LineSymbolizer.strokeColor ) {
                this._lineColor = Utils.RGBIntToFloatColor( style.LineSymbolizer.strokeColor );
            }
            if ( style.LineSymbolizer.strokeWidth )
                this._lineWidth = style.LineSymbolizer.strokeWidth;
        }

        // image plane symbolization
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.fillColor ) {
                this._fillColor = Utils.RGBIntToFloatColor( style.PolygonSymbolizer.fillColor );
            }
        }
    },

    // This method is overwritten to manage the camera symbols in a subgraph.
    initSceneGraph: function ( layer ) {
        ImageSymbol3D.prototype.initSceneGraph.call( this, layer );
        if ( !this._camerasNode ) {
            this._camerasNode = new osg.MatrixTransform();
            this._camerasNode.setName( 'Cameras_PlanarImageSymbol' );
            this._camerasNode.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_SYMBOL3D, Utils.RENDERBIN_SYMBOL3D_TYPE );

            this._symbolNode.addChild( this._camerasNode );
        }

        if ( this._invalidateFeatures ) {
            this._camerasNode.releaseGLObjects();
            this._camerasNode.removeChildren();
        }
    },

    setAttributesFromFeatureData: function ( feature ) {
        if ( feature.getAttributeByName( 'principalPointX' ) ) {
            this._imageNode.setCameraPrincipalPoint( feature.getAttributeByName( 'principalPointX' ), feature.getAttributeByName( 'principalPointY' ) );
        }

        if ( feature.getAttributeByName( 'sensorWidth' ) ) {
            this._imageNode.setCameraSensorSize( feature.getAttributeByName( 'sensorWidth' ), feature.getAttributeByName( 'sensorHeight' ) );
        }

        var distortion = feature.getAttributeByName( 'k1' );
        if ( distortion !== undefined && distortion !== null )
            this._imageNode.setDistortionParams( {
                K1: feature.getAttributeByName( 'k1' ),
                K2: feature.getAttributeByName( 'k2' ),
                K3: feature.getAttributeByName( 'k3' ),
                P1: feature.getAttributeByName( 'p1' ),
                P2: feature.getAttributeByName( 'p2' )
            } );

        if ( feature.getAttributeByName( 'fovW' ) ) {
            this._imageNode.setFieldOfViewValues( feature.getAttributeByName( 'fovW' ), feature.getAttributeByName( 'fovH' ) );
            return;
        }

        if ( feature.getAttributeByName( 'focalLength35mmEquiv' ) )
            this._imageNode.set35mmEquivalentFieldOfView( feature.getAttributeByName( 'focalLength35mmEquiv' ) );
    },

    getLookAt: function () {
        return this._imageNode.getLookAt();
    },

    getImageNode: function () {
        return PlanarImageSymbol3D.getImageNodeInstance();
    },

    float32Concat: function ( array, times ) {
        var result = new Float32Array( array.length * times );

        for ( var i = 0; i < times; i++ ) {
            result.set( array, array.length * i );
        }

        return result;
    },

    createCameraSymbolGeometry: function ( scaleValue, fovX, fovY, distance, principalPointX, principalPointY, cameraSensorWidth, cameraSensorHeight ) {
        // Create the parent node of the necessary geometries
        var cameraNode = new osg.Node();
        // Draw lines
        var lines = [];
        var colors = this.float32Concat( this._lineColor, 2 );

        var vertices = [
            [ 0, 0, 0 ]
        ];
        var halfWidth = distance * Math.tan( fovX / 2 );
        var halfHeight = distance * Math.tan( fovY / 2 );
        var xOffsetPercent = 0,
            yOffsetPercent = 0;
        if ( principalPointX !== undefined && cameraSensorWidth )
            xOffsetPercent = ( principalPointX - ( cameraSensorWidth / 2.0 ) ) / cameraSensorWidth;
        if ( principalPointY !== undefined && cameraSensorHeight )
            yOffsetPercent = ( principalPointY - ( cameraSensorHeight / 2.0 ) ) / cameraSensorHeight;
        var offsetX = halfWidth * 2.0 * xOffsetPercent;
        var offsetY = halfHeight * 2.0 * yOffsetPercent;

        var verticeTL = [ -halfWidth - offsetX, halfHeight + offsetY, -distance ];
        var verticeTR = [ halfWidth - offsetX, halfHeight + offsetY, -distance ];
        var verticeBL = [ -halfWidth - offsetX, -halfHeight + offsetY, -distance ];
        var verticeBR = [ halfWidth - offsetX, -halfHeight + offsetY, -distance ];

        var planeVerticesArray = [ verticeTL, verticeTR, verticeBL, verticeBR ];
        for ( var i = 0; i < 4; i++ ) {
            vertices.push( planeVerticesArray[ i ] );
            lines[ i ] = this._sketchTool.drawScreenLines( vertices, false, colors, this._lineWidth, false, false ).segments;
            lines[ i ].getOrCreateStateSet().removeAttribute( 'Depth' );
            // Add geometry lines to the camera node
            cameraNode.addChild( lines[ i ] );
            vertices.pop();
        }

        // Draw plane
        var planeGeometry = new osg.Geometry();
        var planeVertices = new Float32Array( verticeTL.concat( verticeTR ).concat( verticeBL ).concat( verticeBR ) );
        var planeColors = this.float32Concat( this._fillColor, 4 );
        planeGeometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, planeVertices, 3 );
        planeGeometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, planeColors, 4 );

        var indexes = new Uint16Array( [ 0, 1, 2, 2, 1, 3 ] );
        var gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes );

        planeGeometry.getPrimitives().push( new osg.DrawElements( osg.primitiveSet.TRIANGLES, gIndexes ) );

        var stateSet = planeGeometry.getOrCreateStateSet();
        stateSet.setAttributeAndModes( this._sketchTool.getShader(), osg.StateAttribute.OVERRIDE | osg.StateAttribute.PROTECTED );
        stateSet.setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );
        stateSet.setAttributeAndModes( new osg.BlendFunc( osg.BlendFunc.ONE, osg.BlendFunc.ONE_MINUS_SRC_ALPHA ) );

        // Add geometry plane to the camera node
        cameraNode.addChild( planeGeometry );

        return cameraNode;
    },

    renderFeature: function ( feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount ) {
        vertexCount = ImageSymbol3D.prototype.renderFeature.call( this, feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount );

        var index = featureIterator.getIndex();
        var cameraIndex = index + ( page - 1 ) * Utils.PAGE_SIZE;

        if ( this._invalidateFeatures || this._invalidateCameras ) {

            // Check if the fov exists
            if ( !feature.getAttributeByName( 'fovW' ) && !feature.getAttributeByName( 'fovH' ) && !feature.getAttributeByName( 'focalLength35mmEquiv' ) ) {
                // Adds fake node to maintain the node index relative to the feature index
                this._camerasNode.addChild( new osg.Node() );
                return vertexCount;
            }
            var fovX, fovY;

            if ( feature.getAttributeByName( 'fovW' ) ) {
                fovX = feature.getAttributeByName( 'fovW' );
                fovY = feature.getAttributeByName( 'fovH' );
            } else if ( feature.getAttributeByName( 'focalLength35mmEquiv' ) ) { // For old cases
                var fovs = this.getImageNode().computeEquivalentFieldOfView( feature.getAttributeByName( 'focalLength35mmEquiv' ) );
                fovX = fovs.x;
                fovY = fovs.y;
            }


            var distance = Utils.BOUNDING_FACTOR * Registry.getController( 'UserPreferences' ).getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY );
            // Create the camera symbol node
            var cameraSymbolNode = this.createCameraSymbolGeometry( 3.0, fovX, fovY, distance, feature.getAttributeByName( 'principalPointX' ), feature.getAttributeByName( 'principalPointY' ), feature.getAttributeByName( 'sensorWidth' ), feature.getAttributeByName( 'sensorHeight' ) );

            if ( this._invalidateFeatures ) {
                // Create a matrix transform with the relative rotation to the image.
                var rotationMatrixTransform = new osg.MatrixTransform();
                ImageUtils.setRotationFromImage( rotationMatrixTransform.getMatrix(), feature );
                rotationMatrixTransform.dirtyBound();

                // Add the camera symbol node to the matrix transform as a child
                rotationMatrixTransform.addChild( cameraSymbolNode );
                // Create a matrix transform with the relative feature's position. Add the previous matrix transform as a child.
                var translationMT = new osg.MatrixTransform();
                osg.mat4.fromTranslation( translationMT.getMatrix(), [ this._geometryData.vertices[ index * 3 ], this._geometryData.vertices[ index * 3 + 1 ], this._geometryData.vertices[ index * 3 + 2 ] ] );
                translationMT.addChild( rotationMatrixTransform );
                // Add the matrix transform to the scene.
                this._camerasNode.addChild( translationMT );

                // If the features have been invalidated, the ImageSymbol should reselect the current selected feature
                // (to show its image node in the right position)
                if ( selectedFeatures.has( feature.getId() ) )
                    this.selectFeature( feature );
            } else {
                // Replace the camera symbol node by the new one
                var rotationMatrix = this._camerasNode.getChild( cameraIndex ).getChild( 0 );
                rotationMatrix.removeChildren();
                rotationMatrix.addChild( cameraSymbolNode );
            }
        }

        // Gets the relative camera symbol child to the current feature and sets the right mask 
        var cameraChild = this._camerasNode.getChild( cameraIndex );
        if ( this._color[ 3 ] < 0.01 || // do not draw pyramids for transparent features
            ( this._highlightFeature && !selectedFeatures.has( feature.getId() ) ) )
            cameraChild.setNodeMask( 0x0 );
        else
            cameraChild.setNodeMask( Utils.VISIBILITY_MASK );

        // For the selected feature, hides its plane from its camera symbol (if the camera symbol exists)
        if ( !cameraChild.getNumChildren() )
            return vertexCount;
        if ( selectedFeatures.has( feature.getId() ) )
            cameraChild.getChild( 0 ).getChild( 0 ).getChild( 4 ).setNodeMask( 0x0 );
        else
            cameraChild.getChild( 0 ).getChild( 0 ).getChild( 4 ).setNodeMask( Utils.VISIBILITY_MASK & ~Utils.TRAVERSAL_MASK_IV );
        return vertexCount;
    },

    setCamerasInvalidation: function ( value ) {
        this._invalidateCameras = value;
    },

    setImageMode: function ( value ) {
        ImageSymbol3D.prototype.setImageMode.call( this, value );

        this._camerasNode.setNodeMask( 0x0 );
    },

    setSymbolizer: function () {
        this.getImageNode().setSymbolizer( this );
    },

    setCenterTransform: function ( center, layerCenter ) {
        let differenceCenter = osg.vec3.sub( osg.vec3.create64(), center, layerCenter );
        this._sceneGraph.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
        this._camerasNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
    }

} );

// Single instance of the PlanarImage
PlanarImageSymbol3D.imageNode = undefined;

// This static method is used to retrieve the PlanarImage instance without a PlanarImageSymbol3D object.
PlanarImageSymbol3D.getImageNodeInstance = function () {
    if ( !PlanarImageSymbol3D.imageNode )
        PlanarImageSymbol3D.imageNode = new PlanarImage();
    return PlanarImageSymbol3D.imageNode;
};

PlanarImageSymbol3D.reset = function () {
    PlanarImageSymbol3D.imageNode = undefined;
};

module.exports = PlanarImageSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/PointCloudRenderer.js":
/*!********************************************************!*\
  !*** ./sources/pcvizGISRenderer/PointCloudRenderer.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osg = OSG.osg;

const PointSizeAttribute = __webpack_require__( /*! pcvizNode/PointSizeAttribute */ "./sources/pcvizNode/PointSizeAttribute.js" );
const GeometryTypeAttribute = __webpack_require__( /*! pcvizNode/GeometryTypeAttribute */ "./sources/pcvizNode/GeometryTypeAttribute.js" );
const PointEditionAttribute = __webpack_require__( /*! pcvizNode/PointEditionAttribute */ "./sources/pcvizNode/PointEditionAttribute.js" );
const DrawingRuleAttribute = __webpack_require__( /*! pcvizNode/DrawingRuleAttribute */ "./sources/pcvizNode/DrawingRuleAttribute.js" );
const TileUniformsAttribute = __webpack_require__( /*! pcvizNode/TileUniformsAttribute */ "./sources/pcvizNode/TileUniformsAttribute.js" );
const ElementIDAttribute = __webpack_require__( /*! pcvizNode/ElementIDAttribute */ "./sources/pcvizNode/ElementIDAttribute.js" );
const BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
const LightingAttribute = __webpack_require__( /*! pcvizNode/LightingAttribute */ "./sources/pcvizNode/LightingAttribute.js" );
const SideAttribute = __webpack_require__( /*! pcvizNode/SideAttribute */ "./sources/pcvizNode/SideAttribute.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );

const Properties = function ( layer ) {

    var selectedStyle = layer.getStyle();

    // The Json comes with multiple styles, and starts with style, that's why we have here the symbolizer
    var symbolizer = selectedStyle.PointCloudSymbolizer;
    this.pointSize = parseFloat( Utils.getVariableFromURL( 'PointSize', symbolizer.pointSize ) );
    this.sizePolicy = Utils.getVariableFromURL( 'SizePolicy', symbolizer.sizePolicy );
    this.geometry = Utils.getVariableFromURL( 'Geometry', symbolizer.geometry );
    this.lightOn = ( Utils.getVariableFromURL( 'LightOn', symbolizer.lightOn ) === true );
    this.alpha = parseFloat( Utils.getVariableFromURL( 'Alpha', symbolizer.alpha ) );
    this.fixedColor = Utils.getVariableFromURL( 'FixedColor', symbolizer.fixedColor );
    this.maxDistance = parseFloat( Utils.getVariableFromURL( 'MaxDistance', symbolizer.maxDistance ) );
    this.drawingRule = Utils.getVariableFromURL( 'DrawingRule', symbolizer.drawingRule );
    this.maxIntensity = parseFloat( Utils.getVariableFromURL( 'MaxIntensity', symbolizer.maxIntensity ) );
    this.minIntensity = parseFloat( Utils.getVariableFromURL( 'MinIntensity', symbolizer.minIntensity ) );
    this.maxZ = parseFloat( Utils.getVariableFromURL( 'MaxZ', symbolizer.maxZ ) );
    this.minZ = parseFloat( Utils.getVariableFromURL( 'MinZ', symbolizer.minZ ) );
    this.repeatRange = ( Utils.getVariableFromURL( 'RepeatRange', symbolizer.repeatRange ) === true );
    this.classificationVisibility = symbolizer.classificationVisibility ? JSON.parse( symbolizer.classificationVisibility ) : undefined;

    // CRE heatmap-elevation
    this.elevationPolicy = Utils.getVariableFromURL( 'ElevationPolicy', symbolizer.elevationPolicy );
    this.refElevation = Utils.getVariableFromURL( 'RefElevation', symbolizer.refElevation );
    this.hideAboveBelow = Utils.getVariableFromURL( 'HideAboveBelow', symbolizer.hideAboveBelow );
    this.hideAboveBelowSize = Utils.getVariableFromURL( 'HideAboveBelowSize', symbolizer.hideAboveBelowSize );
    this.tolerance = Utils.getVariableFromURL( 'Tolerance', symbolizer.tolerance );
    this.incSize = Utils.getVariableFromURL( 'IncSize', symbolizer.incSize );
    this.numIntervals = Utils.getVariableFromURL( 'NumIntervals', symbolizer.numIntervals );
    this.repeatIntervals = Utils.getVariableFromURL( 'RepeatIntervals', symbolizer.repeatIntervals );

    // if the style doesn't have a valid maxIntensity value, set the value from layer
    if ( this.maxIntensity === -1.0 ) {
        this.maxIntensity = layer.getMaxIntensity();
    }
    // if the style doesn't have a valid minIntensity value, set the value from layer
    if ( this.minIntensity === -1.0 ) {
        this.minIntensity = layer.getMinIntensity();
    }
    // if the style doesn't have a valid maxZ value, set the value from layer
    if ( this.maxZ === -1.0 ) {
        this.maxZ = layer.getMaxZ();
    }
    // if the style doesn't have a valid minZ value, set the value from layer
    if ( this.minZ === -1.0 ) {
        this.minZ = layer.getMinZ();
    }

    // if the style doesn't have a valiz fixedColor value, set the value from layer or default
    if ( !this.fixedColor )
        this.fixedColor = layer.getFixedColor();
    if ( !this.fixedColor )
        this.fixedColor = '#808080';

    // We should update all the elements in the symbolizer (they've only been changed if the url specifies a value for them or in the previous four special cases)
    symbolizer.pointSize = this.pointSize;
    symbolizer.geometry = this.geometry;
    symbolizer.sizePolicy = this.sizePolicy;
    symbolizer.lightOn = this.lightOn;
    symbolizer.maxIntensity = this.maxIntensity;
    symbolizer.minIntensity = this.minIntensity;
    symbolizer.maxZ = this.maxZ;
    symbolizer.minZ = this.minZ;
    symbolizer.repeatRange = this.repeatRange;
    symbolizer.drawingRule = this.drawingRule;
    symbolizer.maxDistance = this.maxDistance;
    symbolizer.alpha = this.alpha;
    symbolizer.fixedColor = this.fixedColor;

    // CRE heatmap-elevation
    symbolizer.elevationPolicy = this.elevationPolicy;
    if ( this.refElevation === null )
        this.refElevation = ( this.maxZ + this.minZ ) / 2;
    symbolizer.refElevation = this.refElevation;
    symbolizer.hideAboveBelow = this.hideAboveBelow; // flag
    symbolizer.hideAboveBelowSize = this.hideAboveBelowSize; // the amount
    symbolizer.tolerance = this.tolerance;
    symbolizer.incSize = this.incSize;

    symbolizer.numIntervals = this.numIntervals;
    symbolizer.repeatIntervals = this.repeatIntervals;

    if ( !symbolizer.planeNormal )
        symbolizer.planeNormal = JSON.stringify( [ 0, 0, 1 ] );
    this.planeNormal = JSON.parse( symbolizer.planeNormal );
    if ( !symbolizer.planeConstant )
        symbolizer.planeConstant = 0;
    this.planeConstant = symbolizer.planeConstant;

    this.minClassification = layer.getMinClass();
    this.maxClassification = layer.getMaxClass();
};

/**
 * A class to render the point cloud layers.
 * @class
 * @memberof pcvizGISRenderer
 */
const PointCloudRenderer = function () {

    this._pointCloudSceneGraph = new Map();

};

PointCloudRenderer.prototype = {

    configurePointCloudProgram: function ( data ) {
        const sset = data.getStateSet();
        sset.setRenderingHint( 'TRANSPARENT_BIN' );
        sset.setAttributeAndModes( new osg.BlendFunc( osg.BlendFunc.SRC_ALPHA, osg.BlendFunc.ONE_MINUS_SRC_ALPHA ), osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );
        sset.addUniform( data.alphaUniform );

        // Shader Compiler Attributes

    },

    setPointCloudProperties: function ( pointCloud, properties, database ) {
        pointCloud.Name = database;

        var sset = new osg.StateSet();
        sset.setShaderGeneratorName( 'PointShader' );
        pointCloud.setStateSet( sset );
        // Point Size
        pointCloud.PointSize = properties.pointSize;
        pointCloud.pointSizeAttribute = new PointSizeAttribute();
        pointCloud.pointSizeAttribute.setPointSize( pointCloud.PointSize );
        pointCloud.MaxDistance = properties.maxDistance;
        pointCloud.pointSizeAttribute.setMaxDistance( Math.pow( 10, pointCloud.MaxDistance - 3.0 ) );
        pointCloud.SizeFactor = Utils.getSizeFactor( properties.pointSize, window.devicePixelRatio );
        pointCloud.pointSizeAttribute.setSizeFactor( pointCloud.SizeFactor );
        pointCloud.pointSizeAttribute.setDevicePixelRatio( window.devicePixelRatio );

        sset.setAttributeAndModes( pointCloud.pointSizeAttribute );
        pointCloud.SizePolicy = properties.sizePolicy;
        if ( pointCloud.SizePolicy === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED' )
            pointCloud.pointSizeAttribute.setAutomaticSizeEnabled( false );

        // Geometry Type
        pointCloud.geometryTypeAttribute = new GeometryTypeAttribute();
        pointCloud.geometryTypeAttribute.setEnabled( true );
        pointCloud.Geometry = properties.geometry;
        pointCloud.geometryTypeAttribute.setGeometryType( pointCloud.Geometry );
        sset.setAttributeAndModes( pointCloud.geometryTypeAttribute );

        // PointEdition
        pointCloud.pointEditionAttribute = new PointEditionAttribute();
        pointCloud.pointEditionAttribute.setEnabled( true );
        var selectColor = osg.vec4.copy( osg.vec4.create(), Registry.getController( 'UserPreferences' ).getPreference( Utils.SELECTION_COLOR_KEY ) );
        pointCloud.pointEditionAttribute.setSelectColor( selectColor );
        sset.setAttributeAndModes( pointCloud.pointEditionAttribute );
        Registry.getController( 'PointVisibilityManager' ).notifyProcessNewGeometries( pointCloud.getInstanceID() ); // Notify new PLFMZ geometry is loaded in the scene graph.

        // Side by side
        pointCloud.sideAttribute = new SideAttribute();
        sset.setAttributeAndModes( pointCloud.sideAttribute );

        // Drawing Rule
        pointCloud.DrawingRule = properties.drawingRule;
        pointCloud.OldDrawingRule = properties.drawingRule;



        pointCloud.drawingRuleAttribute = new DrawingRuleAttribute();
        pointCloud.MaxIntensity = properties.maxIntensity;
        pointCloud.drawingRuleAttribute.setMaxIntensity( pointCloud.MaxIntensity );
        pointCloud.MinIntensity = properties.minIntensity;
        pointCloud.drawingRuleAttribute.setMinIntensity( pointCloud.MinIntensity );
        pointCloud.MaxZ = properties.maxZ;
        pointCloud.drawingRuleAttribute.setMaxZ( pointCloud.MaxZ );
        pointCloud.MinZ = properties.minZ;
        pointCloud.drawingRuleAttribute.setMinZ( pointCloud.MinZ );
        pointCloud.RepeatRange = properties.repeatRange;
        pointCloud.drawingRuleAttribute.setRepeatRange( pointCloud.RepeatRange );
        pointCloud.PointCloudCenter = pointCloud.Layer.getCenter();
        pointCloud.drawingRuleAttribute.setDataCenter( pointCloud.PointCloudCenter );
        pointCloud.drawingRuleAttribute.setDrawingRule( pointCloud.DrawingRule );
        pointCloud.DrawingRuleArray = pointCloud.drawingRuleAttribute.getDrawingRuleArray();
        if ( properties.classificationVisibility )
            pointCloud.drawingRuleAttribute.setClassificationArray( properties.classificationVisibility );
        pointCloud.ClassificationArray = pointCloud.drawingRuleAttribute.getClassificationArray();

        let rgbcolor = Utils.fullhexToRgb( properties.fixedColor, 1.0, true );
        pointCloud.drawingRuleAttribute.setFixedColor( osg.vec4.fromValues32( rgbcolor[ 0 ], rgbcolor[ 1 ], rgbcolor[ 2 ], rgbcolor[ 3 ] ) );
        sset.setAttributeAndModes( pointCloud.drawingRuleAttribute );
        // TileUniforms attribute ( We need to encapsulate tile uniforms in a StateAttribute so the ShaderCompiler can acces them )
        pointCloud.tileUniformsAttribute = new TileUniformsAttribute();
        sset.setAttributeAndModes( pointCloud.tileUniformsAttribute );

        pointCloud.MinClassification = properties.minClassification;
        pointCloud.MaxClassification = properties.maxClassification;

        // CRE heatmap-elevation
        pointCloud.ElevationPolicy = properties.elevationPolicy;
        pointCloud.drawingRuleAttribute.setElevationPolicy( pointCloud.ElevationPolicy );
        pointCloud.RefElevation = properties.refElevation;
        pointCloud.drawingRuleAttribute.setRefElevation( pointCloud.RefElevation );
        pointCloud.HideAboveBelow = properties.hideAboveBelow;
        pointCloud.drawingRuleAttribute.setHideAboveBelow( pointCloud.HideAboveBelow );
        pointCloud.HideAboveBelowSize = properties.hideAboveBelowSize;
        pointCloud.drawingRuleAttribute.setHideAboveBelowSize( pointCloud.HideAboveBelowSize );
        pointCloud.Tolerance = properties.tolerance;
        pointCloud.drawingRuleAttribute.setTolerance( pointCloud.Tolerance );
        pointCloud.IncSize = properties.incSize;
        pointCloud.drawingRuleAttribute.setIncSize( pointCloud.IncSize );
        pointCloud.NumIntervals = properties.numIntervals;
        pointCloud.RepeatIntervals = properties.repeatIntervals;
        pointCloud.drawingRuleAttribute.setRepeatIntervals( pointCloud.RepeatIntervals );
        pointCloud.planeNormal = properties.planeNormal;
        pointCloud.drawingRuleAttribute.setPlaneNormal( pointCloud.planeNormal );
        pointCloud.planeConstant = properties.planeConstant;
        pointCloud.drawingRuleAttribute.setPlaneConstant( pointCloud.planeConstant );

        // Lighting ON/OFF
        pointCloud.LightOn = properties.lightOn;
        pointCloud.lightingAttribute = new LightingAttribute();
        pointCloud.lightingAttribute.setEnabled( pointCloud.LightOn );
        sset.setAttributeAndModes( pointCloud.lightingAttribute );

        pointCloud.bufferAttribute = new BufferAttribute();
        pointCloud.minColorBufferTool = osg.vec4.fromValues32( 1.0, 0.0, 0.0, 1.0 );
        pointCloud.bufferAttribute.setMinColor( pointCloud.minColorBufferTool );

        pointCloud.maxColorBufferTool = osg.vec4.fromValues32( 0.0, 0.0, 1.0, 1.0 );
        pointCloud.bufferAttribute.setMaxColor( pointCloud.maxColorBufferTool );
        pointCloud.bufferAttribute.setDataCenter( pointCloud.PointCloudCenter );
        pointCloud.rangeBufferTool = Math.pow( 1.1, ( 50.0 - 20.0 ) );
        pointCloud.bufferAttribute.setRange( pointCloud.rangeBufferTool );
        sset.setAttributeAndModes( pointCloud.bufferAttribute );

        pointCloud.Alpha = properties.alpha;
        pointCloud.alphaUniform = osg.Uniform.createFloat1( pointCloud.Alpha, 'alpha' );

        this.configurePointCloudProgram( pointCloud );

        pointCloud.sliderSizeFactor = properties.pointSize;
        // Configure extra properties
        this.setExtraPointCloudProperties( pointCloud, sset );

    },

    setExtraPointCloudProperties: function ( pointCloud, stateSet ) {

        if ( pointCloud.hasExtraAttributes ) {
            pointCloud.drawingRuleAttribute.setNumHeatMaps( pointCloud.numHeatMaps );
            pointCloud.drawingRuleAttribute.setHeatMap( 0 );
            var selectionController = Registry.getInstance().getController( 'SelectionObject' );
            var selectionCB = this.onSelection( selectionController, pointCloud, stateSet );
            selectionController.registerListener( ListenerController.PROJECT, selectionCB );
            selectionCB(); // get initial selection
        }
    },

    onSelection: function ( selectionController, pointCloud, stateSet ) {
        return function () {
            var selectionObject = selectionController.getSelectionObject();
            if ( !selectionObject )
                return;

            var layer = selectionObject.getLayer();
            // if it does not have feature renderer then is a pointcloud so do nothing and return
            if ( !layer || !layer.getFeatureRenderer ) {
                return;
            }
            // if !highlight mode then clean ElementIDAttribute and return
            var layerRenderer = layer.getFeatureRenderer();
            var symbol = ( layerRenderer && layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
            if ( symbol && symbol.getHighlightFeature && !symbol.getHighlightFeature() ) {
                if ( pointCloud.ElementIDAttribute ) {
                    pointCloud.ElementIDAttribute.setElementID( -1 );
                }
                return;
            }
            // if selection is not a vectorlayer do nothing and return
            // this happens when selecting LayerGroups (now there is a LayerGroupSelectionObject and LayerGroup has the function 'getFeatureRenderer')
            if ( !selectionObject.getFeature || !selectionObject.getFeature() ) {
                return;
            }
            var feature = selectionObject.getFeature();
            var elementIDAttribute = feature.getAttributeByName( 'ElementID' );
            // Check value different to undefined because it is a number
            var selectedElementID = ( elementIDAttribute !== undefined ) ? elementIDAttribute : -1;
            if ( !pointCloud.ElementIDAttribute )
                pointCloud.ElementIDAttribute = new ElementIDAttribute();
            pointCloud.ElementIDAttribute.setElementID( selectedElementID );
            stateSet.setAttributeAndModes( pointCloud.ElementIDAttribute );
        };
    },

    /**
     *
     * @method
     * @memberof pcvizGISRenderer.PointCloudRenderer
     * @param {pcvizGIS.PointCloudLayer} layer the layer to be rendered
     */
    renderLayer: function ( layer ) {
        if ( !layer.getUrl() ) {
            this._pointCloudSceneGraph.delete( layer );
            return P.resolve();
        }

        var defer = P.defer();
        var reader = new Input();
        var self = this;
        var opt = {};

        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {
            opt.format = 'cplfmz';

            let url = layer.getUrl();
            let fileName = url.slice( url.lastIndexOf( '/' ) + 1, url.lastIndexOf( '.' ) );
            let database = url.slice( url.lastIndexOf( 'files' ) + 6, url.lastIndexOf( '/' ) ); // in files +6 index starts where we can find the file.
            // This option property is called database, but is used as the plfmz/cplfmz in the ReaderWriters. We have persisted the old name to avoid conflicts. 
            opt.database = fileName;

            url = mount.mountPoint + '/' + database;

            opt.appendQuery = mount.appendQuery;

            opt.urlDataPrefix = url;

            var ext = layer.getDataDriver();
            url = url.concat( '/0/0/0/', fileName, '_L0_X0_Y0_Z0', '.', ext );

            opt.center = layer.getCenter();
            opt.layer = layer;

            P.resolve( reader.readPointCloudURL[ opt.format ]( url, opt ) )
                .then( function ( pointCloud ) {
                    pointCloud.Layer = layer;

                    var properties = new Properties( layer );
                    self.setPointCloudProperties( pointCloud, properties, fileName );

                    self._pointCloudSceneGraph.set( layer, pointCloud );
                    defer.resolve();

                } );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    getSceneGraph: function ( layer ) {
        return this._pointCloudSceneGraph.get( layer );
    }

};

module.exports = PointCloudRenderer;




// This function was in Viewer, but it wasn't called. I think it isn't necessary.

// setUpDefaultValues: function ( data, viewerConfig ) {
// Setting up values
//     data.MaxZ = viewerConfig.maxZ !== -1.0 ? viewerConfig.maxZ : data.Capabilities.lidarStats.maxExtent[ 2 ];
//     data.drawingRuleAttribute.setMaxZ( data.MaxZ );
//     data.MinZ = viewerConfig.minZ !== -1.0 ? viewerConfig.minZ : data.Capabilities.lidarStats.minExtent[ 2 ];
//     data.drawingRuleAttribute.setMinZ( data.MinZ );

//     data.MaxIntensity = viewerConfig.maxIntensity !== -1.0 ? viewerConfig.maxIntensity : data.Capabilities.lidarStats.maxIntensity;
//     data.drawingRuleAttribute.setMaxIntensity( data.MaxIntensity );
//     data.MinIntensity = viewerConfig.minIntensity !== -1.0 ? viewerConfig.minIntensity : data.Capabilities.lidarStats.minIntensity;
//     data.drawingRuleAttribute.setMinIntensity( data.MinIntensity );
// },


/***/ }),

/***/ "./sources/pcvizGISRenderer/PointMarkerSymbol3D.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizGISRenderer/PointMarkerSymbol3D.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var MarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).MarkerSymbol3D;
var PointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js" );

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var PointMarkerSymbol3D = function () {
    MarkerSymbol3D.call( this );
    this._pointSymbol3D = new PointSymbol3D();
};


PointMarkerSymbol3D.prototype = osg.objectInherit( MarkerSymbol3D.prototype, {

    getColor: function () {
        return this._pointSymbol3D.getColor();
    },

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        MarkerSymbol3D.prototype.configure.call( this, style );
        if ( style && style.PointSymbolizer ) {
            this._pointSymbol3D.configureSymbolizers( style, saveAlpha );
        }
        this._color = [ 1.0, 1.0, 1.0, 1.0 ]; // if we want the marker with his color We should use the white color for the symbol
    },

    configureAsInvisible: function () {
        this._pointSymbol3D.configureAsInvisible();
    },

    setStateSet: function () {
        MarkerSymbol3D.prototype.setStateSet.call( this );
    },

    getMarkerPosition: function ( feature, layer ) {
        return PointSymbol3D.prototype.getMarkerPosition( feature, layer );
    },

    getMarkerVerticesUserData: function ( i ) {
        return [ i, i ];
    },

    renderLayer: function ( layer ) {

        var center = layer.getCenter();
        var selectedFeatures = layer.getSelectedFeatures();

        this.initSceneGraph( layer );
        this._pointSymbol3D._geometryData = undefined;
        this._pointSymbol3D._highlightFeature = this._highlightFeature;

        let layerCenter;
        if ( layer.getExtent().isValid() ) {
            layerCenter = layer.computeCenter( true ); // only computes real center but doesn't set it
            this.setCenterTransform( center, layerCenter );
        }

        var defer = P.defer();
        var self = this;

        var page = 1;
        var pageSize = Utils.PAGE_SIZE;

        this.renderByPages( page, pageSize, layer, layerCenter ? layerCenter : center, selectedFeatures ).then( function () {

            self.setStateSet();

            defer.resolve();
        } );

        return defer.promise;

    },

    renderPage: function ( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        var numFeatures = featureIterator.getSize();
        if ( numFeatures > 0 ) {
            if ( this._invalidateFeatures )
                this._pointSymbol3D.getOrCreateFeatureGeometry( numFeatures );

            var selectionColor = this.getSelectionColor();
            var vertexCount = 0;
            var childIndex = 0;

            while ( featureIterator.next() ) {

                var feature = featureIterator.get();

                if ( this._rules )
                    this.evaluateRules( feature );

                var position = this.getMarkerPosition( feature, layer );

                if ( this._invalidateFeatures ) {
                    this._pointSymbol3D.prepareGeometryData( feature, featureIterator, layer, center, selectedFeatures, selectionColor );

                    // we put this line inside the while because we need a feature id
                    this.setGeometryStateSet( this._pointSymbol3D._geometryData.geometry, selectedFeatures, feature.getId() );

                    // Draw the marker
                    var markerNode = this.renderMarker( position, feature.getId(), selectedFeatures, center );

                    var verticesUserDataAT = this.getMarkerVerticesUserData( featureIterator.getIndex() );
                    this.assignUserDataToMarker( markerNode, verticesUserDataAT, feature.getId(), layer.getId() );

                    this._sceneGraph.addChild( markerNode );
                } else {
                    // refresh point color
                    vertexCount = this._pointSymbol3D.overwriteGeometryAttribs( page, feature, selectedFeatures, vertexCount, this._sceneGraph, ( page - 1 ) * pageSize + numFeatures + ( page - 1 ) );
                    // refresh marker color

                    this.overwriteMarkerStateSet( feature, selectedFeatures, ( childIndex ) + ( page - 1 ) * pageSize + ( page - 1 ), this._sceneGraph );
                    childIndex++;
                }

                this.drawLabel( feature, position, layer.getCenter(), selectedFeatures );
            }

            if ( this._invalidateFeatures ) {
                this._pointSymbol3D.buildGeometry();
                this.assignUserData( this._pointSymbol3D._geometryData, layer.getId() );
                this._sceneGraph.addChild( this._pointSymbol3D._geometryData.geometry );
                this.setStateSet();
            }
        }
    },

    _setFeatureColor: function ( feature, color, stateset ) {
        var features = this.getVisitorFeatureNodes( feature );
        for ( var i = 0; i < features.length; i++ ) {
            if ( features[ i ] instanceof osg.AutoTransform ) {
                features[ i ].setStateSet( stateset );

                this.configureDepthTest( color, features[ i ] );

            } else {
                // It is a Geometry
                this._pointSymbol3D._setFeatureColor( feature, color );
            }
        }
    },

    restoreColor: function () { // propagate to internal symbol
        this._pointSymbol3D.restoreColor();
        // propagate back restored color
        this._color[ 0 ] = this._pointSymbol3D._color[ 0 ];
        this._color[ 1 ] = this._pointSymbol3D._color[ 1 ];
        this._color[ 2 ] = this._pointSymbol3D._color[ 2 ];
        this._color[ 3 ] = this._pointSymbol3D._color[ 3 ];
    },

    getShaderInfo: function () {
        return this._pointSymbol3D.getShaderInfo();
    },

} );

module.exports = PointMarkerSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/PointSymbol3D.js":
/*!***************************************************!*\
  !*** ./sources/pcvizGISRenderer/PointSymbol3D.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
var PointSymbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).PointSymbol;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var GeometryData = function ( numPoints ) {
    this.geometry = new osg.Geometry();
    this.vertices = new Float32Array( numPoints * 3 );
    this.colors = new Float32Array( numPoints * 4 );
    this.pointsizes = new Float32Array( numPoints );
    this.featureIds = new Uint16Array( numPoints );
    this.verticesUserData = [];
};

var PointSymbol3D = function () {
    Symbol3D.call( this );
    PointSymbol.call( this );
    this._size = 15.0;
    this._geometryData = undefined;
    this._geometryDataByPages = [];
    this._featurePageMap = new Map();
    this._labelsColor = undefined;
};

PointSymbol3D.prototype = osg.objectInherit( Symbol3D.prototype, osg.objectInherit( PointSymbol.prototype, {

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PointSymbolizer ) {
            if ( style.PointSymbolizer.color ) {
                this._color = Utils.RGBIntToFloatColor( style.PointSymbolizer.color );
                this.applyAlpha( saveAlpha );
            }
            if ( style.PointSymbolizer.labelsColor ) {
                this._labelsColor = Utils.RGBIntToFloatColor( style.PointSymbolizer.labelsColor );
            }
            if ( style.PointSymbolizer.size )
                this._size = style.PointSymbolizer.size;

            if ( style.PointSymbolizer.depthDisabled )
                this._depthDisabled = style.PointSymbolizer.depthDisabled;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    setStateSet: function () {
        Symbol3D.prototype.setStateSet.call( this );
    },

    updateVerticesUserData: function ( verticesUserData, i ) {
        verticesUserData.push( i );
    },

    createPrimitive: function ( vertices ) {
        return ( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, vertices.length / 3 ) );
    },

    getOrCreateFeatureGeometry: function ( numPoints ) {
        this._geometryData = new GeometryData( numPoints );
        return this._geometryData;
    },

    getGeometryDataByFeatureId: function ( featureId ) {
        if ( this._geometryDataByPages.length < 1 ) {
            return;
        }
        const page = this._featurePageMap.get( featureId );
        if ( page === undefined || page > this._geometryDataByPages.length ) {
            return;
        }
        return this._geometryDataByPages[ page - 1 ]; // As page number starts at 1, we need the -1 to position it on the geometry data array.
    },

    prepareGeometryData: function ( feature, featureIterator, layer, center, selectedFeatures, selectionColor ) {
        var gisGeometry = this.getFeatureGeometry( feature );
        var i = featureIterator.getIndex();

        this._geometryData.featureIds[ i ] = feature.getId();
        this.updateVerticesUserData( this._geometryData.verticesUserData, i );

        this.pushVertex( this._geometryData.vertices, layer, gisGeometry, i, center );
        this.pushColor( this._geometryData.colors, selectedFeatures, feature.getId(), i, selectionColor );
        this._geometryData.pointsizes[ i ] = this._size;
    },

    getSize: function () {
        return this._size;
    },

    buildGeometry: function () {
        var geometry = this._geometryData.geometry;
        geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, this._geometryData.vertices, 3 );
        geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, this._geometryData.colors, 4 );
        geometry.getAttributes().PointSize = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, this._geometryData.pointsizes, 1 );

        geometry.getPrimitives().push( this.createPrimitive( this._geometryData.vertices ) );
    },

    overwriteGeometryAttribs: function ( page, feature, selectedFeatures, vertexCount, sceneGraph, childIndexCustom ) {

        var gisGeometry = this.getFeatureGeometry( feature );
        var numPoints = this.getNumPoints( gisGeometry );
        if ( !sceneGraph )
            sceneGraph = this._sceneGraph;
        if ( childIndexCustom === undefined )
            childIndexCustom = page - 1;
        var geometry = sceneGraph.getChild( childIndexCustom );
        if ( !geometry )
            geometry = sceneGraph.getChild( sceneGraph.getNumChildren() - 1 ); // for the last page
        var colorVector = geometry.getAttributes().Color.getElements();
        var sizesVector = geometry.getAttributes().PointSize.getElements();

        for ( var iColor = vertexCount; iColor < vertexCount + numPoints; iColor++ ) {
            this.pushColor( colorVector, selectedFeatures, feature.getId(), iColor, this.getSelectionColor() );
            sizesVector[ iColor ] = this._size;
        }
        geometry.getAttributes().Color.dirty();
        geometry.getAttributes().PointSize.dirty();

        return vertexCount + numPoints;
    },

    renderLayer: function ( layer ) {

        var center = layer.getCenter();
        var selectedFeatures = layer.getSelectedFeatures();

        this.initSceneGraph( layer );
        let layerCenter;
        if ( layer.getExtent().isValid() ) {
            layerCenter = layer.computeCenter( true ); // only computes real center but doesn't set it
            this.setCenterTransform( center, layerCenter );
        }

        if ( this._invalidateFeatures ) {
            this._geometryData = undefined;
            this._geometryDataByPages = [];
            this._featurePageMap.clear();
        }

        var defer = P.defer();
        var self = this;

        var page = 1;
        var pageSize = Utils.PAGE_SIZE;

        this.renderByPages( page, pageSize, layer, layerCenter ? layerCenter : center, selectedFeatures ).then( function () {

            self.setStateSet();

            defer.resolve();
        } );

        return defer.promise;
    },

    renderFeature: function ( feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount ) {
        if ( this._invalidateFeatures ) {
            this.prepareGeometryData( feature, featureIterator, layer, center, selectedFeatures, selectionColor );

            // we put this line inside the while because we need a feature id
            this.setGeometryStateSet( this._geometryData.geometry, selectedFeatures, feature.getId() );
        } else
            vertexCount = this.overwriteGeometryAttribs( page, feature, selectedFeatures, vertexCount );

        return vertexCount;
    },

    renderPage: function ( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        var numFeatures = featureIterator.getSize();

        if ( numFeatures > 0 ) {
            if ( this._invalidateFeatures )
                this.getOrCreateFeatureGeometry( numFeatures );

            var selectionColor = this.getSelectionColor();

            var vertexCount = 0;

            while ( featureIterator.next() ) {

                var feature = featureIterator.get();

                if ( this._rules )
                    this.evaluateRules( feature );

                vertexCount = this.renderFeature( feature, featureIterator, layer, center, selectedFeatures, selectionColor, page, vertexCount );
                this._featurePageMap.set( feature.getId(), page );

                // Draw the label
                var position = this.getMarkerPosition( feature, layer );
                this.drawLabel( feature, position, layer.getCenter(), selectedFeatures );
            }

            if ( this._invalidateFeatures ) {
                this.buildGeometry();
                this.assignUserData( this._geometryData, layer.getId() );
                this._geometryDataByPages[ page - 1 ] = this._geometryData;
                this._sceneGraph.addChild( this._geometryData.geometry );
                this.setStateSet();
            }

        }
    },

    _setFeatureColor: function ( feature, color ) {
        if ( !this._geometryData || this._geometryDataByPages.length < 1 )
            return; // layer not rendered yet

        const fid = feature.getId();
        let geometry = this._geometryData.geometry;
        if ( this._geometryDataByPages.length > 1 )
            geometry = this.getGeometryDataByFeatureId( fid ).geometry;
        if ( !geometry || !geometry.getAttributes().Color )
            return; // layer not rendered yet

        this.configureDepthTest( color, geometry );

        const colors = geometry.getAttributes().Color.getElements();
        for ( let i = 0; i < geometry.getUserData().featureIds.length; i++ ) {
            if ( fid === geometry.getUserData().featureIds[ i ] ) {
                this.saveColor( [ colors[ i * 4 ], colors[ i * 4 + 1 ], colors[ i * 4 + 2 ], colors[ i * 4 + 3 ] ] );
                colors[ i * 4 ] = color[ 0 ];
                colors[ i * 4 + 1 ] = color[ 1 ];
                colors[ i * 4 + 2 ] = color[ 2 ];
                colors[ i * 4 + 3 ] = color[ 3 ];
                geometry.getAttributes().Color.setElements( colors );
                break;
            }
        }
    },

    getShaderInfo: function () {
        return {
            attributeNormal: false,
            attributeColor: true,
            attributePointSize: true,
            uniformColor: false,
            varyingPos: true, // needed for buffers 
            varyingColor: true,
            pointCircle: true
        };
    },

    getMarkerPosition: function ( feature, layer ) {
        var position = feature.getGeometry().getXYZM();
        position[ 2 ] = ( feature.getGeometry().getCoordinateDimension() === 3 ) ? position[ 2 ] : layer.getDefaultZ();

        return position;
    },

    drawLabel: function ( feature, position, center, selectedFeatures ) {
        if ( this._showLabels && ( this._invalidateLabels || this._highlightFeature ) ) {
            let verticalOffset = Math.min( Math.max( 3, Math.ceil( this._size / 4 ) ), 10 );
            var labelNode = this.renderLabel( feature, selectedFeatures, position, center, -verticalOffset );
            if ( labelNode )
                this._labelsNode.addChild( labelNode );
        }
    },


} ) );

module.exports = PointSymbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js":
/*!************************************************************!*\
  !*** ./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PositionMarkerSymbol3D; });
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizNode_Group__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizNode/Group */ "./sources/pcvizNode/Group.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_6__);










const osg = OSG__WEBPACK_IMPORTED_MODULE_6___default.a.osg;
const osgText = OSG__WEBPACK_IMPORTED_MODULE_6___default.a.osgText;

class PositionMarkerSymbol3D extends pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["MarkerSymbol3D"] {
    constructor() {
        super();

        this._nameBase = 'defaultPositionName';
        this.updateNames();

        // Floor symbol
        this._floorPMS = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["MarkerSymbol3D"]();
        this._floorPMS.createQuad = this.createQuad;
        this._floorGroupPMS = new osg.Node();
        this._floorGroupPMS.setName( 'floor marker' );

        this._isSelected = false;
        this._alpha = 1.0;

        this._minScaleFloor = undefined;
    }

    setNameBase( name ) {
        this._nameBase = name;
        this.updateNames();
    }

    updateNames() {
        this._marker2DName = this._nameBase + '_marker2DModel';
        this._floorMarker2DName = this._nameBase + '_floorMarker2DModel';
    }

    setNode( node ) {
        this._node = node;
        // If the layergroup is rendered again, the _node can be one new and we need to add the _symbolNode to it.
        if ( this._symbolNode ) {
            this._node.addChild( this._symbolNode );

            this._symbolNode.addChild( this._sceneGraph );
            this._symbolNode.addChild( this._labelsNode );
        }
    }

    getNode() {
        return this._node;
    }

    configure( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        if ( style && style.PointSymbolizer ) { // usually this should exist, but it is better to check before using it
            let floorStyle = style.PointSymbolizer.floorSymbolizer;
            this._alpha = floorStyle.PointSymbolizer.color[ 3 ];
        } else {
            console.warn( 'Check why there is not style or PointSymbolizer' );
        }
    }

    configureSymbolizers( style /*, saveAlpha*/ ) {
        pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["MarkerSymbol3D"].prototype.configure.call( this, style );
        if ( style && style.PointSymbolizer ) {
            this._color = style.PointSymbolizer.color;
            this._labelId = style.PointSymbolizer.labelId;
            if ( style.PointSymbolizer.floorSymbolizer ) {
                let floorStyle = style.PointSymbolizer.floorSymbolizer;
                this._floorPMS.configure( floorStyle );
            }
        }
    }

    initSceneGraph( layer ) {
        if ( !this._symbolNode ) {
            this._sceneGraph = new osg.MatrixTransform();
            this._sceneGraph.setName( 'Symbol3D_scenegraph' );

            this._labelsNode = new osg.Node(); // Investigate if it is convenient to convert this into a MT
            this._labelsNode.setName( 'Symbol3D_labels' );
            this._labelsNode.setNodeMask( ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.TRAVERSAL_MASK_IV );

            this._symbolNode = new pcvizNode_Group__WEBPACK_IMPORTED_MODULE_4__["default"]();
            this._symbolNode.setName( 'Symbol3D_root' );

            this._symbolNode.addChild( this._sceneGraph );
            this._symbolNode.addChild( this._labelsNode );

            if ( this._node ) {
                this._node.addChild( this._symbolNode );
                this._node._dirtyFeatures = true;
            } else
                layer._dirtyFeatures = true;

            this._symbolNode.bufferAttribute = this.initBufferAttribute( layer );
        }
        // If the layergroup is rendered again, the _node can be one new
        if ( this._node )
            this._node.Layer = layer;

        if ( layer.getDirtyFeatures !== undefined && layer.getDirtyLabels !== undefined ) {
            this._invalidateFeatures = layer.getDirtyFeatures();
            if ( this._invalidateFeatures )
                this._invalidateLabels = true;
            else
                this._invalidateLabels = layer.getDirtyLabels();
        }

        if ( this._invalidateFeatures ) {
            this._sceneGraph.releaseGLObjects();
            this._sceneGraph.removeChildren();
        }
        if ( this._invalidateLabels || this._highlightFeature ) {
            this._labelsNode.releaseGLObjects();
            this._labelsNode.removeChildren();
        }

        this._sceneGraph.addChild( this._floorGroupPMS );
    }

    cleanSymbol() {
        this._floorPMS.cleanSymbol();
        this._symbolNode.removeChildren();
    }

    renderPage( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        if ( page === 1 ) {
            this._floorGroupPMS.removeChildren();
        }

        while ( featureIterator.next() ) {

            let feature = featureIterator.get();
            if ( this._rules ) { // avoid applying autoscale from rules
                this.avoidAutoscaleFeature( feature );
            }
            //generating floor marker
            let mt = new osg.MatrixTransform();

            let markerNode = this.create2DMarker( layer, feature, selectedFeatures, this._floorPMS, this._floorMarker2DName, center );

            // we need feature ID user data for picking
            let verticesUserDataAT = this.getMarkerVerticesUserData( featureIterator.getIndex() );
            this.assignUserDataToMarker( markerNode, verticesUserDataAT, feature.getId(), layer.getId() );

            let selectedFeature = selectedFeatures ? selectedFeatures.has( feature.getId() ) : false;
            this.configureSelectedStateSet( this._floorPMS, selectedFeature, mt );
            mt.addChild( markerNode );
            this._floorGroupPMS.addChild( mt );

            // Drawing label
            let labelPos = featureIterator.get().getGeometry().getXYZM();

            this.drawLabel( feature, labelPos, layer.getCenter(), selectedFeatures );
        }
    }

    avoidAutoscaleFeature( feature ) {
        this.setDisableRuleConfig( true );
        this._floorPMS.setDisableRuleConfig( true );

        this.evaluateRules( feature );

        this.setDisableRuleConfig( false );
        this._floorPMS.setDisableRuleConfig( false );
    }

    getMarkerPosition( feature, layer ) {
        return pcvizGISRenderer_PointSymbol3D__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.getMarkerPosition( feature, layer );
    }

    getMarkerVerticesUserData( i ) {
        return [ i, i ];
    }

    create2DMarker( layer, feature, selectedFeatures, symbol, name, center ) {
        let position = this.getMarkerPosition( feature, layer );

        let model2DMarker = symbol.renderMarker( position, feature.getId(), selectedFeatures, center, undefined, undefined, undefined );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'ModelLibrary' ).addModel( name, model2DMarker ); // TO REVIEW

        return model2DMarker;
    }

    updateColor() { // only called for stations
        this.configureSelectedStateSet( this._floorPMS, this._isSelected, this._floorGroupPMS );
    }

    configureSelectedStateSet( symbol, selectedFeature, markerNode ) {
        let color = osg.vec4.create();
        if ( selectedFeature )
            osg.vec4.copy( color, this.getSelectionColor() );
        else {
            osg.vec4.copy( color, symbol._color );
            color[ 3 ] = this._alpha;
        }

        let stateSet = markerNode.getOrCreateStateSet();
        let colorUniform = stateSet.getUniform( 'color' );
        if ( colorUniform === undefined ) {
            colorUniform = osg.Uniform.createFloat4( color, 'color' );
        } else {
            colorUniform.setVec4( color );
        }
        markerNode.getOrCreateStateSet().addUniform( colorUniform );
    }

    createQuad( markerSize ) {
        let quad = osg.createTexturedQuadGeometry( -markerSize / 2.0, -markerSize / 2.0, 0, markerSize, 0, 0, 0, markerSize, 0 );
        return quad;
    }

    getLabelText( layer ) {
        return layer.getName();
    }

    renderLabel( feature, selectedFeatures, position, center, verticalOffset, label ) {
        let value = label ? label : feature.getAttributeByName( this._labelField );

        let localPos = new osg.vec3.create64();
        osg.vec3.sub( localPos, position, center );
        let text;
        if ( value )
            text = new pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_5___default.a( value.toString() );
        else
            text = new pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_5___default.a( '' );
        text.setPosition( localPos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( 5 );
        text.setVerticalLabelOffset( 3 );
        let depth = new osg.Depth( osg.Depth.ALWAYS );
        text.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

        let outlineColor = osg.vec4.fromValues32( 60, 60, 60, 0.8 * this._color[ 3 ] );
        // use white outline for dark colors
        if ( 0.2126 * this._color[ 0 ] + 0.7152 * this._color[ 1 ] + 0.0722 * this._color[ 2 ] < 0.5 )
            outlineColor = osg.vec4.fromValues32( 255, 255, 255, 0.8 * this._color[ 3 ] );

        text.setColor( this._color );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( outlineColor );
        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    }

    setName( name ) {
        this._name = name;
    }

    getName() {
        return this._name;
    }

    setSelected( selected ) {
        this._isSelected = selected;
    }

}


/***/ }),

/***/ "./sources/pcvizGISRenderer/RasterRenderer.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGISRenderer/RasterRenderer.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var PlanarImage = __webpack_require__( /*! pcvizNode/PlanarImage */ "./sources/pcvizNode/PlanarImage.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var CollageWebFileBrowser = __webpack_require__( /*! pcvizDataAccess/CollageWebFileBrowser */ "./sources/pcvizDataAccess/CollageWebFileBrowser.js" );
var pcvizManipulator = __webpack_require__( /*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var Group = __webpack_require__( /*! pcvizNode/Group */ "./sources/pcvizNode/Group.js" ).default;
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var WorkspaceVisitor = __webpack_require__( /*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js" ).default;

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;

/**
 * A class to render the point cloud layers.
 * @class
 * @memberof pcvizGISRenderer
 */
var RasterRenderer = function () {

    this._rasterSceneGraph = new Map();
    this._cwFileBrowser = new CollageWebFileBrowser();
    this._cwFileBrowser.setMagnetAPI( MagnetAPI );

    this._userPreferencesCtrl = Registry.getController( 'UserPreferences' );
};

RasterRenderer.FIXED_HEIGHT = 50;

RasterRenderer.prototype = {

    createRasterSceneGraph: function ( layer, tilesPath, width, height, x, y ) {
        var far = this._userPreferencesCtrl.getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY );
        var fovX = 2.0 * Math.atan( ( 0.5 * width ) / far );
        var fovY = 2.0 * Math.atan( ( 0.5 * height ) / far );

        // create planarimage node and set url
        var node = new PlanarImage();

        node.setFieldOfViewValues( fovX, fovY );

        node.setImageURL( tilesPath, layer );
        node.enableMultiResolution( true );

        node.setDepth( false, false ); // optional

        if ( x !== undefined ) {
            var position = [ x + width / 2, y + height / 2, layer._center[ 2 ] ];
            node.setPosition( position ); // sets the image in its location
            node.computeRotationTranslation();
        }

        var self = this;
        layer.setVisibilityCallback( '3D', function ( value, options ) {
            node.setNodeMask( value ? layer._visibleMask : 0x0 ); // We use the visibleMask because it can be picked (planar images are non-pickable by default)
            var sceneView = Registry.getInstance().getController( 'View' ).getView( '3D' );
            if ( !options || !options[ 'ccFlag' ] )
                return;
            if ( value ) {
                node._dirty = true;
                far = self._userPreferencesCtrl.getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY );
                fovX = 2.0 * Math.atan( ( 0.5 * width ) / far );
                fovY = 2.0 * Math.atan( ( 0.5 * height ) / far );


                node._lastTextureUrl = undefined;

                node.setFieldOfViewValues( fovX, fovY );

                node.setImageURL( tilesPath, layer );
                node.enableMultiResolution( true ); // enable again the multiresolution because the setImageURL method disables it

                node.setDepth( true, false );

                var config = {
                    position: [ 0, 0, 10 ],
                    forward: [ 0, 0, -1 ],
                    up: [ 0, 1, 0 ],
                    fovy: fovY
                };
                sceneView.setManipulatorMode( pcvizManipulator.PLANAR_IMAGE_MANIPULATOR, config );

                var frustum = {};
                var factor = 15;
                frustum.left = -fovX * factor;
                frustum.right = fovX * factor;
                frustum.bottom = -fovY * factor;
                frustum.top = fovY * factor;

                sceneView._viewer.getOrCreatePlanarImageManipulator().setOrthoFrustum( frustum );

                sceneView._viewer.getOrCreatePlanarImageManipulator().setEnableOrtho( true );
                sceneView._viewer.getOrCreatePlanarImageManipulator().updateOrthoFrustum();
            } else {
                osgDB.Registry.instance().getReaderWriterForExtension( 'planarimage' )._lowResGeometry = undefined;
                sceneView._viewer.getOrCreatePlanarImageManipulator().setEnableOrtho( false );
                sceneView.setManipulatorMode( pcvizManipulator.CAD_MANIPULATOR, {} );

                // If there's a planar image selected
                var selObj = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
                var selectedLayer = selObj ? selObj.getLayer() : undefined;
                if ( selectedLayer && selectedLayer.getCategory && VectorLayerUtils.isPlanarImage( selectedLayer.getCategory() ) && selObj.getFeature() ) {
                    // send an event that is going to be listened by PlanarImageSymbol3d
                    var event = new Event( 'cleanPlanarImage' );
                    document.dispatchEvent( event );
                }
            }

        } );

        return node;
    },

    /**
     *
     * @method
     * @memberof pcvizGISRenderer.PointCloudRenderer
     * @param {pcvizGIS.PointCloudLayer} layer the layer to be rendered
     */
    renderLayer: function ( layer ) {
        if ( !layer.getSource() ) {
            this._rasterSceneGraph.delete( layer );
            return P.resolve();
        }

        if ( layer.getSourceType() !== Utils.RASTER_CW ) {
            return P.resolve();
        }

        var defer = P.defer();
        var self = this;

        // IF source type is CWXYZ, then we should get the tiles from the layer's storage. layer.getSource() should be /tiles/ in most of the cases.
        var tilesPath = layer.getDriver().getServerUrl() + layer.getDriver().getEntryPoint( 'layersFiles', layer.getId() ) + '/files/' + layer.getSource();
        tilesPath = Utils.sanitizeUrlInPlace( tilesPath );
        var basemapUrl = Utils.sanitizeUrlInPlace( tilesPath + '/basemap.xml' );
        this._cwFileBrowser.retrieve( { 'href': basemapUrl } ).then( function ( basemapXML ) {
            var parser = new DOMParser();
            var xmlDoc = parser.parseFromString( basemapXML, 'text/xml' );

            var keywordList = xmlDoc.getElementsByTagName( 'KeyWordList' )[ 0 ];
            // getting BoundingBox
            var bounding = xmlDoc.getElementsByTagName( 'BoundingBox' )[ 0 ];
            var width = bounding.getAttribute( 'maxx' ) - bounding.getAttribute( 'minx' );
            var height = bounding.getAttribute( 'maxy' ) - bounding.getAttribute( 'miny' );
            if ( keywordList && keywordList.childNodes.length && keywordList.childNodes[ 0 ].data === 'BoundingBoxInPixels' ) { //detect non georeferenced PDF
                width = width * RasterRenderer.FIXED_HEIGHT / height;
                height = RasterRenderer.FIXED_HEIGHT;
            }
            var position = xmlDoc.getElementsByTagName( 'Origin' )[ 0 ];
            var x = parseFloat( position.getAttribute( 'x' ) );
            var y = parseFloat( position.getAttribute( 'y' ) );

            var rasterNode = self.createRasterSceneGraph( layer, layer.getSource().slice( 1, -1 ), width, height, x, y );
            rasterNode.Layer = layer;
            rasterNode.Id = layer.getId();

            var group = new Group();

            group.addChild( rasterNode );
            self._rasterSceneGraph.set( layer, group );

            // Adding layer object and osg object to the cache 
            // Only for scan projects
            let ws = Registry.getInstance().getController( 'Workspace' );
            if ( ws.getWorkspace() !== undefined ) {
                let wsVisitor = new WorkspaceVisitor();
                wsVisitor.apply( ws.getWorkspace().workspace );
                let element = wsVisitor.getElementByCatalogId( layer.getId() );
                if ( element ) {
                    let elementObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( element.uuid );
                    if ( elementObj !== undefined ) {
                        elementObj.setOsgNodeObj( rasterNode );
                        elementObj.setLayerGroupObj( layer );
                    }
                    group.setName( element.name + ' group' );
                    if ( element.transformMatrix && !CRSUtils.isEcefPoint( element.transformMatrix[ 3 ], element.transformMatrix[ 7 ], element.transformMatrix[ 11 ] ) ) {
                        osg.mat4.transpose( group.getMatrix(), element.transformMatrix );
                        group.setMatrix( group.getMatrix() );
                    }
                }
            }

            defer.resolve();
        }, ( error ) => {
            defer.reject( error );
        } );
        return defer.promise;
    },

    getSceneGraph: function ( layer ) {
        return this._rasterSceneGraph.get( layer );
    }

};

module.exports = RasterRenderer;


/***/ }),

/***/ "./sources/pcvizGISRenderer/SingleSymbolRenderer.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizGISRenderer/SingleSymbolRenderer.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizGIS_FeatureRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/FeatureRenderer */ "./sources/pcvizGIS/FeatureRenderer.js");



var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 * Feature renderer to draw single symbols for each feature
 * @class
 * @memberof pcvizGISRenderer
 * @extends FeatureRenderer
 */
var SingleSymbolRenderer = function () {};

SingleSymbolRenderer.prototype = Utils.objectInherit( pcvizGIS_FeatureRenderer__WEBPACK_IMPORTED_MODULE_0__["default"].prototype, {

    renderLayer: function ( layer ) {
        var defer = P.defer();
        if ( !this._symbol ) {
            return defer.reject( 'Symbol not defined' );
        }
        this._symbol.renderLayer( layer ).then( function () {
            defer.resolve();
        } );
        return defer.promise;
    },

    getSceneGraph: function () {
        return this._symbol.getSceneGraph();
    },

    getSymbolGraph: function () {
        return this._symbol.getSymbolGraph();
    },
} );

/* harmony default export */ __webpack_exports__["default"] = (SingleSymbolRenderer);


/***/ }),

/***/ "./sources/pcvizGISRenderer/StationSymbol3D.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizGISRenderer/StationSymbol3D.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StationSymbol3D; });
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/PositionMarkerSymbol3D */ "./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGISRenderer/LineSymbol3D */ "./sources/pcvizGISRenderer/LineSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_6__);








const osg = OSG__WEBPACK_IMPORTED_MODULE_6___default.a.osg;

class StationSymbol3D extends pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor() {
        super();

        // Station symbol
        this._stationPMS = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["MarkerSymbol3D"]();
        this._stationPMS._renderBin = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.RENDERBIN_STATION_MARKERSYMBOL;
        this._stationPMS.createQuad = this.createQuad;
        this._stationGroupPMS = new osg.Node();
        this._stationGroupPMS.setName( 'station marker' );

        this._floorPMS._renderBin = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.RENDERBIN_STATION_MARKERSYMBOL;

        // line symbol to draw line between station and his target
        this._line3D = new pcvizGISRenderer_LineSymbol3D__WEBPACK_IMPORTED_MODULE_2___default.a();
        this._showDecorator = true;
        this._decoratorNode = undefined;
        this._stationPos = undefined;
        this._instrumentHeight = 0.0;
        this._targetDecoratorPositions = undefined;
        this._floorDecoratorPositions = undefined;

        this._nameBase = 'station';
        this.updateNames();
    }

    configure( style ) {
        super.configure( style );
    }

    configureSymbolizers( style ) {
        super.configureSymbolizers( style );
        if ( style && style.PointSymbolizer ) {
            this._line3D.configure( style.PointSymbolizer.targetDecorator );
            if ( style.PointSymbolizer.showDecorator !== undefined ) {
                this._showDecorator = style.PointSymbolizer.showDecorator;
            }
            if ( style.PointSymbolizer.stationSymbolizer ) {
                let stationStyle = style.PointSymbolizer.stationSymbolizer;
                this._stationPMS.configure( stationStyle );
                if ( stationStyle.PointSymbolizer.surveyMarker ) {
                    this._stationPMS.getExtraImageUrl().set( 'survey', stationStyle.PointSymbolizer.surveyMarker );
                    this._stationPMS.getExtraTextures().set( 'survey', new osg.Texture() ); //survey
                }
                if ( stationStyle.PointSymbolizer.currentMarker ) {
                    this._stationPMS.getExtraImageUrl().set( 'current', stationStyle.PointSymbolizer.currentMarker );
                    this._stationPMS.getExtraTextures().set( 'current', new osg.Texture() ); //current station
                }
                if ( stationStyle.PointSymbolizer.surveyedCurrentMarker ) {
                    this._stationPMS.getExtraImageUrl().set( 'survey-current', stationStyle.PointSymbolizer.surveyedCurrentMarker );
                    this._stationPMS.getExtraTextures().set( 'survey-current', new osg.Texture() ); //surveyed current station
                }
                if ( stationStyle.PointSymbolizer.minScale ) {
                    this._minScaleFloor = stationStyle.PointSymbolizer.minScale;
                }
            }
        }
    }

    initSceneGraph( layer ) {
        super.initSceneGraph( layer );
        this._sceneGraph.addChild( this._stationGroupPMS );
        this._line3D.initSceneGraph( layer );
        if ( this._decoratorNode === undefined ) {
            this._decoratorNode = new osg.Node();
            this._decoratorNode.setName( 'decorator line' );
            this.getSceneGraph().addChild( this._decoratorNode );
        }
    }

    enableFloorMarkerIntersections( value ) {
        this._floorGroupPMS.setNodeMask( value ? pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.TRAVERSAL_MASK_IV : ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.TRAVERSAL_MASK_IV );
    }

    cleanSymbol() {
        super.cleanSymbol();
        this._stationPMS.cleanSymbol();
        this._line3D.cleanSymbol();
        this._decoratorNode.removeChildren();
    }

    renderPage( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        if ( page === 1 ) {
            this._stationGroupPMS.removeChildren();
            this._floorGroupPMS.removeChildren();
            this._decoratorNode.removeChildren();
        }

        while ( featureIterator.next() ) {

            let feature = featureIterator.get();
            if ( this._rules ) { // avoid applying autoscale from rules
                this.avoidAutoscaleFeature( feature );
            }

            let selectedFeature = selectedFeatures ? selectedFeatures.has( feature.getId() ) : false;

            // generating station marker
            let stationNode = this.create2DMarker( layer, feature, selectedFeatures, this._stationPMS, this._marker2DName, center );
            this._stationGroupPMS.addChild( stationNode );
            this._sceneGraph.addChild( this._stationGroupPMS );
            this.configureSelectedStateSet( this._stationPMS, selectedFeature, this._stationGroupPMS );

            this._instrumentHeight = layer.getWorkspaceObjectProperties().instrumentHeight;
            let transInsHeight = [ 0.0, 0.0, -this._instrumentHeight ];

            if ( this._instrumentHeight > 0.0 ) {
                // translate center instrument height for floor
                let mt = new osg.MatrixTransform();
                mt.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transInsHeight ) );

                //generating floor marker
                let floorNode = this.create2DMarker( layer, feature, selectedFeatures, this._floorPMS, this._floorMarker2DName, center );
                if ( this._minScaleFloor !== undefined ) {
                    floorNode.setMinimumScale( this._minScaleFloor );
                }
                mt.addChild( floorNode );
                this._floorGroupPMS.addChild( mt );
                this.configureSelectedStateSet( this._floorPMS, selectedFeature, this._floorGroupPMS );
            }


            this.drawLabel( feature, transInsHeight, layer.getCenter(), selectedFeatures );
        }

        if ( this._showDecorator )
            this.calculatePositionsAndDrawDecorator( layer );
    }

    updateColor() {
        super.updateColor();
        this.configureSelectedStateSet( this._stationPMS, this._isSelected, this._stationGroupPMS );
        this._decoratorNode.removeChildren();
        if ( this._showDecorator ) {
            this._decoratorNode.removeChildren();
            if ( this._targetDecoratorPositions !== undefined ) {
                this.drawDecorator( this._targetDecoratorPositions );
            }
            if ( this._floorDecoratorPositions !== undefined && this._instrumentHeight > 0.0 ) {
                this.drawDecorator( this._floorDecoratorPositions );
            }
        }
    }

    create2DMarker( layer, feature, selectedFeatures, symbol, name, center ) {
        // Create station marker
        let model2DMarker = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'ModelLibrary' ).getModel( name );
        let position = this.getMarkerPosition( feature, layer );
        if ( !this._invalidateFeatures && model2DMarker !== undefined ) // reuse model unless we need to recreate it (this is not working because invalidateFeatures is always true)
            return model2DMarker;

        let useSurveyMarker = layer.getWorkspaceObject && layer.getWorkspaceObject().surveyRegistrationInfo && ( layer.getWorkspaceObject().surveyRegistrationInfo.method === 'OCCBS' || layer.getWorkspaceObject().surveyRegistrationInfo.method === 'RESECTION' ) && symbol.getExtraTextures().has( 'survey' );
        let useCurrentMarker = layer === pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'ScanSelection' ).getCurrentStationLayer() && symbol.getExtraTextures().size;
        let customState = useCurrentMarker ? ( useSurveyMarker ? 'survey-current' : 'current' ) : ( useSurveyMarker ? 'survey' : undefined );
        model2DMarker = symbol.renderMarker( position, layer.getId(), selectedFeatures, center, undefined, undefined, customState );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'ModelLibrary' ).addModel( name, model2DMarker );

        return model2DMarker;
    }

    renderLabel( feature, selectedFeatures, position, center ) {
        const label = this.getLabelText( feature.getLayer() );
        return super.renderLabel( feature, undefined, position, center, undefined, label );
    }

    drawDecorator( positions ) {

        if ( this._decoratorNode.getParents().length === 0 ) // decorator has been disconnected
            this.getSceneGraph().addChild( this._decoratorNode );

        let color = this._line3D._color;
        if ( this._isSelected ) {
            color = this.getSelectionColor();
        }

        let geometries = this._line3D._sketchTool.drawScreenLines( positions, false, color, this._line3D._lineWidth );
        if ( geometries.segments !== undefined )
            this._decoratorNode.addChild( geometries.segments );
        if ( geometries.marker !== undefined )
            this._decoratorNode.addChild( geometries.marker );
    }

    calculatePositionsAndDrawDecorator( layer ) {
        this._stationPos = osg.vec3.fromValues( 0.0001, 0.0001, 0.0001 ); // We put 0.0000001 because it seems that the shader avoid 0,0,0 value

        // Setting up floor point decorator positions
        let finalPos = osg.vec3.fromValues( 0.0001, 0.0001, -this._instrumentHeight );
        this._floorDecoratorPositions = [ this._stationPos, finalPos ];
        if ( this._instrumentHeight > 0.0 ) {
            this.drawDecorator( this._floorDecoratorPositions );
        }

        // Setting up target decorator positions
        let stationObj = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( layer.getId() );

        let targetLayer = stationObj.getLayerGroupObj().getTargetLayer();
        if ( targetLayer === undefined )
            return;

        let targetName = stationObj.getLayerGroupObj().getWorkspaceObjectProperties().backsight.backsightTarget;

        this.findTargetFeature( targetLayer, targetName, 1, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.PAGE_SIZE ).then( targetPos => {
            this._targetDecoratorPositions = [ this._stationPos, targetPos ];
            this.drawDecorator( this._targetDecoratorPositions );
        } );
    }

    findTargetFeature( layer, targetName, page, pageSize ) {
        let defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();
        layer.getFeatures( {
            'page': page,
            'page_size': pageSize
        } ).then( featureIterator => {
            let targetPos = osg.vec3.create64();
            while ( featureIterator.next() ) {
                let feature = featureIterator.get();
                if ( feature.getAttributeByName( 'name' ) === targetName ) {
                    let pos = featureIterator.get().getGeometry().getXYZM();
                    pos[ 3 ] = 1;
                    targetPos = osg.vec3.fromValues( pos[ 0 ], pos[ 1 ], pos[ 2 ] );
                    break;
                }
            }
            if ( featureIterator.getTotalNumFeatures() / pageSize > page ) {
                page++;
                this.findTargetFeature( layer, targetName, page, pageSize ).then( pos => { defer.resolve( pos ); } );
            } else {
                defer.resolve( targetPos );
            }

        } );
        return defer.promise;
    }
}


/***/ }),

/***/ "./sources/pcvizGISRenderer/Symbol3D.js":
/*!**********************************************!*\
  !*** ./sources/pcvizGISRenderer/Symbol3D.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Symbol = __webpack_require__( /*! pcvizGIS/Symbol */ "./sources/pcvizGIS/Symbol.js" ).Symbol;

const UtilsGIS = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const Geometry = __webpack_require__( /*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js" ).default;
const LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osg = OSG.osg;
const osgText = OSG.osgText;
const CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
const BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
const SideAttribute = __webpack_require__( /*! pcvizNode/SideAttribute */ "./sources/pcvizNode/SideAttribute.js" );
const Group = __webpack_require__( /*! pcvizNode/Group */ "./sources/pcvizNode/Group.js" ).default;

const MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const ShaderUtils = __webpack_require__( /*! pcvizUtils/ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js" ).default;

/**
 * GeometryData Auxiliar Class
 * @class
 * @memberof pcvizGISRenderer
 */
const GeometryData = function ( gisGeometry, numPoints ) {
    this.geometry = new osg.Geometry();
    this.vertices = new Float32Array( numPoints * 3 );
    this.colors = new Float32Array( numPoints * 4 );
    if ( gisGeometry._type === Geometry.MULTIPOINT )
        this.pointsizes = new Float32Array( numPoints );
    this.featureIds = [];
    this.verticesUserData = [];
};

const DEFAULT_EDITING_COLOR = osg.vec4.fromValues32( 147 / 255.0, 3 / 255.0, 167 / 255.0, 0.5 );

/**
 * Specifies a base class to render symbols in a 3D view.
 * @class
 * @memberof pcvizGISRenderer
 * @extends Symbol
 */
const Symbol3D = function () {
    Symbol.call( this );
    this._color = Utils.generateRandomRGBColor();
    this._savedColor = [ 0, 0, 0, 0 ];
    UtilsGIS.copyVec4( DEFAULT_EDITING_COLOR, this._editingColor );
    this._symbolNode = undefined; // root
    this._sceneGraph = undefined; // for geometry
    this._labelsNode = undefined; // for labels
    this._lineWidthUniform = undefined;
    this._invalidateFeatures = true;
    this._invalidateLabels = true;
    this._highlightFeature = false;
    this._stateSetDirty = false;
    this._depthDisabled = false;

    this._lastBufferActive = false;
    this._isSideAttributeActive = false;

    this._textureProgram = undefined; // for markers and labels
    this._colorUniform = osg.Uniform.createFloat4( this._color, 'color' ); // Color to mix with the texture of the marker Symbol.

    this._updateCB = {
        update: ( sSet ) => {
            this.updateStateSet( sSet );
        }
    };
};

const FindFeatureVisitor = function ( f ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._featureNode = undefined;
    this._feature = f;
};

FindFeatureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        var fid = this._feature.getId();
        var userData = node.getUserData();
        if ( userData !== undefined ) {
            for ( var i = 0; i < userData.featureIds.length; i++ ) {
                if ( fid === userData.featureIds[ i ] ) {
                    this._featureNode = node;
                    break;
                }
            }
        }
        this.traverse( node );
    },
    getFeatureNode: function () {
        return this._featureNode;
    }
} );

const FindGeometryVisitor = function () {
    osg.NodeVisitor.call( this );
};

FindGeometryVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        if ( node.getTypeID() === osg.Geometry.getTypeID() ) {
            var stateSet = node.getStateSet();
            if ( stateSet ) {

                var nodePath = Utils.computeNodePath( node );
                var modelMat = osg.computeLocalToWorld( nodePath, true );
                var modelMatrixUniform = osg.Uniform.createMat4( modelMat, 'uModelMatrix' );
                stateSet.addUniform( modelMatrixUniform );
            }
        }
        this.traverse( node );
    }
} );

Symbol3D.prototype = osg.objectInherit( Symbol.prototype, {

    configure: function ( /*style */) {
        console.log( 'Symbol3D.configure: Not implemented' );
    },

    initSceneGraph: function ( layer ) {
        if ( !this._symbolNode ) {
            this._sceneGraph = new osg.MatrixTransform();
            this._sceneGraph.setName( 'Symbol3D_scenegraph' );

            this._labelsNode = new osg.Node(); // Investigate if it is convenient to convert this into a MT
            this._labelsNode.setName( 'Symbol3D_labels' );
            this._labelsNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

            this._symbolNode = new Group();
            this._symbolNode.setName( 'Symbol3D_root' );

            this._symbolNode.addChild( this._sceneGraph );
            this._symbolNode.addChild( this._labelsNode );

            this._symbolNode.bufferAttribute = this.initBufferAttribute( layer );

            this._symbolNode.sideAttribute = this.createSideAttribute();

            layer._dirtyFeatures = true;
        }

        if ( layer.getDirtyFeatures !== undefined && layer.getDirtyLabels !== undefined ) {
            this._invalidateFeatures = layer.getDirtyFeatures();
            if ( this._invalidateFeatures )
                this._invalidateLabels = true;
            else
                this._invalidateLabels = layer.getDirtyLabels();
        }

        if ( this._invalidateFeatures ) {
            this._sceneGraph.releaseGLObjects();
            this._sceneGraph.removeChildren();
        }
        if ( this._invalidateLabels || this._highlightFeature ) {
            this._labelsNode.releaseGLObjects();
            this._labelsNode.removeChildren();
        }

        if ( this._depthDisabled ) {
            let stateSet = this._sceneGraph.getOrCreateStateSet();
            var depth = new osg.Depth( osg.Depth.ALWAYS );
            stateSet.setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );
        }
    },

    initBufferAttribute: function ( layer ) {
        var bufferAttribute = new BufferAttribute();
        bufferAttribute.setMinColor( osg.vec4.fromValues32( 1.0, 0.0, 0.0, 1.0 ) );
        bufferAttribute.setMaxColor( osg.vec4.fromValues32( 0.0, 0.0, 1.0, 1.0 ) );
        bufferAttribute.setDataCenter( layer.getCenter() );
        var rangeBufferTool = Math.pow( 1.1, ( 50.0 - 20.0 ) );
        bufferAttribute.setRange( rangeBufferTool );

        return bufferAttribute;
    },

    createSideAttribute: function () {
        const sideAttribute = new SideAttribute();
        return sideAttribute;
    },

    setFeatureInvalidation: function ( invalidateFeatures ) {
        this._invalidateFeatures = invalidateFeatures;
    },

    setHighlightFeature: function ( flag ) {
        this._highlightFeature = flag;
    },

    getHighlightFeature: function () {
        return this._highlightFeature;
    },

    getOrCreateFeatureGeometry: function ( gisGeometry, numPoints ) {
        var geometryData = new GeometryData( gisGeometry, numPoints );
        return geometryData;
    },

    getOrCreateLineWidthUniform: function () {
        if ( !this._lineWidthUniform ) {
            this._lineWidthUniform = osg.Uniform.createFloat1( 2.0, 'lineWidth' );
        }
        return this._lineWidthUniform;
    },

    renderFeature: function ( feature, layer, selectedFeatures, center, sceneGraph, childIndex, page, pageSize, childIndexCustom ) {

        // init variables
        var gisGeometry = this.getFeatureGeometry( feature );
        var numPoints = this.getNumPoints( gisGeometry );

        var selectionColor = this.getSelectionColor();
        if ( this._rules )
            this.evaluateRules( feature );

        var geometry;
        if ( this._invalidateFeatures ) {
            var geometryData = this.getOrCreateFeatureGeometry( gisGeometry, numPoints );
            // Iterate over each point of the geometry
            for ( var i = 0; i < numPoints; i++ ) {
                var pt = gisGeometry.getPoint ? gisGeometry.getPoint( i ) : gisGeometry;
                this.pushVertex( geometryData.vertices, layer, pt, i, center );
                this.pushColor( geometryData.colors, selectedFeatures, feature.getId(), i, selectionColor );
                if ( geometryData.pointsizes )
                    geometryData.pointsizes[ i ] = this._size;

                geometryData.featureIds.push( feature.getId() );
                this.updateVerticesUserData( geometryData.verticesUserData, i );
            }

            geometry = geometryData.geometry;
            geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, geometryData.vertices, 3 );
            geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, geometryData.colors, 4 );
            if ( geometryData.pointsizes )
                geometry.getAttributes().PointSize = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, geometryData.pointsizes, 1 );

            geometry.getPrimitives().push( this.createPrimitive( geometryData.vertices, geometryData.verticesUserData ) );

            this.setGeometryStateSet( geometry, selectedFeatures, feature.getId() );

            // set the userData for picking
            this.assignUserData( geometryData, layer.getId() );

            return {
                geometry: geometry,
                cNodes: 1
            };
        }

        // only invalidate symbology
        if ( !sceneGraph )
            sceneGraph = this._sceneGraph;

        if ( childIndexCustom === undefined )
            childIndexCustom = childIndex;
        geometry = sceneGraph.getChild( childIndexCustom );
        var colorVector = geometry.getAttributes().Color.getElements();

        var numColors = colorVector.length / 4;
        for ( var iColor = 0; iColor < numColors; iColor++ ) {
            this.pushColor( colorVector, selectedFeatures, feature.getId(), iColor, this.getSelectionColor() );
        }
        geometry.getAttributes().Color.dirty();

        if ( gisGeometry._type === Geometry.MULTIPOINT ) {
            var sizesVector = geometry.getAttributes().PointSize.getElements();
            for ( var iPt = 0; iPt < numColors; iPt++ ) {
                sizesVector[ iPt ] = this._size;
            }
            geometry.getAttributes().PointSize.dirty();
        }

        return {
            geometry: undefined,
            cNodes: 1
        }; // no need to add new node
    },

    pushVertex: function ( vertices, layer, point, i, center ) {
        var pointPos = point.getXYZM();
        var z = ( point.getCoordinateDimension() === 3 ) ? pointPos[ 2 ] : layer.getDefaultZ();

        var vIndex = i * 3;
        this.translateVertex( vertices, pointPos, center, vIndex, z );
    },

    translateVertex: function ( vertices, pointPos, center, vIndex, z ) {
        vertices[ vIndex ] = pointPos[ 0 ] - center[ 0 ];
        vertices[ vIndex + 1 ] = pointPos[ 1 ] - center[ 1 ];
        vertices[ vIndex + 2 ] = z - center[ 2 ];
    },

    pushColor: function ( colors, selectedFeatures, fId, i, selectionColor ) {
        var cIndex = i * 4;
        // in highlight mode, draw transparent non-selected features
        // if the layer uses clip boxes, draw all features with their original colors
        if ( this._highlightFeature ) {

            var highlightFeatureTool = Registry.getInstance().getController( 'View' ).getView( '3D' ).getTool( 'highlightFeature' );
            if ( selectedFeatures.has( fId ) || this._hasClipBox ||
                ( MagnetAPI.isSite() && highlightFeatureTool._featureSelected && highlightFeatureTool._featureSelected.getId() === fId ) ) { // HACK for CRE
                colors[ cIndex ] = this._color[ 0 ];
                colors[ cIndex + 1 ] = this._color[ 1 ];
                colors[ cIndex + 2 ] = this._color[ 2 ];
                var transparencyForNeighbors = this._color[ 3 ];
                if ( !selectedFeatures.has( fId ) && this._hasClipBox ) { // draw neighbors semitransparent
                    transparencyForNeighbors *= 0.25;
                    colors[ cIndex ] *= 0.5;
                    colors[ cIndex + 1 ] *= 0.5;
                    colors[ cIndex + 2 ] *= 0.5;
                }
                colors[ cIndex + 3 ] = transparencyForNeighbors;
            } else {
                colors[ cIndex ] = 0;
                colors[ cIndex + 1 ] = 0;
                colors[ cIndex + 2 ] = 0;
                colors[ cIndex + 3 ] = 0;
            }
            return;
        }

        if ( selectedFeatures.has( fId ) ) {
            colors[ cIndex ] = selectionColor[ 0 ];
            colors[ cIndex + 1 ] = selectionColor[ 1 ];
            colors[ cIndex + 2 ] = selectionColor[ 2 ];
            colors[ cIndex + 3 ] = selectionColor[ 3 ];
        } else {
            colors[ cIndex ] = this._color[ 0 ];
            colors[ cIndex + 1 ] = this._color[ 1 ];
            colors[ cIndex + 2 ] = this._color[ 2 ];
            colors[ cIndex + 3 ] = this._color[ 3 ];
        }
    },

    assignUserData: function ( geometryData, layerId ) {
        geometryData.geometry.setUserData( {
            vertices: geometryData.verticesUserData,
            featureIds: geometryData.featureIds,
            layerId: layerId
        } );
    },

    setRenderBin: function ( stateSet ) {
        stateSet.setRenderBinDetails( Utils.RENDERBIN_SYMBOL3D, Utils.RENDERBIN_SYMBOL3D_TYPE );
    },

    setStateSet: function () {
        // force initial change
        this._lastBufferActive = !this._symbolNode.bufferAttribute.isEnabled();
        this._lastBufferMode = -1;

        var stateSet = this._sceneGraph.getOrCreateStateSet();
        stateSet.setRenderingHint( 'TRANSPARENT_BIN' );
        this.setRenderBin( stateSet );
        stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );

        if ( this.setColorUniform )
            this.setColorUniform( stateSet );

        if ( this.updateStateSet ) {
            if ( !stateSet.hasUpdateCallback( this._updateCB ) )
                stateSet.addUpdateCallback( this._updateCB );

            this.updateStateSet( stateSet ); // initial update
        } else
            stateSet.setAttributeAndModes( this._generateProgram() );
    },

    updateStateSet: function ( stateSet, ignoreBufferState ) {

        var bufferUniforms = this._symbolNode.bufferAttribute.apply();
        var bufferActive = this._symbolNode.bufferAttribute.isEnabled();
        var bufferMode = this._symbolNode.bufferAttribute.getBufferMode();

        const sideAttribute = this._symbolNode.sideAttribute;
        const sideActive = sideAttribute ? sideAttribute.isEnabled() : false;

        const labelsStateSet = this._labelsNode.getOrCreateStateSet();

        if ( sideActive ) {
            const sideUniforms = sideAttribute.getOrCreateUniforms();
            stateSet.addUniform( sideUniforms.side );
            stateSet.addUniform( sideUniforms.sideDivider );

            // Adding screenWidth uniform for fragment coords transformation
            let screenWidth = Utils.getViewCanvasSize()[ 0 ];
            stateSet.addUniform( osg.Uniform.createFloat1( screenWidth, 'screenWidth' ) );

            labelsStateSet.addUniform( sideUniforms.side );
            labelsStateSet.addUniform( sideUniforms.sideDivider );
            labelsStateSet.addUniform( osg.Uniform.createFloat1( screenWidth, 'screenWidth' ) );
        }

        let hasSideActiveChanged = false;
        if ( sideActive !== this._isSideAttributeActive ) {
            this._isSideAttributeActive = sideActive;
            hasSideActiveChanged = true;
        }

        if ( !ignoreBufferState && !this.isStateSetDirty() ) {

            // optimize changes
            if ( bufferActive === this._lastBufferActive && bufferMode === this._lastBufferMode && !hasSideActiveChanged )
                return false;

            this._lastBufferActive = bufferActive;
            this._lastBufferMode = bufferMode;
        }

        // compose shaders
        stateSet.setAttributeAndModes( this._generateProgram() );
        this.configureColorUniform( stateSet );

        this._generateTextureProgram();
        labelsStateSet.setAttributeAndModes( this._textureProgram );

        var labelsColorUniform = osg.Uniform.createFloat4( [ 1, 1, 1, 1 ], 'color' );
        labelsStateSet.addUniform( labelsColorUniform );

        var findGeometryVisitor = new FindGeometryVisitor();
        this._sceneGraph.accept( findGeometryVisitor );

        if ( !bufferActive )
            return true;

        stateSet.addUniform( bufferUniforms.minColor );
        stateSet.addUniform( bufferUniforms.maxColor );
        stateSet.addUniform( bufferUniforms.useBaseColor );
        stateSet.addUniform( bufferUniforms.onlyBuffer );
        stateSet.addUniform( bufferUniforms.range );

        switch ( this._symbolNode.bufferAttribute.getBufferMode() ) {
        case BufferAttribute.POINT:
            stateSet.addUniform( bufferUniforms.pointBuffer );
            break;
        case BufferAttribute.LINE:
        case BufferAttribute.VERTICAL_LINE:
            stateSet.addUniform( bufferUniforms.lineBuffer );
            stateSet.addUniform( bufferUniforms.numBufferVertices );
            break;
        case BufferAttribute.BOX:
            stateSet.addUniform( bufferUniforms.pointBuffer );
            stateSet.addUniform( bufferUniforms.lineBuffer );
            stateSet.addUniform( bufferUniforms.auxMat );
            stateSet.addUniform( bufferUniforms.boxMin );
            stateSet.addUniform( bufferUniforms.boxMax );
            stateSet.addUniform( bufferUniforms.boxRotation );

        }
        return true;
    },

    setGeometryStateSet: function ( g, selectedFeatures, fId ) {
        if ( selectedFeatures.has( fId ) ) {
            g.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );
        }
    },

    getFeatureGeometry: function ( feature ) {
        return feature.getGeometry();
    },

    getNumPoints: function ( gisGeometry ) {
        if ( gisGeometry.getNumPoints )
            return gisGeometry.getNumPoints();

        return 1; // single point
    },

    updateVerticesUserData: function ( /*verticesUserData, i*/) {},

    createPrimitive: function ( /*vertices*/) {},

    renderLayer: function ( layer ) {
        var center = layer.getCenter();
        var selectedFeatures = layer.getSelectedFeatures();

        this.initSceneGraph( layer );

        let layerCenter;
        if ( layer.getType() === LayerType.GROUP || layer.getExtent().isValid() ) { // LayerGroups do not have extent and Station layer groups are rendered
            layerCenter = layer.computeCenter( true ); // only computes real center but doesn't set it
            this.setCenterTransform( center, layerCenter );
        }

        var defer = P.defer();
        var self = this;

        var page = 1;
        var pageSize = Utils.PAGE_SIZE;

        this.renderByPages( page, pageSize, layer, layerCenter ? layerCenter : center, selectedFeatures ).then( function () {

            self.setStateSet();

            defer.resolve();
        } );

        return defer.promise;
    },

    // This function renders all the pages of features.
    renderByPages: function ( page, pageSize, layer, center, selectedFeatures, childIndex ) {
        var defer = P.defer();
        var self = this;

        layer.getFeatures( {
            'page': page,
            'page_size': pageSize
        } ).then( function ( featureIterator ) {
            self.renderPage( featureIterator, page, pageSize, layer, center, selectedFeatures, childIndex );
            if ( featureIterator.getTotalNumFeatures() / pageSize > page ) {
                page++;
                self.renderByPages( page, pageSize, layer, center, selectedFeatures, childIndex ).then( function () {
                    defer.resolve();
                } );
            } else
                defer.resolve();
        } );

        return defer.promise;
    },

    renderPage: function ( featureIterator, page, pageSize, layer, center, selectedFeatures ) {

        if ( featureIterator.getSize() > 0 ) {
            var childIndex = 0;
            while ( featureIterator.next() ) {
                var feature = featureIterator.get();
                var result = this.renderFeature( feature, layer, selectedFeatures, center, undefined, childIndex, page, pageSize, childIndex + ( ( page - 1 ) * pageSize ) );
                var geometry = result.geometry;
                childIndex += result.cNodes;

                // add the geometry to the graph
                if ( this._invalidateFeatures )
                    this._sceneGraph.addChild( geometry );

                var position = this.getMarkerPosition( feature, layer );
                this.drawLabel( feature, position, layer.getCenter(), selectedFeatures );
            }
        }
    },

    getGeometryFeature: function ( feature, overrideNodeMask ) {
        var fv = new FindFeatureVisitor( feature );
        if ( overrideNodeMask ) {
            fv.setNodeMaskOverride( 1 ); // To avoid skip nodes with nodeMask 0
        }
        this._sceneGraph.accept( fv );
        return fv.getFeatureNode();
    },

    setGeometryFeatureVisibility: function ( feature, visible, onlyModel ) {
        let osgObj = this.getGeometryFeature( feature, true, onlyModel );
        if ( osgObj === undefined ) {
            console.warn( 'Check why the node is not rendered (sometimes happens with TIN that are not visible)' );
            return;
        }
        osgObj.setNodeMask( ( visible ) ? ~0x0 : 0x0 );
    },

    _setFeatureColor: function ( feature, color ) {
        var fv = new FindFeatureVisitor( feature );
        this._sceneGraph.accept( fv );
        var fNode = fv.getFeatureNode();
        if ( !fNode )
            return;

        this.configureDepthTest( color, fNode );

        var colorBuffer = fNode.getAttributes().Color;
        var colors = colorBuffer.getElements();
        this.saveColor( colors );
        for ( var c = 0; c < colors.length; c += 4 ) {
            colors[ c ] = color[ 0 ];
            colors[ c + 1 ] = color[ 1 ];
            colors[ c + 2 ] = color[ 2 ];
            colors[ c + 3 ] = color[ 3 ];
        }
        colorBuffer.dirty();
    },

    /**
     * Add the Depth attribute to the stateSet of the node passed if the color passed is the selection color or the editing color.
     * In other case, remove the attribute Depth from the stateSet.
     * @method
     * @memberof pcvizGISRenderer.Symbol3D
     * @param  {Array} color the color used to decide if the depth test has to be enabled or disabled
     * @param  {osg.Node} node  the node, which stateSet is going to be modified
     */
    configureDepthTest: function ( color, node ) {
        if ( color !== this.getSelectionColor() && color !== this._editingColor ) {
            node.getOrCreateStateSet().removeAttribute( 'Depth' );
        } else {
            node.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );
        }
    },

    selectFeature: function ( feature ) {
        this._setFeatureColor( feature, this.getSelectionColor() );
    },

    deselectFeature: function ( feature ) {
        this.restoreColor();
        this._setFeatureColor( feature, this._color );
    },

    saveColor: function ( colors ) {
        if ( colors.length >= 4 ) {
            this._savedColor[ 0 ] = colors[ 0 ];
            this._savedColor[ 1 ] = colors[ 1 ];
            this._savedColor[ 2 ] = colors[ 2 ];
            this._savedColor[ 3 ] = colors[ 3 ];
        }
    },

    restoreColor: function () {
        this._color[ 0 ] = this._savedColor[ 0 ];
        this._color[ 1 ] = this._savedColor[ 1 ];
        this._color[ 2 ] = this._savedColor[ 2 ];
        this._color[ 3 ] = this._savedColor[ 3 ];
    },

    editFeature: function ( feature ) {
        this._setFeatureColor( feature, this._editingColor );
    },

    getSymbolGraph: function () {
        return this._symbolNode;
    },

    getSceneGraph: function () {
        return this._sceneGraph;
    },

    getShaderInfo: function () {
        return {
            attributeNormal: false,
            attributeColor: true,
            uniformColor: false,
            varyingPos: true, // needed for buffers
            varyingColor: true
        };
    },

    // note that 3DTiles will overwrite this shader with another including texture mapping but not lighting
    _generateProgram: function () {

        var vertexShader = this._generateVertexShader();

        var bufferActive = this._symbolNode.bufferAttribute.isEnabled();

        // compose fragment shader

        var fragmentShader = [
            '',
            '#ifdef GL_ES',
            'precision highp float;',
            '#extension GL_OES_standard_derivatives : enable',
            '#endif'
        ];
        // buffer uniforms
        if ( bufferActive )
            fragmentShader = fragmentShader.concat( [
                'uniform float bufferMode;',
                'uniform float useBaseColor;',
                'uniform float range;',
                'uniform vec4 minColor;',
                'uniform vec4 maxColor;',
                'uniform float onlyBuffer;',
                'uniform vec3 pointBuffer;',
                'uniform vec3 lineBuffer[50];',
                'uniform mat4 auxMat;',
                'uniform vec3 boxMin;',
                'uniform vec3 boxMax;',
                'uniform float boxRotation;',
                'uniform int numBufferVertices;'
            ] );

        if ( this._isSideAttributeActive ) {
            fragmentShader = fragmentShader.concat( [
                'uniform float sideDivider;',
                'uniform int side;',
                'uniform float screenWidth;'
            ] );
        }

        // no-buffer code
        var shaderInfo = this.getShaderInfo();

        if ( shaderInfo.modulateTexture )
            fragmentShader = fragmentShader.concat( [
                'uniform float useTexture0;',
                'varying vec2 vTexCoord0;',
                'uniform sampler2D Texture0;',
            ] );

        if ( shaderInfo.varyingColor )
            fragmentShader = fragmentShader.concat( [
                'varying vec4 litColor;'
            ] );

        if ( shaderInfo.varyingPos )
            fragmentShader = fragmentShader.concat( [
                'varying vec3 worldPos;'
            ] );

        if ( shaderInfo.flatShading )
            fragmentShader = fragmentShader.concat( [
                'varying vec3 vertex_view_space;'
            ] );

        if ( shaderInfo.elevationUniforms )
            fragmentShader = fragmentShader.concat( [
                //      'uniform float minZ;',
                //      'uniform float maxZ;',
                'uniform float centerZ;',
                'uniform float tolerance;',
                'varying vec4 normal;',
                'varying float isCut;'
            ] );

        if ( shaderInfo.hsv2rgb )
            fragmentShader = fragmentShader.concat( [
                'vec3 hsv2rgb(vec3 c)',
                '{',
                '  vec4 K = vec4(1.0, 2.0 / 3.0, 1.0/ 3.0, 3.0);',
                '  vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);',
                '  return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0 ,1.0), c.y);',
                '}'

            ] );

        // main
        fragmentShader = fragmentShader.concat( [
            'void main (void)',
            '{'
        ] );

        if ( shaderInfo.flatShading ) {

            fragmentShader = fragmentShader.concat( [
                '  vec4 blendColor = litColor;',
            ] );

            if ( shaderInfo.modulateMaterial )
                fragmentShader = fragmentShader.concat( [
                    '  float ambientFactor = 0.5;',
                    '  float diffuseFactor = 1.0;'
                ] );
            else
                fragmentShader = fragmentShader.concat( [
                    '  float ambientFactor = 0.3;',
                    '  float diffuseFactor = 0.8;'
                ] );

            // In Collage Office is used glShadeModel that is not supported on webGl. This the way to flat shading using on shaders.
            fragmentShader = fragmentShader.concat( [
                '  vec3 U = dFdx(vertex_view_space);',
                '  vec3 V = dFdy(vertex_view_space);',
                '  vec3 N = normalize(cross(U,V));',
                '  float lightFactor = 0.5 * abs(N.x  * 0.0    + N.y * 0.8660 + N.z * 0.5);',
                '  lightFactor += 0.5 * abs(N.x  * 0.7071 + N.y *  0.0    + N.z * 0.7071);',
                '  lightFactor = ambientFactor + diffuseFactor * lightFactor; // add ambient component ',
                '  vec4 resColor = vec4(lightFactor * blendColor.r, lightFactor * blendColor.g, lightFactor * blendColor.b, blendColor.a);'
            ] );
        } else {
            fragmentShader = fragmentShader.concat( [
                '  vec4 resColor = litColor;',
            ] );
        }

        if ( shaderInfo.pointCircle )
            fragmentShader = fragmentShader.concat( [
                '  vec2 coord =  -1.0 + 2.0 * gl_PointCoord.xy;',
                '  float d2  = dot(coord, coord);',
                '  if( d2 > 1.0)', //outside of circle
                '    discard;',
            ] );

        fragmentShader = fragmentShader.concat( [
            // invisible objects
            '  if (resColor.a == 0.0)',
            '    discard;',
            '  vec4 finalColor = resColor;'
        ] );

        if ( shaderInfo.modulateTexture )
            fragmentShader = fragmentShader.concat( [
                '  if (useTexture0 == 1.0) {',
                '    vec4 textColor = texture2D(Texture0,vTexCoord0);',
                '    textColor.rgb = textColor.rgb * resColor.rgb;',
                '    finalColor = vec4(textColor.rgb, resColor.a);',
                '  }'
            ] );


        if ( shaderInfo.elevationUniforms )
            fragmentShader = fragmentShader.concat( this._generateElevationFragmentShader() );

        if ( bufferActive )
            fragmentShader = fragmentShader.concat( this._generateBufferFragmentShader() );

        if ( this._isSideAttributeActive ) {
            fragmentShader = fragmentShader.concat( ShaderUtils.generateSidesFragmentShader() );
        }

        fragmentShader = fragmentShader.concat( [
            '  gl_FragColor = finalColor;',
            '}'
        ] );

        fragmentShader = fragmentShader.join( '\n' );

        var program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );

        return program;
    },

    _generateVertexShader: function () {
        var shaderInfo = this.getShaderInfo();

        var vertexShader = [
            '#version 100',
            '#ifdef GL_FRAGMENT_PRECISION_HIGH',
            'precision highp float;',
            '#else',
            'precision mediump float;',
            '#endif',
            'attribute vec4 Vertex;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;'
        ];

        if ( shaderInfo.modulateTexture )
            vertexShader = vertexShader.concat( [
                'uniform float useTexture0;',
                'attribute vec2 TexCoord0;',
                'varying vec2 vTexCoord0;'
            ] );

        if ( shaderInfo.modulateMaterial )
            vertexShader = vertexShader.concat( [
                'uniform vec4 uMaterialDiffuse;'
            ] );

        if ( shaderInfo.attributeNormal )
            vertexShader = vertexShader.concat( [
                'attribute vec4 Normal;'
            ] );

        if ( shaderInfo.attributeColor )
            vertexShader = vertexShader.concat( [
                'attribute vec4 Color;'
            ] );
        if ( shaderInfo.uniformColor ) // I've removed the else because for the VolumeSymbol we are using both (We could try to avoid using the uniform)
            vertexShader = vertexShader.concat( [
                'uniform vec4 color;'
            ] );
        if ( shaderInfo.uniformUseModelColor )
            vertexShader = vertexShader.concat( [
                'uniform float useModelColor;'
            ] );
        if ( shaderInfo.attributePointSize )
            vertexShader = vertexShader.concat( [
                'attribute float PointSize;'
            ] );

        if ( shaderInfo.varyingColor )
            vertexShader = vertexShader.concat( [
                'varying vec4 litColor;'
            ] );

        if ( shaderInfo.varyingPos )
            vertexShader = vertexShader.concat( [
                'varying vec3 worldPos;',
                'uniform mat4 uModelMatrix;'
            ] );
        if ( shaderInfo.elevationUniforms )
            vertexShader = vertexShader.concat( [
                'varying vec4 normal;', // support elevation in fragmentShader. The first component value is the min Z and the second component is the max Z
                'varying float isCut;' // support elevation in fragmentShader. The value will be 1.0 or 0.0
            ] );

        if ( shaderInfo.flatShading )
            vertexShader = vertexShader.concat( [
                '  varying vec3 vertex_view_space;'
            ] );

        if ( shaderInfo.screenLine )
            vertexShader = vertexShader.concat( this.getSLineVShaderHeader() );

        // main
        vertexShader = vertexShader.concat( [
            'void main(void) {',
        ] );

        if ( shaderInfo.modulateTexture ) {
            vertexShader = vertexShader.concat( [
                '  if (useTexture0 == 1.0)',
                '    vTexCoord0 = TexCoord0;'
            ] );
        }

        if ( shaderInfo.attributePointSize )
            vertexShader = vertexShader.concat( [
                '  gl_PointSize = PointSize;'
            ] );


        if ( shaderInfo.varyingPos )
            vertexShader = vertexShader.concat( [
                '  worldPos = (uModelMatrix * vec4(Vertex.xyz, 1.0)).xyz;'
            ] );

        if ( shaderInfo.varyingColor )
            vertexShader = vertexShader.concat( this._generateVaryingColor() );

        if ( shaderInfo.flatShading )
            vertexShader = vertexShader.concat( [
                '  vertex_view_space = (uModelViewMatrix * Vertex).xyz;'
            ] );

        if ( shaderInfo.screenLine )
            vertexShader = vertexShader.concat( this.getSLineVShaderBody() );
        else
            vertexShader = vertexShader.concat( [
                '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex.xyz, 1.0);'
            ] );

        vertexShader = vertexShader.concat( [
            '}'
        ] );

        vertexShader = vertexShader.join( '\n' );

        return vertexShader;
    },

    _generateBufferFragmentShader: function ( forTexture ) {

        var bufferModeShader = [
            'if (onlyBuffer > 0.0)',
            '    finalColor.a = 0.0;'
        ];

        var shader;
        switch ( this._symbolNode.bufferAttribute.getBufferMode() ) {
        case BufferAttribute.POINT:
            shader = this._generatePointBufferShader( forTexture );
            break;
        case BufferAttribute.LINE:
            shader = this._generateLineBufferShader( forTexture );
            break;
        case BufferAttribute.VERTICAL_LINE:
            shader = this._generateVLineBufferShader( forTexture );
            break;
        case BufferAttribute.BOX:
            shader = this._generateBoxBufferShader();
        }

        bufferModeShader = bufferModeShader.concat( shader );

        // discard points made invisible by buffer
        bufferModeShader = bufferModeShader.concat( [
            'if (finalColor.a == 0.0)',
            '   discard;'
        ] );
        return bufferModeShader;
    },

    _generatePointBufferShader: function ( forTexture ) {
        var pointShader = [
            'float dmin; ',
            'dmin = distance( worldPos, pointBuffer ); '
        ];

        pointShader = pointShader.concat( this._generateDistanceColor( forTexture ) );

        return pointShader;
    },

    _generateLineBufferShader: function ( forTexture ) {
        var lineShader = [
            'const int numVertices = 50;',
            'float dmin=1000.0;',
            'int nv = numBufferVertices -1;',
            'for ( int i = 0; i < numVertices - 1; i++ )',
            '{',
            '   if ( i < nv ){',
            '        vec3 x12 = lineBuffer[i+1] - lineBuffer[i];',
            '        vec3 x01 =  worldPos - lineBuffer[i];',
            '        float t = clamp( dot(x01, x12)/dot(x12, x12), 0.0, 1.0 );',
            '        float d = distance( lineBuffer[i] + (t*x12), worldPos );',
            '        if ( d < dmin )',
            '          dmin = d;',
            '    }',
            '}'
        ];
        lineShader = lineShader.concat( this._generateDistanceColor( forTexture ) );
        return lineShader;
    },

    _generateVLineBufferShader: function ( forTexture ) {
        var lineShader = [
            'const int numVertices = 50;',
            'float dmin=1000.0;',
            'int nv = numBufferVertices -1;',
            'for ( int i = 0; i < numVertices - 1; i++ )',
            '{',
            '   if ( i < nv ){',
            '        vec2 x12 = lineBuffer[i+1].xy - lineBuffer[i].xy;',
            '        vec2 x01 = worldPos.xy - lineBuffer[i].xy;',
            '        float t = clamp( dot(x01, x12)/dot(x12, x12), 0.0, 1.0 );',
            '        float d = distance( lineBuffer[i].xy + (t*x12), worldPos.xy);',
            '        if ( d < dmin )',
            '          dmin = d;',
            '    }',
            '}'
        ];
        lineShader = lineShader.concat( this._generateDistanceColor( forTexture ) );
        return lineShader;
    },

    _generateDistanceColor: function ( forTexture ) {
        var distColorShader = [
            'dmin /= range;',
            'if ( dmin < 1.0 )',
            '{',
            '   if ( useBaseColor > 0.0) {'
        ];

        if ( !forTexture )
            distColorShader = distColorShader.concat(
                '       finalColor.a = litColor.a;'
            );
        distColorShader = distColorShader.concat(
            '   } else {',
            '       finalColor = mix( minColor, maxColor, vec4(dmin,dmin,dmin,1.0) );',
            '   }',
            '} ' );

        return distColorShader;
    },

    _generateBoxBufferShader: function () {
        var boxShader = [
            'vec3 v = worldPos + pointBuffer;',

            'float x1 = v[0],',
            'y1 = v[1],',
            'z1 = v[2];',

            'float w = auxMat[0][3] * x1 + auxMat[1][3] * y1 + auxMat[2][3] * z1 + auxMat[3][3];',
            'v[0] = (auxMat[0][0] * x1 + auxMat[1][0] * y1 + auxMat[2][0] * z1 + auxMat[3][0])/w;',
            'v[1] = (auxMat[0][1] * x1 + auxMat[1][1] * y1 + auxMat[2][1] * z1 + auxMat[3][1])/w;',
            'v[2] = (auxMat[0][2] * x1 + auxMat[1][2] * y1 + auxMat[2][2] * z1 + auxMat[3][2])/w;',

            'vec3 vaux2;',
            'vaux2[0] = v[0] * cos(-boxRotation) - v[1] * sin(-boxRotation);',
            'vaux2[1] = v[0] * sin(-boxRotation) + v[1] * cos(-boxRotation);',
            'vaux2[2] = v[2];',

            'vec3 vaux3 = v - boxMin;',

            'float dx = length(lineBuffer[0]);',
            'float dy = length(lineBuffer[1]);',
            'float dz = length(lineBuffer[2]);',
            'float x = dot(vaux3, lineBuffer[0])/dx;',
            'float y = dot(vaux3, lineBuffer[1])/dy;',
            'float z = dot(vaux3, lineBuffer[2])/dz;',

            'if ( vaux2[0] > boxMin[0] && vaux2[0] < boxMax[0] && vaux2[1] > boxMin[1] && vaux2[1] < boxMax[1] && vaux2[2] > boxMin[2] && vaux2[2] < boxMax[2] )',
            '{',
            '   if ( useBaseColor > 0.0) {',
            '       finalColor.a = litColor.a;',
            '   } else {',
            '       if (x >= range && x <= dx - range && y >= range && y <= dy - range && z >= range && z <= dz - range)',
            '           finalColor = minColor;',
            '       else { // color interpolation',
            '           float dMax = -1e30;',
            '           dMax = max(dMax, x - (dx-range));',
            '           dMax = max(dMax, y - (dy-range));',
            '           dMax = max(dMax, z - (dz-range));',
            '           dMax = max(dMax, range - x);',
            '           dMax = max(dMax, range - y);',
            '           dMax = max(dMax, range - z);',
            '           dMax /= range;',
            '           finalColor = mix( minColor, maxColor, vec4(dMax,dMax,dMax,1.0) );',
            '       }',
            '   }',
            '}'
        ];
        return boxShader;
    },

    _generateVaryingColor: function () {
        var varColorShader = [ '  litColor = Color;' ];
        return varColorShader;
    },

    // for markers and labels
    _generateTextureProgram: function () {

        var vertexShader = [
            '',
            '#version 100',

            '#ifdef GL_FRAGMENT_PRECISION_HIGH',
            'precision highp float;',
            '#else',
            'precision mediump float;',
            '#endif',
            'attribute vec3 Vertex;',
            'attribute vec2 TexCoord0;',
            'varying vec2 FragTexCoord0;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;',
            'uniform mat4 uModelMatrix;', // idem
            'void main(void) {',
            '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex,1.0);',
            '  FragTexCoord0 = TexCoord0;',
            '}',
            ''
        ].join( '\n' );

        var fragmentShader = [
            '',
            '#ifdef GL_ES',
            'precision highp float;',
            '#endif',
            'varying vec2 FragTexCoord0;',
            'uniform sampler2D Texture0;',
            'uniform vec4 color;'
        ];

        if ( this._isSideAttributeActive ) {
            fragmentShader = fragmentShader.concat( [
                'uniform float sideDivider;',
                'uniform int side;',
                'uniform float screenWidth;'
            ] );
        }

        fragmentShader = fragmentShader.concat( [
            'void main (void)',
            '{',
            '  vec4 finalColor = texture2D( Texture0, FragTexCoord0 );',
            '  finalColor = vec4(finalColor.rgb*color.rgb,finalColor.a*color.a);',
            '  if ( finalColor.a == 0.0 )',
            '      discard;'
        ] );

        if ( this._isSideAttributeActive ) {
            fragmentShader = fragmentShader.concat( ShaderUtils.generateSidesFragmentShader() );
        }

        fragmentShader = fragmentShader.concat( [
            '  gl_FragColor = finalColor;',
            '}',
            ''
        ] ).join( '\n' );

        this._textureProgram = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );
    },

    drawLabel: function ( feature, position, center, selectedFeatures ) {
        if ( this._showLabels && ( this._invalidateLabels || this._highlightFeature ) ) {
            var labelNode = this.renderLabel( feature, selectedFeatures, position, center, -3 );
            if ( labelNode )
                this._labelsNode.addChild( labelNode );
        }
    },

    renderLabel: function ( feature, selectedFeatures, position, center, verticalOffset ) {

        if ( this._highlightFeature && !selectedFeatures.has( feature.getId() ) )
            return undefined;

        if ( this._color[ 3 ] === 0 ) // do not render label when color is transparent
            return undefined;

        var localPos = new osg.vec3.create32();
        osg.vec3.sub( localPos, position, center );

        var value;
        if ( this._labelField === 'Id' )
            value = feature.getId();
        else
            value = feature.getAttributeByName( this._labelField );

        if ( !value && ( value !== 0 && value !== false ) )
            return undefined;
        if ( !Number.isInteger( value ) && value.toFixed ) { // for floats, use preference for number of decimals
            var numberOfDecimals = localStorage.getItem( 'ngStorage-numberOfDecimals' );
            value = value.toFixed( numberOfDecimals );
        }

        if ( this._labelField === 'file_name' ) {
            // remove path
            value = value.substring( value.lastIndexOf( '/' ) + 1 );
            // remove image extension
            var pos = value.indexOf( '.jpg' );
            if ( pos === -1 )
                pos = value.indexOf( '.JPG' );
            if ( pos !== -1 )
                value = value.substring( 0, pos );
        }

        var text = new CustomText( value.toString() );
        text.setPosition( localPos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( 5 );
        text.setVerticalLabelOffset( verticalOffset );
        var depth = new osg.Depth( osg.Depth.ALWAYS );
        text.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

        var outlineColor = osg.vec4.fromValues32( 60, 60, 60, 0.8 );
        // use white outline for dark colors
        var fontColor = this._labelsColor ? this._labelsColor : this._color;
        if ( 0.2126 * fontColor[ 0 ] + 0.7152 * fontColor[ 1 ] + 0.0722 * fontColor[ 2 ] < 0.5 )
            outlineColor = osg.vec4.fromValues32( 255, 255, 255, 0.8 );

        text.setColor( fontColor );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( outlineColor );
        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    },

    setStateSetDirty: function ( dirty ) {
        this._stateSetDirty = dirty;
    },

    isStateSetDirty: function () {
        return this._stateSetDirty;
    },

    getColorUniform: function () {
        return this._colorUniform;
    },
    configureColorUniform: function ( stateSet ) {
        stateSet.addUniform( this._colorUniform );
    },

    setCenterTransform: function ( center, layerCenter ) {
        let differenceCenter = osg.vec3.sub( osg.vec3.create64(), center, layerCenter );
        this._sceneGraph.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
        //  this._labelsNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), osg.vec3.negate( osg.vec3.create64(), differenceCenter ) ) );
    }

} );

module.exports = Symbol3D;


/***/ }),

/***/ "./sources/pcvizGISRenderer/TargetSymbol3D.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGISRenderer/TargetSymbol3D.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TargetSymbol3D; });
/* harmony import */ var pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGISRenderer/PositionMarkerSymbol3D */ "./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_2__);




const osg = OSG__WEBPACK_IMPORTED_MODULE_2___default.a.osg;
class TargetSymbol3D extends pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super( false );

        this._nameBase = 'target';
    }

    create2DMarker( layer, feature, selectedFeatures, symbol, name, center ) {
        let position = this.getMarkerPosition( feature, layer );

        let model2DMarker = symbol.renderMarker( position, feature.getId(), selectedFeatures, center, undefined, undefined, undefined );
        if ( !this._floorPMS.isBillboardEnabled() ) {
            this.faceTargetToStation( model2DMarker, position );
        }
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'ModelLibrary' ).addModel( name, model2DMarker );

        return model2DMarker;
    }

    faceTargetToStation( marker, targetPosition ) {
        let dir = osg.vec3.neg( osg.vec3.create64(), targetPosition ); // Direction vector to (0,0,0). In targets the (0,0,0) point is the station.
        osg.vec3.normalize( dir, dir );

        const normal = osg.vec3.fromValues( 0, 0, 1 ); // Normal vector.
        const angle = Math.acos( osg.vec3.dot( dir, normal ) ); // Angle between normal vector & direction vector. (Radians)
        const axis = osg.vec3.cross( osg.vec3.create64(), normal, dir ); // Ortogonal vector from normal & direction. Should be used as rotation axis.

        let rotationMatrix = osg.mat4.create64();
        osg.mat4.rotate( rotationMatrix, marker.getMatrix(), angle, axis ); // Rotate marker such as "angle" in "axis".
        marker.setRotation( osg.mat4.getRotation( osg.quat.create(), rotationMatrix ) );

        // Disabling culling face to watch the symbol from both sides
        let cullFaceMode = new osg.CullFace();
        cullFaceMode.setMode( osg.CullFace.DISABLE );
        marker.getOrCreateStateSet().setAttributeAndModes( cullFaceMode );
    }
}


/***/ }),

/***/ "./sources/pcvizGISRenderer/VolumeSymbol3D.js":
/*!****************************************************!*\
  !*** ./sources/pcvizGISRenderer/VolumeSymbol3D.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VolumeSymbol3D; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/Model3DSymbol3D */ "./sources/pcvizGISRenderer/Model3DSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_1__);

const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;




class VolumeSymbol3D extends pcvizGISRenderer_Model3DSymbol3D__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor() {
        super();
    }
    setColorUniform( stateSet, model, layer ) {
        super.setColorUniform( stateSet, model );

        if ( !stateSet )
            stateSet = model.getOrCreateStateSet();

        if ( layer !== undefined ) {
            stateSet.addUniform( osg.Uniform.createFloat1( layer.getCenter()[ 2 ], 'centerZ' ) );
            stateSet.addUniform( osg.Uniform.createFloat1( layer.getStyle().PolygonSymbolizer.tolerance, 'tolerance' ) );
        }
    }

    setDynamicUniforms( node, layer ) {
        let osgStateSet = node.getOrCreateStateSet();
        let toleranceUniform = osgStateSet.getUniform( 'tolerance' );
        toleranceUniform.setFloat( layer.getStyle().PolygonSymbolizer.tolerance );
    }

    _generateElevationFragmentShader() {
        let varColorShader = [].concat( [
            'float size = (normal.y - normal.x);', // Cube's size

            'float value =  abs(tolerance - size) / tolerance;', // Diference between cube's size and tolerance value
            'value = clamp(value, 0.0, 1.0);', // Only [0.0, 1,0] interval.
            'value = value / 2.0;', // Transform it on [0.0, 0.5] interval. Correct values for cubes above: [0.0,0.5] (red-green).

            'if(isCut == 0.0) {', // Cube behind the cutting edge.
            '    value = abs(value - 1.0);', // Transform it on hue (HSV) value. [1.0, 0.5] (blue-green).

            '    if(size > tolerance)', // Case: if cube's size is greater than the tolerance value, just is blue.
            '        value = 1.0;',
            '}',
            'else {', // Cube above the cutting edge
            '    if(size > tolerance)', // Case: if cube's size is greater than the tolerance value, just is red.
            '        value = 0.0;',
            '}',

            'finalColor = vec4(hsv2rgb(vec3(value*0.7, 0.9, 0.9)), litColor.a);' // Final color using hue value calculated before.
        ] );

        return varColorShader;
    }

    _generateVaryingColor() {
        let varColorShader = super._generateVaryingColor();
        varColorShader = varColorShader.concat( [
            'normal = Normal;',
            'isCut = Color[0];'
        ] );

        return varColorShader;
    }

    getShaderInfo() {
        let shaderInfo = super.getShaderInfo();
        shaderInfo.hsv2rgb = true;
        shaderInfo.elevationUniforms = true;
        shaderInfo.uniformUseModelColor = false;
        shaderInfo.attributeColor = true; // to get the isCut value
        // shaderInfo.uniformColor = false; // We could try this if we are not interested in the alpha value.

        return shaderInfo;
    }
}


/***/ }),

/***/ "./sources/pcvizGISRenderer/pcvizGISRenderer.js":
/*!******************************************************!*\
  !*** ./sources/pcvizGISRenderer/pcvizGISRenderer.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGISRenderer/PositionMarkerSymbol3D */ "./sources/pcvizGISRenderer/PositionMarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_StationSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/StationSymbol3D */ "./sources/pcvizGISRenderer/StationSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_TargetSymbol3D__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGISRenderer/TargetSymbol3D */ "./sources/pcvizGISRenderer/TargetSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_VolumeSymbol3D__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGISRenderer/VolumeSymbol3D */ "./sources/pcvizGISRenderer/VolumeSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MachineryMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGISRenderer/MachineryMarkerSymbol3D */ "./sources/pcvizGISRenderer/MachineryMarkerSymbol3D.js");

const SingleSymbolRenderer = __webpack_require__( /*! pcvizGISRenderer/SingleSymbolRenderer */ "./sources/pcvizGISRenderer/SingleSymbolRenderer.js" );
const LayerRenderer3D = __webpack_require__( /*! pcvizGISRenderer/LayerRenderer3D */ "./sources/pcvizGISRenderer/LayerRenderer3D.js" );
const Symbol3D = __webpack_require__( /*! pcvizGISRenderer/Symbol3D */ "./sources/pcvizGISRenderer/Symbol3D.js" );
const PointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PointSymbol3D */ "./sources/pcvizGISRenderer/PointSymbol3D.js" );
const MultiPointSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MultiPointSymbol3D */ "./sources/pcvizGISRenderer/MultiPointSymbol3D.js" );
const PointMarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PointMarkerSymbol3D */ "./sources/pcvizGISRenderer/PointMarkerSymbol3D.js" );
const MultiPointMarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MultiPointMarkerSymbol3D */ "./sources/pcvizGISRenderer/MultiPointMarkerSymbol3D.js" );
const LineSymbol3D = __webpack_require__( /*! pcvizGISRenderer/LineSymbol3D */ "./sources/pcvizGISRenderer/LineSymbol3D.js" );
const FillSymbol3D = __webpack_require__( /*! pcvizGISRenderer/FillSymbol3D */ "./sources/pcvizGISRenderer/FillSymbol3D.js" );
const PointCloudRenderer = __webpack_require__( /*! pcvizGISRenderer/PointCloudRenderer */ "./sources/pcvizGISRenderer/PointCloudRenderer.js" );
const RasterRenderer = __webpack_require__( /*! pcvizGISRenderer/RasterRenderer */ "./sources/pcvizGISRenderer/RasterRenderer.js" );
const FillMarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/FillMarkerSymbol3D */ "./sources/pcvizGISRenderer/FillMarkerSymbol3D.js" );
const LineMarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/LineMarkerSymbol3D */ "./sources/pcvizGISRenderer/LineMarkerSymbol3D.js" );
const PanoramaSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PanoramaSymbol3D */ "./sources/pcvizGISRenderer/PanoramaSymbol3D.js" );
const PlanarImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PlanarImageSymbol3D */ "./sources/pcvizGISRenderer/PlanarImageSymbol3D.js" );
const Model3DSymbol3D = __webpack_require__( /*! pcvizGISRenderer/Model3DSymbol3D */ "./sources/pcvizGISRenderer/Model3DSymbol3D.js" );



const MultiModel3DSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MultiModel3DSymbol3D */ "./sources/pcvizGISRenderer/MultiModel3DSymbol3D.js" );



/** @namespace pcvizGISRenderer */
let pcvizGISRenderer = {};
pcvizGISRenderer.SingleSymbolRenderer = SingleSymbolRenderer;
pcvizGISRenderer.LayerRenderer3D = LayerRenderer3D;
pcvizGISRenderer.Symbol3D = Symbol3D;
pcvizGISRenderer.PointSymbol3D = PointSymbol3D;
pcvizGISRenderer.MultiPointSymbol3D = MultiPointSymbol3D;
pcvizGISRenderer.PointMarkerSymbol3D = PointMarkerSymbol3D;
pcvizGISRenderer.MultiPointMarkerSymbol3D = MultiPointMarkerSymbol3D;
pcvizGISRenderer.LineSymbol3D = LineSymbol3D;
pcvizGISRenderer.FillSymbol3D = FillSymbol3D;
pcvizGISRenderer.PointCloudRenderer = PointCloudRenderer;
pcvizGISRenderer.RasterRenderer = RasterRenderer;
pcvizGISRenderer.FillMarkerSymbol3D = FillMarkerSymbol3D;
pcvizGISRenderer.LineMarkerSymbol3D = LineMarkerSymbol3D;
pcvizGISRenderer.PanoramaSymbol3D = PanoramaSymbol3D;
pcvizGISRenderer.PlanarImageSymbol3D = PlanarImageSymbol3D;
pcvizGISRenderer.Model3DSymbol3D = Model3DSymbol3D;
pcvizGISRenderer.PositionMarkerSymbol3D = pcvizGISRenderer_PositionMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizGISRenderer.StationSymbol3D = pcvizGISRenderer_StationSymbol3D__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizGISRenderer.TargetSymbol3D = pcvizGISRenderer_TargetSymbol3D__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizGISRenderer.MultiModel3DSymbol3D = MultiModel3DSymbol3D;
pcvizGISRenderer.VolumeSymbol3D = pcvizGISRenderer_VolumeSymbol3D__WEBPACK_IMPORTED_MODULE_3__["default"];
pcvizGISRenderer.MachineryMarkerSymbol3D = pcvizGISRenderer_MachineryMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_4__["default"];
pcvizGISRenderer.STATUS_SITELINK3D = pcvizGISRenderer_MachineryMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_4__["STATUS_SITELINK3D"];
pcvizGISRenderer.STATUS_TELEMATICS = pcvizGISRenderer_MachineryMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_4__["STATUS_TELEMATICS"];
pcvizGISRenderer.MACHINE_TYPES = pcvizGISRenderer_MachineryMarkerSymbol3D__WEBPACK_IMPORTED_MODULE_4__["MACHINE_TYPES"];

/* harmony default export */ __webpack_exports__["default"] = (pcvizGISRenderer);


/***/ }),

/***/ "./sources/pcvizJobs/Job.js":
/*!**********************************!*\
  !*** ./sources/pcvizJobs/Job.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");





const VALID_LISTENER_EVENTS = [ 'progress', 'finish' ];
const JOB_CHECK_INTERVAL = 5000;

class Job {
    constructor( jobObject = undefined ) {
        this._jobDriver = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getDriver( 'da.job' );
        this._jobObject = jobObject;
        this._processId = undefined;
        this._name = undefined;
        this._input = undefined;
        this._output = undefined;
        this._inputData = undefined;
        this._outputData = undefined;
        this._listeners = new Map();
    }

    getPipeline() {
        let pipelineData = {
            process: {
                id: this._processId,
                input: this._input,
                output: this._output,
                inputData: this._inputData,
                outputData: this._outputData
            }
        };
        if ( this._name ) {
            pipelineData.process.name = this._name;
        }
        return pipelineData;
    }

    getJobId() {
        if ( !this._jobObject ) {
            return;
        }
        return this._jobObject.id;
    }

    getProcessId() {
        return this._processId;
    }

    setProcessId( processId ) {
        this._processId = processId;
    }

    getName() {
        return this._name;
    }

    setName( name ) {
        this._name = name;
    }

    getInput() {
        return this._input;
    }

    setInput( input ) {
        this._input = input;
    }

    getOutput() {
        return this._output;
    }

    setOutput( output ) {
        this._output = output;
    }

    getInputData() {
        return this._inputData;
    }

    setInputData( inputData ) {
        this._inputData = inputData;
    }

    getOutputData() {
        return this._outputData;
    }

    setOutputData( outputData ) {
        this._outputData = outputData;
    }

    create( createAndStartOption ) {
        return new Promise( ( resolve, reject ) => {
            this._jobDriver.create( this.getPipeline(), createAndStartOption ).then( job => {
                this._jobObject = job;
                resolve( job );
            }, error => {
                reject( error );
            } );
        } );
    }

    start() {
        return this._jobDriver.start( this.getJobId() );
    }

    cancel() {
        return this._jobDriver.cancel( this.getJobId() );
    }

    estimate() {
        return this._jobDriver.estimate( this.getPipeline() );
    }

    getDriver() {
        return this._jobDriver;
    }

    on( action, fn ) {
        if ( VALID_LISTENER_EVENTS.indexOf( action ) === -1 ) {
            throw `${action} is not a valid event. Valid events are ${VALID_LISTENER_EVENTS}`;
        }
        if ( !this._listeners.has( action ) ) {
            this._listeners.set( action, [] );
        }
        this._listeners.get( action ).push( fn );
        this.startCheckStatus();
    }

    emit( action, ...args ) {
        if ( !this._listeners.has( action ) ) {
            return;
        }
        this._listeners.get( action ).forEach( fn => {
            fn( ...args );
        } );
    }

    startCheckStatus() {
        if ( !this.getJobId() ) {
            throw 'Job has not been created.';
            // TODO: Check upload status
        }
        if ( this._checkInterval ) {
            return;
        }
        this._checkInterval = setInterval( () => {
            this._jobDriver.getJob( this.getJobId() ).then( jobData => {
                if ( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_1__["default"].FINISHED_ARRAY.indexOf( jobData.status ) !== -1 ) {
                    this.emit( 'finish', jobData );
                    clearInterval( this._checkInterval );
                    return;
                }
                if ( pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_1__["default"].PROCESSING_ARRAY.indexOf( jobData.status ) !== -1 ) {
                    this.emit( 'progress', jobData );
                    return;
                }
                // TODO: Check other status
            } );
        }, JOB_CHECK_INTERVAL );
    }
}

/* harmony default export */ __webpack_exports__["default"] = (Job);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapterRegistry.js":
/*!*************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapterRegistry.js ***!
  \*************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobAdapterRegistry; });


/**
 *  JobAdapterRegistry Base Class
 *  @class
 *  @memberof pcvizJobs
 */
class JobAdapterRegistry {
    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @return {Object} The `Registry` instance.
     */
    static getInstance() {
        if ( !JobAdapterRegistry.instance ) {
            JobAdapterRegistry.instance = this;
            JobAdapterRegistry.instance.importers = new Map();
        }
        return JobAdapterRegistry.instance;
    }

    /**
     * Registers a Job adapter.
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {string} name           The name of the Job adapter.
     * @param  {JobAdapter} JobAdapterObject The Job adapter instance.
     */
    static registerJobAdapter( name, JobAdapterObject ) {
        if ( JobAdapterRegistry.instance.importers.get( name ) !== undefined )
            console.log( 'the Layer uploader already exists' );
        JobAdapterRegistry.instance.importers.set( name, JobAdapterObject );
    }

    /**
     * Unregister Job adapter
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {Id} Job adapter Id.
     * @return {result} Return true if the adapter has been unregister and false if the adapter has not been unregister
     */
    static unregisterJobAdapter( Id ) {
        return JobAdapterRegistry.getInstance().importers.delete( Id );
    }

    /**
     * Set enabled Job adapter
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {Id} Job adapter Id.
     * @param  {enabled} enabled the Job adapter.
     */
    static setEnabledJobAdapter( Id, enabled ) {
        var lu = JobAdapterRegistry.getInstance().getImporter( Id );
        if ( lu === undefined )
            return;
        lu.setEnabled( enabled );
    }

    static setEnabledAllJobAdapter( flag ) {
        if ( !JobAdapterRegistry.getInstance().importers ) {
            return;
        }
        JobAdapterRegistry.getInstance().importers.forEach( importer => {
            importer.setEnabled( flag );
        } );
    }



    /**
     * Gets a Job adapter.
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {string} name The name of the Job adapter.
     * @return {Importer}      The Job adapter instance.
     */
    static getImporter( name ) {
        return JobAdapterRegistry.instance.importers.get( name );
    }

    /**
     * Gets a Job adapter. It uses the extension of the file to get the right Job adapter.
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {string} name The name of the Job adapter.
     * @return {Importer}      The Job adapter instance.
     */
    static getJobAdapterByExt( ext ) {
        var uploaders = [];
        var priority = [];

        JobAdapterRegistry.instance.importers.forEach( function ( jobAdapter ) {
            if ( jobAdapter.acceptFile( ext ) ) {
                uploaders.push( jobAdapter.cloneType() );
                return;
            }
        } );

        uploaders.forEach( function ( jobAdapter ) {
            var extensions = jobAdapter._mandatoryDataFileExtension ? jobAdapter._mandatoryDataFileExtension : jobAdapter._extensions;
            if ( extensions.indexOf( ext ) !== -1 )
                priority.push( jobAdapter );
        } );
        return {
            uploaders: uploaders,
            priority: priority
        };
    }

    /**
     * Gets a copy of the passed Job adapter.
     * @method
     * @memberof pcvizJobs.JobAdapterRegistry
     * @param  {jobAdapter} Job adapter to make the copy.
     * @return {Importer}      The Job adapter instance.
     */
    static cloneJobAdapter( jobAdapter ) {
        if ( jobAdapter === undefined )
            return;

        var copyJobAdapter = JobAdapterRegistry.instance.importers.get( jobAdapter._id );
        return copyJobAdapter.cloneType( jobAdapter );
    }

    // This method returns a list of the extensions supported (.jpg,.las,.json.....)
    // We use this method when the files are inserted by the browser dialog. The dialog uses the
    // returned array as a filter for the files.
    static getAcceptedFileExtensions() {
        var acceptedFileExtensions = [];
        JobAdapterRegistry.instance.importers.forEach( function ( jobAdapter ) {
            var extensions = jobAdapter.getExtensions();
            extensions.forEach( function ( extension ) {
                acceptedFileExtensions.push( '.' + extension );
            } );
        } );
        return acceptedFileExtensions.join( ',' );
    }
}


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapterService.js":
/*!************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapterService.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobAdapterService; });
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");


/**
 *  JobAdapterService
 *  @class
 *  @memberof pcvizJobs
 */
var currentJobAdapter;

class JobAdapterService {

    static ensureJobAdapter( jobAdapter ) {
        jobAdapter = pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__["default"].getInstance().cloneJobAdapter( jobAdapter );
        if ( jobAdapter === undefined )
            jobAdapter = this.getJobAdapter();
        return jobAdapter;
    }

    static getJobAdapter() {
        return currentJobAdapter;
    }

    static setJobAdapter( jobAdapter ) {
        currentJobAdapter = jobAdapter;
    }

    static clearService() {
        JobAdapterService.setJobAdapter( undefined );
    }
}


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/BimJobAdapter.js":
/*!********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/BimJobAdapter.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizJobs_JobAdapters_ClearEdgeModelJobAdapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobAdapters/ClearEdgeModelJobAdapter */ "./sources/pcvizJobs/JobAdapters/ClearEdgeModelJobAdapter.js");
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4__);







const BIM_ID = 'BimData';

/**
 *  BimJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
class BimJobAdapter extends pcvizJobs_JobAdapters_ClearEdgeModelJobAdapter__WEBPACK_IMPORTED_MODULE_2__["default"] {

    constructor() {
        super();
        this.setId( 'BIM' );

        this._extensions = [ 'ifc' ];

        this.setRemoteProcessId( pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__["default"].BIM_PROCESS );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: BIM_ID,
            id: BIM_ID,
            label: BIM_ID,
            fileType: BIM_ID
        } ];
    }

    detect() {
        return new Promise( resolve => {
            const out = [];
            const result = {
                format: BIM_ID,
                type: BIM_ID,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    // as it inherits from ClearEdgeModelJobAdapter we need to overwrite
    createJobAdapter() {
        return new BimJobAdapter();
    }

    getJob( config ) {
        const job = pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default.a.prototype.getJob.call( this, config );

        job.setOutputData( JSON.stringify( {
            detectDataType: true,
            outputFilesPath: this.getOutputFilesPath()
        } ) );

        const inputData = JSON.parse( job.getInputData() );
        inputData[ 'process' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_4___default.a.IFC_IMPORT_FILE_PATH;
        inputData[ 'cemzName' ] = config.outputUUID;
        job.setInputData( JSON.stringify( inputData ) );

        return job;
    }

}
// Register JobAdapter
const bim = new BimJobAdapter();
pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__["default"].getInstance().registerJobAdapter( bim.getId(), bim );
/* harmony default export */ __webpack_exports__["default"] = (BimJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/CRP1ScanProjectJobAdapter.js":
/*!********************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/CRP1ScanProjectJobAdapter.js ***!
  \********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3__);





class CRP1ScanProjectJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor() {
        super();
        this.setId( CRP1ScanProjectJobAdapter.ID );

        this._extensions = [ 'json' ];
        this._mandatoryDataFileExtension = [ 'json' ];
        this._mandatoryRules = [];

        this._maxFileCount = 1;

        this._objectType = 'projects';
        this.setRemoteProcessId( pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].IMPORT_SCAN_PROJECT ); // default

        this._scans = undefined;
        this._dataPath = undefined;
        this._workspaceProjectEnabled = false;
        this._unselectedElements = undefined;
        this._workspaceImportPath = undefined;

        this._extraInputData = undefined;
        this._extraOutputData = undefined;

        this._outputFormats = undefined;
        this._formatOptions = undefined;

    }

    setScans( scans ) {
        this._scans = scans;
    }

    getScansData() {
        return this._scans.map( scan => ( {
            name: scan.name,
            source: this.getZipFileShortPath( scan ),
            hasPanorama: scan.capturedWithCamera,
            isDetailScan: scan.isDetailScan,
            groupId: scan.groupId,
        } ) );
    }

    getDstSrcFilePathsFor( projectId ) {
        if ( !this._scans ) throw new Error( 'No scans available' );
        if ( !this._dataPath ) throw new Error( 'File path not found' );

        return this._scans.map( scan => {
            return ( {
                source: this.getFlsFolderPath( scan ),
                dest: this.getZipFilePath( scan, projectId ),
            } );
        } );
    }

    getFilename( scan ) {
        const path = this.getTrimmedFilePath( scan );
        return path.split( '\\' ).pop();
    }

    getTrimmedFilePath( scan ) {
        const windowsPath = scan.filesPath.split( '/' ).join( '\\' );
        const pathWithoutBeginningDot = windowsPath.replace( /^\./, '' );
        const pathWithoutBeginningSlash = pathWithoutBeginningDot.replace( /^\\/, '' );
        return pathWithoutBeginningSlash;
    }

    getFlsFolderPath( scan ) {
        const filePath = this.getTrimmedFilePath( scan );
        return `${ this._dataPath }${ filePath }\\`;
    }

    getZipFilePath( scan, projectId ) {
        const zipPath = this.getZipFileShortPath( scan );
        return `/data/projects/${ projectId }/${ zipPath }`;
    }

    getZipFileShortPath( scan ) {
        const fileName = this.getFilename( scan );
        return `process/import_data/${ fileName }.zip`;
    }

    setDataPath( dataPath ) {
        this._dataPath = dataPath;
    }

    getDataPath() {
        return this._dataPath;
    }

    getScansUUIDs() {
        if ( !this._scans ) {
            return;
        }
        return this._scans.map( scan => scan.uuid );
    }

    getScans() {
        return this._scans;
    }

    setOutputFormats( formats ) {
        this._outputFormats = formats;
    }

    isFileValid() {
        return true;
    }

    getOutputFormats() {
        return this._outputFormats;
    }

    setFormatOptions( options ) {
        this._formatOptions = options;
    }

    getFormatOptions() {
        return this._formatOptions;
    }

    getWorkspaceImportPath() {
        return this._workspaceImportPath;
    }

    setWorkspaceImportPath( importPath ) {
        this._workspaceImportPath = importPath;
    }

    setUnselectedElements( unselectedElements ) {
        this._unselectedElements = unselectedElements;
    }

    getUnselectedElements() {
        return this._unselectedElements;
    }

    setOptions( options ) {
        this._options = options;
    }

    setExtraInputData( extraInputData ) {
        this._extraInputData = extraInputData;
    }
    setExtraOutputData( extraOutputData ) {
        this._extraOutputData = extraOutputData;
    }

    detect() {
        return new Promise( ( resolve ) => {
            let out = [];
            let result = {
                format: CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID,
                type: CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this._id,
            id: CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID,
            label: CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID,
            fileType: CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID
        } ];
    }

    getJob( config ) {
        let job = super.getJob( config );
        let inputData = JSON.parse( job.getInputData() );
        inputData[ 'workspace' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_FILE_PATH;
        inputData[ 'workspaceProcess' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_PROCESS_FILE_PATH;
        if ( this._workspaceProjectEnabled ) {
            inputData[ 'workspaceProject' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_PROJECT_FILE_PATH;
        }
        inputData[ 'projectPath' ] = 'process/scan_project';
        inputData[ 'workspaceImportPath' ] = this.getWorkspaceImportPath();
        inputData[ 'scans' ] = this.getScansUUIDs();
        if ( this._extraInputData ) {
            Object.assign( inputData, this._extraInputData );
        }
        Object.assign( inputData, this._options );
        const outputData = {
            'workspace': pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_FILE_PATH,
            'scans': this.configureOutputScans()
        };
        if ( this._extraOutputData ) {
            Object.assign( outputData, this._extraOutputData );
        }
        job.setOutputData( JSON.stringify( outputData ) );

        job.setInputData( JSON.stringify( inputData ) );
        return job;
    }

    configureOutputScans() {
        if ( !this._scans ) {
            return;
        }

        let outputPaths = {};

        if ( this._options.processPointcloud )
            for ( let scan of this._scans ) {
                // Check this because there are scans without children layers.
                if ( !scan.children )
                    continue;
                let pointcloudLayer = scan.children.find( child => child.category === 'PointCloud' );
                // Check if there is a pointcloud layer (Some scans only have panoramas)
                if ( pointcloudLayer )
                    outputPaths[ scan.uuid ] = {
                        plfmz: '/catalog/collage/layers/' + pointcloudLayer.catalogObjectId + '/',
                        tttl: '/catalog/collage/layers/' + pointcloudLayer.catalogObjectId + '/',
                        // TODO: panoramas: configura panoramas
                    };
            }

        return outputPaths;
    }

    cloneType( jobAdapter ) {
        var copyJobAdapter = new CRP1ScanProjectJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._workspaceProjectEnabled = jobAdapter._workspaceProjectEnabled;
        copyJobAdapter._workspaceImportPath = jobAdapter._workspaceImportPath;
        // uncomment if needed copyJobAdapter._extraInputData = jobAdapter._extraInputData;
        return copyJobAdapter;
    }

    enableWorkspaceProject( enabled = true ) {
        this._workspaceProjectEnabled = enabled;
    }

    hasCost() {
        return this._remoteProcessId === pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_PROCESSING;
    }
}

CRP1ScanProjectJobAdapter.ID = 'CRP1SPA';
CRP1ScanProjectJobAdapter.CRP1_IMPORT_ID = 'CRP1ScanProject';

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_0__["default"].getInstance().registerJobAdapter( CRP1ScanProjectJobAdapter.ID, new CRP1ScanProjectJobAdapter() );

/* harmony default export */ __webpack_exports__["default"] = (CRP1ScanProjectJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ClearEdgeModelJobAdapter.js":
/*!*******************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ClearEdgeModelJobAdapter.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizGIS_LayerDefinition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js");





/**
 * Temporary JobAdapter until IFC is ready
 */
class ClearEdgeModelJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2___default.a {

    constructor() {
        super();
        this.setId( ClearEdgeModelJobAdapter.ID );

        this._layerType = pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_0__["default"].VECTOR;
        this._geometryType = 'Unknown';
        this._extensions = [ 'cemz' ];
        this._mandatoryDataFileExtension = [ 'cemz' ];
        this._mandatoryRules = [];

        this.setRemoteProcessId( pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__["default"].MW_FILTERS_COMMON_PROCESS );
    }

    setOptions( options ) {
        this._options = options;
    }

    detect() {
        return new Promise( resolve => {
            const out = [];
            const result = {
                format: ClearEdgeModelJobAdapter.TYPE,
                type: ClearEdgeModelJobAdapter.TYPE,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this.getId(),
            id: ClearEdgeModelJobAdapter.TYPE,
            label: ClearEdgeModelJobAdapter.TYPE
        } ];
    }

    cloneType( jobAdapter ) {
        let copyJobAdapter = this.createJobAdapter();
        if ( jobAdapter !== undefined ) {
            copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
            copyJobAdapter._extensions = jobAdapter._extensions;
        }
        return copyJobAdapter;
    }

    createJobAdapter() {
        return new ClearEdgeModelJobAdapter();
    }

    getJob( config ) {
        const job = super.getJob( config );
        const inputData = JSON.parse( job.getInputData() );

        inputData[ 'filter' ] = 'verityprocessing';
        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {
            detectDataType: true,
            outputFilesPath: this.getOutputFilesPath()
        } ) );
        return job;
    }

    getLayerDefinition( layer ) {
        if ( layer.id ) {
            return {};
        }

        const layerDefinition = this.getBaseLayerDefinition( layer );

        return layerDefinition.getJSONObject();
    }

    getBaseLayerDefinition( layer ) {
        const layerDefinition = new pcvizGIS_LayerDefinition__WEBPACK_IMPORTED_MODULE_4__["default"]();
        layerDefinition.setName( layer.name );
        layerDefinition.setDescription( layer.description );
        layerDefinition.setLayerType( this._layerType );
        layerDefinition.setLayerGeometryType( this._geometryType );

        return layerDefinition;
    }

    getOutputFilesPath() {
        return [ '3d_models/' ];
    }
}

ClearEdgeModelJobAdapter.ID = 'CEM';
ClearEdgeModelJobAdapter.TYPE = 'ClearEdgeModels';

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"].getInstance().registerJobAdapter( ClearEdgeModelJobAdapter.ID, new ClearEdgeModelJobAdapter() );

/* harmony default export */ __webpack_exports__["default"] = (ClearEdgeModelJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/CreateStationJobAdapter.js":
/*!******************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/CreateStationJobAdapter.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/ScanProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/ScanProjectJobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");



class CreateStationJobAdapter extends pcvizJobs_JobAdapters_ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor() {
        super();
        this.setId( CreateStationJobAdapter.ID );

        this._extensions = [ 'las', 'laz', 'e57', 'pts', 'xyz', 'txt', 'ptx', 'clr', 'cl3', 'ij', 'alg' ];
        this._mandatoryDataFileExtension = [ 'las', 'laz', 'e57', 'pts', 'xyz', 'ptx', 'clr', 'cl3', 'ij', 'alg' ];
        this._mandatoryRules = [ {
            extension: [ 'ij', 'alg' ],
            mandatory: [ 'cl3' ]
        } ];

        this._maxFileCount = undefined;
        this._filesArray = [];

    }

    cloneType( jobAdapter ) {
        var copyJobAdapter = new CreateStationJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._workspaceProjectEnabled = jobAdapter._workspaceProjectEnabled;
        copyJobAdapter._workspaceImportPath = jobAdapter._workspaceImportPath;
        copyJobAdapter._filesArray = jobAdapter._filesArray.slice( 0 );

        return copyJobAdapter;
    }

    detect() {
        return new Promise( ( resolve ) => {
            let out = [];
            let result = {
                format: CreateStationJobAdapter.CREATE_STATION_ID,
                type: CreateStationJobAdapter.CREATE_STATION_ID,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this._id,
            id: CreateStationJobAdapter.CREATE_STATION_ID,
            label: CreateStationJobAdapter.CREATE_STATION_ID,
            fileType: CreateStationJobAdapter.CREATE_STATION_ID
        } ];
    }

    setFilesArray( array ) {
        this._filesArray = array;
    }

    getJob( config ) {
        let job = super.getJob( config );
        let inputData = JSON.parse( job.getInputData() );
        inputData[ 'files' ] = this._filesArray;
        job.setInputData( JSON.stringify( inputData ) );
        return job;
    }
}

CreateStationJobAdapter.ID = 'CSA';
CreateStationJobAdapter.CREATE_STATION_ID = 'CreateStation';

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"].getInstance().registerJobAdapter( CreateStationJobAdapter.ID, new CreateStationJobAdapter() );

/* harmony default export */ __webpack_exports__["default"] = (CreateStationJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/DeleteDataJobAdapter.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/DeleteDataJobAdapter.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");



class DeleteDataJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__["default"].DELETE_DATA;
    }

    getJob( config ) {
        let job = super.getJob( config );
        job.setInputData( JSON.stringify( {
            files: config.files
        } ) );
        return job;
    }
}

/* harmony default export */ __webpack_exports__["default"] = (DeleteDataJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/DesignDataJobAdapter.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/DesignDataJobAdapter.js ***!
  \***************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizGIS_LayerDefinition__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js");
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");






class DesignDataJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_1___default.a {

    constructor() {
        super();
        this.setId( DesignDataJobAdapter.ID );

        this._layerName = undefined;
        this._layerType = pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_0__["default"].VECTOR;
        this._geometryType = 'Unknown';
        this._extensions = [ 'xml', 'mxl', /*'tn3',*/ 'shp', 'shx', 'prj', 'dbf', 'ply' ];
        this._mandatoryDataFileExtension = [ 'xml', 'mxl', /*'tn3' ,*/ 'shp', 'ply' ];
        this._mandatoryRules = [];
        this._groups = [ {
                type: 'SHP',
                ext: [ 'shp', 'shx', 'prj', 'dbf' ],
                filter: 'gisfeatures'
            },
            {
                type: 'PLY',
                ext: [ 'ply' ],
                filter: 'modelprocessing',
                geometryType: 'MultiPoint',
                categoryName: pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_5__["default"].Categories.MODEL3D
            },
            {
                type: 'DEFAULT',
                ext: [ 'xml', 'mxl' ],
                filter: 'designdataimporter'
            }
        ];
        this.setRemoteProcessId( pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__["default"].MW_FILTERS_COMMON_PROCESS );
    }

    setOptions( options ) {
        this._options = options;
    }

    cloneType( jobAdapter ) {
        let copyJobAdapter = new DesignDataJobAdapter();
        if ( jobAdapter !== undefined ) {
            copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
            copyJobAdapter._geometryType = jobAdapter._geometryType;
            copyJobAdapter._extensions = jobAdapter._extensions;
            copyJobAdapter._importGroup = jobAdapter._importGroup;
            copyJobAdapter._layerName = jobAdapter._layerName;
        }
        return copyJobAdapter;
    }

    detect() {
        return new Promise( resolve => {
            const out = [];
            const result = {
                format: DesignDataJobAdapter.DESIGN_DATA_TYPE,
                type: DesignDataJobAdapter.DESIGN_DATA_TYPE,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this.getId(),
            id: DesignDataJobAdapter.DESIGN_DATA_TYPE,
            label: DesignDataJobAdapter.DESIGN_DATA_TYPE,
            fileType: DesignDataJobAdapter.DESIGN_DATA_TYPE,
            warnings: [ 'DDU_GROUPS' ]
        } ];
    }

    getJob( config ) {
        const job = super.getJob( config );
        const inputData = JSON.parse( job.getInputData() );
        this.updateInputData( inputData );
        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {
            files: [
                'features.json',
                'layer.json'
            ],
            detectDataType: true
        } ) );
        return job;
    }

    updateInputData( inputData ) {
        if ( inputData ) {
            const group = this._groups.find( group => group.type === this._importGroup );
            inputData.filter = group ? group.filter : 'designdataimporter';
            if ( this._layerName && inputData.filter === 'designdataimporter' ) {
                inputData.options = { layerName: this._layerName.replaceAll( ' ', '{spc}' ) };
            }
        }
    }

    areLayerFilesValid( files ) {
        if ( !files || files.length === 0 || this.areMultipleImportGroups( files ) ) {
            this._importGroup = undefined;
            return false;
        }
        if ( this.hasExtensionShapefile( files[ 0 ].name ) ) {
            this._importGroup = 'SHP';
            // Required extensions
            return files.some( file => this.getExtension( file.name ) === 'shp' ) &&
                files.some( file => this.getExtension( file.name ) === 'shx' ) &&
                files.some( file => this.getExtension( file.name ) === 'dbf' );
        }
        if ( this.hasExtensionPLY( files[ 0 ].name ) ) {
            this._importGroup = 'PLY';
            // Required extensions
            return files.some( file => this.getExtension( file.name ) === 'ply' );
        }
        this._importGroup = 'DEFAULT';
        return super.areLayerFilesValid( files );
    }

    areMultipleImportGroups( files ) {
        const groupTypes = [];

        files.forEach( file => {
            const fileGroup = this.getGroupTypeByExtension( file.name );

            if ( !groupTypes.includes( fileGroup.type ) ) {
                groupTypes.push( fileGroup.type );
            }
        } );

        return groupTypes && groupTypes.length > 1;
    }

    isFileValid( file, extensions ) {
        if ( this._importGroup ) {
            return super.isFileValid( file, this.getExtensionsOfGroup( this._importGroup ) );
        }
        return super.isFileValid( file, extensions );
    }

    getGroupTypeByExtension( filename ) {
        const ext = this.getExtension( filename );

        return this._groups.find( group => group.ext.includes( ext ) );
    }

    hasExtensionShapefile( filename ) {
        const ext = this.getExtension( filename );
        const extensionsSHP = this.getExtensionsOfGroup( 'SHP' );
        return extensionsSHP.some( e => e === ext );

    }
    hasExtensionPLY( filename ) {
        const ext = this.getExtension( filename );
        const extensionsPLY = this.getExtensionsOfGroup( 'PLY' );
        return extensionsPLY.some( e => e === ext );
    }
    getExtensionsOfGroup( groupId ) {
        const group = this._groups.find( group => group.type === groupId );
        return group.ext;
    }

    getLayerDefinition( layer ) {
        if ( layer.id ) {
            return {};
        }

        const layerDefinition = this.getBaseLayerDefinition( layer );

        return layerDefinition.getJSONObject();
    }

    getBaseLayerDefinition( layer ) {
        const layerDefinition = new pcvizGIS_LayerDefinition__WEBPACK_IMPORTED_MODULE_4__["default"]();
        this._layerName = layer.name;
        layerDefinition.setName( this._layerName );
        layerDefinition.setDescription( layer.description );
        layerDefinition.setLayerType( this._layerType );
        layerDefinition.setLayerGeometryType( this._geometryType );
        layerDefinition.setHorizProjectionEPSG( this.getDestCRS() );
        const group = this._groups.find( group => group.type === this._importGroup );
        if ( group && group.categoryName ) {
            layerDefinition.setLayerCategory( this.getServerCategoryByName( group.categoryName ).id );
        }
        if ( group && group.geometryType ) {
            layerDefinition.setLayerGeometryType( group.geometryType );
        }
        return layerDefinition;
    }
}

DesignDataJobAdapter.ID = 'DDU';
DesignDataJobAdapter.DESIGN_DATA_TYPE = 'DduVectorLayer';

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_2__["default"].getInstance().registerJobAdapter( DesignDataJobAdapter.ID, new DesignDataJobAdapter() );

/* harmony default export */ __webpack_exports__["default"] = (DesignDataJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ExportProjectJobAdapter.js":
/*!******************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ExportProjectJobAdapter.js ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);




const DOWNLOADS_PATH = 'downloads';

const EXTENSIONS_TYPE = { 1: 'cwz', 3: 'scz' };
class ExportProjectJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__["default"].EXPORT;
        this._objectName = undefined;
        this._projectType = undefined;
    }

    getJob( config ) {
        let job = super.getJob( config );
        let inputData = JSON.parse( job.getInputData() );

        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {
            filesPath: this.getOutputPath( config )
        } ) );
        return job;
    }

    setObjectName( name ) {
        this._objectName = name;
    }

    setProjectType( type ) {
        this._projectType = type;
    }

    getExportFileName() {
        return pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.cleanUpFileNameCharacters( `${this._objectName}.${EXTENSIONS_TYPE[this._projectType]}` );
    }
    getOutputPath() {
        return `${DOWNLOADS_PATH}/${this.getExportFileName()}`;
    }

    cloneType( jobAdapter ) {
        let copyJobAdapter = new ExportProjectJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );

        copyJobAdapter._objectName = jobAdapter._objectName;

        return copyJobAdapter;
    }

}

/* harmony default export */ __webpack_exports__["default"] = (ExportProjectJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/FeatureMetadataJobAdapter.js":
/*!********************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/FeatureMetadataJobAdapter.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var VectorJobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/VectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/VectorJobAdapter.js" );

/**
 *  FeatureMetadataJobAdapter Class
 *  @class
 *  @memberof pcvizJobs
 */
var FeatureMetadataJobAdapter = function () {
    VectorJobAdapter.call( this );
    this.setId( 'FMU' );

    this._extensions = [ 'xml', 'csv', 'txt' ];
    this._mandatoryDataFileExtension = [ 'csv', 'txt', 'xml' ];
    this._mandatoryFeatureFileExtension = [ 'xml', 'csv' ];
    this._acceptsPatterns = {}; // To allow using different names in txt files
    this._enabled = false;
};

FeatureMetadataJobAdapter.prototype = Utils.objectInherit( VectorJobAdapter.prototype, {

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = new FeatureMetadataJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );

        copyJobAdapter._geometryType = jobAdapter._geometryType;

        copyJobAdapter._metadataFiles = jobAdapter._metadataFiles;

        copyJobAdapter._formatType = jobAdapter._formatType;

        copyJobAdapter._version = jobAdapter._version;

        copyJobAdapter._converterOptions = Object.assign( {}, jobAdapter.getConverterOptions() );

        return copyJobAdapter;
    }


} );

// Register JobAdapter
var fmu = new FeatureMetadataJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( 'FMU', fmu );
module.exports = FeatureMetadataJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/GcpJobAdapter.js":
/*!********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/GcpJobAdapter.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/GisJobAdapter */ "./sources/pcvizJobs/JobAdapters/GisJobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");



class GcpJobAdapter extends pcvizJobs_JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();

        this.setId( 'GCP' );
        this._extensions = [ 'csv' ];
        this._dataTypes = [ {
            type: 'Gis:csv',
            ext: 'csv',
            format: 'GcpVectorLayer',
        }, ];
        this._maxFileCount = 1;
    }

    createJobAdapter() {
        return new GcpJobAdapter();
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this.getId(),
            id: 'GcpVectorLayer',
            label: 'GcpVectorLayer',
            fileType: 'GcpVectorLayer',
        }, ];
    }
}

const gcpJobAdapter = new GcpJobAdapter();

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"].getInstance().registerJobAdapter( gcpJobAdapter.getId(), gcpJobAdapter );

/* harmony default export */ __webpack_exports__["default"] = (GcpJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/GisJobAdapter.js":
/*!********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/GisJobAdapter.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var LayerDefinition = __webpack_require__( /*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var ObjectType = __webpack_require__( /*! pcvizGIS/ObjectType */ "./sources/pcvizGIS/ObjectType.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  GisJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var GisJobAdapter = function () {
    JobAdapter.call( this );
    this.setId( 'GISU' );

    this._layerType = 'VectorLayer';
    this._geometryType = 'Unknown';
    this._extensions = [ 'shp', 'shx', 'prj', 'dbf', 'kml', 'dxf', 'geojson', 'gml', 'csv' ];
    this._dataTypes = [ {
            type: 'Gis:shp',
            ext: 'shp',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:shp',
            ext: 'shx',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:shp',
            ext: 'prj',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:shp',
            ext: 'dbf',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:kml',
            ext: 'kml',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:dxf',
            ext: 'dxf',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:geojson',
            ext: 'geojson',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:gml',
            ext: 'gml',
            format: 'GisVectorLayer'
        },
        {
            type: 'Gis:csv',
            ext: 'csv',
            format: 'GisVectorLayer'
        }
    ];

    this._importerOptions = {};
    this.setRemoteProcessId( Process.GIS_PROCESS );

    this._objectType = ObjectType.LAYER;

    this._csvOptions = {
        ENZ: 'name;X;Y;Z',
        NEZ: 'name;Y;X;Z',
        XYZ: 'name;X;Y;Z;zone;date'
    };
};

GisJobAdapter.prototype = Utils.objectInherit( JobAdapter.prototype, {

    getGeometryType: function () {
        return this._geometryType;
    },

    getSupportedType: function ( fileName ) {
        var extFile = this.getExtension( fileName );
        var result = this._dataTypes.find( function ( type ) {
            return ( type.ext === extFile );
        } );
        return result;
    },

    findFile: function ( files, ext ) {
        var self = this;
        return ( files.find( function ( file ) {
            var extFile = self.getExtension( file.name );
            return ( ext === extFile );
        } ) );
    },

    detect: function ( files ) {
        var defer = P.defer();

        var out = this.detectImmediate( files );

        defer.resolve( out );
        return defer.promise;
    },

    detectImmediate: function ( files ) {
        var supported;
        for ( var i = 0; i < files.length; i++ ) {
            var file = files[ i ];
            supported = this.getSupportedType( file.name );
            if ( supported )
                break;
        }
        var out = [];
        if ( supported ) {
            out.push( {
                type: supported.type,
                format: supported.format
            } );
        }
        return out;
    },

    getFormatDefinitions: function () {
        return [ {
            uploaderName: this.getId(),
            id: 'GisVectorLayer',
            label: 'GisVectorLayer',
            fileType: 'GisVectorLayer'
        } ];
    },

    /**
      Method to verify if all requare files to upload and create a layer, are on the file list
    */
    areLayerFilesValid: function ( files ) {

        if ( !files || files.length === 0 ) {
            this._detectedType = undefined;
            return false;
        }

        var ext = this.getExtension( files[ 0 ].name );
        if ( ext === 'shp' || ext === 'shx' || ext === 'dbf' || ext === 'prj' ) { // it's a shapefile
            this._detectedType = 'Gis:shp';
            return ( this.findFile( files, 'shp' ) && this.findFile( files, 'shx' ) && this.findFile( files, 'dbf' ) );
        }

        var validFile = JobAdapter.prototype.isFileValid.call( this, files[ 0 ] );
        if ( validFile ) { // we assume the type is given by the first file
            var supportedType = this.getSupportedType( files[ 0 ].name );
            this._detectedType = supportedType.type;
        }
        return validFile;
    },

    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        if ( this._detectedType === 'Gis:csv' ) {
            this._category = this.getServerCategoryByName( VectorLayerUtils.Categories.CONTROL_POINT ).id; // We must use only system cats -> It is using only system cats because they are set from WizarUploadBoxController
            this._categoryString = VectorLayerUtils.Categories.CONTROL_POINT;
            this._geometryType = 'Point';
        }

        var layerDefinition = this.getBaseLayerDefinition( layer );
        layerDefinition.setLayerCategory( this._category );
        if ( layer.coordinateSystem ) {
            layerDefinition.setCoordinateSystem( layer.coordinateSystem );
        }

        // we don't know the attributes to add

        return layerDefinition.getJSONObject();
    },

    getBaseLayerDefinition: function ( layer ) {
        var layerDefinition = new LayerDefinition();
        layerDefinition.setName( layer.name );
        layerDefinition.setDescription( layer.description );
        layerDefinition.setLayerType( this.getLayerType() );
        layerDefinition.setLayerGeometryType( this.getGeometryType() );
        layerDefinition.setHorizProjectionEPSG( this.getDestCRS() );

        return layerDefinition;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        var inputData = JSON.parse( job.getInputData() );
        inputData.options = this._importerOptions;
        job.setInputData( JSON.stringify( inputData ) );
        var nameOption;
        if ( this._options.length )
            nameOption = this._options.find( ( opt ) => { return opt.name !== undefined; } );

        var newLayerName = nameOption ? nameOption.name : this.generateNewLayerName( inputData );
        job.setOutputData( JSON.stringify( {
            files: [ config.outputUUID + '.json' ],
            newLayerName: newLayerName
        } ) );

        return job;
    },

    generateNewLayerName: function ( inputData ) {
        if ( this._objectType === ObjectType.LAYER ) {
            return undefined;
        }
        return inputData.files[ 0 ].substring( inputData.files[ 0 ].indexOf( '/' ) + 1 );
    },

    createJobAdapter() {
        return new GisJobAdapter();
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = this.createJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );

        copyJobAdapter._options = jobAdapter._options;
        copyJobAdapter._geometryType = jobAdapter._geometryType;
        copyJobAdapter._dataTypes = jobAdapter._dataTypes;
        copyJobAdapter._extensions = jobAdapter._extensions;
        copyJobAdapter._renamedFileNameUUID = jobAdapter._renamedFileNameUUID;
        copyJobAdapter._importerOptions = Object.assign( {}, jobAdapter._importerOptions );

        return copyJobAdapter;
    },

    isFileValid: function ( file, extensions ) {
        if ( this._detectedType ) {
            var supportedType = this.getSupportedType( file.name );
            return supportedType && ( this._detectedType === supportedType.type );
        }

        return JobAdapter.prototype.isFileValid.call( this, file, extensions );
    },

    setImporterOptions: function ( options ) {
        this._importerOptions = options;
    },

    getImporterOptions: function () {
        return this._importerOptions;
    },

    getCsvOptions: function () {
        return this._csvOptions;
    },

    /**
     * This overrides parent method because the configuration panel is only visible for
     * DXF files.
     * TODO: Remove environment condition for version 2.0
     */
    canUseExtraPanels: function () {
        return ( this._detectedType === 'Gis:dxf' || this._detectedType === 'Gis:csv' );
    },

    setEnabled: function ( enabled ) {
        JobAdapter.prototype.setEnabled.call( this, enabled );
        this._objectType = ObjectType.LAYER;
    },

    overrideExtensions: function ( extensions ) {
        this._extensions = extensions.slice();
    }

} );

// Register JobAdapter
var glu = new GisJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( glu.getId(), glu );
module.exports = GisJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ImportZipProjectJobAdapter.js":
/*!*********************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ImportZipProjectJobAdapter.js ***!
  \*********************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizGIS/ObjectType */ "./sources/pcvizGIS/ObjectType.js");
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4__);






const IMPORT_ID = 'ImportZipProject';
const TYPE_BY_EXTENSION = { 'cwz': 1, 'scz': 3 };

class ImportZipProjectJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_2___default.a {
    constructor() {
        super();
        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_3__["default"].IMPORT;
        this._extensions = [ 'cwz', 'scz' ];
        this._mandatoryRules = [];

        this._maxFileCount = 1;
        this.setId( 'IZPA' );

        this._enabled = false;
        this._objectType = pcvizGIS_ObjectType__WEBPACK_IMPORTED_MODULE_0__["default"].PROJECT;

        this._limitTotalSize = 107374182400;
    }

    getJob( config ) {
        let job = super.getJob( config );
        let files = config.files.filter( ( file ) => [ 'cwz', 'scz' ].includes( this.getExtension( file ) ) );
        job.setInputData( JSON.stringify( {
            files
        } ) );

        return job;
    }

    getFormatDefinitions() {
        const warnings = pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4___default.a.isSite() ? [ `0_${IMPORT_ID}` ] : null;

        return [ {
            uploaderName: this._id,
            id: IMPORT_ID,
            label: IMPORT_ID,
            fileType: IMPORT_ID,
            warnings
        } ];
    }

    getExtensions() {
        return pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4___default.a.isSite() ? super.getExtensions().filter( extension => extension !== 'cwz' ) : super.getExtensions();
    }

    detect( files ) {
        let out = [];
        let result = {
            format: IMPORT_ID,
            type: IMPORT_ID,
            category: undefined,
            crs: undefined
        };
        out.push( result );

        files.forEach( ( file ) => {
            const ext = this.getExtension( file.name );
            this._projectType = TYPE_BY_EXTENSION[ ext ];

            if ( file.name.indexOf( '_-_' ) !== -1 ) {
                // This string appears before the date when the name is the one we set when exporting
                this._projectName = file.name.slice( 0, file.name.indexOf( '_-_' ) );
            } else {
                // If the project has a different name, remove only extension
                this._projectName = file.name.slice( 0, file.name.lastIndexOf( '.' ) );
            }

        } );

        return new Promise( ( resolve ) => {
            resolve( out );
        } );
    }

    cloneType( jobAdapter ) {
        var copyJobAdapter = new ImportZipProjectJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._projectType = jobAdapter._projectType;
        copyJobAdapter._projectName = jobAdapter._projectName;

        return copyJobAdapter;
    }

    areLayerFilesValid( files ) {
        if ( !files || !files.length ) {
            return false;
        }

        const extension = this.getExtension( files[ 0 ].name );

        return this._extensions.includes( extension );
    }

}

var importProjJobAdap = new ImportZipProjectJobAdapter();

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"].getInstance().registerJobAdapter( importProjJobAdap.getId(), importProjJobAdap );

/* harmony default export */ __webpack_exports__["default"] = (ImportZipProjectJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/JobAdapter.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/JobAdapter.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;

var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );
var Envelope = __webpack_require__( /*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js" ).default;

var Job = __webpack_require__( /*! pcvizJobs/Job */ "./sources/pcvizJobs/Job.js" ).default;
var Pipeline = __webpack_require__( /*! pcvizJobs/Pipeline */ "./sources/pcvizJobs/Pipeline.js" ).Pipeline;

/**
 *  JobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var JobAdapter = function () {
    this._crs = undefined;
    this._destCrs = undefined;
    this._category = undefined;
    this._formatType = undefined;
    this._extent = undefined;
    this._layerType = undefined;
    this._detectedType = undefined;
    this._isFinal = false;
    this._extensions = [];
    this._acceptsPatterns = undefined;

    this._maxFileCount = undefined;

    this._id = undefined;
    this._jobId = undefined;
    this._remoteProcessId = 0;
    this._setByUser = false;
    this._categoryList = [];
    this._options = [];
    this._processingOptions = undefined;

    this._enabled = true;

    this._version = 1;

    this._objectType = undefined;

    this._maximumFileSize = Number.MAX_VALUE;
    this._limitTotalSize = undefined;
};

JobAdapter.PROCESS_CACHE_PATH_PREFIX = 'process_data/cache';

JobAdapter.prototype = {
    setId: function ( id ) {
        this._id = id;
    },

    getId: function () {
        return this._id;
    },

    setProjectVersion: function ( version ) {
        this._version = version;
    },

    setCRS: function ( crs ) {
        this._crs = crs;
    },

    getCRS: function () {
        return this._crs;
    },

    setDestCRS: function ( destCrs ) {
        this._destCrs = destCrs;
    },

    getDestCRS: function () {
        return this._destCrs;
    },

    setCategory: function ( category ) {
        this._category = category;
    },

    getCategory: function () {
        return this._category;
    },

    getCategoryString: function () {
        return this._categoryString;
    },

    setCategoryString: function ( categoryName ) {
        this._categoryString = categoryName;
    },

    setFormatType: function ( formatType ) {
        this._formatType = formatType;
    },

    setIsFinal: function ( isFinal ) {
        this._isFinal = isFinal;
    },

    getDetectedType() {
        return this._detectedType;
    },

    getFormatType: function () {
        return this._formatType;
    },

    setExtent: function ( extent ) {
        this._extent = extent;
    },

    getExtent: function () {
        return this._extent;
    },

    getMaximumFileCount() {
        return this._maxFileCount;
    },

    setLayerType: function ( layerType ) {
        this._layerType = layerType;
    },
    getLayerType: function () {
        return this._layerType;
    },

    setRemoteProcessId: function ( remoteProcessId ) {
        this._remoteProcessId = remoteProcessId;
    },

    getRemoteProcessId: function () {
        return this._remoteProcessId;
    },

    setEnabled: function ( enabled ) {
        this._enabled = enabled;
    },

    isEnabled: function () {
        return this._enabled;
    },

    detect: function () {},

    getJobId: function () {
        return this._jobId;
    },

    setJobId: function ( jobId ) {
        this._jobId = jobId;
    },

    getConfigFile: function ( config ) {
        if ( config === undefined )
            config = {};
        config.jobId = this.getJobId();
        config[ 'crs' ] = this.getCRS();
        if ( config[ 'crs' ] && !config[ 'crs' ].startsWith( 'EPSG:' ) )
            config[ 'crs' ] = undefined;
        config[ 'processType' ] = this.getLayerType();
        return config;
    },

    getExtension: function ( fileName ) {
        return ( fileName.substring( fileName.lastIndexOf( '.' ) + 1 ).toLowerCase() );
    },

    getJob: function ( config ) {
        let files = config.files ? config.files.slice().sort() : undefined;
        var job = new Job();
        job.setProcessId( this.getRemoteProcessId() );
        job.setName( config.jobName );
        job.setInput( config.catalogId );
        job.setOutput( config.catalogId );
        job.setInputData( JSON.stringify( {
            crs: config.crs,
            files: files,
            fileSizes: config.fileSizes
        } ) );
        job.setOutputData( JSON.stringify( {} ) );

        return job;
    },

    getPipelineProcessData: function ( config, pipelineType ) {

        var pipeline = new Pipeline( pipelineType );
        pipeline.setName( config.jobName );
        pipeline.setInput( config.catalogId );
        pipeline.setOutput( config.catalogId );

        return pipeline;
    },

    getCreateProjectJob: function ( config ) {
        var job = new Job();
        job.setProcessId( Process.CREATE_PROJECT );
        job.setName( config.jobName );
        job.setInput( config.catalogId );
        job.setOutput( config.catalogId );
        job.setInputData( JSON.stringify( config.project ) );
        job.setOutputData( JSON.stringify( {} ) );

        return job;
    },

    getCompleteJob: function ( config ) {
        if ( !config.project )
            return this.getJob( config );

        var pipeline = this.getPipelineProcessData( config, 'sequential' );

        pipeline.addJob( this.getJob( config ) );
        pipeline.addJob( this.getCreateProjectJob( config ) );
        return pipeline;
    },


    acceptFile: function ( extension ) {
        if ( !this.isEnabled() )
            return;
        var find = this._extensions.find( function ( ext ) {
            return ( ext === extension );
        } );

        return find;
    },


    isFileValid: function ( file, extensions ) {
        if ( !extensions )
            extensions = this._extensions;
        var ext = this.getExtension( file.name );

        var found = extensions && extensions.some( function ( extension ) {
            return ext === extension;
        } );
        if ( !found || !this._acceptsPatterns )
            return found;
        if ( this._acceptsPatterns[ ext ] ) {
            found = file.name.indexOf( this._acceptsPatterns[ ext ] ) !== -1;
        }
        return found;
    },

    getExtensions: function () {
        return this._extensions;
    },

    getOptions: function () {
        return this._options;
    },

    /**
      Method to verify if all requare files to upload and create a pointCloud layer, are on the file list
    */
    areLayerFilesValid: function ( files ) {
        if ( files === undefined || !files.length )
            return false;

        var result = true;
        for ( var i = 0; i < files.length; i++ ) {
            var file = files[ i ];
            var fileExt = this.getExtension( file.name );
            var rule = this.getRuleForFileExtension( fileExt );
            if ( rule ) {
                result = result && this.existMandatoryFile( rule.mandatory, files );
            }
        }

        return result;
    },

    /**
      find a rule on the mandatoryRules array of the LayerType
    */
    getRuleForFileExtension: function ( ruleExt ) {
        var rule;
        for ( var i = 0; i < this._mandatoryRules.length; i++ ) {
            rule = this._mandatoryRules[ i ];
            for ( var j = 0; j < rule.extension.length; j++ ) {
                if ( rule.extension[ j ] === ruleExt ) {
                    return rule;
                }
            }
        }
        return;
    },

    existMandatoryFile: function ( mandatoryFiles, files ) {
        var self = this;
        var foundFile = files.find( function ( file ) {
            return self.isMandatory( file, mandatoryFiles );
        } );
        return ( foundFile !== undefined );
    },

    isMandatory: function ( file, mandatoryExtArray ) {
        var ext = this.getExtension( file.name );
        var out = false;
        for ( var i = 0; i < mandatoryExtArray.length; i++ ) {
            out = out | ( ext === mandatoryExtArray[ i ] );
        }
        return out;
    },

    getObjectType: function () {
        return this._objectType;
    },

    setObjectType: function ( objectType ) {
        this._objectType = objectType;
    },

    getLayerDefinition: function ( /*layerName, layerDescription*/) {},

    createJobAdapter: function () {
        throw 'JobAdapter: createJobAdapter not implemented';
    },

    cloneType: function ( /*jobAdapter*/) {
        throw 'JobAdapter: cloneType not implemented';
    },

    copyBaseData: function ( ori, dest ) {
        if ( ori === undefined || dest === undefined )
            return;
        var extent = ori._extent ? ori._extent : new Envelope();
        dest._remoteProcessId = ori._remoteProcessId;
        dest._crs = ori._crs;
        dest._destCrs = ori._destCrs;
        dest._category = ori._category;

        dest._categoryString = ori._categoryString;
        dest._fileType = ori._fileType;
        dest._detectedType = ori._detectedType;
        dest._extent = new Envelope( extent._minX, extent._maxX, extent._minY, extent._maxY, extent._minZ, extent._maxZ );
        dest._layerType = ori._layerType;
        dest._processingOptions = ori._processingOptions;
        dest._jobId = ori._jobId;
        dest._version = ori._version;
        dest._objectType = ori._objectType;

        return dest;
    },

    readFile: function ( file, name ) {
        var defer = P.defer();
        var reader = new FileReader();

        reader.onload = function ( /*e*/) {
            defer.resolve( {
                file: reader.result,
                fileName: name
            } );
        };

        reader.readAsText( file );

        return defer.promise;
    },

    /**
      find the importer and load the file
    */
    getImporterAndFile: function ( file ) {
        var defer = P.defer();
        this.readFile( file, file.name ).then( function ( data ) {
            var out = {
                'importer': ImporterRegistry.getInstance().getImporterFromData( file.name, data.file ),
                'file': data
            };
            if ( out.importer ) {
                defer.resolve( out );
            } else {
                defer.reject( file );
            }
        }, function () {
            defer.reject();
        } );
        return defer.promise;
    },

    getFormatDefinitions: function () {
        throw 'JobAdapter: getFormatDefinitions not implemented';
    },

    isSetByUser: function () {
        return this._setByUser;
    },

    setByUser: function ( value ) {
        this._setByUser = value;
    },

    setServerCategoryList: function ( categoryList ) {
        this._categoryList = categoryList;
    },

    getServerCategoryByName: function ( name ) {
        if ( this._categoryList.length === 0 ) return;

        var category = this._categoryList.find( function ( element ) {
            return ( element.name === name );
        } );

        return category;
    },

    prepareCatalogObjects: function ( /*layers*/) {},

    setProcessingOptions: function ( options ) {
        this._processingOptions = options;
    },
    computeName: function ( /*config*/) {},

    getProcessCachePath: function ( path ) {
        if ( path === undefined )
            path = '';
        return JobAdapter.PROCESS_CACHE_PATH_PREFIX + '/' + path;
    },

    getMaximumFileSize: function () {
        return this._maximumFileSize;
    },

    getLimitTotalSize: function () {
        return this._limitTotalSize;
    },

    // true in the specific jobAdapters as sub classes
    hasCost: function () {
        return false;
    }
};

module.exports = JobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/Model3D3MXVectorJobAdapter.js":
/*!*********************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/Model3D3MXVectorJobAdapter.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Model3DVectorJobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/Model3DVectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/Model3DVectorJobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;

var CONTEXT_CAPTURE_3MX_ID = 'ContextCapture3MXVectorLayer';

var Model3D3MXVectorJobAdapter = function () {
    Model3DVectorJobAdapter.call( this );
    this.setId( '3MXVLU' );
    this._extensions = [ '3mx', 'zip' ];
    this._mandatoryRules = [ {
        extension: [ 'zip' ],
        mandatory: [ '3mx', 'zip' ]
    } ];

    this.setRemoteProcessId( Process.OBJ_PROCESS );
    this._formatId = CONTEXT_CAPTURE_3MX_ID;
    this._typeId = CONTEXT_CAPTURE_3MX_ID;
};

Model3D3MXVectorJobAdapter.prototype = Utils.objectInherit( Model3DVectorJobAdapter.prototype, {

    getFormatDefinitions: function () {
        return [ {
            uploaderName: CONTEXT_CAPTURE_3MX_ID,
            id: CONTEXT_CAPTURE_3MX_ID,
            label: CONTEXT_CAPTURE_3MX_ID,
            fileType: CONTEXT_CAPTURE_3MX_ID
        } ];
    },

    createJobAdapter: function () {
        return new Model3D3MXVectorJobAdapter();
    },

    getOutputFilesPath: function () {
        return [ '3d_models/' ];
    },

} );

// Register JobAdapter
var m3D3MXVLU = new Model3D3MXVectorJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( m3D3MXVLU.getId(), m3D3MXVLU );
module.exports = Model3D3MXVectorJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/Model3DVectorJobAdapter.js":
/*!******************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/Model3DVectorJobAdapter.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Envelope = __webpack_require__( /*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js" ).default;
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var VectorJobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/VectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/VectorJobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var MODEL3D_ID = 'Model3DVectorLayer';

/**
 *  Model3DVectorJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var Model3DVectorJobAdapter = function () {
    VectorJobAdapter.call( this );
    this.setId( 'M3DVLU' );
    this._crs = undefined;
    this._destCrs = undefined;
    this._category = undefined;
    this._extent = undefined;

    this._layerType = 'VectorLayer';
    this._geometryType = 'MultiPoint';
    this._extensions = [ 'json', 'zip' ];
    this._mandatoryRules = [ {
        extension: [ 'zip' ],
        mandatory: [ 'json', 'zip' ]
    } ];

    this.setRemoteProcessId( Process.C3DTILES_PROCESS );
    this._options = [];
    this._formatId = MODEL3D_ID;
    this._typeId = MODEL3D_ID;
};

Model3DVectorJobAdapter.prototype = Utils.objectInherit( VectorJobAdapter.prototype, {

    detect: function ( files ) {
        var defer = P.defer();
        var self = this;
        var out = [];
        var result = {
            format: this._formatId,
            type: this._typeId,
            category: this.getServerCategoryByName( VectorLayerUtils.Categories.MODEL3D ).id, // We must use only system cats -> It is using only system cats because they are set from WizarUploadBoxController
            categoryString: VectorLayerUtils.Categories.MODEL3D,
            oriCRS: ''
        };
        out.push( result );
        // read json file and determine the dest crs
        for ( var i = 0; i < files.length; i++ ) {
            var file = files[ i ];
            var ext = this.getExtension( file.name );
            if ( ext === 'json' ) {
                result[ 'baseFile' ] = file;
                break;
            }
        }
        if ( result.baseFile === undefined ) {
            defer.resolve( out );
            return defer.promise;
        }
        var reader = new FileReader();
        reader.onload = function () {
            var object = JSON.parse( reader.result );
            var bounding = object.root.boundingVolume.sphere;

            if ( !CRSUtils.isEcefPoint( bounding[ 0 ], bounding[ 1 ], bounding[ 2 ] ) ) {
                defer.resolve( out );
                return;
            }
            result.oriCRS = 'EPSG:4978';

            var p = CRSUtils.transform( result.oriCRS, CRSUtils.WGS_84, [ bounding[ 0 ], bounding[ 1 ], bounding[ 2 ] ] );
            result.destCRS = 'EPSG:' + CRSUtils.latLonToEPSG( p[ 1 ], p[ 0 ] );

            var epsgDestNum = result.destCRS.substring( result.destCRS.lastIndexOf( ':' ) + 1 );

            CRSUtils.getProjectionInfo( epsgDestNum, CRSUtils.FORMAT.PROJ4 ).then( function ( epsgDef ) {
                CRSUtils.defProj4( result.destCRS, epsgDef );

                var destPoint = CRSUtils.transform( result.oriCRS, result.destCRS, [ bounding[ 0 ], bounding[ 1 ], bounding[ 2 ] ] );
                var extent = new Envelope();
                extent.setMinX( destPoint[ 0 ] - bounding[ 3 ] );
                extent.setMinY( destPoint[ 1 ] - bounding[ 3 ] );
                extent.setMinZ( destPoint[ 2 ] - bounding[ 3 ] );
                extent.setMaxX( destPoint[ 0 ] + bounding[ 3 ] );
                extent.setMaxY( destPoint[ 1 ] + bounding[ 3 ] );
                extent.setMaxZ( destPoint[ 2 ] + bounding[ 3 ] );
                self.setExtent( extent );

                defer.resolve( out );
            } );
        };
        reader.readAsText( result.baseFile );
        return defer.promise;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        job.setInputData( JSON.stringify( {
            crs: config.crs,
            files: config.files,
            fileSizes: config.fileSizes
        } ) );
        job.setOutputData( JSON.stringify( {
            outputFilesPath: this.getOutputFilesPath( config )
        } ) );
        return job;
    },

    getOutputFilesPath: function ( /*config*/) {
        return [ 'model3d/' ];
    },

    /**
      Method to verify if all requare files to upload and create a UAV layer, are on the file list
    */
    areLayerFilesValid: function ( files ) {
        var mandatoryFileExtension = this._mandatoryRules[ 0 ].mandatory;
        if ( files === undefined || !files.length )
            return false;

        if ( files.length !== 2 )
            return false;

        var valid = [ false, false ];
        for ( var i = 0; i < mandatoryFileExtension.length; i++ ) {
            var ext = mandatoryFileExtension[ i ];
            for ( var j = 0; j < files.length; j++ ) {
                var file = files[ j ];
                var extFile = this.getExtension( file.name );
                if ( ext === extFile )
                    valid[ i ] = true;
            }
        }

        var out = true;
        valid.forEach( function ( element ) {
            out = out & element;
        } );

        return out;
    },


    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        if ( !this._category ) {
            this._category = this.getServerCategoryByName( VectorLayerUtils.Categories.MODEL3D ).id; // read comment about categories above

            this._categoryString = VectorLayerUtils.Categories.MODEL3D;
        }
        var layerDefinition = this.getBaseLayerDefinition( layer );
        layerDefinition.setExtent( this.getExtent() );

        var attributes = [];
        var attributeFileName = {
            'name': 'file_name',
            'type': 'TextField',
            'editable': 0,
            'order': 13,
            'visible': 0
        };
        var attributeRootBounds = {
            'name': 'rootBounds',
            'type': 'TextField',
            'editable': 0,
            'order': 14,
            'visible': 0
        };
        attributes.push( attributeFileName );
        attributes.push( attributeRootBounds );
        attributes.forEach( function ( att ) {
            layerDefinition.addAttribute( att.name, att.type, att.editable, att.order, att.visible );
        } );

        return layerDefinition.getJSONObject();
    },

    createJobAdapter: function () {
        return new Model3DVectorJobAdapter();
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = this.createJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );

        copyJobAdapter._geometryType = jobAdapter._geometryType;

        return copyJobAdapter;
    },

    getFormatDefinitions: function () {
        return [ {
            uploaderName: MODEL3D_ID,
            id: MODEL3D_ID,
            label: MODEL3D_ID,
            fileType: MODEL3D_ID
        } ];
    },

    isFileValid: function ( file, extensions ) {
        return JobAdapter.prototype.isFileValid.call( this, file, extensions );
    }
} );


// Register JobAdapter
var m3DVLU = new Model3DVectorJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( m3DVLU.getId(), m3DVLU );
module.exports = Model3DVectorJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ObjJobAdapter.js":
/*!********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ObjJobAdapter.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var LayerDefinition = __webpack_require__( /*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js" ).default;
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var OBJ_ID = 'ObjVectorLayer';

/**
 *  ObjJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var ObjJobAdapter = function () {
    JobAdapter.call( this );
    this.setId( 'OBJU' );
    this._layerType = LayerType.VECTOR;
    this._geometryType = 'MultiPoint';
    this._extensions = [ 'obj', 'fbx', '3ds', 'jpg', 'jpeg', 'mtl', 'png', 'xml', 'xyz' ];
    this._mandatoryDataFileExtension = [ 'obj', 'fbx', '3ds' ];
    this._mandatoryRules = [ {
        extension: [ 'jpg', 'jpeg', 'png' ],
        mandatory: [ 'obj', 'fbx', '3ds' ]
    }, {
        extension: [ 'mtl', 'xyz' ],
        mandatory: [ 'obj' ]
    }, {
        extension: [ 'xml' ],
        mandatory: [ 'obj', 'fbx', '3ds' ]
    }, ];

    this.setRemoteProcessId( Process.OBJ_PROCESS );
    this._converterOptions = {
        'ScaleFactor': 1
    };

    this._objectType = 'layers';

    this._maximumFileSize = 400 * 1049000; // Maximum file size for earch file --> 400 MB
};

ObjJobAdapter.prototype = Utils.objectInherit( JobAdapter.prototype, {

    detect: function () {
        var defer = P.defer();
        var out = [];
        var result = {
            format: OBJ_ID,
            type: OBJ_ID,
            category: this.getServerCategoryByName( VectorLayerUtils.Categories.MODEL3D ).id, // We must use only system cats -> It is using only system cats because they are set from WizarUploadBoxController
            categoryString: VectorLayerUtils.Categories.MODEL3D,
            crs: undefined
        };
        out.push( result );
        defer.resolve( out );
        return defer.promise;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        var files = config.files;
        var extraFiles = [];
        for ( var i = files.length - 1; i >= 0; i-- ) {
            if ( this._mandatoryDataFileExtension.indexOf( this.getExtension( files[ i ] ) ) === -1 ) {
                extraFiles.push( files[ i ] );
                files.splice( i, 1 );
            }
        }
        var inputData = JSON.parse( job.getInputData() );
        inputData.files = files;
        inputData.extraFiles = extraFiles;
        inputData.options = this._converterOptions;
        job.setInputData( JSON.stringify( inputData ) );
        return job;
    },

    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        if ( !this._category ) {
            this._category = this.getServerCategoryByName( VectorLayerUtils.Categories.MODEL3D ).id; // read comment about categories above

            this._categoryString = VectorLayerUtils.Categories.MODEL3D;
        }
        var layerDefinition = new LayerDefinition();
        layerDefinition.setName( layer.name );
        layerDefinition.setDescription( layer.description );
        layerDefinition.setLayerType( this.getLayerType() );
        layerDefinition.setLayerCategory( this.getCategory() );
        layerDefinition.setLayerGeometryType( this._geometryType );
        layerDefinition.setHorizProjectionEPSG( this.getDestCRS() );

        return layerDefinition.getJSONObject();
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = new ObjJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._converterOptions = Object.assign( {}, jobAdapter._converterOptions );

        return copyJobAdapter;
    },

    getFormatDefinitions: function () {
        return [ {
            uploaderName: this._id,
            id: OBJ_ID,
            label: OBJ_ID,
            fileType: OBJ_ID
        } ];
    },

    getOutputFilesPath: function () {
        return [ '3d_models/' ];
    },

    setConverterOptions: function ( options ) {
        this._converterOptions = options;
    },

    getConverterOptions: function () {
        return this._converterOptions;
    }
} );

// Register JobAdapter
var objlu = new ObjJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( objlu.getId(), objlu );
module.exports = ObjJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/PointCloudJobAdapter.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/PointCloudJobAdapter.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var PointCloudLayer = __webpack_require__( /*! pcvizGIS/PointCloudLayer */ "./sources/pcvizGIS/PointCloudLayer.js" ).default;
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  PointCloudJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var PointCloudJobAdapter = function () {
    JobAdapter.call( this );
    this.setId( 'PCU' );
    this._layerType = LayerType.POINTCLOUD;
    this._extensions = [ 'las', 'laz', 'e57', 'pts', 'xyz', 'txt', 'ptx', 'clr', 'cl3', 'ij', 'alg' ];
    this._mandatoryDataFileExtension = [ 'las', 'laz', 'e57', 'pts', 'xyz', 'ptx', 'clr', 'cl3', 'ij', 'alg' ];
    this._mandatoryRules = [ {
        extension: [ 'ij', 'alg' ],
        mandatory: [ 'cl3' ]
    } ];

    this.setRemoteProcessId( Process.POINTCLOUD_PROCESS );

    this._objectType = 'layers';
};

PointCloudJobAdapter.prototype = Utils.objectInherit( JobAdapter.prototype, {

    detect: function () {
        var defer = P.defer();
        var out = [];
        var result = {
            format: LayerType.POINTCLOUD,
            type: LayerType.POINTCLOUD,
            category: undefined,
            crs: undefined
        };
        out.push( result );
        defer.resolve( out );
        return defer.promise;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        var inputData = JSON.parse( job.getInputData() );
        inputData.fileSizes = config.fileSizes;
        inputData.options = this._processingOptions;
        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {
            files: [ config.outputUUID + '/' + config.outputUUID + '.plfmz' ],
        } ) );
        return job;
    },


    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        var layerDefinition = {
            name: layer.name,
            description: layer.description,
            horizProjectionEPSG: this.getCRS()
        };
        layerDefinition.layerType = this.getLayerType();

        if ( !this._processingOptions )
            return layerDefinition;

        var symbolizer = PointCloudLayer.buildDefaultSymbolizer();
        symbolizer.lightOn = this._processingOptions && this._processingOptions.bestsampling;
        layerDefinition.configuration = {
            name: layer.name,
            style: {
                symbolizers: {
                    PointCloudSymbolizer: symbolizer
                }
            }
        };

        return layerDefinition;
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = new PointCloudJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        return this.copyBaseData( jobAdapter, copyJobAdapter );
    },

    getFormatDefinitions: function () {
        return [ {
            uploaderName: this._id,
            id: LayerType.POINTCLOUD,
            label: LayerType.POINTCLOUD,
            fileType: LayerType.POINTCLOUD
        } ];
    }
} );
// Register JobAdapter
var pclu = new PointCloudJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( pclu.getId(), pclu );
module.exports = PointCloudJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/RasterJobAdapter.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/RasterJobAdapter.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  PointCloudJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var RasterJobAdapter = function () {
    JobAdapter.call( this );
    this.setId( 'RU' );
    this._layerType = LayerType.RASTER;
    // TBD, not exactly sure all raster types
    this._extensions = [ 'tiff', 'jpg', 'tif', 'pdf' ];
    this._mandatoryDataFileExtension = [ 'tiff', 'jpg', 'tif', 'pdf' ];
    this._mandatoryRules = [ {
        extension: [],
        mandatory: []
    } ];

    this.setRemoteProcessId( Process.RASTER );

    this._objectType = 'layers';
};

RasterJobAdapter.prototype = Utils.objectInherit( JobAdapter.prototype, {

    detect: function ( files ) {
        var crs;

        var defer = P.defer();
        var out = [];
        window.GeoTIFF.fromBlob( files[ 0 ] )
            .then( tiff => {
                tiff.getImage().then( image => {
                    //   $scope.panel.scope.crs = image.geoKeys.ProjectedCSTypeGeoKey;
                    crs = 'EPSG:' + image.geoKeys.ProjectedCSTypeGeoKey;

                    /*  $scope.searchCrs( image.geoKeys.ProjectedCSTypeGeoKey ).then( ( results ) => {
                          $scope.panel.scope.crs = results.results[ 0 ][ 'name' ];
                      } );
                      $scope.$applyAsync();*/
                    var result = {
                        format: LayerType.RASTER,
                        type: LayerType.RASTER,
                        category: undefined,
                        crs: crs,
                        oriCRS: crs
                    };
                    out.push( result );
                    defer.resolve( out );
                } );
            } ).catch( () => {

                console.error( 'GeoTIFF can not read this file' );

                var result = {
                    format: LayerType.RASTER,
                    type: LayerType.RASTER,
                    category: undefined,
                    crs: undefined,
                    oriCRS: undefined
                };
                out.push( result );
                defer.resolve( out );
            } );


        return defer.promise;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        var inputData = JSON.parse( job.getInputData() );
        inputData.fileSizes = config.fileSizes;
        inputData.options = {
            'InputsFilter': '(.tif|.tiff|.TIF|.TIFF|.jpg|.jpeg|.JPG|.JPEG|.pdf)$',
            'GenerateSinglePyramid': 'raster.vrt'
        };
        job.setInputData( JSON.stringify( inputData ) );
        return job;
    },


    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        var layerDefinition = {
            name: layer.name,
            description: layer.description,
            horizProjectionEPSG: this.getCRS(),
            source: '/tiles/raster.vrt.planarimage/', // This is to have the layer complete, and also to try to render it
            sourceType: 'CWXYZ' // OpenLayers id for TMS  is XYZ, in order to know that is our format we use CWXYZ
        };
        layerDefinition.layerType = this.getLayerType();

        // for now there's no configuration

        return layerDefinition;
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = new RasterJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        return this.copyBaseData( jobAdapter, copyJobAdapter );
    },

    getFormatDefinitions: function () {
        return [ {
            uploaderName: this._id,
            id: LayerType.RASTER,
            label: LayerType.RASTER,
            fileType: LayerType.RASTER
        } ];
    }
} );
// Register JobAdapter
var ru = new RasterJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( ru.getId(), ru );
module.exports = RasterJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ScanProjectJobAdapter.js":
/*!****************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ScanProjectJobAdapter.js ***!
  \****************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5__);







const JOB_TYPES = {
    'ImportProject': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].IMPORT_SCAN_PROJECT,
    'ProcessScan': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_PROCESSING,
    'RegisterOccBsProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].OCCBS_REGISTRATION,
    'RegisterByRefsProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].RESECTION_REGISTRATION,
    'RegisterC2CProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].C2C_REGISTRATION,
    'ExportScans': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].EXPORT_SCANS,
    'CERegisterOccBsProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].CE_OCCBS_REGISTRATION,
    'CERegisterByRefsProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].CE_RESECTION_REGISTRATION,
    'UpgradeSparse': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].UPDATE_SPARSE,
    'MergeScansProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_COMMON_PROCESS,
    'TinProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_DELIVERABLES,
    'VolumeProcess': pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_DELIVERABLES
};

const ZIP_TEMP_PATH = 'downloads';

class ScanProjectJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this.setId( ScanProjectJobAdapter.ID );

        this._extensions = [ 'zip' ];
        this._mandatoryDataFileExtension = [ 'zip' ];
        this._mandatoryRules = [];

        this._maxFileCount = 1;

        this._objectType = 'projects';
        this.setRemoteProcessId( pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].IMPORT_SCAN_PROJECT ); // default

        this._scans = undefined;
        this._workspaceProjectEnabled = false;
        this._unselectedElements = undefined;
        this._workspaceImportPath = undefined;

        this._extraInputData = undefined;
        this._extraOutputData = undefined;

        this._outputFormats = undefined;
        this._formatOptions = undefined;

        this._outputFolder = ZIP_TEMP_PATH;
    }

    setJobType( jobType ) {
        if ( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getController( 'UserPreferences' ).getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.REGIST_ALGO_VER_KEY ) === pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_5___default.a.NEW_ALGORITHMS )
            jobType = JOB_TYPES[ 'CE' + jobType ] !== undefined ? 'CE' + jobType : jobType;

        this.setRemoteProcessId( JOB_TYPES[ jobType ] );
    }

    setScans( scans ) {
        this._scans = scans;
    }

    getScansUUIDs() {
        if ( !this._scans ) {
            return;
        }
        return this._scans.map( scan => scan.uuid );
    }

    getScans() {
        return this._scans;
    }

    setOutputFormats( formats ) {
        this._outputFormats = formats;
    }

    getOutputFormats() {
        return this._outputFormats;
    }

    setFormatOptions( options ) {
        this._formatOptions = options;
    }

    getFormatOptions() {
        return this._formatOptions;
    }

    getWorkspaceImportPath() {
        return this._workspaceImportPath;
    }

    setWorkspaceImportPath( importPath ) {
        this._workspaceImportPath = importPath;
    }

    setUnselectedElements( unselectedElements ) {
        this._unselectedElements = unselectedElements;
    }

    getUnselectedElements() {
        return this._unselectedElements;
    }

    setOptions( options ) {
        this._options = options;
    }

    setExtraInputData( extraInputData ) {
        this._extraInputData = extraInputData;
    }
    setExtraOutputData( extraOutputData ) {
        this._extraOutputData = extraOutputData;
    }

    detect() {
        return new Promise( ( resolve ) => {
            let out = [];
            let result = {
                format: ScanProjectJobAdapter.SCAN_PROJECT_ID,
                type: ScanProjectJobAdapter.SCAN_PROJECT_ID,
                category: undefined,
                crs: undefined
            };
            out.push( result );
            resolve( out );
        } );
    }

    getFormatDefinitions() {
        return [ {
            uploaderName: this._id,
            id: ScanProjectJobAdapter.SCAN_PROJECT_ID,
            label: ScanProjectJobAdapter.SCAN_PROJECT_ID,
            fileType: ScanProjectJobAdapter.SCAN_PROJECT_ID
        } ];
    }

    getJob( config ) {
        let job = super.getJob( config );
        let inputData = JSON.parse( job.getInputData() );
        inputData[ 'workspace' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_FILE_PATH;
        inputData[ 'workspaceProcess' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_PROCESS_FILE_PATH;
        if ( this._workspaceProjectEnabled ) {
            inputData[ 'workspaceProject' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_PROJECT_FILE_PATH;
        }
        inputData[ 'projectPath' ] = 'process/scan_project';
        inputData[ 'workspaceImportPath' ] = this.getWorkspaceImportPath();
        inputData[ 'scans' ] = this.getScansUUIDs();
        if ( this._extraInputData ) {
            Object.assign( inputData, this._extraInputData );
        }
        Object.assign( inputData, this._options );
        let outputData = {};
        if ( this._remoteProcessId === pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].EXPORT_SCANS ) {
            if ( config.selections.length > 0 ) {
                inputData[ 'selections' ] = config.selections;
            }
            inputData[ 'outputFormats' ] = this._outputFormats;
            Object.assign( inputData, this._formatOptions );

            outputData = {
                'zip': {
                    'output': this.getOutputPath( config )
                }
            };
        } else {
            outputData = {
                'workspace': pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_3___default.a.WORKSPACE_FILE_PATH,
                'scans': this.configureOutputScans()
            };
            if ( this._extraOutputData ) {
                Object.assign( outputData, this._extraOutputData );
            }
        }
        job.setOutputData( JSON.stringify( outputData ) );

        job.setInputData( JSON.stringify( inputData ) );
        return job;
    }

    configureOutputScans() {
        if ( !this._scans ) {
            return;
        }

        let outputPaths = {};

        if ( this._options.processPointcloud )
            for ( let scan of this._scans ) {
                // Check this because there are scans without children layers.
                if ( !scan.children )
                    continue;
                let pointcloudLayer = scan.children.find( child => child.category === 'PointCloud' );
                // Check if there is a pointcloud layer (Some scans only have panoramas)
                if ( pointcloudLayer )
                    outputPaths[ scan.uuid ] = {
                        plfmz: '/catalog/collage/layers/' + pointcloudLayer.catalogObjectId + '/',
                        tttl: '/catalog/collage/layers/' + pointcloudLayer.catalogObjectId + '/',
                        // TODO: panoramas: configura panoramas
                    };
            }

        return outputPaths;
    }

    cloneType( jobAdapter ) {
        var copyJobAdapter = new ScanProjectJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._workspaceProjectEnabled = jobAdapter._workspaceProjectEnabled;
        copyJobAdapter._workspaceImportPath = jobAdapter._workspaceImportPath;
        // uncomment if needed copyJobAdapter._extraInputData = jobAdapter._extraInputData;
        return copyJobAdapter;
    }

    enableWorkspaceProject( enabled = true ) {
        this._workspaceProjectEnabled = enabled;
    }

    setOuputFolder( folderName ) {
        this._outputFolder = folderName;
    }

    getOutputPath( config ) {
        return `${this._outputFolder}/${this.getZipFileName( config )}`;
    }

    getZipFileName( config ) {
        return `${config.zipName || config.jobName}.zip`;
    }

    hasCost() {
        return this._remoteProcessId === pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_2__["default"].SCAN_PROCESSING;
    }
}

ScanProjectJobAdapter.ID = 'SPA';
ScanProjectJobAdapter.SCAN_PROJECT_ID = 'ScanProject';

pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"].getInstance().registerJobAdapter( ScanProjectJobAdapter.ID, new ScanProjectJobAdapter() );

/* harmony default export */ __webpack_exports__["default"] = (ScanProjectJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/SyncJobAdapter.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/SyncJobAdapter.js ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__);





class SyncJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {

    constructor() {
        super();

        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__["default"].SYNC_PROJECT;
        this._workspaceProjectEnabled = false;
    }

    setAction( action ) {
        this._action = action;
    }

    getJob( config ) {
        const job = super.getJob( config );

        // input data
        const inputData = JSON.parse( job.getInputData() );
        inputData[ 'workspace' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.WORKSPACE_FILE_PATH;

        // set job data
        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {} ) );

        return job;
    }

    enableWorkspaceProject( enabled = true ) {
        this._workspaceProjectEnabled = enabled;
    }

}

/* harmony default export */ __webpack_exports__["default"] = (SyncJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/VectorJobAdapter.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/VectorJobAdapter.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var JobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js" );
var JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
var LayerDefinition = __webpack_require__( /*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js" ).default;
var Process = __webpack_require__( /*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js" ).default;
var ImporterRegistry = __webpack_require__( /*! pcvizDataAccess/ImporterRegistry */ "./sources/pcvizDataAccess/ImporterRegistry.js" );
var Workflow = __webpack_require__( /*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js" );
var Job = __webpack_require__( /*! pcvizJobs/Job */ "./sources/pcvizJobs/Job.js" ).default;

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  VectorJobAdapter Base Class
 *  @class
 *  @memberof pcvizJobs
 */
var VectorJobAdapter = function () {
    JobAdapter.call( this );
    this.setId( 'VLU' );

    this._layerType = 'VectorLayer';
    this._geometryType = 'Point';
    this._extensions = [ 'xml', 'jpg', 'jpeg', 'csv', 'txt' ];
    this._mandatoryDataFileExtension = [ 'jpg', 'jpeg' ];
    this._mandatoryFeatureFileExtension = [ 'xml', 'csv', 'jpg' ];
    this._acceptsPatterns = {
        txt: '_calibrated_external_camera_parameters_wgs84.txt'
    };
    this._dataFiles = [ 'xml', 'csv', 'txt' ];
    this._formatsExtraPanels = undefined;

    this.setRemoteProcessId( Process.VECTOR_PROCESS );

    this._metadataFiles = [];
    this._options = [];
    this._converterOptions = {
        'SaveBlocksExchange': 1,
        'OnlyFirstMetadataImages': 0
    };

    this._objectType = 'layers';
};

VectorJobAdapter.prototype = Utils.objectInherit( JobAdapter.prototype, {

    setGeometryType: function ( geometryType ) {
        this._geometryType = geometryType;
    },
    getGeometryType: function () {
        return this._geometryType;
    },

    isDataFile: function ( fileName ) {
        var extFile = this.getExtension( fileName );
        var result = this._dataFiles.find( function ( ext ) {
            return ( ext === extFile );
        } );
        return ( result !== undefined );
    },
    detect: function ( files ) {
        var defer = P.defer();

        var promises = [];
        for ( var i = 0; i < files.length; i++ ) {
            var file = files[ i ];
            if ( this.isDataFile( file.name ) ) {
                promises.push( this.getImporterAndFile( file ) );
                var fileName = UtilsDB.cleanUpFileNameCharacters( file.name );
                this._metadataFiles.push( 'process/' + fileName );
            }
        }
        if ( promises.length === 0 ) { // this case it is a dji UAV data
            var out = [];
            out.push( {
                category: 4,
                categoryString: VectorLayerUtils.Categories.PLANAR_IMAGE,
                oriCRS: 'EPSG:4326',
                type: 'UAV:Exif',
                format: 'UAVExif'
            } );
            defer.resolve( out );
            return defer.promise;
        }
        Promise.all( promises ).then( function ( impFile ) {

            var dataPromise = [];
            for ( var j = 0; j < impFile.length; j++ ) {
                var data = impFile[ j ].file;
                dataPromise.push( impFile[ j ].importer.getDataIteratorFromData( data.file ) );
            }
            Promise.all( dataPromise ).then( function ( dataIterators ) {
                var out = [];
                var epsgPromises = [];
                for ( var k = 0; k < dataIterators.length; k++ ) {
                    var di = dataIterators[ k ];

                    epsgPromises.push( impFile[ k ].importer.getEPSG( di ) );
                }

                Promise.all( epsgPromises ).then( function ( epsgArray ) {

                    epsgArray.forEach( function ( element, index ) {

                        // GETTING epsg
                        var epsg = element;
                        out.push( {
                            format: impFile[ index ].importer.getId(),
                            type: impFile[ index ].importer.getType(),
                            category: 4,
                            categoryString: VectorLayerUtils.Categories.PLANAR_IMAGE,
                            oriCRS: epsg.ori,
                            destCRS: epsg.dest,
                            isFinal: impFile[ index ].importer.getIsFinal()
                        } );
                    } );
                    defer.resolve( out );
                } );

            } );

        }, function ( file ) {
            defer.reject( file );
        } );
        return defer.promise;
    },

    /**
      Method to verify if all requare files to upload and create a UAV layer, are on the file list
    */
    areLayerFilesValid: function ( files ) {
        var self = this;

        var mandatoryFeatureFileExtension = this._formatType ? ImporterRegistry.getInstance().getImporterFromFormat( this._formatType ).getExtensions() : this._mandatoryFeatureFileExtension;
        if ( files === undefined || !files.length )
            return false;
        var foundFileData = files.find( function ( file ) {
            return self.isMandatory( file, self._mandatoryDataFileExtension );
        } );
        var foundFeatureFile = files.find( function ( file ) {
            return self.isMandatory( file, mandatoryFeatureFileExtension );
        } );

        return ( ( foundFileData !== undefined ) && ( foundFeatureFile !== undefined ) );
    },


    getConfigFile: function ( config ) {
        config = JobAdapter.prototype.getConfigFile.call( this, config );

        if ( config.files === undefined )
            return config;

        for ( var i = config.files.length - 1; i >= 0; i-- ) {
            var file = config.files[ i ];
            if ( this.isDataFile( file ) ) {
                config.files.splice( i, 1 );
            }
        }
        return config;
    },

    getLayerDefinition: function ( layer ) {
        if ( layer.id )
            return;

        var layerDefinition = this.getBaseLayerDefinition( layer );

        VectorLayerUtils.addPlanarImageAttrsToDefinition( layerDefinition );

        return layerDefinition.getJSONObject();
    },

    getBaseLayerDefinition: function ( layer ) {
        var layerDefinition = new LayerDefinition();
        layerDefinition.setName( layer.name );
        layerDefinition.setDescription( layer.description );
        layerDefinition.setLayerType( this.getLayerType() );
        layerDefinition.setLayerCategory( this.getCategory() );
        layerDefinition.setLayerGeometryType( this.getGeometryType() );
        layerDefinition.setHorizProjectionEPSG( this.getDestCRS() );

        return layerDefinition;
    },

    getJob: function ( config ) {
        var job = JobAdapter.prototype.getJob.call( this, config );
        var inputData = JSON.parse( job.getInputData() );
        inputData[ 'options' ] = this._converterOptions;
        var outputBlock;
        if ( this._converterOptions[ 'SaveBlocksExchange' ] )
            outputBlock = config.useBlock ? this.getProcessDataPath( 'block_1.xml' ) : this.getProcessDataPath( 'block.xml' );
        job.setInputData( JSON.stringify( inputData ) );
        var outputData = {
            files: [ config.outputUUID + '.json' ],
            block: outputBlock
        };
        if ( config.uploadExtraFiles === true )
            outputData[ 'uploadExtraFiles' ] = true;
        job.setOutputData( JSON.stringify( outputData ) );

        if ( this._metadataFiles.length <= 0 && !config.metadataFiles )
            return job;

        var metadataFiles = config.metadataFiles ? config.metadataFiles.slice() : this._metadataFiles.slice();
        var files = config.files.slice();
        if ( this._converterOptions[ 'OnlyFirstMetadataImages' ] )
            metadataFiles.unshift( this.getProcessDataPath( 'block.xml' ) );
        var data = {
            files: files,
            fileSizes: config.fileSizes,
            metadataFiles: metadataFiles,
            metadataHeaders: ImporterRegistry.getInstance().getImporterFromFormat( this._formatType ).getMetadataHeaders(),
            options: Object.assign( {}, this._converterOptions, this._processingOptions )
        };
        if ( config.extraFiles !== undefined )
            data[ 'extraFiles' ] = config.extraFiles;
        if ( config.crs !== undefined )
            data[ 'crs' ] = config.crs;
        job.setInputData( JSON.stringify( data ) );
        return job;
    },

    getBlockMergeJob: function ( config ) {
        var blockMergeJob = new Job();
        blockMergeJob.setProcessId( this.getRemoteProcessId() );
        blockMergeJob.setInput( config.catalogId );
        blockMergeJob.setOutput( config.catalogId );
        blockMergeJob.setInputData( JSON.stringify( {
            metadataFiles: [ this.getProcessDataPath( 'block.xml' ), this.getProcessDataPath( 'block_1.xml' ) ],
            options: this._converterOptions
        } ) );
        blockMergeJob.setOutputData( JSON.stringify( {
            preventUpdate: true,
            block: this.getProcessDataPath( 'block.xml' )
        } ) );

        return blockMergeJob;
    },

    getConverterOptions: function () {
        return this._converterOptions;
    },

    getCompleteJob: function ( config ) {
        var job = JobAdapter.prototype.getCompleteJob.call( this, config );
        if ( !config.useBlock )
            return job;
        var pipeline = this.getPipelineProcessData( config, 'sequential' );
        pipeline.addJob( job );
        pipeline.addJob( this.getBlockMergeJob( config ) );
        return pipeline;
    },

    addOptionToConverterOptions: function ( optionKey, optionValue ) {
        this._converterOptions[ optionKey ] = optionValue;
    },

    createJobAdapter: function () {
        return new VectorJobAdapter();
    },

    cloneType: function ( jobAdapter ) {
        var copyJobAdapter = this.createJobAdapter();
        if ( jobAdapter === undefined )
            return copyJobAdapter;

        copyJobAdapter = this.copyBaseData( jobAdapter, copyJobAdapter );
        copyJobAdapter._geometryType = jobAdapter._geometryType;
        copyJobAdapter._metadataFiles = jobAdapter._metadataFiles;
        copyJobAdapter._formatType = jobAdapter._formatType;
        // clone from attributes instead of getter to avoid 'is not a function' error when 'jobAdapter' is a plain object
        copyJobAdapter._converterOptions = Object.assign( {}, jobAdapter._converterOptions );

        return copyJobAdapter;
    },

    getProcessDataPath: function ( path ) {
        if ( path === undefined )
            path = '';
        return Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/' + path;
    },

    getFormatDefinitions: function () {
        var format = [];
        var self = this;
        ImporterRegistry.getInstance().importers.forEach( function ( value ) {
            format.push( {
                uploaderName: self._id,
                id: value.getId(),
                label: value.getId(),
                fileType: value.getType()
            } );
        } );
        return format;
    },

    getFormatsExtraPanels: function () {
        if ( this._formatsExtraPanels ) {
            return this._formatsExtraPanels;
        }
        var self = this;
        this._formatsExtraPanels = [];
        ImporterRegistry.getInstance().importers.forEach( function ( value ) {
            if ( value.hasOption( 'OnlyImagesInMetadataFiles' ) ) {
                self._formatsExtraPanels.push( value.getId() );
            }
        } );
        return this._formatsExtraPanels;
    },

    isFileValid: function ( file, extensions ) {
        if ( this._setByUser || this._isFinal )
            extensions = this._mandatoryDataFileExtension.concat( ImporterRegistry.getInstance().getImporterFromFormat( this._formatType ).getExtensions() );

        return JobAdapter.prototype.isFileValid.call( this, file, extensions );
    },

    canUseExtraPanels: function () {
        return this.getFormatsExtraPanels().indexOf( this._formatType ) !== -1;
    }
} );

// Register JobAdapter
var vlu = new VectorJobAdapter();
JobAdapterRegistry.getInstance().registerJobAdapter( vlu.getId(), vlu );
module.exports = VectorJobAdapter;


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/VerityAnalysisJobAdapter.js":
/*!*******************************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/VerityAnalysisJobAdapter.js ***!
  \*******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__);




class VerityAnalysisJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__["default"].VERITY_ANALYSIS;
    }

    getJob( config ) {
        let job = super.getJob( config );
        job.setInputData( JSON.stringify( {
            guids: config.guids,
            process: pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.VERITY_ANALYZE_FILE_PATH,
            layer: config.layerId,
            feature: config.featureId
        } ) );
        job.setOutputData( JSON.stringify( {
            projectId: config.projectId
        } ) );

        return job;
    }
}

/* harmony default export */ __webpack_exports__["default"] = (VerityAnalysisJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobAdapters/ZipJobAdapter.js":
/*!********************************************************!*\
  !*** ./sources/pcvizJobs/JobAdapters/ZipJobAdapter.js ***!
  \********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizJobs/JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizJobs/Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2__);




const ZIP = 'zip';
const UNZIP = 'unzip';
const ZIP_TEMP_PATH = 'downloads';

class ZipJobAdapter extends pcvizJobs_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor() {
        super();
        this._remoteProcessId = pcvizJobs_Process__WEBPACK_IMPORTED_MODULE_1__["default"].ZIP_PROCESS;
        this._action = ZIP;
        this._excludedPaths = [];
        this._workspaceProjectEnabled = false; // TODO is a workspace object or a boolean (isWorkspaceProject) ?
    }

    setAction( action ) {
        this._action = action;
    }

    addExcludedPath( excludedPath ) {
        this._excludedPaths.push( excludedPath );
    }

    getJob( config ) {
        let job = super.getJob( config );
        let inputData = JSON.parse( job.getInputData() );

        inputData[ this._action ] = this._action === ZIP ? this.getZipFolder( config ) : config.files;
        if ( this._excludedPaths.length ) {
            inputData.options = {
                exclude: this._excludedPaths
            };
        }
        if ( this._workspaceProjectEnabled ) {
            inputData[ 'workspace' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.WORKSPACE_FILE_PATH;
            inputData[ 'workspaceProject' ] = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.PROCESS_DATA_PATH_PREFIX + this._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_2___default.a.WORKSPACE_PROJECT_FILE_PATH;
        }
        inputData[ 'projectPath' ] = 'process/scan_project';

        //
        job.setInputData( JSON.stringify( inputData ) );
        job.setOutputData( JSON.stringify( {
            filesPath: this.getOutputPath( config )
        } ) );
        return job;
    }

    getZipFolder( config ) {
        if ( config.zipFolder ) {
            return [ config.zipFolder ];
        }
        return config.files.map( file => file.slice( 0, file.length - 1 ) );
    }

    getOutputPath( config ) {
        if ( this._action === ZIP ) {
            return ZIP_TEMP_PATH + '/' + this.getZipFileName( config );
        }
        return ZIP_TEMP_PATH;
    }

    getZipFileName( config ) {
        return `${config.zipName || config.jobName}.zip`;
    }

    enableWorkspaceProject( enabled = true ) {
        this._workspaceProjectEnabled = enabled;
    }

}

ZipJobAdapter.ZIP = ZIP;
ZipJobAdapter.UNZIP = UNZIP;
ZipJobAdapter.ZIP_TEMP_PATH = ZIP_TEMP_PATH;

/* harmony default export */ __webpack_exports__["default"] = (ZipJobAdapter);


/***/ }),

/***/ "./sources/pcvizJobs/JobStatus.js":
/*!****************************************!*\
  !*** ./sources/pcvizJobs/JobStatus.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


let JobStatus = {
    UPLOADING: 'UPLOADING',
    UPLOADED: 'UPLOADED',
    QUEUED: 'QUEUED',
    PENDING: 'PENDING',
    PENDING_QUEUED: 'PENDING_QUEUED',
    RECEIVED: 'RECEIVED',
    STARTING: 'STARTING',
    STARTED: 'STARTED',
    PAUSED: 'PAUSED',
    SUCCESS: 'SUCCESS',
    FAILURE: 'FAILURE',
    REVOKED: 'REVOKED',
    RUNNING_WITH_ERRORS: 'RUNNING_WITH_ERRORS',
    SUCCESS_WITH_ERRORS: 'SUCCESS_WITH_ERRORS',
    RETRY: 'RETRY',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    CANCELLED: 'CANCELLED',
    CANCELLING: 'CANCELLING',
    INCOMPLETE: 'INCOMPLETE',
    NOT_FOUND_ID: 404
};

JobStatus.ERROR = [ JobStatus.FAILURE, JobStatus.REVOKED, JobStatus.CONNECTION_ERROR, JobStatus.NOT_FOUND, JobStatus.SUCCESS_WITH_ERRORS ];
JobStatus.UPLOADING_ARRAY = [ JobStatus.UPLOADING, JobStatus.UPLOADED, JobStatus.PAUSED, JobStatus.QUEUED ];
JobStatus.PROCESSING_ARRAY = [ JobStatus.PENDING, JobStatus.STARTING, JobStatus.STARTED ];
JobStatus.FINISHED_ARRAY = [ JobStatus.FAILURE, JobStatus.SUCCESS, JobStatus.CANCELLED, JobStatus.SUCCESS_WITH_ERRORS ];

/* harmony default export */ __webpack_exports__["default"] = (JobStatus);


/***/ }),

/***/ "./sources/pcvizJobs/Pipeline.js":
/*!***************************************!*\
  !*** ./sources/pcvizJobs/Pipeline.js ***!
  \***************************************/
/*! exports provided: Pipeline, PIPELINE_TYPES */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pipeline", function() { return Pipeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PIPELINE_TYPES", function() { return PIPELINE_TYPES; });
/* harmony import */ var _Job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Job */ "./sources/pcvizJobs/Job.js");




const PIPELINE_TYPES = {
    SEQUENTIAL: 'sequential',
    PARALLEL: 'parallel'
};
var estimateTimeFunction = {};

class Pipeline extends _Job__WEBPACK_IMPORTED_MODULE_0__["default"] {
    constructor( type ) {
        super();
        this._jobTree = [];
        this._type = type;
    }

    getPipeline() {
        let processes = this._jobTree.map( job => {
            return job.getPipeline();
        } );
        let pipelineData = {
            processPipeline: {
                name: this._name,
                type: this._type,
                input: this._input,
                output: this._output,
                processes: processes
            }
        };
        return pipelineData;
    }

    addJob( job ) {
        this._jobTree.push( job );
    }

    getJobs() {
        return this._jobTree;
    }

    getType() {
        return this._type;
    }

    setType( type ) {
        this._type = type;
    }

    estimate() {
        return new Promise( ( resolve, reject ) => {
            this._jobDriver.estimate( this.getPipeline() ).then( response => {
                if ( !Array.isArray( response ) ) {
                    resolve( response );
                    return;
                }
                var estimation = {
                    processingCredits: Pipeline.computePipelineProcessingCredits( response ),
                    processingTime: this.computePipelineProcessingTime( response )
                };
                resolve( estimation );
            }, error => {
                reject( error );
            } );
        } );
    }


    static computePipelineProcessingCredits( estimation ) {
        var processingCredits = 0;
        estimation.forEach( function ( job ) {
            processingCredits += job.processingCredits;
        } );
        return processingCredits;
    }

    computePipelineProcessingTime( estimation ) {
        var type = this.getType();
        return estimateTimeFunction[ type ]( this.getPipeline().processPipeline, estimation );
    }
}

function estimateTimeForSequentialProcesses( processPipeline, estimation ) {
    var time = 0;

    processPipeline.processes.forEach( function ( process ) {
        if ( process.processPipeline ) {
            time += estimateTimeFunction[ process.processPipeline.type ]( process.processPipeline, estimation );
            return;
        }
        var jobEstimation = estimation.find( function ( job ) {
            return job.id === process.process.id;
        } );
        time += jobEstimation.processingTime;
    } );
    return time;
}

function estimateTimeForParallelProcesses( processPipeline, estimation ) {
    var times = [];
    processPipeline.processes.forEach( function ( process ) {
        if ( process.processPipeline ) {
            times.push( estimateTimeFunction[ process.processPipeline.type ]( process.processPipeline, estimation ) );
            return;
        }
        var jobEstimation = estimation.find( function ( job ) {
            return job.id === process.process.id;
        } );
        times.push( jobEstimation.processingTime );
    } );
    return Math.max.apply( null, times );
}


estimateTimeFunction[ PIPELINE_TYPES.SEQUENTIAL ] = estimateTimeForSequentialProcesses;
estimateTimeFunction[ PIPELINE_TYPES.PARALLEL ] = estimateTimeForParallelProcesses;




/***/ }),

/***/ "./sources/pcvizJobs/Process.js":
/*!**************************************!*\
  !*** ./sources/pcvizJobs/Process.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


const Process = { // from server: /api/processes
};

Process.POINTCLOUD_PROCESS = 1;
Process.VECTOR_PROCESS = 3;
Process.ZIP_PROCESS = 4;
Process.CREATE_PROJECT = 8;
Process.GIS_PROCESS = 9;
Process.OBJ_PROCESS = 10;
Process.C3DTILES_PROCESS = 11;
Process.DOWNLOAD_DATA = 12;
Process.IMPORT_SCAN_PROJECT = 13;
Process.SCAN_PROCESSING = 14;
Process.DELETE_DATA = 16;
Process.C2C_REGISTRATION = 17;
Process.OCCBS_REGISTRATION = 18;
Process.RESECTION_REGISTRATION = 19;
Process.RASTER = 20;
Process.EXPORT_SCANS = 21;
Process.CE_OCCBS_REGISTRATION = 22;
Process.CE_RESECTION_REGISTRATION = 23;
Process.SYNC_PROJECT = 24;
Process.UPDATE_SPARSE = 25;
Process.EXPORT = 26;
Process.IMPORT = 27;
Process.SCAN_COMMON_PROCESS = 28;
Process.MW_FILTERS_COMMON_PROCESS = 30;
Process.SCAN_DELIVERABLES = 31;
Process.BIM_PROCESS = 32;
Process.VERITY_ANALYSIS = 33;
Process.VOLUME_CALCULATION = 34;
Process.GENERATE_SNAPSHOT = 35;
Process.IMPORT_REFERENCES_TO_SITES = 38;
Process.EXPORT_PANORAMA = 39;
Process.PROCESS_FLS_SCAN = 40;
Process.PROCESS_SCAN_V2 = 41;
Process.IMPORT_MULTIPLE_STATION_V2 = 43;

Process.getKeyById = function ( id ) {
    let processElement = Object.entries( Process ).find( function ( processElement ) {
        return ( processElement[ 1 ] === id );
    } );
    return processElement[ 0 ];
};

Process.getImportStationJobs = () => {
    return [ Process.IMPORT_SCAN_PROJECT, Process.IMPORT_MULTIPLE_STATION_V2 ];
};

Process.getProcessScanJobs = function () {
    return [ Process.PROCESS_FLS_SCAN, Process.PROCESS_SCAN_V2 ];
};

/* harmony default export */ __webpack_exports__["default"] = (Process);


/***/ }),

/***/ "./sources/pcvizJobs/UploadUtils.js":
/*!******************************************!*\
  !*** ./sources/pcvizJobs/UploadUtils.js ***!
  \******************************************/
/*! exports provided: getFileSize, getUploadFilesList, prepareUploadFilesListForEstimation, prepareProcessConfig, checkFilesToUpload, prepareFilesInfo, createLayer, getOrCreateLayers, configureUploadWithoutJob, createUploadJob, processLayer, removeUpload, startUploadFiles, convertLayer, uploadFiles, addLayersToProjectConfig, process, prepareAndGetOrCreateLayers, createAndUpload, uploadFilesByConfig, uploadJobSiteReferenceData */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFileSize", function() { return getFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUploadFilesList", function() { return getUploadFilesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareUploadFilesListForEstimation", function() { return prepareUploadFilesListForEstimation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareProcessConfig", function() { return prepareProcessConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkFilesToUpload", function() { return checkFilesToUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareFilesInfo", function() { return prepareFilesInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createLayer", function() { return createLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOrCreateLayers", function() { return getOrCreateLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configureUploadWithoutJob", function() { return configureUploadWithoutJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createUploadJob", function() { return createUploadJob; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "processLayer", function() { return processLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeUpload", function() { return removeUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "startUploadFiles", function() { return startUploadFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertLayer", function() { return convertLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFiles", function() { return uploadFiles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addLayersToProjectConfig", function() { return addLayersToProjectConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "process", function() { return process; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prepareAndGetOrCreateLayers", function() { return prepareAndGetOrCreateLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAndUpload", function() { return createAndUpload; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFilesByConfig", function() { return uploadFilesByConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadJobSiteReferenceData", function() { return uploadJobSiteReferenceData; });
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizJobs_JobAdapterService__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizJobs/JobAdapterService */ "./sources/pcvizJobs/JobAdapterService.js");
/* harmony import */ var pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/JobStatus */ "./sources/pcvizJobs/JobStatus.js");
/* harmony import */ var pcvizDataAccess_Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDataAccess/Uploaders/FileUploader */ "./sources/pcvizDataAccess/Uploaders/FileUploader.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js");
/* harmony import */ var pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5__);









if ( !window.sessionStorage.tabId )
    window.sessionStorage.tabId = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.generateUUID();

function getFileSize( file ) {
    var name = file.name ? file.name : file.filePath;
    var ext = name.substring( name.lastIndexOf( '.' ) + 1 ).toLowerCase();
    if ( ext !== 'laz' )
        return file.size;
    return ( file.size * 25 );
}

function getUploadFilesList( config ) {
    var list = [];
    config.upload.filesInfo.forEach( function ( fileInfo, index ) {
        var file = config.files.find( function ( file ) {
            return fileInfo.name === file.name;
        } );
        if ( file === undefined )
            return;
        if ( !fileInfo.mustUpload )
            return;
        list.push( {
            config: config,
            url: config.upload.urls ? config.upload.urls[ index ] : undefined,
            file: file,
            fileInfo: fileInfo
        } );
    } );
    return list;
}

function prepareUploadFilesListForEstimation( config ) {
    var list = getUploadFilesList( config );
    var uploadUrls = list.map( function ( definition ) {
        const name = definition.file.alias || definition.file.name;
        const fileName = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.cleanUpFileNameCharacters( name );
        return {
            filePath: definition.config.upload.prefix + fileName,
            size: definition.file.size,
            uploaded: definition.file.uploaded
        };
    } );
    return uploadUrls;

}

function prepareProcessConfig( config ) {
    var files = [];
    var fileSizes = [];
    var catalogObjects = {};
    var catalogId = config.upload.object ? pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getDriver( 'da.collage' ).getEntryPoint( config.jobAdapter.getObjectType(), config.upload.object.id ) : '';
    var jobName = config.name || config.upload.object && config.upload.object.name || undefined;
    var urls = config.upload.urls ? config.upload.urls : prepareUploadFilesListForEstimation( config );
    if ( config.upload.catalogObjects ) {
        config.upload.catalogObjects.forEach( function ( catalogObject ) {
            catalogObjects[ catalogObject.key ] = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getDriver( 'da.collage' ).getEntryPoint( 'layers', catalogObject.catalogId );
        } );
    }
    urls.forEach( function ( urlObj ) {
        files.push( urlObj.filePath );
        fileSizes.push( getFileSize( urlObj ) );
    } );

    if ( config.filesPath ) {
        files = [ config.filesPath ];
    }

    var processConfig = {
        jobName: jobName,
        catalogId: catalogId,
        catalogObjects: catalogObjects,
        outputUUID: ( config.outputUUID === undefined ) ? pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_0___default.a.generateUUID() : config.outputUUID,
        files: files,
        fileSizes: fileSizes,
        project: config.upload.project,
        useBlock: config.useBlock
    };
    return processConfig;
}

function checkFilesToUpload( job ) {
    job.filesInfo.forEach( function ( fileInfo ) {
        if ( !fileInfo.mustUpload ) {
            fileInfo.invalid = true;
            fileInfo.invalidMessage = 'UPLOAD.RESUME_INVALID';
            return;
        }
        if ( fileInfo.completed )
            return;
        fileInfo.invalid = true;
        fileInfo.invalidMessage = 'UPLOAD.RESUME_INVALID';
    } );
}

function prepareFilesInfo( files ) {
    var filesInfo = [];
    files.forEach( function ( file ) {
        filesInfo.push( {
            name: file.name,
            mustUpload: true,
            size: file.size
        } );
    } );
    return filesInfo;
}

function createLayer( layerData ) {
    return new Promise( function ( resolve, reject ) {
        if ( !layerData ) {
            resolve();
            return;
        }
        var createLayerPromise = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getDriver( 'da.layer' ).createLayer( layerData );
        // Check how to abort/cancel creation
        // $scope.config.cancel = createLayerPromise.abort;
        createLayerPromise.then( function ( layer ) {
            resolve( layer );
        }, function ( error ) {
            // layerSelectionPanel.addError( 'UPLOAD.ERROR_CREATING_LAYER' );
            reject( error );
        } );
    } );
}

function getOrCreateLayers( layerData ) {
    return new Promise( function ( resolve, reject ) {
        if ( Array.isArray( layerData ) ) {
            var promises = [];
            layerData.forEach( function ( layerDefinition ) {
                promises.push( createLayer( layerDefinition ) );
            } );
            Promise.all( promises ).then( function ( layers ) {
                resolve( layers );
            }, reject );
            return;
        }
        createLayer( layerData ).then( function ( layer ) {
            resolve( [ layer ] );
        }, reject );
    } );
}

// If a TranslationService is passed as argument, some job adapters customize the jobs' names
function configureUploadWithoutJob( config, TranslationService ) {

    if ( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).jobExists( config ) ) {
        // Avoid duplicating job when resuming
        return;
    }
    // upload will store the persisted information for uploading jobs
    config.upload = {
        sessionId: window.sessionStorage.tabId, // To identify the tab that is uploading
        uploadJob: true,
        uploadId: config.uploadId,
        project: config.project,
        object: config.object,
        progress: 0,
        filesInfo: prepareFilesInfo( config.files ),
        status: pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].STARTING,
        createdAt: new Date().toISOString(),
        jobAdapter: config.jobAdapter,
        startedAt: 0, // date
        remainingTime: 0, // ms
        useFilePath: config.upload ? config.upload.useFilePath : false
    };
    // TODO: Create Jobs module in core library or standalone
    config.upload.catalogObjects = config.catalogObjects;
    delete config.catalogObjects;
    config.upload.output = config.output;
    delete config.output;
    config.upload.prefix = ( config.prefix ) ? 'process/' + config.prefix : 'process/';

    let jobAdapter = pcvizJobs_JobAdapterService__WEBPACK_IMPORTED_MODULE_2__["default"].ensureJobAdapter( config.upload.jobAdapter );
    let processConfig = jobAdapter.getConfigFile( prepareProcessConfig( config ) );

    jobAdapter.computeName( processConfig, TranslationService );

    return { jobAdapter, processConfig };

}

// If a TranslationService is passed as argument, some job adapters customize the jobs' names
function createUploadJob( config, TranslationService ) {

    return new Promise( function ( resolve, reject ) {
        const { processConfig, jobAdapter } = configureUploadWithoutJob( config, TranslationService );
        if ( !processConfig )
            reject();
        // jobAdapter.getCompleteJob returns a pcvizJob.Job object
        jobAdapter.getCompleteJob( processConfig ).create().then( job => {
            config.upload.id = job.id;
            config.upload.jobAdapter.setJobId( job.id );
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).pushUploadJob( config );
            resolve( job.id );
        }, reject );
    } );
}


function processLayer( config ) {
    return new Promise( function ( resolve, reject ) {
        var jobAdapter = pcvizJobs_JobAdapterService__WEBPACK_IMPORTED_MODULE_2__["default"].ensureJobAdapter( config.upload.jobAdapter );
        pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getDriver( 'da.job' ).start( jobAdapter.getJobId() ).then( function ( job ) {
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).removeUploadJob( config );
            var event = new CustomEvent( 'process:convert-pointcloud', config );
            document.body.dispatchEvent( event );
            resolve( job );

        }, function () {
            // Check error or if it exists in the server (remove to avoid duplicate )
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( config.upload );
            var event = new CustomEvent( 'process:convert-pointcloud', config );
            document.body.dispatchEvent( event );
            reject();
        } );
    } );
}

function removeUpload( config ) {
    pcvizJobs_JobAdapterService__WEBPACK_IMPORTED_MODULE_2__["default"].ensureJobAdapter( config.upload.jobAdapter );

    pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).removeUploadJob( config );
    const event = new CustomEvent( 'process:convert-pointcloud', config );
    document.body.dispatchEvent( event );
}

function startUploadFiles( config, updateCB ) {
    return new Promise( ( resolve, reject ) => {
        let fileUploader = new pcvizDataAccess_Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_4__["default"]( config );
        if ( updateCB ) {
            fileUploader.on( 'progress', updateCB );
            fileUploader.on( 'cancel', updateCB );
        }
        let uploadStart = new Date();

        var oldJobIndex = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' )._uploadJobs.findIndex( function ( job ) {
            return config.upload.id === job.upload.id;
        } );
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' )._uploadJobs[ oldJobIndex ] = config;

        fileUploader.uploadFiles().then( function () {
            config.uploadTime = new Date() - uploadStart;
            resolve();
        }, reject );
    } );
}

// updateCB is used to update in angular
function convertLayer( config, updateCB ) {
    return new Promise( ( resolve, reject ) => {
        function rejectWithError() {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( config.upload );
            if ( updateCB )
                updateCB();
            reject();
        }

        startUploadFiles( config, updateCB ).then( function () {
            processLayer( config ).then( function ( process ) {
                if ( updateCB )
                    updateCB();
                config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].PENDING;
                resolve( process );
            }, rejectWithError );
        }, rejectWithError );
    } );
}



function uploadFiles( config ) {
    return new Promise( ( resolve, reject ) => {
        function rejectWithError() {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( config.upload );
            reject();
        }
        startUploadFiles( config ).then( () => {
            removeUpload( config );
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].PENDING;
            resolve( /*process*/);
        }, rejectWithError );
    } );
}

function addLayersToProjectConfig( projectConfig, layers ) {
    // It can be undefined if the user doesn't want to create a project
    if ( !projectConfig )
        return;
    projectConfig[ 'layers' ] = [];

    layers.forEach( function ( layer ) {
        projectConfig.layers.push( layer.id );
    } );
}


function process( config ) {

    return new Promise( function ( resolve, reject ) {

        function setIncompleteAndReject() {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            reject();
        }
        processLayer( config ).then( function ( process ) {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].PENDING;
            resolve( process );
        }, setIncompleteAndReject );
    } );
}

function prepareAndGetOrCreateLayers( project, config ) {
    return new Promise( function ( resolve, reject ) {
        var jobAdapter = pcvizJobs_JobAdapterService__WEBPACK_IMPORTED_MODULE_2__["default"].getJobAdapter();
        var layerDefinition = jobAdapter.getLayerDefinition( config.object, project );
        config.formatType = {
            type: jobAdapter.getFormatType()
        };

        getOrCreateLayers( layerDefinition ).then( function ( layers ) {
            config.catalogObjects = jobAdapter.prepareCatalogObjects( layers );
            config.object = layers[ 0 ] ? layers[ 0 ] : config.object;
            config.output = pcvizDataAccess_DriverRegistry__WEBPACK_IMPORTED_MODULE_5___default.a.getInstance().getDriver( 'da.collage' ).getEntryPoint( jobAdapter.getObjectType(), config.object.id );
            config.jobAdapter = jobAdapter;
            // fill the project information
            addLayersToProjectConfig( config.project, layers );
            resolve();
        }, reject );

    } );
}

function createAndUpload( config, project, TranslationService ) {

    return new Promise( function ( resolve, reject ) {

        function setIncompleteAndReject() {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( config.upload );
            reject();
        }

        prepareAndGetOrCreateLayers( project, config ).then( function () {
            createUploadJob( config, TranslationService ).then( resolve, setIncompleteAndReject );
        }, setIncompleteAndReject );

    } );
}

function uploadFilesByConfig( config ) {

    return new Promise( function ( resolve, reject ) {

        function setIncompleteAndReject() {
            config.upload.status = pcvizJobs_JobStatus__WEBPACK_IMPORTED_MODULE_3__["default"].INCOMPLETE;
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).updateInLocalStorage( config.upload );
            reject();
        }

        prepareAndGetOrCreateLayers( undefined, config ).then( () => {
            const valid = configureUploadWithoutJob( config );
            if ( valid ) {
                const randomId = Math.random();
                config.upload.id = randomId;
                config.upload.jobAdapter.setJobId( randomId );
                pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Upload' ).pushUploadJob( config );
            }
            resolve( /*randomId*/);
        }, setIncompleteAndReject );

    } );
}

function uploadJobSiteReferenceData( config ) {
    return new Promise( ( resolve, reject ) => {
        config.upload = {
            uploadId: config.uploadId,
            object: config.object,
            progress: 0,
            filesInfo: prepareFilesInfo( config.files ),
            createdAt: new Date().toISOString(),
            jobAdapter: config.jobAdapter,
            startedAt: 0, // date
            remainingTime: 0, // ms
            useFilePath: config.upload ? config.upload.useFilePath : false,
            prefix: 'process/',
        };
        config.upload.catalogObjects = config.catalogObjects;
        delete config.catalogObjects;
        config.upload.output = config.output;
        delete config.output;

        let fileUploader = new pcvizDataAccess_Uploaders_FileUploader__WEBPACK_IMPORTED_MODULE_4__["default"]( config );

        fileUploader.uploadFiles()
            .then( () => resolve() )
            .catch( () => reject() );
    } );
}


/***/ }),

/***/ "./sources/pcvizJobs/pcvizJobs.js":
/*!****************************************!*\
  !*** ./sources/pcvizJobs/pcvizJobs.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Job__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Job */ "./sources/pcvizJobs/Job.js");
/* harmony import */ var _JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");
/* harmony import */ var _JobStatus__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./JobStatus */ "./sources/pcvizJobs/JobStatus.js");
/* harmony import */ var _Pipeline__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./Pipeline */ "./sources/pcvizJobs/Pipeline.js");
/* harmony import */ var _Process__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./Process */ "./sources/pcvizJobs/Process.js");
/* harmony import */ var _JobAdapters_BimJobAdapter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./JobAdapters/BimJobAdapter */ "./sources/pcvizJobs/JobAdapters/BimJobAdapter.js");
/* harmony import */ var _JobAdapters_CRP1ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./JobAdapters/CRP1ScanProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/CRP1ScanProjectJobAdapter.js");
/* harmony import */ var _JobAdapters_ClearEdgeModelJobAdapter__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./JobAdapters/ClearEdgeModelJobAdapter */ "./sources/pcvizJobs/JobAdapters/ClearEdgeModelJobAdapter.js");
/* harmony import */ var _JobAdapters_CreateStationJobAdapter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./JobAdapters/CreateStationJobAdapter */ "./sources/pcvizJobs/JobAdapters/CreateStationJobAdapter.js");
/* harmony import */ var _JobAdapters_DeleteDataJobAdapter__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./JobAdapters/DeleteDataJobAdapter */ "./sources/pcvizJobs/JobAdapters/DeleteDataJobAdapter.js");
/* harmony import */ var _JobAdapters_DesignDataJobAdapter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./JobAdapters/DesignDataJobAdapter */ "./sources/pcvizJobs/JobAdapters/DesignDataJobAdapter.js");
/* harmony import */ var _JobAdapters_ExportProjectJobAdapter__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./JobAdapters/ExportProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/ExportProjectJobAdapter.js");
/* harmony import */ var _JobAdapters_FeatureMetadataJobAdapter__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./JobAdapters/FeatureMetadataJobAdapter */ "./sources/pcvizJobs/JobAdapters/FeatureMetadataJobAdapter.js");
/* harmony import */ var _JobAdapters_FeatureMetadataJobAdapter__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_FeatureMetadataJobAdapter__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _JobAdapters_GcpJobAdapter__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./JobAdapters/GcpJobAdapter */ "./sources/pcvizJobs/JobAdapters/GcpJobAdapter.js");
/* harmony import */ var _JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./JobAdapters/GisJobAdapter */ "./sources/pcvizJobs/JobAdapters/GisJobAdapter.js");
/* harmony import */ var _JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _JobAdapters_ImportZipProjectJobAdapter__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./JobAdapters/ImportZipProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/ImportZipProjectJobAdapter.js");
/* harmony import */ var _JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./JobAdapters/JobAdapter */ "./sources/pcvizJobs/JobAdapters/JobAdapter.js");
/* harmony import */ var _JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _JobAdapters_Model3D3MXVectorJobAdapter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./JobAdapters/Model3D3MXVectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/Model3D3MXVectorJobAdapter.js");
/* harmony import */ var _JobAdapters_Model3D3MXVectorJobAdapter__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_Model3D3MXVectorJobAdapter__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _JobAdapters_Model3DVectorJobAdapter__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./JobAdapters/Model3DVectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/Model3DVectorJobAdapter.js");
/* harmony import */ var _JobAdapters_Model3DVectorJobAdapter__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_Model3DVectorJobAdapter__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _JobAdapters_ObjJobAdapter__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./JobAdapters/ObjJobAdapter */ "./sources/pcvizJobs/JobAdapters/ObjJobAdapter.js");
/* harmony import */ var _JobAdapters_ObjJobAdapter__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_ObjJobAdapter__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _JobAdapters_PointCloudJobAdapter__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./JobAdapters/PointCloudJobAdapter */ "./sources/pcvizJobs/JobAdapters/PointCloudJobAdapter.js");
/* harmony import */ var _JobAdapters_PointCloudJobAdapter__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_PointCloudJobAdapter__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _JobAdapters_RasterJobAdapter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./JobAdapters/RasterJobAdapter */ "./sources/pcvizJobs/JobAdapters/RasterJobAdapter.js");
/* harmony import */ var _JobAdapters_RasterJobAdapter__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_RasterJobAdapter__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _JobAdapters_ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./JobAdapters/ScanProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/ScanProjectJobAdapter.js");
/* harmony import */ var _JobAdapters_SyncJobAdapter__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./JobAdapters/SyncJobAdapter */ "./sources/pcvizJobs/JobAdapters/SyncJobAdapter.js");
/* harmony import */ var _JobAdapters_VectorJobAdapter__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./JobAdapters/VectorJobAdapter */ "./sources/pcvizJobs/JobAdapters/VectorJobAdapter.js");
/* harmony import */ var _JobAdapters_VectorJobAdapter__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_JobAdapters_VectorJobAdapter__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _JobAdapters_VerityAnalysisJobAdapter__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./JobAdapters/VerityAnalysisJobAdapter */ "./sources/pcvizJobs/JobAdapters/VerityAnalysisJobAdapter.js");
/* harmony import */ var _JobAdapters_ZipJobAdapter__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./JobAdapters/ZipJobAdapter */ "./sources/pcvizJobs/JobAdapters/ZipJobAdapter.js");
/* harmony import */ var _JobAdapterService__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./JobAdapterService */ "./sources/pcvizJobs/JobAdapterService.js");
/* harmony import */ var _UploadUtils__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./UploadUtils */ "./sources/pcvizJobs/UploadUtils.js");


































/** @namespace pcvizJobs */
let Jobs = {
    JobStatus: _JobStatus__WEBPACK_IMPORTED_MODULE_2__["default"],
    Job: _Job__WEBPACK_IMPORTED_MODULE_0__["default"],
    Pipeline: _Pipeline__WEBPACK_IMPORTED_MODULE_3__["Pipeline"],
    PIPELINE_TYPES: _Pipeline__WEBPACK_IMPORTED_MODULE_3__["PIPELINE_TYPES"],
    Process: _Process__WEBPACK_IMPORTED_MODULE_4__["default"],
    JobAdapterRegistry: _JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_1__["default"],
    JobAdapter: _JobAdapters_JobAdapter__WEBPACK_IMPORTED_MODULE_16___default.a,
    PointCloudJobAdapter: _JobAdapters_PointCloudJobAdapter__WEBPACK_IMPORTED_MODULE_20___default.a,
    VectorJobAdapter: _JobAdapters_VectorJobAdapter__WEBPACK_IMPORTED_MODULE_24___default.a,
    RasterJobAdapter: _JobAdapters_RasterJobAdapter__WEBPACK_IMPORTED_MODULE_21___default.a,
    Model3DVectorJobAdapter: _JobAdapters_Model3DVectorJobAdapter__WEBPACK_IMPORTED_MODULE_18___default.a,
    Model3D3MXVectorJobAdapter: _JobAdapters_Model3D3MXVectorJobAdapter__WEBPACK_IMPORTED_MODULE_17___default.a,
    GisJobAdapter: _JobAdapters_GisJobAdapter__WEBPACK_IMPORTED_MODULE_14___default.a,
    ObjJobAdapter: _JobAdapters_ObjJobAdapter__WEBPACK_IMPORTED_MODULE_19___default.a,
    FeatureMetadataJobAdapter: _JobAdapters_FeatureMetadataJobAdapter__WEBPACK_IMPORTED_MODULE_12___default.a,
    ScanProjectJobAdapter: _JobAdapters_ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_22__["default"],
    CRP1ScanProjectJobAdapter: _JobAdapters_CRP1ScanProjectJobAdapter__WEBPACK_IMPORTED_MODULE_6__["default"],
    CreateStationJobAdapter: _JobAdapters_CreateStationJobAdapter__WEBPACK_IMPORTED_MODULE_8__["default"],
    ZipJobAdapter: _JobAdapters_ZipJobAdapter__WEBPACK_IMPORTED_MODULE_26__["default"],
    DeleteDataJobAdapter: _JobAdapters_DeleteDataJobAdapter__WEBPACK_IMPORTED_MODULE_9__["default"],
    SyncJobAdapter: _JobAdapters_SyncJobAdapter__WEBPACK_IMPORTED_MODULE_23__["default"],
    ExportProjectJobAdapter: _JobAdapters_ExportProjectJobAdapter__WEBPACK_IMPORTED_MODULE_11__["default"],
    ImportZipProjectJobAdapter: _JobAdapters_ImportZipProjectJobAdapter__WEBPACK_IMPORTED_MODULE_15__["default"],
    UploadUtils: _UploadUtils__WEBPACK_IMPORTED_MODULE_28__,
    JobAdapterService: _JobAdapterService__WEBPACK_IMPORTED_MODULE_27__["default"],
    DesignDataJobAdapter: _JobAdapters_DesignDataJobAdapter__WEBPACK_IMPORTED_MODULE_10__["default"],
    ClearEdgeModelJobAdapter: _JobAdapters_ClearEdgeModelJobAdapter__WEBPACK_IMPORTED_MODULE_7__["default"],
    BimJobAdapter: _JobAdapters_BimJobAdapter__WEBPACK_IMPORTED_MODULE_5__["default"],
    VerityAnalysisJobAdapter: _JobAdapters_VerityAnalysisJobAdapter__WEBPACK_IMPORTED_MODULE_25__["default"],
    GcpJobAdapter: _JobAdapters_GcpJobAdapter__WEBPACK_IMPORTED_MODULE_13__["default"],
};

/* harmony default export */ __webpack_exports__["default"] = (Jobs);


/***/ }),

/***/ "./sources/pcvizManipulator/CADManipulator.js":
/*!****************************************************!*\
  !*** ./sources/pcvizManipulator/CADManipulator.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgGA = OSG.osgGA;
const osgUtil = OSG.osgUtil;
var vec3 = osg.vec3;
var mat4 = osg.mat4;
var quat = osg.quat;

const CADManipulatorStandardMouseKeyboardController = function ( manipulator ) {
    osgGA.getCADManipulatorStandardMouseKeyboardController().call( this, manipulator );
};

CADManipulatorStandardMouseKeyboardController.prototype = osg.objectInherit( osgGA.getCADManipulatorStandardMouseKeyboardController().prototype, {
    mousewheel: function ( ev, intDelta ) {
        const manipulator = this._manipulator;
        const zoomTarget = manipulator.getZoomInterpolator().getTarget()[ 0 ] - intDelta;
        manipulator.getZoomInterpolator().setTarget( zoomTarget );
        let timer;
        if ( this._timer === false ) {
            this._timer = true;
            const that = this;
            clearTimeout( timer );
            timer = setTimeout( function () {
                that._timer = false;
            }, 200 );
            const pos = manipulator.getPositionRelativeToCanvas( ev.clientX, ev.clientY );
            manipulator.computeZoomOffset( pos ); // for computeOnlyZoom
            manipulator.computeIntersections( pos );
        }
    },
} );


const CADManipulatorHammerController = function ( manipulator ) {
    osgGA.getCADManipulatorHammerController().call( this, manipulator );
};

// We override panStart function to call computeZoomOffset (needed since last changes related to ortho zoom)
CADManipulatorHammerController.prototype = osg.objectInherit( osgGA.getCADManipulatorHammerController().prototype, {
    panStart: function ( event ) {
        if ( !this._isValid ) return;

        const manipulator = this._manipulator;
        if ( !manipulator || this._transformStarted || event.pointerType === 'mouse' ) {
            return;
        }

        this._dragStarted = true;
        this._nbPointerLast = this._computeTouches( event );

        let pos;
        if ( this._nbPointerLast === 3 || this._nbPointerLast === 2 ) {
            pos = manipulator.getPositionRelativeToCanvas( event.center.x, event.center.y );
            this._lastPos = pos;
        } else if ( this._nbPointerLast === 1 ) {
            if ( this._lastPos === undefined ) {
                pos = manipulator.getCanvasCenter();
            } else {
                pos = this._lastPos;
            }
        } else {
            // Sometimes more than 3 pointer events are being detected in some touch devices (it can be forced by touching with 4 fingers)
            return;
        }

        manipulator.computeZoomOffset( pos ); // needs to compute zoom offset to do correctly zoom
        manipulator.computeIntersections( pos, event );

        if ( this._nbPointerLast === 3 ) {
            let panInterpolator = manipulator.getPanInterpolator();
            manipulator.getPanInterpolator().reset();
            let xPan = event.center.x * this._panFactorX;
            let yPan = event.center.y * this._panFactorY;
            panInterpolator.set( xPan, yPan );
        } else if ( this._nbPointerLast === 1 ) {
            manipulator.getRotateInterpolator().reset();
        }
    }
} );


var CADManipulator = function () {
    osgGA.CADManipulator.call( this );
    this._orthoMode = false;

    this._orthoFrustum = undefined;
    this._zoomOffset = osg.vec2.create();
    this._center = osg.vec3.create();
    this._orthoEye = osg.vec3.create();
    this._orthoNear = 0.1;
    this._orthoFar = 10000;
};

CADManipulator.prototype = osg.objectInherit( osgGA.CADManipulator.prototype, {

    computePan: ( function () {
        let trans = osg.vec3.create();
        let rotPos = osg.vec3.create();
        let speedTmp = osg.vec3.create();
        return function ( dx, dy, rotMat ) {
            const eye = this._orthoMode ? this._orthoEye : this._eye;
            let speed =
                osg.vec3.length( osg.vec3.sub( speedTmp, eye, this._pivotPoint ) ) / this._panFactor;

            if ( speed < 1 ) speed = 1; // This line in OSG code is: if ( speed < 10 ) speed = 10;

            trans[ 0 ] = dx * speed / 2;
            trans[ 1 ] = dy * speed / 2;
            trans[ 2 ] = 0;
            osg.vec3.transformMat4( rotPos, trans, rotMat );
            osg.vec3.add( this._eye, this._eye, rotPos );
            if ( this._orthoMode )
                osg.vec3.add( this._orthoEye, this._orthoEye, rotPos );
        };
    } )(),

    computeFrustum: function () {
        var viewport = this._camera.getViewport();
        var aspect = viewport.height() / viewport.width();

        osg.mat4.ortho( this._camera.getProjectionMatrix(), this._orthoFrustum.left, this._orthoFrustum.right,
            this._orthoFrustum.bottom * aspect, this._orthoFrustum.top * aspect,
            this._orthoNear, this._orthoFar );
    },

    updateWorldCoords: function () {

        var worldCoord = this.getCamera().getView().getIntersectionPoint( this._ev );
        if ( worldCoord ) {
            this._worldCoord = worldCoord;
        }
    },

    computeZoom: ( function () {
        let vectorDistance = vec3.create();
        let speedDist = vec3.create();
        return function ( dz ) {
            if ( this._orthoMode ) {
                if ( !dz )
                    return;

                this.updateWorldCoords();

                const width = this._orthoFrustum.right - this._orthoFrustum.left;
                const height = this._orthoFrustum.top - this._orthoFrustum.bottom;

                const offsetX = this._orthoFrustum.left + width * this._zoomOffset[ 0 ];
                const offsetY = this._orthoFrustum.bottom + height * this._zoomOffset[ 1 ];

                const doubleTapLimit = 0.1;
                const doubleTapScale = 0.35;

                const zoomScale = dz > doubleTapLimit ? doubleTapScale : 1;
                const zoomFactor = dz * this._zoomFactor * zoomScale;

                this._orthoEye[ 0 ] = this._orthoEye[ 0 ] + ( ( this._pivotPoint[ 0 ] - this._orthoEye[ 0 ] ) * zoomFactor );
                this._orthoEye[ 1 ] = this._orthoEye[ 1 ] + ( ( this._pivotPoint[ 1 ] - this._orthoEye[ 1 ] ) * zoomFactor );
                this._orthoEye[ 2 ] = this._orthoEye[ 2 ] + ( ( this._pivotPoint[ 2 ] - this._orthoEye[ 2 ] ) * zoomFactor );

                this._orthoFrustum.left = this._orthoFrustum.left * ( 1 - zoomFactor ) + offsetX * zoomFactor;
                this._orthoFrustum.right = this._orthoFrustum.right * ( 1 - zoomFactor ) + offsetX * zoomFactor;
                this._orthoFrustum.top = this._orthoFrustum.top * ( 1 - zoomFactor ) + offsetY * zoomFactor;
                this._orthoFrustum.bottom = this._orthoFrustum.bottom * ( 1 - zoomFactor ) + offsetY * zoomFactor;
                this.computeFrustum();
                return;
            }
            let zoomSpeed = dz * this._zoomFactor;
            zoomSpeed = Math.min( 0.99, zoomSpeed );
            vec3.sub( vectorDistance, this._pivotPoint, this._eye );
            vec3.add( this._eye, this._eye, vec3.scale( speedDist, vectorDistance, zoomSpeed ) );
        };
    } )(),

    getOrthoEyePosition: function ( out ) {
        vec3.copy( out, this._orthoEye );
    },

    getOrthoFrustum: function () {
        let frustum = {};
        frustum[ 'top' ] = this._orthoFrustum.top;
        frustum[ 'bottom' ] = this._orthoFrustum.bottom;
        frustum[ 'left' ] = this._orthoFrustum.left;
        frustum[ 'right' ] = this._orthoFrustum.right;

        return frustum;
    },

    setOrthoFrustum: function ( frustum ) {
        this._orthoFrustum = frustum;
    },

    setEnableOrtho: function ( ortho ) {
        this._orthoMode = ortho;
    },

    isEnabledOrtho: function () {
        return this._orthoMode;
    },

    setOrthoNear: function ( near ) {
        this._orthoNear = near;
    },

    setOrthoFar: function ( far ) {
        this._orthoFar = far;
    },

    computeRotation: ( function () {
        var rightNormalized = vec3.create();
        var right = vec3.create();
        var dir = vec3.create();
        var offset = vec3.create();
        var pitchQuat = quat.create();
        var yawQuat = quat.create();
        var pitchyawQuat = quat.create();
        var tmp = vec3.create();
        var rightScalar = vec3.create();
        var rotMat = osg.mat4.create();

        return function ( yawDelta, pitchDelta ) {
            if ( this._rotateForbidden ) {
                osg.mat4.fromQuat( rotMat, this._orientation );
                this.computePan( yawDelta, -pitchDelta, rotMat );
                return;
            }
            vec3.transformQuat( right, this._right, this._orientation );
            vec3.normalize( rightNormalized, right );
            vec3.sub( dir, this._eye, this._pivotPoint );
            var scalar = vec3.dot( rightNormalized, dir );
            vec3.sub( offset, dir, vec3.scale( rightScalar, rightNormalized, scalar ) );
            var xy = vec3.fromValues( -offset[ 0 ], -offset[ 1 ], 0 );

            var positionPitch = Math.atan2( -offset[ 2 ], vec3.length( xy ) );

            pitchDelta =
                Math.max( -Math.PI / 2 + 0.0001,
                    Math.min( Math.PI / 2 - 0.0001, positionPitch + pitchDelta )
                ) - positionPitch;

            quat.setAxisAngle( pitchQuat, right, pitchDelta * this._rotateFactor );
            quat.setAxisAngle( yawQuat, this._upz, yawDelta * this._rotateFactor );

            quat.mul( pitchyawQuat, yawQuat, pitchQuat );
            vec3.transformQuat( tmp, dir, pitchyawQuat );
            vec3.add( this._eye, tmp, this._pivotPoint );

            // Find rotation offset and target
            quat.mul( this._orientation, yawQuat, this._orientation );

            vec3.transformQuat( right, this._right, this._orientation );
            quat.setAxisAngle( pitchQuat, right, pitchDelta * this._rotateFactor );
            quat.mul( this._orientation, pitchQuat, this._orientation );
        };
    } )(),

    setRotateForbidden: function ( flag ) {
        this._rotateForbidden = flag;
    },

    computeZoomOffset: function ( pos ) {
        const viewport = this._camera.getViewport();
        this._zoomOffset[ 0 ] = ( ( pos[ 0 ] - viewport.width() / 2 ) / viewport.width() ) + 0.5;
        this._zoomOffset[ 1 ] = ( ( pos[ 1 ] - viewport.height() / 2 ) / viewport.height() ) + 0.5;
    },

    computeHomePosition: ( function () {
        let f = vec3.create();
        let s = vec3.create();
        let u = vec3.create();
        let result = mat4.create();
        return function ( boundStrategy ) {
            const bs = this.getHomeBoundingSphere( boundStrategy );
            if ( !bs ) return;
            this.setDistance( this.getHomeDistance( bs ) );
            this.setTarget( bs.center() );
            this.setPivotPoint( bs.center() );

            if ( this._homeEye === undefined ) {
                this._homeEye = vec3.create();
                this.getEyePosition( this._homeEye );
            }

            if ( this._homeCenter === undefined ) {
                this._homeCenter = vec3.create();
                vec3.copy( this._homeCenter, bs.center() );
            }

            if ( this._eye === undefined ) {
                this._eye = vec3.create();
            }

            vec3.copy( this._eye, this._homeEye );
            // This function comes from OSGJS and we added this orthoEye in order to 
            // calculate the distance for panning in orthographic mode correctly.
            vec3.copy( this._orthoEye, this._homeEye );
            vec3.copy( this._target, this._homeCenter );
            vec3.copy( this._upz, this._homeUp );

            mat4.copy( result, this._rotation );
            const center = this._target;
            const eye = this._eye;

            vec3.sub( f, center, eye );
            vec3.normalize( f, f );

            vec3.cross( s, f, this._upz );
            vec3.normalize( s, s );

            vec3.cross( u, s, f );
            vec3.normalize( u, u );

            // s[0], f[0], u[0], 0.0,
            // s[1], f[1], u[1], 0.0,
            // s[2], f[2], u[2], 0.0,
            // 0,    0,    0,     1.0
            result[ 0 ] = s[ 0 ];
            result[ 1 ] = u[ 0 ];
            result[ 2 ] = -f[ 0 ];
            result[ 3 ] = 0.0;
            result[ 4 ] = s[ 1 ];
            result[ 5 ] = u[ 1 ];
            result[ 6 ] = -f[ 1 ];
            result[ 7 ] = 0.0;
            result[ 8 ] = s[ 2 ];
            result[ 9 ] = u[ 2 ];
            result[ 10 ] = -f[ 2 ];
            result[ 11 ] = 0.0;
            result[ 12 ] = 0;
            result[ 13 ] = 0;
            result[ 14 ] = 0;
            result[ 15 ] = 1.0;

            mat4.getRotation( this._orientation, result );
            quat.invert( this._orientation, this._orientation );
        };
    } )(),

    // Override method to manage polytope size for tablets using Collage Site
    computeIntersections: ( function () {
        let hits = [];
        const pTrans = vec3.create();
        return function ( pos, ev ) {
            var viewer = this._camera.getView();

            var cam = this._camera;
            var width = cam.getViewport().width();
            var height = cam.getViewport().height();
            this._rotate.setWidth( width );
            this._rotate.setHeight( height );
            this._pan.setWidth( width );
            this._pan.setHeight( height );

            var point, matrix;
            if ( ( this._primitiveMask & osgUtil.TRIANGLE_PRIMITIVES ) !== 0 ) {
                hits = viewer.computeIntersections( pos[ 0 ], pos[ 1 ] );

                if ( hits.length > 0 ) {
                    point = hits[ 0 ]._localIntersectionPoint;
                    hits[ 0 ]._nodePath.shift();
                    matrix = osg.computeLocalToWorld( hits[ 0 ]._nodePath );
                    vec3.transformMat4( pTrans, point, matrix );
                    this.setPivotPoint( pTrans );
                }
            }

            if ( hits.length === 0 && this._usePolytopeIntersector ) {
                var pi = this.getOrCreatePolytopeIntersector();
                pi.reset();
                let pSize = 5;
                if ( ev && ev.pointerType === 'touch' ) { // Is touch event
                    pSize = 10.0 * window.devicePixelRatio;
                }
                pi.setPolytopeFromWindowCoordinates(
                    pos[ 0 ] - pSize,
                    pos[ 1 ] - pSize,
                    pos[ 0 ] + pSize,
                    pos[ 1 ] + pSize
                );
                var iv = this._intersectionVisitor;
                iv.setIntersector( pi );
                viewer.getCamera().accept( iv );
                hits = pi.getIntersections();
                hits.sort( function ( a, b ) {
                    return a._distance - b._distance;
                } );
                if ( hits.length > 0 ) {
                    point = hits[ 0 ]._localIntersectionPoint;
                    hits[ 0 ]._nodePath.shift();
                    matrix = osg.computeLocalToWorld( hits[ 0 ]._nodePath );
                    vec3.transformMat4( pTrans, point, matrix );
                    this.setPivotPoint( pTrans );
                }
            }
        };
    } )(),

} );

osgGA.CADManipulator.StandardMouseKeyboard = CADManipulatorStandardMouseKeyboardController;
osgGA.CADManipulator.Hammer = CADManipulatorHammerController;

module.exports = CADManipulator;


/***/ }),

/***/ "./sources/pcvizManipulator/FirstPersonManipulator.js":
/*!************************************************************!*\
  !*** ./sources/pcvizManipulator/FirstPersonManipulator.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgGA = OSG.osgGA;

var FirstPersonStandardMouseKeyboardController = function ( manipulator ) {
    osgGA.getFirstPersonStandardMouseKeyboardControllerClass().call( this, manipulator );
    this._timer = false;
};

FirstPersonStandardMouseKeyboardController.prototype = osg.objectInherit( osgGA.getFirstPersonStandardMouseKeyboardControllerClass().prototype, {
    mousewheel: function ( ev, intDelta ) {
        var manipulator = this._manipulator;
        ev.preventDefault();
        var zoomTarget = manipulator.getZoomInterpolator().getTarget()[ 0 ] - intDelta;
        manipulator.getZoomInterpolator().setTarget( zoomTarget );
        var timer;
        if ( this._timer === false ) {
            this._timer = true;
            var that = this;
            clearTimeout( timer );
            timer = setTimeout( function () {
                that._timer = false;
            }, 200 );
            var pos = manipulator.getPositionRelativeToCanvas( ev.clientX, ev.clientY );
            manipulator.computeZoomOffset( pos );
        }
    }
} );

const FirstPersonManipulatorHammerController = function ( manipulator ) {
    osgGA.getFirstPersonManipulatorHammerController().call( this, manipulator );
};

// We override panStart function to call computeZoomOffset
FirstPersonManipulatorHammerController.prototype = osg.objectInherit( osgGA.getFirstPersonManipulatorHammerController().prototype, {
    panStart: function ( event ) {
        if ( !this._isValid || this._transformStarted || event.pointerType === 'mouse' ) {
            return;
        }

        this._dragStarted = true;
        const manipulator = this._manipulator;
        this._nbPointerLast = this._computeTouches( event );

        if ( this._nbPointerLast === 2 ) {
            let panInterpolator = manipulator.getPanInterpolator();
            panInterpolator.reset();
            let xPan = event.center.x * this._panFactorX;
            let yPan = event.center.y * this._panFactorY;
            panInterpolator.set( xPan, yPan );

            let pos = manipulator.getPositionRelativeToCanvas( event.center.x, event.center.y );
            manipulator.computeZoomOffset( pos ); // needs to compute zoom offset to do correctly zoom

        } else {
            let rotateInterpolator = manipulator.getRotateInterpolator();
            rotateInterpolator.reset();
            let xRot = event.center.x * this._rotateFactorX;
            let yRot = event.center.y * this._rotateFactorY;
            rotateInterpolator.set( xRot, yRot );
        }

    }
} );

var FirstPersonManipulator = function () {
    osgGA.FirstPersonManipulator.call( this );
    this._zoomFactor = 1;
    this._zoomOffset = osg.vec2.create();
};

FirstPersonManipulator.prototype = osg.objectInherit( osgGA.FirstPersonManipulator.prototype, {

    setZoomFactor: function ( f ) {
        this._zoomFactor = f;
    },

    setHomePosition: function ( eye, center /*, up */ ) {
        this.setEyePosition( eye );
        this.setTarget( center );
    },

    // This method overrides FirstPersonManipulator.setPoseVR from OSGjs because
    // there is a bug in it.
    // Don't remove it until we update to the latest OSGjs version.
    setPoseVR: function ( q, pos ) {
        this._vrEnable = true;
        osg.quat.copy( this._vrRot, q );
        osg.vec3.sub( this._vrTrans, pos, this._vrPos );
        osg.vec3.copy( this._vrPos, pos );
    },

    update: ( function () {
        var tmpTarget = osg.vec3.create();

        return function ( nv ) {

            var dt = nv.getFrameStamp().getDeltaTime();

            var delta = this._lookPosition.update( dt );

            this.computeRotation( -delta[ 0 ] * 0.5, -delta[ 1 ] * 0.5 );

            delta = this._zoom.update( dt );
            osg.mat4.getFrustum( this._frustum, this._camera.getProjectionMatrix() );
            this.computeZoom( delta[ 0 ] );
            osg.mat4.frustum( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right, this._frustum.bottom, this._frustum.top, this._frustum.zNear, this._frustum.zFar );

            osg.vec3.add( tmpTarget, this._eye, this._direction );
            osg.mat4.lookAt( this._inverseMatrix, this._eye, tmpTarget, this._up );

            this._vrEnable = false; // setPoseVR is called on each frame
        };
    } )(),

    getPositionRelativeToCanvas: osgGA.CADManipulator.prototype.getPositionRelativeToCanvas,
    getOffsetRect: osgGA.CADManipulator.prototype.getOffsetRect,

    setFrustum: function ( top, bottom, right, left, near, far ) {
        this._frustum.left = left;
        this._frustum.right = right;
        this._frustum.bottom = bottom;
        this._frustum.top = top;
        this._frustum.zNear = near;
        this._frustum.zFar = far;
        if ( this._camera )
            osg.mat4.frustum( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right, this._frustum.bottom, this._frustum.top, this._frustum.zNear, this._frustum.zFar );
    },

    getZoomOffset: function () {
        return this._zoomOffset;
    },

    setZoomOffset: function ( zoomX, zoomY ) {
        this._zoomOffset[ 0 ] = zoomX;
        this._zoomOffset[ 1 ] = zoomY;
    },

    computeZoom: function ( dz ) {
        if ( !dz )
            return;

        var width = this._frustum.right - this._frustum.left;
        var height = this._frustum.top - this._frustum.bottom;

        var zoomFactor = -dz * this._zoomFactor * 0.1;

        var offsetX = this._frustum.left + width * this._zoomOffset[ 0 ];
        var offsetY = this._frustum.bottom + height * this._zoomOffset[ 1 ];

        var left = this._frustum.left * ( 1 - zoomFactor ) + offsetX * zoomFactor;
        var right = this._frustum.right * ( 1 - zoomFactor ) + offsetX * zoomFactor;
        var top = this._frustum.top * ( 1 - zoomFactor ) + offsetY * zoomFactor;
        var bottom = this._frustum.bottom * ( 1 - zoomFactor ) + offsetY * zoomFactor;

        var fovy = 180 / Math.PI * ( Math.atan( top / this._frustum.zNear ) - Math.atan( bottom / this._frustum.zNear ) );
        if ( fovy > 5 && fovy < 80 ) {
            this._frustum.left = left;
            this._frustum.right = right;
            this._frustum.top = top;
            this._frustum.bottom = bottom;
        }
    },

    computeZoomOffset: function ( pos ) {
        var viewport = this._camera.getViewport();
        this._zoomOffset[ 0 ] = ( ( pos[ 0 ] - viewport.width() / 2 ) / viewport.width() ) + 0.5;
        this._zoomOffset[ 1 ] = ( ( pos[ 1 ] - viewport.height() / 2 ) / viewport.height() ) + 0.5;
    },

} );

osgGA.FirstPersonManipulator.StandardMouseKeyboard = FirstPersonStandardMouseKeyboardController;
osgGA.FirstPersonManipulator.Hammer = FirstPersonManipulatorHammerController;

module.exports = FirstPersonManipulator;


/***/ }),

/***/ "./sources/pcvizManipulator/ImageManipulator.js":
/*!******************************************************!*\
  !*** ./sources/pcvizManipulator/ImageManipulator.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var ImageManipulatorStandardMouseKeyboard = __webpack_require__( /*! pcvizManipulator/ImageManipulatorStandardMouseKeyboard */ "./sources/pcvizManipulator/ImageManipulatorStandardMouseKeyboard.js" );


var osg = OSG.osg;
var osgGA = OSG.osgGA;
var osgUtil = OSG.osgUtil;

var ImageManipulator = function () {
    osgGA.Manipulator.call( this );
    this._savedZoomFactor = undefined;

    this.init();
};

ImageManipulator.AvailableControllerList = [ 'StandardMouseKeyboard', 'Hammer' ];
ImageManipulator.ControllerList = [ 'StandardMouseKeyboard', 'Hammer' ];

ImageManipulator.prototype = osg.objectInherit( osgGA.Manipulator.prototype, {

    init: function () {
        this._eye = osg.vec3.fromValues( 0.0, 25.0, 10.0 );
        this._center = osg.vec3.create();
        this._up = osg.vec3.fromValues( 0.0, 0.0, 1.0 );

        this._zoom = new osgUtil.DelayInterpolator( 1 );
        this._zoomFactor = 1;
        this._zoomOffset = osg.vec2.create();

        this._pan = new osgUtil.DelayInterpolator( 2 );
        this._panFactor = 1;

        this._minFOVY = 0.1; // requested to be able to zoom very close to subpixel details
        this._maxFOVY = 180;
        this._orthoNear = 0.1;
        this._orthoFar = 10000;
        var self = this;

        this._controllerList = {};
        ImageManipulator.ControllerList.forEach( function ( value ) {
            if ( ImageManipulator[ value ] === undefined )
                return;

            if ( self._controllerList[ value ] )
                self._controllerList[ value ].init();
            else
                self._controllerList[ value ] = new ImageManipulator[ value ]( self );
        } );
    },

    getZoomInterpolator: function () {
        return this._zoom;
    },

    getPanInterpolator: function () {
        return this._pan;
    },

    getRotateInterpolator: function () {
        // For compatibility with OrbitManipulatorHammerController
        return this._pan;
    },

    setHomePosition: function ( eye, center, up ) {
        osg.vec3.copy( this._eye, eye );
        osg.vec3.copy( this._center, center );
        osg.vec3.copy( this._up, up );
    },

    setFOVY: function ( fovy ) {
        osg.mat4.getFrustum( this._frustum, this._camera.getProjectionMatrix() );
        osg.mat4.perspective( this._camera.getProjectionMatrix(), fovy, this._camera.getViewport().width() / this._camera.getViewport().height(), this._frustum.zNear, this._frustum.zFar );
    },

    setMinFOVY: function ( minFovy ) {
        this._minFOVY = minFovy;
    },

    update: function ( nv ) {

        var dt = nv.getFrameStamp().getDeltaTime();

        osg.mat4.getFrustum( this._frustum, this._camera.getProjectionMatrix() );

        var delta = this._pan.update( dt );
        this.computePan( delta[ 0 ], delta[ 1 ] );

        delta = this._zoom.update( dt );
        this.computeZoom( delta[ 0 ] );
        if ( !this._orthoMode )
            osg.mat4.frustum( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right, this._frustum.bottom, this._frustum.top, this._frustum.zNear, this._frustum.zFar );

        osg.mat4.lookAt( this._inverseMatrix, this._eye, this._center, this._up );

        this._vrEnable = false; // setPoseVR is called on each frame
    },

    setZoomAtImageLocation: function ( imgWidth, imgHeight, relPosX, relPosY, zoomFactor, useZoomFactor ) {
        if ( !useZoomFactor && this._savedZoomFactor !== undefined )
            zoomFactor = this._savedZoomFactor;
        // we assume an initial full view frustum
        var frustumWidth = this._frustum.right - this._frustum.left;
        var frustumHeight = this._frustum.top - this._frustum.bottom;
        var frustumAspect = frustumWidth / frustumHeight;
        var imgAspect = imgWidth / imgHeight;

        var cenX;
        var cenY;
        if ( frustumAspect > imgAspect ) {

            cenX = ( relPosX - 0.5 ) * frustumHeight * imgAspect;
            cenY = ( relPosY - 0.5 ) * frustumHeight;

        } else {

            cenX = ( relPosX - 0.5 ) * frustumWidth;
            cenY = ( relPosY - 0.5 ) * frustumWidth / imgAspect;

        }
        this.setFrustum( cenY + zoomFactor, cenY - zoomFactor, cenX + zoomFactor * frustumAspect, cenX - zoomFactor * frustumAspect, this._frustum.zNear, this._frustum.zFar );
    },

    setFrustum: function ( top, bottom, right, left, near, far ) {
        this._frustum.left = left;
        this._frustum.right = right;
        this._frustum.bottom = bottom;
        this._frustum.top = top;
        this._frustum.zNear = near;
        this._frustum.zFar = far;
        if ( this._camera )
            osg.mat4.frustum( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right, this._frustum.bottom, this._frustum.top, this._frustum.zNear, this._frustum.zFar );
    },

    getPositionRelativeToCanvas: osgGA.CADManipulator.prototype.getPositionRelativeToCanvas,
    getOffsetRect: osgGA.CADManipulator.prototype.getOffsetRect,

    computePan: function ( dx, dy ) {
        if ( ( !dx && !dy ) || ( Math.abs( dx ) < 0.0001 && Math.abs( dy ) < 0.0001 ) )
            return;

        dx = dx / this._camera.getViewport().width();
        dy = dy / this._camera.getViewport().height();

        if ( this._orthoMode ) {
            this._frustum.left = this._orthoFrustum.left;
            this._frustum.right = this._orthoFrustum.right;
            this._frustum.top = this._orthoFrustum.top;
            this._frustum.bottom = this._orthoFrustum.bottom;
        }
        var width = this._frustum.right - this._frustum.left;
        var height = this._frustum.top - this._frustum.bottom;

        this._frustum.left -= dx * width * this._panFactor;
        this._frustum.right -= dx * width * this._panFactor;
        this._frustum.top -= dy * height * this._panFactor;
        this._frustum.bottom -= dy * height * this._panFactor;
        if ( this._orthoMode ) {
            osg.mat4.ortho( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right,
                this._frustum.bottom, this._frustum.top,
                this._orthoNear, this._orthoFar );

            this._orthoFrustum = this._frustum;
        }
    },

    computeFrustum: function () {
        osg.mat4.ortho( this._camera.getProjectionMatrix(), this._orthoFrustum.left, this._orthoFrustum.right,
            this._orthoFrustum.bottom, this._orthoFrustum.top,
            this._orthoNear, this._orthoFar );
    },

    computeZoom: function ( dz ) {
        if ( !dz || Math.abs( dz ) < 0.0001 )
            return;

        var target = this._pan.getTarget();
        var pos = this.getPositionRelativeToCanvas( target[ 0 ], -target[ 1 ] );
        this.computeZoomOffset( pos );

        if ( this._orthoMode ) {
            this._frustum.left = this._orthoFrustum.left;
            this._frustum.right = this._orthoFrustum.right;
            this._frustum.top = this._orthoFrustum.top;
            this._frustum.bottom = this._orthoFrustum.bottom;
        }

        var width = this._frustum.right - this._frustum.left;
        var height = this._frustum.top - this._frustum.bottom;

        var zoomFactor = -dz * this._zoomFactor * 0.1;

        var offsetX = this._frustum.left + width * this._zoomOffset[ 0 ];
        var offsetY = this._frustum.bottom + height * this._zoomOffset[ 1 ];

        var left = this._frustum.left * ( 1 - zoomFactor ) + offsetX * zoomFactor;
        var right = this._frustum.right * ( 1 - zoomFactor ) + offsetX * zoomFactor;
        var top = this._frustum.top * ( 1 - zoomFactor ) + offsetY * zoomFactor;
        var bottom = this._frustum.bottom * ( 1 - zoomFactor ) + offsetY * zoomFactor;

        var fovy = 180 / Math.PI * ( Math.atan( top / this._frustum.zNear ) - Math.atan( bottom / this._frustum.zNear ) );
        if ( ( dz < 0 && fovy > this._minFOVY ) || ( dz > 0 && fovy < this._maxFOVY ) ) {
            this._frustum.left = left;
            this._frustum.right = right;
            this._frustum.top = top;
            this._frustum.bottom = bottom;
        }

        if ( this._orthoMode ) {
            osg.mat4.ortho( this._camera.getProjectionMatrix(), this._frustum.left, this._frustum.right,
                this._frustum.bottom, this._frustum.top,
                this._orthoNear, this._orthoFar );

            this._orthoFrustum = this._frustum;
        }
    },

    computeZoomOffset: function ( pos ) {
        var viewport = this._camera.getViewport();
        this._zoomOffset[ 0 ] = ( ( pos[ 0 ] - viewport.width() / 2 ) / viewport.width() ) + 0.5;
        this._zoomOffset[ 1 ] = ( ( pos[ 1 ] - viewport.height() / 2 ) / viewport.height() ) + 0.5;
    },

    setSavedZoomFactor: function ( value ) {
        this._savedZoomFactor = value;
    },
    setEnableOrtho: function ( ortho ) {
        this._orthoMode = ortho;
    },
    setOrthoFrustum: function ( frustum ) {
        this._orthoFrustum = frustum;
    },

    getOrthoFrustum: function () {
        var viewport = this._camera.getViewport();
        var aspect = viewport.height() / viewport.width();
        var frustum = {};
        frustum[ 'top' ] = this._orthoFrustum.top;
        frustum[ 'bottom' ] = this._orthoFrustum.bottom;
        frustum[ 'left' ] = this._orthoFrustum.left * aspect;
        frustum[ 'right' ] = this._orthoFrustum.right * aspect;

        return frustum;
    },

    setOrthoNear: function ( near ) {
        this._orthoNear = near;
    },

    setOrthoFar: function ( far ) {
        this._orthoFar = far;
    },

    updateOrthoFrustum: function () {
        var viewport = this._camera.getViewport();
        var aspect = viewport.width() / viewport.height();

        osg.mat4.ortho( this._camera.getProjectionMatrix(), this._orthoFrustum.bottom * aspect, this._orthoFrustum.top * aspect,
            this._orthoFrustum.bottom, this._orthoFrustum.top, this._orthoNear, this._orthoFar );

        this._orthoFrustum.left = this._orthoFrustum.bottom * aspect;
        this._orthoFrustum.right = this._orthoFrustum.top * aspect;
    },


} );

ImageManipulator.StandardMouseKeyboard = ImageManipulatorStandardMouseKeyboard;
ImageManipulator.Hammer = osgGA.getOrbitManipulatorHammerController();
module.exports = ImageManipulator;


/***/ }),

/***/ "./sources/pcvizManipulator/ImageManipulatorStandardMouseKeyboard.js":
/*!***************************************************************************!*\
  !*** ./sources/pcvizManipulator/ImageManipulatorStandardMouseKeyboard.js ***!
  \***************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgGA = OSG.osgGA;

var ImageManipulatorStandardMouseKeyboard = function ( manipulator ) {
    osgGA.Controller.call( this, manipulator );
    this.init();
};


// Inherit from osgGA.Controller. Remember overwrite 'setEnable' if we use it and we want to reset some vars there
ImageManipulatorStandardMouseKeyboard.prototype = osg.objectInherit( osgGA.Controller.prototype, {

    init: function () {
        this.releaseButton();
        this._timer = false;
        this._delay = 0.15;
    },

    setEventProxy: function ( proxy ) {
        this._eventProxy = proxy;
    },

    pushButton: function () {
        this._buttonup = false;
    },

    releaseButton: function () {
        this._buttonup = true;
    },

    mousemove: function ( ev ) {
        if ( this._buttonup === true ) {
            return;
        }
        var pos = this._eventProxy.getPositionRelativeToCanvas( ev );
        var manipulator = this._manipulator;
        if ( osg.isNaN( pos[ 0 ] ) === false && osg.isNaN( pos[ 1 ] ) === false ) {
            manipulator.getPanInterpolator().setDelay( this._delay );
            manipulator.getPanInterpolator().setTarget( pos[ 0 ], pos[ 1 ] );
        }
    },

    mousedown: function ( ev ) {
        var manipulator = this._manipulator;
        this.pushButton();

        var pos = this._eventProxy.getPositionRelativeToCanvas( ev );
        manipulator.getPanInterpolator().reset();
        manipulator.getPanInterpolator().set( pos[ 0 ], pos[ 1 ] );

        ev.preventDefault();
    },

    mouseup: function () {
        this.releaseButton();
    },

    mousewheel: function ( ev, intDelta ) {
        var manipulator = this._manipulator;
        ev.preventDefault();
        var zoomTarget = manipulator.getZoomInterpolator().getTarget()[ 0 ] - intDelta;
        manipulator.getZoomInterpolator().setTarget( zoomTarget );
        manipulator.getPanInterpolator().reset();
        manipulator.getPanInterpolator().setTarget( ev.clientX, -ev.clientY );
        var timer;
        if ( this._timer === false ) {
            this._timer = true;
            var that = this;
            clearTimeout( timer );
            timer = setTimeout( function () {
                that._timer = false;
            }, 200 );
        }
    }

} );

module.exports = ImageManipulatorStandardMouseKeyboard;


/***/ }),

/***/ "./sources/pcvizManipulator/OrbitManipulator.js":
/*!******************************************************!*\
  !*** ./sources/pcvizManipulator/OrbitManipulator.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgGA = OSG.osgGA;


var OrbitManipulator = function () {
    osgGA.OrbitManipulator.call( this );
};

OrbitManipulator.prototype = osg.objectInherit( osgGA.OrbitManipulator.prototype, {
    setHomePosition: function ( eye, center /*, up */ ) {
        this.setTarget( center );
        this.setEyePosition( eye );
    }
} );

module.exports = OrbitManipulator;


/***/ }),

/***/ "./sources/pcvizManipulator/pcvizManipulator.js":
/*!******************************************************!*\
  !*** ./sources/pcvizManipulator/pcvizManipulator.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ImageManipulator = __webpack_require__( /*! pcvizManipulator/ImageManipulator */ "./sources/pcvizManipulator/ImageManipulator.js" );
var CADManipulator = __webpack_require__( /*! pcvizManipulator/CADManipulator */ "./sources/pcvizManipulator/CADManipulator.js" );
var OrbitManipulator = __webpack_require__( /*! pcvizManipulator/OrbitManipulator */ "./sources/pcvizManipulator/OrbitManipulator.js" );
var FirstPersonManipulator = __webpack_require__( /*! pcvizManipulator/FirstPersonManipulator */ "./sources/pcvizManipulator/FirstPersonManipulator.js" );

// var OrthoManipulator = require( 'pcvizManipulator/OrthoManipulator' );

/** @namespace pcvizManipulator */
var pcvizManipulator = {};
pcvizManipulator.ImageManipulator = ImageManipulator;
pcvizManipulator.OrbitManipulator = OrbitManipulator;
pcvizManipulator.FirstPersonManipulator = FirstPersonManipulator;
pcvizManipulator.CADManipulator = CADManipulator;

// pcvizManipulator.OrthoManipulator = OrthoManipulator;

pcvizManipulator.CAD_MANIPULATOR = 0;
pcvizManipulator.PANORAMA_MANIPULATOR = 1;
pcvizManipulator.PLANAR_IMAGE_MANIPULATOR = 2;
pcvizManipulator.PLANAR_ORTHO_MANIPULATOR = 3;
pcvizManipulator.CONTROL_POINT_MANIPULATOR = 4;
pcvizManipulator.REGION_MANIPULATOR = 5;

module.exports = pcvizManipulator;


/***/ }),

/***/ "./sources/pcvizNode/BufferAttribute.js":
/*!**********************************************!*\
  !*** ./sources/pcvizNode/BufferAttribute.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var MAX_FLT_NUMBER = 3.0e+10;

var BufferAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    this._bufferMode = BufferAttribute.POINT;
    this._onlyBuffer = 0.0;
    this._useBaseColor = 0.0;
    this._pointBuffer = osg.vec3.create(); // osg.vec3.INFINITY; this value does not work right on ipad
    this._pointBuffer[ 0 ] = MAX_FLT_NUMBER;
    this._pointBuffer[ 1 ] = MAX_FLT_NUMBER;
    this._pointBuffer[ 2 ] = MAX_FLT_NUMBER;
    this._lineBuffer = new Float32Array( 150 );
    this._auxMat = osg.mat4.create();
    this._boxMin = osg.vec3.create();
    this._boxMax = osg.vec3.create();
    this._boxRotation = 0.0;

    this._numBufferVertices = 0;
    this._uniformMap = new window.Map();
    this._dataCenter = osg.vec3.create32();

    this._dirtyHash = true;
};


BufferAttribute.POINT = 0;
BufferAttribute.LINE = 1;
BufferAttribute.VERTICAL_LINE = 2;
BufferAttribute.BOX = 3;

BufferAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'Buffer',
    cloneType: function () {
        return new BufferAttribute();
    },

    getOrCreateUniforms: function () {
        if ( this._uniformMap.has( this._bufferMode ) ) return this._uniformMap.get( this._bufferMode );
        var minColor = osg.Uniform.createFloat4( this._minColor, 'minColor' );
        var maxColor = osg.Uniform.createFloat4( this._maxColor, 'maxColor' );
        var useBaseColor = osg.Uniform.createFloat1( this._useBaseColor, 'useBaseColor' );
        var onlyBuffer = osg.Uniform.createFloat1( this._onlyBuffer, 'onlyBuffer' );
        var range = osg.Uniform.createFloat1( this._range, 'range' );
        var uniforms;
        // uniforms list are per ClassType
        switch ( this._bufferMode ) {
        case BufferAttribute.POINT:
            uniforms = {
                minColor: minColor,
                maxColor: maxColor,
                range: range,
                useBaseColor: useBaseColor,
                onlyBuffer: onlyBuffer,
                pointBuffer: osg.Uniform.createFloat3( this._pointBuffer, 'pointBuffer' ),
            };
            break;
        case BufferAttribute.LINE:
        case BufferAttribute.VERTICAL_LINE:
            uniforms = {
                minColor: minColor,
                maxColor: maxColor,
                range: range,
                useBaseColor: useBaseColor,
                onlyBuffer: onlyBuffer,
                lineBuffer: osg.Uniform.createFloat3Array( 'lineBuffer', this._lineBuffer.length / 3 ),
                numBufferVertices: osg.Uniform.createInt1( this._numBufferVertices, 'numBufferVertices' ),
            };
            break;
        case BufferAttribute.BOX:
            uniforms = {
                minColor: minColor,
                maxColor: maxColor,
                range: range,
                useBaseColor: useBaseColor,
                onlyBuffer: onlyBuffer,
                pointBuffer: osg.Uniform.createFloat3( this._pointBuffer, 'pointBuffer' ), // box corner
                lineBuffer: osg.Uniform.createFloat3Array( 'lineBuffer', this._lineBuffer.length / 3 ), // three side vectors
                auxMat: osg.Uniform.createMatrix4( this._auxMat, 'auxMat' ), // transform matrix applied to the pointcloud
                boxMin: osg.Uniform.createFloat3Array( this._boxMin, 'boxMin' ), // min corner of the buffer box
                boxMax: osg.Uniform.createFloat3Array( this._boxMax, 'boxMax' ), // max corner of the buffer box
                boxRotation: osg.Uniform.createFloat1( this._boxRotation, 'boxRotation' ), // rotation angle of the buffer box
            };
        }
        this._uniformMap.set( this._bufferMode, uniforms );
        return uniforms;
    },

    setBufferMode: function ( bufferMode ) {
        // We need to clean the line buffer
        if ( this._bufferMode !== BufferAttribute.POINT && bufferMode === BufferAttribute.POINT ) {
            this._lineBuffer = new Float32Array( 150 );
        }
        this._bufferMode = bufferMode;
        this._dirtyHash = true;
    },

    getBufferMode: function () {
        return this._bufferMode;
    },

    setMinColor: function ( color ) {
        this._minColor = color;
    },

    getMinColor: function () {
        return this._minColor;
    },

    setMaxColor: function ( color ) {
        this._maxColor = color;
    },

    getMaxColor: function () {
        return this._maxColor;
    },

    transformPointToBufferCoords: function ( point ) {

        var resultVec = osg.vec3.create64();
        osg.vec3.sub( resultVec, point, this._globalCenter );

        if ( this._dataMT ) {
            osg.vec3.transformMat4( resultVec, resultVec, this._dataMT );

            osg.vec3.sub( resultVec, resultVec, this._dataCenter );
        }

        return resultVec;
    },

    setPointBuffer: function ( point ) {
        // We need to avoid world coordinates because of precission issues, so we substract dataCenter

        this._pointBuffer = osg.vec3.create64();

        osg.vec3.sub( this._pointBuffer, point, this._globalCenter );

        // for point cloud layers
        if ( this._dataMT ) {
            osg.vec3.transformMat4( this._pointBuffer, this._pointBuffer, this._dataMT );

            osg.vec3.sub( this._pointBuffer, this._pointBuffer, this._dataCenter );
        }
    },

    getPointBuffer: function () {
        return this._pointBuffer;
    },

    setRange: function ( range ) {
        this._range = range;
    },

    getRange: function () {
        return this._range;
    },

    setOnlyBuffer: function ( value ) {
        this._onlyBuffer = value;
    },

    getOnlyBuffer: function () {
        return this._onlyBuffer;
    },

    setUseBaseColor: function ( value ) {
        this._useBaseColor = value;
    },

    getUseBaseColor: function () {
        return this._useBaseColor;
    },

    setNumBufferVertices: function ( num ) {
        this._numBufferVertices = num;
    },

    getNumBufferVertices: function () {
        return this._numBufferVertices;
    },

    setLineBuffer: function ( lineBuffer ) {
        for ( var i = 0; i < lineBuffer.length; i++ ) {

            // We need to avoid world coordinates because of precission issues, so we substract dataCenter
            var iLineBuffer = osg.vec3.create64();
            if ( this._globalCenter )
                osg.vec3.sub( iLineBuffer, lineBuffer[ i ], this._globalCenter );

            if ( this._dataMT ) {
                osg.vec3.transformMat4( iLineBuffer, iLineBuffer, this._dataMT );

                this._lineBuffer[ i * 3 ] = iLineBuffer[ 0 ] - this._dataCenter[ 0 ];
                this._lineBuffer[ i * 3 + 1 ] = iLineBuffer[ 1 ] - this._dataCenter[ 1 ];
                this._lineBuffer[ i * 3 + 2 ] = iLineBuffer[ 2 ] - this._dataCenter[ 2 ];
            } else {
                this._lineBuffer[ i * 3 ] = iLineBuffer[ 0 ];
                this._lineBuffer[ i * 3 + 1 ] = iLineBuffer[ 1 ];
                this._lineBuffer[ i * 3 + 2 ] = iLineBuffer[ 2 ];
            } // for vector layers
        }
        this._numBufferVertices = lineBuffer.length;
    },

    getLineBuffer: function () {
        return this._lineBuffer;
    },

    setBoxBuffer: function ( boxOrigin, boxVectors ) {
        var transBoxOrigin = osg.vec3.create64();

        if ( this._dataMT ) {
            osg.vec3.transformMat4( transBoxOrigin, boxOrigin, this._dataMT );

            this._pointBuffer[ 0 ] = transBoxOrigin[ 0 ] - this._dataCenter[ 0 ];
            this._pointBuffer[ 1 ] = transBoxOrigin[ 1 ] - this._dataCenter[ 1 ];
            this._pointBuffer[ 2 ] = transBoxOrigin[ 2 ] - this._dataCenter[ 2 ]; /* CHECK if we can remove some code in this function */
        } else {
            this._pointBuffer = boxOrigin;
        } // for vector layers

        if ( boxVectors.length !== 3 )
            return;

        for ( var i = 0; i < boxVectors.length; i++ ) {
            var iboxVector = boxVectors[ i ];

            this._lineBuffer[ i * 3 ] = iboxVector[ 0 ];
            this._lineBuffer[ i * 3 + 1 ] = iboxVector[ 1 ];
            this._lineBuffer[ i * 3 + 2 ] = iboxVector[ 2 ];
        }
        this._numBufferVertices = boxVectors.length;
    },

    setEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isEnabled: function () {
        return this._attributeEnable;
    },
    setDataCenter: function ( dataCenter ) {
        this._dataCenter = dataCenter;
    },

    getDataCenter: function () {
        return this._dataCenter;
    },

    setParentNode: function ( parentNode ) {
        this._parentNode = parentNode;
        this.computeDataMT();
    },

    computeDataMT: function () {
        var nodePath = Utils.computeNodePath( this._parentNode );
        var mt = osg.computeLocalToWorld( nodePath, true );

        this._dataMT = osg.mat4.create64();
        osg.mat4.invert( this._dataMT, mt );

        this._auxMat = osg.mat4.clone( mt );
    },

    setGlobalCenter: function ( c ) {
        this._globalCenter = c;
    },

    apply: function () {
        if ( !this._attributeEnable ) return;
        var uniforms = this.getOrCreateUniforms();
        uniforms.minColor.setFloat4( this._minColor );
        uniforms.maxColor.setFloat4( this._maxColor );
        uniforms.range.setFloat( this._range );
        uniforms.onlyBuffer.setFloat( this._onlyBuffer );
        uniforms.useBaseColor.setFloat( this._useBaseColor );
        switch ( this._bufferMode ) {
        case BufferAttribute.POINT:
            uniforms.pointBuffer.setFloat3( this._pointBuffer );
            break;
        case BufferAttribute.LINE:
        case BufferAttribute.VERTICAL_LINE:
            uniforms.lineBuffer.getInternalArray().set( this._lineBuffer );
            uniforms.numBufferVertices.setInt( this._numBufferVertices );
            break;
        case BufferAttribute.BOX:
            uniforms.pointBuffer.setFloat3( this._dataCenter ); // we use this uniform to share the dataCenter with the shader
            uniforms.lineBuffer.getInternalArray().set( this._lineBuffer );
            uniforms.auxMat.getInternalArray().set( this._auxMat );
            uniforms.boxMin.getInternalArray().set( this._boxMin );
            uniforms.boxMax.getInternalArray().set( this._boxMax );
            uniforms.boxRotation.setFloat( this._boxRotation );

            break;
        }
        return uniforms;
    },
    getHash: function () {
        if ( !this._dirtyHash ) return this._hash;

        this._hash = this.getType() + this._bufferMode.toString() + this.isEnabled().toString() + this._useBaseColor.toString() + this._onlyBuffer.toString() + this._boxMin.toString() + this._boxMax.toString() + this._lineBuffer.toString() + this._pointBuffer.toString();
        this._dirtyHash = false;
        return this._hash;
    }
} ), 'osg', 'BufferAttribute' );

module.exports = BufferAttribute;


var BufferNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
    this._bufferAttr = BufferAttribute.POINT;
};

BufferNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'Buffer',
    validInputs: [],
    validOutputs: [ 'VertexColor' ],

    setBufferAttribute: function ( bufferAttr ) {
        this._bufferAttr = bufferAttr;
    },

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        // Include the shader file depending on the selected buffer mode.
        var str;
        switch ( this._bufferAttr.getBufferMode() ) {
        case BufferAttribute.POINT:
            str = '#pragma include "bufferPoint.glsl"';
            break;
        case BufferAttribute.LINE:
            str = '#pragma include "bufferLine.glsl"';
            break;
        case BufferAttribute.VERTICAL_LINE:
            str = '#pragma include "bufferVerticalLine.glsl"';
            break;
        case BufferAttribute.BOX:
            str = '#pragma include "bufferBox.glsl"';
            break;
        }
        return str;
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        return osgShader.utils.callFunction( 'bufferColor', undefined, [ this._outputs.VertexColor ] );
    }

} );

factory.registerNode( 'Buffer', BufferNode );


/***/ }),

/***/ "./sources/pcvizNode/ClampProjectionCallback.js":
/*!******************************************************!*\
  !*** ./sources/pcvizNode/ClampProjectionCallback.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;


var ClampProjectionCallback = {};
ClampProjectionCallback.CLAMP_DISTANCE_FACTOR = 0.1;
ClampProjectionCallback.MIN_CLAMP_DISTANCE = 1.5;
/**
 * Configuration of the ClampProjectionCallback for osg
 * @function
 * @memberof ClampProjectionCallback
 * @param viewer osgViewer.Viewer, required for computing the distance to the target
 * @param configureProjectionFunction Function called with the computed projection matrix to configure the projection matrix on the caller.
 * @return ClampProjectionCallback function (projectionMatrix, zNear, zFar, nearFarRatio) -> see osgjs ClampProjectionMatrix documentation
 */
ClampProjectionCallback.getClampProjectionCallback = function ( viewer, configureProjectionFunction ) {
    var vEye = osg.vec3.create();
    var vCenter = osg.vec3.create();
    var vUp = osg.vec3.create();

    var lastNear = 0;
    var lastFar = 0;

    var isOrtho = function () {
        if ( !viewer )
            return false;
        return viewer.getIsOrtho();
    };
    var getFrustum = function () {
        if ( viewer.getManipulator().getOrthoFrustum !== undefined )
            return viewer.getManipulator().getOrthoFrustum();
        return undefined;
    };
    var computeDistance = function () {
        var distance = ClampProjectionCallback.MIN_CLAMP_DISTANCE;
        if ( !viewer )
            return distance;
        var manipulator = viewer.getManipulator();
        if ( manipulator && manipulator._pivotPoint ) {
            var viewMatrix = viewer.getCamera().getViewMatrix();
            osg.mat4.getLookAt( vEye, vCenter, vUp, viewMatrix, 1.0 );
            distance = osg.vec3.distance( manipulator._pivotPoint, vEye );
        }
        distance = Math.max( distance, ClampProjectionCallback.MIN_CLAMP_DISTANCE );
        return distance;
    };
    var getProjectionMatrix = function () {
        return viewer.getCamera().getProjectionMatrix();
    };

    var setOrthoNearFar = function ( near, far ) {
        if ( near.toFixed( 3 ) === lastNear.toFixed( 3 ) && far.toFixed( 3 ) === lastFar.toFixed( 3 ) )
            return;
        if ( near !== lastNear )
            lastNear = near;
        if ( far !== lastFar )
            lastFar = far;
        viewer.getManipulator().setOrthoNear( near );
        viewer.getManipulator().setOrthoFar( far );
        viewer.getManipulator().computeFrustum();
    };

    return function ( projectionMatrix, zNear, zFar, nearFarRatio ) {

        if ( isOrtho() ) {
            var frus = getFrustum();
            if ( !frus )
                return;
            var deltaSpan = ( zFar - zNear ) * 0.07;
            if ( deltaSpan < 1.0 )
                deltaSpan = 1.0;

            var newZnear = zNear - deltaSpan;
            var newZfar = zFar + deltaSpan;

            // assign the clamped values back to the computed values.
            zNear = newZnear;
            zFar = newZfar;

            var out = osg.mat4.create();
            var lr = 1 / ( frus.left - frus.right );
            var bt = 1 / ( frus.bottom - frus.top );
            var nf = 1 / ( zNear - zFar );
            out[ 0 ] = -2 * lr;
            out[ 5 ] = -2 * bt;
            out[ 10 ] = 2 * nf;
            out[ 12 ] = ( frus.left + frus.right ) * lr;
            out[ 13 ] = ( frus.top + frus.bottom ) * bt;
            out[ 14 ] = ( zNear + zFar ) * nf;
            if ( viewer.needsResetNearFar() ) {
                lastNear = lastFar = 0;
                viewer.setResetNearFar( false );
            }

            setOrthoNearFar( zNear * 0.8, zFar * 1.2 );
            projectionMatrix = getProjectionMatrix();
            if ( configureProjectionFunction ) {
                configureProjectionFunction( out );
            }
            return;
        }

        var distance = computeDistance() * ClampProjectionCallback.CLAMP_DISTANCE_FACTOR;

        var zfarPushRatio = 1.02;
        var znearPullRatio = 0.98;

        var desiredZnear = zNear * znearPullRatio;
        var desiredZfar = zFar * zfarPushRatio;

        // near plane clamping.
        var minNearPlane = zFar * nearFarRatio;
        if ( desiredZnear < minNearPlane ) {
            desiredZnear = Math.min( minNearPlane, ( distance && distance > 0 ) ? distance : minNearPlane );
        }

        // assign the clamped values back to the computed values.
        zNear = desiredZnear;
        zFar = desiredZfar;

        var m22 = projectionMatrix[ 10 ];
        var m32 = projectionMatrix[ 14 ];
        var m23 = projectionMatrix[ 11 ];
        var m33 = projectionMatrix[ 15 ];

        var transNearPlane = ( -zNear * m22 + m32 ) / ( -zNear * m23 + m33 );
        var transFarPlane = ( -zFar * m22 + m32 ) / ( -zFar * m23 + m33 );
        var ratio = Math.abs( 2.0 / ( transNearPlane - transFarPlane ) );
        var center = -( transNearPlane + transFarPlane ) / 2.0;
        var centerRatio = center * ratio;
        projectionMatrix[ 2 ] = projectionMatrix[ 2 ] * ratio + projectionMatrix[ 3 ] * centerRatio;
        projectionMatrix[ 6 ] = projectionMatrix[ 6 ] * ratio + projectionMatrix[ 7 ] * centerRatio;
        projectionMatrix[ 10 ] = m22 * ratio + m23 * centerRatio;
        projectionMatrix[ 14 ] = m32 * ratio + m33 * centerRatio;
        if ( configureProjectionFunction ) {
            configureProjectionFunction( projectionMatrix );
        }
    };
};


module.exports = ClampProjectionCallback;


/***/ }),

/***/ "./sources/pcvizNode/CollagePLOD.js":
/*!******************************************!*\
  !*** ./sources/pcvizNode/CollagePLOD.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Jordi torres <jordi.torres@mirage-tech.com>
 */


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var vec3 = osg.vec3;
var mat4 = osg.mat4;
var Lod = osg.Lod;
var NodeVisitor = osg.NodeVisitor;

/**
 *  CollagePLOD
 *  @class
 *  @memberof pcvizNode
 */
var CollagePLOD = function () {
    osg.PagedLOD.call( this );
};


CollagePLOD.prototype = osg.objectInherit( osg.PagedLOD.prototype, {

    traverse: ( function () {
        // avoid to generate variable on the heap to limit garbage collection
        // instead create variable and use the same each time
        var zeroVector = vec3.create();
        var eye = vec3.create();
        var viewModel = mat4.create();

        return function ( visitor ) {
            var traversalMode = visitor.traversalMode;
            var updateTimeStamp = false;

            if ( visitor.getVisitorType() === NodeVisitor.CULL_VISITOR ) {
                this._frameNumberOfLastTraversal = visitor.getFrameStamp().getFrameNumber();
                updateTimeStamp = true;
            }

            switch ( traversalMode ) {
            case NodeVisitor.TRAVERSE_ALL_CHILDREN:
                for ( var index = 0; index < this.children.length; index++ ) {
                    this.children[ index ].accept( visitor );
                }
                break;

            case NodeVisitor.TRAVERSE_ACTIVE_CHILDREN:
                var requiredRange = 0;

                // Calculate distance from viewpoint
                var matrix = visitor.getCurrentModelViewMatrix();
                mat4.invert( viewModel, matrix );
                if ( this._rangeMode === Lod.DISTANCE_FROM_EYE_POINT ) {
                    vec3.transformMat4( eye, zeroVector, viewModel );
                    var d = vec3.distance( this.getBound().center(), eye );
                    requiredRange = d * visitor.getLODScale();
                } else {
                    // Calculate pixels on screen
                    var projmatrix = visitor.getCurrentProjectionMatrix();
                    // ******************************************
                    // add this to osgjs
                    // ******************************************
                    requiredRange = this.getRequiredRange( this.getBound(), visitor, projmatrix[ 0 ] );

                    //*******************************************
                    if ( requiredRange < 0 )
                        requiredRange = this._range[ this._range.length - 1 ][ 0 ];
                }

                var needToLoadChild = false;
                var lastChildTraversed = -1;
                for ( var j = 0; j < this._range.length; ++j ) {
                    if (
                        this._range[ j ][ 0 ] <= requiredRange &&
                        requiredRange < this._range[ j ][ 1 ]
                    ) {
                        if ( j < this.children.length ) {
                            if ( updateTimeStamp ) {
                                this._perRangeDataList[
                                    j
                                ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                                this._perRangeDataList[
                                    j
                                ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                            }

                            this.children[ j ].accept( visitor );
                            lastChildTraversed = j;
                        } else {
                            needToLoadChild = true;
                        }
                    }
                }
                if ( needToLoadChild ) {
                    var numChildren = this.children.length;
                    if ( numChildren > 0 && numChildren - 1 !== lastChildTraversed ) {
                        if ( updateTimeStamp ) {
                            this._perRangeDataList[
                                numChildren - 1
                            ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                            this._perRangeDataList[
                                numChildren - 1
                            ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                        }

                        this.children[ numChildren - 1 ].accept( visitor );
                    }
                    // now request the loading of the next unloaded child.
                    if ( numChildren < this._perRangeDataList.length ) {
                        // compute priority from where abouts in the required range the distance falls.
                        var priority =
                            ( this._range[ numChildren ][ 0 ] - requiredRange ) /
                            ( this._range[ numChildren ][ 1 ] - this._range[ numChildren ][ 0 ] );
                        if ( this._rangeMode === Lod.PIXEL_SIZE_ON_SCREEN ) {
                            priority = -priority;
                        }
                        // Here we do the request
                        var group = visitor.nodePath[ visitor.nodePath.length - 1 ];
                        if ( this._perRangeDataList[ numChildren ].loaded === false ) {
                            this._perRangeDataList[ numChildren ].loaded = true;
                            var dbhandler = visitor.getDatabaseRequestHandler();
                            this._perRangeDataList[
                                numChildren
                            ].dbrequest = dbhandler.requestNodeFile(
                                this._perRangeDataList[ numChildren ].function,
                                this._databasePath +
                                this._perRangeDataList[ numChildren ].filename,
                                group,
                                visitor.getFrameStamp().getSimulationTime(),
                                priority
                            );
                        } else {
                            // Update timestamp of the request.
                            if (
                                this._perRangeDataList[ numChildren ].dbrequest !== undefined
                            ) {
                                this._perRangeDataList[
                                        numChildren
                                    ].dbrequest._timeStamp = visitor
                                    .getFrameStamp()
                                    .getSimulationTime();
                                this._perRangeDataList[
                                    numChildren
                                ].dbrequest._priority = priority;
                            } else {
                                // The DB request is undefined, so the DBPager was not accepting requests, we need to ask for the child again.
                                this._perRangeDataList[ numChildren ].loaded = false;
                            }
                        }
                    }
                }
                break;
            default:
                break;
            }
        };
    } )(),


} );
module.exports = CollagePLOD;


/***/ }),

/***/ "./sources/pcvizNode/CustomText.js":
/*!*****************************************!*\
  !*** ./sources/pcvizNode/CustomText.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const ComputeBoundingVisitor = __webpack_require__( /*! pcvizUtils/ComputeBoundingVisitor */ "./sources/pcvizUtils/ComputeBoundingVisitor.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const { osg, osgText } = OSG;
const { MatrixTransform, BlendFunc, Light, mat4, ComputeBoundsVisitor } = osg;


/**
 * Defines a customized osg Text object. 
 * Be careful when calling to the setColor function after the text is drawn. TODO: We should overwrite it to avoid possible problems with the verical alignment..
 * Warn: If there are more than one line the vertical alignment is not taken into account. The text is placed in the middle.
 * @class
 * @memberof pcvizNode
 * @extends osg.osgText.Text
 * @param {String} text the text to be shown 
 * @property {osg.vec4} _backgroundColor the background color for the label
 * @property {osg.Light} _fakeLight a disabled light
 */
let CustomText = function ( text ) {
    this._backgroundColor = osg.vec4.fromValues32( 114, 114, 114, 0.8 );
    this._fakeLight = new Light( 0, true );
    this._transparent = true;
    this._labelAlignment = CustomText.LABEL_CENTER;
    this._horizLabelOffset = 0;
    this._verticalLabelOffset = 0;

    this._renderBinValue = Utils.RENDERBIN_CUSTOMTEXT;


    this._texts = []; // to support multi-lines text
    this._newLineString = '\n';

    osgText.Text.call( this, text );
    // Override this function to avoid having a matrix that scales too much the bounding box
    this._matrixTransform.computeLocalToWorldMatrix = function ( matrix, nodeVisitor ) {
        if ( nodeVisitor instanceof ComputeBoundsVisitor || nodeVisitor instanceof ComputeBoundingVisitor ) {
            mat4.translate( matrix, matrix, [ this.matrix[ 12 ], this.matrix[ 13 ], this.matrix[ 14 ] ] );
            return;
        }
        MatrixTransform.prototype.computeLocalToWorldMatrix.call( this, matrix );
    };
};

CustomText.LABEL_CENTER = 0;
CustomText.LABEL_RIGHT = 1;
CustomText.LABEL_LEFT = 2;

CustomText.prototype = osg.objectInherit( osgText.Text.prototype, {
    /**
     * Set the text's renderBinValue used later to 'order' text draws
     * @method
     * @memberof pcvizNode.CustomText     
     */
    setRenderBinValue: function ( renderBinValue ) {
        this._renderBinValue = renderBinValue;
    },
    /**
     * Get the text's renderBinValue
     * @method
     * @memberof pcvizNode.CustomText
     * @return {number} The renderBinValue of the text
     */
    getRenderBinValue: function () {
        return this._renderBinValue;
    },

    /**
     * Draw the text in a canvas and apply it as a texture in the geometry object
     * @method
     * @memberof pcvizNode.CustomText
     * @override
     */
    drawText: function () {
        if ( this._geometry !== undefined ) {
            this._matrixTransform.removeChild( this._geometry );
            // The text could be dynamic, so we need to remove GL objects
            this._geometry.releaseGLObjects();
        }
        if ( !this._text ) return;
        this.setTextProperties();
        this._texts = this._text.split( this._newLineString );
        const numLines = this._texts.length;
        this._canvas.width = this.computeCanvasWidth();
        this._canvas.height = this._fontSize * 1.6 * numLines;
        // For devices not supporting NPOT textures
        if ( this._forcePowerOfTwo ) {
            this._canvas.width = this._nextPowerOfTwo( this._canvas.width );
            this._canvas.height = this._nextPowerOfTwo( this._canvas.height );
        }
        // We need to set the text properties again, as the canvas size could change.
        this.setTextProperties();
        this._context.clearRect( 0, 0, this._canvas.width, this._canvas.height );

        this._context.fillStyle = 'rgba(' + this._backgroundColor[ 0 ] + ',' + this._backgroundColor[ 1 ] + ',' + this._backgroundColor[ 2 ] + ',' + this._backgroundColor[ 3 ] + ')';
        this._context.fillRect( 0, 0, this._canvas.width, this._canvas.height );
        this._context.fillStyle = this._fillStyle;

        if ( numLines < 2 ) {
            this._context.fillText( this._texts[ 0 ], this._textX, this._textY );
        } else {
            for ( let i = 0; i < numLines; i++ ) {
                this._context.fillText( this._texts[ i ], this._textX, this._canvas.height * ( ( i + 1 ) / ( numLines + 1 ) ) );
            }
        }
        // Right now we set the pivot point to center, to assure the bounding box is correct when rendering billboards.
        // TODO: Possibility to set different pivot point so we can have missing alignments.
        const aspectRatio = this._canvas.width / this._canvas.height;
        const quadWidth = this._characterSize * aspectRatio * numLines;
        if ( this._labelAlignment === CustomText.LABEL_LEFT )
            this._geometry = osg.createTexturedQuadGeometry( -quadWidth + this._horizLabelOffset, -this._characterSize * numLines + this._verticalLabelOffset, 0,
                quadWidth, 0, 0,
                0, this._characterSize * numLines, 0 );
        else if ( this._labelAlignment === CustomText.LABEL_RIGHT )
            this._geometry = osg.createTexturedQuadGeometry( 0 + this._horizLabelOffset, this._verticalLabelOffset, 0,
                quadWidth, 0, 0,
                0, this._characterSize * numLines, 0 );
        else // centered
            this._geometry = osg.createTexturedQuadGeometry( -quadWidth / 2 + this._horizLabelOffset, -this._characterSize * numLines / 2 + this._verticalLabelOffset, 0,
                quadWidth, 0, 0,
                0, this._characterSize * numLines, 0 );

        // create a texture to attach the canvas2D
        this._texture.setTextureSize( this._canvas.width, this._canvas.height );
        this._texture.setMinFilter( 'LINEAR' );
        this._texture.setMagFilter( 'LINEAR' );
        this._texture.setImage( this._canvas );
        // Transparency stuff
        let stateset = this._geometry.getOrCreateStateSet();
        stateset.setTextureAttributeAndModes( 0, this._texture );
        if ( this._transparent )
            stateset.setAttributeAndModes( new BlendFunc( BlendFunc.ONE, BlendFunc.ONE_MINUS_SRC_ALPHA ) );
        stateset.setRenderBinDetails( this._renderBinValue, Utils.RENDERBIN_CUSTOMTEXT_TYPE );
        stateset.setAttributeAndModes( this._fakeLight );
        this._matrixTransform.addChild( this._geometry );
        this.dirtyBound();
    },

    /**
     * Set the text's background color
     * @method
     * @memberof pcvizNode.CustomText
     * @param {osg.vec4} bColor The background color of the text
     */
    setBackgroundColor: function ( bColor ) {
        this._backgroundColor = bColor;
        this._dirty = true;
    },

    /**
     * Get the text's background color
     * @method
     * @memberof pcvizNode.CustomText
     * @return {osg.vec4} The background color of the text
     */
    getBackgroundColor: function () {
        return this._backgroundColor;
    },
    setCharacterSizeMode: function ( mode ) {
        this._characterSizeMode = mode;
        if ( this._characterSizeMode !== Text.OBJECT_COORDS ) {
            mat4.fromScaling( this._matrixTransform.getMatrix(), [
                this._characterSize * window.devicePixelRatio,
                this._characterSize * window.devicePixelRatio,
                this._characterSize * window.devicePixelRatio
            ] );
            this.setAutoScaleToScreen( true );
            this.setMaximumScale( Number.MAX_VALUE );
            if (
                this._characterSizeMode ===
                Text.OBJECT_COORDS_WITH_MAXIMUM_SCREEN_SIZE_CAPPED_BY_FONT_HEIGHT
            )
                this.setMaximumScale( this._characterSize );
        } else {
            this._matrixTransform.setMatrix( mat4.create() );
            this.setAutoScaleToScreen( false );
        }
        this._dirty = true;
    },
    /**
     * Set the text's position
     * We override this method calling the setPosition method of the osg.AutoTransform class 
     * because osg.Text (the class that we are extending) inherits from osg.AutoTransform and it's overriding the setPosition method incorrectly.
     * @method
     * @override
     * @memberof pcvizNode.CustomText
     * @param {array} position the new position of the text
     */
    setPosition: function ( position ) {
        osg.AutoTransform.prototype.setPosition.call( this, position );
    },

    setTransparent: function ( transparent ) {
        this._transparent = transparent;
        this._dirty = true;
    },

    setLabelAlignment: function ( labelAlignment ) {
        if ( typeof labelAlignment === 'string' )
            this._labelAlignment = CustomText[ labelAlignment ];
        else
            this._labelAlignment = labelAlignment;
        this._dirty = true;
    },

    setHorizLabelOffset: function ( offset ) {
        this._horizLabelOffset = offset;
        this._dirty = true;
    },

    setVerticalLabelOffset: function ( offset ) {
        this._verticalLabelOffset = offset;
        this._dirty = true;
    },

    computeCanvasWidth: function () {
        let width = 0;
        for ( let i = 0; i < this._texts.length; i++ )
            width = Math.max( width, this._context.measureText( this._texts[ i ] ).width * 1.2 );
        return width;
    },

    setNewLineString: function ( newLineStr ) {
        this._newLineString = newLineStr;
    },

    // Override this function to avoid having a matrix that scales incorrectly the bounding box
    computeLocalToWorldMatrix: function ( matrix, nodeVisitor ) {
        if ( nodeVisitor instanceof ComputeBoundsVisitor || nodeVisitor instanceof ComputeBoundingVisitor ) {
            mat4.translate( matrix, matrix, [ this._matrix[ 12 ], this._matrix[ 13 ], this._matrix[ 14 ] ] );
            return;
        }
        osgText.Text.prototype.computeLocalToWorldMatrix.call( this, matrix );
    },

    // Don't compute bound of CustomTexts because it causes zoom isues and currently we can not have a scene with only custom texts.
    traverse: function ( visitor ) {
        if ( visitor instanceof ComputeBoundsVisitor || visitor instanceof ComputeBoundingVisitor )
            return;
        else
            osgText.Text.prototype.traverse.call( this, visitor );
    }

} );

module.exports = CustomText;


/***/ }),

/***/ "./sources/pcvizNode/CustomVertexGizmo.js":
/*!************************************************!*\
  !*** ./sources/pcvizNode/CustomVertexGizmo.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgText = OSG.osgText;
var osgUtil = OSG.osgUtil;

var MatrixTransform = osg.MatrixTransform;
var CullFace = osg.CullFace;
var vec2 = osg.vec2;
var vec3 = osg.vec3;
var mat4 = osg.mat4;

var CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
var VertexGizmo = __webpack_require__( /*! pcvizNode/VertexGizmo */ "./sources/pcvizNode/VertexGizmo.js" );
var GizmoGeometry = osgUtil.GizmoGeometry;

var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Geometry = __webpack_require__( /*! pcvizGIS/Geometry */ "./sources/pcvizGIS/Geometry.js" ).default;

var getCanvasCoord = function ( vec, e ) {
    if ( ( Utils.isTouchEnabled() || Utils.isTouchByTouchPoints() ) && !Utils.isEdge() && e.type.includes( 'touch' ) ) {
        let offset = e.target.getBoundingClientRect();
        vec[ 0 ] = e.changedTouches[ 0 ].clientX - offset.left;
        vec[ 1 ] = e.changedTouches[ 0 ].clientY - offset.top;
        return;
    }
    vec[ 0 ] = e.offsetX === undefined ? e.layerX : e.offsetX;
    vec[ 1 ] = e.offsetY === undefined ? e.layerY : e.offsetY;
};

/**
 * Specifies a customized VertexGizmo that shows a label with the coordinates and scales the translation according to the gizmo's size.
 * @class
 * @extends pcvizNode.VertexGizmo
 * @memberof pcvizNode
 * @property {float} _scaleValueToTranslate the quantity to scale the quantity of translation
 */
var CustomVertexGizmo = function ( viewer ) {

    VertexGizmo.call( this, viewer );

    this._scaleValueToTranslate = 1.0;

    this._pi = new osgUtil.PolytopeIntersector();
    this._pi.setPrimitiveMask( osgUtil.ALL_PRIMITIVES );
    this._pi.setIntersectionLimit( osgUtil.LIMIT_ONE_PER_DRAWABLE );
    this._ivCustom = new osgUtil.IntersectionVisitor();
    this._ivCustom.setIntersector( this._pi );

    // text label to show the coordinates;
    this._mtText = new MatrixTransform();
    this._textNode = new CustomText();
    this._textNode.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );
    this._textNode.setTransparent( false );
    this._textNode.setLabelAlignment( 'LABEL_RIGHT' );
    this._textNode.setHorizLabelOffset( 3 );
    this._mtText.addChild( this._textNode );

    this._posChild = -1;

    GizmoGeometry.resetPrograms();
};

CustomVertexGizmo.prototype = osg.objectInherit( VertexGizmo.prototype, {

    // override to use a polytope
    computeNearestIntersection: ( function () {
        var sortByRatio = function ( a, b ) {
            return a.ratio - b.ratio;
        };

        var coord = vec2.create();

        return function ( e, tmask ) {
            getCanvasCoord( coord, e );

            // canvas to webgl coord
            var viewer = this._viewer;
            var canvas = this._canvas;
            var x = coord[ 0 ] * ( viewer.getCanvasWidth() / canvas.clientWidth );
            var y = ( canvas.clientHeight - coord[ 1 ] ) * ( viewer.getCanvasHeight() / canvas.clientHeight );

            var hits = this.computePolytopeIntersections( x, y, tmask );

            if ( hits.length === 0 )
                return undefined;

            // TODO Review if it makes sense to order by distance and then by ratio
            hits.sort( sortByRatio );
            return hits[ 0 ];
        };
    } )(),

    computePolytopeIntersections: ( function () {
        return function ( x, y, traversalMask ) {
            var ph = 5.0;
            var pw = 5.0;
            this._pi.reset();

            this._pi.setPolytopeFromWindowCoordinates( x - pw, y - ph, x + pw, y + ph );
            this._ivCustom.setTraversalMask( traversalMask );

            this._viewer.getCamera().accept( this._ivCustom );
            var hits = this._pi.getIntersections();
            if ( hits.length > 1 ) {
                hits.sort( function ( a, b ) {
                    return a._distance - b._distance;
                } );
            }

            return hits;
        };
    } )(),

    removeListeners: function () {
        var canvas = this._canvas;
        canvas.removeEventListener( 'mousemove', this._onMouseMove );
        canvas.removeEventListener( 'mousedown', this._onMouseDown );
        canvas.removeEventListener( 'mouseup', this._onMouseUp );
        canvas.removeEventListener( 'mouseout', this._onMouseUp );
    },

    removeTextLabel: function () {
        this.getParents()[ 0 ].removeChild( this._mtText );
    },

    resetGraph: function () {
        var parent = this._attachedNode.getParents()[ 0 ];
        if ( parent ) {
            parent.addChild( this._geometry );
            parent.removeChild( this._attachedNode );
            //reorder
            if ( this._posChild !== undefined && this._posChild !== -1 ) {
                parent.getChildren().pop();
                parent.getChildren().splice( this._posChild, 0, this._geometry );
            }
        }
        this._attachedNode.removeChild( this._geometry );
    },

    // override because of the difference between 'nodepath' and 'nodePath'
    onNodeHovered: ( function () {
        var hoverColor = osg.vec4.fromValues32( 1.0, 1.0, 0.0, 1.0 );

        return function ( hit ) {

            if ( this._hoverNode )
                this._hoverNode.getStateSet().getUniform( 'uColor' ).setFloat4( this._keepHoverColor );
            if ( !hit ) {
                this._hoverNode = null;
                return;
            }

            // stop at the first X/Y/Z matrix node
            var np = hit._nodePath;
            var i = np.length - 1;
            var node = np[ i ];
            while ( node._nbAxis === undefined ) {
                if ( i === 0 )
                    return;
                node = np[ --i ];
            }

            var unif = node.getStateSet().getUniform( 'uColor' );
            this._hoverNode = node;
            osg.vec4.copy( this._keepHoverColor, unif.getInternalArray() );
            unif.setFloat4( hoverColor );
        };
    } )(),

    // override
    createInstance: function ( viewer ) {
        return new CustomVertexGizmo( viewer );
    },

    // override
    attachToGeometry: function ( geometry, indices, oneGizmoPerVertex ) {

        this._posChild = VertexGizmo.prototype.attachToGeometry.call( this, geometry, indices, oneGizmoPerVertex );

        if ( !geometry )
            return;

        // add text label to show the coordinates
        this.getParents()[ 0 ].addChild( this._mtText );

        this._textNode.setAutoRotateToScreen( true );
        this._textNode.setPosition( osg.vec3.fromValues( 0.0, 0.0, 0.0 ) );
        this._textNode.setCharacterSize( 5 );
        this._textNode.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );
    },

    // override
    updateGizmo: ( function () {
        var eye = vec3.create32();
        var trVec = vec3.create32();
        var trVertex = vec3.create32();

        var trWorld = mat4.create();
        var scGiz = mat4.create();

        return function () {
            if ( !this._attachedNode )
                return;
            var ttype = this.getTransformType( this._attachedNode );
            this.setReferenceFrame( ttype );
            this.setCullingActive( ttype === osg.Transform.RELATIVE_RF );
            var worldMat = this._attachedNode.getWorldMatrices()[ 0 ];

            // world trans
            mat4.getTranslation( trVec, worldMat );
            // to position gizmo in the vertex
            var vertices = this._vertexArrayBuffer.getElements();
            vec3.set( trVertex, vertices[ this._indices[ 0 ] * 3 ], vertices[ this._indices[ 0 ] * 3 + 1 ], vertices[ this._indices[ 0 ] * 3 + 2 ] );
            vec3.add( trVec, trVertex, trVec );
            mat4.fromTranslation( trWorld, [ trVec[ 0 ], trVec[ 1 ], trVec[ 2 ] ] );

            // normalize gizmo size
            var scaleFactor = 2.0;
            let scaleFov = this._canvas.clientWidth * 0.023;
            if ( ttype === osg.Transform.ABSOLUTE_RF ) {
                eye[ 0 ] = eye[ 1 ] = eye[ 2 ] = 0.0;
            } else {
                // normalize gizmo size relative to screen size
                if ( !this._viewer.getIsOrtho() ) {
                    var proj = this._viewer.getCamera().getProjectionMatrix();
                    scaleFov *= proj[ 0 ];
                    this._manipulator.getEyePosition( eye );
                } else {
                    scaleFov *= 1.5;
                    this._manipulator.getOrthoEyePosition( eye );
                }
                // while we are editing we don't normalize the gizmo
                // it gives a better depth feedback, especially if we are editing a geometry that has
                // a constant screen size (for example an icon)
                this._lastDistToEye = this._isEditing ? this._lastDistToEye : vec3.distance( eye, trVec );
                scaleFactor *= this._lastDistToEye / scaleFov;

                this._scaleValueToTranslate = scaleFactor;
            }
            mat4.fromScaling( scGiz, [ scaleFactor, scaleFactor, scaleFactor ] );

            // gizmo node
            mat4.multiply( this.getMatrix(), trWorld, scGiz );

            // text label
            this.updateTextLabel( trVec );

            mat4.fromTranslation( this._mtText.getMatrix(), [ trVec[ 0 ], trVec[ 1 ], trVec[ 2 ] ] );

            this._translateNode.dirtyBound();
            this._planeNode.dirtyBound();

        };
    } )(),

    // override
    init: function () {
        //this.getOrCreateStateSet().setAttributeAndModes( new Depth( Depth.DISABLE ) );
        this.getOrCreateStateSet().setAttributeAndModes( new CullFace( CullFace.DISABLE ) );

        var UpdateCallback = function () {};
        UpdateCallback.prototype = {
            update: this.updateGizmo.bind( this )
        };
        this.addUpdateCallback( new UpdateCallback() );
        this.addChild( this.initNodeTranslate() );
        this.addChild( this.initNodeTranslatePlane() );
        if ( this._debugNode ) {
            this._debugNode.addChild( GizmoGeometry.createDebugLineGeometry() );
            this.addChild( this._debugNode );
            this._debugNode.setNodeMask( 0x0 );
        }

        var canvas = this._canvas;
        this._onMouseMove = this.onMouseMove.bind( this );
        this._onMouseDown = this.onMouseDown.bind( this );
        this._onMouseUp = this.onMouseUp.bind( this );

        // For all browsers except Microsoft Edge Legacy
        if ( ( Utils.isTouchEnabled() || Utils.isTouchByTouchPoints() ) && !Utils.isEdge() ) {
            canvas.addEventListener( 'touchmove', this._onMouseMove );
            canvas.addEventListener( 'touchend', this._onMouseUp );
            canvas.addEventListener( 'touchcancel', this._onMouseUp );
            canvas.addEventListener( 'touchstart', this._onMouseDown );
        }
        canvas.addEventListener( 'mousemove', this._onMouseMove );
        canvas.addEventListener( 'mousedown', this._onMouseDown );
        canvas.addEventListener( 'mouseup', this._onMouseUp );
        canvas.addEventListener( 'mouseout', this._onMouseUp );
    },

    // override
    updateTranslateEdit: ( function () {
        var vec = vec2.create32();
        var tra = vec3.create32();

        return function ( e ) {

            var origin = this._editLineOrigin;
            var dir = this._editLineDirection;

            getCanvasCoord( vec, e );
            vec2.sub( vec, vec, origin );
            vec2.sub( vec, vec, this._editOffset );

            var dist = vec2.dot( vec, dir );
            vec[ 0 ] = origin[ 0 ] + dir[ 0 ] * dist;
            vec[ 1 ] = origin[ 1 ] + dir[ 1 ] * dist;

            if ( this._debugNode )
                this.drawLineCanvasDebug( origin[ 0 ], origin[ 1 ], vec[ 0 ], vec[ 1 ] );

            // canvas to webgl coord
            var viewer = this._viewer;
            var canvas = this._canvas;
            var coordx = vec[ 0 ] * ( viewer.getCanvasWidth() / canvas.clientWidth );
            var coordy = ( canvas.clientHeight - vec[ 1 ] ) * ( viewer.getCanvasHeight() / canvas.clientHeight );

            // project 2D point on the 3d line
            this._lsi.reset();
            this._lsi.setTestPlane( false );
            this._lsi.set( vec3.set( this._origIntersect, coordx, coordy, 0.0 ), vec3.set( this._dstIntersect, coordx, coordy, 1.0 ) );
            this._iv.reset();
            this._iv.setTraversalMask( this._hoverNode.getNodeMask() );

            this.setOnlyGizmoPicking();
            this._viewer.getCamera().accept( this._iv );
            this.setOnlyScenePicking();
            // This code is not in the original NodeGizmo, but we are going to keep it until tests.
            // vec3.scale( this._lsi.getTranslateDistance(), this._lsi.getTranslateDistance(), this._scaleValueToTranslate ); // scale the distance to translate as we scale the gizmo's size
            vec3.transformMat4( tra, this._lsi.getTranslateDistance(), this._editInvWorldScaleRot );


            var vertices = this._vertexArrayBuffer.getElements();

            var translateMatrix = mat4.create();
            var identityMatrix = mat4.create();

            // create a Matrix with the translation to be applied to the vertices
            mat4.translate( translateMatrix, identityMatrix, tra );

            // for each vertex
            for ( var i = 0; i < this._indices.length; i++ ) {
                // get the vertex position
                var vector = vec3.fromValues32( vertices[ this._indices[ i ] * 3 ], vertices[ this._indices[ i ] * 3 + 1 ], vertices[ this._indices[ i ] * 3 + 2 ] );

                var result = vec3.create32();

                // set the translated position in a new vector
                vec3.transformMat4( result, vector, translateMatrix );

                // set the new position to the vertex
                vertices[ this._indices[ i ] * 3 ] = result[ 0 ];
                vertices[ this._indices[ i ] * 3 + 1 ] = result[ 1 ];
                vertices[ this._indices[ i ] * 3 + 2 ] = result[ 2 ];


                // update text label (FIXME: This is here because I know there's only one index.. )
                this.updateTextLabel( vector );

                mat4.fromTranslation( this._mtText.getMatrix(), vector );

            }

            // call dirty method first for the geometry and secondly for the BufferArray
            this._geometry.dirty();
            this._vertexArrayBuffer.dirty();

            this._attachedNode.dirtyBound();
        };
    } )(),

    // override
    updatePlaneEdit: function ( e ) {
        var vec = vec3.create32();
        getCanvasCoord( vec, e );
        vec2.sub( vec, vec, this._editOffset );

        // canvas to webgl coord
        var viewer = this._viewer;
        var canvas = this._canvas;
        var coordx = vec[ 0 ] * ( viewer.getCanvasWidth() / canvas.clientWidth );
        var coordy = ( canvas.clientHeight - vec[ 1 ] ) * ( viewer.getCanvasHeight() / canvas.clientHeight );

        // project 2D point on the 3d plane
        this._lsi.reset();
        this._lsi.setTestPlane( true );
        this._lsi.set( vec3.set( this._origIntersect, coordx, coordy, 0.0 ), vec3.set( this._dstIntersect, coordx, coordy, 1.0 ) );
        this._iv.reset();
        this._iv.setTraversalMask( this._hoverNode.getNodeMask() );

        this.setOnlyGizmoPicking();
        this._viewer.getCamera().accept( this._iv );
        this.setOnlyScenePicking();

        vec3.scale( this._lsi.getTranslateDistance(), this._lsi.getTranslateDistance(), this._scaleValueToTranslate ); // scale the distance to translate as we scale the gizmo's size
        vec3.transformMat4( vec, this._lsi.getTranslateDistance(), this._editInvWorldScaleRot );


        var vertices = this._vertexArrayBuffer.getElements();

        var translateMatrix = mat4.create();

        // create a Matrix with the translation to be applied to the vertices
        // Matrix.multTranslate( identityMatrix, vec, translateMatrix ); --> BUG!!!!! changed to makeTranslate->fromTranslation
        mat4.fromTranslation( translateMatrix, vec );

        // for each vertex
        for ( var i = 0; i < this._indices.length; i++ ) {
            // get the vertex position
            var vector = vec3.fromValues32( vertices[ this._indices[ i ] * 3 ], vertices[ this._indices[ i ] * 3 + 1 ], vertices[ this._indices[ i ] * 3 + 2 ] );

            var result = vec3.create32();

            // set the translated position in a new vector
            vec3.transformMat4( result, vector, translateMatrix );

            // set the new position to the vertex
            vertices[ this._indices[ i ] * 3 ] = result[ 0 ];
            vertices[ this._indices[ i ] * 3 + 1 ] = result[ 1 ];
            vertices[ this._indices[ i ] * 3 + 2 ] = result[ 2 ];

            // update text label (FIXME: This is here because I know there's only one index.. )
            this.updateTextLabel( vector );

            mat4.fromTranslation( this._mtText.getMatrix(), vector );
        }

        // call dirty method first for the geometry and secondly for the BufferArray
        this._geometry.dirty();
        this._vertexArrayBuffer.dirty();

        this._attachedNode.dirtyBound();
    },

    updateTextLabel: function ( vector ) {
        var transformedPoint = [];
        transformedPoint[ 0 ] = vector[ 0 ] + this._viewer.getCenter()[ 0 ];
        transformedPoint[ 1 ] = vector[ 1 ] + this._viewer.getCenter()[ 1 ];
        transformedPoint[ 2 ] = vector[ 2 ] + this._viewer.getCenter()[ 2 ];

        var layer = this.getLayerSelected();
        var project = this.getProject();

        if ( layer.getProjection() && project.getProjection() ) {
            var crsData = Geometry.prototype.prepareCRS( layer, project );
            Geometry.prototype._transformPoint( transformedPoint, transformedPoint, transformedPoint, crsData );
        }
        var numberOfDecimals = localStorage.getItem( 'ngStorage-numberOfDecimals' );
        this._textNode.setText( transformedPoint[ 0 ].toFixed( numberOfDecimals ) + ', ' + transformedPoint[ 1 ].toFixed( numberOfDecimals ) + ', ' + transformedPoint[ 2 ].toFixed( numberOfDecimals ) );
    },

    getLayerSelected: function () {
        return Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject().getLayer();
    },

    getProject: function () {
        return Registry.getController( 'Application' ).getApplication().getProject();
    }

} );

module.exports = CustomVertexGizmo;


/***/ }),

/***/ "./sources/pcvizNode/DrawingRuleAttribute.js":
/*!***************************************************!*\
  !*** ./sources/pcvizNode/DrawingRuleAttribute.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var osg = OSG.osg;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

/**
 * Defines the atributtes of the drawing rules.
 * @class
 * @memberof pcvizNode
 */
var DrawingRuleAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    this._drawingRule = DrawingRuleAttribute.RGB;
    this._maxIntensity = 255.0;
    this._minIntensity = 0.0;
    this._maxZ = 1.0;
    this._minZ = 0.0;
    this._repeatRange = false;
    // TODO: We don't need Vec3 at all to compute Z's
    // remove Vec3 Uniforms
    this._dataCenter = osg.vec3.create64();
    this._tileOrigin = osg.vec3.create64();
    this._fixedColor = osg.vec4.fromValues32( 0.5, 0.5, 0.5, 1.0 );
    this._classificationColorArray = new Float32Array(
        [ 0.0, 0.0, 0.0, 1.0,
            0.0, 0.0, 0.0, 1.0,
            0.61, 0.33, 0.25, 1.0,
            0.18, 0.90, 0.28, 1.0,
            0.05, 0.71, 0.2, 1.0,
            0.05, 0.49, 0.13, 1.0,
            0.5, 0.5, 0.75, 1.0,
            1.0, 1.0, 1.0, 1.0,
            0.7, 0.0, 0.7, 1.0,
            0.0, 0.70, 1.0, 1.0,
            1.0, 0.5, 0.0, 1.0,
            1.0, 0.5, 0.5, 1.0,
            1.0, 1.0, 0.0, 1.0,
            0.5, 0.0, 1.0, 1.0,
            0.5, 0.5, 1.0, 1.0,
            0.0, 1.0, 0.5, 1.0
        ] );
    this._drawingRuleArray = new Float32Array( 16 );
    this._classificationArray = new Float32Array( [ 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1 ] );
    this._uniformMap = new window.Map();

    // Verity extra attributes
    this._heatMap = 0;
    this._numHeatMaps = 0;

    // CRE heatmap elevation
    this._refElevation = 0.5;
    this._hideAboveBelow = false;
    this._hideAboveBelowSize = 0;

    this._incSize = 0;
    this._tolerance = 0;
    this._elevationPolicy = 1; // elevationPolicy constant number??
    this._repeatIntervals = false;
    this._planeNormal = [ 0, 0, 1 ]; // plane normal for heatmap elevation when plane is not perpendicular to z
    this._planeConstant = 0;

    this._dataMT = osg.mat4.create();

    this._dirty = false;
};

DrawingRuleAttribute.RGB = 0;
DrawingRuleAttribute.INTENSITY = 1;
DrawingRuleAttribute.ELEVATION = 2;
DrawingRuleAttribute.CLASSIFICATION = 3;
DrawingRuleAttribute.FIXED_COLOR = 4;
DrawingRuleAttribute.CATEGORIZED = 5;
DrawingRuleAttribute.INTENS_COLOR = 6;
// Extra verity attributes
DrawingRuleAttribute.HEATMAP = 7;
DrawingRuleAttribute.HEATMAP_ELEVATION = 8;

DrawingRuleAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'DrawingRule',

    cloneType: function () {
        return new DrawingRuleAttribute();
    },

    /**
     * Return the uniforms according to the drawing rule and create them if they don't exist.
     * @method
     * @memberof pcvizNode.DrawingRuleAttribute
     * @return {window.Map} Uniforms relative to the current drawing rule
     */
    getOrCreateUniforms: function () {

        if ( this._uniformMap.has( this._drawingRule ) ) return this._uniformMap.get( this._drawingRule );

        var classificationArray = osg.Uniform.createFloatArray( 'activeClassification', this._classificationArray.length );

        var uniforms;
        // uniforms list are per ClassType
        switch ( this._drawingRule ) {
        case DrawingRuleAttribute.RGB:
        case DrawingRuleAttribute.CLASSIFICATION:
            uniforms = {
                activeClassification: classificationArray
            };
            break;
        case DrawingRuleAttribute.INTENSITY:
        case DrawingRuleAttribute.INTENS_COLOR:
            uniforms = {
                maxIntensity: osg.Uniform.createFloat1( this._maxIntensity, 'maxIntensity' ),
                minIntensity: osg.Uniform.createFloat1( this._minIntensity, 'minIntensity' ),
                activeClassification: classificationArray
            };
            break;
        case DrawingRuleAttribute.ELEVATION:
            uniforms = {
                maxZ: osg.Uniform.createFloat1( this._maxZ, 'maxZ' ),
                minZ: osg.Uniform.createFloat1( this._minZ, 'minZ' ),
                repeatRange: osg.Uniform.createInt1( this._repeatRange, 'repeatRange' ),
                dataCenter: osg.Uniform.createFloat3( this._dataCenter, 'dataCenter' ),
                activeClassification: classificationArray
            };
            break;

        case DrawingRuleAttribute.FIXED_COLOR:
            uniforms = {
                fixedColor: osg.Uniform.createFloat4( this._fixedColor, 'fixedColor' ),
                activeClassification: classificationArray
            };
            break;
        case DrawingRuleAttribute.CATEGORIZED:
            uniforms = {
                maxIntensity: osg.Uniform.createFloat1( this._maxIntensity, 'maxIntensity' ),
                minIntensity: osg.Uniform.createFloat1( this._minIntensity, 'minIntensity' ),
                maxZ: osg.Uniform.createFloat1( this._maxZ, 'maxZ' ),
                minZ: osg.Uniform.createFloat1( this._minZ, 'minZ' ),
                dataCenter: osg.Uniform.createFloat3( this._dataCenter, 'dataCenter' ),
                activeClassification: classificationArray,
                drawingRuleArray: osg.Uniform.createFloatArray( 'drawingRuleArray', this._drawingRuleArray.length ),
                classificationColorArray: osg.Uniform.createFloatArray( 'classificationColorArray', this._classificationColorArray.length )
            };
            break;
        case DrawingRuleAttribute.HEATMAP:
            uniforms = {
                activeClassification: classificationArray
            };
            break;
        case DrawingRuleAttribute.HEATMAP_ELEVATION:
            uniforms = {
                maxZ: osg.Uniform.createFloat1( this._maxZ, 'maxZ' ),
                minZ: osg.Uniform.createFloat1( this._minZ, 'minZ' ),
                repeatRange: osg.Uniform.createInt1( this._repeatIntervals, 'repeatRange' ),
                dataCenter: osg.Uniform.createFloat3( this._dataCenter, 'dataCenter' ),
                activeClassification: classificationArray, //I don't know why it is necessary
                refElevation: osg.Uniform.createFloat1( this._refElevation, 'refElevation' ),
                hideAboveBelow: osg.Uniform.createInt1( this._hideAboveBelow, 'hideAboveBelow' ),
                hideAboveBelowSize: osg.Uniform.createFloat1( this._hideAboveBelowSize, 'hideAboveBelowSize' ),
                incSize: osg.Uniform.createFloat1( this._incSize, 'incSize' ),
                tolerance: osg.Uniform.createFloat1( this._tolerance, 'tolerance' ),
                elevationPolicy: osg.Uniform.createInt1( this._elevationPolicy, 'elevationPolicy' ),
                dataMT: osg.Uniform.createMatrix4( this._dataMT, 'dataMT' ), // transform matrix applied to the pointcloud
                planeNormal: osg.Uniform.createFloat3( this._planeNormal, 'planeNormal' ),
                planeConstant: osg.Uniform.createFloat1( this._planeConstant, 'planeConstant' ),
            };
            break;
        }
        this._uniformMap.set( this._drawingRule, uniforms );
        return uniforms;
    },

    /**
     * Set the drawing rule
     * @method
     * @memberof pcvizNode.DrawingRuleAttribute
     * @param {string} drawingRule the string that specifies the drawing rule to be set
     */
    setDrawingRule: function ( drawingRule ) {
        var drule;
        switch ( drawingRule ) {
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB':
            drule = DrawingRuleAttribute.RGB;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE':
            drule = DrawingRuleAttribute.INTENSITY;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS':
            drule = DrawingRuleAttribute.INTENS_COLOR;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED':
            drule = DrawingRuleAttribute.CLASSIFICATION;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION':
            drule = DrawingRuleAttribute.ELEVATION;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR':
            drule = DrawingRuleAttribute.FIXED_COLOR;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CATEGORIZED':
            drule = DrawingRuleAttribute.CATEGORIZED;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_HEATMAP':
            drule = DrawingRuleAttribute.HEATMAP;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION_HEATMAP':
            drule = DrawingRuleAttribute.HEATMAP_ELEVATION;
            break;
        }

        this._drawingRule = drule;
    },


    getDrawingRule: function () {
        return this._drawingRule;
    },

    setMaxIntensity: function ( maxIntensity ) {
        this._maxIntensity = maxIntensity;
    },

    getMaxIntensity: function () {
        return this._maxIntensity;
    },

    setMaxZ: function ( maxZ ) {
        this._maxZ = maxZ;
    },

    getMaxZ: function () {
        return this._maxZ;
    },

    setMinZ: function ( minZ ) {
        this._minZ = minZ;
    },

    getMinZ: function () {
        return this._minZ;
    },

    setDataCenter: function ( dataCenter ) {
        this._dataCenter = dataCenter;
    },

    getDataCenter: function () {
        return this._dataCenter;
    },

    setMinIntensity: function ( minIntensity ) {
        this._minIntensity = minIntensity;
    },

    getMinIntensity: function () {
        return this._minIntensity;
    },

    setRepeatRange: function ( repeatRange ) {
        this._repeatRange = repeatRange;
    },

    getRepeatRange: function () {
        return this._repeatRange;
    },

    setFixedColor: function ( color ) {
        this._fixedColor = color;
    },

    getFixedColor: function () {
        return this._fixedColor;
    },

    setDrawingRuleArray: function ( drawingRuleArray ) {
        this._drawingRuleArray = drawingRuleArray;
    },

    getDrawingRuleArray: function () {
        return this._drawingRuleArray;
    },

    setClassificationArray: function ( classificationArray ) {
        this._classificationArray = classificationArray;
    },

    getClassificationArray: function () {
        return this._classificationArray;
    },

    setClassificationColorArray: function ( fColorArray ) {
        this._classificationColorArray = fColorArray;
    },

    getClassificationColorArray: function () {
        return this._classificationColorArray;
    },

    setHeatMap: function ( heatMap ) {
        this._heatMap = heatMap;
    },

    getHeatMap: function () {
        return this._heatMap;
    },

    setNumHeatMaps: function ( numHeatMaps ) {
        this._numHeatMaps = numHeatMaps;
    },

    getNumHeatMaps: function () {
        return this._numHeatMaps;
    },

    setRefElevation: function ( referenceElevation ) {
        this._refElevation = referenceElevation;
    },

    getRefElevation: function () {
        return this._refElevation;
    },

    setHideAboveBelow: function ( flag ) {
        this._hideAboveBelow = flag;
    },

    getHideAboveBelow: function () {
        return this._hideAboveBelow;
    },

    setHideAboveBelowSize: function ( sizeFromRefElevation ) {
        this._hideAboveBelowSize = sizeFromRefElevation;
    },

    getHideAboveBelowSize: function () {
        return this._hideAboveBelowSize;
    },

    setIncSize: function ( incrementSize ) {
        this._incSize = incrementSize;
    },

    setTolerance: function ( tolerance ) {
        this._tolerance = tolerance;
    },

    setElevationPolicy: function ( elevationPolicy ) {
        switch ( elevationPolicy ) {
        case 'POINTCLOUD_LAYER_PROPERTIES.ELEVATION_POLICY_BASIC':
            this._elevationPolicy = 0;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.ELEVATION_POLICY_SMOOTH':
            this._elevationPolicy = 1;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.ELEVATION_POLICY_STEPPED':
            this._elevationPolicy = 2;
            break;
        default:
            console.error( 'Elevation policy not supported' );
        }
    },

    setRepeatIntervals: function ( repeatFlag ) {
        this._repeatIntervals = repeatFlag;
    },

    setPlaneNormal: function ( planeNormal ) {
        this._planeNormal = planeNormal.slice();
    },

    setPlaneConstant: function ( planeConstant ) {
        this._planeConstant = planeConstant;
    },

    getPlaneNormal: function () {
        return this._planeNormal;
    },

    getPlaneConstant: function () {
        return this._planeConstant;
    },

    // In case the scans are registered, we need to take into account the z in the elevationHeatmap
    setParentNode: function ( parentNode ) {
        this._parentNode = parentNode;
        this.computeDataMT();
    },

    computeDataMT: function () {
        let nodePath = Utils.computeNodePath( this._parentNode );
        let mt = osg.computeLocalToWorld( nodePath, true );

        this._dataMT = osg.mat4.create64();
        this._dataMT = osg.mat4.clone( mt );
        this._dataMT[ 12 ] = this._dataMT[ 12 ] + this._globalCenter[ 0 ];
        this._dataMT[ 13 ] = this._dataMT[ 13 ] + this._globalCenter[ 1 ];
        this._dataMT[ 14 ] = this._dataMT[ 14 ] + this._globalCenter[ 2 ];
    },

    setGlobalCenter: function ( c ) {
        this._globalCenter = c;
    },

    apply: function () {
        var uniforms = this.getOrCreateUniforms();
        uniforms.activeClassification.getInternalArray().set( this._classificationArray );
        switch ( this._drawingRule ) {
        case DrawingRuleAttribute.INTENSITY:
        case DrawingRuleAttribute.INTENS_COLOR:
            uniforms.maxIntensity.setFloat( this._maxIntensity );
            uniforms.minIntensity.setFloat( this._minIntensity );
            break;
        case DrawingRuleAttribute.ELEVATION:
            uniforms.maxZ.setFloat( this._maxZ );
            uniforms.minZ.setFloat( this._minZ );
            uniforms.repeatRange.setInt( this._repeatRange );
            uniforms.dataCenter.setFloat3( this._dataCenter );
            break;
        case DrawingRuleAttribute.HEATMAP_ELEVATION:
            uniforms.maxZ.setFloat( this._maxZ );
            uniforms.minZ.setFloat( this._minZ );
            uniforms.repeatRange.setInt( this._repeatIntervals );
            uniforms.dataCenter.setFloat3( this._dataCenter );
            uniforms.refElevation.setFloat( this._refElevation );
            uniforms.hideAboveBelow.setInt( this._hideAboveBelow );
            uniforms.hideAboveBelowSize.setFloat( this._hideAboveBelowSize );
            uniforms.incSize.setFloat( this._incSize );
            uniforms.tolerance.setFloat( this._tolerance );
            uniforms.elevationPolicy.setInt( this._elevationPolicy );
            uniforms.dataMT.getInternalArray().set( this._dataMT );
            uniforms.planeNormal.setFloat3( this._planeNormal );
            uniforms.planeConstant.setFloat( this._planeConstant );
            break;
        case DrawingRuleAttribute.FIXED_COLOR:
            uniforms.fixedColor.setFloat4( this._fixedColor );
            break;
        case DrawingRuleAttribute.CATEGORIZED:
            uniforms.maxZ.setFloat( this._maxZ );
            uniforms.minZ.setFloat( this._minZ );
            uniforms.dataCenter.setFloat3( this._dataCenter );
            uniforms.maxIntensity.setFloat( this._maxIntensity );
            uniforms.minIntensity.setFloat( this._minIntensity );
            uniforms.drawingRuleArray.getInternalArray().set( this._drawingRuleArray );
            uniforms.classificationColorArray.getInternalArray().set( this._classificationColorArray );
            break;
        case DrawingRuleAttribute.HEATMAP:
            // nothing here for now, the node generates the proper code to render the selected heatmap
            break;
        }
    },
    // getHash is used to know if an StateAttribute changed
    // if yes it will trigger a shader rebuild. You can for example
    // trigger a change if we enable or not the attribute. It's really
    // up to how you want to handle your shaders
    // if you dont want to trigger rebuild of shader then instead you an use a
    // uniform and keep always the same hash
    getHash: function () {
        // We need to add some uniforms to the hash string to get layered pointclouds working
        let hash = this.getType() + this._drawingRule.toString() + this._fixedColor.toString() + this._heatMap.toString() + this._dataCenter.toString() + this._dirty;
        this._dirty = false;
        return hash;
    }

} ), 'osg', 'DrawingRuleAttribute' );

module.exports = DrawingRuleAttribute;


var DrawingRuleNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
    this._drawingRuleAttr = DrawingRuleAttribute.RGB;
    this._heatMap = 0;
};


DrawingRuleNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'DrawingRule',
    validInputs: [],
    validOutputs: [ 'VertexColor' ],

    setDrawingRuleAttribute: function ( drawingRuleAttr ) {
        this._drawingRuleAttr = drawingRuleAttr;
    },

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        // Include the shader file depending on the selected drawing rule.
        var str;
        switch ( this._drawingRuleAttr.getDrawingRule() ) {
        case DrawingRuleAttribute.RGB:
            str = '#pragma include "rgb.glsl"';
            break;
        case DrawingRuleAttribute.INTENSITY:
            str = '#pragma include "intensity.glsl"';
            break;
        case DrawingRuleAttribute.INTENS_COLOR:
            str = '#pragma include "intensitycolor.glsl"';
            break;
        case DrawingRuleAttribute.ELEVATION:
            str = '#pragma include "elevation.glsl"';
            break;
        case DrawingRuleAttribute.HEATMAP_ELEVATION:
            str = '#pragma include "heatmapElevation.glsl"';
            break;
        case DrawingRuleAttribute.CLASSIFICATION:
            str = '#pragma include "classification.glsl"';
            break;
        case DrawingRuleAttribute.CATEGORIZED:
            str = '#pragma include "categorized.glsl"';
            break;
        case DrawingRuleAttribute.FIXED_COLOR:
            str = '#pragma include "fixedcolor.glsl"';
            break;
        case DrawingRuleAttribute.HEATMAP:
            // We add the getHeatMapValue used inside the heatMap computePointColor function
            str = '\n\nfloat getHeatMapValue() {  return HeatMap_' + this._drawingRuleAttr.getHeatMap().toString() + '; }\n\n';
            str += '#pragma include "heatMap.glsl"';
            break;
        }
        return str;
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        // Discard noise first
        var str = 'int iclassType = int(Classification);\n';
        str += 'if ( activeClassification[ iclassType ] == 0.0 ) \n';
        str += '    VertexColor = vec4( 0.0, 0.0, 0.0, 0.0 );\n';
        str += 'else\n';
        str += osgShader.utils.callFunction( '    computePointColor', undefined, [ this._outputs.VertexColor ] );
        return str;
    }
} );
factory.registerNode( 'DrawingRule', DrawingRuleNode );


/***/ }),

/***/ "./sources/pcvizNode/EDLNode.js":
/*!**************************************!*\
  !*** ./sources/pcvizNode/EDLNode.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var ClampProjectionCallback = __webpack_require__( /*! pcvizNode/ClampProjectionCallback */ "./sources/pcvizNode/ClampProjectionCallback.js" );
/**
 * This node renders the scene with the EDL tecnique.
 * @class
 * @memberof pcvizNode
 * @extends osg.Node
 * @property {bool} _dirtyEDL A flag to indicate if the EDL graph must be rebuild
 * @property {osg.Node} _edlGroup The node which is going to add as childs the _edlSceneCamera and _edlHUDCamera
 * @property {osg.Node} _edlGeode The node which is going to have all the geometry
 * @property {osg.Camera} _edlSceneCamera TODO
 * @property {osg.Camera} _edlHUDCamera TODO
 * @property {int} _edlTextureWidth The texture's width
 * @property {int} _edlTextureHeight The texture's height
 * @property {float} _edlRadius TODO
 * @property {float} _edlBias TODO
 * @property {float} _edlExp TODO
 * @property {int} _viewerWidth The viewer's width
 * @property {int} _viewerHeight The viewer's height
 * @property {osg.mat4} _inverseProjMat TODO
 * @property {osg.Uniform} _inverseProjMatU TODO
 * @property {osg.mat4} _projMat TODO
 * @property {osg.Uniform} _projMatU TODO
 * @property {int} _ssaoOn TODO
 * @property {osg.Uniform} _ssaoOnU TODO
 */
var EDLNode = function () {
    osg.Node.call( this );

    this._dirtyEDL = true;
    this._edlGroup = new osg.Node();
    this._edlGeode = undefined;
    this._edlSceneCamera = undefined;
    this._edlHUDCamera = undefined;
    this._edlTextureWidth = 1920;
    this._edlTextureHeight = 1080;
    this._edlRadius = 1.0;
    this._edlBias = 0.01;
    this._edlExp = 0.08;
    this._viewerWidth = 1920;
    this._viewerHeight = 1080;
    this._inverseProjMat = osg.mat4.create();
    this._inverseProjMatU = osg.Uniform.createMatrix4( this._inverseProjMat, 'invProjMat' );
    this._projMat = osg.mat4.create();
    this._projMatU = osg.Uniform.createMatrix4( this._projMat, 'projMat' );
    this._ssaoOn = 1;
    this._ssaoOnU = osg.Uniform.createInt1( this._ssaoOn, 'SSAO' );
    this._viewer = undefined;
};

EDLNode.prototype = osg.objectInherit( osg.Node.prototype, {

    /**
     * Adds the scene to the EDL Node.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {osg.Node} scene The scene to be rendered by EDL shader.
     */
    setScene: function ( scene ) {
        this._scene = scene;
        this.addChild( scene );
    },

    /**
     * Configures the viewer in the EDL Node.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {osgViewer.Viewer} viewer The viewer used internally for querying different parameters
     */
    setViewer: function ( viewer ) {
        this._viewer = viewer;
    },

    /**
     * Sets the EDL radius.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {float} radius The radius.
     */
    setEDLRadius: function ( radius ) {
        this._edlRadius = radius;
        if ( this._edlGeode !== undefined ) {
            var radiusUniform = this._edlGeode.getOrCreateStateSet().getUniform( 'radius' );
            radiusUniform.setFloat( radius );
        }
    },

    /**
     * Gets the EDL radius.
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {float} The EDL radius.
     */
    getEDLRadius: function () {
        return this._edlRadius;
    },

    /**
     * Sets the EDL exponent. This controls contrast.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {float} edlExp The EDL exponent.
     */
    setEDLExp: function ( edlExp ) {
        this._edlExp = edlExp;
        if ( this._edlGeode !== undefined ) {
            var expUniform = this._edlGeode.getOrCreateStateSet().getUniform( 'exponent' );
            expUniform.setFloat( edlExp );
        }
    },

    /**
     * Gets the EDL exponent. EDL exponent refers to contrast.
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {float} The EDL exponent.
     */
    getEDLExp: function () {
        return this._edlExp;
    },

    /**
     * Sets EDL bias
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {float} logBias The EDL bias (REVIEW)
     */
    setEDLBiasLog: function ( logBias ) {
        this._edlBias = logBias;
        var biasUniform = this._edlGeode.getOrCreateStateSet().getUniform( 'logbias' );
        biasUniform.setFloat( logBias );
    },

    /**
     * Sets the viewport dimensions
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {float} x Viewport width
     * @param {float} y Viewport height
     */
    setViewportDimensions: function ( x, y ) {
        this._viewerWidth = x;
        this._viewerHeight = y;
        this._edlTextureWidth = x;
        this._edlTextureHeight = y;

        if ( this._edlGeode !== undefined ) {
            var screenWidthUniform = this._edlGeode.getOrCreateStateSet().getUniform( 'screenWidth' );
            screenWidthUniform.setFloat( this._edlTextureWidth );
            var screenHeightUniform = this._edlGeode.getOrCreateStateSet().getUniform( 'screenHeight' );
            screenHeightUniform.setFloat( this._edlTextureHeight );
        }

        this._dirtyEDL = true;
    },

    /**
     * Activate or deactivate EDL
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {bool} value if true, activates EDL rendering; otherwise, deactivates EDL
     */
    setEDLRendering: function ( value ) {
        if ( ( window.navigator.userAgent.indexOf( 'MSIE' ) !== -1 ) || ( window.navigator.userAgent.indexOf( 'Trident' ) !== -1 ) || ( window.navigator.userAgent.match( /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i ) ) )
            value = false;
        this._edlRendering = value;
    },

    /**
     * Activate or deactivate SSAO
     * @method
     * @memberof pcvizNode.EDLNode
     * @param {bool} value if true, activates SSAO rendering; otherwise, deactivates SSAO
     */
    setSSAORendering: function ( value ) {
        if ( value === false )
            this._ssaoOn = 0;
        else
            this._ssaoOn = 1;
        this._ssaoOnU.setInt( this._ssaoOn );
    },

    /**
     * Get whether the EDL rendering is activated or not
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {bool} true if EDL is activated, false otherwise
     */
    getEDLRendering: function () {
        return this._edlRendering;
    },

    /**
     * Get whether the SSAO rendering is activated or not
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {bool} true if SSAO is activated, false otherwise
     */
    getSSAORendering: function () {
        return this._ssaoOn === 1;
    },

    getEDLSceneCamera: function () {
        return this._edlSceneCamera;
    },

    /**
     * It builds the EDL graph by creating the camera and attatching the scene.
     * @method
     * @memberof pcvizNode.EDLNode
     */
    buildEDLGraph: function () {
        var previousColor;
        if ( this._edlSceneCamera )
            previousColor = this._edlSceneCamera.getClearColor();
        this._edlGroup.removeChildren();
        this._edlSceneCamera = new osg.Camera();
        this._edlSceneCamera.setEnableFrustumCulling( true );
        this._edlSceneCamera.setName( 'EDL' );
        this._edlSceneCamera.setRenderOrder( osg.Camera.PRE_RENDER, 0 );
        this._edlSceneCamera.setReferenceFrame( osg.Transform.RELATIVE_RF );
        this._edlSceneCamera.setViewport( new osg.Viewport( 0, 0, this._edlTextureWidth, this._edlTextureHeight ) );
        if ( previousColor )
            this._edlSceneCamera.setClearColor( previousColor );
        else
            this._edlSceneCamera.setClearColor( Registry.getController( 'UserPreferences' ).getPreference( Utils.BACKGROUND_COLOR_KEY ) );

        // attach a texture to this._edlSceneCamera to render the scene on it
        var sceneTexture = new osg.Texture();
        sceneTexture.setTextureSize( this._edlTextureWidth, this._edlTextureHeight );
        sceneTexture.setMinFilter( 'LINEAR' );
        sceneTexture.setMagFilter( 'LINEAR' );

        // attach a texture to the this._edlSceneCamera to render the scene on it
        var depthTexture = new osg.Texture();
        depthTexture.setTextureSize( this._edlTextureWidth, this._edlTextureHeight );
        depthTexture.setMinFilter( 'LINEAR' );
        depthTexture.setMagFilter( 'LINEAR' );
        depthTexture.setInternalFormat( osg.Texture.DEPTH_COMPONENT );
        depthTexture.setInternalFormatType( osg.Texture.UNSIGNED_SHORT );


        this._edlSceneCamera.attachTexture( osg.FrameBufferObject.COLOR_ATTACHMENT0, sceneTexture, 0 );
        this._edlSceneCamera.attachTexture( osg.FrameBufferObject.DEPTH_ATTACHMENT, depthTexture, 0 );
        this._edlSceneCamera.addChild( this._scene );


        var self = this;
        var clampProjectionMatrixCallback = ClampProjectionCallback.getClampProjectionCallback( this._viewer, function ( projectionMatrix ) {
            self._projMatU.setMatrix4( projectionMatrix );
            osg.mat4.invert( self._inverseProjMat, projectionMatrix );
            self._inverseProjMatU.setMatrix4( self._inverseProjMat );
        } );
        this._edlSceneCamera.setClampProjectionMatrixCallback( clampProjectionMatrixCallback );
        this._edlHUDCamera = new osg.Camera();
        osg.mat4.ortho( this._edlHUDCamera.getProjectionMatrix(), 0, this._viewerWidth, 0, this._viewerHeight, -5, 5 );

        this._edlHUDCamera.setRenderOrder( osg.Camera.NESTED_RENDER, 0 );
        this._edlHUDCamera.setReferenceFrame( osg.Transform.ABSOLUTE_RF );
        this._edlHUDCamera.setClearColor( osg.vec4.fromValues32( 1, 1, 1, 0 ) );
        this._edlHUDCamera.setClearMask( osg.Camera.DEPTH_BUFFER_BIT );
        this._edlGroup.addChild( this._edlSceneCamera );
        this._edlGroup.addChild( this._edlHUDCamera );


        this._edlGeode = new osg.Node();

        // this should not be picked
        this._edlGeode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

        this._edlGeode._name = 'debugNode';
        this._edlGeode.setCullingActive( false );
        var quad = osg.createTexturedQuadGeometry( 0, 0, 0, this._viewerWidth, 0, 0, 0, this._viewerHeight, 0 );

        var ss = this._edlGeode.getOrCreateStateSet();

        this._edlGeode.addChild( quad );
        this._edlHUDCamera.addChild( this._edlGeode );

        var program = this.generateEDLSSAOProgram();
        if ( program ) {
            ss.setTextureAttributeAndModes( 0, sceneTexture );
            ss.setTextureAttributeAndModes( 1, depthTexture );
            ss.addUniform( osg.Uniform.createInt1( 0, 'sceneTexture' ) );
            ss.addUniform( osg.Uniform.createInt1( 1, 'sceneDepth' ) );
            ss.addUniform( osg.Uniform.createFloat( this._edlTextureWidth, 'screenWidth' ) );
            ss.addUniform( osg.Uniform.createFloat( this._edlTextureHeight, 'screenHeight' ) );
            ss.addUniform( osg.Uniform.createFloat( this._edlRadius, 'radius' ) );
            ss.addUniform( osg.Uniform.createFloat( this._edlExp, 'exponent' ) );
            ss.addUniform( osg.Uniform.createFloat( this._edlBias, 'logbias' ) );
            ss.addUniform( this._inverseProjMatU );
            ss.addUniform( this._projMatU );
            ss.addUniform( this._ssaoOnU );
        }

        ss.setAttributeAndModes( program );

    },

    /**
     * Creates a Debug view. TODO: Document this.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param  {float} x       The width
     * @param  {float} y       The height
     * @param  {osg.Texture} texture The texture to be attached to the view
     */
    createDebugView: function ( x, y, texture ) {

        var optionsDebug = {
            x: 0,
            y: 100,
            w: 400,
            h: 300,
            horizontal: true,
            screenW: 1024,
            screenH: 768,
            fullscreen: false
        };

        var debugNode = new osg.Node();
        debugNode.setCullingActive( false );
        var quad = osg.createTexturedQuadGeometry( 100 + x, 100 + y, 0, optionsDebug.w, 0, 0, 0, optionsDebug.h, 0 );
        var ss = quad.getOrCreateStateSet();

        quad.setName( 'debugQuadGeom' );
        this._edlGeode.addChild( quad );

        var program = this.generateDebugProgram();
        if ( program ) {
            ss.setTextureAttributeAndModes( 0, texture );
        }
        ss.setAttributeAndModes( program );
    },

    /**
     * Generates a debug program
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {osg.Program} The GPU program to render the view.
     */
    generateDebugProgram: function () {
        if ( !this._programDebug ) {
            let vertexShader = this.getVertexShader();

            var fragmentShader = [
                '',
                '#ifdef GL_ES',
                'precision highp float;',
                '#endif',
                'varying vec2 FragTexCoord0;',
                'uniform sampler2D Texture0;',
                '',
                'void main (void)',
                '{',
                '  vec2 uv = FragTexCoord0;',
                '  gl_FragColor =  vec4(texture2D(Texture0, uv));',
                '}',
                ''
            ].join( '\n' );


            this._programDebug = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );
        }
        return this._programDebug;
    },

    /**
     * Generates the EDL GPU program to render the scene using this tecnique.
     * @method
     * @memberof pcvizNode.EDLNode
     * @return {osg.Program} The GPU program to render the node.
     */
    generateEDLSSAOProgram: function () {
        if ( !this._programEDL ) {
            let vertexShader = this.getVertexShader();

            var fragmentShader = [
                '',
                '#version 100',

                '#ifdef GL_FRAGMENT_PRECISION_HIGH',
                'precision highp float;',
                '#else',
                'precision mediump float;',
                '#endif',
                'uniform mat4 invProjMat;',
                'uniform mat4 projMat;',
                'uniform sampler2D sceneTexture;',
                'uniform sampler2D sceneDepth;',
                'uniform float screenWidth;',
                'uniform float screenHeight;',
                'uniform float radius;',
                'uniform float exponent;',
                'varying vec2 FragTexCoord0;',
                'uniform int SSAO;',

                'float worldDepth(vec2 screen, float depth)',
                '{',
                '     vec3 shiftedCoords = (2.0*vec3(screen, depth))-vec3(1.0, 1.0, 1.0);', // shift to -1,+1 normalization
                '     vec4 point = invProjMat * vec4(shiftedCoords, 1.0);',
                '     return (-point.z / point.w);',
                '}',

                'float obscurance(float z, float dist){',
                '    return max(0.0, z) / dist;',
                '}  ',

                'float computeObscurance(float linearDepth){',
                '  vec4 P = vec4(0.0, 0.0, 1.0, linearDepth);',
                '  vec2 uvRadius = radius / vec2(screenWidth, screenHeight);',

                '  float sum = 0.0;',
                '  vec2 neighbours[8];',
                '  neighbours[0] = vec2( 1.0, 0.0);',
                '  neighbours[1] = vec2( 1.0, 1.0);',
                '  neighbours[2] = vec2( 0.0, 1.0);',
                '  neighbours[3] = vec2(-1.0, 1.0);',
                '  neighbours[4] = vec2(-1.0, 0.0);',
                '  neighbours[5] = vec2(-1.0,-1.0);',
                '  neighbours[6] = vec2( 0.0,-1.0);',
                '  neighbours[7] = vec2( 1.0,-1.0);',

                '  for(int c = 0; c < 8; c++){',
                '    vec2 N_rel_pos = uvRadius * neighbours[c];',
                '    vec2 N_abs_pos = FragTexCoord0.st + N_rel_pos;',

                '    if (N_abs_pos.s < 0.0 || N_abs_pos.s > 1.0 || N_abs_pos.t < 0.0 || N_abs_pos.t > 1.0)',
                '       continue;  ',
                '    float depth = texture2D(sceneDepth, N_abs_pos).r;',
                '    float neighbourDepth = worldDepth(N_abs_pos, depth);',

                '    if(neighbourDepth != 0.0){',
                '        float Zn = -neighbourDepth;',
                '        float Znp = dot( vec4( N_rel_pos, Zn, 1.0), P );',

                '        sum += obscurance( Znp, 0.05 * linearDepth );',
                '    }',
                '  }',

                '  return sum;',
                '} ',

                'void main() {',
                '  vec3 kernel[ 48 ];',
                '  kernel[0] = vec3( -0.22665504819244647, 0.24627626311108025, 0.01050835460563293 );',
                '  kernel[1] = vec3( 0.11177449901969083, -0.2008910174922392, 0.1478299305546571 );',
                '  kernel[2] = vec3( -0.2230872123847479, 0.011227734488804597, -0.01813696426970873 );',
                '  kernel[3] = vec3( 0.19276136272945138, -0.031331073250743136, -0.25516786321540147 );',
                '  kernel[4] = vec3( -0.1917566076813847, -0.19615909571088547, 0.1625550111462361 );',
                '  kernel[5] = vec3( -0.11193310809505999, 0.24310829022959174, 0.0913396112920914 );',
                '  kernel[6] = vec3( -0.2824718517528019, 0.26963291090084, 0.10292589951532094 );',
                '  kernel[7] = vec3( -0.2611520087961701, -0.027406181613733205, -0.21436234107342228 );',
                '  kernel[8] = vec3( -0.18697454603591118, 0.19949739622416401, -0.024323160745302275 );',
                '  kernel[9] = vec3( 0.1367635563546462, -0.2328499441811226, -0.02102416847404548 );',
                '  kernel[10] = vec3( -0.29128815603760744, 0.07749508627534496, -0.2879694947449453 );',
                '  kernel[11] = vec3( -0.06355499602422526, -0.27410542365221513, 0.1643090961376939 );',
                '  kernel[12] = vec3( 0.14533878203825384, 0.00465910264128, 0.027045443408344583 );',
                '  kernel[13] = vec3( -0.2028872153440897, 0.07103106286463468, -0.1285991912698118 );',
                '  kernel[14] = vec3( -0.0392171345171648, 0.22472090540003492, 0.11617484126415523 );',
                '  kernel[15] = vec3( 0.09489339162995836, -0.23521964485603358, -0.14740970504290588 );',
                '  kernel[16] = vec3( -0.2836914281460875, 0.2933953807001835, -0.019447621216581 );',
                '  kernel[17] = vec3( -0.04214080145753368, -0.10260963657211788, 0.115473571645475 );',
                '  kernel[18] = vec3( 0.153673349207878, 0.26048481165289367, -0.18242725526995618 );',
                '  kernel[19] = vec3( 0.0031291266048179556, 0.28567602334910674, -0.2336713031927367 );',
                '  kernel[20] = vec3( -0.04635046452612984, 0.19665946763473152, 0.12560813714077707 );',
                '  kernel[21] = vec3( 0.2014053369595606, 0.0718146082565504, -0.29884634300882085 );',
                '  kernel[22] = vec3( 0.2540248237696668, -0.1770805946280009, 0.19815309399965575);',
                '  kernel[23] = vec3( 0.24490299462781567, -0.05982525202667416, 0.228653342895001 );',
                '  kernel[24] = vec3( -0.22777665150805465, 0.269366673481018, -0.17685915137497238 );',
                '  kernel[25] = vec3( -0.06916310970662845, 0.2126482878723372, -0.027989830974052 );',
                '  kernel[26] = vec3( -0.15305474548863937, -0.00723644169067017, 0.260399261206803 );',
                '  kernel[27] = vec3( 0.11554251922948133, -0.1514787641260548, -0.00524218422830619 );',
                '  kernel[28] = vec3( -0.2522732492300967, 0.21928172374162885, 0.11756662018098285 );',
                '  kernel[29] = vec3( -0.08841639443929225, 0.18653620406243876, 0.18436298541916024 );',
                '  kernel[30] = vec3( -0.02239312176467345, 0.2731163476672123, -0.1259875928629585 );',
                '  kernel[31] = vec3( 0.1695673559446021, -0.06565526380928594, 0.19870566112477134 );',
                '  kernel[32] = vec3( 0.17266327102600088, -0.0351723126397715, -0.25911293100255467 );',
                '  kernel[33] = vec3( -0.1329344164260007, -0.05765446237136401, -0.1674942186135209 );',
                '  kernel[34] = vec3( -0.08660695416219413, 0.12969695315489493, -0.2939607429910532 );',
                '  kernel[35] = vec3( -0.020913093489691614, 0.012754006947088392, 0.1567932264466253 );',
                '  kernel[36] = vec3( -0.1557057039725214, -0.2746599226097113, 0.28617816938203683 );',
                '  kernel[37] = vec3( -0.16224676685122708, -0.13576744604625315, -0.23427369272111154 );',
                '  kernel[38] = vec3( -0.04880009706967331, -0.11810909060538102, 0.26813570246606105 );',
                '  kernel[39] = vec3( 0.14813246748884168, -0.2011455485150952, 0.15548181589004545 );',
                '  kernel[40] = vec3( 0.21263581740502685, -0.041460552450563015, 0.058385408331571464 );',
                '  kernel[41] = vec3( 0.04249988026448237, 0.20473643771423616, 0.08582896345291524 );',
                '  kernel[42] = vec3( -0.29288202948831393, 0.16146285928397286, -0.08211231666551777 );',
                '  kernel[43] = vec3( 0.026826100995756053, -0.184656078730976, -0.26667067730229665 );',
                '  kernel[44] = vec3( 0.29928057810719205, 0.0679756467801359, 0.12441836660037581 );',
                '  kernel[45] = vec3( 0.1731286441332709, 0.14573806009189405, 0.10304237791167237 );',
                '  kernel[46] = vec3( -0.09459369709295315, 0.09706015584177546, -0.01976619697471549 );',
                '  kernel[47] = vec3( -0.06243383410135411, 0.1769013297887596, -0.25423266357806 );',

                '  float x = FragTexCoord0.s * 2.0 - 1.0;',
                '  float y = FragTexCoord0.t * 2.0 - 1.0;',

                // Assume we have a normal depth range between 0.0 and 1.0
                '  float z = texture2D(sceneDepth, FragTexCoord0.st).r * 2.0 - 1.0;',
                '  float far = 9990.0;',
                '  float near = 0.15;',

                '  vec4 posProj = vec4(x, y, z, 1.0);',
                '  vec4 posView = invProjMat * posProj;',
                '  posView /= posView.w;',

                '  vec4 color = texture2D( sceneTexture, FragTexCoord0.st ).rgba;',

                '  float radius = 1.0;',
                '  float sample_depth;',
                '  vec3 samp, samp1;',
                '  vec4 samplePointView;',
                '  float occlusion = 0.0;',

                '  for (int i=0; i < 48/*tam_kernel*/; ++i){ ',
                '       samp1 = kernel[i];',
                '       samplePointView = (vec4(samp1,0.0)*radius) + posView;',

                '       vec4 offset = projMat * samplePointView; ', // In the range -w, w
                '       offset /= offset.w;  ', // in the range -1, 1"
                '       vec2 samplePointTexCoord = offset.xy * 0.5 + 0.5;   ',

                '       float zSceneNDC = texture2D(sceneDepth, samplePointTexCoord).r * 2.0 - 1.0; ',

                '       if( zSceneNDC < offset.z /*- 0.001*/){ ',
                '           offset.z * 0.5 +0.5;',
                '           zSceneNDC = (2.0 * near * far) / (far + near - (zSceneNDC * (far - near)));',
                '           offset.z = (2.0 * near * far) / (far + near - (offset.z * (far - near)));',

                '           float delta = abs(offset.z - zSceneNDC);',

                '           if(delta > 0.0 /*&& delta < 3.5*/)',
                '           { ',
                '               occlusion += 1.0; ',
                '           } ',
                '       } ',

                '   } ',

                '   float darkness = 108.0;', //Related to tam_kernel -> when bigger more lighter
                '   occlusion = 1.0 - (occlusion / float(darkness));',

                '   if(color.a != 1.0){',
                '       occlusion = max(0.8, occlusion);', //Limits occlusion value
                '   }',

                '  float depth = texture2D(sceneDepth, FragTexCoord0.st).r; ',
                '  float linearDepth = worldDepth(FragTexCoord0.st, depth); ',
                '  float f = computeObscurance(linearDepth);',
                '  f = exp(-exponent * f); ',
                '  f = clamp(f, 0.0, 1.0); ',

                // this part is commented because on the SpherePano.js is disabled
                // the osg.Depth
                // '  if (depth == 1.0 /*&& f >= 1.0*/ ){',
                // '     discard;',
                // '  }',
                'if(SSAO == 1)',
                '  gl_FragColor = vec4(color.rgb * f * occlusion, color.a ); ',
                'else',
                '  gl_FragColor = vec4(color.rgb * f, color.a ); ',
                '}',
                '',
            ].join( '\n' );
            this._programEDL = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );
        }
        return this._programEDL;
    },

    /**
     * The node traversing function that checks if the scene graph has to be rebuilt.
     * @method
     * @memberof pcvizNode.EDLNode
     * @param  {osg.Visitor} visitor The node visitor.
     */
    traverse: function ( visitor ) {
        if ( this._dirtyEDL ) {
            this.buildEDLGraph();
            this._dirtyEDL = false;
        }
        this._edlGroup.accept( visitor );
    },

    getVertexShader: function () {
        return [
            '',
            '#version 100',

            '#ifdef GL_FRAGMENT_PRECISION_HIGH',
            'precision highp float;',
            '#else',
            'precision mediump float;',
            '#endif',
            'attribute vec3 Vertex;',
            'attribute vec2 TexCoord0;',
            'varying vec2 FragTexCoord0;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;',
            'void main(void) {',
            '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex,1.0);',
            '  FragTexCoord0 = TexCoord0;',
            '}',
            ''
        ].join( '\n' );
    }
} );

module.exports = EDLNode;


/***/ }),

/***/ "./sources/pcvizNode/ElementIDAttribute.js":
/*!*************************************************!*\
  !*** ./sources/pcvizNode/ElementIDAttribute.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;

var ElementIDAttribute = function () {
    osg.StateAttribute.call( this );
    this._selectedElementID = -1;
};

ElementIDAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'ElementID',

    cloneType: function () {
        return new ElementIDAttribute();
    },

    setElementID: function ( elementID ) {
        this._selectedElementID = elementID;
    },

    getElementID: function () {
        return this._selectedElementID;
    },

    getOrCreateUniforms: function () {
        var obj = ElementIDAttribute;
        if ( obj.uniforms ) return obj.uniforms;
        obj.uniforms = {
            selectedElementID: osg.Uniform.createFloat( this._selectedElementID, 'selectedElementID' ),
        };
        return obj.uniforms;
    },

    apply: function () {
        var uniforms = this.getOrCreateUniforms();
        uniforms.selectedElementID.setFloat( this._selectedElementID );
    }

} ), 'osg', 'ElementIDAttribute' );

module.exports = ElementIDAttribute;

var ElementIDVertexNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
    this._selectedElementID = -1;
};

ElementIDVertexNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'ElementIDVertexNode',
    validInputs: [ 'ElementID', 'selectedElementID' ],
    validOutputs: [ 'VertexColor' ],

    setElementID: function ( elementID ) {
        this._selectedElementID = elementID;
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        var str = osgShader.utils.sprintf( 'if ( %s >= 0.0 && %s != %s ) { %s.a = 0.0; }', [
            this._inputs.selectedElementID,
            this._inputs.ElementID,
            this._inputs.selectedElementID,
            this._outputs.VertexColor
        ] );
        return str;
    }
} );

factory.registerNode( 'ElementIDVertexNode', ElementIDVertexNode );


/***/ }),

/***/ "./sources/pcvizNode/GeoImageNode.js":
/*!*******************************************!*\
  !*** ./sources/pcvizNode/GeoImageNode.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

/**
 *  A node that uses an image texture that is loaded from a URL.
 *  @class
 *  @memberof pcvizNode
 */
var GeoImageNode = function () {
    osg.MatrixTransform.call( this );
    this._texture = undefined;
    this._imageURL = undefined;
    this._fakeLight = new osg.Light( 0, true );
    this.getOrCreateStateSet().setAttributeAndModes( this._fakeLight );

    this._geometryNode = undefined;
    this._category = undefined;
    this._format = 'jpg'; //default

    this._imageMode = false;
    this._seeInFront = true;
    this._position = osg.vec3.create64();
    this._rotationQuat = osg.quat.create64();
    this._reader = new Input();
    this._reader.setMaxRequestsInQueue( 1 );
    this._lastTextureUrl = undefined;
    this._multiResolutionEnabled = false;
    this._readNodeOptions = undefined;
};

GeoImageNode.prototype = osg.objectInherit( osg.MatrixTransform.prototype, {

    setDepth: function ( seeAlways, enableDepthWrite ) {
        this._seeInFront = seeAlways;
        var depth = new osg.Depth( osg.Depth.ALWAYS );
        depth.setWriteMask( enableDepthWrite );
        this.getOrCreateStateSet().setAttributeAndModes( depth );
        if ( this._seeInFront )
            this.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_IMAGE_FRONT, Utils.RENDERBIN_IMAGE_FRONT_TYPE ); // draw after data, before labels
        else
            this.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_IMAGE_BACK, Utils.RENDERBIN_IMAGE_BACK_TYPE ); // draw before data
    },

    getSeeAlways: function () {
        return this._seeInFront;
    },

    getOrCreateGeometry: function () {
        console.log( 'Error: not implemented. GeoImageNode.getOrCreateGeometry' );
    },

    setImageFormat: function ( format ) {
        this._format = format;
    },

    setReadNodeOptions: function ( options ) {
        this._readNodeOptions = options;
    },

    getReadNodeOptions: function ( layer ) {
        let opt = {
            format: this._format,
            category: this._category,
            layer: layer
        };
        return Object.assign( opt, this._readNodeOptions );
    },

    setImageURL: function ( url, layer ) {
        var refresh = false;
        if ( this._layer !== undefined && this._layer.getId() !== layer.getId() )
            refresh = true;
        this._layer = layer;
        if ( this._lastTextureUrl === url && !refresh )
            return;
        this._lastTextureUrl = url;
        this._multiResolutionEnabled = false;
        this._readNodeOptions = Object.assign( this._readNodeOptions || {}, {
            urlTimeStampCacheKey: url
        } );
        var self = this;

        if ( this._geometryNode !== undefined )
            this._geometryNode.releaseGLObjects();
        this.removeChildren();

        osgDB.readNodeURL( url, this.getReadNodeOptions( layer ) ).then( function ( child ) {
            self._geometryNode = child;
            self.addChild( child );
            if ( self._geometryNode.activate )
                self._geometryNode.activate( self._multiResolutionEnabled );

            self._dirty = false;
        } );

    },

    /**
     * Sets the position of the node.
     * @method
     * @memberof pcvizNode.GeoImageNode
     * @param  {osg.vec3} position The position
     */
    setPosition: function ( position ) {
        osg.vec3.copy( this._position, position );
    },

    /**
     * Sets the rotation of node based on a quaternion. (Now it is not used)
     * @method
     * @memberof pcvizNode.GeoImageNode
     * @param  {osg.quat} quat The rotation quaternion.
     */
    setRotationQuat: function ( quat ) {
        osg.quat.copy( this._rotationQuat, quat );
    },

    /**
     * Returns the node position
     * @method
     * @memberof pcvizNode.GeoImageNode
     * @return {osg.vec3}  The position.
     */
    getPosition: function () {
        return this._position;
    },

    /**
     * Returns the node rotation quaternion
     * @method
     * @memberof pcvizNode.GeoImageNode
     * @return {osg.vec3}  The position.
     */
    getRotationQuat: function () {
        return this._rotationQuat;
    },

    /**
     * Computes the rotation and translation of the node and sets its matrix.
     * @method
     * @memberof pcvizNode.GeoImageNode
     */
    computeRotationTranslation: function () {
        osg.mat4.fromRotationTranslation( this.getMatrix(), this._rotationQuat, this._position );
        this.setMatrix( this.getMatrix() );
    },

    setImageMode: function () {
        console.log( 'Error: not implemented. GeoImageNode.setImageMode' );
    },

    getImageMode: function () {
        return this._imageMode;
    },

    deselect: function () {
        if ( !this._imageMode )
            if ( this.getParents() && this.getParents().length )
                this.getParents()[ 0 ].removeChildren();
    },

    enableMultiResolution: function ( value ) {
        this._multiResolutionEnabled = value;
    }
} );

module.exports = GeoImageNode;


/***/ }),

/***/ "./sources/pcvizNode/GeometryTypeAttribute.js":
/*!****************************************************!*\
  !*** ./sources/pcvizNode/GeometryTypeAttribute.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;

var GeometryTypeAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    this._geometryType = GeometryTypeAttribute.QUAD;

};

GeometryTypeAttribute.QUAD = 0;
GeometryTypeAttribute.CIRCLE = 1;
GeometryTypeAttribute.SPLAT = 3;
GeometryTypeAttribute.POINT_SPRITE = 4;

GeometryTypeAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'GeometryType',

    cloneType: function () {
        return new GeometryTypeAttribute();
    },

    setGeometryType: function ( geometryType ) {
        var gType;

        switch ( geometryType ) {
        case 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_CIRCLE':
            gType = GeometryTypeAttribute.CIRCLE;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_ORIENTED':
            gType = GeometryTypeAttribute.SPLAT;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_SQUARE':
            gType = GeometryTypeAttribute.QUAD;
            break;
        }
        this._geometryType = gType;
    },

    getGeometryType: function () {
        return this._geometryType;
    },

    setEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isEnabled: function () {
        return this._attributeEnable;
    },

    // getHash is used to know if an StateAttribute changed
    // if yes it will trigger a shader rebuild. You can for example
    // trigger a change if we enable or not the attribute. It's really
    // up to how you want to handle your shaders
    // if you dont want to trigger rebuild of shader then instead you an use a
    // uniform and keep always the same hash
    getHash: function () {
        return this.getType() + this._geometryType.toString();
    }

} ), 'osg', 'GeometryTypeAttribute' );

module.exports = GeometryTypeAttribute;

var GeometryVertexNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
    this._geometryType = GeometryTypeAttribute.SPLAT;
};

GeometryVertexNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'GeometryTypeVertex',
    validInputs: [],
    validOutputs: [],



    setGeometryType: function ( geomType ) {
        this._geometryType = geomType;

    },
    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        if ( this._geometryType === GeometryTypeAttribute.SPLAT ) {
            return '#pragma include "splat.glsl"';
        }
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        if ( this._geometryType === GeometryTypeAttribute.SPLAT ) {
            return osgShader.utils.callFunction( 'computeRotNormal', undefined, [] );
        }
    }

} );

factory.registerNode( 'GeometryTypeVertex', GeometryVertexNode );


var GeometryFragmentNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
    this._geometryType = GeometryTypeAttribute.QUAD;
};


GeometryFragmentNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'GeometryTypeFragment',
    validInputs: [],
    validOutputs: [ 'dist' ],

    setGeometryType: function ( geomType ) {
        this._geometryType = geomType;
    },

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        if ( this._geometryType === GeometryTypeAttribute.SPLAT )
            return '#pragma include "geometry.glsl"';
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        var str = '';
        if ( this._geometryType === GeometryTypeAttribute.SPLAT ) {
            str = osgShader.utils.callFunction( 'computeDistanceSplat', this._outputs.dist, [] );
            str += 'if (dist > 0.25) discard;';
        } else if ( this._geometryType === GeometryTypeAttribute.CIRCLE ) {

            str = osgShader.utils.sprintf( '%s = distance( vec2(0.5,0.5), gl_PointCoord );', [ this._outputs.dist ] );
            str += 'if ( dist > 0.5 ) discard;';
        }

        return str;
    }
} );


factory.registerNode( 'GeometryTypeFragment', GeometryFragmentNode );


/***/ }),

/***/ "./sources/pcvizNode/Group.js":
/*!************************************!*\
  !*** ./sources/pcvizNode/Group.js ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Group; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);


var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

/**
 * Defines a group of osg nodes that can be transformed by a matrix 
 * @class
 * @memberof pcvizNode
 */
class Group extends osg.MatrixTransform {
    constructor() {
        super();
    }
}


/***/ }),

/***/ "./sources/pcvizNode/HUDNode.js":
/*!**************************************!*\
  !*** ./sources/pcvizNode/HUDNode.js ***!
  \**************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var HUDNode = function () {
    osg.Node.call( this );

    this._hudCamera = new osg.Camera();
    this._hudCamera.setName( 'HUDCamera' );

    this.addChild( this._hudCamera );
};

HUDNode.prototype = osg.objectInherit( osg.Node.prototype, {

    /**
     * Configures the viewer in the HUD Node.
     * @method
     * @memberof pcvizNode.HUDNode
     * @param {osgViewer.Viewer} viewer The viewer used internally for querying different parameters
     */
    setViewer: function ( viewer ) {
        this._viewer = viewer;
    },

    /**
     * Sets the viewport dimensions
     * @method
     * @memberof pcvizNode.HUDNode
     * @param {float} x Viewport width
     * @param {float} y Viewport height
     */
    setViewportDimensions: function ( x, y ) {
        this._viewportWidth = x;
        this._viewportHeight = y;

        osg.mat4.ortho( this._hudCamera.getProjectionMatrix(), 0, this._viewportWidth, 0, this._viewportHeight, -5, 5 );

        this._hudCamera.setReferenceFrame( osg.Transform.ABSOLUTE_RF );
        this._hudCamera.setClearMask( osg.Camera.DEPTH_BUFFER_BIT );
        this._hudCamera.setRenderOrder( osg.Camera.POST_RENDER, 0 );
        this._hudCamera.setClearColor( osg.vec4.fromValues32( 1, 1, 1, 0 ) );
    },

    updateChildrenPosition: function ( x, y ) {
        var dx = ( x - this._viewportWidth ) / 2.0;
        var dy = ( y - this._viewportHeight ) / 2.0;

        var translation = [ dx, dy, 0 ];

        this._hudCamera.children.forEach( ( mt ) => {
            osg.mat4.translate( mt.getMatrix(), mt.getMatrix(), translation );
        } );
    },

    getHUDRootNode: function () {
        return this._hudCamera;
    },

    clearHUD: function () {
        this._hudCamera.removeChildren();
    },

} );

module.exports = HUDNode;


/***/ }),

/***/ "./sources/pcvizNode/LayerGizmo.js":
/*!*****************************************!*\
  !*** ./sources/pcvizNode/LayerGizmo.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );

var osg = OSG.osg;
var osgUtil = OSG.osgUtil;

var vec2 = osg.vec2;
var vec3 = osg.vec3;
var mat4 = osg.mat4;
var vec4 = osg.vec4;

var MatrixTransform = osg.MatrixTransform;
var Node = osg.Node;
var Uniform = osg.Uniform;
var BlendFunc = osg.BlendFunc;

var NodeGizmo = osgUtil.NodeGizmo;
var GizmoGeometry = osgUtil.GizmoGeometry;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;

var LAYER_GIZMO_SCALE = 3.0;

var HideCullCallback = function () {};
HideCullCallback.prototype = {
    cull: function () {
        return false;
    }
};

var blendAttribute = new BlendFunc( BlendFunc.SRC_ALPHA, BlendFunc.ONE_MINUS_SRC_ALPHA );

var getCanvasCoord = function ( vec, e ) {
    if ( ( 'ontouchstart' in window || navigator.maxTouchPoints || navigator.msMaxTouchPoints ) && window.navigator.userAgent.indexOf( 'Edge' ) === -1 && e.type.includes( 'touch' ) ) {
        var offset = e.target.getBoundingClientRect();
        vec[ 0 ] = e.changedTouches[ 0 ].clientX - offset.left;
        vec[ 1 ] = e.changedTouches[ 0 ].clientY - offset.top; // fixed
    } else {
        vec[ 0 ] = e.offsetX === undefined ? e.layerX : e.offsetX;
        vec[ 1 ] = e.offsetY === undefined ? e.layerY : e.offsetY;
    }
};

/**
 * Specifies a customized LayerGizmo 
 * @class
 * @extends osg.NodeGizmo
 * @memberof pcvizNode
 * @property {float} _scaleValueToTranslate the quantity to scale the quantity of translation
 */
var LayerGizmo = function ( viewer ) {

    NodeGizmo.call( this, viewer );

    // CHECK WHICH NEXT LINES ARE REALLY NECESSARY

    this._scaleValueToTranslate = 1.0;

    this._pi = new osgUtil.PolytopeIntersector();
    this._pi.setPrimitiveMask( osgUtil.ALL_PRIMITIVES );
    this._pi.setIntersectionLimit( osgUtil.LIMIT_ONE_PER_DRAWABLE );
    this._ivCustom = new osgUtil.IntersectionVisitor();
    this._ivCustom.setIntersector( this._pi );

    this._editLocal = mat4.create();
    this._lastDistToEye = 100.0;

    this._pickWorldXForm = new osg.MatrixTransform();

    this._toolIsActive = false;
    this._pickPivotMode = false;
    this._forcedPivot = undefined;
    this._pickedLayer = undefined;

    this._isMovementDone = false;
    this._lastXformMat = mat4.create();
    this._currentTransform = { // used for UI
        angles: vec3.create(),
        translation: vec3.create(),
        scale: vec3.create()
    };

    this._handleConfig = {
        rotation: true,
        axes: true,
        plane: true,
        planView: false,
        sideView: false,
        frontView: false
    };

    this._originalTransforms = new Map();

    this.setGizmoMask( this._handleConfig );

    this._pickEnabled = true;

    GizmoGeometry.resetPrograms();

    var stateset = this.getOrCreateStateSet();
    stateset.setRenderBinDetails( Utils.RENDERBIN_SYMBOL3D, Utils.RENDERBIN_SYMBOL3D_TYPE );

    this._mode = LayerGizmo.MODES.STATION;
};

LayerGizmo.MODES = { 'STATION': 0, 'RASTER': 1 };

LayerGizmo.prototype = osg.objectInherit( NodeGizmo.prototype, {

    setToolIsActive: function ( active ) {
        this._toolIsActive = active;

        if ( !active )
            this._originalTransforms.clear();
    },

    getPickPivotMode: function () {
        return this._pickPivotMode;
    },

    setPickPivotMode: function ( mode ) {
        this._pickPivotMode = mode;
    },

    connectToLayerNode: function ( pickedLayer, layerNode ) {

        if ( this._attachedNode )
            this.disconnectFromLayerNode();

        var xFormLayer = layerNode.getParents()[ 0 ];
        var gizmoXForm;

        if ( xFormLayer.editMask ) { // already has gizmo transformation as parent

            gizmoXForm = xFormLayer;
            xFormLayer = xFormLayer.getParents()[ 0 ];

        } else { // insert gizmo transformation

            gizmoXForm = new osg.MatrixTransform();

            // move transformation from layer node to gizmo transform
            gizmoXForm.setMatrix( layerNode.getMatrix() );
            layerNode.setMatrix( mat4.fromTranslation( mat4.create(), [ 0, 0, 0 ] ) );

            gizmoXForm.addChild( layerNode );
            xFormLayer.addChild( gizmoXForm );
            xFormLayer.removeChild( layerNode );
        }

        this._attachedNode = gizmoXForm;
        this._pickedLayer = pickedLayer;

        if ( this._forcedPivot )
            vec3.copy( this._pivotOffset, this._forcedPivot );

        xFormLayer.addChild( this );
        this.setCurrentTransform( ( pickedLayer && pickedLayer.getId ) ? pickedLayer.getId() : undefined ); // for UI

        this._attachedNode.editMask = this._gizmoMask;
        this.updateGizmoMask();

        this._active = true;
    },

    disconnectFromLayerNode: function () {

        if ( this.getParents().length < 1 )
            return;

        this.getParents()[ 0 ].removeChild( this );

        // move transformation from gizmo transform to layer node 
        let layerNode = this._attachedNode.getChildren()[ 0 ];
        if ( layerNode ) {
            let mt = this._attachedNode.getMatrix();

            layerNode.setMatrix( mt );

            this._attachedNode.getParents()[ 0 ].addChild( layerNode );
            this._attachedNode.removeChildren();
            this._attachedNode.getParents()[ 0 ].removeChild( this._attachedNode );
        }

        this._attachedNode = undefined;
        this._active = false;
    },

    setGizmoMask: function ( handleVis ) {

        this._handleConfig = handleVis;

        if ( handleVis.planView === undefined )
            handleVis.planView = this._viewer.getIsOrtho();

        if ( handleVis.planView ) {
            if ( handleVis.frontView ) {
                this._gizmoMask = handleVis.rotation ? NodeGizmo.PICK_ARC_Y : 0;
                this._gizmoMask |= handleVis.axes ? ( NodeGizmo.PICK_ARROW_Z | NodeGizmo.PICK_ARROW_X ) : 0;
                this._gizmoMask |= handleVis.plane ? NodeGizmo.PICK_PLANE_Y : 0;
            } else {
                this._gizmoMask = handleVis.rotation ? ( ( handleVis.sideView ? NodeGizmo.PICK_ARC_X : NodeGizmo.PICK_ARC_Z ) ) : 0;
                this._gizmoMask |= handleVis.axes ? ( ( handleVis.sideView ? ( NodeGizmo.PICK_ARROW_Z | NodeGizmo.PICK_ARROW_Y ) : ( NodeGizmo.PICK_ARROW_X | NodeGizmo.PICK_ARROW_Y ) ) ) : 0;
                this._gizmoMask |= handleVis.plane ? ( ( handleVis.sideView ? NodeGizmo.PICK_PLANE_X : NodeGizmo.PICK_PLANE_Z ) ) : 0;
            }
        } else {
            this._gizmoMask = handleVis.rotation ? NodeGizmo.PICK_ARC_Z : 0;
            this._gizmoMask |= handleVis.axes ? NodeGizmo.PICK_ARROW : 0;
            this._gizmoMask |= handleVis.plane ? NodeGizmo.PICK_PLANE : 0;
        }

        if ( this._attachedNode )
            this._attachedNode.editMask = this._gizmoMask;

        this.setTranslateInLocal( false ); // translation arrows are always oriented with world axes
        this.setRotateInLocal( !handleVis.planView ); // Z rotation always oriented with axes in floorplan

        this._rotateNode.removeChildren();
        this._planeNode.removeChildren();
        this._translateNode.removeChildren();
        this.initNodeRotate();
        this.initNodeTranslate();
        this.initNodeTranslatePlane();

        this.updateGizmoMask();
    },

    getGizmoMask: function () {
        return this._handleConfig;
    },

    // override
    createInstance: function ( viewer ) {
        return new LayerGizmo( viewer );
    },

    init: function () {

        NodeGizmo.prototype.init.call( this );

        this._updateCallbacks = [];
        var UpdateCallback = function () {};
        UpdateCallback.prototype = {
            update: this.updateGizmo.bind( this )
        };
        this.addUpdateCallback( new UpdateCallback() );
    },

    updateGizmo: function () {

        if ( !this._toolIsActive )
            return;

        // make sure the manipulator is set to get the eye position
        if ( !this._manipulator )
            this._manipulator = this._viewer.getManipulator();
        if ( this._attachedNode && this._active )
            this.updateImpl();
    },

    updateImpl: ( function () { // same as NodeGizmo.update, except for the worldMat calculation line
        var eye = vec3.create();
        var worldMat = mat4.create();
        var worldTrans = vec3.create();
        var tmpVec = vec3.create();
        var tmpMat = mat4.create();

        var worldTransForScale = vec3.create();


        return function () {
            if ( !this._attachedNode ) return;

            var ttype = this.getTransformType( this._attachedNode );
            this.setReferenceFrame( ttype );
            this.setCullingActive( ttype === osg.Transform.RELATIVE_RF );

            mat4.copy( worldMat, this._attachedNode.getMatrix() ); // THE ORIGINAL was: this._attachedNode.getWorldMatrix( undefined, worldMat );
            mat4.translate( worldMat, worldMat, this._pivotOffset );

            var worldMatForScale = this._attachedNode.getWorldMatrices()[ 0 ];

            // world trans
            mat4.getTranslation( worldTrans, worldMat );
            mat4.getTranslation( worldTransForScale, worldMatForScale );

            // normalize gizmo size relative to screen size
            var scaleFactor = LAYER_GIZMO_SCALE;
            var scaleFov = this._canvas.clientWidth * 0.023;

            if ( !this._viewer.getIsOrtho() ) {
                const proj = this._viewer.getCamera().getProjectionMatrix();
                scaleFov *= proj[ 0 ];
                this._manipulator.getEyePosition( eye );
            } else {
                scaleFov *= 1.5;
                this._manipulator.getOrthoEyePosition( eye );
            }

            // while we are editing we don't normalize the gizmo
            // it gives a better depth feedback, especially if we are editing a geometry that has
            // a constant screen size (for example an icon)

            this._lastDistToEye = this._isEditing ?
                this._lastDistToEye :
                vec3.distance( worldTransForScale, eye );
            scaleFactor *= this._lastDistToEye / scaleFov;

            // set the position of gizmo
            var gizmoMatrix = this.getMatrix();
            mat4.fromTranslation( gizmoMatrix, worldTrans );

            // set scale of gizmo
            vec3.set( tmpVec, scaleFactor, scaleFactor, scaleFactor );
            mat4.mul( gizmoMatrix, gizmoMatrix, mat4.fromScaling( tmpMat, tmpVec ) );

            vec3.sub( eye, eye, worldTrans );
            vec3.normalize( eye, eye );

            // rotate node
            if ( this._rotateInLocal || this._translateInLocal ) {
                // world scale
                mat4.getScale( tmpVec, worldMat );
                var invScale = mat4.fromScaling( tmpMat, tmpVec );
                mat4.invert( invScale, invScale );

                var worldRot = mat4.mul( worldMat, worldMat, invScale );
                worldRot[ 12 ] = worldRot[ 13 ] = worldRot[ 14 ] = 0.0;

                if ( this._translateInLocal ) {
                    mat4.copy( this._translateNode.getMatrix(), worldRot );
                    mat4.copy( this._planeNode.getMatrix(), worldRot );
                }

                if ( this._rotateInLocal ) {
                    mat4.copy( this._rotateNode.getMatrix(), worldRot );
                    mat4.invert( worldRot, worldRot );
                    vec3.transformMat4( eye, eye, worldRot );
                }
            } else {
                mat4.identity( this._rotateNode.getMatrix() );
            }

            this.updateArcRotation( eye );

            this._rotateNode.dirtyBound();
            this._translateNode.dirtyBound();
            this._planeNode.dirtyBound();

            if ( this._isEditing ) {
                mat4.copy( this._showAngle.getMatrix(), this._hoverNode.getMatrix() );
            }
        };
    } )(),

    // overrride: we need to add a transform node to make picking work on the rendering location
    setOnlyGizmoPicking: function () {

        // build transformation

        var pickWorldMat = mat4.create();
        this._parents[ 0 ].getWorldMatrix( undefined, pickWorldMat );
        this._pickWorldXForm.setMatrix( pickWorldMat );
        this._pickWorldXForm.addChild( this );

        // enable picking only for the gizmo
        this._viewer.getCamera().addChild( this._pickWorldXForm );
        this._viewer.getSceneData().setNodeMask( 0x0 );
        this.setNodeMask( ~0x0 );
    },

    // overrride
    setOnlyScenePicking: function () {

        this._pickWorldXForm.removeChild( this );

        this._viewer.getCamera().removeChild( this._pickWorldXForm );
        this._viewer.getSceneData().setNodeMask( ~0x0 );
        this.setNodeMask( NodeGizmo.NO_PICK );
    },

    // override: get edit translation from local gizmo matrix, not world matrix. Rotation and scale are still from world matrix 
    saveEditMatrices: function () {
        mat4.copy( this._editLocal, this._attachedNode.getMatrix() );
        // save the world translation
        var wm = this._attachedNode.getWorldMatrices()[ 0 ];
        var wm2 = this.getMatrix();
        mat4.fromTranslation( this._editWorldTrans, vec3.fromValues( wm2[ 12 ], wm2[ 13 ], wm2[ 14 ] ) );

        // save the inv of world rotation + scale
        mat4.copy( this._editWorldScaleRot, wm );

        // removes translation
        this._editWorldScaleRot[ 12 ] = this._editWorldScaleRot[ 13 ] = this._editWorldScaleRot[ 14 ] = 0.0;
        mat4.invert( this._editInvWorldScaleRot, this._editWorldScaleRot );
    },

    // overwrite to avoid problems when picking outside gizmo
    pickAndSelect: function ( ev ) {

        if ( !this._toolIsActive )
            return;

        var clientX, clientY;
        if ( ev.type === 'touchend' ) {
            clientX = ev.changedTouches[ 0 ].clientX;
            clientY = ev.changedTouches[ 0 ].clientY;
        } else {
            clientX = ev.clientX;
            clientY = ev.clientY;
        }

        this._viewer.limitIntersections( false );
        // Send true as fifth argument to avoid ev.preventDefault, so we get correctly mouseup event in StationLinkTool (using Chrome in Surface tablet)
        let hits = this._viewer.computeAllIntersections( ev, clientX, clientY, undefined, true );
        this._viewer.limitIntersections( true );

        if ( !hits || hits.length === 0 ) {
            if ( this._pickEnabled )
                this.disconnectFromLayerNode();
            return;
        }

        if ( !this._pickEnabled ) {

            var modelMat = osg.computeLocalToWorld( hits[ 0 ]._nodePath, true );
            mat4.translate( modelMat, modelMat, hits[ 0 ]._localIntersectionPoint );

            // world trans
            var worldTrans = osg.vec3.create();
            mat4.getTranslation( worldTrans, modelMat );

            // set the position of gizmo
            var gizmoMatrix = this._attachedNode.getMatrix();
            gizmoMatrix[ 12 ] = worldTrans[ 0 ];
            gizmoMatrix[ 13 ] = worldTrans[ 1 ];
            gizmoMatrix[ 14 ] = worldTrans[ 2 ];

            this._attachedNode.setMatrix( gizmoMatrix );
            this.setCurrentTransform();

            return;
        }

        // find if we are picking the current layer
        var layerNode; // non-group layer
        var nodePath = hits[ 0 ]._nodePath.slice();
        nodePath.reverse(); // Reverse to find the right layerNode and Layer
        for ( var i = 0; i < nodePath.length; i++ ) {
            if ( nodePath[ i ].Layer ) {
                layerNode = nodePath[ i ];
                break;
            }
        }
        if ( !layerNode ) {
            console.log( 'No layer picked to position LayerGizmo' );
            return;
        }
        if ( this._pickedLayer && layerNode.Layer !== this._pickedLayer )
            this.disconnectFromLayerNode();
        this._pickedLayer = layerNode.Layer;

        // make sure gizmo is attached
        this._forcedPivot = vec3.create();
        if ( !this._attachedNode ) {
            // attach to transform group layer
            var groupLayerNode;

            if ( this._mode === LayerGizmo.MODES.STATION )
                groupLayerNode = this._viewer.getSceneView().findTransformGroupLayerNode( layerNode.Layer );

            else if ( this._mode === LayerGizmo.MODES.RASTER && layerNode.Layer.getType() === LayerType.RASTER )
                groupLayerNode = layerNode._parents[ 0 ];

            if ( groupLayerNode ) {
                this.connectToLayerNode( this._pickedLayer, groupLayerNode );

                let selectionObject = Registry.getInstance().getController( 'SelectionObject' ).createSelectionObject( this._pickedLayer.getType() );
                selectionObject.setLayer( this._pickedLayer );
                Registry.getInstance().getController( 'SelectionObject' ).setSelectionObject( selectionObject );
            }
        }
        if ( !this._attachedNode ) {
            console.error( 'Could not find layer node to attach gizmo' );
            return;
        }

        if ( !this._pickPivotMode )
            return;

        // make sure nodepath contains Xform
        nodePath = hits[ 0 ]._nodePath;
        for ( var iNode = 0; iNode < nodePath.length; iNode++ ) {
            if ( nodePath[ iNode ] === this._parents[ 0 ] ) {
                if ( nodePath[ iNode + 1 ] !== this._attachedNode ) { // does not contain transformation yet
                    nodePath.splice( iNode + 1, 0, this._attachedNode );
                }
                break;
            }
        }

        // set local pivot position
        var hitWorld = this._viewer.calculateWorldHitCoords( hits[ 0 ] );

        var worldMat = mat4.create();
        mat4.copy( worldMat, this._attachedNode.getMatrix() );
        mat4.invert( worldMat, worldMat );
        vec3.transformMat4( this._pivotOffset, hitWorld, worldMat );

        vec3.copy( this._forcedPivot, this._pivotOffset );

        this.saveEditMatrices();
    },

    // overwrite to use the correct getCanvasCoord on touch devices
    computeNearestIntersection: ( function () {
        var sortByRatio = function ( a, b ) {
            return a._ratio - b._ratio;
        };

        var coord = vec2.create();

        return function ( e, tmask ) {
            getCanvasCoord( coord, e ); // overwrite

            // canvas to webgl coord
            var viewer = this._viewer;
            var canvas = this._canvas;
            var x = coord[ 0 ] * ( viewer._canvasWidth / canvas.clientWidth );
            var y =
                ( canvas.clientHeight - coord[ 1 ] ) * ( viewer._canvasHeight / canvas.clientHeight );

            var hits = this._viewer.computeIntersections( x, y, tmask );

            if ( hits.length === 0 ) return undefined;

            hits.sort( sortByRatio );
            return hits[ 0 ];
        };
    } )(),

    saveLastXformMat: function () {
        if ( !this._attachedNode ) {
            console.error( 'No node attached to gizmo' );
            return;
        }
        mat4.copy( this._lastXformMat, this._attachedNode.getMatrix() );
        this._isMovementDone = true;
    },

    setCurrentTransform: function ( newLayerID ) {

        var mat = this._attachedNode.getMatrix();
        var rotQuad = mat4.getRotation( osg.quat.create(), mat );
        Utils.makeEulerFromQuat( this._currentTransform.angles, rotQuad );
        mat4.getTranslation( this._currentTransform.translation, mat );
        mat4.getScale( this._currentTransform.scale, mat );

        if ( newLayerID && !this._originalTransforms.has( newLayerID ) ) { // save a copy as original transform for resetting later
            var newOrigTransform = {
                angles: vec3.create(),
                translation: vec3.create(),
                scale: vec3.create()
            };
            osg.vec3.copy( newOrigTransform.angles, this._currentTransform.angles );
            osg.vec3.copy( newOrigTransform.translation, this._currentTransform.translation );
            osg.vec3.copy( newOrigTransform.scale, this._currentTransform.scale );

            this._originalTransforms.set( newLayerID, newOrigTransform );
        }

        if ( this._UIRefreshCB )
            this._UIRefreshCB();
    },

    resetTransform: function ( resetTranslation, resetAngles, resetScale ) {

        if ( !this._pickedLayer || !this._pickedLayer.getId ) {
            console.log( 'Transformation reset not possible for this object' );
            return;
        }

        var origTransform = this._originalTransforms.get( this._pickedLayer.getId() );
        if ( !origTransform ) {
            console.error( 'Could not find original transformation' );
            return;
        }

        if ( resetAngles )
            osg.vec3.copy( this._currentTransform.angles, origTransform.angles );
        if ( resetTranslation )
            osg.vec3.copy( this._currentTransform.translation, origTransform.translation );
        if ( resetScale )
            osg.vec3.copy( this._currentTransform.scale, origTransform.scale );

        this.setCurrentTransformConfig( this._currentTransform );
    },

    setCurrentTransformConfig: function ( xformconfig, orderPrior, oldValue ) {
        this.saveLastXformMat();

        if ( !this._attachedNode ) {
            console.error( 'No node attached to gizmo' );
            return;
        }

        var applyConfig = {
            angles: xformconfig.angles,
            translation: xformconfig.translation,
            scale: xformconfig.scale
        };
        if ( !applyConfig.angles )
            applyConfig.angles = this._currentTransform.angles;
        if ( !applyConfig.translation )
            applyConfig.translation = this._currentTransform.translation;
        if ( !applyConfig.scale )
            applyConfig.scale = this._currentTransform.scale;

        var mrot = mat4.create();

        var vecX = vec3.fromValues( 1.0, 0.0, 0.0 );
        var vecY = vec3.fromValues( 0.0, 1.0, 0.0 );
        var vecZ = vec3.fromValues( 0.0, 0.0, 1.0 );

        var attMat = this._attachedNode.getMatrix();
        if ( orderPrior === 0 ) mat4.fromRotation( mrot, applyConfig.angles[ 0 ] - oldValue, vecX );
        else if ( orderPrior === 1 ) mat4.fromRotation( mrot, applyConfig.angles[ 1 ] - oldValue, vecY );
        else if ( orderPrior === 2 ) mat4.fromRotation( mrot, applyConfig.angles[ 2 ] - oldValue, vecZ );
        else {
            var qRot = osg.quat.create();
            Utils.glMatrixFromEuler( qRot, applyConfig.angles[ 0 ], applyConfig.angles[ 1 ], applyConfig.angles[ 2 ] );
            mrot = osg.mat4.fromQuat( osg.mat4.create(), qRot );
        }

        if ( !this._rotateInLocal && orderPrior !== undefined ) {
            mat4.mul( mrot, this._editInvWorldScaleRot, mrot );
            mat4.mul( mrot, mrot, this._editWorldScaleRot );
        }

        // rotate around origin pivot (geometry center)
        // the classic rotation around pivot : -T * R * T


        var negatePivot = vec3.create();

        // mat4.translate( attMat, /*this._editLocal*/ attMat, this._pivotOffset );
        mat4.translate( attMat, attMat, this._pivotOffset );

        if ( orderPrior !== undefined ) {
            mat4.mul( attMat, attMat, mrot );
            mat4.translate( attMat, attMat, vec3.negate( negatePivot, this._pivotOffset ) );
        } else {
            mat4.copy( attMat, mrot );

            // apply translation
            attMat[ 12 ] = applyConfig.translation[ 0 ];
            attMat[ 13 ] = applyConfig.translation[ 1 ];
            attMat[ 14 ] = applyConfig.translation[ 2 ];
        }
        // TODO: Apply scale
        // osg.mat4.scale( mat, mat, applyConfig.scale );


        this._attachedNode.setMatrix( attMat );

        this._attachedNode.dirtyBound();
        if ( this._UIRefreshCB )
            this._UIRefreshCB();

        this.saveEditMatrices();
    },

    getCurrentTransformConfig: function () {
        return this._currentTransform;
    },

    setUIRefreshCB: function ( cb ) {
        this._UIRefreshCB = cb;
    },

    // overrides to capture last movements

    startRotateEdit: function ( ev ) {
        this.saveLastXformMat();
        NodeGizmo.prototype.startRotateEdit.call( this, ev );
    },

    startTranslateEdit: function ( ev ) {
        this.saveLastXformMat();
        NodeGizmo.prototype.startTranslateEdit.call( this, ev );
    },

    startPlaneEdit: function ( ev ) {
        this.saveLastXformMat();
        NodeGizmo.prototype.startPlaneEdit.call( this, ev );
    },

    updateRotateEdit: function ( ev ) {
        NodeGizmo.prototype.updateRotateEdit.call( this, ev );
        this.setCurrentTransform();
    },

    updateTranslateEdit: function ( ev ) {
        NodeGizmo.prototype.updateTranslateEdit.call( this, ev );
        this.setCurrentTransform();
    },

    updatePlaneEdit: function ( ev ) {
        NodeGizmo.prototype.updatePlaneEdit.call( this, ev );
        this.setCurrentTransform();
    },

    getHasLastMovement: function () {
        return this._isMovementDone;
    },

    undoLastMovement: function () {
        if ( !this._isMovementDone )
            return;

        mat4.copy( this._attachedNode.getMatrix(), this._lastXformMat );
        this._isMovementDone = false;
        this.setCurrentTransform();
    },


    initNodeTranslate: function () {
        if ( !( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) )
            return NodeGizmo.prototype.initNodeTranslate.call( this );

        var aHeight = 1.5;
        var aConeHeight = 0.3;
        var pickStart = 0.5; // offset (because of the picking plane)
        var pickHeight = ( aHeight - pickStart + aConeHeight ) * 1.1;

        // cone arrow
        var mtCone = new MatrixTransform();
        mat4.fromTranslation(
            mtCone.getMatrix(),
            vec3.fromValues( 0.0, 0.0, aHeight + aConeHeight * 0.5 )
        );
        // Overwritten: bigger radius bottom
        mtCone.addChild(
            GizmoGeometry.createCylinderGeometry( 0.0, 0.14, aConeHeight, 32, 1, true, true )
        );
        // arrow base
        var mtArrow = new MatrixTransform();
        mat4.fromTranslation( mtArrow.getMatrix(), vec3.fromValues( 0.0, 0.0, aHeight * 0.5 ) );
        // Overwritten: bigger radius top and bottom
        mtArrow.addChild(
            GizmoGeometry.createCylinderGeometry( 0.04, 0.04, aHeight, 32, 1, true, true )
        );
        // draw arrow
        var drawArrow = new Node();
        drawArrow.addChild( mtArrow );
        drawArrow.addChild( mtCone );

        // Overwritten: bigger radius top and bottom
        var pickArrow = GizmoGeometry.createCylinderGeometry(
            0.4,
            0.4,
            pickHeight,
            32,
            1,
            true,
            true
        );

        var mtX = new MatrixTransform();
        var mtY = new MatrixTransform();
        var mtZ = new MatrixTransform();
        mtX._nbAxis = 0;
        mtY._nbAxis = 1;
        mtZ._nbAxis = 2;

        mat4.fromRotation( mtX.getMatrix(), Math.PI * 0.5, vec3.fromValues( 0.0, 1.0, 0.0 ) );
        mat4.fromRotation( mtY.getMatrix(), -Math.PI * 0.5, vec3.fromValues( 1.0, 0.0, 0.0 ) );

        var hideNode = new MatrixTransform();
        hideNode.setCullCallback( new HideCullCallback() );
        mat4.fromTranslation(
            hideNode.getMatrix(),
            vec3.fromValues( 0.0, 0.0, pickStart + pickHeight * 0.5 )
        );
        hideNode.addChild( pickArrow );

        // set masks
        drawArrow.setNodeMask( NodeGizmo.NO_PICK );
        mtX.setNodeMask( NodeGizmo.PICK_ARROW_X );
        mtY.setNodeMask( NodeGizmo.PICK_ARROW_Y );
        mtZ.setNodeMask( NodeGizmo.PICK_ARROW_Z );

        mtX.addChild( drawArrow );
        mtY.addChild( drawArrow );
        mtZ.addChild( drawArrow );

        mtX.addChild( hideNode );
        mtY.addChild( hideNode );
        mtZ.addChild( hideNode );

        mtX
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 1.0, 0.0, 0.0, 1.0 ), 'uColor' ) );
        mtY
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 1.0, 0.0, 1.0 ), 'uColor' ) );
        mtZ
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 0.0, 1.0, 1.0 ), 'uColor' ) );

        var translate = this._translateNode;
        translate.setNodeMask( NodeGizmo.PICK_ARROW );
        translate.addChild( mtX );
        translate.addChild( mtY );
        translate.addChild( mtZ );
        return translate;
    },

    initNodeRotate: function () {
        if ( !( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) )
            return NodeGizmo.prototype.initNodeRotate.call( this );

        // Overwritten: bigger radius width
        var drawArcXYZ = GizmoGeometry.createTorusGeometry( 1.0, 0.04, 6, 64, Math.PI * 2 );
        var drawArc = GizmoGeometry.createTorusGeometry( 1.0, 0.04, 6, 64, Math.PI );
        var pickArc = GizmoGeometry.createTorusGeometry( 1.0, 0.4, 6, 64, Math.PI );

        var mtXYZ = new MatrixTransform();
        var mtX = new MatrixTransform();
        var mtY = new MatrixTransform();
        var mtZ = new MatrixTransform();
        mtX._nbAxis = 0;
        mtY._nbAxis = 1;
        mtZ._nbAxis = 2;

        var hideNode = new Node();
        hideNode.setCullCallback( new HideCullCallback() );
        hideNode.addChild( pickArc );

        // set masks
        drawArcXYZ.setNodeMask( NodeGizmo.NO_PICK );
        drawArc.setNodeMask( NodeGizmo.NO_PICK );
        mtX.setNodeMask( NodeGizmo.PICK_ARC_X );
        mtY.setNodeMask( NodeGizmo.PICK_ARC_Y );
        mtZ.setNodeMask( NodeGizmo.PICK_ARC_Z );

        mtXYZ.addChild( drawArcXYZ );
        mtX.addChild( drawArc );
        mtY.addChild( drawArc );
        mtZ.addChild( drawArc );

        mtX.addChild( hideNode );
        mtY.addChild( hideNode );
        mtZ.addChild( hideNode );

        mtXYZ
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.2, 0.2, 0.2, 1.0 ), 'uColor' ) );
        mtX
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 1.0, 0.0, 0.0, 1.0 ), 'uColor' ) );
        mtY
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 1.0, 0.0, 1.0 ), 'uColor' ) );
        mtZ
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 0.0, 1.0, 1.0 ), 'uColor' ) );

        var showAngle = this._showAngle;
        showAngle.getOrCreateStateSet().setAttributeAndModes( blendAttribute );
        showAngle.setNodeMask( 0x0 );
        showAngle
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat3( vec3.fromValues( 1.0, 0.0, 0.0 ), 'uBase' ) );
        showAngle.getOrCreateStateSet().addUniform( Uniform.createFloat( 0.0, 'uAngle' ) );
        showAngle.addChild( GizmoGeometry.createQuadCircleGeometry() );

        var rotate = this._rotateNode;
        rotate.setNodeMask( NodeGizmo.PICK_ARC );
        rotate.addChild( mtXYZ );
        rotate.addChild( mtX );
        rotate.addChild( mtY );
        rotate.addChild( mtZ );
        rotate.addChild( showAngle );
        return rotate;
    },

    initNodeTranslatePlane: function () {
        if ( !( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) )
            return NodeGizmo.prototype.initNodeTranslatePlane.call( this );

        var mtPlane = new MatrixTransform();
        mat4.fromTranslation( mtPlane.getMatrix(), vec3.fromValues( 0.5, 0.5, 0.0 ) );
        // Overwritten: bigger scale factor
        mat4.mul(
            mtPlane.getMatrix(),
            mat4.fromScaling( mat4.create(), vec3.fromValues( 0.8, 0.8, 1.0 ) ),
            mtPlane.getMatrix()
        );
        mtPlane.addChild( GizmoGeometry.createPlaneGeometry() );

        var mtX = new MatrixTransform();
        var mtY = new MatrixTransform();
        var mtZ = new MatrixTransform();
        mtX._nbAxis = 0;
        mtY._nbAxis = 1;
        mtZ._nbAxis = 2;

        mat4.fromRotation( mtX.getMatrix(), -Math.PI * 0.5, vec3.fromValues( 0.0, 1.0, 0.0 ) );
        mat4.fromRotation( mtY.getMatrix(), Math.PI * 0.5, vec3.fromValues( 1.0, 0.0, 0.0 ) );

        // set masks
        mtX.setNodeMask( NodeGizmo.PICK_PLANE_X );
        mtY.setNodeMask( NodeGizmo.PICK_PLANE_Y );
        mtZ.setNodeMask( NodeGizmo.PICK_PLANE_Z );

        mtX.addChild( mtPlane );
        mtY.addChild( mtPlane );
        mtZ.addChild( mtPlane );

        mtX
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 1.0, 0.0, 0.0, 0.3 ), 'uColor' ) );
        mtY
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 1.0, 0.0, 0.3 ), 'uColor' ) );
        mtZ
            .getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( vec4.fromValues( 0.0, 0.0, 1.0, 0.3 ), 'uColor' ) );

        var plane = this._planeNode;
        plane.setNodeMask( NodeGizmo.PICK_PLANE );
        plane.getOrCreateStateSet().setAttributeAndModes( blendAttribute );
        plane.addChild( mtX );
        plane.addChild( mtY );
        plane.addChild( mtZ );
        return plane;
    },

    setPickEnabled: function ( flag ) {
        this._pickEnabled = flag;
    },

    setMode: function ( mode ) {
        this._mode = mode;
    },

    resetGraph: function () {
        if ( !this._attachedNode )
            return;
        var parent = this._attachedNode.getParents()[ 0 ];
        if ( parent ) {
            if ( this._attachedNode.getChildren()[ 0 ] !== undefined ) // The layer can have been removed
                parent.addChild( this._attachedNode.getChildren()[ 0 ] );
            parent.removeChild( this._attachedNode );

        }
        this._attachedNode.removeChildren();
    },

    resetLastXFormMat: function () {
        this._isMovementDone = false;
        this._lastXformMat = mat4.create();
    }

} );

module.exports = LayerGizmo;


/***/ }),

/***/ "./sources/pcvizNode/LayerScene.js":
/*!*****************************************!*\
  !*** ./sources/pcvizNode/LayerScene.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

/**
 * Abstract class to define a scene for any type of layers.
 * @class
 * @memberof pcvizNode
 * @extends osg.Node
 * @property {bool} _dirtyData A flag to indicate if the 'array of layers' is modified
 */
var LayerScene = function () {
    osg.Node.call( this );

    this._dirtyData = true;

    // offset
    this._center = undefined;

};

LayerScene.NO_TRAVERSED = 0; // It never has been traversed with _dirtyData = true
LayerScene.TRAVERSED = 1; // First time it has been traversed with _dirtyData = true
LayerScene.TRAVERSED_AND_RESET = 2; // It has been traversed with _dirtyData = true and the extent has been reset

LayerScene.prototype = osg.objectInherit( osg.Node.prototype, {

    setEnableIntersections: function ( enableIntersections ) {
        if ( enableIntersections )
            this.setNodeMask( ~0x0 );
        else
            this.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
    },

    setCenter: function ( center ) {
        this._center = center;
    },

    getCenter: function () {
        return this._center;
    },

} );

module.exports = LayerScene;


/***/ }),

/***/ "./sources/pcvizNode/LightingAttribute.js":
/*!************************************************!*\
  !*** ./sources/pcvizNode/LightingAttribute.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;

var LightingAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    //this._lightingArray = new  Float32Array( [ 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0, 1.0 ] );
};

LightingAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'Lighting',
    cloneType: function () {
        return new LightingAttribute();
    },

    setEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isEnabled: function () {
        return this._attributeEnable;
    },

    getHash: function () {
        return this.getType() + this._attributeEnable.toString();
    }
} ), 'osg', 'LightingAttribute' );

module.exports = LightingAttribute;


var LightingNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
};

LightingNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'Lighting',
    validInputs: [],
    validOutputs: [ 'VertexColor' ],

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        return '#pragma include "lighting.glsl"';
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        return osgShader.utils.callFunction( 'computeLighting', undefined, [ this._outputs.VertexColor ] );
    }

} );

factory.registerNode( 'Lighting', LightingNode );


/***/ }),

/***/ "./sources/pcvizNode/Model3DLayerScene.js":
/*!************************************************!*\
  !*** ./sources/pcvizNode/Model3DLayerScene.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var LayerScene = __webpack_require__( /*! pcvizNode/LayerScene */ "./sources/pcvizNode/LayerScene.js" );

/**
 * Specifies a scene with features from vector layers
 * @class
 * @memberof pcvizNode
 * @extends pcvizNode.LayerScene
 * @property {Array} _3DNodes Stores the nodes that render the features
 * @property {bool} _dirtyData A flag to indicate if the _3DNodes array is modified
 */
var Model3DLayerScene = function () {
    LayerScene.call( this );

    this._3DNodes = [];
};

Model3DLayerScene.prototype = osg.objectInherit( LayerScene.prototype, {

    get3DLayerNodes: function () {
        return this._3DNodes;
    },

    /**
     * Add a node that renders a vector layer to the _featuresNodes array.
     * @method
     * @memberof pcvizNode.Model3DLayerScene
     * @param {osg.Node} featuresNode the node that renders a vector layer
     */
    add3DLayerNode: function ( model3DNode ) {

        this._3DNodes.push( model3DNode );
        this._dirtyData = true;
    },

    find3DLayerNode: function ( layer ) {
        return this._3DNodes.find( function ( node ) {
            return ( layer._objectId === node.Layer._objectId );
        } );
    },

    /**
     * Delete a node that renders a 3D model from the _3DNodes array.
     * @method
     * @memberof pcvizNode.Model3DLayerScene
     * @param {integer} idLayer the id of the vector layer that we want to remove its node
     */
    delete3DLayerNode: function ( idLayer ) {
        var found = false;
        // make sure all feature nodes with same ID are removed
        // we assume they are contiguous
        for ( var i = 0; i < this._3DNodes.length; i++ ) {
            if ( this._3DNodes[ i ].id === idLayer ) {
                this._3DNodes.splice( i, 1 );
                this._dirtyData = true;
                found = true;
            } else if ( found )
                break;
        }
    },

    // It is not used
    getCenter: function () {
        if ( this._center !== undefined )
            return this._center;

        if ( this._3DNodes.length > 0 ) {
            this._center = new osg.vec3.create64();
            osg.vec3.copy( this._center, this._3DNodes[ 0 ].Layer.getCenter() );
            return this._center;
        }
    },

    /**
     * Overwritten function to add and traverse the nodes according to the currently layers loaded.
     * @method
     * @memberof pcvizNode.Model3DLayerScene
     */
    traverse: function ( visitor ) {

        if ( this._3DNodes.length < 1 ) {
            if ( this._dirtyData ) {
                this._dirtyData = false;
            }
            return;
        }

        if ( this._dirtyData ) {


            this.removeChildren();
            for ( var i = 0; i < this._3DNodes.length; i++ ) {
                this.addChild( this._3DNodes[ i ] );
            }

            this._dirtyData = false;
            this.dirtyBound();
        }

        for ( var j = 0; j < this.getNumChildren(); j++ )
            this.getChild( j ).accept( visitor );
    }

} );

module.exports = Model3DLayerScene;


/***/ }),

/***/ "./sources/pcvizNode/Model3DNode.js":
/*!******************************************!*\
  !*** ./sources/pcvizNode/Model3DNode.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );

/**
 * Model3DNode
 * @class
 * @extends osg.Node
 * @memberof pcvizNode
 */
var Model3DNode = function ( layer ) {
    osg.MatrixTransform.call( this );

    this._layer = layer;
};

Model3DNode.prototype = osg.objectInherit( osg.MatrixTransform.prototype, {

    addModelNode: function ( child ) {
        child.layer = this._layer;
        this.originalBounding = child.originalBounding; // comes only from 3DTiles childs
        this.addChild( child );
    },

    applyRotation: function ( originalBounding ) {
        var positionOri = CRSUtils.transform( 'EPSG:4978', CRSUtils.WGS_84, [ originalBounding.center()[ 0 ], originalBounding.center()[ 1 ], originalBounding.center()[ 2 ] ] );
        var matrixRotateLon = osg.mat4.create64();
        osg.mat4.fromRotation( matrixRotateLon, ( ( -positionOri[ 0 ] - 90 ) * Math.PI ) / 180, osg.vec3.fromValues( 0, 0, 1 ) );

        var matrixRotateLat = osg.mat4.create64();
        osg.mat4.fromRotation( matrixRotateLat, ( ( positionOri[ 1 ] - 90 ) * Math.PI ) / 180, osg.vec3.fromValues( 1, 0, 0 ) );

        var matrixRotate = osg.mat4.create64();
        osg.mat4.mul( matrixRotate, matrixRotateLat, matrixRotateLon );
        this.setMatrix( matrixRotate );
    }

} );

module.exports = Model3DNode;


/***/ }),

/***/ "./sources/pcvizNode/PlanarImage.js":
/*!******************************************!*\
  !*** ./sources/pcvizNode/PlanarImage.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var GeoImageNode = __webpack_require__( /*! pcvizNode/GeoImageNode */ "./sources/pcvizNode/GeoImageNode.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;

/**
 * A node to render planar images.
 * @class
 * @memberof pcvizNode
 * @extends osg.Node
 */
var PlanarImage = function () {
    GeoImageNode.call( this );
    this._category = VectorLayerUtils.Categories.PLANAR_IMAGE;

    this._fovX = 61.9 * Math.PI / 180; // in radians
    this._fovY = 43.6 * Math.PI / 180;
    // initialize non zero to avoid errors if not set
    this._principalPointX = 8.0;
    this._principalPointY = 4.5;
    this._cameraSensorWidth = 16.0;
    this._cameraSensorHeight = 9.0;
    this._distance = Registry.getController( 'UserPreferences' ).getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY );

    this._dirty = false; // Now, we don't want to rebuid the graph by the traverse method the first time.
    this._distortionParams = undefined;

    this.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
};

PlanarImage.FOVTable = {
    FocalLength35mmEquiv: [ 10, 11, 12, 14, 15, 17, 18, 19, 20, 24, 28, 30, 35, 45, 50, 55, 60, 70, 75, 80, 85, 90, 100, 105, 120, 125, 135, 150, 170, 180, 200, 210, 300, 400, 500, 600, 800 ],
    HorizontalFOV: [ 121.9, 117.1, 112.6, 104.3, 100.4, 93.3, 90.0, 86.9, 84.0, 73.7, 65.5, 61.9, 54.4, 43.6, 39.6, 36.2, 33.4, 28.8, 27.0, 25.4, 23.9, 22.6, 20.4, 19.5, 17.1, 16.4, 15.2, 13.7, 12.1, 11.4, 10.3, 9.8, 6.9, 5.2, 4.1, 3.4, 2.6 ],
    VerticalFOV: [ 100.4, 95.0, 90.0, 81.2, 77.3, 70.4, 67.4, 64.6, 61.9, 53.1, 46.4, 43.6, 37.8, 29.9, 27.0, 24.6, 22.6, 19.5, 18.2, 17.1, 16.1, 15.2, 13.7, 13.0, 11.4, 11.0, 10.2, 9.1, 8.1, 7.6, 6.9, 6.5, 4.6, 3.4, 2.7, 2.3, 1.7 ]
};

PlanarImage.prototype = osg.objectInherit( GeoImageNode.prototype, {

    getReadNodeOptions: function ( layer ) {
        var nodeOptions = GeoImageNode.prototype.getReadNodeOptions.call( this );

        nodeOptions.fovx = this._fovX;
        nodeOptions.fovy = this._fovY;
        nodeOptions.principalPointX = this._principalPointX;
        nodeOptions.principalPointY = this._principalPointY;
        nodeOptions.cameraSensorWidth = this._cameraSensorWidth;
        nodeOptions.cameraSensorHeight = this._cameraSensorHeight;
        nodeOptions.layer = layer;
        // If it is a RasterLayer we use the _distance. If not, we are getting the distance from the Registry where we need it.
        if ( layer.getType() === 'RasterLayer' )
            nodeOptions.distance = this._distance;
        nodeOptions.dirty = this._dirty;
        nodeOptions.distortionParams = this._distortionParams;

        return nodeOptions;
    },


    /**
     * Gets the forward and up vectors and the vertical field of view angle
     * @method
     * @memberof pcvizNode.PlanarImage
     * @return {object}  An object with the `forward` and `up` vectors, and the vertical field of view (`fovy`).
     */
    getLookAt: ( function () {
        var forward = osg.vec3.create64();
        var up = osg.vec3.create64();
        return function () {
            osg.vec3.set( up, 0.0, 1.0, 0.0 );
            osg.vec3.set( forward, 0.0, 0.0, -1.0 );
            osg.vec3.transformQuat( forward, forward, this._rotationQuat );
            osg.vec3.normalize( forward, forward );
            osg.vec3.transformQuat( up, up, this._rotationQuat );
            osg.vec3.normalize( up, up );
            return {
                forward: forward,
                up: up,
                fovy: this._fovY
            };
        };
    } )(),

    /**
     * Computes the horizontal and vertical field of view angles to position the planar image properly.
     * @method
     * @memberof pcvizNode.PlanarImage
     * @param  {float} focalLength The equivalent 35mm focal length of the camera.
     */
    set35mmEquivalentFieldOfView: function ( focalLength ) {
        var fovs = this.computeEquivalentFieldOfView( focalLength );
        this._fovX = fovs.x;
        this._fovY = fovs.y;
    },

    computeEquivalentFieldOfView: function ( focalLength ) {
        var index = PlanarImage.FOVTable.FocalLength35mmEquiv.indexOf( focalLength );
        var fovX, fovY;
        if ( index !== -1 ) {
            fovX = PlanarImage.FOVTable.HorizontalFOV[ index ] * Math.PI / 180.0;
            fovY = PlanarImage.FOVTable.VerticalFOV[ index ] * Math.PI / 180.0;
            return {
                x: fovX,
                y: fovY
            };
        }
        for ( index = 0; index < PlanarImage.FOVTable.FocalLength35mmEquiv.length - 1; index++ ) {
            if ( focalLength < PlanarImage.FOVTable.FocalLength35mmEquiv[ index + 1 ] )
                break;
        }
        var flLow = PlanarImage.FOVTable.FocalLength35mmEquiv[ index ];
        var hFOVLow = PlanarImage.FOVTable.HorizontalFOV[ index ];
        var vFOVLow = PlanarImage.FOVTable.VerticalFOV[ index ];
        var hFOVHigh = PlanarImage.FOVTable.HorizontalFOV[ index + 1 ];
        var vFOVHigh = PlanarImage.FOVTable.VerticalFOV[ index + 1 ];
        var interval = PlanarImage.FOVTable.FocalLength35mmEquiv[ index + 1 ] - PlanarImage.FOVTable.FocalLength35mmEquiv[ index ];
        var percentage = ( focalLength - flLow ) / interval;
        fovX = ( hFOVLow * ( 1 - percentage ) + percentage * hFOVHigh ) * Math.PI / 180.0;
        fovY = ( vFOVLow * ( 1 - percentage ) + percentage * vFOVHigh ) * Math.PI / 180.0;
        return {
            x: fovX,
            y: fovY
        };
    },

    /**
     * Sets the vertical and horizontal FOV angles directly
     * @method
     * @memberof pcvizNode.PlanarImage
     * @param  {float} fovW The angle of the horizontal FOV (in radians)
     * @param  {float} fovH The angle of the vertical FOV (in radians)
     */
    setFieldOfViewValues: function ( fovW, fovH ) {
        if ( fovW !== this._fovX || fovH !== this._fovY ) {
            this._dirty = true;

            this._fovX = fovW;
            this._fovY = fovH;
        }
    },

    /**
     * Sets the camera principal point (mm)
     * @method
     * @memberof pcvizNode.PlanarImage
     * @param  {float} principalPointX X coordinate of the principal point
     * @param  {float} principalPointY Y coordinate of the principal point
     */
    setCameraPrincipalPoint: function ( principalPointX, principalPointY ) {
        if ( principalPointX !== this._principalPointX || principalPointY !== this._principalPointY ) {
            this._dirty = true;
            this._principalPointX = principalPointX;
            this._principalPointY = principalPointY;
        }
    },

    /**
     * Sets the sensor size (mm)
     * @method
     * @memberof pcvizNode.PlanarImage
     * @param {float} width Width of the sensor
     * @param {float} height Height of the sensor
     */
    setCameraSensorSize: function ( width, height ) {
        if ( width !== this._cameraSensorWidth || height !== this._cameraSensorHeight ) {
            this._dirty = true;
            this._cameraSensorWidth = width;
            this._cameraSensorHeight = height;
        }
    },

    setDistortionParams: function ( distortionParams ) {
        if ( distortionParams.P1 === null )
            distortionParams.P1 = 0;
        if ( distortionParams.P2 === null )
            distortionParams.P2 = 0;
        this._distortionParams = distortionParams;
    },

    setImageMode: function ( mode ) {
        if ( mode )
            this.setDepth( this._imageMode ? this._seeInFront : true, false );
        else
            this.setDepth( false, true );

        this._imageMode = mode;

        if ( this._geometryNode && this._geometryNode.activate )
            this._geometryNode.activate( mode );
        if ( mode )
            return;

        // If the mode is false, we need to reset the mask of the cameras to visible
        if ( this._symbolizer )
            this._symbolizer._camerasNode.setNodeMask( Utils.VISIBILITY_MASK & ~Utils.TRAVERSAL_MASK_IV );

        var selObj = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
        if ( selObj && selObj.getLayer() && ( !selObj.getLayer().getCategory || !VectorLayerUtils.isPlanarImage( selObj.getLayer().getCategory() ) || !selObj.getFeature() ) && this.getParents().length )
            this.getParents()[ 0 ].removeChildren();
    },

    setSymbolizer: function ( symbolizer ) {
        this._symbolizer = symbolizer;
    },

    setDistance: function ( distance ) {
        if ( distance !== this._distance ) {
            this._dirty = true;

            this._distance = distance;
        }
    },

    traverse: function ( visitor ) {
        if ( this._dirty && this._geometryNode !== undefined ) {
            this._geometryNode.releaseGLObjects();
            this.removeChildren();
            var self = this;
            osgDB.readNodeURL( this._lastTextureUrl, this.getReadNodeOptions( this._layer ) ).then( function ( child ) {
                self._geometryNode = child;
                self.addChild( child );
                if ( self._geometryNode.activate )
                    self._geometryNode.activate( self._multiResolutionEnabled );
            } );
            this._dirty = false;
        }

        for ( var j = 0; j < this.getNumChildren(); j++ )
            this.getChild( j ).accept( visitor );
    }

} );


module.exports = PlanarImage;


/***/ }),

/***/ "./sources/pcvizNode/PointCloudPLOD.js":
/*!*********************************************!*\
  !*** ./sources/pcvizNode/PointCloudPLOD.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Jordi torres <jordi.torres@mirage-tech.com>
 */


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var CollagePLOD = __webpack_require__( /*! pcvizNode/CollagePLOD */ "./sources/pcvizNode/CollagePLOD.js" );

var osg = OSG.osg;

/**
 *  PointCloudPLOD
 *  @class
 *  @memberof pcvizNode
 */
var PointCloudPLOD = function () {
    CollagePLOD.call( this );
    this._options = undefined;
    this._designation = undefined;

    this._id = '';

    this._trX = 0.0;
    this._trY = 0.0;
    this._trZ = 0.0;

    this._tileOrigin = osg.vec3.create64();
    this._focalLength = 0;
};


PointCloudPLOD.prototype = osg.objectInherit( CollagePLOD.prototype, {
    setId: function ( id ) {
        this._id = id;
    },
    setDesignation: function ( designation ) {
        this._designation = designation;
    },
    getDesignation: function () {
        return this._designation;
    },
    setOptions: function ( options ) {
        this._options = options;
    },
    getOptions: function () {
        return this._options;
    },
    getTileOrigin: function () {
        return this._tileOrigin;
    },
    removeExpiredChildren: function ( expiryTime, expiryFrame, removedChildren ) {
        if ( this.children.length <= this._numChildrenThatCannotBeExpired ) return;
        var i = this.children.length - 1;
        var timed, framed;
        timed = this._perRangeDataList[ i ].timeStamp + this._expiryTime;
        framed = this._perRangeDataList[ i ].frameNumber + this._expiryFrame;
        if ( ( i > this._numChildrenThatCannotBeExpired - 1 ) && timed < expiryTime && framed < expiryFrame && ( this._perRangeDataList[ i ].filename.length > 0 ||
                this._perRangeDataList[ i ].function !== undefined ) ) {
            removedChildren.push( this.children[ i ] );
            this.removeChild( this.children[ i ] );
            this._perRangeDataList[ i ].loaded = false;
            if ( this._perRangeDataList[ i ].dbrequest !== undefined ) {
                this._perRangeDataList[ i ].dbrequest._groupExpired = true;
                for ( var h = this._perRangeDataList[ i ].dbrequest._requests.length - 1; h >= 0; h-- ) {
                    var xhr = this._perRangeDataList[ i ].dbrequest._requests.pop();
                    xhr.abort();
                }
                //this._perRangeDataList[ i ].dbrequest = undefined;
            }
        }
    },
    traverse: ( function () {

        // avoid to generate variable on the heap to limit garbage collection
        // instead create variable and use the same each time
        var zeroVector = osg.vec3.create32();
        var eye = osg.vec3.create32();
        var viewModel = osg.mat4.create();

        return function ( visitor ) {

            var traversalMode = visitor.traversalMode;
            var updateTimeStamp = false;

            if ( visitor.getVisitorType() === osg.NodeVisitor.CULL_VISITOR ) {
                this._frameNumberOfLastTraversal = visitor.getFrameStamp().getFrameNumber();
                updateTimeStamp = true;
            }

            switch ( traversalMode ) {

            case osg.NodeVisitor.TRAVERSE_ALL_CHILDREN:

                for ( var index = 0; index < this.children.length; index++ ) {
                    this.children[ index ].accept( visitor );
                }
                break;

            case ( osg.NodeVisitor.TRAVERSE_ACTIVE_CHILDREN ):
                var requiredRange = 0;

                osg.vec3.set( this._tileOrigin, this._trX, this._trY, this._trZ );
                // Calculate distance from viewpoint
                var matrix = visitor.getCurrentModelViewMatrix();
                osg.mat4.invert( viewModel, matrix );
                if ( this._rangeMode === osg.Lod.DISTANCE_FROM_EYE_POINT ) {
                    osg.vec3.transformMat4( eye, zeroVector, viewModel );
                    var d = osg.vec3.distance( eye, this.getBound().center() );
                    requiredRange = d * visitor.getLODScale();
                } else {
                    // Calculate pixels on screen
                    var projmatrix = visitor.getCurrentProjectionMatrix();

                    if ( visitor.getCurrentCamera() === undefined || visitor.getCurrentCamera().getReferenceFrame() === osg.Transform.RELATIVE_RF )
                        this._focalLength = projmatrix[ 0 ];
                    // focal length is the value stored in projmatrix[0]
                    requiredRange = this.getRequiredRange( this.getBound(), visitor, this._focalLength );


                    // if ( visitor.getCurrentCamera() !== undefined && visitor.getCurrentCamera().getReferenceFrame() === osg.Transform.ABSOLUTE_RF )
                    //     if ( requiredRange < 0 ) requiredRange = 1;
                    if ( requiredRange < 0 ) requiredRange = this._range[ this._range.length - 1 ][ 0 ];
                }

                var needToLoadChild = false;
                var lastChildTraversed = -1;
                //this.children[ 0 ].accept( visitor );

                for ( var j = 0; j < this._range.length; ++j ) {
                    if ( this._range[ j ][ 0 ] <= requiredRange && requiredRange < this._range[ j ][ 1 ] ) {
                        if ( j < this.children.length ) {

                            if ( updateTimeStamp ) {
                                this._perRangeDataList[ j ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                                this._perRangeDataList[ j ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                            }
                            this.children[ j ].accept( visitor );
                            if ( this._perRangeDataList[ j ].dbrequest !== undefined && this._perRangeDataList[ j ].dbrequest._finished === false ) {
                                this.children[ 0 ].accept( visitor );
                            }
                            lastChildTraversed = j;
                        } else {
                            needToLoadChild = true;
                        }
                    }
                }
                if ( needToLoadChild ) {
                    var numChildren = this.children.length;
                    if ( numChildren > 0 && ( ( numChildren - 1 ) !== lastChildTraversed ) ) {

                        if ( updateTimeStamp ) {
                            this._perRangeDataList[ numChildren - 1 ].timeStamp = visitor.getFrameStamp().getSimulationTime();
                            this._perRangeDataList[ numChildren - 1 ].frameNumber = visitor.getFrameStamp().getFrameNumber();
                        }
                        this.children[ numChildren - 1 ].accept( visitor );
                    }
                    // now request the loading of the next unloaded child.
                    if ( numChildren < this._perRangeDataList.length ) {
                        // compute priority from where abouts in the required range the distance falls.
                        var priority = ( this._range[ numChildren ][ 0 ] - requiredRange ) / ( this._range[ numChildren ][ 1 ] - this._range[ numChildren ][ 0 ] );
                        if ( this._rangeMode === osg.Lod.PIXEL_SIZE_ON_SCREEN ) {
                            priority = -priority;
                        }
                        // Here we do the request
                        var group = visitor.nodePath[ visitor.nodePath.length - 1 ];
                        if ( this._perRangeDataList[ numChildren ].loaded === false ) {
                            this._perRangeDataList[ numChildren ].loaded = true;
                            var dbhandler = visitor.getDatabaseRequestHandler();
                            this._perRangeDataList[ numChildren ].dbrequest = dbhandler.requestNodeFile( this._perRangeDataList[ numChildren ].function, this._perRangeDataList[ numChildren ].filename, group, visitor.getFrameStamp().getSimulationTime(), priority, this._options );
                        } else {
                            if ( this._perRangeDataList[ numChildren ].filename.constructor === Array ) {
                                if ( this._perRangeDataList[ numChildren ].dbrequest !== undefined && this._perRangeDataList[ numChildren ].dbrequest._finished === false ) {
                                    this._perRangeDataList[ numChildren ].dbrequest._timeStamp = visitor.getFrameStamp().getSimulationTime();
                                    this._perRangeDataList[ numChildren ].dbrequest._priority = priority;
                                } else {
                                    // The DB request is undefined, so the DBPager was not accepting requests, we need to ask for the child again.
                                    this._perRangeDataList[ numChildren ].loaded = false;
                                }
                            } else {
                                if ( this._perRangeDataList[ numChildren ].dbrequest !== undefined ) {
                                    this._perRangeDataList[ numChildren ].dbrequest._timeStamp = visitor.getFrameStamp().getSimulationTime();
                                    this._perRangeDataList[ numChildren ].dbrequest._priority = priority;
                                } else {
                                    // The DB request is undefined, so the DBPager was not accepting requests, we need to ask for the child again.
                                    this._perRangeDataList[ numChildren ].loaded = false;
                                }
                            }
                            // Update timestamp of the request.

                        }
                    }
                }
                break;
            default:
                break;
            }
        };
    } )(),

    updateStyle: function ( property, value ) {
        switch ( property ) {
        case 'drawingRule':
            this.changeDrawingRule( value );
            break;
        case 'geometry':
            this.changeGeometry( value );
            break;
        case 'sizePolicy':
            this.changeSizePolicy( value );
            break;
        case 'pointSize':
            this.changePointSize( value );
            break;
        case 'maxDistance':
            this.changeMaxDistance( value );
            break;
        case 'lightOn':
            this.changeLightOn( value );
            break;
        case 'alpha':
            this.changeAlpha( value );
            break;
        case 'maxIntensity':
            this.changeMaxIntensity( value );
            break;
        case 'minIntensity':
            this.changeMinIntensity( value );
            break;
        case 'maxZ':
            this.changeMaxZ( value );
            break;
        case 'minZ':
            this.changeMinZ( value );
            break;
        case 'repeatRange':
            this.changeRepeatRange( value );
            break;
        case 'fixedColor':
            this.changeFixedColor( value );
            break;
        case 'classificationVisibility':
            this.ClassificationArray = JSON.parse( value );
            this.drawingRuleAttribute.setClassificationArray( this.ClassificationArray );
            break;
        case 'heatMap':
            this.changeHeatMap( value );
            break;
        case 'elevationPolicy':
            this.changeElevationPolicy( value );
            break;
        case 'refElevation':
            this.changeRefElevation( value );
            break;
        case 'hideAboveBelow':
            this.changeHideAboveBelow( value );
            break;
        case 'hideAboveBelowSize':
            this.changeHideAboveBelowSize( value );
            break;
        case 'tolerance':
            this.changeTolerance( value );
            break;
        case 'incSize':
            this.changeIncSize( value );
            break;
        case 'numIntervals':
            this.changeNumIntervals( value );
            break;
        case 'repeatIntervals':
            this.changeRepeatIntervals( value );
            break;
        case 'planeNormal':
            this.changePlaneNormal( value );
            break;
        case 'planeConstant':
            this.changePlaneConstant( value );
            break;
        }
    },

    changeDrawingRule: function ( value ) {
        // Seems 'OldDrawingRule' is not being used, we set it to have possible access
        this.OldDrawingRule = this.DrawingRule;
        this.DrawingRule = value;
        this.drawingRuleAttribute.setDrawingRule( this.DrawingRule );
    },

    changeGeometry: function ( value ) {
        this.Geometry = value;
        this.geometryTypeAttribute.setGeometryType( this.Geometry );
    },

    changeSizePolicy: function ( value ) {
        this.SizePolicy = value;
        this.pointSizeAttribute.setAutomaticSizeEnabled( this.SizePolicy === 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_AUTOMATIC' );
    },

    changePointSize: function ( value ) {
        this.PointSize = value;
        this.sliderSizeFactor = [ value ];
        this.SizeFactor = Utils.getSizeFactor( this.sliderSizeFactor, window.devicePixelRatio );
        this.pointSizeAttribute.setSizeFactor( this.SizeFactor );
        this.pointSizeAttribute.setPointSize( this.PointSize );
    },

    changeMaxDistance: function ( value ) {
        var v = [ value ] - 3.0;
        v = Math.pow( 10, v );
        this.MaxDistance = value;
        this.pointSizeAttribute.setMaxDistance( v );
    },

    changeLightOn: function ( value ) {
        this.LightOn = value;
        this.lightingAttribute.setEnabled( this.LightOn );
    },

    changeAlpha: function ( value ) {
        this.Alpha = value;
        this.alphaUniform.setFloat( value );
    },

    changeMaxIntensity: function ( value ) {
        this.MaxIntensity = value;
        this.drawingRuleAttribute.setMaxIntensity( this.MaxIntensity );
    },

    changeMinIntensity: function ( value ) {
        this.MinIntensity = value;
        this.drawingRuleAttribute.setMinIntensity( this.MinIntensity );
    },

    changeMaxZ: function ( value ) {
        this.MaxZ = value;
        this.drawingRuleAttribute.setMaxZ( this.MaxZ );
    },

    changeMinZ: function ( value ) {
        this.MinZ = value;
        this.drawingRuleAttribute.setMinZ( this.MinZ );
    },

    changeRepeatRange: function ( value ) {
        this.RepeatRange = value;
        this.drawingRuleAttribute.setRepeatRange( this.RepeatRange );
    },

    changeFixedColor: function ( color ) {
        let rgbcolor = Utils.fullhexToRgb( color, 1.0, true );
        this.drawingRuleAttribute.setFixedColor( osg.vec4.fromValues32( rgbcolor[ 0 ], rgbcolor[ 1 ], rgbcolor[ 2 ], rgbcolor[ 3 ] ) );
    },

    changeActiveClassification: function ( index, value ) {
        this.ClassificationArray[ index ] = value ? 1 : 0;
        this.drawingRuleAttribute.setClassificationArray( this.ClassificationArray );
    },

    changeDrawingRuleClassification: function ( index, value ) {
        this.DrawingRuleArray[ index ] = value;
        this.drawingRuleAttribute.setDrawingRuleArray( this.DrawingRuleArray );
        this.drawingRuleAttribute.setDrawingRule( 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CATEGORIZED' );
    },

    changeColorClassification: function ( index, value ) {
        let rgbcolor = Utils.fullhexToRgb( value, 1.0, true );

        var auxClassificationArray = this.drawingRuleAttribute.getClassificationColorArray();
        var i = index * 4;
        auxClassificationArray[ i ] = rgbcolor[ 0 ];
        auxClassificationArray[ i + 1 ] = rgbcolor[ 1 ];
        auxClassificationArray[ i + 2 ] = rgbcolor[ 2 ];
        auxClassificationArray[ i + 3 ] = rgbcolor[ 3 ];
        this.drawingRuleAttribute.setClassificationColorArray( auxClassificationArray );
    },

    changeHeatMap: function ( value ) {
        if ( this.drawingRuleAttribute.getNumHeatMaps() > 0 )
            this.drawingRuleAttribute.setHeatMap( value );
    },

    changeElevationPolicy: function ( value ) {
        this.ElevationPolicy = value;
        this.drawingRuleAttribute.setElevationPolicy( this.ElevationPolicy );
    },

    changeRefElevation: function ( value ) {
        this.RefElevation = value;
        this.drawingRuleAttribute.setRefElevation( this.RefElevation );

    },

    changeHideAboveBelow: function ( value ) {
        this.HideAboveBelow = value;
        this.drawingRuleAttribute.setHideAboveBelow( this.HideAboveBelow );

    },

    changeHideAboveBelowSize: function ( value ) {
        this.HideAboveBelowSize = value;
        this.drawingRuleAttribute.setHideAboveBelowSize( this.HideAboveBelowSize );

    },

    changeTolerance: function ( value ) {
        this.Tolerance = value;
        this.drawingRuleAttribute.setTolerance( this.Tolerance );
    },

    changeIncSize: function ( value ) {
        this.IncSize = value;
        this.drawingRuleAttribute.setIncSize( this.IncSize );
    },

    changeNumIntervals: function ( value ) {
        this.NumIntervals = value;
    },

    changeRepeatIntervals: function ( value ) {
        this.RepeatIntervals = value;
        this.drawingRuleAttribute.setRepeatIntervals( this.RepeatIntervals );
    },

    changePlaneNormal: function ( value ) {
        this.planeNormal = JSON.parse( value );
        this.drawingRuleAttribute.setPlaneNormal( this.planeNormal );
    },

    changePlaneConstant: function ( value ) {
        this.planeConstant = value;
        this.drawingRuleAttribute.setPlaneConstant( this.planeConstant );
    },

    removeChildren: function () {
        CollagePLOD.prototype.removeChildren.call( this );
        this._perRangeDataList.forEach( function ( perRange ) {
            if ( perRange.dbrequest && perRange.dbrequest._requests ) {
                while ( perRange.dbrequest._requests.length ) {
                    var request = perRange.dbrequest._requests.pop();
                    request.abort();
                }
            }
        } );
    },

    cleanNode: function () {
        this.releaseGLObjects();
        this.stateset = undefined;
        this.bufferAttribute = null;
    }


} );
module.exports = PointCloudPLOD;


/***/ }),

/***/ "./sources/pcvizNode/PointCloudScene.js":
/*!**********************************************!*\
  !*** ./sources/pcvizNode/PointCloudScene.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var LayerScene = __webpack_require__( /*! pcvizNode/LayerScene */ "./sources/pcvizNode/LayerScene.js" );

/**
 * Specifies a scene with point clouds
 * @class
 * @memberof pcvizNode
 * @extends pcvizNode.LayerScene
 * @property {Array} _pointCloudNodes Stores the point clouds objects
 * @property {osg.Node} _pointCloudGroup The node which is going to contain the point clouds nodes
 * @property {bool} _dirtyData A flag to indicate if the _pointCloudNodes array is modified
 * @property {Array} _center The center of the first point cloud added
 * @property {float} _minZ Minimum z (component) value in the scene
 * @property {float} _maxZ Maximum z (component) value in the scene
 * @property {int} _minIntensity Minimum intensity value in the scene
 * @property {int} _maxIntensity Maximum intensity value in the scene
 */
var PointCloudScene = function () {
    LayerScene.call( this );
    this._pointCloudNodes = [];
    this._pointCloudGroup = new osg.Node();

    this._minZ = Number.MAX_VALUE;
    this._maxZ = -Number.MAX_VALUE;
    this._minIntensity = Number.MAX_VALUE;
    this._maxIntensity = -Number.MAX_VALUE;

};

PointCloudScene.prototype = osg.objectInherit( LayerScene.prototype, {

    /**
     * Function to add a PointCloudNode in the scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @param {PointCloudPLOD} pointCloudNode The point cloud node to be added
     */
    addPointCloudNode: function ( pointCloudNode, modelMat ) {
        //  this._pointCloudNodes.push( pointCloudNode );
        var transfMinZ = osg.vec3.create64();
        var transfMaxZ = osg.vec3.create64();

        var ptMin = [ pointCloudNode.Layer.getMinX(), pointCloudNode.Layer.getMinY(), pointCloudNode.Layer.getMinZ() ];
        var ptMax = [ pointCloudNode.Layer.getMaxX(), pointCloudNode.Layer.getMaxY(), pointCloudNode.Layer.getMaxZ() ];
        osg.vec3.transformMat4( transfMinZ, ptMin, modelMat );
        osg.vec3.transformMat4( transfMaxZ, ptMax, modelMat );

        this._minZ = Math.min( this._minZ, transfMinZ[ 2 ] );
        this._maxZ = Math.max( this._maxZ, transfMaxZ[ 2 ] );
        this._minIntensity = Math.min( this._minIntensity, pointCloudNode.Layer.getMinIntensity() );
        this._maxIntensity = Math.max( this._maxIntensity, pointCloudNode.Layer.getMaxIntensity() );
        //this._dirtyData = true;
    },

    /**
     * Function to delete a point cloud node of the scene by name
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @param  {string} pointCloudNodeName Name of the point cloud to be deleted
     */
    deletePointCloudNode: function ( pointCloudNodeName ) {
        for ( var i = 0; i < this._pointCloudNodes.length; i++ ) {
            if ( this._pointCloudNodes[ i ].Name === pointCloudNodeName ) {
                this._pointCloudNodes.splice( i, 1 );
                break;
            }
        }
        this._dirtyData = true;
        this.dirtyBound();
    },

    /**
     * Function to delete a point cloud node of the scene by its id
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @param  {string} id Id of the point cloud to be deleted
     */
    deletePointCloudNodeById: function ( id ) {
        for ( var i = 0; i < this._pointCloudNodes.length; i++ ) {
            if ( this._pointCloudNodes[ i ].Id === id ) {
                this._pointCloudNodes.splice( i, 1 );
                break;
            }
        }
        if ( this._pointCloudNodes.length === 0 )
            this._center = undefined;
        this._dirtyData = true;
        this.dirtyBound();
    },

    /**
     * Return the array of point cloud nodes
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {Array} The array which stores the point clouds
     */
    getPointCloudNodes: function () {
        return this._pointCloudNodes;
    },

    getCenter: function () {
        if ( this._center !== undefined )
            return this._center;
        else if ( this._pointCloudNodes.length > 0 ) {
            this._center = new osg.vec3.create64();
            osg.vec3.copy( this._center, this._pointCloudNodes[ 0 ].PointCloudCenter );
            return this._center;
        }
    },

    /**
     * Return the minimum z value in the scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {float} the minimum z value
     */
    getMinZ: function () {
        return this._minZ;
    },

    /**
     * Return the maximum z value in the scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {float} the maximum z value
     */
    getMaxZ: function () {
        return this._maxZ;
    },

    /**
     * Return the minimum intensity value in the scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {int} the minimum intensity value
     */
    getMinIntensity: function () {
        return this._minIntensity;
    },

    /**
     * Return the maximum intensity value in the scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {int} the maximum intensity value
     */
    getMaxIntensity: function () {
        return this._maxIntensity;
    },

    traverse: function ( visitor ) {

        if ( this._pointCloudNodes.length < 1 ) {
            if ( this._dirtyData ) {
                this._dirtyData = false;
            }
            return;
        }
        if ( this._dirtyData ) {

            this._pointCloudGroup.removeChildren();
            for ( var i = 0; i < this._pointCloudNodes.length; i++ ) {
                var transform = new osg.MatrixTransform();
                var center = [ this._pointCloudNodes[ i ].PointCloudCenter[ 0 ] - this._center[ 0 ], this._pointCloudNodes[ i ].PointCloudCenter[ 1 ] - this._center[ 1 ], this._pointCloudNodes[ i ].PointCloudCenter[ 2 ] - this._center[ 2 ] ];
                transform.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), center ) );
                this._pointCloudGroup.addChild( transform );
                transform.addChild( this._pointCloudNodes[ i ] );
            }
            this._dirtyData = false;
            this.dirtyBound();
        }

        this._pointCloudGroup.accept( visitor );
    },

    computeBoundingBox: ( function () {
        var localBB = new osg.BoundingBox();
        var localMax = new osg.vec3.create32();
        var localMin = new osg.vec3.create32();

        return function ( bBox ) {
            if ( this._pointCloudNodes.length < 1 )
                return bBox;
            bBox.init();
            osg.vec3.init( localMax );
            osg.vec3.init( localMin );
            localBB.init();
            for ( var i = 0; i < this._pointCloudNodes.length; i++ ) {
                this._pointCloudNodes[ i ].computeBoundingBox( localBB );
                var minExtent = localBB.getMin();
                var maxExtent = localBB.getMax();

                osg.vec3.sub( localMax, maxExtent, this._center );
                osg.vec3.sub( localMin, minExtent, this._center );

                osg.vec3.add( localMax, localMax, this._pointCloudNodes[ i ].PointCloudCenter );
                osg.vec3.add( localMin, localMin, this._pointCloudNodes[ i ].PointCloudCenter );

                localBB.setMin( localMin );
                localBB.setMax( localMax );
                bBox.expandByBoundingBox( localBB );
            }
            return bBox;
        };
    } )(),

    computeBoundingSphere: ( function () {
        var localBS = new osg.BoundingSphere();
        var newCenter = osg.vec3.create32();
        return function ( bSphere ) {
            if ( this._pointCloudNodes.length < 1 )
                return bSphere;
            bSphere.init();
            for ( var i = 0; i < this._pointCloudNodes.length; i++ ) {
                this._pointCloudNodes[ i ].computeBoundingSphere( localBS );
                osg.vec3.sub( newCenter, this._pointCloudNodes[ i ].PointCloudCenter, this._center );
                localBS.set( newCenter, localBS.radius() );
                bSphere.expandByBoundingSphere( localBS );
            }
            return bSphere;
        };
    } )(),

    /**
     * Returns the extent of the pointcloud scene
     * @method
     * @memberof pcvizNode.PointCloudScene
     * @return {Array}   Array of numbers representing the extent `[ minX, minY, maxX, maxY ]`
     */
    getExtent: ( function () {
        var min = osg.vec3.create32();
        var max = osg.vec3.create32();
        return function () {
            osg.vec3.add( min, this._center, this._boundingBox._min );
            osg.vec3.add( max, this._center, this._boundingBox._max );
            return osg.vec4.fromValues64( min[ 0 ], min[ 1 ], max[ 0 ], max[ 1 ] );
        };
    } )()

} );
module.exports = PointCloudScene;


/***/ }),

/***/ "./sources/pcvizNode/PointEditionAttribute.js":
/*!****************************************************!*\
  !*** ./sources/pcvizNode/PointEditionAttribute.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;

var PointEditionAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    this._selectColor = undefined;
};

PointEditionAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'PointEdition',

    getOrCreateUniforms: function () {

        var uniforms = {
            selectColor: osg.Uniform.createFloat4( this._selectColor, 'selectColor' )
        };

        return uniforms;
    },

    setSelectColor: function ( color ) {
        this._selectColor = color;
    },

    cloneType: function () {
        return new PointEditionAttribute();
    },

    setEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isEnabled: function () {
        return this._attributeEnable;
    },

    // getHash is used to know if an StateAttribute changed
    // if yes it will trigger a shader rebuild. You can for example
    // trigger a change if we enable or not the attribute. It's really
    // up to how you want to handle your shaders
    // if you dont want to trigger rebuild of shader then instead you an use a
    // uniform and keep always the same hash
    getHash: function () {
        return this.getType() + this._attributeEnable.toString() + this._selectColor.toString();
    },

    apply: function () {
        if ( !this._attributeEnable ) return;
        var uniforms = this.getOrCreateUniforms();
        uniforms.selectColor.setFloat4( this._selectColor );
        return uniforms;
    }

} ), 'osg', 'PointEditionAttribute' );

module.exports = PointEditionAttribute;

var PointEditionVertexNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
};

PointEditionVertexNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'PointEditionVertex',
    validInputs: [],
    validOutputs: [ 'VertexColor' ],

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        return '#pragma include "selected.glsl"';
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        return osgShader.utils.callFunction( 'computePointSelection', undefined, [ this._outputs.VertexColor ] );
    }

} );

factory.registerNode( 'PointEditionVertex', PointEditionVertexNode );


/***/ }),

/***/ "./sources/pcvizNode/PointSizeAttribute.js":
/*!*************************************************!*\
  !*** ./sources/pcvizNode/PointSizeAttribute.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgShader = OSG.osgShader;
var shaderNode = osgShader.node;
var factory = osgShader.nodeFactory;

var PointSizeAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = true;
    this._pointSize = 1.0;
    this._maxDistance = 1.0;
    this._sizeFactor = 1.0;
    this._devicePixelRatio = 1.0; // Maybe better having a constant? it should not change...
};

PointSizeAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'PointCloudPointSize',

    cloneType: function () {
        return new PointSizeAttribute();
    },

    // uniforms list are per ClassType
    getOrCreateUniforms: function () {
        var obj = PointSizeAttribute;
        if ( obj.uniforms ) return obj.uniforms;

        obj.uniforms = {
            enable: osg.Uniform.createInt1( 0, 'automaticPointSize' ),
            pointSize: osg.Uniform.createFloat1( this._pointSize, 'pointSize' ),
            maxDistance: osg.Uniform.createFloat1( this._maxDistance, 'maxDistance' ),
            sizeFactor: osg.Uniform.createFloat1( this._sizeFactor, 'sizeFactor' ),
            devicePixelRatio: osg.Uniform.createFloat1( this._devicePixelRatio, 'devicePixelRatio' )
        };

        return obj.uniforms;
    },

    setMaxDistance: function ( maxDistance ) {
        this._maxDistance = maxDistance;
    },

    getMaxDistance: function () {
        return this._maxDistance;
    },

    setSizeFactor: function ( sizeFactor ) {
        this._sizeFactor = sizeFactor;
    },

    getSizeFactor: function () {
        return this._sizeFactor;
    },

    setDevicePixelRatio: function ( devicePixelRatio ) {
        this._devicePixelRatio = devicePixelRatio;
    },

    getDevicePixelRatio: function () {
        return this._devicePixelRatio;
    },

    setPointSize: function ( pointSize ) {
        this._pointSize = pointSize;
    },

    getPointSize: function () {
        return this._pointSize;
    },

    setAutomaticSizeEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isAutomaticSizeEnabled: function () {
        return this._attributeEnable;
    },

    apply: function () {
        var uniforms = this.getOrCreateUniforms();
        var value = this._attributeEnable ? 1 : 0;
        uniforms.enable.setInt( value );
        uniforms.pointSize.setFloat( this._pointSize );
        uniforms.maxDistance.setFloat( this._maxDistance );
        uniforms.sizeFactor.setFloat( this._sizeFactor );
        uniforms.devicePixelRatio.setFloat( this._devicePixelRatio );
    }

} ), 'osg', 'PointSizeAttribute' );

module.exports = PointSizeAttribute;

// this node will call a function negatif in the shader
var PointSizeNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
};

PointSizeNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'PointCloudPointSize',
    validInputs: [ 'fragEyeVec' ],
    validOutputs: [ 'glPointsize' ],

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        return '#pragma include "utils.glsl"';
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        return osgShader.utils.callFunction( 'computePointSize', undefined, [
            this._inputs.fragEyeVec,
            this._outputs.glPointsize
        ] );
    }
} );

factory.registerNode( 'PointCloudPointSize', PointSizeNode );


/***/ }),

/***/ "./sources/pcvizNode/SceneNode.js":
/*!****************************************!*\
  !*** ./sources/pcvizNode/SceneNode.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var PointCloudScene = __webpack_require__( /*! pcvizNode/PointCloudScene */ "./sources/pcvizNode/PointCloudScene.js" );

/**
 * This node contains the scene and is attatched to the SceneGraph as a
 * child of the EDLNode or the Switch node to be rendered with or without EDL.
 * This way we have the EDL on top of the scene graph.
 * @class
 * @extends osg.Node
 * @memberof pcvizNode
 * @property {PointCloudScene} _pointCloudScene A node to attatch all pointclouds.
 * @porperty {osg.Node} _toolsNode A node to attached the tool nodes.
 */
var SceneNode = function () {
    osg.Node.call( this );
    // contains the PointClouds according to the PointCloudLayers
    this._pointCloudScene = new PointCloudScene();
    // tools Node is the one containing the drawing things of the tools
    this._toolsNode = new osg.Node();
    this._toolsNode.setName( 'tools' );
    this._mtNode = new osg.MatrixTransform();

    this.addChild( this._toolsNode );
    this.addChild( this._mtNode );
};

SceneNode.prototype = osg.objectInherit( osg.Node.prototype, {

    /**
     * Gets the PointCloudScene
     * @method
     * @memberof pcvizNode.SceneNode
     * @return {PointCloudScene} The pointcloud scene.
     */
    getPointCloudScene: function () {
        return this._pointCloudScene;
    },

    /**
     * Gets the tools node
     * @method
     * @memberof pcvizNode.SceneNode
     * @return {osg.Node} The tools node.
     */
    getToolsNode: function () {
        return this._toolsNode;
    },

    getTransformNode: function () {
        return this._mtNode;
    }

} );

module.exports = SceneNode;


/***/ }),

/***/ "./sources/pcvizNode/SideAttribute.js":
/*!********************************************!*\
  !*** ./sources/pcvizNode/SideAttribute.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osg = OSG.osg;
const osgShader = OSG.osgShader;
const shaderNode = osgShader.node;
const factory = osgShader.nodeFactory;

const SideAttribute = function () {
    osg.StateAttribute.call( this );
    this._attributeEnable = false;
    this._side = 0; // Side values: 0 for None side, 1 for Left side, and 2 for Right side.
    this._sideDivider = 0.0;
};

SideAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'Side',

    getOrCreateUniforms: function () {

        const uniforms = {
            side: osg.Uniform.createInt1( this._side, 'side' ),
            sideDivider: osg.Uniform.createFloat1( this._sideDivider, 'sideDivider' )
        };

        return uniforms;
    },

    setSide: function ( side ) {
        this._side = side;
    },

    getSide: function () {
        return this._side;
    },

    setSideDivider: function ( dividerRange ) {
        this._sideDivider = dividerRange;
    },

    cloneType: function () {
        return new SideAttribute();
    },

    setEnabled: function ( state ) {
        this._attributeEnable = state;
    },

    isEnabled: function () {
        return this._attributeEnable;
    },

    // getHash is used to know if an StateAttribute changed
    // if yes it will trigger a shader rebuild. You can for example
    // trigger a change if we enable or not the attribute. It's really
    // up to how you want to handle your shaders
    // if you dont want to trigger rebuild of shader then instead you an use a
    // uniform and keep always the same hash
    getHash: function () {
        return this.getType() + this._attributeEnable.toString() + this._side.toString() + this._sideDivider.toString();
    },

    apply: function () {
        if ( !this._attributeEnable ) return;
        const uniforms = this.getOrCreateUniforms();
        uniforms.side.setInt1( this._side );
        uniforms.sideDivider.setFloat1( this._sideDivider );
        return uniforms;
    }

} ), 'osg', 'SideAttribute' );

module.exports = SideAttribute;

const SideVertexNode = function () {
    shaderNode.BaseOperator.apply( this, arguments );
};

SideVertexNode.prototype = osg.objectInherit( shaderNode.BaseOperator.prototype, {
    type: 'SideVertex',
    validInputs: [ 'glPosition' ],
    validOutputs: [ 'VertexColor' ],

    // it's a global declaration
    // you can make your include here or your global variable
    globalFunctionDeclaration: function () {
        return '#pragma include "side.glsl"';
    },

    // call the glsl function with input/output of the node
    computeShader: function () {
        return osgShader.utils.callFunction( 'computeSideVisualization', undefined, [ this._inputs.glPosition, this._outputs.VertexColor ] );
    }

} );

factory.registerNode( 'SideVertex', SideVertexNode );


/***/ }),

/***/ "./sources/pcvizNode/Switch.js":
/*!*************************************!*\
  !*** ./sources/pcvizNode/Switch.js ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 * Switch is a node that allows switching between children.
 * Typical uses would be for objects which might need to be rendered differently at different times.
 * This class will be removed from PointCloudViz.js when it is merged into OSGjs.
 * @class
 * @extends osg.Node
 * @memberof pcvizNode
 */
var Switch = function () {
    osg.Node.call( this );

    this._newChildDefaultValue = true;
    this._values = [];
};

Switch.prototype = osg.objectInherit( osg.Node.prototype, {

    traverse: function ( visitor ) {

        if ( visitor.traversalMode === osg.NodeVisitor.TRAVERSE_ACTIVE_CHILDREN ) {
            for ( var index = 0; index < this.children.length; index++ ) {
                if ( this._values[ index ] )
                    this.children[ index ].accept( visitor );
            }
        } else {
            osg.Node.prototype.traverse.call( this, visitor );
        }

    },

    addChild: function ( child, value ) {
        osg.Node.prototype.addChild.call( this, child );
        if ( value === undefined )
            value = this._newChildDefaultValue;
        if ( this.children.length > this._values.length )
            this._values.push( value );
        return child;
    },

    removeChildren: function () {
        this._values = [];
        osg.Node.prototype.removeChildren.call( this );
    },

    setValue: function ( pos, value ) {
        if ( pos < this._values.length )
            this._values[ pos ] = value;
        this.dirtyBound();
    },

    getValue: function ( pos ) {
        if ( pos >= this._values.length ) return false;
        return this._values[ pos ];
    },

    setAllChildrenOff: function () {
        this._newChildDefaultValue = false;
        for ( var index = 0; index < this._values.length; index++ )
            this._values[ index ] = false;
        this.dirtyBound();
        return true;
    },

    setAllChildrenOn: function () {
        this._newChildDefaultValue = true;
        for ( var index = 0; index < this._values.length; index++ )
            this._values[ index ] = true;
        this.dirtyBound();
        return true;
    },

    setSingleChildOn: function ( pos ) {
        for ( var index = 0; index < this._values.length; index++ )
            this._values[ index ] = false;
        this.setValue( pos, true );
        this.dirtyBound();
        return true;
    },

    setSingleChildOff: function ( pos ) {
        for ( var index = 0; index < this._values.length; index++ )
            this._values[ index ] = true;
        this.setValue( pos, false );
        this.dirtyBound();
        return true;
    },

    computeBoundingBox: function ( bbox ) {

        var children = this.children;
        var values = this._values;
        var l = children.length;

        if ( l === 0 ) return bbox;

        var cc, i;
        bbox.init();
        for ( i = 0; i < l; i++ ) {
            cc = children[ i ];
            if ( cc.referenceFrame !== osg.Transform.ABSOLUTE_RF && values[ i ] ) {
                bbox.expandByBoundingSphere( cc.getBound() );
            }
        }
        return bbox;
    },

    computeBoundingSphere: function ( bSphere ) {

        var children = this.children;
        var values = this._values;
        var l = children.length;

        bSphere.init();
        if ( l === 0 ) return bSphere;

        var cc, i;
        var bb = this._tmpBox;
        bb.init();
        for ( i = 0; i < l; i++ ) {
            cc = children[ i ];
            if ( cc.referenceFrame !== osg.Transform.ABSOLUTE_RF && values[ i ] ) {
                bb.expandByBoundingSphere( cc.getBound() );
            }
        }
        if ( !bb.valid() ) return bSphere;

        bSphere.set( bb.center( bSphere.center() ), 0.0 );
        for ( i = 0; i < l; i++ ) {
            cc = children[ i ];
            if ( cc.referenceFrame !== osg.Transform.ABSOLUTE_RF && values[ i ] ) {
                bSphere.expandRadiusBySphere( cc.getBound() );
            }
        }
        return bSphere;
    },

} );

module.exports = Switch;


/***/ }),

/***/ "./sources/pcvizNode/TileUniformsAttribute.js":
/*!****************************************************!*\
  !*** ./sources/pcvizNode/TileUniformsAttribute.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var TileUniformsAttribute = function () {
    osg.StateAttribute.call( this );
    this._tileOrigin = osg.vec3.create32();
    this._levelFactor = 1.0;
};

TileUniformsAttribute.prototype = osg.objectLibraryClass( osg.objectInherit( osg.StateAttribute.prototype, {

    attributeType: 'TileUniforms',

    cloneType: function () {
        return new TileUniformsAttribute();
    },

    setTileOrigin: function ( tileOrigin ) {
        this._tileOrigin = tileOrigin;
    },

    getTileOrigin: function () {
        return this._tileOrigin;
    },

    setLevelFactor: function ( factor ) {
        this._levelFactor = factor;
    },

    getLevelFactor: function () {
        return this._levelFactor;
    },

    getOrCreateUniforms: function () {
        var obj = TileUniformsAttribute;
        if ( obj.uniforms ) return obj.uniforms;
        obj.uniforms = {
            tileOrigin: osg.Uniform.createFloat3( this._tileOrigin, 'tileOrigin' ),
            levelFactor: osg.Uniform.createFloat( this._levelFactor, 'levelFactor' )
        };
        return obj.uniforms;
    },

    apply: function () {
        var uniforms = this.getOrCreateUniforms();
        uniforms.tileOrigin.setFloat3( this._tileOrigin );
        uniforms.levelFactor.setFloat( this._levelFactor );
    }


} ), 'osg', 'TileUniformsAttribute' );

module.exports = TileUniformsAttribute;


/***/ }),

/***/ "./sources/pcvizNode/VectorLayerScene.js":
/*!***********************************************!*\
  !*** ./sources/pcvizNode/VectorLayerScene.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var LayerScene = __webpack_require__( /*! pcvizNode/LayerScene */ "./sources/pcvizNode/LayerScene.js" );

/**
 * Specifies a scene with features from vector layers
 * @class
 * @memberof pcvizNode
 * @extends pcvizNode.LayerScene
 * @property {Array} _featuresNodes Stores the nodes that render the features
 * @property {bool} _dirtyData A flag to indicate if the _featuresNodes array is modified
 */
var VectorLayerScene = function () {
    LayerScene.call( this );

    this._featuresNodes = [];

};

VectorLayerScene.prototype = osg.objectInherit( LayerScene.prototype, {

    getVectorLayerNodes: function () {
        return this._featuresNodes;
    },

    /**
     * Add a node that renders a vector layer to the _featuresNodes array.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     * @param {osg.Node} featuresNode the node that renders a vector layer
     */
    addFeaturesNode: function ( featuresNode ) {
        this.deleteFeaturesNode( featuresNode.id ); // FIXME: this is necessary now because of the problem about refreshing the layer twice and the first refresh hasn't been finished
        this._featuresNodes.push( featuresNode );
        this._dirtyData = true;
    },

    /**
     * Delete a node that renders a vector layer from the _featuresNodes array.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     * @param {integer} idLayer the id of the vector layer that we want to remove its node
     */
    deleteFeaturesNode: function ( idLayer ) {
        var found = false;
        // make sure all feature nodes with same ID are removed
        // we assume they are contiguous
        for ( var i = 0; i < this._featuresNodes.length; i++ ) {
            if ( this._featuresNodes[ i ].id === idLayer ) {
                this._featuresNodes.splice( i, 1 );
                this._dirtyData = true;
                found = true;
            } else if ( found )
                break;
        }
    },

    /**
     * Get the node that renders the vector layer with the id passed.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     * @param {integer} idLayer the id of the vector layer that we want to get its node
     * @return {osg.Node} the node that renders the vector layer
     */
    getFeaturesNode: function ( idLayer ) {
        for ( var i = 0; i < this._featuresNodes.length; i++ ) {
            if ( this._featuresNodes[ i ].id === idLayer ) {
                return this._featuresNodes[ i ];
            }
        }
    },

    /**
     * Replaces the node that renders the vector layer with the id passed by the new node passed.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     * @param {integer} idLayer the id of the vector layer that we want to replace its node
     * @param {osg.Node} the new node to render the vector layer
     */
    replaceFeaturesNode: function ( idLayer, featuresNode ) {
        for ( var i = 0; i < this._featuresNodes.length; i++ ) {
            if ( this._featuresNodes[ i ].id === idLayer ) {
                this._featuresNodes[ i ] = featuresNode;
                this._dirtyData = true;
                break;
            }
        }
    },

    /**
     * Get the number of nodes in the _featuresNodes array.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     * @return {integer} the number of elements in the _featuresNodes array
     */
    getNumFeaturesNodes: function () {

        return this._featuresNodes.length;
    },

    /**
     * Overwritten function to add and traverse the nodes according to the currently layers loaded.
     * @method
     * @memberof pcvizNode.VectorLayerScene
     */
    traverse: function ( visitor ) {
        if ( this._featuresNodes.length < 1 ) {
            if ( this._dirtyData ) {
                this._dirtyData = false;
            }
            return;
        }
        if ( this._dirtyData ) {
            this.removeChildren();
            for ( var i = 0; i < this._featuresNodes.length; i++ ) {
                this.addChild( this._featuresNodes[ i ] );
                this.dirtyBound();
            }
            this._dirtyData = false;
        }
        for ( var j = 0; j < this.getNumChildren(); j++ )
            this.getChild( j ).accept( visitor );
    }

} );

module.exports = VectorLayerScene;


/***/ }),

/***/ "./sources/pcvizNode/VertexGizmo.js":
/*!******************************************!*\
  !*** ./sources/pcvizNode/VertexGizmo.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgUtil = OSG.osgUtil;

var NodeGizmo = osgUtil.NodeGizmo;
var MatrixTransform = osg.MatrixTransform;
var CullFace = osg.CullFace;
var vec2 = osg.vec2;
var vec3 = osg.vec3;
var mat4 = osg.mat4;
var GizmoGeometry = osgUtil.GizmoGeometry;

const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var getCanvasCoord = function ( vec, e ) {
    if ( ( Utils.isTouchEnabled() || Utils.isTouchByTouchPoints() ) && !Utils.isEdge() && e.type.includes( 'touch' ) ) {
        let offset = e.target.getBoundingClientRect();
        vec[ 0 ] = e.changedTouches[ 0 ].clientX - offset.left;
        vec[ 1 ] = e.changedTouches[ 0 ].clientY - offset.top;
        return;
    }
    vec[ 0 ] = e.offsetX === undefined ? e.layerX : e.offsetX;
    vec[ 1 ] = e.offsetY === undefined ? e.layerY : e.offsetY;
};


/**
 * Specifies a gizmo to transform the vertices of a geometry.
 * @class
 * @extends osg.osgUtil.NodeGizmo
 * @memberof pcvizNode
 * @property {osg.osg.BufferArray} _vertexArrayBuffer the BufferArray that contains the vertices to be modified
 * @property {array} _indices the indices of the vertices to be modified
 * @property {osg.osg.Geometry} _geometry the geometry to which is attached the gizmo
 */
var VertexGizmo = function ( viewer ) {

    NodeGizmo.call( this, viewer );

    this._vertexArrayBuffer = null;
    this._indices = [];
    this._geometry = null;
    //itemsize? // now we work with itemsize = 3

    this._auxiliarGizmos = [];

};


VertexGizmo.prototype = osg.objectInherit( NodeGizmo.prototype, {

    // override
    init: function () {
        //this.getOrCreateStateSet().setAttributeAndModes( new Depth( Depth.DISABLE ) );
        this.getOrCreateStateSet().setAttributeAndModes( new CullFace( CullFace.DISABLE ) );

        var UpdateCallback = function () {};
        UpdateCallback.prototype = {
            update: this.updateGizmo.bind( this )
        };
        this.addUpdateCallback( new UpdateCallback() );
        this.addChild( this.initNodeTranslate() );
        this.addChild( this.initNodeTranslatePlane() );
        if ( this._debugNode ) {
            this._debugNode.addChild( GizmoGeometry.createDebugLineGeometry() );
            this.addChild( this._debugNode );
            this._debugNode.setNodeMask( 0x0 );
        }

        var canvas = this._canvas;
        canvas.addEventListener( 'mousemove', this.onMouseMove.bind( this ) );
        canvas.addEventListener( 'mousedown', this.onMouseDown.bind( this ) );
        canvas.addEventListener( 'mouseup', this.onMouseUp.bind( this ) );
        canvas.addEventListener( 'mouseout', this.onMouseUp.bind( this ) );
    },

    getIndices: function () {
        return this._indices;
    },

    hasAuxiliarGizmos: function () {
        return this._auxiliarGizmos.length > 0;
    },

    getAuxiliarGizmos: function () {
        return this._auxiliarGizmos;
    },

    createInstance: function ( viewer ) {
        return new VertexGizmo( viewer );
    },

    // override
    attachToGeometry: function ( geometry, indices, oneGizmoPerVertex ) {
        oneGizmoPerVertex = oneGizmoPerVertex !== undefined ? oneGizmoPerVertex : false;

        // if each vertex is going to be edited independently
        if ( oneGizmoPerVertex ) {
            // for each vertex (excepting the first)
            for ( var i = 1; i < indices.length; i++ ) {
                // create a VertexGizmo 
                var auxiliarGizmo = this.createInstance( this._viewer );
                // add the new VertexGizmo to the scene (as a sibling of this VertexGizmo)
                this.getParents()[ 0 ].addChild( auxiliarGizmo );
                // attach the geometry sending the respective index
                auxiliarGizmo.attachToGeometry( geometry, indices.slice( i, i + 1 ), false );

                this._auxiliarGizmos.push( auxiliarGizmo );
            }

            // for the first vertex
            if ( !geometry ) {
                this._attachedNode = null;
                this.setNodeMask( 0x0 );
                return;
            }

            this._indices = indices.slice( 0, 1 );

        }

        // if this gizmo is going to edit all the vertices, 
        // do the same than for the first vertex in the previous case, but we save all indices
        else {
            if ( !geometry ) {
                this._attachedNode = null;
                this.setNodeMask( 0x0 );
                return;
            }

            this._indices = indices.slice( 0 );
        }

        this._vertexArrayBuffer = geometry.getVertexAttributeList().Vertex;
        this._geometry = geometry;

        this._geometry.getOrCreateStateSet().setAttributeAndModes( new CullFace( CullFace.DISABLE ) ); //

        var posChild;
        // insert MatrixTransform node before geometry node
        var pr = geometry.getParents();
        if ( pr[ 0 ].editMask === undefined ) {
            var imt = new MatrixTransform();
            while ( pr.length > 0 ) {
                pr[ 0 ].addChild( imt );
                posChild = pr[ 0 ].getChildren().indexOf( geometry );
                pr[ 0 ].removeChild( geometry );
            }
            imt.addChild( geometry );
            imt.editMask = NodeGizmo.PICK_GIZMO;
            geometry = imt;
        } else {
            geometry = pr[ 0 ];
        }

        this._attachedNode = geometry;
        this.updateGizmoMask();

        return posChild;
    },

    // override
    updateGizmoMask: function () {
        if ( !this._attachedNode ) {
            this.setNodeMask( 0x0 );
            return;
        }

        var mask = this._attachedNode.editMask;
        this.setNodeMask( mask & NodeGizmo.PICK_GIZMO ? NodeGizmo.NO_PICK : 0x0 );
        this._translateNode.setNodeMask( mask & NodeGizmo.PICK_ARROW ? NodeGizmo.PICK_ARROW : 0x0 );
        this._planeNode.setNodeMask( mask & NodeGizmo.PICK_PLANE ? NodeGizmo.PICK_PLANE : 0x0 );

        var transChildren = this._translateNode.getChildren();
        transChildren[ 0 ].setNodeMask( mask & NodeGizmo.PICK_ARROW_X ? NodeGizmo.PICK_ARROW_X : 0x0 );
        transChildren[ 1 ].setNodeMask( mask & NodeGizmo.PICK_ARROW_Y ? NodeGizmo.PICK_ARROW_Y : 0x0 );
        transChildren[ 2 ].setNodeMask( mask & NodeGizmo.PICK_ARROW_Z ? NodeGizmo.PICK_ARROW_Z : 0x0 );

        var planeChildren = this._planeNode.getChildren();
        planeChildren[ 0 ].setNodeMask( mask & NodeGizmo.PICK_PLANE_X ? NodeGizmo.PICK_PLANE_X : 0x0 );
        planeChildren[ 1 ].setNodeMask( mask & NodeGizmo.PICK_PLANE_Y ? NodeGizmo.PICK_PLANE_Y : 0x0 );
        planeChildren[ 2 ].setNodeMask( mask & NodeGizmo.PICK_PLANE_Z ? NodeGizmo.PICK_PLANE_Z : 0x0 );
    },


    // override
    updateGizmo: ( function () {
        var eye = vec3.create32();
        var trVec = vec3.create32();
        var trVertex = vec3.create32();

        var trWorld = mat4.create();
        var scGiz = mat4.create();

        return function () {
            if ( !this._attachedNode )
                return;
            var ttype = this.getTransformType( this._attachedNode );
            this.setReferenceFrame( ttype );
            this.setCullingActive( ttype === osg.Transform.RELATIVE_RF );
            var worldMat = this._attachedNode.getWorldMatrices()[ 0 ];

            // world trans
            mat4.getTranslation( trVec, worldMat );
            // to position gizmo in the vertex
            var vertices = this._vertexArrayBuffer.getElements();
            vec3.set( trVertex, vertices[ this._indices[ 0 ] * 3 ], vertices[ this._indices[ 0 ] * 3 + 1 ], vertices[ this._indices[ 0 ] * 3 + 2 ] );
            vec3.add( trVec, trVertex, trVec );
            mat4.fromTranslation( trWorld, [ trVec[ 0 ], trVec[ 1 ], trVec[ 2 ] ] );

            // normalize gizmo size
            var scaleFactor = 2.0;
            if ( ttype === osg.Transform.ABSOLUTE_RF ) {
                eye[ 0 ] = eye[ 1 ] = eye[ 2 ] = 0.0;
            } else {
                // normalize gizmo size relative to screen size
                var proj = this._viewer.getCamera().getProjectionMatrix();
                var scaleFov = this._canvas.clientWidth * 0.023 * proj[ 0 ];
                this._manipulator.getEyePosition( eye );
                // while we are editing we don't normalize the gizmo
                // it gives a better depth feedback, especially if we are editing a geometry that has
                // a constant screen size (for example an icon)
                this._lastDistToEye = this._isEditing ? this._lastDistToEye : vec3.distance( eye, trVec );
                scaleFactor *= this._lastDistToEye / scaleFov;
            }
            mat4.fromScaling( scGiz, [ scaleFactor, scaleFactor, scaleFactor ] );

            // gizmo node
            mat4.multiply( this.getMatrix(), trWorld, scGiz );

            this._translateNode.dirtyBound();
            this._planeNode.dirtyBound();

        };
    } )(),

    // override
    onMouseDown: function ( e ) {
        getCanvasCoord( this._downCanvasCoord, e );
        if ( Utils.isTouchEnabled() || Utils.isTouchByTouchPoints() )
            this.onMouseMove( e );
        if ( !this._hoverNode || !this._attachedNode )
            return;
        e.preventDefault();
        this._viewer.setEnableManipulator( false );

        this.saveEditMatrices();
        var nm = this._hoverNode.getParents()[ 0 ].getNodeMask();
        this._isEditing = true;

        if ( nm & NodeGizmo.PICK_ARROW ) {
            this._planeNode.setNodeMask( 0x0 );
            this.startTranslateEdit( e );
        } else if ( nm & NodeGizmo.PICK_PLANE ) {
            this._translateNode.setNodeMask( 0x0 );
            this.startPlaneEdit( e );
        }
    },

    // override
    saveEditMatrices: function () {
        // save the world translation
        var wm = this._attachedNode.getWorldMatrices()[ 0 ];
        mat4.fromTranslation( this._editWorldTrans, vec3.fromValues( wm[ 12 ], wm[ 13 ], wm[ 14 ] ) );
        // save the inv of world rotation + scale
        mat4.copy( this._editWorldScaleRot, wm );
        // removes translation
        this._editWorldScaleRot[ 12 ] = this._editWorldScaleRot[ 13 ] = this._editWorldScaleRot[ 14 ] = 0.0;
        mat4.invert( this._editInvWorldScaleRot, this._editWorldScaleRot );
    },

    // override
    onMouseUp: function ( /*e*/) {
        this._viewer.setEnableManipulator( true );

        if ( this._debugNode )
            this._debugNode.setNodeMask( 0x0 );

        this._isEditing = false;
        if ( !this._hoverNode )
            return;
        this.updateGizmoMask();

        // to deselect the _hoverNode in touch devices
        if ( Utils.isTouchEnabled() || Utils.isTouchByTouchPoints() )
            this.onMouseMove();
    },

    // override
    onMouseMove: function ( e ) {
        if ( !this._attachedNode )
            return;
        var hit;
        if ( this._isEditing === false ) {
            if ( e ) {
                hit = this.pickGizmo( e, NodeGizmo.PICK_GIZMO );
            }
            this.onNodeHovered( hit );
            return;
        }

        if ( !this._hoverNode )
            return;

        var par = this._hoverNode.getParents()[ 0 ];

        if ( par === this._translateNode )
            this.updateTranslateEdit( e );
        else if ( par === this._planeNode )
            this.updatePlaneEdit( e );
    },

    // override
    updateTranslateEdit: ( function () {
        var vec = vec2.create32();
        var tra = vec3.create32();

        return function ( e ) {

            var origin = this._editLineOrigin;
            var dir = this._editLineDirection;

            getCanvasCoord( vec, e );
            vec2.sub( vec, vec, origin );
            vec2.sub( vec, vec, this._editOffset );

            var dist = vec2.dot( vec, dir );
            vec[ 0 ] = origin[ 0 ] + dir[ 0 ] * dist;
            vec[ 1 ] = origin[ 1 ] + dir[ 1 ] * dist;

            if ( this._debugNode )
                this.drawLineCanvasDebug( origin[ 0 ], origin[ 1 ], vec[ 0 ], vec[ 1 ] );

            // canvas to webgl coord
            var viewer = this._viewer;
            var canvas = this._canvas;
            var coordx = vec[ 0 ] * ( viewer.getCanvasWidth() / canvas.clientWidth );
            var coordy = ( canvas.clientHeight - vec[ 1 ] ) * ( viewer.getCanvasHeight() / canvas.clientHeight );

            // project 2D point on the 3d line
            this._lsi.reset();
            this._lsi.setTestPlane( false );
            this._lsi.set( vec3.set( this._origIntersect, coordx, coordy, 0.0 ), vec3.set( this._dstIntersect, coordx, coordy, 1.0 ) );
            this._iv.reset();
            this._iv.setTraversalMask( this._hoverNode.getNodeMask() );

            this.setOnlyGizmoPicking();
            this._viewer.getCamera().accept( this._iv );
            this.setOnlyScenePicking();

            vec3.transformMat4( tra, this._lsi.getTranslateDistance(), this._editInvWorldScaleRot );


            var vertices = this._vertexArrayBuffer.getElements();

            var translateMatrix = mat4.create();
            var identityMatrix = mat4.create();

            // create a Matrix with the translation to be applied to the vertices
            mat4.translate( translateMatrix, identityMatrix, tra );

            // for each vertex
            for ( var i = 0; i < this._indices.length; i++ ) {
                // get the vertex position
                var vector = vec3.fromValues32( vertices[ this._indices[ i ] * 3 ], vertices[ this._indices[ i ] * 3 + 1 ], vertices[ this._indices[ i ] * 3 + 2 ] );

                var result = vec3.create32();

                // set the translated position in a new vector
                vec3.transformMat4( result, vector, translateMatrix );

                // set the new position to the vertex
                vertices[ this._indices[ i ] * 3 ] = result[ 0 ];
                vertices[ this._indices[ i ] * 3 + 1 ] = result[ 1 ];
                vertices[ this._indices[ i ] * 3 + 2 ] = result[ 2 ];
            }

            // call dirty method first for the geometry and secondly for the BufferArray
            this._geometry.dirty();
            this._vertexArrayBuffer.dirty();

            this._attachedNode.dirtyBound();
        };
    } )(),

    // override
    updatePlaneEdit: function ( e ) {
        var vec = vec3.create32();
        getCanvasCoord( vec, e );
        vec2.sub( vec, vec, this._editOffset );

        // canvas to webgl coord
        var viewer = this._viewer;
        var canvas = this._canvas;
        var coordx = vec[ 0 ] * ( viewer.getCanvasWidth() / canvas.clientWidth );
        var coordy = ( canvas.clientHeight - vec[ 1 ] ) * ( viewer.getCanvasHeight() / canvas.clientHeight );

        // project 2D point on the 3d plane
        this._lsi.reset();
        this._lsi.setTestPlane( true );
        this._lsi.set( vec3.set( this._origIntersect, coordx, coordy, 0.0 ), vec3.set( this._dstIntersect, coordx, coordy, 1.0 ) );
        this._iv.reset();
        this._iv.setTraversalMask( this._hoverNode.getNodeMask() );

        this.setOnlyGizmoPicking();
        this._viewer.getCamera().accept( this._iv );
        this.setOnlyScenePicking();

        vec3.transformMat4( vec, this._lsi.getTranslateDistance(), this._editInvWorldScaleRot );


        var vertices = this._vertexArrayBuffer.getElements();

        var translateMatrix = mat4.create();

        // create a Matrix with the translation to be applied to the vertices
        // Matrix.multTranslate( identityMatrix, vec, translateMatrix ); --> BUG!!!!! changed to makeTranslate->fromTranslation
        mat4.fromTranslation( translateMatrix, vec );

        // for each vertex
        for ( var i = 0; i < this._indices.length; i++ ) {
            // get the vertex position
            var vector = vec3.fromValues32( vertices[ this._indices[ i ] * 3 ], vertices[ this._indices[ i ] * 3 + 1 ], vertices[ this._indices[ i ] * 3 + 2 ] );

            var result = vec3.create32();

            // set the translated position in a new vector
            vec3.transformMat4( result, vector, translateMatrix );

            // set the new position to the vertex
            vertices[ this._indices[ i ] * 3 ] = result[ 0 ];
            vertices[ this._indices[ i ] * 3 + 1 ] = result[ 1 ];
            vertices[ this._indices[ i ] * 3 + 2 ] = result[ 2 ];
        }

        // call dirty method first for the geometry and secondly for the BufferArray
        this._geometry.dirty();
        this._vertexArrayBuffer.dirty();

        this._attachedNode.dirtyBound();
    }

} );

module.exports = VertexGizmo;


/***/ }),

/***/ "./sources/pcvizNode/pcvizNode.js":
/*!****************************************!*\
  !*** ./sources/pcvizNode/pcvizNode.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const DrawingRuleAttribute = __webpack_require__( /*! pcvizNode/DrawingRuleAttribute */ "./sources/pcvizNode/DrawingRuleAttribute.js" );
const LightingAttribute = __webpack_require__( /*! pcvizNode/LightingAttribute */ "./sources/pcvizNode/LightingAttribute.js" );
const BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
const PointSizeAttribute = __webpack_require__( /*! pcvizNode/PointSizeAttribute */ "./sources/pcvizNode/PointSizeAttribute.js" );
const PointCloudPLOD = __webpack_require__( /*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js" );
const PointCloudScene = __webpack_require__( /*! pcvizNode/PointCloudScene */ "./sources/pcvizNode/PointCloudScene.js" );
const GeometryTypeAttribute = __webpack_require__( /*! pcvizNode/GeometryTypeAttribute */ "./sources/pcvizNode/GeometryTypeAttribute.js" );
const CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
const VertexGizmo = __webpack_require__( /*! pcvizNode/VertexGizmo */ "./sources/pcvizNode/VertexGizmo.js" );
const CustomVertexGizmo = __webpack_require__( /*! pcvizNode/CustomVertexGizmo */ "./sources/pcvizNode/CustomVertexGizmo.js" );
const VectorLayerScene = __webpack_require__( /*! pcvizNode/VectorLayerScene */ "./sources/pcvizNode/VectorLayerScene.js" );
const Model3DLayerScene = __webpack_require__( /*! pcvizNode/Model3DLayerScene */ "./sources/pcvizNode/Model3DLayerScene.js" );
const EDLNode = __webpack_require__( /*! pcvizNode/EDLNode */ "./sources/pcvizNode/EDLNode.js" );
const SceneNode = __webpack_require__( /*! pcvizNode/SceneNode */ "./sources/pcvizNode/SceneNode.js" );
const Switch = __webpack_require__( /*! pcvizNode/Switch */ "./sources/pcvizNode/Switch.js" );
const Model3DNode = __webpack_require__( /*! pcvizNode/Model3DNode */ "./sources/pcvizNode/Model3DNode.js" );
const GeoImageNode = __webpack_require__( /*! pcvizNode/GeoImageNode */ "./sources/pcvizNode/GeoImageNode.js" );
const PlanarImage = __webpack_require__( /*! pcvizNode/PlanarImage */ "./sources/pcvizNode/PlanarImage.js" );
const LayerScene = __webpack_require__( /*! pcvizNode/LayerScene */ "./sources/pcvizNode/LayerScene.js" );
const CollagePLOD = __webpack_require__( /*! pcvizNode/CollagePLOD */ "./sources/pcvizNode/CollagePLOD.js" );
const ElementIDAttribute = __webpack_require__( /*! pcvizNode/ElementIDAttribute */ "./sources/pcvizNode/ElementIDAttribute.js" );
const Group = __webpack_require__( /*! pcvizNode/Group */ "./sources/pcvizNode/Group.js" );
const LayerGizmo = __webpack_require__( /*! pcvizNode/LayerGizmo */ "./sources/pcvizNode/LayerGizmo.js" );
const HUDNode = __webpack_require__( /*! pcvizNode/HUDNode */ "./sources/pcvizNode/HUDNode.js" );
const PointEditionAttribute = __webpack_require__( /*! pcvizNode/PointEditionAttribute */ "./sources/pcvizNode/PointEditionAttribute.js" );
const SideAttribute = __webpack_require__( /*! pcvizNode/SideAttribute */ "./sources/pcvizNode/SideAttribute.js" );

/** @namespace pcvizNode */
let pcvizNode = {};
pcvizNode.DrawingRuleAttribute = DrawingRuleAttribute;
pcvizNode.LightingAttribute = LightingAttribute;
pcvizNode.BufferAttribute = BufferAttribute;
pcvizNode.PointSizeAttribute = PointSizeAttribute;
pcvizNode.PointCloudPLOD = PointCloudPLOD;
pcvizNode.PointCloudScene = PointCloudScene;
pcvizNode.GeometryTypeAttribute = GeometryTypeAttribute;
pcvizNode.CustomText = CustomText;
pcvizNode.VertexGizmo = VertexGizmo;
pcvizNode.CustomVertexGizmo = CustomVertexGizmo;
pcvizNode.VectorLayerScene = VectorLayerScene;
pcvizNode.Model3DLayerScene = Model3DLayerScene;
pcvizNode.EDLNode = EDLNode;
pcvizNode.SceneNode = SceneNode;
pcvizNode.Switch = Switch;
pcvizNode.Model3DNode = Model3DNode;
pcvizNode.GeoImageNode = GeoImageNode;
pcvizNode.PlanarImage = PlanarImage;
pcvizNode.LayerScene = LayerScene;
pcvizNode.CollagePLOD = CollagePLOD;
pcvizNode.Group = Group;
pcvizNode.LayerGizmo = LayerGizmo;
pcvizNode.HUDNode = HUDNode;
pcvizNode.PointEditionAttribute = PointEditionAttribute;
pcvizNode.SideAttribute = SideAttribute;
// ElementID Attribute
pcvizNode.ElementIDAttribute = ElementIDAttribute;

module.exports = pcvizNode;


/***/ }),

/***/ "./sources/pcvizPano/SpherePano.js":
/*!*****************************************!*\
  !*** ./sources/pcvizPano/SpherePano.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var GeoImageNode = __webpack_require__( /*! pcvizNode/GeoImageNode */ "./sources/pcvizNode/GeoImageNode.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var osg = OSG.osg;

/**
 *  SpherePano is a node to render inner spheres with panorama textures.
 *  @class
 *  @memberof pcvizPano
 */
var SpherePano = function () {
    GeoImageNode.call( this );

    this._yaw = 0;
    this._pitch = 0;
    this._roll = 0;

    this._lastTextureUrl = undefined;
    this._category = VectorLayerUtils.Categories.PANORAMA;

    this.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( osg.CullFace.FRONT ) );
};

// Converts from degrees to radians.
Math.toRadians = function ( degrees ) {
    return degrees * Math.PI / 180;
};

// Converts from radians to degrees.
Math.toDegrees = function ( radians ) {
    return radians * 180 / Math.PI;
};

SpherePano.prototype = osg.objectInherit( GeoImageNode.prototype, {

    setImageMode: function ( value ) {
        var matrix = this.getMatrix();
        if ( value ) {
            this.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
            // 75.0 is the value they use default in Collage.
            this.setMatrix( osg.mat4.scale( matrix, matrix, osg.vec3.fromValues( 75.0, 75.0, 75.0 ) ) );
            this.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( osg.CullFace.BACK ) );
        } else {
            this.setNodeMask( ~0 );
            this.computeRotationTranslation();
            this.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( osg.CullFace.FRONT ) );
            var selObj = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
            if ( selObj && selObj.getLayer() && ( !selObj.getLayer().getCategory || !VectorLayerUtils.isPanorama( selObj.getLayer().getCategory() ) ) && this.getParents().length )
                this.getParents()[ 0 ].removeChildren();
        }

        if ( this._geometryNode && this._geometryNode.activate )
            this._geometryNode.activate( value );

        if ( value )
            this.setDepth( this._imageMode ? this._seeInFront : true, false );
        else
            this.setDepth( false, true );

        this._imageMode = value;
    },

    /**
     * Rotates the sphere depending on the yaw, pitch and roll values.
     * If one of these parameters are not provided, it will use the cached values.
     * // TODO: Get only the quat rotation from feature not euler angles
     * @param {float} yaw   Yaw angle.
     * @param {float} pitch Pitch angle.
     * @param {float} roll  Roll angle.
     */
    setRotationFromYawPitchRoll: function ( yaw, pitch, roll ) {
        if ( !this._parents.length )
            return;
        if ( yaw === undefined || pitch === undefined || roll === undefined ) {
            yaw = this._yaw;
            pitch = this._pitch;
            roll = this._roll;
        } else {
            this._yaw = roll;
            this._pitch = pitch;
            this._roll = roll;
        }
        Utils.makeRotateFromEuler( this._rotationQuat, Math.toRadians( roll ), Math.toRadians( pitch ), Math.toRadians( yaw ), 'XYZ' );
        osg.quat.rotateZ( this._rotationQuat, this._rotationQuat, Math.PI / 2.0 );
        osg.quat.rotateY( this._rotationQuat, this._rotationQuat, Math.PI );
        this.setMatrix( this.getMatrix() );
    },

} );

module.exports = SpherePano;


/***/ }),

/***/ "./sources/pcvizPano/pcvizPano.js":
/*!****************************************!*\
  !*** ./sources/pcvizPano/pcvizPano.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SpherePano = __webpack_require__( /*! pcvizPano/SpherePano */ "./sources/pcvizPano/SpherePano.js" );

/** @namespace pcvizUtils */
var pcvizPano = {};
pcvizPano.SpherePano = SpherePano;

module.exports = pcvizPano;


/***/ }),

/***/ "./sources/pcvizPlugins/BinaryDecoder.js":
/*!***********************************************!*\
  !*** ./sources/pcvizPlugins/BinaryDecoder.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var string = String;

var BinaryDecoder = function () {
    this._u8array = undefined;
    this._offset = 0;
    this._littleEndian = false;
    this._view = undefined;
};

BinaryDecoder.prototype = {

    setLittleEndian: function ( value ) {
        this._littleEndian = value;
    },

    setBuffer: function ( buffer ) {
        this._u8array = buffer;
        this._offset = 0;
        this._view = new DataView( buffer );
    },

    getOffset: function () {
        return this._offset;
    },

    setOffset: function ( offset ) {
        this._offset = offset;
    },

    getFloat64Value: function () {
        var value = this._view.getFloat64( this._offset, this._littleEndian );
        this._offset += Float64Array.BYTES_PER_ELEMENT;
        return value;
    },

    getFloat32Value: function () {
        var value = this._view.getFloat32( this._offset, this._littleEndian );
        this._offset += Float32Array.BYTES_PER_ELEMENT;
        return value;
    },

    getUint32Value: function () {
        var value = this._view.getUint32( this._offset, this._littleEndian );
        this._offset += Uint32Array.BYTES_PER_ELEMENT;
        return value;
    },

    getUint16Value: function () {
        var value = this._view.getUint16( this._offset, this._littleEndian );
        this._offset += Uint16Array.BYTES_PER_ELEMENT;
        return value;
    },

    getUint8Value: function () {
        var value = this._view.getUint8( this._offset, this._littleEndian );
        this._offset += Uint8Array.BYTES_PER_ELEMENT;
        return value;
    },

    getInt32Value: function () {
        var value = this._view.getInt32( this._offset, this._littleEndian );
        this._offset += Int32Array.BYTES_PER_ELEMENT;
        return value;
    },

    getInt16Value: function () {
        var value = this._view.getInt16( this._offset, this._littleEndian );
        this._offset += Int16Array.BYTES_PER_ELEMENT;
        return value;
    },

    getInt8Value: function () {
        var value = this._view.getInt8( this._offset, this._littleEndian );
        this._offset += Int8Array.BYTES_PER_ELEMENT;
        return value;
    },

    decodeArray: function ( size ) {
        var array = new Uint8Array( this._u8array.slice( this._offset, this._offset + size ) );
        this._offset += size;
        return array;
    },

    decodeStringArray: function ( size ) {
        var str = '';
        for ( var i = this._offset, len = this._offset + size; i < len; i++ ) {
            str += string.fromCharCode( this._view.getUint8( i ) );
        }
        this._offset += size;
        return str;
    }
};

module.exports = BinaryDecoder;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriter3DTiles.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriter3DTiles.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;

var requestFile = osgDB.requestFile;
var Registry = osgDB.Registry;
var MatrixTransform = osg.MatrixTransform;
var Node = osg.Node;
var CollagePLOD = __webpack_require__( /*! pcvizNode/CollagePLOD */ "./sources/pcvizNode/CollagePLOD.js" );
var Lod = osg.Lod;
var BoundingBox = osg.BoundingBox;
var BoundingSphere = osg.BoundingSphere;
var vec3 = osg.vec3;
var mat4 = osg.mat4;

var GEOMETRIC_ERROR_SCALE = 1;
var RANGE_IN_PIXELS = 100000;

var ReaderWriter3DTiles = function () {
    this._b3dmReader = Registry.instance().getReaderWriterForExtension( 'b3dm' );
};

ReaderWriter3DTiles.prototype = {

    readNodeURL: function ( url, options ) {
        var defer = P.defer();
        if ( options && options.parentBounding !== undefined ) {
            options.bounding = options.parentBounding;
        }

        var self = this;
        // remove pseudoloader .3dt
        url = url.substring( 0, url.lastIndexOf( '.' ) );
        this._requestPromise = requestFile;
        if ( options && options.request !== undefined ) {
            this._requestPromise = options.request;
        }

        var filePromise = this._requestPromise( url, options );
        filePromise.then( function ( file ) {
            self.readTileSet( file, options ).then( function ( rootTile ) {
                defer.resolve( rootTile );
            } );
        } );

        return defer.promise;
    },

    readTileSet: function ( file, options ) {
        var defer = P.defer();
        var tilesetJson = JSON.parse( file );
        this.readRootTile( tilesetJson.root, options ).then( function ( rootTile ) {
            defer.resolve( rootTile );
        } );
        return defer.promise;
    },


    readChildrenTiles: function ( parent ) {
        var defer = P.defer();
        var group = new Node();
        var self = this;

        var createTileLOD = function ( tileLOD, tag, rw, options ) {
            var childDefer = P.defer();
            if ( tag.content.uri ) {
                tag.content.url = tag.content.uri;
            }
            var ext = tag.content.url.substring( tag.content.url.lastIndexOf( '.' ) );

            var fileURL = options.databasePath;
            if ( options.subBasePath )
                fileURL += options.subBasePath;
            fileURL += tag.content.url;

            // this is to use geometric error. For now the terrains models does not use
            // var rangeMin = ( tileLOD.json.geometricError !== undefined ) ? tileLOD.json.geometricError : 0;
            var rangeMin = RANGE_IN_PIXELS;
            rangeMin = rangeMin * GEOMETRIC_ERROR_SCALE;
            if ( ext === '.b3dm' ) {
                var b3dmrw = Registry.instance().getReaderWriterForExtension( 'b3dm' );
                var opt = {
                    request: self._requestPromise,
                    appendQuery: options.appendQuery,
                    layer: options.layer,
                    rootBounds: options.rootBounds
                };
                b3dmrw.readNodeURL( fileURL, opt ).then( function ( child ) {
                    var tt = new MatrixTransform();
                    var bs = self.getBounding( tag.boundingVolume );
                    if ( bs.center( vec3.create() ) !== undefined ) {
                        var transVec = vec3.sub( vec3.create(), bs.center( vec3.create() ), options.bounding.center( vec3.create() ) );

                        var matrixTranslate = mat4.create();
                        mat4.fromTranslation( matrixTranslate, vec3.fromValues( transVec[ 0 ], transVec[ 1 ], transVec[ 2 ] ) );

                        var matrixRotate = mat4.create();
                        mat4.fromRotation( matrixRotate, Math.PI / 2.0, vec3.fromValues( 1, 0, 0 ) );

                        mat4.mul( tt.getMatrix(), matrixTranslate, matrixRotate );
                    }

                    tt.addChild( child );

                    tileLOD.addChild( tt, 0, rangeMin );
                    tileLOD.setRangeMode( Lod.PIXEL_SIZE_ON_SCREEN );

                    if ( tileLOD.json.children !== undefined ) {
                        tileLOD.setFunction( 1, rw.readChildrenTiles.bind( rw ) );
                        tileLOD.setRange( 1, rangeMin, Number.MAX_VALUE );
                    } else {
                        tileLOD.setRange( 0, 0, Number.MAX_VALUE );
                    }
                    childDefer.resolve( tileLOD );
                } );
            } else if ( ext === '.json' ) {
                var modelURL = fileURL + '.3dt';
                var basePath = fileURL.substring( parent.options.databasePath.length );
                basePath = basePath.substring( 0, basePath.lastIndexOf( '/' ) + 1 );

                var rwB3DM = new ReaderWriter3DTiles();
                var tiledModelPromise = rwB3DM.readNodeURL( modelURL, {
                    databasePath: parent.options.databasePath,
                    subBasePath: basePath,
                    parentBounding: parent.options.parentBounding,
                    json: tag,
                    request: self._requestPromise,
                    appendQuery: parent.options.appendQuery,
                    layer: options.layer,
                    rootBounds: options.rootBounds
                } );
                tiledModelPromise.then( function ( tiledmodel ) {
                    childDefer.resolve( tiledmodel );
                }, function () {
                    console.error( 'request error' );
                } );
            }
            return childDefer.promise;
        };

        var childrenJson = parent.json.children;
        if ( !childrenJson ) {
            defer.reject();
            return defer.promise;
        }

        var promiseTLOD = [];
        for ( var i = 0; i < childrenJson.length; i++ ) {
            if ( childrenJson[ i ].content.uri ) {
                childrenJson[ i ].content.url = childrenJson[ i ].content.uri;
            }
            var contentURL = childrenJson[ i ].content.url;
            var tileLOD = new CollagePLOD();
            tileLOD.setName( contentURL );
            tileLOD.setDatabasePath( parent.getDatabasePath() );
            if ( contentURL === undefined ) break;
            tileLOD.json = childrenJson[ i ];
            tileLOD.options = parent.options;
            promiseTLOD.push( createTileLOD( tileLOD, childrenJson[ i ], this, parent.options ) );

        }
        P.all( promiseTLOD ).then( function ( tileLODArray ) {
            for ( var i = 0; i < tileLODArray.length; i++ ) {
                group.addChild( tileLODArray[ i ] );
            }
            defer.resolve( group );
        } );
        return defer.promise;
    },

    readSimpleNode: function ( tileJson, group, options ) {
        var self = this;


        var readFromJson = function ( url, childrenJson ) {
            var modelURL = url + '.3dt';

            var basePath = url.substring( options.databasePath.length );
            basePath = basePath.substring( 0, basePath.lastIndexOf( '/' ) + 1 );

            var rwB3DM = new ReaderWriter3DTiles();
            var tiledModelPromise = rwB3DM.readNodeURL( modelURL, {
                databasePath: options.databasePath,
                subBasePath: basePath,
                parentBounding: options.bounding,
                json: childrenJson,
                request: self._requestPromise,
                appendQuery: options.appendQuery,
                layer: options.layer
            } );
            tiledModelPromise.then( function ( tiledmodel ) {
                group.addChild( tiledmodel );
            } );
        };


        for ( var i = 0; i < tileJson.length; i++ ) {
            var childrenJson = tileJson[ i ];
            if ( childrenJson.content.uri ) {
                childrenJson.content.url = childrenJson.content.uri;
            }
            if ( childrenJson.content !== undefined && childrenJson.content.url !== undefined ) {
                readFromJson( options.databasePath + childrenJson.content.url, childrenJson );
            } else {

                var tt = new MatrixTransform();

                if ( childrenJson.children && childrenJson.children.length > 0 )
                    this.readSimpleNode( childrenJson.children, tt, options );

                group.addChild( tt );
            }
        }
    },


    readRootTile: function ( tileJson, options ) {
        var self = this;
        var defer = P.defer();
        var tileTransform = new MatrixTransform();
        tileTransform.setName( 'Root_3D_Tile' );
        // FIXME: transforms seems to be column major
        // So no transforms right now

        if ( tileJson.transform )
            console.warn( 'The model has transforms' );

        if ( options.bounding === undefined ) {
            this.readBoundingVolume( tileJson, options );
            tileTransform.originalBounding = options.bounding;
        } else
            this.readBoundingVolume( tileJson, options );

        // if a node does not have content, try to add his children
        if ( tileJson.content && tileJson.content.uri ) {
            tileJson.content.url = tileJson.content.uri;
        }
        if ( tileJson.content === undefined || tileJson.content.url === undefined ) {
            var group = new MatrixTransform();
            this.readSimpleNode( tileJson.children, group, options );
            tileTransform.addChild( group );
            defer.resolve( tileTransform );
        } else {
            var tileLOD = new CollagePLOD();
            tileLOD.setDatabasePath( options.databasePath );
            var contentURL = tileJson.content.url;
            var fileURL = options.databasePath;
            if ( options.subBasePath )
                fileURL += options.subBasePath;
            fileURL += contentURL;
            var opt = {
                request: self._requestPromise,
                appendQuery: options.appendQuery,
                layer: options.layer,
                rootBounds: options.rootBounds
            };
            this._b3dmReader.readNodeURL( fileURL, opt ).then( function ( node ) {
                tileTransform.addChild( tileLOD );
                tileLOD.setRangeMode( Lod.PIXEL_SIZE_ON_SCREEN );
                var range = RANGE_IN_PIXELS * 0.01;

                var tt = new MatrixTransform();
                var bs = self.getBounding( tileJson.boundingVolume );
                if ( tileJson.children !== undefined && tileJson.children.length === 1 )
                    bs = self.getBounding( tileJson.children[ 0 ].boundingVolume );
                if ( bs.center( vec3.create() ) !== undefined ) {
                    var transVec = vec3.sub( vec3.create(), bs.center( vec3.create() ), options.bounding.center( vec3.create() ) );
                    var matrixTranslate = mat4.create();
                    mat4.fromTranslation( matrixTranslate, vec3.fromValues( transVec[ 0 ], transVec[ 1 ], transVec[ 2 ] ) );

                    var matrixRotate = mat4.create();
                    mat4.fromRotation( matrixRotate, Math.PI / 2.0, vec3.fromValues( 1, 0, 0 ) );

                    mat4.mul( tt.getMatrix(), matrixTranslate, matrixRotate );
                }

                tt.addChild( node );
                tileLOD.addChild( tt, 0, range );
                tileLOD.json = tileJson;
                tileLOD.options = options;
                tileLOD.setFunction( 1, self.readChildrenTiles.bind( self ) );
                tileLOD.setRange( 1, range, Number.MAX_VALUE );

                tileTransform.realBound = tileLOD.getBound();
                defer.resolve( tileTransform );
            } );
        }
        return defer.promise;
    },

    readBoundingVolume: function ( tileJson, options ) {
        if ( options.rootBounds )
            options.bounding = this.getBounding( options.rootBounds );

        else if ( tileJson.boundingVolume.box !== undefined ) {
            var box = tileJson.boundingVolume.box;
            // It's a box
            var bbox = new BoundingBox();
            bbox.expandByvec3( vec3.fromValues( box[ 3 ], box[ 7 ], box[ 11 ] ) );
            bbox.expandByvec3( vec3.fromValues( -box[ 3 ], -box[ 7 ], -box[ 11 ] ) );
            options.bounding = bbox;
        } else if ( tileJson.boundingVolume.sphere !== undefined ) {
            var sphere = tileJson.boundingVolume.sphere;
            var bs = new BoundingSphere();
            bs.set( vec3.fromValues( sphere[ 0 ], sphere[ 1 ], sphere[ 2 ] ), sphere[ 3 ] );
            if ( options.bounding === undefined )
                options.bounding = bs;
        } else {
            console.error( 'this bounding volume is not implement yet' );
        }
    },

    getBounding: function ( boundingTag ) {
        if ( boundingTag.box !== undefined ) {
            var box = boundingTag.box;
            // It's a box
            var bbox = new BoundingBox();
            bbox.expandByvec3( vec3.fromValues( box[ 3 ], box[ 7 ], box[ 11 ] ) );
            bbox.expandByvec3( vec3.fromValues( -box[ 3 ], -box[ 7 ], -box[ 11 ] ) );
            return bbox;
        } else if ( boundingTag.sphere !== undefined ) {
            var sphere = boundingTag.sphere;
            var bs = new BoundingSphere();
            bs.set( vec3.fromValues( sphere[ 0 ], sphere[ 1 ], sphere[ 2 ] ), sphere[ 3 ] );
            return bs;
        } else {
            console.error( 'this bounding volume is not implement yet' );
        }
    },

};

Registry.instance().addReaderWriter( '3dt', new ReaderWriter3DTiles() );

module.exports = ReaderWriter3DTiles;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterB3DM.js":
/*!**************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterB3DM.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osgDB = OSG.osgDB;
var requestFile = osgDB.requestFile;
var Registry = osgDB.Registry;
var BinaryDecoder = __webpack_require__( /*! pcvizPlugins/BinaryDecoder */ "./sources/pcvizPlugins/BinaryDecoder.js" );

var ReaderWriterB3DM = function () {
    this._decoder = new BinaryDecoder();
    this._decoder.setLittleEndian( true );
    this._glbReader = Registry.instance().getReaderWriterForExtension( 'glb' );
};

var B3DMHeader = function () {
    this.magic = ''; // 4-byte ANSI string "b3dm"
    this.version = 0; // uint32 The version of the Batched 3D Model format. It is currently 1
    this.byteLength = 0; // uint32 The length of the entire tile, including the header, in bytes.
    this.batchTableJSONByteLength = 0; // uint32 The length of the batch table JSON section in bytes. Zero indicates there is no batch table.
    this.batchTableBinaryByteLength = 0; // uint32 The length of the batch table binary section in bytes. If batchTableJSONByteLength is zero, this will also be zero.
    this.batchLength = 0; //uint32 The number of models, also called features, in the batch.
};

var B3DMBatchTable = function () {
    this.header = undefined;
    this.binaryBody = undefined;
};

var B3DMModel = function () {
    this.header = new B3DMHeader();
    this.batchTable = new B3DMBatchTable();
    // Several gltf files in a B3DM model?
    // this.gltf = [];
};

ReaderWriterB3DM.prototype = {

    readNodeURL: function ( url, options ) {
        var self = this;
        var model = new B3DMModel();

        this._requestPromise = requestFile;
        if ( options && options.request !== undefined ) {
            this._requestPromise = options.request;
        }

        var filePromise = this._requestPromise( url, {
            responseType: 'arraybuffer',
            appendQuery: options.appendQuery,
            layer: options.layer
        } );
        return filePromise.then( function ( file ) {
            self.readHeader( file, model );
            if ( model.header.featureTableJsonByteLength > 0 ) {
                self.readFeatureTableJson( model );
            }
            if ( model.header.batchTableJSONByteLength > 0 ) {
                self.readBatchTable( file, model );
            }
            return self.readGLTFB( file, model );
        } );
    },

    readHeader: function ( bufferArray, model ) {

        this._decoder.setBuffer( bufferArray );

        model.header.magic = this._decoder.decodeStringArray( 4 );
        if ( model.header.magic !== 'b3dm' ) {
            console.error( 'Invalid Batched 3D Model.  Expected magic=b3dm.  Read magic=' + model.header.magic );
            return;
        }

        model.header.version = this._decoder.getUint32Value();
        if ( model.header.version !== 1 ) {
            console.error( 'Only Batched 3D Model version 1 is supported.  Version' + model.header.version + ' is not.' );
            return;
        }

        model.header.byteLength = this._decoder.getUint32Value();
        model.header.featureTableJsonByteLength = this._decoder.getUint32Value();
        model.header.featureTableBinaryByteLength = this._decoder.getUint32Value();
        model.header.batchTableJsonByteLength = this._decoder.getUint32Value();
        model.header.batchTableBinaryByteLength = this._decoder.getUint32Value();
        model.header.batchLength = 0;

        if ( model.header.batchTableJsonByteLength >= 570425344 ) {
            // First legacy check
            this._decoder.setOffset( this._decoder.getOffset() - Uint32Array.BYTES_PER_ELEMENT * 2 );
            model.header.batchLength = model.header.featureTableJsonByteLength;
            model.header.batchTableJsonByteLength = model.header.featureTableBinaryByteLength;
            model.header.batchTableBinaryByteLength = 0;
            model.header.featureTableJsonByteLength = 0;
            model.header.featureTableBinaryByteLength = 0;
            // console.warn( 'b3dm-legacy-header', 'This b3dm header is using the legacy format [batchLength] [batchTableByteLength]. The new format is [featureTableJsonByteLength] [featureTableBinaryByteLength] [batchTableJsonByteLength] [batchTableBinaryByteLength] from https://github.com/AnalyticalGraphicsInc/3d-tiles/blob/master/TileFormats/Batched3DModel/README.md.' );
        } else if ( model.header.batchTableBinaryByteLength >= 570425344 ) {
            // Second legacy check
            this._decoder.setOffset( this._decoder.getOffset() - Uint32Array.BYTES_PER_ELEMENT );
            model.header.batchLength = model.header.batchTableJsonByteLength;
            model.header.batchTableJsonByteLength = model.header.featureTableJsonByteLength;
            model.header.batchTableBinaryByteLength = model.header.featureTableBinaryByteLength;
            model.header.featureTableJsonByteLength = 0;
            model.header.featureTableBinaryByteLength = 0;
            // console.warn( 'b3dm-legacy-header', 'This b3dm header is using the legacy format [batchTableJsonByteLength] [batchTableBinaryByteLength] [batchLength]. The new format is [featureTableJsonByteLength] [featureTableBinaryByteLength] [batchTableJsonByteLength] [batchTableBinaryByteLength] from https://github.com/AnalyticalGraphicsInc/3d-tiles/blob/master/TileFormats/Batched3DModel/README.md.' );
        }
    },

    readFeatureTableJson: function ( model ) {
        console.warn( 'Feature table json not implemented yet' );
        model.jsonTable = this._decoder.decodeStringArray( model.header.batchTableJsonByteLength );
    },

    readBatchTable: function ( /*bufferArray, model*/) {
        console.error( 'batch table reading not implemented yet' );
    },

    readGLTFB: function ( bufferArray, model ) {
        var gltfArray = bufferArray.slice( this._decoder.getOffset() +
            model.header.featureTableJsonByteLength +
            model.header.featureTableBinaryByteLength +
            model.header.batchTableJsonByteLength +
            model.header.batchTableBinaryByteLength );
        return this._glbReader.readBinaryArray( gltfArray );
    }
};

Registry.instance().addReaderWriter( 'b3dm', new ReaderWriterB3DM() );

module.exports = ReaderWriterB3DM;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterCPLFMZ.js":
/*!****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterCPLFMZ.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;
var ConversionInfo = __webpack_require__( /*! pcvizDB/ConversionInfo */ "./sources/pcvizDB/ConversionInfo.js" );
var PLFMZReaderParser = __webpack_require__( /*! pcvizDB/PLFMZReaderParser */ "./sources/pcvizDB/PLFMZReaderParser.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var PointCloudPLOD = __webpack_require__( /*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js" );
var TileUniformsAttribute = __webpack_require__( /*! pcvizNode/TileUniformsAttribute */ "./sources/pcvizNode/TileUniformsAttribute.js" );
var ReaderWriterPLFBase = __webpack_require__( /*! pcvizPlugins/ReaderWriterPLFBase */ "./sources/pcvizPlugins/ReaderWriterPLFBase.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );


var ReaderWriterCPLFMZ = function () {
    ReaderWriterPLFBase.call( this );
    this._options = undefined;
    this._parser = new PLFMZReaderParser();

    this._conversionInfo = new ConversionInfo();
};

ReaderWriterCPLFMZ.prototype = Utils.objectInherit( ReaderWriterPLFBase.prototype, {

    readSceneGraph: function ( data, options ) {
        return this.parseCPLFMZSceneGraph( data, options );
    },

    parseCPLFMZSceneGraph: function ( data, options ) {

        if ( data === undefined ) {
            console.error( 'No valid data found' );
            return undefined;
        }

        var plfmz = this._parser.parseCompactBuffer( data );
        var plod = this.createCompactPagedLOD( plfmz, options );

        // Set TileUniforms
        var sset = plod.getOrCreateStateSet();

        var levelFactor = Math.pow( 1.2, ( 10.0 - options.level ) );
        var tileUniformsAttribute = new TileUniformsAttribute();
        tileUniformsAttribute.setLevelFactor( levelFactor );
        sset.setAttributeAndModes( tileUniformsAttribute );

        return plod;
    },

    createCompactPagedLOD: function ( cplfmz, options ) {

        var that = this;
        var createURL = function ( i /*plod*/ ) {
            var isLeaf = that._parser.parseLeaf( cplfmz.childrenAttributesInformation[ i ].get( 'Leaf' ).arrayBuffer );
            if ( isLeaf === 'Y' ) return undefined;

            var dsg = that._parser.parseDesignation( cplfmz.childrenAttributesInformation[ i ].get( 'Designation' ).arrayBuffer );
            var url = that.getUrl( dsg, options.urlDataPrefix, options.database, options.format );
            options.level = dsg[ 0 ] + 1;
            return url;
        };
        var group = new osg.Node();
        for ( var i = 0, j = cplfmz.header.numChildren; i < j; i++ ) {
            var geometry = this.getCompactPLODGeometry( cplfmz.childrenAttributesInformation[ i ], options );
            Registry.getController( 'PointVisibilityManager' ).pushNodeToProcess( group.getInstanceID(), geometry ); // Register new CPLFMZ geometry to update visibility.

            var tile = new PointCloudPLOD();

            var sset = tile.getOrCreateStateSet();

            group.addChild( tile );
            tile.setRangeMode( osg.Lod.PIXEL_SIZE_ON_SCREEN );

            var extent = this._parser.parseExtension( cplfmz.childrenAttributesInformation[ i ].get( 'Extension' ).arrayBuffer );

            // transformed positions
            tile._trX = 0.5 * ( extent.minExtent[ 0 ] + extent.maxExtent[ 0 ] ) - options.center[ 0 ];
            tile._trY = 0.5 * ( extent.minExtent[ 1 ] + extent.maxExtent[ 1 ] ) - options.center[ 1 ];
            tile._trZ = 0.5 * ( extent.minExtent[ 2 ] + extent.maxExtent[ 2 ] ) - options.center[ 2 ];

            var transformGeom = new osg.MatrixTransform();
            transformGeom.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), [ tile._trX, tile._trY, tile._trZ ] ) );
            transformGeom.addChild( geometry );
            tile.addChild( transformGeom, 0, 250000 ); // add transformed geometry
            tile.setOptions( options );
            // Set TileUniforms
            var levelFactor = Math.pow( 1.2, ( 10.0 - options.level ) );
            var tileUniformsAttribute = new TileUniformsAttribute();
            tileUniformsAttribute.setTileOrigin( tile.getTileOrigin() );
            tileUniformsAttribute.setLevelFactor( levelFactor );
            sset.setAttributeAndModes( tileUniformsAttribute );

            var url = createURL( i );
            if ( url === undefined ) {
                tile.setRange( 0, 0, Number.MAX_VALUE );
            } else {
                tile.setFileName( 1, url );
                tile.setRange( 1, 250000, Number.MAX_VALUE );
            }
        }
        return group;
    },

    getCompactPLODGeometry: function ( attributesInformation, options ) {
        var geometry = new osg.Geometry();
        let pointType = 'PointArray';
        switch ( true ) {
        case attributesInformation.has( ConversionInfo.CompressedPointArrayID ):
            pointType = ConversionInfo.CompressedPointArrayID;
            break;
        case attributesInformation.has( ConversionInfo.CompressedPointFloat24ArrayID ):
            pointType = ConversionInfo.CompressedPointFloat24ArrayID;
            break;
        case attributesInformation.has( ConversionInfo.CompressedPointFloat16ArrayID ):
            pointType = ConversionInfo.CompressedPointFloat16ArrayID;
            break;
        }

        if ( pointType !== 'PointArray' )
            this._conversionInfo.apply( pointType, geometry, attributesInformation, options );

        const hasCompressedVec3Normal = attributesInformation.has( ConversionInfo.CompressedNormalVec3ArrayID );

        const that = this;
        attributesInformation.forEach( function ( value, key ) {
            if ( key === pointType ) return true;

            if ( hasCompressedVec3Normal && key === ConversionInfo.NormalVec3ArrayID ) {
                return;
            }

            if ( key in that._conversionInfo && key !== 'PointArray' && key !== 'ColorArray' ) {
                that._conversionInfo.apply( key, geometry, attributesInformation, options );
            }
        } );
        const len = geometry.getAttributes().Vertex.getElements().length / 3;
        const u8array = new Uint8Array( len );
        geometry.getAttributes().Visible = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 1, true );
        return geometry;
    }

} );

osgDB.Registry.instance().addReaderWriter( 'cplfmz', new ReaderWriterCPLFMZ() );

module.exports = ReaderWriterCPLFMZ;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterFeatureImage.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterFeatureImage.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
var osgInput = OSG.osgDB.Input;
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var pcvizRegistry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;
var Registry = osgDB.Registry;

var ReaderWriterFeatureImage = function () {
    this._reader = new Input();
    this._reader.setMaxRequestsInQueue( 1 );

    this._baseImageURL = undefined;
    this._layer = undefined;
};

ReaderWriterFeatureImage.prototype = {
    readNodeURL: function ( url, options ) {
        var defer = P.defer();
        var imageNode;
        var self = this;
        this._layer = options.layer;
        var mountController = pcvizRegistry.getInstance().getController( 'Mount' );
        mountController.getMountObject( this._layer.getId() ).getMountObject().then( function ( mount ) {
            self._baseImageURL = url;
            if ( MagnetAPI.isConnectingFromMagnet() ) {
                self._baseImageURL = mount.mountPoint + '/' + url;
            }
            self._fileType = options.format;

            switch ( options.category ) {
            case VectorLayerUtils.Categories.PANORAMA:
                imageNode = Utils.createTexturedSphereFragment( 1.0, 30, 30 );
                break;
            case VectorLayerUtils.Categories.PLANAR_IMAGE:
                imageNode = Utils.createTexturedQuadGeometryFragment( options.fovx, options.fovy, options.principalPointX, options.principalPointY, options.cameraSensorWidth, options.cameraSensorHeight );
                break;
            }

            if ( !MagnetAPI.isConnectingFromMagnet() ) {
                self.loadTexture( imageNode, self._baseImageURL );
                defer.resolve( imageNode );
                return defer.promise;
            }

            self.loadTexture( imageNode, self._baseImageURL, undefined, options );

            defer.resolve( imageNode );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    loadTexture: function ( node, url, sourceUrl, options ) {
        if ( !sourceUrl )
            sourceUrl = url;

        var defer = P.defer();

        var self = this;
        if ( !options )
            options = {};
        options.imageCrossOrigin = 'Anonymous';
        options.imageLoadingUsePromise = true;

        options.readImageURL = function ( url, options ) {
            var defer = P.defer();
            options.imageCrossOrigin = 'anonymous';

            var image = new osg.Image();

            var xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if ( this.readyState === XMLHttpRequest.DONE && ( this.status >= 200 && this.status < 300 ) ) {
                    var response = new Blob( [ this.response ], {
                        type: 'image/jpg'
                    } );
                    self._useTexture = true;
                    var img = new window.Image();
                    img.src = URL.createObjectURL( response );
                    image.setImage( img );

                    img.onload = function () {
                        defer.resolve( image );
                    };

                    img.onerror = function () {
                        image.setImage( osgDB.Input.imageFallback );
                        defer.resolve( image );
                    };

                } else if ( this.readyState === XMLHttpRequest.DONE && !( this.status >= 200 && this.status < 300 ) ) {
                    image.setImage( osgDB.Input.imageFallback );
                    defer.resolve( image );
                }
            };

            xmlhttp.onerror = function () {
                defer.reject();
            };

            xmlhttp.onabort = function () {
                defer.reject();
            };

            xmlhttp.open( 'GET', url, true );

            xmlhttp.setRequestHeader( 'Accept', 'application/json' );
            xmlhttp.setRequestHeader( 'Content-Type', 'image/jpg' );
            xmlhttp.responseType = 'blob';

            xmlhttp.withCredentials = true;

            xmlhttp.send();

            return defer.promise;
        };

        this._reader.requestMountUrl( url, options, osgDB.readImage ).then( function ( image ) {
            // osgjs loads a fallback texture when loading fails
            if ( image.getImage() === osgInput.imageFallback ) {
                defer.reject();
                return;
            }

            // Avoids rendering wrong texture due to asyncronous loading (using .distance to check only for PlanarImage and Panorama)
            if ( !options.distance && sourceUrl.indexOf( self._baseImageURL ) === -1 ) {
                defer.resolve( node );
                return;
            }

            if ( node._texture === undefined ) {
                var texture = new osg.Texture();
                texture.setImage( image );
                texture.setMagFilter( osg.Texture.NEAREST );
                texture.setMinFilter( osg.Texture.LINEAR_MIPMAP_LINEAR );
                node._texture = texture;
                node.getOrCreateStateSet().setTextureAttributeAndModes( 0, texture, osg.StateAttribute.ON );
            } else
                node._texture.setImage( image );

            defer.resolve( node );
        } );

        return defer.promise;
    },
};

var readerWriterPanoramaInstance = new ReaderWriterFeatureImage();
Registry.instance().addReaderWriter( 'jpg', readerWriterPanoramaInstance );
Registry.instance().addReaderWriter( 'jpeg', readerWriterPanoramaInstance );
Registry.instance().addReaderWriter( 'JPG', readerWriterPanoramaInstance );
Registry.instance().addReaderWriter( 'JPEG', readerWriterPanoramaInstance );
Registry.instance().addReaderWriter( 'png', readerWriterPanoramaInstance );
Registry.instance().addReaderWriter( 'PNG', readerWriterPanoramaInstance );

module.exports = ReaderWriterFeatureImage;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterGLB.js":
/*!*************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterGLB.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osgDB = OSG.osgDB;

var requestFile = osgDB.requestFile;
var Registry = osgDB.Registry;
var BinaryDecoder = __webpack_require__( /*! pcvizPlugins/BinaryDecoder */ "./sources/pcvizPlugins/BinaryDecoder.js" );

var ReaderWriterGLB = function () {
    this._decoder = new BinaryDecoder();
    this._decoder.setLittleEndian( true );
    this._gltfReaders = {
        1: Registry.instance().getReaderWriterForExtension( 'gltf10' ),
        2: Registry.instance().getReaderWriterForExtension( 'gltf20' )
    };
    this._gltfReader = undefined;
};

var GLBHeader = function () {
    this.magic = ''; // is the ASCII string 'glTF', and can be used to identify the arraybuffer as Binary glTF.
    this.version = 0; // is an uint32 that indicates the version of the Binary glTF container format
    this.length = 0; // is the total length of the Binary glTF, including header, content, and body, in bytes.
    this.contentLength = 0; // is the length, in bytes, of the glTF content. It must be greater than zero.
    this.contentFormat = 0; // specifies the format of the glTF content
};

var GLBModel = function () {
    this.header = new GLBHeader();
    this.json = undefined;
    this.binary = undefined;
};

ReaderWriterGLB.prototype = {

    readNodeURL: function ( url /*, options*/ ) {
        var self = this;
        var filePromise = requestFile( url, {
            responseType: 'arraybuffer'
        } );

        return filePromise.then( function ( file ) {
            return self.readBinaryArray( file );
        } );
    },

    readBinaryArray: function ( bufferArray, url ) {
        var model = new GLBModel();
        this.readHeader( bufferArray, model );
        this.readJson( bufferArray, model );
        this.readBuffers( bufferArray, model );
        this._gltfReader.init();
        this._gltfReader.setGLBModel( model );
        return this._gltfReader.readJSON( model.json, url );
    },

    readHeader: function ( bufferArray, model ) {

        this._decoder.setBuffer( bufferArray );

        model.header.magic = this._decoder.decodeStringArray( 4 );
        if ( model.header.magic !== 'glTF' ) {
            console.error( 'Invalid GLTF 3D Model.  Expected magic=glTF.  Read magic=' + model.header.magic );
            return;
        }

        model.header.version = this._decoder.getUint32Value();
        if ( model.header.version !== 1 && model.header.version !== 2 ) {
            console.error( 'Only GLTF version 1 & 2 is supported.  Version' + model.header.version + ' is not.' );
            throw 'gltf10';
        }
        this._gltfReader = this._gltfReaders[ model.header.version ];

        model.header.length = this._decoder.getUint32Value();
        model.header.contentLength = this._decoder.getUint32Value();
        model.header.contentFormat = this._decoder.getUint32Value();
    },

    readJson: function ( bufferArray, model ) {
        model.json = this._decoder.decodeStringArray( model.header.contentLength );
    },

    readBuffers: function ( bufferArray, model ) {
        var chunkHeaderLength = ( model.header.version === 1 ) ? 0 : 8;
        model.binary = bufferArray.slice( 20 + model.header.contentLength + chunkHeaderLength ); // 20 is just the size of the header
    },

};

Registry.instance().addReaderWriter( 'glb', new ReaderWriterGLB() );

module.exports = ReaderWriterGLB;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterGLTF.js":
/*!**************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterGLTF.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ReaderWriterGLTF; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizPlugins_BinaryDecoder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizPlugins/BinaryDecoder */ "./sources/pcvizPlugins/BinaryDecoder.js");
/* harmony import */ var pcvizPlugins_BinaryDecoder__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizPlugins_BinaryDecoder__WEBPACK_IMPORTED_MODULE_2__);




const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;
const osgAnimation = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgAnimation;

const requestFile = osgDB.requestFile.js;
const Input = osgDB.Input;
const animation = osgAnimation.animation;
const StackedTranslate = osgAnimation.StackedTranslate;
const StackedQuaternion = osgAnimation.StackedQuaternion;
const StackedScale = osgAnimation.StackedScale;
const FileHelper = osgDB.FileHelper;
const BlendFunc = osg.BlendFunc;

const Texture = osg.Texture;
const BufferArray = osg.BufferArray;
const UpdateBone = osgAnimation.UpdateBone;
const UpdateMatrixTransform = osgAnimation.UpdateMatrixTransform;

const Uniform = osg.Uniform;

const vec3 = osg.vec3;
const quat = osg.quat;
const mat4 = osg.mat4;

/**
 * This class is used as parent refactor for GLTF plugins with different versions.
 * This class implements some common methods to use for each class that extends from this.
 * @name  ReaderWriterGLTF
 * @memberof pcvizPlugins
 */
class ReaderWriterGLTF {
    constructor() {
        // Contains all the needed glTF files (.gltf, .bin, etc...)
        this._filesMap = undefined;
        this._loadedFiles = undefined;
        this._bufferViewCache = undefined;
        this._basicAnimationManager = undefined;
        this._visitedNodes = undefined;
        this._animatedNodes = undefined;
        this._skeletons = undefined;
        this._bones = undefined;
        this._skeletonToInfluenceMap = undefined;
        this._inputImgReader = undefined;
        this._localPath = '';
        this._glbModel = undefined;
        this.init();
    }

    init() {

        this._glTFJSON = undefined;
        this._bufferViewCache = {};
        this._basicAnimationManager = undefined;
        this._localPath = '';
        this._visitedNodes = {};
        this._animatedNodes = {};
        this._skeletons = {};
        this._bones = {};
        this._skeletonToInfluenceMap = {};
        this._stateSetMap = {};
        this._filesMap = new window.Map();
        this._inputReader = new Input();

        this._decoder = new pcvizPlugins_BinaryDecoder__WEBPACK_IMPORTED_MODULE_2___default.a();
        this._decoder.setLittleEndian( true );
    }

    setGLBModel( glbModel ) {
        this._glbModel = glbModel;
    }

    loadFile( uri ) {
        return new Promise( ( resolve, reject ) => {

            if ( this._filesMap.has( uri ) ) {
                resolve( this._filesMap.get( uri ) );
                return;
            }

            if ( ( uri === undefined || uri === 'data:,' ) && this._glbModel !== undefined ) {
                resolve( this._glbModel.binary );
                return;
            }

            const ext = uri.substring( uri.lastIndexOf( '.' ) + 1 );
            const fileType = FileHelper.getTypeForExtension( ext );

            let promiseFile;
            const url = this._localPath + uri;
            if ( fileType === 'blob' ) {
                promiseFile = this._inputReader.readImageURL( url, {
                    imageLoadingUsePromise: true
                } );
            } else if ( fileType === 'arraybuffer' ) {
                promiseFile = this._inputReader.readBinaryArrayURL( url, {
                    fileType: fileType
                } );
            }

            this._filesMap.set( uri, promiseFile );

            promiseFile.then( ( file ) => {
                resolve( file );
            }, reject );
        } );
    }

    /**
     * Loads a osg.BufferArray from a TypeArray obtained by using a glTF accessor.
     * No memory allocation is done, the result is a subarray obtained from a glTF binary file
     * @param  {Object} accessor
     * @param  {osg.BufferArray.ARRAY_BUFFER | osg.BufferArray.ELEMENT_ARRAY_BUFFER} type WebGL buffer type
     * @param  {TypedArray} BufferType specific TypedArray type used for extraction
     * @return {osg.BufferArray} OSG readable buffer contaning the extracted data
     */
    loadAccessorBuffer( accessor, type ) {
        const json = this._glTFJSON;
        const bufferView = json.bufferViews[ accessor.bufferView ];
        const buffer = json.buffers[ bufferView.buffer ];
        const filePromise = this.loadFile( buffer.uri );
        return filePromise.then( ( data ) => {
            return this.assignBuffers( data, accessor, type, bufferView );
        } );
    }

    assignBuffers( data, accessor, type, bufferView ) {
        return new Promise( ( resolve ) => {
            if ( !data ) {
                resolve();
                return;
            }

            const TypedArray = ReaderWriterGLTF.WEBGL_COMPONENT_TYPES[ accessor.componentType ];
            let typedArray = null;

            if ( !this._bufferViewCache[ accessor.bufferView ] )
                this._bufferViewCache[ accessor.bufferView ] = data.slice( bufferView.byteOffset, bufferView.byteOffset + bufferView.byteLength );

            const bufferViewArray = this._bufferViewCache[ accessor.bufferView ];
            typedArray = new TypedArray( bufferViewArray, accessor.byteOffset, accessor.count * ReaderWriterGLTF.TYPE_TABLE[ accessor.type ] );

            if ( type ) {
                resolve( new BufferArray( type, typedArray, ReaderWriterGLTF.TYPE_TABLE[ accessor.type ], true ) );
                return;
            }
            resolve( typedArray );
        } );
    }

    registerUpdateCallback( callbackName, node ) {

        const json = this._glTFJSON;

        let animationCallback = null;
        if ( json.nodes[ callbackName ].jointName )
            animationCallback = new UpdateBone();
        else
            animationCallback = new UpdateMatrixTransform();

        animationCallback.setName( callbackName );

        const translation = vec3.create();
        mat4.getTranslation( translation, node.getMatrix() );

        const rotationQuat = quat.create();
        mat4.getRotation( rotationQuat, node.getMatrix() );

        const scale = vec3.create();
        mat4.getScale( scale, node.getMatrix() );

        animationCallback.getStackedTransforms().push( new StackedTranslate( 'translation', translation ) );
        animationCallback.getStackedTransforms().push( new StackedQuaternion( 'rotation', rotationQuat ) );
        animationCallback.getStackedTransforms().push( new StackedScale( 'scale', scale ) );

        node.addUpdateCallback( animationCallback );
    }

    createTextureAndSetAttribFromBuffer( buffer, stateSet, location, format, uniform ) {
        return new Promise( ( resolve, reject ) => {
            if ( !buffer ) {
                reject();
                return;
            }
            const texture = new Texture();
            // GLTF texture origin is correct
            texture.setFlipY( false );
            texture.setWrapS( 'REPEAT' );
            texture.setWrapT( 'REPEAT' );


            this._inputReader.readImageURL( buffer ).then( ( data ) => {
                texture.setImage( data, format );
                stateSet.setTextureAttributeAndModes( location, texture );
                if ( uniform ) {
                    stateSet.addUniform( Uniform.createInt( location, uniform ) );
                }

                resolve();
            }, reject );
        } );
    }

    /**
     * Creates a MatrixTransform node by using
     * glTF node's properties (matrix, translation, rotation, scale)
     * @param  {Object} glTFNode glTF node
     * @return {OSG.MatrixTransform} MatrixTransform node containing the glTF node transform
     */
    loadTransform( glTFNode ) {
        const mat = mat4.create();
        // The transform is given under a matrix form
        if ( glTFNode.matrix ) {
            mat4.copy( mat, glTFNode.matrix );
            return mat;
        }
        // The transform is given under the form
        // translation, rotation, scale
        const scale = glTFNode.scale || vec3.ONE;
        const rot = glTFNode.rotation || quat.IDENTITY;
        const trans = glTFNode.translation || vec3.ZERO;

        mat4.fromRotationTranslationScale( mat, rot, trans, scale );
        return mat;
    }

    createAnimationFromChannels( channelsPromiseArray, animName ) {
        return Promise.all( channelsPromiseArray ).then( ( channels ) => {
            return animation.createAnimation( channels, animName );
        } );
    }

    loadPBRMaterial( materialId, glTFmaterial, geometryNode, extension ) {
        return new Promise( ( resolve, reject ) => {
            const pbrMetallicRoughness = glTFmaterial.pbrMetallicRoughness;
            const osgStateSet = geometryNode.getOrCreateStateSet();

            const promises = [];

            let model = '';
            if ( pbrMetallicRoughness ) {
                if ( pbrMetallicRoughness.baseColorTexture )
                    promises.push( this.createTextureAndSetAttrib( pbrMetallicRoughness.baseColorTexture, osgStateSet, ReaderWriterGLTF.ALBEDO_TEXTURE_UNIT, ReaderWriterGLTF.ALBEDO_UNIFORM ) );
                if ( pbrMetallicRoughness.metallicRoughnessTexture )
                    promises.push( this.createTextureAndSetAttrib( pbrMetallicRoughness.metallicRoughnessTexture, osgStateSet, ReaderWriterGLTF.METALLIC_ROUGHNESS_TEXTURE_UNIT, ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM ) );
                model = ReaderWriterGLTF.PBR_METAL_MODE;
            }
            if ( extension ) {
                if ( extension.diffuseTexture ) {
                    promises.push( this.createTextureAndSetAttrib( extension.diffuseTexture, osgStateSet, ReaderWriterGLTF.DIFFUSE_TEXTURE_UNIT, ReaderWriterGLTF.ALBEDO_UNIFORM ) );
                }
                if ( extension.specularGlossinessTexture ) {
                    promises.push( this.createTextureAndSetAttrib( extension.specularGlossinessTexture, osgStateSet, ReaderWriterGLTF.SPECULAR_GLOSSINESS_TEXTURE_UNIT, ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM ) );
                }
                model = ReaderWriterGLTF.PBR_SPEC_MODE;
            }
            if ( glTFmaterial.normalTexture )
                promises.push( this.createTextureAndSetAttrib( glTFmaterial.normalTexture, osgStateSet, ReaderWriterGLTF.NORMAL_TEXTURE_UNIT, ReaderWriterGLTF.NORMAL_UNIFORM ) );
            if ( glTFmaterial.occlusionTexture )
                promises.push( this.createTextureAndSetAttrib( glTFmaterial.occlusionTexture, osgStateSet, ReaderWriterGLTF.AO_TEXTURE_UNIT, ReaderWriterGLTF.AO_UNIFORM ) );

            geometryNode.setUserData( {
                pbrWorklow: model
            } );

            geometryNode.stateset = osgStateSet;
            osgStateSet.setRenderingHint( 'TRANSPARENT_BIN' );
            osgStateSet.setRenderBinDetails( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.RENDERBIN_3DMODEL, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.RENDERBIN_3DMODEL_TYPE );
            osgStateSet.setAttributeAndModes( new BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );
            this._stateSetMap[ materialId ] = osgStateSet;

            Promise.all( promises ).then( () => {
                resolve();
            }, reject );
        } );
    }

    loadGLTFPrimitives( meshId, resultMeshNode, skeletonJointId ) {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;
            const mesh = json.meshes[ meshId ];

            const primitives = mesh.primitives;

            const promisesArray = [];

            for ( let i = 0; i < primitives.length; ++i ) {

                const primitive = primitives[ i ];
                const promiseGeom = this.createGeometry( primitive, skeletonJointId );

                promisesArray.push( promiseGeom );

            }

            Promise.all( promisesArray ).then( ( geoms ) => {

                for ( let i = 0; i < geoms.length; ++i )
                    resultMeshNode.addChild( geoms[ i ] );

                resolve( geoms );
            }, reject );
        } );
    }

    readNodeURL( url, options ) {
        return new Promise( ( resolve, reject ) => {
            this.init();
            if ( options && options.filesMap !== undefined && options.filesMap.size > 0 ) {
                // it comes from the ZIP plugin or from drag'n drop
                // So we already have all the files.
                this._filesMap = options.filesMap;
                const glTFFile = this._filesMap.get( url );
                return this.readJSON( glTFFile, url ).then( ( root ) => {
                    resolve( root );
                }, reject );
            }

            const index = url.lastIndexOf( '/' );
            this._localPath = ( index === -1 ) ? '' : url.substring( 0, index + 1 );
            // Else it is a usual XHR request
            const filePromise = requestFile( url );
            filePromise.then( ( glTFFile ) => {
                this.readJSON( glTFFile ).then( ( root ) => {
                    resolve( root );
                } );
            }, reject );
        } );
    }

    findByKey() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.findByKey )' );
    }

    createTextureAndSetAttrib() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.createTextureAndSetAttrib )' );
    }

    preprocessChannel() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.preprocessChannel )' );
    }

    preprocessAnimations() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.preprocessAnimations )' );
    }

    loadBone() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.loadBone )' );
    }

    buildInfluenceMap() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.buildInfluenceMap )' );
    }

    mapBonesToSkin() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.mapBonesToSkin )' );
    }

    preprocessBones() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.preprocessBones )' );
    }

    preprocessSkeletons() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.preprocessSkeletons )' );
    }

    loadMaterial() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.loadMaterial )' );
    }

    createGeometry() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.createGeometry )' );
    }

    loadGLTFNode() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.loadGLTFNode )' );
    }

    readJSON() {
        console.error( 'Error: not implemented. ( ReaderWriterGLTF.readJSON )' );
    }
}

ReaderWriterGLTF.WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};

ReaderWriterGLTF.TYPE_TABLE = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};

ReaderWriterGLTF.TEXTURE_FORMAT = {
    6406: Texture.ALPHA,
    6407: Texture.RGB,
    6408: Texture.RGBA,
    6409: Texture.LUMINANCE,
    6410: Texture.LUMINANCE_ALPHA
};

ReaderWriterGLTF.PBR_SPEC_EXT = 'KHR_materials_pbrSpecularGlossiness';
ReaderWriterGLTF.PBR_SPEC_MODE = 'PBR_specular_glossiness';
ReaderWriterGLTF.PBR_METAL_MODE = 'PBR_metal_roughness';

ReaderWriterGLTF.ALBEDO_TEXTURE_UNIT = 2;
ReaderWriterGLTF.DIFFUSE_TEXTURE_UNIT = 2;
ReaderWriterGLTF.SPECULAR_GLOSSINESS_TEXTURE_UNIT = 3;
ReaderWriterGLTF.METALLIC_ROUGHNESS_TEXTURE_UNIT = 3;
ReaderWriterGLTF.SPECULAR_TEXTURE_UNIT = 4;
ReaderWriterGLTF.NORMAL_TEXTURE_UNIT = 5;
ReaderWriterGLTF.AO_TEXTURE_UNIT = 6;
ReaderWriterGLTF.EMISSIVE_TEXTURE_UNIT = 7;

ReaderWriterGLTF.ALBEDO_UNIFORM = 'albedoMap';
ReaderWriterGLTF.METALLIC_ROUGHNESS_UNIFORM = 'metallicRoughnessMap';
ReaderWriterGLTF.SPECULAR_UNIFORM = 'specularMap';
ReaderWriterGLTF.NORMAL_UNIFORM = 'normalMap';
ReaderWriterGLTF.AO_UNIFORM = 'aoMap';
ReaderWriterGLTF.EMISSIVE_UNIFORM = 'emissiveMap';


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterGLTF10.js":
/*!****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterGLTF10.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ReaderWriterGLTF10; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterGLTF */ "./sources/pcvizPlugins/ReaderWriterGLTF.js");




const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;
const osgAnimation = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgAnimation;

const Registry = osgDB.Registry;
const BasicAnimationManager = osgAnimation.BasicAnimationManager;
const Skeleton = osgAnimation.Skeleton;
const Bone = osgAnimation.Bone;
const RigGeometry = osgAnimation.RigGeometry;
const Channel = osgAnimation.Channel;
const createQuatChannel = Channel.createQuatChannel;
const createVec3Channel = Channel.createVec3Channel;

const Geometry = osg.Geometry;
const Texture = osg.Texture;
const MatrixTransform = osg.MatrixTransform;
const Material = osg.Material;
const DrawElements = osg.DrawElements;
const primitiveSet = osg.primitiveSet;
const BufferArray = osg.BufferArray;

const Uniform = osg.Uniform;

const mat4 = osg.mat4;

class ReaderWriterGLTF10 extends pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"] {

    constructor() {
        super();
    }

    findByKey( obj, key ) {
        if ( !obj )
            return null;
        const keys = window.Object.keys( obj );
        for ( let i = 0; i < keys.length; ++i ) {
            if ( keys[ i ] === key )
                return obj[ keys[ i ] ];
        }
        return null;
    }

    createTextureAndSetAttrib( glTFTextureObject, stateSet, location, uniform ) {
        return new Promise( ( resolve, reject ) => {
            if ( !glTFTextureObject ) {
                resolve();
                return;
            }
            const json = this._glTFJSON;
            const glTFTexture = json.textures[ glTFTextureObject.index ];
            if ( !glTFTexture ) {
                resolve();
                return;
            }

            const image = json.images[ glTFTexture.source ];

            if ( !image ) {
                resolve();
                return;
            }
            const texture = new Texture();
            // GLTF texture origin is correct
            texture.setFlipY( false );
            texture.setWrapS( 'REPEAT' );
            texture.setWrapT( 'REPEAT' );

            this.loadFile( image.uri ).then( ( data ) => {
                if ( !data ) {
                    resolve();
                    return;
                }
                texture.setImage( data, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TEXTURE_FORMAT[ glTFTexture.format ] );
                stateSet.setTextureAttributeAndModes( location, texture );
                if ( uniform ) {
                    stateSet.addUniform( Uniform.createInt( location, uniform ) );
                }
                resolve();
            }, reject );
        } );
    }

    preprocessChannel( glTFChannel, glTFAnim ) {

        const json = this._glTFJSON;
        const promisesArray = [];

        const glTFSampler = glTFAnim.samplers[ glTFChannel.sampler ];

        const timeAccessor = json.accessors[ glTFSampler.input ];
        const valueAccessor = json.accessors[ glTFSampler.output ];

        const timePromise = this.loadAccessorBuffer( timeAccessor, null );
        const valuePromise = this.loadAccessorBuffer( valueAccessor, null );

        promisesArray.push( timePromise, valuePromise );

        return Promise.all( promisesArray ).then( ( timeAndValue ) => {

            const timeKeys = timeAndValue[ 0 ];
            const valueKeys = timeAndValue[ 1 ];

            let osgChannel = null;

            if ( pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TYPE_TABLE[ valueAccessor.type ] === 4 ) {

                osgChannel = createQuatChannel( valueKeys, timeKeys, glTFChannel.target.id, glTFSampler.output, null );

            } else if ( pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TYPE_TABLE[ valueAccessor.type ] === 3 ) {

                osgChannel = createVec3Channel( valueKeys, timeKeys, glTFChannel.target.id, glTFSampler.output, null );

            }

            this._animatedNodes[ glTFChannel.target.id ] = true;

            return osgChannel;

        } );
    }

    /**
     * Loads all the solid animations registering
     * them in a BasicAnimationManager instance
     * @return {BasicAnimationManager} the animation manager containing the animations
     */
    preprocessAnimations() {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;

            if ( !json.animations ) {
                resolve();
                return;
            }

            const animPromiseArray = [];

            const animationsObjectKeys = window.Object.keys( json.animations );
            for ( let i = 0; i < animationsObjectKeys.length; ++i ) {

                const glTFAnim = json.animations[ animationsObjectKeys[ i ] ];

                const channelsPromiseArray = [];
                // Creates each OSGJS channel
                for ( let j = 0; j < glTFAnim.channels.length; ++j ) {

                    const glTFChannel = glTFAnim.channels[ j ];

                    const osgChannel = this.preprocessChannel( glTFChannel, glTFAnim );
                    channelsPromiseArray.push( osgChannel );
                }

                const animPromise = this.createAnimationFromChannels( channelsPromiseArray, animationsObjectKeys[ i ] );
                animPromiseArray.push( animPromise );
            }

            Promise.all( animPromiseArray ).then( ( animations ) => {

                const animationManager = new BasicAnimationManager();
                animationManager.init( animations );

                this._basicAnimationManager = animationManager;

                resolve();
            }, reject );

        } );
    }

    loadBone( boneId, skin ) {

        const json = this._glTFJSON;
        const node = json.nodes[ boneId ];

        const inverseBindMatricesAccessor = json.accessors[ skin.inverseBindMatrices ];
        const bonePromise = this.loadAccessorBuffer( inverseBindMatricesAccessor, null );
        return bonePromise.then( ( data ) => {

            // Creates the current bone
            // initializing it with initial pose
            let i;
            for ( i = 0; i < skin.jointNames.length; ++i ) {

                if ( skin.jointNames[ i ] === node.jointName ) break;

            }

            const boneNode = new Bone( node.jointName );
            const invMat = data.subarray( i * 16, i * 16 + 16 );
            boneNode.setInvBindMatrixInSkeletonSpace( invMat );

            this._bones[ boneId ] = boneNode;

            return boneNode;
        } );

    }

    buildInfluenceMap( rootBoneId, skin ) {

        if ( this._skeletonToInfluenceMap[ rootBoneId ] )
            return;
        this._skeletonToInfluenceMap[ rootBoneId ] = {};
        for ( let j = 0; j < skin.jointNames.length; j++ ) {
            const jointName = skin.jointNames[ j ];
            this._skeletonToInfluenceMap[ rootBoneId ][ jointName ] = j;
        }
    }

    mapBonesToSkin() {

        const json = this._glTFJSON;

        const boneToSkin = {};

        // Maps each bone ID to its skin
        const skinsKeys = window.Object.keys( json.skins );
        for ( let i = 0; i < skinsKeys.length; ++i ) {

            const skin = json.skins[ skinsKeys[ i ] ];

            for ( let j = 0; j < skin.jointNames.length; ++j ) {

                const jName = skin.jointNames[ j ];

                const nodesKeys = window.Object.keys( json.nodes );
                for ( let k = 0; k < nodesKeys.length; ++k ) {

                    const node = json.nodes[ nodesKeys[ k ] ];

                    if ( node.jointName && node.jointName === jName )
                        boneToSkin[ nodesKeys[ k ] ] = skin;
                }
            }

        }

        return boneToSkin;

    }

    preprocessBones( bonesToSkin ) {

        const json = this._glTFJSON;
        const nodesKeys = window.Object.keys( json.nodes );
        const promises = [];
        for ( let i = 0; i < nodesKeys.length; ++i ) {
            const boneId = nodesKeys[ i ];
            const boneNode = json.nodes[ boneId ];
            if ( !boneNode.jointName )
                continue;
            const bonePromise = this.loadBone( boneId, bonesToSkin[ boneId ] );
            promises.push( bonePromise );
        }
        return Promise.all( promises );
    }

    preprocessSkeletons() {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;
            if ( !json.skins ) {
                resolve();
                return;
            }
            const bonesToSkin = this.mapBonesToSkin();

            // Saves each skeleton in the skeleton maprep
            const nodesKeys = window.Object.keys( json.nodes );
            for ( let j = 0; j < nodesKeys.length; ++j ) {

                const nodeId = nodesKeys[ j ];
                const node = json.nodes[ nodeId ];
                const skin = json.skins[ node.skin ];

                if ( !node.skeletons )
                    continue;

                for ( let i = 0; i < node.skeletons.length; ++i ) {
                    let rootBoneId = null;
                    const rootJointId = node.skeletons[ i ];
                    for ( let k = 0; k < nodesKeys.length; ++k ) {
                        const subnodeId = nodesKeys[ k ];
                        const subnode = json.nodes[ subnodeId ];
                        if ( !subnode.jointName )
                            continue;
                        if ( subnode.jointName === rootJointId ) {
                            rootBoneId = subnodeId;
                            break;
                        }
                    }
                    if ( rootBoneId && !this._skeletons[ rootBoneId ] ) {
                        this._skeletons[ rootJointId ] = new Skeleton();
                        // Adds missing bone to the boneMap
                        bonesToSkin[ rootBoneId ] = skin;
                    }
                    this.buildInfluenceMap( rootJointId, skin );
                }
            }

            this.preprocessBones( bonesToSkin ).then( () => {
                resolve();
            }, reject );
        } );
    }

    loadMaterial( materialId, geometryNode ) {
        return new Promise( ( resolve, reject ) => {

            const json = this._glTFJSON;
            const glTFmaterial = json.materials[ materialId ];

            if ( this._stateSetMap[ materialId ] ) {
                geometryNode.stateset = this._stateSetMap[ materialId ];
                resolve();
                return;
            }

            const extension = this.findByKey( glTFmaterial.extensions, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].PBR_SPEC_EXT );
            if ( glTFmaterial.pbrMetallicRoughness || extension )
                return this.loadPBRMaterial( materialId, glTFmaterial, geometryNode, extension ).then( () => {
                    resolve();
                }, reject );

            const values = glTFmaterial.values;

            // Handles basic material attributes
            const osgMaterial = new Material();
            const osgStateSet = geometryNode.getOrCreateStateSet();
            osgStateSet.setAttribute( osgMaterial );

            if ( values.ambient )
                osgMaterial.setAmbient( values.ambient );
            if ( values.emission )
                osgMaterial.setEmission( values.emission );
            if ( values.shininess )
                osgMaterial.setShininess( values.shininess );
            if ( values.specular )
                osgMaterial.setSpecular( values.specular );

            osgMaterial.setAmbient( [ 2, 2, 2, 255 ] );
            // osgMaterial.setEmission( values.emission );
            // osgMaterial.setShininess( values.shininess );
            // osgMaterial.setSpecular( values.specular );
            // Create a texture for the diffuse, if any
            if ( values.diffuse ) {

                if ( typeof ( values.diffuse ) !== 'string' )
                    osgMaterial.setDiffuse( values.diffuse );
                else
                    return this.createTextureAndSetAttrib( values.diffuse, osgStateSet, 0 ).then( () => {
                        resolve();
                    }, reject );
            }

            if ( values.tex ) {
                const texture = json.textures[ values.tex ];
                const image = json.images[ texture.source ];
                const bufferView = json.bufferViews[ image.extensions[ 'KHR_binary_glTF' ].bufferView ];

                this._decoder.setBuffer( this._glbModel.binary );
                this._decoder.setOffset( bufferView.byteOffset );

                let base64 = this._decoder.decodeStringArray( bufferView.byteLength );
                base64 = 'data:' + image.extensions[ 'KHR_binary_glTF' ].mimeType + ';base64,' + btoa( base64 );

                this.createTextureAndSetAttribFromBuffer( base64, osgStateSet, 0, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TEXTURE_FORMAT[ texture.format ] ).then( () => {
                    resolve();
                }, reject );
            } else {

                geometryNode.stateset = osgStateSet;
                this._stateSetMap[ materialId ] = osgStateSet;

                resolve();
            }
        } );

    }

    createGeometry( primitive, skeletonJointId ) {

        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;
            const promisesArray = [];

            // Builds the geometry from the extracted vertices & normals
            const geom = new Geometry();
            let rigOrGeom = geom;

            const cbSetBuffer = function ( name, buffer ) {

                if ( !buffer )
                    return;

                this.getVertexAttributeList()[ name ] = buffer;

            };

            if ( skeletonJointId ) {

                rigOrGeom = new RigGeometry();
                rigOrGeom._boneNameID = this._skeletonToInfluenceMap[ skeletonJointId ];

            }

            const attributeWeight = ( data ) => {

                if ( !data )
                    return;

                rigOrGeom.getAttributes().Weights = data;

                const elts = rigOrGeom.getAttributes().Weights.getElements();
                for ( let i = 0, l = elts.length / 4; i < l; ++i ) {
                    const sum = elts[ i * 4 ] + elts[ i * 4 + 1 ] + elts[ i * 4 + 2 ] + elts[ i * 4 + 3 ];
                    const correc = 1.0 / sum;
                    elts[ i * 4 ] *= correc;
                    elts[ i * 4 + 1 ] *= correc;
                    elts[ i * 4 + 2 ] *= correc;
                    elts[ i * 4 + 3 ] *= correc;
                }

            };

            // Registers each glTF primitive attributes
            // into a respective geometry attribute
            const attributesKeys = window.Object.keys( primitive.attributes );
            for ( let i = 0; i < attributesKeys.length; ++i ) {

                const accessor = json.accessors[ primitive.attributes[ attributesKeys[ i ] ] ];
                const promise = this.loadAccessorBuffer( accessor, BufferArray.ARRAY_BUFFER );

                if ( attributesKeys[ i ].indexOf( 'POSITION' ) !== -1 ) {

                    promise.then( cbSetBuffer.bind( geom, 'Vertex' ) );

                } else if ( attributesKeys[ i ].indexOf( 'NORMAL' ) !== -1 ) {

                    promise.then( cbSetBuffer.bind( geom, 'Normal' ) );

                } else if ( attributesKeys[ i ].indexOf( 'TANGENT' ) !== -1 ) {

                    promise.then( cbSetBuffer.bind( geom, 'Tangent' ) );

                } else if ( attributesKeys[ i ].indexOf( 'JOINT' ) !== -1 ) {

                    promise.then( cbSetBuffer.bind( rigOrGeom, 'Bones' ) );

                } else if ( attributesKeys[ i ].indexOf( 'WEIGHT' ) !== -1 ) {

                    promise.then( attributeWeight );

                } else if ( attributesKeys[ i ].indexOf( 'TEXCOORD' ) !== -1 ) {

                    const texCoordId = attributesKeys[ i ].substring( 9 );
                    promise.then( cbSetBuffer.bind( geom, 'TexCoord' + texCoordId ) );

                }

                promisesArray.push( promise );

            }

            const indicesAccessor = json.accessors[ primitive.indices ];
            const indicesPromise = this.loadAccessorBuffer( indicesAccessor, BufferArray.ELEMENT_ARRAY_BUFFER );
            indicesPromise.then( ( data ) => {

                if ( !data )
                    return;

                const osgPrimitive = new DrawElements( primitiveSet.TRIANGLES, data );
                geom.getPrimitives().push( osgPrimitive );

            } );

            promisesArray.push( indicesPromise );

            if ( primitive.material !== undefined )
                promisesArray.push( this.loadMaterial( primitive.material, geom ) );

            Promise.all( promisesArray ).then( () => {
                if ( skeletonJointId ) {

                    rigOrGeom.setSourceGeometry( geom );
                    rigOrGeom.mergeChildrenData();

                    rigOrGeom.computeBoundingBox = geom.computeBoundingBox;
                }

                resolve( rigOrGeom );

            }, reject );

        } );

    }

    loadGLTFNode( nodeId, root ) {
        return new Promise( ( resolve, reject ) => {
            if ( this._visitedNodes[ nodeId ] ) {
                resolve();
                return;
            }

            const json = this._glTFJSON;
            const glTFNode = json.nodes[ nodeId ];

            const currentNode = ( glTFNode.jointName ) ? this._bones[ nodeId ] : new MatrixTransform();
            currentNode.setName( nodeId );
            mat4.copy( currentNode.getMatrix(), this.loadTransform( glTFNode ) );

            if ( glTFNode.jointName && this._skeletons[ glTFNode.joinName ] ) {
                const skeleton = this._skeletons[ glTFNode.jointName ];
                skeleton.addChild( currentNode );
                root.addChild( skeleton );
            }

            // Recurses on children before
            // processing the current node
            const children = glTFNode.children;
            let i;
            const promises = [];
            if ( children ) {
                for ( i = 0; i < children.length; ++i ) {
                    const nodePromise = this.loadGLTFNode( children[ i ], currentNode );
                    promises.push( nodePromise );
                }
            }
            // Loads meshes contained in the node
            // Adds RigGeometry to corresponding skeleton if any
            if ( glTFNode.meshes ) {
                for ( i = 0; i < glTFNode.meshes.length; ++i ) {
                    const meshId = glTFNode.meshes[ i ];
                    if ( !glTFNode.skeletons ) {
                        const geomPromise = this.loadGLTFPrimitives( meshId, currentNode, null );
                        promises.push( geomPromise );
                        continue;
                    }

                    for ( let j = 0; j < glTFNode.skeletons.length; ++j ) {
                        const rootJointId = glTFNode.skeletons[ j ];
                        const skeletonNode = this._skeletons[ rootJointId ];
                        const meshTransformNode = new MatrixTransform();
                        mat4.copy( meshTransformNode.getMatrix(), currentNode.getMatrix() );
                        const geomP = this.loadGLTFPrimitives( meshId, meshTransformNode, rootJointId );
                        skeletonNode.addChild( meshTransformNode );
                        promises.push( geomP );
                    }
                }
            }
            // Loads solid animations
            // by adding an update callback
            if ( this._animatedNodes[ nodeId ] )
                this.registerUpdateCallback( nodeId, currentNode );

            if ( !this._skeletons[ nodeId ] )
                root.addChild( currentNode );

            this._visitedNodes[ nodeId ] = true;
            Promise.all( promises ).then( () => {
                resolve();
            }, reject );
        } );
    }

    readJSON( glTFFile, url ) {
        return new Promise( ( resolve, reject ) => {
            // Creates the root node
            // adding a PI / 2 rotation arround the X-axis
            const root = new MatrixTransform();
            root.setName( url );

            if ( glTFFile === '' ) {
                console.log( 'not valid json' );
                resolve();
                return;
            }
            const json = JSON.parse( glTFFile );
            if ( !json ) {
                resolve();
                return;
            }

            this._glTFJSON = json;

            const promisesArray = [];
            // Preprocesses animations
            const animPromise = this.preprocessAnimations();
            // Preprocesses skin animations if any
            const skeletonPromise = this.preprocessSkeletons();

            promisesArray.push( skeletonPromise, animPromise );
            Promise.all( promisesArray ).then( () => {

                const promises = [];
                // Loops through each scene
                // loading geometry nodes, transform nodes, etc...s
                const sceneKeys = window.Object.keys( json.scenes );
                for ( let i = 0; i < sceneKeys.length; ++i ) {

                    const scene = json.scenes[ sceneKeys[ i ] ];

                    if ( !scene )
                        continue;
                    for ( let j = 0; j < scene.nodes.length; ++j ) {
                        const p = this.loadGLTFNode( scene.nodes[ j ], root );
                        promises.push( p );
                    }
                }

                // Register the animation manager
                // if the glTF file contains animations
                if ( this._basicAnimationManager )
                    root.addUpdateCallback( this._basicAnimationManager );

                Promise.all( promises ).then( () => {
                    resolve( root );
                } );

            }, reject );
        } );
    }

}

Registry.instance().addReaderWriter( 'gltf10', new ReaderWriterGLTF10() );


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterGLTF20.js":
/*!****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterGLTF20.js ***!
  \****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ReaderWriterGLTF20; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterGLTF */ "./sources/pcvizPlugins/ReaderWriterGLTF.js");




const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;
const osgAnimation = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgAnimation;

const Registry = osgDB.Registry;
const BasicAnimationManager = osgAnimation.BasicAnimationManager;
const Skeleton = osgAnimation.Skeleton;
const Bone = osgAnimation.Bone;
const RigGeometry = osgAnimation.RigGeometry;
const Channel = osgAnimation.Channel;
const createQuatChannel = Channel.createQuatChannel;
const createVec3Channel = Channel.createVec3Channel;

const Geometry = osg.Geometry;
const Texture = osg.Texture;
const MatrixTransform = osg.MatrixTransform;
const Material = osg.Material;
const DrawElements = osg.DrawElements;
const primitiveSet = osg.primitiveSet;
const BufferArray = osg.BufferArray;

const Uniform = osg.Uniform;

const mat4 = osg.mat4;

class ReaderWriterGLTF20 extends pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"] {

    constructor() {
        super();
    }

    findByKey( obj, key ) {
        if ( !obj )
            return null;
        return obj[ key ];
    }

    createTextureAndSetAttrib( glTFTextureObject, stateSet, location, uniform ) {
        return new Promise( ( resolve, reject ) => {
            if ( !glTFTextureObject ) {
                resolve();
                return;
            }
            const json = this._glTFJSON;
            const glTFTexture = json.textures[ glTFTextureObject.index ];
            if ( !glTFTexture ) {
                resolve();
                return;
            }

            const image = json.images[ glTFTexture.source ];

            if ( !image ) {
                resolve();
                return;
            }

            const texture = new Texture();
            // GLTF texture origin is correct
            texture.setFlipY( false );
            texture.setWrapS( 'REPEAT' );
            texture.setWrapT( 'REPEAT' );

            if ( image.uri !== undefined ) {
                this.loadFile( image.uri ).then( ( data ) => {
                    if ( !data ) {
                        resolve();
                        return;
                    }
                    texture.setImage( data, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TEXTURE_FORMAT[ 6408 ] ); // TODO: as default RGBA, but how we know which kind of format is?
                    stateSet.setTextureAttributeAndModes( location, texture );
                    if ( uniform ) {
                        stateSet.addUniform( Uniform.createInt( location, uniform ) );
                    }
                    resolve();
                    return;
                }, reject );
            }

            if ( image.bufferView !== undefined ) {
                const bufferView = json.bufferViews[ image.bufferView ];

                this._decoder.setBuffer( this._glbModel.binary );
                this._decoder.setOffset( bufferView.byteOffset );

                let buffer = this._decoder.decodeStringArray( bufferView.byteLength );
                buffer = 'data:' + image.mimeType + ';base64,' + btoa( buffer );

                const format = ( image.mimeType === 'image/jpeg' ) ? 6407 : 6408;
                return this.createTextureAndSetAttribFromBuffer( buffer, stateSet, 0, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TEXTURE_FORMAT[ format ] ).then( () => {
                    resolve();
                }, reject );
            }

        } );
    }

    preprocessChannel( glTFChannel, glTFAnim ) {
        const json = this._glTFJSON;
        const promisesArray = [];

        const glTFSampler = glTFAnim.samplers[ glTFChannel.sampler ];

        const timeAccessor = json.accessors[ glTFSampler.input ];
        const valueAccessor = json.accessors[ glTFSampler.output ];

        const timePromise = this.loadAccessorBuffer( timeAccessor, null );
        const valuePromise = this.loadAccessorBuffer( valueAccessor, null );

        promisesArray.push( timePromise, valuePromise );

        return Promise.all( promisesArray ).then( ( timeAndValue ) => {

            const timeKeys = timeAndValue[ 0 ];
            const valueKeys = timeAndValue[ 1 ];

            let osgChannel = null;

            if ( pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TYPE_TABLE[ valueAccessor.type ] === 4 ) {

                osgChannel = createQuatChannel( valueKeys, timeKeys, glTFChannel.target.node, glTFSampler.output, null );

            } else if ( pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].TYPE_TABLE[ valueAccessor.type ] === 3 ) {

                osgChannel = createVec3Channel( valueKeys, timeKeys, glTFChannel.target.node, glTFChannel.output, null );

            }

            this._animatedNodes[ glTFChannel.target.node ] = true;

            return osgChannel;
        } );
    }

    /**
     * Loads all the solid animations registering
     * them in a BasicAnimationManager instance
     * @return {BasicAnimationManager} the animation manager containing the animations
     */
    preprocessAnimations() {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;

            if ( !json.animations ) {
                resolve();
                return;
            }

            const animPromiseArray = [];

            for ( let i = 0; i < json.animations.length; ++i ) {
                const glTFAnim = json.animations[ i ];

                const channelsPromiseArray = [];
                // Creates each OSGJS channel
                for ( let j = 0; j < glTFAnim.channels.length; ++j ) {
                    const glTFChannel = glTFAnim.channels[ j ];

                    const osgChannel = this.preprocessChannel( glTFChannel, glTFAnim );
                    channelsPromiseArray.push( osgChannel );
                }

                const animPromise = this.createAnimationFromChannels(
                    channelsPromiseArray,
                    i
                );
                animPromiseArray.push( animPromise );
            }

            Promise.all( animPromiseArray ).then( ( animations ) => {
                const animationManager = new BasicAnimationManager();
                animationManager.init( animations );

                this._basicAnimationManager = animationManager;
                animationManager.playAnimation( animations[ 0 ].name );

                resolve();
            }, reject );

        } );
    }

    loadBone( boneId, skin ) {
        const json = this._glTFJSON;
        const node = json.nodes[ boneId ];

        const inverseBindMatricesAccessor = json.accessors[ skin.inverseBindMatrices ];
        const bonePromise = this.loadAccessorBuffer( inverseBindMatricesAccessor, null );
        return bonePromise.then( ( data ) => {
            // Creates the current bone
            // initializing it with initial pose
            let i;
            for ( i = 0; i < skin.joints.length; ++i ) {
                if ( skin.joints[ i ] === boneId ) break; // Skin joints refers to a node Id, in this case, boneId
            }

            const boneNode = new Bone( node.name );
            const invMat = data.subarray( i * 16, i * 16 + 16 );
            boneNode.setInvBindMatrixInSkeletonSpace( invMat );

            this._bones[ boneId ] = boneNode;

            return boneNode;
        } );
    }

    buildInfluenceMap( rootJointId, skin ) {
        if ( this._skeletonToInfluenceMap[ rootJointId ] ) return;
        this._skeletonToInfluenceMap[ rootJointId ] = {};
        this._skeletonToInfluenceMap[ rootJointId ] = skin.joints;
    }

    mapBonesToSkin() {
        const json = this._glTFJSON;

        const boneToSkin = {};

        // Maps each bone ID to its skin
        for ( let i = 0; i < json.skins.length; ++i ) {
            const skin = json.skins[ i ];

            for ( let j = 0; j < skin.joints.length; ++j ) {
                const jId = skin.joints[ j ];

                boneToSkin[ jId ] = skin;
            }
        }

        return boneToSkin;
    }

    preprocessBones( bonesToSkin ) {
        const json = this._glTFJSON;
        const promises = [];
        for ( let i = 0; i < json.skins.length; ++i ) {
            const skin = json.skins[ i ];

            for ( let j = 0; j < skin.joints.length; ++j ) {
                const boneId = skin.joints[ j ];
                const bonePromise = this.loadBone( boneId, bonesToSkin[ boneId ] );
                promises.push( bonePromise );
            }
        }
        return Promise.all( promises );
    }

    preprocessSkeletons() {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;
            if ( !json.skins ) {
                resolve();
                return;
            }
            const bonesToSkin = this.mapBonesToSkin();

            // Saves each skeleton in the skeleton maprep
            for ( let j = 0; j < json.skins.length; ++j ) {
                const skin = json.skins[ j ];

                if ( skin.skeleton !== undefined ) continue;

                const rootJointId = skin.skeleton;

                if ( !this._skeletons[ rootJointId ] ) {
                    this._skeletons[ rootJointId ] = new Skeleton();
                    // Adds missing bone to the boneMap
                    bonesToSkin[ rootJointId ] = skin;
                }
                this.buildInfluenceMap( rootJointId, skin );

            }

            this.preprocessBones( bonesToSkin ).then( () => {
                resolve();
            }, reject );
        } );
    }

    loadMaterial( materialId, geometryNode ) {
        const json = this._glTFJSON;
        const glTFmaterial = json.materials[ materialId ];

        if ( this._stateSetMap[ materialId ] ) {
            geometryNode.stateset = this._stateSetMap[ materialId ];
            return;
        }

        const extension = this.findByKey( glTFmaterial.extensions, pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_1__["default"].PBR_SPEC_EXT );
        if ( glTFmaterial.pbrMetallicRoughness || extension )
            return this.loadPBRMaterial( materialId, glTFmaterial, geometryNode, extension );

        const values = glTFmaterial.values;
        if ( !values ) return; // DEPRECATED: values doesn't exist in this version for material schema

        // Handles basic material attributes
        const osgMaterial = new Material();
        const osgStateSet = geometryNode.getOrCreateStateSet();
        osgStateSet.setAttribute( osgMaterial );

        if ( values.ambient ) osgMaterial.setAmbient( values.ambient );
        if ( values.emission ) osgMaterial.setEmission( values.emission );
        if ( values.shininess ) osgMaterial.setShininess( values.shininess );
        if ( values.specular ) osgMaterial.setSpecular( values.specular );

        // Create a texture for the diffuse, if any
        if ( values.diffuse ) {
            if ( typeof values.diffuse !== 'string' ) osgMaterial.setDiffuse( values.diffuse );
            else return this.createTextureAndSetAttrib( values.diffuse, osgStateSet, 0 );
        }

        geometryNode.stateset = osgStateSet;
        this._stateSetMap[ materialId ] = osgStateSet;

        return;
    }

    createGeometry( primitive, skeletonJointId ) {
        return new Promise( ( resolve, reject ) => {
            const json = this._glTFJSON;
            const promisesArray = [];

            // Builds the geometry from the extracted vertices & normals
            const geom = new Geometry();
            let rigOrGeom = geom;

            const cbSetBuffer = function ( name, buffer ) {
                if ( !buffer ) return;

                this.getVertexAttributeList()[ name ] = buffer;
            };

            if ( skeletonJointId ) {
                rigOrGeom = new RigGeometry();
                rigOrGeom._boneNameID = json.nodes[ skeletonJointId ].name;
            }

            const attributeWeight = ( data ) => {
                if ( !data ) return;

                rigOrGeom.getAttributes().Weights = data;

                const elts = rigOrGeom.getAttributes().Weights.getElements();
                for ( let i = 0, l = elts.length / 4; i < l; ++i ) {
                    const sum = elts[ i * 4 ] + elts[ i * 4 + 1 ] + elts[ i * 4 + 2 ] + elts[ i * 4 + 3 ];
                    const correc = 1.0 / sum;
                    elts[ i * 4 ] *= correc;
                    elts[ i * 4 + 1 ] *= correc;
                    elts[ i * 4 + 2 ] *= correc;
                    elts[ i * 4 + 3 ] *= correc;
                }
            };

            // Registers each glTF primitive attributes
            // into a respective geometry attribute
            const attributesKeys = window.Object.keys( primitive.attributes );
            for ( let i = 0; i < attributesKeys.length; ++i ) {
                const accessor = json.accessors[ primitive.attributes[ attributesKeys[ i ] ] ];
                const promise = this.loadAccessorBuffer( accessor, BufferArray.ARRAY_BUFFER );

                if ( attributesKeys[ i ].indexOf( 'POSITION' ) !== -1 ) {
                    promise.then( cbSetBuffer.bind( geom, 'Vertex' ) );
                } else if ( attributesKeys[ i ].indexOf( 'NORMAL' ) !== -1 ) {
                    promise.then( cbSetBuffer.bind( geom, 'Normal' ) );
                } else if ( attributesKeys[ i ].indexOf( 'TANGENT' ) !== -1 ) {
                    promise.then( cbSetBuffer.bind( geom, 'Tangent' ) );
                } else if ( attributesKeys[ i ].indexOf( 'JOINT' ) !== -1 ) {
                    promise.then( cbSetBuffer.bind( rigOrGeom, 'Bones' ) );
                } else if ( attributesKeys[ i ].indexOf( 'WEIGHT' ) !== -1 ) {
                    promise.then( attributeWeight );
                } else if ( attributesKeys[ i ].indexOf( 'COLOR' ) !== -1 ) {
                    promise.then( cbSetBuffer.bind( geom, 'Color' ) );
                } else if ( attributesKeys[ i ].indexOf( 'TEXCOORD' ) !== -1 ) {
                    const texCoordId = attributesKeys[ i ].substring( 9 );
                    promise.then( cbSetBuffer.bind( geom, 'TexCoord' + texCoordId ) );
                }

                promisesArray.push( promise );
            }

            const indicesAccessor = json.accessors[ primitive.indices ];
            const indicesPromise = this.loadAccessorBuffer(
                indicesAccessor,
                BufferArray.ELEMENT_ARRAY_BUFFER
            );
            indicesPromise.then( ( data ) => {
                if ( !data ) return;

                const osgPrimitive = new DrawElements( primitiveSet.TRIANGLES, data );
                geom.getPrimitives().push( osgPrimitive );
            } );

            promisesArray.push( indicesPromise );

            if ( primitive.material !== undefined )
                promisesArray.push( this.loadMaterial( primitive.material, geom ) );

            Promise.all( promisesArray ).then( () => {
                if ( skeletonJointId ) {
                    rigOrGeom.setSourceGeometry( geom );
                    rigOrGeom.mergeChildrenData();

                    rigOrGeom.computeBoundingBox = geom.computeBoundingBox;
                }

                resolve( rigOrGeom );
            }, reject );
        } );
    }

    loadGLTFNode( nodeId, root ) {
        return new Promise( ( resolve, reject ) => {
            if ( this._visitedNodes[ nodeId ] ) {
                resolve();
                return;
            }

            const json = this._glTFJSON;
            const glTFNode = json.nodes[ nodeId ];

            const currentNode = ( this._bones[ nodeId ] ) ? this._bones[ nodeId ] : new MatrixTransform();
            currentNode.setName( glTFNode.name );
            mat4.copy( currentNode.getMatrix(), this.loadTransform( glTFNode ) );

            if ( this._bones[ nodeId ] && this._skeletons[ nodeId ] ) {
                const skeleton = this._skeletons[ nodeId ];
                skeleton.addChild( currentNode );
                root.addChild( skeleton );
            }

            // Recurses on children before
            // processing the current node
            const children = glTFNode.children;
            const promises = [];
            if ( children ) {
                for ( let childId = 0; childId < children.length; ++childId ) {
                    const nodePromise = this.loadGLTFNode( children[ childId ], currentNode );
                    promises.push( nodePromise );
                }
            }
            // Loads meshes contained in the node
            // Adds RigGeometry to corresponding skeleton if any
            if ( glTFNode.mesh !== undefined ) {
                const meshId = glTFNode.mesh;
                const skinId = glTFNode.skin;
                if ( skinId === undefined || json.skins[ skinId ].skeleton === undefined ) {
                    const geomPromise = this.loadGLTFPrimitives( meshId, currentNode, null );
                    promises.push( geomPromise );
                } else {
                    const rootJointId = json.skins[ skinId ].skeleton;
                    const skeletonNode = this._skeletons[ rootJointId ];
                    const meshTransformNode = new MatrixTransform();
                    mat4.copy( meshTransformNode.getMatrix(), currentNode.getMatrix() );
                    const geomP = this.loadGLTFPrimitives( meshId, meshTransformNode, rootJointId );
                    skeletonNode.addChild( meshTransformNode );
                    promises.push( geomP );
                }
            }
            // Loads solid animations
            // by adding an update callback
            if ( this._animatedNodes[ nodeId ] ) this.registerUpdateCallback( nodeId, currentNode );

            if ( !this._skeletons[ nodeId ] ) root.addChild( currentNode );

            this._visitedNodes[ nodeId ] = true;
            Promise.all( promises ).then( () => {
                resolve();
            }, reject );
        } );
    }

    readJSON( glTFFile, url ) {
        return new Promise( ( resolve, reject ) => {
            // Creates the root node
            // adding a PI / 2 rotation arround the X-axis
            const root = new MatrixTransform();
            root.setName( url );

            if ( glTFFile === '' ) {
                console.log( 'not valid json' );
                resolve();
                return;
            }
            const json = JSON.parse( glTFFile );
            if ( !json ) {
                resolve();
                return;
            }

            this._glTFJSON = json;

            const promisesArray = [];
            // Preprocesses animations
            const animPromise = this.preprocessAnimations();
            // Preprocesses skin animations if any
            const skeletonPromise = this.preprocessSkeletons();

            promisesArray.push( skeletonPromise, animPromise );
            Promise.all( promisesArray ).then( () => {
                const promises = [];
                // Loops through each scene
                // loading geometry nodes, transform nodes, etc...s
                for ( let i = 0; i < json.scenes.length; ++i ) {
                    const scene = json.scenes[ i ];

                    if ( !scene ) continue;
                    for ( let j = 0; j < scene.nodes.length; ++j ) {
                        const p = this.loadGLTFNode( scene.nodes[ j ], root );
                        promises.push( p );
                    }
                }

                // Register the animation manager
                // if the glTF file contains animations
                if ( this._basicAnimationManager ) root.addUpdateCallback( this._basicAnimationManager );

                Promise.all( promises ).then( () => {
                    resolve( root );
                } );
            }, reject );
        } );
    }
}

Registry.instance().addReaderWriter( 'gltf20', new ReaderWriterGLTF20() );


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterOSGJSC.js":
/*!****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterOSGJSC.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osgDB = OSG.osgDB;
var osg = OSG.osg;

var Registry = osgDB.Registry;
var TimeStampCache = __webpack_require__( /*! pcvizUtils/TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js" );
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );

var FindTextureVisitor = function () {
    osg.NodeVisitor.call( this );
    this._hasTexture = false;
    this._hasMaterial = false;
};

FindTextureVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        if ( node.getTypeID() === osg.Geometry.getTypeID() ) {
            var stateSet = node.getStateSet();
            if ( stateSet ) {
                if ( stateSet.getNumTextureAttributeLists() > 0 ) {
                    this._hasTexture = true;
                    stateSet.addUniform( osg.Uniform.createFloat1( true, 'useTexture0' ) );
                }
                var matAttrib = stateSet.getAttribute( 'Material' );
                if ( matAttrib ) {
                    this._hasMaterial = true;
                    stateSet.addUniform( osg.Uniform.createFloat4( matAttrib.getDiffuse(), 'uMaterialDiffuse' ) );
                }

                var computeNodePath = function ( node ) {
                    var nodePath = [];
                    while ( node && node.getParents() && node.getParents().length > 0 ) {
                        nodePath.push( node.getParents()[ 0 ] );
                        node = node.getParents()[ 0 ];
                    }
                    return nodePath.reverse();
                };

                var nodePath = computeNodePath( node );
                var modelMat = osg.computeLocalToWorld( nodePath, true );
                var modelMatrixUniform = osg.Uniform.createMat4( modelMat, 'uModelMatrix' );
                stateSet.addUniform( modelMatrixUniform );
            }
        }
        this.traverse( node );
    },

    hasTexture: function () {
        return this._hasTexture;
    },

    hasMaterial: function () {
        return this._hasMaterial;
    }
} );

var SetPLODOptionsVisitor = function ( options ) {
    osg.NodeVisitor.call( this );
    this._options = options;
};

SetPLODOptionsVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {
        if ( node.getTypeID() === osg.PagedLOD.getTypeID() ) {
            node.setDatabaseOptions( this._options );
        }
        this.traverse( node );
    },
} );

var ReaderWriterOSGJSC = function () {
    this._identifierMap = {};
    this._input = new Input();
    this._osgDBInput = new osgDB.Input();
};

ReaderWriterOSGJSC.prototype = {

    readNodeURL: function ( url, options ) {
        var defer = P.defer();

        // remove pseudoloader .OSGJSC
        if ( url.endsWith( 'osgjsc' ) )
            url = url.substring( 0, url.length - 1 );

        this._requestPromise = this._osgDBInput.readNodeURL;

        var filePromise = this._requestPromise( url, this.createOptions( options ) );
        filePromise.then( function ( file ) {
            defer.resolve( file );
        } );

        return defer.promise;
    },

    createOptions: function ( options ) {
        var self = this;
        var opt = {};
        if ( options )
            opt = options;

        // insert here a request method to get the auth url
        opt.readNodeURL = function requestAuthURL( url, options ) {
            var defer = P.defer();
            var readSceneGraph = function ( data ) {
                return osgDB.parseSceneGraph( data, options ).then( function ( child ) {
                    var findTextureVisitor = new FindTextureVisitor();
                    child.accept( findTextureVisitor );
                    if ( findTextureVisitor.hasTexture() || findTextureVisitor.hasMaterial() ) {
                        child.setUserData( {
                            enableTexture: findTextureVisitor.hasTexture(),
                            enableMaterial: findTextureVisitor.hasMaterial()
                        } );
                    }

                    var childOptions = osg.objectMix( {}, options );
                    var plodOptionsVisitor = new SetPLODOptionsVisitor( childOptions );
                    child.accept( plodOptionsVisitor );
                    options.layer.getFeatureRenderer( '3D' ).getSymbol().setStateSetDirty( true );
                    return child;
                } );
            };

            self._input.requestMountUrl( url, options ).then( function ( file ) {
                var data = JSON.parse( file );
                if ( !data ) {
                    defer.resolve( file );
                } else {
                    readSceneGraph( data ).then( function ( node ) {
                        defer.resolve( node );
                    } );
                }
            } ).catch( function () {
                defer.reject();
            } );

            return defer.promise;
        };

        opt.readBinaryArrayURL = function ( url, options ) {
            url = options.databasePath + url;

            if ( this._identifierMap[ url ] === undefined ) {
                this._identifierMap[ url ] = self.magnetRequest( url, options );
            }
            return this._identifierMap[ url ];
        };

        opt.readImageURL = function ( url, options ) {
            var defer = P.defer();
            url = options.databasePath + url;
            options.imageCrossOrigin = 'anonymous';

            var timeStampString = '?tsccw=' + TimeStampCache.getTimeStamp( url );
            timeStampString += '&' + options.appendQuery;

            var image = new osg.Image();

            var xmlhttp = new XMLHttpRequest();
            xmlhttp.onreadystatechange = function () {
                if ( this.readyState === XMLHttpRequest.DONE && ( this.status >= 200 && this.status < 300 ) ) {
                    var response = new Blob( [ this.response ], {
                        type: 'image/jpg'
                    } );
                    self._useTexture = true;
                    var img = new window.Image();
                    img.src = URL.createObjectURL( response );
                    image.setImage( img );

                    img.onload = function () {
                        defer.resolve( image );
                    };

                } else if ( this.readyState === XMLHttpRequest.DONE && !( this.status >= 200 && this.status < 300 ) ) {

                    defer.reject( {
                        status: this.status,
                        data: this.response
                    } );
                }
            };

            xmlhttp.onerror = function () {
                defer.reject();
            };

            xmlhttp.onabort = function () {
                defer.reject();
            };

            xmlhttp.open( 'GET', url + timeStampString, true );

            xmlhttp.setRequestHeader( 'Accept', 'application/json' );
            xmlhttp.setRequestHeader( 'Content-Type', 'image/jpg' );
            xmlhttp.responseType = 'blob';
            xmlhttp.withCredentials = true;

            xmlhttp.send();

            return defer.promise;
        };

        return opt;
    },

    magnetRequest: function ( url, options ) {
        var defer = P.defer();
        var self = this;
        options.responseType = 'arraybuffer';
        self._input.requestMountUrl( url, options ).then( function ( file ) {
            defer.resolve( self._unzipTypedArray( file ) );
        }, function () {
            defer.reject();
        } );
        return defer.promise;
    },

    _unzipTypedArray: function ( binary ) {
        var typedArray = new Uint8Array( binary );

        // check magic number 1f8b
        if ( typedArray[ 0 ] === 0x1f && typedArray[ 1 ] === 0x8b ) {
            var _zlib = __webpack_require__( /*! zlib */ "./node_modules/browserify-zlib/lib/index.js" );

            if ( !_zlib ) {
                console.error(
                    'osg failed to use a gunzip.min.js to uncompress a gz file.\n You can add this vendors to enable this feature or adds the good header in your gzip file served by your server'
                );
            }

            var zdec = new _zlib.Gunzip( typedArray );
            var result = zdec.decompress();
            return result.buffer;
        }

        return binary;
    },
};

Registry.instance().addReaderWriter( 'osgjsc', new ReaderWriterOSGJSC() );
Registry.instance().addReaderWriter( 'osgjs', new ReaderWriterOSGJSC() );

module.exports = ReaderWriterOSGJSC;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterPLFBase.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterPLFBase.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

const Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
const TimeStampCache = __webpack_require__( /*! pcvizUtils/TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js" );

var ReaderWriterPLFBase = function () {
    this._input = new Input();
};

ReaderWriterPLFBase.prototype = {
    readNodeURL: function ( url, options ) {
        var self = this;
        var defer = P.defer();
        this.readBinaryArray( url, options ).then( function ( data ) {
            var sceneGraph = self.readSceneGraph( data, options );
            if ( sceneGraph )
                defer.resolve( sceneGraph );

            // FIXME: Please, check what we want to do when sceneGraph is undefined (It would be undefined when data would be undefined)
            else
                defer.reject();
        } ).catch( function () {
            defer.reject();
        } );
        return defer.promise;
    },

    readBinaryArray: function ( url, options ) {

        var defer = P.defer();
        if ( !options )
            options = {};
        options.responseType = 'arraybuffer';
        options.urlTimeStampCacheKey = TimeStampCache.getKeyForTimeStamp( options.layer.getUrl() );
        var filePromise = this.requestFile( url, options );
        filePromise.then( function ( data ) {
            defer.resolve( data );
        }.bind( this ) ).catch( function () {
            defer.reject();
        } );
        return defer.promise;

    },

    requestFile: function ( url, options ) {
        var defer = P.defer();

        this._input.requestMountUrl( url, options ).then( function ( responseText ) {
            defer.resolve( responseText );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    getUrl: function ( dsg, base, database, format ) {
        var url = base.concat(
            '/',
            dsg[ 0 ].toString(), '/',
            dsg[ 1 ].toString(), '/',
            dsg[ 2 ].toString(), '/',
            database, '_L',
            dsg[ 0 ].toString(), '_X',
            dsg[ 1 ].toString(), '_Y',
            dsg[ 2 ].toString(), '_Z',
            dsg[ 3 ].toString(), '.',
            format );
        return url;
    },
};

module.exports = ReaderWriterPLFBase;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterPLFMZ.js":
/*!***************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterPLFMZ.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var osg = OSG.osg;
var osgDB = OSG.osgDB;
var ConversionInfo = __webpack_require__( /*! pcvizDB/ConversionInfo */ "./sources/pcvizDB/ConversionInfo.js" );
var PLFMZReaderParser = __webpack_require__( /*! pcvizDB/PLFMZReaderParser */ "./sources/pcvizDB/PLFMZReaderParser.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var PointCloudPLOD = __webpack_require__( /*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js" );
var ElementIDAttribute = __webpack_require__( /*! pcvizNode/ElementIDAttribute */ "./sources/pcvizNode/ElementIDAttribute.js" );
var ReaderWriterPLFBase = __webpack_require__( /*! pcvizPlugins/ReaderWriterPLFBase */ "./sources/pcvizPlugins/ReaderWriterPLFBase.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );


var ReaderWriterPLFMZ = function () {
    ReaderWriterPLFBase.call( this );
    this._options = undefined;
    this._parser = new PLFMZReaderParser();

    this._conversionInfo = new ConversionInfo();
};

ReaderWriterPLFMZ.prototype = Utils.objectInherit( ReaderWriterPLFBase.prototype, {

    readSceneGraph: function ( data, options ) {
        return this.parsePLFMZSceneGraph( data, options );
    },

    parsePLFMZSceneGraph: function ( data, options ) {
        if ( data !== undefined ) {
            var plfmz = this._parser.parseBuffer( data );
            var plod = this.createCompactPagedLOD( plfmz, options );

            // add uniform here
            var sset = new osg.StateSet();

            var levelFactor = Math.pow( 1.2, ( 10.0 - options.level ) );
            sset.addUniform( osg.Uniform.createFloat1( levelFactor, 'levelFactor' ) );

            plod.setStateSet( sset );

            // Enable extra attributes
            if ( plfmz.attributesInformation.has( ConversionInfo.ElementID ) ) {
                plod.hasExtraAttributes = true;
                plod.numHeatMaps = plfmz.attributesInformation.get( ConversionInfo.NumHeatMaps ).arrayBuffer[ 0 ];
                var elementIDAttribute = new ElementIDAttribute();
                elementIDAttribute.setElementID( -1 ); // < 0 means render all points
                sset.setAttributeAndModes( elementIDAttribute );
            }

            return plod;
        } else {
            console.error( 'No valid data found' );
            return undefined;
        }
    },

    createCompactPagedLOD: function ( plfmz, options ) {

        // First attribute the Vertices
        var geometry = this.getPLODGeometry( plfmz, options );
        var tile = new PointCloudPLOD();
        Registry.getController( 'PointVisibilityManager' ).pushNodeToProcess( tile.getInstanceID(), geometry ); // Register new PLFMZ geometry to update visibility.

        tile.setId( options.database );
        tile.addChild( geometry, 0, 250000 );
        tile.setRangeMode( osg.Lod.PIXEL_SIZE_ON_SCREEN );

        if ( plfmz.childrenData.length === 0 ) {
            tile.setRange( 0, 0, Number.MAX_VALUE );
            return tile;
        }

        var that = this;
        var createURL = function ( /*plod*/) {

            var dsg = plfmz.designation;

            var url = that.getUrl( dsg, options.urlDataPrefix, options.database, options.format );
            options.level = dsg[ 0 ] + 1;
            return url;
        };
        tile.setOptions( options );
        var url = createURL();
        tile.setFileName( 1, url );
        tile.setRange( 1, 250000, Number.MAX_VALUE );
        return tile;
    },

    getPLODGeometry: function ( plfmz, options ) {
        const geometry = new osg.Geometry();
        let pointType = 'PointArray';
        switch ( true ) {
        case plfmz.attributesInformation.has( ConversionInfo.CompressedPointArrayID ):
            pointType = ConversionInfo.CompressedPointArrayID;
            break;
        case plfmz.attributesInformation.has( ConversionInfo.CompressedPointFloat24ArrayID ):
            pointType = ConversionInfo.CompressedPointFloat24ArrayID;
            break;
        case plfmz.attributesInformation.has( ConversionInfo.CompressedPointFloat16ArrayID ):
            pointType = ConversionInfo.CompressedPointFloat16ArrayID;
            break;
        }

        if ( pointType !== 'PointArray' )
            this._conversionInfo.apply( pointType, geometry, plfmz.attributesInformation, options );

        const that = this;
        plfmz.attributesInformation.forEach( function ( value, key ) {
            if ( key === pointType ) return true;

            if ( key in that._conversionInfo && key !== 'PointArray' && key !== 'ColorArray' ) {
                that._conversionInfo.apply( key, geometry, plfmz.attributesInformation, options );
            }
        } );
        const len = geometry.getAttributes().Vertex.getElements().length / 3;
        const u8array = new Uint8Array( len );
        geometry.getAttributes().Visible = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, u8array, 1, true );
        return geometry;
    },

    // NOTE: This method is not using now. It is needed when the rest resquest well done.
    _unzipTypedArray: function ( data ) {

        var binary = new Uint8Array( data );
        // check magic number 1f8b
        if ( binary[ 0 ] === 0x1f && binary[ 1 ] === 0x8b ) {
            var zlib = window.Zlib;

            if ( !zlib ) {
                console.error( 'osg failed to use a gunzip.min.js to uncompress a gz file.\n You can add this vendors to enable this feature or adds the good header in your gzip file served by your server' );
            }

            var zdec = new zlib.Gunzip( binary );
            var result = zdec.decompress();
            return result.buffer;
        }

        return data;
    }

} );

osgDB.Registry.instance().addReaderWriter( 'plfmz', new ReaderWriterPLFMZ() );

module.exports = ReaderWriterPLFMZ;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterSmartPointsPTS.js":
/*!************************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterSmartPointsPTS.js ***!
  \************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Input */ "./sources/pcvizDB/Input.js");
/* harmony import */ var pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizUtils_ShaderUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizUtils/ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js");



const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;




class ReaderWriterSmartPointsPTS {
    constructor() {
        this._input = new pcvizDB_Input__WEBPACK_IMPORTED_MODULE_1___default.a();
    }

    readNodeURL( url, options ) {
        return new Promise( ( resolve, reject ) => {

            let filePromise = this._input.requestMountUrl( url, options );
            filePromise.then( ( file ) => {
                let node = this.readPTS( file, options );
                resolve( node );
            } ).catch( function () {
                reject();
            } );
        } );
    }

    readPTS( data, options ) {

        let group = new osg.Node();
        let geometry = new osg.Geometry();

        let lines = data.split( '\n' );

        let numLines = lines.length;
        if ( lines[ numLines - 1 ] === '' )
            numLines--;
        let numPoints = numLines - 1;
        let x, y, z, r, g, b;
        r = 0;
        g = 0;
        b = 0;

        let vertices = new Float32Array( numPoints * 3 );
        let colors = new Float32Array( numPoints * 4 );
        let pointSizes = new Float32Array( numPoints );

        for ( let i = 0; i < numPoints; i++ ) {
            let smartPoint = lines[ i + 1 ];

            let smartPointComponents = smartPoint.split( ' ' );
            // parse position
            x = parseFloat( smartPointComponents[ 0 ] );
            y = parseFloat( smartPointComponents[ 1 ] );
            z = parseFloat( smartPointComponents[ 2 ] );

            let projectedPt = [ x, y, z ];
            //if ( options.epsg && options.epsg !== '' )
            //    CRSUtils.transform( 'EPSG:4978', options.epsg, projectedPt );

            vertices[ 3 * i ] = projectedPt[ 0 ] - options.center[ 0 ];
            vertices[ 3 * i + 1 ] = projectedPt[ 1 ] - options.center[ 1 ];
            vertices[ 3 * i + 2 ] = projectedPt[ 2 ] - options.center[ 2 ];

            // component 3 is intensity...

            // parse color
            r = parseFloat( smartPointComponents[ 4 ] ) / 255.0;
            g = parseFloat( smartPointComponents[ 5 ] ) / 255.0;
            b = parseFloat( smartPointComponents[ 6 ] ) / 255.0;

            colors[ 4 * i ] = r;
            colors[ 4 * i + 1 ] = g;
            colors[ 4 * i + 2 ] = b;
            colors[ 4 * i + 3 ] = 1;

            pointSizes[ i ] = 5; // fixed size
        }

        geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
        geometry.getAttributes().PointSize = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, pointSizes, 1 );

        geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, numPoints ) );

        group.addChild( geometry );

        // shader
        let stateSet = group.getOrCreateStateSet();
        stateSet.setAttributeAndModes( this.generateProgram() );

        return group;
    }

    generateProgram() {
        let defaultHeatMap = 0;
        let vertexShader = pcvizUtils_ShaderUtils__WEBPACK_IMPORTED_MODULE_2__["default"].getVertexShaderForPoints( defaultHeatMap );

        let fragmentShader = pcvizUtils_ShaderUtils__WEBPACK_IMPORTED_MODULE_2__["default"].getFragmentShaderCircles();

        let program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );

        return program;
    }

}

osgDB.Registry.instance().addReaderWriter( 'pts', new ReaderWriterSmartPointsPTS() );

/* harmony default export */ __webpack_exports__["default"] = (ReaderWriterSmartPointsPTS);


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterTiePointsXML.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterTiePointsXML.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;

var Registry = osgDB.Registry;
var Node = osg.Node;

var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
//var pcvizRegistry = require( 'pcvizDB/Registry' );
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
const ShaderUtils = __webpack_require__( /*! pcvizUtils/ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js" ).default;

var ReaderWriterTiePointsXML = function () {
    this._input = new Input();
};

ReaderWriterTiePointsXML.prototype = {

    readNodeURL: function ( url, options ) {
        var defer = P.defer();

        var self = this;
        // remove ".tie" to the url
        url = url.substring( 0, url.lastIndexOf( '.' ) );
        var filePromise = self._input.requestMountUrl( url, options );
        filePromise.then( function ( file ) {
            var node = self.readXML( file, options );
            defer.resolve( node );
        } ).catch( function () {
            defer.reject();
        } );
        return defer.promise;
    },

    findElement: function ( node, id ) {
        var element;
        var find = false;
        for ( var i = 0; i < node.childNodes.length; i++ ) {
            element = node.childNodes[ i ];
            if ( element.tagName === id ) {
                find = true;
                break;
            }
        }
        if ( !find )
            return;

        return {
            node: element,
            value: element.textContent
        };
    },

    readXML: function ( data, options ) {

        var group = new Node();
        var geometry = new osg.Geometry();

        var parser = new DOMParser();
        var xmlDoc = parser.parseFromString( data, 'text/xml' );

        // getting tie points
        var tiePoints = xmlDoc.getElementsByTagName( 'TiePoint' );
        var numPoints = tiePoints.length;
        var x, y, z, r, g, b;
        r = 0;
        g = 0;
        b = 0;
        var position, color;

        var vertices = new Float32Array( numPoints * 3 );
        var colors = new Float32Array( numPoints * 4 );
        var pointsizes = new Float32Array( numPoints );

        for ( var i = 0; i < numPoints; i++ ) {
            var tiePoint = tiePoints[ i ];

            // parse position
            position = this.findElement( tiePoint, 'Position' ).node;
            if ( !position )
                continue;
            x = parseFloat( this.findElement( position, 'x' ).value );
            y = parseFloat( this.findElement( position, 'y' ).value );
            z = parseFloat( this.findElement( position, 'z' ).value );

            var projectedPt = [ x, y, z ];
            if ( options.epsg && options.epsg !== '' )
                CRSUtils.transform( 'EPSG:4978', options.epsg, projectedPt );

            vertices[ 3 * i ] = projectedPt[ 0 ] - options.center[ 0 ];
            vertices[ 3 * i + 1 ] = projectedPt[ 1 ] - options.center[ 1 ];
            vertices[ 3 * i + 2 ] = projectedPt[ 2 ] - options.center[ 2 ];

            // parse color
            color = this.findElement( tiePoint, 'Color' ).node;
            if ( !color )
                continue;
            r = parseFloat( this.findElement( color, 'Red' ).value );
            g = parseFloat( this.findElement( color, 'Green' ).value );
            b = parseFloat( this.findElement( color, 'Blue' ).value );

            colors[ 4 * i ] = r;
            colors[ 4 * i + 1 ] = g;
            colors[ 4 * i + 2 ] = b;
            colors[ 4 * i + 3 ] = 1;

            pointsizes[ i ] = 5; // fixed size
        }

        geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
        geometry.getAttributes().PointSize = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, pointsizes, 1 );

        geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.POINTS, 0, numPoints ) );

        group.addChild( geometry );

        // shader
        var stateSet = group.getOrCreateStateSet();
        stateSet.setAttributeAndModes( this.generateProgram() );

        return group;
    },

    generateProgram: function () {

        let vertexShader = ShaderUtils.getVertexShaderForPoints();

        let fragmentShader = ShaderUtils.getFragmentShaderCircles();

        var program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );

        return program;
    },

};

Registry.instance().addReaderWriter( 'tie', new ReaderWriterTiePointsXML() );

module.exports = ReaderWriterTiePointsXML;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterTiledImage.js":
/*!********************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterTiledImage.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var Switch = __webpack_require__( /*! pcvizNode/Switch */ "./sources/pcvizNode/Switch.js" );
var ReaderWriterFeatureImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterFeatureImage */ "./sources/pcvizPlugins/ReaderWriterFeatureImage.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var CollagePLOD = __webpack_require__( /*! pcvizNode/CollagePLOD */ "./sources/pcvizNode/CollagePLOD.js" );

var osg = OSG.osg;

var ReaderWriterTiledImage = function () {
    ReaderWriterFeatureImage.call( this );
    this._reader.setMaxRequestsInQueue( 0 );

    this._fileType = undefined;
    this._pixelsPerRange = 1000;
    this._layer = undefined;
};


ReaderWriterTiledImage.prototype = osg.objectInherit( ReaderWriterFeatureImage.prototype, {
    readNodeURL: function ( url, options ) {
        var defer = P.defer();
        var self = this;
        this._layer = options.layer;
        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( this._layer.getId() ).getMountObject().then( function ( mount ) {

            self._baseImageURL = url;
            if ( MagnetAPI.isConnectingFromMagnet() ) {
                self._baseImageURL = mount.mountPoint + '/' + url;
            }
            self._fileType = options.format;

            var switchNode = new Switch();

            var pagedLOD = new CollagePLOD();
            var lowResGeometry = self.getLowResGeometry( options.dirty );
            lowResGeometry._parents = [];
            pagedLOD.addChild( lowResGeometry, 0, self._pixelsPerRange );
            pagedLOD.setRangeMode( osg.Lod.PIXEL_SIZE_ON_SCREEN );

            pagedLOD._level = 0;
            pagedLOD._col = 0;
            pagedLOD._row = 0;
            pagedLOD.setUserData( {
                maxLevel: undefined,
                options: options,
            } );
            // setting this user priority will give images more priority to upload than point clouds
            pagedLOD._userPriority = 100;

            pagedLOD.setFunction( 1, self.createPagedLODGroup.bind( self, pagedLOD, self._baseImageURL ) );
            pagedLOD.setRange( 1, self._pixelsPerRange, Number.MAX_VALUE );

            switchNode.addChild( lowResGeometry );
            switchNode.addChild( pagedLOD );
            switchNode.activate = self.activatePLOD.bind( switchNode );
            switchNode.activate( false );
            // pass options either from input or from userdata (for dynamic children)
            options.urlTimeStampCacheKey += options.layer.getId();
            self.loadTileTexture( lowResGeometry, self.getTileURL( 0, 0, 0, self._baseImageURL ), options || pagedLOD.getUserData().options );
            defer.resolve( switchNode );
        } ).catch( function ( error ) {
            Registry.getController( 'Error' ).addError( error );
            defer.reject( error );
        } );

        return defer.promise;
    },

    createPagedLODGroup: function ( parent, url ) {
        var self = this;
        var defer = P.defer();

        var promises = [];

        var group = new osg.Node();
        var level = parent._level + 1;
        if ( parent.getUserData().maxLevel && parent.getUserData().maxLevel < level ) {
            defer.reject();
            return defer.promise;
        }

        for ( var i = 0; i < 4; i++ ) {
            var x = i % 2;
            var y = i >> 1;
            var row = parent._row * 2 + x;
            var col = parent._col * 2 + y;

            promises.push( this.createNodeTile( level, row, col, parent.getUserData().options, url ) );
        }

        P.all( promises ).then( function ( nodeTiles ) {
            nodeTiles.forEach( function ( nodeTile ) {
                if ( !nodeTile ) return;

                if ( parent.getUserData().maxLevel && parent.getUserData().maxLevel <= level ) {
                    group.addChild( nodeTile );
                    return;
                }

                var plod = new CollagePLOD();
                plod.setRangeMode( osg.Lod.PIXEL_SIZE_ON_SCREEN );
                plod.addChild( nodeTile, 0, self._pixelsPerRange );
                plod.setFunction( 1, self.createPagedLODGroup.bind( self, plod, url ) );
                plod.setRange( 1, self._pixelsPerRange, Number.MAX_VALUE );
                plod._order = parent._order;
                plod._level = level;
                plod._row = nodeTile.row;
                plod._col = nodeTile.col;
                // This way the user data object is shared by all plods
                plod.setUserData( parent.getUserData() );
                group.addChild( plod );

            } );
            defer.resolve( group );
        } ).catch( function () {
            // The highest level of detail has been reached
            parent.getUserData().maxLevel = level - 1;
            defer.reject();
        } );

        return defer.promise;
    },

    createNodeTile: function ( /*level, row, col*/) {
        console.log( 'GeoImageNodePLOD.createNodeTile not implemented.' );
    },

    loadTileTexture: function ( node, url, options ) {
        if ( node._texture )
            node._texture._textureNull = true;

        if ( !MagnetAPI.isConnectingFromMagnet() ) {
            return this.loadTexture( node, url, undefined, options );
        }

        var defer = P.defer();
        var self = this;

        self.loadTexture( node, url, undefined, options ).then( function () {
            defer.resolve( node );
        }, function () {
            defer.reject();
        } );

        return defer.promise;
    },

    getTileURL: function ( level, row, col, url ) {
        if ( !url )
            return;
        return url + '/' + level + '/' + row + '/' + col + '.' + this._fileType;
    },

    activatePLOD: function ( value ) {
        // 'this' is the switch node
        var index = value ? 1 : 0;
        this.setSingleChildOn( index );
    }
} );


module.exports = ReaderWriterTiledImage;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterTiledPanorama.js":
/*!***********************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterTiledPanorama.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// var P = require( 'bluebird' );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var DBUtils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var ReaderWriterTiledImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiledImage */ "./sources/pcvizPlugins/ReaderWriterTiledImage.js" );
var osgDB = OSG.osgDB;

var Registry = osgDB.Registry;

var ReaderWriterTiledPanorama = function () {
    ReaderWriterTiledImage.call( this );
    this._maxNumTiles = 64;
};


ReaderWriterTiledPanorama.prototype = Utils.objectInherit( ReaderWriterTiledImage.prototype, {

    getLowResGeometry: function () {
        if ( !this._lowResGeometry )
            this._lowResGeometry = DBUtils.createTexturedSphereFragment( 1.0, this._maxNumTiles, this._maxNumTiles );
        return this._lowResGeometry;
    },

    createNodeTile: function ( level, row, col, options, url ) {
        var numTiles = 1 << level;
        var phiLength = ( Math.PI * 2 ) / numTiles;
        var phiStart = row * phiLength;
        var thetaLength = Math.PI / numTiles;
        var thetaStart = ( numTiles - col - 1 ) * thetaLength;
        var node = DBUtils.createTexturedSphereFragment( 1.0, this._maxNumTiles / numTiles, this._maxNumTiles / numTiles, phiStart, phiLength, thetaStart, thetaLength );
        node.row = row;
        node.col = col;
        return this.loadTileTexture( node, this.getTileURL( level, row, col, url ), options );
    },

} );

Registry.instance().addReaderWriter( 'panorama', new ReaderWriterTiledPanorama() );

module.exports = ReaderWriterTiledPanorama;


/***/ }),

/***/ "./sources/pcvizPlugins/ReaderWriterTiledPlanarImage.js":
/*!**************************************************************!*\
  !*** ./sources/pcvizPlugins/ReaderWriterTiledPlanarImage.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// var P = require( 'bluebird' );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var DBUtils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var ReaderWriterTiledImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiledImage */ "./sources/pcvizPlugins/ReaderWriterTiledImage.js" );
var osgDB = OSG.osgDB;

var Registry = osgDB.Registry;

var ReaderWriterTiledPlanarImage = function () {
    ReaderWriterTiledImage.call( this );
    this._fovx = undefined;
    this._fovy = undefined;
    this._principalPointX = undefined;
    this._principalPointY = undefined;
    this._cameraSensorWidth = undefined;
    this._cameraSensorHeight = undefined;

    this._pixelsPerRange = 100000;
};


ReaderWriterTiledPlanarImage.prototype = Utils.objectInherit( ReaderWriterTiledImage.prototype, {

    readNodeURL: function ( url, options ) {
        this._fovx = options.fovx;
        this._fovy = options.fovy;
        this._principalPointX = options.principalPointX;
        this._principalPointY = options.principalPointY;
        this._cameraSensorWidth = options.cameraSensorWidth;
        this._cameraSensorHeight = options.cameraSensorHeight;
        this._distortionParams = options.distortionParams;
        this._distance = options.distance;
        return ReaderWriterTiledImage.prototype.readNodeURL.call( this, url, options );
    },

    getLowResGeometry: function ( dirty ) {
        if ( !this._lowResGeometry || dirty ) {
            this._lowResGeometry = DBUtils.createTexturedQuadGeometryFragment(
                this._fovx,
                this._fovy,
                this._principalPointX,
                this._principalPointY,
                this._cameraSensorWidth,
                this._cameraSensorHeight,
                undefined,
                undefined,
                undefined,
                this._distance
            );
        }
        return this._lowResGeometry;
    },

    createNodeTile: function ( level, row, col, options, url ) {
        var numTiles = 1 << level;
        var length = 1 / numTiles;
        var xStart = row * length;
        var yStart = col * length;

        var node = DBUtils.createTexturedQuadGeometryFragment(
            this._fovx,
            this._fovy,
            this._principalPointX,
            this._principalPointY,
            this._cameraSensorWidth,
            this._cameraSensorHeight,
            xStart,
            yStart,
            length,
            this._distance, // far
            this._distortionParams
        );

        node.row = row;
        node.col = col;
        return this.loadTileTexture( node, this.getTileURL( level, row, col, url ), options );
    },

} );

Registry.instance().addReaderWriter( 'planarimage', new ReaderWriterTiledPlanarImage() );

module.exports = ReaderWriterTiledPlanarImage;


/***/ }),

/***/ "./sources/pcvizPlugins/pcvizPlugins.js":
/*!**********************************************!*\
  !*** ./sources/pcvizPlugins/pcvizPlugins.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterGLTF */ "./sources/pcvizPlugins/ReaderWriterGLTF.js");
/* harmony import */ var pcvizPlugins_ReaderWriterGLTF10__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterGLTF10 */ "./sources/pcvizPlugins/ReaderWriterGLTF10.js");
/* harmony import */ var pcvizPlugins_ReaderWriterGLTF20__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterGLTF20 */ "./sources/pcvizPlugins/ReaderWriterGLTF20.js");
/* harmony import */ var pcvizPlugins_ReaderWriterSmartPointsPTS__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizPlugins/ReaderWriterSmartPointsPTS */ "./sources/pcvizPlugins/ReaderWriterSmartPointsPTS.js");

var ReaderWriterCPLFMZ = __webpack_require__( /*! pcvizPlugins/ReaderWriterCPLFMZ */ "./sources/pcvizPlugins/ReaderWriterCPLFMZ.js" );
var ReaderWriterPLFMZ = __webpack_require__( /*! pcvizPlugins/ReaderWriterPLFMZ */ "./sources/pcvizPlugins/ReaderWriterPLFMZ.js" );
var ReaderWriterPLFBase = __webpack_require__( /*! pcvizPlugins/ReaderWriterPLFBase */ "./sources/pcvizPlugins/ReaderWriterPLFBase.js" );
var ReaderWriterFeatureImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterFeatureImage */ "./sources/pcvizPlugins/ReaderWriterFeatureImage.js" );
var ReaderWriterTiledImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiledImage */ "./sources/pcvizPlugins/ReaderWriterTiledImage.js" );
var ReaderWriterTiledPanorama = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiledPanorama */ "./sources/pcvizPlugins/ReaderWriterTiledPanorama.js" );
var ReaderWriterTiledPlanarImage = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiledPlanarImage */ "./sources/pcvizPlugins/ReaderWriterTiledPlanarImage.js" );

var BinaryDecoder = __webpack_require__( /*! pcvizPlugins/BinaryDecoder */ "./sources/pcvizPlugins/BinaryDecoder.js" );



var ReaderWriterGLB = __webpack_require__( /*! pcvizPlugins/ReaderWriterGLB */ "./sources/pcvizPlugins/ReaderWriterGLB.js" );
var ReaderWriterB3DM = __webpack_require__( /*! pcvizPlugins/ReaderWriterB3DM */ "./sources/pcvizPlugins/ReaderWriterB3DM.js" );
var ReaderWriter3DTiles = __webpack_require__( /*! pcvizPlugins/ReaderWriter3DTiles */ "./sources/pcvizPlugins/ReaderWriter3DTiles.js" );
var ReaderWriterOSGJSC = __webpack_require__( /*! pcvizPlugins/ReaderWriterOSGJSC */ "./sources/pcvizPlugins/ReaderWriterOSGJSC.js" );
var ReaderWriterTiePointsXML = __webpack_require__( /*! pcvizPlugins/ReaderWriterTiePointsXML */ "./sources/pcvizPlugins/ReaderWriterTiePointsXML.js" );


var pcvizPlugins = {};

pcvizPlugins.ReaderWriterCPLFMZ = ReaderWriterCPLFMZ;
pcvizPlugins.ReaderWriterPLFMZ = ReaderWriterPLFMZ;
pcvizPlugins.ReaderWriterPLFBase = ReaderWriterPLFBase;
pcvizPlugins.ReaderWriterFeatureImage = ReaderWriterFeatureImage;
pcvizPlugins.ReaderWriterTiledImage = ReaderWriterTiledImage;
pcvizPlugins.ReaderWriterTiledPanorama = ReaderWriterTiledPanorama;
pcvizPlugins.ReaderWriterTiledPlanarImage = ReaderWriterTiledPlanarImage;

pcvizPlugins.BinaryDecoder = BinaryDecoder;
pcvizPlugins.ReaderWriterGLTF = pcvizPlugins_ReaderWriterGLTF__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizPlugins.ReaderWriterGLTF10 = pcvizPlugins_ReaderWriterGLTF10__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizPlugins.ReaderWriterGLTF20 = pcvizPlugins_ReaderWriterGLTF20__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizPlugins.ReaderWriterGLB = ReaderWriterGLB;
pcvizPlugins.ReaderWriterB3DM = ReaderWriterB3DM;
pcvizPlugins.ReaderWriter3DTiles = ReaderWriter3DTiles;
pcvizPlugins.ReaderWriterOSGJSC = ReaderWriterOSGJSC;
pcvizPlugins.ReaderWriterTiePointsXML = ReaderWriterTiePointsXML;
pcvizPlugins.ReaderWriterSmartPointsPTS = pcvizPlugins_ReaderWriterSmartPointsPTS__WEBPACK_IMPORTED_MODULE_3__["default"];

/* harmony default export */ __webpack_exports__["default"] = (pcvizPlugins);


/***/ }),

/***/ "./sources/pcvizRenderTools/CompassTool.js":
/*!*************************************************!*\
  !*** ./sources/pcvizRenderTools/CompassTool.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  Compass tool
 *  @class
 *  @memberof pcvizRenderTools
 *  @extends Tool
 */

var CompassTool = function ( viewer ) {
    Tool.call( this, viewer, 'compass' );

    this._viewer = viewer;
    this._compass = undefined;
    this._lastValue = 0.0;
};

CompassTool.prototype = osg.objectInherit( Tool.prototype, {

    setCompassElement: function ( compass ) {
        this._compass = compass;
    },

    update: function ( /*viewer*/) {

        var viewMatrix = this._viewer.getCamera().getViewMatrix();

        if ( viewMatrix === 0 )
            return;

        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        var angle = this.calculateAngle( eye, center );

        /* 
           TODO: Try decoupling this code from the view
           Maybe an event with the angle should be emited and the view should be updated in the UI.
        */
        if ( this._compass ) {
            const r = `rotate(${angle}deg)`;
            if ( this._compass.css ) {
                this._compass.css( {
                    '-moz-transform': r,
                    '-webkit-transform': r,
                    '-o-transform': r,
                    '-ms-transform': r
                } );
            } else {
                this._compass.style.transform = r;
            }
        }
    },
    /**
     * @method
     * Calculate the angle on degrees to set to the compass.
     * @memberof pcvizRenderTools.CompasTool
     */
    calculateAngle: function ( eye, center ) {
        var vec3Dir = osg.vec3.create();
        osg.vec3.sub( vec3Dir, eye, center );

        var vec2Dir = osg.vec2.fromValues( vec3Dir[ 0 ], vec3Dir[ 1 ] );
        osg.vec3.normalize( vec2Dir, vec2Dir );

        var angle = Math.atan2( vec2Dir[ 1 ], vec2Dir[ 0 ] );

        if ( angle < 0 ) angle += 2 * Math.PI;

        return ( ( angle * 180 / Math.PI ) + 90 );
    }

} );

module.exports = CompassTool;


/***/ }),

/***/ "./sources/pcvizRenderTools/GridTool.js":
/*!**********************************************!*\
  !*** ./sources/pcvizRenderTools/GridTool.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgText = OSG.osgText;
var CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var UnitController = __webpack_require__( /*! pcvizDB/UnitController */ "./sources/pcvizDB/UnitController.js" );


/**
 *  Grid tool
 *  @class
 *  @memberof pcvizRenderTools
 *  @extends Tool
 */

var GridTool = function ( viewer ) {
    Tool.call( this, viewer, 'grid' );

    this._viewer = viewer;
    this._gridNode = undefined;
    this._labelsNode = [];
    this._geometryNode = undefined;
    this._project = undefined;
    this._overwriteColor = undefined;
    this._defaultExtent = Utils.DEFAULT_EXTENT;
    this._floorOnly = false;
};

GridTool.prototype = osg.objectInherit( Tool.prototype, {

    setGridColor: function ( overwriteColor ) {
        this._overwriteColor = overwriteColor;
    },

    setFloorOnly: function ( floorOnly ) {
        this._floorOnly = floorOnly;
    },

    setProject: function ( project ) {

        this._project = project;

        // create node
        if ( !this._gridNode ) {
            this._gridNode = new osg.Node();
            this._gridNode.setName( '3DGrid' );
            this._labelsNode = [];

            this._viewer.getToolsNode().addChild( this._gridNode );

            // register listener to change visibility
            var self = this;
            var userPreferencesCtrl = Registry.getController( 'UserPreferences' );
            userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.GRID_ON_KEY, function () {
                self.buildGrid( self._project );
            } );

            // register listener to change visibility for grid labels
            userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.GRID_LABEL_ON_KEY, function () {
                self.buildGrid( self._project );
            } );

            // register listener to recreate depending on decimals
            userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.NUMBER_OF_DECIMALS_KEY, function () {
                self.buildGrid( self._project );
            } );
            // register listener to recreate depending of the background color
            userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.BACKGROUND_COLOR_KEY, function () {
                self.buildGrid( self._project );
            } );
            //refresh the units preferences 
            Registry.getInstance().getController( 'Units' ).registerListener( ListenerController.APPLICATION, UnitController.DISTANCE_TYPE, () => {
                this.buildGrid( this._project );
            } );

            this._matrixCenter = new osg.MatrixTransform();
            this._matrixToExtent = new osg.MatrixTransform();
        }
        this.buildGrid( project );
    },

    // When we receive the call from listener to gridOn, labelon, color, units
    // and also when the project is just opened    

    buildGrid: function ( project ) {
        if ( !this._project || !this._gridNode )
            return;

        this._matrixToExtent.removeChildren();
        this._matrixCenter.removeChildren();
        this._gridNode.removeChildren();
        this._labelsNode = [];

        // initialize visibility
        var userPreferencesCtrl = Registry.getController( 'UserPreferences' );
        var gridOnNow = userPreferencesCtrl.getPreference( Utils.GRID_ON_KEY );
        var gridLabelOnNow = userPreferencesCtrl.getPreference( Utils.GRID_LABEL_ON_KEY );

        // set main node mask,  we are going to create or not grid / labels (LATER)
        this._gridNode.setNodeMask( gridOnNow ? ~Utils.TRAVERSAL_MASK_IV : 0x0 );

        if ( !gridOnNow && !gridLabelOnNow ) return;

        this._geometryNode = new osg.Geometry();
        osg.mat4.fromTranslation( this._matrixCenter.getMatrix(), [ -this._viewer.getCenter()[ 0 ], -this._viewer.getCenter()[ 1 ], -this._viewer.getCenter()[ 2 ] ] );

        this._gridNode.addChild( this._matrixCenter );

        this._crsData = this.prepareCRSData( project );
        this._coordPrefixes = this.defineLabelPrefixes( project );

        this.createGrid( project, gridOnNow, gridLabelOnNow );
    },

    defineLabelPrefixes: function ( project ) {

        if ( project.getProjection() === 'EPSG:4978' ) // ECEF
            return [ 'X: ', 'Y: ', 'Z: ' ];

        if ( project.getProjection() === 'EPSG:4326' ) // WGS84
            return [ 'L: ', 'B: ', 'H: ' ];

        return [ 'E: ', 'N: ', 'U: ' ];
    },

    prepareCRSData: function ( project ) {

        if ( !project._dataCRS || !project.getProjection() )
            return undefined;

        CRSUtils.defProj4( project._dataCRS, project._dataCRSProj4 );
        CRSUtils.defProj4( project.getProjection(), project.getProj4() );

        return { // inverse reprojection, from project CRS to internal data CRS
            sourceProjection: project.getProjection(),
            destinationProjection: project._dataCRS,
            geoid: project.getGeoid()
        };
    },

    transformPosToInternal: function ( position ) {
        if ( !this._crsData )
            return;

        CRSUtils.transform( this._crsData.sourceProjection, this._crsData.destinationProjection, position, false );
    },

    correctGeoidProjectCRS: function ( position ) {
        if ( !this._crsData || !this._crsData.geoid )
            return;

        CRSUtils.transform( this._crsData.sourceProjection, this._crsData.sourceProjection, position, false, this._crsData.geoid, false );
    },

    createGrid: function ( project, gridOn, gridLabelOn ) {

        var gridExtent = project.getProjectedExtent( true ); // we will get a right reviewed and checked extent

        var centerPt = this._viewer.getCenter();
        if ( !centerPt ) // project not yet loaded
            centerPt = [ 0.5 * ( gridExtent[ 0 ] + gridExtent[ 3 ] ), 0.5 * ( gridExtent[ 1 ] + gridExtent[ 4 ] ), 0.5 * ( gridExtent[ 2 ] + gridExtent[ 5 ] ) ];

        let originalGridExtent = gridExtent.slice();
        var divParams = this.calculateDivisions( gridExtent );
        const unitsController = Registry.getInstance().getController( 'Units' );

        originalGridExtent = [ unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 0 ] ),
            unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 1 ] ),
            unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 2 ] ),
            unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 3 ] ),
            unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 4 ] ),
            unitsController.convertFromDistanceUnitWithoutLabel( gridExtent[ 5 ] )
        ];

        osg.mat4.fromTranslation( this._matrixToExtent.getMatrix(), [ ( originalGridExtent[ 0 ] ), ( originalGridExtent[ 1 ] ), ( originalGridExtent[ 2 ] ) ] );

        this._matrixCenter.addChild( this._matrixToExtent );
        this._matrixToExtent.addChild( this._geometryNode );

        var incrProjCRS = [ originalGridExtent[ 3 ] - originalGridExtent[ 0 ], originalGridExtent[ 4 ] - originalGridExtent[ 1 ], originalGridExtent[ 5 ] - originalGridExtent[ 2 ] ];

        divParams.gridExtent = gridExtent;
        divParams.incrProjCRS = incrProjCRS;
        divParams.centerPt = centerPt;

        //-------------------------- Grid --------------------------------
        if ( gridOn ) {

            let numVertices = 4 * divParams.numDivs[ 0 ] * divParams.numDivs[ 1 ] + 4 * divParams.numDivs[ 0 ] * divParams.numDivs[ 2 ] + 4 * divParams.numDivs[ 1 ] * divParams.numDivs[ 2 ];
            if ( this._floorOnly )
                numVertices = 2 * divParams.numDivs[ 0 ] * divParams.numDivs[ 1 ];

            let vertices = new Float32Array( 3 * numVertices ); // dimension based in number of divisions
            let colors = new Float32Array( 4 * numVertices );

            divParams.colorPerDim = [
                [ 0.9, 0.27, 0.27 ],
                [ 0.27, 0.9, 0.27 ],
                [ 0.27, 0.69, 0.9 ]
            ];
            if ( this._overwriteColor )
                divParams.colorPerDim[ 0 ] = divParams.colorPerDim[ 1 ] = divParams.colorPerDim[ 2 ] = this._overwriteColor;

            let iVert = 0;
            iVert = this.drawPlanes( 0, 1, 2, vertices, colors, iVert, divParams );
            if ( !this._floorOnly ) {
                iVert = this.drawPlanes( 0, 2, 1, vertices, colors, iVert, divParams );
                iVert = this.drawPlanes( 1, 2, 0, vertices, colors, iVert, divParams );
            }

            this._geometryNode.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
            this._geometryNode.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );

            let stateSet = this._geometryNode.getOrCreateStateSet();
            let program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', Utils.getVertexShader() ),
                new osg.Shader( 'FRAGMENT_SHADER', Utils.getFragmentShader() ) );

            stateSet.setAttributeAndModes( program );
        }

        // ------------------------------------------------Labels -- only if gridOn is also true ---------
        if ( gridLabelOn && gridOn ) {
            this.createLabels( 0, divParams, originalGridExtent );
            this.createLabels( 1, divParams, originalGridExtent );
            if ( !this._floorOnly )
                this.createLabels( 2, divParams, originalGridExtent );

            for ( var labelI = 0; labelI < this._labelsNode.length; labelI++ ) {
                this._labelsNode[ labelI ].setNodeMask( gridLabelOn ? ~Utils.TRAVERSAL_MASK_IV : 0x0 );
            }
        }
    },

    calculateDivisions: function ( dataExtent ) {

        // first, we need to reproject to extent to internal Data CRS
        var minExt = [ dataExtent[ 0 ], dataExtent[ 1 ], dataExtent[ 2 ] ];
        var maxExt = [ dataExtent[ 3 ], dataExtent[ 4 ], dataExtent[ 5 ] ];
        this.transformPosToInternal( minExt );
        this.transformPosToInternal( maxExt );

        const unitsController = Registry.getInstance().getController( 'Units' );

        minExt[ 0 ] = unitsController.convertToDistanceUnitWithoutLabel( minExt[ 0 ] );
        minExt[ 1 ] = unitsController.convertToDistanceUnitWithoutLabel( minExt[ 1 ] );
        minExt[ 2 ] = unitsController.convertToDistanceUnitWithoutLabel( minExt[ 2 ] );
        maxExt[ 0 ] = unitsController.convertToDistanceUnitWithoutLabel( maxExt[ 0 ] );
        maxExt[ 1 ] = unitsController.convertToDistanceUnitWithoutLabel( maxExt[ 1 ] );
        maxExt[ 2 ] = unitsController.convertToDistanceUnitWithoutLabel( maxExt[ 2 ] );

        // calculate reference number of subdivisions
        var sizes = [ maxExt[ 0 ] - minExt[ 0 ], maxExt[ 1 ] - minExt[ 1 ], maxExt[ 2 ] - minExt[ 2 ] ];
        var maxSize = Math.max( sizes[ 0 ], Math.max( sizes[ 1 ], sizes[ 2 ] ) );
        var refDivs = 7;
        var minDivs = 2;

        var dims = [ 0, 0, 0 ];
        for ( var iDim = 0; iDim < 3; iDim++ ) {
            if ( maxSize === sizes[ iDim ] )
                dims[ iDim ] = refDivs + 1;
            else
                dims[ iDim ] = Math.floor( refDivs * sizes[ iDim ] / maxSize ) + 1;

            if ( dims[ iDim ] < minDivs + 1 )
                dims[ iDim ] = minDivs + 1;
        }

        // adjust subdivisions to round values and calculate needed precisions
        return this.roundExtent( dataExtent, dims );
    },

    roundExtent: function ( dataExtent, dims ) {
        const unitsController = Registry.getInstance().getController( 'Units' );
        let precisions = [ 0, 0, 0 ];

        let dataExtentUserUnits = [
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 0 ] ),
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 1 ] ),
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 2 ] ),
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 3 ] ),
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 4 ] ),
            unitsController.convertToDistanceUnitWithoutLabel( dataExtent[ 5 ] )
        ];
        let convertedSizes = [
            dataExtentUserUnits[ 3 ] - dataExtentUserUnits[ 0 ], dataExtentUserUnits[ 4 ] - dataExtentUserUnits[ 1 ], dataExtentUserUnits[ 5 ] - dataExtentUserUnits[ 2 ]
        ];
        for ( var iDim = 0; iDim < 3; iDim++ ) {
            if ( convertedSizes[ iDim ] === 0 ) // Check that sizes are positive
                continue;
            convertedSizes[ iDim ] /= ( dims[ iDim ] - 1 );
            // round logarithm to 1, 2, 5, 10
            var power = Math.log10( convertedSizes[ iDim ] );
            var powerInt = Math.floor( power );

            var powerIntUserUnits = Math.floor( Math.log10( convertedSizes[ iDim ] ) );
            var powerFrac = power - powerInt;
            if ( powerFrac >= 0.85 ) // closer to next power
                power = powerInt + 1.0;
            else if ( powerFrac >= 0.5 )
                power = powerInt + Math.log10( 5.0 );
            else if ( powerFrac >= 0.15 )
                power = powerInt + Math.log10( 2.0 );
            else
                power = powerInt;
            convertedSizes[ iDim ] = Math.pow( 10.0, power ); // round size
            // adjust extent
            dataExtent[ iDim ] = Math.floor( dataExtentUserUnits[ iDim ] / convertedSizes[ iDim ] ) * convertedSizes[ iDim ];
            dataExtent[ iDim + 3 ] = ( Math.floor( dataExtentUserUnits[ iDim + 3 ] / convertedSizes[ iDim ] ) + 1 ) * convertedSizes[ iDim ];
            // adjust divisions
            dims[ iDim ] = Math.round( ( dataExtent[ iDim + 3 ] - dataExtent[ iDim ] ) / convertedSizes[ iDim ] ) + 1;
            precisions[ iDim ] = powerIntUserUnits;
        }

        return {
            numDivs: dims,
            precisions: precisions
        };
    },

    drawPlanes: function ( index1, index2, index3, vertices, colors, iVert, divParams ) {
        var factors = [ 0, 0, 0 ];
        var lPrimitive;
        var iX, iY;

        for ( iY = 0; iY < divParams.numDivs[ index1 ]; iY++ ) {
            factors[ index1 ] = iY / ( divParams.numDivs[ index1 ] - 1.0 );
            factors[ index3 ] = 0.0;
            lPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, iVert / 3, divParams.numDivs[ index2 ] );
            for ( iX = 0; iX < divParams.numDivs[ index2 ]; iX++, iVert += 3 ) {
                factors[ index2 ] = iX / ( divParams.numDivs[ index2 ] - 1.0 );
                this.addVertex( vertices, iVert, divParams.gridExtent, divParams.incrProjCRS, divParams.centerPt, factors );
                this.addColor( colors, iVert, divParams.colorPerDim[ index2 ] );
            }
            this._geometryNode.getPrimitives().push( lPrimitive );

            if ( !this._floorOnly ) {
                factors[ index3 ] = 1.0;
                lPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, iVert / 3, divParams.numDivs[ index2 ] );
                for ( iX = 0; iX < divParams.numDivs[ index2 ]; iX++, iVert += 3 ) {
                    factors[ index2 ] = iX / ( divParams.numDivs[ index2 ] - 1.0 );
                    this.addVertex( vertices, iVert, divParams.gridExtent, divParams.incrProjCRS, divParams.centerPt, factors );
                    this.addColor( colors, iVert, divParams.colorPerDim[ index2 ] );
                }
                this._geometryNode.getPrimitives().push( lPrimitive );
            }
        }
        for ( iX = 0; iX < divParams.numDivs[ index2 ]; iX++ ) {
            factors[ index2 ] = iX / ( divParams.numDivs[ index2 ] - 1.0 );
            factors[ index3 ] = 0.0;
            lPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, iVert / 3, divParams.numDivs[ index1 ] );
            for ( iY = 0; iY < divParams.numDivs[ index1 ]; iY++, iVert += 3 ) {
                factors[ index1 ] = iY / ( divParams.numDivs[ index1 ] - 1.0 );
                this.addVertex( vertices, iVert, divParams.gridExtent, divParams.incrProjCRS, divParams.centerPt, factors );
                this.addColor( colors, iVert, divParams.colorPerDim[ index1 ] );
            }
            this._geometryNode.getPrimitives().push( lPrimitive );

            if ( !this._floorOnly ) {
                factors[ index3 ] = 1.0;
                lPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, iVert / 3, divParams.numDivs[ index1 ] );
                for ( iY = 0; iY < divParams.numDivs[ index1 ]; iY++, iVert += 3 ) {
                    factors[ index1 ] = iY / ( divParams.numDivs[ index1 ] - 1.0 );
                    this.addVertex( vertices, iVert, divParams.gridExtent, divParams.incrProjCRS, divParams.centerPt, factors );
                    this.addColor( colors, iVert, divParams.colorPerDim[ index1 ] );
                }
                this._geometryNode.getPrimitives().push( lPrimitive );
            }
        }
        return iVert;
    },

    addVertex: function ( vertices, iVert, gridExtent, incrProjCRS, centerPt, factors ) {
        var pos = [
            factors[ 0 ] * incrProjCRS[ 0 ],
            factors[ 1 ] * incrProjCRS[ 1 ],
            factors[ 2 ] * incrProjCRS[ 2 ],
        ];
        this.transformPosToInternal( pos );
        vertices[ iVert + 0 ] = pos[ 0 ];
        vertices[ iVert + 1 ] = pos[ 1 ];
        vertices[ iVert + 2 ] = pos[ 2 ];
    },

    addColor: function ( colors, iVert, color ) {
        var iColor = 4 * iVert / 3;
        colors[ iColor + 0 ] = color[ 0 ];
        colors[ iColor + 1 ] = color[ 1 ];
        colors[ iColor + 2 ] = color[ 2 ];
        colors[ iColor + 3 ] = 1.0;
    },

    createLabels: function ( dim, divParams, originalGridExtent ) {
        for ( var iY = 0; iY < divParams.numDivs[ dim ]; iY++ ) {
            var factor = iY / ( divParams.numDivs[ dim ] - 1.0 );
            var position = [ originalGridExtent[ 0 ], originalGridExtent[ 1 ], originalGridExtent[ 2 ] ];
            position[ dim ] += factor * divParams.incrProjCRS[ dim ];

            var displayValue;
            if ( dim === 2 ) { // show Z value with geoid correction
                var savedPos = [ position[ 0 ], position[ 1 ], position[ 2 ] ];
                this.correctGeoidProjectCRS( savedPos );
                displayValue = savedPos[ 2 ];
            } else
                displayValue = position[ dim ]; // we display coordinate value in project CRS

            this.transformPosToInternal( position );

            position[ 0 ] -= divParams.centerPt[ 0 ];
            position[ 1 ] -= divParams.centerPt[ 1 ];
            position[ 2 ] -= divParams.centerPt[ 2 ];

            // round value
            if ( divParams.precisions[ dim ] >= 0 )
                displayValue = Math.round( displayValue );
            else {
                displayValue = Math.round( displayValue * Math.pow( 10.0, -divParams.precisions[ dim ] ) ) * Math.pow( 10.0, divParams.precisions[ dim ] );
            }

            var verticalOffset = ( iY !== 0 || dim === 0 ) ? -2 : ( dim === 1 ? -5 : -8 ); // avoid superposicion at origin

            //transform units from preference units configuration
            displayValue = Registry.getInstance().getController( 'Units' ).convertToDistanceUnitWithoutLabel( displayValue );

            var newCT = this.createText( position, displayValue, this._coordPrefixes[ dim ], -divParams.precisions[ dim ], verticalOffset );

            //Store which custom text we have to change the visibility after
            this._labelsNode.push( newCT );

            this._gridNode.addChild( newCT );
        }
    },

    createText: function ( position, value, prefix, precision, verticalOffset ) {

        var numberOfDecimals = ( precision <= 0 ) ? 0 : precision;
        var textString = prefix + value.toFixed( numberOfDecimals );

        var text = new CustomText( textString );
        text.setPosition( position );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( 5 );
        text.setVerticalLabelOffset( verticalOffset );
        var depth = new osg.Depth( osg.Depth.ALWAYS );
        depth.setWriteMask( false ); // avoid text frame with EDL
        text.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

        var backgroundColor = Registry.getController( 'UserPreferences' ).getPreference( Utils.BACKGROUND_COLOR_KEY );
        var textColor = osg.vec4.fromValues32( 0, 0, 0, 0.8 );

        // use white color for dark background colors
        if ( 0.2126 * backgroundColor[ 0 ] + 0.7152 * backgroundColor[ 1 ] + 0.0722 * backgroundColor[ 2 ] < 0.5 )
            textColor = osg.vec4.fromValues32( 1.0, 1.0, 1.0, 0.8 );

        text.setColor( textColor );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( osg.vec4.fromValues32( 63, 81, 181, 0.0 ) );
        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;

    },

} );

module.exports = GridTool;


/***/ }),

/***/ "./sources/pcvizRenderTools/HelperArrowTool.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizRenderTools/HelperArrowTool.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HelperArrowTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);



const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
const osgUtil = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgUtil;

const mat4 = osg.mat4;
const vec3 = osg.vec3;
const MatrixTransform = osg.MatrixTransform;
const Uniform = osg.Uniform;
const GizmoGeometry = osgUtil.GizmoGeometry;




const HELPER_ARROW_COLOR = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.DARK_YELLOW_3;
/**
 *  Tool to render a helper arrow for Volume workflow (CS)
 *  @class
 *  @memberof pcvizRenderTools
 */
class HelperArrowTool {

    constructor( sceneView ) {
        this._id = 'helperArrow';
        this._sceneView = sceneView;
        this._arrowNode = undefined;
        this._arrowToolNode = new osg.Node();
        this._arrowToolNode.setName( 'HelperArrowNode' );
        this._sceneView.getViewer().getToolsNode().addChild( this._arrowToolNode );

        this._position = osg.vec3.create64();
        this._normal = osg.vec3.fromValues( 0, 0, 1 );
    }

    setPosition( position ) {
        this._position = position;
    }

    setNormal( normal ) {
        this._normal = normal;
    }

    drawArrow( position, normal, fixedNormal ) {
        if ( position )
            osg.vec3.copy( this._position, position );
        if ( normal )
            osg.vec3.copy( this._normal, normal );

        if ( this._arrowNode ) {
            this._arrowNode.removeChildren();
        } else {
            this._arrowNode = new MatrixTransform();
            this._arrowNode.setName( 'HelperArrow' );
        }

        const aHeight = 1.5,
            aConeHeight = 0.3;
        // cone arrow
        const mtCone = new MatrixTransform();
        mat4.fromTranslation(
            mtCone.getMatrix(),
            vec3.fromValues( 0.0, 0.0, aHeight + aConeHeight * 0.5 )
        );
        mtCone.addChild(
            GizmoGeometry.createCylinderGeometry( 0.0, 0.14, aConeHeight, 32, 1, true, true )
        );
        // arrow base
        const mtArrow = new MatrixTransform();
        mat4.fromTranslation( mtArrow.getMatrix(), vec3.fromValues( 0.0, 0.0, aHeight * 0.5 ) );
        // Overwritten: bigger radius top and bottom
        mtArrow.addChild(
            GizmoGeometry.createCylinderGeometry( 0.04, 0.04, aHeight, 32, 1, true, true )
        );

        // rotation
        // check if normal needs negate
        if ( !fixedNormal ) {
            const eye = vec3.create64();
            this._sceneView.getViewer().getManipulator().getEyePosition( eye );
            const camDirToPos = osg.vec3.subtract( osg.vec3.create64(), eye, this._position );
            const angleToNormal1 = vec3.angle( camDirToPos, this._normal );
            const negatedNormal = osg.vec3.create64();
            osg.vec3.negate( negatedNormal, this._normal );
            const angleToNormal2 = vec3.angle( camDirToPos, negatedNormal );
            if ( angleToNormal2 < angleToNormal1 )
                this._normal = negatedNormal;
        }
        const angle = vec3.angle( osg.vec3.fromValues( 0, 0, 1 ), this._normal );
        const direction = vec3.cross( osg.vec3.create64(), osg.vec3.fromValues( 0, 0, 1 ), this._normal );

        // draw arrow
        this._arrowNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), this._position ) );
        if ( angle > 0 )
            osg.mat4.rotate( this._arrowNode.getMatrix(), this._arrowNode.getMatrix(), angle, direction );

        this._arrowNode.addChild( mtArrow );
        this._arrowNode.addChild( mtCone );

        this._arrowNode.getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( HELPER_ARROW_COLOR, 'uColor' ) );

        this._arrowNode.getOrCreateStateSet().setRenderBinDetails( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.RENDERBIN_LINEARROWS, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.RENDERBIN_LINEARROWS_TYPE );
        this._arrowNode.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );

        this._arrowToolNode.addChild( this._arrowNode );
    }

    removeArrow() {
        if ( !this._arrowNode )
            return;
        this._arrowToolNode.removeChild( this._arrowNode );
    }

    // These methods are needed to add the tool to the toolbar
    setToolbar() {}

    setGroup() {}

    isToolActive() {
        return false;
    }

    getId() {
        return this._id;
    }
}


/***/ }),

/***/ "./sources/pcvizRenderTools/HighlightFeatureTool.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizRenderTools/HighlightFeatureTool.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HighlightFeatureTool; });
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js");
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");









/**
 *  Tool to manage highlighting features
 *  @class
 *  @memberof pcvizRenderTools
 *  @extends Tool
 */
class HighlightFeatureTool extends pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default.a {

    constructor( sceneView ) {
        super( sceneView.getViewer(), 'highlightFeature' );

        this._selectionObjectController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'SelectionObject' );
        // It is necessary to store the current selected objects to compare when a new selectionObject event arrives.
        this._layerSelected = undefined;
        this._featureSelected = undefined;

        this._avoidPointClouds = false;
        this._toc = undefined;

        var self = this;
        this._selectionObjectController.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_3___default.a.APPLICATION, function ( selectionObject ) {
            if ( self._active ) {
                // if there's a problem and the selectionObject is undefined, reset all.
                if ( selectionObject === undefined || selectionObject.getLayer() === undefined ) {
                    self._layerSelected = undefined;
                    self._featureSelected = undefined;
                    return;
                }

                var layer = selectionObject.getLayer();

                if ( self._avoidPointClouds && layer.getType() !== pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR )
                    return;

                // HACK for CRE
                if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_4___default.a.isSite() && !pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_5__["default"].isModel( layer.getCategory() ) )
                    return;

                if ( self._layerSelected && ( layer.getId() !== self._layerSelected.getId() ||
                        layer.getObjectId() !== self._layerSelected.getObjectId() ) ) {

                    // unselect and refresh previous layer
                    if ( self._featureSelected && self._layerSelected.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR ) {
                        self._layerSelected.deselectAll();
                        self._layerSelected.getFeatureRenderer().getSymbol().setHighlightFeature( false );
                    }
                }

                self.configureHighlight();
            }
        } );
    }


    setProject( project ) {
        this._project = project;
    }

    setActive( active, onlyActivate ) {

        if ( this._active === active )
            return;

        this._active = active;
        if ( onlyActivate )
            return;

        this.configureHighlight();
    }

    setToc( toc ) {
        if ( toc._children ) {
            this._toc = toc;
        } else {
            this._toc = { '_children': toc };
        }
    }

    configureHighlight() {
        if ( !this._toc ) {
            this._toc = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'View' ).getView( 'TOC' ).getTOC();
        }
        this._layerSelected = this._selectionObjectController.getSelectionObject() ? this._selectionObjectController.getSelectionObject().getLayer() : undefined;

        if ( this._active ) {
            // activate highlight
            for ( var i = 0; i < this._toc._children.length; i++ ) {
                this.setHighlightVisibility( this._toc._children[ i ] );
            }
        } else if ( this._toc && this._toc._children ) {
            // if highlight is off, restore visibility
            for ( var iLayer = 0; iLayer < this._toc._children.length; iLayer++ ) {
                this.restoreVisibility( this._toc._children[ iLayer ] );
            }
        }

        if ( this._selectionObjectController.getSelectionObject() )
            this._featureSelected = this._selectionObjectController.getSelectionObject().getFeature && this._selectionObjectController.getSelectionObject().getFeature();

        if ( this._featureSelected !== undefined ) {
            if ( this._active && this._layerSelected &&
                this._layerSelected.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR && this._layerSelected.getFeatureRenderer() ) {
                this._layerSelected.getFeatureRenderer().getSymbol().setHighlightFeature( true );
                this._layerSelected.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
            }
        }
    }

    setHighlightVisibility( layer ) {
        if ( this._layerSelected && layer.getId() === this._layerSelected.getId() ) {
            this.setLayerVisibility( true, layer );
            var featureSelected = this._selectionObjectController.getSelectionObject().getFeature ? this._selectionObjectController.getSelectionObject().getFeature() : undefined;
            // we need to reselect feature after changing visibility
            if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR && featureSelected )
                layer.selectFeature( featureSelected.getId() );
            return true;
        }

        if ( !layer._children || layer._children.length === 0 ) {
            // terminal layers
            if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR ) {
                this.setLayerVisibility( false, layer );
                return false;
            }
            // do not modify non-vector layers
            return layer.isVisible();
        }

        // make parent visible if it contains the visible layer
        var parentVisible = false;
        for ( var i = 0; i < layer._children.length; i++ ) {
            if ( this.setHighlightVisibility( layer._children[ i ] ) )
                parentVisible = true;
        }
        this.setLayerVisibility( parentVisible, layer );
        return parentVisible;
    }

    setLayerVisibility( visible, layer ) {
        if ( layer.savedVisibility === undefined )
            layer.savedVisibility = layer.isVisible();
        layer.setVisible( visible );
    }

    restoreVisibility( layer ) {
        if ( layer.savedVisibility === undefined )
            return;

        layer.setVisible( layer.savedVisibility );
        layer.savedVisibility = undefined;

        // feature visibility
        if ( layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR && layer.getFeatureRenderer() ) {
            layer.getFeatureRenderer().getSymbol().setHighlightFeature( false );
            layer.updateSymbolRendererAndRefreshLayerInViews(); // We don't need to wait because we are not adding/removing nodes
        }

        if ( !layer._children )
            return;

        for ( var i = 0; i < layer._children.length; i++ ) {
            this.restoreVisibility( layer._children[ i ] );
        }
    }

    // Note: this flag makes that the raster layers are ignored too
    avoidPointClouds( flag ) {
        this._avoidPointClouds = flag;
    }
}


/***/ }),

/***/ "./sources/pcvizRenderTools/PrismPoleTool.js":
/*!***************************************************!*\
  !*** ./sources/pcvizRenderTools/PrismPoleTool.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PrismPoleTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__);



const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;



/**
 *  Tool to render the prism pole for Layout Points workflow
 *  @class
 *  @memberof pcvizRenderTools
 */
class PrismPoleTool {

    constructor( sceneView ) {
        this._id = 'prismPole';
        this._sceneView = sceneView;
        this._prismPoleNode = undefined;
        this._prismPoleToolNode = new osg.Node();
        this._prismPoleToolNode.setName( 'PrismPoleTool' );
        this._sceneView.getViewer().getToolsNode().addChild( this._prismPoleToolNode );
    }

    drawPrismPole() {
        let markerSymbol = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["MarkerSymbol3D"]();
        let style = {
            PointSymbolizer: {
                marker: '/assets/prism-pole.png',
                billboard: true,
                autoScale: false,
                size: 2,
                color: [ 1.0, 1.0, 1.0, 1.0 ],
                heightSize: 14
            }
        };
        markerSymbol.configure( style );
        this._prismPoleNode = markerSymbol.renderMarker( osg.vec4.create(), undefined, undefined, osg.vec3.create() );
        markerSymbol.configureColorUniform( this._prismPoleNode.getOrCreateStateSet() );
        this._prismPoleNode.setName( 'PrismPole' );
        this._prismPoleToolNode.addChild( this._prismPoleNode );
    }

    removePrismPole() {
        if ( !this._prismPoleNode )
            return;
        this._prismPoleToolNode.removeChild( this._prismPoleNode );
    }

    updatePrismPolePosition( position ) {
        if ( !this._prismPoleNode )
            return;
        this._prismPoleNode.setPosition( position );
        this._sceneView.getViewer().requestRedraw();
    }

    // These methods are needed to add the tool to the toolbar
    setToolbar() {}

    setGroup() {}

    isToolActive() {
        return false;
    }

    getId() {
        return this._id;
    }
}


/***/ }),

/***/ "./sources/pcvizRenderTools/SketchTool.js":
/*!************************************************!*\
  !*** ./sources/pcvizRenderTools/SketchTool.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var CustomVertexGizmo = __webpack_require__( /*! pcvizNode/CustomVertexGizmo */ "./sources/pcvizNode/CustomVertexGizmo.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var osg = OSG.osg;

/**
 * Tool that manages temporary feature displaying and the edition by gizmos.
 * @class
 * @memberof pcvizRenderTools
 * @extends pcvizTools.Tool
 */
var SketchTool = function ( viewer ) {

    Tool.call( this, viewer, 'sketchTool' );

    this._tempNode = undefined;
    this._positionsArray = [];
    this._tempFeature = undefined;

    this._vertexSelected = 0;
    this._geometrySelected = undefined;

    this._gizmo = undefined;

    this._geomVertexElements = []; // we save it to know if the geometry has been edited

    // yellow
    this._selectionColor = osg.vec4.fromValues32( 0.843, 0.76, 0.06, 0.5 );

};

var redColor = osg.vec4.fromValues32( 1.0, 0.318, 0.31, 1.0 );

SketchTool.prototype = osg.objectInherit( Tool.prototype, {

    /*
     *   this method isn't called automatically. It is called on demand
     */
    update: function ( /*viewer*/) {
        this.drawTempFeatures();
    },

    setFeature: function ( f ) {
        this._tempFeature = f;
    },

    setVertex: function ( v ) {
        if ( v !== this._vertexSelected ) {
            this._vertexSelected = v;

            // If we're editing a feature, we change the index in the gizmo.
            if ( this._gizmo !== undefined ) {
                this._gizmo.getIndices()[ 0 ] = this._vertexSelected;

                this._tempNode.removeChildren();
                this.drawVertices(); // This function only draw vertices if the geometry is a line or a polygon
            }
        }
    },

    setGeometrySelected: function ( geom ) {
        this._geometrySelected = geom;
    },

    setPositionsArray: function ( positionsArray ) {
        this._positionsArray = positionsArray.copyWithin( 0, 0 );
    },

    setNode: function ( node ) {
        this._tempNode = node;
    },

    isGeometryDirty: function () {
        // If _geomVertexElements doesn't have any elements, we're creating a new Feature. So, to check if it's dirty, we use _positionsArray.
        if ( this._geomVertexElements.length === 0 ) {
            return ( this._positionsArray.length > 0 );
        }

        // Else, we're editing an existing feature. So, we check if the vertex elements of its geometry are equal than when we started to edit the feature.
        for ( var i = 0; i < this._geomVertexElements.length; i++ )
            if ( this._geomVertexElements[ i ] !== this._geometrySelected.getVertexAttributeList().Vertex.getElements()[ i ] )
                return true;

        return false;
    },

    /**
     * Instantiates a CustomVertexGizmo to allow to move the selected vertex.
     * Stores the original elements of the Vertex BufferArray.
     * Draws the vertices if the geometry selected is a line or a polygon
     * @method
     * @memberof pcvizRenderTools.SketchTool
     */
    editSelectedGeometry: function () {
        var indicesGizmo = [];
        indicesGizmo.push( this._vertexSelected );
        this._gizmo = new CustomVertexGizmo( this._viewer );
        this._tempNode.getParents()[ 0 ].addChild( this._gizmo );

        this._geomVertexElements = this._geometrySelected.getVertexAttributeList().Vertex.getElements().slice();

        this._gizmo.attachToGeometry( this._geometrySelected, indicesGizmo, true );

        this._tempNode.removeChildren();
        this.drawVertices(); // This function only draw vertices if the geometry is a line or a polygon
    },

    /**
     * Draws the vertices of the geometry which is being edited, if it's a line or a polygon.
     * Be careful! This function removes the childs of _tempNode
     * @method
     * @memberof pcvizRenderTools.SketchTool
     */
    drawVertices: function ( pathFromGeom ) {
        // In this case _tempFeature is the feature which geometry is being edited (it isn't a temporary feature).
        // If, the geometry is a line or a polygon, we draw a point in each vertex (except the selected vertex).
        if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.LINE || this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.POLYGON ) {

            let nodePath = Utils.computeNodePath( pathFromGeom ? this._geometrySelected : this._geometrySelected.getParents()[ 0 ] );
            let mt = osg.computeLocalToWorld( nodePath, true );
            let vecTransformed = osg.vec3.create64();

            var vert = [];
            var geomVert = this._geometrySelected.getVertexAttributeList().Vertex.getElements();
            for ( var i = 0; i < geomVert.length; i += 3 )
                if ( i / 3 !== this._vertexSelected ) {
                    osg.vec3.transformMat4( vecTransformed, [ geomVert[ i ], geomVert[ i + 1 ], geomVert[ i + 2 ] ], mt );
                    vert.push( vecTransformed.slice() );
                }
            var geometryPoints = this.drawPoints( vert );
            this._tempNode.addChild( geometryPoints );
        }
    },

    // This function is only called if the addPoint mode is active, so _geometrySelected won't be a Point.
    drawSelectedVertex: function () {
        var geomVert = this._geometrySelected.getVertexAttributeList().Vertex.getElements();
        let nodePath = Utils.computeNodePath( this._geometrySelected );
        let mt = osg.computeLocalToWorld( nodePath, true );

        //Draw vertex
        let vertexTransformed = osg.vec3.transformMat4( osg.vec3.create64(), [ geomVert[ this._vertexSelected * 3 ], geomVert[ this._vertexSelected * 3 + 1 ], geomVert[ this._vertexSelected * 3 + 2 ] ], mt );
        let geometryPoints = this.drawPoints( [ vertexTransformed ], redColor );
        this._tempNode.addChild( geometryPoints );

        if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.MULTIPOINT )
            return;
        //Draw segment
        var highlightSegmentVertices = [
            vertexTransformed
        ];
        var highlightSegment;

        if ( geomVert[ this._vertexSelected * 3 + 3 ] ) {
            vertexTransformed = osg.vec3.transformMat4( osg.vec3.create64(), [ geomVert[ this._vertexSelected * 3 + 3 ], geomVert[ this._vertexSelected * 3 + 4 ], geomVert[ this._vertexSelected * 3 + 5 ] ], mt );
            highlightSegmentVertices.push( vertexTransformed );
            // if it's the last point and it's a polygon, draw the segment using the first point
        } else if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.POLYGON ) {
            vertexTransformed = osg.vec3.transformMat4( osg.vec3.create64(), [ geomVert[ 0 ], geomVert[ 1 ], geomVert[ 2 ] ], mt );
            highlightSegmentVertices.push( vertexTransformed );
        }

        highlightSegment = this.drawScreenLines( highlightSegmentVertices, false, redColor, 5.0, true );
        highlightSegment.segments.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_SELECTED_VERT, Utils.RENDERBIN_SELECTED_VERT_TYPE );
        this._tempNode.addChild( highlightSegment.segments );
    },

    /**
     * Draw point, lineal and polygon feature geometries. This method updates the geometry of the new feature.
     * @method
     * @memberof pcvizRenderTools.SketchTool
     */
    drawTempFeatures: function () {
        var geometry;

        if ( this._tempFeature !== undefined ) {

            // draw the geometry according to the type

            if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.POINT ) {
                if ( this._tempNode.getNumChildren() === 0 ) {
                    geometry = this.drawPoints( this._positionsArray.slice( 0, 1 ) );
                    this._tempNode.addChild( geometry );
                } else {
                    this.updatePoint();
                }
                this._tempNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

            } else if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.MULTIPOINT ) {

                if ( this._tempNode.getNumChildren() === 0 ) {
                    geometry = this.drawPoints( this._positionsArray );
                    this._tempNode.addChild( geometry );
                } else {
                    this.updateMultipoint();
                }
                this._tempNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

            } else if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.LINE ) {
                if ( this._tempNode.getNumChildren() === 0 ) {
                    geometry = this.drawScreenLines( this._positionsArray, false, this._selectionColor, 5.0 );
                    this._tempNode.addChild( geometry.segments );
                } else {
                    this.updateScreenLines( false, this._selectionColor );
                }

            } else if ( this._tempFeature.getLayer().getGeometryType() === FeatureDefinition.POLYGON ) {
                if ( this._positionsArray.length <= 3 || this._tempNode.getNumChildren() === 0 ) {
                    this._tempNode.removeChildren();
                    geometry = this.drawArea( this._positionsArray, false, this._selectionColor );
                    this._tempNode.addChild( geometry.area );
                    //this._tempNode.addChild( geometry.wire );

                } else {
                    this.updateArea( false );
                }
            }
        }
    },

    getPointsShader: function () {
        if ( this._pointProgram === undefined ) {

            var vertCode = [
                '#ifdef GL_ES',
                '    precision highp float;',
                '#endif',
                'attribute vec3 Vertex;',
                'attribute vec4 Color;',
                'uniform mat4 uModelViewMatrix;',
                'uniform mat4 uProjectionMatrix;',
                '',
                'varying vec4 FragColor;',
                '',
                'void main(void) {',
                '    gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);',
                '    FragColor = Color;',
                '    gl_PointSize = 10.0;',
                '}'
            ].join( '\n' );
            let fragCode = Utils.getFragmentShader();

            this._pointProgram = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertCode ),
                new osg.Shader( 'FRAGMENT_SHADER', fragCode ) );
        }
        return this._pointProgram;
    },

    drawPoints: function ( positions, color ) {

        var vertices = new Float32Array( 3 * positions.length );
        var colors = new Float32Array( 4 * positions.length );

        for ( var i = 0, j = 0, k = 0; i < positions.length; i++, j += 3, k += 4 ) {
            vertices[ j + 0 ] = positions[ i ][ 0 ];
            vertices[ j + 1 ] = positions[ i ][ 1 ];
            vertices[ j + 2 ] = positions[ i ][ 2 ];

            if ( color ) {
                colors[ k + 0 ] = color[ 0 ];
                colors[ k + 1 ] = color[ 1 ];
                colors[ k + 2 ] = color[ 2 ];
                colors[ k + 3 ] = color[ 3 ];
            } else {
                colors[ k + 0 ] = this._selectionColor[ 0 ];
                colors[ k + 1 ] = this._selectionColor[ 1 ];
                colors[ k + 2 ] = this._selectionColor[ 2 ];
                colors[ k + 3 ] = this._selectionColor[ 3 ];
            }
        }

        var s = new osg.Geometry();
        s.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        s.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
        var sPrimitive = new osg.DrawArrays( osg.primitiveSet.POINTS, 0, positions.length );
        s.getPrimitives().push( sPrimitive );

        s.getOrCreateStateSet().setAttributeAndModes( this.getPointsShader() );
        s.getOrCreateStateSet().setRenderBinDetails( 12, 'DepthSortedBin' );

        return s;
    },

    getShader: function () {

        if ( this._linesOrAreasProgram === undefined ) {

            this._linesOrAreasProgram = new osg.Program( new osg.Shader( 'VERTEX_SHADER', Utils.getVertexShader() ),
                new osg.Shader( 'FRAGMENT_SHADER', Utils.getFragmentShader() ) );
        }
        return this._linesOrAreasProgram;
    },

    cleanLinesOrAreasProgram: function () {
        this._linesOrAreasProgram = undefined;
    },

    drawLines: function ( positions, flatProjection, color ) {

        var vertices = new Float32Array( 3 * positions.length );
        var colors = new Float32Array( 4 * positions.length );

        var zMax;

        for ( var i = 0, j = 0, k = 0; i < positions.length; i++, j += 3, k += 4 ) {
            vertices[ j + 0 ] = positions[ i ][ 0 ];
            vertices[ j + 1 ] = positions[ i ][ 1 ];
            vertices[ j + 2 ] = positions[ i ][ 2 ];

            colors[ k + 0 ] = color[ 0 ];
            colors[ k + 1 ] = color[ 1 ];
            colors[ k + 2 ] = color[ 2 ];
            colors[ k + 3 ] = color[ 3 ];
        }

        if ( flatProjection ) {
            zMax = this.getZMax( positions );
            for ( var n = 2; n < vertices.length; n += 3 ) {
                vertices[ n ] = zMax;
            }
        }

        var s = new osg.Geometry();
        s.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        s.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
        var sPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, 0, positions.length );
        s.getPrimitives().push( sPrimitive );
        s.getOrCreateStateSet().setAttributeAndModes( this.getShader() );

        var lineWidth = new osg.LineWidth( 2.0 );
        s.getOrCreateStateSet().setAttributeAndModes( lineWidth, osg.StateAttribute.ON );


        var m;
        if ( flatProjection ) {
            m = this.createMarkers( positions, zMax );
        }

        return {
            segments: s,
            marker: m
        };

    },

    /**
     * shader to draw the line on cross section. Parameters are commented on shader
     * @method
     * @memberof pcvizRenderTools.SketchTool
     * @return  {object} shader program
     */
    // see https://github.com/mattdesl/webgl-lines/blob/master/projected/vert.glsl
    getScreenLineShader: function () {

        if ( this._screenLinesShader === undefined ) {

            var vertexshader = [
                '#ifdef GL_ES',
                '    precision highp float;',
                '#endif',
                'attribute vec3 Vertex;', // current vertex
                'attribute vec4 Color;', // current color
                'attribute float Directions;', // current direction 1 or -1
                'attribute vec3 NextVertex;', // next vertex
                'attribute vec3 PreviousVertex;', // previous vertex
                'uniform mat4 uModelViewMatrix;',
                'uniform mat4 uProjectionMatrix;',
                'uniform float aspect;', // aspect ratio
                'uniform float lineWidth;',
                '',
                'varying vec4 litColor;',
                '',
                'void main(void) {',
                '   vec2 aspectVec = vec2(aspect, 1.0);',
                '   mat4 projViewModel = uProjectionMatrix * uModelViewMatrix; //projection * view * model;',
                '   vec4 previousProjected = projViewModel * vec4(PreviousVertex, 1.0);',
                '   vec4 currentProjected = projViewModel * vec4(Vertex, 1.0);',
                '   vec4 nextProjected = projViewModel * vec4(NextVertex, 1.0);',

                '   //get 2D screen space with W divide',
                '   vec2 currentScreen = currentProjected.xy / (currentProjected.w) * aspectVec;',
                '   vec2 previousScreen = previousProjected.xy / (previousProjected.w) * aspectVec;',
                '   vec2 nextScreen = nextProjected.xy / (nextProjected.w) * aspectVec;',
                '   float thickness = lineWidth * 0.001;',

                '   //starting point uses (NextVertex - Vertex)',
                '   vec2 dir = vec2(0.0, 0.0);',
                '   if (Vertex == PreviousVertex) {',
                '       dir = normalize(nextScreen - currentScreen);',
                '   } ',
                '   //ending point uses (current - previous)',
                '   else if (Vertex == NextVertex) {',
                '       dir = normalize(currentScreen - previousScreen);',
                '   }',
                '   //somewhere in middle, needs a join',
                '   else {',
                '       //get directions from (C - B) and (B - A)',
                '       vec2 dirAB = currentScreen - previousScreen;',
                '       vec2 dirBC = nextScreen - currentScreen;',
                '       float lenLine = length( dirAB + dirBC );',
                '       dirAB = normalize( dirAB );',
                '       dirBC = normalize( dirBC );',
                '       //now compute the miter join normal and length',
                '       vec2 miterNormal = normalize(dirAB + dirBC);',
                '       float cosAng = abs(dot(dirAB, miterNormal));',
                '       dir = (cosAng < 0.05 )? dirAB : miterNormal;',
                '       // limit small angles to avoid infinite spikes',
                '       float scaleFactor = (cosAng < 0.05 )? 1.0 : max(0.3, cosAng);',
                '       thickness = ( lenLine < 0.01 ) ? thickness: thickness / scaleFactor;',
                '    }',
                '    vec2 normal = vec2(-dir.y, dir.x);',
                '    thickness *= currentProjected.w;',
                '    normal *= thickness;',
                '    normal.x /= aspect;',
                '    vec4 offset = vec4(normal * Directions, 0.0, 0.0);',
                '    gl_Position = currentProjected + offset;',
                '    gl_PointSize = 1.0;',
                '    litColor = Color;',
                '}'
            ].join( '\n' );

            var fragmentshader = [
                '#ifdef GL_ES',
                '    precision highp float;',
                '#endif',
                'varying vec4 litColor;',
                'void main(void) {',
                '    if ( litColor[3] == 0.0 )',
                '      discard;',
                '    gl_FragColor = litColor;',
                '}'
            ].join( '\n' );



            this._screenLinesShader = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexshader ),
                new osg.Shader( 'FRAGMENT_SHADER', fragmentshader ) );
        }
        return this._screenLinesShader;
    },

    /**
     * Method to densify a line buffer based on distance, to avoid display problems when zooming closer
     * @method
     * @memberof pcvizRenderTools.SketchTool
     * @parm {array} positions
     */
    densifyPositions: function ( positions, maxNumPoints ) {

        maxNumPoints = ( maxNumPoints === undefined ) ? 3 : maxNumPoints;

        var densePositions = [];
        var ptCount = 0;
        for ( var i = 0; i < positions.length; i++ ) {
            densePositions[ ptCount ] = [ positions[ i ][ 0 ], positions[ i ][ 1 ], positions[ i ][ 2 ] ];
            ptCount++;
            if ( i < positions.length - 1 ) {
                var incX = positions[ i + 1 ][ 0 ] - positions[ i ][ 0 ];
                var incY = positions[ i + 1 ][ 1 ] - positions[ i ][ 1 ];
                var incZ = positions[ i + 1 ][ 2 ] - positions[ i ][ 2 ];
                var segDist = Math.sqrt( incX * incX + incY * incY + incZ * incZ );

                var lineDensDistance = segDist / maxNumPoints;

                var dist = lineDensDistance;
                while ( segDist > 0 && dist < segDist ) {
                    densePositions[ ptCount ] = [
                        positions[ i ][ 0 ] + dist * incX / segDist,
                        positions[ i ][ 1 ] + dist * incY / segDist,
                        positions[ i ][ 2 ] + dist * incZ / segDist
                    ];
                    dist += lineDensDistance;
                    ptCount++;
                }
            }
        }
        return densePositions;
    },


    /**
     * Method to fill the vertex and attribute buffers for screen lines
     * @method
     * @memberof pcvizRenderTools.SketchTool
     * @parm {array} positions
     */
    populateScreenBuffers: function ( positions, vertex, nextVertex, previousVertex, colors, directions, dataLength, color, zMax, flatProjection ) {

        if ( dataLength > 1 ) {
            for ( var i = 0, j = 0, k = 0; i < dataLength; i++, j += 3, k += 4 ) {
                vertex[ 2 * j + 0 ] = positions[ i ][ 0 ];
                vertex[ 2 * j + 1 ] = positions[ i ][ 1 ];
                vertex[ 2 * j + 2 ] = positions[ i ][ 2 ];
                vertex[ 2 * j + 3 ] = vertex[ 2 * j + 0 ]; // duplication
                vertex[ 2 * j + 4 ] = vertex[ 2 * j + 1 ];
                vertex[ 2 * j + 5 ] = vertex[ 2 * j + 2 ];

                var nextI = ( i === dataLength - 1 ) ? dataLength - 1 : i + 1;
                var prevI = ( i === 0 ) ? 0 : i - 1;

                nextVertex[ 2 * j + 0 ] = positions[ nextI ][ 0 ];
                nextVertex[ 2 * j + 1 ] = positions[ nextI ][ 1 ];
                nextVertex[ 2 * j + 2 ] = positions[ nextI ][ 2 ];
                nextVertex[ 2 * j + 3 ] = nextVertex[ 2 * j + 0 ]; // duplication
                nextVertex[ 2 * j + 4 ] = nextVertex[ 2 * j + 1 ];
                nextVertex[ 2 * j + 5 ] = nextVertex[ 2 * j + 2 ];

                previousVertex[ 2 * j + 0 ] = positions[ prevI ][ 0 ];
                previousVertex[ 2 * j + 1 ] = positions[ prevI ][ 1 ];
                previousVertex[ 2 * j + 2 ] = positions[ prevI ][ 2 ];
                previousVertex[ 2 * j + 3 ] = previousVertex[ 2 * j + 0 ]; // duplication
                previousVertex[ 2 * j + 4 ] = previousVertex[ 2 * j + 1 ];
                previousVertex[ 2 * j + 5 ] = previousVertex[ 2 * j + 2 ];

                colors[ 2 * k + 0 ] = color[ 0 ];
                colors[ 2 * k + 1 ] = color[ 1 ];
                colors[ 2 * k + 2 ] = color[ 2 ];
                colors[ 2 * k + 3 ] = color[ 3 ];
                colors[ 2 * k + 4 ] = color[ 0 ];
                colors[ 2 * k + 5 ] = color[ 1 ];
                colors[ 2 * k + 6 ] = color[ 2 ];
                colors[ 2 * k + 7 ] = color[ 3 ];

                directions[ 2 * i + 0 ] = 1;
                directions[ 2 * i + 1 ] = -1;
            }
            if ( flatProjection ) {
                for ( var n = 2; n < vertex.length; n += 3 ) {
                    vertex[ n ] = zMax;
                    nextVertex[ n ] = zMax;
                    previousVertex[ n ] = zMax;
                }
            }
        }
    },

    /**
     * Method to draw the cross section line an special shader
     * @method
     * @memberof pcvizRenderTools.SketchTool
     * @parm {array} positions
     */
    drawScreenLines: function ( positions, flatProjection, color, lineWidth, alwaysVisible, avoidShader, maxNumPoints ) {

        var zMax = this.getZMax( positions );
        var densePositions = this.densifyPositions( positions, maxNumPoints );
        var dataLength = densePositions.length;

        var vertex = new Float32Array( 3 * 2 * dataLength );
        var nextVertex = new Float32Array( 3 * 2 * dataLength );
        var previousVertex = new Float32Array( 3 * 2 * dataLength );
        var colors = new Float32Array( 4 * 2 * dataLength );
        var directions = new Float32Array( 2 * dataLength );

        this.populateScreenBuffers( densePositions, vertex, nextVertex, previousVertex, colors, directions, dataLength, color, zMax, flatProjection );

        var s = new osg.Geometry();

        //setting up the shader attributes
        s.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertex, 3 );
        s.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
        s.getAttributes().Directions = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, directions, 1 );
        s.getAttributes().NextVertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, nextVertex, 3 );
        s.getAttributes().PreviousVertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, previousVertex, 3 );
        // Setting up the shader uniform
        var aspect = 1;
        if ( this._viewer !== undefined )
            aspect = this._viewer.getCanvas().width / this._viewer.getCanvas().height;
        s.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( aspect, 'aspect' ) ); // adding aspect uniform
        if ( lineWidth === undefined )
            lineWidth = 5.0;

        s.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( lineWidth, 'lineWidth' ) );

        // Disable the culling to avoid bugs
        s.setCullingActive( false );

        // to draw this line we use TRIANGLE_STRIP
        var sPrimitive = new osg.DrawArrays( osg.primitiveSet.TRIANGLE_STRIP, 0, vertex.length / 3 );
        s.getPrimitives().push( sPrimitive );
        if ( !avoidShader )
            s.getOrCreateStateSet().setAttributeAndModes( this.getScreenLineShader() );

        // Set up the depth mode to always, this is to work right with EDL
        s.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( osg.Depth.ALWAYS ) );
        // Put the node on a highest render bin
        if ( alwaysVisible === undefined || alwaysVisible === true )
            s.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_SKETCH_LINES, Utils.RENDERBIN_SKETCH_LINES_TYPE );


        var m;
        if ( flatProjection ) {
            m = this.createMarkers( positions, zMax );
        }

        return {
            segments: s,
            marker: m
        };

    },

    /**
     * Creates the geometry of the given array of vertices.
     * @memberof pcvizRenderTools.SketchTool
     * @method
     * @param  {Array<osg.vec3>} positions The vertices that form the area
     * @param  {boolean} flatProjection If true, draw the horizontal projection (and markers), else draw the 3D mesh.
     * @param  {Array} color The color that has to be used to render the area
     * @param  {Array} vertices The array that has to be filled to be used in the Vertex BufferArray of the area geometry. It is OPTIONAL. (we use this in the AreaTool)
     * @param  {Array} pointCenter The array where store a point at the center of the area, but higher than the surface. It is OPTIONAL. (we use this in the AreaTool)
     *
     * @return {object} An object with the geometries: `area` with the area mesh, `wire` with the lines
     * that form the perimeter, and, when using flat projection, `marker` with the vertical lines that
     * go from the vertices of the area to the intersection with the point cloud.
     */
    drawArea: function ( positions, flatProjection, color, vertices, /*indexes,*/ pointCenter ) {

        if ( vertices === undefined )
            vertices = new Float32Array( 3 * positions.length );
        var colors = new Float32Array( 4 * positions.length );
        var wColors = new Float32Array( 4 * positions.length );

        var zMax, xMax, xMin, yMax, yMin, zMin;

        if ( pointCenter ) {
            xMax = -Number.MAX_VALUE;
            xMin = Number.MAX_VALUE;
            yMax = -Number.MAX_VALUE;
            yMin = Number.MAX_VALUE;
            zMax = -Number.MAX_VALUE;
            zMin = Number.MAX_VALUE;
        }

        for ( var i = 0, j = 0, k = 0; i < positions.length; i++, j += 3, k += 4 ) {
            vertices[ j + 0 ] = positions[ i ][ 0 ];
            vertices[ j + 1 ] = positions[ i ][ 1 ];
            vertices[ j + 2 ] = positions[ i ][ 2 ];

            colors[ k + 0 ] = color[ 0 ];
            colors[ k + 1 ] = color[ 1 ];
            colors[ k + 2 ] = color[ 2 ];
            colors[ k + 3 ] = color[ 3 ];
            wColors[ k + 0 ] = color[ 0 ];
            wColors[ k + 1 ] = color[ 1 ];
            wColors[ k + 2 ] = color[ 2 ];
            wColors[ k + 3 ] = 1.0;

            if ( pointCenter ) {
                xMax = Math.max( xMax, positions[ i ][ 0 ] );
                xMin = Math.min( xMin, positions[ i ][ 0 ] );
                yMax = Math.max( yMax, positions[ i ][ 1 ] );
                yMin = Math.min( yMin, positions[ i ][ 1 ] );
                zMax = Math.max( zMax, positions[ i ][ 2 ] );
                zMin = Math.min( zMin, positions[ i ][ 2 ] );
            }
        }

        if ( pointCenter ) {
            pointCenter[ 0 ] = ( xMax + xMin ) / 2;
            pointCenter[ 1 ] = ( yMax + yMin ) / 2;
            pointCenter[ 2 ] = ( zMax * 3 + zMin ) / 4;
            if ( flatProjection )
                pointCenter[ 2 ] = zMax;
        }


        var indexes = Utils.getPolygonTriangIndexes( vertices );

        if ( flatProjection ) {
            zMax = zMax === undefined ? this.getZMax( positions ) : zMax;
            for ( var n = 2; n < vertices.length; n += 3 ) {
                vertices[ n ] = zMax;
            }
        }

        var g = new osg.Geometry();
        g.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        g.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );

        var stateSet = g.getOrCreateStateSet();
        stateSet.setAttributeAndModes( this.getShader(), osg.StateAttribute.OVERRIDE | osg.StateAttribute.PROTECTED );
        stateSet.setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );
        stateSet.setAttributeAndModes( new osg.BlendFunc( osg.BlendFunc.ONE, osg.BlendFunc.ONE_MINUS_SRC_ALPHA ) );
        stateSet.setRenderBinDetails( 12, 'DepthSortedBin' );

        if ( indexes.length ) {
            var gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes );
            var gPrimitive = new osg.DrawElements( osg.primitiveSet.TRIANGLES, gIndexes );
            g.getPrimitives().push( gPrimitive );
        }

        var w = new osg.Geometry();
        w.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        w.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, wColors, 4 );
        var wPrimitive = new osg.DrawArrays( osg.primitiveSet.LINE_LOOP, 0, positions.length );
        w.getPrimitives().push( wPrimitive );
        w.getOrCreateStateSet().setAttributeAndModes( this.getShader() );

        // can we remove these two lines?
        var lineWidth = new osg.LineWidth( 5.0 );
        w.getOrCreateStateSet().setAttributeAndModes( lineWidth, osg.StateAttribute.ON );
        w.getOrCreateStateSet().setRenderBinDetails( 12, 'DepthSortedBin' );

        var m;
        if ( flatProjection ) {
            m = this.createMarkers( positions, zMax );
        }

        return {
            area: g,
            wire: w,
            marker: m
        };
    },

    createMarkers: function ( positions, zMax ) {
        var mVertices = new Float32Array( 3 * positions.length * 2 );
        var mColors = new Float32Array( 4 * positions.length * 2 );
        for ( var ii = 0, jj = 0, kk = 0; kk < positions.length; ii += 6, jj += 8, kk++ ) {
            mVertices[ ii + 0 ] = mVertices[ ii + 3 ] = positions[ kk ][ 0 ];
            mVertices[ ii + 1 ] = mVertices[ ii + 4 ] = positions[ kk ][ 1 ];
            mVertices[ ii + 2 ] = positions[ kk ][ 2 ];
            mVertices[ ii + 5 ] = zMax;
            mColors[ jj + 0 ] = mColors[ jj + 4 ] = redColor[ 0 ];
            mColors[ jj + 1 ] = mColors[ jj + 5 ] = redColor[ 1 ];
            mColors[ jj + 2 ] = mColors[ jj + 6 ] = redColor[ 2 ];
            mColors[ jj + 3 ] = mColors[ jj + 7 ] = redColor[ 3 ];
        }

        var m = new osg.Geometry();
        m.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, mVertices, 3 );
        m.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, mColors, 4 );
        var mPrimitive = new osg.DrawArrays( osg.primitiveSet.LINES, 0, positions.length * 2 );
        m.getPrimitives().push( mPrimitive );
        m.getOrCreateStateSet().setAttributeAndModes( this.getShader() );

        return m;
    },

    updatePoint: function () {
        var vertexBufferArray, vertices;

        vertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Vertex;
        vertices = vertexBufferArray.getElements();

        vertices[ 0 ] = this._positionsArray[ 0 ][ 0 ];
        vertices[ 1 ] = this._positionsArray[ 0 ][ 1 ];
        vertices[ 2 ] = this._positionsArray[ 0 ][ 2 ];

        this._tempNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
    },

    /* Update the last point */
    updateMultipoint: function () {
        var vertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Vertex;
        var colorsBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Color;

        this.updateBufferArrays( vertexBufferArray, colorsBufferArray, undefined, this._selectionColor, false );

        this._tempNode.getChild( 0 ).getPrimitiveSetList()[ 0 ].count = this._positionsArray.length;
        this._tempNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
        colorsBufferArray.dirty();
    },

    /* Update the last segment */
    updateLines: function ( flatProjection, color ) {
        var vertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Vertex;
        var colorsBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Color;
        var zMax;

        if ( flatProjection )
            zMax = this.getZMax( this._positionsArray );

        this.updateBufferArrays( vertexBufferArray, colorsBufferArray, zMax, color, flatProjection );

        this._tempNode.getChild( 0 ).getPrimitiveSetList()[ 0 ].count = this._positionsArray.length;

        // call dirty method first for the geometry and secondly for the BufferArray
        this._tempNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
        colorsBufferArray.dirty();
        this._tempNode.getChild( 0 ).dirtyBound();

        if ( flatProjection ) {
            this.updateMarkers( zMax );
        }
    },

    /* Update the cross section line point*/
    updateScreenLines: function ( flatProjection, color ) {
        var vertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Vertex;
        var colorsBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Color;
        var directionsBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Directions;
        var nextVertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().NextVertex;
        var prevVertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().PreviousVertex;

        var zMax;

        if ( flatProjection )
            zMax = this.getZMax( this._positionsArray );

        this.updateScreenBufferArrays( this._positionsArray, vertexBufferArray, colorsBufferArray, nextVertexBufferArray, prevVertexBufferArray, directionsBufferArray, zMax, color, flatProjection );

        this._tempNode.getChild( 0 ).getPrimitiveSetList()[ 0 ].count = vertexBufferArray.getElements().length / 3;

        // call dirty method first for the geometry and secondly for the BufferArray
        this._tempNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
        colorsBufferArray.dirty();
        this._tempNode.getChild( 0 ).dirtyBound();

        if ( flatProjection ) {
            this.updateMarkers( zMax );
        }
    },

    /* Update the area according to the new last point */
    updateArea: function ( flatProjection ) {
        var vertexBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Vertex;
        var colorsBufferArray = this._tempNode.getChild( 0 ).getVertexAttributeList().Color;
        var indexes, gIndexes, gPrimitive;
        var zMax;

        if ( flatProjection )
            zMax = this.getZMax( this._positionsArray );

        this.updateBufferArrays( vertexBufferArray, colorsBufferArray, zMax, this._selectionColor, flatProjection );

        indexes = Utils.getPolygonTriangIndexes( vertexBufferArray.getElements() );

        gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes );

        gPrimitive = new osg.DrawElements( osg.primitiveSet.TRIANGLES, gIndexes );

        this._tempNode.getChild( 0 ).getPrimitiveSetList().pop();
        this._tempNode.getChild( 0 ).getPrimitiveSetList().push( gPrimitive );

        this._tempNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
        colorsBufferArray.dirty();

        if ( flatProjection ) {
            this.updateMarkers( zMax );
        }
    },

    updateBufferArrays: function ( vertexBufferArray, colorsBufferArray, zMax, color, flatProjection, positionsArray ) {
        // positionsArray parameter is OPTIONAL, we use it to pass the _positionsArray from the AreaTool
        if ( !positionsArray )
            positionsArray = this._positionsArray.slice( 0 );

        var vertices, verticesAux;
        var colorsElements, colorsAux;

        vertices = vertexBufferArray.getElements();
        verticesAux = new Float32Array( positionsArray.length * 3 );
        verticesAux.set( vertices.slice( 0, positionsArray.length * 3 ), 0 );
        var positionsLastIndex = positionsArray.length - 1;
        verticesAux[ positionsLastIndex * 3 ] = positionsArray[ positionsLastIndex ][ 0 ];
        verticesAux[ positionsLastIndex * 3 + 1 ] = positionsArray[ positionsLastIndex ][ 1 ];
        verticesAux[ positionsLastIndex * 3 + 2 ] = positionsArray[ positionsLastIndex ][ 2 ];

        if ( flatProjection ) {
            for ( var n = 2; n < verticesAux.length; n += 3 ) {
                verticesAux[ n ] = zMax;
            }
        }
        vertexBufferArray.setElements( verticesAux );


        colorsElements = colorsBufferArray.getElements();
        colorsAux = new Float32Array( positionsArray.length * 4 );
        colorsAux.set( colorsElements.slice( 0, positionsArray.length * 4 ), 0 );
        var indexRedComponent = positionsLastIndex * 4;
        colorsAux[ indexRedComponent ] = color[ 0 ];
        colorsAux[ indexRedComponent + 1 ] = color[ 1 ];
        colorsAux[ indexRedComponent + 2 ] = color[ 2 ];
        colorsAux[ indexRedComponent + 3 ] = color[ 3 ];

        colorsBufferArray.setElements( colorsAux );

    },

    updateScreenBufferArrays: function ( positions, vertexBufferArray, colorsBufferArray, nextVertexBufferArray, prevVertexBufferArray, directionsBufferArray, zMax, color, flatProjection ) {

        var densePositions = this.densifyPositions( positions );
        var dataLength = densePositions.length;

        var vertex = new Float32Array( 3 * 2 * dataLength );
        var nextVertex = new Float32Array( 3 * 2 * dataLength );
        var previousVertex = new Float32Array( 3 * 2 * dataLength );
        var colors = new Float32Array( 4 * 2 * dataLength );
        var directions = new Float32Array( 2 * dataLength );

        this.populateScreenBuffers( densePositions, vertex, nextVertex, previousVertex, colors, directions, dataLength, color, zMax, flatProjection );

        // Updating shader attributes
        vertexBufferArray.setElements( vertex );
        colorsBufferArray.setElements( colors );
        nextVertexBufferArray.setElements( nextVertex );
        prevVertexBufferArray.setElements( previousVertex );
        directionsBufferArray.setElements( directions );
    },

    /**
     * Update the markers.
     * @memberof pcvizRenderTools.SketchTool
     * @method
     * @param  {Array} positionsArray The vertices that form the area. It is OPTIONAL, we use it to pass the _positionsArray from the AreaTool
     * @param  {float} zMax The highest z value in the area.
     * @param  {osg.Node} markersNode The osg Node that renders the vertical lines which go from the vertices of the area
     * to the intersection with the point cloud. It is OPTIONAL, we use it to pass the relative osg.Node from the AreaTool
     */
    updateMarkers: function ( zMax, markersNode, positionsArray ) {
        if ( !markersNode )
            markersNode = this._tempNode.getChild( 1 );

        if ( !positionsArray )
            positionsArray = this._positionsArray;

        var vertexBufferArrayMarkers, verticesMarkers, verticesAuxMarkers;
        var colorsBufferArrayMarkers, colorsElementsMarkers, colorsAuxMarkers;
        var positionsLastIndex = positionsArray.length - 1;

        vertexBufferArrayMarkers = markersNode.getVertexAttributeList().Vertex;
        verticesMarkers = vertexBufferArrayMarkers.getElements();

        verticesAuxMarkers = new Float32Array( positionsArray.length * 6 );
        verticesAuxMarkers.set( verticesMarkers.slice( 0, positionsArray.length * 6 ), 0 );
        var lastMarkerFirstIndex = positionsLastIndex * 6;
        verticesAuxMarkers[ lastMarkerFirstIndex ] = verticesAuxMarkers[ lastMarkerFirstIndex + 3 ] = positionsArray[ positionsLastIndex ][ 0 ];
        verticesAuxMarkers[ lastMarkerFirstIndex + 1 ] = verticesAuxMarkers[ lastMarkerFirstIndex + 4 ] = positionsArray[ positionsLastIndex ][ 1 ];
        verticesAuxMarkers[ lastMarkerFirstIndex + 2 ] = positionsArray[ positionsLastIndex ][ 2 ];

        for ( var i = 0; i < positionsArray.length; i++ )
            verticesAuxMarkers[ i * 6 + 5 ] = zMax;

        vertexBufferArrayMarkers.setElements( verticesAuxMarkers );


        colorsBufferArrayMarkers = markersNode.getVertexAttributeList().Color;
        colorsElementsMarkers = colorsBufferArrayMarkers.getElements();
        colorsAuxMarkers = new Float32Array( positionsArray.length * 8 );
        colorsAuxMarkers.set( colorsElementsMarkers.slice( 0, positionsArray.length * 8 ), 0 );
        var indexRedComponent = positionsLastIndex * 8;
        colorsAuxMarkers[ indexRedComponent ] = redColor[ 0 ];
        colorsAuxMarkers[ indexRedComponent + 1 ] = redColor[ 1 ];
        colorsAuxMarkers[ indexRedComponent + 2 ] = redColor[ 2 ];
        colorsAuxMarkers[ indexRedComponent + 3 ] = redColor[ 3 ];

        colorsBufferArrayMarkers.setElements( colorsAuxMarkers );

        markersNode.getPrimitiveSetList()[ 0 ].count = positionsArray.length * 2;

        // call dirty method first for the geometry and secondly for the BufferArray
        markersNode.dirty();
        vertexBufferArrayMarkers.dirty();
        colorsBufferArrayMarkers.dirty();
    },


    clearTool: function () {
        this._tempNode.removeChildren();

        if ( this._gizmo !== undefined ) {
            this._gizmo.removeListeners();
            this._gizmo.removeTextLabel();
            this._gizmo.resetGraph();
            this._tempNode.getParents()[ 0 ].removeChild( this._gizmo );
            this._gizmo = undefined;
        }

        this._geomVertexElements = [];
        this._positionsArray = [];
    },

    getZMax: function ( positions ) {
        var zMax = -Number.MAX_VALUE;

        for ( var i = 0; i < positions.length; i++ ) {
            zMax = Math.max( zMax, positions[ i ][ 2 ] );
        }
        return zMax;
    },

    setSelectionColor: function ( color ) {
        osg.vec4.copy( this._selectionColor, color );
    }

} );

module.exports = SketchTool;


/***/ }),

/***/ "./sources/pcvizRenderTools/SmartPointsTool.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizRenderTools/SmartPointsTool.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SmartPointsTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_ShaderUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js");



const osgDB = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osgDB;
const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;





const ANALYZE_RESULT_FOLDER = 'AnalyzeResult';

/**
 *  Tool to render the smart points for Verification workflow
 *  @class
 *  @memberof pcvizRenderTools
 */
class SmartPointsTool {

    constructor( sceneView ) {
        this._id = 'smartPoints';
        this._sceneView = sceneView;
        this._smartPointsNode = undefined;
        this._smartPointsToolNode = new osg.MatrixTransform();
        this._smartPointsToolNode.setName( 'smartPointsTool' );
        sceneView.getViewer().getToolsNode().addChild( this._smartPointsToolNode );

        this._heatMap = 0;
        this._shadersCache = {};
        this._programsCache = {};
    }

    renderSmartPoints( layer, elementTransform, heatMapInformation ) {
        this._smartPointsToolNode.setMatrix( elementTransform );
        // Currently when rendering new smart points we are going to remove the previous loaded
        // (if they need to be renderered simultaneously we will need to manage the several MT)
        this._smartPointsToolNode.removeChildren();
        if ( !heatMapInformation.PTSFilePath ) {
            this._sceneView.getViewer().requestRedraw();
            return;
        }
        const mountController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Mount' );
        mountController.getMountObject( layer.getId() ).getMountObject().then( ( mount ) => {
            let analyzeResultPath = mount.mountPoint + '/' + ANALYZE_RESULT_FOLDER;
            let smartPointsUrl = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.sanitizeUrlInPlace( `${analyzeResultPath}/${heatMapInformation.PTSFilePath}` );


            // If we need to create a timestamp in the cache for the file, do it here
            // Retrieve smart points from the storage url of the layer
            osgDB.readNodeURL( smartPointsUrl, {
                center: this._sceneView.getCenter(), // the center is used in each vertice (Read comment on pcvizTools/ControlPointVizTool.js)
                layer: layer
            } ).then( ( smartPointsNode ) => {
                // This reprojects the geometry and centers the model with the internal transformation
                // var reprojectGeometryVisitor = new ReprojectGeometryVisitor( 'EPSG:4978', epsg, self.getCenter() );
                //  child.accept( reprojectGeometryVisitor );
                // TODO: check to avoid an error in case that this function is called twice 'simultaneously'
                this._smartPointsToolNode.addChild( smartPointsNode );
                this._smartPointsNode = smartPointsNode;
                this.addHeatmapInfo( layer, heatMapInformation );
                this.addHeatmapUniforms();
                this._sceneView.getViewer().requestRedraw();
            } ).catch( ( error ) => {
                // Error reading smart points - nothing to do..
                pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getController( 'Error' ).addError( error );
            } );

        } );
    }

    addHeatmapInfo( layer, heatMapInformation ) {
        let pointsGeometry = this._smartPointsNode.getChild( 0 );
        let analyzeResultPath = ANALYZE_RESULT_FOLDER;
        let heatmapUrl = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.sanitizeUrlInPlace( `${analyzeResultPath}/${heatMapInformation.HeatMapFilePath}` );

        layer.getDriver().getObjectFile( layer, heatmapUrl, true ).then( ( data ) => {

            let lines = data.split( '\n' );

            let numHeatmapData = lines.length - 1;
            if ( lines[ numHeatmapData ] === '' )
                numHeatmapData--;

            let numSmartPoints = pointsGeometry.getAttributes().PointSize.getElements().length;
            let numHeatMaps = new Uint8Array( numSmartPoints );

            // Read line 2 to know how many heatmaps are
            let line2 = lines[ 1 ];
            let lineSplitted = line2.split( ' ' );
            let heatMapsLength = lineSplitted.length - 1;

            // Initialize heatmap bufferarrays
            for ( let k = 0; k < heatMapsLength; k++ ) {
                let heatMapValues = new Float32Array( numSmartPoints );
                // init to -1 (or to use 'numHeatMaps' Attribute to know if there are heatmaps but we would need to add it to the shader)
                heatMapValues.fill( -1 );
                pointsGeometry.getAttributes()[ 'HeatMap_' + k.toString() ] = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, heatMapValues, 1, true );
            }

            for ( let i = 0; i < numHeatmapData; i++ ) {
                let heatmapData = lines[ i + 1 ];

                let heatmapDataComponents = heatmapData.split( ' ' );

                // if there are the same numHeatMaps for every point, we only need to store it in a var
                numHeatMaps[ heatmapDataComponents[ 0 ] - 1 ] = heatmapDataComponents.length - 1; // it should be the same than heatMapsLength

                for ( let j = 1; j < heatmapDataComponents.length; j++ ) {
                    pointsGeometry.getAttributes()[ 'HeatMap_' + ( j - 1 ).toString() ].getElements()[ heatmapDataComponents[ 0 ] - 1 ] = parseFloat( heatmapDataComponents[ j ] );
                }
            }

            pointsGeometry.getAttributes().NumHeatMaps = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, numHeatMaps, 1, true );
            pointsGeometry.dirty();
        } ).catch( () => {
            pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getController( 'Error' ).addError( 'Error getting heatmap file for smart points' );
        } );

    }

    setHeatMap( value ) {
        this._heatMap = value;
        // update shader (instead of doing this here, we could create a new Attribute and add link it to the ShaderGenerator)
        // First try to get from cache, if it doesn't exist call to ShaderUtils.getVertexShader
        let program = this._programsCache[ this._heatMap ];
        if ( !program ) {
            let vertexShader = this._shadersCache[ this._heatMap ];
            if ( !vertexShader ) {
                vertexShader = pcvizUtils_ShaderUtils__WEBPACK_IMPORTED_MODULE_3__["default"].getVertexShaderForPoints( this._heatMap );
                this._shadersCache[ this._heatMap ] = vertexShader;
            }

            let programFragShader = this._smartPointsNode.getOrCreateStateSet().getAttribute( 'Program' ).getFragmentShader();
            program = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), programFragShader );
            this._programsCache[ this._heatMap ] = program;
        }

        this._smartPointsNode.getOrCreateStateSet().setAttributeAndModes( program );
    }

    hasSmartPoints() {
        return this._smartPointsToolNode.getChildren().length > 0;
    }

    clearSmartPoints() {
        this._smartPointsToolNode.removeChildren();
    }

    addHeatmapUniforms() {
        let gradientRange = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'UserPreferences' ).getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.VERITY_HEATMAP_GRADIENT_RANGE_KEY );
        this._smartPointsNode.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( gradientRange, 'heatmapOptionsGradientRange' ) );

        let gradientStyle = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'UserPreferences' ).getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.VERITY_HEATMAP_GRADIENT_STYLE_KEY );
        let numSteps = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'UserPreferences' ).getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.VERITY_HEATMAP_STEPS_KEY );
        let tolerance = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'UserPreferences' ).getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.VERITY_HEATMAP_TOLERANCE_KEY );
        this._smartPointsNode.getOrCreateStateSet().addUniform( osg.Uniform.createInt1( gradientStyle, 'heatmapOptionsGradientStyle' ) );
        this._smartPointsNode.getOrCreateStateSet().addUniform( osg.Uniform.createInt1( numSteps, 'heatmapOptionsNumberOfSteps' ) );
        this._smartPointsNode.getOrCreateStateSet().addUniform( osg.Uniform.createFloat1( tolerance, 'toleranceInModelUnits' ) );
    }

    changeTolerance( tolerance ) {
        if ( !this._smartPointsNode )
            return;
        const osgStateSet = this._smartPointsNode.getOrCreateStateSet();
        const toleranceUniform = osgStateSet.getUniform( 'toleranceInModelUnits' );
        toleranceUniform.setFloat( tolerance );
    }

    changeNumberOfSteps( steps ) {
        let osgStateSet = this._smartPointsNode.getOrCreateStateSet();
        let stepsUniform = osgStateSet.getUniform( 'heatmapOptionsNumberOfSteps' );
        stepsUniform.setInt( steps );
    }

    changeGradientStyle( style ) {
        let osgStateSet = this._smartPointsNode.getOrCreateStateSet();
        let gradientStyleUniform = osgStateSet.getUniform( 'heatmapOptionsGradientStyle' );
        gradientStyleUniform.setInt( style );
    }


    changeGradientRange( multiplier ) {
        let osgStateSet = this._smartPointsNode.getOrCreateStateSet();
        let gradientRangeUniform = osgStateSet.getUniform( 'heatmapOptionsGradientRange' );
        gradientRangeUniform.setFloat( multiplier );
    }

    // These methods are needed to add the tool to the toolbar
    setToolbar() {}

    setGroup() {}

    isToolActive() {
        return false;
    }

    getId() {
        return this._id;
    }
}


/***/ }),

/***/ "./sources/pcvizRenderTools/StationLinkTool.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizRenderTools/StationLinkTool.js ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return StationLinkTool; });
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js");
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_1__);

var MarkerSymbol3D = __webpack_require__( /*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js" ).MarkerSymbol3D;
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );


const osg = OSG__WEBPACK_IMPORTED_MODULE_1___default.a.osg;

/**
 * A class that renders a link between two stations using the information of the link array from the c2c process.
 * The link is drawn as a line with an icon
 * @class
 * @memberof pcvizRenderTools
 * @extends SketchTool
 */
class StationLinkTool extends pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0___default.a {

    /**
     * Constructor of the StationLinkTool
     * @method
     * @memberof pcvizRenderTools.StationLinkTool
     * @param {SceneView} sceneView The SceneView the tool is attached to.
     */
    constructor( sceneView ) {
        super( sceneView.getViewer() );
        this._id = 'linkStation';

        this._linkNode = sceneView.getViewer().getToolsNode().getChildren().find( node => node.getName() === 'Link station node' );

        if ( this._linkNode === undefined )
            this._linkNode = new osg.MatrixTransform();

        if ( this._temporalLinksNode === undefined )
            this._temporalLinksNode = new osg.Node();

        this._linkNode.setName( 'Link station node' );
        this._temporalLinksNode.setName( 'Temporal Link station node' );

        this._linkArray = [];
        this._lineWidth = 10;

        this._linkIconTypes = [];
        this._iconArray = [];
        this._iconSize = 4.5 * window.devicePixelRatio;

        sceneView.getViewer().getToolsNode().addChild( this._linkNode );
        sceneView.getViewer().getToolsNode().addChild( this._temporalLinksNode );
        this._temporalIconArray = [];

        this._iconSymbols = new Map();

        this._pixelsMargin = 0;
        if ( ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) && Utils.isEdge() )
            this._pixelsMargin = 5;
    }

    /**
     * linkArray is an array of pairs of positions and the type of the position.
     * format element = {
     *      source (vec3)
     *      target (vec3)
     *      linkType (Utils.REGISTRATION_COLOR_TYPE)
     *      }
     */
    setLinkArray( linkArray ) {
        this._linkArray = this.parseLinkArray( linkArray );
    }

    /**
     * linkIconsTypes is an array of icon types to draw with his own click.
     * format element = {
     *      type (string)
     *      click (function)
     *      }
     */
    setLinkIconsTypes( linkIconsTypes ) {
        this._linkIconTypes = linkIconsTypes;
        // Create the necessary symbols
        this._linkIconTypes.forEach( element => {
            if ( element.type === 'link' ) { // Create an iconSymbol for any color of link icon
                this._iconSymbols.set( element.type + '-low', new MarkerSymbol3D() );
                this._iconSymbols.set( element.type + '-none', new MarkerSymbol3D() );
                this._iconSymbols.set( element.type + '-high', new MarkerSymbol3D() );
                this._iconSymbols.set( element.type + '-medium', new MarkerSymbol3D() );
                this._iconSymbols.set( element.type + '-unselected', new MarkerSymbol3D() );
            } else {
                this._iconSymbols.set( element.type, new MarkerSymbol3D() );
            }
        } );
    }

    /**
     * Activates or deactivates the tool THIS METHOD IS NOT BEING USED!
     * @method
     * @memberof pcvizRenderTools.StationLinkTool
     * @param {boolean} active To activate or deactivate the tool
     */
    setActive( active ) {
        if ( this._active === active )
            return;

        this._active = active;

        if ( !active ) {
            this._linkNode.removeChildren();
            this._temporalLinksNode.removeChildren();
        } else {
            this.initGraph();

        }
        this._layerGizmo.setToolIsActive( active );
    }

    clearLinks() {
        this._linkNode.removeChildren();
        this._temporalLinksNode.removeChildren();
        this._iconArray = [];
        this._temporalIconArray = [];

        let event = new Event( 'StationLinkTool:update' );
        document.dispatchEvent( event );
    }

    getStationPosition( station ) {
        // Getting the data cache object
        let wsDataCacheObject = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( station.uuid );
        if ( wsDataCacheObject === undefined || wsDataCacheObject.getOsgNodeObj() === undefined )
            return;
        // Getting osg node
        let osgNode = wsDataCacheObject.getOsgNodeObj();
        let nodePath = Utils.computeNodePath( osgNode );
        nodePath.push( osgNode );
        let modelMat = osg.computeLocalToWorld( nodePath, true );

        return osg.mat4.getTranslation( [], modelMat );
    }

    parseLinkArray( linkArray ) {
        let links = [];

        linkArray.forEach( element => {
            let l = {
                source: this.getStationPosition( element.fixedStation ),
                target: this.getStationPosition( element.movingStation ),
                linkType: element.linkType ? element.linkType : Utils.REGISTRATION_COLOR_TYPE.NONE
            };
            if ( l.source === undefined || l.target === undefined )
                return;
            links.push( l );
        } );
        return links;
    }

    /**
     * 
     */
    drawLinks( index, temporalLinks ) {
        this.removeEventListeners();
        let node = this._linkNode;
        let linkArray = this._linkArray;
        if ( temporalLinks ) {
            node = this._temporalLinksNode;
            linkArray = this._temporalLinkArray;
            this._temporalIconArray = [];
        } else
            this._iconArray = [];
        node.removeChildren();


        if ( linkArray.length === 0 )
            return;

        let iconOffset = this._iconSize;
        linkArray.forEach( ( link, linkIndex ) => {
            if ( index !== undefined && index !== linkIndex )
                return;
            let positions = [];
            let mt = new osg.MatrixTransform();
            osg.mat4.fromTranslation( mt.getMatrix(), link.source ); // Use MT to avoid large coordinates in geometries

            positions.push( [ 0, 0, 0 ] );
            positions.push( osg.vec3.subtract( [], link.target, link.source ) );
            let color = Utils.REGISTRATION_COLOR[ link.linkType ];
            let geometries = this.drawScreenLines( positions, false, color, this._lineWidth );

            let position = osg.vec3.fromValues( ( link.source[ 0 ] + link.target[ 0 ] ) / 2.0, ( link.source[ 1 ] + link.target[ 1 ] ) / 2.0, ( link.source[ 2 ] + link.target[ 2 ] ) / 2.0 );

            for ( let i = 0; i < this._linkIconTypes.length; i++ ) {
                let icon = this.drawLinksIcon( position, link, color, linkIndex, this._linkIconTypes[ i ], temporalLinks );

                node.addChild( icon );

                // Next icon position
                position = osg.vec3.fromValues( position[ 0 ] + iconOffset, position[ 1 ], position[ 2 ] );
            }
            node.addChild( mt );
            if ( geometries.segments !== undefined )
                mt.addChild( geometries.segments );
        } );
        let event = new Event( 'StationLinkTool:update' );
        document.dispatchEvent( event );
        this.setUpEventListeners();
    }

    drawLinksIcon( position, link, linkColor, linkIndex, iconType, temporalLinks ) {

        let style = { // Definition of the icon's style
            PointSymbolizer: {
                marker: iconType.img,
                billboard: true,
                autoScale: true,
                size: this._iconSize,
                color: linkColor
            }
        };

        let iconKey = iconType.type;
        let uniformColor = linkColor;

        // Special case for link icons with different colors
        if ( iconType.type === 'link' ) {
            style.PointSymbolizer.marker += link.linkType + '.png';
            iconKey += '-' + link.linkType;
            style.PointSymbolizer.color = [ 1.0, 1.0, 1.0, 1.0 ];
            uniformColor = [ 1.0, 1.0, 1.0, 1.0 ];
        }

        this._iconSymbols.get( iconKey ).configure( style );
        let customStateSet = new osg.StateSet();
        let iconArray = temporalLinks ? this._temporalIconArray : this._iconArray;
        let iconNode = this._iconSymbols.get( iconKey ).renderMarker( position, iconArray.length, undefined, osg.vec3.create(), true, customStateSet );
        iconNode.setMaximumScale( 0.1 );
        iconNode.setMinimumScale( 0.00001 );
        iconNode.children[ 0 ].setName( 'LinkIcon' );

        iconNode.getOrCreateStateSet().addUniform( osg.Uniform.createFloat4( uniformColor, 'color' ) );

        // Store it in a local array for control clicks
        iconArray.push( {
            geomId: iconNode.children[ 0 ]._instanceID,
            linkId: linkIndex,
            type: iconType.type,
            click: temporalLinks ? ( index ) => { iconType.clickTemporal( index ); } : ( index, hit ) => { iconType.click( index, hit ); }
        } );

        return iconNode;
    }

    isDrag( x, y ) {
        return ( Math.abs( x - this.mousePosX ) > this._pixelsMargin || Math.abs( y - this.mousePosY ) > this._pixelsMargin );
    }

    mouseupFunction( ev ) {
        if ( this.isDrag( ev.clientX, ev.clientY ) ) {
            this.mousePosX = 0.0;
            this.mousePosY = 0.0;
            return;
        }

        var isMobile = Utils.isTouchEnabled();
        var clientX, clientY;
        if ( isMobile && ev.type === 'touchend' ) {
            clientX = ev.changedTouches[ 0 ].clientX;
            clientY = ev.changedTouches[ 0 ].clientY;
        } else {
            clientX = ev.clientX;
            clientY = ev.clientY;
        }

        let offset = [];
        this._viewer.getOffsetRect( this._viewer._canvas, offset );
        var ratioX = this._viewer._canvas.width / this._viewer._canvas.clientWidth;
        var ratioY = this._viewer._canvas.height / this._viewer._canvas.clientHeight;

        var x = ( ( clientX - offset[ 1 ] ) * ratioX );
        var y = ( ( this._viewer._canvas.clientHeight - ( clientY - offset[ 0 ] ) ) * ratioY );

        this._viewer.limitIntersections( false );
        var hits = this._viewer.computeIntersections( x, y );
        this._viewer.limitIntersections( true );

        let iconHit;
        for ( let hit of hits ) {
            if ( hit._drawable.getName() === 'LinkIcon' ) {
                iconHit = hit;
                break;
            }
        }

        if ( !iconHit ) {
            return;
        }

        var iconHitId = iconHit._drawable._instanceID;
        this._iconArray.forEach( ( iconData ) => {
            if ( iconData.geomId === iconHitId ) {
                iconData.click( iconData.linkId, iconHit );
            }
        } );
        this._temporalIconArray.forEach( ( iconData ) => {
            if ( iconData.geomId === iconHitId ) {
                iconData.click( iconData.linkId );
            }
        } );
    }

    mousedownFunction( ev ) {

        // save the mouse position to check if there's a drag event
        this.mousePosX = ev.clientX;
        this.mousePosY = ev.clientY;

        ev.stopPropagation();
    }

    setUpEventListeners() {
        var canvas = this._viewer.getCanvas();

        if ( !this._mouseupFunction ) {
            this._mouseupFunction = this.mouseupFunction.bind( this );
            canvas.addEventListener( 'mouseup', this._mouseupFunction );
        }
        if ( !this._mousedownFunction ) {
            this._mousedownFunction = this.mousedownFunction.bind( this );
            canvas.addEventListener( 'mousedown', this._mousedownFunction );
        }
    }

    removeEventListeners() {
        var canvas = this._viewer.getCanvas();

        canvas.removeEventListener( 'mouseup', this._mouseupFunction );
        this._mouseupFunction = undefined;
        canvas.removeEventListener( 'mousedown', this._mousedownFunction );
        this._mousedownFunction = undefined;
    }

    setTemporalLinkArray( linkArray ) {
        this._temporalLinkArray = this.parseLinkArray( linkArray );
    }

    clearTemporalLinksNode() {
        this._temporalLinksNode.removeChildren();
    }

    isRenderingLinks() {
        return this._linkNode.getNumChildren() > 0;
    }
}


/***/ }),

/***/ "./sources/pcvizRenderTools/pcvizRenderTools.js":
/*!******************************************************!*\
  !*** ./sources/pcvizRenderTools/pcvizRenderTools.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js");
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizRenderTools_CompassTool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizRenderTools/CompassTool */ "./sources/pcvizRenderTools/CompassTool.js");
/* harmony import */ var pcvizRenderTools_CompassTool__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_CompassTool__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizRenderTools_GridTool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizRenderTools/GridTool */ "./sources/pcvizRenderTools/GridTool.js");
/* harmony import */ var pcvizRenderTools_GridTool__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_GridTool__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizRenderTools_HighlightFeatureTool__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizRenderTools/HighlightFeatureTool */ "./sources/pcvizRenderTools/HighlightFeatureTool.js");
/* harmony import */ var pcvizRenderTools_StationLinkTool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizRenderTools/StationLinkTool */ "./sources/pcvizRenderTools/StationLinkTool.js");
/* harmony import */ var pcvizRenderTools_PrismPoleTool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizRenderTools/PrismPoleTool */ "./sources/pcvizRenderTools/PrismPoleTool.js");
/* harmony import */ var pcvizRenderTools_SmartPointsTool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizRenderTools/SmartPointsTool */ "./sources/pcvizRenderTools/SmartPointsTool.js");
/* harmony import */ var _HelperArrowTool__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./HelperArrowTool */ "./sources/pcvizRenderTools/HelperArrowTool.js");









/** @namespace pcvizRenderTools */
const pcvizRenderTools = {
    SketchTool: (pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_0___default()),
    CompassTool: (pcvizRenderTools_CompassTool__WEBPACK_IMPORTED_MODULE_1___default()),
    GridTool: (pcvizRenderTools_GridTool__WEBPACK_IMPORTED_MODULE_2___default()),
    HighlightFeatureTool: pcvizRenderTools_HighlightFeatureTool__WEBPACK_IMPORTED_MODULE_3__["default"],
    StationLinkTool: pcvizRenderTools_StationLinkTool__WEBPACK_IMPORTED_MODULE_4__["default"],
    PrismPoleTool: pcvizRenderTools_PrismPoleTool__WEBPACK_IMPORTED_MODULE_5__["default"],
    SmartPointsTool: pcvizRenderTools_SmartPointsTool__WEBPACK_IMPORTED_MODULE_6__["default"],
    HelperArrowTool: _HelperArrowTool__WEBPACK_IMPORTED_MODULE_7__["default"]
};


pcvizRenderTools.HIGHLIGHT_FEATURE = 'highlightFeature';

/* harmony default export */ __webpack_exports__["default"] = (pcvizRenderTools);


/***/ }),

/***/ "./sources/pcvizSceneModes/ControlPointMode.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizSceneModes/ControlPointMode.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Mode = __webpack_require__( /*! pcvizSceneModes/Mode */ "./sources/pcvizSceneModes/Mode.js" );
/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var ControlPointMode = function ( id, cameraManipulator, tool ) {
    Mode.call( this, id, cameraManipulator, tool );
    this._sceneView = undefined;
};

ControlPointMode.prototype = Utils.objectInherit( Mode.prototype, {
    changeMode: function ( mode, sceneView, config ) {
        this._sceneView = sceneView;
        if ( mode !== this._id ) {
            return;
        }

        // Setup image
        if ( this._tool !== undefined ) {
            config = this._tool.setImageManipulatorPosition();
            this._sceneView.setImagePriority( this._sceneView.getImagePriority() );
        }

        this.setViewingParams( config );
    },

    setViewingParams: function ( config ) {
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        var viewMatrix = this._sceneView.getViewer().getCamera().getViewMatrix();
        this._cameraManipulator = this._sceneView.getViewer().getOrCreatePlanarImageManipulator();
        this._cameraManipulator.init();

        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        this._sceneView.setManipulator( this._cameraManipulator );
        if ( !config.position ) {
            osg.warn( 'config.position is undefined.' );
            return;
        }

        if ( !this._sceneView.hasSavedCameraInfo() ) {
            // Camera info is saved to be restored when leaving planar image mode
            this._sceneView.saveCameraInfo( eye, center, up );
        }
        if ( config.forward && config.up ) {
            osg.vec3.add( center, config.position, config.forward );
            osg.vec3.copy( up, config.up );
            osg.vec3.copy( eye, config.position );
            this._sceneView.setPose( eye, center, up );
            this._sceneView.getManipulator().setFOVY( config.fovy );
        }
        this._sceneView.setPresentVR( true );
    }

} );

module.exports = ControlPointMode;


/***/ }),

/***/ "./sources/pcvizSceneModes/Mode.js":
/*!*****************************************!*\
  !*** ./sources/pcvizSceneModes/Mode.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var Mode = function ( id, cameraManipulator, tool ) {
    this._id = id;
    this._cameraManipulator = cameraManipulator;

    // position
    this._eye = undefined;
    this._center = undefined;
    this._up = undefined;

    // tool
    this._tool = tool;
    // View preferences ??

};

Mode.prototype = {
    getId: function () {
        return this._id;
    },

    getTool: function () {
        return this._tool;
    },

    init: function () {

    },

    modeSetup: function () {

    },

    update: function () {

    },

    changeMode: function ( /*mode,sceneView, config*/) {

    }


};

module.exports = Mode;


/***/ }),

/***/ "./sources/pcvizSceneModes/ModeManipulator.js":
/*!****************************************************!*\
  !*** ./sources/pcvizSceneModes/ModeManipulator.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 *  ModeManipulator
 *  @class
 *  @memberof pcvizSceneModes
 */
var ModeManipulator = function () {
    this._modesMap = new Map();
    this._currentMode = undefined;
};

ModeManipulator.prototype = {
    addMode: function ( key, object ) {
        if ( this._currentMode === undefined )
            this._currentMode = key;
        this._modesMap.set( key, object );
    },

    getMode: function ( key ) {
        return this._modesMap.get( key );
    },

    clear: function () {
        this._modesMap.clear();
    },

    setCurrentMode: function ( modeId, sceneView, config ) {
        this._currentMode = modeId;
        this.modeChange( this._currentMode, sceneView, config );
    },

    getCurrentMode: function () {
        return this._currentMode;
    },

    getModeList: function () {
        var modes = [];
        this._modesMap.forEach( function ( mode ) {
            modes.push( mode );
        } );
        return modes;
    },

    updateCurrentMode: function () {
        var mode = this.getMode( this._currentMode );
        if ( mode )
            mode.update();
    },

    modeChange: function ( setMode, sceneView, config ) {
        this._modesMap.forEach( function ( mode ) {
            mode.changeMode( setMode, sceneView, config );
        } );
    }

};

module.exports = ModeManipulator;


/***/ }),

/***/ "./sources/pcvizSceneModes/NormalMode.js":
/*!***********************************************!*\
  !*** ./sources/pcvizSceneModes/NormalMode.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Mode = __webpack_require__( /*! pcvizSceneModes/Mode */ "./sources/pcvizSceneModes/Mode.js" );
/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var NormalMode = function ( id, cameraManipulator, tool ) {
    Mode.call( this, id, cameraManipulator, tool );
    this._lastTarget = undefined;
    this._lastPivotPoint = undefined;
    this._active = true;
};

NormalMode.prototype = Utils.objectInherit( Mode.prototype, {
    changeMode: function ( mode, sceneView ) {
        if ( mode !== this._id ) {
            if ( !this._cameraManipulator )
                this._cameraManipulator = sceneView.getViewer().getOrCreateCADManipulator();
            if ( this._active && this._cameraManipulator ) {
                this._lastTarget = this._cameraManipulator._target;
                this._lastPivotPoint = this._cameraManipulator._pivotPoint;
                this._active = false;
            }
            return;
        }

        this._active = true;
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        var viewMatrix = sceneView.getViewer().getCamera().getViewMatrix();
        this._cameraManipulator = sceneView.getViewer().getOrCreateCADManipulator();
        this._cameraManipulator.setUsePolytopeIntersector( true );
        this._cameraManipulator.init();
        sceneView.setManipulator( this._cameraManipulator );

        // This is a hack to work around a bug in osgjs library. When
        // deactivating CADManipulatorHammerController event listeners are
        // removed and never added again when enabling it.
        var hammer = this._cameraManipulator.getControllerList()[ 'Hammer' ];
        if ( hammer._eventProxy ) {
            hammer._eventProxy.on( 'panstart ', hammer._cbPanStart );
            hammer._eventProxy.on( 'panmove', hammer._cbPanMove );
            hammer._eventProxy.on( 'panend', hammer._cbPanEnd );
            hammer._eventProxy.on( 'pinchstart', hammer._cbPinchStart );
            hammer._eventProxy.on( 'pinchend', hammer._cbPinchEnd );
            hammer._eventProxy.on( 'pinchin pinchout', hammer._cbPinchInOut );
            hammer._eventProxy.on( 'tap', hammer._cbDoubleTap );
        }

        if ( sceneView._savedEye ) {
            osg.vec3.copy( eye, sceneView._savedEye );
            osg.vec3.copy( center, sceneView._savedCenter );
            osg.vec3.copy( up, sceneView._savedUp );
            sceneView._savedEye = sceneView._savedCenter = sceneView._savedUp = undefined;
        } else {
            osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );
        }

        sceneView.setPose( eye, center );

        this._cameraManipulator.computeHomePosition();
        this._cameraManipulator.setPivotPoint( center );
        sceneView.setPresentVR( false );

        var renderSettings = sceneView._project.getCurrentRenderSettings();
        sceneView.getViewer().setFOV( renderSettings ? renderSettings.get( 'fieldOfView' ) : 1.0 );

        if ( this._lastTarget ) {
            this._cameraManipulator._target = this._lastTarget;
            sceneView.getViewer().computeCADManipulatorTarget( this._lastTarget );
        }
        if ( this._lastPivotPoint ) {
            this._cameraManipulator._pivotPoint = this._lastPivotPoint;
        }

    }
} );

module.exports = NormalMode;


/***/ }),

/***/ "./sources/pcvizSceneModes/PanoramaMode.js":
/*!*************************************************!*\
  !*** ./sources/pcvizSceneModes/PanoramaMode.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osg = OSG.osg;
const Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
const Mode = __webpack_require__( /*! pcvizSceneModes/Mode */ "./sources/pcvizSceneModes/Mode.js" );
const PanoramaSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PanoramaSymbol3D */ "./sources/pcvizGISRenderer/PanoramaSymbol3D.js" );
const pcvizTools = __webpack_require__( /*! pcvizTools/pcvizTools */ "./sources/pcvizTools/pcvizTools.js" ).default;
/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var PanoramaMode = function ( id, cameraManipulator, tool ) {
    Mode.call( this, id, cameraManipulator, tool );
};

PanoramaMode.prototype = Utils.objectInherit( Mode.prototype, {
    changeMode: function ( mode, sceneView, config ) {
        if ( mode !== this._id ) {
            this.disablePanoramaMode( sceneView );
            return;
        }
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        var viewMatrix = sceneView.getViewer().getCamera().getViewMatrix();
        var dir = osg.vec3.create64();

        this._cameraManipulator = sceneView.getViewer().getOrCreatePanoramaManipulator();
        this._cameraManipulator.init();
        // removing the key methods to do not compute keyboard
        this._cameraManipulator.getControllerList().StandardMouseKeyboard.keydown = undefined;
        this._cameraManipulator.getControllerList().StandardMouseKeyboard.keyup = undefined;

        // call to intercept for CollageSite (UWP)
        if ( sceneView.getViewer().shouldInterceptMouseFn() )
            sceneView.getViewer().interceptControllerFunctions( this._cameraManipulator );

        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        sceneView.setManipulator( this._cameraManipulator );
        if ( config && config.position ) {

            if ( !sceneView._savedEye ) {
                // Camera info is saved to be restored when leaving panorama mode
                sceneView.saveCameraInfo( eye, center, up );
            }
            if ( config.direction ) { // if direction is provided, use it
                osg.vec3.copy( dir, config.direction );
            } else { // calculate direction
                osg.vec3.sub( dir, config.position, center );
                dir[ 2 ] = 0;
                osg.vec3.normalize( dir, dir );
            }
            osg.vec3.add( center, config.position, dir );
            osg.vec3.copy( eye, config.position );
        }
        sceneView.setPose( eye, center );
    },

    disablePanoramaMode: function ( sceneView ) {
        PanoramaSymbol3D.getImageNodeInstance().setImageMode( false );
        if ( !sceneView.getTool( pcvizTools.INFORMATION ) || !sceneView.getTool( pcvizTools.INFORMATION ).isToolActive() ) {
            return;
        }
        const panoramaOnMode = sceneView.getTool( pcvizTools.INFORMATION ).findActivePanoramaLayer();
        if ( !panoramaOnMode ) {
            return;
        }
        panoramaOnMode.getFeatureRenderer().getSymbol().setOnPanoramaMode( false );
    }
} );

module.exports = PanoramaMode;


/***/ }),

/***/ "./sources/pcvizSceneModes/PlanarImageMode.js":
/*!****************************************************!*\
  !*** ./sources/pcvizSceneModes/PlanarImageMode.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Mode = __webpack_require__( /*! pcvizSceneModes/Mode */ "./sources/pcvizSceneModes/Mode.js" );
var PlanarImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PlanarImageSymbol3D */ "./sources/pcvizGISRenderer/PlanarImageSymbol3D.js" );
/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var PlanarImageMode = function ( id, cameraManipulator, tool ) {
    Mode.call( this, id, cameraManipulator, tool );
};

PlanarImageMode.prototype = Utils.objectInherit( Mode.prototype, {
    changeMode: function ( mode, sceneView, config ) {
        if ( mode !== this._id ) {
            PlanarImageSymbol3D.getImageNodeInstance().setImageMode( false );
            return;
        }
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        var viewMatrix = sceneView.getViewer().getCamera().getViewMatrix();
        this._cameraManipulator = sceneView.getViewer().getOrCreatePlanarImageManipulator();
        this._cameraManipulator.init();

        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        sceneView.setManipulator( this._cameraManipulator );
        if ( !config.position ) {
            osg.warn( 'config.position is undefined.' );
            return;
        }

        if ( !sceneView._savedEye ) {
            // Camera info is saved to be restored when leaving planar image mode
            sceneView.saveCameraInfo( eye, center, up );
        }
        if ( config.forward && config.up ) {
            osg.vec3.add( center, config.position, config.forward );
            osg.vec3.copy( up, config.up );
            osg.vec3.copy( eye, config.position );
            sceneView.setPose( eye, center, up );
            sceneView.getManipulator().setFOVY( config.fovy );
        }
        sceneView.setPresentVR( true );
    }
} );

module.exports = PlanarImageMode;


/***/ }),

/***/ "./sources/pcvizSceneModes/RegionMode.js":
/*!***********************************************!*\
  !*** ./sources/pcvizSceneModes/RegionMode.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//var OSG = require( 'OSG' );
//var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var Mode = __webpack_require__( /*! pcvizSceneModes/Mode */ "./sources/pcvizSceneModes/Mode.js" );
/**
 *  Modes
 *  @class
 *  @memberof pcvizSceneModes
 */
var RegionMode = function ( id, cameraManipulator, tool ) {
    Mode.call( this, id, cameraManipulator, tool );
    this._sceneView = undefined;
};

RegionMode.prototype = Utils.objectInherit( Mode.prototype, {
    changeMode: function ( mode, sceneView /*, config*/ ) {
        this._sceneView = sceneView;
        if ( mode !== this._id ) {
            return;
        }
    },

} );

module.exports = RegionMode;


/***/ }),

/***/ "./sources/pcvizSection/SectionLayerView.js":
/*!**************************************************!*\
  !*** ./sources/pcvizSection/SectionLayerView.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

const d3 = __webpack_require__( /*! d3 */ "./node_modules/d3/d3.js" );
const osg = OSG.osg;

const ProjectView = __webpack_require__( /*! pcvizApp/ProjectView */ "./sources/pcvizApp/ProjectView.js" );
const LayerRenderer3D = __webpack_require__( /*! pcvizGISRenderer/LayerRenderer3D */ "./sources/pcvizGISRenderer/LayerRenderer3D.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
const CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
const Insider2D = __webpack_require__( /*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js" ).default;
const INSIDER_TYPES = __webpack_require__( /*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js" ).INSIDER_TYPES;
const pcvizGISRenderer = __webpack_require__( /*! pcvizGISRenderer/pcvizGISRenderer */ "./sources/pcvizGISRenderer/pcvizGISRenderer.js" ).default;
const BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );


const PointCloudScene = __webpack_require__( /*! pcvizNode/PointCloudScene */ "./sources/pcvizNode/PointCloudScene.js" );
const HUDNode = __webpack_require__( /*! pcvizNode/HUDNode */ "./sources/pcvizNode/HUDNode.js" );
const PointCloudDBPager = __webpack_require__( /*! pcvizDB/PointCloudDBPager */ "./sources/pcvizDB/PointCloudDBPager.js" );
const SectionViewer = __webpack_require__( /*! pcvizSection/SectionViewer */ "./sources/pcvizSection/SectionViewer.js" );
const Group = __webpack_require__( /*! pcvizNode/Group */ "./sources/pcvizNode/Group.js" ).default;
const LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 * @class
 * @memberof pcvizSection
 * @extends ProjectView
 * @param {Project} project The project object.
 * @param {canvas} viewerCanvas The canvas with 3D context in which the pointcloud is going to be rendered. If undefined, one will be created.
 */
var SectionLayerView = function ( project ) {
    ProjectView.call( this, project );

    this.margin = {
        top: 30,
        right: 30,
        bottom: 20,
        left: 20
    };

    this._userPreferencesCtrl = Registry.getController( 'UserPreferences' );
    this._pointVisibilityManagerCtrl = Registry.getController( 'PointVisibilityManager' );

    this._project = project;
    this._layerRenderer = undefined;
    this._canvas = undefined;
    this._image = undefined;
    this._viewer = undefined;
    this._center = undefined;

    // section area size in pixels
    this._width = 0.0;
    this._height = 0.0;

    this._flipSection = false;
    this._verticalScale = 1.0;

    this._layerBufferAttributes = [];
    this._segmentID = 0;

    //svg data domain & axis
    this._xmin = 0.0;
    this._xmax = 0.0;
    this._ymax = 0.0;
    this._ymin = 0.0;
    this._xAxis = undefined;
    this._yAxis = undefined;
    let registryDecimals = Registry.getController( 'UserPreferences' ).getPreference( Utils.NUMBER_OF_DECIMALS_KEY );
    this._decimals = '.' + registryDecimals + 'f';
    this.margin.left += registryDecimals * 1.5;

    // extent of data displayed
    this._xminView = 0.0;
    this._xmaxView = 0.0;
    this._ymaxView = 0.0;
    this._yminView = 0.0;

    // transformation 
    this._lastTransX = 0.0;
    this._lastTransY = 0.0;

    this._zoomOn = true;
    this._zoomValue = 1.0;

    // section lines
    this._gridLineStart = undefined;
    this._gridLineMid = undefined;
    this._gridLineEnd = undefined;

    this._gridLineMinX = 0.0;
    this._gridLineMaxX = 0.0;
    this._gridLineMinY = 0.0;
    this._gridLineMaxY = 0.0;

    // controls mouse interaction with manipulator
    this._mouseHasLeft = false;

    this.registerSymbols();

    this._pointVisibilityManagerCtrl.registerListener( ListenerController.PROJECT, 'visibilityUpdated', () => {
        this.updatePointVisibility();
    }, 'sectionView:visibilityUpdated' );

};

SectionLayerView.prototype = osg.objectInherit( ProjectView.prototype, {

    registerSymbols: function () { //Here, we are going to register the symbols to draw an scene in the canvas
        var symbolRegistry = Registry.getController( 'Symbol' );
        symbolRegistry.registerSymbol( 'Section', 'Point', pcvizGISRenderer.PointSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'PointMarker', pcvizGISRenderer.PointMarkerSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'MultiPoint', pcvizGISRenderer.MultiPointSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'MultiPointMarker', pcvizGISRenderer.MultiPointMarkerSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Line', pcvizGISRenderer.LineSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'LineMarker', pcvizGISRenderer.LineMarkerSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Fill', pcvizGISRenderer.FillSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'FillMarker', pcvizGISRenderer.FillMarkerSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Panorama', pcvizGISRenderer.PanoramaSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'PlanarImage', pcvizGISRenderer.PlanarImageSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Model3D', pcvizGISRenderer.Model3DSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'MultiModel3D', pcvizGISRenderer.MultiModel3DSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'StationSymbol', pcvizGISRenderer.StationSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Target', pcvizGISRenderer.TargetSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Volume', pcvizGISRenderer.VolumeSymbol3D );
        symbolRegistry.registerSymbol( 'Section', 'Machinery', pcvizGISRenderer.MachineryMarkerSymbol3D );
    },

    getCanvas: function () {
        return this._canvas;
    },

    getViewer: function () {
        return this._viewer;
    },

    getLayerRenderer: function () {
        return this._layerRenderer;
    },

    getPointEditionHUD: function () {
        return this._pointEditionHUDNode;
    },

    nextSegment: function () {
        if ( this._data && this._segmentID < this._data.length - 1 ) {
            this._segmentID += 1;
        }
        this.configure( this._data );
    },

    previousSegment: function () {
        if ( this._data && this._segmentID > 0 ) {
            this._segmentID -= 1;
        }
        this.configure( this._data );
    },

    isSectionType: function ( type ) {
        let hasDataType = this._data !== undefined && this._data[ this._segmentID ].bufferType === type;
        return hasDataType;
    },

    initScene: function ( width, height ) {

        // Create canvas
        this._canvas = document.createElement( 'canvas' );
        this._canvas.width = width;
        this._canvas.height = height;
        this._canvas.id = 'profile-canvas';

        //Style
        this._canvas.style.position = 'absolute';
        this._canvas.style.left = this.margin.left + 'px';
        this._canvas.style.top = this.margin.top + 'px';

        if ( document.getElementById( 'profile-area' ) ) document.getElementById( 'profile-area' ).appendChild( this._canvas );

        //Resize
        this._width = width;
        this._height = height;

        //Create a new Viewer
        var options = {
            enableFrustumCulling: true
        };

        this._viewer = new SectionViewer( this._canvas, options );

        var dbPager = new PointCloudDBPager();
        this._viewer.setDatabasePager( dbPager );
        this._viewer.getDatabasePager().setMaxRequestsPerFrame( 1 );
        this._viewer.getDatabasePager().pushOnAddedDataCallback( ( data ) => {
            Registry.getController( 'PointVisibilityManager' ).notifyProcessNewGeometries( data.getInstanceID() ); // Notify new CPLFMZ geometry is loaded in the scene graph. For PLFMZ is notified in PointCloudRenderer.
        } );
        this._viewer.setPickingEnabled( false );

        //Scene initilization
        this._rootNode = new Group();

        //This global MatrixTransform is used to apply vertical scalation in the scene
        this._rootMatrixTransform = new osg.MatrixTransform();
        this._rootMatrixTransform.addChild( this._rootNode );

        var pointCloudScene = new PointCloudScene();
        this._rootNode.addChild( pointCloudScene );

        const hudNode = new HUDNode();
        hudNode.setName( 'HUDNode' );

        this._rootNode.addChild( hudNode );

        if ( this._viewer ) {

            // HUD node settingUp
            hudNode.setViewportDimensions( this._viewer.getCamera().getViewport().width(), this._viewer.getCamera().getViewport().height() );
            hudNode.setViewer( this._viewer );

            //Backgroud color
            this._viewer.getCamera().setClearColor( this._userPreferencesCtrl.getPreference( Utils.SECTION_BACKGROUND_COLOR_KEY ) );
            this._userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.SECTION_BACKGROUND_COLOR_KEY, this.setBackgroundColor.bind( this ) );

            //Grid color
            this._userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.SECTION_GRID_COLOR_KEY, this.setGridColor.bind( this ) );

            this._viewer.setSceneData( this._rootMatrixTransform );
            this._viewer.setPointCloudScene( pointCloudScene );
            this._viewer.setHUDNode( hudNode );

            this._pointEditionHUDNode = new osg.MatrixTransform();
            this._pointEditionHUDNode.setName( 'PointEdition SectionView HUDNode' );
            this._pointEditionHUDNode.getOrCreateStateSet().setAttributeAndModes( new osg.Light( 0, true ) );

            hudNode.getHUDRootNode().addChild( this._pointEditionHUDNode );

            this.addLayers();

            var eyeSectionCamera = osg.vec3.fromValues( 0.0, 150.0, 150.0 );
            var centerSectionCamera = osg.vec3.fromValues( 0.0, 0.0, 0.0 );
            var upSectionCamera = osg.vec3.fromValues( 0.0, 0.0, -1.0 );

            this._viewer.getCamera().setRenderOrder( osg.Camera.PRE_RENDER, 0 );
            this._viewer.getCamera().setReferenceFrame( osg.Transform.ABSOLUTE_RF );

            this._viewer.getCamera().setViewport( new osg.Viewport( 0, 0, this._canvas.width, this._canvas.height ) );

            //OrthoManipulator
            this._manipulator = this._viewer.getOrCreateCADManipulator();
            this._viewer.setupManipulator( this._manipulator );
            this._viewer.setEnableOrtho( true );

            this._manipulator.setRotateForbidden( true ); //For avoid rotate the scene in SectionView

            //Manipulator position recalibration
            this._manipulator.setHomePosition( eyeSectionCamera, centerSectionCamera, upSectionCamera );

            var distance = osg.vec3.distance( eyeSectionCamera, centerSectionCamera );
            this._viewer.resetManipulatorTarget( centerSectionCamera, distance );

            this._viewer.run();

        }

    },

    addLayers: function () {
        var defer = P.defer();
        if ( this._project === undefined )
            return defer.promise;

        var layers = this._project.getAllLayers();

        var promises = [];

        var self = this;

        var layersFiltered = [];
        for ( var i = 0; i < layers.length; i++ ) {
            var layer = layers[ i ];

            //We filter only for 3D Models && PointClouds
            if ( layer.getType() === LayerType.POINTCLOUD ||
                ( layer.getType() === LayerType.VECTOR && VectorLayerUtils.isModel( layer.getCategory() ) ) ) {
                layersFiltered.push( layer );
                promises.push( layer.open() );
            }
        }

        //Override layers with filtered layers
        layers = layersFiltered;

        Promise.all( promises ).then( function ( layersOpened ) {
            var opened = [];
            for ( var i = 0; i < layers.length; i++ )
                if ( layersOpened[ i ].loaded )
                    opened.push( layers[ i ] );
            self.drawLayers( opened );
            defer.resolve();
        } );
        return defer.promise;
    },

    drawLayers: function () {
        var promises = [];

        //Here, on the first param, we should take all layerGroup.children??
        this.renderChildrenLayers( this._project.getProjectDataset()._tableOfContents.layerGroup.children, this._rootNode, promises );

        var self = this;
        Promise.all( promises ).then( function () {
            self._layerBufferAttributes = Array.from( self._layerRenderer.getLayerNodesByType( LayerType.POINTCLOUD ).values() );
            self._layerBufferAttributes = self._layerBufferAttributes.concat( Array.from( self._layerRenderer.getLayerNodesByType( LayerType.VECTOR ).values() ) );
            self.initBufferShader( true );
            self.configure( self._data ); // To refresh when center is set
            self.updatePointVisibility(); // Apply point visibility
        } );
    },


    renderChildrenLayers: function ( children, node, promisesArray ) {
        for ( var i = 0; i < children.length; i++ ) {

            if ( children[ i ].layerGroup ) {
                var group = new Group();
                group.setName( children[ i ].layerGroup.name );
                if ( children[ i ].layerGroup.transformMatrix && !CRSUtils.isEcefPoint( children[ i ].layerGroup.transformMatrix[ 3 ], children[ i ].layerGroup.transformMatrix[ 7 ], children[ i ].layerGroup.transformMatrix[ 11 ] ) ) {
                    osg.mat4.transpose( group.getMatrix(), children[ i ].layerGroup.transformMatrix );
                    group.setMatrix( group.getMatrix() );
                }

                node.addChild( group );
                this.renderChildrenLayers( children[ i ].layerGroup.children, group, promisesArray );
            } else {
                promisesArray.push( this.drawLayer( this._project.getLayerById( children[ i ].id ), node ) );
            }

        }
    },

    drawLayer: function ( layer, node ) {
        if ( this._layerRenderer === undefined ) {
            this._layerRenderer = new LayerRenderer3D();
            this._layerRenderer._featureRendererId = 'Section';
        }
        if ( !layer.getCenter() )
            layer.computeCenter();

        if ( this._center === undefined ) {
            if ( Registry.getInstance().getController( 'View' ).getCenter() !== undefined )
                this._center = Registry.getInstance().getController( 'View' ).getCenter();
            else {
                this._center = layer.getCenter();
                Registry.getInstance().getController( 'View' ).setCenter( this._center );
            }
            this._layerRenderer.setCenter( this._center );
            var transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];

            this._rootNode.setMatrix( osg.mat4.fromTranslation( osg.mat4.create(), transCenter ) );
        }

        return layer.render( this._layerRenderer, this._viewer, node );
    },

    updatePointVisibility: function () {
        if ( this._layerRenderer ) {
            const plodList = Array.from( this._layerRenderer.getLayerNodesByType( LayerType.POINTCLOUD ).values() );
            for ( let child of plodList ) {
                Registry.getController( 'PointVisibilityManager' ).pushNodeToUpdate( child );
            }
            Registry.getController( 'PointVisibilityManager' ).notifyUpdateGeometries();
        }
    },

    setZoomOn: function ( value ) {
        this._zoomOn = value;
    },

    zoom: function () {

        if ( !this._zoomOn ) {
            return;
        }

        // if is not called by event is for restoring the actual zoom
        let fromEvent = d3.event;
        var newScale = fromEvent ? d3.event.scale : this._zoomValue;
        this._zoomValue = newScale;
        //Modifies manipulator frustum for zoom in/ zoom out
        this._manipulator.setOrthoFrustum( {
            top: this._originalFrustrum.top / newScale,
            bottom: this._originalFrustrum.bottom / newScale,
            right: this._originalFrustrum.right / newScale,
            left: this._originalFrustrum.left / newScale,
        } );
        this._manipulator.computeFrustum();

        //Grid dimensions reduction.
        var xlen = this._xmax - this._xmin;
        var ylen = this._ymax - this._ymin;

        var rx = ( xlen - ( xlen / newScale ) ) / 2;
        var ry = ( ylen - ( ylen / newScale ) ) / 2;

        // This avoids control manipulator with right-click.(Update pan interpolator before its usa in manipulator update)
        this._manipulator._pan.update();

        //This is the panning offset that is calculated when we drag the scene with left-click.
        var delta = this._manipulator._rotate.update(); //rotate is the interpolator that we update with left-click
        var rotMat = osg.mat4.create();
        osg.mat4.fromQuat( rotMat, this._manipulator._orientation );
        var transX = -delta[ 0 ] * 10; //* mouse factor (10 in OSG.js)
        var transY = -delta[ 1 ] * 10; //* mouse factor (10 in OSG.js)

        //This is the same as we have un computePan() in CADManipulator. We need to do this here to make the panning operative.
        var speedTmp = osg.vec3.create();
        var speed = osg.vec3.length( osg.vec3.sub( speedTmp, this._manipulator._eye, this._manipulator._pivotPoint ) ) / this._manipulator._panFactor;

        if ( speed < 1 ) speed = 1;

        transX = transX * speed / 2;
        transY = transY * speed / 2;

        var trans = osg.vec3.create();
        trans[ 0 ] = transX;
        trans[ 1 ] = transY;
        trans[ 2 ] = 0;

        // Translate camera eye position to last point
        if ( !fromEvent ) {
            trans[ 0 ] = this._lastTransX;
            trans[ 1 ] = this._lastTransY;
        }

        // Repositioning manipulator eye
        var rotPos = osg.vec3.create();
        osg.vec3.transformMat4( rotPos, trans, rotMat );
        osg.vec3.add( this._manipulator._eye, this._manipulator._eye, rotPos );

        //Then, we use the same pan to add it in the global pan, and re-calculate axis values.
        this._lastTransX += transX;
        this._lastTransY += transY;

        //New scale value: original +/- diference between original and new escale + (global pan accumulated / verticalScale)
        this._xminView = this._xmin + rx + this._lastTransX;
        this._xmaxView = this._xmax - rx + this._lastTransX;
        this._yminView = this._ymin + ry + ( this._lastTransY / this._verticalScale );
        this._ymaxView = this._ymax - ry + ( this._lastTransY / this._verticalScale );

        // Guidelines
        this.configureGuidelines(); // calculate section guidelines

        //Reconfigure grid scale
        this.scaleGrid();
    },

    updateCanvasDimensions: function ( containerWidth, containerHeight ) {
        this._width = containerWidth - this.margin.left - this.margin.right;
        this._height = containerHeight - this.margin.top - this.margin.bottom;

        let canvasSizeChange = ( this._canvas.width !== this._width ) || ( this._canvas.height !== this._height );

        if ( canvasSizeChange ) {
            this._viewer.getHUDNode().setViewportDimensions( Math.floor( this._width ), Math.floor( this._height ) );
            this._canvas.width = this._width;
            this._canvas.height = this._height;
        }
    },

    refresh: function ( data, containerWidth, containerHeight, vScale, flipSection ) {

        this.updateCanvasDimensions( containerWidth, containerHeight );

        if ( flipSection !== undefined )
            this._flipSection = flipSection;

        if ( vScale )
            this._verticalScale = vScale;

        //Here we take the vertical scale value and update transformMatrix to apply this new scale (matrix[10] is the scale value for z coord. that is the vertical axis here)
        let matrix = this._rootMatrixTransform.getMatrix();
        matrix[ 10 ] = this._verticalScale;

        this.configure( data );
    },

    configure: function ( data, containerWidth, containerHeight, flipSection, resetZoom ) {
        //Reset segmentID
        if ( !this.samePoints( data ) ) {
            this._segmentID = 0;
        }

        this._data = data;

        if ( flipSection !== undefined )
            this._flipSection = flipSection;

        if ( containerWidth && containerHeight ) {
            this.updateCanvasDimensions( containerWidth, containerHeight );
        }

        let worldPositions = [];

        if ( data && data.length !== 0 ) {

            let point1 = data[ this._segmentID ].point1;
            let point2 = data[ this._segmentID ].point2;

            //Buffer Shader configuration
            if ( this._center !== undefined ) {
                if ( data[ this._segmentID ].bufferType === 'long' ) {
                    worldPositions.push( osg.vec3.add( osg.vec3.create32(), point1, this._center ) );
                    worldPositions.push( osg.vec3.add( osg.vec3.create32(), point2, this._center ) );
                } else if ( data[ this._segmentID ].bufferType === 'cross' ) {
                    worldPositions.push( osg.vec3.add( osg.vec3.create32(), data[ this._segmentID ].crossPath[ 0 ], this._center ) );
                    worldPositions.push( osg.vec3.add( osg.vec3.create32(), data[ this._segmentID ].crossPath[ 1 ], this._center ) );
                }
                this.setBufferShaderParams( worldPositions, data[ this._segmentID ].width );
            }

            //Grid scale values for x axis
            this._xmin = data[ this._segmentID ].xmin;
            this._xmax = data[ this._segmentID ].xmax;

            //Camera setting
            let distance = 10;
            let segmentCenter = osg.vec3.create();
            let vSegment = osg.vec3.fromValues( point2[ 0 ] - point1[ 0 ], point2[ 1 ] - point1[ 1 ], point2[ 2 ] - point1[ 2 ] );
            let offset = osg.vec3.create();
            let module = Math.sqrt( ( vSegment[ 0 ] * vSegment[ 0 ] ) + ( vSegment[ 1 ] * vSegment[ 1 ] ) + ( vSegment[ 2 ] * vSegment[ 2 ] ) );
            let vSegmentUnit = osg.vec3.create();
            let segmentWidth = 0;
            if ( this.isSectionType( 'long' ) ) {
                //Center of the segment
                segmentCenter = osg.vec3.fromValues( ( point2[ 0 ] + point1[ 0 ] ) / 2, ( point2[ 1 ] + point1[ 1 ] ) / 2, ( point2[ 2 ] + point1[ 2 ] ) / 2 );

                //Camera offset
                vSegmentUnit = osg.vec3.fromValues( vSegment[ 0 ] / module, vSegment[ 1 ] / module, vSegment[ 2 ] / module );
                offset = osg.vec2.fromValues( vSegmentUnit[ 1 ] * distance, ( -vSegmentUnit[ 0 ] ) * distance ); //This is the product of one ortogonal vector from segment vector and distance scalar. 
                segmentWidth = ( 2 * data[ this._segmentID ].width ) + data[ this._segmentID ].segmentWidth; //In long buffer we may use the range value (in both directions) and segmentWidth as camera's frustrum width

                this._xmax = ( 2 * data[ this._segmentID ].width ) + this._xmax; //As segmentWidth
            } else if ( this.isSectionType( 'cross' ) ) {
                //Center of the segment
                segmentCenter = osg.vec3.fromValues( point1[ 0 ], point1[ 1 ], point1[ 2 ] );

                //Camera offset
                vSegment = osg.vec3.fromValues( -vSegment[ 0 ], -vSegment[ 1 ], -vSegment[ 2 ] ); //Change direction
                vSegmentUnit = osg.vec3.fromValues( vSegment[ 0 ] / module, vSegment[ 1 ] / module, vSegment[ 2 ] / module );
                offset = osg.vec2.fromValues( vSegmentUnit[ 0 ] * distance, vSegmentUnit[ 1 ] * distance ); //In this case, the vector between both points is a ortogonal vector for the segment. 
                segmentWidth = data[ this._segmentID ].segmentWidth; //In cross buffer, camera's frustrum width is the Offset value
            }

            //Change the direction of camera's offset depending on flipSection's value
            if ( this._flipSection ) offset = osg.vec2.fromValues( ( -offset[ 0 ] ), ( -offset[ 1 ] ) );

            // Aspect ratio
            let aspectRatio = this._canvas.width / this._canvas.height;
            let segmentHeight = segmentWidth / aspectRatio;

            //Gird scale for y axis
            let centerZ = data[ this._segmentID ].centerZ + segmentCenter[ 2 ]; //This is the center height of the segment in the scene (height of the scene's center + segment center height). This is used as 0 in yscale for the grid.
            this._ymin = centerZ + ( ( -( segmentHeight / 2 ) ) / this._verticalScale );
            this._ymax = centerZ + ( ( segmentHeight / 2 ) / this._verticalScale );

            if ( this._verticalScale !== 1.0 ) { //We apply the verticalScale here because when we apply the new vertical scale, it is applied in z position too
                segmentCenter[ 2 ] = segmentCenter[ 2 ] * ( this._verticalScale );
            }

            //Camera position setting
            let centerSectionCamera = osg.vec3.fromValues( segmentCenter[ 0 ], segmentCenter[ 1 ], segmentCenter[ 2 ] );
            let eyeSectionCamera = osg.vec3.fromValues( centerSectionCamera[ 0 ] + offset[ 0 ], centerSectionCamera[ 1 ] + offset[ 1 ], centerSectionCamera[ 2 ] );
            let upSectionCamera = osg.vec3.fromValues( 0.0, 0.0, 1.0 );

            this._viewer.getCamera().setRenderOrder( osg.Camera.PRE_RENDER, 0 );
            this._viewer.getCamera().setReferenceFrame( osg.Transform.ABSOLUTE_RF );

            this._viewer.getCamera().setViewport( new osg.Viewport( 0, 0, this._canvas.width, this._canvas.height ) );

            //Manipulator position & frustum recalibration
            this._manipulator.setHomePosition( eyeSectionCamera, centerSectionCamera, upSectionCamera );

            this._originalFrustrum = {
                top: ( segmentHeight * aspectRatio / 2 ),
                bottom: -( segmentHeight * aspectRatio / 2 ),
                right: ( segmentWidth / 2 ),
                left: -( segmentWidth / 2 )
            };

            this._manipulator.setOrthoFrustum( this._originalFrustrum );
            this._manipulator.computeFrustum();

            this._viewer.resetManipulatorTarget( centerSectionCamera, distance );

            // extent of data displayed
            this._xminView = this._xmin;
            this._xmaxView = this._xmax;
            this._ymaxView = this._ymax;
            this._yminView = this._ymin;

            if ( resetZoom ) {
                this._lastTransX = 0.0;
                this._lastTransY = 0.0;
                this._zoomValue = 1.0;
            }

            this.configureGuidelines(); // calculate section guidelines

            this.configureGrid( resetZoom );
        }

    },

    scaleGrid: function () {

        // Scale section Guidelines
        this._gridLineStart.attr( 'x1', this._flipSection ? this._gridLineMaxX : this._gridLineMinX )
            .attr( 'y1', this._gridLineMinY )
            .attr( 'x2', this._flipSection ? this._gridLineMaxX : this._gridLineMinX )
            .attr( 'y2', this._gridLineMaxY );

        if ( this.isSectionType( 'cross' ) ) {
            this._gridLineMid.attr( 'x1', ( this._gridLineMaxX + this._gridLineMinX ) / 2 )
                .attr( 'y1', this._gridLineMinY )
                .attr( 'x2', ( this._gridLineMaxX + this._gridLineMinX ) / 2 )
                .attr( 'y2', this._gridLineMaxY );
        }

        this._gridLineEnd.attr( 'x1', this._flipSection ? this._gridLineMinX : this._gridLineMaxX )
            .attr( 'y1', this._gridLineMinY )
            .attr( 'x2', this._flipSection ? this._gridLineMinX : this._gridLineMaxX )
            .attr( 'y2', this._gridLineMaxY );

        //X axis
        var xScale = d3.scale.linear().domain( [ this._xminView, this._xmaxView ] ).range( [ 0, this._width ] );

        var xAxis = d3.svg.axis()
            .scale( xScale )
            .orient( 'bottom' )
            .innerTickSize( -this._height )
            .outerTickSize( 0 )
            .ticks( 10, 'm' )
            .tickFormat( d3.format( this._decimals ) );

        //Y axis
        var yScale = d3.scale.linear().domain( [ this._yminView, this._ymaxView ] ).range( [ this._height, 0 ] );

        var yAxis = d3.svg.axis()
            .scale( yScale )
            .orient( 'left' )
            .ticks( 10, 'm' )
            .innerTickSize( -this._width )
            .outerTickSize( 0 )
            .tickFormat( d3.format( this._decimals ) );

        this._svg.select( '.x.axis' ).call( xAxis );
        this._svg.select( '.y.axis' ).call( yAxis );

        d3.selectAll( '.axis line' ).style( 'stroke', this._userPreferencesCtrl.getPreference( Utils.SECTION_GRID_COLOR_KEY ) );

    },

    configureGrid: function ( resetZoom ) {
        //Clear profile-axis svg
        d3.select( '#profile-axis' ).selectAll( 'g' ).remove();

        //Reconfigure profile-axis svg
        this._svg = d3.select( '#profile-axis' ).attr( 'width', this._width + this.margin.left + this.margin.right ).attr( 'height', this._height + this.margin.top + this.margin.bottom ).append( 'g' )
            .attr( 'transform', 'translate( ' + ( this.margin.left + 20 ) + ' , ' + this.margin.top + ' )' ); // +20 in margin.left is the left attr in profile-area (parent of this), because now is relative.
        if ( this._svg ) {
            //X axis
            var xScale = d3.scale.linear().domain( [ this._xminView, this._xmaxView ] ).range( [ 0, this._width ] );

            var xAxis = d3.svg.axis()
                .scale( xScale )
                .orient( 'bottom' )
                .innerTickSize( -this._height )
                .outerTickSize( 0 )
                .ticks( 10, 'm' )
                .tickFormat( d3.format( this._decimals ) );

            this._svg.append( 'g' )
                .attr( 'class', 'x axis' )
                .attr( 'transform', 'translate( 0,' + this._height + ')' )
                .call( xAxis );

            //Y axis
            var yScale = d3.scale.linear().domain( [ this._yminView, this._ymaxView ] ).range( [ this._height, 0 ] );

            var yAxis = d3.svg.axis()
                .scale( yScale )
                .orient( 'left' )
                .ticks( 10, 'm' )
                .innerTickSize( -this._width )
                .outerTickSize( 0 )
                .tickFormat( d3.format( this._decimals ) );

            // draw color guidelines
            // this foreingObject limits the lines in a space without grid margins
            let linesContext = this._svg.append( 'foreignObject' )
                .attr( 'class', 'lines' )
                .attr( 'x', 0 )
                .attr( 'y', 0 )
                .attr( 'width', this._width )
                .attr( 'height', this._height )
                .append( 'svg' )
                .attr( 'width', '100%' )
                .attr( 'height', '100%' );

            this._gridLineStart = linesContext.append( 'line' )
                .style( 'stroke', this._segmentID === 0 ? 'lightgreen' : 'red' )
                .style( 'stroke-width', 5 )
                .attr( 'x1', this._flipSection ? this._gridLineMaxX : this._gridLineMinX )
                .attr( 'y1', this._gridLineMinY )
                .attr( 'x2', this._flipSection ? this._gridLineMaxX : this._gridLineMinX )
                .attr( 'y2', this._gridLineMaxY );

            if ( this.isSectionType( 'cross' ) ) {
                this._gridLineMid = linesContext.append( 'line' )
                    .style( 'stroke', 'red' )
                    .style( 'stroke-width', 5 )
                    .attr( 'x1', ( this._gridLineMaxX + this._gridLineMinX ) / 2 )
                    .attr( 'y1', this._gridLineMinY )
                    .attr( 'x2', ( this._gridLineMaxX + this._gridLineMinX ) / 2 )
                    .attr( 'y2', this._gridLineMaxY );
            }

            this._gridLineEnd = linesContext.append( 'line' )
                .style( 'stroke', this._segmentID === this._data.length - 1 ? 'orange' : 'red' )
                .style( 'stroke-width', 5 )
                .attr( 'x1', this._flipSection ? this._gridLineMinX : this._gridLineMaxX )
                .attr( 'y1', this._gridLineMinY )
                .attr( 'x2', this._flipSection ? this._gridLineMinX : this._gridLineMaxX )
                .attr( 'y2', this._gridLineMaxY );

            this._svg.append( 'g' )
                .attr( 'class', 'y axis' )
                .call( yAxis );

            // Axis unit labels
            this._svg.append( 'text' )
                .attr( 'text-anchor', 'end' )
                .attr( 'transform', 'translate(0, -10)' )
                .text( Registry.getInstance().getController( 'Units' ).getCurrentUnit( 'distance' ).id );

            this._svg.append( 'text' )
                .attr( 'text-anchor', 'start' )
                .attr( 'transform', 'translate(' + ( this._width - 10 ) + ',' + ( this._height + 10 ) + ')' ) //before we have (this._width + 10), now we put a -20 here, because profile-area is relative and has left: 20px
                .text( Registry.getInstance().getController( 'Units' ).getCurrentUnit( 'distance' ).id );

            d3.selectAll( '.axis line' ).style( 'stroke', this._userPreferencesCtrl.getPreference( Utils.SECTION_GRID_COLOR_KEY ) );

            //Replace zoom listener
            let zoom = d3.behavior.zoom()
                .scaleExtent( [ 1, 128 ] )
                .x( xScale )
                .y( yScale )
                .on( 'zoom', this.zoom.bind( this ) );

            // Apply zoom scale if needs to restore zoom
            if ( !resetZoom ) {
                zoom.scale( this._zoomValue );
                this.zoom();
            }

            let canvas = d3.select( '#profile-canvas' );
            canvas.call( zoom )
                .on( 'mousemove', () => {
                    //This sets rotate and pan interpolator to avoid the manipulator's movement when mouse has left from canvas.
                    //Only when we click again in canvas, this bool is set to false. 
                    if ( this._mouseHasLeft ) {
                        this._manipulator._rotate.update();
                        this._manipulator._pan.update();
                    }
                } )
                .on( 'mousedown', () => {
                    this._mouseHasLeft = false;
                } )
                .on( 'mouseleave', () => {
                    this._mouseHasLeft = true;
                } );
        }

    },

    configureGuidelines: function () {
        // section lines
        let factorX = this._width / ( this._xmaxView - this._xminView );
        let factorY = this._height / ( this._ymaxView - this._yminView );

        // X real world positions
        let dataWidth = this._data[ this._segmentID ].bufferType !== 'cross' ? this._data[ this._segmentID ].width : 0;
        let xMin = this._xmin + dataWidth;
        let xMax = this._xmax - dataWidth;

        // X & Y positions in width-height space
        let xLineMin = ( xMin - this._xminView ) * factorX;
        let xLineMax = ( xMax - this._xminView ) * factorX;
        let yLineMin = ( this._data[ this._segmentID ].ymin - this._yminView ) * factorY;
        let yLineMax = ( this._data[ this._segmentID ].ymax - this._yminView ) * factorY;

        this._gridLineMinX = xLineMin;
        this._gridLineMaxX = xLineMax;
        this._gridLineMinY = this._height - yLineMin;
        this._gridLineMaxY = this._height - yLineMax;
    },

    setBackgroundColor: function ( sectionBackgroundColor ) {
        this._viewer.getCamera().setClearColor( sectionBackgroundColor );
    },

    setGridColor: function ( sectionGridColor ) {
        if ( d3.selectAll( '.axis line' )[ 0 ].length > 0 )
            d3.selectAll( '.axis line' ).style( 'stroke', sectionGridColor );
    },

    initBufferShader: function ( active ) {
        for ( var i = 0; i < this._layerBufferAttributes.length; i++ ) {
            this._layerBufferAttributes[ i ].bufferAttribute.setBufferMode( BufferAttribute.VERTICAL_LINE );
            this._layerBufferAttributes[ i ].bufferAttribute.setOnlyBuffer( active ? 1.0 : 0.0 );
            this._layerBufferAttributes[ i ].bufferAttribute.setUseBaseColor( active ? 1.0 : 0.0 );
            this._layerBufferAttributes[ i ].bufferAttribute.setEnabled( active ? 1.0 : 0.0 );
        }
    },

    setBufferShaderParams: function ( worldPositions, width ) {
        for ( var i = 0; i < this._layerBufferAttributes.length; i++ ) {
            this._layerBufferAttributes[ i ].bufferAttribute.setLineBuffer( worldPositions );
            this._layerBufferAttributes[ i ].bufferAttribute.setRange( width );
        }
    },

    isEmpty: function () {
        return this._data === undefined || this._data.length === 0;
    },

    samePoints: function ( newData ) {
        if ( !newData || !this._data || this._data.length === 0 || newData.length === 0 || newData.length !== this._data.length ) return false;
        for ( var i = 0; i < newData.length; i++ ) {
            if ( newData[ i ].point1 !== this._data[ i ].point1 || newData[ i ].point2 !== this._data[ i ].point2 ) return false;
        }
        return true;
    },

    isMultiSegment: function () {
        if ( this._data ) return this._data.length > 1;
        return false;
    },

    clear: function () {
        this._data = undefined;
    },

    isOpen: function () {
        return document.getElementById( 'profile-canvas' ) !== null;
    },

    getSectionBufferInsider: function () {

        // Calculate 3D world corners from buffer points.
        let positions = [];
        if ( this._data[ this._segmentID ].bufferType === 'long' ) {
            positions.push( osg.vec3.copy( osg.vec3.create32(), this._data[ this._segmentID ].point1 ) );
            positions.push( osg.vec3.copy( osg.vec3.create32(), this._data[ this._segmentID ].point2 ) );
        } else if ( this._data[ this._segmentID ].bufferType === 'cross' ) {
            positions.push( osg.vec3.copy( osg.vec3.create32(), this._data[ this._segmentID ].crossPath[ 0 ] ) );
            positions.push( osg.vec3.copy( osg.vec3.create32(), this._data[ this._segmentID ].crossPath[ 1 ] ) );
        }

        let width = this._data[ this._segmentID ].width;
        let dirVector = osg.vec3.sub( osg.vec3.create64(), positions[ 1 ], positions[ 0 ] );
        dirVector[ 2 ] = 0;
        let planeNormal = osg.vec3.cross( osg.vec3.create64(), dirVector, osg.vec3.fromValues( 0.0, 0.0, 1.0 ) ); // Second vector is camera up.
        osg.vec3.normalize( planeNormal, planeNormal );
        var normWidth = osg.vec3.create();
        osg.vec3.scale( normWidth, planeNormal, width );

        let lowLeftCorner = osg.vec3.create();
        let highLeftCorner = osg.vec3.create();
        let highRightCorner = osg.vec3.create();
        let lowRightCorner = osg.vec3.create();

        osg.vec3.sub( lowLeftCorner, positions[ 0 ], normWidth );
        osg.vec3.sub( lowRightCorner, positions[ 1 ], normWidth );
        osg.vec3.add( highRightCorner, positions[ 1 ], normWidth );
        osg.vec3.add( highLeftCorner, positions[ 0 ], normWidth );

        var normDirVec = osg.vec3.create();
        osg.vec3.normalize( normDirVec, dirVector );
        osg.vec3.scale( normDirVec, normDirVec, width );

        osg.vec3.sub( lowLeftCorner, lowLeftCorner, normDirVec );
        osg.vec3.add( lowRightCorner, lowRightCorner, normDirVec );
        osg.vec3.add( highRightCorner, highRightCorner, normDirVec );
        osg.vec3.sub( highLeftCorner, highLeftCorner, normDirVec );

        // Rotation to get a vertical point of view.
        let matRot = osg.mat4.fromRotation( osg.mat4.create(), Math.PI * 0.5, dirVector );

        const camera = this._viewer.getCamera();

        let transformMatrix = osg.mat4.create();
        osg.mat4.multiply( transformMatrix, transformMatrix, camera.getViewport() ? camera.getViewport().computeWindowMatrix( osg.mat4.create() ) : osg.mat4.create() );
        osg.mat4.multiply( transformMatrix, transformMatrix, camera.getProjectionMatrix() );
        osg.mat4.multiply( transformMatrix, transformMatrix, osg.mat4.mul( osg.mat4.create(), camera.getViewMatrix(), matRot ) );

        // Calculate screen points from a vertical PoV.
        osg.vec3.transformMat4( lowLeftCorner, lowLeftCorner, transformMatrix );
        osg.vec3.transformMat4( highLeftCorner, highLeftCorner, transformMatrix );
        osg.vec3.transformMat4( highRightCorner, highRightCorner, transformMatrix );
        osg.vec3.transformMat4( lowRightCorner, lowRightCorner, transformMatrix );

        let screenPoints = [ lowLeftCorner, highLeftCorner, highRightCorner, lowRightCorner ];

        // Calculate near and far points (from PointEdtionTool.computeNearFarWorldPositions)
        let aux1 = osg.vec3.create();
        let aux2 = osg.vec3.create();
        let invertMt = osg.mat4.invert( osg.mat4.create(), transformMatrix );
        let far = [];
        let near = [];
        for ( let point of screenPoints ) {
            aux1 = osg.vec3.fromValues( point[ 0 ], point[ 1 ], 0 );
            aux2 = osg.vec3.fromValues( point[ 0 ], point[ 1 ], 1 );

            osg.vec3.transformMat4( aux1, aux1, invertMt );
            osg.vec3.transformMat4( aux2, aux2, invertMt );

            near.push( Object.values( aux1 ) );
            far.push( Object.values( aux2 ) );
        }

        return new Insider2D( screenPoints, near, far, transformMatrix, INSIDER_TYPES.INTERSECT );
    }

} );

module.exports = SectionLayerView;


/***/ }),

/***/ "./sources/pcvizSection/SectionView.js":
/*!*********************************************!*\
  !*** ./sources/pcvizSection/SectionView.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var View = __webpack_require__( /*! pcvizApp/View */ "./sources/pcvizApp/View.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var d3 = __webpack_require__( /*! d3 */ "./node_modules/d3/d3.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );

/**
 * The Section view class
 * @class
 * @extends pcvizApp.View
 * @memberof pcvizSection
 * @param {Project} project The project object.
 * @param {View} view3d  The 3D view.
 */
var SectionView = function ( project ) {
    View.call( this, project );
    this.margin = {
        top: 30,
        right: 30,
        bottom: 30,
        left: 40
    };
    this._canvas = document.getElementById( 'profile-canvas' );
    this._svg = undefined;
    this._xAxis = undefined;
    this._yAxis = undefined;
    // section area size in pixels
    this._width = 0.0;
    this._height = 0.0;
    // control max number of points displayed
    this._maxNumPoints = 20000;
    this._increment = 1.0;
    // data domain
    this._xmin = 0.0;
    this._xmax = 0.0;
    this._ymax = 0.0;
    this._ymin = 0.0;
    // extent of data displayed
    this._xminView = 0.0;
    this._xmaxView = 0.0;
    this._ymaxView = 0.0;
    this._yminView = 0.0;
    // vertical scale
    this._verticalScale = 1.0;
    this._flipSection = false;
    // transformation 
    this._lastTransX = 0.0;
    this._lastTransY = 0.0;
    this._lastScale = 1.0;
    this._offsetTransX = 0.0;
    this._offsetTransY = 0.0;
    this._offsetScale = 1.0;

    this._data = undefined;
};

SectionView.prototype = osg.objectInherit( View.prototype, {


    setMaxNumPoints: function ( num ) {
        this._maxNumPoints = num;
    },

    getMaxNumPoints: function () {
        return this._maxNumPoints;
    },

    setVerticalScale: function ( scale ) {
        this._verticalScale = scale;
    },

    zoom: function () {

        this.zoomTo( d3.event.translate[ 0 ] + this._offsetTransX * d3.event.scale,
            d3.event.translate[ 1 ] + this._offsetTransY * d3.event.scale,
            d3.event.scale * this._offsetScale );
    },

    zoomTo: function ( transX, transY, scale ) {
        if ( !this._canvas ) // section not initialized (empty)
            return;

        /* jshint quotmark:double */
        var context = this._canvas.getContext( "2d" );
        /* jshint quotmark:single */
        this._svg.select( '.x.axis' ).call( this._xAxis );
        this._svg.select( '.y.axis' ).call( this._yAxis );
        context.save();
        context.clearRect( 0, 0, this._width, this._height );
        context.translate( transX, transY );
        context.scale( scale, scale );
        this.draw( scale );
        context.restore();

        this._lastTransX = transX;
        this._lastTransY = transY;
        this._lastScale = scale;
    },

    refresh: function ( data, width, height, vScale, flipSection ) {

        var transX = this._lastTransX;
        var transY = this._lastTransY;

        var resizeOps = {
            transX: transX * ( this._xmaxView - this._xminView ) / ( this._width * this._lastScale ),
            transY: transY * ( this._ymaxView - this._yminView ) / ( this._height * this._lastScale ),
            scale: this._lastScale
        };

        this.configure( data, width, height, vScale, flipSection, resizeOps );
        this.zoomTo( transX, transY, this._lastScale );

        // keep offsets to be used in zoom, since trans and scale are reset after resize
        this._offsetTransX = transX;
        this._offsetTransY = transY;
        this._offsetScale = this._lastScale;
    },

    updateProfile: function ( data, scale ) {
        /* jshint quotmark:double */
        var context = this._canvas.getContext( "2d" );
        /* jshint quotmark:single */
        var points = data.points;
        var colors = data.colors;
        var isLine = ( data.primitive && data.primitive === 'line' );
        var nPoints = isLine ? points.length / 4 : points.length / 2;

        // default colors
        var r = 183;
        var g = 201;
        var b = 213;

        var factorX = this._width / ( this._xmaxView - this._xminView );
        var factorY = this._height / ( this._ymaxView - this._yminView );

        for ( var i = 0; i < nPoints; i += this._increment ) {
            var index = 2 * i;

            var x = ( points[ index ] - this._xminView ) * factorX;
            if ( this._flipSection )
                x = this._width - x;
            var y = this._height - ( points[ index + 1 ] - this._yminView ) * factorY;

            // In case we have colors
            if ( colors[ i ] !== undefined ) {
                r = colors[ i ][ 0 ];
                g = colors[ i ][ 1 ];
                b = colors[ i ][ 2 ];
            }

            if ( isLine ) {
                var x2 = ( points[ index + 2 ] - this._xminView ) * factorX;
                if ( this._flipSection )
                    x2 = this._width - x2;
                var y2 = this._height - ( points[ index + 3 ] - this._yminView ) * factorY;
                context.lineWidth = 4.0 / scale;
                context.beginPath();
                context.moveTo( x, y );
                context.lineTo( x2, y2 );
                context.closePath();
                context.strokeStyle = 'rgba( ' + r + ',' + g + ', ' + b + ', 0.8 )';
                context.stroke();
            } else { // point
                context.fillStyle = 'rgba( ' + r + ',' + g + ', ' + b + ', 0.8 )';
                context.fillRect( x, y, 3.0 / scale, 3.0 / scale );
            }
        }
    },

    draw: function ( scale ) {
        /* jshint quotmark:double */
        var context = this._canvas.getContext( "2d" );
        /* jshint quotmark:single */
        context.clearRect( 0, 0, this._width, this._height );
        for ( var i = 0; i < this._data.length; i++ ) {
            this.updateProfile( this._data[ i ], scale );
        }
    },

    isEmpty: function () {
        var deltaX = this._xmax - this._xmin;
        var bEmpty = deltaX === 0 || deltaX === -Infinity;
        return bEmpty;
    },


    configure: function ( data, containerWidth, containerHeight, vScale, flipSection, resizeOps ) {

        // start with empty extent
        this._xmin = Number.MAX_VALUE;
        this._xmax = -Number.MAX_VALUE;

        // remove previous profiles
        d3.selectAll( 'ui-section svg > *' ).remove();

        if ( data === undefined ) { // clear
            this._data = [];
            this.draw( 1.0 );
            return;
        }

        if ( vScale === undefined )
            vScale = this._verticalScale;
        else
            this._verticalScale = vScale;

        if ( flipSection !== undefined )
            this._flipSection = flipSection;

        // Elements size
        this._width = containerWidth - this.margin.left - this.margin.right;
        this._height = containerHeight - this.margin.top - this.margin.bottom;

        if ( !resizeOps ) {
            this._lastTransX = 0.0;
            this._lastTransY = 0.0;
            this._lastScale = 1.0;
            this._offsetTransX = 0.0;
            this._offsetTransY = 0.0;
            this._offsetScale = 1.0;
        }

        // Create canvas
        var canvas = document.getElementById( 'profile-canvas' );
        if ( !canvas ) {
            canvas = this._canvas;
            if ( !canvas ) {
                canvas = d3.select( '#profile-area' ).append( 'canvas' )
                    .attr( 'width', this._width )
                    .attr( 'height', this._height )
                    .node();
                if ( !canvas ) // view does not exist
                    return;
                canvas.id = 'profile-canvas';
            }
        }
        //Resize
        canvas.width = this._width;
        canvas.height = this._height;
        this._canvas = canvas;

        var ymax = -Number.MAX_VALUE;
        var ymin = Number.MAX_VALUE;

        // bounds and point count
        var numPoints = 0;
        for ( var i = 0; i < data.length; i++ ) {
            if ( data[ i ].primitive === 'line' )
                continue;

            numPoints += data[ i ].points.length / 2;

            this._xmin = ( data[ i ].xmin < this._xmin ) ? data[ i ].xmin : this._xmin;
            this._xmax = ( data[ i ].xmax > this._xmax ) ? data[ i ].xmax : this._xmax;
            ymin = ( data[ i ].ymin < ymin ) ? data[ i ].ymin : ymin;
            ymax = ( data[ i ].ymax > ymax ) ? data[ i ].ymax : ymax;
        }

        this._data = data;
        ymax = ymax !== -Number.MAX_VALUE ? ymax : this._ymax;
        ymin = ymin !== Number.MAX_VALUE ? ymin : this._ymin;

        // give a little bit of margin in the profile
        var ydelta = ( ymax - ymin );
        ymax += 0.1 * ydelta;
        ymin -= 0.1 * ydelta;
        var xdelta = ( this._xmax - this._xmin );
        this._xmax += 0.01 * xdelta;
        this._xmin -= 0.01 * xdelta;
        if ( numPoints > this._maxNumPoints ) {
            this._increment = Math.floor( numPoints / this._maxNumPoints );
        }

        this._ymin = ymin;
        this._ymax = ymax;

        // adjust displayed extent to avoid stretching
        var dataAspect = ( this._xmax - this._xmin ) / ( ( ymax - ymin ) );
        var winAspect = this._width / this._height;
        if ( dataAspect > winAspect ) { // data more horizontal
            var dataViewHeight = 0.5 * ( this._xmax - this._xmin ) / ( winAspect );
            var meanHeight = 0.5 * ( ymin + ymax );
            this._yminView = meanHeight - dataViewHeight / vScale;
            this._ymaxView = meanHeight + dataViewHeight / vScale;
            var meanX = 0.5 * ( this._xmin + this._xmax );
            var incX = 0.5 * ( this._xmax - this._xmin );
            this._xminView = meanX - incX;
            this._xmaxView = meanX + incX;
        } else { // data more vertical
            var dataViewWidth = 0.5 * ( ymax - ymin ) * winAspect;
            var meanWidth = 0.5 * ( this._xmin + this._xmax );
            this._xminView = meanWidth - dataViewWidth;
            this._xmaxView = meanWidth + dataViewWidth;
            var meanY = 0.5 * ( ymin + ymax );
            var incY = 0.5 * ( ymax - ymin );
            this._yminView = meanY - incY / vScale;
            this._ymaxView = meanY + incY / vScale;
        }

        // Configure Axis
        var svg = d3.select( '#profile-axis' ).attr( 'width', containerWidth ).attr( 'height', containerHeight ).append( 'g' )
            .attr( 'transform', 'translate( 40 30 )' );

        var xScale;
        if ( resizeOps && resizeOps.scale !== 1.0 ) {
            var xmin = this._xminView - resizeOps.transX;
            var xmax = this._xminView + ( this._xmaxView - this._xminView ) / resizeOps.scale - resizeOps.transX;
            xScale = d3.scale.linear().domain( [ xmin, xmax ] ).range( [ 0, this._width ] );
        } else
            xScale = d3.scale.linear().domain( [ this._xminView, this._xmaxView ] ).range( [ 0, this._width ] );

        this._xAxis = d3.svg.axis()
            .scale( xScale )
            .orient( 'bottom' )
            .innerTickSize( -this._height )
            .outerTickSize( 0 )
            .ticks( 10, 'm' );

        svg.append( 'g' )
            .attr( 'class', 'x axis' )
            .attr( 'transform', 'translate( 0,' + this._height + ')' )
            .call( this._xAxis );

        // Axis stuff
        var yScale;
        if ( resizeOps && resizeOps.scale !== 1.0 ) {
            ymin = this._ymaxView - ( this._ymaxView - this._yminView ) / resizeOps.scale + resizeOps.transY;
            ymax = this._ymaxView + resizeOps.transY;
            yScale = d3.scale.linear().domain( [ ymin, ymax ] ).range( [ this._height, 0 ] );
        } else
            yScale = d3.scale.linear().domain( [ this._yminView, this._ymaxView ] ).range( [ this._height, 0 ] );

        this._yAxis = d3.svg.axis()
            .scale( yScale )
            .orient( 'left' )
            .ticks( 6, 'm' )
            .innerTickSize( -this._width )
            .outerTickSize( 0 );

        svg.append( 'g' )
            .attr( 'class', 'y axis' )
            .call( this._yAxis );

        // Axis unit labels
        svg.append( 'text' )
            .attr( 'text-anchor', 'end' )
            .attr( 'transform', 'translate(0, -10)' )
            .text( Registry.getInstance().getController( 'Units' ).getCurrentUnit( 'distance' ).id );

        svg.append( 'text' )
            .attr( 'text-anchor', 'start' )
            .attr( 'transform', 'translate(' + ( this._width + 10 ) + ',' + ( this._height + 10 ) + ')' )
            .text( Registry.getInstance().getController( 'Units' ).getCurrentUnit( 'distance' ).id );

        // Cache the symbol
        this._svg = svg;

        var scaleFactor = vScale;
        if ( resizeOps )
            scaleFactor = vScale * resizeOps.scale;

        d3.select( '#profile-canvas' )
            .call( d3.behavior.zoom().scaleExtent( [ 1 / scaleFactor, 128 / scaleFactor ] )
                .x( xScale )
                .y( yScale )
                .on( 'zoom', this.zoom.bind( this ) ) );

        if ( !resizeOps )
            this.draw( 1.0 );
    }

} );

module.exports = SectionView;


/***/ }),

/***/ "./sources/pcvizSection/SectionViewer.js":
/*!***********************************************!*\
  !*** ./sources/pcvizSection/SectionViewer.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var PointCloudViz = __webpack_require__( /*! PointCloudViz */ "./sources/PointCloudViz.js" );

var osg = OSG.osg;
var Viewer = PointCloudViz.Viewer.Viewer;

/**
 *  A custom Viewer for the section view which inherits from pcvizViewer.Viewer
 *  @class
 *  @memberof pcvizSection
 *  @extends {pcvizViewer.Viewer}
 */
var SectionViewer = function ( canvas, userOptions, error ) {
    Viewer.call( this, canvas, userOptions, error );

    this.getCamera().setName( 'sectionCamera' );

};

SectionViewer.prototype = osg.objectInherit( Viewer.prototype, {

    // overwritten to avoid execute unnecessary instructions
    frame: function () {
        this.beginFrame();

        this.advance();

        // update viewport if a resize occured
        var canvasSizeChanged = this.updateViewport();
        if ( this._pixelRatio !== window.devicePixelRatio ) {

            canvasSizeChanged = true;
            this._pixelRatio = window.devicePixelRatio;
            this._devicePixelRatio = this._pixelRatio; //osg
            this.updateViewport();
        }

        // update pointcloud RTT
        if ( canvasSizeChanged ) {
            this._hudNode.setViewportDimensions( this.getCamera().getViewport().width(), this.getCamera().getViewport().height() );
        }

        // update inputs devices
        this.updateEventProxy( this._eventProxy, this.getFrameStamp() );

        // update tools
        this.updateTools();

        // setup framestamp
        this._updateVisitor.setFrameStamp( this.getFrameStamp() );
        // Update Manipulator/Event
        if ( this.getManipulator() && this._manipulatorEnabled ) {
            this.getManipulator().update( this._updateVisitor );
            osg.mat4.copy( this.getCamera().getViewMatrix(), this.getManipulator().getInverseMatrix() );
        }

        if ( this.checkNeedToDoFrame() || canvasSizeChanged ) {
            this._requestRedraw = false;
            this.updateTraversal();
            if ( this._canvasWidth > 0 && this._canvasHeight > 0 )
                this.renderingTraversal();
        }

        this.endFrame();
    }

} );

module.exports = SectionViewer;


/***/ }),

/***/ "./sources/pcvizSection/pcvizSection.js":
/*!**********************************************!*\
  !*** ./sources/pcvizSection/pcvizSection.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var SectionLayerView = __webpack_require__( /*! pcvizSection/SectionLayerView */ "./sources/pcvizSection/SectionLayerView.js" );
var SectionView = __webpack_require__( /*! pcvizSection/SectionView */ "./sources/pcvizSection/SectionView.js" );
var SectionViewer = __webpack_require__( /*! pcvizSection/SectionViewer */ "./sources/pcvizSection/SectionViewer.js" );

/** @namespace pcvizSection */
var pcvizSection = {};
pcvizSection.SectionLayerView = SectionLayerView;
pcvizSection.SectionView = SectionView;
pcvizSection.SectionViewer = SectionViewer;

module.exports = pcvizSection;


/***/ }),

/***/ "./sources/pcvizTools/AnnotationTool.js":
/*!**********************************************!*\
  !*** ./sources/pcvizTools/AnnotationTool.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var LayerEditionTool = __webpack_require__( /*! pcvizTools/LayerEditionTool */ "./sources/pcvizTools/LayerEditionTool.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
const PlanarImageSymbol3D = __webpack_require__( /*! pcvizGISRenderer/PlanarImageSymbol3D */ "./sources/pcvizGISRenderer/PlanarImageSymbol3D.js" );
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
const pcvizManipulator = __webpack_require__( /*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js" );
const SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );

var osg = OSG.osg;

/**
 * Tool that manages the vector layer's edition (Create, update and delete features).
 * So, use this tool only when the layer selected is a VectorLayer.
 * @class
 * @memberof pcvizTools
 * @extends LayerEditionTool
 */
var AnnotationTool = function ( view ) {
    LayerEditionTool.call( this, view, 'annotation' );
    this._active = false;
};

AnnotationTool.prototype = osg.objectInherit( LayerEditionTool.prototype, {

    /**
     * Sets the tool active or inactive.
     * @memberof pcvizTools.AnnotationTool
     * @method
     * @param {boolean} active `true` if the tool is active.
     */
    setActive: function ( active ) {

        LayerEditionTool.prototype.setActive.call( this, active );

        if ( !this._active ) {
            // we check this before getting current selectionObject to do this only if the annotationtool has been used before
            if ( this._selectionObject !== undefined ) {
                this._selectionObject = this._selectionObjectController.getSelectionObject();
                if ( this._selectionObject.getLayer() !== undefined && this._selectionObject.setFeature ) {
                    this._selectionObject.setFeature( undefined );
                    this._selectionObjectController.setSelectionObject( this._selectionObject );
                }
            }
        }

        // Now, the user is able to create annotations over Planar Images
        if ( this._view.getCurrentManipulatorModeKey() === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR ) {
            PlanarImageSymbol3D.getImageNodeInstance().setNodeMask( active ? Utils.VISIBILITY_MASK : ~Utils.TRAVERSAL_MASK_IV );
        }

        if ( active ) {
            this._selectionObjectController.registerListener( ListenerController.PROJECT, ( selectionObject ) => {
                if ( this.isPlanarImageSelected( selectionObject ) && this._view.getCurrentManipulatorModeKey() === pcvizManipulator.PLANAR_IMAGE_MANIPULATOR ) {
                    this.enablePlanarImageIntersections();
                }
            }, 'AnnotationTool' );
        } else {
            this._selectionObjectController.removeListener( ListenerController.PROJECT, 'AnnotationTool' );
        }
    },

    isPlanarImageSelected: function ( selectionObject ) {
        if ( selectionObject.getLayer() && selectionObject.getSelectionType() === SelectionObject.VectorLayer ) {
            const layer = selectionObject.getLayer();
            return ( VectorLayerUtils.isPlanarImage( layer.getCategory() ) && selectionObject.getFeature() );
        }
        return false;
    },

    enablePlanarImageIntersections: function () {
        PlanarImageSymbol3D.getImageNodeInstance().setNodeMask( Utils.VISIBILITY_MASK );
    },

    emptyFeature: function () {
        while ( this._positionsArray.length > 1 )
            this._positionsArray.pop();
    },

    /**
     * Method to manage the escape key action.
     * @method
     * @memberof pcvizTools.AnnotationTool
     */
    doEscapeAction: function () {
        if ( this._positionsArray !== undefined && this._positionsArray.length > 1 && !( Utils.isTouchEnabled() ) ) {
            if ( this.isEscapeKeyEvent() ) {
                this.emptyFeature();
                return;
            }
            this._positionsArray.pop();
        }
    },

    update: function () {
        if ( !this.isToolActive() )
            return;
        // If typeEvent is 'mouseup', the mouse position when 'mousedown' is equal to the mouse position when 'mouseup'.
        // We needn't the screenX/Y variables.
        if ( this.isMouseupOrTapEvent() ) {
            this.doMouseupOrTapAction();
        }

        if ( ( this._layerSelected !== undefined ) && ( this._currentHitPosition !== undefined ) && ( this._lastHitPosition !== undefined ) ) {
            this.drawFeature();
        }
        this._typeEvent = undefined;
    },

    finishCurrentEdition: function () {
        this._dblclickFunction();
    },

    declareFunctions: function () {

        LayerEditionTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;
            if ( self._typeEvent === 'mouseup' && !( Utils.isTouchEnabled() ) ) {
                self._positionsArray.pop();
            }

            self._typeEvent = 'dblclick';

            self.dispatchData();
            if ( !ev )
                return;
            ev.stopPropagation();
        };
    }

} );

module.exports = AnnotationTool;


/***/ }),

/***/ "./sources/pcvizTools/AreaTool.js":
/*!****************************************!*\
  !*** ./sources/pcvizTools/AreaTool.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
const osg = OSG.osg;
const osgUtil = OSG.osgUtil;
const osgText = OSG.osgText;
const CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
const SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
const Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
const UnitController = __webpack_require__( /*! pcvizDB/UnitController */ "./sources/pcvizDB/UnitController.js" );
const WorkspaceCategories = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" ).default;
const FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;

/**
 *  This tool allows the user to draw an area and compute it.
 *  It is possible to draw an area in 3D or in a horizontal plane.
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 *  @param {Viewer} viewer The viewer the tool is attached to.
 *  @property {osg.Node} _areaNode The node the drawn geometry is attatched to.
 *  @property {float} _globalArea The computed area value.
 *  @property {Array<osg.vec3>} _positions Stored vertices of the current area.
 *  @property {boolean} _flatProjection Condition to draw and compute the
 *  horizontal projection or the 3D mesh.
 */
const AreaTool = function ( viewer ) {
    PickTool.call( this, viewer, 'area' );
    this._globalArea = 0.0;
    this._positions = [];

    this._areaNode = new osg.Node();
    this._areaNode.setName( 'areaTool' );

    viewer.getToolsNode().addChild( this._areaNode );

    this._geometryNode = new osg.Node();
    this._areaNode.addChild( this._geometryNode );

    this._textNode = undefined;

    this._flatProjection = false;

    this._sketchTool = new SketchTool( viewer );

    this._zMax = undefined;

    this._previousFeatureSelected = undefined;

    var self = this;
    Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.NUMBER_OF_DECIMALS_KEY, function () {
        self.repaintTextNode();
    } );

    this._unitsController = Registry.getInstance().getController( 'Units' );
    this._unitsController.registerListener( ListenerController.APPLICATION, UnitController.AREA_TYPE, function () {
        self.repaintTextNode();
    } );

    this._textSize = ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) ? 7 : 5;

};

AreaTool.prototype = osg.objectInherit( PickTool.prototype, {

    /**
     * Sets the tool active or inactive.
     * @memberof pcvizTools.AreaTool
     * @method
     * @param {boolean} active `true` if the tool is active.
     */
    setActive: function ( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( !active ) {
            this.dispatchData( 0.0 );

            this._viewer.getCanvas().parentElement.style.cursor = 'default';
            if ( this._pickingElement !== undefined )
                this._pickingElement.style.display = 'none';

            this.removeEventListeners();
            this.clearTool();
            // if we want to mantain the area until the tool is reactivated, remove the next two lines.
            this._globalArea = 0.0;
            this._positions = [];

            if ( this._textNode !== undefined ) {
                this._areaNode.removeChild( this._textNode );
                this._textNode = undefined;
            }
            this._geometryNode.removeChildren();

            // Disable picking only if it is necessary
            this.setPickingEnabled( false );

            // we don't need to enable the intersections because they haven't been disabled
            /* if ( this._viewer.getVectorLayerScene() )
                 this._viewer.getVectorLayerScene().setEnableIntersections( true );*/

            // enable stations floor marker intersections
            this.enableStationsIntersections( true );
        } else {

            this.initSelectedFeatureUse();

            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );

            this._viewer.disableManipulatorDoubleClick();
            this.setUpEventListeners();

            this.setPickingEnabled( true );

            // ALLOW intersections for navigation and measurement on features
            //if ( this._viewer.getVectorLayerScene() )
            //    this._viewer.getVectorLayerScene().setEnableIntersections( false );

            // disable stations floor marker intersections
            this.enableStationsIntersections( false );
        }

    },

    enableStationsIntersections: function ( value ) {
        let stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let stationsCache = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );
        stationsCache.forEach( ( stationDataCacheObj ) => {
            if ( stationDataCacheObj.getLayerGroupObj() &&
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer() &&
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer().getSymbol() ) {
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer().getSymbol().enableFloorMarkerIntersections( value );
            }
        } );
    },

    /**
     * Clears the current area.
     * @memberof pcvizTools.AreaTool
     * @method
     */
    clearTool: function () {
        this._zMax = undefined;
        PickTool.prototype.clearTool.call( this );
        this._previousFeatureSelected = undefined;

        this.dispatchData( this._globalArea );
    },

    /**
     * Callback invoked each frame. Checks positions array and calls `draw`
     * to draw and compute the area.
     * @memberof pcvizTools.AreaTool
     * @method
     */
    update: function () {
        if ( !this.isToolActive() )
            return;

        if ( this._positionsArray ) {
            if ( this._globalArea === 0 ) {
                this._geometryNode.removeChildren();
            }
            var auxiliarPositions = this._positionsArray.slice( 0 );

            if ( this._typeEvent !== 'escapeKey' && this._typeEvent !== 'dblclick' ) {
                if ( this._currentHitPosition )
                    auxiliarPositions.push( this._currentHitPosition );
                this.draw( auxiliarPositions );
                return;
            }
            if ( this._typeEvent === 'escapeKey' )
                this.draw( auxiliarPositions );
            if ( this._typeEvent === 'dblclick' ) {
                this._positions.pop();
            }
            this._textNode.setBackgroundColor( osg.vec4.fromValues32( 51, 51, 51, 0.8 ) );
            this.clearTool();
            return;
        }
        if ( this._previousFeatureSelected && this._featureSelectedGeomType === FeatureDefinition.POLYGON ) {
            if ( this._globalArea === 0 ) {
                this._geometryNode.removeChildren();
            }
            var geometryExteriorRing = this._previousFeatureSelected.getGeometry().getExteriorRing();
            this._positions = [];
            var center = this._viewer.getCenter();
            for ( var i = 0; i < geometryExteriorRing.getNumPoints(); i++ ) {
                // for 3d geometries
                this._positions.push( [ geometryExteriorRing.getX( i ) - center[ 0 ], geometryExteriorRing.getY( i ) - center[ 1 ], geometryExteriorRing.getZ( i ) - center[ 2 ] ] );
            }
            this._positionsArray = this._positions.copyWithin( 0, 0 );
            this._currentHitPosition = this._positions[ this._positions.length - 1 ];
            this._lastHitPosition = this._currentHitPosition;

            this.draw( this._positions ); //  to draw the area, compute its value and render the label
            this.clearTool();
        }

    },

    /**
     * Calls a 'createArea' method or a 'updateArea' method and
     * dispatches the area value to the `listenData` callback.
     * @memberof pcvizTools.AreaTool
     * @method
     */
    draw: function ( auxiliarPositions ) {
        var positions;

        this._positions = auxiliarPositions.slice( 0 );

        positions = this._positions;
        if ( positions.length === 0 )
            return;
        else if ( positions.length > 1 ) {

            // While we have minus than 3 points, the area geometry doesn't have Vertex BufferArray. So, we can't update it.
            // But, we have to call 'createArea' to draw the wire geometry.
            if ( this._geometryNode.getChildren().length === 0 ) {
                var geometry = this.createArea( positions );

                this._geometryNode.addChild( geometry.area );
                this._geometryNode.addChild( geometry.wire );
                if ( geometry.marker !== undefined )
                    this._geometryNode.addChild( geometry.marker );
            } else
                this.updateArea( positions );
        }

        this.dispatchData( this._globalArea );
    },

    /**
     * Creates the geometry of the given array of vertices.
     * @memberof pcvizTools.AreaTool
     * @method
     * @param  {Array<osg.vec3>} positions The vertices that form the area
     * @return {object} An object with the geometries: `area` with the area mesh, `wire` with the lines
     * that form the perimeter, and, when using flat projection, `marker` with the vertical lines that
     * go from the vertices of the area to the intersection with the point cloud.
     */
    createArea: function ( positions ) {

        var vertices = new Float32Array( 3 * positions.length );


        var pointCenter = osg.vec3.create32();

        var areaObject = this._sketchTool.drawArea( positions, this._flatProjection, Utils.AREA_COLOR, vertices /*, indexes*/ , pointCenter );

        var indexes = Utils.getPolygonTriangIndexes( vertices ); // check if we can avoid redo this call

        this._globalArea = this.computeArea( vertices, indexes );


        var textString = this._unitsController.convertToUserUnit( this._globalArea.toString(), 'area' );
        if ( this._textNode === undefined ) {
            this._textNode = this.createText( pointCenter, textString );
            this._areaNode.addChild( this._textNode );
        } else {
            this._textNode.setText( textString );
            this._textNode.setPosition( pointCenter );
            if ( this._positionsArray ) // If the user is still measuring
                this._textNode.setBackgroundColor( osg.vec4.fromValues32( 63, 81, 181, 0.8 ) );
            else // If the user has finished the measurement (this can happen because createArea is called when the flat mode is changed)
                this._textNode.setBackgroundColor( osg.vec4.fromValues32( 51, 51, 51, 0.8 ) );
        }

        areaObject.area.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );

        return areaObject;
    },

    updateArea: function ( positions ) {
        var vertexBufferArray, verticesAux;
        var colorsBufferArray, colorsAux;

        var vertexBufferArrayWire, colorsBufferArrayWire, colorsAuxWire;
        var i; // used as loop counter in some 'for' loops
        var indexes, gIndexes, gPrimitive;

        vertexBufferArray = this._geometryNode.getChild( 0 ).getVertexAttributeList().Vertex;
        colorsBufferArray = this._geometryNode.getChild( 0 ).getVertexAttributeList().Color;

        var xMax = -Number.MAX_VALUE;
        var xMin = Number.MAX_VALUE;
        var yMax = -Number.MAX_VALUE;
        var yMin = Number.MAX_VALUE;
        var zMax = -Number.MAX_VALUE;
        var zMin = Number.MAX_VALUE;

        for ( i = 0; i < positions.length; i++ ) {
            var position = positions[ i ];
            xMax = Math.max( xMax, position[ 0 ] );
            xMin = Math.min( xMin, position[ 0 ] );

            yMax = Math.max( yMax, position[ 1 ] );
            yMin = Math.min( yMin, position[ 1 ] );

            zMax = Math.max( zMax, position[ 2 ] );
            zMin = Math.min( zMin, position[ 2 ] );
        }

        this._sketchTool.updateBufferArrays( vertexBufferArray, colorsBufferArray, zMax, Utils.AREA_COLOR, this._flatProjection, positions );

        verticesAux = vertexBufferArray.getElements();

        indexes = Utils.getPolygonTriangIndexes( verticesAux );
        gIndexes = new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes );
        gPrimitive = new osg.DrawElements( osg.primitiveSet.TRIANGLES, gIndexes );

        this._geometryNode.getChild( 0 ).getPrimitiveSetList().pop();
        this._geometryNode.getChild( 0 ).getPrimitiveSetList().push( gPrimitive );


        this._geometryNode.getChild( 0 ).dirty();
        vertexBufferArray.dirty();
        colorsBufferArray.dirty();


        // update text
        var zPos = ( zMax * 3.0 + zMin ) / 4.0;
        this._globalArea = this.computeArea( verticesAux, indexes );
        var point = osg.vec3.fromValues32( ( xMax + xMin ) / 2.0, ( yMax + yMin ) / 2.0, zPos );
        if ( this._flatProjection )
            point[ 2 ] = zMax;

        this._zMax = zMax;


        var textString = this._unitsController.convertToUserUnit( this._globalArea.toString(), 'area' );
        this._textNode.setText( textString );
        this._textNode.setPosition( point );


        if ( this._flatProjection ) {
            //update markers
            this._sketchTool.updateMarkers( zMax, this._geometryNode.getChild( 2 ), positions );
        }


        // update wire
        vertexBufferArrayWire = this._geometryNode.getChild( 1 ).getVertexAttributeList().Vertex;
        vertexBufferArrayWire.setElements( verticesAux );

        colorsBufferArrayWire = this._geometryNode.getChild( 1 ).getVertexAttributeList().Color;
        colorsAuxWire = new Float32Array( positions.length * 4 );
        colorsAux = colorsBufferArray.getElements();
        colorsAuxWire.set( colorsAux, 0 );

        for ( i = 3; i < colorsAuxWire.length; i += 4 )
            colorsAuxWire[ i ] = 1.0;

        colorsBufferArrayWire.setElements( colorsAuxWire );

        this._geometryNode.getChild( 1 ).getPrimitiveSetList()[ 0 ].count = positions.length;

        this._geometryNode.getChild( 1 ).dirty();
        vertexBufferArrayWire.dirty();
        colorsBufferArrayWire.dirty();
    },

    /**
     * Method to create a text label with the distance of a segment
     * @method
     * @memberof pcvizTools.AreaTool
     * @param  {osg.vec3} pos The position of the text
     * @param  {String} textToRender The text to be shown in the label
     * @return {CustomText}     the text object to be added in the scene graph
     */
    createText: function ( pos, textToRender ) {
        var text = new CustomText( textToRender );

        text.setPosition( pos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( this._textSize );
        text.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( osg.Depth.ALWAYS ), osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE ); //

        text.setColor( osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 ) );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( osg.vec4.fromValues32( 63, 81, 181, 0.8 ) );
        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    },

    /**
     * Computes the area of the given mesh by its vertices and indexes
     * @method
     * @memberof pcvizTools.AreaTool
     * @param  {osg.BufferArray} vertices The list of vertices that form the triangles
     * @param  {osg.BufferElementArray} indexes  The indexes of the triangles
     * @return {float}          Total area of the given mesh
     */
    computeArea: function ( vertices, indexes ) {
        var area = 0,
            areaTriangle;
        var s; // semiperimeter
        var a, b, c; // Sides of the triangle
        var v1, v2, v3; // Vertices of the triangle
        for ( var i = 0; i < indexes.length; i += 3 ) {
            v1 = osg.vec3.fromValues32( vertices[ indexes[ i ] * 3 ], vertices[ indexes[ i ] * 3 + 1 ], vertices[ indexes[ i ] * 3 + 2 ] );
            v2 = osg.vec3.fromValues32( vertices[ indexes[ i + 1 ] * 3 ], vertices[ indexes[ i + 1 ] * 3 + 1 ], vertices[ indexes[ i + 1 ] * 3 + 2 ] );
            v3 = osg.vec3.fromValues32( vertices[ indexes[ i + 2 ] * 3 ], vertices[ indexes[ i + 2 ] * 3 + 1 ], vertices[ indexes[ i + 2 ] * 3 + 2 ] );
            a = osg.vec3.distance( v1, v2 );
            b = osg.vec3.distance( v2, v3 );
            c = osg.vec3.distance( v3, v1 );

            s = ( a + b + c ) / 2;
            areaTriangle = Math.sqrt( s * ( s - a ) * ( s - b ) * ( s - c ) );
            area += areaTriangle;
        }
        return area;
    },

    /**
     * Toggles the drawing method between the horizontal projection and
     * the 3D drawing.
     * @method
     * @memberof pcvizTools.AreaTool
     */
    toggleProjection: function () {
        this._flatProjection = !this._flatProjection;

        if ( this._positions.length > 1 ) {
            // we have to remove the area and add the new because of we have to add/remove markers
            this._geometryNode.removeChildren();
            var geometry = this.createArea( this._positions );

            this._geometryNode.addChild( geometry.area );
            this._geometryNode.addChild( geometry.wire );
            if ( geometry.marker !== undefined )
                this._geometryNode.addChild( geometry.marker );
        }

        this.dispatchData( this._globalArea );
    },

    repaintTextNode: function () {
        var textString = this._unitsController.convertToUserUnit( this._globalArea.toString(), 'area' );

        if ( this._textNode !== undefined )
            this._textNode.setText( textString );
    },

    getMeasurePoints: function () {
        return this._positions;
    },

    isFlatProjection: function () {
        return this._flatProjection;
    },

    // Use this method only if isFlatProjection returns true
    getZMax: function () {
        if ( this._zMax )
            return this._zMax;

        return this._textNode.getPosition()[ 2 ];
    },

    computePerimeter: function () {
        var perimeter = 0;
        for ( var i = 0; i < this._positions.length - 1; i++ ) {
            perimeter += osg.vec3.distance( this._positions[ i ], this._positions[ i + 1 ] );
        }
        perimeter += osg.vec3.distance( this._positions[ i ], this._positions[ 0 ] );
        return perimeter;
    }

} );

module.exports = AreaTool;


/***/ }),

/***/ "./sources/pcvizTools/BufferTool.js":
/*!******************************************!*\
  !*** ./sources/pcvizTools/BufferTool.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Julio Campos <julio.campos@mirage-tech.com>
 *  Jordi Torres <jordi.torres@mirage-tech.com>
 */


var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgUtil = OSG.osgUtil;
var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
var PointCollectorPolytopeIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorPolytopeIntersector */ "./sources/pcvizUtils/PointCollectorPolytopeIntersector.js" );
var PointCollectorSphereIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorSphereIntersector */ "./sources/pcvizUtils/PointCollectorSphereIntersector.js" );
var PointCollectorLineIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorLineIntersector */ "./sources/pcvizUtils/PointCollectorLineIntersector.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var Uniform = osg.Uniform;
var GizmoGeometry = osgUtil.GizmoGeometry;
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const { EVENT_KEYS } = __webpack_require__( /*! pcvizUtils/EventKeys */ "./sources/pcvizUtils/EventKeys.js" );

var lineColor = osg.vec4.fromValues32( 1.0, 1.0, 0.0, 1.0 );
var aConeHeight = 15;
var startColor = [ 0.1, 0.8, 0.35, 0.75 ];
var endColor = [ 1.0, 0.5, 0.0, 0.75 ];

/**
 *  Buffer tool
 *  @class
 *  @memberof pcvizTools
 *  @extends Tool
 */

var BufferTool = function ( viewer ) {
    PickTool.call( this, viewer, 'buffer' );

    this._worldPositionsArray = undefined;

    this._currentMode = BufferTool.POINT;

    // Disables the picking element for mobile devices
    if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test( navigator.userAgent ) )
        this._pickingElementEnabled = false;

    this._iv = new osgUtil.IntersectionVisitor();
    this._segments = undefined;
    // For section calculation
    this._width = BufferTool.DEFAULT_RANGE;
    // For cross section
    this._depth = 10.0;
    this._lastHitPosition = osg.vec3.create();
    this._crossSectionNode = new osg.Node();
    viewer.getToolsNode().addChild( this._crossSectionNode );
    this._crossSectionNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
    this._crossSectionPath = undefined;
    this._sketchTool = new SketchTool( viewer );
    this._linesNode = new osg.Node();
    viewer.getToolsNode().addChild( this._linesNode );
    this._linesNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
    this._atArrowIni = this.prepareArrowGeometry( startColor );
    this._atArrowEnd = this.prepareArrowGeometry( endColor );

    this._sliderPosition = 0.0001;
    this._boxRedraw = false;
    this._boxRotation = 0.0;
    this._unitCtrl = Registry.getInstance().getController( 'Units' );
    this._currentDistanceUnit = this._unitCtrl.getCurrentUnit( 'distance' );

    this._data = []; // arrays of nodes containing bufferAttribute objects
    for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
        this._data.push( [] );

    // params for deletionTool workflow
    this._createBufferEnabled = true;
    this._crossSectionPosition = {
        value: 0,
        calculated: 0,
        options: {
            min: 0,
            minTransformed: 0,
            max: 0,
            maxTransformed: 0
        }
    };

    this._disabledModes = [];
};

BufferTool.ON_POINTCLOUDS = 0;
BufferTool.ON_3DMODELS = 1;
BufferTool.ON_FEATURES = 2;
BufferTool.ON_SUPPORTED_TYPES = 3;

BufferTool.POINT = 0;
BufferTool.LINE = 1;
BufferTool.VERTICAL_LINE = 2;
BufferTool.CROSS_SECTION = 3;
BufferTool.BOX = 4;

BufferTool.DEFAULT_RANGE = Math.pow( 1.1, ( 50.0 - 20.0 ) );

BufferTool.prototype = osg.objectInherit( PickTool.prototype, {

    setActive: function ( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( !active ) {
            this.removeEventListeners();

            this._linesNode.removeChildren();
            this._crossSectionNode.removeChildren();
            this._currentHitPosition = undefined;
            this.setCreateBufferEnabled( true );

            // Disable picking only if it is necessary
            this.setPickingEnabled( false );

            // we don't need to enable the intersections because they haven't been disabled
            /*  if ( this._viewer.getVectorLayerScene() )
                  this._viewer.getVectorLayerScene().setEnableIntersections( true );*/
        } else {
            this.initSelectedFeatureUse();

            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );

            this._viewer.disableManipulatorDoubleClick();
            this.setUpEventListeners();

            this.setCreateBufferEnabled( true );
            // Enable picking
            this.setPickingEnabled( true );

            // ALLOW intersections for navigation and measurement on features
            //if ( this._viewer.getVectorLayerScene() )
            //    this._viewer.getVectorLayerScene().setEnableIntersections( false );

            // Initially enable buffer drawing in point mode, when not yet positioned
            if ( this._currentMode === BufferTool.POINT && this._worldPositionsArray === undefined )
                this.activateBufferShaders( true );
        }

        var regionTool = this._viewer.findTool( 'region' );
        regionTool.setActive( this._active && this._useRegionCube, true );
    },

    setUseRegionCube: function ( cubeMode ) {

        this._useRegionCube = ( this._currentMode === BufferTool.BOX ) && cubeMode;
        var regionTool = this._viewer.findTool( 'region' );
        regionTool.setSaveRegionInProject( false );
        regionTool.setActive( this._active && this._useRegionCube, true );

        if ( cubeMode ) {
            this._linesNode.removeChildren();
            this._crossSectionNode.removeChildren();
            this._currentHitPosition = undefined;
            this.setPickingEnabled( false );
        } else if ( this._active ) {
            this.setPickingEnabled( true );
        }
    },

    activateBufferShaders: function ( active ) {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setEnabled( active ? 1.0 : 0.0 );
            }
    },

    setData: function ( data, onNodeType ) {
        if ( onNodeType === undefined )
            onNodeType = BufferTool.ON_POINTCLOUDS;

        this._data[ onNodeType ] = data;

        if ( this._active )
            this.activateBufferShaders( true );

        if ( this._currentMode !== BufferTool.POINT )
            this.setBufferAttributeByMode( this._currentMode );
    },

    setCrsParams: function ( crsParams ) {
        this._crsParams = crsParams;
    },

    setSectionRefreshCallback: function ( callback ) {
        this._sectionRefreshCallback = callback;
    },

    setBufferMode: function ( mode ) {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setBufferMode( mode );
            }
    },

    setLineBufferParams: function () {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setLineBuffer( this._worldPositionsArray );
                this._data[ iType ][ i ].bufferAttribute.setRange( this._width );
            }
    },

    setMode: function ( mode ) {

        if ( mode === this._currentMode || mode === undefined )
            return;

        this._currentMode = mode;

        this.setBufferAttributeByMode( mode );

        this.initWorldPositions();
        this.clearTool( true );
        this._linesNode.removeChildren();
        this.activateBufferShaders( true );
    },

    setBufferAttributeByMode: function ( mode ) {
        switch ( mode ) {
        case BufferTool.POINT:
            this.setBufferMode( BufferAttribute.POINT );
            break;
        case BufferTool.LINE:
            this.setBufferMode( BufferAttribute.LINE );
            break;
        case BufferTool.VERTICAL_LINE:
            this.setBufferMode( BufferAttribute.VERTICAL_LINE );
            break;
        case BufferTool.CROSS_SECTION:
            this.setBufferMode( BufferAttribute.VERTICAL_LINE );
            this._boxRedraw = true;
            break;
        case BufferTool.BOX:
            this.setBufferMode( BufferAttribute.BOX );
            this._boxRedraw = true;
            break;
        }
    },

    initWorldPositions: function () {
        if ( ( this._currentMode === BufferTool.VERTICAL_LINE || this._currentMode === BufferTool.LINE || this._currentMode === BufferTool.CROSS_SECTION ) &&
            this._positionsArray !== undefined ) {
            this._worldPositionsArray = [];
            for ( var i = 0; i < this._positionsArray.length; i++ ) {
                this._worldPositionsArray[ i ] = osg.vec3.add( osg.vec3.create32(), this._positionsArray[ i ], this._viewer.getCenter() );
            }
            this.setLineBufferParams();
            this.activateBufferShaders( true );
        }
    },

    getMode: function () {
        return this._currentMode;
    },

    getIsPathValid: function () {
        if ( this._currentMode === BufferTool.BOX )
            return true;
        if ( this._currentMode === BufferTool.POINT )
            return this._positionsArray !== undefined && this._positionsArray.length === 1;
        return ( this._positionsArray !== undefined && this._positionsArray.length > 1 );
    },

    getReferencePoints: function () {
        return this._positionsArray;
    },

    getLength: function () {
        var l = 0;
        for ( var i = 0; i < this._positionsArray.length - 1; i++ ) {
            l += osg.vec3.distance( this._positionsArray[ i ], this._positionsArray[ i + 1 ] );
        }
        return l;
    },

    // For point, box and 3D line buffers
    getPoints: function () {
        var segments3D = [];

        if ( this._currentMode === BufferTool.POINT ) {
            this._pointCollector = new PointCollectorSphereIntersector();
            this._pointCollector.reset();

            var worldPosition = this._position;
            if ( this._worldPositionsArray !== undefined )
                worldPosition = this._worldPositionsArray[ 0 ];

            var localPosition = osg.vec3.create32();
            osg.vec3.sub( localPosition, worldPosition, this._viewer.getCenter() );
            this._pointCollector.setPath( localPosition );
            this._pointCollector.setWidth( this._width );

        } else if ( this._currentMode === BufferTool.LINE ) {
            this._pointCollector = new PointCollectorLineIntersector();
            this._pointCollector.reset();
            this._pointCollector.setPath( this._positionsArray );
            this._pointCollector.setWidth( this._width );

        } else if ( this._currentMode === BufferTool.BOX ) {
            var corners = this.getRotatedBoxCorners();
            if ( !corners )
                return segments3D;

            this._pointCollector = new PointCollectorPolytopeIntersector();
            this._pointCollector.reset();
            this._pointCollector.setPolytopeCorners( corners );
        }

        this._iv.setIntersector( this._pointCollector );
        this._viewer.getSceneView().getSceneNode().accept( this._iv );

        var points = this._pointCollector.getCollectedPoints3D();
        var colors = this._pointCollector.getCollectedPointsColors();
        this.transformToWorld3D( points );
        //if ( !keepOriginalUnits )
        //    this.transformToUserUnits3D( points );

        var segment = {
            points: points,
            colors: colors
        };
        segments3D.push( segment );

        return segments3D;
    },

    getLongSectionProfile: function ( collectPoints ) {
        // Pass the current path to the intersector
        // Maybe it would be better to update it "on the fly"
        this._segments = [];

        if ( !collectPoints )
            return this._segments;

        var lineLength = 0.0;

        this._currentDistanceUnit = this._unitCtrl.getCurrentUnit( 'distance' );
        var centerZ = this._viewer.getCenter()[ 2 ] / this._currentDistanceUnit.fromMeters;
        this._pointCollector = new PointCollectorPolytopeIntersector();
        var geoidHeight = CRSUtils.getGeoidCorrection( this._viewer.getCenter(), this._crsParams ) / this._currentDistanceUnit.fromMeters;
        centerZ -= geoidHeight; // apply the same height shift to all points (this is an approximation, enough for section view)

        for ( var i = 0, j = this._positionsArray.length; i < j - 1; i++ ) {
            this._pointCollector.reset();
            this._pointCollector.setPath( this._positionsArray[ i ], this._positionsArray[ i + 1 ] );
            this._pointCollector.setWidth( this._width );
            this._iv.setIntersector( this._pointCollector );
            this._viewer.getSceneView().getSceneNode().accept( this._iv );

            var points = this._pointCollector.getLongSectionPositions();
            var colors = this._pointCollector.getCollectedPointsColors();
            var maxZ = this._pointCollector.getMaxZ() / this._currentDistanceUnit.fromMeters + centerZ;
            var minZ = this._pointCollector.getMinZ() / this._currentDistanceUnit.fromMeters + centerZ;

            var lineLengthInc = osg.vec2.distance( [ this._positionsArray[ i ][ 0 ], this._positionsArray[ i ][ 1 ] ], [ this._positionsArray[ i + 1 ][ 0 ], this._positionsArray[ i + 1 ][ 1 ] ] );
            lineLengthInc /= this._currentDistanceUnit.fromMeters;

            this.transformToUserUnits( points );

            // We are translating Y coordinate to avoid negative values in the exporter
            // For the X values we keep the local ones, because the exporter should start from 0, that's why we don't translate
            // xmin and xmax.
            // The SectionView will scale correctly in the X and Y axis regardless the
            // range values.
            // array, offset, start, stride
            this.transformFloatArray( points, centerZ, 1, 2 );

            var segment = {
                points: points,
                colors: colors,
                segmentWidth: lineLengthInc,
                xmin: 0,
                xmax: lineLengthInc,
                ymin: minZ,
                ymax: maxZ,
                point1: this._positionsArray[ i ],
                point2: this._positionsArray[ i + 1 ],
                bufferType: 'long',
                width: this._width,
                centerZ: centerZ
            };
            this._segments.push( segment );

            lineLength += lineLengthInc;
        }

        // apply x offsets
        var xOffset = 0.0;

        this._segments.forEach( function ( pointSeg ) {
            if ( pointSeg.points !== undefined ) {
                for ( var iPt = 0; iPt < pointSeg.points.length; iPt += 2 ) {
                    pointSeg.points[ iPt ] += xOffset;
                }
                if ( pointSeg.segmentWidth !== undefined ) {
                    xOffset += pointSeg.segmentWidth;
                }
            }
        } );

        return this._segments;
    },

    getLongSectionProfile3D: function ( keepOriginalUnits ) { // for 3D exporting

        var segments3D = [];
        this._pointCollector = new PointCollectorPolytopeIntersector();

        for ( var i = 0, j = this._positionsArray.length; i < j - 1; i++ ) {
            this._pointCollector.reset();
            this._pointCollector.setPath( this._positionsArray[ i ], this._positionsArray[ i + 1 ] );
            this._pointCollector.setWidth( this._width );
            this._iv.setIntersector( this._pointCollector );
            this._viewer.getSceneView().getSceneNode().accept( this._iv );

            var points = this._pointCollector.getCollectedPoints3D();
            var colors = this._pointCollector.getCollectedPointsColors();
            this.transformToWorld3D( points );
            if ( !keepOriginalUnits )
                this.transformToUserUnits3D( points );

            var segment = {
                points: points,
                colors: colors
            };
            segments3D.push( segment );
        }
        return segments3D;
    },

    transformToWorld3D: function ( points3D ) {
        var center = this._viewer.getCenter();

        points3D.forEach( function ( point ) {
            point[ 0 ] += center[ 0 ];
            point[ 1 ] += center[ 1 ];
            point[ 2 ] += center[ 2 ];
        } );
    },

    transformFloatArray: function ( floatArray, offset, start, stride ) {
        for ( var i = start, len = floatArray.length; i < len; i += stride ) {
            floatArray[ i ] += offset;
        }
    },

    transformToUserUnits: function ( points ) {
        Registry.getInstance().getController( 'Units' ).convertFloatArrayToDistanceUnit( points );
    },

    transformToUserUnits3D: function ( points3D ) {
        Registry.getInstance().getController( 'Units' ).convertPointArrayToDistanceUnit( points3D, 3 );
    },



    getPathPosition: ( function () {
        var startResult = osg.vec3.create();
        var endResult = osg.vec3.create();
        var dirVec = osg.vec3.create();
        var result = [];
        return function ( sliderPosition ) {
            var pathLength = [ 0 ];
            var totalLength = 0;
            var start, end;
            // We need to have a simple structure to store path distances
            // and fill it.
            var i, j;
            if ( !this.getIsPathValid() )
                return;

            for ( i = 0, j = this._positionsArray.length; i < j - 1; i++ ) {
                start = this._positionsArray[ i ];
                end = this._positionsArray[ i + 1 ];
                totalLength += osg.vec3.distance( start, end );
                pathLength.push( totalLength );
            }

            var pointDistance = totalLength * sliderPosition;
            var startPoint, endPoint;
            var distanceFromStartPoint = 0;

            // Find which segments corresponds to the sliderPos
            for ( i = 0; i < pathLength.length; i++ ) {
                if ( pointDistance >= pathLength[ i ] && pointDistance <= pathLength[ i + 1 ] ) {
                    // We get the start point and the distance from it
                    startPoint = this._positionsArray[ i ];
                    endPoint = this._positionsArray[ i + 1 ];
                    distanceFromStartPoint = pointDistance - pathLength[ i ];
                    break;
                }
            }
            // Now calculate the 3D points
            osg.vec3.sub( dirVec, endPoint, startPoint );
            osg.vec3.normalize( dirVec, dirVec );
            osg.vec3.scale( startResult, dirVec, distanceFromStartPoint );
            osg.vec3.scale( endResult, dirVec, distanceFromStartPoint + this._depth );
            result[ 0 ] = osg.vec3.add( startResult, startResult, startPoint );
            result[ 1 ] = osg.vec3.add( endResult, endResult, startPoint );
            return result;
        };
    } )(),

    getCrossSectionPositionsLength: function () {
        var totalLength = 0;
        if ( this._positionsArray === undefined )
            return totalLength;
        for ( var i = 0; i < this._positionsArray.length - 1; i++ ) {
            totalLength += osg.vec3.distance( this._positionsArray[ i ], this._positionsArray[ i + 1 ] );
        }
        return totalLength;
    },

    getCrossSectionProfile: function ( sliderPosition, collectPoints ) {
        // Calculate first which is the position in the path
        // depending on the position in the slider ( from 0 to 1 )
        this._sliderPosition = sliderPosition;
        var path = this.getPathPosition( sliderPosition );
        if ( path === undefined )
            return;

        this._pointCollector = new PointCollectorPolytopeIntersector();
        this._pointCollector.reset();
        this._pointCollector.setPath( path[ 0 ], path[ 1 ] );
        this._pointCollector.setWidth( this._width );

        this._corners = this._pointCollector.getPolytopeCorners();
        this._crossSectionPath = this.getCrossSectionBufferPath( this._corners );
        this._boxRedraw = true;

        this._currentDistanceUnit = this._unitCtrl.getCurrentUnit( 'distance' );
        var centerZ = this._viewer.getCenter()[ 2 ] / this._currentDistanceUnit.fromMeters;
        var geoidHeight = CRSUtils.getGeoidCorrection( this._viewer.getCenter(), this._crsParams ) / this._currentDistanceUnit.fromMeters;
        centerZ -= geoidHeight; // apply the same height shift to all points (this is an approximation, enough for section view)

        if ( !collectPoints ) { // do not calculate min/maxZ dynamically to make refresh faster
            this._maxZ = this._viewer.getPointCloudScene().getMaxZ();
            this._minZ = this._viewer.getPointCloudScene().getMinZ();
            return [];
        }

        this._iv.setIntersector( this._pointCollector );
        this._viewer.getSceneView().getSceneNode().accept( this._iv );

        var points = this._pointCollector.getCrossSectionPositions();
        var colors = this._pointCollector.getCollectedPointsColors();
        this._maxZ = this._pointCollector.getMaxZ();
        this._minZ = this._pointCollector.getMinZ();
        var maxZ = this._maxZ / this._currentDistanceUnit.fromMeters + centerZ;
        var minZ = this._minZ / this._currentDistanceUnit.fromMeters + centerZ;

        this.transformToUserUnits( points );

        // correct Y coordinate
        this.transformFloatArray( points, centerZ, 1, 2 );

        var convertedWidth = this._width / this._currentDistanceUnit.fromMeters;
        var segment = {
            points: points,
            colors: colors,
            segmentWidth: 2 * convertedWidth,
            xmin: -convertedWidth,
            xmax: convertedWidth,
            ymin: minZ,
            ymax: maxZ,
            point1: path[ 0 ],
            point2: path[ 1 ],
            bufferType: 'cross',
            width: 0.5 * this._depth,
            crossPath: this._crossSectionPath,
            centerZ: centerZ
        };
        this._segments = [];
        this._segments.push( segment );

        return this._segments;
    },

    getCrossSectionProfile3D: function ( sliderPosition, keepOriginalUnits ) {
        // Calculate first which is the position in the path
        // depending on the position in the slider ( from 0 to 1 )
        this._sliderPosition = sliderPosition;
        var path = this.getPathPosition( sliderPosition );
        if ( path === undefined )
            return;

        this._pointCollector = new PointCollectorPolytopeIntersector();
        this._pointCollector.reset();
        this._pointCollector.setPath( path[ 0 ], path[ 1 ] );
        this._pointCollector.setWidth( this._width );
        this._iv.setIntersector( this._pointCollector );

        this._viewer.getSceneView().getSceneNode().accept( this._iv );

        var points = this._pointCollector.getCollectedPoints3D();
        var colors = this._pointCollector.getCollectedPointsColors();
        this.transformToWorld3D( points );
        if ( !keepOriginalUnits )
            this.transformToUserUnits3D( points );

        var segment = {
            points: points,
            colors: colors,
        };
        var segments3D = [];
        segments3D.push( segment );
        return segments3D;
    },

    getCrossSectionBufferPath: function ( corners ) {
        var ll = corners.lowLeft;
        var hl = corners.highLeft;
        var hr = corners.highRight;
        var lr = corners.lowRight;
        var result = [];
        result[ 0 ] = osg.vec3.lerp( osg.vec3.create(), hl, ll, 0.5 );
        result[ 1 ] = osg.vec3.lerp( osg.vec3.create(), hr, lr, 0.5 );
        return result;
    },




    /**
     * Method to draw point buffer
     * @method
     * @memberof pcvizTools.BufferTool
     */
    drawPointBuffer: function () {
        if ( this._position === undefined )
            return;
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setPointBuffer( this._position );
                if ( this._worldPositionsArray !== undefined ) {
                    this._data[ iType ][ i ].bufferAttribute.setPointBuffer( this._worldPositionsArray[ 0 ] );
                }
            }
    },

    /**
     * Method to draw cross section buffer
     * @method
     * @memberof pcvizTools.BufferTool
     */
    drawCrossSectionBuffer: function () {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                if ( this._crossSectionPath === undefined ) {
                    this._data[ iType ][ i ].bufferAttribute.setLineBuffer( [] );
                    continue;
                }
                var worldPath = [];
                worldPath[ 0 ] = osg.vec3.add( osg.vec3.create32(), this._crossSectionPath[ 0 ], this._viewer.getCenter() );
                worldPath[ 1 ] = osg.vec3.add( osg.vec3.create32(), this._crossSectionPath[ 1 ], this._viewer.getCenter() );
                this._data[ iType ][ i ].bufferAttribute.setLineBuffer( worldPath );

                if ( this._maxZ < this._minZ ) { // invalid values may happen if no point cloud is present
                    var minZ = Math.min( this._corners.highLeft[ 2 ], this._corners.lowLeft[ 2 ] );
                    var maxZ = Math.max( this._corners.highLeft[ 2 ], this._corners.lowLeft[ 2 ] );
                    this._minZ = minZ - 50.0;
                    this._maxZ = maxZ + 50.0;
                }

                if ( this._boxRedraw === true ) {
                    this.drawCrossSectionBox( this._corners, this._maxZ, this._minZ );
                    this._boxRedraw = false;
                }
            }

        this.activateBufferShaders( true );
    },
    /**
     * Method to draw long section buffer
     * @method
     * @memberof pcvizTools.BufferTool
     */
    drawLongSectionBuffer: function ( feature ) {
        if ( this._worldPositionsArray === undefined )
            return;
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                if ( !feature )
                    this._worldPositionsArray.push( this._position );
                this._data[ iType ][ i ].bufferAttribute.setLineBuffer( this._worldPositionsArray );
                if ( !feature )
                    this._worldPositionsArray.pop();
            }
        this.activateBufferShaders( true );
    },

    drawBoxBuffer: function () {
        var corners = this.drawBox(); // 2.5D corners
        if ( !corners ) {
            this.activateBufferShaders( false );
            return;
        }

        // set 3D box for bufferAttribute
        var boxOrigin = [ corners.lowLeft[ 0 ], corners.lowLeft[ 1 ], corners.minZ ];

        // create transformed corners
        var transfLowRight = osg.vec3.create64();
        var transfLowLeft = osg.vec3.create64();
        var transfHighLeft = osg.vec3.create64();
        // CHECK if we can remove some code in this function 
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                var boxVectors = [];
                var maxz = [ 0, 0, corners.maxZ ];
                var minz = [ 0, 0, corners.minZ ];
                if ( this._data[ iType ][ i ].bufferAttribute._dataMT ) {
                    var dataMT = this._data[ iType ][ i ].bufferAttribute._dataMT;
                    osg.vec3.transformMat4( transfLowRight, corners.lowRight, dataMT );
                    osg.vec3.transformMat4( transfLowLeft, corners.lowLeft, dataMT );
                    osg.vec3.transformMat4( transfHighLeft, corners.highLeft, dataMT );
                    osg.vec3.transformMat4( maxz, maxz, dataMT );
                    osg.vec3.transformMat4( minz, minz, dataMT );

                    osg.vec3.sub( transfLowRight, transfLowRight, this._data[ iType ][ i ].bufferAttribute._dataCenter );
                    osg.vec3.sub( transfLowLeft, transfLowLeft, this._data[ iType ][ i ].bufferAttribute._dataCenter );
                    osg.vec3.sub( transfHighLeft, transfHighLeft, this._data[ iType ][ i ].bufferAttribute._dataCenter );
                    osg.vec3.sub( maxz, maxz, this._data[ iType ][ i ].bufferAttribute._dataCenter );
                    osg.vec3.sub( minz, minz, this._data[ iType ][ i ].bufferAttribute._dataCenter );
                } else {
                    transfLowRight = corners.lowRight;
                    transfLowLeft = corners.lowLeft;
                    transfHighLeft = corners.highLeft;
                } // for vector


                if ( this._useRegionCube ) {
                    var regionTool = this._viewer.findTool( 'region' );
                    var region = regionTool.getRegion();
                    var xMin = region.xMin - region.rotCenter[ 0 ];
                    var yMin = region.yMin - region.rotCenter[ 1 ];
                    var zMin = region.zMin - region.rotCenter[ 2 ];
                    var xMax = region.xMax - region.rotCenter[ 0 ];
                    var yMax = region.yMax - region.rotCenter[ 1 ];
                    var zMax = region.zMax - region.rotCenter[ 2 ];

                    corners.lowLeft = [ xMin, yMin, 0 ];
                    corners.highLeft = [ xMin, yMax, 0 ];
                    corners.highRight = [ xMax, yMax, 0 ];
                    corners.lowRight = [ xMax, yMin, 0 ];
                    corners.minZ = zMin;
                    corners.maxZ = zMax;
                } else {
                    var minPt = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
                    var maxPt = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];

                    var sinRot = Math.sin( Math.PI * this._boxRotation / 180.0 );
                    var cosRot = Math.cos( Math.PI * this._boxRotation / 180.0 );
                    var rotatedAxes = [
                        [ cosRot, sinRot ],
                        [ -sinRot, cosRot ]
                    ];

                    if ( this._worldPositionsArray && this._currentHitPosition !== undefined ) // track moving cursor
                        this._positionsArray.push( this._currentHitPosition );

                    for ( var iPt = 0; iPt < this._positionsArray.length; iPt++ ) {
                        var x = this._positionsArray[ iPt ][ 0 ] * rotatedAxes[ 0 ][ 0 ] + this._positionsArray[ iPt ][ 1 ] * rotatedAxes[ 0 ][ 1 ];
                        var y = this._positionsArray[ iPt ][ 0 ] * rotatedAxes[ 1 ][ 0 ] + this._positionsArray[ iPt ][ 1 ] * rotatedAxes[ 1 ][ 1 ];
                        var z = this._positionsArray[ iPt ][ 2 ];
                        minPt[ 0 ] = Math.min( minPt[ 0 ], x );
                        minPt[ 1 ] = Math.min( minPt[ 1 ], y );
                        minPt[ 2 ] = Math.min( minPt[ 2 ], z );
                        maxPt[ 0 ] = Math.max( maxPt[ 0 ], x );
                        maxPt[ 1 ] = Math.max( maxPt[ 1 ], y );
                        maxPt[ 2 ] = Math.max( maxPt[ 2 ], z );
                    }
                    if ( this._worldPositionsArray && this._currentHitPosition !== undefined )
                        this._positionsArray.pop();

                    // extend box with range distance
                    minPt[ 0 ] -= this._width;
                    minPt[ 1 ] -= this._width;
                    minPt[ 2 ] -= this._width;
                    maxPt[ 0 ] += this._width;
                    maxPt[ 1 ] += this._width;
                    maxPt[ 2 ] += this._width;

                    corners.lowLeft = [ minPt[ 0 ], minPt[ 1 ], 0 ];
                    corners.highLeft = [ minPt[ 0 ], maxPt[ 1 ], 0 ];
                    corners.highRight = [ maxPt[ 0 ], maxPt[ 1 ], 0 ];
                    corners.lowRight = [ maxPt[ 0 ], minPt[ 1 ], 0 ];
                    corners.minZ = minPt[ 2 ];
                    corners.maxZ = maxPt[ 2 ];

                }
                boxVectors.push( [ corners.lowRight[ 0 ] - corners.lowLeft[ 0 ], corners.lowRight[ 1 ] - corners.lowLeft[ 1 ], 0 ] ); // X
                boxVectors.push( [ corners.highLeft[ 0 ] - corners.lowLeft[ 0 ], corners.highLeft[ 1 ] - corners.lowLeft[ 1 ], 0 ] ); // Y
                boxVectors.push( [ 0, 0, corners.maxZ - corners.minZ ] ); // Z

                this._data[ iType ][ i ].bufferAttribute.setBoxBuffer( boxOrigin, boxVectors );


                this._data[ iType ][ i ].bufferAttribute._boxRotation = this._boxRotation * Math.PI / 180;
                this._data[ iType ][ i ].bufferAttribute._boxMin = [ corners.lowLeft[ 0 ],
                    corners.lowLeft[ 1 ],
                    corners.minZ
                ];

                this._data[ iType ][ i ].bufferAttribute._boxMax = [ corners.lowRight[ 0 ],
                    corners.highLeft[ 1 ],
                    corners.maxZ
                ];

            }
        this.activateBufferShaders( true );
    },

    prepareArrowGeometry: function ( arrowColor ) {

        var arrowNode = new osg.AutoTransform();
        arrowNode.setAutoScaleToScreen( true );
        arrowNode.setMaximumScale( 10 );

        arrowNode.addChild(
            GizmoGeometry.createCylinderGeometry( 7, 7, aConeHeight, 32, 1, true, true )
        );

        arrowNode.getOrCreateStateSet()
            .addUniform( Uniform.createFloat4( arrowColor, 'uColor' ) );

        arrowNode.getOrCreateStateSet().setRenderBinDetails( Utils.RENDERBIN_LINEARROWS, Utils.RENDERBIN_LINEARROWS_TYPE );
        arrowNode.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );

        return arrowNode;
    },

    drawArrowForGuideLine: function () {

        if ( this._positionsArray.length < 1 || ( this._positionsArray.length === 1 && !this._currentHitPosition ) )
            return;

        if ( this._currentMode === BufferTool.BOX )
            return;

        if ( this._linesNode.getNumChildren() === 1 ) {
            this._linesNode.addChild( this._atArrowIni );
            this._linesNode.addChild( this._atArrowEnd );
        }

        var direction = osg.vec3.create();
        var quatRotationIni = osg.quat.create();

        // init arrow
        this._atArrowIni.setPosition( this._positionsArray[ 0 ] );
        if ( this._positionsArray.length >= 2 )
            osg.vec3.sub( direction, this._positionsArray[ 1 ], this._positionsArray[ 0 ] );
        else if ( this._currentHitPosition )
            osg.vec3.sub( direction, this._currentHitPosition, this._positionsArray[ 0 ] );
        else
            direction = osg.vec3.create( 1.0, 0.0, 0.0 );
        osg.vec3.normalize( direction, direction );
        osg.quat.rotationTo( quatRotationIni, [ 0, 0, 1 ], direction );

        this._atArrowIni.setRotation( quatRotationIni );

        // end arrow
        this.drawEndCylinder();
    },

    drawEndCylinder: function () {
        var direction = osg.vec3.create();
        var quatRotationEnd = osg.quat.create();
        if ( this._currentHitPosition && !osg.vec3.exactEquals( this._currentHitPosition, this._lastHitPosition ) ) {
            this._atArrowEnd.setPosition( this._currentHitPosition );
            osg.vec3.sub( direction, this._currentHitPosition, this._lastHitPosition );
        } else {
            this._atArrowEnd.setPosition( this._positionsArray[ this._positionsArray.length - 1 ] );
            if ( this._positionsArray.length >= 2 )
                osg.vec3.sub( direction, this._positionsArray[ this._positionsArray.length - 1 ], this._positionsArray[ this._positionsArray.length - 2 ] );
            else
                direction = osg.vec3.create( 1.0, 0.0, 0.0 );
        }
        osg.vec3.normalize( direction, direction );
        osg.quat.rotationTo( quatRotationEnd, [ 0, 0, 1 ], direction );

        this._atArrowEnd.setRotation( quatRotationEnd );
    },

    /**
     * Method to draw guide lines
     * @method
     * @memberof pcvizTools.BufferTool
     */
    drawGuideLine: function () {
        var auxiliarPositions = this._positionsArray.slice( 0 );
        if ( this._linesNode.getNumChildren() === 0 ) {
            var geometry = this._sketchTool.drawScreenLines( auxiliarPositions, false, lineColor );
            this._linesNode.addChild( geometry.segments );

            if ( this._positionsArray.length >= 1 )
                this.drawArrowForGuideLine();
        } else if ( this._worldPositionsArray !== undefined ) {
            if ( this._currentHitPosition !== undefined )
                auxiliarPositions.push( this._currentHitPosition );

            this.drawArrowForGuideLine();

            this._sketchTool.setPositionsArray( auxiliarPositions );
            this._sketchTool.setNode( this._linesNode );
            this._sketchTool.updateScreenLines( false, lineColor );
        }
    },

    update: function () {
        if ( !this.isToolActive() )
            return;

        if ( this._currentMode === BufferTool.POINT ) {
            var useSelectedPoint = ( this._previousFeatureSelected && this._featureSelectedGeomType === FeatureDefinition.POINT );
            if ( useSelectedPoint ) {
                this.getPositionsFromSelectedFeature();
                var center = this._viewer.getCenter();

                // calculate absolute position (won't change until a new ref point is picked)
                var relPos = osg.vec3.create32();
                osg.vec3.copy( relPos, this._positionsArray[ 0 ] );
                this._position = [ relPos[ 0 ] + center[ 0 ], relPos[ 1 ] + center[ 1 ], relPos[ 2 ] + center[ 2 ] ];
                this._worldPositionsArray = [ this._position ];

                // set local positions
                if ( this._currentHitPosition === undefined )
                    this._currentHitPosition = osg.vec3.create32();
                osg.vec3.copy( this._currentHitPosition, relPos );
                osg.vec3.copy( this._lastHitPosition, relPos );
            }
            this.drawPointBuffer();
            if ( useSelectedPoint ) { // clear selected feature
                this._previousFeatureSelected = undefined;
            }
            return;
        }

        // line-based buffers
        var useSelectedLine = ( this._previousFeatureSelected && this._featureSelectedGeomType === FeatureDefinition.LINE );
        if ( useSelectedLine ) { // init position based on selected feature
            this.getPositionsFromSelectedFeature();
            this.initWorldPositions();
        }
        if ( this._positionsArray === undefined && this._currentMode !== BufferTool.BOX )
            return;

        this.drawBuffer( useSelectedLine );

        if ( this._positionsArray && ( this._currentMode !== BufferTool.BOX || !this._useRegionCube ) )
            this.drawGuideLine();

        if ( useSelectedLine ) { // clear selected feature
            this._worldPositionsArray = undefined; // line is finished
            this._previousFeatureSelected = undefined;
        }
    },

    drawBuffer: function ( feature ) {

        if ( this._positionsArray === undefined && this._currentMode !== BufferTool.BOX )
            return;

        switch ( this._currentMode ) {
        case BufferTool.POINT:
            this.drawPointBuffer();
            break;
        case BufferTool.BOX:
            this.drawBoxBuffer();
            break;
        case BufferTool.CROSS_SECTION:
            this.drawCrossSectionBuffer();
            break;
        case BufferTool.LINE:
        case BufferTool.VERTICAL_LINE:
            this.drawLongSectionBuffer( feature );
        }
    },

    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.PickTool
     */
    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() || self._useRegionCube )
                return;

            // if the current mouse position isn't equal than the mouse position when mousedown event ocurred,
            // it's a drag event, so we don't do anything
            var x = ev.clientX;
            var y = ev.clientY;

            if ( self.isDrag( x, y ) ) {
                self.mousePosX = 0.0;
                self.mousePosY = 0.0;
                return;
            }

            if ( ev.button === 0 ) {

                if ( self._currentHitPosition !== undefined && !osg.vec3.equals( self._lastHitPosition, self._currentHitPosition ) ) {
                    self._typeEvent = 'mouseup';
                    if ( self._worldPositionsArray === undefined ) {
                        self._worldPositionsArray = [];
                        self._positionsArray = [];
                        self._crossSectionPath = undefined;
                        self._crossSectionNode.removeChildren();
                        self._linesNode.removeChildren();
                    }
                    if ( self._currentMode === BufferTool.POINT ) {
                        self._worldPositionsArray = [];
                        self._positionsArray = [];
                    }
                    // add the current position to positionsArray
                    self.addPosition( self._currentHitPosition );
                    // We need to maintain a world position array
                    self._worldPositionsArray.push( self._position );
                    // updating last position to current position
                    osg.vec3.copy( self._lastHitPosition, self._currentHitPosition );

                    self.activateBufferShaders( true );

                    let validSection = self.getIsPathValid();

                    if ( self._sectionRefreshCallback && validSection ) {
                        self._sectionRefreshCallback( true, true );
                    }
                }
            }


            ev.stopPropagation();
        };

        this._pickFunction = function ( ev ) {

            if ( !self.isToolActive() || self._useRegionCube || !self._createBufferEnabled )
                return;
            if ( ev.detail.hit === undefined ) {
                self.drawPickingElement( undefined );
                self._currentHitPosition = undefined;
                return;
            }

            var lastPos = self._currentHitPosition;
            self._currentHitPosition = osg.vec3.sub( osg.vec3.create32(), ev.detail.coordinate, ev.detail.sceneCenter );

            if ( self._currentHitPosition === undefined )
                return;

            self._hit = ev.detail.hit;
            self._position = ev.detail.coordinate;

            // if hit is undefined the draw function will remove the element from the dom
            self.drawPickingElement( ev.detail.hit );

            ev.stopPropagation();

            // we make this only when the touch evetns are enabled
            if ( !( Utils.isTouchEnabled() ) )
                return;

            self._lastHitPosition = lastPos;
            if ( self._positionsArray === undefined )
                self._positionsArray = [];

            self._typeEvent = 'mouseup';
            if ( self._worldPositionsArray === undefined ) {
                self._worldPositionsArray = [];
                self._positionsArray = [];
                self._crossSectionPath = undefined;
                self._crossSectionNode.removeChildren();
                self._linesNode.removeChildren();
            }
            if ( self._currentMode === BufferTool.POINT ) {
                self._worldPositionsArray = [];
                self._positionsArray = [];
            }
            // add the current position to positionsArray
            self.addPosition( self._currentHitPosition );
            // We need to maintain a world position array
            self._worldPositionsArray.push( self._position );
            // updating last position to current position
            self._lastHitPosition = self._currentHitPosition;

        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() || self._useRegionCube || !self._createBufferEnabled )
                return;
            self._typeEvent = 'dblclick';
            if ( self._sectionRefreshCallback )
                self._sectionRefreshCallback( true, true );
            self.clearTool();
            ev.stopPropagation();
        };

        this._keydownFunction = function ( ev ) {
            if ( ev.key === EVENT_KEYS.ESCAPE || ev.key === EVENT_KEYS.ESC ) {
                self._typeEvent = 'escapeKey';
                if ( self._worldPositionsArray !== undefined && ( self._currentMode === BufferTool.LINE || self._currentMode === BufferTool.VERTICAL_LINE || self._currentMode === BufferTool.BOX ) ) {
                    for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
                        for ( var i = 0; i < self._data[ iType ].length; i++ ) {
                            self._data[ iType ][ i ].bufferAttribute.setLineBuffer( self._worldPositionsArray );
                        }
                }
                self.activateBufferShaders( true );

                let validSection = self.getIsPathValid();

                if ( self._sectionRefreshCallback )
                    self._sectionRefreshCallback( validSection, true );
                var auxiliarPositions = self._positionsArray.slice( 0 );
                if ( self._linesNode.getNumChildren() > 0 ) {
                    self._sketchTool.setPositionsArray( auxiliarPositions );
                    self._sketchTool.updateScreenLines( false, lineColor );

                    // update end cylinder
                    self._currentHitPosition = undefined;
                    self.drawEndCylinder();
                }
                self.clearTool();
            }

            ev.stopPropagation();
        };
    },

    setMinColor: function ( value ) {

        var rgb = Utils.hexToRgb( value );
        var color = osg.vec4.fromValues32( rgb.r / 255.0, rgb.g / 255.0, rgb.b / 255.0, 1.0 );
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ )
                this._data[ iType ][ i ].bufferAttribute.setMinColor( color );
    },

    setMaxColor: function ( value ) {
        var rgb = Utils.hexToRgb( value );
        var color = osg.vec4.fromValues32( rgb.r / 255.0, rgb.g / 255.0, rgb.b / 255.0, 1.0 );
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ )
                this._data[ iType ][ i ].bufferAttribute.setMaxColor( color );
    },

    setRange: function ( value ) {
        var expValue = this.calculateRange( value );
        this.setCalculateRange( expValue );
    },

    calculateRange: function ( value ) {
        return Math.pow( 1.1, ( value - 25.0 ) );
    },

    getRange: function () {
        var calculateRange = 0;
        if ( this._currentMode === BufferTool.CROSS_SECTION ) {
            calculateRange = ( Math.log( this._depth ) / Math.log( 1.1 ) ) + 25.0;
        } else {
            calculateRange = ( Math.log( this._width ) / Math.log( 1.1 ) ) + 25.0;
        }
        return calculateRange;
    },

    getCalculateRange: function () {
        var calculateRange = this._width;
        if ( this._currentMode === BufferTool.CROSS_SECTION ) { // value from cross_section
            calculateRange = this._depth;
        }
        return calculateRange;
    },

    setCalculateRange: function ( value ) {
        var setValue;
        if ( this._currentMode === BufferTool.CROSS_SECTION ) {
            this._depth = value;
            setValue = 0.5 * this._depth;
        } else {
            this._width = value;
            setValue = this._width;
        }
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setRange( setValue );
            }
    },

    setAngle: function ( angle ) {
        this._boxRotation = angle;

        if ( this._useRegionCube ) {
            var regionTool = this._viewer.findTool( 'region' );
            if ( regionTool )
                regionTool.setAngleRads( Math.PI * angle / 180.0 );
        }
    },

    getAngle: function () {
        return this._boxRotation;
    },

    calculateCrossSectionDepth: function ( value ) {
        return Math.pow( 1.2, ( value - 25.0 ) );
    },

    setCrossSectionDepth: function ( depth ) {
        this._width = this.calculateCrossSectionDepth( depth );
    },

    getCrossSectionDepth: function () {
        return ( Math.log( this._width ) / Math.log( 1.2 ) ) + 25.0;
    },

    getCalculateCrossSectionDepth: function () {
        return this._width;
    },

    setCalculateCrossSectionDepth: function ( depth ) {
        this._width = depth;
    },

    setCrossSectionPosition( position ) {
        this._crossSectionPosition = position;
    },

    getCrossSectionPosition() {
        return this._crossSectionPosition;
    },

    isValidValue( value, min, max ) {
        return value >= min && value <= max;
    },

    getCrossSectionDepthTransformed( value ) {
        return this._unitCtrl.convertToDistanceUnitWithoutLabel( this.calculateCrossSectionDepth( value ) );
    },

    getCrossSectionPositionTransformed( value ) {
        return this._unitCtrl.convertToDistanceUnitWithoutLabel( this.getCrossSectionPositionsLength() * ( value / 100 ) );
    },

    getRangeTransformed( value ) {
        return this._unitCtrl.convertToDistanceUnitWithoutLabel( this.calculateRange( value ) );
    },


    setCreateBufferEnabled( isSelected ) {
        this._createBufferEnabled = isSelected;
    },

    getCreateBufferEnabled() {
        return this._createBufferEnabled;
    },

    setOnlyBuffer: function ( value ) {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ )
                this._data[ iType ][ i ].bufferAttribute.setOnlyBuffer( value ? 1.0 : 0.0 );
    },

    setBaseColorBuffer: function ( value ) {
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ )
                this._data[ iType ][ i ].bufferAttribute.setUseBaseColor( value ? 1.0 : 0.0 );
    },

    clearTool: function ( preserveSelectedFeature ) {

        this._currentHitPosition = undefined;
        this._lastHitPosition = osg.vec3.create();
        this._worldPositionsArray = undefined;
        this._crossSectionNode.removeChildren();

        if ( !preserveSelectedFeature )
            this._previousFeatureSelected = undefined;
    },

    clearBuffer: function ( avoidClearRegion, resetMode ) {

        this._worldPositionsArray = undefined;
        this._positionsArray = undefined;
        this._segments = undefined;
        this._lastHitPosition = osg.vec3.create();
        this._crossSectionPath = undefined;
        this._linesNode.removeChildren();
        this._crossSectionNode.removeChildren();
        for ( var iType = 0; iType < BufferTool.ON_SUPPORTED_TYPES; iType++ )
            for ( var i = 0; i < this._data[ iType ].length; i++ ) {
                this._data[ iType ][ i ].bufferAttribute.setLineBuffer( [] );
                this._data[ iType ][ i ].bufferAttribute.setPointBuffer( [] );
            }
        var regionTool = this._viewer.findTool( 'region' );
        if ( regionTool && ( !avoidClearRegion || this._currentMode === BufferTool.BOX ) )
            regionTool.clearCube();
        if ( resetMode )
            this.setMode( BufferTool.POINT );
        this.activateBufferShaders( false );
    },

    drawCrossSectionBox: function ( corners, maxZ, minZ, hideWalls ) {
        this._crossSectionNode.removeChildren();

        if ( !corners )
            return;

        var box = this.createCrossSectionBox( corners, maxZ, minZ, hideWalls );
        var stateset = box.getOrCreateStateSet();
        stateset.setRenderingHint( 'TRANSPARENT_BIN' );
        stateset.setAttributeAndModes( new osg.BlendFunc( osg.BlendFunc.ONE, osg.BlendFunc.ONE_MINUS_SRC_ALPHA ) );
        stateset.setRenderBinDetails( Utils.RENDERBIN_CROSS_BOX, Utils.RENDERBIN_CROSS_BOX_TYPE );
        this._crossSectionNode.addChild( box );
    },

    drawBox: function () {
        var corners = this.getRotatedBoxCorners();

        this.drawCrossSectionBox( corners, corners ? corners.maxZ : 0, corners ? corners.minZ : 0, true );
        return corners;
    },

    getRotatedBoxCorners: function () {

        var sinRot = Math.sin( Math.PI * this._boxRotation / 180.0 );
        var cosRot = Math.cos( Math.PI * this._boxRotation / 180.0 );

        var corners = {};
        if ( this._useRegionCube ) {
            var regionTool = this._viewer.findTool( 'region' );
            var region = regionTool.getRegion();
            var xMin = region.xMin - region.rotCenter[ 0 ];
            var yMin = region.yMin - region.rotCenter[ 1 ];
            var zMin = region.zMin - region.rotCenter[ 2 ];
            var xMax = region.xMax - region.rotCenter[ 0 ];
            var yMax = region.yMax - region.rotCenter[ 1 ];
            var zMax = region.zMax - region.rotCenter[ 2 ];

            corners.lowLeft = [ xMin * cosRot - yMin * sinRot, xMin * sinRot + yMin * cosRot, 0 ];
            corners.highLeft = [ xMin * cosRot - yMax * sinRot, xMin * sinRot + yMax * cosRot, 0 ];
            corners.highRight = [ xMax * cosRot - yMax * sinRot, xMax * sinRot + yMax * cosRot, 0 ];
            corners.lowRight = [ xMax * cosRot - yMin * sinRot, xMax * sinRot + yMin * cosRot, 0 ];
            corners.minZ = zMin;
            corners.maxZ = zMax;

            return corners;
        }

        if ( !this._positionsArray )
            return undefined;

        var minPt = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
        var maxPt = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];
        var rotatedAxes = [
            [ cosRot, sinRot ],
            [ -sinRot, cosRot ]
        ];

        if ( this._worldPositionsArray && this._currentHitPosition !== undefined ) // track moving cursor
            this._positionsArray.push( this._currentHitPosition );

        for ( var iPt = 0; iPt < this._positionsArray.length; iPt++ ) {
            var x = this._positionsArray[ iPt ][ 0 ] * rotatedAxes[ 0 ][ 0 ] + this._positionsArray[ iPt ][ 1 ] * rotatedAxes[ 0 ][ 1 ];
            var y = this._positionsArray[ iPt ][ 0 ] * rotatedAxes[ 1 ][ 0 ] + this._positionsArray[ iPt ][ 1 ] * rotatedAxes[ 1 ][ 1 ];
            var z = this._positionsArray[ iPt ][ 2 ];
            minPt[ 0 ] = Math.min( minPt[ 0 ], x );
            minPt[ 1 ] = Math.min( minPt[ 1 ], y );
            minPt[ 2 ] = Math.min( minPt[ 2 ], z );
            maxPt[ 0 ] = Math.max( maxPt[ 0 ], x );
            maxPt[ 1 ] = Math.max( maxPt[ 1 ], y );
            maxPt[ 2 ] = Math.max( maxPt[ 2 ], z );
        }
        if ( this._worldPositionsArray && this._currentHitPosition !== undefined )
            this._positionsArray.pop();

        // extend box with range distance
        minPt[ 0 ] -= this._width;
        minPt[ 1 ] -= this._width;
        minPt[ 2 ] -= this._width;
        maxPt[ 0 ] += this._width;
        maxPt[ 1 ] += this._width;
        maxPt[ 2 ] += this._width;

        corners.lowLeft = [ minPt[ 0 ] * cosRot - minPt[ 1 ] * sinRot, minPt[ 0 ] * sinRot + minPt[ 1 ] * cosRot, 0 ];
        corners.highLeft = [ minPt[ 0 ] * cosRot - maxPt[ 1 ] * sinRot, minPt[ 0 ] * sinRot + maxPt[ 1 ] * cosRot, 0 ];
        corners.highRight = [ maxPt[ 0 ] * cosRot - maxPt[ 1 ] * sinRot, maxPt[ 0 ] * sinRot + maxPt[ 1 ] * cosRot, 0 ];
        corners.lowRight = [ maxPt[ 0 ] * cosRot - minPt[ 1 ] * sinRot, maxPt[ 0 ] * sinRot + minPt[ 1 ] * cosRot, 0 ];
        corners.minZ = minPt[ 2 ];
        corners.maxZ = maxPt[ 2 ];

        return corners;
    },

    createCrossSectionBox: function ( corners, maxZ, minZ, hideWalls ) {

        maxZ = ( maxZ > minZ ) ? maxZ : minZ + 1.0;

        var gl = new osg.Geometry();
        var gr = new osg.Geometry();
        var ll = corners.lowLeft;
        var hl = corners.highLeft;
        var hr = corners.highRight;
        var lr = corners.lowRight;

        var verticesLeft = new Float32Array( 24 );
        var verticesRight = new Float32Array( 24 );
        var normal = new Float32Array( 24 );
        var colors = new Float32Array( 32 );

        for ( var i = 0; i < 8; i++ ) {
            var indexn = i * 3;
            var indexc = i * 4;
            normal[ indexn ] = 0;
            normal[ indexn + 1 ] = 0;
            normal[ indexn + 2 ] = 1;
            colors[ indexc ] = 1;
            colors[ indexc + 1 ] = 1;
            colors[ indexc + 2 ] = 0;
            colors[ indexc + 3 ] = 0.2;
        }

        // Left Half cube
        this.fillVerticesHalfCube( verticesLeft, ll, lr, hl, minZ, maxZ );

        // Right Half cube
        this.fillVerticesHalfCube( verticesRight, hr, hl, lr, minZ, maxZ );

        this.setAttributesToGeom( gl, verticesLeft, normal, colors );

        this.setAttributesToGeom( gr, verticesRight, normal, colors );

        var primitivel = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, 0, verticesLeft.length / 3 );
        var primitiver = new osg.DrawArrays( osg.primitiveSet.LINE_STRIP, 0, verticesRight.length / 3 );
        gl.getPrimitives().push( primitivel );
        gr.getPrimitives().push( primitiver );
        var cube = new osg.Node();
        cube.addChild( gl );
        cube.addChild( gr );

        if ( !hideWalls ) {
            // Draws a polygon on the start side
            var startColorArray = new Float32Array( startColor.slice( 0 ).concat( startColor ).concat( startColor ).concat( startColor ) );

            var g = new osg.Geometry();

            var vertexes = new Float32Array( 12 );
            vertexes[ 0 ] = ll[ 0 ];
            vertexes[ 1 ] = ll[ 1 ];
            vertexes[ 2 ] = maxZ;

            vertexes[ 3 ] = ll[ 0 ];
            vertexes[ 4 ] = ll[ 1 ];
            vertexes[ 5 ] = minZ;

            vertexes[ 6 ] = hl[ 0 ];
            vertexes[ 7 ] = hl[ 1 ];
            vertexes[ 8 ] = minZ;

            vertexes[ 9 ] = hl[ 0 ];
            vertexes[ 10 ] = hl[ 1 ];
            vertexes[ 11 ] = maxZ;

            var indexes = new Uint16Array( 6 );
            indexes[ 0 ] = 0;
            indexes[ 1 ] = 1;
            indexes[ 2 ] = 2;
            indexes[ 3 ] = 0;
            indexes[ 4 ] = 2;
            indexes[ 5 ] = 3;

            var planeNormal = new Float32Array( 12 );
            planeNormal[ 0 ] = 0;
            planeNormal[ 1 ] = 0;
            planeNormal[ 2 ] = 1;

            planeNormal[ 3 ] = 0;
            planeNormal[ 4 ] = 0;
            planeNormal[ 5 ] = 1;

            planeNormal[ 6 ] = 0;
            planeNormal[ 7 ] = 0;
            planeNormal[ 8 ] = 1;

            planeNormal[ 9 ] = 0;
            planeNormal[ 10 ] = 0;
            planeNormal[ 11 ] = 1;

            this.setAttributesToGeom( g, vertexes, planeNormal, startColorArray );

            var primitive = new osg.DrawElements(
                osg.primitiveSet.TRIANGLES,
                new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes )
            );
            g.getPrimitives().push( primitive );

            cube.addChild( g );


            // Draws a polygon on the end side
            var endColorArray = new Float32Array( endColor.slice( 0 ).concat( endColor ).concat( endColor ).concat( endColor ) );

            var g2 = new osg.Geometry();

            var vertexes2 = new Float32Array( 12 );
            vertexes2[ 0 ] = lr[ 0 ];
            vertexes2[ 1 ] = lr[ 1 ];
            vertexes2[ 2 ] = maxZ;

            vertexes2[ 3 ] = lr[ 0 ];
            vertexes2[ 4 ] = lr[ 1 ];
            vertexes2[ 5 ] = minZ;

            vertexes2[ 6 ] = hr[ 0 ];
            vertexes2[ 7 ] = hr[ 1 ];
            vertexes2[ 8 ] = minZ;

            vertexes2[ 9 ] = hr[ 0 ];
            vertexes2[ 10 ] = hr[ 1 ];
            vertexes2[ 11 ] = maxZ;

            this.setAttributesToGeom( g2, vertexes2, planeNormal, endColorArray );

            var primitive2 = new osg.DrawElements(
                osg.primitiveSet.TRIANGLES,
                new osg.BufferArray( osg.BufferArray.ELEMENT_ARRAY_BUFFER, indexes )
            );
            g2.getPrimitives().push( primitive2 );

            cube.addChild( g2 );
        }

        cube.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );

        var fakeLight = new osg.Light( 0, true );
        cube.getOrCreateStateSet().setAttributeAndModes( fakeLight );

        return cube;
    },

    fillVerticesHalfCube( verticesArray, corner1, corner2, corner3, minZ, maxZ ) {
        verticesArray[ 0 ] = corner1[ 0 ];
        verticesArray[ 1 ] = corner1[ 1 ];
        verticesArray[ 2 ] = maxZ;

        verticesArray[ 3 ] = corner2[ 0 ];
        verticesArray[ 4 ] = corner2[ 1 ];
        verticesArray[ 5 ] = maxZ;

        verticesArray[ 6 ] = corner2[ 0 ];
        verticesArray[ 7 ] = corner2[ 1 ];
        verticesArray[ 8 ] = minZ;

        verticesArray[ 9 ] = corner1[ 0 ];
        verticesArray[ 10 ] = corner1[ 1 ];
        verticesArray[ 11 ] = minZ;

        verticesArray[ 12 ] = corner3[ 0 ];
        verticesArray[ 13 ] = corner3[ 1 ];
        verticesArray[ 14 ] = minZ;

        verticesArray[ 15 ] = corner3[ 0 ];
        verticesArray[ 16 ] = corner3[ 1 ];
        verticesArray[ 17 ] = maxZ;

        verticesArray[ 18 ] = corner1[ 0 ];
        verticesArray[ 19 ] = corner1[ 1 ];
        verticesArray[ 20 ] = maxZ;

        verticesArray[ 21 ] = corner1[ 0 ];
        verticesArray[ 22 ] = corner1[ 1 ];
        verticesArray[ 23 ] = minZ;
    },

    setDisabledModes( modes ) {
        this._disabledModes = modes;
    },

    getDisabledModes() {
        return this._disabledModes;
    },

    setAttributesToGeom( geometry, vertices, normals, colors ) {
        geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );
        geometry.getAttributes().Normal = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, normals, 3 );
        geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, colors, 4 );
    }

} );

module.exports = BufferTool;


/***/ }),

/***/ "./sources/pcvizTools/ClassificationTool.js":
/*!**************************************************!*\
  !*** ./sources/pcvizTools/ClassificationTool.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Julio Campos <julio.campos@mirage-tech.com>
 */


var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  Classification tool 
 *  @class
 *  @memberof pcvizTools
 *  @extends Tool
 */
var ClassificationTool = function ( viewer ) {
    Tool.call( this, viewer, 'classification' );

    this._data = undefined;
    this._activePointCloud = -1;
};

ClassificationTool.prototype = osg.objectInherit( Tool.prototype, {

    setActive: function ( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( this._data !== undefined ) {
            for ( var j = 0; j < this._data.length; j++ ) {
                if ( this._active ) {
                    // for ( var i = 0; i < this._data[ j ].LightingArray.length; i++ ) {
                    //     this._data[ j ].LightingArray[ i ] = this._data[ j ].LightOn ? 1 : 0;
                    // }
                    this._data[ j ].DrawingRuleArray = this._data[ j ].drawingRuleAttribute.getDrawingRuleArray();
                    this._data[ j ].DrawingRuleActive = 1.0;
                    // this._data[ j ].LightingArrayEnabled = 1.0;
                    this._data[ j ].OldDrawingRule = this._data[ j ].DrawingRule;
                    // this._data[ j ].DrawingRule = 'Classification';
                } else {
                    this._data[ j ].DrawingRuleActive = 0.0;
                    this._data[ j ].LightingArrayEnabled = 0.0;
                    this._data[ j ].DrawingRule = this._data[ j ].OldDrawingRule;
                }

                // this._data[ j ].lightingArrayEnabled.setInt( this._data[ j ].LightingArrayEnabled );

            }
        }

        if ( this.isToolActive() ) {
            this.updateData( this._data );
        }

    },

    setData: function ( data ) {
        this._data = data;
    },

    setActivePointCloud: function ( index ) {
        this._lastActivePointCloud = this._activePointCloud;
        this._activePointCloud = index;
        if ( this._active )
            this.updateData();
    },

    /**
     * Return an integer according to the drawing rule specified
     * @method
     * @memberof pcvizTools.ClassificationTool
     * @param  {string} drawingRule the name of the drawing rule
     * @return {int}    value associated with the drawing rule specified
     */
    getIntFromDrawingRuleString: function ( drawingRule ) {
        var i = 0.0;
        switch ( drawingRule ) {
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB':
            i = 0.0;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE':
            i = 1.0;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED':
            i = 2.0;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION':
            i = 3.0;
            break;
        case 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS':
            i = 4;
            break;
        }
        return i;
    },

    updateData: function () {
        var self = this;

        var minPointCloud, maxPointCloud, currentPointCloud;

        var min, max;
        if ( this._activePointCloud !== -1 ) {
            minPointCloud = currentPointCloud = this._activePointCloud;
            maxPointCloud = minPointCloud + 1;
            min = this._data[ currentPointCloud ].MinClassification;
            max = this._data[ currentPointCloud ].MaxClassification;
        } else {
            minPointCloud = 0;
            maxPointCloud = this._data.length;
            if ( self._lastActivePointCloud < 0 || self._lastActivePointCloud >= this._data.length )
                currentPointCloud = 0;
            else
                currentPointCloud = self._lastActivePointCloud;
            min = Number.MAX_VALUE;
            max = 0;
            for ( var ind = 0; ind < this._data.length; ind++ ) {
                min = Math.min( this._data[ ind ].MinClassification, min );
                max = Math.max( this._data[ ind ].MaxClassification, max );
            }
            // copy current data to all point clouds
        }


        // These functions are executed in angular scope, so they use 'self' to refer to the ClassificationTool object
        // and 'this' to refer to the angular scope.

        // var onChangeLight = function ( /*cb*/) {
        //     for ( var i = minPointCloud; i < maxPointCloud; i++ ) {
        //         self._data[ i ].LightingArray[ this.index ] = this.light ? 1 : 0;
        //         self._data[ i ].lightingArrayUniform.setInternalArray( self._data[ i ].LightingArray );
        //     }
        // };

        var onActivateLayer = function ( /*cb*/) {
            for ( var i = minPointCloud; i < maxPointCloud; i++ ) {
                self._data[ i ].ClassificationArray[ this.index ] = this.classification ? 1 : 0;
                self._data[ i ].drawingRuleAttribute.setClassificationArray( self._data[ i ].ClassificationArray );
            }
        };

        var onChangeDrawingRule = function () {
            for ( var i = minPointCloud; i < maxPointCloud; i++ ) {
                self._data[ i ].DrawingRuleArray[ this.index ] = self.getIntFromDrawingRuleString( this.drawingRule );
                self._data[ i ].drawingRuleAttribute.setDrawingRuleArray( self._data[ i ].DrawingRuleArray );
                self._data[ i ].drawingRuleAttribute.setDrawingRule( 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CATEGORIZED' );
            }
        };

        var setClassificationColor = function () {
            let rgbcolor = Utils.fullhexToRgb( this.classificationColor, 1.0, true );

            for ( var i = minPointCloud; i < maxPointCloud; i++ ) {
                var auxClassificationArray = self._data[ i ].drawingRuleAttribute.getClassificationColorArray();
                var index = this.index * 4;
                auxClassificationArray[ index ] = rgbcolor[ 0 ];
                auxClassificationArray[ index + 1 ] = rgbcolor[ 1 ];
                auxClassificationArray[ index + 2 ] = rgbcolor[ 2 ];
                auxClassificationArray[ index + 3 ] = rgbcolor[ 3 ];
                self._data[ i ].drawingRuleAttribute.setClassificationColorArray( auxClassificationArray );
            }
        };

        var toolDataArray = [];
        var drawingOptions = [ 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION',
            'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR'
        ];

        for ( var i = min; i <= max; i++ ) {
            var classificationColorArray = self._data[ currentPointCloud ].drawingRuleAttribute.getClassificationColorArray();
            var cAux = Utils.RgbTofullhex( [ classificationColorArray[ i * 4 ], classificationColorArray[ i * 4 + 1 ], classificationColorArray[ i * 4 + 2 ], classificationColorArray[ i * 4 + 3 ] ] );
            var toolData = {
                index: i,
                classification: ( self._data[ currentPointCloud ].ClassificationArray[ i ] === 1.0 ) ? true : false,
                drawingRule: drawingOptions[ self._data[ currentPointCloud ].DrawingRuleArray[ i ] ],
                // light: ( self._data[ currentPointCloud ].LightingArray[ i ] === 1.0 ) ? true : false,
                labelText: Utils.lookUpClassification( i ),
                //labelColor: Utils.lookUpColorClassification( i ),
                classificationColor: cAux,
                onActivateLayer: onActivateLayer,
                // onChangeLight: onChangeLight,
                onChangeDrawingRule: onChangeDrawingRule,
                onChangeClassificationColor: setClassificationColor
            };

            toolDataArray.push( toolData );
        }

        var pointClouds = [];
        for ( var j = 0; j < self._data.length; j++ )
            pointClouds.push( self._data[ j ].Name );

        this.dispatchData( {
            controls: toolDataArray,
            pointClouds: pointClouds
        } );
    }

    // clearTool: function () {

    // }

} );

module.exports = ClassificationTool;


/***/ }),

/***/ "./sources/pcvizTools/ControlPointTool.js":
/*!************************************************!*\
  !*** ./sources/pcvizTools/ControlPointTool.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgDB = OSG.osgDB;

/**
 *  ControlPoint tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */
var ControlPointTool = function ( sceneView ) {
    PickTool.call( this, sceneView.getViewer(), 'controlPoint' );
    this._active = false;

    this._view = sceneView;

    this._viewer.addTool( this ); // since it is not in the toolbar, we need to add it to get update calls

    // group to draw the geometry and texts
    this._controlNode = new osg.Node();
    this._controlNode.setName( 'ctrlPtsTool' );
    this._markersNode = new osg.Node();
    this._linesNode = new osg.Node();
    this._controlNode.addChild( this._markersNode );
    this._controlNode.addChild( this._linesNode );

    this._devicePixelRatio = 1;
    this._pickingExpandFactor = 10; // expansion factor of picking area around marker (to avoid losing it while dragging)

    this._viewer.getToolsNode().addChild( this._controlNode );

    this._sketchTool = new SketchTool( this._viewer );

    //Properties about features of vector layers
    this._featureSelected = undefined; // save the feature intersected to not execute query each frame

    this._selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );
    var self = this;
    this._selectionObjectController.registerListener( ListenerController.PROJECT, function ( selectionObject ) {

        if ( selectionObject.getFeature !== undefined && selectionObject.getFeature() !== undefined ) {
            self._featureSelected = selectionObject.getFeature();
        }
    } );

};

ControlPointTool.ORIGINAL_MARKER = 0;
ControlPointTool.PREVIOUS_MARKER = 1;
ControlPointTool.MOVING_MARKER = 2;

ControlPointTool.MARKER_NODE_NAME = 'ctrlPtsTool_movingMarker';

ControlPointTool.prototype = osg.objectInherit( PickTool.prototype, {

    setProject: function ( project ) {
        this._project = project;
    },

    setActive: function ( active ) {
        if ( this._active === active ) {
            return;
        }
        this._active = active;

        if ( !active ) {
            this._markersNode.removeChildren();
            this._linesNode.removeChildren();
            this.clearTool();
            this.removeEventListeners();
            this.enableOtherTools( true );
            if ( !this.wasPickingEnabled )
                this._viewer.setPickingEnabled( false );
            // restore interaction
            this._state = 'idle';
            this._viewer.enableManipulator( true );
        } else {
            this.drawMarkers();
            this.setUpEventListeners();
            this.enableOtherTools( false );
            // restrict picking to interactive marker
            this.wasPickingEnabled = this._viewer.isPickingEnabled();
            if ( !this.wasPickingEnabled )
                this._viewer.setPickingEnabled( true );
        }
    },

    setDevicePixelRatio: function ( ratio ) {
        this._devicePixelRatio = ratio;
    },

    initMarkersTextures: function () {
        this._markersIconsStateSets = [ new osg.StateSet(), new osg.StateSet(), new osg.StateSet() ];
        var imageUrls = [ '/assets/baseline-center_focus_weak-24pxOriginal.svg', '/assets/baseline-center_focus_weak-24pxPrevious.svg', '/assets/baseline-center_focus_weak-24px.svg' ];
        for ( var i = 0; i < 3; i++ )
            this.setImageTexture( imageUrls[ i ], this._markersIconsStateSets[ i ] );
    },

    setImageTexture: function ( imageUrl, stateSet ) {
        osgDB.readImageURL( imageUrl ).then( function ( image ) {
            var texture = new osg.Texture();
            texture.setImage( image );
            texture.setWrapT( osg.Texture.CLAMP_TO_EDGE );
            texture.setWrapS( osg.Texture.CLAMP_TO_EDGE );
            texture.setMinFilter( 'LINEAR_MIPMAP_LINEAR' );
            texture.setMagFilter( 'LINEAR' );
            stateSet.setTextureAttributeAndModes( 0, texture, osg.StateAttribute.ON );
            stateSet.addUniform( osg.Uniform.createInt1( 0, 'Texture0' ) );
            stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );
            stateSet.setAttributeAndModes( new osg.Depth( osg.Depth.ALWAYS ), osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );
            stateSet.setRenderBinDetails( Utils.RENDERBIN_MARKERSYMBOL3D, Utils.RENDERBIN_MARKERSYMBOL3D_TYPE );
            var mat = new osg.Material(); // set white material to avoid dark markers in some orientations
            mat.setEmission( osg.vec4.fromValues32( 1, 1, 1, 1 ) );
            stateSet.setAttributeAndModes( mat, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );
        } );
    },

    drawMarkers: function () {

        this._markersNode.removeChildren();
        this._markers = [];

        if ( this._markersIconsStateSets === undefined )
            this.initMarkersTextures();

        for ( var i = ControlPointTool.ORIGINAL_MARKER; i <= ControlPointTool.MOVING_MARKER; i++ ) {

            var size;
            switch ( i ) {
            case ControlPointTool.ORIGINAL_MARKER:
                size = 18;
                break;
            case ControlPointTool.PREVIOUS_MARKER:
                size = 28;
                break;
            case ControlPointTool.MOVING_MARKER:
                size = 36;
                break;
            }
            size *= this._pickingExpandFactor * this._devicePixelRatio;

            var node = new osg.Node();
            if ( i === ControlPointTool.MOVING_MARKER )
                node.setName( ControlPointTool.MARKER_NODE_NAME );
            else
                node.setNodeMask( ~Utils.TRAVERSAL_MASK_IV ); // only interactive marker can be picked/moved

            var textureStart = -this._pickingExpandFactor / 2.0 + 0.5; // expand marker quad to better suppor picking
            var textureEnd = this._pickingExpandFactor / 2.0 + 0.5;
            var quad = osg.createTexturedQuadGeometry( -size / 2.0, -size / 2.0, 0, size, 0, 0, 0, size, 0, textureStart, textureStart, textureEnd, textureEnd );
            var at = new osg.AutoTransform();
            at.addChild( quad );
            at.setAutoRotateToScreen( true );
            at.setAutoScaleToScreen( true );
            at.setStateSet( this._markersIconsStateSets[ i ] );

            this._markers.push( at );
            node.addChild( at );

            this._markersNode.addChild( node );
        }
    },

    setMarkerMovementCB: function ( markerMovementCB ) {

        this._markerMovementCB = markerMovementCB;
    },

    setMarkerPosition: function ( type, pos ) {

        if ( !this._featureSelected || !this._markers )
            return;

        if ( !pos ) { // hide marker
            this._markers[ type ].setPosition( osg.vec4.fromValues32( 1, 1, 1, 0 ) );
            return;
        }

        var center = this._featureSelected.getLayer().getCenter();
        var relPos = osg.vec3.sub( osg.vec3.create64(), pos, center );

        this._markers[ type ].setPosition( relPos );
    },

    moveMarker: function ( worldPos ) {

        this.setMarkerPosition( ControlPointTool.MOVING_MARKER, worldPos );

        if ( this._markerMovementCB )
            this._markerMovementCB( worldPos );
    },

    setLines: function ( lineArray ) {

        this._linesNode.removeChildren();
        if ( !lineArray || lineArray.length === 0 )
            return;

        var center = this._featureSelected.getLayer().getCenter();
        var color = osg.vec4.fromValues32( 1, 0.6, 0, 0.5 );

        var self = this;

        lineArray.forEach( function ( line ) {
            var p1 = osg.vec3.sub( osg.vec3.create32(), line.linePt1, center );
            var p2 = osg.vec3.sub( osg.vec3.create32(), line.linePt2, center );

            var lineArray = [ p1, p2 ];
            var geometry = self._sketchTool.drawScreenLines( lineArray, false, color, 5, true );
            self._linesNode.addChild( geometry.segments );
        } );
    },

    /**
     * Method to set the manipulator's position for the selected image
     * @method
     * @memberof  pcvizTools.ControlPointTool
     */
    setImageManipulatorPosition: function ( worldPos ) {

        if ( !this._featureSelected )
            return;

        if ( !worldPos ) {
            var point = this._featureSelected.getGeometry();
            worldPos = [ point.getX(), point.getY(), point.getZ() ];
        }

        var center = this._featureSelected.getLayer().getCenter();
        var position = [ worldPos[ 0 ] - center[ 0 ], worldPos[ 1 ] - center[ 1 ], worldPos[ 2 ] - center[ 2 ] ];

        this._featureSelected.getLayer().getFeatureRenderer().getSymbol().setImageMode( true );
        var lookAt = this._featureSelected.getLayer().getFeatureRenderer().getSymbol().getLookAt();
        var config = {
            position: position,
            forward: lookAt.forward,
            up: lookAt.up,
            fovy: lookAt.fovy
        };
        return config;
    },

    update: function ( /*viewer*/) {
        if ( !this.isToolActive() )
            return;

    },

    setCursor: function ( type ) {

        if ( type !== this._currentCursor ) {
            this._viewer.getCanvas().parentElement.style.cursor = type;
            this._currentCursor = type;
        }
    },

    setUpEventListeners: function () {
        PickTool.prototype.setUpEventListeners.call( this );

        let canvas = this._viewer.getCanvas();

        canvas.addEventListener( 'mousemove', this._mousemoveFunction );
    },

    removeEventListeners: function () {
        PickTool.prototype.removeEventListeners.call( this );

        let canvas = this._viewer.getCanvas();

        canvas.removeEventListener( 'mousemove', this._mousemoveFunction );
    },

    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.ControlPointTool
     */
    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;
        self._state = 'idle';
        self._currentCursor = 'default';

        this._mouseupFunction = function ( ev ) {

            if ( !self.isToolActive() )
                return;

            if ( self._state !== 'dragging' )
                return;

            // restore image manipulation
            var manipulator = self._viewer.getOrCreatePlanarImageManipulator();
            manipulator.getZoomInterpolator().reset();
            manipulator.getPanInterpolator().reset();

            self._viewer.enableManipulator( true );
            self._state = 'idle';
            self._hit = undefined;

            ev.stopPropagation();

        };

        this._wheelFunction = function () {

        };

        this._keydownFunction = function ( ev ) {
            ev.stopPropagation();
        };

        this._mousemoveFunction = function () {
            if ( !self.isToolActive() )
                return;

            self._pickedImage = undefined;
        };

        this._dblclickFunction = function ( ev ) {
            if ( self._lastImagePosition )
                self.moveMarker( self._lastImagePosition );

            ev.stopPropagation();
        };

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( !self._hit ) // no marker to drag
                return;

            self._state = 'dragging';
            // disable image manipulation
            self._viewer.enableManipulator( false );

            ev.stopPropagation();
        };

        this._saveImagePos = function ( coord ) {
            self._lastImagePosition = new Float64Array( 3 );
            self._lastImagePosition[ 0 ] = coord[ 0 ];
            self._lastImagePosition[ 1 ] = coord[ 1 ];
            self._lastImagePosition[ 2 ] = coord[ 2 ];
        };

        this._pickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            self._lastImagePosition = undefined;

            if ( ev.detail.hit === undefined ) {
                self.setCursor( 'default' );
                self._hit = undefined;
                return;
            }

            // check marker in node path
            var foundNode;
            for ( var iNode = ev.detail.hit._nodePath.length - 1; iNode > 0; iNode-- ) {
                var nodeName = ev.detail.hit._nodePath[ iNode ].getName();
                if ( nodeName === ControlPointTool.MARKER_NODE_NAME || nodeName === 'PlanarImageGroupNode' || nodeName === 'PlanarImageSymbol3D' ) {
                    foundNode = ev.detail.hit._nodePath[ iNode ];
                    break;
                }
            }
            if ( !foundNode )
                return;

            if ( self._state === 'dragging' ) {
                self.setCursor( 'move' );
                self.moveMarker( ev.detail.coordinate );
                return;
            }

            if ( foundNode._name === 'PlanarImageSymbol3D' ) {
                self._pickedImage = ev.detail.hit;
                return;
            }
            self._pickedImage = undefined;

            // only grab the marker if cursor is close enough
            var hitCoords = osg.vec3.fromValues64( ev.detail.coordinate[ 0 ], ev.detail.coordinate[ 1 ], ev.detail.coordinate[ 2 ] );
            var bounds = self._markers[ ControlPointTool.MOVING_MARKER ].getBound();
            var centerCoords = osg.vec3.add( osg.vec3.create64(),
                bounds.center(),
                ev.detail.sceneCenter );
            var distance = osg.vec3.distance( hitCoords, centerCoords ) / bounds.radius();

            if ( distance > 1 / self._pickingExpandFactor ) { // too far to grab marker
                self.setCursor( 'default' );
                self._hit = undefined;
                self._saveImagePos( ev.detail.coordinate ); // for double click later
                return;
            }

            self.setCursor( 'grab' );

            self._hit = ev.detail.hit;
        };

    }

} );

module.exports = ControlPointTool;


/***/ }),

/***/ "./sources/pcvizTools/CursorTool.js":
/*!******************************************!*\
  !*** ./sources/pcvizTools/CursorTool.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return CursorTool; });
/* harmony import */ var pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/GizmoTool */ "./sources/pcvizTools/GizmoTool.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGISRenderer/MarkerSymbol3D */ "./sources/pcvizGISRenderer/MarkerSymbol3D.js");
/* harmony import */ var pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_3__);





const osg = OSG__WEBPACK_IMPORTED_MODULE_3___default.a.osg;

/**
 * A class that renders a marker to be used as a 3D cursor
 * @class
 * @memberof pcvizTools
 * @extends GizmoTool
 */
class CursorTool extends pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_0__["default"] {

    /**
     * Constructor of the CursorTool
     * @method
     * @memberof pcvizTools.CursorTool
     * @param {SceneView} sceneView The SceneView the tool is attached to.
     */
    constructor( sceneView ) {
        super( sceneView, 'cursor' );

        this._cursorNode = new osg.MatrixTransform();
        this._cursorNode.setName( 'cursor' );
        // Make this node no-intersectable to avoid bug when finding layer in the hit in InformationTool
        this._cursorNode.setNodeMask( ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_2___default.a.TRAVERSAL_MASK_IV );

        sceneView.getViewer().getToolsNode().addChild( this._cursorNode );

        this.enableRegisterInObjectController( false );

        this._layerGizmo.setPickEnabled( false );
    }

    /**
     * Initializes the scene graph
     * @method
     * @memberof pcvizTools.CursorTool
     */
    initGraph() {
        this._layerGizmoNode = new osg.MatrixTransform();
        this._layerGizmoNode.setName( 'cursorBindNode' );
        this._cursorNode.addChild( this._layerGizmoNode );
    }

    /**
     * Activates or deactivates the tool
     * @method
     * @memberof pcvizTools.CursorTool
     * @param {boolean} active To activate or deactivate the tool
     */
    setActive( active ) {
        if ( this._active === active )
            return;

        this._active = active;

        if ( !active ) {
            this._layerGizmoNode.removeChildren();
            this._layerGizmo.disconnectFromLayerNode();
        } else {
            this.initGraph();
            this._layerGizmo.connectToLayerNode( undefined, this._layerGizmoNode );
            this.drawMarker();
        }
        this._layerGizmo.setToolIsActive( active );
    }

    /**
     * Draws the marker in the 3D view
     * @method
     * @memberof pcvizTools.CursorTool
     */
    drawMarker() {
        this._layerGizmoNode.removeChildren();
        let markerSymbol = new pcvizGISRenderer_MarkerSymbol3D__WEBPACK_IMPORTED_MODULE_1__["MarkerSymbol3D"]();
        let style = {
            PointSymbolizer: {
                marker: '/assets/stationFloorMarker.png',
                billboard: false,
                autoScale: false,
                size: 2,
                color: [ 0.65, 0.3, 0.0, 1.0 ]
            }
        };
        markerSymbol.configure( style );
        let markerNode = markerSymbol.renderMarker( osg.vec4.create(), undefined, undefined, osg.vec3.create() );
        markerSymbol.configureColorUniform( markerNode.getOrCreateStateSet() );
        this._layerGizmoNode.addChild( markerNode );
    }

    /**
     * Returns the transformation matrix of cursor position
     * @method
     * @memberof pcvizTools.CursorTool
     * @returns {osg.mat4} The transformation matrix
     */
    getCursorMatrix() {
        return this._cursorNode.children[ 0 ].getMatrix();
    }

    /**
     * Set a new transformation matrix
     * @method
     * @memberof pcvizTools.CursorTool
     * @param {osg.mat4} matrix The new transformation matrix
     */
    setCursorMatrix( matrix ) {
        osg.mat4.copy( this._cursorNode.children[ 0 ].getMatrix(), matrix );
        this._layerGizmo.setCurrentTransform();
    }
}


/***/ }),

/***/ "./sources/pcvizTools/DistanceTool.js":
/*!********************************************!*\
  !*** ./sources/pcvizTools/DistanceTool.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const PointCloudViz = __webpack_require__( /*! PointCloudViz */ "./sources/PointCloudViz.js" );
const CustomText = __webpack_require__( /*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js" );
const PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
const SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );
const WorkspaceCategories = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" ).default;
const FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;

const { osg, osgText, osgUtil } = OSG;
const { MatrixTransform, BlendFunc, Uniform } = osg;
const GizmoGeometry = osgUtil.GizmoGeometry;
const { Utils, Registry, ListenerController, UnitController } = PointCloudViz.DB;

/**
 *  Distance tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */

const DistanceTool = function ( viewer ) {

    PickTool.call( this, viewer, 'distance' );

    // Initialize local variables
    this._globalDistance = 0.0;
    this._globalHorizontalDistance = 0.0;
    this._globalVerticalDistance = 0.0;

    // To let priority of visualization
    this._renderBinForDistances = Utils.RENDERBIN_CUSTOMTEXT_DISTANCE;
    this._renderBinForAngles = Utils.RENDERBIN_CUSTOMTEXT_ANGLE;
    this._renderBinWhileMeasuring = Utils.RENDERBIN_CUSTOMTEXT_WHILE_MEASURING;

    // group to draw the geometry and texts
    this._distanceNode = new osg.Node();
    this._distanceNode.setName( 'distanceTool' );

    this._linesNode = new osg.Node();

    this._textsNode = new osg.Node();
    this._textsNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );

    this._tempTextsNode = undefined;

    this._tempTextPos = new osg.vec3.create32();

    viewer.getToolsNode().addChild( this._distanceNode );

    this._sketchTool = new SketchTool( viewer );

    this._positions = undefined;

    this._showHorizAndVerti = false;
    this._horizLabel = 'H: ';
    this._vertiLabel = 'V: ';
    this._distLabel = 'D: ';

    let self = this;
    Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.NUMBER_OF_DECIMALS_KEY, function () {
        self.repaintTextNode();
    } );

    this._unitsController = Registry.getInstance().getController( 'Units' );
    this._unitsController.registerListener( ListenerController.APPLICATION, UnitController.DISTANCE_TYPE, function () {
        self.repaintTextNode();
    } );

    this._textSize = ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) ? 7 : 5;

    this._showAngles = false; // the angles are hidden by default
    this._anglesNode = new osg.Node();
    this._angleTextsNode = new osg.Node();
    this._anglesUnit = DistanceTool.ANGLE_UNIT_DEGREES;

};

DistanceTool.ANGLE_UNIT_RADIANS = true;
DistanceTool.ANGLE_UNIT_DEGREES = false;

const TO_DEGREES = 180 / Math.PI;
// colors for lines, rgb 0 - 1
const blueColor = osg.vec4.fromValues32( 0.247, 0.318, 0.71, 0.5 );
const verticalColor = osg.vec4.fromValues32( 1.0, 0.0, 0.0, 0.5 );
const horizontalColor = osg.vec4.fromValues32( 0.0, 1.0, 0.0, 0.5 );
// colors for texts, rgb 0 - 255
const finishedColor = osg.vec4.fromValues32( 51, 51, 61, 0.8 );
const whileMeasuringColor = osg.vec4.fromValues32( 63, 81, 181, 0.8 );

const blendAttribute = new BlendFunc( BlendFunc.SRC_ALPHA, BlendFunc.ONE_MINUS_SRC_ALPHA );

DistanceTool.prototype = osg.objectInherit( PickTool.prototype, {

    setActive: function ( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( !active ) {
            this._distanceNode.removeChildren();
            this.dispatchData( '0.0' );

            this._viewer.getCanvas().parentElement.style.cursor = 'default';
            if ( this._pickingElement !== undefined )
                this._pickingElement.style.display = 'none';

            this.removeEventListeners();
            this.clearTool();
            this._textsNode.removeChildren();
            this._linesNode.removeChildren();
            this._anglesNode.removeChildren();
            this._angleTextsNode.removeChildren();
            this._positions = undefined; // if we want to mantain the distance until the tool is reactivated, remove this line.

            // Disable picking only if it is necessary
            this.setPickingEnabled( false );

            // we don't need to enable the intersections because they haven't been disabled
            /*  if ( this._viewer.getVectorLayerScene() )
                  this._viewer.getVectorLayerScene().setEnableIntersections( true );*/

            this._globalHorizontalDistance = 0.0;
            this._globalVerticalDistance = 0.0;

            // enable stations floor marker intersections
            this.enableStationsIntersections( true );
        } else {

            this.initSelectedFeatureUse();
            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );


            this.setUpEventListeners();
            this._distanceNode.addChild( this._linesNode );
            this._distanceNode.addChild( this._textsNode );
            this._distanceNode.addChild( this._anglesNode );
            this._distanceNode.addChild( this._angleTextsNode );

            this._viewer.disableManipulatorDoubleClick();

            // enable picking
            this.setPickingEnabled( true );

            // ALLOW intersections for navigation and measurement on features
            //if ( this._viewer.getVectorLayerScene() )
            //    this._viewer.getVectorLayerScene().setEnableIntersections( false );

            // disable stations floor marker intersections
            this.enableStationsIntersections( false );
        }

    },

    enableStationsIntersections: function ( value ) {
        let stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let stationsCache = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );
        stationsCache.forEach( ( stationDataCacheObj ) => {
            if ( stationDataCacheObj.getLayerGroupObj() &&
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer() &&
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer().getSymbol() ) {
                stationDataCacheObj.getLayerGroupObj().getFeatureRenderer().getSymbol().enableFloorMarkerIntersections( value );
            }
        } );
    },

    clearTool: function ( forceNodeClean ) {
        PickTool.prototype.clearTool.call( this );
        let d = this._globalDistance;
        this._globalDistance = 0.0;
        this._distanceNode.removeChild( this._tempTextsNode );
        this._tempTextsNode = undefined;

        if ( forceNodeClean ) {
            // delete the 'temporal lines'. create feature call us using 'forceNodeClean' 
            this._linesNode.removeChildren();
        }

        this.dispatchData( d );
    },

    /**
     * @method
     * action when a double click or tab was detected     
     * @memberof pcvizTools.DistanceTool
     */
    doActionDblClickOrTap: function () {
        if ( this._positionsArray !== undefined ) {
            // Check if last point is duplicated
            let l = this._positionsArray.length - 1;
            if ( this._positionsArray[ l ] === this._positionsArray[ l - 1 ] )
                this._positionsArray.pop();

            // copy the positions array to use it when the units is changed
            this._positions = this._positionsArray.slice();
        }

        this.doEscAction(); //we'll do clear + repaint lines + repaint text    
    },

    /**
     * @method
     * Draw the label between the current mouse position and the last position
     * @memberof pcvizTools.DistanceTool
     */
    drawTmpLabel: function () {
        // Temporal Text
        if ( osg.vec3.distance( this._lastHitPosition, this._currentHitPosition ) <= 0.0001 )
            return;
        if ( this._tempTextsNode === undefined ) {
            this._tempTextsNode = this.drawDistanceText( osg.vec3.create32(), osg.vec3.create32() );
            this._tempTextsNode.setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
            this._distanceNode.addChild( this._tempTextsNode );
            this._tempTextsNode.setRenderBinValue( this._renderBinWhileMeasuring );
        }

        let textString = ( osg.vec3.distance( this._lastHitPosition, this._currentHitPosition ) );
        let hTextString = this.horizontalDistance( this._currentHitPosition, this._lastHitPosition );
        // For the vertical difference we use signed numbers.
        let vTextString = this.verticalDistance( this._lastHitPosition, this._currentHitPosition );

        textString = this._unitsController.convertToUserUnit( textString, 'distance' );
        if ( this._showHorizAndVerti ) {
            hTextString = this._unitsController.convertToUserUnit( hTextString, 'distance' );
            vTextString = this._unitsController.convertToUserUnit( vTextString, 'distance' );
        }

        let text = this._distLabel + textString;
        if ( this._showHorizAndVerti )
            text += '\n' + this._horizLabel + hTextString + '\n' + this._vertiLabel + vTextString;

        if ( this._tempTextsNode.getText() !== text )
            this._tempTextsNode.setText( text );

        osg.vec3.lerp( this._tempTextPos, this._lastHitPosition, this._currentHitPosition, 0.5 );
        this._tempTextsNode.setPosition( this._tempTextPos );
    },
    /**
     * @method
     * draw the label for the previous segment to the last one
     * @memberof pcvizTools.DistanceTool
     */
    drawLabels: function () {
        // Text
        if ( this._positionsArray !== undefined && this._positionsArray.length - 1 > this._textsNode.getChildren().length && this._positionsArray.length > 1 ) {
            const text = this.drawDistanceText( this._positionsArray[ this._positionsArray.length - 2 ], this._positionsArray[ this._positionsArray.length - 1 ] );
            this._textsNode.addChild( text );
        }
    },

    /**
     * @method
     * make all actions when the escape key is pressed
     * @memberof pcvizTools.DistanceTool
     */
    doEscAction: function () {
        this.drawLines( true );
        this.clearTool();
        this.repaintTextNode();
    },

    /**
     * @method
     * draw or update the lines
     * @memberof pcvizTools.DistanceTool
     */
    drawLines: function ( escAction ) {
        let geometry;
        let self = this;
        if ( this._positionsArray !== undefined ) {
            let auxiliarPositions;
            if ( escAction )
                auxiliarPositions = this._positionsArray;
            else {
                auxiliarPositions = this._positionsArray.slice( 0 );
                auxiliarPositions.push( this._currentHitPosition );
            }
            const nChildrenRequired = 1 + this._showHorizAndVerti ? 2 * ( auxiliarPositions.length - 1 ) : 0;
            const nChildrenExist = this._linesNode.getNumChildren();
            const refresh = ( nChildrenExist !== nChildrenRequired );
            let child = 0;

            // create/update measurement line
            if ( refresh ) {
                this._linesNode.removeChildren();
                geometry = this._sketchTool.drawScreenLines( auxiliarPositions, false, blueColor );
                this._linesNode.addChild( geometry.segments );
            } else {
                if ( escAction )
                    this._sketchTool.setNode( this._linesNode );
                this.updateLines( child++, auxiliarPositions, blueColor );
            }

            if ( this._showHorizAndVerti ) {
                // create/update vertical and horizontal lines
                const verticalLines = this.getComponentLines( auxiliarPositions, true );
                verticalLines.forEach( function ( verticalLinePositions ) {
                    if ( refresh ) {
                        geometry = self._sketchTool.drawScreenLines( verticalLinePositions, false, verticalColor );
                        self._linesNode.addChild( geometry.segments );
                    } else
                        self.updateLines( child++, verticalLinePositions, verticalColor );
                } );
                const horizontalLines = this.getComponentLines( auxiliarPositions, false );
                horizontalLines.forEach( function ( horizontalLinePositions ) {
                    if ( refresh ) {
                        geometry = self._sketchTool.drawScreenLines( horizontalLinePositions, false, horizontalColor );
                        self._linesNode.addChild( geometry.segments );
                    } else
                        self.updateLines( child++, horizontalLinePositions, horizontalColor );
                } );

            }
            if ( refresh && !escAction )
                this._sketchTool.setNode( this._linesNode );

            this.updateDistanceMeasure();
        }
    },

    repaintLinesNode: function () {
        this._linesNode.removeChildren();

        if ( !this._positions ) {
            return;
        }

        let auxiliarPositions = this._positions.slice( 0 );

        let geometry = this._sketchTool.drawScreenLines( auxiliarPositions, false, blueColor );
        this._linesNode.addChild( geometry.segments );

        let self = this;

        if ( this._showHorizAndVerti ) {
            // create/update vertical and horizontal lines
            const verticalLines = this.getComponentLines( auxiliarPositions, true );
            verticalLines.forEach( function ( verticalLinePositions ) {
                geometry = self._sketchTool.drawScreenLines( verticalLinePositions, false, verticalColor );
                self._linesNode.addChild( geometry.segments );
            } );
            const horizontalLines = this.getComponentLines( auxiliarPositions, false );
            horizontalLines.forEach( function ( horizontalLinePositions ) {
                geometry = self._sketchTool.drawScreenLines( horizontalLinePositions, false, horizontalColor );
                self._linesNode.addChild( geometry.segments );
            } );
        }

        this._sketchTool.setNode( this._linesNode );
    },

    updateLines: function ( child, positions, color ) {
        const childNode = this._linesNode.getChild( child );
        if ( !childNode ) // This happens if the Esc key is pressed just after one single click (the measurement only has one point)
            return;
        const childAttribs = childNode.getVertexAttributeList();

        let zMax;
        this._sketchTool.updateScreenBufferArrays( positions, childAttribs.Vertex, childAttribs.Color, childAttribs.NextVertex, childAttribs.PreviousVertex, childAttribs.Directions, zMax, color, false );

        childNode.getPrimitiveSetList()[ 0 ].count = childAttribs.Vertex.getElements().length / 3;

        // call dirty method first for the geometry and secondly for the BufferArray
        childNode.dirty();
        childAttribs.Vertex.dirty();
        childAttribs.Color.dirty();
        childNode.dirtyBound();
    },

    getComponentLines: function ( positions, vertical ) {
        let lines = [];

        for ( let iVertex = 0; iVertex < positions.length - 1; iVertex++ ) {
            const pos1 = positions[ iVertex ];
            const pos2 = positions[ iVertex + 1 ];
            let newPos1;
            let newPos2;
            if ( pos1[ 2 ] > pos2[ 2 ] ) {
                if ( vertical ) { // vertical line starts in highest vertex of each pair
                    newPos1 = [ pos1[ 0 ], pos1[ 1 ], pos1[ 2 ] ];
                    newPos2 = [ pos1[ 0 ], pos1[ 1 ], pos2[ 2 ] ];
                } else { // horizontal line follows lowest vertex
                    newPos1 = [ pos1[ 0 ], pos1[ 1 ], pos2[ 2 ] ];
                    newPos2 = [ pos2[ 0 ], pos2[ 1 ], pos2[ 2 ] ];
                }
            } else {
                if ( vertical ) {
                    newPos1 = [ pos2[ 0 ], pos2[ 1 ], pos1[ 2 ] ];
                    newPos2 = [ pos2[ 0 ], pos2[ 1 ], pos2[ 2 ] ];
                } else {
                    newPos1 = [ pos1[ 0 ], pos1[ 1 ], pos1[ 2 ] ];
                    newPos2 = [ pos2[ 0 ], pos2[ 1 ], pos1[ 2 ] ];
                }
            }
            lines.push( [ newPos1, newPos2 ] );
        }
        return lines;
    },

    update: function ( /*viewer*/) {
        if ( !this.isToolActive() )
            return;

        if ( this.isDblClickOrTapEvent() ) {
            this.doActionDblClickOrTap();
        } else if ( ( this._currentHitPosition !== undefined ) && ( this._lastHitPosition !== undefined ) ) {
            if ( this._globalDistance === 0 ) {
                this._textsNode.removeChildren();
                this._linesNode.removeChildren();

                this._angleTextsNode.removeChildren();
                this._anglesNode.removeChildren();
            }

            // Drawing current label
            this.drawTmpLabel();

            // Drawing labels instead the last
            this.drawLabels();

            // Lines
            if ( !this.isEscapeKeyEvent() ) {
                this.drawLines();
            } else {
                this.doEscAction();
            }
        } else if ( this._fromPolygon || ( this._previousFeatureSelected && this._featureSelectedGeomType === FeatureDefinition.LINE ) ) {
            if ( this._previousFeatureSelected )
                this.getPositionsFromSelectedFeature();
            this._currentHitPosition = this._positions[ this._positions.length - 1 ];
            this._lastHitPosition = this._currentHitPosition;
            this.repaintTextNode(); // to draw all the labels
            this.doEscAction(); // to draw the screen lines and to update the measure value

            this._fromPolygon = false;
        }

        this.resetEvent();
    },


    /**
     * Method to update the total distance.
     * @method
     * @memberof pcvizTools.DistanceTool
     */
    updateDistanceMeasure: function () {

        if ( this._positionsArray.length === 0 )
            return;

        // We capture click outside valid areas
        if ( this._currentHitPosition === undefined && !this.isEscapeKeyEvent() )
            return;

        // copy the positions array to use it when the units is changed
        this._positions = this._positionsArray.slice();

        this._globalDistance = 0.0;
        this._globalHorizontalDistance = 0.0;
        this._globalVerticalDistance = 0.0;
        let vec1 = osg.vec3.create64();
        let vec2 = osg.vec3.create64();

        for ( let i = 1; i < this._positionsArray.length; i++ ) {
            this._globalDistance = this._globalDistance + osg.vec3.distance( this._positionsArray[ i - 1 ], this._positionsArray[ i ] );
            this._globalHorizontalDistance = this._globalHorizontalDistance + this.horizontalDistance( this._positionsArray[ i ], this._positionsArray[ i - 1 ] );
        }

        // update angles if the angles option is enabled
        if ( this._showAngles && this._anglesNode.getNumChildren() < this._positionsArray.length - 2 ) {
            const i = this._positionsArray.length - 2;
            osg.vec3.sub( vec1, this._positionsArray[ i + 1 ], this._positionsArray[ i ] );
            osg.vec3.sub( vec2, this._positionsArray[ i - 1 ], this._positionsArray[ i ] );
            const angleInRad = osg.vec3.angle( vec1, vec2 );
            this._anglesNode.addChild( this.drawAngle( angleInRad, this._positionsArray[ i ], vec2, vec1 ) );
            this._angleTextsNode.addChild( this.drawAngleText( angleInRad, this._positionsArray[ i ], vec2, vec1 ) );
        }

        this._globalVerticalDistance = this.verticalDistance( this._positionsArray[ 0 ], this._positionsArray[ this._positionsArray.length - 1 ] ); // The vertical value shown is the height difference between the first point and the last one.
        // Update value distance
        let d;
        if ( !this.isEscapeKeyEvent() && !( Utils.isTouchEnabled() ) ) {

            d = this._globalDistance + osg.vec3.distance( this._lastHitPosition, this._currentHitPosition );
            this._globalHorizontalDistance = this._globalHorizontalDistance + this.horizontalDistance( this._currentHitPosition, this._lastHitPosition );
            // The vertical value shown is the height difference between the first point and the last one.
            this._globalVerticalDistance = this.verticalDistance( this._positionsArray[ 0 ], this._currentHitPosition );

        } else {
            d = this._globalDistance;
        }
        this.dispatchData( d );
    },

    /**
     * Computes the projected distance in the horizontal plane
     * @param  {osg.Vec3} positionA A vector 3 point
     * @param  {osg.Vec3} positionB A vector 3 point
     * @return {Float}           The computed distance
     */
    horizontalDistance: function ( positionA, positionB ) {
        return Math.sqrt( Math.pow( positionA[ 0 ] - positionB[ 0 ], 2 ) + Math.pow( positionA[ 1 ] - positionB[ 1 ], 2 ) );
    },

    /**
     * The vertical value is the height difference between the two points
     * @param  {osg.vec3} end   A vector 3 point
     * @param  {osg.Vec3} start A vector 3 point
     * @return {Float}       The computed distance
     */
    verticalDistance: function ( start, end ) {
        return end[ 2 ] - start[ 2 ];
    },

    /**
     * Method to create a text label with the distance of a segment
     * @method
     * @memberof pcvizTools.DistanceTool
     * @param  {osg.vec3} start The initial point of the line
     * @param  {osg.vec3} end The final point of the line
     * @return {CustomText}     the text object to be added in the scene graph
     */
    drawDistanceText: function ( start, end ) {
        let textString = osg.vec3.distance( start, end );
        textString = this._distLabel + this._unitsController.convertToUserUnit( textString, 'distance' );
        if ( this._showHorizAndVerti ) {
            let hTextString = this.horizontalDistance( start, end );
            hTextString = this._unitsController.convertToUserUnit( hTextString, 'distance' );

            let vTextString = this.verticalDistance( start, end );
            vTextString = this._unitsController.convertToUserUnit( vTextString, 'distance' );

            textString = textString + '\n' + this._horizLabel + hTextString + '\n' + this._vertiLabel + vTextString;
        }
        let pos = new osg.vec3.create32();
        osg.vec3.lerp( pos, start, end, 0.5 );
        return this.createText( pos, textString, this._renderBinForDistances );
    },


    repaintTextNode: function () {
        // remove all children
        this._textsNode.removeChildren();
        // repaint texts again, seting renderBinValue increased 0.0001 each time
        if ( this._positions !== undefined && this._positions.length > 1 ) {
            for ( let i = 1; i < this._positions.length; i++ ) {
                let text = this.drawDistanceText( this._positions[ i - 1 ], this._positions[ i ] );
                text.setRenderBinValue( text.getRenderBinValue() + i * 0.0001 );
                // *0.0001 sets a renderBin number greater than previous                
                this._textsNode.addChild( text );
            }
        }
    },

    getMeasurePoints: function () {
        return this._positions;
    },

    /**
     * Sets the translated string for the horizontal distance label to use it in the Text Node.
     * @method
     * @memberof pcvizTools.DistanceTool
     * @param {string} labelTranslated the string for the horizontal distance label
     */
    setHorizLabel: function ( labelTranslated ) {
        this._horizLabel = labelTranslated;
    },

    /**
     * Sets the translated string for the vertical distance label to use it in the Text Node.
     * @method
     * @memberof pcvizTools.DistanceTool
     * @param {string} labelTranslated the string for the vertical distance label
     */
    setVertiLabel: function ( labelTranslated ) {
        this._vertiLabel = labelTranslated;
    },

    /**
     * Sets the translated string for the distance label to use it in the Text Node.
     * @method
     * @memberof pcvizTools.DistanceTool
     * @param {string} labelTranslated the string for the 3D distance label
     */
    setDistanceLabel: function ( labelTranslated ) {
        this._distLabel = labelTranslated;
    },

    /**
     * Changes the attribute to show or hide the horizontal and vertical distances.
     * @method
     * @memberof pcvizTools.DistanceTool
     */
    switchShowHorizAndVerti: function () {
        this._showHorizAndVerti = !this._showHorizAndVerti;
        this.repaintTextNode();
        this.repaintLinesNode();
    },

    /**
     * Gets the value of the attribute that points if the horizontal and vertical distances are visible.
     * @method
     * @memberof pcvizTools.DistanceTool
     * @return {boolean} indicates if the horizontal and vertical distances are visible
     */
    getShowHorizAndVerti: function () {
        return this._showHorizAndVerti;
    },

    getHorizDistance: function () {
        return this._globalHorizontalDistance;
    },

    getVertiDistance: function () {
        return this._globalVerticalDistance;
    },

    switchShowAngles: function () {
        this._showAngles = !this._showAngles;

        // repaint or hide
        if ( this._showAngles ) {
            this.drawAllAngles( true );
        } else {
            this._anglesNode.removeChildren();
            this._angleTextsNode.removeChildren();
        }

        // Another idea is to use nodeMask -> showAngle.setNodeMask( 0x0 );

    },

    getShowAngles: function () {
        return this._showAngles;
    },

    drawAngle: function ( angle, point, pointvector, pointvector2 ) {
        const angleNode = new MatrixTransform();

        angleNode.getOrCreateStateSet().setAttributeAndModes( blendAttribute );

        let quatBetweenNorms;
        let quatInver;
        let cross = osg.vec3.cross( osg.vec3.create64(), pointvector, pointvector2 );
        if ( osg.vec3.dot( point, cross ) < 0 ) {
            osg.vec3.negate( cross, cross ); // to draw in the correct space

            quatBetweenNorms = osg.quat.rotationTo( osg.quat.create(), osg.vec3.fromValues( 0.0, 0.0, 1.0 ), osg.vec3.normalize( osg.vec3.create64(), cross ) );
            quatInver = osg.quat.invert( osg.quat.create64(), quatBetweenNorms );
            angleNode
                .getOrCreateStateSet()
                .addUniform( Uniform.createFloat3( osg.vec3.transformQuat( osg.vec3.create64(), pointvector, quatInver ), 'uBase' ) );

        } else {
            quatBetweenNorms = osg.quat.rotationTo( osg.quat.create(), osg.vec3.fromValues( 0.0, 0.0, 1.0 ), osg.vec3.normalize( osg.vec3.create64(), cross ) );
            quatInver = osg.quat.invert( osg.quat.create64(), quatBetweenNorms );

            angleNode
                .getOrCreateStateSet()
                .addUniform( Uniform.createFloat3( osg.vec3.transformQuat( osg.vec3.create64(), pointvector2, quatInver ), 'uBase' ) );
        }

        angleNode.getOrCreateStateSet().addUniform( Uniform.createFloat( angle, 'uAngle' ) );
        const size = Math.min( osg.vec3.length( pointvector ), osg.vec3.length( pointvector2 ) ) / 2.0;
        angleNode.getOrCreateStateSet().addUniform( Uniform.createFloat( size, 'uSize' ) );

        angleNode.addChild( GizmoGeometry.createQuadCircleGeometry( size, size ) );

        angleNode.getOrCreateStateSet().setAttributeAndModes( new osg.CullFace( osg.CullFace.DISABLE ) ); //to draw the angle for both sides
        angleNode.getOrCreateStateSet().setRenderingHint( 'TRANSPARENT_BIN' ); // to make transparent the angle

        // move the arc to the right position and particular plane (by default it is over the XY plane)
        osg.mat4.copy( angleNode.getMatrix(), osg.mat4.fromRotationTranslation( osg.mat4.create64(), quatBetweenNorms, point ) );

        return angleNode;
    },

    drawAngleText: function ( angle, point, vec1, vec2 ) {
        const vec1Norm = osg.vec3.normalize( osg.vec3.create64(), vec1 );
        const vec2Norm = osg.vec3.normalize( osg.vec3.create64(), vec2 );

        let pos = [ ( vec1Norm[ 0 ] + vec2Norm[ 0 ] ) / 2.0, ( vec1Norm[ 1 ] + vec2Norm[ 1 ] ) / 2.0, ( vec1Norm[ 2 ] + vec2Norm[ 2 ] ) / 2.0 ];
        osg.vec3.scale( pos, pos, Math.min( osg.vec3.length( vec1 ), osg.vec3.length( vec2 ) ) );
        osg.vec3.add( pos, pos, point );
        let angleText;
        if ( this._anglesUnit === DistanceTool.ANGLE_UNIT_RADIANS )
            angleText = angle.toFixed( Registry.getController( 'UserPreferences' ).getPreference( Utils.NUMBER_OF_DECIMALS_KEY ) ) + 'rad';
        else
            angleText = ( angle * TO_DEGREES ).toFixed( Registry.getController( 'UserPreferences' ).getPreference( Utils.NUMBER_OF_DECIMALS_KEY ) ) + 'º';
        // the position is computed by the bisector of the two normalized vectors and scaling it by the length of the shortest one. (We could multiply this length by 0.9)

        return this.createText( pos, angleText, this._renderBinForAngles );
    },

    createText: function ( pos, textString, renderBinValue ) {

        let text = new CustomText( textString );
        //while measuring,  *0.0001 sets a renderBin number greater than previous                
        if ( this._positionsArray )
            text.setRenderBinValue( renderBinValue + this._positionsArray.length * 0.0001 );


        text.setPosition( pos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( this._textSize );
        text.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( osg.Depth.ALWAYS ), osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE ); //

        text.setColor( osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 ) );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        if ( this._positionsArray ) // If the user is still measuring
            text.setBackgroundColor( whileMeasuringColor );
        else // If the user has finished the measurement
            text.setBackgroundColor( finishedColor );

        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    },

    setAnglesUnit: function ( unit ) {
        this._anglesUnit = unit;

        // only repaint texts
        this._angleTextsNode.removeChildren();
        if ( this._showAngles ) {
            this.drawAllAngles();
        }
    },

    drawAllAngles: function ( drawArcs ) {
        if ( this._positions === undefined )
            return;
        let vec1 = osg.vec3.create64();
        let vec2 = osg.vec3.create64();
        for ( let i = 1; i < this._positions.length - 1; i++ ) {

            osg.vec3.sub( vec1, this._positions[ i + 1 ], this._positions[ i ] );
            osg.vec3.sub( vec2, this._positions[ i - 1 ], this._positions[ i ] );
            const angleInRad = osg.vec3.angle( vec1, vec2 );
            if ( drawArcs )
                this._anglesNode.addChild( this.drawAngle( angleInRad, this._positions[ i ], vec2, vec1 ) );

            this._angleTextsNode.addChild( this.drawAngleText( angleInRad, this._positions[ i ], vec2, vec1 ) );
        }
    },

    getAnglesUnit: function () {
        return this._anglesUnit;
    }
} );

module.exports = DistanceTool;


/***/ }),

/***/ "./sources/pcvizTools/ElevationTool.js":
/*!*********************************************!*\
  !*** ./sources/pcvizTools/ElevationTool.js ***!
  \*********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ElevationTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js");
/* harmony import */ var pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js");
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizDB/UnitController */ "./sources/pcvizDB/UnitController.js");
/* harmony import */ var pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizNode/CustomText */ "./sources/pcvizNode/CustomText.js");
/* harmony import */ var pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_8__);














const { osg, osgUtil, osgText } = OSG__WEBPACK_IMPORTED_MODULE_0___default.a;

const ELEVATION_COLOR = osg.vec4.fromValues32( 0.0, 1.0, 0.0, 0.5 );
const ELEVATION_LABEL_BACKGROUND_COLOR = osg.vec4.fromValues32( 51, 51, 61, 0.8 );
const MAXZ = 10000.0;
const ELEVATION_TRAVERSAL_MASK = 1 << 3;

/**
 *  Elevation tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */

class ElevationTool extends pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor( viewer ) {
        super( viewer, 'elevation' );

        this._isContinuous = false;
        this._elevationValue = 0.0;
        this._startPoint = osg.vec3.create64();
        this._finishPoint = osg.vec3.create64();

        this._referenceLayer = undefined;
        this._referenceNode = undefined;

        this._textSize = ( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) ? 7 : 5;

        // OSG tool's nodes
        this._elevationNode = new osg.Node();
        this._elevationNode.setName( 'elevationTool' );

        this._linesNode = new osg.Node();

        this._textsNode = new osg.Node();
        this._textsNode.setNodeMask( ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.TRAVERSAL_MASK_IV );

        viewer.getToolsNode().addChild( this._elevationNode );

        // Intersector's setting up
        this._iv = new osgUtil.IntersectionVisitor();
        this._iv.setTraversalMask( ELEVATION_TRAVERSAL_MASK );

        this._lsi = new osgUtil.LineSegmentIntersector();
        this._iv.setIntersector( this._lsi );

        // Tool for drawing
        this._sketchTool = new pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_2___default.a( viewer );

        // Listeners
        pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getController( 'UserPreferences' ).registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_6___default.a.PROJECT, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.NUMBER_OF_DECIMALS_KEY, () => {
            this.refreshTextLabel();
        } );

        this._unitsController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_4___default.a.getInstance().getController( 'Units' );
        this._unitsController.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_6___default.a.APPLICATION, pcvizDB_UnitController__WEBPACK_IMPORTED_MODULE_5___default.a.DISTANCE_TYPE, () => {
            this.refreshTextLabel();
        } );
    }

    setActive( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        this.setIntersectionsExceptPointClouds( !active );
        if ( !active ) {
            this._viewer.getCanvas().parentElement.style.cursor = 'default';
            if ( this._pickingElement !== undefined )
                this._pickingElement.style.display = 'none';

            this.removeEventListeners();
            this.clearTool();

            // Disable picking only if it is necessary
            this.setPickingEnabled( false );
            this.setContinuousMode( false ); // Turn off continuous mode for a future activation
        } else {
            this.initSelectedFeatureUse();
            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );


            this.setUpEventListeners();

            this._elevationNode.addChild( this._linesNode );
            this._elevationNode.addChild( this._textsNode );

            this._viewer.disableManipulatorDoubleClick();

            // enable picking
            this.setPickingEnabled( true );
        }
    }

    setIntersectionsExceptPointClouds( enable ) {
        const view3d = this._viewer.getSceneView();

        if ( !view3d.getLayerRenderer() ) {
            return;
        }

        if ( enable && this._referenceNode ) {
            this._referenceNode.setNodeMask( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.TRAVERSAL_MASK_IV ); // Restore intersections over previous reference layer
        }

        view3d.setEnableIntersections( enable, pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].VECTOR );
        view3d.setEnableIntersections( enable, pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].RASTER );
    }

    isContinuousMode() {
        return this._isContinuous;
    }

    setContinuousMode( value ) {
        this._isContinuous = value;
    }

    clearTool() {
        super.clearTool();

        this._referenceLayer = undefined;
        this._referenceNode = undefined;

        this._elevationNode.removeChildren();
        this.cleanElevation();
    }

    changeReferenceLayer( layer ) {
        if ( this._referenceNode ) {
            this._referenceNode.setNodeMask( ~pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.TRAVERSAL_MASK_IV ); // Restore no intersections over previous reference layer
        }
        this._referenceLayer = layer;

        this._referenceNode = undefined;
        // Gets vector layer osg node
        if ( this._referenceLayer.isVisible() ) {
            this._referenceNode = this._referenceLayer.getFeatureRenderer().getSceneGraph();
            this._referenceNode.setNodeMask( ELEVATION_TRAVERSAL_MASK );
        }
    }

    update() {
        if ( !this.isToolActive() ) {
            return;
        }
        if ( this.isEscapeKeyEvent() ) {
            this.cleanElevation();
            this.resetEvent();
        }
        if ( this.isMouseupOrTapEvent() || this._isContinuous ) {
            this.cleanElevation();
            this.computeElevation();

            if ( this.isMouseupOrTapEvent() ) {
                this.resetEvent();
            }
        }
    }

    cleanElevation() {
        this._textsNode.removeChildren();
        this._linesNode.removeChildren();

        this.dispatchData( 0.0 );
    }

    computeElevation() {
        if ( !this._currentHitPosition ) {
            return;
        }

        if ( !this._referenceNode ) { // If no layer selected, show the z of the hit world point
            const hitElevation = this._position[ 2 ];
            this.dispatchData( hitElevation );
            return;
        }

        let pickPoint = this._currentHitPosition;

        // Intersection upper limit
        let startAux = osg.vec3.create64();
        let finishAux = osg.vec3.create64();
        osg.vec3.sub( startAux, pickPoint, osg.vec3.fromValues32( 0, 0, MAXZ ) );
        osg.vec3.add( finishAux, pickPoint, osg.vec3.fromValues32( 0, 0, MAXZ ) );

        // Throw intersection line
        this._lsi.reset();
        this._lsi.set( startAux, finishAux );
        this._referenceNode.accept( this._iv ); // Just computing intersection over the reference layer's osg node
        let hits = this._lsi.getIntersections();

        // Get the finish point
        osg.vec3.copy( this._startPoint, startAux );
        osg.vec3.copy( this._finishPoint, finishAux );
        const hasHit = hits.length > 0;
        if ( hasHit ) {
            let hit = hits[ 0 ];

            hit._nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.computeNodePath( hit._drawable );

            osg.vec3.copy( this._startPoint, pickPoint );
            osg.vec3.copy( this._finishPoint, this._viewer.calculateWorldHitCoords( hit, true ) );
        }

        // Draw 3D line
        const positions = [ this._startPoint, this._finishPoint ];
        const line = this._sketchTool.drawLines( positions, false, ELEVATION_COLOR );
        this._linesNode.addChild( line.segments );

        // Update elevation value
        this._elevationValue = this._startPoint[ 2 ] - this._finishPoint[ 2 ];
        this.dispatchData( hasHit ? this._elevationValue : undefined );

        // Draw labels
        if ( hasHit ) {
            let textPos = new osg.vec3.create32();
            osg.vec3.lerp( textPos, positions[ 0 ], positions[ 1 ], 0.5 );
            let textNode = this.createTextLabel( this._elevationValue, textPos );
            this._textsNode.addChild( textNode );
        }
    }

    createTextLabel( textString, pos ) {
        let textUnits = this._unitsController.convertToUserUnit( textString, 'distance' );

        let text = new pcvizNode_CustomText__WEBPACK_IMPORTED_MODULE_8___default.a( textUnits );

        text.setRenderBinValue( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_3___default.a.RENDERBIN_CUSTOMTEXT_DISTANCE );

        text.setPosition( pos );
        text.setAutoRotateToScreen( true );
        text.setCharacterSize( this._textSize );
        text.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( osg.Depth.ALWAYS ), osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

        text.setColor( osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 ) );
        text.setFont( 'sans-serif' );
        text.setFontResolution( 64 );
        text.setBackgroundColor( ELEVATION_LABEL_BACKGROUND_COLOR );

        text.setCharacterSizeMode( osgText.Text.SCREEN_COORDS );

        return text;
    }

    refreshTextLabel() {
        if ( !this._referenceLayer ) {
            return;
        }

        this._textsNode.removeChildren();

        let textPos = new osg.vec3.create32();
        osg.vec3.lerp( textPos, this._startPoint, this._finishPoint, 0.5 );
        let textNode = this.createTextLabel( this._elevationValue, textPos );
        this._textsNode.addChild( textNode );
    }
}


/***/ }),

/***/ "./sources/pcvizTools/FindImagesTool.js":
/*!**********************************************!*\
  !*** ./sources/pcvizTools/FindImagesTool.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" );
var ImageUtils = __webpack_require__( /*! pcvizUtils/ImageUtils */ "./sources/pcvizUtils/ImageUtils.js" ).default;

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  FindImages tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */
var FindImagesTool = function ( sceneView ) {
    PickTool.call( this, sceneView.getViewer(), 'findImages' );

    this._view = sceneView;
    this._active = false;
    this._hit = undefined;
    this._imageLayer = undefined;

    sceneView.getViewer().addTool( this ); // since it is not in the toolbar, we need to add it to get update calls

    this._imageSelectionController = Registry.getInstance().getController( 'ImageSelection' );

};

FindImagesTool.prototype = osg.objectInherit( PickTool.prototype, {

    setProject: function ( project ) {
        this._project = project;
    },

    setActive: function ( active ) {
        if ( this._active === active )
            return;

        this._active = active;
        var infoTool = this._view.getViewer().findTool( 'information' );

        if ( !active ) {
            this.clearTool();
            this.setCursor( 'default' );
            this.drawPickingElement( undefined );
            this._imageSelectionController.inspectedImages = [];
            infoTool.enableSelectionChanges();
        } else {
            this.checkOtherTools();
            this.setCursor( 'crosshair' );
            infoTool.disableSelectionChanges();
        }
    },

    // While in inspection mode, we don't want interference from tools other than information
    // Because this FindImages tool is not in the toolbar, we need to disable other tools here
    checkOtherTools: function () {

        var toolbar = this._view.getToolbar();

        toolbar.forEach( function ( tool ) {
            if ( tool.isToolActive() )
                tool.setActive( false );
        } );

        toolbar.getTool( 'information' ).setActive( true );
    },

    setCursor: function ( type ) {

        if ( type !== this._currentCursor ) {
            this._view.getViewer().getCanvas().parentElement.style.cursor = type;
            this._currentCursor = type;
        }
    },

    update: function () {
        if ( !this.isToolActive() )
            return;

        if ( this._hit )
            this.drawPickingElement( this._hit );
    },

    setSelectionLayer: function ( layer ) {
        this._imageLayer = layer;
    },

    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.FindImagesTool
     */
    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;

        self._currentCursor = 'default';

        this._mouseupFunction = function ( ev ) {

            if ( !self.isToolActive() )
                return;

            var x = ev.clientX;
            var y = ev.clientY;
            // if the current mouse position isn't equal than the mouse position when mousedown event ocurred,
            // it's a drag event, so we don't do anything

            if ( ( x !== self.mousePosX ) || ( y !== self.mousePosY ) ) {
                self.mousePosX = 0.0;
                self.mousePosY = 0.0;
                return;
            }

            var isMobile = UtilsDB.isTouchEnabled();
            var clientX, clientY;
            if ( isMobile && ev.type === 'touchend' ) {
                clientX = ev.changedTouches[ 0 ].clientX;
                clientY = ev.changedTouches[ 0 ].clientY;
            } else {
                clientX = ev.clientX;
                clientY = ev.clientY;
            }

            self._viewer.limitIntersections( false );
            var hits = self._viewer.computeAllIntersections( ev, clientX, clientY );
            self._viewer.limitIntersections( true );

            if ( hits[ 0 ] !== undefined && ev.button === 0 ) {

                // FIXME: this block of code is to give priority to markers when
                // pointclouds and markers are in the hit list
                var hit;
                var userData;
                for ( var j = 0; j < hits.length && hit === undefined; j++ ) {
                    for ( var i = hits[ j ]._nodePath.length - 1; i >= 0; i-- ) {
                        userData = hits[ j ]._nodePath[ i ].getUserData();
                        if ( userData !== undefined && userData.featureIds !== undefined ) {
                            hit = hits[ j ];
                            break;
                        }
                    }
                }
                if ( hit === undefined )
                    hit = hits[ 0 ];
                // END FIXME
                var detail = self._viewer.createHitEventStructure( ev, hit /* hits[ 0 ]*/ , x, y );

                self.drawPickingElement( hit );
                self._hit = hit;

                self.selectImages( detail.coordinate );
            }

            ev.stopPropagation();
        };

        this._wheelFunction = function () {

        };

        this._keydownFunction = function ( ev ) {
            ev.stopPropagation();
        };

        this._dblclickFunction = function ( ev ) {

            ev.stopPropagation();
        };

        this._mousedownFunction = function ( ev ) {

            if ( !self.isToolActive() )
                return;

            // save the mouse position to check if there's a drag event
            self.mousePosX = ev.clientX;
            self.mousePosY = ev.clientY;

            ev.stopPropagation();
        };

        this._pickFunction = function ( /*ev*/) {

        };

    },

    selectImages: function ( coordinate ) {

        var selectedImages = { visibleImages: [] };

        // for now, find an image layer
        if ( !this._imageLayer ) {
            var selectionObject = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
            if ( !selectionObject || !selectionObject.getLayer() )
                return;

            var imageLayer = selectionObject.getLayer();
            if ( !imageLayer || !imageLayer.getFeatures )
                return;

            if ( imageLayer.getCategory() !== VectorLayerUtils.default.Categories.PLANAR_IMAGE )
                return;

            this._imageLayer = imageLayer;
        }

        this.selectImagesByPages( this._imageLayer, selectedImages, coordinate, {
            'page': 1,
            'page_size': UtilsDB.PAGE_SIZE
        } );
    },

    selectImagesByPages: function ( imageLayer, selectedImages, position, config ) {

        var defer = P.defer();
        var self = this;

        imageLayer.getFeatures( config ).then( function ( featureIterator ) {

            featureIterator.reset();
            while ( featureIterator.next() ) {
                var f = featureIterator.get();
                var ptVisibility = ImageUtils.isPointVisibleInImage( position, f );
                if ( ptVisibility ) {
                    ptVisibility.type = 'visible';
                    selectedImages.visibleImages.push( ptVisibility );
                }
            }

            if ( featureIterator.getTotalNumFeatures() / config[ 'page_size' ] > config.page ) {
                config.page++;
                self.selectImagesByPages( imageLayer, selectedImages, position, config ).then( function () {
                    defer.resolve();
                } );
            } else {
                // send notification of new selection only after all image status updates are completed
                self._imageSelectionController.inspectedImages = selectedImages.visibleImages;
                defer.resolve();
            }
        } );

        return defer.promise;
    }

} );

module.exports = FindImagesTool;


/***/ }),

/***/ "./sources/pcvizTools/FlyToTool.js":
/*!*****************************************!*\
  !*** ./sources/pcvizTools/FlyToTool.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Jordi torres <jordi.torres@mirage-tech.com>
 */


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var CADManipulator = __webpack_require__( /*! pcvizManipulator/CADManipulator */ "./sources/pcvizManipulator/CADManipulator.js" );

var osg = OSG.osg;

/**
 *  A tool to simulate a fly movement
 *  @class
 *  @memberof pcvizTools
 *  @extends Tool
 */

var FlyToTool = function ( viewer ) {
    Tool.call( this, viewer, 'flyTo' );
    this._initialPosition = osg.vec3.create64();
    this._initialTarget = osg.vec3.create64();
    this._finalTarget = osg.vec3.create64();
    this._finalPosition = osg.vec3.create64();
    this._forward = osg.vec3.create64();
    this._finalPivotPoint = osg.vec3.create64();
    // default duration
    this._duration = 1.0;
    this._lastTransTime = 0.0;
    this._currentPosition = osg.vec3.create64();
    this._currentTarget = osg.vec3.create64();
    this._currentPivotPoint = osg.vec3.create64();
    this._finishCallback = undefined;
    this._easeFunction = FlyToTool.easeOutQuad;

    this._inverseMatrix = osg.mat4.create();
};


FlyToTool.linear = function ( t ) {
    return t;
};

FlyToTool.easeInOutQuad = function ( t ) {
    return t < 0.5 ? 8 * t * t * t * t : 1 - Math.pow( -2 * t + 2, 4 ) / 2;
};

FlyToTool.easeOutQuad = function ( t ) {
    return -t * ( t - 2 );
};

FlyToTool.easeOutQuart = function ( t ) {
    return 1 - Math.pow( 1 - t, 4 );
};

FlyToTool.easeOutQuint = function ( t ) {
    return 1 + ( --t ) * t * t * t * t;
};

FlyToTool.prototype = osg.objectInherit( Tool.prototype, {

    setFlyParameters: function ( position, target, duration, finishCallback ) {
        var viewMatrix = this._viewer.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );
        this._finishCallback = finishCallback;

        // TODO: This avoids flying to the same position.
        // Use osg.vec3.equals -> See glMatrix Documentation
        var epsilon = 1E-6;
        if ( osg.vec3.dist( eye, position ) < epsilon ) {
            return;
        }

        osg.vec3.copy( this._initialPosition, eye );
        osg.vec3.copy( this._finalPosition, position );

        osg.vec3.copy( this._initialTarget, center );
        if ( target === undefined ) {
            osg.vec3.sub( this._forward, position, eye );
            //    this._forward[ 2 ] = 0;   // this line will be useful when we use this tool to fly to the panoramas
            osg.vec3.normalize( this._forward, this._forward );
            osg.vec3.add( this._finalTarget, position, this._forward );
        } else {
            osg.vec3.copy( this._finalTarget, target );
        }
        this._active = true;
        if ( duration !== undefined ) this._duration = duration;
    },


    // Update function is called once per frame
    update: function () {
        if ( !this.isToolActive() ) return;

        var manipulator = this._viewer.getManipulator();

        if ( !( manipulator instanceof CADManipulator ) ) {
            this._viewer.stopFlyTo();
            return;
        }

        var currentTime = this._viewer.getFrameStamp().getSimulationTime();
        if ( this._requestTime === undefined ) this._requestTime = currentTime;
        var t = ( ( currentTime - this._requestTime ) / this._duration ).toFixed( 4 );
        // Animation is over.
        if ( t > 1.0 ) {
            this._active = false;
            this._requestTime = undefined;
            // Reset the manipulator
            manipulator.reset();
            this.configureManipulatorPose( manipulator, this._currentPosition, this._currentTarget );
            manipulator.computeHomePosition();
            manipulator.setTarget( this._finalTarget );
            manipulator.setEyePosition( this._finalPosition );
            manipulator.setPivotPoint( this._finalTarget );
            this._finishCallback();
            return;
        }

        //slerp spheric interpolation
        osg.vec3.lerp( this._currentPosition, this._initialPosition, this._finalPosition, this._easeFunction( t ) );
        osg.vec3.lerp( this._currentTarget, this._initialTarget, this._finalTarget, this._easeFunction( t ) );

        // TODO: Implement Bezier function
        // let positionInterval = osg.vec3.create64();
        // let positionInterval = osg.vec3.create64();
        // osg.vec3.sub( positionInterval, this._initialPosition, this._finalPosition );
        // osg.vec3.scale( positionInterval, positionInterval, 0.3 );
        // osg.vec3.sum( positionInterval, this._initialPosition, positionInterval );

        // let targetInterval = osg.vec3.create64();
        // osg.vec3.sub( targetInterval, this._initialTarget, this._finalTarget );
        // osg.vec3.scale( targetInterval, targetInterval, 0.3 );
        // osg.vec3.sum( targetInterval, this._initialTarget, positionInterval );

        // osg.vec3.bezier( this._currentPosition, this._initialPosition, this._finalPosition, FlyToTool.linear( t ) );
        // osg.vec3.bezier( this._currentTarget, this._initialTarget, this._finalTarget, FlyToTool.linear( t ) );

        // Update the viewMatrix of the camera
        osg.mat4.lookAt( this._inverseMatrix, this._currentPosition, this._currentTarget, osg.vec3.fromValues( 0, 0, 1 ) );
        osg.mat4.copy( this._viewer.getCamera().getViewMatrix(), this._inverseMatrix );
    },

    configureManipulatorPose: function ( manipulator, eye, target ) {
        if ( !isNaN( eye[ 0 ] ) && !isNaN( target[ 0 ] ) ) {
            manipulator.setHomePosition( eye, target, osg.vec3.fromValues64( 0, 0, 1 ) );
        }
    },

} );

module.exports = FlyToTool;


/***/ }),

/***/ "./sources/pcvizTools/GizmoTool.js":
/*!*****************************************!*\
  !*** ./sources/pcvizTools/GizmoTool.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GizmoTool; });
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js");
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizNode_LayerGizmo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizNode/LayerGizmo */ "./sources/pcvizNode/LayerGizmo.js");
/* harmony import */ var pcvizNode_LayerGizmo__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_LayerGizmo__WEBPACK_IMPORTED_MODULE_1__);



/**
 * This is an interface for tools that need a LayerGizmo such as
 * CursorTool. It implements its property bag fields to allow
 * UI interaction.
 * @class
 * @memberof pcvizTools
 * @extends Tool
 */
class GizmoTool extends pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor( sceneView, id ) {
        super( sceneView.getViewer(), id );

        this._view = sceneView;

        sceneView.getViewer().addTool( this );

        this._layerGizmo = new pcvizNode_LayerGizmo__WEBPACK_IMPORTED_MODULE_1___default.a( sceneView.getViewer() );
        this._rotationVisibility = true;
        this._axesVisibility = true;
        this._planeVisibility = true;

        this._uiEditionEnabled = true;
        this._azimutEditionEnabled = true;

        this._hideRotationArcProperty = false;
        this._hideAzimutProperty = false;
        this._scaleEnabled = false;
        this._layerGizmo.setDisabledRightMiddleButtons( true );
    }

    /**
     * Changes the visibility of the gizmo handlers
     * @method
     * @memberof pcvizTools.GizmoTool
     */
    changeGizmoVisibility() {
        this._layerGizmo.setGizmoMask( {
            rotation: this._rotationVisibility,
            axes: this._axesVisibility,
            plane: this._planeVisibility
        } );
    }


    hideRotationArcProperty( hide ) {
        this._hideRotationArcProperty = hide;
    }

    hideAzimutProperty( hide ) {
        this._hideAzimutProperty = hide;
    }

    enableScale( enable ) {
        this._scaleEnabled = enable;
    }


    /**
     * Inititalizes the property set.
     * @method
     * @memberof pcvizTools.GizmoTool
     */
    initializePropertySet() {
        this.clearProperties();

        if ( this._layerGizmo._mode === pcvizNode_LayerGizmo__WEBPACK_IMPORTED_MODULE_1___default.a.MODES.RASTER || this._id === 'cursor' ) { // CE3D doesn't want to see these properties for manual regist
            // Gizmo visualization group
            let gizmoVisualization = this.addPropertyField( {
                id: 'gizmoVisualizationGroup',
                label: 'GIZMO_TOOL.HANDLER_MANIPULATOR',
                type: 'GroupField',
                translate: true
            } );

            if ( !this._hideRotationArcProperty )
                this.addPropertyField( {
                    id: 'rotationVisibility',
                    label: 'GIZMO_TOOL.ROTATION_VIS',
                    type: 'BooleanField',
                    get: () => this._rotationVisibility,
                    set: value => {
                        this._rotationVisibility = value;
                        this.changeGizmoVisibility();
                    },
                    group: gizmoVisualization
                } );

            this.addPropertyField( {
                id: 'axesVisibility',
                label: 'GIZMO_TOOL.AXES_VIS',
                type: 'BooleanField',
                get: () => this._axesVisibility,
                set: value => {
                    this._axesVisibility = value;
                    this.changeGizmoVisibility();
                },
                group: gizmoVisualization
            } );

            this.addPropertyField( {
                id: 'planeVisibility',
                label: 'GIZMO_TOOL.PLANE_VIS',
                type: 'BooleanField',
                get: () => this._planeVisibility,
                set: value => {
                    this._planeVisibility = value;
                    this.changeGizmoVisibility();
                },
                group: gizmoVisualization
            } );
        }

        // Transformation group
        let transformationGroup = this.addPropertyField( {
            id: 'transformationGroup',
            label: 'GIZMO_TOOL.XFORM_PROP_GROUP',
            type: 'GroupField',
            translate: true
        } );

        if ( !this._hideAzimutProperty )
            this.addPropertyField( {
                id: 'azimuth',
                label: 'GIZMO_TOOL.XFORM_PROP_AZIMUTH',
                type: 'FloatField',
                translate: true,
                editable: () => ( this._uiEditionEnabled || this._azimutEditionEnabled ) && this._layerGizmo._attachedNode,
                decimals: 1,
                valueRange: [ -180.0, 180.0 ],
                get: function () {
                    var xform = this._layerGizmo.getCurrentTransformConfig();
                    return xform.angles[ 2 ] * 180 / Math.PI;
                },
                set: value => {
                    value = value * Math.PI / 180;
                    let xform = this._layerGizmo.getCurrentTransformConfig();
                    let oldValue = xform.angles[ 2 ];
                    xform.angles[ 2 ] = value;
                    this._layerGizmo.setCurrentTransformConfig( xform, 2, oldValue );
                },
                group: transformationGroup,
                visible: () => {
                    return !this._view.getViewer().getIsOrtho() || ( !this._layerGizmo._handleConfig.frontView && !this._layerGizmo._handleConfig.sideView );
                },
            } );

        this.addPropertyField( {
            id: 'tilt',
            label: 'GIZMO_TOOL.XFORM_PROP_TILT',
            type: 'FloatField',
            translate: true,
            editable: () => this._uiEditionEnabled && this._layerGizmo._attachedNode,
            decimals: 1,
            valueRange: [ -90.0, 90.0 ],
            get: () => {
                let xform = this._layerGizmo.getCurrentTransformConfig();
                return xform.angles[ 1 ] * 180 / Math.PI;
            },
            set: value => {
                value = value * Math.PI / 180;
                let xform = this._layerGizmo.getCurrentTransformConfig();
                let oldValue = xform.angles[ 1 ];
                xform.angles[ 1 ] = value;
                this._layerGizmo.setCurrentTransformConfig( xform, 1, oldValue );
            },
            visible: () => {
                // FIXME: now it is hidden because it doesn't work well
                return !this._view.getViewer().getIsOrtho() || this._layerGizmo._handleConfig.frontView /*|| this._layerGizmo._handleConfig.sideView */ ;
            },
            group: transformationGroup
        } );

        this.addPropertyField( {
            id: 'roll',
            label: 'GIZMO_TOOL.XFORM_PROP_ROLL',
            type: 'FloatField',
            translate: true,
            editable: () => this._uiEditionEnabled && this._layerGizmo._attachedNode,
            decimals: 1,
            valueRange: [ -180.0, 180.0 ],
            get: () => {
                var xform = this._layerGizmo.getCurrentTransformConfig();
                return xform.angles[ 0 ] * 180 / Math.PI;
            },
            set: value => {
                value = value * Math.PI / 180;
                let xform = this._layerGizmo.getCurrentTransformConfig();
                let oldValue = xform.angles[ 0 ];
                xform.angles[ 0 ] = value;
                this._layerGizmo.setCurrentTransformConfig( xform, 0, oldValue );
            },
            visible: () => {
                // FIXME: now it is hidden because it doesn't work well
                return !this._view.getViewer().getIsOrtho() || this._layerGizmo._handleConfig.sideView;
            },
            group: transformationGroup
        } );

        this.addPropertyField( {
            id: 'translation',
            label: 'GIZMO_TOOL.XFORM_PROP_TRANS',
            type: 'Point',
            translate: true,
            editable: () => this._uiEditionEnabled && this._layerGizmo._attachedNode,
            get: () => {
                return this._layerGizmo.getCurrentTransformConfig().translation;
            },
            set: () => {
                this._layerGizmo.setCurrentTransformConfig( this._layerGizmo.getCurrentTransformConfig() );
            },
            group: transformationGroup
        } );

        if ( this._scaleEnabled ) {
            this.addPropertyField( {
                id: 'scaleX',
                label: 'GIZMO_TOOL.XFORM_PROP_SCALEX',
                type: 'FloatField',
                translate: true,
                editable: () => this._uiEditionEnabled && this._layerGizmo._attachedNode,
                decimals: 2,
                valueRange: [ 0.01, 10, 0.1 ],
                get: () => {
                    return this._layerGizmo.getCurrentTransformConfig().scale[ 0 ];
                },
                set: ( value ) => {
                    this._layerGizmo.getCurrentTransformConfig().scale[ 0 ] = value;
                    this._layerGizmo.setCurrentTransformConfig( this._layerGizmo.getCurrentTransformConfig() );
                },
                group: transformationGroup
            } );
            this.addPropertyField( {
                id: 'scaleY',
                label: 'GIZMO_TOOL.XFORM_PROP_SCALEY',
                type: 'FloatField',
                translate: true,
                editable: () => this._uiEditionEnabled && this._layerGizmo._attachedNode,
                decimals: 2,
                valueRange: [ 0.01, 10, 0.1 ],
                get: () => {
                    return this._layerGizmo.getCurrentTransformConfig().scale[ 1 ];
                },
                set: ( value ) => {
                    this._layerGizmo.getCurrentTransformConfig().scale[ 1 ] = value;
                    this._layerGizmo.setCurrentTransformConfig( this._layerGizmo.getCurrentTransformConfig() );
                },
                group: transformationGroup
            } );
        }


    }

    /**
     * Adds a callback that is called when the gizmo is updated
     * @method
     * @memberof pcvizTools.GizmoTool
     * @param {function} cb The callback function
     */
    setUIRefreshCB( cb ) {
        this._layerGizmo.setUIRefreshCB( cb );
    }
}


/***/ }),

/***/ "./sources/pcvizTools/InformationTool.js":
/*!***********************************************!*\
  !*** ./sources/pcvizTools/InformationTool.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var pcvizUtils = __webpack_require__( /*! pcvizUtils/pcvizUtils */ "./sources/pcvizUtils/pcvizUtils.js" ).default;
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var FlyToTool = __webpack_require__( /*! pcvizTools/FlyToTool */ "./sources/pcvizTools/FlyToTool.js" );
var pcvizManipulator = __webpack_require__( /*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var osgUtil = OSG.osgUtil;

/**
 *  Information tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */
var InformationTool = function ( view ) {
    PickTool.call( this, view.getViewer(), 'information' );

    this._view = view;

    this._selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );

    // Properties about points of pointclouds
    // the node's geometry which is intersected to get its information
    this._geometry = undefined;

    //Properties about features of vector layers
    this._featureSelected = undefined; // save the feature intersected to not execute query each frame
    this._savedHit = undefined; // to update screen position each frame ??
    this._previousLayer = undefined; // the previous layer only is saved if it is a VectorLayer
    this._userData = undefined;

    // Flags to manage selection modes
    this._isContinuous = false;
    this._isSelectionEnabled = true; // to disable selection when you're editing a feature
    this._changeSelection = true; // to disable changing the selection object for inspection, but keep the picking
    this._isMultipleFeatureEnabled = false;

    this._selectedLayer = undefined; // the current selected layer to use Continuous mode
    this._active = false; // force events setup when setActive called the first time
    this._clearSelection = true; // clear selected feature when tool is deactivated. Must be false when switching to buffer

    this._flyTo = new FlyToTool( this._viewer );
    this._modelMat = osg.mat4.create();

    this._storePointFeaturePosFlag = false;

    var self = this;
    this._selectionObjectController.registerListener( ListenerController.PROJECT, function ( selectionObject ) {
        self._selectionObject = selectionObject;
        if ( selectionObject.getFeature !== undefined && ( selectionObject.getFeature() !== self._featureSelected || self._featureSelected === undefined ) ) {
            if ( !self._isMultipleFeatureEnabled || self._previousLayer !== selectionObject.getLayer() ) {
                if ( self._previousLayer !== undefined ) {
                    if ( self._featureSelected ) {
                        self._previousLayer.deselectAll();

                        self._featureSelected = undefined;
                    }
                    var feature = self._selectionObject.getFeature();
                    if ( feature !== undefined && feature.getId() !== -1 ) {
                        self._featureSelected = feature;
                    }
                    if ( self._featureSelected ) {
                        self.refreshFeatureSelectionRender( self._previousLayer, self._featureSelected, false ).then( function () {
                            self.setFeatureFromSelectionObject();
                        } );
                    }

                } else {
                    self.setFeatureFromSelectionObject();
                }
            }
        }
        // If multiple feature selection is enabled, maybe the listener is being run because 
        // one of the features has been removed from the selectionObect. So, we need to unselect it from the symbology.
        if ( self._isMultipleFeatureEnabled && selectionObject.getLayer() && selectionObject.getSelectionType() === SelectionObject.VectorLayer ) {
            let featuresList = selectionObject.getAllFeatures().slice();
            if ( selectionObject.getFeature() )
                featuresList.unshift( selectionObject.getFeature() );

            let fidDeselect = Array.from( selectionObject.getLayer().getSelectedFeatures() ).find( featureId => {
                return featuresList.some( ( feature ) => feature.getId() === featureId ) === false;
            } );
            if ( fidDeselect !== undefined ) {
                selectionObject.getLayer().deselectFeature( fidDeselect );
                selectionObject.getLayer().getFeature( fidDeselect ).then( ( featureToDeselect ) => {
                    self.refreshFeatureSelectionRender( self._previousLayer, featureToDeselect, false );
                } );

                if ( !featuresList.length || fidDeselect === self._featureSelected.getId() )
                    self._featureSelected = undefined;
            } else {
                if ( selectionObject.getUserData() && selectionObject.getUserData().origin && selectionObject.getUserData().origin.includes( 'LayoutPoints' ) ) {
                    self.refreshFeatureSelectionRender( selectionObject.getLayer(), undefined, true );
                    if ( self._featureSelected === undefined )
                        self._featureSelected = selectionObject.getFeature();
                }
            }
        }

        if ( self._previousLayer !== undefined && self._previousLayer.getType() === 'LayerGroup' ) {
            let layerRenderer = self._previousLayer.getFeatureRenderer();
            if ( layerRenderer !== undefined ) {
                let symbol = ( layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
                if ( symbol ) {
                    symbol.setSelected( false );
                    symbol.updateColor();
                }
            }
        }

        if ( self._selectionObject.getLayer !== undefined && self._selectionObject.getLayer() !== undefined && self._selectionObject.getLayer().getType() === 'LayerGroup' ) {
            let layer = self._selectionObject.getLayer();
            self._previousLayer = layer;
            let layerRenderer = layer.getFeatureRenderer();
            if ( layerRenderer !== undefined ) {
                let symbol = ( layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
                if ( symbol ) {
                    symbol.setSelected( true );
                    symbol.updateColor();
                }
            }
        }

        if ( self._selectionObject.getFeature && self._featureSelected === self._selectionObject.getFeature() ) {
            self._previousLayer = self._selectionObject.getLayer();
        }
    } );

    // If there's an object selected, inits the variables according to the selection. In other case, instantiates the selection object.
    if ( !this._selectionObjectController.getSelectionObject() ) {
        this._selectionObject = new pcvizUtils.SelectionObject();
        return;
    }

    this._selectionObject = this._selectionObjectController.getSelectionObject();
    var layer = this._selectionObject.getLayer();
    this.setSelectedLayer( layer );
    if ( this._selectionObject.getFeature ) {
        var feature = this._selectionObject.getFeature();
        if ( feature !== undefined && feature.getId() !== -1 ) {
            layer.selectFeature( feature.getId() );
            this._featureSelected = feature;
            this._previousLayer = layer;
        }
    }

};

InformationTool.TYPE_POINTCLOUD = 0; // the hit is over a point of a pointcloud
InformationTool.TYPE_FEATURE = 1; // the hit is over a feature of a VectorLayer
InformationTool.TYPE_RASTER = 2; // the hit is over a image of a RasterLayer

InformationTool.prototype = osg.objectInherit( PickTool.prototype, {

    setActive: function ( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        const isJobSite = !!this.getJobSite();
        if ( !active ) {
            this.removeEventListeners();
            if ( this.isContinuous() ) {
                this.resetLayerMasks(); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
            }
            this.clearTool();
            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.POINT_PRIMITIVES );
            // Disable picking only if it is necessary
            this.setPickingEnabled( false );
            if ( Utils.isTouchEnabled() ) { // Maybe we should add || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches )
                this._viewer.restoreManipulatorDoubleClick();
            }
            if ( this._pickingElement !== undefined )
                this._pickingElement.style.display = 'none';
            if ( !isJobSite ) {
                this.enablePanoramaIntersections( false );
            }
        } else {
            this.removeEventListeners(); //This is necessary because this tool is the first one to be activated. So, the event listeners were duplicated without this line 
            this.setUpEventListeners();
            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );
            if ( Utils.isTouchEnabled() ) { //  || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches )
                this._viewer.disableManipulatorDoubleClick(); // We don't allow dblclick on touch devices (it doesn't work well)
            } else
                this._viewer.restoreManipulatorDoubleClick();

            if ( !isJobSite ) {
                this.enablePanoramaIntersections( true );
            }
            if ( this._isContinuous === false ) {
                if ( this._viewer.isPickingEnabled() )
                    this._viewer.setPickingEnabled( false );
                return;
            }
            // if isContinuous
            this.setPickingEnabled( true );
            var self = this;
            this._view.getLayerRenderer().getAllLayerNodes().forEach( function ( node, layerKey ) {
                if ( layerKey !== self._selectedLayer ) {
                    node.setNodeMask( layerKey._visible ? ~Utils.TRAVERSAL_MASK_IV : 0x0 ); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
                }
            } );
            // for layergroups
            this._view._layerGroupNodes.forEach( function ( node, layerId ) {
                if ( layerId !== self._selectedLayer.getId() ) {
                    self.setLayerGroupNodeMask( node, layerId, ~Utils.TRAVERSAL_MASK_IV );
                }
            } );
        }
    },

    enablePanoramaIntersections: function ( value ) {
        let layers = this._view.getProject().getAllLayers();
        for ( let layer of layers ) {
            if ( layer.getType() === LayerType.VECTOR && VectorLayerUtils.isPanorama( layer.getCategory() ) ) { // is a panorama layer
                if ( layer.getFeatureRenderer() && !layer.getFeatureRenderer().getSymbol().getOnPanoramaMode() ) { // avoid changing intersections if is on panorama mode
                    layer.getFeatureRenderer().getSymbol().enableIntersections( value );
                }
            }
        }
    },

    findActivePanoramaLayer: function () {
        let panoramaLayer;
        let layers = this._view.getProject().getAllLayers();
        for ( let layer of layers ) {
            if ( layer.getType() === LayerType.VECTOR && VectorLayerUtils.isPanorama( layer.getCategory() ) ) {
                // check getFeatureRenderer because sometimes happens that there is a panorama layer just added that has not being rendered yet.
                if ( layer.getFeatureRenderer() && layer.getFeatureRenderer().getSymbol().getOnPanoramaMode() ) {
                    panoramaLayer = layer;
                    break;
                }
            }
        }
        return panoramaLayer;
    },

    /**
     * This method should be called when there's a click over a layer.
     * According to the object clicked, this method calls a function that updates the _selectionObject and notifies its change.
     * @method
     * @memberof pcvizTools.InformationTool
     */
    pickLayer: function () {

        if ( !this._changeSelection )
            return;

        var layer = Utils.findLayerInNodePath( this._hit._nodePath );
        if ( !layer )
            return;

        // If it is a point of a PointCloud
        if ( this._typeObjectClicked === InformationTool.TYPE_POINTCLOUD ) {
            this.pickPointCloudLayer( layer );
        } else if ( this._typeObjectClicked === InformationTool.TYPE_RASTER ) {
            this.pickRasterLayer( layer );
        }
        // If not, it's a feature of a VectorLayer
        else if ( layer.getType() === 'LayerGroup' ) {
            this.pickLayerGroup( layer );
        } else {
            this.pickVectorLayer( layer );
        }
    },

    /**
     * This method updates the _selectionObject with the information of the point clicked in a PointCloud.
     * In addition, it deselects a feature if there's someone selected.
     * @method
     * @memberof pcvizTools.InformationTool
     * @param {pcvizGIS.Layer} layer the layer that has been picked
     */
    pickPointCloudLayer: function ( layer ) {

        this.unselectPreviousLayer();

        this._geometry = this._hit._nodePath[ this._hit._nodePath.length - 1 ];
        var colorAttribute = this._geometry.getAttributes().Color;
        var colorIdx = this._hit._primitiveIndex * colorAttribute.getItemSize();

        var color = [
            colorAttribute.getElements()[ colorIdx ] / 255.0,
            ( colorAttribute.getElements()[ colorIdx + 1 ] ) / 255.0,
            ( colorAttribute.getElements()[ colorIdx + 2 ] ) / 255.0
        ];

        var intensity = this._geometry.getAttributes().Intensity.getElements()[ this._hit._primitiveIndex ];
        var classification = this._geometry.getAttributes().Classification.getElements()[ this._hit._primitiveIndex ];

        var info = {
            position: this._position,
            color: Utils.RgbTofullhex( color ),
            intensity: intensity,
            classification: Utils.lookUpClassification( classification )
        };

        if ( this._isContinuous ) {
            this._selectionObject = this._selectionObjectController.getSelectionObject();
            if ( !this._selectionObject.getLayer() )
                this._selectionObject.setLayer( layer );
        } else {
            this._selectionObject = this.createSelectionObject( SelectionObject.PointCloud );
            this._selectionObject.setLayer( layer );
        }
        this._selectionObject.setHit( this._hit );
        this._selectionObject.setUserData( info );

        this.setSelectionObject();
    },
    /**
     * This method updates the _selectionObject with the information of the point clicked in a Raster.
     * In addition, it deselects a feature if there's someone selected.
     * @method
     * @memberof pcvizTools.InformationTool
     * @param {pcvizGIS.Layer} layer the layer that has been picked
     */
    pickRasterLayer: function ( layer ) {

        this.unselectPreviousLayer();

        var info = {
            position: this._position,
        };

        this._selectionObject = this.createSelectionObject( SelectionObject.RasterLayer );
        this._selectionObject.setLayer( layer );
        this._selectionObject.setUserData( info );

        this.setSelectionObject();
    },
    /**
     * This method updates the _selectionObject with the information of the layer group clicked.
     * @method
     * @memberof pcvizTools.InformationTool
     * @param {pcvizGIS.Layer} layer the layer that has been picked
     */
    pickLayerGroup: function ( layer ) {
        this.unselectPreviousLayer();
        this._previousLayer = layer;
        this._selectionObject = this.createSelectionObject( SelectionObject.LayerGroup );
        this._selectionObject.setLayer( layer );
        var userData = {
            origin: [ 'InformationTool' ]
        };
        this._selectionObject.setUserData( userData );
        this.setSelectionObject();

        this._savedHit = this._hit;
    },

    /**
     * This method updates the _selectionObject with the information of the feature clicked.
     * In addition, it selects the feature in its relative layer.
     * @method
     * @memberof pcvizTools.InformationTool
     * @param {pcvizGIS.Layer} layer the layer that has been picked
     */
    pickVectorLayer: function ( layer ) {
        if ( this._previousLayer !== undefined ) {
            if ( this._previousLayer.getType() === 'LayerGroup' ) {
                var layerRenderer = this._previousLayer.getFeatureRenderer();
                if ( layerRenderer !== undefined ) {
                    var symbol = ( layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
                    if ( symbol ) {
                        symbol.setSelected( false );
                        symbol.updateColor();
                    }
                }
            }
        }

        let fid;
        // The osg nodes of verity models don't have the featureId in the userData.
        // So we need to get all the features and find by the instanceGuid
        let promiseGetFeatureId = Promise.resolve();
        if ( VectorLayerUtils.isVerityModel( layer.getCategory() ) ) {
            promiseGetFeatureId = this.getFeatureIdFromVerityModel( this._hit._nodePath, layer ).then( ( featureId ) => {
                fid = featureId;
            } );
        } else {
            fid = this.getFeatureId( this._hit._nodePath, this._hit._primitiveIndex );
        }
        promiseGetFeatureId.then( () => {


            var nearestVertex;

            // When we're editing a feature, we can change the selected vertex
            if ( !this._isSelectionEnabled ) {
                if ( fid === this._featureSelected.getId() && this._previousLayer === layer ) {
                    nearestVertex = this.getNearestVertex();
                    this._selectionObject.setVertex( nearestVertex );
                    this._featureSelected.getGeometry().changeSelectedPropertyField( nearestVertex );
                    this.setSelectionObject();
                }
                return;
            }

            this._savedHit = this._hit;

            // If the picked feature is the same than the selected feature, we set the selected vertex and return.
            if ( this._featureSelected !== undefined && ( fid === this._featureSelected.getId() && this._previousLayer === layer ) ) {
                if ( !VectorLayerUtils.isPanorama( this._featureSelected.getLayerCategory() ) && !VectorLayerUtils.isPlanarImage( this._featureSelected.getLayerCategory() ) &&
                    !VectorLayerUtils.isVerityModel( this._featureSelected.getLayerCategory() ) ) {
                    nearestVertex = this.getNearestVertex();
                    this._selectionObject.setVertex( nearestVertex );
                    this._featureSelected.getGeometry().changeSelectedPropertyField( nearestVertex );
                }

                return;
            }

            if ( this._featureSelected !== undefined && this._previousLayer !== undefined && ( ( fid !== this._featureSelected.getId() && !this._isMultipleFeatureEnabled ) || this._previousLayer !== layer ) ) {
                this._previousLayer.deselectAll();
                this.refreshFeatureSelectionRender( this._previousLayer, this._selectionObject.getFeature(), false );
                // Refresh all posible selected features in case the previousLayer supported multipleSelection
                this._selectionObject.getAllFeatures().forEach( ( f ) => {
                    this.refreshFeatureSelectionRender( this._previousLayer, f, false );
                } );
                this._previousLayer = undefined;
            }

            this._featureSelected = undefined;
            var query = this.getFeature( layer, fid );
            if ( query === undefined ) return;

            var self = this;

            query.then( function ( f ) {
                if ( self._hit !== undefined ) { // To check that anyone hasn't called to clear while we were waiting

                    layer.selectFeature( f.getId() );

                    self._featureSelected = f;

                    self.refreshFeatureSelectionRender( layer, f, true, true );


                    self._previousLayer = layer;

                    // Sometimes _selectionObject can be undefined if clearTool has been called
                    let addFeature = self.isAddingFeature( layer );

                    if ( addFeature ) {
                        let isFeatureAdded = self._selectionObject.addFeature( f );
                        if ( !isFeatureAdded )
                            return;
                    } else {
                        self._selectionObject = self.createSelectionObject( SelectionObject.VectorLayer );
                        self._selectionObject.setLayer( layer );
                        self._selectionObject.setFeature( f );
                    }

                    if ( !VectorLayerUtils.isPanorama( f.getLayerCategory() ) && !VectorLayerUtils.isPlanarImage( f.getLayerCategory() ) &&
                        !VectorLayerUtils.isVerityModel( layer.getCategory() ) ) {
                        // When we select a feature for the first time, we set the selected vertex to the _selectionObject.
                        self._selectionObject.setVertex( self.getNearestVertex() );
                        self._selectionObject.setHit( self._hit );
                    }

                    if ( VectorLayerUtils.isControlPoint( self._featureSelected.getLayerCategory() ) ) {
                        var pt, ptx, pty, screenPos;
                        var ratioX = self._viewer.getCanvas().width / self._viewer.getCanvas().clientWidth;
                        var ratioY = self._viewer.getCanvas().height / self._viewer.getCanvas().clientHeight;

                        pt = Utils.projectToScreen( self._viewer.getCamera(), self._savedHit );
                        ptx = parseInt( pt[ 0 ], 10 ) / ratioX;
                        pty = parseInt( self._viewer.getCanvas().height - pt[ 1 ], 10 ) / ratioY;
                        screenPos = osg.vec2.fromValues( ptx + 10, pty + 10 ); // Adds 10 to move the html component next to the point
                        var featureInfo = {
                            screenPosition: screenPos
                        };
                        self._selectionObject.setUserData( featureInfo );
                    }

                    if ( layer.getGeometryType() === FeatureDefinition.POINT && self._storePointFeaturePosFlag ) {
                        const userData = self._selectionObject.getUserData() || {};
                        // Uncomment next line for reporting the pick position
                        // userData.position = self._position;

                        // compute accumulate MT
                        const xFormMat = Utils.getAccumulateTransformations( layer );
                        let positionFeature = [ self._featureSelected.getGeometry().getX(), self._featureSelected.getGeometry().getY(), self._featureSelected.getGeometry().getZ() ];
                        if ( xFormMat ) {
                            positionFeature = osg.vec3.transformMat4( osg.vec3.create64(), positionFeature, xFormMat );
                        }

                        userData.position = positionFeature;
                        self._selectionObject.setUserData( userData );
                    }

                    self.setSelectionObject();
                }
            } );

        } );
    },

    /**
     * Method to update the userData of the feature picked (if exists) to update the UI component
     * @method
     * @memberof pcvizTools.InformationTool
     */
    update: function () {
        if ( !this.isToolActive() )
            return;

        if ( this._typeEvent === 'escapeKey' ) {
            if ( this._isSelectionEnabled && !MagnetAPI.isVerity() )
                this.clearTool( true );
        }
        // Uncomment this line when the fly to tool would be active.
        // this._flyTo.update( this._viewer );

        if ( this._screenDataListener === undefined || this._isContinuous || !this._isSelectionEnabled || !this._savedHit )
            return;
        if ( this._featureSelected !== undefined && VectorLayerUtils.isControlPoint( this._featureSelected.getLayerCategory() ) ||
            this._selectedLayer.getCategory && this._selectedLayer.getCategory() === 'Station' ) {
            var pt, ptx, pty, screenPos;
            var ratioX = this._viewer.getCanvas().width / this._viewer.getCanvas().clientWidth;
            var ratioY = this._viewer.getCanvas().height / this._viewer.getCanvas().clientHeight;

            pt = Utils.projectToScreen( this._viewer.getCamera(), this._savedHit );
            ptx = parseInt( pt[ 0 ], 10 ) / ratioX;
            pty = parseInt( this._viewer.getCanvas().height - pt[ 1 ], 10 ) / ratioY;
            screenPos = osg.vec2.fromValues( ptx + 10, pty + 10 ); // Adds 10 to move the html component next to the point
            var userData = this._selectionObject.getUserData();
            if ( !userData )
                userData = {};
            userData.screenPosition = screenPos;
            this._selectionObject.setUserData( userData );
            this.notifyListenerScreenData();
        }

    },

    registerListenerScreenData: function ( fn ) {
        this._screenDataListener = fn;
    },

    notifyListenerScreenData: function () {
        this._screenDataListener();
    },

    /**
     * Get the nearest vertex of the selected feature to the intersection point.
     * @method
     * @memberof pcvizTools.InformationTool
     * @return {int} the index of the nearest vertex
     */
    getNearestVertex: function () {
        var primitive = this._hit._primitiveIndex;
        var intersectionPoint = this._hit._localIntersectionPoint;
        var i1, i2;
        var v1, v2;
        var dist1, dist2;
        var vertexArray;
        var geom;

        var iVertex = 0;

        switch ( this._featureSelected.getLayer().getGeometryType() ) {

        case FeatureDefinition.POINT:
            iVertex = this._userData.vertices[ primitive ];
            break;
        case FeatureDefinition.MULTIPOINT:
            iVertex = this._userData.vertices[ primitive ];
            break;
        case FeatureDefinition.LINE:
            i1 = this._userData.vertices[ primitive ][ 0 ];
            i2 = this._userData.vertices[ primitive ][ 1 ];

            // The primitive intersected has two vertices, so we need to find which is the nearest to the intersection point.
            geom = this._featureSelected.getLayer().getFeatureRenderer().getSymbol().getGeometryFeature( this._featureSelected );
            vertexArray = geom.getVertexAttributeList().Vertex.getElements(); // If we don't want to use getGeometryFeature, we could use nodePath[nodePath.length-1] and if it doesn't have userData (it would be an AutoTransform) return the vertex 0.
            v1 = osg.vec3.fromValues( vertexArray[ ( i1 ) * 3 ], vertexArray[ ( i1 ) * 3 + 1 ], vertexArray[ ( i1 ) * 3 + 2 ] );
            v2 = osg.vec3.fromValues( vertexArray[ ( i2 ) * 3 ], vertexArray[ ( i2 ) * 3 + 1 ], vertexArray[ ( i2 ) * 3 + 2 ] );
            dist1 = osg.vec3.distance( intersectionPoint, v1 );
            dist2 = osg.vec3.distance( intersectionPoint, v2 );
            iVertex = ( Math.min( dist1, dist2 ) === dist1 ? i1 : i2 );
            break;
        case FeatureDefinition.POLYGON:
            var indices = this._userData.vertices;
            i1 = indices[ primitive * 3 ];
            i2 = indices[ primitive * 3 + 1 ];
            var i3 = indices[ primitive * 3 + 2 ];

            // The primitive intersected has three vertices, so we need to find which is the nearest to the intersection point.
            geom = this._featureSelected.getLayer().getFeatureRenderer().getSymbol().getGeometryFeature( this._featureSelected );
            vertexArray = geom.getVertexAttributeList().Vertex.getElements(); // If we don't want to use getGeometryFeature, we could use nodePath[nodePath.length-1] and if it doesn't have userData (it would be an AutoTransform) return the vertex 0.
            v1 = osg.vec3.fromValues( vertexArray[ i1 * 3 ], vertexArray[ i1 * 3 + 1 ], vertexArray[ i1 * 3 + 2 ] );
            v2 = osg.vec3.fromValues( vertexArray[ i2 * 3 ], vertexArray[ i2 * 3 + 1 ], vertexArray[ i2 * 3 + 2 ] );
            var v3 = osg.vec3.fromValues( vertexArray[ i3 * 3 ], vertexArray[ i3 * 3 + 1 ], vertexArray[ i3 * 3 + 2 ] );
            dist1 = osg.vec3.distance( intersectionPoint, v1 );
            dist2 = osg.vec3.distance( intersectionPoint, v2 );
            var dist3 = osg.vec3.distance( intersectionPoint, v3 );
            var min = Math.min( dist1, dist2, dist3 );
            if ( min === dist1 )
                iVertex = i1;
            else if ( min === dist2 )
                iVertex = i2;
            else
                iVertex = i3;
            break;
        }

        return iVertex;
    },

    getFeatureId: function ( nodePath, index ) {
        var fid;
        for ( var i = nodePath.length - 1; i >= 0; i-- ) {
            this._userData = nodePath[ i ].getUserData();
            if ( this._userData !== undefined ) {
                if ( this._userData.featureIds && this._userData.featureIds[ index ] ) {
                    fid = this._userData.featureIds[ index ];
                    break;
                } else if ( this._userData.featureId ) {
                    fid = this._userData.featureId;
                    break;
                }
            }
        }
        return fid;
    },

    getFeatureIdFromVerityModel: function ( nodePath, layer ) {
        return new Promise( ( resolve /*, reject*/ ) => {
            let fid, instanceGuid;
            // first, find the relative instanceGuid object
            for ( var i = nodePath.length - 1; i >= 0; i-- ) {
                this._userData = nodePath[ i ].getUserData();
                if ( this._userData !== undefined ) {
                    const instanceGuidObj = this._userData.find( ( e ) => e.Name === 'instanceGuid' );

                    if ( instanceGuidObj ) {
                        instanceGuid = instanceGuidObj.Value;
                        break;
                    }
                }
            }
            if ( instanceGuid !== undefined ) {
                let featureSelected;
                layer.getAllFeaturesByPages().then( ( featuresObj ) => {
                    featureSelected = featuresObj.features.find( ( f ) => { return f.properties.instanceGuid === instanceGuid; } );
                    fid = featureSelected ? featureSelected.id : undefined;
                    resolve( fid );
                } );
                return;
            }
            resolve( fid );
        } );
    },

    getFeature: function ( layer, fid ) {
        if ( fid === undefined || layer === undefined ) return;
        return layer.getFeature( fid );
    },

    setClearSelection: function ( clearSelection ) {
        this._clearSelection = clearSelection;
    },

    /**
     * Clears the properties.
     * @memberof pcvizTools.InformationTool
     * @method
     */
    clearTool: function ( setSelectionIfLayer ) {
        PickTool.prototype.clearTool.call( this );
        var setSelection = true;

        if ( this._previousLayer !== undefined ) {
            if ( this._featureSelected ) {
                this._previousLayer.deselectAll();

                this.refreshFeatureSelectionRender( this._previousLayer, this._featureSelected, false );
                if ( this._isMultipleFeatureEnabled ) {
                    this._selectionObject.getAllFeatures().forEach( ( f ) => {
                        this.refreshFeatureSelectionRender( this._previousLayer, f, false );
                    } );
                    this.refreshFeatureSelectionRender( this._previousLayer, this._selectionObject.getFeature(), false );
                }
            }

            if ( this._previousLayer.getType() === 'LayerGroup' && setSelectionIfLayer ) {
                var layerRenderer = this._previousLayer.getFeatureRenderer();
                var symbol = ( layerRenderer && layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
                if ( symbol ) {
                    symbol.setSelected( false );
                    symbol.updateColor();
                }
            }
        } else {
            // To not notify the SelectionController if this function is called several times and nothing has been selected between each time.
            setSelection = false;
            // To set selection and notify when a feature has just been added
            if ( this._selectionObject && this._selectionObject.setFeature && this._selectionObject.getFeature() && this._selectionObject.getFeature().getId() === -1 )
                setSelection = true;
        }

        if ( this._clearSelection && this._selectionObject && this._selectionObject.setFeature )
            this._selectionObject.setFeature( undefined );
        if ( this._clearSelection && this._selectionObject && setSelectionIfLayer && this._selectionObject.getLayer() )
            this._selectionObject.setLayer( undefined );
        else
            setSelectionIfLayer = false;

        this._previousLayer = undefined;
        this._featureSelected = undefined;
        this._savedHit = undefined;

        this._geometry = undefined;

        this._userData = undefined;

        this._selectionObject = this._selectionObjectController.getSelectionObject();

        // To not notify the SelectionController if this function is called several times and nothing has been selected between each time.
        if ( this._isSelectionEnabled && ( setSelection || setSelectionIfLayer ) ) {
            let userData = ( this._selectionObject ) ? this._selectionObject.getUserData() : undefined;
            // propagate event originators
            if ( userData && userData.origin )
                userData.origin.push( 'InformationTool:clearTool' );
            this.setSelectionObject();

        }

        this._allHits = [];
    },

    getFeatureSelected: function () {
        return this._featureSelected;
    },

    setSelectedLayer: function ( layer ) {
        this._selectedLayer = layer;

        if ( !this.isContinuous() )
            return;
        // TODO for layergroups
        this._view.getLayerRenderer().getAllLayerNodes().forEach( function ( node, layerKey ) {
            if ( layerKey !== layer ) {
                node.setNodeMask( layerKey._visible ? ~Utils.TRAVERSAL_MASK_IV : 0x0 ); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
            } else
                node.setNodeMask( layer._visible ? Utils.VISIBILITY_MASK : 0x0 ); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
        } );
    },

    getSelectedLayer: function () {
        return this._selectedLayer;
    },

    /**
     * Method to enable the features' selection. We call to this method when we finish editing a feature.
     * When we separate the edition from this tool, we can possibly remove this method.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    enableSelect: function () {
        this._isSelectionEnabled = true;
    },

    /**
     * Method to disable the selection of features. We call to this method when we are going to edit a feature.
     * When we separate the edition from this tool, we can possibly remove this method.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    disableSelect: function () {
        this._isSelectionEnabled = false;
        this.setSelectionObject(); // to warn FeaturesContainerController
    },

    /**
     * Method to enable changes in the selection object, needed for inspection mode
     * If we separate both tools, we can possibly remove this method.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    enableSelectionChanges: function () {
        this._changeSelection = true;
    },

    /**
     * Method to disable changes in the selection object, needed for inspection mode
     * If we separate both tools, we can possibly remove this method.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    disableSelectionChanges: function () {
        this._changeSelection = false;
    },

    /**
     * Method to enable the continuous mode. So, it enable the picking.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    enableContinuousMode: function () {
        this._isContinuous = true;
        this.setPickingEnabled( true );

        var self = this;
        this._view.getLayerRenderer().getAllLayerNodes().forEach( function ( node, layer ) {
            if ( layer !== self._selectedLayer ) {
                node.setNodeMask( layer._visible ? ~Utils.TRAVERSAL_MASK_IV : 0x0 ); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
            }
        } );

        this._view._layerGroupNodes.forEach( function ( node, layerId ) {
            if ( layerId !== self._selectedLayer.getId() ) {
                self.setLayerGroupNodeMask( node, layerId, ~Utils.TRAVERSAL_MASK_IV );
            }
        } );

    },

    /**
     * Method to disable the continuous mode. So, it deactivates the picking.
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    disableContinuousMode: function () {
        this._isContinuous = false;
        //this.setPickingEnabled( false );  // Nowadays, we can't use this function because it doesn't allow disable the picking if this tool is active.
        if ( this._viewer.isPickingEnabled() )
            this._viewer.setPickingEnabled( false );

        this.resetLayerMasks(); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
    },

    isContinuous: function () {
        return this._isContinuous;
    },

    enableMultipleFeatureSelection: function () {
        this._isMultipleFeatureEnabled = true;
    },

    disableMultipleFeatureSelection: function () {
        this._isMultipleFeatureEnabled = false;

        // Maybe the multipleFeatureSelection was enabled but nothing was selected before calling to this method
        if ( !this._selectionObject )
            return;
        // clear features array and deselect features in the symbolizer
        if ( this._selectionObject.getSelectionType() === SelectionObject.VectorLayer ) {
            this._selectionObject.getAllFeatures().forEach( ( f ) => {
                this._previousLayer.deselectFeature( f.getId() );
                this.refreshFeatureSelectionRender( this._previousLayer, f, false );
            } );
            this._selectionObject.clearAllFeatures();
            this._featureSelected = this._selectionObject.getFeature(); // because we had set the last selected
        }
    },

    isMultipleFeatureEnabled: function () {
        return this._isMultipleFeatureEnabled;
    },

    /**
     * Method to set manually the selected feature. Used, for instance, to change the current panorama
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    setSelectedFeature: function ( feature, userData, keepManipulatorPosition ) {
        var layer = feature.getLayer();
        var self = this;
        var defer = P.defer();
        var selectNewFeature = function ( avoidRefresh, keepManipulatorPosition ) {
            // select new feature
            layer.deselectAll();

            layer.selectFeature( feature.getId() );
            if ( !avoidRefresh )
                self.refreshFeatureSelectionRender( layer, feature, true, keepManipulatorPosition ).then( () => {
                    defer.resolve();
                } );

            self._previousLayer = layer;

            self._savedHit = undefined;

            self._selectionObject = self.createSelectionObject( SelectionObject.VectorLayer );
            self._selectionObject.setLayer( layer );
            self._selectionObject.setFeature( feature );
            if ( userData )
                self._selectionObject.setUserData( userData );
            self.setSelectionObject();
            if ( avoidRefresh )
                defer.resolve();
        };

        let addFeature = this.isAddingFeature( layer );
        // Block for selecting features from Table view when multiple selection is enabled
        if ( addFeature ) {
            let isFeatureAdded = this._selectionObject.addFeature( feature );
            if ( !isFeatureAdded ) {
                defer.resolve();
                return defer.promise;
            }
            layer.selectFeature( feature.getId() );
            this.refreshFeatureSelectionRender( layer, feature, true, keepManipulatorPosition ).then( () => {
                defer.resolve();
            } );

            this._featureSelected = feature;
            if ( userData )
                this._selectionObject.setUserData( userData );
            this.setSelectionObject();

        } else {
            // the featureSelected needs to be set in these orders 
            if ( this._previousLayer && this._featureSelected && ( feature.getId() !== this._featureSelected.getId() || this._previousLayer !== layer ) ) {
                this.refreshFeatureSelectionRender( this._previousLayer, this._featureSelected, false ).then( () => selectNewFeature( false, keepManipulatorPosition ) );
                this._featureSelected = feature;
            } else {
                const avoidRefresh = this._previousLayer === layer && this._featureSelected && feature.getId() === this._featureSelected.getId();

                this._featureSelected = feature;
                selectNewFeature( avoidRefresh );
            }
        }

        return defer.promise;
    },

    setFeatureFromSelectionObject: function () {
        var feature = this._selectionObject.getFeature();
        var layer = this._selectionObject.getLayer();
        if ( layer && feature !== undefined && feature.getId() !== -1 ) {
            layer.selectFeature( feature.getId() );
            this._featureSelected = feature;
            this._savedHit = undefined;
            this.refreshFeatureSelectionRender( layer, feature, true );
            this._previousLayer = layer;
        }
    },

    /**
     * Method to set the manipulator's position for the selected image
     * @method
     * @memberof  pcvizTools.InformationTool
     */
    setImageManipulatorPosition: function ( viewDir, feature ) {
        if ( !feature )
            feature = this._featureSelected;
        let point = feature.getGeometry();
        let node = this._viewer.getSceneView().getLayerRenderer().getNodeFromLayer( feature.getLayer() );
        var modelMat = this.getLayerMatrix( node );
        var position = osg.mat4.getTranslation( osg.vec3.create(), modelMat );
        position = [ point.getX() + position[ 0 ], point.getY() + position[ 1 ], point.getZ() + position[ 2 ] ];

        // TODO: Use fly to.
        // var flyToFunction = function ( position ) {
        //     self._view.setPanoramaMode( false );
        //     self._flyTo.setFlyParameters( position, undefined, 1.0, /*initialPosition,*/ function () {
        //         self._view.setPanoramaMode( true );
        //         self._featureSelected.getLayer().getFeatureRenderer().getSymbol().setPanoramaMode( true );
        //         // We need to notify other elements that Panorama mode has changed
        //         Registry.getInstance().getController( 'View' ).refreshPanoramaMode();
        //     } );
        // };
        // // self._flyTo.setActive( true );
        // flyToFunction( position );

        // TODO: We need to figure out a way to execute some actions when a feature is selected by double clicking
        if ( VectorLayerUtils.isPanorama( feature.getLayerCategory() ) ) {
            const panoramaSymbol = feature.getLayer().getFeatureRenderer().getSymbol();
            // Restore intersections with last panorama on panorama mode and set on the chosen one
            const lastPanoramaOnMode = this.findActivePanoramaLayer();
            if ( lastPanoramaOnMode ) {
                lastPanoramaOnMode.getFeatureRenderer().getSymbol().setOnPanoramaMode( false );
            }
            panoramaSymbol.setOnPanoramaMode( true );
            panoramaSymbol.setImageMode( true );
            this._view.setManipulatorMode( pcvizManipulator.PANORAMA_MANIPULATOR, {
                position: position,
                direction: viewDir
            } );
            this._viewer.setFOV( 35.0 );

        } else { // VectorLayerUtils.Categories.PLANAR_IMAGE
            feature.getLayer().getFeatureRenderer().getSymbol().setImageMode( true );
            let lookAt = feature.getLayer().getFeatureRenderer().getSymbol().getLookAt();
            var config = {
                position: position,
                forward: lookAt.forward,
                up: lookAt.up,
                fovy: lookAt.fovy
            };
            this._view.setManipulatorMode( pcvizManipulator.PLANAR_IMAGE_MANIPULATOR, config );
            const annotationTool = this._view.getTool( 'annotation' );
            if ( annotationTool && annotationTool.isToolActive() ) {
                annotationTool.enablePlanarImageIntersections();
            }
        }
    },

    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.InformationTool
     */
    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;

        this._mouseupFunction = function ( ev ) {

            if ( !self.isToolActive() )
                return;

            var x = ev.clientX;
            var y = ev.clientY;
            // if the current mouse position isn't equal than the mouse position when mousedown event ocurred,
            // it's a drag event, so we don't do anything

            if ( self.isDrag( x, y ) ) {
                self.mousePosX = 0.0;
                self.mousePosY = 0.0;
                self.drawPickingElement( undefined );
                return;
            }

            var isMobile = Utils.isTouchEnabled();
            var clientX, clientY;
            if ( isMobile && ev.type === 'touchend' ) {
                clientX = ev.changedTouches[ 0 ].clientX;
                clientY = ev.changedTouches[ 0 ].clientY;
            } else {
                clientX = ev.clientX;
                clientY = ev.clientY;
            }

            self._viewer.limitIntersections( false );
            var hits = self._viewer.computeAllIntersections( ev, clientX, clientY, self._storeAllHits );
            self._viewer.limitIntersections( true );

            if ( hits[ 0 ] !== undefined && ev.button === 0 ) {

                // FIXME: this block of code is to give priority to markers when
                // pointclouds and markers are in the hit list
                var hit = Utils.getPriorHit( hits, self._selectedLayer && self._selectedLayer.getType() === LayerType.VECTOR ? self._selectedLayer : undefined );

                // END FIXME
                if ( self._storeAllHits )
                    self._allHits = hits.slice();
                var detail = self._viewer.createHitEventStructure( ev, hit /* hits[ 0 ]*/ , x, y );
                if ( !self._isSelectionEnabled && detail.plod !== undefined )
                    return;


                var layer = Utils.findLayerInNodePath( hit._nodePath );
                if ( !layer ) {
                    return;
                }
                if ( self._filterLayerFunction && self._filterLayerFunction( layer ) === false )
                    return;


                //  Be careful with the objects you save here because this code block is executed although the features' selection is disabled.
                self._typeEvent = 'pickEvent';
                self._hit = hit; // hits[ 0 ]; // This line makes that self._hit points to other object, but not changes the object which is pointed by self._savedHit
                if ( detail.plod !== undefined )
                    self._typeObjectClicked = InformationTool.TYPE_POINTCLOUD;
                else if ( layer.getType() === LayerType.RASTER )
                    self._typeObjectClicked = InformationTool.TYPE_RASTER;
                else
                    self._typeObjectClicked = InformationTool.TYPE_FEATURE;

                self._position = detail.coordinate;

                if ( !self._isContinuous )
                    self.drawPickingElement( hit );

                self.pickLayer();

                // We need mark the event in order to when it arrives to the LayerEditionTool, we could check if we have to add a new vertex (in this mode)
                // We can not use the stopImmediatePropagation function because of the event has to be sent to the OSG manipulator.
                ev.pickedLayer = true;
            } else {
                if ( !self._isSelectionEnabled || MagnetAPI.isVerity() )
                    return;
                self._typeEvent = 'pickOut';
                self.clearTool( true );
            }

            ev.stopPropagation();

        };

        this._wheelFunction = function () {
            if ( !self._isContinuous )
                self.drawPickingElement( undefined );
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() || !self._isSelectionEnabled )
                return;
            this._typeEvent = 'dblclick';
            if ( self._featureSelected !== undefined && ( VectorLayerUtils.isPanorama( self._featureSelected.getLayerCategory() ) || VectorLayerUtils.isPlanarImage( self._featureSelected.getLayerCategory() ) ) ) {

                self.setImageManipulatorPosition();
                self._view.setImagePriority( self._view.getImagePriority() );
            }
            ev.stopPropagation();
            ev.cancelBubble = true;
        };

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // save the mouse position to check if there's a drag event
            self.mousePosX = ev.clientX;
            self.mousePosY = ev.clientY;
            if ( !self._isContinuous )
                self.drawPickingElement( undefined );

            ev.stopPropagation();
        };

        this._pickFunction = function ( ev ) {
            if ( !self.isToolActive() || !self._isSelectionEnabled )
                return;

            self.drawPickingElement( undefined );

            if ( ev.detail.hit !== undefined ) {
                self._hit = ev.detail.hit;
                self._position = ev.detail.coordinate;
                self._typeObjectClicked = ev.detail.plod !== undefined ? InformationTool.TYPE_POINTCLOUD : InformationTool.TYPE_FEATURE;

                // if the argument passed to drawPickingElement is equal to undefined, the draw function will remove the element from the dom
                if ( !self._isContinuous || Utils.findLayerInNodePath( self._hit._nodePath ) === self._selectedLayer )
                    self.drawPickingElement( ev.detail.hit );
                else
                    self.drawPickingElement( undefined );

                self.pickLayer();
                ev.pickedLayer = true;
            } else {
                self.clearTool();
                return;
            }
        };

    },

    createSelectionObject: function ( type ) {
        return this._selectionObjectController.createSelectionObject( type );
    },

    setSelectionObject: function () {
        if ( this._selectionObject !== undefined )
            this._selectionObjectController.setSelectionObject( this._selectionObject );
    },

    getLayerMatrix: function ( node ) {

        var nodePath = Utils.computeNodePath( node );
        if ( nodePath.length === 0 )
            return this._modelMat;
        var modelMat = osg.computeLocalToWorld( nodePath, true );
        this._modelMat = modelMat;
        return modelMat;
    },

    refreshFeatureSelectionRender: function ( layer, feature, select, fromInfoTool ) {
        var defer = P.defer();

        let featureRenderer = layer.getFeatureRenderer();
        if ( VectorLayerUtils.isVerityModel( layer.getCategory() ) ) {

            if ( featureRenderer ) {
                if ( select ) {
                    featureRenderer.getSymbol().selectFeature( feature );
                } else
                    featureRenderer.getSymbol().deselectFeature( feature );
            }
            defer.resolve();
            return defer.promise;
        }

        layer.updateSymbolRendererAndRefreshLayerInViews().then( function () {
            defer.resolve();
        } ).catch( function () {
            defer.reject();
        } );

        if ( VectorLayerUtils.isPanorama( layer.getCategory() ) || VectorLayerUtils.isPlanarImage( layer.getCategory() ) ) {
            if ( featureRenderer ) {
                if ( select ) {
                    featureRenderer.getSymbol().selectFeature( feature );
                    if ( this._view.getManipulatorMode() !== pcvizManipulator.CAD_MANIPULATOR && !fromInfoTool )
                        this.setImageManipulatorPosition(); // We need to make this here because the line before sets the quaternion correctly
                } else
                    featureRenderer.getSymbol().deselectFeature( feature );
            }
        }

        return defer.promise;
    },

    resetLayerMasks: function () {
        this._view.getLayerRenderer().resetLayerMasks();
        // for layer groups
        this._view._layerGroupNodes.forEach( ( node, layerId ) => {
            this.setLayerGroupNodeMask( node, layerId, Utils.VISIBILITY_MASK );
        } );
    },

    setLayerGroupNodeMask: function ( node, layerId, mask ) {
        var dataCacheObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( layerId );
        if ( !dataCacheObj ) {
            console.log( 'workspace group not found in cache' );
            return;
        }
        let layer = dataCacheObj.getLayerGroupObj();
        if ( !layer )
            return;

        let featureRenderer = layer.getFeatureRenderer( '3D' );
        if ( featureRenderer !== undefined ) {
            let symbolNode = featureRenderer.getSymbolGraph();
            if ( symbolNode )
                symbolNode.setNodeMask( layer._visible && !layer._hideSymbol ? mask : 0x0 ); // Note: Now, for there's no problem with this masks change because it is only for continuous mode (this mode can not be active in verity)
        }

    },

    clearPreviousLayer: function () {
        this._previousLayer = undefined;
    },

    setFilterLayerFunction: function ( fn ) {
        this._filterLayerFunction = fn.bind( this );
    },

    unselectPreviousLayer: function () {
        if ( this._previousLayer !== undefined ) {
            if ( this._featureSelected ) {
                this._previousLayer.deselectAll();

                this.refreshFeatureSelectionRender( this._previousLayer, this._featureSelected, false );
            }
            if ( this._previousLayer.getType() === 'LayerGroup' ) {
                var layerRenderer = this._previousLayer.getFeatureRenderer();
                var symbol = ( layerRenderer && layerRenderer.getSymbol ) ? layerRenderer.getSymbol() : undefined;
                if ( symbol ) {
                    symbol.setSelected( false );
                    symbol.updateColor();
                }
            }
            this._previousLayer = undefined;
            this._featureSelected = undefined;
        }
    },

    getAllHits: function () {
        return this._allHits;
    },

    setStoreAllHits: function ( flag ) {
        this._storeAllHits = flag;
    },

    // This method returns true whether a feature is being added to a multiple selection
    isAddingFeature: function ( layer ) {
        return this._isMultipleFeatureEnabled && this._selectionObject && this._selectionObject.getLayer() && this._selectionObject.getLayer().getId() === layer.getId() && this._selectionObject.getFeature();
    },

    enableStorePointFeaturePosition: function () {
        this._storePointFeaturePosFlag = true;
    },

    disableStorePointFeaturePosition: function () {
        this._storePointFeaturePosFlag = false;
    },

    getStorePointFeaturePosition: function () {
        return this._storePointFeaturePosFlag;
    },

    getPositionAndNormal: function () {
        if ( !this._savedHit )
            return;

        const position = osg.vec3.subtract( new osg.vec3.create64(), this._position, this._viewer.getCenter() );
        return { position, normal: this._savedHit._localIntersectionNormal };
    }

} );

module.exports = InformationTool;


/***/ }),

/***/ "./sources/pcvizTools/LayerEditionTool.js":
/*!************************************************!*\
  !*** ./sources/pcvizTools/LayerEditionTool.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );

var Feature = __webpack_require__( /*! pcvizGIS/Feature */ "./sources/pcvizGIS/Feature.js" ).Feature;
var FeatureDefinition = __webpack_require__( /*! pcvizGIS/FeatureDefinition */ "./sources/pcvizGIS/FeatureDefinition.js" ).default;
var Point = __webpack_require__( /*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js" ).default;
var MultiPoint = __webpack_require__( /*! pcvizGIS/MultiPoint */ "./sources/pcvizGIS/MultiPoint.js" ).default;
var LineString = __webpack_require__( /*! pcvizGIS/LineString */ "./sources/pcvizGIS/LineString.js" ).default;
var LinearRing = __webpack_require__( /*! pcvizGIS/LinearRing */ "./sources/pcvizGIS/LinearRing.js" ).default;
var Polygon = __webpack_require__( /*! pcvizGIS/Polygon */ "./sources/pcvizGIS/Polygon.js" ).default;
var VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );

var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );

var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var osg = OSG.osg;
var osgUtil = OSG.osgUtil;

/**
 * Tool that manages the vector layer's edition (Create, update and delete features).
 * So, use this tool only when the layer selected is a VectorLayer.
 * @class
 * @memberof pcvizTools
 * @extends PickTool
 */
var LayerEditionTool = function ( view, id ) {
    PickTool.call( this, view._viewer, id === undefined ? 'layerEdition' : id );

    this._geometrySelected = undefined;
    this._vertexSelected = 0;
    this._featureSelected = undefined;
    this._layerSelected = undefined;

    this._selectionObject = undefined;
    this._selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );

    this._sketchTool = new SketchTool( this._viewer );
    var tempNode = new osg.Node();
    view._viewer.getToolsNode().addChild( tempNode );
    this._sketchTool.setNode( tempNode );

    this._firstPoint = true;

    this._view = view;

    this._modeAddPoint = false;
    this._removedPoint = false;
    this._enableDispatch = false;

};

LayerEditionTool.prototype = osg.objectInherit( PickTool.prototype, {

    /**
     * Sets the tool active or inactive.
     * @memberof pcvizTools.LayerEditionTool
     * @method
     * @param {boolean} active `true` if the tool is active.
     */
    setActive: function ( active, enableDispatch = false ) {
        this._enableDispatch = enableDispatch;
        if ( this._active === active )
            return;
        this._active = active;
        if ( !this._active ) {
            this._viewer.getCanvas().parentElement.style.cursor = 'default';
            if ( this._pickingElement !== undefined )
                this._pickingElement.style.display = 'none';
            this.removeEventListeners();
            this.clearTool();

            // Disable picking only if it is necessary
            this.setPickingEnabled( false );

            // we don't need to enable the intersections because they haven't been disabled
            /* if ( this._viewer.getVectorLayerScene() )
                 this._viewer.getVectorLayerScene().setEnableIntersections( true );*/

            this._sketchTool._tempNode.getOrCreateStateSet().removeAttribute( 'Depth' );
        } else {
            this._viewer.getPolytopeIntersector().setPrimitiveMask( osgUtil.ALL_PRIMITIVES );

            this.setUpEventListeners();
            this._viewer.disableManipulatorDoubleClick();

            // enable picking
            this.setPickingEnabled( true );

            // ALLOW intersections for navigation and editing on features
            //if ( this._viewer.getVectorLayerScene() )
            //    this._viewer.getVectorLayerScene().setEnableIntersections( false );

            this._sketchTool._tempNode.getOrCreateStateSet().setAttributeAndModes( new osg.Depth( 'ALWAYS' ) );
        }

    },

    setViewer: function ( viewer ) {
        this._viewer = viewer;
        this._sketchTool.setViewer( this._viewer );
        // to review what happens to tempNode
    },

    /**
     * Method to create a new Feature object
     * @method
     * @memberof pcvizTools.LayerEditionTool
     * @return {Feature} the new Feature object
     */
    createFeature: ( function () {
        var eye = osg.vec3.create();
        var center = osg.vec3.create();
        var up = osg.vec3.create();

        return function () {
            var camera = this._viewer.getCamera();
            var matrix = camera.getViewMatrix();

            var distance;
            var feature = new Feature();

            feature.setLayer( this._layerSelected );

            // Should I create the geometry at this moment or when the insert function is called?
            var geometry;
            var p;

            var px = this._positionsArray[ 0 ][ 0 ] + this._viewer.getCenter()[ 0 ];
            var py = this._positionsArray[ 0 ][ 1 ] + this._viewer.getCenter()[ 1 ];
            var pz = this._positionsArray[ 0 ][ 2 ] + this._viewer.getCenter()[ 2 ];

            switch ( this._layerSelected.getFeatureDefinition().getGeomFieldType() ) {

            case FeatureDefinition.POINT:
                geometry = new Point( px, py, pz );
                break;
            case FeatureDefinition.MULTIPOINT:
                geometry = new MultiPoint();
                p = new Point( px, py, pz );
                geometry.addGeometry( p );
                break;
            case FeatureDefinition.LINE:
                geometry = new LineString();
                p = new Point( px, py, pz );
                geometry.addPoint( p );
                break;
            case FeatureDefinition.POLYGON:
                var ring = new LinearRing();
                p = new Point( px, py, pz );
                ring.addPoint( p );
                geometry = new Polygon();
                geometry.addRing( ring );
                break;
            }

            feature.setGeometry( geometry );

            osg.mat4.getLookAt( eye, center, up, matrix, distance );
            feature.setAttributeByName( 'cameraEyeX', eye[ 0 ] );
            feature.setAttributeByName( 'cameraEyeY', eye[ 1 ] );
            feature.setAttributeByName( 'cameraEyeZ', eye[ 2 ] );

            feature.setAttributeByName( 'cameraCenterX', center[ 0 ] );
            feature.setAttributeByName( 'cameraCenterY', center[ 1 ] );
            feature.setAttributeByName( 'cameraCenterZ', center[ 2 ] );

            feature.setAttributeByName( 'cameraUpX', up[ 0 ] );
            feature.setAttributeByName( 'cameraUpY', up[ 1 ] );
            feature.setAttributeByName( 'cameraUpZ', up[ 2 ] );

            this._selectionObject = this._selectionObjectController.createSelectionObject( SelectionObject.VectorLayer );
            this._selectionObject.setLayer( this._layerSelected );
            this._selectionObject.setFeature( feature );
            this._selectionObject.setVertex( 0 );
            this._selectionObjectController.setSelectionObject( this._selectionObject );

            if ( this._layerSelected.getCategory() === VectorLayerUtils.Categories.CONTROL_POINT )
                feature.setInvisibleProperties( [ 'x', 'y', 'z' ] ); // names are in lowercase because these are the fields names set in Feature (not the ones from Server)

            if ( this._layerSelected.getCategory() === VectorLayerUtils.Categories.TARGET )
                feature.setInvisibleProperties( [ 'globaltarx', 'globaltary', 'globaltarz', 'localtarx', 'localtary', 'localtarz', 'tarrange', 'tarh', 'tarv', 'tarheight', 'targetversion', 'targettypeid', 'tarsize', 'targettype', 'fittingpoints', 'surfacethickness', 'positiondeviation', 'pointdrift', 'radius' ] ); // names are in lowercase because these are the fields names set in Feature (not the ones from Server)

            return feature;
        };
    } )(),

    setAutomaticAttributes: function ( update ) {
        var geomType = this._layerSelected.getFeatureDefinition().getGeomFieldType();
        if ( geomType === FeatureDefinition.POINT || !VectorLayerUtils.hasAutomaticAttributes( this._layerSelected.getFeatureDefinition() ) )
            return;

        var centroid = this._featureSelected.getGeometry().getCentroid();
        this._featureSelected.setAttributeByName( Utils.CENTROID_X_ATTR, centroid[ 0 ] );
        this._featureSelected.setAttributeByName( Utils.CENTROID_Y_ATTR, centroid[ 1 ] );
        this._featureSelected.setAttributeByName( Utils.CENTROID_Z_ATTR, centroid[ 2 ] );

        if ( geomType === FeatureDefinition.LINE && ( update || !this._featureSelected.getAttributeByName( Utils.LENGTH_ATTR ) ) ) {
            this._featureSelected.setAttributeByName( Utils.LENGTH_ATTR, this._featureSelected.getGeometry().length() );
        }
        if ( geomType === FeatureDefinition.POLYGON ) {
            if ( update ) {
                // if we are updating the feature, we want to override the values
                this._featureSelected.setAttributeByName( Utils.LENGTH_ATTR, this._featureSelected.getGeometry().getExteriorRing().length() );
                this._featureSelected.setAttributeByName(
                    Utils.AREA_ATTR,
                    this._view.getTool( 'area' ).computeArea(
                        this._geometrySelected.getVertexAttributeList().Vertex.getElements(),
                        this._geometrySelected.getPrimitiveSetList()[ 0 ].getIndices().getElements() ) );
            } else {
                // to avoid repeat operations
                if ( !this._featureSelected.getAttributeByName( Utils.LENGTH_ATTR ) )
                    this._featureSelected.setAttributeByName( Utils.LENGTH_ATTR, this._featureSelected.getGeometry().getExteriorRing().length() );
                if ( !this._featureSelected.getAttributeByName( Utils.AREA_ATTR ) ) {
                    if ( this._featureSelected.getGeometry().getExteriorRing().isClockwise() )
                        this._featureSelected.setAttributeByName( Utils.AREA_ATTR, this._view.getTool( 'area' ).computeArea(
                            this._sketchTool._tempNode.getChildren()[ 0 ].getVertexAttributeList().Vertex.getElements(),
                            this._sketchTool._tempNode.getChildren()[ 0 ].getPrimitiveSetList()[ 0 ].getIndices().getElements() ) );
                    else {
                        // we need reverse the points and get the triangles
                        var reversed = this._sketchTool._positionsArray.slice();
                        reversed.reverse();

                        reversed.unshift( reversed[ reversed.length - 1 ] );
                        var verticesReversed = [];
                        for ( var i = 0, j = 0; i < reversed.length; i++, j += 3 ) {
                            verticesReversed[ j + 0 ] = reversed[ i ][ 0 ];
                            verticesReversed[ j + 1 ] = reversed[ i ][ 1 ];
                            verticesReversed[ j + 2 ] = reversed[ i ][ 2 ];
                        }

                        var indexes = Utils.getPolygonTriangIndexes( verticesReversed );

                        this._featureSelected.setAttributeByName( Utils.AREA_ATTR, this._view.getTool( 'area' ).computeArea(
                            verticesReversed, indexes ) );
                    }
                }
            }
        }
    },

    fillTargetAttributes: function ( targetType, transformMatrix ) {
        this._featureSelected.setAttributeByName( 'TargetType', targetType );
        const position = this._featureSelected.getGeometry();
        const transformedPos = osg.vec3.transformMat4( osg.vec3.create64(), [ position.getX(), position.getY(), position.getZ() ], transformMatrix );
        position.setX( transformedPos[ 0 ] );
        position.setY( transformedPos[ 1 ] );
        position.setZ( transformedPos[ 2 ] );
        this._featureSelected.setAttributeByName( 'GlobalTarX', position.getX() );
        this._featureSelected.setAttributeByName( 'GlobalTarY', position.getY() );
        this._featureSelected.setAttributeByName( 'GlobalTarZ', position.getZ() );
        this._featureSelected.setAttributeByName( 'LocalTarX', position.getX() );
        this._featureSelected.setAttributeByName( 'LocalTarY', position.getY() );
        this._featureSelected.setAttributeByName( 'LocalTarZ', position.getZ() );
        const targetName = this._featureSelected.getAttributeByName( 'name' );
        const tarH = this._featureSelected.getAttributeByName( 'TarH' );
        const tarV = this._featureSelected.getAttributeByName( 'TarV' );
        const tarFileStr = `TARGET_VERSION_ \n ${targetName}\n${position.getX()}\n${position.getY()}\n${position.getZ()}\n${tarH}\n${tarV}`;
        this._featureSelected.setAttributeByName( 'TargetFileContents', tarFileStr );
        const guid = Utils.generateUUID();
        this._featureSelected.setAttributeByName( 'guid', guid );
    },

    /**
     * Method to insert the new feature created.
     * @method
     * @memberof pcvizTools.LayerEditionTool
     * @return {promise} the promise result that shows if the feature has been inserted or not
     */
    insertFeature: function () {
        var self = this;
        var defer = P.defer();

        this.setAutomaticAttributes();

        this._layerSelected.update( VectorLayerUtils.ADD_FEATURE, this._featureSelected ).then( function () {

            self.clearTool();
            self._sketchTool.clearTool();

            // Now, we don't need to wait for layers rendered because nobody is calling to refresh layer simultaneously.
            // But, it is more reliable
            Registry.getInstance().getController( 'Layer' ).refreshLayerInAllViews( self._layerSelected ).then( function () {
                defer.resolve();
            } );
        } ).catch( function () {
            defer.reject();
        } );
        return defer.promise;
    },

    updateFeature: function () {
        var self = this;
        var defer = P.defer();

        this.setAutomaticAttributes( true ); // to update

        this._layerSelected.update( VectorLayerUtils.UPDATE_FEATURE, this._featureSelected ).then( function () {
            // Now, we don't need to wait for layers rendered because nobody is calling to refresh layer simultaneously.
            // But, it is more reliable
            Registry.getInstance().getController( 'Layer' ).refreshLayerInAllViews( self._layerSelected ).then( function () {
                defer.resolve();
            } );
        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    deleteFeature: function () {
        var defer = P.defer();
        var self = this;
        this._layerSelected.update( VectorLayerUtils.DELETE_FEATURE, this._featureSelected ).then( function () {

            self._featureSelected = undefined;

            // We wait for layers have been rendered to avoid that they would be rendered at same time.
            Registry.getInstance().getController( 'Layer' ).refreshLayerInAllViews( self._layerSelected ).then( function () {
                defer.resolve();
            } );

        } ).catch( function () {
            defer.reject();
        } );

        return defer.promise;
    },

    updateCameraFeature: ( function () {

        var eye = osg.vec3.create();
        var center = osg.vec3.create();
        var up = osg.vec3.create();
        var distance;

        return function () {
            var camera = this._viewer.getCamera();
            var matrix = camera.getViewMatrix();

            osg.mat4.getLookAt( eye, center, up, matrix, distance );

            this._featureSelected.setAttributeByName( 'cameraEyeX', eye[ 0 ] );
            this._featureSelected.setAttributeByName( 'cameraEyeY', eye[ 1 ] );
            this._featureSelected.setAttributeByName( 'cameraEyeZ', eye[ 2 ] );

            this._featureSelected.setAttributeByName( 'cameraCenterX', center[ 0 ] );
            this._featureSelected.setAttributeByName( 'cameraCenterY', center[ 1 ] );
            this._featureSelected.setAttributeByName( 'cameraCenterZ', center[ 2 ] );

            this._featureSelected.setAttributeByName( 'cameraUpX', up[ 0 ] );
            this._featureSelected.setAttributeByName( 'cameraUpY', up[ 1 ] );
            this._featureSelected.setAttributeByName( 'cameraUpZ', up[ 2 ] );
        };

    } )(),

    updateGISGeometry: function () {
        // Update the GEOMETRY (we do it according to the geometry type)
        var g, vertexBufferArraySketch, vertices;

        g = this._featureSelected.getGeometry();
        vertexBufferArraySketch = this._geometrySelected.getVertexAttributeList().Vertex;
        vertices = vertexBufferArraySketch.getElements();

        // We can have MT above in the scenegraph. So, for setting the correct x,y,z values we have 2 options:
        // 1. Apply to the previous value, the difference of the vertices (We need to had stored the original geometry to avoid issues when multiple editions before updating DB)
        // 2. Apply vertices + MT (above the graph) (It is not enough to add the viewer center as we used to do) -> Current implementation

        let nodePath = Utils.computeNodePath( this._geometrySelected.getParents()[ 0 ] );
        let mt = osg.computeLocalToWorld( nodePath, true );
        let vecTransformed = osg.vec3.create64();
        osg.vec3.transformMat4( vecTransformed, [ vertices[ this._vertexSelected * 3 ], vertices[ this._vertexSelected * 3 + 1 ], vertices[ this._vertexSelected * 3 + 2 ] ], mt );
        osg.vec3.add( vecTransformed, vecTransformed, this._viewer.getCenter() );
        switch ( this._featureSelected.getLayer().getGeometryType() ) {

        case FeatureDefinition.POINT:
            g.setX( vecTransformed[ 0 ] );
            g.setY( vecTransformed[ 1 ] );
            g.setZ( vecTransformed[ 2 ] );

            break;
        case FeatureDefinition.MULTIPOINT:
            g.getGeometry( this._vertexSelected ).setX( vecTransformed[ 0 ] );
            g.getGeometry( this._vertexSelected ).setY( vecTransformed[ 1 ] );
            g.getGeometry( this._vertexSelected ).setZ( vecTransformed[ 2 ] );

            break;
        case FeatureDefinition.LINE:
            g.setX( this._vertexSelected, vecTransformed[ 0 ] );
            g.setY( this._vertexSelected, vecTransformed[ 1 ] );
            g.setZ( this._vertexSelected, vecTransformed[ 2 ] );

            break;
        case FeatureDefinition.POLYGON:
            //FIXME: only for exterior ring
            let extRing = g.getExteriorRing();
            if ( extRing.isClosed() )
                extRing.removeLastPoint();

            extRing.setX( this._vertexSelected, vecTransformed[ 0 ] );
            extRing.setY( this._vertexSelected, vecTransformed[ 1 ] );
            extRing.setZ( this._vertexSelected, vecTransformed[ 2 ] );

            extRing.closeRings();
            break;
        }

        this._featureSelected.setGeometry( g );

        this._selectionObjectController.setSelectionObject( this._selectionObject ); // to force an applyAsync in the Properties Widget
    },

    // We can optimize this method updating only the selected vertex.
    updateOSGGeometry: function () {
        var g, vertexBufferArraySketch, vertices;
        var i, j;

        g = this._featureSelected.getGeometry();
        vertexBufferArraySketch = this._geometrySelected.getVertexAttributeList().Vertex;
        vertices = vertexBufferArraySketch.getElements();

        if ( this._featureSelected.getLayer().getGeometryType() === FeatureDefinition.POINT ) {
            vertices[ this._vertexSelected * 3 ] = g.getX() - this._viewer.getCenter()[ 0 ];
            vertices[ this._vertexSelected * 3 + 1 ] = g.getY() - this._viewer.getCenter()[ 1 ];
            vertices[ this._vertexSelected * 3 + 2 ] = g.getZ() - this._viewer.getCenter()[ 2 ];
        } else if ( this._featureSelected.getLayer().getGeometryType() === FeatureDefinition.MULTIPOINT ) {
            for ( i = 0, j = 0; i < g.getNumGeometries(); i++, j += 3 ) {
                vertices[ j ] = g.getGeometry( i ).getX() - this._viewer.getCenter()[ 0 ];
                vertices[ j + 1 ] = g.getGeometry( i ).getY() - this._viewer.getCenter()[ 1 ];
                vertices[ j + 2 ] = g.getGeometry( i ).getZ() - this._viewer.getCenter()[ 2 ];
            }
        } else if ( this._featureSelected.getLayer().getGeometryType() === FeatureDefinition.LINE ) {
            for ( i = 0, j = 0; i < g.getNumPoints(); i++, j += 3 ) {
                vertices[ j ] = g.getX( i ) - this._viewer.getCenter()[ 0 ];
                vertices[ j + 1 ] = g.getY( i ) - this._viewer.getCenter()[ 1 ];
                vertices[ j + 2 ] = g.getZ( i ) - this._viewer.getCenter()[ 2 ];
            }
        } else if ( this._featureSelected.getLayer().getGeometryType() === FeatureDefinition.POLYGON ) {
            //FIXME: only for exterior ring
            for ( i = 0, j = 0; i < g.getExteriorRing().getRenderingPoints().length; i++, j += 3 ) {
                vertices[ j ] = g.getExteriorRing().getRenderingPoints()[ i ][ 0 ] - this._viewer.getCenter()[ 0 ];
                vertices[ j + 1 ] = g.getExteriorRing().getRenderingPoints()[ i ][ 1 ] - this._viewer.getCenter()[ 1 ];
                vertices[ j + 2 ] = g.getExteriorRing().getRenderingPoints()[ i ][ 2 ] - this._viewer.getCenter()[ 2 ];
            }
        }
        vertexBufferArraySketch.dirty();
    },

    getFeatureSelected: function () {
        return this._featureSelected;
    },

    setSelectedFeature: function ( feature ) {
        this._featureSelected = feature;
    },

    setSelectedVertex: function ( v ) {
        this._vertexSelected = v;

        this._sketchTool.setVertex( v );

        if ( this._modeAddPoint ) {
            this._sketchTool._tempNode.removeChildren();
            this._sketchTool.drawVertices( true );
            this._sketchTool.drawSelectedVertex();
        }
    },

    clearTool: function () {
        PickTool.prototype.clearTool.call( this );
        this._firstPoint = true;
        this._geometrySelected = undefined;
        this._modeAddPoint = false;
    },

    clearTemporaryFeatures: function ( onlySketchTool ) {
        if ( !onlySketchTool )
            this.clearTool();
        this._sketchTool.clearTool();
    },

    /**
     * Checks if the geometry of the selected feature is different now than when the edition started.
     * @method
     * @memberof pcvizTools.LayerEditionTool
     * @return {Boolean} true if the geometry is different than before or false if it's equal
     */
    isGeometryDirty: function () {
        // if the user is adding new points to a feature
        if ( this._modeAddPoint === true && this._currentHitPosition || this._removedPoint )
            return true;

        // if the user is editing exiting points
        return this._sketchTool.isGeometryDirty();
    },

    enableAddPointMode: function () {
        this._modeAddPoint = true;
        this._geometrySelected = this._layerSelected.getFeatureRenderer().getSymbol().getGeometryFeature( this._featureSelected );

        // Draw the vertices
        this._sketchTool.setFeature( this._featureSelected ); // We need to set the feature because sketchTool needs to know what type of geometry we're editing.
        this._sketchTool.setGeometrySelected( this._geometrySelected );
        this._sketchTool._tempNode.removeChildren();
        this._sketchTool.drawVertices( true );
        this._sketchTool.drawSelectedVertex();

        this.setUpEventListeners();

        this._selectionObject = this._selectionObjectController.getSelectionObject();
    },

    disableAddPointMode: function () {
        this._modeAddPoint = false;
        this._removedPoint = false;
    },

    /**
     * Method to prepare the geometry of the selected feature to be edited by gizmos.
     * @method
     * @memberof pcvizTools.LayerEditionTool
     */
    editGeometrySketch: function () {
        this._geometrySelected = this._layerSelected.getFeatureRenderer().getSymbol().getGeometryFeature( this._featureSelected );

        if ( this._layerSelected.getGeometryType() === FeatureDefinition.LINE ) {
            this._layerSelected.getFeatureRenderer().getSymbol().getVisualGeometryFeature( this._featureSelected ).setCullCallback( this._geometrySelected.getCullCallback() );
            this._geometrySelected.setCullCallback( undefined );
        }

        this._sketchTool.setFeature( this._featureSelected ); // We need to send the feature because we need to know in sketchTool what type of geometry we're editing.
        this._sketchTool.setGeometrySelected( this._geometrySelected );
        this._sketchTool.editSelectedGeometry();

        // we have to add the event listeners to allow changing the vertex position by shift+click
        this.setUpEventListeners();

        this._featureSelected.getGeometry().setGeometryEditedCallback( this.updateOSGGeometry.bind( this ) );

        this._selectionObject = this._selectionObjectController.getSelectionObject();
    },

    /**
     * Method to manage the mouseup or tap ( for touchable devices ) action.
     * @method
     * @memberof pcvizTools.LayerEditionTool
     */
    doMouseupOrTapAction: function () {

        // create a feature when the user does the first click
        if ( this._firstPoint === true ) {
            this._sketchTool.clearTool(); // To ensure that the sketchTool is cleared. (Because if you previously were creating a feature and you clicked the escape key, this tool is dirty)
            this.setSelectedFeature( this.createFeature() );
            this._firstPoint = false;
            return;
        }

        // create the new point
        var j = this._positionsArray.length - 1;
        var p = this.createPoint( this._positionsArray[ j ] );

        // add the new point to the feature
        this.addPoint( p );

        // selecting the new vertex
        this._selectionObject.setVertex( j - 1 );
        this._featureSelected.getGeometry().changeSelectedPropertyField( j - 1 );

        this._selectionObjectController.setSelectionObject( this._selectionObject ); // to force an applyAsync in the Properties Widget
    },

    /**
     * Method to manage the escape key action.
     * @method
     * @memberof pcvizTools.LayerEditionTool
     */
    doEscapeAction: function () {
        if ( this._positionsArray !== undefined && this._positionsArray.length > 1 && !( Utils.isTouchEnabled() ) ) {
            this._positionsArray.pop();
        }
    },

    drawFeature: function () {
        if ( !this.isEscapeKeyEvent() && !this.isDblClickOrTapEvent() ) {
            if ( this._positionsArray !== undefined ) {
                if ( this._positionsArray.length > 1 )
                    this._positionsArray.pop();
                this._positionsArray.push( this._currentHitPosition );
            }
        } else {
            this.doEscapeAction();
        }

        //set the feature to be painted
        this._sketchTool.setFeature( this._featureSelected );
        if ( this._layerSelected.getFeatureDefinition().getGeomFieldType() === FeatureDefinition.POINT )
            this._sketchTool.setPositionsArray( [ this._lastHitPosition ] );
        else
            this._sketchTool.setPositionsArray( this._positionsArray );
        this._sketchTool.update();

        if ( this.isEscapeKeyEvent() || this.isDblClickOrTapEvent() )
            this.clearTool();
    },

    update: function () {
        if ( !this.isToolActive() )
            return;
        // If typeEvent is 'mouseup', the mouse position when 'mousedown' is equal to the mouse position when 'mouseup'.
        // We needn't the screenX/Y variables.
        if ( this.isMouseupOrTapEvent() ) {
            this.doMouseupOrTapAction();
        }

        if ( ( this._currentHitPosition !== undefined ) && ( this._lastHitPosition !== undefined ) ) {
            this.drawFeature();
        }
        this._typeEvent = undefined;
    },

    setLayerSelected: function ( layer ) {
        this._layerSelected = layer;
    },

    getLayerSelected: function () {
        return this._layerSelected;
    },

    getView: function () {
        return this._view;
    },

    /**
     * Create a new point in the position indicated
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     * @param {array} position the coordinates for the new Point
     * @return {pcvizGIS.Point} the new point created
     */
    createPoint: function ( position ) {
        var px = position[ 0 ] + this._viewer.getCenter()[ 0 ];
        var py = position[ 1 ] + this._viewer.getCenter()[ 1 ];
        var pz = position[ 2 ] + this._viewer.getCenter()[ 2 ];

        return ( new Point( px, py, pz ) );
    },

    /**
     * Add a new point to the selected feature after the last point
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     * @param {pcvizGIS.Point} p the point to be added
     */
    addPoint: function ( p ) {
        var geometry = this._featureSelected.getGeometry();

        switch ( this._featureSelected.getLayer().getFeatureDefinition().getGeomFieldType() ) {

        case FeatureDefinition.POINT:
            // We move the point to this new position
            geometry.setX( p.getX() );
            geometry.setY( p.getY() );
            geometry.setZ( p.getZ() );
            break;
        case FeatureDefinition.MULTIPOINT:
            geometry.addGeometry( p );
            break;
        case FeatureDefinition.LINE:
            geometry.addPoint( p );
            break;
        case FeatureDefinition.POLYGON:
            geometry.getExteriorRing().addPoint( p );
            break;
        }
    },

    /**
     * Insert a new point to the selected feature after the selected vertex
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     * @param {pcvizGIS.Point} p the point to be added
     */
    insertPoint: function ( p ) {
        var geometry = this._featureSelected.getGeometry();

        switch ( this._featureSelected.getLayer().getFeatureDefinition().getGeomFieldType() ) {
        case FeatureDefinition.MULTIPOINT:
            // if we want to add the geometry at the end, use the addGeometry method
            geometry.insertGeometry( p, this._vertexSelected + 1 );
            break;
        case FeatureDefinition.LINE:
            geometry.insertPoint( p, this._vertexSelected + 1 );
            break;
        case FeatureDefinition.POLYGON:
            var isClosed = geometry.getExteriorRing().isClosed();
            if ( isClosed )
                geometry.getExteriorRing().removeLastPoint();
            geometry.getExteriorRing().insertPoint( p, this._vertexSelected + 1 );
            if ( isClosed )
                geometry.getExteriorRing().closeRings();
            break;
        }
    },

    /**
     * Remove a point from the selected feature according to the selected vertex
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     */
    removePoint: function () {
        this._removedPoint = true;
        var geometry = this._featureSelected.getGeometry();

        switch ( this._featureSelected.getLayer().getFeatureDefinition().getGeomFieldType() ) {
        case FeatureDefinition.MULTIPOINT:
            geometry.removeGeometryAt( this._vertexSelected );
            break;
        case FeatureDefinition.LINE:
            geometry.removePointAt( this._vertexSelected );
            break;
        case FeatureDefinition.POLYGON:
            geometry.getExteriorRing().removePointAt( this._vertexSelected );
            break;
        }

        this.refreshFeatureGeometry();

        var numFeaturePoints;
        if ( this._layerSelected.getGeometryType() === FeatureDefinition.LINE || this._layerSelected.getGeometryType() === FeatureDefinition.MULTIPOINT )
            numFeaturePoints = this._featureSelected.getGeometry().getNumPoints();
        else if ( this._layerSelected.getGeometryType() === FeatureDefinition.POLYGON )
            numFeaturePoints = this._featureSelected.getGeometry().getExteriorRing().getRenderingPoints().length;

        // selecting the next vertex
        if ( this._vertexSelected >= numFeaturePoints )
            this._vertexSelected = 0;
        this.setSelectedVertex( this._vertexSelected );
        this._selectionObject.setVertex( this._vertexSelected );
        this._featureSelected.getGeometry().changeSelectedPropertyField( this._vertexSelected );

        this._selectionObjectController.setSelectionObject( this._selectionObject ); // to force an applyAsync in the Properties Widget
    },

    /**
     * Refresh the geometry selected and reinitialize the relative variables. Use edition color because this function is called when the geometry is being edited.
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     */
    refreshFeatureGeometry: function () {
        // render the feature to get the new geometry, and replace it
        var symbol = this._layerSelected.getFeatureRenderer().getSymbol();
        var sceneGraph = symbol.getSceneGraph();

        sceneGraph.removeChild( this._geometrySelected );

        if ( this._layerSelected.getGeometryType() === FeatureDefinition.LINE ) {
            var visualGeom = symbol.getVisualGeometryFeature( this._featureSelected );
            sceneGraph.removeChild( visualGeom );
        }

        // if a point has been added or remove from a multipoint, the markers of this feature must be refreshed because of the userData needs to be refreshed
        if ( symbol.getMarkersFeature ) {
            var markersFeature = symbol.getMarkersFeature( this._featureSelected );
            for ( var i = 0; i < markersFeature.length; i++ )
                sceneGraph.removeChild( markersFeature[ i ] );

            symbol.drawMarkersFeature( this._featureSelected, this._layerSelected, this._layerSelected.getSelectedFeatures(), this._layerSelected.computeCenter( true ) );
        }

        symbol.setFeatureInvalidation( true );
        let newGeom = symbol.renderFeature( this._featureSelected, this._layerSelected, this._layerSelected.getSelectedFeatures(), this._layerSelected.computeCenter( true ), sceneGraph );
        sceneGraph.addChild( newGeom.geometry );
        this._geometrySelected = newGeom.geometry;
        this._sketchTool.setGeometrySelected( this._geometrySelected );

        // to use edition color (we could avoid this, if we stored a list of features in edition in the layer object as the list of selected features)
        symbol.editFeature( this._featureSelected );
    },

    /**
     * Translate the selected vertex to the position where the user has been clicked
     * @method
     * @memberof pcvizGIS.LayerEditionTool
     */
    moveSelectedVertex: function () {
        var vertexElements = this._geometrySelected.getVertexAttributeList().Vertex.getElements();

        let nodePath = Utils.computeNodePath( this._geometrySelected.getParents()[ 0 ] );
        let mt = osg.computeLocalToWorld( nodePath, true );
        let invertedMT = osg.mat4.invert( osg.mat4.create64(), mt );
        let vecTransformed = osg.vec3.create64();
        osg.vec3.transformMat4( vecTransformed, this._currentHitPosition, invertedMT );

        vertexElements[ this._vertexSelected * 3 ] = vecTransformed[ 0 ];
        vertexElements[ this._vertexSelected * 3 + 1 ] = vecTransformed[ 1 ];
        vertexElements[ this._vertexSelected * 3 + 2 ] = vecTransformed[ 2 ];

        this._geometrySelected.dirty();
        this._geometrySelected.getVertexAttributeList().Vertex.dirty();

        this.updateGISGeometry();
    },

    finishCurrentEdition: function () {
        this._dblclickFunction();
        this._sketchTool.update();
    },

    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;

        this._mouseupFunction = function ( ev ) {

            try {
                if ( !self.isToolActive() && ( self._geometrySelected === undefined ) )
                    return;

                // if the current mouse position isn't equal than the mouse position when mousedown event ocurred,
                // it's a drag event
                var x = ev.clientX;
                var y = ev.clientY;

                if ( self.isDrag( x, y ) ) {
                    self.mousePosX = 0.0;
                    self.mousePosY = 0.0;

                    // if there's a geometry selected and the tool isn't active, it can be that the gizmo has been dragged, so we update the GIS geometry
                    if ( self._geometrySelected !== undefined && !self.isToolActive() )
                        self.updateGISGeometry();
                    return;
                }

                if ( ev.button !== 0 )
                    return;

                if ( self.isToolActive() ) {

                    if ( self._currentHitPosition === undefined )
                        return;

                    self._typeEvent = 'mouseup';

                    if ( self._positionsArray === undefined )
                        self._positionsArray = [];

                    // add the current position to positionsArray
                    self.addPosition( self._currentHitPosition );

                    // updating last position to current position
                    self._lastHitPosition = self._currentHitPosition;

                    return;
                }

                if ( ( self._geometrySelected !== undefined && ev.shiftKey ) || self._modeAddPoint ) {
                    var hits = self._viewer.computePolytopeIntersections( ev );

                    if ( hits.length === 0 )
                        return;

                    for ( var i = 0; i < hits.length; i++ )
                        if ( hits[ i ]._nodePath ) {
                            var detail = self._viewer.createHitEventStructure( ev, hits[ i ], x, y );
                            self._currentHitPosition = osg.vec3.sub( osg.vec3.create32(), detail.coordinate, detail.sceneCenter );

                            if ( !self._modeAddPoint ) {
                                self.moveSelectedVertex();
                                return;
                            }

                            // If the event has this property equal to true, it comes from the InformationTool and the mouseup was used to select a vertex. So, we don't want to add a new point at this position.
                            if ( ev.pickedLayer )
                                return;

                            var p = self.createPoint( self._currentHitPosition ); // create the new point

                            self.insertPoint( p ); // add the new point to the feature (at the right position)

                            self.refreshFeatureGeometry();

                            // selecting the new vertex
                            self._vertexSelected++;
                            self.setSelectedVertex( self._vertexSelected );
                            self._selectionObject.setVertex( self._vertexSelected );
                            self._featureSelected.getGeometry().changeSelectedPropertyField( self._vertexSelected );

                            self._selectionObjectController.setSelectionObject( self._selectionObject ); // to force an applyAsync in the Properties Widget
                            return;
                        }
                }
            } finally {
                ev.stopPropagation(); //
            }
        };

        this._mousedownFunction = function ( ev ) {

            if ( ( self._geometrySelected !== undefined ) || self.isToolActive() ) {

                // save the mouse position to check if there's a drag event
                self.mousePosX = ev.clientX;
                self.mousePosY = ev.clientY;

                self.drawPickingElement( undefined );

                ev.stopPropagation();
            }
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;
            if ( self._typeEvent === 'mouseup' && !( Utils.isTouchEnabled() ) ) {
                self._positionsArray.pop();
            }

            self._typeEvent = 'dblclick';

            if ( self._enableDispatch ) {
                self.dispatchData();
            }

            if ( !ev )
                return;
            ev.stopPropagation();
        };

        this._pickFunction = function ( ev ) {
            if ( !self.isToolActive() && !( self._geometrySelected && ( Utils.isTouchEnabled() ) ) )
                return;

            // if hit is undefined the draw function will remove the element from the dom
            self.drawPickingElement( ev.detail.hit );

            if ( ev.detail.hit === undefined ) {
                self._currentHitPosition = undefined;
                return;
            }

            self._currentHitPosition = osg.vec3.sub( osg.vec3.create32(), ev.detail.coordinate, ev.detail.sceneCenter );
            self._hit = ev.detail.hit;
            self._position = ev.detail.coordinate;

            // we make this only when the touch events are enabled
            if ( !( Utils.isTouchEnabled() ) )
                return;
            self._typeEvent = 'pick';
            self._lastHitPosition = self._currentHitPosition;
            if ( self._positionsArray === undefined )
                self._positionsArray = [];

            // add the current position to positionsArray
            self.addPosition( self._currentHitPosition );
        };

    },

    setUpEventListeners: function () {
        PickTool.prototype.setUpEventListeners.call( this );
        if ( ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) {
            this._touchEndFunction = this._touchEndFunction.bind( this );
            this._touchStartFunction = this._touchStartFunction.bind( this );
            let canvas = this._viewer.getCanvas();
            canvas.addEventListener( 'touchend', this._touchEndFunction );
            canvas.addEventListener( 'touchstart', this._touchStartFunction );

            this._pixelsMargin = 5;
        }
    },

    _touchStartFunction: function ( ev ) {
        if ( this.isToolActive() || ( this._geometrySelected === undefined ) )
            return;
        this.mousePosX = ev.changedTouches[ 0 ].clientX;
        this.mousePosY = ev.changedTouches[ 0 ].clientY;
    },

    _touchEndFunction: function ( ev ) {
        if ( !this.isToolActive() && ( this._geometrySelected === undefined ) )
            return;
        if ( !this.isDrag( ev.changedTouches[ 0 ].clientX, ev.changedTouches[ 0 ].clientY ) )
            return;
        // if there's a geometry selected and the tool isn't active, it can be that the gizmo has been dragged, so we update the GIS geometry
        if ( this._geometrySelected !== undefined && !this.isToolActive() )
            this.updateGISGeometry();
    },

    removeEventListeners: function () {
        PickTool.prototype.removeEventListeners.call( this );
        if ( ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) {
            let canvas = this._viewer.getCanvas();
            canvas.removeEventListener( 'touchend', this._touchEndFunction );
            canvas.removeEventListener( 'touchstart', this._touchStartFunction );
        }
    }

} );

module.exports = LayerEditionTool;


/***/ }),

/***/ "./sources/pcvizTools/LayerTransformTool.js":
/*!**************************************************!*\
  !*** ./sources/pcvizTools/LayerTransformTool.js ***!
  \**************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return LayerTransformTool; });
/* harmony import */ var pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/GizmoTool */ "./sources/pcvizTools/GizmoTool.js");




/**
 *  LayerTransform tool
 *  @class
 *  @memberof pcvizTools
 *  @extends GizmoTool
 */
class LayerTransformTool extends pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_0__["default"] {

    constructor( sceneView ) {
        super( sceneView, 'layerTransform' );

        this.enableRegisterInObjectController( false );
    }

    setLayerNode( pickedLayer, layerNode ) {

        if ( !this._active )
            return false;

        this._layerGizmo.connectToLayerNode( pickedLayer, layerNode );
        return true;
    }

    setActive( active ) {

        if ( this._active === active )
            return;

        this._active = active;

        if ( !active ) {
            this.enableOtherTools( true );
            this._layerGizmo.disconnectFromLayerNode();
        } else {
            this.enableOtherTools( false );
        }
        this._layerGizmo.setToolIsActive( active );
    }

    update( /*viewer*/) {
        if ( !this.isToolActive() )
            return;

    }

    setGizmoMask( handleVis ) {
        this._layerGizmo.setGizmoMask( handleVis );
    }

    getGizmoMask() {
        return this._layerGizmo.getGizmoMask();
    }

    getPickPivotMode() {
        return this._layerGizmo.getPickPivotMode();
    }

    setPickPivotMode( mode ) {
        this._layerGizmo.setPickPivotMode( mode );
    }

    getHasLastMovement() {
        return this._layerGizmo.getHasLastMovement();
    }

    undoLastMovement() {
        this._layerGizmo.undoLastMovement();
    }

    setCurrentTransformConfig( xformconfig ) {
        this._layerGizmo.setCurrentTransformConfig( xformconfig );
    }

    resetTransform( resetTranslation, resetAngles, resetScale ) {
        this._layerGizmo.resetTransform( resetTranslation, resetAngles, resetScale );
    }

    setLayerGizmoMode( mode ) {
        this._layerGizmo.setMode( mode );
    }

    resetGizmoGraph() {
        this._layerGizmo.resetGraph();
    }

    disconnectGizmo() {
        this._layerGizmo.disconnectFromLayerNode();
    }

    resetLastMovement() {
        this._layerGizmo.resetLastXFormMat();
    }
}


/***/ }),

/***/ "./sources/pcvizTools/PaintTool.js":
/*!*****************************************!*\
  !*** ./sources/pcvizTools/PaintTool.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PaintTool; });
const DEFAULT_TEXT_SIZE = 15;
const DEFAULT_COLOR = '#007dc5';
const DEFAULT_LINE_WIDTH = 2;

class PaintTool {
    constructor( idContainer, width, height, imgBackground, defaultLabelText ) {

        this.createCanvas( idContainer, width, height );

        //Default properties:
        this.drawing = false;
        this.currentPoint = { x: 0, y: 0 };
        this.color = DEFAULT_COLOR;
        this.lineWidth = DEFAULT_LINE_WIDTH;
        this.textSize = DEFAULT_TEXT_SIZE;
        this.text = defaultLabelText;
        this.currentActionForPaint = undefined;

        this._refreshUIFn = undefined;

        this.redoList = [];
        this.undoList = [];

        // Set Background Image
        this.setImage( imgBackground );

        // Set up mouse event listeners
        this.canvasAux.addEventListener( 'mousedown', e => {
            // Start drawing
            const point = { x: e.offsetX, y: e.offsetY };
            this.currentPoint = point;
            this.drawing = true;
            this.saveState();
            if ( this._refreshUIFn ) {
                this._refreshUIFn();
            }
        } );

        this.canvasAux.addEventListener( 'mousemove', e => {
            if ( this.drawing ) {
                const point = { x: e.offsetX, y: e.offsetY };
                this.draw( point );
                if ( this.isActionDrawPath() ) {
                    // Update current point
                    this.currentPoint = point;
                }
            }
        } );

        this.canvasAux.addEventListener( 'mouseup', e => {
            if ( this.drawing ) {
                const point = { x: e.offsetX, y: e.offsetY };
                this.draw( point );
                if ( !this.isActionDrawPath() ) {
                    // finish drawing
                    this.clear( this.getContextAux() );
                    this.drawInContext( this.getContext(), point );
                }
                this.currentPoint = { x: 0, y: 0 };
                this.drawing = false;
            }
        } );
    }

    createCanvas( idContainer, width, height ) {
        this.canvas = document.createElement( 'canvas' );
        this.canvas.id = 'canvasScreenShot';
        this.canvas.style.zIndex = 1;
        this.canvas.style.position = 'absolute';
        this.canvas.style.left = '0';
        this.canvas.style.border = '1px solid black';
        document.getElementById( idContainer ).appendChild( this.canvas );

        this.canvasAux = document.createElement( 'canvas' );
        this.canvasAux.id = 'canvasScreenShotAux';
        this.canvasAux.style.zIndex = 2;
        this.canvasAux.style.position = 'absolute';
        this.canvasAux.style.left = '0';
        this.canvasAux.style.border = '1px solid black';
        document.getElementById( idContainer ).appendChild( this.canvasAux );

        this.setDimensionsCanvas( width, height );
    }

    setDimensionsCanvas( width, height ) {
        this.width = width;
        this.height = height;
        this.canvas.width = this.width;
        this.canvas.style.width = this.width;
        this.canvasAux.width = this.width;
        this.canvasAux.style.width = this.width;

        this.canvas.height = this.height;
        this.canvas.style.height = this.height;
        this.canvasAux.height = this.height;
        this.canvasAux.style.height = this.height;
    }

    setImage( image ) {
        let img = new Image();
        img.src = image;
        img.onload = () => {
            this.clear( this.getContext() );
            this.getContext().drawImage( img, 0, 0, this.width, this.height, 0, 0, this.width, this.height );
        };
    }

    setRefreshUIFn( fn ) {
        this._refreshUIFn = fn;
    }

    getContext() {
        return this.canvas.getContext( '2d' );
    }

    getContextAux() {
        return this.canvasAux.getContext( '2d' );
    }

    clear( context ) {
        context.clearRect( 0, 0, this.width, this.height );
    }

    setPropertiesContextCanvas( context ) {
        context.strokeStyle = this.color;
        context.fillStyle = this.color;
        context.lineWidth = this.lineWidth;
        context.font = this.textSize + 'px Arial';
        context.lineCap = 'round';
    }

    drawLine( context, point1, point2 ) {
        this.setPropertiesContextCanvas( context );
        context.beginPath();
        context.moveTo( point1.x, point1.y );
        context.lineTo( point2.x, point2.y );
        context.stroke();
        context.closePath();
    }

    drawText( context, point1, point2 ) {
        this.setPropertiesContextCanvas( context );
        context.save();
        context.translate( point1.x, point1.y );
        const angle = Math.atan2( point2.y - point1.y, point2.x - point1.x );
        context.rotate( angle );
        context.textBaseline = 'bottom';
        context.fillText( this.text, 0, 5 );
        context.restore();
    }

    drawSquare( context, point1, point2 ) {
        this.setPropertiesContextCanvas( context );
        let x0 = Math.min( point1.x, point2.x );
        let y0 = Math.min( point1.y, point2.y );
        let sizeX = Math.abs( point1.x - point2.x );
        let sizeY = Math.abs( point1.y - point2.y );
        if ( this.isActionSquareFilled() ) {
            context.globalAlpha = 0.2;
            context.fillRect( x0, y0, sizeX, sizeY );
            context.globalAlpha = 1;
        } else {
            context.beginPath();
            context.rect( x0, y0, sizeX, sizeY );
            context.stroke();
        }
    }

    drawArrow( context, point1, point2 ) {
        this.drawLine( context, point1, point2 );
        context.beginPath();
        // Draw arroy head
        const dx = point2.x - point1.x;
        const dy = point2.y - point1.y;
        const angle = Math.atan2( dy, dx );
        const headLength = this.lineWidth + 10; // length of head in pixels
        context.moveTo( point2.x - headLength * Math.cos( angle - Math.PI / 6 ), point2.y - headLength * Math.sin( angle - Math.PI / 6 ) );
        context.lineTo( point2.x, point2.y );
        context.lineTo( point2.x - headLength * Math.cos( angle + Math.PI / 6 ), point2.y - headLength * Math.sin( angle + Math.PI / 6 ) );
        context.stroke();
    }

    draw( pointEnd ) {
        if ( this.isActionDrawPath() ) {
            this.drawLine( this.getContext(), this.currentPoint, pointEnd );
        } else {
            this.clear( this.getContextAux() );
        }
        this.drawInContext( this.getContextAux(), pointEnd );
    }

    drawInContext( context, pointEnd ) {
        if ( this.isActionLine() ) {
            this.drawLine( context, this.currentPoint, pointEnd );
        }
        if ( this.isActionSquare() || this.isActionSquareFilled() ) {
            this.drawSquare( context, this.currentPoint, pointEnd );
        }
        if ( this.isActionArrow() ) {
            this.drawArrow( context, this.currentPoint, pointEnd );
        }
        if ( this.isActionText() ) {
            this.drawText( context, this.currentPoint, pointEnd );
        }
    }

    downloadImage( nameFile ) {
        const link = document.createElement( 'a' );
        if ( nameFile ) {
            link.download = nameFile;
        } else {
            link.download = 'screenshot.png';
        }
        link.href = this.canvas.toDataURL();
        link.click();
    }

    isActionDrawPath() {
        return this.currentActionForPaint.id === 'pencil';
    }

    isActionLine() {
        return this.currentActionForPaint.id === 'line';
    }

    isActionSquare() {
        return this.currentActionForPaint.id === 'rectangle';
    }

    isActionSquareFilled() {
        return this.currentActionForPaint.id === 'fillRectangle';
    }

    isActionArrow() {
        return this.currentActionForPaint.id === 'arrow';
    }

    isActionText() {
        return this.currentActionForPaint.id === 'label';
    }

    /***************************************
     *  Methods for History (Undo and Redo) 
     * ************************************/
    saveState( list, keepRedo ) {
        keepRedo = keepRedo || false;
        if ( !keepRedo ) {
            this.redoList = [];
        }
        ( list || this.undoList ).push( this.canvas.toDataURL() );
    }

    undo() {
        this.restoreState( this.undoList, this.redoList );
    }

    redo() {
        this.restoreState( this.redoList, this.undoList );
    }

    restoreState( listPop, listPush ) {
        if ( listPop && listPop.length ) {
            this.saveState( listPush, true );
            const restoreState = listPop.pop();
            this.setImage( restoreState );
        }
    }
}


/***/ }),

/***/ "./sources/pcvizTools/PickTool.js":
/*!****************************************!*\
  !*** ./sources/pcvizTools/PickTool.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var osg = OSG.osg;
const { EVENT_KEYS } = __webpack_require__( /*! pcvizUtils/EventKeys */ "./sources/pcvizUtils/EventKeys.js" );
/**
 * A tool to provide a picking element and control the events
 * @class
 * @memberof pcvizTools
 * @extends Tool
 */

var PickTool = function ( viewer, id ) {
    Tool.call( this, viewer, id );
    this._active = true; //

    // a div to draw the blue circle
    this._pickingElement = undefined;
    // to enable or disable picking element in mobile devices for some tools
    this._pickingElementEnabled = true;

    // If it has value, the circle will have this color
    this._overwritePickingColor = undefined;

    // the next three variables are in local coordinates (they have substracted the pointCloudScene center from the real position)
    // the current position (this variable represents the same than this._position, but in local coordinates)
    this._currentHitPosition = undefined;
    // the last position clicked
    this._lastHitPosition = undefined;
    // an array of the positions clicked
    this._positionsArray = undefined;

    // these variables are used to check if there's a drag event
    this.mousePosX = 0.0;
    this.mousePosY = 0.0;

    // the intersection
    this._hit = undefined;
    // the real position in the PointCloudScene (world coordinates)
    this._position = undefined;

    // feature for tools
    this._previousFeatureSelected = undefined;
    this._featureSelectedGeomType = undefined;

    // event listeners
    this._mouseupFunction = undefined;
    this._mousedownFunction = undefined;
    this._dblclickFunction = undefined;
    this._dbltapFunction = undefined;
    this._pickFunction = undefined;
    this._mouseoutFunction = undefined;
    this._keydownFunction = undefined;
    this._wheelFunction = undefined;
    this.setUpEventListeners();

    this._typeEvent = undefined;
    this.MAX_LINE_PTS = 49; // shader only supports up to 50 vertices

    this._pixelsMargin = 0;
    if ( ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) && Utils.isEdge() )
        this._pixelsMargin = 5;
};

PickTool.prototype = osg.objectInherit( Tool.prototype, {

    // FIXME: Refactor event listeners functions
    //  onMouseLeftUp = function ( ev ) {

    //   },
    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.PickTool
     */
    declareFunctions: function () {

        // We need to store instance variable to add/remove event listeners
        var self = this;

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // if the current mouse position isn't equal than the mouse position when mousedown event ocurred,
            // it's a drag event, so we don't do anything
            var x = ev.clientX;
            var y = ev.clientY;

            if ( self.isDrag( x, y ) ) {
                self.mousePosX = 0.0;
                self.mousePosY = 0.0;
                return;
            }

            if ( ev.button === 0 ) {

                if ( self._currentHitPosition !== undefined ) {

                    self._typeEvent = 'mouseup';

                    if ( self._positionsArray === undefined )
                        self._positionsArray = [];

                    // add the current position to positionsArray
                    self.addPosition( self._currentHitPosition );

                    // updating last position to current position
                    self._lastHitPosition = self._currentHitPosition;
                }
            }


            ev.stopPropagation(); //
        };

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // save the mouse position to check if there's a drag event
            self.mousePosX = ev.clientX;
            self.mousePosY = ev.clientY;

            self.drawPickingElement( undefined );
            self._featureSelectedGeomType = undefined;

            ev.stopPropagation();
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            self._typeEvent = 'dblclick';

            ev.stopPropagation();
        };

        this._dbltapFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            self._typeEvent = 'dbltap';

            ev.stopPropagation();
        };

        this._pickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // if hit is undefined the draw function will remove the element from the dom
            self.drawPickingElement( ev.detail.hit );

            if ( ev.detail.hit === undefined ) {
                self._currentHitPosition = undefined;
                return;
            }

            var lastPos = self._currentHitPosition;
            self._currentHitPosition = osg.vec3.sub( osg.vec3.create32(), ev.detail.coordinate, ev.detail.sceneCenter );
            self._hit = ev.detail.hit;
            self._position = ev.detail.coordinate;

            // we make this only when the touch events are enabled
            if ( !( Utils.isTouchEnabled() ) )
                return;
            self._typeEvent = 'pick';
            self._lastHitPosition = lastPos;
            if ( self._positionsArray === undefined )
                self._positionsArray = [];

            // add the current position to positionsArray
            self.addPosition( self._currentHitPosition );

        };

        this._mouseoutFunction = function () {
            if ( self._pickingElement !== undefined ) {
                self._pickingElement.style.display = 'none';
            }
        };

        this._keydownFunction = function ( ev ) {
            if ( ev.key === EVENT_KEYS.ESCAPE || ev.key === EVENT_KEYS.ESC ) {
                self._typeEvent = 'escapeKey';
                //self.clearTool();
            }

            ev.stopPropagation();
        };

        this._wheelFunction = function () {
            self._typeEvent = 'wheel';
        };
    },

    isDrag: function ( x, y ) {
        return ( Math.abs( x - this.mousePosX ) > this._pixelsMargin || Math.abs( y - this.mousePosY ) > this._pixelsMargin );
    },

    /**
     * Method to add the event listeners and define the necessary functions if they aren't defined.
     * @method
     * @memberof pcvizTools.PickTool
     */
    setUpEventListeners: function () {
        if ( !this._mouseupFunction || !this._mousedownFunction || !this._dblclickFunction || !this._pickFunction || !this._mouseoutFunction || !this._wheelFunction ) {
            this.declareFunctions();
        }

        var canvas = this._viewer.getCanvas();

        canvas.addEventListener( 'mouseup', this._mouseupFunction );
        canvas.addEventListener( 'mousedown', this._mousedownFunction );
        canvas.addEventListener( 'dblclick', this._dblclickFunction, true );
        canvas.addEventListener( 'pick', this._pickFunction );
        canvas.addEventListener( 'dbltap', this._dbltapFunction, true );
        canvas.addEventListener( 'mouseout', this._mouseoutFunction );
        canvas.addEventListener( 'mousewheel', this._wheelFunction );
        window.addEventListener( 'keydown', this._keydownFunction );
        // To listen wheel event in Firefox
        canvas.addEventListener( 'DOMMouseScroll', this._wheelFunction );

        if ( /iphone|ipod|ipad/.test( window.navigator.userAgent.toLowerCase() ) ) {
            canvas.addEventListener( 'mouseup', this.getDoubleTapIOSFunction(), false );
        }
    },

    getDoubleTapIOSFunction: function () {
        var lastTouchEnd = 0;
        var self = this;
        this._doubleTapIOSFunction = function ( event ) {
            var now = new Date().getTime();
            if ( now - lastTouchEnd <= 600 ) {
                event.preventDefault();
                self._dblclickFunction( event );
            }
            lastTouchEnd = now;
        };
        return this._doubleTapIOSFunction;
    },

    createPickingElement: function () {
        const pickingElement = document.createElement( 'div' );
        const pickingElementWidth = 10;
        const pickingElementHeight = 10;
        const pickingElementBorderWidth = 3;
        this._pickingElementWidthOffset = pickingElementWidth / 2 + pickingElementBorderWidth;
        this._pickingElementHeightOffset = pickingElementHeight / 2 + pickingElementBorderWidth;

        pickingElement.style.width = pickingElementWidth + 'px';
        pickingElement.style.height = pickingElementHeight + 'px';
        pickingElement.style.border = pickingElementBorderWidth + 'px';
        pickingElement.style.borderStyle = 'solid';
        pickingElement.style.position = 'absolute';
        pickingElement.style.display = 'none';
        pickingElement.style.borderRadius = '10px';
        pickingElement.style.pointerEvents = 'none';
        return pickingElement;
    },

    /**
     * Create the picking element if it doesn't exist and return it.
     * @method
     * @memberof pcvizTools.PickTool
     */
    getOrCreatePickingElement: function () {
        var canvas = this._viewer.getCanvas();
        const userPreferencesCtrl = Registry.getController( 'UserPreferences' );
        if ( this._pickingElement === undefined ) {
            this._pickingElement = this.createPickingElement();
            var self = this;
            userPreferencesCtrl.registerListener( ListenerController.PROJECT, Utils.PICKING_CIRCLE_COLOR_KEY, function ( pickingCircleColor ) {
                self._pickingElement.style.borderColor = pickingCircleColor;
            } );

            canvas.parentElement.insertBefore( this._pickingElement, canvas );
        }
        if ( this._overwritePickingColor ) {
            this._pickingElement.style.borderColor = this._overwritePickingColor;
        } else {
            const borderColor = ( userPreferencesCtrl.getPreference( Utils.PICKING_CIRCLE_COLOR_KEY ) !== undefined ) ? userPreferencesCtrl.getPreference( Utils.PICKING_CIRCLE_COLOR_KEY ) : 'blue';
            this._pickingElement.style.borderColor = borderColor;
        }
        return this._pickingElement;
    },

    overwritePickingColor: function ( color ) {
        this._overwritePickingColor = color;
    },

    clearOverwrittenPickingColor: function () {
        if ( this._pickingElement !== undefined )
            this._pickingElement.style.display = 'none';
        this._overwritePickingColor = null;
    },

    /**
     * Method to draw the picking element and updates cursor
     * @method
     * @memberof pcvizTools.PickTool
     * @param {osgUtil.PolytopeIntersector.Intersection} hit the intersection when there's a pick event
     */
    drawPickingElement: function ( hit ) {
        if ( this._pickingElementEnabled ) {
            var pickingElement = this.getOrCreatePickingElement();
            if ( hit === undefined ) {
                pickingElement.style.display = 'none';
                this._viewer.getCanvas().parentElement.style.cursor = 'default';
                return;
            }
            this._viewer.getCanvas().parentElement.style.cursor = 'crosshair';
            this.drawPickingDiv( pickingElement, hit );
        }
    },

    drawPickingDiv: function ( pickingElement, hit ) {
        const pt = Utils.projectToScreen( this._viewer.getCamera(), hit );
        if ( pt[ 1 ] < 0 ) { // don't draw element below 3D view
            pickingElement.style.display = 'none';
            return;
        }
        const ratioX = this._viewer.getCanvas().width / this._viewer.getCanvas().clientWidth;
        const ratioY = this._viewer.getCanvas().height / this._viewer.getCanvas().clientHeight;
        const ptx = parseInt( pt[ 0 ], 10 ) / ratioX;
        const pty = parseInt( this._viewer.getCanvas().height - pt[ 1 ], 10 ) / ratioY;
        pickingElement.style.transform = 'translate3d(' + ( ptx - this._pickingElementWidthOffset ) + 'px,' + ( pty - this._pickingElementHeightOffset ) + 'px, 0)';
        pickingElement.style.display = 'block';
    },

    /**
     * Method to reset the PickTool's properties
     * @method
     * @memberof pcvizTools.PickTool
     */
    clearTool: function () {
        this._currentHitPosition = undefined;
        this._lastHitPosition = undefined;
        this._positionsArray = undefined;

        this.mousePosX = 0.0;
        this.mousePosY = 0.0;

        this._hit = undefined;
        this._position = undefined;

        this._typeEvent = undefined;
        this._previousFeatureSelected = undefined;
    },

    /**
     * Method to add a position to _positionsArray
     * @method
     * @memberof pcvizTools.PickTool
     * @param {osg.vec3} position the position to be added
     */
    addPosition: function ( position ) {
        this._positionsArray[ this._positionsArray.length ] = position;
    },

    /**
     * Method to remove the event listeners added when we were using this tool
     * @method
     * @memberof pcvizTools.PickTool
     */
    removeEventListeners: function () {
        var canvas = this._viewer.getCanvas();

        canvas.removeEventListener( 'mouseup', this._mouseupFunction );
        canvas.removeEventListener( 'mousedown', this._mousedownFunction );
        canvas.removeEventListener( 'dblclick', this._dblclickFunction, true );
        canvas.removeEventListener( 'pick', this._pickFunction );
        canvas.removeEventListener( 'dbltap', this._dbltapFunction, true );
        canvas.removeEventListener( 'mouseout', this._mouseoutFunction );
        window.removeEventListener( 'keydown', this._keydownFunction );
        canvas.removeEventListener( 'mousewheel', this._wheelFunction );
        canvas.removeEventListener( 'DOMMouseScroll', this._wheelFunction );
        canvas.removeEventListener( 'mouseup', this._doubleTapIOSFunction );
    },

    /**
     * @method
     * Enable/disable the picking
     * @memberof pcvizTools.PickTool
     * @param  {bool} true = enable, false= disable
     */
    setPickingEnabled: function ( b ) {

        if ( b && !this._viewer.isPickingEnabled() )
            this._viewer.setPickingEnabled( b );
        else
            this.disablePicking();
    },

    /**
     * @method
     * disable picking if there aren´t any other tool using it
     * @memberof pcvizTools.PickTool
     */
    disablePicking: function () {
        // checking there are any picking tool enabled. If there aren´t any. the picking will be disable
        if ( !this._toolBar.isThereAnyPickingToolActive() )
            this._viewer.setPickingEnabled( false );
    },
    /**
     * @method
     * return true if a double click or tap (only in touch mode) event was made
     * @memberof pcvizTools.PickTool
     */
    isDblClickOrTapEvent: function () {
        return ( this._typeEvent === 'dblclick' || this._typeEvent === 'dbltap' );
    },

    /**
     * @method
     * return true if a mouse up or a tap (only in touch mode) event was made
     * @memberof pcvizTools.PickTool
     */
    isMouseupOrTapEvent: function () {
        return ( this._typeEvent === 'mouseup' || this._typeEvent === 'pick' ); // If _typeEvent == 'pick', touch is started in window
    },

    /**
     * @method
     * return true if a escape key event was made
     * @memberof pcvizTools.PickTool
     */
    isEscapeKeyEvent: function () {
        return ( this._typeEvent === 'escapeKey' );
    },

    /**
     * @method
     * reset the typeEvent property
     * @memberof pcvizTools.PickTool
     */
    resetEvent: function () {
        this._typeEvent = undefined;
    },

    /**
     * @method
     * init selected feature to be used in tool
     * @memberof pcvizTools.PickTool
     */
    initSelectedFeatureUse: function () {
        var selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );

        var selectionObject = selectionObjectController.getSelectionObject();
        if ( selectionObject && selectionObject.getFeature )
            this._previousFeatureSelected = selectionObject.getFeature();

        if ( this._previousFeatureSelected )
            this._featureSelectedGeomType = this._previousFeatureSelected.getLayer().getGeometryType();
    },

    /**
     * @method
     * get position array of selected feature
     * @memberof pcvizTools.PickTool
     */
    getPositionsFromSelectedFeature: function () {
        var geometry = this._previousFeatureSelected.getGeometry();
        this._positions = [];
        var center = this._viewer.getCenter();
        // geometry is a line
        if ( geometry.getNumPoints ) {
            var nPts = geometry.getNumPoints();
            if ( nPts <= this.MAX_LINE_PTS ) {
                for ( var i = 0; i < geometry.getNumPoints(); i++ ) {
                    // for 3d geometries
                    this._positions.push( [ geometry.getX( i ) - center[ 0 ], geometry.getY( i ) - center[ 1 ], geometry.getZ( i ) - center[ 2 ] ] );
                }
            } else {
                this.simplifyLine( geometry, this._positions, center );
                console.log( 'Line exceeds maximum number of points (50). It will be simplified.' );
            }
        } else
            this._positions.push( [ geometry.getX() - center[ 0 ], geometry.getY() - center[ 1 ], geometry.getZ() - center[ 2 ] ] );

        this._positionsArray = this._positions.copyWithin( 0, 0 );
    },

    distanceBetweenPoints: function ( geometry, i ) {
        var difVec = [ geometry.getX( i + 1 ) - geometry.getX( i ), geometry.getY( i + 1 ) - geometry.getY( i ), geometry.getZ( i + 1 ) - geometry.getZ( i ) ];
        return Math.sqrt( difVec[ 0 ] * difVec[ 0 ] + difVec[ 1 ] * difVec[ 1 ] + difVec[ 2 ] * difVec[ 2 ] );
    },

    simplifyLine: function ( geometry, positions, center ) {

        // calculate length
        var npts = geometry.getNumPoints();
        var length = 0;
        for ( var i = 0; i < npts - 1; i++ )
            length += this.distanceBetweenPoints( geometry, i );
        length /= this.MAX_LINE_PTS;

        // sample points
        var lengthFromStart = 0;
        var lastPt = -1;
        for ( i = 0; i < npts - 1; i++ ) {
            lengthFromStart += this.distanceBetweenPoints( geometry, i );
            if ( lengthFromStart > lastPt * length ) {
                this._positions.push( [ geometry.getX( i ) - center[ 0 ], geometry.getY( i ) - center[ 1 ], geometry.getZ( i ) - center[ 2 ] ] );
                lastPt = Math.floor( lengthFromStart / length ) + 1;
            }
        }
        this._positions.push( [ geometry.getX( i ) - center[ 0 ], geometry.getY( i ) - center[ 1 ], geometry.getZ( i ) - center[ 2 ] ] );
    },

    /**
     * @method
     * get the geometry type of the selected feature
     * @memberof pcvizTools.PickTool
     */
    getSelectedFeatureGeometryType: function () {
        return this._featureSelectedGeomType;
    },

    isEditingFeature: function () {
        if ( !this._positionsArray )
            return false;
        return ( this._positionsArray.length > 0 );
    }
} );

module.exports = PickTool;


/***/ }),

/***/ "./sources/pcvizTools/PointEditionTool.js":
/*!************************************************!*\
  !*** ./sources/pcvizTools/PointEditionTool.js ***!
  \************************************************/
/*! exports provided: POINT_SELECTION_MODE, POINT_SELECTION_OPERATION_MODE, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINT_SELECTION_MODE", function() { return POINT_SELECTION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINT_SELECTION_OPERATION_MODE", function() { return POINT_SELECTION_OPERATION_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointEditionTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js");
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js");
/* harmony import */ var pcvizUtils_PointVisibilityManager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizUtils/PointVisibilityManager */ "./sources/pcvizUtils/PointVisibilityManager.js");
/* harmony import */ var pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizUtils/EventKeys */ "./sources/pcvizUtils/EventKeys.js");
/* harmony import */ var pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizUtils/PointVisibleCollector */ "./sources/pcvizUtils/PointVisibleCollector.js");

















const SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );

const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

const POINT_SELECTION_MODE = {
    QUAD: 0,
    POLYGON: 1
};

const POINT_SELECTION_OPERATION_MODE = {
    REPLACE: 0,
    ADD: 1,
    SUBSTRACT: 2,
    INTERSECT: 3
};

const GIZMO_SIZE = 30.0 * window.devicePixelRatio;
const SELECTED_GIZMO_ALPHA = 0.1;
const NEAR_VALUE = 1.0;
const MAX_DEPTH_EXTENT_FACTOR = 2.5;

/**
 * Tool that manages the point's edition.
 * @class
 * @memberof pcvizTools
 * @extends Tool
 */
class PointEditionTool extends pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_1___default.a {
    constructor( view, id ) {
        super( view._viewer, id === undefined ? 'pointEdition' : id );

        this._view = view;
        this._viewer = view._viewer;
        this._viewerCanvas = this._viewer.getCanvas();

        this._hudRoot = this._viewer.getHUDNode().getHUDRootNode();

        this._hudPEScene = new osg.MatrixTransform();
        this._hudPEScene.setName( 'PointEdition SceneView HUDNode' );
        this._hudPEScene.getOrCreateStateSet().setAttributeAndModes( new osg.Light( 0, true ) );

        this._hudRoot.addChild( this._hudPEScene ); // This will be always in viewer HUD

        this._scansList = undefined;

        this._initMousePosX = 0.0;
        this._initMousePosY = 0.0;

        this._positionsArray = [];
        this._modifiedPositionsArray = [];

        this.listenersOn = false;

        this._selectionMode = POINT_SELECTION_MODE.QUAD; // As default
        this._operationMode = POINT_SELECTION_OPERATION_MODE.REPLACE; // As default
        this.hideViewButtons = false;
        this._onlySection = false;
        this._cleanPointsAfterDeactive = true;

        this._mouseupFunction = undefined;
        this._mousedownFunction = undefined;
        this._mousemoveFunction = undefined;
        this._touchstartFunction = undefined;
        this._touchendFunction = undefined;
        this._touchmoveFunction = undefined;
        this._wheelFunction = undefined;
        this._dblclickFunction = undefined;
        this._keydownFunction = undefined;
        this._canvasResizeFunction = undefined;
        this._canvasResizeIntervalID = undefined;
        this._pointerModeSwitch = undefined;
        this._hasTouchPointerEvents = undefined;

        this._onCapture = false;
        this._onModifyVertexesMode = false;

        this._sketchTool = new SketchTool( this._viewer );
        this._pointVisibilityManager = new pcvizUtils_PointVisibilityManager__WEBPACK_IMPORTED_MODULE_6__["default"]( this._view );
        this._userPreferences = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getController( 'UserPreferences' );

        this._sectionView = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'View' ).getView( 'Section' );

        const self = this;
        this._userPreferences.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_2___default.a.PROJECT, pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.SELECTION_COLOR_KEY, function () {
            self._pointVisibilityManager.changeSelectionColor( self._userPreferences.getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.SELECTION_COLOR_KEY ) );
        } );

        this._refreshCallback = undefined;
        this._actionView = undefined; // Prevent multiple view events at the same time
        this._hasSectionInsider = false;

        this._selectedPointIndex = -1;

        this._pointCollector = new pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_11__["default"]();

        this._depthRange = 500;
        this._keepViewportMat = osg.mat4.create();
        this._keepViewMat = osg.mat4.create();
        this._keepProjectionMat = osg.mat4.create();
        this._keepIsOrtho = false;
    }

    /**
     * Sets the tool active or inactive.
     * @memberof pcvizTools.PointEditionTool
     * @method
     * @param {boolean} active `true` if the tool is active.
     */
    setActive( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( this._active ) {
            this._operationMode = POINT_SELECTION_OPERATION_MODE.REPLACE;
            this.toggleCapturePoints( POINT_SELECTION_MODE.QUAD ); // We activate the quad selection mode as default
        }
        if ( !this._active ) {
            this._viewer.getCanvas().parentElement.style.cursor = 'default';

            this.stopCapturePoints();
            if ( this._cleanPointsAfterDeactive ) {
                this.cleanPointSelected();
            }
        }
    }

    setRefreshCallback( callback ) {
        this._refreshCallback = callback;
    }

    setScansList( newScans ) {
        this._scansList = newScans;
    }

    haveSelectionInsiders() {
        return this._pointVisibilityManager.getSelectionInsiders().length > 0;
    }

    haveHiddenInsiders() {
        return this._pointVisibilityManager.getHiddenInsiders().length > 0;
    }

    haveDeletedInsiders() {
        return this._pointVisibilityManager.getDeletedInsiders().length > 0;
    }

    setViewer( viewer ) {
        this._viewer = viewer;
    }

    getOP() {
        return this._operationMode;
    }

    setOP( mode ) {
        this._operationMode = mode;
    }

    getSelectionMode() {
        return this._selectionMode;
    }

    isModifyingVertexes() {
        return this._onModifyVertexesMode;
    }

    setCleanPointsAfterDeactive( cleaned ) {
        this._cleanPointsAfterDeactive = cleaned;
    }

    setOnlySection( value ) {
        this._onlySection = value;
    }

    restoreSectionInsider() {
        this._hasSectionInsider = false;
    }

    setDepthValue( value ) {
        this._depthRange = value;
    }

    getDepthValue() {
        return this._depthRange;
    }

    isMobile() {
        return this._hasTouchPointerEvents && ( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.isTouchEnabled() || pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.isTouchByTouchPoints() );
    }

    /**
     * Method to apply the drawn area to select points from scene
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    applySelection() {
        // Applying selection
        const view = ( this._actionView === 'scene' ) ? this._view : this._sectionView;
        const viewer = view.getViewer();

        this.applyPointSelection( this._positionsArray, viewer );
    }

    /**
     * Method to know which is the maxmiun depth value that user can apply on a selection in the current project.
     * @returns a number with the max depth value that could work depending on the extent of the project's data
     */
    getMaximumDepthValue() {
        const project = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_3___default.a.getInstance().getController( 'Application' ).getApplication().getProject();
        const projectExtent = project.getProjectedExtent();
        const extentSizeX = projectExtent[ 3 ] - projectExtent[ 0 ];
        const extentSizeY = projectExtent[ 4 ] - projectExtent[ 1 ];
        const extentSizeZ = projectExtent[ 5 ] - projectExtent[ 2 ];
        return MAX_DEPTH_EXTENT_FACTOR * Math.round( Math.max( extentSizeX, extentSizeY, extentSizeZ ) );
    }

    /**
     * Method that computes a extent using the selected points in the project's pointclouds data.
     * @returns an extent of the selected point in the extent
     */
    get3DSelectionExtent() {
        const view3d = this._view;
        this._pointCollector.reset();
        this._pointCollector.setMode( pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_11__["COLLECT_POINT_MODES"].SELECTED );
        view3d.getSceneNode().accept( this._pointCollector );
        const selectionExtent = this._pointCollector.getAffectedExtent();

        return selectionExtent;
    }

    /**
     * Method to travel to the selected area in scene
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    travel3DSelection() {
        const selectionExtent = this.get3DSelectionExtent();

        if ( !selectionExtent ) { // Cancel travelling when no points selected
            return;
        }

        // Compose Bounding box to make zoom
        const options = {};
        options.zoomOptions = 'global';
        const selectionBounding = this._viewer.getBoundingFromExtent( new pcvizGIS_Envelope__WEBPACK_IMPORTED_MODULE_7__["default"]( selectionExtent[ 0 ], selectionExtent[ 3 ], selectionExtent[ 1 ], selectionExtent[ 4 ], selectionExtent[ 2 ], selectionExtent[ 5 ] ) );
        this._viewer.zoomToBounding( selectionBounding, options );
    }

    /**
     * Method to toggle capturing points from scene with a quad
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    toggleCapturePoints( mode ) {
        if ( this.listenersOn && mode === this._selectionMode ) {
            this.stopCapturePoints();
            return;
        }
        this._selectionMode = mode;

        this.cleanHUD();
        this.resetToolProperties();
        this.resetKeepToolProperties();

        this.removeEventListeners();
        this.setUpEventListeners();
    }

    /**
     * Method to stop capturing points from scene
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    stopCapturePoints() {
        this.removeEventListeners();
        this.cleanHUD();
        this.resetToolProperties();

        // Enable viewer manipulator
        if ( this._viewer && this._viewer.getManipulator() && !this._onlySection ) {
            this._viewer.getManipulator().getRotateInterpolator().reset();
            this._viewer.getManipulator().getPanInterpolator().reset();
            const manipulatorTarget = osg.vec3.create();
            osg.vec3.copy( manipulatorTarget, this._viewer.getManipulator()._target );
            this._viewer.enableManipulator( true );
            if ( this._viewer.getManipulator().setPivotPoint ) {
                this._viewer.getManipulator().setPivotPoint( manipulatorTarget );
            }
        }

        // Enable section viewer manipulator
        const sectionViewer = this._sectionView.getViewer();
        if ( sectionViewer && sectionViewer.getManipulator() ) {
            sectionViewer.getManipulator().getRotateInterpolator().reset();
            sectionViewer.getManipulator().getPanInterpolator().reset();
            const manipulatorTarget = osg.vec3.create();
            osg.vec3.copy( manipulatorTarget, sectionViewer.getManipulator()._target );
            sectionViewer.enableManipulator( true );
            if ( sectionViewer.getManipulator().setPivotPoint ) {
                sectionViewer.getManipulator().setPivotPoint( manipulatorTarget );
            }
            this._sectionView.setZoomOn( true ); // To enable section view zoom event controller.
        }
    }

    resetToolProperties() {
        this._onCapture = false;
        this._onModifyVertexesMode = false;
        this._actionView = undefined;
        this._initMousePosX = 0.0;
        this._initMousePosY = 0.0;
        this._positionsArray = [];
        this._modifiedPositionsArray = [];
        this._selectedPointIndex = -1;
    }

    resetKeepToolProperties() {
        this._keepViewportMat = osg.mat4.create();
        this._keepViewMat = osg.mat4.create();
        this._keepProjectionMat = osg.mat4.create();
        this._keepIsOrtho = false;
    }

    /*** HUD DRAWING ***/
    cleanHUD() {
        this._hudPEScene.removeChildren();
        if ( this._hudPESection ) {
            this._hudPESection.removeChildren();
        }
    }

    drawSelection( positions, viewTag ) { // This method is similar to drawArea() from pcviz.SketchTool
        const hudNode = ( viewTag === 'scene' ) ? this._hudPEScene : this._hudPESection;

        this.cleanHUD();

        const selectionColor = this._userPreferences.getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.SELECTION_COLOR_KEY );
        const color = osg.vec4.fromValues( selectionColor[ 0 ], selectionColor[ 1 ], selectionColor[ 2 ], selectionColor[ 3 ] * 0.5 );
        this._sketchTool.cleanLinesOrAreasProgram(); // Shader reset: is necessary because we are working on differents canvas, and each one have a different graphic context.
        const areaSelection = this._sketchTool.drawArea( positions, false, color );

        hudNode.addChild( areaSelection.area );
        if ( positions.length < 3 ) { // That wired geometry only appears when we draw a polygon with less than 3 vertex
            hudNode.addChild( areaSelection.wire );
        }
    }

    drawPointCircles( positions, viewTag, highlightPositionIndex ) {
        const hudNode = ( viewTag === 'scene' ) ? this._hudPEScene : this._hudPESection;

        const selectionColor = this._userPreferences.getPreference( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.SELECTION_COLOR_KEY );
        const color = osg.vec4.fromValues( 1 - selectionColor[ 0 ], 1 - selectionColor[ 1 ], 1 - selectionColor[ 2 ], 1.0 );

        const points = this._sketchTool.drawPoints( positions, color );
        if ( highlightPositionIndex !== undefined ) {
            let modifiedColors = points.getAttributes().Color.getElements();
            modifiedColors[ ( highlightPositionIndex * 4 ) + 3 ] = SELECTED_GIZMO_ALPHA;
            points.getAttributes().Color.setElements( modifiedColors );
        }

        let stateSet = points.getOrCreateStateSet();
        stateSet.setAttributeAndModes( this.getOrCreatePointCirclesShader(), osg.StateAttribute.OVERRIDE | osg.StateAttribute.PROTECTED );
        stateSet.setAttributeAndModes( new osg.CullFace( 'DISABLE' ) );
        stateSet.setAttributeAndModes( new osg.BlendFunc( osg.BlendFunc.ONE, osg.BlendFunc.ONE_MINUS_SRC_ALPHA ) );
        stateSet.addUniform( osg.Uniform.createFloat1( GIZMO_SIZE, 'gizmoSize' ) ); // Uniform to control gl_PointSize value by gizmo size value.
        stateSet.setRenderBinDetails( 11, 'DepthSortedBin' ); // Render it before selection rectangle

        hudNode.addChild( points );
    }

    getOrCreatePointCirclesShader() {
        const vertCode = [
            '#ifdef GL_ES',
            '    precision highp float;',
            '#endif',
            'attribute vec3 Vertex;',
            'attribute vec4 Color;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;',
            'uniform float gizmoSize;',
            'varying vec4 FragColor;',
            '',
            'void main(void) {',
            '    gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex, 1.0);',
            '    FragColor = Color;',
            '    gl_PointSize = gizmoSize;',
            '}'
        ].join( '\n' );

        const fragCode = [
            '#ifdef GL_ES',
            '    precision highp float;',
            '#endif',
            'varying vec4 FragColor;',

            'void main(void) {',
            '    float dist = distance( vec2(0.5,0.5), gl_PointCoord );',
            '    if ( dist > 0.5 ) discard;',
            '    gl_FragColor = FragColor;',
            '}'
        ].join( '\n' );

        return new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertCode ), new osg.Shader( 'FRAGMENT_SHADER', fragCode ) );
    }

    /*** POINT COLLECTION ***/
    setUpLayerVisibilityCallback( layer, layerNode ) {
        layer.setVisibilityCallback( 'pointEdition', ( visible /*options*/ ) => {
            if ( !visible ) {
                this._pointVisibilityManager.cleanPointSelectedFromHiddenLayer( layer.getId(), layerNode );
            }
        } );
    }

    getPCLayersMap( insider ) {
        const scansMap = new Map();

        if ( !this._view.getLayerRenderer() ) {
            return scansMap;
        }

        const pointCloudNodes = Array.from( this._view.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_8__["default"].POINTCLOUD ).values() );

        for ( let pcLOD of pointCloudNodes ) {
            let parent = pcLOD.Layer.getParent();

            // Avoid store pc layer that are hidden by the TOC
            if ( !pcLOD.Layer.isVisible() ) {
                continue;
            }

            // Avoid store pc layer which don't collide
            const path = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.computeNodePath( pcLOD );
            const accum = osg.computeLocalToWorld( path.slice( 1 ) );

            let stationMatrix = this.getParentStationMatrix( path );
            if ( !stationMatrix ) {
                stationMatrix = osg.mat4.create();
            }

            const origMat = osg.mat4.transpose( osg.mat4.create(), stationMatrix );

            // Geometry bbox
            const pcLODBounding = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_4___default.a.getTransformedBoundingBox( pcLOD, accum );

            // Preventing to add a insider that is not colliding with anything
            if ( insider.getType() !== pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].INTERSECT && !insider.collideBoundingBox( pcLODBounding, undefined ) ) {
                continue;
            }

            let isScan = true;
            // We have to get the parent Layer only if is a Lidar layer, because we need to get in these cases the scan ID
            if ( parent.getCategory() !== pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_9__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_9__["default"].Scan ).name ) {
                isScan = false; // Mark which came from scans
                parent = pcLOD.Layer;
            }

            // If we get a list of scans from merge scans, we look if actual scan was chosen in the step 1
            if ( this._scansList !== undefined && this._scansList.indexOf( parent.getId() ) === -1 ) {
                continue;
            }

            // We use origMat for processing algorithms and accum mat for insider isInside calcs
            const obj = { origMat, isScan, accum };
            scansMap.set( parent.getId(), obj );

            this.setUpLayerVisibilityCallback( parent, pcLOD );
        }

        return scansMap;
    }

    applyPointSelection( selectionVertex, viewer ) {

        // Camera
        const camera = viewer.getCamera();

        // Operation mode & type parser
        const operation = this.getOP();
        const type = this.getInsiderType( operation );

        //Transform matrix to get after a point in Screen World
        const transformMatrix = this.computeWorldToScreenMatrix( camera );

        const nearFarObj = this.computeNearFarWorldPositions( selectionVertex, transformMatrix );
        const insider = new pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["default"]( selectionVertex, nearFarObj.near, nearFarObj.far, transformMatrix, type );

        const layersAffectedMap = this.getPCLayersMap( insider );
        insider.setLayersMap( layersAffectedMap );

        if ( this._actionView === 'scene' ) {
            this._pointVisibilityManager.addInsider( insider, operation );
        }
        if ( this._actionView === 'section' && layersAffectedMap.size > 0 ) { // TODO: Check if we need to support the range bar on section view.
            this.addInsiderFromSection( insider, operation );
            this._hasSectionInsider = true;
        }

        // When we finish the point selection proccess, we deactivate the capture mode
        this.stopCapturePoints();
    }

    modifyRangePointSelection() {
        if ( !this.haveSelectionInsiders() || this._depthRange <= 0.0 ) { // Depth value can't be less than 0
            return;
        }
        const selectionInsiders = this._pointVisibilityManager.getSelectionInsiders();
        const lastSelectionInsider = selectionInsiders[ selectionInsiders.length - 1 ];

        const vertexes = lastSelectionInsider.getVertexes();
        const type = lastSelectionInsider.getType();

        const newMatrix = this.recomputeWorldToScreenMatrix();
        const newNearFarObj = this.computeNearFarWorldPositions( vertexes, newMatrix );

        const newInsider = new pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["default"]( vertexes, newNearFarObj.near, newNearFarObj.far, newMatrix, type );

        // Recompute collisions & layers affected after modifying the range
        const layersAffectedMap = this.getPCLayersMap( newInsider );
        newInsider.setLayersMap( layersAffectedMap );

        this._pointVisibilityManager.replaceLastSelectionInsider( newInsider );
    }

    /**
     * Method that finishes the last selection insider range/depth modification, and checks if its valid
     * or removes it to avoid affect tool's performance.
     */
    saveModifiedPointSelection() {
        this.resetKeepToolProperties();
        this.checkOrRemoveInvalidSelectionInsider();
    }

    /**
     * Method that checks if last selection insider is valid
     * or removes it to avoid affect tool's performance.
     * TODO: Consider something similar for section view, but not last insider, just previous one as the section is applying an extra intersection insider.
     */
    checkOrRemoveInvalidSelectionInsider() {
        const selectionInsiders = this._pointVisibilityManager.getSelectionInsiders();
        const lastSelectionInsider = selectionInsiders[ selectionInsiders.length - 1 ];
        // If after modifying a insider, this is not valid or not affecting any layer, we remove it.
        if ( lastSelectionInsider.getLayersMap().size === 0 || !lastSelectionInsider.isValid() ) {
            this._pointVisibilityManager.popSelectionInsider();
            this._pointVisibilityManager.refreshPointSelection();
        }
    }

    addInsiderFromSection( insider, operation ) {
        let poppedInsider;
        if ( this._hasSectionInsider ) { // Manage intersect insider from section view
            poppedInsider = this._pointVisibilityManager.popSelectionInsider();
        }

        this._pointVisibilityManager.addInsider( insider, operation ); // Add the new insider

        // Add section intersect insider
        const sectionInsider = ( poppedInsider ) ? poppedInsider : this._sectionView.getSectionBufferInsider();
        sectionInsider.setLayersMap( ( insider.getLayersMap() ) ? insider.getLayersMap() : this.getPCLayersMap( sectionInsider ) );
        this._pointVisibilityManager.addInsider( sectionInsider, POINT_SELECTION_OPERATION_MODE.INTERSECT );
    }

    addSelectAll() {
        this.addAllOrInvertSelection( pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].SELECT_ALL );
    }

    addInvertSelection() {
        this.addAllOrInvertSelection( pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].INVERT );
    }

    addAllOrInvertSelection( insiderType ) {
        const insider = new pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["default"]( undefined, undefined, undefined, undefined, insiderType );
        const scansAffected = this.getPCLayersMap( insider );
        insider.setLayersMap( scansAffected );
        let operation = POINT_SELECTION_OPERATION_MODE.REPLACE;

        // By default valid value is false, so we validate it here due to we will not use isInside function for these kind of insiders.
        if ( insiderType === pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].INVERT ) {
            insider.setInsiderValidation();
            operation = POINT_SELECTION_OPERATION_MODE.ADD;
        }

        if ( this._sectionView.isOpen() ) {
            this.addInsiderFromSection( insider, operation );
            this._hasSectionInsider = true;
            return;
        }

        this._pointVisibilityManager.addInsider( insider, operation );
        this._hasSectionInsider = false;
    }

    getInsiderType( op ) {
        let result;
        switch ( op ) {
        case POINT_SELECTION_OPERATION_MODE.REPLACE:
        case POINT_SELECTION_OPERATION_MODE.ADD:
            result = pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].ADD;
            break;
        case POINT_SELECTION_OPERATION_MODE.SUBSTRACT:
            result = pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].SUBSTRACT;
            break;
        case POINT_SELECTION_OPERATION_MODE.INTERSECT:
            result = pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].INTERSECT;
            break;
        }

        return result;
    }

    getSelectionProcess( isRemoveHiddenPoints ) {
        const insidersObject = this._pointVisibilityManager.getInsidersObject();
        let selectionObject = this.getDeletedSelections( insidersObject.delete );

        if ( isRemoveHiddenPoints && insidersObject.hidden.length ) {
            const result = this.getDeletedSelections( insidersObject.hidden );
            selectionObject = selectionObject.concat( result );
        }

        for ( const insiderSelect of insidersObject.select ) {
            selectionObject.push( insiderSelect.getProcessObject() );
        }

        // We need to add a SelectAll after point deletion if haven't any selection
        if ( insidersObject.select.length === 0 && ( insidersObject.delete.length > 0 || ( isRemoveHiddenPoints && insidersObject.hidden.length ) ) ) {
            const selectAllInsider = new pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["default"]( undefined, undefined, undefined, undefined, pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_5__["INSIDER_TYPES"].SELECT_ALL );
            const scansAffected = this.getPCLayersMap( selectAllInsider );
            selectAllInsider.setLayersMap( scansAffected );
            selectionObject.push( selectAllInsider.getProcessObject() );
        }

        return { selections: selectionObject };
    }

    getDeletedSelections( object ) {
        const deletedSelections = [];
        for ( const round of object ) {
            let deleteLayersMap = new Map();
            for ( const insider of round ) {
                deleteLayersMap = new Map( [ ...deleteLayersMap, ...insider.getLayersMap() ] );
                deletedSelections.push( insider.getProcessObject() );
            }

            // From Insider2D.getProcessObject(), to apply the same workflow as in SelectAll insider,
            // but avoiding create a new insider for Delete. Delete is only a operation in processing,
            // in Front-end we use a couple of list to control delete and select sets.
            const layersKeyArray = Array.from( deleteLayersMap.keys() );
            const scansAffected = [];
            for ( let layerID of layersKeyArray ) {
                const layerObject = deleteLayersMap.get( layerID );
                if ( layerObject.isScan ) {
                    scansAffected.push( { idScan: layerID, transform: Object.values( layerObject.origMat ) } );
                }
            }
            deletedSelections.push( { type: 'Delete', scansAffected: scansAffected } );
        }
        return deletedSelections;
    }

    /*** POINT COLOURING ***/
    cleanPointSelected() {
        this._pointVisibilityManager.cleanPointSelected();
        this._hasSectionInsider = false;
    }

    hideSelectedPoints() {
        this._pointVisibilityManager.hideSelectedPoints();
        this._hasSectionInsider = false;
    }

    showHiddenPoints() {
        this._pointVisibilityManager.showHiddenPoints();
    }

    deleteSelectedPoints() {
        this._pointVisibilityManager.deleteSelectedPoints();
        this._hasSectionInsider = false;
    }

    restoreDeletedPoints() {
        this._pointVisibilityManager.restoreDeletedPoints();
    }

    /*** DATABASE ACCESS ***/
    downloadInsidersDB() {
        this._pointVisibilityManager.downloadInsidersDB();
    }

    saveInsidersDB() {
        this._pointVisibilityManager.saveInsidersDB();
    }

    cleanInsidersDB() {
        this._pointVisibilityManager.cleanInsidersDB();
    }

    /*** LISTENERS SETUP AND CLEAN ***/
    /**
     * Method to add the event listeners and define the necessary functions if they aren't defined.
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    setUpEventListeners() {
        this.declarePointerModeSwitchFunction();

        if ( this._selectionMode === POINT_SELECTION_MODE.QUAD ) {
            this.declareQuadSelectionFunctions();
        }
        if ( this._selectionMode === POINT_SELECTION_MODE.POLYGON ) {
            this.declarePolySelectionFunctions();
        }

        if ( !this._onlySection ) {
            this.addOrRemoveEventListeners( this._viewer, true );
        }

        if ( this._sectionView.getViewer() ) {
            this._hudPESection = this._sectionView.getPointEditionHUD();
            this.addOrRemoveEventListeners( this._sectionView.getViewer(), true );
        }

        window.addEventListener( 'keydown', this._keydownFunction );

        this.listenersOn = true;
    }

    /**
     * Method to remove the event listeners added when we were using this tool.
     * @method
     * @memberof pcvizTools.PointEditionTool
     */
    removeEventListeners() {
        if ( !this._onlySection ) {
            this.addOrRemoveEventListeners( this._viewer, false, true );
        }

        if ( this._sectionView.getViewer() ) {
            this.addOrRemoveEventListeners( this._sectionView.getViewer(), false, true );
        }

        window.removeEventListener( 'keydown', this._keydownFunction );
        if ( this._canvasResizeIntervalID ) {
            clearInterval( this._canvasResizeIntervalID );
        }

        this.listenersOn = false;
        this._onCapture = false;
        this._actionView = undefined;

        if ( this._refreshCallback ) this._refreshCallback(); // To refresh UI components styles
    }

    addOrRemoveEventListeners( viewer, enable, removeAll = false ) {
        const canvas = viewer.getCanvas();

        if ( this.isMobile() || removeAll ) {
            this.addOrRemoveTouchEvents( canvas, enable );
        }
        if ( !this.isMobile() || removeAll ) {
            this.addOrRemoveMouseEvents( canvas, enable );
        }
        this.addOrRemovePointerEvents( canvas, enable );

        if ( enable ) {
            canvas.addEventListener( 'wheel', this._wheelFunction );
            canvas.addEventListener( 'dblclick', this._dblclickFunction, true );
        } else {
            canvas.removeEventListener( 'wheel', this._wheelFunction );
            canvas.removeEventListener( 'dblclick', this._dblclickFunction, true );
        }
    }

    addOrRemovePointerEvents( canvas, enable ) {
        const action = enable ? 'addEventListener' : 'removeEventListener';

        canvas[ action ]( 'pointerdown', this._pointerModeSwitch );
        canvas[ action ]( 'pointermove', this._pointerModeSwitch );
        canvas[ action ]( 'pointerup', this._pointerModeSwitch );
    }

    addOrRemoveMouseEvents( canvas, enable ) {
        if ( enable ) {
            canvas.addEventListener( 'mousedown', this._mousedownFunction );
            canvas.addEventListener( 'mousemove', this._mousemoveFunction );
            canvas.addEventListener( 'mouseup', this._mouseupFunction );
            if ( /iphone|ipod|ipad/.test( window.navigator.userAgent.toLowerCase() ) ) {
                canvas.addEventListener( 'mouseup', this.getDoubleTapIOSFunction(), false );
            }
            return;
        }
        canvas.removeEventListener( 'mousedown', this._mousedownFunction );
        canvas.removeEventListener( 'mousemove', this._mousemoveFunction );
        canvas.removeEventListener( 'mouseup', this._mouseupFunction );
        canvas.removeEventListener( 'mouseup', this._doubleTapIOSFunction );
    }

    addOrRemoveTouchEvents( canvas, enable ) {
        if ( enable ) {
            canvas.addEventListener( 'touchstart', this._touchstartFunction );
            canvas.addEventListener( 'touchmove', this._touchmoveFunction );
            canvas.addEventListener( 'touchend', this._touchendFunction );
            if ( /iphone|ipod|ipad/.test( window.navigator.userAgent.toLowerCase() ) ) {
                canvas.addEventListener( 'touchend', this.getDoubleTapIOSFunction(), false );
            }
            return;
        }
        canvas.removeEventListener( 'touchstart', this._touchstartFunction );
        canvas.removeEventListener( 'touchmove', this._touchmoveFunction );
        canvas.removeEventListener( 'touchend', this._touchendFunction );
        canvas.removeEventListener( 'touchend', this._doubleTapIOSFunction );
    }

    getViewTagByEventCanvas( canvas ) {
        return ( canvas === this._viewer.getCanvas() ) ? 'scene' : 'section';
    }

    getRatio( canvas ) {
        const ratioX = canvas.width / canvas.clientWidth;
        const ratioY = canvas.height / canvas.clientHeight;
        return { x: ratioX, y: ratioY };
    }

    getScreenPoint( canvasEvent ) {
        let x = 0.0;
        let y = 0.0;

        if ( this.isMobile() && ( canvasEvent.type === 'touchstart' || canvasEvent.type === 'touchend' || canvasEvent.type === 'touchmove' ) ) {
            x = canvasEvent.changedTouches[ 0 ].clientX;
            y = canvasEvent.changedTouches[ 0 ].clientY;
        } else {
            x = canvasEvent.clientX;
            y = canvasEvent.clientY;
        }
        return [ x, y ];
    }

    getHUDPoint( screenPoint, canvas, viewer ) {
        let offset = [];
        const ratio = this.getRatio( canvas );
        viewer.getOffsetRect( canvas, offset );

        let x = ( screenPoint[ 0 ] - offset[ 1 ] ) * ratio.x;
        let y = ( canvas.clientHeight - ( screenPoint[ 1 ] - offset[ 0 ] ) ) * ratio.y;

        return [ x, y ];
    }

    getHUDQuadCorners( point1, point2 ) {
        // Process to know left-up corner and right-bottom corner
        const xMin = Math.min( point1[ 0 ], point2[ 0 ] );
        const yMin = Math.min( point1[ 1 ], point2[ 1 ] );
        const xMax = Math.max( point1[ 0 ], point2[ 0 ] );
        const yMax = Math.max( point1[ 1 ], point2[ 1 ] );

        const leftLow = osg.vec3.fromValues( xMin, yMin, 0.0 );
        const rightLow = osg.vec3.fromValues( xMax, yMin, 0.0 );
        const rightHigh = osg.vec3.fromValues( xMax, yMax, 0.0 );
        const leftHigh = osg.vec3.fromValues( xMin, yMax, 0.0 );

        return [ leftLow, rightLow, rightHigh, leftHigh ];
    }

    declarePointerModeSwitchFunction() {
        const self = this;

        this._pointerModeSwitch = function ( ev ) {
            const hasTouchPointerEvents = ev.pointerType === 'touch';
            if ( self._hasTouchPointerEvents === hasTouchPointerEvents ) {
                return;
            }

            self._hasTouchPointerEvents = hasTouchPointerEvents;

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );
            self._actionView = viewTag;

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();

            const canvas = viewer.getCanvas();

            self.addOrRemoveTouchEvents( canvas, false );
            self.addOrRemoveMouseEvents( canvas, false );

            if ( hasTouchPointerEvents ) {
                self.addOrRemoveTouchEvents( canvas, true );
            } else {
                self.addOrRemoveMouseEvents( canvas, true );
            }
        };
    }

    declareQuadSelectionFunctions() {
        // We need to store instance letiable to add/remove event listeners
        const self = this;

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );
            self._actionView = viewTag;

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();

            // Disable viewer manipulator
            if ( viewer && viewer.getManipulator() ) {
                viewer.disableManipulatorDoubleClick();
                viewer.enableManipulator( false );
                if ( viewTag === 'section' ) {
                    self._sectionView.setZoomOn( false );
                }
            }

            const screenPoint = self.getScreenPoint( ev );
            self._initMousePosX = screenPoint[ 0 ];
            self._initMousePosY = screenPoint[ 1 ];

            // Start to capture mouse movement
            self._onCapture = true;

            ev.stopPropagation(); //
        };

        this._touchstartFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousedownFunction( ev );
        };

        this._mousemoveFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( !self._onCapture ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const initPoint = self.getHUDPoint( [ self._initMousePosX, self._initMousePosY ], canvas, viewer );
            const currentPoint = self.getHUDPoint( screenPoint, canvas, viewer );

            const quadCorners = self.getHUDQuadCorners( initPoint, currentPoint );

            self._positionsArray = quadCorners;

            // Draw HUD selection
            self.drawSelection( quadCorners, self._actionView );

            ev.stopPropagation(); //
        };

        this._touchmoveFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousemoveFunction( ev );
        };

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            const actionView = self._actionView;
            const view = ( actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();

            self.drawPointCircles( self._positionsArray, actionView );

            self.removeEventListeners(); // This is cleanning _actionView value
            self.declareQuadModifyVertexFunctions( viewer, actionView );

            ev.stopPropagation(); //
        };

        this._touchendFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mouseupFunction( ev );
        };

        this._wheelFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._keydownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };
    }

    declarePolySelectionFunctions() {
        // We need to store instance letiable to add/remove event listeners
        const self = this;

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );
            if ( self._positionsArray.length === 0 ) { // First time in mousedown poly should get the viewTag for the action view checking policy.
                self._actionView = viewTag;
            }

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            // Disable viewer manipulator
            if ( viewer && viewer.getManipulator() ) {
                viewer.disableManipulatorDoubleClick();
                viewer.enableManipulator( false );
            }

            const screenPoint = self.getScreenPoint( ev );
            const initPoint = self.getHUDPoint( screenPoint, canvas, viewer );

            const newPosition = osg.vec3.fromValues( initPoint[ 0 ], initPoint[ 1 ], 0.0 );
            self._positionsArray.push( newPosition );

            // Start to capture mouse movement
            self._onCapture = true;

            ev.stopPropagation(); //
        };

        this._touchstartFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );
            if ( self._positionsArray.length === 0 ) { // First time in mousedown poly should get the viewTag for the action view checking policy.
                self._actionView = viewTag;
            }

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            // Disable viewer manipulator
            if ( viewer && viewer.getManipulator() ) {
                viewer.disableManipulatorDoubleClick();
                viewer.enableManipulator( false );
            }

            const screenPoint = self.getScreenPoint( ev );
            const initPoint = self.getHUDPoint( screenPoint, canvas, viewer );

            const newPosition = osg.vec3.fromValues( initPoint[ 0 ], initPoint[ 1 ], 0.0 );
            self._positionsArray.push( newPosition );

            self.drawSelection( self._positionsArray, viewTag );

            // Start to capture mouse movement
            self._onCapture = true;

            ev.stopPropagation(); //
        };

        this._mousemoveFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( !self._onCapture ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const currentPoint = self.getHUDPoint( screenPoint, canvas, viewer );

            const newPosition = osg.vec3.fromValues( currentPoint[ 0 ], currentPoint[ 1 ], 0.0 );
            self.drawSelection( self._positionsArray.concat( newPosition ), viewTag );

            ev.stopPropagation(); //
        };

        this._touchmoveFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._touchendFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._wheelFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( !self._onCapture ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();

            self._positionsArray.pop(); // delete last point which is added on mouseDownFunction which is applied twice before this function (dblclick = 2 mousedown).

            // Draw HUD selection
            self.drawSelection( self._positionsArray, self._actionView );
            self.drawPointCircles( self._positionsArray, self._actionView );

            self.removeEventListeners(); // This is cleanning _actionView value
            self.declarePolyModifyVertexFunctions( viewer, viewTag );

            ev.stopPropagation(); //
        };

        this._keydownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( !self._onCapture ) {
                return;
            }

            const actionView = self._actionView;
            const view = ( actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();

            if ( ev.key === pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_10__["EVENT_KEYS"].ESCAPE || ev.key === pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_10__["EVENT_KEYS"].ESC ) {
                // Draw HUD selection
                self.drawSelection( self._positionsArray, actionView );
                self.drawPointCircles( self._positionsArray, actionView );

                self.removeEventListeners(); // This is cleanning _actionView value
                self.declarePolyModifyVertexFunctions( viewer, actionView );
            }

            ev.stopPropagation();
        };

    }

    computeWorldToScreenMatrix( cam ) {
        // Viewport transform
        const mat = osg.mat4.create();
        if ( cam.getViewport() )
            cam.getViewport().computeWindowMatrix( mat ); // This sets the result in mat variable
        osg.mat4.copy( this._keepViewportMat, mat );

        // Projection transform
        const farValue = NEAR_VALUE + this._depthRange;
        const projectionMatrix = cam.getProjectionMatrix();
        const isOrtho = cam.getView().getIsOrtho();
        const matProj = this.setProjectionNearFarPlanes( NEAR_VALUE, farValue, projectionMatrix, isOrtho );
        osg.mat4.copy( this._keepProjectionMat, matProj );
        osg.mat4.multiply( mat, mat, matProj );

        // View transform
        const matView = cam.getViewMatrix();
        osg.mat4.copy( this._keepViewMat, matView );

        osg.mat4.multiply( mat, mat, matView );
        return mat;
    }

    recomputeWorldToScreenMatrix() {
        const farValue = NEAR_VALUE + this._depthRange;
        const mat = osg.mat4.create();
        osg.mat4.copy( mat, this._keepViewportMat );

        const newProjection = this.setProjectionNearFarPlanes( NEAR_VALUE, farValue, this._keepProjectionMat, this._keepIsOrtho );
        osg.mat4.multiply( mat, mat, newProjection );

        osg.mat4.multiply( mat, mat, this._keepViewMat );

        return mat;
    }

    setProjectionNearFarPlanes( nearValue, farValue, projectionMatrix, isOrtho ) {
        const newProjectionMatrix = osg.mat4.create();
        osg.mat4.copy( newProjectionMatrix, projectionMatrix );

        if ( isOrtho ) { // Orhtographic calcs for new near+far plane
            newProjectionMatrix[ 10 ] = ( -2.0 ) / ( farValue - nearValue );
            newProjectionMatrix[ 14 ] = -( farValue + nearValue ) / ( farValue - nearValue );
        } else { // Perspective calcs for new near+far plane
            newProjectionMatrix[ 10 ] = ( farValue + nearValue ) / ( nearValue - farValue );
            newProjectionMatrix[ 14 ] = ( 2 * farValue * nearValue ) / ( nearValue - farValue );
        }
        return newProjectionMatrix;
    }

    getParentStationMatrix( path ) {
        for ( let node of path ) {
            if ( node.Layer && node.Layer.isStation && node.Layer.isStation() ) {
                return node.getMatrix();
            }
        }

        // For projects that aren't scan projects
        return undefined;
    }

    computeNearFarWorldPositions( screenPoints, mat ) {
        let aux1 = osg.vec3.create();
        let aux2 = osg.vec3.create();
        let invertMt = osg.mat4.invert( osg.mat4.create(), mat );
        let far = [];
        let near = [];
        for ( let point of screenPoints ) {
            aux1 = osg.vec3.fromValues( point[ 0 ], point[ 1 ], 0 );
            aux2 = osg.vec3.fromValues( point[ 0 ], point[ 1 ], 1 );

            osg.vec3.transformMat4( aux1, aux1, invertMt );
            osg.vec3.transformMat4( aux2, aux2, invertMt );

            near.push( Object.values( aux1 ) );
            far.push( Object.values( aux2 ) );
        }

        return { near: near, far: far };
    }

    updateSelectionsVisibility() {
        this._pointVisibilityManager.processScene();
    }

    /** Modifying vertex function for QUAD and POLYGON selection */
    onResize( element, callback ) {
        let elementWidth = element.clientWidth;
        let elementHeight = element.clientHeight;
        this._canvasResizeIntervalID = setInterval( function () {
            if ( element.clientHeight !== elementHeight || element.clientWidth !== elementWidth ) {
                elementHeight = element.clientHeight;
                elementWidth = element.clientWidth;
                callback();
            }
        }, 100 );
    }

    declareQuadModifyVertexFunctions( viewer, actionView ) {
        const self = this;
        self._actionView = actionView; // Restoring _actionView for some methods
        self._onModifyVertexesMode = true;

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            const view = ( self._actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const click2D = self.getHUDPoint( screenPoint, canvas, viewer );

            const click3D = osg.vec3.fromValues( click2D[ 0 ], click2D[ 1 ], 0.0 );

            self._selectedPointIndex = self._positionsArray.findIndex( ( point ) => osg.vec3.distance( point, click3D ) <= ( GIZMO_SIZE / 2.0 ) * window.devicePixelRatio );

            ev.stopPropagation(); //
        };

        this._touchstartFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousedownFunction( ev );
        };

        this._mousemoveFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( self._selectedPointIndex < 0 ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const point = self.getHUDPoint( screenPoint, canvas, viewer );

            const diagonalPoint = self._positionsArray[ ( self._selectedPointIndex + 2 ) % 4 ]; // By the order to create the quads currently, the diagonal point will always correspond to this formula

            const quadCorners = self.getHUDQuadCorners( point, diagonalPoint );

            self._modifiedPositionsArray = quadCorners;

            // Draw HUD selection
            self.drawSelection( self._modifiedPositionsArray, self._actionView );
            self.drawPointCircles( self._modifiedPositionsArray, self._actionView, self._selectedPointIndex );

            ev.stopPropagation(); //
        };

        this._touchmoveFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousemoveFunction( ev );

            // Force redraw frame for preventing some issue
            const view = ( self._actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            viewer.requestRedraw();
        };

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( self._selectedPointIndex < 0 ) {
                return;
            }

            if ( self._modifiedPositionsArray.length === 0 ) {
                self._selectedPointIndex = -1;
                return;
            }

            self._selectedPointIndex = -1;
            self._positionsArray = self._modifiedPositionsArray;
            self._modifiedPositionsArray = [];

            // Draw HUD selection
            self.drawSelection( self._positionsArray, self._actionView );
            self.drawPointCircles( self._positionsArray, self._actionView );

            ev.stopPropagation(); //
        };

        this._touchendFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mouseupFunction( ev );
        };

        this._wheelFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._keydownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation();
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._canvasResizeFunction = function () {
            self.stopCapturePoints();
        };

        const canvas = viewer.getCanvas();
        this.onResize( canvas, this._canvasResizeFunction );
        window.addEventListener( 'keydown', this._keydownFunction );

        this.addOrRemoveEventListeners( viewer, true );
    }

    declarePolyModifyVertexFunctions( viewer, actionView ) {
        const self = this;
        self._actionView = actionView; // Restoring _actionView for some methods
        self._onModifyVertexesMode = true;

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            const view = ( self._actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const click2D = self.getHUDPoint( screenPoint, canvas, viewer );

            const click3D = osg.vec3.fromValues( click2D[ 0 ], click2D[ 1 ], 0.0 );

            self._selectedPointIndex = self._positionsArray.findIndex( ( point ) => osg.vec3.distance( point, click3D ) <= GIZMO_SIZE / 2.0 );

            ev.stopPropagation(); //
        };

        this._touchstartFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousedownFunction( ev );
        };

        this._mousemoveFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( self._selectedPointIndex < 0 ) {
                return;
            }

            const viewTag = self.getViewTagByEventCanvas( ev.srcElement );

            if ( self._actionView && self._actionView !== viewTag ) {
                return;
            }

            const view = ( viewTag === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            const canvas = viewer.getCanvas();

            const screenPoint = self.getScreenPoint( ev );
            const point = self.getHUDPoint( screenPoint, canvas, viewer );

            self._modifiedPositionsArray = [ ...self._positionsArray ];
            self._modifiedPositionsArray[ self._selectedPointIndex ] = osg.vec3.fromValues( point[ 0 ], point[ 1 ], 0.0 );

            // Draw HUD selection
            self.drawSelection( self._modifiedPositionsArray, self._actionView );
            self.drawPointCircles( self._modifiedPositionsArray, self._actionView, self._selectedPointIndex );

            ev.stopPropagation(); //
        };

        this._touchmoveFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mousemoveFunction( ev );

            // Force redraw frame for preventing some issue
            const view = ( self._actionView === 'scene' ) ? self._view : self._sectionView;
            const viewer = view.getViewer();
            viewer.requestRedraw();
        };

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            if ( self._selectedPointIndex < 0 ) {
                return;
            }

            if ( self._modifiedPositionsArray.length === 0 ) {
                self._selectedPointIndex = -1;
                return;
            }

            self._selectedPointIndex = -1;
            self._positionsArray = self._modifiedPositionsArray;
            self._modifiedPositionsArray = [];

            // Draw HUD selection
            self.drawSelection( self._positionsArray, self._actionView );
            self.drawPointCircles( self._positionsArray, self._actionView );

            ev.stopPropagation(); //
        };

        this._touchendFunction = function ( ev ) {
            if ( ev.touches.length > 1 ) { // Preventing multiple touches
                return;
            }
            self._mouseupFunction( ev );
        };

        this._wheelFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._keydownFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation();
        };

        this._dblclickFunction = function ( ev ) {
            if ( !self.isToolActive() ) {
                return;
            }

            ev.stopPropagation(); //
        };

        this._canvasResizeFunction = function () {
            self.stopCapturePoints();
        };

        const canvas = viewer.getCanvas();
        this.onResize( canvas, this._canvasResizeFunction );
        window.addEventListener( 'keydown', this._keydownFunction );

        this.addOrRemoveEventListeners( viewer, true );
    }

    isSectionView() {
        return this._actionView === 'section';
    }
}


/***/ }),

/***/ "./sources/pcvizTools/ProjectEditionTool.js":
/*!**************************************************!*\
  !*** ./sources/pcvizTools/ProjectEditionTool.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var LayerDefinition = __webpack_require__( /*! pcvizGIS/LayerDefinition */ "./sources/pcvizGIS/LayerDefinition.js" ).default;
var WorkspaceVisitor = __webpack_require__( /*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js" ).default;

var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var ScanWorkflow = __webpack_require__( /*! pcvizWorkflow/ScanWorkflow */ "./sources/pcvizWorkflow/ScanWorkflow.js" );
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
var WorkspaceCategories = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" ).default;

var osg = OSG.osg;

/**
 * Tool that manages the project's edition (Create, add, update and delete layers)
 * @class
 * @memberof pcvizTools
 * @extends Tool
 */
var ProjectEditionTool = function () {
    Tool.call( this, undefined, 'projectEdition' );
};

ProjectEditionTool.prototype = osg.objectInherit( Tool.prototype, {

    createLayerDefinition: function ( layerName, geomType, category, automaticAttributes, previousCategoryAttrs, description ) {
        let layerDefinition = new LayerDefinition();
        layerDefinition.setName( layerName );
        layerDefinition.setLayerType( 'VectorLayer' );
        layerDefinition.setLayerCategory( category );
        layerDefinition.setLayerGeometryType( geomType );

        // set CRS based on the project's internal CRS
        layerDefinition.setHorizProjectionEPSG( this._project.getDataCRS() );

        if ( description ) {
            layerDefinition.setDescription( description );
        }

        // DO NOT REMOVE: in the future we might support creating data in the Project CRS, only if we support on-the-fly projection in the 3D view
        //if ( this._project.getProjection() )
        //    layerDefinition.setHorizProjectionEPSG( this._project.getProjection() );

        if ( automaticAttributes && geomType !== 'Point' ) {

            let maxOrder = 0; //Get the last order from the category selected

            if ( previousCategoryAttrs ) {
                let categoryAttrsKeys = Object.keys( previousCategoryAttrs );

                for ( var i = 0; i < categoryAttrsKeys.length; i++ )
                    maxOrder = Math.max( maxOrder, previousCategoryAttrs[ categoryAttrsKeys[ i ] ].order );
            }

            // Defines them as not editable and visible
            //We've just checked that the geomType is different than 'Point'. So, all the other types have these attributes

            // The parameters for addAttribute are 'name','type','editable', 'order','visible'
            layerDefinition.addAttribute( Utils.CENTROID_X_ATTR, 'FloatField', 0, maxOrder + 1, 1 );
            layerDefinition.addAttribute( Utils.CENTROID_Z_ATTR, 'FloatField', 0, maxOrder + 3, 1 );
            layerDefinition.addAttribute( Utils.CENTROID_Y_ATTR, 'FloatField', 0, maxOrder + 2, 1 );

            // if 'LineString' or 'Polygon'
            if ( geomType !== 'MultiPoint' ) {
                layerDefinition.addAttribute( Utils.LENGTH_ATTR, 'FloatField', 0, maxOrder + 4, 1 );

                if ( geomType === 'Polygon' ) {
                    layerDefinition.addAttribute( Utils.AREA_ATTR, 'FloatField', 0, maxOrder + 5, 1 );
                }
            }
        }

        return layerDefinition;
    },

    /**
     * Method to create a new VectorLayer
     * @method
     * @memberof pcvizTools.ProjectEditionTool
     * @param {string} layerName the name of the new VectorLayer
     * @param {string} geomType the geometry type of the new VectorLayer
     * @param {string} category the category of the new VectorLayer
     */
    createVectorLayer: function ( layerName, geomType, category, color, automaticAttributes, previousCategoryAttrs, wksParentId, coordinateSystem, description, isTargetCat ) {

        var defer = P.defer();

        var view3D = Registry.getInstance().getController( 'View' ).getView( '3D' );
        if ( view3D )
            view3D.startLoading( 1 );

        let layerDefinition = this.createLayerDefinition( layerName, geomType, category, automaticAttributes, previousCategoryAttrs, description );

        if ( coordinateSystem ) {
            layerDefinition.setCoordinateSystem( coordinateSystem );
        }

        if ( isTargetCat ) {
            VectorLayerUtils.addTargetAttrsToDefinition( layerDefinition );
        }
        const self = this;

        this._project.createLayer( layerDefinition ).then( function ( layer ) {
            layer.open().then( function ( layerOpen ) {
                if ( !layerOpen.loaded ) {
                    if ( view3D )
                        view3D.progressLoading( 1 );
                    defer.reject();
                    return;
                }

                if ( color ) {
                    let rgb = Utils.fullhexToRgb( color, 1 );
                    layer.setBaseColor( layer.getStyle(), rgb );
                }
                var layerConfiguration = layer.getDataset().getConfiguration();
                const createConfigPromise = isTargetCat ? Promise.resolve() : layer.getDataset().getDriver().createLayerConfiguration( layerConfiguration, layer.getId(), true );
                createConfigPromise.then( function () {
                    if ( wksParentId ) {
                        self.addLayerToWorkspace( layer, wksParentId );
                    }

                    //TO REVIEW: we only refresh the tocView because there are not any feature to add to sceneView
                    var tocView = Registry.getInstance().getController( 'View' ).getView( 'TOC' );
                    tocView.addLayer( layer, wksParentId );
                    var mapView = Registry.getInstance().getController( 'View' ).getView( 'Map' );
                    if ( mapView !== undefined )
                        mapView.addLayer( layer );

                    if ( view3D )
                        view3D.progressLoading( 1 );
                    defer.resolve( layer ); //?
                } );
            }, function ( response ) {
                if ( view3D )
                    view3D.progressLoading( 1 );
                defer.reject( response );
            } );
        }, function ( response ) {
            if ( view3D )
                view3D.progressLoading( 1 );
            defer.reject( response );
        } );

        return defer.promise;
    },

    /**
     * Method to add an existing Layer from Server to the current Project
     * @method
     * @memberof pcvizTools.ProjectEditionTool
     * @param {int} idLayer the id of the layer to be added
     * @param {uuid} parentId optional Id of the workspace group to add the layer
     */
    addLayer: function ( idLayer, parentId ) {
        var defer = P.defer();
        var view3D = Registry.getInstance().getController( 'View' ).getView( '3D' );
        if ( view3D )
            view3D.startLoading( 1 );

        var self = this;
        this._project.addLayer( idLayer ).then( function ( layer ) {

            layer.open().then( function ( layerOpen ) {
                if ( !layerOpen.loaded ) {
                    if ( view3D )
                        view3D.progressLoading( 1 );
                    defer.reject();
                    return defer.promise;
                }

                if ( parentId )
                    self.addLayerToWorkspace( layer, parentId );

                var viewsArray = Registry.getInstance().getController( 'View' ).getViews();
                for ( var i = 0; i < viewsArray.length; i++ ) {
                    viewsArray[ i ].addLayer( layer, parentId );
                }

                defer.resolve();
            } ).catch( function () {
                defer.reject();
            } );
        } ).catch( function ( response ) {
            console.error( 'Error in promise (ProjectEditionTool.addLayer)' );
            if ( view3D )
                view3D.progressLoading( 1 );
            defer.reject( response );
        } );
        return defer.promise;
    },

    addLayerToWorkspace: function ( layer, parentId ) {

        var dataCacheObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( parentId );
        if ( !dataCacheObj ) {
            console.log( 'Destination workspace group not found in cache' );
            return;
        }

        // add to workspace
        var newWksObject = {
            category: ( layer.getType() === 'VectorLayer' ) ? layer.getCategory() : layer.getType(),
            name: layer.getName(),
            type: layer.getType(),
            uuid: Utils.generateUUID(),
            catalogObjectId: layer.getId()
        };
        var wksParent = dataCacheObj.getWorkspaceObj();
        if ( !wksParent ) {
            console.log( 'Destination workspace group object not found' );
            return;
        }
        if ( !wksParent.children )
            wksParent.children = [];
        wksParent.children.push( newWksObject );

        // add to toc
        var tocParent = dataCacheObj.getLayerGroupObj();
        if ( !tocParent ) {
            console.log( 'Destination toc group object not found' );
            return;
        }
        tocParent.addChild( layer );

        Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().updateOrCreateDataCacheObject( newWksObject.uuid, newWksObject, undefined, undefined );
    },

    deleteWorkspaceLayer: function ( id ) {
        var defer = P.defer();
        // Getting layer data
        let wdc = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache();
        let dcObject = wdc.getDataCacheObject( id );

        let layer = dcObject.getLayerGroupObj();

        if ( !layer ) {
            defer.reject();
            return defer.promise;
        }
        let parentLayer = layer.getParent();
        let layerType = layer.getType();
        let isStation = layer.getCategory() === WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let isScan = layer.getCategory() === WorkspaceCategories.getCategoryProps( WorkspaceCategories.Scan ).name;

        // Getting all child layers
        var wsVisitor = new WorkspaceVisitor();

        wsVisitor.clear();
        wsVisitor.apply( dcObject.getWorkspaceObj() );

        let elements = wsVisitor.getAllElements().reverse();
        let promises = [];
        let deletedLayersInfo = [];
        // Removing all child layers
        elements.forEach( element => {
            if ( element.catalogObjectId === undefined )
                return;

            let l = this._project.getLayerById( element.catalogObjectId );
            if ( l !== undefined ) {
                promises.push( this.deleteLayer( l.getId() ) );
                deletedLayersInfo.push( { 'id': l.getId(), 'projectsCount': l.getProjectsCount() } ); // Send projectsCount to avoid requesting layer to the server
            }
        } );

        Promise.all( promises ).then( () => {
            this.deleteLayerFromWorkspace( id, parentLayer ).then( () => {
                var viewsArray = Registry.getInstance().getController( 'View' ).getViews();

                for ( var i = 0; i < viewsArray.length; i++ ) {
                    viewsArray[ i ].deleteLayer( layerType, id, layer );
                }

                elements.forEach( element => {
                    Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().removeDataCacheObject( element.uuid );
                } );
                defer.resolve( deletedLayersInfo );
            }, function ( response ) {
                defer.reject( response );
            } );
            if ( isStation || ( isScan && parentLayer.getChildren().length < 2 ) ) {
                let event = new CustomEvent( 'removeStationLinks', {
                    detail: { 'stationUuid': isStation ? id : parentLayer.getParent().getId(), 'project': this._project },
                    bubbles: true,
                    cancelable: true
                } );
                document.dispatchEvent( event );
                if ( Registry.getInstance().getController( 'ScanSelection' ).getCurrentStation() === id )
                    Registry.getInstance().getController( 'ScanSelection' ).setCurrentStation( '' );
            } else if ( isScan && parentLayer.getChildren().length >= 2 ) {
                var parentUUID = parentLayer.getParent().getId();
                Registry.getInstance().getController( 'Workspace' ).getOrCreateWorkspace( this._project, ScanWorkflow.prototype.readFromProject( this._project ).getCurrentVersion() ).then( workspace => {
                    var wsVisitor = new WorkspaceVisitor();

                    wsVisitor.clear();
                    wsVisitor.apply( workspace.workspace );

                    var parentDataCacheObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( parentUUID );
                    if ( !parentDataCacheObj ) {
                        return;
                    }

                    var wksParent = parentDataCacheObj.getWorkspaceObj();

                    let event = new CustomEvent( 'updateStationLinks', {
                        detail: { 'station': wksParent, 'project': this._project },
                        bubbles: true,
                        cancelable: true
                    } );
                    document.dispatchEvent( event );
                } );
            }
        } );

        return defer.promise;

    },

    /**
     * Removes an existing layer from the current Project.
     * @method
     * @memberof pcvizTools.ProjectEditionTool
     * @param  {string|int} id                The id of the layer to be removed.
     * @param  {SourceLayer} deleteSourceLayer If true, the layer is deleted from server; else, it is only removed from the project
     * @return {Promise}                   A promise that is resolved when the layer is removed in the database.
     */
    deleteLayer: function ( id, deleteSourceLayer, removeFromWorkspace, removeDataOnly ) {
        var defer = P.defer();
        var layer = this._project.getLayerById( id );

        if ( layer === undefined ) {
            defer.reject();
            return defer.promise;
        }

        if ( removeDataOnly && layer.canRemoveData() ) {
            layer.removeData().then( paths => {
                Registry.getInstance().getController( 'Layer' ).refreshLayerInAllViews( layer ).then( () => {
                    defer.resolve( {
                        dataPaths: paths
                    } );
                }, () => {
                    defer.reject();
                } );
            }, () => {
                defer.reject();
            } );
            return defer.promise;
        }

        var layerType = layer.getType();
        var parentLayer = layer.getParent();
        var self = this;
        this._project.deleteLayer( id, deleteSourceLayer ).then( function () {
            var viewsArray = Registry.getInstance().getController( 'View' ).getViews();

            for ( var i = 0; i < viewsArray.length; i++ ) {
                viewsArray[ i ].deleteLayer( layerType, id, layer );
            }
            if ( self._project.isScanProject() && removeFromWorkspace )
                self.deleteLayerFromWorkspace( id, parentLayer ).then( () => {
                    Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().removeDataCacheObject( layer.uuid );
                    defer.resolve();
                }, () => defer.reject() );
            else
                defer.resolve();
        } ).catch( function ( response ) {
            console.error( 'Error in promise (ProjectEditionTool.deleteLayer)' );
            defer.reject( response );
        } );

        return defer.promise;
    },

    deleteLayerFromWorkspace: function ( id, parentLayer ) {
        var defer = P.defer();

        var parentUUID = parentLayer.getId();
        const workspaceController = Registry.getInstance().getController( 'Workspace' );
        workspaceController.getOrCreateWorkspace( this._project, ScanWorkflow.prototype.readFromProject( this._project ).getCurrentVersion() ).then( workspace => {
            var wsVisitor = new WorkspaceVisitor();

            wsVisitor.clear();
            wsVisitor.apply( workspace.workspace );
            var wksLayer = wsVisitor.getElementByCatalogId( id );
            if ( wksLayer === undefined )
                wksLayer = wsVisitor.getElementById( id );
            var parentDataCacheObj = workspaceController.getWorkspaceDataCache().getDataCacheObject( parentUUID );
            if ( !parentDataCacheObj ) {
                return;
            }

            var wksParent = parentDataCacheObj.getWorkspaceObj();
            if ( !wksParent || !wksLayer ) {
                return;
            }
            var indexToRemove = wksParent.children.indexOf( wksLayer );
            wksParent.children.splice( indexToRemove, 1 );

            // IMPROVE: if there aren't more children, do we want to remove the parent node?

            workspaceController.uploadWorkspace().then( () => defer.resolve(), () => defer.reject() );
        } ).catch( function ( response ) {
            defer.reject( response );
        } );

        // Update stash workspace if exists:
        const stashWorkspace = workspaceController._tmpWorkspace ? workspaceController.stashPopWorkspace() : undefined;
        if ( stashWorkspace ) {
            const stashWorkspaceJson = JSON.parse( stashWorkspace );
            const wsVisitor = new WorkspaceVisitor();

            wsVisitor.clear();
            wsVisitor.apply( stashWorkspaceJson.workspace );
            let wksLayer = wsVisitor.getElementByCatalogId( id );
            if ( wksLayer === undefined )
                wksLayer = wsVisitor.getElementById( id );
            const wksParent = wsVisitor.getElementById( parentUUID );

            if ( !wksParent || !wksLayer ) {
                return;
            }
            const indexToRemove = wksParent.children.indexOf( wksLayer );
            wksParent.children.splice( indexToRemove, 1 );

            workspaceController._tmpWorkspace.stashWorkspace = JSON.stringify( stashWorkspaceJson );
        }

        return defer.promise;
    },

    createCategory: function ( category ) {
        return this._project.createCategory( category );
    },

    updateCategory: function ( category ) {
        return this._project.updateCategory( category );
    },

    deleteCategory: function ( categoryID ) {
        return this._project.deleteCategory( categoryID );
    },

    getCategoryTreeFromServer: function () {
        return this._project.getCategoryTreeFromServer();
    },

    getCategoryListFromServer: function () {
        return this._project.getCategoryListFromServer();
    },

    getSystemCategoryListFromServer: function () {
        return this._project.getSystemCategoryListFromServer();
    },

} );

module.exports = ProjectEditionTool;


/***/ }),

/***/ "./sources/pcvizTools/ReferencePlanesTool.js":
/*!***************************************************!*\
  !*** ./sources/pcvizTools/ReferencePlanesTool.js ***!
  \***************************************************/
/*! exports provided: REFERENCE_PLANE_COLOR, REFERENCE_PLANE_TYPES, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFERENCE_PLANE_COLOR", function() { return REFERENCE_PLANE_COLOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REFERENCE_PLANE_TYPES", function() { return REFERENCE_PLANE_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ReferencePlanesTool; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/Feature */ "./sources/pcvizGIS/Feature.js");
/* harmony import */ var pcvizGIS_LinearRing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizGIS/LinearRing */ "./sources/pcvizGIS/LinearRing.js");
/* harmony import */ var pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js");
/* harmony import */ var pcvizGIS_Polygon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizGIS/Polygon */ "./sources/pcvizGIS/Polygon.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js");
/* harmony import */ var pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js");
/* harmony import */ var pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var pcvizUtils_EigenAxis__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! pcvizUtils/EigenAxis */ "./sources/pcvizUtils/EigenAxis.js");
/* harmony import */ var pcvizUtils_EigenAxis__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_EigenAxis__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! pcvizUtils/EventKeys */ "./sources/pcvizUtils/EventKeys.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! pcvizUtils/PointVisibleCollector */ "./sources/pcvizUtils/PointVisibleCollector.js");
/* harmony import */ var _pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");

















const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

const REFERENCE_PLANE_FACTOR = 0.2;

const REFERENCE_PLANE_COLOR = osg.vec4.fromValues32( 173.0 / 255.0, 216.0 / 255.0, 230.0 / 255.0, 0.1 );
const AREA_COLOR = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.DEFAULT_SELECTION_COLOR.slice(); // color used when drawing region/area
const SLOPE_PICKING_COLOR = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.fullhexToRgb( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.HEATMAP_PICK_POINT_COLOR, 1.0, true );
const CYAN_PTS_RULE = 'cyanPoints';

const REFERENCE_PLANE_TYPES = {
    POLYGON: 0,
    RECTANGLE_POLYGON: 1,
    FIT_PICKS: 2,
    ELEVATED: 3,
    VERTICAL_FIT_PICKS: 4
};

class ReferencePlanesTool extends pcvizTools_PickTool__WEBPACK_IMPORTED_MODULE_9___default.a {
    constructor( view ) {
        super( view.getViewer(), 'referencePlanes' );
        this._view = view;
        this._viewer = view.getViewer();

        this._active = false;

        this._mode = REFERENCE_PLANE_TYPES.POLYGON;

        this._flatPolygon = false;

        this._feature = undefined;
        this._attributes = undefined;

        this._color = REFERENCE_PLANE_COLOR;

        this._pointVisibleCollector = new pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_13__["default"]();

        this._min = osg.vec3.create();
        this._max = osg.vec3.create();

        this._picksArray = [];
        this._maxHeight = -Number.MAX_VALUE;

        this._sketchTool = new pcvizRenderTools_SketchTool__WEBPACK_IMPORTED_MODULE_8___default.a( this._viewer );

        this._onRect = false;

        //Root node for reference planes geometry nodes
        this._referencePlanesRootNode = new osg.MatrixTransform();
        this._referencePlanesRootNode.setName( 'Reference Planes root' );
        this._referencePlaneNode = undefined;
        this._areaNode = undefined;

        // Tools node addition, but we use scene node matrix transform to place the planes
        this._viewer.getToolsNode().addChild( this._referencePlanesRootNode );

        this._onPositionCallback = undefined;

        this._isKeepChildren = false;
        this._asReferencePlane = true; // false when rendering an area/region for volume computation
        this._onlyComputePlane = false; // true when the plane doesn't need to be rendered

        this._pickingElements = undefined; // it will store the array of div elements to draw the circles
        this._showPickingElements = false;
        this._enableHighlightPoints = false;

        if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default.a.isSite() )
            AREA_COLOR[ 3 ] = 0.9;
    }

    setActive( active, keepChildren = false ) {
        if ( this._active === active && !this._isKeepChildren )
            return;

        this._active = active;
        this._isKeepChildren = keepChildren;

        if ( !active ) {
            this.clearTool( keepChildren );
            this.removeEventListeners();
            if ( this._pickingElements ) {
                const canvas = this._viewer.getCanvas();

                canvas.addEventListener( 'mousewheel', this._wheelFunction );
                // To listen wheel event in Firefox
                canvas.addEventListener( 'DOMMouseScroll', this._wheelFunction );
                canvas.addEventListener( 'mousedown', this._wheelFunction ); // Use same function than scroll to clear the picking elements
            }
        } else {
            this.removeEventListeners(); // pick tool super constructor calls first setUpEventListeners
            this.setUpEventListeners();

            // We need to iit here since class constructor is called before scene initialization
            this._referencePlanesRootNode.setMatrix( this._view.getSceneNode().getTransformNode().getMatrix() );

            this.updateExtent();

            this._feature = new pcvizGIS_Feature__WEBPACK_IMPORTED_MODULE_3__["Feature"](); // Create a feature to store in layer.

            if ( !this._areaNode ) {
                this._areaNode = new osg.Node();
                this._referencePlanesRootNode.addChild( this._areaNode );
            }
            if ( !this._referencePlaneNode ) {
                this._referencePlaneNode = new osg.Node();
                this._referencePlanesRootNode.addChild( this._referencePlaneNode );
            }

            this._onlyComputePlane = false;
        }
    }

    setUpEventListeners() {
        super.setUpEventListeners();

        const canvas = this._viewer.getCanvas();
        canvas.addEventListener( 'mousemove', this._mousemoveFunction );
        if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default.a.isSite() && pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.isTouchByTouchPoints() ) {
            canvas.addEventListener( 'touchmove', this._mousemoveFunction );
        }
    }

    removeEventListeners() {
        super.removeEventListeners();

        const canvas = this._viewer.getCanvas();
        canvas.removeEventListener( 'mousemove', this._mousemoveFunction );
        if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default.a.isSite() && pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.isTouchByTouchPoints() && !this._pickingElements ) {
            canvas.removeEventListener( 'touchmove', this._mousemoveFunction );
        }
    }

    clearTool( keepChildren ) {
        this.clearPicks();
        if ( !keepChildren ) {
            this.clearReferencePlanes();
            this._referencePlanesRootNode.removeChild( this._referencePlaneNode );
            this._referencePlaneNode = undefined;
            this.clearArea();
            this._referencePlanesRootNode.removeChild( this._areaNode );
            this._areaNode = undefined;
            this._mode = REFERENCE_PLANE_TYPES.POLYGON;
            this._flatPolygon = false;
            this._feature = undefined;
            this._attributes = undefined;
            this._color = REFERENCE_PLANE_COLOR;
            this._min = osg.vec3.create();
            this._max = osg.vec3.create();
        }

        this._onPositionCallback = undefined;
        this._showPickingElements = false;
        this._enableHighlightPoints = false;
    }

    changeColor( newColor ) {
        this._color = newColor;
    }

    getPicksArray() {
        return this._picksArray;
    }

    setPicksArray( picks ) {
        this._picksArray = picks;
    }

    setMode( mode ) {
        this._mode = mode;
    }

    setFlatPolygon( flatPolygon ) {
        this._flatPolygon = flatPolygon;
    }

    getFeature() {
        return this._feature;
    }

    hasReferencePlane() {
        return !!this._referencePlanesRootNode.children.length && this._referencePlaneNode && this._referencePlaneNode.getChildren().length;
    }

    setLayer( layer ) {
        if ( !layer ) {
            return;
        }

        this._feature.setLayer( layer );

        // Show the name in the properties window (THQ request)
        this._attributes.name = layer.getName();

        const layerSelectedColor = layer.getStyle().PolygonSymbolizer.fillColor;
        this._color = osg.vec4.fromValues( layerSelectedColor[ 0 ] / 255.0, layerSelectedColor[ 1 ] / 255.0, layerSelectedColor[ 2 ] / 255.0, 0.1 );
        this.addReferenceAttributes( this._attributes );
    }

    registerPositionListener( fn ) {
        this._onPositionCallback = fn;
    }

    updateExtent() {
        // Compute scene node bounding to calculate the extent in elevation reference planes.
        const sceneExtent = this._view.calculateSceneExtent( true, true );

        this._min = osg.vec3.fromValues( sceneExtent[ 0 ], sceneExtent[ 1 ], sceneExtent[ 2 ] );
        this._max = osg.vec3.fromValues( sceneExtent[ 3 ], sceneExtent[ 4 ], sceneExtent[ 5 ] );

        // Apply the scale factor to plane dimensions.
        let dim = [ ( this._max[ 0 ] - this._min[ 0 ] ) * 0.5, ( this._max[ 1 ] - this._min[ 1 ] ) * 0.5, ( this._max[ 2 ] - this._min[ 2 ] ) * 0.5 ];
        osg.vec3.scale( dim, dim, REFERENCE_PLANE_FACTOR );

        osg.vec3.sub( this._min, this._min, dim );
        osg.vec3.add( this._max, this._max, dim );
    }

    updateReferencePlane() {
        if ( !this._feature || !this._feature.getGeometry() || !this._feature.getGeometry().getExteriorRing() ) {
            return;
        }

        const points = [];
        const geometry = this._feature.getGeometry().getExteriorRing();
        for ( let pt of geometry._points ) {
            points.push( [ pt[ 0 ], pt[ 1 ], pt[ 2 ] ] );
        }


        const referencePlane = this.drawGeometry( points );
        this.replaceNode( referencePlane, false );
    }

    createFlatPolygon() {
        const vertices = this._picksArray.map( ( pick ) => { return osg.vec3.fromValues( pick[ 0 ], pick[ 1 ], this._maxHeight ); } );

        this.drawPolygon( vertices, false );
    }

    createPolygonByPickPoint( pickPoint, flatPolygon ) {
        this.addPickPoint( pickPoint );

        if ( flatPolygon ) {
            this.createFlatPolygon();
            return;
        }

        this.drawPolygon( this._picksArray.slice(), false );
    }

    drawPolygon( vertices, needsClearPicks ) {
        this.addFeatureGeometry( vertices );
        let osgGeometry;
        const isAreaAndSite = !this._asReferencePlane && pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default.a.isSite();
        if ( vertices.length < 3 ) {
            osgGeometry = this.drawGeometry( vertices, true, isAreaAndSite );
        } else {
            osgGeometry = this.drawGeometry( vertices, isAreaAndSite, isAreaAndSite );
            this._attributes = this.calculatePolygonAttributes();
        }

        if ( isAreaAndSite ) {
            const depth = new osg.Depth( osg.Depth.ALWAYS );
            depth.setWriteMask( true );
            osgGeometry.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );
        }
        if ( osgGeometry ) {
            this.replaceNode( osgGeometry, needsClearPicks );
        }
    }

    addPickPoint( pickPoint ) {
        if ( pickPoint !== undefined ) {
            this._picksArray.push( pickPoint );
            this._maxHeight = Math.max( pickPoint[ 2 ], this._maxHeight );
            return;
        }

        // Recalculates max height point
        for ( let pick of this._picksArray ) {
            this._maxHeight = Math.max( pick[ 2 ], this._maxHeight );
        }
    }

    createPolygonByRect( screenCornerInit, screenCornerFinal, commitPolygon ) {
        // Transform point from screen positions to window positions
        const cam = this._viewer.getCamera();
        const mat = osg.mat4.create();
        osg.mat4.multiply( mat, mat, cam.getViewport() ? cam.getViewport().computeWindowMatrix( osg.mat4.create() ) : osg.mat4.create() );
        osg.mat4.multiply( mat, mat, cam.getProjectionMatrix() );
        osg.mat4.multiply( mat, mat, cam.getViewMatrix() );
        osg.mat4.invert( mat, mat );

        let initPosWorld = osg.vec3.create();
        let finalPosWorld = osg.vec3.create();

        osg.vec3.transformMat4( initPosWorld, screenCornerInit, mat );
        osg.vec3.transformMat4( finalPosWorld, screenCornerFinal, mat );

        // Translate to scene center
        const center = this._viewer.getCenter();
        osg.vec3.add( initPosWorld, initPosWorld, center );
        osg.vec3.add( finalPosWorld, finalPosWorld, center );

        const corner1 = osg.vec3.fromValues( initPosWorld[ 0 ], initPosWorld[ 1 ], this._max[ 2 ] );
        const corner2 = osg.vec3.fromValues( initPosWorld[ 0 ], finalPosWorld[ 1 ], this._max[ 2 ] );
        const corner3 = osg.vec3.fromValues( finalPosWorld[ 0 ], finalPosWorld[ 1 ], this._max[ 2 ] );
        const corner4 = osg.vec3.fromValues( finalPosWorld[ 0 ], initPosWorld[ 1 ], this._max[ 2 ] );

        const corners = [ corner1, corner2, corner3, corner4 ];

        if ( commitPolygon ) {
            this._picksArray = corners;
            this.drawPolygon( this._picksArray.slice(), false );
        } else {
            let osgGeometry = this.drawGeometry( corners );
            this.replaceNode( osgGeometry, true );
        }
    }

    createReferencePlaneByHeight( height ) {
        const corner1 = [ this._min[ 0 ], this._min[ 1 ], height ];
        const corner2 = [ this._max[ 0 ], this._min[ 1 ], height ];
        const corner3 = [ this._max[ 0 ], this._max[ 1 ], height ];
        const corner4 = [ this._min[ 0 ], this._max[ 1 ], height ];

        const cornerPositions = [ corner1, corner2, corner3, corner4 ];
        const planePositions = [ corner1, corner2, corner3 ];
        // Passes the vector with just 3 corners for calculating plane attributes and the vector with 4 corners for computing the centroid
        const plane = this.calculatePlane( planePositions, cornerPositions );

        this.addFeatureGeometry( cornerPositions );

        // to get the area after adding positions to feature
        this.addPlaneArea( plane );

        this._attributes = plane;

        const referencePlane = this.drawGeometry( cornerPositions );
        // This method is only used as reference plane for now
        this.replaceNode( referencePlane, true );
    }

    createReferencePlaneByFitPicks( pickPoint ) {
        this._picksArray.push( pickPoint );

        const vertices = this._picksArray.slice();

        if ( vertices.length === 1 ) {
            vertices.push( osg.vec3.fromValues( this._picksArray[ 0 ][ 0 ] + 5, this._picksArray[ 0 ][ 1 ], this._picksArray[ 0 ][ 2 ] ) );
            vertices.push( osg.vec3.fromValues( this._picksArray[ 0 ][ 0 ], this._picksArray[ 0 ][ 1 ] + 5, this._picksArray[ 0 ][ 2 ] ) );
        } else if ( vertices.length === 2 ) {
            vertices.push( osg.vec3.fromValues( ( this._picksArray[ 0 ][ 0 ] + this._picksArray[ 1 ][ 0 ] ) / 2, ( ( this._picksArray[ 0 ][ 1 ] + this._picksArray[ 1 ][ 1 ] ) / 2 ) + 5, ( this._picksArray[ 0 ][ 2 ] + this._picksArray[ 1 ][ 2 ] ) / 2 ) );
        }
        this._createPlaneFromVertices( vertices );
    }

    createVerticalReferencePlaneByFitPicks( pickPoint ) {
        this._picksArray.push( pickPoint );

        let vertices = this._picksArray.slice();

        if ( vertices.length > 2 ) {
            vertices = vertices.slice( -2 );
        } else if ( vertices.length === 1 ) {
            // This vertice only shares Y value but its purpose is to show some feedback to the user
            vertices.push( osg.vec3.fromValues( this._picksArray[ 0 ][ 0 ] + 5, this._picksArray[ 0 ][ 1 ], this._picksArray[ 0 ][ 2 ] - 5 ) );
        }
        // Now vertices should have 2 elements in every case. Add a vertice with same X,Y values and a different Z since a vertical plane is required.
        vertices.push( osg.vec3.fromValues( this._picksArray.at( -1 )[ 0 ], this._picksArray.at( -1 )[ 1 ], this._picksArray.at( -1 )[ 2 ] + 5 ) );
        this._createPlaneFromVertices( vertices );
    }

    _createPlaneFromVertices( vertices ) {
        const plane = this.calculatePlane( vertices ); // TODO: Check centroid value for this case

        const vecX = osg.vec3.scale( osg.vec3.create(), plane.eigen1, plane.length / 2 );
        const vecY = osg.vec3.scale( osg.vec3.create(), plane.eigen2, plane.width / 2 );

        let corner1 = osg.vec3.add( osg.vec3.create(), vecX, vecY );
        let corner2 = osg.vec3.sub( osg.vec3.create(), vecX, vecY );
        let corner3 = osg.vec3.sub( osg.vec3.create(), osg.vec3.fromValues( -vecX[ 0 ], -vecX[ 1 ], -vecX[ 2 ] ), vecY );
        let corner4 = osg.vec3.add( osg.vec3.create(), osg.vec3.fromValues( -vecX[ 0 ], -vecX[ 1 ], -vecX[ 2 ] ), vecY );

        osg.vec3.add( corner1, corner1, plane.centroid );
        osg.vec3.add( corner2, corner2, plane.centroid );
        osg.vec3.add( corner3, corner3, plane.centroid );
        osg.vec3.add( corner4, corner4, plane.centroid );

        const pos = [ corner1, corner2, corner3, corner4 ];

        this.addFeatureGeometry( pos );

        // to get the area after adding positions to feature
        this.addPlaneArea( plane );

        this._attributes = plane;

        const referencePlane = this.drawGeometry( pos );
        this.replaceNode( referencePlane, false );
        // This condition is to render the points clicked for Slope Heatmap (CS)
        if ( this._onlyComputePlane && this._mode === REFERENCE_PLANE_TYPES.FIT_PICKS ) {
            // Draw points
            const points = this._sketchTool.drawPoints( this._picksArray.slice(), SLOPE_PICKING_COLOR );

            // To render them above the Control Points
            points.getOrCreateStateSet().setRenderBinDetails( pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.RENDERBIN_SELECTED_VERT, 'DepthSortedBin' );
            const depth = new osg.Depth( osg.Depth.ALWAYS );
            points.getOrCreateStateSet().setAttributeAndModes( depth, osg.StateAttribute.ON | osg.StateAttribute.OVERRIDE );

            // Draw contours
            const planeGeoms = this._sketchTool.drawArea( this._picksArray.slice(), false, SLOPE_PICKING_COLOR );

            const node = new osg.Node();
            node.addChild( points );
            node.addChild( planeGeoms.wire );

            this.clearReferencePlanes( false );
            this._referencePlaneNode.addChild( node );
        }
    }

    // This method is not used currently but can be useful
    createReferencePlaneByCloudSelection() {
        const pointSelection = this.collectSelectedPoints();

        if ( pointSelection.length < 3 ) {
            return false;
        }

        const plane = this.calculatePlane( pointSelection );

        const vecX = osg.vec3.scale( osg.vec3.create(), plane.eigen1, plane.length / 2 );
        const vecY = osg.vec3.scale( osg.vec3.create(), plane.eigen2, plane.width / 2 );

        let corner1 = osg.vec3.add( osg.vec3.create(), vecX, vecY );
        let corner2 = osg.vec3.sub( osg.vec3.create(), vecX, vecY );
        let corner3 = osg.vec3.sub( osg.vec3.create(), osg.vec3.fromValues( -vecX[ 0 ], -vecX[ 1 ], -vecX[ 2 ] ), vecY );
        let corner4 = osg.vec3.add( osg.vec3.create(), osg.vec3.fromValues( -vecX[ 0 ], -vecX[ 1 ], -vecX[ 2 ] ), vecY );

        osg.vec3.add( corner1, corner1, plane.centroid );
        osg.vec3.add( corner2, corner2, plane.centroid );
        osg.vec3.add( corner3, corner3, plane.centroid );
        osg.vec3.add( corner4, corner4, plane.centroid );

        const pos = [ corner1, corner2, corner3, corner4 ];

        this.addFeatureGeometry( pos );

        // to get the area after adding positions to feature
        this.addPlaneArea( plane );

        this._attributes = plane;

        const referencePlane = this.drawGeometry( pos );
        this.replaceNode( referencePlane, false );

        return true;
    }

    addFeatureGeometry( vertices ) {
        const ring = new pcvizGIS_LinearRing__WEBPACK_IMPORTED_MODULE_4__["default"]();

        for ( let pt of vertices ) {
            ring.addPoint( new pcvizGIS_Point__WEBPACK_IMPORTED_MODULE_5__["default"]( pt[ 0 ], pt[ 1 ], pt[ 2 ] ) );
        }

        const polygon = new pcvizGIS_Polygon__WEBPACK_IMPORTED_MODULE_6__["default"]();
        polygon.addRing( ring );

        this._feature.setGeometry( polygon );
    }

    addReferenceAttributes( reference ) {
        if ( !this._feature.getLayer() ) {
            return;
        }

        if ( reference.centroid ) {
            let centroidNames = [ 'centroid(x)', 'centroid(y)', 'centroid(z)' ];
            this._feature.setAttributesByNameArray( centroidNames, reference.centroid );
        }

        if ( reference.eigen1 ) {
            let eigen1Names = [ 'eigen1(x)', 'eigen1(y)', 'eigen1(z)' ];
            this._feature.setAttributesByNameArray( eigen1Names, reference.eigen1 );
        }

        if ( reference.eigen2 ) {
            let eigen2Names = [ 'eigen2(x)', 'eigen2(y)', 'eigen2(z)' ];
            this._feature.setAttributesByNameArray( eigen2Names, reference.eigen2 );
        }

        if ( reference.normal ) {
            let normalNames = [ 'normal(x)', 'normal(y)', 'normal(z)' ];
            this._feature.setAttributesByNameArray( normalNames, reference.normal );
        }

        if ( reference.length ) {
            this._feature.setAttributeByName( 'length', reference.length );
        }

        if ( reference.area ) {
            this._feature.setAttributeByName( 'area', reference.area );
        }

        if ( reference.width ) {
            this._feature.setAttributeByName( 'width', reference.width );
        }

        if ( reference.height ) {
            this._feature.setAttributeByName( 'height', reference.height );
        }

        if ( reference.name ) {
            this._feature.setAttributeByName( 'name', reference.name );
        }
    }

    drawGeometry( positions, wired, drawPoints ) {
        if ( this._onlyComputePlane )
            return;
        // Temporally, we use this base color. In the future, when reference plane is added to layer, it will take layer's style fill color.
        const plane = this._sketchTool.drawArea( positions, false, this._color );
        if ( drawPoints ) {
            const points = this._sketchTool.drawPoints( positions, this._color );
            const node = new osg.Node();
            node.addChild( wired ? plane.wire : plane.area );
            node.addChild( points );
            return node;
        }
        if ( wired ) {
            return plane.wire;
        }
        return plane.area;
    }

    clearReferencePlanes( clearPicks ) {
        if ( this._referencePlaneNode ) {
            this._referencePlaneNode.removeChildren();
        }

        if ( clearPicks ) {
            this.clearPicks();
        }
    }

    clearPicks() {
        this._picksArray = [];
        this._maxHeight = -Number.MAX_VALUE;
    }

    clearArea( needsClearPicks ) {
        if ( this._areaNode )
            this._areaNode.removeChildren();
        if ( needsClearPicks )
            this.clearPicks();
    }

    collectSelectedPoints() {
        this._pointVisibleCollector.reset();
        this._pointVisibleCollector.setMode( pcvizUtils_PointVisibleCollector__WEBPACK_IMPORTED_MODULE_13__["COLLECT_POINT_MODES"].SELECTED );
        this._pointVisibleCollector.setViewerCenter( this._viewer.getCenter() );
        this._view.getSceneNode().accept( this._pointVisibleCollector );
        const selectedPoints = this._pointVisibleCollector.getWorldPoints();
        return selectedPoints;
    }

    calculatePlane( vertices, verticesForCentroid ) {
        let plane = {};

        const eigenAxis = new pcvizUtils_EigenAxis__WEBPACK_IMPORTED_MODULE_10___default.a( vertices );

        const eigenVecs = eigenAxis.getEigenAxis();

        // Centroid calcs
        let centroid = [ 0.0, 0.0, 0.0 ];
        let verticesLength = vertices.length;
        if ( verticesForCentroid ) {
            verticesForCentroid.forEach( ( point ) => { osg.vec3.add( centroid, centroid, point ); } );
            verticesLength = verticesForCentroid.length;
        } else
            vertices.forEach( ( point ) => { osg.vec3.add( centroid, centroid, point ); } );
        centroid[ 0 ] = centroid[ 0 ] / verticesLength;
        centroid[ 1 ] = centroid[ 1 ] / verticesLength;
        centroid[ 2 ] = centroid[ 2 ] / verticesLength;

        // Length, width, height calcs
        let length = 0.0;
        let width = 0.0;
        let height = 0.0;
        for ( let point of vertices ) {
            let currentPoint = osg.vec3.sub( osg.vec3.create(), point, centroid );

            let lx = osg.vec3.dot( eigenVecs.R, currentPoint );
            lx = Math.abs( lx );
            if ( lx > length ) {
                length = lx;
            }

            let wy = osg.vec3.dot( eigenVecs.S, currentPoint );
            wy = Math.abs( wy );
            if ( wy > width ) {
                width = wy;
            }

            let hz = osg.vec3.dot( eigenVecs.T, currentPoint );
            hz = Math.abs( hz );
            if ( hz > height ) {
                height = hz;
            }
        }

        length = length * 2;
        width = width * 2;
        height = height * 2;

        plane.centroid = centroid;
        plane.eigen1 = eigenVecs.R;
        plane.eigen2 = eigenVecs.S;
        plane.normal = eigenVecs.T;
        plane.length = length;
        plane.width = width;
        plane.height = height;

        return plane;
    }

    addPlaneArea( plane ) {
        let gisRing = this._feature.getGeometry().getExteriorRing();
        plane.area = gisRing.getArea();
    }

    calculatePolygonAttributes() {
        let polygon = {};

        // These polygons only have one exterior ring
        let gisRing = this._feature.getGeometry().getExteriorRing();


        polygon.centroid = gisRing.getCentroid();
        polygon.length = gisRing.length();
        polygon.area = gisRing.getArea();

        return polygon;
    }

    enablingCameraManipulator( enable ) {
        if ( this._viewer && this._viewer.getManipulator() ) {
            if ( enable ) { // Enable manipulator
                this._viewer.getManipulator().getRotateInterpolator().reset();
                this._viewer.getManipulator().getPanInterpolator().reset();
                const manipulatorTarget = osg.vec3.create();
                osg.vec3.copy( manipulatorTarget, this._viewer.getManipulator()._target );
                this._viewer.restoreManipulatorDoubleClick();
                this._viewer.enableManipulator( true );
                if ( this._viewer.getManipulator().setPivotPoint ) {
                    this._viewer.getManipulator().setPivotPoint( manipulatorTarget );
                }
                return;
            }
            // Disable manipulator
            this._viewer.disableManipulatorDoubleClick();
            this._viewer.enableManipulator( false );
        }

    }

    createSurfaceByPosition( position ) {
        switch ( this._mode ) {
        case REFERENCE_PLANE_TYPES.POLYGON:
            this.createPolygonByPickPoint( position, this._flatPolygon );
            break;
        case REFERENCE_PLANE_TYPES.ELEVATED:
            this.createReferencePlaneByHeight( position[ 2 ] );
            break;
        case REFERENCE_PLANE_TYPES.FIT_PICKS:
            this.createReferencePlaneByFitPicks( position );
            break;
        case REFERENCE_PLANE_TYPES.VERTICAL_FIT_PICKS:
            this.createVerticalReferencePlaneByFitPicks( position );
            break;
        }

        this._onPositionCallback( position );
    }

    setAsReferencePlane( flag ) {
        this._asReferencePlane = flag;
        this.changeColor( flag ? REFERENCE_PLANE_COLOR : AREA_COLOR );
    }

    replaceNode( node, needsClearPicks ) {
        if ( this._onlyComputePlane )
            return;
        if ( this._asReferencePlane ) {
            this.clearReferencePlanes( needsClearPicks );
            this._referencePlaneNode.addChild( node );
        } else {
            this.clearArea();
            this._areaNode.addChild( node );
        }
    }

    getPlaneAttributes() {
        return this._attributes;
    }

    setOnlyComputePlane( flag ) {
        this._onlyComputePlane = flag;
    }

    getOnlyComputePlane() {
        return this._onlyComputePlane;
    }

    showPickingElements( visibleFlag ) {
        this._showPickingElements = visibleFlag;
    }

    enableHighlightPoints( enableFlag ) {
        this._enableHighlightPoints = enableFlag;
        const overwriteSymbologyController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'OverwriteSymbology' );
        if ( enableFlag ) {
            overwriteSymbologyController.runOverwrittenSymbology( [ 'controlPointHeatmap' ], undefined, true ).catch( () => {
                console.error( 'ReferencePlanesTool:enableHighlightPoints: error overwriting symbology.' );
            } );
            return;
        }
        overwriteSymbologyController.restoreSymbology( true ).catch( () => {
            console.error( 'ReferencePlanesTool:enableHighlightPoints: error restoring symbology.' );
        } );
    }

    getOrCreatePickingElements( size ) {
        const canvas = this._viewer.getCanvas();
        if ( this._pickingElements === undefined ) {
            this._pickingElements = [];
            for ( let i = 0; i < size; i++ ) {
                const pickingElement = this.createPickingElement();
                pickingElement.style.borderColor = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.HEATMAP_PICK_POINT_COLOR;
                this._pickingElements.push( pickingElement );

                canvas.parentElement.insertBefore( pickingElement, canvas );
            }
        }

        return this._pickingElements;
    }

    drawPickingElementByIndex( hit, index ) {
        if ( !this._showPickingElements )
            return;
        // Currently we need 2 elements for showing picks when creating a vertical plane (or 1 for ELEVATED)
        const PICKING_ELEMENTS_SIZE = this._mode === REFERENCE_PLANE_TYPES.ELEVATED ? 1 : 2;
        const pickingElement = this.getOrCreatePickingElements( PICKING_ELEMENTS_SIZE )[ index ];
        this.drawPickingDiv( pickingElement, hit );
    }

    clearPickingElements( fromEvent ) {
        if ( !fromEvent ) {
            this.enableHighlightPoints( false );
        }
        if ( !this._pickingElements )
            return;
        for ( let i = 0; i < this._pickingElements.length; i++ ) {
            this._pickingElements[ i ].remove();
        }
        this._pickingElements = undefined;
        if ( !this._active ) {
            const canvas = this._viewer.getCanvas();

            canvas.removeEventListener( 'mousewheel', this._wheelFunction );
            canvas.removeEventListener( 'DOMMouseScroll', this._wheelFunction );
            canvas.removeEventListener( 'mousedown', this._wheelFunction );

            if ( pcvizUtils_MagnetAPI__WEBPACK_IMPORTED_MODULE_12___default.a.isSite() && pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.isTouchByTouchPoints() ) {
                canvas.removeEventListener( 'touchmove', this._mousemoveFunction );
            }
        }
    }

    highlightControlPoint( hit, layer ) {
        const featureId = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getFeatureId( hit._nodePath, hit._primitiveIndex );

        if ( !layer.getStyle().PointSymbolizer.RuleSymbolizer ) {
            return;
        }

        const rule = layer.getStyle().PointSymbolizer.RuleSymbolizer.rules.find( ( r ) => { return r.id === CYAN_PTS_RULE; } );

        if ( !rule )
            return;

        rule.expression.rightExp.constant += ',' + featureId;

        layer.updateSymbolRendererAndRefreshLayerInViews();
    }

    declareFunctions() {
        const self = this;

        this._keydownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( ev.key === pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_11__["EVENT_KEYS"].ESCAPE || ev.key === pcvizUtils_EventKeys__WEBPACK_IMPORTED_MODULE_11__["EVENT_KEYS"].ESC ) {
                self.clearReferencePlanes( true );
                self._onPositionCallback( [ 0, 0, 0 ] ); // to update widget information
            }

            ev.stopPropagation();
        };

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // only left click
            if ( ev.button !== 0 ) {
                return;
            }

            if ( self._mode === REFERENCE_PLANE_TYPES.RECTANGLE_POLYGON ) {
                // Disable viewer manipulator
                self.enablingCameraManipulator( false );
                self._onRect = true;
            }

            // save the mouse position to check if there's a drag event
            self.mousePosX = ev.clientX;
            self.mousePosY = ev.clientY;

            ev.stopPropagation();
        };

        this._mousemoveFunction = function ( ev ) {
            if ( ev.button === undefined )
                self.clearPickingElements( true );
            if ( !self.isToolActive() )
                return;

            // only left click
            if ( ev.button !== 0 ) {
                return;
            }

            const isMobile = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.isTouchEnabled();
            let clientX, clientY;
            if ( isMobile ) {
                clientX = ev.changedTouches[ 0 ].clientX;
                clientY = ev.changedTouches[ 0 ].clientY;
            } else {
                clientX = ev.clientX;
                clientY = ev.clientY;
            }

            if ( self._mode === REFERENCE_PLANE_TYPES.RECTANGLE_POLYGON ) {
                if ( !self._onRect ) {
                    return;
                }

                let initPosX = self.mousePosX;
                let initPosY = self.mousePosY;
                let finalPosX = clientX;
                let finalPosY = clientY;

                let offset = [];
                const canvas = self._viewer.getCanvas();
                self._viewer.getOffsetRect( canvas, offset );
                const ratioX = canvas.width / canvas.clientWidth;
                const ratioY = canvas.height / canvas.clientHeight;

                initPosX = ( ( initPosX - offset[ 1 ] ) * ratioX );
                finalPosX = ( ( finalPosX - offset[ 1 ] ) * ratioX );
                initPosY = ( ( canvas.clientHeight - ( initPosY - offset[ 0 ] ) ) * ratioY );
                finalPosY = ( ( canvas.clientHeight - ( finalPosY - offset[ 0 ] ) ) * ratioY );

                const initPos = osg.vec3.fromValues( initPosX, initPosY, 0 );
                const finalPos = osg.vec3.fromValues( finalPosX, finalPosY, 0 );

                self.createPolygonByRect( initPos, finalPos, false );
            }

            ev.stopPropagation();

        };

        this._mouseupFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            // only left click
            if ( ev.button !== 0 ) {
                return;
            }

            const isMobile = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.isTouchEnabled();
            let clientX, clientY;
            if ( isMobile ) {
                clientX = ev.changedTouches[ 0 ].clientX;
                clientY = ev.changedTouches[ 0 ].clientY;
            } else {
                clientX = ev.clientX;
                clientY = ev.clientY;
            }

            // Rectangle polygon mode
            if ( self._mode === REFERENCE_PLANE_TYPES.RECTANGLE_POLYGON ) {
                let initPosX = self.mousePosX;
                let initPosY = self.mousePosY;
                let finalPosX = clientX;
                let finalPosY = clientY;

                let offset = [];
                const canvas = self._viewer.getCanvas();
                self._viewer.getOffsetRect( canvas, offset );
                const ratioX = canvas.width / canvas.clientWidth;
                const ratioY = canvas.height / canvas.clientHeight;

                initPosX = ( ( initPosX - offset[ 1 ] ) * ratioX );
                finalPosX = ( ( finalPosX - offset[ 1 ] ) * ratioX );
                initPosY = ( ( canvas.clientHeight - ( initPosY - offset[ 0 ] ) ) * ratioY );
                finalPosY = ( ( canvas.clientHeight - ( finalPosY - offset[ 0 ] ) ) * ratioY );

                const initPos = osg.vec3.fromValues( initPosX, initPosY, 0 );
                const finalPos = osg.vec3.fromValues( finalPosX, finalPosY, 0 );

                self.createPolygonByRect( initPos, finalPos, true );
                self._onPositionCallback(); // update region setting on widget

                // Enable viewer manipulator
                self.enablingCameraManipulator( true );
                self._onRect = false;

                ev.stopPropagation();

                return;
            }

            // Avoid dragging on surfaces by picking
            if ( self.isDrag( ev.clientX, ev.clientY ) ) {
                self.mousePosX = 0;
                self.mousePosY = 0;
                return;
            }

            let hits = self._viewer.computeAllIntersections( ev, clientX, clientY, self._onlyComputePlane );

            if ( hits.length < 1 ) {
                return;
            }

            let hit;
            if ( self._onlyComputePlane ) {
                // Use same priority than in InformationTool
                const selectionObject = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getInstance().getController( 'SelectionObject' ).getSelectionObject();
                const selectedLayer = selectionObject ? selectionObject.getLayer() : undefined;
                hit = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getPriorHit( hits, selectedLayer && selectedLayer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].VECTOR ? selectedLayer : undefined );
            } else {
                // Sort hits by distance
                hits.sort( ( hit1, hit2 ) => {
                    if ( hit1._distance === undefined || hit2._distance === undefined )
                        return 0;
                    return hit1._distance - hit2._distance;
                } );
                hit = hits[ 0 ];
            }

            self.drawPickingElementByIndex( hit, self._picksArray.length );
            if ( self._enableHighlightPoints ) {
                const layer = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.findLayerInNodePath( hit._nodePath );
                if ( layer && layer.getType() === pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].VECTOR && _pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_14__["default"].isControlPoint( layer.getCategory() ) ) {
                    self.highlightControlPoint( hit, layer );
                }
            }

            let pos = self._viewer.calculateWorldHitCoords( hit );

            self.createSurfaceByPosition( pos );

            ev.stopPropagation();
        };

        this._wheelFunction = function () {
            self.clearPickingElements( true );
        };

    }

}


/***/ }),

/***/ "./sources/pcvizTools/RegionTool.js":
/*!******************************************!*\
  !*** ./sources/pcvizTools/RegionTool.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );
var CompassTool = __webpack_require__( /*! pcvizRenderTools/CompassTool */ "./sources/pcvizRenderTools/CompassTool.js" );
var SketchTool = __webpack_require__( /*! pcvizRenderTools/SketchTool */ "./sources/pcvizRenderTools/SketchTool.js" );

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

const ScanWorkflow = __webpack_require__( /*! pcvizWorkflow/ScanWorkflow */ "./sources/pcvizWorkflow/ScanWorkflow.js" );

var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;

var MAX_NUMBER_POINTS = 5; // segments
var MIN_BOX_SIZE = 0.1;

/**
 *  Information tool
 *  @class
 *  @memberof pcvizTools
 *  @extends PickTool
 */
var RegionTool = function ( sceneView ) {
    PickTool.call( this, sceneView.getViewer(), 'region' );

    this._view = sceneView;
    this._workflow = undefined; // workflow instance in the UI, to keep region in sync

    sceneView.getViewer().addTool( this ); // since it is not in the toolbar, we need to add it to get update calls

    // group to draw the geometry and texts
    this._toolNode = new osg.Node();
    this._toolNode.setName( 'regionTool' );

    this._nodeNames = [ 'xMin', 'xMax', 'yMin', 'yMax', 'zMin', 'zMax' ];

    this._rotationAngleRads = 0;
    this.calculateNormals();

    this._canvas = sceneView.getViewer().getGraphicContext().canvas;
    this._sketchTool = new SketchTool( undefined );

    sceneView.getViewer().getToolsNode().addChild( this._toolNode );

    this._planeProgram = undefined;

    this._active = false; // TODO: Init the tool as the other tools in the picking group, then remove this line
    this._saveRegionInProject = true;
};

RegionTool.prototype = osg.objectInherit( PickTool.prototype, {

    setActive: function ( active, hideFrame ) {

        // refresh cube in 3D
        if ( active || !hideFrame ) {
            this.ensureRegion();
            this.drawCube( active );
        }

        if ( this._active === active )
            return;

        this._active = active;
        var self = this;

        if ( !active ) {
            this.clearTool();
            if ( !hideFrame ) // do not control other tools when this one is subordinated
                this.enableOtherTools( true );
            if ( !this.wasPickingEnabled )
                this._view.getViewer().setPickingEnabled( false );
            this._view.setEnableIntersections( true, LayerType.VECTOR );
            // restore interaction
            this._state = 'idle';
            this._view.getViewer().enableManipulator( true );
            this._view.getViewer().setMobileNodeFilterCB( undefined );

            if ( hideFrame )
                this.clearCube();
        } else {
            if ( !hideFrame ) // do not control other tools when this one is subordinated
                this.enableOtherTools( false );
            // restrict picking
            this.wasPickingEnabled = this._view.getViewer().isPickingEnabled();
            if ( !this.wasPickingEnabled )
                this._view.getViewer().setPickingEnabled( true );
            this._view.setEnableIntersections( false, LayerType.VECTOR );
            this._view.getViewer().disableManipulatorDoubleClick();
            this._view.getViewer().setMobileNodeFilterCB( function ( node ) {
                return self._nodeNames.indexOf( node.getName() ) !== -1;
            } );
        }
    },

    setProject: function ( project ) {

        if ( !project )
            return;

        this._project = project;
    },

    setUIRefreshCB: function ( cb ) {
        this._UIRefreshCB = cb;
    },

    setSaveRegionInProject: function ( save ) {
        this._saveRegionInProject = save;
    },

    setWorkflow: function ( workflow ) {
        this._workflow = workflow;
    },

    setRegion: function ( region ) {
        this._region = region;
    },

    getRegion: function () {

        this.ensureRegion();

        if ( !this._region )
            return undefined;

        this._region.angleRads = this._rotationAngleRads;
        this._region.rotCenter = this.getCenter();

        return this._region;
    },

    ensureRegion: function () {
        if ( !this._region )
            this._region = ScanWorkflow.prototype.getROIFromProject( this._project );
        if ( !this._region )
            this.resetRegion( false );
    },

    setAngleRads: function ( angleRads ) {
        this._rotationAngleRads = angleRads;

        this.calculateNormals();
        if ( this._region )
            this.drawCube( true );
    },

    calculateNormals: function () {

        var sinRot = Math.sin( this._rotationAngleRads );
        var cosRot = Math.cos( this._rotationAngleRads );

        this._normals = new Map();
        this._normals.set( this._nodeNames[ 0 ], [ -cosRot, -sinRot, 0 ] );
        this._normals.set( this._nodeNames[ 1 ], [ cosRot, sinRot, 0 ] );
        this._normals.set( this._nodeNames[ 2 ], [ sinRot, -cosRot, 0 ] );
        this._normals.set( this._nodeNames[ 3 ], [ -sinRot, cosRot, 0 ] );
        this._normals.set( this._nodeNames[ 4 ], [ 0, 0, -1 ] );
        this._normals.set( this._nodeNames[ 5 ], [ 0, 0, 1 ] );
    },

    resetRegion: function ( redraw ) {
        var epsg = this._project.getDataCRS();

        let sceneExtent = this._viewer.getSceneView().calculateSceneExtent( true, true );
        let region = {
            xMin: sceneExtent[ 0 ],
            yMin: sceneExtent[ 1 ],
            zMin: sceneExtent[ 2 ],
            xMax: sceneExtent[ 3 ],
            yMax: sceneExtent[ 4 ],
            zMax: sceneExtent[ 5 ],
            SRS: epsg
        };

        if ( region.xMin >= region.xMax )
            return;

        if ( redraw || !this._saveRegionInProject || ( this._region && this._region.xMin >= this._region.xMax ) ) // in non-photog case, we need to preserve the region unless it is not valid
            this._region = region;

        this.saveChangesInProject();

        if ( redraw )
            this.drawCube( true );
    },

    getCenter: function () {

        var center = this._viewer.getCenter();
        if ( center && ( center[ 0 ] !== 0 || center[ 1 ] !== 0 || center[ 2 ] !== 0 ) ) {
            return center;
        }

        return osg.vec3.fromValues64( 0, 0, 0 );
    },

    clearCube: function () {
        if ( this._toolNode.getNumChildren() > 0 ) {
            this._toolNode.removeChild( this._planesNode );
            this._toolNode.removeChild( this._linesNode );
        }
    },

    drawCube: function ( drawFaces ) {

        if ( !this._project )
            return;

        this.clearCube();

        this.ensureRegion();

        if ( !this._region )
            return;

        var center = this.getCenter();
        var xMin = this._region.xMin - center[ 0 ];
        var yMin = this._region.yMin - center[ 1 ];
        var zMin = this._region.zMin - center[ 2 ];
        var xMax = this._region.xMax - center[ 0 ];
        var yMax = this._region.yMax - center[ 1 ];
        var zMax = this._region.zMax - center[ 2 ];

        if ( !this._planesNode )
            this._planesNode = new osg.Node();

        var cubeVerts = [
            [ xMin, yMin, zMin ],
            [ xMax, yMin, zMin ],
            [ xMax, yMax, zMin ],
            [ xMin, yMax, zMin ],
            [ xMin, yMin, zMax ],
            [ xMax, yMin, zMax ],
            [ xMax, yMax, zMax ],
            [ xMin, yMax, zMax ]
        ];
        // rotate vertices
        var sinRot = Math.sin( this._rotationAngleRads );
        var cosRot = Math.cos( this._rotationAngleRads );
        for ( var iV = 0; iV < 8; iV++ ) {
            var vert = cubeVerts[ iV ];
            var newXY = [ cosRot * vert[ 0 ] - sinRot * vert[ 1 ], sinRot * vert[ 0 ] + cosRot * vert[ 1 ] ];
            vert[ 0 ] = newXY[ 0 ];
            vert[ 1 ] = newXY[ 1 ];
        }

        if ( drawFaces ) {

            var vertices;
            var normals;

            var cubeFaces = {
                'xMin': [ cubeVerts[ 4 ], cubeVerts[ 7 ], cubeVerts[ 0 ], cubeVerts[ 3 ] ],
                'xMax': [ cubeVerts[ 6 ], cubeVerts[ 5 ], cubeVerts[ 2 ], cubeVerts[ 1 ] ],
                'yMin': [ cubeVerts[ 0 ], cubeVerts[ 1 ], cubeVerts[ 4 ], cubeVerts[ 5 ] ],
                'yMax': [ cubeVerts[ 7 ], cubeVerts[ 6 ], cubeVerts[ 3 ], cubeVerts[ 2 ] ],
                'zMin': [ cubeVerts[ 1 ], cubeVerts[ 0 ], cubeVerts[ 2 ], cubeVerts[ 3 ] ],
                'zMax': [ cubeVerts[ 6 ], cubeVerts[ 7 ], cubeVerts[ 5 ], cubeVerts[ 4 ] ]

            };
            var self = this;
            var k = 0;
            this._normals.forEach( function ( normal, key ) {
                vertices = new Float32Array( 4 * 3 );
                normals = new Float32Array( 4 * 3 );
                self.addVertex( vertices, normals, 0, cubeFaces[ key ][ 0 ], normal[ 0 ], normal[ 1 ], normal[ 2 ] );
                self.addVertex( vertices, normals, 3, cubeFaces[ key ][ 1 ], normal[ 0 ], normal[ 1 ], normal[ 2 ] );
                self.addVertex( vertices, normals, 6, cubeFaces[ key ][ 2 ], normal[ 0 ], normal[ 1 ], normal[ 2 ] );
                self.addVertex( vertices, normals, 9, cubeFaces[ key ][ 3 ], normal[ 0 ], normal[ 1 ], normal[ 2 ] );
                self.setFaceGeometry( self._planesNode, vertices, normals, key, k );
                k++;
            } );

            // plane shader
            var stateSet = this._planesNode.getOrCreateStateSet();
            stateSet.setAttributeAndModes( this.generateProgram() );
            stateSet.setAttributeAndModes( new osg.BlendFunc( 'SRC_ALPHA', 'ONE_MINUS_SRC_ALPHA' ) );
            stateSet.setRenderingHint( 'TRANSPARENT_BIN' );
            stateSet.setRenderBinDetails( Utils.RENDERBIN_CROSS_BOX, Utils.RENDERBIN_CROSS_BOX_TYPE );

            this._toolNode.addChild( this._planesNode );
        }

        // lines
        var lines = [];
        if ( !this._linesNode )
            this._linesNode = new osg.Node();
        this._toolNode.addChild( this._linesNode );

        var lineWidth = 2.0;
        var colors = [ 1, 1, 1, 1, 1, 1, 1, 1 ];

        var cubeLines = [
            [ cubeVerts[ 0 ], cubeVerts[ 1 ] ],
            [ cubeVerts[ 1 ], cubeVerts[ 2 ] ],
            [ cubeVerts[ 2 ], cubeVerts[ 3 ] ],
            [ cubeVerts[ 3 ], cubeVerts[ 0 ] ],
            [ cubeVerts[ 4 ], cubeVerts[ 5 ] ],
            [ cubeVerts[ 5 ], cubeVerts[ 6 ] ],
            [ cubeVerts[ 6 ], cubeVerts[ 7 ] ],
            [ cubeVerts[ 7 ], cubeVerts[ 4 ] ],
            [ cubeVerts[ 0 ], cubeVerts[ 4 ] ],
            [ cubeVerts[ 1 ], cubeVerts[ 5 ] ],
            [ cubeVerts[ 2 ], cubeVerts[ 6 ] ],
            [ cubeVerts[ 3 ], cubeVerts[ 7 ] ],
        ];

        for ( var i = 0; i < cubeLines.length; i++ ) {
            if ( this._linesNode.getNumChildren() < ( i + 1 ) ) {

                lines[ i ] = this._sketchTool.drawScreenLines( cubeLines[ i ], false, colors, lineWidth, false, false, MAX_NUMBER_POINTS ).segments;
                lines[ i ].getOrCreateStateSet().removeAttribute( 'Depth' );
                this._linesNode.addChild( lines[ i ] );

            } else {

                var childNode = this._linesNode.getChildren()[ i ];
                var childAttribs = childNode.getVertexAttributeList();

                this._sketchTool.updateScreenBufferArrays( cubeLines[ i ], childAttribs.Vertex, childAttribs.Color, childAttribs.NextVertex, childAttribs.PreviousVertex, childAttribs.Directions, 0, colors, false );

                childNode.getPrimitiveSetList()[ 0 ].count = childAttribs.Vertex.getElements().length / 3;

                // call dirty method first for the geometry and secondly for the BufferArray
                childNode.dirty();
                childAttribs.Vertex.dirty();
                childAttribs.Color.dirty();
                childNode.dirtyBound();
            }
        }
    },

    generateProgram: function () {
        if ( !this._planeProgram ) {
            var vertexShader = [
                '#version 100',
                '#ifdef GL_FRAGMENT_PRECISION_HIGH',
                'precision highp float;',
                '#else',
                'precision mediump float;',
                '#endif',
                'attribute vec4 Vertex;',
                'uniform mat4 uModelViewMatrix;',
                'uniform mat4 uProjectionMatrix;',

                'void main(void) {',
                '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex.xyz, 1.0);',
                '}'
            ];
            vertexShader = vertexShader.join( '\n' );

            var fragmentShader = [
                '',
                '#ifdef GL_ES',
                'precision highp float;',
                '#endif',

                'uniform vec4 color;',

                'void main (void)',
                '{',
                '  gl_FragColor = color;',
                '}'
            ];
            fragmentShader = fragmentShader.join( '\n' );

            this._planeProgram = new osg.Program( new osg.Shader( 'VERTEX_SHADER', vertexShader ), new osg.Shader( 'FRAGMENT_SHADER', fragmentShader ) );
        }

        return this._planeProgram;
    },

    addVertex: function ( vertices, normals, index, vertice, nx, ny, nz ) {
        vertices[ index + 0 ] = vertice[ 0 ];
        vertices[ index + 1 ] = vertice[ 1 ];
        vertices[ index + 2 ] = vertice[ 2 ];
        normals[ index + 0 ] = nx;
        normals[ index + 1 ] = ny;
        normals[ index + 2 ] = nz;
    },

    setFaceGeometry: function ( planesNode, vertices, normals, name, i ) {
        var geometry;
        if ( planesNode.getChildren() && planesNode.getChildren()[ i ] ) {
            geometry = planesNode.getChildren()[ i ];
            geometry.getPrimitiveSetList().pop();
            geometry.getVertexAttributeList().Vertex.setElements( vertices );

            geometry.getVertexAttributeList().Vertex.dirty();
            geometry.getVertexAttributeList().Color.dirty();
        } else {
            geometry = new osg.Geometry();
            geometry.setName( name );
            geometry.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, vertices, 3 );

            geometry.getAttributes().Color = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, normals, 3 );
            planesNode.addChild( geometry );
        }

        geometry.getPrimitives().push( new osg.DrawArrays( osg.primitiveSet.TRIANGLE_STRIP, 0, 4 ) );

        var osgStateSet = geometry.getOrCreateStateSet();

        var color = ( this._state !== 'idle' && this._planeSelection === name ) ? [ 1, 1, 0.5, 0.25 ] : [ 0.5, 1, 1, 0.25 ];
        osgStateSet.addUniform( osg.Uniform.createFloat4( color, 'color' ) );

        geometry.dirtyBound();
        planesNode.dirtyBound();
    },

    movePlane: function () {

        var dragX = this._newPosX - this._lastPosX;
        var dragY = this._lastPosY - this._newPosY;
        var rotationAngle = this._angle - this._rotationAngleRads * 180 / Math.PI;

        if ( ( this._planeSelection === 'xMin' || this._planeSelection === 'xMax' ) && rotationAngle >= 90 && rotationAngle <= 270 )
            dragX = -dragX;
        if ( ( this._planeSelection === 'yMin' || this._planeSelection === 'yMax' ) && rotationAngle >= 180 && rotationAngle <= 360 )
            dragX = -dragX;

        var dragSize = ( Math.abs( dragX ) > Math.abs( dragY ) ) ? dragX : dragY;
        dragSize *= 0.001 * this._distance;

        if ( dragSize === 0 )
            return;

        this._region[ this._planeSelection ] += dragSize;

        // verify validity of region (keep min size)
        var isMin = ( this._planeSelection.indexOf( 'Min' ) !== -1 );
        var minCoord = isMin ? this._planeSelection : this._planeSelection.replace( 'Max', 'Min' );
        var maxCoord = isMin ? this._planeSelection.replace( 'Min', 'Max' ) : this._planeSelection;

        if ( this._region[ maxCoord ] - this._region[ minCoord ] < MIN_BOX_SIZE ) {
            this._region[ minCoord ] = isMin ? this._region[ maxCoord ] - MIN_BOX_SIZE : this._region[ minCoord ];
            this._region[ maxCoord ] = isMin ? this._region[ maxCoord ] : this._region[ minCoord ] + MIN_BOX_SIZE;
        }

        this._lastPosX = this._newPosX;
        this._lastPosY = this._newPosY;
        this.drawCube( true );

        if ( this._UIRefreshCB )
            this._UIRefreshCB();
    },

    saveChangesInProject: function () {

        if ( !this._project || !this._saveRegionInProject )
            return;

        ScanWorkflow.prototype.setROIInProject( this._project, this._region );
        if ( this._workflow ) { // sync with UI workflow
            this._workflow._ROI = this._region;
            this._workflow._canUseReconstructionCache = false;
        }
    },

    update: function ( /*viewer*/) {
        if ( !this.isToolActive() )
            return;
    },

    setCursor: function ( type ) {

        if ( type !== this._currentCursor ) {
            this._view.getViewer().getCanvas().parentElement.style.cursor = type;
            this._currentCursor = type;
        }
    },

    calculateAngle: function () {
        var viewMatrix = this._view.getViewer().getCamera().getViewMatrix();

        if ( viewMatrix === 0 )
            return;

        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        var angle = CompassTool.prototype.calculateAngle( eye, center );
        return angle % 360;
    },

    restoreManipulatorState: function () {
        var rotateInterpolator = this._view.getViewer().getManipulator().getRotateInterpolator();
        var panInterpolator = this._view.getViewer().getManipulator().getPanInterpolator();
        rotateInterpolator.reset();
        panInterpolator.reset();
    },

    initializePropertySet: function () {
        this.clearProperties();

        this._regionMin = osg.vec3.fromValues( 0, 0, 0 );
        this._regionMax = osg.vec3.fromValues( 0, 0, 0 );

        // Gizmo visualization group
        let propGroup =
            this.addPropertyField( {
                id: 'propGroup',
                label: 'REGION_BOX.PROPGROUP_EXTENT',
                type: 'GroupField',
                translate: true
            } );

        this.addPropertyField( {
            id: 'minCoords',
            label: 'REGION_BOX.MIN',
            type: 'Point',
            translate: true,
            editable: () => true,
            get: () => {
                if ( this._region )
                    osg.vec3.set( this._regionMin, this._region.xMin, this._region.yMin, this._region.zMin );
                return this._regionMin;
            },
            set: value => {
                this._region.xMin = value[ 0 ];
                this._region.yMin = value[ 1 ];
                this._region.zMin = value[ 2 ];

                this.drawCube( true );
            },
            group: propGroup
        } );

        this.addPropertyField( {
            id: 'maxCoords',
            label: 'REGION_BOX.MAX',
            type: 'Point',
            translate: true,
            editable: () => true,
            get: () => {
                if ( this._region )
                    osg.vec3.set( this._regionMax, this._region.xMax, this._region.yMax, this._region.zMax );
                return this._regionMax;
            },
            set: value => {
                this._region.xMax = value[ 0 ];
                this._region.yMax = value[ 1 ];
                this._region.zMax = value[ 2 ];

                this.drawCube( true );
            },
            group: propGroup
        } );
    },

    /**
     * Method to instantiate the event functions
     * @method
     * @memberof pcvizTools.RegionTool
     */
    declareFunctions: function () {

        PickTool.prototype.declareFunctions.call( this );

        // We need to store instance variable to add/remove event listeners
        var self = this;
        self._state = 'idle';
        self._currentCursor = 'default';
        self._initTouch = false;

        this._mouseupFunction = function ( ev ) {

            if ( !self.isToolActive() )
                return;

            if ( self._state !== 'dragging' )
                return;

            self.restoreManipulatorState();
            self._view.getViewer().enableManipulator( true );
            self._state = 'idle';
            self._hit = undefined;
            self._hitNewPos = undefined;
            self.drawCube( true ); // refresh after releasing move

            if ( !( Utils.isTouchEnabled() ) )
                self._canvas.removeEventListener( 'mousemove', self._mousemoveFunction );

            ev.stopPropagation();

            self.saveChangesInProject();
        };

        this._wheelFunction = function () {

        };

        this._keydownFunction = function ( ev ) {
            ev.stopPropagation();
        };

        this._mousedownFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( !self._hit ) // no marker to drag
                return;

            self._state = 'dragging';
            self.setCursor( 'move' );

            // disable image manipulation
            self._view.getViewer().enableManipulator( false );

            self._canvas.addEventListener( 'mousemove', self._mousemoveFunction.bind( self ) );
            self._angle = self.calculateAngle();

            ev.stopPropagation();
        };

        this._pickFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( Utils.isTouchEnabled() && !self._initTouch ) {
                self._canvas.addEventListener( 'touchmove', self._touchMoveFunction.bind( self ) );
                self._canvas.addEventListener( 'touchend', self._touchEndFunction.bind( self ) );
                self._canvas.addEventListener( 'touchstart', self._touchStartFunction.bind( self ) );
                self._initTouch = true;
            }

            if ( ev.detail.hit === undefined ) {
                self.setCursor( 'default' );
                self._hit = undefined;
                return;
            }

            // check marker in node path
            var foundNode;
            for ( var iNode = ev.detail.hit._nodePath.length - 1; iNode > 0; iNode-- ) {
                var name = ev.detail.hit._nodePath[ iNode ].getName();
                if ( self._nodeNames.indexOf( name ) !== -1 ) {
                    foundNode = ev.detail.hit._nodePath[ iNode ];
                    break;
                }
            }
            if ( !foundNode )
                return;

            if ( ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) && !self._initTouch ) {
                self._touchMoveFunction = self._touchMoveFunction.bind( self );
                self._touchEndFunction = self._touchEndFunction.bind( self );
                self._touchStartFunction = self._touchStartFunction.bind( self );
                self._canvas.addEventListener( 'touchmove', self._touchMoveFunction );
                self._canvas.addEventListener( 'touchend', self._touchEndFunction );
                self._canvas.addEventListener( 'touchstart', self._touchStartFunction );
                self._initTouch = true;
            }
            if ( self._state === 'dragging' ) {
                return;
            }
            self.setCursor( 'grab' );

            self._hit = ev.detail.hit;
            self._lastPosX = ev.detail.clientX;
            self._lastPosY = ev.detail.clientY;
            self._distance = ev.detail.hit._distance;
            self._planeSelection = foundNode.getName();
        };

        this._mousemoveFunction = function ( ev ) {

            if ( self._state !== 'dragging' )
                return;

            if ( ev.clientX === self._lastPosX && ev.clientY === self._lastPosY )
                return;

            self._newPosX = ev.clientX;
            self._newPosY = ev.clientY;
            self.movePlane();
        };

        // touch handling

        this._touchMoveFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( self._state !== 'dragging' )
                return;

            ev.clientX = ev.changedTouches[ 0 ].clientX;
            ev.clientY = ev.changedTouches[ 0 ].clientY;

            self._mousemoveFunction( ev );
        };

        this._touchEndFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            self._canvas.removeEventListener( 'touchmove', self._touchMoveFunction );
            self._canvas.removeEventListener( 'touchend', self._touchEndFunction );
            self._canvas.removeEventListener( 'touchstart', self._touchStartFunction );
            self._initTouch = false;

            self._mouseupFunction( ev );
        };

        this._touchStartFunction = function ( ev ) {
            if ( !self.isToolActive() )
                return;

            if ( self._state !== 'dragging' && !self._hit )
                self._view.getViewer().sendPickedEvent( ev, true );

            if ( self._state !== 'dragging' && self._hit )
                self._mousedownFunction( ev );
        };

    },

} );

module.exports = RegionTool;


/***/ }),

/***/ "./sources/pcvizTools/SaveViewTool.js":
/*!********************************************!*\
  !*** ./sources/pcvizTools/SaveViewTool.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );

const OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
const osg = OSG.osg;
const P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

/**
 *  SaveViewTool tool
 *  @class
 *  @memberof pcvizTools
 *  @extends Tool
 */
const SaveViewTool = function ( view ) {
    Tool.call( this, view.getViewer(), 'saveview' );

    this._canvas = view.getViewer().getCanvas();
    this._view = view;
    this._savedViews = undefined;
    this.infoTool = undefined;
};

SaveViewTool.prototype = osg.objectInherit( Tool.prototype, {

    setInformationTool: function ( pcvInformationTool ) {
        this.infoTool = pcvInformationTool;
    },

    getSavedViews: function () {
        if ( !this._savedViews ) {
            const extData = this._view.getProject().getExtData();
            if ( !extData || !extData.savedViews ) {
                this._savedViews = [];
                return this._savedViews;
            }
            this._savedViews = extData.savedViews;
        }

        return this._savedViews;
    },

    saveCurrentView: function ( name ) {

        const savedView = this._view.getSavedView();
        if ( !savedView ) {
            // fail to show error message
            const defer = P.defer();
            defer.reject();
            return defer.promise;
        }

        if ( !this._savedViews )
            this._savedViews = this.getSavedViews();

        this._savedViews.push( {
            name: name,
            viewData: savedView
        } );

        return this.updateViewsInDB();
    },

    goToView: function ( index ) {
        this._view.setSavedView( this._savedViews[ index ].viewData, this.infoTool );
    },

    deleteView: function ( index ) {
        this._savedViews.splice( index, 1 );
        return this.updateViewsInDB();
    },

    renameView: function ( index, name ) {
        this._savedViews[ index ].name = name;
        return this.updateViewsInDB();
    },

    updateViewsInDB: function () {
        let extData = this._view.getProject().getExtData();
        if ( !extData )
            extData = {};
        extData.savedViews = this._savedViews;
        return this._view.getProject().setExtensibleData( extData );
    }

} );

module.exports = SaveViewTool;


/***/ }),

/***/ "./sources/pcvizTools/ScreenshotTool.js":
/*!**********************************************!*\
  !*** ./sources/pcvizTools/ScreenshotTool.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var pcvizNode = __webpack_require__( /*! pcvizNode/pcvizNode */ "./sources/pcvizNode/pcvizNode.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  ScreenshotTool tool
 *  @class
 *  @memberof pcvizTools
 *  @extends Tool
 */
var ScreenshotTool = function ( view ) {
    Tool.call( this, view.getViewer(), 'screenshot' );

    this._screenshotData = {};
    this._canvas = view.getViewer().getCanvas();
    this._view = view;
    this._layer = undefined;
    this._discardedLayers = [];

    this._captureFinishCallback = undefined;
    this._toUpload = false;
};

ScreenshotTool.prototype = osg.objectInherit( Tool.prototype, {

    /**
     * Take a image of the current 3D scene
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    callScreenShot: function () {
        var self = this;

        return function ( state ) {

            var c = document.createElement( 'canvas' );
            var ctx = c.getContext( '2d' );

            var rowSize = self._canvas.width * 4;
            var buffSize = rowSize * self._canvas.height;
            var halfHeight = Math.floor( self._canvas.height * 0.5 );
            var pixels = new Uint8Array( buffSize );
            var rowPixelsStart = new Uint8Array( rowSize );

            var gl = state.getGraphicContext();

            if ( gl.checkFramebufferStatus( gl.FRAMEBUFFER ) === gl.FRAMEBUFFER_COMPLETE ) {
                self._view.getViewer().getCamera().setFinalDrawCallback( null );

                gl.readPixels( 0, 0, self._canvas.width, self._canvas.height, gl.RGBA, gl.UNSIGNED_BYTE, pixels );

                // invert image
                // slow part...
                // so use a optimized inplace image flip.
                var offsetStart = 0;
                var offsetEnd = buffSize - rowSize;
                var i, k;

                for ( i = 0; i < halfHeight; i++ ) {

                    // copy start into temp
                    // typedarray set doesn't take a end param.
                    // forEach cannot be cancelled.
                    // so it's a for.
                    for ( k = 0; k < rowSize; k++ ) {

                        rowPixelsStart[ k ] = pixels[ offsetStart + k ];
                        rowPixelsStart[ k + 1 ] = pixels[ offsetStart + k + 1 ];
                        rowPixelsStart[ k + 2 ] = pixels[ offsetStart + k + 2 ];
                        rowPixelsStart[ k + 3 ] = pixels[ offsetStart + k + 3 ];

                    }

                    // copy end over start
                    pixels.copyWithin( offsetStart, offsetEnd, offsetEnd + rowSize );

                    // copy temp over end
                    pixels.set( rowPixelsStart, offsetEnd );

                    // move ptr
                    offsetStart += rowSize;
                    offsetEnd -= rowSize;

                }

                var offsetX, offsetY, width, height;
                if ( self._canvas.height > self._canvas.width / ( 4 / 3 ) ) {
                    width = self._canvas.width;
                    height = self._canvas.width / ( 4 / 3 );
                    offsetX = 0;
                    offsetY = ( self._canvas.height - height ) / 2;
                } else {
                    height = self._canvas.height;
                    width = self._canvas.height * ( 4 / 3 );
                    offsetX = ( self._canvas.width - width ) / 2;
                    offsetY = 0;
                }

                var imageData = ctx.getImageData( 0, 0, self._canvas.width, self._canvas.height );
                imageData.data.set( pixels );

                c.width = width;
                c.height = height;

                ctx.putImageData( imageData, -offsetX, -offsetY );
                var scale = Utils.SCREENSHOT_WIDTH / c.width;
                ctx.scale( scale, scale );

                var resize = document.createElement( 'canvas' );
                resize.width = Utils.SCREENSHOT_WIDTH;
                resize.height = Utils.SCREENSHOT_HEIGHT;
                var rCtx = resize.getContext( '2d' );
                rCtx.fillStyle = '#4f4f4f';
                rCtx.fillRect( 0, 0, resize.width, resize.height );
                rCtx.drawImage( c, 0, 0, Utils.SCREENSHOT_WIDTH, Utils.SCREENSHOT_HEIGHT );
                self._screenshotData.image = resize.toDataURL( 'image/png', 0.5 );

                self.dispatchData( self._screenshotData );

                if ( self._discardedLayers.length ) {
                    self._discardedLayers.forEach( function ( obj ) {
                        obj.node.setNodeMask( obj.visibility );
                    } );
                    self._discardedLayers.length = 0;
                }
                if ( self._toUpload ) {
                    self.uploadAndUpdateThumbnailToProject();
                    self._toUpload = false;
                }

                if ( self._captureFinishCallback )
                    self._captureFinishCallback();
            }

        };
    },

    uploadS3Thumbnail: function ( s3data ) {
        var self = this;

        function onLoadUpload( e ) {
            var message = document.getElementById( 'capture-message' );
            if ( e.target.status < 400 ) {
                self.registerThumbnail( s3data );
            } else {
                message.innerHTML = 'Error setting thumbnail.';
                message.style.color = 'red';
            }
        }

        function onErrorUpload( e ) {
            console.error( e );
        }

        var file = Utils.blobFromDataURL( self._screenshotData.image );
        var config = {
            key: s3data.path, // + '/${filename}', // the key to store the file on S3, could be file name or customized
            acl: 'public-read', // sets the access to the uploaded file in the bucket: private, public-read, ...
            'Content-Type': 'image/jpg', // content type of the file (NotEmpty)
            'Content-Encoding': 'identity',
            'X-Amz-Credential': s3data.credential,
            'X-Amz-Algorithm': 'AWS4-HMAC-SHA256',
            'X-Amz-Date': s3data.date,
            Policy: s3data.Policy, // base64-encoded json policy (see article below)
            'X-Amz-Signature': s3data.Signature, // base64-encoded signature based on policy string (see article below)
            file: file
        };

        var formDataS3 = new FormData();
        for ( var key in config ) {
            formDataS3.append( key, config[ key ] );
        }

        var reqS3 = new XMLHttpRequest();
        reqS3.open( 'POST', 'https://pointcloudviz-server-1-1.s3-eu-west-1.amazonaws.com/' );
        reqS3.onload = onLoadUpload;
        reqS3.onerror = onErrorUpload;
        reqS3.send( formDataS3 );
    },

    /**
     * Upload the image to a server
     * @method
     * @memberof pcvizTools.ScreenshotTool
     * @return the url of the thumbnail
     */
    uploadThumbnail: function ( /*url or dataset*/) {
        //TODO: When the method to storage thumbnails were implemented this method must be implemented.
        return 'http://thumbnail.test.png';
    },

    /**
     * Update the project thumnnail
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    updateProjectThumbnail: function ( /*thumbnail*/) {
        var project = this.getProject();
        if ( project === undefined )
            return;
        if ( project.getProjectDataset() === undefined || project.getProjectDataset().getDriver() === undefined )
            return;
        // UNCOMMENT THIS LINE WHEN ALL THE SYSTEM ARE RUNNING RIGHT
        //project.getProjectDataset().getDriver().setThumbnail( project.getId(), thumbnail );


    },

    /**
     * to take a capture of the screen
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    captureScreen: function ( toUpload ) {
        this._toUpload = toUpload;
        this._layer = undefined;
        this._view.getViewer().getCamera().setFinalDrawCallback( this.callScreenShot() );
    },

    /**
     * To take a capture of the provided or selected layer
     * @method
     * @memberof pcvizTools.ScreenshotTool
     * @param optional layer, would use the selected one if skipped
     */
    captureLayer: function ( layer ) {
        this._layer = layer ? layer : this.getSelectedLayer();

        if ( !this._layer ) {
            return;
        }

        var layerNode = this._view.getLayerRenderer().getNodeFromLayer( this._layer );

        var self = this;

        if ( layerNode instanceof pcvizNode.PointCloudPLOD ) {
            this.applyScene( layerNode, LayerType.POINTCLOUD );


            Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.VECTOR ).values() )
                .concat( Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.RASTER ).values() ) ).forEach( function ( node ) {
                    self._discardedLayers.push( {
                        node: node,
                        visibility: node.getNodeMask()
                    } );
                } );
        } else if ( this._layer.getType() === LayerType.RASTER ) {
            this.applyScene( layerNode, LayerType.RASTER );
            Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.VECTOR ).values() )
                .concat( Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.POINTCLOUD ).values() ) ).forEach( function ( node ) {
                    self._discardedLayers.push( {
                        node: node,
                        visibility: node.getNodeMask()
                    } );
                } );
        } else {
            this.applyScene( layerNode, LayerType.VECTOR );
            Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.POINTCLOUD ).values() )
                .concat( Array.from( this._view.getLayerRenderer().getLayerNodesByType( LayerType.RASTER ).values() ) ).forEach( function ( node ) {
                    self._discardedLayers.push( {
                        node: node,
                        visibility: node.getNodeMask()
                    } );
                } );
        }

        this._discardedLayers.forEach( function ( obj ) {
            obj.node.setNodeMask( 0x0 );
        } );

        this._view.getViewer().getCamera().setFinalDrawCallback( this.callScreenShot() );
    },

    /**
     * To take a capture of the provided layer type
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    captureLayerType: function ( layerType ) {

        const allLayerNodes = Array.from( this._view.getLayerRenderer().getAllLayerNodes().values() );

        const selectedLayerNodes = Array.from( this._view.getLayerRenderer().getLayerNodesByType( layerType ).values() );

        const notSelectedLayerNodes = allLayerNodes.filter( ( node ) => !selectedLayerNodes.includes( node ) );


        notSelectedLayerNodes.forEach( node => {
            this._discardedLayers.push( {
                node: node,
                visibility: node.getNodeMask()
            } );
        } );

        this._discardedLayers.forEach( function ( obj ) {
            obj.node.setNodeMask( 0x0 );
        } );

        this._view.getViewer().getCamera().setFinalDrawCallback( this.callScreenShot() );
    },

    getSelectedLayer: function () {
        const selectionObject = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
        return selectionObject && selectionObject.getLayer();
    },

    /**
     * Uploads and sets the thumbnail to the current job site or project
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    uploadAndUpdateThumbnail: function ( img ) {
        if ( !img )
            img = this._screenshotData.image;
        if ( img === undefined )
            return;
        const item = this.getAppObject();

        if ( !item )
            return;

        const dataset = item.getDataset();
        if ( !dataset || !dataset.getDriver() )
            return;

        return dataset.getDriver().setThumbnail( item.getId(), Utils.blobFromDataURL( img ) );
    },

    /**
     * Uploads and sets the thumbnail to the selected layer
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    uploadAndUpdateThumbnailToLayer: function ( img ) {
        if ( !img )
            img = this._screenshotData.image;
        if ( !this._screenshotData.image || !this._layer )
            return;
        if ( !this._layer.getDataset() || !this._layer.getDataset().getDriver() )
            return;
        return this._layer.getDataset().getDriver().setLayerThumbnail( this._layer, Utils.blobFromDataURL( img ) );
    },

    applyScene: function ( layerNode, type ) {
        var self = this;
        Array.from( this._view.getLayerRenderer().getLayerNodesByType( type ).values() ).forEach( function ( node ) {
            if ( node !== layerNode )
                self._discardedLayers.push( {
                    node: node,
                    visibility: node.getNodeMask()
                } );
        } );
    },
    /**
     * Returns the data captured
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    getCapture() {
        return this._screenshotData;
    },

    /**
     * Callback to notify when a screenshot has been taken
     * @method
     * @memberof pcvizTools.ScreenshotTool
     */
    setCaptureFinishCallback( callback ) {
        this._captureFinishCallback = callback;
    }

} );

module.exports = ScreenshotTool;


/***/ }),

/***/ "./sources/pcvizTools/SettingsTool.js":
/*!********************************************!*\
  !*** ./sources/pcvizTools/SettingsTool.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var PropertySet = __webpack_require__( /*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var screenfull = __webpack_require__( /*! screenfull */ "./node_modules/screenfull/dist/screenfull.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );

var osg = OSG.osg;

/**
 *  Settings tool. This tool represents the global settings of the project.
 *  @class
 *  @memberof pcvizTools
 *  @property {UnitService} _unitsService The service to transform units.
 *  @extends Tool
 */
var SettingsTool = function ( viewer ) {
    PropertySet.call( this );
    Tool.call( this, viewer, 'settings' );
    this._commitPermission = true;

    this.setUpdateCallback( this.commitChanges );
};

SettingsTool.prototype = osg.objectInherit( Tool.prototype, osg.objectInherit( PropertySet.prototype, {

    /**
     * Sets the permission to commit changes.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {bool} permission If the user has permissions to commit changes
     */
    setCommitPermission: function ( permission ) {
        this._commitPermission = permission;
    },

    /**
     * Sets the level of detail.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {float} value The new level of detail.
     */
    setLevelOfDetail: function ( value ) {
        this._project.getCurrentRenderSettings().set( 'levelOfDetail', value );
        if ( this._viewer ) {
            this._viewer.getCamera().getRenderer().getCullVisitor().setLODScale( ( 3.0 - value ) * window.devicePixelRatio );
            this._viewer.computeLodFactor( value );
        }
    },

    /**
     * Sets the field of view.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {float} value The new field of view value
     */
    setFieldOfView: function ( value ) {
        this._project.getCurrentRenderSettings().set( 'fieldOfView', value );
        if ( this._viewer )
            this._viewer.setFOV( value );
    },

    /**
     * Changes ambient light.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {type} value
     */
    setAmbientLight: function ( value ) {
        var activeEDL = value !== 'SETTINGS_TOOL.AMBIENT_LIGHT.DISABLED';
        this._project.getCurrentRenderSettings().set( 'edlOn', activeEDL );
        if ( this._viewer )
            this._viewer.setEDLRendering( activeEDL );

        var activeSSAO = value === 'SETTINGS_TOOL.AMBIENT_LIGHT.HIGH';
        this._project.getCurrentRenderSettings().set( 'SSAOOn', activeSSAO );
        if ( this._viewer )
            this._viewer.getEDLNode().setSSAORendering( activeSSAO );
    },

    /**
     * Gets ambient light.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @return {type} type of ambient light
     */
    getAmbientLight() {
        var ambientLight = 'SETTINGS_TOOL.AMBIENT_LIGHT.DISABLED';

        if ( this._project.getCurrentRenderSettings().get( 'SSAOOn' ) )
            ambientLight = 'SETTINGS_TOOL.AMBIENT_LIGHT.HIGH';
        else if ( this._project.getCurrentRenderSettings().get( 'edlOn' ) )
            ambientLight = 'SETTINGS_TOOL.AMBIENT_LIGHT.MEDIUM';
        return ambientLight;
    },

    /**
     * Sets the EDL radius parameter.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {type} value The EDL radius parameter.
     */
    setEDLRadius: function ( value ) {
        this._project.getCurrentRenderSettings().set( 'edlRadius', value );
        if ( this._viewer )
            this._viewer.getEDLNode().setEDLRadius( value );
    },

    /**
     * Sets the EDL contrast parameter.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {type} value The EDL contrast parameter.
     */
    setEDLContrast: function ( value ) {
        this._project.getCurrentRenderSettings().set( 'edlContrast', value );
        if ( this._viewer )
            this._viewer.getEDLNode().setEDLExp( value );
    },
    /**
     * Enables or disables mobile fullscreen mode.
     * @method
     * @memberof pcvizTools.SettingsTool
     * @param  {type} value `true` to enable fullscreen, `false` to disable it.
     */
    enableMobileFullScreen: function ( value ) {
        this._project.getCurrentViewerSettings().set( 'mobileFullScreen', value );
    },

    commitChanges: function () {
        if ( this._commitPermission )
            return this._project.getCurrentRenderSettings().commitChanges();
    },

    /**
     * Initializes the property set.
     * @method
     * @memberof pcvizTools.SettingsTool
     */
    initializePropertySet: function () {
        var self = this;

        var userPreferencesCtrl = Registry.getController( 'UserPreferences' );
        var unitsController = Registry.getInstance().getController( 'Units' );

        this.clearProperties();

        var projectPreferences = this.addPropertyField( {
            id: 'projectPreferences',
            label: 'SETTINGS_TOOL.PROJECT_PREFERENCES',
            type: 'GroupField'
        } );

        this.addPropertyField( {
            id: 'fieldOfView',
            label: 'SETTINGS_TOOL.FIELD_OF_VIEW',
            type: 'FloatField',
            valueRange: [ 20, 100 ],
            decimals: 1,
            get: function () {
                return self._project.getCurrentRenderSettings().get( 'fieldOfView' );
            },
            set: function ( value ) {
                self.setFieldOfView( value );
            },
            group: projectPreferences
        } );

        this.addPropertyField( {
            id: 'levelOfDetail',
            label: 'SETTINGS_TOOL.LEVEL_OF_DETAIL',
            type: 'FloatField',
            valueRange: [ 0.01, 2.8 ],
            decimals: 1,
            get: function () {
                return self._project.getCurrentRenderSettings().get( 'levelOfDetail' );
            },
            set: function ( value ) {
                self.setLevelOfDetail( value );
            },
            group: projectPreferences
        } );

        this.addPropertyField( {
            id: 'ambientLight',
            label: 'SETTINGS_TOOL.EDL_ON',
            type: 'CharField',
            valueRange: [ 'SETTINGS_TOOL.AMBIENT_LIGHT.DISABLED',
                'SETTINGS_TOOL.AMBIENT_LIGHT.MEDIUM',
                'SETTINGS_TOOL.AMBIENT_LIGHT.HIGH'
            ],
            get: function () {
                return self.getAmbientLight();
            },
            set: function ( value ) {
                self.setAmbientLight( value );
            },
            group: projectPreferences
        } );

        this.addPropertyField( {
            id: 'edlRadius',
            label: 'SETTINGS_TOOL.EDL_RADIUS',
            type: 'FloatField',
            valueRange: [ 1, 10 ],
            decimals: 1,
            get: function () {
                return self._project.getCurrentRenderSettings().get( 'edlRadius' );
            },
            set: function ( value ) {
                self.setEDLRadius( value );
            },
            group: projectPreferences
        } );

        this.addPropertyField( {
            id: 'edlContrast',
            label: 'SETTINGS_TOOL.EDL_CONTRAST',
            type: 'FloatField',
            valueRange: [ 0.1, 10 ],
            decimals: 1,
            get: function () {
                return self._project.getCurrentRenderSettings().get( 'edlContrast' );
            },
            set: function ( value ) {
                self.setEDLContrast( value );
            },
            group: projectPreferences
        } );



        var userPreferences = this.addPropertyField( {
            id: 'userPreferences',
            label: 'SETTINGS_TOOL.USER_PREFERENCES',
            type: 'GroupField'
        } );

        this.addPropertyField( {
            id: 'gridOn',
            label: 'SETTINGS_TOOL.GRID_ON',
            type: 'BooleanField',
            get: function () {
                return userPreferencesCtrl.getPreference( Utils.GRID_ON_KEY );
            },
            set: function ( value ) {
                userPreferencesCtrl.registerPreference( Utils.GRID_ON_KEY, value );
                userPreferencesCtrl.notify( Utils.GRID_ON_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: 'gridLabelOn',
            label: 'SETTINGS_TOOL.GRID_LABEL_ON',
            type: 'BooleanField',
            get: function () {
                return userPreferencesCtrl.getPreference( Utils.GRID_LABEL_ON_KEY );
            },
            set: function ( value ) {
                userPreferencesCtrl.registerPreference( Utils.GRID_LABEL_ON_KEY, value );
                userPreferencesCtrl.notify( Utils.GRID_LABEL_ON_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: 'distanceUnit',
            label: 'UNIT_SERVICE.DISTANCE_UNITS',
            type: 'CharField',
            valueRange: [ 'UNIT_SERVICE.MM_LONG',
                'UNIT_SERVICE.CM_LONG',
                'UNIT_SERVICE.M_LONG',
                'UNIT_SERVICE.KM_LONG',
                'UNIT_SERVICE.INCHES_LONG',
                'UNIT_SERVICE.INTERNATIONAL_FEET_LONG',
                'UNIT_SERVICE.US_FEET_LONG',
                'UNIT_SERVICE.YARD_LONG',
                'UNIT_SERVICE.MILE_LONG'
            ],
            get: function () {
                return unitsController.getCurrentUnit( 'distance' ).label;
            },
            set: function ( value ) {
                unitsController.setCurrentUnitByLabel( value, 'distance' );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: 'areaUnit',
            label: 'UNIT_SERVICE.AREA_UNITS',
            type: 'CharField',
            valueRange: [ 'UNIT_SERVICE.MM2_LONG',
                'UNIT_SERVICE.CM2_LONG',
                'UNIT_SERVICE.M2_LONG',
                'UNIT_SERVICE.KM2_LONG',
                'UNIT_SERVICE.INCHES2_LONG',
                'UNIT_SERVICE.INTERNATIONAL_FEET2_LONG',
                'UNIT_SERVICE.US_FEET2_LONG',
                'UNIT_SERVICE.YARD2_LONG',
                'UNIT_SERVICE.MILE2_LONG'
            ],
            get: function () {
                return unitsController.getCurrentUnit( 'area' ).label;
            },
            set: function ( value ) {
                unitsController.setCurrentUnitByLabel( value, 'area' );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: 'volumeUnit',
            label: 'UNIT_SERVICE.VOLUME_UNITS',
            type: 'CharField',
            valueRange: [ 'UNIT_SERVICE.MM3_LONG',
                'UNIT_SERVICE.CM3_LONG',
                'UNIT_SERVICE.M3_LONG',
                'UNIT_SERVICE.KM3_LONG',
                'UNIT_SERVICE.INCHES3_LONG',
                'UNIT_SERVICE.INTERNATIONAL_FEET3_LONG',
                'UNIT_SERVICE.US_FEET3_LONG',
                'UNIT_SERVICE.YARD3_LONG',
                'UNIT_SERVICE.MILE3_LONG'
            ],
            get: function () {
                return unitsController.getCurrentUnit( 'volume' ).label;
            },
            set: function ( value ) {
                unitsController.setCurrentUnitByLabel( value, 'volume' );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.BACKGROUND_COLOR_KEY,
            label: 'SETTINGS_TOOL.BACKGROUND_COLOR',
            type: 'ColorField',
            get: function () {
                return Utils.RgbTofullhex( Registry.getController( 'UserPreferences' ).getPreference( Utils.BACKGROUND_COLOR_KEY ) );
            },
            set: function ( value ) {
                let color = Utils.fullhexToRgb( value, 1.0 );
                color = Utils.RGBIntToFloatColor( color );
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.BACKGROUND_COLOR_KEY, color );
                Registry.getController( 'UserPreferences' ).notify( Utils.BACKGROUND_COLOR_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.SECTION_BACKGROUND_COLOR_KEY,
            label: 'SETTINGS_TOOL.SECTION_BACKGROUND_COLOR',
            type: 'ColorField',
            get: function () {
                return Utils.RgbTofullhex( Registry.getController( 'UserPreferences' ).getPreference( Utils.SECTION_BACKGROUND_COLOR_KEY ) );
            },
            set: function ( value ) {
                let color = Utils.fullhexToRgb( value, 1.0 );
                color = Utils.RGBIntToFloatColor( color );
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.SECTION_BACKGROUND_COLOR_KEY, color );
                Registry.getController( 'UserPreferences' ).notify( Utils.SECTION_BACKGROUND_COLOR_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.SECTION_GRID_COLOR_KEY,
            label: 'SETTINGS_TOOL.SECTION_GRID_COLOR',
            type: 'ColorField',
            get: function () {
                return Registry.getController( 'UserPreferences' ).getPreference( Utils.SECTION_GRID_COLOR_KEY );
            },
            set: function ( value ) {
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.SECTION_GRID_COLOR_KEY, value );
                Registry.getController( 'UserPreferences' ).notify( Utils.SECTION_GRID_COLOR_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.SELECTION_COLOR_KEY,
            label: 'SETTINGS_TOOL.SELECTION_COLOR',
            type: 'ColorField',
            get: function () {
                return Utils.RgbTofullhex( Registry.getController( 'UserPreferences' ).getPreference( Utils.SELECTION_COLOR_KEY ) );
            },
            set: function ( value ) {
                let color = Utils.fullhexToRgb( value, 0.5 );
                color = Utils.RGBIntToFloatColor( color );
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.SELECTION_COLOR_KEY, color );
                Registry.getController( 'UserPreferences' ).notify( Utils.SELECTION_COLOR_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.PICKING_CIRCLE_COLOR_KEY,
            label: 'SETTINGS_TOOL.PICKING_CIRCLE_COLOR',
            type: 'ColorField',
            get: function () {
                return Registry.getController( 'UserPreferences' ).getPreference( Utils.PICKING_CIRCLE_COLOR_KEY );
            },
            set: function ( value ) {
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.PICKING_CIRCLE_COLOR_KEY, value );
                Registry.getController( 'UserPreferences' ).notify( Utils.PICKING_CIRCLE_COLOR_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.NUMBER_OF_DECIMALS_KEY,
            label: 'SETTINGS_TOOL.NUMBER_OF_DECIMALS',
            type: 'IntegerField',
            valueRange: [ 0, 9 ],
            get: function () {
                return Registry.getController( 'UserPreferences' ).getPreference( Utils.NUMBER_OF_DECIMALS_KEY );
            },
            set: function ( value ) {
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.NUMBER_OF_DECIMALS_KEY, value );
                Registry.getController( 'UserPreferences' ).notify( Utils.NUMBER_OF_DECIMALS_KEY );
            },
            group: userPreferences
        } );

        this.addPropertyField( {
            id: Utils.PLANAR_IMAGE_DISTANCE_KEY,
            label: 'SETTINGS_TOOL.PLANAR_IMAGE_DISTANCE',
            type: 'FloatField',
            logarithmic: true,
            valueRange: [ 1, 100, 1 ],
            get: function () {
                return Registry.getController( 'UserPreferences' ).getPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY );
            },
            set: function ( value ) {
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.PLANAR_IMAGE_DISTANCE_KEY, value );
                Registry.getController( 'UserPreferences' ).notify( Utils.PLANAR_IMAGE_DISTANCE_KEY );
            },
            group: userPreferences
        } );


        // this property is only visible on mobile devices
        if ( Utils.isTouchEnabled() ) {
            this.addPropertyField( {
                id: 'mobileFullScreen',
                label: 'SETTINGS_TOOL.MOBILE_FULL_SCREEN',
                type: 'ToggleField',
                get: function () {
                    var full = false;
                    if ( self._project.getCurrentViewerSettings().get( 'mobileFullScreen' ) !== undefined )
                        full = self._project.getCurrentViewerSettings().get( 'mobileFullScreen' );
                    return full;
                },
                set: function ( value ) {
                    var full = self._project.getCurrentViewerSettings().get( 'mobileFullScreen' );
                    if ( full !== value ) {
                        if ( value )
                            screenfull.request();
                        else
                            screenfull.exit();
                    }
                    self.enableMobileFullScreen( value );
                }
            } );
        }
        if ( ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) && Utils.isEdge() && MagnetAPI.isSite() ) {
            this.addPropertyField( {
                id: Utils.MOUSE_OR_TOUCH_KEY,
                label: 'SETTINGS_TOOL.MOUSE_OR_TOUCH',
                type: 'SwitchField',
                valueRange: [ Utils.TOUCH_PRIORITY, Utils.MOUSE_PRIORITY ], // for the SwitchField type, these are the possible values
                get: function () {
                    return Registry.getController( 'UserPreferences' ).getPreference( Utils.MOUSE_OR_TOUCH_KEY );
                },
                set: function ( value ) {
                    Registry.getController( 'UserPreferences' ).registerPreference( Utils.MOUSE_OR_TOUCH_KEY, value );
                    Registry.getController( 'UserPreferences' ).notify( Utils.MOUSE_OR_TOUCH_KEY );
                },
                group: userPreferences
            } );
        }
        this.addPropertyField( {
            id: Utils.BATTERY_SAVER,
            label: 'SETTINGS_TOOL.BATTERY_SAVER',
            type: 'BooleanField',
            get: function () {
                return Registry.getController( 'UserPreferences' ).getPreference( Utils.BATTERY_SAVER );
            },
            set: function ( value ) {
                Registry.getController( 'UserPreferences' ).registerPreference( Utils.BATTERY_SAVER, value );
                Registry.getController( 'UserPreferences' ).notify( Utils.BATTERY_SAVER );
            },
            group: userPreferences
        } );

        /* Hides this option because it doesn't work as expected
        this.addPropertyField( {
            id: 'automaticLOD',
            label: 'SETTINGS_TOOL.AUTOMATIC_LOD',
            type: 'BooleanField',
            get: function () {
                return userPreferencesCtrl.getPreference( Utils.AUTOMATIC_LOD_KEY );
            },
            set: function ( value ) {
                userPreferencesCtrl.registerPreference( Utils.AUTOMATIC_LOD_KEY, value );
                userPreferencesCtrl.notify( Utils.AUTOMATIC_LOD_KEY );
            },
            group: userPreferences
        } );*/


        if ( MagnetAPI.isSite() ) {
            if ( MagnetAPI.isTechnicalPreview() ) {
                this.addPropertyField( {
                    id: Utils.REGIST_ALGO_VER_KEY,
                    label: 'SETTINGS_TOOL.REGIST_ALGO_VER',
                    type: 'SwitchField',
                    valueRange: [ Utils.OLD_ALGORITHMS, Utils.NEW_ALGORITHMS ], // for the SwitchField type, these are the possible values
                    get: function () {
                        return Registry.getController( 'UserPreferences' ).getPreference( Utils.REGIST_ALGO_VER_KEY );
                    },
                    set: function ( value ) {
                        Registry.getController( 'UserPreferences' ).registerPreference( Utils.REGIST_ALGO_VER_KEY, value );
                        Registry.getController( 'UserPreferences' ).notify( Utils.REGIST_ALGO_VER_KEY );
                    },
                    group: userPreferences
                } );

                this.addPropertyField( {
                    id: Utils.USER_INTERFACE_VER_KEY,
                    label: 'SETTINGS_TOOL.USER_INTERFACE_VER',
                    type: 'SwitchField',
                    valueRange: [ Utils.CURRENT_UI, Utils.NEW_UI ], // for the SwitchField type, these are the possible values
                    get: function () {
                        return Registry.getController( 'UserPreferences' ).getPreference( Utils.USER_INTERFACE_VER_KEY );
                    },
                    set: function ( value ) {
                        Registry.getController( 'UserPreferences' ).registerPreference( Utils.USER_INTERFACE_VER_KEY, value );
                        Registry.getController( 'UserPreferences' ).notify( Utils.USER_INTERFACE_VER_KEY );
                    },
                    group: userPreferences
                } );
            }
            // Request from CE to include the backgroundProcessing out of technical preview
            this.addPropertyField( {
                id: Utils.BACKGROUND_PROCESSING_KEY,
                label: 'SETTINGS_TOOL.BACKGROUND_PROCESSING',
                type: 'BooleanField',
                get: function () {
                    return Registry.getController( 'UserPreferences' ).getPreference( Utils.BACKGROUND_PROCESSING_KEY );
                },
                set: function ( value ) {
                    Registry.getController( 'UserPreferences' ).registerPreference( Utils.BACKGROUND_PROCESSING_KEY, value );
                    Registry.getController( 'UserPreferences' ).notify( Utils.BACKGROUND_PROCESSING_KEY );
                },
                group: userPreferences
            } );

            this.addPropertyField( {
                id: Utils.DELETE_LAYERS_KEY,
                label: 'SETTINGS_TOOL.DELETE_ORPHAN_LAYERS',
                type: 'BooleanField',
                get: function () {
                    return Registry.getController( 'UserPreferences' ).getPreference( Utils.DELETE_LAYERS_KEY );
                },
                set: function ( value ) {
                    Registry.getController( 'UserPreferences' ).registerPreference( Utils.DELETE_LAYERS_KEY, value );
                    Registry.getController( 'UserPreferences' ).notify( Utils.DELETE_LAYERS_KEY );
                },
                group: userPreferences
            } );
        }
    }

} ) );

module.exports = SettingsTool;


/***/ }),

/***/ "./sources/pcvizTools/SidesTool.js":
/*!*****************************************!*\
  !*** ./sources/pcvizTools/SidesTool.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SidesTool; });
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js");
/* harmony import */ var pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");



const RenderSideId = {
    LEFT: 1,
    RIGHT: 2
};
class SidesTool extends pcvizTools_Tool__WEBPACK_IMPORTED_MODULE_0___default.a {
    constructor( view, id ) {
        super( view.getViewer(), id === undefined ? 'sides' : id );

        this._view = view;
        this._nodeList = undefined;
        this._currentDividerValue = 50.0;
        this._postChangeDividerFn = undefined;
    }

    /**
     * Sets the tool active or inactive.
     * @memberof pcvizTools.SidesTool
     * @method
     * @param {boolean} active `true` if the tool is active.
     */
    setActive( active ) {
        if ( this._active === active )
            return;
        this._active = active;
        if ( this._active ) {
            this.refreshNodeList();
        }
        this._nodeList.forEach( ( node ) => { node.sideAttribute.setEnabled( this._active ); } );
    }

    /**
     * Method to set the function to be called post changing sides divider
     * @memberof pcvizTools.SidesTool
     * @method
     * @param fn function to change
     */
    setPostChangeDividerFn( fn ) {
        this._postChangeDividerFn = fn;
    }

    /**
     * Method to refresh the internal list of nodes
     * @memberof pcvizTools.SidesTool
     * @method
     */
    refreshNodeList() {
        const pointCloudList = Array.from( this._view.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].POINTCLOUD ).values() );
        let vectorList = Array.from( this._view.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_1__["default"].VECTOR ).values() );
        vectorList = vectorList.filter( ( node ) => node.sideAttribute ); // TODO: Prevent side by side breaks by Map symbols.
        this._nodeList = [ ...pointCloudList, ...vectorList ];
    }

    /**
     * Method to change divider value in each side's drawing attribute
     * @memberof pcvizTools.SidesTool
     * @method
     * @param {float} value Real number between 0 and 100.
     */
    setSidesDividerValue( value ) {
        this._currentDividerValue = value;

        const valueClipped = ( value - 50.0 ) / 50.0; // Clip slider value from [0,100] to range [-1,1]
        this._nodeList.forEach( ( node ) => { node.sideAttribute.setSideDivider( valueClipped ); } );

        if ( this._postChangeDividerFn ) {
            this._postChangeDividerFn();
        }
    }

    /**
     * Method to change the side where render a point cloud
     * @memberof pcvizTools.SidesTool
     * @method
     * @param {int} layerId Point cloud's layer id.
     * @param {int} side Side to render. 0 None, 1 Left, 2 Right.
     */
    setSideByLayerID( layerId, side ) {
        const node = this._nodeList.find( ( node ) => node.Layer.getId() === layerId );
        if ( !node ) {
            return;
        }

        node.sideAttribute.setSide( side );
    }

    /**
     * Method to obtain the list of visible nodes in a side
     * @param {int} side 1 for left side, 2 for right side
     * @returns list of nodes
     */
    getNodesBySide( side ) {
        return this._nodeList.filter( ( node ) => node.sideAttribute.getSide() === side );
    }

    /**
     * Method to change the visible nodes from one side to the other
     */
    invertSideSelections() {
        const leftNodes = this.getNodesBySide( RenderSideId.LEFT );
        const rightNodes = this.getNodesBySide( RenderSideId.RIGHT );

        leftNodes.forEach( node => this.setSideByLayerID( node.Layer.getId(), RenderSideId.RIGHT ) );
        rightNodes.forEach( node => this.setSideByLayerID( node.Layer.getId(), RenderSideId.LEFT ) );
    }

    /**
     * Method to remove the visible nodes from all the sides
     */
    resetSides() {
        this._nodeList.forEach( node => node.sideAttribute.setSide( 0 ) );
    }

    /**
     * Method to remove the visible node from the specific side
     */
    removeNodesFromSide( layerId ) {
        this.setSideByLayerID( layerId, 0 );
    }
}


/***/ }),

/***/ "./sources/pcvizTools/Tool.js":
/*!************************************!*\
  !*** ./sources/pcvizTools/Tool.js ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var PropertySet = __webpack_require__( /*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js" );

/**
 *  Tool Base Class
 *  @class
 *  @memberof pcvizTools
 *  @extends PropertySet
 */
var Tool = function ( viewer, id ) {
    PropertySet.call( this );
    this._viewer = viewer;
    this._active = false;
    this._visible = false;
    this._toolBar = undefined;
    this._id = id;
    this._listeners = [];

    this._group = ''; // this is to group the tools
    this._project = undefined;
    this._jobSite = undefined;
};

Tool.prototype = osg.objectInherit( PropertySet.prototype, {
    update: function ( /*viewer*/) {

    },

    updateData: function ( /*data*/) { // [ hit, pos ]

    },

    setProject: function ( project ) {
        this._project = project;
    },

    getProject: function () {
        return this._project;
    },

    setJobSite: function ( jobSite ) {
        this._jobSite = jobSite;
    },

    getJobSite: function () {
        return this._jobSite;
    },

    getAppObject: function () {
        return this._project ? this.getProject() : this.getJobSite();
    },

    setActive: function ( active ) {
        this._active = active;
    },

    setActivePointCloud: function () {},

    setVisibility: function ( visibility ) {
        this._visible = visibility;
    },

    isToolActive: function () {
        return this._active;
    },

    getViewer: function () {
        return this._viewer;
    },

    setViewer: function ( viewer ) {
        this._viewer = viewer;
    },

    setToolbar: function ( toolbar ) {
        this._toolBar = toolbar;
    },

    getId: function () {
        return this._id;
    },

    listenData: function ( f ) {
        this._listeners.push( f );
    },

    dispatchData: function ( data ) {
        for ( var i = 0; i < this._listeners.length; i++ )
            this._listeners[ i ]( data );
    },

    setUpEventListeners: function ( /* canvas */) {},

    removeEventListeners: function () {},

    setGroup: function ( group ) {
        this._group = group;
    },

    getGroup: function () {
        return this._group;
    },

    enableOtherTools: function ( enable ) {

        var toolbar = this._view.getToolbar();

        if ( enable ) {
            toolbar.getTool( 'information' ).setActive( true );
            return;
        }

        toolbar.forEach( function ( tool ) {
            if ( tool.isToolActive() )
                tool.setActive( false );
        } );
    }

} );

module.exports = Tool;


/***/ }),

/***/ "./sources/pcvizTools/ToolBar.js":
/*!***************************************!*\
  !*** ./sources/pcvizTools/ToolBar.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Julio Campos <julio.campos@mirage-tech.com>
 */



/**
 *  Toolbar class
 *  @class
 *  @memberof pcvizTools
 */
var ToolBar = function () {
    this._toolsArray = [];

    this._toolsGroupsMap = new Map();
};

ToolBar.prototype = {

    /**
     * @method
     * add a new to tool to the toolbar
     * @memberof pcvizTools.ToolBar
     * @param  {Object} tool the tool to add
     * @param {Object} group It is the group to which the tool belongs. If it is undefined, the group will be 'default'
     */
    addTool: function ( tool, group ) {

        this._toolsArray[ this._toolsArray.length ] = tool;
        tool.setToolbar( this );

        if ( group === undefined ) {
            this.addToolToGroup( tool, 'default' );
        } else {
            this.addToolToGroup( tool, group );
        }

    },

    /**
     * @method
     * add too to a group
     * @memberof pcvizTools.ToolBar
     * @param  {Object} tool the tool to be added
     * @param {Object} group It is the group to which the tool belongs. If it is undefined, the group will be 'default'
     */
    addToolToGroup: function ( tool, group ) {
        // checking if exists the key
        if ( this._toolsGroupsMap.has( group ) ) {
            var groupArray = this._toolsGroupsMap.get( group ); // if it exists, we get the array 
            groupArray.push( tool ); // and add the new tool 
        } else {
            var newGroupArray = []; // if does not exist, we create a new array
            newGroupArray.push( tool );

            this._toolsGroupsMap.set( group, newGroupArray ); // add to the map
        }

        // setting up the group to tool
        tool.setGroup( group );

    },

    /**
     * @method
     * get a tool by id
     * @memberof pcvizTools.ToolBar
     * @param  {string} id of the tool
     * @return {Object} the tool search. If the tool isn't found, it will be return undefined
     */
    getTool: function ( id ) {
        var result;
        for ( var i = 0; i < this._toolsArray.length; i++ ) {
            if ( this._toolsArray[ i ].getId() === id ) {
                result = this._toolsArray[ i ];
                break;
            }
        }
        return result;
    },

    /**
     * @method
     * Enable the tool passed
     * @memberof pcvizTools.ToolBar
     * @param  {Object} tool to be enabled
     */
    setToolEnabled: function ( tool ) {
        this.disableAllTools();
        for ( var i = 0; i < this._toolsArray.length; i++ ) {
            if ( this._toolsArray[ i ].getId() === tool.id ) {
                this._toolsArray[ i ].setActive( true );
                break;
            }
        }
    },

    /**
     * @method
     * set the viewer to all tools
     * @memberof pcvizTools.ToolBar
     * @param  {Object} Viewer osg
     */
    setViewer: function ( viewer ) {
        for ( var i = 0; i < this._toolsArray.length; i++ ) {
            this._toolsArray[ i ].setViewer( viewer );
        }
    },

    /**
     * @method
     * disable all tools without exceptions
     * @memberof pcvizTools.ToolBar
     */
    disableAllTools: function () {
        for ( var i = 0; i < this._toolsArray.length; i++ ) {
            if ( this._toolsArray[ i ].isToolActive() )
                this._toolsArray[ i ].setActive( false );
        }
    },

    /**
     * @method
     * update the data that use the diferente tools
     * @memberof pcvizTools.ToolBar
     * @param  {Object} infodata necessary
     */
    updateData: function ( infoData ) {
        for ( var i = 0; i < this._toolsArray.length; i++ ) {
            if ( this._toolsArray[ i ].isToolActive() )
                this._toolsArray[ i ].updateData( infoData );
        }
    },

    /**
     * @method
     * this method returns if there are any active tool using picking
     * @memberof pcvizTools.ToolBar
     * @return  {bool} true there are one using the picking, false there aren´t anyone 
     */
    isThereAnyPickingToolActive: function () {

        var group = 'picking';
        var result = false;

        if ( this._toolsGroupsMap.has( group ) ) {
            var toolArray = this._toolsGroupsMap.get( group );
            for ( var i = 0; i < toolArray.length; i++ ) {
                result = result | toolArray[ i ].isToolActive();
            }
        }
        return result;
    },

    forEach: function ( fn ) {
        this._toolsArray.forEach( fn );
    }
};

module.exports = ToolBar;


/***/ }),

/***/ "./sources/pcvizTools/pcvizTools.js":
/*!******************************************!*\
  !*** ./sources/pcvizTools/pcvizTools.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizTools_PointEditionTool__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizTools/PointEditionTool */ "./sources/pcvizTools/PointEditionTool.js");
/* harmony import */ var pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizTools/GizmoTool */ "./sources/pcvizTools/GizmoTool.js");
/* harmony import */ var pcvizTools_LayerTransformTool__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizTools/LayerTransformTool */ "./sources/pcvizTools/LayerTransformTool.js");
/* harmony import */ var pcvizTools_CursorTool__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizTools/CursorTool */ "./sources/pcvizTools/CursorTool.js");
/* harmony import */ var pcvizTools_ReferencePlanesTool__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizTools/ReferencePlanesTool */ "./sources/pcvizTools/ReferencePlanesTool.js");
/* harmony import */ var pcvizTools_PaintTool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizTools/PaintTool */ "./sources/pcvizTools/PaintTool.js");
/* harmony import */ var pcvizTools_SidesTool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizTools/SidesTool */ "./sources/pcvizTools/SidesTool.js");
/* harmony import */ var pcvizTools_ElevationTool__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizTools/ElevationTool */ "./sources/pcvizTools/ElevationTool.js");

var SettingsTool = __webpack_require__( /*! pcvizTools/SettingsTool */ "./sources/pcvizTools/SettingsTool.js" );
var DistanceTool = __webpack_require__( /*! pcvizTools/DistanceTool */ "./sources/pcvizTools/DistanceTool.js" );
var InformationTool = __webpack_require__( /*! pcvizTools/InformationTool */ "./sources/pcvizTools/InformationTool.js" );
var ClassificationTool = __webpack_require__( /*! pcvizTools/ClassificationTool */ "./sources/pcvizTools/ClassificationTool.js" );
var ToolBar = __webpack_require__( /*! pcvizTools/ToolBar */ "./sources/pcvizTools/ToolBar.js" );
var LayerEditionTool = __webpack_require__( /*! pcvizTools/LayerEditionTool */ "./sources/pcvizTools/LayerEditionTool.js" );
var AnnotationTool = __webpack_require__( /*! pcvizTools/AnnotationTool */ "./sources/pcvizTools/AnnotationTool.js" );
var ProjectEditionTool = __webpack_require__( /*! pcvizTools/ProjectEditionTool */ "./sources/pcvizTools/ProjectEditionTool.js" );
var AreaTool = __webpack_require__( /*! pcvizTools/AreaTool */ "./sources/pcvizTools/AreaTool.js" );
var BufferTool = __webpack_require__( /*! pcvizTools/BufferTool */ "./sources/pcvizTools/BufferTool.js" );
var ScreenshotTool = __webpack_require__( /*! pcvizTools/ScreenshotTool */ "./sources/pcvizTools/ScreenshotTool.js" );
var SaveViewTool = __webpack_require__( /*! pcvizTools/SaveViewTool */ "./sources/pcvizTools/SaveViewTool.js" );
var Tool = __webpack_require__( /*! pcvizTools/Tool */ "./sources/pcvizTools/Tool.js" );
var PickTool = __webpack_require__( /*! pcvizTools/PickTool */ "./sources/pcvizTools/PickTool.js" );

var FlyToTool = __webpack_require__( /*! pcvizTools/FlyToTool */ "./sources/pcvizTools/FlyToTool.js" );
var ControlPointTool = __webpack_require__( /*! pcvizTools/ControlPointTool */ "./sources/pcvizTools/ControlPointTool.js" );
var RegionTool = __webpack_require__( /*! pcvizTools/RegionTool */ "./sources/pcvizTools/RegionTool.js" );


var FindImagesTool = __webpack_require__( /*! pcvizTools/FindImagesTool */ "./sources/pcvizTools/FindImagesTool.js" );






/** @namespace pcvizTools */
var pcvizTools = {};
pcvizTools.SettingsTool = SettingsTool;
pcvizTools.DistanceTool = DistanceTool;
pcvizTools.InformationTool = InformationTool;
pcvizTools.ClassificationTool = ClassificationTool;
pcvizTools.ToolBar = ToolBar;
pcvizTools.LayerEditionTool = LayerEditionTool;
pcvizTools.AnnotationTool = AnnotationTool;
pcvizTools.ProjectEditionTool = ProjectEditionTool;
pcvizTools.AreaTool = AreaTool;
pcvizTools.BufferTool = BufferTool;
pcvizTools.ScreenshotTool = ScreenshotTool;
pcvizTools.SaveViewTool = SaveViewTool;
pcvizTools.Tool = Tool;
pcvizTools.PickTool = PickTool;
pcvizTools.PointEditionTool = pcvizTools_PointEditionTool__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizTools.FlyToTool = FlyToTool;
pcvizTools.ControlPointTool = ControlPointTool;
pcvizTools.RegionTool = RegionTool;
pcvizTools.GizmoTool = pcvizTools_GizmoTool__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizTools.LayerTransformTool = pcvizTools_LayerTransformTool__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizTools.FindImagesTool = FindImagesTool;
pcvizTools.CursorTool = pcvizTools_CursorTool__WEBPACK_IMPORTED_MODULE_3__["default"];
pcvizTools.PaintTool = pcvizTools_PaintTool__WEBPACK_IMPORTED_MODULE_5__["default"];
pcvizTools.POINT_SELECTION_MODE = pcvizTools_PointEditionTool__WEBPACK_IMPORTED_MODULE_0__["POINT_SELECTION_MODE"];
pcvizTools.POINT_SELECTION_OPERATION_MODE = pcvizTools_PointEditionTool__WEBPACK_IMPORTED_MODULE_0__["POINT_SELECTION_OPERATION_MODE"];
pcvizTools.ReferencePlanesTool = pcvizTools_ReferencePlanesTool__WEBPACK_IMPORTED_MODULE_4__["default"];
pcvizTools.REFERENCE_PLANE_TYPES = pcvizTools_ReferencePlanesTool__WEBPACK_IMPORTED_MODULE_4__["REFERENCE_PLANE_TYPES"];
pcvizTools.REFERENCE_PLANE_COLOR = pcvizTools_ReferencePlanesTool__WEBPACK_IMPORTED_MODULE_4__["REFERENCE_PLANE_COLOR"];
pcvizTools.SidesTool = pcvizTools_SidesTool__WEBPACK_IMPORTED_MODULE_6__["default"];
pcvizTools.ElevationTool = pcvizTools_ElevationTool__WEBPACK_IMPORTED_MODULE_7__["default"];

pcvizTools.SETTINGS = 'settings';
pcvizTools.INFORMATION = 'information';
pcvizTools.MEASURE = 'measure';
pcvizTools.CLASSIFICATION = 'classification';
pcvizTools.LAYER_EDITION = 'layerEdition';
pcvizTools.ANNOTATION = 'annotation';
pcvizTools.PROJECT_EDITION = 'projectEdition';
pcvizTools.BUFFER = 'buffer';
pcvizTools.VIEWER_CONFIGURATION = 'viewer-config';
pcvizTools.SCREENSHOT = 'screenshot';
pcvizTools.SAVEVIEW = 'saveview';
pcvizTools.FINDIMAGES = 'findImages';
pcvizTools.LAYER_TRANSFORM = 'layerTransform';
pcvizTools.CURSOR = 'cursor';
pcvizTools.POINT_EDITION = 'pointEdition';
pcvizTools.REFERENCE_PLANES = 'referencePlanes';
pcvizTools.VIRTUAL_TOUR = 'virtualTour';
pcvizTools.SIDES = 'sides';
pcvizTools.ELEVATION = 'elevation';

/* harmony default export */ __webpack_exports__["default"] = (pcvizTools);


/***/ }),

/***/ "./sources/pcvizUtils/CRSUtils.js":
/*!****************************************!*\
  !*** ./sources/pcvizUtils/CRSUtils.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Proj4 = __webpack_require__( /*! proj4 */ "./node_modules/proj4/lib/index.js" );
var Proj4Defs = __webpack_require__( /*! proj4/lib/defs */ "./node_modules/proj4/lib/defs.js" );
var Geoid = __webpack_require__( /*! pcvizGIS/Geoid */ "./sources/pcvizGIS/Geoid.js" ).default;
var Input = __webpack_require__( /*! pcvizDB/Input */ "./sources/pcvizDB/Input.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );

var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

/**
 *  CRSUtils Class
 *  @class
 *  @memberof pcvizUtils
 */
var CRSUtils = {

    cEpsgPrefix: 'EPSG:',
    cEpsgWGS84: 'EPSG:4326',

    epsgCache: new Map(),

    _geoidList: undefined,

    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizUtils.CRSUtils
     * @return {Object} The `CRSUtils` instance.
     */
    getInstance: function () {
        if ( !CRSUtils.instance ) {
            CRSUtils.instance = this;
        }
        return CRSUtils.instance;
    },

    /**
     * Returns the configured epsgServer
     * @method
     * @memberof pcvizUtils.CRSUtils
     * @return {Object} The url of the epsg server
     */
    epsgServer: function () {
        if ( MagnetAPI.getAPI() )
            return MagnetAPI.getAPI().epsgServer;
        return 'https://epsg-io.pointcloudviz.com';
    },

    /**
     * Returns the configured epsgServer
     * @method
     * @memberof pcvizUtils.CRSUtils
     * @return {Object} The url of the epsg server
     */
    geoidServer: function () {
        if ( MagnetAPI.getAPI() )
            return MagnetAPI.getAPI().geoidServer;
        return 'https://geoids.magnet-cloud.com';
    },

    defProj4: function ( code, proj4 ) {
        if ( !proj4 )
            return false;

        Proj4Defs( code, proj4 );
    },

    getProjectionInfo: function ( epsgCode, format ) {
        var self = this;
        var defer = P.defer();

        if ( !epsgCode || epsgCode === '-1' || epsgCode === -1 ) {
            defer.reject( 'Invalid epsg code' );
            return defer.promise;
        }

        if ( CRSUtils.epsgCache.has( epsgCode ) && CRSUtils.epsgCache.get( epsgCode ).defers.has( format ) ) {
            this.getProjectionInfoFromCache( epsgCode, format ).then( function ( epsgInfo ) {
                defer.resolve( epsgInfo );
            } );
            return defer.promise;
        }
        this.createProjectionInfoInCache( epsgCode, format );

        var xmlhttp = new XMLHttpRequest();
        xmlhttp.onreadystatechange = function () {
            if ( this.readyState === 4 && this.status === 200 ) {
                self.setProjectionInfoInCache( epsgCode, format, this.responseText );
                defer.resolve( this.responseText );
            } else if ( this.readyState === 4 && this.status !== 200 )
                defer.reject( this.responseText );
        };
        var url = CRSUtils.epsgServer() + '/' + epsgCode + format;
        xmlhttp.open( 'GET', url, true );

        xmlhttp.send();

        return defer.promise;
    },

    getCRSDatum: function ( code ) {
        var defer = P.defer();
        var self = this;

        // check if datum exists in cache
        if ( CRSUtils.epsgCache.has( code ) && CRSUtils.epsgCache.get( code ).datum ) {
            defer.resolve( CRSUtils.epsgCache.get( code ).datum );
            return defer.promise;
        }

        this.getProjectionInfo( code, this.FORMAT.XML ).then( function ( crsInfo ) {

            var parser = new DOMParser();

            if ( crsInfo === 'NOT AVAILABLE,PLEASE SELECT OTHER FORMAT' ) {
                // try through GML format
                self.getProjectionInfo( code, self.FORMAT.GML ).then( function ( crsInfoGML ) {
                    var gmlInfo = parser.parseFromString( crsInfoGML, 'text/xml' );

                    if ( self.parseDatumFromGeodeticGML( code, parser, defer, gmlInfo ) )
                        return;

                    // try as ProjectedCRS
                    var datumElements = gmlInfo.getElementsByTagName( 'gml:ProjectedCRS' );
                    if ( datumElements.length > 0 ) {
                        var datumEPSGElements = datumElements[ 0 ].getElementsByTagName( 'gml:baseGeodeticCRS' );
                        if ( datumEPSGElements.length < 1 ) {
                            defer.resolve( '' );
                            return;
                        }
                        var gmlDatumEPSG = datumEPSGElements[ 0 ].getAttribute( 'xlink:href' );
                        var n = gmlDatumEPSG.indexOf( 'EPSG::' );
                        if ( n === -1 ) {
                            defer.resolve( '' );
                            return;
                        }
                        // now access again the service to get the datum info
                        var geodeticEPSG = gmlDatumEPSG.substring( n + 6 );
                        self.getProjectionInfo( geodeticEPSG, self.FORMAT.GML ).then( function ( geodeticInfoGML ) {
                            var geodeticInfo = parser.parseFromString( geodeticInfoGML, 'text/xml' );
                            if ( !self.parseDatumFromGeodeticGML( code, parser, defer, geodeticInfo ) )
                                defer.resolve( '' );
                        } ).catch( function () {
                            defer.resolve( '' );
                        } );
                        return;
                    }

                } );
            } else { // parse from XML format

                var xmlInfo = parser.parseFromString( crsInfo, 'text/xml' );
                var elements = xmlInfo.getElementsByTagName( 'gml:datumName' );
                if ( elements.length < 1 ) {
                    defer.resolve( '' );
                    return;
                }

                var gmlDatum = self.gmlDatum2GeoSDKDatum( elements[ 0 ].innerHTML );
                self.storeDatumInCache( code, gmlDatum );
                defer.resolve( gmlDatum );
            }
        } );

        return defer.promise;
    },

    getCrsParams: function ( project ) {
        // find point cloud with a CRS, if any
        var options = {};
        if ( project === undefined )
            return options;
        var layers = project.getAllLayers();
        var layer = layers.find( function ( layer ) {
            // check if a PointCloud Layer has projection (WARN: This doesn't work with Vector Layers)
            if ( layer._layerObject && layer._layerObject.horizProjectionEPSG && layer._layerObject.horizProjectionEPSG !== '' )
                return layer;
        } );
        if ( layer ) {
            options.sourceCRS = layer._layerObject.horizProjectionEPSG;
            options.sourceProj4 = layer.getProj4();
        }
        options.destinationCRS = project.getProjection();
        options.destinationProj4 = project.getProj4();
        options.destinationGeoid = project.getGeoid();

        return options;
    },

    // returns whether the crsInfoGML passed is a GeodeticCRS or not

    parseDatumFromGeodeticGML: function ( code, parser, defer, gmlInfo ) {

        // try as GeodeticCRS
        var datumElements = gmlInfo.getElementsByTagName( 'gml:GeodeticCRS' );
        if ( datumElements.length > 0 ) {
            var nameElements = datumElements[ 0 ].getElementsByTagName( 'gml:name' );
            if ( nameElements.length < 1 ) {
                defer.resolve( '' );
                return true;
            }
            var gmlGeodeticDatum = this.gmlDatum2GeoSDKDatum( nameElements[ 0 ].innerHTML );
            this.storeDatumInCache( code, gmlGeodeticDatum );
            defer.resolve( gmlGeodeticDatum );
            return true;
        }
        return false;
    },

    gmlDatum2GeoSDKDatum: function ( gmlDatum ) {
        var geoSDKDatum = CRSUtils.DATUM_MAP.get( gmlDatum );
        return geoSDKDatum ? geoSDKDatum : gmlDatum;
    },

    createProjectionInfoInCache: function ( code, format ) {
        if ( !CRSUtils.epsgCache.has( code ) ) {
            CRSUtils.epsgCache.set( code, {
                info: new Map(),
                defers: new Map()
            } );
        }
        var cacheElement = CRSUtils.epsgCache.get( code );
        cacheElement.defers.set( format, [] );
    },

    storeDatumInCache: function ( code, datum ) {
        if ( !CRSUtils.epsgCache.has( code ) )
            return;

        var cacheElement = CRSUtils.epsgCache.get( code );
        cacheElement.datum = datum;
    },

    getProjectionInfoFromCache: function ( code, format ) {
        var defer = P.defer();
        var codeInfo = CRSUtils.epsgCache.get( code );
        if ( codeInfo.info.get( format ) ) {
            defer.resolve( codeInfo.info.get( format ) );
        } else {
            codeInfo.defers.get( format ).push( defer );
        }
        return defer.promise;
    },

    setProjectionInfoInCache: function ( code, format, info ) {
        var codeInfo = CRSUtils.epsgCache.get( code );
        codeInfo.info.set( format, info );
        while ( codeInfo.defers.get( format ).length ) {
            var defer = codeInfo.defers.get( format ).shift();
            defer.resolve( info );
        }
    },

    getWTKProjectionInfo: function ( epsgCode ) {
        return this.getProjectionInfo( epsgCode, CRSUtils.FORMAT.ESRIWKT );
    },

    // called from ui and collage-web libraries (sending a project or layer)
    setCRSNameToObject: function ( object ) {

        object.taCRS = object.horizProjectionEPSG;
        if ( !object.taCRS )
            return;

        if ( object.taCRS === undefined || object.taCRS === null )
            return;

        if ( object.taCRS.substring( 0, 5 ) !== 'EPSG:' )
            return;
        object.taCRS = object.horizProjectionEPSG.substring( 5, object.horizProjectionEPSG.length );

        // Gets the name of CRS to show in form input
        if ( object.taCRS.length < 3 ) // Expect minimum length
            return;
        this.getProjectionInfo( object.taCRS, CRSUtils.FORMAT.XML ).then( function ( info ) {
            var parser = new DOMParser();
            var xmlInfo = parser.parseFromString( info, 'text/xml' );
            if ( !xmlInfo.getElementsByTagName( 'gml:srsName' )[ 0 ] )
                return;
            object.taCRS = xmlInfo.getElementsByTagName( 'gml:srsName' )[ 0 ].innerHTML;
        } );
    },

    transformFeatureCollection: function ( featureCollection, sourceCRS, destinCRS, geoid ) {
        if ( !sourceCRS || !destinCRS || ( sourceCRS === destinCRS && !geoid ) )
            return featureCollection;

        var self = this;

        var newFeatureCollection = {
            type: 'FeatureCollection'
        };
        var newFeatureArray = [];
        featureCollection.features.forEach( function ( feature ) {
            var newFeature = JSON.parse( JSON.stringify( feature ) ); // clone
            self.transformGeoJSONFeature( newFeature, sourceCRS, destinCRS, geoid );
            newFeatureArray.push( newFeature );
        } );
        newFeatureCollection.features = newFeatureArray;
        return newFeatureCollection;
    },

    transformGeoJSONFeature: function ( feature, source, destination, geoid ) {
        var g = feature.geometry;
        switch ( g.type ) {
        case 'Point':
            this.transform( source, destination, g.coordinates, false, geoid );
            break;
            // if it is line string type
        case 'LineString':
            for ( var i = 0; i < g.coordinates.length; i++ ) {
                this.transform( source, destination, g.coordinates[ i ], false, geoid );
            }
            break;
            // if it is polygon type
        case 'Polygon':
            for ( var iRing = 0; iRing < g.coordinates.length; iRing++ ) {
                for ( var iPoint = 0; iPoint < g.coordinates[ iRing ].length; iPoint++ ) {
                    this.transform( source, destination, g.coordinates[ iRing ][ iPoint ], false, geoid );
                }
            }
            break;

        case 'MultiPoint':
            for ( var iPoints = 0; iPoints < g.coordinates.length; iPoints++ ) {
                this.transform( source, destination, g.coordinates[ iPoints ], false, geoid );
            }
            break;
        }
    },

    transform: ( function () {
        return function ( source, destination, coordinate, addErrorValue, geoid, addGeoid ) {
            var point = [];

            if ( source === 'EPSG:4978' && source !== destination ) {
                source = CRSUtils.WGS_84;
                var wgs84Coordinate = CRSUtils.convertXYZToLatLongHeight( coordinate[ 0 ], coordinate[ 1 ], coordinate[ 2 ] );
                coordinate[ 0 ] = wgs84Coordinate[ 1 ];
                coordinate[ 1 ] = wgs84Coordinate[ 0 ];
                coordinate[ 2 ] = wgs84Coordinate[ 2 ];
            }

            // if geoid is provided, use it to correct height on WGS ellipsoid (origin CRS)
            if ( geoid ) {
                var gPoint = [];
                gPoint[ 0 ] = coordinate[ 0 ];
                gPoint[ 1 ] = coordinate[ 1 ];
                gPoint[ 2 ] = coordinate[ 2 ];
                // first transform to WGS84 to get lon/lat coords
                var bOk = true;
                if ( source !== this.cEpsgWGS84 ) {
                    try {
                        gPoint = Proj4( source, this.cEpsgWGS84 ).forward( gPoint );
                    } catch ( projErr ) {
                        bOk = false;
                        // To manage the error in the ui
                        if ( addErrorValue )
                            coordinate[ 4 ] = projErr;
                    }
                }
                if ( bOk ) {
                    // geoid height correction
                    if ( addGeoid )
                        coordinate[ 2 ] += this.getGeoidHeight( geoid, gPoint[ 0 ], gPoint[ 1 ] );
                    else
                        coordinate[ 2 ] -= this.getGeoidHeight( geoid, gPoint[ 0 ], gPoint[ 1 ] );
                }
            }

            point[ 0 ] = coordinate[ 0 ];
            point[ 1 ] = coordinate[ 1 ];
            point[ 2 ] = coordinate[ 2 ];

            if ( source !== destination ) {
                try {
                    point = Proj4( source, destination ).forward( point );
                } catch ( err ) {
                    // To manage the error in the ui
                    if ( addErrorValue )
                        coordinate[ 4 ] = err;
                }

                coordinate[ 0 ] = point[ 0 ];
                coordinate[ 1 ] = point[ 1 ];
                coordinate[ 2 ] = point[ 2 ];
            }
            return coordinate;
        };
    } )(),

    ///////// GEOIDS ///////////

    getGeoidByID: function ( geoidID ) {
        if ( !this._geoidList ) // could not fetch list
            return undefined;

        // find geoid by ID
        var geoid = this._geoidList.find( function ( geoidItem ) {
            return ( geoidItem.geoidID === geoidID );
        } );
        return geoid;
    },

    getGeoidName: function ( geoidID ) {
        var defer = P.defer();
        var self = this;

        this.initGeoidList( this.geoidServer() ).then( function () {
            defer.resolve( self.getGeoidNameWithValidList( geoidID ) );
        } );

        return defer.promise;
    },

    getGeoidNameWithValidList: function ( geoidID ) {
        var geoid = this.getGeoidByID( geoidID );
        return geoid ? geoid.description : 'Not found in catalog';
    },

    geoidRegionsIntersect: function ( region1, region2 ) {

        var crossesPi = ( region2[ 2 ] + region2[ 3 ] > Math.PI );

        if ( !crossesPi )
            return this.geoidRegionsIntersectSimple( region1, region2 );

        // normalize region 2
        var region2c = [ region2[ 0 ], region2[ 1 ], region2[ 2 ] - Math.PI, region2[ 3 ] ];

        return this.geoidRegionsIntersectSimple( region1, region2c );
    },

    // with normalized region (does not cross Pi longitude)
    geoidRegionsIntersectSimple: function ( region1, region2 ) {

        if ( region1[ 0 ] + region1[ 1 ] < region2[ 0 ] ) // maxLat1 < minLat2
            return false;
        if ( region1[ 0 ] > region2[ 0 ] + region2[ 1 ] ) // minLat1 > maxLat2
            return false;
        if ( region1[ 2 ] + region1[ 3 ] < region2[ 2 ] ) // maxLat1 < minLat2
            return false;
        if ( region1[ 2 ] > region2[ 2 ] + region2[ 3 ] ) // minLat1 > maxLat2
            return false;
        return true;
    },

    // with normalized region (does not cross Pi longitude)
    geoidRegionIncludesSimple: function ( region, lat, lon ) {

        if ( region[ 0 ] + region[ 1 ] < lat )
            return false;
        if ( region[ 0 ] > lat )
            return false;
        if ( region[ 2 ] + region[ 3 ] < lon )
            return false;
        if ( region[ 2 ] > lon )
            return false;
        return true;
    },

    geoidRegionIncludes: function ( region, lat, lon ) {

        var crossesPi = ( region[ 2 ] + region[ 3 ] > Math.PI );

        if ( !crossesPi )
            return this.geoidRegionIncludesSimple( region, lat, lon );

        // normalize region 2
        var regionc = [ region[ 0 ], region[ 1 ], region[ 2 ] - Math.PI, region[ 3 ] ];

        return this.geoidRegionIncludesSimple( regionc, lat, lon );
    },

    filterGeoid: function ( geoid ) { // options are passed through 'this'
        // compare extents
        if ( !geoid.region )
            return false;
        if ( !this.geoidRegionsIntersect( this.region, geoid.region ) )
            return false;

        // compare datum
        if ( !this.datum || this.datum === '' )
            return true;

        for ( var iDatum = 0; iDatum < geoid.datums.length; iDatum++ )
            if ( geoid.datums[ iDatum ] === this.datum )
                return true;

        return false;
    },

    findGeoids: function ( region, datum ) {
        if ( !this._geoidList )
            return [];

        return this._geoidList.filter( this.filterGeoid, {
            region: region,
            datum: datum,
            geoidRegionsIntersect: this.geoidRegionsIntersect,
            geoidRegionsIntersectSimple: this.geoidRegionsIntersectSimple
        } );
    },

    // for searching geoids by aprox name
    findGeoidsByIDImpl: function ( text, datum ) {

        if ( !this._geoidList ) // could not fetch list
            return [];

        return this._geoidList.filter( function ( geoid ) {

            if ( text !== '' ) {
                var textUp = text.toUpperCase();
                var textMatch = ( geoid.geoidID.toUpperCase().indexOf( textUp ) !== -1 ||
                    geoid.description.toUpperCase().indexOf( textUp ) !== -1 );
                if ( !textMatch || !datum || datum === '' )
                    return textMatch;
            }

            var datumMatch = false;
            if ( datum && datum.length > 0 && geoid.datum ) {
                for ( var iDatum = 0; iDatum < geoid.datums.length; iDatum++ ) {
                    if ( geoid.datums[ iDatum ].indexOf( datum ) !== -1 ) {
                        datumMatch = true;
                        break;
                    }
                }
            }
            return datumMatch;

        } );
    },

    // called by search GUI directive
    findGeoidsByID: function ( value ) {
        var defer = P.defer();

        var self = this;

        this.initGeoidList( this.geoidServer() ).then( function () {
            var geoids = self.findGeoidsByIDImpl( value, '' ); // get whole list matching value
            defer.progress( 1.0 ); // all pages loaded
            defer.resolve( geoids );
        } );

        return defer.promise;
    },

    getGeoidDatums: function ( geoidID ) {
        var defer = P.defer();

        var self = this;

        this.initGeoidList( this.geoidServer() ).then( function () {
            var geoid = self.getGeoidByID( geoidID );
            if ( !geoid ) {
                defer.reject();
                return;
            }
            defer.resolve( geoid.datums );
        } );

        return defer.promise;
    },

    loadGeoidFiles: function ( geoid, region ) {
        var defer = P.defer();

        if ( !geoid.files || !this._geoidLibURL ) {
            defer.resolve( [ false ] ); // no files were loaded
            return defer.promise;
        }

        // find and load files for the right extent
        var promises = [];
        var intersect = 0;
        for ( var iFile = 0; iFile < geoid.files.length; iFile++ ) {

            var file = geoid.files[ iFile ];

            if ( this.geoidRegionsIntersect( region, file.region ) ) {
                intersect++;
                if ( file.geoidData && file.geoidData.isValid() )
                    continue;

                file.geoidData = new Geoid();
                promises.push( file.geoidData.readFromURL( file.link ) );
            }
        }
        if ( intersect === 0 )
            console.error( 'No geoid files match the given extent/region' );

        if ( promises.length === 0 ) { // no file loading requests
            defer.resolve( [ true ] );
            return defer.promise;
        }

        // wait for all promises to be resolved
        P.all( promises ).then( function ( okArray ) {
            defer.resolve( okArray );
        } );

        return defer.promise;
    },

    getGeoidHeight: function ( geoid, longitudeDegrees, latitudeDegrees ) {

        var normalizedLon = longitudeDegrees * Math.PI / 180.0;
        var normalizedLat = latitudeDegrees * Math.PI / 180.0;

        for ( var iFile = 0; iFile < geoid.files.length; iFile++ ) {

            var file = geoid.files[ iFile ];
            if ( this.geoidRegionIncludes( file.region, normalizedLat, normalizedLon ) && file.geoidData && file.geoidData.isValid() )
                return file.geoidData.getHeight( normalizedLon, normalizedLat );
        }
        return 0.0;
    },

    getGeoidCorrection: function ( point, crsOptions ) {
        if ( !crsOptions.destinationGeoid )
            return 0.0;

        var gPoint = [];
        gPoint[ 0 ] = point[ 0 ];
        gPoint[ 1 ] = point[ 1 ];
        gPoint[ 2 ] = point[ 2 ];
        // first transform to WGS84 to get lon/lat coords
        if ( crsOptions.sourceCRS !== this.cEpsgWGS84 ) {
            this.defProj4( crsOptions.sourceCRS, crsOptions.sourceProj4 );
            try {
                gPoint = Proj4( crsOptions.sourceCRS, this.cEpsgWGS84 ).forward( gPoint );
            } catch ( error ) {
                //console.error( 'Error projecting center for geoid correction' );
                return 0.0;
            }
        }

        var height = this.getGeoidHeight( crsOptions.destinationGeoid, gPoint[ 0 ], gPoint[ 1 ] );

        return Number.isNaN( height ) ? 0.0 : height;
    },

    initGeoidList: function ( indexUrl ) {

        if ( !indexUrl )
            indexUrl = this.geoidServer();

        if ( indexUrl === '' ) {
            return P.resolve();
        }

        var defer = P.defer();

        if ( this._geoidList ) { // no need to request it again
            defer.resolve( this._geoidList );
            return defer.promise;
        }

        var input = new Input();
        var options = {
            responseType: 'text'
        };
        this._geoidLibURL = indexUrl;

        var self = this;

        input.request( indexUrl + '/v1/geoids', options, true ).then( function ( response ) {
            self._geoidList = JSON.parse( response );
            self._valid = true;

            // accumulate extents for each geoid
            self._geoidList.forEach( function ( geoid ) {
                var geoidMinLat = 99.0;
                var geoidMaxLat = -99.0;
                var geoidMinLon = 99.0;
                var geoidMaxLon = -99.0;

                for ( var iFile = 0; iFile < geoid.files.length; iFile++ ) {
                    // calculate region
                    var file = geoid.files[ iFile ];
                    /*jshint camelcase: false */
                    file.region = [ parseFloat( file.area.lat_min ), parseFloat( file.area.lat_range ), parseFloat( file.area.lon_min ), parseFloat( file.area.lon_range ) ];
                    /*jshint camelcase: true */

                    if ( file.region[ 0 ] < geoidMinLat )
                        geoidMinLat = file.region[ 0 ];
                    if ( file.region[ 2 ] < geoidMinLon )
                        geoidMinLon = file.region[ 2 ];
                    if ( file.region[ 0 ] + file.region[ 1 ] > geoidMaxLat )
                        geoidMaxLat = file.region[ 0 ] + file.region[ 1 ];
                    if ( file.region[ 2 ] + file.region[ 3 ] > geoidMaxLon )
                        geoidMaxLon = file.region[ 2 ] + file.region[ 3 ];
                }
                geoid.region = [ geoidMinLat, geoidMaxLat - geoidMinLat, geoidMinLon, geoidMaxLon - geoidMinLon ];
            } );

            defer.resolve( self._geoidList );

        } ).catch( function ( error ) {
            console.error( 'Could not read Geoid index file: ' + error );
            defer.reject( { 'status': 'GEOIDLIST' } );
        } );

        return defer.promise;
    },

    /** Finds a suitable EPSG code for a given UTM Zone
     * @param zone UTM zone number
     * @param northp True if the zone is in the north hemisphere
     * returns int with the computed EPSG number
     */
    encodeEPSG: function ( zone, northp ) {
        var epsg = -1;
        if ( zone === 0 )
            epsg = 32761;
        else if ( zone >= 1 && zone <= 60 )
            epsg = ( zone - 1 ) + 32701;
        if ( epsg >= 0 && northp )
            epsg += 32661 - 32761;
        return epsg;
    },

    /** Finds a suitable EPSG code for a given Latitude and Longitude
     * @param lat Latitude value
     * @param lon Longitude value
     * returns int with the computed EPSG number
     */
    latLonToEPSG: function ( lat, lon ) {
        var floor = Math.floor( ( lon + 180 ) / 6 );
        var module = floor % 60;
        var zone = module + 1;
        return this.encodeEPSG( zone, ( lat > 0 ) );
    },


    convertXYZToLatLongHeight: function ( X, Y, Z ) {
        var radiusPolar = 6356752.3;
        var radiusEquator = 6378137.0;

        var flattening = ( radiusEquator - radiusPolar ) / radiusEquator;
        var _eccentricitySquared = 2 * flattening - flattening * flattening;

        var p = Math.sqrt( X * X + Y * Y );
        var theta = Math.atan2( Z * radiusEquator, ( p * radiusPolar ) );
        var eDashSquared = ( radiusEquator * radiusEquator - radiusPolar * radiusPolar ) / ( radiusPolar * radiusPolar );

        var sinTheta = Math.sin( theta );
        var cosTheta = Math.cos( theta );

        var latitude = Math.atan( ( Z + eDashSquared * radiusPolar * sinTheta * sinTheta * sinTheta ) /
            ( p - _eccentricitySquared * radiusEquator * cosTheta * cosTheta * cosTheta ) );
        var longitude = Math.atan2( Y, X );

        var sinLatitude = Math.sin( latitude );
        var N = radiusEquator / Math.sqrt( 1.0 - _eccentricitySquared * sinLatitude * sinLatitude );

        var height = p / Math.cos( latitude ) - N;

        latitude = latitude * 180 / Math.PI;
        longitude = longitude * 180 / Math.PI;

        return [ latitude, longitude, height ];
    },

    transformFromECEFTo: function ( point, destEPSG ) {
        var pWGS84 = CRSUtils.convertXYZToLatLongHeight( point[ 0 ], point[ 1 ], point[ 2 ] );
        var pUTM = CRSUtils.transform( CRSUtils.WGS_84, 'EPSG:' + destEPSG, [ pWGS84[ 1 ], pWGS84[ 0 ], pWGS84[ 2 ] ] );
        return pUTM;
    },

    reprojectExtent( extent, fromProj, toProj ) {

        if ( !fromProj || fromProj === '' || !toProj || toProj === '' )
            return extent;

        let minReproj = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
        let maxReproj = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];
        let corners = [];
        corners.push( [ extent[ 0 ], extent[ 1 ], extent[ 2 ] ] );
        corners.push( [ extent[ 3 ], extent[ 4 ], extent[ 5 ] ] );
        corners.push( [ extent[ 0 ], extent[ 1 ], extent[ 5 ] ] );
        corners.push( [ extent[ 0 ], extent[ 4 ], extent[ 2 ] ] );
        corners.push( [ extent[ 0 ], extent[ 4 ], extent[ 5 ] ] );
        corners.push( [ extent[ 3 ], extent[ 1 ], extent[ 2 ] ] );
        corners.push( [ extent[ 3 ], extent[ 1 ], extent[ 5 ] ] );
        corners.push( [ extent[ 3 ], extent[ 4 ], extent[ 2 ] ] );

        for ( let i = 0; i < corners.length; i++ ) {
            CRSUtils.transform( fromProj, toProj, corners[ i ], false );
            for ( let j = 0; j < 3; j++ ) {
                minReproj[ j ] = Math.min( corners[ i ][ j ], minReproj[ j ] );
                maxReproj[ j ] = Math.max( corners[ i ][ j ], maxReproj[ j ] );
            }
        }

        return [ minReproj[ 0 ], minReproj[ 1 ], minReproj[ 2 ], maxReproj[ 0 ], maxReproj[ 1 ], maxReproj[ 2 ] ];
    },


    reprojectOrientation: function ( point, attitude, epsgOrigin, epsgDestination ) {
        var attitudeQuat = osg.quat.fromValues( attitude[ 0 ], attitude[ 1 ], attitude[ 2 ], attitude[ 3 ] );
        var incr = ( epsgOrigin === this.WGS_84 ) ? 0.0001 : 1.0;
        var fromOrigin = osg.vec3.fromValues( point[ 0 ], point[ 1 ], point[ 2 ] );
        var fromXAxis = osg.vec3.fromValues( point[ 0 ] + incr, point[ 1 ], point[ 2 ] );
        var fromYAxis = osg.vec3.fromValues( point[ 0 ], point[ 1 ] + incr, point[ 2 ] );

        var projectedPoint = CRSUtils.transform( epsgOrigin, epsgDestination, [ point[ 0 ], point[ 1 ], point[ 2 ] ] );

        var projOrigin = osg.vec3.fromValues( projectedPoint[ 0 ], projectedPoint[ 1 ], projectedPoint[ 2 ] );

        var projXAxis = CRSUtils.transform( epsgOrigin, epsgDestination, [ point[ 0 ] + incr, point[ 1 ], point[ 2 ] ] );
        var projYAxis = CRSUtils.transform( epsgOrigin, epsgDestination, [ point[ 0 ], point[ 1 ] + incr, point[ 2 ] ] );

        var projTransform = this.findTransformBetween2CS( fromOrigin, fromXAxis, fromYAxis, projOrigin, projXAxis, projYAxis );
        var attitudeProj = osg.mat4.getRotation( osg.quat.create(), projTransform );
        var totalRot = osg.quat.create();
        osg.quat.multiply( totalRot, attitudeProj, attitudeQuat );
        osg.quat.normalize( totalRot, totalRot );

        return totalRot;
    },

    findTransformBetween2CS: function ( fr0, fr1, fr2, to0, to1, to2 ) {


        // Axes of the coordinate system "fr"
        var x1 = osg.vec3.fromValues( fr1[ 0 ] - fr0[ 0 ], fr1[ 1 ] - fr0[ 1 ], fr1[ 2 ] - fr0[ 2 ] );
        osg.vec3.normalize( x1, x1 );

        var y1 = osg.vec3.fromValues( fr2[ 0 ] - fr0[ 0 ], fr2[ 1 ] - fr0[ 1 ], fr2[ 2 ] - fr0[ 2 ] );
        osg.vec3.normalize( y1, y1 );


        // Axes of the coordinate system "to"
        var x2 = osg.vec3.fromValues( to1[ 0 ] - to0[ 0 ], to1[ 1 ] - to0[ 1 ], to1[ 2 ] - to0[ 2 ] );
        osg.vec3.normalize( x2, x2 );

        var y2 = osg.vec3.fromValues( to2[ 0 ] - to0[ 0 ], to2[ 1 ] - to0[ 1 ], to2[ 2 ] - to0[ 2 ] );
        osg.vec3.normalize( y2, y2 );

        // transform from CS1 to CS2
        // Note: if fr0==(0,0,0) --> CS1==CS2 --> T2=Identity
        var crossX1Y1 = osg.vec3.create();
        osg.vec3.cross( crossX1Y1, x1, y1 );
        var T2 = osg.mat4.fromValues( x1[ 0 ], x1[ 1 ], x1[ 2 ], 0, y1[ 0 ], y1[ 1 ], y1[ 2 ], 0, crossX1Y1[ 0 ], crossX1Y1[ 1 ], crossX1Y1[ 2 ], 0, 0, 0, 1 );

        var crossX2Y2 = osg.vec3.create();
        osg.vec3.cross( crossX2Y2, x2, y2 );
        var T3 = osg.mat4.fromValues( x2[ 0 ], x2[ 1 ], x2[ 2 ], 0, y2[ 0 ], y2[ 1 ], y2[ 2 ], 0, crossX2Y2[ 0 ], crossX2Y2[ 1 ], crossX2Y2[ 2 ], 0, 0, 0, 1 );

        var T = osg.mat4.create();
        // Note: if CS1==CS2 --> T = T3
        var inv = osg.mat4.create();
        osg.mat4.invert( inv, T2 );
        osg.mat4.mul( T, T3, inv );

        return T;
    },

    isEcefPoint: function ( x, y, z ) {
        // From Wikipedia
        //    Equatorial radius: 6378.1 km
        //    Polar radius:      6356.8 km
        var offset = 10000; // 10km offset since the data could be underground or at very high altitude
        var minRadius = 6356800.0 - offset;
        var maxRadius = 6378100.0 + offset;
        var radius = Math.sqrt( x * x + y * y + z * z );

        if ( minRadius < radius && radius < maxRadius ) {
            return true;
        }
        return false;
    },

    getCoordLabel: function ( projection, index, withUnits ) {
        if ( projection === 'EPSG:4978' || projection === null || projection === undefined ) // ECEF
            return CRSUtils.defaultCoordName( index );
        if ( projection === 'EPSG:4326' ) // WGS84
            return CRSUtils.latLongCoordName( index, withUnits );

        return CRSUtils.ENUCoordName( index );
    },

    defaultCoordName: function ( valueIndex ) {
        switch ( valueIndex ) {
        case 0:
            return 'X';
        case 1:
            return 'Y';
        case 2:
            return 'Z';
        }
        return '';
    },

    latLongCoordName: function ( valueIndex, withUnits ) {
        switch ( valueIndex ) {
        case 0:
            if ( withUnits )
                return 'UNIT_SERVICE.L_DECIMAL_DEGREES';
            return 'L';
        case 1:
            if ( withUnits )
                return 'UNIT_SERVICE.B_DECIMAL_DEGREES';
            return 'B';
        case 2:
            if ( withUnits )
                return 'UNIT_SERVICE.H';
            return 'H';
        }
        return '';
    },

    ENUCoordName: function ( valueIndex ) {
        switch ( valueIndex ) {
        case 0:
            return 'E';
        case 1:
            return 'N';
        case 2:
            return 'U';
        }
        return '';
    }
};

CRSUtils.FORMAT = {
    ESRIWKT: '.esriwkt',
    PROJ4: '.proj4',
    XML: '.xml',
    GML: '.gml'
};

CRSUtils.DATUM_MAP = new Map(
    [
        [ 'WGS_1984', 'WGS84' ],
        [ 'European_Terrestrial_Reference_System_1989', 'ETRS89' ],
        [ 'European_Datum_1950', 'ED50' ],
        [ 'North_American_Datum_1983', 'NAD83' ],
        [ 'North_American_Datum_1927', 'NAD27' ],
        [ 'Reseau_Geodesique_Francais_1993', 'RGF93' ],
    ]
);

CRSUtils.DEFAULT_PROJECTION = 'EPSG:3857';
CRSUtils.WGS_84 = 'EPSG:4326';

module.exports = CRSUtils;


/***/ }),

/***/ "./sources/pcvizUtils/ComputeBoundingVisitor.js":
/*!******************************************************!*\
  !*** ./sources/pcvizUtils/ComputeBoundingVisitor.js ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );


var ComputeBoundingVisitor = function () {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._bounding = new osg.BoundingBox();
    this._modelMat = undefined;
};

ComputeBoundingVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {

        var bbox = new osg.BoundingBox();
        node.computeBoundingBox( bbox );

        if ( bbox.getMax()[ 0 ] !== -Infinity ) {

            var nodePath = Utils.computeNodePath( node );
            var modelMat = osg.computeLocalToWorld( nodePath, true );
            var min = bbox.getMin();
            var max = bbox.getMax();
            var minVec = osg.vec3.create();
            var maxVec = osg.vec3.create();
            osg.vec3.transformMat4( minVec, min, modelMat );
            osg.vec3.transformMat4( maxVec, max, modelMat );
            var tempBounding = new osg.BoundingBox();
            tempBounding._min = osg.vec3.fromValues( minVec[ 0 ], minVec[ 1 ], minVec[ 2 ] );
            tempBounding._max = osg.vec3.fromValues( maxVec[ 0 ], maxVec[ 1 ], maxVec[ 2 ] );
            this._bounding.expandByBoundingBox( tempBounding );

            this._modelMat = modelMat;
        }
        this.traverse( node );
    },

    getBounding: function () {
        return this._bounding;
    },

    getModelMatrix: function () {
        return this._modelMat;
    }
} );

module.exports = ComputeBoundingVisitor;


/***/ }),

/***/ "./sources/pcvizUtils/EigenAxis.js":
/*!*****************************************!*\
  !*** ./sources/pcvizUtils/EigenAxis.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var numeric = __webpack_require__( /*! numeric */ "./node_modules/numeric/numeric-1.2.6.js" );

var osg = OSG.osg;
var vec3 = osg.vec3;

/**
 * Class to get the eigen vectors of a node
 *  @class
 *  @memberof pcvizUtils
 */
var EigenAxis = function ( vertices ) {
    this.vertices = [];
    if ( vertices !== undefined )
        this._vertices = vertices;

    // for debug
    this._gizmoNode = undefined;
    this._program = undefined;
};

EigenAxis.X_AXIS = 0;
EigenAxis.Y_AXIS = 1;
EigenAxis.Z_AXIS = 2;

EigenAxis.prototype = {

    /**
     * Create the covariance matrix from the object vertex
     * @method
     * @memberof pcvizUtils.EigenAxis
     * @param {Array} vertices Array of vec3 with the vertex of the geometry
     * @return {Array} covariance matrix
     */
    createCovarianceMatrix: function ( vertices ) {
        var mX = 0.0,
            mY = 0.0,
            mZ = 0.0;
        var sumX = 0.0,
            sumY = 0.0,
            sumZ = 0.0;
        for ( var i = 0; i < vertices.length; i++ ) {
            sumX = sumX + vertices[ i ][ 0 ];
            sumY = sumY + vertices[ i ][ 1 ];
            sumZ = sumZ + vertices[ i ][ 2 ];
        }
        mX = sumX / vertices.length;
        mY = sumY / vertices.length;
        mZ = sumZ / vertices.length;

        var sum11 = 0.0,
            sum12 = 0.0,
            sum22 = 0.0,
            sum13 = 0.0,
            sum33 = 0.0,
            sum23 = 0.0;
        for ( i = 0; i < vertices.length; i++ ) {
            // diagonal
            sum11 = sum11 + ( ( vertices[ i ][ 0 ] - mX ) * ( vertices[ i ][ 0 ] - mX ) );
            sum22 = sum22 + ( ( vertices[ i ][ 1 ] - mY ) * ( vertices[ i ][ 1 ] - mY ) );
            sum33 = sum33 + ( ( vertices[ i ][ 2 ] - mZ ) * ( vertices[ i ][ 2 ] - mZ ) );


            sum12 = sum12 + ( ( vertices[ i ][ 0 ] - mX ) * ( vertices[ i ][ 1 ] - mY ) );
            sum13 = sum13 + ( ( vertices[ i ][ 0 ] - mX ) * ( vertices[ i ][ 2 ] - mZ ) );
            sum23 = sum23 + ( ( vertices[ i ][ 1 ] - mY ) * ( vertices[ i ][ 2 ] - mZ ) );
        }
        var covMatrix = [];
        covMatrix[ 0 ] = sum11 / vertices.length;
        covMatrix[ 1 ] = sum12 / vertices.length;
        covMatrix[ 2 ] = sum13 / vertices.length;
        covMatrix[ 3 ] = covMatrix[ 1 ];
        covMatrix[ 4 ] = sum22 / vertices.length;
        covMatrix[ 5 ] = sum23 / vertices.length;
        covMatrix[ 6 ] = covMatrix[ 2 ];
        covMatrix[ 7 ] = covMatrix[ 5 ];
        covMatrix[ 8 ] = sum33 / vertices.length;

        var covMatrixEig = [
            [ covMatrix[ 0 ], covMatrix[ 1 ], covMatrix[ 2 ] ],
            [ covMatrix[ 3 ], covMatrix[ 4 ], covMatrix[ 5 ] ],
            [ covMatrix[ 6 ], covMatrix[ 7 ], covMatrix[ 8 ] ]
        ];

        return covMatrixEig;
    },

    /**
     * Get the eigen axis. R is the principal, S the second and T the third.
     * @method
     * @memberof pcvizUtils.EigenAxis
     * @return {Object} Object with R,S and T vector that represent the axis of the object.
     */
    getEigenAxis: function () {
        var covMatrix = this.createCovarianceMatrix( this._vertices );
        var eigenVectors = numeric.eig( covMatrix );

        // findin the maximun
        var maxIndex = 0;
        var maxValue = eigenVectors.lambda.x[ 0 ];
        for ( var i = 1; i < eigenVectors.lambda.x.length; i++ ) {
            var val = eigenVectors.lambda.x[ i ];
            if ( val > maxValue ) {
                maxIndex = i;
                maxValue = val;
            }
        }
        var minIndex = 0;
        var minValue = eigenVectors.lambda.x[ 0 ];
        for ( i = 1; i < eigenVectors.lambda.x.length; i++ ) {
            var valMin = eigenVectors.lambda.x[ i ];
            if ( valMin < minValue ) {
                minIndex = i;
                minValue = valMin;
            }
        }
        var midIndex = 3 - ( minIndex + maxIndex );
        var out = {};
        out.R = vec3.fromValues( eigenVectors.E.x[ 0 ][ maxIndex ], eigenVectors.E.x[ 1 ][ maxIndex ], eigenVectors.E.x[ 2 ][ maxIndex ] );
        out.S = vec3.fromValues( eigenVectors.E.x[ 0 ][ midIndex ], eigenVectors.E.x[ 1 ][ midIndex ], eigenVectors.E.x[ 2 ][ midIndex ] );
        out.T = vec3.fromValues( eigenVectors.E.x[ 0 ][ minIndex ], eigenVectors.E.x[ 1 ][ minIndex ], eigenVectors.E.x[ 2 ][ minIndex ] );

        return out;
    },


    /**
     * Creates a debug node to show the axes
     * @method
     * @return {osg.Node} Return the osg node
     */
    createDebugGizmos: function () {
        this._gizmoNode = new osg.Node();
        this._gizmoNode.addChild( this.createDebugLineGeometry( [ 1.0, 0.0, 0.0 ] ) );
        this._gizmoNode.addChild( this.createDebugLineGeometry( [ 0.0, 1.0, 0.0 ] ) );
        this._gizmoNode.addChild( this.createDebugLineGeometry( [ 0.0, 0.0, 1.0 ] ) );
        return this._gizmoNode;
    },

    createDebugLineGeometry: function ( color ) {
        var g = new osg.Geometry();
        g.getAttributes().Vertex = new osg.BufferArray( osg.BufferArray.ARRAY_BUFFER, new Float32Array( 6 ), 3 );
        var primitive = new osg.DrawArrays( osg.primitiveSet.LINES, 0, 2 );
        g.getPrimitives().push( primitive );
        g.getOrCreateStateSet().setAttributeAndModes( this.getOrCreateShader() );
        g.getOrCreateStateSet().addUniform( osg.Uniform.createFloat3( color, 'color' ) );
        return g;
    },

    /**
     * Update the position of the axes
     * @method
     * @param {int} axis Axis to update. It can be EigenAxis.X_AXIS, EigenAxis.Y_AXIS, EigenAxis.Z_AXIS
     * @param {float} x1 X coordinate of the origin of the line
     * @param {float} y1 y coordinate of the origin of the line
     * @param {float} z1 z coordinate of the origin of the line
     * @param {float} x2 X coordinate of the end of the line
     * @param {float} y2 y coordinate of the end of the line
     * @param {float} z2 z coordinate of the end of the line
     */
    drawLineDebug: function ( axis, x1, y1, z1, x2, y2, z2 ) {
        var buffer = this._gizmoNode.getChildren()[ axis ].getAttributes().Vertex;

        buffer.getElements()[ 0 ] = x1;
        buffer.getElements()[ 1 ] = y1;
        buffer.getElements()[ 2 ] = z1;

        buffer.getElements()[ 3 ] = x2;
        buffer.getElements()[ 4 ] = y2;
        buffer.getElements()[ 5 ] = z2;

        buffer.dirty();
    },

    getOrCreateShader: function () {

        if ( this._program ) return this._program;
        var shaderName = '#define SHADER_NAME EigenGizmoLine';
        var vertexShader = [
            '',
            '#version 100',
            shaderName,
            '#ifdef GL_FRAGMENT_PRECISION_HIGH',
            'precision highp float;',
            '#else',
            'precision mediump float;',
            '#endif',
            'attribute vec3 Vertex;',
            'attribute vec2 TexCoord0;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;',
            'void main(void) {',
            '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex,1.0);',
            '}',
            ''
        ].join( '\n' );

        var fragmentShader = [
            '',
            '#ifdef GL_ES',
            'precision highp float;',
            '#endif',
            shaderName,
            '',
            'uniform vec3 color;',
            'void main(void) {',
            '  gl_FragColor = vec4(color, 1.0);',
            '}'
        ].join( '\n' );

        this._program = new osg.Program(
            new osg.Shader( osg.Shader.VERTEX_SHADER, vertexShader ),
            new osg.Shader( osg.Shader.FRAGMENT_SHADER, fragmentShader )
        );
        return this._program;
    },
};

module.exports = EigenAxis;


/***/ }),

/***/ "./sources/pcvizUtils/EventKeys.js":
/*!*****************************************!*\
  !*** ./sources/pcvizUtils/EventKeys.js ***!
  \*****************************************/
/*! exports provided: EVENT_KEYS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EVENT_KEYS", function() { return EVENT_KEYS; });
const EVENT_KEYS = {
    ESCAPE: 'Escape',
    ESC: 'Esc',
    ENTER: 'Enter',
    SHIFT: 'Shift',
    ARROW_UP: 'ArrowUp',
    ARROW_DOWN: 'ArrowDown'
};


/***/ }),

/***/ "./sources/pcvizUtils/FindGeometryVisitor.js":
/*!***************************************************!*\
  !*** ./sources/pcvizUtils/FindGeometryVisitor.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var Geometry = osg.Geometry;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;


var FindGeometryVisitor = function ( layer, f, rootNode ) {
    osg.NodeVisitor.call( this, osg.NodeVisitor.TRAVERSE_ALL_CHILDREN );
    this._layer = layer;
    this._geometryArray = [];
    this._rootNode = rootNode;
    this._nodePath = undefined;
    this._feature = f;
};

FindGeometryVisitor.prototype = osg.objectInherit( osg.NodeVisitor.prototype, {
    apply: function ( node ) {

        switch ( this._layer.getType() ) {
        case LayerType.POINTCLOUD:
            this.applyPointcloudLayer( node );
            break;
        case LayerType.RASTER:
            this.applyRasterLayer( node );
            break;
        case LayerType.VECTOR:
        case LayerType.MODEL3D:
            this.applyVectorLayer( node );
            break;
        }

        this.traverse( node );
    },

    applyVectorLayer: function ( node ) {
        var userData = node.getUserData();

        var featureId;
        if ( this._feature !== undefined )
            featureId = this._feature.getId();

        if ( userData !== undefined ) {
            var layerId = this._layer.getId();
            if ( layerId === userData.layerId ) {


                if ( featureId === undefined && node instanceof Geometry ) {
                    this._geometryArray.push( node );
                    return;
                }

                if ( userData.featureIds !== undefined ) {
                    for ( var i = 0; i < userData.featureIds.length; i++ ) {
                        if ( featureId === userData.featureIds[ i ] ) {
                            this._geometryArray.push( node );
                            break;
                        }
                    }
                }
                this._nodePath = this.nodePath;
            }
        }
    },

    applyPointcloudLayer: function ( node ) {
        if ( this._layer.getId() === node.Id ) {
            this._rootNode = node;
            for ( var t = 0; t < node.getNumChildren(); t++ ) {
                if ( node.getChild( t ) instanceof Geometry )
                    this._geometryArray.push( node.getChild( t ) );
            }
        }
    },

    applyRasterLayer: function ( node ) {
        if ( this._layer.getId() === node.Id ) {
            this._rootNode = node;
            for ( var t = 0; t < node.getChild( 0 ).getNumChildren(); t++ ) {
                if ( node.getChild( 0 ).getChild( t ) instanceof Geometry )
                    this._geometryArray.push( node.getChild( 0 ).getChild( t ) );
            }
        }
    },

    getGeometryArray: function () {
        return this._geometryArray;
    },

    getNodePath: function () {
        return this._nodePath;
    },

    getRootNode: function () {
        return this._rootNode;
    }
} );

module.exports = FindGeometryVisitor;


/***/ }),

/***/ "./sources/pcvizUtils/HighlightScans.js":
/*!**********************************************!*\
  !*** ./sources/pcvizUtils/HighlightScans.js ***!
  \**********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HighlightScans; });
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js");
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Insider2D__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./Insider2D */ "./sources/pcvizUtils/Insider2D.js");
/* harmony import */ var _UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./UpdateVisibilityVisitor */ "./sources/pcvizUtils/UpdateVisibilityVisitor.js");
/* harmony import */ var _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PointVisibilityVisitor */ "./sources/pcvizUtils/PointVisibilityVisitor.js");






class HighlightScans {
    constructor() {
        this._updateVisibilityVisitor = new _UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["default"]();
        this._updateVisibilityVisitor.setTemporalInsiderList( [ new _Insider2D__WEBPACK_IMPORTED_MODULE_2__["default"]( undefined, undefined, undefined, undefined, _Insider2D__WEBPACK_IMPORTED_MODULE_2__["INSIDER_TYPES"].HIGHLIGHT ) ] );
        this._pointVisibilityVisitor = new _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__["default"]();
        this._pointVisibilityVisitor.setMode( _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__["POINT_MODES"].SELECTED );
        this._pointVisibilityVisitor.setVisibilityValue( _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__["POINT_VISIBILITY_FLAGS"].VISIBLE );

        // Get selection object before disableSelect
        const selectionObjectController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'SelectionObject' );
        this._selectionObject = selectionObjectController.getSelectionObject();
        selectionObjectController.setSelectionObject();
    }


    getScanSelectedOnToc( scans ) {
        let scanSelected = {};

        if (
            this._selectionObject &&
            this._selectionObject.getLayer() &&
            this._selectionObject.getLayer().isStation
        ) {
            const scanChild = this.findChildScanLayerGroup( this._selectionObject.getLayer() );
            scanSelected = scans.find( scan => scan.uuid === scanChild.getId() );
        }

        return scanSelected;
    }

    getPreviousScansSelected( scans ) {
        if ( !scans || !scans.length ) {
            return false;
        }
        return scans.filter( scan => scan.selected === true );
    }

    getStationIdFromSelection() {
        if ( !this._selectionObject || !this._selectionObject.getLayer() ) {
            return null;
        }

        const wksLayerGroup = this._selectionObject.getLayer();

        const selectedObjectId = ( wksLayerGroup.isStation && wksLayerGroup.isStation() ) ?
            wksLayerGroup.getId() :
            this.getParentStationId( wksLayerGroup );

        return selectedObjectId;
    }

    updateSelectionObject( selectionObject ) {
        this._selectionObject = selectionObject;
    }

    changeScanHighlighting( scans, isSelected ) {
        scans.forEach( scan => {
            this.changeScanHighlightingById( scan.uuid, ( isSelected !== undefined ? isSelected : scan.selected ) );
        } );
    }

    changeScanHighlightingById( scanId, isSelected ) {
        const workspaceDataCacheObj = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( scanId );
        const parentStation = workspaceDataCacheObj.getLayerGroupObj().getParentStation();
        const symbol = parentStation ? parentStation.getFeatureRenderer().getSymbol() : undefined;
        if ( symbol ) {
            symbol.setSelected( isSelected );
            symbol.updateColor();
        }

        const node = workspaceDataCacheObj.getOsgNodeObj();
        const plod = this.findPLODChild( node );

        if ( !plod ) {
            return;
        }

        if ( isSelected ) {
            plod.accept( this._updateVisibilityVisitor );
        } else {
            plod.accept( this._pointVisibilityVisitor );
        }
    }

    getParentStationId( layer ) {
        const parentStation = this.findParentStationLayerGroup( layer );

        if ( !parentStation ) {
            return null;
        }

        return parentStation.getId();
    }

    findChildScanLayerGroup( layerGroup ) {
        for ( const child of layerGroup.getChildren() ) {
            if ( layerGroup.getCategory() === 'Scan' ) {
                return layerGroup;
            }
            if ( child.getChildren ) {
                const scanChild = this.findChildScanLayerGroup( child );
                if ( scanChild ) {
                    return scanChild;
                }
            }
        }

        return undefined;
    }

    findParentStationLayerGroup( layerGroup ) {
        if ( layerGroup.getCategory && layerGroup.getCategory() === 'Station' ) {
            return layerGroup;
        }
        if ( layerGroup.getParent() ) {
            return this.findParentStationLayerGroup( layerGroup.getParent() );
        }

        return undefined;
    }

    findPLODChild( node ) {
        for ( const child of node.getChildren() ) {
            if ( child instanceof pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_1___default.a ) {
                return child;
            }
            const plod = this.findPLODChild( child );
            if ( plod ) {
                return plod;
            }
        }
        return undefined;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/ImageUtils.js":
/*!******************************************!*\
  !*** ./sources/pcvizUtils/ImageUtils.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ImageUtils; });
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js");
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js");






var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;


class ImageUtils {


    /**
     * Get the image name of the element, ignoring path and extensions.
     */
    static getImageName( element ) {
        var value = element.getAttributeByName( 'file_name' );

        if ( !value ) {
            return '';
        }

        return ImageUtils.getFileNameFromPath( value, element.getLayerCategory() );
    }

    static getFileNameFromPath( path, category ) {
        var name = path.substring( path.lastIndexOf( '/' ) + 1 );
        var extensionIndex = -1;
        if ( category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_2__["default"].Categories.PANORAMA )
            extensionIndex = name.lastIndexOf( '.panorama' );
        if ( category === pcvizGIS_VectorLayerUtils__WEBPACK_IMPORTED_MODULE_2__["default"].Categories.PLANAR_IMAGE )
            extensionIndex = name.lastIndexOf( '.planarimage' );
        if ( extensionIndex !== -1 )
            name = name.substring( 0, extensionIndex );
        return name;
    }

    /**
     * Gets the image object from a file and computes its pixel size.
     * @param {File} file The file to extract the image object
     */
    static getImageInfo( file ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_0___default.a.defer();

        var url = URL.createObjectURL( file );
        var img = new Image();

        img.onload = function () {
            img.pixels = img.width * img.height;
            defer.resolve( img );
        };

        img.src = url;

        return defer.promise;
    }

    /**
     * Computes the rotation quaternion of the planar image based on the omega, phi and kappa angles.
     * @method
     * @param  {float} omega Omega angle in radians.
     * @param  {float} phi   Phi angle in radians.
     * @param  {float} kappa Kappa angle in radians
     */
    static setRotationFromOmegaPhiKapa( omega, phi, kappa, quat ) {
        osg.quat.identity( quat );
        osg.quat.rotateZ( quat, quat, -kappa );
        osg.quat.rotateY( quat, quat, -phi );
        osg.quat.rotateX( quat, quat, -omega );
    }

    /**
     * Calculates rotation corresponding to the rotation described in an image feature
     * @param  {Feature} feature The feature to read the rotation from.
     * @param  {Quaternion} quaternion The quaternion which will contain the resulting rotation.
     */
    static setFeatureRotationInQuat( feature, quaternion ) {
        if ( feature.getAttributeByName( 'quatX' ) !== undefined && feature.getAttributeByName( 'quatX' ) !== null ) {
            const quat = osg.quat.fromValues64( feature.getAttributeByName( 'quatX' ), feature.getAttributeByName( 'quatY' ), feature.getAttributeByName( 'quatZ' ), feature.getAttributeByName( 'quatW' ) );

            // If the project feature provides the attribute 'coordinates_origin_offset' (on degrees) a rotation is applied over the z axis of the Quaternion
            const coordinatesOriginOffset = feature.getAttributeByName( 'coordinates_origin_offset' );
            if ( coordinatesOriginOffset ) {
                let rotZ = osg.quat.create();
                osg.quat.setAxisAngle( rotZ, [ 0, 0, 1 ], pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.degreesToRadians( coordinatesOriginOffset ) );
                osg.quat.multiply( quat, rotZ, quat );
            }

            osg.quat.copy( quaternion, quat );
        } else {
            this.setRotationFromFeatureData( feature, quaternion );
        }
    }

    /**
     * Calculates rotation corresponding to the rotation described in an image feature, when the feature contains fields with rotation angles
     * @param  {Feature} feature The feature to read the rotation from.
     * @param  {Quaternion} quaternion The quaternion which will contain the resulting rotation.
     */
    static setRotationFromFeatureData( feature, quaternion ) {
        this.setRotationFromOmegaPhiKapa( feature.getAttributeByName( 'w[rad]' ), feature.getAttributeByName( 'p[rad]' ), feature.getAttributeByName( 'k[rad]' ), quaternion );
    }

    /**
     * Calculates rotation corresponding to the rotation described in an image feature
     * @param  {Matrix} matrix The matrix which will contain the resulting rotation.
     * @param  {Feature} feature The feature to read the rotation from.
     */
    static setRotationFromImage( matrix, feature ) {

        var rotationQuat = osg.quat.create64();
        osg.quat.identity( rotationQuat );

        this.setFeatureRotationInQuat( feature, rotationQuat );

        osg.mat4.fromQuat( matrix, rotationQuat );
    }

    /**
     * Checks if a given 3D location is visible in a planar image. If visible, it returns a structure with image data and relative position of the 3D point
     * @param  {vec3D} worldPos The 3D location to check.
     * @param  {Feature} feature The image for which visibility must be checked.
     */
    static isPointVisibleInImage( worldPos, feature ) {

        var imgData = this.fromWorldToImage( worldPos, feature );

        if ( imgData.imgRelPosX < 0 || imgData.imgRelPosX > 1 || imgData.imgRelPosY < 0 || imgData.imgRelPosY > 1 || isNaN( imgData.imgRelPosX ) || isNaN( imgData.imgRelPosY ) )
            return undefined; // point is not visible

        return {
            id: feature.getId(),
            name: this.getImageName( feature ),
            imgRelPosX: imgData.imgRelPosX,
            imgRelPosY: imgData.imgRelPosY
        };
    }

    /**
     * Gets image size metadata
     * @param {Feature} feature The image for which metadata must be extracted
     */
    static getDataFromFeatureImage( feature ) {
        var fovX = feature.getAttributeByName( 'fovW' );
        var fovY = feature.getAttributeByName( 'fovH' );
        var width = feature.getAttributeByName( 'sensorWidth' );
        var height = feature.getAttributeByName( 'sensorHeight' );
        var princPtX = feature.getAttributeByName( 'principalPointX' );
        var princPtY = feature.getAttributeByName( 'principalPointY' );

        // normalized image frustum
        var halfWidth = Math.tan( fovX / 2 );
        var halfHeight = Math.tan( fovY / 2 );
        var xOffsetPercent = ( princPtX - ( width / 2.0 ) ) / width;
        var yOffsetPercent = ( princPtY - ( height / 2.0 ) ) / height;
        var offsetX = halfWidth * 2.0 * xOffsetPercent;
        var offsetY = halfHeight * 2.0 * yOffsetPercent;

        var distortionParams;
        var distortion = feature.getAttributeByName( 'k1' );
        if ( distortion !== undefined && distortion !== null ) {
            distortionParams = {
                K1: feature.getAttributeByName( 'k1' ),
                K2: feature.getAttributeByName( 'k2' ),
                K3: feature.getAttributeByName( 'k3' ),
                P1: feature.getAttributeByName( 'p1' ),
                P2: feature.getAttributeByName( 'p2' )
            };
            if ( distortionParams.P1 === null )
                distortionParams.P1 = 0;
            if ( distortionParams.P2 === null )
                distortionParams.P2 = 0;
        }

        return {
            'halfWidth': halfWidth,
            'halfHeight': halfHeight,
            'offsetX': offsetX,
            'offsetY': offsetY,
            'distortionParams': distortionParams
        };
    }

    /**
     * Calculates the relative position of a 3D point in the local coordinate system of a planar image
     * @param  {vec3D} worldPos The 3D location to convert.
     * @param  {Feature} feature The image where the relative position must be found.
     */
    static fromWorldToImage( worldPos, feature ) {

        var imagePos = [ feature.getGeometry().getX(), feature.getGeometry().getY(), feature.getGeometry().getZ() ];
        var mat = osg.mat4.create64();
        this.setRotationFromImage( mat, feature );
        var invmat = osg.mat4.create64();
        osg.mat4.invert( invmat, mat );

        var ctrlPtLocal = osg.vec4.fromValues32( worldPos[ 0 ] - imagePos[ 0 ], worldPos[ 1 ] - imagePos[ 1 ], worldPos[ 2 ] - imagePos[ 2 ], 1.0 );
        var ctrlPtRelative = osg.vec4.create32();
        osg.vec4.transformMat4( ctrlPtRelative, ctrlPtLocal, invmat );

        var imageData = this.getDataFromFeatureImage( feature );

        // normalized ctrl pt coordinates
        var imgPtX = -ctrlPtRelative[ 0 ] / ctrlPtRelative[ 2 ];
        var imgPtY = -ctrlPtRelative[ 1 ] / ctrlPtRelative[ 2 ];

        if ( imageData.distortionParams ) {
            var distorted = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.distortPoint( [ imgPtX, imgPtY, 1.0 ], imageData.distortionParams );
            imgPtX = distorted[ 0 ];
            imgPtY = distorted[ 1 ];
        }

        // normalized coordinates of point on image
        var imgRelPosX = ( imgPtX - ( -imageData.halfWidth - imageData.offsetX ) ) / ( 2 * imageData.halfWidth );
        var imgRelPosY = ( imgPtY - ( -imageData.halfHeight + imageData.offsetY ) ) / ( 2 * imageData.halfHeight );

        return {
            imgRelPosX: imgRelPosX,
            imgRelPosY: imgRelPosY
        };
    }

}


/***/ }),

/***/ "./sources/pcvizUtils/Insider2D.js":
/*!*****************************************!*\
  !*** ./sources/pcvizUtils/Insider2D.js ***!
  \*****************************************/
/*! exports provided: INSIDER_TYPES, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INSIDER_TYPES", function() { return INSIDER_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Insider2D; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);


var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

const INSIDER_TYPES = {
    ADD: 'Add',
    SUBSTRACT: 'Substract',
    INTERSECT: 'Intersect',
    SELECT_ALL: 'SelectAll',
    INVERT: 'Invert', // Special case, no isInside function will be used for this type
    HIGHLIGHT: 'Highlight' // Special one, just for highlighting scans on 3D View
};

class Insider2D {
    constructor( vertex, nearPoints, farPoints, transformMatrix, type, layersMap ) {
        this._vertex = vertex; // Counterclokwise order
        this._nearPoints = nearPoints;
        this._farPoints = farPoints;
        this._transformMatrix = transformMatrix;
        this._type = type;
        this._boundingBox = this.getBoundingBox();
        this._layersMap = layersMap;

        // An Insider is valid if its affect to some point in order to avoid storing 'void' selections, excepts Intersect that should be stored always. 
        // This value is setted on isInside function if sometimes is true.
        this._valid = false;
    }

    validateInsider() {
        this._valid = true;
    }

    setInsiderValidation() {
        this._valid = !this._valid;
    }

    isValid() {
        return this._valid;
    }

    setLayersMap( layersMap ) {
        this._layersMap = layersMap;
    }

    getVertexes() {
        return this._vertex;
    }

    getLayersMap() {
        return this._layersMap;
    }

    getType() {
        return this._type;
    }

    isInside( point, parentID ) {
        if ( this._type === INSIDER_TYPES.SELECT_ALL || this._type === INSIDER_TYPES.HIGHLIGHT ) {
            this._valid = true;
            return true;
        }

        if ( this._type === INSIDER_TYPES.INTERSECT && !this.affectsLayer( parentID ) ) {
            this._valid = true;
            return false;
        }

        const pointProject = this.projectPointToPlane( point, parentID );

        let x = pointProject[ 0 ],
            y = pointProject[ 1 ];
        let inside = false;

        if ( pointProject[ 2 ] > 1.0 ) { // Avoid points outside the view scope
            return inside;
        }
        for ( let i = 0, j = this._vertex.length - 1; i < this._vertex.length; j = i++ ) {

            let xi = this._vertex[ i ][ 0 ],
                yi = this._vertex[ i ][ 1 ];
            let xj = this._vertex[ j ][ 0 ],
                yj = this._vertex[ j ][ 1 ];

            let hasIntersect = ( ( yi > y ) !== ( yj > y ) ) &&
                ( x < ( xj - xi ) * ( y - yi ) / ( yj - yi ) + xi );
            if ( hasIntersect ) {
                inside = !inside;
            }
        }

        if ( this._type === INSIDER_TYPES.INTERSECT || inside ) { // We want to know if a insider detects a point inside at least one time, intersect insiders are an exception.
            this._valid = true;
        }

        return inside;
    }

    projectPointToPlane( point, parentID ) {
        let mt = osg.mat4.create();
        osg.mat4.multiply( mt, mt, this._transformMatrix );
        if ( parentID && this._layersMap.get( parentID ) ) {
            osg.mat4.multiply( mt, mt, this._layersMap.get( parentID ).accum );
        }

        let pt = osg.vec3.create();

        osg.vec3.transformMat4( pt, point, mt );
        return pt;
    }

    // 3D colliding
    getBoundingBox() {
        if ( !this._vertex || this._vertex.length <= 0 ) {
            return;
        }
        // First value initialization
        let [ minx, miny, minz ] = [ Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE ];
        let [ maxx, maxy, maxz ] = [ -Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ];

        for ( let vertex of [ ...this._nearPoints, ...this._farPoints ] ) {
            minx = Math.min( vertex[ 0 ], minx );
            miny = Math.min( vertex[ 1 ], miny );
            minz = Math.min( vertex[ 2 ], minz );
            maxx = Math.max( vertex[ 0 ], maxx );
            maxy = Math.max( vertex[ 1 ], maxy );
            maxz = Math.max( vertex[ 2 ], maxz );
        }

        const min = osg.vec3.fromValues( minx, miny, minz );
        const max = osg.vec3.fromValues( maxx, maxy, maxz );

        return { min: min, max: max };
    }

    affectsLayer( parentID ) {
        return this._layersMap.get( parentID );
    }

    collideBoundingBox( bbCorners, parentID ) {

        // Highlights insiders are a kind of SelectAll insiders that doesn't have scans affected list (_layerMap).
        // Both Insiders affects all the points of a PointCloud, but the main difference between these is that SelectAll 
        // should affect only the selected scans affect & Highlight affects to all scans, that why Highlight doesn't have scans affected list.s
        if ( this._type === INSIDER_TYPES.HIGHLIGHT ) {
            return true;
        }

        if ( parentID && !this.affectsLayer( parentID ) ) { // Case: if is from a layer that the user dosen't want to be affected by the selection
            return false;
        }

        if ( this._type === INSIDER_TYPES.SELECT_ALL || this._type === INSIDER_TYPES.INVERT ) {
            return true;
        }

        const min = osg.vec3.create();
        const max = osg.vec3.create();

        osg.vec3.copy( min, osg.vec3.INFINITY );
        osg.vec3.copy( max, osg.vec3.NEGATIVE_INFINITY );

        let mt = osg.mat4.create();
        if ( parentID && this._layersMap.get( parentID ) ) {
            osg.mat4.copy( mt, this._layersMap.get( parentID ).accum );
        }

        let cornerTrans = osg.vec3.create();
        for ( let corner of bbCorners ) {
            osg.vec3.transformMat4( cornerTrans, corner, mt );

            max[ 0 ] = Math.max( cornerTrans[ 0 ], max[ 0 ] );
            max[ 1 ] = Math.max( cornerTrans[ 1 ], max[ 1 ] );
            max[ 2 ] = Math.max( cornerTrans[ 2 ], max[ 2 ] );

            min[ 0 ] = Math.min( cornerTrans[ 0 ], min[ 0 ] );
            min[ 1 ] = Math.min( cornerTrans[ 1 ], min[ 1 ] );
            min[ 2 ] = Math.min( cornerTrans[ 2 ], min[ 2 ] );
        }

        // Insider max & min corners
        const iMin = this._boundingBox.min;
        const iMax = this._boundingBox.max;

        return ( iMin[ 0 ] <= max[ 0 ] && iMax[ 0 ] >= min[ 0 ] ) && ( iMin[ 1 ] <= max[ 1 ] && iMax[ 1 ] >= min[ 1 ] ) && ( iMin[ 2 ] <= max[ 2 ] && iMax[ 2 ] >= min[ 2 ] );
    }

    getProcessObject() {
        const layersKeyArray = Array.from( this._layersMap.keys() );
        const scansAffected = [];
        for ( let layerID of layersKeyArray ) {
            const layerObject = this._layersMap.get( layerID );
            if ( layerObject.isScan ) {
                scansAffected.push( { idScan: layerID, transform: Object.values( layerObject.origMat ) } );
            }
        }

        if ( this._type === INSIDER_TYPES.SELECT_ALL || this._type === INSIDER_TYPES.INVERT ) {
            return { type: this._type, scansAffected: scansAffected }; // Special case for select all & invert insider's type
        }

        //Add scene center to near and far points
        const center = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' ).getViewer().getCenter();

        const near = [];
        const far = [];
        for ( let i = 0; i < this._vertex.length; i++ ) {
            const nearPoint = osg.vec3.fromValues( this._nearPoints[ i ][ 0 ], this._nearPoints[ i ][ 1 ], this._nearPoints[ i ][ 2 ] );
            const farPoint = osg.vec3.fromValues( this._farPoints[ i ][ 0 ], this._farPoints[ i ][ 1 ], this._farPoints[ i ][ 2 ] );

            osg.vec3.add( nearPoint, nearPoint, center );
            osg.vec3.add( farPoint, farPoint, center );

            near.push( Object.values( nearPoint ) );
            far.push( Object.values( farPoint ) );
        }

        return { type: this._type, nearPoints: near, farPoints: far, scansAffected: scansAffected };
    }

    getJSON() {
        const layersKeyArray = Array.from( this._layersMap.keys() );
        const affectedLayers = [];
        for ( let layerID of layersKeyArray ) {
            const lObject = { key: layerID, value: this._layersMap.get( layerID ) };
            affectedLayers.push( lObject );
        }
        if ( this._type === INSIDER_TYPES.SELECT_ALL || this._type === INSIDER_TYPES.INVERT ) {
            return { type: this._type, affectedLayers: affectedLayers }; // Special case for select all & invert insider's type
        }
        const json = { vertex: this._vertex, nearPoints: this._nearPoints, farPoints: this._farPoints, matrix: this._transformMatrix, type: this._type, affectedLayers: affectedLayers };

        return json;
    }

    static isSelectedByInsider( point, parentId, insider, isSelected ) {
        let result = isSelected;
        switch ( insider.getType() ) {
        case INSIDER_TYPES.HIGHLIGHT:
        case INSIDER_TYPES.SELECT_ALL:
        case INSIDER_TYPES.ADD:
            result = result || insider.isInside( point, parentId );
            break;
        case INSIDER_TYPES.SUBSTRACT:
            result = result && !( insider.isInside( point, parentId ) );
            break;
        case INSIDER_TYPES.INTERSECT:
            result = result && insider.isInside( point, parentId );
            break;
        case INSIDER_TYPES.INVERT:
            result = !result;
            break;
        }
        return result;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/LayerGroupSelectionObject.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizUtils/LayerGroupSelectionObject.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );

/**
 * Defines a container to access and store the properties of the selected LayerGroup.
 * @class
 * @memberof pcvizUtils
 * @extends pcvizUtils.SelectionObject
 */
var LayerGroupSelectionObject = function () {
    SelectionObject.call( this );

    this._selectionType = SelectionObject.LayerGroup;
};

LayerGroupSelectionObject.prototype = osg.objectInherit( SelectionObject.prototype, {

    initializePropertySet: function () {
        var self = this;

        this.clearProperties();

        this.addPropertyField( {
            id: 'layer',
            label: 'LAYER_GROUP_SELECTION_OBJECT.LAYER',
            type: 'Object',
            get: function () {
                return self.getLayer();
            }
        } );
    },

    getFeature: function () {
        return undefined;
    }

} );

module.exports = LayerGroupSelectionObject;


/***/ }),

/***/ "./sources/pcvizUtils/MagnetAPI.js":
/*!*****************************************!*\
  !*** ./sources/pcvizUtils/MagnetAPI.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

/**
 *  MagnetAPI class to manage all the properties about magnet connection
 *  @class
 *  @memberof pcvizUtils
 */
var MagnetAPI = {

    API: undefined,
    connectingFromMagnet: false,

    isConnectingFromMagnet: function () {
        return this.connectingFromMagnet;
    },

    setConnectingFromMagnet: function ( connecting ) {
        this.connectingFromMagnet = connecting;
    },

    setAPI: function ( api ) {
        this.API = api;
    },

    getAPI: function () {
        return this.API;
    },

    getAuthorizationToken: function () {
        return this._token;
    },

    setAuthorizationToken: function ( token ) {
        this._token = token;
        this.decodeUserFromToken();
    },

    getAuthorizationType: function () {
        return this._tokenType;
    },

    setAuthorizationType: function ( tokenType ) {
        if ( !tokenType || tokenType.length <= 0 ) {
            this._tokenType = 'JWT ';
            return;
        }
        this._tokenType = tokenType;
    },

    getAuthorizationHeader: function () {
        return this._tokenType + this._token;
    },

    getUserId: function () {
        return this._userId;
    },

    decodeUserFromToken: function () {
        if ( this._token !== undefined ) {
            var res = this._token.split( '.' );
            if ( res.length > 1 ) {
                var uid;
                uid = JSON.parse( window.atob( res[ 1 ] ) )[ 'user_id' ];
                this._userId = uid;
            }
        }
    },

    setAnonymous: function ( value ) {
        this._isAnonymous = value;
    },

    isAnonymous: function () {
        return ( this._isAnonymous || ( window.localStorage[ 'ngStorage-currentUser' ] && JSON.parse( window.localStorage[ 'ngStorage-currentUser' ] ).username === 'anonymous' ) );
    },

    setVerity: function ( isVerity ) {
        this._isVerity = isVerity;
        Utils.setPageSize( isVerity ? Utils.VERITY_PAGE_SIZE : Utils.DEFAULT_PAGE_SIZE );
    },

    isVerity: function () {
        return this._isVerity;
    },

    isSite: function () {
        return this.API && this.API.name.includes( 'site' );
    },

    isDevelopment: function () {
        return this.API && this.API.name.includes( 'development' );
    },

    isTechnicalPreview: function () {
        return this._enabledTechPreview;
    },

    setTechnicalPreview: function ( enabled ) {
        this._enabledTechPreview = enabled;
    }
};

module.exports = MagnetAPI;


/***/ }),

/***/ "./sources/pcvizUtils/MathUtils.js":
/*!*****************************************!*\
  !*** ./sources/pcvizUtils/MathUtils.js ***!
  \*****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);

const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

const MathUtils = {};

MathUtils.vec2 = {
    create: osg.vec2.create,
    create32: osg.vec2.create32,
    create64: osg.vec2.create64,
    fromValues: osg.vec2.fromValues,
    fromValues32: osg.vec2.fromValues32,
    fromValues64: osg.vec2.fromValues64,
    copy: osg.vec2.copy
};

MathUtils.vec3 = {
    create: osg.vec3.create,
    create32: osg.vec3.create32,
    create64: osg.vec3.create64,
    fromValues: osg.vec3.fromValues,
    fromValues32: osg.vec3.fromValues32,
    fromValues64: osg.vec3.fromValues64,
    copy: osg.vec3.copy,
    distance: osg.vec3.distance,
    transformMat4: osg.vec3.transformMat4,
    negate: osg.vec3.negate,
    angle: osg.vec3.angle
};

MathUtils.vec4 = {
    create: osg.vec4.create,
    create32: osg.vec4.create32,
    create64: osg.vec4.create64,
    fromValues: osg.vec4.fromValues,
    fromValues32: osg.vec4.fromValues32,
    fromValues64: osg.vec4.fromValues64,
    copy: osg.vec4.copy
};

MathUtils.mat4 = {
    create: osg.mat4.create,
    create32: osg.mat4.create32,
    create64: osg.mat4.create64,
    fromValues: osg.mat4.fromValues,
    copy: osg.mat4.copy,
    transpose: osg.mat4.transpose
};

/* harmony default export */ __webpack_exports__["default"] = (MathUtils);


/***/ }),

/***/ "./sources/pcvizUtils/PointCloudSelectionObject.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizUtils/PointCloudSelectionObject.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );

/**
 * Defines a container to access and store the properties of the selected PointCloud.
 * @class
 * @memberof pcvizUtils
 * @extends pcvizUtils.SelectionObject
 */
var PointCloudSelectionObject = function () {
    SelectionObject.call( this );

    this._selectionType = SelectionObject.PointCloud;
};

PointCloudSelectionObject.prototype = osg.objectInherit( SelectionObject.prototype, {

    /**
     * A helper function to set a hit in the selection object.
     * @method
     * @memberof pcvizUtils.PointCloudSelectionObject
     * @param {Object} hit The hit object.
     */
    setHit: function ( hit ) {
        this.setObject( 'hit', hit );
    },

    /**
     * A helper function to retrieve the hit from the selection object.
     * @method
     * @memberof pcvizUtils.PointCloudSelectionObject
     * @return {Object} The hit object.
     */
    getHit: function () {
        return this.getObject( 'hit' );
    },

    initializePropertySet: function () {
        var self = this;

        this.clearProperties();

        var infoGroup = this.addPropertyField( {
            id: 'infoGroup',
            label: 'POINTCLOUD_SELECTION_OBJECT.INFORMATION',
            type: 'GroupField',
            visible: function () {
                if ( !self.getLayer() )
                    return false;
                if ( self.getUserData() !== undefined ) {
                    if ( window.Object.keys( self.getUserData() ).length > 0 )
                        return true;
                }
                return false;
            }
        } );

        this.addPropertyField( {
            id: 'layer',
            label: 'POINTCLOUD_SELECTION_OBJECT.LAYER',
            type: 'Object',
            get: function () {
                return self.getLayer();
            }
        } );

        this.addPropertyField( {
            id: 'position',
            label: 'POINTCLOUD_SELECTION_OBJECT.POSITION',
            type: 'Point',
            editable: function () {
                return false;
            },
            get: ( function () {
                var transformedPoint = [];
                return function () {

                    if ( self.getUserData() !== undefined && self.getUserData().hasOwnProperty( 'position' ) ) {

                        var layer = self.getLayer();
                        var project = Registry.getController( 'Application' ).getApplication().getProject();
                        if ( !layer.getProjection() || !project.getProjection() )
                            return self.getUserData().position;

                        // Defines layer's projection and project's projection
                        CRSUtils.defProj4( layer.getProjection(), layer.getProj4() );
                        CRSUtils.defProj4( project.getProjection(), project.getProj4() );

                        transformedPoint[ 0 ] = self.getUserData().position[ 0 ];
                        transformedPoint[ 1 ] = self.getUserData().position[ 1 ];
                        transformedPoint[ 2 ] = self.getUserData().position[ 2 ];

                        // Convert from layer's projection to project's projection
                        try {
                            CRSUtils.transform( layer.getProjection(), project.getProjection(), transformedPoint, true, project.getGeoid() );
                        } catch ( err ) {
                            // To manage the error in the ui
                            transformedPoint[ 4 ] = err;
                        }

                        return transformedPoint;
                    }
                };
            } )(),
            group: infoGroup
        } );

        this.addPropertyField( {
            id: 'color',
            label: 'POINTCLOUD_SELECTION_OBJECT.COLOR',
            type: 'ColorField',
            editable: function () {
                return false;
            },
            get: function () {
                if ( self.getUserData() !== undefined && self.getUserData().hasOwnProperty( 'color' ) )
                    return self.getUserData().color;
            },
            group: infoGroup
        } );

        this.addPropertyField( {
            id: 'intensity',
            label: 'POINTCLOUD_SELECTION_OBJECT.INTENSITY',
            type: 'IntegerField',
            editable: function () {
                return false;
            },
            get: function () {
                if ( self.getUserData() !== undefined && self.getUserData().hasOwnProperty( 'intensity' ) )
                    return self.getUserData().intensity;
            },
            group: infoGroup
        } );

        this.addPropertyField( {
            id: 'classification',
            label: 'POINTCLOUD_SELECTION_OBJECT.CLASSIFICATION',
            type: 'TextField',
            editable: function () {
                return false;
            },
            get: function () {
                if ( self.getUserData() !== undefined && self.getUserData().hasOwnProperty( 'classification' ) ) {
                    return self.getUserData().classification;
                }
            },
            translate: true,
            group: infoGroup
        } );
    }

} );

module.exports = PointCloudSelectionObject;


/***/ }),

/***/ "./sources/pcvizUtils/PointCollectorIntersector.js":
/*!*********************************************************!*\
  !*** ./sources/pcvizUtils/PointCollectorIntersector.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var PointCloudPLOD = __webpack_require__( /*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js" );
const ShaderUtils = __webpack_require__( /*! pcvizUtils/ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js" ).default;

var transformVec4PostMult = function ( out, p, m ) {
    var x = p[ 0 ];
    var y = p[ 1 ];
    var z = p[ 2 ];
    var w = p[ 3 ];

    out[ 0 ] = m[ 0 ] * x + m[ 1 ] * y + m[ 2 ] * z + m[ 3 ] * w;
    out[ 1 ] = m[ 4 ] * x + m[ 5 ] * y + m[ 6 ] * z + m[ 7 ] * w;
    out[ 2 ] = m[ 8 ] * x + m[ 9 ] * y + m[ 10 ] * z + m[ 11 ] * w;
    out[ 3 ] = m[ 12 ] * x + m[ 13 ] * y + m[ 14 ] * z + m[ 15 ] * w;
};

/**
 * Class to get the points contained in a polytope path
 *  @class
 *  @memberof pcvizUtils
 */
var PointCollectorIntersector = function () {

    // Here we store the result
    this._collectedPoints = [];
    this._collectedPointsColors = [];
    this._localUp = osg.vec3.fromValues( 0, 0, 1.0 );
    this._localRight = osg.vec3.fromValues( 1.0, 0, 0 );

    this._maxZ = -Number.MAX_VALUE;
    this._minZ = Number.MAX_VALUE;

    this.COLOR_MODE_NONE = 0;
    this.COLOR_MODE_RGB = 1;
    this.COLOR_MODE_GRAYSCALE = 2;
    this.COLOR_MODE_ELEVATION = 3;
    this.COLOR_MODE_FIXEDCOLOR = 4;
    this.COLOR_MODE_INTENSITY = 5;
    this.COLOR_MODE_CLASSIFIED = 6;
    this.COLOR_MODE_ELEVATION_HEATMAP = 7;

    // avoid 'never used' errors
    var useFunctions = this;
    useFunctions.transformVec4PostMult = transformVec4PostMult;
};

PointCollectorIntersector.prototype = {

    setPath: function ( /*start, end*/) {},

    setWidth: function ( /*width*/) {},

    enter: function ( node ) {
        return ( this.intersects( node.getBound() ) );
    },

    getWidth: function () {
        return this._width;
    },

    getMaxZ: function () {
        return this._maxZ;
    },

    getMinZ: function () {
        return this._minZ;
    },

    reset: function () {},

    getCollectedPoints: function () {
        return this._collectedPoints;
    },


    getCollectedPointsColors: function () {
        return this._collectedPointsColors;
    },

    getCollectedPoints3D: ( function () {
        return function () {
            return this._collectedPoints;
        };
    } )(),

    findParentPointCloud: function ( nodePath ) {
        for ( var i = nodePath.length - 1; i >= 0; i-- ) {
            if ( nodePath[ i ] instanceof PointCloudPLOD ) {
                return nodePath[ i ];
            }
        }
        return undefined;
    },

    findDrawingRuleNode: function ( nodePath ) {
        for ( var i = nodePath.length - 1; i >= 0; i-- ) {
            if ( nodePath[ i ].DrawingRule !== undefined ) {
                return nodePath[ i ];
            }
        }
        return undefined;
    },

    clamp: function ( x ) {
        return ( ( x < 0.0 ) ? 0.0 : ( ( x > 1.0 ) ? 1.0 : x ) );
    },

    getColorInfo: function ( iv, node, pLODNode ) {
        var colorMode = this.COLOR_MODE_NONE;
        var colorBuffer;

        if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_RGB' ) {
            colorMode = this.COLOR_MODE_RGB;
            colorBuffer = node.getAttributes().Color;
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION' ) {
            colorMode = this.COLOR_MODE_ELEVATION;
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_ELEVATION_HEATMAP' ) {
            colorMode = this.COLOR_MODE_ELEVATION_HEATMAP;
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_GRAYSCALE' ) {
            colorMode = this.COLOR_MODE_GRAYSCALE;
            colorBuffer = node.getAttributes().Intensity;
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_COLOR_INTENS' ) {
            colorMode = this.COLOR_MODE_INTENSITY;
            colorBuffer = node.getAttributes().Intensity;
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_FIXED_COLOR' ) {
            colorMode = this.COLOR_MODE_FIXEDCOLOR; // drawingRuleAttribute._fixedColor
        } else if ( pLODNode.DrawingRule === 'POINTCLOUD_LAYER_PROPERTIES.DRAWING_RULE_CLASSIFIED' ) {
            colorMode = this.COLOR_MODE_CLASSIFIED;
            colorBuffer = node.getAttributes().Classification;
        }
        return {
            colorMode: colorMode,
            colorBuffer: colorBuffer
        };
    },

    getColorFromRamp: function ( f ) {
        f *= 0.7;
        // color ramp calculation, adapted from elevation shader
        var p = [];
        var c = f + 1.0;
        c = c - Math.floor( c );
        p[ 0 ] = Math.abs( c * 6.0 - 3.0 );
        c = f + 2.0 / 3.0;
        c = c - Math.floor( c );
        p[ 1 ] = Math.abs( c * 6.0 - 3.0 );
        c = f + 1.0 / 3.0;
        c = c - Math.floor( c );
        p[ 2 ] = Math.abs( c * 6.0 - 3.0 );

        p[ 0 ] = Math.floor( 255 * 0.9 * ( 0.1 + 0.9 * this.clamp( p[ 0 ] - 1.0 ) ) );
        p[ 1 ] = Math.floor( 255 * 0.9 * ( 0.1 + 0.9 * this.clamp( p[ 1 ] - 1.0 ) ) );
        p[ 2 ] = Math.floor( 255 * 0.9 * ( 0.1 + 0.9 * this.clamp( p[ 2 ] - 1.0 ) ) );

        return p;
    },

    calculateColorFromAttribs: function ( pLODNode, colorMode, bufElements, k, vertex ) {
        const z = vertex[ 2 ];
        var color = osg.vec3.create32();
        switch ( colorMode ) {

        case this.COLOR_MODE_RGB:
            osg.vec3.set( color, bufElements[ k ], bufElements[ k + 1 ], bufElements[ k + 2 ] );
            break;

        case this.COLOR_MODE_GRAYSCALE:
            var gray = Math.floor( 255 * ( bufElements[ k / 3 ] - pLODNode.MinIntensity ) / ( pLODNode.MaxIntensity - pLODNode.MinIntensity ) );
            osg.vec3.set( color, gray, gray, gray );
            break;

        case this.COLOR_MODE_INTENSITY:
            var intens = ( bufElements[ k / 3 ] - pLODNode.MinIntensity ) / ( pLODNode.MaxIntensity - pLODNode.MinIntensity );
            var pIC = this.getColorFromRamp( this.clamp( 1.0 - intens ) );
            osg.vec3.set( color, pIC[ 0 ], pIC[ 1 ], pIC[ 2 ] );
            break;

        case this.COLOR_MODE_ELEVATION:
            var height = pLODNode.drawingRuleAttribute._dataCenter[ 2 ] + z;
            var f = ( height - pLODNode.MinZ ) / ( pLODNode.MaxZ - pLODNode.MinZ );
            f = ( pLODNode.drawingRuleAttribute._repeatRange ) ? 1.0 - ( f - Math.floor( f ) ) : 1.0 - this.clamp( f );
            var p = this.getColorFromRamp( f );
            osg.vec3.set( color, p[ 0 ], p[ 1 ], p[ 2 ] );
            break;

        case this.COLOR_MODE_FIXEDCOLOR:
            osg.vec3.set( color,
                Math.floor( 255 * pLODNode.drawingRuleAttribute._fixedColor[ 0 ] ),
                Math.floor( 255 * pLODNode.drawingRuleAttribute._fixedColor[ 1 ] ),
                Math.floor( 255 * pLODNode.drawingRuleAttribute._fixedColor[ 2 ] ) );
            break;

        case this.COLOR_MODE_CLASSIFIED:
            var classif = bufElements[ k / 3 ] % 16;
            if ( pLODNode.drawingRuleAttribute._classificationArray[ classif ] === 0 ) // invisible class
                return false;

            osg.vec3.set( color,
                Math.floor( 255 * pLODNode.drawingRuleAttribute._classificationColorArray[ classif * 4 + 0 ] ),
                Math.floor( 255 * pLODNode.drawingRuleAttribute._classificationColorArray[ classif * 4 + 1 ] ),
                Math.floor( 255 * pLODNode.drawingRuleAttribute._classificationColorArray[ classif * 4 + 2 ] ) );
            break;
        case this.COLOR_MODE_ELEVATION_HEATMAP:
            const drawingRuleAttr = pLODNode.drawingRuleAttribute;
            const x1 = drawingRuleAttr._dataCenter[ 0 ] + vertex[ 0 ];
            const y1 = drawingRuleAttr._dataCenter[ 1 ] + vertex[ 1 ];
            const z1 = drawingRuleAttr._dataCenter[ 2 ] + z;
            const dataMT = drawingRuleAttr._dataMT;
            const w = dataMT[ 3 ] * x1 + dataMT[ 7 ] * y1 + dataMT[ 11 ] * z1 + dataMT[ 15 ];
            // If there is a custom planeNormal, we should ignore refElevation (or set to 0). If not using custom planeNormal, we should ignore planeConstant (or set to 0).
            let xTransformed, yTransformed;
            const isCustomPlane = drawingRuleAttr.getPlaneNormal()[ 0 ] !== 0 && drawingRuleAttr.getPlaneNormal()[ 1 ] !== 0 && drawingRuleAttr.getPlaneNormal()[ 2 ] !== 1;
            if ( isCustomPlane ) {
                xTransformed = ( dataMT[ 0 ] * x1 + dataMT[ 4 ] * y1 + dataMT[ 8 ] * z1 + dataMT[ 12 ] ) / w;
                yTransformed = ( dataMT[ 1 ] * x1 + dataMT[ 5 ] * y1 + dataMT[ 9 ] * z1 + dataMT[ 13 ] ) / w;
            }
            const zTransformed = ( dataMT[ 2 ] * x1 + dataMT[ 6 ] * y1 + dataMT[ 10 ] * z1 + dataMT[ 14 ] ) / w;
            let heightTransformed = zTransformed;
            if ( isCustomPlane ) {
                heightTransformed = xTransformed * drawingRuleAttr.getPlaneNormal()[ 0 ] + yTransformed * drawingRuleAttr.getPlaneNormal()[ 1 ] + zTransformed * drawingRuleAttr.getPlaneNormal()[ 2 ] + drawingRuleAttr.getPlaneConstant();
            }
            if ( drawingRuleAttr._elevationPolicy === 0 ) {

                const intervalSize = ( pLODNode.MaxZ - pLODNode.MinZ );
                let value = ( heightTransformed - pLODNode.MinZ ) / intervalSize;
                value = 1.0 - this.clamp( value );

                const c = this.getColorFromRamp( value );
                osg.vec3.set( color, c[ 0 ], c[ 1 ], c[ 2 ] );
            } else {
                if ( drawingRuleAttr._hideAboveBelow ) {
                    const clamp = Math.min( Math.max( heightTransformed, drawingRuleAttr._refElevation - drawingRuleAttr._hideAboveBelowSize ), drawingRuleAttr._refElevation + drawingRuleAttr._hideAboveBelowSize );
                    if ( clamp !== heightTransformed )
                        return false;
                }
                const halfTolerance = drawingRuleAttr._tolerance;
                const doubleTolerance = drawingRuleAttr._tolerance * 2;
                let value = ( heightTransformed - drawingRuleAttr._refElevation + halfTolerance ) / doubleTolerance;
                value = !drawingRuleAttr._repeatIntervals ? this.clamp( value ) : ( value - Math.floor( value ) );
                if ( drawingRuleAttr._elevationPolicy === 2 ) {
                    const steps = Math.ceil( drawingRuleAttr._tolerance / drawingRuleAttr._incSize );
                    value = ShaderUtils._getSteppedValue( value, steps * 2, drawingRuleAttr._tolerance, drawingRuleAttr._incSize );
                }

                value = 1.0 - value;

                const c = this.getColorFromRamp( value );
                osg.vec3.set( color, c[ 0 ], c[ 1 ], c[ 2 ] );

                if ( !drawingRuleAttr._repeatIntervals ) {
                    if ( heightTransformed < ( drawingRuleAttr._refElevation - halfTolerance ) )
                        osg.vec3.set( color, 0, 0, 255 );
                    else if ( heightTransformed > ( drawingRuleAttr._refElevation + halfTolerance ) )
                        osg.vec3.set( color, 255, 0, 0 );
                }
            }


        }
        this._collectedPointsColors.push( color );
        return true;
    },

    // called by visitor
    setCurrentTransformation: function ( /*matrix*/) {
        // Transform the collector geometries to the current Model local coordinate frame
    },

    intersectsBoundingSphere: function ( /*position, radius*/) {
        console.error( 'PointCollectorIntersector.intersectsBoundingSphere NOT IMPLEMENTED' );
    },

    includesVertex: function ( /*vertex*/) {
        console.error( 'PointCollectorIntersector.includesVertex NOT IMPLEMENTED' );
    },

    // Intersection with node bounding sphere
    intersects: ( function () {
        var position = osg.vec3.create();
        return function ( bsphere ) {
            if ( !bsphere.valid() ) return false;
            var pos = bsphere.center();
            osg.vec3.copy( position, pos );

            return this.intersectsBoundingSphere( position, bsphere.radius() );
        };
    } )(),

    intersect: ( function () {
        var vertex = osg.vec3.create32();
        var vertexTr1 = osg.vec3.create32();
        var vertexTr2 = osg.vec3.create32();

        return function ( iv, node ) {

            // avoid lower LOD points, only use terminal nodes
            var parentLOD = node._parents[ 0 ];
            if ( !( parentLOD instanceof PointCloudPLOD ) ) {
                parentLOD = parentLOD._parents[ 0 ];
            }
            if ( parentLOD.children.length > 1 )
                return;
            if ( !( parentLOD instanceof PointCloudPLOD ) )
                return;

            const nodePath = iv.getNodePath();
            var mat = osg.computeLocalToWorld( nodePath );
            const indexPointcloudPLOD = nodePath.findIndex( ( n ) => n instanceof PointCloudPLOD );
            var mat2 = osg.computeLocalToWorld( nodePath.slice( indexPointcloudPLOD ) ); // does not include root transform

            var vertexBuffer = node.getAttributes().Vertex;
            var elements = vertexBuffer.getElements();

            var pLODNode = this.findDrawingRuleNode( nodePath );
            var colorInfo = this.getColorInfo( iv, node, pLODNode );
            var colorElements = colorInfo.colorBuffer ? colorInfo.colorBuffer.getElements() : 0;

            for ( var k = 0, l = elements.length; k < l; k += 3 ) {
                osg.vec3.set( vertex, elements[ k ], elements[ k + 1 ], elements[ k + 2 ] );
                osg.vec3.transformMat4( vertexTr1, vertex, mat );

                const visiblilityFlag = node.getAttributes().Visible.getElements()[ k / 3 ];

                if ( this.includesVertex( vertexTr1 ) && visiblilityFlag !== 2.0 ) {
                    this._maxZ = Math.max( this._maxZ, vertex[ 2 ] );
                    this._minZ = Math.min( this._minZ, vertex[ 2 ] );
                    osg.vec3.transformMat4( vertexTr2, vertex, mat2 );
                    if ( colorInfo.colorMode !== this.COLOR_MODE_NONE &&
                        this.calculateColorFromAttribs( pLODNode, colorInfo.colorMode, colorElements, k, vertexTr2 ) ) {
                        this._collectedPoints.push( osg.vec3.copy( osg.vec3.create64(), vertexTr1 ) );
                    }
                }
            }
        };
    } )(),
};

module.exports = PointCollectorIntersector;


/***/ }),

/***/ "./sources/pcvizUtils/PointCollectorLineIntersector.js":
/*!*************************************************************!*\
  !*** ./sources/pcvizUtils/PointCollectorLineIntersector.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var PointCollectorIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorIntersector */ "./sources/pcvizUtils/PointCollectorIntersector.js" );

/**
 * Class to get the points contained in a sphere
 *  @class
 *  @memberof pcvizUtils
 */
var PointCollectorLineIntersector = function () {

    PointCollectorIntersector.call( this );
};

PointCollectorLineIntersector.prototype = Utils.objectInherit( PointCollectorIntersector.prototype, {

    /**
     * In this case we have an array of line vertices
     * @method
     * @memberof pcvizUtils.PointCollectorIntersector
     */
    setPath: function ( worldPositionsArray ) {
        this._worldPositionsArray = worldPositionsArray;
    },

    setWidth: function ( width ) {
        this._radius = width;
    },

    reset: function () {
        this._collectedPoints = [];
        this._collectedPointsColors = [];
        this._worldPositionsArray = undefined;
        this._matrix = undefined;
        this._radius = undefined;
        this._maxZ = -Number.MAX_VALUE;
        this._minZ = Number.MAX_VALUE;
    },

    distanceTo3DLine: function ( vertex, positions ) {
        var dmin = Number.MAX_VALUE;

        for ( var iPt = 0, l = positions.length; iPt < l - 1; iPt++ ) {
            var x12 = osg.vec3.sub( osg.vec3.create(), positions[ iPt + 1 ], positions[ iPt ] );
            var x01 = osg.vec3.sub( osg.vec3.create(), vertex, positions[ iPt ] );
            var t = this.clamp( osg.vec3.dot( x01, x12 ) / osg.vec3.dot( x12, x12 ) );
            var pt = osg.vec3.add( osg.vec3.create(), positions[ iPt ], osg.vec3.scale( osg.vec3.create(), x12, t ) );
            var d = osg.vec3.distance( pt, vertex );
            if ( d < dmin )
                dmin = d;
        }
        return dmin;
    },

    intersectsBoundingSphere: function ( position, radius ) {
        if ( !this._matrix )
            return true;

        var transfPos = osg.vec3.create();
        osg.vec3.transformMat4( transfPos, position, this._matrix );

        var d = this.distanceTo3DLine( transfPos, this._worldPositionsArray );
        if ( d > radius + this._radius )
            return false;
        return true;
    },

    includesVertex: function ( vertex ) {
        var d = this.distanceTo3DLine( vertex, this._worldPositionsArray );
        return ( d < this._radius );
    },

    // called by visitor
    setCurrentTransformation: function ( matrix ) {
        this._matrix = matrix;
    }

} );

module.exports = PointCollectorLineIntersector;


/***/ }),

/***/ "./sources/pcvizUtils/PointCollectorPolytopeIntersector.js":
/*!*****************************************************************!*\
  !*** ./sources/pcvizUtils/PointCollectorPolytopeIntersector.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var PointCollectorIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorIntersector */ "./sources/pcvizUtils/PointCollectorIntersector.js" );

/**
 * Class to get the points contained in a polytope path
 *  @class
 *  @memberof pcvizUtils
 */
var PointCollectorPolytopeIntersector = function () {

    PointCollectorIntersector.call( this );

    this._polytope = [];
    this._lowLeftCorner = osg.vec3.create32();
    this._highLeftCorner = osg.vec3.create32();
    this._highRightCorner = osg.vec3.create32();
    this._lowRightCorner = osg.vec3.create32();
    this._clipMinZ = Number.MAX_VALUE;
    this._clipMaxZ = -Number.MAX_VALUE;
    this._iPolytope = [];
};

PointCollectorPolytopeIntersector.prototype = Utils.objectInherit( PointCollectorIntersector.prototype, {

    /**
     * Path should be an array of points
     * @method
     * @memberof pcvizUtils.PointCollectorIntersector
     */
    setPath: function ( start, end ) {
        this._start = start;
        this._end = end;
        // Update the polytope
        this.updatePolytope();
    },

    setPolytope: function ( polytope ) {
        this._polytope = polytope;
        this._iPolytope = [];
        this._polytopeModel.setPlanes( this._polytope );
    },


    setWidth: function ( width ) {
        this._width = width;
        this.updatePolytope();
    },

    updatePolytope: function () {
        // Calculate planes from the path;
        var first = this._start;
        var last = this._end;

        var dirVector = osg.vec3.sub( osg.vec3.create64(), last, first );
        dirVector[ 2 ] = 0;
        var planeNormal = osg.vec3.cross( osg.vec3.create64(), dirVector, this._localUp );
        osg.vec3.normalize( planeNormal, planeNormal );
        var normWidth = osg.vec3.create();
        osg.vec3.scale( normWidth, planeNormal, this._width );

        osg.vec3.sub( this._lowLeftCorner, first, normWidth );
        osg.vec3.sub( this._highLeftCorner, last, normWidth );
        osg.vec3.add( this._highRightCorner, last, normWidth );
        osg.vec3.add( this._lowRightCorner, first, normWidth );

        this._clipMinZ = Number.MAX_VALUE;
        this._clipMaxZ = -Number.MAX_VALUE;

        this.calculatePlanes();
    },

    calculatePlanes: function () {

        var p1 = this.calculatePlane( this._lowLeftCorner, this._highLeftCorner );
        var p2 = this.calculatePlane( this._highLeftCorner, this._highRightCorner );
        var p3 = this.calculatePlane( this._highRightCorner, this._lowRightCorner );
        var p4 = this.calculatePlane( this._lowRightCorner, this._lowLeftCorner );

        var polytope = [
            [ p1[ 0 ], p1[ 1 ], p1[ 2 ], p1[ 3 ] ],
            [ p2[ 0 ], p2[ 1 ], p2[ 2 ], p2[ 3 ] ],
            [ p3[ 0 ], p3[ 1 ], p3[ 2 ], p3[ 3 ] ],
            [ p4[ 0 ], p4[ 1 ], p4[ 2 ], p4[ 3 ] ]
        ];
        if ( this._clipMinZ < this._clipMaxZ ) {
            var p5 = this.calculateVerticalPlane( this._clipMinZ, true );
            var p6 = this.calculateVerticalPlane( this._clipMaxZ, false );
            polytope.push( [ p5[ 0 ], p5[ 1 ], p5[ 2 ], p5[ 3 ] ] );
            polytope.push( [ p6[ 0 ], p6[ 1 ], p6[ 2 ], p6[ 3 ] ] );
        }
        this.setPolytope( polytope );
    },

    setPolytopeCorners: function ( corners ) { // used by Box buffer to export points
        this._lowLeftCorner = corners.lowLeft;
        this._highLeftCorner = corners.highLeft;
        this._highRightCorner = corners.highRight;
        this._lowRightCorner = corners.lowRight;
        this._clipMinZ = corners.minZ;
        this._clipMaxZ = corners.maxZ;

        this.calculatePlanes();
    },

    getPolytopeCorners: function () {
        return {
            lowLeft: this._lowLeftCorner,
            highLeft: this._highLeftCorner,
            highRight: this._highRightCorner,
            lowRight: this._lowRightCorner
        };
    },

    calculatePlane: function ( first, last ) {
        var dirVector = osg.vec3.sub( osg.vec3.create(), last, first );
        dirVector[ 2 ] = 0;
        var planeNormal = osg.vec3.cross( osg.vec3.create(), dirVector, this._localUp );
        osg.vec3.normalize( planeNormal, planeNormal );
        var d = -planeNormal[ 0 ] * first[ 0 ] - planeNormal[ 1 ] * first[ 1 ] - planeNormal[ 2 ] * first[ 2 ];
        return osg.vec4.fromValues( planeNormal[ 0 ], planeNormal[ 1 ], planeNormal[ 2 ], d );
    },

    calculateVerticalPlane: function ( zValue, isMin ) {
        return osg.vec4.fromValues64( 0, 0, isMin ? 1.0 : -1.0, isMin ? -zValue : zValue );
    },

    reset: function () {
        this._collectedPoints = [];
        this._collectedPointsColors = [];
        this._start = osg.vec3.create64();
        this._end = osg.vec3.create64();
        this._depth = undefined;
        this._maxZ = -Number.MAX_VALUE;
        this._minZ = Number.MAX_VALUE;
        this._polytopeModel = new osg.Polytope();
    },

    projectToPlane: ( function () {
        var projPoint = osg.vec3.create();
        var diff = osg.vec3.create();

        return function ( plane, dirVec, offset, flipX ) {
            this._maxZ = -Number.MAX_VALUE;
            this._minZ = Number.MAX_VALUE;
            var projPositions = new Float32Array( this._collectedPoints.length * 2 );
            for ( var i = 0, j = this._collectedPoints.length; i < j; i++ ) {
                // First project points to the plane
                var d = osg.Plane.distanceToPlane( plane, this._collectedPoints[ i ] );

                var nd = osg.vec3.fromValues( plane[ 0 ] * d, plane[ 1 ] * d, plane[ 2 ] * d );
                osg.vec3.sub( projPoint, this._collectedPoints[ i ], nd );
                // Then calculate X distance in the projected plane
                osg.vec3.sub( diff, projPoint, this._lowLeftCorner );
                projPositions[ 2 * i ] = ( osg.vec3.dot( dirVec, diff ) + offset ) * flipX;
                var z = this._collectedPoints[ i ][ 2 ];
                projPositions[ 2 * i + 1 ] = z;
                this._maxZ = ( z > this._maxZ ) ? z : this._maxZ;
                this._minZ = ( z < this._minZ ) ? z : this._minZ;
            }
            return projPositions;
        };
    } )(),

    getLongSectionPositions: function () {
        var plane = this._polytope[ 0 ];
        var dirVec = osg.vec3.sub( osg.vec3.create(), this._end, this._start );
        dirVec[ 2 ] = 0.0;
        osg.vec3.normalize( dirVec, dirVec );

        return this.projectToPlane( plane, dirVec, 0.0, 1.0 );
    },

    getCrossSectionPositions: function () {
        var plane = this._polytope[ 1 ];
        var dirVec = osg.vec3.sub( osg.vec3.create(), this._end, this._start );
        var dirVecP = [ -dirVec[ 1 ], dirVec[ 0 ], 0.0 ];
        osg.vec3.normalize( dirVecP, dirVecP );

        return this.projectToPlane( plane, dirVecP, this._width, -1.0 );
    },

    intersectsBoundingSphere: function ( position, radius ) {
        var d;
        var r = -radius * 5.0;
        for ( var i = 0, j = this._iPolytope.length; i < j; i++ ) {
            d = this._iPolytope[ i ][ 0 ] * position[ 0 ] + this._iPolytope[ i ][ 1 ] * position[ 1 ] + this._iPolytope[ i ][ 2 ] * position[ 2 ] + this._iPolytope[ i ][ 3 ];
            if ( d <= r ) {
                return false;
            }
        }
        return true;
    },

    includesVertex: function ( vertex ) {
        return ( this._polytopeModel.containsVertex( vertex ) );
    },

    // called by visitor
    setCurrentTransformation: function ( matrix ) {
        // Transform the polytope and the referencePlane to the current Model local coordinate frame
        var inv;
        var iplane = osg.vec4.create();
        // Need to update all the list, not a single polytope
        for ( var i = 0, j = this._polytope.length; i < j; i++ ) {
            var plane = this._polytope[ i ];
            // transform current polytope plane to the local coordinate frame
            this.transformVec4PostMult( iplane, plane, matrix );
            // multiply the coefficients of the plane equation with a constant factor so that the equation a^2+b^2+c^2 = 1 holds.
            inv = 1.0 / Math.sqrt( iplane[ 0 ] * iplane[ 0 ] + iplane[ 1 ] * iplane[ 1 ] + iplane[ 2 ] * iplane[ 2 ] );
            iplane[ 0 ] *= inv;
            iplane[ 1 ] *= inv;
            iplane[ 2 ] *= inv;
            iplane[ 3 ] *= inv;
            this._iPolytope[ i ] = osg.vec4.copy( osg.vec4.create(), iplane );
        }
    }
} );

module.exports = PointCollectorPolytopeIntersector;


/***/ }),

/***/ "./sources/pcvizUtils/PointCollectorSphereIntersector.js":
/*!***************************************************************!*\
  !*** ./sources/pcvizUtils/PointCollectorSphereIntersector.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;

var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var PointCollectorIntersector = __webpack_require__( /*! pcvizUtils/PointCollectorIntersector */ "./sources/pcvizUtils/PointCollectorIntersector.js" );

/**
 * Class to get the points contained in a sphere
 *  @class
 *  @memberof pcvizUtils
 */
var PointCollectorSphereIntersector = function () {

    PointCollectorIntersector.call( this );
};

PointCollectorSphereIntersector.prototype = Utils.objectInherit( PointCollectorIntersector.prototype, {

    /**
     * In this case we only use the "start" point as sphere center
     * @method
     * @memberof pcvizUtils.PointCollectorIntersector
     */
    setPath: function ( center ) {
        this._center = center;
    },

    setWidth: function ( width ) {
        this._radius = width;
    },

    reset: function () {
        this._collectedPoints = [];
        this._collectedPointsColors = [];
        this._center = undefined;
        this._matrix = undefined;
        this._radius = undefined;
        this._maxZ = -Number.MAX_VALUE;
        this._minZ = Number.MAX_VALUE;
    },

    intersectsBoundingSphere: function ( position, radius ) {
        if ( !this._matrix )
            return true;

        var transfPos = osg.vec3.create();
        osg.vec3.transformMat4( transfPos, position, this._matrix );

        var d = osg.vec3.distance( transfPos, this._center );
        if ( d > radius + this._radius )
            return false;
        return true;
    },

    includesVertex: function ( vertex ) {
        var d = osg.vec3.distance( vertex, this._center );
        return ( d < this._radius );
    },

    // called by visitor
    setCurrentTransformation: function ( matrix ) {
        this._matrix = matrix;
    }

} );

module.exports = PointCollectorSphereIntersector;


/***/ }),

/***/ "./sources/pcvizUtils/PointVisibilityManager.js":
/*!******************************************************!*\
  !*** ./sources/pcvizUtils/PointVisibilityManager.js ***!
  \******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointVisibilityManager; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js");
/* harmony import */ var pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizUtils/PointVisibilityVisitor */ "./sources/pcvizUtils/PointVisibilityVisitor.js");
/* harmony import */ var pcvizUtils_SelectionVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/SelectionVisibilityVisitor */ "./sources/pcvizUtils/SelectionVisibilityVisitor.js");
/* harmony import */ var pcvizUtils_UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! pcvizUtils/UpdateVisibilityVisitor */ "./sources/pcvizUtils/UpdateVisibilityVisitor.js");
/* harmony import */ var pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js");
/* harmony import */ var pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js");











const osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;

const INSIDER_OPERATION = {
    REPLACE: 0,
    ADD: 1,
    SUBSTRACT: 2,
    INTERSECT: 3
};
class PointVisibilityManager {
    constructor( view ) {
        this._view = view;
        this._viewer = view._viewer; // Camera is the first node

        this._selectionInsiders = []; // insiders that only selects/preview point to be hide
        this._hideInsiders = []; // insiders that hide points. Is a list of insiders list
        this._deleteInsiders = []; // insiders that delete points. Is a list of insiders list

        this._selectionVisitor = new pcvizUtils_SelectionVisibilityVisitor__WEBPACK_IMPORTED_MODULE_4__["default"](); // Visitor to apply just one insider at the same time considering previous visibility values.
        this._updateVisitor = new pcvizUtils_UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_5__["default"]();
        this._pointVisibilityVisitor = new pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["default"]();

        this._controller = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_2___default.a.getController( 'PointVisibilityManager' );
        this._controller.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1___default.a.PROJECT, 'processGeometriesStacked', ( id ) => {
            // Process new tiles comming from zoom
            if ( this._hideInsiders.length > 0 || this._deleteInsiders.length > 0 || this._selectionInsiders.length > 0 ) {
                const geomArray = this._controller.getGeomToProcess( id );
                if ( geomArray ) {
                    geomArray.forEach( ( geom ) => {
                        this.traverseGeometry( geom );
                    } );
                }
            }
            this._controller.clearGeomToProcess( id );
        }, 'pointVisibilityManager:processGeometries' );

        this._controller.registerListener( pcvizDB_ListenerController__WEBPACK_IMPORTED_MODULE_1___default.a.PROJECT, 'updateGeometriesStacked', () => {
            // Update geometries from diferents views
            const geomArray = this._controller.getGeomToUpdate();
            geomArray.forEach( ( geom ) => {
                this.restoreAndApply( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].ALL, geom );
            } );
            this._controller.clearGeomToUpdate();
        }, 'pointVisibilityManager:updateGeometries' );
    }

    getSelectionInsiders() {
        return this._selectionInsiders;
    }

    getHiddenInsiders() {
        return this._hideInsiders;
    }

    getDeletedInsiders() {
        return this._deleteInsiders;
    }

    getPCNodeVisibles() {
        let pointCloudNodes = Array.from( this._view.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].POINTCLOUD ).values() );

        pointCloudNodes = pointCloudNodes.filter( ( pcNode ) => {
            return pcNode.Layer.isVisible();
        } );

        return pointCloudNodes;
    }

    addInsider( insider, op ) {

        if ( ( op === INSIDER_OPERATION.SUBSTRACT || op === INSIDER_OPERATION.INTERSECT ) && this._selectionInsiders.length === 0 ) {
            return;
        }

        this._selectionInsiders.push( insider );

        if ( op === INSIDER_OPERATION.REPLACE ) {
            this.cleanPointSelected();
            this._selectionInsiders = [ insider ];
        }

        const sceneToProcess = this.getPCNodeVisibles();

        // Sets insider for selection process. This part just uses the last insider created to change the selection over the point cloud.
        this._selectionVisitor.setInsider( insider );
        for ( let node of sceneToProcess ) {
            node.accept( this._selectionVisitor );
        }

        this._controller.notifyNewCloudSelection();
        this._controller.notifyVisibilityUpdated();
    }

    replaceLastSelectionInsider( newInsider ) {
        this.popSelectionInsider();
        const newSelectionInsiders = [ ...this._selectionInsiders, newInsider ];

        this.cleanPointSelected();
        this._selectionInsiders = newSelectionInsiders;

        this.refreshPointSelection();
    }

    popSelectionInsider() {
        return this._selectionInsiders.pop();
    }

    traverseGeometry( geom ) { // This code applies all selection, hidden selection and delete selection that have been applied at the same time.
        // Apply updateVisibilityVisitor
        this._updateVisitor.reset();
        this._updateVisitor.setCommitedInsiderList( [ ...this._hideInsiders, ...this._deleteInsiders ] );
        this._updateVisitor.setTemporalInsiderList( this._selectionInsiders );
        geom.accept( this._updateVisitor );
    }

    changeSelectionColor( value ) {
        const color = osg.vec4.copy( osg.vec4.create(), value );
        const pointCloudNodes = Array.from( this._view.getLayerRenderer().getLayerNodesByType( pcvizGIS_LayerType__WEBPACK_IMPORTED_MODULE_7__["default"].POINTCLOUD ).values() );
        for ( const pcNode of pointCloudNodes ) {
            pcNode.pointEditionAttribute.setSelectColor( color );
        }
    }

    refreshPointSelection() {
        this._updateVisitor.reset();
        this._updateVisitor.setTemporalInsiderList( this._selectionInsiders );

        const sceneToProcess = this.getPCNodeVisibles();
        for ( const node of sceneToProcess ) {
            node.accept( this._updateVisitor );
        }
    }

    cleanPointSelected() {
        this._pointVisibilityVisitor.setMode( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].SELECTED );
        this._pointVisibilityVisitor.setVisibilityValue( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_VISIBILITY_FLAGS"].VISIBLE );

        const sceneToProcess = this.getPCNodeVisibles();
        for ( const node of sceneToProcess ) {
            node.accept( this._pointVisibilityVisitor );
        }

        this._selectionInsiders = [];

        this._controller.notifyVisibilityUpdated();
    }

    cleanPointSelectedFromHiddenLayer( layerID, layerNode ) {
        this._pointVisibilityVisitor.setMode( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].SELECTED );
        this._pointVisibilityVisitor.setVisibilityValue( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_VISIBILITY_FLAGS"].VISIBLE );
        layerNode.accept( this._pointVisibilityVisitor );

        const aux = [];
        for ( let i = 0; i < this._selectionInsiders.length; i++ ) {
            this._selectionInsiders[ i ].getLayersMap().delete( layerID );

            if ( this._selectionInsiders[ i ].getLayersMap().size > 0 ) {
                aux.push( this._selectionInsiders[ i ] );
            }
        }
        this._selectionInsiders = aux;
    }

    hideSelectedPoints() {
        this.dumpSelectToHide();

        const sceneToProcess = this.getPCNodeVisibles();

        this._pointVisibilityVisitor.setMode( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].SELECTED );
        this._pointVisibilityVisitor.setVisibilityValue( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_VISIBILITY_FLAGS"].INVISIBLE );

        for ( let node of sceneToProcess ) {
            node.accept( this._pointVisibilityVisitor );
        }

        //Refresh others Views
        this._controller.notifyVisibilityUpdated();
    }

    deleteSelectedPoints() {
        this.dumpSelectToDelete();

        const sceneToProcess = this.getPCNodeVisibles();
        this._pointVisibilityVisitor.setMode( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].SELECTED );
        this._pointVisibilityVisitor.setVisibilityValue( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_VISIBILITY_FLAGS"].INVISIBLE );

        for ( let node of sceneToProcess ) {
            node.accept( this._pointVisibilityVisitor );
        }

        //Refresh others Views
        this._controller.notifyVisibilityUpdated();
    }

    restoreAndApply( mode, node ) {
        this._pointVisibilityVisitor.setMode( mode );
        this._pointVisibilityVisitor.setVisibilityValue( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_VISIBILITY_FLAGS"].VISIBLE );

        node.accept( this._pointVisibilityVisitor ); // Clean points selected: All selection insiders will be applied in proccesGeometry
        this.traverseGeometry( node );
    }

    dumpSelectToHide() {
        this._hideInsiders.push( this._selectionInsiders );

        this._selectionInsiders = [];
    }

    dumpSelectToDelete() {
        this._deleteInsiders.push( this._selectionInsiders );

        this._selectionInsiders = [];
    }

    showHiddenPoints() {
        this._hideInsiders = [];

        const sceneToProcess = this.getPCNodeVisibles();

        for ( let node of sceneToProcess ) {
            this.restoreAndApply( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].ALL, node );
        }

        //Refresh others Views
        this._controller.notifyVisibilityUpdated();
    }

    restoreDeletedPoints() {
        this._deleteInsiders = [];

        const sceneToProcess = this.getPCNodeVisibles();

        for ( let node of sceneToProcess ) {
            this.restoreAndApply( pcvizUtils_PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_3__["POINT_MODES"].ALL, node );
        }

        //Refresh others Views
        this._controller.notifyVisibilityUpdated();
    }

    getInsidersObject() {
        return { delete: [ ...this._deleteInsiders ], select: [ ...this._selectionInsiders ], hidden: [ ...this._hideInsiders ] };
    }

    saveInsidersDB() {
        let extData = this._view.getProject().getExtData();

        if ( !extData ) {
            extData = {};
        }

        extData.insiders = [];

        this._deleteInsiders.forEach( ( round ) => {
            const insidersRound = [];
            round.forEach( ( insider ) => {
                insidersRound.push( insider.getJSON() );
            } );
            extData.insiders.push( insidersRound );
        } );

        return this._view.getProject().setExtensibleData( extData );
    }

    downloadInsidersDB() {
        const extData = this._view.getProject().getExtData();

        if ( !extData || !extData.insiders ) {
            this._controller.enableProcessGeometries();
            return;
        }

        if ( extData.insiders.delete ) { // DEPRECATE: Just to make it compatible with old version.
            extData.insiders = extData.insiders.delete;
        }
        this._deleteInsiders = this.loadInsiderList( extData.insiders );

        this._controller.enableProcessGeometries();
    }

    loadInsiderList( dbList ) {
        const insidersList = [];
        dbList.forEach( ( insidersRound ) => {
            const round = [];
            insidersRound.forEach( ( insiderJSON ) => {
                const insider = new pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_6__["default"]( insiderJSON.vertex, insiderJSON.nearPoints, insiderJSON.farPoints, insiderJSON.matrix, insiderJSON.type );

                const layerMap = new Map();
                if ( insiderJSON.affectedLayers ) {
                    for ( let layer of insiderJSON.affectedLayers ) {
                        layerMap.set( layer.key, layer.value );
                    }
                    insider.setLayersMap( layerMap );
                }

                // In DB only exists valid insiders. This flag is checked before store insiders, and are pop up if are invalid.
                insider.validateInsider();

                round.push( insider );
            } );
            insidersList.push( round );
        } );

        return insidersList;
    }

    cleanInsidersDB() {
        const extData = this._view.getProject().getExtData();

        if ( !extData || !extData.insiders ) {
            return;
        }

        extData.insiders = [];

        return this._view.getProject().setExtensibleData( extData );
    }

    processScene() {
        const sceneToProcess = this.getPCNodeVisibles();

        for ( const node of sceneToProcess ) {
            this.traverseGeometry( node );
        }
    }

}


/***/ }),

/***/ "./sources/pcvizUtils/PointVisibilityVisitor.js":
/*!******************************************************!*\
  !*** ./sources/pcvizUtils/PointVisibilityVisitor.js ***!
  \******************************************************/
/*! exports provided: POINT_MODES, POINT_VISIBILITY_FLAGS, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINT_MODES", function() { return POINT_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "POINT_VISIBILITY_FLAGS", function() { return POINT_VISIBILITY_FLAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointVisibilityVisitor; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);

var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
var NodeVisitor = osg.NodeVisitor;

const POINT_MODES = {
    ALL: 'all',
    SELECTED: 'selected',
    HIDDEN: 'hidden'
};

const POINT_VISIBILITY_FLAGS = {
    VISIBLE: 0.0,
    SELECTED: 1.0,
    INVISIBLE: 2.0
};

class PointVisibilityVisitor extends NodeVisitor {
    constructor() {
        super( NodeVisitor.TRAVERSE_ALL_CHILDREN );
        this._mode = POINT_MODES.HIDDEN;
        this._visibilityValue = POINT_VISIBILITY_FLAGS.VISIBLE;
    }

    apply( node ) {

        if ( node.getTypeID() === osg.Geometry.getTypeID() && node.getAttributes() && node.getAttributes().Visible ) {

            let visibleElements = node.getAttributes().Visible.getElements();
            if ( visibleElements.length ) {
                if ( this._mode === POINT_MODES.ALL )
                    visibleElements.fill( this._visibilityValue );

                else
                    for ( let k = 0; k < visibleElements.length; k++ )
                        if ( ( this._mode === POINT_MODES.SELECTED && this.isSelectedPoint( visibleElements, k ) ) ||
                            ( this._mode === POINT_MODES.HIDDEN && this.isHiddenPoint( visibleElements, k ) ) ) {

                            visibleElements[ k ] = this._visibilityValue;
                        }
            }

            node.getAttributes().Visible.dirty();
        }

        this.traverse( node );
    }

    isSelectedPoint( visibleElements, vertexID ) {
        return visibleElements[ vertexID ] === POINT_VISIBILITY_FLAGS.SELECTED;
    }

    isHiddenPoint( visibleElements, vertexID ) {
        return visibleElements[ vertexID ] === POINT_VISIBILITY_FLAGS.INVISIBLE;
    }

    setMode( mode ) {
        this._mode = mode;
    }

    setVisibilityValue( value ) {
        this._visibilityValue = value;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/PointVisibleCollector.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizUtils/PointVisibleCollector.js ***!
  \*****************************************************/
/*! exports provided: COLLECT_POINT_MODES, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLLECT_POINT_MODES", function() { return COLLECT_POINT_MODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PointVisibleCollector; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizNode/SceneNode */ "./sources/pcvizNode/SceneNode.js");
/* harmony import */ var pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2__);



var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
var NodeVisitor = osg.NodeVisitor;

const COLLECT_POINT_MODES = {
    SELECTED: 'selected',
    HIDDEN: 'hidden'
};

class PointVisibleCollector extends NodeVisitor {
    constructor() {
        super( NodeVisitor.TRAVERSE_ALL_CHILDREN );
        this._collectedPoints = [];
        this._worldCollectedPoints = [];
        this._mode = COLLECT_POINT_MODES.SELECTED;
        this._viewerCenter = osg.vec3.create();
        this._affectedExtent = undefined; // minX, minY, minZ, maxX, maxY, maxZ
    }

    apply( node ) {

        if ( node.getTypeID() === osg.Geometry.getTypeID() && node.getAttributes() && node.getAttributes().Visible ) {

            const elements = node.getAttributes().Vertex.getElements();

            const nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.computeNodePath( node );
            const scenePath = this.findScenePath( nodePath );

            const mat = osg.computeLocalToWorld( nodePath );
            const sceneMat = osg.computeLocalToWorld( scenePath );

            const vertex = osg.vec3.create();
            const vertexTr1 = osg.vec3.create();
            const vertexTr2 = osg.vec3.create();

            for ( let k = 0, l = elements.length; k < l; k += 3 ) {
                if ( node.getAttributes().Visible.getElements().length > k / 3 ) {

                    if ( ( this._mode === COLLECT_POINT_MODES.SELECTED && this.isSelectedPoint( node, k / 3 ) ) ||
                        ( this._mode === COLLECT_POINT_MODES.HIDDEN && this.isHiddenPoint( node, k / 3 ) ) ) {

                        osg.vec3.set( vertex, elements[ k ], elements[ k + 1 ], elements[ k + 2 ] ); // Vertex geometry-local coords

                        osg.vec3.transformMat4( vertexTr1, vertex, mat );
                        this._collectedPoints.push( osg.vec3.copy( osg.vec3.create64(), vertexTr1 ) ); // Vertex camera coords

                        osg.vec3.transformMat4( vertexTr2, vertex, sceneMat );
                        osg.vec3.add( vertexTr2, vertexTr2, this._viewerCenter );
                        const newWorldPoint = osg.vec3.copy( osg.vec3.create64(), vertexTr2 );
                        this._worldCollectedPoints.push( newWorldPoint ); // Vertex world coords

                        this.updateAffectedExtent( newWorldPoint );
                    }
                }
            }
        }

        this.traverse( node );
    }

    findScenePath( nodePath ) {
        for ( var i = 0; i < nodePath.length; i++ ) {
            if ( nodePath[ i ] instanceof pcvizNode_SceneNode__WEBPACK_IMPORTED_MODULE_2___default.a ) {
                break;
            }
        }

        return nodePath.slice( i );
    }

    getPoints() {
        return this._collectedPoints;
    }

    getWorldPoints() {
        return this._worldCollectedPoints;
    }

    isSelectedPoint( geom, vertexID ) {
        return geom.getAttributes().Visible.getElements()[ vertexID ] === 1.0;
    }

    isHiddenPoint( geom, vertexID ) {
        return geom.getAttributes().Visible.getElements()[ vertexID ] === 2.0;
    }

    setViewerCenter( center ) {
        this._viewerCenter = osg.vec3.fromValues( center[ 0 ], center[ 1 ], center[ 2 ] );
    }

    setMode( mode ) {
        this._mode = mode;
    }

    getAffectedExtent() {
        return this._affectedExtent;
    }

    updateAffectedExtent( point ) {
        if ( !this._affectedExtent ) {
            this._affectedExtent = [ point[ 0 ], point[ 1 ], point[ 2 ], point[ 0 ], point[ 1 ], point[ 2 ] ];
            return;
        }
        this._affectedExtent[ 0 ] = Math.min( point[ 0 ], this._affectedExtent[ 0 ] );
        this._affectedExtent[ 1 ] = Math.min( point[ 1 ], this._affectedExtent[ 1 ] );
        this._affectedExtent[ 2 ] = Math.min( point[ 2 ], this._affectedExtent[ 2 ] );
        this._affectedExtent[ 3 ] = Math.max( point[ 0 ], this._affectedExtent[ 3 ] );
        this._affectedExtent[ 4 ] = Math.max( point[ 1 ], this._affectedExtent[ 4 ] );
        this._affectedExtent[ 5 ] = Math.max( point[ 2 ], this._affectedExtent[ 5 ] );
    }

    reset() {
        this._collectedPoints = [];
        this._worldCollectedPoints = [];
        this._mode = COLLECT_POINT_MODES.SELECTED;
        this._viewerCenter = osg.vec3.create();
        this._affectedExtent = undefined;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/PropertySet.js":
/*!*******************************************!*\
  !*** ./sources/pcvizUtils/PropertySet.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
/**
 * A container to access and store generic properties.
 * @class
 * @memberof pcvizUtils
 * @property {Integer} _objectId The id to identify the object in the application.
 * @property {Array} _fields The fields to be rendered by a PropertyBag.
 * @property {Object} _dirty An object with key value pairs indicating which fields have been modified.
 * @property {Object} _getCallbacks An object that references the getters of the field values.
 * @property {Object} _setCallbacks An object that references the setters of the field values.
 */
var PropertySet = function () {
    this._objectId = Utils.generateUUID();
    this._fields = [];
    this._dirty = {};
    this._getCallbacks = {};
    this._setCallbacks = {};
    this._registerInObjectController = true;
};

PropertySet.prototype = {

    /**
     * Returns the object id in the application.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @return {string} The UUID.
     */
    getObjectId: function () {
        return this._objectId;
    },

    /**
     * Registers a property.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param {object} field An object containing the property definition.
     * `id` | The key of the property
     *
     * `label` | The text to be shown in the UI.
     *
     * `type` | The type of the property. `TODO`: Define property types properly.
     * Options are `CharField`, `FloatField`, `IntegerField`, `BooleanField`, `Point`,
     * `ColorField`, `GeometryField`, `CalssificationField`, `ArrayField`, `PointArrayField`, 'ExpressionField' and `GroupField`.
     *
     * `editable` | Defines whether the property is editable or not
     *
     * `selected` | Defines which element in an Array is selected or if a Point is selected.
     *
     * `valueRange`| Defines ranges for the field.
     * >If the field type is `CharField`, `valueRange` must be an array containing the list of options.
     *
     * >If the field type is `FloatField`, `valueRange` must be an array whose first and second elements define the *min* and *max* values.
     * >If a third element is included, it is considered the *step* size.
     *
     * `order` | A value indicating the order the properties must be sorted.
     *
     * `multiple` | Defines whether it is a multiple selection or not.
     *
     * `children` | Objects selected when the selection is multiple.
     *
     * `get` | A callback to get the value.
     *
     * `set` | A callback to set the value.
     *
     * `group` | The group the property belongs to. This may be a `string` with the key of the `GroupField` or the group object.
     *
     * `decimals` | For FloatField, it defines how many number of decimals are shown for this property (when it is not focused).
     */
    addPropertyField: function ( field ) {

        var visibilityFunction;
        if ( field.visible !== undefined ) {
            visibilityFunction = field.visible;
        } else if ( field.multiple ) {
            visibilityFunction = function () {
                if ( field.type === 'GroupField' )
                    return true;
                var visible = field.children.some( function ( obj ) {
                    return obj.getField( field.id ).visible();
                } );
                return visible;
            };
        } else {
            visibilityFunction = function () {
                return true;
            };
        }

        var editableFunction;
        if ( field.editable !== undefined ) {
            editableFunction = field.editable;
        } else {
            editableFunction = function () {
                return true;
            };
        }

        if ( field.type === 'GroupField' ) {
            field.children = [];
        }

        var propertyField = {
            field: field.id,
            label: field.label,
            type: field.type,
            visible: visibilityFunction,
            editable: editableFunction,
            selected: field.selected !== undefined ? field.selected : null,
            expanded: field.expanded !== undefined ? field.expanded : null,
            valueRange: field.valueRange !== undefined ? field.valueRange : null,
            size: field.size !== undefined ? field.size : null,
            sortIndex: field.order,
            multiple: field.multiple !== undefined ? field.multiple : false,
            children: field.children !== undefined ? field.children : null,
            isDirty: field.isDirty !== undefined ? field.isDirty : null,
            translate: field.translate,
            decimals: field.decimals !== undefined ? field.decimals : null,
            getUnit: field.getUnit !== undefined ? field.getUnit : null,
            convertUnit: field.convertUnit !== undefined ? field.convertUnit : null,
            unitType: field.unitType !== undefined ? field.unitType : null,
            logarithmic: field.logarithmic !== undefined ? field.logarithmic : false,
            set: field.set !== undefined ? field.set : undefined,
        };

        if ( field.group !== undefined ) {
            if ( typeof field.group === 'string' ) {
                this.getField( field.group ).children.push( propertyField );
            } else {
                field.group.children.push( propertyField );
            }
        } else {
            this._fields.push( propertyField );
        }
        this._dirty[ field.id ] = false;
        this._getCallbacks[ field.id ] = field.get;
        this._setCallbacks[ field.id ] = field.set;

        return propertyField;
    },

    /**
     * Removes a property field of the list of properties.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} id The property id.
     */
    removePropertyField: function ( groupId, field ) {
        var group = this._fields.find( function ( g ) {
            return ( g.field === groupId );
        } );
        if ( group === undefined )
            return;

        for ( var i = 0; i < group.children.length; i++ ) {
            if ( group.children[ i ].field === field )
                break;
        }
        if ( i < group.children.length )
            group.children.splice( i, 1 );
        return;
    },

    /**
     * Returns the list of properties.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @return {JSON} The properties definition.
     */
    getProperties: function ( group ) {
        var fields;
        if ( group !== undefined ) {
            var prop = this.getField( group );
            if ( !prop ) // this may happen when style rules are removed
                return undefined;
            fields = prop.children;
        } else
            fields = this._fields;
        return fields;
    },

    /**
     * Gets the property calling the field callback.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @param  {any} args Extra arguments to pass to the property callback.
     * @return {any}          The property value.
     */
    getProperty: function ( property, args ) {
        var prop = this.getField( property );
        if ( !prop ) // this may happen when style rules are removed
            return undefined;

        if ( prop.multiple )
            return this.getValueFromMultipleSelection( property, args );
        else
            return this._getCallbacks[ property ].call( this, args );
    },

    /**
     * Sets the property calling the field callback.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name
     * @param  {any} value The property value
     * @param  {any} args     Extra arguments to pass to the property callback.
     */
    setProperty: function ( property, value, args ) {
        var prop = this.getField( property );
        if ( !prop ) // this may happen when style rules are removed
            return undefined;

        this.dirtyProperty( property );
        if ( prop.multiple )
            this.setValueToMultipleSelection( property, value, args );
        else
            this._setCallbacks[ property ].call( this, value, args );
    },

    /**
     * Gets the property value when the field has children. If they are
     * equal, it returns that value. Otherwise, it returns `undefined` and
     * the flag `multipleData` is set to `true`.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @param  {any} args     Extra arguments to pass to the property callback.
     * @return {any}          The property value when children values are equal, `undefined` otherwise.
     */
    getValueFromMultipleSelection: function ( property, args ) {
        var field = this.getField( property );
        field.multipleData = false;
        var index = 0;
        var findNull = false;
        var value = field.children.find( function ( prop ) {
            index++;
            if ( prop.getProperty( property, args ) === null )
                findNull = true;
            return prop.getProperty( property, args ) !== null;
        } );

        value = field.children[ index - 1 ].getProperty( property, args );
        for ( var i = index; i < field.children.length; i++ ) {
            if ( field.children[ i ].getProperty( property, args ) !== value ) {
                field.multipleData = true;

                if ( field.children[ i ].getProperty( property, args ) !== null ) {
                    value = undefined;
                    break;
                }
            }
            if ( findNull )
                field.multipleData = true;
        }
        return value;
    },

    /**
     * Sets the property when the field has children. It calling the field callback
     * of each children.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name
     * @param  {any} value The property value
     * @param  {any} args     Extra arguments to pass to the property callback.
     */
    setValueToMultipleSelection: function ( property, value, args ) {
        var field = this.getField( property );
        field.multipleData = false;
        for ( var i = 0; i < field.children.length; i++ )
            field.children[ i ].setProperty( property, value, args );
    },

    /**
     * Gets the property value range when the field has children.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @return {any}          The property value range when children values are equal, `undefined` otherwise.
     */
    getValueRangeFromMultipleSelection: function ( property, childrenToUse ) {
        var children = childrenToUse ? childrenToUse : this.getField( property ).children;
        var value = children[ 0 ].getValueRange( property );
        for ( var i = 1; i < children.length; i++ ) {
            if ( !Utils.arrayEquals( children[ i ].getValueRange( property ), value ) ) {
                value = undefined;
                break;
            }
        }
        if ( value !== undefined ) // al ranges match
            return value;

        // find common range set (only valid for enumerations)
        value = [];
        var firstChildValues = children[ 0 ].getValueRange( property );
        if ( firstChildValues ) {
            firstChildValues.forEach( function ( enumValue ) {
                var found = true;
                for ( i = 1; i < children.length; i++ ) {
                    if ( children[ i ].getValueRange( property ).indexOf( enumValue ) === -1 ) {
                        found = false;
                        break;
                    }
                }
                if ( found )
                    value.push( enumValue );
            } );
        }

        return value;
    },

    /**
     * Changes a property field inner value. I.e, its visibility or getter function.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @param  {string} key      The key of the property field to be changed. Options are `visible`, `get`,
     * `set`, `multiple`, `type`, `label`, `editable`, `valueRange` and `children`.
     * @param  {any} value    The new value.
     */
    changePropertyField: function ( property, key, value ) {
        for ( var i = 0; i < this._fields.length; i++ )
            if ( this._fields[ i ].field === property ) {
                this._fields[ i ][ key ] = value;
            }
    },

    /**
     * Gets a field by its name. This method searchs the property
     * also in the children of group fields.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @return {object}          A property field.
     */
    getField: function ( property, root ) {
        if ( !root )
            root = this._fields;

        for ( var i = 0; i < root.length; i++ ) {
            if ( root[ i ].field === property )
                return root[ i ];
            else if ( root[ i ].type === 'GroupField' ) { // recurse
                var findRecurse = this.getField( property, root[ i ].children );
                if ( findRecurse )
                    return findRecurse;
            }
        }
        return undefined;
    },

    /**
     * Gets the value range of the property
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     * @return {array}          The property value range.
     */
    getValueRange: function ( property ) {
        var field = this.getField( property );
        if ( field.multiple )
            return this.getValueRangeFromMultipleSelection( property );
        else
            return field.valueRange;
    },

    /**
     * Sets all attributes clean
     * @method
     * @memberof pcvizUtils.PropertySet
     */
    clearDirty: function () {
        var dirtyKeys = window.Object.keys( this._dirty );
        for ( var i = 0; i < dirtyKeys.length; i++ )
            this._dirty[ dirtyKeys[ i ] ] = false;
    },

    /**
     * Checks if an object has defined a property.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string}  prop The property name.
     * @return {Boolean}      `true` when the object has defined that property, `false` otherwise.
     */
    hasProperty: function ( prop ) {
        var res = false;
        for ( var i = 0; i < this._fields.length; i++ )
            if ( this._fields[ i ].field === prop ) {
                res = true;
                break;
            }
        return res;
    },

    /**
     * Registers the object in the ObjectController.
     * @method
     * @memberof pcvizUtils.PropertySet
     */
    dirtyObject: function () {
        Registry.getInstance().getController( 'Object' ).registerObject( this );
    },

    /**
     * Checks if the object has been modified.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @return {Boolean} Returns `true` when
     * at least one of the property fields values has been modified
     */
    isDirty: function () {
        var dirty = false;
        for ( var i = 0; i < this._fields.length; i++ ) {
            if ( this.fieldIsDirty( this._fields[ i ] ) ) {
                dirty = true;
                break;
            }
        }
        return dirty;
    },

    /**
     * Checks if a field value has been  modified.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} field The field name.
     * @return {Boolean}       Returns `true` if the field value has been changed.
     */
    fieldIsDirty: function ( field ) {
        if ( field.type === 'GroupField' ) {
            var dirty = false;
            for ( var i = 0; i < field.children.length; i++ ) {
                if ( this.fieldIsDirty( field.children[ i ] ) ) {
                    dirty = true;
                    break;
                }
            }
            return dirty;
        }
        if ( field.isDirty )
            return field.isDirty();
        return this._dirty[ field.field ];
    },
    /**
     * return if a property is dirty.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     */
    isDirtyProperty: function ( property ) {
        if ( !this._registerInObjectController )
            return;
        return this._dirty[ property ];
    },




    /**
     * Sets a property dirty.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {string} property The property name.
     */
    dirtyProperty: function ( property ) {
        if ( !this._registerInObjectController )
            return;
        this._dirty[ property ] = true;
        this.dirtyObject();
    },

    /**
     * Enables/disables registration in Object Controller
     * when a field value is modified.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param  {Boolean} enabled `true` to enable registering, `false` to disable.
     */
    enableRegisterInObjectController: function ( enabled ) {
        this._registerInObjectController = enabled;
    },

    /**
     * Clears the property set.
     * @method
     * @memberof pcvizUtils.PropertySet
     */
    clearProperties: function () {
        this._fields = [];
        this._dirty = {};
        this._getCallbacks = {};
        this._setCallbacks = {};
    },

    /**
     * Sets the update callback.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @param {Function} cb The update callback
     */
    setUpdateCallback: function ( cb ) {
        this._updateCallback = cb;
    },

    /**
     * This ensures that the update process has been executed successfully.
     * In case it fails, it is registered again in the object controller.
     * @method
     * @memberof pcvizUtils.PropertySet
     * @return {Promise} A promise that is resolved when the update callback has been resolved.
     */
    ensureUpdateCallback: function () {
        var self = this;
        var defer = P.defer();

        if ( this._updateCallback === undefined ) {
            defer.resolve();
            this.clearDirty();
        } else {
            var promise = this._updateCallback();
            if ( promise !== undefined ) {
                promise.then( function () {
                    defer.resolve();
                    self.clearDirty();
                } ).catch( function () {
                    defer.reject();
                    self.dirtyObject();
                } );
            } else {
                defer.resolve();
                this.clearDirty();
            }
        }

        return defer.promise;
    },

    initializePropertySet: function () {}
};

module.exports = PropertySet;


/***/ }),

/***/ "./sources/pcvizUtils/RasterLayerSelectionObject.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizUtils/RasterLayerSelectionObject.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
var CRSUtils = __webpack_require__( /*! pcvizUtils/CRSUtils */ "./sources/pcvizUtils/CRSUtils.js" );
/**
 * Defines a container to access and store the properties of the selected LayerGroup.
 * @class
 * @memberof pcvizUtils
 * @extends pcvizUtils.SelectionObject
 */
var RasterLayerSelectionObject = function () {
    SelectionObject.call( this );

    this._selectionType = SelectionObject.RasterLayer;
};

RasterLayerSelectionObject.prototype = osg.objectInherit( SelectionObject.prototype, {

    initializePropertySet: function () {
        var self = this;

        this.clearProperties();
        var infoGroup = this.addPropertyField( {
            id: 'infoGroup',
            label: 'POINTCLOUD_SELECTION_OBJECT.INFORMATION',
            type: 'GroupField',
            visible: function () {
                if ( !self.getLayer() )
                    return false;
                if ( self.getUserData() !== undefined ) {
                    if ( window.Object.keys( self.getUserData() ).length > 0 )
                        return true;
                }
                return false;
            }
        } );

        this.addPropertyField( {
            id: 'position',
            label: 'POINTCLOUD_SELECTION_OBJECT.POSITION',
            type: 'Point',
            editable: function () {
                return false;
            },
            get: ( function () {
                var transformedPoint = [];
                return function () {

                    if ( self.getUserData() !== undefined && self.getUserData().hasOwnProperty( 'position' ) ) {

                        var layer = self.getLayer();
                        var project = Registry.getController( 'Application' ).getApplication().getProject();
                        if ( !layer.getProjection() || !project.getProjection() )
                            return self.getUserData().position;

                        // Defines layer's projection and project's projection
                        CRSUtils.defProj4( layer.getProjection(), layer.getProj4() );
                        CRSUtils.defProj4( project.getProjection(), project.getProj4() );

                        transformedPoint[ 0 ] = self.getUserData().position[ 0 ];
                        transformedPoint[ 1 ] = self.getUserData().position[ 1 ];
                        transformedPoint[ 2 ] = self.getUserData().position[ 2 ];

                        // Convert from layer's projection to project's projection
                        try {
                            CRSUtils.transform( layer.getProjection(), project.getProjection(), transformedPoint, true, project.getGeoid() );
                        } catch ( err ) {
                            // To manage the error in the ui
                            transformedPoint[ 4 ] = err;
                        }

                        return transformedPoint;
                    }
                };
            } )(),
            group: infoGroup
        } );

        this.addPropertyField( {
            id: 'layer',
            label: 'RASTER_SELECTION_OBJECT.LAYER',
            type: 'Object',
            get: function () {
                return self.getLayer();
            }
        } );
    }

} );

module.exports = RasterLayerSelectionObject;


/***/ }),

/***/ "./sources/pcvizUtils/SegmentationConstants.js":
/*!*****************************************************!*\
  !*** ./sources/pcvizUtils/SegmentationConstants.js ***!
  \*****************************************************/
/*! exports provided: SEGMENTATION_LABELS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SEGMENTATION_LABELS", function() { return SEGMENTATION_LABELS; });


const SEGMENTATION_LABELS = [ {
        name: 'Sky',
        color: [ 128, 128, 128 ]
    },
    {
        name: 'Building',
        color: [ 128, 0, 0 ]
    },
    {
        name: 'Pole',
        color: [ 192, 192, 128 ]
    },
    {
        name: 'Road',
        color: [ 128, 64, 128 ]
    },
    {
        name: 'Pavement',
        color: [ 60, 40, 222 ]
    },
    {
        name: 'Tree',
        color: [ 128, 128, 0 ]
    },
    {
        name: 'SignSymbol',
        color: [ 192, 128, 128 ]
    },
    {
        name: 'Fence',
        color: [ 64, 64, 128 ]
    },
    {
        name: 'Car',
        color: [ 64, 0, 128 ]
    },
    {
        name: 'Pedestrian',
        color: [ 64, 64, 0 ]
    },
    {
        name: 'Bicyclist',
        color: [ 0, 128, 192 ]
    },
    {
        name: 'Unlabelled',
        color: [ 0, 0, 0 ]
    },
    {
        name: 'Heavy_car',
        color: [ 192, 64, 0 ]
    },
    {
        name: 'Shadow',
        color: [ 155, 87, 87 ]
    },
    {
        name: 'Pylon',
        color: [ 253, 190, 190 ]
    },
    {
        name: 'Electric_line',
        color: [ 0, 128, 64 ]
    },
    {
        name: 'Tripod',
        color: [ 64, 128, 0 ]
    },
    {
        name: 'Guardrail',
        color: [ 255, 245, 0 ]
    },
    {
        name: 'Guardpipe',
        color: [ 229, 93, 215 ]
    },
    {
        name: 'Soil',
        color: [ 0, 0, 222 ]
    },
    {
        name: 'Weed',
        color: [ 0, 0, 222 ]
    },
];


/***/ }),

/***/ "./sources/pcvizUtils/SelectionObject.js":
/*!***********************************************!*\
  !*** ./sources/pcvizUtils/SelectionObject.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var PropertySet = __webpack_require__( /*! pcvizUtils/PropertySet */ "./sources/pcvizUtils/PropertySet.js" );

/**
 * Defines a container to access and store the properties of the object selected (it can be a feature, a point of a PointCloud, etc.).
 * @class
 * @memberof pcvizUtils
 * @extends pcvizUtils.PropertySet
 */
var SelectionObject = function () {
    PropertySet.call( this );

    this._selectionType = SelectionObject.SELECTION_OBJECT;
    this._objects = new Map();
};

SelectionObject.SELECTION_OBJECT = 0;
SelectionObject.PointCloud = 1;
SelectionObject.VectorLayer = 2;
SelectionObject.RasterLayer = 3;
SelectionObject.LayerGroup = 4;

SelectionObject.getTypeFromString = function ( type ) {
    let out = type;
    switch ( type ) {
    case 'PointCloud':
        out = SelectionObject.PointCloud;
        break;
    case 'VectorLayer':
        out = SelectionObject.VectorLayer;
        break;
    case 'RasterLayer':
        out = SelectionObject.RasterLayer;
        break;
    case 'LayerGroup':
        out = SelectionObject.LayerGroup;
        break;
    }
    return out;
};

SelectionObject.prototype = osg.objectInherit( PropertySet.prototype, {

    /**
     * Sets an object in the selection object
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @param {string} name   The key name of the object
     * @param {any} object The object.
     */
    setObject: function ( name, object ) {
        this._objects.set( name, object );
    },

    /**
     * Gets an object from the selection object
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @param {string} name   The key name of the object
     * @return {any} object The object.
     */
    getObject: function ( name ) {
        return this._objects.get( name );
    },

    /**
     * Gets the selection object type.
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @return {string} The selection type.
     */
    getSelectionType: function () {
        return this._selectionType;
    },

    /**
     * Clears the selection object.
     * @method
     * @memberof pcvizUtils.SelectionObject
     */
    clear: function () {
        this._objects.clear();
    },

    /**
     * A helper function to set a layer in the selection object.
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @param {Layer} layer The layer
     */
    setLayer: function ( layer ) {
        this.setObject( 'layer', layer );
    },

    /**
     * A helper function to retrieve the layer from the selection object.
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @return {Layer} The layer.
     */
    getLayer: function () {
        return this.getObject( 'layer' );
    },

    /**
     * A helper function to set the information data in the selection object.
     * @method
     * @memberof pcvizUtils.SelectionObject
     * @param {Object} data The data object.
     */
    setUserData: function ( data ) {
        this.setObject( 'userData', data );
    },

    /**
     * A helper function to retrieve the information data from the selection object.
     * This object contains screen point position of the feature (VectorLayer).
     * This object contains the point information: its coordinates, its intensity value, its color value
     * and its classification value. (PointCloud)
     * @method
     * @memberof pcvizUtils.rSelectionObject
     * @return {Object} The data object.
     */
    getUserData: function () {
        return this.getObject( 'userData' );
    }

} );

module.exports = SelectionObject;


/***/ }),

/***/ "./sources/pcvizUtils/SelectionVisibilityVisitor.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizUtils/SelectionVisibilityVisitor.js ***!
  \**********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SelectionVisibilityVisitor; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js");
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js");






var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
var NodeVisitor = osg.NodeVisitor;

class SelectionVisibilityVisitor extends NodeVisitor {
    constructor() {
        super( NodeVisitor.TRAVERSE_ALL_CHILDREN );
        this._insider = undefined;
    }

    apply( node ) {

        // Skip nodes by bounding box collision and hidden layers
        const nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getNodePathToParent( node, pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_3___default.a );
        const pointCloudLayer = nodePath ? nodePath[ 0 ].Layer : undefined;
        if ( !pointCloudLayer ) {
            return;
        }

        let parentID = pointCloudLayer.getId();
        if ( pointCloudLayer.getParent().getCategory() === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_2__["default"].Scan ).name ) {
            parentID = pointCloudLayer.getParent().getId();
        }

        const localMat = osg.computeLocalToWorld( nodePath );

        // Geometry bbox
        const geomBounding = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getTransformedBoundingBox( node, localMat );

        if ( this.isCollidingInsider( geomBounding, parentID ) && node.getTypeID() === osg.Geometry.getTypeID() && node.getAttributes() && node.getAttributes().Visible ) {

            const vertexBuffer = node.getAttributes().Vertex;
            const elements = vertexBuffer.getElements();

            const vertex = osg.vec3.create();

            let visibleElements = node.getAttributes().Visible.getElements();
            for ( let k = 0, l = elements.length; k < l; k += 3 ) {
                osg.vec3.set( vertex, elements[ k ], elements[ k + 1 ], elements[ k + 2 ] );
                osg.vec3.transformMat4( vertex, vertex, localMat );

                let isPointVisible = visibleElements[ k / 3 ] !== 2.0;
                let isPointSelected = visibleElements[ k / 3 ] === 1.0;
                if ( isPointVisible ) {
                    visibleElements[ k / 3 ] = this.getSelectedValue( vertex, parentID, isPointSelected );
                }
            }

            node.getAttributes().Visible.dirty();
        }

        this.traverse( node );
    }

    isCollidingInsider( bounding, parentID ) {
        return this._insider.getType() === pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__["INSIDER_TYPES"].INTERSECT || this._insider.collideBoundingBox( bounding, parentID );
    }

    /**
     * Uses previous visibility of a point and the current insider to know if a point should be selected.
     * @method
     * @memberof pcvizUtils.InsiderVisitor
     * @param point 3d point from a geometry
     * @param parentId pcvizNode.PointCloudPLOD parent id
     * @param selected previous selection value of the point
     * @returns {Float} 1.0 if the point is selected, 0.0 if not.
     */
    getSelectedValue( point, parentId, selected ) {
        let result = pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__["default"].isSelectedByInsider( point, parentId, this._insider, selected );

        return result ? 1.0 : 0.0;
    }

    setInsider( insider ) {
        this._insider = insider;
    }

    reset() {
        this._insider = undefined;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/ShaderUtils.js":
/*!*******************************************!*\
  !*** ./sources/pcvizUtils/ShaderUtils.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ShaderUtils; });
class ShaderUtils {

    static getVertexShaderForPoints( heatMap ) {
        let vertexShader = [
            //'#version 100', // if we uncomment this line, #pragma include is not recognized
            '#ifdef GL_FRAGMENT_PRECISION_HIGH',
            'precision highp float;',
            '#else',
            'precision mediump float;',
            '#endif',
            'attribute vec4 Vertex;',
            'uniform mat4 uModelViewMatrix;',
            'uniform mat4 uProjectionMatrix;',
            'attribute vec4 Color;',
            'attribute float PointSize;',
            'varying vec4 litColor;'
        ];
        if ( heatMap !== undefined )
            vertexShader = vertexShader.concat( [
                `attribute float HeatMap_${heatMap};`,
                'uniform float heatmapOptionsGradientRange;',
                'uniform int heatmapOptionsGradientStyle;',
                'uniform int heatmapOptionsNumberOfSteps;',
                'uniform float toleranceInModelUnits;',
                '#pragma include "verityHeatmap.glsl"',
                'float getHeatMapValue() {',
                `  return convertToHeatmap(HeatMap_${heatMap});`,
                '}',
                '#pragma include "heatMap.glsl"',
                'void main(void) {',
                '  gl_PointSize = PointSize;',
                '  computePointColor(litColor);',

                '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex.xyz, 1.0);',
                '}'
            ] );
        else
            vertexShader = vertexShader.concat( [
                'void main(void) {',
                '  gl_PointSize = PointSize;',
                '  litColor = Color;',
                '  gl_Position = uProjectionMatrix * uModelViewMatrix * vec4(Vertex.xyz, 1.0);',
                '}'
            ] );
        vertexShader = vertexShader.join( '\n' );
        return vertexShader;
    }

    static getFragmentShaderCircles() {
        let fragmentShader = [
            '',
            '#ifdef GL_ES',
            'precision highp float;',
            '#endif',

            'varying vec4 litColor;',

            'void main (void)',
            '{',
            '  vec2 coord =  -1.0 + 2.0 * gl_PointCoord.xy;',
            '  float d2  = dot(coord, coord);',
            '  if( d2 > 1.0)', //outside of circle
            '    discard;',

            // invisible objects
            '  if (litColor.a == 0.0)',
            '    discard;',
            '  vec4 finalColor = litColor;',
            '  gl_FragColor = finalColor;',
            '}'
        ];
        fragmentShader = fragmentShader.join( '\n' );
        return fragmentShader;
    }

    static _getSteppedValue( value, steps, tolerance, incSize ) {
        const stepSize = 1.0 / steps; // normalized between 0 and 1
        const fictizeStepSize = 1.0 / ( steps + 1 ); // color step values

        let modulus = tolerance % incSize;

        if ( Math.abs( modulus - incSize ) < 0.000001 ) // Sometimes there are precision issues with the division
            modulus = 0.0;

        const ratio = modulus !== 0.0 ? incSize / modulus : 0.0;

        const halfSteps = steps / 2.0;

        const modulusPonderated = 0.5 / ( ratio * ( halfSteps - 1.0 ) + 1.0 ) * ratio;

        let valueComputed = 0.0;
        // Initialize and condition should be constants. So I start at 0, and use a fictice max
        for ( let i = 1; i <= steps; i++ ) { // i should be started to 1

            if ( modulus !== 0.0 ) {
                if ( i > steps / 2 ) {
                    let modStep = i % halfSteps;
                    if ( Math.abs( modStep - ( steps / 2 ) ) < 0.000001 )
                        modStep = 0.0;

                    valueComputed = 0.5 - modStep * modulusPonderated;
                } else {
                    let modStep = ( steps - i ) % halfSteps;
                    if ( Math.abs( modStep - ( steps / 2 ) ) < 0.000001 )
                        modStep = 0.0;

                    valueComputed = 0.5 + modStep * modulusPonderated;
                }
            }

            if ( value >= ( modulus !== 0.0 ? valueComputed : stepSize * ( steps - i ) ) ) // original shader uses step function
                return fictizeStepSize * ( steps - i + 1 );
        }
        return fictizeStepSize; // 0.0
    }

    static _hsv2rgb( hsvColor ) {
        const K = [ 1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0 ];
        // compute fract glsl
        let auxVec = [ hsvColor[ 0 ] + K[ 0 ], hsvColor[ 0 ] + K[ 1 ], hsvColor[ 0 ] + K[ 2 ] ];
        const fract = [ auxVec[ 0 ] - Math.floor( auxVec[ 0 ] ), auxVec[ 1 ] - Math.floor( auxVec[ 1 ] ), auxVec[ 2 ] - Math.floor( auxVec[ 2 ] ) ];

        const p = [ Math.abs( fract[ 0 ] * 6.0 - K[ 3 ] ), Math.abs( fract[ 1 ] * 6.0 - K[ 3 ] ), Math.abs( fract[ 2 ] * 6.0 - K[ 3 ] ) ];
        // compute clamp glsl
        let auxVec2 = [ p[ 0 ] - K[ 0 ], p[ 1 ] - K[ 0 ], p[ 2 ] - K[ 0 ] ];
        let clamp = [
            Math.min( Math.max( auxVec2[ 0 ], 0.0 ), 1.0 ),
            Math.min( Math.max( auxVec2[ 1 ], 0.0 ), 1.0 ),
            Math.min( Math.max( auxVec2[ 2 ], 0.0 ), 1.0 )
        ];

        // compute mix glsl
        let mix = [
            K[ 0 ] * ( 1 - hsvColor[ 1 ] ) + clamp[ 0 ] * hsvColor[ 1 ],
            K[ 0 ] * ( 1 - hsvColor[ 1 ] ) + clamp[ 1 ] * hsvColor[ 1 ],
            K[ 0 ] * ( 1 - hsvColor[ 1 ] ) + clamp[ 2 ] * hsvColor[ 1 ]
        ];

        return [ hsvColor[ 2 ] * mix[ 0 ], hsvColor[ 2 ] * mix[ 1 ], hsvColor[ 2 ] * mix[ 2 ] ];
    }

    /**
     * Computes the color for a relative value according to the heatmap elevation shader (stepped policy) taking into account configuration arguments
     * @param {number} value relative between 0 and 1
     * @param {number} tolerance specified in meters
     * @param {number} incSize size increment for each step specified in meters
     */
    static computeColorHeatmapElevation( value, tolerance, incSize ) {
        const stepsFloat = tolerance / incSize;
        const steps = Math.ceil( stepsFloat );
        value = this._getSteppedValue( value, steps * 2, tolerance, incSize );
        value = 1.0 - value;
        const color = this._hsv2rgb( [ value * 0.7, 0.9, 0.9 ] );
        return `${color[0]*100}%, ${color[1]*100}%, ${color[2]*100}%`;
    }

    /**
     * From side.glsl original shader. Fragment shader for using just one screen side for drawing.
     */
    static generateSidesFragmentShader() {
        const sidesShader = [
            '  float clipPosX = ((gl_FragCoord.x / screenWidth) * 2.0) - 1.0;', // Transforming fragment coordinate into [-1, 1]
            '  if( (side == 0) || ((clipPosX <= sideDivider) && (side == 2)) || ((clipPosX > sideDivider) && (side == 1)) ){',
            '    discard;',
            '  }'
        ];
        return sidesShader;
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/TimeStampCache.js":
/*!**********************************************!*\
  !*** ./sources/pcvizUtils/TimeStampCache.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );

/**
 *  TimeStampCache to manage time access to cached objects
 *  @class
 *  @memberof pcvizUtils
 */
var TimeStampCache = {
    _cache: {},
    OBJECT_TYPES: [ 'layers', 'projects' ],
    MILLISECONDS_IN_WEEK: 604800000,

    init: function () {
        var dirtyCache = false;
        this.fetchCache();

        // Expired objects must be deleted from TimeStampCache
        for ( var key in this._cache )
            if ( this._cache[ key ] - Date.now() > this.MILLISECONDS_IN_WEEK ) {
                delete this._cache[ key ];
                dirtyCache = true;
            }
        if ( dirtyCache )
            localStorage.setItem( 'pcvizCache', JSON.stringify( this._cache ) );
    },

    fetchCache: function () {
        this._cache = {};
        if ( localStorage.getItem( 'pcvizCache' ) )
            this._cache = JSON.parse( localStorage.getItem( 'pcvizCache' ) );
    },

    getKeyForTimeStamp: function ( url ) {
        var key, start, length;

        if ( Utils.isRelativeURL( url ) )
            return url;

        this.OBJECT_TYPES.find( function ( objectType ) {
            start = url.indexOf( objectType );
            length = objectType.length + 1;
            return start !== -1;
        } );

        var end = url.indexOf( '/', start + length );
        if ( end !== -1 )
            key = url.slice( start, end );
        else
            key = url.slice( start );
        return key;
    },

    getTimeStamp: function ( url, cacheKey ) {
        var key = cacheKey || this.getKeyForTimeStamp( url );

        this.fetchCache();
        if ( !this._cache[ key ] ) {
            this.createTimeStamp( key );
        }
        return this._cache[ key ];
    },

    createTimeStamp: function ( key ) {
        this._cache[ key ] = Date.now();
        localStorage.setItem( 'pcvizCache', JSON.stringify( this._cache ) );
    },
};

TimeStampCache.init();

module.exports = TimeStampCache;


/***/ }),

/***/ "./sources/pcvizUtils/UpdateVisibilityVisitor.js":
/*!*******************************************************!*\
  !*** ./sources/pcvizUtils/UpdateVisibilityVisitor.js ***!
  \*******************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return UpdateVisibilityVisitor; });
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! OSG */ "./dependencies/OSG.js");
/* harmony import */ var OSG__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(OSG__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js");
/* harmony import */ var pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js");
/* harmony import */ var pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js");
/* harmony import */ var pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! pcvizUtils/Insider2D */ "./sources/pcvizUtils/Insider2D.js");






var osg = OSG__WEBPACK_IMPORTED_MODULE_0___default.a.osg;
var NodeVisitor = osg.NodeVisitor;


class UpdateVisibilityVisitor extends NodeVisitor {
    constructor() {
        super( NodeVisitor.TRAVERSE_ALL_CHILDREN );
        this._commitedInsidersList = [];
        this._temporalInsidersList = [];
    }

    apply( node ) {

        // Skip nodes without a Layer in the parent PLOD entity
        const nodePath = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getNodePathToParent( node, pcvizNode_PointCloudPLOD__WEBPACK_IMPORTED_MODULE_2___default.a );
        const pointCloudLayer = nodePath ? nodePath[ 0 ].Layer : undefined;
        if ( !pointCloudLayer ) {
            return;
        }

        // Just process geometries with the Visible attribute
        if ( node.getTypeID() === osg.Geometry.getTypeID() && node.getAttributes() && node.getAttributes().Visible ) {

            let parentId = pointCloudLayer.getId();
            if ( pointCloudLayer.getParent().getCategory() === pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].getCategoryProps( pcvizGIS_WorkspaceCategories__WEBPACK_IMPORTED_MODULE_3__["default"].Scan ).name ) {
                parentId = pointCloudLayer.getParent().getId();
            }

            this.applyGeometryVisibility( node, nodePath, parentId );
        }

        this.traverse( node );
    }

    applyGeometryVisibility( node, nodePath, parentId ) {
        const localMat = osg.computeLocalToWorld( nodePath );

        // Geometry bbox
        const geomBounding = pcvizDB_Utils__WEBPACK_IMPORTED_MODULE_1___default.a.getTransformedBoundingBox( node, localMat );

        // Filter insiders lists per colliding bboxes
        const temporalCollidingInsiders = this.filterByColliding( geomBounding, parentId, this._temporalInsidersList );
        const commitedCollidingInsiders = this.filterByCollidingPerRound( geomBounding, parentId, this._commitedInsidersList );

        if ( commitedCollidingInsiders.length === 0 && temporalCollidingInsiders.length === 0 ) {
            return; // Skip nodes that don't collide with insider bounding
        }

        const vertexBuffer = node.getAttributes().Vertex;
        const elements = vertexBuffer.getElements();

        const vertex = osg.vec3.create();

        let visibleElements = node.getAttributes().Visible.getElements();
        for ( let k = 0, l = elements.length; k < l; k += 3 ) {
            osg.vec3.set( vertex, elements[ k ], elements[ k + 1 ], elements[ k + 2 ] );
            osg.vec3.transformMat4( vertex, vertex, localMat );

            let isPointVisible = visibleElements[ k / 3 ] !== 2.0;
            if ( isPointVisible ) {
                if ( this.isReachedPerRound( vertex, parentId, commitedCollidingInsiders ) ) {
                    visibleElements[ k / 3 ] = 2.0; // Hide the point
                    continue;
                }

                if ( this.isReached( vertex, parentId, temporalCollidingInsiders ) ) { // The point can be hidden by the before insider list
                    visibleElements[ k / 3 ] = 1.0; // Select the point
                }
            }
        }

        node.getAttributes().Visible.dirty();
    }

    /**
     * Process a list of insiders to know if a point is reached by a the group of selections.
     * @method
     * @memberof pcvizUtils.UpdateVisibilityVisitor
     * @param point 3d point from a geometry
     * @param parentId pcvizNode.PointCloudPLOD parent id
     * @param insiderList pcvizUtils.Insider2D[]
     * @returns {Boolean} true if reached, false if not.
     */
    isReached( point, parentId, insidersList ) {
        let reached = false;
        for ( let insider of insidersList ) {
            reached = pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__["default"].isSelectedByInsider( point, parentId, insider, reached );
        }

        return reached;
    }

    isReachedPerRound( point, parentId, roundList ) {
        let result = false;
        for ( let round of roundList ) {
            result = result || this.isReached( point, parentId, round );
            if ( result ) {
                break;
            }
        }
        return result;
    }

    filterByColliding( bounding, parentID, list ) {
        // We can't filter by colliding intersect insider because they will be take into account by new geometries that didn't collide with them.
        const final = [];
        for ( let insider of list ) {
            if ( ( insider.getType() === pcvizUtils_Insider2D__WEBPACK_IMPORTED_MODULE_4__["INSIDER_TYPES"].INTERSECT && final.length !== 0 ) || insider.collideBoundingBox( bounding, parentID ) ) {
                final.push( insider );
            }
        }
        return final;
    }

    filterByCollidingPerRound( bounding, parentID, roundList ) {
        const result = [];
        for ( let round of roundList ) {
            const list = this.filterByColliding( bounding, parentID, round );
            if ( list.length > 0 ) {
                result.push( list );
            }
        }
        return result;
    }

    setCommitedInsiderList( commitedInsidersList ) {
        this._commitedInsidersList = commitedInsidersList;
    }

    setTemporalInsiderList( temporalInsidersList ) {
        this._temporalInsidersList = temporalInsidersList;
    }

    reset() {
        this._commitedInsidersList = [];
        this._temporalInsidersList = [];
    }
}


/***/ }),

/***/ "./sources/pcvizUtils/VectorLayerSelectionObject.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizUtils/VectorLayerSelectionObject.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var osg = OSG.osg;
var SelectionObject = __webpack_require__( /*! pcvizUtils/SelectionObject */ "./sources/pcvizUtils/SelectionObject.js" );

/**
 * Defines a container to access and store the properties of the selected VectorLayer and the selected Feature.
 * @class
 * @memberof pcvizUtils
 * @extends pcvizUtils.SelectionObject
 */
var VectorLayerSelectionObject = function () {
    SelectionObject.call( this );

    this._selectionType = SelectionObject.VectorLayer;
    this.setObject( 'features', [] );
};

VectorLayerSelectionObject.prototype = osg.objectInherit( SelectionObject.prototype, {

    /**
     * A helper function to set a vertex in the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @param {int} v The vertex.
     */
    setVertex: function ( v ) {
        this.setObject( 'vertex', v );
    },

    /**
     * A helper function to retrieve the vertex from the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @return {int} The vertex.
     */
    getVertex: function () {
        return this.getObject( 'vertex' );
    },

    /**
     * A helper function to set a feature in the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @param {Feature} layer The feature.
     */
    setFeature: function ( f ) {
        this.setObject( 'feature', f );
    },

    /**
     * A helper function to retrieve the feature from the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @return {Feature} The feature.
     */
    getFeature: function () {
        return this.getObject( 'feature' );
    },

    /**
     * A helper function to set a hit in the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @param {Object} hit The hit object.
     */
    setHit: function ( hit ) {
        this.setObject( 'hit', hit );
    },

    /**
     * A helper function to retrieve the hit from the selection object.
     * @method
     * @memberof pcvizUtils.VectorLayerSelectionObject
     * @return {Object} The hit object.
     */
    getHit: function () {
        return this.getObject( 'hit' );
    },

    addFeature: function ( feature ) {
        let found = this.getObject( 'features' ).find( ( f ) => {
            return f.getId() === feature.getId();
        } );
        found = found || this.getFeature().getId() === feature.getId();
        if ( found ) {
            console.warn( 'feature added previously' );
            return false;
        }
        this.getObject( 'features' ).push( feature );
        return true;
    },

    removeFeature: function ( index ) {
        this.getObject( 'features' ).splice( index, 1 );
    },

    getAllFeatures: function () {
        return this.getObject( 'features' );
    },

    clearAllFeatures: function () {
        this.setObject( 'features', [] );
    },

    /**
     * Clears the selection object.
     * @method
     * @memberof pcvizUtils.SelectionObject
     */
    clear: function () {
        SelectionObject.prototype.clear.call( this );
        this.setObject( 'features', [] );
    },

    initializePropertySet: function () {
        var self = this;

        this.clearProperties();

        this.addPropertyField( {
            id: 'feature',
            label: 'VECTOR_LAYER_SELECTION_OBJECT.FEATURE',
            type: 'Object',
            get: function () {
                return self.getFeature();
            }
        } );

        this.addPropertyField( {
            id: 'layer',
            label: 'VECTOR_LAYER_SELECTION_OBJECT.LAYER',
            type: 'Object',
            get: function () {
                return self.getLayer();
            }
        } );
    }

} );

module.exports = VectorLayerSelectionObject;


/***/ }),

/***/ "./sources/pcvizUtils/pcvizUtils.js":
/*!******************************************!*\
  !*** ./sources/pcvizUtils/pcvizUtils.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _PropertySet__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./PropertySet */ "./sources/pcvizUtils/PropertySet.js");
/* harmony import */ var _PropertySet__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_PropertySet__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _PointCollectorIntersector__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./PointCollectorIntersector */ "./sources/pcvizUtils/PointCollectorIntersector.js");
/* harmony import */ var _PointCollectorIntersector__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_PointCollectorIntersector__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _PointCollectorPolytopeIntersector__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./PointCollectorPolytopeIntersector */ "./sources/pcvizUtils/PointCollectorPolytopeIntersector.js");
/* harmony import */ var _PointCollectorPolytopeIntersector__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_PointCollectorPolytopeIntersector__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _PointCollectorSphereIntersector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./PointCollectorSphereIntersector */ "./sources/pcvizUtils/PointCollectorSphereIntersector.js");
/* harmony import */ var _PointCollectorSphereIntersector__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_PointCollectorSphereIntersector__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _PointCollectorLineIntersector__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PointCollectorLineIntersector */ "./sources/pcvizUtils/PointCollectorLineIntersector.js");
/* harmony import */ var _PointCollectorLineIntersector__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_PointCollectorLineIntersector__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SelectionObject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./SelectionObject */ "./sources/pcvizUtils/SelectionObject.js");
/* harmony import */ var _SelectionObject__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_SelectionObject__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _PointCloudSelectionObject__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./PointCloudSelectionObject */ "./sources/pcvizUtils/PointCloudSelectionObject.js");
/* harmony import */ var _PointCloudSelectionObject__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_PointCloudSelectionObject__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./VectorLayerSelectionObject */ "./sources/pcvizUtils/VectorLayerSelectionObject.js");
/* harmony import */ var _VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _RasterLayerSelectionObject__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./RasterLayerSelectionObject */ "./sources/pcvizUtils/RasterLayerSelectionObject.js");
/* harmony import */ var _RasterLayerSelectionObject__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_RasterLayerSelectionObject__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _LayerGroupSelectionObject__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./LayerGroupSelectionObject */ "./sources/pcvizUtils/LayerGroupSelectionObject.js");
/* harmony import */ var _LayerGroupSelectionObject__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_LayerGroupSelectionObject__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _CRSUtils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CRSUtils */ "./sources/pcvizUtils/CRSUtils.js");
/* harmony import */ var _CRSUtils__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_CRSUtils__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _MagnetAPI__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js");
/* harmony import */ var _MagnetAPI__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_MagnetAPI__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _TimeStampCache__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./TimeStampCache */ "./sources/pcvizUtils/TimeStampCache.js");
/* harmony import */ var _TimeStampCache__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_TimeStampCache__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _EigenAxis__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./EigenAxis */ "./sources/pcvizUtils/EigenAxis.js");
/* harmony import */ var _EigenAxis__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_EigenAxis__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _FindGeometryVisitor__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./FindGeometryVisitor */ "./sources/pcvizUtils/FindGeometryVisitor.js");
/* harmony import */ var _FindGeometryVisitor__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_FindGeometryVisitor__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _ImageUtils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./ImageUtils */ "./sources/pcvizUtils/ImageUtils.js");
/* harmony import */ var _ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./ComputeBoundingVisitor */ "./sources/pcvizUtils/ComputeBoundingVisitor.js");
/* harmony import */ var _ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _Insider2D__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./Insider2D */ "./sources/pcvizUtils/Insider2D.js");
/* harmony import */ var _SelectionVisibilityVisitor__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./SelectionVisibilityVisitor */ "./sources/pcvizUtils/SelectionVisibilityVisitor.js");
/* harmony import */ var _UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./UpdateVisibilityVisitor */ "./sources/pcvizUtils/UpdateVisibilityVisitor.js");
/* harmony import */ var _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./PointVisibilityVisitor */ "./sources/pcvizUtils/PointVisibilityVisitor.js");
/* harmony import */ var _PointVisibleCollector__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./PointVisibleCollector */ "./sources/pcvizUtils/PointVisibleCollector.js");
/* harmony import */ var _HighlightScans__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./HighlightScans */ "./sources/pcvizUtils/HighlightScans.js");
/* harmony import */ var _MathUtils__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./MathUtils */ "./sources/pcvizUtils/MathUtils.js");
/* harmony import */ var _EventKeys__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./EventKeys */ "./sources/pcvizUtils/EventKeys.js");
/* harmony import */ var _ShaderUtils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./ShaderUtils */ "./sources/pcvizUtils/ShaderUtils.js");
/* harmony import */ var _SegmentationConstants__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./SegmentationConstants */ "./sources/pcvizUtils/SegmentationConstants.js");






























/** @namespace pcvizUtils */
const pcvizUtils = {
    PropertySet: (_PropertySet__WEBPACK_IMPORTED_MODULE_0___default()),
    PointCollectorIntersector: (_PointCollectorIntersector__WEBPACK_IMPORTED_MODULE_1___default()),
    PointCollectorPolytopeIntersector: (_PointCollectorPolytopeIntersector__WEBPACK_IMPORTED_MODULE_2___default()),
    PointCollectorSphereIntersector: (_PointCollectorSphereIntersector__WEBPACK_IMPORTED_MODULE_3___default()),
    PointCollectorLineIntersector: (_PointCollectorLineIntersector__WEBPACK_IMPORTED_MODULE_4___default()),
    SelectionObject: (_SelectionObject__WEBPACK_IMPORTED_MODULE_5___default()),
    PointCloudSelectionObject: (_PointCloudSelectionObject__WEBPACK_IMPORTED_MODULE_6___default()),
    VectorLayerSelectionObject: (_VectorLayerSelectionObject__WEBPACK_IMPORTED_MODULE_7___default()),
    RasterLayerSelectionObject: (_RasterLayerSelectionObject__WEBPACK_IMPORTED_MODULE_8___default()),
    LayerGroupSelectionObject: (_LayerGroupSelectionObject__WEBPACK_IMPORTED_MODULE_9___default()),
    CRSUtils: (_CRSUtils__WEBPACK_IMPORTED_MODULE_10___default()),
    MagnetAPI: (_MagnetAPI__WEBPACK_IMPORTED_MODULE_11___default()),
    TimeStampCache: (_TimeStampCache__WEBPACK_IMPORTED_MODULE_12___default()),
    EigenAxis: (_EigenAxis__WEBPACK_IMPORTED_MODULE_13___default()),
    FindGeometryVisitor: (_FindGeometryVisitor__WEBPACK_IMPORTED_MODULE_14___default()),
    ImageUtils: _ImageUtils__WEBPACK_IMPORTED_MODULE_15__["default"],
    ComputeBoundingVisitor: (_ComputeBoundingVisitor__WEBPACK_IMPORTED_MODULE_16___default()),
    Insider2D: _Insider2D__WEBPACK_IMPORTED_MODULE_17__["default"],
    INSIDER_TYPES: _Insider2D__WEBPACK_IMPORTED_MODULE_17__["INSIDER_TYPES"],
    SelectionVisibilityVisitor: _SelectionVisibilityVisitor__WEBPACK_IMPORTED_MODULE_18__["default"],
    UpdateVisibilityVisitor: _UpdateVisibilityVisitor__WEBPACK_IMPORTED_MODULE_19__["default"],
    PointVisibilityVisitor: _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_20__["default"],
    POINT_MODES: _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_20__["POINT_MODES"],
    POINT_VISIBILITY_FLAGS: _PointVisibilityVisitor__WEBPACK_IMPORTED_MODULE_20__["POINT_VISIBILITY_FLAGS"],
    PointVisibleCollector: _PointVisibleCollector__WEBPACK_IMPORTED_MODULE_21__["default"],
    COLLECT_POINT_MODES: _PointVisibleCollector__WEBPACK_IMPORTED_MODULE_21__["COLLECT_POINT_MODES"],
    HighlightScans: _HighlightScans__WEBPACK_IMPORTED_MODULE_22__["default"],
    MathUtils: _MathUtils__WEBPACK_IMPORTED_MODULE_23__["default"],
    EVENT_KEYS: _EventKeys__WEBPACK_IMPORTED_MODULE_24__["EVENT_KEYS"],
    ShaderUtils: _ShaderUtils__WEBPACK_IMPORTED_MODULE_25__["default"],
    SEGMENTATION_LABELS: _SegmentationConstants__WEBPACK_IMPORTED_MODULE_26__["SEGMENTATION_LABELS"]
};

/* harmony default export */ __webpack_exports__["default"] = (pcvizUtils);


/***/ }),

/***/ "./sources/pcvizViewer/ShaderCompiler.js":
/*!***********************************************!*\
  !*** ./sources/pcvizViewer/ShaderCompiler.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 *  Author:
 *  Jordi torres <jordi.torres@mirage-tech.com>
 */


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );

var GeometryTypeAttribute = __webpack_require__( /*! pcvizNode/GeometryTypeAttribute */ "./sources/pcvizNode/GeometryTypeAttribute.js" );
var DrawingRuleAttribute = __webpack_require__( /*! pcvizNode/DrawingRuleAttribute */ "./sources/pcvizNode/DrawingRuleAttribute.js" );
var BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );

var osg = OSG.osg;
var osgShader = OSG.osgShader;

/**
 * ShaderCompiler
 * @class
 * @memberof pcvizViewer
 */

var ShaderCompiler = function () {
    osgShader.Compiler.apply( this, arguments );
};


// make the ShaderGenerator accept new Attributes
// we use same attributes than the default compiler
var config = osgShader.Compiler.cloneStateAttributeConfig( osgShader.Compiler );
config.attribute.push( 'PointCloudPointSize' );
config.attribute.push( 'GeometryType' );
config.attribute.push( 'DrawingRule' );
config.attribute.push( 'PointEdition' );
config.attribute.push( 'TileUniforms' );
config.attribute.push( 'ElementID' );
config.attribute.push( 'Lighting' );
config.attribute.push( 'Buffer' );
config.attribute.push( 'Side' );
osgShader.Compiler.setStateAttributeConfig( ShaderCompiler, config );


ShaderCompiler.prototype = osg.objectInherit( osgShader.Compiler.prototype, {

    declareVertexMain: function () {
        // the mandatory output is glPosition
        var glPosition = this.getNode( 'glPosition' );

        // The shader graph can have multiple outputs (glPointsize, varyings)
        // here named roots
        // all outputs must be pushed inside
        var roots = [];

        this.declareScreenVertex( glPosition );
        // Calculate RotationNormal for Splats if needed
        var geometryTypeAttribute = this.getAttributeType( 'GeometryType' );
        if ( geometryTypeAttribute && geometryTypeAttribute.getGeometryType() === GeometryTypeAttribute.SPLAT ) {

            this.getNode( 'GeometryTypeVertex' ).inputs( {
                Normal: this.getOrCreateAttribute( 'vec3', 'Normal' ),
                uModelViewMatrix: this.getOrCreateUniform( 'mat4', 'uModelViewMatrix' ),
            } ).outputs( {
                RotNormal: this.getOrCreateVarying( 'vec3', 'RotNormal' )
            } );
        }

        var tileUniformsAttribute = this.getAttributeType( 'TileUniforms' );

        // Calculate PointColor here in the vertex shader.
        var drawingRuleAttribute = this.getAttributeType( 'DrawingRule' );
        if ( drawingRuleAttribute ) {
            this.configureDrawingRuleNode( drawingRuleAttribute, tileUniformsAttribute );
        }

        // Buffer
        var bufferToolAttribute = this.getAttributeType( 'Buffer' );
        if ( bufferToolAttribute ) {
            this.configureBufferNode( bufferToolAttribute, tileUniformsAttribute );
        }

        // Lighting
        var lightingAttribute = this.getAttributeType( 'Lighting' );
        if ( lightingAttribute ) {
            roots.push( this.getOrCreateLocalNormal() ); // lighting requires normals
            this.getNode( 'Lighting' ).inputs( {} ).outputs( {
                VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
            } );
        }

        // Generate PointSize code.
        var glPointSize = this.getNode( 'glPointSize' );
        var pointSizeAttribute = this.getAttributeType( 'PointCloudPointSize' );
        if ( pointSizeAttribute ) {

            this.getNode( 'PointCloudPointSize' ).inputs( {
                fragEyeVec: this.getOrCreateViewVertex(),
                distance: this.getOrCreateAttribute( 'float', 'Distance' ),
                maxDistance: this.getOrCreateUniform( pointSizeAttribute.getOrCreateUniforms().maxDistance ),
                levelFactor: this.getOrCreateUniform( tileUniformsAttribute.getOrCreateUniforms().levelFactor ),
                sizeFactor: this.getOrCreateUniform( pointSizeAttribute.getOrCreateUniforms().sizeFactor ),
                devicePixelRatio: this.getOrCreateUniform( pointSizeAttribute.getOrCreateUniforms().devicePixelRatio ),
                pointSize: this.getOrCreateUniform( pointSizeAttribute.getOrCreateUniforms().pointSize ),
                enable: this.getOrCreateUniform( pointSizeAttribute.getOrCreateUniforms().enable )
            } ).outputs( {
                glPointsize: glPointSize
            } );
        }

        // PointEdition
        var pointEditionAttribute = this.getAttributeType( 'PointEdition' );
        if ( pointEditionAttribute ) {
            this.getNode( 'PointEditionVertex' ).inputs( {
                Visible: this.getOrCreateAttribute( 'float', 'Visible' ),
                selectColor: this.getOrCreateUniform( pointEditionAttribute.getOrCreateUniforms().selectColor )
            } ).outputs( {
                VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
            } );
        }

        // Side by side
        const sideAttribute = this.getAttributeType( 'Side' );
        if ( sideAttribute ) {
            this.getNode( 'SideVertex' ).inputs( {
                glPosition: glPosition,
                side: this.getOrCreateUniform( sideAttribute.getOrCreateUniforms().side ),
                sideDivider: this.getOrCreateUniform( sideAttribute.getOrCreateUniforms().sideDivider ),
            } ).outputs( {
                VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
            } );
        }

        this.configureVertexElementIDNode();

        // Point Size
        roots.push( glPointSize );

        // Because of a weird bug on iOS
        // glPosition should be computed in the vertex shader before some varyings
        roots.push( glPosition );

        this.declareVertexVaryings( roots );

        return roots;
    },

    createFragmentShaderGraph: function () {

        // shader graph can have multiple output (glPointsize, varyings)
        // here named roots
        // all outputs must be pushed inside
        var roots = [];

        // no material then return a default shader
        if ( !this._material ) {
            roots.push( this.createDefaultFragmentShaderGraph() );
            return roots;
        }

        // Geometry Type
        var geometryTypeAttribute = this.getAttributeType( 'GeometryType' );
        if ( geometryTypeAttribute ) {
            var dist = this.createVariable( 'float', 'dist' );
            var geometryNode = this.getNode( 'GeometryTypeFragment' );
            geometryNode.setGeometryType( geometryTypeAttribute.getGeometryType() );

            var inputs = {};
            if ( geometryTypeAttribute.getGeometryType() === GeometryTypeAttribute.SPLAT )
                inputs = {
                    RotNormal: this.getOrCreateVarying( 'vec3', 'RotNormal' )
                };

            // Set geometryNode
            geometryNode.inputs( inputs ).outputs( {
                dist: dist,
                //spriteColor: spriteColor
            } );
            roots.push( geometryNode );
        }

        var diffuseColor = this.getOrCreateVarying( 'vec4', 'VertexColor' );
        roots.push( diffuseColor );

        // compute alpha
        var alpha = this.getOrCreateUniform( 'float', 'alpha' );
        //Discard fragments totally transparents when rendering billboards
        var alphaCompute = 'if ( %alpha == 0.0 || %color.a == 0.0 ) discard;';

        this.getNode( 'InlineCode' ).code( alphaCompute ).inputs( {
            color: diffuseColor
        } ).outputs( {
            alpha: alpha
        } );


        var fragColor = this.getNode( 'glFragColor' );
        var finalColor = diffuseColor;
        this.getNode( 'SetAlpha' ).inputs( {
            color: finalColor,
            alpha: alpha
        } ).outputs( {
            result: fragColor
        } );

        roots.push( fragColor );

        return roots;
    },


    configureBufferNode: function ( bufferAttribute, tileUniformsAttribute ) {

        var bufferNode = this.getNode( 'Buffer' );
        bufferNode.setBufferAttribute( bufferAttribute );
        var uniforms = bufferAttribute.getOrCreateUniforms();
        var inputs = {
            minColor: this.getOrCreateUniform( uniforms.minColor ),
            maxColor: this.getOrCreateUniform( uniforms.maxColor ),
            range: this.getOrCreateUniform( uniforms.range ),
            useBaseColor: this.getOrCreateUniform( uniforms.useBaseColor ),
            onlyBuffer: this.getOrCreateUniform( uniforms.onlyBuffer ),
            tileOrigin: this.getOrCreateUniform( tileUniformsAttribute.getOrCreateUniforms().tileOrigin ),
        };

        switch ( bufferAttribute.getBufferMode() ) {
        case BufferAttribute.POINT:
            inputs.pointBuffer = this.getOrCreateUniform( uniforms.pointBuffer );
            break;
        case BufferAttribute.LINE:
        case BufferAttribute.VERTICAL_LINE:
            var lineBuffer = this.getOrCreateUniform( 'vec3', 'lineBuffer', 50 );
            inputs.lineBuffer = lineBuffer;
            inputs.numBufferVertices = this.getOrCreateUniform( uniforms.numBufferVertices );
            break;
        case BufferAttribute.BOX:
            inputs.pointBuffer = this.getOrCreateUniform( uniforms.pointBuffer );
            inputs.auxMat = this.getOrCreateUniform( uniforms.auxMat );
            inputs.boxMin = this.getOrCreateUniform( uniforms.boxMin );
            inputs.boxMax = this.getOrCreateUniform( uniforms.boxMax );
            inputs.boxRotation = this.getOrCreateUniform( uniforms.boxRotation );
            var lineBufferBox = this.getOrCreateUniform( 'vec3', 'lineBuffer', 50 );
            inputs.lineBuffer = lineBufferBox;
            break;
        }
        bufferNode.inputs( inputs );
        bufferNode.outputs( {
            VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
        } );
        return bufferNode;
    },

    configureDrawingRuleNode: function ( drawingRuleAttribute, tileUniformsAttribute ) {
        var drawingRuleNode = this.getNode( 'DrawingRule' );
        drawingRuleNode.setDrawingRuleAttribute( drawingRuleAttribute );
        var inputs;
        var uniforms = drawingRuleAttribute.getOrCreateUniforms();
        switch ( drawingRuleAttribute.getDrawingRule() ) {
        case DrawingRuleAttribute.RGB:
            inputs = {
                Color: this.getOrCreateAttribute( 'vec4', 'Color' ),
            };
            break;
        case DrawingRuleAttribute.INTENSITY:
        case DrawingRuleAttribute.INTENS_COLOR:
            inputs = {
                Intensity: this.getOrCreateAttribute( 'float', 'Intensity' ),
                maxIntensity: this.getOrCreateUniform( uniforms.maxIntensity ),
                minIntensity: this.getOrCreateUniform( uniforms.minIntensity )
            };
            break;
        case DrawingRuleAttribute.ELEVATION:
            inputs = {
                maxZ: this.getOrCreateUniform( uniforms.maxZ ),
                minZ: this.getOrCreateUniform( uniforms.minZ ),
                dataCenter: this.getOrCreateUniform( uniforms.dataCenter ),
                repeatRange: this.getOrCreateUniform( uniforms.repeatRange ),
                tileOrigin: this.getOrCreateUniform( tileUniformsAttribute.getOrCreateUniforms().tileOrigin )
            };
            break;
        case DrawingRuleAttribute.HEATMAP_ELEVATION:
            inputs = {
                maxZ: this.getOrCreateUniform( uniforms.maxZ ),
                minZ: this.getOrCreateUniform( uniforms.minZ ),
                dataCenter: this.getOrCreateUniform( uniforms.dataCenter ),
                repeatRange: this.getOrCreateUniform( uniforms.repeatRange ),
                tileOrigin: this.getOrCreateUniform( tileUniformsAttribute.getOrCreateUniforms().tileOrigin ),
                refElevation: this.getOrCreateUniform( uniforms.refElevation ),
                hideAboveBelow: this.getOrCreateUniform( uniforms.hideAboveBelow ),
                hideAboveBelowSize: this.getOrCreateUniform( uniforms.hideAboveBelowSize ),
                incSize: this.getOrCreateUniform( uniforms.incSize ),
                tolerance: this.getOrCreateUniform( uniforms.tolerance ),
                elevationPolicy: this.getOrCreateUniform( uniforms.elevationPolicy ),
                dataMT: this.getOrCreateUniform( uniforms.dataMT ),
                planeNormal: this.getOrCreateUniform( uniforms.planeNormal ),
                planeConstant: this.getOrCreateUniform( uniforms.planeConstant )
            };
            break;
        case DrawingRuleAttribute.FIXED_COLOR:
            inputs = {
                fixedColor: this.getOrCreateUniform( uniforms.fixedColor )
            };
            break;
        case DrawingRuleAttribute.CLASSIFICATION:
            inputs = {};
            break;
        case DrawingRuleAttribute.CATEGORIZED:
            inputs = {

                Intensity: this.getOrCreateAttribute( 'float', 'Intensity' ),
                maxIntensity: this.getOrCreateUniform( uniforms.maxIntensity ),
                minIntensity: this.getOrCreateUniform( uniforms.minIntensity ),
                maxZ: this.getOrCreateUniform( uniforms.maxZ ),
                minZ: this.getOrCreateUniform( uniforms.minZ ),
                dataCenter: this.getOrCreateUniform( uniforms.dataCenter ),
                tileOrigin: this.getOrCreateUniform( tileUniformsAttribute.getOrCreateUniforms().tileOrigin ),
                classificationColorArray: this.getOrCreateUniform( uniforms.classificationColorArray.getType(), uniforms.classificationColorArray.getName(), uniforms.classificationColorArray.getInternalArray().length ),
                drawingRuleArray: this.getOrCreateUniform( uniforms.drawingRuleArray.getType(), uniforms.drawingRuleArray.getName(), uniforms.drawingRuleArray.getInternalArray().length ),
                Color: this.getOrCreateAttribute( 'vec4', 'Color' ),
            };
            break;
        case DrawingRuleAttribute.HEATMAP:
            var numHeatMaps = drawingRuleAttribute.getNumHeatMaps();
            var heatMap = 'HeatMap_' + drawingRuleAttribute.getHeatMap().toString();
            inputs = {
                Color: this.getOrCreateAttribute( 'vec4', 'Color' )
            };
            if ( numHeatMaps > 0 ) {
                inputs[ heatMap ] = this.getOrCreateAttribute( 'float', heatMap );
            }
            break;
        }

        // Common uniforms
        inputs.Classification = this.getOrCreateAttribute( 'float', 'Classification' );
        inputs.activeClassification = this.getOrCreateUniform( uniforms.activeClassification.getType(), uniforms.activeClassification.getName(), uniforms.activeClassification.getInternalArray().length );

        drawingRuleNode.inputs( inputs );
        drawingRuleNode.outputs( {
            VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
        } );
        return drawingRuleNode;
    },

    configureVertexElementIDNode: function () {
        var elementIDAttribute = this.getAttributeType( 'ElementID' );
        if ( !elementIDAttribute )
            return;
        var elementIDNode = this.getNode( 'ElementIDVertexNode' );
        if ( !elementIDNode )
            return;
        var elementIDUniforms = elementIDAttribute.getOrCreateUniforms();
        var inputs = {
            ElementID: this.getOrCreateAttribute( 'float', 'ElementID' ),
            selectedElementID: this.getOrCreateUniform( elementIDUniforms.selectedElementID )
        };
        var outputs = {
            VertexColor: this.getOrCreateVarying( 'vec4', 'VertexColor' )
        };
        elementIDNode.inputs( inputs );
        elementIDNode.outputs( outputs );
        return elementIDNode;
    }

} );

module.exports = ShaderCompiler;


/***/ }),

/***/ "./sources/pcvizViewer/ShaderLib.js":
/*!******************************************!*\
  !*** ./sources/pcvizViewer/ShaderLib.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

const geometry = __webpack_require__( /*! pcvizViewer/shaders/geometry.glsl */ "./sources/pcvizViewer/shaders/geometry.glsl" );
const splat = __webpack_require__( /*! pcvizViewer/shaders/splat.glsl */ "./sources/pcvizViewer/shaders/splat.glsl" );
const utils = __webpack_require__( /*! pcvizViewer/shaders/utils.glsl */ "./sources/pcvizViewer/shaders/utils.glsl" );
const vertex = __webpack_require__( /*! pcvizViewer/shaders/vertex.glsl */ "./sources/pcvizViewer/shaders/vertex.glsl" );
const fragment = __webpack_require__( /*! pcvizViewer/shaders/fragment.glsl */ "./sources/pcvizViewer/shaders/fragment.glsl" );
const rgb = __webpack_require__( /*! pcvizViewer/shaders/rgb.glsl */ "./sources/pcvizViewer/shaders/rgb.glsl" );
const intensity = __webpack_require__( /*! pcvizViewer/shaders/intensity.glsl */ "./sources/pcvizViewer/shaders/intensity.glsl" );
const intensityColor = __webpack_require__( /*! pcvizViewer/shaders/intensitycolor.glsl */ "./sources/pcvizViewer/shaders/intensitycolor.glsl" );
const classification = __webpack_require__( /*! pcvizViewer/shaders/classification.glsl */ "./sources/pcvizViewer/shaders/classification.glsl" );
const elevation = __webpack_require__( /*! pcvizViewer/shaders/elevation.glsl */ "./sources/pcvizViewer/shaders/elevation.glsl" );
const drawingrule = __webpack_require__( /*! pcvizViewer/shaders/categorized.glsl */ "./sources/pcvizViewer/shaders/categorized.glsl" );
const fixedcolor = __webpack_require__( /*! pcvizViewer/shaders/fixedcolor.glsl */ "./sources/pcvizViewer/shaders/fixedcolor.glsl" );
const lighting = __webpack_require__( /*! pcvizViewer/shaders/lighting.glsl */ "./sources/pcvizViewer/shaders/lighting.glsl" );
const bufferPoint = __webpack_require__( /*! pcvizViewer/shaders/bufferPoint.glsl */ "./sources/pcvizViewer/shaders/bufferPoint.glsl" );
const bufferLine = __webpack_require__( /*! pcvizViewer/shaders/bufferLine.glsl */ "./sources/pcvizViewer/shaders/bufferLine.glsl" );
const bufferVerticalLine = __webpack_require__( /*! pcvizViewer/shaders/bufferVerticalLine.glsl */ "./sources/pcvizViewer/shaders/bufferVerticalLine.glsl" );
const bufferBox = __webpack_require__( /*! pcvizViewer/shaders/bufferBox.glsl */ "./sources/pcvizViewer/shaders/bufferBox.glsl" );
const heatMap = __webpack_require__( /*! pcvizViewer/shaders/heatMap.glsl */ "./sources/pcvizViewer/shaders/heatMap.glsl" );
const selected = __webpack_require__( /*! pcvizViewer/shaders/selected.glsl */ "./sources/pcvizViewer/shaders/selected.glsl" );
const heatmapElevation = __webpack_require__( /*! pcvizViewer/shaders/heatmapElevation.glsl */ "./sources/pcvizViewer/shaders/heatmapElevation.glsl" );
const verityHeatmap = __webpack_require__( /*! pcvizViewer/shaders/verityHeatmap.glsl */ "./sources/pcvizViewer/shaders/verityHeatmap.glsl" );
const side = __webpack_require__( /*! pcvizViewer/shaders/side.glsl */ "./sources/pcvizViewer/shaders/side.glsl" );

module.exports = {
    'geometry.glsl': geometry,
    'splat.glsl': splat,
    'utils.glsl': utils,
    'vertex.glsl': vertex,
    'fragment.glsl': fragment,
    'rgb.glsl': rgb,
    'intensity.glsl': intensity,
    'intensitycolor.glsl': intensityColor,
    'classification.glsl': classification,
    'elevation.glsl': elevation,
    'categorized.glsl': drawingrule,
    'fixedcolor.glsl': fixedcolor,
    'lighting.glsl': lighting,
    'bufferPoint.glsl': bufferPoint,
    'bufferLine.glsl': bufferLine,
    'bufferVerticalLine.glsl': bufferVerticalLine,
    'bufferBox.glsl': bufferBox,
    'heatMap.glsl': heatMap,
    'selected.glsl': selected,
    'heatmapElevation.glsl': heatmapElevation,
    'verityHeatmap.glsl': verityHeatmap,
    'side.glsl': side
};


/***/ }),

/***/ "./sources/pcvizViewer/Viewer.js":
/*!***************************************!*\
  !*** ./sources/pcvizViewer/Viewer.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var OSG = __webpack_require__( /*! OSG */ "./dependencies/OSG.js" );
var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var PointCloudPLOD = __webpack_require__( /*! pcvizNode/PointCloudPLOD */ "./sources/pcvizNode/PointCloudPLOD.js" );
var SceneNode = __webpack_require__( /*! pcvizNode/SceneNode */ "./sources/pcvizNode/SceneNode.js" );
var BufferAttribute = __webpack_require__( /*! pcvizNode/BufferAttribute */ "./sources/pcvizNode/BufferAttribute.js" );
const DrawingRuleAttribute = __webpack_require__( /*! pcvizNode/DrawingRuleAttribute */ "./sources/pcvizNode/DrawingRuleAttribute.js" );
var ShaderCompiler = __webpack_require__( /*! pcvizViewer/ShaderCompiler */ "./sources/pcvizViewer/ShaderCompiler.js" );
var ShaderLib = __webpack_require__( /*! pcvizViewer/ShaderLib */ "./sources/pcvizViewer/ShaderLib.js" );
const pcvizManipulator = __webpack_require__( /*! pcvizManipulator/pcvizManipulator */ "./sources/pcvizManipulator/pcvizManipulator.js" );
var FirstPersonManipulator = __webpack_require__( /*! pcvizManipulator/FirstPersonManipulator */ "./sources/pcvizManipulator/FirstPersonManipulator.js" );
var ImageManipulator = __webpack_require__( /*! pcvizManipulator/ImageManipulator */ "./sources/pcvizManipulator/ImageManipulator.js" );
var Utils = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );

var FlyToTool = __webpack_require__( /*! pcvizTools/FlyToTool */ "./sources/pcvizTools/FlyToTool.js" );
var Hammer = __webpack_require__( /*! hammerjs */ "./node_modules/hammerjs/hammer.js" );
var Polygon = __webpack_require__( /*! pcvizGIS/Polygon */ "./sources/pcvizGIS/Polygon.js" ).default;
var Point = __webpack_require__( /*! pcvizGIS/Point */ "./sources/pcvizGIS/Point.js" ).default;
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var FindGeometryVisitor = __webpack_require__( /*! pcvizUtils/FindGeometryVisitor */ "./sources/pcvizUtils/FindGeometryVisitor.js" );
var EigenAxis = __webpack_require__( /*! pcvizUtils/EigenAxis */ "./sources/pcvizUtils/EigenAxis.js" );
var Envelope = __webpack_require__( /*! pcvizGIS/Envelope */ "./sources/pcvizGIS/Envelope.js" ).default;
var CADManipulator = __webpack_require__( /*! pcvizManipulator/CADManipulator */ "./sources/pcvizManipulator/CADManipulator.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );

var ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );

var osg = OSG.osg;
var osgViewer = OSG.osgViewer;
var osgUtil = OSG.osgUtil;
var osgShader = OSG.osgShader;
var osgDB = OSG.osgDB;
var osgStats = OSG.osgStats;

const ON_DEMAND_MAX_TIME = 5000;

/**
 *  Viewer
 *  @class
 *  @memberof pcvizViewer
 */
var Viewer = function ( canvas, userOptions, error ) {
    // Force hammer initialization. "ontouchstart" does not work on Windows with touch screens and osg detects touch
    // screens using it
    const options = Object.assign( {
        EventBackend: {
            Hammer: {
                eventNode: canvas
            }
        }
    }, userOptions );

    osgViewer.Viewer.call( this, canvas, options, error );

    this._canvas = canvas;
    //this.setLightingMode( osgViewer.View.LightingMode.SKY_LIGHT );
    this._pickingActive = false;
    this._pi = new osgUtil.PolytopeIntersector();
    this._pi.setPrimitiveMask( osgUtil.ALL_PRIMITIVES );
    this._pi.setIntersectionLimit( osgUtil.LIMIT_ONE_PER_DRAWABLE );

    this._ivTools = new osgUtil.IntersectionVisitor();
    this._ivTools.setTraversalMask( Utils.TRAVERSAL_MASK_IV );
    this._ivTools.setIntersector( this._pi );
    this.setUpIntersector( this._ivTools );

    this._isDragging = false;
    this.setFOV( 35.0 );
    this._pointCloudScene = undefined;
    this._toolsNode = undefined;
    this._edlSwitchNode = undefined;
    this._edlNode = undefined;
    this._hudNode = undefined;
    this._arrayTools = [];

    this._center = undefined;

    this._cadManipulator = undefined;
    this._panoramaManipulator = undefined;
    this._planarImageManipulator = undefined;
    this._dblclickCADManipulatorFn = undefined;

    this._lastFrameTime = undefined;
    this._pointBoundingRadius = 2.0;

    this._polytopeSize = 5.0 * window.devicePixelRatio;
    this._pixelRatio = window.devicePixelRatio;

    this.init();

    this._latestTap = undefined;

    this._dblclickRemoveSelectionFunction = function () {
        Utils.removeBrowserSelection();
    };

    this._flyTo = new FlyToTool( this );
    this._manipulatorEnabled = true;

    var self = this;

    this._dblclickFlyToFunction = function ( ev ) {
        if ( self._ortho )
            return;
        Utils.removeBrowserSelection();

        if ( !( self._manipulator instanceof CADManipulator ) ) {
            self.stopFlyTo();
            return;
        }

        var hits = self.computePolytopeIntersections( ev );
        if ( !hits.length )
            return;

        self._manipulatorEnabled = false;
        var point = hits[ 0 ]._localIntersectionPoint;
        hits[ 0 ]._nodePath.shift();
        var matrix = osg.computeLocalToWorld( hits[ 0 ]._nodePath );
        var pTrans = osg.vec3.create();
        osg.vec3.transformMat4( pTrans, point, matrix );

        var viewMatrix = self.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        var vectorDistance = osg.vec3.create();
        osg.vec3.sub( vectorDistance, pTrans, eye );
        var vectorDistanceScaled = osg.vec3.create();

        osg.vec3.scale( vectorDistanceScaled, vectorDistance, 0.85 );

        var finalPosition = osg.vec3.create();
        osg.vec3.add( finalPosition, eye, vectorDistanceScaled );

        self._flyTo.setFlyParameters( finalPosition, undefined, 1.0, function () {
            self._manipulatorEnabled = true;
            self._cadManipulator.setPivotPoint( pTrans );
        } );
        self._flyTo.setActive( true );
    };


    this._sceneView = undefined;

    this._zoomLayer = undefined;
    this._zoomFeature = undefined;
    this._zoomExtent = undefined;
    this._zoomOptions = undefined;
    this._zoomSavedView = undefined;

    // ortho manipulator
    this._ortho = false;
    this._firstZoom = true;

    this._imageModeByUrl = false;

    // only for edge
    this._enableTouchController = false;

    this._lastEventTime = window.performance.now();


    // disabling continous update
    this._requestContinousUpdate = false;

    this._fpsCounter = new osgStats.Counter( {
        caption: 'fpsForLOD',
        average: true,
        avgMs: 3000
    } );

    this._LODfactor = 2.8 / 50;

    this._automaticLOD = Registry.getController( 'UserPreferences' ).getPreference( Utils.AUTOMATIC_LOD_KEY );

    Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.AUTOMATIC_LOD_KEY, ( value ) => {
        this._automaticLOD = value;
    } );

};


Viewer.prototype = osg.objectInherit( osgViewer.Viewer.prototype, {

    init: function () {
        osgViewer.Viewer.prototype.init.call( this );
        this.installCustomShaders();
        this.configureFrameOnDemandListeners( window );
        this._canvas.addEventListener( 'dblclick', this._dblclickFlyToFunction, true );
    },

    requestRedraw: function () {
        this._lastEventTime = window.performance.now();
        this._requestRedraw = true;
    },

    configureFrameOnDemandListeners: function ( parent ) {
        this._lastEventTime = window.performance.now();

        parent.addEventListener( 'mousemove', () => this.requestRedraw() );
        parent.addEventListener( 'click', () => this.requestRedraw() );
        parent.addEventListener( 'scroll', () => this.requestRedraw() );
        parent.addEventListener( 'dblclick', () => this.requestRedraw() );
        parent.addEventListener( 'mousedown', () => this.requestRedraw() );
        parent.addEventListener( 'mouseup', () => this.requestRedraw() );
        parent.addEventListener( 'mouseover', () => this.requestRedraw() );
        parent.addEventListener( 'mouseout', () => this.requestRedraw() );
        parent.addEventListener( 'mouseenter', () => this.requestRedraw() );
        parent.addEventListener( 'mouseleave', () => this.requestRedraw() );
        parent.addEventListener( 'wheel', () => this.requestRedraw() );
        parent.addEventListener( 'load', () => this.requestRedraw() );
        parent.addEventListener( 'resize', () => this.requestRedraw() );
        parent.addEventListener( 'scroll', () => this.requestRedraw() );
        parent.addEventListener( 'unload', () => this.requestRedraw() );
        parent.addEventListener( 'error', () => this.requestRedraw() );
        parent.addEventListener( 'keydown', () => this.requestRedraw() );
        parent.addEventListener( 'keypress', () => this.requestRedraw() );
        parent.addEventListener( 'keyup', () => this.requestRedraw() );
        parent.addEventListener( 'blur', () => this.requestRedraw() );
        parent.addEventListener( 'focus', () => this.requestRedraw() );
        parent.addEventListener( 'focusin', () => this.requestRedraw() );
        parent.addEventListener( 'focusout', () => this.requestRedraw() );
        parent.addEventListener( 'change', () => this.requestRedraw() );
        parent.addEventListener( 'select', () => this.requestRedraw() );
        parent.addEventListener( 'submit', () => this.requestRedraw() );
        parent.addEventListener( 'touchstart', () => this.requestRedraw() );
        parent.addEventListener( 'touchmove', () => this.requestRedraw() );
        parent.addEventListener( 'touchend', () => this.requestRedraw() );
        parent.addEventListener( 'touchcancel', () => this.requestRedraw() );
    },



    // make visitor work only on active (visible) children, emulating the cull visitor
    setUpIntersector: function ( intersector ) {

        intersector.traversalMode = osg.NodeVisitor.TRAVERSE_ACTIVE_CHILDREN;

        var self = this;
        intersector.getCurrentModelViewMatrix = function () {
            var mat = osg.mat4.create();
            osg.mat4.copy( mat, intersector.getViewMatrix() );
            osg.mat4.mul( mat, mat, intersector.getModelMatrix() );
            return mat;
        };
        intersector.getCurrentProjectionMatrix = function () {
            return intersector.getProjectionMatrix();
        };
        intersector.getViewport = function () {
            return self._camera.getViewport();
        };
        intersector.getLODScale = function () {
            return self._camera.getRenderer().getCullVisitor().getLODScale();
        };
        intersector.getDatabaseRequestHandler = function () {
            return self._camera.getRenderer().getCullVisitor().getDatabaseRequestHandler();
        };
        intersector.getFrameStamp = function () {
            return self._camera.getRenderer().getCullVisitor().getFrameStamp();
        };
        intersector.getCurrentCamera = function () {
            return self._camera;
        };
    },

    installCustomShaders: function () {
        var shaderProcessor = new osgShader.ShaderProcessor();
        shaderProcessor.addShaders( ShaderLib );
        // create a new shader generator with our own compiler
        var shaderGenerator = new osgShader.ShaderGenerator();
        shaderGenerator.setShaderCompiler( ShaderCompiler );

        // get or create instance of ShaderGeneratorProxy
        var shaderGeneratorProxy = this.getState().getShaderGeneratorProxy();
        shaderGeneratorProxy.addShaderGenerator( 'PointShader', shaderGenerator );

        // now we can use 'custom' in StateSet to access our shader generator
    },

    createDefaultLighting: function () {
        var lights = new osg.Node();
        var lsource1 = new osg.LightSource();
        var lsource2 = new osg.LightSource();
        var light1 = new osg.Light();
        var light2 = new osg.Light();
        lsource1.setLight( light1 );
        lsource2.setLight( light2 );
        light1.setPosition( osg.vec4.fromValues32( 0.0, 0.8660, 0.5, 0.0 ) );
        light1.setAmbient( osg.vec4.fromValues32( 0.7, 0.7, 0.7, 1.0 ) );
        light1.setDiffuse( osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 ) );
        light2.setPosition( osg.vec4.fromValues32( 0.7071, 0.0, 0.7071, 0.0 ) );
        light2.setAmbient( osg.vec4.fromValues32( 0.7, 0.7, 0.7, 1.0 ) );
        light2.setDiffuse( osg.vec4.fromValues32( 1.0, 1.0, 1.0, 1.0 ) );
        lights.addChild( lsource1 );
        lights.addChild( lsource2 );
        return lights;
    },

    setSceneData: function ( node ) {
        var root = new osg.Node();
        root.addChild( node );
        root.addChild( this.createDefaultLighting() );
        this._scene.setSceneData( root );

        // this._camera.removeChildren();
        this._camera.addChild( root );
    },

    setPointCloudScene: function ( pcscene ) {
        this._pointCloudScene = pcscene;
    },

    getPointCloudScene: function () {
        return this._pointCloudScene;
    },

    setSceneView: function ( sceneView ) {
        this._sceneView = sceneView;
    },

    getSceneView: function () {
        return this._sceneView;
    },

    setToolsNode: function ( toolsNode ) {
        this._toolsNode = toolsNode;
    },

    getToolsNode: function () {
        return this._toolsNode;
    },

    /**
     * Sets the node that activates or deactivates the EDL path.
     * @method
     * @memberof pcvizViewer.Viewer
     * @param {Switch} node The switch node.
     */
    setEDLSwitchNode: function ( node ) {
        this._edlSwitchNode = node;
    },

    /**
     * Gets the switch node.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {pcvizNode.Switch} The switch node.
     */
    getEDLSwitchNode: function () {
        return this._edlSwitchNode;
    },

    /**
     * Sets the EDL node
     * @method
     * @memberof pcvizViewer.Viewer
     * @param {pcvizNode.EDLNode} node The node with the EDL rendering.
     */
    setEDLNode: function ( node ) {
        this._edlNode = node;
    },

    /**
     * Gets the EDL Node.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {pcvizNode.EDLNode} The EDL node.
     */
    getEDLNode: function () {
        return this._edlNode;
    },

    /**
     * Activates or deactivates the EDL rendering. Note that index `1` points to EDLNode.
     * @method
     * @memberof pcvizViewer.Viewer
     * @param {bool} value `true` to activates, `false` to deactivate.
     */
    setEDLRendering: function ( value ) {
        if ( ( window.navigator.userAgent.indexOf( 'MSIE' ) !== -1 ) || ( window.navigator.userAgent.indexOf( 'Trident' ) !== -1 ) || ( window.navigator.userAgent.match( /(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i ) ) )
            value = false;

        // Node 1 is EDLNode
        var nodeIndex = value ? 1 : 0;
        this._edlSwitchNode.setSingleChildOn( nodeIndex );

        // Set nodeMasks to traverse only the active child in the Switch.
        var otherNodeIndex = value ? 0 : 1;
        this._edlSwitchNode.getChild( otherNodeIndex ).setNodeMask( ~Utils.TRAVERSAL_MASK_IV );
        this._edlSwitchNode.getChild( nodeIndex ).setNodeMask( Utils.TRAVERSAL_MASK_IV );
    },

    /**
     * Gets the state of the EDL rendering.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {bool} `true` when activated, otherwise `false`.
     */
    getEDLRendering: function () {
        // Node 1 is EDLNode
        return this._edlSwitchNode.getValue( 1 );
    },

    /**
     * Sets the HUD node
     * @method
     * @memberof pcvizViewer.Viewer
     * @param {pcvizNode.HUDNode} node The node with the HUD rendering.
     */
    setHUDNode: function ( node ) {
        this._hudNode = node;
    },

    /**
     * Gets the HUD Node.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {pcvizNode.HUDNode} The HUD node.
     */
    getHUDNode: function () {
        return this._hudNode;
    },

    // this center (offset) is equal to the sceneview center (offset)
    getCenter: function () {
        if ( this._center !== undefined )
            return this._center;
        else
            return osg.vec3.create64();
    },

    setCenter: function ( center ) {
        this._center = center;
    },

    getPolytopeIntersector: function () {
        return this._pi;
    },

    getCanvas: function () {
        return this._canvas;
    },

    /**
     * Computes intersections
     * @memberof pcvizViewer.Viewer
     * @param  {int} x             0 at the left
     * @param  {int} y             0 at the bottom
     * @param  {traversalMask} traversalMask Traversal Mask
     * @return {object}               intersections
     */
    computeIntersections: function ( x, y, traversalMask ) {

        if ( traversalMask === undefined ) {
            traversalMask = ( Utils.TRAVERSAL_MASK_IV );
        }


        if ( !this._lsi ) {
            this._lsi = new osgUtil.LineSegmentIntersector();
        } else {
            this._lsi.reset();
        }

        if ( !this._origIntersect ) {
            this._origIntersect = osg.vec3.create32();
            this._dstIntersect = osg.vec3.create32();
        }

        // set the maximum 'distance' for intersections
        var perspective = osg.mat4.getPerspective( osg.mat4.create(), this.getCamera().getProjectionMatrix() );
        var distance = 10000;
        var nearFarFactor = ( perspective.zFar - perspective.zNear ) / perspective.zFar;
        var maxZ = ( 1.0 - 1.0 / distance ) / nearFarFactor; // equals 1.0 if 'distance' = far
        this._lsi.set( osg.vec3.set( this._origIntersect, x, y, 0.0 ), osg.vec3.set( this._dstIntersect, x, y, maxZ ) );


        if ( !this._iv ) {
            this._iv = new osgUtil.IntersectionVisitor();
            this._iv.setIntersector( this._lsi );
            this.setUpIntersector( this._iv );
        } else {
            this._iv.reset();
        }
        this._iv.setTraversalMask( traversalMask );
        this._camera.accept( this._iv );

        var hits = this._lsi.getIntersections();

        // calculate distances
        var viewMatrix = this.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        var self = this;
        hits.forEach( function ( hit ) {
            var pointHit = self.calculateWorldHitCoords( hit, true );
            hit._distance = osg.vec3.distance( pointHit, eye );
        } );

        return this.filterHits( hits ); // do not include invisible points
    },

    resetState: function () {
        let options = {};
        options.zoomOptions = 'global';
        options.reset = true;

        const sceneExtent = this._sceneView.calculateSceneExtent( false ); // full extent, having 'tools' into account

        // This is for the 3d models. 
        // Because when the model is loading the bounding is not available yet. 
        // In this case we use the extent saved on the project.
        if ( sceneExtent[ 3 ] === -Infinity ) {
            let extent = this.getSceneView().getAppObject().getUnprojectedExtent();

            let bs = this.getBoundingFromExtent( new Envelope( extent[ 0 ], extent[ 3 ], extent[ 1 ], extent[ 4 ], extent[ 2 ], extent[ 5 ] ) );
            bs._center = osg.vec3.fromValues( 0, 0, 0 );
            this.zoomToBounding( bs, options );
            return;
        }

        let bsn = this.getBoundingFromExtent( new Envelope( sceneExtent[ 0 ], sceneExtent[ 3 ], sceneExtent[ 1 ], sceneExtent[ 4 ], sceneExtent[ 2 ], sceneExtent[ 5 ] ) );
        this.zoomToBounding( bsn, options );
    },

    checkNeedToDoFrame: function () {
        // calculating the elapse time for the on demand frame
        let elapsedTime = window.performance.now() - this._lastEventTime;

        this._requestContinousUpdate = !this.isBatterySaverEnabled();

        // if the elapsed time is over on demand max time, the redraw request will be stopped
        if ( !this._requestContinousUpdate && elapsedTime > ON_DEMAND_MAX_TIME && this.getDatabasePager().isIdle() ) {
            this._requestRedraw = false;
        }

        return this._requestContinousUpdate || this._requestRedraw;
    },


    //overwrite this method to update the tools
    frame: function () {
        // _contextLost check for code calling viewer::frame directly
        // (likely force preload gl resource or direct render control )
        if ( this._contextLost || !this.checkNeedToDoFrame() ) return;

        // now the zoom is made when all layers are rendered
        if ( this._firstZoom && this._sceneView.areAllLayersRendered() ) {
            this.setManipulator( this._manipulator );
            this.computeZoom();
            Utils.setBoundingFactor( Math.min( Math.max( 0.5, this._camera.getBoundingSphere()._radius / 60 ), 100 ) );
            Registry.getController( 'UserPreferences' ).notify( Utils.PLANAR_IMAGE_DISTANCE_KEY ); // Notify to redraw the planar images symbols when the bounding factor has changed

            if ( this._imageModeByUrl )
                this._sceneView.getTool( 'information' ).setImageManipulatorPosition();

            if ( MagnetAPI.isVerity() ) {
                this._sceneView.getLayerRenderer().getAllLayerNodes().forEach( function ( node, layer ) {
                    if ( MagnetAPI.isVerity() && layer.getType() === LayerType.POINTCLOUD ) {
                        node.setNodeMask( layer._visible ? ~Utils.TRAVERSAL_MASK_IV : 0x0 ); // Note: Now, for verity there's no problem with the masks because the left-panel is hidden and they can not modify the layers' visibility
                    }
                } );
            }
        }
        if ( this._newZoom === true && this._sceneView.areAllLayersRendered() ) {
            this.computeZoom();
            this._newZoom = false;
        }

        if ( Registry.getController( 'Error' ).hasErrors() && this._sceneView.getRenderErrorCB() ) {
            Registry.getController( 'Error' ).notify( this._sceneView.getRenderErrorCB() );
        }

        this.beginFrame();
        this._fpsCounter.frame();

        this.advance();

        // update viewport if a resize occured
        var canvasSizeChanged = this.updateViewport();
        if ( this._pixelRatio !== window.devicePixelRatio ) {

            canvasSizeChanged = true;
            this._pixelRatio = window.devicePixelRatio;
            this._devicePixelRatio = this._pixelRatio; //osg
            this.updateViewport();
        }


        // update pointcloud RTT
        if ( canvasSizeChanged ) {
            this._edlNode.setViewportDimensions( this.getCamera().getViewport().width(), this.getCamera().getViewport().height() );
            this._hudNode.setViewportDimensions( this.getCamera().getViewport().width(), this.getCamera().getViewport().height() );

            if ( this._ortho ) {
                this.getManipulator().computeZoom( 0.00000001 );
            }

        }
        // update inputs devices
        this.updateEventProxy( this._eventProxy, this.getFrameStamp() );

        // update tools
        this.updateTools();

        // setup framestamp
        this._updateVisitor.setFrameStamp( this.getFrameStamp() );
        // Update Manipulator/Event
        if ( this.getManipulator() && this._manipulatorEnabled ) {
            this.getManipulator().update( this._updateVisitor );
            osg.mat4.copy( this.getCamera().getViewMatrix(), this.getManipulator().getInverseMatrix() );
        }

        if ( this.checkNeedToDoFrame() || canvasSizeChanged ) {
            this.updateTraversal();
            this.renderingTraversal();

            if ( this._automaticLOD ) {
                // set level of detail
                let fps = this._fpsCounter.getAverageValue();
                let lodValue; // in the slider settings values allowed are between 0.01 and 2.8

                if ( fps < 50 ) // only modify LOD if fps is below 50
                    lodValue = ( this._LODfactor * fps );
                else
                    lodValue = this._sceneView.getProject().getCurrentRenderSettings().get( 'levelOfDetail' );

                let previousLodValue = 3.0 - this.getCamera().getRenderer().getCullVisitor().getLODScale();
                let smoothValue = ( lodValue + previousLodValue ) / 2.0;
                if ( smoothValue !== previousLodValue )
                    this.getCamera().getRenderer().getCullVisitor().setLODScale( ( 3.0 - smoothValue ) * window.devicePixelRatio );
            }
        }

        if ( this.getDatabasePager()._downloadingRequestsNumber === 0 && this._sceneView.getLayerRenderer() !== undefined ) {
            this._sceneView.getLayerRenderer().getAllLayerNodes().forEach( function ( node ) {
                if ( node.Layer.getType() !== 'VectorLayer' )
                    return;
                var symbol = node.Layer.getFeatureRenderer( '3D' ).getSymbol();
                if ( symbol.isStateSetDirty() )
                    symbol.setStateSetDirty( false );
            } );
        }

        this.endFrame();

    },

    findTool: function ( id ) {
        return this._arrayTools.find( function ( tool ) {
            return ( tool.getId() === id );
        } );
    },

    updateTools: function () {
        var self = this;
        var keys = window.Object.keys( this._arrayTools );
        keys.forEach( function ( key ) {
            var tool = self._arrayTools[ key ];
            if ( tool.update )
                tool.update( self );
        } );

        this._flyTo.update();
    },

    addTool: function ( tool ) {
        this._arrayTools.push( tool );
    },

    setPagedLODPrefixURL: function ( prefix ) {
        osgDB.registry().setPagedLODPrefixURL( prefix );
    },

    setPagedLODSuffixURL: function ( suffix ) {
        osgDB.registry().setPagedLODSuffixURL( suffix );
    },

    setPrefixURL: function ( prefix ) {
        osgDB.registry().setPrefixURL( prefix );
    },

    // Should we remove this method?
    readNodeURL: function ( URL ) {
        var defer = P.defer();
        osgDB.registry().setReadNodeURLCallback( this.customReadNode );
        //osgDB.registry().setReadBinaryArrayURLCallback( this.customReadBinaryArrayURL );
        var options = osgDB.registry().getOptions();
        options._selectionAttribute = this._selectionAttribute;
        P.resolve( osgDB.readNodeURL( URL, options ) ).then( function ( data ) {
            defer.resolve( data );
        } );
        return defer.promise;
    },

    setupManipulator: function ( manipulator ) {
        if ( manipulator === undefined ) {
            this._cadManipulator = new CADManipulator();
            this._cadManipulator.setUsePolytopeIntersector( true );
            manipulator = this._cadManipulator;
        }
        if ( manipulator.setNode !== undefined ) {
            manipulator.setNode( this.getSceneData() );
        }

        manipulator.setCamera( this.getCamera() );
        this.setManipulator( manipulator );
    },

    isPickingEnabled: function () {
        return this._pickingActive;
    },

    ensureInitPickingEvents: function () {
        var self = this;
        if ( !this._pickFn ) {
            this._pickFn = function ( event ) {
                if ( !self._isDragging || !self._manipulatorEnabled ) {
                    self.sendPickedEvent( event );
                }
            };
        }

        if ( !this._isMouseDownFn ) {
            this._isMouseDownFn = function ( /* event */) {
                self._isDragging = true;
            };
        }

        if ( !this._isMouseUpFn ) {
            this._isMouseUpFn = function () {
                self._isDragging = false;
            };
        }
    },

    ensureMobileInitPickingEvents: function () {
        var self = this;
        if ( !this._mobilePickFn ) {
            this._mobilePickFn = function ( event ) {
                if ( !self._isDragging || !self._manipulatorEnabled ) {
                    self.sendPickedEvent( event );
                }
                self._isDragging = false;
                //this._canvas.removeEventListener( 'touchmove', this._mobilePickFn , false);
            };
        }

        if ( !this._isMobileMovingFn ) {
            this._isMobileMovingFn = function ( event ) {
                self._isDragging = true;
                // for disabling the marker
                self.dispatchHitEvent( event, undefined );
            };
        }
    },

    /**
     * Enable disable eventlistener.
     * @memberof pcvizViewer.Viewer
     * @param {boolean} enabled Sets if the picking tool is enabled
     */
    setPickingEnabled: function ( enabled ) {
        if ( Utils.isTouchEnabled() ) { // It returns false for Microsoft Surface tablet
            return this.setTouchEnabled( enabled );
        }

        this.ensureInitPickingEvents();

        if ( enabled && !this._pickingActive ) {
            this._canvas.addEventListener( 'mousedown', this._isMouseDownFn, false );
            this._canvas.addEventListener( 'mouseup', this._isMouseUpFn, false );
            this._canvas.addEventListener( 'mousemove', this._pickFn, false );
            this._pickingActive = true;
        }
        if ( !enabled && this._pickingActive ) {
            this._canvas.removeEventListener( 'mousedown', this._isMouseDownFn, false );
            this._canvas.removeEventListener( 'mouseup', this._isMouseUpFn, false );
            this._canvas.removeEventListener( 'mousemove', this._pickFn, false );
            this._pickingActive = false;
        }

    },
    setTouchEnabled: function ( enabled ) {
        this._polytopeSize = 10.0 * window.devicePixelRatio;
        this.ensureMobileInitPickingEvents();

        if ( enabled && !this._pickingActive ) {
            this._canvas.addEventListener( 'touchmove', this._isMobileMovingFn, false );
            this._canvas.addEventListener( 'touchend', this._mobilePickFn, false );
            this._pickingActive = true;
        }
        if ( !enabled && this._pickingActive ) {
            this._canvas.removeEventListener( 'touchmove', this._isMobileMovingFn, false );
            this._canvas.removeEventListener( 'touchend', this._mobilePickFn, false );
            this._pickingActive = false;
        }

    },

    findPointCloudCenter: function ( nodePath ) {
        for ( var i = 0; i < nodePath.length; i++ ) {
            if ( nodePath[ i ] instanceof PointCloudPLOD ) {
                if ( nodePath[ i ].PointCloudCenter !== undefined )
                    return nodePath[ i ].PointCloudCenter;
            }
        }
        return undefined;
    },

    findParentPointCloud: function ( nodePath, fromTop ) {

        if ( fromTop ) {
            for ( var i = 0; i < nodePath.length; i++ ) {
                if ( nodePath[ i ] instanceof PointCloudPLOD ) {
                    return nodePath[ i ];
                }
            }
            return undefined;
        }

        for ( var j = nodePath.length - 1; j >= 0; j-- ) {
            if ( nodePath[ j ] instanceof PointCloudPLOD ) {
                return nodePath[ j ];
            }
        }
        return undefined;
    },

    findBufferAttribute: function ( nodePath ) {
        for ( var j = nodePath.length - 1; j >= 0; j-- ) {
            if ( nodePath[ j ].bufferAttribute ) {
                return nodePath[ j ].bufferAttribute;
            }
        }
        return undefined;
    },

    createHitEventStructure: function ( ev, hit, clientX, clientY ) {
        var plod;
        var plodCenter;
        var pos;
        if ( hit !== undefined ) {
            plod = this.findParentPointCloud( hit._nodePath );
            plodCenter = this.findPointCloudCenter( hit._nodePath );
            pos = this.calculateWorldHitCoords( hit );
        }
        var eventStructure = {
            hit: hit,
            sceneCenter: this.getCenter(),
            plod: plod,
            plodCenter: plodCenter,
            coordinate: pos,
            clientX: clientX,
            clientY: clientY
        };
        return eventStructure;
    },

    calculateWorldHitCoords: function ( hit, keepLocal ) {
        for ( var i = 0; i < hit._nodePath.length; i++ ) {
            if ( hit._nodePath[ i ] instanceof SceneNode ) {
                break;
            }
        }
        var scenePath = hit._nodePath.slice( i );

        var matrix = osg.computeLocalToWorld( scenePath );
        var pos = osg.vec3.create64();
        osg.vec3.transformMat4( pos, hit._localIntersectionPoint, matrix );

        if ( keepLocal )
            return pos;

        return osg.vec3.fromValues64(
            pos[ 0 ] + this.getCenter()[ 0 ],
            pos[ 1 ] + this.getCenter()[ 1 ],
            pos[ 2 ] + this.getCenter()[ 2 ] );
    },

    dispatchHitEvent: function ( ev, hit, clientX, clientY ) {

        var detail = this.createHitEventStructure( ev, hit, clientX, clientY );
        var event = new CustomEvent( 'pick', {
            detail: detail,
            bubbles: true,
            cancelable: true
        } );

        if ( Utils.isTouchEnabled() ) {
            var now = new Date().getTime();
            var timesince = now - this._latestTap;
            if ( !this.isDragging() && ( timesince < 600 ) && ( timesince > 0 ) ) {
                event = new CustomEvent( 'dblclick', {
                    detail: detail,
                    bubbles: true,
                    cancelable: true
                } );
            }
            this._latestTap = new Date().getTime();
        }

        // launching event
        ev.currentTarget.dispatchEvent( event );
    },

    filterHits: function ( hits ) {
        var filteredHits = [];
        var self = this;
        hits.forEach( function ( hit ) {
            var pCloudLOD = self.findParentPointCloud( hit._nodePath, true );
            if ( pCloudLOD ) {
                var geometry = hit._nodePath[ hit._nodePath.length - 1 ];
                var classification = geometry.getAttributes().Classification.getElements()[ hit._primitiveIndex ];
                if ( pCloudLOD.ClassificationArray[ classification ] === 0 ) // point class is not visible
                    return;
            }
            // filter points outside buffer
            var bufAttribute = pCloudLOD ? pCloudLOD.bufferAttribute : self.findBufferAttribute( hit._nodePath );
            if ( bufAttribute && bufAttribute.isEnabled() && bufAttribute.getOnlyBuffer() && self.filterHitByBuffer( hit, bufAttribute ) )
                return;

            // filter points that are hidden by the PointEditionTool. If a point is hidden, his visibilityFlag is 2.0.
            if ( hit._drawable && hit._drawable.getAttributes() && hit._drawable.getAttributes().Visible ) {
                const visibleFlag = hit._drawable.getAttributes().Visible.getElements()[ hit._primitiveIndex ];
                if ( visibleFlag === 2.0 ) {
                    return;
                }
            }

            // filter points hidden by Elevation heatmap drawing rule (hide above/below points option)
            if ( pCloudLOD && pCloudLOD.drawingRuleAttribute && pCloudLOD.drawingRuleAttribute.getDrawingRule() === DrawingRuleAttribute.HEATMAP_ELEVATION &&
                pCloudLOD.drawingRuleAttribute.getHideAboveBelow() ) {
                let pointHit = self.calculateWorldHitCoords( hit );
                let refElevation = pCloudLOD.drawingRuleAttribute.getRefElevation();
                let aboveBelowSize = pCloudLOD.drawingRuleAttribute.getHideAboveBelowSize();
                let planeConstant = pCloudLOD.drawingRuleAttribute.getPlaneConstant();
                let planeNormal = pCloudLOD.drawingRuleAttribute.getPlaneNormal();
                let valueTransformed = pointHit[ 0 ] * planeNormal[ 0 ] + pointHit[ 1 ] * planeNormal[ 1 ] + pointHit[ 2 ] * planeNormal[ 2 ] + planeConstant;
                if ( valueTransformed < refElevation - aboveBelowSize || valueTransformed > refElevation + aboveBelowSize ) {
                    return;
                }
            }

            //avoid to hit reference planes
            if ( hit._drawable && hit._drawable.getParents() && hit._drawable.getParents()[ 0 ] && hit._drawable.getParents()[ 0 ].getName() === 'Reference Planes root' ) {
                return;
            }

            filteredHits.push( hit );
        } );

        // sort by distance
        if ( filteredHits.length > 1 ) {
            filteredHits.sort( function ( a, b ) {
                if ( a._screenDistance !== undefined && b._screenDistance !== undefined )
                    return a._screenDistance - b._screenDistance;
                if ( a._distance === undefined || b._distance === undefined )
                    return 0;
                if ( a._screenDistance !== undefined ) // "a" is a point and "b" is not -> give preference to "b"
                    return 1;
                if ( b._screenDistance !== undefined ) // "b" is a point and "a" is not -> give preference to "a"
                    return -1;
                return a._distance - b._distance;
            } );
        }

        return filteredHits;
    },

    filterHitByBuffer: function ( hit, bufAttribute ) {

        var pointHit = this.calculateWorldHitCoords( hit );
        pointHit = bufAttribute.transformPointToBufferCoords( pointHit );

        switch ( bufAttribute.getBufferMode() ) {
        case BufferAttribute.POINT:
            var d = osg.vec3.distance( pointHit, bufAttribute.getPointBuffer() );
            return ( d > bufAttribute.getRange() );

        case BufferAttribute.LINE:
            var dmin = Number.MAX_VALUE;
            var lineBuf = bufAttribute.getLineBuffer();

            for ( var i = 0; i < bufAttribute.getNumBufferVertices() - 1; i++ ) {
                var vec12 = [ lineBuf[ 3 * i + 3 ] - lineBuf[ 3 * i + 0 ], lineBuf[ 3 * i + 4 ] - lineBuf[ 3 * i + 1 ], lineBuf[ 3 * i + 5 ] - lineBuf[ 3 * i + 2 ] ];
                var vec01 = [ pointHit[ 0 ] - lineBuf[ 3 * i + 0 ], pointHit[ 1 ] - lineBuf[ 3 * i + 1 ], pointHit[ 2 ] - lineBuf[ 3 * i + 2 ] ];
                var t = ( vec01[ 0 ] * vec12[ 0 ] + vec01[ 1 ] * vec12[ 1 ] + vec01[ 2 ] * vec12[ 2 ] ) / ( vec12[ 0 ] * vec12[ 0 ] + vec12[ 1 ] * vec12[ 1 ] + vec12[ 2 ] * vec12[ 2 ] );
                t = ( t < 0.0 ) ? 0.0 : ( ( t > 1.0 ) ? 1.0 : t );
                var intPt = osg.vec3.fromValues64(
                    lineBuf[ 3 * i + 0 ] + t * vec12[ 0 ],
                    lineBuf[ 3 * i + 1 ] + t * vec12[ 1 ],
                    lineBuf[ 3 * i + 2 ] + t * vec12[ 2 ] );

                var dL = osg.vec3.distance( intPt, pointHit );
                if ( dL < dmin )
                    dmin = dL;
            }
            return ( dmin > bufAttribute.getRange() );

        case BufferAttribute.VERTICAL_LINE:
            var dmin2 = Number.MAX_VALUE;
            var lineBuf2 = bufAttribute.getLineBuffer();

            for ( var i2 = 0; i2 < bufAttribute.getNumBufferVertices() - 1; i2++ ) {
                var vec122 = [ lineBuf2[ 3 * i2 + 3 ] - lineBuf2[ 3 * i2 + 0 ], lineBuf2[ 3 * i2 + 4 ] - lineBuf2[ 3 * i2 + 1 ] ];
                var vec012 = [ pointHit[ 0 ] - lineBuf2[ 3 * i2 + 0 ], pointHit[ 1 ] - lineBuf2[ 3 * i2 + 1 ] ];
                var t2 = ( vec012[ 0 ] * vec122[ 0 ] + vec012[ 1 ] * vec122[ 1 ] ) / ( vec122[ 0 ] * vec122[ 0 ] + vec122[ 1 ] * vec122[ 1 ] );
                t2 = ( t2 < 0.0 ) ? 0.0 : ( ( t2 > 1.0 ) ? 1.0 : t2 );
                var intPt2 = osg.vec2.fromValues64(
                    lineBuf2[ 3 * i2 + 0 ] + t2 * vec122[ 0 ],
                    lineBuf2[ 3 * i2 + 1 ] + t2 * vec122[ 1 ] );

                var dL2 = osg.vec2.distance( intPt2, osg.vec2.fromValues64( pointHit[ 0 ], pointHit[ 1 ] ) );
                if ( dL2 < dmin2 )
                    dmin2 = dL2;
            }
            return ( dmin2 > bufAttribute.getRange() );

        case BufferAttribute.BOX:
            var vec = osg.vec3.create();
            osg.vec3.sub( vec, pointHit, bufAttribute.getPointBuffer() );

            var vectors = bufAttribute.getLineBuffer();

            for ( var i3 = 0; i3 < 3; i3++ ) {
                var boxVec = osg.vec3.fromValues64( vectors[ 3 * i3 ], vectors[ 3 * i3 + 1 ], vectors[ 3 * i3 + 2 ] );
                var vecL = osg.vec3.length( boxVec );
                var pos = osg.vec3.dot( boxVec, vec ) / vecL;
                if ( pos < 0 || pos > vecL )
                    return true;
            }
        }

        return false; // passes filter
    },

    computePolytopeIntersections: ( function () {
        var offset = [];
        return function ( ev, skipFilter, skipFilterDist, avoidEventPrevent ) {
            var ph = this._polytopeSize;
            var pw = this._polytopeSize;
            // On Microsoft surface tablet that supports both 'touch' and 'mouse' events we need to update polytopeSize according to the event (which is always 'mouseup')
            // First condition is valid for Chrome and WinUI3. Second condition for Firefox.
            const MOZ_TOUCH = 5;
            if ( ev.sourceCapabilities && ev.sourceCapabilities.firesTouchEvents || ev.mozInputSource === MOZ_TOUCH ) { // Is touch event
                ph = 10.0 * window.devicePixelRatio;
                pw = 10.0 * window.devicePixelRatio;
            }
            var ratioX, ratioY;
            var clientX, clientY;
            if ( !avoidEventPrevent )
                ev.preventDefault();
            this._pi.reset();

            this.getOffsetRect( this._canvas, offset );
            ratioX = this._canvas.width / this._canvas.clientWidth;
            ratioY = this._canvas.height / this._canvas.clientHeight;

            // We check the event type's name because we sometimes call to this function from a mouseup event (listener function).
            // So, although we are in a mobile device, the event isn't a touchevent.
            // We need test this in some different devices (iPad)
            if ( ev.type === 'touchend' ) {
                clientX = ev.changedTouches[ 0 ].clientX;
                clientY = ev.changedTouches[ 0 ].clientY;
            } else {
                clientX = ev.clientX;
                clientY = ev.clientY;
            }

            var xCen = ( clientX - offset[ 1 ] ) * ratioX;
            var yCen = ( this._canvas.clientHeight - ( clientY - offset[ 0 ] ) ) * ratioY;

            this._pi.setPolytopeFromWindowCoordinates( xCen - pw, yCen - ph, xCen + pw, yCen + ph );
            this.limitIntersections( false ); // allow multiple hits per primitive
            this.setUpIntersector( this._ivTools );

            this.getCamera().accept( this._ivTools );
            var hits = this._pi.getIntersections();
            // calculate pixel distances
            var viewMatrix = this.getCamera().getViewMatrix();
            var eye = osg.vec3.create64();
            var center = osg.vec3.create64();
            var up = osg.vec3.create64();
            osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

            var winMatrix = osg.mat4.create64();
            this.getCamera().getViewport().computeWindowMatrix( winMatrix );
            var projMatrix = this.getCamera().getProjectionMatrix();
            var pickMatrix = osg.mat4.create64();
            var screenPoint = osg.vec3.create();

            // calculate min distance to eye
            var dMin = Number.MAX_VALUE;
            hits.forEach( function ( hit ) {
                if ( hit._distance < dMin )
                    dMin = hit._distance;
            } );
            // discard farther hits and calculate pixel distances to cursor
            var closerHits = [];
            var foundFromLayer;
            var layerSelected = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject() ? Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject().getLayer() : undefined;
            if ( skipFilterDist )
                return skipFilter ? hits : this.filterHits( hits );
            hits.forEach( function ( hit ) {

                if ( hit._distance < dMin * 1.05 ) {
                    osg.mat4.mul( pickMatrix, winMatrix, projMatrix );
                    osg.mat4.mul( pickMatrix, pickMatrix, hit._matrix );
                    osg.vec3.transformMat4( screenPoint, hit._localIntersectionPoint, pickMatrix );
                    hit._screenDistance = Math.abs( screenPoint[ 0 ] - xCen ) + Math.abs( screenPoint[ 1 ] - yCen );

                    closerHits.push( hit );
                } else if ( layerSelected && !foundFromLayer ) {
                    var layer;
                    for ( var i = hit._nodePath.length - 1; i >= 0; i-- ) {
                        if ( hit._nodePath[ i ].Layer ) {
                            layer = hit._nodePath[ i ].Layer;
                            break;
                        }
                    }
                    if ( layer && layer.getId() === layerSelected.getId() ) {
                        osg.mat4.mul( pickMatrix, winMatrix, projMatrix );
                        osg.mat4.mul( pickMatrix, pickMatrix, hit._matrix );
                        osg.vec3.transformMat4( screenPoint, hit._localIntersectionPoint, pickMatrix );
                        hit._screenDistance = Math.abs( screenPoint[ 0 ] - xCen ) + Math.abs( screenPoint[ 1 ] - yCen );

                        closerHits.push( hit );
                        foundFromLayer = true;
                    }
                }
            } );

            if ( skipFilter )
                return closerHits;

            return this.filterHits( closerHits );
        };
    } )(),

    computeAllIntersections: function ( ev, clientX, clientY, withoutFilter, avoidEventPrevent ) {

        var offset = [];
        this.getOffsetRect( this._canvas, offset );
        var ratioX = this._canvas.width / this._canvas.clientWidth;
        var ratioY = this._canvas.height / this._canvas.clientHeight;

        var x = ( ( clientX - offset[ 1 ] ) * ratioX );
        var y = ( ( this._canvas.clientHeight - ( clientY - offset[ 0 ] ) ) * ratioY );

        let hits = this.computePolytopeIntersections( ev, true, withoutFilter, avoidEventPrevent );
        hits = hits.concat( this.computeIntersections( x, y ) ); // join line-based intersections for precise picking on surface objects. REVIEW These are filtered twice
        hits = this.filterHits( hits );
        return hits;
    },

    setMobileNodeFilterCB: function ( cb ) {
        this._mobileNodeFilterCB = cb;
    },

    /**
     * Send a picked event to listeners attached to this event. The registered user callbacks will be called.
     * @memberof pcvizViewer.Viewer
     * @param  {Event} ev Picked event
     */
    sendPickedEvent: function ( ev, forceTouch ) {
        if ( !this._pickingActive ) return;

        var isMobile = Utils.isTouchEnabled();
        var clientX, clientY;
        if ( isMobile || forceTouch ) {
            clientX = ev.changedTouches[ 0 ].clientX;
            clientY = ev.changedTouches[ 0 ].clientY;
        } else {
            clientX = ev.clientX;
            clientY = ev.clientY;
        }

        // convert coordinates
        ev.preventDefault();

        var hits = this.computeAllIntersections( ev, clientX, clientY );

        // Should we add some async mechanism?
        if ( hits.length === 0 && this._isLast ) {
            this._isLast = false;
            this.dispatchHitEvent( ev, undefined );
        }
        if ( hits.length === 0 )
            return;

        var hit;
        if ( isMobile || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) {
            var userData;
            for ( var j = 0; j < hits.length && hit === undefined; j++ ) {
                for ( var i = hits[ j ]._nodePath.length - 1; i >= 0; i-- ) {
                    if ( this._mobileNodeFilterCB && this._mobileNodeFilterCB( hits[ j ]._nodePath[ i ] ) ) {
                        hit = hits[ j ];
                        break;
                    }

                    userData = hits[ j ]._nodePath[ i ].getUserData();
                    if ( userData !== undefined && userData.featureIds !== undefined ) {
                        hit = hits[ j ];
                        break;
                    }
                }
            }
        }
        if ( hit === undefined )
            hit = hits[ 0 ];

        if ( window.CustomEvent /* && hits.length > 0*/ ) {
            this._isLast = true;
            this.dispatchHitEvent( ev, hit, clientX, clientY );
        }
    },

    getOffsetRect: function ( elem, pos ) {
        var box = elem.getBoundingClientRect();
        var body = document.body;
        var docElem = document.documentElement;
        var scrollTop = window.pageYOffset || docElem.scrollTop || body.scrollTop;
        var scrollLeft = window.pageXOffset || docElem.scrollLeft || body.scrollLeft;
        var clientTop = docElem.clientTop || body.clientTop || 0;
        var clientLeft = docElem.clientLeft || body.clientLeft || 0;
        var top = box.top + scrollTop - clientTop;
        var left = box.left + scrollLeft - clientLeft;
        pos[ 0 ] = Math.round( top );
        pos[ 1 ] = Math.round( left );
        return pos;
    },

    isDragging: function () {
        return this._isDragging;
    },

    setPresentVR: function ( bool ) {
        if ( !this._hmd ) {
            return;
        }

        // reset position/orientation of hmd device
        if ( !this._hmd.capabilities.hasPosition )
            this._hmd.resetPose();

        if ( !this._hmd.capabilities.canPresent )
            return P.reject();

        if ( bool ) {
            var layers = [ {
                source: this.getGraphicContext().canvas
            } ];
            return this._hmd.requestPresent( layers );

        } else {
            return this._hmd.exitPresent();
        }
    },

    /**
     * Configures the intersector to limit the intersections or not.
     * @method
     * @memberof pcvizViewer.Viewer
     * @param  {Boolean} limit `true` to limit to one per drawable. `false` to disable limit.
     */
    limitIntersections: function ( limit ) {
        if ( limit )
            this._pi.setIntersectionLimit( osgUtil.LIMIT_ONE_PER_DRAWABLE );
        else
            this._pi.setIntersectionLimit( osgUtil.NO_LIMIT );
    },

    /**
     * Gets or creates an OSG CADManipulator if it does not exist.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {CADManipulator} The CAD manipulator.
     */
    getOrCreateCADManipulator: function () {
        if ( this._cadManipulator === undefined ) {
            this._cadManipulator = new CADManipulator();
            this._cadManipulator.setUsePolytopeIntersector( true );

            this._cadManipulator.setPanFactor( 8.0 / ( this.getCamera().getViewport().width() / this.getCamera().getViewport().height() ) );
            this._cadManipulator.setZoomFactor( 2 );
            if ( this._cadManipulator.getIntersectionVisitor() !== undefined )
                this._cadManipulator.getIntersectionVisitor().setTraversalMask( Utils.TRAVERSAL_MASK_IV );
            // Disables the CADManipulator `dblclick` function
            this._cadManipulator.getControllerList().StandardMouseKeyboard.dblclick = undefined;
            this._cadManipulator.getControllerList().StandardMouseKeyboard.keydown = undefined;
            this._cadManipulator.getControllerList().StandardMouseKeyboard.keyup = undefined;

            // check for any-pointer:coarse which mostly means touchscreen
            if ( this.shouldInterceptMouseFn() ) {
                this.interceptControllerFunctions( this._cadManipulator );
                if ( Registry.getController( 'UserPreferences' ).getPreference( Utils.MOUSE_OR_TOUCH_KEY ) !== Utils.MOUSE_PRIORITY ) {
                    this._enableTouchController = true;
                    this._polytopeSize = 10.0 * window.devicePixelRatio;
                }
                Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.MOUSE_OR_TOUCH_KEY, ( option ) => {
                    if ( option === Utils.MOUSE_PRIORITY ) {
                        this._enableTouchController = false;
                        this._polytopeSize = 5.0 * window.devicePixelRatio;
                        return;
                    }
                    if ( option === Utils.TOUCH_PRIORITY ) {
                        this._enableTouchController = true;
                        this._polytopeSize = 10.0 * window.devicePixelRatio;
                    }
                } );
            }

            if ( this._eventProxy.Hammer && this._eventProxy.Hammer._hammer ) {
                this._eventProxy.Hammer._hammer.add( new Hammer.Tap() );
            }

        }
        return this._cadManipulator;
    },

    getOrCreateManipulator: function () {
        if ( this._ortho ) {
            console.error( 'This is not supported' );
            return;
        } else
            return this.getOrCreateCADManipulator();
    },

    /**
     * Gets or creates an extended FirstPersonManipulator.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {pcvizManipulator.FirstPersonManipulator} The first person manipulator.
     */
    getOrCreatePanoramaManipulator: function () {
        if ( this._panoramaManipulator === undefined ) {
            this._panoramaManipulator = new FirstPersonManipulator();
            this._panoramaManipulator.getControllerList().StandardMouseKeyboard.keydown = undefined;
            this._panoramaManipulator.getControllerList().StandardMouseKeyboard.keyup = undefined;

            if ( this.shouldInterceptMouseFn() )
                this.interceptControllerFunctions( this._panoramaManipulator );
        }
        return this._panoramaManipulator;
    },

    /**
     * Gets or creates a PlanarImageManipulator.
     * @method
     * @memberof pcvizViewer.Viewer
     * @return {pcvizManipulator.ImageManipulator} The planar image manipulator.
     */
    getOrCreatePlanarImageManipulator: function () {
        if ( this._planarImageManipulator === undefined ) {
            this._planarImageManipulator = new ImageManipulator();
        }
        return this._planarImageManipulator;
    },

    /**
     * Disables the double click function that makes the 'fly to' and the 'double tap' function.
     * @method
     * @memberof pcvizViewer.Viewer
     */
    disableManipulatorDoubleClick: function () {
        this.disableFlyTo();
        this._canvas.addEventListener( 'dblclick', this._dblclickRemoveSelectionFunction, true );
    },

    /**
     * Restores the double click function that makes the 'fly to' and the 'double tap' function. See `disableManipulatorDoubleClick` for more information.
     * @method
     * @memberof pcvizViewer.Viewer
     */
    restoreManipulatorDoubleClick: function () {
        this.enableFlyTo();
        this._canvas.removeEventListener( 'dblclick', this._dblclickRemoveSelectionFunction, true );
    },

    disableFlyTo: function () {
        // Touch devices
        if ( this._eventProxy.Hammer._hammer !== undefined )
            this._eventProxy.Hammer._hammer.off( 'tap', this._cadManipulator.getControllerList().Hammer._cbDoubleTap );

        this._canvas.removeEventListener( 'dblclick', this._dblclickFlyToFunction, true );
    },

    enableFlyTo: function () {
        // Touch devices
        if ( this._eventProxy.Hammer._hammer !== undefined && this._cadManipulator && this._eventProxy.Hammer._hammer.handlers[ 'tap' ] && this._eventProxy.Hammer._hammer.handlers[ 'tap' ].length === 0 )
            this._eventProxy.Hammer._hammer.on( 'tap', this._cadManipulator.getControllerList().Hammer._cbDoubleTap );

        this._canvas.addEventListener( 'dblclick', this._dblclickFlyToFunction, true );
    },

    setFOV: function ( value ) {
        var ratio = this._canvas.clientWidth / this._canvas.clientHeight;
        // the near far will be recalulated by the cull visitor, so no need to set something here.
        this._fov = value;
        osg.mat4.perspective( this._camera.getProjectionMatrix(), value * Math.PI / 180.0, ratio, 1.0, 1000.0 );
    },

    stopFlyTo: function () {
        this._flyTo.setActive( false );
        if ( this._manipulatorEnabled === false ) {
            this._manipulatorEnabled = true;
        }
    },

    stop: function () {
        window.cancelAnimationFrame( this._requestID );
    },

    enableManipulator: function ( enable ) {
        this._manipulatorEnabled = enable;
    },

    destroy: function () {
        this.stop();
        this.getCamera().setRenderer( undefined );
        if ( this.getManipulator() && this.getManipulator()._polytopeIntersector )
            this.getManipulator()._polytopeIntersector.reset();
        this.getDatabasePager().reset();
        this._toolsNode = undefined;
        this._edlSwitchNode = undefined;
        this._edlNode = undefined;
        this._hudNode = undefined;
        this._arrayTools.length = 0;
        this._pi.reset();
        this._pi = undefined;
        this._ivTools.reset();
        this._ivTools = undefined;
    },

    zoomToBounding: function ( bounding, options ) {
        var centerObj = bounding.center();
        if ( bounding.radius() < 0.01 ) // point-like extent
            bounding.set( centerObj, this._pointBoundingRadius );
        var distance = ( bounding.radius() / Math.tan( this._fov * Math.PI / 180.0 ) ) * 2.0;

        this.changeViewPoint( {
            id: options.zoomOptions,
            distance: distance,
            centerObj: centerObj,
            radius: bounding.radius()
        }, options );

    },

    getOrCreateEigenAxis: function ( layer, feature, node ) {
        var identity = {
            R: [ 0, 0, 1 ],
            S: [ 0, 1, 0 ],
            T: [ 1, 0, 0 ]
        };

        var geometryVisitor = new FindGeometryVisitor( layer, feature, node );
        this._sceneView.getSceneNode().accept( geometryVisitor );

        // getting vertex from the geometry array
        var geometryArray = geometryVisitor.getGeometryArray();
        if ( geometryArray.length === 0 )
            return identity;

        node = geometryVisitor.getRootNode();
        if ( node === undefined )
            return identity;

        if ( node.eigenAxis !== undefined )
            return node.eigenAxis;

        var vertexArray = [];
        for ( var i = 0; i < geometryArray.length; i++ ) {
            if ( !geometryArray[ i ].getAttributes )
                continue;
            var buffer = geometryArray[ i ].getAttributes().Vertex;

            for ( var t = 0; t < buffer.getElements().length; t++ ) {
                vertexArray.push( buffer.getElements()[ t ] );
            }
        }

        var vertices = [];
        for ( var s = 0; s < vertexArray.length; s = s + 3 ) {
            vertices.push( osg.vec3.fromValues( vertexArray[ s ], vertexArray[ s + 1 ], vertexArray[ s + 2 ] ) );
        }

        var eigenAxis = new EigenAxis( vertices );
        node.eigenAxis = eigenAxis.getEigenAxis();

        return node.eigenAxis;
    },

    zoomToLayer: function ( layer, options ) {
        var layerRenderer = this.getSceneView().getLayerRenderer();
        options.layer = layer;
        options.node = layerRenderer.getNodeFromLayer( layer );

        if ( !options.node ) // The layer doesn't have node (f.i. when the layer has just been created)
            return;

        var bbox = options.node.getBoundingBox();
        if ( !bbox.valid() ) // The bounding box is not valid (f.i. the layer is rendered but it doesn't have any features)
            return;

        var bsn;

        var nodePath = Utils.computeNodePath( options.node );
        var modelMat = osg.computeLocalToWorld( nodePath, true );
        var center = osg.vec3.create();
        bbox.center( center );

        bsn = this.getBoundingFromExtent( new Envelope( bbox.getMin()[ 0 ], bbox.getMax()[ 0 ], bbox.getMin()[ 1 ], bbox.getMax()[ 1 ], bbox.getMin()[ 2 ], bbox.getMax()[ 2 ] ) );

        if ( !bsn.valid() ) {
            return;
        }

        osg.vec3.transformMat4( center, center, modelMat );
        bsn._center = center;
        var scale = osg.mat4.getScale( osg.vec3.create(), modelMat );
        var maxScale = Math.max( Math.max( scale[ 0 ], scale[ 1 ] ), scale[ 2 ] );
        bsn.radius( bsn.radius() * maxScale );



        if ( bsn.radius() < 1 )
            bsn._radius = 1;

        this.zoomToBounding( bsn, options );
    },

    zoomToFeature: function ( layer, feature, options ) {
        var geometry = feature.getGeometry();

        var layerRenderer = this.getSceneView().getLayerRenderer();
        options.layer = layer;
        options.feature = feature;
        options.node = layerRenderer.getNodeFromLayer( layer );
        var bs = new osg.BoundingSphere();

        if ( geometry instanceof Polygon ) {
            geometry = geometry.getExteriorRing();
        }

        var nodePath = Utils.computeNodePath( options.node );
        var mt = osg.computeLocalToWorld( nodePath, true );

        var pointVec = osg.vec3.create64();

        if ( geometry instanceof Point ) {

            osg.vec3.transformMat4( pointVec, [ geometry.getX(), geometry.getY(), geometry.getZ() ], mt );

            bs.expandByVec3( pointVec );
            this.zoomToBounding( bs, options );
            return;
        }

        for ( var i = 0; i < geometry.getNumPoints(); i++ ) {
            var point = geometry.getPoint( i );

            osg.vec3.transformMat4( pointVec, [ point.getX(), point.getY(), point.getZ() ], mt );
            bs.expandByVec3( pointVec );
        }

        this.zoomToBounding( bs, options );
    },

    zoomToExtent: function ( extent, options ) {
        var layerRenderer = this.getSceneView().getLayerRenderer();
        var bs = this.getBoundingFromExtent( extent, layerRenderer.getCenter() );
        this.zoomToBounding( bs, options );
    },

    getBoundingFromExtent: function ( extent, worldCenter ) {
        let bs = new osg.BoundingSphere();

        let maxX = extent.getMaxX();
        let maxY = extent.getMaxY();
        let maxZ = extent.getMaxZ();

        let x = ( maxX + extent.getMinX() ) / 2.0;
        let y = ( maxY + extent.getMinY() ) / 2.0;
        let z = ( maxZ + extent.getMinZ() ) / 2.0;

        if ( worldCenter !== undefined ) {
            x = x - worldCenter[ 0 ];
            y = y - worldCenter[ 1 ];
            z = z - worldCenter[ 2 ];

            maxX = maxX - worldCenter[ 0 ];
            maxY = maxY - worldCenter[ 1 ];
            maxZ = maxZ - worldCenter[ 2 ];
        }
        bs._center = osg.vec3.fromValues( x, y, z );
        bs._radius = osg.vec3.dist( bs.center(), osg.vec3.fromValues( maxX, maxY, maxZ ) );

        // Protection under unknown conditions or empty projects (getprojct extents)
        if ( bs._radius === Infinity ) {
            console.warn( '_radius for boundingSphere is Infinity, causing matrix problems. Changed by 0' );
            bs._radius = 0;
        }

        return bs;
    },

    getIsOrtho: function () {
        return this._ortho;
    },

    toggleProjectionManipulator: function ( useHomePositions ) {
        this._ortho = !this._ortho;
        this.setEnableOrtho( this._ortho, useHomePositions );
    },

    setEnableOrtho: function ( enable, useHomePositions ) {
        this._ortho = enable;
        var viewMatrix = this.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var factor = 0.8;
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        const manipulator = this.getManipulator();

        if ( this._cadManipulator === undefined )
            return;
        if ( manipulator === undefined )
            return;

        if ( useHomePositions ) {
            eye = manipulator._homeEye;
            center = manipulator._homeCenter;
            up = manipulator._homeUp;
        }

        manipulator.setEnableOrtho( this._ortho );
        if ( this._ortho ) {

            manipulator.setHomePosition( eye, center, up );
            manipulator.setCamera( this.getCamera() );

            var target = manipulator._target;
            //
            var d = osg.vec3.distance( target, eye ) * factor;
            if ( this._sceneView === undefined ) return;
            var half = d * Math.tan( this._sceneView.getProject().getCurrentRenderSettings().get( 'fieldOfView' ) * Math.PI / 180 );

            var frustum = {};
            frustum.left = -half;
            frustum.right = half;
            frustum.bottom = -half;
            frustum.top = half;
            manipulator.setOrthoFrustum( frustum );
            manipulator.setNode( this.getSceneData() );
            manipulator.setTarget( target );

            manipulator.computeFrustum();
            return;
        }
        if ( !this._ortho ) {
            var perspective = osg.mat4.getPerspective( osg.mat4.create(), this.getCamera().getProjectionMatrix() );
            if ( this._sceneView === undefined )
                return;
            if ( !this._sceneView.getProject().getCurrentRenderSettings() )
                return;
            osg.mat4.perspective( this.getCamera().getProjectionMatrix(), this._sceneView.getProject().getCurrentRenderSettings().get( 'fieldOfView' ) * Math.PI / 180.0,
                this.getCamera().getViewport().width() / this.getCamera().getViewport().height(), perspective.zNear, perspective.zFar );
        }
    },

    // Uncomment this to change update the target.
    getTargetTemp: function () {
        var w = this.getCamera().getViewport().width();
        var h = this.getCamera().getViewport().height();
        var offset = this.getCamera().getView().getOffsetRect( this.getCamera().getView().getCanvas(), [] );
        var event = new MouseEvent( 'center', {
            clientX: offset[ 1 ] + ( ( w / window.devicePixelRatio ) / 2.0 ),
            clientY: offset[ 0 ] + ( ( h / window.devicePixelRatio ) / 2.0 )
        } );

        var target = new osg.vec3.create();
        var interTarget = this.getIntersectionPoint( event );
        if ( interTarget )
            target = interTarget;
        return target;
    },

    getIntersectionPoint: function ( event ) {
        var hit, matrix;
        if ( event === undefined ) return;
        var hits = this.getCamera().getView().computePolytopeIntersections( event );
        var point = osg.vec3.create64();
        if ( hits.length <= 0 ) return;

        hits.sort( function ( a, b ) {
            if ( a._distance === undefined || b._distance === undefined )
                return 0;
            return a._distance - b._distance;
        } );
        hit = hits[ 0 ];
        for ( var i = 0; i < hit._nodePath.length; i++ ) {
            if ( hit._nodePath[ i ] instanceof SceneNode ) {
                break;
            }
        }
        var scenePath = hit._nodePath.slice( i );

        matrix = osg.computeLocalToWorld( scenePath );
        osg.vec3.transformMat4( point, hit._localIntersectionPoint, matrix );
        return point;
    },

    computeCADManipulatorTarget: function ( target ) {

        var viewMatrix = this.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        // using the target to get the distance
        var distance = osg.vec3.distance( eye, target );

        this.resetManipulatorTarget( center, distance );
    },

    resetManipulatorTarget: function ( center, distance ) {
        var manipulator = this.getManipulator();
        manipulator.computeHomePosition();
        /* Force target, distance and pivot point in the manipulator
           The node is the SceneView, and the CADManipulator computes this
           values using the default assigned node
           */
        manipulator.setDistance( distance );
        manipulator.setTarget( center );
        if ( manipulator.setPivotPoint ) //some manipulators don't have this function
            manipulator.setPivotPoint( center );
    },

    changeViewPoint: function ( view, options ) {
        // changing the active view for the tools

        var viewMatrix = this.getCamera().getViewMatrix();
        var eye = osg.vec3.create64();
        var center = osg.vec3.create64();
        var up = osg.vec3.create64();
        osg.mat4.getLookAt( eye, center, up, viewMatrix, 1.0 );

        if ( this._sceneView !== undefined )
            center = this.getTargetTemp();

        var finalPosition = osg.vec3.create();
        var directorVect = osg.vec3.create();
        osg.vec3.sub( directorVect, eye, center );
        osg.vec3.normalize( directorVect, directorVect );
        if ( view.centerObj !== undefined )
            center = view.centerObj;
        var distance = osg.vec3.distance( eye, center );
        if ( view.distance !== undefined )
            distance = view.distance;


        var local = false;
        var topBottomAngle = ( 0.0005 * Math.PI ) / 180;

        const isPanoramaMode = this._sceneView.getCurrentManipulatorModeKey() === pcvizManipulator.PANORAMA_MANIPULATOR;

        if ( ( view.id === undefined || view.id === Utils.GLOBAL_ZOOM ) && ( this._ortho || isPanoramaMode ) ) {
            if ( isPanoramaMode ) {
                // Zoom using Panorama mode (FirstPersonManipulator)
                this._sceneView.setPose( eye, center );
                this.setFOV( 35.0 );
                return;
            }

            directorVect = osg.vec3.fromValues( 0, -Math.sin( topBottomAngle ), Math.cos( topBottomAngle ) );
            up = this.getManipulator()._upz;
            var r = view.radius;
            var frustum = {};

            // This ratio is used to get a better result on the zoom of the scene
            var ratio = this._canvas.clientWidth / this._canvas.clientHeight;

            frustum.left = -r * ratio;
            frustum.right = r * ratio;
            frustum.bottom = -r * ratio;
            frustum.top = r * ratio;
            if ( view.distance > 10000 )
                this._resetNearFar = true;
            this.getManipulator().setOrthoFrustum( frustum );
            this.getManipulator().computeFrustum();
        } else {
            if ( view.id !== undefined ) {
                switch ( view.id ) {
                case Utils.GLOBAL_ZOOM:
                    var eyeTemp = osg.vec3.fromValues( center[ 0 ], center[ 1 ] + distance, distance * Math.sin( ( -30 * Math.PI ) / 180 ) );
                    directorVect = osg.vec3.fromValues( center[ 0 ] - eyeTemp[ 0 ], center[ 1 ] - eyeTemp[ 1 ], center[ 2 ] - eyeTemp[ 2 ] );
                    osg.vec3.normalize( directorVect, directorVect );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.TOP_VIEW:
                case Utils.TOP_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( 0, -Math.sin( topBottomAngle ), Math.cos( topBottomAngle ) );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.BOTTOM_VIEW:
                case Utils.BOTTOM_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( 0, -Math.sin( topBottomAngle ), -Math.cos( topBottomAngle ) );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.LEFT_VIEW:
                case Utils.LEFT_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( -1, 0, 0 );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.RIGHT_VIEW:
                case Utils.RIGHT_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( 1, 0, 0 );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.FRONT_VIEW:
                case Utils.FRONT_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( 0, -1, 0 );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.BACK_VIEW:
                case Utils.BACK_GLOBAL_ZOOM:
                    directorVect = osg.vec3.fromValues( 0, 1, 0 );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.ISOMETRIC_VIEW:
                    if ( !this._ortho )
                        return;
                    directorVect = osg.vec3.fromValues( 1, 1, 1 );
                    up = osg.vec3.fromValues64( 0, 0, 1 );
                    break;
                case Utils.TOP_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).R;
                    break;
                case Utils.FRONT_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).S;
                    break;
                case Utils.RIGHT_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).T;
                    break;
                case Utils.BOTTOM_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).R;
                    directorVect = osg.vec3.scale( directorVect, directorVect, -1 );
                    break;
                case Utils.BACK_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).S;
                    directorVect = osg.vec3.scale( directorVect, directorVect, -1 );
                    break;
                case Utils.LEFT_LOCAL_ZOOM:
                    if ( options.layer === undefined )
                        return;
                    local = true;
                    directorVect = this.getOrCreateEigenAxis( options.layer, options.feature, options.node ).T;
                    directorVect = osg.vec3.scale( directorVect, directorVect, -1 );
                    break;
                }
            } else {
                up = osg.vec3.fromValues64( 0, 0, 1 );
            }
        }

        directorVect[ 0 ] = directorVect[ 0 ] * distance;
        directorVect[ 1 ] = directorVect[ 1 ] * distance;
        directorVect[ 2 ] = directorVect[ 2 ] * distance;

        osg.vec3.add( finalPosition, center, directorVect );
        var manipulator = this.getManipulator();
        manipulator.setHomePosition( finalPosition, center, up );
        this.resetManipulatorTarget( center, distance );
    },

    computeZoom: function () {
        try {
            if ( this._zoomSavedView ) {
                var infoTool = this._arrayTools.find( function ( tool ) {
                    return ( tool.getId() === 'information' );
                } );
                this._sceneView.setSavedView( this._zoomSavedView, infoTool );
                return;
            }

            if ( this._zoomLayer === undefined && this._zoomExtent !== undefined && !this._zoomExtent ) {
                this.resetState( this._sceneView._rootNode );
                return;
            }

            if ( this._zoomLayer !== undefined && this._zoomFeature === undefined ) {
                this.zoomToLayer( this._zoomLayer, this._zoomOptions );
                return;
            }
            if ( this._zoomLayer !== undefined && this._zoomFeature !== undefined ) {
                this.zoomToFeature( this._zoomLayer, this._zoomFeature, this._zoomOptions );
                return;
            }

            if ( this._zoomExtent !== undefined && this._zoomExtent ) {
                this.zoomToExtent( this._zoomExtent, this._zoomOptions );
            }
            if ( this._zoomOptions !== undefined ) {
                this.changeViewPoint( {
                    id: this._zoomOptions.zoomOptions,
                }, this._zoomOptions );
            }
        } finally {
            this._firstZoom = false;
            this._zoomLayer = undefined;
            this._zoomOptions = undefined;
            this._zoomFeature = undefined;
            this._zoomExtent = undefined;
            this._zoomSavedView = undefined;
        }
    },

    setZoomLayer: function ( zoomLayer ) {
        this._zoomLayer = zoomLayer;
    },

    setZoomOptions: function ( zoomOptions ) {
        this._zoomOptions = zoomOptions;
    },

    setZoomFeature: function ( zoomFeature ) {
        this._zoomFeature = zoomFeature;
    },

    setZoomExtent: function ( zoomExtent ) {
        this._zoomExtent = zoomExtent;
    },

    setZoomNamedView: function ( viewData ) {
        this._zoomSavedView = viewData;
    },

    setImageModeByUrl: function ( value ) {
        this._imageModeByUrl = value;
    },

    // To overwrite the method implemented in osgViewer. We want to add events to the current manipulator.
    setManipulator: function ( manipulator ) {
        osgViewer.Viewer.prototype.setManipulator.call( this, manipulator );
        if ( this._eventProxy.Hammer._hammer ) {
            this._eventProxy.Hammer._hammer.on( 'panstart ', this._eventProxy.Hammer.getManipulatorController()._cbPanStart );
            this._eventProxy.Hammer._hammer.on( 'panmove', this._eventProxy.Hammer.getManipulatorController()._cbPanMove );
            this._eventProxy.Hammer._hammer.on( 'panend', this._eventProxy.Hammer.getManipulatorController()._cbPanEnd );
            this._eventProxy.Hammer._hammer.on( 'pinchstart', this._eventProxy.Hammer.getManipulatorController()._cbPinchStart );
            this._eventProxy.Hammer._hammer.on( 'pinchend', this._eventProxy.Hammer.getManipulatorController()._cbPinchEnd );
            this._eventProxy.Hammer._hammer.on( 'pinchin pinchout', this._eventProxy.Hammer.getManipulatorController()._cbPinchInOut );
            this._eventProxy.Hammer._hammer.on( 'tap', this._eventProxy.Hammer.getManipulatorController()._cbDoubleTap );
        }
    },

    interceptControllerFunctions: function ( manipulator ) {
        var standardMouseKeyboard = manipulator.getControllerList().StandardMouseKeyboard;
        var mousemove = standardMouseKeyboard.mousemove.bind( standardMouseKeyboard );
        var mouseup = standardMouseKeyboard.mouseup.bind( standardMouseKeyboard );
        var mousedown = standardMouseKeyboard.mousedown.bind( standardMouseKeyboard );
        standardMouseKeyboard.mousemove = this.setControllerFunction( mousemove, false );
        standardMouseKeyboard.mouseup = this.setControllerFunction( mouseup, false );
        standardMouseKeyboard.mousedown = this.setControllerFunction( mousedown, false );
    },

    shouldInterceptMouseFn: function () {
        return ( ( Utils.isTouchEnabled() || ( window.matchMedia && window.matchMedia( '(any-pointer:coarse)' ).matches ) ) && Utils.isEdge() && MagnetAPI.isSite() );
    },

    setControllerFunction( func, isTouchEnabled ) {
        var self = this;
        return ( ev ) => {
            if ( self._enableTouchController === isTouchEnabled )
                func( ev );
        };
    },

    setNewZoom( flag ) {
        this._newZoom = flag;
    },

    isBatterySaverEnabled() {
        if ( this.getSceneView() === undefined )
            return false;
        return Registry.getController( 'UserPreferences' ).getPreference( Utils.BATTERY_SAVER );
    },

    resetViewerStats() {
        this._stats = undefined;
    },

    computeLodFactor( LODsetting ) {
        this._LODfactor = LODsetting / 50;
    },

    // to reset lastNear, lastFar in ClampProjectionCallback
    needsResetNearFar() {
        return this._resetNearFar;
    },

    setResetNearFar( flag ) {
        this._resetNearFar = flag;
    }

} );

module.exports = Viewer;


/***/ }),

/***/ "./sources/pcvizViewer/pcvizViewer.js":
/*!********************************************!*\
  !*** ./sources/pcvizViewer/pcvizViewer.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Viewer = __webpack_require__( /*! pcvizViewer/Viewer */ "./sources/pcvizViewer/Viewer.js" );
var ShaderCompiler = __webpack_require__( /*! pcvizViewer/ShaderCompiler */ "./sources/pcvizViewer/ShaderCompiler.js" );

/** @namespace pcvizViewer */
var pcvizViewer = {};
pcvizViewer.Viewer = Viewer;
pcvizViewer.ShaderCompiler = ShaderCompiler;
module.exports = pcvizViewer;


/***/ }),

/***/ "./sources/pcvizViewer/shaders/bufferBox.glsl":
/*!****************************************************!*\
  !*** ./sources/pcvizViewer/shaders/bufferBox.glsl ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const int numVertices = 50;\n\nvoid bufferColor( inout vec4 color )\n{\n    if ( onlyBuffer > 0.0 )\n       color.a = 0.0;\n\n    vec3 v = Vertex + tileOrigin + pointBuffer;\n\n    float x1 = v[0],\n        y1 = v[1],\n        z1 = v[2];\n\n    float w = auxMat[0][3] * x1 + auxMat[1][3] * y1 + auxMat[2][3] * z1 + auxMat[3][3];\n    v[0] = (auxMat[0][0] * x1 + auxMat[1][0] * y1 + auxMat[2][0] * z1 + auxMat[3][0])/w;\n    v[1] = (auxMat[0][1] * x1 + auxMat[1][1] * y1 + auxMat[2][1] * z1 + auxMat[3][1])/w;\n    v[2] = (auxMat[0][2] * x1 + auxMat[1][2] * y1 + auxMat[2][2] * z1 + auxMat[3][2])/w;\n\n    vec3 vaux2;\n    vaux2[0] = v[0] * cos(-boxRotation) - v[1] * sin(-boxRotation);\n    vaux2[1] = v[0] * sin(-boxRotation) + v[1] * cos(-boxRotation);\n    vaux2[2] = v[2];\n\n    vec3 vaux3;\n    vaux3 = vaux2 - boxMin;\n    \n    float dx = length(lineBuffer[0]);\n    float dy = length(lineBuffer[1]);\n    float dz = length(lineBuffer[2]);\n    float x = dot(vaux3, lineBuffer[0])/dx;\n    float y = dot(vaux3, lineBuffer[1])/dy;\n    float z = dot(vaux3, lineBuffer[2])/dz;\n\n    if ( vaux2[0] > boxMin[0] && vaux2[0] < boxMax[0] && vaux2[1] > boxMin[1] && vaux2[1] < boxMax[1] && vaux2[2] > boxMin[2] && vaux2[2] < boxMax[2] )\n    {\n        if ( useBaseColor > 0.0) {\n            color.a = 1.0;\n        } else {\n            if (x >= range && x <= dx - range && y >= range && y <= dy - range && z >= range && z <= dz - range)\n                color = minColor;\n            else { // color interpolation\n                float dMax = -1e30;\n                dMax = max(dMax, x - (dx-range));\n                dMax = max(dMax, y - (dy-range));\n                dMax = max(dMax, z - (dz-range));\n                dMax = max(dMax, range - x);\n                dMax = max(dMax, range - y);\n                dMax = max(dMax, range - z);\n                dMax /= range;\n                color = mix( minColor, maxColor, vec4(dMax,dMax,dMax,1.0) );\n            }\n        }\n    }\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/bufferLine.glsl":
/*!*****************************************************!*\
  !*** ./sources/pcvizViewer/shaders/bufferLine.glsl ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const int numVertices = 50;\n\nvoid bufferColor( inout vec4 color )\n{\n    if ( onlyBuffer > 0.0 )\n       color.a = 0.0;\n\n    float dmin=1000.0;\n    int nv = numBufferVertices -1;\n    for ( int i = 0; i < numVertices - 1; i++ )\n    {\n        if ( i < nv ){\n            vec3 x12 = lineBuffer[i+1] - lineBuffer[i];\n            vec3 x01 =  Vertex + tileOrigin - lineBuffer[i];\n            float t = clamp( dot(x01, x12)/dot(x12, x12), 0.0, 1.0 );\n            float d = distance( lineBuffer[i] + (t*x12) - tileOrigin, Vertex );\n            if ( d < dmin )\n              dmin = d;\n        }\n    }\n\n    dmin /= range;\n\n    if ( dmin < 1.0 )\n    {\n       \n        if ( useBaseColor > 0.0) {\n            color.a = 1.0;\n        } else {\n            color = mix( minColor, maxColor, vec4(dmin,dmin,dmin,1.0) );\n        }\n    }\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/bufferPoint.glsl":
/*!******************************************************!*\
  !*** ./sources/pcvizViewer/shaders/bufferPoint.glsl ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const float MAX_FLT_NUMBER = 3.0e+10;\n\nvoid bufferColor( inout vec4 color )\n{\n    if (Vertex[0] == MAX_FLT_NUMBER && Vertex[1] == MAX_FLT_NUMBER && Vertex[2] == MAX_FLT_NUMBER)\n        return;\n    if (onlyBuffer > 0.0)\n       color.a = 0.0;\n    float dist;\n    dist = distance( Vertex, pointBuffer - tileOrigin );\n    if ( dist <= range )\n    {\n        if ( useBaseColor > 0.0 )\n        {\n            color.a = 1.0;\n        } else {\n            color = minColor * ( 1.0 - dist / range ) + maxColor * (dist / range);\n        }\n    }\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/bufferVerticalLine.glsl":
/*!*************************************************************!*\
  !*** ./sources/pcvizViewer/shaders/bufferVerticalLine.glsl ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const int numVertices = 50;\n\nvoid bufferColor( inout vec4 color )\n{\n    if ( onlyBuffer > 0.0 )\n       color.a = 0.0;\n\n    float dmin=1000.0;\n    int nv = numBufferVertices -1;\n    for ( int i = 0; i < numVertices - 1; i++ )\n    {\n        if ( i < nv ){\n            vec2 x12 = lineBuffer[i+1].xy - lineBuffer[i].xy;\n            vec2 localLine = lineBuffer[i].xy - tileOrigin.xy;\n            vec2 x01 = Vertex.xy - localLine;\n            float t = clamp( dot(x01, x12)/dot(x12, x12), 0.0, 1.0 );\n            float d = distance( lineBuffer[i].xy + (t*x12) - tileOrigin.xy, Vertex.xy);\n            if ( d < dmin )\n              dmin = d;\n        }\n    }\n\n    dmin /= range;\n\n    if ( dmin < 1.0 )\n    {\n       \n        if ( useBaseColor > 0.0) {\n            color.a = 1.0;\n        } else {\n            color = mix( minColor, maxColor, vec4(dmin,dmin,dmin,1.0) );\n        }\n    }\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/categorized.glsl":
/*!******************************************************!*\
  !*** ./sources/pcvizViewer/shaders/categorized.glsl ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computeIntensityPointColor( out vec4 color )\n{\n    float irange = ( maxIntensity - minIntensity );\n    irange = ( irange < 0.0001 ) ? 0.0001 : irange;\n    float I = Intensity/irange;\n    I = ( I <= 0.0001 ) ? 0.0 : I;\n    color = vec4( I, I, I, 1.0 );\n}\n\nvec3 hsv2rgb(vec3 c)\n{\n    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0/ 3.0, 3.0);\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0 ,1.0), c.y);\n}\n\nvoid computeElevationPointColor(out vec4 color)\n{\n    float interval_size = (maxZ - minZ);\n\n    float value = (dataCenter.z + Vertex.z + tileOrigin.z - minZ)/interval_size;\n    value = 1.0 - clamp(value, 0.0, 1.0);\n\n    color = vec4(hsv2rgb(vec3(value*0.7, 0.9, 0.9)), 1.0);\n}\n\nvoid computeClassificationColor(out vec4 color){\n    int iclassType = int(Classification) * 4;\n    color = vec4( classificationColorArray[ iclassType ], classificationColorArray[iclassType + 1] , classificationColorArray[ iclassType + 2], classificationColorArray[iclassType + 3 ]);\n}\n\nvoid computePointColor(out vec4 color)\n{\n    int iclassType = int(Classification);\n\n    if (drawingRuleArray[iclassType] == 0.0)\n    {\n        color = Color;\n    } else if (drawingRuleArray[iclassType] == 1.0)\n    {\n        computeIntensityPointColor(color);\n    } else if (drawingRuleArray[iclassType] == 2.0)\n    {\n        computeClassificationColor(color);\n    } else if (drawingRuleArray[iclassType] == 3.0)\n    {\n        computeElevationPointColor(color);\n    }\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/classification.glsl":
/*!*********************************************************!*\
  !*** ./sources/pcvizViewer/shaders/classification.glsl ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "\r\nvoid computePointColor(out vec4 color)\r\n{\r\n    color = vec4(1.0,0.0,0.0,1.0); // unknown\r\n    float classificationF = mod(Classification, 16.0);\r\n    if(classificationF == 0.0 ) //Never classified\r\n        color = vec4(0.0,0.0,0.0,1.0);\r\n    else if(classificationF == 1.0) //Unassigned\r\n        color = vec4(0.0,0.0,0.0,1.0);\r\n    else if(classificationF ==2.0) //Ground\r\n        color = vec4(0.61,0.33,0.25,1.0);\r\n    else if(classificationF ==3.0) //Low Vegetation\r\n        color = vec4(0.18,0.90,0.28,1.0);\r\n    else if(classificationF ==4.0) //Medium Vegetation\r\n        color = vec4(0.05,0.71,0.2,1.0);\r\n    else if(classificationF ==5.0) //High Vegetation\r\n        color = vec4(0.05,0.49,0.13,1.0);\r\n    else if(classificationF ==6.0) //Building\r\n        color = vec4(0.5,0.50,0.75,1.0);\r\n    else if(classificationF ==7.0) //Noise\r\n        color = vec4(1.0,1.0,1.0,1.0);\r\n    else if(classificationF ==8.0) //Model Key\r\n        color = vec4(0.7,0.0,0.7,1.0);\r\n    else if(classificationF ==9.0) //Water\r\n        color = vec4(0.0,0.70,1.0,1.0);\r\n    else if(classificationF ==10.0) //Reserved for ASPRS Definition\r\n        color = vec4(1.0,0.5,0.0,1.0);\r\n    else if(classificationF ==11.0) //Reserved for ASPRS Definition\r\n        color = vec4(1.0,0.5,0.5,1.0);\r\n    else if(classificationF ==12.0) //Overlap\r\n        color = vec4(1.0,1.0,0.0,1.0);\r\n    else if(classificationF ==13.0) //Reserved fro ASPRS Definition\r\n        color = vec4(0.5,0.0,1.0,1.0);\r\n    else if(classificationF ==14.0) //Reserved fro ASPRS Definition\r\n        color = vec4(0.5,0.5,1.0,1.0);\r\n    else if(classificationF ==15.0) //Reserved fro ASPRS Definition\r\n        color = vec4(0.0,1.0,0.5,1.0);\r\n}\r\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/elevation.glsl":
/*!****************************************************!*\
  !*** ./sources/pcvizViewer/shaders/elevation.glsl ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "/*\r\n * GLSL HSV to RGB+A conversion. Useful for many effects and shader debugging.\r\n *\r\n * Copyright (c) 2012 Corey Tabaka\r\n *\r\n * Hue is in the range [0.0, 1.0] instead of degrees or radians.\r\n * Alpha is simply passed through for convenience.\r\n */\r\n \r\nvec3 hsv2rgb(vec3 c)\r\n{\r\n    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0/ 3.0, 3.0);\r\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\r\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0 ,1.0), c.y);\r\n}\r\n\r\nvoid computePointColor(out vec4 color)\r\n{\r\n    float intervalSize = ( maxZ - minZ );\r\n\r\n    float value = (dataCenter.z + Vertex.z + tileOrigin.z - minZ)/intervalSize;\r\n    value = (repeatRange == 1)? mod(value, 1.0): clamp(value, 0.0, 1.0);\r\n    value = 1.0 - value;\r\n\r\n    color = vec4(hsv2rgb(vec3(value*0.7, 0.9, 0.9)), 1.0);\r\n}\r\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/fixedcolor.glsl":
/*!*****************************************************!*\
  !*** ./sources/pcvizViewer/shaders/fixedcolor.glsl ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computePointColor(out vec4 color) {\n    color = fixedColor;\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/fragment.glsl":
/*!***************************************************!*\
  !*** ./sources/pcvizViewer/shaders/fragment.glsl ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "//#define USE_FRAG_DEPTH\r\n#ifdef USE_FRAG_DEPTH\r\n#extension GL_EXT_frag_depth : enable\r\n#endif\r\n//precision mediump float;\r\nprecision highp float;\r\n\r\nuniform float geometry;\r\n\r\nvarying vec4 pointColor;\r\n\r\nvarying vec3 normal;\r\n\r\nvarying vec3 rotnormal;\r\n\r\nvarying mat4 mvm;\r\n\r\nvoid main(void) {\r\n\r\n    if (pointColor.a == 0.0)\r\n        discard;\r\n\r\n    if(geometry == 1.0) \r\n    {\r\n        vec2 xyNormal = normalize(rotnormal.xy);\r\n\r\n        vec2 uv = gl_PointCoord.xy - vec2(0.5,0.5);\r\n        vec2 rotUV = vec2(xyNormal.y * uv.x + xyNormal.x * uv.y, -xyNormal.x* uv.x + xyNormal.y * uv.y);\r\n        rotUV.y = rotUV.y / rotnormal.z;\r\n\r\n        float d2 = dot(rotUV, rotUV);\r\n        if (d2 > 0.25)\r\n            discard;\r\n\r\n        #ifdef USE_FRAG_DEPTH\r\n        //gl_FragDepthEXT = gl_FragCoord.z + 0.2*(1.0-(1.0 - d)*(1.0 - d)) * gl_FragCoord.w;\r\n        gl_FragDepthEXT = gl_FragCoord.z + 0.2 * d2 * gl_FragCoord.w;\r\n        #endif\r\n\r\n    } else if (geometry == 0.5) {\r\n\r\n        vec2 coord = gl_PointCoord.xy - vec2(0.5,0.5); \r\n        float d2  = dot(coord, coord);\r\n        if( d2 > 0.25)  //outside of circle\r\n            discard;\r\n\r\n        #ifdef USE_FRAG_DEPTH\r\n        //gl_FragDepthEXT = gl_FragCoord.z + 0.2*(1.0-(1.0 - d)*(1.0 - d)) * gl_FragCoord.w;\r\n        gl_FragDepthEXT = gl_FragCoord.z + 0.2 * d2 * gl_FragCoord.w;\r\n        #endif\r\n\r\n    } else {\r\n        #ifdef USE_FRAG_DEPTH\r\n        gl_FragDepthEXT = gl_FragCoord.z ;\r\n        #endif\r\n    }\r\n\r\n    gl_FragColor = vec4(pointColor.r, pointColor.g, pointColor.b, pointColor.a);\r\n\r\n\r\n}\r\n\r\n\r\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/geometry.glsl":
/*!***************************************************!*\
  !*** ./sources/pcvizViewer/shaders/geometry.glsl ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "float computeDistanceSplat(){ \n    vec2 xyNormal = normalize( RotNormal.xy );\n    vec2 uv = gl_PointCoord.xy - vec2( 0.5, 0.5 );\n    vec2 rotUV = vec2( xyNormal.y * uv.x + xyNormal.x * uv.y, -xyNormal.x* uv.x + xyNormal.y * uv.y );\n    rotUV.y = rotUV.y / RotNormal.z;\n    return dot( rotUV, rotUV );\n}\n\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/heatMap.glsl":
/*!**************************************************!*\
  !*** ./sources/pcvizViewer/shaders/heatMap.glsl ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const float RED_CHARACTERISTIC_VALUE = 0.0;\r\nconst float GREEN_CHARACTERISTIC_VALUE = 0.5;\r\nconst float BLUE_CHARACTERISTIC_VALUE = 1.0;\r\nconst float DISTANCE_FOR_FULL_VALUE = 0.25;\r\nconst float DISTANCE_FOR_ANY_VALUE = 0.5;\r\n\r\nfloat getColorValue(in float value, in float characteristicValue)\r\n{\r\n    float distanceFromCharac = abs(value - characteristicValue);\r\n    float colorValue = 0.0;\r\n    if(distanceFromCharac < DISTANCE_FOR_FULL_VALUE)\r\n    {\r\n        colorValue = 1.0;\r\n    }\r\n    else if( distanceFromCharac < DISTANCE_FOR_ANY_VALUE)\r\n    {\r\n        float valueMinusFullValue = distanceFromCharac - DISTANCE_FOR_FULL_VALUE;\r\n        float ratio = valueMinusFullValue / (DISTANCE_FOR_ANY_VALUE - DISTANCE_FOR_FULL_VALUE);\r\n        colorValue = 1.0 - ratio;\r\n    }\r\n    return colorValue;\r\n}\r\n\r\nvec4 convertToColor(in float value)\r\n{\r\n    float r = getColorValue(value, RED_CHARACTERISTIC_VALUE);\r\n    float g = getColorValue(value, GREEN_CHARACTERISTIC_VALUE);\r\n    float b = getColorValue(value, BLUE_CHARACTERISTIC_VALUE);\r\n\r\n    return vec4(r,g,b,1.0);\r\n}\r\n\r\nvoid computePointColor(out vec4 color)\r\n{\r\n    float value = getHeatMapValue();\r\n    color = ( value >= 0.0 ) ? convertToColor(value) : Color;\r\n}\r\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/heatmapElevation.glsl":
/*!***********************************************************!*\
  !*** ./sources/pcvizViewer/shaders/heatmapElevation.glsl ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "/*\n * GLSL HSV to RGB+A conversion. Useful for many effects and shader debugging.\n *\n * Copyright (c) 2012 Corey Tabaka\n *\n * Hue is in the range [0.0, 1.0] instead of degrees or radians.\n * Alpha is simply passed through for convenience.\n * \n * Shader for the elevation drawing rule requested for CRE\n */\n\nconst int _maxSteps = 50;\nvec3 hsv2rgb(vec3 c)\n{\n    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0/ 3.0, 3.0);\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0 ,1.0), c.y);\n}\n\nfloat getSteppedValue(float value, int steps)\n{\n    float stepSize = 1.0 / float(steps); // normalized between 0 and 1\n    float fictizeStepSize = 1.0 / float(steps+1); // color step values\n\n    float modulus = mod(tolerance, incSize);\n\n    if(abs(modulus-incSize) < 0.000001 || modulus<0.000001) { // Sometimes there are precision issues with the division (or with subtract/multiply inside mod)\n        modulus = 0.0;\n    }\n\n    float ratio = modulus != 0.0 ? incSize/modulus : 0.0;\n\n    float halfSteps = (float(steps)/2.0);\n\n    float modulusPonderated = 0.5/(ratio * (halfSteps-1.0) + 1.0) * (ratio);\n\n    float valueComputed = 0.0;\n    // Initialize and condition should be constants. So I start at 0, and use a fictice max\n    for(int i = 1; i < _maxSteps; i++) { // i should be started to 1\n        if(i > steps) // steps is the real max of iterations\n            break;\n\n        if(modulus != 0.0) {\n            if(i > steps/2) {\n                float modStep = mod(float(i), halfSteps);\n                if (abs(modStep-float(steps/2)) < 0.000001)\n                    modStep = 0.0;\n\n                valueComputed = 0.5 - modStep * modulusPonderated;\n            }\n            else {\n                float modStep = mod(float(steps-i), halfSteps);\n                if (abs(modStep-float(steps/2)) < 0.000001)\n                    modStep = 0.0;\n\n                valueComputed = 0.5 + modStep * modulusPonderated;\n            }\n        }\n\n        if(step(modulus != 0.0 ? valueComputed : stepSize * float(steps-i), value) == 1.0)\n            return fictizeStepSize * (float(steps-i+1));\n    }\n    return fictizeStepSize; // 0.0\n}\n\nvoid computePointColor(out vec4 color)\n{\n    // float z = dataCenter.z + Vertex.z + tileOrigin.z - dataMT[3][2];\n\n    vec3 v = Vertex + tileOrigin + dataCenter;\n    float x1 = v[0],\n        y1 = v[1],\n        z1 = v[2];\n\n    float w = dataMT[0][3] * x1 + dataMT[1][3] * y1 + dataMT[2][3] * z1 + dataMT[3][3];\n    v[0] = (dataMT[0][0] * x1 + dataMT[1][0] * y1 + dataMT[2][0] * z1 + dataMT[3][0])/w;\n    v[1] = (dataMT[0][1] * x1 + dataMT[1][1] * y1 + dataMT[2][1] * z1 + dataMT[3][1])/w;\n    v[2] = (dataMT[0][2] * x1 + dataMT[1][2] * y1 + dataMT[2][2] * z1 + dataMT[3][2])/w;\n    // If there is a custom planeNormal, we should ignore refElevation (or set to 0). If not using custom planeNormal, we should ignore planeConstant (or set to 0).\n    float z = v[0] * planeNormal[0] + v[1] * planeNormal[1] + v[2] * planeNormal[2] + planeConstant;\n\n    // Same as \"original\" elevation\n    if(elevationPolicy == 0){\n        float intervalSize = ( maxZ - minZ );\n\n        float value = (z - minZ) / intervalSize;\n        value = clamp(value, 0.0, 1.0);\n        value = 1.0 - value;\n\n        color = vec4(hsv2rgb(vec3(value*0.7, 0.9, 0.9)), 1.0);\n        return;\n    }\n  \n    // Hide points above and below some range if the flag is set to true\n    if ( hideAboveBelow == 1 && clamp(z, refElevation-hideAboveBelowSize, refElevation+hideAboveBelowSize) != z )\n    {\n        color.a = 0.0;\n        return; \n    }\n\n    float halfTolerance = tolerance; // For better understanding\n    float doubleTolerance = tolerance * 2.0;\n\n    float value = (z - refElevation + halfTolerance) / doubleTolerance; // We sum halfTolerance to set green colour in the center.\n    // And we divide by the tolerance instead of by incSize to set the colour gradation filling the whole tolerance space\n    // If repeatRange is active use mod function, else use clamp function\n    value = repeatRange == 0 ? clamp(value, 0.0, 1.0) : mod(value, 1.0);\n    if(elevationPolicy == 2) { // STEPPED\n        float stepsFloat = tolerance / incSize;\n        int steps = int(ceil(stepsFloat));\n        value = getSteppedValue(value, steps * 2);\n    }\n\n    value = 1.0 - value;\n\n    color = vec4(hsv2rgb(vec3(value*0.7, 0.9, 0.9)), 1.0);\n\n    // If repeatRange is NOT active\n    if(repeatRange == 0) {\n        // Set red and blue above/below the tolerance range\n        if(z < (refElevation - halfTolerance))\n            color = vec4(0.0, 0.0, 1.0, 1.0); // blue\n        else if(z > (refElevation + halfTolerance))\n            color = vec4(1.0, 0.0, 0.0, 1.0); // red\n    }\n\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/intensity.glsl":
/*!****************************************************!*\
  !*** ./sources/pcvizViewer/shaders/intensity.glsl ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computePointColor(out vec4 color)\r\n{\r\n    float irange = (maxIntensity-minIntensity);\r\n    irange = (irange<0.0001)?0.0001:irange;\r\n    float I = (Intensity-minIntensity)/irange;\r\n    I = (I<=0.0001)?0.0:I;\r\n    color = vec4(I,I,I,1.0);\r\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/intensitycolor.glsl":
/*!*********************************************************!*\
  !*** ./sources/pcvizViewer/shaders/intensitycolor.glsl ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "/*\n * GLSL HSV to RGB+A conversion. Useful for many effects and shader debugging.\n *\n * Copyright (c) 2012 Corey Tabaka\n *\n * Hue is in the range [0.0, 1.0] instead of degrees or radians.\n * Alpha is simply passed through for convenience.\n */\n\nvec3 hsv2rgb(vec3 c)\n{\n    vec4 K = vec4(1.0, 2.0 / 3.0, 1.0/ 3.0, 3.0);\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0 ,1.0), c.y);\n}\n\nvoid computePointColor(out vec4 color)\n{\n    float irange = (maxIntensity-minIntensity);\n    irange = (irange<0.0001)?0.0001:irange;\n    float I = (Intensity-minIntensity)/irange;\n    I = (I<=0.0001)? 1.0: (1.0-I);\n    I = clamp(I,0.0,1.0);\n    color = vec4(hsv2rgb(vec3(I*0.7, 0.9, 0.9)), 1.0);\n}\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/lighting.glsl":
/*!***************************************************!*\
  !*** ./sources/pcvizViewer/shaders/lighting.glsl ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computeLighting( inout vec4 color ) {\n\n        if (Normal.x != 0.0 || Normal.y != 0.0 || Normal.z != 0.0)        \n        {\n          float lightFactor = 0.5 * abs(Normal.x  * 0.0    + Normal.y * 0.8660 + Normal.z * 0.5);\n          lightFactor += 0.5 * abs(Normal.x  * 0.7071 + Normal.y *  0.0    + Normal.z * 0.7071);\n          lightFactor = 1.0 + 1.2 * (lightFactor-0.5); // add ambient component\n\n          color = vec4(lightFactor * color.r, lightFactor * color.g, lightFactor * color.b, color.a);\n        }           \n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/rgb.glsl":
/*!**********************************************!*\
  !*** ./sources/pcvizViewer/shaders/rgb.glsl ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computePointColor(out vec4 color) {\r\n    color = Color;\r\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/selected.glsl":
/*!***************************************************!*\
  !*** ./sources/pcvizViewer/shaders/selected.glsl ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computePointSelection(inout vec4 color) {\n    if(Visible == 0.0)\n        color = color;\n    else if(Visible == 1.0)\n        color = selectColor;\n    else if(Visible == 2.0)\n        color = vec4(0.0,0.0,0.0,0.0);\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/side.glsl":
/*!***********************************************!*\
  !*** ./sources/pcvizViewer/shaders/side.glsl ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computeSideVisualization( in vec4 glPosition, inout vec4 color) {\n    float clipPosX = glPosition.x / glPosition.w;\n    if( (side == 0) || ((clipPosX <= sideDivider) && (side == 2)) || ((clipPosX > sideDivider) && (side == 1)) ){\n        color.a = 0.0;\n    }\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/splat.glsl":
/*!************************************************!*\
  !*** ./sources/pcvizViewer/shaders/splat.glsl ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "void computeRotNormal()\r\n{\r\n    vec4 eyeNormal = uModelViewMatrix * vec4( Normal.xyz, 0.0 );\r\n    eyeNormal = normalize( eyeNormal );\r\n\r\n    //float depthFactor = eyeNormal.z;\r\n    if ( abs( eyeNormal.z ) < 0.2 ) \r\n        eyeNormal.z = 0.2*sign( eyeNormal.z );\r\n\r\n    RotNormal.xy = normalize( eyeNormal.xy );\r\n    RotNormal.z = eyeNormal.z;\r\n}"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/utils.glsl":
/*!************************************************!*\
  !*** ./sources/pcvizViewer/shaders/utils.glsl ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "\nvoid computePointSize( in vec4 fragEyeVec, out float size )\n{\n    size = pointSize;\n    if( automaticPointSize > 0 )\n    {\n        if ( Distance > maxDistance * levelFactor ) {\n            size = 0.0;\n        } else {\n            // changes for PROXIMITY-BASED POINT SIZE\n            size = Distance * sizeFactor / -fragEyeVec.z;\n        }\n        size = clamp( size, 3.0 * devicePixelRatio, 20.0 * devicePixelRatio );\n    }\n}\n\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/verityHeatmap.glsl":
/*!********************************************************!*\
  !*** ./sources/pcvizViewer/shaders/verityHeatmap.glsl ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "const float FAR_NEGATIVE_COLORVALUE = 1.0;\nconst float FAR_POSITIVE_COLORVALUE = 0.0;\n\nconst int GradientSmooth = 0;\nconst int GradientStepped = 1;\n\nfloat convertToHeatmap(in float inputValue)\n{\n    // Custom if for managing 'empty' values\n    if(inputValue < 0.0)\n        return inputValue;\n    \n    // the number to multiply by the tolerance to find where the colors are saturated to a single color\n    float toleranceMultiplier = heatmapOptionsGradientRange;//double\n\n    // if true, negative displacements are the same color as positive displacements\n    // bool symetricColors = (this.mHeatmapOptions.Symmetry== HeatmapOptions.SymmetryType.Symmetric);\n\n    // whether to use steps versus a linear continuous transition\n    bool useStepsForColors = (heatmapOptionsGradientStyle != GradientSmooth);\n\n    // if steps are to be used, if true the steps are equally wide NOW we only have this option\n    bool useEquallyWideSteps = true;\n\n    // if in equally divided step mode, this is the number of steps to divide the dynamic range by\n    int nEquallyDividedSteps = heatmapOptionsNumberOfSteps;\n\n    //if in stepped dimensional mode, this is the length of the steps\n    //Length dimensionalStepLength = this.mHeatmapOptions.DimensionalStepLength;\n\n    // if in stepped dimensional mode, this is the length in modelunits for each step\n    // double lengthOfDimensionalStepInModelUnits = Constants.FloatingPointTolerance;\n\n    // define the thresholds for saturation\n    float lowEndCuttoffInModelUnits = -1.0 * toleranceMultiplier * toleranceInModelUnits;//double\n    float upperEndCuttoffInModelUnits = toleranceMultiplier * toleranceInModelUnits;//double\n\n    // dynamic range\n    float distanceFromLowToHighInModelUnits = upperEndCuttoffInModelUnits - lowEndCuttoffInModelUnits;//double\n\n    // this means that at zero displacement,the color value is 0.5 (green)\n    const float colorValueAtZero = 0.5;//double\n\n    // for stepped modes, define the step dimensions\n    float stepWidthInColorValues = 0.0;//double\n    float distanceToMiddleOfColorStep = 0.0;//double\n\n    if (useStepsForColors)\n    {\n        if (useEquallyWideSteps)\n        {\n            // the full dynamic color range is divided up\n            const float colorRangeUsedInThisCalc = 0.5;//double\n            stepWidthInColorValues = colorRangeUsedInThisCalc / float(nEquallyDividedSteps);//double\n        }\n        /* else\n        {\n            double dynamicRangeOsPlusSide = toleranceMultiplier * this.mToleranceInModelUnits;\n            if (lengthOfDimensionalStepInModelUnits < dynamicRangeOsPlusSide)\n            {\n                int nDimensionalSteps = (int)ceil(dynamicRangeOsPlusSide / lengthOfDimensionalStepInModelUnits);\n\n                //0.5 is the color range from either extreme to the color value at 0 \n                stepWidthInColorValues = 0.5 / nDimensionalSteps;\n            }\n            else\n            {\n                stepWidthInColorValues = 0.5;\n            }\n        }*/\n\n        distanceToMiddleOfColorStep = stepWidthInColorValues * 0.5;\n    }\n    // else do nothing\n\n    float lowEndColorValue = FAR_NEGATIVE_COLORVALUE;//double\n    /* if(symetricColors == true)\n    {\n        lowEndColorValue = FAR_POSITIVE_COLORVALUE;\n    }*/\n    // else do not change\n\n\n    // Here starts original loop\n\n    float outputValue;//double\n    if (inputValue < lowEndCuttoffInModelUnits)\n    {\n        outputValue = lowEndColorValue;\n    }\n    else if(inputValue > upperEndCuttoffInModelUnits)\n    {\n        outputValue = FAR_POSITIVE_COLORVALUE;\n    }\n    else\n    {\n\n        /*if (useStepsForColors == true && useEquallyWideSteps == false)\n        {\n            // because we are doing a different type of step, we break it out completely\n\n            // inputValue is all ready relative to zero\n            double stepsFromZero = 0.0;\n\n            if (inputValue >= 0.0)\n            {\n                stepsFromZero = Math.Floor(inputValue / lengthOfDimensionalStepInModelUnits);\n            }\n            else\n            {\n                stepsFromZero = ceil(inputValue / lengthOfDimensionalStepInModelUnits);\n            }\n\n            // this is the color value at the edge of color step closest to zero relative to zero\n            // we are still not in the right value since 0 displacement should be 0.5 \n            // the negative is in because the color scale and the displacement scale are anti proportional\n            double colorValueAtStepEdgeClosestToZeroRelativeToZero = -1.0 * stepsFromZero * stepWidthInColorValues;\n\n            // add the half step in the correct direction to bring us to the middle of the step\n            double colorValueDifferenceFromColorAtZero;\n            if(symetricColors == true)\n            {\n                // if we are in symmetric mode, then we make sure the colorvalue is negative and subtract the half step \n                colorValueDifferenceFromColorAtZero = (-1.0 * Math.Abs(colorValueAtStepEdgeClosestToZeroRelativeToZero)) - distanceToMiddleOfColorStep;                            \n            }\n            else if(inputValue > 0.0)\n            {\n                // move it more in the negative direction\n                colorValueDifferenceFromColorAtZero = colorValueAtStepEdgeClosestToZeroRelativeToZero - distanceToMiddleOfColorStep;\n            }\n            else\n            {\n                // move it more in the positive direction\n                colorValueDifferenceFromColorAtZero = colorValueAtStepEdgeClosestToZeroRelativeToZero + distanceToMiddleOfColorStep;\n            }\n\n            \n            outputValue = colorValueAtZero + colorValueDifferenceFromColorAtZero;\n        }*/\n        // else\n        // {\n            float distanceFromLowCuttoffToInput = inputValue - lowEndCuttoffInModelUnits;//double\n            \n            float ratio = distanceFromLowCuttoffToInput / distanceFromLowToHighInModelUnits;//double\n\n            float colorValue;//double\n            /*if (symetricColors == false)\n            {\n                // because 0.0 -> red -> upperEndCuffoff\n                // because 1.0 -> blue -> lowerEnd\n                // anti proprtional\n                colorValue = 1.0 - ratio;\n            }*/\n            //else\n            // {\n                // 0.5 => green \n                // 0.0 => red\n                // no blue 1.0 => red\n                float distanceFromhalf = abs(ratio - 0.5);//double\n                colorValue = 0.5 - distanceFromhalf;\n            // }\n\n\n            outputValue = colorValue;\n\n            if (useStepsForColors == true)\n            {\n                if (useEquallyWideSteps == true)\n                {\n                    float stepN = floor(colorValue / stepWidthInColorValues);//double\n\n                    // stepN * stepWidth -> puts you at the low end value of the color step \n                    // add the half step to get to the middle;\n                    outputValue = stepN * stepWidthInColorValues + distanceToMiddleOfColorStep;\n                }\n                // else do nothing\n            }\n            // else do nothing\n        //}\n    }\n\n\n    return outputValue;\n\n}\n\n"

/***/ }),

/***/ "./sources/pcvizViewer/shaders/vertex.glsl":
/*!*************************************************!*\
  !*** ./sources/pcvizViewer/shaders/vertex.glsl ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = "attribute vec3 Vertex;\r\nattribute vec4 Color;\r\nattribute float Intensity;\r\nattribute float Classification;\r\nattribute float Distance;\r\nattribute vec3 Normal;\r\nattribute float Visible;\r\n\r\n\r\nuniform mat4 uModelViewMatrix;\r\nuniform mat4 uProjectionMatrix;\r\nuniform float pointSize;\r\nuniform float automaticPointSize;\r\nuniform float sizeFactor;\r\nuniform float maxIntensity;\r\nuniform float minIntensity;\r\nuniform float maxZ;\r\nuniform float minZ;\r\nuniform int repeatRange;\r\nuniform vec3 dataCenter;\r\nuniform float maxDistance;\r\nuniform float levelFactor;\r\nuniform int lightsOn;\r\nuniform float classificationActive[14];\r\nuniform float geometry;\r\nuniform float devicePixelRatio;\r\nuniform float drawingRuleArray[14];\r\nuniform float lightingArrayEnabled;\r\nuniform float lightingArray[14];\r\n\r\nuniform vec3 tileOrigin;\r\n\r\n// buffer tool\r\nuniform float bufferActive;\r\nconst int _npoints = 50; //  ADDED DYNAMICALLY in updateStateSet\r\n\r\nuniform vec3 lineBuffer[50]; //  ADDED DYNAMICALLY\r\nuniform vec4 minColor;\r\nuniform vec4 maxColor;\r\nuniform float range;\r\nuniform float bufferMode;\r\nuniform float onlyBuffer;\r\nuniform float baseColorBuffer;\r\nuniform vec4 selectColor;\r\n\r\nuniform float alpha;\r\n\r\n// side by side\r\nuniform int side;\r\nuniform float sideDivider;\r\n\r\n// out\r\nvarying vec4 pointColor;\r\n\r\nvarying vec3 normal;\r\n\r\nvarying vec3 rotnormal;\r\n\r\nvarying mat4 mvm;\r\n\r\nvarying float p3d;\r\n\r\n// forward declaration\r\nvoid computePointColor(out vec4 color);\r\n\r\nfloat computePointSize(float d)\r\n{\r\n    float size = pointSize;\r\n    if( automaticPointSize > 0.0 )\r\n    {\r\n        if ( Distance > maxDistance * levelFactor ) {\r\n            size = 0.0;\r\n        } else {\r\n            // changes for PROXIMITY-BASED POINT SIZE\r\n            size = Distance * sizeFactor / -d;\r\n        }\r\n        size = clamp( size, 3.0 * devicePixelRatio, 20.0 * devicePixelRatio );\r\n    }\r\n    return size;\r\n}\r\n\r\nvoid computeRotNormal()\r\n{\r\n    vec4 eyeNormal = uModelViewMatrix * vec4(normal.xyz, 0.0);\r\n    eyeNormal = normalize(eyeNormal);\r\n\r\n    //float depthFactor = eyeNormal.z;\r\n    if (abs(eyeNormal.z) < 0.2)\r\n        eyeNormal.z = 0.2*sign(eyeNormal.z);\r\n\r\n    rotnormal.xy = normalize(eyeNormal.xy);\r\n    rotnormal.z = eyeNormal.z;\r\n}\r\n\r\nvoid computeLighting(inout vec4 color) {\r\n\r\n    int iclassType = int(Classification);\r\n\r\n    if ( ( ( lightingArrayEnabled == 0.0 ) && ( lightsOn == 1 ) ) || ( ( lightingArrayEnabled == 1.0 )  && ( lightingArray[iclassType] > 0.0 ) ) )\r\n    {\r\n        float lightFactor = 0.5 * abs(Normal.x  * 0.0    + Normal.y * 0.8660 + Normal.z * 0.5);\r\n\r\n        lightFactor += 0.5 * abs(Normal.x  * 0.7071 + Normal.y *  0.0    + Normal.z * 0.7071);\r\n        lightFactor = 1.0 + 1.2 * (lightFactor-0.5); // add ambient component\r\n\r\n        color = vec4(lightFactor * color.r, lightFactor * color.g, lightFactor * color.b, 1.0);\r\n    }\r\n}\r\n\r\nvec4 bufferLineColor(vec4 colorIn)\r\n{\r\n    vec4 color = colorIn;\r\n\r\n\r\n    if (onlyBuffer > 0.0)\r\n       color.a = 0.0;\r\n\r\n    if (bufferMode == 0.0)\r\n    {\r\n        float dist;\r\n        dist = distance(Vertex,lineBuffer[0] - tileOrigin);\r\n        if ( dist <= range )\r\n        {\r\n            color = minColor * ( 1.0 - dist / range ) + maxColor * dist / range;\r\n            if (baseColorBuffer > 0.0)\r\n            {\r\n                color = colorIn;\r\n                color.a = 1.0;\r\n            }\r\n        }\r\n    } else if (bufferMode == 1.0)\r\n    {\r\n        float dmin=1000.0;\r\n        for (int i=0; i<_npoints-1; i++)\r\n        {\r\n            if (lineBuffer[i].x == 999.999 &&\r\n                lineBuffer[i].y == 999.999 &&\r\n                lineBuffer[i].z == 999.999)\r\n                break;\r\n            if (lineBuffer[i+1].x == 999.999 &&\r\n                lineBuffer[i+1].y == 999.999 &&\r\n                lineBuffer[i+1].z == 999.999)\r\n                break;\r\n\r\n            vec3 x12 = lineBuffer[i+1] - lineBuffer[i];\r\n            vec3 x01 = lineBuffer[i] - tileOrigin - Vertex;\r\n            float t = -dot(x01, x12)/dot(x12, x12);\r\n            if ( t < 0.0 )\r\n                t=0.0;\r\n            if ( t > 1.0 )\r\n                t=1.0;\r\n            float d = distance( lineBuffer[i] - tileOrigin + (t*x12), Vertex);\r\n            if (d<dmin)\r\n              dmin=d;\r\n        }\r\n        dmin /= range;\r\n\r\n\r\n        //vec4 color = maxColor;//vec4(1.0,1.0,0.0,1.0);\r\n        if ( dmin < 1.0 )\r\n        {\r\n            color = mix(minColor,maxColor,vec4(dmin,dmin,dmin,1.0));\r\n            if (baseColorBuffer > 0.0)\r\n            {\r\n                color = colorIn;\r\n                //color = vec4(1.0,1.0,0.0,1.0);\r\n                color.a = 1.0;\r\n            }\r\n            //color.a = onlyBuffer;\r\n        }\r\n\r\n    } else if (bufferMode == 2.0)\r\n    {\r\n\r\n              float dmin=1000.0;\r\n        for (int i=0; i<_npoints-1; i++)\r\n        {\r\n            if (lineBuffer[i].x == 999.999 &&\r\n                lineBuffer[i].y == 999.999 &&\r\n                lineBuffer[i].z == 999.999)\r\n                break;\r\n            if (lineBuffer[i+1].x == 999.999 &&\r\n                lineBuffer[i+1].y == 999.999 &&\r\n                lineBuffer[i+1].z == 999.999)\r\n                break;\r\n\r\n            vec2 x12 = lineBuffer[i+1].xy - lineBuffer[i].xy;\r\n            vec2 x01 = lineBuffer[i].xy  - tileOrigin.xy - Vertex.xy;\r\n            float t = -dot(x01, x12)/dot(x12, x12);\r\n            if ( t < 0.0 )\r\n                t=0.0;\r\n            if ( t > 1.0 )\r\n                t=1.0;\r\n            float d = distance( lineBuffer[i].xy - tileOrigin.xy +(t*x12), Vertex.xy);\r\n            if (d<dmin)\r\n              dmin=d;\r\n        }\r\n        dmin /= range;\r\n\r\n\r\n        //vec4 color = maxColor;//vec4(1.0,1.0,0.0,1.0);\r\n        if ( dmin < 1.0 )\r\n        {\r\n            color = mix(minColor,maxColor,vec4(dmin,dmin,dmin,1.0));\r\n            if (baseColorBuffer > 0.0)\r\n            {\r\n                color = colorIn;\r\n                color.a = 1.0;\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    return color;\r\n}\r\n\r\nvoid main(void) {\r\n    normal = Normal;\r\n    if(geometry == 1.0)\r\n        computeRotNormal();\r\n    mvm = uModelViewMatrix;\r\n\r\n    int iclassType = int(Classification);\r\n    if (classificationActive[iclassType] == 0.0)\r\n        pointColor = vec4(0.0,0.0,0.0,0.0);\r\n    else\r\n    {\r\n        computePointColor( pointColor );\r\n        computeLighting( pointColor );\r\n\r\n        pointColor.a = alpha;\r\n\r\n        if (bufferActive > 0.0)\r\n            pointColor = bufferLineColor( pointColor );\r\n    }\r\n\r\n\r\n    vec4 pos = uModelViewMatrix * vec4( Vertex, 1.0 );\r\n    gl_PointSize = computePointSize( pos.z );\r\n    gl_Position = uProjectionMatrix * pos;\r\n\r\n    // Depth offset to draw points above terrain\r\n    gl_Position.z = gl_Position.z - 1.0;\r\n\r\n}\r\n"

/***/ }),

/***/ "./sources/pcvizWorkflow/C2C.js":
/*!**************************************!*\
  !*** ./sources/pcvizWorkflow/C2C.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js");
/* harmony import */ var pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1__);



class C2C {
    constructor( workflow ) {
        this._workflow = workflow;
    }

    launchRegistrationJob( fixedStation, movingStation, method, project, suffixJobName ) {

        return new Promise( ( resolve, reject ) => {
            let registrationStations = [];
            let workspaceStations = [];

            const c2cLinkManager = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'C2CLink' );

            let pushRegistrationStation = function ( station, staArray ) {
                let sta = {};
                sta.uuid = station.uuid;
                sta.transform = station.transformMatrix;
                sta.parameters = {};
                let find = staArray.find( ( element ) => element.uuid === sta.uuid );
                if ( !find )
                    staArray.push( sta );
            };

            let pushWorkspaceStations = function ( station, staArray ) {
                let find = staArray.find( ( element ) => element.uuid === station.uuid );
                if ( !find )
                    staArray.push( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( station.uuid ).getWorkspaceObj() );
            };

            let selectedBundle = this._workflow.getRegistrationObject().processedBundles.find( ( bundle ) => {
                return bundle.find( ( sta ) => { return sta.uuid === fixedStation.uuid; } );
            } );


            let secondarySelectedBundle = this._workflow.getRegistrationObject().processedBundles.find( ( bundle ) => {
                return bundle.find( ( sta ) => { return sta.uuid === movingStation.uuid; } );
            } );

            pushRegistrationStation( movingStation, registrationStations );
            pushRegistrationStation( fixedStation, registrationStations );
            pushWorkspaceStations( movingStation, workspaceStations );
            pushWorkspaceStations( fixedStation, workspaceStations );

            c2cLinkManager.setSelectedBundle( selectedBundle ? selectedBundle : secondarySelectedBundle );

            // getting edges
            let extraData = c2cLinkManager.getEdge( fixedStation.uuid, movingStation.uuid );
            if ( !extraData.edges.length ) { // launched from script
                // add the edges parameter 
                extraData = {
                    edges: [ {
                        'fixedStationUuid': fixedStation.uuid,
                        'movingStationUuid': movingStation.uuid
                    } ]
                };

                // adding root nodes, for now the first node of a bundle it is the root node of this bundle
                let prop = { rootStationUuid: fixedStation.uuid };
                extraData.properties = prop;
            }

            // getting selections from point editing tool
            let selectionsObj = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' ).getTool( 'pointEdition' ).getSelectionProcess( true );
            extraData.selections = selectionsObj.selections;
            if ( extraData.selections && extraData.selections.length ) {
                extraData.scans = [];
                workspaceStations.forEach( station => {
                    const uuid = this.getSelectedScanUuid( station );
                    if ( uuid ) {
                        extraData.scans.push( uuid );
                    }
                } );
            }

            // if there are two bundles affected, get the edges of both of them
            let edges = c2cLinkManager.getEdges( extraData, selectedBundle ? secondarySelectedBundle : undefined );
            // upload here edges.json
            this._workflow.uploadEdgesFile( project, edges ).then( () => {
                    let edgeFile = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0___default.a.PROCESS_DATA_PATH_PREFIX + this._workflow._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0___default.a.EDGES_FILE_PATH;
                    this._workflow.getConfiguredJobAndUploadWorkspaceFiles( method, registrationStations, workspaceStations, this._workflow.SCANTASK.REGISTER_C2C_PROCESS, [ edgeFile ], extraData, undefined, project, suffixJobName ).then( ( job ) => { resolve( job ); } );
                },
                ( error ) => {
                    reject( error );
                    console.error( 'Error uploading edges.json' );
                } );
        } );
    }

    getSelectedScanUuid( station ) {
        let uuid = '';
        station.children.forEach( child => {
            if ( child.category === 'ScansFolder' && child.children && child.children.length ) {
                child.children.forEach( scan => {
                    uuid = scan.uuid;
                } );
            }
        } );

        return uuid;
    }

    // Used by C2COptimizeBundle 
    launchC2CFullRegistration( project, suffixJobName ) {

        return new Promise( ( resolve ) => {
            let registrationStations = [];
            let workspaceStations = [];

            let pushRegistrationStation = function ( station, staArray ) {
                let sta = {};
                sta.uuid = station.uuid;
                sta.transform = station.transformMatrix;
                sta.parameters = {};
                let find = staArray.find( ( element ) => element.uuid === sta.uuid );
                if ( !find )
                    staArray.push( sta );
            };

            let pushWorkspaceStations = function ( station, staArray ) {
                let find = staArray.find( ( element ) => element.uuid === station.uuid );
                if ( !find ) // We should get the station from WorkspaceDataCahe or WorkspaceVisitor
                    staArray.push( pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( station.uuid ).getWorkspaceObj() );
            };

            const c2cLinkManager = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'C2CLink' );

            c2cLinkManager.getLinkArray().forEach( ( link ) => {
                if ( c2cLinkManager.isLinkInSelectedBundle( link ) ) {
                    pushRegistrationStation( link.fixedStation, registrationStations );
                    pushRegistrationStation( link.movingStation, registrationStations );

                    pushWorkspaceStations( link.fixedStation, workspaceStations );
                    pushWorkspaceStations( link.movingStation, workspaceStations );
                }
            } );

            // getting edges
            let edges = c2cLinkManager.getEdges();

            // getting selections from point editing tool
            let extraData = {};
            let selectionsObj = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'View' ).getView( '3D' ).getTool( 'pointEdition' ).getSelectionProcess( true );
            extraData.selections = selectionsObj.selections;
            if ( extraData.selections && extraData.selections.length ) {
                extraData.scans = [];
                workspaceStations.forEach( station => {
                    const uuid = this.getSelectedScanUuid( station );
                    if ( uuid ) {
                        extraData.scans.push( uuid );
                    }
                } );
            }

            //upload here edges.json
            this._workflow.uploadEdgesFile( project, edges ).then( () => {
                    let edgeFile = pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0___default.a.PROCESS_DATA_PATH_PREFIX + this._workflow._version + '/' + pcvizWorkflow_Workflow__WEBPACK_IMPORTED_MODULE_0___default.a.EDGES_FILE_PATH;
                    this._workflow.getConfiguredJobAndUploadWorkspaceFiles( 'full', registrationStations, workspaceStations, this._workflow.SCANTASK.REGISTER_C2C_PROCESS, [ edgeFile ], extraData, undefined, project, suffixJobName ).then( ( job ) => { resolve( job ); } );
                },
                () => console.error( 'Error uploading edges.json' ) );
        } );
    }

    // REVIEW: I think we don't need two index values 
    launchManualRegistration( index, project, tempLinkIndex, launchLinkStations ) {
        let registrationObject = this._workflow.getRegistrationObject();
        registrationObject.selectedLink = index;
        registrationObject.tmpLinkIndex = tempLinkIndex;
        // this.registrationObject.tmpWorkspace = this.getBackWorkspace();
        const c2cLinkManager = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_1___default.a.getInstance().getController( 'C2CLink' );
        c2cLinkManager.saveLinks();
        c2cLinkManager.clearLinks();
        if ( launchLinkStations )
            this._workflow.setShowSpinner( true );
        let promise = launchLinkStations ? this._workflow.runTask( project, this._workflow.SCANTASK.LINK_STATIONS ) : Promise.resolve();
        promise.then( () => {
            this._workflow.runTask( project, this._workflow.SCANTASK.C2C_MANUAL ).then( () => {}, () => {
                console.error( 'The C2C manual task can not been launched' );
            } ).finally( () => {
                this._workflow.setShowSpinner( false );
            } );
        } ).catch( () => {
            this._workflow.setShowSpinner( false );
        } );
    }

}

/* harmony default export */ __webpack_exports__["default"] = (C2C);


/***/ }),

/***/ "./sources/pcvizWorkflow/GenericConstants.js":
/*!***************************************************!*\
  !*** ./sources/pcvizWorkflow/GenericConstants.js ***!
  \***************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return GenericConstants; });
class GenericConstants {
    static getGenericStates() {
        let GENERICSTATE = {};
        GENERICSTATE.BASE = 'Base';
        GENERICSTATE.EXPORT = 'Exporting';
        GENERICSTATE.PROCESSING_POINTCLOUDS = 'ProcessingPointclouds';
        return GENERICSTATE;
    }

    static getGenericTasks() {
        let GENERICTASK = {};
        GENERICTASK.EXPORT_PANORAMAS = 'ExportPanoramas';
        GENERICTASK.PROCESS_POINTCLOUDS = 'ProcessPointclouds';
        return GENERICTASK;
    }
}


/***/ }),

/***/ "./sources/pcvizWorkflow/GenericWorkflow.js":
/*!**************************************************!*\
  !*** ./sources/pcvizWorkflow/GenericWorkflow.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


const Workflow = __webpack_require__( /*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js" );
const Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
const GenericConstants = __webpack_require__( /*! pcvizWorkflow/GenericConstants */ "./sources/pcvizWorkflow/GenericConstants.js" ).default;
const Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
const { Sources } = __webpack_require__( /*! pcvizGIS/PointCloudLayer */ "./sources/pcvizGIS/PointCloudLayer.js" );

const GenericWorkflow = function () {
    Workflow.call( this );

    this.GENERICSTATE = GenericConstants.getGenericStates();
    this.GENERICTASK = GenericConstants.getGenericTasks();


    this._stateMachine = [
        // initial state, no images
        {
            name: this.GENERICSTATE.BASE,
            tip: 'GENERIC_HELP.TIP_BASE',
            help: 'GENERIC_HELP.HELP_BASE',
            push: true,
            tasks: [ {
                name: this.GENERICTASK.PROCESS_POINTCLOUDS,
                visible: () => this.hasJavelinPointclouds()
            }, {
                name: this.GENERICTASK.EXPORT_PANORAMAS,
                visible: true,
                enabled: () => this.hasProcessedPanoramas()
            } ]
        },
        {
            name: this.GENERICSTATE.PROCESSING_POINTCLOUDS,
            tip: 'GENERIC_HELP.TIP_PROCESSING_POINTCLOUDS',
            help: 'GENERIC_HELP.HELP_PROCESSING_POINTCLOUDS',
            push: false,
            tasks: []
        }
    ];

    this._taskInfo.set( this.GENERICTASK.EXPORT_PANORAMAS, {
        icon: 'pcviz-icon-export-scan',
        tip: 'GENERIC_HELP.TIP_ExportPanoramas',
        help: 'GENERIC_HELP.HELP_ExportPanoramas',
        main: true
    } );

    this._taskInfo.set( this.GENERICTASK.PROCESS_POINTCLOUDS, {
        icon: 'process-scan',
        tip: 'GENERIC_HELP.TIP_ProcessPointclouds',
        help: 'GENERIC_HELP.HELP_ProcessPointclouds',
        main: true
    } );

    this.setStateAndTasks( this.GENERICSTATE.BASE );
};

GenericWorkflow.prototype = Utils.objectInherit( Workflow.prototype, {

    getClassName: function () {
        return 'GenericWorkflow';
    },

    getHelpPrefix: function () {
        return 'GENERIC';
    },

    getInstance: function () {
        return new GenericWorkflow();
    },

    writeToJSON: function () {

        // do not save some properties
        let savedStateNames = this.GENERICSTATE;
        let savedTaskNames = this.GENERICTASK;
        this.GENERICSTATE = undefined;
        this.GENERICTASK = undefined;

        let savedData = Workflow.prototype.writeToJSON.call( this );

        this.GENERICSTATE = savedStateNames;
        this.GENERICTASK = savedTaskNames;

        return savedData;
    },

    // state machine transitions
    runTask: function ( project, taskName ) {
        return new Promise( ( resolve ) => {
            this._hasToRefresh = false;
            const found = this._tasks.find( ( task ) => ( task && task.name === taskName ) );
            if ( !found && taskName !== Workflow.TASK.FINISH ) {
                console.log( `Generic Workflow: task ${taskName} not defined for state ${this._state}` );
                resolve();
                return;
            }

            switch ( this._state ) {
            case this.GENERICSTATE.BASE:
                if ( taskName === this.GENERICTASK.PROCESS_POINTCLOUDS ) {
                    this.setStateAndTasks( this.GENERICSTATE.PROCESSING_POINTCLOUDS );
                }
                break;
            case this.GENERICSTATE.EXPORT:
                if ( taskName === this.GENERICTASK.EXPORT_PANORAMAS ) {
                    this.setStateAndTasks( this.GENERICSTATE.EXPORT );

                }
                break;
            case this.GENERICSTATE.PROCESSING_POINTCLOUDS:
                if ( taskName === Workflow.TASK.FINISH ) {
                    this.backToPreviousState();
                }
                break;
            default:
                console.warn( `trying to set ${taskName} from state ${this._state}` );
            }
            this.writeToProject( project ).then( () => {
                resolve();
            } );
        } );
    },

    isProgressState: function () {
        return false;
    },

    saveVersionContent: function ( destinationVersion ) {
        Object.keys( destinationVersion ).forEach( ( attr ) => {
            if ( attr.startsWith( '$' ) ) {
                console.log( attr );
                delete destinationVersion[ attr ];
            }
        } );
    },

    hasProcessedPanoramas() {
        const project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        const layers = project.getAllLayers();
        return layers.some( ( layer ) => layer.getType() === LayerType.VECTOR && VectorLayerUtils.isPanorama( layer.getCategory() ) && !layer.isIncomplete() );
    },

    hasJavelinPointclouds() {
        const project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        const layers = project.getAllLayers();
        return layers.some( ( layer ) => layer.getType() === LayerType.POINTCLOUD && layer.getCapturedIn() === Sources.JAVELIN );
    },

    needCancelState: function () {
        return false;
    },

    // For compatibility with current progress bar (REVIEW)
    getWaitingStateByJobName( jobName ) {
        // Implemented with a switch because it is probable we add more cases
        switch ( jobName ) {
        case this.GENERICTASK.PROCESS_POINTCLOUDS:
            return this.GENERICTASK.PROCESS_POINTCLOUDS;
        }
    }
} );

module.exports = GenericWorkflow;


/***/ }),

/***/ "./sources/pcvizWorkflow/ProcessScans.js":
/*!***********************************************!*\
  !*** ./sources/pcvizWorkflow/ProcessScans.js ***!
  \***********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ProcessScans; });
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js");
/* harmony import */ var pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var pcvizDB_WorkspaceController__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! pcvizDB/WorkspaceController */ "./sources/pcvizDB/WorkspaceController.js");
/* harmony import */ var pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js");
/* harmony import */ var pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js");





class ProcessScans {
    constructor( workflow, project, jobsService, TranslationService ) {
        this._workflow = workflow;
        this._project = project;
        this._jobsService = jobsService;
        this._jobAdapter = pcvizJobs_JobAdapterRegistry__WEBPACK_IMPORTED_MODULE_3__["default"].getImporter( 'SPA' );
        this._translationService = TranslationService;
        this._scanWorkflowJobData = {};
        this.workspaceController = pcvizDB_Registry__WEBPACK_IMPORTED_MODULE_0___default.a.getInstance().getController( 'Workspace' );

        this.initScanJobData();
    }

    setJobAdapter( keepOptions ) {
        this._jobAdapter.setJobType( 'ProcessScan' );
        this._jobAdapter.enableWorkspaceProject( true );
        this._jobAdapter.setExtraInputData( undefined ); // clear extra input data to avoid issues launching this task after a merge scans process

        if ( !keepOptions )
            this._jobAdapter.setOptions( this._project.getExtData().jobOptions );
    }

    initScanJobData() {
        this._scanWorkflowJobData.name = 'ProcessScan';
        this._scanWorkflowJobData.processId = undefined;
    }

    // Function used for CW in collage-front repository (Remove when CW uses new endpoint)
    launchProcess( job, scans ) {
        this.setJobAdapter( scans !== undefined );

        return new Promise( ( resolve, reject ) => {
            this.workspaceController.getOrCreateWorkspace( this._project, this._workflow.getCurrentVersion() ).then( workspace => {
                const scansVisitor = new pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_2__["default"]();
                scansVisitor.traverse( workspace.workspace );

                let getScans = scans ? Promise.resolve( scans ) : this.getScansFromJobResult( job );
                getScans.then( ( scansToProcess ) => {
                    this.setScansToProcess( scansToProcess, scansVisitor.getScans() );

                    if ( !this._jobAdapter.getScans() || !this._jobAdapter.getScans().length ) {
                        reject();
                        return;
                    }

                    delete this._scanWorkflowJobData.hasCalledFinishCB;

                    const newJob = this.configAndGetJob();
                    this.launchTaskProcess( newJob ).then( ( data ) => {
                        resolve( data );
                    } ).catch( () => {
                        reject();
                    } );
                } );
            } );
        } );
    }

    launchProcessByEndpoint( job, scans ) {
        this.setJobAdapter( scans !== undefined );

        return new Promise( ( resolve, reject ) => {
            this.workspaceController.getOrCreateWorkspace( this._project, this._workflow.getCurrentVersion() ).then( workspace => {
                const scansVisitor = new pcvizGIS_WorkspaceVisitor__WEBPACK_IMPORTED_MODULE_2__["default"]();
                scansVisitor.traverse( workspace.workspace );

                let getScans = scans ? Promise.resolve( scans ) : this.getScansFromJobResult( job );
                getScans.then( ( scansToProcess ) => {
                    this.setScansToProcess( scansToProcess, scansVisitor.getScans() );

                    if ( !this._jobAdapter.getScans() || !this._jobAdapter.getScans().length ) {
                        reject();
                        return;
                    }

                    delete this._scanWorkflowJobData.hasCalledFinishCB;

                    const jobData = this.configAndGetJobData();
                    this.launchTaskProcessByEndpoint( jobData ).then( ( data ) => {
                        resolve( data );
                    } ).catch( () => {
                        reject();
                    } );
                } );
            } );
        } );
    }

    getScansFromJobResult( job ) {
        return new Promise( ( resolve ) => {
            // if UPGRADE_SPARSE_TO_FULL, only set the scans in result
            this._jobsService.getJobResult( job.processId ).then( jobResult => {
                if ( jobResult && ( jobResult[ 'mwFilters' ] || jobResult[ 'updatedWorkspace' ] ) ) {
                    const newScans = this.getNewScans( jobResult[ 'mwFilters' ][ 0 ] );
                    const updatedScans = this.getUpdatedScans( jobResult[ 'updatedWorkspace' ] );

                    let scans = [];
                    if ( newScans && newScans.length )
                        scans = scans.concat( newScans );
                    if ( updatedScans && updatedScans.length )
                        scans = scans.concat( updatedScans );
                    resolve( scans );
                } else
                    resolve();
            } );
        } );
    }

    setScansToProcess( scansToProcess, scans ) {

        if ( scansToProcess !== undefined ) {
            const filteredScans = scans.filter( scan => ( scansToProcess.includes( scan.uuid ) ) );

            this._jobAdapter.setScans( filteredScans );
        } else {
            this._jobAdapter.setScans( scans );
        }

        delete this._jobAdapter.getOptions().name;
    }

    getNewScans( mwFilters ) {
        if ( !mwFilters || mwFilters === 'null' ) {
            return null;
        }

        return JSON.parse( mwFilters )[ 'newScans' ];
    }

    getUpdatedScans( updatedWorkspace ) {
        if ( !updatedWorkspace ) {
            return null;
        }

        return updatedWorkspace[ 0 ][ 'updatedScans' ];
    }

    // Function used for CW in collage-front repository (Remove when CW uses new endpoint)
    configAndGetJob() {
        const config = {
            jobName: `${this._project.getName()} - ${this._translationService.translate( 'SCANPROC.TASK_ProcessScan' ).toLowerCase()}`,
            files: [],
            fileSizes: [],
            catalogId: this._project.getProjectDataset().getDriver().getEntryPoint(
                'projects',
                this._project.getId()
            )
        };

        this._jobAdapter.computeName( config, this._translationService );
        return this._jobAdapter.getCompleteJob( config );
    }

    configAndGetJobData() {
        const jobData = {
            'jobName': `${this._project.getName()} - ${this._translationService.translate( 'SCANPROC.TASK_ProcessScan' ).toLowerCase()}`,
            'scans': this._jobAdapter.getScansUUIDs(),
            'outputData': { 'scans': this._jobAdapter.configureOutputScans() },
            'options': this._jobAdapter._options
        };
        if ( this._jobAdapter._extraOuputData ) {
            Object.assign( jobData.outputData, this._extraOutputData );
        }
        return jobData;
    }

    // Function used for CW in collage-front repository (Remove when CW uses new endpoint)
    launchTaskProcess( job ) {
        const error = {
            message: '',
            code: ''
        };

        return new Promise( ( resolve, reject ) => {
            this._workflow.uploadWorkspace( this._project ).then( () => {
                this._workflow.uploadWorkspaceProcess( this._project, job.getPipeline() ).then( () => {
                    const workspaceDownloadProjectJson = this.getWksDownloadProjectJson();

                    this.workspaceController.uploadDownloadWorkspaceFile( workspaceDownloadProjectJson ).then( () => {
                        job.create( true ).then( process => {
                            if ( !process ) {
                                return;
                            }
                            this.fillScanJobData( job.getJobId() );

                            resolve( this._scanWorkflowJobData );
                        }, () => {
                            error.code = 'showDialog';
                            error.message = 'Error creating the job';
                            reject( error );
                        } );
                    }, () => {
                        error.message = 'Error uploading workspaceProject.json';
                        reject( error );
                    } );
                }, () => {
                    error.message = 'Error uploading workspaceProcess.json';
                    reject( error );
                } );
            }, e => {
                reject( e );
            } );
        } );
    }

    launchTaskProcessByEndpoint( jobData ) {
        const error = {
            message: '',
            code: ''
        };

        return new Promise( ( resolve, reject ) => {
            const projectDriver = this._project.getProjectDataset().getDriver();
            const jobEndpoint = 'process-scans';
            projectDriver.launchWorkflowJob( this._project.getId(), jobData, jobEndpoint ).then( ( jobResult ) => {
                if ( !process ) {
                    return;
                }
                this.fillScanJobData( +jobResult.job.id, jobResult );

                resolve( this._scanWorkflowJobData );
            }, () => {
                error.code = 'process-scans';
                error.message = 'Error creating the job by process-scans endpoint';
                reject( error );
            } );
        } );
    }

    /**
     * Returns the pointcloud layers of the scans if panorama images are not needed
     * to avoid the download of images in the process.
     */
    getLayersForDownloadInProcessing() {
        const { processPanorama, colorize } = this._jobAdapter.getOptions();
        if ( processPanorama || colorize ) {
            return;
        }
        const scans = this._jobAdapter.getScans();
        let layers = [];
        scans.forEach( scan => {
            // Check this because there are scans without children layers.
            if ( !scan.children )
                return;
            scan.children.forEach( layer => {
                if ( layer.category === 'PointCloud' ) {
                    layers.push( layer );
                }
            } );
        } );
        return layers;
    }

    fillScanJobData( jobId, jobResult ) {
        const { processPointcloud, highQualityPointcloud } = this._jobAdapter.getOptions();
        this._scanWorkflowJobData.processId = jobId;
        const pointCloudLayersIds = [];
        if ( processPointcloud ) {
            // Check if there is a pointcloud (Some scans only have panoramas)
            for ( const scan of this._jobAdapter.getScans() ) {
                // Check scan.children this because there are scans without children layers.
                const pointcloudChild = scan.children && scan.children.find( child => child.category === 'PointCloud' );
                if ( pointcloudChild ) {
                    pointCloudLayersIds.push( pointcloudChild.catalogObjectId );
                }
            }
            this._scanWorkflowJobData.qualityOption = highQualityPointcloud;
        }
        this._scanWorkflowJobData.pointCloudLayersIds = pointCloudLayersIds;
        if ( jobResult )
            this._scanWorkflowJobData.processes = jobResult.job.processes;
    }

    getWksDownloadProjectJson() {
        const selectedLayers = this.getLayersForDownloadInProcessing();
        return this.workspaceController.createDownloadWorkspaceJson(
            this.workspaceController.getWorkspace(),
            this._jobAdapter.getScans(),
            selectedLayers,
            undefined,
            pcvizDB_WorkspaceController__WEBPACK_IMPORTED_MODULE_1__["default"].SELECT_MODE
        );
    }

    setDefaultOptions() {
        // options as sent by FS using libcollagewebapi, except from surfaceSmoothing (false), vertexFormatType, colorFormatType
        const options = {
            'processPointcloud': true,
            'highQualityPointcloud': false,
            'processPanorama': true,
            'panoramaResX': 4096,
            'panoramaResY': 2048,
            'panoramaRadius': 20,
            'precision': 0.001,
            'density': 0.001,
            'colorize': true,
            'maxProcesses': 1,
            'maxDistance': 400.0,
            'surfaceSmoothing': true,
            'strayFilter': false,
            'edgeNoiseReduction': true,
            'edgeNoiseReductionLevel': 1, // same than ScanProcessing.EDGE_NOISE_REDUCT_LEVELS[ 1 ].value (cannot access here)
        };
        if ( !options.highQualityPointcloud && navigator.hardwareConcurrency ) // It is necessary to check hardwareConcurrency because Safari doesn't return value
            options.maxProcesses = Math.max( 1, navigator.hardwareConcurrency - 2 );

        this._jobAdapter.setOptions( options );
    }
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../node_modules/process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./sources/pcvizWorkflow/ReportC2C.js":
/*!********************************************!*\
  !*** ./sources/pcvizWorkflow/ReportC2C.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizDataAccess_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! pcvizDataAccess/CollageWebFileBrowser */ "./sources/pcvizDataAccess/CollageWebFileBrowser.js");
/* harmony import */ var pcvizDataAccess_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(pcvizDataAccess_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_0__);


const METRICS_FILE = 'metrics.json';
const EDGES_FILE = 'edges.json';

class ReportC2C {
    constructor( c2cLinkManager, project ) {
        this._c2cLinkManager = c2cLinkManager;
        this._project = project;
        this._cwFileBrowser = new pcvizDataAccess_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_0___default.a();
    }

    getCwFileBrowser() {
        return this._cwFileBrowser;
    }

    getReportFile() {
        return this.getFileFromOutput( METRICS_FILE );
    }

    getFileFromOutput( name ) {
        return new Promise( ( resolve, reject ) => {
            this._cwFileBrowser.list( this._project, pcvizDataAccess_CollageWebFileBrowser__WEBPACK_IMPORTED_MODULE_0___default.a.OBJECT_TYPE.PROJECT, 'process_data/v1', undefined, true )
                .then( ( elementsList ) => {
                    if ( !elementsList.length ) {
                        reject( 'REPORT_FILE_NOT_FOUND' );
                        return;
                    }

                    const reportElement = elementsList.find( ( element ) => element.name === name );
                    if ( !reportElement ) {
                        reject( 'REPORT_FILE_NOT_FOUND' );
                        return;
                    }

                    //get file and resolve fileData
                    this._cwFileBrowser.retrieve( reportElement )
                        .then( ( fileData ) => {
                            resolve( fileData );
                        } )
                        .catch( ( e ) => reject( 'ERROR_GETTING_REPORT', e ) );
                }, () => {
                    reject( 'ERROR_GETTING_FILES' );
                } );
        } );
    }


    setReportByLink( file, index ) {
        let linkArray = this._c2cLinkManager.getLinkArray();
        file.metrics.forEach( ( element ) => {
            let linkFind = linkArray.find( link => {
                return ( link.fixedStation.uuid === element.fixedStationUuid && link.movingStation.uuid === element.movingStationUuid );
            } );
            //If we change order for stations in bundles we should change this.
            if ( !linkFind )
                linkFind = linkArray[ index ];
            if ( linkFind ) {
                linkFind.report = element.fineAlignmentMetrics;
            } else
                console.warn( 'no link found' );
        } );
    }

    applyColorsToLinkArray( file, index ) {
        let linkArray = this._c2cLinkManager.getLinkArray();
        linkArray.forEach( ( link, i ) => {
            let element = file.metrics.find( ( fileElement ) =>
                link.fixedStation.uuid === fileElement.fixedStationUuid && link.movingStation.uuid === fileElement.movingStationUuid
            );
            //If we change order for stations in bundles we should change this.
            if ( !element && index === i )
                element = file.metrics[ 0 ];

            if ( element )
                link.linkType = this._c2cLinkManager.computeLinkColor( element.fineAlignmentMetrics[ 'point_to_plane_rms' ] );
        } );
    }

    applyReportResults( index, forceNoDraw ) {

        return new Promise( ( resolve, reject ) => {
            this._c2cLinkManager.clearLinks();
            this.getReportFile().then( ( metricsFile ) => {
                this.getFileFromOutput( EDGES_FILE ).then( ( edgesFile ) => {
                    this.updateEdgesInformation( JSON.parse( edgesFile ) );
                    let file = JSON.parse( metricsFile );
                    this.setReportByLink( file, index );
                    this.applyColorsToLinkArray( file, index );
                    if ( !forceNoDraw )
                        this._c2cLinkManager.drawLinks( index );
                    this._c2cLinkManager.saveLinks();
                    resolve();
                } );
            } ).catch( () => {
                reject( 'C2C_REG.ERROR_METRICS' );
            } );
        } );

    }

    updateEdgesInformation( file ) {
        let linkArray = this._c2cLinkManager.getLinkArray();
        linkArray.forEach( ( link ) => {
            let element = file.edges.find( ( fileElement ) =>
                ( link.fixedStation.uuid === fileElement.fixedStationUuid && link.movingStation.uuid === fileElement.movingStationUuid ) ||
                ( link.movingStation.uuid === fileElement.fixedStationUuid && link.fixedStation.uuid === fileElement.movingStationUuid )
            );

            if ( element )
                link.edgeInformation = this._c2cLinkManager.updateLinkEdgeProperties( element );
        } );
    }
}

/* harmony default export */ __webpack_exports__["default"] = (ReportC2C);


/***/ }),

/***/ "./sources/pcvizWorkflow/ScanConstants.js":
/*!************************************************!*\
  !*** ./sources/pcvizWorkflow/ScanConstants.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ScanConstants; });
class ScanConstants {
    static getScanStates() {
        let SCANSTATE = {};
        // not related to jobs
        SCANSTATE.EMPTY = 'Empty';
        SCANSTATE.NOT_EMPTY = 'NotEmpty';
        SCANSTATE.IMPORT = 'Import';
        SCANSTATE.REGISTRATION = 'Registration';
        SCANSTATE.REGISTRATION_MANUAL = 'RegistrationManual';
        SCANSTATE.REGISTRATION_OCCBS = 'RegistrationOccBs';
        SCANSTATE.REGISTRATION_BYREFS = 'RegistrationByRefs';
        SCANSTATE.REGISTRATION_BYREFS_AUTO = 'RegistrationByRefsAuto';
        SCANSTATE.REGISTRATION_C2C = 'RegistrationC2CNew';
        SCANSTATE.EXPORT = 'Export';
        SCANSTATE.EXPORTING_SCAN = 'ExportingScan';
        SCANSTATE.LINKING_STATIONS = 'LinkingStations';
        // SCANSTATE.C2C_LINK_STATION = 'LinkStation';
        SCANSTATE.C2C_REMOVING_LINKS = 'RemovingLinks';
        SCANSTATE.ADJUSTING_BUNDLES = 'BundleAdjustment';
        SCANSTATE.TRANSFORMING_RASTER = 'TransformingRaster';
        SCANSTATE.SCAN = 'Scan';
        SCANSTATE.LOCALIZED = 'Localized';
        SCANSTATE.WAITING_FOR_IMPORT = 'WaitingImport';
        SCANSTATE.WAITING_FOR_PROCESS = 'WaitingProcess';
        SCANSTATE.EDIT_SCANS = 'EditScans';
        SCANSTATE.DELETION_TOOL = 'DeletionTool';
        SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES = 'GenerateAndExportDeliverables';
        SCANSTATE.CONTOURS_DELIVERABLES = 'ContoursDeliverables';
        SCANSTATE.VOLUME_DELIVERABLES = 'VolumeDeliverables';
        SCANSTATE.TIN_DELIVERABLES = 'TinDeliverables';
        SCANSTATE.ORTHOPHOTO_DELIVERABLES = 'OrthophotoDeliverables';
        SCANSTATE.VERIFY = 'Verify';
        SCANSTATE.MEASUREMENTS = 'Measurements';
        SCANSTATE.VOLUME_MEASURE = 'VolumeMeasure';
        SCANSTATE.AREA_MEASURE = 'AreaMeasure';
        SCANSTATE.DISTANCE_MEASURE = 'DistanceMeasure';
        SCANSTATE.VOLUME_SURFACE = 'VolumeSurface';
        SCANSTATE.VOLUME_QUANTITY = 'VolumeQuantity';
        SCANSTATE.VOLUME_STOCKPILE = 'VolumeStockpile';
        SCANSTATE.STANDARD_VERIFY = 'StandardVerify';
        SCANSTATE.VERIFING_ELEMENTS = 'VerifingElements';
        SCANSTATE.VERIFIED_ELEMENTS = 'VerifiedElements';
        SCANSTATE.TOTAL_STATION_VERIFY = 'TotalStationVerify';
        SCANSTATE.LAYOUT = 'LayoutNewPoint';
        SCANSTATE.LAYOUT_SELECTING_POINTS = 'LayoutSelectingPoints';
        SCANSTATE.REVERT_REGISTRATION = 'RevertRegistration';
        SCANSTATE.GEOREFERENCING = 'Georeferencing';
        SCANSTATE.IDENTIFY_TARGETS = 'IdentifyTargets';

        // related to jobs
        SCANSTATE.IMPORTING_PROJECT = 'ImportingProject';
        SCANSTATE.IMPORTING_SCAN = 'ImportingScan';
        SCANSTATE.IMPORTING_STATION = 'ImportingStation';
        SCANSTATE.CREATING_STATION = 'CreatingStation';
        SCANSTATE.CAPTURING_SCAN = 'CapturingScan';
        SCANSTATE.IMPORTING_REFS = 'ImportingRefs';
        SCANSTATE.PROCESSING_SCAN = 'ProcessingScan';
        SCANSTATE.REGISTERING_SCAN = 'RegisteringScan';
        SCANSTATE.REGISTERING_C2C_SCAN = 'RegisteringC2CScan';
        SCANSTATE.SYNCHRONIZING = 'SynchronizingCloud';
        SCANSTATE.UPGRADING_SPARSE_TO_FULL = 'UpgradingSparse';
        SCANSTATE.ADDING_NEW_STATION = 'AddingNewStation';
        SCANSTATE.SCANNING_CLOUD = 'ScanningCloud';
        SCANSTATE.SCANNING_TARGET = 'ScanningTarget';
        SCANSTATE.SCANNING_WINDOW = 'ScanningWindow';
        SCANSTATE.SCANNING_CLOUD_RASTER = 'ScanningCloudRaster';
        SCANSTATE.TRANSFERING_STATION = 'TransferingStation';
        SCANSTATE.SURVEYING_NEW_POINT = 'SurveyingNewPoint';
        SCANSTATE.MERGE_SCANS = 'MergeScans';
        SCANSTATE.MERGE_SCANS_PROCESSING = 'MergeScansProcessing';
        SCANSTATE.SEGMENTS_CONTROL = 'SegmentsControl';
        SCANSTATE.CREATE_REFERENCE_PLANE = 'CreateReferencePlane';
        SCANSTATE.TIN_PROCESSING = 'TinProcessing';
        SCANSTATE.VOLUME_PROCESSING = 'VolumeProcessing';
        SCANSTATE.VOLUME_REPORT = 'VolumeReport';
        SCANSTATE.ASSISTED_TARGET_DETECTION = 'AssistedTargetDetection';

        return SCANSTATE;
    }

    static getScanTasks() {
        let SCANTASK = {};
        SCANTASK.IMPORT = 'Import';
        SCANTASK.IMPORT_PROJECT = 'ImportProject';
        SCANTASK.IMPORT_SCAN = 'ImportScan';
        SCANTASK.IMPORT_STATION = 'ImportStation';
        SCANTASK.CREATE_STATION = 'CreateStation';
        SCANTASK.IMPORT_REFS = 'ImportRefs';
        SCANTASK.CAPTURE_SCAN = 'CaptureScan';
        SCANTASK.PROCESS_SCAN = 'ProcessScan';
        SCANTASK.REGISTER = 'Register';
        SCANTASK.REGISTER_MANUAL = 'RegisterManual';
        SCANTASK.REGISTER_BYREFS = 'RegisterByRefs';
        SCANTASK.REGISTER_BYREFS_AUTO = 'RegisterByRefsAuto';
        SCANTASK.REGISTER_BYREFS_PROCESS = 'RegisterByRefsProcess';
        SCANTASK.REGISTER_OCCBS = 'RegisterOccBs';
        SCANTASK.REGISTER_OCCBS_PROCESS = 'RegisterOccBsProcess';
        SCANTASK.REGISTER_C2C = 'RegisterC2CNew';
        SCANTASK.REGISTER_C2C_PROCESS = 'RegisterC2CProcess';
        SCANTASK.LINK_STATIONS = 'LinkStations';
        // SCANTASK.C2C_LINK_STATION = 'LinkStation';
        SCANTASK.C2C_MANUAL = 'ManualC2C';
        SCANTASK.C2C_REMOVE_LINKS = 'RemoveLinks';
        SCANTASK.BUNDLE_ADJUST = 'BundleAdjust';
        SCANTASK.ALIGNMENT_REPORT = 'AlignmentReport';
        SCANTASK.EXPORT = 'Export';
        SCANTASK.EXPORT_PROJECT_BACKUP = 'ExportProjectBackup';
        SCANTASK.EXPORT_PROJECT = 'ExportProject';
        SCANTASK.EXPORT_SCANS = 'ExportScans';
        SCANTASK.TRANSFORM_RASTER = 'TransformRaster';
        SCANTASK.C2C_REGISTER_PREFERENCES = 'C2CRegisterPreferences';
        SCANTASK.SYNC_CLOUD = 'SyncCloud';
        SCANTASK.REGISTRATION_REPORT = 'RegistrationReport';
        SCANTASK.UPGRADE_SPARSE_TO_FULL = 'UpgradeSparse';
        SCANTASK.ADD_NEW_STATION = 'AddNewStation';
        SCANTASK.LAYOUT = 'Layout';
        SCANTASK.LAYOUT_EACH_POINT = 'LayoutEachPoint';
        SCANTASK.VERIFY = 'Verify';
        SCANTASK.MEASUREMENTS = 'Measurements';
        SCANTASK.VOLUME_MEASURE = 'VolumeMeasure';
        SCANTASK.VOLUME_SURFACE = 'VolumeSurface';
        SCANTASK.VOLUME_QUANTITY = 'VolumeQuantity';
        SCANTASK.VOLUME_STOCKPILE = 'VolumeStockpile';
        SCANTASK.AREA_MEASURE = 'AreaMeasure';
        SCANTASK.DISTANCE_MEASURE = 'DistanceMeasure';
        SCANTASK.VERIFING_ELEMENTS = 'VerifingElements';
        SCANTASK.VERIFIED_ELEMENTS = 'VerifiedElements';
        SCANTASK.VERIFY_INSTALLATION = 'VerifyInstallation';
        SCANTASK.AS_BUILT_POINTS = 'AsBuiltPoints';
        SCANTASK.SPOT_MEASUREMENT = 'SpotMeasurement';
        SCANTASK.VERIFY_REPORT = 'VerifyReport';
        SCANTASK.SCAN = 'Scan';
        SCANTASK.FREE_SCAN = 'FreeScan';
        SCANTASK.WINDOW_SCAN = 'WindowScan';
        SCANTASK.DETAIL_SCAN = 'DetailScan';
        SCANTASK.TARGET_SCAN = 'TargetScan';
        SCANTASK.RASTER_FULL_SCAN = 'RasterFullScan';
        SCANTASK.LINK = 'Link';
        SCANTASK.SURVEY_NEW_POINT = 'SurveyNewPoint';
        SCANTASK.EDIT_LOCALIZATION = 'EditLocalization';
        SCANTASK.EDIT_SCANS = 'EditScans';
        SCANTASK.CREATE_REFERENCE_PLANE = 'CreateReferencePlane';
        SCANTASK.MERGE_SCANS = 'MergeScans';
        SCANTASK.MERGE_SCANS_PROCESS = 'MergeScansProcess';
        SCANTASK.SEGMENTS_CONTROL = 'SegmentsControl';
        SCANTASK.DELETION_TOOL = 'DeletionTool';
        SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES = 'GenerateAndExportDeliverables';
        SCANTASK.CONTOURS_DELIVERABLES = 'ContoursDeliverables';
        SCANTASK.VOLUME_DELIVERABLES = 'VolumeDeliverables';
        SCANTASK.TIN_DELIVERABLES = 'TinDeliverables';
        SCANTASK.TIN_PROCESS = 'TinProcess';
        SCANTASK.ORTHOPHOTO_DELIVERABLES = 'OrthophotoDeliverables';
        SCANTASK.VOLUME_PROCESS = 'VolumeProcess';
        SCANTASK.CANCEL = 'Cancel';
        SCANTASK.REVERT_REGISTRATION = 'RevertRegistration';
        SCANTASK.SCAN_RASTER = 'ScanRaster';
        SCANTASK.TARGET_REGISTER_PREFERENCES = 'TargetRegisterPreferences';
        SCANTASK.IDENTIFY_TARGETS = 'IdentifyTargets';
        SCANTASK.GEOREFERENCING = 'Georeferencing';
        SCANTASK.GEOREFERENCING_PROCESS = 'GeoreferencingProcess';
        SCANTASK.ASSISTED_TARGET_DETECTION = 'AssistedTargetDetection';

        return SCANTASK;
    }
}


/***/ }),

/***/ "./sources/pcvizWorkflow/ScanWorkflow.js":
/*!***********************************************!*\
  !*** ./sources/pcvizWorkflow/ScanWorkflow.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );
var Workflow = __webpack_require__( /*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js" );
var Utils = __webpack_require__( /*! pcvizGIS/Utils */ "./sources/pcvizGIS/Utils.js" );
var BaseDriver = __webpack_require__( /*! pcvizDataAccess/Drivers/CollageCloud/BaseDriver */ "./sources/pcvizDataAccess/Drivers/CollageCloud/BaseDriver.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );
const ListenerController = __webpack_require__( /*! pcvizDB/ListenerController */ "./sources/pcvizDB/ListenerController.js" );
var MagnetAPI = __webpack_require__( /*! pcvizUtils/MagnetAPI */ "./sources/pcvizUtils/MagnetAPI.js" );
var LayerType = __webpack_require__( /*! pcvizGIS/LayerType */ "./sources/pcvizGIS/LayerType.js" ).default;
var WorkspaceVisitor = __webpack_require__( /*! pcvizGIS/WorkspaceVisitor */ "./sources/pcvizGIS/WorkspaceVisitor.js" ).default;
var WorkspaceCategories = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" ).default;
const { WorkspaceStationTypes } = __webpack_require__( /*! pcvizGIS/WorkspaceCategories */ "./sources/pcvizGIS/WorkspaceCategories.js" );
const VectorLayerUtils = __webpack_require__( /*! pcvizGIS/VectorLayerUtils */ "./sources/pcvizGIS/VectorLayerUtils.js" ).default;
const JobAdapterService = __webpack_require__( /*! pcvizJobs/JobAdapterService */ "./sources/pcvizJobs/JobAdapterService.js" ).default;
const JobAdapterRegistry = __webpack_require__( /*! pcvizJobs/JobAdapterRegistry */ "./sources/pcvizJobs/JobAdapterRegistry.js" ).default;
const ScanProjectJobAdapter = __webpack_require__( /*! pcvizJobs/JobAdapters/ScanProjectJobAdapter */ "./sources/pcvizJobs/JobAdapters/ScanProjectJobAdapter.js" ).default;
const WorkspaceController = __webpack_require__( /*! pcvizDB/WorkspaceController */ "./sources/pcvizDB/WorkspaceController.js" );
const ScanSelectionController = __webpack_require__( /*! pcvizDB/ScanSelectionController */ "./sources/pcvizDB/ScanSelectionController.js" ).default;
const UtilsDB = __webpack_require__( /*! pcvizDB/Utils */ "./sources/pcvizDB/Utils.js" );
const ScanConstants = __webpack_require__( /*! pcvizWorkflow/ScanConstants */ "./sources/pcvizWorkflow/ScanConstants.js" ).default;
const DriverRegistry = __webpack_require__( /*! pcvizDataAccess/DriverRegistry */ "./sources/pcvizDataAccess/DriverRegistry.js" );
const { SEGMENTATION_LABELS } = __webpack_require__( /*! pcvizUtils/SegmentationConstants */ "./sources/pcvizUtils/SegmentationConstants.js" );

var ScanWorkflow = function () {
    Workflow.call( this );

    this._version = 1; // in case we need to manage persisted versions

    // status info that needs to be saved (add to saveVersionContent and restoreVersionContent)
    /*
       Registration status (method used?)
       Bundle/graph
       Registration matrices for each scan
    */

    this.isResectionActiveBySelection = true;
    this.isOccBsActiveBySelection = true;

    this.SCANSTATE = ScanConstants.getScanStates();
    this.SCANTASK = ScanConstants.getScanTasks();

    this.PROGRESSIVE_STATES = [
        this.SCANSTATE.IMPORTING_PROJECT,
        this.SCANSTATE.IMPORTING_SCAN,
        this.SCANSTATE.IMPORTING_STATION,
        this.SCANSTATE.CREATING_STATION,
        /*this.SCANSTATE.CAPTURING_SCAN,*/
        this.SCANSTATE.IMPORTING_REFS,
        this.SCANSTATE.PROCESSING_SCAN,
        this.SCANSTATE.REGISTERING_SCAN,
        this.SCANSTATE.REGISTERING_C2C_SCAN,
        this.SCANSTATE.EXPORTING_SCAN,
        this.SCANSTATE.SYNCHRONIZING,
        this.SCANSTATE.UPGRADING_SPARSE_TO_FULL,
        this.SCANSTATE.ADDING_NEW_STATION,
        this.SCANSTATE.LAYOUT,
        // don't exist yet this.SCANSTATE.TOTAL_STATION_VERIFY,
        // this.SCANSTATE.SCANNING_CLOUD,
        this.SCANSTATE.SCANNING_TARGET,
        this.SCANSTATE.TRANSFERING_STATION,
        this.SCANSTATE.WAITING_FOR_IMPORT, // these two are not progressive states but we need to put it in the list to show the cancel button in the WorkflowWidget
        this.SCANSTATE.WAITING_FOR_PROCESS,
        this.SCANSTATE.SURVEYING_NEW_POINT,
        this.SCANSTATE.MERGE_SCANS_PROCESSING,
        this.SCANSTATE.TIN_PROCESSING,
        this.SCANSTATE.VOLUME_PROCESSING,
    ];

    this.INDETERMINATE_STATES = [ this.SCANSTATE.WAITING_FOR_IMPORT ];

    this._isBackgroundProcessingEnabled = false;
    this.BACKGROUND_TASKS = [];
    this.FORCE_FOREGROUND_TASKS = [];
    if ( MagnetAPI.isSite() ) {
        if ( Registry.getInstance().getController( 'UserPreferences' ).getPreference( UtilsDB.BACKGROUND_PROCESSING_KEY ) ) {
            this._isBackgroundProcessingEnabled = true;
            this.BACKGROUND_TASKS = [ this.SCANTASK.PROCESS_SCAN ];
        }
        Registry.getInstance()
            .getController( 'UserPreferences' )
            .registerListener( ListenerController.PROJECT, UtilsDB.BACKGROUND_PROCESSING_KEY, ( enableBackgroundProcessing ) => {
                this._isBackgroundProcessingEnabled = enableBackgroundProcessing;
                const project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
                if ( this._projectPatchPromises.length )
                    Promise.allSettled( this._projectPatchPromises ).then( () => {
                        this._projectPatchPromises = [];
                        this._projectPatchPromises.push(
                            this.writeToProject( project )
                            .then( () => {} )
                            .catch( () => {
                                console.error( 'Background processing flag has not been saved' );
                            } )
                        );
                    } );
                else
                    this._projectPatchPromises.push(
                        this.writeToProject( project )
                        .then( () => {} )
                        .catch( () => {
                            console.error( 'Background processing flag has not been saved' );
                        } )
                    );
                if ( enableBackgroundProcessing ) this.BACKGROUND_TASKS = [ this.SCANTASK.PROCESS_SCAN ];
                else this.BACKGROUND_TASKS = [];
            } );
    }

    this._stateMachine = [
        // initial state
        {
            name: this.SCANSTATE.EMPTY,
            tip: 'SCAN_HELP.TIP_EMPTY',
            help: 'SCAN_HELP.HELP_EMPTY',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.IMPORT,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.ADD_NEW_STATION,
                    recommended: false,
                    visible: () => this.isScannerConnected(),
                },
                /*{
                    name: this.SCANTASK.VERIFY,
                    recommended: false,
                    visible: MagnetAPI.isSite() ? () => MagnetAPI.isTechnicalPreview() : false,
                    enabled: () => !this.hasBackgroundJob()
                    // Remove from here (STATE EMPTY) after the TIF
                },*/
                {
                    name: this.SCANTASK.TRANSFORM_RASTER,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        this.getHasRasterLayer.bind( this ) :
                        () => {
                            return false;
                        },
                },
                {
                    name: this.SCANTASK.EXPORT,
                    recommended: false,
                    visible: () => this.hasData(),
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.SYNC_CLOUD,
                    recommended: false,
                    visible: () => MagnetAPI.isSite() && this.hasWorkspaceData(),
                    enabled: () => !this.hasBackgroundJob(),
                },
            ],
        },
        // importing
        {
            name: this.SCANSTATE.IMPORTING_PROJECT,
            tip: 'SCAN_HELP.TIP_IMPORTING_PROJECT',
            help: 'SCAN_HELP.HELP_IMPORTING_PROJECT',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.IMPORTING_SCAN,
            tip: 'SCAN_HELP.TIP_IMPORTING_SCAN',
            help: 'SCAN_HELP.HELP_IMPORTING_SCAN',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.IMPORTING_STATION,
            tip: 'SCAN_HELP.TIP_IMPORTING_STATION',
            help: 'SCAN_HELP.HELP_IMPORTING_STATION',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.CREATING_STATION,
            tip: 'SCAN_HELP.TIP_CREATING_STATION',
            help: 'SCAN_HELP.HELP_CREATING_STATION',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.IMPORTING_REFS,
            tip: 'SCAN_HELP.TIP_IMPORTING_REFS',
            help: 'SCAN_HELP.HELP_IMPORTING_REFS',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.UPGRADING_SPARSE_TO_FULL,
            tip: 'SCAN_HELP.TIP_UPGRADING_SPARSE',
            help: 'SCAN_HELP.HELP_UPGRADING_SPARSE',
            push: false,
            tasks: [],
        },
        // some scans exist
        {
            name: this.SCANSTATE.NOT_EMPTY,
            tip: 'SCAN_HELP.TIP_NOT_EMPTY',
            help: 'SCAN_HELP.HELP_NOT_EMPTY',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.IMPORT,
                    recommended: false,
                    visible: true,
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.ADD_NEW_STATION,
                    recommended: false,
                    visible: () => this.isScannerConnected(),
                },
                {
                    name: this.SCANTASK.LAYOUT,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        () => MagnetAPI.isTechnicalPreview() && this.isScannerConnected() :
                        () => {
                            return false;
                        },
                    enabled: () => this.isEnabledLayout() && !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.VERIFY,
                    recommended: false,
                    visible: MagnetAPI.isSite() ? () => MagnetAPI.isTechnicalPreview() : false,
                    enabled: () =>
                        !this.hasBackgroundJob() &&
                        this.hasVerityModel() &&
                        ( this.isScannerConnected() ? this.isCurrentStationLocalized() : this.getSelectedStation() ),
                },
                {
                    name: this.SCANTASK.MEASUREMENTS,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.REGISTER,
                    recommended: false,
                    visible: true,
                    enabled: () => this.getStationsLength() > 0,
                },
                {
                    name: this.SCANTASK.SCAN,
                    recommended: false,
                    visible: () => this.isScannerConnected(), // only when connected to a scanner
                    enabled: () =>
                        this.getCurrentStation() !== undefined &&
                        this.getCurrentStationWorkspaceObj() &&
                        this.getBackgroundJobs().length < 2,
                },
                {
                    name: this.SCANTASK.LINK,
                    recommended: false,
                    visible: true,
                    enabled: () => this.getStationsWithPointcloudsLength() >= 2 && !this.hasBackgroundJob(), // grey-out until there are two or more stations with scans (pointclouds processed)
                },
                {
                    name: this.SCANTASK.EXPORT,
                    recommended: false,
                    visible: true,
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.TRANSFORM_RASTER,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        MagnetAPI.isTechnicalPreview() && this.getHasRasterLayer.bind( this ) :
                        () => {
                            return false;
                        },
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.SYNC_CLOUD,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                    enabled: () => !this.hasBackgroundJob(),
                },
                {
                    name: this.SCANTASK.PROCESS_SCAN,
                    recommended: false,
                    visible: true,
                    enabled: () => ( MagnetAPI.isSite() ? true : !this.areAllStationsFromCRP1() ),
                },
                // task disabled in Workflow but accessible directly from Layers
                /* Check with CE3D {
                    name: this.SCANTASK.REGISTER_MANUAL,
                    recommended: false,
                    visible: false
                },*/
                {
                    name: this.SCANTASK.REGISTER_OCCBS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.REGISTER_BYREFS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.REGISTER_C2C,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.EXPORT_PROJECT,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.EXPORT_SCANS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.CAPTURE_SCAN,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.EDIT_SCANS,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        () => MagnetAPI.isTechnicalPreview() :
                        () => {
                            return true;
                        },
                    enabled: () => !this.hasBackgroundJob(),
                },
                // {
                //     name: this.SCANTASK.LINK_STATIONS,
                //     recommended: false,
                //     visible: false
                // }
                {
                    name: this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        () => MagnetAPI.isTechnicalPreview() :
                        () => {
                            return true;
                        },
                },
            ],
        },
        {
            name: this.SCANSTATE.IMPORT,
            tip: 'SCAN_HELP.TIP_IMPORT',
            help: 'SCAN_HELP.HELP_IMPORT',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.IMPORT_PROJECT,
                    recommended: false,
                    visible: () => this.isEmpty(), // this task is hidden when NOT_EMPTY
                },
                /*{
                    name: this.SCANTASK.IMPORT_SCAN,
                    recommended: false,
                    visible: true
                }, */
                {
                    name: this.SCANTASK.CREATE_STATION,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.IMPORT_STATION,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.UPGRADE_SPARSE_TO_FULL,
                    recommended: false,
                    visible: true,
                    enabled: () => this.hasSparse(),
                },
                {
                    name: this.SCANTASK.IMPORT_REFS,
                    recommended: false,
                    visible: true,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        // capturing scan
        {
            name: this.SCANSTATE.CAPTURING_SCAN,
            tip: 'SCAN_HELP.TIP_CAPTURING_SCAN',
            help: 'SCAN_HELP.HELP_CAPTURING_SCAN',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: true,
            }, ],
        },
        // processing scan
        {
            name: this.SCANSTATE.PROCESSING_SCAN,
            tip: 'SCAN_HELP.TIP_PROCESSING_SCAN',
            help: 'SCAN_HELP.HELP_PROCESSING_SCAN',
            push: false,
            tasks: [],
        },
        // registration tasks
        {
            name: this.SCANSTATE.REGISTRATION,
            tip: 'SCAN_HELP.TIP_REGISTRATION',
            help: 'SCAN_HELP.HELP_REGISTRATION',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.CAPTURE_SCAN,
                    recommended: false,
                    visible: false /*MagnetAPI.isSite() ? () => { return this.getSelectedStation() && !this.hasScan( this.getSelectedStation() ); } : false*/ ,
                },
                {
                    name: this.SCANTASK.REGISTER_MANUAL,
                    recommended: false,
                    visible: true,
                    enabled: () => ( MagnetAPI.isSite() ? this.getSelectedStation() : true ),
                    // grey-out until there is a station selected (site)
                },
                {
                    name: this.SCANTASK.REGISTER_C2C,
                    recommended: false,
                    visible: true,
                    enabled: () => this.isC2CRegistrationActive(),
                    // grey-out unless the selected station has a scan and at least one other station has a scan in it (pointclouds processed)
                },
                {
                    name: this.SCANTASK.REGISTER_OCCBS,
                    recommended: false,
                    visible: true,
                    enabled: () => this.isOccBsRegistrationActive() && this.isOccBsActiveBySelection,
                    // grey-out if the (selected) station has a survey localization applied to it
                    // also grey-out for raster devices (site)
                },
                {
                    name: this.SCANTASK.REGISTER_BYREFS,
                    recommended: false,
                    visible: true,
                    enabled: () => this.isResectionRegistrationActive() && this.isResectionActiveBySelection,
                    // grey-out if the (selected) station has a survey localization applied to it
                },
                {
                    name: this.SCANTASK.REGISTER_BYREFS_AUTO,
                    recommended: false,
                    visible: () => {
                        return this.isSiteAndRaster();
                    },
                    enabled: () => {
                        return this.isNotLocalizedStation() && this.isSelectedStationNotFake();
                    },
                    // grey-out if the (selected) station has a survey localization applied to it
                },
                {
                    name: this.SCANTASK.SURVEY_NEW_POINT,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                    enabled: () => {
                        return (
                            this.isScannerConnected() &&
                            ( this.isCurrentStationLocalized() || this.belongsCurrentToLocalizedBundle() ) &&
                            !this.isCRP1ScannerType()
                        );
                    },
                    // grey-out if the (current) station doesn't have a survey localization applied to it
                },
                {
                    name: this.SCANTASK.IDENTIFY_TARGETS,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                    enabled: () => this.isIdentifyTargetsEnabled(),
                },
                {
                    name: this.SCANTASK.GEOREFERENCING,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                    enabled: () => this.isGeoReferencingActive(),
                },
                {
                    name: this.SCANTASK.EDIT_LOCALIZATION,
                    recommended: false,
                    visible: true,
                    enabled: () => this.isLocalizedStation(),
                    // grey-out if the (selected) station doesn't have a survey localization applied to it
                },
                {
                    name: this.SCANTASK.REGISTRATION_REPORT,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.REVERT_REGISTRATION,
                    recommended: false,
                    visible: !MagnetAPI.isSite(),
                    enabled: () => this.isRevertRegistrationActive(),
                },
                // { ### Hidden by Collage Web Release 4.1 ###
                //     name: this.SCANTASK.TARGET_REGISTER_PREFERENCES,
                //     recommended: false,
                //     visible: !MagnetAPI.isSite(),
                // },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.REGISTRATION_MANUAL,
            tip: 'SCAN_HELP.TIP_REGISTRATION_MANUAL',
            help: () =>
                this.getPreviousState() === this.SCANSTATE.LINKING_STATIONS ?
                'SCAN_HELP.HELP_REGISTRATION_MANUAL_C2C' : 'SCAN_HELP.HELP_REGISTRATION_MANUAL',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_C2C_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
            overwriteSymbology: [ 'pointcloudFixedColor', 'pointcloudTransparency', 'targetColorAsPointcloud' ],
        },
        {
            name: this.SCANSTATE.REGISTRATION_OCCBS,
            tip: 'SCAN_HELP.TIP_REGISTRATION_OCCBS',
            help: 'SCAN_HELP.HELP_REGISTRATION_OCCBS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_OCCBS_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
            overwriteSymbology: [ 'controlPointColor' ],
        },
        {
            name: this.SCANSTATE.REGISTRATION_BYREFS,
            tip: 'SCAN_HELP.TIP_REGISTRATION_BYREFS',
            help: 'SCAN_HELP.HELP_REGISTRATION_BYREFS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_BYREFS_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.SCAN_RASTER,
                    recommended: false,
                    visible: false,
                },
            ],
            overwriteSymbology: [ 'controlPointResection' ],
        },
        {
            name: this.SCANSTATE.REGISTRATION_BYREFS_AUTO,
            tip: 'SCAN_HELP.TIP_REGISTRATION_BYREFS_AUTO',
            help: 'SCAN_HELP.HELP_REGISTRATION_BYREFS_AUTO',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_BYREFS_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.SCAN_RASTER,
                    recommended: false,
                    visible: false,
                },
            ],
            overwriteSymbology: [ 'controlPointResection' ],
        },
        {
            name: this.SCANSTATE.REGISTRATION_C2C,
            tip: 'SCAN_HELP.TIP_REGISTRATION_C2C',
            help: 'SCAN_HELP.HELP_REGISTRATION_C2C',
            push: true,
            tasks: [
                /*{
                    name: this.SCANTASK.CAPTURE_SCAN,
                    recommended: false, //make recommended for CRE MagnetAPI.isSite()
                    visible: MagnetAPI.isSite()
                },*/
                {
                    name: this.SCANTASK.REGISTER_MANUAL,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.LINK_STATIONS,
                    recommended: false, //make recommended for CW !MagnetAPI.isSite()
                    visible: true,
                },
                /*{
                    name: this.SCANTASK.C2C_MANUAL, //TODO: remove this task from here
                    recommended: false,
                    visible: true
                },*/
                /*{
                    name: this.SCANTASK.C2C_LINK_STATION,
                    recommended: false,
                    visible: true,
                    enabled: true
                },*/
                {
                    name: this.SCANTASK.C2C_REMOVE_LINKS,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        () => MagnetAPI.isTechnicalPreview() :
                        () => {
                            return true;
                        },
                },
                {
                    name: this.SCANTASK.BUNDLE_ADJUST,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.ALIGNMENT_REPORT,
                    recommended: false,
                    visible: true,
                    enabled: () => {
                        return this.hasReports();
                    },
                },
                {
                    name: this.SCANTASK.C2C_REGISTER_PREFERENCES,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.REGISTER_C2C_PROCESS, // From link viewer menu in C2C
                    recommended: false,
                    visible: false,
                },
                /*  {
                      name: this.SCANTASK.C2C_MANUAL, // From context menu in C2C
                      recommended: false,
                      visible: false
                  },*/
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.CANCEL,
                    recommended: false,
                    visible: true,
                },
            ],
            overwriteSymbology: [ 'pointcloudFixedColor', 'targetColorAsPointcloud' ],
        },
        {
            name: this.SCANSTATE.REGISTERING_SCAN,
            tip: 'SCAN_HELP.TIP_REGISTERING_SCAN',
            help: 'SCAN_HELP.HELP_REGISTERING_SCAN',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.REGISTERING_C2C_SCAN,
            tip: 'SCAN_HELP.TIP_REGISTERING_C2C_SCAN',
            help: 'SCAN_HELP.HELP_REGISTERING_C2C_SCAN',
            push: false,
            tasks: [],
            overwriteSymbology: [ 'pointcloudFixedColor', 'targetColorAsPointcloud' ],
        },
        // linking stations
        {
            name: this.SCANSTATE.LINKING_STATIONS,
            tip: 'SCAN_HELP.TIP_LINKING_STATIONS',
            help: 'SCAN_HELP.HELP_LINKING_STATIONS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_C2C_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.C2C_MANUAL,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: /*true*/ false,
                },
            ],
            overwriteSymbology: [ 'pointcloudFixedColor', 'targetColorAsPointcloud' ],
        },
        // link station
        /* {
             name: this.SCANSTATE.C2C_LINK_STATION,
             tip: 'SCAN_HELP.TIP_C2C_LINK_STATION',
             help: 'SCAN_HELP.HELP_C2C_LINK_STATION',
             push: true,
             tasks: [ {
                     name: this.SCANTASK.REGISTER_C2C_PROCESS,
                     recommended: false,
                     enabled: false,
                 },
                 {
                     name: this.SCANTASK.C2C_MANUAL,
                     recommended: false,
                     enabled: false
                 }, {
                     name: Workflow.TASK.CLOSE,
                     recommended: false,
                     enabled: false
                 }
             ]
         },*/
        // removing links
        {
            name: this.SCANSTATE.C2C_REMOVING_LINKS,
            tip: 'SCAN_HELP.TIP_C2C_REMOVING_LINKS',
            help: 'SCAN_HELP.HELP_C2C_REMOVING_LINKS',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        // bundle ajustement
        {
            name: this.SCANSTATE.ADJUSTING_BUNDLES,
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTER_C2C_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
            overwriteSymbology: [ 'pointcloudFixedColor', 'targetColorAsPointcloud' ],
        },
        {
            name: this.SCANSTATE.LOCALIZED,
            tip: 'SCAN_HELP.TIP_LOCALIZED',
            help: 'SCAN_HELP.HELP_LOCALIZED',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.REGISTRATION_REPORT,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.EDIT_LOCALIZATION,
                    recommended: false,
                    visible: true,
                    enabled: () => {
                        return this.isLocalizedStation();
                    },
                    // grey-out if the (selected) station doesn't have a survey localization applied to it
                },
                {
                    name: this.SCANTASK.FREE_SCAN,
                    recommended: false,
                    visible: () => MagnetAPI.isSite() && !this.isGTScannerType(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: this.SCANTASK.WINDOW_SCAN,
                    recommended: false,
                    visible: () => MagnetAPI.isSite() && !this.isGTScannerType() && !this.isCRP1ScannerType(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.REVERT_REGISTRATION,
            tip: 'SCAN_HELP.TIP_REVERT_REGISTRATION',
            help: 'SCAN_HELP.HELP_REVERT_REGISTRATION',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.EDIT_SCANS,
            tip: 'SCAN_HELP.TIP_EDIT_SCANS',
            help: 'SCAN_HELP.HELP_EDIT_SCANS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.MERGE_SCANS,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.DELETION_TOOL,
                    recommended: false,
                    visible: MagnetAPI.isSite() ?
                        () => MagnetAPI.isTechnicalPreview() :
                        () => {
                            return true;
                        },
                },
                {
                    name: this.SCANTASK.SEGMENTS_CONTROL,
                    recommended: false,
                    visible: () => !MagnetAPI.isSite() && this.isAnyScanSegmented(),
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.MERGE_SCANS,
            tip: 'SCAN_HELP.TIP_MERGE_SCANS',
            help: 'SCAN_HELP.HELP_MERGE_SCANS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.MERGE_SCANS_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.MERGE_SCANS_PROCESSING,
            tip: 'SCAN_HELP.TIP_MERGE_SCANS_PROCESSING',
            help: 'SCAN_HELP.HELP_MERGE_SCANS_PROCESSING',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES,
            tip: 'SCAN_HELP.TIP_GENERATE_AND_EXPORT_DELIVERABLES',
            help: 'SCAN_HELP.HELP_GENERATE_AND_EXPORT_DELIVERABLES',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.CREATE_REFERENCE_PLANE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.TIN_DELIVERABLES,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VOLUME_DELIVERABLES,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.CONTOURS_DELIVERABLES,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.ORTHOPHOTO_DELIVERABLES,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.CREATE_REFERENCE_PLANE,
            tip: 'SCAN_HELP.TIP_CREATE_REFERENCE_PLANE',
            help: 'SCAN_HELP.CREATE_REFERENCE_PLANE',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.TIN_DELIVERABLES,
            tip: 'SCAN_HELP.TIP_TIN_DELIVERABLES',
            help: 'SCAN_HELP.TIN_DELIVERABLES',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.TIN_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.TIN_PROCESSING,
            tip: 'SCAN_HELP.TIP_TIN_PROCESSING ',
            help: 'SCAN_HELP.HELP_TIN_PROCESSING ',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.DELETION_TOOL,
            tip: 'SCAN_HELP.TIP_DELETION_TOOL',
            help: 'SCAN_HELP.HELP_DELETION_TOOL',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.SEGMENTS_CONTROL,
            tip: 'SCAN_HELP.TIP_SEGMENTS_CONTROL',
            help: 'SCAN_HELP.HELP_SEGMENTS_CONTROL',
            push: true,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: true,
            }, ],
        },
        {
            name: this.SCANSTATE.VOLUME_DELIVERABLES,
            tip: 'SCAN_HELP.TIP_VOLUME_DELIVERABLES',
            help: 'SCAN_HELP.HELP_VOLUME_DELIVERABLES',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.VOLUME_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_PROCESSING,
            tip: 'SCAN_HELP.TIP_VOLUME_PROCESSING ',
            help: 'SCAN_HELP.HELP_VOLUME_PROCESSING ',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.EXPORT,
            tip: 'SCAN_HELP.TIP_EXPORT',
            help: 'SCAN_HELP.HELP_EXPORT',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.EXPORT_PROJECT_BACKUP,
                    recommended: false,
                    visible: MagnetAPI.isSite(),
                },
                {
                    name: this.SCANTASK.EXPORT_PROJECT,
                    recommended: false,
                    visible: () => !this.isEmpty() && MagnetAPI.isSite() && !this.areAllStationsFromCRP1(),
                },
                {
                    name: this.SCANTASK.EXPORT_SCANS,
                    recommended: false,
                    visible: () => !this.isEmpty() && MagnetAPI.isSite(),
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.EXPORTING_SCAN,
            tip: 'SCAN_HELP.TIP_EXPORTING_SCAN',
            help: 'SCAN_HELP.HELP_EXPORTING_SCAN',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.SCAN,
            tip: 'SCAN_HELP.TIP_SCAN',
            help: 'SCAN_HELP.HELP_SCAN',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.FREE_SCAN,
                    recommended: false,
                    visible: () => !this.isGTScannerType(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: this.SCANTASK.RASTER_FULL_SCAN,
                    recommended: false,
                    visible: () => this.isScannerConnected() && this.isRasterScannerType(),
                    enabled: () => this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: this.SCANTASK.WINDOW_SCAN,
                    recommended: false,
                    visible: () => !this.isGTScannerType() && !this.isCRP1Connected(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: this.SCANTASK.DETAIL_SCAN,
                    recommended: false,
                    visible: () => this.isCRP1Connected(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: this.SCANTASK.TARGET_SCAN,
                    recommended: false,
                    visible: () => !this.isCRP1ScannerType(),
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.TRANSFORMING_RASTER,
            tip: 'SCAN_HELP.TIP_TRANSFORMING_RASTER',
            help: 'SCAN_HELP.HELP_TRANSFORMING_RASTER',
            push: false,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.SYNCHRONIZING,
            tip: 'SCAN_HELP.TIP_SYNCHRONIZING',
            help: 'SCAN_HELP.HELP_SYNCHRONIZING',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.ADDING_NEW_STATION,
            tip: 'SCAN_HELP.TIP_ADDING_NEW_STATION',
            help: 'SCAN_HELP.HELP_ADDING_NEW_STATION',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.LAYOUT,
            tip: 'SCAN_HELP.TIP_LAYOUT_NEW_POINT',
            help: 'SCAN_HELP.HELP_LAYOUT_NEW_POINT',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.LAYOUT_SELECTING_POINTS,
            tip: 'SCAN_HELP.TIP_LAYOUT_SELECTING_POINTS',
            help: () => ( this._layoutAddingFromList ? 'SCAN_HELP.HELP_LAYOUT_ADD_FROM_LIST' : 'SCAN_HELP.HELP_LAYOUT_SELECTING_POINTS' ),
            push: false,
            tasks: [ {
                    name: this.SCANTASK.LAYOUT_EACH_POINT,
                    recommended: false,
                    visible: false,
                    enabled: true,
                },
                {
                    name: this.SCANTASK.CANCEL,
                    recommended: false,
                    visible: () => !this._layoutAddingFromList,
                },
            ],
        },
        {
            name: this.SCANSTATE.STANDARD_VERIFY,
            tip: 'SCAN_HELP.TIP_STANDARD_VERIFY',
            help: 'SCAN_HELP.HELP_STANDARD_VERIFY',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.VERIFING_ELEMENTS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.FREE_SCAN,
                    recommended: false,
                    visible: false,
                    enabled: () =>
                        this.isScannerConnected() && this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj(),
                },
            ],
        },
        {
            name: this.SCANSTATE.VERIFY,
            tip: 'SCAN_HELP.TIP_VERIFY',
            help: 'SCAN_HELP.HELP_VERIFY',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VERIFY_INSTALLATION,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.AS_BUILT_POINTS,
                    recommended: false,
                    visible: true,
                    enabled: false,
                },
                {
                    name: this.SCANTASK.SPOT_MEASUREMENT,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VERIFY_REPORT,
                    recommended: false,
                    visible: true,
                    enabled: () => this.hasVerifyReport(),
                },
            ],
        },
        {
            name: this.SCANSTATE.TOTAL_STATION_VERIFY, // Keeping this just for OLD projects
            tip: 'SCAN_HELP.TIP_STANDARD_VERIFY',
            help: 'SCAN_HELP.HELP_STANDARD_VERIFY',
            push: false,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: true,
            }, ],
        },
        {
            name: this.SCANSTATE.VERIFING_ELEMENTS,
            tip: 'SCAN_HELP.TIP_VERIFING_ELEMENTS',
            help: '',
            push: false,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.VERIFIED_ELEMENTS,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.VERIFIED_ELEMENTS,
            tip: 'SCAN_HELP.TIP_VERIFIED_ELEMENTS',
            help: 'SCAN_HELP.HELP_VERIFIED_ELEMENTS',
            push: false,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: true,
            }, ],
        },
        {
            name: this.SCANSTATE.SCANNING_CLOUD,
            tip: 'SCAN_HELP.TIP_SCANNING_CLOUD',
            help: 'SCAN_HELP.HELP_SCANNING_CLOUD',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.SCANNING_WINDOW,
            tip: 'SCAN_HELP.TIP_SCANNING_WINDOW',
            help: 'SCAN_HELP.HELP_SCANNING_WINDOW',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.SCANNING_TARGET,
            tip: 'SCAN_HELP.TIP_SCANNING_TARGET',
            help: 'SCAN_HELP.HELP_SCANNING_TARGET',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.SCANNING_CLOUD_RASTER,
            tip: 'SCAN_HELP.TIP_SCANNING_CLOUD',
            help: 'SCAN_HELP.HELP_SCANNING_CLOUD',
            push: true,
            tasks: [],
        },
        {
            name: this.SCANSTATE.TRANSFERING_STATION,
            tip: 'SCAN_HELP.TIP_TRANSFERING_STATION',
            help: 'SCAN_HELP.HELP_TRANSFERING_STATION',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.WAITING_FOR_IMPORT,
            tip: 'SCAN_HELP.TIP_WAITING_FOR_IMPORT',
            help: 'SCAN_HELP.HELP_WAITING_FOR_IMPORT',
            push: false,
            tasks: [ {
                name: this.SCANTASK.IMPORT_PROJECT,
                recommended: false,
                visible: false, // this task is only for using from script (libcollagewebapi)
            }, ],
        },
        {
            name: this.SCANSTATE.WAITING_FOR_PROCESS,
            tip: 'SCAN_HELP.TIP_WAITING_FOR_PROCESS',
            help: 'SCAN_HELP.HELP_WAITING_FOR_PROCESS',
            push: false,
            tasks: [ {
                name: this.SCANTASK.PROCESS_SCAN,
                recommended: false,
                visible: false, // this task is only for using from script (libcollagewebapi)
            }, ],
        },
        {
            name: this.SCANSTATE.SURVEYING_NEW_POINT,
            tip: 'SCAN_HELP.TIP_SURVEYING_NEW_POINT',
            help: 'SCAN_HELP.HELP_SURVEYING_NEW_POINT',
            push: false,
            tasks: [],
        },
        {
            name: this.SCANSTATE.MEASUREMENTS,
            tip: 'SCAN_HELP.TIP_MEASUREMENTS',
            help: 'SCAN_HELP.HELP_MEASUREMENTS',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VOLUME_MEASURE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.AREA_MEASURE,
                    recommended: false,
                    visible: MagnetAPI.isSite() ? () => MagnetAPI.isTechnicalPreview() : false,
                    enabled: () => false, // TODO
                },
                {
                    name: this.SCANTASK.DISTANCE_MEASURE,
                    recommended: false,
                    visible: MagnetAPI.isSite() ? () => MagnetAPI.isTechnicalPreview() : false,
                    enabled: () => false, // TODO
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_MEASURE,
            tip: 'SCAN_HELP.TIP_VOLUME_MEASURE',
            help: 'SCAN_HELP.HELP_VOLUME_MEASURE',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VOLUME_SURFACE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VOLUME_QUANTITY,
                    recommended: false,
                    visible: MagnetAPI.isTechnicalPreview(),
                    enabled: () => !this.hasBackgroundJob() && ( !this.isScannerConnected() || this.isCurrentStationLocalized() ),
                },
                {
                    name: this.SCANTASK.VOLUME_STOCKPILE,
                    recommended: false,
                    visible: true,
                    enabled: true,
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_SURFACE,
            tip: 'SCAN_HELP.TIP_VOLUME_SURFACE',
            help: 'SCAN_HELP.HELP_VOLUME_SURFACE',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.VOLUME_PROCESS,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_STOCKPILE,
            tip: 'SCAN_HELP.TIP_VOLUME_STOCKPILE',
            help: 'SCAN_HELP.HELP_VOLUME_STOCKPILE',
            push: true,
            tasks: [ {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
                {
                    name: this.SCANTASK.VOLUME_PROCESS,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_QUANTITY,
            tip: 'SCAN_HELP.TIP_VOLUME_QUANTITY',
            help: 'SCAN_HELP.HELP_VOLUME_QUANTITY',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.IMPORT_REFS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: true,
                },
                {
                    name: this.SCANTASK.VOLUME_PROCESS,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.VOLUME_REPORT,
            tip: 'SCAN_HELP.TIP_VOLUME_REPORT',
            help: 'SCAN_HELP.HELP_VOLUME_REPORT',
            push: false,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.IDENTIFY_TARGETS,
            tip: 'SCAN_HELP.TIP_IDENTIFY_TARGETS',
            help: 'SCAN_HELP.HELP_IDENTIFY_TARGETS',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.ASSISTED_TARGET_DETECTION,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
        },
        {
            name: this.SCANSTATE.ASSISTED_TARGET_DETECTION,
            tip: 'SCAN_HELP.TIP_ASSISTED_TARGET_DETECTION',
            help: 'SCAN_HELP.HELP_ASSISTED_TARGET_DETECTION',
            push: false,
            tasks: [ {
                name: Workflow.TASK.CLOSE,
                recommended: false,
                visible: false,
            }, ],
        },
        {
            name: this.SCANSTATE.GEOREFERENCING,
            tip: 'SCAN_HELP.TIP_GEOREFERENCING',
            help: 'SCAN_HELP.HELP_GEOREFERENCING',
            push: true,
            tasks: [ {
                    name: this.SCANTASK.GEOREFERENCING_PROCESS,
                    recommended: false,
                    visible: false,
                },
                {
                    name: Workflow.TASK.CLOSE,
                    recommended: false,
                    visible: false,
                },
            ],
        }
    ];

    // TODO: Change tasks icons
    this._taskInfo.set( this.SCANTASK.IMPORT, {
        icon: 'pcviz-icon-upload',
        main: true,
        isAddTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.EDIT_SCANS, {
        icon: 'pcviz-icon-draw',
        main: true,
        isAddTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.CREATE_REFERENCE_PLANE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.MERGE_SCANS, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.SEGMENTS_CONTROL, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.MERGE_SCANS_PROCESS, {
        main: true,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.DELETION_TOOL, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES, {
        icon: 'pcviz-icon-verticalconstruction',
        main: true,
        isAddTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.CONTOURS_DELIVERABLES, {
        main: true,
        previousState: this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES,
        previousTasks: [ this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_DELIVERABLES, {
        main: true,
        isAddTask: true,
        previousState: this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES,
        previousTasks: [ this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES ],
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_PROCESS, {
        main: true,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.ORTHOPHOTO_DELIVERABLES, {
        main: true,
        previousState: this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES,
        previousTasks: [ this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.TIN_DELIVERABLES, {
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES,
        previousTasks: [ this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.TIN_PROCESS, {
        main: true,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.IMPORT_PROJECT, {
        icon: 'pcviz-icon-import-project',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.IMPORT_SCAN, {
        icon: 'pcviz-icon-import-scan-project',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.CREATE_STATION, {
        icon: 'pcviz-icon-import-scan-as-station',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.IMPORT_STATION, {
        icon: 'pcviz-icon-upload',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.IMPORT_REFS, {
        icon: 'pcviz-icon-import-references',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.TRANSFORM_RASTER, {
        icon: 'pcviz-icon-transform',
        main: false,
        isAddTask: MagnetAPI.isSite(),
    } );
    this._taskInfo.set( this.SCANTASK.C2C_REGISTER_PREFERENCES, {
        icon: 'pcviz-icon-settings',
        main: false,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.REGISTRATION_REPORT, {
        icon: 'pcviz-icon-data',
        main: true,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.CAPTURE_SCAN, {
        icon: 'pcviz-icon-place',
        main: true,
        isProcessTask: false,
        openTab: 'workflow',
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
    } );
    this._taskInfo.set( this.SCANTASK.PROCESS_SCAN, {
        icon: 'pcviz-icon-process-scan',
        main: true,
        isProcessTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER, {
        icon: 'pcviz-icon-localize',
        main: true,
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_MANUAL, {
        icon: 'pcviz-icon-visual-alignment',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION_C2C,
        previousTasks: [ this.SCANTASK.REGISTER_C2C ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_BYREFS, {
        icon: 'pcviz-icon-point-resection',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_BYREFS_AUTO, {
        icon: 'pcviz-icon-point-resection',
        main: true,
        isProcessTask: true,
        checkVisibleAndEnabled: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_BYREFS_PROCESS, {
        icon: 'pcviz-icon-point-resection',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION_BYREFS,
        previousTasks: [ this.SCANTASK.REGISTER_BYREFS ],
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_OCCBS, {
        icon: 'pcviz-icon-occupation-backsight',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_OCCBS_PROCESS, {
        icon: 'pcviz-icon-occupation-backsight',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION_OCCBS,
        previousTasks: [ this.SCANTASK.REGISTER_OCCBS ],
    } );
    // this._taskInfo.set( this.SCANTASK.TARGET_REGISTER_PREFERENCES, { ### Hidden by Collage Web Release 4.1 ###
    //     icon: 'pcviz-icon-settings',
    //     main: false,
    //     isProcessTask: true
    // } );
    this._taskInfo.set( this.SCANTASK.REGISTER_C2C, {
        icon: 'pcviz-icon-cloud-to-cloud',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.REGISTER_C2C_PROCESS, {
        icon: 'pcviz-icon-cloud-to-cloud',
        main: true,
        isProcessTask: false,
        previousState: this.SCANSTATE.REGISTRATION_C2C,
        previousTasks: [ this.SCANTASK.REGISTER_C2C ],
    } );
    this._taskInfo.set( this.SCANTASK.LINK_STATIONS, {
        icon: 'pcviz-icon-link-station',
        main: true,
        isProcessTask: false,
        openTab: 'workflow',
        previousState: this.SCANSTATE.REGISTRATION_C2C,
        previousTasks: [ this.SCANTASK.REGISTER_C2C ],
    } );
    this._taskInfo.set( this.SCANTASK.C2C_MANUAL, {
        icon: 'pcviz-icon-manual-link',
        main: true,
        isProcessTask: true,
        openTab: 'workflow',
    } );
    /*this._taskInfo.set( this.SCANTASK.C2C_LINK_STATION, {
        icon: 'pcviz-icon-link',
        main: true,
        isProcessTask: false,
        openTab: 'workflow'
    } );*/
    this._taskInfo.set( this.SCANTASK.C2C_REMOVE_LINKS, {
        icon: 'pcviz-icon-add-remove-multiple-links',
        main: true,
        isProcessTask: false,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.BUNDLE_ADJUST, {
        icon: 'pcviz-icon-optimize',
        main: true,
        isProcessTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.ALIGNMENT_REPORT, {
        icon: 'pcviz-icon-data',
        main: true,
        isProcessTask: true,
        openTab: 'workflow',
    } );

    this._taskInfo.set( this.SCANTASK.REVERT_REGISTRATION, {
        main: true,
        isProcessTask: !MagnetAPI.isSite(),
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );

    this._taskInfo.set( this.SCANTASK.GEOREFERENCING_PROCESS, {
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.GEOREFERENCING,
        previousTasks: [ this.SCANTASK.GEOREFERENCING ],
    } );

    this._taskInfo.set( this.SCANTASK.EXPORT, {
        icon: 'pcviz-icon-download',
        main: true,
    } );
    this._taskInfo.set( this.SCANTASK.EXPORT_PROJECT_BACKUP, {
        icon: 'pcviz-icon-export-project',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.EXPORT,
        previousTasks: [ this.SCANTASK.EXPORT ],
    } );
    this._taskInfo.set( this.SCANTASK.EXPORT_PROJECT, {
        icon: 'pcviz-icon-export-project',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.EXPORT,
        previousTasks: [ this.SCANTASK.EXPORT ],
    } );
    this._taskInfo.set( this.SCANTASK.EXPORT_SCANS, {
        icon: 'pcviz-icon-export-scan',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.EXPORT,
        previousTasks: [ this.SCANTASK.EXPORT ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.SYNC_CLOUD, {
        icon: 'pcviz-icon-publish-to-CW',
        main: true,
        isProcessTask: MagnetAPI.isSite(),
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.UPGRADE_SPARSE_TO_FULL, {
        icon: 'pcviz-icon-upgrade-sparse-scan',
        main: true,
        isProcessTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.ADD_NEW_STATION, {
        icon: 'pcviz-icon-add-new-station',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.LAYOUT, {
        icon: 'pcviz-icon-scanners',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.LAYOUT_EACH_POINT, {
        icon: 'pcviz-icon-scanners',
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VERIFING_ELEMENTS, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VERIFY, {
        icon: 'pcviz-icon-check',
        main: true,
        isProcessTask: MagnetAPI.isSite() && MagnetAPI.isTechnicalPreview(),
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.MEASUREMENTS, {
        icon: 'pcviz-icon-draw-polygon',
        main: true,
        isProcessTask: MagnetAPI.isSite(),
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_MEASURE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_SURFACE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_QUANTITY, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VOLUME_STOCKPILE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.AREA_MEASURE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.DISTANCE_MEASURE, {
        main: true,
        isAddTask: true,
    } );
    this._taskInfo.set( this.SCANTASK.VERIFY_INSTALLATION, {
        icon: 'pcviz-icon-check',
        main: true,
        isProcessTask: MagnetAPI.isSite() && MagnetAPI.isTechnicalPreview(),
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.AS_BUILT_POINTS, {
        icon: 'pcviz-icon-distance',
        main: true,
        isProcessTask: MagnetAPI.isSite() && MagnetAPI.isTechnicalPreview(),
    } );
    this._taskInfo.set( this.SCANTASK.SPOT_MEASUREMENT, {
        icon: 'pcviz-icon-target-scan',
        main: true,
        isProcessTask: MagnetAPI.isSite() && MagnetAPI.isTechnicalPreview(),
    } );
    this._taskInfo.set( this.SCANTASK.VERIFY_REPORT, {
        icon: 'pcviz-icon-data',
        main: true,
        isProcessTask: MagnetAPI.isSite() && MagnetAPI.isTechnicalPreview(),
    } );
    this._taskInfo.set( this.SCANTASK.SCAN, {
        icon: 'pcviz-icon-scanners',
        main: true,
    } );
    this._taskInfo.set( this.SCANTASK.FREE_SCAN, {
        icon: 'pcviz-icon-free-scan',
        main: true,
        // isProcessTask: true,
        previousState: this.SCANSTATE.SCAN,
        previousTasks: [ this.SCANTASK.SCAN ],
    } );
    this._taskInfo.set( this.SCANTASK.WINDOW_SCAN, {
        icon: 'pcviz-icon-window-scan',
        main: true,
        // isProcessTask: true,
        previousState: this.SCANSTATE.SCAN,
        previousTasks: [ this.SCANTASK.SCAN ],
    } );
    this._taskInfo.set( this.SCANTASK.DETAIL_SCAN, {
        icon: 'pcviz-icon-window-scan',
        main: true,
        previousState: this.SCANSTATE.SCAN,
        previousTasks: [ this.SCANTASK.SCAN ],
    } );
    this._taskInfo.set( this.SCANTASK.TARGET_SCAN, {
        icon: 'pcviz-icon-target-scan',
        main: true,
        //isProcessTask: true,
        previousState: this.SCANSTATE.SCAN,
        previousTasks: [ this.SCANTASK.SCAN ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.RASTER_FULL_SCAN, {
        icon: 'pcviz-icon-free-scan',
        main: true,
        // isProcessTask: true,
        previousState: this.SCANSTATE.SCAN,
        previousTasks: [ this.SCANTASK.SCAN ],
    } );
    this._taskInfo.set( this.SCANTASK.LINK, {
        icon: 'pcviz-icon-link',
        main: true,
        isProcessTask: true,
        openTab: 'workflow',
    } );
    this._taskInfo.set( Workflow.TASK.CLOSE, {
        icon: 'pcviz-icon-close',
        main: true,
        position: Workflow.TASK_POSITION.BOTTOM,
    } );
    this._taskInfo.set( this.SCANTASK.EDIT_LOCALIZATION, {
        icon: 'pcviz-icon-edit-localization',
        main: true,
        isProcessTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
    } );
    this._taskInfo.set( this.SCANTASK.SURVEY_NEW_POINT, {
        icon: 'pcviz-icon-survey-new-point',
        main: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
    } );
    this._taskInfo.set( this.SCANTASK.CANCEL, {
        icon: 'pcviz-icon-close',
        main: true,
        position: Workflow.TASK_POSITION.BOTTOM,
    } );
    this._taskInfo.set( this.SCANTASK.SCAN_RASTER, {
        icon: '',
        main: true,
    } );
    this._taskInfo.set( this.SCANTASK.IDENTIFY_TARGETS, {
        icon: 'pcviz-icon-target',
        main: true,
        isAddTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.GEOREFERENCING, {
        icon: 'geo-positioning',
        main: true,
        isAddTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );
    this._taskInfo.set( this.SCANTASK.ASSISTED_TARGET_DETECTION, {
        main: true,
        isAddTask: true,
    } );

    this._taskInfo.set( this.SCANTASK.GEOREFERENCING, {
        icon: 'pcviz-icon-georeferencing',
        main: true,
        isAddTask: true,
        previousState: this.SCANSTATE.REGISTRATION,
        previousTasks: [ this.SCANTASK.REGISTER ],
        openTab: 'workflow',
    } );

    this.setStateAndTasks( this.SCANSTATE.EMPTY );

    this._workspace = undefined;

    // TODO: Remove when import scan project job is completed
    this._scanProjectFiles = undefined;

    this._registrationObject = {
        type: 'none', // here we can use SCANTASK.REGISTER_xxx to identify
        points: {}, // here we add the different points needed for each registration
        bundles: [],
        processedBundles: [],
        version: 2,
    };

    // this is to save temporaly workspace to undo the registration
    this._tmpWorkspace = {};

    this._hasRasterLayer = false;

    this._isScannerConnected = false;

    this._projectPatchPromises = [];
    this._layoutAddingFromList = false;
    this._resectionFromRaster = false;

    this._backgroundJobFinishListener = undefined;

    this._controlPointsFeaturesCount = 0;
    this._targetFeaturesInCurrentBundle = 0;

    this.REGISTRATION_METHOD = {
        OCCBS: 'OCCBS',
        RESECTION: 'RESECTION',
        C2C: 'C2C',
        DISTRIBUTED_LOCALIZATION: 'DISTRIBUTED_LOCALIZATION',
    };

    this.localizationMethods = [ this.REGISTRATION_METHOD.OCCBS, this.REGISTRATION_METHOD.RESECTION, this.REGISTRATION_METHOD.DISTRIBUTED_LOCALIZATION ];


    Registry.getInstance()
        .getController( 'ScanSelection' )
        .registerListener(
            ListenerController.PROJECT,
            () => {
                if ( this._savedCurrentStation !== this.getCurrentStation() ) {
                    this._savedCurrentStation = this.getCurrentStation();
                    let project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
                    if ( this._projectPatchPromises.length )
                        Promise.allSettled( this._projectPatchPromises ).then( () => {
                            this._projectPatchPromises = [];
                            this._projectPatchPromises.push(
                                this.writeToProject( project )
                                .then( () => {} )
                                .catch( () => {
                                    console.error( 'The current station has not been saved' );
                                } )
                            ); // .finally( () => { this._projectPatchPromises.pop(); } )
                        } );
                    else
                        this._projectPatchPromises.push(
                            this.writeToProject( project )
                            .then( () => {} )
                            .catch( () => {
                                console.error( 'The current station has not been saved' );
                            } )
                        ); // .finally( () => { this._projectPatchPromises.pop(); } )
                }
            },
            'ScanWorkflow',
            'currentStation'
        );
    Registry.getInstance()
        .getController( 'SelectionObject' )
        .registerListener(
            ListenerController.PROJECT,
            ( selectionObject ) => {
                const selectionObjectLayer = selectionObject.getLayer();
                if ( selectionObjectLayer && selectionObjectLayer.getType() === 'LayerGroup' && selectionObjectLayer.isStation() ) {
                    this.computeTargetsLengthFromBundle( selectionObjectLayer );
                    this.computeControlPointsCount();
                }
            },
            'ScanWorkflow',
            'selectionObject'
        );
};

ScanWorkflow.prototype = Utils.objectInherit( Workflow.prototype, {
    getClassName: function () {
        return 'ScanWorkflow';
    },

    getHelpPrefix: function () {
        return 'SCANPROC';
    },

    getInstance: function () {
        return new ScanWorkflow();
    },

    writeToJSON: function () {
        // do not save some properties
        const savedStateNames = this.SCANSTATE;
        const savedTaskNames = this.SCANTASK;
        const savedProgressiveStates = this.PROGRESSIVE_STATES;
        const isScannerConnected = this._isScannerConnected;
        const savedProjectPatchPromises = this._projectPatchPromises;
        const savedBackgroundTasks = this.BACKGROUND_TASKS;
        const savedRegistrationMethods = this.REGISTRATION_METHOD;
        //
        this.SCANSTATE = undefined;
        this.SCANTASK = undefined;
        this.PROGRESSIVE_STATES = undefined;
        this._isScannerConnected = undefined;
        this._projectPatchPromises = undefined;
        this.BACKGROUND_TASKS = undefined;
        this.REGISTRATION_METHOD = undefined;

        // create serialized object
        const savedData = Workflow.prototype.writeToJSON.call( this );

        // restore properties
        this.SCANSTATE = savedStateNames;
        this.SCANTASK = savedTaskNames;
        this.PROGRESSIVE_STATES = savedProgressiveStates;
        this._isScannerConnected = isScannerConnected;
        this._projectPatchPromises = savedProjectPatchPromises;
        this.BACKGROUND_TASKS = savedBackgroundTasks;
        this.REGISTRATION_METHOD = savedRegistrationMethods;

        return savedData;
    },

    readFromJSON: function ( wfJSON ) {
        if ( wfJSON && wfJSON.data && wfJSON.data.REGISTRATION_METHOD ) {
            // Temporal change: delete it after CS 1.10.0
            delete wfJSON.data.REGISTRATION_METHOD;
        }
        let wf = Workflow.prototype.readFromJSON.call( this, wfJSON );
        this.ensureRegistrationObject( wf );
        if ( this.getCurrentStation() === undefined && wf._savedCurrentStation )
            // Maybe we could set the saved in the project if there's current station but it is not in the project
            Registry.getInstance().getController( 'ScanSelection' ).setCurrentStation( wf._savedCurrentStation );
        return wf;
    },

    ensureRegistrationObject: function ( wfObj ) {
        if ( !wfObj._registrationObject.version ) {
            wfObj._registrationObject.version = 2;
            wfObj._registrationObject.low = 0.02;
            wfObj._registrationObject.high = 0.05;
        }
    },

    isProgressState: function () {
        return this.PROGRESSIVE_STATES.includes( this._state );
    },

    needCancelState: function () {
        return [ this.SCANSTATE.SCANNING_CLOUD, this.SCANSTATE.SCANNING_WINDOW, this.SCANSTATE.SCANNING_CLOUD_RASTER ].includes( this._state );
    },

    getROI: function () {
        return this._ROI;
    },

    getROIFromProject: function ( project ) {
        const workflow = this.getWorkflowFromProject( project );
        if ( workflow ) return workflow._ROI;

        return undefined;
    },

    // be careful when using this function. It doesn't modify the 'this._ROI' attribute directly
    setROIInProject: function ( project, region ) {
        const workflow = this.getWorkflowFromProject( project );

        if ( workflow ) {
            workflow._ROI = region;
            const destinationVersion = workflow._savedVersions[ 0 ];
            destinationVersion.ROI = workflow._ROI ? JSON.parse( JSON.stringify( workflow._ROI ) ) : undefined; // clone ROI
            Workflow.prototype.writeWorkflowToProject( workflow, project, this.getClassName() );
        }
    },

    // state machine transitions

    runTask: function ( project, taskName, isVersionChange, jobData ) {
        var previousState = this._state;

        this._hasToRefresh = false;
        var found = this._tasks.find( function ( task ) {
            return task && task.name === taskName;
        } );
        if ( !found && taskName !== Workflow.TASK.FINISH ) {
            console.log( 'Workflow: task ' + taskName + ' not defined for state ' + this._state );
            return P.resolve();
        }

        let launchNotify;

        switch ( this._state ) {
        case this.SCANSTATE.EMPTY:
            switch ( taskName ) {
            case this.SCANTASK.IMPORT:
                this.setStateAndTasks( this.SCANSTATE.IMPORT );
                break;
            case this.SCANTASK.ADD_NEW_STATION:
                this.setStateAndTasks( this.SCANSTATE.ADDING_NEW_STATION );
                break;
            case this.SCANTASK.LAYOUT:
                this.setStateAndTasks( this.SCANSTATE.LAYOUT_SELECTING_POINTS );
                break;
            case this.SCANTASK.TRANSFORM_RASTER:
                this.setStateAndTasks( this.SCANSTATE.TRANSFORMING_RASTER );
                break;

            case this.SCANTASK.EXPORT:
                this.setStateAndTasks( this.SCANSTATE.EXPORT );
                break;
            case this.SCANTASK.SYNC_CLOUD:
                this.setStateAndTasks( this.SCANSTATE.SYNCHRONIZING );
                break;
            case this.SCANTASK.VERIFY:
                this.setStateAndTasks( this.SCANSTATE.VERIFY );
                break;
            case this.SCANTASK.MEASUREMENTS:
                this.setStateAndTasks( this.SCANSTATE.MEASUREMENTS );
                break;
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.NOT_EMPTY:
            switch ( taskName ) {
            case this.SCANTASK.IMPORT:
                this.setStateAndTasks( this.SCANSTATE.IMPORT );
                break;
            case this.SCANTASK.PROCESS_SCAN:
                this.setStateAndTasks( this.SCANSTATE.PROCESSING_SCAN );
                break;
            case this.SCANTASK.REGISTER:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION );
                break;
            case this.SCANTASK.REGISTER_C2C:
            case this.SCANTASK.LINK:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_C2C );
                break;
            case this.SCANTASK.EXPORT:
                this.setStateAndTasks( this.SCANSTATE.EXPORT );
                break;
            case this.SCANTASK.TRANSFORM_RASTER:
                this.setStateAndTasks( this.SCANSTATE.TRANSFORMING_RASTER );
                break;
            case this.SCANTASK.SYNC_CLOUD:
                this.setStateAndTasks( this.SCANSTATE.SYNCHRONIZING );
                break;
            case this.SCANTASK.CAPTURE_SCAN:
                this.setStateAndTasks( this.SCANSTATE.CAPTURING_SCAN );
                break;
            case this.SCANTASK.SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCAN );
                break;
            case this.SCANTASK.ADD_NEW_STATION:
                this.setStateAndTasks( this.SCANSTATE.ADDING_NEW_STATION );
                break;
            case this.SCANTASK.LAYOUT:
                this.setStateAndTasks( this.SCANSTATE.LAYOUT_SELECTING_POINTS );
                break;
            case this.SCANTASK.VERIFY:
                this.setStateAndTasks( this.SCANSTATE.VERIFY );
                break;
            case this.SCANTASK.MEASUREMENTS:
                this.setStateAndTasks( this.SCANSTATE.MEASUREMENTS );
                break;
            case this.SCANTASK.EDIT_SCANS:
                this.setStateAndTasks( this.SCANSTATE.EDIT_SCANS );
                break;
            case this.SCANTASK.GENERATE_AND_EXPORT_DELIVERABLES:
                this.setStateAndTasks( this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES );
                break;
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.IMPORT:
            switch ( taskName ) {
            case this.SCANTASK.IMPORT_PROJECT:
                this.setStateAndTasks( this.SCANSTATE.IMPORTING_PROJECT );
                break;
            case this.SCANTASK.IMPORT_SCAN:
                this.setStateAndTasks( this.SCANSTATE.IMPORTING_SCAN );
                break;
            case this.SCANTASK.CREATE_STATION:
                this.setStateAndTasks( this.SCANSTATE.CREATING_STATION );
                break;
            case this.SCANTASK.IMPORT_STATION:
                this.setStateAndTasks( this.SCANSTATE.IMPORTING_STATION );
                break;
            case this.SCANTASK.IMPORT_REFS:
                this.setStateAndTasks( this.SCANSTATE.IMPORTING_REFS );
                break;
            case this.SCANTASK.UPGRADE_SPARSE_TO_FULL:
                this.setStateAndTasks( this.SCANSTATE.UPGRADING_SPARSE_TO_FULL );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState(); // we do not modify the empty/not-empty state
                this.notifyStateChange( this.SCANTASK.IMPORT );
                break;
            }
            break;

        case this.SCANSTATE.REGISTRATION:
            let notifyChangeReg = '';
            switch ( taskName ) {
            case this.SCANTASK.REGISTER_MANUAL:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_MANUAL );
                break;
            case this.SCANTASK.CAPTURE_SCAN:
                this.setStateAndTasks( this.SCANSTATE.CAPTURING_SCAN );
                break;
            case this.SCANTASK.REGISTER_OCCBS:
                this._avoidWaitingImportAfterRegister = false;
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_OCCBS );
                break;
            case this.SCANTASK.REGISTER_BYREFS:
                this._resectionFromRaster = false;
                this._avoidWaitingImportAfterRegister = false;
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_BYREFS );
                break;
            case this.SCANTASK.REGISTER_BYREFS_AUTO:
                this._resectionFromRaster = true;
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_BYREFS_AUTO );
                break;
            case this.SCANTASK.REGISTER_C2C:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_C2C );
                break;
            case this.SCANTASK.EDIT_LOCALIZATION:
                let station = this.getSelectedStationWorkspaceObj() ?
                    this.getSelectedStationWorkspaceObj() :
                    this.getCurrentStationWorkspaceObj();
                this._avoidWaitingImportAfterRegister = false;

                const method = station.surveyRegistrationInfo && station.surveyRegistrationInfo.method;
                switch ( method ) {
                case this.REGISTRATION_METHOD.OCCBS:
                    this.setStateAndTasks( this.SCANSTATE.REGISTRATION_OCCBS );
                    break;
                case this.REGISTRATION_METHOD.DISTRIBUTED_LOCALIZATION:
                    this.setStateAndTasks( this.SCANSTATE.GEOREFERENCING );
                    break;
                default:
                    this._resectionFromRaster = this.isScannerConnected() && this.isRasterScannerType() ? true : false;
                    this.setStateAndTasks( this.SCANSTATE.REGISTRATION_BYREFS );
                    notifyChangeReg = this.SCANTASK.EDIT_LOCALIZATION;
                    break;
                }
                break;

            case this.SCANTASK.SURVEY_NEW_POINT:
                this.setStateAndTasks( this.SCANSTATE.SURVEYING_NEW_POINT );
                break;
            case this.SCANTASK.REVERT_REGISTRATION:
                this.setStateAndTasks( this.SCANSTATE.REVERT_REGISTRATION );
                break;
            case this.SCANTASK.GEOREFERENCING:
                this.setStateAndTasks( this.SCANSTATE.GEOREFERENCING );
                break;
            case this.SCANTASK.IDENTIFY_TARGETS:
                this.setStateAndTasks( this.SCANSTATE.IDENTIFY_TARGETS );
                break;
            case Workflow.TASK.CLOSE:
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                break;
            }
            this.notifyStateChange( notifyChangeReg );
            break;

        case this.SCANSTATE.CAPTURING_SCAN:
        case this.SCANSTATE.REGISTRATION_MANUAL:
        case this.SCANSTATE.TRANSFORMING_RASTER:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.backToPreviousState();
            } else if ( taskName === this.SCANTASK.REGISTER_C2C_PROCESS ) {
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_C2C_SCAN );
            } else if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
            } else {
                this.notifyStateChange( '' );
            }
            break;

        case this.SCANSTATE.REGISTRATION_OCCBS:
        case this.SCANSTATE.REGISTRATION_BYREFS:
        case this.SCANSTATE.REGISTRATION_BYREFS_AUTO:
        case this.SCANSTATE.LINKING_STATIONS:
            //case this.SCANSTATE.C2C_LINK_STATION:
        case this.SCANSTATE.C2C_REMOVING_LINKS:
            switch ( taskName ) {
            case this.SCANTASK.REGISTER_BYREFS_PROCESS:
            case this.SCANTASK.REGISTER_OCCBS_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_SCAN );
                break;
            case this.SCANTASK.REGISTER_C2C_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_C2C_SCAN );
                break;
            case this.SCANTASK.C2C_MANUAL:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_MANUAL );
                break;
            case this.SCANTASK.SCAN_RASTER:
                if ( this._resectionFromRaster ) this.setStateAndTasks( this.SCANSTATE.SCANNING_CLOUD_RASTER );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.ADJUSTING_BUNDLES:
            switch ( taskName ) {
            case this.SCANTASK.REGISTER_C2C_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_C2C_SCAN, true ); // not push ADJUSTING_BUNDLES state
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }

            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.REGISTRATION_C2C:
            if ( taskName !== this.SCANTASK.REGISTER_C2C_PROCESS ) Registry.getInstance().getController( 'C2CLink' ).clearBackupLinkArray();
            switch ( taskName ) {
            case this.SCANTASK.REGISTER_MANUAL:
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_MANUAL );
                break;
            case this.SCANTASK.CAPTURE_SCAN:
                this.setStateAndTasks( this.SCANSTATE.CAPTURING_SCAN );
                break; // Check with CE3D if this is necessary
            case this.SCANTASK.LINK_STATIONS:
                this.setStateAndTasks( this.SCANSTATE.LINKING_STATIONS );
                break;
                /* case this.SCANTASK.C2C_LINK_STATION:
                 this.setStateAndTasks( this.SCANSTATE.C2C_LINK_STATION );
                 break;*/
            case this.SCANTASK.C2C_REMOVE_LINKS:
                this.setStateAndTasks( this.SCANSTATE.C2C_REMOVING_LINKS );
                break;
            case this.SCANTASK.BUNDLE_ADJUST:
                this.setStateAndTasks( this.SCANSTATE.ADJUSTING_BUNDLES );
                break;
            case this.SCANTASK.REGISTER_C2C_PROCESS: // From context menu in C2C
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_C2C_SCAN );
                break;
            case this.SCANTASK.C2C_MANUAL: // From context menu in C2C
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_MANUAL );
                break;
            case this.SCANTASK.CANCEL:
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange(
                taskName === Workflow.TASK.CLOSE || taskName === this.SCANTASK.CANCEL ? this.SCANTASK.REGISTER_C2C : taskName
            );
            break;

        case this.SCANSTATE.REVERT_REGISTRATION:
            this.backToPreviousState( true );
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.GEOREFERENCING:
            switch ( taskName ) {
            case this.SCANTASK.GEOREFERENCING_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.REGISTERING_SCAN );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange( this.SCANTASK.GEOREFERENCING );
            break;

        case this.SCANSTATE.IDENTIFY_TARGETS:
            switch ( taskName ) {
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            case this.SCANTASK.ASSISTED_TARGET_DETECTION:
                this.setStateAndTasks( this.SCANSTATE.ASSISTED_TARGET_DETECTION );
                break;
            }
            this.notifyStateChange( this.SCANTASK.IDENTIFY_TARGETS );
            break;

        case this.SCANSTATE.ASSISTED_TARGET_DETECTION:
            this.backToPreviousState( true );
            this.notifyStateChange( this.SCANTASK.ASSISTED_TARGET_DETECTION );
            break;

        case this.SCANSTATE.EXPORT:
            switch ( taskName ) {
            case this.SCANTASK.EXPORT_SCANS:
                this.setStateAndTasks( this.SCANSTATE.EXPORTING_SCAN );
                break;
            case Workflow.TASK.CLOSE:
                this.setStateAndTasks( this.isEmpty() ? this.SCANSTATE.EMPTY : this.SCANSTATE.NOT_EMPTY );
                break;
            }
            this.notifyStateChange( '' );
            break;
        case this.SCANSTATE.SCAN:
            switch ( taskName ) {
            case this.SCANTASK.FREE_SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCANNING_CLOUD );
                break;
            case this.SCANTASK.WINDOW_SCAN:
            case this.SCANTASK.DETAIL_SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCANNING_WINDOW );
                break;
            case this.SCANTASK.TARGET_SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCANNING_TARGET );
                break;
            case this.SCANTASK.RASTER_FULL_SCAN:
                this._resectionFromRaster = true;
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION_BYREFS_AUTO );
                break;
            case Workflow.TASK.CLOSE:
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                break;
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.EDIT_SCANS:
            switch ( taskName ) {
            case this.SCANTASK.MERGE_SCANS:
                this.setStateAndTasks( this.SCANSTATE.MERGE_SCANS );
                break;
            case this.SCANTASK.DELETION_TOOL:
                this.setStateAndTasks( this.SCANSTATE.DELETION_TOOL );
                break;
            case this.SCANTASK.SEGMENTS_CONTROL:
                this.setStateAndTasks( this.SCANSTATE.SEGMENTS_CONTROL );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange( taskName === Workflow.TASK.CLOSE ? this.SCANTASK.EDIT_SCANS : taskName );
            break;
        case this.SCANSTATE.CREATE_REFERENCE_PLANE:
            switch ( taskName ) {
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                this.notifyStateChange( this.SCANTASK.CREATE_REFERENCE_PLANE );
                break;
            }
            break;
        case this.SCANSTATE.MERGE_SCANS:
            if ( taskName === this.SCANTASK.MERGE_SCANS_PROCESS ) {
                this.setStateAndTasks( this.SCANSTATE.MERGE_SCANS_PROCESSING );
                this.notifyStateChange( this.SCANTASK.MERGE_SCANS_PROCESS );
            } else {
                this.backToPreviousState( true );
                this.notifyStateChange( this.SCANTASK.MERGE_SCANS );
            }
            break;

        case this.SCANSTATE.MERGE_SCANS_PROCESSING:
        case this.SCANSTATE.TIN_PROCESSING:
            this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.VOLUME_PROCESSING:
            const previousStateInArray = this.getPreviousState();
            const nextState =
                previousStateInArray !== this.SCANSTATE.VOLUME_DELIVERABLES ? this.SCANSTATE.VOLUME_REPORT : this.SCANSTATE.NOT_EMPTY;
            this.setStateAndTasks( nextState );
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.STANDARD_VERIFY:
        case this.SCANSTATE.TOTAL_STATION_VERIFY: // Keeping this just for old projects
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.backToPreviousState( true );
                this.notifyStateChange( this.SCANTASK.VERIFY_INSTALLATION );
            }
            if ( taskName === this.SCANTASK.VERIFING_ELEMENTS ) {
                this.setStateAndTasks( this.SCANSTATE.VERIFING_ELEMENTS );
            }
            if ( taskName === this.SCANTASK.FREE_SCAN ) {
                this.setStateAndTasks( this.SCANSTATE.SCANNING_CLOUD );
            }
            break;
        case this.SCANSTATE.VERIFY:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.setStateAndTasks( this.isEmpty() ? this.SCANSTATE.EMPTY : this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.VERIFY );
            }
            if ( taskName === this.SCANTASK.VERIFY_INSTALLATION ) {
                this.setStateAndTasks( this.SCANSTATE.STANDARD_VERIFY );
            }
            break;

        case this.SCANSTATE.VERIFING_ELEMENTS:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.setStateAndTasks( this.SCANSTATE.VERIFY );
                this.notifyStateChange( this.SCANTASK.VERIFY_INSTALLATION ); // to exit panorama mode and restore visibility
            }
            if ( taskName === this.SCANTASK.VERIFIED_ELEMENTS ) {
                this.setStateAndTasks( this.SCANSTATE.VERIFIED_ELEMENTS );
            }
            break;

        case this.SCANSTATE.VERIFIED_ELEMENTS:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.setStateAndTasks( this.SCANSTATE.VERIFY );
                this.notifyStateChange( this.SCANTASK.VERIFY_INSTALLATION ); // to exit panorama mode and restore visibility
            }
            break;

        case this.SCANSTATE.MEASUREMENTS:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.MEASUREMENTS );
            } else {
                if ( taskName === this.SCANTASK.VOLUME_MEASURE ) {
                    this.setStateAndTasks( this.SCANSTATE.VOLUME_MEASURE );
                    this.notifyStateChange( this.SCANTASK.VOLUME_MEASURE );
                }
                if ( taskName === this.SCANTASK.AREA_MEASURE ) {
                    this.setStateAndTasks( this.SCANSTATE.AREA_MEASURE );
                    this.notifyStateChange( this.SCANTASK.AREA_MEASURE );
                }
                if ( taskName === this.SCANTASK.DISTANCE_MEASURE ) {
                    this.setStateAndTasks( this.SCANSTATE.DISTANCE_MEASURE );
                    this.notifyStateChange( this.SCANTASK.DISTANCE_MEASURE );
                }
            }
            break;

        case this.SCANSTATE.VOLUME_MEASURE:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.setStateAndTasks( this.SCANSTATE.MEASUREMENTS );
                this.notifyStateChange( this.SCANTASK.VOLUME_MEASURE );
            }
            if ( taskName === this.SCANTASK.VOLUME_SURFACE ) {
                this.setStateAndTasks( this.SCANSTATE.VOLUME_SURFACE );
                this.notifyStateChange( this.SCANTASK.VOLUME_SURFACE );
            }
            if ( taskName === this.SCANTASK.VOLUME_QUANTITY ) {
                this.setStateAndTasks( this.SCANSTATE.VOLUME_QUANTITY );
                this.notifyStateChange( this.SCANTASK.VOLUME_QUANTITY );
            }
            if ( taskName === this.SCANTASK.VOLUME_STOCKPILE ) {
                this.setStateAndTasks( this.SCANSTATE.VOLUME_STOCKPILE );
                this.notifyStateChange( this.SCANTASK.VOLUME_STOCKPILE );
            }
            break;

        case this.SCANSTATE.VOLUME_QUANTITY:
        case this.SCANSTATE.VOLUME_STOCKPILE:
        case this.SCANSTATE.VOLUME_SURFACE:
            switch ( taskName ) {
            case Workflow.TASK.CLOSE:
                this.setStateAndTasks( this.SCANSTATE.VOLUME_MEASURE );
                break;
            case this.SCANTASK.IMPORT_REFS:
                this.setStateAndTasks( this.SCANSTATE.IMPORTING_REFS );
                break;
            case this.SCANTASK.VOLUME_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.VOLUME_PROCESSING );
                break;
            default:
                this.backToPreviousState( true );
            }
            this.notifyStateChange( '' );
            break;
        case this.SCANSTATE.VOLUME_REPORT:
            if ( taskName === Workflow.TASK.CLOSE ) this.setStateAndTasks( this.SCANSTATE.VOLUME_MEASURE );
            this.notifyStateChange( '' );
            break;
        case this.SCANSTATE.GENERATE_AND_EXPORT_DELIVERABLES:
            switch ( taskName ) {
            case this.SCANTASK.CREATE_REFERENCE_PLANE:
                this.setStateAndTasks( this.SCANSTATE.CREATE_REFERENCE_PLANE );
                break;
            case this.SCANTASK.TIN_DELIVERABLES:
                this.setStateAndTasks( this.SCANSTATE.TIN_DELIVERABLES );
                break;
            case this.SCANTASK.VOLUME_DELIVERABLES:
                this.setStateAndTasks( this.SCANSTATE.VOLUME_DELIVERABLES );
                break;
            case this.SCANTASK.CONTOURS_DELIVERABLES:
                this.setStateAndTasks( this.SCANSTATE.CONTOURS_DELIVERABLES );
                break;
            case this.SCANTASK.ORTHOPHOTO_DELIVERABLES:
                this.setStateAndTasks( this.SCANSTATE.ORTHOPHOTO_DELIVERABLES );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange( '' );
            break;
        case this.SCANSTATE.DELETION_TOOL:
        case this.SCANSTATE.SEGMENTS_CONTROL:
            if ( taskName === Workflow.TASK.CLOSE ) {
                this.backToPreviousState( true );
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.VOLUME_DELIVERABLES:
            if ( taskName === this.SCANTASK.VOLUME_PROCESS ) {
                this.setStateAndTasks( this.SCANSTATE.VOLUME_PROCESSING );
            } else {
                this.backToPreviousState( true );
            }
            this.notifyStateChange( '' );
            break;
            // related to jobs

        case this.SCANSTATE.TIN_DELIVERABLES:
            switch ( taskName ) {
            case this.SCANTASK.TIN_PROCESS:
                this.setStateAndTasks( this.SCANSTATE.TIN_PROCESSING );
                break;
            case Workflow.TASK.CLOSE:
                this.backToPreviousState( true );
                break;
            }
            this.notifyStateChange( '' );
            break;

        case this.SCANSTATE.IMPORTING_PROJECT:
            let previousState = this.getPreviousState();

            if ( taskName === Workflow.TASK.FINISH ) {
                // TODO: this.finishImportingProject(); // Do we need to set something
                if ( jobData && jobData.waitingProcess ) {
                    this.setStateAndTasks( this.SCANSTATE.WAITING_FOR_PROCESS );
                    // If job was started from the script lib, avoid doing PATCH to the project (to avoid simultaneous requests and losing information)
                    if ( this.isJobFromScript( jobData ) ) return Promise.resolve();
                } else if (
                    [
                        this.SCANSTATE.REGISTRATION_BYREFS,
                        this.SCANSTATE.REGISTRATION_BYREFS_AUTO,
                        this.SCANSTATE.REGISTRATION_OCCBS,
                    ].includes( previousState )
                )
                    this.setStateAndTasks( this.SCANSTATE.LOCALIZED );
                else {
                    this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                }

                this.notifyStateChange( this.SCANTASK.IMPORT_PROJECT );
            }
            break;
        case this.SCANSTATE.PROCESSING_SCAN:
            if ( taskName === Workflow.TASK.FINISH ) {
                let lastStandardVerification = this._previousStates.lastIndexOf( this.SCANSTATE.VERIFY );

                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                if (
                    lastStandardVerification !== -1 &&
                    this._verificationRunning &&
                    this._previousStates.length - lastStandardVerification === 2
                )
                    this.launchStandardVerification( undefined );
                this.notifyStateChange( this.SCANTASK.PROCESS_SCAN );
            }
            break;
        case this.SCANSTATE.IMPORTING_REFS:
            if ( taskName === Workflow.TASK.FINISH ) {
                this._hasRasterLayer = project.getAllLayers().some( ( layer ) => {
                    return layer.getType() === LayerType.RASTER;
                } );

                this.backToPreviousState(); // we do not modify the empty/not-empty state
                this.notifyStateChange( this.SCANTASK.IMPORT_REFS );
            }
            break;
        case this.SCANSTATE.IMPORTING_SCAN:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.backToPreviousState(); // we do not modify the empty/not-empty state
                this.notifyStateChange( this.SCANTASK.IMPORT_SCAN );
            }
            break;
        case this.SCANSTATE.CREATING_STATION:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.IMPORT_STATION );
            }
            break;
        case this.SCANSTATE.IMPORTING_STATION:
            if ( taskName === Workflow.TASK.FINISH ) {
                const newState = jobData && jobData.waitingProcess ? this.SCANSTATE.PROCESSING_SCAN : this.SCANSTATE.NOT_EMPTY;

                this.setStateAndTasks( newState );
                this.notifyStateChange( this.SCANTASK.IMPORT_STATION );
            }
            break;
        case this.SCANSTATE.SYNCHRONIZING:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.backToPreviousState(); // we do not modify the empty/not-empty state
                this.notifyStateChange( this.SCANTASK.SYNC_CLOUD );
            }
            break;
        case this.SCANSTATE.REGISTERING_SCAN:
            if ( taskName === Workflow.TASK.FINISH ) {
                let prevTask = this._previousStates[ this._previousStates.length - 1 ];
                switch ( prevTask ) {
                    // Keep these cases to keep compatibility with previous versions (when launching c2c set this state)
                case this.SCANSTATE.REGISTRATION_MANUAL:
                case this.SCANSTATE.LINKING_STATIONS:
                    // case this.SCANSTATE.C2C_LINK_STATION:
                case this.SCANSTATE.C2C_REMOVING_LINKS:
                case this.SCANSTATE.REGISTRATION_C2C: // if we come from a not pushed state
                    this.backToPreviousState( true );
                    break;
                case this.SCANSTATE.REGISTRATION_BYREFS:
                case this.SCANSTATE.REGISTRATION_BYREFS_AUTO:
                case this.SCANSTATE.REGISTRATION_OCCBS:
                case this.SCANSTATE.GEOREFERENCING:
                    let nextState = this._setWaitingStateOrDefault( this.SCANSTATE.LOCALIZED, prevTask );

                    // aditional extra mock action ? please go below 'extramock action' in the pointcloudvizmocks file

                    this.setStateAndTasks( nextState );
                    break;
                }
                launchNotify = this.SCANTASK.REGISTER;
            }
            break;

        case this.SCANSTATE.REGISTERING_C2C_SCAN:
            if ( taskName === Workflow.TASK.FINISH ) {
                let prevTask = this._previousStates[ this._previousStates.length - 1 ];
                switch ( prevTask ) {
                case this.SCANSTATE.REGISTRATION_MANUAL:
                case this.SCANSTATE.LINKING_STATIONS:
                case this.SCANSTATE.C2C_REMOVING_LINKS:
                case this.SCANSTATE.REGISTRATION_C2C: // if we come from a not pushed state
                    this.backToPreviousState( true );
                    break;
                }
                launchNotify = this.SCANTASK.REGISTER;
            }
            break;

        case this.SCANSTATE.LOCALIZED:
            let notifyChange = '';
            switch ( taskName ) {
            case this.SCANTASK.EDIT_LOCALIZATION:
                let station = this.getSelectedStationWorkspaceObj() ?
                    this.getSelectedStationWorkspaceObj() :
                    this.getCurrentStationWorkspaceObj();
                this._avoidWaitingImportAfterRegister = false;
                const method = station.surveyRegistrationInfo && station.surveyRegistrationInfo.method;
                switch ( method ) {
                case this.REGISTRATION_METHOD.OCCBS:
                    this.setStateAndTasks( this.SCANSTATE.REGISTRATION_OCCBS );
                    break;
                case this.REGISTRATION_METHOD.DISTRIBUTED_LOCALIZATION:
                    this.setStateAndTasks( this.SCANSTATE.GEOREFERENCING );
                    break;
                default:
                    this.setStateAndTasks( this.SCANSTATE.REGISTRATION_BYREFS );
                    notifyChange = this.SCANTASK.EDIT_LOCALIZATION;
                    break;
                }
                break;

            case this.SCANTASK.FREE_SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCANNING_CLOUD );
                break;

            case this.SCANTASK.WINDOW_SCAN:
                this.setStateAndTasks( this.SCANSTATE.SCANNING_WINDOW );
                break;

            case Workflow.TASK.CLOSE:
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                break;
            }
            this.notifyStateChange( notifyChange );
            break;

        case this.SCANSTATE.EXPORTING_SCAN:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.EXPORT );
                this.notifyStateChange( this.SCANTASK.EXPORT_SCANS );
            }
            break;
        case this.SCANSTATE.UPGRADING_SPARSE_TO_FULL:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.UPGRADE_SPARSE_TO_FULL );
            }
            break;
        case this.SCANSTATE.ADDING_NEW_STATION:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.ADD_NEW_STATION );
            }
            /* Use the code below if the cancel function runs the CLOSE task
             if ( taskName === Workflow.TASK.CLOSE )
                 this.backToPreviousState(); // we do not modify the empty/not-empty state*/

            break;
        case this.SCANSTATE.LAYOUT_SELECTING_POINTS:
            if ( taskName === Workflow.TASK.FINISH || taskName === this.SCANTASK.CANCEL ) {
                this.setStateAndTasks( this.SCANSTATE.NOT_EMPTY );
                this.notifyStateChange( this.SCANTASK.LAYOUT );
                break;
            } else if ( taskName === this.SCANTASK.LAYOUT_EACH_POINT ) {
                this.setStateAndTasks( this.SCANSTATE.LAYOUT );
                //   this.notifyStateChange( this.SCANTASK.LAYOUT );
                break;
            }
            break;

        case this.SCANSTATE.SCANNING_CLOUD:
        case this.SCANSTATE.SCANNING_CLOUD_RASTER:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.WAITING_FOR_IMPORT );
                this.notifyStateChange( this.SCANTASK.FREE_SCAN );
                break;
            }
            break;

        case this.SCANSTATE.SCANNING_WINDOW:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.WAITING_FOR_IMPORT );
                this.notifyStateChange( this.isCRP1Connected() ? this.SCANTASK.DETAIL_SCAN : this.SCANTASK.WINDOW_SCAN );
                break;
            }
            break;

        case this.SCANSTATE.SCANNING_TARGET:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.WAITING_FOR_IMPORT );
                this.notifyStateChange( this.SCANTASK.TARGET_SCAN );
                break;
            }
            break;

            // TRANSFERING_STATION is Deprecated, keep this in case a user has a project in this state.
        case this.SCANSTATE.TRANSFERING_STATION:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANTASK.SCAN );
                this.notifyStateChange( this.SCANSTATE.TARGET_SCAN );
            }
            break;

        case this.SCANSTATE.SURVEYING_NEW_POINT:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.REGISTRATION );
                this.notifyStateChange( this.SCANTASK.SURVEY_NEW_POINT );
            }
            break;
        case this.SCANSTATE.LAYOUT:
            if ( taskName === Workflow.TASK.FINISH ) {
                this.setStateAndTasks( this.SCANSTATE.LAYOUT_SELECTING_POINTS );
            }
            break;

        default:
            console.warn( 'trying to set ' + taskName + 'from state' + this._state );
        }
        return this.saveStatusRunTask( project, taskName, previousState, launchNotify );
    },

    /**
     * This function has some logic to know if we have to set waitingForImport or a defaultState passed
     * @param defaultState, the state to set if some conditions are not true to set waitingForImport
     */

    _setWaitingStateOrDefault: function ( defaultState, previousState ) {
        let nextState = defaultState;

        const localizeStates = [ this.SCANSTATE.REGISTRATION_BYREFS, this.SCANSTATE.REGISTRATION_OCCBS, this.SCANSTATE.GEOREFERENCING ];

        if ( localizeStates.includes( previousState ) && this._avoidWaitingImportAfterRegister ) return nextState;

        // It is not allowed to Scan targets with CR-P1 currently
        if (
            MagnetAPI.isSite() &&
            this.getCurrentStation() &&
            this.getCurrentStationWorkspaceObj() &&
            Registry.getInstance().getController( 'ScanSelection' ).getScannerStatus() &&
            !this.isCRP1ScannerType()
        ) {
            let lastScan = this._previousStates.lastIndexOf( this.SCANSTATE.SCAN );
            let lastRasterScan = this._previousStates.lastIndexOf( this.SCANSTATE.SCANNING_CLOUD_RASTER );
            // For autoresection we can view the state name 'RegistrationByRefsAuto' just before scanning the raster
            // It is necessary to check if there has been a Scan after last RasterScan and if the user is just localizing and Raster Scan happened sometime before (> 5 states)
            let isAutoresection =
                lastRasterScan > -1 &&
                this._previousStates[ lastRasterScan - 1 ] === this.SCANSTATE.REGISTRATION_BYREFS_AUTO &&
                lastRasterScan > lastScan &&
                this._previousStates.length - lastRasterScan <= 5;

            // CE3D doesn't want to be set WaitingForImport just after AutoResection (RasterScan) but they want to set it if editing AutoResection
            if ( !isAutoresection ) {
                nextState = this.SCANSTATE.WAITING_FOR_IMPORT;
            }
        }
        return nextState;
    },

    saveStatusRunTask: function ( project, taskName, previousState, launchNotify ) {
        var defer = P.defer();
        var self = this;
        // save status

        const manageSymbologyAndRefresh = () => {
            return new Promise( ( resolve, reject ) => {
                let symbologiesToSet = self.findState( self._state ).overwriteSymbology;
                let symbologiesToRemove = self.findState( previousState ).overwriteSymbology;
                let differentSymbology = !symbologiesToSet || !symbologiesToRemove || symbologiesToRemove.toString() !== symbologiesToSet.toString();
                let overwriteSymbologyControler = Registry.getInstance().getController( 'OverwriteSymbology' );

                // If the previous state had overwritten the symbology, restore it to the original
                let restorePromise = Promise.resolve();

                if ( symbologiesToRemove ) {
                    if ( taskName !== self.SCANTASK.C2C_MANUAL && differentSymbology )
                        restorePromise = overwriteSymbologyControler.restoreSymbology( true );
                }
                restorePromise
                    .then( () => {
                        let runOverwritePromise = Promise.resolve();

                        // if we have to change symbology and our task is not C2C
                        if ( differentSymbology && taskName !== self.SCANTASK.C2C_MANUAL ) {
                            // Do this after the writeToProject promise has been resolved (because both update the extensible data of the project)
                            if ( project && symbologiesToSet ) {
                                // This exception is needed because this task goes to a shared state but overwrites the simbology differently
                                // Send as argument all the simbologies ids to be applied (they are applied in the same order)
                                if ( self._state !== self.SCANSTATE.REGISTRATION_MANUAL || taskName !== Workflow.TASK.FINISH )
                                    runOverwritePromise = overwriteSymbologyControler.runOverwrittenSymbology( symbologiesToSet );
                            }
                        }

                        if ( self._hasToRefresh && self._refreshCallback ) self._refreshCallback( self._hasToRefresh );

                        runOverwritePromise
                            .then( () => {
                                if ( launchNotify !== undefined ) this.notifyStateChange( launchNotify );
                                resolve();
                            } )
                            .catch( () => {
                                reject();
                            } );
                    } )
                    .catch( () => {
                        reject();
                    } );
            } );
        };

        if ( this._projectPatchPromises.length )
            Promise.allSettled( this._projectPatchPromises )
            .then( () => {
                this._projectPatchPromises = [];
                let promise = this.writeToProject( project );
                this._projectPatchPromises.push( promise );
                promise
                    .then( function () {
                        manageSymbologyAndRefresh()
                            .then( () => {
                                defer.resolve();
                            } )
                            .catch( () => {
                                console.warn( 'catch from manageSymbologyAndRefresh (more than one project PATCH)' );
                                defer.reject();
                            } );
                    } )
                    .catch( function () {
                        defer.reject();
                    } ); // .finally( () => { this._projectPatchPromises.pop(); } )
            } )
            .catch( function () {
                console.warn( 'allSettled in saveStatusRunTask method has failed' );
                defer.reject();
            } );
        else {
            let promise = this.writeToProject( project );
            this._projectPatchPromises.push( promise );
            promise
                .then( function () {
                    manageSymbologyAndRefresh().then( () => {
                        defer.resolve();
                    } );
                } )
                .catch( function () {
                    defer.reject();
                } ); // .finally( () => { this._projectPatchPromises.pop(); } )
        }
        return defer.promise;
    },

    /////  versions: implementation functions, must be called from Workflow base class  /////

    saveVersionContent: function ( destinationVersion ) {
        // First, we clean the version data from AngularJS attributes
        Object.keys( destinationVersion ).forEach( function ( attr ) {
            if ( attr.startsWith( '$' ) ) {
                console.log( attr );
                delete destinationVersion[ attr ];
            }
        } );
    },

    restoreVersionContent: function ( sourceVersion ) {
        // restore state
        if ( sourceVersion.state !== undefined ) {
            this.setStateAndTasks( sourceVersion.state, true ); // do not add state to previous list
        }
    },

    setScanProjectFiles: function ( scanProjectFiles ) {
        this._scanProjectFiles = scanProjectFiles;
    },

    getScanProjectFile: function () {
        return this._scanProjectFiles;
    },

    uploadWorkspace: function ( project ) {
        return Registry.getInstance().getController( 'Workspace' ).uploadWorkspace( project, this._version );
    },

    uploadWorkspaceProcess: function ( project, workspaceProcessData ) {
        workspaceProcessData.process.inputData = JSON.parse( workspaceProcessData.process.inputData );
        workspaceProcessData.process.outputData = JSON.parse( workspaceProcessData.process.outputData );
        let filePathPrefix = `${Workflow.PROCESS_DATA_PATH_PREFIX}${this._version}/`;
        let filePath = Workflow.WORKSPACE_PROCESS_FILE_PATH;

        let wrksProcessDataStr = JSON.stringify( workspaceProcessData );
        return project
            .getProjectDataset()
            .getDriver()
            .uploadObjectFile( project, wrksProcessDataStr, filePath, filePathPrefix, 'application/json', BaseDriver.NO_CACHE, 'attachment' );
    },

    uploadEdgesFile: function ( project, edges ) {
        let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/';
        return project
            .getProjectDataset()
            .getDriver()
            .uploadObjectFile(
                project,
                JSON.stringify( edges ),
                Workflow.EDGES_FILE_PATH,
                workspaceFilePath,
                'application/json',
                BaseDriver.NO_CACHE,
                'attachment'
            );
    },

    uploadVerityAnalyzeFile: function ( /*project*/ layer, verityAnalyze ) {
        let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/';

        return /*project.getProjectDataset()*/ layer
            .getDataset()
            .getDriver()
            .uploadObjectFile(
                layer /*project*/ ,
                JSON.stringify( verityAnalyze ),
                Workflow.VERITY_ANALYZE_FILE_PATH,
                workspaceFilePath,
                'application/json',
                BaseDriver.NO_CACHE,
                'attachment'
            );
    },

    uploadIfcImportFile: function ( layerObject, ifcImport ) {
        let workspaceFilePath = Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/';

        let layerDriver = DriverRegistry.getInstance().getDriver( 'da.layer' );
        return layerDriver.uploadLayerFile(
            layerObject,
            JSON.stringify( ifcImport ),
            Workflow.IFC_IMPORT_FILE_PATH,
            workspaceFilePath,
            'application/json',
            BaseDriver.NO_CACHE,
            'attachment'
        );
    },

    backToPreviousState: function ( avoidNotify ) {
        Workflow.prototype.backToPreviousState.call( this );
        if ( !avoidNotify )
            // REVIEW workflow to avoid this workaround
            this.notifyStateChange( '' );
    },

    setStateAndTasks: function ( state, preventPush, previousStates ) {
        if ( state === this.SCANSTATE.EMPTY && this.hasStations() ) {
            state = this.SCANSTATE.NOT_EMPTY;
        }
        Workflow.prototype.setStateAndTasks.call( this, state, preventPush, previousStates );
    },


    getJobDataIndex: function ( jobData ) {
        let index = this._jobs.indexOf( jobData );
        if ( index === -1 ) {
            index = this._jobs.findIndex( ( jobAux ) => JSON.stringify( jobAux ) === JSON.stringify( jobData ) );
            if ( index === -1 ) {
                this.setError( 'TAB_WORFLOW.JOB_DOESNT_EXIST' );
                return;
            }
        }
        return index;
    },

    finishTaskIfNoWaitingJobs: function ( jobs, jobFinish, project, jobData ) {
        const waitingJobs = jobs.filter(
            ( job ) =>
            !this.BACKGROUND_TASKS.includes( job.name ) ||
            ( this.isForceForegroundJob( jobFinish.name ) && job.processId === this.getForceForegroundId() )
        );

        if ( waitingJobs.length === 0 ) {
            // all waiting jobs finished
            this.runFinishTask( project, jobData );
        }
    },

    // Overwriting finishJob from Workflow.js
    finishJob: function ( project, jobData ) {
        const index = this.getJobDataIndex( jobData );
        if ( index === undefined ) {
            return;
        }

        const jobFinish = this._jobs[ index ];
        this._jobs.splice( index, 1 ); // remove job from list

        if ( this.BACKGROUND_TASKS.includes( jobFinish.name ) && !this.isForceForegroundJob( jobFinish.name ) ) {
            // Avoiding to call finish task
            if ( !jobData.launchC2C ) this.notifyBackgroundJobFinish();
            this.saveStatusRunTask( project, '', this._state ); // save status
            return;
        }

        this.finishTaskIfNoWaitingJobs( this._jobs, jobFinish, project, jobData );
    },

    switchToProcessJob: function ( project, jobData ) {
        const index = this.getJobDataIndex( jobData );
        if ( index === undefined ) {
            return;
        }

        const jobFinish = this._jobs[ index ];

        const jobsNotFinished = this._jobs.filter( ( job ) => job !== jobFinish );

        jobData.waitingProcess = !this.BACKGROUND_TASKS.includes( this.SCANTASK.PROCESS_SCAN ) || this.isForceForegroundJob( this.SCANTASK.PROCESS_SCAN );

        this.finishTaskIfNoWaitingJobs( jobsNotFinished, jobFinish, project, jobData );

        jobFinish.name = this.SCANTASK.PROCESS_SCAN;
    },

    getRegistrationObject() {
        // for now the _registrationObject is in this class.
        // Maybe it should be on the workflow objecto , it depends if we need persistence
        return this._registrationObject;
    },

    getTmpWorkspace() {
        return this._tmpWorkspace;
    },

    getHasRasterLayer() {
        return this._hasRasterLayer;
    },

    isEmpty() {
        return !this._previousStates.includes( this.SCANSTATE.NOT_EMPTY );
    },

    isScannerConnected() {
        return this._isScannerConnected;
    },

    getStationsWithPointcloudsLength() {
        let stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let stations = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );

        let stationsWithScans = 0;
        stations.forEach( ( station ) => {
            if ( station.getLayerGroupObj() && station.getLayerGroupObj().hasPointcloud() ) stationsWithScans++;
        } );

        return stationsWithScans;
    },

    getStationsLength() {
        const stationCat = WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name;
        let stations = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().findElementsByCategory( stationCat );
        return stations.length;
    },

    getSelectedStation() {
        let selectionObject = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
        if ( !selectionObject || !selectionObject.getLayer() ) {
            return;
        }
        let layer = selectionObject.getLayer();
        if ( layer.getCategory && layer.getCategory() === WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name ) {
            return layer;
        }
    },

    /**
     * Sets the selected station.
     *
     * @param {PcvizWorkspaceLayerGroup} stationLayer
     * @param {PcvizSelectionObject} [selectionObject]
     * @returns {void}
     */
    setSelectedStation( stationLayer, selectionObject ) {
        if (
            stationLayer.getCategory &&
            stationLayer.getCategory() !== WorkspaceCategories.getCategoryProps( WorkspaceCategories.Station ).name
        ) {
            throw 'Invalid station layer';
        }

        const selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );
        if ( !selectionObject ) {
            selectionObject = selectionObjectController.createSelectionObject( stationLayer.getType() );
        }
        selectionObject.setLayer( stationLayer );
        selectionObjectController.setSelectionObject( selectionObject );
    },

    /**
     * Checks if the station passed as argument has scan data (REMOVE this function if not used anymore)
     * @method
     * @memberof pcvizWorkflow.ScanWorkflow
     * @param  {WorkspaceLayerGroup} station the station whose children are going to be checked
     * @return {bool} `true` if has scan, otherwise `false`.
     */
    /*hasScan( station ) {
        let scansFolder = station.getChildren().find( ( child ) => {
            return child.getCategory() === WorkspaceCategories.Categories[ WorkspaceCategories.ScansFolder ].name;
        } );
        if ( !scansFolder )
            return false;
        let scan = scansFolder.getChildren().find( ( child ) => {
            return child.getCategory() === WorkspaceCategories.Categories[ WorkspaceCategories.Scan ].name;
        } );
        return scan !== undefined;
    },*/

    getSelectedStationWorkspaceObj() {
        const layer = this.getSelectedStation();
        if ( layer ) {
            return this.getStationWorkspaceObjByLayer( layer );
        }
    },

    getStationWorkspaceObjByLayer( layer ) {
        const stations = this.getStationsFromWsVisitor();
        const sta = stations.find( ( station ) => station.uuid === layer.getId() );
        this.updateRegistrationMethodProperty( sta );
        return sta;
    },

    isAnyScanSegmented() {
        let scans = this.getScansFromWsVisitor();
        if ( scans.length === 0 ) {
            return false;
        }

        return scans.some( ( scan ) => SEGMENTATION_LABELS.some( ( label ) => label.name === scan.name ) );
    },

    hasReports() {
        return this._registrationObject.linkArray && this._registrationObject.linkArray.some( ( link ) => link.report );
    },

    getCurrentStation() {
        return Registry.getInstance().getController( 'ScanSelection' ).getCurrentStation();
    },

    isEnabledLayout() {
        const selectionObjectController = Registry.getInstance().getController( 'SelectionObject' );
        let selectionObject = selectionObjectController.getSelectionObject();
        return (
            selectionObject &&
            selectionObject.getFeature &&
            selectionObject.getFeature() &&
            selectionObject.getLayer() &&
            VectorLayerUtils.isControlPoint( selectionObject.getLayer().getCategory() )
        );
    },

    isScannerType( scannerType ) {
        return Registry.getInstance().getController( 'ScanSelection' ).getScannerType() === scannerType;
    },

    isGTLConnected() {
        return this._isScannerConnected && this.isScannerType( ScanSelectionController.SCANNER_TYPES.GTL );
    },

    isCRP1Connected() {
        return this.isScannerConnected() && this.isCRP1ScannerType();
    },

    isGTScannerType() {
        return this.isScannerType( ScanSelectionController.SCANNER_TYPES.GT );
    },

    isRasterScannerType() {
        return this.isScannerType( ScanSelectionController.SCANNER_TYPES.RASTER );
    },

    isCRP1ScannerType() {
        return this.isScannerType( ScanSelectionController.SCANNER_TYPES.CRP1 );
    },

    getCurrentStationLayer() {
        return Registry.getInstance().getController( 'ScanSelection' ).getCurrentStationLayer();
    },

    getCurrentStationWorkspaceObj() {
        let stations = this.getStationsFromWsVisitor();

        let sta = stations.find( ( station ) => {
            return station.uuid === this.getCurrentStation();
        } );

        // Maybe there is current station but it can not be found in the workspace because that station is in other project
        this.updateRegistrationMethodProperty( sta );

        return sta;
    },
    hasSparse() {
        const wsVisitor = new WorkspaceVisitor();
        const workspace = Registry.getInstance().getController( 'Workspace' ).getWorkspace();
        wsVisitor.apply( workspace.workspace );

        const sparseExist = wsVisitor.getPointclouds().some( ( pointcloud ) => {
            return pointcloud.resolution === 'sparse';
        } );
        return sparseExist;
    },

    hasWorkspaceData() {
        return this.getWorkspaceVisitor().getAllElements().length > 0;
    },

    // returns if the selected or current station is not localized (by occbs or resection)
    // it is necessary to check this.getCurrentStationWorkspaceObj() because maybe there is a current station but it is not in the project
    isNotLocalizedStation() {
        return (
            this.isGivenStationNotLocalized( this.getSelectedStationWorkspaceObj() ) ||
            ( this.isScannerConnected() && this.getCurrentStation() && this.isGivenStationNotLocalized( this.getCurrentStationWorkspaceObj() ) )
        );
    },

    isGivenStationNotLocalized( station ) {
        return ( station && !station.surveyRegistrationInfo ) || !this.isLocalized( station );
    },

    // returns true if the Station has been created by a Scanner (while being connected or imported after)
    // returns false if the station is fake (creted by merge process) or it was generated from a scan file (created by Import scans as stations)
    isNotFakeStation( stationWorkspaceObj ) {
        if ( !stationWorkspaceObj ) {
            return false;
        }

        if ( this.isScannerConnected() ) return true;

        return !this.isGivenStationFake( stationWorkspaceObj );
    },

    // returns true if the selected Station has been created by a Scanner (while being connected or imported after)
    // returns false if the selected station is fake (creted by merge process) or it was generated from a scan file (created by Import scans as stations)
    isSelectedStationNotFake() {
        if ( this.isScannerConnected() && this.getCurrentStation() && this.getCurrentStationWorkspaceObj() ) return true;
        return this.getSelectedStationWorkspaceObj() && !this.isGivenStationFake( this.getSelectedStationWorkspaceObj() );
    },

    isGivenStationFake( station ) {
        if ( this.isSelectedStationFromCRP1() && station.generatedFromScanFile ) {
            return station.fake;
        }
        return station.generatedFromScanFile || station.fake;
    },

    // returns if the selected or current station is localized (by occbs or resection)
    // it is necessary to check this.getCurrentStationWorkspaceObj() because maybe there is a current station but it is not in the project
    isLocalizedStation() {
        return (
            ( this.getSelectedStationWorkspaceObj() && this.isLocalized( this.getSelectedStationWorkspaceObj() ) ) ||
            ( this.isScannerConnected() && this.isCurrentStationLocalized() )
        );
    },

    // returns if the station sent as argument is localized (by occbs or resection)
    isLocalized( station ) {
        return station && station.surveyRegistrationInfo && this.localizationMethods.includes( station.surveyRegistrationInfo.method );
    },

    isCurrentStationLocalized() {
        return this.getCurrentStation() && this.getCurrentStationWorkspaceObj() && this.isLocalized( this.getCurrentStationWorkspaceObj() );
    },

    // returns true if the current station belongs to a localized bundle
    belongsCurrentToLocalizedBundle() {
        let currentStationUuid = this.getCurrentStation();
        if ( !currentStationUuid || !this.getCurrentStationWorkspaceObj() ) return false;

        // finds the bundle to which the current station belongs to, if there is
        let bundle = this._registrationObject.processedBundles.find( ( b ) => {
            return b.some( ( station ) => station.uuid === currentStationUuid );
        } );

        if ( !bundle ) return false;

        return bundle.some( ( station ) => this.isLocalized( station ) );
    },

    // this method can be used to get the job for registrations, merge, generate tins...
    // the first two arguments are only for registration jobs (method should be the string expected by the job)
    getConfiguredJobAndUploadWorkspaceFiles(
        method,
        registrationStationsData,
        selectedStations,
        taskName,
        files,
        extraInputData,
        extraOutputData,
        project,
        suffixJobName
    ) {
        return new Promise( ( resolve, reject ) => {
            const workspaceController = Registry.getInstance().getController( 'Workspace' );
            let jobAdapter = JobAdapterRegistry.getImporter( ScanProjectJobAdapter.ID );
            jobAdapter.setProjectVersion( this.getCurrentVersion() );
            jobAdapter.setJobType( taskName );
            jobAdapter.enableWorkspaceProject( true );
            jobAdapter.setScans( undefined ); // clear var
            jobAdapter.setOptions( [] ); // clear var to avoid send processing scan options
            JobAdapterService.setJobAdapter( jobAdapter );

            let config = {
                files: files !== undefined ? files : [],
                jobName: project.getName() + ' - ' + suffixJobName, // + TranslationService.translate( 'SCANPROC.TASK_' + taskName ).toLowerCase(),
                catalogId: project.getProjectDataset().getDriver().getEntryPoint( 'projects', project.getId() ),
            };
            // this is for registration jobs (it doesn't cause issues to other jobs at this moment)
            let extraInputDataToSet = {
                method: method,
                stations: registrationStationsData,
            };
            // extra data for c2c, merge scan, TIN
            if ( extraInputData ) {
                for ( const property in extraInputData ) {
                    extraInputDataToSet[ property ] = extraInputData[ property ];
                }
            }
            jobAdapter.setExtraInputData( extraInputDataToSet );

            let downloadWorkspaceOptions;
            const extraOutputDataToSet = Object.assign( {}, extraOutputData );
            if ( method === 'full' || method === 'quick_automatic' || method === 'quick_manual' ) {
                Object.assign( extraOutputDataToSet, {
                    result: {
                        'metrics.json': Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/' + 'metrics.json',
                        'edges.json': Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/' + 'edges.json',
                        'nodes.json': Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/' + 'nodes.json',
                    },
                } );
                downloadWorkspaceOptions = {
                    CL3: false,
                    CLR: false,
                };
            }

            if ( method === 'occbs' || method === 'resection' || method === 'autoresection' ) {
                Object.assign( extraOutputDataToSet, {
                    result: {
                        'registrationResult.json': Workflow.PROCESS_DATA_PATH_PREFIX + this._version + '/' + 'registrationResult.json',
                    },
                } );
            }

            if ( taskName === this.SCANTASK.VOLUME_PROCESS ) {
                downloadWorkspaceOptions = {
                    '3DModels': true,
                };
            }

            // Set output data although it is empty, so we clear the variable in case a merge scan is launched after a c2c process
            jobAdapter.setExtraOutputData( extraOutputDataToSet );

            let job = jobAdapter.getCompleteJob( config );
            this.uploadWorkspace( project ).then(
                () => {
                    this.uploadWorkspaceProcess( project, job.getPipeline() ).then(
                        () => {
                            // TODO: Check options to pass to createDownloadWorkspaceJson function
                            // These probably need to be received as arguments
                            // Check also layersObjects and unselecetedObjects arguments if needed

                            // let downloadWorkspaceOptions = {  // optional arguments if not configured use the default option
                            //     "tiledImages": true|false, // downloads the pretiled images. default: false
                            //     "primitiveLayers": true|false,  // downloads the primitive layers. default: true
                            //     "TTTL": true|false  // downloads the tttl processed files. default: true
                            // }

                            const workspaceDownloadProjectJson = workspaceController.createDownloadWorkspaceJson(
                                workspaceController.getWorkspace(),
                                selectedStations,
                                undefined,
                                undefined,
                                WorkspaceController.SELECT_MODE,
                                downloadWorkspaceOptions
                            );
                            workspaceController.uploadDownloadWorkspaceFile( workspaceDownloadProjectJson ).then(
                                () => {
                                    resolve( job );
                                },
                                () => console.error( 'Error uploading workspaceProject.json' )
                            );
                        },
                        () => console.error( 'Error uploading workspaceProcess.json' )
                    );
                },
                ( e ) => {
                    console.error( 'Error uploading workspace.json' );
                    reject( e );
                }
            );
        } );
    },

    updateRegistrationMethodProperty( station ) {
        if ( !station ) {
            return;
        }

        if ( station.registrationMethod ) {
            if ( station.surveyRegistrationInfo === undefined ) {
                station.surveyRegistrationInfo = {};
            }
            station.surveyRegistrationInfo.method = station.registrationMethod;
            delete station.registrationMethod;
        }
    },

    // Overwrite function because we don't want to set 'Error' state and empty tasks when the finishJob method doesn't find the job
    // That can happen when cancelling manually a process (by the button in the WorkflowProgressBar) while it is finishing.
    setError( errorMsg ) {
        this._stateMessage = errorMsg;
        if ( errorMsg !== 'TAB_WORFLOW.JOB_DOESNT_EXIST' ) Workflow.prototype.setError.call( this, errorMsg );
    },

    getWaitingStateByJobName( jobName ) {
        switch ( jobName ) {
        case this.SCANTASK.PROCESS_SCAN:
            return this.SCANSTATE.PROCESSING_SCAN;
        case this.SCANTASK.IMPORT_PROJECT:
            return this.SCANSTATE.IMPORTING_PROJECT;
        case this.SCANTASK.IMPORT_SCAN:
            return this.SCANSTATE.IMPORTING_SCAN;
        case this.SCANTASK.LAYOUT:
            return this.SCANSTATE.LAYOUT_SELECTING_POINTS;
        case this.SCANTASK.LAYOUT_EACH_POINT:
            return this.SCANSTATE.LAYOUT;
        case this.SCANTASK.IMPORT_STATION:
            return this.SCANSTATE.IMPORTING_STATION;
        case this.SCANTASK.IMPORT_REFS:
            return this.SCANSTATE.IMPORTING_REFS;
        case this.SCANTASK.CREATE_STATION:
            return this.SCANSTATE.CREATING_STATION;
        case this.SCANTASK.REGISTER_C2C_PROCESS:
            return this.SCANSTATE.REGISTERING_SCAN;
        case this.SCANTASK.EXPORT_SCANS:
            return this.SCANSTATE.EXPORTING_SCAN;
        case this.SCANTASK.SYNC_CLOUD:
            return this.SCANSTATE.SYNCHRONIZING;
        case this.SCANTASK.UPGRADE_SPARSE_TO_FULL:
            return this.SCANSTATE.UPGRADING_SPARSE_TO_FULL;
        case this.SCANTASK.MERGE_SCANS_PROCESS:
            return this.SCANSTATE.MERGE_SCANS_PROCESSING;
        case this.SCANTASK.TIN_PROCESS:
            return this.SCANSTATE.TIN_PROCESSING;
        case this.SCANTASK.VOLUME_PROCESS:
            return this.SCANSTATE.VOLUME_PROCESSING;
        case this.SCANTASK.REGISTER_OCCBS_PROCESS:
        case this.SCANTASK.REGISTER_BYREFS_PROCESS:
            return this.SCANSTATE.REGISTERING_SCAN;
        default:
            return jobName;
        }
    },

    hasBackgroundJob() {
        return this._jobs.some( ( job ) => this.BACKGROUND_TASKS.includes( job.name ) );
    },

    getBackgroundJobs() {
        return this._jobs.filter( ( job ) => this.BACKGROUND_TASKS.includes( job.name ) );
    },

    forceForegroundJob( jobName ) {
        this.FORCE_FOREGROUND_TASKS.push( jobName );
    },

    isForceForegroundJob( jobName ) {
        return this.FORCE_FOREGROUND_TASKS.includes( jobName );
    },

    removeForceForegroundJob( jobName ) {
        this.FORCE_FOREGROUND_TASKS = this.FORCE_FOREGROUND_TASKS.filter( ( taskName ) => taskName !== jobName );
    },

    hasVerifyReport() {
        // TODO: check if there is a report (when server endpoint is available)
        return false;
    },

    setLayoutAddingFromList( flag ) {
        this._layoutAddingFromList = flag;
    },

    hasData() {
        let project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        return project.getAllLayers().length > 0;
    },

    isRevertRegistrationActive() {
        const stations = this.getStationsFromWsVisitor();

        if ( !stations.length ) {
            return false;
        }

        return stations.some( ( station ) => this.isLocalized( station ) || this.isAutoregisteredStation( station ) );
    },

    isAutoregisteredStation( station ) {
        return !!station.originalSurveyRegistrationInfo;
    },

    isResectionFromRaster() {
        return this._resectionFromRaster;
    },

    setResectionFromRaster( flag ) {
        this._resectionFromRaster = flag;
    },

    setVerificationRunning( flag ) {
        this._verificationRunning = flag;
    },

    isVerificationRunning() {
        return this._verificationRunning;
    },

    setAvoidWaitingImportAfterRegister( flag ) {
        this._avoidWaitingImportAfterRegister = flag;
    },

    /**
     * Returns true for site & raster device, otherwise false
     */
    isSiteAndRaster() {
        return MagnetAPI.isSite() ? this.isRasterScannerType() : false;
    },
    /**
     * Returns true for web, true for site !==raster, false for raster device
     */
    isSiteNoRasterOrWeb() {
        return MagnetAPI.isSite() ? !this.isRasterScannerType() : true;
    },

    launchStandardVerification( project ) {
        this.runTask( project, this.SCANTASK.VERIFY ).then( () => {
            this.runTask( project, this.SCANTASK.VERIFY_INSTALLATION ).then( () => {
                let event = new CustomEvent( 'launchVerificationProcess', {
                    detail: {},
                    bubbles: true,
                    cancelable: true,
                } );
                document.dispatchEvent( event );
            } );
        } );
    },

    hasVerityModel() {
        let project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        return project
            .getAllLayers()
            .some( ( layer ) => layer.getType() === LayerType.VECTOR && VectorLayerUtils.isVerityModel( layer.getCategory() ) );
    },

    setForceForegroundId( jobId ) {
        this._forceForegroundJobId = jobId;
    },

    getForceForegroundId() {
        return this._forceForegroundJobId;
    },

    notifyBackgroundJobFinish() {
        if ( this._backgroundJobFinishListener ) this._backgroundJobFinishListener();
    },

    setBackgroundJobFinishListener( listenerFn ) {
        this._backgroundJobFinishListener = listenerFn;
    },

    isC2CRegistrationActive() {
        if ( MagnetAPI.isSite() ) {
            return (
                this.getSelectedStation() &&
                this.getSelectedStation().hasPointcloud() &&
                this.getStationsWithPointcloudsLength() >= 2 &&
                !this.hasBackgroundJob()
            );
        }

        return this.getStationsWithPointcloudsLength() >= 2;
    },

    isOccBsRegistrationActive() {
        if ( MagnetAPI.isSite() ) {
            const isStationSelected = !!this.getSelectedStation();
            const hasCurrentStation = !!this.getCurrentStation();
            const hasCrDisableCheck = this.isSelectedStationFromCRP1() || ( this.isCRP1Connected() && !isStationSelected );
            //TODO: Add ESN-100 rules when implemented by [COLW-12102]
            const hasOtherDisableCheck = this.isScannerConnected() && !isStationSelected && !hasCurrentStation;

            if ( hasCrDisableCheck || hasOtherDisableCheck ) {
                this.isOccBsActiveBySelection = false;
            } else {
                this.isOccBsActiveBySelection = true;
            }

            return this.isNotLocalizedStation() && this.isSelectedStationNotFake() && this.isSiteNoRasterOrWeb();
        }

        return this.isFirstRegistrationActiveForCw();
    },

    isResectionRegistrationActive() {
        if ( MagnetAPI.isSite() ) {
            if ( this.isSelectedStationFromCRP1() ) {
                const targetLayer = this.getSelectedStation().getTargetLayer();
                if ( targetLayer ) {
                    targetLayer
                        .getFeatures()
                        .then( ( featureIterator ) => ( this.isResectionActiveBySelection = featureIterator.getSize() >= 2 ) );
                } else {
                    this.isResectionActiveBySelection = false;
                }
            } else {
                this.isResectionActiveBySelection = true;
            }

            return this.isNotLocalizedStation() && this.isSelectedStationNotFake();
        }

        return this.isFirstRegistrationActiveForCw();
    },

    isFirstRegistrationActiveForCw() {
        if ( this.areAllStationsLocalized() ) {
            return false;
        }

        const isStationSelected = !!this.getSelectedStation();
        if ( !isStationSelected ) {
            return true;
        }

        return this.isNotLocalizedStation() && this.isSelectedStationNotFake();
    },

    areAllStationsLocalized() {
        const stations = this.getStationsFromWsVisitor();
        return stations.length ? stations.every( ( station ) => this.isLocalized( station ) ) : true;
    },

    getStationsFromWsVisitor() {
        return this.getWorkspaceVisitor().getStations();
    },

    hasStations() {
        const stations = this.getStationsFromWsVisitor();
        return Array.isArray( stations ) && !!stations.length;
    },


    getScansFromWsVisitor() {
        return this.getWorkspaceVisitor().getScans();
    },

    getWorkspaceVisitor() {
        const workspace = Registry.getInstance().getController( 'Workspace' ).getWorkspace();
        const workspaceVisitor = new WorkspaceVisitor();
        workspaceVisitor.traverse( workspace.workspace );
        return workspaceVisitor;
    },

    isIdentifyTargetsEnabled( enableAllStations = true ) {
        if ( enableAllStations ) {
            return this.isIdentifyTargetsEnabledAllStations();
        } else {
            return this.isIdentifyTargetsEnabledOnlyCRP1();
        }
    },

    isIdentifyTargetsEnabledAllStations() {
        return !!this.getSelectedStation();
    },

    isIdentifyTargetsEnabledOnlyCRP1() {
        if ( !this.isScannerConnected() ) {
            return this.isSelectedStationFromCRP1();
        }

        if ( !this.isCRP1Connected() ) return false;

        if ( this.getCurrentStation() !== undefined && this.getCurrentStationWorkspaceObj() ) {
            return [ WorkspaceStationTypes.LIGHTHOUSE, WorkspaceStationTypes.CR ].includes(
                this.getCurrentStationWorkspaceObj().properties.type
            );
        }

        return this.isSelectedStationFromCRP1();
    },

    isSelectedStationFromCRP1() {
        const selectedStationLayer = this.getSelectedStation();
        if ( !selectedStationLayer ) {
            return false;
        }
        const stationWorkspaceObj = this.getStationWorkspaceObjByLayer( selectedStationLayer );
        return this.isGivenStationLayerFromCRP1( stationWorkspaceObj );
    },

    isGivenStationLayerFromCRP1( stationWorkspaceObj ) {
        if ( stationWorkspaceObj && stationWorkspaceObj.properties && stationWorkspaceObj.properties.type ) {
            return [ WorkspaceStationTypes.LIGHTHOUSE, WorkspaceStationTypes.CR ].includes( stationWorkspaceObj.properties.type );
        }
        return false;
    },

    isJobFromScript( job ) {
        return job.origin === 'LibCollageWebAPI' || job.origin === 'Scanprocessing launcher';
    },

    areAllStationsFromCRP1() {
        const stations = this.getStationsFromWsVisitor();

        return stations.length ?
            stations.every( ( station ) => [ WorkspaceStationTypes.LIGHTHOUSE, WorkspaceStationTypes.CR ].includes( station.properties.type ) ) :
            false;
    },

    isGeoReferencingActive() {
        const registrationObj = this.getRegistrationObject();
        const project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        const selectedStationLayer = this.getSelectedStation();

        if ( !registrationObj || !project || !selectedStationLayer || this.isLocalizedStation() ) {
            return false;
        }

        return this._targetFeaturesInCurrentBundle >= 3 && this._controlPointsFeaturesCount >= 3;
    },

    computeControlPointsCount() {
        const project = Registry.getInstance().getController( 'Application' ).getApplication().getProject();
        const controlPointsLayers = project.getControlPointsLayers();

        this._controlPointsFeaturesCount = 0;

        controlPointsLayers.forEach( ( layer ) => {
            layer
                .getAllFeaturesByPages()
                .then( ( featuresConcatenated ) => {
                    this._controlPointsFeaturesCount += featuresConcatenated.features.length;
                } )
                .catch( ( error ) => {
                    console.error( 'Error counting control points features:', error );
                } );
        } );
    },

    computeTargetsLengthFromBundle( stationLayer ) {
        const registrationObj = this.getRegistrationObject();

        this._targetFeaturesInCurrentBundle = 0;

        if ( !registrationObj || !registrationObj.processedBundles ) {
            return;
        }
        const stationId = stationLayer.getId();
        const currentBundle = registrationObj.processedBundles.find(
            ( bundle ) => Array.isArray( bundle ) && bundle.some( ( station ) => station.uuid === stationId )
        );

        if ( !currentBundle || currentBundle.length < 2 ) {
            return;
        }

        currentBundle.forEach( ( station ) => {
            const stationObj = Registry.getInstance().getController( 'Workspace' ).getWorkspaceDataCache().getDataCacheObject( station.uuid );

            if ( stationObj ) {
                const stationLayerObj = stationObj.getLayerGroupObj();
                if ( stationLayerObj ) {
                    const targetLayer = stationLayerObj.getTargetLayer();
                    if ( targetLayer ) {
                        targetLayer
                            .getAllFeaturesByPages()
                            .then( ( featuresConcatenated ) => {
                                this._targetFeaturesInCurrentBundle += featuresConcatenated.features.length;
                            } )
                            .catch( ( error ) => {
                                console.error( `Error counting targets for station ${station.uuid}:`, error );
                            } );
                    }
                }
            }
        } );
    },
} );

module.exports = ScanWorkflow;


/***/ }),

/***/ "./sources/pcvizWorkflow/Workflow.js":
/*!*******************************************!*\
  !*** ./sources/pcvizWorkflow/Workflow.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var P = __webpack_require__( /*! bluebird */ "./node_modules/bluebird/js/browser/bluebird.js" );

var WorkflowSettings = __webpack_require__( /*! pcvizWorkflow/WorkflowSettings */ "./sources/pcvizWorkflow/WorkflowSettings.js" );
var Registry = __webpack_require__( /*! pcvizDB/Registry */ "./sources/pcvizDB/Registry.js" );

/**
 * Interface for Workflow
 * @class
 * @memberof pcvizWorkflow
 */
var Workflow = function () {
    this._state = 'NotSet';
    this._previousStates = []; // state stack, important when canceling waiting states and closing nested workflows
    this._stateMessage = ''; // for error messages
    this._jobs = []; // wait states will have 1 or more associated jobs
    this._tasks = []; // each task has members { name, recommended (true/false), visible (true/false), enabled (true/false) }
    this._currentVersion = 1;
    this._savedVersionsCount = 1;
    this._savedVersions = [ {
        id: 1,
        name: 'DEFAULT',
        settings: {}
    } ];

    // data to track version change
    this._versionChange = {
        nextState: undefined,
        originalVersion: undefined
    };

    this._stateMachine = undefined; // must be defined by derived workflow classes
    this._taskInfo = new Map(); // must be filled by derived workflow classes
    this._stateChangeListeners = [];
    this._settings = new WorkflowSettings();

    this._hasToRefresh = false; // It points if it is necessary to call to the _refreshCallback
    this._refreshCallback = undefined;
    this._lastJob = undefined;
    this._showSpinner = false;
    this._spinnerChangeListeners = new Map();

    this.INDETERMINATE_STATES = [];
};

Workflow.TASK = {
    CLOSE: 'Close',
    FINISH: '_Finish' // not visible
};

Workflow.TASK_POSITION = {
    DEFAULT: 'default',
    BOTTOM: 'bottom'
};

Workflow.PROCESS_DATA_PATH_PREFIX = 'process_data/v';
Workflow.PROCESS_OUTPUT_DATA_PATH_PREFIX = 'process/cc_output/v';
Workflow.WORKSPACE_FILE_PATH = 'workspace.json';
Workflow.WORKSPACE_PROCESS_FILE_PATH = 'workspaceProcess.json';
Workflow.WORKSPACE_PROJECT_FILE_PATH = 'workspaceProject.json';
Workflow.EDGES_FILE_PATH = 'edges.json';
Workflow.PREFIX_PATH = 'M:/';
Workflow.VERITY_ANALYZE_FILE_PATH = 'verityAnalyze.json';
Workflow.IFC_IMPORT_FILE_PATH = 'ifcImport.json';

Workflow.prototype = {

    // overwrite/extend in derived classes
    writeToJSON: function () {

        // do not save some properties
        var savedStateMachine = this._stateMachine;
        var savedTasks = this._tasks;
        var savedStateChangeListeners = this._stateChangeListeners;
        var savedInfo = this._taskInfo;
        var savedSettings = this._settings;
        let savedShowSpinner = this._showSpinner;
        let savedSpinnerListeners = this._spinnerChangeListeners;
        this._stateMachine = undefined;
        this._tasks = undefined;
        this._stateChangeListeners = undefined;
        this._taskInfo = undefined;
        this._settings = savedSettings.getData();
        this._showSpinner = undefined;
        this._spinnerChangeListeners = undefined;

        var wfJsonStr = JSON.stringify( this );

        this._stateMachine = savedStateMachine;
        this._tasks = savedTasks;
        this._stateChangeListeners = savedStateChangeListeners;
        this._taskInfo = savedInfo;
        this._settings = savedSettings;
        this._showSpinner = savedShowSpinner;
        this._spinnerChangeListeners = savedSpinnerListeners;

        return {
            className: this.getClassName(),
            data: JSON.parse( wfJsonStr )
        };
    },

    readFromJSON: function ( wfJSON ) {

        if ( wfJSON.className !== this.getClassName() )
            return undefined;

        let wfObj = this.getInstance();
        // copy data
        for ( let member in wfJSON.data )
            if ( wfJSON.data[ member ] )
                wfObj[ member ] = wfJSON.data[ member ];

        // store settings as object
        if ( wfObj._settings instanceof WorkflowSettings === false )
            wfObj._settings = new WorkflowSettings( wfObj._settings );

        let wfStateName = wfObj.getState();
        // pass previousstates to let choose a valid state if not valid
        wfObj.setStateAndTasks( wfStateName, undefined, wfJSON.data._previousStates );

        return wfObj;
    },

    // beware that this creates a new instance of the specific Workflow class
    readFromProject: function ( project ) {

        if ( !project )
            return undefined;

        var extData = project.getExtData();
        if ( !extData || !extData.workflows || extData.workflows.length === 0 )
            return this.getInstance();

        var foundWf = this.findWorkflow( extData.workflows );
        if ( foundWf === -1 )
            return this.getInstance();

        var workflow = extData.workflows[ foundWf ];
        // we don't use persisted state machine and icons, in case we want to change them
        if ( workflow.data ) {
            workflow.data._stateMachine = undefined;
            workflow.data._taskInfo = undefined;
        }

        return this.readFromJSON( workflow );
    },

    getWorkflowFromProject: function ( project ) {
        if ( !project )
            return undefined;

        var extData = project.getExtData();
        if ( !extData || !extData.workflows || extData.workflows.length === 0 )
            return undefined;

        var foundWf = this.findWorkflow( extData.workflows );
        if ( foundWf === -1 )
            return undefined;

        var workflow = extData.workflows[ foundWf ];
        if ( workflow.data )
            return workflow.data;

        return undefined;
    },

    /// state ///

    isStateSet: function () {
        return this._state !== 'NotSet';
    },

    isError: function () {
        return this._state === 'Error';
    },

    setError: function ( errorMsg ) {
        this._state = 'Error';
        this._stateMessage = errorMsg;
        this._jobs = [];
        this._tasks = [];
    },

    getState: function () {
        return this._state;
    },

    setState: function ( state, preventPush ) {
        if ( state === this._state )
            return;

        if ( !preventPush && this.getPushableState( this._state ) )
            this._previousStates.push( this._state );
        this._state = state;

        // in case the battery saver is enabled. Requesting frames
        if ( Registry.getInstance().getController( 'View' ).getView( '3D' ) )
            Registry.getInstance().getController( 'View' ).getView( '3D' ).getViewer().requestRedraw();
    },

    getPreviousState: function () {
        return this._previousStates[ this._previousStates.length - 1 ];
    },

    getAllPreviousStates: function () {
        return this._previousStates;
    },

    backToPreviousState: function () {

        // special case for image importing in version change
        if ( this._versionChange.nextState !== undefined && this._versionChange.originalVersion !== undefined ) {
            var origVersion = this.getVersionById( this._versionChange.originalVersion );
            if ( !origVersion )
                console.error( 'Original version does not exist!' );
            if ( origVersion && origVersion.previousStates )
                origVersion.previousStates.pop();
            // clear version change status
            this._versionChange.originalVersion = undefined;

            this.setStateAndTasks( this._versionChange.nextState, true ); // restore state after version change
            return;
        }

        let backState = '';

        // add the default state only when it's a scan project
        if ( this.SCANSTATE && ( !this._previousStates || !this._previousStates.length ) ) {
            backState = this.SCANSTATE.NOT_EMPTY;
        } else {
            backState = this._previousStates.pop();
        }

        this.setStateAndTasks( backState, true );
    },

    clearPreviousState: function () {
        this._previousStates = [];
    },

    getStateMessage: function () {
        return this._stateMessage;
    },

    /// jobs ///

    hasJobs: function () {
        return this._jobs.length > 0;
    },

    getJobs: function () {
        return this._jobs;
    },

    addJob: function ( project, jobData ) {
        this._jobs.push( jobData );
        this._lastJob = jobData;
        return this.writeToProject( project ); // save status
    },

    // To be called when a pending job is completed. The job variable can be an object or a string (job id)
    finishJob: function ( project, job, jobData ) { // TODO: Review if jobData is needed. It seems that it is not being used
        const index = this._jobs.findIndex( ( jobAux ) => jobAux === job || jobAux.name === job );
        if ( index === -1 ) {
            this.setError( 'TAB_WORFLOW.JOB_DOESNT_EXIST' );
            return;
        }
        this._jobs.splice( index, 1 ); // remove job from list

        if ( this._jobs.length === 0 ) // all jobs finished
            this.runFinishTask( project, jobData );
    },

    // predefined task for finishing waiting states
    runFinishTask: function ( project, jobData ) {
        this.runTask( project, Workflow.TASK.FINISH, undefined, jobData ).catch( function () {
            console.log( 'Could not finish task' );
        } );
    },

    deleteJob: function ( job ) {
        let indexJob = this._jobs.indexOf( job );
        if ( indexJob !== undefined ) {
            this._jobs.splice( indexJob, 1 );
        }
    },

    // to be called when the user cancels a process associated to a waiting state
    cancelJobs: function () {

        this.backToPreviousState();
        this.clearJobs();
    },

    clearJobs: function () {
        this._jobs = [];
    },

    /// tasks ///

    getTasks: function () {
        return this._tasks;
    },

    setTasks: function ( taskArray ) {
        this._tasks = taskArray;
    },

    addTask: function ( taskName, taskRecommend, taskVisible, taskEnabled ) {
        this._tasks.push( {
            name: taskName,
            recommended: taskRecommend,
            visible: taskVisible,
            enabled: taskEnabled
        } );
    },

    clearTasks: function () {
        this._tasks = [];
    },

    /// serialization ///

    findWorkflow: function ( workflows, className ) {
        if ( !className ) {
            className = this.getClassName();
        }

        return workflows.findIndex( function ( workflow ) {
            return workflow.className === className;
        } );
    },

    writeToProject: function ( project ) {

        if ( !project )
            return P.resolve();

        var destinationVersion = this.getActiveVersion();
        this._settings.saveVersionSettings( destinationVersion );
        this.saveVersionContent( destinationVersion );

        var wfJSON = this.writeToJSON();

        var extData = project.getExtData();
        if ( !extData )
            extData = {};
        if ( !extData.workflows )
            extData.workflows = [];

        var foundWorkflow = this.findWorkflow( extData.workflows );

        if ( foundWorkflow === -1 )
            extData.workflows.push( wfJSON );
        else
            extData.workflows[ foundWorkflow ] = wfJSON;

        return project.setExtensibleData( extData );
    },

    writeWorkflowToProject: function ( workflow, project, className ) {

        if ( !project )
            return;

        var extData = project.getExtData();
        if ( !extData )
            extData = {};

        var foundWfIndex = this.findWorkflow( extData.workflows, className );

        if ( foundWfIndex === -1 )
            extData.workflows.push( {
                className: className,
                data: workflow
            } );
        else
            extData.workflows[ foundWfIndex ].data = workflow;

        return project.setExtensibleData( extData );
    },

    ////////  STATE MACHINE  ///////////
    findState: function ( state ) {
        let stateFound;
        this._stateMachine.find( stateElement => {
            if ( stateElement && stateElement.name === state ) {
                stateFound = stateElement;
                return true;
            }
            return false;
        } );

        return stateFound;
    },

    // We want to get a valid state choosing the lastone in  previousStates until valid
    findValidState: function ( previousStates ) {
        let foundState;
        let index = previousStates.length;
        while ( !foundState && index > -1 ) {
            foundState = this.findState( previousStates[ --index ] );
            if ( foundState )
                break;
        }
        return foundState;
    },

    getCurrentStateData: function () {
        var foundState = this.findState( this._state );
        if ( !foundState )
            return {};

        return foundState;
    },

    getPushableState: function ( state ) {

        if ( this._stateMachine === undefined ) // test base class
            return true;

        let foundStateObj = this.findState( state );
        return foundStateObj ? foundStateObj.push : false;

    },

    addStateChangeListener: function ( changeListener ) {
        if ( this._stateChangeListeners.indexOf( changeListener ) >= 0 )
            return;
        const length = this._stateChangeListeners.push( changeListener );

        return length - 1;
    },

    removeStateChangeListener: function ( id ) {
        if ( !this._stateChangeListeners[ id ] ) {
            return;
        }

        this._stateChangeListeners[ id ] = () => {};
    },

    notifyStateChange: function ( taskName ) {
        this._stateChangeListeners.forEach( function ( changeListener ) {
            changeListener( taskName );
        } );
    },

    getTaskInfo: function ( taskName ) {
        return this._taskInfo.get( taskName );
    },

    getCommands: function ( key ) {

        var commands = [];

        var self = this;
        this._tasks.forEach( function ( task ) {

            var taskInfo = self._taskInfo.get( task.name );
            if ( taskInfo[ key ] ) {
                var newCommand = {
                    name: task.name,
                    label: 'SCANPROC.TASK_' + task.name,
                    // support for nested tasks
                    previousState: taskInfo.previousState, // needs to be in this state to run
                    previousTasks: taskInfo.previousTasks, // need to be run before, if state is not previousState
                    openTab: taskInfo.openTab, // for tasks that need to switch to 'workflow' tab or another tab
                    visible: task.visible,
                    enabled: task.enabled,
                    checkVisibleAndEnabled: taskInfo.checkVisibleAndEnabled
                };
                commands.push( newCommand );
            }
        } );
        return commands;
    },

    // available tasks for each state

    setStateAndTasks: function ( state, preventPush, previousStates ) {

        let validStateObj = this.findState( state );

        if ( !validStateObj ) {
            if ( previousStates ) {
                validStateObj = this.findValidState( previousStates );
                console.warn( `Workflow: state '${state}' not defined in state machine, forced to: '${validStateObj.name}'` );
            } else {
                console.warn( `Workflow: state '${state}' not defined in state machine` );
                return;
            }
        }

        this.setState( validStateObj.name, preventPush );
        this.setTasks( validStateObj.tasks );
    },

    // versions (index is 1-based, not 0-based)

    getCurrentVersion: function () {
        return this._currentVersion; // index
    },

    setCurrentVersion: function ( index ) {
        this._currentVersion = index;
    },

    getSavedVersionsCount: function () {
        return this._savedVersionsCount;
    },

    getSavedVersions: function () {
        return this._savedVersions;
    },

    getActiveVersion: function () {
        return this.getVersionById( this._currentVersion );
    },

    getVersionById: function ( id ) {
        return this._savedVersions.find( function ( versionData ) {
            return versionData.id === id;
        } );
    },

    saveVersion: function ( project, name, index ) {

        // save state of current version
        var currentVersion = this.getActiveVersion();
        currentVersion.state = this._state;

        var destinationVersion;
        if ( index && index <= this._savedVersionsCount ) { // already exists
            // find destination version
            destinationVersion = this._savedVersions.find( function ( versionData ) {
                return versionData.id === index;
            } );
            if ( name )
                destinationVersion.name = name;
            this._currentVersion = index;
        } else { // new version
            this._savedVersionsCount++;
            destinationVersion = {
                id: this._savedVersionsCount,
                name: name,
            };
            this._savedVersions.push( destinationVersion );
            this._currentVersion = destinationVersion.id;
        }
        this._settings.saveVersionSettings( destinationVersion );
        this.saveVersionContent( destinationVersion );

        // copy state
        destinationVersion.state = this._state;

        if ( project )
            return this.writeToProject( project );

        return destinationVersion; // for tests
    },

    deleteVersion: function ( project, versionId ) {
        var index = this._savedVersions.findIndex( function ( versionData ) {
            return versionData.id === versionId;
        } );
        if ( index === -1 )
            return P.reject();
        this._savedVersions.splice( index, 1 );
        return this.writeToProject( project );
    },

    restoreVersion: function ( project, versionId ) {

        // first, preserve current version changes
        var currentVersion = this.getActiveVersion();
        currentVersion.state = this._state;
        this._settings.saveVersionSettings( currentVersion );
        this.saveVersionContent( currentVersion );

        // now, restore saved version
        var savedVersion = this._savedVersions.find( function ( versionData ) {
            return versionData.id === versionId;
        } );
        if ( !savedVersion ) {
            console.log( 'Version index does not exist' );
            return;
        }

        this._settings.restoreVersionSettings( savedVersion );
        this.restoreVersionContent( savedVersion );

        this._currentVersion = versionId;
        if ( project )
            this.writeToProject( project );
    },

    setHasToRefresh: function ( taskName ) {
        this._hasToRefresh = taskName;
    },

    setRefreshCallback: function ( fn ) {
        this._refreshCallback = fn;
    },

    /// TO BE IMPLEMENTED BY DERIVED CLASSES

    getClassName: function () {
        console.log( 'Workflow: getClassName not implemented' );
        this.setError( 'Method not implemented' );
        return '';
    },

    getHelpPrefix: function () {
        console.log( 'Workflow: getHelpPrefix not implemented' );
        this.setError( 'Method not implemented' );
        return '';
    },

    getInstance: function () {
        console.log( 'Workflow: getInstance not implemented' );
        this.setError( 'Method not implemented' );
        return undefined;
    },

    runTask: function ( /* taskName, project */) { // needs to be implemented by specific workflows
        console.log( 'Workflow: runTask not implemented' );
        this.setError( 'Method not implemented' );

        var defer = P.defer();
        defer.resolve();
        return defer.promise;
    },

    // versions
    saveVersionContent: function ( /* destinationVersion */) {
        console.log( 'Workflow: saveVersionContent not implemented' );
        this.setError( 'Method not implemented' );
    },

    restoreVersionContent: function ( /* sourceVersion */) {
        console.log( 'Workflow: restoreVersion not implemented' );
        this.setError( 'Method not implemented' );
    },

    // settings

    getSettings: function () {
        return this._settings;
    },

    getLastJobData: function () {
        return this._lastJob;
    },

    setShowSpinner: function ( show ) {
        this._showSpinner = show;
        this.notifyShowSpinnerChange();
    },
    getShowSpinner: function () {
        return this._showSpinner;
    },

    addSpinnerChangeListener: function ( fn, id ) {
        this._spinnerChangeListeners.set( id, fn );
    },

    removeSpinnerChangeListener: function ( id ) {
        this._spinnerChangeListeners.delete( id );
    },

    notifyShowSpinnerChange: function () {
        for ( const listener of this._spinnerChangeListeners.values() ) {
            listener();
        }
    },

    isIndeterminateState: function () {
        return this.INDETERMINATE_STATES.includes( this._state );
    }

};

module.exports = Workflow;


/***/ }),

/***/ "./sources/pcvizWorkflow/WorkflowServiceRegistry.js":
/*!**********************************************************!*\
  !*** ./sources/pcvizWorkflow/WorkflowServiceRegistry.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 *  Workflow Service Registry Class
 *  @class
 *  @memberof pcvizWorkflow
 */
var WorkflowServiceRegistry = {

    /**
     * Returns an single instance of this class
     * @method
     * @memberof pcvizWorkflow.WorkflowServiceRegistry
     * @return {Object} The `Registry` instance.
     */
    getInstance: function () {
        if ( !WorkflowServiceRegistry.instance ) {
            WorkflowServiceRegistry.instance = this;
            WorkflowServiceRegistry.instance.services = new Map();
        }
        return WorkflowServiceRegistry.instance;
    },

    /**
     * Registers a service.
     * @method
     * @memberof pcvizWorkflow.WorkflowServiceRegistry
     * @param  {string} name           The name of the service.
     * @param  {WorkflowService} serviceInstance The service instance.
     */
    registerService: function ( name, serviceInstance ) {
        if ( this.getInstance().services.get( name ) !== undefined )
            console.log( 'The workflow service is already registered.' );
        WorkflowServiceRegistry.instance.services.set( name, serviceInstance );
    },

    /**
     * Gets a service.
     * @method
     * @memberof pcvizWorkflow.WorkflowServiceRegistry
     * @param  {string} name The name of the exporter.
     * @return {WorkflowService} serviceInstance The service instance.
     */
    getService: function ( name ) {
        return this.getInstance().services.get( name );
    },

    /**
     * Clears the list of registered services.
     * @method [name]
     * @memberof pcvizWorkflow.WorkflowServiceRegistry
     */
    unregisterAllServices: function () {
        this.getInstance().services.clear();
    },

    resetServices: function () {
        this.getInstance().services.forEach( service => {
            service.reset();
        } );
    }
};


module.exports = WorkflowServiceRegistry;


/***/ }),

/***/ "./sources/pcvizWorkflow/WorkflowSettings.js":
/*!***************************************************!*\
  !*** ./sources/pcvizWorkflow/WorkflowSettings.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Interface for Workflow Settings
 * @class
 * @memberof pcvizWorkflow
 */
var WorkflowSettings = function ( data ) {

    this._settings = data ? data : {}; // value = data.groupName.settingName
    this._settingsDirty = false;

};

WorkflowSettings.prototype = {

    getData: function () {
        return this._settings;
    },

    setDirty: function ( dirty ) {
        this._settingsDirty = dirty;
    },

    getDirty: function () {
        return this._settingsDirty;
    },

    clearSettings: function ( group, setting ) {

        this._settingsDirty = true;
        if ( !group ) {
            this._settings = {};
            return;
        }

        if ( !setting ) {
            delete this._settings[ group ];
            return;
        }

        delete this._settings[ group ][ setting ];
    },

    addOrChangeSetting: function ( group, settingName, value ) {

        if ( !this._settings[ group ] )
            this._settings[ group ] = {};
        var settingsGroup = this._settings[ group ];
        settingsGroup[ settingName ] = value;

        this._settingsDirty = true;
    },

    saveVersionSettings: function ( destinationVersion ) {

        var self = this;
        destinationVersion.settings = {};
        Object.keys( this._settings ).forEach( function ( group ) {
            if ( group && !group.startsWith( '$' ) ) {
                destinationVersion.settings[ group ] = {};
                Object.keys( self._settings[ group ] ).forEach( function ( childSetting ) {
                    if ( childSetting && !childSetting.startsWith( '$' ) ) {
                        var dest = destinationVersion.settings[ group ];
                        var src = self._settings[ group ];
                        dest[ childSetting ] = src[ childSetting ];
                    }
                } );
            }
        } );
    },

    restoreVersionSettings: function ( sourceVersion ) {

        this._settings = {};
        this._settingsDirty = true;
        if ( !sourceVersion.settings )
            return;

        var self = this;

        Object.keys( sourceVersion.settings ).forEach( function ( group ) {
            if ( group && !group.startsWith( '$' ) ) {
                self._settings[ group ] = {};
                Object.keys( sourceVersion.settings[ group ] ).forEach( function ( childSetting ) {
                    if ( childSetting && !childSetting.startsWith( '$' ) ) {
                        var dest = self._settings[ group ];
                        var src = sourceVersion.settings[ group ];
                        dest[ childSetting ] = src[ childSetting ];
                    }
                } );
            }
        } );
    },
};

module.exports = WorkflowSettings;


/***/ }),

/***/ "./sources/pcvizWorkflow/pcvizWorkflow.js":
/*!************************************************!*\
  !*** ./sources/pcvizWorkflow/pcvizWorkflow.js ***!
  \************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _C2C__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./C2C */ "./sources/pcvizWorkflow/C2C.js");
/* harmony import */ var _ReportC2C__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ReportC2C */ "./sources/pcvizWorkflow/ReportC2C.js");
/* harmony import */ var _ProcessScans__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./ProcessScans */ "./sources/pcvizWorkflow/ProcessScans.js");
/* harmony import */ var _ScanConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ScanConstants */ "./sources/pcvizWorkflow/ScanConstants.js");
/* harmony import */ var _GenericWorkflow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./GenericWorkflow */ "./sources/pcvizWorkflow/GenericWorkflow.js");
/* harmony import */ var _GenericWorkflow__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_GenericWorkflow__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _GenericConstants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./GenericConstants */ "./sources/pcvizWorkflow/GenericConstants.js");

var Workflow = __webpack_require__( /*! pcvizWorkflow/Workflow */ "./sources/pcvizWorkflow/Workflow.js" );
var WorkflowSettings = __webpack_require__( /*! pcvizWorkflow/WorkflowSettings */ "./sources/pcvizWorkflow/WorkflowSettings.js" );
var ScanWorkflow = __webpack_require__( /*! pcvizWorkflow/ScanWorkflow */ "./sources/pcvizWorkflow/ScanWorkflow.js" );
var WorkflowServiceRegistry = __webpack_require__( /*! pcvizWorkflow/WorkflowServiceRegistry */ "./sources/pcvizWorkflow/WorkflowServiceRegistry.js" );







/** @namespace pcvizWorkflow */
const pcvizWorkflow = {
    Workflow,
    WorkflowSettings,
    ScanWorkflow,
    GenericWorkflow: (_GenericWorkflow__WEBPACK_IMPORTED_MODULE_4___default()),
    WorkflowServiceRegistry,
    C2C: _C2C__WEBPACK_IMPORTED_MODULE_0__["default"],
    ReportC2C: _ReportC2C__WEBPACK_IMPORTED_MODULE_1__["default"],
    ProcessScans: _ProcessScans__WEBPACK_IMPORTED_MODULE_2__["default"],
    ScanConstants: _ScanConstants__WEBPACK_IMPORTED_MODULE_3__["default"],
    GenericConstants: _GenericConstants__WEBPACK_IMPORTED_MODULE_5__["default"]
};

/* harmony default export */ __webpack_exports__["default"] = (pcvizWorkflow);


/***/ }),

/***/ "./sources/version.js":
/*!****************************!*\
  !*** ./sources/version.js ***!
  \****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return {
        name: 'PointCloudViz.js',
        version: '3.7.0',
        author: 'Mirage Technologies S.L.U. a Topcon Company'
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),

/***/ 0:
/*!****************************************!*\
  !*** multi ./sources/PointCloudViz.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! ./sources/PointCloudViz.js */"./sources/PointCloudViz.js");


/***/ }),

/***/ 1:
/*!**********************!*\
  !*** util (ignored) ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

/******/ });
});
//# sourceMappingURL=pointcloudviz.js.map
/*!
 * PointCloudViz-Map.js - Mirage Technologies S.L.
 * Rafa Gaitán <rafa.gaitan@mirage-tech.com> (http://mirage-tech.com)
 * Jordi Torres <jordi.torres@mirage-tech.com> (http://mirage-tech.com)
 * Julio Campos <julio.campos@mirage-tech.com> (http://mirage-tech.com)
 * David Haro <david.haro@mirage-tech.com> (http://mirage-tech.com)
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("PointCloudViz"), require("proj4"));
	else if(typeof define === 'function' && define.amd)
		define(["PointCloudViz", "proj4"], factory);
	else if(typeof exports === 'object')
		exports["PointCloudVizMap"] = factory(require("PointCloudViz"), require("proj4"));
	else
		root["PointCloudVizMap"] = factory(root["PointCloudViz"], root["proj4"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__26__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var pcvizMap_pcvizMap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);
/* harmony import */ var pcvizMapLayers_pcvizMapLayers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(312);
/* harmony import */ var PointCloudVizMapCSS__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(366);
/** @namespace PointCloudVizMap */





PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"].Map = pcvizMap_pcvizMap__WEBPACK_IMPORTED_MODULE_1__["default"];
PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"].Layers = pcvizMapLayers_pcvizMapLayers__WEBPACK_IMPORTED_MODULE_2__["default"];
PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"].CSS = PointCloudVizMapCSS__WEBPACK_IMPORTED_MODULE_3__["default"];

var namespaces = [ 'pcvizMapView' ];

// for backward compatibility
PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"].globalify = function () {
    namespaces.forEach( function ( namespace ) {
        window[ namespace ] = PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"][ namespace ];
    } );
};

/* harmony default export */ __webpack_exports__["default"] = (PointCloudVizMapNS__WEBPACK_IMPORTED_MODULE_0__["default"]);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var version__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var version__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(version__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["default"] = (version__WEBPACK_IMPORTED_MODULE_0___default.a);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
    return {
        name: 'PointCloudViz-Map.js',
        version: '3.7.0',
        author: 'Mirage Technologies S.L.U. a Topcon Company'
    };
}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizMap_MapView__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(33);
/* harmony import */ var pcvizMap_MapViewer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(349);
/* harmony import */ var pcvizMap_Projection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(354);
/* harmony import */ var _SitesMapViewer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(364);
/* harmony import */ var pcvizMap_JobSiteMapView__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(365);








/** @namespace pcvizMap */
const pcvizMap = {};
pcvizMap.MapView = pcvizMap_MapView__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizMap.MapViewer = pcvizMap_MapViewer__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizMap.OLMapViewer = pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizMap.Projection = pcvizMap_Projection__WEBPACK_IMPORTED_MODULE_3__["default"];
pcvizMap.SitesMapViewer = _SitesMapViewer__WEBPACK_IMPORTED_MODULE_4__["default"];
pcvizMap.JobSiteMapView = pcvizMap_JobSiteMapView__WEBPACK_IMPORTED_MODULE_5__["default"];

/* harmony default export */ __webpack_exports__["default"] = (pcvizMap);


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapView; });
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(Proj4js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28);
/* harmony import */ var bluebird__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(bluebird__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(33);
/* harmony import */ var pcvizMapTools_MapInformationTool__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(351);
/* harmony import */ var pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(352);
/* harmony import */ var pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(353);










const ProjectView = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.App.ProjectView;

const {
    Registry,
    ListenerController,
    Utils: UtilsDB
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB;
const pcvizGIS = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS;
const {
    CRSUtils,
    MathUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils;
const {
    LayerType,
    VectorLayerUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS;
const pcvizGISRenderer = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Renderer;
const Group = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Node.Group.default;

/**
 * This class implements the map view. It uses [OpenLayers](http://www.openlayers.org) to render the map.
 * TODO: Refactor this class. I.e. *drawLayer* functions must be implemented in their respective classes like `MapVectorLayer`.
 * @class
 * @memberof pcvizMap
 * @extends ProjectView
 * @param {element} mapElement DOM element to link the map
 * @param {object} opt        Configuration options
 * @param {canvas} viewerCanvas The canvas with 3D context in which the pointcloud is going to be rendered. If undefined, one will be created.
 * @property {OLMapViewer} _olMapViewer The map viewer that renders the OL map.
 * @property {MapInformationTool} _informationTool The information tool that works with the map.
 * @property {MapLayerRenderer} _layerRenderer The layer renderer.
 */
class MapView extends ProjectView {
    constructor( project, mapElement, opt, viewerCanvas ) {
        super( project );

        this._olMapViewer = new pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_5__["default"]( mapElement, viewerCanvas );
        this._center = undefined;

        this.registerLayerActions();
        this.addEventListeners();
        Registry.getInstance().getController( 'Object' ).addUpdatedFinishCallback( ListenerController.PROJECT, this.refresh.bind( this ) );

        this._pointVisibilityManagerCtrl = Registry.getController( 'PointVisibilityManager' );
        this._workspaceController = Registry.getInstance().getController( 'Workspace' );

        this._informationTool = new pcvizMapTools_MapInformationTool__WEBPACK_IMPORTED_MODULE_6__["default"]( this._olMapViewer );
        this._layerRenderer = new pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_8__["default"]( this._olMapViewer );
        this._layerGroupNodes = new Map();

        this._pointVisibilityManagerCtrl.registerListener( ListenerController.PROJECT, 'visibilityUpdated', () => {
            this.updatePointVisibility();
        }, 'mapView:visibilityUpdated' );

        this.registerSymbols();
    }

    registerSymbols() {
        var symbolRegistry = Registry.getController( 'Symbol' );
        symbolRegistry.registerSymbol( 'Map', 'Point', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'PointMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'MultiPoint', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'MultiPointMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Line', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].LineSymbol );
        symbolRegistry.registerSymbol( 'Map', 'LineMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].LineMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Fill', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].FillSymbol );
        symbolRegistry.registerSymbol( 'Map', 'FillMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].FillMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Panorama', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'PlanarImage', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Target', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].PointSymbol ); //CHECK if we want a special symbol for targets
        symbolRegistry.registerSymbol( 'Map', 'Model3D', pcvizGISRenderer.Model3DSymbol3D );
        symbolRegistry.registerSymbol( 'Map', 'Volume', pcvizGISRenderer.VolumeSymbol3D );
        symbolRegistry.registerSymbol( 'Map', 'Machinery', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_7__["default"].MachineryMarkerSymbol );
    }

    /**
     * Returns the MapViewer object
     * @memberof pcvizMap.MapView
     * @return {OLMapViewer} The Map viewer
     */
    getMapViewer() {
        return this._olMapViewer;
    }

    /**
     * Returns the OpenLayers map object
     * @memberof pcvizMap.MapView
     * @return {Map} The OpenLayers map
     */
    getOLMap() {
        return this._olMapViewer.getMap();
    }

    getLayerRenderer() {
        return this._layerRenderer;
    }

    // we use a promise because another views (sceneView) must be wait to know if
    // all the layers are loaded right.
    // In this case map doesn´t need to wait to anything to resolve the promise
    run() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();
        this._olMapViewer.closeOverlay();

        // Sometimes, this._project.getProj4() is an empty string. So, we can't execute Proj4.defs with this argument.
        if ( this._projection && this._project && this._project.getProj4() !== '' ) {
            Proj4js__WEBPACK_IMPORTED_MODULE_2___default.a.defs( this._projection, this._project.getProj4() );
            Object(ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__["register"])( Proj4js__WEBPACK_IMPORTED_MODULE_2___default.a );
            this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_1__["get"]( this._projection );
        } else {
            this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_1__["get"]( CRSUtils.DEFAULT_PROJECTION );
        }
        this._olMapViewer.setProjection( this._olProjection );

        this.addLayers().then( function () {
            defer.resolve();
        } );

        this._olMapViewer.run();
        return defer.promise;
    }

    addLayers() {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();
        if ( this._project === undefined )
            return defer.promise;

        var layers = this._project.getAllLayers();

        var promises = [];

        var self = this;

        for ( var i = 0; i < layers.length; i++ ) {
            var layer = layers[ i ];
            promises.push( layer.open() );
        }

        Promise.all( promises ).then( function ( layersOpened ) {
            var opened = [];
            for ( var i = 0; i < layers.length; i++ )
                if ( layersOpened[ i ].loaded )
                    opened.push( layers[ i ] );
            self.drawLayers( opened );
            defer.resolve();
        } );
        return defer.promise;
    }

    drawLayers() {
        var promises = [];
        var self = this;
        self.renderChildrenLayers( self._project.getProjectDataset()._tableOfContents.layerGroup.children, this._olMapViewer.getMap3DScene().getRootNode(), promises );

        Promise.all( promises ).then( function () {
            Registry.getInstance().getController( 'SelectionObject' ).notify();
            self._olMapViewer.renderExtent();
            self._olMapViewer.fit();
            self.updatePointVisibility(); // Apply point visibility
        } );
    }

    refreshMap() {
        return new Promise( resolve => {
            this._olMapViewer.getMap3DScene()._rootNode.removeChildren();
            this._layerRenderer.initLayerNodes();

            this.drawLayers();
            resolve();
        } );
    }

    renderChildrenLayers( children, node, promisesArray ) {
        for ( var i = 0; i < children.length; i++ ) {

            if ( children[ i ].layerGroup ) {
                var group = new Group();
                group.name = children[ i ].layerGroup.name;

                if ( children[ i ].layerGroup.transformMatrix && !CRSUtils.isEcefPoint( children[ i ].layerGroup.transformMatrix[ 3 ], children[ i ].layerGroup.transformMatrix[ 7 ], children[ i ].layerGroup.transformMatrix[ 11 ] ) ) {
                    UtilsDB.transposeMat4( group.getMatrix(), children[ i ].layerGroup.transformMatrix );
                    group.setMatrix( group.getMatrix() );
                }

                this._layerGroupNodes.set( children[ i ].layerGroup.id, group );
                node.addChild( group );
                this.renderChildrenLayers( children[ i ].layerGroup.children, group, promisesArray );
            } else {
                promisesArray.push( this.drawLayer( this._project.getLayerById( children[ i ].id ), node ) );
            }

        }
    }


    drawLayer( layer, node ) {
        if ( !layer.getCenter() )
            layer.computeCenter();

        if ( this._center === undefined ) {
            if ( Registry.getInstance().getController( 'View' ).getCenter() !== undefined )
                this._center = Registry.getInstance().getController( 'View' ).getCenter();
            else {
                this._center = layer.getCenter();
                Registry.getInstance().getController( 'View' ).setCenter( this._center );
            }
            this._layerRenderer.setCenter( this._center );
            var transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];

            this._olMapViewer.getMap3DScene().getRootNode().setMatrix( UtilsDB.translateMat4( MathUtils.mat4.create(), transCenter ) );
        }

        return layer.render( this._layerRenderer, this._olMapViewer, node );
    }

    setControlPointsVisibility( visible ) {
        this._layerRenderer.setControlPointsVisibility( visible );
    }

    refresh( objects ) {
        for ( var i = 0; i < objects.length; i++ ) {
            if ( objects[ i ] instanceof pcvizGIS.Layer )
                this.refreshLayer( objects[ i ] );
            else if ( objects[ i ] instanceof pcvizGIS.Feature )
                this.refreshLayer( objects[ i ].getLayer() );
        }
    }

    // This function returns promise to be compatible with SceneView
    refreshLayer( layer ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();

        var parentNode;
        var group = this.findElementInTableOfContents( layer.getId(), this._project.getProjectDataset()._tableOfContents.layerGroup.children );
        parentNode = this.getOrCreateParentNode( group );


        // Refreshes layer style
        if ( layer.getType() === LayerType.VECTOR && !VectorLayerUtils.isModel( layer.getCategory() ) ) {
            var olLayer = this.getOLMap().getLayers().getArray().find( function ( element ) {
                if ( element.get( 'id' ) === layer.getId() )
                    return element;
            } );
            if ( !olLayer ) { // layer has not been created in Map yet
                defer.resolve();
                return defer.promise;
            }
            var self = this;


            olLayer.get( 'mapVectorLayer' ).render( this._layerRenderer, parentNode ).then( function () {
                self._informationTool.refresh();
                defer.resolve();
            } );
        } else if ( layer.getCategory !== undefined && VectorLayerUtils.isModel( layer.getCategory() ) ) {
            this.drawLayer( layer );
            defer.resolve(); // Maybe we could wait for drawLayer
        } else if ( layer.getType() === LayerType.POINTCLOUD ) {
            // We need to redraw the layer. This will be executed when: process scan and remove data from scan
            var pcNode = this._layerRenderer.getNodeFromLayer( layer );
            if ( pcNode !== undefined ) {
                var mt = pcNode._parents[ 0 ];
                mt.removeChild( pcNode );

                if ( pcNode.cleanNode )
                    pcNode.cleanNode();

                mt._parents[ 0 ].removeChild( mt ); // removes MatrixTransform

                mt.releaseGLObjects();
                mt = null;
            }
            this._layerRenderer.removeLayerNode( layer );

            var that = this;
            this.drawLayer( layer, parentNode ).then( function () {
                that.render();
                defer.resolve();
            } );

        } else { //Raster layers (We need at least to resolve the promise)
            defer.resolve();
        }

        return defer.promise;
    }

    refreshLayerGroup( layerGroup ) {
        var defer = bluebird__WEBPACK_IMPORTED_MODULE_4___default.a.defer();

        // Rendering the station layers
        let lDataCacheObj = this._workspaceController.getWorkspaceDataCache().getDataCacheObject( layerGroup.getId() );
        if ( lDataCacheObj !== undefined ) {
            layerGroup.render( this.getLayerRenderer() );
        }
        defer.resolve();
        return defer.promise;
    }

    updatePointVisibility() {
        if ( this._layerRenderer ) {
            const pointCloudNodes = Array.from( this._layerRenderer.getLayerNodesByType( LayerType.POINTCLOUD ).values() );
            for ( let node of pointCloudNodes ) {
                Registry.getController( 'PointVisibilityManager' ).pushNodeToUpdate( node );
            }

            Registry.getController( 'PointVisibilityManager' ).notifyUpdateGeometries();
        }
    }

    findElementInTableOfContents( id, children ) {
        for ( var i = 0; i < children.length; i++ ) {
            if ( children[ i ].layerGroup /*|| children[ i ].children*/ ) {
                var find = this.findElementInTableOfContents( id, children[ i ].layerGroup.children );
                // true means the element has been found
                // if it is an object, it means the parent layer group has found
                if ( find === true )
                    return children[ i ].layerGroup;
                if ( find )
                    return find;
            } else {
                if ( children[ i ].id === id )
                    return true;
            }
        }
    }

    setMapDOMElement( element ) {
        this._mapElement = element;
        if ( this._olMapViewer !== undefined )
            this._olMapViewer.setTarget( this._mapElement );
    }

    render() {
        this._olMapViewer.renderPointCloudScene();
        this._olMapViewer.renderExtent();
    }

    setResourcesPath( path ) {
        this._resourcesPath = path;
    }

    getOrCreateParentNode( group ) {
        var parentNode = this._layerGroupNodes.get( group.id );
        if ( !parentNode ) {
            parentNode = new Group();
            this._layerGroupNodes.set( group.id, parentNode );
            this._olMapViewer.getMap3DScene().getRootNode().addChild( parentNode );
        }
        return parentNode;
    }

    registerLayerActions() {
        var self = this;

        var onAddLayer = function ( layer ) {
            var group = self.findElementInTableOfContents( layer.getId(), self._project.getProjectDataset()._tableOfContents.layerGroup.children );
            // group must be defined
            var parentNode = self.getOrCreateParentNode( group );
            self.drawLayer( layer, parentNode ).then( function () {
                self._olMapViewer.renderExtent();
                self._olMapViewer.fit();
            } );
        };
        this.registerLayerAction( 'add', 'PointCloud', onAddLayer );

        this.registerLayerAction( 'delete', 'PointCloud', function ( id, layer ) {
            var mt = self._layerRenderer.getNodeFromLayer( layer )._parents[ 0 ];
            mt.removeChild( self._layerRenderer.getNodeFromLayer( layer ) );
            mt._parents[ 0 ].removeChild( mt ); // removes MatrixTransform
            self._layerRenderer.removeLayerNode( layer );
            self.render();
        } );

        this.registerLayerAction( 'add', 'VectorLayer', onAddLayer );

        this.registerLayerAction( 'delete', 'VectorLayer', function ( id, layer ) {
            if ( VectorLayerUtils.isModel( layer.getCategory() ) ) {
                self._layerRenderer.getNodeFromLayer( layer )._parents[ 0 ].removeChild( self._layerRenderer.getNodeFromLayer( layer ) );
                self._layerRenderer.removeLayerNode( layer );

                self.render();
                return;
            }

            self._olMapViewer.removeLayerById( id );
            self._olMapViewer.renderExtent();
        } );

        this.registerLayerAction( 'add', 'RasterLayer', onAddLayer );
        this.registerLayerAction( 'delete', 'RasterLayer', function ( id /*, layer*/ ) {
            self._olMapViewer.removeLayerById( id );
            self._olMapViewer.renderExtent();
        } );
    }

    addEventListeners() {
        var self = this;

        document.body.addEventListener( 'reorder', function ( ev ) {
            function getLayerInfo( group ) {
                for ( var i = 0; i < group.length; i++ ) {
                    var olLayer = self._olMapViewer.getOLLayerById( group[ i ].getId() );
                    if ( olLayer !== undefined )
                        olLayer.setZIndex( 100000 - group[ i ].getIndex() );
                    if ( group[ i ].getChildren !== undefined && group[ i ].getChildren().length > 0 )
                        getLayerInfo( group[ i ].getChildren() );
                }
            }

            getLayerInfo( ev.detail.tocLayerGroup.getChildren() );

        } );

        document.body.addEventListener( 'updateFeature', function () {
            self._olMapViewer.closeOverlay();
        } );
    }

    // Check the usability of the following methods
    toggleExtent() {
        var l = this.getOLMap().getLayers();
        for ( var i = 0; i < l.getLength(); i++ ) {
            if ( l.item( i ).get( 'id' ) === 'extent' )
                l.item( i ).setVisible( !l.item( i ).getVisible() );
        }
    }

    isExtentVisible() {
        var l = this.getOLMap().getLayers();
        var value;
        for ( var i = 0; i < l.getLength(); i++ ) {
            if ( l.item( i ).get( 'id' ) === 'extent' )
                value = l.item( i ).getVisible();
        }
        return value;
    }

    destroy() {
        this._olMapViewer.destroy();
    }
}


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cloneTransform", function() { return cloneTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "identityTransform", function() { return identityTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProjection", function() { return addProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addProjections", function() { return addProjections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointResolution", function() { return getPointResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEquivalentProjections", function() { return addEquivalentProjections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addEquivalentTransforms", function() { return addEquivalentTransforms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearAllProjections", function() { return clearAllProjections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createProjection", function() { return createProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTransformFromCoordinateTransform", function() { return createTransformFromCoordinateTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCoordinateTransforms", function() { return addCoordinateTransforms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromLonLat", function() { return fromLonLat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toLonLat", function() { return toLonLat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equivalent", function() { return equivalent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTransformFromProjections", function() { return getTransformFromProjections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTransform", function() { return getTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transform", function() { return transform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformExtent", function() { return transformExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformWithProjections", function() { return transformWithProjections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserProjection", function() { return setUserProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearUserProjection", function() { return clearUserProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserProjection", function() { return getUserProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "useGeographic", function() { return useGeographic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUserCoordinate", function() { return toUserCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromUserCoordinate", function() { return fromUserCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUserExtent", function() { return toUserExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromUserExtent", function() { return fromUserExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSafeCoordinateTransform", function() { return createSafeCoordinateTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addCommon", function() { return addCommon; });
/* harmony import */ var _proj_Projection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Projection", function() { return _proj_Projection_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "METERS_PER_UNIT", function() { return _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["METERS_PER_UNIT"]; });

/* harmony import */ var _proj_epsg3857_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10);
/* harmony import */ var _proj_epsg4326_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12);
/* harmony import */ var _proj_projections_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13);
/* harmony import */ var _proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11);
/* harmony import */ var _sphere_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24);
/**
 * @module ol/proj
 */
/**
 * The ol/proj module stores:
 * * a list of {@link module:ol/proj/Projection}
 * objects, one for each projection supported by the application
 * * a list of transform functions needed to convert coordinates in one projection
 * into another.
 *
 * The static functions are the methods used to maintain these.
 * Each transform function can handle not only simple coordinate pairs, but also
 * large arrays of coordinates such as vector geometries.
 *
 * When loaded, the library adds projection objects for EPSG:4326 (WGS84
 * geographic coordinates) and EPSG:3857 (Web or Spherical Mercator, as used
 * for example by Bing Maps or OpenStreetMap), together with the relevant
 * transform functions.
 *
 * Additional transforms may be added by using the http://proj4js.org/
 * library (version 2.2 or later). You can use the full build supplied by
 * Proj4js, or create a custom build to support those projections you need; see
 * the Proj4js website for how to do this. You also need the Proj4js definitions
 * for the required projections. These definitions can be obtained from
 * https://epsg.io/, and are a JS function, so can be loaded in a script
 * tag (as in the examples) or pasted into your application.
 *
 * After all required projection definitions are added to proj4's registry (by
 * using `proj4.defs()`), simply call `register(proj4)` from the `ol/proj/proj4`
 * package. Existing transforms are not changed by this function. See
 * examples/wms-image-custom-proj for an example of this.
 *
 * Additional projection definitions can be registered with `proj4.defs()` any
 * time. Just make sure to call `register(proj4)` again; for example, with user-supplied data where you don't
 * know in advance what projections are needed, you can initially load minimal
 * support and then load whichever are requested.
 *
 * Note that Proj4js does not support projection extents. If you want to add
 * one for creating default tile grids, you can add it after the Projection
 * object has been created with `setExtent`, for example,
 * `get('EPSG:1234').setExtent(extent)`.
 *
 * In addition to Proj4js support, any transform functions can be added with
 * {@link module:ol/proj.addCoordinateTransforms}. To use this, you must first create
 * a {@link module:ol/proj/Projection} object for the new projection and add it with
 * {@link module:ol/proj.addProjection}. You can then add the forward and inverse
 * functions with {@link module:ol/proj.addCoordinateTransforms}. See
 * examples/wms-custom-proj for an example of this.
 *
 * Note that if no transforms are needed and you only need to define the
 * projection, just add a {@link module:ol/proj/Projection} with
 * {@link module:ol/proj.addProjection}. See examples/wms-no-proj for an example of
 * this.
 */










/**
 * A projection as {@link module:ol/proj/Projection}, SRS identifier
 * string or undefined.
 * @typedef {Projection|string|undefined} ProjectionLike
 * @api
 */
/**
 * A transform function accepts an array of input coordinate values, an optional
 * output array, and an optional dimension (default should be 2).  The function
 * transforms the input coordinate values, populates the output array, and
 * returns the output array.
 *
 * @typedef {function(Array<number>, Array<number>=, number=): Array<number>} TransformFunction
 * @api
 */


/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension.
 * @return {Array<number>} Output coordinate array (new array, same coordinate
 *     values).
 */
function cloneTransform(input, opt_output, opt_dimension) {
    var output;
    if (opt_output !== undefined) {
        for (var i = 0, ii = input.length; i < ii; ++i) {
            opt_output[i] = input[i];
        }
        output = opt_output;
    }
    else {
        output = input.slice();
    }
    return output;
}
/**
 * @param {Array<number>} input Input coordinate array.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension.
 * @return {Array<number>} Input coordinate array (same array as input).
 */
function identityTransform(input, opt_output, opt_dimension) {
    if (opt_output !== undefined && input !== opt_output) {
        for (var i = 0, ii = input.length; i < ii; ++i) {
            opt_output[i] = input[i];
        }
        input = opt_output;
    }
    return input;
}
/**
 * Add a Projection object to the list of supported projections that can be
 * looked up by their code.
 *
 * @param {Projection} projection Projection instance.
 * @api
 */
function addProjection(projection) {
    Object(_proj_projections_js__WEBPACK_IMPORTED_MODULE_4__["add"])(projection.getCode(), projection);
    Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(projection, projection, cloneTransform);
}
/**
 * @param {Array<Projection>} projections Projections.
 */
function addProjections(projections) {
    projections.forEach(addProjection);
}
/**
 * Fetches a Projection object for the code specified.
 *
 * @param {ProjectionLike} projectionLike Either a code string which is
 *     a combination of authority and identifier such as "EPSG:4326", or an
 *     existing projection object, or undefined.
 * @return {Projection} Projection object, or null if not in list.
 * @api
 */
function get(projectionLike) {
    return typeof projectionLike === 'string'
        ? Object(_proj_projections_js__WEBPACK_IMPORTED_MODULE_4__["get"])(/** @type {string} */ (projectionLike))
        : /** @type {Projection} */ (projectionLike) || null;
}
/**
 * Get the resolution of the point in degrees or distance units.
 * For projections with degrees as the unit this will simply return the
 * provided resolution. For other projections the point resolution is
 * by default estimated by transforming the 'point' pixel to EPSG:4326,
 * measuring its width and height on the normal sphere,
 * and taking the average of the width and height.
 * A custom function can be provided for a specific projection, either
 * by setting the `getPointResolution` option in the
 * {@link module:ol/proj/Projection~Projection} constructor or by using
 * {@link module:ol/proj/Projection~Projection#setGetPointResolution} to change an existing
 * projection object.
 * @param {ProjectionLike} projection The projection.
 * @param {number} resolution Nominal resolution in projection units.
 * @param {import("./coordinate.js").Coordinate} point Point to find adjusted resolution at.
 * @param {import("./proj/Units.js").default} [opt_units] Units to get the point resolution in.
 * Default is the projection's units.
 * @return {number} Point resolution.
 * @api
 */
function getPointResolution(projection, resolution, point, opt_units) {
    projection = get(projection);
    var pointResolution;
    var getter = projection.getPointResolutionFunc();
    if (getter) {
        pointResolution = getter(resolution, point);
        if (opt_units && opt_units !== projection.getUnits()) {
            var metersPerUnit = projection.getMetersPerUnit();
            if (metersPerUnit) {
                pointResolution =
                    (pointResolution * metersPerUnit) / _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["METERS_PER_UNIT"][opt_units];
            }
        }
    }
    else {
        var units = projection.getUnits();
        if ((units == _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES && !opt_units) || opt_units == _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES) {
            pointResolution = resolution;
        }
        else {
            // Estimate point resolution by transforming the center pixel to EPSG:4326,
            // measuring its width and height on the normal sphere, and taking the
            // average of the width and height.
            var toEPSG4326_1 = getTransformFromProjections(projection, get('EPSG:4326'));
            if (toEPSG4326_1 === identityTransform && units !== _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES) {
                // no transform is available
                pointResolution = resolution * projection.getMetersPerUnit();
            }
            else {
                var vertices = [
                    point[0] - resolution / 2,
                    point[1],
                    point[0] + resolution / 2,
                    point[1],
                    point[0],
                    point[1] - resolution / 2,
                    point[0],
                    point[1] + resolution / 2,
                ];
                vertices = toEPSG4326_1(vertices, vertices, 2);
                var width = Object(_sphere_js__WEBPACK_IMPORTED_MODULE_8__["getDistance"])(vertices.slice(0, 2), vertices.slice(2, 4));
                var height = Object(_sphere_js__WEBPACK_IMPORTED_MODULE_8__["getDistance"])(vertices.slice(4, 6), vertices.slice(6, 8));
                pointResolution = (width + height) / 2;
            }
            var metersPerUnit = opt_units
                ? _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["METERS_PER_UNIT"][opt_units]
                : projection.getMetersPerUnit();
            if (metersPerUnit !== undefined) {
                pointResolution /= metersPerUnit;
            }
        }
    }
    return pointResolution;
}
/**
 * Registers transformation functions that don't alter coordinates. Those allow
 * to transform between projections with equal meaning.
 *
 * @param {Array<Projection>} projections Projections.
 * @api
 */
function addEquivalentProjections(projections) {
    addProjections(projections);
    projections.forEach(function (source) {
        projections.forEach(function (destination) {
            if (source !== destination) {
                Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(source, destination, cloneTransform);
            }
        });
    });
}
/**
 * Registers transformation functions to convert coordinates in any projection
 * in projection1 to any projection in projection2.
 *
 * @param {Array<Projection>} projections1 Projections with equal
 *     meaning.
 * @param {Array<Projection>} projections2 Projections with equal
 *     meaning.
 * @param {TransformFunction} forwardTransform Transformation from any
 *   projection in projection1 to any projection in projection2.
 * @param {TransformFunction} inverseTransform Transform from any projection
 *   in projection2 to any projection in projection1..
 */
function addEquivalentTransforms(projections1, projections2, forwardTransform, inverseTransform) {
    projections1.forEach(function (projection1) {
        projections2.forEach(function (projection2) {
            Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(projection1, projection2, forwardTransform);
            Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(projection2, projection1, inverseTransform);
        });
    });
}
/**
 * Clear all cached projections and transforms.
 */
function clearAllProjections() {
    Object(_proj_projections_js__WEBPACK_IMPORTED_MODULE_4__["clear"])();
    Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["clear"])();
}
/**
 * @param {Projection|string|undefined} projection Projection.
 * @param {string} defaultCode Default code.
 * @return {Projection} Projection.
 */
function createProjection(projection, defaultCode) {
    if (!projection) {
        return get(defaultCode);
    }
    else if (typeof projection === 'string') {
        return get(projection);
    }
    else {
        return /** @type {Projection} */ (projection);
    }
}
/**
 * Creates a {@link module:ol/proj~TransformFunction} from a simple 2D coordinate transform
 * function.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} coordTransform Coordinate
 *     transform.
 * @return {TransformFunction} Transform function.
 */
function createTransformFromCoordinateTransform(coordTransform) {
    return (
    /**
     * @param {Array<number>} input Input.
     * @param {Array<number>} [opt_output] Output.
     * @param {number} [opt_dimension] Dimension.
     * @return {Array<number>} Output.
     */
    function (input, opt_output, opt_dimension) {
        var length = input.length;
        var dimension = opt_dimension !== undefined ? opt_dimension : 2;
        var output = opt_output !== undefined ? opt_output : new Array(length);
        for (var i = 0; i < length; i += dimension) {
            var point = coordTransform([input[i], input[i + 1]]);
            output[i] = point[0];
            output[i + 1] = point[1];
            for (var j = dimension - 1; j >= 2; --j) {
                output[i + j] = input[i + j];
            }
        }
        return output;
    });
}
/**
 * Registers coordinate transform functions to convert coordinates between the
 * source projection and the destination projection.
 * The forward and inverse functions convert coordinate pairs; this function
 * converts these into the functions used internally which also handle
 * extents and coordinate arrays.
 *
 * @param {ProjectionLike} source Source projection.
 * @param {ProjectionLike} destination Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} forward The forward transform
 *     function (that is, from the source projection to the destination
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} inverse The inverse transform
 *     function (that is, from the destination projection to the source
 *     projection) that takes a {@link module:ol/coordinate~Coordinate} as argument and returns
 *     the transformed {@link module:ol/coordinate~Coordinate}.
 * @api
 */
function addCoordinateTransforms(source, destination, forward, inverse) {
    var sourceProj = get(source);
    var destProj = get(destination);
    Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(sourceProj, destProj, createTransformFromCoordinateTransform(forward));
    Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["add"])(destProj, sourceProj, createTransformFromCoordinateTransform(inverse));
}
/**
 * Transforms a coordinate from longitude/latitude to a different projection.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate as longitude and latitude, i.e.
 *     an array with longitude as 1st and latitude as 2nd element.
 * @param {ProjectionLike} [opt_projection] Target projection. The
 *     default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate projected to the target projection.
 * @api
 */
function fromLonLat(coordinate, opt_projection) {
    return transform(coordinate, 'EPSG:4326', opt_projection !== undefined ? opt_projection : 'EPSG:3857');
}
/**
 * Transforms a coordinate to longitude/latitude.
 * @param {import("./coordinate.js").Coordinate} coordinate Projected coordinate.
 * @param {ProjectionLike} [opt_projection] Projection of the coordinate.
 *     The default is Web Mercator, i.e. 'EPSG:3857'.
 * @return {import("./coordinate.js").Coordinate} Coordinate as longitude and latitude, i.e. an array
 *     with longitude as 1st and latitude as 2nd element.
 * @api
 */
function toLonLat(coordinate, opt_projection) {
    var lonLat = transform(coordinate, opt_projection !== undefined ? opt_projection : 'EPSG:3857', 'EPSG:4326');
    var lon = lonLat[0];
    if (lon < -180 || lon > 180) {
        lonLat[0] = Object(_math_js__WEBPACK_IMPORTED_MODULE_7__["modulo"])(lon + 180, 360) - 180;
    }
    return lonLat;
}
/**
 * Checks if two projections are the same, that is every coordinate in one
 * projection does represent the same geographic point as the same coordinate in
 * the other projection.
 *
 * @param {Projection} projection1 Projection 1.
 * @param {Projection} projection2 Projection 2.
 * @return {boolean} Equivalent.
 * @api
 */
function equivalent(projection1, projection2) {
    if (projection1 === projection2) {
        return true;
    }
    var equalUnits = projection1.getUnits() === projection2.getUnits();
    if (projection1.getCode() === projection2.getCode()) {
        return equalUnits;
    }
    else {
        var transformFunc = getTransformFromProjections(projection1, projection2);
        return transformFunc === cloneTransform && equalUnits;
    }
}
/**
 * Searches in the list of transform functions for the function for converting
 * coordinates from the source projection to the destination projection.
 *
 * @param {Projection} sourceProjection Source Projection object.
 * @param {Projection} destinationProjection Destination Projection
 *     object.
 * @return {TransformFunction} Transform function.
 */
function getTransformFromProjections(sourceProjection, destinationProjection) {
    var sourceCode = sourceProjection.getCode();
    var destinationCode = destinationProjection.getCode();
    var transformFunc = Object(_proj_transforms_js__WEBPACK_IMPORTED_MODULE_5__["get"])(sourceCode, destinationCode);
    if (!transformFunc) {
        transformFunc = identityTransform;
    }
    return transformFunc;
}
/**
 * Given the projection-like objects, searches for a transformation
 * function to convert a coordinates array from the source projection to the
 * destination projection.
 *
 * @param {ProjectionLike} source Source.
 * @param {ProjectionLike} destination Destination.
 * @return {TransformFunction} Transform function.
 * @api
 */
function getTransform(source, destination) {
    var sourceProjection = get(source);
    var destinationProjection = get(destination);
    return getTransformFromProjections(sourceProjection, destinationProjection);
}
/**
 * Transforms a coordinate from source projection to destination projection.
 * This returns a new coordinate (and does not modify the original).
 *
 * See {@link module:ol/proj.transformExtent} for extent transformation.
 * See the transform method of {@link module:ol/geom/Geometry~Geometry} and its
 * subclasses for geometry transforms.
 *
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @return {import("./coordinate.js").Coordinate} Coordinate.
 * @api
 */
function transform(coordinate, source, destination) {
    var transformFunc = getTransform(source, destination);
    return transformFunc(coordinate, undefined, coordinate.length);
}
/**
 * Transforms an extent from source projection to destination projection.  This
 * returns a new extent (and does not modify the original).
 *
 * @param {import("./extent.js").Extent} extent The extent to transform.
 * @param {ProjectionLike} source Source projection-like.
 * @param {ProjectionLike} destination Destination projection-like.
 * @param {number} [opt_stops] Number of stops per side used for the transform.
 * By default only the corners are used.
 * @return {import("./extent.js").Extent} The transformed extent.
 * @api
 */
function transformExtent(extent, source, destination, opt_stops) {
    var transformFunc = getTransform(source, destination);
    return Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["applyTransform"])(extent, transformFunc, undefined, opt_stops);
}
/**
 * Transforms the given point to the destination projection.
 *
 * @param {import("./coordinate.js").Coordinate} point Point.
 * @param {Projection} sourceProjection Source projection.
 * @param {Projection} destinationProjection Destination projection.
 * @return {import("./coordinate.js").Coordinate} Point.
 */
function transformWithProjections(point, sourceProjection, destinationProjection) {
    var transformFunc = getTransformFromProjections(sourceProjection, destinationProjection);
    return transformFunc(point);
}
/**
 * @type {?Projection}
 */
var userProjection = null;
/**
 * Set the projection for coordinates supplied from and returned by API methods.
 * Note that this method is not yet a part of the stable API.  Support for user
 * projections is not yet complete and should be considered experimental.
 * @param {ProjectionLike} projection The user projection.
 */
function setUserProjection(projection) {
    userProjection = get(projection);
}
/**
 * Clear the user projection if set.  Note that this method is not yet a part of
 * the stable API.  Support for user projections is not yet complete and should
 * be considered experimental.
 */
function clearUserProjection() {
    userProjection = null;
}
/**
 * Get the projection for coordinates supplied from and returned by API methods.
 * Note that this method is not yet a part of the stable API.  Support for user
 * projections is not yet complete and should be considered experimental.
 * @return {?Projection} The user projection (or null if not set).
 */
function getUserProjection() {
    return userProjection;
}
/**
 * Use geographic coordinates (WGS-84 datum) in API methods.  Note that this
 * method is not yet a part of the stable API.  Support for user projections is
 * not yet complete and should be considered experimental.
 */
function useGeographic() {
    setUserProjection('EPSG:4326');
}
/**
 * Return a coordinate transformed into the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} sourceProjection The input coordinate projection.
 * @return {Array<number>} The input coordinate in the user projection.
 */
function toUserCoordinate(coordinate, sourceProjection) {
    if (!userProjection) {
        return coordinate;
    }
    return transform(coordinate, sourceProjection, userProjection);
}
/**
 * Return a coordinate transformed from the user projection.  If no user projection
 * is set, the original coordinate is returned.
 * @param {Array<number>} coordinate Input coordinate.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {Array<number>} The input coordinate transformed.
 */
function fromUserCoordinate(coordinate, destProjection) {
    if (!userProjection) {
        return coordinate;
    }
    return transform(coordinate, userProjection, destProjection);
}
/**
 * Return an extent transformed into the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} sourceProjection The input extent projection.
 * @return {import("./extent.js").Extent} The input extent in the user projection.
 */
function toUserExtent(extent, sourceProjection) {
    if (!userProjection) {
        return extent;
    }
    return transformExtent(extent, sourceProjection, userProjection);
}
/**
 * Return an extent transformed from the user projection.  If no user projection
 * is set, the original extent is returned.
 * @param {import("./extent.js").Extent} extent Input extent.
 * @param {ProjectionLike} destProjection The destination projection.
 * @return {import("./extent.js").Extent} The input extent transformed.
 */
function fromUserExtent(extent, destProjection) {
    if (!userProjection) {
        return extent;
    }
    return transformExtent(extent, userProjection, destProjection);
}
/**
 * Creates a safe coordinate transform function from a coordinate transform function.
 * "Safe" means that it can handle wrapping of x-coordinates for global projections,
 * and that coordinates exceeding the source projection validity extent's range will be
 * clamped to the validity range.
 * @param {Projection} sourceProj Source projection.
 * @param {Projection} destProj Destination projection.
 * @param {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} transform Transform function (source to destiation).
 * @return {function(import("./coordinate.js").Coordinate): import("./coordinate.js").Coordinate} Safe transform function (source to destiation).
 */
function createSafeCoordinateTransform(sourceProj, destProj, transform) {
    return function (coord) {
        var sourceX = coord[0];
        var sourceY = coord[1];
        var transformed, worldsAway;
        if (sourceProj.canWrapX()) {
            var sourceExtent = sourceProj.getExtent();
            var sourceExtentWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(sourceExtent);
            worldsAway = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_9__["getWorldsAway"])(coord, sourceProj, sourceExtentWidth);
            if (worldsAway) {
                // Move x to the real world
                sourceX = sourceX - worldsAway * sourceExtentWidth;
            }
            sourceX = Object(_math_js__WEBPACK_IMPORTED_MODULE_7__["clamp"])(sourceX, sourceExtent[0], sourceExtent[2]);
            sourceY = Object(_math_js__WEBPACK_IMPORTED_MODULE_7__["clamp"])(sourceY, sourceExtent[1], sourceExtent[3]);
            transformed = transform([sourceX, sourceY]);
        }
        else {
            transformed = transform(coord);
        }
        if (worldsAway && destProj.canWrapX()) {
            // Move transformed coordinate back to the offset world
            transformed[0] += worldsAway * Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(destProj.getExtent());
        }
        return transformed;
    };
}
/**
 * Add transforms to and from EPSG:4326 and EPSG:3857.  This function is called
 * by when this module is executed and should only need to be called again after
 * `clearAllProjections()` is called (e.g. in tests).
 */
function addCommon() {
    // Add transformations that don't alter coordinates to convert within set of
    // projections with equal meaning.
    addEquivalentProjections(_proj_epsg3857_js__WEBPACK_IMPORTED_MODULE_2__["PROJECTIONS"]);
    addEquivalentProjections(_proj_epsg4326_js__WEBPACK_IMPORTED_MODULE_3__["PROJECTIONS"]);
    // Add transformations to convert EPSG:4326 like coordinates to EPSG:3857 like
    // coordinates and back.
    addEquivalentTransforms(_proj_epsg4326_js__WEBPACK_IMPORTED_MODULE_3__["PROJECTIONS"], _proj_epsg3857_js__WEBPACK_IMPORTED_MODULE_2__["PROJECTIONS"], _proj_epsg3857_js__WEBPACK_IMPORTED_MODULE_2__["fromEPSG4326"], _proj_epsg3857_js__WEBPACK_IMPORTED_MODULE_2__["toEPSG4326"]);
}
addCommon();
//# sourceMappingURL=proj.js.map

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Units_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
/**
 * @module ol/proj/Projection
 */

/**
 * @typedef {Object} Options
 * @property {string} code The SRS identifier code, e.g. `EPSG:4326`.
 * @property {import("./Units.js").default|string} [units] Units. Required unless a
 * proj4 projection is defined for `code`.
 * @property {import("../extent.js").Extent} [extent] The validity extent for the SRS.
 * @property {string} [axisOrientation='enu'] The axis orientation as specified in Proj4.
 * @property {boolean} [global=false] Whether the projection is valid for the whole globe.
 * @property {number} [metersPerUnit] The meters per unit for the SRS.
 * If not provided, the `units` are used to get the meters per unit from the {@link module:ol/proj/Units~METERS_PER_UNIT}
 * lookup table.
 * @property {import("../extent.js").Extent} [worldExtent] The world extent for the SRS.
 * @property {function(number, import("../coordinate.js").Coordinate):number} [getPointResolution]
 * Function to determine resolution at a point. The function is called with a
 * `number` view resolution and a {@link module:ol/coordinate~Coordinate Coordinate} as arguments, and returns
 * the `number` resolution in projection units at the passed coordinate. If this is `undefined`,
 * the default {@link module:ol/proj.getPointResolution getPointResolution()} function will be used.
 */
/**
 * @classdesc
 * Projection definition class. One of these is created for each projection
 * supported in the application and stored in the {@link module:ol/proj} namespace.
 * You can use these in applications, but this is not required, as API params
 * and options use {@link module:ol/proj~ProjectionLike} which means the simple string
 * code will suffice.
 *
 * You can use {@link module:ol/proj.get} to retrieve the object for a particular
 * projection.
 *
 * The library includes definitions for `EPSG:4326` and `EPSG:3857`, together
 * with the following aliases:
 * * `EPSG:4326`: CRS:84, urn:ogc:def:crs:EPSG:6.6:4326,
 *     urn:ogc:def:crs:OGC:1.3:CRS84, urn:ogc:def:crs:OGC:2:84,
 *     http://www.opengis.net/gml/srs/epsg.xml#4326,
 *     urn:x-ogc:def:crs:EPSG:4326
 * * `EPSG:3857`: EPSG:102100, EPSG:102113, EPSG:900913,
 *     urn:ogc:def:crs:EPSG:6.18:3:3857,
 *     http://www.opengis.net/gml/srs/epsg.xml#3857
 *
 * If you use [proj4js](https://github.com/proj4js/proj4js), aliases can
 * be added using `proj4.defs()`. After all required projection definitions are
 * added, call the {@link module:ol/proj/proj4.register} function.
 *
 * @api
 */
var Projection = /** @class */ (function () {
    /**
     * @param {Options} options Projection options.
     */
    function Projection(options) {
        /**
         * @private
         * @type {string}
         */
        this.code_ = options.code;
        /**
         * Units of projected coordinates. When set to `TILE_PIXELS`, a
         * `this.extent_` and `this.worldExtent_` must be configured properly for each
         * tile.
         * @private
         * @type {import("./Units.js").default}
         */
        this.units_ = /** @type {import("./Units.js").default} */ (options.units);
        /**
         * Validity extent of the projection in projected coordinates. For projections
         * with `TILE_PIXELS` units, this is the extent of the tile in
         * tile pixel space.
         * @private
         * @type {import("../extent.js").Extent}
         */
        this.extent_ = options.extent !== undefined ? options.extent : null;
        /**
         * Extent of the world in EPSG:4326. For projections with
         * `TILE_PIXELS` units, this is the extent of the tile in
         * projected coordinate space.
         * @private
         * @type {import("../extent.js").Extent}
         */
        this.worldExtent_ =
            options.worldExtent !== undefined ? options.worldExtent : null;
        /**
         * @private
         * @type {string}
         */
        this.axisOrientation_ =
            options.axisOrientation !== undefined ? options.axisOrientation : 'enu';
        /**
         * @private
         * @type {boolean}
         */
        this.global_ = options.global !== undefined ? options.global : false;
        /**
         * @private
         * @type {boolean}
         */
        this.canWrapX_ = !!(this.global_ && this.extent_);
        /**
         * @private
         * @type {function(number, import("../coordinate.js").Coordinate):number|undefined}
         */
        this.getPointResolutionFunc_ = options.getPointResolution;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */
        this.defaultTileGrid_ = null;
        /**
         * @private
         * @type {number|undefined}
         */
        this.metersPerUnit_ = options.metersPerUnit;
    }
    /**
     * @return {boolean} The projection is suitable for wrapping the x-axis
     */
    Projection.prototype.canWrapX = function () {
        return this.canWrapX_;
    };
    /**
     * Get the code for this projection, e.g. 'EPSG:4326'.
     * @return {string} Code.
     * @api
     */
    Projection.prototype.getCode = function () {
        return this.code_;
    };
    /**
     * Get the validity extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    Projection.prototype.getExtent = function () {
        return this.extent_;
    };
    /**
     * Get the units of this projection.
     * @return {import("./Units.js").default} Units.
     * @api
     */
    Projection.prototype.getUnits = function () {
        return this.units_;
    };
    /**
     * Get the amount of meters per unit of this projection.  If the projection is
     * not configured with `metersPerUnit` or a units identifier, the return is
     * `undefined`.
     * @return {number|undefined} Meters.
     * @api
     */
    Projection.prototype.getMetersPerUnit = function () {
        return this.metersPerUnit_ || _Units_js__WEBPACK_IMPORTED_MODULE_0__["METERS_PER_UNIT"][this.units_];
    };
    /**
     * Get the world extent for this projection.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    Projection.prototype.getWorldExtent = function () {
        return this.worldExtent_;
    };
    /**
     * Get the axis orientation of this projection.
     * Example values are:
     * enu - the default easting, northing, elevation.
     * neu - northing, easting, up - useful for "lat/long" geographic coordinates,
     *     or south orientated transverse mercator.
     * wnu - westing, northing, up - some planetary coordinate systems have
     *     "west positive" coordinate systems
     * @return {string} Axis orientation.
     * @api
     */
    Projection.prototype.getAxisOrientation = function () {
        return this.axisOrientation_;
    };
    /**
     * Is this projection a global projection which spans the whole world?
     * @return {boolean} Whether the projection is global.
     * @api
     */
    Projection.prototype.isGlobal = function () {
        return this.global_;
    };
    /**
     * Set if the projection is a global projection which spans the whole world
     * @param {boolean} global Whether the projection is global.
     * @api
     */
    Projection.prototype.setGlobal = function (global) {
        this.global_ = global;
        this.canWrapX_ = !!(global && this.extent_);
    };
    /**
     * @return {import("../tilegrid/TileGrid.js").default} The default tile grid.
     */
    Projection.prototype.getDefaultTileGrid = function () {
        return this.defaultTileGrid_;
    };
    /**
     * @param {import("../tilegrid/TileGrid.js").default} tileGrid The default tile grid.
     */
    Projection.prototype.setDefaultTileGrid = function (tileGrid) {
        this.defaultTileGrid_ = tileGrid;
    };
    /**
     * Set the validity extent for this projection.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */
    Projection.prototype.setExtent = function (extent) {
        this.extent_ = extent;
        this.canWrapX_ = !!(this.global_ && extent);
    };
    /**
     * Set the world extent for this projection.
     * @param {import("../extent.js").Extent} worldExtent World extent
     *     [minlon, minlat, maxlon, maxlat].
     * @api
     */
    Projection.prototype.setWorldExtent = function (worldExtent) {
        this.worldExtent_ = worldExtent;
    };
    /**
     * Set the getPointResolution function (see {@link module:ol/proj.getPointResolution}
     * for this projection.
     * @param {function(number, import("../coordinate.js").Coordinate):number} func Function
     * @api
     */
    Projection.prototype.setGetPointResolution = function (func) {
        this.getPointResolutionFunc_ = func;
    };
    /**
     * Get the custom point resolution function for this projection (if set).
     * @return {function(number, import("../coordinate.js").Coordinate):number|undefined} The custom point
     * resolution function (if set).
     */
    Projection.prototype.getPointResolutionFunc = function () {
        return this.getPointResolutionFunc_;
    };
    return Projection;
}());
/* harmony default export */ __webpack_exports__["default"] = (Projection);
//# sourceMappingURL=Projection.js.map

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "METERS_PER_UNIT", function() { return METERS_PER_UNIT; });
/**
 * @module ol/proj/Units
 */
/**
 * Projection units: `'degrees'`, `'ft'`, `'m'`, `'pixels'`, `'tile-pixels'` or
 * `'us-ft'`.
 * @enum {string}
 */
var Units = {
    /**
     * Degrees
     * @api
     */
    DEGREES: 'degrees',
    /**
     * Feet
     * @api
     */
    FEET: 'ft',
    /**
     * Meters
     * @api
     */
    METERS: 'm',
    /**
     * Pixels
     * @api
     */
    PIXELS: 'pixels',
    /**
     * Tile Pixels
     * @api
     */
    TILE_PIXELS: 'tile-pixels',
    /**
     * US Feet
     * @api
     */
    USFEET: 'us-ft',
};
/**
 * Meters per unit lookup table.
 * @const
 * @type {Object<Units, number>}
 * @api
 */
var METERS_PER_UNIT = {};
// use the radius of the Normal sphere
METERS_PER_UNIT[Units.DEGREES] = (2 * Math.PI * 6370997) / 360;
METERS_PER_UNIT[Units.FEET] = 0.3048;
METERS_PER_UNIT[Units.METERS] = 1;
METERS_PER_UNIT[Units.USFEET] = 1200 / 3937;
/* harmony default export */ __webpack_exports__["default"] = (Units);
//# sourceMappingURL=Units.js.map

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIUS", function() { return RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HALF_SIZE", function() { return HALF_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXTENT", function() { return EXTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WORLD_EXTENT", function() { return WORLD_EXTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAX_SAFE_Y", function() { return MAX_SAFE_Y; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROJECTIONS", function() { return PROJECTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromEPSG4326", function() { return fromEPSG4326; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toEPSG4326", function() { return toEPSG4326; });
/* harmony import */ var _Projection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/proj/epsg3857
 */



/**
 * Radius of WGS84 sphere
 *
 * @const
 * @type {number}
 */
var RADIUS = 6378137;
/**
 * @const
 * @type {number}
 */
var HALF_SIZE = Math.PI * RADIUS;
/**
 * @const
 * @type {import("../extent.js").Extent}
 */
var EXTENT = [-HALF_SIZE, -HALF_SIZE, HALF_SIZE, HALF_SIZE];
/**
 * @const
 * @type {import("../extent.js").Extent}
 */
var WORLD_EXTENT = [-180, -85, 180, 85];
/**
 * Maximum safe value in y direction
 * @const
 * @type {number}
 */
var MAX_SAFE_Y = RADIUS * Math.log(Math.tan(Math.PI / 2));
/**
 * @classdesc
 * Projection object for web/spherical Mercator (EPSG:3857).
 */
var EPSG3857Projection = /** @class */ (function (_super) {
    __extends(EPSG3857Projection, _super);
    /**
     * @param {string} code Code.
     */
    function EPSG3857Projection(code) {
        return _super.call(this, {
            code: code,
            units: _Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].METERS,
            extent: EXTENT,
            global: true,
            worldExtent: WORLD_EXTENT,
            getPointResolution: function (resolution, point) {
                return resolution / Object(_math_js__WEBPACK_IMPORTED_MODULE_2__["cosh"])(point[1] / RADIUS);
            },
        }) || this;
    }
    return EPSG3857Projection;
}(_Projection_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Projections equal to EPSG:3857.
 *
 * @const
 * @type {Array<import("./Projection.js").default>}
 */
var PROJECTIONS = [
    new EPSG3857Projection('EPSG:3857'),
    new EPSG3857Projection('EPSG:102100'),
    new EPSG3857Projection('EPSG:102113'),
    new EPSG3857Projection('EPSG:900913'),
    new EPSG3857Projection('http://www.opengis.net/gml/srs/epsg.xml#3857'),
];
/**
 * Transformation from EPSG:4326 to EPSG:3857.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension (default is `2`).
 * @return {Array<number>} Output array of coordinate values.
 */
function fromEPSG4326(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) {
            // preserve values beyond second dimension
            output = input.slice();
        }
        else {
            output = new Array(length);
        }
    }
    for (var i = 0; i < length; i += dimension) {
        output[i] = (HALF_SIZE * input[i]) / 180;
        var y = RADIUS * Math.log(Math.tan((Math.PI * (+input[i + 1] + 90)) / 360));
        if (y > MAX_SAFE_Y) {
            y = MAX_SAFE_Y;
        }
        else if (y < -MAX_SAFE_Y) {
            y = -MAX_SAFE_Y;
        }
        output[i + 1] = y;
    }
    return output;
}
/**
 * Transformation from EPSG:3857 to EPSG:4326.
 *
 * @param {Array<number>} input Input array of coordinate values.
 * @param {Array<number>} [opt_output] Output array of coordinate values.
 * @param {number} [opt_dimension] Dimension (default is `2`).
 * @return {Array<number>} Output array of coordinate values.
 */
function toEPSG4326(input, opt_output, opt_dimension) {
    var length = input.length;
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var output = opt_output;
    if (output === undefined) {
        if (dimension > 2) {
            // preserve values beyond second dimension
            output = input.slice();
        }
        else {
            output = new Array(length);
        }
    }
    for (var i = 0; i < length; i += dimension) {
        output[i] = (180 * input[i]) / HALF_SIZE;
        output[i + 1] =
            (360 * Math.atan(Math.exp(input[i + 1] / RADIUS))) / Math.PI - 90;
    }
    return output;
}
//# sourceMappingURL=epsg3857.js.map

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clamp", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cosh", function() { return cosh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "log2", function() { return log2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "squaredSegmentDistance", function() { return squaredSegmentDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "squaredDistance", function() { return squaredDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "solveLinearSystem", function() { return solveLinearSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toDegrees", function() { return toDegrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toRadians", function() { return toRadians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modulo", function() { return modulo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lerp", function() { return lerp; });
/**
 * @module ol/math
 */
/**
 * Takes a number and clamps it to within the provided bounds.
 * @param {number} value The input number.
 * @param {number} min The minimum value to return.
 * @param {number} max The maximum value to return.
 * @return {number} The input number if it is within bounds, or the nearest
 *     number within the bounds.
 */
function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
}
/**
 * Return the hyperbolic cosine of a given number. The method will use the
 * native `Math.cosh` function if it is available, otherwise the hyperbolic
 * cosine will be calculated via the reference implementation of the Mozilla
 * developer network.
 *
 * @param {number} x X.
 * @return {number} Hyperbolic cosine of x.
 */
var cosh = (function () {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var cosh;
    if ('cosh' in Math) {
        // The environment supports the native Math.cosh function, use it…
        cosh = Math.cosh;
    }
    else {
        // … else, use the reference implementation of MDN:
        cosh = function (x) {
            var y = /** @type {Math} */ (Math).exp(x);
            return (y + 1 / y) / 2;
        };
    }
    return cosh;
})();
/**
 * Return the base 2 logarithm of a given number. The method will use the
 * native `Math.log2` function if it is available, otherwise the base 2
 * logarithm will be calculated via the reference implementation of the
 * Mozilla developer network.
 *
 * @param {number} x X.
 * @return {number} Base 2 logarithm of x.
 */
var log2 = (function () {
    // Wrapped in a iife, to save the overhead of checking for the native
    // implementation on every invocation.
    var log2;
    if ('log2' in Math) {
        // The environment supports the native Math.log2 function, use it…
        log2 = Math.log2;
    }
    else {
        // … else, use the reference implementation of MDN:
        log2 = function (x) {
            return Math.log(x) * Math.LOG2E;
        };
    }
    return log2;
})();
/**
 * Returns the square of the closest distance between the point (x, y) and the
 * line segment (x1, y1) to (x2, y2).
 * @param {number} x X.
 * @param {number} y Y.
 * @param {number} x1 X1.
 * @param {number} y1 Y1.
 * @param {number} x2 X2.
 * @param {number} y2 Y2.
 * @return {number} Squared distance.
 */
function squaredSegmentDistance(x, y, x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    if (dx !== 0 || dy !== 0) {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            x1 = x2;
            y1 = y2;
        }
        else if (t > 0) {
            x1 += dx * t;
            y1 += dy * t;
        }
    }
    return squaredDistance(x, y, x1, y1);
}
/**
 * Returns the square of the distance between the points (x1, y1) and (x2, y2).
 * @param {number} x1 X1.
 * @param {number} y1 Y1.
 * @param {number} x2 X2.
 * @param {number} y2 Y2.
 * @return {number} Squared distance.
 */
function squaredDistance(x1, y1, x2, y2) {
    var dx = x2 - x1;
    var dy = y2 - y1;
    return dx * dx + dy * dy;
}
/**
 * Solves system of linear equations using Gaussian elimination method.
 *
 * @param {Array<Array<number>>} mat Augmented matrix (n x n + 1 column)
 *                                     in row-major order.
 * @return {Array<number>} The resulting vector.
 */
function solveLinearSystem(mat) {
    var n = mat.length;
    for (var i = 0; i < n; i++) {
        // Find max in the i-th column (ignoring i - 1 first rows)
        var maxRow = i;
        var maxEl = Math.abs(mat[i][i]);
        for (var r = i + 1; r < n; r++) {
            var absValue = Math.abs(mat[r][i]);
            if (absValue > maxEl) {
                maxEl = absValue;
                maxRow = r;
            }
        }
        if (maxEl === 0) {
            return null; // matrix is singular
        }
        // Swap max row with i-th (current) row
        var tmp = mat[maxRow];
        mat[maxRow] = mat[i];
        mat[i] = tmp;
        // Subtract the i-th row to make all the remaining rows 0 in the i-th column
        for (var j = i + 1; j < n; j++) {
            var coef = -mat[j][i] / mat[i][i];
            for (var k = i; k < n + 1; k++) {
                if (i == k) {
                    mat[j][k] = 0;
                }
                else {
                    mat[j][k] += coef * mat[i][k];
                }
            }
        }
    }
    // Solve Ax=b for upper triangular matrix A (mat)
    var x = new Array(n);
    for (var l = n - 1; l >= 0; l--) {
        x[l] = mat[l][n] / mat[l][l];
        for (var m = l - 1; m >= 0; m--) {
            mat[m][n] -= mat[m][l] * x[l];
        }
    }
    return x;
}
/**
 * Converts radians to to degrees.
 *
 * @param {number} angleInRadians Angle in radians.
 * @return {number} Angle in degrees.
 */
function toDegrees(angleInRadians) {
    return (angleInRadians * 180) / Math.PI;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} angleInDegrees Angle in degrees.
 * @return {number} Angle in radians.
 */
function toRadians(angleInDegrees) {
    return (angleInDegrees * Math.PI) / 180;
}
/**
 * Returns the modulo of a / b, depending on the sign of b.
 *
 * @param {number} a Dividend.
 * @param {number} b Divisor.
 * @return {number} Modulo.
 */
function modulo(a, b) {
    var r = a % b;
    return r * b < 0 ? r + b : r;
}
/**
 * Calculates the linearly interpolated value of x between a and b.
 *
 * @param {number} a Number
 * @param {number} b Number
 * @param {number} x Value to be interpolated.
 * @return {number} Interpolated value.
 */
function lerp(a, b, x) {
    return a + x * (b - a);
}
//# sourceMappingURL=math.js.map

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RADIUS", function() { return RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EXTENT", function() { return EXTENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "METERS_PER_UNIT", function() { return METERS_PER_UNIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PROJECTIONS", function() { return PROJECTIONS; });
/* harmony import */ var _Projection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/proj/epsg4326
 */


/**
 * Semi-major radius of the WGS84 ellipsoid.
 *
 * @const
 * @type {number}
 */
var RADIUS = 6378137;
/**
 * Extent of the EPSG:4326 projection which is the whole world.
 *
 * @const
 * @type {import("../extent.js").Extent}
 */
var EXTENT = [-180, -90, 180, 90];
/**
 * @const
 * @type {number}
 */
var METERS_PER_UNIT = (Math.PI * RADIUS) / 180;
/**
 * @classdesc
 * Projection object for WGS84 geographic coordinates (EPSG:4326).
 *
 * Note that OpenLayers does not strictly comply with the EPSG definition.
 * The EPSG registry defines 4326 as a CRS for Latitude,Longitude (y,x).
 * OpenLayers treats EPSG:4326 as a pseudo-projection, with x,y coordinates.
 */
var EPSG4326Projection = /** @class */ (function (_super) {
    __extends(EPSG4326Projection, _super);
    /**
     * @param {string} code Code.
     * @param {string} [opt_axisOrientation] Axis orientation.
     */
    function EPSG4326Projection(code, opt_axisOrientation) {
        return _super.call(this, {
            code: code,
            units: _Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES,
            extent: EXTENT,
            axisOrientation: opt_axisOrientation,
            global: true,
            metersPerUnit: METERS_PER_UNIT,
            worldExtent: EXTENT,
        }) || this;
    }
    return EPSG4326Projection;
}(_Projection_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Projections equal to EPSG:4326.
 *
 * @const
 * @type {Array<import("./Projection.js").default>}
 */
var PROJECTIONS = [
    new EPSG4326Projection('CRS:84'),
    new EPSG4326Projection('EPSG:4326', 'neu'),
    new EPSG4326Projection('urn:ogc:def:crs:OGC:1.3:CRS84'),
    new EPSG4326Projection('urn:ogc:def:crs:OGC:2:84'),
    new EPSG4326Projection('http://www.opengis.net/gml/srs/epsg.xml#4326', 'neu'),
];
//# sourceMappingURL=epsg4326.js.map

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clear", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/**
 * @module ol/proj/projections
 */
/**
 * @type {Object<string, import("./Projection.js").default>}
 */
var cache = {};
/**
 * Clear the projections cache.
 */
function clear() {
    cache = {};
}
/**
 * Get a cached projection by code.
 * @param {string} code The code for the projection.
 * @return {import("./Projection.js").default} The projection (if cached).
 */
function get(code) {
    return (cache[code] ||
        cache[code.replace(/urn:(x-)?ogc:def:crs:EPSG:(.*:)?(\w+)$/, 'EPSG:$3')] ||
        null);
}
/**
 * Add a projection to the cache.
 * @param {string} code The projection code.
 * @param {import("./Projection.js").default} projection The projection to cache.
 */
function add(code, projection) {
    cache[code] = projection;
}
//# sourceMappingURL=projections.js.map

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clear", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/**
 * @module ol/proj/transforms
 */

/**
 * @private
 * @type {!Object<string, Object<string, import("../proj.js").TransformFunction>>}
 */
var transforms = {};
/**
 * Clear the transform cache.
 */
function clear() {
    transforms = {};
}
/**
 * Registers a conversion function to convert coordinates from the source
 * projection to the destination projection.
 *
 * @param {import("./Projection.js").default} source Source.
 * @param {import("./Projection.js").default} destination Destination.
 * @param {import("../proj.js").TransformFunction} transformFn Transform.
 */
function add(source, destination, transformFn) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    if (!(sourceCode in transforms)) {
        transforms[sourceCode] = {};
    }
    transforms[sourceCode][destinationCode] = transformFn;
}
/**
 * Unregisters the conversion function to convert coordinates from the source
 * projection to the destination projection.  This method is used to clean up
 * cached transforms during testing.
 *
 * @param {import("./Projection.js").default} source Source projection.
 * @param {import("./Projection.js").default} destination Destination projection.
 * @return {import("../proj.js").TransformFunction} transformFn The unregistered transform.
 */
function remove(source, destination) {
    var sourceCode = source.getCode();
    var destinationCode = destination.getCode();
    var transform = transforms[sourceCode][destinationCode];
    delete transforms[sourceCode][destinationCode];
    if (Object(_obj_js__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(transforms[sourceCode])) {
        delete transforms[sourceCode];
    }
    return transform;
}
/**
 * Get a transform given a source code and a destination code.
 * @param {string} sourceCode The code for the source projection.
 * @param {string} destinationCode The code for the destination projection.
 * @return {import("../proj.js").TransformFunction|undefined} The transform function (if found).
 */
function get(sourceCode, destinationCode) {
    var transform;
    if (sourceCode in transforms && destinationCode in transforms[sourceCode]) {
        transform = transforms[sourceCode][destinationCode];
    }
    return transform;
}
//# sourceMappingURL=transforms.js.map

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clear", function() { return clear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValues", function() { return getValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/**
 * @module ol/obj
 */
/**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */
var assign = typeof Object.assign === 'function'
    ? Object.assign
    : function (target, var_sources) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }
        var output = Object(target);
        for (var i = 1, ii = arguments.length; i < ii; ++i) {
            var source = arguments[i];
            if (source !== undefined && source !== null) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        output[key] = source[key];
                    }
                }
            }
        }
        return output;
    };
/**
 * Removes all properties from an object.
 * @param {Object} object The object to clear.
 */
function clear(object) {
    for (var property in object) {
        delete object[property];
    }
}
/**
 * Polyfill for Object.values().  Get an array of property values from an object.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/values
 *
 * @param {!Object<K,V>} object The object from which to get the values.
 * @return {!Array<V>} The property values.
 * @template K,V
 */
var getValues = typeof Object.values === 'function'
    ? Object.values
    : function (object) {
        var values = [];
        for (var property in object) {
            values.push(object[property]);
        }
        return values;
    };
/**
 * Determine if an object has any properties.
 * @param {Object} object The object to check.
 * @return {boolean} The object is empty.
 */
function isEmpty(object) {
    var property;
    for (property in object) {
        return false;
    }
    return !property;
}
//# sourceMappingURL=obj.js.map

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "boundingExtent", function() { return boundingExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return buffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closestSquaredDistanceXY", function() { return closestSquaredDistanceXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "containsCoordinate", function() { return containsCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "containsExtent", function() { return containsExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "containsXY", function() { return containsXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coordinateRelationship", function() { return coordinateRelationship; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEmpty", function() { return createEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdate", function() { return createOrUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdateEmpty", function() { return createOrUpdateEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdateFromCoordinate", function() { return createOrUpdateFromCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdateFromCoordinates", function() { return createOrUpdateFromCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdateFromFlatCoordinates", function() { return createOrUpdateFromFlatCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdateFromRings", function() { return createOrUpdateFromRings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equals", function() { return equals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "approximatelyEquals", function() { return approximatelyEquals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendCoordinate", function() { return extendCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendCoordinates", function() { return extendCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendFlatCoordinates", function() { return extendFlatCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendRings", function() { return extendRings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extendXY", function() { return extendXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEachCorner", function() { return forEachCorner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArea", function() { return getArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBottomLeft", function() { return getBottomLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBottomRight", function() { return getBottomRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCenter", function() { return getCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCorner", function() { return getCorner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getEnlargedArea", function() { return getEnlargedArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getForViewAndSize", function() { return getForViewAndSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getHeight", function() { return getHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntersectionArea", function() { return getIntersectionArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIntersection", function() { return getIntersection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMargin", function() { return getMargin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSize", function() { return getSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopLeft", function() { return getTopLeft; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTopRight", function() { return getTopRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWidth", function() { return getWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersects", function() { return intersects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "returnOrUpdate", function() { return returnOrUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scaleFromCenter", function() { return scaleFromCenter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsSegment", function() { return intersectsSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyTransform", function() { return applyTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapX", function() { return wrapX; });
/* harmony import */ var _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17);
/* harmony import */ var _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19);
/**
 * @module ol/extent
 */



/**
 * An array of numbers representing an extent: `[minx, miny, maxx, maxy]`.
 * @typedef {Array<number>} Extent
 * @api
 */
/**
 * Build an extent that includes all given coordinates.
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @return {Extent} Bounding extent.
 * @api
 */
function boundingExtent(coordinates) {
    var extent = createEmpty();
    for (var i = 0, ii = coordinates.length; i < ii; ++i) {
        extendCoordinate(extent, coordinates[i]);
    }
    return extent;
}
/**
 * @param {Array<number>} xs Xs.
 * @param {Array<number>} ys Ys.
 * @param {Extent} [opt_extent] Destination extent.
 * @private
 * @return {Extent} Extent.
 */
function _boundingExtentXYs(xs, ys, opt_extent) {
    var minX = Math.min.apply(null, xs);
    var minY = Math.min.apply(null, ys);
    var maxX = Math.max.apply(null, xs);
    var maxY = Math.max.apply(null, ys);
    return createOrUpdate(minX, minY, maxX, maxY, opt_extent);
}
/**
 * Return extent increased by the provided value.
 * @param {Extent} extent Extent.
 * @param {number} value The amount by which the extent should be buffered.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 * @api
 */
function buffer(extent, value, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0] - value;
        opt_extent[1] = extent[1] - value;
        opt_extent[2] = extent[2] + value;
        opt_extent[3] = extent[3] + value;
        return opt_extent;
    }
    else {
        return [
            extent[0] - value,
            extent[1] - value,
            extent[2] + value,
            extent[3] + value,
        ];
    }
}
/**
 * Creates a clone of an extent.
 *
 * @param {Extent} extent Extent to clone.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} The clone.
 */
function clone(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    }
    else {
        return extent.slice();
    }
}
/**
 * @param {Extent} extent Extent.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {number} Closest squared distance.
 */
function closestSquaredDistanceXY(extent, x, y) {
    var dx, dy;
    if (x < extent[0]) {
        dx = extent[0] - x;
    }
    else if (extent[2] < x) {
        dx = x - extent[2];
    }
    else {
        dx = 0;
    }
    if (y < extent[1]) {
        dy = extent[1] - y;
    }
    else if (extent[3] < y) {
        dy = y - extent[3];
    }
    else {
        dy = 0;
    }
    return dx * dx + dy * dy;
}
/**
 * Check if the passed coordinate is contained or on the edge of the extent.
 *
 * @param {Extent} extent Extent.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @return {boolean} The coordinate is contained in the extent.
 * @api
 */
function containsCoordinate(extent, coordinate) {
    return containsXY(extent, coordinate[0], coordinate[1]);
}
/**
 * Check if one extent contains another.
 *
 * An extent is deemed contained if it lies completely within the other extent,
 * including if they share one or more edges.
 *
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {boolean} The second extent is contained by or on the edge of the
 *     first.
 * @api
 */
function containsExtent(extent1, extent2) {
    return (extent1[0] <= extent2[0] &&
        extent2[2] <= extent1[2] &&
        extent1[1] <= extent2[1] &&
        extent2[3] <= extent1[3]);
}
/**
 * Check if the passed coordinate is contained or on the edge of the extent.
 *
 * @param {Extent} extent Extent.
 * @param {number} x X coordinate.
 * @param {number} y Y coordinate.
 * @return {boolean} The x, y values are contained in the extent.
 * @api
 */
function containsXY(extent, x, y) {
    return extent[0] <= x && x <= extent[2] && extent[1] <= y && y <= extent[3];
}
/**
 * Get the relationship between a coordinate and extent.
 * @param {Extent} extent The extent.
 * @param {import("./coordinate.js").Coordinate} coordinate The coordinate.
 * @return {import("./extent/Relationship.js").default} The relationship (bitwise compare with
 *     import("./extent/Relationship.js").Relationship).
 */
function coordinateRelationship(extent, coordinate) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var x = coordinate[0];
    var y = coordinate[1];
    var relationship = _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].UNKNOWN;
    if (x < minX) {
        relationship = relationship | _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].LEFT;
    }
    else if (x > maxX) {
        relationship = relationship | _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].RIGHT;
    }
    if (y < minY) {
        relationship = relationship | _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].BELOW;
    }
    else if (y > maxY) {
        relationship = relationship | _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].ABOVE;
    }
    if (relationship === _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].UNKNOWN) {
        relationship = _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].INTERSECTING;
    }
    return relationship;
}
/**
 * Create an empty extent.
 * @return {Extent} Empty extent.
 * @api
 */
function createEmpty() {
    return [Infinity, Infinity, -Infinity, -Infinity];
}
/**
 * Create a new extent or update the provided extent.
 * @param {number} minX Minimum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxX Maximum X.
 * @param {number} maxY Maximum Y.
 * @param {Extent} [opt_extent] Destination extent.
 * @return {Extent} Extent.
 */
function createOrUpdate(minX, minY, maxX, maxY, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = minX;
        opt_extent[1] = minY;
        opt_extent[2] = maxX;
        opt_extent[3] = maxY;
        return opt_extent;
    }
    else {
        return [minX, minY, maxX, maxY];
    }
}
/**
 * Create a new empty extent or make the provided one empty.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function createOrUpdateEmpty(opt_extent) {
    return createOrUpdate(Infinity, Infinity, -Infinity, -Infinity, opt_extent);
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function createOrUpdateFromCoordinate(coordinate, opt_extent) {
    var x = coordinate[0];
    var y = coordinate[1];
    return createOrUpdate(x, y, x, y, opt_extent);
}
/**
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function createOrUpdateFromCoordinates(coordinates, opt_extent) {
    var extent = createOrUpdateEmpty(opt_extent);
    return extendCoordinates(extent, coordinates);
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function createOrUpdateFromFlatCoordinates(flatCoordinates, offset, end, stride, opt_extent) {
    var extent = createOrUpdateEmpty(opt_extent);
    return extendFlatCoordinates(extent, flatCoordinates, offset, end, stride);
}
/**
 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function createOrUpdateFromRings(rings, opt_extent) {
    var extent = createOrUpdateEmpty(opt_extent);
    return extendRings(extent, rings);
}
/**
 * Determine if two extents are equivalent.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {boolean} The two extents are equivalent.
 * @api
 */
function equals(extent1, extent2) {
    return (extent1[0] == extent2[0] &&
        extent1[2] == extent2[2] &&
        extent1[1] == extent2[1] &&
        extent1[3] == extent2[3]);
}
/**
 * Determine if two extents are approximately equivalent.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @param {number} tolerance Tolerance in extent coordinate units.
 * @return {boolean} The two extents differ by less than the tolerance.
 */
function approximatelyEquals(extent1, extent2, tolerance) {
    return (Math.abs(extent1[0] - extent2[0]) < tolerance &&
        Math.abs(extent1[2] - extent2[2]) < tolerance &&
        Math.abs(extent1[1] - extent2[1]) < tolerance &&
        Math.abs(extent1[3] - extent2[3]) < tolerance);
}
/**
 * Modify an extent to include another extent.
 * @param {Extent} extent1 The extent to be modified.
 * @param {Extent} extent2 The extent that will be included in the first.
 * @return {Extent} A reference to the first (extended) extent.
 * @api
 */
function extend(extent1, extent2) {
    if (extent2[0] < extent1[0]) {
        extent1[0] = extent2[0];
    }
    if (extent2[2] > extent1[2]) {
        extent1[2] = extent2[2];
    }
    if (extent2[1] < extent1[1]) {
        extent1[1] = extent2[1];
    }
    if (extent2[3] > extent1[3]) {
        extent1[3] = extent2[3];
    }
    return extent1;
}
/**
 * @param {Extent} extent Extent.
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 */
function extendCoordinate(extent, coordinate) {
    if (coordinate[0] < extent[0]) {
        extent[0] = coordinate[0];
    }
    if (coordinate[0] > extent[2]) {
        extent[2] = coordinate[0];
    }
    if (coordinate[1] < extent[1]) {
        extent[1] = coordinate[1];
    }
    if (coordinate[1] > extent[3]) {
        extent[3] = coordinate[1];
    }
}
/**
 * @param {Extent} extent Extent.
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates Coordinates.
 * @return {Extent} Extent.
 */
function extendCoordinates(extent, coordinates) {
    for (var i = 0, ii = coordinates.length; i < ii; ++i) {
        extendCoordinate(extent, coordinates[i]);
    }
    return extent;
}
/**
 * @param {Extent} extent Extent.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Extent} Extent.
 */
function extendFlatCoordinates(extent, flatCoordinates, offset, end, stride) {
    for (; offset < end; offset += stride) {
        extendXY(extent, flatCoordinates[offset], flatCoordinates[offset + 1]);
    }
    return extent;
}
/**
 * @param {Extent} extent Extent.
 * @param {Array<Array<import("./coordinate.js").Coordinate>>} rings Rings.
 * @return {Extent} Extent.
 */
function extendRings(extent, rings) {
    for (var i = 0, ii = rings.length; i < ii; ++i) {
        extendCoordinates(extent, rings[i]);
    }
    return extent;
}
/**
 * @param {Extent} extent Extent.
 * @param {number} x X.
 * @param {number} y Y.
 */
function extendXY(extent, x, y) {
    extent[0] = Math.min(extent[0], x);
    extent[1] = Math.min(extent[1], y);
    extent[2] = Math.max(extent[2], x);
    extent[3] = Math.max(extent[3], y);
}
/**
 * This function calls `callback` for each corner of the extent. If the
 * callback returns a truthy value the function returns that value
 * immediately. Otherwise the function returns `false`.
 * @param {Extent} extent Extent.
 * @param {function(import("./coordinate.js").Coordinate): S} callback Callback.
 * @return {S|boolean} Value.
 * @template S
 */
function forEachCorner(extent, callback) {
    var val;
    val = callback(getBottomLeft(extent));
    if (val) {
        return val;
    }
    val = callback(getBottomRight(extent));
    if (val) {
        return val;
    }
    val = callback(getTopRight(extent));
    if (val) {
        return val;
    }
    val = callback(getTopLeft(extent));
    if (val) {
        return val;
    }
    return false;
}
/**
 * Get the size of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Area.
 * @api
 */
function getArea(extent) {
    var area = 0;
    if (!isEmpty(extent)) {
        area = getWidth(extent) * getHeight(extent);
    }
    return area;
}
/**
 * Get the bottom left coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Bottom left coordinate.
 * @api
 */
function getBottomLeft(extent) {
    return [extent[0], extent[1]];
}
/**
 * Get the bottom right coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Bottom right coordinate.
 * @api
 */
function getBottomRight(extent) {
    return [extent[2], extent[1]];
}
/**
 * Get the center coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Center.
 * @api
 */
function getCenter(extent) {
    return [(extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2];
}
/**
 * Get a corner coordinate of an extent.
 * @param {Extent} extent Extent.
 * @param {import("./extent/Corner.js").default} corner Corner.
 * @return {import("./coordinate.js").Coordinate} Corner coordinate.
 */
function getCorner(extent, corner) {
    var coordinate;
    if (corner === _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__["default"].BOTTOM_LEFT) {
        coordinate = getBottomLeft(extent);
    }
    else if (corner === _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__["default"].BOTTOM_RIGHT) {
        coordinate = getBottomRight(extent);
    }
    else if (corner === _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__["default"].TOP_LEFT) {
        coordinate = getTopLeft(extent);
    }
    else if (corner === _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__["default"].TOP_RIGHT) {
        coordinate = getTopRight(extent);
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])(false, 13); // Invalid corner
    }
    return coordinate;
}
/**
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {number} Enlarged area.
 */
function getEnlargedArea(extent1, extent2) {
    var minX = Math.min(extent1[0], extent2[0]);
    var minY = Math.min(extent1[1], extent2[1]);
    var maxX = Math.max(extent1[2], extent2[2]);
    var maxY = Math.max(extent1[3], extent2[3]);
    return (maxX - minX) * (maxY - minY);
}
/**
 * @param {import("./coordinate.js").Coordinate} center Center.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @param {import("./size.js").Size} size Size.
 * @param {Extent} [opt_extent] Destination extent.
 * @return {Extent} Extent.
 */
function getForViewAndSize(center, resolution, rotation, size, opt_extent) {
    var dx = (resolution * size[0]) / 2;
    var dy = (resolution * size[1]) / 2;
    var cosRotation = Math.cos(rotation);
    var sinRotation = Math.sin(rotation);
    var xCos = dx * cosRotation;
    var xSin = dx * sinRotation;
    var yCos = dy * cosRotation;
    var ySin = dy * sinRotation;
    var x = center[0];
    var y = center[1];
    var x0 = x - xCos + ySin;
    var x1 = x - xCos - ySin;
    var x2 = x + xCos - ySin;
    var x3 = x + xCos + ySin;
    var y0 = y - xSin - yCos;
    var y1 = y - xSin + yCos;
    var y2 = y + xSin + yCos;
    var y3 = y + xSin - yCos;
    return createOrUpdate(Math.min(x0, x1, x2, x3), Math.min(y0, y1, y2, y3), Math.max(x0, x1, x2, x3), Math.max(y0, y1, y2, y3), opt_extent);
}
/**
 * Get the height of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Height.
 * @api
 */
function getHeight(extent) {
    return extent[3] - extent[1];
}
/**
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @return {number} Intersection area.
 */
function getIntersectionArea(extent1, extent2) {
    var intersection = getIntersection(extent1, extent2);
    return getArea(intersection);
}
/**
 * Get the intersection of two extents.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent 2.
 * @param {Extent} [opt_extent] Optional extent to populate with intersection.
 * @return {Extent} Intersecting extent.
 * @api
 */
function getIntersection(extent1, extent2, opt_extent) {
    var intersection = opt_extent ? opt_extent : createEmpty();
    if (intersects(extent1, extent2)) {
        if (extent1[0] > extent2[0]) {
            intersection[0] = extent1[0];
        }
        else {
            intersection[0] = extent2[0];
        }
        if (extent1[1] > extent2[1]) {
            intersection[1] = extent1[1];
        }
        else {
            intersection[1] = extent2[1];
        }
        if (extent1[2] < extent2[2]) {
            intersection[2] = extent1[2];
        }
        else {
            intersection[2] = extent2[2];
        }
        if (extent1[3] < extent2[3]) {
            intersection[3] = extent1[3];
        }
        else {
            intersection[3] = extent2[3];
        }
    }
    else {
        createOrUpdateEmpty(intersection);
    }
    return intersection;
}
/**
 * @param {Extent} extent Extent.
 * @return {number} Margin.
 */
function getMargin(extent) {
    return getWidth(extent) + getHeight(extent);
}
/**
 * Get the size (width, height) of an extent.
 * @param {Extent} extent The extent.
 * @return {import("./size.js").Size} The extent size.
 * @api
 */
function getSize(extent) {
    return [extent[2] - extent[0], extent[3] - extent[1]];
}
/**
 * Get the top left coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Top left coordinate.
 * @api
 */
function getTopLeft(extent) {
    return [extent[0], extent[3]];
}
/**
 * Get the top right coordinate of an extent.
 * @param {Extent} extent Extent.
 * @return {import("./coordinate.js").Coordinate} Top right coordinate.
 * @api
 */
function getTopRight(extent) {
    return [extent[2], extent[3]];
}
/**
 * Get the width of an extent.
 * @param {Extent} extent Extent.
 * @return {number} Width.
 * @api
 */
function getWidth(extent) {
    return extent[2] - extent[0];
}
/**
 * Determine if one extent intersects another.
 * @param {Extent} extent1 Extent 1.
 * @param {Extent} extent2 Extent.
 * @return {boolean} The two extents intersect.
 * @api
 */
function intersects(extent1, extent2) {
    return (extent1[0] <= extent2[2] &&
        extent1[2] >= extent2[0] &&
        extent1[1] <= extent2[3] &&
        extent1[3] >= extent2[1]);
}
/**
 * Determine if an extent is empty.
 * @param {Extent} extent Extent.
 * @return {boolean} Is empty.
 * @api
 */
function isEmpty(extent) {
    return extent[2] < extent[0] || extent[3] < extent[1];
}
/**
 * @param {Extent} extent Extent.
 * @param {Extent} [opt_extent] Extent.
 * @return {Extent} Extent.
 */
function returnOrUpdate(extent, opt_extent) {
    if (opt_extent) {
        opt_extent[0] = extent[0];
        opt_extent[1] = extent[1];
        opt_extent[2] = extent[2];
        opt_extent[3] = extent[3];
        return opt_extent;
    }
    else {
        return extent;
    }
}
/**
 * @param {Extent} extent Extent.
 * @param {number} value Value.
 */
function scaleFromCenter(extent, value) {
    var deltaX = ((extent[2] - extent[0]) / 2) * (value - 1);
    var deltaY = ((extent[3] - extent[1]) / 2) * (value - 1);
    extent[0] -= deltaX;
    extent[2] += deltaX;
    extent[1] -= deltaY;
    extent[3] += deltaY;
}
/**
 * Determine if the segment between two coordinates intersects (crosses,
 * touches, or is contained by) the provided extent.
 * @param {Extent} extent The extent.
 * @param {import("./coordinate.js").Coordinate} start Segment start coordinate.
 * @param {import("./coordinate.js").Coordinate} end Segment end coordinate.
 * @return {boolean} The segment intersects the extent.
 */
function intersectsSegment(extent, start, end) {
    var intersects = false;
    var startRel = coordinateRelationship(extent, start);
    var endRel = coordinateRelationship(extent, end);
    if (startRel === _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].INTERSECTING ||
        endRel === _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].INTERSECTING) {
        intersects = true;
    }
    else {
        var minX = extent[0];
        var minY = extent[1];
        var maxX = extent[2];
        var maxY = extent[3];
        var startX = start[0];
        var startY = start[1];
        var endX = end[0];
        var endY = end[1];
        var slope = (endY - startY) / (endX - startX);
        var x = void 0, y = void 0;
        if (!!(endRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].ABOVE) && !(startRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].ABOVE)) {
            // potentially intersects top
            x = endX - (endY - maxY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects &&
            !!(endRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].RIGHT) &&
            !(startRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].RIGHT)) {
            // potentially intersects right
            y = endY - (endX - maxX) * slope;
            intersects = y >= minY && y <= maxY;
        }
        if (!intersects &&
            !!(endRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].BELOW) &&
            !(startRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].BELOW)) {
            // potentially intersects bottom
            x = endX - (endY - minY) / slope;
            intersects = x >= minX && x <= maxX;
        }
        if (!intersects &&
            !!(endRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].LEFT) &&
            !(startRel & _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_1__["default"].LEFT)) {
            // potentially intersects left
            y = endY - (endX - minX) * slope;
            intersects = y >= minY && y <= maxY;
        }
    }
    return intersects;
}
/**
 * Apply a transform function to the extent.
 * @param {Extent} extent Extent.
 * @param {import("./proj.js").TransformFunction} transformFn Transform function.
 * Called with `[minX, minY, maxX, maxY]` extent coordinates.
 * @param {Extent} [opt_extent] Destination extent.
 * @param {number} [opt_stops] Number of stops per side used for the transform.
 * By default only the corners are used.
 * @return {Extent} Extent.
 * @api
 */
function applyTransform(extent, transformFn, opt_extent, opt_stops) {
    var coordinates = [];
    if (opt_stops > 1) {
        var width = extent[2] - extent[0];
        var height = extent[3] - extent[1];
        for (var i = 0; i < opt_stops; ++i) {
            coordinates.push(extent[0] + (width * i) / opt_stops, extent[1], extent[2], extent[1] + (height * i) / opt_stops, extent[2] - (width * i) / opt_stops, extent[3], extent[0], extent[3] - (height * i) / opt_stops);
        }
    }
    else {
        coordinates = [
            extent[0],
            extent[1],
            extent[2],
            extent[1],
            extent[2],
            extent[3],
            extent[0],
            extent[3],
        ];
    }
    transformFn(coordinates, coordinates, 2);
    var xs = [];
    var ys = [];
    for (var i = 0, l = coordinates.length; i < l; i += 2) {
        xs.push(coordinates[i]);
        ys.push(coordinates[i + 1]);
    }
    return _boundingExtentXYs(xs, ys, opt_extent);
}
/**
 * Modifies the provided extent in-place to be within the real world
 * extent.
 *
 * @param {Extent} extent Extent.
 * @param {import("./proj/Projection.js").default} projection Projection
 * @return {Extent} The extent within the real world extent.
 */
function wrapX(extent, projection) {
    var projectionExtent = projection.getExtent();
    var center = getCenter(extent);
    if (projection.canWrapX() &&
        (center[0] < projectionExtent[0] || center[0] >= projectionExtent[2])) {
        var worldWidth = getWidth(projectionExtent);
        var worldsAway = Math.floor((center[0] - projectionExtent[0]) / worldWidth);
        var offset = worldsAway * worldWidth;
        extent[0] -= offset;
        extent[2] -= offset;
    }
    return extent;
}
//# sourceMappingURL=extent.js.map

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/extent/Corner
 */
/**
 * Extent corner.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
});
//# sourceMappingURL=Corner.js.map

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/extent/Relationship
 */
/**
 * Relationship to an extent.
 * @enum {number}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    UNKNOWN: 0,
    INTERSECTING: 1,
    ABOVE: 2,
    RIGHT: 4,
    BELOW: 8,
    LEFT: 16,
});
//# sourceMappingURL=Relationship.js.map

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assert", function() { return assert; });
/* harmony import */ var _AssertionError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20);
/**
 * @module ol/asserts
 */

/**
 * @param {*} assertion Assertion we expected to be truthy.
 * @param {number} errorCode Error code.
 */
function assert(assertion, errorCode) {
    if (!assertion) {
        throw new _AssertionError_js__WEBPACK_IMPORTED_MODULE_0__["default"](errorCode);
    }
}
//# sourceMappingURL=asserts.js.map

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/AssertionError
 */

/**
 * Error object thrown when an assertion failed. This is an ECMA-262 Error,
 * extended with a `code` property.
 * See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error.
 */
var AssertionError = /** @class */ (function (_super) {
    __extends(AssertionError, _super);
    /**
     * @param {number} code Error code.
     */
    function AssertionError(code) {
        var _this = this;
        var path = _util_js__WEBPACK_IMPORTED_MODULE_0__["VERSION"] === 'latest' ? _util_js__WEBPACK_IMPORTED_MODULE_0__["VERSION"] : 'v' + _util_js__WEBPACK_IMPORTED_MODULE_0__["VERSION"].split('-')[0];
        var message = 'Assertion failed. See https://openlayers.org/en/' +
            path +
            '/doc/errors/#' +
            code +
            ' for details.';
        _this = _super.call(this, message) || this;
        /**
         * Error code. The meaning of the code can be found on
         * https://openlayers.org/en/latest/doc/errors/ (replace `latest` with
         * the version found in the OpenLayers script's header comment if a version
         * other than the latest is used).
         * @type {number}
         * @api
         */
        _this.code = code;
        /**
         * @type {string}
         */
        _this.name = 'AssertionError';
        // Re-assign message, see https://github.com/Rich-Harris/buble/issues/40
        _this.message = message;
        return _this;
    }
    return AssertionError;
}(Error));
/* harmony default export */ __webpack_exports__["default"] = (AssertionError);
//# sourceMappingURL=AssertionError.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "abstract", function() { return abstract; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUid", function() { return getUid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return VERSION; });
/**
 * @module ol/util
 */
/**
 * @return {?} Any return.
 */
function abstract() {
    return /** @type {?} */ ((function () {
        throw new Error('Unimplemented abstract method.');
    })());
}
/**
 * Counter for getUid.
 * @type {number}
 * @private
 */
var uidCounter_ = 0;
/**
 * Gets a unique ID for an object. This mutates the object so that further calls
 * with the same object as a parameter returns the same value. Unique IDs are generated
 * as a strictly increasing sequence. Adapted from goog.getUid.
 *
 * @param {Object} obj The object to get the unique ID for.
 * @return {string} The unique ID for the object.
 * @api
 */
function getUid(obj) {
    return obj.ol_uid || (obj.ol_uid = String(++uidCounter_));
}
/**
 * OpenLayers version.
 * @type {string}
 */
var VERSION = '6.6.0';
//# sourceMappingURL=util.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_RADIUS", function() { return DEFAULT_RADIUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDistance", function() { return getDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLength", function() { return getLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArea", function() { return getArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "offset", function() { return offset; });
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/**
 * @module ol/sphere
 */


/**
 * Object literal with options for the {@link getLength} or {@link getArea}
 * functions.
 * @typedef {Object} SphereMetricOptions
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857']
 * Projection of the  geometry.  By default, the geometry is assumed to be in
 * Web Mercator.
 * @property {number} [radius=6371008.8] Sphere radius.  By default, the
 * [mean Earth radius](https://en.wikipedia.org/wiki/Earth_radius#Mean_radius)
 * for the WGS84 ellipsoid is used.
 */
/**
 * The mean Earth radius (1/3 * (2a + b)) for the WGS84 ellipsoid.
 * https://en.wikipedia.org/wiki/Earth_radius#Mean_radius
 * @type {number}
 */
var DEFAULT_RADIUS = 6371008.8;
/**
 * Get the great circle distance (in meters) between two geographic coordinates.
 * @param {Array} c1 Starting coordinate.
 * @param {Array} c2 Ending coordinate.
 * @param {number} [opt_radius] The sphere radius to use.  Defaults to the Earth's
 *     mean radius using the WGS84 ellipsoid.
 * @return {number} The great circle distance between the points (in meters).
 * @api
 */
function getDistance(c1, c2, opt_radius) {
    var radius = opt_radius || DEFAULT_RADIUS;
    var lat1 = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(c1[1]);
    var lat2 = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(c2[1]);
    var deltaLatBy2 = (lat2 - lat1) / 2;
    var deltaLonBy2 = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(c2[0] - c1[0]) / 2;
    var a = Math.sin(deltaLatBy2) * Math.sin(deltaLatBy2) +
        Math.sin(deltaLonBy2) *
            Math.sin(deltaLonBy2) *
            Math.cos(lat1) *
            Math.cos(lat2);
    return 2 * radius * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}
/**
 * Get the cumulative great circle length of linestring coordinates (geographic).
 * @param {Array} coordinates Linestring coordinates.
 * @param {number} radius The sphere radius to use.
 * @return {number} The length (in meters).
 */
function getLengthInternal(coordinates, radius) {
    var length = 0;
    for (var i = 0, ii = coordinates.length; i < ii - 1; ++i) {
        length += getDistance(coordinates[i], coordinates[i + 1], radius);
    }
    return length;
}
/**
 * Get the spherical length of a geometry.  This length is the sum of the
 * great circle distances between coordinates.  For polygons, the length is
 * the sum of all rings.  For points, the length is zero.  For multi-part
 * geometries, the length is the sum of the length of each part.
 * @param {import("./geom/Geometry.js").default} geometry A geometry.
 * @param {SphereMetricOptions} [opt_options] Options for the
 * length calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
 * You can change this by providing a `projection` option.
 * @return {number} The spherical length (in meters).
 * @api
 */
function getLength(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || DEFAULT_RADIUS;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION) {
        geometry = geometry.clone().transform(projection, 'EPSG:4326');
    }
    var length = 0;
    var coordinates, coords, i, ii, j, jj;
    switch (type) {
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POINT:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POINT: {
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINEAR_RING: {
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
            length = getLengthInternal(coordinates, radius);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_LINE_STRING:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON: {
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
            for (i = 0, ii = coordinates.length; i < ii; ++i) {
                length += getLengthInternal(coordinates[i], radius);
            }
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POLYGON: {
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
            for (i = 0, ii = coordinates.length; i < ii; ++i) {
                coords = coordinates[i];
                for (j = 0, jj = coords.length; j < jj; ++j) {
                    length += getLengthInternal(coords[j], radius);
                }
            }
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION: {
            var geometries = 
            /** @type {import("./geom/GeometryCollection.js").default} */ (geometry).getGeometries();
            for (i = 0, ii = geometries.length; i < ii; ++i) {
                length += getLength(geometries[i], opt_options);
            }
            break;
        }
        default: {
            throw new Error('Unsupported geometry type: ' + type);
        }
    }
    return length;
}
/**
 * Returns the spherical area for a list of coordinates.
 *
 * [Reference](https://trs.jpl.nasa.gov/handle/2014/40409)
 * Robert. G. Chamberlain and William H. Duquette, "Some Algorithms for
 * Polygons on a Sphere", JPL Publication 07-03, Jet Propulsion
 * Laboratory, Pasadena, CA, June 2007
 *
 * @param {Array<import("./coordinate.js").Coordinate>} coordinates List of coordinates of a linear
 * ring. If the ring is oriented clockwise, the area will be positive,
 * otherwise it will be negative.
 * @param {number} radius The sphere radius.
 * @return {number} Area (in square meters).
 */
function getAreaInternal(coordinates, radius) {
    var area = 0;
    var len = coordinates.length;
    var x1 = coordinates[len - 1][0];
    var y1 = coordinates[len - 1][1];
    for (var i = 0; i < len; i++) {
        var x2 = coordinates[i][0];
        var y2 = coordinates[i][1];
        area +=
            Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(x2 - x1) *
                (2 + Math.sin(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(y1)) + Math.sin(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(y2)));
        x1 = x2;
        y1 = y2;
    }
    return (area * radius * radius) / 2.0;
}
/**
 * Get the spherical area of a geometry.  This is the area (in meters) assuming
 * that polygon edges are segments of great circles on a sphere.
 * @param {import("./geom/Geometry.js").default} geometry A geometry.
 * @param {SphereMetricOptions} [opt_options] Options for the area
 *     calculation.  By default, geometries are assumed to be in 'EPSG:3857'.
 *     You can change this by providing a `projection` option.
 * @return {number} The spherical area (in square meters).
 * @api
 */
function getArea(geometry, opt_options) {
    var options = opt_options || {};
    var radius = options.radius || DEFAULT_RADIUS;
    var projection = options.projection || 'EPSG:3857';
    var type = geometry.getType();
    if (type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION) {
        geometry = geometry.clone().transform(projection, 'EPSG:4326');
    }
    var area = 0;
    var coordinates, coords, i, ii, j, jj;
    switch (type) {
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POINT:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POINT:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_LINE_STRING:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINEAR_RING: {
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON: {
            coordinates = /** @type {import("./geom/Polygon.js").default} */ (geometry).getCoordinates();
            area = Math.abs(getAreaInternal(coordinates[0], radius));
            for (i = 1, ii = coordinates.length; i < ii; ++i) {
                area -= Math.abs(getAreaInternal(coordinates[i], radius));
            }
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POLYGON: {
            coordinates = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometry).getCoordinates();
            for (i = 0, ii = coordinates.length; i < ii; ++i) {
                coords = coordinates[i];
                area += Math.abs(getAreaInternal(coords[0], radius));
                for (j = 1, jj = coords.length; j < jj; ++j) {
                    area -= Math.abs(getAreaInternal(coords[j], radius));
                }
            }
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION: {
            var geometries = 
            /** @type {import("./geom/GeometryCollection.js").default} */ (geometry).getGeometries();
            for (i = 0, ii = geometries.length; i < ii; ++i) {
                area += getArea(geometries[i], opt_options);
            }
            break;
        }
        default: {
            throw new Error('Unsupported geometry type: ' + type);
        }
    }
    return area;
}
/**
 * Returns the coordinate at the given distance and bearing from `c1`.
 *
 * @param {import("./coordinate.js").Coordinate} c1 The origin point (`[lon, lat]` in degrees).
 * @param {number} distance The great-circle distance between the origin
 *     point and the target point.
 * @param {number} bearing The bearing (in radians).
 * @param {number} [opt_radius] The sphere radius to use.  Defaults to the Earth's
 *     mean radius using the WGS84 ellipsoid.
 * @return {import("./coordinate.js").Coordinate} The target point.
 */
function offset(c1, distance, bearing, opt_radius) {
    var radius = opt_radius || DEFAULT_RADIUS;
    var lat1 = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(c1[1]);
    var lon1 = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(c1[0]);
    var dByR = distance / radius;
    var lat = Math.asin(Math.sin(lat1) * Math.cos(dByR) +
        Math.cos(lat1) * Math.sin(dByR) * Math.cos(bearing));
    var lon = lon1 +
        Math.atan2(Math.sin(bearing) * Math.sin(dByR) * Math.cos(lat1), Math.cos(dByR) - Math.sin(lat1) * Math.sin(lat));
    return [Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toDegrees"])(lon), Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toDegrees"])(lat)];
}
//# sourceMappingURL=sphere.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/geom/GeometryType
 */
/**
 * The geometry type. One of `'Point'`, `'LineString'`, `'LinearRing'`,
 * `'Polygon'`, `'MultiPoint'`, `'MultiLineString'`, `'MultiPolygon'`,
 * `'GeometryCollection'`, `'Circle'`.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    POINT: 'Point',
    LINE_STRING: 'LineString',
    LINEAR_RING: 'LinearRing',
    POLYGON: 'Polygon',
    MULTI_POINT: 'MultiPoint',
    MULTI_LINE_STRING: 'MultiLineString',
    MULTI_POLYGON: 'MultiPolygon',
    GEOMETRY_COLLECTION: 'GeometryCollection',
    CIRCLE: 'Circle',
});
//# sourceMappingURL=GeometryType.js.map

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "add", function() { return add; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closestOnCircle", function() { return closestOnCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closestOnSegment", function() { return closestOnSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStringXY", function() { return createStringXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "degreesToStringHDMS", function() { return degreesToStringHDMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equals", function() { return equals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rotate", function() { return rotate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scale", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "squaredDistance", function() { return squaredDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "distance", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "squaredDistanceToSegment", function() { return squaredDistanceToSegment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toStringHDMS", function() { return toStringHDMS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toStringXY", function() { return toStringXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapX", function() { return wrapX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getWorldsAway", function() { return getWorldsAway; });
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25);
/**
 * @module ol/coordinate
 */



/**
 * An array of numbers representing an xy coordinate. Example: `[16, 48]`.
 * @typedef {Array<number>} Coordinate
 * @api
 */
/**
 * A function that takes a {@link module:ol/coordinate~Coordinate} and
 * transforms it into a `{string}`.
 *
 * @typedef {function((Coordinate|undefined)): string} CoordinateFormat
 * @api
 */
/**
 * Add `delta` to `coordinate`. `coordinate` is modified in place and returned
 * by the function.
 *
 * Example:
 *
 *     import {add} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     add(coord, [-2, 4]);
 *     // coord is now [5.85, 51.983333]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {Coordinate} delta Delta.
 * @return {Coordinate} The input coordinate adjusted by
 * the given delta.
 * @api
 */
function add(coordinate, delta) {
    coordinate[0] += +delta[0];
    coordinate[1] += +delta[1];
    return coordinate;
}
/**
 * Calculates the point closest to the passed coordinate on the passed circle.
 *
 * @param {Coordinate} coordinate The coordinate.
 * @param {import("./geom/Circle.js").default} circle The circle.
 * @return {Coordinate} Closest point on the circumference.
 */
function closestOnCircle(coordinate, circle) {
    var r = circle.getRadius();
    var center = circle.getCenter();
    var x0 = center[0];
    var y0 = center[1];
    var x1 = coordinate[0];
    var y1 = coordinate[1];
    var dx = x1 - x0;
    var dy = y1 - y0;
    if (dx === 0 && dy === 0) {
        dx = 1;
    }
    var d = Math.sqrt(dx * dx + dy * dy);
    var x = x0 + (r * dx) / d;
    var y = y0 + (r * dy) / d;
    return [x, y];
}
/**
 * Calculates the point closest to the passed coordinate on the passed segment.
 * This is the foot of the perpendicular of the coordinate to the segment when
 * the foot is on the segment, or the closest segment coordinate when the foot
 * is outside the segment.
 *
 * @param {Coordinate} coordinate The coordinate.
 * @param {Array<Coordinate>} segment The two coordinates
 * of the segment.
 * @return {Coordinate} The foot of the perpendicular of
 * the coordinate to the segment.
 */
function closestOnSegment(coordinate, segment) {
    var x0 = coordinate[0];
    var y0 = coordinate[1];
    var start = segment[0];
    var end = segment[1];
    var x1 = start[0];
    var y1 = start[1];
    var x2 = end[0];
    var y2 = end[1];
    var dx = x2 - x1;
    var dy = y2 - y1;
    var along = dx === 0 && dy === 0
        ? 0
        : (dx * (x0 - x1) + dy * (y0 - y1)) / (dx * dx + dy * dy || 0);
    var x, y;
    if (along <= 0) {
        x = x1;
        y = y1;
    }
    else if (along >= 1) {
        x = x2;
        y = y2;
    }
    else {
        x = x1 + along * dx;
        y = y1 + along * dy;
    }
    return [x, y];
}
/**
 * Returns a {@link module:ol/coordinate~CoordinateFormat} function that can be
 * used to format
 * a {Coordinate} to a string.
 *
 * Example without specifying the fractional digits:
 *
 *     import {createStringXY} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var stringifyFunc = createStringXY();
 *     var out = stringifyFunc(coord);
 *     // out is now '8, 48'
 *
 * Example with explicitly specifying 2 fractional digits:
 *
 *     import {createStringXY} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var stringifyFunc = createStringXY(2);
 *     var out = stringifyFunc(coord);
 *     // out is now '7.85, 47.98'
 *
 * @param {number} [opt_fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {CoordinateFormat} Coordinate format.
 * @api
 */
function createStringXY(opt_fractionDigits) {
    return (
    /**
     * @param {Coordinate} coordinate Coordinate.
     * @return {string} String XY.
     */
    function (coordinate) {
        return toStringXY(coordinate, opt_fractionDigits);
    });
}
/**
 * @param {string} hemispheres Hemispheres.
 * @param {number} degrees Degrees.
 * @param {number} [opt_fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} String.
 */
function degreesToStringHDMS(hemispheres, degrees, opt_fractionDigits) {
    var normalizedDegrees = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["modulo"])(degrees + 180, 360) - 180;
    var x = Math.abs(3600 * normalizedDegrees);
    var dflPrecision = opt_fractionDigits || 0;
    var precision = Math.pow(10, dflPrecision);
    var deg = Math.floor(x / 3600);
    var min = Math.floor((x - deg * 3600) / 60);
    var sec = x - deg * 3600 - min * 60;
    sec = Math.ceil(sec * precision) / precision;
    if (sec >= 60) {
        sec = 0;
        min += 1;
    }
    if (min >= 60) {
        min = 0;
        deg += 1;
    }
    return (deg +
        '\u00b0 ' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_2__["padNumber"])(min, 2) +
        '\u2032 ' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_2__["padNumber"])(sec, 2, dflPrecision) +
        '\u2033' +
        (normalizedDegrees == 0
            ? ''
            : ' ' + hemispheres.charAt(normalizedDegrees < 0 ? 1 : 0)));
}
/**
 * Transforms the given {@link module:ol/coordinate~Coordinate} to a string
 * using the given string template. The strings `{x}` and `{y}` in the template
 * will be replaced with the first and second coordinate values respectively.
 *
 * Example without specifying the fractional digits:
 *
 *     import {format} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var template = 'Coordinate is ({x}|{y}).';
 *     var out = format(coord, template);
 *     // out is now 'Coordinate is (8|48).'
 *
 * Example explicitly specifying the fractional digits:
 *
 *     import {format} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var template = 'Coordinate is ({x}|{y}).';
 *     var out = format(coord, template, 2);
 *     // out is now 'Coordinate is (7.85|47.98).'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {string} template A template string with `{x}` and `{y}` placeholders
 *     that will be replaced by first and second coordinate values.
 * @param {number} [opt_fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} Formatted coordinate.
 * @api
 */
function format(coordinate, template, opt_fractionDigits) {
    if (coordinate) {
        return template
            .replace('{x}', coordinate[0].toFixed(opt_fractionDigits))
            .replace('{y}', coordinate[1].toFixed(opt_fractionDigits));
    }
    else {
        return '';
    }
}
/**
 * @param {Coordinate} coordinate1 First coordinate.
 * @param {Coordinate} coordinate2 Second coordinate.
 * @return {boolean} The two coordinates are equal.
 */
function equals(coordinate1, coordinate2) {
    var equals = true;
    for (var i = coordinate1.length - 1; i >= 0; --i) {
        if (coordinate1[i] != coordinate2[i]) {
            equals = false;
            break;
        }
    }
    return equals;
}
/**
 * Rotate `coordinate` by `angle`. `coordinate` is modified in place and
 * returned by the function.
 *
 * Example:
 *
 *     import {rotate} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var rotateRadians = Math.PI / 2; // 90 degrees
 *     rotate(coord, rotateRadians);
 *     // coord is now [-47.983333, 7.85]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} angle Angle in radian.
 * @return {Coordinate} Coordinate.
 * @api
 */
function rotate(coordinate, angle) {
    var cosAngle = Math.cos(angle);
    var sinAngle = Math.sin(angle);
    var x = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var y = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    coordinate[0] = x;
    coordinate[1] = y;
    return coordinate;
}
/**
 * Scale `coordinate` by `scale`. `coordinate` is modified in place and returned
 * by the function.
 *
 * Example:
 *
 *     import {scale as scaleCoordinate} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var scale = 1.2;
 *     scaleCoordinate(coord, scale);
 *     // coord is now [9.42, 57.5799996]
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} scale Scale factor.
 * @return {Coordinate} Coordinate.
 */
function scale(coordinate, scale) {
    coordinate[0] *= scale;
    coordinate[1] *= scale;
    return coordinate;
}
/**
 * @param {Coordinate} coord1 First coordinate.
 * @param {Coordinate} coord2 Second coordinate.
 * @return {number} Squared distance between coord1 and coord2.
 */
function squaredDistance(coord1, coord2) {
    var dx = coord1[0] - coord2[0];
    var dy = coord1[1] - coord2[1];
    return dx * dx + dy * dy;
}
/**
 * @param {Coordinate} coord1 First coordinate.
 * @param {Coordinate} coord2 Second coordinate.
 * @return {number} Distance between coord1 and coord2.
 */
function distance(coord1, coord2) {
    return Math.sqrt(squaredDistance(coord1, coord2));
}
/**
 * Calculate the squared distance from a coordinate to a line segment.
 *
 * @param {Coordinate} coordinate Coordinate of the point.
 * @param {Array<Coordinate>} segment Line segment (2
 * coordinates).
 * @return {number} Squared distance from the point to the line segment.
 */
function squaredDistanceToSegment(coordinate, segment) {
    return squaredDistance(coordinate, closestOnSegment(coordinate, segment));
}
/**
 * Format a geographic coordinate with the hemisphere, degrees, minutes, and
 * seconds.
 *
 * Example without specifying fractional digits:
 *
 *     import {toStringHDMS} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var out = toStringHDMS(coord);
 *     // out is now '47° 58′ 60″ N 7° 50′ 60″ E'
 *
 * Example explicitly specifying 1 fractional digit:
 *
 *     import {toStringHDMS} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var out = toStringHDMS(coord, 1);
 *     // out is now '47° 58′ 60.0″ N 7° 50′ 60.0″ E'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} [opt_fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} Hemisphere, degrees, minutes and seconds.
 * @api
 */
function toStringHDMS(coordinate, opt_fractionDigits) {
    if (coordinate) {
        return (degreesToStringHDMS('NS', coordinate[1], opt_fractionDigits) +
            ' ' +
            degreesToStringHDMS('EW', coordinate[0], opt_fractionDigits));
    }
    else {
        return '';
    }
}
/**
 * Format a coordinate as a comma delimited string.
 *
 * Example without specifying fractional digits:
 *
 *     import {toStringXY} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var out = toStringXY(coord);
 *     // out is now '8, 48'
 *
 * Example explicitly specifying 1 fractional digit:
 *
 *     import {toStringXY} from 'ol/coordinate';
 *
 *     var coord = [7.85, 47.983333];
 *     var out = toStringXY(coord, 1);
 *     // out is now '7.8, 48.0'
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {number} [opt_fractionDigits] The number of digits to include
 *    after the decimal point. Default is `0`.
 * @return {string} XY.
 * @api
 */
function toStringXY(coordinate, opt_fractionDigits) {
    return format(coordinate, '{x}, {y}', opt_fractionDigits);
}
/**
 * Modifies the provided coordinate in-place to be within the real world
 * extent. The lower projection extent boundary is inclusive, the upper one
 * exclusive.
 *
 * @param {Coordinate} coordinate Coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {Coordinate} The coordinate within the real world extent.
 */
function wrapX(coordinate, projection) {
    if (projection.canWrapX()) {
        var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(projection.getExtent());
        var worldsAway = getWorldsAway(coordinate, projection, worldWidth);
        if (worldsAway) {
            coordinate[0] -= worldsAway * worldWidth;
        }
    }
    return coordinate;
}
/**
 * @param {Coordinate} coordinate Coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @param {number} [opt_sourceExtentWidth] Width of the source extent.
 * @return {number} Offset in world widths.
 */
function getWorldsAway(coordinate, projection, opt_sourceExtentWidth) {
    var projectionExtent = projection.getExtent();
    var worldsAway = 0;
    if (projection.canWrapX() &&
        (coordinate[0] < projectionExtent[0] || coordinate[0] > projectionExtent[2])) {
        var sourceExtentWidth = opt_sourceExtentWidth || Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(projectionExtent);
        worldsAway = Math.floor((coordinate[0] - projectionExtent[0]) / sourceExtentWidth);
    }
    return worldsAway;
}
//# sourceMappingURL=coordinate.js.map

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "padNumber", function() { return padNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareVersions", function() { return compareVersions; });
/**
 * @module ol/string
 */
/**
 * @param {number} number Number to be formatted
 * @param {number} width The desired width
 * @param {number} [opt_precision] Precision of the output string (i.e. number of decimal places)
 * @return {string} Formatted string
 */
function padNumber(number, width, opt_precision) {
    var numberString = opt_precision !== undefined ? number.toFixed(opt_precision) : '' + number;
    var decimal = numberString.indexOf('.');
    decimal = decimal === -1 ? numberString.length : decimal;
    return decimal > width
        ? numberString
        : new Array(1 + width - decimal).join('0') + numberString;
}
/**
 * Adapted from https://github.com/omichelsen/compare-versions/blob/master/index.js
 * @param {string|number} v1 First version
 * @param {string|number} v2 Second version
 * @return {number} Value
 */
function compareVersions(v1, v2) {
    var s1 = ('' + v1).split('.');
    var s2 = ('' + v2).split('.');
    for (var i = 0; i < Math.max(s1.length, s2.length); i++) {
        var n1 = parseInt(s1[i] || '0', 10);
        var n2 = parseInt(s2[i] || '0', 10);
        if (n1 > n2) {
            return 1;
        }
        if (n2 > n1) {
            return -1;
        }
    }
    return 0;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__26__;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony import */ var _Projection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/* harmony import */ var _Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var _transforms_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14);
/**
 * @module ol/proj/proj4
 */





/**
 * Make projections defined in proj4 (with `proj4.defs()`) available in
 * OpenLayers.
 *
 * This function should be called whenever changes are made to the proj4
 * registry, e.g. after calling `proj4.defs()`. Existing transforms will not be
 * modified by this function.
 *
 * @param {?} proj4 Proj4.
 * @api
 */
function register(proj4) {
    var projCodes = Object.keys(proj4.defs);
    var len = projCodes.length;
    var i, j;
    for (i = 0; i < len; ++i) {
        var code = projCodes[i];
        if (!Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["get"])(code)) {
            var def = proj4.defs(code);
            var units = def.units;
            if (!units && def.projName === 'longlat') {
                units = _Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES;
            }
            Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["addProjection"])(new _Projection_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
                code: code,
                axisOrientation: def.axis,
                metersPerUnit: def.to_meter,
                units: units,
            }));
        }
    }
    for (i = 0; i < len; ++i) {
        var code1 = projCodes[i];
        var proj1 = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["get"])(code1);
        for (j = 0; j < len; ++j) {
            var code2 = projCodes[j];
            var proj2 = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["get"])(code2);
            if (!Object(_transforms_js__WEBPACK_IMPORTED_MODULE_4__["get"])(code1, code2)) {
                var def1 = proj4.defs(code1);
                var def2 = proj4.defs(code2);
                if (def1 === def2) {
                    Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["addEquivalentProjections"])([proj1, proj2]);
                }
                else {
                    // Reset axis because OpenLayers always uses x, y axis order
                    var transform = proj4(Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])({}, def1, { axis: undefined }), Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])({}, def2, { axis: undefined }));
                    Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["addCoordinateTransforms"])(proj1, proj2, Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["createSafeCoordinateTransform"])(proj1, proj2, transform.forward), Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["createSafeCoordinateTransform"])(proj2, proj1, transform.inverse));
                }
            }
        }
    }
}
//# sourceMappingURL=proj4.js.map

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2014 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:</p>
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */
/**
 * bluebird build version 2.9.25
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
*/
!function(e){if(true)module.exports=e();else { var f; }}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var SomePromiseArray = Promise._SomePromiseArray;
function any(promises) {
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(1);
    ret.setUnwrap();
    ret.init();
    return promise;
}

Promise.any = function (promises) {
    return any(promises);
};

Promise.prototype.any = function () {
    return any(this);
};

};

},{}],2:[function(_dereq_,module,exports){
"use strict";
var firstLineError;
try {throw new Error(); } catch (e) {firstLineError = e;}
var schedule = _dereq_("./schedule.js");
var Queue = _dereq_("./queue.js");
var util = _dereq_("./util.js");

function Async() {
    this._isTickUsed = false;
    this._lateQueue = new Queue(16);
    this._normalQueue = new Queue(16);
    this._trampolineEnabled = true;
    var self = this;
    this.drainQueues = function () {
        self._drainQueues();
    };
    this._schedule =
        schedule.isStatic ? schedule(this.drainQueues) : schedule;
}

Async.prototype.disableTrampolineIfNecessary = function() {
    if (util.hasDevTools) {
        this._trampolineEnabled = false;
    }
};

Async.prototype.enableTrampoline = function() {
    if (!this._trampolineEnabled) {
        this._trampolineEnabled = true;
        this._schedule = function(fn) {
            setTimeout(fn, 0);
        };
    }
};

Async.prototype.haveItemsQueued = function () {
    return this._normalQueue.length() > 0;
};

Async.prototype.throwLater = function(fn, arg) {
    if (arguments.length === 1) {
        arg = fn;
        fn = function () { throw arg; };
    }
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    if (typeof setTimeout !== "undefined") {
        setTimeout(function() {
            fn(arg);
        }, 0);
    } else try {
        this._schedule(function() {
            fn(arg);
        });
    } catch (e) {
        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
    }
};

Async.prototype._getDomain = function() {};

if (false) { var usingDomains, descriptor, domainGetter, EventsModule; }

function AsyncInvokeLater(fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._lateQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncInvoke(fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._normalQueue.push(fn, receiver, arg);
    this._queueTick();
}

function AsyncSettlePromises(promise) {
    var domain = this._getDomain();
    if (domain !== undefined) {
        var fn = domain.bind(promise._settlePromises);
        this._normalQueue.push(fn, promise, undefined);
    } else {
        this._normalQueue._pushOne(promise);
    }
    this._queueTick();
}

if (!util.hasDevTools) {
    Async.prototype.invokeLater = AsyncInvokeLater;
    Async.prototype.invoke = AsyncInvoke;
    Async.prototype.settlePromises = AsyncSettlePromises;
} else {
    Async.prototype.invokeLater = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvokeLater.call(this, fn, receiver, arg);
        } else {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 100);
        }
    };

    Async.prototype.invoke = function (fn, receiver, arg) {
        if (this._trampolineEnabled) {
            AsyncInvoke.call(this, fn, receiver, arg);
        } else {
            setTimeout(function() {
                fn.call(receiver, arg);
            }, 0);
        }
    };

    Async.prototype.settlePromises = function(promise) {
        if (this._trampolineEnabled) {
            AsyncSettlePromises.call(this, promise);
        } else {
            setTimeout(function() {
                promise._settlePromises();
            }, 0);
        }
    };
}

Async.prototype.invokeFirst = function (fn, receiver, arg) {
    var domain = this._getDomain();
    if (domain !== undefined) fn = domain.bind(fn);
    this._normalQueue.unshift(fn, receiver, arg);
    this._queueTick();
};

Async.prototype._drainQueue = function(queue) {
    while (queue.length() > 0) {
        var fn = queue.shift();
        if (typeof fn !== "function") {
            fn._settlePromises();
            continue;
        }
        var receiver = queue.shift();
        var arg = queue.shift();
        fn.call(receiver, arg);
    }
};

Async.prototype._drainQueues = function () {
    this._drainQueue(this._normalQueue);
    this._reset();
    this._drainQueue(this._lateQueue);
};

Async.prototype._queueTick = function () {
    if (!this._isTickUsed) {
        this._isTickUsed = true;
        this._schedule(this.drainQueues);
    }
};

Async.prototype._reset = function () {
    this._isTickUsed = false;
};

module.exports = new Async();
module.exports.firstLineError = firstLineError;

},{"./queue.js":28,"./schedule.js":31,"./util.js":38,"events":39}],3:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
var rejectThis = function(_, e) {
    this._reject(e);
};

var targetRejected = function(e, context) {
    context.promiseRejectionQueued = true;
    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
};

var bindingResolved = function(thisArg, context) {
    this._setBoundTo(thisArg);
    if (this._isPending()) {
        this._resolveCallback(context.target);
    }
};

var bindingRejected = function(e, context) {
    if (!context.promiseRejectionQueued) this._reject(e);
};

Promise.prototype.bind = function (thisArg) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);
    ret._propagateFrom(this, 1);
    var target = this._target();
    if (maybePromise instanceof Promise) {
        var context = {
            promiseRejectionQueued: false,
            promise: ret,
            target: target,
            bindingPromise: maybePromise
        };
        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
        maybePromise._then(
            bindingResolved, bindingRejected, ret._progress, ret, context);
    } else {
        ret._setBoundTo(thisArg);
        ret._resolveCallback(target);
    }
    return ret;
};

Promise.prototype._setBoundTo = function (obj) {
    if (obj !== undefined) {
        this._bitField = this._bitField | 131072;
        this._boundTo = obj;
    } else {
        this._bitField = this._bitField & (~131072);
    }
};

Promise.prototype._isBound = function () {
    return (this._bitField & 131072) === 131072;
};

Promise.bind = function (thisArg, value) {
    var maybePromise = tryConvertToPromise(thisArg);
    var ret = new Promise(INTERNAL);

    if (maybePromise instanceof Promise) {
        maybePromise._then(function(thisArg) {
            ret._setBoundTo(thisArg);
            ret._resolveCallback(value);
        }, ret._reject, ret._progress, ret, null);
    } else {
        ret._setBoundTo(thisArg);
        ret._resolveCallback(value);
    }
    return ret;
};
};

},{}],4:[function(_dereq_,module,exports){
"use strict";
var old;
if (typeof Promise !== "undefined") old = Promise;
function noConflict() {
    try { if (Promise === bluebird) Promise = old; }
    catch (e) {}
    return bluebird;
}
var bluebird = _dereq_("./promise.js")();
bluebird.noConflict = noConflict;
module.exports = bluebird;

},{"./promise.js":23}],5:[function(_dereq_,module,exports){
"use strict";
var cr = Object.create;
if (cr) {
    var callerCache = cr(null);
    var getterCache = cr(null);
    callerCache[" size"] = getterCache[" size"] = 0;
}

module.exports = function(Promise) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var isIdentifier = util.isIdentifier;

var getMethodCaller;
var getGetter;
if (false) { var getCompiled, makeGetter, makeMethodCaller; }

function ensureMethod(obj, methodName) {
    var fn;
    if (obj != null) fn = obj[methodName];
    if (typeof fn !== "function") {
        var message = "Object " + util.classString(obj) + " has no method '" +
            util.toString(methodName) + "'";
        throw new Promise.TypeError(message);
    }
    return fn;
}

function caller(obj) {
    var methodName = this.pop();
    var fn = ensureMethod(obj, methodName);
    return fn.apply(obj, this);
}
Promise.prototype.call = function (methodName) {
    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
    if (false) { var maybeCaller; }
    args.push(methodName);
    return this._then(caller, undefined, undefined, args, undefined);
};

function namedGetter(obj) {
    return obj[this];
}
function indexedGetter(obj) {
    var index = +this;
    if (index < 0) index = Math.max(0, index + obj.length);
    return obj[index];
}
Promise.prototype.get = function (propertyName) {
    var isIndex = (typeof propertyName === "number");
    var getter;
    if (!isIndex) {
        if (canEvaluate) {
            var maybeGetter = getGetter(propertyName);
            getter = maybeGetter !== null ? maybeGetter : namedGetter;
        } else {
            getter = namedGetter;
        }
    } else {
        getter = indexedGetter;
    }
    return this._then(getter, undefined, undefined, propertyName, undefined);
};
};

},{"./util.js":38}],6:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var errors = _dereq_("./errors.js");
var async = _dereq_("./async.js");
var CancellationError = errors.CancellationError;

Promise.prototype._cancel = function (reason) {
    if (!this.isCancellable()) return this;
    var parent;
    var promiseToReject = this;
    while ((parent = promiseToReject._cancellationParent) !== undefined &&
        parent.isCancellable()) {
        promiseToReject = parent;
    }
    this._unsetCancellable();
    promiseToReject._target()._rejectCallback(reason, false, true);
};

Promise.prototype.cancel = function (reason) {
    if (!this.isCancellable()) return this;
    if (reason === undefined) reason = new CancellationError();
    async.invokeLater(this._cancel, this, reason);
    return this;
};

Promise.prototype.cancellable = function () {
    if (this._cancellable()) return this;
    async.enableTrampoline();
    this._setCancellable();
    this._cancellationParent = undefined;
    return this;
};

Promise.prototype.uncancellable = function () {
    var ret = this.then();
    ret._unsetCancellable();
    return ret;
};

Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
    var ret = this._then(didFulfill, didReject, didProgress,
                         undefined, undefined);

    ret._setCancellable();
    ret._cancellationParent = undefined;
    return ret;
};
};

},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var bluebirdFramePattern =
    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
var stackFramePattern = null;
var formatStack = null;
var indentStackFrames = false;
var warn;

function CapturedTrace(parent) {
    this._parent = parent;
    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
    captureStackTrace(this, CapturedTrace);
    if (length > 32) this.uncycle();
}
util.inherits(CapturedTrace, Error);

CapturedTrace.prototype.uncycle = function() {
    var length = this._length;
    if (length < 2) return;
    var nodes = [];
    var stackToIndex = {};

    for (var i = 0, node = this; node !== undefined; ++i) {
        nodes.push(node);
        node = node._parent;
    }
    length = this._length = i;
    for (var i = length - 1; i >= 0; --i) {
        var stack = nodes[i].stack;
        if (stackToIndex[stack] === undefined) {
            stackToIndex[stack] = i;
        }
    }
    for (var i = 0; i < length; ++i) {
        var currentStack = nodes[i].stack;
        var index = stackToIndex[currentStack];
        if (index !== undefined && index !== i) {
            if (index > 0) {
                nodes[index - 1]._parent = undefined;
                nodes[index - 1]._length = 1;
            }
            nodes[i]._parent = undefined;
            nodes[i]._length = 1;
            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;

            if (index < length - 1) {
                cycleEdgeNode._parent = nodes[index + 1];
                cycleEdgeNode._parent.uncycle();
                cycleEdgeNode._length =
                    cycleEdgeNode._parent._length + 1;
            } else {
                cycleEdgeNode._parent = undefined;
                cycleEdgeNode._length = 1;
            }
            var currentChildLength = cycleEdgeNode._length + 1;
            for (var j = i - 2; j >= 0; --j) {
                nodes[j]._length = currentChildLength;
                currentChildLength++;
            }
            return;
        }
    }
};

CapturedTrace.prototype.parent = function() {
    return this._parent;
};

CapturedTrace.prototype.hasParent = function() {
    return this._parent !== undefined;
};

CapturedTrace.prototype.attachExtraTrace = function(error) {
    if (error.__stackCleaned__) return;
    this.uncycle();
    var parsed = CapturedTrace.parseStackAndMessage(error);
    var message = parsed.message;
    var stacks = [parsed.stack];

    var trace = this;
    while (trace !== undefined) {
        stacks.push(cleanStack(trace.stack.split("\n")));
        trace = trace._parent;
    }
    removeCommonRoots(stacks);
    removeDuplicateOrEmptyJumps(stacks);
    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
    util.notEnumerableProp(error, "__stackCleaned__", true);
};

function reconstructStack(message, stacks) {
    for (var i = 0; i < stacks.length - 1; ++i) {
        stacks[i].push("From previous event:");
        stacks[i] = stacks[i].join("\n");
    }
    if (i < stacks.length) {
        stacks[i] = stacks[i].join("\n");
    }
    return message + "\n" + stacks.join("\n");
}

function removeDuplicateOrEmptyJumps(stacks) {
    for (var i = 0; i < stacks.length; ++i) {
        if (stacks[i].length === 0 ||
            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
            stacks.splice(i, 1);
            i--;
        }
    }
}

function removeCommonRoots(stacks) {
    var current = stacks[0];
    for (var i = 1; i < stacks.length; ++i) {
        var prev = stacks[i];
        var currentLastIndex = current.length - 1;
        var currentLastLine = current[currentLastIndex];
        var commonRootMeetPoint = -1;

        for (var j = prev.length - 1; j >= 0; --j) {
            if (prev[j] === currentLastLine) {
                commonRootMeetPoint = j;
                break;
            }
        }

        for (var j = commonRootMeetPoint; j >= 0; --j) {
            var line = prev[j];
            if (current[currentLastIndex] === line) {
                current.pop();
                currentLastIndex--;
            } else {
                break;
            }
        }
        current = prev;
    }
}

function cleanStack(stack) {
    var ret = [];
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        var isTraceLine = stackFramePattern.test(line) ||
            "    (No stack trace)" === line;
        var isInternalFrame = isTraceLine && shouldIgnore(line);
        if (isTraceLine && !isInternalFrame) {
            if (indentStackFrames && line.charAt(0) !== " ") {
                line = "    " + line;
            }
            ret.push(line);
        }
    }
    return ret;
}

function stackFramesAsArray(error) {
    var stack = error.stack.replace(/\s+$/g, "").split("\n");
    for (var i = 0; i < stack.length; ++i) {
        var line = stack[i];
        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
            break;
        }
    }
    if (i > 0) {
        stack = stack.slice(i);
    }
    return stack;
}

CapturedTrace.parseStackAndMessage = function(error) {
    var stack = error.stack;
    var message = error.toString();
    stack = typeof stack === "string" && stack.length > 0
                ? stackFramesAsArray(error) : ["    (No stack trace)"];
    return {
        message: message,
        stack: cleanStack(stack)
    };
};

CapturedTrace.formatAndLogError = function(error, title) {
    if (typeof console !== "undefined") {
        var message;
        if (typeof error === "object" || typeof error === "function") {
            var stack = error.stack;
            message = title + formatStack(stack, error);
        } else {
            message = title + String(error);
        }
        if (typeof warn === "function") {
            warn(message);
        } else if (typeof console.log === "function" ||
            typeof console.log === "object") {
            console.log(message);
        }
    }
};

CapturedTrace.unhandledRejection = function (reason) {
    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
};

CapturedTrace.isSupported = function () {
    return typeof captureStackTrace === "function";
};

CapturedTrace.fireRejectionEvent =
function(name, localHandler, reason, promise) {
    var localEventFired = false;
    try {
        if (typeof localHandler === "function") {
            localEventFired = true;
            if (name === "rejectionHandled") {
                localHandler(promise);
            } else {
                localHandler(reason, promise);
            }
        }
    } catch (e) {
        async.throwLater(e);
    }

    var globalEventFired = false;
    try {
        globalEventFired = fireGlobalEvent(name, reason, promise);
    } catch (e) {
        globalEventFired = true;
        async.throwLater(e);
    }

    var domEventFired = false;
    if (fireDomEvent) {
        try {
            domEventFired = fireDomEvent(name.toLowerCase(), {
                reason: reason,
                promise: promise
            });
        } catch (e) {
            domEventFired = true;
            async.throwLater(e);
        }
    }

    if (!globalEventFired && !localEventFired && !domEventFired &&
        name === "unhandledRejection") {
        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
    }
};

function formatNonError(obj) {
    var str;
    if (typeof obj === "function") {
        str = "[function " +
            (obj.name || "anonymous") +
            "]";
    } else {
        str = obj.toString();
        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
        if (ruselessToString.test(str)) {
            try {
                var newStr = JSON.stringify(obj);
                str = newStr;
            }
            catch(e) {

            }
        }
        if (str.length === 0) {
            str = "(empty array)";
        }
    }
    return ("(<" + snip(str) + ">, no stack trace)");
}

function snip(str) {
    var maxChars = 41;
    if (str.length < maxChars) {
        return str;
    }
    return str.substr(0, maxChars - 3) + "...";
}

var shouldIgnore = function() { return false; };
var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
function parseLineInfo(line) {
    var matches = line.match(parseLineInfoRegex);
    if (matches) {
        return {
            fileName: matches[1],
            line: parseInt(matches[2], 10)
        };
    }
}
CapturedTrace.setBounds = function(firstLineError, lastLineError) {
    if (!CapturedTrace.isSupported()) return;
    var firstStackLines = firstLineError.stack.split("\n");
    var lastStackLines = lastLineError.stack.split("\n");
    var firstIndex = -1;
    var lastIndex = -1;
    var firstFileName;
    var lastFileName;
    for (var i = 0; i < firstStackLines.length; ++i) {
        var result = parseLineInfo(firstStackLines[i]);
        if (result) {
            firstFileName = result.fileName;
            firstIndex = result.line;
            break;
        }
    }
    for (var i = 0; i < lastStackLines.length; ++i) {
        var result = parseLineInfo(lastStackLines[i]);
        if (result) {
            lastFileName = result.fileName;
            lastIndex = result.line;
            break;
        }
    }
    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
        firstFileName !== lastFileName || firstIndex >= lastIndex) {
        return;
    }

    shouldIgnore = function(line) {
        if (bluebirdFramePattern.test(line)) return true;
        var info = parseLineInfo(line);
        if (info) {
            if (info.fileName === firstFileName &&
                (firstIndex <= info.line && info.line <= lastIndex)) {
                return true;
            }
        }
        return false;
    };
};

var captureStackTrace = (function stackDetection() {
    var v8stackFramePattern = /^\s*at\s*/;
    var v8stackFormatter = function(stack, error) {
        if (typeof stack === "string") return stack;

        if (error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    if (typeof Error.stackTraceLimit === "number" &&
        typeof Error.captureStackTrace === "function") {
        Error.stackTraceLimit = Error.stackTraceLimit + 6;
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        var captureStackTrace = Error.captureStackTrace;

        shouldIgnore = function(line) {
            return bluebirdFramePattern.test(line);
        };
        return function(receiver, ignoreUntil) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            captureStackTrace(receiver, ignoreUntil);
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }
    var err = new Error();

    if (typeof err.stack === "string" &&
        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
        stackFramePattern = /@/;
        formatStack = v8stackFormatter;
        indentStackFrames = true;
        return function captureStackTrace(o) {
            o.stack = new Error().stack;
        };
    }

    var hasStackAfterThrow;
    try { throw new Error(); }
    catch(e) {
        hasStackAfterThrow = ("stack" in e);
    }
    if (!("stack" in err) && hasStackAfterThrow) {
        stackFramePattern = v8stackFramePattern;
        formatStack = v8stackFormatter;
        return function captureStackTrace(o) {
            Error.stackTraceLimit = Error.stackTraceLimit + 6;
            try { throw new Error(); }
            catch(e) { o.stack = e.stack; }
            Error.stackTraceLimit = Error.stackTraceLimit - 6;
        };
    }

    formatStack = function(stack, error) {
        if (typeof stack === "string") return stack;

        if ((typeof error === "object" ||
            typeof error === "function") &&
            error.name !== undefined &&
            error.message !== undefined) {
            return error.toString();
        }
        return formatNonError(error);
    };

    return null;

})([]);

var fireDomEvent;
var fireGlobalEvent = (function() {
    if (util.isNode) {
        return function(name, reason, promise) {
            if (name === "rejectionHandled") {
                return process.emit(name, promise);
            } else {
                return process.emit(name, reason, promise);
            }
        };
    } else {
        var customEventWorks = false;
        var anyEventWorks = true;
        try {
            var ev = new self.CustomEvent("test");
            customEventWorks = ev instanceof CustomEvent;
        } catch (e) {}
        if (!customEventWorks) {
            try {
                var event = document.createEvent("CustomEvent");
                event.initCustomEvent("testingtheevent", false, true, {});
                self.dispatchEvent(event);
            } catch (e) {
                anyEventWorks = false;
            }
        }
        if (anyEventWorks) {
            fireDomEvent = function(type, detail) {
                var event;
                if (customEventWorks) {
                    event = new self.CustomEvent(type, {
                        detail: detail,
                        bubbles: false,
                        cancelable: true
                    });
                } else if (self.dispatchEvent) {
                    event = document.createEvent("CustomEvent");
                    event.initCustomEvent(type, false, true, detail);
                }

                return event ? !self.dispatchEvent(event) : false;
            };
        }

        var toWindowMethodNameMap = {};
        toWindowMethodNameMap["unhandledRejection"] = ("on" +
            "unhandledRejection").toLowerCase();
        toWindowMethodNameMap["rejectionHandled"] = ("on" +
            "rejectionHandled").toLowerCase();

        return function(name, reason, promise) {
            var methodName = toWindowMethodNameMap[name];
            var method = self[methodName];
            if (!method) return false;
            if (name === "rejectionHandled") {
                method.call(self, promise);
            } else {
                method.call(self, reason, promise);
            }
            return true;
        };
    }
})();

if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
    warn = function (message) {
        console.warn(message);
    };
    if (util.isNode && process.stderr.isTTY) {
        warn = function(message) {
            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
        };
    } else if (!util.isNode && typeof (new Error().stack) === "string") {
        warn = function(message) {
            console.warn("%c" + message, "color: red");
        };
    }
}

return CapturedTrace;
};

},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
"use strict";
module.exports = function(NEXT_FILTER) {
var util = _dereq_("./util.js");
var errors = _dereq_("./errors.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var keys = _dereq_("./es5.js").keys;
var TypeError = errors.TypeError;

function CatchFilter(instances, callback, promise) {
    this._instances = instances;
    this._callback = callback;
    this._promise = promise;
}

function safePredicate(predicate, e) {
    var safeObject = {};
    var retfilter = tryCatch(predicate).call(safeObject, e);

    if (retfilter === errorObj) return retfilter;

    var safeKeys = keys(safeObject);
    if (safeKeys.length) {
        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
        return errorObj;
    }
    return retfilter;
}

CatchFilter.prototype.doFilter = function (e) {
    var cb = this._callback;
    var promise = this._promise;
    var boundTo = promise._boundTo;
    for (var i = 0, len = this._instances.length; i < len; ++i) {
        var item = this._instances[i];
        var itemIsErrorType = item === Error ||
            (item != null && item.prototype instanceof Error);

        if (itemIsErrorType && e instanceof item) {
            var ret = tryCatch(cb).call(boundTo, e);
            if (ret === errorObj) {
                NEXT_FILTER.e = ret.e;
                return NEXT_FILTER;
            }
            return ret;
        } else if (typeof item === "function" && !itemIsErrorType) {
            var shouldHandle = safePredicate(item, e);
            if (shouldHandle === errorObj) {
                e = errorObj.e;
                break;
            } else if (shouldHandle) {
                var ret = tryCatch(cb).call(boundTo, e);
                if (ret === errorObj) {
                    NEXT_FILTER.e = ret.e;
                    return NEXT_FILTER;
                }
                return ret;
            }
        }
    }
    NEXT_FILTER.e = e;
    return NEXT_FILTER;
};

return CatchFilter;
};

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace, isDebugging) {
var contextStack = [];
function Context() {
    this._trace = new CapturedTrace(peekContext());
}
Context.prototype._pushContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.push(this._trace);
    }
};

Context.prototype._popContext = function () {
    if (!isDebugging()) return;
    if (this._trace !== undefined) {
        contextStack.pop();
    }
};

function createContext() {
    if (isDebugging()) return new Context();
}

function peekContext() {
    var lastIndex = contextStack.length - 1;
    if (lastIndex >= 0) {
        return contextStack[lastIndex];
    }
    return undefined;
}

Promise.prototype._peekContext = peekContext;
Promise.prototype._pushContext = Context.prototype._pushContext;
Promise.prototype._popContext = Context.prototype._popContext;

return createContext;
};

},{}],10:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, CapturedTrace) {
var async = _dereq_("./async.js");
var Warning = _dereq_("./errors.js").Warning;
var util = _dereq_("./util.js");
var canAttachTrace = util.canAttachTrace;
var unhandledRejectionHandled;
var possiblyUnhandledRejection;
var debugging =  false || (util.isNode &&
                    (!!process.env["BLUEBIRD_DEBUG"] ||
                     "none" === "development"));

if (debugging) {
    async.disableTrampolineIfNecessary();
}

Promise.prototype._ensurePossibleRejectionHandled = function () {
    this._setRejectionIsUnhandled();
    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
};

Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
    CapturedTrace.fireRejectionEvent("rejectionHandled",
                                  unhandledRejectionHandled, undefined, this);
};

Promise.prototype._notifyUnhandledRejection = function () {
    if (this._isRejectionUnhandled()) {
        var reason = this._getCarriedStackTrace() || this._settledValue;
        this._setUnhandledRejectionIsNotified();
        CapturedTrace.fireRejectionEvent("unhandledRejection",
                                      possiblyUnhandledRejection, reason, this);
    }
};

Promise.prototype._setUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField | 524288;
};

Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
    this._bitField = this._bitField & (~524288);
};

Promise.prototype._isUnhandledRejectionNotified = function () {
    return (this._bitField & 524288) > 0;
};

Promise.prototype._setRejectionIsUnhandled = function () {
    this._bitField = this._bitField | 2097152;
};

Promise.prototype._unsetRejectionIsUnhandled = function () {
    this._bitField = this._bitField & (~2097152);
    if (this._isUnhandledRejectionNotified()) {
        this._unsetUnhandledRejectionIsNotified();
        this._notifyUnhandledRejectionIsHandled();
    }
};

Promise.prototype._isRejectionUnhandled = function () {
    return (this._bitField & 2097152) > 0;
};

Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
    this._bitField = this._bitField | 1048576;
    this._fulfillmentHandler0 = capturedTrace;
};

Promise.prototype._isCarryingStackTrace = function () {
    return (this._bitField & 1048576) > 0;
};

Promise.prototype._getCarriedStackTrace = function () {
    return this._isCarryingStackTrace()
        ? this._fulfillmentHandler0
        : undefined;
};

Promise.prototype._captureStackTrace = function () {
    if (debugging) {
        this._trace = new CapturedTrace(this._peekContext());
    }
    return this;
};

Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
    if (debugging && canAttachTrace(error)) {
        var trace = this._trace;
        if (trace !== undefined) {
            if (ignoreSelf) trace = trace._parent;
        }
        if (trace !== undefined) {
            trace.attachExtraTrace(error);
        } else if (!error.__stackCleaned__) {
            var parsed = CapturedTrace.parseStackAndMessage(error);
            util.notEnumerableProp(error, "stack",
                parsed.message + "\n" + parsed.stack.join("\n"));
            util.notEnumerableProp(error, "__stackCleaned__", true);
        }
    }
};

Promise.prototype._warn = function(message) {
    var warning = new Warning(message);
    var ctx = this._peekContext();
    if (ctx) {
        ctx.attachExtraTrace(warning);
    } else {
        var parsed = CapturedTrace.parseStackAndMessage(warning);
        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
    }
    CapturedTrace.formatAndLogError(warning, "");
};

Promise.onPossiblyUnhandledRejection = function (fn) {
    possiblyUnhandledRejection = typeof fn === "function" ? fn : undefined;
};

Promise.onUnhandledRejectionHandled = function (fn) {
    unhandledRejectionHandled = typeof fn === "function" ? fn : undefined;
};

Promise.longStackTraces = function () {
    if (async.haveItemsQueued() &&
        debugging === false
   ) {
        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
    }
    debugging = CapturedTrace.isSupported();
    if (debugging) {
        async.disableTrampolineIfNecessary();
    }
};

Promise.hasLongStackTraces = function () {
    return debugging && CapturedTrace.isSupported();
};

if (!CapturedTrace.isSupported()) {
    Promise.longStackTraces = function(){};
    debugging = false;
}

return function() {
    return debugging;
};
};

},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var isPrimitive = util.isPrimitive;
var wrapsPrimitiveReceiver = util.wrapsPrimitiveReceiver;

module.exports = function(Promise) {
var returner = function () {
    return this;
};
var thrower = function () {
    throw this;
};

var wrapper = function (value, action) {
    if (action === 1) {
        return function () {
            throw value;
        };
    } else if (action === 2) {
        return function () {
            return value;
        };
    }
};


Promise.prototype["return"] =
Promise.prototype.thenReturn = function (value) {
    if (wrapsPrimitiveReceiver && isPrimitive(value)) {
        return this._then(
            wrapper(value, 2),
            undefined,
            undefined,
            undefined,
            undefined
       );
    }
    return this._then(returner, undefined, undefined, value, undefined);
};

Promise.prototype["throw"] =
Promise.prototype.thenThrow = function (reason) {
    if (wrapsPrimitiveReceiver && isPrimitive(reason)) {
        return this._then(
            wrapper(reason, 1),
            undefined,
            undefined,
            undefined,
            undefined
       );
    }
    return this._then(thrower, undefined, undefined, reason, undefined);
};
};

},{"./util.js":38}],12:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseReduce = Promise.reduce;

Promise.prototype.each = function (fn) {
    return PromiseReduce(this, fn, null, INTERNAL);
};

Promise.each = function (promises, fn) {
    return PromiseReduce(promises, fn, null, INTERNAL);
};
};

},{}],13:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var Objectfreeze = es5.freeze;
var util = _dereq_("./util.js");
var inherits = util.inherits;
var notEnumerableProp = util.notEnumerableProp;

function subError(nameProperty, defaultMessage) {
    function SubError(message) {
        if (!(this instanceof SubError)) return new SubError(message);
        notEnumerableProp(this, "message",
            typeof message === "string" ? message : defaultMessage);
        notEnumerableProp(this, "name", nameProperty);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, this.constructor);
        } else {
            Error.call(this);
        }
    }
    inherits(SubError, Error);
    return SubError;
}

var _TypeError, _RangeError;
var Warning = subError("Warning", "warning");
var CancellationError = subError("CancellationError", "cancellation error");
var TimeoutError = subError("TimeoutError", "timeout error");
var AggregateError = subError("AggregateError", "aggregate error");
try {
    _TypeError = TypeError;
    _RangeError = RangeError;
} catch(e) {
    _TypeError = subError("TypeError", "type error");
    _RangeError = subError("RangeError", "range error");
}

var methods = ("join pop push shift unshift slice filter forEach some " +
    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");

for (var i = 0; i < methods.length; ++i) {
    if (typeof Array.prototype[methods[i]] === "function") {
        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
    }
}

es5.defineProperty(AggregateError.prototype, "length", {
    value: 0,
    configurable: false,
    writable: true,
    enumerable: true
});
AggregateError.prototype["isOperational"] = true;
var level = 0;
AggregateError.prototype.toString = function() {
    var indent = Array(level * 4 + 1).join(" ");
    var ret = "\n" + indent + "AggregateError of:" + "\n";
    level++;
    indent = Array(level * 4 + 1).join(" ");
    for (var i = 0; i < this.length; ++i) {
        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
        var lines = str.split("\n");
        for (var j = 0; j < lines.length; ++j) {
            lines[j] = indent + lines[j];
        }
        str = lines.join("\n");
        ret += str + "\n";
    }
    level--;
    return ret;
};

function OperationalError(message) {
    if (!(this instanceof OperationalError))
        return new OperationalError(message);
    notEnumerableProp(this, "name", "OperationalError");
    notEnumerableProp(this, "message", message);
    this.cause = message;
    this["isOperational"] = true;

    if (message instanceof Error) {
        notEnumerableProp(this, "message", message.message);
        notEnumerableProp(this, "stack", message.stack);
    } else if (Error.captureStackTrace) {
        Error.captureStackTrace(this, this.constructor);
    }

}
inherits(OperationalError, Error);

var errorTypes = Error["__BluebirdErrorTypes__"];
if (!errorTypes) {
    errorTypes = Objectfreeze({
        CancellationError: CancellationError,
        TimeoutError: TimeoutError,
        OperationalError: OperationalError,
        RejectionError: OperationalError,
        AggregateError: AggregateError
    });
    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
}

module.exports = {
    Error: Error,
    TypeError: _TypeError,
    RangeError: _RangeError,
    CancellationError: errorTypes.CancellationError,
    OperationalError: errorTypes.OperationalError,
    TimeoutError: errorTypes.TimeoutError,
    AggregateError: errorTypes.AggregateError,
    Warning: Warning
};

},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
var isES5 = (function(){
    "use strict";
    return this === undefined;
})();

if (isES5) {
    module.exports = {
        freeze: Object.freeze,
        defineProperty: Object.defineProperty,
        getDescriptor: Object.getOwnPropertyDescriptor,
        keys: Object.keys,
        names: Object.getOwnPropertyNames,
        getPrototypeOf: Object.getPrototypeOf,
        isArray: Array.isArray,
        isES5: isES5,
        propertyIsWritable: function(obj, prop) {
            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
            return !!(!descriptor || descriptor.writable || descriptor.set);
        }
    };
} else {
    var has = {}.hasOwnProperty;
    var str = {}.toString;
    var proto = {}.constructor.prototype;

    var ObjectKeys = function (o) {
        var ret = [];
        for (var key in o) {
            if (has.call(o, key)) {
                ret.push(key);
            }
        }
        return ret;
    };

    var ObjectGetDescriptor = function(o, key) {
        return {value: o[key]};
    };

    var ObjectDefineProperty = function (o, key, desc) {
        o[key] = desc.value;
        return o;
    };

    var ObjectFreeze = function (obj) {
        return obj;
    };

    var ObjectGetPrototypeOf = function (obj) {
        try {
            return Object(obj).constructor.prototype;
        }
        catch (e) {
            return proto;
        }
    };

    var ArrayIsArray = function (obj) {
        try {
            return str.call(obj) === "[object Array]";
        }
        catch(e) {
            return false;
        }
    };

    module.exports = {
        isArray: ArrayIsArray,
        keys: ObjectKeys,
        names: ObjectKeys,
        defineProperty: ObjectDefineProperty,
        getDescriptor: ObjectGetDescriptor,
        freeze: ObjectFreeze,
        getPrototypeOf: ObjectGetPrototypeOf,
        isES5: isES5,
        propertyIsWritable: function() {
            return true;
        }
    };
}

},{}],15:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var PromiseMap = Promise.map;

Promise.prototype.filter = function (fn, options) {
    return PromiseMap(this, fn, options, INTERNAL);
};

Promise.filter = function (promises, fn, options) {
    return PromiseMap(promises, fn, options, INTERNAL);
};
};

},{}],16:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
var util = _dereq_("./util.js");
var wrapsPrimitiveReceiver = util.wrapsPrimitiveReceiver;
var isPrimitive = util.isPrimitive;
var thrower = util.thrower;

function returnThis() {
    return this;
}
function throwThis() {
    throw this;
}
function return$(r) {
    return function() {
        return r;
    };
}
function throw$(r) {
    return function() {
        throw r;
    };
}
function promisedFinally(ret, reasonOrValue, isFulfilled) {
    var then;
    if (wrapsPrimitiveReceiver && isPrimitive(reasonOrValue)) {
        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
    } else {
        then = isFulfilled ? returnThis : throwThis;
    }
    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
}

function finallyHandler(reasonOrValue) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundTo)
                    : handler();

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, reasonOrValue,
                                    promise.isFulfilled());
        }
    }

    if (promise.isRejected()) {
        NEXT_FILTER.e = reasonOrValue;
        return NEXT_FILTER;
    } else {
        return reasonOrValue;
    }
}

function tapHandler(value) {
    var promise = this.promise;
    var handler = this.handler;

    var ret = promise._isBound()
                    ? handler.call(promise._boundTo, value)
                    : handler(value);

    if (ret !== undefined) {
        var maybePromise = tryConvertToPromise(ret, promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            return promisedFinally(maybePromise, value, true);
        }
    }
    return value;
}

Promise.prototype._passThroughHandler = function (handler, isFinally) {
    if (typeof handler !== "function") return this.then();

    var promiseAndHandler = {
        promise: this,
        handler: handler
    };

    return this._then(
            isFinally ? finallyHandler : tapHandler,
            isFinally ? finallyHandler : undefined, undefined,
            promiseAndHandler, undefined);
};

Promise.prototype.lastly =
Promise.prototype["finally"] = function (handler) {
    return this._passThroughHandler(handler, true);
};

Promise.prototype.tap = function (handler) {
    return this._passThroughHandler(handler, false);
};
};

},{"./util.js":38}],17:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          apiRejection,
                          INTERNAL,
                          tryConvertToPromise) {
var errors = _dereq_("./errors.js");
var TypeError = errors.TypeError;
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
var yieldHandlers = [];

function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
    for (var i = 0; i < yieldHandlers.length; ++i) {
        traceParent._pushContext();
        var result = tryCatch(yieldHandlers[i])(value);
        traceParent._popContext();
        if (result === errorObj) {
            traceParent._pushContext();
            var ret = Promise.reject(errorObj.e);
            traceParent._popContext();
            return ret;
        }
        var maybePromise = tryConvertToPromise(result, traceParent);
        if (maybePromise instanceof Promise) return maybePromise;
    }
    return null;
}

function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
    var promise = this._promise = new Promise(INTERNAL);
    promise._captureStackTrace();
    this._stack = stack;
    this._generatorFunction = generatorFunction;
    this._receiver = receiver;
    this._generator = undefined;
    this._yieldHandlers = typeof yieldHandler === "function"
        ? [yieldHandler].concat(yieldHandlers)
        : yieldHandlers;
}

PromiseSpawn.prototype.promise = function () {
    return this._promise;
};

PromiseSpawn.prototype._run = function () {
    this._generator = this._generatorFunction.call(this._receiver);
    this._receiver =
        this._generatorFunction = undefined;
    this._next(undefined);
};

PromiseSpawn.prototype._continue = function (result) {
    if (result === errorObj) {
        return this._promise._rejectCallback(result.e, false, true);
    }

    var value = result.value;
    if (result.done === true) {
        this._promise._resolveCallback(value);
    } else {
        var maybePromise = tryConvertToPromise(value, this._promise);
        if (!(maybePromise instanceof Promise)) {
            maybePromise =
                promiseFromYieldHandler(maybePromise,
                                        this._yieldHandlers,
                                        this._promise);
            if (maybePromise === null) {
                this._throw(
                    new TypeError(
                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
                        "From coroutine:\u000a" +
                        this._stack.split("\n").slice(1, -7).join("\n")
                    )
                );
                return;
            }
        }
        maybePromise._then(
            this._next,
            this._throw,
            undefined,
            this,
            null
       );
    }
};

PromiseSpawn.prototype._throw = function (reason) {
    this._promise._attachExtraTrace(reason);
    this._promise._pushContext();
    var result = tryCatch(this._generator["throw"])
        .call(this._generator, reason);
    this._promise._popContext();
    this._continue(result);
};

PromiseSpawn.prototype._next = function (value) {
    this._promise._pushContext();
    var result = tryCatch(this._generator.next).call(this._generator, value);
    this._promise._popContext();
    this._continue(result);
};

Promise.coroutine = function (generatorFunction, options) {
    if (typeof generatorFunction !== "function") {
        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var yieldHandler = Object(options).yieldHandler;
    var PromiseSpawn$ = PromiseSpawn;
    var stack = new Error().stack;
    return function () {
        var generator = generatorFunction.apply(this, arguments);
        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
                                      stack);
        spawn._generator = generator;
        spawn._next(undefined);
        return spawn.promise();
    };
};

Promise.coroutine.addYieldHandler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    yieldHandlers.push(fn);
};

Promise.spawn = function (generatorFunction) {
    if (typeof generatorFunction !== "function") {
        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
    }
    var spawn = new PromiseSpawn(generatorFunction, this);
    var ret = spawn.promise();
    spawn._run(Promise.spawn);
    return ret;
};
};

},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
var util = _dereq_("./util.js");
var canEvaluate = util.canEvaluate;
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var reject;

if (false) { var reject, Holder, i, callers, thenCallbacks, caller, thenCallback; }

Promise.join = function () {
    var last = arguments.length - 1;
    var fn;
    if (last > 0 && typeof arguments[last] === "function") {
        fn = arguments[last];
        if (false) { var maybePromise, i, callbacks, holder, ret; }
    }
    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
    if (fn) args.pop();
    var ret = new PromiseArray(args).promise();
    return fn !== undefined ? ret.spread(fn) : ret;
};

};

},{"./util.js":38}],19:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
var PENDING = {};
var EMPTY_ARRAY = [];

function MappingPromiseArray(promises, fn, limit, _filter) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    this._callback = fn;
    this._preservedValues = _filter === INTERNAL
        ? new Array(this.length())
        : null;
    this._limit = limit;
    this._inFlight = 0;
    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
    async.invoke(init, this, undefined);
}
util.inherits(MappingPromiseArray, PromiseArray);
function init() {this._init$(undefined, -2);}

MappingPromiseArray.prototype._init = function () {};

MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var limit = this._limit;
    if (values[index] === PENDING) {
        values[index] = value;
        if (limit >= 1) {
            this._inFlight--;
            this._drainQueue();
            if (this._isResolved()) return;
        }
    } else {
        if (limit >= 1 && this._inFlight >= limit) {
            values[index] = value;
            this._queue.push(index);
            return;
        }
        if (preservedValues !== null) preservedValues[index] = value;

        var callback = this._callback;
        var receiver = this._promise._boundTo;
        this._promise._pushContext();
        var ret = tryCatch(callback).call(receiver, value, index, length);
        this._promise._popContext();
        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                if (limit >= 1) this._inFlight++;
                values[index] = PENDING;
                return maybePromise._proxyPromiseArray(this, index);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }
        values[index] = ret;
    }
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= length) {
        if (preservedValues !== null) {
            this._filter(values, preservedValues);
        } else {
            this._resolve(values);
        }

    }
};

MappingPromiseArray.prototype._drainQueue = function () {
    var queue = this._queue;
    var limit = this._limit;
    var values = this._values;
    while (queue.length > 0 && this._inFlight < limit) {
        if (this._isResolved()) return;
        var index = queue.pop();
        this._promiseFulfilled(values[index], index);
    }
};

MappingPromiseArray.prototype._filter = function (booleans, values) {
    var len = values.length;
    var ret = new Array(len);
    var j = 0;
    for (var i = 0; i < len; ++i) {
        if (booleans[i]) ret[j++] = values[i];
    }
    ret.length = j;
    this._resolve(ret);
};

MappingPromiseArray.prototype.preservedValues = function () {
    return this._preservedValues;
};

function map(promises, fn, options, _filter) {
    var limit = typeof options === "object" && options !== null
        ? options.concurrency
        : 0;
    limit = typeof limit === "number" &&
        isFinite(limit) && limit >= 1 ? limit : 0;
    return new MappingPromiseArray(promises, fn, limit, _filter);
}

Promise.prototype.map = function (fn, options) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");

    return map(this, fn, options, null).promise();
};

Promise.map = function (promises, fn, options, _filter) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    return map(promises, fn, options, _filter).promise();
};


};

},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;

Promise.method = function (fn) {
    if (typeof fn !== "function") {
        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    return function () {
        var ret = new Promise(INTERNAL);
        ret._captureStackTrace();
        ret._pushContext();
        var value = tryCatch(fn).apply(this, arguments);
        ret._popContext();
        ret._resolveFromSyncValue(value);
        return ret;
    };
};

Promise.attempt = Promise["try"] = function (fn, args, ctx) {
    if (typeof fn !== "function") {
        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._pushContext();
    var value = util.isArray(args)
        ? tryCatch(fn).apply(ctx, args)
        : tryCatch(fn).call(ctx, args);
    ret._popContext();
    ret._resolveFromSyncValue(value);
    return ret;
};

Promise.prototype._resolveFromSyncValue = function (value) {
    if (value === util.errorObj) {
        this._rejectCallback(value.e, false, true);
    } else {
        this._resolveCallback(value, true);
    }
};
};

},{"./util.js":38}],21:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

function spreadAdapter(val, nodeback) {
    var promise = this;
    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
    var ret = tryCatch(nodeback).apply(promise._boundTo, [null].concat(val));
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

function successAdapter(val, nodeback) {
    var promise = this;
    var receiver = promise._boundTo;
    var ret = val === undefined
        ? tryCatch(nodeback).call(receiver, null)
        : tryCatch(nodeback).call(receiver, null, val);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}
function errorAdapter(reason, nodeback) {
    var promise = this;
    if (!reason) {
        var target = promise._target();
        var newReason = target._getCarriedStackTrace();
        newReason.cause = reason;
        reason = newReason;
    }
    var ret = tryCatch(nodeback).call(promise._boundTo, reason);
    if (ret === errorObj) {
        async.throwLater(ret.e);
    }
}

Promise.prototype.asCallback = 
Promise.prototype.nodeify = function (nodeback, options) {
    if (typeof nodeback == "function") {
        var adapter = successAdapter;
        if (options !== undefined && Object(options).spread) {
            adapter = spreadAdapter;
        }
        this._then(
            adapter,
            errorAdapter,
            undefined,
            this,
            nodeback
        );
    }
    return this;
};
};

},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, PromiseArray) {
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;

Promise.prototype.progressed = function (handler) {
    return this._then(undefined, undefined, handler, undefined, undefined);
};

Promise.prototype._progress = function (progressValue) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._target()._progressUnchecked(progressValue);

};

Promise.prototype._progressHandlerAt = function (index) {
    return index === 0
        ? this._progressHandler0
        : this[(index << 2) + index - 5 + 2];
};

Promise.prototype._doProgressWith = function (progression) {
    var progressValue = progression.value;
    var handler = progression.handler;
    var promise = progression.promise;
    var receiver = progression.receiver;

    var ret = tryCatch(handler).call(receiver, progressValue);
    if (ret === errorObj) {
        if (ret.e != null &&
            ret.e.name !== "StopProgressPropagation") {
            var trace = util.canAttachTrace(ret.e)
                ? ret.e : new Error(util.toString(ret.e));
            promise._attachExtraTrace(trace);
            promise._progress(ret.e);
        }
    } else if (ret instanceof Promise) {
        ret._then(promise._progress, null, null, promise, undefined);
    } else {
        promise._progress(ret);
    }
};


Promise.prototype._progressUnchecked = function (progressValue) {
    var len = this._length();
    var progress = this._progress;
    for (var i = 0; i < len; i++) {
        var handler = this._progressHandlerAt(i);
        var promise = this._promiseAt(i);
        if (!(promise instanceof Promise)) {
            var receiver = this._receiverAt(i);
            if (typeof handler === "function") {
                handler.call(receiver, progressValue, promise);
            } else if (receiver instanceof PromiseArray &&
                       !receiver._isResolved()) {
                receiver._promiseProgressed(progressValue, promise);
            }
            continue;
        }

        if (typeof handler === "function") {
            async.invoke(this._doProgressWith, this, {
                handler: handler,
                promise: promise,
                receiver: this._receiverAt(i),
                value: progressValue
            });
        } else {
            async.invoke(progress, promise, progressValue);
        }
    }
};
};

},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
"use strict";
module.exports = function() {
var makeSelfResolutionError = function () {
    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
};
var reflect = function() {
    return new Promise.PromiseInspection(this._target());
};
var apiRejection = function(msg) {
    return Promise.reject(new TypeError(msg));
};
var util = _dereq_("./util.js");
var async = _dereq_("./async.js");
var errors = _dereq_("./errors.js");
var TypeError = Promise.TypeError = errors.TypeError;
Promise.RangeError = errors.RangeError;
Promise.CancellationError = errors.CancellationError;
Promise.TimeoutError = errors.TimeoutError;
Promise.OperationalError = errors.OperationalError;
Promise.RejectionError = errors.OperationalError;
Promise.AggregateError = errors.AggregateError;
var INTERNAL = function(){};
var APPLY = {};
var NEXT_FILTER = {e: null};
var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
var PromiseArray =
    _dereq_("./promise_array.js")(Promise, INTERNAL,
                                    tryConvertToPromise, apiRejection);
var CapturedTrace = _dereq_("./captured_trace.js")();
var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
 /*jshint unused:false*/
var createContext =
    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
var PromiseResolver = _dereq_("./promise_resolver.js");
var nodebackForPromise = PromiseResolver._nodebackForPromise;
var errorObj = util.errorObj;
var tryCatch = util.tryCatch;
function Promise(resolver) {
    if (typeof resolver !== "function") {
        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
    }
    if (this.constructor !== Promise) {
        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
    }
    this._bitField = 0;
    this._fulfillmentHandler0 = undefined;
    this._rejectionHandler0 = undefined;
    this._progressHandler0 = undefined;
    this._promise0 = undefined;
    this._receiver0 = undefined;
    this._settledValue = undefined;
    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
}

Promise.prototype.toString = function () {
    return "[object Promise]";
};

Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
    var len = arguments.length;
    if (len > 1) {
        var catchInstances = new Array(len - 1),
            j = 0, i;
        for (i = 0; i < len - 1; ++i) {
            var item = arguments[i];
            if (typeof item === "function") {
                catchInstances[j++] = item;
            } else {
                return Promise.reject(
                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
            }
        }
        catchInstances.length = j;
        fn = arguments[i];
        var catchFilter = new CatchFilter(catchInstances, fn, this);
        return this._then(undefined, catchFilter.doFilter, undefined,
            catchFilter, undefined);
    }
    return this._then(undefined, fn, undefined, undefined, undefined);
};

Promise.prototype.reflect = function () {
    return this._then(reflect, reflect, undefined, this, undefined);
};

Promise.prototype.then = function (didFulfill, didReject, didProgress) {
    if (isDebugging() && arguments.length > 0 &&
        typeof didFulfill !== "function" &&
        typeof didReject !== "function") {
        var msg = ".then() only accepts functions but was passed: " +
                util.classString(didFulfill);
        if (arguments.length > 1) {
            msg += ", " + util.classString(didReject);
        }
        this._warn(msg);
    }
    return this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
};

Promise.prototype.done = function (didFulfill, didReject, didProgress) {
    var promise = this._then(didFulfill, didReject, didProgress,
        undefined, undefined);
    promise._setIsFinal();
};

Promise.prototype.spread = function (didFulfill, didReject) {
    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
};

Promise.prototype.isCancellable = function () {
    return !this.isResolved() &&
        this._cancellable();
};

Promise.prototype.toJSON = function () {
    var ret = {
        isFulfilled: false,
        isRejected: false,
        fulfillmentValue: undefined,
        rejectionReason: undefined
    };
    if (this.isFulfilled()) {
        ret.fulfillmentValue = this.value();
        ret.isFulfilled = true;
    } else if (this.isRejected()) {
        ret.rejectionReason = this.reason();
        ret.isRejected = true;
    }
    return ret;
};

Promise.prototype.all = function () {
    return new PromiseArray(this).promise();
};

Promise.prototype.error = function (fn) {
    return this.caught(util.originatesFromRejection, fn);
};

Promise.is = function (val) {
    return val instanceof Promise;
};

Promise.fromNode = function(fn) {
    var ret = new Promise(INTERNAL);
    var result = tryCatch(fn)(nodebackForPromise(ret));
    if (result === errorObj) {
        ret._rejectCallback(result.e, true, true);
    }
    return ret;
};

Promise.all = function (promises) {
    return new PromiseArray(promises).promise();
};

Promise.defer = Promise.pending = function () {
    var promise = new Promise(INTERNAL);
    return new PromiseResolver(promise);
};

Promise.cast = function (obj) {
    var ret = tryConvertToPromise(obj);
    if (!(ret instanceof Promise)) {
        var val = ret;
        ret = new Promise(INTERNAL);
        ret._fulfillUnchecked(val);
    }
    return ret;
};

Promise.resolve = Promise.fulfilled = Promise.cast;

Promise.reject = Promise.rejected = function (reason) {
    var ret = new Promise(INTERNAL);
    ret._captureStackTrace();
    ret._rejectCallback(reason, true);
    return ret;
};

Promise.setScheduler = function(fn) {
    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var prev = async._schedule;
    async._schedule = fn;
    return prev;
};

Promise.prototype._then = function (
    didFulfill,
    didReject,
    didProgress,
    receiver,
    internalData
) {
    var haveInternalData = internalData !== undefined;
    var ret = haveInternalData ? internalData : new Promise(INTERNAL);

    if (!haveInternalData) {
        ret._propagateFrom(this, 4 | 1);
        ret._captureStackTrace();
    }

    var target = this._target();
    if (target !== this) {
        if (receiver === undefined) receiver = this._boundTo;
        if (!haveInternalData) ret._setIsMigrated();
    }

    var callbackIndex =
        target._addCallbacks(didFulfill, didReject, didProgress, ret, receiver);

    if (target._isResolved() && !target._isSettlePromisesQueued()) {
        async.invoke(
            target._settlePromiseAtPostResolution, target, callbackIndex);
    }

    return ret;
};

Promise.prototype._settlePromiseAtPostResolution = function (index) {
    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
    this._settlePromiseAt(index);
};

Promise.prototype._length = function () {
    return this._bitField & 131071;
};

Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
    return (this._bitField & 939524096) > 0;
};

Promise.prototype._isFollowing = function () {
    return (this._bitField & 536870912) === 536870912;
};

Promise.prototype._setLength = function (len) {
    this._bitField = (this._bitField & -131072) |
        (len & 131071);
};

Promise.prototype._setFulfilled = function () {
    this._bitField = this._bitField | 268435456;
};

Promise.prototype._setRejected = function () {
    this._bitField = this._bitField | 134217728;
};

Promise.prototype._setFollowing = function () {
    this._bitField = this._bitField | 536870912;
};

Promise.prototype._setIsFinal = function () {
    this._bitField = this._bitField | 33554432;
};

Promise.prototype._isFinal = function () {
    return (this._bitField & 33554432) > 0;
};

Promise.prototype._cancellable = function () {
    return (this._bitField & 67108864) > 0;
};

Promise.prototype._setCancellable = function () {
    this._bitField = this._bitField | 67108864;
};

Promise.prototype._unsetCancellable = function () {
    this._bitField = this._bitField & (~67108864);
};

Promise.prototype._setIsMigrated = function () {
    this._bitField = this._bitField | 4194304;
};

Promise.prototype._unsetIsMigrated = function () {
    this._bitField = this._bitField & (~4194304);
};

Promise.prototype._isMigrated = function () {
    return (this._bitField & 4194304) > 0;
};

Promise.prototype._receiverAt = function (index) {
    var ret = index === 0
        ? this._receiver0
        : this[
            index * 5 - 5 + 4];
    if (ret === undefined && this._isBound()) {
        return this._boundTo;
    }
    return ret;
};

Promise.prototype._promiseAt = function (index) {
    return index === 0
        ? this._promise0
        : this[index * 5 - 5 + 3];
};

Promise.prototype._fulfillmentHandlerAt = function (index) {
    return index === 0
        ? this._fulfillmentHandler0
        : this[index * 5 - 5 + 0];
};

Promise.prototype._rejectionHandlerAt = function (index) {
    return index === 0
        ? this._rejectionHandler0
        : this[index * 5 - 5 + 1];
};

Promise.prototype._migrateCallbacks = function (follower, index) {
    var fulfill = follower._fulfillmentHandlerAt(index);
    var reject = follower._rejectionHandlerAt(index);
    var progress = follower._progressHandlerAt(index);
    var promise = follower._promiseAt(index);
    var receiver = follower._receiverAt(index);
    if (promise instanceof Promise) promise._setIsMigrated();
    this._addCallbacks(fulfill, reject, progress, promise, receiver);
};

Promise.prototype._addCallbacks = function (
    fulfill,
    reject,
    progress,
    promise,
    receiver
) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }

    if (index === 0) {
        this._promise0 = promise;
        if (receiver !== undefined) this._receiver0 = receiver;
        if (typeof fulfill === "function" && !this._isCarryingStackTrace())
            this._fulfillmentHandler0 = fulfill;
        if (typeof reject === "function") this._rejectionHandler0 = reject;
        if (typeof progress === "function") this._progressHandler0 = progress;
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promise;
        this[base + 4] = receiver;
        if (typeof fulfill === "function")
            this[base + 0] = fulfill;
        if (typeof reject === "function")
            this[base + 1] = reject;
        if (typeof progress === "function")
            this[base + 2] = progress;
    }
    this._setLength(index + 1);
    return index;
};

Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
    var index = this._length();

    if (index >= 131071 - 5) {
        index = 0;
        this._setLength(0);
    }
    if (index === 0) {
        this._promise0 = promiseSlotValue;
        this._receiver0 = receiver;
    } else {
        var base = index * 5 - 5;
        this[base + 3] = promiseSlotValue;
        this[base + 4] = receiver;
    }
    this._setLength(index + 1);
};

Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
    this._setProxyHandlers(promiseArray, index);
};

Promise.prototype._resolveCallback = function(value, shouldBind) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    if (value === this)
        return this._rejectCallback(makeSelfResolutionError(), false, true);
    var maybePromise = tryConvertToPromise(value, this);
    if (!(maybePromise instanceof Promise)) return this._fulfill(value);

    var propagationFlags = 1 | (shouldBind ? 4 : 0);
    this._propagateFrom(maybePromise, propagationFlags);
    var promise = maybePromise._target();
    if (promise._isPending()) {
        var len = this._length();
        for (var i = 0; i < len; ++i) {
            promise._migrateCallbacks(this, i);
        }
        this._setFollowing();
        this._setLength(0);
        this._setFollowee(promise);
    } else if (promise._isFulfilled()) {
        this._fulfillUnchecked(promise._value());
    } else {
        this._rejectUnchecked(promise._reason(),
            promise._getCarriedStackTrace());
    }
};

Promise.prototype._rejectCallback =
function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
    if (!shouldNotMarkOriginatingFromRejection) {
        util.markAsOriginatingFromRejection(reason);
    }
    var trace = util.ensureErrorObject(reason);
    var hasStack = trace === reason;
    this._attachExtraTrace(trace, synchronous ? hasStack : false);
    this._reject(reason, hasStack ? undefined : trace);
};

Promise.prototype._resolveFromResolver = function (resolver) {
    var promise = this;
    this._captureStackTrace();
    this._pushContext();
    var synchronous = true;
    var r = tryCatch(resolver)(function(value) {
        if (promise === null) return;
        promise._resolveCallback(value);
        promise = null;
    }, function (reason) {
        if (promise === null) return;
        promise._rejectCallback(reason, synchronous);
        promise = null;
    });
    synchronous = false;
    this._popContext();

    if (r !== undefined && r === errorObj && promise !== null) {
        promise._rejectCallback(r.e, true, true);
        promise = null;
    }
};

Promise.prototype._settlePromiseFromHandler = function (
    handler, receiver, value, promise
) {
    if (promise._isRejected()) return;
    promise._pushContext();
    var x;
    if (receiver === APPLY && !this._isRejected()) {
        x = tryCatch(handler).apply(this._boundTo, value);
    } else {
        x = tryCatch(handler).call(receiver, value);
    }
    promise._popContext();

    if (x === errorObj || x === promise || x === NEXT_FILTER) {
        var err = x === promise ? makeSelfResolutionError() : x.e;
        promise._rejectCallback(err, false, true);
    } else {
        promise._resolveCallback(x);
    }
};

Promise.prototype._target = function() {
    var ret = this;
    while (ret._isFollowing()) ret = ret._followee();
    return ret;
};

Promise.prototype._followee = function() {
    return this._rejectionHandler0;
};

Promise.prototype._setFollowee = function(promise) {
    this._rejectionHandler0 = promise;
};

Promise.prototype._cleanValues = function () {
    if (this._cancellable()) {
        this._cancellationParent = undefined;
    }
};

Promise.prototype._propagateFrom = function (parent, flags) {
    if ((flags & 1) > 0 && parent._cancellable()) {
        this._setCancellable();
        this._cancellationParent = parent;
    }
    if ((flags & 4) > 0 && parent._isBound()) {
        this._setBoundTo(parent._boundTo);
    }
};

Promise.prototype._fulfill = function (value) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._fulfillUnchecked(value);
};

Promise.prototype._reject = function (reason, carriedStackTrace) {
    if (this._isFollowingOrFulfilledOrRejected()) return;
    this._rejectUnchecked(reason, carriedStackTrace);
};

Promise.prototype._settlePromiseAt = function (index) {
    var promise = this._promiseAt(index);
    var isPromise = promise instanceof Promise;

    if (isPromise && promise._isMigrated()) {
        promise._unsetIsMigrated();
        return async.invoke(this._settlePromiseAt, this, index);
    }
    var handler = this._isFulfilled()
        ? this._fulfillmentHandlerAt(index)
        : this._rejectionHandlerAt(index);

    var carriedStackTrace =
        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
    var value = this._settledValue;
    var receiver = this._receiverAt(index);


    this._clearCallbackDataAtIndex(index);

    if (typeof handler === "function") {
        if (!isPromise) {
            handler.call(receiver, value, promise);
        } else {
            this._settlePromiseFromHandler(handler, receiver, value, promise);
        }
    } else if (receiver instanceof PromiseArray) {
        if (!receiver._isResolved()) {
            if (this._isFulfilled()) {
                receiver._promiseFulfilled(value, promise);
            }
            else {
                receiver._promiseRejected(value, promise);
            }
        }
    } else if (isPromise) {
        if (this._isFulfilled()) {
            promise._fulfill(value);
        } else {
            promise._reject(value, carriedStackTrace);
        }
    }

    if (index >= 4 && (index & 31) === 4)
        async.invokeLater(this._setLength, this, 0);
};

Promise.prototype._clearCallbackDataAtIndex = function(index) {
    if (index === 0) {
        if (!this._isCarryingStackTrace()) {
            this._fulfillmentHandler0 = undefined;
        }
        this._rejectionHandler0 =
        this._progressHandler0 =
        this._receiver0 =
        this._promise0 = undefined;
    } else {
        var base = index * 5 - 5;
        this[base + 3] =
        this[base + 4] =
        this[base + 0] =
        this[base + 1] =
        this[base + 2] = undefined;
    }
};

Promise.prototype._isSettlePromisesQueued = function () {
    return (this._bitField &
            -1073741824) === -1073741824;
};

Promise.prototype._setSettlePromisesQueued = function () {
    this._bitField = this._bitField | -1073741824;
};

Promise.prototype._unsetSettlePromisesQueued = function () {
    this._bitField = this._bitField & (~-1073741824);
};

Promise.prototype._queueSettlePromises = function() {
    async.settlePromises(this);
    this._setSettlePromisesQueued();
};

Promise.prototype._fulfillUnchecked = function (value) {
    if (value === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err, undefined);
    }
    this._setFulfilled();
    this._settledValue = value;
    this._cleanValues();

    if (this._length() > 0) {
        this._queueSettlePromises();
    }
};

Promise.prototype._rejectUncheckedCheckError = function (reason) {
    var trace = util.ensureErrorObject(reason);
    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
};

Promise.prototype._rejectUnchecked = function (reason, trace) {
    if (reason === this) {
        var err = makeSelfResolutionError();
        this._attachExtraTrace(err);
        return this._rejectUnchecked(err);
    }
    this._setRejected();
    this._settledValue = reason;
    this._cleanValues();

    if (this._isFinal()) {
        async.throwLater(function(e) {
            if ("stack" in e) {
                async.invokeFirst(
                    CapturedTrace.unhandledRejection, undefined, e);
            }
            throw e;
        }, trace === undefined ? reason : trace);
        return;
    }

    if (trace !== undefined && trace !== reason) {
        this._setCarriedStackTrace(trace);
    }

    if (this._length() > 0) {
        this._queueSettlePromises();
    } else {
        this._ensurePossibleRejectionHandled();
    }
};

Promise.prototype._settlePromises = function () {
    this._unsetSettlePromisesQueued();
    var len = this._length();
    for (var i = 0; i < len; i++) {
        this._settlePromiseAt(i);
    }
};

Promise._makeSelfResolutionError = makeSelfResolutionError;
_dereq_("./progress.js")(Promise, PromiseArray);
_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
_dereq_("./direct_resolve.js")(Promise);
_dereq_("./synchronous_inspection.js")(Promise);
_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
Promise.Promise = Promise;
_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./cancel.js')(Promise);
_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
_dereq_('./nodeify.js')(Promise);
_dereq_('./call_get.js')(Promise);
_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
_dereq_('./settle.js')(Promise, PromiseArray);
_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
_dereq_('./promisify.js')(Promise, INTERNAL);
_dereq_('./any.js')(Promise);
_dereq_('./each.js')(Promise, INTERNAL);
_dereq_('./timers.js')(Promise, INTERNAL);
_dereq_('./filter.js')(Promise, INTERNAL);
                                                         
    util.toFastProperties(Promise);                                          
    util.toFastProperties(Promise.prototype);                                
    function fillTypes(value) {                                              
        var p = new Promise(INTERNAL);                                       
        p._fulfillmentHandler0 = value;                                      
        p._rejectionHandler0 = value;                                        
        p._progressHandler0 = value;                                         
        p._promise0 = value;                                                 
        p._receiver0 = value;                                                
        p._settledValue = value;                                             
    }                                                                        
    // Complete slack tracking, opt out of field-type tracking and           
    // stabilize map                                                         
    fillTypes({a: 1});                                                       
    fillTypes({b: 2});                                                       
    fillTypes({c: 3});                                                       
    fillTypes(1);                                                            
    fillTypes(function(){});                                                 
    fillTypes(undefined);                                                    
    fillTypes(false);                                                        
    fillTypes(new Promise(INTERNAL));                                        
    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
    return Promise;                                                          

};

},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL, tryConvertToPromise,
    apiRejection) {
var util = _dereq_("./util.js");
var isArray = util.isArray;

function toResolutionValue(val) {
    switch(val) {
    case -2: return [];
    case -3: return {};
    }
}

function PromiseArray(values) {
    var promise = this._promise = new Promise(INTERNAL);
    var parent;
    if (values instanceof Promise) {
        parent = values;
        promise._propagateFrom(parent, 1 | 4);
    }
    this._values = values;
    this._length = 0;
    this._totalResolved = 0;
    this._init(undefined, -2);
}
PromiseArray.prototype.length = function () {
    return this._length;
};

PromiseArray.prototype.promise = function () {
    return this._promise;
};

PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
    var values = tryConvertToPromise(this._values, this._promise);
    if (values instanceof Promise) {
        values = values._target();
        this._values = values;
        if (values._isFulfilled()) {
            values = values._value();
            if (!isArray(values)) {
                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
                this.__hardReject__(err);
                return;
            }
        } else if (values._isPending()) {
            values._then(
                init,
                this._reject,
                undefined,
                this,
                resolveValueIfEmpty
           );
            return;
        } else {
            this._reject(values._reason());
            return;
        }
    } else if (!isArray(values)) {
        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
        return;
    }

    if (values.length === 0) {
        if (resolveValueIfEmpty === -5) {
            this._resolveEmptyArray();
        }
        else {
            this._resolve(toResolutionValue(resolveValueIfEmpty));
        }
        return;
    }
    var len = this.getActualLength(values.length);
    this._length = len;
    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
    var promise = this._promise;
    for (var i = 0; i < len; ++i) {
        var isResolved = this._isResolved();
        var maybePromise = tryConvertToPromise(values[i], promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (isResolved) {
                maybePromise._unsetRejectionIsUnhandled();
            } else if (maybePromise._isPending()) {
                maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                this._promiseFulfilled(maybePromise._value(), i);
            } else {
                this._promiseRejected(maybePromise._reason(), i);
            }
        } else if (!isResolved) {
            this._promiseFulfilled(maybePromise, i);
        }
    }
};

PromiseArray.prototype._isResolved = function () {
    return this._values === null;
};

PromiseArray.prototype._resolve = function (value) {
    this._values = null;
    this._promise._fulfill(value);
};

PromiseArray.prototype.__hardReject__ =
PromiseArray.prototype._reject = function (reason) {
    this._values = null;
    this._promise._rejectCallback(reason, false, true);
};

PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
    this._promise._progress({
        index: index,
        value: progressValue
    });
};


PromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

PromiseArray.prototype._promiseRejected = function (reason, index) {
    this._totalResolved++;
    this._reject(reason);
};

PromiseArray.prototype.shouldCopyValues = function () {
    return true;
};

PromiseArray.prototype.getActualLength = function (len) {
    return len;
};

return PromiseArray;
};

},{"./util.js":38}],25:[function(_dereq_,module,exports){
"use strict";
var util = _dereq_("./util.js");
var maybeWrapAsError = util.maybeWrapAsError;
var errors = _dereq_("./errors.js");
var TimeoutError = errors.TimeoutError;
var OperationalError = errors.OperationalError;
var haveGetters = util.haveGetters;
var es5 = _dereq_("./es5.js");

function isUntypedError(obj) {
    return obj instanceof Error &&
        es5.getPrototypeOf(obj) === Error.prototype;
}

var rErrorKey = /^(?:name|message|stack|cause)$/;
function wrapAsOperationalError(obj) {
    var ret;
    if (isUntypedError(obj)) {
        ret = new OperationalError(obj);
        ret.name = obj.name;
        ret.message = obj.message;
        ret.stack = obj.stack;
        var keys = es5.keys(obj);
        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!rErrorKey.test(key)) {
                ret[key] = obj[key];
            }
        }
        return ret;
    }
    util.markAsOriginatingFromRejection(obj);
    return obj;
}

function nodebackForPromise(promise) {
    return function(err, value) {
        if (promise === null) return;

        if (err) {
            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
            promise._attachExtraTrace(wrapped);
            promise._reject(wrapped);
        } else if (arguments.length > 2) {
            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
            promise._fulfill(args);
        } else {
            promise._fulfill(value);
        }

        promise = null;
    };
}


var PromiseResolver;
if (!haveGetters) {
    PromiseResolver = function (promise) {
        this.promise = promise;
        this.asCallback = nodebackForPromise(promise);
        this.callback = this.asCallback;
    };
}
else {
    PromiseResolver = function (promise) {
        this.promise = promise;
    };
}
if (haveGetters) {
    var prop = {
        get: function() {
            return nodebackForPromise(this.promise);
        }
    };
    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
}

PromiseResolver._nodebackForPromise = nodebackForPromise;

PromiseResolver.prototype.toString = function () {
    return "[object PromiseResolver]";
};

PromiseResolver.prototype.resolve =
PromiseResolver.prototype.fulfill = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._resolveCallback(value);
};

PromiseResolver.prototype.reject = function (reason) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._rejectCallback(reason);
};

PromiseResolver.prototype.progress = function (value) {
    if (!(this instanceof PromiseResolver)) {
        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
    }
    this.promise._progress(value);
};

PromiseResolver.prototype.cancel = function (err) {
    this.promise.cancel(err);
};

PromiseResolver.prototype.timeout = function () {
    this.reject(new TimeoutError("timeout"));
};

PromiseResolver.prototype.isResolved = function () {
    return this.promise.isResolved();
};

PromiseResolver.prototype.toJSON = function () {
    return this.promise.toJSON();
};

module.exports = PromiseResolver;

},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var THIS = {};
var util = _dereq_("./util.js");
var nodebackForPromise = _dereq_("./promise_resolver.js")
    ._nodebackForPromise;
var withAppended = util.withAppended;
var maybeWrapAsError = util.maybeWrapAsError;
var canEvaluate = util.canEvaluate;
var TypeError = _dereq_("./errors").TypeError;
var defaultSuffix = "Async";
var defaultPromisified = {__isPromisified__: true};
var noCopyPropsPattern =
    /^(?:length|name|arguments|caller|callee|prototype|__isPromisified__)$/;
var defaultFilter = function(name, func) {
    return util.isIdentifier(name) &&
        name.charAt(0) !== "_" &&
        !util.isClass(func);
};

function propsFilter(key) {
    return !noCopyPropsPattern.test(key);
}

function isPromisified(fn) {
    try {
        return fn.__isPromisified__ === true;
    }
    catch (e) {
        return false;
    }
}

function hasPromisified(obj, key, suffix) {
    var val = util.getDataPropertyOrDefault(obj, key + suffix,
                                            defaultPromisified);
    return val ? isPromisified(val) : false;
}
function checkValid(ret, suffix, suffixRegexp) {
    for (var i = 0; i < ret.length; i += 2) {
        var key = ret[i];
        if (suffixRegexp.test(key)) {
            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
            for (var j = 0; j < ret.length; j += 2) {
                if (ret[j] === keyWithoutAsyncSuffix) {
                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
                        .replace("%s", suffix));
                }
            }
        }
    }
}

function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
    var keys = util.inheritedDataKeys(obj);
    var ret = [];
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var value = obj[key];
        var passesDefaultFilter = filter === defaultFilter
            ? true : defaultFilter(key, value, obj);
        if (typeof value === "function" &&
            !isPromisified(value) &&
            !hasPromisified(obj, key, suffix) &&
            filter(key, value, obj, passesDefaultFilter)) {
            ret.push(key, value);
        }
    }
    checkValid(ret, suffix, suffixRegexp);
    return ret;
}

var escapeIdentRegex = function(str) {
    return str.replace(/([$])/, "\\$");
};

var makeNodePromisifiedEval;
if (false) { var parameterCount, parameterDeclaration, argumentSequence, switchCaseArgumentOrder; }

function makeNodePromisifiedClosure(callback, receiver, _, fn) {
    var defaultThis = (function() {return this;})();
    var method = callback;
    if (typeof method === "string") {
        callback = fn;
    }
    function promisified() {
        var _receiver = receiver;
        if (receiver === THIS) _receiver = this;
        var promise = new Promise(INTERNAL);
        promise._captureStackTrace();
        var cb = typeof method === "string" && this !== defaultThis
            ? this[method] : callback;
        var fn = nodebackForPromise(promise);
        try {
            cb.apply(_receiver, withAppended(arguments, fn));
        } catch(e) {
            promise._rejectCallback(maybeWrapAsError(e), true, true);
        }
        return promise;
    }
    promisified.__isPromisified__ = true;
    return promisified;
}

var makeNodePromisified = canEvaluate
    ? makeNodePromisifiedEval
    : makeNodePromisifiedClosure;

function promisifyAll(obj, suffix, filter, promisifier) {
    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
    var methods =
        promisifiableMethods(obj, suffix, suffixRegexp, filter);

    for (var i = 0, len = methods.length; i < len; i+= 2) {
        var key = methods[i];
        var fn = methods[i+1];
        var promisifiedKey = key + suffix;
        obj[promisifiedKey] = promisifier === makeNodePromisified
                ? makeNodePromisified(key, THIS, key, fn, suffix)
                : promisifier(fn, function() {
                    return makeNodePromisified(key, THIS, key, fn, suffix);
                });
    }
    util.toFastProperties(obj);
    return obj;
}

function promisify(callback, receiver) {
    return makeNodePromisified(callback, receiver, undefined, callback);
}

Promise.promisify = function (fn, receiver) {
    if (typeof fn !== "function") {
        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    }
    if (isPromisified(fn)) {
        return fn;
    }
    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
    util.copyDescriptors(fn, ret, propsFilter);
    return ret;
};

Promise.promisifyAll = function (target, options) {
    if (typeof target !== "function" && typeof target !== "object") {
        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
    }
    options = Object(options);
    var suffix = options.suffix;
    if (typeof suffix !== "string") suffix = defaultSuffix;
    var filter = options.filter;
    if (typeof filter !== "function") filter = defaultFilter;
    var promisifier = options.promisifier;
    if (typeof promisifier !== "function") promisifier = makeNodePromisified;

    if (!util.isIdentifier(suffix)) {
        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
    }

    var keys = util.inheritedDataKeys(target);
    for (var i = 0; i < keys.length; ++i) {
        var value = target[keys[i]];
        if (keys[i] !== "constructor" &&
            util.isClass(value)) {
            promisifyAll(value.prototype, suffix, filter, promisifier);
            promisifyAll(value, suffix, filter, promisifier);
        }
    }

    return promisifyAll(target, suffix, filter, promisifier);
};
};


},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
var util = _dereq_("./util.js");
var isObject = util.isObject;
var es5 = _dereq_("./es5.js");

function PropertiesPromiseArray(obj) {
    var keys = es5.keys(obj);
    var len = keys.length;
    var values = new Array(len * 2);
    for (var i = 0; i < len; ++i) {
        var key = keys[i];
        values[i] = obj[key];
        values[i + len] = key;
    }
    this.constructor$(values);
}
util.inherits(PropertiesPromiseArray, PromiseArray);

PropertiesPromiseArray.prototype._init = function () {
    this._init$(undefined, -3) ;
};

PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
    this._values[index] = value;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        var val = {};
        var keyOffset = this.length();
        for (var i = 0, len = this.length(); i < len; ++i) {
            val[this._values[i + keyOffset]] = this._values[i];
        }
        this._resolve(val);
    }
};

PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
    this._promise._progress({
        key: this._values[index + this.length()],
        value: value
    });
};

PropertiesPromiseArray.prototype.shouldCopyValues = function () {
    return false;
};

PropertiesPromiseArray.prototype.getActualLength = function (len) {
    return len >> 1;
};

function props(promises) {
    var ret;
    var castValue = tryConvertToPromise(promises);

    if (!isObject(castValue)) {
        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
    } else if (castValue instanceof Promise) {
        ret = castValue._then(
            Promise.props, undefined, undefined, undefined, undefined);
    } else {
        ret = new PropertiesPromiseArray(castValue).promise();
    }

    if (castValue instanceof Promise) {
        ret._propagateFrom(castValue, 4);
    }
    return ret;
}

Promise.prototype.props = function () {
    return props(this);
};

Promise.props = function (promises) {
    return props(promises);
};
};

},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
"use strict";
function arrayMove(src, srcIndex, dst, dstIndex, len) {
    for (var j = 0; j < len; ++j) {
        dst[j + dstIndex] = src[j + srcIndex];
        src[j + srcIndex] = void 0;
    }
}

function Queue(capacity) {
    this._capacity = capacity;
    this._length = 0;
    this._front = 0;
}

Queue.prototype._willBeOverCapacity = function (size) {
    return this._capacity < size;
};

Queue.prototype._pushOne = function (arg) {
    var length = this.length();
    this._checkCapacity(length + 1);
    var i = (this._front + length) & (this._capacity - 1);
    this[i] = arg;
    this._length = length + 1;
};

Queue.prototype._unshiftOne = function(value) {
    var capacity = this._capacity;
    this._checkCapacity(this.length() + 1);
    var front = this._front;
    var i = (((( front - 1 ) &
                    ( capacity - 1) ) ^ capacity ) - capacity );
    this[i] = value;
    this._front = i;
    this._length = this.length() + 1;
};

Queue.prototype.unshift = function(fn, receiver, arg) {
    this._unshiftOne(arg);
    this._unshiftOne(receiver);
    this._unshiftOne(fn);
};

Queue.prototype.push = function (fn, receiver, arg) {
    var length = this.length() + 3;
    if (this._willBeOverCapacity(length)) {
        this._pushOne(fn);
        this._pushOne(receiver);
        this._pushOne(arg);
        return;
    }
    var j = this._front + length - 3;
    this._checkCapacity(length);
    var wrapMask = this._capacity - 1;
    this[(j + 0) & wrapMask] = fn;
    this[(j + 1) & wrapMask] = receiver;
    this[(j + 2) & wrapMask] = arg;
    this._length = length;
};

Queue.prototype.shift = function () {
    var front = this._front,
        ret = this[front];

    this[front] = undefined;
    this._front = (front + 1) & (this._capacity - 1);
    this._length--;
    return ret;
};

Queue.prototype.length = function () {
    return this._length;
};

Queue.prototype._checkCapacity = function (size) {
    if (this._capacity < size) {
        this._resizeTo(this._capacity << 1);
    }
};

Queue.prototype._resizeTo = function (capacity) {
    var oldCapacity = this._capacity;
    this._capacity = capacity;
    var front = this._front;
    var length = this._length;
    var moveItemsCount = (front + length) & (oldCapacity - 1);
    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
};

module.exports = Queue;

},{}],29:[function(_dereq_,module,exports){
"use strict";
module.exports = function(
    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
var isArray = _dereq_("./util.js").isArray;

var raceLater = function (promise) {
    return promise.then(function(array) {
        return race(array, promise);
    });
};

function race(promises, parent) {
    var maybePromise = tryConvertToPromise(promises);

    if (maybePromise instanceof Promise) {
        return raceLater(maybePromise);
    } else if (!isArray(promises)) {
        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
    }

    var ret = new Promise(INTERNAL);
    if (parent !== undefined) {
        ret._propagateFrom(parent, 4 | 1);
    }
    var fulfill = ret._fulfill;
    var reject = ret._reject;
    for (var i = 0, len = promises.length; i < len; ++i) {
        var val = promises[i];

        if (val === undefined && !(i in promises)) {
            continue;
        }

        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
    }
    return ret;
}

Promise.race = function (promises) {
    return race(promises, undefined);
};

Promise.prototype.race = function () {
    return race(this, undefined);
};

};

},{"./util.js":38}],30:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise,
                          PromiseArray,
                          apiRejection,
                          tryConvertToPromise,
                          INTERNAL) {
var async = _dereq_("./async.js");
var util = _dereq_("./util.js");
var tryCatch = util.tryCatch;
var errorObj = util.errorObj;
function ReductionPromiseArray(promises, fn, accum, _each) {
    this.constructor$(promises);
    this._promise._captureStackTrace();
    this._preservedValues = _each === INTERNAL ? [] : null;
    this._zerothIsAccum = (accum === undefined);
    this._gotAccum = false;
    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
    this._valuesPhase = undefined;
    var maybePromise = tryConvertToPromise(accum, this._promise);
    var rejected = false;
    var isPromise = maybePromise instanceof Promise;
    if (isPromise) {
        maybePromise = maybePromise._target();
        if (maybePromise._isPending()) {
            maybePromise._proxyPromiseArray(this, -1);
        } else if (maybePromise._isFulfilled()) {
            accum = maybePromise._value();
            this._gotAccum = true;
        } else {
            this._reject(maybePromise._reason());
            rejected = true;
        }
    }
    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
    this._callback = fn;
    this._accum = accum;
    if (!rejected) async.invoke(init, this, undefined);
}
function init() {
    this._init$(undefined, -5);
}
util.inherits(ReductionPromiseArray, PromiseArray);

ReductionPromiseArray.prototype._init = function () {};

ReductionPromiseArray.prototype._resolveEmptyArray = function () {
    if (this._gotAccum || this._zerothIsAccum) {
        this._resolve(this._preservedValues !== null
                        ? [] : this._accum);
    }
};

ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var values = this._values;
    values[index] = value;
    var length = this.length();
    var preservedValues = this._preservedValues;
    var isEach = preservedValues !== null;
    var gotAccum = this._gotAccum;
    var valuesPhase = this._valuesPhase;
    var valuesPhaseIndex;
    if (!valuesPhase) {
        valuesPhase = this._valuesPhase = new Array(length);
        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
            valuesPhase[valuesPhaseIndex] = 0;
        }
    }
    valuesPhaseIndex = valuesPhase[index];

    if (index === 0 && this._zerothIsAccum) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
        valuesPhase[index] = ((valuesPhaseIndex === 0)
            ? 1 : 2);
    } else if (index === -1) {
        this._accum = value;
        this._gotAccum = gotAccum = true;
    } else {
        if (valuesPhaseIndex === 0) {
            valuesPhase[index] = 1;
        } else {
            valuesPhase[index] = 2;
            this._accum = value;
        }
    }
    if (!gotAccum) return;

    var callback = this._callback;
    var receiver = this._promise._boundTo;
    var ret;

    for (var i = this._reducingIndex; i < length; ++i) {
        valuesPhaseIndex = valuesPhase[i];
        if (valuesPhaseIndex === 2) {
            this._reducingIndex = i + 1;
            continue;
        }
        if (valuesPhaseIndex !== 1) return;
        value = values[i];
        this._promise._pushContext();
        if (isEach) {
            preservedValues.push(value);
            ret = tryCatch(callback).call(receiver, value, i, length);
        }
        else {
            ret = tryCatch(callback)
                .call(receiver, this._accum, value, i, length);
        }
        this._promise._popContext();

        if (ret === errorObj) return this._reject(ret.e);

        var maybePromise = tryConvertToPromise(ret, this._promise);
        if (maybePromise instanceof Promise) {
            maybePromise = maybePromise._target();
            if (maybePromise._isPending()) {
                valuesPhase[i] = 4;
                return maybePromise._proxyPromiseArray(this, i);
            } else if (maybePromise._isFulfilled()) {
                ret = maybePromise._value();
            } else {
                return this._reject(maybePromise._reason());
            }
        }

        this._reducingIndex = i + 1;
        this._accum = ret;
    }

    this._resolve(isEach ? preservedValues : this._accum);
};

function reduce(promises, fn, initialValue, _each) {
    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
    return array.promise();
}

Promise.prototype.reduce = function (fn, initialValue) {
    return reduce(this, fn, initialValue, null);
};

Promise.reduce = function (promises, fn, initialValue, _each) {
    return reduce(promises, fn, initialValue, _each);
};
};

},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
"use strict";
var schedule;
var noAsyncScheduler = function() {
    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
};
if (_dereq_("./util.js").isNode) {
    var version = process.versions.node.split(".").map(Number);
    schedule = (version[0] === 0 && version[1] > 10) || (version[0] > 0)
        ? global.setImmediate : process.nextTick;

    if (!schedule) {
        if (typeof setImmediate !== "undefined") {
            schedule = setImmediate;
        } else if (typeof setTimeout !== "undefined") {
            schedule = setTimeout;
        } else {
            schedule = noAsyncScheduler;
        }
    }
} else if (typeof MutationObserver !== "undefined") {
    schedule = function(fn) {
        var div = document.createElement("div");
        var observer = new MutationObserver(fn);
        observer.observe(div, {attributes: true});
        return function() { div.classList.toggle("foo"); };
    };
    schedule.isStatic = true;
} else if (typeof setImmediate !== "undefined") {
    schedule = function (fn) {
        setImmediate(fn);
    };
} else if (typeof setTimeout !== "undefined") {
    schedule = function (fn) {
        setTimeout(fn, 0);
    };
} else {
    schedule = noAsyncScheduler;
}
module.exports = schedule;

},{"./util.js":38}],32:[function(_dereq_,module,exports){
"use strict";
module.exports =
    function(Promise, PromiseArray) {
var PromiseInspection = Promise.PromiseInspection;
var util = _dereq_("./util.js");

function SettledPromiseArray(values) {
    this.constructor$(values);
}
util.inherits(SettledPromiseArray, PromiseArray);

SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
    this._values[index] = inspection;
    var totalResolved = ++this._totalResolved;
    if (totalResolved >= this._length) {
        this._resolve(this._values);
    }
};

SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
    var ret = new PromiseInspection();
    ret._bitField = 268435456;
    ret._settledValue = value;
    this._promiseResolved(index, ret);
};
SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
    var ret = new PromiseInspection();
    ret._bitField = 134217728;
    ret._settledValue = reason;
    this._promiseResolved(index, ret);
};

Promise.settle = function (promises) {
    return new SettledPromiseArray(promises).promise();
};

Promise.prototype.settle = function () {
    return new SettledPromiseArray(this).promise();
};
};

},{"./util.js":38}],33:[function(_dereq_,module,exports){
"use strict";
module.exports =
function(Promise, PromiseArray, apiRejection) {
var util = _dereq_("./util.js");
var RangeError = _dereq_("./errors.js").RangeError;
var AggregateError = _dereq_("./errors.js").AggregateError;
var isArray = util.isArray;


function SomePromiseArray(values) {
    this.constructor$(values);
    this._howMany = 0;
    this._unwrap = false;
    this._initialized = false;
}
util.inherits(SomePromiseArray, PromiseArray);

SomePromiseArray.prototype._init = function () {
    if (!this._initialized) {
        return;
    }
    if (this._howMany === 0) {
        this._resolve([]);
        return;
    }
    this._init$(undefined, -5);
    var isArrayResolved = isArray(this._values);
    if (!this._isResolved() &&
        isArrayResolved &&
        this._howMany > this._canPossiblyFulfill()) {
        this._reject(this._getRangeError(this.length()));
    }
};

SomePromiseArray.prototype.init = function () {
    this._initialized = true;
    this._init();
};

SomePromiseArray.prototype.setUnwrap = function () {
    this._unwrap = true;
};

SomePromiseArray.prototype.howMany = function () {
    return this._howMany;
};

SomePromiseArray.prototype.setHowMany = function (count) {
    this._howMany = count;
};

SomePromiseArray.prototype._promiseFulfilled = function (value) {
    this._addFulfilled(value);
    if (this._fulfilled() === this.howMany()) {
        this._values.length = this.howMany();
        if (this.howMany() === 1 && this._unwrap) {
            this._resolve(this._values[0]);
        } else {
            this._resolve(this._values);
        }
    }

};
SomePromiseArray.prototype._promiseRejected = function (reason) {
    this._addRejected(reason);
    if (this.howMany() > this._canPossiblyFulfill()) {
        var e = new AggregateError();
        for (var i = this.length(); i < this._values.length; ++i) {
            e.push(this._values[i]);
        }
        this._reject(e);
    }
};

SomePromiseArray.prototype._fulfilled = function () {
    return this._totalResolved;
};

SomePromiseArray.prototype._rejected = function () {
    return this._values.length - this.length();
};

SomePromiseArray.prototype._addRejected = function (reason) {
    this._values.push(reason);
};

SomePromiseArray.prototype._addFulfilled = function (value) {
    this._values[this._totalResolved++] = value;
};

SomePromiseArray.prototype._canPossiblyFulfill = function () {
    return this.length() - this._rejected();
};

SomePromiseArray.prototype._getRangeError = function (count) {
    var message = "Input array must contain at least " +
            this._howMany + " items but contains only " + count + " items";
    return new RangeError(message);
};

SomePromiseArray.prototype._resolveEmptyArray = function () {
    this._reject(this._getRangeError(0));
};

function some(promises, howMany) {
    if ((howMany | 0) !== howMany || howMany < 0) {
        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
    }
    var ret = new SomePromiseArray(promises);
    var promise = ret.promise();
    ret.setHowMany(howMany);
    ret.init();
    return promise;
}

Promise.some = function (promises, howMany) {
    return some(promises, howMany);
};

Promise.prototype.some = function (howMany) {
    return some(this, howMany);
};

Promise._SomePromiseArray = SomePromiseArray;
};

},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise) {
function PromiseInspection(promise) {
    if (promise !== undefined) {
        promise = promise._target();
        this._bitField = promise._bitField;
        this._settledValue = promise._settledValue;
    }
    else {
        this._bitField = 0;
        this._settledValue = undefined;
    }
}

PromiseInspection.prototype.value = function () {
    if (!this.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.error =
PromiseInspection.prototype.reason = function () {
    if (!this.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    return this._settledValue;
};

PromiseInspection.prototype.isFulfilled =
Promise.prototype._isFulfilled = function () {
    return (this._bitField & 268435456) > 0;
};

PromiseInspection.prototype.isRejected =
Promise.prototype._isRejected = function () {
    return (this._bitField & 134217728) > 0;
};

PromiseInspection.prototype.isPending =
Promise.prototype._isPending = function () {
    return (this._bitField & 402653184) === 0;
};

PromiseInspection.prototype.isResolved =
Promise.prototype._isResolved = function () {
    return (this._bitField & 402653184) > 0;
};

Promise.prototype.isPending = function() {
    return this._target()._isPending();
};

Promise.prototype.isRejected = function() {
    return this._target()._isRejected();
};

Promise.prototype.isFulfilled = function() {
    return this._target()._isFulfilled();
};

Promise.prototype.isResolved = function() {
    return this._target()._isResolved();
};

Promise.prototype._value = function() {
    return this._settledValue;
};

Promise.prototype._reason = function() {
    this._unsetRejectionIsUnhandled();
    return this._settledValue;
};

Promise.prototype.value = function() {
    var target = this._target();
    if (!target.isFulfilled()) {
        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
    }
    return target._settledValue;
};

Promise.prototype.reason = function() {
    var target = this._target();
    if (!target.isRejected()) {
        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
    }
    target._unsetRejectionIsUnhandled();
    return target._settledValue;
};


Promise.PromiseInspection = PromiseInspection;
};

},{}],35:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var errorObj = util.errorObj;
var isObject = util.isObject;

function tryConvertToPromise(obj, context) {
    if (isObject(obj)) {
        if (obj instanceof Promise) {
            return obj;
        }
        else if (isAnyBluebirdPromise(obj)) {
            var ret = new Promise(INTERNAL);
            obj._then(
                ret._fulfillUnchecked,
                ret._rejectUncheckedCheckError,
                ret._progressUnchecked,
                ret,
                null
            );
            return ret;
        }
        var then = util.tryCatch(getThen)(obj);
        if (then === errorObj) {
            if (context) context._pushContext();
            var ret = Promise.reject(then.e);
            if (context) context._popContext();
            return ret;
        } else if (typeof then === "function") {
            return doThenable(obj, then, context);
        }
    }
    return obj;
}

function getThen(obj) {
    return obj.then;
}

var hasProp = {}.hasOwnProperty;
function isAnyBluebirdPromise(obj) {
    return hasProp.call(obj, "_promise0");
}

function doThenable(x, then, context) {
    var promise = new Promise(INTERNAL);
    var ret = promise;
    if (context) context._pushContext();
    promise._captureStackTrace();
    if (context) context._popContext();
    var synchronous = true;
    var result = util.tryCatch(then).call(x,
                                        resolveFromThenable,
                                        rejectFromThenable,
                                        progressFromThenable);
    synchronous = false;
    if (promise && result === errorObj) {
        promise._rejectCallback(result.e, true, true);
        promise = null;
    }

    function resolveFromThenable(value) {
        if (!promise) return;
        if (x === value) {
            promise._rejectCallback(
                Promise._makeSelfResolutionError(), false, true);
        } else {
            promise._resolveCallback(value);
        }
        promise = null;
    }

    function rejectFromThenable(reason) {
        if (!promise) return;
        promise._rejectCallback(reason, synchronous, true);
        promise = null;
    }

    function progressFromThenable(value) {
        if (!promise) return;
        if (typeof promise._progress === "function") {
            promise._progress(value);
        }
    }
    return ret;
}

return tryConvertToPromise;
};

},{"./util.js":38}],36:[function(_dereq_,module,exports){
"use strict";
module.exports = function(Promise, INTERNAL) {
var util = _dereq_("./util.js");
var TimeoutError = Promise.TimeoutError;

var afterTimeout = function (promise, message) {
    if (!promise.isPending()) return;
    if (typeof message !== "string") {
        message = "operation timed out";
    }
    var err = new TimeoutError(message);
    util.markAsOriginatingFromRejection(err);
    promise._attachExtraTrace(err);
    promise._cancel(err);
};

var afterValue = function(value) { return delay(+this).thenReturn(value); };
var delay = Promise.delay = function (value, ms) {
    if (ms === undefined) {
        ms = value;
        value = undefined;
        var ret = new Promise(INTERNAL);
        setTimeout(function() { ret._fulfill(); }, ms);
        return ret;
    }
    ms = +ms;
    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
};

Promise.prototype.delay = function (ms) {
    return delay(this, ms);
};

function successClear(value) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    return value;
}

function failureClear(reason) {
    var handle = this;
    if (handle instanceof Number) handle = +handle;
    clearTimeout(handle);
    throw reason;
}

Promise.prototype.timeout = function (ms, message) {
    ms = +ms;
    var ret = this.then().cancellable();
    ret._cancellationParent = this;
    var handle = setTimeout(function timeoutTimeout() {
        afterTimeout(ret, message);
    }, ms);
    return ret._then(successClear, failureClear, undefined, handle, undefined);
};

};

},{"./util.js":38}],37:[function(_dereq_,module,exports){
"use strict";
module.exports = function (Promise, apiRejection, tryConvertToPromise,
    createContext) {
    var TypeError = _dereq_("./errors.js").TypeError;
    var inherits = _dereq_("./util.js").inherits;
    var PromiseInspection = Promise.PromiseInspection;

    function inspectionMapper(inspections) {
        var len = inspections.length;
        for (var i = 0; i < len; ++i) {
            var inspection = inspections[i];
            if (inspection.isRejected()) {
                return Promise.reject(inspection.error());
            }
            inspections[i] = inspection._settledValue;
        }
        return inspections;
    }

    function thrower(e) {
        setTimeout(function(){throw e;}, 0);
    }

    function castPreservingDisposable(thenable) {
        var maybePromise = tryConvertToPromise(thenable);
        if (maybePromise !== thenable &&
            typeof thenable._isDisposable === "function" &&
            typeof thenable._getDisposer === "function" &&
            thenable._isDisposable()) {
            maybePromise._setDisposable(thenable._getDisposer());
        }
        return maybePromise;
    }
    function dispose(resources, inspection) {
        var i = 0;
        var len = resources.length;
        var ret = Promise.defer();
        function iterator() {
            if (i >= len) return ret.resolve();
            var maybePromise = castPreservingDisposable(resources[i++]);
            if (maybePromise instanceof Promise &&
                maybePromise._isDisposable()) {
                try {
                    maybePromise = tryConvertToPromise(
                        maybePromise._getDisposer().tryDispose(inspection),
                        resources.promise);
                } catch (e) {
                    return thrower(e);
                }
                if (maybePromise instanceof Promise) {
                    return maybePromise._then(iterator, thrower,
                                              null, null, null);
                }
            }
            iterator();
        }
        iterator();
        return ret.promise;
    }

    function disposerSuccess(value) {
        var inspection = new PromiseInspection();
        inspection._settledValue = value;
        inspection._bitField = 268435456;
        return dispose(this, inspection).thenReturn(value);
    }

    function disposerFail(reason) {
        var inspection = new PromiseInspection();
        inspection._settledValue = reason;
        inspection._bitField = 134217728;
        return dispose(this, inspection).thenThrow(reason);
    }

    function Disposer(data, promise, context) {
        this._data = data;
        this._promise = promise;
        this._context = context;
    }

    Disposer.prototype.data = function () {
        return this._data;
    };

    Disposer.prototype.promise = function () {
        return this._promise;
    };

    Disposer.prototype.resource = function () {
        if (this.promise().isFulfilled()) {
            return this.promise().value();
        }
        return null;
    };

    Disposer.prototype.tryDispose = function(inspection) {
        var resource = this.resource();
        var context = this._context;
        if (context !== undefined) context._pushContext();
        var ret = resource !== null
            ? this.doDispose(resource, inspection) : null;
        if (context !== undefined) context._popContext();
        this._promise._unsetDisposable();
        this._data = null;
        return ret;
    };

    Disposer.isDisposer = function (d) {
        return (d != null &&
                typeof d.resource === "function" &&
                typeof d.tryDispose === "function");
    };

    function FunctionDisposer(fn, promise, context) {
        this.constructor$(fn, promise, context);
    }
    inherits(FunctionDisposer, Disposer);

    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
        var fn = this.data();
        return fn.call(resource, resource, inspection);
    };

    function maybeUnwrapDisposer(value) {
        if (Disposer.isDisposer(value)) {
            this.resources[this.index]._setDisposable(value);
            return value.promise();
        }
        return value;
    }

    Promise.using = function () {
        var len = arguments.length;
        if (len < 2) return apiRejection(
                        "you must pass at least 2 arguments to Promise.using");
        var fn = arguments[len - 1];
        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
        len--;
        var resources = new Array(len);
        for (var i = 0; i < len; ++i) {
            var resource = arguments[i];
            if (Disposer.isDisposer(resource)) {
                var disposer = resource;
                resource = resource.promise();
                resource._setDisposable(disposer);
            } else {
                var maybePromise = tryConvertToPromise(resource);
                if (maybePromise instanceof Promise) {
                    resource =
                        maybePromise._then(maybeUnwrapDisposer, null, null, {
                            resources: resources,
                            index: i
                    }, undefined);
                }
            }
            resources[i] = resource;
        }

        var promise = Promise.settle(resources)
            .then(inspectionMapper)
            .then(function(vals) {
                promise._pushContext();
                var ret;
                try {
                    ret = fn.apply(undefined, vals);
                } finally {
                    promise._popContext();
                }
                return ret;
            })
            ._then(
                disposerSuccess, disposerFail, undefined, resources, undefined);
        resources.promise = promise;
        return promise;
    };

    Promise.prototype._setDisposable = function (disposer) {
        this._bitField = this._bitField | 262144;
        this._disposer = disposer;
    };

    Promise.prototype._isDisposable = function () {
        return (this._bitField & 262144) > 0;
    };

    Promise.prototype._getDisposer = function () {
        return this._disposer;
    };

    Promise.prototype._unsetDisposable = function () {
        this._bitField = this._bitField & (~262144);
        this._disposer = undefined;
    };

    Promise.prototype.disposer = function (fn) {
        if (typeof fn === "function") {
            return new FunctionDisposer(fn, this, createContext());
        }
        throw new TypeError();
    };

};

},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
"use strict";
var es5 = _dereq_("./es5.js");
var canEvaluate = typeof navigator == "undefined";
var haveGetters = (function(){
    try {
        var o = {};
        es5.defineProperty(o, "f", {
            get: function () {
                return 3;
            }
        });
        return o.f === 3;
    }
    catch (e) {
        return false;
    }

})();

var errorObj = {e: {}};
var tryCatchTarget;
function tryCatcher() {
    try {
        return tryCatchTarget.apply(this, arguments);
    } catch (e) {
        errorObj.e = e;
        return errorObj;
    }
}
function tryCatch(fn) {
    tryCatchTarget = fn;
    return tryCatcher;
}

var inherits = function(Child, Parent) {
    var hasProp = {}.hasOwnProperty;

    function T() {
        this.constructor = Child;
        this.constructor$ = Parent;
        for (var propertyName in Parent.prototype) {
            if (hasProp.call(Parent.prototype, propertyName) &&
                propertyName.charAt(propertyName.length-1) !== "$"
           ) {
                this[propertyName + "$"] = Parent.prototype[propertyName];
            }
        }
    }
    T.prototype = Parent.prototype;
    Child.prototype = new T();
    return Child.prototype;
};


function isPrimitive(val) {
    return val == null || val === true || val === false ||
        typeof val === "string" || typeof val === "number";

}

function isObject(value) {
    return !isPrimitive(value);
}

function maybeWrapAsError(maybeError) {
    if (!isPrimitive(maybeError)) return maybeError;

    return new Error(safeToString(maybeError));
}

function withAppended(target, appendee) {
    var len = target.length;
    var ret = new Array(len + 1);
    var i;
    for (i = 0; i < len; ++i) {
        ret[i] = target[i];
    }
    ret[i] = appendee;
    return ret;
}

function getDataPropertyOrDefault(obj, key, defaultValue) {
    if (es5.isES5) {
        var desc = Object.getOwnPropertyDescriptor(obj, key);
        if (desc != null) {
            return desc.get == null && desc.set == null
                    ? desc.value
                    : defaultValue;
        }
    } else {
        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
    }
}

function notEnumerableProp(obj, name, value) {
    if (isPrimitive(obj)) return obj;
    var descriptor = {
        value: value,
        configurable: true,
        enumerable: false,
        writable: true
    };
    es5.defineProperty(obj, name, descriptor);
    return obj;
}


var wrapsPrimitiveReceiver = (function() {
    return this !== "string";
}).call("string");

function thrower(r) {
    throw r;
}

var inheritedDataKeys = (function() {
    if (es5.isES5) {
        var oProto = Object.prototype;
        var getKeys = Object.getOwnPropertyNames;
        return function(obj) {
            var ret = [];
            var visitedKeys = Object.create(null);
            while (obj != null && obj !== oProto) {
                var keys;
                try {
                    keys = getKeys(obj);
                } catch (e) {
                    return ret;
                }
                for (var i = 0; i < keys.length; ++i) {
                    var key = keys[i];
                    if (visitedKeys[key]) continue;
                    visitedKeys[key] = true;
                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                    if (desc != null && desc.get == null && desc.set == null) {
                        ret.push(key);
                    }
                }
                obj = es5.getPrototypeOf(obj);
            }
            return ret;
        };
    } else {
        return function(obj) {
            var ret = [];
            /*jshint forin:false */
            for (var key in obj) {
                ret.push(key);
            }
            return ret;
        };
    }

})();

function isClass(fn) {
    try {
        if (typeof fn === "function") {
            var keys = es5.names(fn.prototype);
            if (es5.isES5) return keys.length > 1;
            return keys.length > 0 &&
                   !(keys.length === 1 && keys[0] === "constructor");
        }
        return false;
    } catch (e) {
        return false;
    }
}

function toFastProperties(obj) {
    /*jshint -W027,-W055,-W031*/
    function f() {}
    f.prototype = obj;
    var l = 8;
    while (l--) new f();
    return obj;
    eval(obj);
}

var rident = /^[a-z$_][a-z$_0-9]*$/i;
function isIdentifier(str) {
    return rident.test(str);
}

function filledRange(count, prefix, suffix) {
    var ret = new Array(count);
    for(var i = 0; i < count; ++i) {
        ret[i] = prefix + i + suffix;
    }
    return ret;
}

function safeToString(obj) {
    try {
        return obj + "";
    } catch (e) {
        return "[no string representation]";
    }
}

function markAsOriginatingFromRejection(e) {
    try {
        notEnumerableProp(e, "isOperational", true);
    }
    catch(ignore) {}
}

function originatesFromRejection(e) {
    if (e == null) return false;
    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
        e["isOperational"] === true);
}

function canAttachTrace(obj) {
    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
}

var ensureErrorObject = (function() {
    if (!("stack" in new Error())) {
        return function(value) {
            if (canAttachTrace(value)) return value;
            try {throw new Error(safeToString(value));}
            catch(err) {return err;}
        };
    } else {
        return function(value) {
            if (canAttachTrace(value)) return value;
            return new Error(safeToString(value));
        };
    }
})();

function classString(obj) {
    return {}.toString.call(obj);
}

function copyDescriptors(from, to, filter) {
    var keys = es5.names(from);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        if (filter(key)) {
            es5.defineProperty(to, key, es5.getDescriptor(from, key));
        }
    }
}

var ret = {
    isClass: isClass,
    isIdentifier: isIdentifier,
    inheritedDataKeys: inheritedDataKeys,
    getDataPropertyOrDefault: getDataPropertyOrDefault,
    thrower: thrower,
    isArray: es5.isArray,
    haveGetters: haveGetters,
    notEnumerableProp: notEnumerableProp,
    isPrimitive: isPrimitive,
    isObject: isObject,
    canEvaluate: canEvaluate,
    errorObj: errorObj,
    tryCatch: tryCatch,
    inherits: inherits,
    withAppended: withAppended,
    maybeWrapAsError: maybeWrapAsError,
    wrapsPrimitiveReceiver: wrapsPrimitiveReceiver,
    toFastProperties: toFastProperties,
    filledRange: filledRange,
    toString: safeToString,
    canAttachTrace: canAttachTrace,
    ensureErrorObject: ensureErrorObject,
    originatesFromRejection: originatesFromRejection,
    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
    classString: classString,
    copyDescriptors: copyDescriptors,
    hasDevTools: typeof chrome !== "undefined" && chrome &&
                 typeof chrome.loadTimes === "function",
    isNode: typeof process !== "undefined" &&
        classString(process).toLowerCase() === "[object process]"
};
try {throw new Error(); } catch (e) {ret.lastLineError = e;}
module.exports = ret;

},{"./es5.js":14}],39:[function(_dereq_,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      }
      throw TypeError('Uncaught, unspecified "error" event.');
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        len = arguments.length;
        args = new Array(len - 1);
        for (i = 1; i < len; i++)
          args[i - 1] = arguments[i];
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    len = arguments.length;
    args = new Array(len - 1);
    for (i = 1; i < len; i++)
      args[i - 1] = arguments[i];

    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    var m;
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.listenerCount = function(emitter, type) {
  var ret;
  if (!emitter._events || !emitter._events[type])
    ret = 0;
  else if (isFunction(emitter._events[type]))
    ret = 1;
  else
    ret = emitter._events[type].length;
  return ret;
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

},{}]},{},[4])(4)
});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(29), __webpack_require__(30), __webpack_require__(31).setImmediate))

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 30 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(32);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(30)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(30), __webpack_require__(29)))

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return OLMapViewer; });
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34);
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68);
/* harmony import */ var ol_control__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(158);
/* harmony import */ var ol_format__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(199);
/* harmony import */ var ol_extent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var ol_geom_Polygon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(184);
/* harmony import */ var ol_Map__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(265);
/* harmony import */ var ol_View__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(179);
/* harmony import */ var ol_layer_Tile__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(140);
/* harmony import */ var ol_Overlay__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(171);
/* harmony import */ var pcvizMapLayers_pcvizMapLayers__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(312);














const {
    MathUtils,
    CRSUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils;
const Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Registry;

/**
 * This class implements the map viewer. It encapsulates [OpenLayers](http://www.openlayers.org) to render the map.
 * @class
 * @memberof pcvizMap
 * @param {canvas} mapElement The map DOM element.
 * @property {canvas} _mapElement The map DOM element.
 * @property {Array} _center XY center of the map.
 * @property {Projection} _mercator The map projection. EPSG:3857
 * @property {Overlay} _overlay An Openlayers overlay element to render feature information.
 * @property {pcvizMapLayers.VectorLayer} _extentLayer A layer that wraps an Openlayers Vector layer to render the PointCloudScene extent.
 * @property {Array<pcvizMapLayers.VectorLayer>} _layers An array of layers that wraps an array Openlayers Vector layers to render the vector layers.
 * @property {ol.Map} _olMap An Openlayers map.
 * @property {pcvizMapLayers.PointCloudScene} _map3DScene The map pointcloud scene.
 */

class OLMapViewer {
    constructor( mapElement, viewerCanvas, projection ) {

        if ( viewerCanvas !== undefined ) {
            this._canvas = viewerCanvas;
        } else {
            var mapCanvas = document.createElement( 'canvas' );
            mapCanvas.style.display = 'none';
            document.body.appendChild( mapCanvas );
            this._canvas = mapCanvas;
        }
        this._mapElement = mapElement;
        this._projection = projection;
        this._center = [ 0, 0 ];
        this._mercator = ol_proj__WEBPACK_IMPORTED_MODULE_1__["get"]( CRSUtils.DEFAULT_PROJECTION );

        this._olProjection = undefined;
        this._extent = undefined;

        this._overlay = undefined;
        this._extentLayer = undefined;
        this._layers = undefined;

        this._olMap = undefined;
        this._scaleLineControl = undefined;

        this._map3DScene = undefined;
        this._layerRenderer = undefined;

        this._maximizeFn = undefined;

        this.init();
    }

    /**
     * Initializes the map viewer.
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    init() {
        this._overlay = new ol_Overlay__WEBPACK_IMPORTED_MODULE_11__["default"]( ( {
            autoPan: true,
            autoPanAnimation: {
                duration: 250
            }
        } ) );

        this._extentLayer = new pcvizMapLayers_pcvizMapLayers__WEBPACK_IMPORTED_MODULE_12__["default"].VectorLayer( undefined, undefined, {
            id: 'extent',
            source: null,
            style: new ol_style__WEBPACK_IMPORTED_MODULE_2__["Style"]( {
                stroke: new ol_style__WEBPACK_IMPORTED_MODULE_2__["Stroke"]( {
                    color: 'blue',
                    width: 3
                } ),
                fill: new ol_style__WEBPACK_IMPORTED_MODULE_2__["Fill"]( {
                    color: 'rgba(0, 0, 255, 0.1)'
                } )
            } ),
            zIndex: 11
        } ).getOLLayer();

        this._layers = [
            new ol_layer_Tile__WEBPACK_IMPORTED_MODULE_10__["default"]( {
                source: new ol_source__WEBPACK_IMPORTED_MODULE_3__["OSM"](),
                id: 'OSM'
            } ),
            this._extentLayer
        ];

        this._scaleLineControl = new ol_control__WEBPACK_IMPORTED_MODULE_4__["ScaleLine"]();

        this._olMap = new ol_Map__WEBPACK_IMPORTED_MODULE_8__["default"]( {
            target: this._mapElement,
            logo: false,
            controls: ol_control__WEBPACK_IMPORTED_MODULE_4__["defaults"]().extend( [ this._scaleLineControl ] ),
            layers: this._layers,
            overlays: [ this._overlay ],
            view: new ol_View__WEBPACK_IMPORTED_MODULE_9__["default"]( {
                projection: this._mercator,
                center: this._center,
                zoom: 2,
            } )
        } );

        this._olMap.on( 'moveend', this.moveMap.bind( this ) );
        this._olMap.getViewport().addEventListener( 'contextmenu', function ( ev ) {
            ev.preventDefault();
        } );

    }

    setOverlayButtonsEvents() {
        if ( this._overlay.getElement() !== null ) {
            var self = this;

            var closer = this._overlay.getElement().getElementsByClassName( 'popup-closer' )[ 0 ];
            closer.onclick = function () {
                self.closeOverlay();
                closer.blur();
                return false;
            };
            var maximizer = this._overlay.getElement().getElementsByClassName( 'popup-max' )[ 0 ];
            maximizer.onclick = function () {
                self._maximizeFn();
            };
        }
    }

    setMaximizeFnEvent( fn ) {
        this._maximizeFn = fn;
    }

    /**
     * Initializes the pointcloud rendering
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    run() {
        this._map3DScene = new pcvizMapLayers_pcvizMapLayers__WEBPACK_IMPORTED_MODULE_12__["default"].Map3DScene( this, this._canvas );
        this._olMap.addLayer( this._map3DScene.getOLLayer() );
        this._map3DScene.run();

        window.addEventListener( 'resize', this.renderPointCloudScene );
    }

    /**
     * Returns the OpenLayers map object
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {ol.Map} The OpenLayers map
     */
    getMap() {
        return this._olMap;
    }

    /**
     * Returns the OpenLayers layer object from a PointCloudViz.pcvizGIS.Layer
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {ol.layer} The OpenLayers layer object
     */
    getOLLayer( layer ) {
        var olLayers = this._olMap.getLayers().getArray();
        for ( var i = 0; i < olLayers.length; i++ ) {
            if ( olLayers[ i ].get( 'layer' ) === layer )
                return olLayers[ i ];
        }
    }

    /**
     * Returns the OpenLayers feature object from a PointCloudViz.pcvizGIS.Feature
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {ol.layer} The OpenLayers feature object
     */
    getOLFeature( feature ) {
        var olLayer = this.getOLLayer( feature.getLayer() );
        if ( olLayer !== undefined )
            return olLayer.getSource().getFeatureById( feature.getId() );
    }

    /**
     * Sets the map projection.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @param {String} projection The projection.
     */
    setProjection( olProjection ) {
        this._olProjection = olProjection;
    }

    /**
     * Gets the map projection.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {String} The projection.
     */
    getProjection() {
        return this._olProjection.getCode();
    }

    /**
     * Returns the OpenLayers layer from its id
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @param  {string} id Layer id
     * @return {ol.layer}    The OpenLayers layer with the entered id
     */
    getOLLayerById( id ) {
        var retLayer;
        this._olMap.getLayers().forEach( function ( layer ) {
            if ( layer.get( 'id' ) === id )
                retLayer = layer;
        } );
        return retLayer;
    }

    /**
     * Adds an Openlayers layer object to the map.
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    addLayer( mapLayer ) {
        this._olMap.addLayer( mapLayer );
    }

    /**
     * Returns the overlay object.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {ol.Overlay}    The OpenLayers overlay object
     */
    getOverlay() {
        return this._overlay;
    }

    /**
     * Sets the overlay coordinate.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @param {Array<Float>} coordinate The position of the feature in the map.
     * @param {Boolean} hasMarker Indicates whether the feature has an image marker or not. This is used to set an offset to render the overlay.
     */
    setOverlayPosition( coordinate, hasMarker ) {
        if ( hasMarker ) {
            this._overlay.getElement().classList.add( 'has-marker' );
        } else {
            this._overlay.getElement().classList.remove( 'has-marker' );
        }
        this._overlay.setPosition( coordinate );
    }

    /**
     * Closes the overlay
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    closeOverlay() {
        this._overlay.setPosition( undefined );
    }

    /**
     * Returns the map size in pixels.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {Array<Integer>} The map size.
     */
    getSize() {
        return this._olMap.getSize();
    }

    /**
     * Returns the OpenLayers View object.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @return {ol.View} The OpenLayers view object.
     */
    getView() {
        return this._olMap.getView();
    }

    /**
     * Creates the rectangle that defines the extent of scene.
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    renderExtent() {

        let appObject = Registry.getController( 'Application' ).getApplication().getAppObject();
        if ( !appObject.isExtentValid() ) {
            return;
        }

        let extent = appObject.getProjectedExtent(); // we will get a right checked extent

        if ( extent ) {

            this._extent = ol_extent__WEBPACK_IMPORTED_MODULE_6__["applyTransform"]( MathUtils.vec4.fromValues( extent[ 0 ], extent[ 1 ], extent[ 3 ], extent[ 4 ] ), ol_proj__WEBPACK_IMPORTED_MODULE_1__["getTransform"]( this._olProjection.getCode(), this._mercator ) );
            this.ensureControlPointsExtent();

            let extentPolygon = new ol_format__WEBPACK_IMPORTED_MODULE_5__["GeoJSON"]().writeGeometryObject( Object(ol_geom_Polygon__WEBPACK_IMPORTED_MODULE_7__["fromExtent"])( this._extent ) );

            var geojsonObject = {
                'type': 'FeatureCollection',
                'crs': {
                    'type': 'name',
                    'properties': {
                        'name': this._olProjection.getCode()
                    }
                },
                'features': [ {
                    'type': 'Feature',
                    'geometry': extentPolygon
                } ]
            };



            this._center = ol_proj__WEBPACK_IMPORTED_MODULE_1__["transform"]( [ ( extent[ 0 ] + extent[ 3 ] ) / 2.0, ( extent[ 1 ] + extent[ 4 ] ) / 2.0 ], this._olProjection.getCode(), this._mercator );
            this._extentLayer.setSource( new ol_source__WEBPACK_IMPORTED_MODULE_3__["Vector"]( {
                features: ( new ol_format__WEBPACK_IMPORTED_MODULE_5__["GeoJSON"]() ).readFeatures( geojsonObject ),
            } ) );
        } else {
            this._extentLayer.setSource( null );
        }
    }

    ensureControlPointsExtent() {
        let groundControlPointsOLLayer = this.getOLLayerById( 'ControlPoints' );
        if ( !groundControlPointsOLLayer ) {
            return;
        }
        let groundControlPointsExtent = groundControlPointsOLLayer.getSource().getExtent();
        if ( ol_extent__WEBPACK_IMPORTED_MODULE_6__["isEmpty"]( groundControlPointsExtent ) ) {
            return;
        }
        ol_extent__WEBPACK_IMPORTED_MODULE_6__["extend"]( this._extent, groundControlPointsExtent );
    }

    /**
     * Centers the view to the extent of the scene.
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    fit() {
        if ( !this._extent ) {
            return;
        }
        this._olMap.getView().fit( this._extent, this._olMap.getSize() );
    }

    /**
     * The callback that is executed when the map is moved.
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    moveMap() {
        if ( this._olProjection !== undefined )
            this.renderPointCloudScene();
    }

    /**
     * Remove the ol Layer in the ol Map
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @param  {integer} id the id of the layer to be removed
     */
    removeLayerById( id ) {
        var olLayer = this.getOLLayerById( id );
        this.getMap().removeLayer( olLayer );
    }

    /**
     * Renders the pointcloud scene
     * @method
     * @memberof pcvizMap.OLMapViewer
     */
    renderPointCloudScene() {
        if ( this._map3DScene !== undefined && this._olMap.getSize()[ 0 ] !== null )
            this._map3DScene.render();
    }

    getMap3DScene() {
        return this._map3DScene;
    }

    getPointCloudScene() {
        return this._map3DScene.getPointCloudScene();
    }

    getModel3DLayerScene() {
        return this._map3DScene.getModel3DLayerScene();
    }

    /**
     * Sets the layer renderer.
     * @method
     * @memberof pcvizMap.OLMapViewer
     * @param {LayerRenderer} layerRenderer The layer renderer.
     */
    setLayerRenderer( layerRenderer ) {
        this._layerRenderer = layerRenderer;
    }

    destroy() {
        if ( document.getElementsByClassName( 'ol-viewport' ).length > 0 )
            document.getElementsByClassName( 'ol-viewport' )[ 0 ].remove();
        this._canvas.remove();

        if ( this._map3DScene )
            this._map3DScene.destroy();
    }

    setScaleUnits( units ) {
        this._scaleLineControl.setUnits( units );
    }
}


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_Circle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return _style_Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Fill", function() { return _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _style_Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return _style_Icon_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _style_IconImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IconImage", function() { return _style_IconImage_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _style_Image_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return _style_Image_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _style_RegularShape_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegularShape", function() { return _style_RegularShape_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _style_Stroke_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(64);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stroke", function() { return _style_Stroke_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Style", function() { return _style_Style_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _style_Text_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return _style_Text_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/**
 * @module ol/style
 */









//# sourceMappingURL=style.js.map

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _RegularShape_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36);
/**
 * @module ol/style/Circle
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} radius Circle radius.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {Array<number>} [displacement=[0,0]] displacement
 * @property {number|import("../size.js").Size} [scale=1] Scale. A two dimensional scale will produce an ellipse.
 * Unless two dimensional scaling is required a better result may be obtained with an appropriate setting for `radius`.
 * @property {number} [rotation=0] Rotation in radians
 * (positive rotation clockwise, meaningful only when used in conjunction with a two dimensional scale).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view
 * (meaningful only when used in conjunction with a two dimensional scale).
 */
/**
 * @classdesc
 * Set circle style for vector features.
 * @api
 */
var CircleStyle = /** @class */ (function (_super) {
    __extends(CircleStyle, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function CircleStyle(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            points: Infinity,
            fill: options.fill,
            radius: options.radius,
            stroke: options.stroke,
            scale: options.scale !== undefined ? options.scale : 1,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            rotateWithView: options.rotateWithView !== undefined ? options.rotateWithView : false,
            displacement: options.displacement !== undefined ? options.displacement : [0, 0],
        }) || this;
        return _this;
    }
    /**
     * Clones the style.
     * @return {CircleStyle} The cloned style.
     * @api
     */
    CircleStyle.prototype.clone = function () {
        var scale = this.getScale();
        var style = new CircleStyle({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            radius: this.getRadius(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Set the circle radius.
     *
     * @param {number} radius Circle radius.
     * @api
     */
    CircleStyle.prototype.setRadius = function (radius) {
        this.radius_ = radius;
        this.render();
    };
    return CircleStyle;
}(_RegularShape_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CircleStyle);
//# sourceMappingURL=Circle.js.map

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38);
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40);
/* harmony import */ var _colorlike_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
/* harmony import */ var _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
/**
 * @module ol/style/RegularShape
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






/**
 * Specify radius for regular polygons, or radius1 and radius2 for stars.
 * @typedef {Object} Options
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {number} points Number of points for stars and regular polygons. In case of a polygon, the number of points
 * is the number of sides.
 * @property {number} [radius] Radius of a regular polygon.
 * @property {number} [radius1] First radius of a star. Ignored if radius is set.
 * @property {number} [radius2] Second radius of a star.
 * @property {number} [angle=0] Shape's angle in radians. A value of 0 will have one of the shape's point facing up.
 * @property {Array<number>} [displacement=[0,0]] Displacement of the shape
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {boolean} [rotateWithView=false] Whether to rotate the shape with the view.
 * @property {number|import("../size.js").Size} [scale=1] Scale. Unless two dimensional scaling is required a better
 * result may be obtained with appropriate settings for `radius`, `radius1` and `radius2`.
 */
/**
 * @typedef {Object} RenderOptions
 * @property {import("../colorlike.js").ColorLike} [strokeStyle] StrokeStyle.
 * @property {number} strokeWidth StrokeWidth.
 * @property {number} size Size.
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} miterLimit MiterLimit.
 */
/**
 * @classdesc
 * Set regular shape style for vector features. The resulting shape will be
 * a regular polygon when `radius` is provided, or a star when `radius1` and
 * `radius2` are provided.
 * @api
 */
var RegularShape = /** @class */ (function (_super) {
    __extends(RegularShape, _super);
    /**
     * @param {Options} options Options.
     */
    function RegularShape(options) {
        var _this = this;
        /**
         * @type {boolean}
         */
        var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: 1,
            rotateWithView: rotateWithView,
            rotation: options.rotation !== undefined ? options.rotation : 0,
            scale: options.scale !== undefined ? options.scale : 1,
            displacement: options.displacement !== undefined ? options.displacement : [0, 0],
        }) || this;
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */
        _this.canvas_ = undefined;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.hitDetectionCanvas_ = null;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */
        _this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.origin_ = [0, 0];
        /**
         * @private
         * @type {number}
         */
        _this.points_ = options.points;
        /**
         * @protected
         * @type {number}
         */
        _this.radius_ =
            options.radius !== undefined ? options.radius : options.radius1;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.radius2_ = options.radius2;
        /**
         * @private
         * @type {number}
         */
        _this.angle_ = options.angle !== undefined ? options.angle : 0;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */
        _this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.anchor_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.size_ = null;
        /**
         * @private
         * @type {RenderOptions}
         */
        _this.renderOptions_ = null;
        _this.render();
        return _this;
    }
    /**
     * Clones the style.
     * @return {RegularShape} The cloned style.
     * @api
     */
    RegularShape.prototype.clone = function () {
        var scale = this.getScale();
        var style = new RegularShape({
            fill: this.getFill() ? this.getFill().clone() : undefined,
            points: this.getPoints(),
            radius: this.getRadius(),
            radius2: this.getRadius2(),
            angle: this.getAngle(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            displacement: this.getDisplacement().slice(),
        });
        style.setOpacity(this.getOpacity());
        return style;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */
    RegularShape.prototype.getAnchor = function () {
        return this.anchor_;
    };
    /**
     * Get the angle used in generating the shape.
     * @return {number} Shape's rotation in radians.
     * @api
     */
    RegularShape.prototype.getAngle = function () {
        return this.angle_;
    };
    /**
     * Get the fill style for the shape.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */
    RegularShape.prototype.getFill = function () {
        return this.fill_;
    };
    /**
     * @return {HTMLCanvasElement} Image element.
     */
    RegularShape.prototype.getHitDetectionImage = function () {
        if (!this.hitDetectionCanvas_) {
            this.createHitDetectionCanvas_(this.renderOptions_);
        }
        return this.hitDetectionCanvas_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement} Image or Canvas element.
     * @api
     */
    RegularShape.prototype.getImage = function (pixelRatio) {
        var image = this.canvas_[pixelRatio];
        if (!image) {
            var renderOptions = this.renderOptions_;
            var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(renderOptions.size * pixelRatio, renderOptions.size * pixelRatio);
            this.draw_(renderOptions, context, pixelRatio);
            image = context.canvas;
            this.canvas_[pixelRatio] = image;
        }
        return image;
    };
    /**
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Pixel ratio.
     */
    RegularShape.prototype.getPixelRatio = function (pixelRatio) {
        return pixelRatio;
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */
    RegularShape.prototype.getImageSize = function () {
        return this.size_;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */
    RegularShape.prototype.getImageState = function () {
        return _ImageState_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOADED;
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */
    RegularShape.prototype.getOrigin = function () {
        return this.origin_;
    };
    /**
     * Get the number of points for generating the shape.
     * @return {number} Number of points for stars and regular polygons.
     * @api
     */
    RegularShape.prototype.getPoints = function () {
        return this.points_;
    };
    /**
     * Get the (primary) radius for the shape.
     * @return {number} Radius.
     * @api
     */
    RegularShape.prototype.getRadius = function () {
        return this.radius_;
    };
    /**
     * Get the secondary radius for the shape.
     * @return {number|undefined} Radius2.
     * @api
     */
    RegularShape.prototype.getRadius2 = function () {
        return this.radius2_;
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @return {import("../size.js").Size} Size.
     * @api
     */
    RegularShape.prototype.getSize = function () {
        return this.size_;
    };
    /**
     * Get the stroke style for the shape.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */
    RegularShape.prototype.getStroke = function () {
        return this.stroke_;
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    RegularShape.prototype.listenImageChange = function (listener) { };
    /**
     * Load not yet loaded URI.
     */
    RegularShape.prototype.load = function () { };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    RegularShape.prototype.unlistenImageChange = function (listener) { };
    /**
     * Calculate additional canvas size needed for the miter.
     * @param {string} lineJoin Line join
     * @param {number} strokeWidth Stroke width
     * @param {number} miterLimit Miter limit
     * @return {number} Additional canvas size needed
     * @private
     */
    RegularShape.prototype.calculateLineJoinSize_ = function (lineJoin, strokeWidth, miterLimit) {
        if (strokeWidth === 0 ||
            this.points_ === Infinity ||
            (lineJoin !== 'bevel' && lineJoin !== 'miter')) {
            return strokeWidth;
        }
        // m  | ^
        // i  | |\                  .
        // t >|  #\
        // e  | |\ \              .
        // r      \s\
        //      |  \t\          .                 .
        //          \r\                      .   .
        //      |    \o\      .          .  . . .
        //          e \k\            .  .    . .
        //      |      \e\  .    .  .       . .
        //       d      \ \  .  .          . .
        //      | _ _a_ _\#  .            . .
        //   r1          / `             . .
        //      |                       . .
        //       b     /               . .
        //      |                     . .
        //           / r2            . .
        //      |                        .   .
        //         /                           .   .
        //      |α                                   .   .
        //       /                                         .   .
        //      ° center
        var r1 = this.radius_;
        var r2 = this.radius2_ === undefined ? r1 : this.radius2_;
        if (r1 < r2) {
            var tmp = r1;
            r1 = r2;
            r2 = tmp;
        }
        var points = this.radius2_ === undefined ? this.points_ : this.points_ * 2;
        var alpha = (2 * Math.PI) / points;
        var a = r2 * Math.sin(alpha);
        var b = Math.sqrt(r2 * r2 - a * a);
        var d = r1 - b;
        var e = Math.sqrt(a * a + d * d);
        var miterRatio = e / a;
        if (lineJoin === 'miter' && miterRatio <= miterLimit) {
            return miterRatio * strokeWidth;
        }
        // Calculate the distnce from center to the stroke corner where
        // it was cut short because of the miter limit.
        //              l
        //        ----+---- <= distance from center to here is maxr
        //       /####|k ##\
        //      /#####^#####\
        //     /#### /+\# s #\
        //    /### h/+++\# t #\
        //   /### t/+++++\# r #\
        //  /### a/+++++++\# o #\
        // /### p/++ fill +\# k #\
        ///#### /+++++^+++++\# e #\
        //#####/+++++/+\+++++\#####\
        var k = strokeWidth / 2 / miterRatio;
        var l = (strokeWidth / 2) * (d / e);
        var maxr = Math.sqrt((r1 + k) * (r1 + k) + l * l);
        var bevelAdd = maxr - r1;
        if (this.radius2_ === undefined || lineJoin === 'bevel') {
            return bevelAdd * 2;
        }
        // If outer miter is over the miter limit the inner miter may reach through the
        // center and be longer than the bevel, same calculation as above but swap r1 / r2.
        var aa = r1 * Math.sin(alpha);
        var bb = Math.sqrt(r1 * r1 - aa * aa);
        var dd = r2 - bb;
        var ee = Math.sqrt(aa * aa + dd * dd);
        var innerMiterRatio = ee / aa;
        if (innerMiterRatio <= miterLimit) {
            var innerLength = (innerMiterRatio * strokeWidth) / 2 - r2 - r1;
            return 2 * Math.max(bevelAdd, innerLength);
        }
        return bevelAdd * 2;
    };
    /**
     * @return {RenderOptions}  The render options
     * @protected
     */
    RegularShape.prototype.createRenderOptions = function () {
        var lineCap = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineCap"];
        var lineJoin = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineJoin"];
        var miterLimit = 0;
        var lineDash = null;
        var lineDashOffset = 0;
        var strokeStyle;
        var strokeWidth = 0;
        if (this.stroke_) {
            strokeStyle = this.stroke_.getColor();
            if (strokeStyle === null) {
                strokeStyle = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultStrokeStyle"];
            }
            strokeStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_3__["asColorLike"])(strokeStyle);
            strokeWidth = this.stroke_.getWidth();
            if (strokeWidth === undefined) {
                strokeWidth = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineWidth"];
            }
            lineDash = this.stroke_.getLineDash();
            lineDashOffset = this.stroke_.getLineDashOffset();
            lineJoin = this.stroke_.getLineJoin();
            if (lineJoin === undefined) {
                lineJoin = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineJoin"];
            }
            lineCap = this.stroke_.getLineCap();
            if (lineCap === undefined) {
                lineCap = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineCap"];
            }
            miterLimit = this.stroke_.getMiterLimit();
            if (miterLimit === undefined) {
                miterLimit = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultMiterLimit"];
            }
        }
        var add = this.calculateLineJoinSize_(lineJoin, strokeWidth, miterLimit);
        var maxRadius = Math.max(this.radius_, this.radius2_ || 0);
        var size = Math.ceil(2 * maxRadius + add);
        return {
            strokeStyle: strokeStyle,
            strokeWidth: strokeWidth,
            size: size,
            lineCap: lineCap,
            lineDash: lineDash,
            lineDashOffset: lineDashOffset,
            lineJoin: lineJoin,
            miterLimit: miterLimit,
        };
    };
    /**
     * @protected
     */
    RegularShape.prototype.render = function () {
        this.renderOptions_ = this.createRenderOptions();
        var size = this.renderOptions_.size;
        var displacement = this.getDisplacement();
        this.canvas_ = {};
        this.anchor_ = [size / 2 - displacement[0], size / 2 + displacement[1]];
        this.size_ = [size, size];
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The rendering context.
     * @param {number} pixelRatio The pixel ratio.
     */
    RegularShape.prototype.draw_ = function (renderOptions, context, pixelRatio) {
        context.scale(pixelRatio, pixelRatio);
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        if (this.fill_) {
            var color = this.fill_.getColor();
            if (color === null) {
                color = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultFillStyle"];
            }
            context.fillStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_3__["asColorLike"])(color);
            context.fill();
        }
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (context.setLineDash && renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.lineCap = renderOptions.lineCap;
            context.lineJoin = renderOptions.lineJoin;
            context.miterLimit = renderOptions.miterLimit;
            context.stroke();
        }
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     */
    RegularShape.prototype.createHitDetectionCanvas_ = function (renderOptions) {
        if (this.fill_) {
            var color = this.fill_.getColor();
            // determine if fill is transparent (or pattern or gradient)
            var opacity = 0;
            if (typeof color === 'string') {
                color = Object(_color_js__WEBPACK_IMPORTED_MODULE_2__["asArray"])(color);
            }
            if (color === null) {
                opacity = 1;
            }
            else if (Array.isArray(color)) {
                opacity = color.length === 4 ? color[3] : 1;
            }
            if (opacity === 0) {
                // if a transparent fill style is set, create an extra hit-detection image
                // with a default fill style
                var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(renderOptions.size, renderOptions.size);
                this.hitDetectionCanvas_ = context.canvas;
                this.drawHitDetectionCanvas_(renderOptions, context);
            }
        }
        if (!this.hitDetectionCanvas_) {
            this.hitDetectionCanvas_ = this.getImage(1);
        }
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context The context to draw in.
     */
    RegularShape.prototype.createPath_ = function (context) {
        var points = this.points_;
        var radius = this.radius_;
        if (points === Infinity) {
            context.arc(0, 0, radius, 0, 2 * Math.PI);
        }
        else {
            var radius2 = this.radius2_ === undefined ? radius : this.radius2_;
            if (this.radius2_ !== undefined) {
                points *= 2;
            }
            var startAngle = this.angle_ - Math.PI / 2;
            var step = (2 * Math.PI) / points;
            for (var i = 0; i < points; i++) {
                var angle0 = startAngle + i * step;
                var radiusC = i % 2 === 0 ? radius : radius2;
                context.lineTo(radiusC * Math.cos(angle0), radiusC * Math.sin(angle0));
            }
            context.closePath();
        }
    };
    /**
     * @private
     * @param {RenderOptions} renderOptions Render options.
     * @param {CanvasRenderingContext2D} context The context.
     */
    RegularShape.prototype.drawHitDetectionCanvas_ = function (renderOptions, context) {
        // set origin to canvas center
        context.translate(renderOptions.size / 2, renderOptions.size / 2);
        this.createPath_(context);
        context.fillStyle = _render_canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultFillStyle"];
        context.fill();
        if (this.stroke_) {
            context.strokeStyle = renderOptions.strokeStyle;
            context.lineWidth = renderOptions.strokeWidth;
            if (renderOptions.lineDash) {
                context.setLineDash(renderOptions.lineDash);
                context.lineDashOffset = renderOptions.lineDashOffset;
            }
            context.stroke();
        }
    };
    return RegularShape;
}(_Image_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (RegularShape);
//# sourceMappingURL=RegularShape.js.map

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/ImageState
 */
/**
 * @enum {number}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    EMPTY: 4,
});
//# sourceMappingURL=ImageState.js.map

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39);
/**
 * @module ol/style/Image
 */


/**
 * @typedef {Object} Options
 * @property {number} opacity Opacity.
 * @property {boolean} rotateWithView If the image should get rotated with the view.
 * @property {number} rotation Rotation.
 * @property {number|import("../size.js").Size} scale Scale.
 * @property {Array<number>} displacement Displacement.
 */
/**
 * @classdesc
 * A base class used for creating subclasses and not instantiated in
 * apps. Base class for {@link module:ol/style/Icon~Icon}, {@link module:ol/style/Circle~CircleStyle} and
 * {@link module:ol/style/RegularShape~RegularShape}.
 * @abstract
 * @api
 */
var ImageStyle = /** @class */ (function () {
    /**
     * @param {Options} options Options.
     */
    function ImageStyle(options) {
        /**
         * @private
         * @type {number}
         */
        this.opacity_ = options.opacity;
        /**
         * @private
         * @type {boolean}
         */
        this.rotateWithView_ = options.rotateWithView;
        /**
         * @private
         * @type {number}
         */
        this.rotation_ = options.rotation;
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */
        this.scale_ = options.scale;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        this.scaleArray_ = Object(_size_js__WEBPACK_IMPORTED_MODULE_1__["toSize"])(options.scale);
        /**
         * @private
         * @type {Array<number>}
         */
        this.displacement_ = options.displacement;
    }
    /**
     * Clones the style.
     * @return {ImageStyle} The cloned style.
     * @api
     */
    ImageStyle.prototype.clone = function () {
        var scale = this.getScale();
        return new ImageStyle({
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            displacement: this.getDisplacement().slice(),
        });
    };
    /**
     * Get the symbolizer opacity.
     * @return {number} Opacity.
     * @api
     */
    ImageStyle.prototype.getOpacity = function () {
        return this.opacity_;
    };
    /**
     * Determine whether the symbolizer rotates with the map.
     * @return {boolean} Rotate with map.
     * @api
     */
    ImageStyle.prototype.getRotateWithView = function () {
        return this.rotateWithView_;
    };
    /**
     * Get the symoblizer rotation.
     * @return {number} Rotation.
     * @api
     */
    ImageStyle.prototype.getRotation = function () {
        return this.rotation_;
    };
    /**
     * Get the symbolizer scale.
     * @return {number|import("../size.js").Size} Scale.
     * @api
     */
    ImageStyle.prototype.getScale = function () {
        return this.scale_;
    };
    /**
     * Get the symbolizer scale array.
     * @return {import("../size.js").Size} Scale array.
     */
    ImageStyle.prototype.getScaleArray = function () {
        return this.scaleArray_;
    };
    /**
     * Get the displacement of the shape
     * @return {Array<number>} Shape's center displacement
     * @api
     */
    ImageStyle.prototype.getDisplacement = function () {
        return this.displacement_;
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @abstract
     * @return {Array<number>} Anchor.
     */
    ImageStyle.prototype.getAnchor = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Get the image element for the symbolizer.
     * @abstract
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */
    ImageStyle.prototype.getImage = function (pixelRatio) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} Image element.
     */
    ImageStyle.prototype.getHitDetectionImage = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Get the image pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Pixel ratio.
     */
    ImageStyle.prototype.getPixelRatio = function (pixelRatio) {
        return 1;
    };
    /**
     * @abstract
     * @return {import("../ImageState.js").default} Image state.
     */
    ImageStyle.prototype.getImageState = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * @abstract
     * @return {import("../size.js").Size} Image size.
     */
    ImageStyle.prototype.getImageSize = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Get the origin of the symbolizer.
     * @abstract
     * @return {Array<number>} Origin.
     */
    ImageStyle.prototype.getOrigin = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Get the size of the symbolizer (in pixels).
     * @abstract
     * @return {import("../size.js").Size} Size.
     */
    ImageStyle.prototype.getSize = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Set the opacity.
     *
     * @param {number} opacity Opacity.
     * @api
     */
    ImageStyle.prototype.setOpacity = function (opacity) {
        this.opacity_ = opacity;
    };
    /**
     * Set whether to rotate the style with the view.
     *
     * @param {boolean} rotateWithView Rotate with map.
     * @api
     */
    ImageStyle.prototype.setRotateWithView = function (rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    };
    /**
     * Set the rotation.
     *
     * @param {number} rotation Rotation.
     * @api
     */
    ImageStyle.prototype.setRotation = function (rotation) {
        this.rotation_ = rotation;
    };
    /**
     * Set the scale.
     *
     * @param {number|import("../size.js").Size} scale Scale.
     * @api
     */
    ImageStyle.prototype.setScale = function (scale) {
        this.scale_ = scale;
        this.scaleArray_ = Object(_size_js__WEBPACK_IMPORTED_MODULE_1__["toSize"])(scale);
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    ImageStyle.prototype.listenImageChange = function (listener) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */
    ImageStyle.prototype.load = function () {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    /**
     * @abstract
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    ImageStyle.prototype.unlistenImageChange = function (listener) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["abstract"])();
    };
    return ImageStyle;
}());
/* harmony default export */ __webpack_exports__["default"] = (ImageStyle);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buffer", function() { return buffer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasArea", function() { return hasArea; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scale", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toSize", function() { return toSize; });
/**
 * @module ol/size
 */
/**
 * An array of numbers representing a size: `[width, height]`.
 * @typedef {Array<number>} Size
 * @api
 */
/**
 * Returns a buffered size.
 * @param {Size} size Size.
 * @param {number} num The amount by which to buffer.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} The buffered size.
 */
function buffer(size, num, opt_size) {
    if (opt_size === undefined) {
        opt_size = [0, 0];
    }
    opt_size[0] = size[0] + 2 * num;
    opt_size[1] = size[1] + 2 * num;
    return opt_size;
}
/**
 * Determines if a size has a positive area.
 * @param {Size} size The size to test.
 * @return {boolean} The size has a positive area.
 */
function hasArea(size) {
    return size[0] > 0 && size[1] > 0;
}
/**
 * Returns a size scaled by a ratio. The result will be an array of integers.
 * @param {Size} size Size.
 * @param {number} ratio Ratio.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} The scaled size.
 */
function scale(size, ratio, opt_size) {
    if (opt_size === undefined) {
        opt_size = [0, 0];
    }
    opt_size[0] = (size[0] * ratio + 0.5) | 0;
    opt_size[1] = (size[1] * ratio + 0.5) | 0;
    return opt_size;
}
/**
 * Returns an `Size` array for the passed in number (meaning: square) or
 * `Size` array.
 * (meaning: non-square),
 * @param {number|Size} size Width and height.
 * @param {Size} [opt_size] Optional reusable size array.
 * @return {Size} Size.
 * @api
 */
function toSize(size, opt_size) {
    if (Array.isArray(size)) {
        return size;
    }
    else {
        if (opt_size === undefined) {
            opt_size = [size, size];
        }
        else {
            opt_size[0] = size;
            opt_size[1] = size;
        }
        return opt_size;
    }
}
//# sourceMappingURL=size.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asString", function() { return asString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromString", function() { return fromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asArray", function() { return asArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalize", function() { return normalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toString", function() { return toString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isStringColor", function() { return isStringColor; });
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/**
 * @module ol/color
 */


/**
 * A color represented as a short array [red, green, blue, alpha].
 * red, green, and blue should be integers in the range 0..255 inclusive.
 * alpha should be a float in the range 0..1 inclusive. If no alpha value is
 * given then `1` will be used.
 * @typedef {Array<number>} Color
 * @api
 */
/**
 * This RegExp matches # followed by 3, 4, 6, or 8 hex digits.
 * @const
 * @type {RegExp}
 * @private
 */
var HEX_COLOR_RE_ = /^#([a-f0-9]{3}|[a-f0-9]{4}(?:[a-f0-9]{2}){0,2})$/i;
/**
 * Regular expression for matching potential named color style strings.
 * @const
 * @type {RegExp}
 * @private
 */
var NAMED_COLOR_RE_ = /^([a-z]*)$|^hsla?\(.*\)$/i;
/**
 * Return the color as an rgba string.
 * @param {Color|string} color Color.
 * @return {string} Rgba string.
 * @api
 */
function asString(color) {
    if (typeof color === 'string') {
        return color;
    }
    else {
        return toString(color);
    }
}
/**
 * Return named color as an rgba string.
 * @param {string} color Named color.
 * @return {string} Rgb string.
 */
function fromNamed(color) {
    var el = document.createElement('div');
    el.style.color = color;
    if (el.style.color !== '') {
        document.body.appendChild(el);
        var rgb = getComputedStyle(el).color;
        document.body.removeChild(el);
        return rgb;
    }
    else {
        return '';
    }
}
/**
 * @param {string} s String.
 * @return {Color} Color.
 */
var fromString = (function () {
    // We maintain a small cache of parsed strings.  To provide cheap LRU-like
    // semantics, whenever the cache grows too large we simply delete an
    // arbitrary 25% of the entries.
    /**
     * @const
     * @type {number}
     */
    var MAX_CACHE_SIZE = 1024;
    /**
     * @type {Object<string, Color>}
     */
    var cache = {};
    /**
     * @type {number}
     */
    var cacheSize = 0;
    return (
    /**
     * @param {string} s String.
     * @return {Color} Color.
     */
    function (s) {
        var color;
        if (cache.hasOwnProperty(s)) {
            color = cache[s];
        }
        else {
            if (cacheSize >= MAX_CACHE_SIZE) {
                var i = 0;
                for (var key in cache) {
                    if ((i++ & 3) === 0) {
                        delete cache[key];
                        --cacheSize;
                    }
                }
            }
            color = fromStringInternal_(s);
            cache[s] = color;
            ++cacheSize;
        }
        return color;
    });
})();
/**
 * Return the color as an array. This function maintains a cache of calculated
 * arrays which means the result should not be modified.
 * @param {Color|string} color Color.
 * @return {Color} Color.
 * @api
 */
function asArray(color) {
    if (Array.isArray(color)) {
        return color;
    }
    else {
        return fromString(color);
    }
}
/**
 * @param {string} s String.
 * @private
 * @return {Color} Color.
 */
function fromStringInternal_(s) {
    var r, g, b, a, color;
    if (NAMED_COLOR_RE_.exec(s)) {
        s = fromNamed(s);
    }
    if (HEX_COLOR_RE_.exec(s)) {
        // hex
        var n = s.length - 1; // number of hex digits
        var d = // number of digits per channel
         void 0; // number of digits per channel
        if (n <= 4) {
            d = 1;
        }
        else {
            d = 2;
        }
        var hasAlpha = n === 4 || n === 8;
        r = parseInt(s.substr(1 + 0 * d, d), 16);
        g = parseInt(s.substr(1 + 1 * d, d), 16);
        b = parseInt(s.substr(1 + 2 * d, d), 16);
        if (hasAlpha) {
            a = parseInt(s.substr(1 + 3 * d, d), 16);
        }
        else {
            a = 255;
        }
        if (d == 1) {
            r = (r << 4) + r;
            g = (g << 4) + g;
            b = (b << 4) + b;
            if (hasAlpha) {
                a = (a << 4) + a;
            }
        }
        color = [r, g, b, a / 255];
    }
    else if (s.indexOf('rgba(') == 0) {
        // rgba()
        color = s.slice(5, -1).split(',').map(Number);
        normalize(color);
    }
    else if (s.indexOf('rgb(') == 0) {
        // rgb()
        color = s.slice(4, -1).split(',').map(Number);
        color.push(1);
        normalize(color);
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(false, 14); // Invalid color
    }
    return color;
}
/**
 * TODO this function is only used in the test, we probably shouldn't export it
 * @param {Color} color Color.
 * @return {Color} Clamped color.
 */
function normalize(color) {
    color[0] = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["clamp"])((color[0] + 0.5) | 0, 0, 255);
    color[1] = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["clamp"])((color[1] + 0.5) | 0, 0, 255);
    color[2] = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["clamp"])((color[2] + 0.5) | 0, 0, 255);
    color[3] = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["clamp"])(color[3], 0, 1);
    return color;
}
/**
 * @param {Color} color Color.
 * @return {string} String.
 */
function toString(color) {
    var r = color[0];
    if (r != (r | 0)) {
        r = (r + 0.5) | 0;
    }
    var g = color[1];
    if (g != (g | 0)) {
        g = (g + 0.5) | 0;
    }
    var b = color[2];
    if (b != (b | 0)) {
        b = (b + 0.5) | 0;
    }
    var a = color[3] === undefined ? 1 : color[3];
    return 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
}
/**
 * @param {string} s String.
 * @return {boolean} Whether the string is actually a valid color
 */
function isStringColor(s) {
    if (NAMED_COLOR_RE_.test(s)) {
        s = fromNamed(s);
    }
    return (HEX_COLOR_RE_.test(s) || s.indexOf('rgba(') === 0 || s.indexOf('rgb(') === 0);
}
//# sourceMappingURL=color.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "asColorLike", function() { return asColorLike; });
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
/**
 * @module ol/colorlike
 */

/**
 * A type accepted by CanvasRenderingContext2D.fillStyle
 * or CanvasRenderingContext2D.strokeStyle.
 * Represents a color, pattern, or gradient. The origin for patterns and
 * gradients as fill style is an increment of 512 css pixels from map coordinate
 * `[0, 0]`. For seamless repeat patterns, width and height of the pattern image
 * must be a factor of two (2, 4, 8, ..., 512).
 *
 * @typedef {string|CanvasPattern|CanvasGradient} ColorLike
 * @api
 */
/**
 * @param {import("./color.js").Color|ColorLike} color Color.
 * @return {ColorLike} The color as an {@link ol/colorlike~ColorLike}.
 * @api
 */
function asColorLike(color) {
    if (Array.isArray(color)) {
        return Object(_color_js__WEBPACK_IMPORTED_MODULE_0__["toString"])(color);
    }
    else {
        return color;
    }
}
//# sourceMappingURL=colorlike.js.map

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCanvasContext2D", function() { return createCanvasContext2D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outerWidth", function() { return outerWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "outerHeight", function() { return outerHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceNode", function() { return replaceNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeNode", function() { return removeNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeChildren", function() { return removeChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceChildren", function() { return replaceChildren; });
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);

/**
 * @module ol/dom
 */
//FIXME Move this function to the canvas module
/**
 * Create an html canvas element and returns its 2d context.
 * @param {number} [opt_width] Canvas width.
 * @param {number} [opt_height] Canvas height.
 * @param {Array<HTMLCanvasElement>} [opt_canvasPool] Canvas pool to take existing canvas from.
 * @param {CanvasRenderingContext2DSettings} [opt_Context2DSettings] CanvasRenderingContext2DSettings
 * @return {CanvasRenderingContext2D} The context.
 */
function createCanvasContext2D(opt_width, opt_height, opt_canvasPool, opt_Context2DSettings) {
    var canvas = opt_canvasPool && opt_canvasPool.length
        ? opt_canvasPool.shift()
        : _has_js__WEBPACK_IMPORTED_MODULE_0__["WORKER_OFFSCREEN_CANVAS"]
            ? new OffscreenCanvas(opt_width || 300, opt_height || 300)
            : document.createElement('canvas');
    if (opt_width) {
        canvas.width = opt_width;
    }
    if (opt_height) {
        canvas.height = opt_height;
    }
    //FIXME Allow OffscreenCanvasRenderingContext2D as return type
    return /** @type {CanvasRenderingContext2D} */ (canvas.getContext('2d', opt_Context2DSettings));
}
/**
 * Get the current computed width for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerWidth(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The width.
 */
function outerWidth(element) {
    var width = element.offsetWidth;
    var style = getComputedStyle(element);
    width += parseInt(style.marginLeft, 10) + parseInt(style.marginRight, 10);
    return width;
}
/**
 * Get the current computed height for the given element including margin,
 * padding and border.
 * Equivalent to jQuery's `$(el).outerHeight(true)`.
 * @param {!HTMLElement} element Element.
 * @return {number} The height.
 */
function outerHeight(element) {
    var height = element.offsetHeight;
    var style = getComputedStyle(element);
    height += parseInt(style.marginTop, 10) + parseInt(style.marginBottom, 10);
    return height;
}
/**
 * @param {Node} newNode Node to replace old node
 * @param {Node} oldNode The node to be replaced
 */
function replaceNode(newNode, oldNode) {
    var parent = oldNode.parentNode;
    if (parent) {
        parent.replaceChild(newNode, oldNode);
    }
}
/**
 * @param {Node} node The node to remove.
 * @return {Node} The node that was removed or null.
 */
function removeNode(node) {
    return node && node.parentNode ? node.parentNode.removeChild(node) : null;
}
/**
 * @param {Node} node The node to remove the children from.
 */
function removeChildren(node) {
    while (node.lastChild) {
        node.removeChild(node.lastChild);
    }
}
/**
 * Transform the children of a parent node so they match the
 * provided list of children.  This function aims to efficiently
 * remove, add, and reorder child nodes while maintaining a simple
 * implementation (it is not guaranteed to minimize DOM operations).
 * @param {Node} node The parent node whose children need reworking.
 * @param {Array<Node>} children The desired children.
 */
function replaceChildren(node, children) {
    var oldChildren = node.childNodes;
    for (var i = 0; true; ++i) {
        var oldChild = oldChildren[i];
        var newChild = children[i];
        // check if our work is done
        if (!oldChild && !newChild) {
            break;
        }
        // check if children match
        if (oldChild === newChild) {
            continue;
        }
        // check if a new child needs to be added
        if (!oldChild) {
            node.appendChild(newChild);
            continue;
        }
        // check if an old child needs to be removed
        if (!newChild) {
            node.removeChild(oldChild);
            --i;
            continue;
        }
        // reorder
        node.insertBefore(newChild, oldChild);
    }
}
//# sourceMappingURL=dom.js.map

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FIREFOX", function() { return FIREFOX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SAFARI", function() { return SAFARI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WEBKIT", function() { return WEBKIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAC", function() { return MAC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEVICE_PIXEL_RATIO", function() { return DEVICE_PIXEL_RATIO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WORKER_OFFSCREEN_CANVAS", function() { return WORKER_OFFSCREEN_CANVAS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGE_DECODE", function() { return IMAGE_DECODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PASSIVE_EVENT_LISTENERS", function() { return PASSIVE_EVENT_LISTENERS; });
/**
 * @module ol/has
 */
var ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined'
    ? navigator.userAgent.toLowerCase()
    : '';
/**
 * User agent string says we are dealing with Firefox as browser.
 * @type {boolean}
 */
var FIREFOX = ua.indexOf('firefox') !== -1;
/**
 * User agent string says we are dealing with Safari as browser.
 * @type {boolean}
 */
var SAFARI = ua.indexOf('safari') !== -1 && ua.indexOf('chrom') == -1;
/**
 * User agent string says we are dealing with a WebKit engine.
 * @type {boolean}
 */
var WEBKIT = ua.indexOf('webkit') !== -1 && ua.indexOf('edge') == -1;
/**
 * User agent string says we are dealing with a Mac as platform.
 * @type {boolean}
 */
var MAC = ua.indexOf('macintosh') !== -1;
/**
 * The ratio between physical pixels and device-independent pixels
 * (dips) on the device (`window.devicePixelRatio`).
 * @const
 * @type {number}
 * @api
 */
var DEVICE_PIXEL_RATIO = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
/**
 * The execution context is a worker with OffscreenCanvas available.
 * @const
 * @type {boolean}
 */
var WORKER_OFFSCREEN_CANVAS = typeof WorkerGlobalScope !== 'undefined' &&
    typeof OffscreenCanvas !== 'undefined' &&
    self instanceof WorkerGlobalScope; //eslint-disable-line
/**
 * Image.prototype.decode() is supported.
 * @type {boolean}
 */
var IMAGE_DECODE = typeof Image !== 'undefined' && Image.prototype.decode;
/**
 * @type {boolean}
 */
var PASSIVE_EVENT_LISTENERS = (function () {
    var passive = false;
    try {
        var options = Object.defineProperty({}, 'passive', {
            get: function () {
                passive = true;
            },
        });
        window.addEventListener('_', null, options);
        window.removeEventListener('_', null, options);
    }
    catch (error) {
        // passive not supported
    }
    return passive;
})();
//# sourceMappingURL=has.js.map

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFont", function() { return defaultFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultFillStyle", function() { return defaultFillStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLineCap", function() { return defaultLineCap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLineDash", function() { return defaultLineDash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLineDashOffset", function() { return defaultLineDashOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLineJoin", function() { return defaultLineJoin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultMiterLimit", function() { return defaultMiterLimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultStrokeStyle", function() { return defaultStrokeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTextAlign", function() { return defaultTextAlign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTextBaseline", function() { return defaultTextBaseline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultPadding", function() { return defaultPadding; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLineWidth", function() { return defaultLineWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkedFonts", function() { return checkedFonts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "labelCache", function() { return labelCache; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "textHeights", function() { return textHeights; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerFont", function() { return registerFont; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "measureTextHeight", function() { return measureTextHeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "measureTextWidth", function() { return measureTextWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "measureAndCacheTextWidth", function() { return measureAndCacheTextWidth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "measureTextWidths", function() { return measureTextWidths; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rotateAtOffset", function() { return rotateAtOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drawImageOrLabel", function() { return drawImageOrLabel; });
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55);
/**
 * @module ol/render/canvas
 */






/**
 * @typedef {Object} FillState
 * @property {import("../colorlike.js").ColorLike} fillStyle FillStyle.
 */
/**
 * @typedef Label
 * @property {number} width Width.
 * @property {number} height Height.
 * @property {Array<string|number>} contextInstructions ContextInstructions.
 */
/**
 * @typedef {Object} FillStrokeState
 * @property {import("../colorlike.js").ColorLike} [currentFillStyle] Current FillStyle.
 * @property {import("../colorlike.js").ColorLike} [currentStrokeStyle] Current StrokeStyle.
 * @property {CanvasLineCap} [currentLineCap] Current LineCap.
 * @property {Array<number>} currentLineDash Current LineDash.
 * @property {number} [currentLineDashOffset] Current LineDashOffset.
 * @property {CanvasLineJoin} [currentLineJoin] Current LineJoin.
 * @property {number} [currentLineWidth] Current LineWidth.
 * @property {number} [currentMiterLimit] Current MiterLimit.
 * @property {number} [lastStroke] Last stroke.
 * @property {import("../colorlike.js").ColorLike} [fillStyle] FillStyle.
 * @property {import("../colorlike.js").ColorLike} [strokeStyle] StrokeStyle.
 * @property {CanvasLineCap} [lineCap] LineCap.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} [lineDashOffset] LineDashOffset.
 * @property {CanvasLineJoin} [lineJoin] LineJoin.
 * @property {number} [lineWidth] LineWidth.
 * @property {number} [miterLimit] MiterLimit.
 */
/**
 * @typedef {Object} StrokeState
 * @property {CanvasLineCap} lineCap LineCap.
 * @property {Array<number>} lineDash LineDash.
 * @property {number} lineDashOffset LineDashOffset.
 * @property {CanvasLineJoin} lineJoin LineJoin.
 * @property {number} lineWidth LineWidth.
 * @property {number} miterLimit MiterLimit.
 * @property {import("../colorlike.js").ColorLike} strokeStyle StrokeStyle.
 */
/**
 * @typedef {Object} TextState
 * @property {string} font Font.
 * @property {string} [textAlign] TextAlign.
 * @property {string} textBaseline TextBaseline.
 * @property {string} [placement] Placement.
 * @property {number} [maxAngle] MaxAngle.
 * @property {boolean} [overflow] Overflow.
 * @property {import("../style/Fill.js").default} [backgroundFill] BackgroundFill.
 * @property {import("../style/Stroke.js").default} [backgroundStroke] BackgroundStroke.
 * @property {import("../size.js").Size} [scale] Scale.
 * @property {Array<number>} [padding] Padding.
 */
/**
 * @typedef {Object} SerializableInstructions
 * @property {Array<*>} instructions The rendering instructions.
 * @property {Array<*>} hitDetectionInstructions The rendering hit detection instructions.
 * @property {Array<number>} coordinates The array of all coordinates.
 * @property {!Object<string, TextState>} [textStates] The text states (decluttering).
 * @property {!Object<string, FillState>} [fillStates] The fill states (decluttering).
 * @property {!Object<string, StrokeState>} [strokeStates] The stroke states (decluttering).
 */
/**
 * @typedef {Object<number, import("./canvas/Executor.js").ReplayImageOrLabelArgs>} DeclutterImageWithText
 */
/**
 * @const
 * @type {string}
 */
var defaultFont = '10px sans-serif';
/**
 * @const
 * @type {import("../colorlike.js").ColorLike}
 */
var defaultFillStyle = '#000';
/**
 * @const
 * @type {CanvasLineCap}
 */
var defaultLineCap = 'round';
/**
 * @const
 * @type {Array<number>}
 */
var defaultLineDash = [];
/**
 * @const
 * @type {number}
 */
var defaultLineDashOffset = 0;
/**
 * @const
 * @type {CanvasLineJoin}
 */
var defaultLineJoin = 'round';
/**
 * @const
 * @type {number}
 */
var defaultMiterLimit = 10;
/**
 * @const
 * @type {import("../colorlike.js").ColorLike}
 */
var defaultStrokeStyle = '#000';
/**
 * @const
 * @type {string}
 */
var defaultTextAlign = 'center';
/**
 * @const
 * @type {string}
 */
var defaultTextBaseline = 'middle';
/**
 * @const
 * @type {Array<number>}
 */
var defaultPadding = [0, 0, 0, 0];
/**
 * @const
 * @type {number}
 */
var defaultLineWidth = 1;
/**
 * @type {BaseObject}
 */
var checkedFonts = new _Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
/**
 * The label cache for text rendering. To change the default cache size of 2048
 * entries, use {@link module:ol/structs/LRUCache~LRUCache#setSize cache.setSize()}.
 * Deprecated - there is no label cache any more.
 * @type {?}
 * @api
 * @deprecated
 */
var labelCache = new _events_Target_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
labelCache.setSize = function () {
    console.warn('labelCache is deprecated.'); //eslint-disable-line
};
/**
 * @type {CanvasRenderingContext2D}
 */
var measureContext = null;
/**
 * @type {string}
 */
var measureFont;
/**
 * @type {!Object<string, number>}
 */
var textHeights = {};
/**
 * Clears the label cache when a font becomes available.
 * @param {string} fontSpec CSS font spec.
 */
var registerFont = (function () {
    var retries = 100;
    var size = '32px ';
    var referenceFonts = ['monospace', 'serif'];
    var len = referenceFonts.length;
    var text = 'wmytzilWMYTZIL@#/&?$%10\uF013';
    var interval, referenceWidth;
    /**
     * @param {string} fontStyle Css font-style
     * @param {string} fontWeight Css font-weight
     * @param {*} fontFamily Css font-family
     * @return {boolean} Font with style and weight is available
     */
    function isAvailable(fontStyle, fontWeight, fontFamily) {
        var available = true;
        for (var i = 0; i < len; ++i) {
            var referenceFont = referenceFonts[i];
            referenceWidth = measureTextWidth(fontStyle + ' ' + fontWeight + ' ' + size + referenceFont, text);
            if (fontFamily != referenceFont) {
                var width = measureTextWidth(fontStyle +
                    ' ' +
                    fontWeight +
                    ' ' +
                    size +
                    fontFamily +
                    ',' +
                    referenceFont, text);
                // If width and referenceWidth are the same, then the fallback was used
                // instead of the font we wanted, so the font is not available.
                available = available && width != referenceWidth;
            }
        }
        if (available) {
            return true;
        }
        return false;
    }
    function check() {
        var done = true;
        var fonts = checkedFonts.getKeys();
        for (var i = 0, ii = fonts.length; i < ii; ++i) {
            var font = fonts[i];
            if (checkedFonts.get(font) < retries) {
                if (isAvailable.apply(this, font.split('\n'))) {
                    Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["clear"])(textHeights);
                    // Make sure that loaded fonts are picked up by Safari
                    measureContext = null;
                    measureFont = undefined;
                    checkedFonts.set(font, retries);
                }
                else {
                    checkedFonts.set(font, checkedFonts.get(font) + 1, true);
                    done = false;
                }
            }
        }
        if (done) {
            clearInterval(interval);
            interval = undefined;
        }
    }
    return function (fontSpec) {
        var font = Object(_css_js__WEBPACK_IMPORTED_MODULE_5__["getFontParameters"])(fontSpec);
        if (!font) {
            return;
        }
        var families = font.families;
        for (var i = 0, ii = families.length; i < ii; ++i) {
            var family = families[i];
            var key = font.style + '\n' + font.weight + '\n' + family;
            if (checkedFonts.get(key) === undefined) {
                checkedFonts.set(key, retries, true);
                if (!isAvailable(font.style, font.weight, family)) {
                    checkedFonts.set(key, 0, true);
                    if (interval === undefined) {
                        interval = setInterval(check, 32);
                    }
                }
            }
        }
    };
})();
/**
 * @param {string} font Font to use for measuring.
 * @return {import("../size.js").Size} Measurement.
 */
var measureTextHeight = (function () {
    /**
     * @type {HTMLDivElement}
     */
    var measureElement;
    return function (fontSpec) {
        var height = textHeights[fontSpec];
        if (height == undefined) {
            if (_has_js__WEBPACK_IMPORTED_MODULE_2__["WORKER_OFFSCREEN_CANVAS"]) {
                var font = Object(_css_js__WEBPACK_IMPORTED_MODULE_5__["getFontParameters"])(fontSpec);
                var metrics = measureText(fontSpec, 'Žg');
                var lineHeight = isNaN(Number(font.lineHeight))
                    ? 1.2
                    : Number(font.lineHeight);
                height =
                    lineHeight *
                        (metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent);
            }
            else {
                if (!measureElement) {
                    measureElement = document.createElement('div');
                    measureElement.innerHTML = 'M';
                    measureElement.style.minHeight = '0';
                    measureElement.style.maxHeight = 'none';
                    measureElement.style.height = 'auto';
                    measureElement.style.padding = '0';
                    measureElement.style.border = 'none';
                    measureElement.style.position = 'absolute';
                    measureElement.style.display = 'block';
                    measureElement.style.left = '-99999px';
                }
                measureElement.style.font = fontSpec;
                document.body.appendChild(measureElement);
                height = measureElement.offsetHeight;
                document.body.removeChild(measureElement);
            }
            textHeights[fontSpec] = height;
        }
        return height;
    };
})();
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {TextMetrics} Text metrics.
 */
function measureText(font, text) {
    if (!measureContext) {
        measureContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(1, 1);
    }
    if (font != measureFont) {
        measureContext.font = font;
        measureFont = measureContext.font;
    }
    return measureContext.measureText(text);
}
/**
 * @param {string} font Font.
 * @param {string} text Text.
 * @return {number} Width.
 */
function measureTextWidth(font, text) {
    return measureText(font, text).width;
}
/**
 * Measure text width using a cache.
 * @param {string} font The font.
 * @param {string} text The text to measure.
 * @param {Object<string, number>} cache A lookup of cached widths by text.
 * @return {number} The text width.
 */
function measureAndCacheTextWidth(font, text, cache) {
    if (text in cache) {
        return cache[text];
    }
    var width = measureTextWidth(font, text);
    cache[text] = width;
    return width;
}
/**
 * @param {string} font Font to use for measuring.
 * @param {Array<string>} lines Lines to measure.
 * @param {Array<number>} widths Array will be populated with the widths of
 * each line.
 * @return {number} Width of the whole text.
 */
function measureTextWidths(font, lines, widths) {
    var numLines = lines.length;
    var width = 0;
    for (var i = 0; i < numLines; ++i) {
        var currentWidth = measureTextWidth(font, lines[i]);
        width = Math.max(width, currentWidth);
        widths.push(currentWidth);
    }
    return width;
}
/**
 * @param {CanvasRenderingContext2D} context Context.
 * @param {number} rotation Rotation.
 * @param {number} offsetX X offset.
 * @param {number} offsetY Y offset.
 */
function rotateAtOffset(context, rotation, offsetX, offsetY) {
    if (rotation !== 0) {
        context.translate(offsetX, offsetY);
        context.rotate(rotation);
        context.translate(-offsetX, -offsetY);
    }
}
/**
 * @param {CanvasRenderingContext2D} context Context.
 * @param {import("../transform.js").Transform|null} transform Transform.
 * @param {number} opacity Opacity.
 * @param {Label|HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} labelOrImage Label.
 * @param {number} originX Origin X.
 * @param {number} originY Origin Y.
 * @param {number} w Width.
 * @param {number} h Height.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {import("../size.js").Size} scale Scale.
 */
function drawImageOrLabel(context, transform, opacity, labelOrImage, originX, originY, w, h, x, y, scale) {
    context.save();
    if (opacity !== 1) {
        context.globalAlpha *= opacity;
    }
    if (transform) {
        context.setTransform.apply(context, transform);
    }
    if ( /** @type {*} */(labelOrImage).contextInstructions) {
        // label
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        executeLabelInstructions(/** @type {Label} */ (labelOrImage), context);
    }
    else if (scale[0] < 0 || scale[1] < 0) {
        // flipped image
        context.translate(x, y);
        context.scale(scale[0], scale[1]);
        context.drawImage(
        /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ (labelOrImage), originX, originY, w, h, 0, 0, w, h);
    }
    else {
        // if image not flipped translate and scale can be avoided
        context.drawImage(
        /** @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} */ (labelOrImage), originX, originY, w, h, x, y, w * scale[0], h * scale[1]);
    }
    context.restore();
}
/**
 * @param {Label} label Label.
 * @param {CanvasRenderingContext2D} context Context.
 */
function executeLabelInstructions(label, context) {
    var contextInstructions = label.contextInstructions;
    for (var i = 0, ii = contextInstructions.length; i < ii; i += 2) {
        if (Array.isArray(contextInstructions[i + 1])) {
            context[contextInstructions[i]].apply(context, contextInstructions[i + 1]);
        }
        else {
            context[contextInstructions[i]] = contextInstructions[i + 1];
        }
    }
}
//# sourceMappingURL=canvas.js.map

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ObjectEvent", function() { return ObjectEvent; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Object
 */





/**
 * @classdesc
 * Events emitted by {@link module:ol/Object~BaseObject} instances are instances of this type.
 */
var ObjectEvent = /** @class */ (function (_super) {
    __extends(ObjectEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {string} key The property name.
     * @param {*} oldValue The old value for `key`.
     */
    function ObjectEvent(type, key, oldValue) {
        var _this = _super.call(this, type) || this;
        /**
         * The name of the property whose value is changing.
         * @type {string}
         * @api
         */
        _this.key = key;
        /**
         * The old value. To get the new value use `e.target.get(e.key)` where
         * `e` is the event object.
         * @type {*}
         * @api
         */
        _this.oldValue = oldValue;
        return _this;
    }
    return ObjectEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<import("./ObjectEventType").Types, ObjectEvent, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types, Return>} ObjectOnSignature
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Most non-trivial classes inherit from this.
 *
 * This extends {@link module:ol/Observable} with observable
 * properties, where each property is observable as well as the object as a
 * whole.
 *
 * Classes that inherit from this have pre-defined properties, to which you can
 * add your owns. The pre-defined properties are listed in this documentation as
 * 'Observable Properties', and have their own accessors; for example,
 * {@link module:ol/Map~Map} has a `target` property, accessed with
 * `getTarget()` and changed with `setTarget()`. Not all properties are however
 * settable. There are also general-purpose accessors `get()` and `set()`. For
 * example, `get('target')` is equivalent to `getTarget()`.
 *
 * The `set` accessors trigger a change event, and you can monitor this by
 * registering a listener. For example, {@link module:ol/View~View} has a
 * `center` property, so `view.on('change:center', function(evt) {...});` would
 * call the function whenever the value of the center property changes. Within
 * the function, `evt.target` would be the view, so `evt.target.getCenter()`
 * would return the new center.
 *
 * You can add your own observable properties with
 * `object.set('prop', 'value')`, and retrieve that with `object.get('prop')`.
 * You can listen for changes on that property value with
 * `object.on('change:prop', listener)`. You can get a list of all
 * properties with {@link module:ol/Object~BaseObject#getProperties}.
 *
 * Note that the observable properties are separate from standard JS properties.
 * You can, for example, give your map object a title with
 * `map.title='New title'` and with `map.set('title', 'Another title')`. The
 * first will be a `hasOwnProperty`; the second will appear in
 * `getProperties()`. Only the second is observable.
 *
 * Properties can be deleted by using the unset method. E.g.
 * object.unset('foo').
 *
 * @fires ObjectEvent
 * @api
 */
var BaseObject = /** @class */ (function (_super) {
    __extends(BaseObject, _super);
    /**
     * @param {Object<string, *>} [opt_values] An object with key-value pairs.
     */
    function BaseObject(opt_values) {
        var _this = _super.call(this) || this;
        /***
         * @type {ObjectOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ObjectOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ObjectOnSignature<void>}
         */
        _this.un;
        // Call {@link module:ol/util.getUid} to ensure that the order of objects' ids is
        // the same as the order in which they were created.  This also helps to
        // ensure that object properties are always added in the same order, which
        // helps many JavaScript engines generate faster code.
        Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["getUid"])(_this);
        /**
         * @private
         * @type {Object<string, *>}
         */
        _this.values_ = null;
        if (opt_values !== undefined) {
            _this.setProperties(opt_values);
        }
        return _this;
    }
    /**
     * Gets a value.
     * @param {string} key Key name.
     * @return {*} Value.
     * @api
     */
    BaseObject.prototype.get = function (key) {
        var value;
        if (this.values_ && this.values_.hasOwnProperty(key)) {
            value = this.values_[key];
        }
        return value;
    };
    /**
     * Get a list of object property names.
     * @return {Array<string>} List of property names.
     * @api
     */
    BaseObject.prototype.getKeys = function () {
        return (this.values_ && Object.keys(this.values_)) || [];
    };
    /**
     * Get an object of all property names and values.
     * @return {Object<string, *>} Object.
     * @api
     */
    BaseObject.prototype.getProperties = function () {
        return (this.values_ && Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])({}, this.values_)) || {};
    };
    /**
     * @return {boolean} The object has properties.
     */
    BaseObject.prototype.hasProperties = function () {
        return !!this.values_;
    };
    /**
     * @param {string} key Key name.
     * @param {*} oldValue Old value.
     */
    BaseObject.prototype.notify = function (key, oldValue) {
        var eventType;
        eventType = "change:" + key;
        this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
        eventType = _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].PROPERTYCHANGE;
        this.dispatchEvent(new ObjectEvent(eventType, key, oldValue));
    };
    /**
     * @param {string} key Key name.
     * @param {import("./events.js").Listener} listener Listener.
     */
    BaseObject.prototype.addChangeListener = function (key, listener) {
        this.addEventListener("change:" + key, listener);
    };
    /**
     * @param {string} key Key name.
     * @param {import("./events.js").Listener} listener Listener.
     */
    BaseObject.prototype.removeChangeListener = function (key, listener) {
        this.removeEventListener("change:" + key, listener);
    };
    /**
     * Sets a value.
     * @param {string} key Key name.
     * @param {*} value Value.
     * @param {boolean} [opt_silent] Update without triggering an event.
     * @api
     */
    BaseObject.prototype.set = function (key, value, opt_silent) {
        var values = this.values_ || (this.values_ = {});
        if (opt_silent) {
            values[key] = value;
        }
        else {
            var oldValue = values[key];
            values[key] = value;
            if (oldValue !== value) {
                this.notify(key, oldValue);
            }
        }
    };
    /**
     * Sets a collection of key-value pairs.  Note that this changes any existing
     * properties and adds new ones (it does not remove any existing properties).
     * @param {Object<string, *>} values Values.
     * @param {boolean} [opt_silent] Update without triggering an event.
     * @api
     */
    BaseObject.prototype.setProperties = function (values, opt_silent) {
        for (var key in values) {
            this.set(key, values[key], opt_silent);
        }
    };
    /**
     * Apply any properties from another object without triggering events.
     * @param {BaseObject} source The source object.
     * @protected
     */
    BaseObject.prototype.applyProperties = function (source) {
        if (!source.values_) {
            return;
        }
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])(this.values_ || (this.values_ = {}), source.values_);
    };
    /**
     * Unsets a property.
     * @param {string} key Key name.
     * @param {boolean} [opt_silent] Unset without triggering an event.
     * @api
     */
    BaseObject.prototype.unset = function (key, opt_silent) {
        if (this.values_ && key in this.values_) {
            var oldValue = this.values_[key];
            delete this.values_[key];
            if (Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["isEmpty"])(this.values_)) {
                this.values_ = null;
            }
            if (!opt_silent) {
                this.notify(key, oldValue);
            }
        }
    };
    return BaseObject;
}(_Observable_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseObject);
//# sourceMappingURL=Object.js.map

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stopPropagation", function() { return stopPropagation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefault", function() { return preventDefault; });
/**
 * @module ol/events/Event
 */
/**
 * @classdesc
 * Stripped down implementation of the W3C DOM Level 2 Event interface.
 * See https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-interface.
 *
 * This implementation only provides `type` and `target` properties, and
 * `stopPropagation` and `preventDefault` methods. It is meant as base class
 * for higher level events defined in the library, and works with
 * {@link module:ol/events/Target~Target}.
 */
var BaseEvent = /** @class */ (function () {
    /**
     * @param {string} type Type.
     */
    function BaseEvent(type) {
        /**
         * @type {boolean}
         */
        this.propagationStopped;
        /**
         * @type {boolean}
         */
        this.defaultPrevented;
        /**
         * The event type.
         * @type {string}
         * @api
         */
        this.type = type;
        /**
         * The event target.
         * @type {Object}
         * @api
         */
        this.target = null;
    }
    /**
     * Prevent default. This means that no emulated `click`, `singleclick` or `doubleclick` events
     * will be fired.
     * @api
     */
    BaseEvent.prototype.preventDefault = function () {
        this.defaultPrevented = true;
    };
    /**
     * Stop event propagation.
     * @api
     */
    BaseEvent.prototype.stopPropagation = function () {
        this.propagationStopped = true;
    };
    return BaseEvent;
}());
/**
 * @param {Event|import("./Event.js").default} evt Event
 */
function stopPropagation(evt) {
    evt.stopPropagation();
}
/**
 * @param {Event|import("./Event.js").default} evt Event
 */
function preventDefault(evt) {
    evt.preventDefault();
}
/* harmony default export */ __webpack_exports__["default"] = (BaseEvent);
//# sourceMappingURL=Event.js.map

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/ObjectEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered when a property is changed.
     * @event module:ol/Object.ObjectEvent#propertychange
     * @api
     */
    PROPERTYCHANGE: 'propertychange',
});
/**
 * @typedef {'propertychange'} Types
 */
//# sourceMappingURL=ObjectEventType.js.map

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unByKey", function() { return unByKey; });
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Observable
 */



/***
 * @template {string} Type
 * @template {Event|import("./events/Event.js").default} EventClass
 * @template Return
 * @typedef {(type: Type|Type[], listener: (event: EventClass) => (void|boolean)) => Return} OnSignature
 */
/***
 * @template {string} Type
 * @template Return
 * @typedef {(type: Type[], listener: (event: Event|import("./events/Event").default) => (void|boolean)) => Return} CombinedOnSignature
 */
/***
 * @typedef {import("./events").EventsKey|Array<import("./events").EventsKey>} OnReturn
 */
/**
 * @typedef {'change'|'error'} EventTypes
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * An event target providing convenient methods for listener registration
 * and unregistration. A generic `change` event is always available through
 * {@link module:ol/Observable~Observable#changed}.
 *
 * @fires import("./events/Event.js").default
 * @api
 */
var Observable = /** @class */ (function (_super) {
    __extends(Observable, _super);
    function Observable() {
        var _this = _super.call(this) || this;
        /***
         * @type {OnSignature<EventTypes, import("./events/Event.js").default, OnReturn>}
         */
        _this.on = _this.onInternal;
        /***
         * @type {OnSignature<EventTypes, import("./events/Event.js").default, OnReturn>}
         */
        _this.once = _this.onceInternal;
        /***
         * @type {OnSignature<EventTypes, import("./events/Event.js").default, void>}
         */
        _this.un = _this.unInternal;
        /**
         * @private
         * @type {number}
         */
        _this.revision_ = 0;
        return _this;
    }
    /**
     * Increases the revision counter and dispatches a 'change' event.
     * @api
     */
    Observable.prototype.changed = function () {
        ++this.revision_;
        this.dispatchEvent(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE);
    };
    /**
     * Get the version number for this object.  Each time the object is modified,
     * its version number will be incremented.
     * @return {number} Revision.
     * @api
     */
    Observable.prototype.getRevision = function () {
        return this.revision_;
    };
    /**
     * @param {string|Array<string>} type Type.
     * @param {function(?): (void|boolean)} listener Listener.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
     * @protected
     */
    Observable.prototype.onInternal = function (type, listener) {
        if (Array.isArray(type)) {
            var len = type.length;
            var keys = new Array(len);
            for (var i = 0; i < len; ++i) {
                keys[i] = Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["listen"])(this, type[i], listener);
            }
            return keys;
        }
        else {
            return Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["listen"])(this, /** @type {string} */ (type), listener);
        }
    };
    /**
     * @param {string|Array<string>} type Type.
     * @param {function(?): (void|boolean)} listener Listener.
     * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Event key.
     * @protected
     */
    Observable.prototype.onceInternal = function (type, listener) {
        var key;
        if (Array.isArray(type)) {
            var len = type.length;
            key = new Array(len);
            for (var i = 0; i < len; ++i) {
                key[i] = Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["listenOnce"])(this, type[i], listener);
            }
        }
        else {
            key = Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["listenOnce"])(this, /** @type {string} */ (type), listener);
        }
        /** @type {Object} */ (listener).ol_key = key;
        return key;
    };
    /**
     * Unlisten for a certain type of event.
     * @param {string|Array<string>} type Type.
     * @param {function(?): (void|boolean)} listener Listener.
     * @protected
     */
    Observable.prototype.unInternal = function (type, listener) {
        var key = /** @type {Object} */ (listener).ol_key;
        if (key) {
            unByKey(key);
        }
        else if (Array.isArray(type)) {
            for (var i = 0, ii = type.length; i < ii; ++i) {
                this.removeEventListener(type[i], listener);
            }
        }
        else {
            this.removeEventListener(type, listener);
        }
    };
    return Observable;
}(_events_Target_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Listen for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): (void|boolean)} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */
Observable.prototype.on;
/**
 * Listen once for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): (void|boolean)} listener The listener function.
 * @return {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} Unique key for the listener. If
 *     called with an array of event types as the first argument, the return
 *     will be an array of keys.
 * @api
 */
Observable.prototype.once;
/**
 * Unlisten for a certain type of event.
 * @function
 * @param {string|Array<string>} type The event type or array of event types.
 * @param {function((Event|import("./events/Event").default)): (void|boolean)} listener The listener function.
 * @api
 */
Observable.prototype.un;
/**
 * Removes an event listener using the key returned by `on()` or `once()`.
 * @param {import("./events.js").EventsKey|Array<import("./events.js").EventsKey>} key The key returned by `on()`
 *     or `once()` (or an array of keys).
 * @api
 */
function unByKey(key) {
    if (Array.isArray(key)) {
        for (var i = 0, ii = key.length; i < ii; ++i) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["unlistenByKey"])(key[i]);
        }
    }
    else {
        Object(_events_js__WEBPACK_IMPORTED_MODULE_2__["unlistenByKey"])(/** @type {import("./events.js").EventsKey} */ (key));
    }
}
/* harmony default export */ __webpack_exports__["default"] = (Observable);
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Disposable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
/* harmony import */ var _Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/events/Target
 */




/**
 * @typedef {EventTarget|Target} EventTargetLike
 */
/**
 * @classdesc
 * A simplified implementation of the W3C DOM Level 2 EventTarget interface.
 * See https://www.w3.org/TR/2000/REC-DOM-Level-2-Events-20001113/events.html#Events-EventTarget.
 *
 * There are two important simplifications compared to the specification:
 *
 * 1. The handling of `useCapture` in `addEventListener` and
 *    `removeEventListener`. There is no real capture model.
 * 2. The handling of `stopPropagation` and `preventDefault` on `dispatchEvent`.
 *    There is no event target hierarchy. When a listener calls
 *    `stopPropagation` or `preventDefault` on an event object, it means that no
 *    more listeners after this one will be called. Same as when the listener
 *    returns false.
 */
var Target = /** @class */ (function (_super) {
    __extends(Target, _super);
    /**
     * @param {*} [opt_target] Default event target for dispatched events.
     */
    function Target(opt_target) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {*}
         */
        _this.eventTarget_ = opt_target;
        /**
         * @private
         * @type {Object<string, number>}
         */
        _this.pendingRemovals_ = null;
        /**
         * @private
         * @type {Object<string, number>}
         */
        _this.dispatching_ = null;
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").Listener>>}
         */
        _this.listeners_ = null;
        return _this;
    }
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */
    Target.prototype.addEventListener = function (type, listener) {
        if (!type || !listener) {
            return;
        }
        var listeners = this.listeners_ || (this.listeners_ = {});
        var listenersForType = listeners[type] || (listeners[type] = []);
        if (listenersForType.indexOf(listener) === -1) {
            listenersForType.push(listener);
        }
    };
    /**
     * Dispatches an event and calls all listeners listening for events
     * of this type. The event parameter can either be a string or an
     * Object with a `type` property.
     *
     * @param {import("./Event.js").default|string} event Event object.
     * @return {boolean|undefined} `false` if anyone called preventDefault on the
     *     event object or if any of the listeners returned false.
     * @api
     */
    Target.prototype.dispatchEvent = function (event) {
        /** @type {import("./Event.js").default|Event} */
        var evt = typeof event === 'string' ? new _Event_js__WEBPACK_IMPORTED_MODULE_1__["default"](event) : event;
        var type = evt.type;
        if (!evt.target) {
            evt.target = this.eventTarget_ || this;
        }
        var listeners = this.listeners_ && this.listeners_[type];
        var propagate;
        if (listeners) {
            var dispatching = this.dispatching_ || (this.dispatching_ = {});
            var pendingRemovals = this.pendingRemovals_ || (this.pendingRemovals_ = {});
            if (!(type in dispatching)) {
                dispatching[type] = 0;
                pendingRemovals[type] = 0;
            }
            ++dispatching[type];
            for (var i = 0, ii = listeners.length; i < ii; ++i) {
                if ('handleEvent' in listeners[i]) {
                    propagate = /** @type {import("../events.js").ListenerObject} */ (listeners[i]).handleEvent(evt);
                }
                else {
                    propagate = /** @type {import("../events.js").ListenerFunction} */ (listeners[i]).call(this, evt);
                }
                if (propagate === false || evt.propagationStopped) {
                    propagate = false;
                    break;
                }
            }
            --dispatching[type];
            if (dispatching[type] === 0) {
                var pr = pendingRemovals[type];
                delete pendingRemovals[type];
                while (pr--) {
                    this.removeEventListener(type, _functions_js__WEBPACK_IMPORTED_MODULE_2__["VOID"]);
                }
                delete dispatching[type];
            }
            return propagate;
        }
    };
    /**
     * Clean up.
     */
    Target.prototype.disposeInternal = function () {
        this.listeners_ && Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["clear"])(this.listeners_);
    };
    /**
     * Get the listeners for a specified event type. Listeners are returned in the
     * order that they will be called in.
     *
     * @param {string} type Type.
     * @return {Array<import("../events.js").Listener>|undefined} Listeners.
     */
    Target.prototype.getListeners = function (type) {
        return (this.listeners_ && this.listeners_[type]) || undefined;
    };
    /**
     * @param {string} [opt_type] Type. If not provided,
     *     `true` will be returned if this event target has any listeners.
     * @return {boolean} Has listeners.
     */
    Target.prototype.hasListener = function (opt_type) {
        if (!this.listeners_) {
            return false;
        }
        return opt_type
            ? opt_type in this.listeners_
            : Object.keys(this.listeners_).length > 0;
    };
    /**
     * @param {string} type Type.
     * @param {import("../events.js").Listener} listener Listener.
     */
    Target.prototype.removeEventListener = function (type, listener) {
        var listeners = this.listeners_ && this.listeners_[type];
        if (listeners) {
            var index = listeners.indexOf(listener);
            if (index !== -1) {
                if (this.pendingRemovals_ && type in this.pendingRemovals_) {
                    // make listener a no-op, and remove later in #dispatchEvent()
                    listeners[index] = _functions_js__WEBPACK_IMPORTED_MODULE_2__["VOID"];
                    ++this.pendingRemovals_[type];
                }
                else {
                    listeners.splice(index, 1);
                    if (listeners.length === 0) {
                        delete this.listeners_[type];
                    }
                }
            }
        }
    };
    return Target;
}(_Disposable_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Target);
//# sourceMappingURL=Target.js.map

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/Disposable
 */
/**
 * @classdesc
 * Objects that need to clean up after themselves.
 */
var Disposable = /** @class */ (function () {
    function Disposable() {
        /**
         * The object has already been disposed.
         * @type {boolean}
         * @protected
         */
        this.disposed = false;
    }
    /**
     * Clean up.
     */
    Disposable.prototype.dispose = function () {
        if (!this.disposed) {
            this.disposed = true;
            this.disposeInternal();
        }
    };
    /**
     * Extension point for disposable objects.
     * @protected
     */
    Disposable.prototype.disposeInternal = function () { };
    return Disposable;
}());
/* harmony default export */ __webpack_exports__["default"] = (Disposable);
//# sourceMappingURL=Disposable.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRUE", function() { return TRUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FALSE", function() { return FALSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VOID", function() { return VOID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "memoizeOne", function() { return memoizeOne; });
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/**
 * @module ol/functions
 */

/**
 * Always returns true.
 * @return {boolean} true.
 */
function TRUE() {
    return true;
}
/**
 * Always returns false.
 * @return {boolean} false.
 */
function FALSE() {
    return false;
}
/**
 * A reusable function, used e.g. as a default for callbacks.
 *
 * @return {void} Nothing.
 */
function VOID() { }
/**
 * Wrap a function in another function that remembers the last return.  If the
 * returned function is called twice in a row with the same arguments and the same
 * this object, it will return the value from the first call in the second call.
 *
 * @param {function(...any): ReturnType} fn The function to memoize.
 * @return {function(...any): ReturnType} The memoized function.
 * @template ReturnType
 */
function memoizeOne(fn) {
    var called = false;
    /** @type {ReturnType} */
    var lastResult;
    /** @type {Array<any>} */
    var lastArgs;
    var lastThis;
    return function () {
        var nextArgs = Array.prototype.slice.call(arguments);
        if (!called || this !== lastThis || !Object(_array_js__WEBPACK_IMPORTED_MODULE_0__["equals"])(nextArgs, lastArgs)) {
            called = true;
            lastThis = this;
            lastArgs = nextArgs;
            lastResult = fn.apply(this, arguments);
        }
        return lastResult;
    };
}
//# sourceMappingURL=functions.js.map

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binarySearch", function() { return binarySearch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberSafeCompareFunction", function() { return numberSafeCompareFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "includes", function() { return includes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearFindNearest", function() { return linearFindNearest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reverseSubArray", function() { return reverseSubArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extend", function() { return extend; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "remove", function() { return remove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "find", function() { return find; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equals", function() { return equals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stableSort", function() { return stableSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findIndex", function() { return findIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSorted", function() { return isSorted; });
/**
 * @module ol/array
 */
/**
 * Performs a binary search on the provided sorted list and returns the index of the item if found. If it can't be found it'll return -1.
 * https://github.com/darkskyapp/binary-search
 *
 * @param {Array<*>} haystack Items to search through.
 * @param {*} needle The item to look for.
 * @param {Function} [opt_comparator] Comparator function.
 * @return {number} The index of the item if found, -1 if not.
 */
function binarySearch(haystack, needle, opt_comparator) {
    var mid, cmp;
    var comparator = opt_comparator || numberSafeCompareFunction;
    var low = 0;
    var high = haystack.length;
    var found = false;
    while (low < high) {
        /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
         * to double (which gives the wrong results). */
        mid = low + ((high - low) >> 1);
        cmp = +comparator(haystack[mid], needle);
        if (cmp < 0.0) {
            /* Too low. */
            low = mid + 1;
        }
        else {
            /* Key found or too high */
            high = mid;
            found = !cmp;
        }
    }
    /* Key not found. */
    return found ? low : ~low;
}
/**
 * Compare function for array sort that is safe for numbers.
 * @param {*} a The first object to be compared.
 * @param {*} b The second object to be compared.
 * @return {number} A negative number, zero, or a positive number as the first
 *     argument is less than, equal to, or greater than the second.
 */
function numberSafeCompareFunction(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
}
/**
 * Whether the array contains the given object.
 * @param {Array<*>} arr The array to test for the presence of the element.
 * @param {*} obj The object for which to test.
 * @return {boolean} The object is in the array.
 */
function includes(arr, obj) {
    return arr.indexOf(obj) >= 0;
}
/**
 * {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution} can use a function
 * of this type to determine which nearest resolution to use.
 *
 * This function takes a `{number}` representing a value between two array entries,
 * a `{number}` representing the value of the nearest higher entry and
 * a `{number}` representing the value of the nearest lower entry
 * as arguments and returns a `{number}`. If a negative number or zero is returned
 * the lower value will be used, if a positive number is returned the higher value
 * will be used.
 * @typedef {function(number, number, number): number} NearestDirectionFunction
 * @api
 */
/**
 * @param {Array<number>} arr Array in desccending order.
 * @param {number} target Target.
 * @param {number|NearestDirectionFunction} direction
 *    0 means return the nearest,
 *    > 0 means return the largest nearest,
 *    < 0 means return the smallest nearest.
 * @return {number} Index.
 */
function linearFindNearest(arr, target, direction) {
    var n = arr.length;
    if (arr[0] <= target) {
        return 0;
    }
    else if (target <= arr[n - 1]) {
        return n - 1;
    }
    else {
        var i = void 0;
        if (direction > 0) {
            for (i = 1; i < n; ++i) {
                if (arr[i] < target) {
                    return i - 1;
                }
            }
        }
        else if (direction < 0) {
            for (i = 1; i < n; ++i) {
                if (arr[i] <= target) {
                    return i;
                }
            }
        }
        else {
            for (i = 1; i < n; ++i) {
                if (arr[i] == target) {
                    return i;
                }
                else if (arr[i] < target) {
                    if (typeof direction === 'function') {
                        if (direction(target, arr[i - 1], arr[i]) > 0) {
                            return i - 1;
                        }
                        else {
                            return i;
                        }
                    }
                    else if (arr[i - 1] - target < target - arr[i]) {
                        return i - 1;
                    }
                    else {
                        return i;
                    }
                }
            }
        }
        return n - 1;
    }
}
/**
 * @param {Array<*>} arr Array.
 * @param {number} begin Begin index.
 * @param {number} end End index.
 */
function reverseSubArray(arr, begin, end) {
    while (begin < end) {
        var tmp = arr[begin];
        arr[begin] = arr[end];
        arr[end] = tmp;
        ++begin;
        --end;
    }
}
/**
 * @param {Array<VALUE>} arr The array to modify.
 * @param {!Array<VALUE>|VALUE} data The elements or arrays of elements to add to arr.
 * @template VALUE
 */
function extend(arr, data) {
    var extension = Array.isArray(data) ? data : [data];
    var length = extension.length;
    for (var i = 0; i < length; i++) {
        arr[arr.length] = extension[i];
    }
}
/**
 * @param {Array<VALUE>} arr The array to modify.
 * @param {VALUE} obj The element to remove.
 * @template VALUE
 * @return {boolean} If the element was removed.
 */
function remove(arr, obj) {
    var i = arr.indexOf(obj);
    var found = i > -1;
    if (found) {
        arr.splice(i, 1);
    }
    return found;
}
/**
 * @param {Array<VALUE>} arr The array to search in.
 * @param {function(VALUE, number, ?) : boolean} func The function to compare.
 * @template VALUE
 * @return {VALUE|null} The element found or null.
 */
function find(arr, func) {
    var length = arr.length >>> 0;
    var value;
    for (var i = 0; i < length; i++) {
        value = arr[i];
        if (func(value, i, arr)) {
            return value;
        }
    }
    return null;
}
/**
 * @param {Array|Uint8ClampedArray} arr1 The first array to compare.
 * @param {Array|Uint8ClampedArray} arr2 The second array to compare.
 * @return {boolean} Whether the two arrays are equal.
 */
function equals(arr1, arr2) {
    var len1 = arr1.length;
    if (len1 !== arr2.length) {
        return false;
    }
    for (var i = 0; i < len1; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}
/**
 * Sort the passed array such that the relative order of equal elements is preverved.
 * See https://en.wikipedia.org/wiki/Sorting_algorithm#Stability for details.
 * @param {Array<*>} arr The array to sort (modifies original).
 * @param {!function(*, *): number} compareFnc Comparison function.
 * @api
 */
function stableSort(arr, compareFnc) {
    var length = arr.length;
    var tmp = Array(arr.length);
    var i;
    for (i = 0; i < length; i++) {
        tmp[i] = { index: i, value: arr[i] };
    }
    tmp.sort(function (a, b) {
        return compareFnc(a.value, b.value) || a.index - b.index;
    });
    for (i = 0; i < arr.length; i++) {
        arr[i] = tmp[i].value;
    }
}
/**
 * @param {Array<*>} arr The array to search in.
 * @param {Function} func Comparison function.
 * @return {number} Return index.
 */
function findIndex(arr, func) {
    var index;
    var found = !arr.every(function (el, idx) {
        index = idx;
        return !func(el, idx, arr);
    });
    return found ? index : -1;
}
/**
 * @param {Array<*>} arr The array to test.
 * @param {Function} [opt_func] Comparison function.
 * @param {boolean} [opt_strict] Strictly sorted (default false).
 * @return {boolean} Return index.
 */
function isSorted(arr, opt_func, opt_strict) {
    var compare = opt_func || numberSafeCompareFunction;
    return arr.every(function (currentVal, index) {
        if (index === 0) {
            return true;
        }
        var res = compare(arr[index - 1], currentVal);
        return !(res > 0 || (opt_strict && res === 0));
    });
}
//# sourceMappingURL=array.js.map

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/events/EventType
 */
/**
 * @enum {string}
 * @const
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Generic change event. Triggered when the revision counter is increased.
     * @event module:ol/events/Event~BaseEvent#change
     * @api
     */
    CHANGE: 'change',
    /**
     * Generic error event. Triggered when an error occurs.
     * @event module:ol/events/Event~BaseEvent#error
     * @api
     */
    ERROR: 'error',
    BLUR: 'blur',
    CLEAR: 'clear',
    CONTEXTMENU: 'contextmenu',
    CLICK: 'click',
    DBLCLICK: 'dblclick',
    DRAGENTER: 'dragenter',
    DRAGOVER: 'dragover',
    DROP: 'drop',
    FOCUS: 'focus',
    KEYDOWN: 'keydown',
    KEYPRESS: 'keypress',
    LOAD: 'load',
    RESIZE: 'resize',
    TOUCHMOVE: 'touchmove',
    WHEEL: 'wheel',
});
//# sourceMappingURL=EventType.js.map

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listen", function() { return listen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listenOnce", function() { return listenOnce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unlistenByKey", function() { return unlistenByKey; });
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15);
/**
 * @module ol/events
 */

/**
 * Key to use with {@link module:ol/Observable~Observable#unByKey}.
 * @typedef {Object} EventsKey
 * @property {ListenerFunction} listener Listener.
 * @property {import("./events/Target.js").EventTargetLike} target Target.
 * @property {string} type Type.
 * @api
 */
/**
 * Listener function. This function is called with an event object as argument.
 * When the function returns `false`, event propagation will stop.
 *
 * @typedef {function((Event|import("./events/Event.js").default)): (void|boolean)} ListenerFunction
 * @api
 */
/**
 * @typedef {Object} ListenerObject
 * @property {ListenerFunction} handleEvent HandleEvent listener function.
 */
/**
 * @typedef {ListenerFunction|ListenerObject} Listener
 */
/**
 * Registers an event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` to a `this` object, and returns
 * a key for use with {@link module:ol/events.unlistenByKey}.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [opt_this] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @param {boolean} [opt_once] If true, add the listener as one-off listener.
 * @return {EventsKey} Unique key for the listener.
 */
function listen(target, type, listener, opt_this, opt_once) {
    if (opt_this && opt_this !== target) {
        listener = listener.bind(opt_this);
    }
    if (opt_once) {
        var originalListener_1 = listener;
        listener = function () {
            target.removeEventListener(type, listener);
            originalListener_1.apply(this, arguments);
        };
    }
    var eventsKey = {
        target: target,
        type: type,
        listener: listener,
    };
    target.addEventListener(type, listener);
    return eventsKey;
}
/**
 * Registers a one-off event listener on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * This function efficiently binds a `listener` as self-unregistering listener
 * to a `this` object, and returns a key for use with
 * {@link module:ol/events.unlistenByKey} in case the listener needs to be
 * unregistered before it is called.
 *
 * When {@link module:ol/events.listen} is called with the same arguments after this
 * function, the self-unregistering listener will be turned into a permanent
 * listener.
 *
 * @param {import("./events/Target.js").EventTargetLike} target Event target.
 * @param {string} type Event type.
 * @param {ListenerFunction} listener Listener.
 * @param {Object} [opt_this] Object referenced by the `this` keyword in the
 *     listener. Default is the `target`.
 * @return {EventsKey} Key for unlistenByKey.
 */
function listenOnce(target, type, listener, opt_this) {
    return listen(target, type, listener, opt_this, true);
}
/**
 * Unregisters event listeners on an event target. Inspired by
 * https://google.github.io/closure-library/api/source/closure/goog/events/events.js.src.html
 *
 * The argument passed to this function is the key returned from
 * {@link module:ol/events.listen} or {@link module:ol/events.listenOnce}.
 *
 * @param {EventsKey} key The key.
 */
function unlistenByKey(key) {
    if (key && key.target) {
        key.target.removeEventListener(key.type, key.listener);
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_0__["clear"])(key);
    }
}
//# sourceMappingURL=events.js.map

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_HIDDEN", function() { return CLASS_HIDDEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_SELECTABLE", function() { return CLASS_SELECTABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_UNSELECTABLE", function() { return CLASS_UNSELECTABLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_UNSUPPORTED", function() { return CLASS_UNSUPPORTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_CONTROL", function() { return CLASS_CONTROL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLASS_COLLAPSED", function() { return CLASS_COLLAPSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontParameters", function() { return getFontParameters; });
/**
 * @module ol/css
 */
/**
 * @typedef {Object} FontParameters
 * @property {string} style Style.
 * @property {string} variant Variant.
 * @property {string} weight Weight.
 * @property {string} size Size.
 * @property {string} lineHeight LineHeight.
 * @property {string} family Family.
 * @property {Array<string>} families Families.
 */
/**
 * The CSS class for hidden feature.
 *
 * @const
 * @type {string}
 */
var CLASS_HIDDEN = 'ol-hidden';
/**
 * The CSS class that we'll give the DOM elements to have them selectable.
 *
 * @const
 * @type {string}
 */
var CLASS_SELECTABLE = 'ol-selectable';
/**
 * The CSS class that we'll give the DOM elements to have them unselectable.
 *
 * @const
 * @type {string}
 */
var CLASS_UNSELECTABLE = 'ol-unselectable';
/**
 * The CSS class for unsupported feature.
 *
 * @const
 * @type {string}
 */
var CLASS_UNSUPPORTED = 'ol-unsupported';
/**
 * The CSS class for controls.
 *
 * @const
 * @type {string}
 */
var CLASS_CONTROL = 'ol-control';
/**
 * The CSS class that we'll give the DOM elements that are collapsed, i.e.
 * to those elements which usually can be expanded.
 *
 * @const
 * @type {string}
 */
var CLASS_COLLAPSED = 'ol-collapsed';
/**
 * From https://stackoverflow.com/questions/10135697/regex-to-parse-any-css-font
 * @type {RegExp}
 */
var fontRegEx = new RegExp([
    '^\\s*(?=(?:(?:[-a-z]+\\s*){0,2}(italic|oblique))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(small-caps))?)',
    '(?=(?:(?:[-a-z]+\\s*){0,2}(bold(?:er)?|lighter|[1-9]00 ))?)',
    '(?:(?:normal|\\1|\\2|\\3)\\s*){0,3}((?:xx?-)?',
    '(?:small|large)|medium|smaller|larger|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx]))',
    '(?:\\s*\\/\\s*(normal|[\\.\\d]+(?:\\%|in|[cem]m|ex|p[ctx])?))',
    '?\\s*([-,\\"\\\'\\sa-z]+?)\\s*$',
].join(''), 'i');
var fontRegExMatchIndex = [
    'style',
    'variant',
    'weight',
    'size',
    'lineHeight',
    'family',
];
/**
 * Get the list of font families from a font spec.  Note that this doesn't work
 * for font families that have commas in them.
 * @param {string} fontSpec The CSS font property.
 * @return {FontParameters} The font parameters (or null if the input spec is invalid).
 */
var getFontParameters = function (fontSpec) {
    var match = fontSpec.match(fontRegEx);
    if (!match) {
        return null;
    }
    var style = /** @type {FontParameters} */ ({
        lineHeight: 'normal',
        size: '1.2em',
        style: 'normal',
        weight: 'normal',
        variant: 'normal',
    });
    for (var i = 0, ii = fontRegExMatchIndex.length; i < ii; ++i) {
        var value = match[i + 1];
        if (value !== undefined) {
            style[fontRegExMatchIndex[i]] = value;
        }
    }
    style.families = style.family.split(/,\s?/);
    return style;
};
//# sourceMappingURL=css.js.map

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/style/Fill
 */
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color=null] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 */
/**
 * @classdesc
 * Set fill style for vector features.
 * @api
 */
var Fill = /** @class */ (function () {
    /**
     * @param {Options} [opt_options] Options.
     */
    function Fill(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
         */
        this.color_ = options.color !== undefined ? options.color : null;
    }
    /**
     * Clones the style. The color is not cloned if it is an {@link module:ol/colorlike~ColorLike}.
     * @return {Fill} The cloned style.
     * @api
     */
    Fill.prototype.clone = function () {
        var color = this.getColor();
        return new Fill({
            color: Array.isArray(color) ? color.slice() : color || undefined,
        });
    };
    /**
     * Get the fill color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
     * @api
     */
    Fill.prototype.getColor = function () {
        return this.color_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
     * @api
     */
    Fill.prototype.setColor = function (color) {
        this.color_ = color;
    };
    return Fill;
}());
/* harmony default export */ __webpack_exports__["default"] = (Fill);
//# sourceMappingURL=Fill.js.map

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58);
/* harmony import */ var _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(38);
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19);
/* harmony import */ var _IconImage_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/style/Icon
 */









/**
 * @typedef {Object} Options
 * @property {Array<number>} [anchor=[0.5, 0.5]] Anchor. Default value is the icon center.
 * @property {import("./IconOrigin.js").default} [anchorOrigin='top-left'] Origin of the anchor: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {import("./IconAnchorUnits.js").default} [anchorXUnits='fraction'] Units in which the anchor x value is
 * specified. A value of `'fraction'` indicates the x value is a fraction of the icon. A value of `'pixels'` indicates
 * the x value in pixels.
 * @property {import("./IconAnchorUnits.js").default} [anchorYUnits='fraction'] Units in which the anchor y value is
 * specified. A value of `'fraction'` indicates the y value is a fraction of the icon. A value of `'pixels'` indicates
 * the y value in pixels.
 * @property {import("../color.js").Color|string} [color] Color to tint the icon. If not specified,
 * the icon will be left as is.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {HTMLImageElement|HTMLCanvasElement} [img] Image object for the icon. If the `src` option is not provided then the
 * provided image must already be loaded. And in that case, it is required
 * to provide the size of the image, with the `imgSize` option.
 * @property {Array<number>} [offset=[0, 0]] Offset, which, together with the size and the offset origin, define the
 * sub-rectangle to use from the original icon image.
 * @property {Array<number>} [displacement=[0,0]] Displacement the icon
 * @property {import("./IconOrigin.js").default} [offsetOrigin='top-left'] Origin of the offset: `bottom-left`, `bottom-right`,
 * `top-left` or `top-right`.
 * @property {number} [opacity=1] Opacity of the icon.
 * @property {number|import("../size.js").Size} [scale=1] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the icon with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {import("../size.js").Size} [size] Icon size in pixel. Can be used together with `offset` to define the
 * sub-rectangle to use from the origin (sprite) icon image.
 * @property {import("../size.js").Size} [imgSize] Image size in pixels. Only required if `img` is set and `src` is not, and
 * for SVG images in Internet Explorer 11. The provided `imgSize` needs to match the actual size of the image.
 * @property {string} [src] Image source URI.
 */
/**
 * @classdesc
 * Set icon style for vector features.
 * @api
 */
var Icon = /** @class */ (function (_super) {
    __extends(Icon, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Icon(opt_options) {
        var _this = this;
        var options = opt_options || {};
        /**
         * @type {number}
         */
        var opacity = options.opacity !== undefined ? options.opacity : 1;
        /**
         * @type {number}
         */
        var rotation = options.rotation !== undefined ? options.rotation : 0;
        /**
         * @type {number|import("../size.js").Size}
         */
        var scale = options.scale !== undefined ? options.scale : 1;
        /**
         * @type {boolean}
         */
        var rotateWithView = options.rotateWithView !== undefined ? options.rotateWithView : false;
        _this = _super.call(this, {
            opacity: opacity,
            rotation: rotation,
            scale: scale,
            displacement: options.displacement !== undefined ? options.displacement : [0, 0],
            rotateWithView: rotateWithView,
        }) || this;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.anchor_ = options.anchor !== undefined ? options.anchor : [0.5, 0.5];
        /**
         * @private
         * @type {Array<number>}
         */
        _this.normalizedAnchor_ = null;
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */
        _this.anchorOrigin_ =
            options.anchorOrigin !== undefined
                ? options.anchorOrigin
                : _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_LEFT;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */
        _this.anchorXUnits_ =
            options.anchorXUnits !== undefined
                ? options.anchorXUnits
                : _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION;
        /**
         * @private
         * @type {import("./IconAnchorUnits.js").default}
         */
        _this.anchorYUnits_ =
            options.anchorYUnits !== undefined
                ? options.anchorYUnits
                : _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION;
        /**
         * @private
         * @type {?string}
         */
        _this.crossOrigin_ =
            options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @type {HTMLImageElement|HTMLCanvasElement}
         */
        var image = options.img !== undefined ? options.img : null;
        /**
         * @type {import("../size.js").Size}
         */
        var imgSize = options.imgSize !== undefined ? options.imgSize : null;
        /**
         * @type {string|undefined}
         */
        var src = options.src;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(!(src !== undefined && image), 4); // `image` and `src` cannot be provided at the same time
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(!image || (image && imgSize), 5); // `imgSize` must be set when `image` is provided
        if ((src === undefined || src.length === 0) && image) {
            src = /** @type {HTMLImageElement} */ (image).src || Object(_util_js__WEBPACK_IMPORTED_MODULE_8__["getUid"])(image);
        }
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(src !== undefined && src.length > 0, 6); // A defined and non-empty `src` or `image` must be provided
        /**
         * @type {import("../ImageState.js").default}
         */
        var imageState = options.src !== undefined ? _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE : _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED;
        /**
         * @private
         * @type {import("../color.js").Color}
         */
        _this.color_ = options.color !== undefined ? Object(_color_js__WEBPACK_IMPORTED_MODULE_5__["asArray"])(options.color) : null;
        /**
         * @private
         * @type {import("./IconImage.js").default}
         */
        _this.iconImage_ = Object(_IconImage_js__WEBPACK_IMPORTED_MODULE_7__["get"])(image, 
        /** @type {string} */ (src), imgSize, _this.crossOrigin_, imageState, _this.color_);
        /**
         * @private
         * @type {Array<number>}
         */
        _this.offset_ = options.offset !== undefined ? options.offset : [0, 0];
        /**
         * @private
         * @type {import("./IconOrigin.js").default}
         */
        _this.offsetOrigin_ =
            options.offsetOrigin !== undefined
                ? options.offsetOrigin
                : _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_LEFT;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.origin_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.size_ = options.size !== undefined ? options.size : null;
        return _this;
    }
    /**
     * Clones the style. The underlying Image/HTMLCanvasElement is not cloned.
     * @return {Icon} The cloned style.
     * @api
     */
    Icon.prototype.clone = function () {
        var scale = this.getScale();
        return new Icon({
            anchor: this.anchor_.slice(),
            anchorOrigin: this.anchorOrigin_,
            anchorXUnits: this.anchorXUnits_,
            anchorYUnits: this.anchorYUnits_,
            crossOrigin: this.crossOrigin_,
            color: this.color_ && this.color_.slice
                ? this.color_.slice()
                : this.color_ || undefined,
            src: this.getSrc(),
            offset: this.offset_.slice(),
            offsetOrigin: this.offsetOrigin_,
            size: this.size_ !== null ? this.size_.slice() : undefined,
            opacity: this.getOpacity(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
        });
    };
    /**
     * Get the anchor point in pixels. The anchor determines the center point for the
     * symbolizer.
     * @return {Array<number>} Anchor.
     * @api
     */
    Icon.prototype.getAnchor = function () {
        if (this.normalizedAnchor_) {
            return this.normalizedAnchor_;
        }
        var anchor = this.anchor_;
        var size = this.getSize();
        if (this.anchorXUnits_ == _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION ||
            this.anchorYUnits_ == _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION) {
            if (!size) {
                return null;
            }
            anchor = this.anchor_.slice();
            if (this.anchorXUnits_ == _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION) {
                anchor[0] *= size[0];
            }
            if (this.anchorYUnits_ == _IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_1__["default"].FRACTION) {
                anchor[1] *= size[1];
            }
        }
        if (this.anchorOrigin_ != _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_LEFT) {
            if (!size) {
                return null;
            }
            if (anchor === this.anchor_) {
                anchor = this.anchor_.slice();
            }
            if (this.anchorOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_RIGHT ||
                this.anchorOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT) {
                anchor[0] = -anchor[0] + size[0];
            }
            if (this.anchorOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_LEFT ||
                this.anchorOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT) {
                anchor[1] = -anchor[1] + size[1];
            }
        }
        var displacement = this.getDisplacement();
        anchor[0] -= displacement[0];
        anchor[1] += displacement[1];
        this.normalizedAnchor_ = anchor;
        return this.normalizedAnchor_;
    };
    /**
     * Set the anchor point. The anchor determines the center point for the
     * symbolizer.
     *
     * @param {Array<number>} anchor Anchor.
     * @api
     */
    Icon.prototype.setAnchor = function (anchor) {
        this.anchor_ = anchor;
        this.normalizedAnchor_ = null;
    };
    /**
     * Get the icon color.
     * @return {import("../color.js").Color} Color.
     * @api
     */
    Icon.prototype.getColor = function () {
        return this.color_;
    };
    /**
     * Get the image icon.
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     * @api
     */
    Icon.prototype.getImage = function (pixelRatio) {
        return this.iconImage_.getImage(pixelRatio);
    };
    /**
     * Get the pixel ratio.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} The pixel ratio of the image.
     * @api
     */
    Icon.prototype.getPixelRatio = function (pixelRatio) {
        return this.iconImage_.getPixelRatio(pixelRatio);
    };
    /**
     * @return {import("../size.js").Size} Image size.
     */
    Icon.prototype.getImageSize = function () {
        return this.iconImage_.getSize();
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */
    Icon.prototype.getImageState = function () {
        return this.iconImage_.getImageState();
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */
    Icon.prototype.getHitDetectionImage = function () {
        return this.iconImage_.getHitDetectionImage();
    };
    /**
     * Get the origin of the symbolizer.
     * @return {Array<number>} Origin.
     * @api
     */
    Icon.prototype.getOrigin = function () {
        if (this.origin_) {
            return this.origin_;
        }
        var offset = this.offset_;
        if (this.offsetOrigin_ != _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_LEFT) {
            var size = this.getSize();
            var iconImageSize = this.iconImage_.getSize();
            if (!size || !iconImageSize) {
                return null;
            }
            offset = offset.slice();
            if (this.offsetOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_RIGHT ||
                this.offsetOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT) {
                offset[0] = iconImageSize[0] - size[0] - offset[0];
            }
            if (this.offsetOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_LEFT ||
                this.offsetOrigin_ == _IconOrigin_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT) {
                offset[1] = iconImageSize[1] - size[1] - offset[1];
            }
        }
        this.origin_ = offset;
        return this.origin_;
    };
    /**
     * Get the image URL.
     * @return {string|undefined} Image src.
     * @api
     */
    Icon.prototype.getSrc = function () {
        return this.iconImage_.getSrc();
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     * @api
     */
    Icon.prototype.getSize = function () {
        return !this.size_ ? this.iconImage_.getSize() : this.size_;
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    Icon.prototype.listenImageChange = function (listener) {
        this.iconImage_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, listener);
    };
    /**
     * Load not yet loaded URI.
     * When rendering a feature with an icon style, the vector renderer will
     * automatically call this method. However, you might want to call this
     * method yourself for preloading or other purposes.
     * @api
     */
    Icon.prototype.load = function () {
        this.iconImage_.load();
    };
    /**
     * @param {function(import("../events/Event.js").default): void} listener Listener function.
     */
    Icon.prototype.unlistenImageChange = function (listener) {
        this.iconImage_.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, listener);
    };
    return Icon;
}(_Image_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Icon);
//# sourceMappingURL=Icon.js.map

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/style/IconAnchorUnits
 */
/**
 * Icon anchor units. One of 'fraction', 'pixels'.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Anchor is a fraction
     * @api
     */
    FRACTION: 'fraction',
    /**
     * Anchor is in pixels
     * @api
     */
    PIXELS: 'pixels',
});
//# sourceMappingURL=IconAnchorUnits.js.map

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/style/IconOrigin
 */
/**
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Origin is at bottom left
     * @api
     */
    BOTTOM_LEFT: 'bottom-left',
    /**
     * Origin is at bottom right
     * @api
     */
    BOTTOM_RIGHT: 'bottom-right',
    /**
     * Origin is at top left
     * @api
     */
    TOP_LEFT: 'top-left',
    /**
     * Origin is at top right
     * @api
     */
    TOP_RIGHT: 'top-right',
});
//# sourceMappingURL=IconOrigin.js.map

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "get", function() { return get; });
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
/* harmony import */ var _IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62);
/**
 * @module ol/style/IconImage
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @type {CanvasRenderingContext2D}
 */
var taintedTestContext = null;
var IconImage = /** @class */ (function (_super) {
    __extends(IconImage, _super);
    /**
     * @param {HTMLImageElement|HTMLCanvasElement} image Image.
     * @param {string|undefined} src Src.
     * @param {import("../size.js").Size} size Size.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../ImageState.js").default} imageState Image state.
     * @param {import("../color.js").Color} color Color.
     */
    function IconImage(image, src, size, crossOrigin, imageState, color) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */
        _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */
        _this.image_ = !image ? new Image() : image;
        if (crossOrigin !== null) {
            /** @type {HTMLImageElement} */ (_this.image_).crossOrigin = crossOrigin;
        }
        /**
         * @private
         * @type {Object<number, HTMLCanvasElement>}
         */
        _this.canvas_ = {};
        /**
         * @private
         * @type {import("../color.js").Color}
         */
        _this.color_ = color;
        /**
         * @private
         * @type {?function():void}
         */
        _this.unlisten_ = null;
        /**
         * @private
         * @type {import("../ImageState.js").default}
         */
        _this.imageState_ = imageState;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.size_ = size;
        /**
         * @private
         * @type {string|undefined}
         */
        _this.src_ = src;
        /**
         * @private
         */
        _this.tainted_;
        return _this;
    }
    /**
     * @private
     * @return {boolean} The image canvas is tainted.
     */
    IconImage.prototype.isTainted_ = function () {
        if (this.tainted_ === undefined && this.imageState_ === _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
            if (!taintedTestContext) {
                taintedTestContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(1, 1);
            }
            taintedTestContext.drawImage(this.image_, 0, 0);
            try {
                taintedTestContext.getImageData(0, 0, 1, 1);
                this.tainted_ = false;
            }
            catch (e) {
                taintedTestContext = null;
                this.tainted_ = true;
            }
        }
        return this.tainted_ === true;
    };
    /**
     * @private
     */
    IconImage.prototype.dispatchChangeEvent_ = function () {
        this.dispatchEvent(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE);
    };
    /**
     * @private
     */
    IconImage.prototype.handleImageError_ = function () {
        this.imageState_ = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR;
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @private
     */
    IconImage.prototype.handleImageLoad_ = function () {
        this.imageState_ = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED;
        if (this.size_) {
            this.image_.width = this.size_[0];
            this.image_.height = this.size_[1];
        }
        else {
            this.size_ = [this.image_.width, this.image_.height];
        }
        this.unlistenImage_();
        this.dispatchChangeEvent_();
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {HTMLImageElement|HTMLCanvasElement} Image or Canvas element.
     */
    IconImage.prototype.getImage = function (pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? this.canvas_[pixelRatio] : this.image_;
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Image or Canvas element.
     */
    IconImage.prototype.getPixelRatio = function (pixelRatio) {
        this.replaceColor_(pixelRatio);
        return this.canvas_[pixelRatio] ? pixelRatio : 1;
    };
    /**
     * @return {import("../ImageState.js").default} Image state.
     */
    IconImage.prototype.getImageState = function () {
        return this.imageState_;
    };
    /**
     * @return {HTMLImageElement|HTMLCanvasElement} Image element.
     */
    IconImage.prototype.getHitDetectionImage = function () {
        if (!this.hitDetectionImage_) {
            if (this.isTainted_()) {
                var width = this.size_[0];
                var height = this.size_[1];
                var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(width, height);
                context.fillRect(0, 0, width, height);
                this.hitDetectionImage_ = context.canvas;
            }
            else {
                this.hitDetectionImage_ = this.image_;
            }
        }
        return this.hitDetectionImage_;
    };
    /**
     * Get the size of the icon (in pixels).
     * @return {import("../size.js").Size} Image size.
     */
    IconImage.prototype.getSize = function () {
        return this.size_;
    };
    /**
     * @return {string|undefined} Image src.
     */
    IconImage.prototype.getSrc = function () {
        return this.src_;
    };
    /**
     * Load not yet loaded URI.
     */
    IconImage.prototype.load = function () {
        if (this.imageState_ == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE) {
            this.imageState_ = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING;
            try {
                /** @type {HTMLImageElement} */ (this.image_).src = this.src_;
            }
            catch (e) {
                this.handleImageError_();
            }
            this.unlisten_ = Object(_Image_js__WEBPACK_IMPORTED_MODULE_6__["listenImage"])(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @private
     */
    IconImage.prototype.replaceColor_ = function (pixelRatio) {
        if (!this.color_ || this.canvas_[pixelRatio]) {
            return;
        }
        var canvas = document.createElement('canvas');
        this.canvas_[pixelRatio] = canvas;
        canvas.width = Math.ceil(this.image_.width * pixelRatio);
        canvas.height = Math.ceil(this.image_.height * pixelRatio);
        var ctx = canvas.getContext('2d');
        ctx.scale(pixelRatio, pixelRatio);
        ctx.drawImage(this.image_, 0, 0);
        ctx.globalCompositeOperation = 'multiply';
        // Internet Explorer 11 does not support the multiply operation.
        // If the canvas is tainted in Internet Explorer this still produces
        // a solid color image with the shape of the icon.
        if (ctx.globalCompositeOperation === 'multiply' || this.isTainted_()) {
            ctx.fillStyle = Object(_color_js__WEBPACK_IMPORTED_MODULE_3__["asString"])(this.color_);
            ctx.fillRect(0, 0, canvas.width / pixelRatio, canvas.height / pixelRatio);
            ctx.globalCompositeOperation = 'destination-in';
            ctx.drawImage(this.image_, 0, 0);
        }
        else {
            var imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            var data = imgData.data;
            var r = this.color_[0] / 255.0;
            var g = this.color_[1] / 255.0;
            var b = this.color_[2] / 255.0;
            var a = this.color_[3];
            for (var i = 0, ii = data.length; i < ii; i += 4) {
                data[i] *= r;
                data[i + 1] *= g;
                data[i + 2] *= b;
                data[i + 3] *= a;
            }
            ctx.putImageData(imgData, 0, 0);
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */
    IconImage.prototype.unlistenImage_ = function () {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return IconImage;
}(_events_Target_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {HTMLImageElement|HTMLCanvasElement} image Image.
 * @param {string} src Src.
 * @param {import("../size.js").Size} size Size.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../ImageState.js").default} imageState Image state.
 * @param {import("../color.js").Color} color Color.
 * @return {IconImage} Icon image.
 */
function get(image, src, size, crossOrigin, imageState, color) {
    var iconImage = _IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__["shared"].get(src, crossOrigin, color);
    if (!iconImage) {
        iconImage = new IconImage(image, src, size, crossOrigin, imageState, color);
        _IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__["shared"].set(src, crossOrigin, color, iconImage);
    }
    return iconImage;
}
/* harmony default export */ __webpack_exports__["default"] = (IconImage);
//# sourceMappingURL=IconImage.js.map

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shared", function() { return shared; });
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
/**
 * @module ol/style/IconImageCache
 */

/**
 * @classdesc
 * Singleton class. Available through {@link module:ol/style/IconImageCache~shared}.
 */
var IconImageCache = /** @class */ (function () {
    function IconImageCache() {
        /**
         * @type {!Object<string, import("./IconImage.js").default>}
         * @private
         */
        this.cache_ = {};
        /**
         * @type {number}
         * @private
         */
        this.cacheSize_ = 0;
        /**
         * @type {number}
         * @private
         */
        this.maxCacheSize_ = 32;
    }
    /**
     * FIXME empty description for jsdoc
     */
    IconImageCache.prototype.clear = function () {
        this.cache_ = {};
        this.cacheSize_ = 0;
    };
    /**
     * @return {boolean} Can expire cache.
     */
    IconImageCache.prototype.canExpireCache = function () {
        return this.cacheSize_ > this.maxCacheSize_;
    };
    /**
     * FIXME empty description for jsdoc
     */
    IconImageCache.prototype.expire = function () {
        if (this.canExpireCache()) {
            var i = 0;
            for (var key in this.cache_) {
                var iconImage = this.cache_[key];
                if ((i++ & 3) === 0 && !iconImage.hasListener()) {
                    delete this.cache_[key];
                    --this.cacheSize_;
                }
            }
        }
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @return {import("./IconImage.js").default} Icon image.
     */
    IconImageCache.prototype.get = function (src, crossOrigin, color) {
        var key = getKey(src, crossOrigin, color);
        return key in this.cache_ ? this.cache_[key] : null;
    };
    /**
     * @param {string} src Src.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../color.js").Color} color Color.
     * @param {import("./IconImage.js").default} iconImage Icon image.
     */
    IconImageCache.prototype.set = function (src, crossOrigin, color, iconImage) {
        var key = getKey(src, crossOrigin, color);
        this.cache_[key] = iconImage;
        ++this.cacheSize_;
    };
    /**
     * Set the cache size of the icon cache. Default is `32`. Change this value when
     * your map uses more than 32 different icon images and you are not caching icon
     * styles on the application level.
     * @param {number} maxCacheSize Cache max size.
     * @api
     */
    IconImageCache.prototype.setSize = function (maxCacheSize) {
        this.maxCacheSize_ = maxCacheSize;
        this.expire();
    };
    return IconImageCache;
}());
/**
 * @param {string} src Src.
 * @param {?string} crossOrigin Cross origin.
 * @param {import("../color.js").Color} color Color.
 * @return {string} Cache key.
 */
function getKey(src, crossOrigin, color) {
    var colorString = color ? Object(_color_js__WEBPACK_IMPORTED_MODULE_0__["asString"])(color) : 'null';
    return crossOrigin + ':' + src + ':' + colorString;
}
/* harmony default export */ __webpack_exports__["default"] = (IconImageCache);
/**
 * The {@link module:ol/style/IconImageCache~IconImageCache} for
 * {@link module:ol/style/Icon~Icon} images.
 * @api
 */
var shared = new IconImageCache();
//# sourceMappingURL=IconImageCache.js.map

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "listenImage", function() { return listenImage; });
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _ImageBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Image
 */






/**
 * A function that takes an {@link module:ol/Image~Image} for the image and a
 * `{string}` for the src as arguments. It is supposed to make it so the
 * underlying image {@link module:ol/Image~Image#getImage} is assigned the
 * content specified by the src. If not specified, the default is
 *
 *     function(image, src) {
 *       image.getImage().src = src;
 *     }
 *
 * Providing a custom `imageLoadFunction` can be useful to load images with
 * post requests or - in general - through XHR requests, where the src of the
 * image element would be set to a data URI when the content is loaded.
 *
 * @typedef {function(ImageWrapper, string): void} LoadFunction
 * @api
 */
var ImageWrapper = /** @class */ (function (_super) {
    __extends(ImageWrapper, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {LoadFunction} imageLoadFunction Image load function.
     */
    function ImageWrapper(extent, resolution, pixelRatio, src, crossOrigin, imageLoadFunction) {
        var _this = _super.call(this, extent, resolution, pixelRatio, _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE) || this;
        /**
         * @private
         * @type {string}
         */
        _this.src_ = src;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
         */
        _this.image_ = new Image();
        if (crossOrigin !== null) {
            _this.image_.crossOrigin = crossOrigin;
        }
        /**
         * @private
         * @type {?function():void}
         */
        _this.unlisten_ = null;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */
        _this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE;
        /**
         * @private
         * @type {LoadFunction}
         */
        _this.imageLoadFunction_ = imageLoadFunction;
        return _this;
    }
    /**
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */
    ImageWrapper.prototype.getImage = function () {
        return this.image_;
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */
    ImageWrapper.prototype.handleImageError_ = function () {
        this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */
    ImageWrapper.prototype.handleImageLoad_ = function () {
        if (this.resolution === undefined) {
            this.resolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getHeight"])(this.extent) / this.image_.height;
        }
        this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @api
     */
    ImageWrapper.prototype.load = function () {
        if (this.state == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE || this.state == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR) {
            this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING;
            this.changed();
            this.imageLoadFunction_(this, this.src_);
            this.unlisten_ = listenImage(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
     */
    ImageWrapper.prototype.setImage = function (image) {
        this.image_ = image;
        this.resolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getHeight"])(this.extent) / this.image_.height;
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */
    ImageWrapper.prototype.unlistenImage_ = function () {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageWrapper;
}(_ImageBase_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @param {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image element.
 * @param {function():any} loadHandler Load callback function.
 * @param {function():any} errorHandler Error callback function.
 * @return {function():void} Callback to stop listening.
 */
function listenImage(image, loadHandler, errorHandler) {
    var img = /** @type {HTMLImageElement} */ (image);
    if (img.src && _has_js__WEBPACK_IMPORTED_MODULE_3__["IMAGE_DECODE"]) {
        var promise = img.decode();
        var listening_1 = true;
        var unlisten = function () {
            listening_1 = false;
        };
        promise
            .then(function () {
            if (listening_1) {
                loadHandler();
            }
        })
            .catch(function (error) {
            if (listening_1) {
                // FIXME: Unconditionally call errorHandler() when this bug is fixed upstream:
                //        https://bugs.webkit.org/show_bug.cgi?id=198527
                if (error.name === 'EncodingError' &&
                    error.message === 'Invalid image type.') {
                    loadHandler();
                }
                else {
                    errorHandler();
                }
            }
        });
        return unlisten;
    }
    var listenerKeys = [
        Object(_events_js__WEBPACK_IMPORTED_MODULE_5__["listenOnce"])(img, _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOAD, loadHandler),
        Object(_events_js__WEBPACK_IMPORTED_MODULE_5__["listenOnce"])(img, _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR, errorHandler),
    ];
    return function unlisten() {
        listenerKeys.forEach(_events_js__WEBPACK_IMPORTED_MODULE_5__["unlistenByKey"]);
    };
}
/* harmony default export */ __webpack_exports__["default"] = (ImageWrapper);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/ImageBase
 */



/**
 * @abstract
 */
var ImageBase = /** @class */ (function (_super) {
    __extends(ImageBase, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number|undefined} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./ImageState.js").default} state State.
     */
    function ImageBase(extent, resolution, pixelRatio, state) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./extent.js").Extent}
         */
        _this.extent = extent;
        /**
         * @private
         * @type {number}
         */
        _this.pixelRatio_ = pixelRatio;
        /**
         * @protected
         * @type {number|undefined}
         */
        _this.resolution = resolution;
        /**
         * @protected
         * @type {import("./ImageState.js").default}
         */
        _this.state = state;
        return _this;
    }
    /**
     * @protected
     */
    ImageBase.prototype.changed = function () {
        this.dispatchEvent(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE);
    };
    /**
     * @return {import("./extent.js").Extent} Extent.
     */
    ImageBase.prototype.getExtent = function () {
        return this.extent;
    };
    /**
     * @abstract
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */
    ImageBase.prototype.getImage = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @return {number} PixelRatio.
     */
    ImageBase.prototype.getPixelRatio = function () {
        return this.pixelRatio_;
    };
    /**
     * @return {number} Resolution.
     */
    ImageBase.prototype.getResolution = function () {
        return /** @type {number} */ (this.resolution);
    };
    /**
     * @return {import("./ImageState.js").default} State.
     */
    ImageBase.prototype.getState = function () {
        return this.state;
    };
    /**
     * Load not yet loaded URI.
     * @abstract
     */
    ImageBase.prototype.load = function () {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    return ImageBase;
}(_events_Target_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageBase);
//# sourceMappingURL=ImageBase.js.map

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/style/Stroke
 */
/**
 * @typedef {Object} Options
 * @property {import("../color.js").Color|import("../colorlike.js").ColorLike} [color] A color, gradient or pattern.
 * See {@link module:ol/color~Color} and {@link module:ol/colorlike~ColorLike} for possible formats.
 * Default null; if null, the Canvas/renderer default black will be used.
 * @property {CanvasLineCap} [lineCap='round'] Line cap style: `butt`, `round`, or `square`.
 * @property {CanvasLineJoin} [lineJoin='round'] Line join style: `bevel`, `round`, or `miter`.
 * @property {Array<number>} [lineDash] Line dash pattern. Default is `null` (no dash).
 * Please note that Internet Explorer 10 and lower do not support the `setLineDash` method on
 * the `CanvasRenderingContext2D` and therefore this option will have no visual effect in these browsers.
 * @property {number} [lineDashOffset=0] Line dash offset.
 * @property {number} [miterLimit=10] Miter limit.
 * @property {number} [width] Width.
 */
/**
 * @classdesc
 * Set stroke style for vector features.
 * Note that the defaults given are the Canvas defaults, which will be used if
 * option is not defined. The `get` functions return whatever was entered in
 * the options; they will not return the default.
 * @api
 */
var Stroke = /** @class */ (function () {
    /**
     * @param {Options} [opt_options] Options.
     */
    function Stroke(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {import("../color.js").Color|import("../colorlike.js").ColorLike}
         */
        this.color_ = options.color !== undefined ? options.color : null;
        /**
         * @private
         * @type {CanvasLineCap|undefined}
         */
        this.lineCap_ = options.lineCap;
        /**
         * @private
         * @type {Array<number>}
         */
        this.lineDash_ = options.lineDash !== undefined ? options.lineDash : null;
        /**
         * @private
         * @type {number|undefined}
         */
        this.lineDashOffset_ = options.lineDashOffset;
        /**
         * @private
         * @type {CanvasLineJoin|undefined}
         */
        this.lineJoin_ = options.lineJoin;
        /**
         * @private
         * @type {number|undefined}
         */
        this.miterLimit_ = options.miterLimit;
        /**
         * @private
         * @type {number|undefined}
         */
        this.width_ = options.width;
    }
    /**
     * Clones the style.
     * @return {Stroke} The cloned style.
     * @api
     */
    Stroke.prototype.clone = function () {
        var color = this.getColor();
        return new Stroke({
            color: Array.isArray(color) ? color.slice() : color || undefined,
            lineCap: this.getLineCap(),
            lineDash: this.getLineDash() ? this.getLineDash().slice() : undefined,
            lineDashOffset: this.getLineDashOffset(),
            lineJoin: this.getLineJoin(),
            miterLimit: this.getMiterLimit(),
            width: this.getWidth(),
        });
    };
    /**
     * Get the stroke color.
     * @return {import("../color.js").Color|import("../colorlike.js").ColorLike} Color.
     * @api
     */
    Stroke.prototype.getColor = function () {
        return this.color_;
    };
    /**
     * Get the line cap type for the stroke.
     * @return {CanvasLineCap|undefined} Line cap.
     * @api
     */
    Stroke.prototype.getLineCap = function () {
        return this.lineCap_;
    };
    /**
     * Get the line dash style for the stroke.
     * @return {Array<number>} Line dash.
     * @api
     */
    Stroke.prototype.getLineDash = function () {
        return this.lineDash_;
    };
    /**
     * Get the line dash offset for the stroke.
     * @return {number|undefined} Line dash offset.
     * @api
     */
    Stroke.prototype.getLineDashOffset = function () {
        return this.lineDashOffset_;
    };
    /**
     * Get the line join type for the stroke.
     * @return {CanvasLineJoin|undefined} Line join.
     * @api
     */
    Stroke.prototype.getLineJoin = function () {
        return this.lineJoin_;
    };
    /**
     * Get the miter limit for the stroke.
     * @return {number|undefined} Miter limit.
     * @api
     */
    Stroke.prototype.getMiterLimit = function () {
        return this.miterLimit_;
    };
    /**
     * Get the stroke width.
     * @return {number|undefined} Width.
     * @api
     */
    Stroke.prototype.getWidth = function () {
        return this.width_;
    };
    /**
     * Set the color.
     *
     * @param {import("../color.js").Color|import("../colorlike.js").ColorLike} color Color.
     * @api
     */
    Stroke.prototype.setColor = function (color) {
        this.color_ = color;
    };
    /**
     * Set the line cap.
     *
     * @param {CanvasLineCap|undefined} lineCap Line cap.
     * @api
     */
    Stroke.prototype.setLineCap = function (lineCap) {
        this.lineCap_ = lineCap;
    };
    /**
     * Set the line dash.
     *
     * Please note that Internet Explorer 10 and lower [do not support][mdn] the
     * `setLineDash` method on the `CanvasRenderingContext2D` and therefore this
     * property will have no visual effect in these browsers.
     *
     * [mdn]: https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/setLineDash#Browser_compatibility
     *
     * @param {Array<number>} lineDash Line dash.
     * @api
     */
    Stroke.prototype.setLineDash = function (lineDash) {
        this.lineDash_ = lineDash;
    };
    /**
     * Set the line dash offset.
     *
     * @param {number|undefined} lineDashOffset Line dash offset.
     * @api
     */
    Stroke.prototype.setLineDashOffset = function (lineDashOffset) {
        this.lineDashOffset_ = lineDashOffset;
    };
    /**
     * Set the line join.
     *
     * @param {CanvasLineJoin|undefined} lineJoin Line join.
     * @api
     */
    Stroke.prototype.setLineJoin = function (lineJoin) {
        this.lineJoin_ = lineJoin;
    };
    /**
     * Set the miter limit.
     *
     * @param {number|undefined} miterLimit Miter limit.
     * @api
     */
    Stroke.prototype.setMiterLimit = function (miterLimit) {
        this.miterLimit_ = miterLimit;
    };
    /**
     * Set the width.
     *
     * @param {number|undefined} width Width.
     * @api
     */
    Stroke.prototype.setWidth = function (width) {
        this.width_ = width;
    };
    return Stroke;
}());
/* harmony default export */ __webpack_exports__["default"] = (Stroke);
//# sourceMappingURL=Stroke.js.map

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toFunction", function() { return toFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDefaultStyle", function() { return createDefaultStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEditingStyle", function() { return createEditingStyle; });
/* harmony import */ var _Circle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
/* harmony import */ var _Fill_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _Stroke_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/**
 * @module ol/style/Style
 */





/**
 * A function that takes an {@link module:ol/Feature} and a `{number}`
 * representing the view's resolution. The function should return a
 * {@link module:ol/style/Style} or an array of them. This way e.g. a
 * vector layer can be styled. If the function returns `undefined`, the
 * feature will not be rendered.
 *
 * @typedef {function(import("../Feature.js").FeatureLike, number):(Style|Array<Style>|void)} StyleFunction
 */
/**
 * A {@link Style}, an array of {@link Style}, or a {@link StyleFunction}.
 * @typedef {Style|Array<Style>|StyleFunction} StyleLike
 */
/**
 * A function that takes an {@link module:ol/Feature} as argument and returns an
 * {@link module:ol/geom/Geometry} that will be rendered and styled for the feature.
 *
 * @typedef {function(import("../Feature.js").FeatureLike):
 *     (import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined)} GeometryFunction
 */
/**
 * Custom renderer function. Takes two arguments:
 *
 * 1. The pixel coordinates of the geometry in GeoJSON notation.
 * 2. The {@link module:ol/render~State} of the layer renderer.
 *
 * @typedef {function((import("../coordinate.js").Coordinate|Array<import("../coordinate.js").Coordinate>|Array<Array<import("../coordinate.js").Coordinate>>),import("../render.js").State): void}
 * RenderFunction
 */
/**
 * @typedef {Object} Options
 * @property {string|import("../geom/Geometry.js").default|GeometryFunction} [geometry] Feature property or geometry
 * or function returning a geometry to render for this style.
 * @property {import("./Fill.js").default} [fill] Fill style.
 * @property {import("./Image.js").default} [image] Image style.
 * @property {RenderFunction} [renderer] Custom renderer. When configured, `fill`, `stroke` and `image` will be
 * ignored, and the provided function will be called with each render frame for each geometry.
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Text.js").default} [text] Text style.
 * @property {number} [zIndex] Z index.
 */
/**
 * @classdesc
 * Container for vector feature rendering styles. Any changes made to the style
 * or its children through `set*()` methods will not take effect until the
 * feature or layer that uses the style is re-rendered.
 *
 * ## Feature styles
 *
 * If no style is defined, the following default style is used:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *
 *  var fill = new Fill({
 *    color: 'rgba(255,255,255,0.4)'
 *  });
 *  var stroke = new Stroke({
 *    color: '#3399CC',
 *    width: 1.25
 *  });
 *  var styles = [
 *    new Style({
 *      image: new Circle({
 *        fill: fill,
 *        stroke: stroke,
 *        radius: 5
 *      }),
 *      fill: fill,
 *      stroke: stroke
 *    })
 *  ];
 * ```
 *
 * A separate editing style has the following defaults:
 * ```js
 *  import {Fill, Stroke, Circle, Style} from 'ol/style';
 *  import GeometryType from 'ol/geom/GeometryType';
 *
 *  var white = [255, 255, 255, 1];
 *  var blue = [0, 153, 255, 1];
 *  var width = 3;
 *  styles[GeometryType.POLYGON] = [
 *    new Style({
 *      fill: new Fill({
 *        color: [255, 255, 255, 0.5]
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POLYGON] =
 *      styles[GeometryType.POLYGON];
 *  styles[GeometryType.LINE_STRING] = [
 *    new Style({
 *      stroke: new Stroke({
 *        color: white,
 *        width: width + 2
 *      })
 *    }),
 *    new Style({
 *      stroke: new Stroke({
 *        color: blue,
 *        width: width
 *      })
 *    })
 *  ];
 *  styles[GeometryType.MULTI_LINE_STRING] =
 *      styles[GeometryType.LINE_STRING];
 *  styles[GeometryType.POINT] = [
 *    new Style({
 *      image: new Circle({
 *        radius: width * 2,
 *        fill: new Fill({
 *          color: blue
 *        }),
 *        stroke: new Stroke({
 *          color: white,
 *          width: width / 2
 *        })
 *      }),
 *      zIndex: Infinity
 *    })
 *  ];
 *  styles[GeometryType.MULTI_POINT] =
 *      styles[GeometryType.POINT];
 *  styles[GeometryType.GEOMETRY_COLLECTION] =
 *      styles[GeometryType.POLYGON].concat(
 *          styles[GeometryType.LINE_STRING],
 *          styles[GeometryType.POINT]
 *      );
 * ```
 *
 * @api
 */
var Style = /** @class */ (function () {
    /**
     * @param {Options} [opt_options] Style options.
     */
    function Style(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {string|import("../geom/Geometry.js").default|GeometryFunction}
         */
        this.geometry_ = null;
        /**
         * @private
         * @type {!GeometryFunction}
         */
        this.geometryFunction_ = defaultGeometryFunction;
        if (options.geometry !== undefined) {
            this.setGeometry(options.geometry);
        }
        /**
         * @private
         * @type {import("./Fill.js").default}
         */
        this.fill_ = options.fill !== undefined ? options.fill : null;
        /**
         * @private
         * @type {import("./Image.js").default}
         */
        this.image_ = options.image !== undefined ? options.image : null;
        /**
         * @private
         * @type {RenderFunction|null}
         */
        this.renderer_ = options.renderer !== undefined ? options.renderer : null;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */
        this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {import("./Text.js").default}
         */
        this.text_ = options.text !== undefined ? options.text : null;
        /**
         * @private
         * @type {number|undefined}
         */
        this.zIndex_ = options.zIndex;
    }
    /**
     * Clones the style.
     * @return {Style} The cloned style.
     * @api
     */
    Style.prototype.clone = function () {
        var geometry = this.getGeometry();
        if (geometry && typeof geometry === 'object') {
            geometry = /** @type {import("../geom/Geometry.js").default} */ (geometry).clone();
        }
        return new Style({
            geometry: geometry,
            fill: this.getFill() ? this.getFill().clone() : undefined,
            image: this.getImage() ? this.getImage().clone() : undefined,
            renderer: this.getRenderer(),
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            text: this.getText() ? this.getText().clone() : undefined,
            zIndex: this.getZIndex(),
        });
    };
    /**
     * Get the custom renderer function that was configured with
     * {@link #setRenderer} or the `renderer` constructor option.
     * @return {RenderFunction|null} Custom renderer function.
     * @api
     */
    Style.prototype.getRenderer = function () {
        return this.renderer_;
    };
    /**
     * Sets a custom renderer function for this style. When set, `fill`, `stroke`
     * and `image` options of the style will be ignored.
     * @param {RenderFunction|null} renderer Custom renderer function.
     * @api
     */
    Style.prototype.setRenderer = function (renderer) {
        this.renderer_ = renderer;
    };
    /**
     * Get the geometry to be rendered.
     * @return {string|import("../geom/Geometry.js").default|GeometryFunction}
     * Feature property or geometry or function that returns the geometry that will
     * be rendered with this style.
     * @api
     */
    Style.prototype.getGeometry = function () {
        return this.geometry_;
    };
    /**
     * Get the function used to generate a geometry for rendering.
     * @return {!GeometryFunction} Function that is called with a feature
     * and returns the geometry to render instead of the feature's geometry.
     * @api
     */
    Style.prototype.getGeometryFunction = function () {
        return this.geometryFunction_;
    };
    /**
     * Get the fill style.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */
    Style.prototype.getFill = function () {
        return this.fill_;
    };
    /**
     * Set the fill style.
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */
    Style.prototype.setFill = function (fill) {
        this.fill_ = fill;
    };
    /**
     * Get the image style.
     * @return {import("./Image.js").default} Image style.
     * @api
     */
    Style.prototype.getImage = function () {
        return this.image_;
    };
    /**
     * Set the image style.
     * @param {import("./Image.js").default} image Image style.
     * @api
     */
    Style.prototype.setImage = function (image) {
        this.image_ = image;
    };
    /**
     * Get the stroke style.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */
    Style.prototype.getStroke = function () {
        return this.stroke_;
    };
    /**
     * Set the stroke style.
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */
    Style.prototype.setStroke = function (stroke) {
        this.stroke_ = stroke;
    };
    /**
     * Get the text style.
     * @return {import("./Text.js").default} Text style.
     * @api
     */
    Style.prototype.getText = function () {
        return this.text_;
    };
    /**
     * Set the text style.
     * @param {import("./Text.js").default} text Text style.
     * @api
     */
    Style.prototype.setText = function (text) {
        this.text_ = text;
    };
    /**
     * Get the z-index for the style.
     * @return {number|undefined} ZIndex.
     * @api
     */
    Style.prototype.getZIndex = function () {
        return this.zIndex_;
    };
    /**
     * Set a geometry that is rendered instead of the feature's geometry.
     *
     * @param {string|import("../geom/Geometry.js").default|GeometryFunction} geometry
     *     Feature property or geometry or function returning a geometry to render
     *     for this style.
     * @api
     */
    Style.prototype.setGeometry = function (geometry) {
        if (typeof geometry === 'function') {
            this.geometryFunction_ = geometry;
        }
        else if (typeof geometry === 'string') {
            this.geometryFunction_ = function (feature) {
                return /** @type {import("../geom/Geometry.js").default} */ (feature.get(geometry));
            };
        }
        else if (!geometry) {
            this.geometryFunction_ = defaultGeometryFunction;
        }
        else if (geometry !== undefined) {
            this.geometryFunction_ = function () {
                return /** @type {import("../geom/Geometry.js").default} */ (geometry);
            };
        }
        this.geometry_ = geometry;
    };
    /**
     * Set the z-index.
     *
     * @param {number|undefined} zIndex ZIndex.
     * @api
     */
    Style.prototype.setZIndex = function (zIndex) {
        this.zIndex_ = zIndex;
    };
    return Style;
}());
/**
 * Convert the provided object into a style function.  Functions passed through
 * unchanged.  Arrays of Style or single style objects wrapped in a
 * new style function.
 * @param {StyleFunction|Array<Style>|Style} obj
 *     A style function, a single style, or an array of styles.
 * @return {StyleFunction} A style function.
 */
function toFunction(obj) {
    var styleFunction;
    if (typeof obj === 'function') {
        styleFunction = obj;
    }
    else {
        /**
         * @type {Array<Style>}
         */
        var styles_1;
        if (Array.isArray(obj)) {
            styles_1 = obj;
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(typeof ( /** @type {?} */(obj).getZIndex) === 'function', 41); // Expected an `Style` or an array of `Style`
            var style = /** @type {Style} */ (obj);
            styles_1 = [style];
        }
        styleFunction = function () {
            return styles_1;
        };
    }
    return styleFunction;
}
/**
 * @type {Array<Style>}
 */
var defaultStyles = null;
/**
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {number} resolution Resolution.
 * @return {Array<Style>} Style.
 */
function createDefaultStyle(feature, resolution) {
    // We don't use an immediately-invoked function
    // and a closure so we don't get an error at script evaluation time in
    // browsers that do not support Canvas. (import("./Circle.js").CircleStyle does
    // canvas.getContext('2d') at construction time, which will cause an.error
    // in such browsers.)
    if (!defaultStyles) {
        var fill = new _Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
            color: 'rgba(255,255,255,0.4)',
        });
        var stroke = new _Stroke_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
            color: '#3399CC',
            width: 1.25,
        });
        defaultStyles = [
            new Style({
                image: new _Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
                    fill: fill,
                    stroke: stroke,
                    radius: 5,
                }),
                fill: fill,
                stroke: stroke,
            }),
        ];
    }
    return defaultStyles;
}
/**
 * Default styles for editing features.
 * @return {Object<import("../geom/GeometryType.js").default, Array<Style>>} Styles
 */
function createEditingStyle() {
    /** @type {Object<import("../geom/GeometryType.js").default, Array<Style>>} */
    var styles = {};
    var white = [255, 255, 255, 1];
    var blue = [0, 153, 255, 1];
    var width = 3;
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON] = [
        new Style({
            fill: new _Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
                color: [255, 255, 255, 0.5],
            }),
        }),
    ];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON] = styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING] = [
        new Style({
            stroke: new _Stroke_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                color: white,
                width: width + 2,
            }),
        }),
        new Style({
            stroke: new _Stroke_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                color: blue,
                width: width,
            }),
        }),
    ];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING] = styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CIRCLE] = styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON].concat(styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING]);
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT] = [
        new Style({
            image: new _Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
                radius: width * 2,
                fill: new _Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
                    color: blue,
                }),
                stroke: new _Stroke_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                    color: white,
                    width: width / 2,
                }),
            }),
            zIndex: Infinity,
        }),
    ];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT] = styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT];
    styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].GEOMETRY_COLLECTION] = styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON].concat(styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING], styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT]);
    return styles;
}
/**
 * Function that is called with a feature and returns its default geometry.
 * @param {import("../Feature.js").FeatureLike} feature Feature to get the geometry for.
 * @return {import("../geom/Geometry.js").default|import("../render/Feature.js").default|undefined} Geometry to render.
 */
function defaultGeometryFunction(feature) {
    return feature.getGeometry();
}
/* harmony default export */ __webpack_exports__["default"] = (Style);
//# sourceMappingURL=Style.js.map

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Fill_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56);
/* harmony import */ var _TextPlacement_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39);
/**
 * @module ol/style/Text
 */



/**
 * The default fill color to use if no fill was set at construction time; a
 * blackish `#333`.
 *
 * @const {string}
 */
var DEFAULT_FILL_COLOR = '#333';
/**
 * @typedef {Object} Options
 * @property {string} [font] Font style as CSS 'font' value, see:
 * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/font. Default is '10px sans-serif'
 * @property {number} [maxAngle=Math.PI/4] When `placement` is set to `'line'`, allow a maximum angle between adjacent characters.
 * The expected value is in radians, and the default is 45° (`Math.PI / 4`).
 * @property {number} [offsetX=0] Horizontal text offset in pixels. A positive will shift the text right.
 * @property {number} [offsetY=0] Vertical text offset in pixels. A positive will shift the text down.
 * @property {boolean} [overflow=false] For polygon labels or when `placement` is set to `'line'`, allow text to exceed
 * the width of the polygon at the label position or the length of the path that it follows.
 * @property {import("./TextPlacement.js").default|string} [placement='point'] Text placement.
 * @property {number|import("../size.js").Size} [scale] Scale.
 * @property {boolean} [rotateWithView=false] Whether to rotate the text with the view.
 * @property {number} [rotation=0] Rotation in radians (positive rotation clockwise).
 * @property {string} [text] Text content.
 * @property {string} [textAlign] Text alignment. Possible values: 'left', 'right', 'center', 'end' or 'start'.
 * Default is 'center' for `placement: 'point'`. For `placement: 'line'`, the default is to let the renderer choose a
 * placement where `maxAngle` is not exceeded.
 * @property {string} [textBaseline='middle'] Text base line. Possible values: 'bottom', 'top', 'middle', 'alphabetic',
 * 'hanging', 'ideographic'.
 * @property {import("./Fill.js").default} [fill] Fill style. If none is provided, we'll use a dark fill-style (#333).
 * @property {import("./Stroke.js").default} [stroke] Stroke style.
 * @property {import("./Fill.js").default} [backgroundFill] Fill style for the text background when `placement` is
 * `'point'`. Default is no fill.
 * @property {import("./Stroke.js").default} [backgroundStroke] Stroke style for the text background  when `placement`
 * is `'point'`. Default is no stroke.
 * @property {Array<number>} [padding=[0, 0, 0, 0]] Padding in pixels around the text for decluttering and background. The order of
 * values in the array is `[top, right, bottom, left]`.
 */
/**
 * @classdesc
 * Set text style for vector features.
 * @api
 */
var Text = /** @class */ (function () {
    /**
     * @param {Options} [opt_options] Options.
     */
    function Text(opt_options) {
        var options = opt_options || {};
        /**
         * @private
         * @type {string|undefined}
         */
        this.font_ = options.font;
        /**
         * @private
         * @type {number|undefined}
         */
        this.rotation_ = options.rotation;
        /**
         * @private
         * @type {boolean|undefined}
         */
        this.rotateWithView_ = options.rotateWithView;
        /**
         * @private
         * @type {number|import("../size.js").Size|undefined}
         */
        this.scale_ = options.scale;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        this.scaleArray_ = Object(_size_js__WEBPACK_IMPORTED_MODULE_2__["toSize"])(options.scale !== undefined ? options.scale : 1);
        /**
         * @private
         * @type {string|undefined}
         */
        this.text_ = options.text;
        /**
         * @private
         * @type {string|undefined}
         */
        this.textAlign_ = options.textAlign;
        /**
         * @private
         * @type {string|undefined}
         */
        this.textBaseline_ = options.textBaseline;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */
        this.fill_ =
            options.fill !== undefined
                ? options.fill
                : new _Fill_js__WEBPACK_IMPORTED_MODULE_0__["default"]({ color: DEFAULT_FILL_COLOR });
        /**
         * @private
         * @type {number}
         */
        this.maxAngle_ =
            options.maxAngle !== undefined ? options.maxAngle : Math.PI / 4;
        /**
         * @private
         * @type {import("./TextPlacement.js").default|string}
         */
        this.placement_ =
            options.placement !== undefined ? options.placement : _TextPlacement_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINT;
        /**
         * @private
         * @type {boolean}
         */
        this.overflow_ = !!options.overflow;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */
        this.stroke_ = options.stroke !== undefined ? options.stroke : null;
        /**
         * @private
         * @type {number}
         */
        this.offsetX_ = options.offsetX !== undefined ? options.offsetX : 0;
        /**
         * @private
         * @type {number}
         */
        this.offsetY_ = options.offsetY !== undefined ? options.offsetY : 0;
        /**
         * @private
         * @type {import("./Fill.js").default}
         */
        this.backgroundFill_ = options.backgroundFill
            ? options.backgroundFill
            : null;
        /**
         * @private
         * @type {import("./Stroke.js").default}
         */
        this.backgroundStroke_ = options.backgroundStroke
            ? options.backgroundStroke
            : null;
        /**
         * @private
         * @type {Array<number>}
         */
        this.padding_ = options.padding === undefined ? null : options.padding;
    }
    /**
     * Clones the style.
     * @return {Text} The cloned style.
     * @api
     */
    Text.prototype.clone = function () {
        var scale = this.getScale();
        return new Text({
            font: this.getFont(),
            placement: this.getPlacement(),
            maxAngle: this.getMaxAngle(),
            overflow: this.getOverflow(),
            rotation: this.getRotation(),
            rotateWithView: this.getRotateWithView(),
            scale: Array.isArray(scale) ? scale.slice() : scale,
            text: this.getText(),
            textAlign: this.getTextAlign(),
            textBaseline: this.getTextBaseline(),
            fill: this.getFill() ? this.getFill().clone() : undefined,
            stroke: this.getStroke() ? this.getStroke().clone() : undefined,
            offsetX: this.getOffsetX(),
            offsetY: this.getOffsetY(),
            backgroundFill: this.getBackgroundFill()
                ? this.getBackgroundFill().clone()
                : undefined,
            backgroundStroke: this.getBackgroundStroke()
                ? this.getBackgroundStroke().clone()
                : undefined,
            padding: this.getPadding(),
        });
    };
    /**
     * Get the `overflow` configuration.
     * @return {boolean} Let text overflow the length of the path they follow.
     * @api
     */
    Text.prototype.getOverflow = function () {
        return this.overflow_;
    };
    /**
     * Get the font name.
     * @return {string|undefined} Font.
     * @api
     */
    Text.prototype.getFont = function () {
        return this.font_;
    };
    /**
     * Get the maximum angle between adjacent characters.
     * @return {number} Angle in radians.
     * @api
     */
    Text.prototype.getMaxAngle = function () {
        return this.maxAngle_;
    };
    /**
     * Get the label placement.
     * @return {import("./TextPlacement.js").default|string} Text placement.
     * @api
     */
    Text.prototype.getPlacement = function () {
        return this.placement_;
    };
    /**
     * Get the x-offset for the text.
     * @return {number} Horizontal text offset.
     * @api
     */
    Text.prototype.getOffsetX = function () {
        return this.offsetX_;
    };
    /**
     * Get the y-offset for the text.
     * @return {number} Vertical text offset.
     * @api
     */
    Text.prototype.getOffsetY = function () {
        return this.offsetY_;
    };
    /**
     * Get the fill style for the text.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */
    Text.prototype.getFill = function () {
        return this.fill_;
    };
    /**
     * Determine whether the text rotates with the map.
     * @return {boolean|undefined} Rotate with map.
     * @api
     */
    Text.prototype.getRotateWithView = function () {
        return this.rotateWithView_;
    };
    /**
     * Get the text rotation.
     * @return {number|undefined} Rotation.
     * @api
     */
    Text.prototype.getRotation = function () {
        return this.rotation_;
    };
    /**
     * Get the text scale.
     * @return {number|import("../size.js").Size|undefined} Scale.
     * @api
     */
    Text.prototype.getScale = function () {
        return this.scale_;
    };
    /**
     * Get the symbolizer scale array.
     * @return {import("../size.js").Size} Scale array.
     */
    Text.prototype.getScaleArray = function () {
        return this.scaleArray_;
    };
    /**
     * Get the stroke style for the text.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */
    Text.prototype.getStroke = function () {
        return this.stroke_;
    };
    /**
     * Get the text to be rendered.
     * @return {string|undefined} Text.
     * @api
     */
    Text.prototype.getText = function () {
        return this.text_;
    };
    /**
     * Get the text alignment.
     * @return {string|undefined} Text align.
     * @api
     */
    Text.prototype.getTextAlign = function () {
        return this.textAlign_;
    };
    /**
     * Get the text baseline.
     * @return {string|undefined} Text baseline.
     * @api
     */
    Text.prototype.getTextBaseline = function () {
        return this.textBaseline_;
    };
    /**
     * Get the background fill style for the text.
     * @return {import("./Fill.js").default} Fill style.
     * @api
     */
    Text.prototype.getBackgroundFill = function () {
        return this.backgroundFill_;
    };
    /**
     * Get the background stroke style for the text.
     * @return {import("./Stroke.js").default} Stroke style.
     * @api
     */
    Text.prototype.getBackgroundStroke = function () {
        return this.backgroundStroke_;
    };
    /**
     * Get the padding for the text.
     * @return {Array<number>} Padding.
     * @api
     */
    Text.prototype.getPadding = function () {
        return this.padding_;
    };
    /**
     * Set the `overflow` property.
     *
     * @param {boolean} overflow Let text overflow the path that it follows.
     * @api
     */
    Text.prototype.setOverflow = function (overflow) {
        this.overflow_ = overflow;
    };
    /**
     * Set the font.
     *
     * @param {string|undefined} font Font.
     * @api
     */
    Text.prototype.setFont = function (font) {
        this.font_ = font;
    };
    /**
     * Set the maximum angle between adjacent characters.
     *
     * @param {number} maxAngle Angle in radians.
     * @api
     */
    Text.prototype.setMaxAngle = function (maxAngle) {
        this.maxAngle_ = maxAngle;
    };
    /**
     * Set the x offset.
     *
     * @param {number} offsetX Horizontal text offset.
     * @api
     */
    Text.prototype.setOffsetX = function (offsetX) {
        this.offsetX_ = offsetX;
    };
    /**
     * Set the y offset.
     *
     * @param {number} offsetY Vertical text offset.
     * @api
     */
    Text.prototype.setOffsetY = function (offsetY) {
        this.offsetY_ = offsetY;
    };
    /**
     * Set the text placement.
     *
     * @param {import("./TextPlacement.js").default|string} placement Placement.
     * @api
     */
    Text.prototype.setPlacement = function (placement) {
        this.placement_ = placement;
    };
    /**
     * Set whether to rotate the text with the view.
     *
     * @param {boolean} rotateWithView Rotate with map.
     * @api
     */
    Text.prototype.setRotateWithView = function (rotateWithView) {
        this.rotateWithView_ = rotateWithView;
    };
    /**
     * Set the fill.
     *
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */
    Text.prototype.setFill = function (fill) {
        this.fill_ = fill;
    };
    /**
     * Set the rotation.
     *
     * @param {number|undefined} rotation Rotation.
     * @api
     */
    Text.prototype.setRotation = function (rotation) {
        this.rotation_ = rotation;
    };
    /**
     * Set the scale.
     *
     * @param {number|import("../size.js").Size|undefined} scale Scale.
     * @api
     */
    Text.prototype.setScale = function (scale) {
        this.scale_ = scale;
        this.scaleArray_ = Object(_size_js__WEBPACK_IMPORTED_MODULE_2__["toSize"])(scale !== undefined ? scale : 1);
    };
    /**
     * Set the stroke.
     *
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */
    Text.prototype.setStroke = function (stroke) {
        this.stroke_ = stroke;
    };
    /**
     * Set the text.
     *
     * @param {string|undefined} text Text.
     * @api
     */
    Text.prototype.setText = function (text) {
        this.text_ = text;
    };
    /**
     * Set the text alignment.
     *
     * @param {string|undefined} textAlign Text align.
     * @api
     */
    Text.prototype.setTextAlign = function (textAlign) {
        this.textAlign_ = textAlign;
    };
    /**
     * Set the text baseline.
     *
     * @param {string|undefined} textBaseline Text baseline.
     * @api
     */
    Text.prototype.setTextBaseline = function (textBaseline) {
        this.textBaseline_ = textBaseline;
    };
    /**
     * Set the background fill.
     *
     * @param {import("./Fill.js").default} fill Fill style.
     * @api
     */
    Text.prototype.setBackgroundFill = function (fill) {
        this.backgroundFill_ = fill;
    };
    /**
     * Set the background stroke.
     *
     * @param {import("./Stroke.js").default} stroke Stroke style.
     * @api
     */
    Text.prototype.setBackgroundStroke = function (stroke) {
        this.backgroundStroke_ = stroke;
    };
    /**
     * Set the padding (`[top, right, bottom, left]`).
     *
     * @param {!Array<number>} padding Padding.
     * @api
     */
    Text.prototype.setPadding = function (padding) {
        this.padding_ = padding;
    };
    return Text;
}());
/* harmony default export */ __webpack_exports__["default"] = (Text);
//# sourceMappingURL=Text.js.map

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/style/TextPlacement
 */
/**
 * Text placement. One of `'point'`, `'line'`. Default is `'point'`. Note that
 * `'line'` requires the underlying geometry to be a {@link module:ol/geom/LineString~LineString},
 * {@link module:ol/geom/Polygon~Polygon}, {@link module:ol/geom/MultiLineString~MultiLineString} or
 * {@link module:ol/geom/MultiPolygon~MultiPolygon}.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    POINT: 'point',
    LINE: 'line',
});
//# sourceMappingURL=TextPlacement.js.map

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _source_BingMaps_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BingMaps", function() { return _source_BingMaps_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _source_CartoDB_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CartoDB", function() { return _source_CartoDB_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _source_Cluster_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cluster", function() { return _source_Cluster_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _source_IIIF_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(114);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IIIF", function() { return _source_IIIF_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _source_Image_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(117);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return _source_Image_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _source_ImageArcGISRest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(119);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageArcGISRest", function() { return _source_ImageArcGISRest_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _source_ImageCanvas_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(121);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageCanvas", function() { return _source_ImageCanvas_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _source_ImageMapGuide_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(123);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageMapGuide", function() { return _source_ImageMapGuide_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _source_ImageStatic_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(124);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageStatic", function() { return _source_ImageStatic_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _source_ImageWMS_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(125);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageWMS", function() { return _source_ImageWMS_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _source_OSM_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(127);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OSM", function() { return _source_OSM_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _source_Raster_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(128);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Raster", function() { return _source_Raster_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _source_Source_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Source", function() { return _source_Source_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _source_Stamen_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(146);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Stamen", function() { return _source_Stamen_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _source_Tile_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(86);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tile", function() { return _source_Tile_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _source_TileArcGISRest_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(147);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileArcGISRest", function() { return _source_TileArcGISRest_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _source_TileDebug_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(148);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileDebug", function() { return _source_TileDebug_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var _source_TileImage_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileImage", function() { return _source_TileImage_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony import */ var _source_TileJSON_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(149);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileJSON", function() { return _source_TileJSON_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _source_TileWMS_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(150);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TileWMS", function() { return _source_TileWMS_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _source_UrlTile_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(84);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UrlTile", function() { return _source_UrlTile_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _source_UTFGrid_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(151);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UTFGrid", function() { return _source_UTFGrid_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var _source_Vector_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(105);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vector", function() { return _source_Vector_js__WEBPACK_IMPORTED_MODULE_22__["default"]; });

/* harmony import */ var _source_VectorTile_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(152);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VectorTile", function() { return _source_VectorTile_js__WEBPACK_IMPORTED_MODULE_23__["default"]; });

/* harmony import */ var _source_WMTS_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(155);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WMTS", function() { return _source_WMTS_js__WEBPACK_IMPORTED_MODULE_24__["default"]; });

/* harmony import */ var _source_XYZ_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(95);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "XYZ", function() { return _source_XYZ_js__WEBPACK_IMPORTED_MODULE_25__["default"]; });

/* harmony import */ var _source_Zoomify_js__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(115);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Zoomify", function() { return _source_Zoomify_js__WEBPACK_IMPORTED_MODULE_26__["default"]; });

/**
 * @module ol/source
 */



























//# sourceMappingURL=source.js.map

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quadKey", function() { return quadKey; });
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _net_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93);
/**
 * @module ol/source/BingMaps
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








/**
 * @param {import('../tilecoord.js').TileCoord} tileCoord Tile coord.
 * @return {string} Quad key.
 */
function quadKey(tileCoord) {
    var z = tileCoord[0];
    var digits = new Array(z);
    var mask = 1 << (z - 1);
    var i, charCode;
    for (i = 0; i < z; ++i) {
        // 48 is charCode for 0 - '0'.charCodeAt(0)
        charCode = 48;
        if (tileCoord[1] & mask) {
            charCode += 1;
        }
        if (tileCoord[2] & mask) {
            charCode += 2;
        }
        digits[i] = String.fromCharCode(charCode);
        mask >>= 1;
    }
    return digits.join('');
}
/**
 * The attribution containing a link to the Microsoft® Bing™ Maps Platform APIs’
 * Terms Of Use.
 * @const
 * @type {string}
 */
var TOS_ATTRIBUTION = '<a class="ol-attribution-bing-tos" ' +
    'href="https://www.microsoft.com/maps/product/terms.html" target="_blank">' +
    'Terms of Use</a>';
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {boolean} [hidpi=false] If `true` hidpi tiles will be requested.
 * @property {string} [culture='en-us'] Culture code.
 * @property {string} key Bing Maps API key. Get yours at https://www.bingmapsportal.com/.
 * @property {string} imagerySet Type of imagery.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {number} [maxZoom=21] Max zoom. Default is what's advertized by the BingMaps service.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @typedef {Object} BingMapsImageryMetadataResponse
 * @property {number} statusCode The response status code
 * @property {string} statusDescription The response status description
 * @property {string} authenticationResultCode The authentication result code
 * @property {Array<ResourceSet>} resourceSets The array of resource sets
 */
/**
 * @typedef {Object} ResourceSet
 * @property {Array<Resource>} resources Resources.
 */
/**
 * @typedef {Object} Resource
 * @property {number} imageHeight The image height
 * @property {number} imageWidth The image width
 * @property {number} zoomMin The minimum zoom level
 * @property {number} zoomMax The maximum zoom level
 * @property {string} imageUrl The image URL
 * @property {Array<string>} imageUrlSubdomains The image URL subdomains for rotation
 * @property {Array<ImageryProvider>} [imageryProviders] The array of ImageryProviders
 */
/**
 * @typedef {Object} ImageryProvider
 * @property {Array<CoverageArea>} coverageAreas The coverage areas
 * @property {string} [attribution] The attribution
 */
/**
 * @typedef {Object} CoverageArea
 * @property {number} zoomMin The minimum zoom
 * @property {number} zoomMax The maximum zoom
 * @property {Array<number>} bbox The coverage bounding box
 */
/**
 * @classdesc
 * Layer source for Bing Maps tile data.
 * @api
 */
var BingMaps = /** @class */ (function (_super) {
    __extends(BingMaps, _super);
    /**
     * @param {Options} options Bing Maps options.
     */
    function BingMaps(options) {
        var _this = this;
        var hidpi = options.hidpi !== undefined ? options.hidpi : false;
        _this = _super.call(this, {
            cacheSize: options.cacheSize,
            crossOrigin: 'anonymous',
            imageSmoothing: options.imageSmoothing,
            opaque: true,
            projection: Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["get"])('EPSG:3857'),
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: _State_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOADING,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: hidpi ? 2 : 1,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = hidpi;
        /**
         * @private
         * @type {string}
         */
        _this.culture_ = options.culture !== undefined ? options.culture : 'en-us';
        /**
         * @private
         * @type {number}
         */
        _this.maxZoom_ = options.maxZoom !== undefined ? options.maxZoom : -1;
        /**
         * @private
         * @type {string}
         */
        _this.apiKey_ = options.key;
        /**
         * @private
         * @type {string}
         */
        _this.imagerySet_ = options.imagerySet;
        var url = 'https://dev.virtualearth.net/REST/v1/Imagery/Metadata/' +
            _this.imagerySet_ +
            '?uriScheme=https&include=ImageryProviders&key=' +
            _this.apiKey_ +
            '&c=' +
            _this.culture_;
        Object(_net_js__WEBPACK_IMPORTED_MODULE_7__["jsonp"])(url, _this.handleImageryMetadataResponse.bind(_this), undefined, 'jsonp');
        return _this;
    }
    /**
     * Get the api key used for this source.
     *
     * @return {string} The api key.
     * @api
     */
    BingMaps.prototype.getApiKey = function () {
        return this.apiKey_;
    };
    /**
     * Get the imagery set associated with this source.
     *
     * @return {string} The imagery set.
     * @api
     */
    BingMaps.prototype.getImagerySet = function () {
        return this.imagerySet_;
    };
    /**
     * @param {BingMapsImageryMetadataResponse} response Response.
     */
    BingMaps.prototype.handleImageryMetadataResponse = function (response) {
        if (response.statusCode != 200 ||
            response.statusDescription != 'OK' ||
            response.authenticationResultCode != 'ValidCredentials' ||
            response.resourceSets.length != 1 ||
            response.resourceSets[0].resources.length != 1) {
            this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR);
            return;
        }
        var resource = response.resourceSets[0].resources[0];
        var maxZoom = this.maxZoom_ == -1 ? resource.zoomMax : this.maxZoom_;
        var sourceProjection = this.getProjection();
        var extent = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_5__["extentFromProjection"])(sourceProjection);
        var scale = this.hidpi_ ? 2 : 1;
        var tileSize = resource.imageWidth == resource.imageHeight
            ? resource.imageWidth / scale
            : [resource.imageWidth / scale, resource.imageHeight / scale];
        var tileGrid = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_5__["createXYZ"])({
            extent: extent,
            minZoom: resource.zoomMin,
            maxZoom: maxZoom,
            tileSize: tileSize,
        });
        this.tileGrid = tileGrid;
        var culture = this.culture_;
        var hidpi = this.hidpi_;
        this.tileUrlFunction = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_3__["createFromTileUrlFunctions"])(resource.imageUrlSubdomains.map(function (subdomain) {
            /** @type {import('../tilecoord.js').TileCoord} */
            var quadKeyTileCoord = [0, 0, 0];
            var imageUrl = resource.imageUrl
                .replace('{subdomain}', subdomain)
                .replace('{culture}', culture);
            return (
            /**
             * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
             * @param {number} pixelRatio Pixel ratio.
             * @param {import("../proj/Projection.js").default} projection Projection.
             * @return {string|undefined} Tile URL.
             */
            function (tileCoord, pixelRatio, projection) {
                if (!tileCoord) {
                    return undefined;
                }
                else {
                    Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdate"])(tileCoord[0], tileCoord[1], tileCoord[2], quadKeyTileCoord);
                    var url = imageUrl;
                    if (hidpi) {
                        url += '&dpi=d1&device=mobile';
                    }
                    return url.replace('{quadkey}', quadKey(quadKeyTileCoord));
                }
            });
        }));
        if (resource.imageryProviders) {
            var transform_1 = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["getTransformFromProjections"])(Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["get"])('EPSG:4326'), this.getProjection());
            this.setAttributions(function (frameState) {
                var attributions = [];
                var viewState = frameState.viewState;
                var tileGrid = this.getTileGrid();
                var z = tileGrid.getZForResolution(viewState.resolution, this.zDirection);
                var tileCoord = tileGrid.getTileCoordForCoordAndZ(viewState.center, z);
                var zoom = tileCoord[0];
                resource.imageryProviders.map(function (imageryProvider) {
                    var intersecting = false;
                    var coverageAreas = imageryProvider.coverageAreas;
                    for (var i = 0, ii = coverageAreas.length; i < ii; ++i) {
                        var coverageArea = coverageAreas[i];
                        if (zoom >= coverageArea.zoomMin &&
                            zoom <= coverageArea.zoomMax) {
                            var bbox = coverageArea.bbox;
                            var epsg4326Extent = [bbox[1], bbox[0], bbox[3], bbox[2]];
                            var extent_1 = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["applyTransform"])(epsg4326Extent, transform_1);
                            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["intersects"])(extent_1, frameState.extent)) {
                                intersecting = true;
                                break;
                            }
                        }
                    }
                    if (intersecting) {
                        attributions.push(imageryProvider.attribution);
                    }
                });
                attributions.push(TOS_ATTRIBUTION);
                return attributions;
            }.bind(this));
        }
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].READY);
    };
    return BingMaps;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BingMaps);
//# sourceMappingURL=BingMaps.js.map

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/source/State
 */
/**
 * @enum {string}
 * State of the source, one of 'undefined', 'loading', 'ready' or 'error'.
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    UNDEFINED: 'undefined',
    LOADING: 'loading',
    READY: 'ready',
    ERROR: 'error',
});
//# sourceMappingURL=State.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _ImageTile_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);
/* harmony import */ var _reproj_Tile_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76);
/* harmony import */ var _TileCache_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(81);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74);
/* harmony import */ var _UrlTile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84);
/* harmony import */ var _reproj_common_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(77);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(88);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/TileImage
 */












/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./State.js").default} [state] Source state.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service. For example, if the tile
 * service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX] Whether to wrap the world horizontally. The default, is to
 * request out-of-bounds tiles from the server. When set to `false`, only one
 * world will be rendered. When set to `true`, tiles will be requested for one
 * world only, but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [key] Optional tile key for proper cache fetching
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Base class for sources providing images divided into a tile grid.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */
var TileImage = /** @class */ (function (_super) {
    __extends(TileImage, _super);
    /**
     * @param {!Options} options Image tile options.
     */
    function TileImage(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction
                ? options.tileLoadFunction
                : defaultTileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @protected
         * @type {?string}
         */
        _this.crossOrigin =
            options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @protected
         * @type {typeof ImageTile}
         */
        _this.tileClass =
            options.tileClass !== undefined ? options.tileClass : _ImageTile_js__WEBPACK_IMPORTED_MODULE_1__["default"];
        /**
         * @protected
         * @type {!Object<string, TileCache>}
         */
        _this.tileCacheForProjection = {};
        /**
         * @protected
         * @type {!Object<string, import("../tilegrid/TileGrid.js").default>}
         */
        _this.tileGridForProjection = {};
        /**
         * @private
         * @type {number|undefined}
         */
        _this.reprojectionErrorThreshold_ = options.reprojectionErrorThreshold;
        /**
         * @private
         * @type {object|undefined}
         */
        _this.contextOptions_ =
            options.imageSmoothing === false ? _common_js__WEBPACK_IMPORTED_MODULE_7__["IMAGE_SMOOTHING_DISABLED"] : undefined;
        /**
         * @private
         * @type {boolean}
         */
        _this.renderReprojectionEdges_ = false;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */
    TileImage.prototype.canExpireCache = function () {
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"]) {
            return _super.prototype.canExpireCache.call(this);
        }
        if (this.tileCache.canExpireCache()) {
            return true;
        }
        else {
            for (var key in this.tileCacheForProjection) {
                if (this.tileCacheForProjection[key].canExpireCache()) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */
    TileImage.prototype.expireCache = function (projection, usedTiles) {
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"]) {
            _super.prototype.expireCache.call(this, projection, usedTiles);
            return;
        }
        var usedTileCache = this.getTileCacheForProjection(projection);
        this.tileCache.expireCache(this.tileCache == usedTileCache ? usedTiles : {});
        for (var id in this.tileCacheForProjection) {
            var tileCache = this.tileCacheForProjection[id];
            tileCache.expireCache(tileCache == usedTileCache ? usedTiles : {});
        }
    };
    /**
     * @return {Object|undefined} Context options.
     */
    TileImage.prototype.getContextOptions = function () {
        return this.contextOptions_;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */
    TileImage.prototype.getGutterForProjection = function (projection) {
        if (_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"] &&
            this.getProjection() &&
            projection &&
            !Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(this.getProjection(), projection)) {
            return 0;
        }
        else {
            return this.getGutter();
        }
    };
    /**
     * @return {number} Gutter.
     */
    TileImage.prototype.getGutter = function () {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     * @protected
     */
    TileImage.prototype.getKey = function () {
        return (_super.prototype.getKey.call(this) +
            (this.contextOptions_ ? '\n' + JSON.stringify(this.contextOptions_) : ''));
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */
    TileImage.prototype.getOpaque = function (projection) {
        if (_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"] &&
            this.getProjection() &&
            projection &&
            !Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(this.getProjection(), projection)) {
            return false;
        }
        else {
            return _super.prototype.getOpaque.call(this, projection);
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */
    TileImage.prototype.getTileGridForProjection = function (projection) {
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"]) {
            return _super.prototype.getTileGridForProjection.call(this, projection);
        }
        var thisProj = this.getProjection();
        if (this.tileGrid && (!thisProj || Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(thisProj, projection))) {
            return this.tileGrid;
        }
        else {
            var projKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(projection);
            if (!(projKey in this.tileGridForProjection)) {
                this.tileGridForProjection[projKey] =
                    Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_10__["getForProjection"])(projection);
            }
            return this.tileGridForProjection[projKey];
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     */
    TileImage.prototype.getTileCacheForProjection = function (projection) {
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"]) {
            return _super.prototype.getTileCacheForProjection.call(this, projection);
        }
        var thisProj = this.getProjection();
        if (!thisProj || Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(thisProj, projection)) {
            return this.tileCache;
        }
        else {
            var projKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(projection);
            if (!(projKey in this.tileCacheForProjection)) {
                this.tileCacheForProjection[projKey] = new _TileCache_js__WEBPACK_IMPORTED_MODULE_3__["default"](this.tileCache.highWaterMark);
            }
            return this.tileCacheForProjection[projKey];
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {string} key The key set on the tile.
     * @return {!import("../Tile.js").default} Tile.
     * @private
     */
    TileImage.prototype.createTile_ = function (z, x, y, pixelRatio, projection, key) {
        var tileCoord = [z, x, y];
        var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        var tileUrl = urlTileCoord
            ? this.tileUrlFunction(urlTileCoord, pixelRatio, projection)
            : undefined;
        var tile = new this.tileClass(tileCoord, tileUrl !== undefined ? _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].IDLE : _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].EMPTY, tileUrl !== undefined ? tileUrl : '', this.crossOrigin, this.tileLoadFunction, this.tileOptions);
        tile.key = key;
        tile.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.handleTileChange.bind(this));
        return tile;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     */
    TileImage.prototype.getTile = function (z, x, y, pixelRatio, projection) {
        var sourceProjection = this.getProjection();
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"] ||
            !sourceProjection ||
            !projection ||
            Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(sourceProjection, projection)) {
            return this.getTileInternal(z, x, y, pixelRatio, sourceProjection || projection);
        }
        else {
            var cache = this.getTileCacheForProjection(projection);
            var tileCoord = [z, x, y];
            var tile = void 0;
            var tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_9__["getKey"])(tileCoord);
            if (cache.containsKey(tileCoordKey)) {
                tile = cache.get(tileCoordKey);
            }
            var key = this.getKey();
            if (tile && tile.key == key) {
                return tile;
            }
            else {
                var sourceTileGrid = this.getTileGridForProjection(sourceProjection);
                var targetTileGrid = this.getTileGridForProjection(projection);
                var wrappedTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
                var newTile = new _reproj_Tile_js__WEBPACK_IMPORTED_MODULE_2__["default"](sourceProjection, sourceTileGrid, projection, targetTileGrid, tileCoord, wrappedTileCoord, this.getTilePixelRatio(pixelRatio), this.getGutter(), function (z, x, y, pixelRatio) {
                    return this.getTileInternal(z, x, y, pixelRatio, sourceProjection);
                }.bind(this), this.reprojectionErrorThreshold_, this.renderReprojectionEdges_, this.contextOptions_);
                newTile.key = key;
                if (tile) {
                    newTile.interimTile = tile;
                    newTile.refreshInterimChain();
                    cache.replace(tileCoordKey, newTile);
                }
                else {
                    cache.set(tileCoordKey, newTile);
                }
                return newTile;
            }
        }
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {!import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     * @protected
     */
    TileImage.prototype.getTileInternal = function (z, x, y, pixelRatio, projection) {
        var tile = null;
        var tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_9__["getKeyZXY"])(z, x, y);
        var key = this.getKey();
        if (!this.tileCache.containsKey(tileCoordKey)) {
            tile = this.createTile_(z, x, y, pixelRatio, projection, key);
            this.tileCache.set(tileCoordKey, tile);
        }
        else {
            tile = this.tileCache.get(tileCoordKey);
            if (tile.key != key) {
                // The source's params changed. If the tile has an interim tile and if we
                // can use it then we use it. Otherwise we create a new tile.  In both
                // cases we attempt to assign an interim tile to the new tile.
                var interimTile = tile;
                tile = this.createTile_(z, x, y, pixelRatio, projection, key);
                //make the new tile the head of the list,
                if (interimTile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].IDLE) {
                    //the old tile hasn't begun loading yet, and is now outdated, so we can simply discard it
                    tile.interimTile = interimTile.interimTile;
                }
                else {
                    tile.interimTile = interimTile;
                }
                tile.refreshInterimChain();
                this.tileCache.replace(tileCoordKey, tile);
            }
        }
        return tile;
    };
    /**
     * Sets whether to render reprojection edges or not (usually for debugging).
     * @param {boolean} render Render the edges.
     * @api
     */
    TileImage.prototype.setRenderReprojectionEdges = function (render) {
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"] ||
            this.renderReprojectionEdges_ == render) {
            return;
        }
        this.renderReprojectionEdges_ = render;
        for (var id in this.tileCacheForProjection) {
            this.tileCacheForProjection[id].clear();
        }
        this.changed();
    };
    /**
     * Sets the tile grid to use when reprojecting the tiles to the given
     * projection instead of the default tile grid for the projection.
     *
     * This can be useful when the default tile grid cannot be created
     * (e.g. projection has no extent defined) or
     * for optimization reasons (custom tile size, resolutions, ...).
     *
     * @param {import("../proj.js").ProjectionLike} projection Projection.
     * @param {import("../tilegrid/TileGrid.js").default} tilegrid Tile grid to use for the projection.
     * @api
     */
    TileImage.prototype.setTileGridForProjection = function (projection, tilegrid) {
        if (_reproj_common_js__WEBPACK_IMPORTED_MODULE_6__["ENABLE_RASTER_REPROJECTION"]) {
            var proj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["get"])(projection);
            if (proj) {
                var projKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(proj);
                if (!(projKey in this.tileGridForProjection)) {
                    this.tileGridForProjection[projKey] = tilegrid;
                }
            }
        }
    };
    return TileImage;
}(_UrlTile_js__WEBPACK_IMPORTED_MODULE_5__["default"]));
/**
 * @param {ImageTile} imageTile Image tile.
 * @param {string} src Source.
 */
function defaultTileLoadFunction(imageTile, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ (imageTile.getImage()).src =
        src;
}
/* harmony default export */ __webpack_exports__["default"] = (TileImage);
//# sourceMappingURL=TileImage.js.map

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/ImageTile
 */




var ImageTile = /** @class */ (function (_super) {
    __extends(ImageTile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @param {import("./Tile.js").Options} [opt_options] Tile options.
     */
    function ImageTile(tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
        var _this = _super.call(this, tileCoord, state, opt_options) || this;
        /**
         * @private
         * @type {?string}
         */
        _this.crossOrigin_ = crossOrigin;
        /**
         * Image URI
         *
         * @private
         * @type {string}
         */
        _this.src_ = src;
        _this.key = src;
        /**
         * @private
         * @type {HTMLImageElement|HTMLCanvasElement}
         */
        _this.image_ = new Image();
        if (crossOrigin !== null) {
            _this.image_.crossOrigin = crossOrigin;
        }
        /**
         * @private
         * @type {?function():void}
         */
        _this.unlisten_ = null;
        /**
         * @private
         * @type {import("./Tile.js").LoadFunction}
         */
        _this.tileLoadFunction_ = tileLoadFunction;
        return _this;
    }
    /**
     * Get the HTML image element for this tile (may be a Canvas, Image, or Video).
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @api
     */
    ImageTile.prototype.getImage = function () {
        return this.image_;
    };
    /**
     * Sets an HTML image element for this tile (may be a Canvas or preloaded Image).
     * @param {HTMLCanvasElement|HTMLImageElement} element Element.
     */
    ImageTile.prototype.setImage = function (element) {
        this.image_ = element;
        this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED;
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Tracks loading or read errors.
     *
     * @private
     */
    ImageTile.prototype.handleImageError_ = function () {
        this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR;
        this.unlistenImage_();
        this.image_ = getBlankImage();
        this.changed();
    };
    /**
     * Tracks successful image load.
     *
     * @private
     */
    ImageTile.prototype.handleImageLoad_ = function () {
        var image = /** @type {HTMLImageElement} */ (this.image_);
        if (image.naturalWidth && image.naturalHeight) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED;
        }
        else {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].EMPTY;
        }
        this.unlistenImage_();
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     * @api
     */
    ImageTile.prototype.load = function () {
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE;
            this.image_ = new Image();
            if (this.crossOrigin_ !== null) {
                this.image_.crossOrigin = this.crossOrigin_;
            }
        }
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADING;
            this.changed();
            this.tileLoadFunction_(this, this.src_);
            this.unlisten_ = Object(_Image_js__WEBPACK_IMPORTED_MODULE_3__["listenImage"])(this.image_, this.handleImageLoad_.bind(this), this.handleImageError_.bind(this));
        }
    };
    /**
     * Discards event handlers which listen for load completion or errors.
     *
     * @private
     */
    ImageTile.prototype.unlistenImage_ = function () {
        if (this.unlisten_) {
            this.unlisten_();
            this.unlisten_ = null;
        }
    };
    return ImageTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Get a 1-pixel blank image.
 * @return {HTMLCanvasElement} Blank image.
 */
function getBlankImage() {
    var ctx = Object(_dom_js__WEBPACK_IMPORTED_MODULE_2__["createCanvasContext2D"])(1, 1);
    ctx.fillStyle = 'rgba(0,0,0,0)';
    ctx.fillRect(0, 0, 1, 1);
    return ctx.canvas;
}
/* harmony default export */ __webpack_exports__["default"] = (ImageTile);
//# sourceMappingURL=ImageTile.js.map

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Tile
 */





/**
 * A function that takes an {@link module:ol/Tile} for the tile and a
 * `{string}` for the url as arguments. The default is
 * ```js
 * source.setTileLoadFunction(function(tile, src) {
 *   tile.getImage().src = src;
 * });
 * ```
 * For more fine grained control, the load function can use fetch or XMLHttpRequest and involve
 * error handling:
 *
 * ```js
 * import TileState from 'ol/TileState';
 *
 * source.setTileLoadFunction(function(tile, src) {
 *   var xhr = new XMLHttpRequest();
 *   xhr.responseType = 'blob';
 *   xhr.addEventListener('loadend', function (evt) {
 *     var data = this.response;
 *     if (data !== undefined) {
 *       tile.getImage().src = URL.createObjectURL(data);
 *     } else {
 *       tile.setState(TileState.ERROR);
 *     }
 *   });
 *   xhr.addEventListener('error', function () {
 *     tile.setState(TileState.ERROR);
 *   });
 *   xhr.open('GET', src);
 *   xhr.send();
 * });
 * ```
 *
 * @typedef {function(Tile, string): void} LoadFunction
 * @api
 */
/**
 * {@link module:ol/source/Tile~Tile} sources use a function of this type to get
 * the url that provides a tile for a given tile coordinate.
 *
 * This function takes an {@link module:ol/tilecoord~TileCoord} for the tile
 * coordinate, a `{number}` representing the pixel ratio and a
 * {@link module:ol/proj/Projection} for the projection  as arguments
 * and returns a `{string}` representing the tile URL, or undefined if no tile
 * should be requested for the passed tile coordinate.
 *
 * @typedef {function(import("./tilecoord.js").TileCoord, number,
 *           import("./proj/Projection.js").default): (string|undefined)} UrlFunction
 * @api
 */
/**
 * @typedef {Object} Options
 * @property {number} [transition=250] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @api
 */
/**
 * @classdesc
 * Base class for tiles.
 *
 * @abstract
 */
var Tile = /** @class */ (function (_super) {
    __extends(Tile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {Options} [opt_options] Tile options.
     */
    function Tile(tileCoord, state, opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("./tilecoord.js").TileCoord}
         */
        _this.tileCoord = tileCoord;
        /**
         * @protected
         * @type {import("./TileState.js").default}
         */
        _this.state = state;
        /**
         * An "interim" tile for this tile. The interim tile may be used while this
         * one is loading, for "smooth" transitions when changing params/dimensions
         * on the source.
         * @type {Tile}
         */
        _this.interimTile = null;
        /**
         * A key assigned to the tile. This is used by the tile source to determine
         * if this tile can effectively be used, or if a new tile should be created
         * and this one be used as an interim tile for this new tile.
         * @type {string}
         */
        _this.key = '';
        /**
         * The duration for the opacity transition.
         * @type {number}
         */
        _this.transition_ =
            options.transition === undefined ? 250 : options.transition;
        /**
         * Lookup of start times for rendering transitions.  If the start time is
         * equal to -1, the transition is complete.
         * @type {Object<string, number>}
         */
        _this.transitionStarts_ = {};
        return _this;
    }
    /**
     * @protected
     */
    Tile.prototype.changed = function () {
        this.dispatchEvent(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE);
    };
    /**
     * Called by the tile cache when the tile is removed from the cache due to expiry
     */
    Tile.prototype.release = function () { };
    /**
     * @return {string} Key.
     */
    Tile.prototype.getKey = function () {
        return this.key + '/' + this.tileCoord;
    };
    /**
     * Get the interim tile most suitable for rendering using the chain of interim
     * tiles. This corresponds to the  most recent tile that has been loaded, if no
     * such tile exists, the original tile is returned.
     * @return {!Tile} Best tile for rendering.
     */
    Tile.prototype.getInterimTile = function () {
        if (!this.interimTile) {
            //empty chain
            return this;
        }
        var tile = this.interimTile;
        // find the first loaded tile and return it. Since the chain is sorted in
        // decreasing order of creation time, there is no need to search the remainder
        // of the list (all those tiles correspond to older requests and will be
        // cleaned up by refreshInterimChain)
        do {
            if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
                // Show tile immediately instead of fading it in after loading, because
                // the interim tile is in place already
                this.transition_ = 0;
                return tile;
            }
            tile = tile.interimTile;
        } while (tile);
        // we can not find a better tile
        return this;
    };
    /**
     * Goes through the chain of interim tiles and discards sections of the chain
     * that are no longer relevant.
     */
    Tile.prototype.refreshInterimChain = function () {
        if (!this.interimTile) {
            return;
        }
        var tile = this.interimTile;
        var prev = /** @type {Tile} */ (this);
        do {
            if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
                //we have a loaded tile, we can discard the rest of the list
                //we would could abort any LOADING tile request
                //older than this tile (i.e. any LOADING tile following this entry in the chain)
                tile.interimTile = null;
                break;
            }
            else if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING) {
                //keep this LOADING tile any loaded tiles later in the chain are
                //older than this tile, so we're still interested in the request
                prev = tile;
            }
            else if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE) {
                //the head of the list is the most current tile, we don't need
                //to start any other requests for this chain
                prev.interimTile = tile.interimTile;
            }
            else {
                prev = tile;
            }
            tile = prev.interimTile;
        } while (tile);
    };
    /**
     * Get the tile coordinate for this tile.
     * @return {import("./tilecoord.js").TileCoord} The tile coordinate.
     * @api
     */
    Tile.prototype.getTileCoord = function () {
        return this.tileCoord;
    };
    /**
     * @return {import("./TileState.js").default} State.
     */
    Tile.prototype.getState = function () {
        return this.state;
    };
    /**
     * Sets the state of this tile. If you write your own {@link module:ol/Tile~LoadFunction tileLoadFunction} ,
     * it is important to set the state correctly to {@link module:ol/TileState~ERROR}
     * when the tile cannot be loaded. Otherwise the tile cannot be removed from
     * the tile queue and will block other requests.
     * @param {import("./TileState.js").default} state State.
     * @api
     */
    Tile.prototype.setState = function (state) {
        if (this.state !== _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR && this.state > state) {
            throw new Error('Tile load sequence violation');
        }
        this.state = state;
        this.changed();
    };
    /**
     * Load the image or retry if loading previously failed.
     * Loading is taken care of by the tile queue, and calling this method is
     * only needed for preloading or for reloading in case of an error.
     * @abstract
     * @api
     */
    Tile.prototype.load = function () {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_3__["abstract"])();
    };
    /**
     * Get the alpha value for rendering.
     * @param {string} id An id for the renderer.
     * @param {number} time The render frame time.
     * @return {number} A number between 0 and 1.
     */
    Tile.prototype.getAlpha = function (id, time) {
        if (!this.transition_) {
            return 1;
        }
        var start = this.transitionStarts_[id];
        if (!start) {
            start = time;
            this.transitionStarts_[id] = start;
        }
        else if (start === -1) {
            return 1;
        }
        var delta = time - start + 1000 / 60; // avoid rendering at 0
        if (delta >= this.transition_) {
            return 1;
        }
        return Object(_easing_js__WEBPACK_IMPORTED_MODULE_4__["easeIn"])(delta / this.transition_);
    };
    /**
     * Determine if a tile is in an alpha transition.  A tile is considered in
     * transition if tile.getAlpha() has not yet been called or has been called
     * and returned 1.
     * @param {string} id An id for the renderer.
     * @return {boolean} The tile is in transition.
     */
    Tile.prototype.inTransition = function (id) {
        if (!this.transition_) {
            return false;
        }
        return this.transitionStarts_[id] !== -1;
    };
    /**
     * Mark a transition as complete.
     * @param {string} id An id for the renderer.
     */
    Tile.prototype.endTransition = function (id) {
        if (this.transition_) {
            this.transitionStarts_[id] = -1;
        }
    };
    return Tile;
}(_events_Target_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Tile);
//# sourceMappingURL=Tile.js.map

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/TileState
 */
/**
 * @enum {number}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    IDLE: 0,
    LOADING: 1,
    LOADED: 2,
    /**
     * Indicates that tile loading failed
     * @type {number}
     */
    ERROR: 3,
    EMPTY: 4,
});
//# sourceMappingURL=TileState.js.map

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeIn", function() { return easeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOut", function() { return easeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inAndOut", function() { return inAndOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "upAndDown", function() { return upAndDown; });
/**
 * @module ol/easing
 */
/**
 * Start slow and speed up.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function easeIn(t) {
    return Math.pow(t, 3);
}
/**
 * Start fast and slow down.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function easeOut(t) {
    return 1 - easeIn(1 - t);
}
/**
 * Start slow, speed up, and then slow down again.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function inAndOut(t) {
    return 3 * t * t - 2 * t * t * t;
}
/**
 * Maintain a constant speed over time.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function linear(t) {
    return t;
}
/**
 * Start slow, speed up, and at the very end slow down again.  This has the
 * same general behavior as {@link module:ol/easing.inAndOut}, but the final
 * slowdown is delayed.
 * @param {number} t Input between 0 and 1.
 * @return {number} Output between 0 and 1.
 * @api
 */
function upAndDown(t) {
    if (t < 0.5) {
        return inAndOut(2 * t);
    }
    else {
        return 1 - inAndOut(2 * (t - 0.5));
    }
}
//# sourceMappingURL=easing.js.map

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74);
/* harmony import */ var _Triangulation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78);
/* harmony import */ var _reproj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/reproj/Tile
 */









/**
 * @typedef {function(number, number, number, number) : import("../Tile.js").default} FunctionType
 */
/**
 * @classdesc
 * Class encapsulating single reprojected tile.
 * See {@link module:ol/source/TileImage~TileImage}.
 *
 */
var ReprojTile = /** @class */ (function (_super) {
    __extends(ReprojTile, _super);
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../tilegrid/TileGrid.js").default} sourceTileGrid Source tile grid.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../tilegrid/TileGrid.js").default} targetTileGrid Target tile grid.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Coordinate of the tile.
     * @param {import("../tilecoord.js").TileCoord} wrappedTileCoord Coordinate of the tile wrapped in X.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} gutter Gutter of the source tiles.
     * @param {FunctionType} getTileFunction
     *     Function returning source tiles (z, x, y, pixelRatio).
     * @param {number} [opt_errorThreshold] Acceptable reprojection error (in px).
     * @param {boolean} [opt_renderEdges] Render reprojection edges.
     * @param {object} [opt_contextOptions] Properties to set on the canvas context.
     */
    function ReprojTile(sourceProj, sourceTileGrid, targetProj, targetTileGrid, tileCoord, wrappedTileCoord, pixelRatio, gutter, getTileFunction, opt_errorThreshold, opt_renderEdges, opt_contextOptions) {
        var _this = _super.call(this, tileCoord, _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.renderEdges_ = opt_renderEdges !== undefined ? opt_renderEdges : false;
        /**
         * @private
         * @type {object}
         */
        _this.contextOptions_ = opt_contextOptions;
        /**
         * @private
         * @type {number}
         */
        _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */
        _this.gutter_ = gutter;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.canvas_ = null;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */
        _this.sourceTileGrid_ = sourceTileGrid;
        /**
         * @private
         * @type {import("../tilegrid/TileGrid.js").default}
         */
        _this.targetTileGrid_ = targetTileGrid;
        /**
         * @private
         * @type {import("../tilecoord.js").TileCoord}
         */
        _this.wrappedTileCoord_ = wrappedTileCoord ? wrappedTileCoord : tileCoord;
        /**
         * @private
         * @type {!Array<import("../Tile.js").default>}
         */
        _this.sourceTiles_ = [];
        /**
         * @private
         * @type {?Array<import("../events.js").EventsKey>}
         */
        _this.sourcesListenerKeys_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.sourceZ_ = 0;
        var targetExtent = targetTileGrid.getTileCoordExtent(_this.wrappedTileCoord_);
        var maxTargetExtent = _this.targetTileGrid_.getExtent();
        var maxSourceExtent = _this.sourceTileGrid_.getExtent();
        var limitedTargetExtent = maxTargetExtent
            ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getIntersection"])(targetExtent, maxTargetExtent)
            : targetExtent;
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getArea"])(limitedTargetExtent) === 0) {
            // Tile is completely outside range -> EMPTY
            // TODO: is it actually correct that the source even creates the tile ?
            _this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
            return _this;
        }
        var sourceProjExtent = sourceProj.getExtent();
        if (sourceProjExtent) {
            if (!maxSourceExtent) {
                maxSourceExtent = sourceProjExtent;
            }
            else {
                maxSourceExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getIntersection"])(maxSourceExtent, sourceProjExtent);
            }
        }
        var targetResolution = targetTileGrid.getResolution(_this.wrappedTileCoord_[0]);
        var sourceResolution = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_5__["calculateSourceExtentResolution"])(sourceProj, targetProj, limitedTargetExtent, targetResolution);
        if (!isFinite(sourceResolution) || sourceResolution <= 0) {
            // invalid sourceResolution -> EMPTY
            // probably edges of the projections when no extent is defined
            _this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
            return _this;
        }
        var errorThresholdInPixels = opt_errorThreshold !== undefined ? opt_errorThreshold : _common_js__WEBPACK_IMPORTED_MODULE_0__["ERROR_THRESHOLD"];
        /**
         * @private
         * @type {!import("./Triangulation.js").default}
         */
        _this.triangulation_ = new _Triangulation_js__WEBPACK_IMPORTED_MODULE_4__["default"](sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        if (_this.triangulation_.getTriangles().length === 0) {
            // no valid triangles -> EMPTY
            _this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
            return _this;
        }
        _this.sourceZ_ = sourceTileGrid.getZForResolution(sourceResolution);
        var sourceExtent = _this.triangulation_.calculateSourceExtent();
        if (maxSourceExtent) {
            if (sourceProj.canWrapX()) {
                sourceExtent[1] = Object(_math_js__WEBPACK_IMPORTED_MODULE_6__["clamp"])(sourceExtent[1], maxSourceExtent[1], maxSourceExtent[3]);
                sourceExtent[3] = Object(_math_js__WEBPACK_IMPORTED_MODULE_6__["clamp"])(sourceExtent[3], maxSourceExtent[1], maxSourceExtent[3]);
            }
            else {
                sourceExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getIntersection"])(sourceExtent, maxSourceExtent);
            }
        }
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getArea"])(sourceExtent)) {
            _this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
        }
        else {
            var sourceRange = sourceTileGrid.getTileRangeForExtentAndZ(sourceExtent, _this.sourceZ_);
            for (var srcX = sourceRange.minX; srcX <= sourceRange.maxX; srcX++) {
                for (var srcY = sourceRange.minY; srcY <= sourceRange.maxY; srcY++) {
                    var tile = getTileFunction(_this.sourceZ_, srcX, srcY, pixelRatio);
                    if (tile) {
                        _this.sourceTiles_.push(tile);
                    }
                }
            }
            if (_this.sourceTiles_.length === 0) {
                _this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
            }
        }
        return _this;
    }
    /**
     * Get the HTML Canvas element for this tile.
     * @return {HTMLCanvasElement} Canvas.
     */
    ReprojTile.prototype.getImage = function () {
        return this.canvas_;
    };
    /**
     * @private
     */
    ReprojTile.prototype.reproject_ = function () {
        var sources = [];
        this.sourceTiles_.forEach(function (tile, i, arr) {
            if (tile && tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED) {
                sources.push({
                    extent: this.sourceTileGrid_.getTileCoordExtent(tile.tileCoord),
                    image: tile.getImage(),
                });
            }
        }.bind(this));
        this.sourceTiles_.length = 0;
        if (sources.length === 0) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR;
        }
        else {
            var z = this.wrappedTileCoord_[0];
            var size = this.targetTileGrid_.getTileSize(z);
            var width = typeof size === 'number' ? size : size[0];
            var height = typeof size === 'number' ? size : size[1];
            var targetResolution = this.targetTileGrid_.getResolution(z);
            var sourceResolution = this.sourceTileGrid_.getResolution(this.sourceZ_);
            var targetExtent = this.targetTileGrid_.getTileCoordExtent(this.wrappedTileCoord_);
            this.canvas_ = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_5__["render"])(width, height, this.pixelRatio_, sourceResolution, this.sourceTileGrid_.getExtent(), targetResolution, targetExtent, this.triangulation_, sources, this.gutter_, this.renderEdges_, this.contextOptions_);
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED;
        }
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     */
    ReprojTile.prototype.load = function () {
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING;
            this.changed();
            var leftToLoad_1 = 0;
            this.sourcesListenerKeys_ = [];
            this.sourceTiles_.forEach(function (tile, i, arr) {
                var state = tile.getState();
                if (state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE || state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING) {
                    leftToLoad_1++;
                    var sourceListenKey_1 = Object(_events_js__WEBPACK_IMPORTED_MODULE_8__["listen"])(tile, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, function (e) {
                        var state = tile.getState();
                        if (state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED ||
                            state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR ||
                            state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY) {
                            Object(_events_js__WEBPACK_IMPORTED_MODULE_8__["unlistenByKey"])(sourceListenKey_1);
                            leftToLoad_1--;
                            if (leftToLoad_1 === 0) {
                                this.unlistenSources_();
                                this.reproject_();
                            }
                        }
                    }, this);
                    this.sourcesListenerKeys_.push(sourceListenKey_1);
                }
            }.bind(this));
            if (leftToLoad_1 === 0) {
                setTimeout(this.reproject_.bind(this), 0);
            }
            else {
                this.sourceTiles_.forEach(function (tile, i, arr) {
                    var state = tile.getState();
                    if (state == _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) {
                        tile.load();
                    }
                });
            }
        }
    };
    /**
     * @private
     */
    ReprojTile.prototype.unlistenSources_ = function () {
        this.sourcesListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_8__["unlistenByKey"]);
        this.sourcesListenerKeys_ = null;
    };
    return ReprojTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ReprojTile);
//# sourceMappingURL=Tile.js.map

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ERROR_THRESHOLD", function() { return ERROR_THRESHOLD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ENABLE_RASTER_REPROJECTION", function() { return ENABLE_RASTER_REPROJECTION; });
/**
 * @module ol/reproj/common
 */
/**
 * Default maximum allowed threshold  (in pixels) for reprojection
 * triangulation.
 * @type {number}
 */
var ERROR_THRESHOLD = 0.5;
/**
 * Enable automatic reprojection of raster sources. Default is `true`.
 * TODO: decide if we want to expose this as a build flag or remove it
 * @type {boolean}
 */
var ENABLE_RASTER_REPROJECTION = true;
//# sourceMappingURL=common.js.map

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11);
/**
 * @module ol/reproj/Triangulation
 */



/**
 * Single triangle; consists of 3 source points and 3 target points.
 * @typedef {Object} Triangle
 * @property {Array<import("../coordinate.js").Coordinate>} source Source.
 * @property {Array<import("../coordinate.js").Coordinate>} target Target.
 */
/**
 * Maximum number of subdivision steps during raster reprojection triangulation.
 * Prevents high memory usage and large number of proj4 calls (for certain
 * transformations and areas). At most `2*(2^this)` triangles are created for
 * each triangulated extent (tile/image).
 * @type {number}
 */
var MAX_SUBDIVISION = 10;
/**
 * Maximum allowed size of triangle relative to world width. When transforming
 * corners of world extent between certain projections, the resulting
 * triangulation seems to have zero error and no subdivision is performed. If
 * the triangle width is more than this (relative to world width; 0-1),
 * subdivison is forced (up to `MAX_SUBDIVISION`). Default is `0.25`.
 * @type {number}
 */
var MAX_TRIANGLE_WIDTH = 0.25;
/**
 * @classdesc
 * Class containing triangulation of the given target extent.
 * Used for determining source data and the reprojection itself.
 */
var Triangulation = /** @class */ (function () {
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection.
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../extent.js").Extent} targetExtent Target extent to triangulate.
     * @param {import("../extent.js").Extent} maxSourceExtent Maximal source extent that can be used.
     * @param {number} errorThreshold Acceptable error (in source units).
     * @param {?number} opt_destinationResolution The (optional) resolution of the destination.
     */
    function Triangulation(sourceProj, targetProj, targetExtent, maxSourceExtent, errorThreshold, opt_destinationResolution) {
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */
        this.sourceProj_ = sourceProj;
        /**
         * @type {import("../proj/Projection.js").default}
         * @private
         */
        this.targetProj_ = targetProj;
        /** @type {!Object<string, import("../coordinate.js").Coordinate>} */
        var transformInvCache = {};
        var transformInv = Object(_proj_js__WEBPACK_IMPORTED_MODULE_1__["getTransform"])(this.targetProj_, this.sourceProj_);
        /**
         * @param {import("../coordinate.js").Coordinate} c A coordinate.
         * @return {import("../coordinate.js").Coordinate} Transformed coordinate.
         * @private
         */
        this.transformInv_ = function (c) {
            var key = c[0] + '/' + c[1];
            if (!transformInvCache[key]) {
                transformInvCache[key] = transformInv(c);
            }
            return transformInvCache[key];
        };
        /**
         * @type {import("../extent.js").Extent}
         * @private
         */
        this.maxSourceExtent_ = maxSourceExtent;
        /**
         * @type {number}
         * @private
         */
        this.errorThresholdSquared_ = errorThreshold * errorThreshold;
        /**
         * @type {Array<Triangle>}
         * @private
         */
        this.triangles_ = [];
        /**
         * Indicates that the triangulation crosses edge of the source projection.
         * @type {boolean}
         * @private
         */
        this.wrapsXInSource_ = false;
        /**
         * @type {boolean}
         * @private
         */
        this.canWrapXInSource_ =
            this.sourceProj_.canWrapX() &&
                !!maxSourceExtent &&
                !!this.sourceProj_.getExtent() &&
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(maxSourceExtent) == Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(this.sourceProj_.getExtent());
        /**
         * @type {?number}
         * @private
         */
        this.sourceWorldWidth_ = this.sourceProj_.getExtent()
            ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(this.sourceProj_.getExtent())
            : null;
        /**
         * @type {?number}
         * @private
         */
        this.targetWorldWidth_ = this.targetProj_.getExtent()
            ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(this.targetProj_.getExtent())
            : null;
        var destinationTopLeft = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getTopLeft"])(targetExtent);
        var destinationTopRight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getTopRight"])(targetExtent);
        var destinationBottomRight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getBottomRight"])(targetExtent);
        var destinationBottomLeft = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getBottomLeft"])(targetExtent);
        var sourceTopLeft = this.transformInv_(destinationTopLeft);
        var sourceTopRight = this.transformInv_(destinationTopRight);
        var sourceBottomRight = this.transformInv_(destinationBottomRight);
        var sourceBottomLeft = this.transformInv_(destinationBottomLeft);
        /*
         * The maxSubdivision controls how many splittings of the target area can
         * be done. The idea here is to do a linear mapping of the target areas
         * but the actual overal reprojection (can be) extremely non-linear. The
         * default value of MAX_SUBDIVISION was chosen based on mapping a 256x256
         * tile size. However this function is also called to remap canvas rendered
         * layers which can be much larger. This calculation increases the maxSubdivision
         * value by the right factor so that each 256x256 pixel area has
         * MAX_SUBDIVISION divisions.
         */
        var maxSubdivision = MAX_SUBDIVISION +
            (opt_destinationResolution
                ? Math.max(0, Math.ceil(Object(_math_js__WEBPACK_IMPORTED_MODULE_2__["log2"])(Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getArea"])(targetExtent) /
                    (opt_destinationResolution *
                        opt_destinationResolution *
                        256 *
                        256))))
                : 0);
        this.addQuad_(destinationTopLeft, destinationTopRight, destinationBottomRight, destinationBottomLeft, sourceTopLeft, sourceTopRight, sourceBottomRight, sourceBottomLeft, maxSubdivision);
        if (this.wrapsXInSource_) {
            var leftBound_1 = Infinity;
            this.triangles_.forEach(function (triangle, i, arr) {
                leftBound_1 = Math.min(leftBound_1, triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]);
            });
            // Shift triangles to be as close to `leftBound` as possible
            // (if the distance is more than `worldWidth / 2` it can be closer.
            this.triangles_.forEach(function (triangle) {
                if (Math.max(triangle.source[0][0], triangle.source[1][0], triangle.source[2][0]) -
                    leftBound_1 >
                    this.sourceWorldWidth_ / 2) {
                    var newTriangle = [
                        [triangle.source[0][0], triangle.source[0][1]],
                        [triangle.source[1][0], triangle.source[1][1]],
                        [triangle.source[2][0], triangle.source[2][1]],
                    ];
                    if (newTriangle[0][0] - leftBound_1 > this.sourceWorldWidth_ / 2) {
                        newTriangle[0][0] -= this.sourceWorldWidth_;
                    }
                    if (newTriangle[1][0] - leftBound_1 > this.sourceWorldWidth_ / 2) {
                        newTriangle[1][0] -= this.sourceWorldWidth_;
                    }
                    if (newTriangle[2][0] - leftBound_1 > this.sourceWorldWidth_ / 2) {
                        newTriangle[2][0] -= this.sourceWorldWidth_;
                    }
                    // Rarely (if the extent contains both the dateline and prime meridian)
                    // the shift can in turn break some triangles.
                    // Detect this here and don't shift in such cases.
                    var minX = Math.min(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    var maxX = Math.max(newTriangle[0][0], newTriangle[1][0], newTriangle[2][0]);
                    if (maxX - minX < this.sourceWorldWidth_ / 2) {
                        triangle.source = newTriangle;
                    }
                }
            }.bind(this));
        }
        transformInvCache = {};
    }
    /**
     * Adds triangle to the triangulation.
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @private
     */
    Triangulation.prototype.addTriangle_ = function (a, b, c, aSrc, bSrc, cSrc) {
        this.triangles_.push({
            source: [aSrc, bSrc, cSrc],
            target: [a, b, c],
        });
    };
    /**
     * Adds quad (points in clock-wise order) to the triangulation
     * (and reprojects the vertices) if valid.
     * Performs quad subdivision if needed to increase precision.
     *
     * @param {import("../coordinate.js").Coordinate} a The target a coordinate.
     * @param {import("../coordinate.js").Coordinate} b The target b coordinate.
     * @param {import("../coordinate.js").Coordinate} c The target c coordinate.
     * @param {import("../coordinate.js").Coordinate} d The target d coordinate.
     * @param {import("../coordinate.js").Coordinate} aSrc The source a coordinate.
     * @param {import("../coordinate.js").Coordinate} bSrc The source b coordinate.
     * @param {import("../coordinate.js").Coordinate} cSrc The source c coordinate.
     * @param {import("../coordinate.js").Coordinate} dSrc The source d coordinate.
     * @param {number} maxSubdivision Maximal allowed subdivision of the quad.
     * @private
     */
    Triangulation.prototype.addQuad_ = function (a, b, c, d, aSrc, bSrc, cSrc, dSrc, maxSubdivision) {
        var sourceQuadExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["boundingExtent"])([aSrc, bSrc, cSrc, dSrc]);
        var sourceCoverageX = this.sourceWorldWidth_
            ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(sourceQuadExtent) / this.sourceWorldWidth_
            : null;
        var sourceWorldWidth = /** @type {number} */ (this.sourceWorldWidth_);
        // when the quad is wrapped in the source projection
        // it covers most of the projection extent, but not fully
        var wrapsX = this.sourceProj_.canWrapX() &&
            sourceCoverageX > 0.5 &&
            sourceCoverageX < 1;
        var needsSubdivision = false;
        if (maxSubdivision > 0) {
            if (this.targetProj_.isGlobal() && this.targetWorldWidth_) {
                var targetQuadExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["boundingExtent"])([a, b, c, d]);
                var targetCoverageX = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["getWidth"])(targetQuadExtent) / this.targetWorldWidth_;
                needsSubdivision =
                    targetCoverageX > MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
            if (!wrapsX && this.sourceProj_.isGlobal() && sourceCoverageX) {
                needsSubdivision =
                    sourceCoverageX > MAX_TRIANGLE_WIDTH || needsSubdivision;
            }
        }
        if (!needsSubdivision && this.maxSourceExtent_) {
            if (isFinite(sourceQuadExtent[0]) &&
                isFinite(sourceQuadExtent[1]) &&
                isFinite(sourceQuadExtent[2]) &&
                isFinite(sourceQuadExtent[3])) {
                if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["intersects"])(sourceQuadExtent, this.maxSourceExtent_)) {
                    // whole quad outside source projection extent -> ignore
                    return;
                }
            }
        }
        var isNotFinite = 0;
        if (!needsSubdivision) {
            if (!isFinite(aSrc[0]) ||
                !isFinite(aSrc[1]) ||
                !isFinite(bSrc[0]) ||
                !isFinite(bSrc[1]) ||
                !isFinite(cSrc[0]) ||
                !isFinite(cSrc[1]) ||
                !isFinite(dSrc[0]) ||
                !isFinite(dSrc[1])) {
                if (maxSubdivision > 0) {
                    needsSubdivision = true;
                }
                else {
                    // It might be the case that only 1 of the points is infinite. In this case
                    // we can draw a single triangle with the other three points
                    isNotFinite =
                        (!isFinite(aSrc[0]) || !isFinite(aSrc[1]) ? 8 : 0) +
                            (!isFinite(bSrc[0]) || !isFinite(bSrc[1]) ? 4 : 0) +
                            (!isFinite(cSrc[0]) || !isFinite(cSrc[1]) ? 2 : 0) +
                            (!isFinite(dSrc[0]) || !isFinite(dSrc[1]) ? 1 : 0);
                    if (isNotFinite != 1 &&
                        isNotFinite != 2 &&
                        isNotFinite != 4 &&
                        isNotFinite != 8) {
                        return;
                    }
                }
            }
        }
        if (maxSubdivision > 0) {
            if (!needsSubdivision) {
                var center = [(a[0] + c[0]) / 2, (a[1] + c[1]) / 2];
                var centerSrc = this.transformInv_(center);
                var dx = void 0;
                if (wrapsX) {
                    var centerSrcEstimX = (Object(_math_js__WEBPACK_IMPORTED_MODULE_2__["modulo"])(aSrc[0], sourceWorldWidth) +
                        Object(_math_js__WEBPACK_IMPORTED_MODULE_2__["modulo"])(cSrc[0], sourceWorldWidth)) /
                        2;
                    dx = centerSrcEstimX - Object(_math_js__WEBPACK_IMPORTED_MODULE_2__["modulo"])(centerSrc[0], sourceWorldWidth);
                }
                else {
                    dx = (aSrc[0] + cSrc[0]) / 2 - centerSrc[0];
                }
                var dy = (aSrc[1] + cSrc[1]) / 2 - centerSrc[1];
                var centerSrcErrorSquared = dx * dx + dy * dy;
                needsSubdivision = centerSrcErrorSquared > this.errorThresholdSquared_;
            }
            if (needsSubdivision) {
                if (Math.abs(a[0] - c[0]) <= Math.abs(a[1] - c[1])) {
                    // split horizontally (top & bottom)
                    var bc = [(b[0] + c[0]) / 2, (b[1] + c[1]) / 2];
                    var bcSrc = this.transformInv_(bc);
                    var da = [(d[0] + a[0]) / 2, (d[1] + a[1]) / 2];
                    var daSrc = this.transformInv_(da);
                    this.addQuad_(a, b, bc, da, aSrc, bSrc, bcSrc, daSrc, maxSubdivision - 1);
                    this.addQuad_(da, bc, c, d, daSrc, bcSrc, cSrc, dSrc, maxSubdivision - 1);
                }
                else {
                    // split vertically (left & right)
                    var ab = [(a[0] + b[0]) / 2, (a[1] + b[1]) / 2];
                    var abSrc = this.transformInv_(ab);
                    var cd = [(c[0] + d[0]) / 2, (c[1] + d[1]) / 2];
                    var cdSrc = this.transformInv_(cd);
                    this.addQuad_(a, ab, cd, d, aSrc, abSrc, cdSrc, dSrc, maxSubdivision - 1);
                    this.addQuad_(ab, b, c, cd, abSrc, bSrc, cSrc, cdSrc, maxSubdivision - 1);
                }
                return;
            }
        }
        if (wrapsX) {
            if (!this.canWrapXInSource_) {
                return;
            }
            this.wrapsXInSource_ = true;
        }
        // Exactly zero or one of *Src is not finite
        // The triangles must have the diagonal line as the first side
        // This is to allow easy code in reproj.s to make it straight for broken
        // browsers that can't handle diagonal clipping
        if ((isNotFinite & 0xb) == 0) {
            this.addTriangle_(a, c, d, aSrc, cSrc, dSrc);
        }
        if ((isNotFinite & 0xe) == 0) {
            this.addTriangle_(a, c, b, aSrc, cSrc, bSrc);
        }
        if (isNotFinite) {
            // Try the other two triangles
            if ((isNotFinite & 0xd) == 0) {
                this.addTriangle_(b, d, a, bSrc, dSrc, aSrc);
            }
            if ((isNotFinite & 0x7) == 0) {
                this.addTriangle_(b, d, c, bSrc, dSrc, cSrc);
            }
        }
    };
    /**
     * Calculates extent of the 'source' coordinates from all the triangles.
     *
     * @return {import("../extent.js").Extent} Calculated extent.
     */
    Triangulation.prototype.calculateSourceExtent = function () {
        var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["createEmpty"])();
        this.triangles_.forEach(function (triangle, i, arr) {
            var src = triangle.source;
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["extendCoordinate"])(extent, src[0]);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["extendCoordinate"])(extent, src[1]);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["extendCoordinate"])(extent, src[2]);
        });
        return extent;
    };
    /**
     * @return {Array<Triangle>} Array of the calculated triangles.
     */
    Triangulation.prototype.getTriangles = function () {
        return this.triangles_;
    };
    return Triangulation;
}());
/* harmony default export */ __webpack_exports__["default"] = (Triangulation);
//# sourceMappingURL=Triangulation.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateSourceResolution", function() { return calculateSourceResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "calculateSourceExtentResolution", function() { return calculateSourceExtentResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return render; });
/* harmony import */ var _source_common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11);
/**
 * @module ol/reproj
 */






var brokenDiagonalRendering_;
/**
 * This draws a small triangle into a canvas by setting the triangle as the clip region
 * and then drawing a (too large) rectangle
 *
 * @param {CanvasRenderingContext2D} ctx The context in which to draw the triangle
 * @param {number} u1 The x-coordinate of the second point. The first point is 0,0.
 * @param {number} v1 The y-coordinate of the second point.
 * @param {number} u2 The x-coordinate of the third point.
 * @param {number} v2 The y-coordinate of the third point.
 */
function drawTestTriangle(ctx, u1, v1, u2, v2) {
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(u1, v1);
    ctx.lineTo(u2, v2);
    ctx.closePath();
    ctx.save();
    ctx.clip();
    ctx.fillRect(0, 0, Math.max(u1, u2) + 1, Math.max(v1, v2));
    ctx.restore();
}
/**
 * Given the data from getImageData, see if the right values appear at the provided offset.
 * Returns true if either the color or transparency is off
 *
 * @param {Uint8ClampedArray} data The data returned from getImageData
 * @param {number} offset The pixel offset from the start of data.
 * @return {boolean} true if the diagonal rendering is broken
 */
function verifyBrokenDiagonalRendering(data, offset) {
    // the values ought to be close to the rgba(210, 0, 0, 0.75)
    return (Math.abs(data[offset * 4] - 210) > 2 ||
        Math.abs(data[offset * 4 + 3] - 0.75 * 255) > 2);
}
/**
 * Determines if the current browser configuration can render triangular clip regions correctly.
 * This value is cached so the function is only expensive the first time called.
 * Firefox on Windows (as of now) does not if HWA is enabled. See https://bugzilla.mozilla.org/show_bug.cgi?id=1606976
 * IE also doesn't. Chrome works, and everything seems to work on OSX and Android. This function caches the
 * result. I suppose that it is conceivably possible that a browser might flip modes while the app is
 * running, but lets hope not.
 *
 * @return {boolean} true if the Diagonal Rendering is broken.
 */
function isBrokenDiagonalRendering() {
    if (brokenDiagonalRendering_ === undefined) {
        var ctx = document.createElement('canvas').getContext('2d');
        ctx.globalCompositeOperation = 'lighter';
        ctx.fillStyle = 'rgba(210, 0, 0, 0.75)';
        drawTestTriangle(ctx, 4, 5, 4, 0);
        drawTestTriangle(ctx, 4, 5, 0, 5);
        var data = ctx.getImageData(0, 0, 3, 3).data;
        brokenDiagonalRendering_ =
            verifyBrokenDiagonalRendering(data, 0) ||
                verifyBrokenDiagonalRendering(data, 4) ||
                verifyBrokenDiagonalRendering(data, 8);
    }
    return brokenDiagonalRendering_;
}
/**
 * Calculates ideal resolution to use from the source in order to achieve
 * pixel mapping as close as possible to 1:1 during reprojection.
 * The resolution is calculated regardless of what resolutions
 * are actually available in the dataset (TileGrid, Image, ...).
 *
 * @param {import("./proj/Projection.js").default} sourceProj Source projection.
 * @param {import("./proj/Projection.js").default} targetProj Target projection.
 * @param {import("./coordinate.js").Coordinate} targetCenter Target center.
 * @param {number} targetResolution Target resolution.
 * @return {number} The best resolution to use. Can be +-Infinity, NaN or 0.
 */
function calculateSourceResolution(sourceProj, targetProj, targetCenter, targetResolution) {
    var sourceCenter = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["transform"])(targetCenter, targetProj, sourceProj);
    // calculate the ideal resolution of the source data
    var sourceResolution = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["getPointResolution"])(targetProj, targetResolution, targetCenter);
    var targetMetersPerUnit = targetProj.getMetersPerUnit();
    if (targetMetersPerUnit !== undefined) {
        sourceResolution *= targetMetersPerUnit;
    }
    var sourceMetersPerUnit = sourceProj.getMetersPerUnit();
    if (sourceMetersPerUnit !== undefined) {
        sourceResolution /= sourceMetersPerUnit;
    }
    // Based on the projection properties, the point resolution at the specified
    // coordinates may be slightly different. We need to reverse-compensate this
    // in order to achieve optimal results.
    var sourceExtent = sourceProj.getExtent();
    if (!sourceExtent || Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["containsCoordinate"])(sourceExtent, sourceCenter)) {
        var compensationFactor = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["getPointResolution"])(sourceProj, sourceResolution, sourceCenter) /
            sourceResolution;
        if (isFinite(compensationFactor) && compensationFactor > 0) {
            sourceResolution /= compensationFactor;
        }
    }
    return sourceResolution;
}
/**
 * Calculates ideal resolution to use from the source in order to achieve
 * pixel mapping as close as possible to 1:1 during reprojection.
 * The resolution is calculated regardless of what resolutions
 * are actually available in the dataset (TileGrid, Image, ...).
 *
 * @param {import("./proj/Projection.js").default} sourceProj Source projection.
 * @param {import("./proj/Projection.js").default} targetProj Target projection.
 * @param {import("./extent.js").Extent} targetExtent Target extent
 * @param {number} targetResolution Target resolution.
 * @return {number} The best resolution to use. Can be +-Infinity, NaN or 0.
 */
function calculateSourceExtentResolution(sourceProj, targetProj, targetExtent, targetResolution) {
    var targetCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getCenter"])(targetExtent);
    var sourceResolution = calculateSourceResolution(sourceProj, targetProj, targetCenter, targetResolution);
    if (!isFinite(sourceResolution) || sourceResolution <= 0) {
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["forEachCorner"])(targetExtent, function (corner) {
            sourceResolution = calculateSourceResolution(sourceProj, targetProj, corner, targetResolution);
            return isFinite(sourceResolution) && sourceResolution > 0;
        });
    }
    return sourceResolution;
}
/**
 * @typedef {Object} ImageExtent
 * @property {import("./extent.js").Extent} extent Extent.
 * @property {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} image Image.
 */
/**
 * Renders the source data into new canvas based on the triangulation.
 *
 * @param {number} width Width of the canvas.
 * @param {number} height Height of the canvas.
 * @param {number} pixelRatio Pixel ratio.
 * @param {number} sourceResolution Source resolution.
 * @param {import("./extent.js").Extent} sourceExtent Extent of the data source.
 * @param {number} targetResolution Target resolution.
 * @param {import("./extent.js").Extent} targetExtent Target extent.
 * @param {import("./reproj/Triangulation.js").default} triangulation Calculated triangulation.
 * @param {Array<ImageExtent>} sources Array of sources.
 * @param {number} gutter Gutter of the sources.
 * @param {boolean} [opt_renderEdges] Render reprojection edges.
 * @param {object} [opt_contextOptions] Properties to set on the canvas context.
 * @return {HTMLCanvasElement} Canvas with reprojected data.
 */
function render(width, height, pixelRatio, sourceResolution, sourceExtent, targetResolution, targetExtent, triangulation, sources, gutter, opt_renderEdges, opt_contextOptions) {
    var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_3__["createCanvasContext2D"])(Math.round(pixelRatio * width), Math.round(pixelRatio * height));
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_1__["assign"])(context, opt_contextOptions);
    if (sources.length === 0) {
        return context.canvas;
    }
    context.scale(pixelRatio, pixelRatio);
    function pixelRound(value) {
        return Math.round(value * pixelRatio) / pixelRatio;
    }
    context.globalCompositeOperation = 'lighter';
    var sourceDataExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createEmpty"])();
    sources.forEach(function (src, i, arr) {
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["extend"])(sourceDataExtent, src.extent);
    });
    var canvasWidthInUnits = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getWidth"])(sourceDataExtent);
    var canvasHeightInUnits = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getHeight"])(sourceDataExtent);
    var stitchContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_3__["createCanvasContext2D"])(Math.round((pixelRatio * canvasWidthInUnits) / sourceResolution), Math.round((pixelRatio * canvasHeightInUnits) / sourceResolution));
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_1__["assign"])(stitchContext, opt_contextOptions);
    var stitchScale = pixelRatio / sourceResolution;
    sources.forEach(function (src, i, arr) {
        var xPos = src.extent[0] - sourceDataExtent[0];
        var yPos = -(src.extent[3] - sourceDataExtent[3]);
        var srcWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getWidth"])(src.extent);
        var srcHeight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getHeight"])(src.extent);
        // This test should never fail -- but it does. Need to find a fix the upstream condition
        if (src.image.width > 0 && src.image.height > 0) {
            stitchContext.drawImage(src.image, gutter, gutter, src.image.width - 2 * gutter, src.image.height - 2 * gutter, xPos * stitchScale, yPos * stitchScale, srcWidth * stitchScale, srcHeight * stitchScale);
        }
    });
    var targetTopLeft = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getTopLeft"])(targetExtent);
    triangulation.getTriangles().forEach(function (triangle, i, arr) {
        /* Calculate affine transform (src -> dst)
         * Resulting matrix can be used to transform coordinate
         * from `sourceProjection` to destination pixels.
         *
         * To optimize number of context calls and increase numerical stability,
         * we also do the following operations:
         * trans(-topLeftExtentCorner), scale(1 / targetResolution), scale(1, -1)
         * here before solving the linear system so [ui, vi] are pixel coordinates.
         *
         * Src points: xi, yi
         * Dst points: ui, vi
         * Affine coefficients: aij
         *
         * | x0 y0 1  0  0 0 |   |a00|   |u0|
         * | x1 y1 1  0  0 0 |   |a01|   |u1|
         * | x2 y2 1  0  0 0 | x |a02| = |u2|
         * |  0  0 0 x0 y0 1 |   |a10|   |v0|
         * |  0  0 0 x1 y1 1 |   |a11|   |v1|
         * |  0  0 0 x2 y2 1 |   |a12|   |v2|
         */
        var source = triangle.source;
        var target = triangle.target;
        var x0 = source[0][0], y0 = source[0][1];
        var x1 = source[1][0], y1 = source[1][1];
        var x2 = source[2][0], y2 = source[2][1];
        // Make sure that everything is on pixel boundaries
        var u0 = pixelRound((target[0][0] - targetTopLeft[0]) / targetResolution);
        var v0 = pixelRound(-(target[0][1] - targetTopLeft[1]) / targetResolution);
        var u1 = pixelRound((target[1][0] - targetTopLeft[0]) / targetResolution);
        var v1 = pixelRound(-(target[1][1] - targetTopLeft[1]) / targetResolution);
        var u2 = pixelRound((target[2][0] - targetTopLeft[0]) / targetResolution);
        var v2 = pixelRound(-(target[2][1] - targetTopLeft[1]) / targetResolution);
        // Shift all the source points to improve numerical stability
        // of all the subsequent calculations. The [x0, y0] is used here.
        // This is also used to simplify the linear system.
        var sourceNumericalShiftX = x0;
        var sourceNumericalShiftY = y0;
        x0 = 0;
        y0 = 0;
        x1 -= sourceNumericalShiftX;
        y1 -= sourceNumericalShiftY;
        x2 -= sourceNumericalShiftX;
        y2 -= sourceNumericalShiftY;
        var augmentedMatrix = [
            [x1, y1, 0, 0, u1 - u0],
            [x2, y2, 0, 0, u2 - u0],
            [0, 0, x1, y1, v1 - v0],
            [0, 0, x2, y2, v2 - v0],
        ];
        var affineCoefs = Object(_math_js__WEBPACK_IMPORTED_MODULE_5__["solveLinearSystem"])(augmentedMatrix);
        if (!affineCoefs) {
            return;
        }
        context.save();
        context.beginPath();
        if (isBrokenDiagonalRendering() ||
            opt_contextOptions === _source_common_js__WEBPACK_IMPORTED_MODULE_0__["IMAGE_SMOOTHING_DISABLED"]) {
            // Make sure that all lines are horizontal or vertical
            context.moveTo(u1, v1);
            // This is the diagonal line. Do it in 4 steps
            var steps = 4;
            var ud = u0 - u1;
            var vd = v0 - v1;
            for (var step = 0; step < steps; step++) {
                // Go horizontally
                context.lineTo(u1 + pixelRound(((step + 1) * ud) / steps), v1 + pixelRound((step * vd) / (steps - 1)));
                // Go vertically
                if (step != steps - 1) {
                    context.lineTo(u1 + pixelRound(((step + 1) * ud) / steps), v1 + pixelRound(((step + 1) * vd) / (steps - 1)));
                }
            }
            // We are almost at u0r, v0r
            context.lineTo(u2, v2);
        }
        else {
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
        }
        context.clip();
        context.transform(affineCoefs[0], affineCoefs[2], affineCoefs[1], affineCoefs[3], u0, v0);
        context.translate(sourceDataExtent[0] - sourceNumericalShiftX, sourceDataExtent[3] - sourceNumericalShiftY);
        context.scale(sourceResolution / pixelRatio, -sourceResolution / pixelRatio);
        context.drawImage(stitchContext.canvas, 0, 0);
        context.restore();
    });
    if (opt_renderEdges) {
        context.save();
        context.globalCompositeOperation = 'source-over';
        context.strokeStyle = 'black';
        context.lineWidth = 1;
        triangulation.getTriangles().forEach(function (triangle, i, arr) {
            var target = triangle.target;
            var u0 = (target[0][0] - targetTopLeft[0]) / targetResolution;
            var v0 = -(target[0][1] - targetTopLeft[1]) / targetResolution;
            var u1 = (target[1][0] - targetTopLeft[0]) / targetResolution;
            var v1 = -(target[1][1] - targetTopLeft[1]) / targetResolution;
            var u2 = (target[2][0] - targetTopLeft[0]) / targetResolution;
            var v2 = -(target[2][1] - targetTopLeft[1]) / targetResolution;
            context.beginPath();
            context.moveTo(u1, v1);
            context.lineTo(u0, v0);
            context.lineTo(u2, v2);
            context.closePath();
            context.stroke();
        });
        context.restore();
    }
    return context.canvas;
}
//# sourceMappingURL=reproj.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_WMS_VERSION", function() { return DEFAULT_WMS_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGE_SMOOTHING_DISABLED", function() { return IMAGE_SMOOTHING_DISABLED; });
/**
 * @module ol/source/common
 */
/**
 * Default WMS version.
 * @type {string}
 */
var DEFAULT_WMS_VERSION = '1.3.0';
/**
 * Context options to disable image smoothing.
 * @type {Object}
 */
var IMAGE_SMOOTHING_DISABLED = {
    imageSmoothingEnabled: false,
    msImageSmoothingEnabled: false,
};
//# sourceMappingURL=common.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _structs_LRUCache_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/TileCache
 */


var TileCache = /** @class */ (function (_super) {
    __extends(TileCache, _super);
    function TileCache() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */
    TileCache.prototype.expireCache = function (usedTiles) {
        while (this.canExpireCache()) {
            var tile = this.peekLast();
            if (tile.getKey() in usedTiles) {
                break;
            }
            else {
                this.pop().release();
            }
        }
    };
    /**
     * Prune all tiles from the cache that don't have the same z as the newest tile.
     */
    TileCache.prototype.pruneExceptNewestZ = function () {
        if (this.getCount() === 0) {
            return;
        }
        var key = this.peekFirstKey();
        var tileCoord = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_1__["fromKey"])(key);
        var z = tileCoord[0];
        this.forEach(function (tile) {
            if (tile.tileCoord[0] !== z) {
                this.remove(Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_1__["getKey"])(tile.tileCoord));
                tile.release();
            }
        }.bind(this));
    };
    return TileCache;
}(_structs_LRUCache_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileCache);
//# sourceMappingURL=TileCache.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/**
 * @module ol/structs/LRUCache
 */

/**
 * @typedef {Object} Entry
 * @property {string} key_ Key.
 * @property {Object} newer Newer.
 * @property {Object} older Older.
 * @property {*} value_ Value.
 */
/**
 * @classdesc
 * Implements a Least-Recently-Used cache where the keys do not conflict with
 * Object's properties (e.g. 'hasOwnProperty' is not allowed as a key). Expiring
 * items from the cache is the responsibility of the user.
 *
 * @fires import("../events/Event.js").default
 * @template T
 */
var LRUCache = /** @class */ (function () {
    /**
     * @param {number} [opt_highWaterMark] High water mark.
     */
    function LRUCache(opt_highWaterMark) {
        /**
         * Desired max cache size after expireCache(). If set to 0, no cache entries
         * will be pruned at all.
         * @type {number}
         */
        this.highWaterMark =
            opt_highWaterMark !== undefined ? opt_highWaterMark : 2048;
        /**
         * @private
         * @type {number}
         */
        this.count_ = 0;
        /**
         * @private
         * @type {!Object<string, Entry>}
         */
        this.entries_ = {};
        /**
         * @private
         * @type {?Entry}
         */
        this.oldest_ = null;
        /**
         * @private
         * @type {?Entry}
         */
        this.newest_ = null;
    }
    /**
     * @return {boolean} Can expire cache.
     */
    LRUCache.prototype.canExpireCache = function () {
        return this.highWaterMark > 0 && this.getCount() > this.highWaterMark;
    };
    /**
     * FIXME empty description for jsdoc
     */
    LRUCache.prototype.clear = function () {
        this.count_ = 0;
        this.entries_ = {};
        this.oldest_ = null;
        this.newest_ = null;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Contains key.
     */
    LRUCache.prototype.containsKey = function (key) {
        return this.entries_.hasOwnProperty(key);
    };
    /**
     * @param {function(T, string, LRUCache<T>): ?} f The function
     *     to call for every entry from the oldest to the newer. This function takes
     *     3 arguments (the entry value, the entry key and the LRUCache object).
     *     The return value is ignored.
     */
    LRUCache.prototype.forEach = function (f) {
        var entry = this.oldest_;
        while (entry) {
            f(entry.value_, entry.key_, this);
            entry = entry.newer;
        }
    };
    /**
     * @param {string} key Key.
     * @param {*} [opt_options] Options (reserved for subclasses).
     * @return {T} Value.
     */
    LRUCache.prototype.get = function (key, opt_options) {
        var entry = this.entries_[key];
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) {
            return entry.value_;
        }
        else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ (this.oldest_.newer);
            this.oldest_.older = null;
        }
        else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        entry.newer = null;
        entry.older = this.newest_;
        this.newest_.newer = entry;
        this.newest_ = entry;
        return entry.value_;
    };
    /**
     * Remove an entry from the cache.
     * @param {string} key The entry key.
     * @return {T} The removed entry.
     */
    LRUCache.prototype.remove = function (key) {
        var entry = this.entries_[key];
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(entry !== undefined, 15); // Tried to get a value for a key that does not exist in the cache
        if (entry === this.newest_) {
            this.newest_ = /** @type {Entry} */ (entry.older);
            if (this.newest_) {
                this.newest_.newer = null;
            }
        }
        else if (entry === this.oldest_) {
            this.oldest_ = /** @type {Entry} */ (entry.newer);
            if (this.oldest_) {
                this.oldest_.older = null;
            }
        }
        else {
            entry.newer.older = entry.older;
            entry.older.newer = entry.newer;
        }
        delete this.entries_[key];
        --this.count_;
        return entry.value_;
    };
    /**
     * @return {number} Count.
     */
    LRUCache.prototype.getCount = function () {
        return this.count_;
    };
    /**
     * @return {Array<string>} Keys.
     */
    LRUCache.prototype.getKeys = function () {
        var keys = new Array(this.count_);
        var i = 0;
        var entry;
        for (entry = this.newest_; entry; entry = entry.older) {
            keys[i++] = entry.key_;
        }
        return keys;
    };
    /**
     * @return {Array<T>} Values.
     */
    LRUCache.prototype.getValues = function () {
        var values = new Array(this.count_);
        var i = 0;
        var entry;
        for (entry = this.newest_; entry; entry = entry.older) {
            values[i++] = entry.value_;
        }
        return values;
    };
    /**
     * @return {T} Last value.
     */
    LRUCache.prototype.peekLast = function () {
        return this.oldest_.value_;
    };
    /**
     * @return {string} Last key.
     */
    LRUCache.prototype.peekLastKey = function () {
        return this.oldest_.key_;
    };
    /**
     * Get the key of the newest item in the cache.  Throws if the cache is empty.
     * @return {string} The newest key.
     */
    LRUCache.prototype.peekFirstKey = function () {
        return this.newest_.key_;
    };
    /**
     * @return {T} value Value.
     */
    LRUCache.prototype.pop = function () {
        var entry = this.oldest_;
        delete this.entries_[entry.key_];
        if (entry.newer) {
            entry.newer.older = null;
        }
        this.oldest_ = /** @type {Entry} */ (entry.newer);
        if (!this.oldest_) {
            this.newest_ = null;
        }
        --this.count_;
        return entry.value_;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */
    LRUCache.prototype.replace = function (key, value) {
        this.get(key); // update `newest_`
        this.entries_[key].value_ = value;
    };
    /**
     * @param {string} key Key.
     * @param {T} value Value.
     */
    LRUCache.prototype.set = function (key, value) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(!(key in this.entries_), 16); // Tried to set a value for a key that is used already
        var entry = {
            key_: key,
            newer: null,
            older: this.newest_,
            value_: value,
        };
        if (!this.newest_) {
            this.oldest_ = entry;
        }
        else {
            this.newest_.newer = entry;
        }
        this.newest_ = entry;
        this.entries_[key] = entry;
        ++this.count_;
    };
    /**
     * Set a maximum number of entries for the cache.
     * @param {number} size Cache size.
     * @api
     */
    LRUCache.prototype.setSize = function (size) {
        this.highWaterMark = size;
    };
    return LRUCache;
}());
/* harmony default export */ __webpack_exports__["default"] = (LRUCache);
//# sourceMappingURL=LRUCache.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdate", function() { return createOrUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getKeyZXY", function() { return getKeyZXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getKey", function() { return getKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCacheKeyForTileKey", function() { return getCacheKeyForTileKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromKey", function() { return fromKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hash", function() { return hash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withinExtentAndZ", function() { return withinExtentAndZ; });
/**
 * @module ol/tilecoord
 */
/**
 * An array of three numbers representing the location of a tile in a tile
 * grid. The order is `z` (zoom level), `x` (column), and `y` (row).
 * @typedef {Array<number>} TileCoord
 * @api
 */
/**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {TileCoord} [opt_tileCoord] Tile coordinate.
 * @return {TileCoord} Tile coordinate.
 */
function createOrUpdate(z, x, y, opt_tileCoord) {
    if (opt_tileCoord !== undefined) {
        opt_tileCoord[0] = z;
        opt_tileCoord[1] = x;
        opt_tileCoord[2] = y;
        return opt_tileCoord;
    }
    else {
        return [z, x, y];
    }
}
/**
 * @param {number} z Z.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {string} Key.
 */
function getKeyZXY(z, x, y) {
    return z + '/' + x + '/' + y;
}
/**
 * Get the key for a tile coord.
 * @param {TileCoord} tileCoord The tile coord.
 * @return {string} Key.
 */
function getKey(tileCoord) {
    return getKeyZXY(tileCoord[0], tileCoord[1], tileCoord[2]);
}
/**
 * Get the tile cache key for a tile key obtained through `tile.getKey()`.
 * @param {string} tileKey The tile key.
 * @return {string} The cache key.
 */
function getCacheKeyForTileKey(tileKey) {
    var _a = tileKey
        .substring(tileKey.lastIndexOf('/') + 1, tileKey.length)
        .split(',')
        .map(Number), z = _a[0], x = _a[1], y = _a[2];
    return getKeyZXY(z, x, y);
}
/**
 * Get a tile coord given a key.
 * @param {string} key The tile coord key.
 * @return {TileCoord} The tile coord.
 */
function fromKey(key) {
    return key.split('/').map(Number);
}
/**
 * @param {TileCoord} tileCoord Tile coord.
 * @return {number} Hash.
 */
function hash(tileCoord) {
    return (tileCoord[1] << tileCoord[0]) + tileCoord[2];
}
/**
 * @param {TileCoord} tileCoord Tile coordinate.
 * @param {!import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {boolean} Tile coordinate is within extent and zoom level range.
 */
function withinExtentAndZ(tileCoord, tileGrid) {
    var z = tileCoord[0];
    var x = tileCoord[1];
    var y = tileCoord[2];
    if (tileGrid.getMinZoom() > z || z > tileGrid.getMaxZoom()) {
        return false;
    }
    var tileRange = tileGrid.getFullTileRange(z);
    if (!tileRange) {
        return true;
    }
    else {
        return tileRange.containsXY(x, y);
    }
}
//# sourceMappingURL=tilecoord.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileEventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/UrlTile
 */






/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Cache size.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./State.js").default} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {import("../Tile.js").LoadFunction} tileLoadFunction TileLoadFunction.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] TileUrlFunction.
 * @property {string} [url] Url.
 * @property {Array<string>} [urls] Urls.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 */
/**
 * @classdesc
 * Base class for sources providing tiles divided into a tile grid over http.
 *
 * @fires import("./Tile.js").TileSourceEvent
 */
var UrlTile = /** @class */ (function (_super) {
    __extends(UrlTile, _super);
    /**
     * @param {Options} options Image tile options.
     */
    function UrlTile(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            opaque: options.opaque,
            projection: options.projection,
            state: options.state,
            tileGrid: options.tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            wrapX: options.wrapX,
            transition: options.transition,
            key: options.key,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.generateTileUrlFunction_ =
            _this.tileUrlFunction === UrlTile.prototype.tileUrlFunction;
        /**
         * @protected
         * @type {import("../Tile.js").LoadFunction}
         */
        _this.tileLoadFunction = options.tileLoadFunction;
        if (options.tileUrlFunction) {
            _this.tileUrlFunction = options.tileUrlFunction;
        }
        /**
         * @protected
         * @type {!Array<string>|null}
         */
        _this.urls = null;
        if (options.urls) {
            _this.setUrls(options.urls);
        }
        else if (options.url) {
            _this.setUrl(options.url);
        }
        /**
         * @private
         * @type {!Object<string, boolean>}
         */
        _this.tileLoadingKeys_ = {};
        return _this;
    }
    /**
     * Return the tile load function of the source.
     * @return {import("../Tile.js").LoadFunction} TileLoadFunction
     * @api
     */
    UrlTile.prototype.getTileLoadFunction = function () {
        return this.tileLoadFunction;
    };
    /**
     * Return the tile URL function of the source.
     * @return {import("../Tile.js").UrlFunction} TileUrlFunction
     * @api
     */
    UrlTile.prototype.getTileUrlFunction = function () {
        return Object.getPrototypeOf(this).tileUrlFunction === this.tileUrlFunction
            ? this.tileUrlFunction.bind(this)
            : this.tileUrlFunction;
    };
    /**
     * Return the URLs used for this source.
     * When a tileUrlFunction is used instead of url or urls,
     * null will be returned.
     * @return {!Array<string>|null} URLs.
     * @api
     */
    UrlTile.prototype.getUrls = function () {
        return this.urls;
    };
    /**
     * Handle tile change events.
     * @param {import("../events/Event.js").default} event Event.
     * @protected
     */
    UrlTile.prototype.handleTileChange = function (event) {
        var tile = /** @type {import("../Tile.js").default} */ (event.target);
        var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_5__["getUid"])(tile);
        var tileState = tile.getState();
        var type;
        if (tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADING) {
            this.tileLoadingKeys_[uid] = true;
            type = _TileEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TILELOADSTART;
        }
        else if (uid in this.tileLoadingKeys_) {
            delete this.tileLoadingKeys_[uid];
            type =
                tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR
                    ? _TileEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TILELOADERROR
                    : tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED
                        ? _TileEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TILELOADEND
                        : undefined;
        }
        if (type != undefined) {
            this.dispatchEvent(new _Tile_js__WEBPACK_IMPORTED_MODULE_1__["TileSourceEvent"](type, tile));
        }
    };
    /**
     * Set the tile load function of the source.
     * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @api
     */
    UrlTile.prototype.setTileLoadFunction = function (tileLoadFunction) {
        this.tileCache.clear();
        this.tileLoadFunction = tileLoadFunction;
        this.changed();
    };
    /**
     * Set the tile URL function of the source.
     * @param {import("../Tile.js").UrlFunction} tileUrlFunction Tile URL function.
     * @param {string} [key] Optional new tile key for the source.
     * @api
     */
    UrlTile.prototype.setTileUrlFunction = function (tileUrlFunction, key) {
        this.tileUrlFunction = tileUrlFunction;
        this.tileCache.pruneExceptNewestZ();
        if (typeof key !== 'undefined') {
            this.setKey(key);
        }
        else {
            this.changed();
        }
    };
    /**
     * Set the URL to use for requests.
     * @param {string} url URL.
     * @api
     */
    UrlTile.prototype.setUrl = function (url) {
        var urls = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_3__["expandUrl"])(url);
        this.urls = urls;
        this.setUrls(urls);
    };
    /**
     * Set the URLs to use for requests.
     * @param {Array<string>} urls URLs.
     * @api
     */
    UrlTile.prototype.setUrls = function (urls) {
        this.urls = urls;
        var key = urls.join('\n');
        if (this.generateTileUrlFunction_) {
            this.setTileUrlFunction(Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_3__["createFromTemplates"])(urls, this.tileGrid), key);
        }
        else {
            this.setKey(key);
        }
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    UrlTile.prototype.tileUrlFunction = function (tileCoord, pixelRatio, projection) {
        return undefined;
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     */
    UrlTile.prototype.useTile = function (z, x, y) {
        var tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_4__["getKeyZXY"])(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) {
            this.tileCache.get(tileCoordKey);
        }
    };
    return UrlTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (UrlTile);
//# sourceMappingURL=UrlTile.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/source/TileEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered when a tile starts loading.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadstart
     * @api
     */
    TILELOADSTART: 'tileloadstart',
    /**
     * Triggered when a tile finishes loading, either when its data is loaded,
     * or when loading was aborted because the tile is no longer needed.
     * @event module:ol/source/Tile.TileSourceEvent#tileloadend
     * @api
     */
    TILELOADEND: 'tileloadend',
    /**
     * Triggered if tile loading results in an error.
     * @event module:ol/source/Tile.TileSourceEvent#tileloaderror
     * @api
     */
    TILELOADERROR: 'tileloaderror',
});
/**
 * @typedef {'tileloadstart'|'tileloadend'|'tileloaderror'} TileSourceEventTypes
 */
//# sourceMappingURL=TileEventType.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TileSourceEvent", function() { return TileSourceEvent; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _Source_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87);
/* harmony import */ var _TileCache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(83);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/Tile
 */










/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./TileEventType").TileSourceEventTypes, TileSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./TileEventType").TileSourceEventTypes, Return>} TileSourceOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] CacheSize.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {number} [tilePixelRatio] TilePixelRatio.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {import("./State.js").default} [state] State.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] TileGrid.
 * @property {boolean} [wrapX=true] WrapX.
 * @property {number} [transition] Transition.
 * @property {string} [key] Key.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0] ZDirection.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing images divided into a tile grid.
 * @abstract
 * @api
 */
var TileSource = /** @class */ (function (_super) {
    __extends(TileSource, _super);
    /**
     * @param {Options} options SourceTile source options.
     */
    function TileSource(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            projection: options.projection,
            state: options.state,
            wrapX: options.wrapX,
        }) || this;
        /***
         * @type {TileSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {TileSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {TileSourceOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {boolean}
         */
        _this.opaque_ = options.opaque !== undefined ? options.opaque : false;
        /**
         * @private
         * @type {number}
         */
        _this.tilePixelRatio_ =
            options.tilePixelRatio !== undefined ? options.tilePixelRatio : 1;
        /**
         * @protected
         * @type {import("../tilegrid/TileGrid.js").default}
         */
        _this.tileGrid = options.tileGrid !== undefined ? options.tileGrid : null;
        var tileSize = [256, 256];
        var tileGrid = options.tileGrid;
        if (tileGrid) {
            Object(_size_js__WEBPACK_IMPORTED_MODULE_9__["toSize"])(tileGrid.getTileSize(tileGrid.getMinZoom()), tileSize);
        }
        /**
         * @protected
         * @type {import("../TileCache.js").default}
         */
        _this.tileCache = new _TileCache_js__WEBPACK_IMPORTED_MODULE_2__["default"](options.cacheSize || 0);
        /**
         * @protected
         * @type {import("../size.js").Size}
         */
        _this.tmpSize = [0, 0];
        /**
         * @private
         * @type {string}
         */
        _this.key_ = options.key || '';
        /**
         * @protected
         * @type {import("../Tile.js").Options}
         */
        _this.tileOptions = { transition: options.transition };
        /**
         * zDirection hint, read by the renderer. Indicates which resolution should be used
         * by a renderer if the views resolution does not match any resolution of the tile source.
         * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
         * will be used. If -1, the nearest higher resolution will be used.
         * @type {number|import("../array.js").NearestDirectionFunction}
         */
        _this.zDirection = options.zDirection ? options.zDirection : 0;
        return _this;
    }
    /**
     * @return {boolean} Can expire cache.
     */
    TileSource.prototype.canExpireCache = function () {
        return this.tileCache.canExpireCache();
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */
    TileSource.prototype.expireCache = function (projection, usedTiles) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCache) {
            tileCache.expireCache(usedTiles);
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {number} z Zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {function(import("../Tile.js").default):(boolean|void)} callback Called with each
     *     loaded tile.  If the callback returns `false`, the tile will not be
     *     considered loaded.
     * @return {boolean} The tile range is fully covered with loaded tiles.
     */
    TileSource.prototype.forEachLoadedTile = function (projection, z, tileRange, callback) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (!tileCache) {
            return false;
        }
        var covered = true;
        var tile, tileCoordKey, loaded;
        for (var x = tileRange.minX; x <= tileRange.maxX; ++x) {
            for (var y = tileRange.minY; y <= tileRange.maxY; ++y) {
                tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_7__["getKeyZXY"])(z, x, y);
                loaded = false;
                if (tileCache.containsKey(tileCoordKey)) {
                    tile = /** @type {!import("../Tile.js").default} */ (tileCache.get(tileCoordKey));
                    loaded = tile.getState() === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED;
                    if (loaded) {
                        loaded = callback(tile) !== false;
                    }
                }
                if (!loaded) {
                    covered = false;
                }
            }
        }
        return covered;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {number} Gutter.
     */
    TileSource.prototype.getGutterForProjection = function (projection) {
        return 0;
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     * @protected
     */
    TileSource.prototype.getKey = function () {
        return this.key_;
    };
    /**
     * Set the value to be used as the key for all tiles in the source.
     * @param {string} key The key for tiles.
     * @protected
     */
    TileSource.prototype.setKey = function (key) {
        if (this.key_ !== key) {
            this.key_ = key;
            this.changed();
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {boolean} Opaque.
     */
    TileSource.prototype.getOpaque = function (projection) {
        return this.opaque_;
    };
    /**
     * @return {Array<number>} Resolutions.
     */
    TileSource.prototype.getResolutions = function () {
        return this.tileGrid.getResolutions();
    };
    /**
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../Tile.js").default} Tile.
     */
    TileSource.prototype.getTile = function (z, x, y, pixelRatio, projection) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["abstract"])();
    };
    /**
     * Return the tile grid of the tile source.
     * @return {import("../tilegrid/TileGrid.js").default} Tile grid.
     * @api
     */
    TileSource.prototype.getTileGrid = function () {
        return this.tileGrid;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */
    TileSource.prototype.getTileGridForProjection = function (projection) {
        if (!this.tileGrid) {
            return Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_8__["getForProjection"])(projection);
        }
        else {
            return this.tileGrid;
        }
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../TileCache.js").default} Tile cache.
     * @protected
     */
    TileSource.prototype.getTileCacheForProjection = function (projection) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_5__["assert"])(Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["equivalent"])(this.getProjection(), projection), 68 // A VectorTile source can only be rendered if it has a projection compatible with the view projection.
        );
        return this.tileCache;
    };
    /**
     * Get the tile pixel ratio for this source. Subclasses may override this
     * method, which is meant to return a supported pixel ratio that matches the
     * provided `pixelRatio` as close as possible.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */
    TileSource.prototype.getTilePixelRatio = function (pixelRatio) {
        return this.tilePixelRatio_;
    };
    /**
     * @param {number} z Z.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../size.js").Size} Tile size.
     */
    TileSource.prototype.getTilePixelSize = function (z, pixelRatio, projection) {
        var tileGrid = this.getTileGridForProjection(projection);
        var tilePixelRatio = this.getTilePixelRatio(pixelRatio);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_9__["toSize"])(tileGrid.getTileSize(z), this.tmpSize);
        if (tilePixelRatio == 1) {
            return tileSize;
        }
        else {
            return Object(_size_js__WEBPACK_IMPORTED_MODULE_9__["scale"])(tileSize, tilePixelRatio, this.tmpSize);
        }
    };
    /**
     * Returns a tile coordinate wrapped around the x-axis. When the tile coordinate
     * is outside the resolution and extent range of the tile grid, `null` will be
     * returned.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../proj/Projection.js").default} [opt_projection] Projection.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate to be passed to the tileUrlFunction or
     *     null if no tile URL should be created for the passed `tileCoord`.
     */
    TileSource.prototype.getTileCoordForTileUrlFunction = function (tileCoord, opt_projection) {
        var projection = opt_projection !== undefined ? opt_projection : this.getProjection();
        var tileGrid = this.getTileGridForProjection(projection);
        if (this.getWrapX() && projection.isGlobal()) {
            tileCoord = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_8__["wrapX"])(tileGrid, tileCoord, projection);
        }
        return Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_7__["withinExtentAndZ"])(tileCoord, tileGrid) ? tileCoord : null;
    };
    /**
     * Remove all cached tiles from the source. The next render cycle will fetch new tiles.
     * @api
     */
    TileSource.prototype.clear = function () {
        this.tileCache.clear();
    };
    TileSource.prototype.refresh = function () {
        this.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Increases the cache size if needed
     * @param {number} tileCount Minimum number of tiles needed.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    TileSource.prototype.updateCacheSize = function (tileCount, projection) {
        var tileCache = this.getTileCacheForProjection(projection);
        if (tileCount > tileCache.highWaterMark) {
            tileCache.highWaterMark = tileCount;
        }
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @abstract
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    TileSource.prototype.useTile = function (z, x, y, projection) { };
    return TileSource;
}(_Source_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Tile~TileSource} instances are instances of this
 * type.
 */
var TileSourceEvent = /** @class */ (function (_super) {
    __extends(TileSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Tile.js").default} tile The tile.
     */
    function TileSourceEvent(type, tile) {
        var _this = _super.call(this, type) || this;
        /**
         * The tile related to the event.
         * @type {import("../Tile.js").default}
         * @api
         */
        _this.tile = tile;
        return _this;
    }
    return TileSourceEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/* harmony default export */ __webpack_exports__["default"] = (TileSource);
//# sourceMappingURL=Tile.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/Source
 */




/**
 * A function that takes a {@link module:ol/PluggableMap~FrameState} and returns a string or
 * an array of strings representing source attributions.
 *
 * @typedef {function(import("../PluggableMap.js").FrameState): (string|Array<string>)} Attribution
 */
/**
 * A type that can be used to provide attribution information for data sources.
 *
 * It represents either
 * * a simple string (e.g. `'© Acme Inc.'`)
 * * an array of simple strings (e.g. `['© Acme Inc.', '© Bacme Inc.']`)
 * * a function that returns a string or array of strings ({@link module:ol/source/Source~Attribution})
 *
 * @typedef {string|Array<string>|Attribution} AttributionLike
 */
/**
 * @typedef {Object} Options
 * @property {AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("./State.js").default} [state='ready'] State.
 * @property {boolean} [wrapX=false] WrapX.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for {@link module:ol/layer/Layer~Layer} sources.
 *
 * A generic `change` event is triggered when the state of the source changes.
 * @abstract
 * @api
 */
var Source = /** @class */ (function (_super) {
    __extends(Source, _super);
    /**
     * @param {Options} options Source options.
     */
    function Source(options) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("../proj/Projection.js").default}
         */
        _this.projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(options.projection);
        /**
         * @private
         * @type {?Attribution}
         */
        _this.attributions_ = adaptAttributions(options.attributions);
        /**
         * @private
         * @type {boolean}
         */
        _this.attributionsCollapsible_ =
            options.attributionsCollapsible !== undefined
                ? options.attributionsCollapsible
                : true;
        /**
         * This source is currently loading data. Sources that defer loading to the
         * map's tile queue never set this to `true`.
         * @type {boolean}
         */
        _this.loading = false;
        /**
         * @private
         * @type {import("./State.js").default}
         */
        _this.state_ =
            options.state !== undefined ? options.state : _State_js__WEBPACK_IMPORTED_MODULE_1__["default"].READY;
        /**
         * @private
         * @type {boolean}
         */
        _this.wrapX_ = options.wrapX !== undefined ? options.wrapX : false;
        return _this;
    }
    /**
     * Get the attribution function for the source.
     * @return {?Attribution} Attribution function.
     */
    Source.prototype.getAttributions = function () {
        return this.attributions_;
    };
    /**
     * @return {boolean} Attributions are collapsible.
     */
    Source.prototype.getAttributionsCollapsible = function () {
        return this.attributionsCollapsible_;
    };
    /**
     * Get the projection of the source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */
    Source.prototype.getProjection = function () {
        return this.projection;
    };
    /**
     * @abstract
     * @return {Array<number>|undefined} Resolutions.
     */
    Source.prototype.getResolutions = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Get the state of the source, see {@link module:ol/source/State~State} for possible states.
     * @return {import("./State.js").default} State.
     * @api
     */
    Source.prototype.getState = function () {
        return this.state_;
    };
    /**
     * @return {boolean|undefined} Wrap X.
     */
    Source.prototype.getWrapX = function () {
        return this.wrapX_;
    };
    /**
     * @return {Object|undefined} Context options.
     */
    Source.prototype.getContextOptions = function () {
        return undefined;
    };
    /**
     * Refreshes the source. The source will be cleared, and data from the server will be reloaded.
     * @api
     */
    Source.prototype.refresh = function () {
        this.changed();
    };
    /**
     * Set the attributions of the source.
     * @param {AttributionLike|undefined} attributions Attributions.
     *     Can be passed as `string`, `Array<string>`, {@link module:ol/source/Source~Attribution},
     *     or `undefined`.
     * @api
     */
    Source.prototype.setAttributions = function (attributions) {
        this.attributions_ = adaptAttributions(attributions);
        this.changed();
    };
    /**
     * Set the state of the source.
     * @param {import("./State.js").default} state State.
     */
    Source.prototype.setState = function (state) {
        this.state_ = state;
        this.changed();
    };
    return Source;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Turns the attributions option into an attributions function.
 * @param {AttributionLike|undefined} attributionLike The attribution option.
 * @return {?Attribution} An attribution function (or null).
 */
function adaptAttributions(attributionLike) {
    if (!attributionLike) {
        return null;
    }
    if (Array.isArray(attributionLike)) {
        return function (frameState) {
            return attributionLike;
        };
    }
    if (typeof attributionLike === 'function') {
        return attributionLike;
    }
    return function (frameState) {
        return [attributionLike];
    };
}
/* harmony default export */ __webpack_exports__["default"] = (Source);
//# sourceMappingURL=Source.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getForProjection", function() { return getForProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapX", function() { return wrapX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createForExtent", function() { return createForExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createXYZ", function() { return createXYZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createForProjection", function() { return createForProjection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "extentFromProjection", function() { return extentFromProjection; });
/* harmony import */ var _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17);
/* harmony import */ var _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89);
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39);
/**
 * @module ol/tilegrid
 */







/**
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {!TileGrid} Default tile grid for the
 * passed projection.
 */
function getForProjection(projection) {
    var tileGrid = projection.getDefaultTileGrid();
    if (!tileGrid) {
        tileGrid = createForProjection(projection);
        projection.setDefaultTileGrid(tileGrid);
    }
    return tileGrid;
}
/**
 * @param {TileGrid} tileGrid Tile grid.
 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {import("./tilecoord.js").TileCoord} Tile coordinate.
 */
function wrapX(tileGrid, tileCoord, projection) {
    var z = tileCoord[0];
    var center = tileGrid.getTileCoordCenter(tileCoord);
    var projectionExtent = extentFromProjection(projection);
    if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["containsCoordinate"])(projectionExtent, center)) {
        var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getWidth"])(projectionExtent);
        var worldsAway = Math.ceil((projectionExtent[0] - center[0]) / worldWidth);
        center[0] += worldWidth * worldsAway;
        return tileGrid.getTileCoordForCoordAndZ(center, z);
    }
    else {
        return tileCoord;
    }
}
/**
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [opt_maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [opt_tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {import("./extent/Corner.js").default} [opt_corner] Extent corner (default is `'top-left'`).
 * @return {!TileGrid} TileGrid instance.
 */
function createForExtent(extent, opt_maxZoom, opt_tileSize, opt_corner) {
    var corner = opt_corner !== undefined ? opt_corner : _extent_Corner_js__WEBPACK_IMPORTED_MODULE_0__["default"].TOP_LEFT;
    var resolutions = resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize);
    return new _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        extent: extent,
        origin: Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getCorner"])(extent, corner),
        resolutions: resolutions,
        tileSize: opt_tileSize,
    });
}
/**
 * @typedef {Object} XYZOptions
 * @property {import("./extent.js").Extent} [extent] Extent for the tile grid. The origin for an XYZ tile grid is the
 * top-left corner of the extent. If `maxResolution` is not provided the zero level of the grid is defined by the resolution
 * at which one tile fits in the provided extent. If not provided, the extent of the EPSG:3857 projection is used.
 * @property {number} [maxResolution] Resolution at level zero.
 * @property {number} [maxZoom] Maximum zoom. The default is `42`. This determines the number of levels
 * in the grid set. For example, a `maxZoom` of 21 means there are 22 levels in the grid set.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {number|import("./size.js").Size} [tileSize=[256, 256]] Tile size in pixels.
 */
/**
 * Creates a tile grid with a standard XYZ tiling scheme.
 * @param {XYZOptions} [opt_options] Tile grid options.
 * @return {!TileGrid} Tile grid instance.
 * @api
 */
function createXYZ(opt_options) {
    var xyzOptions = opt_options || {};
    var extent = xyzOptions.extent || Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["get"])('EPSG:3857').getExtent();
    var gridOptions = {
        extent: extent,
        minZoom: xyzOptions.minZoom,
        tileSize: xyzOptions.tileSize,
        resolutions: resolutionsFromExtent(extent, xyzOptions.maxZoom, xyzOptions.tileSize, xyzOptions.maxResolution),
    };
    return new _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_1__["default"](gridOptions);
}
/**
 * Create a resolutions array from an extent.  A zoom factor of 2 is assumed.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} [opt_maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [opt_tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {number} [opt_maxResolution] Resolution at level zero.
 * @return {!Array<number>} Resolutions array.
 */
function resolutionsFromExtent(extent, opt_maxZoom, opt_tileSize, opt_maxResolution) {
    var maxZoom = opt_maxZoom !== undefined ? opt_maxZoom : _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_MAX_ZOOM"];
    var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getHeight"])(extent);
    var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getWidth"])(extent);
    var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_6__["toSize"])(opt_tileSize !== undefined ? opt_tileSize : _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_TILE_SIZE"]);
    var maxResolution = opt_maxResolution > 0
        ? opt_maxResolution
        : Math.max(width / tileSize[0], height / tileSize[1]);
    var length = maxZoom + 1;
    var resolutions = new Array(length);
    for (var z = 0; z < length; ++z) {
        resolutions[z] = maxResolution / Math.pow(2, z);
    }
    return resolutions;
}
/**
 * @param {import("./proj.js").ProjectionLike} projection Projection.
 * @param {number} [opt_maxZoom] Maximum zoom level (default is
 *     DEFAULT_MAX_ZOOM).
 * @param {number|import("./size.js").Size} [opt_tileSize] Tile size (default uses
 *     DEFAULT_TILE_SIZE).
 * @param {import("./extent/Corner.js").default} [opt_corner] Extent corner (default is `'top-left'`).
 * @return {!TileGrid} TileGrid instance.
 */
function createForProjection(projection, opt_maxZoom, opt_tileSize, opt_corner) {
    var extent = extentFromProjection(projection);
    return createForExtent(extent, opt_maxZoom, opt_tileSize, opt_corner);
}
/**
 * Generate a tile grid extent from a projection.  If the projection has an
 * extent, it is used.  If not, a global extent is assumed.
 * @param {import("./proj.js").ProjectionLike} projection Projection.
 * @return {import("./extent.js").Extent} Extent.
 */
function extentFromProjection(projection) {
    projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["get"])(projection);
    var extent = projection.getExtent();
    if (!extent) {
        var half = (180 * _proj_js__WEBPACK_IMPORTED_MODULE_4__["METERS_PER_UNIT"][_proj_Units_js__WEBPACK_IMPORTED_MODULE_2__["default"].DEGREES]) / projection.getMetersPerUnit();
        extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["createOrUpdate"])(-half, -half, half, half);
    }
    return extent;
}
//# sourceMappingURL=tilegrid.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileRange_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39);
/**
 * @module ol/tilegrid/TileGrid
 */








/**
 * @private
 * @type {import("../tilecoord.js").TileCoord}
 */
var tmpTileCoord = [0, 0, 0];
/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles outside this
 * extent will be requested by {@link module:ol/source/Tile} sources. When no `origin` or
 * `origins` are configured, the `origin` will be set to the top-left corner of the extent.
 * @property {number} [minZoom=0] Minimum zoom.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e. where the `x`
 * and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left to right and downwards. If not
 * specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins, i.e. where
 * the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * origin. Tile coordinates increase left to right and downwards. If not specified, `extent` or
 * `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each resolution needs
 * to match the zoom level. This means that even if a `minZoom` is configured, the resolutions
 * array will have a length of `maxZoom + 1`.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. If specified the values
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent
 * for which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Default is `[256, 256]`.
 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. If given, the array length
 * should match the length of the `resolutions` array, i.e. each resolution can have a different
 * tile size.
 */
/**
 * @classdesc
 * Base class for setting the grid pattern for sources accessing tiled-image
 * servers.
 * @api
 */
var TileGrid = /** @class */ (function () {
    /**
     * @param {Options} options Tile grid options.
     */
    function TileGrid(options) {
        /**
         * @protected
         * @type {number}
         */
        this.minZoom = options.minZoom !== undefined ? options.minZoom : 0;
        /**
         * @private
         * @type {!Array<number>}
         */
        this.resolutions_ = options.resolutions;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])(Object(_array_js__WEBPACK_IMPORTED_MODULE_6__["isSorted"])(this.resolutions_, function (a, b) {
            return b - a;
        }, true), 17); // `resolutions` must be sorted in descending order
        // check if we've got a consistent zoom factor and origin
        var zoomFactor;
        if (!options.origins) {
            for (var i = 0, ii = this.resolutions_.length - 1; i < ii; ++i) {
                if (!zoomFactor) {
                    zoomFactor = this.resolutions_[i] / this.resolutions_[i + 1];
                }
                else {
                    if (this.resolutions_[i] / this.resolutions_[i + 1] !== zoomFactor) {
                        zoomFactor = undefined;
                        break;
                    }
                }
            }
        }
        /**
         * @private
         * @type {number|undefined}
         */
        this.zoomFactor_ = zoomFactor;
        /**
         * @protected
         * @type {number}
         */
        this.maxZoom = this.resolutions_.length - 1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */
        this.origin_ = options.origin !== undefined ? options.origin : null;
        /**
         * @private
         * @type {Array<import("../coordinate.js").Coordinate>}
         */
        this.origins_ = null;
        if (options.origins !== undefined) {
            this.origins_ = options.origins;
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])(this.origins_.length == this.resolutions_.length, 20); // Number of `origins` and `resolutions` must be equal
        }
        var extent = options.extent;
        if (extent !== undefined && !this.origin_ && !this.origins_) {
            this.origin_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getTopLeft"])(extent);
        }
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])((!this.origin_ && this.origins_) || (this.origin_ && !this.origins_), 18); // Either `origin` or `origins` must be configured, never both
        /**
         * @private
         * @type {Array<number|import("../size.js").Size>}
         */
        this.tileSizes_ = null;
        if (options.tileSizes !== undefined) {
            this.tileSizes_ = options.tileSizes;
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])(this.tileSizes_.length == this.resolutions_.length, 19); // Number of `tileSizes` and `resolutions` must be equal
        }
        /**
         * @private
         * @type {number|import("../size.js").Size}
         */
        this.tileSize_ =
            options.tileSize !== undefined
                ? options.tileSize
                : !this.tileSizes_
                    ? _common_js__WEBPACK_IMPORTED_MODULE_1__["DEFAULT_TILE_SIZE"]
                    : null;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])((!this.tileSize_ && this.tileSizes_) ||
            (this.tileSize_ && !this.tileSizes_), 22); // Either `tileSize` or `tileSizes` must be configured, never both
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        this.extent_ = extent !== undefined ? extent : null;
        /**
         * @private
         * @type {Array<import("../TileRange.js").default>}
         */
        this.fullTileRanges_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        this.tmpSize_ = [0, 0];
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        this.tmpExtent_ = [0, 0, 0, 0];
        if (options.sizes !== undefined) {
            this.fullTileRanges_ = options.sizes.map(function (size, z) {
                var tileRange = new _TileRange_js__WEBPACK_IMPORTED_MODULE_0__["default"](Math.min(0, size[0]), Math.max(size[0] - 1, -1), Math.min(0, size[1]), Math.max(size[1] - 1, -1));
                if (extent) {
                    var restrictedTileRange = this.getTileRangeForExtentAndZ(extent, z);
                    tileRange.minX = Math.max(restrictedTileRange.minX, tileRange.minX);
                    tileRange.maxX = Math.min(restrictedTileRange.maxX, tileRange.maxX);
                    tileRange.minY = Math.max(restrictedTileRange.minY, tileRange.minY);
                    tileRange.maxY = Math.min(restrictedTileRange.maxY, tileRange.maxY);
                }
                return tileRange;
            }, this);
        }
        else if (extent) {
            this.calculateTileRanges_(extent);
        }
    }
    /**
     * Call a function with each tile coordinate for a given extent and zoom level.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} zoom Integer zoom level.
     * @param {function(import("../tilecoord.js").TileCoord): void} callback Function called with each tile coordinate.
     * @api
     */
    TileGrid.prototype.forEachTileCoord = function (extent, zoom, callback) {
        var tileRange = this.getTileRangeForExtentAndZ(extent, zoom);
        for (var i = tileRange.minX, ii = tileRange.maxX; i <= ii; ++i) {
            for (var j = tileRange.minY, jj = tileRange.maxY; j <= jj; ++j) {
                callback([zoom, i, j]);
            }
        }
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {function(number, import("../TileRange.js").default): boolean} callback Callback.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {boolean} Callback succeeded.
     */
    TileGrid.prototype.forEachTileCoordParentTileRange = function (tileCoord, callback, opt_tileRange, opt_extent) {
        var tileRange, x, y;
        var tileCoordExtent = null;
        var z = tileCoord[0] - 1;
        if (this.zoomFactor_ === 2) {
            x = tileCoord[1];
            y = tileCoord[2];
        }
        else {
            tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent);
        }
        while (z >= this.minZoom) {
            if (this.zoomFactor_ === 2) {
                x = Math.floor(x / 2);
                y = Math.floor(y / 2);
                tileRange = Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(x, x, y, y, opt_tileRange);
            }
            else {
                tileRange = this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
            }
            if (callback(z, tileRange)) {
                return true;
            }
            --z;
        }
        return false;
    };
    /**
     * Get the extent for this tile grid, if it was configured.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    TileGrid.prototype.getExtent = function () {
        return this.extent_;
    };
    /**
     * Get the maximum zoom level for the grid.
     * @return {number} Max zoom.
     * @api
     */
    TileGrid.prototype.getMaxZoom = function () {
        return this.maxZoom;
    };
    /**
     * Get the minimum zoom level for the grid.
     * @return {number} Min zoom.
     * @api
     */
    TileGrid.prototype.getMinZoom = function () {
        return this.minZoom;
    };
    /**
     * Get the origin for the grid at the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {import("../coordinate.js").Coordinate} Origin.
     * @api
     */
    TileGrid.prototype.getOrigin = function (z) {
        if (this.origin_) {
            return this.origin_;
        }
        else {
            return this.origins_[z];
        }
    };
    /**
     * Get the resolution for the given zoom level.
     * @param {number} z Integer zoom level.
     * @return {number} Resolution.
     * @api
     */
    TileGrid.prototype.getResolution = function (z) {
        return this.resolutions_[z];
    };
    /**
     * Get the list of resolutions for the tile grid.
     * @return {Array<number>} Resolutions.
     * @api
     */
    TileGrid.prototype.getResolutions = function () {
        return this.resolutions_;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {import("../TileRange.js").default} Tile range.
     */
    TileGrid.prototype.getTileCoordChildTileRange = function (tileCoord, opt_tileRange, opt_extent) {
        if (tileCoord[0] < this.maxZoom) {
            if (this.zoomFactor_ === 2) {
                var minX = tileCoord[1] * 2;
                var minY = tileCoord[2] * 2;
                return Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(minX, minX + 1, minY, minY + 1, opt_tileRange);
            }
            var tileCoordExtent = this.getTileCoordExtent(tileCoord, opt_extent || this.tmpExtent_);
            return this.getTileRangeForExtentAndZ(tileCoordExtent, tileCoord[0] + 1, opt_tileRange);
        }
        return null;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary import("../TileRange.js").default object.
     * @return {import("../TileRange.js").default} Tile range.
     */
    TileGrid.prototype.getTileRangeForTileCoordAndZ = function (tileCoord, z, opt_tileRange) {
        if (z > this.maxZoom || z < this.minZoom) {
            return null;
        }
        var tileCoordZ = tileCoord[0];
        var tileCoordX = tileCoord[1];
        var tileCoordY = tileCoord[2];
        if (z === tileCoordZ) {
            return Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(tileCoordX, tileCoordY, tileCoordX, tileCoordY, opt_tileRange);
        }
        if (this.zoomFactor_) {
            var factor = Math.pow(this.zoomFactor_, z - tileCoordZ);
            var minX = Math.floor(tileCoordX * factor);
            var minY = Math.floor(tileCoordY * factor);
            if (z < tileCoordZ) {
                return Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(minX, minX, minY, minY, opt_tileRange);
            }
            var maxX = Math.floor(factor * (tileCoordX + 1)) - 1;
            var maxY = Math.floor(factor * (tileCoordY + 1)) - 1;
            return Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(minX, maxX, minY, maxY, opt_tileRange);
        }
        var tileCoordExtent = this.getTileCoordExtent(tileCoord, this.tmpExtent_);
        return this.getTileRangeForExtentAndZ(tileCoordExtent, z, opt_tileRange);
    };
    /**
     * Get the extent for a tile range.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} tileRange Tile range.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary import("../extent.js").Extent object.
     * @return {import("../extent.js").Extent} Extent.
     */
    TileGrid.prototype.getTileRangeExtent = function (z, tileRange, opt_extent) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(this.getTileSize(z), this.tmpSize_);
        var minX = origin[0] + tileRange.minX * tileSize[0] * resolution;
        var maxX = origin[0] + (tileRange.maxX + 1) * tileSize[0] * resolution;
        var minY = origin[1] + tileRange.minY * tileSize[1] * resolution;
        var maxY = origin[1] + (tileRange.maxY + 1) * tileSize[1] * resolution;
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdate"])(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get a tile range for the given extent and integer zoom level.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} z Integer zoom level.
     * @param {import("../TileRange.js").default} [opt_tileRange] Temporary tile range object.
     * @return {import("../TileRange.js").default} Tile range.
     */
    TileGrid.prototype.getTileRangeForExtentAndZ = function (extent, z, opt_tileRange) {
        var tileCoord = tmpTileCoord;
        this.getTileCoordForXYAndZ_(extent[0], extent[3], z, false, tileCoord);
        var minX = tileCoord[1];
        var minY = tileCoord[2];
        this.getTileCoordForXYAndZ_(extent[2], extent[1], z, true, tileCoord);
        return Object(_TileRange_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdate"])(minX, tileCoord[1], minY, tileCoord[2], opt_tileRange);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {import("../coordinate.js").Coordinate} Tile center.
     */
    TileGrid.prototype.getTileCoordCenter = function (tileCoord) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(this.getTileSize(tileCoord[0]), this.tmpSize_);
        return [
            origin[0] + (tileCoord[1] + 0.5) * tileSize[0] * resolution,
            origin[1] - (tileCoord[2] + 0.5) * tileSize[1] * resolution,
        ];
    };
    /**
     * Get the extent of a tile coordinate.
     *
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../extent.js").Extent} [opt_extent] Temporary extent object.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    TileGrid.prototype.getTileCoordExtent = function (tileCoord, opt_extent) {
        var origin = this.getOrigin(tileCoord[0]);
        var resolution = this.getResolution(tileCoord[0]);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(this.getTileSize(tileCoord[0]), this.tmpSize_);
        var minX = origin[0] + tileCoord[1] * tileSize[0] * resolution;
        var minY = origin[1] - (tileCoord[2] + 1) * tileSize[1] * resolution;
        var maxX = minX + tileSize[0] * resolution;
        var maxY = minY + tileSize[1] * resolution;
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdate"])(minX, minY, maxX, maxY, opt_extent);
    };
    /**
     * Get the tile coordinate for the given map coordinate and resolution.  This
     * method considers that coordinates that intersect tile boundaries should be
     * assigned the higher tile coordinate.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */
    TileGrid.prototype.getTileCoordForCoordAndResolution = function (coordinate, resolution, opt_tileCoord) {
        return this.getTileCoordForXYAndResolution_(coordinate[0], coordinate[1], resolution, false, opt_tileCoord);
    };
    /**
     * Note that this method should not be called for resolutions that correspond
     * to an integer zoom level.  Instead call the `getTileCoordForXYAndZ_` method.
     * @param {number} x X.
     * @param {number} y Y.
     * @param {number} resolution Resolution (for a non-integer zoom level).
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */
    TileGrid.prototype.getTileCoordForXYAndResolution_ = function (x, y, resolution, reverseIntersectionPolicy, opt_tileCoord) {
        var z = this.getZForResolution(resolution);
        var scale = resolution / this.getResolution(z);
        var origin = this.getOrigin(z);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(this.getTileSize(z), this.tmpSize_);
        var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
        var adjustY = reverseIntersectionPolicy ? 0.5 : 0;
        var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
        var yFromOrigin = Math.floor((origin[1] - y) / resolution + adjustY);
        var tileCoordX = (scale * xFromOrigin) / tileSize[0];
        var tileCoordY = (scale * yFromOrigin) / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = Math.ceil(tileCoordX) - 1;
            tileCoordY = Math.ceil(tileCoordY) - 1;
        }
        else {
            tileCoordX = Math.floor(tileCoordX);
            tileCoordY = Math.floor(tileCoordY);
        }
        return Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_5__["createOrUpdate"])(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Although there is repetition between this method and `getTileCoordForXYAndResolution_`,
     * they should have separate implementations.  This method is for integer zoom
     * levels.  The other method should only be called for resolutions corresponding
     * to non-integer zoom levels.
     * @param {number} x Map x coordinate.
     * @param {number} y Map y coordinate.
     * @param {number} z Integer zoom level.
     * @param {boolean} reverseIntersectionPolicy Instead of letting edge
     *     intersections go to the higher tile coordinate, let edge intersections
     *     go to the lower tile coordinate.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Temporary import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @private
     */
    TileGrid.prototype.getTileCoordForXYAndZ_ = function (x, y, z, reverseIntersectionPolicy, opt_tileCoord) {
        var origin = this.getOrigin(z);
        var resolution = this.getResolution(z);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(this.getTileSize(z), this.tmpSize_);
        var adjustX = reverseIntersectionPolicy ? 0.5 : 0;
        var adjustY = reverseIntersectionPolicy ? 0.5 : 0;
        var xFromOrigin = Math.floor((x - origin[0]) / resolution + adjustX);
        var yFromOrigin = Math.floor((origin[1] - y) / resolution + adjustY);
        var tileCoordX = xFromOrigin / tileSize[0];
        var tileCoordY = yFromOrigin / tileSize[1];
        if (reverseIntersectionPolicy) {
            tileCoordX = Math.ceil(tileCoordX) - 1;
            tileCoordY = Math.ceil(tileCoordY) - 1;
        }
        else {
            tileCoordX = Math.floor(tileCoordX);
            tileCoordY = Math.floor(tileCoordY);
        }
        return Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_5__["createOrUpdate"])(z, tileCoordX, tileCoordY, opt_tileCoord);
    };
    /**
     * Get a tile coordinate given a map coordinate and zoom level.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} z Zoom level.
     * @param {import("../tilecoord.js").TileCoord} [opt_tileCoord] Destination import("../tilecoord.js").TileCoord object.
     * @return {import("../tilecoord.js").TileCoord} Tile coordinate.
     * @api
     */
    TileGrid.prototype.getTileCoordForCoordAndZ = function (coordinate, z, opt_tileCoord) {
        return this.getTileCoordForXYAndZ_(coordinate[0], coordinate[1], z, false, opt_tileCoord);
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {number} Tile resolution.
     */
    TileGrid.prototype.getTileCoordResolution = function (tileCoord) {
        return this.resolutions_[tileCoord[0]];
    };
    /**
     * Get the tile size for a zoom level. The type of the return value matches the
     * `tileSize` or `tileSizes` that the tile grid was configured with. To always
     * get an `import("../size.js").Size`, run the result through `import("../size.js").Size.toSize()`.
     * @param {number} z Z.
     * @return {number|import("../size.js").Size} Tile size.
     * @api
     */
    TileGrid.prototype.getTileSize = function (z) {
        if (this.tileSize_) {
            return this.tileSize_;
        }
        else {
            return this.tileSizes_[z];
        }
    };
    /**
     * @param {number} z Zoom level.
     * @return {import("../TileRange.js").default} Extent tile range for the specified zoom level.
     */
    TileGrid.prototype.getFullTileRange = function (z) {
        if (!this.fullTileRanges_) {
            return this.extent_
                ? this.getTileRangeForExtentAndZ(this.extent_, z)
                : null;
        }
        else {
            return this.fullTileRanges_[z];
        }
    };
    /**
     * @param {number} resolution Resolution.
     * @param {number|import("../array.js").NearestDirectionFunction} [opt_direction]
     *     If 0, the nearest resolution will be used.
     *     If 1, the nearest higher resolution (lower Z) will be used. If -1, the
     *     nearest lower resolution (higher Z) will be used. Default is 0.
     *     Use a {@link module:ol/array~NearestDirectionFunction} for more precise control.
     *
     * For example to change tile Z at the midpoint of zoom levels
     * ```js
     * function(value, high, low) {
     *   return value - low * Math.sqrt(high / low);
     * }
     * ```
     * @return {number} Z.
     * @api
     */
    TileGrid.prototype.getZForResolution = function (resolution, opt_direction) {
        var z = Object(_array_js__WEBPACK_IMPORTED_MODULE_6__["linearFindNearest"])(this.resolutions_, resolution, opt_direction || 0);
        return Object(_math_js__WEBPACK_IMPORTED_MODULE_3__["clamp"])(z, this.minZoom, this.maxZoom);
    };
    /**
     * @param {!import("../extent.js").Extent} extent Extent for this tile grid.
     * @private
     */
    TileGrid.prototype.calculateTileRanges_ = function (extent) {
        var length = this.resolutions_.length;
        var fullTileRanges = new Array(length);
        for (var z = this.minZoom; z < length; ++z) {
            fullTileRanges[z] = this.getTileRangeForExtentAndZ(extent, z);
        }
        this.fullTileRanges_ = fullTileRanges;
    };
    return TileGrid;
}());
/* harmony default export */ __webpack_exports__["default"] = (TileGrid);
//# sourceMappingURL=TileGrid.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createOrUpdate", function() { return createOrUpdate; });
/**
 * @module ol/TileRange
 */
/**
 * A representation of a contiguous block of tiles.  A tile range is specified
 * by its min/max tile coordinates and is inclusive of coordinates.
 */
var TileRange = /** @class */ (function () {
    /**
     * @param {number} minX Minimum X.
     * @param {number} maxX Maximum X.
     * @param {number} minY Minimum Y.
     * @param {number} maxY Maximum Y.
     */
    function TileRange(minX, maxX, minY, maxY) {
        /**
         * @type {number}
         */
        this.minX = minX;
        /**
         * @type {number}
         */
        this.maxX = maxX;
        /**
         * @type {number}
         */
        this.minY = minY;
        /**
         * @type {number}
         */
        this.maxY = maxY;
    }
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @return {boolean} Contains tile coordinate.
     */
    TileRange.prototype.contains = function (tileCoord) {
        return this.containsXY(tileCoord[1], tileCoord[2]);
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Contains.
     */
    TileRange.prototype.containsTileRange = function (tileRange) {
        return (this.minX <= tileRange.minX &&
            tileRange.maxX <= this.maxX &&
            this.minY <= tileRange.minY &&
            tileRange.maxY <= this.maxY);
    };
    /**
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @return {boolean} Contains coordinate.
     */
    TileRange.prototype.containsXY = function (x, y) {
        return this.minX <= x && x <= this.maxX && this.minY <= y && y <= this.maxY;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Equals.
     */
    TileRange.prototype.equals = function (tileRange) {
        return (this.minX == tileRange.minX &&
            this.minY == tileRange.minY &&
            this.maxX == tileRange.maxX &&
            this.maxY == tileRange.maxY);
    };
    /**
     * @param {TileRange} tileRange Tile range.
     */
    TileRange.prototype.extend = function (tileRange) {
        if (tileRange.minX < this.minX) {
            this.minX = tileRange.minX;
        }
        if (tileRange.maxX > this.maxX) {
            this.maxX = tileRange.maxX;
        }
        if (tileRange.minY < this.minY) {
            this.minY = tileRange.minY;
        }
        if (tileRange.maxY > this.maxY) {
            this.maxY = tileRange.maxY;
        }
    };
    /**
     * @return {number} Height.
     */
    TileRange.prototype.getHeight = function () {
        return this.maxY - this.minY + 1;
    };
    /**
     * @return {import("./size.js").Size} Size.
     */
    TileRange.prototype.getSize = function () {
        return [this.getWidth(), this.getHeight()];
    };
    /**
     * @return {number} Width.
     */
    TileRange.prototype.getWidth = function () {
        return this.maxX - this.minX + 1;
    };
    /**
     * @param {TileRange} tileRange Tile range.
     * @return {boolean} Intersects.
     */
    TileRange.prototype.intersects = function (tileRange) {
        return (this.minX <= tileRange.maxX &&
            this.maxX >= tileRange.minX &&
            this.minY <= tileRange.maxY &&
            this.maxY >= tileRange.minY);
    };
    return TileRange;
}());
/**
 * @param {number} minX Minimum X.
 * @param {number} maxX Maximum X.
 * @param {number} minY Minimum Y.
 * @param {number} maxY Maximum Y.
 * @param {TileRange} [tileRange] TileRange.
 * @return {TileRange} Tile range.
 */
function createOrUpdate(minX, maxX, minY, maxY, tileRange) {
    if (tileRange !== undefined) {
        tileRange.minX = minX;
        tileRange.maxX = maxX;
        tileRange.minY = minY;
        tileRange.maxY = maxY;
        return tileRange;
    }
    else {
        return new TileRange(minX, maxX, minY, maxY);
    }
}
/* harmony default export */ __webpack_exports__["default"] = (TileRange);
//# sourceMappingURL=TileRange.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_MAX_ZOOM", function() { return DEFAULT_MAX_ZOOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_TILE_SIZE", function() { return DEFAULT_TILE_SIZE; });
/**
 * @module ol/tilegrid/common
 */
/**
 * Default maximum zoom for default tile grids.
 * @type {number}
 */
var DEFAULT_MAX_ZOOM = 42;
/**
 * Default tile size.
 * @type {number}
 */
var DEFAULT_TILE_SIZE = 256;
//# sourceMappingURL=common.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFromTemplate", function() { return createFromTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFromTemplates", function() { return createFromTemplates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFromTileUrlFunctions", function() { return createFromTileUrlFunctions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nullTileUrlFunction", function() { return nullTileUrlFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expandUrl", function() { return expandUrl; });
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83);
/**
 * @module ol/tileurlfunction
 */



/**
 * @param {string} template Template.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */
function createFromTemplate(template, tileGrid) {
    var zRegEx = /\{z\}/g;
    var xRegEx = /\{x\}/g;
    var yRegEx = /\{y\}/g;
    var dashYRegEx = /\{-y\}/g;
    return (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function (tileCoord, pixelRatio, projection) {
        if (!tileCoord) {
            return undefined;
        }
        else {
            return template
                .replace(zRegEx, tileCoord[0].toString())
                .replace(xRegEx, tileCoord[1].toString())
                .replace(yRegEx, tileCoord[2].toString())
                .replace(dashYRegEx, function () {
                var z = tileCoord[0];
                var range = tileGrid.getFullTileRange(z);
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(range, 55); // The {-y} placeholder requires a tile grid with extent
                var y = range.getHeight() - tileCoord[2] - 1;
                return y.toString();
            });
        }
    });
}
/**
 * @param {Array<string>} templates Templates.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */
function createFromTemplates(templates, tileGrid) {
    var len = templates.length;
    var tileUrlFunctions = new Array(len);
    for (var i = 0; i < len; ++i) {
        tileUrlFunctions[i] = createFromTemplate(templates[i], tileGrid);
    }
    return createFromTileUrlFunctions(tileUrlFunctions);
}
/**
 * @param {Array<import("./Tile.js").UrlFunction>} tileUrlFunctions Tile URL Functions.
 * @return {import("./Tile.js").UrlFunction} Tile URL function.
 */
function createFromTileUrlFunctions(tileUrlFunctions) {
    if (tileUrlFunctions.length === 1) {
        return tileUrlFunctions[0];
    }
    return (
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile Coordinate.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @return {string|undefined} Tile URL.
     */
    function (tileCoord, pixelRatio, projection) {
        if (!tileCoord) {
            return undefined;
        }
        else {
            var h = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_2__["hash"])(tileCoord);
            var index = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["modulo"])(h, tileUrlFunctions.length);
            return tileUrlFunctions[index](tileCoord, pixelRatio, projection);
        }
    });
}
/**
 * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
 * @param {number} pixelRatio Pixel ratio.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @return {string|undefined} Tile URL.
 */
function nullTileUrlFunction(tileCoord, pixelRatio, projection) {
    return undefined;
}
/**
 * @param {string} url URL.
 * @return {Array<string>} Array of urls.
 */
function expandUrl(url) {
    var urls = [];
    var match = /\{([a-z])-([a-z])\}/.exec(url);
    if (match) {
        // char range
        var startCharCode = match[1].charCodeAt(0);
        var stopCharCode = match[2].charCodeAt(0);
        var charCode = void 0;
        for (charCode = startCharCode; charCode <= stopCharCode; ++charCode) {
            urls.push(url.replace(match[0], String.fromCharCode(charCode)));
        }
        return urls;
    }
    match = /\{(\d+)-(\d+)\}/.exec(url);
    if (match) {
        // number range
        var stop_1 = parseInt(match[2], 10);
        for (var i = parseInt(match[1], 10); i <= stop_1; i++) {
            urls.push(url.replace(match[0], i.toString()));
        }
        return urls;
    }
    urls.push(url);
    return urls;
}
//# sourceMappingURL=tileurlfunction.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jsonp", function() { return jsonp; });
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21);
/**
 * @module ol/net
 */

/**
 * Simple JSONP helper. Supports error callbacks and a custom callback param.
 * The error callback will be called when no JSONP is executed after 10 seconds.
 *
 * @param {string} url Request url. A 'callback' query parameter will be
 *     appended.
 * @param {Function} callback Callback on success.
 * @param {Function} [opt_errback] Callback on error.
 * @param {string} [opt_callbackParam] Custom query parameter for the JSONP
 *     callback. Default is 'callback'.
 */
function jsonp(url, callback, opt_errback, opt_callbackParam) {
    var script = document.createElement('script');
    var key = 'olc_' + Object(_util_js__WEBPACK_IMPORTED_MODULE_0__["getUid"])(callback);
    function cleanup() {
        delete window[key];
        script.parentNode.removeChild(script);
    }
    script.async = true;
    script.src =
        url +
            (url.indexOf('?') == -1 ? '?' : '&') +
            (opt_callbackParam || 'callback') +
            '=' +
            key;
    var timer = setTimeout(function () {
        cleanup();
        if (opt_errback) {
            opt_errback();
        }
    }, 10000);
    window[key] = function (data) {
        clearTimeout(timer);
        cleanup();
        callback(data);
    };
    document.getElementsByTagName('head')[0].appendChild(script);
}
//# sourceMappingURL=net.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70);
/* harmony import */ var _XYZ_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/**
 * @module ol/source/CartoDB
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [maxZoom=18] Max zoom.
 * @property {number} [minZoom] Minimum zoom.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {Object} [config] If using anonymous maps, the CartoDB config to use. See
 * https://carto.com/developers/maps-api/guides/anonymous-maps/
 * for more detail.
 * If using named maps, a key-value lookup with the template parameters.
 * See https://carto.com/developers/maps-api/guides/named-maps/
 * for more detail.
 * @property {string} [map] If using named maps, this will be the name of the template to load.
 * See https://carto.com/developers/maps-api/guides/named-maps/
 * for more detail.
 * @property {string} [account] Username as used to access public Carto dashboard at https://{username}.carto.com/.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @typedef {Object} CartoDBLayerInfo
 * @property {string} layergroupid The layer group ID
 * @property {{https: string}} cdn_url The CDN URL
 */
/**
 * @classdesc
 * Layer source for the CartoDB Maps API.
 * @api
 */
var CartoDB = /** @class */ (function (_super) {
    __extends(CartoDB, _super);
    /**
     * @param {Options} options CartoDB options.
     */
    function CartoDB(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 18,
            minZoom: options.minZoom,
            projection: options.projection,
            transition: options.transition,
            wrapX: options.wrapX,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @type {string}
         * @private
         */
        _this.account_ = options.account;
        /**
         * @type {string}
         * @private
         */
        _this.mapId_ = options.map || '';
        /**
         * @type {!Object}
         * @private
         */
        _this.config_ = options.config || {};
        /**
         * @type {!Object<string, CartoDBLayerInfo>}
         * @private
         */
        _this.templateCache_ = {};
        _this.initializeMap_();
        return _this;
    }
    /**
     * Returns the current config.
     * @return {!Object} The current configuration.
     * @api
     */
    CartoDB.prototype.getConfig = function () {
        return this.config_;
    };
    /**
     * Updates the carto db config.
     * @param {Object} config a key-value lookup. Values will replace current values
     *     in the config.
     * @api
     */
    CartoDB.prototype.updateConfig = function (config) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])(this.config_, config);
        this.initializeMap_();
    };
    /**
     * Sets the CartoDB config
     * @param {Object} config In the case of anonymous maps, a CartoDB configuration
     *     object.
     * If using named maps, a key-value lookup with the template parameters.
     * @api
     */
    CartoDB.prototype.setConfig = function (config) {
        this.config_ = config || {};
        this.initializeMap_();
    };
    /**
     * Issue a request to initialize the CartoDB map.
     * @private
     */
    CartoDB.prototype.initializeMap_ = function () {
        var paramHash = JSON.stringify(this.config_);
        if (this.templateCache_[paramHash]) {
            this.applyTemplate_(this.templateCache_[paramHash]);
            return;
        }
        var mapUrl = 'https://' + this.account_ + '.carto.com/api/v1/map';
        if (this.mapId_) {
            mapUrl += '/named/' + this.mapId_;
        }
        var client = new XMLHttpRequest();
        client.addEventListener('load', this.handleInitResponse_.bind(this, paramHash));
        client.addEventListener('error', this.handleInitError_.bind(this));
        client.open('POST', mapUrl);
        client.setRequestHeader('Content-type', 'application/json');
        client.send(JSON.stringify(this.config_));
    };
    /**
     * Handle map initialization response.
     * @param {string} paramHash a hash representing the parameter set that was used
     *     for the request
     * @param {Event} event Event.
     * @private
     */
    CartoDB.prototype.handleInitResponse_ = function (paramHash, event) {
        var client = /** @type {XMLHttpRequest} */ (event.target);
        // status will be 0 for file:// urls
        if (!client.status || (client.status >= 200 && client.status < 300)) {
            var response = void 0;
            try {
                response = /** @type {CartoDBLayerInfo} */ (JSON.parse(client.responseText));
            }
            catch (err) {
                this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR);
                return;
            }
            this.applyTemplate_(response);
            this.templateCache_[paramHash] = response;
            this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].READY);
        }
        else {
            this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR);
        }
    };
    /**
     * @private
     * @param {Event} event Event.
     */
    CartoDB.prototype.handleInitError_ = function (event) {
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR);
    };
    /**
     * Apply the new tile urls returned by carto db
     * @param {CartoDBLayerInfo} data Result of carto db call.
     * @private
     */
    CartoDB.prototype.applyTemplate_ = function (data) {
        var tilesUrl = 'https://' +
            data.cdn_url.https +
            '/' +
            this.account_ +
            '/api/v1/map/' +
            data.layergroupid +
            '/{z}/{x}/{y}.png';
        this.setUrl(tilesUrl);
    };
    return CartoDB;
}(_XYZ_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CartoDB);
//# sourceMappingURL=CartoDB.js.map

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88);
/**
 * @module ol/source/XYZ
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {boolean} [opaque=false] Whether the layer is opaque.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {number} [maxZoom=42] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom=0] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Not used if `tileGrid` is provided.
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get
 * tile URL given a tile coordinate and the projection.
 * Required if `url` or `urls` are not provided.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`,
 * and `{z}` placeholders. A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`,
 * may be used instead of defining each one separately in the `urls` option.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data with URLs in a set XYZ format that are
 * defined in a URL template. By default, this follows the widely-used
 * Google grid where `x` 0 and `y` 0 are in the top left. Grids like
 * TMS where `x` 0 and `y` 0 are in the bottom left can be used by
 * using the `{-y}` placeholder in the URL template, so long as the
 * source does not have a custom tile grid. In this case
 * a `tileUrlFunction` can be used, such as:
 * ```js
 *  tileUrlFunction: function(coordinate) {
 *    return 'http://mapserver.com/' + coordinate[0] + '/' +
 *      coordinate[1] + '/' + (-coordinate[2] - 1) + '.png';
 *  }
 * ```
 * @api
 */
var XYZ = /** @class */ (function (_super) {
    __extends(XYZ, _super);
    /**
     * @param {Options} [opt_options] XYZ options.
     */
    function XYZ(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var projection = options.projection !== undefined ? options.projection : 'EPSG:3857';
        var tileGrid = options.tileGrid !== undefined
            ? options.tileGrid
            : Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_1__["createXYZ"])({
                extent: Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_1__["extentFromProjection"])(projection),
                maxResolution: options.maxResolution,
                maxZoom: options.maxZoom,
                minZoom: options.minZoom,
                tileSize: options.tileSize,
            });
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            opaque: options.opaque,
            projection: projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            attributionsCollapsible: options.attributionsCollapsible,
            zDirection: options.zDirection,
        }) || this;
        return _this;
    }
    return XYZ;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (XYZ);
//# sourceMappingURL=XYZ.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98);
/* harmony import */ var _Vector_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(105);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21);
/**
 * @module ol/source/Cluster
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [distance=20] Distance in pixels within which features will
 * be clustered together.
 * @property {number} [minDistance=0] Minimum distance in pixels between clusters.
 * Will be capped at the configured distance.
 * By default no minimum distance is guaranteed. This config can be used to avoid
 * overlapping icons. As a tradoff, the cluster feature's position will no longer be
 * the center of all its features.
 * @property {function(Feature):Point} [geometryFunction]
 * Function that takes an {@link module:ol/Feature} as argument and returns an
 * {@link module:ol/geom/Point} as cluster calculation point for the feature. When a
 * feature should not be considered for clustering, the function should return
 * `null`. The default, which works when the underlying source contains point
 * features only, is
 * ```js
 * function(feature) {
 *   return feature.getGeometry();
 * }
 * ```
 * See {@link module:ol/geom/Polygon~Polygon#getInteriorPoint} for a way to get a cluster
 * calculation point for polygons.
 * @property {VectorSource} [source] Source.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 */
/**
 * @classdesc
 * Layer source to cluster vector data. Works out of the box with point
 * geometries. For other geometry types, or if not all geometries should be
 * considered for clustering, a custom `geometryFunction` can be defined.
 *
 * If the instance is disposed without also disposing the underlying
 * source `setSource(null)` has to be called to remove the listener reference
 * from the wrapped source.
 * @api
 */
var Cluster = /** @class */ (function (_super) {
    __extends(Cluster, _super);
    /**
     * @param {Options} options Cluster options.
     */
    function Cluster(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            wrapX: options.wrapX,
        }) || this;
        /**
         * @type {number|undefined}
         * @protected
         */
        _this.resolution = undefined;
        /**
         * @type {number}
         * @protected
         */
        _this.distance = options.distance !== undefined ? options.distance : 20;
        /**
         * @type {number}
         * @protected
         */
        _this.minDistance = options.minDistance || 0;
        /**
         * @type {number}
         * @protected
         */
        _this.interpolationRatio = 0;
        /**
         * @type {Array<Feature>}
         * @protected
         */
        _this.features = [];
        /**
         * @param {Feature} feature Feature.
         * @return {Point} Cluster calculation point.
         * @protected
         */
        _this.geometryFunction =
            options.geometryFunction ||
                function (feature) {
                    var geometry = feature.getGeometry();
                    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT, 10); // The default `geometryFunction` can only handle `Point` geometries
                    return geometry;
                };
        /**
         * @type {VectorSource}
         * @protected
         */
        _this.source = null;
        _this.boundRefresh_ = _this.refresh.bind(_this);
        _this.updateDistance(_this.distance, _this.minDistance);
        _this.setSource(options.source || null);
        return _this;
    }
    /**
     * Remove all features from the source.
     * @param {boolean} [opt_fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#removefeature} events.
     * @api
     */
    Cluster.prototype.clear = function (opt_fast) {
        this.features.length = 0;
        _super.prototype.clear.call(this, opt_fast);
    };
    /**
     * Get the distance in pixels between clusters.
     * @return {number} Distance.
     * @api
     */
    Cluster.prototype.getDistance = function () {
        return this.distance;
    };
    /**
     * Get a reference to the wrapped source.
     * @return {VectorSource} Source.
     * @api
     */
    Cluster.prototype.getSource = function () {
        return this.source;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    Cluster.prototype.loadFeatures = function (extent, resolution, projection) {
        this.source.loadFeatures(extent, resolution, projection);
        if (resolution !== this.resolution) {
            this.resolution = resolution;
            this.refresh();
        }
    };
    /**
     * Set the distance within which features will be clusterd together.
     * @param {number} distance The distance in pixels.
     * @api
     */
    Cluster.prototype.setDistance = function (distance) {
        this.updateDistance(distance, this.minDistance);
    };
    /**
     * Set the minimum distance between clusters. Will be capped at the
     * configured distance.
     * @param {number} minDistance The minimum distance in pixels.
     * @api
     */
    Cluster.prototype.setMinDistance = function (minDistance) {
        this.updateDistance(this.distance, minDistance);
    };
    /**
     * The configured minimum distance between clusters.
     * @return {number} The minimum distance in pixels.
     * @api
     */
    Cluster.prototype.getMinDistance = function () {
        return this.minDistance;
    };
    /**
     * Replace the wrapped source.
     * @param {VectorSource} source The new source for this instance.
     * @api
     */
    Cluster.prototype.setSource = function (source) {
        if (this.source) {
            this.source.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.boundRefresh_);
        }
        this.source = source;
        if (source) {
            source.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.boundRefresh_);
        }
        this.refresh();
    };
    /**
     * Handle the source changing.
     */
    Cluster.prototype.refresh = function () {
        this.clear();
        this.cluster();
        this.addFeatures(this.features);
    };
    /**
     * Update the distances and refresh the source if necessary.
     * @param {number} distance The new distance.
     * @param {number} minDistance The new minimum distance.
     */
    Cluster.prototype.updateDistance = function (distance, minDistance) {
        var ratio = distance === 0 ? 0 : Math.min(minDistance, distance) / distance;
        var changed = distance !== this.distance || this.interpolationRatio !== ratio;
        this.distance = distance;
        this.minDistance = minDistance;
        this.interpolationRatio = ratio;
        if (changed) {
            this.refresh();
        }
    };
    /**
     * @protected
     */
    Cluster.prototype.cluster = function () {
        if (this.resolution === undefined || !this.source) {
            return;
        }
        var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["createEmpty"])();
        var mapDistance = this.distance * this.resolution;
        var features = this.source.getFeatures();
        /** @type {Object<string, true>} */
        var clustered = {};
        for (var i = 0, ii = features.length; i < ii; i++) {
            var feature = features[i];
            if (!(Object(_util_js__WEBPACK_IMPORTED_MODULE_8__["getUid"])(feature) in clustered)) {
                var geometry = this.geometryFunction(feature);
                if (geometry) {
                    var coordinates = geometry.getCoordinates();
                    Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["createOrUpdateFromCoordinate"])(coordinates, extent);
                    Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["buffer"])(extent, mapDistance, extent);
                    var neighbors = this.source
                        .getFeaturesInExtent(extent)
                        .filter(function (neighbor) {
                        var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_8__["getUid"])(neighbor);
                        if (uid in clustered) {
                            return false;
                        }
                        clustered[uid] = true;
                        return true;
                    });
                    this.features.push(this.createCluster(neighbors, extent));
                }
            }
        }
    };
    /**
     * @param {Array<Feature>} features Features
     * @param {import("../extent.js").Extent} extent The searched extent for these features.
     * @return {Feature} The cluster feature.
     * @protected
     */
    Cluster.prototype.createCluster = function (features, extent) {
        var centroid = [0, 0];
        for (var i = features.length - 1; i >= 0; --i) {
            var geometry_1 = this.geometryFunction(features[i]);
            if (geometry_1) {
                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_5__["add"])(centroid, geometry_1.getCoordinates());
            }
            else {
                features.splice(i, 1);
            }
        }
        Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_5__["scale"])(centroid, 1 / features.length);
        var searchCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["getCenter"])(extent);
        var ratio = this.interpolationRatio;
        var geometry = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_3__["default"]([
            centroid[0] * (1 - ratio) + searchCenter[0] * ratio,
            centroid[1] * (1 - ratio) + searchCenter[1] * ratio,
        ]);
        var cluster = new _Feature_js__WEBPACK_IMPORTED_MODULE_1__["default"](geometry);
        cluster.set('features', features, true);
        return cluster;
    };
    return Cluster;
}(_Vector_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Cluster);
//# sourceMappingURL=Cluster.js.map

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStyleFunction", function() { return createStyleFunction; });
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Feature
 */




/**
 * @typedef {typeof Feature|typeof import("./render/Feature.js").default} FeatureClass
 */
/**
 * @typedef {Feature|import("./render/Feature.js").default} FeatureLike
 */
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:geometry', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types
 *     |'change:geometry', Return>} FeatureOnSignature
 */
/**
 * @classdesc
 * A vector object for geographic features with a geometry and other
 * attribute properties, similar to the features in vector file formats like
 * GeoJSON.
 *
 * Features can be styled individually with `setStyle`; otherwise they use the
 * style of their vector layer.
 *
 * Note that attribute properties are set as {@link module:ol/Object} properties on
 * the feature object, so they are observable, and have get/set accessors.
 *
 * Typically, a feature has a single geometry property. You can set the
 * geometry using the `setGeometry` method and get it with `getGeometry`.
 * It is possible to store more than one geometry on a feature using attribute
 * properties. By default, the geometry used for rendering is identified by
 * the property name `geometry`. If you want to use another geometry property
 * for rendering, use the `setGeometryName` method to change the attribute
 * property associated with the geometry for the feature.  For example:
 *
 * ```js
 *
 * import Feature from 'ol/Feature';
 * import Polygon from 'ol/geom/Polygon';
 * import Point from 'ol/geom/Point';
 *
 * var feature = new Feature({
 *   geometry: new Polygon(polyCoords),
 *   labelPoint: new Point(labelCoords),
 *   name: 'My Polygon'
 * });
 *
 * // get the polygon geometry
 * var poly = feature.getGeometry();
 *
 * // Render the feature as a point using the coordinates from labelPoint
 * feature.setGeometryName('labelPoint');
 *
 * // get the point geometry
 * var point = feature.getGeometry();
 * ```
 *
 * @api
 * @template {import("./geom/Geometry.js").default} Geometry
 */
var Feature = /** @class */ (function (_super) {
    __extends(Feature, _super);
    /**
     * @param {Geometry|Object<string, *>} [opt_geometryOrProperties]
     *     You may pass a Geometry object directly, or an object literal containing
     *     properties. If you pass an object literal, you may include a Geometry
     *     associated with a `geometry` key.
     */
    function Feature(opt_geometryOrProperties) {
        var _this = _super.call(this) || this;
        /***
         * @type {FeatureOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {FeatureOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {FeatureOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {number|string|undefined}
         */
        _this.id_ = undefined;
        /**
         * @type {string}
         * @private
         */
        _this.geometryName_ = 'geometry';
        /**
         * User provided style.
         * @private
         * @type {import("./style/Style.js").StyleLike}
         */
        _this.style_ = null;
        /**
         * @private
         * @type {import("./style/Style.js").StyleFunction|undefined}
         */
        _this.styleFunction_ = undefined;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */
        _this.geometryChangeKey_ = null;
        _this.addChangeListener(_this.geometryName_, _this.handleGeometryChanged_);
        if (opt_geometryOrProperties) {
            if (typeof (
            /** @type {?} */ (opt_geometryOrProperties).getSimplifiedGeometry) === 'function') {
                var geometry = /** @type {Geometry} */ (opt_geometryOrProperties);
                _this.setGeometry(geometry);
            }
            else {
                /** @type {Object<string, *>} */
                var properties = opt_geometryOrProperties;
                _this.setProperties(properties);
            }
        }
        return _this;
    }
    /**
     * Clone this feature. If the original feature has a geometry it
     * is also cloned. The feature id is not set in the clone.
     * @return {Feature} The clone.
     * @api
     */
    Feature.prototype.clone = function () {
        var clone = new Feature(this.hasProperties() ? this.getProperties() : null);
        clone.setGeometryName(this.getGeometryName());
        var geometry = this.getGeometry();
        if (geometry) {
            clone.setGeometry(geometry.clone());
        }
        var style = this.getStyle();
        if (style) {
            clone.setStyle(style);
        }
        return clone;
    };
    /**
     * Get the feature's default geometry.  A feature may have any number of named
     * geometries.  The "default" geometry (the one that is rendered by default) is
     * set when calling {@link module:ol/Feature~Feature#setGeometry}.
     * @return {Geometry|undefined} The default geometry for the feature.
     * @api
     * @observable
     */
    Feature.prototype.getGeometry = function () {
        return /** @type {Geometry|undefined} */ (this.get(this.geometryName_));
    };
    /**
     * Get the feature identifier.  This is a stable identifier for the feature and
     * is either set when reading data from a remote source or set explicitly by
     * calling {@link module:ol/Feature~Feature#setId}.
     * @return {number|string|undefined} Id.
     * @api
     */
    Feature.prototype.getId = function () {
        return this.id_;
    };
    /**
     * Get the name of the feature's default geometry.  By default, the default
     * geometry is named `geometry`.
     * @return {string} Get the property name associated with the default geometry
     *     for this feature.
     * @api
     */
    Feature.prototype.getGeometryName = function () {
        return this.geometryName_;
    };
    /**
     * Get the feature's style. Will return what was provided to the
     * {@link module:ol/Feature~Feature#setStyle} method.
     * @return {import("./style/Style.js").StyleLike|undefined} The feature style.
     * @api
     */
    Feature.prototype.getStyle = function () {
        return this.style_;
    };
    /**
     * Get the feature's style function.
     * @return {import("./style/Style.js").StyleFunction|undefined} Return a function
     * representing the current style of this feature.
     * @api
     */
    Feature.prototype.getStyleFunction = function () {
        return this.styleFunction_;
    };
    /**
     * @private
     */
    Feature.prototype.handleGeometryChange_ = function () {
        this.changed();
    };
    /**
     * @private
     */
    Feature.prototype.handleGeometryChanged_ = function () {
        if (this.geometryChangeKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["unlistenByKey"])(this.geometryChangeKey_);
            this.geometryChangeKey_ = null;
        }
        var geometry = this.getGeometry();
        if (geometry) {
            this.geometryChangeKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["listen"])(geometry, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, this.handleGeometryChange_, this);
        }
        this.changed();
    };
    /**
     * Set the default geometry for the feature.  This will update the property
     * with the name returned by {@link module:ol/Feature~Feature#getGeometryName}.
     * @param {Geometry|undefined} geometry The new geometry.
     * @api
     * @observable
     */
    Feature.prototype.setGeometry = function (geometry) {
        this.set(this.geometryName_, geometry);
    };
    /**
     * Set the style for the feature to override the layer style.  This can be a
     * single style object, an array of styles, or a function that takes a
     * resolution and returns an array of styles. To unset the feature style, call
     * `setStyle()` without arguments or a falsey value.
     * @param {import("./style/Style.js").StyleLike} [opt_style] Style for this feature.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */
    Feature.prototype.setStyle = function (opt_style) {
        this.style_ = opt_style;
        this.styleFunction_ = !opt_style
            ? undefined
            : createStyleFunction(opt_style);
        this.changed();
    };
    /**
     * Set the feature id.  The feature id is considered stable and may be used when
     * requesting features or comparing identifiers returned from a remote source.
     * The feature id can be used with the
     * {@link module:ol/source/Vector~VectorSource#getFeatureById} method.
     * @param {number|string|undefined} id The feature id.
     * @api
     * @fires module:ol/events/Event~BaseEvent#event:change
     */
    Feature.prototype.setId = function (id) {
        this.id_ = id;
        this.changed();
    };
    /**
     * Set the property name to be used when getting the feature's default geometry.
     * When calling {@link module:ol/Feature~Feature#getGeometry}, the value of the property with
     * this name will be returned.
     * @param {string} name The property name of the default geometry.
     * @api
     */
    Feature.prototype.setGeometryName = function (name) {
        this.removeChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.geometryName_ = name;
        this.addChangeListener(this.geometryName_, this.handleGeometryChanged_);
        this.handleGeometryChanged_();
    };
    return Feature;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Convert the provided object into a feature style function.  Functions passed
 * through unchanged.  Arrays of Style or single style objects wrapped
 * in a new feature style function.
 * @param {!import("./style/Style.js").StyleFunction|!Array<import("./style/Style.js").default>|!import("./style/Style.js").default} obj
 *     A feature style function, a single style, or an array of styles.
 * @return {import("./style/Style.js").StyleFunction} A style function.
 */
function createStyleFunction(obj) {
    if (typeof obj === 'function') {
        return obj;
    }
    else {
        /**
         * @type {Array<import("./style/Style.js").default>}
         */
        var styles_1;
        if (Array.isArray(obj)) {
            styles_1 = obj;
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_2__["assert"])(typeof ( /** @type {?} */(obj).getZIndex) === 'function', 41); // Expected an `import("./style/Style.js").Style` or an array of `import("./style/Style.js").Style`
            var style = /** @type {import("./style/Style.js").default} */ (obj);
            styles_1 = [style];
        }
        return function () {
            return styles_1;
        };
    }
}
/* harmony default export */ __webpack_exports__["default"] = (Feature);
//# sourceMappingURL=Feature.js.map

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(104);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/Point
 */





/**
 * @classdesc
 * Point geometry.
 *
 * @api
 */
var Point = /** @class */ (function (_super) {
    __extends(Point, _super);
    /**
     * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    function Point(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        _this.setCoordinates(coordinates, opt_layout);
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!Point} Clone.
     * @api
     */
    Point.prototype.clone = function () {
        var point = new Point(this.flatCoordinates.slice(), this.layout);
        point.applyProperties(this);
        return point;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    Point.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        var flatCoordinates = this.flatCoordinates;
        var squaredDistance = Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["squaredDistance"])(x, y, flatCoordinates[0], flatCoordinates[1]);
        if (squaredDistance < minSquaredDistance) {
            var stride = this.stride;
            for (var i = 0; i < stride; ++i) {
                closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = stride;
            return squaredDistance;
        }
        else {
            return minSquaredDistance;
        }
    };
    /**
     * Return the coordinate of the point.
     * @return {import("../coordinate.js").Coordinate} Coordinates.
     * @api
     */
    Point.prototype.getCoordinates = function () {
        return !this.flatCoordinates ? [] : this.flatCoordinates.slice();
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */
    Point.prototype.computeExtent = function (extent) {
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createOrUpdateFromCoordinate"])(this.flatCoordinates, extent);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    Point.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POINT;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    Point.prototype.intersectsExtent = function (extent) {
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["containsXY"])(extent, this.flatCoordinates[0], this.flatCoordinates[1]);
    };
    /**
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    Point.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 0);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        this.flatCoordinates.length = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_3__["deflateCoordinate"])(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return Point;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Point);
//# sourceMappingURL=Point.js.map

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStrideForLayout", function() { return getStrideForLayout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformGeom2D", function() { return transformGeom2D; });
/* harmony import */ var _Geometry_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(100);
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _flat_transform_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(102);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/SimpleGeometry
 */





/**
 * @classdesc
 * Abstract base class; only used for creating subclasses; do not instantiate
 * in apps, as cannot be rendered.
 *
 * @abstract
 * @api
 */
var SimpleGeometry = /** @class */ (function (_super) {
    __extends(SimpleGeometry, _super);
    function SimpleGeometry() {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {import("./GeometryLayout.js").default}
         */
        _this.layout = _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
        /**
         * @protected
         * @type {number}
         */
        _this.stride = 2;
        /**
         * @protected
         * @type {Array<number>}
         */
        _this.flatCoordinates = null;
        return _this;
    }
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */
    SimpleGeometry.prototype.computeExtent = function (extent) {
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["createOrUpdateFromFlatCoordinates"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * @abstract
     * @return {Array<*>} Coordinates.
     */
    SimpleGeometry.prototype.getCoordinates = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Return the first coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} First coordinate.
     * @api
     */
    SimpleGeometry.prototype.getFirstCoordinate = function () {
        return this.flatCoordinates.slice(0, this.stride);
    };
    /**
     * @return {Array<number>} Flat coordinates.
     */
    SimpleGeometry.prototype.getFlatCoordinates = function () {
        return this.flatCoordinates;
    };
    /**
     * Return the last coordinate of the geometry.
     * @return {import("../coordinate.js").Coordinate} Last point.
     * @api
     */
    SimpleGeometry.prototype.getLastCoordinate = function () {
        return this.flatCoordinates.slice(this.flatCoordinates.length - this.stride);
    };
    /**
     * Return the {@link module:ol/geom/GeometryLayout layout} of the geometry.
     * @return {import("./GeometryLayout.js").default} Layout.
     * @api
     */
    SimpleGeometry.prototype.getLayout = function () {
        return this.layout;
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker algorithm.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     */
    SimpleGeometry.prototype.getSimplifiedGeometry = function (squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        // If squaredTolerance is negative or if we know that simplification will not
        // have any effect then just return this.
        if (squaredTolerance < 0 ||
            (this.simplifiedGeometryMaxMinSquaredTolerance !== 0 &&
                squaredTolerance <= this.simplifiedGeometryMaxMinSquaredTolerance)) {
            return this;
        }
        var simplifiedGeometry = this.getSimplifiedGeometryInternal(squaredTolerance);
        var simplifiedFlatCoordinates = simplifiedGeometry.getFlatCoordinates();
        if (simplifiedFlatCoordinates.length < this.flatCoordinates.length) {
            return simplifiedGeometry;
        }
        else {
            // Simplification did not actually remove any coordinates.  We now know
            // that any calls to getSimplifiedGeometry with a squaredTolerance less
            // than or equal to the current squaredTolerance will also not have any
            // effect.  This allows us to short circuit simplification (saving CPU
            // cycles) and prevents the cache of simplified geometries from filling
            // up with useless identical copies of this geometry (saving memory).
            this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
            return this;
        }
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {SimpleGeometry} Simplified geometry.
     * @protected
     */
    SimpleGeometry.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        return this;
    };
    /**
     * @return {number} Stride.
     */
    SimpleGeometry.prototype.getStride = function () {
        return this.stride;
    };
    /**
     * @param {import("./GeometryLayout.js").default} layout Layout.
     * @param {Array<number>} flatCoordinates Flat coordinates.
     */
    SimpleGeometry.prototype.setFlatCoordinates = function (layout, flatCoordinates) {
        this.stride = getStrideForLayout(layout);
        this.layout = layout;
        this.flatCoordinates = flatCoordinates;
    };
    /**
     * @abstract
     * @param {!Array<*>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    SimpleGeometry.prototype.setCoordinates = function (coordinates, opt_layout) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @param {import("./GeometryLayout.js").default|undefined} layout Layout.
     * @param {Array<*>} coordinates Coordinates.
     * @param {number} nesting Nesting.
     * @protected
     */
    SimpleGeometry.prototype.setLayout = function (layout, coordinates, nesting) {
        /** @type {number} */
        var stride;
        if (layout) {
            stride = getStrideForLayout(layout);
        }
        else {
            for (var i = 0; i < nesting; ++i) {
                if (coordinates.length === 0) {
                    this.layout = _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
                    this.stride = 2;
                    return;
                }
                else {
                    coordinates = /** @type {Array} */ (coordinates[0]);
                }
            }
            stride = coordinates.length;
            layout = getLayoutForStride(stride);
        }
        this.layout = layout;
        this.stride = stride;
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     * @api
     */
    SimpleGeometry.prototype.applyTransform = function (transformFn) {
        if (this.flatCoordinates) {
            transformFn(this.flatCoordinates, this.flatCoordinates, this.stride);
            this.changed();
        }
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in counter-clockwise radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */
    SimpleGeometry.prototype.rotate = function (angle, anchor) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["rotate"])(flatCoordinates, 0, flatCoordinates.length, stride, angle, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */
    SimpleGeometry.prototype.scale = function (sx, opt_sy, opt_anchor) {
        var sy = opt_sy;
        if (sy === undefined) {
            sy = sx;
        }
        var anchor = opt_anchor;
        if (!anchor) {
            anchor = Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["getCenter"])(this.getExtent());
        }
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["scale"])(flatCoordinates, 0, flatCoordinates.length, stride, sx, sy, anchor, flatCoordinates);
            this.changed();
        }
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */
    SimpleGeometry.prototype.translate = function (deltaX, deltaY) {
        var flatCoordinates = this.getFlatCoordinates();
        if (flatCoordinates) {
            var stride = this.getStride();
            Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["translate"])(flatCoordinates, 0, flatCoordinates.length, stride, deltaX, deltaY, flatCoordinates);
            this.changed();
        }
    };
    return SimpleGeometry;
}(_Geometry_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {number} stride Stride.
 * @return {import("./GeometryLayout.js").default} layout Layout.
 */
function getLayoutForStride(stride) {
    var layout;
    if (stride == 2) {
        layout = _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
    }
    else if (stride == 3) {
        layout = _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ;
    }
    else if (stride == 4) {
        layout = _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM;
    }
    return /** @type {import("./GeometryLayout.js").default} */ (layout);
}
/**
 * @param {import("./GeometryLayout.js").default} layout Layout.
 * @return {number} Stride.
 */
function getStrideForLayout(layout) {
    var stride;
    if (layout == _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY) {
        stride = 2;
    }
    else if (layout == _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ || layout == _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM) {
        stride = 3;
    }
    else if (layout == _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM) {
        stride = 4;
    }
    return /** @type {number} */ (stride);
}
/**
 * @param {SimpleGeometry} simpleGeometry Simple geometry.
 * @param {import("../transform.js").Transform} transform Transform.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed flat coordinates.
 */
function transformGeom2D(simpleGeometry, transform, opt_dest) {
    var flatCoordinates = simpleGeometry.getFlatCoordinates();
    if (!flatCoordinates) {
        return null;
    }
    else {
        var stride = simpleGeometry.getStride();
        return Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["transform2D"])(flatCoordinates, 0, flatCoordinates.length, stride, transform, opt_dest);
    }
}
/* harmony default export */ __webpack_exports__["default"] = (SimpleGeometry);
//# sourceMappingURL=SimpleGeometry.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51);
/* harmony import */ var _flat_transform_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(102);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/Geometry
 */








/**
 * @type {import("../transform.js").Transform}
 */
var tmpTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for vector geometries.
 *
 * To get notified of changes to the geometry, register a listener for the
 * generic `change` event on your geometry instance.
 *
 * @abstract
 * @api
 */
var Geometry = /** @class */ (function (_super) {
    __extends(Geometry, _super);
    function Geometry() {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.extent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createEmpty"])();
        /**
         * @private
         * @type {number}
         */
        _this.extentRevision_ = -1;
        /**
         * @protected
         * @type {number}
         */
        _this.simplifiedGeometryMaxMinSquaredTolerance = 0;
        /**
         * @protected
         * @type {number}
         */
        _this.simplifiedGeometryRevision = 0;
        /**
         * Get a transformed and simplified version of the geometry.
         * @abstract
         * @param {number} revision The geometry revision.
         * @param {number} squaredTolerance Squared tolerance.
         * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
         * @return {Geometry} Simplified geometry.
         */
        _this.simplifyTransformedInternal = Object(_functions_js__WEBPACK_IMPORTED_MODULE_6__["memoizeOne"])(function (revision, squaredTolerance, opt_transform) {
            if (!opt_transform) {
                return this.getSimplifiedGeometry(squaredTolerance);
            }
            var clone = this.clone();
            clone.applyTransform(opt_transform);
            return clone.getSimplifiedGeometry(squaredTolerance);
        });
        return _this;
    }
    /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
     * @return {Geometry} Simplified geometry.
     */
    Geometry.prototype.simplifyTransformed = function (squaredTolerance, opt_transform) {
        return this.simplifyTransformedInternal(this.getRevision(), squaredTolerance, opt_transform);
    };
    /**
     * Make a complete copy of the geometry.
     * @abstract
     * @return {!Geometry} Clone.
     */
    Geometry.prototype.clone = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @abstract
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    Geometry.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */
    Geometry.prototype.containsXY = function (x, y) {
        var coord = this.getClosestPoint([x, y]);
        return coord[0] === x && coord[1] === y;
    };
    /**
     * Return the closest point of the geometry to the passed point as
     * {@link module:ol/coordinate~Coordinate coordinate}.
     * @param {import("../coordinate.js").Coordinate} point Point.
     * @param {import("../coordinate.js").Coordinate} [opt_closestPoint] Closest point.
     * @return {import("../coordinate.js").Coordinate} Closest point.
     * @api
     */
    Geometry.prototype.getClosestPoint = function (point, opt_closestPoint) {
        var closestPoint = opt_closestPoint ? opt_closestPoint : [NaN, NaN];
        this.closestPointXY(point[0], point[1], closestPoint, Infinity);
        return closestPoint;
    };
    /**
     * Returns true if this geometry includes the specified coordinate. If the
     * coordinate is on the boundary of the geometry, returns false.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains coordinate.
     * @api
     */
    Geometry.prototype.intersectsCoordinate = function (coordinate) {
        return this.containsXY(coordinate[0], coordinate[1]);
    };
    /**
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */
    Geometry.prototype.computeExtent = function (extent) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Get the extent of the geometry.
     * @param {import("../extent.js").Extent} [opt_extent] Extent.
     * @return {import("../extent.js").Extent} extent Extent.
     * @api
     */
    Geometry.prototype.getExtent = function (opt_extent) {
        if (this.extentRevision_ != this.getRevision()) {
            var extent = this.computeExtent(this.extent_);
            if (isNaN(extent[0]) || isNaN(extent[1])) {
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdateEmpty"])(extent);
            }
            this.extentRevision_ = this.getRevision();
        }
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["returnOrUpdate"])(this.extent_, opt_extent);
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} angle Rotation angle in radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */
    Geometry.prototype.rotate = function (angle, anchor) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */
    Geometry.prototype.scale = function (sx, opt_sy, opt_anchor) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Create a simplified version of this geometry.  For linestrings, this uses
     * the [Douglas Peucker](https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm)
     * algorithm.  For polygons, a quantization-based
     * simplification is used to preserve topology.
     * @param {number} tolerance The tolerance distance for simplification.
     * @return {Geometry} A new, simplified version of the original geometry.
     * @api
     */
    Geometry.prototype.simplify = function (tolerance) {
        return this.getSimplifiedGeometry(tolerance * tolerance);
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker
     * algorithm.
     * See https://en.wikipedia.org/wiki/Ramer-Douglas-Peucker_algorithm.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Geometry} Simplified geometry.
     */
    Geometry.prototype.getSimplifiedGeometry = function (squaredTolerance) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Get the type of this geometry.
     * @abstract
     * @return {import("./GeometryType.js").default} Geometry type.
     */
    Geometry.prototype.getType = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @abstract
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     */
    Geometry.prototype.applyTransform = function (transformFn) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     */
    Geometry.prototype.intersectsExtent = function (extent) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @abstract
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */
    Geometry.prototype.translate = function (deltaX, deltaY) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Transform each coordinate of the geometry from one coordinate reference
     * system to another. The geometry is modified in place.
     * For example, a line will be transformed to a line and a circle to a circle.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     *
     * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
     *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
     * @return {Geometry} This geometry.  Note that original geometry is
     *     modified in place.
     * @api
     */
    Geometry.prototype.transform = function (source, destination) {
        /** @type {import("../proj/Projection.js").default} */
        var sourceProj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_5__["get"])(source);
        var transformFn = sourceProj.getUnits() == _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].TILE_PIXELS
            ? function (inCoordinates, outCoordinates, stride) {
                var pixelExtent = sourceProj.getExtent();
                var projectedExtent = sourceProj.getWorldExtent();
                var scale = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getHeight"])(projectedExtent) / Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getHeight"])(pixelExtent);
                Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
                Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__["transform2D"])(inCoordinates, 0, inCoordinates.length, stride, tmpTransform, outCoordinates);
                return Object(_proj_js__WEBPACK_IMPORTED_MODULE_5__["getTransform"])(sourceProj, destination)(inCoordinates, outCoordinates, stride);
            }
            : Object(_proj_js__WEBPACK_IMPORTED_MODULE_5__["getTransform"])(sourceProj, destination);
        this.applyTransform(transformFn);
        return this;
    };
    return Geometry;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Geometry);
//# sourceMappingURL=Geometry.js.map

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reset", function() { return reset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multiply", function() { return multiply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "set", function() { return set; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setFromArray", function() { return setFromArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return apply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rotate", function() { return rotate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scale", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeScale", function() { return makeScale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "translate", function() { return translate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composeCssTransform", function() { return composeCssTransform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invert", function() { return invert; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeInverse", function() { return makeInverse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "determinant", function() { return determinant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toString", function() { return toString; });
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19);
/**
 * @module ol/transform
 */


/**
 * An array representing an affine 2d transformation for use with
 * {@link module:ol/transform} functions. The array has 6 elements.
 * @typedef {!Array<number>} Transform
 * @api
 */
/**
 * Collection of affine 2d transformation functions. The functions work on an
 * array of 6 elements. The element order is compatible with the [SVGMatrix
 * interface](https://developer.mozilla.org/en-US/docs/Web/API/SVGMatrix) and is
 * a subset (elements a to f) of a 3×3 matrix:
 * ```
 * [ a c e ]
 * [ b d f ]
 * [ 0 0 1 ]
 * ```
 */
/**
 * @private
 * @type {Transform}
 */
var tmp_ = new Array(6);
/**
 * Create an identity transform.
 * @return {!Transform} Identity transform.
 */
function create() {
    return [1, 0, 0, 1, 0, 0];
}
/**
 * Resets the given transform to an identity transform.
 * @param {!Transform} transform Transform.
 * @return {!Transform} Transform.
 */
function reset(transform) {
    return set(transform, 1, 0, 0, 1, 0, 0);
}
/**
 * Multiply the underlying matrices of two transforms and return the result in
 * the first transform.
 * @param {!Transform} transform1 Transform parameters of matrix 1.
 * @param {!Transform} transform2 Transform parameters of matrix 2.
 * @return {!Transform} transform1 multiplied with transform2.
 */
function multiply(transform1, transform2) {
    var a1 = transform1[0];
    var b1 = transform1[1];
    var c1 = transform1[2];
    var d1 = transform1[3];
    var e1 = transform1[4];
    var f1 = transform1[5];
    var a2 = transform2[0];
    var b2 = transform2[1];
    var c2 = transform2[2];
    var d2 = transform2[3];
    var e2 = transform2[4];
    var f2 = transform2[5];
    transform1[0] = a1 * a2 + c1 * b2;
    transform1[1] = b1 * a2 + d1 * b2;
    transform1[2] = a1 * c2 + c1 * d2;
    transform1[3] = b1 * c2 + d1 * d2;
    transform1[4] = a1 * e2 + c1 * f2 + e1;
    transform1[5] = b1 * e2 + d1 * f2 + f1;
    return transform1;
}
/**
 * Set the transform components a-f on a given transform.
 * @param {!Transform} transform Transform.
 * @param {number} a The a component of the transform.
 * @param {number} b The b component of the transform.
 * @param {number} c The c component of the transform.
 * @param {number} d The d component of the transform.
 * @param {number} e The e component of the transform.
 * @param {number} f The f component of the transform.
 * @return {!Transform} Matrix with transform applied.
 */
function set(transform, a, b, c, d, e, f) {
    transform[0] = a;
    transform[1] = b;
    transform[2] = c;
    transform[3] = d;
    transform[4] = e;
    transform[5] = f;
    return transform;
}
/**
 * Set transform on one matrix from another matrix.
 * @param {!Transform} transform1 Matrix to set transform to.
 * @param {!Transform} transform2 Matrix to set transform from.
 * @return {!Transform} transform1 with transform from transform2 applied.
 */
function setFromArray(transform1, transform2) {
    transform1[0] = transform2[0];
    transform1[1] = transform2[1];
    transform1[2] = transform2[2];
    transform1[3] = transform2[3];
    transform1[4] = transform2[4];
    transform1[5] = transform2[5];
    return transform1;
}
/**
 * Transforms the given coordinate with the given transform returning the
 * resulting, transformed coordinate. The coordinate will be modified in-place.
 *
 * @param {Transform} transform The transformation.
 * @param {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} coordinate The coordinate to transform.
 * @return {import("./coordinate.js").Coordinate|import("./pixel.js").Pixel} return coordinate so that operations can be
 *     chained together.
 */
function apply(transform, coordinate) {
    var x = coordinate[0];
    var y = coordinate[1];
    coordinate[0] = transform[0] * x + transform[2] * y + transform[4];
    coordinate[1] = transform[1] * x + transform[3] * y + transform[5];
    return coordinate;
}
/**
 * Applies rotation to the given transform.
 * @param {!Transform} transform Transform.
 * @param {number} angle Angle in radians.
 * @return {!Transform} The rotated transform.
 */
function rotate(transform, angle) {
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    return multiply(transform, set(tmp_, cos, sin, -sin, cos, 0, 0));
}
/**
 * Applies scale to a given transform.
 * @param {!Transform} transform Transform.
 * @param {number} x Scale factor x.
 * @param {number} y Scale factor y.
 * @return {!Transform} The scaled transform.
 */
function scale(transform, x, y) {
    return multiply(transform, set(tmp_, x, 0, 0, y, 0, 0));
}
/**
 * Creates a scale transform.
 * @param {!Transform} target Transform to overwrite.
 * @param {number} x Scale factor x.
 * @param {number} y Scale factor y.
 * @return {!Transform} The scale transform.
 */
function makeScale(target, x, y) {
    return set(target, x, 0, 0, y, 0, 0);
}
/**
 * Applies translation to the given transform.
 * @param {!Transform} transform Transform.
 * @param {number} dx Translation x.
 * @param {number} dy Translation y.
 * @return {!Transform} The translated transform.
 */
function translate(transform, dx, dy) {
    return multiply(transform, set(tmp_, 1, 0, 0, 1, dx, dy));
}
/**
 * Creates a composite transform given an initial translation, scale, rotation, and
 * final translation (in that order only, not commutative).
 * @param {!Transform} transform The transform (will be modified in place).
 * @param {number} dx1 Initial translation x.
 * @param {number} dy1 Initial translation y.
 * @param {number} sx Scale factor x.
 * @param {number} sy Scale factor y.
 * @param {number} angle Rotation (in counter-clockwise radians).
 * @param {number} dx2 Final translation x.
 * @param {number} dy2 Final translation y.
 * @return {!Transform} The composite transform.
 */
function compose(transform, dx1, dy1, sx, sy, angle, dx2, dy2) {
    var sin = Math.sin(angle);
    var cos = Math.cos(angle);
    transform[0] = sx * cos;
    transform[1] = sy * sin;
    transform[2] = -sx * sin;
    transform[3] = sy * cos;
    transform[4] = dx2 * sx * cos - dy2 * sx * sin + dx1;
    transform[5] = dx2 * sy * sin + dy2 * sy * cos + dy1;
    return transform;
}
/**
 * Creates a composite transform given an initial translation, scale, rotation, and
 * final translation (in that order only, not commutative). The resulting transform
 * string can be applied as `transform` property of an HTMLElement's style.
 * @param {number} dx1 Initial translation x.
 * @param {number} dy1 Initial translation y.
 * @param {number} sx Scale factor x.
 * @param {number} sy Scale factor y.
 * @param {number} angle Rotation (in counter-clockwise radians).
 * @param {number} dx2 Final translation x.
 * @param {number} dy2 Final translation y.
 * @return {string} The composite css transform.
 * @api
 */
function composeCssTransform(dx1, dy1, sx, sy, angle, dx2, dy2) {
    return toString(compose(create(), dx1, dy1, sx, sy, angle, dx2, dy2));
}
/**
 * Invert the given transform.
 * @param {!Transform} source The source transform to invert.
 * @return {!Transform} The inverted (source) transform.
 */
function invert(source) {
    return makeInverse(source, source);
}
/**
 * Invert the given transform.
 * @param {!Transform} target Transform to be set as the inverse of
 *     the source transform.
 * @param {!Transform} source The source transform to invert.
 * @return {!Transform} The inverted (target) transform.
 */
function makeInverse(target, source) {
    var det = determinant(source);
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_1__["assert"])(det !== 0, 32); // Transformation matrix cannot be inverted
    var a = source[0];
    var b = source[1];
    var c = source[2];
    var d = source[3];
    var e = source[4];
    var f = source[5];
    target[0] = d / det;
    target[1] = -b / det;
    target[2] = -c / det;
    target[3] = a / det;
    target[4] = (c * f - d * e) / det;
    target[5] = -(a * f - b * e) / det;
    return target;
}
/**
 * Returns the determinant of the given matrix.
 * @param {!Transform} mat Matrix.
 * @return {number} Determinant.
 */
function determinant(mat) {
    return mat[0] * mat[3] - mat[1] * mat[2];
}
/**
 * @type {HTMLElement}
 * @private
 */
var transformStringDiv;
/**
 * A rounded string version of the transform.  This can be used
 * for CSS transforms.
 * @param {!Transform} mat Matrix.
 * @return {string} The transform as a string.
 */
function toString(mat) {
    var transformString = 'matrix(' + mat.join(', ') + ')';
    if (_has_js__WEBPACK_IMPORTED_MODULE_0__["WORKER_OFFSCREEN_CANVAS"]) {
        return transformString;
    }
    var node = transformStringDiv || (transformStringDiv = document.createElement('div'));
    node.style.transform = transformString;
    return node.style.transform;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transform2D", function() { return transform2D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "rotate", function() { return rotate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scale", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "translate", function() { return translate; });
/**
 * @module ol/geom/flat/transform
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../transform.js").Transform} transform Transform.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */
function transform2D(flatCoordinates, offset, end, stride, transform, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for (var j = offset; j < end; j += stride) {
        var x = flatCoordinates[j];
        var y = flatCoordinates[j + 1];
        dest[i++] = transform[0] * x + transform[2] * y + transform[4];
        dest[i++] = transform[1] * x + transform[3] * y + transform[5];
    }
    if (opt_dest && dest.length != i) {
        dest.length = i;
    }
    return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} angle Angle.
 * @param {Array<number>} anchor Rotation anchor point.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */
function rotate(flatCoordinates, offset, end, stride, angle, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var cos = Math.cos(angle);
    var sin = Math.sin(angle);
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for (var j = offset; j < end; j += stride) {
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + deltaX * cos - deltaY * sin;
        dest[i++] = anchorY + deltaX * sin + deltaY * cos;
        for (var k = j + 2; k < j + stride; ++k) {
            dest[i++] = flatCoordinates[k];
        }
    }
    if (opt_dest && dest.length != i) {
        dest.length = i;
    }
    return dest;
}
/**
 * Scale the coordinates.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} sx Scale factor in the x-direction.
 * @param {number} sy Scale factor in the y-direction.
 * @param {Array<number>} anchor Scale anchor point.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */
function scale(flatCoordinates, offset, end, stride, sx, sy, anchor, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var anchorX = anchor[0];
    var anchorY = anchor[1];
    var i = 0;
    for (var j = offset; j < end; j += stride) {
        var deltaX = flatCoordinates[j] - anchorX;
        var deltaY = flatCoordinates[j + 1] - anchorY;
        dest[i++] = anchorX + sx * deltaX;
        dest[i++] = anchorY + sy * deltaY;
        for (var k = j + 2; k < j + stride; ++k) {
            dest[i++] = flatCoordinates[k];
        }
    }
    if (opt_dest && dest.length != i) {
        dest.length = i;
    }
    return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} deltaX Delta X.
 * @param {number} deltaY Delta Y.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Transformed coordinates.
 */
function translate(flatCoordinates, offset, end, stride, deltaX, deltaY, opt_dest) {
    var dest = opt_dest ? opt_dest : [];
    var i = 0;
    for (var j = offset; j < end; j += stride) {
        dest[i++] = flatCoordinates[j] + deltaX;
        dest[i++] = flatCoordinates[j + 1] + deltaY;
        for (var k = j + 2; k < j + stride; ++k) {
            dest[i++] = flatCoordinates[k];
        }
    }
    if (opt_dest && dest.length != i) {
        dest.length = i;
    }
    return dest;
}
//# sourceMappingURL=transform.js.map

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/geom/GeometryLayout
 */
/**
 * The coordinate layout for geometries, indicating whether a 3rd or 4th z ('Z')
 * or measure ('M') coordinate is available. Supported values are `'XY'`,
 * `'XYZ'`, `'XYM'`, `'XYZM'`.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    XY: 'XY',
    XYZ: 'XYZ',
    XYM: 'XYM',
    XYZM: 'XYZM',
});
//# sourceMappingURL=GeometryLayout.js.map

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deflateCoordinate", function() { return deflateCoordinate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deflateCoordinates", function() { return deflateCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deflateCoordinatesArray", function() { return deflateCoordinatesArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deflateMultiCoordinatesArray", function() { return deflateMultiCoordinatesArray; });
/**
 * @module ol/geom/flat/deflate
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */
function deflateCoordinate(flatCoordinates, offset, coordinate, stride) {
    for (var i = 0, ii = coordinate.length; i < ii; ++i) {
        flatCoordinates[offset++] = coordinate[i];
    }
    return offset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<import("../../coordinate.js").Coordinate>} coordinates Coordinates.
 * @param {number} stride Stride.
 * @return {number} offset Offset.
 */
function deflateCoordinates(flatCoordinates, offset, coordinates, stride) {
    for (var i = 0, ii = coordinates.length; i < ii; ++i) {
        var coordinate = coordinates[i];
        for (var j = 0; j < stride; ++j) {
            flatCoordinates[offset++] = coordinate[j];
        }
    }
    return offset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} coordinatess Coordinatess.
 * @param {number} stride Stride.
 * @param {Array<number>} [opt_ends] Ends.
 * @return {Array<number>} Ends.
 */
function deflateCoordinatesArray(flatCoordinates, offset, coordinatess, stride, opt_ends) {
    var ends = opt_ends ? opt_ends : [];
    var i = 0;
    for (var j = 0, jj = coordinatess.length; j < jj; ++j) {
        var end = deflateCoordinates(flatCoordinates, offset, coordinatess[j], stride);
        ends[i++] = end;
        offset = end;
    }
    ends.length = i;
    return ends;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} coordinatesss Coordinatesss.
 * @param {number} stride Stride.
 * @param {Array<Array<number>>} [opt_endss] Endss.
 * @return {Array<Array<number>>} Endss.
 */
function deflateMultiCoordinatesArray(flatCoordinates, offset, coordinatesss, stride, opt_endss) {
    var endss = opt_endss ? opt_endss : [];
    var i = 0;
    for (var j = 0, jj = coordinatesss.length; j < jj; ++j) {
        var ends = deflateCoordinatesArray(flatCoordinates, offset, coordinatesss[j], stride, endss[i]);
        endss[i++] = ends;
        offset = ends[ends.length - 1];
    }
    endss.length = i;
    return endss;
}
//# sourceMappingURL=deflate.js.map

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VectorSourceEvent", function() { return VectorSourceEvent; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(107);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47);
/* harmony import */ var _structs_RBush_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(108);
/* harmony import */ var _Source_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70);
/* harmony import */ var _VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(110);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(51);
/* harmony import */ var _loadingstrategy_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(111);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(21);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(15);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(54);
/* harmony import */ var _featureloader_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(112);
/**
 * @module ol/source/Vector
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


















/**
 * A function that takes an {@link module:ol/extent~Extent} and a resolution as arguments, and
 * returns an array of {@link module:ol/extent~Extent} with the extents to load. Usually this
 * is one of the standard {@link module:ol/loadingstrategy} strategies.
 *
 * @typedef {function(import("../extent.js").Extent, number): Array<import("../extent.js").Extent>} LoadingStrategy
 * @api
 */
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Vector} instances are instances of this
 * type.
 * @template {import("../geom/Geometry.js").default} Geometry
 */
var VectorSourceEvent = /** @class */ (function (_super) {
    __extends(VectorSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Feature.js").default<Geometry>} [opt_feature] Feature.
     * @param {Array<import("../Feature.js").default<Geometry>>} [opt_features] Features.
     */
    function VectorSourceEvent(type, opt_feature, opt_features) {
        var _this = _super.call(this, type) || this;
        /**
         * The added or removed feature for the `ADDFEATURE` and `REMOVEFEATURE` events, `undefined` otherwise.
         * @type {import("../Feature.js").default<Geometry>|undefined}
         * @api
         */
        _this.feature = opt_feature;
        /**
         * The loaded features for the `FEATURESLOADED` event, `undefined` otherwise.
         * @type {Array<import("../Feature.js").default<Geometry>>|undefined}
         * @api
         */
        _this.features = opt_features;
        return _this;
    }
    return VectorSourceEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_2__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("./VectorEventType").VectorSourceEventTypes, VectorSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     import("./VectorEventType").VectorSourceEventTypes, Return>} VectorSourceOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {Array<import("../Feature.js").default>|Collection<import("../Feature.js").default>} [features]
 * Features. If provided as {@link module:ol/Collection}, the features in the source
 * and the collection will stay in sync.
 * @property {import("../format/Feature.js").default} [format] The feature format used by the XHR
 * feature loader when `url` is set. Required if `url` is set, otherwise ignored.
 * @property {import("../featureloader.js").FeatureLoader} [loader]
 * The loader function used to load features, from a remote source for example.
 * If this is not set and `url` is set, the source will create and use an XHR
 * feature loader. The `'featuresloadend'` and `'featuresloaderror'` events
 * will only fire if the `success` and `failure` callbacks are used.
 *
 * Example:
 *
 * ```js
 * import {Vector} from 'ol/source';
 * import {GeoJSON} from 'ol/format';
 * import {bbox} from 'ol/loadingstrategy';
 *
 * var vectorSource = new Vector({
 *   format: new GeoJSON(),
 *   loader: function(extent, resolution, projection, success, failure) {
 *      var proj = projection.getCode();
 *      var url = 'https://ahocevar.com/geoserver/wfs?service=WFS&' +
 *          'version=1.1.0&request=GetFeature&typename=osm:water_areas&' +
 *          'outputFormat=application/json&srsname=' + proj + '&' +
 *          'bbox=' + extent.join(',') + ',' + proj;
 *      var xhr = new XMLHttpRequest();
 *      xhr.open('GET', url);
 *      var onError = function() {
 *        vectorSource.removeLoadedExtent(extent);
 *        failure();
 *      }
 *      xhr.onerror = onError;
 *      xhr.onload = function() {
 *        if (xhr.status == 200) {
 *          var features = vectorSource.getFormat().readFeatures(xhr.responseText);
 *          vectorSource.addFeatures(features);
 *          success(features);
 *        } else {
 *          onError();
 *        }
 *      }
 *      xhr.send();
 *    },
 *    strategy: bbox
 *  });
 * ```
 * @property {boolean} [overlaps=true] This source may have overlapping geometries.
 * Setting this to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {LoadingStrategy} [strategy] The loading strategy to use.
 * By default an {@link module:ol/loadingstrategy.all}
 * strategy is used, a one-off strategy which loads all features at once.
 * @property {string|import("../featureloader.js").FeatureUrlFunction} [url]
 * Setting this option instructs the source to load features using an XHR loader
 * (see {@link module:ol/featureloader.xhr}). Use a `string` and an
 * {@link module:ol/loadingstrategy.all} for a one-off download of all features from
 * the given URL. Use a {@link module:ol/featureloader~FeatureUrlFunction} to generate the url with
 * other loading strategies.
 * Requires `format` to be set as well.
 * When default XHR feature loader is provided, the features will
 * be transformed from the data projection to the view projection
 * during parsing. If your remote data source does not advertise its projection
 * properly, this transformation will be incorrect. For some formats, the
 * default projection (usually EPSG:4326) can be overridden by setting the
 * dataProjection constructor option on the format.
 * Note that if a source contains non-feature data, such as a GeoJSON geometry
 * or a KML NetworkLink, these will be ignored. Use a custom loader to load these.
 * @property {boolean} [useSpatialIndex=true]
 * By default, an RTree is used as spatial index. When features are removed and
 * added frequently, and the total number of features is low, setting this to
 * `false` may improve performance.
 *
 * Note that
 * {@link module:ol/source/Vector~VectorSource#getFeaturesInExtent},
 * {@link module:ol/source/Vector~VectorSource#getClosestFeatureToCoordinate} and
 * {@link module:ol/source/Vector~VectorSource#getExtent} cannot be used when `useSpatialIndex` is
 * set to `false`, and {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent} will loop
 * through all features.
 *
 * When set to `false`, the features will be maintained in an
 * {@link module:ol/Collection}, which can be retrieved through
 * {@link module:ol/source/Vector~VectorSource#getFeaturesCollection}.
 * @property {boolean} [wrapX=true] Wrap the world horizontally. For vector editing across the
 * -180° and 180° meridians to work properly, this should be set to `false`. The
 * resulting geometry coordinates will then exceed the world bounds.
 */
/**
 * @classdesc
 * Provides a source of features for vector layers. Vector features provided
 * by this source are suitable for editing. See {@link module:ol/source/VectorTile~VectorTile} for
 * vector data that is optimized for rendering.
 *
 * @fires VectorSourceEvent
 * @api
 * @template {import("../geom/Geometry.js").default} Geometry
 */
var VectorSource = /** @class */ (function (_super) {
    __extends(VectorSource, _super);
    /**
     * @param {Options} [opt_options] Vector source options.
     */
    function VectorSource(opt_options) {
        var _this = this;
        var options = opt_options || {};
        _this = _super.call(this, {
            attributions: options.attributions,
            projection: undefined,
            state: _State_js__WEBPACK_IMPORTED_MODULE_7__["default"].READY,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
        }) || this;
        /***
         * @type {VectorSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {VectorSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {VectorSourceOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {import("../featureloader.js").FeatureLoader}
         */
        _this.loader_ = _functions_js__WEBPACK_IMPORTED_MODULE_9__["VOID"];
        /**
         * @private
         * @type {import("../format/Feature.js").default|undefined}
         */
        _this.format_ = options.format;
        /**
         * @private
         * @type {boolean}
         */
        _this.overlaps_ = options.overlaps === undefined ? true : options.overlaps;
        /**
         * @private
         * @type {string|import("../featureloader.js").FeatureUrlFunction|undefined}
         */
        _this.url_ = options.url;
        if (options.loader !== undefined) {
            _this.loader_ = options.loader;
        }
        else if (_this.url_ !== undefined) {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_11__["assert"])(_this.format_, 7); // `format` must be set when `url` is set
            // create a XHR feature loader for "url" and "format"
            _this.loader_ = Object(_featureloader_js__WEBPACK_IMPORTED_MODULE_17__["xhr"])(_this.url_, 
            /** @type {import("../format/Feature.js").default} */ (_this.format_));
        }
        /**
         * @private
         * @type {LoadingStrategy}
         */
        _this.strategy_ =
            options.strategy !== undefined ? options.strategy : _loadingstrategy_js__WEBPACK_IMPORTED_MODULE_10__["all"];
        var useSpatialIndex = options.useSpatialIndex !== undefined ? options.useSpatialIndex : true;
        /**
         * @private
         * @type {RBush<import("../Feature.js").default<Geometry>>}
         */
        _this.featuresRtree_ = useSpatialIndex ? new _structs_RBush_js__WEBPACK_IMPORTED_MODULE_5__["default"]() : null;
        /**
         * @private
         * @type {RBush<{extent: import("../extent.js").Extent}>}
         */
        _this.loadedExtentsRtree_ = new _structs_RBush_js__WEBPACK_IMPORTED_MODULE_5__["default"]();
        /**
         * @type {number}
         * @private
         */
        _this.loadingExtentsCount_ = 0;
        /**
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */
        _this.nullGeometryFeatures_ = {};
        /**
         * A lookup of features by id (the return from feature.getId()).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */
        _this.idIndex_ = {};
        /**
         * A lookup of features by uid (using getUid(feature)).
         * @private
         * @type {!Object<string, import("../Feature.js").default<Geometry>>}
         */
        _this.uidIndex_ = {};
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */
        _this.featureChangeKeys_ = {};
        /**
         * @private
         * @type {Collection<import("../Feature.js").default<Geometry>>}
         */
        _this.featuresCollection_ = null;
        var collection, features;
        if (Array.isArray(options.features)) {
            features = options.features;
        }
        else if (options.features) {
            collection = options.features;
            features = collection.getArray();
        }
        if (!useSpatialIndex && collection === undefined) {
            collection = new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"](features);
        }
        if (features !== undefined) {
            _this.addFeaturesInternal(features);
        }
        if (collection !== undefined) {
            _this.bindFeaturesCollection_(collection);
        }
        return _this;
    }
    /**
     * Add a single feature to the source.  If you want to add a batch of features
     * at once, call {@link module:ol/source/Vector~VectorSource#addFeatures #addFeatures()}
     * instead. A feature will not be added to the source if feature with
     * the same id is already there. The reason for this behavior is to avoid
     * feature duplication when using bbox or tile loading strategies.
     * Note: this also applies if an {@link module:ol/Collection} is used for features,
     * meaning that if a feature with a duplicate id is added in the collection, it will
     * be removed from it right away.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to add.
     * @api
     */
    VectorSource.prototype.addFeature = function (feature) {
        this.addFeatureInternal(feature);
        this.changed();
    };
    /**
     * Add a feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @protected
     */
    VectorSource.prototype.addFeatureInternal = function (feature) {
        var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
        if (!this.addToIndex_(featureKey, feature)) {
            if (this.featuresCollection_) {
                this.featuresCollection_.remove(feature);
            }
            return;
        }
        this.setupChangeEvents_(featureKey, feature);
        var geometry = feature.getGeometry();
        if (geometry) {
            var extent = geometry.getExtent();
            if (this.featuresRtree_) {
                this.featuresRtree_.insert(extent, feature);
            }
        }
        else {
            this.nullGeometryFeatures_[featureKey] = feature;
        }
        this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].ADDFEATURE, feature));
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @private
     */
    VectorSource.prototype.setupChangeEvents_ = function (featureKey, feature) {
        this.featureChangeKeys_[featureKey] = [
            Object(_events_js__WEBPACK_IMPORTED_MODULE_16__["listen"])(feature, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.handleFeatureChange_, this),
            Object(_events_js__WEBPACK_IMPORTED_MODULE_16__["listen"])(feature, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_4__["default"].PROPERTYCHANGE, this.handleFeatureChange_, this),
        ];
    };
    /**
     * @param {string} featureKey Unique identifier for the feature.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} The feature is "valid", in the sense that it is also a
     *     candidate for insertion into the Rtree.
     * @private
     */
    VectorSource.prototype.addToIndex_ = function (featureKey, feature) {
        var valid = true;
        var id = feature.getId();
        if (id !== undefined) {
            if (!(id.toString() in this.idIndex_)) {
                this.idIndex_[id.toString()] = feature;
            }
            else {
                valid = false;
            }
        }
        if (valid) {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_11__["assert"])(!(featureKey in this.uidIndex_), 30); // The passed `feature` was already added to the source
            this.uidIndex_[featureKey] = feature;
        }
        return valid;
    };
    /**
     * Add a batch of features to the source.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features to add.
     * @api
     */
    VectorSource.prototype.addFeatures = function (features) {
        this.addFeaturesInternal(features);
        this.changed();
    };
    /**
     * Add features without firing a `change` event.
     * @param {Array<import("../Feature.js").default<Geometry>>} features Features.
     * @protected
     */
    VectorSource.prototype.addFeaturesInternal = function (features) {
        var extents = [];
        var newFeatures = [];
        var geometryFeatures = [];
        for (var i = 0, length_1 = features.length; i < length_1; i++) {
            var feature = features[i];
            var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
            if (this.addToIndex_(featureKey, feature)) {
                newFeatures.push(feature);
            }
        }
        for (var i = 0, length_2 = newFeatures.length; i < length_2; i++) {
            var feature = newFeatures[i];
            var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
            this.setupChangeEvents_(featureKey, feature);
            var geometry = feature.getGeometry();
            if (geometry) {
                var extent = geometry.getExtent();
                extents.push(extent);
                geometryFeatures.push(feature);
            }
            else {
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        }
        if (this.featuresRtree_) {
            this.featuresRtree_.load(extents, geometryFeatures);
        }
        for (var i = 0, length_3 = newFeatures.length; i < length_3; i++) {
            this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].ADDFEATURE, newFeatures[i]));
        }
    };
    /**
     * @param {!Collection<import("../Feature.js").default<Geometry>>} collection Collection.
     * @private
     */
    VectorSource.prototype.bindFeaturesCollection_ = function (collection) {
        var modifyingCollection = false;
        this.addEventListener(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].ADDFEATURE, 
        /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */
        function (evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.push(evt.feature);
                modifyingCollection = false;
            }
        });
        this.addEventListener(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].REMOVEFEATURE, 
        /**
         * @param {VectorSourceEvent<Geometry>} evt The vector source event
         */
        function (evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                collection.remove(evt.feature);
                modifyingCollection = false;
            }
        });
        collection.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ADD, 
        /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */
        function (evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.addFeature(
                /** @type {import("../Feature.js").default<Geometry>} */ (evt.element));
                modifyingCollection = false;
            }
        }.bind(this));
        collection.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].REMOVE, 
        /**
         * @param {import("../Collection.js").CollectionEvent} evt The collection event
         */
        function (evt) {
            if (!modifyingCollection) {
                modifyingCollection = true;
                this.removeFeature(
                /** @type {import("../Feature.js").default<Geometry>} */ (evt.element));
                modifyingCollection = false;
            }
        }.bind(this));
        this.featuresCollection_ = collection;
    };
    /**
     * Remove all features from the source.
     * @param {boolean} [opt_fast] Skip dispatching of {@link module:ol/source/Vector.VectorSourceEvent#event:removefeature removefeature} events.
     * @api
     */
    VectorSource.prototype.clear = function (opt_fast) {
        if (opt_fast) {
            for (var featureId in this.featureChangeKeys_) {
                var keys = this.featureChangeKeys_[featureId];
                keys.forEach(_events_js__WEBPACK_IMPORTED_MODULE_16__["unlistenByKey"]);
            }
            if (!this.featuresCollection_) {
                this.featureChangeKeys_ = {};
                this.idIndex_ = {};
                this.uidIndex_ = {};
            }
        }
        else {
            if (this.featuresRtree_) {
                this.featuresRtree_.forEach(this.removeFeatureInternal.bind(this));
                for (var id in this.nullGeometryFeatures_) {
                    this.removeFeatureInternal(this.nullGeometryFeatures_[id]);
                }
            }
        }
        if (this.featuresCollection_) {
            this.featuresCollection_.clear();
        }
        if (this.featuresRtree_) {
            this.featuresRtree_.clear();
        }
        this.nullGeometryFeatures_ = {};
        var clearEvent = new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].CLEAR);
        this.dispatchEvent(clearEvent);
        this.changed();
    };
    /**
     * Iterate through all features on the source, calling the provided callback
     * with each one.  If the callback returns any "truthy" value, iteration will
     * stop and the function will return the same value.
     * Note: this function only iterate through the feature that have a defined geometry.
     *
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     on the source.  Return a truthy value to stop iteration.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */
    VectorSource.prototype.forEachFeature = function (callback) {
        if (this.featuresRtree_) {
            return this.featuresRtree_.forEach(callback);
        }
        else if (this.featuresCollection_) {
            this.featuresCollection_.forEach(callback);
        }
    };
    /**
     * Iterate through all features whose geometries contain the provided
     * coordinate, calling the callback with each feature.  If the callback returns
     * a "truthy" value, iteration will stop and the function will return the same
     * value.
     *
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose goemetry contains the provided coordinate.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     */
    VectorSource.prototype.forEachFeatureAtCoordinateDirect = function (coordinate, callback) {
        var extent = [coordinate[0], coordinate[1], coordinate[0], coordinate[1]];
        return this.forEachFeatureInExtent(extent, function (feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsCoordinate(coordinate)) {
                return callback(feature);
            }
            else {
                return undefined;
            }
        });
    };
    /**
     * Iterate through all features whose bounding box intersects the provided
     * extent (note that the feature's geometry may not intersect the extent),
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you are interested in features whose geometry intersects an extent, call
     * the {@link module:ol/source/Vector~VectorSource#forEachFeatureIntersectingExtent #forEachFeatureIntersectingExtent()} method instead.
     *
     * When `useSpatialIndex` is set to false, this method will loop through all
     * features, equivalent to {@link module:ol/source/Vector~VectorSource#forEachFeature #forEachFeature()}.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose bounding box intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */
    VectorSource.prototype.forEachFeatureInExtent = function (extent, callback) {
        if (this.featuresRtree_) {
            return this.featuresRtree_.forEachInExtent(extent, callback);
        }
        else if (this.featuresCollection_) {
            this.featuresCollection_.forEach(callback);
        }
    };
    /**
     * Iterate through all features whose geometry intersects the provided extent,
     * calling the callback with each feature.  If the callback returns a "truthy"
     * value, iteration will stop and the function will return the same value.
     *
     * If you only want to test for bounding box intersection, call the
     * {@link module:ol/source/Vector~VectorSource#forEachFeatureInExtent #forEachFeatureInExtent()} method instead.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(import("../Feature.js").default<Geometry>): T} callback Called with each feature
     *     whose geometry intersects the provided extent.
     * @return {T|undefined} The return value from the last call to the callback.
     * @template T
     * @api
     */
    VectorSource.prototype.forEachFeatureIntersectingExtent = function (extent, callback) {
        return this.forEachFeatureInExtent(extent, 
        /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         * @return {T|undefined} The return value from the last call to the callback.
         */
        function (feature) {
            var geometry = feature.getGeometry();
            if (geometry.intersectsExtent(extent)) {
                var result = callback(feature);
                if (result) {
                    return result;
                }
            }
        });
    };
    /**
     * Get the features collection associated with this source. Will be `null`
     * unless the source was configured with `useSpatialIndex` set to `false`, or
     * with an {@link module:ol/Collection} as `features`.
     * @return {Collection<import("../Feature.js").default<Geometry>>} The collection of features.
     * @api
     */
    VectorSource.prototype.getFeaturesCollection = function () {
        return this.featuresCollection_;
    };
    /**
     * Get a snapshot of the features currently on the source in random order. The returned array
     * is a copy, the features are references to the features in the source.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */
    VectorSource.prototype.getFeatures = function () {
        var features;
        if (this.featuresCollection_) {
            features = this.featuresCollection_.getArray().slice(0);
        }
        else if (this.featuresRtree_) {
            features = this.featuresRtree_.getAll();
            if (!Object(_obj_js__WEBPACK_IMPORTED_MODULE_15__["isEmpty"])(this.nullGeometryFeatures_)) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_13__["extend"])(features, Object(_obj_js__WEBPACK_IMPORTED_MODULE_15__["getValues"])(this.nullGeometryFeatures_));
            }
        }
        return /** @type {Array<import("../Feature.js").default<Geometry>>} */ (features);
    };
    /**
     * Get all features whose geometry intersects the provided coordinate.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */
    VectorSource.prototype.getFeaturesAtCoordinate = function (coordinate) {
        var features = [];
        this.forEachFeatureAtCoordinateDirect(coordinate, function (feature) {
            features.push(feature);
        });
        return features;
    };
    /**
     * Get all features whose bounding box intersects the provided extent.  Note that this returns an array of
     * all features intersecting the given extent in random order (so it may include
     * features whose geometries do not intersect the extent).
     *
     * When `useSpatialIndex` is set to false, this method will return all
     * features.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<import("../Feature.js").default<Geometry>>} Features.
     * @api
     */
    VectorSource.prototype.getFeaturesInExtent = function (extent) {
        if (this.featuresRtree_) {
            return this.featuresRtree_.getInExtent(extent);
        }
        else if (this.featuresCollection_) {
            return this.featuresCollection_.getArray().slice(0);
        }
        else {
            return [];
        }
    };
    /**
     * Get the closest feature to the provided coordinate.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(import("../Feature.js").default<Geometry>):boolean} [opt_filter] Feature filter function.
     *     The filter function will receive one argument, the {@link module:ol/Feature feature}
     *     and it should return a boolean value. By default, no filtering is made.
     * @return {import("../Feature.js").default<Geometry>} Closest feature.
     * @api
     */
    VectorSource.prototype.getClosestFeatureToCoordinate = function (coordinate, opt_filter) {
        // Find the closest feature using branch and bound.  We start searching an
        // infinite extent, and find the distance from the first feature found.  This
        // becomes the closest feature.  We then compute a smaller extent which any
        // closer feature must intersect.  We continue searching with this smaller
        // extent, trying to find a closer feature.  Every time we find a closer
        // feature, we update the extent being searched so that any even closer
        // feature must intersect it.  We continue until we run out of features.
        var x = coordinate[0];
        var y = coordinate[1];
        var closestFeature = null;
        var closestPoint = [NaN, NaN];
        var minSquaredDistance = Infinity;
        var extent = [-Infinity, -Infinity, Infinity, Infinity];
        var filter = opt_filter ? opt_filter : _functions_js__WEBPACK_IMPORTED_MODULE_9__["TRUE"];
        this.featuresRtree_.forEachInExtent(extent, 
        /**
         * @param {import("../Feature.js").default<Geometry>} feature Feature.
         */
        function (feature) {
            if (filter(feature)) {
                var geometry = feature.getGeometry();
                var previousMinSquaredDistance = minSquaredDistance;
                minSquaredDistance = geometry.closestPointXY(x, y, closestPoint, minSquaredDistance);
                if (minSquaredDistance < previousMinSquaredDistance) {
                    closestFeature = feature;
                    // This is sneaky.  Reduce the extent that it is currently being
                    // searched while the R-Tree traversal using this same extent object
                    // is still in progress.  This is safe because the new extent is
                    // strictly contained by the old extent.
                    var minDistance = Math.sqrt(minSquaredDistance);
                    extent[0] = x - minDistance;
                    extent[1] = y - minDistance;
                    extent[2] = x + minDistance;
                    extent[3] = y + minDistance;
                }
            }
        });
        return closestFeature;
    };
    /**
     * Get the extent of the features currently in the source.
     *
     * This method is not available when the source is configured with
     * `useSpatialIndex` set to `false`.
     * @param {import("../extent.js").Extent} [opt_extent] Destination extent. If provided, no new extent
     *     will be created. Instead, that extent's coordinates will be overwritten.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    VectorSource.prototype.getExtent = function (opt_extent) {
        return this.featuresRtree_.getExtent(opt_extent);
    };
    /**
     * Get a feature by its identifier (the value returned by feature.getId()).
     * Note that the index treats string and numeric identifiers as the same.  So
     * `source.getFeatureById(2)` will return a feature with id `'2'` or `2`.
     *
     * @param {string|number} id Feature identifier.
     * @return {import("../Feature.js").default<Geometry>} The feature (or `null` if not found).
     * @api
     */
    VectorSource.prototype.getFeatureById = function (id) {
        var feature = this.idIndex_[id.toString()];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get a feature by its internal unique identifier (using `getUid`).
     *
     * @param {string} uid Feature identifier.
     * @return {import("../Feature.js").default<Geometry>} The feature (or `null` if not found).
     */
    VectorSource.prototype.getFeatureByUid = function (uid) {
        var feature = this.uidIndex_[uid];
        return feature !== undefined ? feature : null;
    };
    /**
     * Get the format associated with this source.
     *
     * @return {import("../format/Feature.js").default|undefined} The feature format.
     * @api
     */
    VectorSource.prototype.getFormat = function () {
        return this.format_;
    };
    /**
     * @return {boolean} The source can have overlapping geometries.
     */
    VectorSource.prototype.getOverlaps = function () {
        return this.overlaps_;
    };
    /**
     * Get the url associated with this source.
     *
     * @return {string|import("../featureloader.js").FeatureUrlFunction|undefined} The url.
     * @api
     */
    VectorSource.prototype.getUrl = function () {
        return this.url_;
    };
    /**
     * @param {Event} event Event.
     * @private
     */
    VectorSource.prototype.handleFeatureChange_ = function (event) {
        var feature = /** @type {import("../Feature.js").default<Geometry>} */ (event.target);
        var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
        var geometry = feature.getGeometry();
        if (!geometry) {
            if (!(featureKey in this.nullGeometryFeatures_)) {
                if (this.featuresRtree_) {
                    this.featuresRtree_.remove(feature);
                }
                this.nullGeometryFeatures_[featureKey] = feature;
            }
        }
        else {
            var extent = geometry.getExtent();
            if (featureKey in this.nullGeometryFeatures_) {
                delete this.nullGeometryFeatures_[featureKey];
                if (this.featuresRtree_) {
                    this.featuresRtree_.insert(extent, feature);
                }
            }
            else {
                if (this.featuresRtree_) {
                    this.featuresRtree_.update(extent, feature);
                }
            }
        }
        var id = feature.getId();
        if (id !== undefined) {
            var sid = id.toString();
            if (this.idIndex_[sid] !== feature) {
                this.removeFromIdIndex_(feature);
                this.idIndex_[sid] = feature;
            }
        }
        else {
            this.removeFromIdIndex_(feature);
            this.uidIndex_[featureKey] = feature;
        }
        this.changed();
        this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].CHANGEFEATURE, feature));
    };
    /**
     * Returns true if the feature is contained within the source.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @return {boolean} Has feature.
     * @api
     */
    VectorSource.prototype.hasFeature = function (feature) {
        var id = feature.getId();
        if (id !== undefined) {
            return id in this.idIndex_;
        }
        else {
            return Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature) in this.uidIndex_;
        }
    };
    /**
     * @return {boolean} Is empty.
     */
    VectorSource.prototype.isEmpty = function () {
        return this.featuresRtree_.isEmpty() && Object(_obj_js__WEBPACK_IMPORTED_MODULE_15__["isEmpty"])(this.nullGeometryFeatures_);
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    VectorSource.prototype.loadFeatures = function (extent, resolution, projection) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var extentsToLoad = this.strategy_(extent, resolution);
        var _loop_1 = function (i, ii) {
            var extentToLoad = extentsToLoad[i];
            var alreadyLoaded = loadedExtentsRtree.forEachInExtent(extentToLoad, 
            /**
             * @param {{extent: import("../extent.js").Extent}} object Object.
             * @return {boolean} Contains.
             */
            function (object) {
                return Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsExtent"])(object.extent, extentToLoad);
            });
            if (!alreadyLoaded) {
                ++this_1.loadingExtentsCount_;
                this_1.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].FEATURESLOADSTART));
                this_1.loader_.call(this_1, extentToLoad, resolution, projection, function (features) {
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].FEATURESLOADEND, undefined, features));
                }.bind(this_1), function () {
                    --this.loadingExtentsCount_;
                    this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].FEATURESLOADERROR));
                }.bind(this_1));
                loadedExtentsRtree.insert(extentToLoad, { extent: extentToLoad.slice() });
            }
        };
        var this_1 = this;
        for (var i = 0, ii = extentsToLoad.length; i < ii; ++i) {
            _loop_1(i, ii);
        }
        this.loading =
            this.loader_ === _functions_js__WEBPACK_IMPORTED_MODULE_9__["VOID"] ? false : this.loadingExtentsCount_ > 0;
    };
    VectorSource.prototype.refresh = function () {
        this.clear(true);
        this.loadedExtentsRtree_.clear();
        _super.prototype.refresh.call(this);
    };
    /**
     * Remove an extent from the list of loaded extents.
     * @param {import("../extent.js").Extent} extent Extent.
     * @api
     */
    VectorSource.prototype.removeLoadedExtent = function (extent) {
        var loadedExtentsRtree = this.loadedExtentsRtree_;
        var obj;
        loadedExtentsRtree.forEachInExtent(extent, function (object) {
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["equals"])(object.extent, extent)) {
                obj = object;
                return true;
            }
        });
        if (obj) {
            loadedExtentsRtree.remove(obj);
        }
    };
    /**
     * Remove a single feature from the source.  If you want to remove all features
     * at once, use the {@link module:ol/source/Vector~VectorSource#clear #clear()} method
     * instead.
     * @param {import("../Feature.js").default<Geometry>} feature Feature to remove.
     * @api
     */
    VectorSource.prototype.removeFeature = function (feature) {
        var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
        if (featureKey in this.nullGeometryFeatures_) {
            delete this.nullGeometryFeatures_[featureKey];
        }
        else {
            if (this.featuresRtree_) {
                this.featuresRtree_.remove(feature);
            }
        }
        this.removeFeatureInternal(feature);
        this.changed();
    };
    /**
     * Remove feature without firing a `change` event.
     * @param {import("../Feature.js").default<Geometry>} feature Feature.
     * @protected
     */
    VectorSource.prototype.removeFeatureInternal = function (feature) {
        var featureKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_14__["getUid"])(feature);
        this.featureChangeKeys_[featureKey].forEach(_events_js__WEBPACK_IMPORTED_MODULE_16__["unlistenByKey"]);
        delete this.featureChangeKeys_[featureKey];
        var id = feature.getId();
        if (id !== undefined) {
            delete this.idIndex_[id.toString()];
        }
        delete this.uidIndex_[featureKey];
        this.dispatchEvent(new VectorSourceEvent(_VectorEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].REMOVEFEATURE, feature));
    };
    /**
     * Remove a feature from the id index.  Called internally when the feature id
     * may have changed.
     * @param {import("../Feature.js").default<Geometry>} feature The feature.
     * @return {boolean} Removed the feature from the index.
     * @private
     */
    VectorSource.prototype.removeFromIdIndex_ = function (feature) {
        var removed = false;
        for (var id in this.idIndex_) {
            if (this.idIndex_[id] === feature) {
                delete this.idIndex_[id];
                removed = true;
                break;
            }
        }
        return removed;
    };
    /**
     * Set the new loader of the source. The next render cycle will use the
     * new loader.
     * @param {import("../featureloader.js").FeatureLoader} loader The loader to set.
     * @api
     */
    VectorSource.prototype.setLoader = function (loader) {
        this.loader_ = loader;
    };
    /**
     * Points the source to a new url. The next render cycle will use the new url.
     * @param {string|import("../featureloader.js").FeatureUrlFunction} url Url.
     * @api
     */
    VectorSource.prototype.setUrl = function (url) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_11__["assert"])(this.format_, 7); // `format` must be set when `url` is set
        this.url_ = url;
        this.setLoader(Object(_featureloader_js__WEBPACK_IMPORTED_MODULE_17__["xhr"])(url, this.format_));
    };
    return VectorSource;
}(_Source_js__WEBPACK_IMPORTED_MODULE_6__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorSource);
//# sourceMappingURL=Vector.js.map

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CollectionEvent", function() { return CollectionEvent; });
/* harmony import */ var _AssertionError_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(107);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Collection
 */




/**
 * @enum {string}
 * @private
 */
var Property = {
    LENGTH: 'length',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/Collection~Collection} instances are instances of this
 * type.
 */
var CollectionEvent = /** @class */ (function (_super) {
    __extends(CollectionEvent, _super);
    /**
     * @param {import("./CollectionEventType.js").default} type Type.
     * @param {*} [opt_element] Element.
     * @param {number} [opt_index] The index of the added or removed element.
     */
    function CollectionEvent(type, opt_element, opt_index) {
        var _this = _super.call(this, type) || this;
        /**
         * The element that is added to or removed from the collection.
         * @type {*}
         * @api
         */
        _this.element = opt_element;
        /**
         * The index of the added or removed element.
         * @type {number}
         * @api
         */
        _this.index = opt_index;
        return _this;
    }
    return CollectionEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_3__["default"]));

/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<import("./ObjectEventType").Types|'change:length', import("./Object").ObjectEvent, Return> &
 *   import("./Observable").OnSignature<'add'|'remove', CollectionEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|import("./ObjectEventType").Types|
 *     'change:length'|'add'|'remove',Return>} CollectionOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {boolean} [unique=false] Disallow the same item from being added to
 * the collection twice.
 */
/**
 * @classdesc
 * An expanded version of standard JS Array, adding convenience methods for
 * manipulation. Add and remove changes to the Collection trigger a Collection
 * event. Note that this does not cover changes to the objects _within_ the
 * Collection; they trigger events on the appropriate object, not on the
 * Collection as a whole.
 *
 * @fires CollectionEvent
 *
 * @template T
 * @api
 */
var Collection = /** @class */ (function (_super) {
    __extends(Collection, _super);
    /**
     * @param {Array<T>} [opt_array] Array.
     * @param {Options} [opt_options] Collection options.
     */
    function Collection(opt_array, opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {CollectionOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {CollectionOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {CollectionOnSignature<void>}
         */
        _this.un;
        var options = opt_options || {};
        /**
         * @private
         * @type {boolean}
         */
        _this.unique_ = !!options.unique;
        /**
         * @private
         * @type {!Array<T>}
         */
        _this.array_ = opt_array ? opt_array : [];
        if (_this.unique_) {
            for (var i = 0, ii = _this.array_.length; i < ii; ++i) {
                _this.assertUnique_(_this.array_[i], i);
            }
        }
        _this.updateLength_();
        return _this;
    }
    /**
     * Remove all elements from the collection.
     * @api
     */
    Collection.prototype.clear = function () {
        while (this.getLength() > 0) {
            this.pop();
        }
    };
    /**
     * Add elements to the collection.  This pushes each item in the provided array
     * to the end of the collection.
     * @param {!Array<T>} arr Array.
     * @return {Collection<T>} This collection.
     * @api
     */
    Collection.prototype.extend = function (arr) {
        for (var i = 0, ii = arr.length; i < ii; ++i) {
            this.push(arr[i]);
        }
        return this;
    };
    /**
     * Iterate over each element, calling the provided callback.
     * @param {function(T, number, Array<T>): *} f The function to call
     *     for every element. This function takes 3 arguments (the element, the
     *     index and the array). The return value is ignored.
     * @api
     */
    Collection.prototype.forEach = function (f) {
        var array = this.array_;
        for (var i = 0, ii = array.length; i < ii; ++i) {
            f(array[i], i, array);
        }
    };
    /**
     * Get a reference to the underlying Array object. Warning: if the array
     * is mutated, no events will be dispatched by the collection, and the
     * collection's "length" property won't be in sync with the actual length
     * of the array.
     * @return {!Array<T>} Array.
     * @api
     */
    Collection.prototype.getArray = function () {
        return this.array_;
    };
    /**
     * Get the element at the provided index.
     * @param {number} index Index.
     * @return {T} Element.
     * @api
     */
    Collection.prototype.item = function (index) {
        return this.array_[index];
    };
    /**
     * Get the length of this collection.
     * @return {number} The length of the array.
     * @observable
     * @api
     */
    Collection.prototype.getLength = function () {
        return this.get(Property.LENGTH);
    };
    /**
     * Insert an element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */
    Collection.prototype.insertAt = function (index, elem) {
        if (this.unique_) {
            this.assertUnique_(elem);
        }
        this.array_.splice(index, 0, elem);
        this.updateLength_();
        this.dispatchEvent(new CollectionEvent(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, elem, index));
    };
    /**
     * Remove the last element of the collection and return it.
     * Return `undefined` if the collection is empty.
     * @return {T|undefined} Element.
     * @api
     */
    Collection.prototype.pop = function () {
        return this.removeAt(this.getLength() - 1);
    };
    /**
     * Insert the provided element at the end of the collection.
     * @param {T} elem Element.
     * @return {number} New length of the collection.
     * @api
     */
    Collection.prototype.push = function (elem) {
        if (this.unique_) {
            this.assertUnique_(elem);
        }
        var n = this.getLength();
        this.insertAt(n, elem);
        return this.getLength();
    };
    /**
     * Remove the first occurrence of an element from the collection.
     * @param {T} elem Element.
     * @return {T|undefined} The removed element or undefined if none found.
     * @api
     */
    Collection.prototype.remove = function (elem) {
        var arr = this.array_;
        for (var i = 0, ii = arr.length; i < ii; ++i) {
            if (arr[i] === elem) {
                return this.removeAt(i);
            }
        }
        return undefined;
    };
    /**
     * Remove the element at the provided index and return it.
     * Return `undefined` if the collection does not contain this index.
     * @param {number} index Index.
     * @return {T|undefined} Value.
     * @api
     */
    Collection.prototype.removeAt = function (index) {
        var prev = this.array_[index];
        this.array_.splice(index, 1);
        this.updateLength_();
        this.dispatchEvent(new CollectionEvent(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, prev, index));
        return prev;
    };
    /**
     * Set the element at the provided index.
     * @param {number} index Index.
     * @param {T} elem Element.
     * @api
     */
    Collection.prototype.setAt = function (index, elem) {
        var n = this.getLength();
        if (index < n) {
            if (this.unique_) {
                this.assertUnique_(elem, index);
            }
            var prev = this.array_[index];
            this.array_[index] = elem;
            this.dispatchEvent(new CollectionEvent(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, prev, index));
            this.dispatchEvent(new CollectionEvent(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, elem, index));
        }
        else {
            for (var j = n; j < index; ++j) {
                this.insertAt(j, undefined);
            }
            this.insertAt(index, elem);
        }
    };
    /**
     * @private
     */
    Collection.prototype.updateLength_ = function () {
        this.set(Property.LENGTH, this.array_.length);
    };
    /**
     * @private
     * @param {T} elem Element.
     * @param {number} [opt_except] Optional index to ignore.
     */
    Collection.prototype.assertUnique_ = function (elem, opt_except) {
        for (var i = 0, ii = this.array_.length; i < ii; ++i) {
            if (this.array_[i] === elem && i !== opt_except) {
                throw new _AssertionError_js__WEBPACK_IMPORTED_MODULE_0__["default"](58);
            }
        }
    };
    return Collection;
}(_Object_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Collection);
//# sourceMappingURL=Collection.js.map

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/CollectionEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered when an item is added to the collection.
     * @event module:ol/Collection.CollectionEvent#add
     * @api
     */
    ADD: 'add',
    /**
     * Triggered when an item is removed from the collection.
     * @event module:ol/Collection.CollectionEvent#remove
     * @api
     */
    REMOVE: 'remove',
});
//# sourceMappingURL=CollectionEventType.js.map

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(109);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(rbush__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/**
 * @module ol/structs/RBush
 */




/**
 * @typedef {Object} Entry
 * @property {number} minX MinX.
 * @property {number} minY MinY.
 * @property {number} maxX MaxX.
 * @property {number} maxY MaxY.
 * @property {Object} [value] Value.
 */
/**
 * @classdesc
 * Wrapper around the RBush by Vladimir Agafonkin.
 * See https://github.com/mourner/rbush.
 *
 * @template T
 */
var RBush = /** @class */ (function () {
    /**
     * @param {number} [opt_maxEntries] Max entries.
     */
    function RBush(opt_maxEntries) {
        /**
         * @private
         */
        this.rbush_ = new rbush__WEBPACK_IMPORTED_MODULE_0___default.a(opt_maxEntries);
        /**
         * A mapping between the objects added to this rbush wrapper
         * and the objects that are actually added to the internal rbush.
         * @private
         * @type {Object<string, Entry>}
         */
        this.items_ = {};
    }
    /**
     * Insert a value into the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */
    RBush.prototype.insert = function (extent, value) {
        /** @type {Entry} */
        var item = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
            value: value,
        };
        this.rbush_.insert(item);
        this.items_[Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(value)] = item;
    };
    /**
     * Bulk-insert values into the RBush.
     * @param {Array<import("../extent.js").Extent>} extents Extents.
     * @param {Array<T>} values Values.
     */
    RBush.prototype.load = function (extents, values) {
        var items = new Array(values.length);
        for (var i = 0, l = values.length; i < l; i++) {
            var extent = extents[i];
            var value = values[i];
            /** @type {Entry} */
            var item = {
                minX: extent[0],
                minY: extent[1],
                maxX: extent[2],
                maxY: extent[3],
                value: value,
            };
            items[i] = item;
            this.items_[Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(value)] = item;
        }
        this.rbush_.load(items);
    };
    /**
     * Remove a value from the RBush.
     * @param {T} value Value.
     * @return {boolean} Removed.
     */
    RBush.prototype.remove = function (value) {
        var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(value);
        // get the object in which the value was wrapped when adding to the
        // internal rbush. then use that object to do the removal.
        var item = this.items_[uid];
        delete this.items_[uid];
        return this.rbush_.remove(item) !== null;
    };
    /**
     * Update the extent of a value in the RBush.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {T} value Value.
     */
    RBush.prototype.update = function (extent, value) {
        var item = this.items_[Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(value)];
        var bbox = [item.minX, item.minY, item.maxX, item.maxY];
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_1__["equals"])(bbox, extent)) {
            this.remove(value);
            this.insert(extent, value);
        }
    };
    /**
     * Return all values in the RBush.
     * @return {Array<T>} All.
     */
    RBush.prototype.getAll = function () {
        var items = this.rbush_.all();
        return items.map(function (item) {
            return item.value;
        });
    };
    /**
     * Return all values in the given extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<T>} All in extent.
     */
    RBush.prototype.getInExtent = function (extent) {
        /** @type {Entry} */
        var bbox = {
            minX: extent[0],
            minY: extent[1],
            maxX: extent[2],
            maxY: extent[3],
        };
        var items = this.rbush_.search(bbox);
        return items.map(function (item) {
            return item.value;
        });
    };
    /**
     * Calls a callback function with each value in the tree.
     * If the callback returns a truthy value, this value is returned without
     * checking the rest of the tree.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */
    RBush.prototype.forEach = function (callback) {
        return this.forEach_(this.getAll(), callback);
    };
    /**
     * Calls a callback function with each value in the provided extent.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {function(T): *} callback Callback.
     * @return {*} Callback return value.
     */
    RBush.prototype.forEachInExtent = function (extent, callback) {
        return this.forEach_(this.getInExtent(extent), callback);
    };
    /**
     * @param {Array<T>} values Values.
     * @param {function(T): *} callback Callback.
     * @private
     * @return {*} Callback return value.
     */
    RBush.prototype.forEach_ = function (values, callback) {
        var result;
        for (var i = 0, l = values.length; i < l; i++) {
            result = callback(values[i]);
            if (result) {
                return result;
            }
        }
        return result;
    };
    /**
     * @return {boolean} Is empty.
     */
    RBush.prototype.isEmpty = function () {
        return Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["isEmpty"])(this.items_);
    };
    /**
     * Remove all values from the RBush.
     */
    RBush.prototype.clear = function () {
        this.rbush_.clear();
        this.items_ = {};
    };
    /**
     * @param {import("../extent.js").Extent} [opt_extent] Extent.
     * @return {import("../extent.js").Extent} Extent.
     */
    RBush.prototype.getExtent = function (opt_extent) {
        var data = this.rbush_.toJSON();
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_1__["createOrUpdate"])(data.minX, data.minY, data.maxX, data.maxY, opt_extent);
    };
    /**
     * @param {RBush} rbush R-Tree.
     */
    RBush.prototype.concat = function (rbush) {
        this.rbush_.load(rbush.rbush_.all());
        for (var i in rbush.items_) {
            this.items_[i] = rbush.items_[i];
        }
    };
    return RBush;
}());
/* harmony default export */ __webpack_exports__["default"] = (RBush);
//# sourceMappingURL=RBush.js.map

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,i){ true?module.exports=i():undefined}(this,function(){"use strict";function t(t,r,e,a,h){!function t(n,r,e,a,h){for(;a>e;){if(a-e>600){var o=a-e+1,s=r-e+1,l=Math.log(o),f=.5*Math.exp(2*l/3),u=.5*Math.sqrt(l*f*(o-f)/o)*(s-o/2<0?-1:1),m=Math.max(e,Math.floor(r-s*f/o+u)),c=Math.min(a,Math.floor(r+(o-s)*f/o+u));t(n,r,m,c,h)}var p=n[r],d=e,x=a;for(i(n,e,r),h(n[a],p)>0&&i(n,e,a);d<x;){for(i(n,d,x),d++,x--;h(n[d],p)<0;)d++;for(;h(n[x],p)>0;)x--}0===h(n[e],p)?i(n,e,x):i(n,++x,a),x<=r&&(e=x+1),r<=x&&(a=x-1)}}(t,r,e||0,a||t.length-1,h||n)}function i(t,i,n){var r=t[i];t[i]=t[n],t[n]=r}function n(t,i){return t<i?-1:t>i?1:0}var r=function(t){void 0===t&&(t=9),this._maxEntries=Math.max(4,t),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),this.clear()};function e(t,i,n){if(!n)return i.indexOf(t);for(var r=0;r<i.length;r++)if(n(t,i[r]))return r;return-1}function a(t,i){h(t,0,t.children.length,i,t)}function h(t,i,n,r,e){e||(e=p(null)),e.minX=1/0,e.minY=1/0,e.maxX=-1/0,e.maxY=-1/0;for(var a=i;a<n;a++){var h=t.children[a];o(e,t.leaf?r(h):h)}return e}function o(t,i){return t.minX=Math.min(t.minX,i.minX),t.minY=Math.min(t.minY,i.minY),t.maxX=Math.max(t.maxX,i.maxX),t.maxY=Math.max(t.maxY,i.maxY),t}function s(t,i){return t.minX-i.minX}function l(t,i){return t.minY-i.minY}function f(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function u(t){return t.maxX-t.minX+(t.maxY-t.minY)}function m(t,i){return t.minX<=i.minX&&t.minY<=i.minY&&i.maxX<=t.maxX&&i.maxY<=t.maxY}function c(t,i){return i.minX<=t.maxX&&i.minY<=t.maxY&&i.maxX>=t.minX&&i.maxY>=t.minY}function p(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function d(i,n,r,e,a){for(var h=[n,r];h.length;)if(!((r=h.pop())-(n=h.pop())<=e)){var o=n+Math.ceil((r-n)/e/2)*e;t(i,o,n,r,a),h.push(n,o,o,r)}}return r.prototype.all=function(){return this._all(this.data,[])},r.prototype.search=function(t){var i=this.data,n=[];if(!c(t,i))return n;for(var r=this.toBBox,e=[];i;){for(var a=0;a<i.children.length;a++){var h=i.children[a],o=i.leaf?r(h):h;c(t,o)&&(i.leaf?n.push(h):m(t,o)?this._all(h,n):e.push(h))}i=e.pop()}return n},r.prototype.collides=function(t){var i=this.data;if(!c(t,i))return!1;for(var n=[];i;){for(var r=0;r<i.children.length;r++){var e=i.children[r],a=i.leaf?this.toBBox(e):e;if(c(t,a)){if(i.leaf||m(t,a))return!0;n.push(e)}}i=n.pop()}return!1},r.prototype.load=function(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(var i=0;i<t.length;i++)this.insert(t[i]);return this}var n=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===n.height)this._splitRoot(this.data,n);else{if(this.data.height<n.height){var r=this.data;this.data=n,n=r}this._insert(n,this.data.height-n.height-1,!0)}else this.data=n;return this},r.prototype.insert=function(t){return t&&this._insert(t,this.data.height-1),this},r.prototype.clear=function(){return this.data=p([]),this},r.prototype.remove=function(t,i){if(!t)return this;for(var n,r,a,h=this.data,o=this.toBBox(t),s=[],l=[];h||s.length;){if(h||(h=s.pop(),r=s[s.length-1],n=l.pop(),a=!0),h.leaf){var f=e(t,h.children,i);if(-1!==f)return h.children.splice(f,1),s.push(h),this._condense(s),this}a||h.leaf||!m(h,o)?r?(n++,h=r.children[n],a=!1):h=null:(s.push(h),l.push(n),n=0,r=h,h=h.children[0])}return this},r.prototype.toBBox=function(t){return t},r.prototype.compareMinX=function(t,i){return t.minX-i.minX},r.prototype.compareMinY=function(t,i){return t.minY-i.minY},r.prototype.toJSON=function(){return this.data},r.prototype.fromJSON=function(t){return this.data=t,this},r.prototype._all=function(t,i){for(var n=[];t;)t.leaf?i.push.apply(i,t.children):n.push.apply(n,t.children),t=n.pop();return i},r.prototype._build=function(t,i,n,r){var e,h=n-i+1,o=this._maxEntries;if(h<=o)return a(e=p(t.slice(i,n+1)),this.toBBox),e;r||(r=Math.ceil(Math.log(h)/Math.log(o)),o=Math.ceil(h/Math.pow(o,r-1))),(e=p([])).leaf=!1,e.height=r;var s=Math.ceil(h/o),l=s*Math.ceil(Math.sqrt(o));d(t,i,n,l,this.compareMinX);for(var f=i;f<=n;f+=l){var u=Math.min(f+l-1,n);d(t,f,u,s,this.compareMinY);for(var m=f;m<=u;m+=s){var c=Math.min(m+s-1,u);e.children.push(this._build(t,m,c,r-1))}}return a(e,this.toBBox),e},r.prototype._chooseSubtree=function(t,i,n,r){for(;r.push(i),!i.leaf&&r.length-1!==n;){for(var e=1/0,a=1/0,h=void 0,o=0;o<i.children.length;o++){var s=i.children[o],l=f(s),u=(m=t,c=s,(Math.max(c.maxX,m.maxX)-Math.min(c.minX,m.minX))*(Math.max(c.maxY,m.maxY)-Math.min(c.minY,m.minY))-l);u<a?(a=u,e=l<e?l:e,h=s):u===a&&l<e&&(e=l,h=s)}i=h||i.children[0]}var m,c;return i},r.prototype._insert=function(t,i,n){var r=n?t:this.toBBox(t),e=[],a=this._chooseSubtree(r,this.data,i,e);for(a.children.push(t),o(a,r);i>=0&&e[i].children.length>this._maxEntries;)this._split(e,i),i--;this._adjustParentBBoxes(r,e,i)},r.prototype._split=function(t,i){var n=t[i],r=n.children.length,e=this._minEntries;this._chooseSplitAxis(n,e,r);var h=this._chooseSplitIndex(n,e,r),o=p(n.children.splice(h,n.children.length-h));o.height=n.height,o.leaf=n.leaf,a(n,this.toBBox),a(o,this.toBBox),i?t[i-1].children.push(o):this._splitRoot(n,o)},r.prototype._splitRoot=function(t,i){this.data=p([t,i]),this.data.height=t.height+1,this.data.leaf=!1,a(this.data,this.toBBox)},r.prototype._chooseSplitIndex=function(t,i,n){for(var r,e,a,o,s,l,u,m=1/0,c=1/0,p=i;p<=n-i;p++){var d=h(t,0,p,this.toBBox),x=h(t,p,n,this.toBBox),v=(e=d,a=x,o=void 0,s=void 0,l=void 0,u=void 0,o=Math.max(e.minX,a.minX),s=Math.max(e.minY,a.minY),l=Math.min(e.maxX,a.maxX),u=Math.min(e.maxY,a.maxY),Math.max(0,l-o)*Math.max(0,u-s)),M=f(d)+f(x);v<m?(m=v,r=p,c=M<c?M:c):v===m&&M<c&&(c=M,r=p)}return r||n-i},r.prototype._chooseSplitAxis=function(t,i,n){var r=t.leaf?this.compareMinX:s,e=t.leaf?this.compareMinY:l;this._allDistMargin(t,i,n,r)<this._allDistMargin(t,i,n,e)&&t.children.sort(r)},r.prototype._allDistMargin=function(t,i,n,r){t.children.sort(r);for(var e=this.toBBox,a=h(t,0,i,e),s=h(t,n-i,n,e),l=u(a)+u(s),f=i;f<n-i;f++){var m=t.children[f];o(a,t.leaf?e(m):m),l+=u(a)}for(var c=n-i-1;c>=i;c--){var p=t.children[c];o(s,t.leaf?e(p):p),l+=u(s)}return l},r.prototype._adjustParentBBoxes=function(t,i,n){for(var r=n;r>=0;r--)o(i[r],t)},r.prototype._condense=function(t){for(var i=t.length-1,n=void 0;i>=0;i--)0===t[i].children.length?i>0?(n=t[i-1].children).splice(n.indexOf(t[i]),1):this.clear():a(t[i],this.toBBox)},r});


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/source/VectorEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered when a feature is added to the source.
     * @event module:ol/source/Vector.VectorSourceEvent#addfeature
     * @api
     */
    ADDFEATURE: 'addfeature',
    /**
     * Triggered when a feature is updated.
     * @event module:ol/source/Vector.VectorSourceEvent#changefeature
     * @api
     */
    CHANGEFEATURE: 'changefeature',
    /**
     * Triggered when the clear method is called on the source.
     * @event module:ol/source/Vector.VectorSourceEvent#clear
     * @api
     */
    CLEAR: 'clear',
    /**
     * Triggered when a feature is removed from the source.
     * See {@link module:ol/source/Vector~VectorSource#clear source.clear()} for exceptions.
     * @event module:ol/source/Vector.VectorSourceEvent#removefeature
     * @api
     */
    REMOVEFEATURE: 'removefeature',
    /**
     * Triggered when features starts loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadstart
     * @api
     */
    FEATURESLOADSTART: 'featuresloadstart',
    /**
     * Triggered when features finishes loading.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloadend
     * @api
     */
    FEATURESLOADEND: 'featuresloadend',
    /**
     * Triggered if feature loading results in an error.
     * @event module:ol/source/Vector.VectorSourceEvent#featuresloaderror
     * @api
     */
    FEATURESLOADERROR: 'featuresloaderror',
});
/**
 * @typedef {'addfeature'|'clear'|'removefeature'|'featuresloadstart'|'featuresloadend'|'featuresloaderror'} VectorSourceEventTypes
 */
//# sourceMappingURL=VectorEventType.js.map

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bbox", function() { return bbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tile", function() { return tile; });
/**
 * @module ol/loadingstrategy
 */
/**
 * Strategy function for loading all features with a single request.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */
function all(extent, resolution) {
    return [[-Infinity, -Infinity, Infinity, Infinity]];
}
/**
 * Strategy function for loading features based on the view's extent and
 * resolution.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @return {Array<import("./extent.js").Extent>} Extents.
 * @api
 */
function bbox(extent, resolution) {
    return [extent];
}
/**
 * Creates a strategy function for loading features based on a tile grid.
 * @param {import("./tilegrid/TileGrid.js").default} tileGrid Tile grid.
 * @return {function(import("./extent.js").Extent, number): Array<import("./extent.js").Extent>} Loading strategy.
 * @api
 */
function tile(tileGrid) {
    return (
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @return {Array<import("./extent.js").Extent>} Extents.
     */
    function (extent, resolution) {
        var z = tileGrid.getZForResolution(resolution);
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /** @type {Array<import("./extent.js").Extent>} */
        var extents = [];
        /** @type {import("./tilecoord.js").TileCoord} */
        var tileCoord = [z, 0, 0];
        for (tileCoord[1] = tileRange.minX; tileCoord[1] <= tileRange.maxX; ++tileCoord[1]) {
            for (tileCoord[2] = tileRange.minY; tileCoord[2] <= tileRange.maxY; ++tileCoord[2]) {
                extents.push(tileGrid.getTileCoordExtent(tileCoord));
            }
        }
        return extents;
    });
}
//# sourceMappingURL=loadingstrategy.js.map

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFeaturesXhr", function() { return loadFeaturesXhr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "xhr", function() { return xhr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setWithCredentials", function() { return setWithCredentials; });
/* harmony import */ var _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(113);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/**
 * @module ol/featureloader
 */


/**
 *
 * @type {boolean}
 * @private
 */
var withCredentials = false;
/**
 * {@link module:ol/source/Vector} sources use a function of this type to
 * load features.
 *
 * This function takes up to 5 arguments. These are an {@link module:ol/extent~Extent} representing
 * the area to be loaded, a `{number}` representing the resolution (map units per pixel), an
 * {@link module:ol/proj/Projection} for the projection, an optional success callback that should get
 * the loaded features passed as an argument and an optional failure callback with no arguments. If
 * the callbacks are not used, the corresponding vector source will not fire `'featuresloadend'` and
 * `'featuresloaderror'` events. `this` within the function is bound to the
 * {@link module:ol/source/Vector} it's called from.
 *
 * The function is responsible for loading the features and adding them to the
 * source.
 * @typedef {function(this:(import("./source/Vector").default|import("./VectorTile.js").default),
 *           import("./extent.js").Extent,
 *           number,
 *           import("./proj/Projection.js").default,
 *           function(Array<import("./Feature.js").default>): void=,
 *           function(): void=): void} FeatureLoader
 * @api
 */
/**
 * {@link module:ol/source/Vector} sources use a function of this type to
 * get the url to load features from.
 *
 * This function takes an {@link module:ol/extent~Extent} representing the area
 * to be loaded, a `{number}` representing the resolution (map units per pixel)
 * and an {@link module:ol/proj/Projection} for the projection  as
 * arguments and returns a `{string}` representing the URL.
 * @typedef {function(import("./extent.js").Extent, number, import("./proj/Projection.js").default): string} FeatureUrlFunction
 * @api
 */
/**
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {import("./format/Feature.js").default} format Feature format.
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {import("./proj/Projection.js").default} projection Projection.
 * @param {function(Array<import("./Feature.js").default>, import("./proj/Projection.js").default): void} success Success
 *      Function called with the loaded features and optionally with the data projection.
 * @param {function(): void} failure Failure
 *      Function called when loading failed.
 */
function loadFeaturesXhr(url, format, extent, resolution, projection, success, failure) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', typeof url === 'function' ? url(extent, resolution, projection) : url, true);
    if (format.getType() == _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__["default"].ARRAY_BUFFER) {
        xhr.responseType = 'arraybuffer';
    }
    xhr.withCredentials = withCredentials;
    /**
     * @param {Event} event Event.
     * @private
     */
    xhr.onload = function (event) {
        // status will be 0 for file:// urls
        if (!xhr.status || (xhr.status >= 200 && xhr.status < 300)) {
            var type = format.getType();
            /** @type {Document|Node|Object|string|undefined} */
            var source = void 0;
            if (type == _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__["default"].JSON || type == _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) {
                source = xhr.responseText;
            }
            else if (type == _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__["default"].XML) {
                source = xhr.responseXML;
                if (!source) {
                    source = new DOMParser().parseFromString(xhr.responseText, 'application/xml');
                }
            }
            else if (type == _format_FormatType_js__WEBPACK_IMPORTED_MODULE_0__["default"].ARRAY_BUFFER) {
                source = /** @type {ArrayBuffer} */ (xhr.response);
            }
            if (source) {
                success(
                /** @type {Array<import("./Feature.js").default>} */
                (format.readFeatures(source, {
                    extent: extent,
                    featureProjection: projection,
                })), format.readProjection(source));
            }
            else {
                failure();
            }
        }
        else {
            failure();
        }
    };
    /**
     * @private
     */
    xhr.onerror = failure;
    xhr.send();
}
/**
 * Create an XHR feature loader for a `url` and `format`. The feature loader
 * loads features (with XHR), parses the features, and adds them to the
 * vector source.
 * @param {string|FeatureUrlFunction} url Feature URL service.
 * @param {import("./format/Feature.js").default} format Feature format.
 * @return {FeatureLoader} The feature loader.
 * @api
 */
function xhr(url, format) {
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("./proj/Projection.js").default} projection Projection.
     * @param {function(Array<import("./Feature.js").default>): void} [success] Success
     *      Function called when loading succeeded.
     * @param {function(): void} [failure] Failure
     *      Function called when loading failed.
     * @this {import("./source/Vector").default}
     */
    return function (extent, resolution, projection, success, failure) {
        var source = /** @type {import("./source/Vector").default} */ (this);
        loadFeaturesXhr(url, format, extent, resolution, projection, 
        /**
         * @param {Array<import("./Feature.js").default>} features The loaded features.
         * @param {import("./proj/Projection.js").default} dataProjection Data
         * projection.
         */
        function (features, dataProjection) {
            source.addFeatures(features);
            if (success !== undefined) {
                success(features);
            }
        }, 
        /* FIXME handle error */ failure ? failure : _functions_js__WEBPACK_IMPORTED_MODULE_1__["VOID"]);
    };
}
/**
 * Setter for the withCredentials configuration for the XHR.
 *
 * @param {boolean} xhrWithCredentials The value of withCredentials to set.
 * Compare https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/
 * @api
 */
function setWithCredentials(xhrWithCredentials) {
    withCredentials = xhrWithCredentials;
}
//# sourceMappingURL=featureloader.js.map

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/format/FormatType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    ARRAY_BUFFER: 'arraybuffer',
    JSON: 'json',
    TEXT: 'text',
    XML: 'xml',
});
//# sourceMappingURL=FormatType.js.map

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71);
/* harmony import */ var _Zoomify_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(115);
/* harmony import */ var _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91);
/* harmony import */ var _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(116);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39);
/**
 * @module ol/source/IIIF
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Size of the cache.
 * @property {null|string} [crossOrigin] The value for the crossOrigin option of the request.
 * @property {import("../extent.js").Extent} [extent=[0, -height, width, 0]] The extent.
 * @property {string} [format='jpg'] Requested image format.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {string} [quality] Requested IIIF image quality. Default is 'native'
 * for version 1, 'default' for versions 2 and 3.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {Array<number>} [resolutions] Supported resolutions as given in IIIF 'scaleFactors'
 * @property {import("../size.js").Size} size Size of the image [width, height].
 * @property {Array<import("../size.js").Size>} [sizes] Supported scaled image sizes.
 * Content of the IIIF info.json 'sizes' property, but as array of Size objects.
 * @property {import("./State.js").default} [state] Source state.
 * @property {Array<string>} [supports=[]] Supported IIIF region and size calculation
 * features.
 * @property {number} [tilePixelRatio] Tile pixel ratio.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * Same tile size is used for all zoom levels. If tile size is a number,
 * a square tile is assumed. If the IIIF image service supports arbitrary
 * tiling (sizeByH, sizeByW, sizeByWh or sizeByPct as well as regionByPx or regionByPct
 * are supported), the default tilesize is 256.
 * @property {number} [transition] Transition.
 * @property {string} [url] Base URL of the IIIF Image service.
 * This should be the same as the IIIF Image ID.
 * @property {import("../format/IIIFInfo.js").Versions} [version=Versions.VERSION2] Service's IIIF Image API version.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
function formatPercentage(percentage) {
    return percentage.toLocaleString('en', { maximumFractionDigits: 10 });
}
/**
 * @classdesc
 * Layer source for IIIF Image API services.
 * @api
 */
var IIIF = /** @class */ (function (_super) {
    __extends(IIIF, _super);
    /**
     * @param {Options} [opt_options] Tile source options. Use {@link import("../format/IIIFInfo.js").IIIFInfo}
     * to parse Image API service information responses into constructor options.
     * @api
     */
    function IIIF(opt_options) {
        var _this = this;
        /**
         * @type {Partial<Options>}
         */
        var options = opt_options || {};
        var baseUrl = options.url || '';
        baseUrl =
            baseUrl +
                (baseUrl.lastIndexOf('/') === baseUrl.length - 1 || baseUrl === ''
                    ? ''
                    : '/');
        var version = options.version || _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__["Versions"].VERSION2;
        var sizes = options.sizes || [];
        var size = options.size;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_5__["assert"])(size != undefined &&
            Array.isArray(size) &&
            size.length == 2 &&
            !isNaN(size[0]) &&
            size[0] > 0 &&
            !isNaN(size[1]) &&
            size[1] > 0, 60);
        var width = size[0];
        var height = size[1];
        var tileSize = options.tileSize;
        var tilePixelRatio = options.tilePixelRatio || 1;
        var format = options.format || 'jpg';
        var quality = options.quality ||
            (options.version == _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__["Versions"].VERSION1 ? 'native' : 'default');
        var resolutions = options.resolutions || [];
        var supports = options.supports || [];
        var extent = options.extent || [0, -height, width, 0];
        var supportsListedSizes = sizes != undefined && Array.isArray(sizes) && sizes.length > 0;
        var supportsListedTiles = tileSize !== undefined &&
            ((typeof tileSize === 'number' &&
                Number.isInteger(tileSize) &&
                tileSize > 0) ||
                (Array.isArray(tileSize) && tileSize.length > 0));
        var supportsArbitraryTiling = supports != undefined &&
            Array.isArray(supports) &&
            (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'regionByPx') || Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'regionByPct')) &&
            (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByWh') ||
                Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByH') ||
                Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByW') ||
                Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByPct'));
        var tileWidth, tileHeight, maxZoom;
        resolutions.sort(function (a, b) {
            return b - a;
        });
        if (supportsListedTiles || supportsArbitraryTiling) {
            if (tileSize != undefined) {
                if (typeof tileSize === 'number' &&
                    Number.isInteger(tileSize) &&
                    tileSize > 0) {
                    tileWidth = tileSize;
                    tileHeight = tileSize;
                }
                else if (Array.isArray(tileSize) && tileSize.length > 0) {
                    if (tileSize.length == 1 ||
                        (tileSize[1] == undefined && Number.isInteger(tileSize[0]))) {
                        tileWidth = tileSize[0];
                        tileHeight = tileSize[0];
                    }
                    if (tileSize.length == 2) {
                        if (Number.isInteger(tileSize[0]) &&
                            Number.isInteger(tileSize[1])) {
                            tileWidth = tileSize[0];
                            tileHeight = tileSize[1];
                        }
                        else if (tileSize[0] == undefined &&
                            Number.isInteger(tileSize[1])) {
                            tileWidth = tileSize[1];
                            tileHeight = tileSize[1];
                        }
                    }
                }
            }
            if (tileWidth === undefined || tileHeight === undefined) {
                tileWidth = _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_TILE_SIZE"];
                tileHeight = _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_3__["DEFAULT_TILE_SIZE"];
            }
            if (resolutions.length == 0) {
                maxZoom = Math.max(Math.ceil(Math.log(width / tileWidth) / Math.LN2), Math.ceil(Math.log(height / tileHeight) / Math.LN2));
                for (var i = maxZoom; i >= 0; i--) {
                    resolutions.push(Math.pow(2, i));
                }
            }
            else {
                var maxScaleFactor = Math.max.apply(Math, resolutions);
                // TODO maxScaleFactor might not be a power to 2
                maxZoom = Math.round(Math.log(maxScaleFactor) / Math.LN2);
            }
        }
        else {
            // No tile support.
            tileWidth = width;
            tileHeight = height;
            resolutions = [];
            if (supportsListedSizes) {
                /*
                 * 'sizes' provided. Use full region in different resolutions. Every
                 * resolution has only one tile.
                 */
                sizes.sort(function (a, b) {
                    return a[0] - b[0];
                });
                maxZoom = -1;
                var ignoredSizesIndex = [];
                for (var i = 0; i < sizes.length; i++) {
                    var resolution = width / sizes[i][0];
                    if (resolutions.length > 0 &&
                        resolutions[resolutions.length - 1] == resolution) {
                        ignoredSizesIndex.push(i);
                        continue;
                    }
                    resolutions.push(resolution);
                    maxZoom++;
                }
                if (ignoredSizesIndex.length > 0) {
                    for (var i = 0; i < ignoredSizesIndex.length; i++) {
                        sizes.splice(ignoredSizesIndex[i] - i, 1);
                    }
                }
            }
            else {
                // No useful image information at all. Try pseudo tile with full image.
                resolutions.push(1);
                sizes.push([width, height]);
                maxZoom = 0;
            }
        }
        var tileGrid = new _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
            tileSize: [tileWidth, tileHeight],
            extent: extent,
            origin: Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getTopLeft"])(extent),
            resolutions: resolutions,
        });
        var tileUrlFunction = function (tileCoord, pixelRatio, projection) {
            var regionParam, sizeParam;
            var zoom = tileCoord[0];
            if (zoom > maxZoom) {
                return;
            }
            var tileX = tileCoord[1], tileY = tileCoord[2], scale = resolutions[zoom];
            if (tileX === undefined ||
                tileY === undefined ||
                scale === undefined ||
                tileX < 0 ||
                Math.ceil(width / scale / tileWidth) <= tileX ||
                tileY < 0 ||
                Math.ceil(height / scale / tileHeight) <= tileY) {
                return;
            }
            if (supportsArbitraryTiling || supportsListedTiles) {
                var regionX = tileX * tileWidth * scale, regionY = tileY * tileHeight * scale;
                var regionW = tileWidth * scale, regionH = tileHeight * scale, sizeW = tileWidth, sizeH = tileHeight;
                if (regionX + regionW > width) {
                    regionW = width - regionX;
                }
                if (regionY + regionH > height) {
                    regionH = height - regionY;
                }
                if (regionX + tileWidth * scale > width) {
                    sizeW = Math.floor((width - regionX + scale - 1) / scale);
                }
                if (regionY + tileHeight * scale > height) {
                    sizeH = Math.floor((height - regionY + scale - 1) / scale);
                }
                if (regionX == 0 &&
                    regionW == width &&
                    regionY == 0 &&
                    regionH == height) {
                    // canonical full image region parameter is 'full', not 'x,y,w,h'
                    regionParam = 'full';
                }
                else if (!supportsArbitraryTiling ||
                    Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'regionByPx')) {
                    regionParam = regionX + ',' + regionY + ',' + regionW + ',' + regionH;
                }
                else if (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'regionByPct')) {
                    var pctX = formatPercentage((regionX / width) * 100), pctY = formatPercentage((regionY / height) * 100), pctW = formatPercentage((regionW / width) * 100), pctH = formatPercentage((regionH / height) * 100);
                    regionParam = 'pct:' + pctX + ',' + pctY + ',' + pctW + ',' + pctH;
                }
                if (version == _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__["Versions"].VERSION3 &&
                    (!supportsArbitraryTiling || Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByWh'))) {
                    sizeParam = sizeW + ',' + sizeH;
                }
                else if (!supportsArbitraryTiling || Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByW')) {
                    sizeParam = sizeW + ',';
                }
                else if (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByH')) {
                    sizeParam = ',' + sizeH;
                }
                else if (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByWh')) {
                    sizeParam = sizeW + ',' + sizeH;
                }
                else if (Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["includes"])(supports, 'sizeByPct')) {
                    sizeParam = 'pct:' + formatPercentage(100 / scale);
                }
            }
            else {
                regionParam = 'full';
                if (supportsListedSizes) {
                    var regionWidth = sizes[zoom][0], regionHeight = sizes[zoom][1];
                    if (version == _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__["Versions"].VERSION3) {
                        if (regionWidth == width && regionHeight == height) {
                            sizeParam = 'max';
                        }
                        else {
                            sizeParam = regionWidth + ',' + regionHeight;
                        }
                    }
                    else {
                        if (regionWidth == width) {
                            sizeParam = 'full';
                        }
                        else {
                            sizeParam = regionWidth + ',';
                        }
                    }
                }
                else {
                    sizeParam = version == _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_4__["Versions"].VERSION3 ? 'max' : 'full';
                }
            }
            return (baseUrl + regionParam + '/' + sizeParam + '/0/' + quality + '.' + format);
        };
        var IiifTileClass = _Zoomify_js__WEBPACK_IMPORTED_MODULE_2__["CustomTile"].bind(null, Object(_size_js__WEBPACK_IMPORTED_MODULE_8__["toSize"])(tileSize || 256).map(function (size) {
            return size * tilePixelRatio;
        }));
        _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: options.state,
            tileClass: IiifTileClass,
            tileGrid: tileGrid,
            tilePixelRatio: options.tilePixelRatio,
            tileUrlFunction: tileUrlFunction,
            transition: options.transition,
        }) || this;
        /**
         * @type {number|import("../array.js").NearestDirectionFunction}
         */
        _this.zDirection = options.zDirection;
        return _this;
    }
    return IIIF;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (IIIF);
//# sourceMappingURL=IIIF.js.map

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomTile", function() { return CustomTile; });
/* harmony import */ var _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91);
/* harmony import */ var _ImageTile_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72);
/* harmony import */ var _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(39);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/Zoomify
 */










/**
 * @enum {string}
 */
var TierSizeCalculation = {
    DEFAULT: 'default',
    TRUNCATED: 'truncated',
};
var CustomTile = /** @class */ (function (_super) {
    __extends(CustomTile, _super);
    /**
     * @param {import("../size.js").Size} tileSize Full tile size.
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../TileState.js").default} state State.
     * @param {string} src Image source URI.
     * @param {?string} crossOrigin Cross origin.
     * @param {import("../Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @param {import("../Tile.js").Options} [opt_options] Tile options.
     */
    function CustomTile(tileSize, tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) {
        var _this = _super.call(this, tileCoord, state, src, crossOrigin, tileLoadFunction, opt_options) || this;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement}
         */
        _this.zoomifyImage_ = null;
        /**
         * @type {import("../size.js").Size}
         */
        _this.tileSize_ = tileSize;
        return _this;
    }
    /**
     * Get the image element for this tile.
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */
    CustomTile.prototype.getImage = function () {
        if (this.zoomifyImage_) {
            return this.zoomifyImage_;
        }
        var image = _super.prototype.getImage.call(this);
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].LOADED) {
            var tileSize = this.tileSize_;
            if (image.width == tileSize[0] && image.height == tileSize[1]) {
                this.zoomifyImage_ = image;
                return image;
            }
            else {
                var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_6__["createCanvasContext2D"])(tileSize[0], tileSize[1]);
                context.drawImage(image, 0, 0);
                this.zoomifyImage_ = context.canvas;
                return context.canvas;
            }
        }
        else {
            return image;
        }
    };
    return CustomTile;
}(_ImageTile_js__WEBPACK_IMPORTED_MODULE_1__["default"]));

/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value  you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {number} [tilePixelRatio] The pixel ratio used by the tile service. For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px by 512px images (for retina/hidpi devices) then `tilePixelRatio` should be set to `2`
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {string} url URL template or base URL of the Zoomify service.
 * A base URL is the fixed part
 * of the URL, excluding the tile group, z, x, and y folder structure, e.g.
 * `http://my.zoomify.info/IMAGE.TIF/`. A URL template must include
 * `{TileGroup}`, `{x}`, `{y}`, and `{z}` placeholders, e.g.
 * `http://my.zoomify.info/IMAGE.TIF/{TileGroup}/{z}-{x}-{y}.jpg`.
 * Internet Imaging Protocol (IIP) with JTL extension can be also used with
 * `{tileIndex}` and `{z}` placeholders, e.g.
 * `http://my.zoomify.info?FIF=IMAGE.TIF&JTL={z},{tileIndex}`.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {string} [tierSizeCalculation] Tier size calculation method: `default` or `truncated`.
 * @property {import("../size.js").Size} size Size.
 * @property {import("../extent.js").Extent} [extent] Extent for the TileGrid that is created.
 * Default sets the TileGrid in the
 * fourth quadrant, meaning extent is `[0, -height, width, 0]`. To change the
 * extent to the first quadrant (the default for OpenLayers 2) set the extent
 * as `[0, 0, width, height]`.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number} [tileSize=256] Tile size. Same tile size is used for all zoom levels.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data in Zoomify format (both Zoomify and Internet
 * Imaging Protocol are supported).
 * @api
 */
var Zoomify = /** @class */ (function (_super) {
    __extends(Zoomify, _super);
    /**
     * @param {Options} opt_options Options.
     */
    function Zoomify(opt_options) {
        var _this = this;
        var options = opt_options;
        var size = options.size;
        var tierSizeCalculation = options.tierSizeCalculation !== undefined
            ? options.tierSizeCalculation
            : TierSizeCalculation.DEFAULT;
        var tilePixelRatio = options.tilePixelRatio || 1;
        var imageWidth = size[0];
        var imageHeight = size[1];
        var tierSizeInTiles = [];
        var tileSize = options.tileSize || _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_TILE_SIZE"];
        var tileSizeForTierSizeCalculation = tileSize * tilePixelRatio;
        switch (tierSizeCalculation) {
            case TierSizeCalculation.DEFAULT:
                while (imageWidth > tileSizeForTierSizeCalculation ||
                    imageHeight > tileSizeForTierSizeCalculation) {
                    tierSizeInTiles.push([
                        Math.ceil(imageWidth / tileSizeForTierSizeCalculation),
                        Math.ceil(imageHeight / tileSizeForTierSizeCalculation),
                    ]);
                    tileSizeForTierSizeCalculation += tileSizeForTierSizeCalculation;
                }
                break;
            case TierSizeCalculation.TRUNCATED:
                var width = imageWidth;
                var height = imageHeight;
                while (width > tileSizeForTierSizeCalculation ||
                    height > tileSizeForTierSizeCalculation) {
                    tierSizeInTiles.push([
                        Math.ceil(width / tileSizeForTierSizeCalculation),
                        Math.ceil(height / tileSizeForTierSizeCalculation),
                    ]);
                    width >>= 1;
                    height >>= 1;
                }
                break;
            default:
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_5__["assert"])(false, 53); // Unknown `tierSizeCalculation` configured
                break;
        }
        tierSizeInTiles.push([1, 1]);
        tierSizeInTiles.reverse();
        var resolutions = [tilePixelRatio];
        var tileCountUpToTier = [0];
        for (var i = 1, ii = tierSizeInTiles.length; i < ii; i++) {
            resolutions.push(tilePixelRatio << i);
            tileCountUpToTier.push(tierSizeInTiles[i - 1][0] * tierSizeInTiles[i - 1][1] +
                tileCountUpToTier[i - 1]);
        }
        resolutions.reverse();
        var tileGrid = new _tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
            tileSize: tileSize,
            extent: options.extent || [0, -imageHeight, imageWidth, 0],
            resolutions: resolutions,
        });
        var url = options.url;
        if (url &&
            url.indexOf('{TileGroup}') == -1 &&
            url.indexOf('{tileIndex}') == -1) {
            url += '{TileGroup}/{z}-{x}-{y}.jpg';
        }
        var urls = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__["expandUrl"])(url);
        var tileWidth = tileSize * tilePixelRatio;
        /**
         * @param {string} template Template.
         * @return {import("../Tile.js").UrlFunction} Tile URL function.
         */
        function createFromTemplate(template) {
            return (
            /**
             * @param {import("../tilecoord.js").TileCoord} tileCoord Tile Coordinate.
             * @param {number} pixelRatio Pixel ratio.
             * @param {import("../proj/Projection.js").default} projection Projection.
             * @return {string|undefined} Tile URL.
             */
            function (tileCoord, pixelRatio, projection) {
                if (!tileCoord) {
                    return undefined;
                }
                else {
                    var tileCoordZ = tileCoord[0];
                    var tileCoordX = tileCoord[1];
                    var tileCoordY = tileCoord[2];
                    var tileIndex = tileCoordX + tileCoordY * tierSizeInTiles[tileCoordZ][0];
                    var tileGroup = ((tileIndex + tileCountUpToTier[tileCoordZ]) / tileWidth) | 0;
                    var localContext_1 = {
                        'z': tileCoordZ,
                        'x': tileCoordX,
                        'y': tileCoordY,
                        'tileIndex': tileIndex,
                        'TileGroup': 'TileGroup' + tileGroup,
                    };
                    return template.replace(/\{(\w+?)\}/g, function (m, p) {
                        return localContext_1[p];
                    });
                }
            });
        }
        var tileUrlFunction = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__["createFromTileUrlFunctions"])(urls.map(createFromTemplate));
        var ZoomifyTileClass = CustomTile.bind(null, Object(_size_js__WEBPACK_IMPORTED_MODULE_9__["toSize"])(tileSize * tilePixelRatio));
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            tilePixelRatio: tilePixelRatio,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: ZoomifyTileClass,
            tileGrid: tileGrid,
            tileUrlFunction: tileUrlFunction,
            transition: options.transition,
        }) || this;
        /**
         * @type {number|import("../array.js").NearestDirectionFunction}
         */
        _this.zDirection = options.zDirection;
        // Server retina tile detection (non-standard):
        // Try loading the center tile for the highest resolution. If it is not
        // available, we are dealing with retina tiles, and need to adjust the
        // tile url calculation.
        var tileUrl = tileGrid.getTileCoordForCoordAndResolution(Object(_extent_js__WEBPACK_IMPORTED_MODULE_8__["getCenter"])(tileGrid.getExtent()), resolutions[resolutions.length - 1]);
        var testTileUrl = tileUrlFunction(tileUrl, 1, null);
        var image = new Image();
        image.addEventListener('error', function () {
            tileWidth = tileSize;
            this.changed();
        }.bind(_this));
        image.src = testTileUrl;
        return _this;
    }
    return Zoomify;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Zoomify);
//# sourceMappingURL=Zoomify.js.map

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Versions", function() { return Versions; });
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52);
/**
 * @module ol/format/IIIFInfo
 */
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};


/**
 * @typedef {Object} PreferredOptions
 * @property {string} [format] Preferred image format. Will be used if the image information
 * indicates support for that format.
 * @property {string} [quality] IIIF image qualitiy.  Will be used if the image information
 * indicates support for that quality.
 */
/**
 * @typedef {Object} SupportedFeatures
 * @property {Array<string>} [supports] Supported IIIF image size and region
 * calculation features.
 * @property {Array<string>} [formats] Supported image formats.
 * @property {Array<string>} [qualities] Supported IIIF image qualities.
 */
/**
 * @typedef {Object} TileInfo
 * @property {Array<number>} scaleFactors Supported resolution scaling factors.
 * @property {number} width Tile width in pixels.
 * @property {number} [height] Tile height in pixels. Same as tile width if height is
 * not given.
 */
/**
 * @typedef {Object} IiifProfile
 * @property {Array<string>} [formats] Supported image formats for the image service.
 * @property {Array<string>} [qualities] Supported IIIF image qualities.
 * @property {Array<string>} [supports] Supported features.
 * @property {number} [maxArea] Maximum area (pixels) available for this image service.
 * @property {number} [maxHeight] Maximum height.
 * @property {number} [maxWidth] Maximum width.
 */
/**
 * @typedef {Object<string,string|number|Array<number|string|IiifProfile>|Object<string, number>|TileInfo>}
 *    ImageInformationResponse
 */
/**
 * Enum representing the major IIIF Image API versions
 * @enum {string}
 */
var Versions = {
    VERSION1: 'version1',
    VERSION2: 'version2',
    VERSION3: 'version3',
};
/**
 * Supported image formats, qualities and supported region / size calculation features
 * for different image API versions and compliance levels
 * @const
 * @type {Object<string, Object<string, SupportedFeatures>>}
 */
var IIIF_PROFILE_VALUES = {};
IIIF_PROFILE_VALUES[Versions.VERSION1] = {
    'level0': {
        supports: [],
        formats: [],
        qualities: ['native'],
    },
    'level1': {
        supports: ['regionByPx', 'sizeByW', 'sizeByH', 'sizeByPct'],
        formats: ['jpg'],
        qualities: ['native'],
    },
    'level2': {
        supports: [
            'regionByPx',
            'regionByPct',
            'sizeByW',
            'sizeByH',
            'sizeByPct',
            'sizeByConfinedWh',
            'sizeByWh',
        ],
        formats: ['jpg', 'png'],
        qualities: ['native', 'color', 'grey', 'bitonal'],
    },
};
IIIF_PROFILE_VALUES[Versions.VERSION2] = {
    'level0': {
        supports: [],
        formats: ['jpg'],
        qualities: ['default'],
    },
    'level1': {
        supports: ['regionByPx', 'sizeByW', 'sizeByH', 'sizeByPct'],
        formats: ['jpg'],
        qualities: ['default'],
    },
    'level2': {
        supports: [
            'regionByPx',
            'regionByPct',
            'sizeByW',
            'sizeByH',
            'sizeByPct',
            'sizeByConfinedWh',
            'sizeByDistortedWh',
            'sizeByWh',
        ],
        formats: ['jpg', 'png'],
        qualities: ['default', 'bitonal'],
    },
};
IIIF_PROFILE_VALUES[Versions.VERSION3] = {
    'level0': {
        supports: [],
        formats: ['jpg'],
        qualities: ['default'],
    },
    'level1': {
        supports: ['regionByPx', 'regionSquare', 'sizeByW', 'sizeByH', 'sizeByWh'],
        formats: ['jpg'],
        qualities: ['default'],
    },
    'level2': {
        supports: [
            'regionByPx',
            'regionSquare',
            'regionByPct',
            'sizeByW',
            'sizeByH',
            'sizeByPct',
            'sizeByConfinedWh',
            'sizeByWh',
        ],
        formats: ['jpg', 'png'],
        qualities: ['default'],
    },
};
IIIF_PROFILE_VALUES['none'] = {
    'none': {
        supports: [],
        formats: [],
        qualities: [],
    },
};
var COMPLIANCE_VERSION1 = /^https?:\/\/library\.stanford\.edu\/iiif\/image-api\/(?:1\.1\/)?compliance\.html#level[0-2]$/;
var COMPLIANCE_VERSION2 = /^https?:\/\/iiif\.io\/api\/image\/2\/level[0-2](?:\.json)?$/;
var COMPLIANCE_VERSION3 = /(^https?:\/\/iiif\.io\/api\/image\/3\/level[0-2](?:\.json)?$)|(^level[0-2]$)/;
function generateVersion1Options(iiifInfo) {
    var levelProfile = iiifInfo.getComplianceLevelSupportedFeatures();
    // Version 1.0 and 1.1 do not require a profile.
    if (levelProfile === undefined) {
        levelProfile = IIIF_PROFILE_VALUES[Versions.VERSION1]['level0'];
    }
    return {
        url: iiifInfo.imageInfo['@id'] === undefined
            ? undefined
            : iiifInfo.imageInfo['@id'].replace(/\/?(?:info\.json)?$/g, ''),
        supports: levelProfile.supports,
        formats: __spreadArray(__spreadArray([], levelProfile.formats), [
            iiifInfo.imageInfo.formats === undefined
                ? []
                : iiifInfo.imageInfo.formats,
        ]),
        qualities: __spreadArray(__spreadArray([], levelProfile.qualities), [
            iiifInfo.imageInfo.qualities === undefined
                ? []
                : iiifInfo.imageInfo.qualities,
        ]),
        resolutions: iiifInfo.imageInfo.scale_factors,
        tileSize: iiifInfo.imageInfo.tile_width !== undefined
            ? iiifInfo.imageInfo.tile_height !== undefined
                ? [iiifInfo.imageInfo.tile_width, iiifInfo.imageInfo.tile_height]
                : [iiifInfo.imageInfo.tile_width, iiifInfo.imageInfo.tile_width]
            : iiifInfo.imageInfo.tile_height != undefined
                ? [iiifInfo.imageInfo.tile_height, iiifInfo.imageInfo.tile_height]
                : undefined,
    };
}
function generateVersion2Options(iiifInfo) {
    var levelProfile = iiifInfo.getComplianceLevelSupportedFeatures(), additionalProfile = Array.isArray(iiifInfo.imageInfo.profile) &&
        iiifInfo.imageInfo.profile.length > 1, profileSupports = additionalProfile && iiifInfo.imageInfo.profile[1].supports
        ? iiifInfo.imageInfo.profile[1].supports
        : [], profileFormats = additionalProfile && iiifInfo.imageInfo.profile[1].formats
        ? iiifInfo.imageInfo.profile[1].formats
        : [], profileQualities = additionalProfile && iiifInfo.imageInfo.profile[1].qualities
        ? iiifInfo.imageInfo.profile[1].qualities
        : [];
    return {
        url: iiifInfo.imageInfo['@id'].replace(/\/?(?:info\.json)?$/g, ''),
        sizes: iiifInfo.imageInfo.sizes === undefined
            ? undefined
            : iiifInfo.imageInfo.sizes.map(function (size) {
                return [size.width, size.height];
            }),
        tileSize: iiifInfo.imageInfo.tiles === undefined
            ? undefined
            : [
                iiifInfo.imageInfo.tiles.map(function (tile) {
                    return tile.width;
                })[0],
                iiifInfo.imageInfo.tiles.map(function (tile) {
                    return tile.height === undefined ? tile.width : tile.height;
                })[0],
            ],
        resolutions: iiifInfo.imageInfo.tiles === undefined
            ? undefined
            : iiifInfo.imageInfo.tiles.map(function (tile) {
                return tile.scaleFactors;
            })[0],
        supports: __spreadArray(__spreadArray([], levelProfile.supports), profileSupports),
        formats: __spreadArray(__spreadArray([], levelProfile.formats), profileFormats),
        qualities: __spreadArray(__spreadArray([], levelProfile.qualities), profileQualities),
    };
}
function generateVersion3Options(iiifInfo) {
    var levelProfile = iiifInfo.getComplianceLevelSupportedFeatures(), formats = iiifInfo.imageInfo.extraFormats === undefined
        ? levelProfile.formats
        : __spreadArray(__spreadArray([], levelProfile.formats), iiifInfo.imageInfo.extraFormats), preferredFormat = iiifInfo.imageInfo.preferredFormats !== undefined &&
        Array.isArray(iiifInfo.imageInfo.preferredFormats) &&
        iiifInfo.imageInfo.preferredFormats.length > 0
        ? iiifInfo.imageInfo.preferredFormats
            .filter(function (format) {
            return Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["includes"])(['jpg', 'png', 'gif'], format);
        })
            .reduce(function (acc, format) {
            return acc === undefined && Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["includes"])(formats, format)
                ? format
                : acc;
        }, undefined)
        : undefined;
    return {
        url: iiifInfo.imageInfo['id'],
        sizes: iiifInfo.imageInfo.sizes === undefined
            ? undefined
            : iiifInfo.imageInfo.sizes.map(function (size) {
                return [size.width, size.height];
            }),
        tileSize: iiifInfo.imageInfo.tiles === undefined
            ? undefined
            : [
                iiifInfo.imageInfo.tiles.map(function (tile) {
                    return tile.width;
                })[0],
                iiifInfo.imageInfo.tiles.map(function (tile) {
                    return tile.height;
                })[0],
            ],
        resolutions: iiifInfo.imageInfo.tiles === undefined
            ? undefined
            : iiifInfo.imageInfo.tiles.map(function (tile) {
                return tile.scaleFactors;
            })[0],
        supports: iiifInfo.imageInfo.extraFeatures === undefined
            ? levelProfile.supports
            : __spreadArray(__spreadArray([], levelProfile.supports), iiifInfo.imageInfo.extraFeatures),
        formats: formats,
        qualities: iiifInfo.imageInfo.extraQualities === undefined
            ? levelProfile.qualities
            : __spreadArray(__spreadArray([], levelProfile.qualities), iiifInfo.imageInfo.extraQualities),
        preferredFormat: preferredFormat,
    };
}
var versionFunctions = {};
versionFunctions[Versions.VERSION1] = generateVersion1Options;
versionFunctions[Versions.VERSION2] = generateVersion2Options;
versionFunctions[Versions.VERSION3] = generateVersion3Options;
/**
 * @classdesc
 * Format for transforming IIIF Image API image information responses into
 * IIIF tile source ready options
 *
 * @api
 */
var IIIFInfo = /** @class */ (function () {
    /**
     * @param {string|ImageInformationResponse} imageInfo
     * Deserialized image information JSON response object or JSON response as string
     */
    function IIIFInfo(imageInfo) {
        this.setImageInfo(imageInfo);
    }
    /**
     * @param {string|ImageInformationResponse} imageInfo
     * Deserialized image information JSON response object or JSON response as string
     * @api
     */
    IIIFInfo.prototype.setImageInfo = function (imageInfo) {
        if (typeof imageInfo == 'string') {
            this.imageInfo = JSON.parse(imageInfo);
        }
        else {
            this.imageInfo = imageInfo;
        }
    };
    /**
     * @return {Versions} Major IIIF version.
     * @api
     */
    IIIFInfo.prototype.getImageApiVersion = function () {
        if (this.imageInfo === undefined) {
            return;
        }
        var context = this.imageInfo['@context'] || 'ol-no-context';
        if (typeof context == 'string') {
            context = [context];
        }
        for (var i = 0; i < context.length; i++) {
            switch (context[i]) {
                case 'http://library.stanford.edu/iiif/image-api/1.1/context.json':
                case 'http://iiif.io/api/image/1/context.json':
                    return Versions.VERSION1;
                case 'http://iiif.io/api/image/2/context.json':
                    return Versions.VERSION2;
                case 'http://iiif.io/api/image/3/context.json':
                    return Versions.VERSION3;
                case 'ol-no-context':
                    // Image API 1.0 has no '@context'
                    if (this.getComplianceLevelEntryFromProfile(Versions.VERSION1) &&
                        this.imageInfo.identifier) {
                        return Versions.VERSION1;
                    }
                    break;
                default:
            }
        }
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(false, 61);
    };
    /**
     * @param {Versions} version Optional IIIF image API version
     * @return {string} Compliance level as it appears in the IIIF image information
     * response.
     */
    IIIFInfo.prototype.getComplianceLevelEntryFromProfile = function (version) {
        if (this.imageInfo === undefined || this.imageInfo.profile === undefined) {
            return;
        }
        if (version === undefined) {
            version = this.getImageApiVersion();
        }
        switch (version) {
            case Versions.VERSION1:
                if (COMPLIANCE_VERSION1.test(this.imageInfo.profile)) {
                    return this.imageInfo.profile;
                }
                break;
            case Versions.VERSION3:
                if (COMPLIANCE_VERSION3.test(this.imageInfo.profile)) {
                    return this.imageInfo.profile;
                }
                break;
            case Versions.VERSION2:
                if (typeof this.imageInfo.profile === 'string' &&
                    COMPLIANCE_VERSION2.test(this.imageInfo.profile)) {
                    return this.imageInfo.profile;
                }
                if (Array.isArray(this.imageInfo.profile) &&
                    this.imageInfo.profile.length > 0 &&
                    typeof this.imageInfo.profile[0] === 'string' &&
                    COMPLIANCE_VERSION2.test(this.imageInfo.profile[0])) {
                    return this.imageInfo.profile[0];
                }
                break;
            default:
        }
    };
    /**
     * @param {Versions} version Optional IIIF image API version
     * @return {string} Compliance level, on of 'level0', 'level1' or 'level2' or undefined
     */
    IIIFInfo.prototype.getComplianceLevelFromProfile = function (version) {
        var complianceLevel = this.getComplianceLevelEntryFromProfile(version);
        if (complianceLevel === undefined) {
            return undefined;
        }
        var level = complianceLevel.match(/level[0-2](?:\.json)?$/g);
        return Array.isArray(level) ? level[0].replace('.json', '') : undefined;
    };
    /**
     * @return {SupportedFeatures} Image formats, qualities and region / size calculation
     * methods that are supported by the IIIF service.
     */
    IIIFInfo.prototype.getComplianceLevelSupportedFeatures = function () {
        if (this.imageInfo === undefined) {
            return;
        }
        var version = this.getImageApiVersion();
        var level = this.getComplianceLevelFromProfile(version);
        if (level === undefined) {
            return IIIF_PROFILE_VALUES['none']['none'];
        }
        return IIIF_PROFILE_VALUES[version][level];
    };
    /**
     * @param {PreferredOptions} [opt_preferredOptions] Optional options for preferred format and quality.
     * @return {import("../source/IIIF.js").Options} IIIF tile source ready constructor options.
     * @api
     */
    IIIFInfo.prototype.getTileSourceOptions = function (opt_preferredOptions) {
        var options = opt_preferredOptions || {}, version = this.getImageApiVersion();
        if (version === undefined) {
            return;
        }
        var imageOptions = version === undefined ? undefined : versionFunctions[version](this);
        if (imageOptions === undefined) {
            return;
        }
        return {
            url: imageOptions.url,
            version: version,
            size: [this.imageInfo.width, this.imageInfo.height],
            sizes: imageOptions.sizes,
            format: options.format !== undefined &&
                Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["includes"])(imageOptions.formats, options.format)
                ? options.format
                : imageOptions.preferredFormat !== undefined
                    ? imageOptions.preferredFormat
                    : 'jpg',
            supports: imageOptions.supports,
            quality: options.quality && Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["includes"])(imageOptions.qualities, options.quality)
                ? options.quality
                : Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["includes"])(imageOptions.qualities, 'native')
                    ? 'native'
                    : 'default',
            resolutions: Array.isArray(imageOptions.resolutions)
                ? imageOptions.resolutions.sort(function (a, b) {
                    return b - a;
                })
                : undefined,
            tileSize: imageOptions.tileSize,
        };
    };
    return IIIFInfo;
}());
/* harmony default export */ __webpack_exports__["default"] = (IIIFInfo);
//# sourceMappingURL=IIIFInfo.js.map

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageSourceEventType", function() { return ImageSourceEventType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageSourceEvent", function() { return ImageSourceEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultImageLoadFunction", function() { return defaultImageLoadFunction; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
/* harmony import */ var _reproj_Image_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(118);
/* harmony import */ var _Source_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87);
/* harmony import */ var _reproj_common_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/Image
 */










/**
 * @enum {string}
 */
var ImageSourceEventType = {
    /**
     * Triggered when an image starts loading.
     * @event module:ol/source/Image.ImageSourceEvent#imageloadstart
     * @api
     */
    IMAGELOADSTART: 'imageloadstart',
    /**
     * Triggered when an image finishes loading.
     * @event module:ol/source/Image.ImageSourceEvent#imageloadend
     * @api
     */
    IMAGELOADEND: 'imageloadend',
    /**
     * Triggered if image loading results in an error.
     * @event module:ol/source/Image.ImageSourceEvent#imageloaderror
     * @api
     */
    IMAGELOADERROR: 'imageloaderror',
};
/**
 * @typedef {'imageloadend'|'imageloaderror'|'imageloadstart'} ImageSourceEventTypes
 */
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Image~ImageSource} instances are instances of this
 * type.
 */
var ImageSourceEvent = /** @class */ (function (_super) {
    __extends(ImageSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../Image.js").default} image The image.
     */
    function ImageSourceEvent(type, image) {
        var _this = _super.call(this, type) || this;
        /**
         * The image related to the event.
         * @type {import("../Image.js").default}
         * @api
         */
        _this.image = image;
        return _this;
    }
    return ImageSourceEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<ImageSourceEventTypes, ImageSourceEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |ImageSourceEventTypes, Return>} ImageSourceOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection.
 * @property {Array<number>} [resolutions] Resolutions.
 * @property {import("./State.js").default} [state] State.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for sources providing a single image.
 * @abstract
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */
var ImageSource = /** @class */ (function (_super) {
    __extends(ImageSource, _super);
    /**
     * @param {Options} options Single image source options.
     */
    function ImageSource(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            projection: options.projection,
            state: options.state,
        }) || this;
        /***
         * @type {ImageSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ImageSourceOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ImageSourceOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.resolutions_ =
            options.resolutions !== undefined ? options.resolutions : null;
        /**
         * @private
         * @type {import("../reproj/Image.js").default}
         */
        _this.reprojectedImage_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.reprojectedRevision_ = 0;
        /**
         * @private
         * @type {object|undefined}
         */
        _this.contextOptions_ =
            options.imageSmoothing === false ? _common_js__WEBPACK_IMPORTED_MODULE_5__["IMAGE_SMOOTHING_DISABLED"] : undefined;
        return _this;
    }
    /**
     * @return {Array<number>} Resolutions.
     */
    ImageSource.prototype.getResolutions = function () {
        return this.resolutions_;
    };
    /**
     * @return {Object|undefined} Context options.
     */
    ImageSource.prototype.getContextOptions = function () {
        return this.contextOptions_;
    };
    /**
     * @protected
     * @param {number} resolution Resolution.
     * @return {number} Resolution.
     */
    ImageSource.prototype.findNearestResolution = function (resolution) {
        if (this.resolutions_) {
            var idx = Object(_array_js__WEBPACK_IMPORTED_MODULE_9__["linearFindNearest"])(this.resolutions_, resolution, 0);
            resolution = this.resolutions_[idx];
        }
        return resolution;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../ImageBase.js").default} Single image.
     */
    ImageSource.prototype.getImage = function (extent, resolution, pixelRatio, projection) {
        var sourceProjection = this.getProjection();
        if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_4__["ENABLE_RASTER_REPROJECTION"] ||
            !sourceProjection ||
            !projection ||
            Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(sourceProjection, projection)) {
            if (sourceProjection) {
                projection = sourceProjection;
            }
            return this.getImageInternal(extent, resolution, pixelRatio, projection);
        }
        else {
            if (this.reprojectedImage_) {
                if (this.reprojectedRevision_ == this.getRevision() &&
                    Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["equivalent"])(this.reprojectedImage_.getProjection(), projection) &&
                    this.reprojectedImage_.getResolution() == resolution &&
                    Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["equals"])(this.reprojectedImage_.getExtent(), extent)) {
                    return this.reprojectedImage_;
                }
                this.reprojectedImage_.dispose();
                this.reprojectedImage_ = null;
            }
            this.reprojectedImage_ = new _reproj_Image_js__WEBPACK_IMPORTED_MODULE_2__["default"](sourceProjection, projection, extent, resolution, pixelRatio, function (extent, resolution, pixelRatio) {
                return this.getImageInternal(extent, resolution, pixelRatio, sourceProjection);
            }.bind(this), this.contextOptions_);
            this.reprojectedRevision_ = this.getRevision();
            return this.reprojectedImage_;
        }
    };
    /**
     * @abstract
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../ImageBase.js").default} Single image.
     * @protected
     */
    ImageSource.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_6__["abstract"])();
    };
    /**
     * Handle image change events.
     * @param {import("../events/Event.js").default} event Event.
     * @protected
     */
    ImageSource.prototype.handleImageChange = function (event) {
        var image = /** @type {import("../Image.js").default} */ (event.target);
        switch (image.getState()) {
            case _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADING:
                this.loading = true;
                this.dispatchEvent(new ImageSourceEvent(ImageSourceEventType.IMAGELOADSTART, image));
                break;
            case _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED:
                this.loading = false;
                this.dispatchEvent(new ImageSourceEvent(ImageSourceEventType.IMAGELOADEND, image));
                break;
            case _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR:
                this.loading = false;
                this.dispatchEvent(new ImageSourceEvent(ImageSourceEventType.IMAGELOADERROR, image));
                break;
            default:
            // pass
        }
    };
    return ImageSource;
}(_Source_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/**
 * Default image load function for image sources that use import("../Image.js").Image image
 * instances.
 * @param {import("../Image.js").default} image Image.
 * @param {string} src Source.
 */
function defaultImageLoadFunction(image, src) {
    /** @type {HTMLImageElement|HTMLVideoElement} */ (image.getImage()).src = src;
}
/* harmony default export */ __webpack_exports__["default"] = (ImageSource);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _ImageBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37);
/* harmony import */ var _Triangulation_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78);
/* harmony import */ var _reproj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/reproj/Image
 */








/**
 * @typedef {function(import("../extent.js").Extent, number, number) : import("../ImageBase.js").default} FunctionType
 */
/**
 * @classdesc
 * Class encapsulating single reprojected image.
 * See {@link module:ol/source/Image~ImageSource}.
 */
var ReprojImage = /** @class */ (function (_super) {
    __extends(ReprojImage, _super);
    /**
     * @param {import("../proj/Projection.js").default} sourceProj Source projection (of the data).
     * @param {import("../proj/Projection.js").default} targetProj Target projection.
     * @param {import("../extent.js").Extent} targetExtent Target extent.
     * @param {number} targetResolution Target resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {FunctionType} getImageFunction
     *     Function returning source images (extent, resolution, pixelRatio).
     * @param {object} [opt_contextOptions] Properties to set on the canvas context.
     */
    function ReprojImage(sourceProj, targetProj, targetExtent, targetResolution, pixelRatio, getImageFunction, opt_contextOptions) {
        var _this = this;
        var maxSourceExtent = sourceProj.getExtent();
        var maxTargetExtent = targetProj.getExtent();
        var limitedTargetExtent = maxTargetExtent
            ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getIntersection"])(targetExtent, maxTargetExtent)
            : targetExtent;
        var targetCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getCenter"])(limitedTargetExtent);
        var sourceResolution = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_5__["calculateSourceResolution"])(sourceProj, targetProj, targetCenter, targetResolution);
        var errorThresholdInPixels = _common_js__WEBPACK_IMPORTED_MODULE_0__["ERROR_THRESHOLD"];
        var triangulation = new _Triangulation_js__WEBPACK_IMPORTED_MODULE_4__["default"](sourceProj, targetProj, limitedTargetExtent, maxSourceExtent, sourceResolution * errorThresholdInPixels, targetResolution);
        var sourceExtent = triangulation.calculateSourceExtent();
        var sourceImage = getImageFunction(sourceExtent, sourceResolution, pixelRatio);
        var state = sourceImage ? _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE : _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY;
        var sourcePixelRatio = sourceImage ? sourceImage.getPixelRatio() : 1;
        _this = _super.call(this, targetExtent, targetResolution, sourcePixelRatio, state) || this;
        /**
         * @private
         * @type {import("../proj/Projection.js").default}
         */
        _this.targetProj_ = targetProj;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.maxSourceExtent_ = maxSourceExtent;
        /**
         * @private
         * @type {!import("./Triangulation.js").default}
         */
        _this.triangulation_ = triangulation;
        /**
         * @private
         * @type {number}
         */
        _this.targetResolution_ = targetResolution;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.targetExtent_ = targetExtent;
        /**
         * @private
         * @type {import("../ImageBase.js").default}
         */
        _this.sourceImage_ = sourceImage;
        /**
         * @private
         * @type {number}
         */
        _this.sourcePixelRatio_ = sourcePixelRatio;
        /**
         * @private
         * @type {object}
         */
        _this.contextOptions_ = opt_contextOptions;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.canvas_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */
        _this.sourceListenerKey_ = null;
        return _this;
    }
    /**
     * Clean up.
     */
    ReprojImage.prototype.disposeInternal = function () {
        if (this.state == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING) {
            this.unlistenSource_();
        }
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * @return {HTMLCanvasElement} Image.
     */
    ReprojImage.prototype.getImage = function () {
        return this.canvas_;
    };
    /**
     * @return {import("../proj/Projection.js").default} Projection.
     */
    ReprojImage.prototype.getProjection = function () {
        return this.targetProj_;
    };
    /**
     * @private
     */
    ReprojImage.prototype.reproject_ = function () {
        var sourceState = this.sourceImage_.getState();
        if (sourceState == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED) {
            var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(this.targetExtent_) / this.targetResolution_;
            var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getHeight"])(this.targetExtent_) / this.targetResolution_;
            this.canvas_ = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_5__["render"])(width, height, this.sourcePixelRatio_, this.sourceImage_.getResolution(), this.maxSourceExtent_, this.targetResolution_, this.targetExtent_, this.triangulation_, [
                {
                    extent: this.sourceImage_.getExtent(),
                    image: this.sourceImage_.getImage(),
                },
            ], 0, undefined, this.contextOptions_);
        }
        this.state = sourceState;
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     */
    ReprojImage.prototype.load = function () {
        if (this.state == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) {
            this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING;
            this.changed();
            var sourceState = this.sourceImage_.getState();
            if (sourceState == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED || sourceState == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR) {
                this.reproject_();
            }
            else {
                this.sourceListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(this.sourceImage_, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, function (e) {
                    var sourceState = this.sourceImage_.getState();
                    if (sourceState == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED ||
                        sourceState == _ImageState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR) {
                        this.unlistenSource_();
                        this.reproject_();
                    }
                }, this);
                this.sourceImage_.load();
            }
        }
    };
    /**
     * @private
     */
    ReprojImage.prototype.unlistenSource_ = function () {
        Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(
        /** @type {!import("../events.js").EventsKey} */ (this.sourceListenerKey_));
        this.sourceListenerKey_ = null;
    };
    return ReprojImage;
}(_ImageBase_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ReprojImage);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(120);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/**
 * @module ol/source/ImageArcGISRest
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting the image from
 * the remote server.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given
 * a URL.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service
 * defaults will be used for any fields not specified. `FORMAT` is `PNG32` by default. `F` is
 * `IMAGE` by default. `TRANSPARENT` is `true` by default.  `BBOX`, `SIZE`, `BBOXSR`, and `IMAGESR`
 * will be set dynamically. Set `LAYERS` to override the default service layer visibility. See
 * https://developers.arcgis.com/rest/services-reference/export-map.htm
 * for further reference.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * The projection code must contain a numeric end portion separated by :
 * or the entire code must form a valid ArcGIS SpatialReference definition.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport,
 * `2` means twice the size of the map viewport, and so on.
 * @property {Array<number>} [resolutions] Resolutions. If specified, requests will be made for
 * these resolutions only.
 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The url
 * should include /MapServer or /ImageServer.
 */
/**
 * @classdesc
 * Source for data from ArcGIS Rest services providing single, untiled images.
 * Useful when underlying map service has labels.
 *
 * If underlying map service is not using labels,
 * take advantage of ol image caching and use
 * {@link module:ol/source/TileArcGISRest} data source.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */
var ImageArcGISRest = /** @class */ (function (_super) {
    __extends(ImageArcGISRest, _super);
    /**
     * @param {Options} [opt_options] Image ArcGIS Rest Options.
     */
    function ImageArcGISRest(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            attributions: options.attributions,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            resolutions: options.resolutions,
        }) || this;
        /**
         * @private
         * @type {?string}
         */
        _this.crossOrigin_ =
            options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
         * @private
         * @type {string|undefined}
         */
        _this.url_ = options.url;
        /**
         * @private
         * @type {import("../Image.js").LoadFunction}
         */
        _this.imageLoadFunction_ =
            options.imageLoadFunction !== undefined
                ? options.imageLoadFunction
                : _Image_js__WEBPACK_IMPORTED_MODULE_1__["defaultImageLoadFunction"];
        /**
         * @private
         * @type {!Object}
         */
        _this.params_ = options.params || {};
        /**
         * @private
         * @type {import("../Image.js").default}
         */
        _this.image_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.imageSize_ = [0, 0];
        /**
         * @private
         * @type {number}
         */
        _this.renderedRevision_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        return _this;
    }
    /**
     * Get the user-provided params, i.e. those passed to the constructor through
     * the "params" option, and possibly updated using the updateParams method.
     * @return {Object} Params.
     * @api
     */
    ImageArcGISRest.prototype.getParams = function () {
        return this.params_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     */
    ImageArcGISRest.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) {
            return null;
        }
        resolution = this.findNearestResolution(resolution);
        pixelRatio = this.hidpi_ ? pixelRatio : 1;
        var image = this.image_;
        if (image &&
            this.renderedRevision_ == this.getRevision() &&
            image.getResolution() == resolution &&
            image.getPixelRatio() == pixelRatio &&
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["containsExtent"])(image.getExtent(), extent)) {
            return image;
        }
        var params = {
            'F': 'image',
            'FORMAT': 'PNG32',
            'TRANSPARENT': true,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(params, this.params_);
        extent = extent.slice();
        var centerX = (extent[0] + extent[2]) / 2;
        var centerY = (extent[1] + extent[3]) / 2;
        if (this.ratio_ != 1) {
            var halfWidth = (this.ratio_ * Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(extent)) / 2;
            var halfHeight = (this.ratio_ * Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getHeight"])(extent)) / 2;
            extent[0] = centerX - halfWidth;
            extent[1] = centerY - halfHeight;
            extent[2] = centerX + halfWidth;
            extent[3] = centerY + halfHeight;
        }
        var imageResolution = resolution / pixelRatio;
        // Compute an integer width and height.
        var width = Math.ceil(Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(extent) / imageResolution);
        var height = Math.ceil(Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getHeight"])(extent) / imageResolution);
        // Modify the extent to match the integer width and height.
        extent[0] = centerX - (imageResolution * width) / 2;
        extent[2] = centerX + (imageResolution * width) / 2;
        extent[1] = centerY - (imageResolution * height) / 2;
        extent[3] = centerY + (imageResolution * height) / 2;
        this.imageSize_[0] = width;
        this.imageSize_[1] = height;
        var url = this.getRequestUrl_(extent, this.imageSize_, pixelRatio, projection, params);
        this.image_ = new _Image_js__WEBPACK_IMPORTED_MODULE_2__["default"](extent, resolution, pixelRatio, url, this.crossOrigin_, this.imageLoadFunction_);
        this.renderedRevision_ = this.getRevision();
        this.image_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.handleImageChange.bind(this));
        return this.image_;
    };
    /**
     * Return the image load function of the source.
     * @return {import("../Image.js").LoadFunction} The image load function.
     * @api
     */
    ImageArcGISRest.prototype.getImageLoadFunction = function () {
        return this.imageLoadFunction_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {import("../size.js").Size} size Size.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {Object} params Params.
     * @return {string} Request URL.
     * @private
     */
    ImageArcGISRest.prototype.getRequestUrl_ = function (extent, size, pixelRatio, projection, params) {
        // ArcGIS Server only wants the numeric portion of the projection ID.
        // (if there is no numeric portion the entire projection code must
        // form a valid ArcGIS SpatialReference definition).
        var srid = projection
            .getCode()
            .split(/:(?=\d+$)/)
            .pop();
        params['SIZE'] = size[0] + ',' + size[1];
        params['BBOX'] = extent.join(',');
        params['BBOXSR'] = srid;
        params['IMAGESR'] = srid;
        params['DPI'] = Math.round(90 * pixelRatio);
        var url = this.url_;
        var modifiedUrl = url
            .replace(/MapServer\/?$/, 'MapServer/export')
            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
        if (modifiedUrl == url) {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(false, 50); // `options.featureTypes` should be an Array
        }
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_3__["appendParams"])(modifiedUrl, params);
    };
    /**
     * Return the URL used for this ArcGIS source.
     * @return {string|undefined} URL.
     * @api
     */
    ImageArcGISRest.prototype.getUrl = function () {
        return this.url_;
    };
    /**
     * Set the image load function of the source.
     * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
     * @api
     */
    ImageArcGISRest.prototype.setImageLoadFunction = function (imageLoadFunction) {
        this.image_ = null;
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    };
    /**
     * Set the URL to use for requests.
     * @param {string|undefined} url URL.
     * @api
     */
    ImageArcGISRest.prototype.setUrl = function (url) {
        if (url != this.url_) {
            this.url_ = url;
            this.image_ = null;
            this.changed();
        }
    };
    /**
     * Update the user-provided params.
     * @param {Object} params Params.
     * @api
     */
    ImageArcGISRest.prototype.updateParams = function (params) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(this.params_, params);
        this.image_ = null;
        this.changed();
    };
    return ImageArcGISRest;
}(_Image_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageArcGISRest);
//# sourceMappingURL=ImageArcGISRest.js.map

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendParams", function() { return appendParams; });
/**
 * @module ol/uri
 */
/**
 * Appends query parameters to a URI.
 *
 * @param {string} uri The original URI, which may already have query data.
 * @param {!Object} params An object where keys are URI-encoded parameter keys,
 *     and the values are arbitrary types or arrays.
 * @return {string} The new URI.
 */
function appendParams(uri, params) {
    var keyParams = [];
    // Skip any null or undefined parameter values
    Object.keys(params).forEach(function (k) {
        if (params[k] !== null && params[k] !== undefined) {
            keyParams.push(k + '=' + encodeURIComponent(params[k]));
        }
    });
    var qs = keyParams.join('&');
    // remove any trailing ? or &
    uri = uri.replace(/[?&]$/, '');
    // append ? or & depending on whether uri has existing parameters
    uri = uri.indexOf('?') === -1 ? uri + '?' : uri + '&';
    return uri + qs;
}
//# sourceMappingURL=uri.js.map

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(122);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/**
 * @module ol/source/ImageCanvas
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * A function returning the canvas element (`{HTMLCanvasElement}`)
 * used by the source as an image. The arguments passed to the function are:
 * {@link module:ol/extent~Extent} the image extent, `{number}` the image resolution,
 * `{number}` the pixel ratio of the map, {@link module:ol/size~Size} the image size,
 * and {@link module:ol/proj/Projection} the image projection. The canvas returned by
 * this function is cached by the source. The this keyword inside the function
 * references the {@link module:ol/source/ImageCanvas}.
 *
 * @typedef {function(this:import("../ImageCanvas.js").default, import("../extent.js").Extent, number,
 *     number, import("../size.js").Size, import("../proj/Projection.js").default): HTMLCanvasElement} FunctionType
 */
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {FunctionType} [canvasFunction] Canvas function.
 * The function returning the canvas element used by the source
 * as an image. The arguments passed to the function are: `{import("../extent.js").Extent}` the
 * image extent, `{number}` the image resolution, `{number}` the pixel ratio of the map,
 * `{import("../size.js").Size}` the image size, and `{import("../proj/Projection.js").Projection}` the image
 * projection. The canvas returned by this function is cached by the source. If
 * the value returned by the function is later changed then
 * `changed` should be called on the source for the source to
 * invalidate the current cached image. See: {@link module:ol/Observable~Observable#changed}
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. 1 means canvases are the size of the map viewport, 2 means twice the
 * width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, new canvases will be created for these resolutions
 * @property {import("./State.js").default} [state] Source state.
 */
/**
 * @classdesc
 * Base class for image sources where a canvas element is the image.
 * @api
 */
var ImageCanvasSource = /** @class */ (function (_super) {
    __extends(ImageCanvasSource, _super);
    /**
     * @param {Options} [opt_options] ImageCanvas options.
     */
    function ImageCanvasSource(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            attributions: options.attributions,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            resolutions: options.resolutions,
            state: options.state,
        }) || this;
        /**
         * @private
         * @type {FunctionType}
         */
        _this.canvasFunction_ = options.canvasFunction;
        /**
         * @private
         * @type {import("../ImageCanvas.js").default}
         */
        _this.canvas_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.renderedRevision_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        return _this;
    }
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../ImageCanvas.js").default} Single image.
     */
    ImageCanvasSource.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        resolution = this.findNearestResolution(resolution);
        var canvas = this.canvas_;
        if (canvas &&
            this.renderedRevision_ == this.getRevision() &&
            canvas.getResolution() == resolution &&
            canvas.getPixelRatio() == pixelRatio &&
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["containsExtent"])(canvas.getExtent(), extent)) {
            return canvas;
        }
        extent = extent.slice();
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["scaleFromCenter"])(extent, this.ratio_);
        var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getWidth"])(extent) / resolution;
        var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getHeight"])(extent) / resolution;
        var size = [width * pixelRatio, height * pixelRatio];
        var canvasElement = this.canvasFunction_.call(this, extent, resolution, pixelRatio, size, projection);
        if (canvasElement) {
            canvas = new _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_0__["default"](extent, resolution, pixelRatio, canvasElement);
        }
        this.canvas_ = canvas;
        this.renderedRevision_ = this.getRevision();
        return canvas;
    };
    return ImageCanvasSource;
}(_Image_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageCanvasSource);
//# sourceMappingURL=ImageCanvas.js.map

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/ImageCanvas
 */


/**
 * A function that is called to trigger asynchronous canvas drawing.  It is
 * called with a "done" callback that should be called when drawing is done.
 * If any error occurs during drawing, the "done" callback should be called with
 * that error.
 *
 * @typedef {function(function(Error=): void): void} Loader
 */
var ImageCanvas = /** @class */ (function (_super) {
    __extends(ImageCanvas, _super);
    /**
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {HTMLCanvasElement} canvas Canvas.
     * @param {Loader} [opt_loader] Optional loader function to
     *     support asynchronous canvas drawing.
     */
    function ImageCanvas(extent, resolution, pixelRatio, canvas, opt_loader) {
        var _this = this;
        var state = opt_loader !== undefined ? _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE : _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED;
        _this = _super.call(this, extent, resolution, pixelRatio, state) || this;
        /**
         * Optional canvas loader function.
         * @type {?Loader}
         * @private
         */
        _this.loader_ = opt_loader !== undefined ? opt_loader : null;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.canvas_ = canvas;
        /**
         * @private
         * @type {?Error}
         */
        _this.error_ = null;
        return _this;
    }
    /**
     * Get any error associated with asynchronous rendering.
     * @return {?Error} Any error that occurred during rendering.
     */
    ImageCanvas.prototype.getError = function () {
        return this.error_;
    };
    /**
     * Handle async drawing complete.
     * @param {Error} [err] Any error during drawing.
     * @private
     */
    ImageCanvas.prototype.handleLoad_ = function (err) {
        if (err) {
            this.error_ = err;
            this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR;
        }
        else {
            this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED;
        }
        this.changed();
    };
    /**
     * Load not yet loaded URI.
     */
    ImageCanvas.prototype.load = function () {
        if (this.state == _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE) {
            this.state = _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADING;
            this.changed();
            this.loader_(this.handleLoad_.bind(this));
        }
    };
    /**
     * @return {HTMLCanvasElement} Canvas element.
     */
    ImageCanvas.prototype.getImage = function () {
        return this.canvas_;
    };
    return ImageCanvas;
}(_ImageBase_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageCanvas);
//# sourceMappingURL=ImageCanvas.js.map

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(120);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/**
 * @module ol/source/ImageMapGuide
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






/**
 * @typedef {Object} Options
 * @property {string} [url] The mapagent url.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {number} [displayDpi=96] The display resolution.
 * @property {number} [metersPerUnit=1] The meters-per-unit value.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {boolean} [useOverlay] If `true`, will use `GETDYNAMICMAPOVERLAYIMAGE`.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {Object} [params] Additional parameters.
 */
/**
 * @classdesc
 * Source for images from Mapguide servers
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */
var ImageMapGuide = /** @class */ (function (_super) {
    __extends(ImageMapGuide, _super);
    /**
     * @param {Options} options ImageMapGuide options.
     */
    function ImageMapGuide(options) {
        var _this = _super.call(this, {
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            resolutions: options.resolutions,
        }) || this;
        /**
         * @private
         * @type {?string}
         */
        _this.crossOrigin_ =
            options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @private
         * @type {number}
         */
        _this.displayDpi_ =
            options.displayDpi !== undefined ? options.displayDpi : 96;
        /**
         * @private
         * @type {!Object}
         */
        _this.params_ = options.params || {};
        /**
         * @private
         * @type {string|undefined}
         */
        _this.url_ = options.url;
        /**
         * @private
         * @type {import("../Image.js").LoadFunction}
         */
        _this.imageLoadFunction_ =
            options.imageLoadFunction !== undefined
                ? options.imageLoadFunction
                : _Image_js__WEBPACK_IMPORTED_MODULE_1__["defaultImageLoadFunction"];
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
         * @private
         * @type {number}
         */
        _this.metersPerUnit_ =
            options.metersPerUnit !== undefined ? options.metersPerUnit : 1;
        /**
         * @private
         * @type {number}
         */
        _this.ratio_ = options.ratio !== undefined ? options.ratio : 1;
        /**
         * @private
         * @type {boolean}
         */
        _this.useOverlay_ =
            options.useOverlay !== undefined ? options.useOverlay : false;
        /**
         * @private
         * @type {import("../Image.js").default}
         */
        _this.image_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.renderedRevision_ = 0;
        return _this;
    }
    /**
     * Get the user-provided params, i.e. those passed to the constructor through
     * the "params" option, and possibly updated using the updateParams method.
     * @return {Object} Params.
     * @api
     */
    ImageMapGuide.prototype.getParams = function () {
        return this.params_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     */
    ImageMapGuide.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        resolution = this.findNearestResolution(resolution);
        pixelRatio = this.hidpi_ ? pixelRatio : 1;
        var image = this.image_;
        if (image &&
            this.renderedRevision_ == this.getRevision() &&
            image.getResolution() == resolution &&
            image.getPixelRatio() == pixelRatio &&
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["containsExtent"])(image.getExtent(), extent)) {
            return image;
        }
        if (this.ratio_ != 1) {
            extent = extent.slice();
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["scaleFromCenter"])(extent, this.ratio_);
        }
        var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getWidth"])(extent) / resolution;
        var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getHeight"])(extent) / resolution;
        var size = [width * pixelRatio, height * pixelRatio];
        if (this.url_ !== undefined) {
            var imageUrl = this.getUrl(this.url_, this.params_, extent, size, projection);
            image = new _Image_js__WEBPACK_IMPORTED_MODULE_2__["default"](extent, resolution, pixelRatio, imageUrl, this.crossOrigin_, this.imageLoadFunction_);
            image.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.handleImageChange.bind(this));
        }
        else {
            image = null;
        }
        this.image_ = image;
        this.renderedRevision_ = this.getRevision();
        return image;
    };
    /**
     * Return the image load function of the source.
     * @return {import("../Image.js").LoadFunction} The image load function.
     * @api
     */
    ImageMapGuide.prototype.getImageLoadFunction = function () {
        return this.imageLoadFunction_;
    };
    /**
     * Update the user-provided params.
     * @param {Object} params Params.
     * @api
     */
    ImageMapGuide.prototype.updateParams = function (params) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])(this.params_, params);
        this.changed();
    };
    /**
     * @param {string} baseUrl The mapagent url.
     * @param {Object<string, string|number>} params Request parameters.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {import("../size.js").Size} size Size.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {string} The mapagent map image request URL.
     */
    ImageMapGuide.prototype.getUrl = function (baseUrl, params, extent, size, projection) {
        var scale = getScale(extent, size, this.metersPerUnit_, this.displayDpi_);
        var center = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getCenter"])(extent);
        var baseParams = {
            'OPERATION': this.useOverlay_
                ? 'GETDYNAMICMAPOVERLAYIMAGE'
                : 'GETMAPIMAGE',
            'VERSION': '2.0.0',
            'LOCALE': 'en',
            'CLIENTAGENT': 'ol/source/ImageMapGuide source',
            'CLIP': '1',
            'SETDISPLAYDPI': this.displayDpi_,
            'SETDISPLAYWIDTH': Math.round(size[0]),
            'SETDISPLAYHEIGHT': Math.round(size[1]),
            'SETVIEWSCALE': scale,
            'SETVIEWCENTERX': center[0],
            'SETVIEWCENTERY': center[1],
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])(baseParams, params);
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_3__["appendParams"])(baseUrl, baseParams);
    };
    /**
     * Set the image load function of the MapGuide source.
     * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
     * @api
     */
    ImageMapGuide.prototype.setImageLoadFunction = function (imageLoadFunction) {
        this.image_ = null;
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    };
    return ImageMapGuide;
}(_Image_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @param {import("../extent.js").Extent} extent The map extents.
 * @param {import("../size.js").Size} size The viewport size.
 * @param {number} metersPerUnit The meters-per-unit value.
 * @param {number} dpi The display resolution.
 * @return {number} The computed map scale.
 */
function getScale(extent, size, metersPerUnit, dpi) {
    var mcsW = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getWidth"])(extent);
    var mcsH = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getHeight"])(extent);
    var devW = size[0];
    var devH = size[1];
    var mpp = 0.0254 / dpi;
    if (devH * mcsW > devW * mcsH) {
        return (mcsW * metersPerUnit) / (devW * mpp); // width limited
    }
    else {
        return (mcsH * metersPerUnit) / (devH * mpp); // height limited
    }
}
/* harmony default export */ __webpack_exports__["default"] = (ImageMapGuide);
//# sourceMappingURL=ImageMapGuide.js.map

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(117);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/**
 * @module ol/source/ImageStatic
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {import("../extent.js").Extent} [imageExtent] Extent of the image in map coordinates.
 * This is the [left, bottom, right, top] map coordinates of your image.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {import("../size.js").Size} [imageSize] Size of the image in pixels. Usually the image size is auto-detected, so this
 * only needs to be set if auto-detection fails for some reason.
 * @property {string} url Image URL.
 */
/**
 * @classdesc
 * A layer source for displaying a single, static image.
 * @api
 */
var Static = /** @class */ (function (_super) {
    __extends(Static, _super);
    /**
     * @param {Options} options ImageStatic options.
     */
    function Static(options) {
        var _this = this;
        var crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : null;
        var /** @type {import("../Image.js").LoadFunction} */ imageLoadFunction = options.imageLoadFunction !== undefined
            ? options.imageLoadFunction
            : _Image_js__WEBPACK_IMPORTED_MODULE_1__["defaultImageLoadFunction"];
        _this = _super.call(this, {
            attributions: options.attributions,
            imageSmoothing: options.imageSmoothing,
            projection: Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])(options.projection),
        }) || this;
        /**
         * @private
         * @type {string}
         */
        _this.url_ = options.url;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.imageExtent_ = options.imageExtent;
        /**
         * @private
         * @type {import("../Image.js").default}
         */
        _this.image_ = new _Image_js__WEBPACK_IMPORTED_MODULE_3__["default"](_this.imageExtent_, undefined, 1, _this.url_, crossOrigin, imageLoadFunction);
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.imageSize_ = options.imageSize ? options.imageSize : null;
        _this.image_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, _this.handleImageChange.bind(_this));
        return _this;
    }
    /**
     * Returns the image extent
     * @return {import("../extent.js").Extent} image extent.
     * @api
     */
    Static.prototype.getImageExtent = function () {
        return this.imageExtent_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     */
    Static.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(extent, this.image_.getExtent())) {
            return this.image_;
        }
        return null;
    };
    /**
     * Return the URL used for this image source.
     * @return {string} URL.
     * @api
     */
    Static.prototype.getUrl = function () {
        return this.url_;
    };
    /**
     * @param {import("../events/Event.js").default} evt Event.
     */
    Static.prototype.handleImageChange = function (evt) {
        if (this.image_.getState() == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
            var imageExtent = this.image_.getExtent();
            var image = this.image_.getImage();
            var imageWidth = void 0, imageHeight = void 0;
            if (this.imageSize_) {
                imageWidth = this.imageSize_[0];
                imageHeight = this.imageSize_[1];
            }
            else {
                imageWidth = image.width;
                imageHeight = image.height;
            }
            var extentWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(imageExtent);
            var extentHeight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getHeight"])(imageExtent);
            var xResolution = extentWidth / imageWidth;
            var yResolution = extentHeight / imageHeight;
            var targetWidth = imageWidth;
            var targetHeight = imageHeight;
            if (xResolution > yResolution) {
                targetWidth = Math.round(extentWidth / yResolution);
            }
            else {
                targetHeight = Math.round(extentHeight / xResolution);
            }
            if (targetWidth !== imageWidth || targetHeight !== imageHeight) {
                var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["createCanvasContext2D"])(targetWidth, targetHeight);
                Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])(context, this.getContextOptions());
                var canvas = context.canvas;
                context.drawImage(image, 0, 0, imageWidth, imageHeight, 0, 0, canvas.width, canvas.height);
                this.image_.setImage(canvas);
            }
        }
        _super.prototype.handleImageChange.call(this, evt);
    };
    return Static;
}(_Image_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Static);
//# sourceMappingURL=ImageStatic.js.map

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(117);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62);
/* harmony import */ var _WMSServerType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(126);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(120);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15);
/* harmony import */ var _reproj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7);
/**
 * @module ol/source/ImageWMS
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












/**
 * @const
 * @type {import("../size.js").Size}
 */
var GETFEATUREINFO_IMAGE_SIZE = [101, 101];
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("./WMSServerType.js").default|string} [serverType] The type of
 * the remote WMS server: `mapserver`, `geoserver` or `qgis`. Only needed if `hidpi` is `true`.
 * @property {import("../Image.js").LoadFunction} [imageLoadFunction] Optional function to load an image given a URL.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [ratio=1.5] Ratio. `1` means image requests are the size of the map viewport, `2` means
 * twice the width and height of the map viewport, and so on. Must be `1` or
 * higher.
 * @property {Array<number>} [resolutions] Resolutions.
 * If specified, requests will be made for these resolutions only.
 * @property {string} url WMS service URL.
 */
/**
 * @classdesc
 * Source for WMS servers providing single, untiled images.
 *
 * @fires module:ol/source/Image.ImageSourceEvent
 * @api
 */
var ImageWMS = /** @class */ (function (_super) {
    __extends(ImageWMS, _super);
    /**
     * @param {Options} [opt_options] ImageWMS options.
     */
    function ImageWMS(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            attributions: options.attributions,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            resolutions: options.resolutions,
        }) || this;
        /**
         * @private
         * @type {?string}
         */
        _this.crossOrigin_ =
            options.crossOrigin !== undefined ? options.crossOrigin : null;
        /**
         * @private
         * @type {string|undefined}
         */
        _this.url_ = options.url;
        /**
         * @private
         * @type {import("../Image.js").LoadFunction}
         */
        _this.imageLoadFunction_ =
            options.imageLoadFunction !== undefined
                ? options.imageLoadFunction
                : _Image_js__WEBPACK_IMPORTED_MODULE_2__["defaultImageLoadFunction"];
        /**
         * @private
         * @type {!Object}
         */
        _this.params_ = options.params || {};
        /**
         * @private
         * @type {boolean}
         */
        _this.v13_ = true;
        _this.updateV13_();
        /**
         * @private
         * @type {import("./WMSServerType.js").default|undefined}
         */
        _this.serverType_ =
            /** @type {import("./WMSServerType.js").default|undefined} */ (options.serverType);
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
         * @private
         * @type {import("../Image.js").default}
         */
        _this.image_ = null;
        /**
         * @private
         * @type {import("../size.js").Size}
         */
        _this.imageSize_ = [0, 0];
        /**
         * @private
         * @type {number}
         */
        _this.renderedRevision_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.ratio_ = options.ratio !== undefined ? options.ratio : 1.5;
        return _this;
    }
    /**
     * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
     * projection. Return `undefined` if the GetFeatureInfo URL cannot be
     * constructed.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {import("../proj.js").ProjectionLike} projection Projection.
     * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
     *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
     *     in the `LAYERS` parameter will be used. `VERSION` should not be
     *     specified here.
     * @return {string|undefined} GetFeatureInfo URL.
     * @api
     */
    ImageWMS.prototype.getFeatureInfoUrl = function (coordinate, resolution, projection, params) {
        if (this.url_ === undefined) {
            return undefined;
        }
        var projectionObj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["get"])(projection);
        var sourceProjectionObj = this.getProjection();
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            resolution = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_8__["calculateSourceResolution"])(sourceProjectionObj, projectionObj, coordinate, resolution);
            coordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["transform"])(coordinate, projectionObj, sourceProjectionObj);
        }
        var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getForViewAndSize"])(coordinate, resolution, 0, GETFEATUREINFO_IMAGE_SIZE);
        var baseParams = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetFeatureInfo',
            'FORMAT': 'image/png',
            'TRANSPARENT': true,
            'QUERY_LAYERS': this.params_['LAYERS'],
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["assign"])(baseParams, this.params_, params);
        var x = Math.floor((coordinate[0] - extent[0]) / resolution);
        var y = Math.floor((extent[3] - coordinate[1]) / resolution);
        baseParams[this.v13_ ? 'I' : 'X'] = x;
        baseParams[this.v13_ ? 'J' : 'Y'] = y;
        return this.getRequestUrl_(extent, GETFEATUREINFO_IMAGE_SIZE, 1, sourceProjectionObj || projectionObj, baseParams);
    };
    /**
     * Return the GetLegendGraphic URL, optionally optimized for the passed
     * resolution and possibly including any passed specific parameters. Returns
     * `undefined` if the GetLegendGraphic URL cannot be constructed.
     *
     * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
     *     will not be calculated and included in URL.
     * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
     *     request is generated for this wms layer, else it will try to use the
     *     configured wms layer. Default `FORMAT` is `image/png`.
     *     `VERSION` should not be specified here.
     * @return {string|undefined} GetLegendGraphic URL.
     * @api
     */
    ImageWMS.prototype.getLegendUrl = function (resolution, params) {
        if (this.url_ === undefined) {
            return undefined;
        }
        var baseParams = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetLegendGraphic',
            'FORMAT': 'image/png',
        };
        if (params === undefined || params['LAYER'] === undefined) {
            var layers = this.params_.LAYERS;
            var isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) {
                return undefined;
            }
            baseParams['LAYER'] = layers;
        }
        if (resolution !== undefined) {
            var mpu = this.getProjection()
                ? this.getProjection().getMetersPerUnit()
                : 1;
            var pixelSize = 0.00028;
            baseParams['SCALE'] = (resolution * mpu) / pixelSize;
        }
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["assign"])(baseParams, params);
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_5__["appendParams"])(/** @type {string} */ (this.url_), baseParams);
    };
    /**
     * Get the user-provided params, i.e. those passed to the constructor through
     * the "params" option, and possibly updated using the updateParams method.
     * @return {Object} Params.
     * @api
     */
    ImageWMS.prototype.getParams = function () {
        return this.params_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../Image.js").default} Single image.
     */
    ImageWMS.prototype.getImageInternal = function (extent, resolution, pixelRatio, projection) {
        if (this.url_ === undefined) {
            return null;
        }
        resolution = this.findNearestResolution(resolution);
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) {
            pixelRatio = 1;
        }
        var imageResolution = resolution / pixelRatio;
        var center = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getCenter"])(extent);
        var viewWidth = Math.ceil(Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getWidth"])(extent) / imageResolution);
        var viewHeight = Math.ceil(Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getHeight"])(extent) / imageResolution);
        var viewExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getForViewAndSize"])(center, imageResolution, 0, [
            viewWidth,
            viewHeight,
        ]);
        var requestWidth = Math.ceil((this.ratio_ * Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getWidth"])(extent)) / imageResolution);
        var requestHeight = Math.ceil((this.ratio_ * Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getHeight"])(extent)) / imageResolution);
        var requestExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getForViewAndSize"])(center, imageResolution, 0, [
            requestWidth,
            requestHeight,
        ]);
        var image = this.image_;
        if (image &&
            this.renderedRevision_ == this.getRevision() &&
            image.getResolution() == resolution &&
            image.getPixelRatio() == pixelRatio &&
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["containsExtent"])(image.getExtent(), viewExtent)) {
            return image;
        }
        var params = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetMap',
            'FORMAT': 'image/png',
            'TRANSPARENT': true,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["assign"])(params, this.params_);
        this.imageSize_[0] = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getWidth"])(requestExtent) / imageResolution);
        this.imageSize_[1] = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getHeight"])(requestExtent) / imageResolution);
        var url = this.getRequestUrl_(requestExtent, this.imageSize_, pixelRatio, projection, params);
        this.image_ = new _Image_js__WEBPACK_IMPORTED_MODULE_3__["default"](requestExtent, resolution, pixelRatio, url, this.crossOrigin_, this.imageLoadFunction_);
        this.renderedRevision_ = this.getRevision();
        this.image_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, this.handleImageChange.bind(this));
        return this.image_;
    };
    /**
     * Return the image load function of the source.
     * @return {import("../Image.js").LoadFunction} The image load function.
     * @api
     */
    ImageWMS.prototype.getImageLoadFunction = function () {
        return this.imageLoadFunction_;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {import("../size.js").Size} size Size.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {Object} params Params.
     * @return {string} Request URL.
     * @private
     */
    ImageWMS.prototype.getRequestUrl_ = function (extent, size, pixelRatio, projection, params) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(this.url_ !== undefined, 9); // `url` must be configured or set using `#setUrl()`
        params[this.v13_ ? 'CRS' : 'SRS'] = projection.getCode();
        if (!('STYLES' in this.params_)) {
            params['STYLES'] = '';
        }
        if (pixelRatio != 1) {
            switch (this.serverType_) {
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOSERVER:
                    var dpi = (90 * pixelRatio + 0.5) | 0;
                    if ('FORMAT_OPTIONS' in params) {
                        params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
                    }
                    else {
                        params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
                    }
                    break;
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MAPSERVER:
                    params['MAP_RESOLUTION'] = 90 * pixelRatio;
                    break;
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_4__["default"].CARMENTA_SERVER:
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_4__["default"].QGIS:
                    params['DPI'] = 90 * pixelRatio;
                    break;
                default:
                    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(false, 8); // Unknown `serverType` configured
                    break;
            }
        }
        params['WIDTH'] = size[0];
        params['HEIGHT'] = size[1];
        var axisOrientation = projection.getAxisOrientation();
        var bbox;
        if (this.v13_ && axisOrientation.substr(0, 2) == 'ne') {
            bbox = [extent[1], extent[0], extent[3], extent[2]];
        }
        else {
            bbox = extent;
        }
        params['BBOX'] = bbox.join(',');
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_5__["appendParams"])(/** @type {string} */ (this.url_), params);
    };
    /**
     * Return the URL used for this WMS source.
     * @return {string|undefined} URL.
     * @api
     */
    ImageWMS.prototype.getUrl = function () {
        return this.url_;
    };
    /**
     * Set the image load function of the source.
     * @param {import("../Image.js").LoadFunction} imageLoadFunction Image load function.
     * @api
     */
    ImageWMS.prototype.setImageLoadFunction = function (imageLoadFunction) {
        this.image_ = null;
        this.imageLoadFunction_ = imageLoadFunction;
        this.changed();
    };
    /**
     * Set the URL to use for requests.
     * @param {string|undefined} url URL.
     * @api
     */
    ImageWMS.prototype.setUrl = function (url) {
        if (url != this.url_) {
            this.url_ = url;
            this.image_ = null;
            this.changed();
        }
    };
    /**
     * Update the user-provided params.
     * @param {Object} params Params.
     * @api
     */
    ImageWMS.prototype.updateParams = function (params) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["assign"])(this.params_, params);
        this.updateV13_();
        this.image_ = null;
        this.changed();
    };
    /**
     * @private
     */
    ImageWMS.prototype.updateV13_ = function () {
        var version = this.params_['VERSION'] || _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"];
        this.v13_ = Object(_string_js__WEBPACK_IMPORTED_MODULE_9__["compareVersions"])(version, '1.3') >= 0;
    };
    return ImageWMS;
}(_Image_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageWMS);
//# sourceMappingURL=ImageWMS.js.map

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/source/WMSServerType
 */
/**
 * Available server types: `'carmentaserver'`, `'geoserver'`, `'mapserver'`,
 *     `'qgis'`. These are servers that have vendor parameters beyond the WMS
 *     specification that OpenLayers can make use of.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * HiDPI support for [Carmenta Server](https://www.carmenta.com/en/products/carmenta-server)
     * @api
     */
    CARMENTA_SERVER: 'carmentaserver',
    /**
     * HiDPI support for [GeoServer](https://geoserver.org/)
     * @api
     */
    GEOSERVER: 'geoserver',
    /**
     * HiDPI support for [MapServer](https://mapserver.org/)
     * @api
     */
    MAPSERVER: 'mapserver',
    /**
     * HiDPI support for [QGIS](https://qgis.org/)
     * @api
     */
    QGIS: 'qgis',
});
//# sourceMappingURL=WMSServerType.js.map

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ATTRIBUTION", function() { return ATTRIBUTION; });
/* harmony import */ var _XYZ_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95);
/**
 * @module ol/source/OSM
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * The attribution containing a link to the OpenStreetMap Copyright and License
 * page.
 * @const
 * @type {string}
 * @api
 */
var ATTRIBUTION = '&#169; ' +
    '<a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a> ' +
    'contributors.';
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {number} [maxZoom=19] Max zoom.
 * @property {boolean} [opaque=true] Whether the layer is opaque.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url='https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png'] URL template.
 * Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for the OpenStreetMap tile server.
 * @api
 */
var OSM = /** @class */ (function (_super) {
    __extends(OSM, _super);
    /**
     * @param {Options} [opt_options] Open Street Map options.
     */
    function OSM(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var attributions;
        if (options.attributions !== undefined) {
            attributions = options.attributions;
        }
        else {
            attributions = [ATTRIBUTION];
        }
        var crossOrigin = options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        var url = options.url !== undefined
            ? options.url
            : 'https://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png';
        _this = _super.call(this, {
            attributions: attributions,
            attributionsCollapsible: false,
            cacheSize: options.cacheSize,
            crossOrigin: crossOrigin,
            imageSmoothing: options.imageSmoothing,
            maxZoom: options.maxZoom !== undefined ? options.maxZoom : 19,
            opaque: options.opaque !== undefined ? options.opaque : true,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection,
        }) || this;
        return _this;
    }
    return OSM;
}(_XYZ_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (OSM);
//# sourceMappingURL=OSM.js.map

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "newImageData", function() { return newImageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Processor", function() { return Processor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RasterSourceEvent", function() { return RasterSourceEvent; });
/* harmony import */ var _Disposable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53);
/* harmony import */ var _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(122);
/* harmony import */ var _layer_Image_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(129);
/* harmony import */ var _Image_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(117);
/* harmony import */ var _Source_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70);
/* harmony import */ var _layer_Tile_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(140);
/* harmony import */ var _TileQueue_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(144);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/source/Raster
 */















var hasImageData = true;
try {
    new ImageData(10, 10);
}
catch (_) {
    hasImageData = false;
}
var context = document.createElement('canvas').getContext('2d');
/**
 * @param {Uint8ClampedArray} data Image data.
 * @param {number} width Number of columns.
 * @param {number} height Number of rows.
 * @return {ImageData} Image data.
 */
function newImageData(data, width, height) {
    if (hasImageData) {
        return new ImageData(data, width, height);
    }
    else {
        var imageData = context.createImageData(width, height);
        imageData.data.set(data);
        return imageData;
    }
}
/* istanbul ignore next */
/**
 * Create a function for running operations.  This function is serialized for
 * use in a worker.
 * @param {function(Array, Object):*} operation The operation.
 * @return {function(Object):ArrayBuffer} A function that takes an object with
 * buffers, meta, imageOps, width, and height properties and returns an array
 * buffer.
 */
function createMinion(operation) {
    var workerHasImageData = true;
    try {
        new ImageData(10, 10);
    }
    catch (_) {
        workerHasImageData = false;
    }
    function newWorkerImageData(data, width, height) {
        if (workerHasImageData) {
            return new ImageData(data, width, height);
        }
        else {
            return { data: data, width: width, height: height };
        }
    }
    return function (data) {
        // bracket notation for minification support
        var buffers = data['buffers'];
        var meta = data['meta'];
        var imageOps = data['imageOps'];
        var width = data['width'];
        var height = data['height'];
        var numBuffers = buffers.length;
        var numBytes = buffers[0].byteLength;
        var output, b;
        if (imageOps) {
            var images = new Array(numBuffers);
            for (b = 0; b < numBuffers; ++b) {
                images[b] = newWorkerImageData(new Uint8ClampedArray(buffers[b]), width, height);
            }
            output = operation(images, meta).data;
        }
        else {
            output = new Uint8ClampedArray(numBytes);
            var arrays = new Array(numBuffers);
            var pixels = new Array(numBuffers);
            for (b = 0; b < numBuffers; ++b) {
                arrays[b] = new Uint8ClampedArray(buffers[b]);
                pixels[b] = [0, 0, 0, 0];
            }
            for (var i = 0; i < numBytes; i += 4) {
                for (var j = 0; j < numBuffers; ++j) {
                    var array = arrays[j];
                    pixels[j][0] = array[i];
                    pixels[j][1] = array[i + 1];
                    pixels[j][2] = array[i + 2];
                    pixels[j][3] = array[i + 3];
                }
                var pixel = operation(pixels, meta);
                output[i] = pixel[0];
                output[i + 1] = pixel[1];
                output[i + 2] = pixel[2];
                output[i + 3] = pixel[3];
            }
        }
        return output.buffer;
    };
}
/**
 * Create a worker for running operations.
 * @param {Object} config Configuration.
 * @param {function(MessageEvent): void} onMessage Called with a message event.
 * @return {Worker} The worker.
 */
function createWorker(config, onMessage) {
    var lib = Object.keys(config.lib || {}).map(function (name) {
        return 'var ' + name + ' = ' + config.lib[name].toString() + ';';
    });
    var lines = lib.concat([
        'var __minion__ = (' + createMinion.toString() + ')(',
        config.operation.toString(),
        ');',
        'self.addEventListener("message", function(event) {',
        '  var buffer = __minion__(event.data);',
        '  self.postMessage({buffer: buffer, meta: event.data.meta}, [buffer]);',
        '});',
    ]);
    var blob = new Blob(lines, { type: 'text/javascript' });
    var source = URL.createObjectURL(blob);
    var worker = new Worker(source);
    worker.addEventListener('message', onMessage);
    return worker;
}
/**
 * @typedef {Object} FauxMessageEvent
 * @property {Object} data Message data.
 */
/**
 * Create a faux worker for running operations.
 * @param {ProcessorOptions} config Configuration.
 * @param {function(FauxMessageEvent): void} onMessage Called with a message event.
 * @return {Object} The faux worker.
 */
function createFauxWorker(config, onMessage) {
    var minion = createMinion(config.operation);
    var terminated = false;
    return {
        postMessage: function (data) {
            setTimeout(function () {
                if (terminated) {
                    return;
                }
                onMessage({ data: { buffer: minion(data), meta: data['meta'] } });
            }, 0);
        },
        terminate: function () {
            terminated = true;
        },
    };
}
/**
 * @typedef {Object} ProcessorOptions
 * @property {number} threads Number of workers to spawn.
 * @property {function(Array, Object):*} operation The operation.
 * @property {Object} [lib] Functions that will be made available to operations run in a worker.
 * @property {number} queue The number of queued jobs to allow.
 * @property {boolean} [imageOps=false] Pass all the image data to the operation instead of a single pixel.
 */
/**
 * @classdesc
 * A processor runs pixel or image operations in workers.
 */
var Processor = /** @class */ (function (_super) {
    __extends(Processor, _super);
    /**
     * @param {ProcessorOptions} config Configuration.
     */
    function Processor(config) {
        var _this = _super.call(this) || this;
        _this._imageOps = !!config.imageOps;
        var threads;
        if (config.threads === 0) {
            threads = 0;
        }
        else if (_this._imageOps) {
            threads = 1;
        }
        else {
            threads = config.threads || 1;
        }
        var workers = [];
        if (threads) {
            for (var i = 0; i < threads; ++i) {
                workers[i] = createWorker(config, _this._onWorkerMessage.bind(_this, i));
            }
        }
        else {
            workers[0] = createFauxWorker(config, _this._onWorkerMessage.bind(_this, 0));
        }
        _this._workers = workers;
        _this._queue = [];
        _this._maxQueueLength = config.queue || Infinity;
        _this._running = 0;
        _this._dataLookup = {};
        _this._job = null;
        return _this;
    }
    /**
     * Run operation on input data.
     * @param {Array<Array|ImageData>} inputs Array of pixels or image data
     *     (depending on the operation type).
     * @param {Object} meta A user data object.  This is passed to all operations
     *     and must be serializable.
     * @param {function(Error, ImageData, Object): void} callback Called when work
     *     completes.  The first argument is any error.  The second is the ImageData
     *     generated by operations.  The third is the user data object.
     */
    Processor.prototype.process = function (inputs, meta, callback) {
        this._enqueue({
            inputs: inputs,
            meta: meta,
            callback: callback,
        });
        this._dispatch();
    };
    /**
     * Add a job to the queue.
     * @param {Object} job The job.
     */
    Processor.prototype._enqueue = function (job) {
        this._queue.push(job);
        while (this._queue.length > this._maxQueueLength) {
            this._queue.shift().callback(null, null);
        }
    };
    /**
     * Dispatch a job.
     */
    Processor.prototype._dispatch = function () {
        if (this._running === 0 && this._queue.length > 0) {
            var job = this._queue.shift();
            this._job = job;
            var width = job.inputs[0].width;
            var height = job.inputs[0].height;
            var buffers = job.inputs.map(function (input) {
                return input.data.buffer;
            });
            var threads = this._workers.length;
            this._running = threads;
            if (threads === 1) {
                this._workers[0].postMessage({
                    buffers: buffers,
                    meta: job.meta,
                    imageOps: this._imageOps,
                    width: width,
                    height: height,
                }, buffers);
            }
            else {
                var length_1 = job.inputs[0].data.length;
                var segmentLength = 4 * Math.ceil(length_1 / 4 / threads);
                for (var i = 0; i < threads; ++i) {
                    var offset = i * segmentLength;
                    var slices = [];
                    for (var j = 0, jj = buffers.length; j < jj; ++j) {
                        slices.push(buffers[j].slice(offset, offset + segmentLength));
                    }
                    this._workers[i].postMessage({
                        buffers: slices,
                        meta: job.meta,
                        imageOps: this._imageOps,
                        width: width,
                        height: height,
                    }, slices);
                }
            }
        }
    };
    /**
     * Handle messages from the worker.
     * @param {number} index The worker index.
     * @param {MessageEvent} event The message event.
     */
    Processor.prototype._onWorkerMessage = function (index, event) {
        if (this.disposed) {
            return;
        }
        this._dataLookup[index] = event.data;
        --this._running;
        if (this._running === 0) {
            this._resolveJob();
        }
    };
    /**
     * Resolve a job.  If there are no more worker threads, the processor callback
     * will be called.
     */
    Processor.prototype._resolveJob = function () {
        var job = this._job;
        var threads = this._workers.length;
        var data, meta;
        if (threads === 1) {
            data = new Uint8ClampedArray(this._dataLookup[0]['buffer']);
            meta = this._dataLookup[0]['meta'];
        }
        else {
            var length_2 = job.inputs[0].data.length;
            data = new Uint8ClampedArray(length_2);
            meta = new Array(length_2);
            var segmentLength = 4 * Math.ceil(length_2 / 4 / threads);
            for (var i = 0; i < threads; ++i) {
                var buffer = this._dataLookup[i]['buffer'];
                var offset = i * segmentLength;
                data.set(new Uint8ClampedArray(buffer), offset);
                meta[i] = this._dataLookup[i]['meta'];
            }
        }
        this._job = null;
        this._dataLookup = {};
        job.callback(null, newImageData(data, job.inputs[0].width, job.inputs[0].height), meta);
        this._dispatch();
    };
    /**
     * Terminate all workers associated with the processor.
     */
    Processor.prototype.disposeInternal = function () {
        for (var i = 0; i < this._workers.length; ++i) {
            this._workers[i].terminate();
        }
        this._workers.length = 0;
    };
    return Processor;
}(_Disposable_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/**
 * A function that takes an array of input data, performs some operation, and
 * returns an array of output data.
 * For `pixel` type operations, the function will be called with an array of
 * pixels, where each pixel is an array of four numbers (`[r, g, b, a]`) in the
 * range of 0 - 255. It should return a single pixel array.
 * For `'image'` type operations, functions will be called with an array of
 * [ImageData](https://developer.mozilla.org/en-US/docs/Web/API/ImageData)
 * and should return a single
 * [ImageData](https://developer.mozilla.org/en-US/docs/Web/API/ImageData).
 * The operations
 * are called with a second "data" argument, which can be used for storage.  The
 * data object is accessible from raster events, where it can be initialized in
 * "beforeoperations" and accessed again in "afteroperations".
 *
 * @typedef {function((Array<Array<number>>|Array<ImageData>), Object):
 *     (Array<number>|ImageData)} Operation
 */
/**
 * @enum {string}
 */
var RasterEventType = {
    /**
     * Triggered before operations are run.
     * @event module:ol/source/Raster.RasterSourceEvent#beforeoperations
     * @api
     */
    BEFOREOPERATIONS: 'beforeoperations',
    /**
     * Triggered after operations are run.
     * @event module:ol/source/Raster.RasterSourceEvent#afteroperations
     * @api
     */
    AFTEROPERATIONS: 'afteroperations',
};
/**
 * Raster operation type. Supported values are `'pixel'` and `'image'`.
 * @enum {string}
 */
var RasterOperationType = {
    PIXEL: 'pixel',
    IMAGE: 'image',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/source/Raster} instances are instances of this
 * type.
 */
var RasterSourceEvent = /** @class */ (function (_super) {
    __extends(RasterSourceEvent, _super);
    /**
     * @param {string} type Type.
     * @param {import("../PluggableMap.js").FrameState} frameState The frame state.
     * @param {Object} data An object made available to operations.
     */
    function RasterSourceEvent(type, frameState, data) {
        var _this = _super.call(this, type) || this;
        /**
         * The raster extent.
         * @type {import("../extent.js").Extent}
         * @api
         */
        _this.extent = frameState.extent;
        /**
         * The pixel resolution (map units per pixel).
         * @type {number}
         * @api
         */
        _this.resolution = frameState.viewState.resolution / frameState.pixelRatio;
        /**
         * An object made available to all operations.  This can be used by operations
         * as a storage object (e.g. for calculating statistics).
         * @type {Object}
         * @api
         */
        _this.data = data;
        return _this;
    }
    return RasterSourceEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_1__["default"]));

/**
 * @typedef {Object} Options
 * @property {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources Input
 * sources or layers.  For vector data, use an VectorImage layer.
 * @property {Operation} [operation] Raster operation.
 * The operation will be called with data from input sources
 * and the output will be assigned to the raster source.
 * @property {Object} [lib] Functions that will be made available to operations run in a worker.
 * @property {number} [threads] By default, operations will be run in a single worker thread.
 * To avoid using workers altogether, set `threads: 0`.  For pixel operations, operations can
 * be run in multiple worker threads.  Note that there is additional overhead in
 * transferring data to multiple workers, and that depending on the user's
 * system, it may not be possible to parallelize the work.
 * @property {RasterOperationType} [operationType='pixel'] Operation type.
 * Supported values are `'pixel'` and `'image'`.  By default,
 * `'pixel'` operations are assumed, and operations will be called with an
 * array of pixels from input sources.  If set to `'image'`, operations will
 * be called with an array of ImageData objects from input sources.
 */
/**
 * @classdesc
 * A source that transforms data from any number of input sources using an
 * {@link module:ol/source/Raster~Operation} function to transform input pixel values into
 * output pixel values.
 *
 * @fires module:ol/source/Raster.RasterSourceEvent
 * @api
 */
var RasterSource = /** @class */ (function (_super) {
    __extends(RasterSource, _super);
    /**
     * @param {Options} options Options.
     */
    function RasterSource(options) {
        var _this = _super.call(this, {
            projection: null,
        }) || this;
        /**
         * @private
         * @type {Processor}
         */
        _this.processor_ = null;
        /**
         * @private
         * @type {RasterOperationType}
         */
        _this.operationType_ =
            options.operationType !== undefined
                ? options.operationType
                : RasterOperationType.PIXEL;
        /**
         * @private
         * @type {number}
         */
        _this.threads_ = options.threads !== undefined ? options.threads : 1;
        /**
         * @private
         * @type {Array<import("../layer/Layer.js").default>}
         */
        _this.layers_ = createLayers(options.sources);
        var changed = _this.changed.bind(_this);
        for (var i = 0, ii = _this.layers_.length; i < ii; ++i) {
            _this.layers_[i].addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CHANGE, changed);
        }
        /**
         * @private
         * @type {import("../TileQueue.js").default}
         */
        _this.tileQueue_ = new _TileQueue_js__WEBPACK_IMPORTED_MODULE_9__["default"](function () {
            return 1;
        }, _this.changed.bind(_this));
        /**
         * The most recently requested frame state.
         * @type {import("../PluggableMap.js").FrameState}
         * @private
         */
        _this.requestedFrameState_;
        /**
         * The most recently rendered image canvas.
         * @type {import("../ImageCanvas.js").default}
         * @private
         */
        _this.renderedImageCanvas_ = null;
        /**
         * The most recently rendered revision.
         * @type {number}
         */
        _this.renderedRevision_;
        /**
         * @private
         * @type {import("../PluggableMap.js").FrameState}
         */
        _this.frameState_ = {
            animate: false,
            coordinateToPixelTransform: Object(_transform_js__WEBPACK_IMPORTED_MODULE_13__["create"])(),
            declutterTree: null,
            extent: null,
            index: 0,
            layerIndex: 0,
            layerStatesArray: getLayerStatesArray(_this.layers_),
            pixelRatio: 1,
            pixelToCoordinateTransform: Object(_transform_js__WEBPACK_IMPORTED_MODULE_13__["create"])(),
            postRenderFunctions: [],
            size: [0, 0],
            tileQueue: _this.tileQueue_,
            time: Date.now(),
            usedTiles: {},
            viewState: /** @type {import("../View.js").State} */ ({
                rotation: 0,
            }),
            viewHints: [],
            wantedTiles: {},
        };
        _this.setAttributions(function (frameState) {
            var attributions = [];
            for (var index = 0, iMax = options.sources.length; index < iMax; ++index) {
                var sourceOrLayer = options.sources[index];
                var source = sourceOrLayer instanceof _Source_js__WEBPACK_IMPORTED_MODULE_6__["default"]
                    ? sourceOrLayer
                    : sourceOrLayer.getSource();
                var attributionGetter = source.getAttributions();
                if (typeof attributionGetter === 'function') {
                    var sourceAttribution = attributionGetter(frameState);
                    attributions.push.apply(attributions, sourceAttribution);
                }
            }
            return attributions.length !== 0 ? attributions : null;
        });
        if (options.operation !== undefined) {
            _this.setOperation(options.operation, options.lib);
        }
        return _this;
    }
    /**
     * Set the operation.
     * @param {Operation} operation New operation.
     * @param {Object} [opt_lib] Functions that will be available to operations run
     *     in a worker.
     * @api
     */
    RasterSource.prototype.setOperation = function (operation, opt_lib) {
        if (this.processor_) {
            this.processor_.dispose();
        }
        this.processor_ = new Processor({
            operation: operation,
            imageOps: this.operationType_ === RasterOperationType.IMAGE,
            queue: 1,
            lib: opt_lib,
            threads: this.threads_,
        });
        this.changed();
    };
    /**
     * Update the stored frame state.
     * @param {import("../extent.js").Extent} extent The view extent (in map units).
     * @param {number} resolution The view resolution.
     * @param {import("../proj/Projection.js").default} projection The view projection.
     * @return {import("../PluggableMap.js").FrameState} The updated frame state.
     * @private
     */
    RasterSource.prototype.updateFrameState_ = function (extent, resolution, projection) {
        var frameState = /** @type {import("../PluggableMap.js").FrameState} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_11__["assign"])({}, this.frameState_));
        frameState.viewState = /** @type {import("../View.js").State} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_11__["assign"])({}, frameState.viewState));
        var center = Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["getCenter"])(extent);
        frameState.extent = extent.slice();
        frameState.size[0] = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["getWidth"])(extent) / resolution);
        frameState.size[1] = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["getHeight"])(extent) / resolution);
        frameState.time = Infinity;
        var viewState = frameState.viewState;
        viewState.center = center;
        viewState.projection = projection;
        viewState.resolution = resolution;
        return frameState;
    };
    /**
     * Determine if all sources are ready.
     * @return {boolean} All sources are ready.
     * @private
     */
    RasterSource.prototype.allSourcesReady_ = function () {
        var ready = true;
        var source;
        for (var i = 0, ii = this.layers_.length; i < ii; ++i) {
            source = this.layers_[i].getSource();
            if (source.getState() !== _State_js__WEBPACK_IMPORTED_MODULE_7__["default"].READY) {
                ready = false;
                break;
            }
        }
        return ready;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../ImageCanvas.js").default} Single image.
     */
    RasterSource.prototype.getImage = function (extent, resolution, pixelRatio, projection) {
        if (!this.allSourcesReady_()) {
            return null;
        }
        var frameState = this.updateFrameState_(extent, resolution, projection);
        this.requestedFrameState_ = frameState;
        // check if we can't reuse the existing ol/ImageCanvas
        if (this.renderedImageCanvas_) {
            var renderedResolution = this.renderedImageCanvas_.getResolution();
            var renderedExtent = this.renderedImageCanvas_.getExtent();
            if (resolution !== renderedResolution ||
                !Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["equals"])(extent, renderedExtent)) {
                this.renderedImageCanvas_ = null;
            }
        }
        if (!this.renderedImageCanvas_ ||
            this.getRevision() !== this.renderedRevision_) {
            this.processSources_();
        }
        frameState.tileQueue.loadMoreTiles(16, 16);
        if (frameState.animate) {
            requestAnimationFrame(this.changed.bind(this));
        }
        return this.renderedImageCanvas_;
    };
    /**
     * Start processing source data.
     * @private
     */
    RasterSource.prototype.processSources_ = function () {
        var frameState = this.requestedFrameState_;
        var len = this.layers_.length;
        var imageDatas = new Array(len);
        for (var i = 0; i < len; ++i) {
            frameState.layerIndex = i;
            var imageData = getImageData(this.layers_[i], frameState);
            if (imageData) {
                imageDatas[i] = imageData;
            }
            else {
                return;
            }
        }
        var data = {};
        this.dispatchEvent(new RasterSourceEvent(RasterEventType.BEFOREOPERATIONS, frameState, data));
        this.processor_.process(imageDatas, data, this.onWorkerComplete_.bind(this, frameState));
    };
    /**
     * Called when pixel processing is complete.
     * @param {import("../PluggableMap.js").FrameState} frameState The frame state.
     * @param {Error} err Any error during processing.
     * @param {ImageData} output The output image data.
     * @param {Object} data The user data.
     * @private
     */
    RasterSource.prototype.onWorkerComplete_ = function (frameState, err, output, data) {
        if (err || !output) {
            return;
        }
        // do nothing if extent or resolution changed
        var extent = frameState.extent;
        var resolution = frameState.viewState.resolution;
        if (resolution !== this.requestedFrameState_.viewState.resolution ||
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["equals"])(extent, this.requestedFrameState_.extent)) {
            return;
        }
        var context;
        if (this.renderedImageCanvas_) {
            context = this.renderedImageCanvas_.getImage().getContext('2d');
        }
        else {
            var width = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["getWidth"])(extent) / resolution);
            var height = Math.round(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["getHeight"])(extent) / resolution);
            context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_12__["createCanvasContext2D"])(width, height);
            this.renderedImageCanvas_ = new _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_3__["default"](extent, resolution, 1, context.canvas);
        }
        context.putImageData(output, 0, 0);
        this.changed();
        this.renderedRevision_ = this.getRevision();
        this.dispatchEvent(new RasterSourceEvent(RasterEventType.AFTEROPERATIONS, frameState, data));
    };
    /**
     * @return {null} not implemented
     */
    RasterSource.prototype.getImageInternal = function () {
        return null; // not implemented
    };
    RasterSource.prototype.disposeInternal = function () {
        if (this.processor_) {
            this.processor_.dispose();
        }
        _super.prototype.disposeInternal.call(this);
    };
    return RasterSource;
}(_Image_js__WEBPACK_IMPORTED_MODULE_5__["default"]));
/**
 * Clean up and unregister the worker.
 * @function
 * @api
 */
RasterSource.prototype.dispose;
/**
 * A reusable canvas context.
 * @type {CanvasRenderingContext2D}
 * @private
 */
var sharedContext = null;
/**
 * Get image data from a layer.
 * @param {import("../layer/Layer.js").default} layer Layer to render.
 * @param {import("../PluggableMap.js").FrameState} frameState The frame state.
 * @return {ImageData} The image data.
 */
function getImageData(layer, frameState) {
    var renderer = layer.getRenderer();
    if (!renderer) {
        throw new Error('Unsupported layer type: ' + layer);
    }
    if (!renderer.prepareFrame(frameState)) {
        return null;
    }
    var width = frameState.size[0];
    var height = frameState.size[1];
    if (width === 0 || height === 0) {
        return null;
    }
    var container = renderer.renderFrame(frameState, null);
    var element;
    if (container) {
        element = container.firstElementChild;
    }
    if (!(element instanceof HTMLCanvasElement)) {
        throw new Error('Unsupported rendered element: ' + element);
    }
    if (element.width === width && element.height === height) {
        var context_1 = element.getContext('2d');
        return context_1.getImageData(0, 0, width, height);
    }
    if (!sharedContext) {
        sharedContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_12__["createCanvasContext2D"])(width, height);
    }
    else {
        var canvas = sharedContext.canvas;
        if (canvas.width !== width || canvas.height !== height) {
            sharedContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_12__["createCanvasContext2D"])(width, height);
        }
        else {
            sharedContext.clearRect(0, 0, width, height);
        }
    }
    sharedContext.drawImage(element, 0, 0, width, height);
    return sharedContext.getImageData(0, 0, width, height);
}
/**
 * Get a list of layer states from a list of layers.
 * @param {Array<import("../layer/Layer.js").default>} layers Layers.
 * @return {Array<import("../layer/Layer.js").State>} The layer states.
 */
function getLayerStatesArray(layers) {
    return layers.map(function (layer) {
        return layer.getLayerState();
    });
}
/**
 * Create layers for all sources.
 * @param {Array<import("./Source.js").default|import("../layer/Layer.js").default>} sources The sources.
 * @return {Array<import("../layer/Layer.js").default>} Array of layers.
 */
function createLayers(sources) {
    var len = sources.length;
    var layers = new Array(len);
    for (var i = 0; i < len; ++i) {
        layers[i] = createLayer(sources[i]);
    }
    return layers;
}
/**
 * Create a layer for the provided source.
 * @param {import("./Source.js").default|import("../layer/Layer.js").default} layerOrSource The layer or source.
 * @return {import("../layer/Layer.js").default} The layer.
 */
function createLayer(layerOrSource) {
    // @type {import("../layer/Layer.js").default}
    var layer;
    if (layerOrSource instanceof _Source_js__WEBPACK_IMPORTED_MODULE_6__["default"]) {
        if (layerOrSource instanceof _Tile_js__WEBPACK_IMPORTED_MODULE_10__["default"]) {
            layer = new _layer_Tile_js__WEBPACK_IMPORTED_MODULE_8__["default"]({ source: layerOrSource });
        }
        else if (layerOrSource instanceof _Image_js__WEBPACK_IMPORTED_MODULE_5__["default"]) {
            layer = new _layer_Image_js__WEBPACK_IMPORTED_MODULE_4__["default"]({ source: layerOrSource });
        }
    }
    else {
        layer = layerOrSource;
    }
    return layer;
}
/* harmony default export */ __webpack_exports__["default"] = (RasterSource);
//# sourceMappingURL=Raster.js.map

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BaseImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(130);
/* harmony import */ var _renderer_canvas_ImageLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(135);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Image
 */


/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {BaseImageLayer<ImageSourceType>}
 * @api
 */
var ImageLayer = /** @class */ (function (_super) {
    __extends(ImageLayer, _super);
    /**
     * @param {import("./BaseImage.js").Options<ImageSourceType>} [opt_options] Layer options.
     */
    function ImageLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     */
    ImageLayer.prototype.createRenderer = function () {
        return new _renderer_canvas_ImageLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this);
    };
    return ImageLayer;
}(_BaseImage_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ImageLayer);
//# sourceMappingURL=Image.js.map

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/BaseImage
 */

/**
 * @template {import("../source/Image.js").default} ImageSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {ImageSourceType} [source] Source for this layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Server-rendered images that are available for arbitrary extents and
 * resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Image.js").default} ImageSourceType
 * @extends {Layer<ImageSourceType>}
 * @api
 */
var BaseImageLayer = /** @class */ (function (_super) {
    __extends(BaseImageLayer, _super);
    /**
     * @param {Options<ImageSourceType>} [opt_options] Layer options.
     */
    function BaseImageLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, options) || this;
        return _this;
    }
    return BaseImageLayer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseImageLayer);
//# sourceMappingURL=BaseImage.js.map

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inView", function() { return inView; });
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(132);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _Property_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(133);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134);
/* harmony import */ var _source_State_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Layer
 */








/**
 * @typedef {function(import("../PluggableMap.js").FrameState):HTMLElement} RenderFunction
 */
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|'change:source'|
 *     import("../render/EventType").LayerRenderEventTypes, Return>} LayerOnSignature
 */
/**
 * @template {import("../source/Source.js").default} SourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {SourceType} [source] Source for this layer.  If not provided to the constructor,
 * the source can be set by calling {@link module:ol/layer/Layer~Layer#setSource layer.setSource(source)} after
 * construction.
 * @property {import("../PluggableMap.js").default} [map] Map.
 * @property {RenderFunction} [render] Render function. Takes the frame state as input and is expected to return an
 * HTML element. Will overwrite the default rendering for the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @typedef {Object} State
 * @property {import("./Layer.js").default} layer Layer.
 * @property {number} opacity Opacity, the value is rounded to two digits to appear after the decimal point.
 * @property {import("../source/State.js").default} sourceState SourceState.
 * @property {boolean} visible Visible.
 * @property {boolean} managed Managed.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {number} zIndex ZIndex.
 * @property {number} maxResolution Maximum resolution.
 * @property {number} minResolution Minimum resolution.
 * @property {number} minZoom Minimum zoom.
 * @property {number} maxZoom Maximum zoom.
 */
/**
 * @classdesc
 * Base class from which all layer types are derived. This should only be instantiated
 * in the case where a custom layer is be added to the map with a custom `render` function.
 * Such a function can be specified in the `options` object, and is expected to return an HTML element.
 *
 * A visual representation of raster or vector map data.
 * Layers group together those properties that pertain to how the data is to be
 * displayed, irrespective of the source of that data.
 *
 * Layers are usually added to a map with {@link import("../PluggableMap.js").default#addLayer map.addLayer()}. Components
 * like {@link module:ol/interaction/Select~Select} use unmanaged layers
 * internally. These unmanaged layers are associated with the map using
 * {@link module:ol/layer/Layer~Layer#setMap} instead.
 *
 * A generic `change` event is fired when the state of the source changes.
 *
 * Please note that for performance reasons several layers might get rendered to
 * the same HTML element, which will cause {@link import("../PluggableMap.js").default#forEachLayerAtPixel map.forEachLayerAtPixel()} to
 * give false positives. To avoid this, apply different `className` properties to the
 * layers at creation time.
 *
 * @fires import("../render/Event.js").RenderEvent#prerender
 * @fires import("../render/Event.js").RenderEvent#postrender
 *
 * @template {import("../source/Source.js").default} SourceType
 * @api
 */
var Layer = /** @class */ (function (_super) {
    __extends(Layer, _super);
    /**
     * @param {Options<SourceType>} options Layer options.
     */
    function Layer(options) {
        var _this = this;
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_6__["assign"])({}, options);
        delete baseOptions.source;
        _this = _super.call(this, baseOptions) || this;
        /***
         * @type {LayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {LayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {LayerOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */
        _this.mapPrecomposeKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */
        _this.mapRenderKey_ = null;
        /**
         * @private
         * @type {?import("../events.js").EventsKey}
         */
        _this.sourceChangeKey_ = null;
        /**
         * @private
         * @type {import("../renderer/Layer.js").default}
         */
        _this.renderer_ = null;
        // Overwrite default render method with a custom one
        if (options.render) {
            _this.render = options.render;
        }
        if (options.map) {
            _this.setMap(options.map);
        }
        _this.addChangeListener(_Property_js__WEBPACK_IMPORTED_MODULE_2__["default"].SOURCE, _this.handleSourcePropertyChange_);
        var source = options.source
            ? /** @type {SourceType} */ (options.source)
            : null;
        _this.setSource(source);
        return _this;
    }
    /**
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */
    Layer.prototype.getLayersArray = function (opt_array) {
        var array = opt_array ? opt_array : [];
        array.push(this);
        return array;
    };
    /**
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */
    Layer.prototype.getLayerStatesArray = function (opt_states) {
        var states = opt_states ? opt_states : [];
        states.push(this.getLayerState());
        return states;
    };
    /**
     * Get the layer source.
     * @return {SourceType} The layer source (or `null` if not yet set).
     * @observable
     * @api
     */
    Layer.prototype.getSource = function () {
        return /** @type {SourceType} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_2__["default"].SOURCE)) || null;
    };
    /**
     * @return {import("../source/State.js").default} Source state.
     */
    Layer.prototype.getSourceState = function () {
        var source = this.getSource();
        return !source ? _source_State_js__WEBPACK_IMPORTED_MODULE_4__["default"].UNDEFINED : source.getState();
    };
    /**
     * @private
     */
    Layer.prototype.handleSourceChange_ = function () {
        this.changed();
    };
    /**
     * @private
     */
    Layer.prototype.handleSourcePropertyChange_ = function () {
        if (this.sourceChangeKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(this.sourceChangeKey_);
            this.sourceChangeKey_ = null;
        }
        var source = this.getSource();
        if (source) {
            this.sourceChangeKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(source, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, this.handleSourceChange_, this);
        }
        this.changed();
    };
    /**
     * @param {import("../pixel").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */
    Layer.prototype.getFeatures = function (pixel) {
        if (!this.renderer_) {
            return new Promise(function (resolve) { return resolve([]); });
        }
        return this.renderer_.getFeatures(pixel);
    };
    /**
     * In charge to manage the rendering of the layer. One layer type is
     * bounded with one layer renderer.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target which the renderer may (but need not) use
     * for rendering its content.
     * @return {HTMLElement} The rendered element.
     */
    Layer.prototype.render = function (frameState, target) {
        var layerRenderer = this.getRenderer();
        if (layerRenderer.prepareFrame(frameState)) {
            return layerRenderer.renderFrame(frameState, target);
        }
    };
    /**
     * Sets the layer to be rendered on top of other layers on a map. The map will
     * not manage this layer in its layers collection, and the callback in
     * {@link module:ol/Map~Map#forEachLayerAtPixel} will receive `null` as layer. This
     * is useful for temporary layers. To remove an unmanaged layer from the map,
     * use `#setMap(null)`.
     *
     * To add the layer to a map and have it managed by the map, use
     * {@link module:ol/Map~Map#addLayer} instead.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    Layer.prototype.setMap = function (map) {
        if (this.mapPrecomposeKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(this.mapPrecomposeKey_);
            this.mapPrecomposeKey_ = null;
        }
        if (!map) {
            this.changed();
        }
        if (this.mapRenderKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(this.mapRenderKey_);
            this.mapRenderKey_ = null;
        }
        if (map) {
            this.mapPrecomposeKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(map, _render_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].PRECOMPOSE, function (evt) {
                var renderEvent = 
                /** @type {import("../render/Event.js").default} */ (evt);
                var layerStatesArray = renderEvent.frameState.layerStatesArray;
                var layerState = this.getLayerState(false);
                // A layer can only be added to the map once. Use either `layer.setMap()` or `map.addLayer()`, not both.
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_5__["assert"])(!layerStatesArray.some(function (arrayLayerState) {
                    return arrayLayerState.layer === layerState.layer;
                }), 67);
                layerStatesArray.push(layerState);
            }, this);
            this.mapRenderKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(this, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, map.render, map);
            this.changed();
        }
    };
    /**
     * Set the layer source.
     * @param {SourceType} source The layer source.
     * @observable
     * @api
     */
    Layer.prototype.setSource = function (source) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_2__["default"].SOURCE, source);
    };
    /**
     * Get the renderer for this layer.
     * @return {import("../renderer/Layer.js").default} The layer renderer.
     */
    Layer.prototype.getRenderer = function () {
        if (!this.renderer_) {
            this.renderer_ = this.createRenderer();
        }
        return this.renderer_;
    };
    /**
     * @return {boolean} The layer has a renderer.
     */
    Layer.prototype.hasRenderer = function () {
        return !!this.renderer_;
    };
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     * @protected
     */
    Layer.prototype.createRenderer = function () {
        return null;
    };
    /**
     * Clean up.
     */
    Layer.prototype.disposeInternal = function () {
        this.setSource(null);
        _super.prototype.disposeInternal.call(this);
    };
    return Layer;
}(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Return `true` if the layer is visible and if the provided view state
 * has resolution and zoom levels that are in range of the layer's min/max.
 * @param {State} layerState Layer state.
 * @param {import("../View.js").State} viewState View state.
 * @return {boolean} The layer is visible at the given view state.
 */
function inView(layerState, viewState) {
    if (!layerState.visible) {
        return false;
    }
    var resolution = viewState.resolution;
    if (resolution < layerState.minResolution ||
        resolution >= layerState.maxResolution) {
        return false;
    }
    var zoom = viewState.zoom;
    return zoom > layerState.minZoom && zoom <= layerState.maxZoom;
}
/* harmony default export */ __webpack_exports__["default"] = (Layer);
//# sourceMappingURL=Layer.js.map

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _Property_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(133);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Base
 */






/**
 * @typedef {import("../ObjectEventType").Types|'change:extent'|'change:maxResolution'|'change:maxZoom'|
 *    'change:minResolution'|'change:minZoom'|'change:opacity'|'change:visible'|'change:zIndex'} BaseLayerObjectEventTypes
 */
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<BaseLayerObjectEventTypes, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|BaseLayerObjectEventTypes, Return>} BaseLayerOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Note that with {@link module:ol/layer/Base} and all its subclasses, any property set in
 * the options is set as a {@link module:ol/Object} property on the layer object, so
 * is observable, and has get/set accessors.
 *
 * @api
 */
var BaseLayer = /** @class */ (function (_super) {
    __extends(BaseLayer, _super);
    /**
     * @param {Options} options Layer options.
     */
    function BaseLayer(options) {
        var _this = _super.call(this) || this;
        /***
         * @type {BaseLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {BaseLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {BaseLayerOnSignature<void>}
         */
        _this.un;
        /**
         * @type {Object<string, *>}
         */
        var properties = Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])({}, options);
        if (typeof options.properties === 'object') {
            delete properties.properties;
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])(properties, options.properties);
        }
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].OPACITY] =
            options.opacity !== undefined ? options.opacity : 1;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(typeof properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].OPACITY] === 'number', 64); // Layer opacity must be a number
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].VISIBLE] =
            options.visible !== undefined ? options.visible : true;
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].Z_INDEX] = options.zIndex;
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_RESOLUTION] =
            options.maxResolution !== undefined ? options.maxResolution : Infinity;
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_RESOLUTION] =
            options.minResolution !== undefined ? options.minResolution : 0;
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_ZOOM] =
            options.minZoom !== undefined ? options.minZoom : -Infinity;
        properties[_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_ZOOM] =
            options.maxZoom !== undefined ? options.maxZoom : Infinity;
        /**
         * @type {string}
         * @private
         */
        _this.className_ =
            properties.className !== undefined ? options.className : 'ol-layer';
        delete properties.className;
        _this.setProperties(properties);
        /**
         * @type {import("./Layer.js").State}
         * @private
         */
        _this.state_ = null;
        return _this;
    }
    /**
     * @return {string} CSS class name.
     */
    BaseLayer.prototype.getClassName = function () {
        return this.className_;
    };
    /**
     * This method is not meant to be called by layers or layer renderers because the state
     * is incorrect if the layer is included in a layer group.
     *
     * @param {boolean} [opt_managed] Layer is managed.
     * @return {import("./Layer.js").State} Layer state.
     */
    BaseLayer.prototype.getLayerState = function (opt_managed) {
        /** @type {import("./Layer.js").State} */
        var state = this.state_ ||
            /** @type {?} */ ({
                layer: this,
                managed: opt_managed === undefined ? true : opt_managed,
            });
        var zIndex = this.getZIndex();
        state.opacity = Object(_math_js__WEBPACK_IMPORTED_MODULE_5__["clamp"])(Math.round(this.getOpacity() * 100) / 100, 0, 1);
        state.sourceState = this.getSourceState();
        state.visible = this.getVisible();
        state.extent = this.getExtent();
        state.zIndex = zIndex === undefined && !state.managed ? Infinity : zIndex;
        state.maxResolution = this.getMaxResolution();
        state.minResolution = Math.max(this.getMinResolution(), 0);
        state.minZoom = this.getMinZoom();
        state.maxZoom = this.getMaxZoom();
        this.state_ = state;
        return state;
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be
     *     modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */
    BaseLayer.prototype.getLayersArray = function (opt_array) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @abstract
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list of layer
     *     states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */
    BaseLayer.prototype.getLayerStatesArray = function (opt_states) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Return the {@link module:ol/extent~Extent extent} of the layer or `undefined` if it
     * will be visible regardless of extent.
     * @return {import("../extent.js").Extent|undefined} The layer extent.
     * @observable
     * @api
     */
    BaseLayer.prototype.getExtent = function () {
        return /** @type {import("../extent.js").Extent|undefined} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].EXTENT));
    };
    /**
     * Return the maximum resolution of the layer.
     * @return {number} The maximum resolution of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getMaxResolution = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_RESOLUTION));
    };
    /**
     * Return the minimum resolution of the layer.
     * @return {number} The minimum resolution of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getMinResolution = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_RESOLUTION));
    };
    /**
     * Return the minimum zoom level of the layer.
     * @return {number} The minimum zoom level of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getMinZoom = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_ZOOM));
    };
    /**
     * Return the maximum zoom level of the layer.
     * @return {number} The maximum zoom level of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getMaxZoom = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_ZOOM));
    };
    /**
     * Return the opacity of the layer (between 0 and 1).
     * @return {number} The opacity of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getOpacity = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].OPACITY));
    };
    /**
     * @abstract
     * @return {import("../source/State.js").default} Source state.
     */
    BaseLayer.prototype.getSourceState = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Return the visibility of the layer (`true` or `false`).
     * @return {boolean} The visibility of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getVisible = function () {
        return /** @type {boolean} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].VISIBLE));
    };
    /**
     * Return the Z-index of the layer, which is used to order layers before
     * rendering. The default Z-index is 0.
     * @return {number} The Z-index of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.getZIndex = function () {
        return /** @type {number} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].Z_INDEX));
    };
    /**
     * Set the extent at which the layer is visible.  If `undefined`, the layer
     * will be visible at all extents.
     * @param {import("../extent.js").Extent|undefined} extent The extent of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setExtent = function (extent) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].EXTENT, extent);
    };
    /**
     * Set the maximum resolution at which the layer is visible.
     * @param {number} maxResolution The maximum resolution of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setMaxResolution = function (maxResolution) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_RESOLUTION, maxResolution);
    };
    /**
     * Set the minimum resolution at which the layer is visible.
     * @param {number} minResolution The minimum resolution of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setMinResolution = function (minResolution) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_RESOLUTION, minResolution);
    };
    /**
     * Set the maximum zoom (exclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} maxZoom The maximum zoom of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setMaxZoom = function (maxZoom) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MAX_ZOOM, maxZoom);
    };
    /**
     * Set the minimum zoom (inclusive) at which the layer is visible.
     * Note that the zoom levels for layer visibility are based on the
     * view zoom level, which may be different from a tile source zoom level.
     * @param {number} minZoom The minimum zoom of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setMinZoom = function (minZoom) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].MIN_ZOOM, minZoom);
    };
    /**
     * Set the opacity of the layer, allowed values range from 0 to 1.
     * @param {number} opacity The opacity of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setOpacity = function (opacity) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(typeof opacity === 'number', 64); // Layer opacity must be a number
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].OPACITY, opacity);
    };
    /**
     * Set the visibility of the layer (`true` or `false`).
     * @param {boolean} visible The visibility of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setVisible = function (visible) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].VISIBLE, visible);
    };
    /**
     * Set Z-index of the layer, which is used to order layers before rendering.
     * The default Z-index is 0.
     * @param {number} zindex The z-index of the layer.
     * @observable
     * @api
     */
    BaseLayer.prototype.setZIndex = function (zindex) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].Z_INDEX, zindex);
    };
    /**
     * Clean up.
     */
    BaseLayer.prototype.disposeInternal = function () {
        if (this.state_) {
            this.state_.layer = null;
            this.state_ = null;
        }
        _super.prototype.disposeInternal.call(this);
    };
    return BaseLayer;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseLayer);
//# sourceMappingURL=Base.js.map

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/layer/Property
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    OPACITY: 'opacity',
    VISIBLE: 'visible',
    EXTENT: 'extent',
    Z_INDEX: 'zIndex',
    MAX_RESOLUTION: 'maxResolution',
    MIN_RESOLUTION: 'minResolution',
    MAX_ZOOM: 'maxZoom',
    MIN_ZOOM: 'minZoom',
    SOURCE: 'source',
});
//# sourceMappingURL=Property.js.map

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/render/EventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered before a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#prerender
     * @api
     */
    PRERENDER: 'prerender',
    /**
     * Triggered after a layer is rendered.
     * @event module:ol/render/Event~RenderEvent#postrender
     * @api
     */
    POSTRENDER: 'postrender',
    /**
     * Triggered before layers are rendered.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#precompose
     * @api
     */
    PRECOMPOSE: 'precompose',
    /**
     * Triggered after all layers are rendered.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#postcompose
     * @api
     */
    POSTCOMPOSE: 'postcompose',
    /**
     * Triggered when rendering is complete, i.e. all sources and tiles have
     * finished loading for the current viewport, and all tiles are faded in.
     * The event object will not have a `context` set.
     * @event module:ol/render/Event~RenderEvent#rendercomplete
     * @api
     */
    RENDERCOMPLETE: 'rendercomplete',
});
/**
 * @typedef {'postrender'|'precompose'|'postcompose'|'rendercomplete'} MapRenderEventTypes
 */
/**
 * @typedef {'postrender'|'prerender'} LayerRenderEventTypes
 */
//# sourceMappingURL=EventType.js.map

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(136);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(139);
/* harmony import */ var _reproj_common_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/ImageLayer
 */









/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */
var CanvasImageLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasImageLayerRenderer, _super);
    /**
     * @param {import("../../layer/Image.js").default} imageLayer Image layer.
     */
    function CanvasImageLayerRenderer(imageLayer) {
        var _this = _super.call(this, imageLayer) || this;
        /**
         * @protected
         * @type {?import("../../ImageBase.js").default}
         */
        _this.image_ = null;
        return _this;
    }
    /**
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     */
    CanvasImageLayerRenderer.prototype.getImage = function () {
        return !this.image_ ? null : this.image_.getImage();
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    CanvasImageLayerRenderer.prototype.prepareFrame = function (frameState) {
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var viewResolution = viewState.resolution;
        var imageSource = this.getLayer().getSource();
        var hints = frameState.viewHints;
        var renderedExtent = frameState.extent;
        if (layerState.extent !== undefined) {
            renderedExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getIntersection"])(renderedExtent, Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(layerState.extent, viewState.projection));
        }
        if (!hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_1__["default"].ANIMATING] &&
            !hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_1__["default"].INTERACTING] &&
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(renderedExtent)) {
            if (imageSource) {
                var projection = viewState.projection;
                if (!_reproj_common_js__WEBPACK_IMPORTED_MODULE_2__["ENABLE_RASTER_REPROJECTION"]) {
                    var sourceProjection = imageSource.getProjection();
                    if (sourceProjection) {
                        projection = sourceProjection;
                    }
                }
                var image = imageSource.getImage(renderedExtent, viewResolution, pixelRatio, projection);
                if (image && this.loadImage(image)) {
                    this.image_ = image;
                }
            }
            else {
                this.image_ = null;
            }
        }
        return !!this.image_;
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
    CanvasImageLayerRenderer.prototype.renderFrame = function (frameState, target) {
        var image = this.image_;
        var imageExtent = image.getExtent();
        var imageResolution = image.getResolution();
        var imagePixelRatio = image.getPixelRatio();
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var viewCenter = viewState.center;
        var viewResolution = viewState.resolution;
        var size = frameState.size;
        var scale = (pixelRatio * imageResolution) / (viewResolution * imagePixelRatio);
        var width = Math.round(size[0] * pixelRatio);
        var height = Math.round(size[1] * pixelRatio);
        var rotation = viewState.rotation;
        if (rotation) {
            var size_1 = Math.round(Math.sqrt(width * width + height * height));
            width = size_1;
            height = size_1;
        }
        // set forward and inverse pixel transforms
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_4__["compose"])(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / pixelRatio, 1 / pixelRatio, rotation, -width / 2, -height / 2);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_4__["makeInverse"])(this.inversePixelTransform, this.pixelTransform);
        var canvasTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_4__["toString"])(this.pixelTransform);
        this.useContainer(target, canvasTransform, layerState.opacity);
        var context = this.context;
        var canvas = context.canvas;
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
        }
        else if (!this.containerReused) {
            context.clearRect(0, 0, width, height);
        }
        // clipped rendering if layer extent is set
        var clipped = false;
        var render = true;
        if (layerState.extent) {
            var layerExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(layerState.extent, viewState.projection);
            render = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["intersects"])(layerExtent, frameState.extent);
            clipped = render && !Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["containsExtent"])(layerExtent, frameState.extent);
            if (clipped) {
                this.clipUnrotated(context, frameState, layerExtent);
            }
        }
        var img = image.getImage();
        var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_4__["compose"])(this.tempTransform, width / 2, height / 2, scale, scale, 0, (imagePixelRatio * (imageExtent[0] - viewCenter[0])) / imageResolution, (imagePixelRatio * (viewCenter[1] - imageExtent[3])) / imageResolution);
        this.renderedResolution = (imageResolution * pixelRatio) / imagePixelRatio;
        var dw = img.width * transform[0];
        var dh = img.height * transform[3];
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])(context, this.getLayer().getSource().getContextOptions());
        this.preRender(context, frameState);
        if (render && dw >= 0.5 && dh >= 0.5) {
            var dx = transform[4];
            var dy = transform[5];
            var opacity = layerState.opacity;
            var previousAlpha = void 0;
            if (opacity !== 1) {
                previousAlpha = context.globalAlpha;
                context.globalAlpha = opacity;
            }
            context.drawImage(img, 0, 0, +img.width, +img.height, Math.round(dx), Math.round(dy), Math.round(dw), Math.round(dh));
            if (opacity !== 1) {
                context.globalAlpha = previousAlpha;
            }
        }
        this.postRender(context, frameState);
        if (clipped) {
            context.restore();
        }
        if (canvasTransform !== canvas.style.transform) {
            canvas.style.transform = canvasTransform;
        }
        return this.container;
    };
    return CanvasImageLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasImageLayerRenderer);
//# sourceMappingURL=ImageLayer.js.map

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(137);
/* harmony import */ var _render_Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(134);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/Layer
 */






/**
 * @abstract
 * @template {import("../../layer/Layer.js").default} LayerType
 */
var CanvasLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasLayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */
    function CanvasLayerRenderer(layer) {
        var _this = _super.call(this, layer) || this;
        /**
         * @protected
         * @type {HTMLElement}
         */
        _this.container = null;
        /**
         * @protected
         * @type {number}
         */
        _this.renderedResolution;
        /**
         * A temporary transform.  The values in this transform should only be used in a
         * function that sets the values.
         * @protected
         * @type {import("../../transform.js").Transform}
         */
        _this.tempTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        /**
         * The transform for rendered pixels to viewport CSS pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */
        _this.pixelTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        /**
         * The transform for viewport CSS pixels to rendered pixels.  This transform must
         * be set when rendering a frame and may be used by other functions after rendering.
         * @protected
         * @type {import("../../transform.js").Transform}
         */
        _this.inversePixelTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        /**
         * @type {CanvasRenderingContext2D}
         */
        _this.context = null;
        /**
         * @type {boolean}
         */
        _this.containerReused = false;
        return _this;
    }
    /**
     * Get a rendering container from an existing target, if compatible.
     * @param {HTMLElement} target Potential render target.
     * @param {string} transform CSS Transform.
     * @param {number} opacity Opacity.
     */
    CanvasLayerRenderer.prototype.useContainer = function (target, transform, opacity) {
        var layerClassName = this.getLayer().getClassName();
        var container, context;
        if (target &&
            target.style.opacity === '' &&
            target.className === layerClassName) {
            var canvas = target.firstElementChild;
            if (canvas instanceof HTMLCanvasElement) {
                context = canvas.getContext('2d');
            }
        }
        if (context &&
            (context.canvas.width === 0 ||
                context.canvas.style.transform === transform)) {
            // Container of the previous layer renderer can be used.
            this.container = target;
            this.context = context;
            this.containerReused = true;
        }
        else if (this.containerReused) {
            // Previously reused container cannot be used any more.
            this.container = null;
            this.context = null;
            this.containerReused = false;
        }
        if (!this.container) {
            container = document.createElement('div');
            container.className = layerClassName;
            var style = container.style;
            style.position = 'absolute';
            style.width = '100%';
            style.height = '100%';
            context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["createCanvasContext2D"])();
            var canvas = context.canvas;
            container.appendChild(canvas);
            style = canvas.style;
            style.position = 'absolute';
            style.left = '0';
            style.transformOrigin = 'top left';
            this.container = container;
            this.context = context;
        }
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../extent.js").Extent} extent Clip extent.
     * @protected
     */
    CanvasLayerRenderer.prototype.clipUnrotated = function (context, frameState, extent) {
        var topLeft = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getTopLeft"])(extent);
        var topRight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getTopRight"])(extent);
        var bottomRight = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getBottomRight"])(extent);
        var bottomLeft = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getBottomLeft"])(extent);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(frameState.coordinateToPixelTransform, topLeft);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(frameState.coordinateToPixelTransform, topRight);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(frameState.coordinateToPixelTransform, bottomRight);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(frameState.coordinateToPixelTransform, bottomLeft);
        var inverted = this.inversePixelTransform;
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(inverted, topLeft);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(inverted, topRight);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(inverted, bottomRight);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(inverted, bottomLeft);
        context.save();
        context.beginPath();
        context.moveTo(Math.round(topLeft[0]), Math.round(topLeft[1]));
        context.lineTo(Math.round(topRight[0]), Math.round(topRight[1]));
        context.lineTo(Math.round(bottomRight[0]), Math.round(bottomRight[1]));
        context.lineTo(Math.round(bottomLeft[0]), Math.round(bottomLeft[1]));
        context.clip();
    };
    /**
     * @param {import("../../render/EventType.js").default} type Event type.
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */
    CanvasLayerRenderer.prototype.dispatchRenderEvent_ = function (type, context, frameState) {
        var layer = this.getLayer();
        if (layer.hasListener(type)) {
            var event_1 = new _render_Event_js__WEBPACK_IMPORTED_MODULE_1__["default"](type, this.inversePixelTransform, frameState, context);
            layer.dispatchEvent(event_1);
        }
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */
    CanvasLayerRenderer.prototype.preRender = function (context, frameState) {
        this.dispatchRenderEvent_(_render_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].PRERENDER, context, frameState);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */
    CanvasLayerRenderer.prototype.postRender = function (context, frameState) {
        this.dispatchRenderEvent_(_render_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POSTRENDER, context, frameState);
    };
    /**
     * Creates a transform for rendering to an element that will be rotated after rendering.
     * @param {import("../../coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} pixelRatio Pixel ratio.
     * @param {number} width Width of the rendered element (in pixels).
     * @param {number} height Height of the rendered element (in pixels).
     * @param {number} offsetX Offset on the x-axis in view coordinates.
     * @protected
     * @return {!import("../../transform.js").Transform} Transform.
     */
    CanvasLayerRenderer.prototype.getRenderTransform = function (center, resolution, rotation, pixelRatio, width, height, offsetX) {
        var dx1 = width / 2;
        var dy1 = height / 2;
        var sx = pixelRatio / resolution;
        var sy = -sx;
        var dx2 = -center[0] + offsetX;
        var dy2 = -center[1];
        return Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(this.tempTransform, dx1, dy1, sx, sy, -rotation, dx2, dy2);
    };
    /**
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @param {import("../../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */
    CanvasLayerRenderer.prototype.getDataAtPixel = function (pixel, frameState, hitTolerance) {
        var renderPixel = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(this.inversePixelTransform, pixel.slice());
        var context = this.context;
        var layer = this.getLayer();
        var layerExtent = layer.getExtent();
        if (layerExtent) {
            var renderCoordinate = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(frameState.pixelToCoordinateTransform, pixel.slice());
            /** get only data inside of the layer extent */
            if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["containsCoordinate"])(layerExtent, renderCoordinate)) {
                return null;
            }
        }
        var data;
        try {
            var x = Math.round(renderPixel[0]);
            var y = Math.round(renderPixel[1]);
            var newCanvas = document.createElement('canvas');
            var newContext = newCanvas.getContext('2d');
            newCanvas.width = 1;
            newCanvas.height = 1;
            newContext.clearRect(0, 0, 1, 1);
            newContext.drawImage(context.canvas, x, y, 1, 1, 0, 0, 1, 1);
            data = newContext.getImageData(0, 0, 1, 1).data;
        }
        catch (err) {
            if (err.name === 'SecurityError') {
                // tainted canvas, we assume there is data at the given pixel (although there might not be)
                return new Uint8Array();
            }
            return data;
        }
        if (data[3] === 0) {
            return null;
        }
        return data;
    };
    return CanvasLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasLayerRenderer);
//# sourceMappingURL=Layer.js.map

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37);
/* harmony import */ var _Observable_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48);
/* harmony import */ var _source_State_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/Layer
 */





/**
 * @template {import("../layer/Layer.js").default} LayerType
 */
var LayerRenderer = /** @class */ (function (_super) {
    __extends(LayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     */
    function LayerRenderer(layer) {
        var _this = _super.call(this) || this;
        /** @private */
        _this.boundHandleImageChange_ = _this.handleImageChange_.bind(_this);
        /**
         * @protected
         * @type {LayerType}
         */
        _this.layer_ = layer;
        /**
         * @type {import("../render/canvas/ExecutorGroup").default}
         */
        _this.declutterExecutorGroup = null;
        return _this;
    }
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with
     * an array of features.
     */
    LayerRenderer.prototype.getFeatures = function (pixel) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["abstract"])();
    };
    /**
     * Determine whether render should be called.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    LayerRenderer.prototype.prepareFrame = function (frameState) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["abstract"])();
    };
    /**
     * Render the layer.
     * @abstract
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
    LayerRenderer.prototype.renderFrame = function (frameState, target) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["abstract"])();
    };
    /**
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */
    LayerRenderer.prototype.loadedTileCallback = function (tiles, zoom, tile) {
        if (!tiles[zoom]) {
            tiles[zoom] = {};
        }
        tiles[zoom][tile.tileCoord.toString()] = tile;
        return undefined;
    };
    /**
     * Create a function that adds loaded tiles to the tile lookup.
     * @param {import("../source/Tile.js").default} source Tile source.
     * @param {import("../proj/Projection.js").default} projection Projection of the tiles.
     * @param {Object<number, Object<string, import("../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @return {function(number, import("../TileRange.js").default):boolean} A function that can be
     *     called with a zoom level and a tile range to add loaded tiles to the lookup.
     * @protected
     */
    LayerRenderer.prototype.createLoadedTileFinder = function (source, projection, tiles) {
        return (
        /**
         * @param {number} zoom Zoom level.
         * @param {import("../TileRange.js").default} tileRange Tile range.
         * @return {boolean} The tile range is fully loaded.
         * @this {LayerRenderer}
         */
        function (zoom, tileRange) {
            var callback = this.loadedTileCallback.bind(this, tiles, zoom);
            return source.forEachLoadedTile(projection, zoom, tileRange, callback);
        }.bind(this));
    };
    /**
     * @abstract
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("./Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
    LayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
        return undefined;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @return {Uint8ClampedArray|Uint8Array} The result.  If there is no data at the pixel
     *    location, null will be returned.  If there is data, but pixel values cannot be
     *    returned, and empty array will be returned.
     */
    LayerRenderer.prototype.getDataAtPixel = function (pixel, frameState, hitTolerance) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_4__["abstract"])();
    };
    /**
     * @return {LayerType} Layer.
     */
    LayerRenderer.prototype.getLayer = function () {
        return this.layer_;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     * @abstract
     */
    LayerRenderer.prototype.handleFontsChanged = function () { };
    /**
     * Handle changes in image state.
     * @param {import("../events/Event.js").default} event Image change event.
     * @private
     */
    LayerRenderer.prototype.handleImageChange_ = function (event) {
        var image = /** @type {import("../Image.js").default} */ (event.target);
        if (image.getState() === _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED) {
            this.renderIfReadyAndVisible();
        }
    };
    /**
     * Load the image if not already loaded, and register the image change
     * listener if needed.
     * @param {import("../ImageBase.js").default} image Image.
     * @return {boolean} `true` if the image is already loaded, `false` otherwise.
     * @protected
     */
    LayerRenderer.prototype.loadImage = function (image) {
        var imageState = image.getState();
        if (imageState != _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED && imageState != _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR) {
            image.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.boundHandleImageChange_);
        }
        if (imageState == _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE) {
            image.load();
            imageState = image.getState();
        }
        return imageState == _ImageState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED;
    };
    /**
     * @protected
     */
    LayerRenderer.prototype.renderIfReadyAndVisible = function () {
        var layer = this.getLayer();
        if (layer.getVisible() && layer.getSourceState() == _source_State_js__WEBPACK_IMPORTED_MODULE_3__["default"].READY) {
            layer.changed();
        }
    };
    return LayerRenderer;
}(_Observable_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LayerRenderer);
//# sourceMappingURL=Layer.js.map

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/**
 * @module ol/render/Event
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

var RenderEvent = /** @class */ (function (_super) {
    __extends(RenderEvent, _super);
    /**
     * @param {import("./EventType.js").default} type Type.
     * @param {import("../transform.js").Transform} [opt_inversePixelTransform] Transform for
     *     CSS pixels to rendered pixels.
     * @param {import("../PluggableMap.js").FrameState} [opt_frameState] Frame state.
     * @param {?CanvasRenderingContext2D} [opt_context] Context.
     */
    function RenderEvent(type, opt_inversePixelTransform, opt_frameState, opt_context) {
        var _this = _super.call(this, type) || this;
        /**
         * Transform from CSS pixels (relative to the top-left corner of the map viewport)
         * to rendered pixels on this event's `context`. Only available when a Canvas renderer is used, null otherwise.
         * @type {import("../transform.js").Transform|undefined}
         * @api
         */
        _this.inversePixelTransform = opt_inversePixelTransform;
        /**
         * An object representing the current render frame state.
         * @type {import("../PluggableMap.js").FrameState|undefined}
         * @api
         */
        _this.frameState = opt_frameState;
        /**
         * Canvas context. Not available when the event is dispatched by the map. Only available
         * when a Canvas renderer is used, null otherwise.
         * @type {CanvasRenderingContext2D|null|undefined}
         * @api
         */
        _this.context = opt_context;
        return _this;
    }
    return RenderEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (RenderEvent);
//# sourceMappingURL=Event.js.map

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/ViewHint
 */
/**
 * @enum {number}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    ANIMATING: 0,
    INTERACTING: 1,
});
//# sourceMappingURL=ViewHint.js.map

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BaseTile_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(141);
/* harmony import */ var _renderer_canvas_TileLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(143);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Tile
 */


/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends {BaseTileLayer<TileSourceType>}
 * @api
 */
var TileLayer = /** @class */ (function (_super) {
    __extends(TileLayer, _super);
    /**
     * @param {import("./BaseTile.js").Options<TileSourceType>} [opt_options] Tile layer options.
     */
    function TileLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     * @protected
     */
    TileLayer.prototype.createRenderer = function () {
        return new _renderer_canvas_TileLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this);
    };
    return TileLayer;
}(_BaseTile_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileLayer);
//# sourceMappingURL=Tile.js.map

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131);
/* harmony import */ var _TileProperty_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(142);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/BaseTile
 */



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source'|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *   'change:source'|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} BaseTileLayerOnSignature
 */
/**
 * @template {import("../source/Tile.js").default} TileSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {TileSourceType} [source] Source for this layer.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * For layer sources that provide pre-rendered, tiled images in grids that are
 * organized by zoom levels for specific resolutions.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Tile.js").default} TileSourceType
 * @extends {Layer<TileSourceType>}
 * @api
 */
var BaseTileLayer = /** @class */ (function (_super) {
    __extends(BaseTileLayer, _super);
    /**
     * @param {Options<TileSourceType>} [opt_options] Tile layer options.
     */
    function BaseTileLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        _this = _super.call(this, baseOptions) || this;
        /***
         * @type {BaseTileLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {BaseTileLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {BaseTileLayerOnSignature<void>}
         */
        _this.un;
        _this.setPreload(options.preload !== undefined ? options.preload : 0);
        _this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined
            ? options.useInterimTilesOnError
            : true);
        return _this;
    }
    /**
     * Return the level as number to which we will preload tiles up to.
     * @return {number} The level to preload tiles up to.
     * @observable
     * @api
     */
    BaseTileLayer.prototype.getPreload = function () {
        return /** @type {number} */ (this.get(_TileProperty_js__WEBPACK_IMPORTED_MODULE_1__["default"].PRELOAD));
    };
    /**
     * Set the level as number to which we will preload tiles up to.
     * @param {number} preload The level to preload tiles up to.
     * @observable
     * @api
     */
    BaseTileLayer.prototype.setPreload = function (preload) {
        this.set(_TileProperty_js__WEBPACK_IMPORTED_MODULE_1__["default"].PRELOAD, preload);
    };
    /**
     * Whether we use interim tiles on error.
     * @return {boolean} Use interim tiles on error.
     * @observable
     * @api
     */
    BaseTileLayer.prototype.getUseInterimTilesOnError = function () {
        return /** @type {boolean} */ (this.get(_TileProperty_js__WEBPACK_IMPORTED_MODULE_1__["default"].USE_INTERIM_TILES_ON_ERROR));
    };
    /**
     * Set whether we use interim tiles on error.
     * @param {boolean} useInterimTilesOnError Use interim tiles on error.
     * @observable
     * @api
     */
    BaseTileLayer.prototype.setUseInterimTilesOnError = function (useInterimTilesOnError) {
        this.set(_TileProperty_js__WEBPACK_IMPORTED_MODULE_1__["default"].USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    };
    return BaseTileLayer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseTileLayer);
//# sourceMappingURL=BaseTile.js.map

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/layer/TileProperty
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    PRELOAD: 'preload',
    USE_INTERIM_TILES_ON_ERROR: 'useInterimTilesOnError',
});
//# sourceMappingURL=TileProperty.js.map

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(136);
/* harmony import */ var _TileRange_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(21);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/TileLayer
 */










/**
 * @classdesc
 * Canvas renderer for tile layers.
 * @api
 */
var CanvasTileLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasTileLayerRenderer, _super);
    /**
     * @param {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default} tileLayer Tile layer.
     */
    function CanvasTileLayerRenderer(tileLayer) {
        var _this = _super.call(this, tileLayer) || this;
        /**
         * Rendered extent has changed since the previous `renderFrame()` call
         * @type {boolean}
         */
        _this.extentChanged = true;
        /**
         * @private
         * @type {?import("../../extent.js").Extent}
         */
        _this.renderedExtent_ = null;
        /**
         * @protected
         * @type {number}
         */
        _this.renderedPixelRatio;
        /**
         * @protected
         * @type {import("../../proj/Projection.js").default}
         */
        _this.renderedProjection = null;
        /**
         * @protected
         * @type {number}
         */
        _this.renderedRevision;
        /**
         * @protected
         * @type {!Array<import("../../Tile.js").default>}
         */
        _this.renderedTiles = [];
        /**
         * @private
         * @type {boolean}
         */
        _this.newTiles_ = false;
        /**
         * @protected
         * @type {import("../../extent.js").Extent}
         */
        _this.tmpExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["createEmpty"])();
        /**
         * @private
         * @type {import("../../TileRange.js").default}
         */
        _this.tmpTileRange_ = new _TileRange_js__WEBPACK_IMPORTED_MODULE_1__["default"](0, 0, 0, 0);
        return _this;
    }
    /**
     * @protected
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean} Tile is drawable.
     */
    CanvasTileLayerRenderer.prototype.isDrawableTile = function (tile) {
        var tileLayer = this.getLayer();
        var tileState = tile.getState();
        var useInterimTilesOnError = tileLayer.getUseInterimTilesOnError();
        return (tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED ||
            tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].EMPTY ||
            (tileState == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR && !useInterimTilesOnError));
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {!import("../../Tile.js").default} Tile.
     */
    CanvasTileLayerRenderer.prototype.getTile = function (z, x, y, frameState) {
        var pixelRatio = frameState.pixelRatio;
        var projection = frameState.viewState.projection;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var tile = tileSource.getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR) {
            if (!tileLayer.getUseInterimTilesOnError()) {
                // When useInterimTilesOnError is false, we consider the error tile as loaded.
                tile.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED);
            }
            else if (tileLayer.getPreload() > 0) {
                // Preloaded tiles for lower resolutions might have finished loading.
                this.newTiles_ = true;
            }
        }
        if (!this.isDrawableTile(tile)) {
            tile = tile.getInterimTile();
        }
        return tile;
    };
    /**
     * @param {Object<number, Object<string, import("../../Tile.js").default>>} tiles Lookup of loaded tiles by zoom level.
     * @param {number} zoom Zoom level.
     * @param {import("../../Tile.js").default} tile Tile.
     * @return {boolean|void} If `false`, the tile will not be considered loaded.
     */
    CanvasTileLayerRenderer.prototype.loadedTileCallback = function (tiles, zoom, tile) {
        if (this.isDrawableTile(tile)) {
            return _super.prototype.loadedTileCallback.call(this, tiles, zoom, tile);
        }
        return false;
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    CanvasTileLayerRenderer.prototype.prepareFrame = function (frameState) {
        return !!this.getLayer().getSource();
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
    CanvasTileLayerRenderer.prototype.renderFrame = function (frameState, target) {
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var viewResolution = viewState.resolution;
        var viewCenter = viewState.center;
        var rotation = viewState.rotation;
        var pixelRatio = frameState.pixelRatio;
        var tileLayer = this.getLayer();
        var tileSource = tileLayer.getSource();
        var sourceRevision = tileSource.getRevision();
        var tileGrid = tileSource.getTileGridForProjection(projection);
        var z = tileGrid.getZForResolution(viewResolution, tileSource.zDirection);
        var tileResolution = tileGrid.getResolution(z);
        var extent = frameState.extent;
        var layerExtent = layerState.extent && Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(layerState.extent, projection);
        if (layerExtent) {
            extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getIntersection"])(extent, Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(layerState.extent, projection));
        }
        var tilePixelRatio = tileSource.getTilePixelRatio(pixelRatio);
        // desired dimensions of the canvas in pixels
        var width = Math.round(frameState.size[0] * tilePixelRatio);
        var height = Math.round(frameState.size[1] * tilePixelRatio);
        if (rotation) {
            var size = Math.round(Math.sqrt(width * width + height * height));
            width = size;
            height = size;
        }
        var dx = (tileResolution * width) / 2 / tilePixelRatio;
        var dy = (tileResolution * height) / 2 / tilePixelRatio;
        var canvasExtent = [
            viewCenter[0] - dx,
            viewCenter[1] - dy,
            viewCenter[0] + dx,
            viewCenter[1] + dy,
        ];
        var tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z);
        /**
         * @type {Object<number, Object<string, import("../../Tile.js").default>>}
         */
        var tilesToDrawByZ = {};
        tilesToDrawByZ[z] = {};
        var findLoadedTiles = this.createLoadedTileFinder(tileSource, projection, tilesToDrawByZ);
        var tmpExtent = this.tmpExtent;
        var tmpTileRange = this.tmpTileRange_;
        this.newTiles_ = false;
        for (var x = tileRange.minX; x <= tileRange.maxX; ++x) {
            for (var y = tileRange.minY; y <= tileRange.maxY; ++y) {
                var tile = this.getTile(z, x, y, frameState);
                if (this.isDrawableTile(tile)) {
                    var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(this);
                    if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
                        tilesToDrawByZ[z][tile.tileCoord.toString()] = tile;
                        var inTransition = tile.inTransition(uid);
                        if (!this.newTiles_ &&
                            (inTransition || this.renderedTiles.indexOf(tile) === -1)) {
                            this.newTiles_ = true;
                        }
                    }
                    if (tile.getAlpha(uid, frameState.time) === 1) {
                        // don't look for alt tiles if alpha is 1
                        continue;
                    }
                }
                var childTileRange = tileGrid.getTileCoordChildTileRange(tile.tileCoord, tmpTileRange, tmpExtent);
                var covered = false;
                if (childTileRange) {
                    covered = findLoadedTiles(z + 1, childTileRange);
                }
                if (!covered) {
                    tileGrid.forEachTileCoordParentTileRange(tile.tileCoord, findLoadedTiles, tmpTileRange, tmpExtent);
                }
            }
        }
        var canvasScale = tileResolution / viewResolution;
        // set forward and inverse pixel transforms
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(this.pixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / tilePixelRatio, 1 / tilePixelRatio, rotation, -width / 2, -height / 2);
        var canvasTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["toString"])(this.pixelTransform);
        this.useContainer(target, canvasTransform, layerState.opacity);
        var context = this.context;
        var canvas = context.canvas;
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["makeInverse"])(this.inversePixelTransform, this.pixelTransform);
        // set scale transform for calculating tile positions on the canvas
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(this.tempTransform, width / 2, height / 2, canvasScale, canvasScale, 0, -width / 2, -height / 2);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
        }
        else if (!this.containerReused) {
            context.clearRect(0, 0, width, height);
        }
        if (layerExtent) {
            this.clipUnrotated(context, frameState, layerExtent);
        }
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_4__["assign"])(context, tileSource.getContextOptions());
        this.preRender(context, frameState);
        this.renderedTiles.length = 0;
        /** @type {Array<number>} */
        var zs = Object.keys(tilesToDrawByZ).map(Number);
        zs.sort(_array_js__WEBPACK_IMPORTED_MODULE_8__["numberSafeCompareFunction"]);
        var clips, clipZs, currentClip;
        if (layerState.opacity === 1 &&
            (!this.containerReused ||
                tileSource.getOpaque(frameState.viewState.projection))) {
            zs = zs.reverse();
        }
        else {
            clips = [];
            clipZs = [];
        }
        for (var i = zs.length - 1; i >= 0; --i) {
            var currentZ = zs[i];
            var currentTilePixelSize = tileSource.getTilePixelSize(currentZ, pixelRatio, projection);
            var currentResolution = tileGrid.getResolution(currentZ);
            var currentScale = currentResolution / tileResolution;
            var dx_1 = currentTilePixelSize[0] * currentScale * canvasScale;
            var dy_1 = currentTilePixelSize[1] * currentScale * canvasScale;
            var originTileCoord = tileGrid.getTileCoordForCoordAndZ(Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["getTopLeft"])(canvasExtent), currentZ);
            var originTileExtent = tileGrid.getTileCoordExtent(originTileCoord);
            var origin_1 = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(this.tempTransform, [
                (tilePixelRatio * (originTileExtent[0] - canvasExtent[0])) /
                    tileResolution,
                (tilePixelRatio * (canvasExtent[3] - originTileExtent[3])) /
                    tileResolution,
            ]);
            var tileGutter = tilePixelRatio * tileSource.getGutterForProjection(projection);
            var tilesToDraw = tilesToDrawByZ[currentZ];
            for (var tileCoordKey in tilesToDraw) {
                var tile = /** @type {import("../../ImageTile.js").default} */ (tilesToDraw[tileCoordKey]);
                var tileCoord = tile.tileCoord;
                // Calculate integer positions and sizes so that tiles align
                var xIndex = originTileCoord[1] - tileCoord[1];
                var nextX = Math.round(origin_1[0] - (xIndex - 1) * dx_1);
                var yIndex = originTileCoord[2] - tileCoord[2];
                var nextY = Math.round(origin_1[1] - (yIndex - 1) * dy_1);
                var x = Math.round(origin_1[0] - xIndex * dx_1);
                var y = Math.round(origin_1[1] - yIndex * dy_1);
                var w = nextX - x;
                var h = nextY - y;
                var transition = z === currentZ;
                var inTransition = transition && tile.getAlpha(Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(this), frameState.time) !== 1;
                if (!inTransition) {
                    if (clips) {
                        // Clip mask for regions in this tile that already filled by a higher z tile
                        context.save();
                        currentClip = [x, y, x + w, y, x + w, y + h, x, y + h];
                        for (var i_1 = 0, ii = clips.length; i_1 < ii; ++i_1) {
                            if (z !== currentZ && currentZ < clipZs[i_1]) {
                                var clip = clips[i_1];
                                context.beginPath();
                                // counter-clockwise (outer ring) for current tile
                                context.moveTo(currentClip[0], currentClip[1]);
                                context.lineTo(currentClip[2], currentClip[3]);
                                context.lineTo(currentClip[4], currentClip[5]);
                                context.lineTo(currentClip[6], currentClip[7]);
                                // clockwise (inner ring) for higher z tile
                                context.moveTo(clip[6], clip[7]);
                                context.lineTo(clip[4], clip[5]);
                                context.lineTo(clip[2], clip[3]);
                                context.lineTo(clip[0], clip[1]);
                                context.clip();
                            }
                        }
                        clips.push(currentClip);
                        clipZs.push(currentZ);
                    }
                    else {
                        context.clearRect(x, y, w, h);
                    }
                }
                this.drawTileImage(tile, frameState, x, y, w, h, tileGutter, transition, layerState.opacity);
                if (clips && !inTransition) {
                    context.restore();
                    this.renderedTiles.unshift(tile);
                }
                else {
                    this.renderedTiles.push(tile);
                }
                this.updateUsedTiles(frameState.usedTiles, tileSource, tile);
            }
        }
        this.renderedRevision = sourceRevision;
        this.renderedResolution = tileResolution;
        this.extentChanged =
            !this.renderedExtent_ || !Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["equals"])(this.renderedExtent_, canvasExtent);
        this.renderedExtent_ = canvasExtent;
        this.renderedPixelRatio = pixelRatio;
        this.renderedProjection = projection;
        this.manageTilePyramid(frameState, tileSource, tileGrid, pixelRatio, projection, extent, z, tileLayer.getPreload());
        this.scheduleExpireCache(frameState, tileSource);
        this.postRender(context, frameState);
        if (layerState.extent) {
            context.restore();
        }
        if (canvasTransform !== canvas.style.transform) {
            canvas.style.transform = canvasTransform;
        }
        return this.container;
    };
    /**
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} x Left of the tile.
     * @param {number} y Top of the tile.
     * @param {number} w Width of the tile.
     * @param {number} h Height of the tile.
     * @param {number} gutter Tile gutter.
     * @param {boolean} transition Apply an alpha transition.
     * @param {number} opacity Opacity.
     */
    CanvasTileLayerRenderer.prototype.drawTileImage = function (tile, frameState, x, y, w, h, gutter, transition, opacity) {
        var image = this.getTileImage(tile);
        if (!image) {
            return;
        }
        var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(this);
        var tileAlpha = transition ? tile.getAlpha(uid, frameState.time) : 1;
        var alpha = opacity * tileAlpha;
        var alphaChanged = alpha !== this.context.globalAlpha;
        if (alphaChanged) {
            this.context.save();
            this.context.globalAlpha = alpha;
        }
        this.context.drawImage(image, gutter, gutter, image.width - 2 * gutter, image.height - 2 * gutter, x, y, w, h);
        if (alphaChanged) {
            this.context.restore();
        }
        if (tileAlpha !== 1) {
            frameState.animate = true;
        }
        else if (transition) {
            tile.endTransition(uid);
        }
    };
    /**
     * @return {HTMLCanvasElement} Image
     */
    CanvasTileLayerRenderer.prototype.getImage = function () {
        var context = this.context;
        return context ? context.canvas : null;
    };
    /**
     * Get the image from a tile.
     * @param {import("../../ImageTile.js").default} tile Tile.
     * @return {HTMLCanvasElement|HTMLImageElement|HTMLVideoElement} Image.
     * @protected
     */
    CanvasTileLayerRenderer.prototype.getTileImage = function (tile) {
        return tile.getImage();
    };
    /**
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @protected
     */
    CanvasTileLayerRenderer.prototype.scheduleExpireCache = function (frameState, tileSource) {
        if (tileSource.canExpireCache()) {
            /**
             * @param {import("../../source/Tile.js").default} tileSource Tile source.
             * @param {import("../../PluggableMap.js").default} map Map.
             * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
             */
            var postRenderFunction = function (tileSource, map, frameState) {
                var tileSourceKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(tileSource);
                if (tileSourceKey in frameState.usedTiles) {
                    tileSource.expireCache(frameState.viewState.projection, frameState.usedTiles[tileSourceKey]);
                }
            }.bind(null, tileSource);
            frameState.postRenderFunctions.push(
            /** @type {import("../../PluggableMap.js").PostRenderFunction} */ (postRenderFunction));
        }
    };
    /**
     * @param {!Object<string, !Object<string, boolean>>} usedTiles Used tiles.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import('../../Tile.js').default} tile Tile.
     * @protected
     */
    CanvasTileLayerRenderer.prototype.updateUsedTiles = function (usedTiles, tileSource, tile) {
        // FIXME should we use tilesToDrawByZ instead?
        var tileSourceKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(tileSource);
        if (!(tileSourceKey in usedTiles)) {
            usedTiles[tileSourceKey] = {};
        }
        usedTiles[tileSourceKey][tile.getKey()] = true;
    };
    /**
     * Manage tile pyramid.
     * This function performs a number of functions related to the tiles at the
     * current zoom and lower zoom levels:
     * - registers idle tiles in frameState.wantedTiles so that they are not
     *   discarded by the tile queue
     * - enqueues missing tiles
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../../source/Tile.js").default} tileSource Tile source.
     * @param {import("../../tilegrid/TileGrid.js").default} tileGrid Tile grid.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection.js").default} projection Projection.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {number} currentZ Current Z.
     * @param {number} preload Load low resolution tiles up to 'preload' levels.
     * @param {function(import("../../Tile.js").default):void} [opt_tileCallback] Tile callback.
     * @protected
     */
    CanvasTileLayerRenderer.prototype.manageTilePyramid = function (frameState, tileSource, tileGrid, pixelRatio, projection, extent, currentZ, preload, opt_tileCallback) {
        var tileSourceKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_7__["getUid"])(tileSource);
        if (!(tileSourceKey in frameState.wantedTiles)) {
            frameState.wantedTiles[tileSourceKey] = {};
        }
        var wantedTiles = frameState.wantedTiles[tileSourceKey];
        var tileQueue = frameState.tileQueue;
        var minZoom = tileGrid.getMinZoom();
        var tileCount = 0;
        var tile, tileRange, tileResolution, x, y, z;
        for (z = minZoom; z <= currentZ; ++z) {
            tileRange = tileGrid.getTileRangeForExtentAndZ(extent, z, tileRange);
            tileResolution = tileGrid.getResolution(z);
            for (x = tileRange.minX; x <= tileRange.maxX; ++x) {
                for (y = tileRange.minY; y <= tileRange.maxY; ++y) {
                    if (currentZ - z <= preload) {
                        ++tileCount;
                        tile = tileSource.getTile(z, x, y, pixelRatio, projection);
                        if (tile.getState() == _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE) {
                            wantedTiles[tile.getKey()] = true;
                            if (!tileQueue.isKeyQueued(tile.getKey())) {
                                tileQueue.enqueue([
                                    tile,
                                    tileSourceKey,
                                    tileGrid.getTileCoordCenter(tile.tileCoord),
                                    tileResolution,
                                ]);
                            }
                        }
                        if (opt_tileCallback !== undefined) {
                            opt_tileCallback(tile);
                        }
                    }
                    else {
                        tileSource.useTile(z, x, y, projection);
                    }
                }
            }
        }
        tileSource.updateCacheSize(tileCount, projection);
    };
    return CanvasTileLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @function
 * @return {import("../../layer/Tile.js").default|import("../../layer/VectorTile.js").default}
 */
CanvasTileLayerRenderer.prototype.getLayer;
/* harmony default export */ __webpack_exports__["default"] = (CanvasTileLayerRenderer);
//# sourceMappingURL=TileLayer.js.map

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTilePriority", function() { return getTilePriority; });
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _structs_PriorityQueue_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(145);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/TileQueue
 */



/**
 * @typedef {function(import("./Tile.js").default, string, import("./coordinate.js").Coordinate, number): number} PriorityFunction
 */
var TileQueue = /** @class */ (function (_super) {
    __extends(TileQueue, _super);
    /**
     * @param {PriorityFunction} tilePriorityFunction Tile priority function.
     * @param {function(): ?} tileChangeCallback Function called on each tile change event.
     */
    function TileQueue(tilePriorityFunction, tileChangeCallback) {
        var _this = _super.call(this, 
        /**
         * @param {Array} element Element.
         * @return {number} Priority.
         */
        function (element) {
            return tilePriorityFunction.apply(null, element);
        }, 
        /**
         * @param {Array} element Element.
         * @return {string} Key.
         */
        function (element) {
            return /** @type {import("./Tile.js").default} */ (element[0]).getKey();
        }) || this;
        /** @private */
        _this.boundHandleTileChange_ = _this.handleTileChange.bind(_this);
        /**
         * @private
         * @type {function(): ?}
         */
        _this.tileChangeCallback_ = tileChangeCallback;
        /**
         * @private
         * @type {number}
         */
        _this.tilesLoading_ = 0;
        /**
         * @private
         * @type {!Object<string,boolean>}
         */
        _this.tilesLoadingKeys_ = {};
        return _this;
    }
    /**
     * @param {Array} element Element.
     * @return {boolean} The element was added to the queue.
     */
    TileQueue.prototype.enqueue = function (element) {
        var added = _super.prototype.enqueue.call(this, element);
        if (added) {
            var tile = element[0];
            tile.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.boundHandleTileChange_);
        }
        return added;
    };
    /**
     * @return {number} Number of tiles loading.
     */
    TileQueue.prototype.getTilesLoading = function () {
        return this.tilesLoading_;
    };
    /**
     * @param {import("./events/Event.js").default} event Event.
     * @protected
     */
    TileQueue.prototype.handleTileChange = function (event) {
        var tile = /** @type {import("./Tile.js").default} */ (event.target);
        var state = tile.getState();
        if (state === _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED ||
            state === _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR ||
            state === _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].EMPTY) {
            tile.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.boundHandleTileChange_);
            var tileKey = tile.getKey();
            if (tileKey in this.tilesLoadingKeys_) {
                delete this.tilesLoadingKeys_[tileKey];
                --this.tilesLoading_;
            }
            this.tileChangeCallback_();
        }
    };
    /**
     * @param {number} maxTotalLoading Maximum number tiles to load simultaneously.
     * @param {number} maxNewLoads Maximum number of new tiles to load.
     */
    TileQueue.prototype.loadMoreTiles = function (maxTotalLoading, maxNewLoads) {
        var newLoads = 0;
        var state, tile, tileKey;
        while (this.tilesLoading_ < maxTotalLoading &&
            newLoads < maxNewLoads &&
            this.getCount() > 0) {
            tile = /** @type {import("./Tile.js").default} */ (this.dequeue()[0]);
            tileKey = tile.getKey();
            state = tile.getState();
            if (state === _TileState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE && !(tileKey in this.tilesLoadingKeys_)) {
                this.tilesLoadingKeys_[tileKey] = true;
                ++this.tilesLoading_;
                ++newLoads;
                tile.load();
            }
        }
    };
    return TileQueue;
}(_structs_PriorityQueue_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileQueue);
/**
 * @param {import('./PluggableMap.js').FrameState} frameState Frame state.
 * @param {import("./Tile.js").default} tile Tile.
 * @param {string} tileSourceKey Tile source key.
 * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
 * @param {number} tileResolution Tile resolution.
 * @return {number} Tile priority.
 */
function getTilePriority(frameState, tile, tileSourceKey, tileCenter, tileResolution) {
    // Filter out tiles at higher zoom levels than the current zoom level, or that
    // are outside the visible extent.
    if (!frameState || !(tileSourceKey in frameState.wantedTiles)) {
        return _structs_PriorityQueue_js__WEBPACK_IMPORTED_MODULE_1__["DROP"];
    }
    if (!frameState.wantedTiles[tileSourceKey][tile.getKey()]) {
        return _structs_PriorityQueue_js__WEBPACK_IMPORTED_MODULE_1__["DROP"];
    }
    // Prioritize the highest zoom level tiles closest to the focus.
    // Tiles at higher zoom levels are prioritized using Math.log(tileResolution).
    // Within a zoom level, tiles are prioritized by the distance in pixels between
    // the center of the tile and the center of the viewport.  The factor of 65536
    // means that the prioritization should behave as desired for tiles up to
    // 65536 * Math.log(2) = 45426 pixels from the focus.
    var center = frameState.viewState.center;
    var deltaX = tileCenter[0] - center[0];
    var deltaY = tileCenter[1] - center[1];
    return (65536 * Math.log(tileResolution) +
        Math.sqrt(deltaX * deltaX + deltaY * deltaY) / tileResolution);
}
//# sourceMappingURL=TileQueue.js.map

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DROP", function() { return DROP; });
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15);
/**
 * @module ol/structs/PriorityQueue
 */


/**
 * @type {number}
 */
var DROP = Infinity;
/**
 * @classdesc
 * Priority queue.
 *
 * The implementation is inspired from the Closure Library's Heap class and
 * Python's heapq module.
 *
 * See https://github.com/google/closure-library/blob/master/closure/goog/structs/heap.js
 * and https://hg.python.org/cpython/file/2.7/Lib/heapq.py.
 *
 * @template T
 */
var PriorityQueue = /** @class */ (function () {
    /**
     * @param {function(T): number} priorityFunction Priority function.
     * @param {function(T): string} keyFunction Key function.
     */
    function PriorityQueue(priorityFunction, keyFunction) {
        /**
         * @type {function(T): number}
         * @private
         */
        this.priorityFunction_ = priorityFunction;
        /**
         * @type {function(T): string}
         * @private
         */
        this.keyFunction_ = keyFunction;
        /**
         * @type {Array<T>}
         * @private
         */
        this.elements_ = [];
        /**
         * @type {Array<number>}
         * @private
         */
        this.priorities_ = [];
        /**
         * @type {!Object<string, boolean>}
         * @private
         */
        this.queuedElements_ = {};
    }
    /**
     * FIXME empty description for jsdoc
     */
    PriorityQueue.prototype.clear = function () {
        this.elements_.length = 0;
        this.priorities_.length = 0;
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_1__["clear"])(this.queuedElements_);
    };
    /**
     * Remove and return the highest-priority element. O(log N).
     * @return {T} Element.
     */
    PriorityQueue.prototype.dequeue = function () {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[0];
        if (elements.length == 1) {
            elements.length = 0;
            priorities.length = 0;
        }
        else {
            elements[0] = elements.pop();
            priorities[0] = priorities.pop();
            this.siftUp_(0);
        }
        var elementKey = this.keyFunction_(element);
        delete this.queuedElements_[elementKey];
        return element;
    };
    /**
     * Enqueue an element. O(log N).
     * @param {T} element Element.
     * @return {boolean} The element was added to the queue.
     */
    PriorityQueue.prototype.enqueue = function (element) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_0__["assert"])(!(this.keyFunction_(element) in this.queuedElements_), 31); // Tried to enqueue an `element` that was already added to the queue
        var priority = this.priorityFunction_(element);
        if (priority != DROP) {
            this.elements_.push(element);
            this.priorities_.push(priority);
            this.queuedElements_[this.keyFunction_(element)] = true;
            this.siftDown_(0, this.elements_.length - 1);
            return true;
        }
        return false;
    };
    /**
     * @return {number} Count.
     */
    PriorityQueue.prototype.getCount = function () {
        return this.elements_.length;
    };
    /**
     * Gets the index of the left child of the node at the given index.
     * @param {number} index The index of the node to get the left child for.
     * @return {number} The index of the left child.
     * @private
     */
    PriorityQueue.prototype.getLeftChildIndex_ = function (index) {
        return index * 2 + 1;
    };
    /**
     * Gets the index of the right child of the node at the given index.
     * @param {number} index The index of the node to get the right child for.
     * @return {number} The index of the right child.
     * @private
     */
    PriorityQueue.prototype.getRightChildIndex_ = function (index) {
        return index * 2 + 2;
    };
    /**
     * Gets the index of the parent of the node at the given index.
     * @param {number} index The index of the node to get the parent for.
     * @return {number} The index of the parent.
     * @private
     */
    PriorityQueue.prototype.getParentIndex_ = function (index) {
        return (index - 1) >> 1;
    };
    /**
     * Make this a heap. O(N).
     * @private
     */
    PriorityQueue.prototype.heapify_ = function () {
        var i;
        for (i = (this.elements_.length >> 1) - 1; i >= 0; i--) {
            this.siftUp_(i);
        }
    };
    /**
     * @return {boolean} Is empty.
     */
    PriorityQueue.prototype.isEmpty = function () {
        return this.elements_.length === 0;
    };
    /**
     * @param {string} key Key.
     * @return {boolean} Is key queued.
     */
    PriorityQueue.prototype.isKeyQueued = function (key) {
        return key in this.queuedElements_;
    };
    /**
     * @param {T} element Element.
     * @return {boolean} Is queued.
     */
    PriorityQueue.prototype.isQueued = function (element) {
        return this.isKeyQueued(this.keyFunction_(element));
    };
    /**
     * @param {number} index The index of the node to move down.
     * @private
     */
    PriorityQueue.prototype.siftUp_ = function (index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var count = elements.length;
        var element = elements[index];
        var priority = priorities[index];
        var startIndex = index;
        while (index < count >> 1) {
            var lIndex = this.getLeftChildIndex_(index);
            var rIndex = this.getRightChildIndex_(index);
            var smallerChildIndex = rIndex < count && priorities[rIndex] < priorities[lIndex]
                ? rIndex
                : lIndex;
            elements[index] = elements[smallerChildIndex];
            priorities[index] = priorities[smallerChildIndex];
            index = smallerChildIndex;
        }
        elements[index] = element;
        priorities[index] = priority;
        this.siftDown_(startIndex, index);
    };
    /**
     * @param {number} startIndex The index of the root.
     * @param {number} index The index of the node to move up.
     * @private
     */
    PriorityQueue.prototype.siftDown_ = function (startIndex, index) {
        var elements = this.elements_;
        var priorities = this.priorities_;
        var element = elements[index];
        var priority = priorities[index];
        while (index > startIndex) {
            var parentIndex = this.getParentIndex_(index);
            if (priorities[parentIndex] > priority) {
                elements[index] = elements[parentIndex];
                priorities[index] = priorities[parentIndex];
                index = parentIndex;
            }
            else {
                break;
            }
        }
        elements[index] = element;
        priorities[index] = priority;
    };
    /**
     * FIXME empty description for jsdoc
     */
    PriorityQueue.prototype.reprioritize = function () {
        var priorityFunction = this.priorityFunction_;
        var elements = this.elements_;
        var priorities = this.priorities_;
        var index = 0;
        var n = elements.length;
        var element, i, priority;
        for (i = 0; i < n; ++i) {
            element = elements[i];
            priority = priorityFunction(element);
            if (priority == DROP) {
                delete this.queuedElements_[this.keyFunction_(element)];
            }
            else {
                priorities[index] = priority;
                elements[index++] = element;
            }
        }
        elements.length = index;
        priorities.length = index;
        this.heapify_();
    };
    return PriorityQueue;
}());
/* harmony default export */ __webpack_exports__["default"] = (PriorityQueue);
//# sourceMappingURL=PriorityQueue.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _XYZ_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95);
/* harmony import */ var _OSM_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(127);
/**
 * @module ol/source/Stamen
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * @const
 * @type {Array<string>}
 */
var ATTRIBUTIONS = [
    'Map tiles by <a href="https://stamen.com/" target="_blank">Stamen Design</a>, ' +
        'under <a href="https://creativecommons.org/licenses/by/3.0/" target="_blank">CC BY' +
        ' 3.0</a>.',
    _OSM_js__WEBPACK_IMPORTED_MODULE_1__["ATTRIBUTION"],
];
/**
 * @type {Object<string, {extension: string, opaque: boolean}>}
 */
var LayerConfig = {
    'terrain': {
        extension: 'jpg',
        opaque: true,
    },
    'terrain-background': {
        extension: 'jpg',
        opaque: true,
    },
    'terrain-labels': {
        extension: 'png',
        opaque: false,
    },
    'terrain-lines': {
        extension: 'png',
        opaque: false,
    },
    'toner-background': {
        extension: 'png',
        opaque: true,
    },
    'toner': {
        extension: 'png',
        opaque: true,
    },
    'toner-hybrid': {
        extension: 'png',
        opaque: false,
    },
    'toner-labels': {
        extension: 'png',
        opaque: false,
    },
    'toner-lines': {
        extension: 'png',
        opaque: false,
    },
    'toner-lite': {
        extension: 'png',
        opaque: true,
    },
    'watercolor': {
        extension: 'jpg',
        opaque: true,
    },
};
/**
 * @type {Object<string, {minZoom: number, maxZoom: number}>}
 */
var ProviderConfig = {
    'terrain': {
        minZoom: 0,
        maxZoom: 18,
    },
    'toner': {
        minZoom: 0,
        maxZoom: 20,
    },
    'watercolor': {
        minZoom: 0,
        maxZoom: 18,
    },
};
/**
 * @typedef {Object} Options
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {string} layer Layer name.
 * @property {number} [minZoom] Minimum zoom.
 * @property {number} [maxZoom] Maximum zoom.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
 * Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number} [transition=250] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for the Stamen tile server.
 * @api
 */
var Stamen = /** @class */ (function (_super) {
    __extends(Stamen, _super);
    /**
     * @param {Options} options Stamen options.
     */
    function Stamen(options) {
        var _this = this;
        var i = options.layer.indexOf('-');
        var provider = i == -1 ? options.layer : options.layer.slice(0, i);
        var providerConfig = ProviderConfig[provider];
        var layerConfig = LayerConfig[options.layer];
        var url = options.url !== undefined
            ? options.url
            : 'https://stamen-tiles-{a-d}.a.ssl.fastly.net/' +
                options.layer +
                '/{z}/{x}/{y}.' +
                layerConfig.extension;
        _this = _super.call(this, {
            attributions: ATTRIBUTIONS,
            cacheSize: options.cacheSize,
            crossOrigin: 'anonymous',
            imageSmoothing: options.imageSmoothing,
            maxZoom: options.maxZoom != undefined ? options.maxZoom : providerConfig.maxZoom,
            minZoom: options.minZoom != undefined ? options.minZoom : providerConfig.minZoom,
            opaque: layerConfig.opaque,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileLoadFunction: options.tileLoadFunction,
            transition: options.transition,
            url: url,
            wrapX: options.wrapX,
            zDirection: options.zDirection,
        }) || this;
        return _this;
    }
    return Stamen;
}(_XYZ_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Stamen);
//# sourceMappingURL=Stamen.js.map

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(120);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83);
/**
 * @module ol/source/TileArcGISRest
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {Object<string,*>} [params] ArcGIS Rest parameters. This field is optional. Service defaults will be
 * used for any fields not specified. `FORMAT` is `PNG32` by default. `F` is `IMAGE` by
 * default. `TRANSPARENT` is `true` by default.  `BBOX`, `SIZE`, `BBOXSR`,
 * and `IMAGESR` will be set dynamically. Set `LAYERS` to
 * override the default service layer visibility. See
 * https://developers.arcgis.com/rest/services-reference/export-map.htm
 * for further reference.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * The projection code must contain a numeric end portion separated by :
 * or the entire code must form a valid ArcGIS SpatialReference definition.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL.
 * The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] ArcGIS Rest service URL for a Map Service or Image Service. The
 * url should include /MapServer or /ImageServer.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.  To disable the opacity
 * transition, pass `transition: 0`.
 * @property {Array<string>} [urls] ArcGIS Rest service urls. Use this instead of `url` when the ArcGIS
 * Service supports multiple urls for export requests.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data from ArcGIS Rest services. Map and Image
 * Services are supported.
 *
 * For cached ArcGIS services, better performance is available using the
 * {@link module:ol/source/XYZ~XYZ} data source.
 * @api
 */
var TileArcGISRest = /** @class */ (function (_super) {
    __extends(TileArcGISRest, _super);
    /**
     * @param {Options} [opt_options] Tile ArcGIS Rest options.
     */
    function TileArcGISRest(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {!Object}
         */
        _this.params_ = options.params || {};
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.tmpExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["createEmpty"])();
        _this.setKey(_this.getKeyForParams_());
        return _this;
    }
    /**
     * @private
     * @return {string} The key for the current params.
     */
    TileArcGISRest.prototype.getKeyForParams_ = function () {
        var i = 0;
        var res = [];
        for (var key in this.params_) {
            res[i++] = key + '-' + this.params_[key];
        }
        return res.join('/');
    };
    /**
     * Get the user-provided params, i.e. those passed to the constructor through
     * the "params" option, and possibly updated using the updateParams method.
     * @return {Object} Params.
     * @api
     */
    TileArcGISRest.prototype.getParams = function () {
        return this.params_;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../size.js").Size} tileSize Tile size.
     * @param {import("../extent.js").Extent} tileExtent Tile extent.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {Object} params Params.
     * @return {string|undefined} Request URL.
     * @private
     */
    TileArcGISRest.prototype.getRequestUrl_ = function (tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
        var urls = this.urls;
        if (!urls) {
            return undefined;
        }
        // ArcGIS Server only wants the numeric portion of the projection ID.
        // (if there is no numeric portion the entire projection code must
        // form a valid ArcGIS SpatialReference definition).
        var srid = projection
            .getCode()
            .split(/:(?=\d+$)/)
            .pop();
        params['SIZE'] = tileSize[0] + ',' + tileSize[1];
        params['BBOX'] = tileExtent.join(',');
        params['BBOXSR'] = srid;
        params['IMAGESR'] = srid;
        params['DPI'] = Math.round(params['DPI'] ? params['DPI'] * pixelRatio : 90 * pixelRatio);
        var url;
        if (urls.length == 1) {
            url = urls[0];
        }
        else {
            var index = Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["modulo"])(Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_6__["hash"])(tileCoord), urls.length);
            url = urls[index];
        }
        var modifiedUrl = url
            .replace(/MapServer\/?$/, 'MapServer/export')
            .replace(/ImageServer\/?$/, 'ImageServer/exportImage');
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_1__["appendParams"])(modifiedUrl, params);
    };
    /**
     * Get the tile pixel ratio for this source.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */
    TileArcGISRest.prototype.getTilePixelRatio = function (pixelRatio) {
        return this.hidpi_ ? pixelRatio : 1;
    };
    /**
     * Update the user-provided params.
     * @param {Object} params Params.
     * @api
     */
    TileArcGISRest.prototype.updateParams = function (params) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])(this.params_, params);
        this.setKey(this.getKeyForParams_());
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
     * @param {number} pixelRatio The pixel ratio
     * @param {import("../proj/Projection.js").default} projection The projection
     * @return {string|undefined} The tile URL
     * @override
     */
    TileArcGISRest.prototype.tileUrlFunction = function (tileCoord, pixelRatio, projection) {
        var tileGrid = this.getTileGrid();
        if (!tileGrid) {
            tileGrid = this.getTileGridForProjection(projection);
        }
        if (tileGrid.getResolutions().length <= tileCoord[0]) {
            return undefined;
        }
        if (pixelRatio != 1 && !this.hidpi_) {
            pixelRatio = 1;
        }
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_5__["toSize"])(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
        if (pixelRatio != 1) {
            tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_5__["scale"])(tileSize, pixelRatio, this.tmpSize);
        }
        // Apply default params and override with user specified values.
        var baseParams = {
            'F': 'image',
            'FORMAT': 'PNG32',
            'TRANSPARENT': true,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])(baseParams, this.params_);
        return this.getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, baseParams);
    };
    return TileArcGISRest;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileArcGISRest);
//# sourceMappingURL=TileArcGISRest.js.map

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _XYZ_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39);
/**
 * @module ol/source/TileDebug
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @typedef {Object} Options
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Optional projection.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Set to `1` when debugging `VectorTile` sources with a default configuration.
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 * @property {string} [template='z:{z} x:{x} y:{y}'] Template for labeling the tiles.
 * Should include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 */
/**
 * @classdesc
 * A pseudo tile source, which does not fetch tiles from a server, but renders
 * a grid outline for the tile grid/projection along with the coordinates for
 * each tile. See examples/canvas-tiles for an example.
 * @api
 */
var TileDebug = /** @class */ (function (_super) {
    __extends(TileDebug, _super);
    /**
     * @param {Options} [opt_options] Debug tile options.
     */
    function TileDebug(opt_options) {
        var _this = this;
        /**
         * @type {Options}
         */
        var options = opt_options || {};
        _this = _super.call(this, {
            opaque: false,
            projection: options.projection,
            tileGrid: options.tileGrid,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            zDirection: options.zDirection,
            url: options.template || 'z:{z} x:{x} y:{y}',
            tileLoadFunction: function (tile, text) {
                var z = tile.getTileCoord()[0];
                var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_2__["toSize"])(_this.tileGrid.getTileSize(z));
                var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_1__["createCanvasContext2D"])(tileSize[0], tileSize[1]);
                context.strokeStyle = 'grey';
                context.strokeRect(0.5, 0.5, tileSize[0] + 0.5, tileSize[1] + 0.5);
                context.fillStyle = 'grey';
                context.strokeStyle = 'white';
                context.textAlign = 'center';
                context.textBaseline = 'middle';
                context.font = '24px sans-serif';
                context.lineWidth = 4;
                context.strokeText(text, tileSize[0] / 2, tileSize[1] / 2, tileSize[0]);
                context.fillText(text, tileSize[0] / 2, tileSize[1] / 2, tileSize[0]);
                /** @type {import("../ImageTile.js").default} */ (tile).setImage(context.canvas);
            },
        }) || this;
        return _this;
    }
    return TileDebug;
}(_XYZ_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileDebug);
//# sourceMappingURL=TileDebug.js.map

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _net_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93);
/**
 * @module ol/source/TileJSON
 */
// FIXME check order of async callbacks
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * See https://mapbox.com/developers/api/.
 */








/**
 * @typedef {Object} Config
 * @property {string} [name] The name.
 * @property {string} [description] The description.
 * @property {string} [version] The version.
 * @property {string} [attribution] The attribution.
 * @property {string} [template] The template.
 * @property {string} [legend] The legend.
 * @property {string} [scheme] The scheme.
 * @property {Array<string>} tiles The tile URL templates.
 * @property {Array<string>} [grids] Optional grids.
 * @property {number} [minzoom] Minimum zoom level.
 * @property {number} [maxzoom] Maximum zoom level.
 * @property {Array<number>} [bounds] Optional bounds.
 * @property {Array<number>} [center] Optional center.
 */
/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
 * Useful when the server does not support CORS..
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {Config} [tileJSON] TileJSON configuration for this source.
 * If not provided, `url` must be configured.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {number|import("../size.js").Size} [tileSize=[256, 256]] The tile size used by the tile service.
 * Note: `tileSize` and other non-standard TileJSON properties are currently ignored.
 * @property {string} [url] URL to the TileJSON file. If not provided, `tileJSON` must be configured.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data in TileJSON format.
 * @api
 */
var TileJSON = /** @class */ (function (_super) {
    __extends(TileJSON, _super);
    /**
     * @param {Options} options TileJSON options.
     */
    function TileJSON(options) {
        var _this = _super.call(this, {
            attributions: options.attributions,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            projection: Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["get"])('EPSG:3857'),
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            state: _State_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOADING,
            tileLoadFunction: options.tileLoadFunction,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @type {Config}
         * @private
         */
        _this.tileJSON_ = null;
        /**
         * @type {number|import("../size.js").Size}
         * @private
         */
        _this.tileSize_ = options.tileSize;
        if (options.url) {
            if (options.jsonp) {
                Object(_net_js__WEBPACK_IMPORTED_MODULE_7__["jsonp"])(options.url, _this.handleTileJSONResponse.bind(_this), _this.handleTileJSONError.bind(_this));
            }
            else {
                var client = new XMLHttpRequest();
                client.addEventListener('load', _this.onXHRLoad_.bind(_this));
                client.addEventListener('error', _this.onXHRError_.bind(_this));
                client.open('GET', options.url);
                client.send();
            }
        }
        else if (options.tileJSON) {
            _this.handleTileJSONResponse(options.tileJSON);
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(false, 51); // Either `url` or `tileJSON` options must be provided
        }
        return _this;
    }
    /**
     * @private
     * @param {Event} event The load event.
     */
    TileJSON.prototype.onXHRLoad_ = function (event) {
        var client = /** @type {XMLHttpRequest} */ (event.target);
        // status will be 0 for file:// urls
        if (!client.status || (client.status >= 200 && client.status < 300)) {
            var response = void 0;
            try {
                response = /** @type {TileJSON} */ (JSON.parse(client.responseText));
            }
            catch (err) {
                this.handleTileJSONError();
                return;
            }
            this.handleTileJSONResponse(response);
        }
        else {
            this.handleTileJSONError();
        }
    };
    /**
     * @private
     * @param {Event} event The error event.
     */
    TileJSON.prototype.onXHRError_ = function (event) {
        this.handleTileJSONError();
    };
    /**
     * @return {Config} The tilejson object.
     * @api
     */
    TileJSON.prototype.getTileJSON = function () {
        return this.tileJSON_;
    };
    /**
     * @protected
     * @param {Config} tileJSON Tile JSON.
     */
    TileJSON.prototype.handleTileJSONResponse = function (tileJSON) {
        var epsg4326Projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["get"])('EPSG:4326');
        var sourceProjection = this.getProjection();
        var extent;
        if (tileJSON['bounds'] !== undefined) {
            var transform = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["getTransformFromProjections"])(epsg4326Projection, sourceProjection);
            extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["applyTransform"])(tileJSON['bounds'], transform);
        }
        var gridExtent = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_5__["extentFromProjection"])(sourceProjection);
        var minZoom = tileJSON['minzoom'] || 0;
        var maxZoom = tileJSON['maxzoom'] || 22;
        var tileGrid = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_5__["createXYZ"])({
            extent: gridExtent,
            maxZoom: maxZoom,
            minZoom: minZoom,
            tileSize: this.tileSize_,
        });
        this.tileGrid = tileGrid;
        this.tileUrlFunction = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_4__["createFromTemplates"])(tileJSON['tiles'], tileGrid);
        if (tileJSON['attribution'] !== undefined && !this.getAttributions()) {
            var attributionExtent_1 = extent !== undefined ? extent : gridExtent;
            this.setAttributions(function (frameState) {
                if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["intersects"])(attributionExtent_1, frameState.extent)) {
                    return [tileJSON['attribution']];
                }
                return null;
            });
        }
        this.tileJSON_ = tileJSON;
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].READY);
    };
    /**
     * @protected
     */
    TileJSON.prototype.handleTileJSONError = function () {
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_0__["default"].ERROR);
    };
    return TileJSON;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileJSON);
//# sourceMappingURL=TileJSON.js.map

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _common_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80);
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71);
/* harmony import */ var _WMSServerType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(126);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(120);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(39);
/* harmony import */ var _reproj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(25);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(11);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(83);
/**
 * @module ol/source/TileWMS
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {Object<string,*>} params WMS request parameters.
 * At least a `LAYERS` param is required. `STYLES` is
 * `''` by default. `VERSION` is `1.3.0` by default. `WIDTH`, `HEIGHT`, `BBOX`
 * and `CRS` (`SRS` for WMS version < 1.3.0) will be set dynamically.
 * @property {number} [gutter=0]
 * The size in pixels of the gutter around image tiles to ignore. By setting
 * this property to a non-zero value, images will be requested that are wider
 * and taller than the tile size by a value of `2 x gutter`.
 * Using a non-zero value allows artifacts of rendering at tile edges to be
 * ignored. If you control the WMS service it is recommended to address
 * "artifacts at tile edges" issues by properly configuring the WMS service. For
 * example, MapServer has a `tile_map_edge_buffer` configuration parameter for
 * this. See https://mapserver.org/output/tile_mode.html.
 * @property {boolean} [hidpi=true] Use the `ol/Map#pixelRatio` value when requesting
 * the image from the remote server.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {typeof import("../ImageTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid. Base this on the resolutions,
 * tilesize and extent supported by the server.
 * If this is not defined, a default grid will be used: if there is a projection
 * extent, the grid will be based on that; if not, a grid based on a global
 * extent with origin at 0,0 will be used..
 * @property {import("./WMSServerType.js").default|string} [serverType]
 * The type of the remote WMS server. Currently only used when `hidpi` is
 * `true`.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {string} [url] WMS service URL.
 * @property {Array<string>} [urls] WMS service urls.
 * Use this instead of `url` when the WMS supports multiple urls for GetMap requests.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When `true`, tiles will be requested for one world only,
 * but they will be wrapped horizontally to render multiple worlds.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data from WMS servers.
 * @api
 */
var TileWMS = /** @class */ (function (_super) {
    __extends(TileWMS, _super);
    /**
     * @param {Options} [opt_options] Tile WMS options.
     */
    function TileWMS(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : /** @type {Options} */ ({});
        var params = options.params || {};
        var transparent = 'TRANSPARENT' in params ? params['TRANSPARENT'] : true;
        _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            opaque: !transparent,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: options.tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : true,
            transition: options.transition,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {number}
         */
        _this.gutter_ = options.gutter !== undefined ? options.gutter : 0;
        /**
         * @private
         * @type {!Object}
         */
        _this.params_ = params;
        /**
         * @private
         * @type {boolean}
         */
        _this.v13_ = true;
        /**
         * @private
         * @type {import("./WMSServerType.js").default|undefined}
         */
        _this.serverType_ =
            /** @type {import("./WMSServerType.js").default|undefined} */ (options.serverType);
        /**
         * @private
         * @type {boolean}
         */
        _this.hidpi_ = options.hidpi !== undefined ? options.hidpi : true;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.tmpExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["createEmpty"])();
        _this.updateV13_();
        _this.setKey(_this.getKeyForParams_());
        return _this;
    }
    /**
     * Return the GetFeatureInfo URL for the passed coordinate, resolution, and
     * projection. Return `undefined` if the GetFeatureInfo URL cannot be
     * constructed.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {import("../proj.js").ProjectionLike} projection Projection.
     * @param {!Object} params GetFeatureInfo params. `INFO_FORMAT` at least should
     *     be provided. If `QUERY_LAYERS` is not provided then the layers specified
     *     in the `LAYERS` parameter will be used. `VERSION` should not be
     *     specified here.
     * @return {string|undefined} GetFeatureInfo URL.
     * @api
     */
    TileWMS.prototype.getFeatureInfoUrl = function (coordinate, resolution, projection, params) {
        var projectionObj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["get"])(projection);
        var sourceProjectionObj = this.getProjection();
        var tileGrid = this.getTileGrid();
        if (!tileGrid) {
            tileGrid = this.getTileGridForProjection(projectionObj);
        }
        var z = tileGrid.getZForResolution(resolution, this.zDirection);
        var tileCoord = tileGrid.getTileCoordForCoordAndZ(coordinate, z);
        if (tileGrid.getResolutions().length <= tileCoord[0]) {
            return undefined;
        }
        var tileResolution = tileGrid.getResolution(tileCoord[0]);
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
        var gutter = this.gutter_;
        if (gutter !== 0) {
            tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["buffer"])(tileSize, gutter, this.tmpSize);
            tileExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(tileExtent, tileResolution * gutter, tileExtent);
        }
        if (sourceProjectionObj && sourceProjectionObj !== projectionObj) {
            tileResolution = Object(_reproj_js__WEBPACK_IMPORTED_MODULE_8__["calculateSourceResolution"])(sourceProjectionObj, projectionObj, coordinate, tileResolution);
            tileExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["transformExtent"])(tileExtent, projectionObj, sourceProjectionObj);
            coordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["transform"])(coordinate, projectionObj, sourceProjectionObj);
        }
        var baseParams = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetFeatureInfo',
            'FORMAT': 'image/png',
            'TRANSPARENT': true,
            'QUERY_LAYERS': this.params_['LAYERS'],
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(baseParams, this.params_, params);
        var x = Math.floor((coordinate[0] - tileExtent[0]) / tileResolution);
        var y = Math.floor((tileExtent[3] - coordinate[1]) / tileResolution);
        baseParams[this.v13_ ? 'I' : 'X'] = x;
        baseParams[this.v13_ ? 'J' : 'Y'] = y;
        return this.getRequestUrl_(tileCoord, tileSize, tileExtent, 1, sourceProjectionObj || projectionObj, baseParams);
    };
    /**
     * Return the GetLegendGraphic URL, optionally optimized for the passed
     * resolution and possibly including any passed specific parameters. Returns
     * `undefined` if the GetLegendGraphic URL cannot be constructed.
     *
     * @param {number} [resolution] Resolution. If set to undefined, `SCALE`
     *     will not be calculated and included in URL.
     * @param {Object} [params] GetLegendGraphic params. If `LAYER` is set, the
     *     request is generated for this wms layer, else it will try to use the
     *     configured wms layer. Default `FORMAT` is `image/png`.
     *     `VERSION` should not be specified here.
     * @return {string|undefined} GetLegendGraphic URL.
     * @api
     */
    TileWMS.prototype.getLegendUrl = function (resolution, params) {
        if (this.urls[0] === undefined) {
            return undefined;
        }
        var baseParams = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetLegendGraphic',
            'FORMAT': 'image/png',
        };
        if (params === undefined || params['LAYER'] === undefined) {
            var layers = this.params_.LAYERS;
            var isSingleLayer = !Array.isArray(layers) || layers.length === 1;
            if (!isSingleLayer) {
                return undefined;
            }
            baseParams['LAYER'] = layers;
        }
        if (resolution !== undefined) {
            var mpu = this.getProjection()
                ? this.getProjection().getMetersPerUnit()
                : 1;
            var pixelSize = 0.00028;
            baseParams['SCALE'] = (resolution * mpu) / pixelSize;
        }
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(baseParams, params);
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_3__["appendParams"])(/** @type {string} */ (this.urls[0]), baseParams);
    };
    /**
     * @return {number} Gutter.
     */
    TileWMS.prototype.getGutter = function () {
        return this.gutter_;
    };
    /**
     * Get the user-provided params, i.e. those passed to the constructor through
     * the "params" option, and possibly updated using the updateParams method.
     * @return {Object} Params.
     * @api
     */
    TileWMS.prototype.getParams = function () {
        return this.params_;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../size.js").Size} tileSize Tile size.
     * @param {import("../extent.js").Extent} tileExtent Tile extent.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {Object} params Params.
     * @return {string|undefined} Request URL.
     * @private
     */
    TileWMS.prototype.getRequestUrl_ = function (tileCoord, tileSize, tileExtent, pixelRatio, projection, params) {
        var urls = this.urls;
        if (!urls) {
            return undefined;
        }
        params['WIDTH'] = tileSize[0];
        params['HEIGHT'] = tileSize[1];
        params[this.v13_ ? 'CRS' : 'SRS'] = projection.getCode();
        if (!('STYLES' in this.params_)) {
            params['STYLES'] = '';
        }
        if (pixelRatio != 1) {
            switch (this.serverType_) {
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_2__["default"].GEOSERVER:
                    var dpi = (90 * pixelRatio + 0.5) | 0;
                    if ('FORMAT_OPTIONS' in params) {
                        params['FORMAT_OPTIONS'] += ';dpi:' + dpi;
                    }
                    else {
                        params['FORMAT_OPTIONS'] = 'dpi:' + dpi;
                    }
                    break;
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MAPSERVER:
                    params['MAP_RESOLUTION'] = 90 * pixelRatio;
                    break;
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CARMENTA_SERVER:
                case _WMSServerType_js__WEBPACK_IMPORTED_MODULE_2__["default"].QGIS:
                    params['DPI'] = 90 * pixelRatio;
                    break;
                default:
                    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(false, 52); // Unknown `serverType` configured
                    break;
            }
        }
        var axisOrientation = projection.getAxisOrientation();
        var bbox = tileExtent;
        if (this.v13_ && axisOrientation.substr(0, 2) == 'ne') {
            var tmp = void 0;
            tmp = tileExtent[0];
            bbox[0] = tileExtent[1];
            bbox[1] = tmp;
            tmp = tileExtent[2];
            bbox[2] = tileExtent[3];
            bbox[3] = tmp;
        }
        params['BBOX'] = bbox.join(',');
        var url;
        if (urls.length == 1) {
            url = urls[0];
        }
        else {
            var index = Object(_math_js__WEBPACK_IMPORTED_MODULE_11__["modulo"])(Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_12__["hash"])(tileCoord), urls.length);
            url = urls[index];
        }
        return Object(_uri_js__WEBPACK_IMPORTED_MODULE_3__["appendParams"])(url, params);
    };
    /**
     * Get the tile pixel ratio for this source.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */
    TileWMS.prototype.getTilePixelRatio = function (pixelRatio) {
        return !this.hidpi_ || this.serverType_ === undefined ? 1 : pixelRatio;
    };
    /**
     * @private
     * @return {string} The key for the current params.
     */
    TileWMS.prototype.getKeyForParams_ = function () {
        var i = 0;
        var res = [];
        for (var key in this.params_) {
            res[i++] = key + '-' + this.params_[key];
        }
        return res.join('/');
    };
    /**
     * Update the user-provided params.
     * @param {Object} params Params.
     * @api
     */
    TileWMS.prototype.updateParams = function (params) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(this.params_, params);
        this.updateV13_();
        this.setKey(this.getKeyForParams_());
    };
    /**
     * @private
     */
    TileWMS.prototype.updateV13_ = function () {
        var version = this.params_['VERSION'] || _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"];
        this.v13_ = Object(_string_js__WEBPACK_IMPORTED_MODULE_9__["compareVersions"])(version, '1.3') >= 0;
    };
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord The tile coordinate
     * @param {number} pixelRatio The pixel ratio
     * @param {import("../proj/Projection.js").default} projection The projection
     * @return {string|undefined} The tile URL
     * @override
     */
    TileWMS.prototype.tileUrlFunction = function (tileCoord, pixelRatio, projection) {
        var tileGrid = this.getTileGrid();
        if (!tileGrid) {
            tileGrid = this.getTileGridForProjection(projection);
        }
        if (tileGrid.getResolutions().length <= tileCoord[0]) {
            return undefined;
        }
        if (pixelRatio != 1 && (!this.hidpi_ || this.serverType_ === undefined)) {
            pixelRatio = 1;
        }
        var tileResolution = tileGrid.getResolution(tileCoord[0]);
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent_);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["toSize"])(tileGrid.getTileSize(tileCoord[0]), this.tmpSize);
        var gutter = this.gutter_;
        if (gutter !== 0) {
            tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["buffer"])(tileSize, gutter, this.tmpSize);
            tileExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(tileExtent, tileResolution * gutter, tileExtent);
        }
        if (pixelRatio != 1) {
            tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_7__["scale"])(tileSize, pixelRatio, this.tmpSize);
        }
        var baseParams = {
            'SERVICE': 'WMS',
            'VERSION': _common_js__WEBPACK_IMPORTED_MODULE_0__["DEFAULT_WMS_VERSION"],
            'REQUEST': 'GetMap',
            'FORMAT': 'image/png',
            'TRANSPARENT': true,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])(baseParams, this.params_);
        return this.getRequestUrl_(tileCoord, tileSize, tileExtent, pixelRatio, projection, baseParams);
    };
    return TileWMS;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (TileWMS);
//# sourceMappingURL=TileWMS.js.map

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomTile", function() { return CustomTile; });
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _State_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(88);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(54);
/* harmony import */ var _net_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93);
/**
 * @module ol/source/UTFGrid
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();













/**
 * @typedef {Object} UTFGridJSON
 * @property {Array<string>} grid The grid.
 * @property {Array<string>} keys The keys.
 * @property {Object<string, Object>} [data] Optional data.
 */
var CustomTile = /** @class */ (function (_super) {
    __extends(CustomTile, _super);
    /**
     * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("../TileState.js").default} state State.
     * @param {string} src Image source URI.
     * @param {import("../extent.js").Extent} extent Extent of the tile.
     * @param {boolean} preemptive Load the tile when visible (before it's needed).
     * @param {boolean} jsonp Load the tile as a script.
     */
    function CustomTile(tileCoord, state, src, extent, preemptive, jsonp) {
        var _this = _super.call(this, tileCoord, state) || this;
        /**
         * @private
         * @type {string}
         */
        _this.src_ = src;
        /**
         * @private
         * @type {import("../extent.js").Extent}
         */
        _this.extent_ = extent;
        /**
         * @private
         * @type {boolean}
         */
        _this.preemptive_ = preemptive;
        /**
         * @private
         * @type {Array<string>}
         */
        _this.grid_ = null;
        /**
         * @private
         * @type {Array<string>}
         */
        _this.keys_ = null;
        /**
         * @private
         * @type {Object<string, Object>|undefined}
         */
        _this.data_ = null;
        /**
         * @private
         * @type {boolean}
         */
        _this.jsonp_ = jsonp;
        return _this;
    }
    /**
     * Get the image element for this tile.
     * @return {HTMLImageElement} Image.
     */
    CustomTile.prototype.getImage = function () {
        return null;
    };
    /**
     * Synchronously returns data at given coordinate (if available).
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {*} The data.
     */
    CustomTile.prototype.getData = function (coordinate) {
        if (!this.grid_ || !this.keys_) {
            return null;
        }
        var xRelative = (coordinate[0] - this.extent_[0]) / (this.extent_[2] - this.extent_[0]);
        var yRelative = (coordinate[1] - this.extent_[1]) / (this.extent_[3] - this.extent_[1]);
        var row = this.grid_[Math.floor((1 - yRelative) * this.grid_.length)];
        if (typeof row !== 'string') {
            return null;
        }
        var code = row.charCodeAt(Math.floor(xRelative * row.length));
        if (code >= 93) {
            code--;
        }
        if (code >= 35) {
            code--;
        }
        code -= 32;
        var data = null;
        if (code in this.keys_) {
            var id = this.keys_[code];
            if (this.data_ && id in this.data_) {
                data = this.data_[id];
            }
            else {
                data = id;
            }
        }
        return data;
    };
    /**
     * Calls the callback (synchronously by default) with the available data
     * for given coordinate (or `null` if not yet loaded).
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {function(*): void} callback Callback.
     * @param {boolean} [opt_request] If `true` the callback is always async.
     *                               The tile data is requested if not yet loaded.
     */
    CustomTile.prototype.forDataAtCoordinate = function (coordinate, callback, opt_request) {
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].EMPTY && opt_request === true) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].IDLE;
            Object(_events_js__WEBPACK_IMPORTED_MODULE_11__["listenOnce"])(this, _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, function (e) {
                callback(this.getData(coordinate));
            }, this);
            this.loadInternal_();
        }
        else {
            if (opt_request === true) {
                setTimeout(function () {
                    callback(this.getData(coordinate));
                }.bind(this), 0);
            }
            else {
                callback(this.getData(coordinate));
            }
        }
    };
    /**
     * Return the key to be used for all tiles in the source.
     * @return {string} The key for all tiles.
     */
    CustomTile.prototype.getKey = function () {
        return this.src_;
    };
    /**
     * @private
     */
    CustomTile.prototype.handleError_ = function () {
        this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].ERROR;
        this.changed();
    };
    /**
     * @param {!UTFGridJSON} json UTFGrid data.
     * @private
     */
    CustomTile.prototype.handleLoad_ = function (json) {
        this.grid_ = json['grid'];
        this.keys_ = json['keys'];
        this.data_ = json['data'];
        this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].LOADED;
        this.changed();
    };
    /**
     * @private
     */
    CustomTile.prototype.loadInternal_ = function () {
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].IDLE) {
            this.state = _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].LOADING;
            if (this.jsonp_) {
                Object(_net_js__WEBPACK_IMPORTED_MODULE_12__["jsonp"])(this.src_, this.handleLoad_.bind(this), this.handleError_.bind(this));
            }
            else {
                var client = new XMLHttpRequest();
                client.addEventListener('load', this.onXHRLoad_.bind(this));
                client.addEventListener('error', this.onXHRError_.bind(this));
                client.open('GET', this.src_);
                client.send();
            }
        }
    };
    /**
     * @private
     * @param {Event} event The load event.
     */
    CustomTile.prototype.onXHRLoad_ = function (event) {
        var client = /** @type {XMLHttpRequest} */ (event.target);
        // status will be 0 for file:// urls
        if (!client.status || (client.status >= 200 && client.status < 300)) {
            var response = void 0;
            try {
                response = /** @type {!UTFGridJSON} */ (JSON.parse(client.responseText));
            }
            catch (err) {
                this.handleError_();
                return;
            }
            this.handleLoad_(response);
        }
        else {
            this.handleError_();
        }
    };
    /**
     * @private
     * @param {Event} event The error event.
     */
    CustomTile.prototype.onXHRError_ = function (event) {
        this.handleError_();
    };
    /**
     */
    CustomTile.prototype.load = function () {
        if (this.preemptive_) {
            this.loadInternal_();
        }
        else {
            this.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].EMPTY);
        }
    };
    return CustomTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_2__["default"]));

/**
 * @typedef {Object} Options
 * @property {boolean} [preemptive=true]
 * If `true` the UTFGrid source loads the tiles based on their "visibility".
 * This improves the speed of response, but increases traffic.
 * Note that if set to `false` (lazy loading), you need to pass `true` as
 * `opt_request` to the `forDataAtCoordinateAndResolution` method otherwise no
 * data will ever be loaded.
 * @property {boolean} [jsonp=false] Use JSONP with callback to load the TileJSON.
 * Useful when the server does not support CORS..
 * @property {import("./TileJSON.js").Config} [tileJSON] TileJSON configuration for this source.
 * If not provided, `url` must be configured.
 * @property {string} [url] TileJSON endpoint that provides the configuration for this source.
 * Request will be made through JSONP. If not provided, `tileJSON` must be configured.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for UTFGrid interaction data loaded from TileJSON format.
 * @api
 */
var UTFGrid = /** @class */ (function (_super) {
    __extends(UTFGrid, _super);
    /**
     * @param {Options} options Source options.
     */
    function UTFGrid(options) {
        var _this = _super.call(this, {
            projection: Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["get"])('EPSG:3857'),
            state: _State_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADING,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.preemptive_ =
            options.preemptive !== undefined ? options.preemptive : true;
        /**
         * @private
         * @type {!import("../Tile.js").UrlFunction}
         */
        _this.tileUrlFunction_ = _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__["nullTileUrlFunction"];
        /**
         * @private
         * @type {string|undefined}
         */
        _this.template_ = undefined;
        /**
         * @private
         * @type {boolean}
         */
        _this.jsonp_ = options.jsonp || false;
        if (options.url) {
            if (_this.jsonp_) {
                Object(_net_js__WEBPACK_IMPORTED_MODULE_12__["jsonp"])(options.url, _this.handleTileJSONResponse.bind(_this), _this.handleTileJSONError.bind(_this));
            }
            else {
                var client = new XMLHttpRequest();
                client.addEventListener('load', _this.onXHRLoad_.bind(_this));
                client.addEventListener('error', _this.onXHRError_.bind(_this));
                client.open('GET', options.url);
                client.send();
            }
        }
        else if (options.tileJSON) {
            _this.handleTileJSONResponse(options.tileJSON);
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(false, 51); // Either `url` or `tileJSON` options must be provided
        }
        return _this;
    }
    /**
     * @private
     * @param {Event} event The load event.
     */
    UTFGrid.prototype.onXHRLoad_ = function (event) {
        var client = /** @type {XMLHttpRequest} */ (event.target);
        // status will be 0 for file:// urls
        if (!client.status || (client.status >= 200 && client.status < 300)) {
            var response = void 0;
            try {
                response = /** @type {import("./TileJSON.js").Config} */ (JSON.parse(client.responseText));
            }
            catch (err) {
                this.handleTileJSONError();
                return;
            }
            this.handleTileJSONResponse(response);
        }
        else {
            this.handleTileJSONError();
        }
    };
    /**
     * @private
     * @param {Event} event The error event.
     */
    UTFGrid.prototype.onXHRError_ = function (event) {
        this.handleTileJSONError();
    };
    /**
     * Return the template from TileJSON.
     * @return {string|undefined} The template from TileJSON.
     * @api
     */
    UTFGrid.prototype.getTemplate = function () {
        return this.template_;
    };
    /**
     * Calls the callback (synchronously by default) with the available data
     * for given coordinate and resolution (or `null` if not yet loaded or
     * in case of an error).
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {function(*): void} callback Callback.
     * @param {boolean} [opt_request] If `true` the callback is always async.
     *                               The tile data is requested if not yet loaded.
     * @api
     */
    UTFGrid.prototype.forDataAtCoordinateAndResolution = function (coordinate, resolution, callback, opt_request) {
        if (this.tileGrid) {
            var z = this.tileGrid.getZForResolution(resolution, this.zDirection);
            var tileCoord = this.tileGrid.getTileCoordForCoordAndZ(coordinate, z);
            var tile = /** @type {!CustomTile} */ (this.getTile(tileCoord[0], tileCoord[1], tileCoord[2], 1, this.getProjection()));
            tile.forDataAtCoordinate(coordinate, callback, opt_request);
        }
        else {
            if (opt_request === true) {
                setTimeout(function () {
                    callback(null);
                }, 0);
            }
            else {
                callback(null);
            }
        }
    };
    /**
     * @protected
     */
    UTFGrid.prototype.handleTileJSONError = function () {
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR);
    };
    /**
     * TODO: very similar to ol/source/TileJSON#handleTileJSONResponse
     * @protected
     * @param {import("./TileJSON.js").Config} tileJSON Tile JSON.
     */
    UTFGrid.prototype.handleTileJSONResponse = function (tileJSON) {
        var epsg4326Projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["get"])('EPSG:4326');
        var sourceProjection = this.getProjection();
        var extent;
        if (tileJSON['bounds'] !== undefined) {
            var transform = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["getTransformFromProjections"])(epsg4326Projection, sourceProjection);
            extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["applyTransform"])(tileJSON['bounds'], transform);
        }
        var gridExtent = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_8__["extentFromProjection"])(sourceProjection);
        var minZoom = tileJSON['minzoom'] || 0;
        var maxZoom = tileJSON['maxzoom'] || 22;
        var tileGrid = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_8__["createXYZ"])({
            extent: gridExtent,
            maxZoom: maxZoom,
            minZoom: minZoom,
        });
        this.tileGrid = tileGrid;
        this.template_ = tileJSON['template'];
        var grids = tileJSON['grids'];
        if (!grids) {
            this.setState(_State_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR);
            return;
        }
        this.tileUrlFunction_ = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_7__["createFromTemplates"])(grids, tileGrid);
        if (tileJSON['attribution'] !== undefined) {
            var attributionExtent_1 = extent !== undefined ? extent : gridExtent;
            this.setAttributions(function (frameState) {
                if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["intersects"])(attributionExtent_1, frameState.extent)) {
                    return [tileJSON['attribution']];
                }
                return null;
            });
        }
        this.setState(_State_js__WEBPACK_IMPORTED_MODULE_1__["default"].READY);
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!CustomTile} Tile.
     */
    UTFGrid.prototype.getTile = function (z, x, y, pixelRatio, projection) {
        var tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_9__["getKeyZXY"])(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) {
            return this.tileCache.get(tileCoordKey);
        }
        else {
            var tileCoord = [z, x, y];
            var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
            var tileUrl = this.tileUrlFunction_(urlTileCoord, pixelRatio, projection);
            var tile = new CustomTile(tileCoord, tileUrl !== undefined ? _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].IDLE : _TileState_js__WEBPACK_IMPORTED_MODULE_4__["default"].EMPTY, tileUrl !== undefined ? tileUrl : '', this.tileGrid.getTileCoordExtent(tileCoord), this.preemptive_, this.jsonp_);
            this.tileCache.set(tileCoordKey, tile);
            return tile;
        }
    };
    /**
     * Marks a tile coord as being used, without triggering a load.
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     */
    UTFGrid.prototype.useTile = function (z, x, y) {
        var tileCoordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_9__["getKeyZXY"])(z, x, y);
        if (this.tileCache.containsKey(tileCoordKey)) {
            this.tileCache.get(tileCoordKey);
        }
    };
    return UTFGrid;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (UTFGrid);
//# sourceMappingURL=UTFGrid.js.map

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultLoadFunction", function() { return defaultLoadFunction; });
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _VectorTile_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(153);
/* harmony import */ var _TileCache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74);
/* harmony import */ var _UrlTile_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84);
/* harmony import */ var _VectorRenderTile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(154);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _tilegrid_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88);
/* harmony import */ var _tilecoord_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15);
/* harmony import */ var _featureloader_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(112);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39);
/**
 * @module ol/source/VectorTile
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();












/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least twice the number of tiles in the viewport.
 * @property {import("../extent.js").Extent} [extent] Extent.
 * @property {import("../format/Feature.js").default} [format] Feature format for tiles. Used and required by the default.
 * @property {boolean} [overlaps=true] This source may have overlapping geometries. Setting this
 * to `false` (e.g. for sources with polygons that represent administrative
 * boundaries or TopoJSON sources) allows the renderer to optimise fill and
 * stroke operations.
 * @property {import("../proj.js").ProjectionLike} [projection='EPSG:3857'] Projection of the tile grid.
 * @property {import("./State.js").default} [state] Source state.
 * @property {typeof import("../VectorTile.js").default} [tileClass] Class used to instantiate image tiles.
 * Default is {@link module:ol/VectorTile}.
 * @property {number} [maxZoom=22] Optional max zoom level. Not used if `tileGrid` is provided.
 * @property {number} [minZoom] Optional min zoom level. Not used if `tileGrid` is provided.
 * @property {number|import("../size.js").Size} [tileSize=512] Optional tile size. Not used if `tileGrid` is provided.
 * @property {number} [maxResolution] Optional tile grid resolution at level zero. Not used if `tileGrid` is provided.
 * @property {import("../tilegrid/TileGrid.js").default} [tileGrid] Tile grid.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction]
 * Optional function to load a tile given a URL. Could look like this for pbf tiles:
 * ```js
 * function(tile, url) {
 *   tile.setLoader(function(extent, resolution, projection) {
 *     fetch(url).then(function(response) {
 *       response.arrayBuffer().then(function(data) {
 *         const format = tile.getFormat() // ol/format/MVT configured as source format
 *         const features = format.readFeatures(data, {
 *           extent: extent,
 *           featureProjection: projection
 *         });
 *         tile.setFeatures(features);
 *       });
 *     });
 *   });
 * }
 * ```
 * If you do not need extent, resolution and projection to get the features for a tile (e.g.
 * for GeoJSON tiles), your `tileLoadFunction` does not need a `setLoader()` call. Only make sure
 * to call `setFeatures()` on the tile:
 * ```js
 * const format = new GeoJSON({featureProjection: map.getView().getProjection()});
 * async function tileLoadFunction(tile, url) {
 *   const response = await fetch(url);
 *   const data = await response.json();
 *   tile.setFeatures(format.readFeatures(data));
 * }
 * ```
 * @property {import("../Tile.js").UrlFunction} [tileUrlFunction] Optional function to get tile URL given a tile coordinate and the projection.
 * @property {string} [url] URL template. Must include `{x}`, `{y}` or `{-y}`, and `{z}` placeholders.
 * A `{?-?}` template pattern, for example `subdomain{a-f}.domain.com`, may be
 * used instead of defining each one separately in the `urls` option.
 * @property {number} [transition] A duration for tile opacity
 * transitions in milliseconds. A duration of 0 disables the opacity transition.
 * @property {Array<string>} [urls] An array of URL templates.
 * @property {boolean} [wrapX=true] Whether to wrap the world horizontally.
 * When set to `false`, only one world
 * will be rendered. When set to `true`, tiles will be wrapped horizontally to
 * render multiple worlds.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=1]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Class for layer sources providing vector data divided into a tile grid, to be
 * used with {@link module:ol/layer/VectorTile~VectorTile}. Although this source receives tiles
 * with vector features from the server, it is not meant for feature editing.
 * Features are optimized for rendering, their geometries are clipped at or near
 * tile boundaries and simplified for a view resolution. See
 * {@link module:ol/source/Vector} for vector sources that are suitable for feature
 * editing.
 *
 * @fires import("./Tile.js").TileSourceEvent
 * @api
 */
var VectorTile = /** @class */ (function (_super) {
    __extends(VectorTile, _super);
    /**
     * @param {!Options} options Vector tile options.
     */
    function VectorTile(options) {
        var _this = this;
        var projection = options.projection || 'EPSG:3857';
        var extent = options.extent || Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_7__["extentFromProjection"])(projection);
        var tileGrid = options.tileGrid ||
            Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_7__["createXYZ"])({
                extent: extent,
                maxResolution: options.maxResolution,
                maxZoom: options.maxZoom !== undefined ? options.maxZoom : 22,
                minZoom: options.minZoom,
                tileSize: options.tileSize || 512,
            });
        _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            opaque: false,
            projection: projection,
            state: options.state,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction
                ? options.tileLoadFunction
                : defaultLoadFunction,
            tileUrlFunction: options.tileUrlFunction,
            url: options.url,
            urls: options.urls,
            wrapX: options.wrapX === undefined ? true : options.wrapX,
            transition: options.transition,
            zDirection: options.zDirection === undefined ? 1 : options.zDirection,
        }) || this;
        /**
         * @private
         * @type {import("../format/Feature.js").default}
         */
        _this.format_ = options.format ? options.format : null;
        /**
         * @private
         * @type {TileCache}
         */
        _this.sourceTileCache = new _TileCache_js__WEBPACK_IMPORTED_MODULE_2__["default"](_this.tileCache.highWaterMark);
        /**
         * @private
         * @type {boolean}
         */
        _this.overlaps_ = options.overlaps == undefined ? true : options.overlaps;
        /**
         * @protected
         * @type {typeof import("../VectorTile.js").default}
         */
        _this.tileClass = options.tileClass ? options.tileClass : _VectorTile_js__WEBPACK_IMPORTED_MODULE_1__["default"];
        /**
         * @private
         * @type {Object<string, import("../tilegrid/TileGrid.js").default>}
         */
        _this.tileGrids_ = {};
        return _this;
    }
    /**
     * Get features whose bounding box intersects the provided extent. Only features for cached
     * tiles for the last rendered zoom level are available in the source. So this method is only
     * suitable for requesting tiles for extents that are currently rendered.
     *
     * Features are returned in random tile order and as they are included in the tiles. This means
     * they can be clipped, duplicated across tiles, and simplified to the render resolution.
     *
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {Array<import("../Feature.js").FeatureLike>} Features.
     * @api
     */
    VectorTile.prototype.getFeaturesInExtent = function (extent) {
        var features = [];
        var tileCache = this.tileCache;
        if (tileCache.getCount() === 0) {
            return features;
        }
        var z = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_8__["fromKey"])(tileCache.peekFirstKey())[0];
        var tileGrid = this.tileGrid;
        tileCache.forEach(function (tile) {
            if (tile.tileCoord[0] !== z || tile.getState() !== _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED) {
                return;
            }
            var sourceTiles = tile.getSourceTiles();
            for (var i = 0, ii = sourceTiles.length; i < ii; ++i) {
                var sourceTile = sourceTiles[i];
                var tileCoord = sourceTile.tileCoord;
                if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(extent, tileGrid.getTileCoordExtent(tileCoord))) {
                    var tileFeatures = sourceTile.getFeatures();
                    if (tileFeatures) {
                        for (var j = 0, jj = tileFeatures.length; j < jj; ++j) {
                            var candidate = tileFeatures[j];
                            var geometry = candidate.getGeometry();
                            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(extent, geometry.getExtent())) {
                                features.push(candidate);
                            }
                        }
                    }
                }
            }
        });
        return features;
    };
    /**
     * @return {boolean} The source can have overlapping geometries.
     */
    VectorTile.prototype.getOverlaps = function () {
        return this.overlaps_;
    };
    /**
     * clear {@link module:ol/TileCache~TileCache} and delete all source tiles
     * @api
     */
    VectorTile.prototype.clear = function () {
        this.tileCache.clear();
        this.sourceTileCache.clear();
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @param {!Object<string, boolean>} usedTiles Used tiles.
     */
    VectorTile.prototype.expireCache = function (projection, usedTiles) {
        var tileCache = this.getTileCacheForProjection(projection);
        var usedSourceTiles = Object.keys(usedTiles).reduce(function (acc, key) {
            var cacheKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_8__["getCacheKeyForTileKey"])(key);
            if (tileCache.containsKey(cacheKey)) {
                var sourceTiles = tileCache.get(cacheKey).sourceTiles;
                for (var i = 0, ii = sourceTiles.length; i < ii; ++i) {
                    acc[sourceTiles[i].getKey()] = true;
                }
            }
            return acc;
        }, {});
        _super.prototype.expireCache.call(this, projection, usedTiles);
        this.sourceTileCache.expireCache(usedSourceTiles);
    };
    /**
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection").default} projection Projection.
     * @param {VectorRenderTile} tile Vector image tile.
     * @return {Array<import("../VectorTile").default>} Tile keys.
     */
    VectorTile.prototype.getSourceTiles = function (pixelRatio, projection, tile) {
        var _this = this;
        if (tile.getState() === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) {
            tile.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING);
            var urlTileCoord = tile.wrappedTileCoord;
            var tileGrid = this.getTileGridForProjection(projection);
            var extent = tileGrid.getTileCoordExtent(urlTileCoord);
            var z = urlTileCoord[0];
            var resolution = tileGrid.getResolution(z);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(extent, -resolution, extent);
            var sourceTileGrid_1 = this.tileGrid;
            var sourceExtent = sourceTileGrid_1.getExtent();
            if (sourceExtent) {
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getIntersection"])(extent, sourceExtent, extent);
            }
            var sourceZ = sourceTileGrid_1.getZForResolution(resolution, 1);
            sourceTileGrid_1.forEachTileCoord(extent, sourceZ, function (sourceTileCoord) {
                var tileUrl = _this.tileUrlFunction(sourceTileCoord, pixelRatio, projection);
                var sourceTile = _this.sourceTileCache.containsKey(tileUrl)
                    ? _this.sourceTileCache.get(tileUrl)
                    : new _this.tileClass(sourceTileCoord, tileUrl ? _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE : _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY, tileUrl, _this.format_, _this.tileLoadFunction);
                tile.sourceTiles.push(sourceTile);
                var sourceTileState = sourceTile.getState();
                if (sourceTileState < _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED) {
                    var listenChange_1 = function (event) {
                        _this.handleTileChange(event);
                        var state = sourceTile.getState();
                        if (state === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED || state === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR) {
                            var sourceTileKey = sourceTile.getKey();
                            if (sourceTileKey in tile.errorTileKeys) {
                                if (sourceTile.getState() === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED) {
                                    delete tile.errorTileKeys[sourceTileKey];
                                }
                            }
                            else {
                                tile.loadingSourceTiles--;
                            }
                            if (state === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR) {
                                tile.errorTileKeys[sourceTileKey] = true;
                            }
                            else {
                                sourceTile.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, listenChange_1);
                            }
                            if (tile.loadingSourceTiles === 0) {
                                tile.setState(Object(_obj_js__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(tile.errorTileKeys)
                                    ? _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED
                                    : _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR);
                            }
                        }
                    };
                    sourceTile.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, listenChange_1);
                    tile.loadingSourceTiles++;
                }
                if (sourceTileState === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE) {
                    sourceTile.extent =
                        sourceTileGrid_1.getTileCoordExtent(sourceTileCoord);
                    sourceTile.projection = projection;
                    sourceTile.resolution = sourceTileGrid_1.getResolution(sourceTileCoord[0]);
                    _this.sourceTileCache.set(tileUrl, sourceTile);
                    sourceTile.load();
                }
            });
            if (!tile.loadingSourceTiles) {
                tile.setState(tile.sourceTiles.some(function (sourceTile) { return sourceTile.getState() === _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR; })
                    ? _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR
                    : _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADED);
            }
        }
        return tile.sourceTiles;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!VectorRenderTile} Tile.
     */
    VectorTile.prototype.getTile = function (z, x, y, pixelRatio, projection) {
        var coordKey = Object(_tilecoord_js__WEBPACK_IMPORTED_MODULE_8__["getKeyZXY"])(z, x, y);
        var key = this.getKey();
        var tile;
        if (this.tileCache.containsKey(coordKey)) {
            tile = this.tileCache.get(coordKey);
            if (tile.key === key) {
                return tile;
            }
        }
        var tileCoord = [z, x, y];
        var urlTileCoord = this.getTileCoordForTileUrlFunction(tileCoord, projection);
        var sourceExtent = this.getTileGrid().getExtent();
        var tileGrid = this.getTileGridForProjection(projection);
        if (urlTileCoord && sourceExtent) {
            var tileExtent = tileGrid.getTileCoordExtent(urlTileCoord);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(tileExtent, -tileGrid.getResolution(z), tileExtent);
            if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(sourceExtent, tileExtent)) {
                urlTileCoord = null;
            }
        }
        var empty = true;
        if (urlTileCoord !== null) {
            var sourceTileGrid = this.tileGrid;
            var resolution = tileGrid.getResolution(z);
            var sourceZ = sourceTileGrid.getZForResolution(resolution, 1);
            // make extent 1 pixel smaller so we don't load tiles for < 0.5 pixel render space
            var extent = tileGrid.getTileCoordExtent(urlTileCoord);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(extent, -resolution, extent);
            sourceTileGrid.forEachTileCoord(extent, sourceZ, function (sourceTileCoord) {
                empty =
                    empty &&
                        !this.tileUrlFunction(sourceTileCoord, pixelRatio, projection);
            }.bind(this));
        }
        var newTile = new _VectorRenderTile_js__WEBPACK_IMPORTED_MODULE_5__["default"](tileCoord, empty ? _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].EMPTY : _TileState_js__WEBPACK_IMPORTED_MODULE_3__["default"].IDLE, urlTileCoord, this.getSourceTiles.bind(this, pixelRatio, projection));
        newTile.key = key;
        if (tile) {
            newTile.interimTile = tile;
            newTile.refreshInterimChain();
            this.tileCache.replace(coordKey, newTile);
        }
        else {
            this.tileCache.set(coordKey, newTile);
        }
        return newTile;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {!import("../tilegrid/TileGrid.js").default} Tile grid.
     */
    VectorTile.prototype.getTileGridForProjection = function (projection) {
        var code = projection.getCode();
        var tileGrid = this.tileGrids_[code];
        if (!tileGrid) {
            // A tile grid that matches the tile size of the source tile grid is more
            // likely to have 1:1 relationships between source tiles and rendered tiles.
            var sourceTileGrid = this.tileGrid;
            tileGrid = Object(_tilegrid_js__WEBPACK_IMPORTED_MODULE_7__["createForProjection"])(projection, undefined, sourceTileGrid
                ? sourceTileGrid.getTileSize(sourceTileGrid.getMinZoom())
                : undefined);
            this.tileGrids_[code] = tileGrid;
        }
        return tileGrid;
    };
    /**
     * Get the tile pixel ratio for this source.
     * @param {number} pixelRatio Pixel ratio.
     * @return {number} Tile pixel ratio.
     */
    VectorTile.prototype.getTilePixelRatio = function (pixelRatio) {
        return pixelRatio;
    };
    /**
     * @param {number} z Z.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @return {import("../size.js").Size} Tile size.
     */
    VectorTile.prototype.getTilePixelSize = function (z, pixelRatio, projection) {
        var tileGrid = this.getTileGridForProjection(projection);
        var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_11__["toSize"])(tileGrid.getTileSize(z), this.tmpSize);
        return [
            Math.round(tileSize[0] * pixelRatio),
            Math.round(tileSize[1] * pixelRatio),
        ];
    };
    /**
     * Increases the cache size if needed
     * @param {number} tileCount Minimum number of tiles needed.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    VectorTile.prototype.updateCacheSize = function (tileCount, projection) {
        _super.prototype.updateCacheSize.call(this, tileCount * 2, projection);
        this.sourceTileCache.highWaterMark =
            this.getTileCacheForProjection(projection).highWaterMark;
    };
    return VectorTile;
}(_UrlTile_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorTile);
/**
 * Sets the loader for a tile.
 * @param {import("../VectorTile.js").default} tile Vector tile.
 * @param {string} url URL.
 */
function defaultLoadFunction(tile, url) {
    tile.setLoader(
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @param {import("../proj/Projection.js").default} projection Projection.
     */
    function (extent, resolution, projection) {
        Object(_featureloader_js__WEBPACK_IMPORTED_MODULE_10__["loadFeaturesXhr"])(url, tile.getFormat(), extent, resolution, projection, tile.onLoad.bind(tile), tile.onError.bind(tile));
    });
}
//# sourceMappingURL=VectorTile.js.map

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/VectorTile
 */


var VectorTile = /** @class */ (function (_super) {
    __extends(VectorTile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {string} src Data source url.
     * @param {import("./format/Feature.js").default} format Feature format.
     * @param {import("./Tile.js").LoadFunction} tileLoadFunction Tile load function.
     * @param {import("./Tile.js").Options} [opt_options] Tile options.
     */
    function VectorTile(tileCoord, state, src, format, tileLoadFunction, opt_options) {
        var _this = _super.call(this, tileCoord, state, opt_options) || this;
        /**
         * Extent of this tile; set by the source.
         * @type {import("./extent.js").Extent}
         */
        _this.extent = null;
        /**
         * @private
         * @type {import("./format/Feature.js").default}
         */
        _this.format_ = format;
        /**
         * @private
         * @type {Array<import("./Feature.js").default>}
         */
        _this.features_ = null;
        /**
         * @private
         * @type {import("./featureloader.js").FeatureLoader}
         */
        _this.loader_;
        /**
         * Feature projection of this tile; set by the source.
         * @type {import("./proj/Projection.js").default}
         */
        _this.projection = null;
        /**
         * Resolution of this tile; set by the source.
         * @type {number}
         */
        _this.resolution;
        /**
         * @private
         * @type {import("./Tile.js").LoadFunction}
         */
        _this.tileLoadFunction_ = tileLoadFunction;
        /**
         * @private
         * @type {string}
         */
        _this.url_ = src;
        _this.key = src;
        return _this;
    }
    /**
     * Get the feature format assigned for reading this tile's features.
     * @return {import("./format/Feature.js").default} Feature format.
     * @api
     */
    VectorTile.prototype.getFormat = function () {
        return this.format_;
    };
    /**
     * Get the features for this tile. Geometries will be in the view projection.
     * @return {Array<import("./Feature.js").FeatureLike>} Features.
     * @api
     */
    VectorTile.prototype.getFeatures = function () {
        return this.features_;
    };
    /**
     * Load not yet loaded URI.
     */
    VectorTile.prototype.load = function () {
        if (this.state == _TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].IDLE) {
            this.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADING);
            this.tileLoadFunction_(this, this.url_);
            if (this.loader_) {
                this.loader_(this.extent, this.resolution, this.projection);
            }
        }
    };
    /**
     * Handler for successful tile load.
     * @param {Array<import("./Feature.js").default>} features The loaded features.
     * @param {import("./proj/Projection.js").default} dataProjection Data projection.
     */
    VectorTile.prototype.onLoad = function (features, dataProjection) {
        this.setFeatures(features);
    };
    /**
     * Handler for tile load errors.
     */
    VectorTile.prototype.onError = function () {
        this.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR);
    };
    /**
     * Function for use in an {@link module:ol/source/VectorTile~VectorTile}'s `tileLoadFunction`.
     * Sets the features for the tile.
     * @param {Array<import("./Feature.js").default>} features Features.
     * @api
     */
    VectorTile.prototype.setFeatures = function (features) {
        this.features_ = features;
        this.setState(_TileState_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOADED);
    };
    /**
     * Set the feature loader for reading this tile's features.
     * @param {import("./featureloader.js").FeatureLoader} loader Feature loader.
     * @api
     */
    VectorTile.prototype.setLoader = function (loader) {
        this.loader_ = loader;
    };
    return VectorTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorTile);
//# sourceMappingURL=VectorTile.js.map

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Tile_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(73);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/VectorRenderTile
 */



/**
 * @typedef {Object} ReplayState
 * @property {boolean} dirty Dirty.
 * @property {null|import("./render.js").OrderFunction} renderedRenderOrder RenderedRenderOrder.
 * @property {number} renderedTileRevision RenderedTileRevision.
 * @property {number} renderedResolution RenderedResolution.
 * @property {number} renderedRevision RenderedRevision.
 * @property {number} renderedTileResolution RenderedTileResolution.
 * @property {number} renderedTileZ RenderedTileZ.
 */
/**
 * @type {Array<HTMLCanvasElement>}
 */
var canvasPool = [];
var VectorRenderTile = /** @class */ (function (_super) {
    __extends(VectorRenderTile, _super);
    /**
     * @param {import("./tilecoord.js").TileCoord} tileCoord Tile coordinate.
     * @param {import("./TileState.js").default} state State.
     * @param {import("./tilecoord.js").TileCoord} urlTileCoord Wrapped tile coordinate for source urls.
     * @param {function(VectorRenderTile):Array<import("./VectorTile").default>} getSourceTiles Function
     * to get source tiles for this tile.
     */
    function VectorRenderTile(tileCoord, state, urlTileCoord, getSourceTiles) {
        var _this = _super.call(this, tileCoord, state, { transition: 0 }) || this;
        /**
         * @private
         * @type {!Object<string, CanvasRenderingContext2D>}
         */
        _this.context_ = {};
        /**
         * Executor groups by layer uid. Entries are read/written by the renderer.
         * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
         */
        _this.executorGroups = {};
        /**
         * Executor groups for decluttering, by layer uid. Entries are read/written by the renderer.
         * @type {Object<string, Array<import("./render/canvas/ExecutorGroup.js").default>>}
         */
        _this.declutterExecutorGroups = {};
        /**
         * Number of loading source tiles. Read/written by the source.
         * @type {number}
         */
        _this.loadingSourceTiles = 0;
        /**
         * @type {Object<number, ImageData>}
         */
        _this.hitDetectionImageData = {};
        /**
         * @private
         * @type {!Object<string, ReplayState>}
         */
        _this.replayState_ = {};
        /**
         * @type {Array<import("./VectorTile.js").default>}
         */
        _this.sourceTiles = [];
        /**
         * @type {Object<string, boolean>}
         */
        _this.errorTileKeys = {};
        /**
         * @type {number}
         */
        _this.wantedResolution;
        /**
         * @type {!function():Array<import("./VectorTile.js").default>}
         */
        _this.getSourceTiles = getSourceTiles.bind(undefined, _this);
        /**
         * @type {import("./tilecoord.js").TileCoord}
         */
        _this.wrappedTileCoord = urlTileCoord;
        return _this;
    }
    /**
     * @param {import("./layer/Layer.js").default} layer Layer.
     * @return {CanvasRenderingContext2D} The rendering context.
     */
    VectorRenderTile.prototype.getContext = function (layer) {
        var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(layer);
        if (!(key in this.context_)) {
            this.context_[key] = Object(_dom_js__WEBPACK_IMPORTED_MODULE_1__["createCanvasContext2D"])(1, 1, canvasPool);
        }
        return this.context_[key];
    };
    /**
     * @param {import("./layer/Layer.js").default} layer Layer.
     * @return {boolean} Tile has a rendering context for the given layer.
     */
    VectorRenderTile.prototype.hasContext = function (layer) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(layer) in this.context_;
    };
    /**
     * Get the Canvas for this tile.
     * @param {import("./layer/Layer.js").default} layer Layer.
     * @return {HTMLCanvasElement} Canvas.
     */
    VectorRenderTile.prototype.getImage = function (layer) {
        return this.hasContext(layer) ? this.getContext(layer).canvas : null;
    };
    /**
     * @param {import("./layer/Layer.js").default} layer Layer.
     * @return {ReplayState} The replay state.
     */
    VectorRenderTile.prototype.getReplayState = function (layer) {
        var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["getUid"])(layer);
        if (!(key in this.replayState_)) {
            this.replayState_[key] = {
                dirty: false,
                renderedRenderOrder: null,
                renderedResolution: NaN,
                renderedRevision: -1,
                renderedTileResolution: NaN,
                renderedTileRevision: -1,
                renderedTileZ: -1,
            };
        }
        return this.replayState_[key];
    };
    /**
     * Load the tile.
     */
    VectorRenderTile.prototype.load = function () {
        this.getSourceTiles();
    };
    /**
     * Remove from the cache due to expiry
     */
    VectorRenderTile.prototype.release = function () {
        for (var key in this.context_) {
            canvasPool.push(this.context_[key].canvas);
            delete this.context_[key];
        }
        _super.prototype.release.call(this);
    };
    return VectorRenderTile;
}(_Tile_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorRenderTile);
//# sourceMappingURL=VectorRenderTile.js.map

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "optionsFromCapabilities", function() { return optionsFromCapabilities; });
/* harmony import */ var _TileImage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71);
/* harmony import */ var _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(156);
/* harmony import */ var _uri_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(120);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _tilegrid_WMTS_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(157);
/* harmony import */ var _tileurlfunction_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/**
 * @module ol/source/WMTS
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @typedef {Object} Options
 * @property {import("./Source.js").AttributionLike} [attributions] Attributions.
 * @property {boolean} [attributionsCollapsible=true] Attributions are collapsible.
 * @property {number} [cacheSize] Initial tile cache size. Will auto-grow to hold at least the number of tiles in the viewport.
 * @property {null|string} [crossOrigin] The `crossOrigin` attribute for loaded images.  Note that
 * you must provide a `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image for more detail.
 * @property {boolean} [imageSmoothing=true] Enable image smoothing.
 * @property {import("../tilegrid/WMTS.js").default} tileGrid Tile grid.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {number} [reprojectionErrorThreshold=0.5] Maximum allowed reprojection error (in pixels).
 * Higher values can increase reprojection performance, but decrease precision.
 * @property {import("./WMTSRequestEncoding.js").default|string} [requestEncoding='KVP'] Request encoding.
 * @property {string} layer Layer name as advertised in the WMTS capabilities.
 * @property {string} style Style name as advertised in the WMTS capabilities.
 * @property {typeof import("../ImageTile.js").default} [tileClass]  Class used to instantiate image tiles. Default is {@link module:ol/ImageTile~ImageTile}.
 * @property {number} [tilePixelRatio=1] The pixel ratio used by the tile service.
 * For example, if the tile service advertizes 256px by 256px tiles but actually sends 512px
 * by 512px images (for retina/hidpi devices) then `tilePixelRatio`
 * should be set to `2`.
 * @property {string} [format='image/jpeg'] Image format. Only used when `requestEncoding` is `'KVP'`.
 * @property {string} [version='1.0.0'] WMTS version.
 * @property {string} matrixSet Matrix set.
 * @property {!Object} [dimensions] Additional "dimensions" for tile requests.
 * This is an object with properties named like the advertised WMTS dimensions.
 * @property {string} [url]  A URL for the service.
 * For the RESTful request encoding, this is a URL
 * template.  For KVP encoding, it is normal URL. A `{?-?}` template pattern,
 * for example `subdomain{a-f}.domain.com`, may be used instead of defining
 * each one separately in the `urls` option.
 * @property {import("../Tile.js").LoadFunction} [tileLoadFunction] Optional function to load a tile given a URL. The default is
 * ```js
 * function(imageTile, src) {
 *   imageTile.getImage().src = src;
 * };
 * ```
 * @property {Array<string>} [urls] An array of URLs.
 * Requests will be distributed among the URLs in this array.
 * @property {boolean} [wrapX=false] Whether to wrap the world horizontally.
 * @property {number} [transition] Duration of the opacity transition for rendering.
 * To disable the opacity transition, pass `transition: 0`.
 * @property {number|import("../array.js").NearestDirectionFunction} [zDirection=0]
 * Choose whether to use tiles with a higher or lower zoom level when between integer
 * zoom levels. See {@link module:ol/tilegrid/TileGrid~TileGrid#getZForResolution}.
 */
/**
 * @classdesc
 * Layer source for tile data from WMTS servers.
 * @api
 */
var WMTS = /** @class */ (function (_super) {
    __extends(WMTS, _super);
    /**
     * @param {Options} options WMTS options.
     */
    function WMTS(options) {
        // TODO: add support for TileMatrixLimits
        var _this = this;
        var requestEncoding = options.requestEncoding !== undefined
            ? /** @type {import("./WMTSRequestEncoding.js").default} */ (options.requestEncoding)
            : _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP;
        // FIXME: should we create a default tileGrid?
        // we could issue a getCapabilities xhr to retrieve missing configuration
        var tileGrid = options.tileGrid;
        var urls = options.urls;
        if (urls === undefined && options.url !== undefined) {
            urls = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_6__["expandUrl"])(options.url);
        }
        _this = _super.call(this, {
            attributions: options.attributions,
            attributionsCollapsible: options.attributionsCollapsible,
            cacheSize: options.cacheSize,
            crossOrigin: options.crossOrigin,
            imageSmoothing: options.imageSmoothing,
            projection: options.projection,
            reprojectionErrorThreshold: options.reprojectionErrorThreshold,
            tileClass: options.tileClass,
            tileGrid: tileGrid,
            tileLoadFunction: options.tileLoadFunction,
            tilePixelRatio: options.tilePixelRatio,
            urls: urls,
            wrapX: options.wrapX !== undefined ? options.wrapX : false,
            transition: options.transition,
            zDirection: options.zDirection,
        }) || this;
        /**
         * @private
         * @type {string}
         */
        _this.version_ = options.version !== undefined ? options.version : '1.0.0';
        /**
         * @private
         * @type {string}
         */
        _this.format_ = options.format !== undefined ? options.format : 'image/jpeg';
        /**
         * @private
         * @type {!Object}
         */
        _this.dimensions_ =
            options.dimensions !== undefined ? options.dimensions : {};
        /**
         * @private
         * @type {string}
         */
        _this.layer_ = options.layer;
        /**
         * @private
         * @type {string}
         */
        _this.matrixSet_ = options.matrixSet;
        /**
         * @private
         * @type {string}
         */
        _this.style_ = options.style;
        // FIXME: should we guess this requestEncoding from options.url(s)
        //        structure? that would mean KVP only if a template is not provided.
        /**
         * @private
         * @type {import("./WMTSRequestEncoding.js").default}
         */
        _this.requestEncoding_ = requestEncoding;
        _this.setKey(_this.getKeyForDimensions_());
        if (urls && urls.length > 0) {
            _this.tileUrlFunction = Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_6__["createFromTileUrlFunctions"])(urls.map(_this.createFromWMTSTemplate.bind(_this)));
        }
        return _this;
    }
    /**
     * Set the URLs to use for requests.
     * URLs may contain OGC conform URL Template Variables: {TileMatrix}, {TileRow}, {TileCol}.
     * @param {Array<string>} urls URLs.
     */
    WMTS.prototype.setUrls = function (urls) {
        this.urls = urls;
        var key = urls.join('\n');
        this.setTileUrlFunction(Object(_tileurlfunction_js__WEBPACK_IMPORTED_MODULE_6__["createFromTileUrlFunctions"])(urls.map(this.createFromWMTSTemplate.bind(this))), key);
    };
    /**
     * Get the dimensions, i.e. those passed to the constructor through the
     * "dimensions" option, and possibly updated using the updateDimensions
     * method.
     * @return {!Object} Dimensions.
     * @api
     */
    WMTS.prototype.getDimensions = function () {
        return this.dimensions_;
    };
    /**
     * Return the image format of the WMTS source.
     * @return {string} Format.
     * @api
     */
    WMTS.prototype.getFormat = function () {
        return this.format_;
    };
    /**
     * Return the layer of the WMTS source.
     * @return {string} Layer.
     * @api
     */
    WMTS.prototype.getLayer = function () {
        return this.layer_;
    };
    /**
     * Return the matrix set of the WMTS source.
     * @return {string} MatrixSet.
     * @api
     */
    WMTS.prototype.getMatrixSet = function () {
        return this.matrixSet_;
    };
    /**
     * Return the request encoding, either "KVP" or "REST".
     * @return {import("./WMTSRequestEncoding.js").default} Request encoding.
     * @api
     */
    WMTS.prototype.getRequestEncoding = function () {
        return this.requestEncoding_;
    };
    /**
     * Return the style of the WMTS source.
     * @return {string} Style.
     * @api
     */
    WMTS.prototype.getStyle = function () {
        return this.style_;
    };
    /**
     * Return the version of the WMTS source.
     * @return {string} Version.
     * @api
     */
    WMTS.prototype.getVersion = function () {
        return this.version_;
    };
    /**
     * @private
     * @return {string} The key for the current dimensions.
     */
    WMTS.prototype.getKeyForDimensions_ = function () {
        var i = 0;
        var res = [];
        for (var key in this.dimensions_) {
            res[i++] = key + '-' + this.dimensions_[key];
        }
        return res.join('/');
    };
    /**
     * Update the dimensions.
     * @param {Object} dimensions Dimensions.
     * @api
     */
    WMTS.prototype.updateDimensions = function (dimensions) {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])(this.dimensions_, dimensions);
        this.setKey(this.getKeyForDimensions_());
    };
    /**
     * @param {string} template Template.
     * @return {import("../Tile.js").UrlFunction} Tile URL function.
     */
    WMTS.prototype.createFromWMTSTemplate = function (template) {
        var requestEncoding = this.requestEncoding_;
        // context property names are lower case to allow for a case insensitive
        // replacement as some services use different naming conventions
        var context = {
            'layer': this.layer_,
            'style': this.style_,
            'tilematrixset': this.matrixSet_,
        };
        if (requestEncoding == _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP) {
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])(context, {
                'Service': 'WMTS',
                'Request': 'GetTile',
                'Version': this.version_,
                'Format': this.format_,
            });
        }
        // TODO: we may want to create our own appendParams function so that params
        // order conforms to wmts spec guidance, and so that we can avoid to escape
        // special template params
        template =
            requestEncoding == _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP
                ? Object(_uri_js__WEBPACK_IMPORTED_MODULE_2__["appendParams"])(template, context)
                : template.replace(/\{(\w+?)\}/g, function (m, p) {
                    return p.toLowerCase() in context ? context[p.toLowerCase()] : m;
                });
        var tileGrid = /** @type {import("../tilegrid/WMTS.js").default} */ (this.tileGrid);
        var dimensions = this.dimensions_;
        return (
        /**
         * @param {import("../tilecoord.js").TileCoord} tileCoord Tile coordinate.
         * @param {number} pixelRatio Pixel ratio.
         * @param {import("../proj/Projection.js").default} projection Projection.
         * @return {string|undefined} Tile URL.
         */
        function (tileCoord, pixelRatio, projection) {
            if (!tileCoord) {
                return undefined;
            }
            else {
                var localContext_1 = {
                    'TileMatrix': tileGrid.getMatrixId(tileCoord[0]),
                    'TileCol': tileCoord[1],
                    'TileRow': tileCoord[2],
                };
                Object(_obj_js__WEBPACK_IMPORTED_MODULE_3__["assign"])(localContext_1, dimensions);
                var url = template;
                if (requestEncoding == _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP) {
                    url = Object(_uri_js__WEBPACK_IMPORTED_MODULE_2__["appendParams"])(url, localContext_1);
                }
                else {
                    url = url.replace(/\{(\w+?)\}/g, function (m, p) {
                        return localContext_1[p];
                    });
                }
                return url;
            }
        });
    };
    return WMTS;
}(_TileImage_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (WMTS);
/**
 * Generate source options from a capabilities object.
 * @param {Object} wmtsCap An object representing the capabilities document.
 * @param {!Object} config Configuration properties for the layer.  Defaults for
 *                  the layer will apply if not provided.
 *
 * Required config properties:
 *  - layer - {string} The layer identifier.
 *
 * Optional config properties:
 *  - matrixSet - {string} The matrix set identifier, required if there is
 *       more than one matrix set in the layer capabilities.
 *  - projection - {string} The desired CRS when no matrixSet is specified.
 *       eg: "EPSG:3857". If the desired projection is not available,
 *       an error is thrown.
 *  - requestEncoding - {string} url encoding format for the layer. Default is
 *       the first tile url format found in the GetCapabilities response.
 *  - style - {string} The name of the style
 *  - format - {string} Image format for the layer. Default is the first
 *       format returned in the GetCapabilities response.
 *  - crossOrigin - {string|null|undefined} Cross origin. Default is `undefined`.
 * @return {?Options} WMTS source options object or `null` if the layer was not found.
 * @api
 */
function optionsFromCapabilities(wmtsCap, config) {
    var layers = wmtsCap['Contents']['Layer'];
    var l = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["find"])(layers, function (elt, index, array) {
        return elt['Identifier'] == config['layer'];
    });
    if (l === null) {
        return null;
    }
    var tileMatrixSets = wmtsCap['Contents']['TileMatrixSet'];
    var idx;
    if (l['TileMatrixSetLink'].length > 1) {
        if ('projection' in config) {
            idx = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["findIndex"])(l['TileMatrixSetLink'], function (elt, index, array) {
                var tileMatrixSet = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["find"])(tileMatrixSets, function (el) {
                    return el['Identifier'] == elt['TileMatrixSet'];
                });
                var supportedCRS = tileMatrixSet['SupportedCRS'];
                var proj1 = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])(supportedCRS);
                var proj2 = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])(config['projection']);
                if (proj1 && proj2) {
                    return Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["equivalent"])(proj1, proj2);
                }
                else {
                    return supportedCRS == config['projection'];
                }
            });
        }
        else {
            idx = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["findIndex"])(l['TileMatrixSetLink'], function (elt, index, array) {
                return elt['TileMatrixSet'] == config['matrixSet'];
            });
        }
    }
    else {
        idx = 0;
    }
    if (idx < 0) {
        idx = 0;
    }
    var matrixSet = 
    /** @type {string} */
    (l['TileMatrixSetLink'][idx]['TileMatrixSet']);
    var matrixLimits = 
    /** @type {Array<Object>} */
    (l['TileMatrixSetLink'][idx]['TileMatrixSetLimits']);
    var format = /** @type {string} */ (l['Format'][0]);
    if ('format' in config) {
        format = config['format'];
    }
    idx = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["findIndex"])(l['Style'], function (elt, index, array) {
        if ('style' in config) {
            return elt['Title'] == config['style'];
        }
        else {
            return elt['isDefault'];
        }
    });
    if (idx < 0) {
        idx = 0;
    }
    var style = /** @type {string} */ (l['Style'][idx]['Identifier']);
    var dimensions = {};
    if ('Dimension' in l) {
        l['Dimension'].forEach(function (elt, index, array) {
            var key = elt['Identifier'];
            var value = elt['Default'];
            if (value === undefined) {
                value = elt['Value'][0];
            }
            dimensions[key] = value;
        });
    }
    var matrixSets = wmtsCap['Contents']['TileMatrixSet'];
    var matrixSetObj = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["find"])(matrixSets, function (elt, index, array) {
        return elt['Identifier'] == matrixSet;
    });
    var projection;
    var code = matrixSetObj['SupportedCRS'];
    if (code) {
        projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])(code);
    }
    if ('projection' in config) {
        var projConfig = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])(config['projection']);
        if (projConfig) {
            if (!projection || Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["equivalent"])(projConfig, projection)) {
                projection = projConfig;
            }
        }
    }
    var wrapX = false;
    var switchOriginXY = projection.getAxisOrientation().substr(0, 2) == 'ne';
    var matrix = matrixSetObj.TileMatrix[0];
    // create default matrixLimit
    var selectedMatrixLimit = {
        MinTileCol: 0,
        MinTileRow: 0,
        // subtract one to end up at tile top left
        MaxTileCol: matrix.MatrixWidth - 1,
        MaxTileRow: matrix.MatrixHeight - 1,
    };
    //in case of matrix limits, use matrix limits to calculate extent
    if (matrixLimits) {
        selectedMatrixLimit = matrixLimits[matrixLimits.length - 1];
        var m = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["find"])(matrixSetObj.TileMatrix, function (tileMatrixValue) {
            return tileMatrixValue.Identifier === selectedMatrixLimit.TileMatrix ||
                matrixSetObj.Identifier + ':' + tileMatrixValue.Identifier ===
                    selectedMatrixLimit.TileMatrix;
        });
        if (m) {
            matrix = m;
        }
    }
    var resolution = (matrix.ScaleDenominator * 0.00028) / projection.getMetersPerUnit(); // WMTS 1.0.0: standardized rendering pixel size
    var origin = switchOriginXY
        ? [matrix.TopLeftCorner[1], matrix.TopLeftCorner[0]]
        : matrix.TopLeftCorner;
    var tileSpanX = matrix.TileWidth * resolution;
    var tileSpanY = matrix.TileHeight * resolution;
    var matrixSetExtent = matrixSetObj['BoundingBox'];
    var extent = [
        origin[0] + tileSpanX * selectedMatrixLimit.MinTileCol,
        // add one to get proper bottom/right coordinate
        origin[1] - tileSpanY * (1 + selectedMatrixLimit.MaxTileRow),
        origin[0] + tileSpanX * (1 + selectedMatrixLimit.MaxTileCol),
        origin[1] - tileSpanY * selectedMatrixLimit.MinTileRow,
    ];
    if (matrixSetExtent !== undefined &&
        !Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["containsExtent"])(matrixSetExtent, extent)) {
        var wgs84BoundingBox = l['WGS84BoundingBox'];
        var wgs84ProjectionExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["get"])('EPSG:4326').getExtent();
        extent = matrixSetExtent;
        if (wgs84BoundingBox) {
            wrapX =
                wgs84BoundingBox[0] === wgs84ProjectionExtent[0] &&
                    wgs84BoundingBox[2] === wgs84ProjectionExtent[2];
        }
        else {
            var wgs84MatrixSetExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_7__["transformExtent"])(matrixSetExtent, matrixSetObj['SupportedCRS'], 'EPSG:4326');
            // Ignore slight deviation from the correct x limits
            wrapX =
                wgs84MatrixSetExtent[0] - 1e-10 <= wgs84ProjectionExtent[0] &&
                    wgs84MatrixSetExtent[2] + 1e-10 >= wgs84ProjectionExtent[2];
        }
    }
    var tileGrid = Object(_tilegrid_WMTS_js__WEBPACK_IMPORTED_MODULE_5__["createFromCapabilitiesMatrixSet"])(matrixSetObj, extent, matrixLimits);
    /** @type {!Array<string>} */
    var urls = [];
    var requestEncoding = config['requestEncoding'];
    requestEncoding = requestEncoding !== undefined ? requestEncoding : '';
    if ('OperationsMetadata' in wmtsCap &&
        'GetTile' in wmtsCap['OperationsMetadata']) {
        var gets = wmtsCap['OperationsMetadata']['GetTile']['DCP']['HTTP']['Get'];
        for (var i = 0, ii = gets.length; i < ii; ++i) {
            if (gets[i]['Constraint']) {
                var constraint = Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["find"])(gets[i]['Constraint'], function (element) {
                    return element['name'] == 'GetEncoding';
                });
                var encodings = constraint['AllowedValues']['Value'];
                if (requestEncoding === '') {
                    // requestEncoding not provided, use the first encoding from the list
                    requestEncoding = encodings[0];
                }
                if (requestEncoding === _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP) {
                    if (Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["includes"])(encodings, _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP)) {
                        urls.push(/** @type {string} */ (gets[i]['href']));
                    }
                }
                else {
                    break;
                }
            }
            else if (gets[i]['href']) {
                requestEncoding = _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].KVP;
                urls.push(/** @type {string} */ (gets[i]['href']));
            }
        }
    }
    if (urls.length === 0) {
        requestEncoding = _WMTSRequestEncoding_js__WEBPACK_IMPORTED_MODULE_1__["default"].REST;
        l['ResourceURL'].forEach(function (element) {
            if (element['resourceType'] === 'tile') {
                format = element['format'];
                urls.push(/** @type {string} */ (element['template']));
            }
        });
    }
    return {
        urls: urls,
        layer: config['layer'],
        matrixSet: matrixSet,
        format: format,
        projection: projection,
        requestEncoding: requestEncoding,
        tileGrid: tileGrid,
        style: style,
        dimensions: dimensions,
        wrapX: wrapX,
        crossOrigin: config['crossOrigin'],
    };
}
//# sourceMappingURL=WMTS.js.map

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/source/WMTSRequestEncoding
 */
/**
 * Request encoding. One of 'KVP', 'REST'.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    KVP: 'KVP',
    REST: 'REST', // see spec §10
});
//# sourceMappingURL=WMTSRequestEncoding.js.map

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createFromCapabilitiesMatrixSet", function() { return createFromCapabilitiesMatrixSet; });
/* harmony import */ var _TileGrid_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/**
 * @module ol/tilegrid/WMTS
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * @typedef {Object} Options
 * @property {import("../extent.js").Extent} [extent] Extent for the tile grid. No tiles
 * outside this extent will be requested by {@link module:ol/source/Tile} sources.
 * When no `origin` or `origins` are configured, the `origin` will be set to the
 * top-left corner of the extent.
 * @property {import("../coordinate.js").Coordinate} [origin] The tile grid origin, i.e.
 * where the `x` and `y` axes meet (`[z, 0, 0]`). Tile coordinates increase left
 * to right and downwards. If not specified, `extent` or `origins` must be provided.
 * @property {Array<import("../coordinate.js").Coordinate>} [origins] Tile grid origins,
 * i.e. where the `x` and `y` axes meet (`[z, 0, 0]`), for each zoom level. If
 * given, the array length should match the length of the `resolutions` array, i.e.
 * each resolution can have a different origin. Tile coordinates increase left to
 * right and downwards. If not specified, `extent` or `origin` must be provided.
 * @property {!Array<number>} resolutions Resolutions. The array index of each
 * resolution needs to match the zoom level. This means that even if a `minZoom`
 * is configured, the resolutions array will have a length of `maxZoom + 1`
 * @property {!Array<string>} matrixIds matrix IDs. The length of this array needs
 * to match the length of the `resolutions` array.
 * @property {Array<import("../size.js").Size>} [sizes] Number of tile rows and columns
 * of the grid for each zoom level. The values here are the `TileMatrixWidth` and
 * `TileMatrixHeight` advertised in the GetCapabilities response of the WMTS, and
 * define each zoom level's extent together with the `origin` or `origins`.
 * A grid `extent` can be configured in addition, and will further limit the extent for
 * which tile requests are made by sources. If the bottom-left corner of
 * an extent is used as `origin` or `origins`, then the `y` value must be
 * negative because OpenLayers tile coordinates use the top left as the origin.
 * @property {number|import("../size.js").Size} [tileSize] Tile size.
 * @property {Array<import("../size.js").Size>} [tileSizes] Tile sizes. The length of
 * this array needs to match the length of the `resolutions` array.
 */
/**
 * @classdesc
 * Set the grid pattern for sources accessing WMTS tiled-image servers.
 * @api
 */
var WMTSTileGrid = /** @class */ (function (_super) {
    __extends(WMTSTileGrid, _super);
    /**
     * @param {Options} options WMTS options.
     */
    function WMTSTileGrid(options) {
        var _this = _super.call(this, {
            extent: options.extent,
            origin: options.origin,
            origins: options.origins,
            resolutions: options.resolutions,
            tileSize: options.tileSize,
            tileSizes: options.tileSizes,
            sizes: options.sizes,
        }) || this;
        /**
         * @private
         * @type {!Array<string>}
         */
        _this.matrixIds_ = options.matrixIds;
        return _this;
    }
    /**
     * @param {number} z Z.
     * @return {string} MatrixId..
     */
    WMTSTileGrid.prototype.getMatrixId = function (z) {
        return this.matrixIds_[z];
    };
    /**
     * Get the list of matrix identifiers.
     * @return {Array<string>} MatrixIds.
     * @api
     */
    WMTSTileGrid.prototype.getMatrixIds = function () {
        return this.matrixIds_;
    };
    return WMTSTileGrid;
}(_TileGrid_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (WMTSTileGrid);
/**
 * Create a tile grid from a WMTS capabilities matrix set and an
 * optional TileMatrixSetLimits.
 * @param {Object} matrixSet An object representing a matrixSet in the
 *     capabilities document.
 * @param {import("../extent.js").Extent} [opt_extent] An optional extent to restrict the tile
 *     ranges the server provides.
 * @param {Array<Object>} [opt_matrixLimits] An optional object representing
 *     the available matrices for tileGrid.
 * @return {WMTSTileGrid} WMTS tileGrid instance.
 * @api
 */
function createFromCapabilitiesMatrixSet(matrixSet, opt_extent, opt_matrixLimits) {
    /** @type {!Array<number>} */
    var resolutions = [];
    /** @type {!Array<string>} */
    var matrixIds = [];
    /** @type {!Array<import("../coordinate.js").Coordinate>} */
    var origins = [];
    /** @type {!Array<import("../size.js").Size>} */
    var tileSizes = [];
    /** @type {!Array<import("../size.js").Size>} */
    var sizes = [];
    var matrixLimits = opt_matrixLimits !== undefined ? opt_matrixLimits : [];
    var supportedCRSPropName = 'SupportedCRS';
    var matrixIdsPropName = 'TileMatrix';
    var identifierPropName = 'Identifier';
    var scaleDenominatorPropName = 'ScaleDenominator';
    var topLeftCornerPropName = 'TopLeftCorner';
    var tileWidthPropName = 'TileWidth';
    var tileHeightPropName = 'TileHeight';
    var code = matrixSet[supportedCRSPropName];
    var projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["get"])(code);
    var metersPerUnit = projection.getMetersPerUnit();
    // swap origin x and y coordinates if axis orientation is lat/long
    var switchOriginXY = projection.getAxisOrientation().substr(0, 2) == 'ne';
    matrixSet[matrixIdsPropName].sort(function (a, b) {
        return b[scaleDenominatorPropName] - a[scaleDenominatorPropName];
    });
    matrixSet[matrixIdsPropName].forEach(function (elt) {
        var matrixAvailable;
        // use of matrixLimits to filter TileMatrices from GetCapabilities
        // TileMatrixSet from unavailable matrix levels.
        if (matrixLimits.length > 0) {
            matrixAvailable = Object(_array_js__WEBPACK_IMPORTED_MODULE_1__["find"])(matrixLimits, function (elt_ml) {
                if (elt[identifierPropName] == elt_ml[matrixIdsPropName]) {
                    return true;
                }
                // Fallback for tileMatrix identifiers that don't get prefixed
                // by their tileMatrixSet identifiers.
                if (elt[identifierPropName].indexOf(':') === -1) {
                    return (matrixSet[identifierPropName] + ':' + elt[identifierPropName] ===
                        elt_ml[matrixIdsPropName]);
                }
                return false;
            });
        }
        else {
            matrixAvailable = true;
        }
        if (matrixAvailable) {
            matrixIds.push(elt[identifierPropName]);
            var resolution = (elt[scaleDenominatorPropName] * 0.28e-3) / metersPerUnit;
            var tileWidth = elt[tileWidthPropName];
            var tileHeight = elt[tileHeightPropName];
            if (switchOriginXY) {
                origins.push([
                    elt[topLeftCornerPropName][1],
                    elt[topLeftCornerPropName][0],
                ]);
            }
            else {
                origins.push(elt[topLeftCornerPropName]);
            }
            resolutions.push(resolution);
            tileSizes.push(tileWidth == tileHeight ? tileWidth : [tileWidth, tileHeight]);
            sizes.push([elt['MatrixWidth'], elt['MatrixHeight']]);
        }
    });
    return new WMTSTileGrid({
        extent: opt_extent,
        origins: origins,
        resolutions: resolutions,
        matrixIds: matrixIds,
        tileSizes: tileSizes,
        sizes: sizes,
    });
}
//# sourceMappingURL=WMTS.js.map

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* harmony import */ var _control_Attribution_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(159);
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106);
/* harmony import */ var _control_Rotate_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(162);
/* harmony import */ var _control_Zoom_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(163);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Attribution", function() { return _control_Attribution_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _control_Control_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(160);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Control", function() { return _control_Control_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _control_FullScreen_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(164);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FullScreen", function() { return _control_FullScreen_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _control_MousePosition_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(165);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MousePosition", function() { return _control_MousePosition_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _control_OverviewMap_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(167);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OverviewMap", function() { return _control_OverviewMap_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Rotate", function() { return _control_Rotate_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _control_ScaleLine_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(196);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ScaleLine", function() { return _control_ScaleLine_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Zoom", function() { return _control_Zoom_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _control_ZoomSlider_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(197);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomSlider", function() { return _control_ZoomSlider_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _control_ZoomToExtent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(198);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ZoomToExtent", function() { return _control_ZoomToExtent_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/**
 * @module ol/control
 */














/**
 * @typedef {Object} DefaultsOptions
 * @property {boolean} [attribution=true] Include
 * {@link module:ol/control/Attribution~Attribution}.
 * @property {import("./control/Attribution.js").Options} [attributionOptions]
 * Options for {@link module:ol/control/Attribution~Attribution}.
 * @property {boolean} [rotate=true] Include
 * {@link module:ol/control/Rotate~Rotate}.
 * @property {import("./control/Rotate.js").Options} [rotateOptions] Options
 * for {@link module:ol/control/Rotate~Rotate}.
 * @property {boolean} [zoom] Include {@link module:ol/control/Zoom~Zoom}.
 * @property {import("./control/Zoom.js").Options} [zoomOptions] Options for
 * {@link module:ol/control/Zoom~Zoom}.
 * @api
 */
/**
 * Set of controls included in maps by default. Unless configured otherwise,
 * this returns a collection containing an instance of each of the following
 * controls:
 * * {@link module:ol/control/Zoom~Zoom}
 * * {@link module:ol/control/Rotate~Rotate}
 * * {@link module:ol/control/Attribution~Attribution}
 *
 * @param {DefaultsOptions} [opt_options]
 * Defaults options.
 * @return {Collection<import("./control/Control.js").default>}
 * Controls.
 * @api
 */
function defaults(opt_options) {
    var options = opt_options ? opt_options : {};
    var controls = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
    var zoomControl = options.zoom !== undefined ? options.zoom : true;
    if (zoomControl) {
        controls.push(new _control_Zoom_js__WEBPACK_IMPORTED_MODULE_3__["default"](options.zoomOptions));
    }
    var rotateControl = options.rotate !== undefined ? options.rotate : true;
    if (rotateControl) {
        controls.push(new _control_Rotate_js__WEBPACK_IMPORTED_MODULE_2__["default"](options.rotateOptions));
    }
    var attributionControl = options.attribution !== undefined ? options.attribution : true;
    if (attributionControl) {
        controls.push(new _control_Attribution_js__WEBPACK_IMPORTED_MODULE_0__["default"](options.attributionOptions));
    }
    return controls;
}
//# sourceMappingURL=control.js.map

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52);
/* harmony import */ var _layer_Layer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(131);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/Attribution
 */






/**
 * @typedef {Object} Options
 * @property {string} [className='ol-attribution'] CSS class name.
 * @property {HTMLElement|string} [target] Specify a target if you
 * want the control to be rendered outside of the map's
 * viewport.
 * @property {boolean} [collapsible] Specify if attributions can
 * be collapsed. If not specified, sources control this behavior with their
 * `attributionsCollapsible` setting.
 * @property {boolean} [collapsed=true] Specify if attributions should
 * be collapsed at startup.
 * @property {string} [tipLabel='Attributions'] Text label to use for the button tip.
 * @property {string} [label='i'] Text label to use for the
 * collapsed attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [expandClassName=className + '-expand'] CSS class name for the
 * collapsed attributions button.
 * @property {string|HTMLElement} [collapseLabel='»'] Text label to use
 * for the expanded attributions button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [collapseClassName=className + '-collapse'] CSS class name for the
 * expanded attributions button.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 */
/**
 * @classdesc
 * Control to show all the attributions associated with the layer sources
 * in the map. This control is one of the default controls included in maps.
 * By default it will show in the bottom right portion of the map, but this can
 * be changed by using a css selector for `.ol-attribution`.
 *
 * @api
 */
var Attribution = /** @class */ (function (_super) {
    __extends(Attribution, _super);
    /**
     * @param {Options} [opt_options] Attribution options.
     */
    function Attribution(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target,
        }) || this;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.ulElement_ = document.createElement('ul');
        /**
         * @private
         * @type {boolean}
         */
        _this.collapsed_ =
            options.collapsed !== undefined ? options.collapsed : true;
        /**
         * @private
         * @type {boolean}
         */
        _this.userCollapsed_ = _this.collapsed_;
        /**
         * @private
         * @type {boolean}
         */
        _this.overrideCollapsible_ = options.collapsible !== undefined;
        /**
         * @private
         * @type {boolean}
         */
        _this.collapsible_ =
            options.collapsible !== undefined ? options.collapsible : true;
        if (!_this.collapsible_) {
            _this.collapsed_ = false;
        }
        var className = options.className !== undefined ? options.className : 'ol-attribution';
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Attributions';
        var expandClassName = options.expandClassName !== undefined
            ? options.expandClassName
            : className + '-expand';
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00BB';
        var collapseClassName = options.collapseClassName !== undefined
            ? options.collapseClassName
            : className + '-collpase';
        if (typeof collapseLabel === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */
            _this.collapseLabel_ = document.createElement('span');
            _this.collapseLabel_.textContent = collapseLabel;
            _this.collapseLabel_.className = collapseClassName;
        }
        else {
            _this.collapseLabel_ = collapseLabel;
        }
        var label = options.label !== undefined ? options.label : 'i';
        if (typeof label === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */
            _this.label_ = document.createElement('span');
            _this.label_.textContent = label;
            _this.label_.className = expandClassName;
        }
        else {
            _this.label_ = label;
        }
        var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.toggleButton_ = document.createElement('button');
        _this.toggleButton_.setAttribute('type', 'button');
        _this.toggleButton_.setAttribute('aria-expanded', String(!_this.collapsed_));
        _this.toggleButton_.title = tipLabel;
        _this.toggleButton_.appendChild(activeLabel);
        _this.toggleButton_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"] +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_CONTROL"] +
            (_this.collapsed_ && _this.collapsible_ ? ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_COLLAPSED"] : '') +
            (_this.collapsible_ ? '' : ' ol-uncollapsible');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.toggleButton_);
        element.appendChild(_this.ulElement_);
        /**
         * A list of currently rendered resolutions.
         * @type {Array<string>}
         * @private
         */
        _this.renderedAttributions_ = [];
        /**
         * @private
         * @type {boolean}
         */
        _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * Collect a list of visible attributions and set the collapsible state.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @return {Array<string>} Attributions.
     * @private
     */
    Attribution.prototype.collectSourceAttributions_ = function (frameState) {
        /**
         * Used to determine if an attribution already exists.
         * @type {!Object<string, boolean>}
         */
        var lookup = {};
        /**
         * A list of visible attributions.
         * @type {Array<string>}
         */
        var visibleAttributions = [];
        var collapsible = true;
        var layerStatesArray = frameState.layerStatesArray;
        for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
            var layerState = layerStatesArray[i];
            if (!Object(_layer_Layer_js__WEBPACK_IMPORTED_MODULE_4__["inView"])(layerState, frameState.viewState)) {
                continue;
            }
            var source = /** @type {import("../layer/Layer.js").default} */ (layerState.layer).getSource();
            if (!source) {
                continue;
            }
            var attributionGetter = source.getAttributions();
            if (!attributionGetter) {
                continue;
            }
            var attributions = attributionGetter(frameState);
            if (!attributions) {
                continue;
            }
            collapsible =
                collapsible && source.getAttributionsCollapsible() !== false;
            if (Array.isArray(attributions)) {
                for (var j = 0, jj = attributions.length; j < jj; ++j) {
                    if (!(attributions[j] in lookup)) {
                        visibleAttributions.push(attributions[j]);
                        lookup[attributions[j]] = true;
                    }
                }
            }
            else {
                if (!(attributions in lookup)) {
                    visibleAttributions.push(attributions);
                    lookup[attributions] = true;
                }
            }
        }
        if (!this.overrideCollapsible_) {
            this.setCollapsible(collapsible);
        }
        return visibleAttributions;
    };
    /**
     * @private
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    Attribution.prototype.updateElement_ = function (frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        var attributions = this.collectSourceAttributions_(frameState);
        var visible = attributions.length > 0;
        if (this.renderedVisible_ != visible) {
            this.element.style.display = visible ? '' : 'none';
            this.renderedVisible_ = visible;
        }
        if (Object(_array_js__WEBPACK_IMPORTED_MODULE_3__["equals"])(attributions, this.renderedAttributions_)) {
            return;
        }
        Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["removeChildren"])(this.ulElement_);
        // append the attributions
        for (var i = 0, ii = attributions.length; i < ii; ++i) {
            var element = document.createElement('li');
            element.innerHTML = attributions[i];
            this.ulElement_.appendChild(element);
        }
        this.renderedAttributions_ = attributions;
    };
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */
    Attribution.prototype.handleClick_ = function (event) {
        event.preventDefault();
        this.handleToggle_();
        this.userCollapsed_ = this.collapsed_;
    };
    /**
     * @private
     */
    Attribution.prototype.handleToggle_ = function () {
        this.element.classList.toggle(_css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_COLLAPSED"]);
        if (this.collapsed_) {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["replaceNode"])(this.collapseLabel_, this.label_);
        }
        else {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["replaceNode"])(this.label_, this.collapseLabel_);
        }
        this.collapsed_ = !this.collapsed_;
        this.toggleButton_.setAttribute('aria-expanded', String(!this.collapsed_));
    };
    /**
     * Return `true` if the attribution is collapsible, `false` otherwise.
     * @return {boolean} True if the widget is collapsible.
     * @api
     */
    Attribution.prototype.getCollapsible = function () {
        return this.collapsible_;
    };
    /**
     * Set whether the attribution should be collapsible.
     * @param {boolean} collapsible True if the widget is collapsible.
     * @api
     */
    Attribution.prototype.setCollapsible = function (collapsible) {
        if (this.collapsible_ === collapsible) {
            return;
        }
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (this.userCollapsed_) {
            this.handleToggle_();
        }
    };
    /**
     * Collapse or expand the attribution according to the passed parameter. Will
     * not do anything if the attribution isn't collapsible or if the current
     * collapsed state is already the one requested.
     * @param {boolean} collapsed True if the widget is collapsed.
     * @api
     */
    Attribution.prototype.setCollapsed = function (collapsed) {
        this.userCollapsed_ = collapsed;
        if (!this.collapsible_ || this.collapsed_ === collapsed) {
            return;
        }
        this.handleToggle_();
    };
    /**
     * Return `true` when the attribution is currently collapsed or `false`
     * otherwise.
     * @return {boolean} True if the widget is collapsed.
     * @api
     */
    Attribution.prototype.getCollapsed = function () {
        return this.collapsed_;
    };
    /**
     * Update the attribution element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    Attribution.prototype.render = function (mapEvent) {
        this.updateElement_(mapEvent.frameState);
    };
    return Attribution;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Attribution);
//# sourceMappingURL=Attribution.js.map

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _MapEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(161);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/Control
 */





/**
 * @typedef {Object} Options
 * @property {HTMLElement} [element] The element is the control's
 * container element. This only needs to be specified if you're developing
 * a custom control.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when
 * the control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want
 * the control to be rendered outside of the map's viewport.
 */
/**
 * @classdesc
 * A control is a visible widget with a DOM element in a fixed position on the
 * screen. They can involve user input (buttons), or be informational only;
 * the position is determined using CSS. By default these are placed in the
 * container with CSS class name `ol-overlaycontainer-stopevent`, but can use
 * any outside DOM element.
 *
 * This is the base class for controls. You can use it for simple custom
 * controls by creating the element with listeners, creating an instance:
 * ```js
 * var myControl = new Control({element: myElement});
 * ```
 * and then adding this to the map.
 *
 * The main advantage of having this as a control rather than a simple separate
 * DOM element is that preventing propagation is handled for you. Controls
 * will also be objects in a {@link module:ol/Collection~Collection}, so you can use their methods.
 *
 * You can also extend this base for your own control class. See
 * examples/custom-controls for an example of how to do this.
 *
 * @api
 */
var Control = /** @class */ (function (_super) {
    __extends(Control, _super);
    /**
     * @param {Options} options Control options.
     */
    function Control(options) {
        var _this = _super.call(this) || this;
        var element = options.element;
        if (element && !options.target && !element.style.pointerEvents) {
            element.style.pointerEvents = 'auto';
        }
        /**
         * @protected
         * @type {HTMLElement}
         */
        _this.element = element ? element : null;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.target_ = null;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */
        _this.map_ = null;
        /**
         * @protected
         * @type {!Array<import("../events.js").EventsKey>}
         */
        _this.listenerKeys = [];
        if (options.render) {
            _this.render = options.render;
        }
        if (options.target) {
            _this.setTarget(options.target);
        }
        return _this;
    }
    /**
     * Clean up.
     */
    Control.prototype.disposeInternal = function () {
        Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["removeNode"])(this.element);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Get the map associated with this control.
     * @return {import("../PluggableMap.js").default} Map.
     * @api
     */
    Control.prototype.getMap = function () {
        return this.map_;
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    Control.prototype.setMap = function (map) {
        if (this.map_) {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["removeNode"])(this.element);
        }
        for (var i = 0, ii = this.listenerKeys.length; i < ii; ++i) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["unlistenByKey"])(this.listenerKeys[i]);
        }
        this.listenerKeys.length = 0;
        this.map_ = map;
        if (this.map_) {
            var target = this.target_
                ? this.target_
                : map.getOverlayContainerStopEvent();
            target.appendChild(this.element);
            if (this.render !== _functions_js__WEBPACK_IMPORTED_MODULE_2__["VOID"]) {
                this.listenerKeys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["listen"])(map, _MapEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POSTRENDER, this.render, this));
            }
            map.render();
        }
    };
    /**
     * Renders the control.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @api
     */
    Control.prototype.render = function (mapEvent) { };
    /**
     * This function is used to set a target element for the control. It has no
     * effect if it is called after the control has been added to the map (i.e.
     * after `setMap` is called on the control). If no `target` is set in the
     * options passed to the control constructor and if `setTarget` is not called
     * then the control is added to the map's overlay container.
     * @param {HTMLElement|string} target Target.
     * @api
     */
    Control.prototype.setTarget = function (target) {
        this.target_ =
            typeof target === 'string' ? document.getElementById(target) : target;
    };
    return Control;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Control);
//# sourceMappingURL=Control.js.map

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/MapEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Triggered after a map frame is rendered.
     * @event module:ol/MapEvent~MapEvent#postrender
     * @api
     */
    POSTRENDER: 'postrender',
    /**
     * Triggered when the map starts moving.
     * @event module:ol/MapEvent~MapEvent#movestart
     * @api
     */
    MOVESTART: 'movestart',
    /**
     * Triggered after the map is moved.
     * @event module:ol/MapEvent~MapEvent#moveend
     * @api
     */
    MOVEEND: 'moveend',
});
/***
 * @typedef {'postrender'|'movestart'|'moveend'} Types
 */
//# sourceMappingURL=MapEventType.js.map

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/Rotate
 */




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-rotate'] CSS class name.
 * @property {string|HTMLElement} [label='⇧'] Text label to use for the rotate button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Reset rotation'] Text label to use for the rotate tip.
 * @property {string} [compassClassName='ol-compass'] CSS class name for the compass.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {boolean} [autoHide=true] Hide the control when rotation is 0.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control should
 * be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {function():void} [resetNorth] Function called when the control is clicked.
 * This will override the default `resetNorth`.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */
/**
 * @classdesc
 * A button control to reset rotation to 0.
 * To style this control use css selector `.ol-rotate`. A `.ol-hidden` css
 * selector is added to the button when the rotation is 0.
 *
 * @api
 */
var Rotate = /** @class */ (function (_super) {
    __extends(Rotate, _super);
    /**
     * @param {Options} [opt_options] Rotate options.
     */
    function Rotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target,
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-rotate';
        var label = options.label !== undefined ? options.label : '\u21E7';
        var compassClassName = options.compassClassName !== undefined
            ? options.compassClassName
            : 'ol-compass';
        /**
         * @type {HTMLElement}
         * @private
         */
        _this.label_ = null;
        if (typeof label === 'string') {
            _this.label_ = document.createElement('span');
            _this.label_.className = compassClassName;
            _this.label_.textContent = label;
        }
        else {
            _this.label_ = label;
            _this.label_.classList.add(compassClassName);
        }
        var tipLabel = options.tipLabel ? options.tipLabel : 'Reset rotation';
        var button = document.createElement('button');
        button.className = className + '-reset';
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(_this.label_);
        button.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"] + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_CONTROL"];
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(button);
        _this.callResetNorth_ = options.resetNorth ? options.resetNorth : undefined;
        /**
         * @type {number}
         * @private
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @type {boolean}
         * @private
         */
        _this.autoHide_ = options.autoHide !== undefined ? options.autoHide : true;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.rotation_ = undefined;
        if (_this.autoHide_) {
            _this.element.classList.add(_css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_HIDDEN"]);
        }
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */
    Rotate.prototype.handleClick_ = function (event) {
        event.preventDefault();
        if (this.callResetNorth_ !== undefined) {
            this.callResetNorth_();
        }
        else {
            this.resetNorth_();
        }
    };
    /**
     * @private
     */
    Rotate.prototype.resetNorth_ = function () {
        var map = this.getMap();
        var view = map.getView();
        if (!view) {
            // the map does not have a view, so we can't act
            // upon it
            return;
        }
        var rotation = view.getRotation();
        if (rotation !== undefined) {
            if (this.duration_ > 0 && rotation % (2 * Math.PI) !== 0) {
                view.animate({
                    rotation: 0,
                    duration: this.duration_,
                    easing: _easing_js__WEBPACK_IMPORTED_MODULE_3__["easeOut"],
                });
            }
            else {
                view.setRotation(0);
            }
        }
    };
    /**
     * Update the rotate control element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    Rotate.prototype.render = function (mapEvent) {
        var frameState = mapEvent.frameState;
        if (!frameState) {
            return;
        }
        var rotation = frameState.viewState.rotation;
        if (rotation != this.rotation_) {
            var transform = 'rotate(' + rotation + 'rad)';
            if (this.autoHide_) {
                var contains = this.element.classList.contains(_css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_HIDDEN"]);
                if (!contains && rotation === 0) {
                    this.element.classList.add(_css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_HIDDEN"]);
                }
                else if (contains && rotation !== 0) {
                    this.element.classList.remove(_css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_HIDDEN"]);
                }
            }
            this.label_.style.transform = transform;
        }
        this.rotation_ = rotation;
    };
    return Rotate;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Rotate);
//# sourceMappingURL=Rotate.js.map

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/Zoom
 */




/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {string} [className='ol-zoom'] CSS class name.
 * @property {string} [zoomInClassName=className + '-in'] CSS class name for the zoom-in button.
 * @property {string} [zoomOutClassName=className + '-out'] CSS class name for the zoom-out button.
 * @property {string|HTMLElement} [zoomInLabel='+'] Text label to use for the zoom-in
 * button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|HTMLElement} [zoomOutLabel='-'] Text label to use for the zoom-out button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [zoomInTipLabel='Zoom in'] Text label to use for the button tip.
 * @property {string} [zoomOutTipLabel='Zoom out'] Text label to use for the button tip.
 * @property {number} [delta=1] The zoom delta applied on each click.
 * @property {HTMLElement|string} [target] Specify a target if you want the control to be
 * rendered outside of the map's viewport.
 */
/**
 * @classdesc
 * A control with 2 buttons, one for zoom in and one for zoom out.
 * This control is one of the default controls of a map. To style this control
 * use css selectors `.ol-zoom-in` and `.ol-zoom-out`.
 *
 * @api
 */
var Zoom = /** @class */ (function (_super) {
    __extends(Zoom, _super);
    /**
     * @param {Options} [opt_options] Zoom options.
     */
    function Zoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target,
        }) || this;
        var className = options.className !== undefined ? options.className : 'ol-zoom';
        var delta = options.delta !== undefined ? options.delta : 1;
        var zoomInClassName = options.zoomInClassName !== undefined
            ? options.zoomInClassName
            : className + '-in';
        var zoomOutClassName = options.zoomOutClassName !== undefined
            ? options.zoomOutClassName
            : className + '-out';
        var zoomInLabel = options.zoomInLabel !== undefined ? options.zoomInLabel : '+';
        var zoomOutLabel = options.zoomOutLabel !== undefined ? options.zoomOutLabel : '\u2212';
        var zoomInTipLabel = options.zoomInTipLabel !== undefined ? options.zoomInTipLabel : 'Zoom in';
        var zoomOutTipLabel = options.zoomOutTipLabel !== undefined
            ? options.zoomOutTipLabel
            : 'Zoom out';
        var inElement = document.createElement('button');
        inElement.className = zoomInClassName;
        inElement.setAttribute('type', 'button');
        inElement.title = zoomInTipLabel;
        inElement.appendChild(typeof zoomInLabel === 'string'
            ? document.createTextNode(zoomInLabel)
            : zoomInLabel);
        inElement.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this, delta), false);
        var outElement = document.createElement('button');
        outElement.className = zoomOutClassName;
        outElement.setAttribute('type', 'button');
        outElement.title = zoomOutTipLabel;
        outElement.appendChild(typeof zoomOutLabel === 'string'
            ? document.createTextNode(zoomOutLabel)
            : zoomOutLabel);
        outElement.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this, -delta), false);
        var cssClasses = className + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"] + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_CONTROL"];
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(inElement);
        element.appendChild(outElement);
        /**
         * @type {number}
         * @private
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * @param {number} delta Zoom delta.
     * @param {MouseEvent} event The event to handle
     * @private
     */
    Zoom.prototype.handleClick_ = function (delta, event) {
        event.preventDefault();
        this.zoomByDelta_(delta);
    };
    /**
     * @param {number} delta Zoom delta.
     * @private
     */
    Zoom.prototype.zoomByDelta_ = function (delta) {
        var map = this.getMap();
        var view = map.getView();
        if (!view) {
            // the map does not have a view, so we can't act
            // upon it
            return;
        }
        var currentZoom = view.getZoom();
        if (currentZoom !== undefined) {
            var newZoom = view.getConstrainedZoom(currentZoom + delta);
            if (this.duration_ > 0) {
                if (view.getAnimating()) {
                    view.cancelAnimations();
                }
                view.animate({
                    zoom: newZoom,
                    duration: this.duration_,
                    easing: _easing_js__WEBPACK_IMPORTED_MODULE_3__["easeOut"],
                });
            }
            else {
                view.setZoom(newZoom);
            }
        }
    };
    return Zoom;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Zoom);
//# sourceMappingURL=Zoom.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/FullScreen
 */





var events = [
    'fullscreenchange',
    'webkitfullscreenchange',
    'MSFullscreenChange',
];
/**
 * @enum {string}
 */
var FullScreenEventType = {
    /**
     * Triggered after the map entered fullscreen.
     * @event FullScreenEventType#enterfullscreen
     * @api
     */
    ENTERFULLSCREEN: 'enterfullscreen',
    /**
     * Triggered after the map leave fullscreen.
     * @event FullScreenEventType#leavefullscreen
     * @api
     */
    LEAVEFULLSCREEN: 'leavefullscreen',
};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen', import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types, import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|
 *     'enterfullscreen'|'leavefullscreen'|import("../ObjectEventType").Types, Return>} FullScreenOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-full-screen'] CSS class name.
 * @property {string|Text} [label='\u2922'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string|Text} [labelActive='\u00d7'] Text label to use for the
 * button when full-screen is active.
 * @property {string} [activeClassName=className + '-true'] CSS class name for the button
 * when full-screen is active.
 * @property {string} [inactiveClassName=className + '-false'] CSS class name for the button
 * when full-screen is inactive.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Toggle full-screen'] Text label to use for the button tip.
 * @property {boolean} [keys=false] Full keyboard access.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {HTMLElement|string} [source] The element to be displayed
 * fullscreen. When not provided, the element containing the map viewport will
 * be displayed fullscreen.
 */
/**
 * @classdesc
 * Provides a button that when clicked fills up the full screen with the map.
 * The full screen source element is by default the element containing the map viewport unless
 * overridden by providing the `source` option. In which case, the dom
 * element introduced using this parameter will be displayed in full screen.
 *
 * When in full screen mode, a close button is shown to exit full screen mode.
 * The [Fullscreen API](https://www.w3.org/TR/fullscreen/) is used to
 * toggle the map in full screen mode.
 *
 * @fires FullScreenEventType#enterfullscreen
 * @fires FullScreenEventType#leavefullscreen
 * @api
 */
var FullScreen = /** @class */ (function (_super) {
    __extends(FullScreen, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function FullScreen(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target,
        }) || this;
        /***
         * @type {FullScreenOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {FullScreenOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {FullScreenOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {string}
         */
        _this.cssClassName_ =
            options.className !== undefined ? options.className : 'ol-full-screen';
        /**
         * @private
         * @type {Array<string>}
         */
        _this.activeClassName_ =
            options.activeClassName !== undefined
                ? options.activeClassName.split(' ')
                : [_this.cssClassName_ + '-true'];
        /**
         * @private
         * @type {Array<string>}
         */
        _this.inactiveClassName_ =
            options.inactiveClassName !== undefined
                ? options.inactiveClassName.split(' ')
                : [_this.cssClassName_ + '-false'];
        var label = options.label !== undefined ? options.label : '\u2922';
        /**
         * @private
         * @type {Text}
         */
        _this.labelNode_ =
            typeof label === 'string' ? document.createTextNode(label) : label;
        var labelActive = options.labelActive !== undefined ? options.labelActive : '\u00d7';
        /**
         * @private
         * @type {Text}
         */
        _this.labelActiveNode_ =
            typeof labelActive === 'string'
                ? document.createTextNode(labelActive)
                : labelActive;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.button_ = document.createElement('button');
        var tipLabel = options.tipLabel ? options.tipLabel : 'Toggle full-screen';
        _this.setClassName_(_this.button_, isFullScreen());
        _this.button_.setAttribute('type', 'button');
        _this.button_.title = tipLabel;
        _this.button_.appendChild(_this.labelNode_);
        _this.button_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = _this.cssClassName_ +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"] +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_CONTROL"] +
            ' ' +
            (!isFullScreenSupported() ? _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSUPPORTED"] : '');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.button_);
        /**
         * @private
         * @type {boolean}
         */
        _this.keys_ = options.keys !== undefined ? options.keys : false;
        /**
         * @private
         * @type {HTMLElement|string|undefined}
         */
        _this.source_ = options.source;
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */
    FullScreen.prototype.handleClick_ = function (event) {
        event.preventDefault();
        this.handleFullScreen_();
    };
    /**
     * @private
     */
    FullScreen.prototype.handleFullScreen_ = function () {
        if (!isFullScreenSupported()) {
            return;
        }
        var map = this.getMap();
        if (!map) {
            return;
        }
        if (isFullScreen()) {
            exitFullScreen();
        }
        else {
            var element = void 0;
            if (this.source_) {
                element =
                    typeof this.source_ === 'string'
                        ? document.getElementById(this.source_)
                        : this.source_;
            }
            else {
                element = map.getTargetElement();
            }
            if (this.keys_) {
                requestFullScreenWithKeys(element);
            }
            else {
                requestFullScreen(element);
            }
        }
    };
    /**
     * @private
     */
    FullScreen.prototype.handleFullScreenChange_ = function () {
        var map = this.getMap();
        if (isFullScreen()) {
            this.setClassName_(this.button_, true);
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["replaceNode"])(this.labelActiveNode_, this.labelNode_);
            this.dispatchEvent(FullScreenEventType.ENTERFULLSCREEN);
        }
        else {
            this.setClassName_(this.button_, false);
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["replaceNode"])(this.labelNode_, this.labelActiveNode_);
            this.dispatchEvent(FullScreenEventType.LEAVEFULLSCREEN);
        }
        if (map) {
            map.updateSize();
        }
    };
    /**
     * @param {HTMLElement} element Target element
     * @param {boolean} fullscreen True if fullscreen class name should be active
     * @private
     */
    FullScreen.prototype.setClassName_ = function (element, fullscreen) {
        var _a, _b, _c;
        var activeClassName = this.activeClassName_;
        var inactiveClassName = this.inactiveClassName_;
        var nextClassName = fullscreen ? activeClassName : inactiveClassName;
        (_a = element.classList).remove.apply(_a, activeClassName);
        (_b = element.classList).remove.apply(_b, inactiveClassName);
        (_c = element.classList).add.apply(_c, nextClassName);
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    FullScreen.prototype.setMap = function (map) {
        _super.prototype.setMap.call(this, map);
        if (map) {
            for (var i = 0, ii = events.length; i < ii; ++i) {
                this.listenerKeys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["listen"])(document, events[i], this.handleFullScreenChange_, this));
            }
        }
    };
    return FullScreen;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @return {boolean} Fullscreen is supported by the current platform.
 */
function isFullScreenSupported() {
    var body = document.body;
    return !!(body['webkitRequestFullscreen'] ||
        (body['msRequestFullscreen'] && document['msFullscreenEnabled']) ||
        (body.requestFullscreen && document.fullscreenEnabled));
}
/**
 * @return {boolean} Element is currently in fullscreen.
 */
function isFullScreen() {
    return !!(document['webkitIsFullScreen'] ||
        document['msFullscreenElement'] ||
        document.fullscreenElement);
}
/**
 * Request to fullscreen an element.
 * @param {HTMLElement} element Element to request fullscreen
 */
function requestFullScreen(element) {
    if (element.requestFullscreen) {
        element.requestFullscreen();
    }
    else if (element['msRequestFullscreen']) {
        element['msRequestFullscreen']();
    }
    else if (element['webkitRequestFullscreen']) {
        element['webkitRequestFullscreen']();
    }
}
/**
 * Request to fullscreen an element with keyboard input.
 * @param {HTMLElement} element Element to request fullscreen
 */
function requestFullScreenWithKeys(element) {
    if (element['webkitRequestFullscreen']) {
        element['webkitRequestFullscreen']();
    }
    else {
        requestFullScreen(element);
    }
}
/**
 * Exit fullscreen.
 */
function exitFullScreen() {
    if (document.exitFullscreen) {
        document.exitFullscreen();
    }
    else if (document['msExitFullscreen']) {
        document['msExitFullscreen']();
    }
    else if (document['webkitExitFullscreen']) {
        document['webkitExitFullscreen']();
    }
}
/* harmony default export */ __webpack_exports__["default"] = (FullScreen);
//# sourceMappingURL=FullScreen.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(166);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54);
/**
 * @module ol/control/MousePosition
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




/**
 * @type {string}
 */
var PROJECTION = 'projection';
/**
 * @type {string}
 */
var COORDINATE_FORMAT = 'coordinateFormat';
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:coordinateFormat'|'change:projection', Return>} MousePositionOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-mouse-position'] CSS class name.
 * @property {import("../coordinate.js").CoordinateFormat} [coordinateFormat] Coordinate format.
 * @property {import("../proj.js").ProjectionLike} [projection] Projection. Default is the view projection.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the
 * control should be re-rendered. This is called in a `requestAnimationFrame`
 * callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the
 * control to be rendered outside of the map's viewport.
 * @property {string|boolean} [placeholder] Markup to show when the mouse position is not
 * available (e.g. when the pointer leaves the map viewport).  By default, a non-breaking space
 * is rendered when the mouse leaves the viewport.  To render something else, provide a string
 * to be used as the text content (e.g. 'no position' or '' for an empty string).  Set the placeholder
 * to `false` to retain the last position when the mouse leaves the viewport.  In a future release, this
 * will be the default behavior.
 * @property {string} [undefinedHTML='&#160;'] This option is deprecated.  Use the `placeholder` option instead.
 */
/**
 * @classdesc
 * A control to show the 2D coordinates of the mouse cursor. By default, these
 * are in the view projection, but can be in any supported projection.
 * By default the control is shown in the top right corner of the map, but this
 * can be changed by using the css selector `.ol-mouse-position`.
 *
 * On touch devices, which usually do not have a mouse cursor, the coordinates
 * of the currently touched position are shown.
 *
 * @api
 */
var MousePosition = /** @class */ (function (_super) {
    __extends(MousePosition, _super);
    /**
     * @param {Options} [opt_options] Mouse position options.
     */
    function MousePosition(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var element = document.createElement('div');
        element.className =
            options.className !== undefined ? options.className : 'ol-mouse-position';
        _this = _super.call(this, {
            element: element,
            render: options.render,
            target: options.target,
        }) || this;
        /***
         * @type {MousePositionOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {MousePositionOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {MousePositionOnSignature<void>}
         */
        _this.un;
        _this.addChangeListener(PROJECTION, _this.handleProjectionChanged_);
        if (options.coordinateFormat) {
            _this.setCoordinateFormat(options.coordinateFormat);
        }
        if (options.projection) {
            _this.setProjection(options.projection);
        }
        /**
         * @type {boolean}
         * Change this to `false` when removing the deprecated `undefinedHTML` option.
         */
        var renderOnMouseOut = true;
        /**
         * @type {string}
         */
        var placeholder = '&#160;';
        if ('undefinedHTML' in options) {
            // deprecated behavior
            if (options.undefinedHTML !== undefined) {
                placeholder = options.undefinedHTML;
            }
            renderOnMouseOut = !!placeholder;
        }
        else if ('placeholder' in options) {
            if (options.placeholder === false) {
                renderOnMouseOut = false;
            }
            else {
                placeholder = String(options.placeholder);
            }
        }
        /**
         * @private
         * @type {string}
         */
        _this.placeholder_ = placeholder;
        /**
         * @private
         * @type {boolean}
         */
        _this.renderOnMouseOut_ = renderOnMouseOut;
        /**
         * @private
         * @type {string}
         */
        _this.renderedHTML_ = element.innerHTML;
        /**
         * @private
         * @type {?import("../proj/Projection.js").default}
         */
        _this.mapProjection_ = null;
        /**
         * @private
         * @type {?import("../proj.js").TransformFunction}
         */
        _this.transform_ = null;
        return _this;
    }
    /**
     * @private
     */
    MousePosition.prototype.handleProjectionChanged_ = function () {
        this.transform_ = null;
    };
    /**
     * Return the coordinate format type used to render the current position or
     * undefined.
     * @return {import("../coordinate.js").CoordinateFormat|undefined} The format to render the current
     *     position in.
     * @observable
     * @api
     */
    MousePosition.prototype.getCoordinateFormat = function () {
        return /** @type {import("../coordinate.js").CoordinateFormat|undefined} */ (this.get(COORDINATE_FORMAT));
    };
    /**
     * Return the projection that is used to report the mouse position.
     * @return {import("../proj/Projection.js").default|undefined} The projection to report mouse
     *     position in.
     * @observable
     * @api
     */
    MousePosition.prototype.getProjection = function () {
        return /** @type {import("../proj/Projection.js").default|undefined} */ (this.get(PROJECTION));
    };
    /**
     * @param {MouseEvent} event Browser event.
     * @protected
     */
    MousePosition.prototype.handleMouseMove = function (event) {
        var map = this.getMap();
        this.updateHTML_(map.getEventPixel(event));
    };
    /**
     * @param {Event} event Browser event.
     * @protected
     */
    MousePosition.prototype.handleMouseOut = function (event) {
        this.updateHTML_(null);
    };
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    MousePosition.prototype.setMap = function (map) {
        _super.prototype.setMap.call(this, map);
        if (map) {
            var viewport = map.getViewport();
            this.listenerKeys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["listen"])(viewport, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERMOVE, this.handleMouseMove, this));
            if (this.renderOnMouseOut_) {
                this.listenerKeys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_3__["listen"])(viewport, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTEROUT, this.handleMouseOut, this));
            }
            this.updateHTML_(null);
        }
    };
    /**
     * Set the coordinate format type used to render the current position.
     * @param {import("../coordinate.js").CoordinateFormat} format The format to render the current
     *     position in.
     * @observable
     * @api
     */
    MousePosition.prototype.setCoordinateFormat = function (format) {
        this.set(COORDINATE_FORMAT, format);
    };
    /**
     * Set the projection that is used to report the mouse position.
     * @param {import("../proj.js").ProjectionLike} projection The projection to report mouse
     *     position in.
     * @observable
     * @api
     */
    MousePosition.prototype.setProjection = function (projection) {
        this.set(PROJECTION, Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["get"])(projection));
    };
    /**
     * @param {?import("../pixel.js").Pixel} pixel Pixel.
     * @private
     */
    MousePosition.prototype.updateHTML_ = function (pixel) {
        var html = this.placeholder_;
        if (pixel && this.mapProjection_) {
            if (!this.transform_) {
                var projection = this.getProjection();
                if (projection) {
                    this.transform_ = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["getTransformFromProjections"])(this.mapProjection_, projection);
                }
                else {
                    this.transform_ = _proj_js__WEBPACK_IMPORTED_MODULE_2__["identityTransform"];
                }
            }
            var map = this.getMap();
            var coordinate = map.getCoordinateFromPixelInternal(pixel);
            if (coordinate) {
                var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["getUserProjection"])();
                if (userProjection) {
                    this.transform_ = Object(_proj_js__WEBPACK_IMPORTED_MODULE_2__["getTransformFromProjections"])(this.mapProjection_, userProjection);
                }
                this.transform_(coordinate, coordinate);
                var coordinateFormat = this.getCoordinateFormat();
                if (coordinateFormat) {
                    html = coordinateFormat(coordinate);
                }
                else {
                    html = coordinate.toString();
                }
            }
        }
        if (!this.renderedHTML_ || html !== this.renderedHTML_) {
            this.element.innerHTML = html;
            this.renderedHTML_ = html;
        }
    };
    /**
     * Update the projection. Rendering of the coordinates is done in
     * `handleMouseMove` and `handleMouseUp`.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    MousePosition.prototype.render = function (mapEvent) {
        var frameState = mapEvent.frameState;
        if (!frameState) {
            this.mapProjection_ = null;
        }
        else {
            if (this.mapProjection_ != frameState.viewState.projection) {
                this.mapProjection_ = frameState.viewState.projection;
                this.transform_ = null;
            }
        }
    };
    return MousePosition;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MousePosition);
//# sourceMappingURL=MousePosition.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/pointer/EventType
 */
/**
 * Constants for event names.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel',
});
//# sourceMappingURL=EventType.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _renderer_Composite_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(168);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53);
/* harmony import */ var _MapEventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(161);
/* harmony import */ var _MapProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(170);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47);
/* harmony import */ var _Overlay_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(171);
/* harmony import */ var _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(172);
/* harmony import */ var _PluggableMap_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(173);
/* harmony import */ var _View_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(179);
/* harmony import */ var _ViewProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(180);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(55);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(184);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/OverviewMap
 */
















/**
 * Maximum width and/or height extent ratio that determines when the overview
 * map should be zoomed out.
 * @type {number}
 */
var MAX_RATIO = 0.75;
/**
 * Minimum width and/or height extent ratio that determines when the overview
 * map should be zoomed in.
 * @type {number}
 */
var MIN_RATIO = 0.1;
var ControlledMap = /** @class */ (function (_super) {
    __extends(ControlledMap, _super);
    function ControlledMap() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ControlledMap.prototype.createRenderer = function () {
        return new _renderer_Composite_js__WEBPACK_IMPORTED_MODULE_0__["default"](this);
    };
    return ControlledMap;
}(_PluggableMap_js__WEBPACK_IMPORTED_MODULE_8__["default"]));
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-overviewmap'] CSS class name.
 * @property {boolean} [collapsed=true] Whether the control should start collapsed or not (expanded).
 * @property {string|HTMLElement} [collapseLabel='«'] Text label to use for the
 * expanded overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {boolean} [collapsible=true] Whether the control can be collapsed or not.
 * @property {string|HTMLElement} [label='»'] Text label to use for the collapsed
 * overviewmap button. Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {Array<import("../layer/Layer.js").default>|import("../Collection.js").default<import("../layer/Layer.js").default>} [layers]
 * Layers for the overview map.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {boolean} [rotateWithView=false] Whether the control view should rotate with the main map view.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {string} [tipLabel='Overview map'] Text label to use for the button tip.
 * @property {View} [view] Custom view for the overview map (should use same projection as main map). If not provided,
 * a default view with the same projection as the main map will be used.
 */
/**
 * Create a new control with a map acting as an overview map for another
 * defined map.
 *
 * @api
 */
var OverviewMap = /** @class */ (function (_super) {
    __extends(OverviewMap, _super);
    /**
     * @param {Options} [opt_options] OverviewMap options.
     */
    function OverviewMap(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target,
        }) || this;
        /**
         * @private
         */
        _this.boundHandleRotationChanged_ = _this.handleRotationChanged_.bind(_this);
        /**
         * @type {boolean}
         * @private
         */
        _this.collapsed_ =
            options.collapsed !== undefined ? options.collapsed : true;
        /**
         * @private
         * @type {boolean}
         */
        _this.collapsible_ =
            options.collapsible !== undefined ? options.collapsible : true;
        if (!_this.collapsible_) {
            _this.collapsed_ = false;
        }
        /**
         * @private
         * @type {boolean}
         */
        _this.rotateWithView_ =
            options.rotateWithView !== undefined ? options.rotateWithView : false;
        /**
         * @private
         * @type {import("../extent.js").Extent|undefined}
         */
        _this.viewExtent_ = undefined;
        var className = options.className !== undefined ? options.className : 'ol-overviewmap';
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Overview map';
        var collapseLabel = options.collapseLabel !== undefined ? options.collapseLabel : '\u00AB';
        if (typeof collapseLabel === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */
            _this.collapseLabel_ = document.createElement('span');
            _this.collapseLabel_.textContent = collapseLabel;
        }
        else {
            _this.collapseLabel_ = collapseLabel;
        }
        var label = options.label !== undefined ? options.label : '\u00BB';
        if (typeof label === 'string') {
            /**
             * @private
             * @type {HTMLElement}
             */
            _this.label_ = document.createElement('span');
            _this.label_.textContent = label;
        }
        else {
            _this.label_ = label;
        }
        var activeLabel = _this.collapsible_ && !_this.collapsed_ ? _this.collapseLabel_ : _this.label_;
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(activeLabel);
        button.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CLICK, _this.handleClick_.bind(_this), false);
        /**
         * @type {HTMLElement}
         * @private
         */
        _this.ovmapDiv_ = document.createElement('div');
        _this.ovmapDiv_.className = 'ol-overviewmap-map';
        /**
         * Explicitly given view to be used instead of a view derived from the main map.
         * @type {View}
         * @private
         */
        _this.view_ = options.view;
        /**
         * @type {ControlledMap}
         * @private
         */
        _this.ovmap_ = new ControlledMap({
            view: options.view,
        });
        var ovmap = _this.ovmap_;
        if (options.layers) {
            options.layers.forEach(function (layer) {
                ovmap.addLayer(layer);
            });
        }
        var box = document.createElement('div');
        box.className = 'ol-overviewmap-box';
        box.style.boxSizing = 'border-box';
        /**
         * @type {import("../Overlay.js").default}
         * @private
         */
        _this.boxOverlay_ = new _Overlay_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
            position: [0, 0],
            positioning: _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_7__["default"].CENTER_CENTER,
            element: box,
        });
        _this.ovmap_.addOverlay(_this.boxOverlay_);
        var cssClasses = className +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_11__["CLASS_UNSELECTABLE"] +
            ' ' +
            _css_js__WEBPACK_IMPORTED_MODULE_11__["CLASS_CONTROL"] +
            (_this.collapsed_ && _this.collapsible_ ? ' ' + _css_js__WEBPACK_IMPORTED_MODULE_11__["CLASS_COLLAPSED"] : '') +
            (_this.collapsible_ ? '' : ' ol-uncollapsible');
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(_this.ovmapDiv_);
        element.appendChild(button);
        /* Interactive map */
        var scope = _this;
        var overlay = _this.boxOverlay_;
        var overlayBox = _this.boxOverlay_.getElement();
        /* Functions definition */
        var computeDesiredMousePosition = function (mousePosition) {
            return {
                clientX: mousePosition.clientX,
                clientY: mousePosition.clientY,
            };
        };
        var move = function (event) {
            var position = /** @type {?} */ (computeDesiredMousePosition(event));
            var coordinates = ovmap.getEventCoordinateInternal(
            /** @type {MouseEvent} */ (position));
            overlay.setPosition(coordinates);
        };
        var endMoving = function (event) {
            var coordinates = ovmap.getEventCoordinateInternal(event);
            scope.getMap().getView().setCenterInternal(coordinates);
            window.removeEventListener('mousemove', move);
            window.removeEventListener('mouseup', endMoving);
        };
        /* Binding */
        overlayBox.addEventListener('mousedown', function () {
            window.addEventListener('mousemove', move);
            window.addEventListener('mouseup', endMoving);
        });
        return _this;
    }
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    OverviewMap.prototype.setMap = function (map) {
        var oldMap = this.getMap();
        if (map === oldMap) {
            return;
        }
        if (oldMap) {
            var oldView = oldMap.getView();
            if (oldView) {
                this.unbindView_(oldView);
            }
            this.ovmap_.setTarget(null);
        }
        _super.prototype.setMap.call(this, map);
        if (map) {
            this.ovmap_.setTarget(this.ovmapDiv_);
            this.listenerKeys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(map, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_5__["default"].PROPERTYCHANGE, this.handleMapPropertyChange_, this));
            var view = map.getView();
            if (view) {
                this.bindView_(view);
                if (view.isDef()) {
                    this.ovmap_.updateSize();
                    this.resetExtent_();
                }
            }
            if (!this.ovmap_.isRendered()) {
                this.updateBoxAfterOvmapIsRendered_();
            }
        }
    };
    /**
     * Handle map property changes.  This only deals with changes to the map's view.
     * @param {import("../Object.js").ObjectEvent} event The propertychange event.
     * @private
     */
    OverviewMap.prototype.handleMapPropertyChange_ = function (event) {
        if (event.key === _MapProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].VIEW) {
            var oldView = /** @type {import("../View.js").default} */ (event.oldValue);
            if (oldView) {
                this.unbindView_(oldView);
            }
            var newView = this.getMap().getView();
            this.bindView_(newView);
        }
        else if (!this.ovmap_.isRendered() &&
            (event.key === _MapProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].TARGET || event.key === _MapProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].SIZE)) {
            this.ovmap_.updateSize();
        }
    };
    /**
     * Register listeners for view property changes.
     * @param {import("../View.js").default} view The view.
     * @private
     */
    OverviewMap.prototype.bindView_ = function (view) {
        if (!this.view_) {
            // Unless an explicit view definition was given, derive default from whatever main map uses.
            var newView = new _View_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                projection: view.getProjection(),
            });
            this.ovmap_.setView(newView);
        }
        view.addChangeListener(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].ROTATION, this.boundHandleRotationChanged_);
        // Sync once with the new view
        this.handleRotationChanged_();
    };
    /**
     * Unregister listeners for view property changes.
     * @param {import("../View.js").default} view The view.
     * @private
     */
    OverviewMap.prototype.unbindView_ = function (view) {
        view.removeChangeListener(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].ROTATION, this.boundHandleRotationChanged_);
    };
    /**
     * Handle rotation changes to the main map.
     * @private
     */
    OverviewMap.prototype.handleRotationChanged_ = function () {
        if (this.rotateWithView_) {
            this.ovmap_.getView().setRotation(this.getMap().getView().getRotation());
        }
    };
    /**
     * Reset the overview map extent if the box size (width or
     * height) is less than the size of the overview map size times minRatio
     * or is greater than the size of the overview size times maxRatio.
     *
     * If the map extent was not reset, the box size can fits in the defined
     * ratio sizes. This method then checks if is contained inside the overview
     * map current extent. If not, recenter the overview map to the current
     * main map center location.
     * @private
     */
    OverviewMap.prototype.validateExtent_ = function () {
        var map = this.getMap();
        var ovmap = this.ovmap_;
        if (!map.isRendered() || !ovmap.isRendered()) {
            return;
        }
        var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
        var view = map.getView();
        var extent = view.calculateExtentInternal(mapSize);
        if (this.viewExtent_ && Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["equals"])(extent, this.viewExtent_)) {
            // repeats of the same extent may indicate constraint conflicts leading to an endless cycle
            return;
        }
        this.viewExtent_ = extent;
        var ovmapSize = /** @type {import("../size.js").Size} */ (ovmap.getSize());
        var ovview = ovmap.getView();
        var ovextent = ovview.calculateExtentInternal(ovmapSize);
        var topLeftPixel = ovmap.getPixelFromCoordinateInternal(Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getTopLeft"])(extent));
        var bottomRightPixel = ovmap.getPixelFromCoordinateInternal(Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getBottomRight"])(extent));
        var boxWidth = Math.abs(topLeftPixel[0] - bottomRightPixel[0]);
        var boxHeight = Math.abs(topLeftPixel[1] - bottomRightPixel[1]);
        var ovmapWidth = ovmapSize[0];
        var ovmapHeight = ovmapSize[1];
        if (boxWidth < ovmapWidth * MIN_RATIO ||
            boxHeight < ovmapHeight * MIN_RATIO ||
            boxWidth > ovmapWidth * MAX_RATIO ||
            boxHeight > ovmapHeight * MAX_RATIO) {
            this.resetExtent_();
        }
        else if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsExtent"])(ovextent, extent)) {
            this.recenter_();
        }
    };
    /**
     * Reset the overview map extent to half calculated min and max ratio times
     * the extent of the main map.
     * @private
     */
    OverviewMap.prototype.resetExtent_ = function () {
        if (MAX_RATIO === 0 || MIN_RATIO === 0) {
            return;
        }
        var map = this.getMap();
        var ovmap = this.ovmap_;
        var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
        var view = map.getView();
        var extent = view.calculateExtentInternal(mapSize);
        var ovview = ovmap.getView();
        // get how many times the current map overview could hold different
        // box sizes using the min and max ratio, pick the step in the middle used
        // to calculate the extent from the main map to set it to the overview map,
        var steps = Math.log(MAX_RATIO / MIN_RATIO) / Math.LN2;
        var ratio = 1 / (Math.pow(2, steps / 2) * MIN_RATIO);
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["scaleFromCenter"])(extent, ratio);
        ovview.fitInternal(Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__["fromExtent"])(extent));
    };
    /**
     * Set the center of the overview map to the map center without changing its
     * resolution.
     * @private
     */
    OverviewMap.prototype.recenter_ = function () {
        var map = this.getMap();
        var ovmap = this.ovmap_;
        var view = map.getView();
        var ovview = ovmap.getView();
        ovview.setCenterInternal(view.getCenterInternal());
    };
    /**
     * Update the box using the main map extent
     * @private
     */
    OverviewMap.prototype.updateBox_ = function () {
        var map = this.getMap();
        var ovmap = this.ovmap_;
        if (!map.isRendered() || !ovmap.isRendered()) {
            return;
        }
        var mapSize = /** @type {import("../size.js").Size} */ (map.getSize());
        var view = map.getView();
        var ovview = ovmap.getView();
        var rotation = this.rotateWithView_ ? 0 : -view.getRotation();
        var overlay = this.boxOverlay_;
        var box = this.boxOverlay_.getElement();
        var center = view.getCenterInternal();
        var resolution = view.getResolution();
        var ovresolution = ovview.getResolution();
        var width = (mapSize[0] * resolution) / ovresolution;
        var height = (mapSize[1] * resolution) / ovresolution;
        // set position using center coordinates
        overlay.setPosition(center);
        // set box size calculated from map extent size and overview map resolution
        if (box) {
            box.style.width = width + 'px';
            box.style.height = height + 'px';
            var transform = 'rotate(' + rotation + 'rad)';
            box.style.transform = transform;
        }
    };
    /**
     * @private
     */
    OverviewMap.prototype.updateBoxAfterOvmapIsRendered_ = function () {
        if (this.ovmapPostrenderKey_) {
            return;
        }
        this.ovmapPostrenderKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listenOnce"])(this.ovmap_, _MapEventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POSTRENDER, function (event) {
            delete this.ovmapPostrenderKey_;
            this.updateBox_();
        }, this);
    };
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */
    OverviewMap.prototype.handleClick_ = function (event) {
        event.preventDefault();
        this.handleToggle_();
    };
    /**
     * @private
     */
    OverviewMap.prototype.handleToggle_ = function () {
        this.element.classList.toggle(_css_js__WEBPACK_IMPORTED_MODULE_11__["CLASS_COLLAPSED"]);
        if (this.collapsed_) {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_15__["replaceNode"])(this.collapseLabel_, this.label_);
        }
        else {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_15__["replaceNode"])(this.label_, this.collapseLabel_);
        }
        this.collapsed_ = !this.collapsed_;
        // manage overview map if it had not been rendered before and control
        // is expanded
        var ovmap = this.ovmap_;
        if (!this.collapsed_) {
            if (ovmap.isRendered()) {
                this.viewExtent_ = undefined;
                ovmap.render();
                return;
            }
            ovmap.updateSize();
            this.resetExtent_();
            this.updateBoxAfterOvmapIsRendered_();
        }
    };
    /**
     * Return `true` if the overview map is collapsible, `false` otherwise.
     * @return {boolean} True if the widget is collapsible.
     * @api
     */
    OverviewMap.prototype.getCollapsible = function () {
        return this.collapsible_;
    };
    /**
     * Set whether the overview map should be collapsible.
     * @param {boolean} collapsible True if the widget is collapsible.
     * @api
     */
    OverviewMap.prototype.setCollapsible = function (collapsible) {
        if (this.collapsible_ === collapsible) {
            return;
        }
        this.collapsible_ = collapsible;
        this.element.classList.toggle('ol-uncollapsible');
        if (!collapsible && this.collapsed_) {
            this.handleToggle_();
        }
    };
    /**
     * Collapse or expand the overview map according to the passed parameter. Will
     * not do anything if the overview map isn't collapsible or if the current
     * collapsed state is already the one requested.
     * @param {boolean} collapsed True if the widget is collapsed.
     * @api
     */
    OverviewMap.prototype.setCollapsed = function (collapsed) {
        if (!this.collapsible_ || this.collapsed_ === collapsed) {
            return;
        }
        this.handleToggle_();
    };
    /**
     * Determine if the overview map is collapsed.
     * @return {boolean} The overview map is collapsed.
     * @api
     */
    OverviewMap.prototype.getCollapsed = function () {
        return this.collapsed_;
    };
    /**
     * Return `true` if the overview map view can rotate, `false` otherwise.
     * @return {boolean} True if the control view can rotate.
     * @api
     */
    OverviewMap.prototype.getRotateWithView = function () {
        return this.rotateWithView_;
    };
    /**
     * Set whether the overview map view should rotate with the main map view.
     * @param {boolean} rotateWithView True if the control view should rotate.
     * @api
     */
    OverviewMap.prototype.setRotateWithView = function (rotateWithView) {
        if (this.rotateWithView_ === rotateWithView) {
            return;
        }
        this.rotateWithView_ = rotateWithView;
        if (this.getMap().getView().getRotation() !== 0) {
            if (this.rotateWithView_) {
                this.handleRotationChanged_();
            }
            else {
                this.ovmap_.getView().setRotation(0);
            }
            this.viewExtent_ = undefined;
            this.validateExtent_();
            this.updateBox_();
        }
    };
    /**
     * Return the overview map.
     * @return {import("../PluggableMap.js").default} Overview map.
     * @api
     */
    OverviewMap.prototype.getOverviewMap = function () {
        return this.ovmap_;
    };
    /**
     * Update the overview map element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    OverviewMap.prototype.render = function (mapEvent) {
        this.validateExtent_();
        this.updateBox_();
    };
    return OverviewMap;
}(_Control_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (OverviewMap);
//# sourceMappingURL=OverviewMap.js.map

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Map_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(169);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47);
/* harmony import */ var _render_Event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(138);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(134);
/* harmony import */ var _source_State_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55);
/* harmony import */ var _render_canvas_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44);
/* harmony import */ var _layer_Layer_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(131);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/Composite
 */










/**
 * @classdesc
 * Canvas map renderer.
 * @api
 */
var CompositeMapRenderer = /** @class */ (function (_super) {
    __extends(CompositeMapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */
    function CompositeMapRenderer(map) {
        var _this = _super.call(this, map) || this;
        /**
         * @type {import("../events.js").EventsKey}
         */
        _this.fontChangeListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_8__["listen"])(_render_canvas_js__WEBPACK_IMPORTED_MODULE_6__["checkedFonts"], _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].PROPERTYCHANGE, map.redrawText.bind(map));
        /**
         * @private
         * @type {HTMLDivElement}
         */
        _this.element_ = document.createElement('div');
        var style = _this.element_.style;
        style.position = 'absolute';
        style.width = '100%';
        style.height = '100%';
        style.zIndex = '0';
        _this.element_.className = _css_js__WEBPACK_IMPORTED_MODULE_5__["CLASS_UNSELECTABLE"] + ' ol-layers';
        var container = map.getViewport();
        container.insertBefore(_this.element_, container.firstChild || null);
        /**
         * @private
         * @type {Array<HTMLElement>}
         */
        _this.children_ = [];
        /**
         * @private
         * @type {boolean}
         */
        _this.renderedVisible_ = true;
        return _this;
    }
    /**
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    CompositeMapRenderer.prototype.dispatchRenderEvent = function (type, frameState) {
        var map = this.getMap();
        if (map.hasListener(type)) {
            var event_1 = new _render_Event_js__WEBPACK_IMPORTED_MODULE_2__["default"](type, undefined, frameState);
            map.dispatchEvent(event_1);
        }
    };
    CompositeMapRenderer.prototype.disposeInternal = function () {
        Object(_events_js__WEBPACK_IMPORTED_MODULE_8__["unlistenByKey"])(this.fontChangeListenerKey_);
        this.element_.parentNode.removeChild(this.element_);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Render.
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    CompositeMapRenderer.prototype.renderFrame = function (frameState) {
        if (!frameState) {
            if (this.renderedVisible_) {
                this.element_.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        this.calculateMatrices2D(frameState);
        this.dispatchRenderEvent(_render_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].PRECOMPOSE, frameState);
        var layerStatesArray = frameState.layerStatesArray.sort(function (a, b) {
            return a.zIndex - b.zIndex;
        });
        var viewState = frameState.viewState;
        this.children_.length = 0;
        /**
         * @type {Array<import("../layer/BaseVector.js").default>}
         */
        var declutterLayers = [];
        var previousElement = null;
        for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
            var layerState = layerStatesArray[i];
            frameState.layerIndex = i;
            if (!Object(_layer_Layer_js__WEBPACK_IMPORTED_MODULE_7__["inView"])(layerState, viewState) ||
                (layerState.sourceState != _source_State_js__WEBPACK_IMPORTED_MODULE_4__["default"].READY &&
                    layerState.sourceState != _source_State_js__WEBPACK_IMPORTED_MODULE_4__["default"].UNDEFINED)) {
                continue;
            }
            var layer = layerState.layer;
            var element = layer.render(frameState, previousElement);
            if (!element) {
                continue;
            }
            if (element !== previousElement) {
                this.children_.push(element);
                previousElement = element;
            }
            if ('getDeclutter' in layer) {
                declutterLayers.push(
                /** @type {import("../layer/BaseVector.js").default} */ (layer));
            }
        }
        for (var i = declutterLayers.length - 1; i >= 0; --i) {
            declutterLayers[i].renderDeclutter(frameState);
        }
        Object(_dom_js__WEBPACK_IMPORTED_MODULE_9__["replaceChildren"])(this.element_, this.children_);
        this.dispatchRenderEvent(_render_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POSTCOMPOSE, frameState);
        if (!this.renderedVisible_) {
            this.element_.style.display = '';
            this.renderedVisible_ = true;
        }
        this.scheduleExpireIconCache(frameState);
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */
    CompositeMapRenderer.prototype.forEachLayerAtPixel = function (pixel, frameState, hitTolerance, callback, layerFilter) {
        var viewState = frameState.viewState;
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        for (var i = numLayers - 1; i >= 0; --i) {
            var layerState = layerStates[i];
            var layer = layerState.layer;
            if (layer.hasRenderer() &&
                Object(_layer_Layer_js__WEBPACK_IMPORTED_MODULE_7__["inView"])(layerState, viewState) &&
                layerFilter(layer)) {
                var layerRenderer = layer.getRenderer();
                var data = layerRenderer.getDataAtPixel(pixel, frameState, hitTolerance);
                if (data) {
                    var result = callback(layer, data);
                    if (result) {
                        return result;
                    }
                }
            }
        }
        return undefined;
    };
    return CompositeMapRenderer;
}(_Map_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CompositeMapRenderer);
//# sourceMappingURL=Composite.js.map

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Disposable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _style_IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61);
/* harmony import */ var _layer_Layer_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(131);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/Map
 */








/**
 * @typedef HitMatch
 * @property {import("../Feature.js").FeatureLike} feature Feature.
 * @property {import("../layer/Layer.js").default} layer Layer.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} distanceSq Squared distance.
 * @property {import("./vector.js").FeatureCallback<T>} callback Callback.
 * @template T
 */
/**
 * @abstract
 */
var MapRenderer = /** @class */ (function (_super) {
    __extends(MapRenderer, _super);
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */
    function MapRenderer(map) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */
        _this.map_ = map;
        return _this;
    }
    /**
     * @abstract
     * @param {import("../render/EventType.js").default} type Event type.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    MapRenderer.prototype.dispatchRenderEvent = function (type, frameState) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @protected
     */
    MapRenderer.prototype.calculateMatrices2D = function (frameState) {
        var viewState = frameState.viewState;
        var coordinateToPixelTransform = frameState.coordinateToPixelTransform;
        var pixelToCoordinateTransform = frameState.pixelToCoordinateTransform;
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(coordinateToPixelTransform, frameState.size[0] / 2, frameState.size[1] / 2, 1 / viewState.resolution, -1 / viewState.resolution, -viewState.rotation, -viewState.center[0], -viewState.center[1]);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["makeInverse"])(pixelToCoordinateTransform, coordinateToPixelTransform);
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {import("./vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {S} thisArg Value to use as `this` when executing `callback`.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg2 Value to use as `this` when executing `layerFilter`.
     * @return {T|undefined} Callback result.
     * @template S,T,U
     */
    MapRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, checkWrapped, callback, thisArg, layerFilter, thisArg2) {
        var result;
        var viewState = frameState.viewState;
        /**
         * @param {boolean} managed Managed layer.
         * @param {import("../Feature.js").FeatureLike} feature Feature.
         * @param {import("../layer/Layer.js").default} layer Layer.
         * @param {import("../geom/Geometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */
        function forEachFeatureAtCoordinate(managed, feature, layer, geometry) {
            return callback.call(thisArg, feature, managed ? layer : null, geometry);
        }
        var projection = viewState.projection;
        var translatedCoordinate = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_7__["wrapX"])(coordinate.slice(), projection);
        var offsets = [[0, 0]];
        if (projection.canWrapX() && checkWrapped) {
            var projectionExtent = projection.getExtent();
            var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["getWidth"])(projectionExtent);
            offsets.push([-worldWidth, 0], [worldWidth, 0]);
        }
        var layerStates = frameState.layerStatesArray;
        var numLayers = layerStates.length;
        var matches = /** @type {Array<HitMatch<T>>} */ ([]);
        var tmpCoord = [];
        for (var i = 0; i < offsets.length; i++) {
            for (var j = numLayers - 1; j >= 0; --j) {
                var layerState = layerStates[j];
                var layer = layerState.layer;
                if (layer.hasRenderer() &&
                    Object(_layer_Layer_js__WEBPACK_IMPORTED_MODULE_6__["inView"])(layerState, viewState) &&
                    layerFilter.call(thisArg2, layer)) {
                    var layerRenderer = layer.getRenderer();
                    var source = layer.getSource();
                    if (layerRenderer && source) {
                        var coordinates = source.getWrapX()
                            ? translatedCoordinate
                            : coordinate;
                        var callback_1 = forEachFeatureAtCoordinate.bind(null, layerState.managed);
                        tmpCoord[0] = coordinates[0] + offsets[i][0];
                        tmpCoord[1] = coordinates[1] + offsets[i][1];
                        result = layerRenderer.forEachFeatureAtCoordinate(tmpCoord, frameState, hitTolerance, callback_1, matches);
                    }
                    if (result) {
                        return result;
                    }
                }
            }
        }
        if (matches.length === 0) {
            return undefined;
        }
        var order = 1 / matches.length;
        matches.forEach(function (m, i) { return (m.distanceSq += i * order); });
        matches.sort(function (a, b) { return a.distanceSq - b.distanceSq; });
        matches.some(function (m) {
            return (result = m.callback(m.feature, m.layer, m.geometry));
        });
        return result;
    };
    /**
     * @abstract
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback Layer
     *     callback.
     * @param {function(import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @return {T|undefined} Callback result.
     * @template T
     */
    MapRenderer.prototype.forEachLayerAtPixel = function (pixel, frameState, hitTolerance, callback, layerFilter) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../PluggableMap.js").FrameState} frameState FrameState.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {boolean} checkWrapped Check for wrapped geometries.
     * @param {function(this: U, import("../layer/Layer.js").default): boolean} layerFilter Layer filter
     *     function, only layers which are visible and for which this function
     *     returns `true` will be tested for features.  By default, all visible
     *     layers will be tested.
     * @param {U} thisArg Value to use as `this` when executing `layerFilter`.
     * @return {boolean} Is there a feature at the given coordinate?
     * @template U
     */
    MapRenderer.prototype.hasFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, checkWrapped, layerFilter, thisArg) {
        var hasFeature = this.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, checkWrapped, _functions_js__WEBPACK_IMPORTED_MODULE_1__["TRUE"], this, layerFilter, thisArg);
        return hasFeature !== undefined;
    };
    /**
     * @return {import("../PluggableMap.js").default} Map.
     */
    MapRenderer.prototype.getMap = function () {
        return this.map_;
    };
    /**
     * Render.
     * @abstract
     * @param {?import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    MapRenderer.prototype.renderFrame = function (frameState) {
        Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */
    MapRenderer.prototype.scheduleExpireIconCache = function (frameState) {
        if (_style_IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__["shared"].canExpireCache()) {
            frameState.postRenderFunctions.push(expireIconCache);
        }
    };
    return MapRenderer;
}(_Disposable_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {import("../PluggableMap.js").default} map Map.
 * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
 */
function expireIconCache(map, frameState) {
    _style_IconImageCache_js__WEBPACK_IMPORTED_MODULE_5__["shared"].expire();
}
/* harmony default export */ __webpack_exports__["default"] = (MapRenderer);
//# sourceMappingURL=Map.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/MapProperty
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    LAYERGROUP: 'layergroup',
    SIZE: 'size',
    TARGET: 'target',
    VIEW: 'view',
});
//# sourceMappingURL=MapProperty.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _MapEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(161);
/* harmony import */ var _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(172);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Overlay
 */







/**
 * @typedef {Object} Options
 * @property {number|string} [id] Set the overlay id. The overlay id can be used
 * with the {@link module:ol/Map~Map#getOverlayById} method.
 * @property {HTMLElement} [element] The overlay element.
 * @property {Array<number>} [offset=[0, 0]] Offsets in pixels used when positioning
 * the overlay. The first element in the
 * array is the horizontal offset. A positive value shifts the overlay right.
 * The second element in the array is the vertical offset. A positive value
 * shifts the overlay down.
 * @property {import("./coordinate.js").Coordinate} [position] The overlay position
 * in map projection.
 * @property {import("./OverlayPositioning.js").default} [positioning='top-left'] Defines how
 * the overlay is actually positioned with respect to its `position` property.
 * Possible values are `'bottom-left'`, `'bottom-center'`, `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, and `'top-right'`.
 * @property {boolean} [stopEvent=true] Whether event propagation to the map
 * viewport should be stopped. If `true` the overlay is placed in the same
 * container as that of the controls (CSS class name
 * `ol-overlaycontainer-stopevent`); if `false` it is placed in the container
 * with CSS class name specified by the `className` property.
 * @property {boolean} [insertFirst=true] Whether the overlay is inserted first
 * in the overlay container, or appended. If the overlay is placed in the same
 * container as that of the controls (see the `stopEvent` option) you will
 * probably set `insertFirst` to `true` so the overlay is displayed below the
 * controls.
 * @property {PanIntoViewOptions|boolean} [autoPan=false] Pan the map when calling
 * `setPosition`, so that the overlay is entirely visible in the current viewport?
 * If `true` (deprecated), then `autoPanAnimation` and `autoPanMargin` will be
 * used to determine the panning parameters; if an object is supplied then other
 * parameters are ignored.
 * @property {PanOptions} [autoPanAnimation] The animation options used to pan
 * the overlay into view. This animation is only used when `autoPan` is enabled.
 * A `duration` and `easing` may be provided to customize the animation.
 * Deprecated and ignored if `autoPan` is supplied as an object.
 * @property {number} [autoPanMargin=20] The margin (in pixels) between the
 * overlay and the borders of the map when autopanning. Deprecated and ignored
 * if `autoPan` is supplied as an object.
 * @property {PanIntoViewOptions} [autoPanOptions] The options to use for the
 * autoPan. This is only used when `autoPan` is enabled and has preference over
 * the individual `autoPanMargin` and `autoPanOptions`.
 * @property {string} [className='ol-overlay-container ol-selectable'] CSS class
 * name.
 */
/**
 * @typedef {Object} PanOptions
 * @property {number} [duration=1000] The duration of the animation in
 * milliseconds.
 * @property {function(number):number} [easing] The easing function to use. Can
 * be one from {@link module:ol/easing} or a custom function.
 * Default is {@link module:ol/easing.inAndOut}.
 */
/**
 * @typedef {Object} PanIntoViewOptions
 * @property {PanOptions} [animation={}] The animation parameters for the pan
 * @property {number} [margin=20] The margin (in pixels) between the
 * overlay and the borders of the map when panning into view.
 */
/**
 * @enum {string}
 * @protected
 */
var Property = {
    ELEMENT: 'element',
    MAP: 'map',
    OFFSET: 'offset',
    POSITION: 'position',
    POSITIONING: 'positioning',
};
/**
 * @typedef {import("./ObjectEventType").Types|'change:element'|'change:map'|'change:offset'|'change:position'|
 *   'change:positioning'} OverlayObjectEventTypes
 */
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<OverlayObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|OverlayObjectEventTypes, Return>} OverlayOnSignature
 */
/**
 * @classdesc
 * An element to be displayed over the map and attached to a single map
 * location.  Like {@link module:ol/control/Control~Control}, Overlays are
 * visible widgets. Unlike Controls, they are not in a fixed position on the
 * screen, but are tied to a geographical coordinate, so panning the map will
 * move an Overlay but not a Control.
 *
 * Example:
 *
 *     import Overlay from 'ol/Overlay';
 *
 *     var popup = new Overlay({
 *       element: document.getElementById('popup')
 *     });
 *     popup.setPosition(coordinate);
 *     map.addOverlay(popup);
 *
 * @api
 */
var Overlay = /** @class */ (function (_super) {
    __extends(Overlay, _super);
    /**
     * @param {Options} options Overlay options.
     */
    function Overlay(options) {
        var _this = _super.call(this) || this;
        /***
         * @type {OverlayOnSignature<import("./Observable").OnReturn>}
         */
        _this.on;
        /***
         * @type {OverlayOnSignature<import("./Observable").OnReturn>}
         */
        _this.once;
        /***
         * @type {OverlayOnSignature<void>}
         */
        _this.un;
        /**
         * @protected
         * @type {Options}
         */
        _this.options = options;
        /**
         * @protected
         * @type {number|string|undefined}
         */
        _this.id = options.id;
        /**
         * @protected
         * @type {boolean}
         */
        _this.insertFirst =
            options.insertFirst !== undefined ? options.insertFirst : true;
        /**
         * @protected
         * @type {boolean}
         */
        _this.stopEvent = options.stopEvent !== undefined ? options.stopEvent : true;
        /**
         * @protected
         * @type {HTMLElement}
         */
        _this.element = document.createElement('div');
        _this.element.className =
            options.className !== undefined
                ? options.className
                : 'ol-overlay-container ' + _css_js__WEBPACK_IMPORTED_MODULE_3__["CLASS_SELECTABLE"];
        _this.element.style.position = 'absolute';
        _this.element.style.pointerEvents = 'auto';
        var autoPan = options.autoPan;
        if (autoPan && 'object' !== typeof autoPan) {
            autoPan = {
                animation: options.autoPanAnimation,
                margin: options.autoPanMargin,
            };
        }
        /**
         * @protected
         * @type {PanIntoViewOptions|false}
         */
        _this.autoPan = /** @type {PanIntoViewOptions} */ (autoPan) || false;
        /**
         * @protected
         * @type {{transform_: string,
         *         visible: boolean}}
         */
        _this.rendered = {
            transform_: '',
            visible: true,
        };
        /**
         * @protected
         * @type {?import("./events.js").EventsKey}
         */
        _this.mapPostrenderListenerKey = null;
        _this.addChangeListener(Property.ELEMENT, _this.handleElementChanged);
        _this.addChangeListener(Property.MAP, _this.handleMapChanged);
        _this.addChangeListener(Property.OFFSET, _this.handleOffsetChanged);
        _this.addChangeListener(Property.POSITION, _this.handlePositionChanged);
        _this.addChangeListener(Property.POSITIONING, _this.handlePositioningChanged);
        if (options.element !== undefined) {
            _this.setElement(options.element);
        }
        _this.setOffset(options.offset !== undefined ? options.offset : [0, 0]);
        _this.setPositioning(options.positioning !== undefined
            ? /** @type {import("./OverlayPositioning.js").default} */ (options.positioning)
            : _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_LEFT);
        if (options.position !== undefined) {
            _this.setPosition(options.position);
        }
        return _this;
    }
    /**
     * Get the DOM element of this overlay.
     * @return {HTMLElement|undefined} The Element containing the overlay.
     * @observable
     * @api
     */
    Overlay.prototype.getElement = function () {
        return /** @type {HTMLElement|undefined} */ (this.get(Property.ELEMENT));
    };
    /**
     * Get the overlay identifier which is set on constructor.
     * @return {number|string|undefined} Id.
     * @api
     */
    Overlay.prototype.getId = function () {
        return this.id;
    };
    /**
     * Get the map associated with this overlay.
     * @return {import("./PluggableMap.js").default|undefined} The map that the
     * overlay is part of.
     * @observable
     * @api
     */
    Overlay.prototype.getMap = function () {
        return /** @type {import("./PluggableMap.js").default|undefined} */ (this.get(Property.MAP));
    };
    /**
     * Get the offset of this overlay.
     * @return {Array<number>} The offset.
     * @observable
     * @api
     */
    Overlay.prototype.getOffset = function () {
        return /** @type {Array<number>} */ (this.get(Property.OFFSET));
    };
    /**
     * Get the current position of this overlay.
     * @return {import("./coordinate.js").Coordinate|undefined} The spatial point that the overlay is
     *     anchored at.
     * @observable
     * @api
     */
    Overlay.prototype.getPosition = function () {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ (this.get(Property.POSITION));
    };
    /**
     * Get the current positioning of this overlay.
     * @return {import("./OverlayPositioning.js").default} How the overlay is positioned
     *     relative to its point on the map.
     * @observable
     * @api
     */
    Overlay.prototype.getPositioning = function () {
        return /** @type {import("./OverlayPositioning.js").default} */ (this.get(Property.POSITIONING));
    };
    /**
     * @protected
     */
    Overlay.prototype.handleElementChanged = function () {
        Object(_dom_js__WEBPACK_IMPORTED_MODULE_6__["removeChildren"])(this.element);
        var element = this.getElement();
        if (element) {
            this.element.appendChild(element);
        }
    };
    /**
     * @protected
     */
    Overlay.prototype.handleMapChanged = function () {
        if (this.mapPostrenderListenerKey) {
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_6__["removeNode"])(this.element);
            Object(_events_js__WEBPACK_IMPORTED_MODULE_5__["unlistenByKey"])(this.mapPostrenderListenerKey);
            this.mapPostrenderListenerKey = null;
        }
        var map = this.getMap();
        if (map) {
            this.mapPostrenderListenerKey = Object(_events_js__WEBPACK_IMPORTED_MODULE_5__["listen"])(map, _MapEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POSTRENDER, this.render, this);
            this.updatePixelPosition();
            var container = this.stopEvent
                ? map.getOverlayContainerStopEvent()
                : map.getOverlayContainer();
            if (this.insertFirst) {
                container.insertBefore(this.element, container.childNodes[0] || null);
            }
            else {
                container.appendChild(this.element);
            }
            this.performAutoPan();
        }
    };
    /**
     * @protected
     */
    Overlay.prototype.render = function () {
        this.updatePixelPosition();
    };
    /**
     * @protected
     */
    Overlay.prototype.handleOffsetChanged = function () {
        this.updatePixelPosition();
    };
    /**
     * @protected
     */
    Overlay.prototype.handlePositionChanged = function () {
        this.updatePixelPosition();
        this.performAutoPan();
    };
    /**
     * @protected
     */
    Overlay.prototype.handlePositioningChanged = function () {
        this.updatePixelPosition();
    };
    /**
     * Set the DOM element to be associated with this overlay.
     * @param {HTMLElement|undefined} element The Element containing the overlay.
     * @observable
     * @api
     */
    Overlay.prototype.setElement = function (element) {
        this.set(Property.ELEMENT, element);
    };
    /**
     * Set the map to be associated with this overlay.
     * @param {import("./PluggableMap.js").default|undefined} map The map that the
     * overlay is part of.
     * @observable
     * @api
     */
    Overlay.prototype.setMap = function (map) {
        this.set(Property.MAP, map);
    };
    /**
     * Set the offset for this overlay.
     * @param {Array<number>} offset Offset.
     * @observable
     * @api
     */
    Overlay.prototype.setOffset = function (offset) {
        this.set(Property.OFFSET, offset);
    };
    /**
     * Set the position for this overlay. If the position is `undefined` the
     * overlay is hidden.
     * @param {import("./coordinate.js").Coordinate|undefined} position The spatial point that the overlay
     *     is anchored at.
     * @observable
     * @api
     */
    Overlay.prototype.setPosition = function (position) {
        this.set(Property.POSITION, position);
    };
    /**
     * Pan the map so that the overlay is entirely visible in the current viewport
     * (if necessary) using the configured autoPan parameters
     * @protected
     */
    Overlay.prototype.performAutoPan = function () {
        if (this.autoPan) {
            this.panIntoView(this.autoPan);
        }
    };
    /**
     * Pan the map so that the overlay is entirely visible in the current viewport
     * (if necessary).
     * @param {PanIntoViewOptions} [opt_panIntoViewOptions] Options for the pan action
     * @api
     */
    Overlay.prototype.panIntoView = function (opt_panIntoViewOptions) {
        var map = this.getMap();
        if (!map || !map.getTargetElement() || !this.get(Property.POSITION)) {
            return;
        }
        var mapRect = this.getRect(map.getTargetElement(), map.getSize());
        var element = this.getElement();
        var overlayRect = this.getRect(element, [
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_6__["outerWidth"])(element),
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_6__["outerHeight"])(element),
        ]);
        var panIntoViewOptions = opt_panIntoViewOptions || {};
        var myMargin = panIntoViewOptions.margin === undefined ? 20 : panIntoViewOptions.margin;
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["containsExtent"])(mapRect, overlayRect)) {
            // the overlay is not completely inside the viewport, so pan the map
            var offsetLeft = overlayRect[0] - mapRect[0];
            var offsetRight = mapRect[2] - overlayRect[2];
            var offsetTop = overlayRect[1] - mapRect[1];
            var offsetBottom = mapRect[3] - overlayRect[3];
            var delta = [0, 0];
            if (offsetLeft < 0) {
                // move map to the left
                delta[0] = offsetLeft - myMargin;
            }
            else if (offsetRight < 0) {
                // move map to the right
                delta[0] = Math.abs(offsetRight) + myMargin;
            }
            if (offsetTop < 0) {
                // move map up
                delta[1] = offsetTop - myMargin;
            }
            else if (offsetBottom < 0) {
                // move map down
                delta[1] = Math.abs(offsetBottom) + myMargin;
            }
            if (delta[0] !== 0 || delta[1] !== 0) {
                var center = /** @type {import("./coordinate.js").Coordinate} */ (map.getView().getCenterInternal());
                var centerPx = map.getPixelFromCoordinateInternal(center);
                if (!centerPx) {
                    return;
                }
                var newCenterPx = [centerPx[0] + delta[0], centerPx[1] + delta[1]];
                var panOptions = panIntoViewOptions.animation || {};
                map.getView().animateInternal({
                    center: map.getCoordinateFromPixelInternal(newCenterPx),
                    duration: panOptions.duration,
                    easing: panOptions.easing,
                });
            }
        }
    };
    /**
     * Get the extent of an element relative to the document
     * @param {HTMLElement} element The element.
     * @param {import("./size.js").Size} size The size of the element.
     * @return {import("./extent.js").Extent} The extent.
     * @protected
     */
    Overlay.prototype.getRect = function (element, size) {
        var box = element.getBoundingClientRect();
        var offsetX = box.left + window.pageXOffset;
        var offsetY = box.top + window.pageYOffset;
        return [offsetX, offsetY, offsetX + size[0], offsetY + size[1]];
    };
    /**
     * Set the positioning for this overlay.
     * @param {import("./OverlayPositioning.js").default} positioning how the overlay is
     *     positioned relative to its point on the map.
     * @observable
     * @api
     */
    Overlay.prototype.setPositioning = function (positioning) {
        this.set(Property.POSITIONING, positioning);
    };
    /**
     * Modify the visibility of the element.
     * @param {boolean} visible Element visibility.
     * @protected
     */
    Overlay.prototype.setVisible = function (visible) {
        if (this.rendered.visible !== visible) {
            this.element.style.display = visible ? '' : 'none';
            this.rendered.visible = visible;
        }
    };
    /**
     * Update pixel position.
     * @protected
     */
    Overlay.prototype.updatePixelPosition = function () {
        var map = this.getMap();
        var position = this.getPosition();
        if (!map || !map.isRendered() || !position) {
            this.setVisible(false);
            return;
        }
        var pixel = map.getPixelFromCoordinate(position);
        var mapSize = map.getSize();
        this.updateRenderedPosition(pixel, mapSize);
    };
    /**
     * @param {import("./pixel.js").Pixel} pixel The pixel location.
     * @param {import("./size.js").Size|undefined} mapSize The map size.
     * @protected
     */
    Overlay.prototype.updateRenderedPosition = function (pixel, mapSize) {
        var style = this.element.style;
        var offset = this.getOffset();
        var positioning = this.getPositioning();
        this.setVisible(true);
        var x = Math.round(pixel[0] + offset[0]) + 'px';
        var y = Math.round(pixel[1] + offset[1]) + 'px';
        var posX = '0%';
        var posY = '0%';
        if (positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].CENTER_RIGHT ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_RIGHT) {
            posX = '-100%';
        }
        else if (positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_CENTER ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].CENTER_CENTER ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].TOP_CENTER) {
            posX = '-50%';
        }
        if (positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_LEFT ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_CENTER ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].BOTTOM_RIGHT) {
            posY = '-100%';
        }
        else if (positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].CENTER_LEFT ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].CENTER_CENTER ||
            positioning == _OverlayPositioning_js__WEBPACK_IMPORTED_MODULE_2__["default"].CENTER_RIGHT) {
            posY = '-50%';
        }
        var transform = "translate(" + posX + ", " + posY + ") translate(" + x + ", " + y + ")";
        if (this.rendered.transform_ != transform) {
            this.rendered.transform_ = transform;
            style.transform = transform;
            // @ts-ignore IE9
            style.msTransform = transform;
        }
    };
    /**
     * returns the options this Overlay has been created with
     * @return {Options} overlay options
     */
    Overlay.prototype.getOptions = function () {
        return this.options;
    };
    return Overlay;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Overlay);
//# sourceMappingURL=Overlay.js.map

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/OverlayPositioning
 */
/**
 * Overlay position: `'bottom-left'`, `'bottom-center'`,  `'bottom-right'`,
 * `'center-left'`, `'center-center'`, `'center-right'`, `'top-left'`,
 * `'top-center'`, `'top-right'`
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_CENTER: 'bottom-center',
    BOTTOM_RIGHT: 'bottom-right',
    CENTER_LEFT: 'center-left',
    CENTER_CENTER: 'center-center',
    CENTER_RIGHT: 'center-right',
    TOP_LEFT: 'top-left',
    TOP_CENTER: 'top-center',
    TOP_RIGHT: 'top-right',
});
//# sourceMappingURL=OverlayPositioning.js.map

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(107);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53);
/* harmony import */ var _layer_Group_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(174);
/* harmony import */ var _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(175);
/* harmony import */ var _MapBrowserEventHandler_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(177);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(178);
/* harmony import */ var _MapEvent_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(176);
/* harmony import */ var _MapEventType_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(161);
/* harmony import */ var _MapProperty_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(170);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(47);
/* harmony import */ var _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(166);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(134);
/* harmony import */ var _TileQueue_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(144);
/* harmony import */ var _View_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(179);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(139);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(51);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(101);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(39);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(54);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/PluggableMap
 */


























/**
 * State of the current frame. Only `pixelRatio`, `time` and `viewState` should
 * be used in applications.
 * @typedef {Object} FrameState
 * @property {number} pixelRatio The pixel ratio of the frame.
 * @property {number} time The time when rendering of the frame was requested.
 * @property {import("./View.js").State} viewState The state of the current view.
 * @property {boolean} animate Animate.
 * @property {import("./transform.js").Transform} coordinateToPixelTransform CoordinateToPixelTransform.
 * @property {import("rbush").default} declutterTree DeclutterTree.
 * @property {null|import("./extent.js").Extent} extent Extent.
 * @property {number} index Index.
 * @property {Array<import("./layer/Layer.js").State>} layerStatesArray LayerStatesArray.
 * @property {number} layerIndex LayerIndex.
 * @property {import("./transform.js").Transform} pixelToCoordinateTransform PixelToCoordinateTransform.
 * @property {Array<PostRenderFunction>} postRenderFunctions PostRenderFunctions.
 * @property {import("./size.js").Size} size Size.
 * @property {TileQueue} tileQueue TileQueue.
 * @property {!Object<string, Object<string, boolean>>} usedTiles UsedTiles.
 * @property {Array<number>} viewHints ViewHints.
 * @property {!Object<string, Object<string, boolean>>} wantedTiles WantedTiles.
 */
/**
 * @typedef {function(PluggableMap, ?FrameState): any} PostRenderFunction
 */
/**
 * @typedef {Object} AtPixelOptions
 * @property {undefined|function(import("./layer/Layer.js").default): boolean} [layerFilter] Layer filter
 * function. The filter function will receive one argument, the
 * {@link module:ol/layer/Layer layer-candidate} and it should return a boolean value.
 * Only layers which are visible and for which this function returns `true`
 * will be tested for features. By default, all visible layers will be tested.
 * @property {number} [hitTolerance=0] Hit-detection tolerance in css pixels. Pixels
 * inside the radius around the given position will be checked for features.
 * @property {boolean} [checkWrapped=true] Check-Wrapped Will check for for wrapped geometries inside the range of
 *   +/- 1 world width. Works only if a projection is used that can be wrapped.
 */
/**
 * @typedef {Object} MapOptionsInternal
 * @property {Collection<import("./control/Control.js").default>} [controls] Controls.
 * @property {Collection<import("./interaction/Interaction.js").default>} [interactions] Interactions.
 * @property {HTMLElement|Document} keyboardEventTarget KeyboardEventTarget.
 * @property {Collection<import("./Overlay.js").default>} overlays Overlays.
 * @property {Object<string, *>} values Values.
 */
/**
 * @typedef {import("./ObjectEventType").Types|'change:layergroup'|'change:size'|'change:target'|'change:view'} MapObjectEventTypes
 */
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *    import("./Observable").OnSignature<MapObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *    import("./Observable").OnSignature<import("./MapBrowserEventType").Types, import("./MapBrowserEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./MapEventType").Types, import("./MapEvent").default, Return> &
 *    import("./Observable").OnSignature<import("./render/EventType").MapRenderEventTypes, import("./render/Event").default, Return> &
 *    import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|MapObjectEventTypes|
 *      import("./MapBrowserEventType").Types|import("./MapEventType").Types|
 *      import("./render/EventType").MapRenderEventTypes, Return>} PluggableMapOnSignature
 */
/**
 * Object literal with config options for the map.
 * @typedef {Object} MapOptions
 * @property {Collection<import("./control/Control.js").default>|Array<import("./control/Control.js").default>} [controls]
 * Controls initially added to the map. If not specified,
 * {@link module:ol/control.defaults} is used.
 * @property {number} [pixelRatio=window.devicePixelRatio] The ratio between
 * physical pixels and device-independent pixels (dips) on the device.
 * @property {Collection<import("./interaction/Interaction.js").default>|Array<import("./interaction/Interaction.js").default>} [interactions]
 * Interactions that are initially added to the map. If not specified,
 * {@link module:ol/interaction.defaults} is used.
 * @property {HTMLElement|Document|string} [keyboardEventTarget] The element to
 * listen to keyboard events on. This determines when the `KeyboardPan` and
 * `KeyboardZoom` interactions trigger. For example, if this option is set to
 * `document` the keyboard interactions will always trigger. If this option is
 * not specified, the element the library listens to keyboard events on is the
 * map target (i.e. the user-provided div for the map). If this is not
 * `document`, the target element needs to be focused for key events to be
 * emitted, requiring that the target element has a `tabindex` attribute.
 * @property {Array<import("./layer/Base.js").default>|Collection<import("./layer/Base.js").default>|LayerGroup} [layers]
 * Layers. If this is not defined, a map with no layers will be rendered. Note
 * that layers are rendered in the order supplied, so if you want, for example,
 * a vector layer to appear on top of a tile layer, it must come after the tile
 * layer.
 * @property {number} [maxTilesLoading=16] Maximum number tiles to load
 * simultaneously.
 * @property {number} [moveTolerance=1] The minimum distance in pixels the
 * cursor must move to be detected as a map move event instead of a click.
 * Increasing this value can make it easier to click on the map.
 * @property {Collection<import("./Overlay.js").default>|Array<import("./Overlay.js").default>} [overlays]
 * Overlays initially added to the map. By default, no overlays are added.
 * @property {HTMLElement|string} [target] The container for the map, either the
 * element itself or the `id` of the element. If not specified at construction
 * time, {@link module:ol/Map~Map#setTarget} must be called for the map to be
 * rendered. If passed by element, the container can be in a secondary document.
 * @property {View} [view] The map's view.  No layer sources will be
 * fetched unless this is specified at construction time or through
 * {@link module:ol/Map~Map#setView}.
 */
/**
 * @api
 */
var PluggableMap = /** @class */ (function (_super) {
    __extends(PluggableMap, _super);
    /**
     * @param {MapOptions} options Map options.
     */
    function PluggableMap(options) {
        var _this = _super.call(this) || this;
        /***
         * @type {PluggableMapOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {PluggableMapOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {PluggableMapOnSignature<void>}
         */
        _this.un;
        var optionsInternal = createOptionsInternal(options);
        /** @private */
        _this.boundHandleBrowserEvent_ = _this.handleBrowserEvent.bind(_this);
        /**
         * @type {number}
         * @private
         */
        _this.maxTilesLoading_ =
            options.maxTilesLoading !== undefined ? options.maxTilesLoading : 16;
        /**
         * @private
         * @type {number}
         */
        _this.pixelRatio_ =
            options.pixelRatio !== undefined
                ? options.pixelRatio
                : _has_js__WEBPACK_IMPORTED_MODULE_17__["DEVICE_PIXEL_RATIO"];
        /**
         * @private
         * @type {*}
         */
        _this.postRenderTimeoutHandle_;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.animationDelayKey_;
        /**
         * @private
         */
        _this.animationDelay_ = /** @this {PluggableMap} */ function () {
            this.animationDelayKey_ = undefined;
            this.renderFrame_(Date.now());
        }.bind(_this);
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */
        _this.coordinateToPixelTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_19__["create"])();
        /**
         * @private
         * @type {import("./transform.js").Transform}
         */
        _this.pixelToCoordinateTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_19__["create"])();
        /**
         * @private
         * @type {number}
         */
        _this.frameIndex_ = 0;
        /**
         * @private
         * @type {?FrameState}
         */
        _this.frameState_ = null;
        /**
         * The extent at the previous 'moveend' event.
         * @private
         * @type {import("./extent.js").Extent}
         */
        _this.previousExtent_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */
        _this.viewPropertyListenerKey_ = null;
        /**
         * @private
         * @type {?import("./events.js").EventsKey}
         */
        _this.viewChangeListenerKey_ = null;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */
        _this.layerGroupPropertyListenerKeys_ = null;
        /**
         * @private
         * @type {!HTMLElement}
         */
        _this.viewport_ = document.createElement('div');
        _this.viewport_.className =
            'ol-viewport' + ('ontouchstart' in window ? ' ol-touch' : '');
        _this.viewport_.style.position = 'relative';
        _this.viewport_.style.overflow = 'hidden';
        _this.viewport_.style.width = '100%';
        _this.viewport_.style.height = '100%';
        /**
         * @private
         * @type {!HTMLElement}
         */
        _this.overlayContainer_ = document.createElement('div');
        _this.overlayContainer_.style.position = 'absolute';
        _this.overlayContainer_.style.zIndex = '0';
        _this.overlayContainer_.style.width = '100%';
        _this.overlayContainer_.style.height = '100%';
        _this.overlayContainer_.style.pointerEvents = 'none';
        _this.overlayContainer_.className = 'ol-overlaycontainer';
        _this.viewport_.appendChild(_this.overlayContainer_);
        /**
         * @private
         * @type {!HTMLElement}
         */
        _this.overlayContainerStopEvent_ = document.createElement('div');
        _this.overlayContainerStopEvent_.style.position = 'absolute';
        _this.overlayContainerStopEvent_.style.zIndex = '0';
        _this.overlayContainerStopEvent_.style.width = '100%';
        _this.overlayContainerStopEvent_.style.height = '100%';
        _this.overlayContainerStopEvent_.style.pointerEvents = 'none';
        _this.overlayContainerStopEvent_.className = 'ol-overlaycontainer-stopevent';
        _this.viewport_.appendChild(_this.overlayContainerStopEvent_);
        /**
         * @private
         * @type {MapBrowserEventHandler}
         */
        _this.mapBrowserEventHandler_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.moveTolerance_ = options.moveTolerance;
        /**
         * @private
         * @type {HTMLElement|Document}
         */
        _this.keyboardEventTarget_ = optionsInternal.keyboardEventTarget;
        /**
         * @private
         * @type {?Array<import("./events.js").EventsKey>}
         */
        _this.keyHandlerKeys_ = null;
        /**
         * @type {Collection<import("./control/Control.js").default>}
         * @protected
         */
        _this.controls = optionsInternal.controls || new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
        /**
         * @type {Collection<import("./interaction/Interaction.js").default>}
         * @protected
         */
        _this.interactions = optionsInternal.interactions || new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
        /**
         * @type {Collection<import("./Overlay.js").default>}
         * @private
         */
        _this.overlays_ = optionsInternal.overlays;
        /**
         * A lookup of overlays by id.
         * @private
         * @type {Object<string, import("./Overlay.js").default>}
         */
        _this.overlayIdIndex_ = {};
        /**
         * @type {import("./renderer/Map.js").default}
         * @private
         */
        _this.renderer_ = null;
        /**
         * @type {undefined|function(Event): void}
         * @private
         */
        _this.handleResize_;
        /**
         * @private
         * @type {!Array<PostRenderFunction>}
         */
        _this.postRenderFunctions_ = [];
        /**
         * @private
         * @type {TileQueue}
         */
        _this.tileQueue_ = new _TileQueue_js__WEBPACK_IMPORTED_MODULE_14__["default"](_this.getTilePriority.bind(_this), _this.handleTileChange_.bind(_this));
        _this.addChangeListener(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].LAYERGROUP, _this.handleLayerGroupChanged_);
        _this.addChangeListener(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].VIEW, _this.handleViewChanged_);
        _this.addChangeListener(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].SIZE, _this.handleSizeChanged_);
        _this.addChangeListener(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].TARGET, _this.handleTargetChanged_);
        // setProperties will trigger the rendering of the map if the map
        // is "defined" already.
        _this.setProperties(optionsInternal.values);
        _this.controls.forEach(
        /**
         * @param {import("./control/Control.js").default} control Control.
         * @this {PluggableMap}
         */
        function (control) {
            control.setMap(this);
        }.bind(_this));
        _this.controls.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            event.element.setMap(this);
        }.bind(_this));
        _this.controls.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            event.element.setMap(null);
        }.bind(_this));
        _this.interactions.forEach(
        /**
         * @param {import("./interaction/Interaction.js").default} interaction Interaction.
         * @this {PluggableMap}
         */
        function (interaction) {
            interaction.setMap(this);
        }.bind(_this));
        _this.interactions.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            event.element.setMap(this);
        }.bind(_this));
        _this.interactions.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            event.element.setMap(null);
        }.bind(_this));
        _this.overlays_.forEach(_this.addOverlayInternal_.bind(_this));
        _this.overlays_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            this.addOverlayInternal_(
            /** @type {import("./Overlay.js").default} */ (event.element));
        }.bind(_this));
        _this.overlays_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, 
        /**
         * @param {import("./Collection.js").CollectionEvent} event CollectionEvent.
         */
        function (event) {
            var overlay = /** @type {import("./Overlay.js").default} */ (event.element);
            var id = overlay.getId();
            if (id !== undefined) {
                delete this.overlayIdIndex_[id.toString()];
            }
            event.element.setMap(null);
        }.bind(_this));
        return _this;
    }
    /**
     * @abstract
     * @return {import("./renderer/Map.js").default} The map renderer
     */
    PluggableMap.prototype.createRenderer = function () {
        throw new Error('Use a map type that has a createRenderer method');
    };
    /**
     * Add the given control to the map.
     * @param {import("./control/Control.js").default} control Control.
     * @api
     */
    PluggableMap.prototype.addControl = function (control) {
        this.getControls().push(control);
    };
    /**
     * Add the given interaction to the map. If you want to add an interaction
     * at another point of the collection use `getInteraction()` and the methods
     * available on {@link module:ol/Collection~Collection}. This can be used to
     * stop the event propagation from the handleEvent function. The interactions
     * get to handle the events in the reverse order of this collection.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to add.
     * @api
     */
    PluggableMap.prototype.addInteraction = function (interaction) {
        this.getInteractions().push(interaction);
    };
    /**
     * Adds the given layer to the top of this map. If you want to add a layer
     * elsewhere in the stack, use `getLayers()` and the methods available on
     * {@link module:ol/Collection~Collection}.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @api
     */
    PluggableMap.prototype.addLayer = function (layer) {
        var layers = this.getLayerGroup().getLayers();
        layers.push(layer);
    };
    /**
     * Add the given overlay to the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @api
     */
    PluggableMap.prototype.addOverlay = function (overlay) {
        this.getOverlays().push(overlay);
    };
    /**
     * This deals with map's overlay collection changes.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @private
     */
    PluggableMap.prototype.addOverlayInternal_ = function (overlay) {
        var id = overlay.getId();
        if (id !== undefined) {
            this.overlayIdIndex_[id.toString()] = overlay;
        }
        overlay.setMap(this);
    };
    /**
     *
     * Clean up.
     */
    PluggableMap.prototype.disposeInternal = function () {
        this.setTarget(null);
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Detect features that intersect a pixel on the viewport, and execute a
     * callback with each intersecting feature. Layers included in the detection can
     * be configured through the `layerFilter` option in `opt_options`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(import("./Feature.js").FeatureLike, import("./layer/Layer.js").default, import("./geom/SimpleGeometry.js").default): T} callback Feature callback. The callback will be
     *     called with two arguments. The first argument is one
     *     {@link module:ol/Feature feature} or
     *     {@link module:ol/render/Feature render feature} at the pixel, the second is
     *     the {@link module:ol/layer/Layer layer} of the feature and will be null for
     *     unmanaged layers. To stop detection, callback functions can return a
     *     truthy value.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template S,T
     * @api
     */
    PluggableMap.prototype.forEachFeatureAtPixel = function (pixel, callback, opt_options) {
        if (!this.frameState_) {
            return;
        }
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : _functions_js__WEBPACK_IMPORTED_MODULE_18__["TRUE"];
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.forEachFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, callback, null, layerFilter, null);
    };
    /**
     * Get all features that intersect a pixel on the viewport.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {Array<import("./Feature.js").FeatureLike>} The detected features or
     * an empty array if none were found.
     * @api
     */
    PluggableMap.prototype.getFeaturesAtPixel = function (pixel, opt_options) {
        var features = [];
        this.forEachFeatureAtPixel(pixel, function (feature) {
            features.push(feature);
        }, opt_options);
        return features;
    };
    /**
     * Detect layers that have a color value at a pixel on the viewport, and
     * execute a callback with each matching layer. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     *
     * Note: this may give false positives unless the map layers have had different `className`
     * properties assigned to them.
     *
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {function(this: S, import("./layer/Layer.js").default, (Uint8ClampedArray|Uint8Array)): T} callback
     *     Layer callback. This callback will receive two arguments: first is the
     *     {@link module:ol/layer/Layer layer}, second argument is an array representing
     *     [R, G, B, A] pixel values (0 - 255) and will be `null` for layer types
     *     that do not currently support this argument. To stop detection, callback
     *     functions can return a truthy value.
     * @param {AtPixelOptions} [opt_options] Configuration options.
     * @return {T|undefined} Callback result, i.e. the return value of last
     * callback execution, or the first truthy callback return value.
     * @template S,T
     * @api
     */
    PluggableMap.prototype.forEachLayerAtPixel = function (pixel, callback, opt_options) {
        if (!this.frameState_) {
            return;
        }
        var options = opt_options || {};
        var hitTolerance = options.hitTolerance !== undefined ? options.hitTolerance : 0;
        var layerFilter = options.layerFilter || _functions_js__WEBPACK_IMPORTED_MODULE_18__["TRUE"];
        return this.renderer_.forEachLayerAtPixel(pixel, this.frameState_, hitTolerance, callback, layerFilter);
    };
    /**
     * Detect if features intersect a pixel on the viewport. Layers included in the
     * detection can be configured through `opt_layerFilter`.
     * @param {import("./pixel.js").Pixel} pixel Pixel.
     * @param {AtPixelOptions} [opt_options] Optional options.
     * @return {boolean} Is there a feature at the given pixel?
     * @api
     */
    PluggableMap.prototype.hasFeatureAtPixel = function (pixel, opt_options) {
        if (!this.frameState_) {
            return false;
        }
        var coordinate = this.getCoordinateFromPixelInternal(pixel);
        opt_options = opt_options !== undefined ? opt_options : {};
        var layerFilter = opt_options.layerFilter !== undefined ? opt_options.layerFilter : _functions_js__WEBPACK_IMPORTED_MODULE_18__["TRUE"];
        var hitTolerance = opt_options.hitTolerance !== undefined ? opt_options.hitTolerance : 0;
        var checkWrapped = opt_options.checkWrapped !== false;
        return this.renderer_.hasFeatureAtCoordinate(coordinate, this.frameState_, hitTolerance, checkWrapped, layerFilter, null);
    };
    /**
     * Returns the coordinate in user projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     * @api
     */
    PluggableMap.prototype.getEventCoordinate = function (event) {
        return this.getCoordinateFromPixel(this.getEventPixel(event));
    };
    /**
     * Returns the coordinate in view projection for a browser event.
     * @param {MouseEvent} event Event.
     * @return {import("./coordinate.js").Coordinate} Coordinate.
     */
    PluggableMap.prototype.getEventCoordinateInternal = function (event) {
        return this.getCoordinateFromPixelInternal(this.getEventPixel(event));
    };
    /**
     * Returns the map pixel position for a browser event relative to the viewport.
     * @param {UIEvent} event Event.
     * @return {import("./pixel.js").Pixel} Pixel.
     * @api
     */
    PluggableMap.prototype.getEventPixel = function (event) {
        var viewportPosition = this.viewport_.getBoundingClientRect();
        var eventPosition = 
        //FIXME Are we really calling this with a TouchEvent anywhere?
        'changedTouches' in event
            ? /** @type {TouchEvent} */ (event).changedTouches[0]
            : /** @type {MouseEvent} */ (event);
        return [
            eventPosition.clientX - viewportPosition.left,
            eventPosition.clientY - viewportPosition.top,
        ];
    };
    /**
     * Get the target in which this map is rendered.
     * Note that this returns what is entered as an option or in setTarget:
     * if that was an element, it returns an element; if a string, it returns that.
     * @return {HTMLElement|string|undefined} The Element or id of the Element that the
     *     map is rendered in.
     * @observable
     * @api
     */
    PluggableMap.prototype.getTarget = function () {
        return /** @type {HTMLElement|string|undefined} */ (this.get(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].TARGET));
    };
    /**
     * Get the DOM element into which this map is rendered. In contrast to
     * `getTarget` this method always return an `Element`, or `null` if the
     * map has no target.
     * @return {HTMLElement} The element that the map is rendered in.
     * @api
     */
    PluggableMap.prototype.getTargetElement = function () {
        var target = this.getTarget();
        if (target !== undefined) {
            return typeof target === 'string'
                ? document.getElementById(target)
                : target;
        }
        else {
            return null;
        }
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * user projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     * @api
     */
    PluggableMap.prototype.getCoordinateFromPixel = function (pixel) {
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_22__["toUserCoordinate"])(this.getCoordinateFromPixelInternal(pixel), this.getView().getProjection());
    };
    /**
     * Get the coordinate for a given pixel.  This returns a coordinate in the
     * map view projection.
     * @param {import("./pixel.js").Pixel} pixel Pixel position in the map viewport.
     * @return {import("./coordinate.js").Coordinate} The coordinate for the pixel position.
     */
    PluggableMap.prototype.getCoordinateFromPixelInternal = function (pixel) {
        var frameState = this.frameState_;
        if (!frameState) {
            return null;
        }
        else {
            return Object(_transform_js__WEBPACK_IMPORTED_MODULE_19__["apply"])(frameState.pixelToCoordinateTransform, pixel.slice());
        }
    };
    /**
     * Get the map controls. Modifying this collection changes the controls
     * associated with the map.
     * @return {Collection<import("./control/Control.js").default>} Controls.
     * @api
     */
    PluggableMap.prototype.getControls = function () {
        return this.controls;
    };
    /**
     * Get the map overlays. Modifying this collection changes the overlays
     * associated with the map.
     * @return {Collection<import("./Overlay.js").default>} Overlays.
     * @api
     */
    PluggableMap.prototype.getOverlays = function () {
        return this.overlays_;
    };
    /**
     * Get an overlay by its identifier (the value returned by overlay.getId()).
     * Note that the index treats string and numeric identifiers as the same. So
     * `map.getOverlayById(2)` will return an overlay with id `'2'` or `2`.
     * @param {string|number} id Overlay identifier.
     * @return {import("./Overlay.js").default} Overlay.
     * @api
     */
    PluggableMap.prototype.getOverlayById = function (id) {
        var overlay = this.overlayIdIndex_[id.toString()];
        return overlay !== undefined ? overlay : null;
    };
    /**
     * Get the map interactions. Modifying this collection changes the interactions
     * associated with the map.
     *
     * Interactions are used for e.g. pan, zoom and rotate.
     * @return {Collection<import("./interaction/Interaction.js").default>} Interactions.
     * @api
     */
    PluggableMap.prototype.getInteractions = function () {
        return this.interactions;
    };
    /**
     * Get the layergroup associated with this map.
     * @return {LayerGroup} A layer group containing the layers in this map.
     * @observable
     * @api
     */
    PluggableMap.prototype.getLayerGroup = function () {
        return /** @type {LayerGroup} */ (this.get(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].LAYERGROUP));
    };
    /**
     * Get the collection of layers associated with this map.
     * @return {!Collection<import("./layer/Base.js").default>} Layers.
     * @api
     */
    PluggableMap.prototype.getLayers = function () {
        var layers = this.getLayerGroup().getLayers();
        return layers;
    };
    /**
     * @return {boolean} Layers have sources that are still loading.
     */
    PluggableMap.prototype.getLoading = function () {
        var layerStatesArray = this.getLayerGroup().getLayerStatesArray();
        for (var i = 0, ii = layerStatesArray.length; i < ii; ++i) {
            var layer = layerStatesArray[i].layer;
            var source = /** @type {import("./layer/Layer.js").default} */ (layer).getSource();
            if (source && source.loading) {
                return true;
            }
        }
        return false;
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the user
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     * @api
     */
    PluggableMap.prototype.getPixelFromCoordinate = function (coordinate) {
        var viewCoordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_22__["fromUserCoordinate"])(coordinate, this.getView().getProjection());
        return this.getPixelFromCoordinateInternal(viewCoordinate);
    };
    /**
     * Get the pixel for a coordinate.  This takes a coordinate in the map view
     * projection and returns the corresponding pixel.
     * @param {import("./coordinate.js").Coordinate} coordinate A map coordinate.
     * @return {import("./pixel.js").Pixel} A pixel position in the map viewport.
     */
    PluggableMap.prototype.getPixelFromCoordinateInternal = function (coordinate) {
        var frameState = this.frameState_;
        if (!frameState) {
            return null;
        }
        else {
            return Object(_transform_js__WEBPACK_IMPORTED_MODULE_19__["apply"])(frameState.coordinateToPixelTransform, coordinate.slice(0, 2));
        }
    };
    /**
     * Get the map renderer.
     * @return {import("./renderer/Map.js").default} Renderer
     */
    PluggableMap.prototype.getRenderer = function () {
        return this.renderer_;
    };
    /**
     * Get the size of this map.
     * @return {import("./size.js").Size|undefined} The size in pixels of the map in the DOM.
     * @observable
     * @api
     */
    PluggableMap.prototype.getSize = function () {
        return /** @type {import("./size.js").Size|undefined} */ (this.get(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].SIZE));
    };
    /**
     * Get the view associated with this map. A view manages properties such as
     * center and resolution.
     * @return {View} The view that controls this map.
     * @observable
     * @api
     */
    PluggableMap.prototype.getView = function () {
        return /** @type {View} */ (this.get(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].VIEW));
    };
    /**
     * Get the element that serves as the map viewport.
     * @return {HTMLElement} Viewport.
     * @api
     */
    PluggableMap.prototype.getViewport = function () {
        return this.viewport_;
    };
    /**
     * Get the element that serves as the container for overlays.  Elements added to
     * this container will let mousedown and touchstart events through to the map,
     * so clicks and gestures on an overlay will trigger {@link module:ol/MapBrowserEvent~MapBrowserEvent}
     * events.
     * @return {!HTMLElement} The map's overlay container.
     */
    PluggableMap.prototype.getOverlayContainer = function () {
        return this.overlayContainer_;
    };
    /**
     * Get the element that serves as a container for overlays that don't allow
     * event propagation. Elements added to this container won't let mousedown and
     * touchstart events through to the map, so clicks and gestures on an overlay
     * don't trigger any {@link module:ol/MapBrowserEvent~MapBrowserEvent}.
     * @return {!HTMLElement} The map's overlay container that stops events.
     */
    PluggableMap.prototype.getOverlayContainerStopEvent = function () {
        return this.overlayContainerStopEvent_;
    };
    /**
     * @return {!Document} The document where the map is displayed.
     */
    PluggableMap.prototype.getOwnerDocument = function () {
        var targetElement = this.getTargetElement();
        return targetElement ? targetElement.ownerDocument : document;
    };
    /**
     * @param {import("./Tile.js").default} tile Tile.
     * @param {string} tileSourceKey Tile source key.
     * @param {import("./coordinate.js").Coordinate} tileCenter Tile center.
     * @param {number} tileResolution Tile resolution.
     * @return {number} Tile priority.
     */
    PluggableMap.prototype.getTilePriority = function (tile, tileSourceKey, tileCenter, tileResolution) {
        return Object(_TileQueue_js__WEBPACK_IMPORTED_MODULE_14__["getTilePriority"])(this.frameState_, tile, tileSourceKey, tileCenter, tileResolution);
    };
    /**
     * @param {UIEvent} browserEvent Browser event.
     * @param {string} [opt_type] Type.
     */
    PluggableMap.prototype.handleBrowserEvent = function (browserEvent, opt_type) {
        var type = opt_type || browserEvent.type;
        var mapBrowserEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_5__["default"](type, this, browserEvent);
        this.handleMapBrowserEvent(mapBrowserEvent);
    };
    /**
     * @param {MapBrowserEvent} mapBrowserEvent The event to handle.
     */
    PluggableMap.prototype.handleMapBrowserEvent = function (mapBrowserEvent) {
        if (!this.frameState_) {
            // With no view defined, we cannot translate pixels into geographical
            // coordinates so interactions cannot be used.
            return;
        }
        var originalEvent = /** @type {PointerEvent} */ (mapBrowserEvent.originalEvent);
        var eventType = originalEvent.type;
        if (eventType === _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_12__["default"].POINTERDOWN ||
            eventType === _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].WHEEL ||
            eventType === _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].KEYDOWN) {
            var doc = this.getOwnerDocument();
            var rootNode = this.viewport_.getRootNode
                ? this.viewport_.getRootNode()
                : doc;
            var target = /** @type {Node} */ (originalEvent.target);
            if (
            // Abort if the target is a child of the container for elements whose events are not meant
            // to be handled by map interactions.
            this.overlayContainerStopEvent_.contains(target) ||
                // Abort if the event target is a child of the container that is no longer in the page.
                // It's possible for the target to no longer be in the page if it has been removed in an
                // event listener, this might happen in a Control that recreates it's content based on
                // user interaction either manually or via a render in something like https://reactjs.org/
                !(rootNode === doc ? doc.documentElement : rootNode).contains(target)) {
                return;
            }
        }
        mapBrowserEvent.frameState = this.frameState_;
        if (this.dispatchEvent(mapBrowserEvent) !== false) {
            var interactionsArray = this.getInteractions().getArray().slice();
            for (var i = interactionsArray.length - 1; i >= 0; i--) {
                var interaction = interactionsArray[i];
                if (interaction.getMap() !== this ||
                    !interaction.getActive() ||
                    !this.getTargetElement()) {
                    continue;
                }
                var cont = interaction.handleEvent(mapBrowserEvent);
                if (!cont || mapBrowserEvent.propagationStopped) {
                    break;
                }
            }
        }
    };
    /**
     * @protected
     */
    PluggableMap.prototype.handlePostRender = function () {
        var frameState = this.frameState_;
        // Manage the tile queue
        // Image loads are expensive and a limited resource, so try to use them
        // efficiently:
        // * When the view is static we allow a large number of parallel tile loads
        //   to complete the frame as quickly as possible.
        // * When animating or interacting, image loads can cause janks, so we reduce
        //   the maximum number of loads per frame and limit the number of parallel
        //   tile loads to remain reactive to view changes and to reduce the chance of
        //   loading tiles that will quickly disappear from view.
        var tileQueue = this.tileQueue_;
        if (!tileQueue.isEmpty()) {
            var maxTotalLoading = this.maxTilesLoading_;
            var maxNewLoads = maxTotalLoading;
            if (frameState) {
                var hints = frameState.viewHints;
                if (hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_16__["default"].ANIMATING] || hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_16__["default"].INTERACTING]) {
                    var lowOnFrameBudget = Date.now() - frameState.time > 8;
                    maxTotalLoading = lowOnFrameBudget ? 0 : 8;
                    maxNewLoads = lowOnFrameBudget ? 0 : 2;
                }
            }
            if (tileQueue.getTilesLoading() < maxTotalLoading) {
                tileQueue.reprioritize(); // FIXME only call if view has changed
                tileQueue.loadMoreTiles(maxTotalLoading, maxNewLoads);
            }
        }
        if (frameState &&
            this.hasListener(_render_EventType_js__WEBPACK_IMPORTED_MODULE_13__["default"].RENDERCOMPLETE) &&
            !frameState.animate &&
            !this.tileQueue_.getTilesLoading() &&
            !this.getLoading()) {
            this.renderer_.dispatchRenderEvent(_render_EventType_js__WEBPACK_IMPORTED_MODULE_13__["default"].RENDERCOMPLETE, frameState);
        }
        var postRenderFunctions = this.postRenderFunctions_;
        for (var i = 0, ii = postRenderFunctions.length; i < ii; ++i) {
            postRenderFunctions[i](this, frameState);
        }
        postRenderFunctions.length = 0;
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleSizeChanged_ = function () {
        if (this.getView() && !this.getView().getAnimating()) {
            this.getView().resolveConstraints(0);
        }
        this.render();
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleTargetChanged_ = function () {
        // target may be undefined, null, a string or an Element.
        // If it's a string we convert it to an Element before proceeding.
        // If it's not now an Element we remove the viewport from the DOM.
        // If it's an Element we append the viewport element to it.
        var targetElement;
        if (this.getTarget()) {
            targetElement = this.getTargetElement();
        }
        if (this.mapBrowserEventHandler_) {
            for (var i = 0, ii = this.keyHandlerKeys_.length; i < ii; ++i) {
                Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["unlistenByKey"])(this.keyHandlerKeys_[i]);
            }
            this.keyHandlerKeys_ = null;
            this.viewport_.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CONTEXTMENU, this.boundHandleBrowserEvent_);
            this.viewport_.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].WHEEL, this.boundHandleBrowserEvent_);
            if (this.handleResize_ !== undefined) {
                removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].RESIZE, this.handleResize_, false);
                this.handleResize_ = undefined;
            }
            this.mapBrowserEventHandler_.dispose();
            this.mapBrowserEventHandler_ = null;
            Object(_dom_js__WEBPACK_IMPORTED_MODULE_25__["removeNode"])(this.viewport_);
        }
        if (!targetElement) {
            if (this.renderer_) {
                clearTimeout(this.postRenderTimeoutHandle_);
                this.postRenderTimeoutHandle_ = undefined;
                this.postRenderFunctions_.length = 0;
                this.renderer_.dispose();
                this.renderer_ = null;
            }
            if (this.animationDelayKey_) {
                cancelAnimationFrame(this.animationDelayKey_);
                this.animationDelayKey_ = undefined;
            }
        }
        else {
            targetElement.appendChild(this.viewport_);
            if (!this.renderer_) {
                this.renderer_ = this.createRenderer();
            }
            this.mapBrowserEventHandler_ = new _MapBrowserEventHandler_js__WEBPACK_IMPORTED_MODULE_6__["default"](this, this.moveTolerance_);
            for (var key in _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_7__["default"]) {
                this.mapBrowserEventHandler_.addEventListener(_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_7__["default"][key], this.handleMapBrowserEvent.bind(this));
            }
            this.viewport_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CONTEXTMENU, this.boundHandleBrowserEvent_, false);
            this.viewport_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].WHEEL, this.boundHandleBrowserEvent_, _has_js__WEBPACK_IMPORTED_MODULE_17__["PASSIVE_EVENT_LISTENERS"] ? { passive: false } : false);
            var keyboardEventTarget = !this.keyboardEventTarget_
                ? targetElement
                : this.keyboardEventTarget_;
            this.keyHandlerKeys_ = [
                Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(keyboardEventTarget, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].KEYDOWN, this.handleBrowserEvent, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(keyboardEventTarget, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].KEYPRESS, this.handleBrowserEvent, this),
            ];
            if (!this.handleResize_) {
                this.handleResize_ = this.updateSize.bind(this);
                window.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].RESIZE, this.handleResize_, false);
            }
        }
        this.updateSize();
        // updateSize calls setSize, so no need to call this.render
        // ourselves here.
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleTileChange_ = function () {
        this.render();
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleViewPropertyChanged_ = function () {
        this.render();
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleViewChanged_ = function () {
        if (this.viewPropertyListenerKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["unlistenByKey"])(this.viewPropertyListenerKey_);
            this.viewPropertyListenerKey_ = null;
        }
        if (this.viewChangeListenerKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["unlistenByKey"])(this.viewChangeListenerKey_);
            this.viewChangeListenerKey_ = null;
        }
        var view = this.getView();
        if (view) {
            this.updateViewportSize_();
            this.viewPropertyListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(view, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_11__["default"].PROPERTYCHANGE, this.handleViewPropertyChanged_, this);
            this.viewChangeListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(view, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.handleViewPropertyChanged_, this);
            view.resolveConstraints(0);
        }
        this.render();
    };
    /**
     * @private
     */
    PluggableMap.prototype.handleLayerGroupChanged_ = function () {
        if (this.layerGroupPropertyListenerKeys_) {
            this.layerGroupPropertyListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_24__["unlistenByKey"]);
            this.layerGroupPropertyListenerKeys_ = null;
        }
        var layerGroup = this.getLayerGroup();
        if (layerGroup) {
            this.layerGroupPropertyListenerKeys_ = [
                Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(layerGroup, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_11__["default"].PROPERTYCHANGE, this.render, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_24__["listen"])(layerGroup, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.render, this),
            ];
        }
        this.render();
    };
    /**
     * @return {boolean} Is rendered.
     */
    PluggableMap.prototype.isRendered = function () {
        return !!this.frameState_;
    };
    /**
     * Requests an immediate render in a synchronous manner.
     * @api
     */
    PluggableMap.prototype.renderSync = function () {
        if (this.animationDelayKey_) {
            cancelAnimationFrame(this.animationDelayKey_);
        }
        this.animationDelay_();
    };
    /**
     * Redraws all text after new fonts have loaded
     */
    PluggableMap.prototype.redrawText = function () {
        var layerStates = this.getLayerGroup().getLayerStatesArray();
        for (var i = 0, ii = layerStates.length; i < ii; ++i) {
            var layer = layerStates[i].layer;
            if (layer.hasRenderer()) {
                layer.getRenderer().handleFontsChanged();
            }
        }
    };
    /**
     * Request a map rendering (at the next animation frame).
     * @api
     */
    PluggableMap.prototype.render = function () {
        if (this.renderer_ && this.animationDelayKey_ === undefined) {
            this.animationDelayKey_ = requestAnimationFrame(this.animationDelay_);
        }
    };
    /**
     * Remove the given control from the map.
     * @param {import("./control/Control.js").default} control Control.
     * @return {import("./control/Control.js").default|undefined} The removed control (or undefined
     *     if the control was not found).
     * @api
     */
    PluggableMap.prototype.removeControl = function (control) {
        return this.getControls().remove(control);
    };
    /**
     * Remove the given interaction from the map.
     * @param {import("./interaction/Interaction.js").default} interaction Interaction to remove.
     * @return {import("./interaction/Interaction.js").default|undefined} The removed interaction (or
     *     undefined if the interaction was not found).
     * @api
     */
    PluggableMap.prototype.removeInteraction = function (interaction) {
        return this.getInteractions().remove(interaction);
    };
    /**
     * Removes the given layer from the map.
     * @param {import("./layer/Base.js").default} layer Layer.
     * @return {import("./layer/Base.js").default|undefined} The removed layer (or undefined if the
     *     layer was not found).
     * @api
     */
    PluggableMap.prototype.removeLayer = function (layer) {
        var layers = this.getLayerGroup().getLayers();
        return layers.remove(layer);
    };
    /**
     * Remove the given overlay from the map.
     * @param {import("./Overlay.js").default} overlay Overlay.
     * @return {import("./Overlay.js").default|undefined} The removed overlay (or undefined
     *     if the overlay was not found).
     * @api
     */
    PluggableMap.prototype.removeOverlay = function (overlay) {
        return this.getOverlays().remove(overlay);
    };
    /**
     * @param {number} time Time.
     * @private
     */
    PluggableMap.prototype.renderFrame_ = function (time) {
        var _this = this;
        var size = this.getSize();
        var view = this.getView();
        var previousFrameState = this.frameState_;
        /** @type {?FrameState} */
        var frameState = null;
        if (size !== undefined && Object(_size_js__WEBPACK_IMPORTED_MODULE_23__["hasArea"])(size) && view && view.isDef()) {
            var viewHints = view.getHints(this.frameState_ ? this.frameState_.viewHints : undefined);
            var viewState = view.getState();
            frameState = {
                animate: false,
                coordinateToPixelTransform: this.coordinateToPixelTransform_,
                declutterTree: null,
                extent: Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["getForViewAndSize"])(viewState.center, viewState.resolution, viewState.rotation, size),
                index: this.frameIndex_++,
                layerIndex: 0,
                layerStatesArray: this.getLayerGroup().getLayerStatesArray(),
                pixelRatio: this.pixelRatio_,
                pixelToCoordinateTransform: this.pixelToCoordinateTransform_,
                postRenderFunctions: [],
                size: size,
                tileQueue: this.tileQueue_,
                time: time,
                usedTiles: {},
                viewState: viewState,
                viewHints: viewHints,
                wantedTiles: {},
            };
        }
        this.frameState_ = frameState;
        this.renderer_.renderFrame(frameState);
        if (frameState) {
            if (frameState.animate) {
                this.render();
            }
            Array.prototype.push.apply(this.postRenderFunctions_, frameState.postRenderFunctions);
            if (previousFrameState) {
                var moveStart = !this.previousExtent_ ||
                    (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["isEmpty"])(this.previousExtent_) &&
                        !Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["equals"])(frameState.extent, this.previousExtent_));
                if (moveStart) {
                    this.dispatchEvent(new _MapEvent_js__WEBPACK_IMPORTED_MODULE_8__["default"](_MapEventType_js__WEBPACK_IMPORTED_MODULE_9__["default"].MOVESTART, this, previousFrameState));
                    this.previousExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["createOrUpdateEmpty"])(this.previousExtent_);
                }
            }
            var idle = this.previousExtent_ &&
                !frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_16__["default"].ANIMATING] &&
                !frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_16__["default"].INTERACTING] &&
                !Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["equals"])(frameState.extent, this.previousExtent_);
            if (idle) {
                this.dispatchEvent(new _MapEvent_js__WEBPACK_IMPORTED_MODULE_8__["default"](_MapEventType_js__WEBPACK_IMPORTED_MODULE_9__["default"].MOVEEND, this, frameState));
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_21__["clone"])(frameState.extent, this.previousExtent_);
            }
        }
        this.dispatchEvent(new _MapEvent_js__WEBPACK_IMPORTED_MODULE_8__["default"](_MapEventType_js__WEBPACK_IMPORTED_MODULE_9__["default"].POSTRENDER, this, frameState));
        if (!this.postRenderTimeoutHandle_) {
            this.postRenderTimeoutHandle_ = setTimeout(function () {
                _this.postRenderTimeoutHandle_ = undefined;
                _this.handlePostRender();
            }, 0);
        }
    };
    /**
     * Sets the layergroup of this map.
     * @param {LayerGroup} layerGroup A layer group containing the layers in this map.
     * @observable
     * @api
     */
    PluggableMap.prototype.setLayerGroup = function (layerGroup) {
        this.set(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].LAYERGROUP, layerGroup);
    };
    /**
     * Set the size of this map.
     * @param {import("./size.js").Size|undefined} size The size in pixels of the map in the DOM.
     * @observable
     * @api
     */
    PluggableMap.prototype.setSize = function (size) {
        this.set(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].SIZE, size);
    };
    /**
     * Set the target element to render this map into.
     * @param {HTMLElement|string|undefined} target The Element or id of the Element
     *     that the map is rendered in.
     * @observable
     * @api
     */
    PluggableMap.prototype.setTarget = function (target) {
        this.set(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].TARGET, target);
    };
    /**
     * Set the view for this map.
     * @param {View} view The view that controls this map.
     * @observable
     * @api
     */
    PluggableMap.prototype.setView = function (view) {
        this.set(_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].VIEW, view);
    };
    /**
     * Force a recalculation of the map viewport size.  This should be called when
     * third-party code changes the size of the map viewport.
     * @api
     */
    PluggableMap.prototype.updateSize = function () {
        var targetElement = this.getTargetElement();
        var size = undefined;
        if (targetElement) {
            var computedStyle = getComputedStyle(targetElement);
            var width = targetElement.offsetWidth -
                parseFloat(computedStyle['borderLeftWidth']) -
                parseFloat(computedStyle['paddingLeft']) -
                parseFloat(computedStyle['paddingRight']) -
                parseFloat(computedStyle['borderRightWidth']);
            var height = targetElement.offsetHeight -
                parseFloat(computedStyle['borderTopWidth']) -
                parseFloat(computedStyle['paddingTop']) -
                parseFloat(computedStyle['paddingBottom']) -
                parseFloat(computedStyle['borderBottomWidth']);
            if (!isNaN(width) && !isNaN(height)) {
                size = [width, height];
                if (!Object(_size_js__WEBPACK_IMPORTED_MODULE_23__["hasArea"])(size)) {
                    // eslint-disable-next-line
                    console.warn("No map visible because the map container's width or height are 0.");
                }
            }
        }
        this.setSize(size);
        this.updateViewportSize_();
    };
    /**
     * Recomputes the viewport size and save it on the view object (if any)
     * @private
     */
    PluggableMap.prototype.updateViewportSize_ = function () {
        var view = this.getView();
        if (view) {
            var size = undefined;
            var computedStyle = getComputedStyle(this.viewport_);
            if (computedStyle.width && computedStyle.height) {
                size = [
                    parseInt(computedStyle.width, 10),
                    parseInt(computedStyle.height, 10),
                ];
            }
            view.setViewportSize(size);
        }
    };
    return PluggableMap;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {MapOptions} options Map options.
 * @return {MapOptionsInternal} Internal map options.
 */
function createOptionsInternal(options) {
    /**
     * @type {HTMLElement|Document}
     */
    var keyboardEventTarget = null;
    if (options.keyboardEventTarget !== undefined) {
        keyboardEventTarget =
            typeof options.keyboardEventTarget === 'string'
                ? document.getElementById(options.keyboardEventTarget)
                : options.keyboardEventTarget;
    }
    /**
     * @type {Object<string, *>}
     */
    var values = {};
    var layerGroup = options.layers &&
        typeof ( /** @type {?} */(options.layers).getLayers) === 'function'
        ? /** @type {LayerGroup} */ (options.layers)
        : new _layer_Group_js__WEBPACK_IMPORTED_MODULE_4__["default"]({ layers: /** @type {Collection} */ (options.layers) });
    values[_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].LAYERGROUP] = layerGroup;
    values[_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].TARGET] = options.target;
    values[_MapProperty_js__WEBPACK_IMPORTED_MODULE_10__["default"].VIEW] =
        options.view !== undefined ? options.view : new _View_js__WEBPACK_IMPORTED_MODULE_15__["default"]();
    var controls;
    if (options.controls !== undefined) {
        if (Array.isArray(options.controls)) {
            controls = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](options.controls.slice());
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(typeof ( /** @type {?} */(options.controls).getArray) === 'function', 47); // Expected `controls` to be an array or an `import("./Collection.js").Collection`
            controls = /** @type {Collection} */ (options.controls);
        }
    }
    var interactions;
    if (options.interactions !== undefined) {
        if (Array.isArray(options.interactions)) {
            interactions = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](options.interactions.slice());
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(typeof ( /** @type {?} */(options.interactions).getArray) ===
                'function', 48); // Expected `interactions` to be an array or an `import("./Collection.js").Collection`
            interactions = /** @type {Collection} */ (options.interactions);
        }
    }
    var overlays;
    if (options.overlays !== undefined) {
        if (Array.isArray(options.overlays)) {
            overlays = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](options.overlays.slice());
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(typeof ( /** @type {?} */(options.overlays).getArray) === 'function', 49); // Expected `overlays` to be an array or an `import("./Collection.js").Collection`
            overlays = options.overlays;
        }
    }
    else {
        overlays = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
    }
    return {
        controls: controls,
        interactions: interactions,
        keyboardEventTarget: keyboardEventTarget,
        overlays: overlays,
        values: values,
    };
}
/* harmony default export */ __webpack_exports__["default"] = (PluggableMap);
//# sourceMappingURL=PluggableMap.js.map

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Base_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(132);
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(106);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(107);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53);
/* harmony import */ var _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47);
/* harmony import */ var _source_State_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Group
 */











/**
 * @typedef {Object} Options
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<import("./Base.js").default>|import("../Collection.js").default<import("./Base.js").default>} [layers] Child layers.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @enum {string}
 * @private
 */
var Property = {
    LAYERS: 'layers',
};
/**
 * @classdesc
 * A {@link module:ol/Collection~Collection} of layers that are handled together.
 *
 * A generic `change` event is triggered when the group/Collection changes.
 *
 * @api
 */
var LayerGroup = /** @class */ (function (_super) {
    __extends(LayerGroup, _super);
    /**
     * @param {Options} [opt_options] Layer options.
     */
    function LayerGroup(opt_options) {
        var _this = this;
        var options = opt_options || {};
        var baseOptions = /** @type {Options} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["assign"])({}, options));
        delete baseOptions.layers;
        var layers = options.layers;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {Array<import("../events.js").EventsKey>}
         */
        _this.layersListenerKeys_ = [];
        /**
         * @private
         * @type {Object<string, Array<import("../events.js").EventsKey>>}
         */
        _this.listenerKeys_ = {};
        _this.addChangeListener(Property.LAYERS, _this.handleLayersChanged_);
        if (layers) {
            if (Array.isArray(layers)) {
                layers = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](layers.slice(), { unique: true });
            }
            else {
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_6__["assert"])(typeof ( /** @type {?} */(layers).getArray) === 'function', 43); // Expected `layers` to be an array or a `Collection`
            }
        }
        else {
            layers = new _Collection_js__WEBPACK_IMPORTED_MODULE_1__["default"](undefined, { unique: true });
        }
        _this.setLayers(layers);
        return _this;
    }
    /**
     * @private
     */
    LayerGroup.prototype.handleLayerChange_ = function () {
        this.changed();
    };
    /**
     * @private
     */
    LayerGroup.prototype.handleLayersChanged_ = function () {
        this.layersListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_10__["unlistenByKey"]);
        this.layersListenerKeys_.length = 0;
        var layers = this.getLayers();
        this.layersListenerKeys_.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layers, _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADD, this.handleLayersAdd_, this), Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layers, _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVE, this.handleLayersRemove_, this));
        for (var id in this.listenerKeys_) {
            this.listenerKeys_[id].forEach(_events_js__WEBPACK_IMPORTED_MODULE_10__["unlistenByKey"]);
        }
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_7__["clear"])(this.listenerKeys_);
        var layersArray = layers.getArray();
        for (var i = 0, ii = layersArray.length; i < ii; i++) {
            var layer = layersArray[i];
            this.listenerKeys_[Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(layer)] = [
                Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layer, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_4__["default"].PROPERTYCHANGE, this.handleLayerChange_, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layer, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.handleLayerChange_, this),
            ];
        }
        this.changed();
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */
    LayerGroup.prototype.handleLayersAdd_ = function (collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ (collectionEvent.element);
        this.listenerKeys_[Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(layer)] = [
            Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layer, _ObjectEventType_js__WEBPACK_IMPORTED_MODULE_4__["default"].PROPERTYCHANGE, this.handleLayerChange_, this),
            Object(_events_js__WEBPACK_IMPORTED_MODULE_10__["listen"])(layer, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.handleLayerChange_, this),
        ];
        this.changed();
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} collectionEvent CollectionEvent.
     * @private
     */
    LayerGroup.prototype.handleLayersRemove_ = function (collectionEvent) {
        var layer = /** @type {import("./Base.js").default} */ (collectionEvent.element);
        var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(layer);
        this.listenerKeys_[key].forEach(_events_js__WEBPACK_IMPORTED_MODULE_10__["unlistenByKey"]);
        delete this.listenerKeys_[key];
        this.changed();
    };
    /**
     * Returns the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @return {!import("../Collection.js").default<import("./Base.js").default>} Collection of
     *   {@link module:ol/layer/Base layers} that are part of this group.
     * @observable
     * @api
     */
    LayerGroup.prototype.getLayers = function () {
        return /** @type {!import("../Collection.js").default<import("./Base.js").default>} */ (this.get(Property.LAYERS));
    };
    /**
     * Set the {@link module:ol/Collection collection} of {@link module:ol/layer/Layer~Layer layers}
     * in this group.
     * @param {!import("../Collection.js").default<import("./Base.js").default>} layers Collection of
     *   {@link module:ol/layer/Base layers} that are part of this group.
     * @observable
     * @api
     */
    LayerGroup.prototype.setLayers = function (layers) {
        this.set(Property.LAYERS, layers);
    };
    /**
     * @param {Array<import("./Layer.js").default>} [opt_array] Array of layers (to be modified in place).
     * @return {Array<import("./Layer.js").default>} Array of layers.
     */
    LayerGroup.prototype.getLayersArray = function (opt_array) {
        var array = opt_array !== undefined ? opt_array : [];
        this.getLayers().forEach(function (layer) {
            layer.getLayersArray(array);
        });
        return array;
    };
    /**
     * Get the layer states list and use this groups z-index as the default
     * for all layers in this and nested groups, if it is unset at this point.
     * If opt_states is not provided and this group's z-index is undefined
     * 0 is used a the default z-index.
     * @param {Array<import("./Layer.js").State>} [opt_states] Optional list
     * of layer states (to be modified in place).
     * @return {Array<import("./Layer.js").State>} List of layer states.
     */
    LayerGroup.prototype.getLayerStatesArray = function (opt_states) {
        var states = opt_states !== undefined ? opt_states : [];
        var pos = states.length;
        this.getLayers().forEach(function (layer) {
            layer.getLayerStatesArray(states);
        });
        var ownLayerState = this.getLayerState();
        var defaultZIndex = ownLayerState.zIndex;
        if (!opt_states && ownLayerState.zIndex === undefined) {
            defaultZIndex = 0;
        }
        for (var i = pos, ii = states.length; i < ii; i++) {
            var layerState = states[i];
            layerState.opacity *= ownLayerState.opacity;
            layerState.visible = layerState.visible && ownLayerState.visible;
            layerState.maxResolution = Math.min(layerState.maxResolution, ownLayerState.maxResolution);
            layerState.minResolution = Math.max(layerState.minResolution, ownLayerState.minResolution);
            layerState.minZoom = Math.max(layerState.minZoom, ownLayerState.minZoom);
            layerState.maxZoom = Math.min(layerState.maxZoom, ownLayerState.maxZoom);
            if (ownLayerState.extent !== undefined) {
                if (layerState.extent !== undefined) {
                    layerState.extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_8__["getIntersection"])(layerState.extent, ownLayerState.extent);
                }
                else {
                    layerState.extent = ownLayerState.extent;
                }
            }
            if (layerState.zIndex === undefined) {
                layerState.zIndex = defaultZIndex;
            }
        }
        return states;
    };
    /**
     * @return {import("../source/State.js").default} Source state.
     */
    LayerGroup.prototype.getSourceState = function () {
        return _source_State_js__WEBPACK_IMPORTED_MODULE_5__["default"].READY;
    };
    return LayerGroup;
}(_Base_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LayerGroup);
//# sourceMappingURL=Group.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _MapEvent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(176);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/MapBrowserEvent
 */

/**
 * @classdesc
 * Events emitted as map browser events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map browser event.
 * @template {UIEvent} EVENT
 */
var MapBrowserEvent = /** @class */ (function (_super) {
    __extends(MapBrowserEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {EVENT} originalEvent Original event.
     * @param {boolean} [opt_dragging] Is the map currently being dragged?
     * @param {?import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
     */
    function MapBrowserEvent(type, map, originalEvent, opt_dragging, opt_frameState) {
        var _this = _super.call(this, type, map, opt_frameState) || this;
        /**
         * The original browser event.
         * @const
         * @type {EVENT}
         * @api
         */
        _this.originalEvent = originalEvent;
        /**
         * The map pixel relative to the viewport corresponding to the original browser event.
         * @type {?import("./pixel.js").Pixel}
         */
        _this.pixel_ = null;
        /**
         * The coordinate in the user projection corresponding to the original browser event.
         * @type {?import("./coordinate.js").Coordinate}
         */
        _this.coordinate_ = null;
        /**
         * Indicates if the map is currently being dragged. Only set for
         * `POINTERDRAG` and `POINTERMOVE` events. Default is `false`.
         *
         * @type {boolean}
         * @api
         */
        _this.dragging = opt_dragging !== undefined ? opt_dragging : false;
        return _this;
    }
    Object.defineProperty(MapBrowserEvent.prototype, "pixel", {
        /**
         * The map pixel relative to the viewport corresponding to the original event.
         * @type {import("./pixel.js").Pixel}
         * @api
         */
        get: function () {
            if (!this.pixel_) {
                this.pixel_ = this.map.getEventPixel(this.originalEvent);
            }
            return this.pixel_;
        },
        set: function (pixel) {
            this.pixel_ = pixel;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MapBrowserEvent.prototype, "coordinate", {
        /**
         * The coordinate corresponding to the original browser event.  This will be in the user
         * projection if one is set.  Otherwise it will be in the view projection.
         * @type {import("./coordinate.js").Coordinate}
         * @api
         */
        get: function () {
            if (!this.coordinate_) {
                this.coordinate_ = this.map.getCoordinateFromPixel(this.pixel);
            }
            return this.coordinate_;
        },
        set: function (coordinate) {
            this.coordinate_ = coordinate;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Prevents the default browser action.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.preventDefault.
     * @api
     */
    MapBrowserEvent.prototype.preventDefault = function () {
        _super.prototype.preventDefault.call(this);
        if ('preventDefault' in this.originalEvent) {
            /** @type {UIEvent} */ (this.originalEvent).preventDefault();
        }
    };
    /**
     * Prevents further propagation of the current event.
     * See https://developer.mozilla.org/en-US/docs/Web/API/event.stopPropagation.
     * @api
     */
    MapBrowserEvent.prototype.stopPropagation = function () {
        _super.prototype.stopPropagation.call(this);
        if ('stopPropagation' in this.originalEvent) {
            /** @type {UIEvent} */ (this.originalEvent).stopPropagation();
        }
    };
    return MapBrowserEvent;
}(_MapEvent_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MapBrowserEvent);
//# sourceMappingURL=MapBrowserEvent.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/MapEvent
 */

/**
 * @classdesc
 * Events emitted as map events are instances of this type.
 * See {@link module:ol/PluggableMap~PluggableMap} for which events trigger a map event.
 */
var MapEvent = /** @class */ (function (_super) {
    __extends(MapEvent, _super);
    /**
     * @param {string} type Event type.
     * @param {import("./PluggableMap.js").default} map Map.
     * @param {?import("./PluggableMap.js").FrameState} [opt_frameState] Frame state.
     */
    function MapEvent(type, map, opt_frameState) {
        var _this = _super.call(this, type) || this;
        /**
         * The map where the event occurred.
         * @type {import("./PluggableMap.js").default}
         * @api
         */
        _this.map = map;
        /**
         * The frame state at the time of the event.
         * @type {?import("./PluggableMap.js").FrameState}
         * @api
         */
        _this.frameState = opt_frameState !== undefined ? opt_frameState : null;
        return _this;
    }
    return MapEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MapEvent);
//# sourceMappingURL=MapEvent.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(175);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(178);
/* harmony import */ var _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(166);
/* harmony import */ var _events_Target_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(49);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54);
/**
 * @module ol/MapBrowserEventHandler
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








var MapBrowserEventHandler = /** @class */ (function (_super) {
    __extends(MapBrowserEventHandler, _super);
    /**
     * @param {import("./PluggableMap.js").default} map The map with the viewport to listen to events on.
     * @param {number} [moveTolerance] The minimal distance the pointer must travel to trigger a move.
     */
    function MapBrowserEventHandler(map, moveTolerance) {
        var _this = _super.call(this, map) || this;
        /**
         * This is the element that we will listen to the real events on.
         * @type {import("./PluggableMap.js").default}
         * @private
         */
        _this.map_ = map;
        /**
         * @type {any}
         * @private
         */
        _this.clickTimeoutId_;
        /**
         * Emulate dblclick and singleclick. Will be true when only one pointer is active.
         * @type {boolean}
         */
        _this.emulateClicks_ = false;
        /**
         * @type {boolean}
         * @private
         */
        _this.dragging_ = false;
        /**
         * @type {!Array<import("./events.js").EventsKey>}
         * @private
         */
        _this.dragListenerKeys_ = [];
        /**
         * @type {number}
         * @private
         */
        _this.moveTolerance_ = moveTolerance === undefined ? 1 : moveTolerance;
        /**
         * The most recent "down" type event (or null if none have occurred).
         * Set on pointerdown.
         * @type {PointerEvent}
         * @private
         */
        _this.down_ = null;
        var element = _this.map_.getViewport();
        /**
         * @type {number}
         * @private
         */
        _this.activePointers_ = 0;
        /**
         * @type {!Object<number, boolean>}
         * @private
         */
        _this.trackedTouches_ = {};
        _this.element_ = element;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */
        _this.pointerdownListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(element, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POINTERDOWN, _this.handlePointerDown_, _this);
        /**
         * @type {PointerEvent}
         * @private
         */
        _this.originalPointerMoveEvent_;
        /**
         * @type {?import("./events.js").EventsKey}
         * @private
         */
        _this.relayedListenerKey_ = Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(element, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POINTERMOVE, _this.relayEvent_, _this);
        /**
         * @private
         */
        _this.boundHandleTouchMove_ = _this.handleTouchMove_.bind(_this);
        _this.element_.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TOUCHMOVE, _this.boundHandleTouchMove_, _has_js__WEBPACK_IMPORTED_MODULE_5__["PASSIVE_EVENT_LISTENERS"] ? { passive: false } : false);
        return _this;
    }
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.emulateClick_ = function (pointerEvent) {
        var newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CLICK, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        if (this.clickTimeoutId_ !== undefined) {
            // double-click
            clearTimeout(this.clickTimeoutId_);
            this.clickTimeoutId_ = undefined;
            newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].DBLCLICK, this.map_, pointerEvent);
            this.dispatchEvent(newEvent);
        }
        else {
            // click
            this.clickTimeoutId_ = setTimeout(
            /** @this {MapBrowserEventHandler} */
            function () {
                this.clickTimeoutId_ = undefined;
                var newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].SINGLECLICK, this.map_, pointerEvent);
                this.dispatchEvent(newEvent);
            }.bind(this), 250);
        }
    };
    /**
     * Keeps track on how many pointers are currently active.
     *
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.updateActivePointers_ = function (pointerEvent) {
        var event = pointerEvent;
        if (event.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP ||
            event.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERCANCEL) {
            delete this.trackedTouches_[event.pointerId];
        }
        else if (event.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERDOWN) {
            this.trackedTouches_[event.pointerId] = true;
        }
        this.activePointers_ = Object.keys(this.trackedTouches_).length;
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.handlePointerUp_ = function (pointerEvent) {
        this.updateActivePointers_(pointerEvent);
        var newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        // We emulate click events on left mouse button click, touch contact, and pen
        // contact. isMouseActionButton returns true in these cases (evt.button is set
        // to 0).
        // See http://www.w3.org/TR/pointerevents/#button-states
        // We only fire click, singleclick, and doubleclick if nobody has called
        // event.preventDefault().
        if (this.emulateClicks_ &&
            !newEvent.defaultPrevented &&
            !this.dragging_ &&
            this.isMouseActionButton_(pointerEvent)) {
            this.emulateClick_(this.down_);
        }
        if (this.activePointers_ === 0) {
            this.dragListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"]);
            this.dragListenerKeys_.length = 0;
            this.dragging_ = false;
            this.down_ = null;
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} If the left mouse button was pressed.
     * @private
     */
    MapBrowserEventHandler.prototype.isMouseActionButton_ = function (pointerEvent) {
        return pointerEvent.button === 0;
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.handlePointerDown_ = function (pointerEvent) {
        this.emulateClicks_ = this.activePointers_ === 0;
        this.updateActivePointers_(pointerEvent);
        var newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERDOWN, this.map_, pointerEvent);
        this.dispatchEvent(newEvent);
        // Store a copy of the down event
        this.down_ = /** @type {PointerEvent} */ ({});
        for (var property in pointerEvent) {
            var value = pointerEvent[property];
            this.down_[property] = typeof value === 'function' ? _functions_js__WEBPACK_IMPORTED_MODULE_6__["VOID"] : value;
        }
        if (this.dragListenerKeys_.length === 0) {
            var doc = this.map_.getOwnerDocument();
            this.dragListenerKeys_.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(doc, _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERMOVE, this.handlePointerMove_, this), Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(doc, _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP, this.handlePointerUp_, this), 
            /* Note that the listener for `pointercancel is set up on
             * `pointerEventHandler_` and not `documentPointerEventHandler_` like
             * the `pointerup` and `pointermove` listeners.
             *
             * The reason for this is the following: `TouchSource.vacuumTouches_()`
             * issues `pointercancel` events, when there was no `touchend` for a
             * `touchstart`. Now, let's say a first `touchstart` is registered on
             * `pointerEventHandler_`. The `documentPointerEventHandler_` is set up.
             * But `documentPointerEventHandler_` doesn't know about the first
             * `touchstart`. If there is no `touchend` for the `touchstart`, we can
             * only receive a `touchcancel` from `pointerEventHandler_`, because it is
             * only registered there.
             */
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(this.element_, _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERCANCEL, this.handlePointerUp_, this));
            if (this.element_.getRootNode && this.element_.getRootNode() !== doc) {
                this.dragListenerKeys_.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["listen"])(this.element_.getRootNode(), _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP, this.handlePointerUp_, this));
            }
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.handlePointerMove_ = function (pointerEvent) {
        // Between pointerdown and pointerup, pointermove events are triggered.
        // To avoid a 'false' touchmove event to be dispatched, we test if the pointer
        // moved a significant distance.
        if (this.isMoving_(pointerEvent)) {
            this.dragging_ = true;
            var newEvent = new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERDRAG, this.map_, pointerEvent, this.dragging_);
            this.dispatchEvent(newEvent);
        }
    };
    /**
     * Wrap and relay a pointer event.  Note that this requires that the type
     * string for the MapBrowserEvent matches the PointerEvent type.
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @private
     */
    MapBrowserEventHandler.prototype.relayEvent_ = function (pointerEvent) {
        this.originalPointerMoveEvent_ = pointerEvent;
        var dragging = !!(this.down_ && this.isMoving_(pointerEvent));
        this.dispatchEvent(new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_1__["default"](pointerEvent.type, this.map_, pointerEvent, dragging));
    };
    /**
     * Flexible handling of a `touch-action: none` css equivalent: because calling
     * `preventDefault()` on a `pointermove` event does not stop native page scrolling
     * and zooming, we also listen for `touchmove` and call `preventDefault()` on it
     * when an interaction (currently `DragPan` handles the event.
     * @param {TouchEvent} event Event.
     * @private
     */
    MapBrowserEventHandler.prototype.handleTouchMove_ = function (event) {
        // Due to https://github.com/mpizenberg/elm-pep/issues/2, `this.originalPointerMoveEvent_`
        // may not be initialized yet when we get here on a platform without native pointer events.
        var originalEvent = this.originalPointerMoveEvent_;
        if ((!originalEvent || originalEvent.defaultPrevented) &&
            (typeof event.cancelable !== 'boolean' || event.cancelable === true)) {
            event.preventDefault();
        }
    };
    /**
     * @param {PointerEvent} pointerEvent Pointer
     * event.
     * @return {boolean} Is moving.
     * @private
     */
    MapBrowserEventHandler.prototype.isMoving_ = function (pointerEvent) {
        return (this.dragging_ ||
            Math.abs(pointerEvent.clientX - this.down_.clientX) >
                this.moveTolerance_ ||
            Math.abs(pointerEvent.clientY - this.down_.clientY) > this.moveTolerance_);
    };
    /**
     * Clean up.
     */
    MapBrowserEventHandler.prototype.disposeInternal = function () {
        if (this.relayedListenerKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(this.relayedListenerKey_);
            this.relayedListenerKey_ = null;
        }
        this.element_.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TOUCHMOVE, this.boundHandleTouchMove_);
        if (this.pointerdownListenerKey_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"])(this.pointerdownListenerKey_);
            this.pointerdownListenerKey_ = null;
        }
        this.dragListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_7__["unlistenByKey"]);
        this.dragListenerKeys_.length = 0;
        this.element_ = null;
        _super.prototype.disposeInternal.call(this);
    };
    return MapBrowserEventHandler;
}(_events_Target_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MapBrowserEventHandler);
//# sourceMappingURL=MapBrowserEventHandler.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/**
 * @module ol/MapBrowserEventType
 */

/**
 * Constants for event names.
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * A true single click with no dragging and no double click. Note that this
     * event is delayed by 250 ms to ensure that it is not a double click.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#singleclick
     * @api
     */
    SINGLECLICK: 'singleclick',
    /**
     * A click with no dragging. A double click will fire two of this.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#click
     * @api
     */
    CLICK: _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CLICK,
    /**
     * A true double click, with no dragging.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#dblclick
     * @api
     */
    DBLCLICK: _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].DBLCLICK,
    /**
     * Triggered when a pointer is dragged.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointerdrag
     * @api
     */
    POINTERDRAG: 'pointerdrag',
    /**
     * Triggered when a pointer is moved. Note that on touch devices this is
     * triggered when the map is panned, so is not the same as mousemove.
     * @event module:ol/MapBrowserEvent~MapBrowserEvent#pointermove
     * @api
     */
    POINTERMOVE: 'pointermove',
    POINTERDOWN: 'pointerdown',
    POINTERUP: 'pointerup',
    POINTEROVER: 'pointerover',
    POINTEROUT: 'pointerout',
    POINTERENTER: 'pointerenter',
    POINTERLEAVE: 'pointerleave',
    POINTERCANCEL: 'pointercancel',
});
/***
 * @typedef {'singleclick'|'click'|'dblclick'|'pointerdrag'|'pointermove'} Types
 */
//# sourceMappingURL=MapBrowserEventType.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCenterConstraint", function() { return createCenterConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createResolutionConstraint", function() { return createResolutionConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRotationConstraint", function() { return createRotationConstraint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNoopAnimation", function() { return isNoopAnimation; });
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(139);
/* harmony import */ var _ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(180);
/* harmony import */ var _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15);
/* harmony import */ var _centerconstraint_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(181);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(11);
/* harmony import */ var _resolutionconstraint_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(182);
/* harmony import */ var _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(183);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(75);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(184);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/View
 */






















/**
 * An animation configuration
 *
 * @typedef {Object} Animation
 * @property {import("./coordinate.js").Coordinate} [sourceCenter] Source center.
 * @property {import("./coordinate.js").Coordinate} [targetCenter] Target center.
 * @property {number} [sourceResolution] Source resolution.
 * @property {number} [targetResolution] Target resolution.
 * @property {number} [sourceRotation] Source rotation.
 * @property {number} [targetRotation] Target rotation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Anchor.
 * @property {number} start Start.
 * @property {number} duration Duration.
 * @property {boolean} complete Complete.
 * @property {function(number):number} easing Easing.
 * @property {function(boolean):void} callback Callback.
 */
/**
 * @typedef {Object} Constraints
 * @property {import("./centerconstraint.js").Type} center Center.
 * @property {import("./resolutionconstraint.js").Type} resolution Resolution.
 * @property {import("./rotationconstraint.js").Type} rotation Rotation.
 */
/**
 * @typedef {Object} FitOptions
 * @property {import("./size.js").Size} [size] The size in pixels of the box to fit
 * the extent into. Default is the current size of the first map in the DOM that
 * uses this view, or `[100, 100]` if no such map is found.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in pixels) to be
 * cleared inside the view. Values in the array are top, right, bottom and left
 * padding.
 * @property {boolean} [nearest=false] If the view `constrainResolution` option is `true`,
 * get the nearest extent instead of the closest that actually fits the view.
 * @property {number} [minResolution=0] Minimum resolution that we zoom to.
 * @property {number} [maxZoom] Maximum zoom level that we zoom to. If
 * `minResolution` is given, this property is ignored.
 * @property {number} [duration] The duration of the animation in milliseconds.
 * By default, there is no animation to the target extent.
 * @property {function(number):number} [easing] The easing function used during
 * the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 * @property {function(boolean):void} [callback] Function called when the view is in
 * its final position. The callback will be called with `true` if the animation
 * series completed on its own or `false` if it was cancelled.
 */
/**
 * @typedef {Object} ViewOptions
 * @property {import("./coordinate.js").Coordinate} [center] The initial center for
 * the view. If a user projection is not set, the coordinate system for the center is
 * specified with the `projection` option. Layer sources will not be fetched if this
 * is not set, but the center can be set later with {@link #setCenter}.
 * @property {boolean|number} [constrainRotation=true] Rotation constraint.
 * `false` means no constraint. `true` means no constraint, but snap to zero
 * near zero. A number constrains the rotation to that number of values. For
 * example, `4` will constrain the rotation to 0, 90, 180, and 270 degrees.
 * @property {boolean} [enableRotation=true] Enable rotation.
 * If `false`, a rotation constraint that always sets the rotation to zero is
 * used. The `constrainRotation` option has no effect if `enableRotation` is
 * `false`.
 * @property {import("./extent.js").Extent} [extent] The extent that constrains the
 * view, in other words, nothing outside of this extent can be visible on the map.
 * @property {boolean} [constrainOnlyCenter=false] If true, the extent
 * constraint will only apply to the view center and not the whole extent.
 * @property {boolean} [smoothExtentConstraint=true] If true, the extent
 * constraint will be applied smoothly, i.e. allow the view to go slightly outside
 * of the given `extent`.
 * @property {number} [maxResolution] The maximum resolution used to determine
 * the resolution constraint. It is used together with `minResolution` (or
 * `maxZoom`) and `zoomFactor`. If unspecified it is calculated in such a way
 * that the projection's validity extent fits in a 256x256 px tile. If the
 * projection is Spherical Mercator (the default) then `maxResolution` defaults
 * to `40075016.68557849 / 256 = 156543.03392804097`.
 * @property {number} [minResolution] The minimum resolution used to determine
 * the resolution constraint.  It is used together with `maxResolution` (or
 * `minZoom`) and `zoomFactor`.  If unspecified it is calculated assuming 29
 * zoom levels (with a factor of 2). If the projection is Spherical Mercator
 * (the default) then `minResolution` defaults to
 * `40075016.68557849 / 256 / Math.pow(2, 28) = 0.0005831682455839253`.
 * @property {number} [maxZoom=28] The maximum zoom level used to determine the
 * resolution constraint. It is used together with `minZoom` (or
 * `maxResolution`) and `zoomFactor`.  Note that if `minResolution` is also
 * provided, it is given precedence over `maxZoom`.
 * @property {number} [minZoom=0] The minimum zoom level used to determine the
 * resolution constraint. It is used together with `maxZoom` (or
 * `minResolution`) and `zoomFactor`.  Note that if `maxResolution` is also
 * provided, it is given precedence over `minZoom`.
 * @property {boolean} [multiWorld=false] If `false` the view is constrained so
 * only one world is visible, and you cannot pan off the edge.  If `true` the map
 * may show multiple worlds at low zoom levels.  Only used if the `projection` is
 * global.  Note that if `extent` is also provided it is given precedence.
 * @property {boolean} [constrainResolution=false] If true, the view will always
 * animate to the closest zoom level after an interaction; false means
 * intermediary zoom levels are allowed.
 * @property {boolean} [smoothResolutionConstraint=true] If true, the resolution
 * min/max values will be applied smoothly, i. e. allow the view to exceed slightly
 * the given resolution or zoom bounds.
 * @property {boolean} [showFullExtent=false] Allow the view to be zoomed out to
 * show the full configured extent. By default, when a view is configured with an
 * extent, users will not be able to zoom out so the viewport exceeds the extent in
 * either dimension. This means the full extent may not be visible if the viewport
 * is taller or wider than the aspect ratio of the configured extent. If
 * showFullExtent is true, the user will be able to zoom out so that the viewport
 * exceeds the height or width of the configured extent, but not both, allowing the
 * full extent to be shown.
 * @property {import("./proj.js").ProjectionLike} [projection='EPSG:3857'] The
 * projection. The default is Spherical Mercator.
 * @property {number} [resolution] The initial resolution for the view. The
 * units are `projection` units per pixel (e.g. meters per pixel). An
 * alternative to setting this is to set `zoom`. Layer sources will not be
 * fetched if neither this nor `zoom` are defined, but they can be set later
 * with {@link #setZoom} or {@link #setResolution}.
 * @property {Array<number>} [resolutions] Resolutions that determine the
 * zoom levels if specified. The index in the array corresponds to the zoom level,
 * therefore the resolution values have to be in descending order. It also constrains
 * the resolution by the minimum and maximum value. If set the `maxResolution`,
 * `minResolution`, `minZoom`, `maxZoom`, and `zoomFactor` options are ignored.
 * @property {number} [rotation=0] The initial rotation for the view in radians
 * (positive rotation clockwise, 0 means North).
 * @property {number} [zoom] Only used if `resolution` is not defined. Zoom
 * level used to calculate the initial resolution for the view.
 * @property {number} [zoomFactor=2] The zoom factor used to compute the
 * corresponding resolution.
 * @property {!Array<number>} [padding=[0, 0, 0, 0]] Padding (in css pixels).
 * If the map viewport is partially covered with other content (overlays) along
 * its edges, this setting allows to shift the center of the viewport away from
 * that content. The order of the values is top, right, bottom, left.
 */
/**
 * @typedef {Object} AnimationOptions
 * @property {import("./coordinate.js").Coordinate} [center] The center of the view at the end of
 * the animation.
 * @property {number} [zoom] The zoom level of the view at the end of the
 * animation. This takes precedence over `resolution`.
 * @property {number} [resolution] The resolution of the view at the end
 * of the animation.  If `zoom` is also provided, this option will be ignored.
 * @property {number} [rotation] The rotation of the view at the end of
 * the animation.
 * @property {import("./coordinate.js").Coordinate} [anchor] Optional anchor to remain fixed
 * during a rotation or resolution animation.
 * @property {number} [duration=1000] The duration of the animation in milliseconds.
 * @property {function(number):number} [easing] The easing function used
 * during the animation (defaults to {@link module:ol/easing.inAndOut}).
 * The function will be called for each frame with a number representing a
 * fraction of the animation's duration.  The function should return a number
 * between 0 and 1 representing the progress toward the destination state.
 */
/**
 * @typedef {Object} State
 * @property {import("./coordinate.js").Coordinate} center Center.
 * @property {import("./proj/Projection.js").default} projection Projection.
 * @property {number} resolution Resolution.
 * @property {number} rotation Rotation.
 * @property {number} zoom Zoom.
 */
/**
 * Default min zoom level for the map view.
 * @type {number}
 */
var DEFAULT_MIN_ZOOM = 0;
/**
 * @typedef {import("./ObjectEventType").Types|'change:center'|'change:resolution'|'change:rotation'} ViewObjectEventTypes
 */
/***
 * @template Return
 * @typedef {import("./Observable").OnSignature<import("./Observable").EventTypes, import("./events/Event.js").default, Return> &
 *   import("./Observable").OnSignature<ViewObjectEventTypes, import("./Object").ObjectEvent, Return> &
 *   import("./Observable").CombinedOnSignature<import("./Observable").EventTypes|ViewObjectEventTypes, Return>} ViewOnSignature
 */
/**
 * @classdesc
 * A View object represents a simple 2D view of the map.
 *
 * This is the object to act upon to change the center, resolution,
 * and rotation of the map.
 *
 * A View has a `projection`. The projection determines the
 * coordinate system of the center, and its units determine the units of the
 * resolution (projection units per pixel). The default projection is
 * Spherical Mercator (EPSG:3857).
 *
 * ### The view states
 *
 * A View is determined by three states: `center`, `resolution`,
 * and `rotation`. Each state has a corresponding getter and setter, e.g.
 * `getCenter` and `setCenter` for the `center` state.
 *
 * The `zoom` state is actually not saved on the view: all computations
 * internally use the `resolution` state. Still, the `setZoom` and `getZoom`
 * methods are available, as well as `getResolutionForZoom` and
 * `getZoomForResolution` to switch from one system to the other.
 *
 * ### The constraints
 *
 * `setCenter`, `setResolution` and `setRotation` can be used to change the
 * states of the view, but any constraint defined in the constructor will
 * be applied along the way.
 *
 * A View object can have a *resolution constraint*, a *rotation constraint*
 * and a *center constraint*.
 *
 * The *resolution constraint* typically restricts min/max values and
 * snaps to specific resolutions. It is determined by the following
 * options: `resolutions`, `maxResolution`, `maxZoom` and `zoomFactor`.
 * If `resolutions` is set, the other three options are ignored. See
 * documentation for each option for more information. By default, the view
 * only has a min/max restriction and allow intermediary zoom levels when
 * pinch-zooming for example.
 *
 * The *rotation constraint* snaps to specific angles. It is determined
 * by the following options: `enableRotation` and `constrainRotation`.
 * By default rotation is allowed and its value is snapped to zero when approaching the
 * horizontal.
 *
 * The *center constraint* is determined by the `extent` option. By
 * default the view center is not constrained at all.
 *
 * ### Changing the view state
 *
 * It is important to note that `setZoom`, `setResolution`, `setCenter` and
 * `setRotation` are subject to the above mentioned constraints. As such, it
 * may sometimes not be possible to know in advance the resulting state of the
 * View. For example, calling `setResolution(10)` does not guarantee that
 * `getResolution()` will return `10`.
 *
 * A consequence of this is that, when applying a delta on the view state, one
 * should use `adjustCenter`, `adjustRotation`, `adjustZoom` and `adjustResolution`
 * rather than the corresponding setters. This will let view do its internal
 * computations. Besides, the `adjust*` methods also take an `opt_anchor`
 * argument which allows specifying an origin for the transformation.
 *
 * ### Interacting with the view
 *
 * View constraints are usually only applied when the view is *at rest*, meaning that
 * no interaction or animation is ongoing. As such, if the user puts the view in a
 * state that is not equivalent to a constrained one (e.g. rotating the view when
 * the snap angle is 0), an animation will be triggered at the interaction end to
 * put back the view to a stable state;
 *
 * @api
 */
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    /**
     * @param {ViewOptions} [opt_options] View options.
     */
    function View(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {ViewOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ViewOnSignature<import("./Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ViewOnSignature<void>}
         */
        _this.un;
        var options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])({}, opt_options);
        /**
         * @private
         * @type {Array<number>}
         */
        _this.hints_ = [0, 0];
        /**
         * @private
         * @type {Array<Array<Animation>>}
         */
        _this.animations_ = [];
        /**
         * @private
         * @type {number|undefined}
         */
        _this.updateAnimationKey_;
        /**
         * @private
         * @const
         * @type {import("./proj/Projection.js").default}
         */
        _this.projection_ = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["createProjection"])(options.projection, 'EPSG:3857');
        /**
         * @private
         * @type {import("./size.js").Size}
         */
        _this.viewportSize_ = [100, 100];
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */
        _this.targetCenter_ = null;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.targetResolution_;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.targetRotation_;
        /**
         * @private
         * @type {import("./coordinate.js").Coordinate|undefined}
         */
        _this.cancelAnchor_ = undefined;
        if (options.center) {
            options.center = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(options.center, _this.projection_);
        }
        if (options.extent) {
            options.extent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(options.extent, _this.projection_);
        }
        _this.applyOptions_(options);
        return _this;
    }
    /**
     * Set up the view with the given options.
     * @param {ViewOptions} options View options.
     */
    View.prototype.applyOptions_ = function (options) {
        /**
         * @type {Object<string, *>}
         */
        var properties = {};
        var resolutionConstraintInfo = createResolutionConstraint(options);
        /**
         * @private
         * @type {number}
         */
        this.maxResolution_ = resolutionConstraintInfo.maxResolution;
        /**
         * @private
         * @type {number}
         */
        this.minResolution_ = resolutionConstraintInfo.minResolution;
        /**
         * @private
         * @type {number}
         */
        this.zoomFactor_ = resolutionConstraintInfo.zoomFactor;
        /**
         * @private
         * @type {Array<number>|undefined}
         */
        this.resolutions_ = options.resolutions;
        /**
         * @type {Array<number>|undefined}
         * @private
         */
        this.padding_ = options.padding;
        /**
         * @private
         * @type {number}
         */
        this.minZoom_ = resolutionConstraintInfo.minZoom;
        var centerConstraint = createCenterConstraint(options);
        var resolutionConstraint = resolutionConstraintInfo.constraint;
        var rotationConstraint = createRotationConstraint(options);
        /**
         * @private
         * @type {Constraints}
         */
        this.constraints_ = {
            center: centerConstraint,
            resolution: resolutionConstraint,
            rotation: rotationConstraint,
        };
        this.setRotation(options.rotation !== undefined ? options.rotation : 0);
        this.setCenterInternal(options.center !== undefined ? options.center : null);
        if (options.resolution !== undefined) {
            this.setResolution(options.resolution);
        }
        else if (options.zoom !== undefined) {
            this.setZoom(options.zoom);
        }
        this.setProperties(properties);
        /**
         * @private
         * @type {ViewOptions}
         */
        this.options_ = options;
    };
    Object.defineProperty(View.prototype, "padding", {
        /**
         * Padding (in css pixels).
         * If the map viewport is partially covered with other content (overlays) along
         * its edges, this setting allows to shift the center of the viewport away from that
         * content. The order of the values in the array is top, right, bottom, left.
         * The default is no padding, which is equivalent to `[0, 0, 0, 0]`.
         * @type {Array<number>|undefined}
         * @api
         */
        get: function () {
            return this.padding_;
        },
        set: function (padding) {
            var oldPadding = this.padding_;
            this.padding_ = padding;
            var center = this.getCenter();
            if (center) {
                var newPadding = padding || [0, 0, 0, 0];
                oldPadding = oldPadding || [0, 0, 0, 0];
                var resolution = this.getResolution();
                var offsetX = (resolution / 2) *
                    (newPadding[3] - oldPadding[3] + oldPadding[1] - newPadding[1]);
                var offsetY = (resolution / 2) *
                    (newPadding[0] - oldPadding[0] + oldPadding[2] - newPadding[2]);
                this.setCenterInternal([center[0] + offsetX, center[1] - offsetY]);
            }
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Get an updated version of the view options used to construct the view.  The
     * current resolution (or zoom), center, and rotation are applied to any stored
     * options.  The provided options can be used to apply new min/max zoom or
     * resolution limits.
     * @param {ViewOptions} newOptions New options to be applied.
     * @return {ViewOptions} New options updated with the current view state.
     */
    View.prototype.getUpdatedOptions_ = function (newOptions) {
        var options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])({}, this.options_);
        // preserve resolution (or zoom)
        if (options.resolution !== undefined) {
            options.resolution = this.getResolution();
        }
        else {
            options.zoom = this.getZoom();
        }
        // preserve center
        options.center = this.getCenterInternal();
        // preserve rotation
        options.rotation = this.getRotation();
        return Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])({}, options, newOptions);
    };
    /**
     * Animate the view.  The view's center, zoom (or resolution), and rotation
     * can be animated for smooth transitions between view states.  For example,
     * to animate the view to a new zoom level:
     *
     *     view.animate({zoom: view.getZoom() + 1});
     *
     * By default, the animation lasts one second and uses in-and-out easing.  You
     * can customize this behavior by including `duration` (in milliseconds) and
     * `easing` options (see {@link module:ol/easing}).
     *
     * To chain together multiple animations, call the method with multiple
     * animation objects.  For example, to first zoom and then pan:
     *
     *     view.animate({zoom: 10}, {center: [0, 0]});
     *
     * If you provide a function as the last argument to the animate method, it
     * will get called at the end of an animation series.  The callback will be
     * called with `true` if the animation series completed on its own or `false`
     * if it was cancelled.
     *
     * Animations are cancelled by user interactions (e.g. dragging the map) or by
     * calling `view.setCenter()`, `view.setResolution()`, or `view.setRotation()`
     * (or another method that calls one of these).
     *
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation
     *     options.  Multiple animations can be run in series by passing multiple
     *     options objects.  To run multiple animations in parallel, call the method
     *     multiple times.  An optional callback can be provided as a final
     *     argument.  The callback will be called with a boolean indicating whether
     *     the animation completed without being cancelled.
     * @api
     */
    View.prototype.animate = function (var_args) {
        if (this.isDef() && !this.getAnimating()) {
            this.resolveConstraints(0);
        }
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i) {
            var options = arguments[i];
            if (options.center) {
                options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])({}, options);
                options.center = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(options.center, this.getProjection());
            }
            if (options.anchor) {
                options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])({}, options);
                options.anchor = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(options.anchor, this.getProjection());
            }
            args[i] = options;
        }
        this.animateInternal.apply(this, args);
    };
    /**
     * @param {...(AnimationOptions|function(boolean): void)} var_args Animation options.
     */
    View.prototype.animateInternal = function (var_args) {
        var animationCount = arguments.length;
        var callback;
        if (animationCount > 1 &&
            typeof arguments[animationCount - 1] === 'function') {
            callback = arguments[animationCount - 1];
            --animationCount;
        }
        if (!this.isDef()) {
            // if view properties are not yet set, shortcut to the final state
            var state = arguments[animationCount - 1];
            if (state.center) {
                this.setCenterInternal(state.center);
            }
            if (state.zoom !== undefined) {
                this.setZoom(state.zoom);
            }
            if (state.rotation !== undefined) {
                this.setRotation(state.rotation);
            }
            if (callback) {
                animationCallback(callback, true);
            }
            return;
        }
        var start = Date.now();
        var center = this.targetCenter_.slice();
        var resolution = this.targetResolution_;
        var rotation = this.targetRotation_;
        var series = [];
        for (var i = 0; i < animationCount; ++i) {
            var options = /** @type {AnimationOptions} */ (arguments[i]);
            var animation = {
                start: start,
                complete: false,
                anchor: options.anchor,
                duration: options.duration !== undefined ? options.duration : 1000,
                easing: options.easing || _easing_js__WEBPACK_IMPORTED_MODULE_15__["inAndOut"],
                callback: callback,
            };
            if (options.center) {
                animation.sourceCenter = center;
                animation.targetCenter = options.center.slice();
                center = animation.targetCenter;
            }
            if (options.zoom !== undefined) {
                animation.sourceResolution = resolution;
                animation.targetResolution = this.getResolutionForZoom(options.zoom);
                resolution = animation.targetResolution;
            }
            else if (options.resolution) {
                animation.sourceResolution = resolution;
                animation.targetResolution = options.resolution;
                resolution = animation.targetResolution;
            }
            if (options.rotation !== undefined) {
                animation.sourceRotation = rotation;
                var delta = Object(_math_js__WEBPACK_IMPORTED_MODULE_12__["modulo"])(options.rotation - rotation + Math.PI, 2 * Math.PI) - Math.PI;
                animation.targetRotation = rotation + delta;
                rotation = animation.targetRotation;
            }
            // check if animation is a no-op
            if (isNoopAnimation(animation)) {
                animation.complete = true;
                // we still push it onto the series for callback handling
            }
            else {
                start += animation.duration;
            }
            series.push(animation);
        }
        this.animations_.push(series);
        this.setHint(_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING, 1);
        this.updateAnimations_();
    };
    /**
     * Determine if the view is being animated.
     * @return {boolean} The view is being animated.
     * @api
     */
    View.prototype.getAnimating = function () {
        return this.hints_[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING] > 0;
    };
    /**
     * Determine if the user is interacting with the view, such as panning or zooming.
     * @return {boolean} The view is being interacted with.
     * @api
     */
    View.prototype.getInteracting = function () {
        return this.hints_[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING] > 0;
    };
    /**
     * Cancel any ongoing animations.
     * @api
     */
    View.prototype.cancelAnimations = function () {
        this.setHint(_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING, -this.hints_[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING]);
        var anchor;
        for (var i = 0, ii = this.animations_.length; i < ii; ++i) {
            var series = this.animations_[i];
            if (series[0].callback) {
                animationCallback(series[0].callback, false);
            }
            if (!anchor) {
                for (var j = 0, jj = series.length; j < jj; ++j) {
                    var animation = series[j];
                    if (!animation.complete) {
                        anchor = animation.anchor;
                        break;
                    }
                }
            }
        }
        this.animations_.length = 0;
        this.cancelAnchor_ = anchor;
    };
    /**
     * Update all animations.
     */
    View.prototype.updateAnimations_ = function () {
        if (this.updateAnimationKey_ !== undefined) {
            cancelAnimationFrame(this.updateAnimationKey_);
            this.updateAnimationKey_ = undefined;
        }
        if (!this.getAnimating()) {
            return;
        }
        var now = Date.now();
        var more = false;
        for (var i = this.animations_.length - 1; i >= 0; --i) {
            var series = this.animations_[i];
            var seriesComplete = true;
            for (var j = 0, jj = series.length; j < jj; ++j) {
                var animation = series[j];
                if (animation.complete) {
                    continue;
                }
                var elapsed = now - animation.start;
                var fraction = animation.duration > 0 ? elapsed / animation.duration : 1;
                if (fraction >= 1) {
                    animation.complete = true;
                    fraction = 1;
                }
                else {
                    seriesComplete = false;
                }
                var progress = animation.easing(fraction);
                if (animation.sourceCenter) {
                    var x0 = animation.sourceCenter[0];
                    var y0 = animation.sourceCenter[1];
                    var x1 = animation.targetCenter[0];
                    var y1 = animation.targetCenter[1];
                    var x = x0 + progress * (x1 - x0);
                    var y = y0 + progress * (y1 - y0);
                    this.targetCenter_ = [x, y];
                }
                if (animation.sourceResolution && animation.targetResolution) {
                    var resolution = progress === 1
                        ? animation.targetResolution
                        : animation.sourceResolution +
                            progress *
                                (animation.targetResolution - animation.sourceResolution);
                    if (animation.anchor) {
                        var size = this.getViewportSize_(this.getRotation());
                        var constrainedResolution = this.constraints_.resolution(resolution, 0, size, true);
                        this.targetCenter_ = this.calculateCenterZoom(constrainedResolution, animation.anchor);
                    }
                    this.targetResolution_ = resolution;
                    this.applyTargetState_(true);
                }
                if (animation.sourceRotation !== undefined &&
                    animation.targetRotation !== undefined) {
                    var rotation = progress === 1
                        ? Object(_math_js__WEBPACK_IMPORTED_MODULE_12__["modulo"])(animation.targetRotation + Math.PI, 2 * Math.PI) -
                            Math.PI
                        : animation.sourceRotation +
                            progress *
                                (animation.targetRotation - animation.sourceRotation);
                    if (animation.anchor) {
                        var constrainedRotation = this.constraints_.rotation(rotation, true);
                        this.targetCenter_ = this.calculateCenterRotate(constrainedRotation, animation.anchor);
                    }
                    this.targetRotation_ = rotation;
                }
                this.applyTargetState_(true);
                more = true;
                if (!animation.complete) {
                    break;
                }
            }
            if (seriesComplete) {
                this.animations_[i] = null;
                this.setHint(_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING, -1);
                var callback = series[0].callback;
                if (callback) {
                    animationCallback(callback, true);
                }
            }
        }
        // prune completed series
        this.animations_ = this.animations_.filter(Boolean);
        if (more && this.updateAnimationKey_ === undefined) {
            this.updateAnimationKey_ = requestAnimationFrame(this.updateAnimations_.bind(this));
        }
    };
    /**
     * @param {number} rotation Target rotation.
     * @param {import("./coordinate.js").Coordinate} anchor Rotation anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for rotation and anchor.
     */
    View.prototype.calculateCenterRotate = function (rotation, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        if (currentCenter !== undefined) {
            center = [currentCenter[0] - anchor[0], currentCenter[1] - anchor[1]];
            Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["rotate"])(center, rotation - this.getRotation());
            Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["add"])(center, anchor);
        }
        return center;
    };
    /**
     * @param {number} resolution Target resolution.
     * @param {import("./coordinate.js").Coordinate} anchor Zoom anchor.
     * @return {import("./coordinate.js").Coordinate|undefined} Center for resolution and anchor.
     */
    View.prototype.calculateCenterZoom = function (resolution, anchor) {
        var center;
        var currentCenter = this.getCenterInternal();
        var currentResolution = this.getResolution();
        if (currentCenter !== undefined && currentResolution !== undefined) {
            var x = anchor[0] -
                (resolution * (anchor[0] - currentCenter[0])) / currentResolution;
            var y = anchor[1] -
                (resolution * (anchor[1] - currentCenter[1])) / currentResolution;
            center = [x, y];
        }
        return center;
    };
    /**
     * Returns the current viewport size.
     * @private
     * @param {number} [opt_rotation] Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size or `[100, 100]` when no viewport is found.
     */
    View.prototype.getViewportSize_ = function (opt_rotation) {
        var size = this.viewportSize_;
        if (opt_rotation) {
            var w = size[0];
            var h = size[1];
            return [
                Math.abs(w * Math.cos(opt_rotation)) +
                    Math.abs(h * Math.sin(opt_rotation)),
                Math.abs(w * Math.sin(opt_rotation)) +
                    Math.abs(h * Math.cos(opt_rotation)),
            ];
        }
        else {
            return size;
        }
    };
    /**
     * Stores the viewport size on the view. The viewport size is not read every time from the DOM
     * to avoid performance hit and layout reflow.
     * This should be done on map size change.
     * Note: the constraints are not resolved during an animation to avoid stopping it
     * @param {import("./size.js").Size} [opt_size] Viewport size; if undefined, [100, 100] is assumed
     */
    View.prototype.setViewportSize = function (opt_size) {
        this.viewportSize_ = Array.isArray(opt_size)
            ? opt_size.slice()
            : [100, 100];
        if (!this.getAnimating()) {
            this.resolveConstraints(0);
        }
    };
    /**
     * Get the view center.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     * @observable
     * @api
     */
    View.prototype.getCenter = function () {
        var center = this.getCenterInternal();
        if (!center) {
            return center;
        }
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["toUserCoordinate"])(center, this.getProjection());
    };
    /**
     * Get the view center without transforming to user projection.
     * @return {import("./coordinate.js").Coordinate|undefined} The center of the view.
     */
    View.prototype.getCenterInternal = function () {
        return /** @type {import("./coordinate.js").Coordinate|undefined} */ (this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].CENTER));
    };
    /**
     * @return {Constraints} Constraints.
     */
    View.prototype.getConstraints = function () {
        return this.constraints_;
    };
    /**
     * @return {boolean} Resolution constraint is set
     */
    View.prototype.getConstrainResolution = function () {
        return this.options_.constrainResolution;
    };
    /**
     * @param {Array<number>} [opt_hints] Destination array.
     * @return {Array<number>} Hint.
     */
    View.prototype.getHints = function (opt_hints) {
        if (opt_hints !== undefined) {
            opt_hints[0] = this.hints_[0];
            opt_hints[1] = this.hints_[1];
            return opt_hints;
        }
        else {
            return this.hints_.slice();
        }
    };
    /**
     * Calculate the extent for the current view state and the passed size.
     * The size is the pixel dimensions of the box into which the calculated extent
     * should fit. In most cases you want to get the extent of the entire map,
     * that is `map.getSize()`.
     * @param {import("./size.js").Size} [opt_size] Box pixel size. If not provided, the size
     * of the map that uses this view will be used.
     * @return {import("./extent.js").Extent} Extent.
     * @api
     */
    View.prototype.calculateExtent = function (opt_size) {
        var extent = this.calculateExtentInternal(opt_size);
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["toUserExtent"])(extent, this.getProjection());
    };
    /**
     * @param {import("./size.js").Size} [opt_size] Box pixel size. If not provided,
     * the map's last known viewport size will be used.
     * @return {import("./extent.js").Extent} Extent.
     */
    View.prototype.calculateExtentInternal = function (opt_size) {
        var size = opt_size || this.getViewportSizeMinusPadding_();
        var center = /** @type {!import("./coordinate.js").Coordinate} */ (this.getCenterInternal());
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_9__["assert"])(center, 1); // The view center is not defined
        var resolution = /** @type {!number} */ (this.getResolution());
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_9__["assert"])(resolution !== undefined, 2); // The view resolution is not defined
        var rotation = /** @type {!number} */ (this.getRotation());
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_9__["assert"])(rotation !== undefined, 3); // The view rotation is not defined
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getForViewAndSize"])(center, resolution, rotation, size);
    };
    /**
     * Get the maximum resolution of the view.
     * @return {number} The maximum resolution of the view.
     * @api
     */
    View.prototype.getMaxResolution = function () {
        return this.maxResolution_;
    };
    /**
     * Get the minimum resolution of the view.
     * @return {number} The minimum resolution of the view.
     * @api
     */
    View.prototype.getMinResolution = function () {
        return this.minResolution_;
    };
    /**
     * Get the maximum zoom level for the view.
     * @return {number} The maximum zoom level.
     * @api
     */
    View.prototype.getMaxZoom = function () {
        return /** @type {number} */ (this.getZoomForResolution(this.minResolution_));
    };
    /**
     * Set a new maximum zoom level for the view.
     * @param {number} zoom The maximum zoom level.
     * @api
     */
    View.prototype.setMaxZoom = function (zoom) {
        this.applyOptions_(this.getUpdatedOptions_({ maxZoom: zoom }));
    };
    /**
     * Get the minimum zoom level for the view.
     * @return {number} The minimum zoom level.
     * @api
     */
    View.prototype.getMinZoom = function () {
        return /** @type {number} */ (this.getZoomForResolution(this.maxResolution_));
    };
    /**
     * Set a new minimum zoom level for the view.
     * @param {number} zoom The minimum zoom level.
     * @api
     */
    View.prototype.setMinZoom = function (zoom) {
        this.applyOptions_(this.getUpdatedOptions_({ minZoom: zoom }));
    };
    /**
     * Set whether the view should allow intermediary zoom levels.
     * @param {boolean} enabled Whether the resolution is constrained.
     * @api
     */
    View.prototype.setConstrainResolution = function (enabled) {
        this.applyOptions_(this.getUpdatedOptions_({ constrainResolution: enabled }));
    };
    /**
     * Get the view projection.
     * @return {import("./proj/Projection.js").default} The projection of the view.
     * @api
     */
    View.prototype.getProjection = function () {
        return this.projection_;
    };
    /**
     * Get the view resolution.
     * @return {number|undefined} The resolution of the view.
     * @observable
     * @api
     */
    View.prototype.getResolution = function () {
        return /** @type {number|undefined} */ (this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].RESOLUTION));
    };
    /**
     * Get the resolutions for the view. This returns the array of resolutions
     * passed to the constructor of the View, or undefined if none were given.
     * @return {Array<number>|undefined} The resolutions of the view.
     * @api
     */
    View.prototype.getResolutions = function () {
        return this.resolutions_;
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size} [opt_size] Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     * @api
     */
    View.prototype.getResolutionForExtent = function (extent, opt_size) {
        return this.getResolutionForExtentInternal(Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(extent, this.getProjection()), opt_size);
    };
    /**
     * Get the resolution for a provided extent (in map units) and size (in pixels).
     * @param {import("./extent.js").Extent} extent Extent.
     * @param {import("./size.js").Size} [opt_size] Box pixel size.
     * @return {number} The resolution at which the provided extent will render at
     *     the given size.
     */
    View.prototype.getResolutionForExtentInternal = function (extent, opt_size) {
        var size = opt_size || this.getViewportSizeMinusPadding_();
        var xResolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getWidth"])(extent) / size[0];
        var yResolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getHeight"])(extent) / size[1];
        return Math.max(xResolution, yResolution);
    };
    /**
     * Return a function that returns a value between 0 and 1 for a
     * resolution. Exponential scaling is assumed.
     * @param {number} [opt_power] Power.
     * @return {function(number): number} Resolution for value function.
     */
    View.prototype.getResolutionForValueFunction = function (opt_power) {
        var power = opt_power || 2;
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / Math.log(power);
        return (
        /**
         * @param {number} value Value.
         * @return {number} Resolution.
         */
        function (value) {
            var resolution = maxResolution / Math.pow(power, value * max);
            return resolution;
        });
    };
    /**
     * Get the view rotation.
     * @return {number} The rotation of the view in radians.
     * @observable
     * @api
     */
    View.prototype.getRotation = function () {
        return /** @type {number} */ (this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].ROTATION));
    };
    /**
     * Return a function that returns a resolution for a value between
     * 0 and 1. Exponential scaling is assumed.
     * @param {number} [opt_power] Power.
     * @return {function(number): number} Value for resolution function.
     */
    View.prototype.getValueForResolutionFunction = function (opt_power) {
        var logPower = Math.log(opt_power || 2);
        var maxResolution = this.getConstrainedResolution(this.maxResolution_);
        var minResolution = this.minResolution_;
        var max = Math.log(maxResolution / minResolution) / logPower;
        return (
        /**
         * @param {number} resolution Resolution.
         * @return {number} Value.
         */
        function (resolution) {
            var value = Math.log(maxResolution / resolution) / logPower / max;
            return value;
        });
    };
    /**
     * Returns the size of the viewport minus padding.
     * @private
     * @param {number} [opt_rotation] Take into account the rotation of the viewport when giving the size
     * @return {import("./size.js").Size} Viewport size reduced by the padding.
     */
    View.prototype.getViewportSizeMinusPadding_ = function (opt_rotation) {
        var size = this.getViewportSize_(opt_rotation);
        var padding = this.padding_;
        if (padding) {
            size = [
                size[0] - padding[1] - padding[3],
                size[1] - padding[0] - padding[2],
            ];
        }
        return size;
    };
    /**
     * @return {State} View state.
     */
    View.prototype.getState = function () {
        var projection = this.getProjection();
        var resolution = /** @type {number} */ (this.getResolution());
        var rotation = this.getRotation();
        var center = /** @type {import("./coordinate.js").Coordinate} */ (this.getCenterInternal());
        var padding = this.padding_;
        if (padding) {
            var reducedSize = this.getViewportSizeMinusPadding_();
            center = calculateCenterOn(center, this.getViewportSize_(), [reducedSize[0] / 2 + padding[3], reducedSize[1] / 2 + padding[0]], resolution, rotation);
        }
        return {
            center: center.slice(0),
            projection: projection !== undefined ? projection : null,
            resolution: resolution,
            rotation: rotation,
            zoom: this.getZoom(),
        };
    };
    /**
     * Get the current zoom level. This method may return non-integer zoom levels
     * if the view does not constrain the resolution, or if an interaction or
     * animation is underway.
     * @return {number|undefined} Zoom.
     * @api
     */
    View.prototype.getZoom = function () {
        var zoom;
        var resolution = this.getResolution();
        if (resolution !== undefined) {
            zoom = this.getZoomForResolution(resolution);
        }
        return zoom;
    };
    /**
     * Get the zoom level for a resolution.
     * @param {number} resolution The resolution.
     * @return {number|undefined} The zoom level for the provided resolution.
     * @api
     */
    View.prototype.getZoomForResolution = function (resolution) {
        var offset = this.minZoom_ || 0;
        var max, zoomFactor;
        if (this.resolutions_) {
            var nearest = Object(_array_js__WEBPACK_IMPORTED_MODULE_17__["linearFindNearest"])(this.resolutions_, resolution, 1);
            offset = nearest;
            max = this.resolutions_[nearest];
            if (nearest == this.resolutions_.length - 1) {
                zoomFactor = 2;
            }
            else {
                zoomFactor = max / this.resolutions_[nearest + 1];
            }
        }
        else {
            max = this.maxResolution_;
            zoomFactor = this.zoomFactor_;
        }
        return offset + Math.log(max / resolution) / Math.log(zoomFactor);
    };
    /**
     * Get the resolution for a zoom level.
     * @param {number} zoom Zoom level.
     * @return {number} The view resolution for the provided zoom level.
     * @api
     */
    View.prototype.getResolutionForZoom = function (zoom) {
        if (this.resolutions_) {
            if (this.resolutions_.length <= 1) {
                return 0;
            }
            var baseLevel = Object(_math_js__WEBPACK_IMPORTED_MODULE_12__["clamp"])(Math.floor(zoom), 0, this.resolutions_.length - 2);
            var zoomFactor = this.resolutions_[baseLevel] / this.resolutions_[baseLevel + 1];
            return (this.resolutions_[baseLevel] /
                Math.pow(zoomFactor, Object(_math_js__WEBPACK_IMPORTED_MODULE_12__["clamp"])(zoom - baseLevel, 0, 1)));
        }
        else {
            return (this.maxResolution_ / Math.pow(this.zoomFactor_, zoom - this.minZoom_));
        }
    };
    /**
     * Fit the given geometry or extent based on the given map size and border.
     * The size is pixel dimensions of the box to fit the extent into.
     * In most cases you will want to use the map size, that is `map.getSize()`.
     * Takes care of the map angle.
     * @param {import("./geom/SimpleGeometry.js").default|import("./extent.js").Extent} geometryOrExtent The geometry or
     *     extent to fit the view to.
     * @param {FitOptions} [opt_options] Options.
     * @api
     */
    View.prototype.fit = function (geometryOrExtent, opt_options) {
        /** @type {import("./geom/SimpleGeometry.js").default} */
        var geometry;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_9__["assert"])(Array.isArray(geometryOrExtent) ||
            typeof ( /** @type {?} */(geometryOrExtent).getSimplifiedGeometry) ===
                'function', 24); // Invalid extent or geometry provided as `geometry`
        if (Array.isArray(geometryOrExtent)) {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_9__["assert"])(!Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["isEmpty"])(geometryOrExtent), 25); // Cannot fit empty extent provided as `geometry`
            var extent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(geometryOrExtent, this.getProjection());
            geometry = Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__["fromExtent"])(extent);
        }
        else if (geometryOrExtent.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CIRCLE) {
            var extent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserExtent"])(geometryOrExtent.getExtent(), this.getProjection());
            geometry = Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__["fromExtent"])(extent);
            geometry.rotate(this.getRotation(), Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getCenter"])(extent));
        }
        else {
            var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["getUserProjection"])();
            if (userProjection) {
                geometry = /** @type {import("./geom/SimpleGeometry.js").default} */ (geometryOrExtent
                    .clone()
                    .transform(userProjection, this.getProjection()));
            }
            else {
                geometry = geometryOrExtent;
            }
        }
        this.fitInternal(geometry, opt_options);
    };
    /**
     * Calculate rotated extent
     * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
     * @return {import("./extent").Extent} The rotated extent for the geometry.
     */
    View.prototype.rotatedExtentForGeometry = function (geometry) {
        var rotation = this.getRotation();
        var cosAngle = Math.cos(rotation);
        var sinAngle = Math.sin(-rotation);
        var coords = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        var minRotX = +Infinity;
        var minRotY = +Infinity;
        var maxRotX = -Infinity;
        var maxRotY = -Infinity;
        for (var i = 0, ii = coords.length; i < ii; i += stride) {
            var rotX = coords[i] * cosAngle - coords[i + 1] * sinAngle;
            var rotY = coords[i] * sinAngle + coords[i + 1] * cosAngle;
            minRotX = Math.min(minRotX, rotX);
            minRotY = Math.min(minRotY, rotY);
            maxRotX = Math.max(maxRotX, rotX);
            maxRotY = Math.max(maxRotY, rotY);
        }
        return [minRotX, minRotY, maxRotX, maxRotY];
    };
    /**
     * @param {import("./geom/SimpleGeometry.js").default} geometry The geometry.
     * @param {FitOptions} [opt_options] Options.
     */
    View.prototype.fitInternal = function (geometry, opt_options) {
        var options = opt_options || {};
        var size = options.size;
        if (!size) {
            size = this.getViewportSizeMinusPadding_();
        }
        var padding = options.padding !== undefined ? options.padding : [0, 0, 0, 0];
        var nearest = options.nearest !== undefined ? options.nearest : false;
        var minResolution;
        if (options.minResolution !== undefined) {
            minResolution = options.minResolution;
        }
        else if (options.maxZoom !== undefined) {
            minResolution = this.getResolutionForZoom(options.maxZoom);
        }
        else {
            minResolution = 0;
        }
        var rotatedExtent = this.rotatedExtentForGeometry(geometry);
        // calculate resolution
        var resolution = this.getResolutionForExtentInternal(rotatedExtent, [
            size[0] - padding[1] - padding[3],
            size[1] - padding[0] - padding[2],
        ]);
        resolution = isNaN(resolution)
            ? minResolution
            : Math.max(resolution, minResolution);
        resolution = this.getConstrainedResolution(resolution, nearest ? 0 : 1);
        // calculate center
        var rotation = this.getRotation();
        var sinAngle = Math.sin(rotation);
        var cosAngle = Math.cos(rotation);
        var centerRot = Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getCenter"])(rotatedExtent);
        centerRot[0] += ((padding[1] - padding[3]) / 2) * resolution;
        centerRot[1] += ((padding[0] - padding[2]) / 2) * resolution;
        var centerX = centerRot[0] * cosAngle - centerRot[1] * sinAngle;
        var centerY = centerRot[1] * cosAngle + centerRot[0] * sinAngle;
        var center = this.getConstrainedCenter([centerX, centerY], resolution);
        var callback = options.callback ? options.callback : _functions_js__WEBPACK_IMPORTED_MODULE_7__["VOID"];
        if (options.duration !== undefined) {
            this.animateInternal({
                resolution: resolution,
                center: center,
                duration: options.duration,
                easing: options.easing,
            }, callback);
        }
        else {
            this.targetResolution_ = resolution;
            this.targetCenter_ = center;
            this.applyTargetState_(false, true);
            animationCallback(callback, true);
        }
    };
    /**
     * Center on coordinate and view position.
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     * @api
     */
    View.prototype.centerOn = function (coordinate, size, position) {
        this.centerOnInternal(Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(coordinate, this.getProjection()), size, position);
    };
    /**
     * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("./size.js").Size} size Box pixel size.
     * @param {import("./pixel.js").Pixel} position Position on the view to center on.
     */
    View.prototype.centerOnInternal = function (coordinate, size, position) {
        this.setCenterInternal(calculateCenterOn(coordinate, size, position, this.getResolution(), this.getRotation()));
    };
    /**
     * Calculates the shift between map and viewport center.
     * @param {import("./coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {import("./size.js").Size} size Size.
     * @return {Array<number>|undefined} Center shift.
     */
    View.prototype.calculateCenterShift = function (center, resolution, rotation, size) {
        var centerShift;
        var padding = this.padding_;
        if (padding && center) {
            var reducedSize = this.getViewportSizeMinusPadding_(-rotation);
            var shiftedCenter = calculateCenterOn(center, size, [reducedSize[0] / 2 + padding[3], reducedSize[1] / 2 + padding[0]], resolution, rotation);
            centerShift = [
                center[0] - shiftedCenter[0],
                center[1] - shiftedCenter[1],
            ];
        }
        return centerShift;
    };
    /**
     * @return {boolean} Is defined.
     */
    View.prototype.isDef = function () {
        return !!this.getCenterInternal() && this.getResolution() !== undefined;
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     * @api
     */
    View.prototype.adjustCenter = function (deltaCoordinates) {
        var center = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["toUserCoordinate"])(this.targetCenter_, this.getProjection());
        this.setCenter([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1],
        ]);
    };
    /**
     * Adds relative coordinates to the center of the view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate} deltaCoordinates Relative value to add.
     */
    View.prototype.adjustCenterInternal = function (deltaCoordinates) {
        var center = this.targetCenter_;
        this.setCenterInternal([
            center[0] + deltaCoordinates[0],
            center[1] + deltaCoordinates[1],
        ]);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */
    View.prototype.adjustResolution = function (ratio, opt_anchor) {
        var anchor = opt_anchor && Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(opt_anchor, this.getProjection());
        this.adjustResolutionInternal(ratio, anchor);
    };
    /**
     * Multiply the view resolution by a ratio, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} ratio The ratio to apply on the view resolution.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */
    View.prototype.adjustResolutionInternal = function (ratio, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var size = this.getViewportSize_(this.getRotation());
        var newResolution = this.constraints_.resolution(this.targetResolution_ * ratio, 0, size, isMoving);
        if (opt_anchor) {
            this.targetCenter_ = this.calculateCenterZoom(newResolution, opt_anchor);
        }
        this.targetResolution_ *= ratio;
        this.applyTargetState_();
    };
    /**
     * Adds a value to the view zoom level, optionally using an anchor. Any resolution
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom level.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */
    View.prototype.adjustZoom = function (delta, opt_anchor) {
        this.adjustResolution(Math.pow(this.zoomFactor_, -delta), opt_anchor);
    };
    /**
     * Adds a value to the view rotation, optionally using an anchor. Any rotation
     * constraint will apply.
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The rotation center.
     * @api
     */
    View.prototype.adjustRotation = function (delta, opt_anchor) {
        if (opt_anchor) {
            opt_anchor = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(opt_anchor, this.getProjection());
        }
        this.adjustRotationInternal(delta, opt_anchor);
    };
    /**
     * @param {number} delta Relative value to add to the zoom rotation, in radians.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The rotation center.
     */
    View.prototype.adjustRotationInternal = function (delta, opt_anchor) {
        var isMoving = this.getAnimating() || this.getInteracting();
        var newRotation = this.constraints_.rotation(this.targetRotation_ + delta, isMoving);
        if (opt_anchor) {
            this.targetCenter_ = this.calculateCenterRotate(newRotation, opt_anchor);
        }
        this.targetRotation_ += delta;
        this.applyTargetState_();
    };
    /**
     * Set the center of the current view. Any extent constraint will apply.
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     * @observable
     * @api
     */
    View.prototype.setCenter = function (center) {
        this.setCenterInternal(Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(center, this.getProjection()));
    };
    /**
     * Set the center using the view projection (not the user projection).
     * @param {import("./coordinate.js").Coordinate|undefined} center The center of the view.
     */
    View.prototype.setCenterInternal = function (center) {
        this.targetCenter_ = center;
        this.applyTargetState_();
    };
    /**
     * @param {import("./ViewHint.js").default} hint Hint.
     * @param {number} delta Delta.
     * @return {number} New value.
     */
    View.prototype.setHint = function (hint, delta) {
        this.hints_[hint] += delta;
        this.changed();
        return this.hints_[hint];
    };
    /**
     * Set the resolution for this view. Any resolution constraint will apply.
     * @param {number|undefined} resolution The resolution of the view.
     * @observable
     * @api
     */
    View.prototype.setResolution = function (resolution) {
        this.targetResolution_ = resolution;
        this.applyTargetState_();
    };
    /**
     * Set the rotation for this view. Any rotation constraint will apply.
     * @param {number} rotation The rotation of the view in radians.
     * @observable
     * @api
     */
    View.prototype.setRotation = function (rotation) {
        this.targetRotation_ = rotation;
        this.applyTargetState_();
    };
    /**
     * Zoom to a specific zoom level. Any resolution constrain will apply.
     * @param {number} zoom Zoom level.
     * @api
     */
    View.prototype.setZoom = function (zoom) {
        this.setResolution(this.getResolutionForZoom(zoom));
    };
    /**
     * Recompute rotation/resolution/center based on target values.
     * Note: we have to compute rotation first, then resolution and center considering that
     * parameters can influence one another in case a view extent constraint is present.
     * @param {boolean} [opt_doNotCancelAnims] Do not cancel animations.
     * @param {boolean} [opt_forceMoving] Apply constraints as if the view is moving.
     * @private
     */
    View.prototype.applyTargetState_ = function (opt_doNotCancelAnims, opt_forceMoving) {
        var isMoving = this.getAnimating() || this.getInteracting() || opt_forceMoving;
        // compute rotation
        var newRotation = this.constraints_.rotation(this.targetRotation_, isMoving);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, 0, size, isMoving);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, isMoving, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].ROTATION) !== newRotation) {
            this.set(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].ROTATION, newRotation);
        }
        if (this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].RESOLUTION) !== newResolution) {
            this.set(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].RESOLUTION, newResolution);
        }
        if (!this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].CENTER) ||
            !Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["equals"])(this.get(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].CENTER), newCenter)) {
            this.set(_ViewProperty_js__WEBPACK_IMPORTED_MODULE_4__["default"].CENTER, newCenter);
        }
        if (this.getAnimating() && !opt_doNotCancelAnims) {
            this.cancelAnimations();
        }
        this.cancelAnchor_ = undefined;
    };
    /**
     * If any constraints need to be applied, an animation will be triggered.
     * This is typically done on interaction end.
     * Note: calling this with a duration of 0 will apply the constrained values straight away,
     * without animation.
     * @param {number} [opt_duration] The animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */
    View.prototype.resolveConstraints = function (opt_duration, opt_resolutionDirection, opt_anchor) {
        var duration = opt_duration !== undefined ? opt_duration : 200;
        var direction = opt_resolutionDirection || 0;
        var newRotation = this.constraints_.rotation(this.targetRotation_);
        var size = this.getViewportSize_(newRotation);
        var newResolution = this.constraints_.resolution(this.targetResolution_, direction, size);
        var newCenter = this.constraints_.center(this.targetCenter_, newResolution, size, false, this.calculateCenterShift(this.targetCenter_, newResolution, newRotation, size));
        if (duration === 0 && !this.cancelAnchor_) {
            this.targetResolution_ = newResolution;
            this.targetRotation_ = newRotation;
            this.targetCenter_ = newCenter;
            this.applyTargetState_();
            return;
        }
        var anchor = opt_anchor || (duration === 0 ? this.cancelAnchor_ : undefined);
        this.cancelAnchor_ = undefined;
        if (this.getResolution() !== newResolution ||
            this.getRotation() !== newRotation ||
            !this.getCenterInternal() ||
            !Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["equals"])(this.getCenterInternal(), newCenter)) {
            if (this.getAnimating()) {
                this.cancelAnimations();
            }
            this.animateInternal({
                rotation: newRotation,
                center: newCenter,
                resolution: newResolution,
                duration: duration,
                easing: _easing_js__WEBPACK_IMPORTED_MODULE_15__["easeOut"],
                anchor: anchor,
            });
        }
    };
    /**
     * Notify the View that an interaction has started.
     * The view state will be resolved to a stable one if needed
     * (depending on its constraints).
     * @api
     */
    View.prototype.beginInteraction = function () {
        this.resolveConstraints(0);
        this.setHint(_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING, 1);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number} [opt_duration] Animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     * @api
     */
    View.prototype.endInteraction = function (opt_duration, opt_resolutionDirection, opt_anchor) {
        var anchor = opt_anchor && Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["fromUserCoordinate"])(opt_anchor, this.getProjection());
        this.endInteractionInternal(opt_duration, opt_resolutionDirection, anchor);
    };
    /**
     * Notify the View that an interaction has ended. The view state will be resolved
     * to a stable one if needed (depending on its constraints).
     * @param {number} [opt_duration] Animation duration in ms.
     * @param {number} [opt_resolutionDirection] Which direction to zoom.
     * @param {import("./coordinate.js").Coordinate} [opt_anchor] The origin of the transformation.
     */
    View.prototype.endInteractionInternal = function (opt_duration, opt_resolutionDirection, opt_anchor) {
        this.setHint(_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING, -1);
        this.resolveConstraints(opt_duration, opt_resolutionDirection, opt_anchor);
    };
    /**
     * Get a valid position for the view center according to the current constraints.
     * @param {import("./coordinate.js").Coordinate|undefined} targetCenter Target center position.
     * @param {number} [opt_targetResolution] Target resolution. If not supplied, the current one will be used.
     * This is useful to guess a valid center position at a different zoom level.
     * @return {import("./coordinate.js").Coordinate|undefined} Valid center position.
     */
    View.prototype.getConstrainedCenter = function (targetCenter, opt_targetResolution) {
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.center(targetCenter, opt_targetResolution || this.getResolution(), size);
    };
    /**
     * Get a valid zoom level according to the current view constraints.
     * @param {number|undefined} targetZoom Target zoom.
     * @param {number} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid zoom level.
     */
    View.prototype.getConstrainedZoom = function (targetZoom, opt_direction) {
        var targetRes = this.getResolutionForZoom(targetZoom);
        return this.getZoomForResolution(this.getConstrainedResolution(targetRes, opt_direction));
    };
    /**
     * Get a valid resolution according to the current view constraints.
     * @param {number|undefined} targetResolution Target resolution.
     * @param {number} [opt_direction=0] Indicate which resolution should be used
     * by a renderer if the view resolution does not match any resolution of the tile source.
     * If 0, the nearest resolution will be used. If 1, the nearest lower resolution
     * will be used. If -1, the nearest higher resolution will be used.
     * @return {number|undefined} Valid resolution.
     */
    View.prototype.getConstrainedResolution = function (targetResolution, opt_direction) {
        var direction = opt_direction || 0;
        var size = this.getViewportSize_(this.getRotation());
        return this.constraints_.resolution(targetResolution, direction, size);
    };
    return View;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {Function} callback Callback.
 * @param {*} returnValue Return value.
 */
function animationCallback(callback, returnValue) {
    setTimeout(function () {
        callback(returnValue);
    }, 0);
}
/**
 * @param {ViewOptions} options View options.
 * @return {import("./centerconstraint.js").Type} The constraint.
 */
function createCenterConstraint(options) {
    if (options.extent !== undefined) {
        var smooth = options.smoothExtentConstraint !== undefined
            ? options.smoothExtentConstraint
            : true;
        return Object(_centerconstraint_js__WEBPACK_IMPORTED_MODULE_11__["createExtent"])(options.extent, options.constrainOnlyCenter, smooth);
    }
    var projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["createProjection"])(options.projection, 'EPSG:3857');
    if (options.multiWorld !== true && projection.isGlobal()) {
        var extent = projection.getExtent().slice();
        extent[0] = -Infinity;
        extent[2] = Infinity;
        return Object(_centerconstraint_js__WEBPACK_IMPORTED_MODULE_11__["createExtent"])(extent, false, false);
    }
    return _centerconstraint_js__WEBPACK_IMPORTED_MODULE_11__["none"];
}
/**
 * @param {ViewOptions} options View options.
 * @return {{constraint: import("./resolutionconstraint.js").Type, maxResolution: number,
 *     minResolution: number, minZoom: number, zoomFactor: number}} The constraint.
 */
function createResolutionConstraint(options) {
    var resolutionConstraint;
    var maxResolution;
    var minResolution;
    // TODO: move these to be ol constants
    // see https://github.com/openlayers/openlayers/issues/2076
    var defaultMaxZoom = 28;
    var defaultZoomFactor = 2;
    var minZoom = options.minZoom !== undefined ? options.minZoom : DEFAULT_MIN_ZOOM;
    var maxZoom = options.maxZoom !== undefined ? options.maxZoom : defaultMaxZoom;
    var zoomFactor = options.zoomFactor !== undefined ? options.zoomFactor : defaultZoomFactor;
    var multiWorld = options.multiWorld !== undefined ? options.multiWorld : false;
    var smooth = options.smoothResolutionConstraint !== undefined
        ? options.smoothResolutionConstraint
        : true;
    var showFullExtent = options.showFullExtent !== undefined ? options.showFullExtent : false;
    var projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["createProjection"])(options.projection, 'EPSG:3857');
    var projExtent = projection.getExtent();
    var constrainOnlyCenter = options.constrainOnlyCenter;
    var extent = options.extent;
    if (!multiWorld && !extent && projection.isGlobal()) {
        constrainOnlyCenter = false;
        extent = projExtent;
    }
    if (options.resolutions !== undefined) {
        var resolutions = options.resolutions;
        maxResolution = resolutions[minZoom];
        minResolution =
            resolutions[maxZoom] !== undefined
                ? resolutions[maxZoom]
                : resolutions[resolutions.length - 1];
        if (options.constrainResolution) {
            resolutionConstraint = Object(_resolutionconstraint_js__WEBPACK_IMPORTED_MODULE_13__["createSnapToResolutions"])(resolutions, smooth, !constrainOnlyCenter && extent, showFullExtent);
        }
        else {
            resolutionConstraint = Object(_resolutionconstraint_js__WEBPACK_IMPORTED_MODULE_13__["createMinMaxResolution"])(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        }
    }
    else {
        // calculate the default min and max resolution
        var size = !projExtent
            ? // use an extent that can fit the whole world if need be
                (360 * _proj_js__WEBPACK_IMPORTED_MODULE_6__["METERS_PER_UNIT"][_proj_Units_js__WEBPACK_IMPORTED_MODULE_2__["default"].DEGREES]) / projection.getMetersPerUnit()
            : Math.max(Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getWidth"])(projExtent), Object(_extent_js__WEBPACK_IMPORTED_MODULE_16__["getHeight"])(projExtent));
        var defaultMaxResolution = size / _tilegrid_common_js__WEBPACK_IMPORTED_MODULE_5__["DEFAULT_TILE_SIZE"] / Math.pow(defaultZoomFactor, DEFAULT_MIN_ZOOM);
        var defaultMinResolution = defaultMaxResolution /
            Math.pow(defaultZoomFactor, defaultMaxZoom - DEFAULT_MIN_ZOOM);
        // user provided maxResolution takes precedence
        maxResolution = options.maxResolution;
        if (maxResolution !== undefined) {
            minZoom = 0;
        }
        else {
            maxResolution = defaultMaxResolution / Math.pow(zoomFactor, minZoom);
        }
        // user provided minResolution takes precedence
        minResolution = options.minResolution;
        if (minResolution === undefined) {
            if (options.maxZoom !== undefined) {
                if (options.maxResolution !== undefined) {
                    minResolution = maxResolution / Math.pow(zoomFactor, maxZoom);
                }
                else {
                    minResolution = defaultMaxResolution / Math.pow(zoomFactor, maxZoom);
                }
            }
            else {
                minResolution = defaultMinResolution;
            }
        }
        // given discrete zoom levels, minResolution may be different than provided
        maxZoom =
            minZoom +
                Math.floor(Math.log(maxResolution / minResolution) / Math.log(zoomFactor));
        minResolution = maxResolution / Math.pow(zoomFactor, maxZoom - minZoom);
        if (options.constrainResolution) {
            resolutionConstraint = Object(_resolutionconstraint_js__WEBPACK_IMPORTED_MODULE_13__["createSnapToPower"])(zoomFactor, maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        }
        else {
            resolutionConstraint = Object(_resolutionconstraint_js__WEBPACK_IMPORTED_MODULE_13__["createMinMaxResolution"])(maxResolution, minResolution, smooth, !constrainOnlyCenter && extent, showFullExtent);
        }
    }
    return {
        constraint: resolutionConstraint,
        maxResolution: maxResolution,
        minResolution: minResolution,
        minZoom: minZoom,
        zoomFactor: zoomFactor,
    };
}
/**
 * @param {ViewOptions} options View options.
 * @return {import("./rotationconstraint.js").Type} Rotation constraint.
 */
function createRotationConstraint(options) {
    var enableRotation = options.enableRotation !== undefined ? options.enableRotation : true;
    if (enableRotation) {
        var constrainRotation = options.constrainRotation;
        if (constrainRotation === undefined || constrainRotation === true) {
            return Object(_rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__["createSnapToZero"])();
        }
        else if (constrainRotation === false) {
            return _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__["none"];
        }
        else if (typeof constrainRotation === 'number') {
            return Object(_rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__["createSnapToN"])(constrainRotation);
        }
        else {
            return _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__["none"];
        }
    }
    else {
        return _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_14__["disable"];
    }
}
/**
 * Determine if an animation involves no view change.
 * @param {Animation} animation The animation.
 * @return {boolean} The animation involves no view change.
 */
function isNoopAnimation(animation) {
    if (animation.sourceCenter && animation.targetCenter) {
        if (!Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["equals"])(animation.sourceCenter, animation.targetCenter)) {
            return false;
        }
    }
    if (animation.sourceResolution !== animation.targetResolution) {
        return false;
    }
    if (animation.sourceRotation !== animation.targetRotation) {
        return false;
    }
    return true;
}
/**
 * @param {import("./coordinate.js").Coordinate} coordinate Coordinate.
 * @param {import("./size.js").Size} size Box pixel size.
 * @param {import("./pixel.js").Pixel} position Position on the view to center on.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {import("./coordinate.js").Coordinate} Shifted center.
 */
function calculateCenterOn(coordinate, size, position, resolution, rotation) {
    // calculate rotated position
    var cosAngle = Math.cos(-rotation);
    var sinAngle = Math.sin(-rotation);
    var rotX = coordinate[0] * cosAngle - coordinate[1] * sinAngle;
    var rotY = coordinate[1] * cosAngle + coordinate[0] * sinAngle;
    rotX += (size[0] / 2 - position[0]) * resolution;
    rotY += (position[1] - size[1] / 2) * resolution;
    // go back to original angle
    sinAngle = -sinAngle; // go back to original rotation
    var centerX = rotX * cosAngle - rotY * sinAngle;
    var centerY = rotY * cosAngle + rotX * sinAngle;
    return [centerX, centerY];
}
/* harmony default export */ __webpack_exports__["default"] = (View);
//# sourceMappingURL=View.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/ViewProperty
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    CENTER: 'center',
    RESOLUTION: 'resolution',
    ROTATION: 'rotation',
});
//# sourceMappingURL=ViewProperty.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createExtent", function() { return createExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "none", function() { return none; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/**
 * @module ol/centerconstraint
 */

/**
 * @typedef {function((import("./coordinate.js").Coordinate|undefined), number, import("./size.js").Size, boolean=, Array<number>=): (import("./coordinate.js").Coordinate|undefined)} Type
 */
/**
 * @param {import("./extent.js").Extent} extent Extent.
 * @param {boolean} onlyCenter If true, the constraint will only apply to the view center.
 * @param {boolean} smooth If true, the view will be able to go slightly out of the given extent
 * (only during interaction and animation).
 * @return {Type} The constraint.
 */
function createExtent(extent, onlyCenter, smooth) {
    return (
    /**
     * @param {import("./coordinate.js").Coordinate|undefined} center Center.
     * @param {number} resolution Resolution.
     * @param {import("./size.js").Size} size Viewport size; unused if `onlyCenter` was specified.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @param {Array<number>} [opt_centerShift] Shift between map center and viewport center.
     * @return {import("./coordinate.js").Coordinate|undefined} Center.
     */
    function (center, resolution, size, opt_isMoving, opt_centerShift) {
        if (center) {
            var viewWidth = onlyCenter ? 0 : size[0] * resolution;
            var viewHeight = onlyCenter ? 0 : size[1] * resolution;
            var shiftX = opt_centerShift ? opt_centerShift[0] : 0;
            var shiftY = opt_centerShift ? opt_centerShift[1] : 0;
            var minX = extent[0] + viewWidth / 2 + shiftX;
            var maxX = extent[2] - viewWidth / 2 + shiftX;
            var minY = extent[1] + viewHeight / 2 + shiftY;
            var maxY = extent[3] - viewHeight / 2 + shiftY;
            // note: when zooming out of bounds, min and max values for x and y may
            // end up inverted (min > max); this has to be accounted for
            if (minX > maxX) {
                minX = (maxX + minX) / 2;
                maxX = minX;
            }
            if (minY > maxY) {
                minY = (maxY + minY) / 2;
                maxY = minY;
            }
            var x = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(center[0], minX, maxX);
            var y = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(center[1], minY, maxY);
            var ratio = 30 * resolution;
            // during an interaction, allow some overscroll
            if (opt_isMoving && smooth) {
                x +=
                    -ratio * Math.log(1 + Math.max(0, minX - center[0]) / ratio) +
                        ratio * Math.log(1 + Math.max(0, center[0] - maxX) / ratio);
                y +=
                    -ratio * Math.log(1 + Math.max(0, minY - center[1]) / ratio) +
                        ratio * Math.log(1 + Math.max(0, center[1] - maxY) / ratio);
            }
            return [x, y];
        }
        else {
            return undefined;
        }
    });
}
/**
 * @param {import("./coordinate.js").Coordinate} [center] Center.
 * @return {import("./coordinate.js").Coordinate|undefined} Center.
 */
function none(center) {
    return center;
}
//# sourceMappingURL=centerconstraint.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSnapToResolutions", function() { return createSnapToResolutions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSnapToPower", function() { return createSnapToPower; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMinMaxResolution", function() { return createMinMaxResolution; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52);
/**
 * @module ol/resolutionconstraint
 */



/**
 * @typedef {function((number|undefined), number, import("./size.js").Size, boolean=): (number|undefined)} Type
 */
/**
 * Returns a modified resolution taking into account the viewport size and maximum
 * allowed extent.
 * @param {number} resolution Resolution
 * @param {import("./extent.js").Extent} maxExtent Maximum allowed extent.
 * @param {import("./size.js").Size} viewportSize Viewport size.
 * @param {boolean} showFullExtent Whether to show the full extent.
 * @return {number} Capped resolution.
 */
function getViewportClampedResolution(resolution, maxExtent, viewportSize, showFullExtent) {
    var xResolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_1__["getWidth"])(maxExtent) / viewportSize[0];
    var yResolution = Object(_extent_js__WEBPACK_IMPORTED_MODULE_1__["getHeight"])(maxExtent) / viewportSize[1];
    if (showFullExtent) {
        return Math.min(resolution, Math.max(xResolution, yResolution));
    }
    return Math.min(resolution, Math.min(xResolution, yResolution));
}
/**
 * Returns a modified resolution to be between maxResolution and minResolution while
 * still allowing the value to be slightly out of bounds.
 * Note: the computation is based on the logarithm function (ln):
 *  - at 1, ln(x) is 0
 *  - above 1, ln(x) keeps increasing but at a much slower pace than x
 * The final result is clamped to prevent getting too far away from bounds.
 * @param {number} resolution Resolution.
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @return {number} Smoothed resolution.
 */
function getSmoothClampedResolution(resolution, maxResolution, minResolution) {
    var result = Math.min(resolution, maxResolution);
    var ratio = 50;
    result *=
        Math.log(1 + ratio * Math.max(0, resolution / maxResolution - 1)) / ratio +
            1;
    if (minResolution) {
        result = Math.max(result, minResolution);
        result /=
            Math.log(1 + ratio * Math.max(0, minResolution / resolution - 1)) /
                ratio +
                1;
    }
    return Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(result, minResolution / 2, maxResolution * 2);
}
/**
 * @param {Array<number>} resolutions Resolutions.
 * @param {boolean} [opt_smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [opt_maxExtent] Maximum allowed extent.
 * @param {boolean} [opt_showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */
function createSnapToResolutions(resolutions, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return (
    /**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */
    function (resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var maxResolution = resolutions[0];
            var minResolution = resolutions[resolutions.length - 1];
            var cappedMaxRes = opt_maxExtent
                ? getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent)
                : maxResolution;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) {
                    return Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(resolution, minResolution, cappedMaxRes);
                }
                return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var capped = Math.min(cappedMaxRes, resolution);
            var z = Math.floor(Object(_array_js__WEBPACK_IMPORTED_MODULE_2__["linearFindNearest"])(resolutions, capped, direction));
            if (resolutions[z] > cappedMaxRes && z < resolutions.length - 1) {
                return resolutions[z + 1];
            }
            return resolutions[z];
        }
        else {
            return undefined;
        }
    });
}
/**
 * @param {number} power Power.
 * @param {number} maxResolution Maximum resolution.
 * @param {number} [opt_minResolution] Minimum resolution.
 * @param {boolean} [opt_smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [opt_maxExtent] Maximum allowed extent.
 * @param {boolean} [opt_showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */
function createSnapToPower(power, maxResolution, opt_minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return (
    /**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */
    function (resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent
                ? getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent)
                : maxResolution;
            var minResolution = opt_minResolution !== undefined ? opt_minResolution : 0;
            // during interacting or animating, allow intermediary values
            if (opt_isMoving) {
                var smooth = opt_smooth !== undefined ? opt_smooth : true;
                if (!smooth) {
                    return Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(resolution, minResolution, cappedMaxRes);
                }
                return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
            }
            var tolerance = 1e-9;
            var minZoomLevel = Math.ceil(Math.log(maxResolution / cappedMaxRes) / Math.log(power) - tolerance);
            var offset = -direction * (0.5 - tolerance) + 0.5;
            var capped = Math.min(cappedMaxRes, resolution);
            var cappedZoomLevel = Math.floor(Math.log(maxResolution / capped) / Math.log(power) + offset);
            var zoomLevel = Math.max(minZoomLevel, cappedZoomLevel);
            var newResolution = maxResolution / Math.pow(power, zoomLevel);
            return Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(newResolution, minResolution, cappedMaxRes);
        }
        else {
            return undefined;
        }
    });
}
/**
 * @param {number} maxResolution Max resolution.
 * @param {number} minResolution Min resolution.
 * @param {boolean} [opt_smooth] If true, the view will be able to slightly exceed resolution limits. Default: true.
 * @param {import("./extent.js").Extent} [opt_maxExtent] Maximum allowed extent.
 * @param {boolean} [opt_showFullExtent] If true, allows us to show the full extent. Default: false.
 * @return {Type} Zoom function.
 */
function createMinMaxResolution(maxResolution, minResolution, opt_smooth, opt_maxExtent, opt_showFullExtent) {
    return (
    /**
     * @param {number|undefined} resolution Resolution.
     * @param {number} direction Direction.
     * @param {import("./size.js").Size} size Viewport size.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Resolution.
     */
    function (resolution, direction, size, opt_isMoving) {
        if (resolution !== undefined) {
            var cappedMaxRes = opt_maxExtent
                ? getViewportClampedResolution(maxResolution, opt_maxExtent, size, opt_showFullExtent)
                : maxResolution;
            var smooth = opt_smooth !== undefined ? opt_smooth : true;
            if (!smooth || !opt_isMoving) {
                return Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["clamp"])(resolution, minResolution, cappedMaxRes);
            }
            return getSmoothClampedResolution(resolution, cappedMaxRes, minResolution);
        }
        else {
            return undefined;
        }
    });
}
//# sourceMappingURL=resolutionconstraint.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disable", function() { return disable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "none", function() { return none; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSnapToN", function() { return createSnapToN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSnapToZero", function() { return createSnapToZero; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/**
 * @module ol/rotationconstraint
 */

/**
 * @typedef {function((number|undefined), boolean=): (number|undefined)} Type
 */
/**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */
function disable(rotation) {
    if (rotation !== undefined) {
        return 0;
    }
    else {
        return undefined;
    }
}
/**
 * @param {number|undefined} rotation Rotation.
 * @return {number|undefined} Rotation.
 */
function none(rotation) {
    if (rotation !== undefined) {
        return rotation;
    }
    else {
        return undefined;
    }
}
/**
 * @param {number} n N.
 * @return {Type} Rotation constraint.
 */
function createSnapToN(n) {
    var theta = (2 * Math.PI) / n;
    return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function (rotation, opt_isMoving) {
        if (opt_isMoving) {
            return rotation;
        }
        if (rotation !== undefined) {
            rotation = Math.floor(rotation / theta + 0.5) * theta;
            return rotation;
        }
        else {
            return undefined;
        }
    });
}
/**
 * @param {number} [opt_tolerance] Tolerance.
 * @return {Type} Rotation constraint.
 */
function createSnapToZero(opt_tolerance) {
    var tolerance = opt_tolerance || Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["toRadians"])(5);
    return (
    /**
     * @param {number|undefined} rotation Rotation.
     * @param {boolean} [opt_isMoving] True if an interaction or animation is in progress.
     * @return {number|undefined} Rotation.
     */
    function (rotation, opt_isMoving) {
        if (opt_isMoving) {
            return rotation;
        }
        if (rotation !== undefined) {
            if (Math.abs(rotation) <= tolerance) {
                return 0;
            }
            else {
                return rotation;
            }
        }
        else {
            return undefined;
        }
    });
}
//# sourceMappingURL=rotationconstraint.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circular", function() { return circular; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromExtent", function() { return fromExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromCircle", function() { return fromCircle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeRegular", function() { return makeRegular; });
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(103);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _LinearRing_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(185);
/* harmony import */ var _Point_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99);
/* harmony import */ var _flat_closest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(104);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/* harmony import */ var _flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(190);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(188);
/* harmony import */ var _flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192);
/* harmony import */ var _flat_orient_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(194);
/* harmony import */ var _flat_area_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(189);
/* harmony import */ var _flat_contains_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(191);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11);
/* harmony import */ var _flat_simplify_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(187);
/* harmony import */ var _sphere_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(22);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/Polygon
 */


















/**
 * @classdesc
 * Polygon geometry.
 *
 * @api
 */
var Polygon = /** @class */ (function (_super) {
    __extends(Polygon, _super);
    /**
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>|!Array<number>} coordinates
     *     Array of linear rings that define the polygon. The first linear ring of the
     *     array defines the outer-boundary or surface of the polygon. Each subsequent
     *     linear ring defines a hole in the surface of the polygon. A linear ring is
     *     an array of vertices' coordinates where the first coordinate and the last are
     *     equivalent. (For internal use, flat coordinates in combination with
     *     `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<number>} [opt_ends] Ends (for internal use with flat coordinates).
     */
    function Polygon(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */
        _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */
        _this.flatInteriorPointRevision_ = -1;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */
        _this.flatInteriorPoint_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDeltaRevision_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.orientedRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.orientedFlatCoordinates_ = null;
        if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
            _this.ends_ = opt_ends;
        }
        else {
            _this.setCoordinates(
            /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ (coordinates), opt_layout);
        }
        return _this;
    }
    /**
     * Append the passed linear ring to this polygon.
     * @param {LinearRing} linearRing Linear ring.
     * @api
     */
    Polygon.prototype.appendLinearRing = function (linearRing) {
        if (!this.flatCoordinates) {
            this.flatCoordinates = linearRing.getFlatCoordinates().slice();
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(this.flatCoordinates, linearRing.getFlatCoordinates());
        }
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!Polygon} Clone.
     * @api
     */
    Polygon.prototype.clone = function () {
        var polygon = new Polygon(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        polygon.applyProperties(this);
        return polygon;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    Polygon.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt(Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_5__["arrayMaxSquaredDelta"])(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_5__["assignClosestArrayPoint"])(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */
    Polygon.prototype.containsXY = function (x, y) {
        return Object(_flat_contains_js__WEBPACK_IMPORTED_MODULE_14__["linearRingsContainsXY"])(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, x, y);
    };
    /**
     * Return the area of the polygon on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */
    Polygon.prototype.getArea = function () {
        return Object(_flat_area_js__WEBPACK_IMPORTED_MODULE_13__["linearRings"])(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride);
    };
    /**
     * Get the coordinate array for this geometry.  This array has the structure
     * of a GeoJSON coordinate array for polygons.
     *
     * @param {boolean} [opt_right] Orient coordinates according to the right-hand
     *     rule (counter-clockwise for exterior and clockwise for interior rings).
     *     If `false`, coordinates will be oriented according to the left-hand rule
     *     (clockwise for exterior and counter-clockwise for interior rings).
     *     By default, coordinate orientation will depend on how the geometry was
     *     constructed.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */
    Polygon.prototype.getCoordinates = function (opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["orientLinearRings"])(flatCoordinates, 0, this.ends_, this.stride, opt_right);
        }
        else {
            flatCoordinates = this.flatCoordinates;
        }
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_10__["inflateCoordinatesArray"])(flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */
    Polygon.prototype.getEnds = function () {
        return this.ends_;
    };
    /**
     * @return {Array<number>} Interior point.
     */
    Polygon.prototype.getFlatInteriorPoint = function () {
        if (this.flatInteriorPointRevision_ != this.getRevision()) {
            var flatCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getCenter"])(this.getExtent());
            this.flatInteriorPoint_ = Object(_flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_9__["getInteriorPointOfArray"])(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, flatCenter, 0);
            this.flatInteriorPointRevision_ = this.getRevision();
        }
        return this.flatInteriorPoint_;
    };
    /**
     * Return an interior point of the polygon.
     * @return {Point} Interior point as XYM coordinate, where M is the
     * length of the horizontal intersection that the point belongs to.
     * @api
     */
    Polygon.prototype.getInteriorPoint = function () {
        return new _Point_js__WEBPACK_IMPORTED_MODULE_3__["default"](this.getFlatInteriorPoint(), _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYM);
    };
    /**
     * Return the number of rings of the polygon,  this includes the exterior
     * ring and any interior rings.
     *
     * @return {number} Number of rings.
     * @api
     */
    Polygon.prototype.getLinearRingCount = function () {
        return this.ends_.length;
    };
    /**
     * Return the Nth linear ring of the polygon geometry. Return `null` if the
     * given index is out of range.
     * The exterior linear ring is available at index `0` and the interior rings
     * at index `1` and beyond.
     *
     * @param {number} index Index.
     * @return {LinearRing} Linear ring.
     * @api
     */
    Polygon.prototype.getLinearRing = function (index) {
        if (index < 0 || this.ends_.length <= index) {
            return null;
        }
        return new _LinearRing_js__WEBPACK_IMPORTED_MODULE_2__["default"](this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linear rings of the polygon.
     * @return {Array<LinearRing>} Linear rings.
     * @api
     */
    Polygon.prototype.getLinearRings = function () {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var linearRings = [];
        var offset = 0;
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            var end = ends[i];
            var linearRing = new _LinearRing_js__WEBPACK_IMPORTED_MODULE_2__["default"](flatCoordinates.slice(offset, end), layout);
            linearRings.push(linearRing);
            offset = end;
        }
        return linearRings;
    };
    /**
     * @return {Array<number>} Oriented flat coordinates.
     */
    Polygon.prototype.getOrientedFlatCoordinates = function () {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if (Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["linearRingsAreOriented"])(flatCoordinates, 0, this.ends_, this.stride)) {
                this.orientedFlatCoordinates_ = flatCoordinates;
            }
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["orientLinearRings"])(this.orientedFlatCoordinates_, 0, this.ends_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {Polygon} Simplified Polygon.
     * @protected
     */
    Polygon.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = Object(_flat_simplify_js__WEBPACK_IMPORTED_MODULE_16__["quantizeArray"])(this.flatCoordinates, 0, this.ends_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new Polygon(simplifiedFlatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    Polygon.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    Polygon.prototype.intersectsExtent = function (extent) {
        return Object(_flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__["intersectsLinearRingArray"])(this.getOrientedFlatCoordinates(), 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the polygon.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    Polygon.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        var ends = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_7__["deflateCoordinatesArray"])(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return Polygon;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Polygon);
/**
 * Create an approximation of a circle on the surface of a sphere.
 * @param {import("../coordinate.js").Coordinate} center Center (`[lon, lat]` in degrees).
 * @param {number} radius The great-circle distance from the center to
 *     the polygon vertices in meters.
 * @param {number} [opt_n] Optional number of vertices for the resulting
 *     polygon. Default is `32`.
 * @param {number} [opt_sphereRadius] Optional radius for the sphere (defaults to
 *     the Earth's mean radius using the WGS84 ellipsoid).
 * @return {Polygon} The "circular" polygon.
 * @api
 */
function circular(center, radius, opt_n, opt_sphereRadius) {
    var n = opt_n ? opt_n : 32;
    /** @type {Array<number>} */
    var flatCoordinates = [];
    for (var i = 0; i < n; ++i) {
        Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(flatCoordinates, Object(_sphere_js__WEBPACK_IMPORTED_MODULE_17__["offset"])(center, radius, (2 * Math.PI * i) / n, opt_sphereRadius));
    }
    flatCoordinates.push(flatCoordinates[0], flatCoordinates[1]);
    return new Polygon(flatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY, [
        flatCoordinates.length,
    ]);
}
/**
 * Create a polygon from an extent. The layout used is `XY`.
 * @param {import("../extent.js").Extent} extent The extent.
 * @return {Polygon} The polygon.
 * @api
 */
function fromExtent(extent) {
    var minX = extent[0];
    var minY = extent[1];
    var maxX = extent[2];
    var maxY = extent[3];
    var flatCoordinates = [
        minX,
        minY,
        minX,
        maxY,
        maxX,
        maxY,
        maxX,
        minY,
        minX,
        minY,
    ];
    return new Polygon(flatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY, [
        flatCoordinates.length,
    ]);
}
/**
 * Create a regular polygon from a circle.
 * @param {import("./Circle.js").default} circle Circle geometry.
 * @param {number} [opt_sides] Number of sides of the polygon. Default is 32.
 * @param {number} [opt_angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 * @return {Polygon} Polygon geometry.
 * @api
 */
function fromCircle(circle, opt_sides, opt_angle) {
    var sides = opt_sides ? opt_sides : 32;
    var stride = circle.getStride();
    var layout = circle.getLayout();
    var center = circle.getCenter();
    var arrayLength = stride * (sides + 1);
    var flatCoordinates = new Array(arrayLength);
    for (var i = 0; i < arrayLength; i += stride) {
        flatCoordinates[i] = 0;
        flatCoordinates[i + 1] = 0;
        for (var j = 2; j < stride; j++) {
            flatCoordinates[i + j] = center[j];
        }
    }
    var ends = [flatCoordinates.length];
    var polygon = new Polygon(flatCoordinates, layout, ends);
    makeRegular(polygon, center, circle.getRadius(), opt_angle);
    return polygon;
}
/**
 * Modify the coordinates of a polygon to make it a regular polygon.
 * @param {Polygon} polygon Polygon geometry.
 * @param {import("../coordinate.js").Coordinate} center Center of the regular polygon.
 * @param {number} radius Radius of the regular polygon.
 * @param {number} [opt_angle] Start angle for the first vertex of the polygon in
 *     counter-clockwise radians. 0 means East. Default is 0.
 */
function makeRegular(polygon, center, radius, opt_angle) {
    var flatCoordinates = polygon.getFlatCoordinates();
    var stride = polygon.getStride();
    var sides = flatCoordinates.length / stride - 1;
    var startAngle = opt_angle ? opt_angle : 0;
    for (var i = 0; i <= sides; ++i) {
        var offset = i * stride;
        var angle = startAngle + (Object(_math_js__WEBPACK_IMPORTED_MODULE_15__["modulo"])(i, sides) * 2 * Math.PI) / sides;
        flatCoordinates[offset] = center[0] + radius * Math.cos(angle);
        flatCoordinates[offset + 1] = center[1] + radius * Math.sin(angle);
    }
    polygon.changed();
}
//# sourceMappingURL=Polygon.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(103);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99);
/* harmony import */ var _flat_closest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(104);
/* harmony import */ var _flat_simplify_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(187);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(188);
/* harmony import */ var _flat_area_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(189);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/LinearRing
 */









/**
 * @classdesc
 * Linear ring geometry. Only used as part of polygon; cannot be rendered
 * on its own.
 *
 * @api
 */
var LinearRing = /** @class */ (function (_super) {
    __extends(LinearRing, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    function LinearRing(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
        }
        else {
            _this.setCoordinates(
            /** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
        }
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!LinearRing} Clone.
     * @api
     */
    LinearRing.prototype.clone = function () {
        return new LinearRing(this.flatCoordinates.slice(), this.layout);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    LinearRing.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt(Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_3__["maxSquaredDelta"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_3__["assignClosestPoint"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Return the area of the linear ring on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */
    LinearRing.prototype.getArea = function () {
        return Object(_flat_area_js__WEBPACK_IMPORTED_MODULE_8__["linearRing"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinates of the linear ring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */
    LinearRing.prototype.getCoordinates = function () {
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_7__["inflateCoordinates"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LinearRing} Simplified LinearRing.
     * @protected
     */
    LinearRing.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = Object(_flat_simplify_js__WEBPACK_IMPORTED_MODULE_6__["douglasPeucker"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LinearRing(simplifiedFlatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    LinearRing.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].LINEAR_RING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    LinearRing.prototype.intersectsExtent = function (extent) {
        return false;
    };
    /**
     * Set the coordinates of the linear ring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    LinearRing.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        this.flatCoordinates.length = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_5__["deflateCoordinates"])(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LinearRing;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LinearRing);
//# sourceMappingURL=LinearRing.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "maxSquaredDelta", function() { return maxSquaredDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMaxSquaredDelta", function() { return arrayMaxSquaredDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "multiArrayMaxSquaredDelta", function() { return multiArrayMaxSquaredDelta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignClosestPoint", function() { return assignClosestPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignClosestArrayPoint", function() { return assignClosestArrayPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignClosestMultiArrayPoint", function() { return assignClosestMultiArrayPoint; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/**
 * @module ol/geom/flat/closest
 */

/**
 * Returns the point on the 2D line segment flatCoordinates[offset1] to
 * flatCoordinates[offset2] that is closest to the point (x, y).  Extra
 * dimensions are linearly interpolated.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset1 Offset 1.
 * @param {number} offset2 Offset 2.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 */
function assignClosest(flatCoordinates, offset1, offset2, stride, x, y, closestPoint) {
    var x1 = flatCoordinates[offset1];
    var y1 = flatCoordinates[offset1 + 1];
    var dx = flatCoordinates[offset2] - x1;
    var dy = flatCoordinates[offset2 + 1] - y1;
    var offset;
    if (dx === 0 && dy === 0) {
        offset = offset1;
    }
    else {
        var t = ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy);
        if (t > 1) {
            offset = offset2;
        }
        else if (t > 0) {
            for (var i = 0; i < stride; ++i) {
                closestPoint[i] = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(flatCoordinates[offset1 + i], flatCoordinates[offset2 + i], t);
            }
            closestPoint.length = stride;
            return;
        }
        else {
            offset = offset1;
        }
    }
    for (var i = 0; i < stride; ++i) {
        closestPoint[i] = flatCoordinates[offset + i];
    }
    closestPoint.length = stride;
}
/**
 * Return the squared of the largest distance between any pair of consecutive
 * coordinates.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */
function maxSquaredDelta(flatCoordinates, offset, end, stride, max) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    for (offset += stride; offset < end; offset += stride) {
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        var squaredDelta = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredDistance"])(x1, y1, x2, y2);
        if (squaredDelta > max) {
            max = squaredDelta;
        }
        x1 = x2;
        y1 = y2;
    }
    return max;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */
function arrayMaxSquaredDelta(flatCoordinates, offset, ends, stride, max) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        max = maxSquaredDelta(flatCoordinates, offset, end, stride, max);
        offset = end;
    }
    return max;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} max Max squared delta.
 * @return {number} Max squared delta.
 */
function multiArrayMaxSquaredDelta(flatCoordinates, offset, endss, stride, max) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        max = arrayMaxSquaredDelta(flatCoordinates, offset, ends, stride, max);
        offset = ends[ends.length - 1];
    }
    return max;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [opt_tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */
function assignClosestPoint(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    if (offset == end) {
        return minSquaredDistance;
    }
    var i, squaredDistance;
    if (maxDelta === 0) {
        // All points are identical, so just test the first point.
        squaredDistance = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredDistance"])(x, y, flatCoordinates[offset], flatCoordinates[offset + 1]);
        if (squaredDistance < minSquaredDistance) {
            for (i = 0; i < stride; ++i) {
                closestPoint[i] = flatCoordinates[offset + i];
            }
            closestPoint.length = stride;
            return squaredDistance;
        }
        else {
            return minSquaredDistance;
        }
    }
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
    var index = offset + stride;
    while (index < end) {
        assignClosest(flatCoordinates, index - stride, index, stride, x, y, tmpPoint);
        squaredDistance = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredDistance"])(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for (i = 0; i < stride; ++i) {
                closestPoint[i] = tmpPoint[i];
            }
            closestPoint.length = stride;
            index += stride;
        }
        else {
            // Skip ahead multiple points, because we know that all the skipped
            // points cannot be any closer than the closest point we have found so
            // far.  We know this because we know how close the current point is, how
            // close the closest point we have found so far is, and the maximum
            // distance between consecutive points.  For example, if we're currently
            // at distance 10, the best we've found so far is 3, and that the maximum
            // distance between consecutive points is 2, then we'll need to skip at
            // least (10 - 3) / 2 == 3 (rounded down) points to have any chance of
            // finding a closer point.  We use Math.max(..., 1) to ensure that we
            // always advance at least one point, to avoid an infinite loop.
            index +=
                stride *
                    Math.max(((Math.sqrt(squaredDistance) - Math.sqrt(minSquaredDistance)) /
                        maxDelta) |
                        0, 1);
        }
    }
    if (isRing) {
        // Check the closing segment.
        assignClosest(flatCoordinates, end - stride, offset, stride, x, y, tmpPoint);
        squaredDistance = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredDistance"])(x, y, tmpPoint[0], tmpPoint[1]);
        if (squaredDistance < minSquaredDistance) {
            minSquaredDistance = squaredDistance;
            for (i = 0; i < stride; ++i) {
                closestPoint[i] = tmpPoint[i];
            }
            closestPoint.length = stride;
        }
    }
    return minSquaredDistance;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [opt_tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */
function assignClosestArrayPoint(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        minSquaredDistance = assignClosestPoint(flatCoordinates, offset, end, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = end;
    }
    return minSquaredDistance;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} maxDelta Max delta.
 * @param {boolean} isRing Is ring.
 * @param {number} x X.
 * @param {number} y Y.
 * @param {Array<number>} closestPoint Closest point.
 * @param {number} minSquaredDistance Minimum squared distance.
 * @param {Array<number>} [opt_tmpPoint] Temporary point object.
 * @return {number} Minimum squared distance.
 */
function assignClosestMultiArrayPoint(flatCoordinates, offset, endss, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, opt_tmpPoint) {
    var tmpPoint = opt_tmpPoint ? opt_tmpPoint : [NaN, NaN];
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        minSquaredDistance = assignClosestArrayPoint(flatCoordinates, offset, ends, stride, maxDelta, isRing, x, y, closestPoint, minSquaredDistance, tmpPoint);
        offset = ends[ends.length - 1];
    }
    return minSquaredDistance;
}
//# sourceMappingURL=closest.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "simplifyLineString", function() { return simplifyLineString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "douglasPeucker", function() { return douglasPeucker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "douglasPeuckerArray", function() { return douglasPeuckerArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "douglasPeuckerMultiArray", function() { return douglasPeuckerMultiArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "radialDistance", function() { return radialDistance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "snap", function() { return snap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return quantize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quantizeArray", function() { return quantizeArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "quantizeMultiArray", function() { return quantizeMultiArray; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/**
 * @module ol/geom/flat/simplify
 */
// Based on simplify-js https://github.com/mourner/simplify-js
// Copyright (c) 2012, Vladimir Agafonkin
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without
// modification, are permitted provided that the following conditions are met:
//
//    1. Redistributions of source code must retain the above copyright notice,
//       this list of conditions and the following disclaimer.
//
//    2. Redistributions in binary form must reproduce the above copyright
//       notice, this list of conditions and the following disclaimer in the
//       documentation and/or other materials provided with the distribution.
//
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
// AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
// IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
// ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
// LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
// CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
// SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
// INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
// CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
// ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
// POSSIBILITY OF SUCH DAMAGE.

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {boolean} highQuality Highest quality.
 * @param {Array<number>} [opt_simplifiedFlatCoordinates] Simplified flat
 *     coordinates.
 * @return {Array<number>} Simplified line string.
 */
function simplifyLineString(flatCoordinates, offset, end, stride, squaredTolerance, highQuality, opt_simplifiedFlatCoordinates) {
    var simplifiedFlatCoordinates = opt_simplifiedFlatCoordinates !== undefined
        ? opt_simplifiedFlatCoordinates
        : [];
    if (!highQuality) {
        end = radialDistance(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        flatCoordinates = simplifiedFlatCoordinates;
        offset = 0;
        stride = 2;
    }
    simplifiedFlatCoordinates.length = douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, 0);
    return simplifiedFlatCoordinates;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */
function douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    var n = (end - offset) / stride;
    if (n < 3) {
        for (; offset < end; offset += stride) {
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] =
                flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    /** @type {Array<number>} */
    var markers = new Array(n);
    markers[0] = 1;
    markers[n - 1] = 1;
    /** @type {Array<number>} */
    var stack = [offset, end - stride];
    var index = 0;
    while (stack.length > 0) {
        var last = stack.pop();
        var first = stack.pop();
        var maxSquaredDistance = 0;
        var x1 = flatCoordinates[first];
        var y1 = flatCoordinates[first + 1];
        var x2 = flatCoordinates[last];
        var y2 = flatCoordinates[last + 1];
        for (var i = first + stride; i < last; i += stride) {
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            var squaredDistance_1 = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredSegmentDistance"])(x, y, x1, y1, x2, y2);
            if (squaredDistance_1 > maxSquaredDistance) {
                index = i;
                maxSquaredDistance = squaredDistance_1;
            }
        }
        if (maxSquaredDistance > squaredTolerance) {
            markers[(index - offset) / stride] = 1;
            if (first + stride < index) {
                stack.push(first, index);
            }
            if (index + stride < last) {
                stack.push(index, last);
            }
        }
    }
    for (var i = 0; i < n; ++i) {
        if (markers[i]) {
            simplifiedFlatCoordinates[simplifiedOffset++] =
                flatCoordinates[offset + i * stride];
            simplifiedFlatCoordinates[simplifiedOffset++] =
                flatCoordinates[offset + i * stride + 1];
        }
    }
    return simplifiedOffset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<number>} simplifiedEnds Simplified ends.
 * @return {number} Simplified offset.
 */
function douglasPeuckerArray(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        simplifiedOffset = douglasPeucker(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<Array<number>>} simplifiedEndss Simplified endss.
 * @return {number} Simplified offset.
 */
function douglasPeuckerMultiArray(flatCoordinates, offset, endss, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = douglasPeuckerArray(flatCoordinates, offset, ends, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */
function radialDistance(flatCoordinates, offset, end, stride, squaredTolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    if (end <= offset + stride) {
        // zero or one point, no simplification possible, so copy and return
        for (; offset < end; offset += stride) {
            simplifiedFlatCoordinates[simplifiedOffset++] = flatCoordinates[offset];
            simplifiedFlatCoordinates[simplifiedOffset++] =
                flatCoordinates[offset + 1];
        }
        return simplifiedOffset;
    }
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    // copy first point
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    var x2 = x1;
    var y2 = y1;
    for (offset += stride; offset < end; offset += stride) {
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        if (Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["squaredDistance"])(x1, y1, x2, y2) > squaredTolerance) {
            // copy point at offset
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            x1 = x2;
            y1 = y2;
        }
    }
    if (x2 != x1 || y2 != y1) {
        // copy last point
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    }
    return simplifiedOffset;
}
/**
 * @param {number} value Value.
 * @param {number} tolerance Tolerance.
 * @return {number} Rounded value.
 */
function snap(value, tolerance) {
    return tolerance * Math.round(value / tolerance);
}
/**
 * Simplifies a line string using an algorithm designed by Tim Schaub.
 * Coordinates are snapped to the nearest value in a virtual grid and
 * consecutive duplicate coordinates are discarded.  This effectively preserves
 * topology as the simplification of any subsection of a line string is
 * independent of the rest of the line string.  This means that, for examples,
 * the common edge between two polygons will be simplified to the same line
 * string independently in both polygons.  This implementation uses a single
 * pass over the coordinates and eliminates intermediate collinear points.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @return {number} Simplified offset.
 */
function quantize(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset) {
    // do nothing if the line is empty
    if (offset == end) {
        return simplifiedOffset;
    }
    // snap the first coordinate (P1)
    var x1 = snap(flatCoordinates[offset], tolerance);
    var y1 = snap(flatCoordinates[offset + 1], tolerance);
    offset += stride;
    // add the first coordinate to the output
    simplifiedFlatCoordinates[simplifiedOffset++] = x1;
    simplifiedFlatCoordinates[simplifiedOffset++] = y1;
    // find the next coordinate that does not snap to the same value as the first
    // coordinate (P2)
    var x2, y2;
    do {
        x2 = snap(flatCoordinates[offset], tolerance);
        y2 = snap(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        if (offset == end) {
            // all coordinates snap to the same value, the line collapses to a point
            // push the last snapped value anyway to ensure that the output contains
            // at least two points
            // FIXME should we really return at least two points anyway?
            simplifiedFlatCoordinates[simplifiedOffset++] = x2;
            simplifiedFlatCoordinates[simplifiedOffset++] = y2;
            return simplifiedOffset;
        }
    } while (x2 == x1 && y2 == y1);
    while (offset < end) {
        // snap the next coordinate (P3)
        var x3 = snap(flatCoordinates[offset], tolerance);
        var y3 = snap(flatCoordinates[offset + 1], tolerance);
        offset += stride;
        // skip P3 if it is equal to P2
        if (x3 == x2 && y3 == y2) {
            continue;
        }
        // calculate the delta between P1 and P2
        var dx1 = x2 - x1;
        var dy1 = y2 - y1;
        // calculate the delta between P3 and P1
        var dx2 = x3 - x1;
        var dy2 = y3 - y1;
        // if P1, P2, and P3 are colinear and P3 is further from P1 than P2 is from
        // P1 in the same direction then P2 is on the straight line between P1 and
        // P3
        if (dx1 * dy2 == dy1 * dx2 &&
            ((dx1 < 0 && dx2 < dx1) || dx1 == dx2 || (dx1 > 0 && dx2 > dx1)) &&
            ((dy1 < 0 && dy2 < dy1) || dy1 == dy2 || (dy1 > 0 && dy2 > dy1))) {
            // discard P2 and set P2 = P3
            x2 = x3;
            y2 = y3;
            continue;
        }
        // either P1, P2, and P3 are not colinear, or they are colinear but P3 is
        // between P3 and P1 or on the opposite half of the line to P2.  add P2,
        // and continue with P1 = P2 and P2 = P3
        simplifiedFlatCoordinates[simplifiedOffset++] = x2;
        simplifiedFlatCoordinates[simplifiedOffset++] = y2;
        x1 = x2;
        y1 = y2;
        x2 = x3;
        y2 = y3;
    }
    // add the last point (P2)
    simplifiedFlatCoordinates[simplifiedOffset++] = x2;
    simplifiedFlatCoordinates[simplifiedOffset++] = y2;
    return simplifiedOffset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<number>} simplifiedEnds Simplified ends.
 * @return {number} Simplified offset.
 */
function quantizeArray(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        simplifiedOffset = quantize(flatCoordinates, offset, end, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset);
        simplifiedEnds.push(simplifiedOffset);
        offset = end;
    }
    return simplifiedOffset;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} tolerance Tolerance.
 * @param {Array<number>} simplifiedFlatCoordinates Simplified flat
 *     coordinates.
 * @param {number} simplifiedOffset Simplified offset.
 * @param {Array<Array<number>>} simplifiedEndss Simplified endss.
 * @return {number} Simplified offset.
 */
function quantizeMultiArray(flatCoordinates, offset, endss, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEndss) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        var simplifiedEnds = [];
        simplifiedOffset = quantizeArray(flatCoordinates, offset, ends, stride, tolerance, simplifiedFlatCoordinates, simplifiedOffset, simplifiedEnds);
        simplifiedEndss.push(simplifiedEnds);
        offset = ends[ends.length - 1];
    }
    return simplifiedOffset;
}
//# sourceMappingURL=simplify.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inflateCoordinates", function() { return inflateCoordinates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inflateCoordinatesArray", function() { return inflateCoordinatesArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "inflateMultiCoordinatesArray", function() { return inflateMultiCoordinatesArray; });
/**
 * @module ol/geom/flat/inflate
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<import("../../coordinate.js").Coordinate>} [opt_coordinates] Coordinates.
 * @return {Array<import("../../coordinate.js").Coordinate>} Coordinates.
 */
function inflateCoordinates(flatCoordinates, offset, end, stride, opt_coordinates) {
    var coordinates = opt_coordinates !== undefined ? opt_coordinates : [];
    var i = 0;
    for (var j = offset; j < end; j += stride) {
        coordinates[i++] = flatCoordinates.slice(j, j + stride);
    }
    coordinates.length = i;
    return coordinates;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<Array<import("../../coordinate.js").Coordinate>>} [opt_coordinatess] Coordinatess.
 * @return {Array<Array<import("../../coordinate.js").Coordinate>>} Coordinatess.
 */
function inflateCoordinatesArray(flatCoordinates, offset, ends, stride, opt_coordinatess) {
    var coordinatess = opt_coordinatess !== undefined ? opt_coordinatess : [];
    var i = 0;
    for (var j = 0, jj = ends.length; j < jj; ++j) {
        var end = ends[j];
        coordinatess[i++] = inflateCoordinates(flatCoordinates, offset, end, stride, coordinatess[i]);
        offset = end;
    }
    coordinatess.length = i;
    return coordinatess;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} [opt_coordinatesss]
 *     Coordinatesss.
 * @return {Array<Array<Array<import("../../coordinate.js").Coordinate>>>} Coordinatesss.
 */
function inflateMultiCoordinatesArray(flatCoordinates, offset, endss, stride, opt_coordinatesss) {
    var coordinatesss = opt_coordinatesss !== undefined ? opt_coordinatesss : [];
    var i = 0;
    for (var j = 0, jj = endss.length; j < jj; ++j) {
        var ends = endss[j];
        coordinatesss[i++] = inflateCoordinatesArray(flatCoordinates, offset, ends, stride, coordinatesss[i]);
        offset = ends[ends.length - 1];
    }
    coordinatesss.length = i;
    return coordinatesss;
}
//# sourceMappingURL=inflate.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRing", function() { return linearRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRings", function() { return linearRings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingss", function() { return linearRingss; });
/**
 * @module ol/geom/flat/area
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */
function linearRing(flatCoordinates, offset, end, stride) {
    var twiceArea = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for (; offset < end; offset += stride) {
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        twiceArea += y1 * x2 - x1 * y2;
        x1 = x2;
        y1 = y2;
    }
    return twiceArea / 2;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @return {number} Area.
 */
function linearRings(flatCoordinates, offset, ends, stride) {
    var area = 0;
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        area += linearRing(flatCoordinates, offset, end, stride);
        offset = end;
    }
    return area;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {number} Area.
 */
function linearRingss(flatCoordinates, offset, endss, stride) {
    var area = 0;
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        area += linearRings(flatCoordinates, offset, ends, stride);
        offset = ends[ends.length - 1];
    }
    return area;
}
//# sourceMappingURL=area.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInteriorPointOfArray", function() { return getInteriorPointOfArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInteriorPointsOfMultiArray", function() { return getInteriorPointsOfMultiArray; });
/* harmony import */ var _contains_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(191);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52);
/**
 * @module ol/geom/flat/interiorpoint
 */


/**
 * Calculates a point that is likely to lie in the interior of the linear rings.
 * Inspired by JTS's com.vividsolutions.jts.geom.Geometry#getInteriorPoint.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @param {number} flatCentersOffset Flat center offset.
 * @param {Array<number>} [opt_dest] Destination.
 * @return {Array<number>} Destination point as XYM coordinate, where M is the
 * length of the horizontal intersection that the point belongs to.
 */
function getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, flatCentersOffset, opt_dest) {
    var i, ii, x, x1, x2, y1, y2;
    var y = flatCenters[flatCentersOffset + 1];
    /** @type {Array<number>} */
    var intersections = [];
    // Calculate intersections with the horizontal line
    for (var r = 0, rr = ends.length; r < rr; ++r) {
        var end = ends[r];
        x1 = flatCoordinates[end - stride];
        y1 = flatCoordinates[end - stride + 1];
        for (i = offset; i < end; i += stride) {
            x2 = flatCoordinates[i];
            y2 = flatCoordinates[i + 1];
            if ((y <= y1 && y2 <= y) || (y1 <= y && y <= y2)) {
                x = ((y - y1) / (y2 - y1)) * (x2 - x1) + x1;
                intersections.push(x);
            }
            x1 = x2;
            y1 = y2;
        }
    }
    // Find the longest segment of the horizontal line that has its center point
    // inside the linear ring.
    var pointX = NaN;
    var maxSegmentLength = -Infinity;
    intersections.sort(_array_js__WEBPACK_IMPORTED_MODULE_1__["numberSafeCompareFunction"]);
    x1 = intersections[0];
    for (i = 1, ii = intersections.length; i < ii; ++i) {
        x2 = intersections[i];
        var segmentLength = Math.abs(x2 - x1);
        if (segmentLength > maxSegmentLength) {
            x = (x1 + x2) / 2;
            if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_0__["linearRingsContainsXY"])(flatCoordinates, offset, ends, stride, x, y)) {
                pointX = x;
                maxSegmentLength = segmentLength;
            }
        }
        x1 = x2;
    }
    if (isNaN(pointX)) {
        // There is no horizontal line that has its center point inside the linear
        // ring.  Use the center of the the linear ring's extent.
        pointX = flatCenters[flatCentersOffset];
    }
    if (opt_dest) {
        opt_dest.push(pointX, y, maxSegmentLength);
        return opt_dest;
    }
    else {
        return [pointX, y, maxSegmentLength];
    }
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {Array<number>} flatCenters Flat centers.
 * @return {Array<number>} Interior points as XYM coordinates, where M is the
 * length of the horizontal intersection that the point belongs to.
 */
function getInteriorPointsOfMultiArray(flatCoordinates, offset, endss, stride, flatCenters) {
    var interiorPoints = [];
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        interiorPoints = getInteriorPointOfArray(flatCoordinates, offset, ends, stride, flatCenters, 2 * i, interiorPoints);
        offset = ends[ends.length - 1];
    }
    return interiorPoints;
}
//# sourceMappingURL=interiorpoint.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingContainsExtent", function() { return linearRingContainsExtent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingContainsXY", function() { return linearRingContainsXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingsContainsXY", function() { return linearRingsContainsXY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingssContainsXY", function() { return linearRingssContainsXY; });
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/**
 * @module ol/geom/flat/contains
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} Contains extent.
 */
function linearRingContainsExtent(flatCoordinates, offset, end, stride, extent) {
    var outside = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["forEachCorner"])(extent, 
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @return {boolean} Contains (x, y).
     */
    function (coordinate) {
        return !linearRingContainsXY(flatCoordinates, offset, end, stride, coordinate[0], coordinate[1]);
    });
    return !outside;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */
function linearRingContainsXY(flatCoordinates, offset, end, stride, x, y) {
    // https://geomalgorithms.com/a03-_inclusion.html
    // Copyright 2000 softSurfer, 2012 Dan Sunday
    // This code may be freely used and modified for any purpose
    // providing that this copyright notice is included with it.
    // SoftSurfer makes no warranty for this code, and cannot be held
    // liable for any real or imagined damage resulting from its use.
    // Users of this code must verify correctness for their application.
    var wn = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for (; offset < end; offset += stride) {
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        if (y1 <= y) {
            if (y2 > y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) > 0) {
                wn++;
            }
        }
        else if (y2 <= y && (x2 - x1) * (y - y1) - (x - x1) * (y2 - y1) < 0) {
            wn--;
        }
        x1 = x2;
        y1 = y2;
    }
    return wn !== 0;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */
function linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y) {
    if (ends.length === 0) {
        return false;
    }
    if (!linearRingContainsXY(flatCoordinates, offset, ends[0], stride, x, y)) {
        return false;
    }
    for (var i = 1, ii = ends.length; i < ii; ++i) {
        if (linearRingContainsXY(flatCoordinates, ends[i - 1], ends[i], stride, x, y)) {
            return false;
        }
    }
    return true;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {number} x X.
 * @param {number} y Y.
 * @return {boolean} Contains (x, y).
 */
function linearRingssContainsXY(flatCoordinates, offset, endss, stride, x, y) {
    if (endss.length === 0) {
        return false;
    }
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        if (linearRingsContainsXY(flatCoordinates, offset, ends, stride, x, y)) {
            return true;
        }
        offset = ends[ends.length - 1];
    }
    return false;
}
//# sourceMappingURL=contains.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsLineString", function() { return intersectsLineString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsLineStringArray", function() { return intersectsLineStringArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsLinearRing", function() { return intersectsLinearRing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsLinearRingArray", function() { return intersectsLinearRingArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersectsLinearRingMultiArray", function() { return intersectsLinearRingMultiArray; });
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/* harmony import */ var _segments_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193);
/* harmony import */ var _contains_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(191);
/**
 * @module ol/geom/flat/intersectsextent
 */



/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLineString(flatCoordinates, offset, end, stride, extent) {
    var coordinatesExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["extendFlatCoordinates"])(Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["createEmpty"])(), flatCoordinates, offset, end, stride);
    if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["intersects"])(extent, coordinatesExtent)) {
        return false;
    }
    if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["containsExtent"])(extent, coordinatesExtent)) {
        return true;
    }
    if (coordinatesExtent[0] >= extent[0] && coordinatesExtent[2] <= extent[2]) {
        return true;
    }
    if (coordinatesExtent[1] >= extent[1] && coordinatesExtent[3] <= extent[3]) {
        return true;
    }
    return Object(_segments_js__WEBPACK_IMPORTED_MODULE_1__["forEach"])(flatCoordinates, offset, end, stride, 
    /**
     * @param {import("../../coordinate.js").Coordinate} point1 Start point.
     * @param {import("../../coordinate.js").Coordinate} point2 End point.
     * @return {boolean} `true` if the segment and the extent intersect,
     *     `false` otherwise.
     */
    function (point1, point2) {
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["intersectsSegment"])(extent, point1, point2);
    });
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLineStringArray(flatCoordinates, offset, ends, stride, extent) {
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        if (intersectsLineString(flatCoordinates, offset, ends[i], stride, extent)) {
            return true;
        }
        offset = ends[i];
    }
    return false;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLinearRing(flatCoordinates, offset, end, stride, extent) {
    if (intersectsLineString(flatCoordinates, offset, end, stride, extent)) {
        return true;
    }
    if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_2__["linearRingContainsXY"])(flatCoordinates, offset, end, stride, extent[0], extent[1])) {
        return true;
    }
    if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_2__["linearRingContainsXY"])(flatCoordinates, offset, end, stride, extent[0], extent[3])) {
        return true;
    }
    if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_2__["linearRingContainsXY"])(flatCoordinates, offset, end, stride, extent[2], extent[1])) {
        return true;
    }
    if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_2__["linearRingContainsXY"])(flatCoordinates, offset, end, stride, extent[2], extent[3])) {
        return true;
    }
    return false;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent) {
    if (!intersectsLinearRing(flatCoordinates, offset, ends[0], stride, extent)) {
        return false;
    }
    if (ends.length === 1) {
        return true;
    }
    for (var i = 1, ii = ends.length; i < ii; ++i) {
        if (Object(_contains_js__WEBPACK_IMPORTED_MODULE_2__["linearRingContainsExtent"])(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
            if (!intersectsLineString(flatCoordinates, ends[i - 1], ends[i], stride, extent)) {
                return false;
            }
        }
    }
    return true;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @return {boolean} True if the geometry and the extent intersect.
 */
function intersectsLinearRingMultiArray(flatCoordinates, offset, endss, stride, extent) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        if (intersectsLinearRingArray(flatCoordinates, offset, ends, stride, extent)) {
            return true;
        }
        offset = ends[ends.length - 1];
    }
    return false;
}
//# sourceMappingURL=intersectsextent.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forEach", function() { return forEach; });
/**
 * @module ol/geom/flat/segments
 */
/**
 * This function calls `callback` for each segment of the flat coordinates
 * array. If the callback returns a truthy value the function returns that
 * value immediately. Otherwise the function returns `false`.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {function(import("../../coordinate.js").Coordinate, import("../../coordinate.js").Coordinate): T} callback Function
 *     called for each segment.
 * @return {T|boolean} Value.
 * @template T
 */
function forEach(flatCoordinates, offset, end, stride, callback) {
    var point1 = [flatCoordinates[offset], flatCoordinates[offset + 1]];
    var point2 = [];
    var ret;
    for (; offset + stride < end; offset += stride) {
        point2[0] = flatCoordinates[offset + stride];
        point2[1] = flatCoordinates[offset + stride + 1];
        ret = callback(point1, point2);
        if (ret) {
            return ret;
        }
        point1[0] = point2[0];
        point1[1] = point2[1];
    }
    return false;
}
//# sourceMappingURL=segments.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingIsClockwise", function() { return linearRingIsClockwise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingsAreOriented", function() { return linearRingsAreOriented; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingssAreOriented", function() { return linearRingssAreOriented; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orientLinearRings", function() { return orientLinearRings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orientLinearRingsArray", function() { return orientLinearRingsArray; });
/* harmony import */ var _reverse_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(195);
/**
 * @module ol/geom/flat/orient
 */

/**
 * Is the linear ring oriented clockwise in a coordinate system with a bottom-left
 * coordinate origin? For a coordinate system with a top-left coordinate origin,
 * the ring's orientation is clockwise when this function returns false.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {boolean} Is clockwise.
 */
function linearRingIsClockwise(flatCoordinates, offset, end, stride) {
    // https://stackoverflow.com/q/1165647/clockwise-method#1165943
    // https://github.com/OSGeo/gdal/blob/master/gdal/ogr/ogrlinearring.cpp
    var edge = 0;
    var x1 = flatCoordinates[end - stride];
    var y1 = flatCoordinates[end - stride + 1];
    for (; offset < end; offset += stride) {
        var x2 = flatCoordinates[offset];
        var y2 = flatCoordinates[offset + 1];
        edge += (x2 - x1) * (y2 + y1);
        x1 = x2;
        y1 = y2;
    }
    return edge === 0 ? undefined : edge > 0;
}
/**
 * Determines if linear rings are oriented.  By default, left-hand orientation
 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
 * To test for right-hand orientation, use the `opt_right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [opt_right] Test for right-hand orientation
 *     (counter-clockwise exterior ring and clockwise interior rings).
 * @return {boolean} Rings are correctly oriented.
 */
function linearRingsAreOriented(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        var isClockwise = linearRingIsClockwise(flatCoordinates, offset, end, stride);
        if (i === 0) {
            if ((right && isClockwise) || (!right && !isClockwise)) {
                return false;
            }
        }
        else {
            if ((right && !isClockwise) || (!right && isClockwise)) {
                return false;
            }
        }
        offset = end;
    }
    return true;
}
/**
 * Determines if linear rings are oriented.  By default, left-hand orientation
 * is tested (first ring must be clockwise, remaining rings counter-clockwise).
 * To test for right-hand orientation, use the `opt_right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Array of array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [opt_right] Test for right-hand orientation
 *     (counter-clockwise exterior ring and clockwise interior rings).
 * @return {boolean} Rings are correctly oriented.
 */
function linearRingssAreOriented(flatCoordinates, offset, endss, stride, opt_right) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        if (!linearRingsAreOriented(flatCoordinates, offset, ends, stride, opt_right)) {
            return false;
        }
        if (ends.length) {
            offset = ends[ends.length - 1];
        }
    }
    return true;
}
/**
 * Orient coordinates in a flat array of linear rings.  By default, rings
 * are oriented following the left-hand rule (clockwise for exterior and
 * counter-clockwise for interior rings).  To orient according to the
 * right-hand rule, use the `opt_right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {boolean} [opt_right] Follow the right-hand rule for orientation.
 * @return {number} End.
 */
function orientLinearRings(flatCoordinates, offset, ends, stride, opt_right) {
    var right = opt_right !== undefined ? opt_right : false;
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        var isClockwise = linearRingIsClockwise(flatCoordinates, offset, end, stride);
        var reverse = i === 0
            ? (right && isClockwise) || (!right && !isClockwise)
            : (right && !isClockwise) || (!right && isClockwise);
        if (reverse) {
            Object(_reverse_js__WEBPACK_IMPORTED_MODULE_0__["coordinates"])(flatCoordinates, offset, end, stride);
        }
        offset = end;
    }
    return offset;
}
/**
 * Orient coordinates in a flat array of linear rings.  By default, rings
 * are oriented following the left-hand rule (clockwise for exterior and
 * counter-clockwise for interior rings).  To orient according to the
 * right-hand rule, use the `opt_right` argument.
 *
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Array of array of end indexes.
 * @param {number} stride Stride.
 * @param {boolean} [opt_right] Follow the right-hand rule for orientation.
 * @return {number} End.
 */
function orientLinearRingsArray(flatCoordinates, offset, endss, stride, opt_right) {
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        offset = orientLinearRings(flatCoordinates, offset, endss[i], stride, opt_right);
    }
    return offset;
}
//# sourceMappingURL=orient.js.map

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "coordinates", function() { return coordinates; });
/**
 * @module ol/geom/flat/reverse
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 */
function coordinates(flatCoordinates, offset, end, stride) {
    while (offset < end - stride) {
        for (var i = 0; i < stride; ++i) {
            var tmp = flatCoordinates[offset + i];
            flatCoordinates[offset + i] = flatCoordinates[end - stride + i];
            flatCoordinates[end - stride + i] = tmp;
        }
        offset += stride;
        end -= stride;
    }
}
//# sourceMappingURL=reverse.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Units", function() { return Units; });
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/ScaleLine
 */





/**
 * @type {string}
 */
var UNITS_PROP = 'units';
/**
 * Units for the scale line. Supported values are `'degrees'`, `'imperial'`,
 * `'nautical'`, `'metric'`, `'us'`.
 * @enum {string}
 */
var Units = {
    DEGREES: 'degrees',
    IMPERIAL: 'imperial',
    NAUTICAL: 'nautical',
    METRIC: 'metric',
    US: 'us',
};
/**
 * @const
 * @type {Array<number>}
 */
var LEADING_DIGITS = [1, 2, 5];
/**
 * @const
 * @type {number}
 */
var DEFAULT_DPI = 25.4 / 0.28;
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:units', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types
 *     |'change:units', Return>} ScaleLineOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-scale-line'] CSS Class name.
 * @property {number} [minWidth=64] Minimum width in pixels at the OGC default dpi. The width will be
 * adjusted to match the dpi used.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {import("./ScaleLine.js").Units|string} [units='metric'] Units.
 * @property {boolean} [bar=false] Render scalebars instead of a line.
 * @property {number} [steps=4] Number of steps the scalebar should use. Use even numbers
 * for best results. Only applies when `bar` is `true`.
 * @property {boolean} [text=false] Render the text scale above of the scalebar. Only applies
 * when `bar` is `true`.
 * @property {number|undefined} [dpi=undefined] dpi of output device such as printer. Only applies
 * when `bar` is `true`. If undefined the OGC default screen pixel size of 0.28mm will be assumed.
 */
/**
 * @classdesc
 * A control displaying rough y-axis distances, calculated for the center of the
 * viewport. For conformal projections (e.g. EPSG:3857, the default view
 * projection in OpenLayers), the scale is valid for all directions.
 * No scale line will be shown when the y-axis distance of a pixel at the
 * viewport center cannot be calculated in the view projection.
 * By default the scale line will show in the bottom left portion of the map,
 * but this can be changed by using the css selector `.ol-scale-line`.
 * When specifying `bar` as `true`, a scalebar will be rendered instead
 * of a scaleline.
 *
 * @api
 */
var ScaleLine = /** @class */ (function (_super) {
    __extends(ScaleLine, _super);
    /**
     * @param {Options} [opt_options] Scale line options.
     */
    function ScaleLine(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var className = options.className !== undefined
            ? options.className
            : options.bar
                ? 'ol-scale-bar'
                : 'ol-scale-line';
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
            target: options.target,
        }) || this;
        /***
         * @type {ScaleLineOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ScaleLineOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ScaleLineOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.innerElement_ = document.createElement('div');
        _this.innerElement_.className = className + '-inner';
        _this.element.className = className + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"];
        _this.element.appendChild(_this.innerElement_);
        /**
         * @private
         * @type {?import("../View.js").State}
         */
        _this.viewState_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.minWidth_ = options.minWidth !== undefined ? options.minWidth : 64;
        /**
         * @private
         * @type {boolean}
         */
        _this.renderedVisible_ = false;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.renderedWidth_ = undefined;
        /**
         * @private
         * @type {string}
         */
        _this.renderedHTML_ = '';
        _this.addChangeListener(UNITS_PROP, _this.handleUnitsChanged_);
        _this.setUnits(options.units || Units.METRIC);
        /**
         * @private
         * @type {boolean}
         */
        _this.scaleBar_ = options.bar || false;
        /**
         * @private
         * @type {number}
         */
        _this.scaleBarSteps_ = options.steps || 4;
        /**
         * @private
         * @type {boolean}
         */
        _this.scaleBarText_ = options.text || false;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.dpi_ = options.dpi || undefined;
        return _this;
    }
    /**
     * Return the units to use in the scale line.
     * @return {import("./ScaleLine.js").Units} The units
     * to use in the scale line.
     * @observable
     * @api
     */
    ScaleLine.prototype.getUnits = function () {
        return this.get(UNITS_PROP);
    };
    /**
     * @private
     */
    ScaleLine.prototype.handleUnitsChanged_ = function () {
        this.updateElement_();
    };
    /**
     * Set the units to use in the scale line.
     * @param {import("./ScaleLine.js").Units} units The units to use in the scale line.
     * @observable
     * @api
     */
    ScaleLine.prototype.setUnits = function (units) {
        this.set(UNITS_PROP, units);
    };
    /**
     * Specify the dpi of output device such as printer.
     * @param {number|undefined} dpi The dpi of output device.
     * @api
     */
    ScaleLine.prototype.setDpi = function (dpi) {
        this.dpi_ = dpi;
    };
    /**
     * @private
     */
    ScaleLine.prototype.updateElement_ = function () {
        var viewState = this.viewState_;
        if (!viewState) {
            if (this.renderedVisible_) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
            }
            return;
        }
        var center = viewState.center;
        var projection = viewState.projection;
        var units = this.getUnits();
        var pointResolutionUnits = units == Units.DEGREES ? _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES : _proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].METERS;
        var pointResolution = Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["getPointResolution"])(projection, viewState.resolution, center, pointResolutionUnits);
        var minWidth = (this.minWidth_ * (this.dpi_ || DEFAULT_DPI)) / DEFAULT_DPI;
        var nominalCount = minWidth * pointResolution;
        var suffix = '';
        if (units == Units.DEGREES) {
            var metersPerDegree = _proj_js__WEBPACK_IMPORTED_MODULE_3__["METERS_PER_UNIT"][_proj_Units_js__WEBPACK_IMPORTED_MODULE_1__["default"].DEGREES];
            nominalCount *= metersPerDegree;
            if (nominalCount < metersPerDegree / 60) {
                suffix = '\u2033'; // seconds
                pointResolution *= 3600;
            }
            else if (nominalCount < metersPerDegree) {
                suffix = '\u2032'; // minutes
                pointResolution *= 60;
            }
            else {
                suffix = '\u00b0'; // degrees
            }
        }
        else if (units == Units.IMPERIAL) {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution /= 0.0254;
            }
            else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.3048;
            }
            else {
                suffix = 'mi';
                pointResolution /= 1609.344;
            }
        }
        else if (units == Units.NAUTICAL) {
            pointResolution /= 1852;
            suffix = 'nm';
        }
        else if (units == Units.METRIC) {
            if (nominalCount < 0.001) {
                suffix = 'μm';
                pointResolution *= 1000000;
            }
            else if (nominalCount < 1) {
                suffix = 'mm';
                pointResolution *= 1000;
            }
            else if (nominalCount < 1000) {
                suffix = 'm';
            }
            else {
                suffix = 'km';
                pointResolution /= 1000;
            }
        }
        else if (units == Units.US) {
            if (nominalCount < 0.9144) {
                suffix = 'in';
                pointResolution *= 39.37;
            }
            else if (nominalCount < 1609.344) {
                suffix = 'ft';
                pointResolution /= 0.30480061;
            }
            else {
                suffix = 'mi';
                pointResolution /= 1609.3472;
            }
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(false, 33); // Invalid units
        }
        var i = 3 * Math.floor(Math.log(minWidth * pointResolution) / Math.log(10));
        var count, width, decimalCount;
        while (true) {
            decimalCount = Math.floor(i / 3);
            var decimal = Math.pow(10, decimalCount);
            count = LEADING_DIGITS[((i % 3) + 3) % 3] * decimal;
            width = Math.round(count / pointResolution);
            if (isNaN(width)) {
                this.element.style.display = 'none';
                this.renderedVisible_ = false;
                return;
            }
            else if (width >= minWidth) {
                break;
            }
            ++i;
        }
        var html;
        if (this.scaleBar_) {
            html = this.createScaleBar(width, count, suffix);
        }
        else {
            html = count.toFixed(decimalCount < 0 ? -decimalCount : 0) + ' ' + suffix;
        }
        if (this.renderedHTML_ != html) {
            this.innerElement_.innerHTML = html;
            this.renderedHTML_ = html;
        }
        if (this.renderedWidth_ != width) {
            this.innerElement_.style.width = width + 'px';
            this.renderedWidth_ = width;
        }
        if (!this.renderedVisible_) {
            this.element.style.display = '';
            this.renderedVisible_ = true;
        }
    };
    /**
     * @private
     * @param {number} width The current width of the scalebar.
     * @param {number} scale The current scale.
     * @param {string} suffix The suffix to append to the scale text.
     * @return {string} The stringified HTML of the scalebar.
     */
    ScaleLine.prototype.createScaleBar = function (width, scale, suffix) {
        var mapScale = '1 : ' + Math.round(this.getScaleForResolution()).toLocaleString();
        var scaleSteps = [];
        var stepWidth = width / this.scaleBarSteps_;
        var backgroundColor = '#ffffff';
        for (var i = 0; i < this.scaleBarSteps_; i++) {
            if (i === 0) {
                // create the first marker at position 0
                scaleSteps.push(this.createMarker('absolute', i));
            }
            scaleSteps.push('<div>' +
                '<div ' +
                'class="ol-scale-singlebar" ' +
                'style=' +
                '"width: ' +
                stepWidth +
                'px;' +
                'background-color: ' +
                backgroundColor +
                ';"' +
                '>' +
                '</div>' +
                this.createMarker('relative', i) +
                /*render text every second step, except when only 2 steps */
                (i % 2 === 0 || this.scaleBarSteps_ === 2
                    ? this.createStepText(i, width, false, scale, suffix)
                    : '') +
                '</div>');
            if (i === this.scaleBarSteps_ - 1) {
                {
                    /*render text at the end */
                }
                scaleSteps.push(this.createStepText(i + 1, width, true, scale, suffix));
            }
            // switch colors of steps between black and white
            if (backgroundColor === '#ffffff') {
                backgroundColor = '#000000';
            }
            else {
                backgroundColor = '#ffffff';
            }
        }
        var scaleBarText;
        if (this.scaleBarText_) {
            scaleBarText =
                '<div ' +
                    'class="ol-scale-text" ' +
                    'style="width: ' +
                    width +
                    'px;">' +
                    mapScale +
                    '</div>';
        }
        else {
            scaleBarText = '';
        }
        var container = '<div ' +
            'style="display: flex;">' +
            scaleBarText +
            scaleSteps.join('') +
            '</div>';
        return container;
    };
    /**
     * Creates a marker at given position
     * @param {string} position The position, absolute or relative
     * @param {number} i The iterator
     * @return {string} The stringified div containing the marker
     */
    ScaleLine.prototype.createMarker = function (position, i) {
        var top = position === 'absolute' ? 3 : -10;
        return ('<div ' +
            'class="ol-scale-step-marker" ' +
            'style="position: ' +
            position +
            ';' +
            'top: ' +
            top +
            'px;"' +
            '></div>');
    };
    /**
     * Creates the label for a marker marker at given position
     * @param {number} i The iterator
     * @param {number} width The width the scalebar will currently use
     * @param {boolean} isLast Flag indicating if we add the last step text
     * @param {number} scale The current scale for the whole scalebar
     * @param {string} suffix The suffix for the scale
     * @return {string} The stringified div containing the step text
     */
    ScaleLine.prototype.createStepText = function (i, width, isLast, scale, suffix) {
        var length = i === 0 ? 0 : Math.round((scale / this.scaleBarSteps_) * i * 100) / 100;
        var lengthString = length + (i === 0 ? '' : ' ' + suffix);
        var margin = i === 0 ? -3 : (width / this.scaleBarSteps_) * -1;
        var minWidth = i === 0 ? 0 : (width / this.scaleBarSteps_) * 2;
        return ('<div ' +
            'class="ol-scale-step-text" ' +
            'style="' +
            'margin-left: ' +
            margin +
            'px;' +
            'text-align: ' +
            (i === 0 ? 'left' : 'center') +
            '; ' +
            'min-width: ' +
            minWidth +
            'px;' +
            'left: ' +
            (isLast ? width + 'px' : 'unset') +
            ';"' +
            '>' +
            lengthString +
            '</div>');
    };
    /**
     * Returns the appropriate scale for the given resolution and units.
     * @return {number} The appropriate scale.
     */
    ScaleLine.prototype.getScaleForResolution = function () {
        var resolution = Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["getPointResolution"])(this.viewState_.projection, this.viewState_.resolution, this.viewState_.center);
        var dpi = this.dpi_ || DEFAULT_DPI;
        var mpu = this.viewState_.projection.getMetersPerUnit();
        var inchesPerMeter = 1000 / 25.4;
        return parseFloat(resolution.toString()) * mpu * inchesPerMeter * dpi;
    };
    /**
     * Update the scale line element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    ScaleLine.prototype.render = function (mapEvent) {
        var frameState = mapEvent.frameState;
        if (!frameState) {
            this.viewState_ = null;
        }
        else {
            this.viewState_ = frameState.viewState;
        }
        this.updateElement_();
    };
    return ScaleLine;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ScaleLine);
//# sourceMappingURL=ScaleLine.js.map

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(166);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46);
/**
 * @module ol/control/ZoomSlider
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();








/**
 * The enum for available directions.
 *
 * @enum {number}
 */
var Direction = {
    VERTICAL: 0,
    HORIZONTAL: 1,
};
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-zoomslider'] CSS class name.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {function(import("../MapEvent.js").default):void} [render] Function called when the control
 * should be re-rendered. This is called in a `requestAnimationFrame` callback.
 */
/**
 * @classdesc
 * A slider type of control for zooming.
 *
 * Example:
 *
 *     map.addControl(new ZoomSlider());
 *
 * @api
 */
var ZoomSlider = /** @class */ (function (_super) {
    __extends(ZoomSlider, _super);
    /**
     * @param {Options} [opt_options] Zoom slider options.
     */
    function ZoomSlider(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            render: options.render,
        }) || this;
        /**
         * @type {!Array<import("../events.js").EventsKey>}
         * @private
         */
        _this.dragListenerKeys_ = [];
        /**
         * Will hold the current resolution of the view.
         *
         * @type {number|undefined}
         * @private
         */
        _this.currentResolution_ = undefined;
        /**
         * The direction of the slider. Will be determined from actual display of the
         * container and defaults to Direction.VERTICAL.
         *
         * @type {Direction}
         * @private
         */
        _this.direction_ = Direction.VERTICAL;
        /**
         * @type {boolean}
         * @private
         */
        _this.dragging_;
        /**
         * @type {number}
         * @private
         */
        _this.heightLimit_ = 0;
        /**
         * @type {number}
         * @private
         */
        _this.widthLimit_ = 0;
        /**
         * @type {number|undefined}
         * @private
         */
        _this.startX_;
        /**
         * @type {number|undefined}
         * @private
         */
        _this.startY_;
        /**
         * The calculated thumb size (border box plus margins).  Set when initSlider_
         * is called.
         * @type {import("../size.js").Size}
         * @private
         */
        _this.thumbSize_ = null;
        /**
         * Whether the slider is initialized.
         * @type {boolean}
         * @private
         */
        _this.sliderInitialized_ = false;
        /**
         * @type {number}
         * @private
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 200;
        var className = options.className !== undefined ? options.className : 'ol-zoomslider';
        var thumbElement = document.createElement('button');
        thumbElement.setAttribute('type', 'button');
        thumbElement.className = className + '-thumb ' + _css_js__WEBPACK_IMPORTED_MODULE_3__["CLASS_UNSELECTABLE"];
        var containerElement = _this.element;
        containerElement.className =
            className + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_3__["CLASS_UNSELECTABLE"] + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_3__["CLASS_CONTROL"];
        containerElement.appendChild(thumbElement);
        containerElement.addEventListener(_pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERDOWN, _this.handleDraggerStart_.bind(_this), false);
        containerElement.addEventListener(_pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERMOVE, _this.handleDraggerDrag_.bind(_this), false);
        containerElement.addEventListener(_pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP, _this.handleDraggerEnd_.bind(_this), false);
        containerElement.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleContainerClick_.bind(_this), false);
        thumbElement.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _events_Event_js__WEBPACK_IMPORTED_MODULE_7__["stopPropagation"], false);
        return _this;
    }
    /**
     * Remove the control from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    ZoomSlider.prototype.setMap = function (map) {
        _super.prototype.setMap.call(this, map);
        if (map) {
            map.render();
        }
    };
    /**
     * Initializes the slider element. This will determine and set this controls
     * direction_ and also constrain the dragging of the thumb to always be within
     * the bounds of the container.
     *
     * @return {boolean} Initialization successful
     * @private
     */
    ZoomSlider.prototype.initSlider_ = function () {
        var container = this.element;
        var containerWidth = container.offsetWidth;
        var containerHeight = container.offsetHeight;
        if (containerWidth === 0 && containerHeight === 0) {
            return (this.sliderInitialized_ = false);
        }
        var containerStyle = getComputedStyle(container);
        containerWidth -=
            parseFloat(containerStyle['paddingRight']) +
                parseFloat(containerStyle['paddingLeft']);
        containerHeight -=
            parseFloat(containerStyle['paddingTop']) +
                parseFloat(containerStyle['paddingBottom']);
        var thumb = /** @type {HTMLElement} */ (container.firstElementChild);
        var thumbStyle = getComputedStyle(thumb);
        var thumbWidth = thumb.offsetWidth +
            parseFloat(thumbStyle['marginRight']) +
            parseFloat(thumbStyle['marginLeft']);
        var thumbHeight = thumb.offsetHeight +
            parseFloat(thumbStyle['marginTop']) +
            parseFloat(thumbStyle['marginBottom']);
        this.thumbSize_ = [thumbWidth, thumbHeight];
        if (containerWidth > containerHeight) {
            this.direction_ = Direction.HORIZONTAL;
            this.widthLimit_ = containerWidth - thumbWidth;
        }
        else {
            this.direction_ = Direction.VERTICAL;
            this.heightLimit_ = containerHeight - thumbHeight;
        }
        return (this.sliderInitialized_ = true);
    };
    /**
     * @param {PointerEvent} event The browser event to handle.
     * @private
     */
    ZoomSlider.prototype.handleContainerClick_ = function (event) {
        var view = this.getMap().getView();
        var relativePosition = this.getRelativePosition_(event.offsetX - this.thumbSize_[0] / 2, event.offsetY - this.thumbSize_[1] / 2);
        var resolution = this.getResolutionForPosition_(relativePosition);
        var zoom = view.getConstrainedZoom(view.getZoomForResolution(resolution));
        view.animateInternal({
            zoom: zoom,
            duration: this.duration_,
            easing: _easing_js__WEBPACK_IMPORTED_MODULE_5__["easeOut"],
        });
    };
    /**
     * Handle dragger start events.
     * @param {PointerEvent} event The drag event.
     * @private
     */
    ZoomSlider.prototype.handleDraggerStart_ = function (event) {
        if (!this.dragging_ && event.target === this.element.firstElementChild) {
            var element = /** @type {HTMLElement} */ (this.element.firstElementChild);
            this.getMap().getView().beginInteraction();
            this.startX_ = event.clientX - parseFloat(element.style.left);
            this.startY_ = event.clientY - parseFloat(element.style.top);
            this.dragging_ = true;
            if (this.dragListenerKeys_.length === 0) {
                var drag = this.handleDraggerDrag_;
                var end = this.handleDraggerEnd_;
                var doc = this.getMap().getOwnerDocument();
                this.dragListenerKeys_.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(doc, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERMOVE, drag, this), Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(doc, _pointer_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINTERUP, end, this));
            }
        }
    };
    /**
     * Handle dragger drag events.
     *
     * @param {PointerEvent} event The drag event.
     * @private
     */
    ZoomSlider.prototype.handleDraggerDrag_ = function (event) {
        if (this.dragging_) {
            var deltaX = event.clientX - this.startX_;
            var deltaY = event.clientY - this.startY_;
            var relativePosition = this.getRelativePosition_(deltaX, deltaY);
            this.currentResolution_ =
                this.getResolutionForPosition_(relativePosition);
            this.getMap().getView().setResolution(this.currentResolution_);
        }
    };
    /**
     * Handle dragger end events.
     * @param {PointerEvent} event The drag event.
     * @private
     */
    ZoomSlider.prototype.handleDraggerEnd_ = function (event) {
        if (this.dragging_) {
            var view = this.getMap().getView();
            view.endInteraction();
            this.dragging_ = false;
            this.startX_ = undefined;
            this.startY_ = undefined;
            this.dragListenerKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_6__["unlistenByKey"]);
            this.dragListenerKeys_.length = 0;
        }
    };
    /**
     * Positions the thumb inside its container according to the given resolution.
     *
     * @param {number} res The res.
     * @private
     */
    ZoomSlider.prototype.setThumbPosition_ = function (res) {
        var position = this.getPositionForResolution_(res);
        var thumb = /** @type {HTMLElement} */ (this.element.firstElementChild);
        if (this.direction_ == Direction.HORIZONTAL) {
            thumb.style.left = this.widthLimit_ * position + 'px';
        }
        else {
            thumb.style.top = this.heightLimit_ * position + 'px';
        }
    };
    /**
     * Calculates the relative position of the thumb given x and y offsets.  The
     * relative position scales from 0 to 1.  The x and y offsets are assumed to be
     * in pixel units within the dragger limits.
     *
     * @param {number} x Pixel position relative to the left of the slider.
     * @param {number} y Pixel position relative to the top of the slider.
     * @return {number} The relative position of the thumb.
     * @private
     */
    ZoomSlider.prototype.getRelativePosition_ = function (x, y) {
        var amount;
        if (this.direction_ === Direction.HORIZONTAL) {
            amount = x / this.widthLimit_;
        }
        else {
            amount = y / this.heightLimit_;
        }
        return Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["clamp"])(amount, 0, 1);
    };
    /**
     * Calculates the corresponding resolution of the thumb given its relative
     * position (where 0 is the minimum and 1 is the maximum).
     *
     * @param {number} position The relative position of the thumb.
     * @return {number} The corresponding resolution.
     * @private
     */
    ZoomSlider.prototype.getResolutionForPosition_ = function (position) {
        var fn = this.getMap().getView().getResolutionForValueFunction();
        return fn(1 - position);
    };
    /**
     * Determines the relative position of the slider for the given resolution.  A
     * relative position of 0 corresponds to the minimum view resolution.  A
     * relative position of 1 corresponds to the maximum view resolution.
     *
     * @param {number} res The resolution.
     * @return {number} The relative position value (between 0 and 1).
     * @private
     */
    ZoomSlider.prototype.getPositionForResolution_ = function (res) {
        var fn = this.getMap().getView().getValueForResolutionFunction();
        return Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["clamp"])(1 - fn(res), 0, 1);
    };
    /**
     * Update the zoomslider element.
     * @param {import("../MapEvent.js").default} mapEvent Map event.
     * @override
     */
    ZoomSlider.prototype.render = function (mapEvent) {
        if (!mapEvent.frameState) {
            return;
        }
        if (!this.sliderInitialized_ && !this.initSlider_()) {
            return;
        }
        var res = mapEvent.frameState.viewState.resolution;
        this.currentResolution_ = res;
        this.setThumbPosition_(res);
    };
    return ZoomSlider;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ZoomSlider);
//# sourceMappingURL=ZoomSlider.js.map

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Control_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _css_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(184);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/control/ZoomToExtent
 */




/**
 * @typedef {Object} Options
 * @property {string} [className='ol-zoom-extent'] Class name.
 * @property {HTMLElement|string} [target] Specify a target if you want the control
 * to be rendered outside of the map's viewport.
 * @property {string|HTMLElement} [label='E'] Text label to use for the button.
 * Instead of text, also an element (e.g. a `span` element) can be used.
 * @property {string} [tipLabel='Fit to extent'] Text label to use for the button tip.
 * @property {import("../extent.js").Extent} [extent] The extent to zoom to. If undefined the validity
 * extent of the view projection is used.
 */
/**
 * @classdesc
 * A button control which, when pressed, changes the map view to a specific
 * extent. To style this control use the css selector `.ol-zoom-extent`.
 *
 * @api
 */
var ZoomToExtent = /** @class */ (function (_super) {
    __extends(ZoomToExtent, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function ZoomToExtent(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            element: document.createElement('div'),
            target: options.target,
        }) || this;
        /**
         * @type {?import("../extent.js").Extent}
         * @protected
         */
        _this.extent = options.extent ? options.extent : null;
        var className = options.className !== undefined ? options.className : 'ol-zoom-extent';
        var label = options.label !== undefined ? options.label : 'E';
        var tipLabel = options.tipLabel !== undefined ? options.tipLabel : 'Fit to extent';
        var button = document.createElement('button');
        button.setAttribute('type', 'button');
        button.title = tipLabel;
        button.appendChild(typeof label === 'string' ? document.createTextNode(label) : label);
        button.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CLICK, _this.handleClick_.bind(_this), false);
        var cssClasses = className + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_UNSELECTABLE"] + ' ' + _css_js__WEBPACK_IMPORTED_MODULE_2__["CLASS_CONTROL"];
        var element = _this.element;
        element.className = cssClasses;
        element.appendChild(button);
        return _this;
    }
    /**
     * @param {MouseEvent} event The event to handle
     * @private
     */
    ZoomToExtent.prototype.handleClick_ = function (event) {
        event.preventDefault();
        this.handleZoomToExtent();
    };
    /**
     * @protected
     */
    ZoomToExtent.prototype.handleZoomToExtent = function () {
        var map = this.getMap();
        var view = map.getView();
        var extent = !this.extent
            ? view.getProjection().getExtent()
            : this.extent;
        view.fitInternal(Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_3__["fromExtent"])(extent));
    };
    return ZoomToExtent;
}(_Control_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ZoomToExtent);
//# sourceMappingURL=ZoomToExtent.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _format_EsriJSON_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(200);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EsriJSON", function() { return _format_EsriJSON_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _format_GeoJSON_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(210);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GeoJSON", function() { return _format_GeoJSON_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _format_GML_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GML", function() { return _format_GML_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _format_GPX_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(219);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GPX", function() { return _format_GPX_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _format_IGC_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(220);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IGC", function() { return _format_IGC_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(116);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IIIFInfo", function() { return _format_IIIFInfo_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _format_KML_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(222);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KML", function() { return _format_KML_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _format_MVT_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(223);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MVT", function() { return _format_MVT_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _format_OWS_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(227);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OWS", function() { return _format_OWS_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _format_Polyline_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(230);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Polyline", function() { return _format_Polyline_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _format_TopoJSON_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(232);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TopoJSON", function() { return _format_TopoJSON_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _format_WFS_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(233);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WFS", function() { return _format_WFS_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _format_WKT_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(261);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WKT", function() { return _format_WKT_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony import */ var _format_WMSCapabilities_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(262);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WMSCapabilities", function() { return _format_WMSCapabilities_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var _format_WMSGetFeatureInfo_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(263);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WMSGetFeatureInfo", function() { return _format_WMSGetFeatureInfo_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _format_WMTSCapabilities_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(264);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WMTSCapabilities", function() { return _format_WMTSCapabilities_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/**
 * @module ol/format
 */
















//# sourceMappingURL=format.js.map

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _JSONFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(201);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony import */ var _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(185);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(184);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(16);
/* harmony import */ var _geom_flat_deflate_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(104);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7);
/* harmony import */ var _geom_flat_orient_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(194);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/EsriJSON
 */


















/**
 * @typedef {import("arcgis-rest-api").Feature} EsriJSONFeature
 * @typedef {import("arcgis-rest-api").FeatureSet} EsriJSONFeatureSet
 * @typedef {import("arcgis-rest-api").Geometry} EsriJSONGeometry
 * @typedef {import("arcgis-rest-api").Point} EsriJSONPoint
 * @typedef {import("arcgis-rest-api").Polyline} EsriJSONPolyline
 * @typedef {import("arcgis-rest-api").Polygon} EsriJSONPolygon
 * @typedef {import("arcgis-rest-api").Multipoint} EsriJSONMultipoint
 * @typedef {import("arcgis-rest-api").HasZM} EsriJSONHasZM
 * @typedef {import("arcgis-rest-api").Position} EsriJSONPosition
 * @typedef {import("arcgis-rest-api").SpatialReferenceWkid} EsriJSONSpatialReferenceWkid
 */
/**
 * @typedef {Object} EsriJSONMultiPolygon
 * @property {Array<Array<Array<Array<number>>>>} rings Rings for the MultiPolygon.
 * @property {boolean} [hasM] If the polygon coordinates have an M value.
 * @property {boolean} [hasZ] If the polygon coordinates have a Z value.
 * @property {EsriJSONSpatialReferenceWkid} [spatialReference] The coordinate reference system.
 */
/**
 * @const
 * @type {Object<import("../geom/GeometryType.js").default, function(EsriJSONGeometry): import("../geom/Geometry.js").default>}
 */
var GEOMETRY_READERS = {};
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT] = readPointGeometry;
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING] = readLineStringGeometry;
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON] = readPolygonGeometry;
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT] = readMultiPointGeometry;
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING] = readMultiLineStringGeometry;
GEOMETRY_READERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON] = readMultiPolygonGeometry;
/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default, import("./Feature.js").WriteOptions=): (EsriJSONGeometry)>}
 */
var GEOMETRY_WRITERS = {};
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT] = writePointGeometry;
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING] = writeLineStringGeometry;
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON] = writePolygonGeometry;
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT] = writeMultiPointGeometry;
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING] = writeMultiLineStringGeometry;
GEOMETRY_WRITERS[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON] = writeMultiPolygonGeometry;
/**
 * @typedef {Object} Options
 * @property {string} [geometryName] Geometry name to use when creating features.
 */
/**
 * @classdesc
 * Feature format for reading and writing data in the EsriJSON format.
 *
 * @api
 */
var EsriJSON = /** @class */ (function (_super) {
    __extends(EsriJSON, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function EsriJSON(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this) || this;
        /**
         * Name of the geometry attribute for features.
         * @type {string|undefined}
         * @private
         */
        _this.geometryName_ = options.geometryName;
        return _this;
    }
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @param {string} [opt_idField] Name of the field where to get the id from.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */
    EsriJSON.prototype.readFeatureFromObject = function (object, opt_options, opt_idField) {
        var esriJSONFeature = /** @type {EsriJSONFeature} */ (object);
        var geometry = readGeometry(esriJSONFeature.geometry, opt_options);
        var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        if (this.geometryName_) {
            feature.setGeometryName(this.geometryName_);
        }
        feature.setGeometry(geometry);
        if (esriJSONFeature.attributes) {
            feature.setProperties(esriJSONFeature.attributes, true);
            var id = esriJSONFeature.attributes[opt_idField];
            if (id !== undefined) {
                feature.setId(/** @type {number} */ (id));
            }
        }
        return feature;
    };
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    EsriJSON.prototype.readFeaturesFromObject = function (object, opt_options) {
        var options = opt_options ? opt_options : {};
        if (object['features']) {
            var esriJSONFeatureSet = /** @type {EsriJSONFeatureSet} */ (object);
            /** @type {Array<import("../Feature.js").default>} */
            var features = [];
            var esriJSONFeatures = esriJSONFeatureSet.features;
            for (var i = 0, ii = esriJSONFeatures.length; i < ii; ++i) {
                features.push(this.readFeatureFromObject(esriJSONFeatures[i], options, object.objectIdFieldName));
            }
            return features;
        }
        else {
            return [this.readFeatureFromObject(object, options)];
        }
    };
    /**
     * @param {EsriJSONGeometry} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    EsriJSON.prototype.readGeometryFromObject = function (object, opt_options) {
        return readGeometry(object, opt_options);
    };
    /**
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    EsriJSON.prototype.readProjectionFromObject = function (object) {
        if (object['spatialReference'] &&
            object['spatialReference']['wkid'] !== undefined) {
            var spatialReference = /** @type {EsriJSONSpatialReferenceWkid} */ (object['spatialReference']);
            var crs = spatialReference.wkid;
            return Object(_proj_js__WEBPACK_IMPORTED_MODULE_15__["get"])('EPSG:' + crs);
        }
        else {
            return null;
        }
    };
    /**
     * Encode a geometry as a EsriJSON object.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {EsriJSONGeometry} Object.
     * @api
     */
    EsriJSON.prototype.writeGeometryObject = function (geometry, opt_options) {
        return writeGeometry(geometry, this.adaptOptions(opt_options));
    };
    /**
     * Encode a feature as a esriJSON Feature object.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     * @api
     */
    EsriJSON.prototype.writeFeatureObject = function (feature, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var object = {};
        if (!feature.hasProperties()) {
            object['attributes'] = {};
            return object;
        }
        var properties = feature.getProperties();
        var geometry = feature.getGeometry();
        if (geometry) {
            object['geometry'] = writeGeometry(geometry, opt_options);
            var projection = opt_options &&
                (opt_options.dataProjection || opt_options.featureProjection);
            if (projection) {
                object['geometry']['spatialReference'] =
                    /** @type {EsriJSONSpatialReferenceWkid} */ ({
                        wkid: Number(Object(_proj_js__WEBPACK_IMPORTED_MODULE_15__["get"])(projection).getCode().split(':').pop()),
                    });
            }
            delete properties[feature.getGeometryName()];
        }
        if (!Object(_obj_js__WEBPACK_IMPORTED_MODULE_12__["isEmpty"])(properties)) {
            object['attributes'] = properties;
        }
        else {
            object['attributes'] = {};
        }
        return object;
    };
    /**
     * Encode an array of features as a EsriJSON object.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {EsriJSONFeatureSet} EsriJSON Object.
     * @api
     */
    EsriJSON.prototype.writeFeaturesObject = function (features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var objects = [];
        for (var i = 0, ii = features.length; i < ii; ++i) {
            objects.push(this.writeFeatureObject(features[i], opt_options));
        }
        return {
            'features': objects,
        };
    };
    return EsriJSON;
}(_JSONFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/**
 * @param {EsriJSONGeometry} object Object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */
function readGeometry(object, opt_options) {
    var _a, _b;
    if (!object) {
        return null;
    }
    /** @type {import("../geom/GeometryType.js").default} */
    var type;
    if (typeof object['x'] === 'number' && typeof object['y'] === 'number') {
        type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT;
    }
    else if (object['points']) {
        type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT;
    }
    else if (object['paths']) {
        var esriJSONPolyline = /** @type {EsriJSONPolyline} */ (object);
        if (esriJSONPolyline.paths.length === 1) {
            type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING;
        }
        else {
            type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING;
        }
    }
    else if (object['rings']) {
        var esriJSONPolygon = /** @type {EsriJSONPolygon} */ (object);
        var layout = getGeometryLayout(esriJSONPolygon);
        var rings = convertRings(esriJSONPolygon.rings, layout);
        if (rings.length === 1) {
            type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON;
            object = Object(_obj_js__WEBPACK_IMPORTED_MODULE_12__["assign"])({}, object, (_a = {}, _a['rings'] = rings[0], _a));
        }
        else {
            type = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON;
            object = Object(_obj_js__WEBPACK_IMPORTED_MODULE_12__["assign"])({}, object, (_b = {}, _b['rings'] = rings, _b));
        }
    }
    var geometryReader = GEOMETRY_READERS[type];
    return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_17__["transformGeometryWithOptions"])(geometryReader(object), false, opt_options);
}
/**
 * Determines inner and outer rings.
 * Checks if any polygons in this array contain any other polygons in this
 * array. It is used for checking for holes.
 * Logic inspired by: https://github.com/Esri/terraformer-arcgis-parser
 * @param {Array<!Array<!Array<number>>>} rings Rings.
 * @param {import("../geom/GeometryLayout.js").default} layout Geometry layout.
 * @return {Array<!Array<!Array<!Array<number>>>>} Transformed rings.
 */
function convertRings(rings, layout) {
    var flatRing = [];
    var outerRings = [];
    var holes = [];
    var i, ii;
    for (i = 0, ii = rings.length; i < ii; ++i) {
        flatRing.length = 0;
        Object(_geom_flat_deflate_js__WEBPACK_IMPORTED_MODULE_14__["deflateCoordinates"])(flatRing, 0, rings[i], layout.length);
        // is this ring an outer ring? is it clockwise?
        var clockwise = Object(_geom_flat_orient_js__WEBPACK_IMPORTED_MODULE_16__["linearRingIsClockwise"])(flatRing, 0, flatRing.length, layout.length);
        if (clockwise) {
            outerRings.push([rings[i]]);
        }
        else {
            holes.push(rings[i]);
        }
    }
    while (holes.length) {
        var hole = holes.shift();
        var matched = false;
        // loop over all outer rings and see if they contain our hole.
        for (i = outerRings.length - 1; i >= 0; i--) {
            var outerRing = outerRings[i][0];
            var containsHole = Object(_extent_js__WEBPACK_IMPORTED_MODULE_13__["containsExtent"])(new _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_5__["default"](outerRing).getExtent(), new _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_5__["default"](hole).getExtent());
            if (containsHole) {
                // the hole is contained push it into our polygon
                outerRings[i].push(hole);
                matched = true;
                break;
            }
        }
        if (!matched) {
            // no outer rings contain this hole turn it into and outer
            // ring (reverse it)
            outerRings.push([hole.reverse()]);
        }
    }
    return outerRings;
}
/**
 * @param {EsriJSONPoint} object Object.
 * @return {import("../geom/Geometry.js").default} Point.
 */
function readPointGeometry(object) {
    var point;
    if (object.m !== undefined && object.z !== undefined) {
        point = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"]([object.x, object.y, object.z, object.m], _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM);
    }
    else if (object.z !== undefined) {
        point = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"]([object.x, object.y, object.z], _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ);
    }
    else if (object.m !== undefined) {
        point = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"]([object.x, object.y, object.m], _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM);
    }
    else {
        point = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"]([object.x, object.y]);
    }
    return point;
}
/**
 * @param {EsriJSONPolyline} object Object.
 * @return {import("../geom/Geometry.js").default} LineString.
 */
function readLineStringGeometry(object) {
    var layout = getGeometryLayout(object);
    return new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](object.paths[0], layout);
}
/**
 * @param {EsriJSONPolyline} object Object.
 * @return {import("../geom/Geometry.js").default} MultiLineString.
 */
function readMultiLineStringGeometry(object) {
    var layout = getGeometryLayout(object);
    return new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_6__["default"](object.paths, layout);
}
/**
 * @param {EsriJSONHasZM} object Object.
 * @return {import("../geom/GeometryLayout.js").default} The geometry layout to use.
 */
function getGeometryLayout(object) {
    var layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
    if (object.hasZ === true && object.hasM === true) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM;
    }
    else if (object.hasZ === true) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ;
    }
    else if (object.hasM === true) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM;
    }
    return layout;
}
/**
 * @param {EsriJSONMultipoint} object Object.
 * @return {import("../geom/Geometry.js").default} MultiPoint.
 */
function readMultiPointGeometry(object) {
    var layout = getGeometryLayout(object);
    return new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_7__["default"](object.points, layout);
}
/**
 * @param {EsriJSONMultiPolygon} object Object.
 * @return {import("../geom/Geometry.js").default} MultiPolygon.
 */
function readMultiPolygonGeometry(object) {
    var layout = getGeometryLayout(object);
    return new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_8__["default"](object.rings, layout);
}
/**
 * @param {EsriJSONPolygon} object Object.
 * @return {import("../geom/Geometry.js").default} Polygon.
 */
function readPolygonGeometry(object) {
    var layout = getGeometryLayout(object);
    return new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_10__["default"](object.rings, layout);
}
/**
 * @param {import("../geom/Point.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONPoint} EsriJSON geometry.
 */
function writePointGeometry(geometry, opt_options) {
    var coordinates = geometry.getCoordinates();
    /** @type {EsriJSONPoint} */
    var esriJSON;
    var layout = geometry.getLayout();
    if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ) {
        esriJSON = {
            x: coordinates[0],
            y: coordinates[1],
            z: coordinates[2],
        };
    }
    else if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM) {
        esriJSON = {
            x: coordinates[0],
            y: coordinates[1],
            m: coordinates[2],
        };
    }
    else if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM) {
        esriJSON = {
            x: coordinates[0],
            y: coordinates[1],
            z: coordinates[2],
            m: coordinates[3],
        };
    }
    else if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY) {
        esriJSON = {
            x: coordinates[0],
            y: coordinates[1],
        };
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_11__["assert"])(false, 34); // Invalid geometry layout
    }
    return esriJSON;
}
/**
 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @return {Object} Object with boolean hasZ and hasM keys.
 */
function getHasZM(geometry) {
    var layout = geometry.getLayout();
    return {
        hasZ: layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ || layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM,
        hasM: layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM || layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM,
    };
}
/**
 * @param {import("../geom/LineString.js").default} lineString Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONPolyline} EsriJSON geometry.
 */
function writeLineStringGeometry(lineString, opt_options) {
    var hasZM = getHasZM(lineString);
    return {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        paths: [
            /** @type {Array<EsriJSONPosition>} */ (lineString.getCoordinates()),
        ],
    };
}
/**
 * @param {import("../geom/Polygon.js").default} polygon Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONPolygon} EsriJSON geometry.
 */
function writePolygonGeometry(polygon, opt_options) {
    // Esri geometries use the left-hand rule
    var hasZM = getHasZM(polygon);
    return {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        rings: /** @type {Array<Array<EsriJSONPosition>>} */ (polygon.getCoordinates(false)),
    };
}
/**
 * @param {import("../geom/MultiLineString.js").default} multiLineString Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONPolyline} EsriJSON geometry.
 */
function writeMultiLineStringGeometry(multiLineString, opt_options) {
    var hasZM = getHasZM(multiLineString);
    return {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        paths: /** @type {Array<Array<EsriJSONPosition>>} */ (multiLineString.getCoordinates()),
    };
}
/**
 * @param {import("../geom/MultiPoint.js").default} multiPoint Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONMultipoint} EsriJSON geometry.
 */
function writeMultiPointGeometry(multiPoint, opt_options) {
    var hasZM = getHasZM(multiPoint);
    return {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        points: /** @type {Array<EsriJSONPosition>} */ (multiPoint.getCoordinates()),
    };
}
/**
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONPolygon} EsriJSON geometry.
 */
function writeMultiPolygonGeometry(geometry, opt_options) {
    var hasZM = getHasZM(geometry);
    var coordinates = geometry.getCoordinates(false);
    var output = [];
    for (var i = 0; i < coordinates.length; i++) {
        for (var x = coordinates[i].length - 1; x >= 0; x--) {
            output.push(coordinates[i][x]);
        }
    }
    return {
        hasZ: hasZM.hasZ,
        hasM: hasZM.hasM,
        rings: /** @type {Array<Array<EsriJSONPosition>>} */ (output),
    };
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {EsriJSONGeometry} EsriJSON geometry.
 */
function writeGeometry(geometry, opt_options) {
    var geometryWriter = GEOMETRY_WRITERS[geometry.getType()];
    return geometryWriter(Object(_Feature_js__WEBPACK_IMPORTED_MODULE_17__["transformGeometryWithOptions"])(geometry, true, opt_options), opt_options);
}
/* harmony default export */ __webpack_exports__["default"] = (EsriJSON);
//# sourceMappingURL=EsriJSON.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(202);
/* harmony import */ var _FormatType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/JSONFeature
 */



/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for JSON feature formats.
 *
 * @abstract
 */
var JSONFeature = /** @class */ (function (_super) {
    __extends(JSONFeature, _super);
    function JSONFeature() {
        return _super.call(this) || this;
    }
    /**
     * @return {import("./FormatType.js").default} Format.
     */
    JSONFeature.prototype.getType = function () {
        return _FormatType_js__WEBPACK_IMPORTED_MODULE_1__["default"].JSON;
    };
    /**
     * Read a feature.  Only works for a single feature. Use `readFeatures` to
     * read a feature collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */
    JSONFeature.prototype.readFeature = function (source, opt_options) {
        return this.readFeatureFromObject(getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * Read all features.  Works with both a single feature and a feature
     * collection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */
    JSONFeature.prototype.readFeatures = function (source, opt_options) {
        return this.readFeaturesFromObject(getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */
    JSONFeature.prototype.readFeatureFromObject = function (object, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */
    JSONFeature.prototype.readFeaturesFromObject = function (object, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read a geometry.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     * @api
     */
    JSONFeature.prototype.readGeometry = function (source, opt_options) {
        return this.readGeometryFromObject(getObject(source), this.getReadOptions(source, opt_options));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    JSONFeature.prototype.readGeometryFromObject = function (object, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read the projection.
     *
     * @param {ArrayBuffer|Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */
    JSONFeature.prototype.readProjection = function (source) {
        return this.readProjectionFromObject(getObject(source));
    };
    /**
     * @abstract
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    JSONFeature.prototype.readProjectionFromObject = function (object) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Encode a feature as string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded feature.
     * @api
     */
    JSONFeature.prototype.writeFeature = function (feature, opt_options) {
        return JSON.stringify(this.writeFeatureObject(feature, opt_options));
    };
    /**
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */
    JSONFeature.prototype.writeFeatureObject = function (feature, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded features.
     * @api
     */
    JSONFeature.prototype.writeFeatures = function (features, opt_options) {
        return JSON.stringify(this.writeFeaturesObject(features, opt_options));
    };
    /**
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */
    JSONFeature.prototype.writeFeaturesObject = function (features, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Encode a geometry as string.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded geometry.
     * @api
     */
    JSONFeature.prototype.writeGeometry = function (geometry, opt_options) {
        return JSON.stringify(this.writeGeometryObject(geometry, opt_options));
    };
    /**
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {Object} Object.
     */
    JSONFeature.prototype.writeGeometryObject = function (geometry, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    return JSONFeature;
}(_Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {Object} Object.
 */
function getObject(source) {
    if (typeof source === 'string') {
        var object = JSON.parse(source);
        return object ? /** @type {Object} */ (object) : null;
    }
    else if (source !== null) {
        return source;
    }
    else {
        return null;
    }
}
/* harmony default export */ __webpack_exports__["default"] = (JSONFeature);
//# sourceMappingURL=JSONFeature.js.map

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformGeometryWithOptions", function() { return transformGeometryWithOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transformExtentWithOptions", function() { return transformExtentWithOptions; });
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/**
 * @module ol/format/Feature
 */




/**
 * @typedef {Object} ReadOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are reading.
 * If not provided, the projection will be derived from the data (where possible) or
 * the `dataProjection` of the format is assigned (where set). If the projection
 * can not be derived from the data and if no `dataProjection` is set for a format,
 * the features will not be reprojected.
 * @property {import("../extent.js").Extent} [extent] Tile extent in map units of the tile being read.
 * This is only required when reading data with tile pixels as geometry units. When configured,
 * a `dataProjection` with `TILE_PIXELS` as `units` and the tile's pixel extent as `extent` needs to be
 * provided.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * created by the format reader. If not provided, features will be returned in the
 * `dataProjection`.
 */
/**
 * @typedef {Object} WriteOptions
 * @property {import("../proj.js").ProjectionLike} [dataProjection] Projection of the data we are writing.
 * If not provided, the `dataProjection` of the format is assigned (where set).
 * If no `dataProjection` is set for a format, the features will be returned
 * in the `featureProjection`.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection of the feature geometries
 * that will be serialized by the format writer. If not provided, geometries are assumed
 * to be in the `dataProjection` if that is set; in other words, they are not transformed.
 * @property {boolean} [rightHanded] When writing geometries, follow the right-hand
 * rule for linear ring orientation.  This means that polygons will have counter-clockwise
 * exterior rings and clockwise interior rings.  By default, coordinates are serialized
 * as they are provided at construction.  If `true`, the right-hand rule will
 * be applied.  If `false`, the left-hand rule will be applied (clockwise for
 * exterior and counter-clockwise for interior rings).  Note that not all
 * formats support this.  The GeoJSON format does use this property when writing
 * geometries.
 * @property {number} [decimals] Maximum number of decimal places for coordinates.
 * Coordinates are stored internally as floats, but floating-point arithmetic can create
 * coordinates with a large number of decimal places, not generally wanted on output.
 * Set a number here to round coordinates. Can also be used to ensure that
 * coordinates read in can be written back out with the same number of decimals.
 * Default is no rounding.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for feature formats.
 * {@link module:ol/format/Feature~FeatureFormat} subclasses provide the ability to decode and encode
 * {@link module:ol/Feature~Feature} objects from a variety of commonly used geospatial
 * file formats.  See the documentation for each format for more details.
 *
 * @abstract
 * @api
 */
var FeatureFormat = /** @class */ (function () {
    function FeatureFormat() {
        /**
         * @protected
         * @type {import("../proj/Projection.js").default|undefined}
         */
        this.dataProjection = undefined;
        /**
         * @protected
         * @type {import("../proj/Projection.js").default|undefined}
         */
        this.defaultFeatureProjection = undefined;
    }
    /**
     * Adds the data projection to the read options.
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Options.
     * @return {ReadOptions|undefined} Options.
     * @protected
     */
    FeatureFormat.prototype.getReadOptions = function (source, opt_options) {
        var options;
        if (opt_options) {
            var dataProjection = opt_options.dataProjection
                ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(opt_options.dataProjection)
                : this.readProjection(source);
            if (opt_options.extent &&
                dataProjection &&
                dataProjection.getUnits() === _proj_Units_js__WEBPACK_IMPORTED_MODULE_0__["default"].TILE_PIXELS) {
                dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(dataProjection);
                dataProjection.setWorldExtent(opt_options.extent);
            }
            options = {
                dataProjection: dataProjection,
                featureProjection: opt_options.featureProjection,
            };
        }
        return this.adaptOptions(options);
    };
    /**
     * Sets the `dataProjection` on the options, if no `dataProjection`
     * is set.
     * @param {WriteOptions|ReadOptions|undefined} options
     *     Options.
     * @protected
     * @return {WriteOptions|ReadOptions|undefined}
     *     Updated options.
     */
    FeatureFormat.prototype.adaptOptions = function (options) {
        return Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({
            dataProjection: this.dataProjection,
            featureProjection: this.defaultFeatureProjection,
        }, options);
    };
    /**
     * @abstract
     * @return {import("./FormatType.js").default} Format.
     */
    FeatureFormat.prototype.getType = function () {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Read a single feature from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").FeatureLike} Feature.
     */
    FeatureFormat.prototype.readFeature = function (source, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Read all features from a source.
     *
     * @abstract
     * @param {Document|Element|ArrayBuffer|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").FeatureLike>} Features.
     */
    FeatureFormat.prototype.readFeatures = function (source, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Read a single geometry from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @param {ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    FeatureFormat.prototype.readGeometry = function (source, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Read the projection from a source.
     *
     * @abstract
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default|undefined} Projection.
     */
    FeatureFormat.prototype.readProjection = function (source) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Encode a feature in this format.
     *
     * @abstract
     * @param {import("../Feature.js").default} feature Feature.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */
    FeatureFormat.prototype.writeFeature = function (feature, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Encode an array of features in this format.
     *
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */
    FeatureFormat.prototype.writeFeatures = function (features, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    /**
     * Write a single geometry in this format.
     *
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {WriteOptions} [opt_options] Write options.
     * @return {string|ArrayBuffer} Result.
     */
    FeatureFormat.prototype.writeGeometry = function (geometry, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_1__["abstract"])();
    };
    return FeatureFormat;
}());
/* harmony default export */ __webpack_exports__["default"] = (FeatureFormat);
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {boolean} write Set to true for writing, false for reading.
 * @param {WriteOptions|ReadOptions} [opt_options] Options.
 * @return {import("../geom/Geometry.js").default} Transformed geometry.
 */
function transformGeometryWithOptions(geometry, write, opt_options) {
    var featureProjection = opt_options
        ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(opt_options.featureProjection)
        : null;
    var dataProjection = opt_options
        ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(opt_options.dataProjection)
        : null;
    var transformed;
    if (featureProjection &&
        dataProjection &&
        !Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["equivalent"])(featureProjection, dataProjection)) {
        transformed = (write ? geometry.clone() : geometry).transform(write ? featureProjection : dataProjection, write ? dataProjection : featureProjection);
    }
    else {
        transformed = geometry;
    }
    if (write &&
        opt_options &&
        /** @type {WriteOptions} */ (opt_options).decimals !== undefined) {
        var power_1 = Math.pow(10, 
        /** @type {WriteOptions} */ (opt_options).decimals);
        // if decimals option on write, round each coordinate appropriately
        /**
         * @param {Array<number>} coordinates Coordinates.
         * @return {Array<number>} Transformed coordinates.
         */
        var transform = function (coordinates) {
            for (var i = 0, ii = coordinates.length; i < ii; ++i) {
                coordinates[i] = Math.round(coordinates[i] * power_1) / power_1;
            }
            return coordinates;
        };
        if (transformed === geometry) {
            transformed = geometry.clone();
        }
        transformed.applyTransform(transform);
    }
    return transformed;
}
/**
 * @param {import("../extent.js").Extent} extent Extent.
 * @param {ReadOptions} [opt_options] Read options.
 * @return {import("../extent.js").Extent} Transformed extent.
 */
function transformExtentWithOptions(extent, opt_options) {
    var featureProjection = opt_options
        ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(opt_options.featureProjection)
        : null;
    var dataProjection = opt_options
        ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["get"])(opt_options.dataProjection)
        : null;
    if (featureProjection &&
        dataProjection &&
        !Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["equivalent"])(featureProjection, dataProjection)) {
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_3__["transformExtent"])(extent, dataProjection, featureProjection);
    }
    else {
        return extent;
    }
}
//# sourceMappingURL=Feature.js.map

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(103);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99);
/* harmony import */ var _flat_closest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(186);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(104);
/* harmony import */ var _flat_simplify_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(187);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/* harmony import */ var _flat_segments_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(193);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(188);
/* harmony import */ var _flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(204);
/* harmony import */ var _flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192);
/* harmony import */ var _flat_length_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(205);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/LineString
 */













/**
 * @classdesc
 * Linestring geometry.
 *
 * @api
 */
var LineString = /** @class */ (function (_super) {
    __extends(LineString, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    function LineString(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */
        _this.flatMidpoint_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.flatMidpointRevision_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDeltaRevision_ = -1;
        if (opt_layout !== undefined && !Array.isArray(coordinates[0])) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
        }
        else {
            _this.setCoordinates(
            /** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
        }
        return _this;
    }
    /**
     * Append the passed coordinate to the coordinates of the linestring.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @api
     */
    LineString.prototype.appendCoordinate = function (coordinate) {
        if (!this.flatCoordinates) {
            this.flatCoordinates = coordinate.slice();
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["extend"])(this.flatCoordinates, coordinate);
        }
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!LineString} Clone.
     * @api
     */
    LineString.prototype.clone = function () {
        var lineString = new LineString(this.flatCoordinates.slice(), this.layout);
        lineString.applyProperties(this);
        return lineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    LineString.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt(Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_3__["maxSquaredDelta"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_3__["assignClosestPoint"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Iterate over each segment, calling the provided callback.
     * If the callback returns a truthy value the function returns that
     * value immediately. Otherwise the function returns `false`.
     *
     * @param {function(this: S, import("../coordinate.js").Coordinate, import("../coordinate.js").Coordinate): T} callback Function
     *     called for each segment. The function will receive two arguments, the start and end coordinates of the segment.
     * @return {T|boolean} Value.
     * @template T,S
     * @api
     */
    LineString.prototype.forEachSegment = function (callback) {
        return Object(_flat_segments_js__WEBPACK_IMPORTED_MODULE_8__["forEach"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, callback);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * @param {number} m M.
     * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate} Coordinate.
     * @api
     */
    LineString.prototype.getCoordinateAtM = function (m, opt_extrapolate) {
        if (this.layout != _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYM &&
            this.layout != _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYZM) {
            return null;
        }
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        return Object(_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__["lineStringCoordinateAtM"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, m, extrapolate);
    };
    /**
     * Return the coordinates of the linestring.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */
    LineString.prototype.getCoordinates = function () {
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_9__["inflateCoordinates"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the coordinate at the provided fraction along the linestring.
     * The `fraction` is a number between 0 and 1, where 0 is the start of the
     * linestring and 1 is the end.
     * @param {number} fraction Fraction.
     * @param {import("../coordinate.js").Coordinate} [opt_dest] Optional coordinate whose values will
     *     be modified. If not provided, a new coordinate will be returned.
     * @return {import("../coordinate.js").Coordinate} Coordinate of the interpolated point.
     * @api
     */
    LineString.prototype.getCoordinateAt = function (fraction, opt_dest) {
        return Object(_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__["interpolatePoint"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, fraction, opt_dest, this.stride);
    };
    /**
     * Return the length of the linestring on projected plane.
     * @return {number} Length (on projected plane).
     * @api
     */
    LineString.prototype.getLength = function () {
        return Object(_flat_length_js__WEBPACK_IMPORTED_MODULE_12__["lineStringLength"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * @return {Array<number>} Flat midpoint.
     */
    LineString.prototype.getFlatMidpoint = function () {
        if (this.flatMidpointRevision_ != this.getRevision()) {
            this.flatMidpoint_ = this.getCoordinateAt(0.5, this.flatMidpoint_);
            this.flatMidpointRevision_ = this.getRevision();
        }
        return this.flatMidpoint_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LineString} Simplified LineString.
     * @protected
     */
    LineString.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        simplifiedFlatCoordinates.length = Object(_flat_simplify_js__WEBPACK_IMPORTED_MODULE_6__["douglasPeucker"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0);
        return new LineString(simplifiedFlatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    LineString.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].LINE_STRING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    LineString.prototype.intersectsExtent = function (extent) {
        return Object(_flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__["intersectsLineString"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride, extent);
    };
    /**
     * Set the coordinates of the linestring.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    LineString.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        this.flatCoordinates.length = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_5__["deflateCoordinates"])(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return LineString;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LineString);
//# sourceMappingURL=LineString.js.map

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "interpolatePoint", function() { return interpolatePoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineStringCoordinateAtM", function() { return lineStringCoordinateAtM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineStringsCoordinateAtM", function() { return lineStringsCoordinateAtM; });
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/**
 * @module ol/geom/flat/interpolate
 */


/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} fraction Fraction.
 * @param {Array<number>} [opt_dest] Destination.
 * @param {number} [opt_dimension] Destination dimension (default is `2`)
 * @return {Array<number>} Destination.
 */
function interpolatePoint(flatCoordinates, offset, end, stride, fraction, opt_dest, opt_dimension) {
    var o, t;
    var n = (end - offset) / stride;
    if (n === 1) {
        o = offset;
    }
    else if (n === 2) {
        o = offset;
        t = fraction;
    }
    else if (n !== 0) {
        var x1 = flatCoordinates[offset];
        var y1 = flatCoordinates[offset + 1];
        var length_1 = 0;
        var cumulativeLengths = [0];
        for (var i = offset + stride; i < end; i += stride) {
            var x2 = flatCoordinates[i];
            var y2 = flatCoordinates[i + 1];
            length_1 += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
            cumulativeLengths.push(length_1);
            x1 = x2;
            y1 = y2;
        }
        var target = fraction * length_1;
        var index = Object(_array_js__WEBPACK_IMPORTED_MODULE_0__["binarySearch"])(cumulativeLengths, target);
        if (index < 0) {
            t =
                (target - cumulativeLengths[-index - 2]) /
                    (cumulativeLengths[-index - 1] - cumulativeLengths[-index - 2]);
            o = offset + (-index - 2) * stride;
        }
        else {
            o = offset + index * stride;
        }
    }
    var dimension = opt_dimension > 1 ? opt_dimension : 2;
    var dest = opt_dest ? opt_dest : new Array(dimension);
    for (var i = 0; i < dimension; ++i) {
        dest[i] =
            o === undefined
                ? NaN
                : t === undefined
                    ? flatCoordinates[o + i]
                    : Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["lerp"])(flatCoordinates[o + i], flatCoordinates[o + stride + i], t);
    }
    return dest;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @return {import("../../coordinate.js").Coordinate} Coordinate.
 */
function lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, extrapolate) {
    if (end == offset) {
        return null;
    }
    var coordinate;
    if (m < flatCoordinates[offset + stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(offset, offset + stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        else {
            return null;
        }
    }
    else if (flatCoordinates[end - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(end - stride, end);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        else {
            return null;
        }
    }
    // FIXME use O(1) search
    if (m == flatCoordinates[offset + stride - 1]) {
        return flatCoordinates.slice(offset, offset + stride);
    }
    var lo = offset / stride;
    var hi = end / stride;
    while (lo < hi) {
        var mid = (lo + hi) >> 1;
        if (m < flatCoordinates[(mid + 1) * stride - 1]) {
            hi = mid;
        }
        else {
            lo = mid + 1;
        }
    }
    var m0 = flatCoordinates[lo * stride - 1];
    if (m == m0) {
        return flatCoordinates.slice((lo - 1) * stride, (lo - 1) * stride + stride);
    }
    var m1 = flatCoordinates[(lo + 1) * stride - 1];
    var t = (m - m0) / (m1 - m0);
    coordinate = [];
    for (var i = 0; i < stride - 1; ++i) {
        coordinate.push(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["lerp"])(flatCoordinates[(lo - 1) * stride + i], flatCoordinates[lo * stride + i], t));
    }
    coordinate.push(m);
    return coordinate;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @param {number} m M.
 * @param {boolean} extrapolate Extrapolate.
 * @param {boolean} interpolate Interpolate.
 * @return {import("../../coordinate.js").Coordinate} Coordinate.
 */
function lineStringsCoordinateAtM(flatCoordinates, offset, ends, stride, m, extrapolate, interpolate) {
    if (interpolate) {
        return lineStringCoordinateAtM(flatCoordinates, offset, ends[ends.length - 1], stride, m, extrapolate);
    }
    var coordinate;
    if (m < flatCoordinates[stride - 1]) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(0, stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        else {
            return null;
        }
    }
    if (flatCoordinates[flatCoordinates.length - 1] < m) {
        if (extrapolate) {
            coordinate = flatCoordinates.slice(flatCoordinates.length - stride);
            coordinate[stride - 1] = m;
            return coordinate;
        }
        else {
            return null;
        }
    }
    for (var i = 0, ii = ends.length; i < ii; ++i) {
        var end = ends[i];
        if (offset == end) {
            continue;
        }
        if (m < flatCoordinates[offset + stride - 1]) {
            return null;
        }
        else if (m <= flatCoordinates[end - 1]) {
            return lineStringCoordinateAtM(flatCoordinates, offset, end, stride, m, false);
        }
        offset = end;
    }
    return null;
}
//# sourceMappingURL=interpolate.js.map

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lineStringLength", function() { return lineStringLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingLength", function() { return linearRingLength; });
/**
 * @module ol/geom/flat/length
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Length.
 */
function lineStringLength(flatCoordinates, offset, end, stride) {
    var x1 = flatCoordinates[offset];
    var y1 = flatCoordinates[offset + 1];
    var length = 0;
    for (var i = offset + stride; i < end; i += stride) {
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        length += Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
        x1 = x2;
        y1 = y2;
    }
    return length;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Perimeter.
 */
function linearRingLength(flatCoordinates, offset, end, stride) {
    var perimeter = lineStringLength(flatCoordinates, offset, end, stride);
    var dx = flatCoordinates[end - stride] - flatCoordinates[offset];
    var dy = flatCoordinates[end - stride + 1] - flatCoordinates[offset + 1];
    perimeter += Math.sqrt(dx * dx + dy * dy);
    return perimeter;
}
//# sourceMappingURL=length.js.map

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(103);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _LineString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(203);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99);
/* harmony import */ var _flat_closest_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(186);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(104);
/* harmony import */ var _flat_simplify_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(187);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(188);
/* harmony import */ var _flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(204);
/* harmony import */ var _flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/MultiLineString
 */












/**
 * @classdesc
 * Multi-linestring geometry.
 *
 * @api
 */
var MultiLineString = /** @class */ (function (_super) {
    __extends(MultiLineString, _super);
    /**
     * @param {Array<Array<import("../coordinate.js").Coordinate>|LineString>|Array<number>} coordinates
     *     Coordinates or LineString geometries. (For internal use, flat coordinates in
     *     combination with `opt_layout` and `opt_ends` are also accepted.)
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<number>} [opt_ends] Flat coordinate ends for internal use.
     */
    function MultiLineString(coordinates, opt_layout, opt_ends) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<number>}
         * @private
         */
        _this.ends_ = [];
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDeltaRevision_ = -1;
        if (Array.isArray(coordinates[0])) {
            _this.setCoordinates(
            /** @type {Array<Array<import("../coordinate.js").Coordinate>>} */ (coordinates), opt_layout);
        }
        else if (opt_layout !== undefined && opt_ends) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
            _this.ends_ = opt_ends;
        }
        else {
            var layout = _this.getLayout();
            var lineStrings = /** @type {Array<LineString>} */ (coordinates);
            var flatCoordinates = [];
            var ends = [];
            for (var i = 0, ii = lineStrings.length; i < ii; ++i) {
                var lineString = lineStrings[i];
                if (i === 0) {
                    layout = lineString.getLayout();
                }
                Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(flatCoordinates, lineString.getFlatCoordinates());
                ends.push(flatCoordinates.length);
            }
            _this.setFlatCoordinates(layout, flatCoordinates);
            _this.ends_ = ends;
        }
        return _this;
    }
    /**
     * Append the passed linestring to the multilinestring.
     * @param {LineString} lineString LineString.
     * @api
     */
    MultiLineString.prototype.appendLineString = function (lineString) {
        if (!this.flatCoordinates) {
            this.flatCoordinates = lineString.getFlatCoordinates().slice();
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(this.flatCoordinates, lineString.getFlatCoordinates().slice());
        }
        this.ends_.push(this.flatCoordinates.length);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiLineString} Clone.
     * @api
     */
    MultiLineString.prototype.clone = function () {
        var multiLineString = new MultiLineString(this.flatCoordinates.slice(), this.layout, this.ends_.slice());
        multiLineString.applyProperties(this);
        return multiLineString;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    MultiLineString.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt(Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_4__["arrayMaxSquaredDelta"])(this.flatCoordinates, 0, this.ends_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_4__["assignClosestArrayPoint"])(this.flatCoordinates, 0, this.ends_, this.stride, this.maxDelta_, false, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * Returns the coordinate at `m` using linear interpolation, or `null` if no
     * such coordinate exists.
     *
     * `opt_extrapolate` controls extrapolation beyond the range of Ms in the
     * MultiLineString. If `opt_extrapolate` is `true` then Ms less than the first
     * M will return the first coordinate and Ms greater than the last M will
     * return the last coordinate.
     *
     * `opt_interpolate` controls interpolation between consecutive LineStrings
     * within the MultiLineString. If `opt_interpolate` is `true` the coordinates
     * will be linearly interpolated between the last coordinate of one LineString
     * and the first coordinate of the next LineString.  If `opt_interpolate` is
     * `false` then the function will return `null` for Ms falling between
     * LineStrings.
     *
     * @param {number} m M.
     * @param {boolean} [opt_extrapolate] Extrapolate. Default is `false`.
     * @param {boolean} [opt_interpolate] Interpolate. Default is `false`.
     * @return {import("../coordinate.js").Coordinate} Coordinate.
     * @api
     */
    MultiLineString.prototype.getCoordinateAtM = function (m, opt_extrapolate, opt_interpolate) {
        if ((this.layout != _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYM &&
            this.layout != _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYZM) ||
            this.flatCoordinates.length === 0) {
            return null;
        }
        var extrapolate = opt_extrapolate !== undefined ? opt_extrapolate : false;
        var interpolate = opt_interpolate !== undefined ? opt_interpolate : false;
        return Object(_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__["lineStringsCoordinateAtM"])(this.flatCoordinates, 0, this.ends_, this.stride, m, extrapolate, interpolate);
    };
    /**
     * Return the coordinates of the multilinestring.
     * @return {Array<Array<import("../coordinate.js").Coordinate>>} Coordinates.
     * @api
     */
    MultiLineString.prototype.getCoordinates = function () {
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_9__["inflateCoordinatesArray"])(this.flatCoordinates, 0, this.ends_, this.stride);
    };
    /**
     * @return {Array<number>} Ends.
     */
    MultiLineString.prototype.getEnds = function () {
        return this.ends_;
    };
    /**
     * Return the linestring at the specified index.
     * @param {number} index Index.
     * @return {LineString} LineString.
     * @api
     */
    MultiLineString.prototype.getLineString = function (index) {
        if (index < 0 || this.ends_.length <= index) {
            return null;
        }
        return new _LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](this.flatCoordinates.slice(index === 0 ? 0 : this.ends_[index - 1], this.ends_[index]), this.layout);
    };
    /**
     * Return the linestrings of this multilinestring.
     * @return {Array<LineString>} LineStrings.
     * @api
     */
    MultiLineString.prototype.getLineStrings = function () {
        var flatCoordinates = this.flatCoordinates;
        var ends = this.ends_;
        var layout = this.layout;
        /** @type {Array<LineString>} */
        var lineStrings = [];
        var offset = 0;
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            var end = ends[i];
            var lineString = new _LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](flatCoordinates.slice(offset, end), layout);
            lineStrings.push(lineString);
            offset = end;
        }
        return lineStrings;
    };
    /**
     * @return {Array<number>} Flat midpoints.
     */
    MultiLineString.prototype.getFlatMidpoints = function () {
        var midpoints = [];
        var flatCoordinates = this.flatCoordinates;
        var offset = 0;
        var ends = this.ends_;
        var stride = this.stride;
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            var end = ends[i];
            var midpoint = Object(_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_10__["interpolatePoint"])(flatCoordinates, offset, end, stride, 0.5);
            Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(midpoints, midpoint);
            offset = end;
        }
        return midpoints;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {MultiLineString} Simplified MultiLineString.
     * @protected
     */
    MultiLineString.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEnds = [];
        simplifiedFlatCoordinates.length = Object(_flat_simplify_js__WEBPACK_IMPORTED_MODULE_7__["douglasPeuckerArray"])(this.flatCoordinates, 0, this.ends_, this.stride, squaredTolerance, simplifiedFlatCoordinates, 0, simplifiedEnds);
        return new MultiLineString(simplifiedFlatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY, simplifiedEnds);
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    MultiLineString.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].MULTI_LINE_STRING;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    MultiLineString.prototype.intersectsExtent = function (extent) {
        return Object(_flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__["intersectsLineStringArray"])(this.flatCoordinates, 0, this.ends_, this.stride, extent);
    };
    /**
     * Set the coordinates of the multilinestring.
     * @param {!Array<Array<import("../coordinate.js").Coordinate>>} coordinates Coordinates.
     * @param {GeometryLayout} [opt_layout] Layout.
     * @api
     */
    MultiLineString.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 2);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        var ends = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_6__["deflateCoordinatesArray"])(this.flatCoordinates, 0, coordinates, this.stride, this.ends_);
        this.flatCoordinates.length = ends.length === 0 ? 0 : ends[ends.length - 1];
        this.changed();
    };
    return MultiLineString;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MultiLineString);
//# sourceMappingURL=MultiLineString.js.map

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _Point_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(104);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(188);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/MultiPoint
 */








/**
 * @classdesc
 * Multi-point geometry.
 *
 * @api
 */
var MultiPoint = /** @class */ (function (_super) {
    __extends(MultiPoint, _super);
    /**
     * @param {Array<import("../coordinate.js").Coordinate>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    function MultiPoint(coordinates, opt_layout) {
        var _this = _super.call(this) || this;
        if (opt_layout && !Array.isArray(coordinates[0])) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
        }
        else {
            _this.setCoordinates(
            /** @type {Array<import("../coordinate.js").Coordinate>} */ (coordinates), opt_layout);
        }
        return _this;
    }
    /**
     * Append the passed point to this multipoint.
     * @param {Point} point Point.
     * @api
     */
    MultiPoint.prototype.appendPoint = function (point) {
        if (!this.flatCoordinates) {
            this.flatCoordinates = point.getFlatCoordinates().slice();
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_5__["extend"])(this.flatCoordinates, point.getFlatCoordinates());
        }
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiPoint} Clone.
     * @api
     */
    MultiPoint.prototype.clone = function () {
        var multiPoint = new MultiPoint(this.flatCoordinates.slice(), this.layout);
        multiPoint.applyProperties(this);
        return multiPoint;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    MultiPoint.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
            var squaredDistance = Object(_math_js__WEBPACK_IMPORTED_MODULE_7__["squaredDistance"])(x, y, flatCoordinates[i], flatCoordinates[i + 1]);
            if (squaredDistance < minSquaredDistance) {
                minSquaredDistance = squaredDistance;
                for (var j = 0; j < stride; ++j) {
                    closestPoint[j] = flatCoordinates[i + j];
                }
                closestPoint.length = stride;
            }
        }
        return minSquaredDistance;
    };
    /**
     * Return the coordinates of the multipoint.
     * @return {Array<import("../coordinate.js").Coordinate>} Coordinates.
     * @api
     */
    MultiPoint.prototype.getCoordinates = function () {
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_6__["inflateCoordinates"])(this.flatCoordinates, 0, this.flatCoordinates.length, this.stride);
    };
    /**
     * Return the point at the specified index.
     * @param {number} index Index.
     * @return {Point} Point.
     * @api
     */
    MultiPoint.prototype.getPoint = function (index) {
        var n = !this.flatCoordinates
            ? 0
            : this.flatCoordinates.length / this.stride;
        if (index < 0 || n <= index) {
            return null;
        }
        return new _Point_js__WEBPACK_IMPORTED_MODULE_1__["default"](this.flatCoordinates.slice(index * this.stride, (index + 1) * this.stride), this.layout);
    };
    /**
     * Return the points of this multipoint.
     * @return {Array<Point>} Points.
     * @api
     */
    MultiPoint.prototype.getPoints = function () {
        var flatCoordinates = this.flatCoordinates;
        var layout = this.layout;
        var stride = this.stride;
        /** @type {Array<Point>} */
        var points = [];
        for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
            var point = new _Point_js__WEBPACK_IMPORTED_MODULE_1__["default"](flatCoordinates.slice(i, i + stride), layout);
            points.push(point);
        }
        return points;
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    MultiPoint.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POINT;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    MultiPoint.prototype.intersectsExtent = function (extent) {
        var flatCoordinates = this.flatCoordinates;
        var stride = this.stride;
        for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
            var x = flatCoordinates[i];
            var y = flatCoordinates[i + 1];
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["containsXY"])(extent, x, y)) {
                return true;
            }
        }
        return false;
    };
    /**
     * Set the coordinates of the multipoint.
     * @param {!Array<import("../coordinate.js").Coordinate>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    MultiPoint.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 1);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        this.flatCoordinates.length = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_4__["deflateCoordinates"])(this.flatCoordinates, 0, coordinates, this.stride);
        this.changed();
    };
    return MultiPoint;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MultiPoint);
//# sourceMappingURL=MultiPoint.js.map

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(103);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _MultiPoint_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(207);
/* harmony import */ var _Polygon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(184);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99);
/* harmony import */ var _flat_closest_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(186);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(104);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/* harmony import */ var _flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(190);
/* harmony import */ var _flat_inflate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(188);
/* harmony import */ var _flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192);
/* harmony import */ var _flat_orient_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(194);
/* harmony import */ var _flat_area_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(189);
/* harmony import */ var _flat_center_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(209);
/* harmony import */ var _flat_contains_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(191);
/* harmony import */ var _flat_simplify_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(187);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/MultiPolygon
 */

















/**
 * @classdesc
 * Multi-polygon geometry.
 *
 * @api
 */
var MultiPolygon = /** @class */ (function (_super) {
    __extends(MultiPolygon, _super);
    /**
     * @param {Array<Array<Array<import("../coordinate.js").Coordinate>>|Polygon>|Array<number>} coordinates Coordinates.
     *     For internal use, flat coordinates in combination with `opt_layout` and `opt_endss` are also accepted.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @param {Array<Array<number>>} [opt_endss] Array of ends for internal use with flat coordinates.
     */
    function MultiPolygon(coordinates, opt_layout, opt_endss) {
        var _this = _super.call(this) || this;
        /**
         * @type {Array<Array<number>>}
         * @private
         */
        _this.endss_ = [];
        /**
         * @private
         * @type {number}
         */
        _this.flatInteriorPointsRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.flatInteriorPoints_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.maxDeltaRevision_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.orientedRevision_ = -1;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.orientedFlatCoordinates_ = null;
        if (!opt_endss && !Array.isArray(coordinates[0])) {
            var layout = _this.getLayout();
            var polygons = /** @type {Array<Polygon>} */ (coordinates);
            var flatCoordinates = [];
            var endss = [];
            for (var i = 0, ii = polygons.length; i < ii; ++i) {
                var polygon = polygons[i];
                if (i === 0) {
                    layout = polygon.getLayout();
                }
                var offset = flatCoordinates.length;
                var ends = polygon.getEnds();
                for (var j = 0, jj = ends.length; j < jj; ++j) {
                    ends[j] += offset;
                }
                Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(flatCoordinates, polygon.getFlatCoordinates());
                endss.push(ends);
            }
            opt_layout = layout;
            coordinates = flatCoordinates;
            opt_endss = endss;
        }
        if (opt_layout !== undefined && opt_endss) {
            _this.setFlatCoordinates(opt_layout, 
            /** @type {Array<number>} */ (coordinates));
            _this.endss_ = opt_endss;
        }
        else {
            _this.setCoordinates(
            /** @type {Array<Array<Array<import("../coordinate.js").Coordinate>>>} */ (coordinates), opt_layout);
        }
        return _this;
    }
    /**
     * Append the passed polygon to this multipolygon.
     * @param {Polygon} polygon Polygon.
     * @api
     */
    MultiPolygon.prototype.appendPolygon = function (polygon) {
        /** @type {Array<number>} */
        var ends;
        if (!this.flatCoordinates) {
            this.flatCoordinates = polygon.getFlatCoordinates().slice();
            ends = polygon.getEnds().slice();
            this.endss_.push();
        }
        else {
            var offset = this.flatCoordinates.length;
            Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(this.flatCoordinates, polygon.getFlatCoordinates());
            ends = polygon.getEnds().slice();
            for (var i = 0, ii = ends.length; i < ii; ++i) {
                ends[i] += offset;
            }
        }
        this.endss_.push(ends);
        this.changed();
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!MultiPolygon} Clone.
     * @api
     */
    MultiPolygon.prototype.clone = function () {
        var len = this.endss_.length;
        var newEndss = new Array(len);
        for (var i = 0; i < len; ++i) {
            newEndss[i] = this.endss_[i].slice();
        }
        var multiPolygon = new MultiPolygon(this.flatCoordinates.slice(), this.layout, newEndss);
        multiPolygon.applyProperties(this);
        return multiPolygon;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    MultiPolygon.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        if (this.maxDeltaRevision_ != this.getRevision()) {
            this.maxDelta_ = Math.sqrt(Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_5__["multiArrayMaxSquaredDelta"])(this.flatCoordinates, 0, this.endss_, this.stride, 0));
            this.maxDeltaRevision_ = this.getRevision();
        }
        return Object(_flat_closest_js__WEBPACK_IMPORTED_MODULE_5__["assignClosestMultiArrayPoint"])(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, this.maxDelta_, true, x, y, closestPoint, minSquaredDistance);
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */
    MultiPolygon.prototype.containsXY = function (x, y) {
        return Object(_flat_contains_js__WEBPACK_IMPORTED_MODULE_15__["linearRingssContainsXY"])(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, x, y);
    };
    /**
     * Return the area of the multipolygon on projected plane.
     * @return {number} Area (on projected plane).
     * @api
     */
    MultiPolygon.prototype.getArea = function () {
        return Object(_flat_area_js__WEBPACK_IMPORTED_MODULE_13__["linearRingss"])(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride);
    };
    /**
     * Get the coordinate array for this geometry.  This array has the structure
     * of a GeoJSON coordinate array for multi-polygons.
     *
     * @param {boolean} [opt_right] Orient coordinates according to the right-hand
     *     rule (counter-clockwise for exterior and clockwise for interior rings).
     *     If `false`, coordinates will be oriented according to the left-hand rule
     *     (clockwise for exterior and counter-clockwise for interior rings).
     *     By default, coordinate orientation will depend on how the geometry was
     *     constructed.
     * @return {Array<Array<Array<import("../coordinate.js").Coordinate>>>} Coordinates.
     * @api
     */
    MultiPolygon.prototype.getCoordinates = function (opt_right) {
        var flatCoordinates;
        if (opt_right !== undefined) {
            flatCoordinates = this.getOrientedFlatCoordinates().slice();
            Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["orientLinearRingsArray"])(flatCoordinates, 0, this.endss_, this.stride, opt_right);
        }
        else {
            flatCoordinates = this.flatCoordinates;
        }
        return Object(_flat_inflate_js__WEBPACK_IMPORTED_MODULE_10__["inflateMultiCoordinatesArray"])(flatCoordinates, 0, this.endss_, this.stride);
    };
    /**
     * @return {Array<Array<number>>} Endss.
     */
    MultiPolygon.prototype.getEndss = function () {
        return this.endss_;
    };
    /**
     * @return {Array<number>} Flat interior points.
     */
    MultiPolygon.prototype.getFlatInteriorPoints = function () {
        if (this.flatInteriorPointsRevision_ != this.getRevision()) {
            var flatCenters = Object(_flat_center_js__WEBPACK_IMPORTED_MODULE_14__["linearRingss"])(this.flatCoordinates, 0, this.endss_, this.stride);
            this.flatInteriorPoints_ = Object(_flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_9__["getInteriorPointsOfMultiArray"])(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, flatCenters);
            this.flatInteriorPointsRevision_ = this.getRevision();
        }
        return this.flatInteriorPoints_;
    };
    /**
     * Return the interior points as {@link module:ol/geom/MultiPoint multipoint}.
     * @return {MultiPoint} Interior points as XYM coordinates, where M is
     * the length of the horizontal intersection that the point belongs to.
     * @api
     */
    MultiPolygon.prototype.getInteriorPoints = function () {
        return new _MultiPoint_js__WEBPACK_IMPORTED_MODULE_2__["default"](this.getFlatInteriorPoints().slice(), _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XYM);
    };
    /**
     * @return {Array<number>} Oriented flat coordinates.
     */
    MultiPolygon.prototype.getOrientedFlatCoordinates = function () {
        if (this.orientedRevision_ != this.getRevision()) {
            var flatCoordinates = this.flatCoordinates;
            if (Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["linearRingssAreOriented"])(flatCoordinates, 0, this.endss_, this.stride)) {
                this.orientedFlatCoordinates_ = flatCoordinates;
            }
            else {
                this.orientedFlatCoordinates_ = flatCoordinates.slice();
                this.orientedFlatCoordinates_.length = Object(_flat_orient_js__WEBPACK_IMPORTED_MODULE_12__["orientLinearRingsArray"])(this.orientedFlatCoordinates_, 0, this.endss_, this.stride);
            }
            this.orientedRevision_ = this.getRevision();
        }
        return this.orientedFlatCoordinates_;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {MultiPolygon} Simplified MultiPolygon.
     * @protected
     */
    MultiPolygon.prototype.getSimplifiedGeometryInternal = function (squaredTolerance) {
        var simplifiedFlatCoordinates = [];
        var simplifiedEndss = [];
        simplifiedFlatCoordinates.length = Object(_flat_simplify_js__WEBPACK_IMPORTED_MODULE_16__["quantizeMultiArray"])(this.flatCoordinates, 0, this.endss_, this.stride, Math.sqrt(squaredTolerance), simplifiedFlatCoordinates, 0, simplifiedEndss);
        return new MultiPolygon(simplifiedFlatCoordinates, _GeometryLayout_js__WEBPACK_IMPORTED_MODULE_0__["default"].XY, simplifiedEndss);
    };
    /**
     * Return the polygon at the specified index.
     * @param {number} index Index.
     * @return {Polygon} Polygon.
     * @api
     */
    MultiPolygon.prototype.getPolygon = function (index) {
        if (index < 0 || this.endss_.length <= index) {
            return null;
        }
        var offset;
        if (index === 0) {
            offset = 0;
        }
        else {
            var prevEnds = this.endss_[index - 1];
            offset = prevEnds[prevEnds.length - 1];
        }
        var ends = this.endss_[index].slice();
        var end = ends[ends.length - 1];
        if (offset !== 0) {
            for (var i = 0, ii = ends.length; i < ii; ++i) {
                ends[i] -= offset;
            }
        }
        return new _Polygon_js__WEBPACK_IMPORTED_MODULE_3__["default"](this.flatCoordinates.slice(offset, end), this.layout, ends);
    };
    /**
     * Return the polygons of this multipolygon.
     * @return {Array<Polygon>} Polygons.
     * @api
     */
    MultiPolygon.prototype.getPolygons = function () {
        var layout = this.layout;
        var flatCoordinates = this.flatCoordinates;
        var endss = this.endss_;
        var polygons = [];
        var offset = 0;
        for (var i = 0, ii = endss.length; i < ii; ++i) {
            var ends = endss[i].slice();
            var end = ends[ends.length - 1];
            if (offset !== 0) {
                for (var j = 0, jj = ends.length; j < jj; ++j) {
                    ends[j] -= offset;
                }
            }
            var polygon = new _Polygon_js__WEBPACK_IMPORTED_MODULE_3__["default"](flatCoordinates.slice(offset, end), layout, ends);
            polygons.push(polygon);
            offset = end;
        }
        return polygons;
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    MultiPolygon.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].MULTI_POLYGON;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    MultiPolygon.prototype.intersectsExtent = function (extent) {
        return Object(_flat_intersectsextent_js__WEBPACK_IMPORTED_MODULE_11__["intersectsLinearRingMultiArray"])(this.getOrientedFlatCoordinates(), 0, this.endss_, this.stride, extent);
    };
    /**
     * Set the coordinates of the multipolygon.
     * @param {!Array<Array<Array<import("../coordinate.js").Coordinate>>>} coordinates Coordinates.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    MultiPolygon.prototype.setCoordinates = function (coordinates, opt_layout) {
        this.setLayout(opt_layout, coordinates, 3);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        var endss = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_7__["deflateMultiCoordinatesArray"])(this.flatCoordinates, 0, coordinates, this.stride, this.endss_);
        if (endss.length === 0) {
            this.flatCoordinates.length = 0;
        }
        else {
            var lastEnds = endss[endss.length - 1];
            this.flatCoordinates.length =
                lastEnds.length === 0 ? 0 : lastEnds[lastEnds.length - 1];
        }
        this.changed();
    };
    return MultiPolygon;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MultiPolygon);
//# sourceMappingURL=MultiPolygon.js.map

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linearRingss", function() { return linearRingss; });
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/**
 * @module ol/geom/flat/center
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {Array<number>} Flat centers.
 */
function linearRingss(flatCoordinates, offset, endss, stride) {
    var flatCenters = [];
    var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["createEmpty"])();
    for (var i = 0, ii = endss.length; i < ii; ++i) {
        var ends = endss[i];
        extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_0__["createOrUpdateFromFlatCoordinates"])(flatCoordinates, offset, ends[0], stride);
        flatCenters.push((extent[0] + extent[2]) / 2, (extent[1] + extent[3]) / 2);
        offset = ends[ends.length - 1];
    }
    return flatCenters;
}
//# sourceMappingURL=center.js.map

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(211);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _JSONFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(201);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(202);
/**
 * @module ol/format/GeoJSON
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();














/**
 * @typedef {import("geojson").GeoJSON} GeoJSONObject
 * @typedef {import("geojson").Feature} GeoJSONFeature
 * @typedef {import("geojson").FeatureCollection} GeoJSONFeatureCollection
 * @typedef {import("geojson").Geometry} GeoJSONGeometry
 * @typedef {import("geojson").Point} GeoJSONPoint
 * @typedef {import("geojson").LineString} GeoJSONLineString
 * @typedef {import("geojson").Polygon} GeoJSONPolygon
 * @typedef {import("geojson").MultiPoint} GeoJSONMultiPoint
 * @typedef {import("geojson").MultiLineString} GeoJSONMultiLineString
 * @typedef {import("geojson").MultiPolygon} GeoJSONMultiPolygon
 * @typedef {import("geojson").GeometryCollection} GeoJSONGeometryCollection
 */
/**
 * @typedef {Object} Options
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {import("../proj.js").ProjectionLike} [featureProjection] Projection for features read or
 * written by the format.  Options passed to read or write methods will take precedence.
 * @property {string} [geometryName] Geometry name to use when creating features.
 * @property {boolean} [extractGeometryName=false] Certain GeoJSON providers include
 * the geometry_name field in the feature GeoJSON. If set to `true` the GeoJSON reader
 * will look for that field to set the geometry name. If both this field is set to `true`
 * and a `geometryName` is provided, the `geometryName` will take precedence.
 */
/**
 * @classdesc
 * Feature format for reading and writing data in the GeoJSON format.
 *
 * @api
 */
var GeoJSON = /** @class */ (function (_super) {
    __extends(GeoJSON, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function GeoJSON(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this) || this;
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_12__["get"])(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        if (options.featureProjection) {
            _this.defaultFeatureProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_12__["get"])(options.featureProjection);
        }
        /**
         * Name of the geometry attribute for features.
         * @type {string|undefined}
         * @private
         */
        _this.geometryName_ = options.geometryName;
        /**
         * Look for the geometry name in the feature GeoJSON
         * @type {boolean|undefined}
         * @private
         */
        _this.extractGeometryName_ = options.extractGeometryName;
        return _this;
    }
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */
    GeoJSON.prototype.readFeatureFromObject = function (object, opt_options) {
        /**
         * @type {GeoJSONFeature}
         */
        var geoJSONFeature = null;
        if (object['type'] === 'Feature') {
            geoJSONFeature = /** @type {GeoJSONFeature} */ (object);
        }
        else {
            geoJSONFeature = {
                'type': 'Feature',
                'geometry': /** @type {GeoJSONGeometry} */ (object),
                'properties': null,
            };
        }
        var geometry = readGeometry(geoJSONFeature['geometry'], opt_options);
        var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        if (this.geometryName_) {
            feature.setGeometryName(this.geometryName_);
        }
        else if (this.extractGeometryName_ &&
            'geometry_name' in geoJSONFeature !== undefined) {
            feature.setGeometryName(geoJSONFeature['geometry_name']);
        }
        feature.setGeometry(geometry);
        if ('id' in geoJSONFeature) {
            feature.setId(geoJSONFeature['id']);
        }
        if (geoJSONFeature['properties']) {
            feature.setProperties(geoJSONFeature['properties'], true);
        }
        return feature;
    };
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    GeoJSON.prototype.readFeaturesFromObject = function (object, opt_options) {
        var geoJSONObject = /** @type {GeoJSONObject} */ (object);
        /** @type {Array<import("../Feature.js").default>} */
        var features = null;
        if (geoJSONObject['type'] === 'FeatureCollection') {
            var geoJSONFeatureCollection = /** @type {GeoJSONFeatureCollection} */ (object);
            features = [];
            var geoJSONFeatures = geoJSONFeatureCollection['features'];
            for (var i = 0, ii = geoJSONFeatures.length; i < ii; ++i) {
                features.push(this.readFeatureFromObject(geoJSONFeatures[i], opt_options));
            }
        }
        else {
            features = [this.readFeatureFromObject(object, opt_options)];
        }
        return features;
    };
    /**
     * @param {GeoJSONGeometry} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    GeoJSON.prototype.readGeometryFromObject = function (object, opt_options) {
        return readGeometry(object, opt_options);
    };
    /**
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    GeoJSON.prototype.readProjectionFromObject = function (object) {
        var crs = object['crs'];
        var projection;
        if (crs) {
            if (crs['type'] == 'name') {
                projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_12__["get"])(crs['properties']['name']);
            }
            else if (crs['type'] === 'EPSG') {
                projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_12__["get"])('EPSG:' + crs['properties']['code']);
            }
            else {
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_10__["assert"])(false, 36); // Unknown SRS type
            }
        }
        else {
            projection = this.dataProjection;
        }
        return /** @type {import("../proj/Projection.js").default} */ (projection);
    };
    /**
     * Encode a feature as a GeoJSON Feature object.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONFeature} Object.
     * @api
     */
    GeoJSON.prototype.writeFeatureObject = function (feature, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        /** @type {GeoJSONFeature} */
        var object = {
            'type': 'Feature',
            geometry: null,
            properties: null,
        };
        var id = feature.getId();
        if (id !== undefined) {
            object.id = id;
        }
        if (!feature.hasProperties()) {
            return object;
        }
        var properties = feature.getProperties();
        var geometry = feature.getGeometry();
        if (geometry) {
            object.geometry = writeGeometry(geometry, opt_options);
            delete properties[feature.getGeometryName()];
        }
        if (!Object(_obj_js__WEBPACK_IMPORTED_MODULE_11__["isEmpty"])(properties)) {
            object.properties = properties;
        }
        return object;
    };
    /**
     * Encode an array of features as a GeoJSON object.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONFeatureCollection} GeoJSON Object.
     * @api
     */
    GeoJSON.prototype.writeFeaturesObject = function (features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var objects = [];
        for (var i = 0, ii = features.length; i < ii; ++i) {
            objects.push(this.writeFeatureObject(features[i], opt_options));
        }
        return {
            type: 'FeatureCollection',
            features: objects,
        };
    };
    /**
     * Encode a geometry as a GeoJSON object.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {GeoJSONGeometry|GeoJSONGeometryCollection} Object.
     * @api
     */
    GeoJSON.prototype.writeGeometryObject = function (geometry, opt_options) {
        return writeGeometry(geometry, this.adaptOptions(opt_options));
    };
    return GeoJSON;
}(_JSONFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/**
 * @param {GeoJSONGeometry|GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */
function readGeometry(object, opt_options) {
    if (!object) {
        return null;
    }
    /**
     * @type {import("../geom/Geometry.js").default}
     */
    var geometry;
    switch (object['type']) {
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT: {
            geometry = readPointGeometry(/** @type {GeoJSONPoint} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING: {
            geometry = readLineStringGeometry(
            /** @type {GeoJSONLineString} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON: {
            geometry = readPolygonGeometry(/** @type {GeoJSONPolygon} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT: {
            geometry = readMultiPointGeometry(
            /** @type {GeoJSONMultiPoint} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING: {
            geometry = readMultiLineStringGeometry(
            /** @type {GeoJSONMultiLineString} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON: {
            geometry = readMultiPolygonGeometry(
            /** @type {GeoJSONMultiPolygon} */ (object));
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].GEOMETRY_COLLECTION: {
            geometry = readGeometryCollectionGeometry(
            /** @type {GeoJSONGeometryCollection} */ (object));
            break;
        }
        default: {
            throw new Error('Unsupported GeoJSON type: ' + object.type);
        }
    }
    return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_13__["transformGeometryWithOptions"])(geometry, false, opt_options);
}
/**
 * @param {GeoJSONGeometryCollection} object Object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {GeometryCollection} Geometry collection.
 */
function readGeometryCollectionGeometry(object, opt_options) {
    var geometries = object['geometries'].map(
    /**
     * @param {GeoJSONGeometry} geometry Geometry.
     * @return {import("../geom/Geometry.js").default} geometry Geometry.
     */
    function (geometry) {
        return readGeometry(geometry, opt_options);
    });
    return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__["default"](geometries);
}
/**
 * @param {GeoJSONPoint} object Object.
 * @return {Point} Point.
 */
function readPointGeometry(object) {
    return new _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__["default"](object['coordinates']);
}
/**
 * @param {GeoJSONLineString} object Object.
 * @return {LineString} LineString.
 */
function readLineStringGeometry(object) {
    return new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](object['coordinates']);
}
/**
 * @param {GeoJSONMultiLineString} object Object.
 * @return {MultiLineString} MultiLineString.
 */
function readMultiLineStringGeometry(object) {
    return new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__["default"](object['coordinates']);
}
/**
 * @param {GeoJSONMultiPoint} object Object.
 * @return {MultiPoint} MultiPoint.
 */
function readMultiPointGeometry(object) {
    return new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__["default"](object['coordinates']);
}
/**
 * @param {GeoJSONMultiPolygon} object Object.
 * @return {MultiPolygon} MultiPolygon.
 */
function readMultiPolygonGeometry(object) {
    return new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__["default"](object['coordinates']);
}
/**
 * @param {GeoJSONPolygon} object Object.
 * @return {Polygon} Polygon.
 */
function readPolygonGeometry(object) {
    return new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__["default"](object['coordinates']);
}
/**
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writeGeometry(geometry, opt_options) {
    geometry = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_13__["transformGeometryWithOptions"])(geometry, true, opt_options);
    var type = geometry.getType();
    /** @type {GeoJSONGeometry} */
    var geoJSON;
    switch (type) {
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT: {
            geoJSON = writePointGeometry(
            /** @type {Point} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING: {
            geoJSON = writeLineStringGeometry(
            /** @type {LineString} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON: {
            geoJSON = writePolygonGeometry(
            /** @type {Polygon} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT: {
            geoJSON = writeMultiPointGeometry(
            /** @type {MultiPoint} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING: {
            geoJSON = writeMultiLineStringGeometry(
            /** @type {MultiLineString} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON: {
            geoJSON = writeMultiPolygonGeometry(
            /** @type {MultiPolygon} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].GEOMETRY_COLLECTION: {
            geoJSON = writeGeometryCollectionGeometry(
            /** @type {GeometryCollection} */ (geometry), opt_options);
            break;
        }
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CIRCLE: {
            geoJSON = {
                type: 'GeometryCollection',
                geometries: [],
            };
            break;
        }
        default: {
            throw new Error('Unsupported geometry type: ' + type);
        }
    }
    return geoJSON;
}
/**
 * @param {GeometryCollection} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometryCollection} GeoJSON geometry collection.
 */
function writeGeometryCollectionGeometry(geometry, opt_options) {
    var geometries = geometry.getGeometriesArray().map(function (geometry) {
        var options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_11__["assign"])({}, opt_options);
        delete options.featureProjection;
        return writeGeometry(geometry, options);
    });
    return {
        type: 'GeometryCollection',
        geometries: geometries,
    };
}
/**
 * @param {LineString} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writeLineStringGeometry(geometry, opt_options) {
    return {
        type: 'LineString',
        coordinates: geometry.getCoordinates(),
    };
}
/**
 * @param {MultiLineString} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writeMultiLineStringGeometry(geometry, opt_options) {
    return {
        type: 'MultiLineString',
        coordinates: geometry.getCoordinates(),
    };
}
/**
 * @param {MultiPoint} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writeMultiPointGeometry(geometry, opt_options) {
    return {
        type: 'MultiPoint',
        coordinates: geometry.getCoordinates(),
    };
}
/**
 * @param {MultiPolygon} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writeMultiPolygonGeometry(geometry, opt_options) {
    var right;
    if (opt_options) {
        right = opt_options.rightHanded;
    }
    return {
        type: 'MultiPolygon',
        coordinates: geometry.getCoordinates(right),
    };
}
/**
 * @param {Point} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writePointGeometry(geometry, opt_options) {
    return {
        type: 'Point',
        coordinates: geometry.getCoordinates(),
    };
}
/**
 * @param {Polygon} geometry Geometry.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
 * @return {GeoJSONGeometry} GeoJSON geometry.
 */
function writePolygonGeometry(geometry, opt_options) {
    var right;
    if (opt_options) {
        right = opt_options.rightHanded;
    }
    return {
        type: 'Polygon',
        coordinates: geometry.getCoordinates(right),
    };
}
/* harmony default export */ __webpack_exports__["default"] = (GeoJSON);
//# sourceMappingURL=GeoJSON.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Geometry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/GeometryCollection
 */





/**
 * @classdesc
 * An array of {@link module:ol/geom/Geometry} objects.
 *
 * @api
 */
var GeometryCollection = /** @class */ (function (_super) {
    __extends(GeometryCollection, _super);
    /**
     * @param {Array<Geometry>} [opt_geometries] Geometries.
     */
    function GeometryCollection(opt_geometries) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {Array<Geometry>}
         */
        _this.geometries_ = opt_geometries ? opt_geometries : null;
        /**
         * @type {Array<import("../events.js").EventsKey>}
         */
        _this.changeEventsKeys_ = [];
        _this.listenGeometriesChange_();
        return _this;
    }
    /**
     * @private
     */
    GeometryCollection.prototype.unlistenGeometriesChange_ = function () {
        this.changeEventsKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_4__["unlistenByKey"]);
        this.changeEventsKeys_.length = 0;
    };
    /**
     * @private
     */
    GeometryCollection.prototype.listenGeometriesChange_ = function () {
        if (!this.geometries_) {
            return;
        }
        for (var i = 0, ii = this.geometries_.length; i < ii; ++i) {
            this.changeEventsKeys_.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_4__["listen"])(this.geometries_[i], _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CHANGE, this.changed, this));
        }
    };
    /**
     * Make a complete copy of the geometry.
     * @return {!GeometryCollection} Clone.
     * @api
     */
    GeometryCollection.prototype.clone = function () {
        var geometryCollection = new GeometryCollection(null);
        geometryCollection.setGeometries(this.geometries_);
        geometryCollection.applyProperties(this);
        return geometryCollection;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    GeometryCollection.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        if (minSquaredDistance < Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["closestSquaredDistanceXY"])(this.getExtent(), x, y)) {
            return minSquaredDistance;
        }
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            minSquaredDistance = geometries[i].closestPointXY(x, y, closestPoint, minSquaredDistance);
        }
        return minSquaredDistance;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */
    GeometryCollection.prototype.containsXY = function (x, y) {
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            if (geometries[i].containsXY(x, y)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */
    GeometryCollection.prototype.computeExtent = function (extent) {
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["createOrUpdateEmpty"])(extent);
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["extend"])(extent, geometries[i].getExtent());
        }
        return extent;
    };
    /**
     * Return the geometries that make up this geometry collection.
     * @return {Array<Geometry>} Geometries.
     * @api
     */
    GeometryCollection.prototype.getGeometries = function () {
        return cloneGeometries(this.geometries_);
    };
    /**
     * @return {Array<Geometry>} Geometries.
     */
    GeometryCollection.prototype.getGeometriesArray = function () {
        return this.geometries_;
    };
    /**
     * @return {Array<Geometry>} Geometries.
     */
    GeometryCollection.prototype.getGeometriesArrayRecursive = function () {
        /** @type {Array<Geometry>} */
        var geometriesArray = [];
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            if (geometries[i].getType() === this.getType()) {
                geometriesArray = geometriesArray.concat(
                /** @type {GeometryCollection} */ (geometries[i]).getGeometriesArrayRecursive());
            }
            else {
                geometriesArray.push(geometries[i]);
            }
        }
        return geometriesArray;
    };
    /**
     * Create a simplified version of this geometry using the Douglas Peucker algorithm.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {GeometryCollection} Simplified GeometryCollection.
     */
    GeometryCollection.prototype.getSimplifiedGeometry = function (squaredTolerance) {
        if (this.simplifiedGeometryRevision !== this.getRevision()) {
            this.simplifiedGeometryMaxMinSquaredTolerance = 0;
            this.simplifiedGeometryRevision = this.getRevision();
        }
        if (squaredTolerance < 0 ||
            (this.simplifiedGeometryMaxMinSquaredTolerance !== 0 &&
                squaredTolerance < this.simplifiedGeometryMaxMinSquaredTolerance)) {
            return this;
        }
        var simplifiedGeometries = [];
        var geometries = this.geometries_;
        var simplified = false;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            var geometry = geometries[i];
            var simplifiedGeometry = geometry.getSimplifiedGeometry(squaredTolerance);
            simplifiedGeometries.push(simplifiedGeometry);
            if (simplifiedGeometry !== geometry) {
                simplified = true;
            }
        }
        if (simplified) {
            var simplifiedGeometryCollection = new GeometryCollection(null);
            simplifiedGeometryCollection.setGeometriesArray(simplifiedGeometries);
            return simplifiedGeometryCollection;
        }
        else {
            this.simplifiedGeometryMaxMinSquaredTolerance = squaredTolerance;
            return this;
        }
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    GeometryCollection.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].GEOMETRY_COLLECTION;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    GeometryCollection.prototype.intersectsExtent = function (extent) {
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            if (geometries[i].intersectsExtent(extent)) {
                return true;
            }
        }
        return false;
    };
    /**
     * @return {boolean} Is empty.
     */
    GeometryCollection.prototype.isEmpty = function () {
        return this.geometries_.length === 0;
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */
    GeometryCollection.prototype.rotate = function (angle, anchor) {
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            geometries[i].rotate(angle, anchor);
        }
        this.changed();
    };
    /**
     * Scale the geometry (with an optional origin).  This modifies the geometry
     * coordinates in place.
     * @abstract
     * @param {number} sx The scaling factor in the x-direction.
     * @param {number} [opt_sy] The scaling factor in the y-direction (defaults to sx).
     * @param {import("../coordinate.js").Coordinate} [opt_anchor] The scale origin (defaults to the center
     *     of the geometry extent).
     * @api
     */
    GeometryCollection.prototype.scale = function (sx, opt_sy, opt_anchor) {
        var anchor = opt_anchor;
        if (!anchor) {
            anchor = Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["getCenter"])(this.getExtent());
        }
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            geometries[i].scale(sx, opt_sy, anchor);
        }
        this.changed();
    };
    /**
     * Set the geometries that make up this geometry collection.
     * @param {Array<Geometry>} geometries Geometries.
     * @api
     */
    GeometryCollection.prototype.setGeometries = function (geometries) {
        this.setGeometriesArray(cloneGeometries(geometries));
    };
    /**
     * @param {Array<Geometry>} geometries Geometries.
     */
    GeometryCollection.prototype.setGeometriesArray = function (geometries) {
        this.unlistenGeometriesChange_();
        this.geometries_ = geometries;
        this.listenGeometriesChange_();
        this.changed();
    };
    /**
     * Apply a transform function to the coordinates of the geometry.
     * The geometry is modified in place.
     * If you do not want the geometry modified in place, first `clone()` it and
     * then use this function on the clone.
     * @param {import("../proj.js").TransformFunction} transformFn Transform function.
     * Called with a flat array of geometry coordinates.
     * @api
     */
    GeometryCollection.prototype.applyTransform = function (transformFn) {
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            geometries[i].applyTransform(transformFn);
        }
        this.changed();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */
    GeometryCollection.prototype.translate = function (deltaX, deltaY) {
        var geometries = this.geometries_;
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            geometries[i].translate(deltaX, deltaY);
        }
        this.changed();
    };
    /**
     * Clean up.
     */
    GeometryCollection.prototype.disposeInternal = function () {
        this.unlistenGeometriesChange_();
        _super.prototype.disposeInternal.call(this);
    };
    return GeometryCollection;
}(_Geometry_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @param {Array<Geometry>} geometries Geometries.
 * @return {Array<Geometry>} Cloned geometries.
 */
function cloneGeometries(geometries) {
    var clonedGeometries = [];
    for (var i = 0, ii = geometries.length; i < ii; ++i) {
        clonedGeometries.push(geometries[i].clone());
    }
    return clonedGeometries;
}
/* harmony default export */ __webpack_exports__["default"] = (GeometryCollection);
//# sourceMappingURL=GeometryCollection.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GML3_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(213);
/**
 * @module ol/format/GML
 */

/**
 * Feature format for reading and writing data in the GML format
 * version 3.1.1.
 * Currently only supports GML 3.1.1 Simple Features profile.
 *
 * @class
 * @param {import("./GMLBase.js").Options} [opt_options]
 *     Optional configuration object.
 * @api
 */
var GML = _GML3_js__WEBPACK_IMPORTED_MODULE_0__["default"];
/**
 * Encode an array of features in GML 3.1.1 Simple Features.
 *
 * @function
 * @param {Array<import("../Feature.js").default>} features Features.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
 * @return {string} Result.
 * @api
 */
GML.prototype.writeFeatures;
/**
 * Encode an array of features in the GML 3.1.1 format as an XML node.
 *
 * @function
 * @param {Array<import("../Feature.js").default>} features Features.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
 * @return {Node} Node.
 * @api
 */
GML.prototype.writeFeaturesNode;
/* harmony default export */ __webpack_exports__["default"] = (GML);
//# sourceMappingURL=GML.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GML2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(214);
/* harmony import */ var _GMLBase_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(215);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(103);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(208);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(184);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(217);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(218);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/GML3
 */














/**
 * @const
 * @type {string}
 * @private
 */
var schemaLocation = _GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["GMLNS"] +
    ' http://schemas.opengis.net/gml/3.1.1/profiles/gmlsfProfile/' +
    '1.0.0/gmlsf.xsd';
/**
 * @const
 * @type {Object<string, string>}
 */
var MULTIGEOMETRY_TO_MEMBER_NODENAME = {
    'MultiLineString': 'lineStringMember',
    'MultiCurve': 'curveMember',
    'MultiPolygon': 'polygonMember',
    'MultiSurface': 'surfaceMember',
};
/**
 * @classdesc
 * Feature format for reading and writing data in the GML format
 * version 3.1.1.
 * Currently only supports GML 3.1.1 Simple Features profile.
 *
 * @api
 */
var GML3 = /** @class */ (function (_super) {
    __extends(GML3, _super);
    /**
     * @param {import("./GMLBase.js").Options} [opt_options] Optional configuration object.
     */
    function GML3(opt_options) {
        var _this = this;
        var options = 
        /** @type {import("./GMLBase.js").Options} */
        (opt_options ? opt_options : {});
        _this = _super.call(this, options) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.surface_ = options.surface !== undefined ? options.surface : false;
        /**
         * @private
         * @type {boolean}
         */
        _this.curve_ = options.curve !== undefined ? options.curve : false;
        /**
         * @private
         * @type {boolean}
         */
        _this.multiCurve_ =
            options.multiCurve !== undefined ? options.multiCurve : true;
        /**
         * @private
         * @type {boolean}
         */
        _this.multiSurface_ =
            options.multiSurface !== undefined ? options.multiSurface : true;
        /**
         * @type {string}
         */
        _this.schemaLocation = options.schemaLocation
            ? options.schemaLocation
            : schemaLocation;
        /**
         * @private
         * @type {boolean}
         */
        _this.hasZ = options.hasZ !== undefined ? options.hasZ : false;
        return _this;
    }
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {MultiLineString|undefined} MultiLineString.
     */
    GML3.prototype.readMultiCurve = function (node, objectStack) {
        /** @type {Array<LineString>} */
        var lineStrings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([], this.MULTICURVE_PARSERS, node, objectStack, this);
        if (lineStrings) {
            var multiLineString = new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](lineStrings);
            return multiLineString;
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {MultiPolygon|undefined} MultiPolygon.
     */
    GML3.prototype.readMultiSurface = function (node, objectStack) {
        /** @type {Array<Polygon>} */
        var polygons = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([], this.MULTISURFACE_PARSERS, node, objectStack, this);
        if (polygons) {
            return new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_5__["default"](polygons);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML3.prototype.curveMemberParser = function (node, objectStack) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["parseNode"])(this.CURVEMEMBER_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML3.prototype.surfaceMemberParser = function (node, objectStack) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["parseNode"])(this.SURFACEMEMBER_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<(Array<number>)>|undefined} flat coordinates.
     */
    GML3.prototype.readPatch = function (node, objectStack) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.PATCHES_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} flat coordinates.
     */
    GML3.prototype.readSegment = function (node, objectStack) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.SEGMENTS_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<(Array<number>)>|undefined} flat coordinates.
     */
    GML3.prototype.readPolygonPatch = function (node, objectStack) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.FLAT_LINEAR_RINGS_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} flat coordinates.
     */
    GML3.prototype.readLineStringSegment = function (node, objectStack) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML3.prototype.interiorParser = function (node, objectStack) {
        /** @type {Array<number>|undefined} */
        var flatLinearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])(undefined, this.RING_PARSERS, node, objectStack, this);
        if (flatLinearRing) {
            var flatLinearRings = 
            /** @type {Array<Array<number>>} */
            (objectStack[objectStack.length - 1]);
            flatLinearRings.push(flatLinearRing);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML3.prototype.exteriorParser = function (node, objectStack) {
        /** @type {Array<number>|undefined} */
        var flatLinearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])(undefined, this.RING_PARSERS, node, objectStack, this);
        if (flatLinearRing) {
            var flatLinearRings = 
            /** @type {Array<Array<number>>} */
            (objectStack[objectStack.length - 1]);
            flatLinearRings[0] = flatLinearRing;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Polygon|undefined} Polygon.
     */
    GML3.prototype.readSurface = function (node, objectStack) {
        /** @type {Array<Array<number>>} */
        var flatLinearRings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.SURFACE_PARSERS, node, objectStack, this);
        if (flatLinearRings && flatLinearRings[0]) {
            var flatCoordinates = flatLinearRings[0];
            var ends = [flatCoordinates.length];
            var i = void 0, ii = void 0;
            for (i = 1, ii = flatLinearRings.length; i < ii; ++i) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_10__["extend"])(flatCoordinates, flatLinearRings[i]);
                ends.push(flatCoordinates.length);
            }
            return new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_6__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZ, ends);
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {LineString|undefined} LineString.
     */
    GML3.prototype.readCurve = function (node, objectStack) {
        /** @type {Array<number>} */
        var flatCoordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.CURVE_PARSERS, node, objectStack, this);
        if (flatCoordinates) {
            var lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_3__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZ);
            return lineString;
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {import("../extent.js").Extent|undefined} Envelope.
     */
    GML3.prototype.readEnvelope = function (node, objectStack) {
        /** @type {Array<number>} */
        var flatCoordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([null], this.ENVELOPE_PARSERS, node, objectStack, this);
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["createOrUpdate"])(flatCoordinates[1][0], flatCoordinates[1][1], flatCoordinates[2][0], flatCoordinates[2][1]);
    };
    /**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} Flat coordinates.
     */
    GML3.prototype.readFlatPos = function (node, objectStack) {
        var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["getAllTextContent"])(node, false);
        var re = /^\s*([+\-]?\d*\.?\d+(?:[eE][+\-]?\d+)?)\s*/;
        /** @type {Array<number>} */
        var flatCoordinates = [];
        var m;
        while ((m = re.exec(s))) {
            flatCoordinates.push(parseFloat(m[1]));
            s = s.substr(m[0].length);
        }
        if (s !== '') {
            return undefined;
        }
        var context = objectStack[0];
        var containerSrs = context['srsName'];
        var axisOrientation = 'enu';
        if (containerSrs) {
            var proj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["get"])(containerSrs);
            axisOrientation = proj.getAxisOrientation();
        }
        if (axisOrientation === 'neu') {
            var i = void 0, ii = void 0;
            for (i = 0, ii = flatCoordinates.length; i < ii; i += 3) {
                var y = flatCoordinates[i];
                var x = flatCoordinates[i + 1];
                flatCoordinates[i] = x;
                flatCoordinates[i + 1] = y;
            }
        }
        var len = flatCoordinates.length;
        if (len == 2) {
            flatCoordinates.push(0);
        }
        if (len === 0) {
            return undefined;
        }
        return flatCoordinates;
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} Flat coordinates.
     */
    GML3.prototype.readFlatPosList = function (node, objectStack) {
        var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["getAllTextContent"])(node, false).replace(/^\s*|\s*$/g, '');
        var context = objectStack[0];
        var containerSrs = context['srsName'];
        var contextDimension = context['srsDimension'];
        var axisOrientation = 'enu';
        if (containerSrs) {
            var proj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["get"])(containerSrs);
            axisOrientation = proj.getAxisOrientation();
        }
        var coords = s.split(/\s+/);
        // The "dimension" attribute is from the GML 3.0.1 spec.
        var dim = 2;
        if (node.getAttribute('srsDimension')) {
            dim = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["readNonNegativeIntegerString"])(node.getAttribute('srsDimension'));
        }
        else if (node.getAttribute('dimension')) {
            dim = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["readNonNegativeIntegerString"])(node.getAttribute('dimension'));
        }
        else if (
        /** @type {Element} */ (node.parentNode).getAttribute('srsDimension')) {
            dim = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["readNonNegativeIntegerString"])(
            /** @type {Element} */ (node.parentNode).getAttribute('srsDimension'));
        }
        else if (contextDimension) {
            dim = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["readNonNegativeIntegerString"])(contextDimension);
        }
        var x, y, z;
        var flatCoordinates = [];
        for (var i = 0, ii = coords.length; i < ii; i += dim) {
            x = parseFloat(coords[i]);
            y = parseFloat(coords[i + 1]);
            z = dim === 3 ? parseFloat(coords[i + 2]) : 0;
            if (axisOrientation.substr(0, 2) === 'en') {
                flatCoordinates.push(x, y, z);
            }
            else {
                flatCoordinates.push(y, x, z);
            }
        }
        return flatCoordinates;
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/Point.js").default} value Point geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML3.prototype.writePos_ = function (node, value, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsDimension = hasZ ? '3' : '2';
        node.setAttribute('srsDimension', srsDimension);
        var srsName = context['srsName'];
        var axisOrientation = 'enu';
        if (srsName) {
            axisOrientation = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["get"])(srsName).getAxisOrientation();
        }
        var point = value.getCoordinates();
        var coords;
        // only 2d for simple features profile
        if (axisOrientation.substr(0, 2) === 'en') {
            coords = point[0] + ' ' + point[1];
        }
        else {
            coords = point[1] + ' ' + point[0];
        }
        if (hasZ) {
            // For newly created points, Z can be undefined.
            var z = point[2] || 0;
            coords += ' ' + z;
        }
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["writeStringTextNode"])(node, coords);
    };
    /**
     * @param {Array<number>} point Point geometry.
     * @param {string} [opt_srsName] Optional srsName
     * @param {boolean} [opt_hasZ] whether the geometry has a Z coordinate (is 3D) or not.
     * @return {string} The coords string.
     * @private
     */
    GML3.prototype.getCoords_ = function (point, opt_srsName, opt_hasZ) {
        var axisOrientation = 'enu';
        if (opt_srsName) {
            axisOrientation = Object(_proj_js__WEBPACK_IMPORTED_MODULE_11__["get"])(opt_srsName).getAxisOrientation();
        }
        var coords = axisOrientation.substr(0, 2) === 'en'
            ? point[0] + ' ' + point[1]
            : point[1] + ' ' + point[0];
        if (opt_hasZ) {
            // For newly created points, Z can be undefined.
            var z = point[2] || 0;
            coords += ' ' + z;
        }
        return coords;
    };
    /**
     * @param {Element} node Node.
     * @param {LineString|import("../geom/LinearRing.js").default} value Geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML3.prototype.writePosList_ = function (node, value, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsDimension = hasZ ? '3' : '2';
        node.setAttribute('srsDimension', srsDimension);
        var srsName = context['srsName'];
        // only 2d for simple features profile
        var points = value.getCoordinates();
        var len = points.length;
        var parts = new Array(len);
        var point;
        for (var i = 0; i < len; ++i) {
            point = points[i];
            parts[i] = this.getCoords_(point, srsName, hasZ);
        }
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["writeStringTextNode"])(node, parts.join(' '));
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/Point.js").default} geometry Point geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writePoint = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var pos = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'pos');
        node.appendChild(pos);
        this.writePos_(pos, geometry, objectStack);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeEnvelope = function (node, extent, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var keys = ['lowerCorner', 'upperCorner'];
        var values = [extent[0] + ' ' + extent[1], extent[2] + ' ' + extent[3]];
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        ({ node: node }), this.ENVELOPE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_7__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, keys, this);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/LinearRing.js").default} geometry LinearRing geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeLinearRing = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var posList = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'posList');
        node.appendChild(posList);
        this.writePosList_(posList, geometry, objectStack);
    };
    /**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Node} Node.
     * @private
     */
    GML3.prototype.RING_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var context = objectStack[objectStack.length - 1];
        var parentNode = context.node;
        var exteriorWritten = context['exteriorWritten'];
        if (exteriorWritten === undefined) {
            context['exteriorWritten'] = true;
        }
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(parentNode.namespaceURI, exteriorWritten !== undefined ? 'interior' : 'exterior');
    };
    /**
     * @param {Element} node Node.
     * @param {Polygon} geometry Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeSurfaceOrPolygon = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        if (node.nodeName !== 'PolygonPatch' && srsName) {
            node.setAttribute('srsName', srsName);
        }
        if (node.nodeName === 'Polygon' || node.nodeName === 'PolygonPatch') {
            var rings = geometry.getLinearRings();
            Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName }, this.RING_SERIALIZERS, this.RING_NODE_FACTORY_, rings, objectStack, undefined, this);
        }
        else if (node.nodeName === 'Surface') {
            var patches = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'patches');
            node.appendChild(patches);
            this.writeSurfacePatches_(patches, geometry, objectStack);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {LineString} geometry LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeCurveOrLineString = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (node.nodeName !== 'LineStringSegment' && srsName) {
            node.setAttribute('srsName', srsName);
        }
        if (node.nodeName === 'LineString' ||
            node.nodeName === 'LineStringSegment') {
            var posList = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'posList');
            node.appendChild(posList);
            this.writePosList_(posList, geometry, objectStack);
        }
        else if (node.nodeName === 'Curve') {
            var segments = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'segments');
            node.appendChild(segments);
            this.writeCurveSegments_(segments, geometry, objectStack);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {MultiPolygon} geometry MultiPolygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeMultiSurfaceOrPolygon = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        var surface = context['surface'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var polygons = geometry.getPolygons();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName, surface: surface }, this.SURFACEORPOLYGONMEMBER_SERIALIZERS, this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, polygons, objectStack, undefined, this);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/MultiPoint.js").default} geometry MultiPoint geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeMultiPoint = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        var hasZ = context['hasZ'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var points = geometry.getPoints();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName }, this.POINTMEMBER_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSimpleNodeFactory"])('pointMember'), points, objectStack, undefined, this);
    };
    /**
     * @param {Element} node Node.
     * @param {MultiLineString} geometry MultiLineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeMultiCurveOrLineString = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        var curve = context['curve'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var lines = geometry.getLineStrings();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName, curve: curve }, this.LINESTRINGORCURVEMEMBER_SERIALIZERS, this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, lines, objectStack, undefined, this);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/LinearRing.js").default} ring LinearRing geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeRing = function (node, ring, objectStack) {
        var linearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'LinearRing');
        node.appendChild(linearRing);
        this.writeLinearRing(linearRing, ring, objectStack);
    };
    /**
     * @param {Node} node Node.
     * @param {Polygon} polygon Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeSurfaceOrPolygonMember = function (node, polygon, objectStack) {
        var child = this.GEOMETRY_NODE_FACTORY_(polygon, objectStack);
        if (child) {
            node.appendChild(child);
            this.writeSurfaceOrPolygon(child, polygon, objectStack);
        }
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Point.js").default} point Point geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writePointMember = function (node, point, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'Point');
        node.appendChild(child);
        this.writePoint(child, point, objectStack);
    };
    /**
     * @param {Node} node Node.
     * @param {LineString} line LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeLineStringOrCurveMember = function (node, line, objectStack) {
        var child = this.GEOMETRY_NODE_FACTORY_(line, objectStack);
        if (child) {
            node.appendChild(child);
            this.writeCurveOrLineString(child, line, objectStack);
        }
    };
    /**
     * @param {Node} node Node.
     * @param {Polygon} polygon Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML3.prototype.writeSurfacePatches_ = function (node, polygon, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'PolygonPatch');
        node.appendChild(child);
        this.writeSurfaceOrPolygon(child, polygon, objectStack);
    };
    /**
     * @param {Node} node Node.
     * @param {LineString} line LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML3.prototype.writeCurveSegments_ = function (node, line, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(node.namespaceURI, 'LineStringSegment');
        node.appendChild(child);
        this.writeCurveOrLineString(child, line, objectStack);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Geometry.js").default|import("../extent.js").Extent} geometry Geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeGeometryElement = function (node, geometry, objectStack) {
        var context = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[objectStack.length - 1]);
        var item = Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, context);
        item['node'] = node;
        var value;
        if (Array.isArray(geometry)) {
            value = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_13__["transformExtentWithOptions"])(
            /** @type {import("../extent.js").Extent} */ (geometry), context);
        }
        else {
            value = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_13__["transformGeometryWithOptions"])(
            /** @type {import("../geom/Geometry.js").default} */ (geometry), true, context);
        }
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        (item), this.GEOMETRY_SERIALIZERS, this.GEOMETRY_NODE_FACTORY_, [value], objectStack, undefined, this);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../Feature.js").default} feature Feature.
     * @param {Array<*>} objectStack Node stack.
     */
    GML3.prototype.writeFeatureElement = function (node, feature, objectStack) {
        var fid = feature.getId();
        if (fid) {
            node.setAttribute('fid', /** @type {string} */ (fid));
        }
        var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
        var featureNS = context['featureNS'];
        var geometryName = feature.getGeometryName();
        if (!context.serializers) {
            context.serializers = {};
            context.serializers[featureNS] = {};
        }
        var keys = [];
        var values = [];
        if (feature.hasProperties()) {
            var properties = feature.getProperties();
            for (var key in properties) {
                var value = properties[key];
                if (value !== null) {
                    keys.push(key);
                    values.push(value);
                    if (key == geometryName ||
                        typeof ( /** @type {?} */(value).getSimplifiedGeometry) ===
                            'function') {
                        if (!(key in context.serializers[featureNS])) {
                            context.serializers[featureNS][key] = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(this.writeGeometryElement, this);
                        }
                    }
                    else {
                        if (!(key in context.serializers[featureNS])) {
                            context.serializers[featureNS][key] =
                                Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["writeStringTextNode"]);
                        }
                    }
                }
            }
        }
        var item = Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, context);
        item.node = node;
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        (item), context.serializers, Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSimpleNodeFactory"])(undefined, featureNS), values, objectStack, keys);
    };
    /**
     * @param {Node} node Node.
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML3.prototype.writeFeatureMembers_ = function (node, features, objectStack) {
        var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
        var featureType = context['featureType'];
        var featureNS = context['featureNS'];
        /** @type {Object<string, Object<string, import("../xml.js").Serializer>>} */
        var serializers = {};
        serializers[featureNS] = {};
        serializers[featureNS][featureType] = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(this.writeFeatureElement, this);
        var item = Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, context);
        item.node = node;
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        (item), serializers, Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSimpleNodeFactory"])(featureType, featureNS), features, objectStack);
    };
    /**
     * @const
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Node|undefined} Node.
     * @private
     */
    GML3.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var parentNode = objectStack[objectStack.length - 1].node;
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(this.namespace, MULTIGEOMETRY_TO_MEMBER_NODENAME[parentNode.nodeName]);
    };
    /**
     * @const
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Element|undefined} Node.
     * @private
     */
    GML3.prototype.GEOMETRY_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var context = objectStack[objectStack.length - 1];
        var multiSurface = context['multiSurface'];
        var surface = context['surface'];
        var curve = context['curve'];
        var multiCurve = context['multiCurve'];
        var nodeName;
        if (!Array.isArray(value)) {
            nodeName = /** @type {import("../geom/Geometry.js").default} */ (value).getType();
            if (nodeName === 'MultiPolygon' && multiSurface === true) {
                nodeName = 'MultiSurface';
            }
            else if (nodeName === 'Polygon' && surface === true) {
                nodeName = 'Surface';
            }
            else if (nodeName === 'LineString' && curve === true) {
                nodeName = 'Curve';
            }
            else if (nodeName === 'MultiLineString' && multiCurve === true) {
                nodeName = 'MultiCurve';
            }
        }
        else {
            nodeName = 'Envelope';
        }
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(this.namespace, nodeName);
    };
    /**
     * Encode a geometry in GML 3.1.1 Simple Features.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Node} Node.
     * @api
     */
    GML3.prototype.writeGeometryNode = function (geometry, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var geom = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(this.namespace, 'geom');
        var context = {
            node: geom,
            hasZ: this.hasZ,
            srsName: this.srsName,
            curve: this.curve_,
            surface: this.surface_,
            multiSurface: this.multiSurface_,
            multiCurve: this.multiCurve_,
        };
        if (opt_options) {
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, opt_options);
        }
        this.writeGeometryElement(geom, geometry, [context]);
        return geom;
    };
    /**
     * Encode an array of features in the GML 3.1.1 format as an XML node.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Element} Node.
     * @api
     */
    GML3.prototype.writeFeaturesNode = function (features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var node = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(this.namespace, 'featureMembers');
        node.setAttributeNS(_xml_js__WEBPACK_IMPORTED_MODULE_7__["XML_SCHEMA_INSTANCE_URI"], 'xsi:schemaLocation', this.schemaLocation);
        var context = {
            srsName: this.srsName,
            hasZ: this.hasZ,
            curve: this.curve_,
            surface: this.surface_,
            multiSurface: this.multiSurface_,
            multiCurve: this.multiCurve_,
            featureNS: this.featureNS,
            featureType: this.featureType,
        };
        if (opt_options) {
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, opt_options);
        }
        this.writeFeatureMembers_(node, features, [context]);
        return node;
    };
    return GML3;
}(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
    'http://www.opengis.net/gml': {
        'pos': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readFlatPos),
        'posList': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readFlatPosList),
        'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readFlatCoordinates),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.FLAT_LINEAR_RINGS_PARSERS = {
    'http://www.opengis.net/gml': {
        'interior': GML3.prototype.interiorParser,
        'exterior': GML3.prototype.exteriorParser,
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.GEOMETRY_PARSERS = {
    'http://www.opengis.net/gml': {
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readPoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readMultiLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readMultiPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readSurface),
        'MultiSurface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readMultiSurface),
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readCurve),
        'MultiCurve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readMultiCurve),
        'Envelope': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readEnvelope),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.MULTICURVE_PARSERS = {
    'http://www.opengis.net/gml': {
        'curveMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.curveMemberParser),
        'curveMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.curveMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.MULTISURFACE_PARSERS = {
    'http://www.opengis.net/gml': {
        'surfaceMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.surfaceMemberParser),
        'surfaceMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.surfaceMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.CURVEMEMBER_PARSERS = {
    'http://www.opengis.net/gml': {
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readLineString),
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.readCurve),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.SURFACEMEMBER_PARSERS = {
    'http://www.opengis.net/gml': {
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.readSurface),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.SURFACE_PARSERS = {
    'http://www.opengis.net/gml': {
        'patches': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readPatch),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.CURVE_PARSERS = {
    'http://www.opengis.net/gml': {
        'segments': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readSegment),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.ENVELOPE_PARSERS = {
    'http://www.opengis.net/gml': {
        'lowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.readFlatPosList),
        'upperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(GML3.prototype.readFlatPosList),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.PATCHES_PARSERS = {
    'http://www.opengis.net/gml': {
        'PolygonPatch': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readPolygonPatch),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML3.prototype.SEGMENTS_PARSERS = {
    'http://www.opengis.net/gml': {
        'LineStringSegment': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeReplacer"])(GML3.prototype.readLineStringSegment),
    },
};
/**
 * Encode an array of features in GML 3.1.1 Simple Features.
 *
 * @function
 * @param {Array<import("../Feature.js").default>} features Features.
 * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
 * @return {string} Result.
 * @api
 */
GML3.prototype.writeFeatures;
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.RING_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'exterior': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeRing),
        'interior': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeRing),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.ENVELOPE_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'lowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["writeStringTextNode"]),
        'upperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_12__["writeStringTextNode"]),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'surfaceMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeSurfaceOrPolygonMember),
        'polygonMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeSurfaceOrPolygonMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.POINTMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'pointMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writePointMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'lineStringMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeLineStringOrCurveMember),
        'curveMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeLineStringOrCurveMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML3.prototype.GEOMETRY_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeCurveOrLineString),
        'MultiCurve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeMultiCurveOrLineString),
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writePoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeCurveOrLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeMultiCurveOrLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeSurfaceOrPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeMultiSurfaceOrPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeSurfaceOrPolygon),
        'MultiSurface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeMultiSurfaceOrPolygon),
        'Envelope': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(GML3.prototype.writeEnvelope),
    },
};
/* harmony default export */ __webpack_exports__["default"] = (GML3);
//# sourceMappingURL=GML3.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GMLBase_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(215);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(217);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(202);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(218);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/GML2
 */







/**
 * @const
 * @type {string}
 */
var schemaLocation = _GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["GMLNS"] + ' http://schemas.opengis.net/gml/2.1.2/feature.xsd';
/**
 * @const
 * @type {Object<string, string>}
 */
var MULTIGEOMETRY_TO_MEMBER_NODENAME = {
    'MultiLineString': 'lineStringMember',
    'MultiCurve': 'curveMember',
    'MultiPolygon': 'polygonMember',
    'MultiSurface': 'surfaceMember',
};
/**
 * @classdesc
 * Feature format for reading and writing data in the GML format,
 * version 2.1.2.
 *
 * @api
 */
var GML2 = /** @class */ (function (_super) {
    __extends(GML2, _super);
    /**
     * @param {import("./GMLBase.js").Options} [opt_options] Optional configuration object.
     */
    function GML2(opt_options) {
        var _this = this;
        var options = 
        /** @type {import("./GMLBase.js").Options} */
        (opt_options ? opt_options : {});
        _this = _super.call(this, options) || this;
        _this.FEATURE_COLLECTION_PARSERS[_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["GMLNS"]]['featureMember'] = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeArrayPusher"])(_this.readFeaturesInternal);
        /**
         * @type {string}
         */
        _this.schemaLocation = options.schemaLocation
            ? options.schemaLocation
            : schemaLocation;
        return _this;
    }
    /**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} Flat coordinates.
     */
    GML2.prototype.readFlatCoordinates = function (node, objectStack) {
        var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["getAllTextContent"])(node, false).replace(/^\s*|\s*$/g, '');
        var context = /** @type {import("../xml.js").NodeStackItem} */ (objectStack[0]);
        var containerSrs = context['srsName'];
        var axisOrientation = 'enu';
        if (containerSrs) {
            var proj = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["get"])(containerSrs);
            if (proj) {
                axisOrientation = proj.getAxisOrientation();
            }
        }
        var coordsGroups = s.trim().split(/\s+/);
        var flatCoordinates = [];
        for (var i = 0, ii = coordsGroups.length; i < ii; i++) {
            var coords = coordsGroups[i].split(/,+/);
            var x = parseFloat(coords[0]);
            var y = parseFloat(coords[1]);
            var z = coords.length === 3 ? parseFloat(coords[2]) : 0;
            if (axisOrientation.substr(0, 2) === 'en') {
                flatCoordinates.push(x, y, z);
            }
            else {
                flatCoordinates.push(y, x, z);
            }
        }
        return flatCoordinates;
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {import("../extent.js").Extent|undefined} Envelope.
     */
    GML2.prototype.readBox = function (node, objectStack) {
        /** @type {Array<number>} */
        var flatCoordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])([null], this.BOX_PARSERS_, node, objectStack, this);
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_3__["createOrUpdate"])(flatCoordinates[1][0], flatCoordinates[1][1], flatCoordinates[1][3], flatCoordinates[1][4]);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML2.prototype.innerBoundaryIsParser = function (node, objectStack) {
        /** @type {Array<number>|undefined} */
        var flatLinearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])(undefined, this.RING_PARSERS, node, objectStack, this);
        if (flatLinearRing) {
            var flatLinearRings = 
            /** @type {Array<Array<number>>} */
            (objectStack[objectStack.length - 1]);
            flatLinearRings.push(flatLinearRing);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GML2.prototype.outerBoundaryIsParser = function (node, objectStack) {
        /** @type {Array<number>|undefined} */
        var flatLinearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])(undefined, this.RING_PARSERS, node, objectStack, this);
        if (flatLinearRing) {
            var flatLinearRings = 
            /** @type {Array<Array<number>>} */
            (objectStack[objectStack.length - 1]);
            flatLinearRings[0] = flatLinearRing;
        }
    };
    /**
     * @const
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Element|undefined} Node.
     * @private
     */
    GML2.prototype.GEOMETRY_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var context = objectStack[objectStack.length - 1];
        var multiSurface = context['multiSurface'];
        var surface = context['surface'];
        var multiCurve = context['multiCurve'];
        var nodeName;
        if (!Array.isArray(value)) {
            nodeName = /** @type {import("../geom/Geometry.js").default} */ (value).getType();
            if (nodeName === 'MultiPolygon' && multiSurface === true) {
                nodeName = 'MultiSurface';
            }
            else if (nodeName === 'Polygon' && surface === true) {
                nodeName = 'Surface';
            }
            else if (nodeName === 'MultiLineString' && multiCurve === true) {
                nodeName = 'MultiCurve';
            }
        }
        else {
            nodeName = 'Envelope';
        }
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])('http://www.opengis.net/gml', nodeName);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../Feature.js").default} feature Feature.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeFeatureElement = function (node, feature, objectStack) {
        var fid = feature.getId();
        if (fid) {
            node.setAttribute('fid', /** @type {string} */ (fid));
        }
        var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
        var featureNS = context['featureNS'];
        var geometryName = feature.getGeometryName();
        if (!context.serializers) {
            context.serializers = {};
            context.serializers[featureNS] = {};
        }
        var keys = [];
        var values = [];
        if (feature.hasProperties()) {
            var properties = feature.getProperties();
            for (var key in properties) {
                var value = properties[key];
                if (value !== null) {
                    keys.push(key);
                    values.push(value);
                    if (key == geometryName ||
                        typeof ( /** @type {?} */(value).getSimplifiedGeometry) ===
                            'function') {
                        if (!(key in context.serializers[featureNS])) {
                            context.serializers[featureNS][key] = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(this.writeGeometryElement, this);
                        }
                    }
                    else {
                        if (!(key in context.serializers[featureNS])) {
                            context.serializers[featureNS][key] =
                                Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_6__["writeStringTextNode"]);
                        }
                    }
                }
            }
        }
        var item = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, context);
        item.node = node;
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        (item), context.serializers, Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeSimpleNodeFactory"])(undefined, featureNS), values, objectStack, keys);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/LineString.js").default} geometry LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeCurveOrLineString = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (node.nodeName !== 'LineStringSegment' && srsName) {
            node.setAttribute('srsName', srsName);
        }
        if (node.nodeName === 'LineString' ||
            node.nodeName === 'LineStringSegment') {
            var coordinates = this.createCoordinatesNode_(node.namespaceURI);
            node.appendChild(coordinates);
            this.writeCoordinates_(coordinates, geometry, objectStack);
        }
        else if (node.nodeName === 'Curve') {
            var segments = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'segments');
            node.appendChild(segments);
            this.writeCurveSegments_(segments, geometry, objectStack);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/LineString.js").default} line LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeLineStringOrCurveMember = function (node, line, objectStack) {
        var child = this.GEOMETRY_NODE_FACTORY_(line, objectStack);
        if (child) {
            node.appendChild(child);
            this.writeCurveOrLineString(child, line, objectStack);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/MultiLineString.js").default} geometry MultiLineString geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeMultiCurveOrLineString = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        var curve = context['curve'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var lines = geometry.getLineStrings();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName, curve: curve }, this.LINESTRINGORCURVEMEMBER_SERIALIZERS, this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, lines, objectStack, undefined, this);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Geometry.js").default|import("../extent.js").Extent} geometry Geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeGeometryElement = function (node, geometry, objectStack) {
        var context = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[objectStack.length - 1]);
        var item = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, context);
        item['node'] = node;
        var value;
        if (Array.isArray(geometry)) {
            value = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_5__["transformExtentWithOptions"])(
            /** @type {import("../extent.js").Extent} */ (geometry), context);
        }
        else {
            value = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_5__["transformGeometryWithOptions"])(
            /** @type {import("../geom/Geometry.js").default} */ (geometry), true, context);
        }
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        (item), this.GEOMETRY_SERIALIZERS, this.GEOMETRY_NODE_FACTORY_, [value], objectStack, undefined, this);
    };
    /**
     * @param {string} namespaceURI XML namespace.
     * @return {Element} coordinates node.
     * @private
     */
    GML2.prototype.createCoordinatesNode_ = function (namespaceURI) {
        var coordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(namespaceURI, 'coordinates');
        coordinates.setAttribute('decimal', '.');
        coordinates.setAttribute('cs', ',');
        coordinates.setAttribute('ts', ' ');
        return coordinates;
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/LineString.js").default|import("../geom/LinearRing.js").default} value Geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML2.prototype.writeCoordinates_ = function (node, value, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        // only 2d for simple features profile
        var points = value.getCoordinates();
        var len = points.length;
        var parts = new Array(len);
        for (var i = 0; i < len; ++i) {
            var point = points[i];
            parts[i] = this.getCoords_(point, srsName, hasZ);
        }
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_6__["writeStringTextNode"])(node, parts.join(' '));
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/LineString.js").default} line LineString geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML2.prototype.writeCurveSegments_ = function (node, line, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'LineStringSegment');
        node.appendChild(child);
        this.writeCurveOrLineString(child, line, objectStack);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeSurfaceOrPolygon = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        if (node.nodeName !== 'PolygonPatch' && srsName) {
            node.setAttribute('srsName', srsName);
        }
        if (node.nodeName === 'Polygon' || node.nodeName === 'PolygonPatch') {
            var rings = geometry.getLinearRings();
            Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName }, this.RING_SERIALIZERS, this.RING_NODE_FACTORY_, rings, objectStack, undefined, this);
        }
        else if (node.nodeName === 'Surface') {
            var patches = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'patches');
            node.appendChild(patches);
            this.writeSurfacePatches_(patches, geometry, objectStack);
        }
    };
    /**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Node} Node.
     * @private
     */
    GML2.prototype.RING_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var context = objectStack[objectStack.length - 1];
        var parentNode = context.node;
        var exteriorWritten = context['exteriorWritten'];
        if (exteriorWritten === undefined) {
            context['exteriorWritten'] = true;
        }
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(parentNode.namespaceURI, exteriorWritten !== undefined ? 'innerBoundaryIs' : 'outerBoundaryIs');
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Polygon.js").default} polygon Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     * @private
     */
    GML2.prototype.writeSurfacePatches_ = function (node, polygon, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'PolygonPatch');
        node.appendChild(child);
        this.writeSurfaceOrPolygon(child, polygon, objectStack);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/LinearRing.js").default} ring LinearRing geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeRing = function (node, ring, objectStack) {
        var linearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'LinearRing');
        node.appendChild(linearRing);
        this.writeLinearRing(linearRing, ring, objectStack);
    };
    /**
     * @param {Array<number>} point Point geometry.
     * @param {string} [opt_srsName] Optional srsName
     * @param {boolean} [opt_hasZ] whether the geometry has a Z coordinate (is 3D) or not.
     * @return {string} The coords string.
     * @private
     */
    GML2.prototype.getCoords_ = function (point, opt_srsName, opt_hasZ) {
        var axisOrientation = 'enu';
        if (opt_srsName) {
            axisOrientation = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["get"])(opt_srsName).getAxisOrientation();
        }
        var coords = axisOrientation.substr(0, 2) === 'en'
            ? point[0] + ',' + point[1]
            : point[1] + ',' + point[0];
        if (opt_hasZ) {
            // For newly created points, Z can be undefined.
            var z = point[2] || 0;
            coords += ',' + z;
        }
        return coords;
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/Point.js").default} geometry Point geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writePoint = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var coordinates = this.createCoordinatesNode_(node.namespaceURI);
        node.appendChild(coordinates);
        var point = geometry.getCoordinates();
        var coord = this.getCoords_(point, srsName, hasZ);
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_6__["writeStringTextNode"])(coordinates, coord);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/MultiPoint.js").default} geometry MultiPoint geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeMultiPoint = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var points = geometry.getPoints();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName }, this.POINTMEMBER_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeSimpleNodeFactory"])('pointMember'), points, objectStack, undefined, this);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Point.js").default} point Point geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writePointMember = function (node, point, objectStack) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])(node.namespaceURI, 'Point');
        node.appendChild(child);
        this.writePoint(child, point, objectStack);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/LinearRing.js").default} geometry LinearRing geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeLinearRing = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var coordinates = this.createCoordinatesNode_(node.namespaceURI);
        node.appendChild(coordinates);
        this.writeCoordinates_(coordinates, geometry, objectStack);
    };
    /**
     * @param {Element} node Node.
     * @param {import("../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeMultiSurfaceOrPolygon = function (node, geometry, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var hasZ = context['hasZ'];
        var srsName = context['srsName'];
        var surface = context['surface'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var polygons = geometry.getPolygons();
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])({ node: node, hasZ: hasZ, srsName: srsName, surface: surface }, this.SURFACEORPOLYGONMEMBER_SERIALIZERS, this.MULTIGEOMETRY_MEMBER_NODE_FACTORY_, polygons, objectStack, undefined, this);
    };
    /**
     * @param {Node} node Node.
     * @param {import("../geom/Polygon.js").default} polygon Polygon geometry.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeSurfaceOrPolygonMember = function (node, polygon, objectStack) {
        var child = this.GEOMETRY_NODE_FACTORY_(polygon, objectStack);
        if (child) {
            node.appendChild(child);
            this.writeSurfaceOrPolygon(child, polygon, objectStack);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {Array<*>} objectStack Node stack.
     */
    GML2.prototype.writeEnvelope = function (node, extent, objectStack) {
        var context = objectStack[objectStack.length - 1];
        var srsName = context['srsName'];
        if (srsName) {
            node.setAttribute('srsName', srsName);
        }
        var keys = ['lowerCorner', 'upperCorner'];
        var values = [extent[0] + ' ' + extent[1], extent[2] + ' ' + extent[3]];
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        ({ node: node }), this.ENVELOPE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_1__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, keys, this);
    };
    /**
     * @const
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Node|undefined} Node.
     * @private
     */
    GML2.prototype.MULTIGEOMETRY_MEMBER_NODE_FACTORY_ = function (value, objectStack, opt_nodeName) {
        var parentNode = objectStack[objectStack.length - 1].node;
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["createElementNS"])('http://www.opengis.net/gml', MULTIGEOMETRY_TO_MEMBER_NODENAME[parentNode.nodeName]);
    };
    return GML2;
}(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML2.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
    'http://www.opengis.net/gml': {
        'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(GML2.prototype.readFlatCoordinates),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML2.prototype.FLAT_LINEAR_RINGS_PARSERS = {
    'http://www.opengis.net/gml': {
        'innerBoundaryIs': GML2.prototype.innerBoundaryIsParser,
        'outerBoundaryIs': GML2.prototype.outerBoundaryIsParser,
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML2.prototype.BOX_PARSERS_ = {
    'http://www.opengis.net/gml': {
        'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeArrayPusher"])(GML2.prototype.readFlatCoordinates),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML2.prototype.GEOMETRY_PARSERS = {
    'http://www.opengis.net/gml': {
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readPoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readMultiLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readMultiPolygon),
        'Box': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeReplacer"])(GML2.prototype.readBox),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.GEOMETRY_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeCurveOrLineString),
        'MultiCurve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeMultiCurveOrLineString),
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writePoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeCurveOrLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeMultiCurveOrLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeSurfaceOrPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeMultiSurfaceOrPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeSurfaceOrPolygon),
        'MultiSurface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeMultiSurfaceOrPolygon),
        'Envelope': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeEnvelope),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'lineStringMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeLineStringOrCurveMember),
        'curveMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeLineStringOrCurveMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.RING_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'outerBoundaryIs': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeRing),
        'innerBoundaryIs': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeRing),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.POINTMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'pointMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writePointMember),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'surfaceMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeSurfaceOrPolygonMember),
        'polygonMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(GML2.prototype.writeSurfaceOrPolygonMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML2.prototype.ENVELOPE_SERIALIZERS = {
    'http://www.opengis.net/gml': {
        'lowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_6__["writeStringTextNode"]),
        'upperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_6__["writeStringTextNode"]),
    },
};
/* harmony default export */ __webpack_exports__["default"] = (GML2);
//# sourceMappingURL=GML2.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GMLNS", function() { return GMLNS; });
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(203);
/* harmony import */ var _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(184);
/* harmony import */ var _XMLFeature_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(216);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(15);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(217);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/GMLBase
 */
// FIXME Envelopes should not be treated as geometries! readEnvelope_ is part
// of GEOMETRY_PARSERS_ and methods using GEOMETRY_PARSERS_ do not expect
// envelopes/extents, only geometries!















/**
 * @const
 * @type {string}
 */
var GMLNS = 'http://www.opengis.net/gml';
/**
 * A regular expression that matches if a string only contains whitespace
 * characters. It will e.g. match `''`, `' '`, `'\n'` etc. The non-breaking
 * space (0xa0) is explicitly included as IE doesn't include it in its
 * definition of `\s`.
 *
 * Information from `goog.string.isEmptyOrWhitespace`: https://github.com/google/closure-library/blob/e877b1e/closure/goog/string/string.js#L156-L160
 *
 * @const
 * @type {RegExp}
 */
var ONLY_WHITESPACE_RE = /^[\s\xa0]*$/;
/**
 * @typedef {Object} Options
 * @property {Object<string, string>|string} [featureNS] Feature
 * namespace. If not defined will be derived from GML. If multiple
 * feature types have been configured which come from different feature
 * namespaces, this will be an object with the keys being the prefixes used
 * in the entries of featureType array. The values of the object will be the
 * feature namespaces themselves. So for instance there might be a featureType
 * item `topp:states` in the `featureType` array and then there will be a key
 * `topp` in the featureNS object with value `http://www.openplans.org/topp`.
 * @property {Array<string>|string} [featureType] Feature type(s) to parse.
 * If multiple feature types need to be configured
 * which come from different feature namespaces, `featureNS` will be an object
 * with the keys being the prefixes used in the entries of featureType array.
 * The values of the object will be the feature namespaces themselves.
 * So for instance there might be a featureType item `topp:states` and then
 * there will be a key named `topp` in the featureNS object with value
 * `http://www.openplans.org/topp`.
 * @property {string} srsName srsName to use when writing geometries.
 * @property {boolean} [surface=false] Write gml:Surface instead of gml:Polygon
 * elements. This also affects the elements in multi-part geometries.
 * @property {boolean} [curve=false] Write gml:Curve instead of gml:LineString
 * elements. This also affects the elements in multi-part geometries.
 * @property {boolean} [multiCurve=true] Write gml:MultiCurve instead of gml:MultiLineString.
 * Since the latter is deprecated in GML 3.
 * @property {boolean} [multiSurface=true] Write gml:multiSurface instead of
 * gml:MultiPolygon. Since the latter is deprecated in GML 3.
 * @property {string} [schemaLocation] Optional schemaLocation to use when
 * writing out the GML, this will override the default provided.
 * @property {boolean} [hasZ=false] If coordinates have a Z value.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Feature base format for reading and writing data in the GML format.
 * This class cannot be instantiated, it contains only base content that
 * is shared with versioned format classes GML2 and GML3.
 *
 * @abstract
 */
var GMLBase = /** @class */ (function (_super) {
    __extends(GMLBase, _super);
    /**
     * @param {Options} [opt_options] Optional configuration object.
     */
    function GMLBase(opt_options) {
        var _this = _super.call(this) || this;
        var options = /** @type {Options} */ (opt_options ? opt_options : {});
        /**
         * @protected
         * @type {Array<string>|string|undefined}
         */
        _this.featureType = options.featureType;
        /**
         * @protected
         * @type {Object<string, string>|string|undefined}
         */
        _this.featureNS = options.featureNS;
        /**
         * @protected
         * @type {string}
         */
        _this.srsName = options.srsName;
        /**
         * @protected
         * @type {string}
         */
        _this.schemaLocation = '';
        /**
         * @type {Object<string, Object<string, Object>>}
         */
        _this.FEATURE_COLLECTION_PARSERS = {};
        _this.FEATURE_COLLECTION_PARSERS[_this.namespace] = {
            'featureMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(_this.readFeaturesInternal),
            'featureMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeReplacer"])(_this.readFeaturesInternal),
        };
        return _this;
    }
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<Feature> | undefined} Features.
     */
    GMLBase.prototype.readFeaturesInternal = function (node, objectStack) {
        var localName = node.localName;
        var features = null;
        if (localName == 'FeatureCollection') {
            features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([], this.FEATURE_COLLECTION_PARSERS, node, objectStack, this);
        }
        else if (localName == 'featureMembers' ||
            localName == 'featureMember' ||
            localName == 'member') {
            var context = objectStack[0];
            var featureType = context['featureType'];
            var featureNS = context['featureNS'];
            var prefix = 'p';
            var defaultPrefix = 'p0';
            if (!featureType && node.childNodes) {
                (featureType = []), (featureNS = {});
                for (var i = 0, ii = node.childNodes.length; i < ii; ++i) {
                    var child = node.childNodes[i];
                    if (child.nodeType === 1) {
                        var ft = child.nodeName.split(':').pop();
                        if (featureType.indexOf(ft) === -1) {
                            var key = '';
                            var count = 0;
                            var uri = child.namespaceURI;
                            for (var candidate in featureNS) {
                                if (featureNS[candidate] === uri) {
                                    key = candidate;
                                    break;
                                }
                                ++count;
                            }
                            if (!key) {
                                key = prefix + count;
                                featureNS[key] = uri;
                            }
                            featureType.push(key + ':' + ft);
                        }
                    }
                }
                if (localName != 'featureMember') {
                    // recheck featureType for each featureMember
                    context['featureType'] = featureType;
                    context['featureNS'] = featureNS;
                }
            }
            if (typeof featureNS === 'string') {
                var ns = featureNS;
                featureNS = {};
                featureNS[defaultPrefix] = ns;
            }
            /** @type {Object<string, Object<string, import("../xml.js").Parser>>} */
            var parsersNS = {};
            var featureTypes = Array.isArray(featureType)
                ? featureType
                : [featureType];
            for (var p in featureNS) {
                /** @type {Object<string, import("../xml.js").Parser>} */
                var parsers = {};
                for (var i = 0, ii = featureTypes.length; i < ii; ++i) {
                    var featurePrefix = featureTypes[i].indexOf(':') === -1
                        ? defaultPrefix
                        : featureTypes[i].split(':')[0];
                    if (featurePrefix === p) {
                        parsers[featureTypes[i].split(':').pop()] =
                            localName == 'featureMembers'
                                ? Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(this.readFeatureElement, this)
                                : Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeReplacer"])(this.readFeatureElement, this);
                    }
                }
                parsersNS[featureNS[p]] = parsers;
            }
            if (localName == 'featureMember' || localName == 'member') {
                features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])(undefined, parsersNS, node, objectStack);
            }
            else {
                features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([], parsersNS, node, objectStack);
            }
        }
        if (features === null) {
            features = [];
        }
        return features;
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {import("../geom/Geometry.js").default|import("../extent.js").Extent|undefined} Geometry.
     */
    GMLBase.prototype.readGeometryElement = function (node, objectStack) {
        var context = /** @type {Object} */ (objectStack[0]);
        context['srsName'] = node.firstElementChild.getAttribute('srsName');
        context['srsDimension'] =
            node.firstElementChild.getAttribute('srsDimension');
        var geometry = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])(null, this.GEOMETRY_PARSERS, node, objectStack, this);
        if (geometry) {
            if (Array.isArray(geometry)) {
                return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_14__["transformExtentWithOptions"])(
                /** @type {import("../extent.js").Extent} */ (geometry), context);
            }
            else {
                return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_14__["transformGeometryWithOptions"])(
                /** @type {import("../geom/Geometry.js").default} */ (geometry), false, context);
            }
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @param {boolean} asFeature whether result should be wrapped as a feature.
     * @return {Feature|Object} Feature
     */
    GMLBase.prototype.readFeatureElementInternal = function (node, objectStack, asFeature) {
        var geometryName;
        var values = {};
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            var value = void 0;
            var localName = n.localName;
            // first, check if it is simple attribute
            if (n.childNodes.length === 0 ||
                (n.childNodes.length === 1 &&
                    (n.firstChild.nodeType === 3 || n.firstChild.nodeType === 4))) {
                value = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["getAllTextContent"])(n, false);
                if (ONLY_WHITESPACE_RE.test(value)) {
                    value = undefined;
                }
            }
            else {
                if (asFeature) {
                    //if feature, try it as a geometry
                    value = this.readGeometryElement(n, objectStack);
                }
                if (!value) {
                    //if not a geometry or not a feature, treat it as a complex attribute
                    value = this.readFeatureElementInternal(n, objectStack, false);
                }
                else if (localName !== 'boundedBy') {
                    // boundedBy is an extent and must not be considered as a geometry
                    geometryName = localName;
                }
            }
            if (values[localName]) {
                if (!(values[localName] instanceof Array)) {
                    values[localName] = [values[localName]];
                }
                values[localName].push(value);
            }
            else {
                values[localName] = value;
            }
            var len = n.attributes.length;
            if (len > 0) {
                values[localName] = { _content_: values[localName] };
                for (var i = 0; i < len; i++) {
                    var attName = n.attributes[i].name;
                    values[localName][attName] = n.attributes[i].value;
                }
            }
        }
        if (!asFeature) {
            return values;
        }
        else {
            var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](values);
            if (geometryName) {
                feature.setGeometryName(geometryName);
            }
            var fid = node.getAttribute('fid') || Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["getAttributeNS"])(node, this.namespace, 'id');
            if (fid) {
                feature.setId(fid);
            }
            return feature;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Feature} Feature.
     */
    GMLBase.prototype.readFeatureElement = function (node, objectStack) {
        return this.readFeatureElementInternal(node, objectStack, true);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Point|undefined} Point.
     */
    GMLBase.prototype.readPoint = function (node, objectStack) {
        var flatCoordinates = this.readFlatCoordinatesFromNode(node, objectStack);
        if (flatCoordinates) {
            return new _geom_Point_js__WEBPACK_IMPORTED_MODULE_7__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {MultiPoint|undefined} MultiPoint.
     */
    GMLBase.prototype.readMultiPoint = function (node, objectStack) {
        /** @type {Array<Array<number>>} */
        var coordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([], this.MULTIPOINT_PARSERS, node, objectStack, this);
        if (coordinates) {
            return new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_5__["default"](coordinates);
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {MultiLineString|undefined} MultiLineString.
     */
    GMLBase.prototype.readMultiLineString = function (node, objectStack) {
        /** @type {Array<LineString>} */
        var lineStrings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([], this.MULTILINESTRING_PARSERS, node, objectStack, this);
        if (lineStrings) {
            return new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](lineStrings);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {MultiPolygon|undefined} MultiPolygon.
     */
    GMLBase.prototype.readMultiPolygon = function (node, objectStack) {
        /** @type {Array<Polygon>} */
        var polygons = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([], this.MULTIPOLYGON_PARSERS, node, objectStack, this);
        if (polygons) {
            return new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_6__["default"](polygons);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GMLBase.prototype.pointMemberParser = function (node, objectStack) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["parseNode"])(this.POINTMEMBER_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GMLBase.prototype.lineStringMemberParser = function (node, objectStack) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["parseNode"])(this.LINESTRINGMEMBER_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    GMLBase.prototype.polygonMemberParser = function (node, objectStack) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["parseNode"])(this.POLYGONMEMBER_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {LineString|undefined} LineString.
     */
    GMLBase.prototype.readLineString = function (node, objectStack) {
        var flatCoordinates = this.readFlatCoordinatesFromNode(node, objectStack);
        if (flatCoordinates) {
            var lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ);
            return lineString;
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>|undefined} LinearRing flat coordinates.
     */
    GMLBase.prototype.readFlatLinearRing = function (node, objectStack) {
        var ring = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])(null, this.GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack, this);
        if (ring) {
            return ring;
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {LinearRing|undefined} LinearRing.
     */
    GMLBase.prototype.readLinearRing = function (node, objectStack) {
        var flatCoordinates = this.readFlatCoordinatesFromNode(node, objectStack);
        if (flatCoordinates) {
            return new _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_3__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Polygon|undefined} Polygon.
     */
    GMLBase.prototype.readPolygon = function (node, objectStack) {
        /** @type {Array<Array<number>>} */
        var flatLinearRings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])([null], this.FLAT_LINEAR_RINGS_PARSERS, node, objectStack, this);
        if (flatLinearRings && flatLinearRings[0]) {
            var flatCoordinates = flatLinearRings[0];
            var ends = [flatCoordinates.length];
            var i = void 0, ii = void 0;
            for (i = 1, ii = flatLinearRings.length; i < ii; ++i) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_11__["extend"])(flatCoordinates, flatLinearRings[i]);
                ends.push(flatCoordinates.length);
            }
            return new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_8__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ, ends);
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<number>} Flat coordinates.
     */
    GMLBase.prototype.readFlatCoordinatesFromNode = function (node, objectStack) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["pushParseAndPop"])(null, this.GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack, this);
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @protected
     * @return {import("../geom/Geometry.js").default|import("../extent.js").Extent} Geometry.
     */
    //@ts-ignore
    GMLBase.prototype.readGeometryFromNode = function (node, opt_options) {
        var geometry = this.readGeometryElement(node, [
            this.getReadOptions(node, opt_options ? opt_options : {}),
        ]);
        return geometry ? geometry : null;
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */
    GMLBase.prototype.readFeaturesFromNode = function (node, opt_options) {
        var options = {
            featureType: this.featureType,
            featureNS: this.featureNS,
        };
        if (opt_options) {
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_10__["assign"])(options, this.getReadOptions(node, opt_options));
        }
        var features = this.readFeaturesInternal(node, [options]);
        return features || [];
    };
    /**
     * @param {Element} node Node.
     * @return {import("../proj/Projection.js").default} Projection.
     */
    GMLBase.prototype.readProjectionFromNode = function (node) {
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_13__["get"])(this.srsName
            ? this.srsName
            : node.firstElementChild.getAttribute('srsName'));
    };
    return GMLBase;
}(_XMLFeature_js__WEBPACK_IMPORTED_MODULE_9__["default"]));
GMLBase.prototype.namespace = GMLNS;
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.FLAT_LINEAR_RINGS_PARSERS = {
    'http://www.opengis.net/gml': {},
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
    'http://www.opengis.net/gml': {},
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.GEOMETRY_PARSERS = {
    'http://www.opengis.net/gml': {},
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.MULTIPOINT_PARSERS = {
    'http://www.opengis.net/gml': {
        'pointMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.pointMemberParser),
        'pointMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.pointMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.MULTILINESTRING_PARSERS = {
    'http://www.opengis.net/gml': {
        'lineStringMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.lineStringMemberParser),
        'lineStringMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.lineStringMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.MULTIPOLYGON_PARSERS = {
    'http://www.opengis.net/gml': {
        'polygonMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.polygonMemberParser),
        'polygonMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.polygonMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.POINTMEMBER_PARSERS = {
    'http://www.opengis.net/gml': {
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.readFlatCoordinatesFromNode),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.LINESTRINGMEMBER_PARSERS = {
    'http://www.opengis.net/gml': {
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.readLineString),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.POLYGONMEMBER_PARSERS = {
    'http://www.opengis.net/gml': {
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeArrayPusher"])(GMLBase.prototype.readPolygon),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GMLBase.prototype.RING_PARSERS = {
    'http://www.opengis.net/gml': {
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_12__["makeReplacer"])(GMLBase.prototype.readFlatLinearRing),
    },
};
/* harmony default export */ __webpack_exports__["default"] = (GMLBase);
//# sourceMappingURL=GMLBase.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _format_Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(202);
/* harmony import */ var _format_FormatType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(217);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/XMLFeature
 */





/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for XML feature formats.
 *
 * @abstract
 */
var XMLFeature = /** @class */ (function (_super) {
    __extends(XMLFeature, _super);
    function XMLFeature() {
        var _this = _super.call(this) || this;
        /**
         * @type {XMLSerializer}
         * @private
         */
        _this.xmlSerializer_ = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["getXMLSerializer"])();
        return _this;
    }
    /**
     * @return {import("./FormatType.js").default} Format.
     */
    XMLFeature.prototype.getType = function () {
        return _format_FormatType_js__WEBPACK_IMPORTED_MODULE_1__["default"].XML;
    };
    /**
     * Read a single feature.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */
    XMLFeature.prototype.readFeature = function (source, opt_options) {
        if (!source) {
            return null;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["parse"])(source);
            return this.readFeatureFromDocument(doc, opt_options);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["isDocument"])(source)) {
            return this.readFeatureFromDocument(
            /** @type {Document} */ (source), opt_options);
        }
        else {
            return this.readFeatureFromNode(
            /** @type {Element} */ (source), opt_options);
        }
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {import("../Feature.js").default} Feature.
     */
    XMLFeature.prototype.readFeatureFromDocument = function (doc, opt_options) {
        var features = this.readFeaturesFromDocument(doc, opt_options);
        if (features.length > 0) {
            return features[0];
        }
        else {
            return null;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {import("../Feature.js").default} Feature.
     */
    XMLFeature.prototype.readFeatureFromNode = function (node, opt_options) {
        return null; // not implemented
    };
    /**
     * Read all features from a feature collection.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */
    XMLFeature.prototype.readFeatures = function (source, opt_options) {
        if (!source) {
            return [];
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["parse"])(source);
            return this.readFeaturesFromDocument(doc, opt_options);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["isDocument"])(source)) {
            return this.readFeaturesFromDocument(
            /** @type {Document} */ (source), opt_options);
        }
        else {
            return this.readFeaturesFromNode(
            /** @type {Element} */ (source), opt_options);
        }
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */
    XMLFeature.prototype.readFeaturesFromDocument = function (doc, opt_options) {
        /** @type {Array<import("../Feature.js").default>} */
        var features = [];
        for (var n = doc.firstChild; n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_3__["extend"])(features, this.readFeaturesFromNode(/** @type {Element} */ (n), opt_options));
            }
        }
        return features;
    };
    /**
     * @abstract
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */
    XMLFeature.prototype.readFeaturesFromNode = function (node, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read a single geometry from a source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    XMLFeature.prototype.readGeometry = function (source, opt_options) {
        if (!source) {
            return null;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["parse"])(source);
            return this.readGeometryFromDocument(doc, opt_options);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["isDocument"])(source)) {
            return this.readGeometryFromDocument(
            /** @type {Document} */ (source), opt_options);
        }
        else {
            return this.readGeometryFromNode(
            /** @type {Element} */ (source), opt_options);
        }
    };
    /**
     * @param {Document} doc Document.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    XMLFeature.prototype.readGeometryFromDocument = function (doc, opt_options) {
        return null; // not implemented
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    XMLFeature.prototype.readGeometryFromNode = function (node, opt_options) {
        return null; // not implemented
    };
    /**
     * Read the projection from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */
    XMLFeature.prototype.readProjection = function (source) {
        if (!source) {
            return null;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["parse"])(source);
            return this.readProjectionFromDocument(doc);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["isDocument"])(source)) {
            return this.readProjectionFromDocument(/** @type {Document} */ (source));
        }
        else {
            return this.readProjectionFromNode(/** @type {Element} */ (source));
        }
    };
    /**
     * @param {Document} doc Document.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    XMLFeature.prototype.readProjectionFromDocument = function (doc) {
        return this.dataProjection;
    };
    /**
     * @param {Element} node Node.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    XMLFeature.prototype.readProjectionFromNode = function (node) {
        return this.dataProjection;
    };
    /**
     * Encode a feature as string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded feature.
     */
    XMLFeature.prototype.writeFeature = function (feature, opt_options) {
        var node = this.writeFeatureNode(feature, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @protected
     * @return {Node} Node.
     */
    XMLFeature.prototype.writeFeatureNode = function (feature, opt_options) {
        return null; // not implemented
    };
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Result.
     * @api
     */
    XMLFeature.prototype.writeFeatures = function (features, opt_options) {
        var node = this.writeFeaturesNode(features, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Node} Node.
     */
    XMLFeature.prototype.writeFeaturesNode = function (features, opt_options) {
        return null; // not implemented
    };
    /**
     * Encode a geometry as string.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded geometry.
     */
    XMLFeature.prototype.writeGeometry = function (geometry, opt_options) {
        var node = this.writeGeometryNode(geometry, opt_options);
        return this.xmlSerializer_.serializeToString(node);
    };
    /**
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Node} Node.
     */
    XMLFeature.prototype.writeGeometryNode = function (geometry, opt_options) {
        return null; // not implemented
    };
    return XMLFeature;
}(_format_Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (XMLFeature);
//# sourceMappingURL=XMLFeature.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "XML_SCHEMA_INSTANCE_URI", function() { return XML_SCHEMA_INSTANCE_URI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElementNS", function() { return createElementNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllTextContent", function() { return getAllTextContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllTextContent_", function() { return getAllTextContent_; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isDocument", function() { return isDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttributeNS", function() { return getAttributeNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return parse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeArrayExtender", function() { return makeArrayExtender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeArrayPusher", function() { return makeArrayPusher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeReplacer", function() { return makeReplacer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeObjectPropertyPusher", function() { return makeObjectPropertyPusher; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeObjectPropertySetter", function() { return makeObjectPropertySetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeChildAppender", function() { return makeChildAppender; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeArraySerializer", function() { return makeArraySerializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeSimpleNodeFactory", function() { return makeSimpleNodeFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OBJECT_PROPERTY_NODE_FACTORY", function() { return OBJECT_PROPERTY_NODE_FACTORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeSequence", function() { return makeSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "makeStructureNS", function() { return makeStructureNS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseNode", function() { return parseNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushParseAndPop", function() { return pushParseAndPop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "serialize", function() { return serialize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pushSerializeAndPop", function() { return pushSerializeAndPop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerXMLSerializer", function() { return registerXMLSerializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getXMLSerializer", function() { return getXMLSerializer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerDocument", function() { return registerDocument; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocument", function() { return getDocument; });
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/**
 * @module ol/xml
 */

/**
 * When using {@link module:ol/xml.makeChildAppender} or
 * {@link module:ol/xml.makeSimpleNodeFactory}, the top `objectStack` item needs
 * to have this structure.
 * @typedef {Object} NodeStackItem
 * @property {Node} node Node.
 */
/**
 * @typedef {function(Element, Array<*>): void} Parser
 */
/**
 * @typedef {function(Element, *, Array<*>): void} Serializer
 */
/**
 * @type {string}
 */
var XML_SCHEMA_INSTANCE_URI = 'http://www.w3.org/2001/XMLSchema-instance';
/**
 * @param {string} namespaceURI Namespace URI.
 * @param {string} qualifiedName Qualified name.
 * @return {Element} Node.
 */
function createElementNS(namespaceURI, qualifiedName) {
    return getDocument().createElementNS(namespaceURI, qualifiedName);
}
/**
 * Recursively grab all text content of child nodes into a single string.
 * @param {Node} node Node.
 * @param {boolean} normalizeWhitespace Normalize whitespace: remove all line
 * breaks.
 * @return {string} All text content.
 * @api
 */
function getAllTextContent(node, normalizeWhitespace) {
    return getAllTextContent_(node, normalizeWhitespace, []).join('');
}
/**
 * Recursively grab all text content of child nodes into a single string.
 * @param {Node} node Node.
 * @param {boolean} normalizeWhitespace Normalize whitespace: remove all line
 * breaks.
 * @param {Array<string>} accumulator Accumulator.
 * @private
 * @return {Array<string>} Accumulator.
 */
function getAllTextContent_(node, normalizeWhitespace, accumulator) {
    if (node.nodeType == Node.CDATA_SECTION_NODE ||
        node.nodeType == Node.TEXT_NODE) {
        if (normalizeWhitespace) {
            accumulator.push(String(node.nodeValue).replace(/(\r\n|\r|\n)/g, ''));
        }
        else {
            accumulator.push(node.nodeValue);
        }
    }
    else {
        var n = void 0;
        for (n = node.firstChild; n; n = n.nextSibling) {
            getAllTextContent_(n, normalizeWhitespace, accumulator);
        }
    }
    return accumulator;
}
/**
 * @param {Object} object Object.
 * @return {boolean} Is a document.
 */
function isDocument(object) {
    return 'documentElement' in object;
}
/**
 * @param {Element} node Node.
 * @param {?string} namespaceURI Namespace URI.
 * @param {string} name Attribute name.
 * @return {string} Value
 */
function getAttributeNS(node, namespaceURI, name) {
    return node.getAttributeNS(namespaceURI, name) || '';
}
/**
 * Parse an XML string to an XML Document.
 * @param {string} xml XML.
 * @return {Document} Document.
 * @api
 */
function parse(xml) {
    return new DOMParser().parseFromString(xml, 'application/xml');
}
/**
 * Make an array extender function for extending the array at the top of the
 * object stack.
 * @param {function(this: T, Node, Array<*>): (Array<*>|undefined)} valueReader Value reader.
 * @param {T} [opt_this] The object to use as `this` in `valueReader`.
 * @return {Parser} Parser.
 * @template T
 */
function makeArrayExtender(valueReader, opt_this) {
    return (
    /**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    function (node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var array = /** @type {Array<*>} */ (objectStack[objectStack.length - 1]);
            Object(_array_js__WEBPACK_IMPORTED_MODULE_0__["extend"])(array, value);
        }
    });
}
/**
 * Make an array pusher function for pushing to the array at the top of the
 * object stack.
 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
 * @param {T} [opt_this] The object to use as `this` in `valueReader`.
 * @return {Parser} Parser.
 * @template T
 */
function makeArrayPusher(valueReader, opt_this) {
    return (
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    function (node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var array = /** @type {Array<*>} */ (objectStack[objectStack.length - 1]);
            array.push(value);
        }
    });
}
/**
 * Make an object stack replacer function for replacing the object at the
 * top of the stack.
 * @param {function(this: T, Node, Array<*>): *} valueReader Value reader.
 * @param {T} [opt_this] The object to use as `this` in `valueReader`.
 * @return {Parser} Parser.
 * @template T
 */
function makeReplacer(valueReader, opt_this) {
    return (
    /**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    function (node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            objectStack[objectStack.length - 1] = value;
        }
    });
}
/**
 * Make an object property pusher function for adding a property to the
 * object at the top of the stack.
 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
 * @param {string} [opt_property] Property.
 * @param {T} [opt_this] The object to use as `this` in `valueReader`.
 * @return {Parser} Parser.
 * @template T
 */
function makeObjectPropertyPusher(valueReader, opt_property, opt_this) {
    return (
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    function (node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var object = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
            var property = opt_property !== undefined ? opt_property : node.localName;
            var array = void 0;
            if (property in object) {
                array = object[property];
            }
            else {
                array = [];
                object[property] = array;
            }
            array.push(value);
        }
    });
}
/**
 * Make an object property setter function.
 * @param {function(this: T, Element, Array<*>): *} valueReader Value reader.
 * @param {string} [opt_property] Property.
 * @param {T} [opt_this] The object to use as `this` in `valueReader`.
 * @return {Parser} Parser.
 * @template T
 */
function makeObjectPropertySetter(valueReader, opt_property, opt_this) {
    return (
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     */
    function (node, objectStack) {
        var value = valueReader.call(opt_this !== undefined ? opt_this : this, node, objectStack);
        if (value !== undefined) {
            var object = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
            var property = opt_property !== undefined ? opt_property : node.localName;
            object[property] = value;
        }
    });
}
/**
 * Create a serializer that appends nodes written by its `nodeWriter` to its
 * designated parent. The parent is the `node` of the
 * {@link module:ol/xml~NodeStackItem} at the top of the `objectStack`.
 * @param {function(this: T, Node, V, Array<*>): void} nodeWriter Node writer.
 * @param {T} [opt_this] The object to use as `this` in `nodeWriter`.
 * @return {Serializer} Serializer.
 * @template T, V
 */
function makeChildAppender(nodeWriter, opt_this) {
    return function (node, value, objectStack) {
        nodeWriter.call(opt_this !== undefined ? opt_this : this, node, value, objectStack);
        var parent = /** @type {NodeStackItem} */ (objectStack[objectStack.length - 1]);
        var parentNode = parent.node;
        parentNode.appendChild(node);
    };
}
/**
 * Create a serializer that calls the provided `nodeWriter` from
 * {@link module:ol/xml.serialize}. This can be used by the parent writer to have the
 * 'nodeWriter' called with an array of values when the `nodeWriter` was
 * designed to serialize a single item. An example would be a LineString
 * geometry writer, which could be reused for writing MultiLineString
 * geometries.
 * @param {function(this: T, Element, V, Array<*>): void} nodeWriter Node writer.
 * @param {T} [opt_this] The object to use as `this` in `nodeWriter`.
 * @return {Serializer} Serializer.
 * @template T, V
 */
function makeArraySerializer(nodeWriter, opt_this) {
    var serializersNS, nodeFactory;
    return function (node, value, objectStack) {
        if (serializersNS === undefined) {
            serializersNS = {};
            var serializers = {};
            serializers[node.localName] = nodeWriter;
            serializersNS[node.namespaceURI] = serializers;
            nodeFactory = makeSimpleNodeFactory(node.localName);
        }
        serialize(serializersNS, nodeFactory, value, objectStack);
    };
}
/**
 * Create a node factory which can use the `opt_keys` passed to
 * {@link module:ol/xml.serialize} or {@link module:ol/xml.pushSerializeAndPop} as node names,
 * or a fixed node name. The namespace of the created nodes can either be fixed,
 * or the parent namespace will be used.
 * @param {string} [opt_nodeName] Fixed node name which will be used for all
 *     created nodes. If not provided, the 3rd argument to the resulting node
 *     factory needs to be provided and will be the nodeName.
 * @param {string} [opt_namespaceURI] Fixed namespace URI which will be used for
 *     all created nodes. If not provided, the namespace of the parent node will
 *     be used.
 * @return {function(*, Array<*>, string=): (Node|undefined)} Node factory.
 */
function makeSimpleNodeFactory(opt_nodeName, opt_namespaceURI) {
    var fixedNodeName = opt_nodeName;
    return (
    /**
     * @param {*} value Value.
     * @param {Array<*>} objectStack Object stack.
     * @param {string} [opt_nodeName] Node name.
     * @return {Node} Node.
     */
    function (value, objectStack, opt_nodeName) {
        var context = /** @type {NodeStackItem} */ (objectStack[objectStack.length - 1]);
        var node = context.node;
        var nodeName = fixedNodeName;
        if (nodeName === undefined) {
            nodeName = opt_nodeName;
        }
        var namespaceURI = opt_namespaceURI !== undefined ? opt_namespaceURI : node.namespaceURI;
        return createElementNS(namespaceURI, /** @type {string} */ (nodeName));
    });
}
/**
 * A node factory that creates a node using the parent's `namespaceURI` and the
 * `nodeName` passed by {@link module:ol/xml.serialize} or
 * {@link module:ol/xml.pushSerializeAndPop} to the node factory.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var OBJECT_PROPERTY_NODE_FACTORY = makeSimpleNodeFactory();
/**
 * Create an array of `values` to be used with {@link module:ol/xml.serialize} or
 * {@link module:ol/xml.pushSerializeAndPop}, where `orderedKeys` has to be provided as
 * `opt_key` argument.
 * @param {Object<string, *>} object Key-value pairs for the sequence. Keys can
 *     be a subset of the `orderedKeys`.
 * @param {Array<string>} orderedKeys Keys in the order of the sequence.
 * @return {Array<*>} Values in the order of the sequence. The resulting array
 *     has the same length as the `orderedKeys` array. Values that are not
 *     present in `object` will be `undefined` in the resulting array.
 */
function makeSequence(object, orderedKeys) {
    var length = orderedKeys.length;
    var sequence = new Array(length);
    for (var i = 0; i < length; ++i) {
        sequence[i] = object[orderedKeys[i]];
    }
    return sequence;
}
/**
 * Create a namespaced structure, using the same values for each namespace.
 * This can be used as a starting point for versioned parsers, when only a few
 * values are version specific.
 * @param {Array<string>} namespaceURIs Namespace URIs.
 * @param {T} structure Structure.
 * @param {Object<string, T>} [opt_structureNS] Namespaced structure to add to.
 * @return {Object<string, T>} Namespaced structure.
 * @template T
 */
function makeStructureNS(namespaceURIs, structure, opt_structureNS) {
    /**
     * @type {Object<string, T>}
     */
    var structureNS = opt_structureNS !== undefined ? opt_structureNS : {};
    var i, ii;
    for (i = 0, ii = namespaceURIs.length; i < ii; ++i) {
        structureNS[namespaceURIs[i]] = structure;
    }
    return structureNS;
}
/**
 * Parse a node using the parsers and object stack.
 * @param {Object<string, Object<string, Parser>>} parsersNS
 *     Parsers by namespace.
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @param {*} [opt_this] The object to use as `this`.
 */
function parseNode(parsersNS, node, objectStack, opt_this) {
    var n;
    for (n = node.firstElementChild; n; n = n.nextElementSibling) {
        var parsers = parsersNS[n.namespaceURI];
        if (parsers !== undefined) {
            var parser = parsers[n.localName];
            if (parser !== undefined) {
                parser.call(opt_this, n, objectStack);
            }
        }
    }
}
/**
 * Push an object on top of the stack, parse and return the popped object.
 * @param {T} object Object.
 * @param {Object<string, Object<string, Parser>>} parsersNS
 *     Parsers by namespace.
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @param {*} [opt_this] The object to use as `this`.
 * @return {T} Object.
 * @template T
 */
function pushParseAndPop(object, parsersNS, node, objectStack, opt_this) {
    objectStack.push(object);
    parseNode(parsersNS, node, objectStack, opt_this);
    return /** @type {T} */ (objectStack.pop());
}
/**
 * Walk through an array of `values` and call a serializer for each value.
 * @param {Object<string, Object<string, Serializer>>} serializersNS
 *     Namespaced serializers.
 * @param {function(this: T, *, Array<*>, (string|undefined)): (Node|undefined)} nodeFactory
 *     Node factory. The `nodeFactory` creates the node whose namespace and name
 *     will be used to choose a node writer from `serializersNS`. This
 *     separation allows us to decide what kind of node to create, depending on
 *     the value we want to serialize. An example for this would be different
 *     geometry writers based on the geometry type.
 * @param {Array<*>} values Values to serialize. An example would be an array
 *     of {@link module:ol/Feature~Feature} instances.
 * @param {Array<*>} objectStack Node stack.
 * @param {Array<string>} [opt_keys] Keys of the `values`. Will be passed to the
 *     `nodeFactory`. This is used for serializing object literals where the
 *     node name relates to the property key. The array length of `opt_keys` has
 *     to match the length of `values`. For serializing a sequence, `opt_keys`
 *     determines the order of the sequence.
 * @param {T} [opt_this] The object to use as `this` for the node factory and
 *     serializers.
 * @template T
 */
function serialize(serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
    var length = (opt_keys !== undefined ? opt_keys : values).length;
    var value, node;
    for (var i = 0; i < length; ++i) {
        value = values[i];
        if (value !== undefined) {
            node = nodeFactory.call(opt_this !== undefined ? opt_this : this, value, objectStack, opt_keys !== undefined ? opt_keys[i] : undefined);
            if (node !== undefined) {
                serializersNS[node.namespaceURI][node.localName].call(opt_this, node, value, objectStack);
            }
        }
    }
}
/**
 * @param {O} object Object.
 * @param {Object<string, Object<string, Serializer>>} serializersNS
 *     Namespaced serializers.
 * @param {function(this: T, *, Array<*>, (string|undefined)): (Node|undefined)} nodeFactory
 *     Node factory. The `nodeFactory` creates the node whose namespace and name
 *     will be used to choose a node writer from `serializersNS`. This
 *     separation allows us to decide what kind of node to create, depending on
 *     the value we want to serialize. An example for this would be different
 *     geometry writers based on the geometry type.
 * @param {Array<*>} values Values to serialize. An example would be an array
 *     of {@link module:ol/Feature~Feature} instances.
 * @param {Array<*>} objectStack Node stack.
 * @param {Array<string>} [opt_keys] Keys of the `values`. Will be passed to the
 *     `nodeFactory`. This is used for serializing object literals where the
 *     node name relates to the property key. The array length of `opt_keys` has
 *     to match the length of `values`. For serializing a sequence, `opt_keys`
 *     determines the order of the sequence.
 * @param {T} [opt_this] The object to use as `this` for the node factory and
 *     serializers.
 * @return {O|undefined} Object.
 * @template O, T
 */
function pushSerializeAndPop(object, serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this) {
    objectStack.push(object);
    serialize(serializersNS, nodeFactory, values, objectStack, opt_keys, opt_this);
    return /** @type {O|undefined} */ (objectStack.pop());
}
var xmlSerializer_ = undefined;
/**
 * Register a XMLSerializer. Can be used  to inject a XMLSerializer
 * where there is no globally available implementation.
 *
 * @param {XMLSerializer} xmlSerializer A XMLSerializer.
 * @api
 */
function registerXMLSerializer(xmlSerializer) {
    xmlSerializer_ = xmlSerializer;
}
/**
 * @return {XMLSerializer} The XMLSerializer.
 */
function getXMLSerializer() {
    if (xmlSerializer_ === undefined && typeof XMLSerializer !== 'undefined') {
        xmlSerializer_ = new XMLSerializer();
    }
    return xmlSerializer_;
}
var document_ = undefined;
/**
 * Register a Document to use when creating nodes for XML serializations. Can be used
 * to inject a Document where there is no globally available implementation.
 *
 * @param {Document} document A Document.
 * @api
 */
function registerDocument(document) {
    document_ = document;
}
/**
 * Get a document that should be used when creating nodes for XML serializations.
 * @return {Document} The document.
 */
function getDocument() {
    if (document_ === undefined && typeof document !== 'undefined') {
        document_ = document.implementation.createDocument('', '', null);
    }
    return document_;
}
//# sourceMappingURL=xml.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readBoolean", function() { return readBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readBooleanString", function() { return readBooleanString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readDateTime", function() { return readDateTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readDecimal", function() { return readDecimal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readDecimalString", function() { return readDecimalString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readNonNegativeInteger", function() { return readNonNegativeInteger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readNonNegativeIntegerString", function() { return readNonNegativeIntegerString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readString", function() { return readString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeBooleanTextNode", function() { return writeBooleanTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeCDATASection", function() { return writeCDATASection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeDateTimeTextNode", function() { return writeDateTimeTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeDecimalTextNode", function() { return writeDecimalTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeNonNegativeIntegerTextNode", function() { return writeNonNegativeIntegerTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeStringTextNode", function() { return writeStringTextNode; });
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(217);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/**
 * @module ol/format/xsd
 */


/**
 * @param {Node} node Node.
 * @return {boolean|undefined} Boolean.
 */
function readBoolean(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getAllTextContent"])(node, false);
    return readBooleanString(s);
}
/**
 * @param {string} string String.
 * @return {boolean|undefined} Boolean.
 */
function readBooleanString(string) {
    var m = /^\s*(true|1)|(false|0)\s*$/.exec(string);
    if (m) {
        return m[1] !== undefined || false;
    }
    else {
        return undefined;
    }
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} DateTime in seconds.
 */
function readDateTime(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getAllTextContent"])(node, false);
    var dateTime = Date.parse(s);
    return isNaN(dateTime) ? undefined : dateTime / 1000;
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} Decimal.
 */
function readDecimal(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getAllTextContent"])(node, false);
    return readDecimalString(s);
}
/**
 * @param {string} string String.
 * @return {number|undefined} Decimal.
 */
function readDecimalString(string) {
    // FIXME check spec
    var m = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)\s*$/i.exec(string);
    if (m) {
        return parseFloat(m[1]);
    }
    else {
        return undefined;
    }
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} Non negative integer.
 */
function readNonNegativeInteger(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getAllTextContent"])(node, false);
    return readNonNegativeIntegerString(s);
}
/**
 * @param {string} string String.
 * @return {number|undefined} Non negative integer.
 */
function readNonNegativeIntegerString(string) {
    var m = /^\s*(\d+)\s*$/.exec(string);
    if (m) {
        return parseInt(m[1], 10);
    }
    else {
        return undefined;
    }
}
/**
 * @param {Node} node Node.
 * @return {string|undefined} String.
 */
function readString(node) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getAllTextContent"])(node, false).trim();
}
/**
 * @param {Node} node Node to append a TextNode with the boolean to.
 * @param {boolean} bool Boolean.
 */
function writeBooleanTextNode(node, bool) {
    writeStringTextNode(node, bool ? '1' : '0');
}
/**
 * @param {Node} node Node to append a CDATA Section with the string to.
 * @param {string} string String.
 */
function writeCDATASection(node, string) {
    node.appendChild(Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getDocument"])().createCDATASection(string));
}
/**
 * @param {Node} node Node to append a TextNode with the dateTime to.
 * @param {number} dateTime DateTime in seconds.
 */
function writeDateTimeTextNode(node, dateTime) {
    var date = new Date(dateTime * 1000);
    var string = date.getUTCFullYear() +
        '-' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_1__["padNumber"])(date.getUTCMonth() + 1, 2) +
        '-' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_1__["padNumber"])(date.getUTCDate(), 2) +
        'T' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_1__["padNumber"])(date.getUTCHours(), 2) +
        ':' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_1__["padNumber"])(date.getUTCMinutes(), 2) +
        ':' +
        Object(_string_js__WEBPACK_IMPORTED_MODULE_1__["padNumber"])(date.getUTCSeconds(), 2) +
        'Z';
    node.appendChild(Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getDocument"])().createTextNode(string));
}
/**
 * @param {Node} node Node to append a TextNode with the decimal to.
 * @param {number} decimal Decimal.
 */
function writeDecimalTextNode(node, decimal) {
    var string = decimal.toPrecision();
    node.appendChild(Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getDocument"])().createTextNode(string));
}
/**
 * @param {Node} node Node to append a TextNode with the decimal to.
 * @param {number} nonNegativeInteger Non negative integer.
 */
function writeNonNegativeIntegerTextNode(node, nonNegativeInteger) {
    var string = nonNegativeInteger.toString();
    node.appendChild(Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getDocument"])().createTextNode(string));
}
/**
 * @param {Node} node Node to append a TextNode with the string to.
 * @param {string} string String.
 */
function writeStringTextNode(node, string) {
    node.appendChild(Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["getDocument"])().createTextNode(string));
}
//# sourceMappingURL=xsd.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(206);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98);
/* harmony import */ var _XMLFeature_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(216);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(217);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(218);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/GPX
 */












/**
 * @const
 * @type {Array<null|string>}
 */
var NAMESPACE_URIS = [
    null,
    'http://www.topografix.com/GPX/1/0',
    'http://www.topografix.com/GPX/1/1',
];
/**
 * @const
 * @type {string}
 */
var SCHEMA_LOCATION = 'http://www.topografix.com/GPX/1/1 ' +
    'http://www.topografix.com/GPX/1/1/gpx.xsd';
/**
 * @const
 * @type {Object<string, function(Node, Array<*>): (Feature|undefined)>}
 */
var FEATURE_READER = {
    'rte': readRte,
    'trk': readTrk,
    'wpt': readWpt,
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var GPX_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'rte': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(readRte),
    'trk': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(readTrk),
    'wpt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArrayPusher"])(readWpt),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LINK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'text': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"], 'linkText'),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"], 'linkType'),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var GPX_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'rte': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeRte),
    'trk': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeTrk),
    'wpt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeWpt),
});
/**
 * @typedef {Object} Options
 * @property {function(Feature, Node):void} [readExtensions] Callback function
 * to process `extensions` nodes. To prevent memory leaks, this callback function must
 * not store any references to the node. Note that the `extensions`
 * node is not allowed in GPX 1.0. Moreover, only `extensions`
 * nodes from `wpt`, `rte` and `trk` can be processed, as those are
 * directly mapped to a feature.
 */
/**
 * @typedef {Object} LayoutOptions
 * @property {boolean} [hasZ] HasZ.
 * @property {boolean} [hasM] HasM.
 */
/**
 * @classdesc
 * Feature format for reading and writing data in the GPX format.
 *
 * Note that {@link module:ol/format/GPX~GPX#readFeature} only reads the first
 * feature of the source.
 *
 * When reading, routes (`<rte>`) are converted into LineString geometries, and
 * tracks (`<trk>`) into MultiLineString. Any properties on route and track
 * waypoints are ignored.
 *
 * When writing, LineString geometries are output as routes (`<rte>`), and
 * MultiLineString as tracks (`<trk>`).
 *
 * @api
 */
var GPX = /** @class */ (function (_super) {
    __extends(GPX, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function GPX(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["get"])('EPSG:4326');
        /**
         * @type {function(Feature, Node): void|undefined}
         * @private
         */
        _this.readExtensions_ = options.readExtensions;
        return _this;
    }
    /**
     * @param {Array<Feature>} features List of features.
     * @private
     */
    GPX.prototype.handleReadExtensions_ = function (features) {
        if (!features) {
            features = [];
        }
        for (var i = 0, ii = features.length; i < ii; ++i) {
            var feature = features[i];
            if (this.readExtensions_) {
                var extensionsNode = feature.get('extensionsNode_') || null;
                this.readExtensions_(feature, extensionsNode);
            }
            feature.set('extensionsNode_', undefined);
        }
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {import("../Feature.js").default} Feature.
     */
    GPX.prototype.readFeatureFromNode = function (node, opt_options) {
        if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_9__["includes"])(NAMESPACE_URIS, node.namespaceURI)) {
            return null;
        }
        var featureReader = FEATURE_READER[node.localName];
        if (!featureReader) {
            return null;
        }
        var feature = featureReader(node, [
            this.getReadOptions(node, opt_options),
        ]);
        if (!feature) {
            return null;
        }
        this.handleReadExtensions_([feature]);
        return feature;
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */
    GPX.prototype.readFeaturesFromNode = function (node, opt_options) {
        if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_9__["includes"])(NAMESPACE_URIS, node.namespaceURI)) {
            return [];
        }
        if (node.localName == 'gpx') {
            /** @type {Array<Feature>} */
            var features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])([], GPX_PARSERS, node, [
                this.getReadOptions(node, opt_options),
            ]);
            if (features) {
                this.handleReadExtensions_(features);
                return features;
            }
            else {
                return [];
            }
        }
        return [];
    };
    /**
     * Encode an array of features in the GPX format as an XML node.
     * LineString geometries are output as routes (`<rte>`), and MultiLineString
     * as tracks (`<trk>`).
     *
     * @param {Array<Feature>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Node} Node.
     * @api
     */
    GPX.prototype.writeFeaturesNode = function (features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        //FIXME Serialize metadata
        var gpx = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])('http://www.topografix.com/GPX/1/1', 'gpx');
        var xmlnsUri = 'http://www.w3.org/2000/xmlns/';
        gpx.setAttributeNS(xmlnsUri, 'xmlns:xsi', _xml_js__WEBPACK_IMPORTED_MODULE_7__["XML_SCHEMA_INSTANCE_URI"]);
        gpx.setAttributeNS(_xml_js__WEBPACK_IMPORTED_MODULE_7__["XML_SCHEMA_INSTANCE_URI"], 'xsi:schemaLocation', SCHEMA_LOCATION);
        gpx.setAttribute('version', '1.1');
        gpx.setAttribute('creator', 'OpenLayers');
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */
        ({ node: gpx }), GPX_SERIALIZERS, GPX_NODE_FACTORY, features, [opt_options]);
        return gpx;
    };
    return GPX;
}(_XMLFeature_js__WEBPACK_IMPORTED_MODULE_6__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var RTE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'link': parseLink,
    'number': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    'extensions': parseExtensions,
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'rtept': parseRtePt,
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var RTEPT_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'ele': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'time': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDateTime"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TRK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'link': parseLink,
    'number': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'extensions': parseExtensions,
    'trkseg': parseTrkSeg,
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TRKSEG_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'trkpt': parseTrkPt,
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TRKPT_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'ele': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'time': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDateTime"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var WPT_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'ele': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'time': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDateTime"]),
    'magvar': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'geoidheight': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'link': parseLink,
    'sym': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'fix': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readString"]),
    'sat': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    'hdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'vdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'pdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'ageofdgpsdata': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readDecimal"]),
    'dgpsid': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    'extensions': parseExtensions,
});
/**
 * @const
 * @type {Array<string>}
 */
var LINK_SEQUENCE = ['text', 'type'];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var LINK_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'text': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var RTE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, [
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'number',
    'type',
    'rtept',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var RTE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'link': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeLink),
    'number': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeNonNegativeIntegerTextNode"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'rtept': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArraySerializer"])(Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeWptType)),
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var RTEPT_TYPE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, ['ele', 'time']);
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var TRK_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, [
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'number',
    'type',
    'trkseg',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var TRK_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'link': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeLink),
    'number': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeNonNegativeIntegerTextNode"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'trkseg': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeArraySerializer"])(Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeTrkSeg)),
});
/**
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var TRKSEG_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSimpleNodeFactory"])('trkpt');
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var TRKSEG_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'trkpt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeWptType),
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var WPT_TYPE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, [
    'ele',
    'time',
    'magvar',
    'geoidheight',
    'name',
    'cmt',
    'desc',
    'src',
    'link',
    'sym',
    'type',
    'fix',
    'sat',
    'hdop',
    'vdop',
    'pdop',
    'ageofdgpsdata',
    'dgpsid',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var WPT_TYPE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeStructureNS"])(NAMESPACE_URIS, {
    'ele': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'time': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDateTimeTextNode"]),
    'magvar': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'geoidheight': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'cmt': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'desc': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'src': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'link': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(writeLink),
    'sym': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'type': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'fix': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    'sat': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeNonNegativeIntegerTextNode"]),
    'hdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'vdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'pdop': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'ageofdgpsdata': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeDecimalTextNode"]),
    'dgpsid': Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeNonNegativeIntegerTextNode"]),
});
/**
 * @const
 * @type {Object<string, string>}
 */
var GEOMETRY_TYPE_TO_NODENAME = {
    'Point': 'wpt',
    'LineString': 'rte',
    'MultiLineString': 'trk',
};
/**
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [opt_nodeName] Node name.
 * @return {Node|undefined} Node.
 */
function GPX_NODE_FACTORY(value, objectStack, opt_nodeName) {
    var geometry = /** @type {Feature} */ (value).getGeometry();
    if (geometry) {
        var nodeName = GEOMETRY_TYPE_TO_NODENAME[geometry.getType()];
        if (nodeName) {
            var parentNode = objectStack[objectStack.length - 1].node;
            return Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["createElementNS"])(parentNode.namespaceURI, nodeName);
        }
    }
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Element} node Node.
 * @param {!Object} values Values.
 * @return {Array<number>} Flat coordinates.
 */
function appendCoordinate(flatCoordinates, layoutOptions, node, values) {
    flatCoordinates.push(parseFloat(node.getAttribute('lon')), parseFloat(node.getAttribute('lat')));
    if ('ele' in values) {
        flatCoordinates.push(/** @type {number} */ (values['ele']));
        delete values['ele'];
        layoutOptions.hasZ = true;
    }
    else {
        flatCoordinates.push(0);
    }
    if ('time' in values) {
        flatCoordinates.push(/** @type {number} */ (values['time']));
        delete values['time'];
        layoutOptions.hasM = true;
    }
    else {
        flatCoordinates.push(0);
    }
    return flatCoordinates;
}
/**
 * Choose GeometryLayout based on flags in layoutOptions and adjust flatCoordinates
 * and ends arrays by shrinking them accordingly (removing unused zero entries).
 *
 * @param {LayoutOptions} layoutOptions Layout options.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {Array<number>} [ends] Ends.
 * @return {import("../geom/GeometryLayout.js").default} Layout.
 */
function applyLayoutOptions(layoutOptions, flatCoordinates, ends) {
    var layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
    var stride = 2;
    if (layoutOptions.hasZ && layoutOptions.hasM) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM;
        stride = 4;
    }
    else if (layoutOptions.hasZ) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ;
        stride = 3;
    }
    else if (layoutOptions.hasM) {
        layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM;
        stride = 3;
    }
    if (stride !== 4) {
        for (var i = 0, ii = flatCoordinates.length / 4; i < ii; i++) {
            flatCoordinates[i * stride] = flatCoordinates[i * 4];
            flatCoordinates[i * stride + 1] = flatCoordinates[i * 4 + 1];
            if (layoutOptions.hasZ) {
                flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 2];
            }
            if (layoutOptions.hasM) {
                flatCoordinates[i * stride + 2] = flatCoordinates[i * 4 + 3];
            }
        }
        flatCoordinates.length = (flatCoordinates.length / 4) * stride;
        if (ends) {
            for (var i = 0, ii = ends.length; i < ii; i++) {
                ends[i] = (ends[i] / 4) * stride;
            }
        }
    }
    return layout;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function parseLink(node, objectStack) {
    var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var href = node.getAttribute('href');
    if (href !== null) {
        values['link'] = href;
    }
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["parseNode"])(LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function parseExtensions(node, objectStack) {
    var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    values['extensionsNode_'] = node;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function parseRtePt(node, objectStack) {
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])({}, RTEPT_PARSERS, node, objectStack);
    if (values) {
        var rteValues = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
        var flatCoordinates = /** @type {Array<number>} */ (rteValues['flatCoordinates']);
        var layoutOptions = /** @type {LayoutOptions} */ (rteValues['layoutOptions']);
        appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function parseTrkPt(node, objectStack) {
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])({}, TRKPT_PARSERS, node, objectStack);
    if (values) {
        var trkValues = /** @type {!Object} */ (objectStack[objectStack.length - 1]);
        var flatCoordinates = /** @type {Array<number>} */ (trkValues['flatCoordinates']);
        var layoutOptions = /** @type {LayoutOptions} */ (trkValues['layoutOptions']);
        appendCoordinate(flatCoordinates, layoutOptions, node, values);
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function parseTrkSeg(node, objectStack) {
    var values = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["parseNode"])(TRKSEG_PARSERS, node, objectStack);
    var flatCoordinates = 
    /** @type {Array<number>} */
    (values['flatCoordinates']);
    var ends = /** @type {Array<number>} */ (values['ends']);
    ends.push(flatCoordinates.length);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */
function readRte(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])({
        'flatCoordinates': [],
        'layoutOptions': {},
    }, RTE_PARSERS, node, objectStack);
    if (!values) {
        return undefined;
    }
    var flatCoordinates = 
    /** @type {Array<number>} */
    (values['flatCoordinates']);
    delete values['flatCoordinates'];
    var layoutOptions = /** @type {LayoutOptions} */ (values['layoutOptions']);
    delete values['layoutOptions'];
    var layout = applyLayoutOptions(layoutOptions, flatCoordinates);
    var geometry = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_3__["default"](flatCoordinates, layout);
    Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, false, options);
    var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Track.
 */
function readTrk(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])({
        'flatCoordinates': [],
        'ends': [],
        'layoutOptions': {},
    }, TRK_PARSERS, node, objectStack);
    if (!values) {
        return undefined;
    }
    var flatCoordinates = 
    /** @type {Array<number>} */
    (values['flatCoordinates']);
    delete values['flatCoordinates'];
    var ends = /** @type {Array<number>} */ (values['ends']);
    delete values['ends'];
    var layoutOptions = /** @type {LayoutOptions} */ (values['layoutOptions']);
    delete values['layoutOptions'];
    var layout = applyLayoutOptions(layoutOptions, flatCoordinates, ends);
    var geometry = new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](flatCoordinates, layout, ends);
    Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, false, options);
    var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Feature|undefined} Waypoint.
 */
function readWpt(node, objectStack) {
    var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushParseAndPop"])({}, WPT_PARSERS, node, objectStack);
    if (!values) {
        return undefined;
    }
    var layoutOptions = /** @type {LayoutOptions} */ ({});
    var coordinates = appendCoordinate([], layoutOptions, node, values);
    var layout = applyLayoutOptions(layoutOptions, coordinates);
    var geometry = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_5__["default"](coordinates, layout);
    Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, false, options);
    var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](geometry);
    feature.setProperties(values, true);
    return feature;
}
/**
 * @param {Element} node Node.
 * @param {string} value Value for the link's `href` attribute.
 * @param {Array<*>} objectStack Node stack.
 */
function writeLink(node, value, objectStack) {
    node.setAttribute('href', value);
    var context = objectStack[objectStack.length - 1];
    var properties = context['properties'];
    var link = [properties['linkText'], properties['linkType']];
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
    /** @type {import("../xml.js").NodeStackItem} */ ({ node: node }), LINK_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_7__["OBJECT_PROPERTY_NODE_FACTORY"], link, objectStack, LINK_SEQUENCE);
}
/**
 * @param {Element} node Node.
 * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
 * @param {Array<*>} objectStack Object stack.
 */
function writeWptType(node, coordinate, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var parentNode = context.node;
    var namespaceURI = parentNode.namespaceURI;
    var properties = context['properties'];
    //FIXME Projection handling
    node.setAttributeNS(null, 'lat', String(coordinate[1]));
    node.setAttributeNS(null, 'lon', String(coordinate[0]));
    var geometryLayout = context['geometryLayout'];
    switch (geometryLayout) {
        case _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM:
            if (coordinate[3] !== 0) {
                properties['time'] = coordinate[3];
            }
        // fall through
        case _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZ:
            if (coordinate[2] !== 0) {
                properties['ele'] = coordinate[2];
            }
            break;
        case _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM:
            if (coordinate[2] !== 0) {
                properties['time'] = coordinate[2];
            }
            break;
        default:
        // pass
    }
    var orderedKeys = node.nodeName == 'rtept'
        ? RTEPT_TYPE_SEQUENCE[namespaceURI]
        : WPT_TYPE_SEQUENCE[namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(
    /** @type {import("../xml.js").NodeStackItem} */
    ({ node: node, 'properties': properties }), WPT_TYPE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_7__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */
function writeRte(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
    var properties = feature.getProperties();
    var context = { node: node };
    context['properties'] = properties;
    var geometry = feature.getGeometry();
    if (geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING) {
        var lineString = /** @type {LineString} */ (Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, true, options));
        context['geometryLayout'] = lineString.getLayout();
        properties['rtept'] = lineString.getCoordinates();
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = RTE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(context, RTE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_7__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */
function writeTrk(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
    var properties = feature.getProperties();
    /** @type {import("../xml.js").NodeStackItem} */
    var context = { node: node };
    context['properties'] = properties;
    var geometry = feature.getGeometry();
    if (geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING) {
        var multiLineString = /** @type {MultiLineString} */ (Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, true, options));
        properties['trkseg'] = multiLineString.getLineStrings();
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = TRK_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(context, TRK_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_7__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node.
 * @param {LineString} lineString LineString.
 * @param {Array<*>} objectStack Object stack.
 */
function writeTrkSeg(node, lineString, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */
    var context = { node: node };
    context['geometryLayout'] = lineString.getLayout();
    context['properties'] = {};
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_7__["pushSerializeAndPop"])(context, TRKSEG_SERIALIZERS, TRKSEG_NODE_FACTORY, lineString.getCoordinates(), objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 */
function writeWpt(node, feature, objectStack) {
    var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
    var context = objectStack[objectStack.length - 1];
    context['properties'] = feature.getProperties();
    var geometry = feature.getGeometry();
    if (geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT) {
        var point = /** @type {Point} */ (Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, true, options));
        context['geometryLayout'] = point.getLayout();
        writeWptType(node, point.getCoordinates(), objectStack);
    }
}
/* harmony default export */ __webpack_exports__["default"] = (GPX);
//# sourceMappingURL=GPX.js.map

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(203);
/* harmony import */ var _TextFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(221);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/IGC
 */






/**
 * IGC altitude/z. One of 'barometric', 'gps', 'none'.
 * @enum {string}
 */
var IGCZ = {
    BAROMETRIC: 'barometric',
    GPS: 'gps',
    NONE: 'none',
};
/**
 * @const
 * @type {RegExp}
 */
var B_RECORD_RE = /^B(\d{2})(\d{2})(\d{2})(\d{2})(\d{5})([NS])(\d{3})(\d{5})([EW])([AV])(\d{5})(\d{5})/;
/**
 * @const
 * @type {RegExp}
 */
var H_RECORD_RE = /^H.([A-Z]{3}).*?:(.*)/;
/**
 * @const
 * @type {RegExp}
 */
var HFDTE_RECORD_RE = /^HFDTE(\d{2})(\d{2})(\d{2})/;
/**
 * A regular expression matching the newline characters `\r\n`, `\r` and `\n`.
 *
 * @const
 * @type {RegExp}
 */
var NEWLINE_RE = /\r\n|\r|\n/;
/**
 * @typedef {Object} Options
 * @property {IGCZ|string} [altitudeMode='none'] Altitude mode. Possible
 * values are `'barometric'`, `'gps'`, and `'none'`.
 */
/**
 * @classdesc
 * Feature format for `*.igc` flight recording files.
 *
 * As IGC sources contain a single feature,
 * {@link module:ol/format/IGC~IGC#readFeatures} will return the feature in an
 * array
 *
 * @api
 */
var IGC = /** @class */ (function (_super) {
    __extends(IGC, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function IGC(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["get"])('EPSG:4326');
        /**
         * @private
         * @type {IGCZ}
         */
        _this.altitudeMode_ = options.altitudeMode
            ? options.altitudeMode
            : IGCZ.NONE;
        return _this;
    }
    /**
     * @protected
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     */
    IGC.prototype.readFeatureFromText = function (text, opt_options) {
        var altitudeMode = this.altitudeMode_;
        var lines = text.split(NEWLINE_RE);
        /** @type {Object<string, string>} */
        var properties = {};
        var flatCoordinates = [];
        var year = 2000;
        var month = 0;
        var day = 1;
        var lastDateTime = -1;
        var i, ii;
        for (i = 0, ii = lines.length; i < ii; ++i) {
            var line = lines[i];
            var m = void 0;
            if (line.charAt(0) == 'B') {
                m = B_RECORD_RE.exec(line);
                if (m) {
                    var hour = parseInt(m[1], 10);
                    var minute = parseInt(m[2], 10);
                    var second = parseInt(m[3], 10);
                    var y = parseInt(m[4], 10) + parseInt(m[5], 10) / 60000;
                    if (m[6] == 'S') {
                        y = -y;
                    }
                    var x = parseInt(m[7], 10) + parseInt(m[8], 10) / 60000;
                    if (m[9] == 'W') {
                        x = -x;
                    }
                    flatCoordinates.push(x, y);
                    if (altitudeMode != IGCZ.NONE) {
                        var z = void 0;
                        if (altitudeMode == IGCZ.GPS) {
                            z = parseInt(m[11], 10);
                        }
                        else if (altitudeMode == IGCZ.BAROMETRIC) {
                            z = parseInt(m[12], 10);
                        }
                        else {
                            z = 0;
                        }
                        flatCoordinates.push(z);
                    }
                    var dateTime = Date.UTC(year, month, day, hour, minute, second);
                    // Detect UTC midnight wrap around.
                    if (dateTime < lastDateTime) {
                        dateTime = Date.UTC(year, month, day + 1, hour, minute, second);
                    }
                    flatCoordinates.push(dateTime / 1000);
                    lastDateTime = dateTime;
                }
            }
            else if (line.charAt(0) == 'H') {
                m = HFDTE_RECORD_RE.exec(line);
                if (m) {
                    day = parseInt(m[1], 10);
                    month = parseInt(m[2], 10) - 1;
                    year = 2000 + parseInt(m[3], 10);
                }
                else {
                    m = H_RECORD_RE.exec(line);
                    if (m) {
                        properties[m[1]] = m[2].trim();
                    }
                }
            }
        }
        if (flatCoordinates.length === 0) {
            return null;
        }
        var layout = altitudeMode == IGCZ.NONE ? _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYM : _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XYZM;
        var lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](flatCoordinates, layout);
        var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](Object(_Feature_js__WEBPACK_IMPORTED_MODULE_5__["transformGeometryWithOptions"])(lineString, false, opt_options));
        feature.setProperties(properties, true);
        return feature;
    };
    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    IGC.prototype.readFeaturesFromText = function (text, opt_options) {
        var feature = this.readFeatureFromText(text, opt_options);
        if (feature) {
            return [feature];
        }
        else {
            return [];
        }
    };
    return IGC;
}(_TextFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (IGC);
//# sourceMappingURL=IGC.js.map

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _format_Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(202);
/* harmony import */ var _format_FormatType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/TextFeature
 */



/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * Base class for text feature formats.
 *
 * @abstract
 */
var TextFeature = /** @class */ (function (_super) {
    __extends(TextFeature, _super);
    function TextFeature() {
        return _super.call(this) || this;
    }
    /**
     * @return {import("./FormatType.js").default} Format.
     */
    TextFeature.prototype.getType = function () {
        return _format_FormatType_js__WEBPACK_IMPORTED_MODULE_1__["default"].TEXT;
    };
    /**
     * Read the feature from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     * @api
     */
    TextFeature.prototype.readFeature = function (source, opt_options) {
        return this.readFeatureFromText(getText(source), this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../Feature.js").default} Feature.
     */
    TextFeature.prototype.readFeatureFromText = function (text, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read the features from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").default>} Features.
     * @api
     */
    TextFeature.prototype.readFeatures = function (source, opt_options) {
        return this.readFeaturesFromText(getText(source), this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<import("../Feature.js").default>} Features.
     */
    TextFeature.prototype.readFeaturesFromText = function (text, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read the geometry from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../geom/Geometry.js").default} Geometry.
     * @api
     */
    TextFeature.prototype.readGeometry = function (source, opt_options) {
        return this.readGeometryFromText(getText(source), this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    TextFeature.prototype.readGeometryFromText = function (text, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Read the projection from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default|undefined} Projection.
     * @api
     */
    TextFeature.prototype.readProjection = function (source) {
        return this.readProjectionFromText(getText(source));
    };
    /**
     * @param {string} text Text.
     * @protected
     * @return {import("../proj/Projection.js").default|undefined} Projection.
     */
    TextFeature.prototype.readProjectionFromText = function (text) {
        return this.dataProjection;
    };
    /**
     * Encode a feature as a string.
     *
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded feature.
     * @api
     */
    TextFeature.prototype.writeFeature = function (feature, opt_options) {
        return this.writeFeatureText(feature, this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {import("../Feature.js").default} feature Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    TextFeature.prototype.writeFeatureText = function (feature, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Encode an array of features as string.
     *
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Encoded features.
     * @api
     */
    TextFeature.prototype.writeFeatures = function (features, opt_options) {
        return this.writeFeaturesText(features, this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    TextFeature.prototype.writeFeaturesText = function (features, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    /**
     * Write a single geometry.
     *
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @return {string} Geometry.
     * @api
     */
    TextFeature.prototype.writeGeometry = function (geometry, opt_options) {
        return this.writeGeometryText(geometry, this.adaptOptions(opt_options));
    };
    /**
     * @abstract
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    TextFeature.prototype.writeGeometryText = function (geometry, opt_options) {
        return Object(_util_js__WEBPACK_IMPORTED_MODULE_2__["abstract"])();
    };
    return TextFeature;
}(_format_Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {Document|Element|Object|string} source Source.
 * @return {string} Text.
 */
function getText(source) {
    if (typeof source === 'string') {
        return source;
    }
    else {
        return '';
    }
}
/* harmony default export */ __webpack_exports__["default"] = (TextFeature);
//# sourceMappingURL=TextFeature.js.map

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultFillStyle", function() { return getDefaultFillStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultImageStyle", function() { return getDefaultImageStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultStrokeStyle", function() { return getDefaultStrokeStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultTextStyle", function() { return getDefaultTextStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultStyle", function() { return getDefaultStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaultStyleArray", function() { return getDefaultStyleArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readFlatCoordinates", function() { return readFlatCoordinates; });
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56);
/* harmony import */ var _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(211);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(103);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23);
/* harmony import */ var _style_Icon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57);
/* harmony import */ var _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58);
/* harmony import */ var _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(184);
/* harmony import */ var _style_Stroke_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(64);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(65);
/* harmony import */ var _style_Text_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(66);
/* harmony import */ var _XMLFeature_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(216);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(217);
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(40);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(19);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(52);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(7);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(218);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(11);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/KML
 */


























/**
 * @typedef {Object} Vec2
 * @property {number} x X coordinate.
 * @property {import("../style/IconAnchorUnits").default} xunits Units of x.
 * @property {number} y Y coordinate.
 * @property {import("../style/IconAnchorUnits").default} yunits Units of Y.
 * @property {import("../style/IconOrigin.js").default} [origin] Origin.
 */
/**
 * @typedef {Object} GxTrackObject
 * @property {Array<Array<number>>} coordinates Coordinates.
 * @property {Array<number>} whens Whens.
 */
/**
 * @const
 * @type {Array<string>}
 */
var GX_NAMESPACE_URIS = ['http://www.google.com/kml/ext/2.2'];
/**
 * @const
 * @type {Array<null|string>}
 */
var NAMESPACE_URIS = [
    null,
    'http://earth.google.com/kml/2.0',
    'http://earth.google.com/kml/2.1',
    'http://earth.google.com/kml/2.2',
    'http://www.opengis.net/kml/2.2',
];
/**
 * @const
 * @type {string}
 */
var SCHEMA_LOCATION = 'http://www.opengis.net/kml/2.2 ' +
    'https://developers.google.com/kml/schema/kml22gx.xsd';
/**
 * @type {Object<string, import("../style/IconAnchorUnits").default>}
 */
var ICON_ANCHOR_UNITS_MAP = {
    'fraction': _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].FRACTION,
    'pixels': _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS,
    'insetPixels': _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS,
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PLACEMARK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'ExtendedData': extendedDataParser,
    'Region': regionParser,
    'MultiGeometry': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readMultiGeometry, 'geometry'),
    'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readLineString, 'geometry'),
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readLinearRing, 'geometry'),
    'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readPoint, 'geometry'),
    'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readPolygon, 'geometry'),
    'Style': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readStyle),
    'StyleMap': placemarkStyleMapParser,
    'address': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'description': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'open': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
    'phoneNumber': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'styleUrl': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readStyleURL),
    'visibility': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, {
    'MultiTrack': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readGxMultiTrack, 'geometry'),
    'Track': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readGxTrack, 'geometry'),
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var NETWORK_LINK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'ExtendedData': extendedDataParser,
    'Region': regionParser,
    'Link': linkParser,
    'address': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'description': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'open': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
    'phoneNumber': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'visibility': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LINK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'href': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readURI),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var REGION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'LatLonAltBox': latLonAltBoxParser,
    'Lod': lodParser,
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var KML_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, ['Document', 'Placemark']);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var KML_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Document': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeDocument),
    'Placemark': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePlacemark),
});
/**
 * @type {import("../color.js").Color}
 */
var DEFAULT_COLOR;
/**
 * @type {Fill}
 */
var DEFAULT_FILL_STYLE = null;
/**
 * Get the default fill style (or null if not yet set).
 * @return {Fill} The default fill style.
 */
function getDefaultFillStyle() {
    return DEFAULT_FILL_STYLE;
}
/**
 * @type {import("../size.js").Size}
 */
var DEFAULT_IMAGE_STYLE_ANCHOR;
/**
 * @type {import("../style/IconAnchorUnits").default}
 */
var DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
/**
 * @type {import("../style/IconAnchorUnits").default}
 */
var DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
/**
 * @type {import("../size.js").Size}
 */
var DEFAULT_IMAGE_STYLE_SIZE;
/**
 * @type {string}
 */
var DEFAULT_IMAGE_STYLE_SRC;
/**
 * @type {number}
 */
var DEFAULT_IMAGE_SCALE_MULTIPLIER;
/**
 * @type {import("../style/Image.js").default}
 */
var DEFAULT_IMAGE_STYLE = null;
/**
 * Get the default image style (or null if not yet set).
 * @return {import("../style/Image.js").default} The default image style.
 */
function getDefaultImageStyle() {
    return DEFAULT_IMAGE_STYLE;
}
/**
 * @type {string}
 */
var DEFAULT_NO_IMAGE_STYLE;
/**
 * @type {Stroke}
 */
var DEFAULT_STROKE_STYLE = null;
/**
 * Get the default stroke style (or null if not yet set).
 * @return {Stroke} The default stroke style.
 */
function getDefaultStrokeStyle() {
    return DEFAULT_STROKE_STYLE;
}
/**
 * @type {Stroke}
 */
var DEFAULT_TEXT_STROKE_STYLE;
/**
 * @type {Text}
 */
var DEFAULT_TEXT_STYLE = null;
/**
 * Get the default text style (or null if not yet set).
 * @return {Text} The default text style.
 */
function getDefaultTextStyle() {
    return DEFAULT_TEXT_STYLE;
}
/**
 * @type {Style}
 */
var DEFAULT_STYLE = null;
/**
 * Get the default style (or null if not yet set).
 * @return {Style} The default style.
 */
function getDefaultStyle() {
    return DEFAULT_STYLE;
}
/**
 * @type {Array<Style>}
 */
var DEFAULT_STYLE_ARRAY = null;
/**
 * Get the default style array (or null if not yet set).
 * @return {Array<Style>} The default style.
 */
function getDefaultStyleArray() {
    return DEFAULT_STYLE_ARRAY;
}
function createStyleDefaults() {
    DEFAULT_COLOR = [255, 255, 255, 1];
    DEFAULT_FILL_STYLE = new _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        color: DEFAULT_COLOR,
    });
    DEFAULT_IMAGE_STYLE_ANCHOR = [20, 2]; // FIXME maybe [8, 32] ?
    DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS = _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS;
    DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS = _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS;
    DEFAULT_IMAGE_STYLE_SIZE = [64, 64];
    DEFAULT_IMAGE_STYLE_SRC =
        'https://maps.google.com/mapfiles/kml/pushpin/ylw-pushpin.png';
    DEFAULT_IMAGE_SCALE_MULTIPLIER = 0.5;
    DEFAULT_IMAGE_STYLE = new _style_Icon_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
        anchor: DEFAULT_IMAGE_STYLE_ANCHOR,
        anchorOrigin: _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].BOTTOM_LEFT,
        anchorXUnits: DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS,
        anchorYUnits: DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS,
        crossOrigin: 'anonymous',
        rotation: 0,
        scale: DEFAULT_IMAGE_SCALE_MULTIPLIER,
        size: DEFAULT_IMAGE_STYLE_SIZE,
        src: DEFAULT_IMAGE_STYLE_SRC,
    });
    DEFAULT_NO_IMAGE_STYLE = 'NO_IMAGE';
    DEFAULT_STROKE_STYLE = new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        color: DEFAULT_COLOR,
        width: 1,
    });
    DEFAULT_TEXT_STROKE_STYLE = new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        color: [51, 51, 51, 1],
        width: 2,
    });
    DEFAULT_TEXT_STYLE = new _style_Text_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
        font: 'bold 16px Helvetica',
        fill: DEFAULT_FILL_STYLE,
        stroke: DEFAULT_TEXT_STROKE_STYLE,
        scale: 0.8,
    });
    DEFAULT_STYLE = new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
        fill: DEFAULT_FILL_STYLE,
        image: DEFAULT_IMAGE_STYLE,
        text: DEFAULT_TEXT_STYLE,
        stroke: DEFAULT_STROKE_STYLE,
        zIndex: 0,
    });
    DEFAULT_STYLE_ARRAY = [DEFAULT_STYLE];
}
/**
 * @type {HTMLTextAreaElement}
 */
var TEXTAREA;
/**
 * A function that takes a url `{string}` and returns a url `{string}`.
 * Might be used to change an icon path or to substitute a
 * data url obtained from a KMZ array buffer.
 *
 * @typedef {function(string):string} IconUrlFunction
 * @api
 */
/**
 * Function that returns a url unchanged.
 * @param {string} href Input url.
 * @return {string} Output url.
 */
function defaultIconUrlFunction(href) {
    return href;
}
/**
 * @typedef {Object} Options
 * @property {boolean} [extractStyles=true] Extract styles from the KML.
 * @property {boolean} [showPointNames=true] Show names as labels for placemarks which contain points.
 * @property {Array<Style>} [defaultStyle] Default style. The
 * default default style is the same as Google Earth.
 * @property {boolean} [writeStyles=true] Write styles into KML.
 * @property {null|string} [crossOrigin='anonymous'] The `crossOrigin` attribute for loaded images. Note that you must provide a
 * `crossOrigin` value if you want to access pixel data with the Canvas renderer.
 * @property {IconUrlFunction} [iconUrlFunction] Function that takes a url string and returns a url string.
 * Might be used to change an icon path or to substitute a data url obtained from a KMZ array buffer.
 */
/**
 * @classdesc
 * Feature format for reading and writing data in the KML format.
 *
 * {@link module:ol/format/KML~KML#readFeature} will read the first feature from
 * a KML source.
 *
 * MultiGeometries are converted into GeometryCollections if they are a mix of
 * geometry types, and into MultiPoint/MultiLineString/MultiPolygon if they are
 * all of the same type.
 *
 * Note that the KML format uses the URL() constructor. Older browsers such as IE
 * which do not support this will need a URL polyfill to be loaded before use.
 *
 * @api
 */
var KML = /** @class */ (function (_super) {
    __extends(KML, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function KML(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        if (!DEFAULT_STYLE_ARRAY) {
            createStyleDefaults();
        }
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_22__["get"])('EPSG:4326');
        /**
         * @private
         * @type {Array<Style>}
         */
        _this.defaultStyle_ = options.defaultStyle
            ? options.defaultStyle
            : DEFAULT_STYLE_ARRAY;
        /**
         * @private
         * @type {boolean}
         */
        _this.extractStyles_ =
            options.extractStyles !== undefined ? options.extractStyles : true;
        /**
         * @type {boolean}
         */
        _this.writeStyles_ =
            options.writeStyles !== undefined ? options.writeStyles : true;
        /**
         * @private
         * @type {!Object<string, (Array<Style>|string)>}
         */
        _this.sharedStyles_ = {};
        /**
         * @private
         * @type {boolean}
         */
        _this.showPointNames_ =
            options.showPointNames !== undefined ? options.showPointNames : true;
        /**
         * @type {null|string}
         */
        _this.crossOrigin_ =
            options.crossOrigin !== undefined ? options.crossOrigin : 'anonymous';
        /**
         * @type {IconUrlFunction}
         */
        _this.iconUrlFunction_ = options.iconUrlFunction
            ? options.iconUrlFunction
            : defaultIconUrlFunction;
        return _this;
    }
    /**
     * @param {Node} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @private
     * @return {Array<Feature>|undefined} Features.
     */
    KML.prototype.readDocumentOrFolder_ = function (node, objectStack) {
        // FIXME use scope somehow
        var parsersNS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
            'Document': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayExtender"])(this.readDocumentOrFolder_, this),
            'Folder': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayExtender"])(this.readDocumentOrFolder_, this),
            'Placemark': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(this.readPlacemark_, this),
            'Style': this.readSharedStyle_.bind(this),
            'StyleMap': this.readSharedStyleMap_.bind(this),
        });
        /** @type {Array<Feature>} */
        // @ts-ignore
        var features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])([], parsersNS, node, objectStack, this);
        if (features) {
            return features;
        }
        else {
            return undefined;
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @private
     * @return {Feature|undefined} Feature.
     */
    KML.prototype.readPlacemark_ = function (node, objectStack) {
        var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({ 'geometry': null }, PLACEMARK_PARSERS, node, objectStack, this);
        if (!object) {
            return undefined;
        }
        var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        var id = node.getAttribute('id');
        if (id !== null) {
            feature.setId(id);
        }
        var options = /** @type {import("./Feature.js").ReadOptions} */ (objectStack[0]);
        var geometry = object['geometry'];
        if (geometry) {
            Object(_Feature_js__WEBPACK_IMPORTED_MODULE_25__["transformGeometryWithOptions"])(geometry, false, options);
        }
        feature.setGeometry(geometry);
        delete object['geometry'];
        if (this.extractStyles_) {
            var style = object['Style'];
            var styleUrl = object['styleUrl'];
            var styleFunction = createFeatureStyleFunction(style, styleUrl, this.defaultStyle_, this.sharedStyles_, this.showPointNames_);
            feature.setStyle(styleFunction);
        }
        delete object['Style'];
        // we do not remove the styleUrl property from the object, so it
        // gets stored on feature when setProperties is called
        feature.setProperties(object, true);
        return feature;
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @private
     */
    KML.prototype.readSharedStyle_ = function (node, objectStack) {
        var id = node.getAttribute('id');
        if (id !== null) {
            var style = readStyle.call(this, node, objectStack);
            if (style) {
                var styleUri = void 0;
                var baseURI = node.baseURI;
                if (!baseURI || baseURI == 'about:blank') {
                    baseURI = window.location.href;
                }
                if (baseURI) {
                    var url = new URL('#' + id, baseURI);
                    styleUri = url.href;
                }
                else {
                    styleUri = '#' + id;
                }
                this.sharedStyles_[styleUri] = style;
            }
        }
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @private
     */
    KML.prototype.readSharedStyleMap_ = function (node, objectStack) {
        var id = node.getAttribute('id');
        if (id === null) {
            return;
        }
        var styleMapValue = readStyleMapValue.call(this, node, objectStack);
        if (!styleMapValue) {
            return;
        }
        var styleUri;
        var baseURI = node.baseURI;
        if (!baseURI || baseURI == 'about:blank') {
            baseURI = window.location.href;
        }
        if (baseURI) {
            var url = new URL('#' + id, baseURI);
            styleUri = url.href;
        }
        else {
            styleUri = '#' + id;
        }
        this.sharedStyles_[styleUri] = styleMapValue;
    };
    /**
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {import("../Feature.js").default} Feature.
     */
    KML.prototype.readFeatureFromNode = function (node, opt_options) {
        if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, node.namespaceURI)) {
            return null;
        }
        var feature = this.readPlacemark_(node, [
            this.getReadOptions(node, opt_options),
        ]);
        if (feature) {
            return feature;
        }
        else {
            return null;
        }
    };
    /**
     * @protected
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */
    KML.prototype.readFeaturesFromNode = function (node, opt_options) {
        if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, node.namespaceURI)) {
            return [];
        }
        var features;
        var localName = node.localName;
        if (localName == 'Document' || localName == 'Folder') {
            features = this.readDocumentOrFolder_(node, [
                this.getReadOptions(node, opt_options),
            ]);
            if (features) {
                return features;
            }
            else {
                return [];
            }
        }
        else if (localName == 'Placemark') {
            var feature = this.readPlacemark_(node, [
                this.getReadOptions(node, opt_options),
            ]);
            if (feature) {
                return [feature];
            }
            else {
                return [];
            }
        }
        else if (localName == 'kml') {
            features = [];
            for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
                var fs = this.readFeaturesFromNode(n, opt_options);
                if (fs) {
                    Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(features, fs);
                }
            }
            return features;
        }
        else {
            return [];
        }
    };
    /**
     * Read the name of the KML.
     *
     * @param {Document|Element|string} source Source.
     * @return {string|undefined} Name.
     * @api
     */
    KML.prototype.readName = function (source) {
        if (!source) {
            return undefined;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parse"])(source);
            return this.readNameFromDocument(doc);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["isDocument"])(source)) {
            return this.readNameFromDocument(/** @type {Document} */ (source));
        }
        else {
            return this.readNameFromNode(/** @type {Element} */ (source));
        }
    };
    /**
     * @param {Document} doc Document.
     * @return {string|undefined} Name.
     */
    KML.prototype.readNameFromDocument = function (doc) {
        for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                var name_1 = this.readNameFromNode(/** @type {Element} */ (n));
                if (name_1) {
                    return name_1;
                }
            }
        }
        return undefined;
    };
    /**
     * @param {Element} node Node.
     * @return {string|undefined} Name.
     */
    KML.prototype.readNameFromNode = function (node) {
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) && n.localName == 'name') {
                return Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"])(n);
            }
        }
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            var localName = n.localName;
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) &&
                (localName == 'Document' ||
                    localName == 'Folder' ||
                    localName == 'Placemark' ||
                    localName == 'kml')) {
                var name_2 = this.readNameFromNode(n);
                if (name_2) {
                    return name_2;
                }
            }
        }
        return undefined;
    };
    /**
     * Read the network links of the KML.
     *
     * @param {Document|Element|string} source Source.
     * @return {Array<Object>} Network links.
     * @api
     */
    KML.prototype.readNetworkLinks = function (source) {
        var networkLinks = [];
        if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parse"])(source);
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(networkLinks, this.readNetworkLinksFromDocument(doc));
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["isDocument"])(source)) {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(networkLinks, this.readNetworkLinksFromDocument(/** @type {Document} */ (source)));
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ (source)));
        }
        return networkLinks;
    };
    /**
     * @param {Document} doc Document.
     * @return {Array<Object>} Network links.
     */
    KML.prototype.readNetworkLinksFromDocument = function (doc) {
        var networkLinks = [];
        for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(networkLinks, this.readNetworkLinksFromNode(/** @type {Element} */ (n)));
            }
        }
        return networkLinks;
    };
    /**
     * @param {Element} node Node.
     * @return {Array<Object>} Network links.
     */
    KML.prototype.readNetworkLinksFromNode = function (node) {
        var networkLinks = [];
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) &&
                n.localName == 'NetworkLink') {
                var obj = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, NETWORK_LINK_PARSERS, n, []);
                networkLinks.push(obj);
            }
        }
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            var localName = n.localName;
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) &&
                (localName == 'Document' || localName == 'Folder' || localName == 'kml')) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(networkLinks, this.readNetworkLinksFromNode(n));
            }
        }
        return networkLinks;
    };
    /**
     * Read the regions of the KML.
     *
     * @param {Document|Element|string} source Source.
     * @return {Array<Object>} Regions.
     * @api
     */
    KML.prototype.readRegion = function (source) {
        var regions = [];
        if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parse"])(source);
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(regions, this.readRegionFromDocument(doc));
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["isDocument"])(source)) {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(regions, this.readRegionFromDocument(/** @type {Document} */ (source)));
        }
        else {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(regions, this.readRegionFromNode(/** @type {Element} */ (source)));
        }
        return regions;
    };
    /**
     * @param {Document} doc Document.
     * @return {Array<Object>} Region.
     */
    KML.prototype.readRegionFromDocument = function (doc) {
        var regions = [];
        for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(regions, this.readRegionFromNode(/** @type {Element} */ (n)));
            }
        }
        return regions;
    };
    /**
     * @param {Element} node Node.
     * @return {Array<Object>} Region.
     * @api
     */
    KML.prototype.readRegionFromNode = function (node) {
        var regions = [];
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) && n.localName == 'Region') {
                var obj = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, REGION_PARSERS, n, []);
                regions.push(obj);
            }
        }
        for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
            var localName = n.localName;
            if (Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["includes"])(NAMESPACE_URIS, n.namespaceURI) &&
                (localName == 'Document' || localName == 'Folder' || localName == 'kml')) {
                Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(regions, this.readRegionFromNode(n));
            }
        }
        return regions;
    };
    /**
     * Encode an array of features in the KML format as an XML node. GeometryCollections,
     * MultiPoints, MultiLineStrings, and MultiPolygons are output as MultiGeometries.
     *
     * @param {Array<Feature>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Options.
     * @return {Node} Node.
     * @api
     */
    KML.prototype.writeFeaturesNode = function (features, opt_options) {
        opt_options = this.adaptOptions(opt_options);
        var kml = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["createElementNS"])(NAMESPACE_URIS[4], 'kml');
        var xmlnsUri = 'http://www.w3.org/2000/xmlns/';
        kml.setAttributeNS(xmlnsUri, 'xmlns:gx', GX_NAMESPACE_URIS[0]);
        kml.setAttributeNS(xmlnsUri, 'xmlns:xsi', _xml_js__WEBPACK_IMPORTED_MODULE_18__["XML_SCHEMA_INSTANCE_URI"]);
        kml.setAttributeNS(_xml_js__WEBPACK_IMPORTED_MODULE_18__["XML_SCHEMA_INSTANCE_URI"], 'xsi:schemaLocation', SCHEMA_LOCATION);
        var /** @type {import("../xml.js").NodeStackItem} */ context = {
            node: kml,
        };
        /** @type {!Object<string, (Array<Feature>|Feature|undefined)>} */
        var properties = {};
        if (features.length > 1) {
            properties['Document'] = features;
        }
        else if (features.length == 1) {
            properties['Placemark'] = features[0];
        }
        var orderedKeys = KML_SEQUENCE[kml.namespaceURI];
        var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, KML_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, [opt_options], orderedKeys, this);
        return kml;
    };
    return KML;
}(_XMLFeature_js__WEBPACK_IMPORTED_MODULE_17__["default"]));
/**
 * @param {Style|undefined} foundStyle Style.
 * @param {string} name Name.
 * @return {Style} style Style.
 */
function createNameStyleFunction(foundStyle, name) {
    var textOffset = [0, 0];
    var textAlign = 'start';
    var imageStyle = foundStyle.getImage();
    if (imageStyle) {
        var imageSize = imageStyle.getImageSize();
        if (imageSize === null) {
            imageSize = DEFAULT_IMAGE_STYLE_SIZE;
        }
        if (imageSize.length == 2) {
            var imageScale = imageStyle.getScaleArray();
            // Offset the label to be centered to the right of the icon,
            // if there is one.
            textOffset[0] = (imageScale[0] * imageSize[0]) / 2;
            textOffset[1] = (-imageScale[1] * imageSize[1]) / 2;
            textAlign = 'left';
        }
    }
    var textStyle = foundStyle.getText();
    if (textStyle) {
        // clone the text style, customizing it with name, alignments and offset.
        // Note that kml does not support many text options that OpenLayers does (rotation, textBaseline).
        textStyle = textStyle.clone();
        textStyle.setFont(textStyle.getFont() || DEFAULT_TEXT_STYLE.getFont());
        textStyle.setScale(textStyle.getScale() || DEFAULT_TEXT_STYLE.getScale());
        textStyle.setFill(textStyle.getFill() || DEFAULT_TEXT_STYLE.getFill());
        textStyle.setStroke(textStyle.getStroke() || DEFAULT_TEXT_STROKE_STYLE);
    }
    else {
        textStyle = DEFAULT_TEXT_STYLE.clone();
    }
    textStyle.setText(name);
    textStyle.setOffsetX(textOffset[0]);
    textStyle.setOffsetY(textOffset[1]);
    textStyle.setTextAlign(textAlign);
    var nameStyle = new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
        image: imageStyle,
        text: textStyle,
    });
    return nameStyle;
}
/**
 * @param {Array<Style>|undefined} style Style.
 * @param {string} styleUrl Style URL.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles Shared styles.
 * @param {boolean|undefined} showPointNames true to show names for point placemarks.
 * @return {import("../style/Style.js").StyleFunction} Feature style function.
 */
function createFeatureStyleFunction(style, styleUrl, defaultStyle, sharedStyles, showPointNames) {
    return (
    /**
     * @param {Feature} feature feature.
     * @param {number} resolution Resolution.
     * @return {Array<Style>|Style} Style.
     */
    function (feature, resolution) {
        var drawName = showPointNames;
        var name = '';
        var multiGeometryPoints = [];
        if (drawName) {
            var geometry = feature.getGeometry();
            if (geometry) {
                var type = geometry.getType();
                if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                    multiGeometryPoints = geometry
                        .getGeometriesArrayRecursive()
                        .filter(function (geometry) {
                        var type = geometry.getType();
                        return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT ||
                            type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT);
                    });
                    drawName = multiGeometryPoints.length > 0;
                }
                else {
                    drawName =
                        type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT || type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT;
                }
            }
        }
        if (drawName) {
            name = /** @type {string} */ (feature.get('name'));
            drawName = drawName && !!name;
            // convert any html character codes
            if (drawName && name.search(/&[^&]+;/) > -1) {
                if (!TEXTAREA) {
                    TEXTAREA = document.createElement('textarea');
                }
                TEXTAREA.innerHTML = name;
                name = TEXTAREA.value;
            }
        }
        var featureStyle = defaultStyle;
        if (style) {
            featureStyle = style;
        }
        else if (styleUrl) {
            featureStyle = findStyle(styleUrl, defaultStyle, sharedStyles);
        }
        if (drawName) {
            var nameStyle = createNameStyleFunction(featureStyle[0], name);
            if (multiGeometryPoints.length > 0) {
                // in multigeometries restrict the name style to points and create a
                // style without image or text for geometries requiring fill or stroke
                // including any polygon specific style if there is one
                nameStyle.setGeometry(new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](multiGeometryPoints));
                var baseStyle = new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                    geometry: featureStyle[0].getGeometry(),
                    image: null,
                    fill: featureStyle[0].getFill(),
                    stroke: featureStyle[0].getStroke(),
                    text: null,
                });
                return [nameStyle, baseStyle].concat(featureStyle.slice(1));
            }
            return nameStyle;
        }
        return featureStyle;
    });
}
/**
 * @param {Array<Style>|string|undefined} styleValue Style value.
 * @param {Array<Style>} defaultStyle Default style.
 * @param {!Object<string, (Array<Style>|string)>} sharedStyles
 * Shared styles.
 * @return {Array<Style>} Style.
 */
function findStyle(styleValue, defaultStyle, sharedStyles) {
    if (Array.isArray(styleValue)) {
        return styleValue;
    }
    else if (typeof styleValue === 'string') {
        return findStyle(sharedStyles[styleValue], defaultStyle, sharedStyles);
    }
    else {
        return defaultStyle;
    }
}
/**
 * @param {Node} node Node.
 * @return {import("../color.js").Color|undefined} Color.
 */
function readColor(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false);
    // The KML specification states that colors should not include a leading `#`
    // but we tolerate them.
    var m = /^\s*#?\s*([0-9A-Fa-f]{8})\s*$/.exec(s);
    if (m) {
        var hexColor = m[1];
        return [
            parseInt(hexColor.substr(6, 2), 16),
            parseInt(hexColor.substr(4, 2), 16),
            parseInt(hexColor.substr(2, 2), 16),
            parseInt(hexColor.substr(0, 2), 16) / 255,
        ];
    }
    else {
        return undefined;
    }
}
/**
 * @param {Node} node Node.
 * @return {Array<number>|undefined} Flat coordinates.
 */
function readFlatCoordinates(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false);
    var flatCoordinates = [];
    // The KML specification states that coordinate tuples should not include
    // spaces, but we tolerate them.
    s = s.replace(/\s*,\s*/g, ',');
    var re = /^\s*([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?),([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|,|$)(?:([+\-]?\d*\.?\d+(?:e[+\-]?\d+)?)(?:\s+|$))?\s*/i;
    var m;
    while ((m = re.exec(s))) {
        var x = parseFloat(m[1]);
        var y = parseFloat(m[2]);
        var z = m[3] ? parseFloat(m[3]) : 0;
        flatCoordinates.push(x, y, z);
        s = s.substr(m[0].length);
    }
    if (s !== '') {
        return undefined;
    }
    return flatCoordinates;
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */
function readURI(node) {
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false).trim();
    var baseURI = node.baseURI;
    if (!baseURI || baseURI == 'about:blank') {
        baseURI = window.location.href;
    }
    if (baseURI) {
        var url = new URL(s, baseURI);
        return url.href;
    }
    else {
        return s;
    }
}
/**
 * @param {Node} node Node.
 * @return {string} URI.
 */
function readStyleURL(node) {
    // KML files in the wild occasionally forget the leading
    // `#` on styleUrlsdefined in the same document.
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false)
        .trim()
        .replace(/^(?!.*#)/, '#');
    var baseURI = node.baseURI;
    if (!baseURI || baseURI == 'about:blank') {
        baseURI = window.location.href;
    }
    if (baseURI) {
        var url = new URL(s, baseURI);
        return url.href;
    }
    else {
        return s;
    }
}
/**
 * @param {Element} node Node.
 * @return {Vec2} Vec2.
 */
function readVec2(node) {
    var xunits = node.getAttribute('xunits');
    var yunits = node.getAttribute('yunits');
    var origin;
    if (xunits !== 'insetPixels') {
        if (yunits !== 'insetPixels') {
            origin = _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].BOTTOM_LEFT;
        }
        else {
            origin = _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].TOP_LEFT;
        }
    }
    else {
        if (yunits !== 'insetPixels') {
            origin = _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].BOTTOM_RIGHT;
        }
        else {
            origin = _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].TOP_RIGHT;
        }
    }
    return {
        x: parseFloat(node.getAttribute('x')),
        xunits: ICON_ANCHOR_UNITS_MAP[xunits],
        y: parseFloat(node.getAttribute('y')),
        yunits: ICON_ANCHOR_UNITS_MAP[yunits],
        origin: origin,
    };
}
/**
 * @param {Node} node Node.
 * @return {number|undefined} Scale.
 */
function readScale(node) {
    return Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"])(node);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var STYLE_MAP_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Pair': pairDataParser,
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>|string|undefined} StyleMap.
 */
function readStyleMapValue(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(undefined, STYLE_MAP_PARSERS, node, objectStack, this);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var ICON_STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Icon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readIcon),
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readColor),
    'heading': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'hotSpot': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readVec2),
    'scale': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readScale),
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function iconStyleParser(node, objectStack) {
    // FIXME refreshMode
    // FIXME refreshInterval
    // FIXME viewRefreshTime
    // FIXME viewBoundScale
    // FIXME viewFormat
    // FIXME httpQuery
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, ICON_STYLE_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var styleObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var IconObject = 'Icon' in object ? object['Icon'] : {};
    var drawIcon = !('Icon' in object) || Object.keys(IconObject).length > 0;
    var src;
    var href = /** @type {string|undefined} */ (IconObject['href']);
    if (href) {
        src = href;
    }
    else if (drawIcon) {
        src = DEFAULT_IMAGE_STYLE_SRC;
    }
    var anchor, anchorXUnits, anchorYUnits;
    var anchorOrigin = _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].BOTTOM_LEFT;
    var hotSpot = /** @type {Vec2|undefined} */ (object['hotSpot']);
    if (hotSpot) {
        anchor = [hotSpot.x, hotSpot.y];
        anchorXUnits = hotSpot.xunits;
        anchorYUnits = hotSpot.yunits;
        anchorOrigin = hotSpot.origin;
    }
    else if (src === DEFAULT_IMAGE_STYLE_SRC) {
        anchor = DEFAULT_IMAGE_STYLE_ANCHOR;
        anchorXUnits = DEFAULT_IMAGE_STYLE_ANCHOR_X_UNITS;
        anchorYUnits = DEFAULT_IMAGE_STYLE_ANCHOR_Y_UNITS;
    }
    else if (/^http:\/\/maps\.(?:google|gstatic)\.com\//.test(src)) {
        anchor = [0.5, 0];
        anchorXUnits = _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].FRACTION;
        anchorYUnits = _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].FRACTION;
    }
    var offset;
    var x = /** @type {number|undefined} */ (IconObject['x']);
    var y = /** @type {number|undefined} */ (IconObject['y']);
    if (x !== undefined && y !== undefined) {
        offset = [x, y];
    }
    var size;
    var w = /** @type {number|undefined} */ (IconObject['w']);
    var h = /** @type {number|undefined} */ (IconObject['h']);
    if (w !== undefined && h !== undefined) {
        size = [w, h];
    }
    var rotation;
    var heading = /** @type {number} */ (object['heading']);
    if (heading !== undefined) {
        rotation = Object(_math_js__WEBPACK_IMPORTED_MODULE_24__["toRadians"])(heading);
    }
    var scale = /** @type {number|undefined} */ (object['scale']);
    var color = /** @type {Array<number>|undefined} */ (object['color']);
    if (drawIcon) {
        if (src == DEFAULT_IMAGE_STYLE_SRC) {
            size = DEFAULT_IMAGE_STYLE_SIZE;
            if (scale === undefined) {
                scale = DEFAULT_IMAGE_SCALE_MULTIPLIER;
            }
        }
        var imageStyle = new _style_Icon_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
            anchor: anchor,
            anchorOrigin: anchorOrigin,
            anchorXUnits: anchorXUnits,
            anchorYUnits: anchorYUnits,
            crossOrigin: this.crossOrigin_,
            offset: offset,
            offsetOrigin: _style_IconOrigin_js__WEBPACK_IMPORTED_MODULE_7__["default"].BOTTOM_LEFT,
            rotation: rotation,
            scale: scale,
            size: size,
            src: this.iconUrlFunction_(src),
            color: color,
        });
        styleObject['imageStyle'] = imageStyle;
    }
    else {
        // handle the case when we explicitly want to draw no icon.
        styleObject['imageStyle'] = DEFAULT_NO_IMAGE_STYLE;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LABEL_STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readColor),
    'scale': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readScale),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function labelStyleParser(node, objectStack) {
    // FIXME colorMode
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, LABEL_STYLE_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var styleObject = objectStack[objectStack.length - 1];
    var textStyle = new _style_Text_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
        fill: new _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
            color: 
            /** @type {import("../color.js").Color} */
            ('color' in object ? object['color'] : DEFAULT_COLOR),
        }),
        scale: /** @type {number|undefined} */ (object['scale']),
    });
    styleObject['textStyle'] = textStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LINE_STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readColor),
    'width': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function lineStyleParser(node, objectStack) {
    // FIXME colorMode
    // FIXME gx:outerColor
    // FIXME gx:outerWidth
    // FIXME gx:physicalWidth
    // FIXME gx:labelVisibility
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, LINE_STYLE_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var styleObject = objectStack[objectStack.length - 1];
    var strokeStyle = new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_14__["default"]({
        color: 
        /** @type {import("../color.js").Color} */
        ('color' in object ? object['color'] : DEFAULT_COLOR),
        width: /** @type {number} */ ('width' in object ? object['width'] : 1),
    });
    styleObject['strokeStyle'] = strokeStyle;
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var POLY_STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readColor),
    'fill': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
    'outline': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function polyStyleParser(node, objectStack) {
    // FIXME colorMode
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, POLY_STYLE_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var styleObject = objectStack[objectStack.length - 1];
    var fillStyle = new _style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
        color: 
        /** @type {import("../color.js").Color} */
        ('color' in object ? object['color'] : DEFAULT_COLOR),
    });
    styleObject['fillStyle'] = fillStyle;
    var fill = /** @type {boolean|undefined} */ (object['fill']);
    if (fill !== undefined) {
        styleObject['fill'] = fill;
    }
    var outline = /** @type {boolean|undefined} */ (object['outline']);
    if (outline !== undefined) {
        styleObject['outline'] = outline;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var FLAT_LINEAR_RING_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeReplacer"])(readFlatCoordinates),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} LinearRing flat coordinates.
 */
function readFlatLinearRing(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(null, FLAT_LINEAR_RING_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function gxCoordParser(node, objectStack) {
    var gxTrackObject = 
    /** @type {GxTrackObject} */
    (objectStack[objectStack.length - 1]);
    var coordinates = gxTrackObject.coordinates;
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false);
    var re = /^\s*([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s+([+\-]?\d+(?:\.\d*)?(?:e[+\-]?\d*)?)\s*$/i;
    var m = re.exec(s);
    if (m) {
        var x = parseFloat(m[1]);
        var y = parseFloat(m[2]);
        var z = parseFloat(m[3]);
        coordinates.push([x, y, z]);
    }
    else {
        coordinates.push([]);
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var GX_MULTITRACK_GEOMETRY_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, {
    'Track': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readGxTrack),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {MultiLineString|undefined} MultiLineString.
 */
function readGxMultiTrack(node, objectStack) {
    var lineStrings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])([], GX_MULTITRACK_GEOMETRY_PARSERS, node, objectStack);
    if (!lineStrings) {
        return undefined;
    }
    return new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_9__["default"](lineStrings);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var GX_TRACK_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'when': whenParser,
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, {
    'coord': gxCoordParser,
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */
function readGxTrack(node, objectStack) {
    var gxTrackObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(
    /** @type {GxTrackObject} */ ({
        coordinates: [],
        whens: [],
    }), GX_TRACK_PARSERS, node, objectStack);
    if (!gxTrackObject) {
        return undefined;
    }
    var flatCoordinates = [];
    var coordinates = gxTrackObject.coordinates;
    var whens = gxTrackObject.whens;
    for (var i = 0, ii = Math.min(coordinates.length, whens.length); i < ii; ++i) {
        if (coordinates[i].length == 3) {
            flatCoordinates.push(coordinates[i][0], coordinates[i][1], coordinates[i][2], whens[i]);
        }
    }
    return new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_8__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZM);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var ICON_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'href': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readURI),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, {
    'x': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'y': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'w': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'h': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object} Icon object.
 */
function readIcon(node, objectStack) {
    var iconObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, ICON_PARSERS, node, objectStack);
    if (iconObject) {
        return iconObject;
    }
    else {
        return null;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var GEOMETRY_FLAT_COORDINATES_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeReplacer"])(readFlatCoordinates),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<number>} Flat coordinates.
 */
function readFlatCoordinatesFromNode(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(null, GEOMETRY_FLAT_COORDINATES_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var EXTRUDE_AND_ALTITUDE_MODE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'extrude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
    'tessellate': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readBoolean"]),
    'altitudeMode': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {LineString|undefined} LineString.
 */
function readLineString(node, objectStack) {
    var properties = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    var flatCoordinates = readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        var lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_8__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZ);
        lineString.setProperties(properties, true);
        return lineString;
    }
    else {
        return undefined;
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */
function readLinearRing(node, objectStack) {
    var properties = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    var flatCoordinates = readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        var polygon = new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_13__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZ, [
            flatCoordinates.length,
        ]);
        polygon.setProperties(properties, true);
        return polygon;
    }
    else {
        return undefined;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var MULTI_GEOMETRY_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readLineString),
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readLinearRing),
    'MultiGeometry': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readMultiGeometry),
    'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readPoint),
    'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readPolygon),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {import("../geom/Geometry.js").default} Geometry.
 */
function readMultiGeometry(node, objectStack) {
    var geometries = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])([], MULTI_GEOMETRY_PARSERS, node, objectStack);
    if (!geometries) {
        return null;
    }
    if (geometries.length === 0) {
        return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometries);
    }
    var multiGeometry;
    var homogeneous = true;
    var type = geometries[0].getType();
    var geometry;
    for (var i = 1, ii = geometries.length; i < ii; ++i) {
        geometry = geometries[i];
        if (geometry.getType() != type) {
            homogeneous = false;
            break;
        }
    }
    if (homogeneous) {
        var layout = void 0;
        var flatCoordinates = void 0;
        if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT) {
            var point = geometries[0];
            layout = point.getLayout();
            flatCoordinates = point.getFlatCoordinates();
            for (var i = 1, ii = geometries.length; i < ii; ++i) {
                geometry = geometries[i];
                Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(flatCoordinates, geometry.getFlatCoordinates());
            }
            multiGeometry = new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_10__["default"](flatCoordinates, layout);
            setCommonGeometryProperties(multiGeometry, geometries);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING) {
            multiGeometry = new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_9__["default"](geometries);
            setCommonGeometryProperties(multiGeometry, geometries);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON) {
            multiGeometry = new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_11__["default"](geometries);
            setCommonGeometryProperties(multiGeometry, geometries);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
            multiGeometry = new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometries);
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(false, 37); // Unknown geometry type found
        }
    }
    else {
        multiGeometry = new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometries);
    }
    return /** @type {import("../geom/Geometry.js").default} */ (multiGeometry);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Point|undefined} Point.
 */
function readPoint(node, objectStack) {
    var properties = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    var flatCoordinates = readFlatCoordinatesFromNode(node, objectStack);
    if (flatCoordinates) {
        var point = new _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZ);
        point.setProperties(properties, true);
        return point;
    }
    else {
        return undefined;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var FLAT_LINEAR_RINGS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'innerBoundaryIs': innerBoundaryIsParser,
    'outerBoundaryIs': outerBoundaryIsParser,
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Polygon|undefined} Polygon.
 */
function readPolygon(node, objectStack) {
    var properties = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(
    /** @type {Object<string,*>} */ ({}), EXTRUDE_AND_ALTITUDE_MODE_PARSERS, node, objectStack);
    var flatLinearRings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])([null], FLAT_LINEAR_RINGS_PARSERS, node, objectStack);
    if (flatLinearRings && flatLinearRings[0]) {
        var flatCoordinates = flatLinearRings[0];
        var ends = [flatCoordinates.length];
        for (var i = 1, ii = flatLinearRings.length; i < ii; ++i) {
            Object(_array_js__WEBPACK_IMPORTED_MODULE_21__["extend"])(flatCoordinates, flatLinearRings[i]);
            ends.push(flatCoordinates.length);
        }
        var polygon = new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_13__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZ, ends);
        polygon.setProperties(properties, true);
        return polygon;
    }
    else {
        return undefined;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'IconStyle': iconStyleParser,
    'LabelStyle': labelStyleParser,
    'LineStyle': lineStyleParser,
    'PolyStyle': polyStyleParser,
});
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<Style>} Style.
 */
function readStyle(node, objectStack) {
    var styleObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, STYLE_PARSERS, node, objectStack, this);
    if (!styleObject) {
        return null;
    }
    var fillStyle = 
    /** @type {Fill} */
    ('fillStyle' in styleObject ? styleObject['fillStyle'] : DEFAULT_FILL_STYLE);
    var fill = /** @type {boolean|undefined} */ (styleObject['fill']);
    if (fill !== undefined && !fill) {
        fillStyle = null;
    }
    var imageStyle;
    if ('imageStyle' in styleObject) {
        if (styleObject['imageStyle'] != DEFAULT_NO_IMAGE_STYLE) {
            imageStyle = styleObject['imageStyle'];
        }
    }
    else {
        imageStyle = DEFAULT_IMAGE_STYLE;
    }
    var textStyle = 
    /** @type {Text} */
    ('textStyle' in styleObject ? styleObject['textStyle'] : DEFAULT_TEXT_STYLE);
    var strokeStyle = 
    /** @type {Stroke} */
    ('strokeStyle' in styleObject
        ? styleObject['strokeStyle']
        : DEFAULT_STROKE_STYLE);
    var outline = /** @type {boolean|undefined} */ (styleObject['outline']);
    if (outline !== undefined && !outline) {
        // if the polystyle specifies no outline two styles are needed,
        // one for non-polygon geometries where linestrings require a stroke
        // and one for polygons where there should be no stroke
        return [
            new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                geometry: function (feature) {
                    var geometry = feature.getGeometry();
                    var type = geometry.getType();
                    if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                        return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometry
                            .getGeometriesArrayRecursive()
                            .filter(function (geometry) {
                            var type = geometry.getType();
                            return (type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON &&
                                type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON);
                        }));
                    }
                    else if (type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON &&
                        type !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON) {
                        return geometry;
                    }
                },
                fill: fillStyle,
                image: imageStyle,
                stroke: strokeStyle,
                text: textStyle,
                zIndex: undefined, // FIXME
            }),
            new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
                geometry: function (feature) {
                    var geometry = feature.getGeometry();
                    var type = geometry.getType();
                    if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                        return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometry
                            .getGeometriesArrayRecursive()
                            .filter(function (geometry) {
                            var type = geometry.getType();
                            return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON ||
                                type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON);
                        }));
                    }
                    else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON ||
                        type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON) {
                        return geometry;
                    }
                },
                fill: fillStyle,
                stroke: null,
                zIndex: undefined, // FIXME
            }),
        ];
    }
    return [
        new _style_Style_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
            fill: fillStyle,
            image: imageStyle,
            stroke: strokeStyle,
            text: textStyle,
            zIndex: undefined, // FIXME
        }),
    ];
}
/**
 * Reads an array of geometries and creates arrays for common geometry
 * properties. Then sets them to the multi geometry.
 * @param {MultiPoint|MultiLineString|MultiPolygon} multiGeometry A multi-geometry.
 * @param {Array<import("../geom/Geometry.js").default>} geometries List of geometries.
 */
function setCommonGeometryProperties(multiGeometry, geometries) {
    var ii = geometries.length;
    var extrudes = new Array(geometries.length);
    var tessellates = new Array(geometries.length);
    var altitudeModes = new Array(geometries.length);
    var hasExtrude, hasTessellate, hasAltitudeMode;
    hasExtrude = false;
    hasTessellate = false;
    hasAltitudeMode = false;
    for (var i = 0; i < ii; ++i) {
        var geometry = geometries[i];
        extrudes[i] = geometry.get('extrude');
        tessellates[i] = geometry.get('tessellate');
        altitudeModes[i] = geometry.get('altitudeMode');
        hasExtrude = hasExtrude || extrudes[i] !== undefined;
        hasTessellate = hasTessellate || tessellates[i] !== undefined;
        hasAltitudeMode = hasAltitudeMode || altitudeModes[i];
    }
    if (hasExtrude) {
        multiGeometry.set('extrude', extrudes);
    }
    if (hasTessellate) {
        multiGeometry.set('tessellate', tessellates);
    }
    if (hasAltitudeMode) {
        multiGeometry.set('altitudeMode', altitudeModes);
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var DATA_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'displayName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'value': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function dataParser(node, objectStack) {
    var name = node.getAttribute('name');
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parseNode"])(DATA_PARSERS, node, objectStack);
    var featureObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    if (name && featureObject.displayName) {
        featureObject[name] = {
            value: featureObject.value,
            displayName: featureObject.displayName,
            toString: function () {
                return featureObject.value;
            },
        };
    }
    else if (name !== null) {
        featureObject[name] = featureObject.value;
    }
    else if (featureObject.displayName !== null) {
        featureObject[featureObject.displayName] = featureObject.value;
    }
    delete featureObject['value'];
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var EXTENDED_DATA_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Data': dataParser,
    'SchemaData': schemaDataParser,
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function extendedDataParser(node, objectStack) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parseNode"])(EXTENDED_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function regionParser(node, objectStack) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parseNode"])(REGION_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PAIR_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Style': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readStyle),
    'key': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'styleUrl': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(readStyleURL),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function pairDataParser(node, objectStack) {
    var pairObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, PAIR_PARSERS, node, objectStack, this);
    if (!pairObject) {
        return;
    }
    var key = /** @type {string|undefined} */ (pairObject['key']);
    if (key && key == 'normal') {
        var styleUrl = /** @type {string|undefined} */ (pairObject['styleUrl']);
        if (styleUrl) {
            objectStack[objectStack.length - 1] = styleUrl;
        }
        var style = /** @type {Style} */ (pairObject['Style']);
        if (style) {
            objectStack[objectStack.length - 1] = style;
        }
    }
}
/**
 * @this {KML}
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function placemarkStyleMapParser(node, objectStack) {
    var styleMapValue = readStyleMapValue.call(this, node, objectStack);
    if (!styleMapValue) {
        return;
    }
    var placemarkObject = objectStack[objectStack.length - 1];
    if (Array.isArray(styleMapValue)) {
        placemarkObject['Style'] = styleMapValue;
    }
    else if (typeof styleMapValue === 'string') {
        placemarkObject['styleUrl'] = styleMapValue;
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(false, 38); // `styleMapValue` has an unknown type
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var SCHEMA_DATA_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'SimpleData': simpleDataParser,
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function schemaDataParser(node, objectStack) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parseNode"])(SCHEMA_DATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function simpleDataParser(node, objectStack) {
    var name = node.getAttribute('name');
    if (name !== null) {
        var data = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"])(node);
        var featureObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
        featureObject[name] = data;
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LAT_LON_ALT_BOX_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'altitudeMode': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readString"]),
    'minAltitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'maxAltitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'north': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'south': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'east': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'west': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function latLonAltBoxParser(node, objectStack) {
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, LAT_LON_ALT_BOX_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var regionObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var extent = [
        parseFloat(object['west']),
        parseFloat(object['south']),
        parseFloat(object['east']),
        parseFloat(object['north']),
    ];
    regionObject['extent'] = extent;
    regionObject['altitudeMode'] = object['altitudeMode'];
    regionObject['minAltitude'] = parseFloat(object['minAltitude']);
    regionObject['maxAltitude'] = parseFloat(object['maxAltitude']);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LOD_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'minLodPixels': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'maxLodPixels': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'minFadeExtent': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
    'maxFadeExtent': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["readDecimal"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function lodParser(node, objectStack) {
    var object = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])({}, LOD_PARSERS, node, objectStack);
    if (!object) {
        return;
    }
    var lodObject = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    lodObject['minLodPixels'] = parseFloat(object['minLodPixels']);
    lodObject['maxLodPixels'] = parseFloat(object['maxLodPixels']);
    lodObject['minFadeExtent'] = parseFloat(object['minFadeExtent']);
    lodObject['maxFadeExtent'] = parseFloat(object['maxFadeExtent']);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var INNER_BOUNDARY_IS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    // KML spec only allows one LinearRing  per innerBoundaryIs, but Google Earth
    // allows multiple, so we parse multiple here too.
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeArrayPusher"])(readFlatLinearRing),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function innerBoundaryIsParser(node, objectStack) {
    var innerBoundaryFlatLinearRings = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(
    /** @type {Array<Array<number>>} */ ([]), INNER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (innerBoundaryFlatLinearRings.length > 0) {
        var flatLinearRings = 
        /** @type {Array<Array<number>>} */
        (objectStack[objectStack.length - 1]);
        flatLinearRings.push.apply(flatLinearRings, innerBoundaryFlatLinearRings);
    }
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var OUTER_BOUNDARY_IS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeReplacer"])(readFlatLinearRing),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function outerBoundaryIsParser(node, objectStack) {
    /** @type {Array<number>|undefined} */
    var flatLinearRing = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushParseAndPop"])(undefined, OUTER_BOUNDARY_IS_PARSERS, node, objectStack);
    if (flatLinearRing) {
        var flatLinearRings = 
        /** @type {Array<Array<number>>} */
        (objectStack[objectStack.length - 1]);
        flatLinearRings[0] = flatLinearRing;
    }
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function linkParser(node, objectStack) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["parseNode"])(LINK_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function whenParser(node, objectStack) {
    var gxTrackObject = 
    /** @type {GxTrackObject} */
    (objectStack[objectStack.length - 1]);
    var whens = gxTrackObject.whens;
    var s = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["getAllTextContent"])(node, false);
    var when = Date.parse(s);
    whens.push(isNaN(when) ? 0 : when);
}
/**
 * @param {Node} node Node to append a TextNode with the color to.
 * @param {import("../color.js").Color|string} color Color.
 */
function writeColorTextNode(node, color) {
    var rgba = Object(_color_js__WEBPACK_IMPORTED_MODULE_19__["asArray"])(color);
    var opacity = rgba.length == 4 ? rgba[3] : 1;
    /** @type {Array<string|number>} */
    var abgr = [opacity * 255, rgba[2], rgba[1], rgba[0]];
    for (var i = 0; i < 4; ++i) {
        var hex = Math.floor(/** @type {number} */ (abgr[i])).toString(16);
        abgr[i] = hex.length == 1 ? '0' + hex : hex;
    }
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"])(node, abgr.join(''));
}
/**
 * @param {Node} node Node to append a TextNode with the coordinates to.
 * @param {Array<number>} coordinates Coordinates.
 * @param {Array<*>} objectStack Object stack.
 */
function writeCoordinatesTextNode(node, coordinates, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var layout = context['layout'];
    var stride = context['stride'];
    var dimension;
    if (layout == _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XY || layout == _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYM) {
        dimension = 2;
    }
    else if (layout == _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZ || layout == _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_3__["default"].XYZM) {
        dimension = 3;
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(false, 34); // Invalid geometry layout
    }
    var ii = coordinates.length;
    var text = '';
    if (ii > 0) {
        text += coordinates[0];
        for (var d = 1; d < dimension; ++d) {
            text += ',' + coordinates[d];
        }
        for (var i = stride; i < ii; i += stride) {
            text += ' ' + coordinates[i];
            for (var d = 1; d < dimension; ++d) {
                text += ',' + coordinates[i + d];
            }
        }
    }
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"])(node, text);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var EXTENDEDDATA_NODE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Data': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeDataNode),
    'value': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeDataNodeValue),
    'displayName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeDataNodeName),
});
/**
 * @param {Element} node Node.
 * @param {{name: *, value: *}} pair Name value pair.
 * @param {Array<*>} objectStack Object stack.
 */
function writeDataNode(node, pair, objectStack) {
    node.setAttribute('name', pair.name);
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var value = pair.value;
    if (typeof value == 'object') {
        if (value !== null && value.displayName) {
            Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, EXTENDEDDATA_NODE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], [value.displayName], objectStack, ['displayName']);
        }
        if (value !== null && value.value) {
            Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, EXTENDEDDATA_NODE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], [value.value], objectStack, ['value']);
        }
    }
    else {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, EXTENDEDDATA_NODE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], [value], objectStack, ['value']);
    }
}
/**
 * @param {Node} node Node to append a TextNode with the name to.
 * @param {string} name DisplayName.
 */
function writeDataNodeName(node, name) {
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeCDATASection"])(node, name);
}
/**
 * @param {Node} node Node to append a CDATA Section with the value to.
 * @param {string} value Value.
 */
function writeDataNodeValue(node, value) {
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"])(node, value);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var DOCUMENT_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Placemark': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePlacemark),
});
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [opt_nodeName] Node name.
 * @return {Node|undefined} Node.
 */
var DOCUMENT_NODE_FACTORY = function (value, objectStack, opt_nodeName) {
    var parentNode = objectStack[objectStack.length - 1].node;
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["createElementNS"])(parentNode.namespaceURI, 'Placemark');
};
/**
 * @param {Node} node Node.
 * @param {Array<Feature>} features Features.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */
function writeDocument(node, features, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, DOCUMENT_SERIALIZERS, DOCUMENT_NODE_FACTORY, features, objectStack, undefined, this);
}
/**
 * A factory for creating Data nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */
var DATA_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('Data');
/**
 * @param {Node} node Node.
 * @param {{names: Array<string>, values: (Array<*>)}} namesAndValues Names and values.
 * @param {Array<*>} objectStack Object stack.
 */
function writeExtendedData(node, namesAndValues, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var names = namesAndValues.names;
    var values = namesAndValues.values;
    var length = names.length;
    for (var i = 0; i < length; i++) {
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, EXTENDEDDATA_NODE_SERIALIZERS, DATA_NODE_FACTORY, [{ name: names[i], value: values[i] }], objectStack);
    }
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var ICON_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, ['href'], Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, ['x', 'y', 'w', 'h']));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var ICON_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'href': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(GX_NAMESPACE_URIS, {
    'x': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
    'y': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
    'w': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
    'h': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
}));
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [opt_nodeName] Node name.
 * @return {Node|undefined} Node.
 */
var GX_NODE_FACTORY = function (value, objectStack, opt_nodeName) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["createElementNS"])(GX_NAMESPACE_URIS[0], 'gx:' + opt_nodeName);
};
/**
 * @param {Node} node Node.
 * @param {Object} icon Icon object.
 * @param {Array<*>} objectStack Object stack.
 */
function writeIcon(node, icon, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = ICON_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(icon, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, ICON_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
    orderedKeys = ICON_SEQUENCE[GX_NAMESPACE_URIS[0]];
    values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(icon, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, ICON_SERIALIZERS, GX_NODE_FACTORY, values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var ICON_STYLE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'scale',
    'heading',
    'Icon',
    'color',
    'hotSpot',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var ICON_STYLE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'Icon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeIcon),
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeColorTextNode),
    'heading': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
    'hotSpot': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeVec2),
    'scale': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeScaleTextNode),
});
/**
 * @param {Node} node Node.
 * @param {import("../style/Icon.js").default} style Icon style.
 * @param {Array<*>} objectStack Object stack.
 */
function writeIconStyle(node, style, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var /** @type {Object<string, any>} */ properties = {};
    var src = style.getSrc();
    var size = style.getSize();
    var iconImageSize = style.getImageSize();
    var iconProperties = {
        'href': src,
    };
    if (size) {
        iconProperties['w'] = size[0];
        iconProperties['h'] = size[1];
        var anchor = style.getAnchor(); // top-left
        var origin_1 = style.getOrigin(); // top-left
        if (origin_1 && iconImageSize && origin_1[0] !== 0 && origin_1[1] !== size[1]) {
            iconProperties['x'] = origin_1[0];
            iconProperties['y'] = iconImageSize[1] - (origin_1[1] + size[1]);
        }
        if (anchor && (anchor[0] !== size[0] / 2 || anchor[1] !== size[1] / 2)) {
            var /** @type {Vec2} */ hotSpot = {
                x: anchor[0],
                xunits: _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS,
                y: size[1] - anchor[1],
                yunits: _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_6__["default"].PIXELS,
            };
            properties['hotSpot'] = hotSpot;
        }
    }
    properties['Icon'] = iconProperties;
    var scale = style.getScale();
    if (scale !== 1) {
        properties['scale'] = scale;
    }
    var rotation = style.getRotation();
    if (rotation !== 0) {
        properties['heading'] = rotation; // 0-360
    }
    var color = style.getColor();
    if (color) {
        properties['color'] = color;
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = ICON_STYLE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, ICON_STYLE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var LABEL_STYLE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'color',
    'scale',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var LABEL_STYLE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeColorTextNode),
    'scale': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeScaleTextNode),
});
/**
 * @param {Node} node Node.
 * @param {Text} style style.
 * @param {Array<*>} objectStack Object stack.
 */
function writeLabelStyle(node, style, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var properties = {};
    var fill = style.getFill();
    if (fill) {
        properties['color'] = fill.getColor();
    }
    var scale = style.getScale();
    if (scale && scale !== 1) {
        properties['scale'] = scale;
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = LABEL_STYLE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, LABEL_STYLE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var LINE_STYLE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, ['color', 'width']);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var LINE_STYLE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeColorTextNode),
    'width': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"]),
});
/**
 * @param {Node} node Node.
 * @param {Stroke} style style.
 * @param {Array<*>} objectStack Object stack.
 */
function writeLineStyle(node, style, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var properties = {
        'color': style.getColor(),
        'width': Number(style.getWidth()) || 1,
    };
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = LINE_STYLE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, LINE_STYLE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, string>}
 */
var GEOMETRY_TYPE_TO_NODENAME = {
    'Point': 'Point',
    'LineString': 'LineString',
    'LinearRing': 'LinearRing',
    'Polygon': 'Polygon',
    'MultiPoint': 'MultiGeometry',
    'MultiLineString': 'MultiGeometry',
    'MultiPolygon': 'MultiGeometry',
    'GeometryCollection': 'MultiGeometry',
};
/**
 * @const
 * @param {*} value Value.
 * @param {Array<*>} objectStack Object stack.
 * @param {string} [opt_nodeName] Node name.
 * @return {Node|undefined} Node.
 */
var GEOMETRY_NODE_FACTORY = function (value, objectStack, opt_nodeName) {
    if (value) {
        var parentNode = objectStack[objectStack.length - 1].node;
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["createElementNS"])(parentNode.namespaceURI, GEOMETRY_TYPE_TO_NODENAME[
        /** @type {import("../geom/Geometry.js").default} */ (value).getType()]);
    }
};
/**
 * A factory for creating Point nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var POINT_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('Point');
/**
 * A factory for creating LineString nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var LINE_STRING_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('LineString');
/**
 * A factory for creating LinearRing nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var LINEAR_RING_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('LinearRing');
/**
 * A factory for creating Polygon nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var POLYGON_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('Polygon');
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var MULTI_GEOMETRY_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
    'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
    'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePolygon),
    'GeometryCollection': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeMultiGeometry),
});
/**
 * @param {Node} node Node.
 * @param {import("../geom/Geometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */
function writeMultiGeometry(node, geometry, objectStack) {
    /** @type {import("../xml.js").NodeStackItem} */
    var context = { node: node };
    var type = geometry.getType();
    /** @type {Array<import("../geom/Geometry.js").default>} */
    var geometries = [];
    /** @type {function(*, Array<*>, string=): (Node|undefined)} */
    var factory;
    if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
        /** @type {GeometryCollection} */ (geometry)
            .getGeometriesArrayRecursive()
            .forEach(function (geometry) {
            var type = geometry.getType();
            if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT) {
                geometries = geometries.concat(
                /** @type {MultiPoint} */ (geometry).getPoints());
            }
            else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING) {
                geometries = geometries.concat(
                /** @type {MultiLineString} */ (geometry).getLineStrings());
            }
            else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON) {
                geometries = geometries.concat(
                /** @type {MultiPolygon} */ (geometry).getPolygons());
            }
            else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT ||
                type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING ||
                type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON) {
                geometries.push(geometry);
            }
            else {
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(false, 39); // Unknown geometry type
            }
        });
        factory = GEOMETRY_NODE_FACTORY;
    }
    else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT) {
        geometries = /** @type {MultiPoint} */ (geometry).getPoints();
        factory = POINT_NODE_FACTORY;
    }
    else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING) {
        geometries = /** @type {MultiLineString} */ (geometry).getLineStrings();
        factory = LINE_STRING_NODE_FACTORY;
    }
    else if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON) {
        geometries = /** @type {MultiPolygon} */ (geometry).getPolygons();
        factory = POLYGON_NODE_FACTORY;
    }
    else {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_20__["assert"])(false, 39); // Unknown geometry type
    }
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, MULTI_GEOMETRY_SERIALIZERS, factory, geometries, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var BOUNDARY_IS_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
});
/**
 * @param {Node} node Node.
 * @param {import("../geom/LinearRing.js").default} linearRing Linear ring.
 * @param {Array<*>} objectStack Object stack.
 */
function writeBoundaryIs(node, linearRing, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, BOUNDARY_IS_SERIALIZERS, LINEAR_RING_NODE_FACTORY, [linearRing], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var PLACEMARK_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'ExtendedData': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeExtendedData),
    'MultiGeometry': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeMultiGeometry),
    'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
    'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
    'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePrimitiveGeometry),
    'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePolygon),
    'Style': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeStyle),
    'address': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'description': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'open': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
    'phoneNumber': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'styleUrl': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'visibility': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
});
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var PLACEMARK_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'name',
    'open',
    'visibility',
    'address',
    'phoneNumber',
    'description',
    'styleUrl',
    'Style',
]);
/**
 * A factory for creating ExtendedData nodes.
 * @const
 * @type {function(*, Array<*>): (Node|undefined)}
 */
var EXTENDEDDATA_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('ExtendedData');
/**
 * FIXME currently we do serialize arbitrary/custom feature properties
 * (ExtendedData).
 * @param {Element} node Node.
 * @param {Feature} feature Feature.
 * @param {Array<*>} objectStack Object stack.
 * @this {KML}
 */
function writePlacemark(node, feature, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    // set id
    if (feature.getId()) {
        node.setAttribute('id', /** @type {string} */ (feature.getId()));
    }
    // serialize properties (properties unknown to KML are not serialized)
    var properties = feature.getProperties();
    // don't export these to ExtendedData
    var filter = {
        'address': 1,
        'description': 1,
        'name': 1,
        'open': 1,
        'phoneNumber': 1,
        'styleUrl': 1,
        'visibility': 1,
    };
    filter[feature.getGeometryName()] = 1;
    var keys = Object.keys(properties || {})
        .sort()
        .filter(function (v) {
        return !filter[v];
    });
    var styleFunction = feature.getStyleFunction();
    if (styleFunction) {
        // FIXME the styles returned by the style function are supposed to be
        // resolution-independent here
        var styles = styleFunction(feature, 0);
        if (styles) {
            var styleArray = Array.isArray(styles) ? styles : [styles];
            var pointStyles = styleArray;
            if (feature.getGeometry()) {
                pointStyles = styleArray.filter(function (style) {
                    var geometry = style.getGeometryFunction()(feature);
                    if (geometry) {
                        var type = geometry.getType();
                        if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                            return /** @type {GeometryCollection} */ (geometry)
                                .getGeometriesArrayRecursive()
                                .filter(function (geometry) {
                                var type = geometry.getType();
                                return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT ||
                                    type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT);
                            }).length;
                        }
                        return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT || type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT);
                    }
                });
            }
            if (this.writeStyles_) {
                var lineStyles = styleArray;
                var polyStyles = styleArray;
                if (feature.getGeometry()) {
                    lineStyles = styleArray.filter(function (style) {
                        var geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            var type = geometry.getType();
                            if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                                return /** @type {GeometryCollection} */ (geometry)
                                    .getGeometriesArrayRecursive()
                                    .filter(function (geometry) {
                                    var type = geometry.getType();
                                    return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING ||
                                        type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING);
                                }).length;
                            }
                            return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING ||
                                type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING);
                        }
                    });
                    polyStyles = styleArray.filter(function (style) {
                        var geometry = style.getGeometryFunction()(feature);
                        if (geometry) {
                            var type = geometry.getType();
                            if (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].GEOMETRY_COLLECTION) {
                                return /** @type {GeometryCollection} */ (geometry)
                                    .getGeometriesArrayRecursive()
                                    .filter(function (geometry) {
                                    var type = geometry.getType();
                                    return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON ||
                                        type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON);
                                }).length;
                            }
                            return (type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON ||
                                type === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON);
                        }
                    });
                }
                properties['Style'] = {
                    pointStyles: pointStyles,
                    lineStyles: lineStyles,
                    polyStyles: polyStyles,
                };
            }
            if (pointStyles.length && properties['name'] === undefined) {
                var textStyle = pointStyles[0].getText();
                if (textStyle) {
                    properties['name'] = textStyle.getText();
                }
            }
        }
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = PLACEMARK_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, PLACEMARK_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
    if (keys.length > 0) {
        var sequence = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, keys);
        var namesAndValues = { names: keys, values: sequence };
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, PLACEMARK_SERIALIZERS, EXTENDEDDATA_NODE_FACTORY, [namesAndValues], objectStack);
    }
    // serialize geometry
    var options = /** @type {import("./Feature.js").WriteOptions} */ (objectStack[0]);
    var geometry = feature.getGeometry();
    if (geometry) {
        geometry = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_25__["transformGeometryWithOptions"])(geometry, true, options);
    }
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, PLACEMARK_SERIALIZERS, GEOMETRY_NODE_FACTORY, [geometry], objectStack);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var PRIMITIVE_GEOMETRY_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'extrude',
    'tessellate',
    'altitudeMode',
    'coordinates',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var PRIMITIVE_GEOMETRY_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'extrude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
    'tessellate': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
    'altitudeMode': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeStringTextNode"]),
    'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeCoordinatesTextNode),
});
/**
 * @param {Node} node Node.
 * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @param {Array<*>} objectStack Object stack.
 */
function writePrimitiveGeometry(node, geometry, objectStack) {
    var flatCoordinates = geometry.getFlatCoordinates();
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    context['layout'] = geometry.getLayout();
    context['stride'] = geometry.getStride();
    // serialize properties (properties unknown to KML are not serialized)
    var properties = geometry.getProperties();
    properties.coordinates = flatCoordinates;
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = PRIMITIVE_GEOMETRY_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, PRIMITIVE_GEOMETRY_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var POLY_STYLE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'color',
    'fill',
    'outline',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var POLYGON_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'outerBoundaryIs': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeBoundaryIs),
    'innerBoundaryIs': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeBoundaryIs),
});
/**
 * A factory for creating innerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var INNER_BOUNDARY_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('innerBoundaryIs');
/**
 * A factory for creating outerBoundaryIs nodes.
 * @const
 * @type {function(*, Array<*>, string=): (Node|undefined)}
 */
var OUTER_BOUNDARY_NODE_FACTORY = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSimpleNodeFactory"])('outerBoundaryIs');
/**
 * @param {Node} node Node.
 * @param {Polygon} polygon Polygon.
 * @param {Array<*>} objectStack Object stack.
 */
function writePolygon(node, polygon, objectStack) {
    var linearRings = polygon.getLinearRings();
    var outerRing = linearRings.shift();
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    // inner rings
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, POLYGON_SERIALIZERS, INNER_BOUNDARY_NODE_FACTORY, linearRings, objectStack);
    // outer ring
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, POLYGON_SERIALIZERS, OUTER_BOUNDARY_NODE_FACTORY, [outerRing], objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var POLY_STYLE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'color': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeColorTextNode),
    'fill': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
    'outline': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeBooleanTextNode"]),
});
/**
 * @param {Node} node Node.
 * @param {Style} style Style.
 * @param {Array<*>} objectStack Object stack.
 */
function writePolyStyle(node, style, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var fill = style.getFill();
    var stroke = style.getStroke();
    var properties = {
        'color': fill ? fill.getColor() : undefined,
        'fill': fill ? undefined : false,
        'outline': stroke ? undefined : false,
    };
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = POLY_STYLE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, POLY_STYLE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @param {Node} node Node to append a TextNode with the scale to.
 * @param {number|undefined} scale Scale.
 */
function writeScaleTextNode(node, scale) {
    // the Math is to remove any excess decimals created by float arithmetic
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_23__["writeDecimalTextNode"])(node, Math.round(scale * 1e6) / 1e6);
}
/**
 * @const
 * @type {Object<string, Array<string>>}
 */
// @ts-ignore
var STYLE_SEQUENCE = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, [
    'IconStyle',
    'LabelStyle',
    'LineStyle',
    'PolyStyle',
]);
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
// @ts-ignore
var STYLE_SERIALIZERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeStructureNS"])(NAMESPACE_URIS, {
    'IconStyle': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeIconStyle),
    'LabelStyle': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeLabelStyle),
    'LineStyle': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writeLineStyle),
    'PolyStyle': Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeChildAppender"])(writePolyStyle),
});
/**
 * @param {Node} node Node.
 * @param {Object<string, Array<Style>>} styles Styles.
 * @param {Array<*>} objectStack Object stack.
 */
function writeStyle(node, styles, objectStack) {
    var /** @type {import("../xml.js").NodeStackItem} */ context = { node: node };
    var properties = {};
    if (styles.pointStyles.length) {
        var textStyle = styles.pointStyles[0].getText();
        if (textStyle) {
            properties['LabelStyle'] = textStyle;
        }
        var imageStyle = styles.pointStyles[0].getImage();
        if (imageStyle &&
            typeof ( /** @type {?} */(imageStyle).getSrc) === 'function') {
            properties['IconStyle'] = imageStyle;
        }
    }
    if (styles.lineStyles.length) {
        var strokeStyle = styles.lineStyles[0].getStroke();
        if (strokeStyle) {
            properties['LineStyle'] = strokeStyle;
        }
    }
    if (styles.polyStyles.length) {
        var strokeStyle = styles.polyStyles[0].getStroke();
        if (strokeStyle && !properties['LineStyle']) {
            properties['LineStyle'] = strokeStyle;
        }
        properties['PolyStyle'] = styles.polyStyles[0];
    }
    var parentNode = objectStack[objectStack.length - 1].node;
    var orderedKeys = STYLE_SEQUENCE[parentNode.namespaceURI];
    var values = Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["makeSequence"])(properties, orderedKeys);
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_18__["pushSerializeAndPop"])(context, STYLE_SERIALIZERS, _xml_js__WEBPACK_IMPORTED_MODULE_18__["OBJECT_PROPERTY_NODE_FACTORY"], values, objectStack, orderedKeys);
}
/**
 * @param {Element} node Node to append a TextNode with the Vec2 to.
 * @param {Vec2} vec2 Vec2.
 */
function writeVec2(node, vec2) {
    node.setAttribute('x', String(vec2.x));
    node.setAttribute('y', String(vec2.y));
    node.setAttribute('xunits', vec2.xunits);
    node.setAttribute('yunits', vec2.yunits);
}
/* harmony default export */ __webpack_exports__["default"] = (KML);
//# sourceMappingURL=KML.js.map

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(202);
/* harmony import */ var _FormatType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(113);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(103);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(208);
/* harmony import */ var pbf__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(224);
/* harmony import */ var pbf__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(pbf__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(184);
/* harmony import */ var _proj_Projection_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8);
/* harmony import */ var _render_Feature_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(226);
/* harmony import */ var _proj_Units_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(19);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(7);
/* harmony import */ var _geom_flat_orient_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(194);
/**
 * @module ol/format/MVT
 */
//FIXME Implement projection handling
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

















/**
 * @typedef {Object} Options
 * @property {import("../Feature.js").FeatureClass} [featureClass] Class for features returned by
 * {@link module:ol/format/MVT~MVT#readFeatures}. Set to {@link module:ol/Feature~Feature} to get full editing and geometry
 * support at the cost of decreased rendering performance. The default is
 * {@link module:ol/render/Feature~RenderFeature}, which is optimized for rendering and hit detection.
 * @property {string} [geometryName='geometry'] Geometry name to use when creating features.
 * @property {string} [layerName='layer'] Name of the feature attribute that holds the layer name.
 * @property {Array<string>} [layers] Layers to read features from. If not provided, features will be read from all
 * @property {string} [idProperty] Optional property that will be assigned as the feature id and removed from the properties.
 * layers.
 */
/**
 * @classdesc
 * Feature format for reading data in the Mapbox MVT format.
 *
 * @param {Options} [opt_options] Options.
 * @api
 */
var MVT = /** @class */ (function (_super) {
    __extends(MVT, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function MVT(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {Projection}
         */
        _this.dataProjection = new _proj_Projection_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
            code: '',
            units: _proj_Units_js__WEBPACK_IMPORTED_MODULE_13__["default"].TILE_PIXELS,
        });
        /**
         * @private
         * @type {import("../Feature.js").FeatureClass}
         */
        _this.featureClass_ = options.featureClass
            ? options.featureClass
            : _render_Feature_js__WEBPACK_IMPORTED_MODULE_12__["default"];
        /**
         * @private
         * @type {string|undefined}
         */
        _this.geometryName_ = options.geometryName;
        /**
         * @private
         * @type {string}
         */
        _this.layerName_ = options.layerName ? options.layerName : 'layer';
        /**
         * @private
         * @type {Array<string>}
         */
        _this.layers_ = options.layers ? options.layers : null;
        /**
         * @private
         * @type {string}
         */
        _this.idProperty_ = options.idProperty;
        return _this;
    }
    /**
     * Read the raw geometry from the pbf offset stored in a raw feature's geometry
     * property.
     * @param {PBF} pbf PBF.
     * @param {Object} feature Raw feature.
     * @param {Array<number>} flatCoordinates Array to store flat coordinates in.
     * @param {Array<number>} ends Array to store ends in.
     * @private
     */
    MVT.prototype.readRawGeometry_ = function (pbf, feature, flatCoordinates, ends) {
        pbf.pos = feature.geometry;
        var end = pbf.readVarint() + pbf.pos;
        var cmd = 1;
        var length = 0;
        var x = 0;
        var y = 0;
        var coordsLen = 0;
        var currentEnd = 0;
        while (pbf.pos < end) {
            if (!length) {
                var cmdLen = pbf.readVarint();
                cmd = cmdLen & 0x7;
                length = cmdLen >> 3;
            }
            length--;
            if (cmd === 1 || cmd === 2) {
                x += pbf.readSVarint();
                y += pbf.readSVarint();
                if (cmd === 1) {
                    // moveTo
                    if (coordsLen > currentEnd) {
                        ends.push(coordsLen);
                        currentEnd = coordsLen;
                    }
                }
                flatCoordinates.push(x, y);
                coordsLen += 2;
            }
            else if (cmd === 7) {
                if (coordsLen > currentEnd) {
                    // close polygon
                    flatCoordinates.push(flatCoordinates[currentEnd], flatCoordinates[currentEnd + 1]);
                    coordsLen += 2;
                }
            }
            else {
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_14__["assert"])(false, 59); // Invalid command found in the PBF
            }
        }
        if (coordsLen > currentEnd) {
            ends.push(coordsLen);
            currentEnd = coordsLen;
        }
    };
    /**
     * @private
     * @param {PBF} pbf PBF
     * @param {Object} rawFeature Raw Mapbox feature.
     * @param {import("./Feature.js").ReadOptions} options Read options.
     * @return {import("../Feature.js").FeatureLike} Feature.
     */
    MVT.prototype.createFeature_ = function (pbf, rawFeature, options) {
        var type = rawFeature.type;
        if (type === 0) {
            return null;
        }
        var feature;
        var values = rawFeature.properties;
        var id;
        if (!this.idProperty_) {
            id = rawFeature.id;
        }
        else {
            id = values[this.idProperty_];
            delete values[this.idProperty_];
        }
        values[this.layerName_] = rawFeature.layer.name;
        var flatCoordinates = [];
        var ends = [];
        this.readRawGeometry_(pbf, rawFeature, flatCoordinates, ends);
        var geometryType = getGeometryType(type, ends.length);
        if (this.featureClass_ === _render_Feature_js__WEBPACK_IMPORTED_MODULE_12__["default"]) {
            feature = new this.featureClass_(geometryType, flatCoordinates, ends, values, id);
            feature.transform(options.dataProjection);
        }
        else {
            var geom = void 0;
            if (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POLYGON) {
                var endss = [];
                var offset = 0;
                var prevEndIndex = 0;
                for (var i = 0, ii = ends.length; i < ii; ++i) {
                    var end = ends[i];
                    // classifies an array of rings into polygons with outer rings and holes
                    if (!Object(_geom_flat_orient_js__WEBPACK_IMPORTED_MODULE_16__["linearRingIsClockwise"])(flatCoordinates, offset, end, 2)) {
                        endss.push(ends.slice(prevEndIndex, i + 1));
                    }
                    else {
                        if (endss.length === 0) {
                            continue;
                        }
                        endss[endss.length - 1].push(ends[prevEndIndex]);
                    }
                    prevEndIndex = i + 1;
                    offset = end;
                }
                if (endss.length > 1) {
                    geom = new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY, endss);
                }
                else {
                    geom = new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_10__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY, ends);
                }
            }
            else {
                geom =
                    geometryType === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POINT
                        ? new _geom_Point_js__WEBPACK_IMPORTED_MODULE_9__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY)
                        : geometryType === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].LINE_STRING
                            ? new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY)
                            : geometryType === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POLYGON
                                ? new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_10__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY, ends)
                                : geometryType === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].MULTI_POINT
                                    ? new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY)
                                    : geometryType === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].MULTI_LINE_STRING
                                        ? new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY, ends)
                                        : null;
            }
            var ctor = /** @type {typeof import("../Feature.js").default} */ (this.featureClass_);
            feature = new ctor();
            if (this.geometryName_) {
                feature.setGeometryName(this.geometryName_);
            }
            var geometry = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_0__["transformGeometryWithOptions"])(geom, false, options);
            feature.setGeometry(geometry);
            feature.setId(id);
            feature.setProperties(values, true);
        }
        return feature;
    };
    /**
     * @return {import("./FormatType.js").default} Format.
     */
    MVT.prototype.getType = function () {
        return _FormatType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ARRAY_BUFFER;
    };
    /**
     * Read all features.
     *
     * @param {ArrayBuffer} source Source.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {Array<import("../Feature.js").FeatureLike>} Features.
     * @api
     */
    MVT.prototype.readFeatures = function (source, opt_options) {
        var layers = this.layers_;
        var options = /** @type {import("./Feature.js").ReadOptions} */ (this.adaptOptions(opt_options));
        var dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_15__["get"])(options.dataProjection);
        dataProjection.setWorldExtent(options.extent);
        options.dataProjection = dataProjection;
        var pbf = new pbf__WEBPACK_IMPORTED_MODULE_8___default.a(/** @type {ArrayBuffer} */ (source));
        var pbfLayers = pbf.readFields(layersPBFReader, {});
        var features = [];
        for (var name_1 in pbfLayers) {
            if (layers && layers.indexOf(name_1) == -1) {
                continue;
            }
            var pbfLayer = pbfLayers[name_1];
            var extent = pbfLayer ? [0, 0, pbfLayer.extent, pbfLayer.extent] : null;
            dataProjection.setExtent(extent);
            for (var i = 0, ii = pbfLayer.length; i < ii; ++i) {
                var rawFeature = readRawFeature(pbf, pbfLayer, i);
                features.push(this.createFeature_(pbf, rawFeature, options));
            }
        }
        return features;
    };
    /**
     * Read the projection from the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {import("../proj/Projection.js").default} Projection.
     * @api
     */
    MVT.prototype.readProjection = function (source) {
        return this.dataProjection;
    };
    /**
     * Sets the layers that features will be read from.
     * @param {Array<string>} layers Layers.
     * @api
     */
    MVT.prototype.setLayers = function (layers) {
        this.layers_ = layers;
    };
    return MVT;
}(_Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * Reader callback for parsing layers.
 * @param {number} tag The tag.
 * @param {Object} layers The layers object.
 * @param {PBF} pbf The PBF.
 */
function layersPBFReader(tag, layers, pbf) {
    if (tag === 3) {
        var layer = {
            keys: [],
            values: [],
            features: [],
        };
        var end = pbf.readVarint() + pbf.pos;
        pbf.readFields(layerPBFReader, layer, end);
        layer.length = layer.features.length;
        if (layer.length) {
            layers[layer.name] = layer;
        }
    }
}
/**
 * Reader callback for parsing layer.
 * @param {number} tag The tag.
 * @param {Object} layer The layer object.
 * @param {PBF} pbf The PBF.
 */
function layerPBFReader(tag, layer, pbf) {
    if (tag === 15) {
        layer.version = pbf.readVarint();
    }
    else if (tag === 1) {
        layer.name = pbf.readString();
    }
    else if (tag === 5) {
        layer.extent = pbf.readVarint();
    }
    else if (tag === 2) {
        layer.features.push(pbf.pos);
    }
    else if (tag === 3) {
        layer.keys.push(pbf.readString());
    }
    else if (tag === 4) {
        var value = null;
        var end = pbf.readVarint() + pbf.pos;
        while (pbf.pos < end) {
            tag = pbf.readVarint() >> 3;
            value =
                tag === 1
                    ? pbf.readString()
                    : tag === 2
                        ? pbf.readFloat()
                        : tag === 3
                            ? pbf.readDouble()
                            : tag === 4
                                ? pbf.readVarint64()
                                : tag === 5
                                    ? pbf.readVarint()
                                    : tag === 6
                                        ? pbf.readSVarint()
                                        : tag === 7
                                            ? pbf.readBoolean()
                                            : null;
        }
        layer.values.push(value);
    }
}
/**
 * Reader callback for parsing feature.
 * @param {number} tag The tag.
 * @param {Object} feature The feature object.
 * @param {PBF} pbf The PBF.
 */
function featurePBFReader(tag, feature, pbf) {
    if (tag == 1) {
        feature.id = pbf.readVarint();
    }
    else if (tag == 2) {
        var end = pbf.readVarint() + pbf.pos;
        while (pbf.pos < end) {
            var key = feature.layer.keys[pbf.readVarint()];
            var value = feature.layer.values[pbf.readVarint()];
            feature.properties[key] = value;
        }
    }
    else if (tag == 3) {
        feature.type = pbf.readVarint();
    }
    else if (tag == 4) {
        feature.geometry = pbf.pos;
    }
}
/**
 * Read a raw feature from the pbf offset stored at index `i` in the raw layer.
 * @param {PBF} pbf PBF.
 * @param {Object} layer Raw layer.
 * @param {number} i Index of the feature in the raw layer's `features` array.
 * @return {Object} Raw feature.
 */
function readRawFeature(pbf, layer, i) {
    pbf.pos = layer.features[i];
    var end = pbf.readVarint() + pbf.pos;
    var feature = {
        layer: layer,
        type: 0,
        properties: {},
    };
    pbf.readFields(featurePBFReader, feature, end);
    return feature;
}
/**
 * @param {number} type The raw feature's geometry type
 * @param {number} numEnds Number of ends of the flat coordinates of the
 * geometry.
 * @return {import("../geom/GeometryType.js").default} The geometry type.
 */
function getGeometryType(type, numEnds) {
    /** @type {import("../geom/GeometryType.js").default} */
    var geometryType;
    if (type === 1) {
        geometryType =
            numEnds === 1 ? _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POINT : _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].MULTI_POINT;
    }
    else if (type === 2) {
        geometryType =
            numEnds === 1 ? _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].LINE_STRING : _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].MULTI_LINE_STRING;
    }
    else if (type === 3) {
        geometryType = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POLYGON;
        // MultiPolygon not relevant for rendering - winding order determines
        // outer rings of polygons.
    }
    return geometryType;
}
/* harmony default export */ __webpack_exports__["default"] = (MVT);
//# sourceMappingURL=MVT.js.map

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = Pbf;

var ieee754 = __webpack_require__(225);

function Pbf(buf) {
    this.buf = ArrayBuffer.isView && ArrayBuffer.isView(buf) ? buf : new Uint8Array(buf || 0);
    this.pos = 0;
    this.type = 0;
    this.length = this.buf.length;
}

Pbf.Varint  = 0; // varint: int32, int64, uint32, uint64, sint32, sint64, bool, enum
Pbf.Fixed64 = 1; // 64-bit: double, fixed64, sfixed64
Pbf.Bytes   = 2; // length-delimited: string, bytes, embedded messages, packed repeated fields
Pbf.Fixed32 = 5; // 32-bit: float, fixed32, sfixed32

var SHIFT_LEFT_32 = (1 << 16) * (1 << 16),
    SHIFT_RIGHT_32 = 1 / SHIFT_LEFT_32;

// Threshold chosen based on both benchmarking and knowledge about browser string
// data structures (which currently switch structure types at 12 bytes or more)
var TEXT_DECODER_MIN_LENGTH = 12;
var utf8TextDecoder = typeof TextDecoder === 'undefined' ? null : new TextDecoder('utf8');

Pbf.prototype = {

    destroy: function() {
        this.buf = null;
    },

    // === READING =================================================================

    readFields: function(readField, result, end) {
        end = end || this.length;

        while (this.pos < end) {
            var val = this.readVarint(),
                tag = val >> 3,
                startPos = this.pos;

            this.type = val & 0x7;
            readField(tag, result, this);

            if (this.pos === startPos) this.skip(val);
        }
        return result;
    },

    readMessage: function(readField, result) {
        return this.readFields(readField, result, this.readVarint() + this.pos);
    },

    readFixed32: function() {
        var val = readUInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },

    readSFixed32: function() {
        var val = readInt32(this.buf, this.pos);
        this.pos += 4;
        return val;
    },

    // 64-bit int handling is based on github.com/dpw/node-buffer-more-ints (MIT-licensed)

    readFixed64: function() {
        var val = readUInt32(this.buf, this.pos) + readUInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },

    readSFixed64: function() {
        var val = readUInt32(this.buf, this.pos) + readInt32(this.buf, this.pos + 4) * SHIFT_LEFT_32;
        this.pos += 8;
        return val;
    },

    readFloat: function() {
        var val = ieee754.read(this.buf, this.pos, true, 23, 4);
        this.pos += 4;
        return val;
    },

    readDouble: function() {
        var val = ieee754.read(this.buf, this.pos, true, 52, 8);
        this.pos += 8;
        return val;
    },

    readVarint: function(isSigned) {
        var buf = this.buf,
            val, b;

        b = buf[this.pos++]; val  =  b & 0x7f;        if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 7;  if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 14; if (b < 0x80) return val;
        b = buf[this.pos++]; val |= (b & 0x7f) << 21; if (b < 0x80) return val;
        b = buf[this.pos];   val |= (b & 0x0f) << 28;

        return readVarintRemainder(val, isSigned, this);
    },

    readVarint64: function() { // for compatibility with v2.0.1
        return this.readVarint(true);
    },

    readSVarint: function() {
        var num = this.readVarint();
        return num % 2 === 1 ? (num + 1) / -2 : num / 2; // zigzag encoding
    },

    readBoolean: function() {
        return Boolean(this.readVarint());
    },

    readString: function() {
        var end = this.readVarint() + this.pos;
        var pos = this.pos;
        this.pos = end;

        if (end - pos >= TEXT_DECODER_MIN_LENGTH && utf8TextDecoder) {
            // longer strings are fast with the built-in browser TextDecoder API
            return readUtf8TextDecoder(this.buf, pos, end);
        }
        // short strings are fast with our custom implementation
        return readUtf8(this.buf, pos, end);
    },

    readBytes: function() {
        var end = this.readVarint() + this.pos,
            buffer = this.buf.subarray(this.pos, end);
        this.pos = end;
        return buffer;
    },

    // verbose for performance reasons; doesn't affect gzipped size

    readPackedVarint: function(arr, isSigned) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readVarint(isSigned));
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readVarint(isSigned));
        return arr;
    },
    readPackedSVarint: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSVarint());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSVarint());
        return arr;
    },
    readPackedBoolean: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readBoolean());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readBoolean());
        return arr;
    },
    readPackedFloat: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFloat());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFloat());
        return arr;
    },
    readPackedDouble: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readDouble());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readDouble());
        return arr;
    },
    readPackedFixed32: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFixed32());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFixed32());
        return arr;
    },
    readPackedSFixed32: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSFixed32());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSFixed32());
        return arr;
    },
    readPackedFixed64: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readFixed64());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readFixed64());
        return arr;
    },
    readPackedSFixed64: function(arr) {
        if (this.type !== Pbf.Bytes) return arr.push(this.readSFixed64());
        var end = readPackedEnd(this);
        arr = arr || [];
        while (this.pos < end) arr.push(this.readSFixed64());
        return arr;
    },

    skip: function(val) {
        var type = val & 0x7;
        if (type === Pbf.Varint) while (this.buf[this.pos++] > 0x7f) {}
        else if (type === Pbf.Bytes) this.pos = this.readVarint() + this.pos;
        else if (type === Pbf.Fixed32) this.pos += 4;
        else if (type === Pbf.Fixed64) this.pos += 8;
        else throw new Error('Unimplemented type: ' + type);
    },

    // === WRITING =================================================================

    writeTag: function(tag, type) {
        this.writeVarint((tag << 3) | type);
    },

    realloc: function(min) {
        var length = this.length || 16;

        while (length < this.pos + min) length *= 2;

        if (length !== this.length) {
            var buf = new Uint8Array(length);
            buf.set(this.buf);
            this.buf = buf;
            this.length = length;
        }
    },

    finish: function() {
        this.length = this.pos;
        this.pos = 0;
        return this.buf.subarray(0, this.length);
    },

    writeFixed32: function(val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },

    writeSFixed32: function(val) {
        this.realloc(4);
        writeInt32(this.buf, val, this.pos);
        this.pos += 4;
    },

    writeFixed64: function(val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },

    writeSFixed64: function(val) {
        this.realloc(8);
        writeInt32(this.buf, val & -1, this.pos);
        writeInt32(this.buf, Math.floor(val * SHIFT_RIGHT_32), this.pos + 4);
        this.pos += 8;
    },

    writeVarint: function(val) {
        val = +val || 0;

        if (val > 0xfffffff || val < 0) {
            writeBigVarint(val, this);
            return;
        }

        this.realloc(4);

        this.buf[this.pos++] =           val & 0x7f  | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] = ((val >>>= 7) & 0x7f) | (val > 0x7f ? 0x80 : 0); if (val <= 0x7f) return;
        this.buf[this.pos++] =   (val >>> 7) & 0x7f;
    },

    writeSVarint: function(val) {
        this.writeVarint(val < 0 ? -val * 2 - 1 : val * 2);
    },

    writeBoolean: function(val) {
        this.writeVarint(Boolean(val));
    },

    writeString: function(str) {
        str = String(str);
        this.realloc(str.length * 4);

        this.pos++; // reserve 1 byte for short string length

        var startPos = this.pos;
        // write the string directly to the buffer and see how much was written
        this.pos = writeUtf8(this.buf, str, this.pos);
        var len = this.pos - startPos;

        if (len >= 0x80) makeRoomForExtraLength(startPos, len, this);

        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },

    writeFloat: function(val) {
        this.realloc(4);
        ieee754.write(this.buf, val, this.pos, true, 23, 4);
        this.pos += 4;
    },

    writeDouble: function(val) {
        this.realloc(8);
        ieee754.write(this.buf, val, this.pos, true, 52, 8);
        this.pos += 8;
    },

    writeBytes: function(buffer) {
        var len = buffer.length;
        this.writeVarint(len);
        this.realloc(len);
        for (var i = 0; i < len; i++) this.buf[this.pos++] = buffer[i];
    },

    writeRawMessage: function(fn, obj) {
        this.pos++; // reserve 1 byte for short message length

        // write the message directly to the buffer and see how much was written
        var startPos = this.pos;
        fn(obj, this);
        var len = this.pos - startPos;

        if (len >= 0x80) makeRoomForExtraLength(startPos, len, this);

        // finally, write the message length in the reserved place and restore the position
        this.pos = startPos - 1;
        this.writeVarint(len);
        this.pos += len;
    },

    writeMessage: function(tag, fn, obj) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeRawMessage(fn, obj);
    },

    writePackedVarint:   function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedVarint, arr);   },
    writePackedSVarint:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSVarint, arr);  },
    writePackedBoolean:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedBoolean, arr);  },
    writePackedFloat:    function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFloat, arr);    },
    writePackedDouble:   function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedDouble, arr);   },
    writePackedFixed32:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFixed32, arr);  },
    writePackedSFixed32: function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSFixed32, arr); },
    writePackedFixed64:  function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedFixed64, arr);  },
    writePackedSFixed64: function(tag, arr) { if (arr.length) this.writeMessage(tag, writePackedSFixed64, arr); },

    writeBytesField: function(tag, buffer) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeBytes(buffer);
    },
    writeFixed32Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFixed32(val);
    },
    writeSFixed32Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeSFixed32(val);
    },
    writeFixed64Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeFixed64(val);
    },
    writeSFixed64Field: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeSFixed64(val);
    },
    writeVarintField: function(tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeVarint(val);
    },
    writeSVarintField: function(tag, val) {
        this.writeTag(tag, Pbf.Varint);
        this.writeSVarint(val);
    },
    writeStringField: function(tag, str) {
        this.writeTag(tag, Pbf.Bytes);
        this.writeString(str);
    },
    writeFloatField: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed32);
        this.writeFloat(val);
    },
    writeDoubleField: function(tag, val) {
        this.writeTag(tag, Pbf.Fixed64);
        this.writeDouble(val);
    },
    writeBooleanField: function(tag, val) {
        this.writeVarintField(tag, Boolean(val));
    }
};

function readVarintRemainder(l, s, p) {
    var buf = p.buf,
        h, b;

    b = buf[p.pos++]; h  = (b & 0x70) >> 4;  if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 3;  if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 10; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 17; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x7f) << 24; if (b < 0x80) return toNum(l, h, s);
    b = buf[p.pos++]; h |= (b & 0x01) << 31; if (b < 0x80) return toNum(l, h, s);

    throw new Error('Expected varint not more than 10 bytes');
}

function readPackedEnd(pbf) {
    return pbf.type === Pbf.Bytes ?
        pbf.readVarint() + pbf.pos : pbf.pos + 1;
}

function toNum(low, high, isSigned) {
    if (isSigned) {
        return high * 0x100000000 + (low >>> 0);
    }

    return ((high >>> 0) * 0x100000000) + (low >>> 0);
}

function writeBigVarint(val, pbf) {
    var low, high;

    if (val >= 0) {
        low  = (val % 0x100000000) | 0;
        high = (val / 0x100000000) | 0;
    } else {
        low  = ~(-val % 0x100000000);
        high = ~(-val / 0x100000000);

        if (low ^ 0xffffffff) {
            low = (low + 1) | 0;
        } else {
            low = 0;
            high = (high + 1) | 0;
        }
    }

    if (val >= 0x10000000000000000 || val < -0x10000000000000000) {
        throw new Error('Given varint doesn\'t fit into 10 bytes');
    }

    pbf.realloc(10);

    writeBigVarintLow(low, high, pbf);
    writeBigVarintHigh(high, pbf);
}

function writeBigVarintLow(low, high, pbf) {
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos++] = low & 0x7f | 0x80; low >>>= 7;
    pbf.buf[pbf.pos]   = low & 0x7f;
}

function writeBigVarintHigh(high, pbf) {
    var lsb = (high & 0x07) << 4;

    pbf.buf[pbf.pos++] |= lsb         | ((high >>>= 3) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f | ((high >>>= 7) ? 0x80 : 0); if (!high) return;
    pbf.buf[pbf.pos++]  = high & 0x7f;
}

function makeRoomForExtraLength(startPos, len, pbf) {
    var extraLen =
        len <= 0x3fff ? 1 :
        len <= 0x1fffff ? 2 :
        len <= 0xfffffff ? 3 : Math.floor(Math.log(len) / (Math.LN2 * 7));

    // if 1 byte isn't enough for encoding message length, shift the data to the right
    pbf.realloc(extraLen);
    for (var i = pbf.pos - 1; i >= startPos; i--) pbf.buf[i + extraLen] = pbf.buf[i];
}

function writePackedVarint(arr, pbf)   { for (var i = 0; i < arr.length; i++) pbf.writeVarint(arr[i]);   }
function writePackedSVarint(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeSVarint(arr[i]);  }
function writePackedFloat(arr, pbf)    { for (var i = 0; i < arr.length; i++) pbf.writeFloat(arr[i]);    }
function writePackedDouble(arr, pbf)   { for (var i = 0; i < arr.length; i++) pbf.writeDouble(arr[i]);   }
function writePackedBoolean(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeBoolean(arr[i]);  }
function writePackedFixed32(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeFixed32(arr[i]);  }
function writePackedSFixed32(arr, pbf) { for (var i = 0; i < arr.length; i++) pbf.writeSFixed32(arr[i]); }
function writePackedFixed64(arr, pbf)  { for (var i = 0; i < arr.length; i++) pbf.writeFixed64(arr[i]);  }
function writePackedSFixed64(arr, pbf) { for (var i = 0; i < arr.length; i++) pbf.writeSFixed64(arr[i]); }

// Buffer code below from https://github.com/feross/buffer, MIT-licensed

function readUInt32(buf, pos) {
    return ((buf[pos]) |
        (buf[pos + 1] << 8) |
        (buf[pos + 2] << 16)) +
        (buf[pos + 3] * 0x1000000);
}

function writeInt32(buf, val, pos) {
    buf[pos] = val;
    buf[pos + 1] = (val >>> 8);
    buf[pos + 2] = (val >>> 16);
    buf[pos + 3] = (val >>> 24);
}

function readInt32(buf, pos) {
    return ((buf[pos]) |
        (buf[pos + 1] << 8) |
        (buf[pos + 2] << 16)) +
        (buf[pos + 3] << 24);
}

function readUtf8(buf, pos, end) {
    var str = '';
    var i = pos;

    while (i < end) {
        var b0 = buf[i];
        var c = null; // codepoint
        var bytesPerSequence =
            b0 > 0xEF ? 4 :
            b0 > 0xDF ? 3 :
            b0 > 0xBF ? 2 : 1;

        if (i + bytesPerSequence > end) break;

        var b1, b2, b3;

        if (bytesPerSequence === 1) {
            if (b0 < 0x80) {
                c = b0;
            }
        } else if (bytesPerSequence === 2) {
            b1 = buf[i + 1];
            if ((b1 & 0xC0) === 0x80) {
                c = (b0 & 0x1F) << 0x6 | (b1 & 0x3F);
                if (c <= 0x7F) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 3) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0xC | (b1 & 0x3F) << 0x6 | (b2 & 0x3F);
                if (c <= 0x7FF || (c >= 0xD800 && c <= 0xDFFF)) {
                    c = null;
                }
            }
        } else if (bytesPerSequence === 4) {
            b1 = buf[i + 1];
            b2 = buf[i + 2];
            b3 = buf[i + 3];
            if ((b1 & 0xC0) === 0x80 && (b2 & 0xC0) === 0x80 && (b3 & 0xC0) === 0x80) {
                c = (b0 & 0xF) << 0x12 | (b1 & 0x3F) << 0xC | (b2 & 0x3F) << 0x6 | (b3 & 0x3F);
                if (c <= 0xFFFF || c >= 0x110000) {
                    c = null;
                }
            }
        }

        if (c === null) {
            c = 0xFFFD;
            bytesPerSequence = 1;

        } else if (c > 0xFFFF) {
            c -= 0x10000;
            str += String.fromCharCode(c >>> 10 & 0x3FF | 0xD800);
            c = 0xDC00 | c & 0x3FF;
        }

        str += String.fromCharCode(c);
        i += bytesPerSequence;
    }

    return str;
}

function readUtf8TextDecoder(buf, pos, end) {
    return utf8TextDecoder.decode(buf.subarray(pos, end));
}

function writeUtf8(buf, str, pos) {
    for (var i = 0, c, lead; i < str.length; i++) {
        c = str.charCodeAt(i); // code point

        if (c > 0xD7FF && c < 0xE000) {
            if (lead) {
                if (c < 0xDC00) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                    lead = c;
                    continue;
                } else {
                    c = lead - 0xD800 << 10 | c - 0xDC00 | 0x10000;
                    lead = null;
                }
            } else {
                if (c > 0xDBFF || (i + 1 === str.length)) {
                    buf[pos++] = 0xEF;
                    buf[pos++] = 0xBF;
                    buf[pos++] = 0xBD;
                } else {
                    lead = c;
                }
                continue;
            }
        } else if (lead) {
            buf[pos++] = 0xEF;
            buf[pos++] = 0xBF;
            buf[pos++] = 0xBD;
            lead = null;
        }

        if (c < 0x80) {
            buf[pos++] = c;
        } else {
            if (c < 0x800) {
                buf[pos++] = c >> 0x6 | 0xC0;
            } else {
                if (c < 0x10000) {
                    buf[pos++] = c >> 0xC | 0xE0;
                } else {
                    buf[pos++] = c >> 0x12 | 0xF0;
                    buf[pos++] = c >> 0xC & 0x3F | 0x80;
                }
                buf[pos++] = c >> 0x6 & 0x3F | 0x80;
            }
            buf[pos++] = c & 0x3F | 0x80;
        }
    }
    return pos;
}


/***/ }),
/* 225 */
/***/ (function(module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52);
/* harmony import */ var _geom_flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(190);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var _geom_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(204);
/* harmony import */ var _geom_flat_center_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(209);
/* harmony import */ var _geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(102);
/**
 * @module ol/render/Feature
 */









/**
 * @type {import("../transform.js").Transform}
 */
var tmpTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_1__["create"])();
/**
 * Lightweight, read-only, {@link module:ol/Feature~Feature} and {@link module:ol/geom/Geometry~Geometry} like
 * structure, optimized for vector tile rendering and styling. Geometry access
 * through the API is limited to getting the type and extent of the geometry.
 */
var RenderFeature = /** @class */ (function () {
    /**
     * @param {import("../geom/GeometryType.js").default} type Geometry type.
     * @param {Array<number>} flatCoordinates Flat coordinates. These always need
     *     to be right-handed for polygons.
     * @param {Array<number>|Array<Array<number>>} ends Ends or Endss.
     * @param {Object<string, *>} properties Properties.
     * @param {number|string|undefined} id Feature id.
     */
    function RenderFeature(type, flatCoordinates, ends, properties, id) {
        /**
         * @private
         * @type {import("../extent.js").Extent|undefined}
         */
        this.extent_;
        /**
         * @private
         * @type {number|string|undefined}
         */
        this.id_ = id;
        /**
         * @private
         * @type {import("../geom/GeometryType.js").default}
         */
        this.type_ = type;
        /**
         * @private
         * @type {Array<number>}
         */
        this.flatCoordinates_ = flatCoordinates;
        /**
         * @private
         * @type {Array<number>}
         */
        this.flatInteriorPoints_ = null;
        /**
         * @private
         * @type {Array<number>}
         */
        this.flatMidpoints_ = null;
        /**
         * @private
         * @type {Array<number>|Array<Array<number>>}
         */
        this.ends_ = ends;
        /**
         * @private
         * @type {Object<string, *>}
         */
        this.properties_ = properties;
    }
    /**
     * Get a feature property by its key.
     * @param {string} key Key
     * @return {*} Value for the requested key.
     * @api
     */
    RenderFeature.prototype.get = function (key) {
        return this.properties_[key];
    };
    /**
     * Get the extent of this feature's geometry.
     * @return {import("../extent.js").Extent} Extent.
     * @api
     */
    RenderFeature.prototype.getExtent = function () {
        if (!this.extent_) {
            this.extent_ =
                this.type_ === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POINT
                    ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createOrUpdateFromCoordinate"])(this.flatCoordinates_)
                    : Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createOrUpdateFromFlatCoordinates"])(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2);
        }
        return this.extent_;
    };
    /**
     * @return {Array<number>} Flat interior points.
     */
    RenderFeature.prototype.getFlatInteriorPoint = function () {
        if (!this.flatInteriorPoints_) {
            var flatCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getCenter"])(this.getExtent());
            this.flatInteriorPoints_ = Object(_geom_flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_4__["getInteriorPointOfArray"])(this.flatCoordinates_, 0, 
            /** @type {Array<number>} */ (this.ends_), 2, flatCenter, 0);
        }
        return this.flatInteriorPoints_;
    };
    /**
     * @return {Array<number>} Flat interior points.
     */
    RenderFeature.prototype.getFlatInteriorPoints = function () {
        if (!this.flatInteriorPoints_) {
            var flatCenters = Object(_geom_flat_center_js__WEBPACK_IMPORTED_MODULE_7__["linearRingss"])(this.flatCoordinates_, 0, 
            /** @type {Array<Array<number>>} */ (this.ends_), 2);
            this.flatInteriorPoints_ = Object(_geom_flat_interiorpoint_js__WEBPACK_IMPORTED_MODULE_4__["getInteriorPointsOfMultiArray"])(this.flatCoordinates_, 0, 
            /** @type {Array<Array<number>>} */ (this.ends_), 2, flatCenters);
        }
        return this.flatInteriorPoints_;
    };
    /**
     * @return {Array<number>} Flat midpoint.
     */
    RenderFeature.prototype.getFlatMidpoint = function () {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = Object(_geom_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_6__["interpolatePoint"])(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, 0.5);
        }
        return this.flatMidpoints_;
    };
    /**
     * @return {Array<number>} Flat midpoints.
     */
    RenderFeature.prototype.getFlatMidpoints = function () {
        if (!this.flatMidpoints_) {
            this.flatMidpoints_ = [];
            var flatCoordinates = this.flatCoordinates_;
            var offset = 0;
            var ends = /** @type {Array<number>} */ (this.ends_);
            for (var i = 0, ii = ends.length; i < ii; ++i) {
                var end = ends[i];
                var midpoint = Object(_geom_flat_interpolate_js__WEBPACK_IMPORTED_MODULE_6__["interpolatePoint"])(flatCoordinates, offset, end, 2, 0.5);
                Object(_array_js__WEBPACK_IMPORTED_MODULE_3__["extend"])(this.flatMidpoints_, midpoint);
                offset = end;
            }
        }
        return this.flatMidpoints_;
    };
    /**
     * Get the feature identifier.  This is a stable identifier for the feature and
     * is set when reading data from a remote source.
     * @return {number|string|undefined} Id.
     * @api
     */
    RenderFeature.prototype.getId = function () {
        return this.id_;
    };
    /**
     * @return {Array<number>} Flat coordinates.
     */
    RenderFeature.prototype.getOrientedFlatCoordinates = function () {
        return this.flatCoordinates_;
    };
    /**
     * For API compatibility with {@link module:ol/Feature~Feature}, this method is useful when
     * determining the geometry type in style function (see {@link #getType}).
     * @return {RenderFeature} Feature.
     * @api
     */
    RenderFeature.prototype.getGeometry = function () {
        return this;
    };
    /**
     * @param {number} squaredTolerance Squared tolerance.
     * @return {RenderFeature} Simplified geometry.
     */
    RenderFeature.prototype.getSimplifiedGeometry = function (squaredTolerance) {
        return this;
    };
    /**
     * Get a transformed and simplified version of the geometry.
     * @abstract
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
     * @return {RenderFeature} Simplified geometry.
     */
    RenderFeature.prototype.simplifyTransformed = function (squaredTolerance, opt_transform) {
        return this;
    };
    /**
     * Get the feature properties.
     * @return {Object<string, *>} Feature properties.
     * @api
     */
    RenderFeature.prototype.getProperties = function () {
        return this.properties_;
    };
    /**
     * @return {number} Stride.
     */
    RenderFeature.prototype.getStride = function () {
        return 2;
    };
    /**
     * @return {undefined}
     */
    RenderFeature.prototype.getStyleFunction = function () {
        return undefined;
    };
    /**
     * Get the type of this feature's geometry.
     * @return {import("../geom/GeometryType.js").default} Geometry type.
     * @api
     */
    RenderFeature.prototype.getType = function () {
        return this.type_;
    };
    /**
     * Transform geometry coordinates from tile pixel space to projected.
     *
     * @param {import("../proj.js").ProjectionLike} projection The data projection
     */
    RenderFeature.prototype.transform = function (projection) {
        projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_5__["get"])(projection);
        var pixelExtent = projection.getExtent();
        var projectedExtent = projection.getWorldExtent();
        if (pixelExtent && projectedExtent) {
            var scale = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getHeight"])(projectedExtent) / Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["getHeight"])(pixelExtent);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_1__["compose"])(tmpTransform, projectedExtent[0], projectedExtent[3], scale, -scale, 0, 0, 0);
            Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_8__["transform2D"])(this.flatCoordinates_, 0, this.flatCoordinates_.length, 2, tmpTransform, this.flatCoordinates_);
        }
    };
    /**
     * @return {Array<number>|Array<Array<number>>} Ends or endss.
     */
    RenderFeature.prototype.getEnds = function () {
        return this.ends_;
    };
    return RenderFeature;
}());
RenderFeature.prototype.getEndss = RenderFeature.prototype.getEnds;
/**
 * @return {Array<number>} Flat coordinates.
 */
RenderFeature.prototype.getFlatCoordinates =
    RenderFeature.prototype.getOrientedFlatCoordinates;
/* harmony default export */ __webpack_exports__["default"] = (RenderFeature);
//# sourceMappingURL=Feature.js.map

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _XML_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(228);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(217);
/* harmony import */ var _xlink_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(229);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(218);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/OWS
 */




/**
 * @const
 * @type {Array<null|string>}
 */
var NAMESPACE_URIS = [null, 'http://www.opengis.net/ows/1.1'];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'ServiceIdentification': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readServiceIdentification),
    'ServiceProvider': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readServiceProvider),
    'OperationsMetadata': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readOperationsMetadata),
});
var OWS = /** @class */ (function (_super) {
    __extends(OWS, _super);
    function OWS() {
        return _super.call(this) || this;
    }
    /**
     * @param {Element} node Node.
     * @return {Object} Object
     */
    OWS.prototype.readFromNode = function (node) {
        var owsObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, PARSERS, node, []);
        return owsObject ? owsObject : null;
    };
    return OWS;
}(_XML_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var ADDRESS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'DeliveryPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'City': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'AdministrativeArea': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'PostalCode': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'Country': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'ElectronicMailAddress': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var ALLOWED_VALUES_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Value': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readValue),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONSTRAINT_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'AllowedValues': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readAllowedValues),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONTACT_INFO_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Phone': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readPhone),
    'Address': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readAddress),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var DCP_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'HTTP': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readHttp),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var HTTP_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Get': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readGet),
    'Post': undefined, // TODO
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var OPERATION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'DCP': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readDcp),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var OPERATIONS_METADATA_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Operation': readOperation,
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PHONE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Voice': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'Facsimile': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var REQUEST_METHOD_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Constraint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readConstraint),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var SERVICE_CONTACT_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'IndividualName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'PositionName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'ContactInfo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readContactInfo),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var SERVICE_IDENTIFICATION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Abstract': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'AccessConstraints': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'Fees': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'ServiceTypeVersion': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'ServiceType': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var SERVICE_PROVIDER_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'ProviderName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"]),
    'ProviderSite': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xlink_js__WEBPACK_IMPORTED_MODULE_2__["readHref"]),
    'ServiceContact': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readServiceContact),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The address.
 */
function readAddress(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, ADDRESS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The values.
 */
function readAllowedValues(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, ALLOWED_VALUES_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The constraint.
 */
function readConstraint(node, objectStack) {
    var name = node.getAttribute('name');
    if (!name) {
        return undefined;
    }
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({ 'name': name }, CONSTRAINT_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The contact info.
 */
function readContactInfo(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, CONTACT_INFO_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The DCP.
 */
function readDcp(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, DCP_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The GET object.
 */
function readGet(node, objectStack) {
    var href = Object(_xlink_js__WEBPACK_IMPORTED_MODULE_2__["readHref"])(node);
    if (!href) {
        return undefined;
    }
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({ 'href': href }, REQUEST_METHOD_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The HTTP object.
 */
function readHttp(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, HTTP_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The operation.
 */
function readOperation(node, objectStack) {
    var name = node.getAttribute('name');
    var value = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, OPERATION_PARSERS, node, objectStack);
    if (!value) {
        return undefined;
    }
    var object = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    object[name] = value;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The operations metadata.
 */
function readOperationsMetadata(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, OPERATIONS_METADATA_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The phone.
 */
function readPhone(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, PHONE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The service identification.
 */
function readServiceIdentification(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, SERVICE_IDENTIFICATION_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The service contact.
 */
function readServiceContact(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, SERVICE_CONTACT_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} The service provider.
 */
function readServiceProvider(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, SERVICE_PROVIDER_PARSERS, node, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {string|undefined} The value.
 */
function readValue(node, objectStack) {
    return Object(_xsd_js__WEBPACK_IMPORTED_MODULE_3__["readString"])(node);
}
/* harmony default export */ __webpack_exports__["default"] = (OWS);
//# sourceMappingURL=OWS.js.map

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(217);
/**
 * @module ol/format/XML
 */

/**
 * @classdesc
 * Generic format for reading non-feature XML data
 *
 * @abstract
 */
var XML = /** @class */ (function () {
    function XML() {
    }
    /**
     * Read the source document.
     *
     * @param {Document|Element|string} source The XML source.
     * @return {Object} An object representing the source.
     * @api
     */
    XML.prototype.read = function (source) {
        if (!source) {
            return null;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["parse"])(source);
            return this.readFromDocument(doc);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_0__["isDocument"])(source)) {
            return this.readFromDocument(/** @type {Document} */ (source));
        }
        else {
            return this.readFromNode(/** @type {Element} */ (source));
        }
    };
    /**
     * @param {Document} doc Document.
     * @return {Object} Object
     */
    XML.prototype.readFromDocument = function (doc) {
        for (var n = doc.firstChild; n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                return this.readFromNode(/** @type {Element} */ (n));
            }
        }
        return null;
    };
    /**
     * @abstract
     * @param {Element} node Node.
     * @return {Object} Object
     */
    XML.prototype.readFromNode = function (node) { };
    return XML;
}());
/* harmony default export */ __webpack_exports__["default"] = (XML);
//# sourceMappingURL=XML.js.map

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "readHref", function() { return readHref; });
/**
 * @module ol/format/xlink
 */
/**
 * @const
 * @type {string}
 */
var NAMESPACE_URI = 'http://www.w3.org/1999/xlink';
/**
 * @param {Element} node Node.
 * @return {string|undefined} href.
 */
function readHref(node) {
    return node.getAttributeNS(NAMESPACE_URI, 'href');
}
//# sourceMappingURL=xlink.js.map

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeDeltas", function() { return encodeDeltas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeDeltas", function() { return decodeDeltas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeFloats", function() { return encodeFloats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeFloats", function() { return decodeFloats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeSignedIntegers", function() { return encodeSignedIntegers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeSignedIntegers", function() { return decodeSignedIntegers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeUnsignedIntegers", function() { return encodeUnsignedIntegers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "decodeUnsignedIntegers", function() { return decodeUnsignedIntegers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "encodeUnsignedInteger", function() { return encodeUnsignedInteger; });
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(103);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(203);
/* harmony import */ var _TextFeature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(221);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _geom_flat_flip_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(231);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7);
/* harmony import */ var _geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99);
/* harmony import */ var _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(188);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/Polyline
 */










/**
 * @typedef {Object} Options
 * @property {number} [factor=1e5] The factor by which the coordinates values will be scaled.
 * @property {GeometryLayout} [geometryLayout='XY'] Layout of the
 * feature geometries created by the format reader.
 */
/**
 * @classdesc
 * Feature format for reading and writing data in the Encoded
 * Polyline Algorithm Format.
 *
 * When reading features, the coordinates are assumed to be in two dimensions
 * and in [latitude, longitude] order.
 *
 * As Polyline sources contain a single feature,
 * {@link module:ol/format/Polyline~Polyline#readFeatures} will return the
 * feature in an array.
 *
 * @api
 */
var Polyline = /** @class */ (function (_super) {
    __extends(Polyline, _super);
    /**
     * @param {Options} [opt_options] Optional configuration object.
     */
    function Polyline(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_6__["get"])('EPSG:4326');
        /**
         * @private
         * @type {number}
         */
        _this.factor_ = options.factor ? options.factor : 1e5;
        /**
         * @private
         * @type {import("../geom/GeometryLayout").default}
         */
        _this.geometryLayout_ = options.geometryLayout
            ? options.geometryLayout
            : _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_1__["default"].XY;
        return _this;
    }
    /**
     * @protected
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     */
    Polyline.prototype.readFeatureFromText = function (text, opt_options) {
        var geometry = this.readGeometryFromText(text, opt_options);
        return new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"](geometry);
    };
    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    Polyline.prototype.readFeaturesFromText = function (text, opt_options) {
        var feature = this.readFeatureFromText(text, opt_options);
        return [feature];
    };
    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    Polyline.prototype.readGeometryFromText = function (text, opt_options) {
        var stride = Object(_geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_7__["getStrideForLayout"])(this.geometryLayout_);
        var flatCoordinates = decodeDeltas(text, stride, this.factor_);
        Object(_geom_flat_flip_js__WEBPACK_IMPORTED_MODULE_5__["flipXY"])(flatCoordinates, 0, flatCoordinates.length, stride, flatCoordinates);
        var coordinates = Object(_geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__["inflateCoordinates"])(flatCoordinates, 0, flatCoordinates.length, stride);
        var lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](coordinates, this.geometryLayout_);
        return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_9__["transformGeometryWithOptions"])(lineString, false, this.adaptOptions(opt_options));
    };
    /**
     * @param {import("../Feature.js").default} feature Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    Polyline.prototype.writeFeatureText = function (feature, opt_options) {
        var geometry = feature.getGeometry();
        if (geometry) {
            return this.writeGeometryText(geometry, opt_options);
        }
        else {
            Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(false, 40); // Expected `feature` to have a geometry
            return '';
        }
    };
    /**
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    Polyline.prototype.writeFeaturesText = function (features, opt_options) {
        return this.writeFeatureText(features[0], opt_options);
    };
    /**
     * @param {LineString} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    Polyline.prototype.writeGeometryText = function (geometry, opt_options) {
        geometry =
            /** @type {LineString} */
            (Object(_Feature_js__WEBPACK_IMPORTED_MODULE_9__["transformGeometryWithOptions"])(geometry, true, this.adaptOptions(opt_options)));
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        Object(_geom_flat_flip_js__WEBPACK_IMPORTED_MODULE_5__["flipXY"])(flatCoordinates, 0, flatCoordinates.length, stride, flatCoordinates);
        return encodeDeltas(flatCoordinates, stride, this.factor_);
    };
    return Polyline;
}(_TextFeature_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/**
 * Encode a list of n-dimensional points and return an encoded string
 *
 * Attention: This function will modify the passed array!
 *
 * @param {Array<number>} numbers A list of n-dimensional points.
 * @param {number} stride The number of dimension of the points in the list.
 * @param {number} [opt_factor] The factor by which the numbers will be
 *     multiplied. The remaining decimal places will get rounded away.
 *     Default is `1e5`.
 * @return {string} The encoded string.
 * @api
 */
function encodeDeltas(numbers, stride, opt_factor) {
    var factor = opt_factor ? opt_factor : 1e5;
    var d;
    var lastNumbers = new Array(stride);
    for (d = 0; d < stride; ++d) {
        lastNumbers[d] = 0;
    }
    for (var i = 0, ii = numbers.length; i < ii;) {
        for (d = 0; d < stride; ++d, ++i) {
            var num = numbers[i];
            var delta = num - lastNumbers[d];
            lastNumbers[d] = num;
            numbers[i] = delta;
        }
    }
    return encodeFloats(numbers, factor);
}
/**
 * Decode a list of n-dimensional points from an encoded string
 *
 * @param {string} encoded An encoded string.
 * @param {number} stride The number of dimension of the points in the
 *     encoded string.
 * @param {number} [opt_factor] The factor by which the resulting numbers will
 *     be divided. Default is `1e5`.
 * @return {Array<number>} A list of n-dimensional points.
 * @api
 */
function decodeDeltas(encoded, stride, opt_factor) {
    var factor = opt_factor ? opt_factor : 1e5;
    var d;
    /** @type {Array<number>} */
    var lastNumbers = new Array(stride);
    for (d = 0; d < stride; ++d) {
        lastNumbers[d] = 0;
    }
    var numbers = decodeFloats(encoded, factor);
    for (var i = 0, ii = numbers.length; i < ii;) {
        for (d = 0; d < stride; ++d, ++i) {
            lastNumbers[d] += numbers[i];
            numbers[i] = lastNumbers[d];
        }
    }
    return numbers;
}
/**
 * Encode a list of floating point numbers and return an encoded string
 *
 * Attention: This function will modify the passed array!
 *
 * @param {Array<number>} numbers A list of floating point numbers.
 * @param {number} [opt_factor] The factor by which the numbers will be
 *     multiplied. The remaining decimal places will get rounded away.
 *     Default is `1e5`.
 * @return {string} The encoded string.
 * @api
 */
function encodeFloats(numbers, opt_factor) {
    var factor = opt_factor ? opt_factor : 1e5;
    for (var i = 0, ii = numbers.length; i < ii; ++i) {
        numbers[i] = Math.round(numbers[i] * factor);
    }
    return encodeSignedIntegers(numbers);
}
/**
 * Decode a list of floating point numbers from an encoded string
 *
 * @param {string} encoded An encoded string.
 * @param {number} [opt_factor] The factor by which the result will be divided.
 *     Default is `1e5`.
 * @return {Array<number>} A list of floating point numbers.
 * @api
 */
function decodeFloats(encoded, opt_factor) {
    var factor = opt_factor ? opt_factor : 1e5;
    var numbers = decodeSignedIntegers(encoded);
    for (var i = 0, ii = numbers.length; i < ii; ++i) {
        numbers[i] /= factor;
    }
    return numbers;
}
/**
 * Encode a list of signed integers and return an encoded string
 *
 * Attention: This function will modify the passed array!
 *
 * @param {Array<number>} numbers A list of signed integers.
 * @return {string} The encoded string.
 */
function encodeSignedIntegers(numbers) {
    for (var i = 0, ii = numbers.length; i < ii; ++i) {
        var num = numbers[i];
        numbers[i] = num < 0 ? ~(num << 1) : num << 1;
    }
    return encodeUnsignedIntegers(numbers);
}
/**
 * Decode a list of signed integers from an encoded string
 *
 * @param {string} encoded An encoded string.
 * @return {Array<number>} A list of signed integers.
 */
function decodeSignedIntegers(encoded) {
    var numbers = decodeUnsignedIntegers(encoded);
    for (var i = 0, ii = numbers.length; i < ii; ++i) {
        var num = numbers[i];
        numbers[i] = num & 1 ? ~(num >> 1) : num >> 1;
    }
    return numbers;
}
/**
 * Encode a list of unsigned integers and return an encoded string
 *
 * @param {Array<number>} numbers A list of unsigned integers.
 * @return {string} The encoded string.
 */
function encodeUnsignedIntegers(numbers) {
    var encoded = '';
    for (var i = 0, ii = numbers.length; i < ii; ++i) {
        encoded += encodeUnsignedInteger(numbers[i]);
    }
    return encoded;
}
/**
 * Decode a list of unsigned integers from an encoded string
 *
 * @param {string} encoded An encoded string.
 * @return {Array<number>} A list of unsigned integers.
 */
function decodeUnsignedIntegers(encoded) {
    var numbers = [];
    var current = 0;
    var shift = 0;
    for (var i = 0, ii = encoded.length; i < ii; ++i) {
        var b = encoded.charCodeAt(i) - 63;
        current |= (b & 0x1f) << shift;
        if (b < 0x20) {
            numbers.push(current);
            current = 0;
            shift = 0;
        }
        else {
            shift += 5;
        }
    }
    return numbers;
}
/**
 * Encode one single unsigned integer and return an encoded string
 *
 * @param {number} num Unsigned integer that should be encoded.
 * @return {string} The encoded string.
 */
function encodeUnsignedInteger(num) {
    var value, encoded = '';
    while (num >= 0x20) {
        value = (0x20 | (num & 0x1f)) + 63;
        encoded += String.fromCharCode(value);
        num >>= 5;
    }
    value = num + 63;
    encoded += String.fromCharCode(value);
    return encoded;
}
/* harmony default export */ __webpack_exports__["default"] = (Polyline);
//# sourceMappingURL=Polyline.js.map

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flipXY", function() { return flipXY; });
/**
 * @module ol/geom/flat/flip
 */
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @param {Array<number>} [opt_dest] Destination.
 * @param {number} [opt_destOffset] Destination offset.
 * @return {Array<number>} Flat coordinates.
 */
function flipXY(flatCoordinates, offset, end, stride, opt_dest, opt_destOffset) {
    var dest, destOffset;
    if (opt_dest !== undefined) {
        dest = opt_dest;
        destOffset = opt_destOffset !== undefined ? opt_destOffset : 0;
    }
    else {
        dest = [];
        destOffset = 0;
    }
    var j = offset;
    while (j < end) {
        var x = flatCoordinates[j++];
        dest[destOffset++] = flatCoordinates[j++];
        dest[destOffset++] = x;
        for (var k = 2; k < stride; ++k) {
            dest[destOffset++] = flatCoordinates[j++];
        }
    }
    dest.length = destOffset;
    return dest;
}
//# sourceMappingURL=flip.js.map

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _JSONFeature_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(201);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(184);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/TopoJSON
 */










/**
 * @typedef {import("topojson-specification").Topology} TopoJSONTopology
 * @typedef {import("topojson-specification").GeometryCollection} TopoJSONGeometryCollection
 * @typedef {import("topojson-specification").GeometryObject} TopoJSONGeometry
 * @typedef {import("topojson-specification").Point} TopoJSONPoint
 * @typedef {import("topojson-specification").MultiPoint} TopoJSONMultiPoint
 * @typedef {import("topojson-specification").LineString} TopoJSONLineString
 * @typedef {import("topojson-specification").MultiLineString} TopoJSONMultiLineString
 * @typedef {import("topojson-specification").Polygon} TopoJSONPolygon
 * @typedef {import("topojson-specification").MultiPolygon} TopoJSONMultiPolygon
 */
/**
 * @typedef {Object} Options
 * @property {import("../proj.js").ProjectionLike} [dataProjection='EPSG:4326'] Default data projection.
 * @property {string} [layerName] Set the name of the TopoJSON topology
 * `objects`'s children as feature property with the specified name. This means
 * that when set to `'layer'`, a topology like
 * ```
 * {
 *   "type": "Topology",
 *   "objects": {
 *     "example": {
 *       "type": "GeometryCollection",
 *       "geometries": []
 *     }
 *   }
 * }
 * ```
 * will result in features that have a property `'layer'` set to `'example'`.
 * When not set, no property will be added to features.
 * @property {Array<string>} [layers] Names of the TopoJSON topology's
 * `objects`'s children to read features from.  If not provided, features will
 * be read from all children.
 */
/**
 * @classdesc
 * Feature format for reading data in the TopoJSON format.
 *
 * @api
 */
var TopoJSON = /** @class */ (function (_super) {
    __extends(TopoJSON, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function TopoJSON(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {string|undefined}
         */
        _this.layerName_ = options.layerName;
        /**
         * @private
         * @type {?Array<string>}
         */
        _this.layers_ = options.layers ? options.layers : null;
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.dataProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_8__["get"])(options.dataProjection ? options.dataProjection : 'EPSG:4326');
        return _this;
    }
    /**
     * @param {Object} object Object.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    TopoJSON.prototype.readFeaturesFromObject = function (object, opt_options) {
        if (object.type == 'Topology') {
            var topoJSONTopology = /** @type {TopoJSONTopology} */ (object);
            var transform = void 0, scale = null, translate = null;
            if (topoJSONTopology['transform']) {
                transform = topoJSONTopology['transform'];
                scale = transform['scale'];
                translate = transform['translate'];
            }
            var arcs = topoJSONTopology['arcs'];
            if (transform) {
                transformArcs(arcs, scale, translate);
            }
            /** @type {Array<Feature>} */
            var features = [];
            var topoJSONFeatures = topoJSONTopology['objects'];
            var property = this.layerName_;
            var feature = void 0;
            for (var objectName in topoJSONFeatures) {
                if (this.layers_ && this.layers_.indexOf(objectName) == -1) {
                    continue;
                }
                if (topoJSONFeatures[objectName].type === 'GeometryCollection') {
                    feature = /** @type {TopoJSONGeometryCollection} */ (topoJSONFeatures[objectName]);
                    features.push.apply(features, readFeaturesFromGeometryCollection(feature, arcs, scale, translate, property, objectName, opt_options));
                }
                else {
                    feature = /** @type {TopoJSONGeometry} */ (topoJSONFeatures[objectName]);
                    features.push(readFeatureFromGeometry(feature, arcs, scale, translate, property, objectName, opt_options));
                }
            }
            return features;
        }
        else {
            return [];
        }
    };
    /**
     * @param {Object} object Object.
     * @protected
     * @return {import("../proj/Projection.js").default} Projection.
     */
    TopoJSON.prototype.readProjectionFromObject = function (object) {
        return this.dataProjection;
    };
    return TopoJSON;
}(_JSONFeature_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @const
 * @type {Object<string, function(TopoJSONGeometry, Array, ...Array=): import("../geom/Geometry.js").default>}
 */
var GEOMETRY_READERS = {
    'Point': readPointGeometry,
    'LineString': readLineStringGeometry,
    'Polygon': readPolygonGeometry,
    'MultiPoint': readMultiPointGeometry,
    'MultiLineString': readMultiLineStringGeometry,
    'MultiPolygon': readMultiPolygonGeometry,
};
/**
 * Concatenate arcs into a coordinate array.
 * @param {Array<number>} indices Indices of arcs to concatenate.  Negative
 *     values indicate arcs need to be reversed.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs (already
 *     transformed).
 * @return {Array<import("../coordinate.js").Coordinate>} Coordinates array.
 */
function concatenateArcs(indices, arcs) {
    /** @type {Array<import("../coordinate.js").Coordinate>} */
    var coordinates = [];
    var index, arc;
    for (var i = 0, ii = indices.length; i < ii; ++i) {
        index = indices[i];
        if (i > 0) {
            // splicing together arcs, discard last point
            coordinates.pop();
        }
        if (index >= 0) {
            // forward arc
            arc = arcs[index];
        }
        else {
            // reverse arc
            arc = arcs[~index].slice().reverse();
        }
        coordinates.push.apply(coordinates, arc);
    }
    // provide fresh copies of coordinate arrays
    for (var j = 0, jj = coordinates.length; j < jj; ++j) {
        coordinates[j] = coordinates[j].slice();
    }
    return coordinates;
}
/**
 * Create a point from a TopoJSON geometry object.
 *
 * @param {TopoJSONPoint} object TopoJSON object.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @return {Point} Geometry.
 */
function readPointGeometry(object, scale, translate) {
    var coordinates = object['coordinates'];
    if (scale && translate) {
        transformVertex(coordinates, scale, translate);
    }
    return new _geom_Point_js__WEBPACK_IMPORTED_MODULE_6__["default"](coordinates);
}
/**
 * Create a multi-point from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiPoint} object TopoJSON object.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @return {MultiPoint} Geometry.
 */
function readMultiPointGeometry(object, scale, translate) {
    var coordinates = object['coordinates'];
    if (scale && translate) {
        for (var i = 0, ii = coordinates.length; i < ii; ++i) {
            transformVertex(coordinates[i], scale, translate);
        }
    }
    return new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_4__["default"](coordinates);
}
/**
 * Create a linestring from a TopoJSON geometry object.
 *
 * @param {TopoJSONLineString} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {LineString} Geometry.
 */
function readLineStringGeometry(object, arcs) {
    var coordinates = concatenateArcs(object['arcs'], arcs);
    return new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_2__["default"](coordinates);
}
/**
 * Create a multi-linestring from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiLineString} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {MultiLineString} Geometry.
 */
function readMultiLineStringGeometry(object, arcs) {
    var coordinates = [];
    for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
        coordinates[i] = concatenateArcs(object['arcs'][i], arcs);
    }
    return new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_3__["default"](coordinates);
}
/**
 * Create a polygon from a TopoJSON geometry object.
 *
 * @param {TopoJSONPolygon} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {Polygon} Geometry.
 */
function readPolygonGeometry(object, arcs) {
    var coordinates = [];
    for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
        coordinates[i] = concatenateArcs(object['arcs'][i], arcs);
    }
    return new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_7__["default"](coordinates);
}
/**
 * Create a multi-polygon from a TopoJSON geometry object.
 *
 * @param {TopoJSONMultiPolygon} object TopoJSON object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @return {MultiPolygon} Geometry.
 */
function readMultiPolygonGeometry(object, arcs) {
    var coordinates = [];
    for (var i = 0, ii = object['arcs'].length; i < ii; ++i) {
        // for each polygon
        var polyArray = object['arcs'][i];
        var ringCoords = [];
        for (var j = 0, jj = polyArray.length; j < jj; ++j) {
            // for each ring
            ringCoords[j] = concatenateArcs(polyArray[j], arcs);
        }
        coordinates[i] = ringCoords;
    }
    return new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_5__["default"](coordinates);
}
/**
 * Create features from a TopoJSON GeometryCollection object.
 *
 * @param {TopoJSONGeometryCollection} collection TopoJSON Geometry
 *     object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
 *     object to.
 * @param {string} name Name of the `Topology`'s child object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {Array<Feature>} Array of features.
 */
function readFeaturesFromGeometryCollection(collection, arcs, scale, translate, property, name, opt_options) {
    var geometries = collection['geometries'];
    var features = [];
    for (var i = 0, ii = geometries.length; i < ii; ++i) {
        features[i] = readFeatureFromGeometry(geometries[i], arcs, scale, translate, property, name, opt_options);
    }
    return features;
}
/**
 * Create a feature from a TopoJSON geometry object.
 *
 * @param {TopoJSONGeometry} object TopoJSON geometry object.
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 * @param {string|undefined} property Property to set the `GeometryCollection`'s parent
 *     object to.
 * @param {string} name Name of the `Topology`'s child object.
 * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
 * @return {Feature} Feature.
 */
function readFeatureFromGeometry(object, arcs, scale, translate, property, name, opt_options) {
    var geometry = null;
    var type = object.type;
    if (type) {
        var geometryReader = GEOMETRY_READERS[type];
        if (type === 'Point' || type === 'MultiPoint') {
            geometry = geometryReader(object, scale, translate);
        }
        else {
            geometry = geometryReader(object, arcs);
        }
        geometry = Object(_Feature_js__WEBPACK_IMPORTED_MODULE_9__["transformGeometryWithOptions"])(geometry, false, opt_options);
    }
    var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]({ geometry: geometry });
    if (object.id !== undefined) {
        feature.setId(object.id);
    }
    var properties = object.properties;
    if (property) {
        if (!properties) {
            properties = {};
        }
        properties[property] = name;
    }
    if (properties) {
        feature.setProperties(properties, true);
    }
    return feature;
}
/**
 * Apply a linear transform to array of arcs.  The provided array of arcs is
 * modified in place.
 *
 * @param {Array<Array<import("../coordinate.js").Coordinate>>} arcs Array of arcs.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */
function transformArcs(arcs, scale, translate) {
    for (var i = 0, ii = arcs.length; i < ii; ++i) {
        transformArc(arcs[i], scale, translate);
    }
}
/**
 * Apply a linear transform to an arc.  The provided arc is modified in place.
 *
 * @param {Array<import("../coordinate.js").Coordinate>} arc Arc.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */
function transformArc(arc, scale, translate) {
    var x = 0;
    var y = 0;
    for (var i = 0, ii = arc.length; i < ii; ++i) {
        var vertex = arc[i];
        x += vertex[0];
        y += vertex[1];
        vertex[0] = x;
        vertex[1] = y;
        transformVertex(vertex, scale, translate);
    }
}
/**
 * Apply a linear transform to a vertex.  The provided vertex is modified in
 * place.
 *
 * @param {import("../coordinate.js").Coordinate} vertex Vertex.
 * @param {Array<number>} scale Scale for each dimension.
 * @param {Array<number>} translate Translation for each dimension.
 */
function transformVertex(vertex, scale, translate) {
    vertex[0] = vertex[0] * scale[0] + translate[0];
    vertex[1] = vertex[1] * scale[1] + translate[1];
}
/* harmony default export */ __webpack_exports__["default"] = (TopoJSON);
//# sourceMappingURL=TopoJSON.js.map

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeFilter", function() { return writeFilter; });
/* harmony import */ var _GML2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(214);
/* harmony import */ var _GML3_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(213);
/* harmony import */ var _GML32_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(234);
/* harmony import */ var _GMLBase_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(215);
/* harmony import */ var _XMLFeature_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(216);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(217);
/* harmony import */ var _filter_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(235);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(218);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/WFS
 */











/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
var FEATURE_COLLECTION_PARSERS = {
    'http://www.opengis.net/gml': {
        'boundedBy': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["default"].prototype.readGeometryElement, 'bounds'),
    },
    'http://www.opengis.net/wfs/2.0': {
        'member': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["default"].prototype.readFeaturesInternal),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
var TRANSACTION_SUMMARY_PARSERS = {
    'http://www.opengis.net/wfs': {
        'totalInserted': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
        'totalUpdated': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
        'totalDeleted': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    },
    'http://www.opengis.net/wfs/2.0': {
        'totalInserted': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
        'totalUpdated': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
        'totalDeleted': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeInteger"]),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
var TRANSACTION_RESPONSE_PARSERS = {
    'http://www.opengis.net/wfs': {
        'TransactionSummary': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(readTransactionSummary, 'transactionSummary'),
        'InsertResults': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(readInsertResults, 'insertIds'),
    },
    'http://www.opengis.net/wfs/2.0': {
        'TransactionSummary': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(readTransactionSummary, 'transactionSummary'),
        'InsertResults': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeObjectPropertySetter"])(readInsertResults, 'insertIds'),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
var QUERY_SERIALIZERS = {
    'http://www.opengis.net/wfs': {
        'PropertyName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    },
    'http://www.opengis.net/wfs/2.0': {
        'PropertyName': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"]),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
var TRANSACTION_SERIALIZERS = {
    'http://www.opengis.net/wfs': {
        'Insert': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeFeature),
        'Update': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeUpdate),
        'Delete': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDelete),
        'Property': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeProperty),
        'Native': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeNative),
    },
    'http://www.opengis.net/wfs/2.0': {
        'Insert': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeFeature),
        'Update': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeUpdate),
        'Delete': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDelete),
        'Property': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeProperty),
        'Native': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeNative),
    },
};
/**
 * @typedef {Object} Options
 * @property {Object<string, string>|string} [featureNS] The namespace URI used for features.
 * @property {Array<string>|string} [featureType] The feature type to parse. Only used for read operations.
 * @property {GMLBase} [gmlFormat] The GML format to use to parse the response.
 * Default is `ol/format/GML2` for WFS 1.0.0, `ol/format/GML3` for WFS 1.1.0 and `ol/format/GML32` for WFS 2.0.0.
 * @property {string} [schemaLocation] Optional schemaLocation to use for serialization, this will override the default.
 * @property {string} [version='1.1.0'] WFS version to use. Can be either `1.0.0`, `1.1.0` or `2.0.0`.
 */
/**
 * @typedef {Object} WriteGetFeatureOptions
 * @property {string} featureNS The namespace URI used for features.
 * @property {string} featurePrefix The prefix for the feature namespace.
 * @property {Array<string|FeatureType>} featureTypes The feature type names or FeatureType objects to
 * define a unique bbox filter per feature type name (in this case, options `bbox` and `geometryName` are
 * ignored.).
 * @property {string} [srsName] SRS name. No srsName attribute will be set on
 * geometries when this is not provided.
 * @property {string} [handle] Handle.
 * @property {string} [outputFormat] Output format.
 * @property {number} [maxFeatures] Maximum number of features to fetch.
 * @property {string} [geometryName] Geometry name to use in a BBOX filter.
 * @property {Array<string>} [propertyNames] Optional list of property names to serialize.
 * @property {string} [viewParams] viewParams GeoServer vendor parameter.
 * @property {number} [startIndex] Start index to use for WFS paging. This is a
 * WFS 2.0 feature backported to WFS 1.1.0 by some Web Feature Services.
 * @property {number} [count] Number of features to retrieve when paging. This is a
 * WFS 2.0 feature backported to WFS 1.1.0 by some Web Feature Services. Please note that some
 * Web Feature Services have repurposed `maxfeatures` instead.
 * @property {import("../extent.js").Extent} [bbox] Extent to use for the BBOX filter. The `geometryName`
 * option must be set.
 * @property {import("./filter/Filter.js").default} [filter] Filter condition. See
 * {@link module:ol/format/Filter} for more information.
 * @property {string} [resultType] Indicates what response should be returned,
 * E.g. `hits` only includes the `numberOfFeatures` attribute in the response and no features.
 */
/**
 * @typedef {Object} FeatureType
 * @property {!string} name The feature type name.
 * @property {!import("../extent.js").Extent} bbox Extent to use for the BBOX filter.
 * @property {!string} geometryName Geometry name to use in the BBOX filter.
 */
/**
 * @typedef {Object} WriteTransactionOptions
 * @property {string} featureNS The namespace URI used for features.
 * @property {string} featurePrefix The prefix for the feature namespace.
 * @property {string} featureType The feature type name.
 * @property {string} [srsName] SRS name. No srsName attribute will be set on
 * geometries when this is not provided.
 * @property {string} [handle] Handle.
 * @property {boolean} [hasZ] Must be set to true if the transaction is for
 * a 3D layer. This will allow the Z coordinate to be included in the transaction.
 * @property {Array<Object>} nativeElements Native elements. Currently not supported.
 * @property {import("./GMLBase.js").Options} [gmlOptions] GML options for the WFS transaction writer.
 * @property {string} [version='1.1.0'] WFS version to use for the transaction. Can be either `1.0.0`, `1.1.0` or `2.0.0`.
 */
/**
 * Number of features; bounds/extent.
 * @typedef {Object} FeatureCollectionMetadata
 * @property {number} numberOfFeatures NumberOfFeatures.
 * @property {import("../extent.js").Extent} bounds Bounds.
 */
/**
 * Total deleted; total inserted; total updated; array of insert ids.
 * @typedef {Object} TransactionResponse
 * @property {number} totalDeleted TotalDeleted.
 * @property {number} totalInserted TotalInserted.
 * @property {number} totalUpdated TotalUpdated.
 * @property {Array<string>} insertIds InsertIds.
 */
/**
 * @type {string}
 */
var FEATURE_PREFIX = 'feature';
/**
 * @type {string}
 */
var XMLNS = 'http://www.w3.org/2000/xmlns/';
/**
 * @type {Object<string, string>}
 */
var OGCNS = {
    '2.0.0': 'http://www.opengis.net/ogc/1.1',
    '1.1.0': 'http://www.opengis.net/ogc',
    '1.0.0': 'http://www.opengis.net/ogc',
};
/**
 * @type {Object<string, string>}
 */
var WFSNS = {
    '2.0.0': 'http://www.opengis.net/wfs/2.0',
    '1.1.0': 'http://www.opengis.net/wfs',
    '1.0.0': 'http://www.opengis.net/wfs',
};
/**
 * @type {Object<string, string>}
 */
var FESNS = {
    '2.0.0': 'http://www.opengis.net/fes/2.0',
    '1.1.0': 'http://www.opengis.net/fes',
    '1.0.0': 'http://www.opengis.net/fes',
};
/**
 * @type {Object<string, string>}
 */
var SCHEMA_LOCATIONS = {
    '2.0.0': 'http://www.opengis.net/wfs/2.0 http://schemas.opengis.net/wfs/2.0/wfs.xsd',
    '1.1.0': 'http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.1.0/wfs.xsd',
    '1.0.0': 'http://www.opengis.net/wfs http://schemas.opengis.net/wfs/1.0.0/wfs.xsd',
};
/**
 * @type {Object<string, object>}
 */
var GML_FORMATS = {
    '2.0.0': _GML32_js__WEBPACK_IMPORTED_MODULE_2__["default"],
    '1.1.0': _GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    '1.0.0': _GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"],
};
/**
 * @const
 * @type {string}
 */
var DEFAULT_VERSION = '1.1.0';
/**
 * @classdesc
 * Feature format for reading and writing data in the WFS format.
 * By default, supports WFS version 1.1.0. You can pass a GML format
 * as option to override the default.
 * Also see {@link module:ol/format/GMLBase~GMLBase} which is used by this format.
 *
 * @api
 */
var WFS = /** @class */ (function (_super) {
    __extends(WFS, _super);
    /**
     * @param {Options} [opt_options] Optional configuration object.
     */
    function WFS(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {string}
         */
        _this.version_ = options.version ? options.version : DEFAULT_VERSION;
        /**
         * @private
         * @type {Array<string>|string|undefined}
         */
        _this.featureType_ = options.featureType;
        /**
         * @private
         * @type {Object<string, string>|string|undefined}
         */
        _this.featureNS_ = options.featureNS;
        /**
         * @private
         * @type {GMLBase}
         */
        _this.gmlFormat_ = options.gmlFormat
            ? options.gmlFormat
            : new GML_FORMATS[_this.version_]();
        /**
         * @private
         * @type {string}
         */
        _this.schemaLocation_ = options.schemaLocation
            ? options.schemaLocation
            : SCHEMA_LOCATIONS[_this.version_];
        return _this;
    }
    /**
     * @return {Array<string>|string|undefined} featureType
     */
    WFS.prototype.getFeatureType = function () {
        return this.featureType_;
    };
    /**
     * @param {Array<string>|string|undefined} featureType Feature type(s) to parse.
     */
    WFS.prototype.setFeatureType = function (featureType) {
        this.featureType_ = featureType;
    };
    /**
     * @protected
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */
    WFS.prototype.readFeaturesFromNode = function (node, opt_options) {
        /** @type {import("../xml.js").NodeStackItem} */
        var context = {
            node: node,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, {
            'featureType': this.featureType_,
            'featureNS': this.featureNS_,
        });
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, this.getReadOptions(node, opt_options ? opt_options : {}));
        var objectStack = [context];
        var featuresNS;
        if (this.version_ === '2.0.0') {
            featuresNS = FEATURE_COLLECTION_PARSERS;
        }
        else {
            featuresNS = this.gmlFormat_.FEATURE_COLLECTION_PARSERS;
        }
        var features = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushParseAndPop"])([], featuresNS, node, objectStack, this.gmlFormat_);
        if (!features) {
            features = [];
        }
        return features;
    };
    /**
     * Read transaction response of the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {TransactionResponse|undefined} Transaction response.
     * @api
     */
    WFS.prototype.readTransactionResponse = function (source) {
        if (!source) {
            return undefined;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["parse"])(source);
            return this.readTransactionResponseFromDocument(doc);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["isDocument"])(source)) {
            return this.readTransactionResponseFromDocument(
            /** @type {Document} */ (source));
        }
        else {
            return this.readTransactionResponseFromNode(
            /** @type {Element} */ (source));
        }
    };
    /**
     * Read feature collection metadata of the source.
     *
     * @param {Document|Element|Object|string} source Source.
     * @return {FeatureCollectionMetadata|undefined}
     *     FeatureCollection metadata.
     * @api
     */
    WFS.prototype.readFeatureCollectionMetadata = function (source) {
        if (!source) {
            return undefined;
        }
        else if (typeof source === 'string') {
            var doc = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["parse"])(source);
            return this.readFeatureCollectionMetadataFromDocument(doc);
        }
        else if (Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["isDocument"])(source)) {
            return this.readFeatureCollectionMetadataFromDocument(
            /** @type {Document} */ (source));
        }
        else {
            return this.readFeatureCollectionMetadataFromNode(
            /** @type {Element} */ (source));
        }
    };
    /**
     * @param {Document} doc Document.
     * @return {FeatureCollectionMetadata|undefined}
     *     FeatureCollection metadata.
     */
    WFS.prototype.readFeatureCollectionMetadataFromDocument = function (doc) {
        for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                return this.readFeatureCollectionMetadataFromNode(
                /** @type {Element} */ (n));
            }
        }
        return undefined;
    };
    /**
     * @param {Element} node Node.
     * @return {FeatureCollectionMetadata|undefined}
     *     FeatureCollection metadata.
     */
    WFS.prototype.readFeatureCollectionMetadataFromNode = function (node) {
        var result = {};
        var value = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["readNonNegativeIntegerString"])(node.getAttribute('numberOfFeatures'));
        result['numberOfFeatures'] = value;
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushParseAndPop"])(
        /** @type {FeatureCollectionMetadata} */ (result), FEATURE_COLLECTION_PARSERS, node, [], this.gmlFormat_);
    };
    /**
     * @param {Document} doc Document.
     * @return {TransactionResponse|undefined} Transaction response.
     */
    WFS.prototype.readTransactionResponseFromDocument = function (doc) {
        for (var n = /** @type {Node} */ (doc.firstChild); n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                return this.readTransactionResponseFromNode(/** @type {Element} */ (n));
            }
        }
        return undefined;
    };
    /**
     * @param {Element} node Node.
     * @return {TransactionResponse|undefined} Transaction response.
     */
    WFS.prototype.readTransactionResponseFromNode = function (node) {
        return Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushParseAndPop"])(
        /** @type {TransactionResponse} */ ({}), TRANSACTION_RESPONSE_PARSERS, node, []);
    };
    /**
     * Encode format as WFS `GetFeature` and return the Node.
     *
     * @param {WriteGetFeatureOptions} options Options.
     * @return {Node} Result.
     * @api
     */
    WFS.prototype.writeGetFeature = function (options) {
        var _this = this;
        var node = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(WFSNS[this.version_], 'GetFeature');
        node.setAttribute('service', 'WFS');
        node.setAttribute('version', this.version_);
        if (options.handle) {
            node.setAttribute('handle', options.handle);
        }
        if (options.outputFormat) {
            node.setAttribute('outputFormat', options.outputFormat);
        }
        if (options.maxFeatures !== undefined) {
            node.setAttribute('maxFeatures', String(options.maxFeatures));
        }
        if (options.resultType) {
            node.setAttribute('resultType', options.resultType);
        }
        if (options.startIndex !== undefined) {
            node.setAttribute('startIndex', String(options.startIndex));
        }
        if (options.count !== undefined) {
            node.setAttribute('count', String(options.count));
        }
        if (options.viewParams !== undefined) {
            node.setAttribute('viewParams', options.viewParams);
        }
        node.setAttributeNS(_xml_js__WEBPACK_IMPORTED_MODULE_5__["XML_SCHEMA_INSTANCE_URI"], 'xsi:schemaLocation', this.schemaLocation_);
        /** @type {import("../xml.js").NodeStackItem} */
        var context = {
            node: node,
        };
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, {
            'version': this.version_,
            'srsName': options.srsName,
            'featureNS': options.featureNS ? options.featureNS : this.featureNS_,
            'featurePrefix': options.featurePrefix,
            'propertyNames': options.propertyNames ? options.propertyNames : [],
        });
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_7__["assert"])(Array.isArray(options.featureTypes), 11); // `options.featureTypes` must be an Array
        if (typeof options.featureTypes[0] === 'string') {
            var filter = options.filter;
            if (options.bbox) {
                Object(_asserts_js__WEBPACK_IMPORTED_MODULE_7__["assert"])(options.geometryName, 12); // `options.geometryName` must also be provided when `options.bbox` is set
                filter = this.combineBboxAndFilter(options.geometryName, options.bbox, options.srsName, filter);
            }
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, {
                'geometryName': options.geometryName,
                'filter': filter,
            });
            writeGetFeature(node, 
            /** @type {!Array<string>} */ (options.featureTypes), [context]);
        }
        else {
            // Write one query node per element in featuresType.
            options.featureTypes.forEach(function (/** @type {FeatureType} */ featureType) {
                var completeFilter = _this.combineBboxAndFilter(featureType.geometryName, featureType.bbox, options.srsName, options.filter);
                Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, {
                    'geometryName': featureType.geometryName,
                    'filter': completeFilter,
                });
                writeGetFeature(node, [featureType.name], [context]);
            });
        }
        return node;
    };
    /**
     * Create a bbox filter and combine it with another optional filter.
     *
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../extent.js").Extent} extent Extent.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     * @param {import("./filter/Filter.js").default} [opt_filter] Filter condition.
     * @return {import("./filter/Filter.js").default} The filter.
     */
    WFS.prototype.combineBboxAndFilter = function (geometryName, extent, opt_srsName, opt_filter) {
        var bboxFilter = Object(_filter_js__WEBPACK_IMPORTED_MODULE_6__["bbox"])(geometryName, extent, opt_srsName);
        if (opt_filter) {
            // if bbox and filter are both set, combine the two into a single filter
            return Object(_filter_js__WEBPACK_IMPORTED_MODULE_6__["and"])(opt_filter, bboxFilter);
        }
        return bboxFilter;
    };
    /**
     * Encode format as WFS `Transaction` and return the Node.
     *
     * @param {Array<import("../Feature.js").default>} inserts The features to insert.
     * @param {Array<import("../Feature.js").default>} updates The features to update.
     * @param {Array<import("../Feature.js").default>} deletes The features to delete.
     * @param {WriteTransactionOptions} options Write options.
     * @return {Node} Result.
     * @api
     */
    WFS.prototype.writeTransaction = function (inserts, updates, deletes, options) {
        var objectStack = [];
        var version = options.version ? options.version : this.version_;
        var node = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(WFSNS[version], 'Transaction');
        node.setAttribute('service', 'WFS');
        node.setAttribute('version', version);
        var baseObj;
        /** @type {import("../xml.js").NodeStackItem} */
        if (options) {
            baseObj = options.gmlOptions ? options.gmlOptions : {};
            if (options.handle) {
                node.setAttribute('handle', options.handle);
            }
        }
        node.setAttributeNS(_xml_js__WEBPACK_IMPORTED_MODULE_5__["XML_SCHEMA_INSTANCE_URI"], 'xsi:schemaLocation', SCHEMA_LOCATIONS[version]);
        var request = createTransactionRequest(node, baseObj, version, options);
        if (inserts) {
            serializeTransactionRequest('Insert', inserts, objectStack, request);
        }
        if (updates) {
            serializeTransactionRequest('Update', updates, objectStack, request);
        }
        if (deletes) {
            serializeTransactionRequest('Delete', deletes, objectStack, request);
        }
        if (options.nativeElements) {
            serializeTransactionRequest('Native', options.nativeElements, objectStack, request);
        }
        return node;
    };
    /**
     * @param {Document} doc Document.
     * @return {import("../proj/Projection.js").default} Projection.
     */
    WFS.prototype.readProjectionFromDocument = function (doc) {
        for (var n = doc.firstChild; n; n = n.nextSibling) {
            if (n.nodeType == Node.ELEMENT_NODE) {
                return this.readProjectionFromNode(/** @type {Element} */ (n));
            }
        }
        return null;
    };
    /**
     * @param {Element} node Node.
     * @return {import("../proj/Projection.js").default} Projection.
     */
    WFS.prototype.readProjectionFromNode = function (node) {
        if (node.firstElementChild && node.firstElementChild.firstElementChild) {
            node = node.firstElementChild.firstElementChild;
            for (var n = node.firstElementChild; n; n = n.nextElementSibling) {
                if (!(n.childNodes.length === 0 ||
                    (n.childNodes.length === 1 && n.firstChild.nodeType === 3))) {
                    var objectStack = [{}];
                    this.gmlFormat_.readGeometryElement(n, objectStack);
                    return Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["get"])(objectStack.pop().srsName);
                }
            }
        }
        return null;
    };
    return WFS;
}(_XMLFeature_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/**
 * @param {Element} node Node.
 * @param {*} baseObj Base object.
 * @param {string} version Version.
 * @param {WriteTransactionOptions} options Options.
 * @return {Object} Request object.
 */
function createTransactionRequest(node, baseObj, version, options) {
    var featurePrefix = options.featurePrefix
        ? options.featurePrefix
        : FEATURE_PREFIX;
    var gmlVersion;
    if (version === '1.0.0') {
        gmlVersion = 2;
    }
    else if (version === '1.1.0') {
        gmlVersion = 3;
    }
    else if (version === '2.0.0') {
        gmlVersion = 3.2;
    }
    var obj = Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({ node: node }, {
        version: version,
        'featureNS': options.featureNS,
        'featureType': options.featureType,
        'featurePrefix': featurePrefix,
        'gmlVersion': gmlVersion,
        'hasZ': options.hasZ,
        'srsName': options.srsName,
    }, baseObj);
    return obj;
}
/**
 * @param {string} type Request type.
 * @param {Array<import("../Feature.js").default>} features Features.
 * @param {Array<*>} objectStack Object stack.
 * @param {Element} request Transaction Request.
 */
function serializeTransactionRequest(type, features, objectStack, request) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(request, TRANSACTION_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])(type), features, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Transaction Summary.
 */
function readTransactionSummary(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushParseAndPop"])({}, TRANSACTION_SUMMARY_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
var OGC_FID_PARSERS = {
    'http://www.opengis.net/ogc': {
        'FeatureId': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeArrayPusher"])(function (node, objectStack) {
            return node.getAttribute('fid');
        }),
    },
    'http://www.opengis.net/ogc/1.1': {
        'FeatureId': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeArrayPusher"])(function (node, objectStack) {
            return node.getAttribute('fid');
        }),
    },
};
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 */
function fidParser(node, objectStack) {
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["parseNode"])(OGC_FID_PARSERS, node, objectStack);
}
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
var INSERT_RESULTS_PARSERS = {
    'http://www.opengis.net/wfs': {
        'Feature': fidParser,
    },
    'http://www.opengis.net/wfs/2.0': {
        'Feature': fidParser,
    },
};
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<string>|undefined} Insert results.
 */
function readInsertResults(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushParseAndPop"])([], INSERT_RESULTS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {Array<*>} objectStack Node stack.
 */
function writeFeature(node, feature, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var featureType = context['featureType'];
    var featureNS = context['featureNS'];
    var gmlVersion = context['gmlVersion'];
    var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(featureNS, featureType);
    node.appendChild(child);
    if (gmlVersion === 2) {
        _GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.writeFeatureElement(child, feature, objectStack);
    }
    else if (gmlVersion === 3) {
        _GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeFeatureElement(child, feature, objectStack);
    }
    else {
        _GML32_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.writeFeatureElement(child, feature, objectStack);
    }
}
/**
 * @param {Node} node Node.
 * @param {number|string} fid Feature identifier.
 * @param {Array<*>} objectStack Node stack.
 */
function writeOgcFidFilter(node, fid, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var version = context['version'];
    var ns = OGCNS[version];
    var filter = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'Filter');
    var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'FeatureId');
    filter.appendChild(child);
    child.setAttribute('fid', /** @type {string} */ (fid));
    node.appendChild(filter);
}
/**
 * @param {string|undefined} featurePrefix The prefix of the feature.
 * @param {string} featureType The type of the feature.
 * @return {string} The value of the typeName property.
 */
function getTypeName(featurePrefix, featureType) {
    featurePrefix = featurePrefix ? featurePrefix : FEATURE_PREFIX;
    var prefix = featurePrefix + ':';
    // The featureType already contains the prefix.
    if (featureType.indexOf(prefix) === 0) {
        return featureType;
    }
    else {
        return prefix + featureType;
    }
}
/**
 * @param {Element} node Node.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {Array<*>} objectStack Node stack.
 */
function writeDelete(node, feature, objectStack) {
    var context = objectStack[objectStack.length - 1];
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_7__["assert"])(feature.getId() !== undefined, 26); // Features must have an id set
    var featureType = context['featureType'];
    var featurePrefix = context['featurePrefix'];
    var featureNS = context['featureNS'];
    var typeName = getTypeName(featurePrefix, featureType);
    node.setAttribute('typeName', typeName);
    node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
    var fid = feature.getId();
    if (fid !== undefined) {
        writeOgcFidFilter(node, fid, objectStack);
    }
}
/**
 * @param {Element} node Node.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {Array<*>} objectStack Node stack.
 */
function writeUpdate(node, feature, objectStack) {
    var context = objectStack[objectStack.length - 1];
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_7__["assert"])(feature.getId() !== undefined, 27); // Features must have an id set
    var version = context['version'];
    var featureType = context['featureType'];
    var featurePrefix = context['featurePrefix'];
    var featureNS = context['featureNS'];
    var typeName = getTypeName(featurePrefix, featureType);
    var geometryName = feature.getGeometryName();
    node.setAttribute('typeName', typeName);
    node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
    var fid = feature.getId();
    if (fid !== undefined) {
        var keys = feature.getKeys();
        var values = [];
        for (var i = 0, ii = keys.length; i < ii; i++) {
            var value = feature.get(keys[i]);
            if (value !== undefined) {
                var name_1 = keys[i];
                if (value &&
                    typeof ( /** @type {?} */(value).getSimplifiedGeometry) === 'function') {
                    name_1 = geometryName;
                }
                values.push({ name: name_1, value: value });
            }
        }
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(
        /** @type {import("../xml.js").NodeStackItem} */ ({
            version: version,
            'gmlVersion': context['gmlVersion'],
            node: node,
            'hasZ': context['hasZ'],
            'srsName': context['srsName'],
        }), TRANSACTION_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])('Property'), values, objectStack);
        writeOgcFidFilter(node, fid, objectStack);
    }
}
/**
 * @param {Node} node Node.
 * @param {Object} pair Property name and value.
 * @param {Array<*>} objectStack Node stack.
 */
function writeProperty(node, pair, objectStack) {
    var context = objectStack[objectStack.length - 1];
    var version = context['version'];
    var ns = WFSNS[version];
    var name = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'Name');
    var gmlVersion = context['gmlVersion'];
    node.appendChild(name);
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(name, pair.name);
    if (pair.value !== undefined && pair.value !== null) {
        var value = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'Value');
        node.appendChild(value);
        if (pair.value &&
            typeof ( /** @type {?} */(pair.value).getSimplifiedGeometry) ===
                'function') {
            if (gmlVersion === 2) {
                _GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.writeGeometryElement(value, pair.value, objectStack);
            }
            else if (gmlVersion === 3) {
                _GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeGeometryElement(value, pair.value, objectStack);
            }
            else {
                _GML32_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.writeGeometryElement(value, pair.value, objectStack);
            }
        }
        else {
            Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(value, pair.value);
        }
    }
}
/**
 * @param {Element} node Node.
 * @param {{vendorId: string, safeToIgnore: boolean, value: string}} nativeElement The native element.
 * @param {Array<*>} objectStack Node stack.
 */
function writeNative(node, nativeElement, objectStack) {
    if (nativeElement.vendorId) {
        node.setAttribute('vendorId', nativeElement.vendorId);
    }
    if (nativeElement.safeToIgnore !== undefined) {
        node.setAttribute('safeToIgnore', String(nativeElement.safeToIgnore));
    }
    if (nativeElement.value !== undefined) {
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(node, nativeElement.value);
    }
}
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
var GETFEATURE_SERIALIZERS = {
    'http://www.opengis.net/wfs': {
        'Query': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeQuery),
    },
    'http://www.opengis.net/wfs/2.0': {
        'Query': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeQuery),
    },
    'http://www.opengis.net/ogc': {
        'During': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDuringFilter),
        'And': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeLogicalFilter),
        'Or': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeLogicalFilter),
        'Not': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeNotFilter),
        'BBOX': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeBboxFilter),
        'Contains': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'Intersects': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'Within': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'DWithin': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDWithinFilter),
        'PropertyIsEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsNotEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsLessThan': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsLessThanOrEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsGreaterThan': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsGreaterThanOrEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsNull': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsNullFilter),
        'PropertyIsBetween': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsBetweenFilter),
        'PropertyIsLike': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsLikeFilter),
    },
    'http://www.opengis.net/fes/2.0': {
        'During': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDuringFilter),
        'And': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeLogicalFilter),
        'Or': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeLogicalFilter),
        'Not': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeNotFilter),
        'BBOX': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeBboxFilter),
        'Contains': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'Disjoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'Intersects': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'ResourceId': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeResourceIdFilter),
        'Within': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeSpatialFilter),
        'DWithin': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeDWithinFilter),
        'PropertyIsEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsNotEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsLessThan': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsLessThanOrEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsGreaterThan': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsGreaterThanOrEqualTo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeComparisonFilter),
        'PropertyIsNull': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsNullFilter),
        'PropertyIsBetween': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsBetweenFilter),
        'PropertyIsLike': Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeChildAppender"])(writeIsLikeFilter),
    },
};
/**
 * @param {Element} node Node.
 * @param {string} featureType Feature type.
 * @param {Array<*>} objectStack Node stack.
 */
function writeQuery(node, featureType, objectStack) {
    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var version = context['version'];
    var featurePrefix = context['featurePrefix'];
    var featureNS = context['featureNS'];
    var propertyNames = context['propertyNames'];
    var srsName = context['srsName'];
    var typeName;
    // If feature prefix is not defined, we must not use the default prefix.
    if (featurePrefix) {
        typeName = getTypeName(featurePrefix, featureType);
    }
    else {
        typeName = featureType;
    }
    var typeNameAttr;
    if (version === '2.0.0') {
        typeNameAttr = 'typeNames';
    }
    else {
        typeNameAttr = 'typeName';
    }
    node.setAttribute(typeNameAttr, typeName);
    if (srsName) {
        node.setAttribute('srsName', srsName);
    }
    if (featureNS) {
        node.setAttributeNS(XMLNS, 'xmlns:' + featurePrefix, featureNS);
    }
    var item = /** @type {import("../xml.js").NodeStackItem} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, context));
    item.node = node;
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(item, QUERY_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])('PropertyName'), propertyNames, objectStack);
    var filter = context['filter'];
    if (filter) {
        var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(getFilterNS(version), 'Filter');
        node.appendChild(child);
        writeFilterCondition(child, filter, objectStack);
    }
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/Filter.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeFilterCondition(node, filter, objectStack) {
    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    /** @type {import("../xml.js").NodeStackItem} */
    var item = { node: node };
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(item, { context: context });
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(item, GETFEATURE_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])(filter.getTagName()), [filter], objectStack);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/Bbox.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeBboxFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    parent['srsName'] = filter.srsName;
    var format = GML_FORMATS[version];
    writePropertyName(version, node, filter.geometryName);
    format.prototype.writeGeometryElement(node, filter.extent, objectStack);
}
/**
 * @param {Element} node Element.
 * @param {import("./filter/ResourceId.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeResourceIdFilter(node, filter, objectStack) {
    node.setAttribute('rid', /** @type {string} */ (filter.rid));
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/Spatial.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeSpatialFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    parent['srsName'] = filter.srsName;
    var format = GML_FORMATS[version];
    writePropertyName(version, node, filter.geometryName);
    format.prototype.writeGeometryElement(node, filter.geometry, objectStack);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/DWithin.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeDWithinFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    writeSpatialFilter(node, filter, objectStack);
    var distance = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(getFilterNS(version), 'Distance');
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(distance, filter.distance.toString());
    if (version === '2.0.0') {
        distance.setAttribute('uom', filter.unit);
    }
    else {
        distance.setAttribute('units', filter.unit);
    }
    node.appendChild(distance);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/During.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeDuringFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    writeExpression(FESNS[version], 'ValueReference', node, filter.propertyName);
    var timePeriod = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["GMLNS"], 'TimePeriod');
    node.appendChild(timePeriod);
    var begin = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["GMLNS"], 'begin');
    timePeriod.appendChild(begin);
    writeTimeInstant(begin, filter.begin);
    var end = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["GMLNS"], 'end');
    timePeriod.appendChild(end);
    writeTimeInstant(end, filter.end);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/LogicalNary.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeLogicalFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    /** @type {import("../xml.js").NodeStackItem} */
    var item = { node: node };
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(item, { context: context });
    var conditions = filter.conditions;
    for (var i = 0, ii = conditions.length; i < ii; ++i) {
        var condition = conditions[i];
        Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(item, GETFEATURE_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])(condition.getTagName()), [condition], objectStack);
    }
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/Not.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeNotFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    /** @type {import("../xml.js").NodeStackItem} */
    var item = { node: node };
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(item, { context: context });
    var condition = filter.condition;
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(item, GETFEATURE_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])(condition.getTagName()), [condition], objectStack);
}
/**
 * @param {Element} node Node.
 * @param {import("./filter/ComparisonBinary.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeComparisonFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    if (filter.matchCase !== undefined) {
        node.setAttribute('matchCase', filter.matchCase.toString());
    }
    writePropertyName(version, node, filter.propertyName);
    writeLiteral(version, node, '' + filter.expression);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/IsNull.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeIsNullFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    writePropertyName(version, node, filter.propertyName);
}
/**
 * @param {Node} node Node.
 * @param {import("./filter/IsBetween.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeIsBetweenFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    var ns = getFilterNS(version);
    writePropertyName(version, node, filter.propertyName);
    var lowerBoundary = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'LowerBoundary');
    node.appendChild(lowerBoundary);
    writeLiteral(version, lowerBoundary, '' + filter.lowerBoundary);
    var upperBoundary = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, 'UpperBoundary');
    node.appendChild(upperBoundary);
    writeLiteral(version, upperBoundary, '' + filter.upperBoundary);
}
/**
 * @param {Element} node Node.
 * @param {import("./filter/IsLike.js").default} filter Filter.
 * @param {Array<*>} objectStack Node stack.
 */
function writeIsLikeFilter(node, filter, objectStack) {
    var parent = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var context = parent['context'];
    var version = context['version'];
    node.setAttribute('wildCard', filter.wildCard);
    node.setAttribute('singleChar', filter.singleChar);
    node.setAttribute('escapeChar', filter.escapeChar);
    if (filter.matchCase !== undefined) {
        node.setAttribute('matchCase', filter.matchCase.toString());
    }
    writePropertyName(version, node, filter.propertyName);
    writeLiteral(version, node, '' + filter.pattern);
}
/**
 * @param {string} ns Namespace.
 * @param {string} tagName Tag name.
 * @param {Node} node Node.
 * @param {string} value Value.
 */
function writeExpression(ns, tagName, node, value) {
    var property = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(ns, tagName);
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(property, value);
    node.appendChild(property);
}
/**
 * @param {string} version Version.
 * @param {Node} node Node.
 * @param {string} value PropertyName value.
 */
function writeLiteral(version, node, value) {
    writeExpression(getFilterNS(version), 'Literal', node, value);
}
/**
 * @param {string} version Version.
 * @param {Node} node Node.
 * @param {string} value PropertyName value.
 */
function writePropertyName(version, node, value) {
    if (version === '2.0.0') {
        writeExpression(FESNS[version], 'ValueReference', node, value);
    }
    else {
        writeExpression(OGCNS[version], 'PropertyName', node, value);
    }
}
/**
 * @param {Node} node Node.
 * @param {string} time PropertyName value.
 */
function writeTimeInstant(node, time) {
    var timeInstant = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["GMLNS"], 'TimeInstant');
    node.appendChild(timeInstant);
    var timePosition = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_3__["GMLNS"], 'timePosition');
    timeInstant.appendChild(timePosition);
    Object(_xsd_js__WEBPACK_IMPORTED_MODULE_10__["writeStringTextNode"])(timePosition, time);
}
/**
 * Encode filter as WFS `Filter` and return the Node.
 *
 * @param {import("./filter/Filter.js").default} filter Filter.
 * @param {string} opt_version WFS version. If not provided defaults to '1.1.0'
 * @return {Node} Result.
 * @api
 */
function writeFilter(filter, opt_version) {
    var version = opt_version || '1.1.0';
    var child = Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["createElementNS"])(getFilterNS(version), 'Filter');
    var context = {
        node: child,
    };
    Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])(context, {
        'version': version,
        'filter': filter,
    });
    writeFilterCondition(child, filter, [context]);
    return child;
}
/**
 * @param {Node} node Node.
 * @param {Array<string>} featureTypes Feature types.
 * @param {Array<*>} objectStack Node stack.
 */
function writeGetFeature(node, featureTypes, objectStack) {
    var context = /** @type {Object} */ (objectStack[objectStack.length - 1]);
    var item = /** @type {import("../xml.js").NodeStackItem} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, context));
    item.node = node;
    Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["pushSerializeAndPop"])(item, GETFEATURE_SERIALIZERS, Object(_xml_js__WEBPACK_IMPORTED_MODULE_5__["makeSimpleNodeFactory"])('Query'), featureTypes, objectStack);
}
function getFilterNS(version) {
    var ns;
    if (version === '2.0.0') {
        ns = FESNS[version];
    }
    else {
        ns = OGCNS[version];
    }
    return ns;
}
/* harmony default export */ __webpack_exports__["default"] = (WFS);
//# sourceMappingURL=WFS.js.map

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GML2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(214);
/* harmony import */ var _GML3_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(213);
/* harmony import */ var _GMLBase_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(215);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(217);
/* harmony import */ var _format_xsd_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(218);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/GML32
 */





/**
 * @classdesc Feature format for reading and writing data in the GML format
 *            version 3.2.1.
 * @api
 */
var GML32 = /** @class */ (function (_super) {
    __extends(GML32, _super);
    /**
     * @param {import("./GMLBase.js").Options} [opt_options] Optional configuration object.
     */
    function GML32(opt_options) {
        var _this = this;
        var options = /** @type {import("./GMLBase.js").Options} */ (opt_options ? opt_options : {});
        _this = _super.call(this, options) || this;
        /**
         * @type {string}
         */
        _this.schemaLocation = options.schemaLocation
            ? options.schemaLocation
            : _this.namespace + ' http://schemas.opengis.net/gml/3.2.1/gml.xsd';
        return _this;
    }
    return GML32;
}(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
GML32.prototype.namespace = 'http://www.opengis.net/gml/3.2';
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.GEOMETRY_FLAT_COORDINATES_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'pos': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readFlatPos),
        'posList': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readFlatPosList),
        'coordinates': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"].prototype.readFlatCoordinates),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.FLAT_LINEAR_RINGS_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'interior': _GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.interiorParser,
        'exterior': _GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.exteriorParser,
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.GEOMETRY_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readPoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readMultiLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readMultiPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(GML32.prototype.readSurface),
        'MultiSurface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readMultiSurface),
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(GML32.prototype.readCurve),
        'MultiCurve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readMultiCurve),
        'Envelope': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(GML32.prototype.readEnvelope),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.MULTICURVE_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'curveMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.curveMemberParser),
        'curveMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.curveMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.MULTISURFACE_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'surfaceMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.surfaceMemberParser),
        'surfaceMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.surfaceMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.CURVEMEMBER_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readLineString),
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readCurve),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.SURFACEMEMBER_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readSurface),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.SURFACE_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'patches': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readPatch),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.CURVE_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'segments': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readSegment),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.ENVELOPE_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'lowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readFlatPosList),
        'upperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readFlatPosList),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.PATCHES_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'PolygonPatch': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readPolygonPatch),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.SEGMENTS_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'LineStringSegment': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.readLineStringSegment),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.MULTIPOINT_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'pointMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.pointMemberParser),
        'pointMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.pointMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.MULTILINESTRING_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'lineStringMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.lineStringMemberParser),
        'lineStringMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.lineStringMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.MULTIPOLYGON_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'polygonMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.polygonMemberParser),
        'polygonMembers': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.polygonMemberParser),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.POINTMEMBER_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readFlatCoordinatesFromNode),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.LINESTRINGMEMBER_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readLineString),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.POLYGONMEMBER_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readPolygon),
    },
};
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
GML32.prototype.RING_PARSERS = {
    'http://www.opengis.net/gml/3.2': {
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeReplacer"])(_GMLBase_js__WEBPACK_IMPORTED_MODULE_2__["default"].prototype.readFlatLinearRing),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.RING_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'exterior': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeRing),
        'interior': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeRing),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.ENVELOPE_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'lowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_format_xsd_js__WEBPACK_IMPORTED_MODULE_4__["writeStringTextNode"]),
        'upperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_format_xsd_js__WEBPACK_IMPORTED_MODULE_4__["writeStringTextNode"]),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.SURFACEORPOLYGONMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'surfaceMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeSurfaceOrPolygonMember),
        'polygonMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeSurfaceOrPolygonMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.POINTMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'pointMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writePointMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.LINESTRINGORCURVEMEMBER_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'lineStringMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeLineStringOrCurveMember),
        'curveMember': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeLineStringOrCurveMember),
    },
};
/**
 * @type {Object<string, Object<string, import("../xml.js").Serializer>>}
 */
GML32.prototype.GEOMETRY_SERIALIZERS = {
    'http://www.opengis.net/gml/3.2': {
        'Curve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeCurveOrLineString),
        'MultiCurve': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeMultiCurveOrLineString),
        'Point': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(GML32.prototype.writePoint),
        'MultiPoint': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeMultiPoint),
        'LineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeCurveOrLineString),
        'MultiLineString': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeMultiCurveOrLineString),
        'LinearRing': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeLinearRing),
        'Polygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeSurfaceOrPolygon),
        'MultiPolygon': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeMultiSurfaceOrPolygon),
        'Surface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeSurfaceOrPolygon),
        'MultiSurface': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeMultiSurfaceOrPolygon),
        'Envelope': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeChildAppender"])(_GML3_js__WEBPACK_IMPORTED_MODULE_1__["default"].prototype.writeEnvelope),
    },
};
/* harmony default export */ __webpack_exports__["default"] = (GML32);
//# sourceMappingURL=GML32.js.map

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "and", function() { return and; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "or", function() { return or; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "not", function() { return not; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bbox", function() { return bbox; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "contains", function() { return contains; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "intersects", function() { return intersects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "disjoint", function() { return disjoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "within", function() { return within; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dwithin", function() { return dwithin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "equalTo", function() { return equalTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "notEqualTo", function() { return notEqualTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lessThan", function() { return lessThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lessThanOrEqualTo", function() { return lessThanOrEqualTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "greaterThan", function() { return greaterThan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "greaterThanOrEqualTo", function() { return greaterThanOrEqualTo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNull", function() { return isNull; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "between", function() { return between; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "like", function() { return like; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "during", function() { return during; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resourceId", function() { return resourceId; });
/* harmony import */ var _filter_And_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(236);
/* harmony import */ var _filter_Bbox_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(239);
/* harmony import */ var _filter_Contains_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(240);
/* harmony import */ var _filter_DWithin_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(242);
/* harmony import */ var _filter_Disjoint_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(243);
/* harmony import */ var _filter_During_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(244);
/* harmony import */ var _filter_EqualTo_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(246);
/* harmony import */ var _filter_GreaterThan_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(248);
/* harmony import */ var _filter_GreaterThanOrEqualTo_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(249);
/* harmony import */ var _filter_Intersects_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(250);
/* harmony import */ var _filter_IsBetween_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(251);
/* harmony import */ var _filter_IsLike_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(252);
/* harmony import */ var _filter_IsNull_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(253);
/* harmony import */ var _filter_LessThan_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(254);
/* harmony import */ var _filter_LessThanOrEqualTo_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(255);
/* harmony import */ var _filter_Not_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(256);
/* harmony import */ var _filter_NotEqualTo_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(257);
/* harmony import */ var _filter_Or_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(258);
/* harmony import */ var _filter_ResourceId_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(259);
/* harmony import */ var _filter_Within_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(260);
/**
 * @module ol/format/filter
 */




















/**
 * Create a logical `<And>` operator between two or more filter conditions.
 *
 * @param {...import("./filter/Filter.js").default} conditions Filter conditions.
 * @return {!And} `<And>` operator.
 * @api
 */
function and(conditions) {
    var params = [null].concat(Array.prototype.slice.call(arguments));
    return new (Function.prototype.bind.apply(_filter_And_js__WEBPACK_IMPORTED_MODULE_0__["default"], params))();
}
/**
 * Create a logical `<Or>` operator between two or more filter conditions.
 *
 * @param {...import("./filter/Filter.js").default} conditions Filter conditions.
 * @return {!Or} `<Or>` operator.
 * @api
 */
function or(conditions) {
    var params = [null].concat(Array.prototype.slice.call(arguments));
    return new (Function.prototype.bind.apply(_filter_Or_js__WEBPACK_IMPORTED_MODULE_17__["default"], params))();
}
/**
 * Represents a logical `<Not>` operator for a filter condition.
 *
 * @param {!import("./filter/Filter.js").default} condition Filter condition.
 * @return {!Not} `<Not>` operator.
 * @api
 */
function not(condition) {
    return new _filter_Not_js__WEBPACK_IMPORTED_MODULE_15__["default"](condition);
}
/**
 * Create a `<BBOX>` operator to test whether a geometry-valued property
 * intersects a fixed bounding box
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../extent.js").Extent} extent Extent.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!Bbox} `<BBOX>` operator.
 * @api
 */
function bbox(geometryName, extent, opt_srsName) {
    return new _filter_Bbox_js__WEBPACK_IMPORTED_MODULE_1__["default"](geometryName, extent, opt_srsName);
}
/**
 * Create a `<Contains>` operator to test whether a geometry-valued property
 * contains a given geometry.
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!Contains} `<Contains>` operator.
 * @api
 */
function contains(geometryName, geometry, opt_srsName) {
    return new _filter_Contains_js__WEBPACK_IMPORTED_MODULE_2__["default"](geometryName, geometry, opt_srsName);
}
/**
 * Create a `<Intersects>` operator to test whether a geometry-valued property
 * intersects a given geometry.
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!Intersects} `<Intersects>` operator.
 * @api
 */
function intersects(geometryName, geometry, opt_srsName) {
    return new _filter_Intersects_js__WEBPACK_IMPORTED_MODULE_9__["default"](geometryName, geometry, opt_srsName);
}
/**
 * Create a `<Disjoint>` operator to test whether a geometry-valued property
 * is disjoint to a given geometry.
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!Disjoint} `<Disjoint>` operator.
 * @api
 */
function disjoint(geometryName, geometry, opt_srsName) {
    return new _filter_Disjoint_js__WEBPACK_IMPORTED_MODULE_4__["default"](geometryName, geometry, opt_srsName);
}
/**
 * Create a `<Within>` operator to test whether a geometry-valued property
 * is within a given geometry.
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!Within} `<Within>` operator.
 * @api
 */
function within(geometryName, geometry, opt_srsName) {
    return new _filter_Within_js__WEBPACK_IMPORTED_MODULE_19__["default"](geometryName, geometry, opt_srsName);
}
/**
 * Create a `<DWithin>` operator to test whether a geometry-valued property
 * is within a distance to a given geometry.
 *
 * @param {!string} geometryName Geometry name to use.
 * @param {!import("../geom/Geometry.js").default} geometry Geometry.
 * @param {!number} distance Distance.
 * @param {!string} unit Unit.
 * @param {string} [opt_srsName] SRS name. No srsName attribute will be
 *    set on geometries when this is not provided.
 * @return {!DWithin} `<DWithin>` operator.
 * @api
 */
function dwithin(geometryName, geometry, distance, unit, opt_srsName) {
    return new _filter_DWithin_js__WEBPACK_IMPORTED_MODULE_3__["default"](geometryName, geometry, distance, unit, opt_srsName);
}
/**
 * Creates a `<PropertyIsEqualTo>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!(string|number)} expression The value to compare.
 * @param {boolean} [opt_matchCase] Case-sensitive?
 * @return {!EqualTo} `<PropertyIsEqualTo>` operator.
 * @api
 */
function equalTo(propertyName, expression, opt_matchCase) {
    return new _filter_EqualTo_js__WEBPACK_IMPORTED_MODULE_6__["default"](propertyName, expression, opt_matchCase);
}
/**
 * Creates a `<PropertyIsNotEqualTo>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!(string|number)} expression The value to compare.
 * @param {boolean} [opt_matchCase] Case-sensitive?
 * @return {!NotEqualTo} `<PropertyIsNotEqualTo>` operator.
 * @api
 */
function notEqualTo(propertyName, expression, opt_matchCase) {
    return new _filter_NotEqualTo_js__WEBPACK_IMPORTED_MODULE_16__["default"](propertyName, expression, opt_matchCase);
}
/**
 * Creates a `<PropertyIsLessThan>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!number} expression The value to compare.
 * @return {!LessThan} `<PropertyIsLessThan>` operator.
 * @api
 */
function lessThan(propertyName, expression) {
    return new _filter_LessThan_js__WEBPACK_IMPORTED_MODULE_13__["default"](propertyName, expression);
}
/**
 * Creates a `<PropertyIsLessThanOrEqualTo>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!number} expression The value to compare.
 * @return {!LessThanOrEqualTo} `<PropertyIsLessThanOrEqualTo>` operator.
 * @api
 */
function lessThanOrEqualTo(propertyName, expression) {
    return new _filter_LessThanOrEqualTo_js__WEBPACK_IMPORTED_MODULE_14__["default"](propertyName, expression);
}
/**
 * Creates a `<PropertyIsGreaterThan>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!number} expression The value to compare.
 * @return {!GreaterThan} `<PropertyIsGreaterThan>` operator.
 * @api
 */
function greaterThan(propertyName, expression) {
    return new _filter_GreaterThan_js__WEBPACK_IMPORTED_MODULE_7__["default"](propertyName, expression);
}
/**
 * Creates a `<PropertyIsGreaterThanOrEqualTo>` comparison operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!number} expression The value to compare.
 * @return {!GreaterThanOrEqualTo} `<PropertyIsGreaterThanOrEqualTo>` operator.
 * @api
 */
function greaterThanOrEqualTo(propertyName, expression) {
    return new _filter_GreaterThanOrEqualTo_js__WEBPACK_IMPORTED_MODULE_8__["default"](propertyName, expression);
}
/**
 * Creates a `<PropertyIsNull>` comparison operator to test whether a property value
 * is null.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @return {!IsNull} `<PropertyIsNull>` operator.
 * @api
 */
function isNull(propertyName) {
    return new _filter_IsNull_js__WEBPACK_IMPORTED_MODULE_12__["default"](propertyName);
}
/**
 * Creates a `<PropertyIsBetween>` comparison operator to test whether an expression
 * value lies within a range given by a lower and upper bound (inclusive).
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!number} lowerBoundary The lower bound of the range.
 * @param {!number} upperBoundary The upper bound of the range.
 * @return {!IsBetween} `<PropertyIsBetween>` operator.
 * @api
 */
function between(propertyName, lowerBoundary, upperBoundary) {
    return new _filter_IsBetween_js__WEBPACK_IMPORTED_MODULE_10__["default"](propertyName, lowerBoundary, upperBoundary);
}
/**
 * Represents a `<PropertyIsLike>` comparison operator that matches a string property
 * value against a text pattern.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!string} pattern Text pattern.
 * @param {string} [opt_wildCard] Pattern character which matches any sequence of
 *    zero or more string characters. Default is '*'.
 * @param {string} [opt_singleChar] pattern character which matches any single
 *    string character. Default is '.'.
 * @param {string} [opt_escapeChar] Escape character which can be used to escape
 *    the pattern characters. Default is '!'.
 * @param {boolean} [opt_matchCase] Case-sensitive?
 * @return {!IsLike} `<PropertyIsLike>` operator.
 * @api
 */
function like(propertyName, pattern, opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase) {
    return new _filter_IsLike_js__WEBPACK_IMPORTED_MODULE_11__["default"](propertyName, pattern, opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase);
}
/**
 * Create a `<During>` temporal operator.
 *
 * @param {!string} propertyName Name of the context property to compare.
 * @param {!string} begin The begin date in ISO-8601 format.
 * @param {!string} end The end date in ISO-8601 format.
 * @return {!During} `<During>` operator.
 * @api
 */
function during(propertyName, begin, end) {
    return new _filter_During_js__WEBPACK_IMPORTED_MODULE_5__["default"](propertyName, begin, end);
}
function resourceId(rid) {
    return new _filter_ResourceId_js__WEBPACK_IMPORTED_MODULE_18__["default"](rid);
}
//# sourceMappingURL=filter.js.map

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _LogicalNary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/And
 */

/**
 * @classdesc
 * Represents a logical `<And>` operator between two or more filter conditions.
 *
 * @abstract
 */
var And = /** @class */ (function (_super) {
    __extends(And, _super);
    /**
     * @param {...import("./Filter.js").default} conditions Conditions.
     */
    function And(conditions) {
        return _super.call(this, 'And', Array.prototype.slice.call(arguments)) || this;
    }
    return And;
}(_LogicalNary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (And);
//# sourceMappingURL=And.js.map

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/LogicalNary
 */


/**
 * @classdesc
 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
 * Base class for WFS GetFeature n-ary logical filters.
 *
 * @abstract
 */
var LogicalNary = /** @class */ (function (_super) {
    __extends(LogicalNary, _super);
    /**
     * @param {!string} tagName The XML tag name for this filter.
     * @param {Array<import("./Filter.js").default>} conditions Conditions.
     */
    function LogicalNary(tagName, conditions) {
        var _this = _super.call(this, tagName) || this;
        /**
         * @type {Array<import("./Filter.js").default>}
         */
        _this.conditions = conditions;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_1__["assert"])(_this.conditions.length >= 2, 57); // At least 2 conditions are required.
        return _this;
    }
    return LogicalNary;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LogicalNary);
//# sourceMappingURL=LogicalNary.js.map

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/format/filter/Filter
 */
/**
 * @classdesc
 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
 * Base class for WFS GetFeature filters.
 *
 * @abstract
 */
var Filter = /** @class */ (function () {
    /**
     * @param {!string} tagName The XML tag name for this filter.
     */
    function Filter(tagName) {
        /**
         * @private
         * @type {!string}
         */
        this.tagName_ = tagName;
    }
    /**
     * The XML tag name for a filter.
     * @return {!string} Name.
     */
    Filter.prototype.getTagName = function () {
        return this.tagName_;
    };
    return Filter;
}());
/* harmony default export */ __webpack_exports__["default"] = (Filter);
//# sourceMappingURL=Filter.js.map

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Bbox
 */

/**
 * @classdesc
 * Represents a `<BBOX>` operator to test whether a geometry-valued property
 * intersects a fixed bounding box
 *
 * @api
 */
var Bbox = /** @class */ (function (_super) {
    __extends(Bbox, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../extent.js").Extent} extent Extent.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be set
     * on geometries when this is not provided.
     */
    function Bbox(geometryName, extent, opt_srsName) {
        var _this = _super.call(this, 'BBOX') || this;
        /**
         * @type {!string}
         */
        _this.geometryName = geometryName;
        /**
         * @type {import("../../extent.js").Extent}
         */
        _this.extent = extent;
        if (extent.length !== 4) {
            throw new Error('Expected an extent with four values ([minX, minY, maxX, maxY])');
        }
        /**
         * @type {string|undefined}
         */
        _this.srsName = opt_srsName;
        return _this;
    }
    return Bbox;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Bbox);
//# sourceMappingURL=Bbox.js.map

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Spatial_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Contains
 */

/**
 * @classdesc
 * Represents a `<Contains>` operator to test whether a geometry-valued property
 * contains a given geometry.
 * @api
 */
var Contains = /** @class */ (function (_super) {
    __extends(Contains, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function Contains(geometryName, geometry, opt_srsName) {
        return _super.call(this, 'Contains', geometryName, geometry, opt_srsName) || this;
    }
    return Contains;
}(_Spatial_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Contains);
//# sourceMappingURL=Contains.js.map

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Spatial
 */

/**
 * @classdesc
 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
 * Represents a spatial operator to test whether a geometry-valued property
 * relates to a given geometry.
 *
 * @abstract
 */
var Spatial = /** @class */ (function (_super) {
    __extends(Spatial, _super);
    /**
     * @param {!string} tagName The XML tag name for this filter.
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function Spatial(tagName, geometryName, geometry, opt_srsName) {
        var _this = _super.call(this, tagName) || this;
        /**
         * @type {!string}
         */
        _this.geometryName = geometryName || 'the_geom';
        /**
         * @type {import("../../geom/Geometry.js").default}
         */
        _this.geometry = geometry;
        /**
         * @type {string|undefined}
         */
        _this.srsName = opt_srsName;
        return _this;
    }
    return Spatial;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Spatial);
//# sourceMappingURL=Spatial.js.map

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Spatial_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/DWithin
 */

/**
 * @classdesc
 * Represents a `<DWithin>` operator to test whether a geometry-valued property
 * is within a distance to a given geometry.
 * @api
 */
var DWithin = /** @class */ (function (_super) {
    __extends(DWithin, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {!number} distance Distance.
     * @param {!string} unit Unit.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function DWithin(geometryName, geometry, distance, unit, opt_srsName) {
        var _this = _super.call(this, 'DWithin', geometryName, geometry, opt_srsName) || this;
        /**
         * @public
         * @type {!number}
         */
        _this.distance = distance;
        /**
         * @public
         * @type {!string}
         */
        _this.unit = unit;
        return _this;
    }
    return DWithin;
}(_Spatial_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DWithin);
//# sourceMappingURL=DWithin.js.map

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Spatial_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Disjoint
 */

/**
 * @classdesc
 * Represents a `<Disjoint>` operator to test whether a geometry-valued property
 * is disjoint to a given geometry.
 * @api
 */
var Disjoint = /** @class */ (function (_super) {
    __extends(Disjoint, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function Disjoint(geometryName, geometry, opt_srsName) {
        return _super.call(this, 'Disjoint', geometryName, geometry, opt_srsName) || this;
    }
    return Disjoint;
}(_Spatial_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Disjoint);
//# sourceMappingURL=Disjoint.js.map

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Comparison_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/During
 */

/**
 * @classdesc
 * Represents a `<During>` comparison operator.
 * @api
 */
var During = /** @class */ (function (_super) {
    __extends(During, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!string} begin The begin date in ISO-8601 format.
     * @param {!string} end The end date in ISO-8601 format.
     */
    function During(propertyName, begin, end) {
        var _this = _super.call(this, 'During', propertyName) || this;
        /**
         * @type {!string}
         */
        _this.begin = begin;
        /**
         * @type {!string}
         */
        _this.end = end;
        return _this;
    }
    return During;
}(_Comparison_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (During);
//# sourceMappingURL=During.js.map

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Comparison
 */

/**
 * @classdesc
 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
 * Base class for WFS GetFeature property comparison filters.
 *
 * @abstract
 */
var Comparison = /** @class */ (function (_super) {
    __extends(Comparison, _super);
    /**
     * @param {!string} tagName The XML tag name for this filter.
     * @param {!string} propertyName Name of the context property to compare.
     */
    function Comparison(tagName, propertyName) {
        var _this = _super.call(this, tagName) || this;
        /**
         * @type {!string}
         */
        _this.propertyName = propertyName;
        return _this;
    }
    return Comparison;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Comparison);
//# sourceMappingURL=Comparison.js.map

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/EqualTo
 */

/**
 * @classdesc
 * Represents a `<PropertyIsEqualTo>` comparison operator.
 * @api
 */
var EqualTo = /** @class */ (function (_super) {
    __extends(EqualTo, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!(string|number)} expression The value to compare.
     * @param {boolean} [opt_matchCase] Case-sensitive?
     */
    function EqualTo(propertyName, expression, opt_matchCase) {
        return _super.call(this, 'PropertyIsEqualTo', propertyName, expression, opt_matchCase) || this;
    }
    return EqualTo;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (EqualTo);
//# sourceMappingURL=EqualTo.js.map

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Comparison_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/ComparisonBinary
 */

/**
 * @classdesc
 * Abstract class; normally only used for creating subclasses and not instantiated in apps.
 * Base class for WFS GetFeature property binary comparison filters.
 *
 * @abstract
 */
var ComparisonBinary = /** @class */ (function (_super) {
    __extends(ComparisonBinary, _super);
    /**
     * @param {!string} tagName The XML tag name for this filter.
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!(string|number)} expression The value to compare.
     * @param {boolean} [opt_matchCase] Case-sensitive?
     */
    function ComparisonBinary(tagName, propertyName, expression, opt_matchCase) {
        var _this = _super.call(this, tagName, propertyName) || this;
        /**
         * @type {!(string|number)}
         */
        _this.expression = expression;
        /**
         * @type {boolean|undefined}
         */
        _this.matchCase = opt_matchCase;
        return _this;
    }
    return ComparisonBinary;
}(_Comparison_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ComparisonBinary);
//# sourceMappingURL=ComparisonBinary.js.map

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/GreaterThan
 */

/**
 * @classdesc
 * Represents a `<PropertyIsGreaterThan>` comparison operator.
 * @api
 */
var GreaterThan = /** @class */ (function (_super) {
    __extends(GreaterThan, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} expression The value to compare.
     */
    function GreaterThan(propertyName, expression) {
        return _super.call(this, 'PropertyIsGreaterThan', propertyName, expression) || this;
    }
    return GreaterThan;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (GreaterThan);
//# sourceMappingURL=GreaterThan.js.map

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/GreaterThanOrEqualTo
 */

/**
 * @classdesc
 * Represents a `<PropertyIsGreaterThanOrEqualTo>` comparison operator.
 * @api
 */
var GreaterThanOrEqualTo = /** @class */ (function (_super) {
    __extends(GreaterThanOrEqualTo, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} expression The value to compare.
     */
    function GreaterThanOrEqualTo(propertyName, expression) {
        return _super.call(this, 'PropertyIsGreaterThanOrEqualTo', propertyName, expression) || this;
    }
    return GreaterThanOrEqualTo;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (GreaterThanOrEqualTo);
//# sourceMappingURL=GreaterThanOrEqualTo.js.map

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Spatial_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Intersects
 */

/**
 * @classdesc
 * Represents a `<Intersects>` operator to test whether a geometry-valued property
 * intersects a given geometry.
 * @api
 */
var Intersects = /** @class */ (function (_super) {
    __extends(Intersects, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function Intersects(geometryName, geometry, opt_srsName) {
        return _super.call(this, 'Intersects', geometryName, geometry, opt_srsName) || this;
    }
    return Intersects;
}(_Spatial_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Intersects);
//# sourceMappingURL=Intersects.js.map

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Comparison_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/IsBetween
 */

/**
 * @classdesc
 * Represents a `<PropertyIsBetween>` comparison operator.
 * @api
 */
var IsBetween = /** @class */ (function (_super) {
    __extends(IsBetween, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} lowerBoundary The lower bound of the range.
     * @param {!number} upperBoundary The upper bound of the range.
     */
    function IsBetween(propertyName, lowerBoundary, upperBoundary) {
        var _this = _super.call(this, 'PropertyIsBetween', propertyName) || this;
        /**
         * @type {!number}
         */
        _this.lowerBoundary = lowerBoundary;
        /**
         * @type {!number}
         */
        _this.upperBoundary = upperBoundary;
        return _this;
    }
    return IsBetween;
}(_Comparison_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (IsBetween);
//# sourceMappingURL=IsBetween.js.map

/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Comparison_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/IsLike
 */

/**
 * @classdesc
 * Represents a `<PropertyIsLike>` comparison operator.
 * @api
 */
var IsLike = /** @class */ (function (_super) {
    __extends(IsLike, _super);
    /**
     * [constructor description]
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!string} pattern Text pattern.
     * @param {string} [opt_wildCard] Pattern character which matches any sequence of
     *    zero or more string characters. Default is '*'.
     * @param {string} [opt_singleChar] pattern character which matches any single
     *    string character. Default is '.'.
     * @param {string} [opt_escapeChar] Escape character which can be used to escape
     *    the pattern characters. Default is '!'.
     * @param {boolean} [opt_matchCase] Case-sensitive?
     */
    function IsLike(propertyName, pattern, opt_wildCard, opt_singleChar, opt_escapeChar, opt_matchCase) {
        var _this = _super.call(this, 'PropertyIsLike', propertyName) || this;
        /**
         * @type {!string}
         */
        _this.pattern = pattern;
        /**
         * @type {!string}
         */
        _this.wildCard = opt_wildCard !== undefined ? opt_wildCard : '*';
        /**
         * @type {!string}
         */
        _this.singleChar = opt_singleChar !== undefined ? opt_singleChar : '.';
        /**
         * @type {!string}
         */
        _this.escapeChar = opt_escapeChar !== undefined ? opt_escapeChar : '!';
        /**
         * @type {boolean|undefined}
         */
        _this.matchCase = opt_matchCase;
        return _this;
    }
    return IsLike;
}(_Comparison_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (IsLike);
//# sourceMappingURL=IsLike.js.map

/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Comparison_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(245);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/IsNull
 */

/**
 * @classdesc
 * Represents a `<PropertyIsNull>` comparison operator.
 * @api
 */
var IsNull = /** @class */ (function (_super) {
    __extends(IsNull, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     */
    function IsNull(propertyName) {
        return _super.call(this, 'PropertyIsNull', propertyName) || this;
    }
    return IsNull;
}(_Comparison_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (IsNull);
//# sourceMappingURL=IsNull.js.map

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/LessThan
 */

/**
 * @classdesc
 * Represents a `<PropertyIsLessThan>` comparison operator.
 * @api
 */
var LessThan = /** @class */ (function (_super) {
    __extends(LessThan, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} expression The value to compare.
     */
    function LessThan(propertyName, expression) {
        return _super.call(this, 'PropertyIsLessThan', propertyName, expression) || this;
    }
    return LessThan;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LessThan);
//# sourceMappingURL=LessThan.js.map

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/LessThanOrEqualTo
 */

/**
 * @classdesc
 * Represents a `<PropertyIsLessThanOrEqualTo>` comparison operator.
 * @api
 */
var LessThanOrEqualTo = /** @class */ (function (_super) {
    __extends(LessThanOrEqualTo, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!number} expression The value to compare.
     */
    function LessThanOrEqualTo(propertyName, expression) {
        return _super.call(this, 'PropertyIsLessThanOrEqualTo', propertyName, expression) || this;
    }
    return LessThanOrEqualTo;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (LessThanOrEqualTo);
//# sourceMappingURL=LessThanOrEqualTo.js.map

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Not
 */

/**
 * @classdesc
 * Represents a logical `<Not>` operator for a filter condition.
 * @api
 */
var Not = /** @class */ (function (_super) {
    __extends(Not, _super);
    /**
     * @param {!import("./Filter.js").default} condition Filter condition.
     */
    function Not(condition) {
        var _this = _super.call(this, 'Not') || this;
        /**
         * @type {!import("./Filter.js").default}
         */
        _this.condition = condition;
        return _this;
    }
    return Not;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Not);
//# sourceMappingURL=Not.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(247);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/NotEqualTo
 */

/**
 * @classdesc
 * Represents a `<PropertyIsNotEqualTo>` comparison operator.
 * @api
 */
var NotEqualTo = /** @class */ (function (_super) {
    __extends(NotEqualTo, _super);
    /**
     * @param {!string} propertyName Name of the context property to compare.
     * @param {!(string|number)} expression The value to compare.
     * @param {boolean} [opt_matchCase] Case-sensitive?
     */
    function NotEqualTo(propertyName, expression, opt_matchCase) {
        return _super.call(this, 'PropertyIsNotEqualTo', propertyName, expression, opt_matchCase) || this;
    }
    return NotEqualTo;
}(_ComparisonBinary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (NotEqualTo);
//# sourceMappingURL=NotEqualTo.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _LogicalNary_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(237);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Or
 */

/**
 * @classdesc
 * Represents a logical `<Or>` operator between two ore more filter conditions.
 * @api
 */
var Or = /** @class */ (function (_super) {
    __extends(Or, _super);
    /**
     * @param {...import("./Filter.js").default} conditions Conditions.
     */
    function Or(conditions) {
        return _super.call(this, 'Or', Array.prototype.slice.call(arguments)) || this;
    }
    return Or;
}(_LogicalNary_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Or);
//# sourceMappingURL=Or.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Filter_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(238);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/ResourceId
 */

/**
 * @classdesc
 *
 * @abstract
 */
var ResourceId = /** @class */ (function (_super) {
    __extends(ResourceId, _super);
    /**
     * @param {!string} rid Resource ID.
     */
    function ResourceId(rid) {
        var _this = _super.call(this, 'ResourceId') || this;
        /**
         * @type {!string}
         */
        _this.rid = rid;
        return _this;
    }
    return ResourceId;
}(_Filter_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (ResourceId);
//# sourceMappingURL=ResourceId.js.map

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Spatial_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(241);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/filter/Within
 */

/**
 * @classdesc
 * Represents a `<Within>` operator to test whether a geometry-valued property
 * is within a given geometry.
 * @api
 */
var Within = /** @class */ (function (_super) {
    __extends(Within, _super);
    /**
     * @param {!string} geometryName Geometry name to use.
     * @param {!import("../../geom/Geometry.js").default} geometry Geometry.
     * @param {string} [opt_srsName] SRS name. No srsName attribute will be
     *    set on geometries when this is not provided.
     */
    function Within(geometryName, geometry, opt_srsName) {
        return _super.call(this, 'Within', geometryName, geometry, opt_srsName) || this;
    }
    return Within;
}(_Spatial_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Within);
//# sourceMappingURL=Within.js.map

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(211);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(103);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony import */ var _TextFeature_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(221);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(202);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/WKT
 */












/**
 * Geometry constructors
 * @enum {function (new:import("../geom/Geometry.js").default, Array, import("../geom/GeometryLayout.js").default)}
 */
var GeometryConstructor = {
    'POINT': _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__["default"],
    'LINESTRING': _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__["default"],
    'POLYGON': _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__["default"],
    'MULTIPOINT': _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__["default"],
    'MULTILINESTRING': _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__["default"],
    'MULTIPOLYGON': _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__["default"],
};
/**
 * @typedef {Object} Options
 * @property {boolean} [splitCollection=false] Whether to split GeometryCollections into
 * multiple features on reading.
 */
/**
 * @typedef {Object} Token
 * @property {number} type Type.
 * @property {number|string} [value] Value.
 * @property {number} position Position.
 */
/**
 * @const
 * @type {string}
 */
var EMPTY = 'EMPTY';
/**
 * @const
 * @type {string}
 */
var Z = 'Z';
/**
 * @const
 * @type {string}
 */
var M = 'M';
/**
 * @const
 * @type {string}
 */
var ZM = 'ZM';
/**
 * @const
 * @enum {number}
 */
var TokenType = {
    START: 0,
    TEXT: 1,
    LEFT_PAREN: 2,
    RIGHT_PAREN: 3,
    NUMBER: 4,
    COMMA: 5,
    EOF: 6,
};
/**
 * @const
 * @type {Object<string, string>}
 */
var WKTGeometryType = {};
for (var type in _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"]) {
    WKTGeometryType[type] = _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"][type].toUpperCase();
}
/**
 * Class to tokenize a WKT string.
 */
var Lexer = /** @class */ (function () {
    /**
     * @param {string} wkt WKT string.
     */
    function Lexer(wkt) {
        /**
         * @type {string}
         */
        this.wkt = wkt;
        /**
         * @type {number}
         * @private
         */
        this.index_ = -1;
    }
    /**
     * @param {string} c Character.
     * @return {boolean} Whether the character is alphabetic.
     * @private
     */
    Lexer.prototype.isAlpha_ = function (c) {
        return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z');
    };
    /**
     * @param {string} c Character.
     * @param {boolean} [opt_decimal] Whether the string number
     *     contains a dot, i.e. is a decimal number.
     * @return {boolean} Whether the character is numeric.
     * @private
     */
    Lexer.prototype.isNumeric_ = function (c, opt_decimal) {
        var decimal = opt_decimal !== undefined ? opt_decimal : false;
        return (c >= '0' && c <= '9') || (c == '.' && !decimal);
    };
    /**
     * @param {string} c Character.
     * @return {boolean} Whether the character is whitespace.
     * @private
     */
    Lexer.prototype.isWhiteSpace_ = function (c) {
        return c == ' ' || c == '\t' || c == '\r' || c == '\n';
    };
    /**
     * @return {string} Next string character.
     * @private
     */
    Lexer.prototype.nextChar_ = function () {
        return this.wkt.charAt(++this.index_);
    };
    /**
     * Fetch and return the next token.
     * @return {Token} Next string token.
     */
    Lexer.prototype.nextToken = function () {
        var c = this.nextChar_();
        var position = this.index_;
        /** @type {number|string} */
        var value = c;
        var type;
        if (c == '(') {
            type = TokenType.LEFT_PAREN;
        }
        else if (c == ',') {
            type = TokenType.COMMA;
        }
        else if (c == ')') {
            type = TokenType.RIGHT_PAREN;
        }
        else if (this.isNumeric_(c) || c == '-') {
            type = TokenType.NUMBER;
            value = this.readNumber_();
        }
        else if (this.isAlpha_(c)) {
            type = TokenType.TEXT;
            value = this.readText_();
        }
        else if (this.isWhiteSpace_(c)) {
            return this.nextToken();
        }
        else if (c === '') {
            type = TokenType.EOF;
        }
        else {
            throw new Error('Unexpected character: ' + c);
        }
        return { position: position, value: value, type: type };
    };
    /**
     * @return {number} Numeric token value.
     * @private
     */
    Lexer.prototype.readNumber_ = function () {
        var c;
        var index = this.index_;
        var decimal = false;
        var scientificNotation = false;
        do {
            if (c == '.') {
                decimal = true;
            }
            else if (c == 'e' || c == 'E') {
                scientificNotation = true;
            }
            c = this.nextChar_();
        } while (this.isNumeric_(c, decimal) ||
            // if we haven't detected a scientific number before, 'e' or 'E'
            // hint that we should continue to read
            (!scientificNotation && (c == 'e' || c == 'E')) ||
            // once we know that we have a scientific number, both '-' and '+'
            // are allowed
            (scientificNotation && (c == '-' || c == '+')));
        return parseFloat(this.wkt.substring(index, this.index_--));
    };
    /**
     * @return {string} String token value.
     * @private
     */
    Lexer.prototype.readText_ = function () {
        var c;
        var index = this.index_;
        do {
            c = this.nextChar_();
        } while (this.isAlpha_(c));
        return this.wkt.substring(index, this.index_--).toUpperCase();
    };
    return Lexer;
}());
/**
 * Class to parse the tokens from the WKT string.
 */
var Parser = /** @class */ (function () {
    /**
     * @param {Lexer} lexer The lexer.
     */
    function Parser(lexer) {
        /**
         * @type {Lexer}
         * @private
         */
        this.lexer_ = lexer;
        /**
         * @type {Token}
         * @private
         */
        this.token_ = {
            position: 0,
            type: TokenType.START,
        };
        /**
         * @type {import("../geom/GeometryLayout.js").default}
         * @private
         */
        this.layout_ = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY;
    }
    /**
     * Fetch the next token form the lexer and replace the active token.
     * @private
     */
    Parser.prototype.consume_ = function () {
        this.token_ = this.lexer_.nextToken();
    };
    /**
     * Tests if the given type matches the type of the current token.
     * @param {TokenType} type Token type.
     * @return {boolean} Whether the token matches the given type.
     */
    Parser.prototype.isTokenType = function (type) {
        return this.token_.type == type;
    };
    /**
     * If the given type matches the current token, consume it.
     * @param {TokenType} type Token type.
     * @return {boolean} Whether the token matches the given type.
     */
    Parser.prototype.match = function (type) {
        var isMatch = this.isTokenType(type);
        if (isMatch) {
            this.consume_();
        }
        return isMatch;
    };
    /**
     * Try to parse the tokens provided by the lexer.
     * @return {import("../geom/Geometry.js").default} The geometry.
     */
    Parser.prototype.parse = function () {
        this.consume_();
        return this.parseGeometry_();
    };
    /**
     * Try to parse the dimensional info.
     * @return {import("../geom/GeometryLayout.js").default} The layout.
     * @private
     */
    Parser.prototype.parseGeometryLayout_ = function () {
        var layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY;
        var dimToken = this.token_;
        if (this.isTokenType(TokenType.TEXT)) {
            var dimInfo = dimToken.value;
            if (dimInfo === Z) {
                layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZ;
            }
            else if (dimInfo === M) {
                layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYM;
            }
            else if (dimInfo === ZM) {
                layout = _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZM;
            }
            if (layout !== _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XY) {
                this.consume_();
            }
        }
        return layout;
    };
    /**
     * @return {Array<import("../geom/Geometry.js").default>} A collection of geometries.
     * @private
     */
    Parser.prototype.parseGeometryCollectionText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var geometries = [];
            do {
                geometries.push(this.parseGeometry_());
            } while (this.match(TokenType.COMMA));
            if (this.match(TokenType.RIGHT_PAREN)) {
                return geometries;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<number>} All values in a point.
     * @private
     */
    Parser.prototype.parsePointText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = this.parsePoint_();
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<number>>} All points in a linestring.
     * @private
     */
    Parser.prototype.parseLineStringText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = this.parsePointList_();
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<Array<number>>>} All points in a polygon.
     * @private
     */
    Parser.prototype.parsePolygonText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = this.parseLineStringTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<number>>} All points in a multipoint.
     * @private
     */
    Parser.prototype.parseMultiPointText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = void 0;
            if (this.token_.type == TokenType.LEFT_PAREN) {
                coordinates = this.parsePointTextList_();
            }
            else {
                coordinates = this.parsePointList_();
            }
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<Array<number>>>} All linestring points
     *                                          in a multilinestring.
     * @private
     */
    Parser.prototype.parseMultiLineStringText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = this.parseLineStringTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<Array<Array<number>>>>} All polygon points in a multipolygon.
     * @private
     */
    Parser.prototype.parseMultiPolygonText_ = function () {
        if (this.match(TokenType.LEFT_PAREN)) {
            var coordinates = this.parsePolygonTextList_();
            if (this.match(TokenType.RIGHT_PAREN)) {
                return coordinates;
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<number>} A point.
     * @private
     */
    Parser.prototype.parsePoint_ = function () {
        var coordinates = [];
        var dimensions = this.layout_.length;
        for (var i = 0; i < dimensions; ++i) {
            var token = this.token_;
            if (this.match(TokenType.NUMBER)) {
                coordinates.push(/** @type {number} */ (token.value));
            }
            else {
                break;
            }
        }
        if (coordinates.length == dimensions) {
            return coordinates;
        }
        throw new Error(this.formatErrorMessage_());
    };
    /**
     * @return {Array<Array<number>>} An array of points.
     * @private
     */
    Parser.prototype.parsePointList_ = function () {
        var coordinates = [this.parsePoint_()];
        while (this.match(TokenType.COMMA)) {
            coordinates.push(this.parsePoint_());
        }
        return coordinates;
    };
    /**
     * @return {Array<Array<number>>} An array of points.
     * @private
     */
    Parser.prototype.parsePointTextList_ = function () {
        var coordinates = [this.parsePointText_()];
        while (this.match(TokenType.COMMA)) {
            coordinates.push(this.parsePointText_());
        }
        return coordinates;
    };
    /**
     * @return {Array<Array<Array<number>>>} An array of points.
     * @private
     */
    Parser.prototype.parseLineStringTextList_ = function () {
        var coordinates = [this.parseLineStringText_()];
        while (this.match(TokenType.COMMA)) {
            coordinates.push(this.parseLineStringText_());
        }
        return coordinates;
    };
    /**
     * @return {Array<Array<Array<Array<number>>>>} An array of points.
     * @private
     */
    Parser.prototype.parsePolygonTextList_ = function () {
        var coordinates = [this.parsePolygonText_()];
        while (this.match(TokenType.COMMA)) {
            coordinates.push(this.parsePolygonText_());
        }
        return coordinates;
    };
    /**
     * @return {boolean} Whether the token implies an empty geometry.
     * @private
     */
    Parser.prototype.isEmptyGeometry_ = function () {
        var isEmpty = this.isTokenType(TokenType.TEXT) && this.token_.value == EMPTY;
        if (isEmpty) {
            this.consume_();
        }
        return isEmpty;
    };
    /**
     * Create an error message for an unexpected token error.
     * @return {string} Error message.
     * @private
     */
    Parser.prototype.formatErrorMessage_ = function () {
        return ('Unexpected `' +
            this.token_.value +
            '` at position ' +
            this.token_.position +
            ' in `' +
            this.lexer_.wkt +
            '`');
    };
    /**
     * @return {import("../geom/Geometry.js").default} The geometry.
     * @private
     */
    Parser.prototype.parseGeometry_ = function () {
        var token = this.token_;
        if (this.match(TokenType.TEXT)) {
            var geomType = /** @type {string} */ (token.value);
            this.layout_ = this.parseGeometryLayout_();
            var isEmpty = this.isEmptyGeometry_();
            if (geomType == 'GEOMETRYCOLLECTION') {
                if (isEmpty) {
                    return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__["default"]([]);
                }
                var geometries = this.parseGeometryCollectionText_();
                return new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__["default"](geometries);
            }
            else {
                var ctor = GeometryConstructor[geomType];
                if (!ctor) {
                    throw new Error('Invalid geometry type: ' + geomType);
                }
                var coordinates = void 0;
                if (isEmpty) {
                    if (geomType == 'POINT') {
                        coordinates = [NaN, NaN];
                    }
                    else {
                        coordinates = [];
                    }
                }
                else {
                    switch (geomType) {
                        case 'POINT': {
                            coordinates = this.parsePointText_();
                            break;
                        }
                        case 'LINESTRING': {
                            coordinates = this.parseLineStringText_();
                            break;
                        }
                        case 'POLYGON': {
                            coordinates = this.parsePolygonText_();
                            break;
                        }
                        case 'MULTIPOINT': {
                            coordinates = this.parseMultiPointText_();
                            break;
                        }
                        case 'MULTILINESTRING': {
                            coordinates = this.parseMultiLineStringText_();
                            break;
                        }
                        case 'MULTIPOLYGON': {
                            coordinates = this.parseMultiPolygonText_();
                            break;
                        }
                        default:
                            break;
                    }
                }
                return new ctor(coordinates, this.layout_);
            }
        }
        throw new Error(this.formatErrorMessage_());
    };
    return Parser;
}());
/**
 * @classdesc
 * Geometry format for reading and writing data in the `WellKnownText` (WKT)
 * format.
 *
 * @api
 */
var WKT = /** @class */ (function (_super) {
    __extends(WKT, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function WKT(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * Split GeometryCollection into multiple features.
         * @type {boolean}
         * @private
         */
        _this.splitCollection_ =
            options.splitCollection !== undefined ? options.splitCollection : false;
        return _this;
    }
    /**
     * Parse a WKT string.
     * @param {string} wkt WKT string.
     * @return {import("../geom/Geometry.js").default}
     *     The geometry created.
     * @private
     */
    WKT.prototype.parse_ = function (wkt) {
        var lexer = new Lexer(wkt);
        var parser = new Parser(lexer);
        return parser.parse();
    };
    /**
     * @protected
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @return {import("../Feature.js").default} Feature.
     */
    WKT.prototype.readFeatureFromText = function (text, opt_options) {
        var geom = this.readGeometryFromText(text, opt_options);
        var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        feature.setGeometry(geom);
        return feature;
    };
    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {Array<Feature>} Features.
     */
    WKT.prototype.readFeaturesFromText = function (text, opt_options) {
        var geometries = [];
        var geometry = this.readGeometryFromText(text, opt_options);
        if (this.splitCollection_ &&
            geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].GEOMETRY_COLLECTION) {
            geometries = /** @type {GeometryCollection} */ (geometry).getGeometriesArray();
        }
        else {
            geometries = [geometry];
        }
        var features = [];
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            var feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
            feature.setGeometry(geometries[i]);
            features.push(feature);
        }
        return features;
    };
    /**
     * @param {string} text Text.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Read options.
     * @protected
     * @return {import("../geom/Geometry.js").default} Geometry.
     */
    WKT.prototype.readGeometryFromText = function (text, opt_options) {
        var geometry = this.parse_(text);
        return Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, false, opt_options);
    };
    /**
     * @param {import("../Feature.js").default} feature Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    WKT.prototype.writeFeatureText = function (feature, opt_options) {
        var geometry = feature.getGeometry();
        if (geometry) {
            return this.writeGeometryText(geometry, opt_options);
        }
        return '';
    };
    /**
     * @param {Array<import("../Feature.js").default>} features Features.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    WKT.prototype.writeFeaturesText = function (features, opt_options) {
        if (features.length == 1) {
            return this.writeFeatureText(features[0], opt_options);
        }
        var geometries = [];
        for (var i = 0, ii = features.length; i < ii; ++i) {
            geometries.push(features[i].getGeometry());
        }
        var collection = new _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_1__["default"](geometries);
        return this.writeGeometryText(collection, opt_options);
    };
    /**
     * @param {import("../geom/Geometry.js").default} geometry Geometry.
     * @param {import("./Feature.js").WriteOptions} [opt_options] Write options.
     * @protected
     * @return {string} Text.
     */
    WKT.prototype.writeGeometryText = function (geometry, opt_options) {
        return encode(Object(_Feature_js__WEBPACK_IMPORTED_MODULE_11__["transformGeometryWithOptions"])(geometry, true, opt_options));
    };
    return WKT;
}(_TextFeature_js__WEBPACK_IMPORTED_MODULE_10__["default"]));
/**
 * @param {Point} geom Point geometry.
 * @return {string} Coordinates part of Point as WKT.
 */
function encodePointGeometry(geom) {
    var coordinates = geom.getCoordinates();
    if (coordinates.length === 0) {
        return '';
    }
    return coordinates.join(' ');
}
/**
 * @param {MultiPoint} geom MultiPoint geometry.
 * @return {string} Coordinates part of MultiPoint as WKT.
 */
function encodeMultiPointGeometry(geom) {
    var array = [];
    var components = geom.getPoints();
    for (var i = 0, ii = components.length; i < ii; ++i) {
        array.push('(' + encodePointGeometry(components[i]) + ')');
    }
    return array.join(',');
}
/**
 * @param {GeometryCollection} geom GeometryCollection geometry.
 * @return {string} Coordinates part of GeometryCollection as WKT.
 */
function encodeGeometryCollectionGeometry(geom) {
    var array = [];
    var geoms = geom.getGeometries();
    for (var i = 0, ii = geoms.length; i < ii; ++i) {
        array.push(encode(geoms[i]));
    }
    return array.join(',');
}
/**
 * @param {LineString|import("../geom/LinearRing.js").default} geom LineString geometry.
 * @return {string} Coordinates part of LineString as WKT.
 */
function encodeLineStringGeometry(geom) {
    var coordinates = geom.getCoordinates();
    var array = [];
    for (var i = 0, ii = coordinates.length; i < ii; ++i) {
        array.push(coordinates[i].join(' '));
    }
    return array.join(',');
}
/**
 * @param {MultiLineString} geom MultiLineString geometry.
 * @return {string} Coordinates part of MultiLineString as WKT.
 */
function encodeMultiLineStringGeometry(geom) {
    var array = [];
    var components = geom.getLineStrings();
    for (var i = 0, ii = components.length; i < ii; ++i) {
        array.push('(' + encodeLineStringGeometry(components[i]) + ')');
    }
    return array.join(',');
}
/**
 * @param {Polygon} geom Polygon geometry.
 * @return {string} Coordinates part of Polygon as WKT.
 */
function encodePolygonGeometry(geom) {
    var array = [];
    var rings = geom.getLinearRings();
    for (var i = 0, ii = rings.length; i < ii; ++i) {
        array.push('(' + encodeLineStringGeometry(rings[i]) + ')');
    }
    return array.join(',');
}
/**
 * @param {MultiPolygon} geom MultiPolygon geometry.
 * @return {string} Coordinates part of MultiPolygon as WKT.
 */
function encodeMultiPolygonGeometry(geom) {
    var array = [];
    var components = geom.getPolygons();
    for (var i = 0, ii = components.length; i < ii; ++i) {
        array.push('(' + encodePolygonGeometry(components[i]) + ')');
    }
    return array.join(',');
}
/**
 * @param {import("../geom/SimpleGeometry.js").default} geom SimpleGeometry geometry.
 * @return {string} Potential dimensional information for WKT type.
 */
function encodeGeometryLayout(geom) {
    var layout = geom.getLayout();
    var dimInfo = '';
    if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZ || layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZM) {
        dimInfo += Z;
    }
    if (layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYM || layout === _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_2__["default"].XYZM) {
        dimInfo += M;
    }
    return dimInfo;
}
/**
 * @const
 * @type {Object<string, function(import("../geom/Geometry.js").default): string>}
 */
var GeometryEncoder = {
    'Point': encodePointGeometry,
    'LineString': encodeLineStringGeometry,
    'Polygon': encodePolygonGeometry,
    'MultiPoint': encodeMultiPointGeometry,
    'MultiLineString': encodeMultiLineStringGeometry,
    'MultiPolygon': encodeMultiPolygonGeometry,
    'GeometryCollection': encodeGeometryCollectionGeometry,
};
/**
 * Encode a geometry as WKT.
 * @param {import("../geom/Geometry.js").default} geom The geometry to encode.
 * @return {string} WKT string for the geometry.
 */
function encode(geom) {
    var type = geom.getType();
    var geometryEncoder = GeometryEncoder[type];
    var enc = geometryEncoder(geom);
    type = type.toUpperCase();
    if (typeof ( /** @type {?} */(geom).getFlatCoordinates) === 'function') {
        var dimInfo = encodeGeometryLayout(
        /** @type {import("../geom/SimpleGeometry.js").default} */ (geom));
        if (dimInfo.length > 0) {
            type += ' ' + dimInfo;
        }
    }
    if (enc.length === 0) {
        return type + ' ' + EMPTY;
    }
    return type + '(' + enc + ')';
}
/* harmony default export */ __webpack_exports__["default"] = (WKT);
//# sourceMappingURL=WKT.js.map

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _XML_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(228);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(217);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(218);
/* harmony import */ var _xlink_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(229);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/WMSCapabilities
 */




/**
 * @const
 * @type {Array<null|string>}
 */
var NAMESPACE_URIS = [null, 'http://www.opengis.net/wms'];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Service': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readService),
    'Capability': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readCapability),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CAPABILITY_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Request': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readRequest),
    'Exception': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readException),
    'Layer': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readCapabilityLayer),
});
/**
 * @classdesc
 * Format for reading WMS capabilities data
 *
 * @api
 */
var WMSCapabilities = /** @class */ (function (_super) {
    __extends(WMSCapabilities, _super);
    function WMSCapabilities() {
        var _this = _super.call(this) || this;
        /**
         * @type {string|undefined}
         */
        _this.version = undefined;
        return _this;
    }
    /**
     * @param {Element} node Node.
     * @return {Object} Object
     */
    WMSCapabilities.prototype.readFromNode = function (node) {
        this.version = node.getAttribute('version').trim();
        var wmsCapabilityObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({
            'version': this.version,
        }, PARSERS, node, []);
        return wmsCapabilityObject ? wmsCapabilityObject : null;
    };
    return WMSCapabilities;
}(_XML_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var SERVICE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Abstract': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'KeywordList': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readKeywordList),
    'OnlineResource': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xlink_js__WEBPACK_IMPORTED_MODULE_3__["readHref"]),
    'ContactInformation': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readContactInformation),
    'Fees': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'AccessConstraints': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'LayerLimit': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeInteger"]),
    'MaxWidth': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeInteger"]),
    'MaxHeight': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeInteger"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONTACT_INFORMATION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'ContactPersonPrimary': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readContactPersonPrimary),
    'ContactPosition': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'ContactAddress': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readContactAddress),
    'ContactVoiceTelephone': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'ContactFacsimileTelephone': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'ContactElectronicMailAddress': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONTACT_PERSON_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'ContactPerson': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'ContactOrganization': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONTACT_ADDRESS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'AddressType': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Address': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'City': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'StateOrProvince': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'PostCode': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Country': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var EXCEPTION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Format': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeArrayPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LAYER_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Abstract': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'KeywordList': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readKeywordList),
    'CRS': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'EX_GeographicBoundingBox': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readEXGeographicBoundingBox),
    'BoundingBox': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readBoundingBox),
    'Dimension': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readDimension),
    'Attribution': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readAttribution),
    'AuthorityURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readAuthorityURL),
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'MetadataURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readMetadataURL),
    'DataURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readFormatOnlineresource),
    'FeatureListURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readFormatOnlineresource),
    'Style': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readStyle),
    'MinScaleDenominator': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
    'MaxScaleDenominator': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
    'Layer': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readLayer),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var ATTRIBUTION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'OnlineResource': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xlink_js__WEBPACK_IMPORTED_MODULE_3__["readHref"]),
    'LogoURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readSizedFormatOnlineresource),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var EX_GEOGRAPHIC_BOUNDING_BOX_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'westBoundLongitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
    'eastBoundLongitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
    'southBoundLatitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
    'northBoundLatitude': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimal"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var REQUEST_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'GetCapabilities': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readOperationType),
    'GetMap': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readOperationType),
    'GetFeatureInfo': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readOperationType),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var OPERATIONTYPE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Format': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'DCPType': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readDCPType),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var DCPTYPE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'HTTP': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readHTTP),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var HTTP_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Get': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readFormatOnlineresource),
    'Post': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readFormatOnlineresource),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Name': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'Abstract': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'LegendURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertyPusher"])(readSizedFormatOnlineresource),
    'StyleSheetURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readFormatOnlineresource),
    'StyleURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(readFormatOnlineresource),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var FORMAT_ONLINERESOURCE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Format': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
    'OnlineResource': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeObjectPropertySetter"])(_xlink_js__WEBPACK_IMPORTED_MODULE_3__["readHref"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var KEYWORDLIST_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeStructureNS"])(NAMESPACE_URIS, {
    'Keyword': Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["makeArrayPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"]),
});
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Attribution object.
 */
function readAttribution(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, ATTRIBUTION_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object} Bounding box object.
 */
function readBoundingBox(node, objectStack) {
    var extent = [
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('minx')),
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('miny')),
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('maxx')),
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('maxy')),
    ];
    var resolutions = [
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('resx')),
        Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('resy')),
    ];
    return {
        'crs': node.getAttribute('CRS'),
        'extent': extent,
        'res': resolutions,
    };
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {import("../extent.js").Extent|undefined} Bounding box object.
 */
function readEXGeographicBoundingBox(node, objectStack) {
    var geographicBoundingBox = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, EX_GEOGRAPHIC_BOUNDING_BOX_PARSERS, node, objectStack);
    if (!geographicBoundingBox) {
        return undefined;
    }
    var westBoundLongitude = 
    /** @type {number|undefined} */
    (geographicBoundingBox['westBoundLongitude']);
    var southBoundLatitude = 
    /** @type {number|undefined} */
    (geographicBoundingBox['southBoundLatitude']);
    var eastBoundLongitude = 
    /** @type {number|undefined} */
    (geographicBoundingBox['eastBoundLongitude']);
    var northBoundLatitude = 
    /** @type {number|undefined} */
    (geographicBoundingBox['northBoundLatitude']);
    if (westBoundLongitude === undefined ||
        southBoundLatitude === undefined ||
        eastBoundLongitude === undefined ||
        northBoundLatitude === undefined) {
        return undefined;
    }
    return [
        westBoundLongitude,
        southBoundLatitude,
        eastBoundLongitude,
        northBoundLatitude,
    ];
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Capability object.
 */
function readCapability(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, CAPABILITY_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Service object.
 */
function readService(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, SERVICE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Contact information object.
 */
function readContactInformation(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, CONTACT_INFORMATION_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Contact person object.
 */
function readContactPersonPrimary(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, CONTACT_PERSON_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Contact address object.
 */
function readContactAddress(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, CONTACT_ADDRESS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<string>|undefined} Format array.
 */
function readException(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])([], EXCEPTION_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Layer object.
 */
function readCapabilityLayer(node, objectStack) {
    var layerObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, LAYER_PARSERS, node, objectStack);
    if (layerObject['Layer'] === undefined) {
        return Object.assign(layerObject, readLayer(node, objectStack));
    }
    return layerObject;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Layer object.
 */
function readLayer(node, objectStack) {
    var parentLayerObject = /**  @type {!Object<string,*>} */ (objectStack[objectStack.length - 1]);
    var layerObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, LAYER_PARSERS, node, objectStack);
    if (!layerObject) {
        return undefined;
    }
    var queryable = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('queryable'));
    if (queryable === undefined) {
        queryable = parentLayerObject['queryable'];
    }
    layerObject['queryable'] = queryable !== undefined ? queryable : false;
    var cascaded = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeIntegerString"])(node.getAttribute('cascaded'));
    if (cascaded === undefined) {
        cascaded = parentLayerObject['cascaded'];
    }
    layerObject['cascaded'] = cascaded;
    var opaque = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('opaque'));
    if (opaque === undefined) {
        opaque = parentLayerObject['opaque'];
    }
    layerObject['opaque'] = opaque !== undefined ? opaque : false;
    var noSubsets = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('noSubsets'));
    if (noSubsets === undefined) {
        noSubsets = parentLayerObject['noSubsets'];
    }
    layerObject['noSubsets'] = noSubsets !== undefined ? noSubsets : false;
    var fixedWidth = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('fixedWidth'));
    if (!fixedWidth) {
        fixedWidth = parentLayerObject['fixedWidth'];
    }
    layerObject['fixedWidth'] = fixedWidth;
    var fixedHeight = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readDecimalString"])(node.getAttribute('fixedHeight'));
    if (!fixedHeight) {
        fixedHeight = parentLayerObject['fixedHeight'];
    }
    layerObject['fixedHeight'] = fixedHeight;
    // See 7.2.4.8
    var addKeys = ['Style', 'CRS', 'AuthorityURL'];
    addKeys.forEach(function (key) {
        if (key in parentLayerObject) {
            var childValue = layerObject[key] || [];
            layerObject[key] = childValue.concat(parentLayerObject[key]);
        }
    });
    var replaceKeys = [
        'EX_GeographicBoundingBox',
        'BoundingBox',
        'Dimension',
        'Attribution',
        'MinScaleDenominator',
        'MaxScaleDenominator',
    ];
    replaceKeys.forEach(function (key) {
        if (!(key in layerObject)) {
            var parentValue = parentLayerObject[key];
            layerObject[key] = parentValue;
        }
    });
    return layerObject;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object} Dimension object.
 */
function readDimension(node, objectStack) {
    var dimensionObject = {
        'name': node.getAttribute('name'),
        'units': node.getAttribute('units'),
        'unitSymbol': node.getAttribute('unitSymbol'),
        'default': node.getAttribute('default'),
        'multipleValues': Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('multipleValues')),
        'nearestValue': Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('nearestValue')),
        'current': Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readBooleanString"])(node.getAttribute('current')),
        'values': Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readString"])(node),
    };
    return dimensionObject;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Online resource object.
 */
function readFormatOnlineresource(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, FORMAT_ONLINERESOURCE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Request object.
 */
function readRequest(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, REQUEST_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} DCP type object.
 */
function readDCPType(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, DCPTYPE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} HTTP object.
 */
function readHTTP(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, HTTP_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Operation type object.
 */
function readOperationType(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, OPERATIONTYPE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Online resource object.
 */
function readSizedFormatOnlineresource(node, objectStack) {
    var formatOnlineresource = readFormatOnlineresource(node, objectStack);
    if (formatOnlineresource) {
        var size = [
            Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeIntegerString"])(node.getAttribute('width')),
            Object(_xsd_js__WEBPACK_IMPORTED_MODULE_2__["readNonNegativeIntegerString"])(node.getAttribute('height')),
        ];
        formatOnlineresource['size'] = size;
        return formatOnlineresource;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Authority URL object.
 */
function readAuthorityURL(node, objectStack) {
    var authorityObject = readFormatOnlineresource(node, objectStack);
    if (authorityObject) {
        authorityObject['name'] = node.getAttribute('name');
        return authorityObject;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Metadata URL object.
 */
function readMetadataURL(node, objectStack) {
    var metadataObject = readFormatOnlineresource(node, objectStack);
    if (metadataObject) {
        metadataObject['type'] = node.getAttribute('type');
        return metadataObject;
    }
    return undefined;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Style object.
 */
function readStyle(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])({}, STYLE_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Array<string>|undefined} Keyword list.
 */
function readKeywordList(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_1__["pushParseAndPop"])([], KEYWORDLIST_PARSERS, node, objectStack);
}
/* harmony default export */ __webpack_exports__["default"] = (WMSCapabilities);
//# sourceMappingURL=WMSCapabilities.js.map

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GML2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(214);
/* harmony import */ var _XMLFeature_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(216);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(52);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(217);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/WMSGetFeatureInfo
 */





/**
 * @typedef {Object} Options
 * @property {Array<string>} [layers] If set, only features of the given layers will be returned by the format when read.
 */
/**
 * @const
 * @type {string}
 */
var featureIdentifier = '_feature';
/**
 * @const
 * @type {string}
 */
var layerIdentifier = '_layer';
/**
 * @classdesc
 * Format for reading WMSGetFeatureInfo format. It uses
 * {@link module:ol/format/GML2~GML2} to read features.
 *
 * @api
 */
var WMSGetFeatureInfo = /** @class */ (function (_super) {
    __extends(WMSGetFeatureInfo, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function WMSGetFeatureInfo(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {string}
         */
        _this.featureNS_ = 'http://mapserver.gis.umn.edu/mapserver';
        /**
         * @private
         * @type {GML2}
         */
        _this.gmlFormat_ = new _GML2_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        /**
         * @private
         * @type {Array<string>}
         */
        _this.layers_ = options.layers ? options.layers : null;
        return _this;
    }
    /**
     * @return {Array<string>} layers
     */
    WMSGetFeatureInfo.prototype.getLayers = function () {
        return this.layers_;
    };
    /**
     * @param {Array<string>} layers Layers to parse.
     */
    WMSGetFeatureInfo.prototype.setLayers = function (layers) {
        this.layers_ = layers;
    };
    /**
     * @param {Element} node Node.
     * @param {Array<*>} objectStack Object stack.
     * @return {Array<import("../Feature.js").default>} Features.
     * @private
     */
    WMSGetFeatureInfo.prototype.readFeatures_ = function (node, objectStack) {
        node.setAttribute('namespaceURI', this.featureNS_);
        var localName = node.localName;
        /** @type {Array<import("../Feature.js").default>} */
        var features = [];
        if (node.childNodes.length === 0) {
            return features;
        }
        if (localName == 'msGMLOutput') {
            for (var i = 0, ii = node.childNodes.length; i < ii; i++) {
                var layer = node.childNodes[i];
                if (layer.nodeType !== Node.ELEMENT_NODE) {
                    continue;
                }
                var layerElement = /** @type {Element} */ (layer);
                var context = objectStack[0];
                var toRemove = layerIdentifier;
                var layerName = layerElement.localName.replace(toRemove, '');
                if (this.layers_ && !Object(_array_js__WEBPACK_IMPORTED_MODULE_3__["includes"])(this.layers_, layerName)) {
                    continue;
                }
                var featureType = layerName + featureIdentifier;
                context['featureType'] = featureType;
                context['featureNS'] = this.featureNS_;
                /** @type {Object<string, import("../xml.js").Parser>} */
                var parsers = {};
                parsers[featureType] = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["makeArrayPusher"])(this.gmlFormat_.readFeatureElement, this.gmlFormat_);
                var parsersNS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["makeStructureNS"])([context['featureNS'], null], parsers);
                layerElement.setAttribute('namespaceURI', this.featureNS_);
                var layerFeatures = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["pushParseAndPop"])([], 
                // @ts-ignore
                parsersNS, layerElement, objectStack, this.gmlFormat_);
                if (layerFeatures) {
                    Object(_array_js__WEBPACK_IMPORTED_MODULE_3__["extend"])(features, layerFeatures);
                }
            }
        }
        if (localName == 'FeatureCollection') {
            var gmlFeatures = Object(_xml_js__WEBPACK_IMPORTED_MODULE_4__["pushParseAndPop"])([], this.gmlFormat_.FEATURE_COLLECTION_PARSERS, node, [{}], this.gmlFormat_);
            if (gmlFeatures) {
                features = gmlFeatures;
            }
        }
        return features;
    };
    /**
     * @protected
     * @param {Element} node Node.
     * @param {import("./Feature.js").ReadOptions} [opt_options] Options.
     * @return {Array<import("../Feature.js").default>} Features.
     */
    WMSGetFeatureInfo.prototype.readFeaturesFromNode = function (node, opt_options) {
        var options = {};
        if (opt_options) {
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])(options, this.getReadOptions(node, opt_options));
        }
        return this.readFeatures_(node, [options]);
    };
    return WMSGetFeatureInfo;
}(_XMLFeature_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (WMSGetFeatureInfo);
//# sourceMappingURL=WMSGetFeatureInfo.js.map

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _OWS_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(227);
/* harmony import */ var _XML_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(228);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _xml_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(217);
/* harmony import */ var _xsd_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(218);
/* harmony import */ var _xlink_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(229);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/format/WMTSCapabilities
 */






/**
 * @const
 * @type {Array<null|string>}
 */
var NAMESPACE_URIS = [null, 'http://www.opengis.net/wmts/1.0'];
/**
 * @const
 * @type {Array<null|string>}
 */
var OWS_NAMESPACE_URIS = [null, 'http://www.opengis.net/ows/1.1'];
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'Contents': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(readContents),
});
/**
 * @classdesc
 * Format for reading WMTS capabilities data.
 *
 * @api
 */
var WMTSCapabilities = /** @class */ (function (_super) {
    __extends(WMTSCapabilities, _super);
    function WMTSCapabilities() {
        var _this = _super.call(this) || this;
        /**
         * @type {OWS}
         * @private
         */
        _this.owsParser_ = new _OWS_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        return _this;
    }
    /**
     * @param {Element} node Node.
     * @return {Object} Object
     */
    WMTSCapabilities.prototype.readFromNode = function (node) {
        var version = node.getAttribute('version');
        if (version) {
            version = version.trim();
        }
        var WMTSCapabilityObject = this.owsParser_.readFromNode(node);
        if (!WMTSCapabilityObject) {
            return null;
        }
        WMTSCapabilityObject['version'] = version;
        WMTSCapabilityObject = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])(WMTSCapabilityObject, PARSERS, node, []);
        return WMTSCapabilityObject ? WMTSCapabilityObject : null;
    };
    return WMTSCapabilities;
}(_XML_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var CONTENTS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'Layer': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readLayer),
    'TileMatrixSet': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readTileMatrixSet),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var LAYER_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'Style': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readStyle),
    'Format': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'TileMatrixSetLink': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readTileMatrixSetLink),
    'Dimension': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readDimensions),
    'ResourceURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readResourceUrl),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'Abstract': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'WGS84BoundingBox': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(readBoundingBox),
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var STYLE_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'LegendURL': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readLegendUrl),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'Title': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TMS_LINKS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'TileMatrixSet': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'TileMatrixSetLimits': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(readTileMatrixLimitsList),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TMS_LIMITS_LIST_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'TileMatrixLimits': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(readTileMatrixLimits),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TMS_LIMITS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'TileMatrix': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'MinTileRow': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'MaxTileRow': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'MinTileCol': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'MaxTileCol': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var DIMENSION_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'Default': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'Value': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var WGS84_BBOX_READERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'LowerCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(readCoordinates),
    'UpperCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeArrayPusher"])(readCoordinates),
});
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TMS_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'WellKnownScaleSet': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'TileMatrix': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertyPusher"])(readTileMatrix),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'SupportedCRS': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
    'BoundingBox': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(readBoundingBox),
}));
/**
 * @const
 * @type {Object<string, Object<string, import("../xml.js").Parser>>}
 */
// @ts-ignore
var TM_PARSERS = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(NAMESPACE_URIS, {
    'TopLeftCorner': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(readCoordinates),
    'ScaleDenominator': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readDecimal"]),
    'TileWidth': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'TileHeight': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'MatrixWidth': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
    'MatrixHeight': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readNonNegativeInteger"]),
}, Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeStructureNS"])(OWS_NAMESPACE_URIS, {
    'Identifier': Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["makeObjectPropertySetter"])(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"]),
}));
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Attribution object.
 */
function readContents(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, CONTENTS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Layers object.
 */
function readLayer(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, LAYER_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Tile Matrix Set object.
 */
function readTileMatrixSet(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, TMS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Style object.
 */
function readStyle(node, objectStack) {
    var style = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, STYLE_PARSERS, node, objectStack);
    if (!style) {
        return undefined;
    }
    var isDefault = node.getAttribute('isDefault') === 'true';
    style['isDefault'] = isDefault;
    return style;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Tile Matrix Set Link object.
 */
function readTileMatrixSetLink(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, TMS_LINKS_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Dimension object.
 */
function readDimensions(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, DIMENSION_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Resource URL object.
 */
function readResourceUrl(node, objectStack) {
    var format = node.getAttribute('format');
    var template = node.getAttribute('template');
    var resourceType = node.getAttribute('resourceType');
    var resource = {};
    if (format) {
        resource['format'] = format;
    }
    if (template) {
        resource['template'] = template;
    }
    if (resourceType) {
        resource['resourceType'] = resourceType;
    }
    return resource;
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} BBox object.
 */
function readBoundingBox(node, objectStack) {
    var coordinates = Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])([], WGS84_BBOX_READERS, node, objectStack);
    if (coordinates.length != 2) {
        return undefined;
    }
    return Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["boundingExtent"])(coordinates);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Legend object.
 */
function readLegendUrl(node, objectStack) {
    var legend = {};
    legend['format'] = node.getAttribute('format');
    legend['href'] = Object(_xlink_js__WEBPACK_IMPORTED_MODULE_5__["readHref"])(node);
    return legend;
}
/**
 * @param {Node} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} Coordinates object.
 */
function readCoordinates(node, objectStack) {
    var coordinates = Object(_xsd_js__WEBPACK_IMPORTED_MODULE_4__["readString"])(node).split(/\s+/);
    if (!coordinates || coordinates.length != 2) {
        return undefined;
    }
    var x = +coordinates[0];
    var y = +coordinates[1];
    if (isNaN(x) || isNaN(y)) {
        return undefined;
    }
    return [x, y];
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} TileMatrix object.
 */
function readTileMatrix(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, TM_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} TileMatrixSetLimits Object.
 */
function readTileMatrixLimitsList(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])([], TMS_LIMITS_LIST_PARSERS, node, objectStack);
}
/**
 * @param {Element} node Node.
 * @param {Array<*>} objectStack Object stack.
 * @return {Object|undefined} TileMatrixLimits Array.
 */
function readTileMatrixLimits(node, objectStack) {
    return Object(_xml_js__WEBPACK_IMPORTED_MODULE_3__["pushParseAndPop"])({}, TMS_LIMITS_PARSERS, node, objectStack);
}
/* harmony default export */ __webpack_exports__["default"] = (WMTSCapabilities);
//# sourceMappingURL=WMTSCapabilities.js.map

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _renderer_Composite_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(168);
/* harmony import */ var _PluggableMap_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(173);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _control_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(158);
/* harmony import */ var _interaction_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(266);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/Map
 */





/**
 * @classdesc
 * The map is the core component of OpenLayers. For a map to render, a view,
 * one or more layers, and a target container are needed:
 *
 *     import Map from 'ol/Map';
 *     import View from 'ol/View';
 *     import TileLayer from 'ol/layer/Tile';
 *     import OSM from 'ol/source/OSM';
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new TileLayer({
 *           source: new OSM()
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * The above snippet creates a map using a {@link module:ol/layer/Tile} to
 * display {@link module:ol/source/OSM~OSM} OSM data and render it to a DOM
 * element with the id `map`.
 *
 * The constructor places a viewport container (with CSS class name
 * `ol-viewport`) in the target element (see `getViewport()`), and then two
 * further elements within the viewport: one with CSS class name
 * `ol-overlaycontainer-stopevent` for controls and some overlays, and one with
 * CSS class name `ol-overlaycontainer` for other overlays (see the `stopEvent`
 * option of {@link module:ol/Overlay~Overlay} for the difference). The map
 * itself is placed in a further element within the viewport.
 *
 * Layers are stored as a {@link module:ol/Collection~Collection} in
 * layerGroups. A top-level group is provided by the library. This is what is
 * accessed by `getLayerGroup` and `setLayerGroup`. Layers entered in the
 * options are added to this group, and `addLayer` and `removeLayer` change the
 * layer collection in the group. `getLayers` is a convenience function for
 * `getLayerGroup().getLayers()`. Note that {@link module:ol/layer/Group~Group}
 * is a subclass of {@link module:ol/layer/Base}, so layers entered in the
 * options or added with `addLayer` can be groups, which can contain further
 * groups, and so on.
 *
 * @api
 */
var Map = /** @class */ (function (_super) {
    __extends(Map, _super);
    /**
     * @param {import("./PluggableMap.js").MapOptions} options Map options.
     */
    function Map(options) {
        var _this = this;
        options = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        if (!options.controls) {
            options.controls = Object(_control_js__WEBPACK_IMPORTED_MODULE_3__["defaults"])();
        }
        if (!options.interactions) {
            options.interactions = Object(_interaction_js__WEBPACK_IMPORTED_MODULE_4__["defaults"])({
                onFocusOnly: true,
            });
        }
        _this = _super.call(this, options) || this;
        return _this;
    }
    Map.prototype.createRenderer = function () {
        return new _renderer_Composite_js__WEBPACK_IMPORTED_MODULE_0__["default"](this);
    };
    return Map;
}(_PluggableMap_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Map);
//# sourceMappingURL=Map.js.map

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaults", function() { return defaults; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _interaction_DoubleClickZoom_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(267);
/* harmony import */ var _interaction_DragPan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(270);
/* harmony import */ var _interaction_DragRotate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(273);
/* harmony import */ var _interaction_DragZoom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(274);
/* harmony import */ var _interaction_KeyboardPan_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(277);
/* harmony import */ var _interaction_KeyboardZoom_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(279);
/* harmony import */ var _Kinetic_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(280);
/* harmony import */ var _interaction_MouseWheelZoom_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(281);
/* harmony import */ var _interaction_PinchRotate_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(282);
/* harmony import */ var _interaction_PinchZoom_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(283);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DoubleClickZoom", function() { return _interaction_DoubleClickZoom_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _interaction_DragAndDrop_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(284);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragAndDrop", function() { return _interaction_DragAndDrop_js__WEBPACK_IMPORTED_MODULE_11__["default"]; });

/* harmony import */ var _interaction_DragBox_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(275);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragBox", function() { return _interaction_DragBox_js__WEBPACK_IMPORTED_MODULE_12__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragPan", function() { return _interaction_DragPan_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragRotate", function() { return _interaction_DragRotate_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _interaction_DragRotateAndZoom_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(285);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragRotateAndZoom", function() { return _interaction_DragRotateAndZoom_js__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragZoom", function() { return _interaction_DragZoom_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _interaction_Draw_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(286);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Draw", function() { return _interaction_Draw_js__WEBPACK_IMPORTED_MODULE_14__["default"]; });

/* harmony import */ var _interaction_Extent_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(307);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Extent", function() { return _interaction_Extent_js__WEBPACK_IMPORTED_MODULE_15__["default"]; });

/* harmony import */ var _interaction_Interaction_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(268);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Interaction", function() { return _interaction_Interaction_js__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyboardPan", function() { return _interaction_KeyboardPan_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "KeyboardZoom", function() { return _interaction_KeyboardZoom_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _interaction_Modify_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(308);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Modify", function() { return _interaction_Modify_js__WEBPACK_IMPORTED_MODULE_17__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MouseWheelZoom", function() { return _interaction_MouseWheelZoom_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PinchRotate", function() { return _interaction_PinchRotate_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PinchZoom", function() { return _interaction_PinchZoom_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/* harmony import */ var _interaction_Pointer_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(271);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pointer", function() { return _interaction_Pointer_js__WEBPACK_IMPORTED_MODULE_18__["default"]; });

/* harmony import */ var _interaction_Select_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(309);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return _interaction_Select_js__WEBPACK_IMPORTED_MODULE_19__["default"]; });

/* harmony import */ var _interaction_Snap_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(310);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Snap", function() { return _interaction_Snap_js__WEBPACK_IMPORTED_MODULE_20__["default"]; });

/* harmony import */ var _interaction_Translate_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(311);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Translate", function() { return _interaction_Translate_js__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/**
 * @module ol/interaction
 */































/**
 * @typedef {Object} DefaultsOptions
 * @property {boolean} [altShiftDragRotate=true] Whether Alt-Shift-drag rotate is
 * desired.
 * @property {boolean} [onFocusOnly=false] Interact only when the map has the
 * focus. This affects the `MouseWheelZoom` and `DragPan` interactions and is
 * useful when page scroll is desired for maps that do not have the browser's
 * focus.
 * @property {boolean} [doubleClickZoom=true] Whether double click zoom is
 * desired.
 * @property {boolean} [keyboard=true] Whether keyboard interaction is desired.
 * @property {boolean} [mouseWheelZoom=true] Whether mousewheel zoom is desired.
 * @property {boolean} [shiftDragZoom=true] Whether Shift-drag zoom is desired.
 * @property {boolean} [dragPan=true] Whether drag pan is desired.
 * @property {boolean} [pinchRotate=true] Whether pinch rotate is desired.
 * @property {boolean} [pinchZoom=true] Whether pinch zoom is desired.
 * @property {number} [zoomDelta] Zoom level delta when using keyboard or double click zoom.
 * @property {number} [zoomDuration] Duration of the zoom animation in
 * milliseconds.
 */
/**
 * Set of interactions included in maps by default. Specific interactions can be
 * excluded by setting the appropriate option to false in the constructor
 * options, but the order of the interactions is fixed.  If you want to specify
 * a different order for interactions, you will need to create your own
 * {@link module:ol/interaction/Interaction} instances and insert
 * them into a {@link module:ol/Collection} in the order you want
 * before creating your {@link module:ol/Map~Map} instance. Changing the order can
 * be of interest if the event propagation needs to be stopped at a point.
 * The default set of interactions, in sequence, is:
 * * {@link module:ol/interaction/DragRotate~DragRotate}
 * * {@link module:ol/interaction/DoubleClickZoom~DoubleClickZoom}
 * * {@link module:ol/interaction/DragPan~DragPan}
 * * {@link module:ol/interaction/PinchRotate~PinchRotate}
 * * {@link module:ol/interaction/PinchZoom~PinchZoom}
 * * {@link module:ol/interaction/KeyboardPan~KeyboardPan}
 * * {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}
 * * {@link module:ol/interaction/MouseWheelZoom~MouseWheelZoom}
 * * {@link module:ol/interaction/DragZoom~DragZoom}
 *
 * @param {DefaultsOptions} [opt_options] Defaults options.
 * @return {import("./Collection.js").default<import("./interaction/Interaction.js").default>}
 * A collection of interactions to be used with the {@link module:ol/Map~Map}
 * constructor's `interactions` option.
 * @api
 */
function defaults(opt_options) {
    var options = opt_options ? opt_options : {};
    var interactions = new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
    var kinetic = new _Kinetic_js__WEBPACK_IMPORTED_MODULE_7__["default"](-0.005, 0.05, 100);
    var altShiftDragRotate = options.altShiftDragRotate !== undefined
        ? options.altShiftDragRotate
        : true;
    if (altShiftDragRotate) {
        interactions.push(new _interaction_DragRotate_js__WEBPACK_IMPORTED_MODULE_3__["default"]());
    }
    var doubleClickZoom = options.doubleClickZoom !== undefined ? options.doubleClickZoom : true;
    if (doubleClickZoom) {
        interactions.push(new _interaction_DoubleClickZoom_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
            delta: options.zoomDelta,
            duration: options.zoomDuration,
        }));
    }
    var dragPan = options.dragPan !== undefined ? options.dragPan : true;
    if (dragPan) {
        interactions.push(new _interaction_DragPan_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
            onFocusOnly: options.onFocusOnly,
            kinetic: kinetic,
        }));
    }
    var pinchRotate = options.pinchRotate !== undefined ? options.pinchRotate : true;
    if (pinchRotate) {
        interactions.push(new _interaction_PinchRotate_js__WEBPACK_IMPORTED_MODULE_9__["default"]());
    }
    var pinchZoom = options.pinchZoom !== undefined ? options.pinchZoom : true;
    if (pinchZoom) {
        interactions.push(new _interaction_PinchZoom_js__WEBPACK_IMPORTED_MODULE_10__["default"]({
            duration: options.zoomDuration,
        }));
    }
    var keyboard = options.keyboard !== undefined ? options.keyboard : true;
    if (keyboard) {
        interactions.push(new _interaction_KeyboardPan_js__WEBPACK_IMPORTED_MODULE_5__["default"]());
        interactions.push(new _interaction_KeyboardZoom_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
            delta: options.zoomDelta,
            duration: options.zoomDuration,
        }));
    }
    var mouseWheelZoom = options.mouseWheelZoom !== undefined ? options.mouseWheelZoom : true;
    if (mouseWheelZoom) {
        interactions.push(new _interaction_MouseWheelZoom_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
            onFocusOnly: options.onFocusOnly,
            duration: options.zoomDuration,
        }));
    }
    var shiftDragZoom = options.shiftDragZoom !== undefined ? options.shiftDragZoom : true;
    if (shiftDragZoom) {
        interactions.push(new _interaction_DragZoom_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
            duration: options.zoomDuration,
        }));
    }
    return interactions;
}
//# sourceMappingURL=interaction.js.map

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DoubleClickZoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [delta=1] The zoom delta applied on each double click.
 */
/**
 * @classdesc
 * Allows the user to zoom by double-clicking on the map.
 * @api
 */
var DoubleClickZoom = /** @class */ (function (_super) {
    __extends(DoubleClickZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DoubleClickZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {number}
         */
        _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a
     * doubleclick) and eventually zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */
    DoubleClickZoom.prototype.handleEvent = function (mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].DBLCLICK) {
            var browserEvent = /** @type {MouseEvent} */ (mapBrowserEvent.originalEvent);
            var map = mapBrowserEvent.map;
            var anchor = mapBrowserEvent.coordinate;
            var delta = browserEvent.shiftKey ? -this.delta_ : this.delta_;
            var view = map.getView();
            Object(_Interaction_js__WEBPACK_IMPORTED_MODULE_0__["zoomByDelta"])(view, delta, anchor, this.duration_);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    };
    return DoubleClickZoom;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DoubleClickZoom);
//# sourceMappingURL=DoubleClickZoom.js.map

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pan", function() { return pan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "zoomByDelta", function() { return zoomByDelta; });
/* harmony import */ var _Object_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45);
/* harmony import */ var _Property_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(269);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Interaction
 */



/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active', Return>} InteractionOnSignature
 */
/**
 * Object literal with config options for interactions.
 * @typedef {Object} InteractionOptions
 * @property {function(import("../MapBrowserEvent.js").default):boolean} handleEvent
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. If the function returns a falsy value, propagation of
 * the event to other interactions in the map's interactions chain will be
 * prevented (this includes functions with no explicit return). The interactions
 * are traversed in reverse order of the interactions collection of the map.
 */
/**
 * @classdesc
 * Abstract base class; normally only used for creating subclasses and not
 * instantiated in apps.
 * User actions that change the state of the map. Some are similar to controls,
 * but are not associated with a DOM element.
 * For example, {@link module:ol/interaction/KeyboardZoom~KeyboardZoom} is
 * functionally the same as {@link module:ol/control/Zoom~Zoom}, but triggered
 * by a keyboard event not a button element event.
 * Although interactions do not have a DOM element, some of them do render
 * vectors and so are visible on the screen.
 * @api
 */
var Interaction = /** @class */ (function (_super) {
    __extends(Interaction, _super);
    /**
     * @param {InteractionOptions} [opt_options] Options.
     */
    function Interaction(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {InteractionOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {InteractionOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {InteractionOnSignature<void>}
         */
        _this.un;
        if (opt_options && opt_options.handleEvent) {
            _this.handleEvent = opt_options.handleEvent;
        }
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */
        _this.map_ = null;
        _this.setActive(true);
        return _this;
    }
    /**
     * Return whether the interaction is currently active.
     * @return {boolean} `true` if the interaction is active, `false` otherwise.
     * @observable
     * @api
     */
    Interaction.prototype.getActive = function () {
        return /** @type {boolean} */ (this.get(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].ACTIVE));
    };
    /**
     * Get the map associated with this interaction.
     * @return {import("../PluggableMap.js").default} Map.
     * @api
     */
    Interaction.prototype.getMap = function () {
        return this.map_;
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event}.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */
    Interaction.prototype.handleEvent = function (mapBrowserEvent) {
        return true;
    };
    /**
     * Activate or deactivate the interaction.
     * @param {boolean} active Active.
     * @observable
     * @api
     */
    Interaction.prototype.setActive = function (active) {
        this.set(_Property_js__WEBPACK_IMPORTED_MODULE_1__["default"].ACTIVE, active);
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Interaction.prototype.setMap = function (map) {
        this.map_ = map;
    };
    return Interaction;
}(_Object_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {import("../View.js").default} view View.
 * @param {import("../coordinate.js").Coordinate} delta Delta.
 * @param {number} [opt_duration] Duration.
 */
function pan(view, delta, opt_duration) {
    var currentCenter = view.getCenterInternal();
    if (currentCenter) {
        var center = [currentCenter[0] + delta[0], currentCenter[1] + delta[1]];
        view.animateInternal({
            duration: opt_duration !== undefined ? opt_duration : 250,
            easing: _easing_js__WEBPACK_IMPORTED_MODULE_2__["linear"],
            center: view.getConstrainedCenter(center),
        });
    }
}
/**
 * @param {import("../View.js").default} view View.
 * @param {number} delta Delta from previous zoom level.
 * @param {import("../coordinate.js").Coordinate} [opt_anchor] Anchor coordinate in the user projection.
 * @param {number} [opt_duration] Duration.
 */
function zoomByDelta(view, delta, opt_anchor, opt_duration) {
    var currentZoom = view.getZoom();
    if (currentZoom === undefined) {
        return;
    }
    var newZoom = view.getConstrainedZoom(currentZoom + delta);
    var newResolution = view.getResolutionForZoom(newZoom);
    if (view.getAnimating()) {
        view.cancelAnimations();
    }
    view.animate({
        resolution: newResolution,
        anchor: opt_anchor,
        duration: opt_duration !== undefined ? opt_duration : 250,
        easing: _easing_js__WEBPACK_IMPORTED_MODULE_2__["easeOut"],
    });
}
/* harmony default export */ __webpack_exports__["default"] = (Interaction);
//# sourceMappingURL=Interaction.js.map

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/interaction/Property
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    ACTIVE: 'active',
});
//# sourceMappingURL=Property.js.map

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(271);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(272);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DragPan
 */





/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.noModifierKeys} and {@link module:ol/events/condition.primaryAction}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {import("../Kinetic.js").default} [kinetic] Kinetic inertia to apply to the pan.
 */
/**
 * @classdesc
 * Allows the user to pan the map by dragging the map.
 * @api
 */
var DragPan = /** @class */ (function (_super) {
    __extends(DragPan, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragPan(opt_options) {
        var _this = _super.call(this, {
            stopDown: _functions_js__WEBPACK_IMPORTED_MODULE_1__["FALSE"],
        }) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../Kinetic.js").default|undefined}
         */
        _this.kinetic_ = options.kinetic;
        /**
         * @type {import("../pixel.js").Pixel}
         */
        _this.lastCentroid = null;
        /**
         * @type {number}
         */
        _this.lastPointersCount_;
        /**
         * @type {boolean}
         */
        _this.panning_ = false;
        var condition = options.condition
            ? options.condition
            : Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["all"])(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["noModifierKeys"], _events_condition_js__WEBPACK_IMPORTED_MODULE_2__["primaryAction"]);
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.onFocusOnly
            ? Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["all"])(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["focusWithTabindex"], condition)
            : condition;
        /**
         * @private
         * @type {boolean}
         */
        _this.noKinetic_ = false;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    DragPan.prototype.handleDragEvent = function (mapBrowserEvent) {
        if (!this.panning_) {
            this.panning_ = true;
            this.getMap().getView().beginInteraction();
        }
        var targetPointers = this.targetPointers;
        var centroid = Object(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["centroid"])(targetPointers);
        if (targetPointers.length == this.lastPointersCount_) {
            if (this.kinetic_) {
                this.kinetic_.update(centroid[0], centroid[1]);
            }
            if (this.lastCentroid) {
                var delta = [
                    this.lastCentroid[0] - centroid[0],
                    centroid[1] - this.lastCentroid[1],
                ];
                var map = mapBrowserEvent.map;
                var view = map.getView();
                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_4__["scale"])(delta, view.getResolution());
                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_4__["rotate"])(delta, view.getRotation());
                view.adjustCenterInternal(delta);
            }
        }
        else if (this.kinetic_) {
            // reset so we don't overestimate the kinetic energy after
            // after one finger down, tiny drag, second finger down
            this.kinetic_.begin();
        }
        this.lastCentroid = centroid;
        this.lastPointersCount_ = targetPointers.length;
        mapBrowserEvent.originalEvent.preventDefault();
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragPan.prototype.handleUpEvent = function (mapBrowserEvent) {
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (this.targetPointers.length === 0) {
            if (!this.noKinetic_ && this.kinetic_ && this.kinetic_.end()) {
                var distance = this.kinetic_.getDistance();
                var angle = this.kinetic_.getAngle();
                var center = view.getCenterInternal();
                var centerpx = map.getPixelFromCoordinateInternal(center);
                var dest = map.getCoordinateFromPixelInternal([
                    centerpx[0] - distance * Math.cos(angle),
                    centerpx[1] - distance * Math.sin(angle),
                ]);
                view.animateInternal({
                    center: view.getConstrainedCenter(dest),
                    duration: 500,
                    easing: _easing_js__WEBPACK_IMPORTED_MODULE_3__["easeOut"],
                });
            }
            if (this.panning_) {
                this.panning_ = false;
                view.endInteraction();
            }
            return false;
        }
        else {
            if (this.kinetic_) {
                // reset so we don't overestimate the kinetic energy after
                // after one finger up, tiny drag, second finger up
                this.kinetic_.begin();
            }
            this.lastCentroid = null;
            return true;
        }
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragPan.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (this.targetPointers.length > 0 && this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            this.lastCentroid = null;
            // stop any current animation
            if (view.getAnimating()) {
                view.cancelAnimations();
            }
            if (this.kinetic_) {
                this.kinetic_.begin();
            }
            // No kinetic as soon as more than one pointer on the screen is
            // detected. This is to prevent nasty pans after pinch.
            this.noKinetic_ = this.targetPointers.length > 1;
            return true;
        }
        else {
            return false;
        }
    };
    return DragPan;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragPan);
//# sourceMappingURL=DragPan.js.map

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "centroid", function() { return centroid; });
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(268);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(178);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Pointer
 */



/**
 * @typedef {Object} Options
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleDownEvent]
 * Function handling "down" events. If the function returns `true` then a drag
 * sequence is started.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleDragEvent]
 * Function handling "drag" events. This function is called on "move" events
 * during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleEvent]
 * Method called by the map to notify the interaction that a browser event was
 * dispatched to the map. The function may return `false` to prevent the
 * propagation of the event to other interactions in the map's interactions
 * chain.
 * @property {function(import("../MapBrowserEvent.js").default):void} [handleMoveEvent]
 * Function handling "move" events. This function is called on "move" events.
 * This functions is also called during a drag sequence, so during a drag
 * sequence both the `handleDragEvent` function and this function are called.
 * If `handleDownEvent` is defined and it returns true this function will not
 * be called during a drag sequence.
 * @property {function(import("../MapBrowserEvent.js").default):boolean} [handleUpEvent]
 *  Function handling "up" events. If the function returns `false` then the
 * current drag sequence is stopped.
 * @property {function(boolean):boolean} [stopDown]
 * Should the down event be propagated to other interactions, or should be
 * stopped?
 */
/**
 * @classdesc
 * Base class that calls user-defined functions on `down`, `move` and `up`
 * events. This class also manages "drag sequences".
 *
 * When the `handleDownEvent` user function returns `true` a drag sequence is
 * started. During a drag sequence the `handleDragEvent` user function is
 * called on `move` events. The drag sequence ends when the `handleUpEvent`
 * user function is called and returns `false`.
 * @api
 */
var PointerInteraction = /** @class */ (function (_super) {
    __extends(PointerInteraction, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function PointerInteraction(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, 
        /** @type {import("./Interaction.js").InteractionOptions} */ (options)) || this;
        if (options.handleDownEvent) {
            _this.handleDownEvent = options.handleDownEvent;
        }
        if (options.handleDragEvent) {
            _this.handleDragEvent = options.handleDragEvent;
        }
        if (options.handleMoveEvent) {
            _this.handleMoveEvent = options.handleMoveEvent;
        }
        if (options.handleUpEvent) {
            _this.handleUpEvent = options.handleUpEvent;
        }
        if (options.stopDown) {
            _this.stopDown = options.stopDown;
        }
        /**
         * @type {boolean}
         * @protected
         */
        _this.handlingDownUpSequence = false;
        /**
         * @type {!Object<string, PointerEvent>}
         * @private
         */
        _this.trackedPointers_ = {};
        /**
         * @type {Array<PointerEvent>}
         * @protected
         */
        _this.targetPointers = [];
        return _this;
    }
    /**
     * Returns the current number of pointers involved in the interaction,
     * e.g. `2` when two fingers are used.
     * @return {number} The number of pointers.
     * @api
     */
    PointerInteraction.prototype.getPointerCount = function () {
        return this.targetPointers.length;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */
    PointerInteraction.prototype.handleDownEvent = function (mapBrowserEvent) {
        return false;
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */
    PointerInteraction.prototype.handleDragEvent = function (mapBrowserEvent) { };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} and may call into
     * other functions, if event sequences like e.g. 'drag' or 'down-up' etc. are
     * detected.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */
    PointerInteraction.prototype.handleEvent = function (mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) {
            return true;
        }
        var stopEvent = false;
        this.updateTrackedPointers_(mapBrowserEvent);
        if (this.handlingDownUpSequence) {
            if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERDRAG) {
                this.handleDragEvent(mapBrowserEvent);
                // prevent page scrolling during dragging
                mapBrowserEvent.originalEvent.preventDefault();
            }
            else if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERUP) {
                var handledUp = this.handleUpEvent(mapBrowserEvent);
                this.handlingDownUpSequence =
                    handledUp && this.targetPointers.length > 0;
            }
        }
        else {
            if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERDOWN) {
                var handled = this.handleDownEvent(mapBrowserEvent);
                this.handlingDownUpSequence = handled;
                stopEvent = this.stopDown(handled);
            }
            else if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERMOVE) {
                this.handleMoveEvent(mapBrowserEvent);
            }
        }
        return !stopEvent;
    };
    /**
     * Handle pointer move events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @protected
     */
    PointerInteraction.prototype.handleMoveEvent = function (mapBrowserEvent) { };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     * @protected
     */
    PointerInteraction.prototype.handleUpEvent = function (mapBrowserEvent) {
        return false;
    };
    /**
     * This function is used to determine if "down" events should be propagated
     * to other interactions or should be stopped.
     * @param {boolean} handled Was the event handled by the interaction?
     * @return {boolean} Should the `down` event be stopped?
     */
    PointerInteraction.prototype.stopDown = function (handled) {
        return handled;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @private
     */
    PointerInteraction.prototype.updateTrackedPointers_ = function (mapBrowserEvent) {
        if (isPointerDraggingEvent(mapBrowserEvent)) {
            var event_1 = mapBrowserEvent.originalEvent;
            var id = event_1.pointerId.toString();
            if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERUP) {
                delete this.trackedPointers_[id];
            }
            else if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERDOWN) {
                this.trackedPointers_[id] = event_1;
            }
            else if (id in this.trackedPointers_) {
                // update only when there was a pointerdown event for this pointer
                this.trackedPointers_[id] = event_1;
            }
            this.targetPointers = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["getValues"])(this.trackedPointers_);
        }
    };
    return PointerInteraction;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {Array<PointerEvent>} pointerEvents List of events.
 * @return {import("../pixel.js").Pixel} Centroid pixel.
 */
function centroid(pointerEvents) {
    var length = pointerEvents.length;
    var clientX = 0;
    var clientY = 0;
    for (var i = 0; i < length; i++) {
        clientX += pointerEvents[i].clientX;
        clientY += pointerEvents[i].clientY;
    }
    return [clientX / length, clientY / length];
}
/**
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
 * @return {boolean} Whether the event is a pointerdown, pointerdrag
 *     or pointerup event.
 */
function isPointerDraggingEvent(mapBrowserEvent) {
    var type = mapBrowserEvent.type;
    return (type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERDOWN ||
        type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERDRAG ||
        type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINTERUP);
}
/* harmony default export */ __webpack_exports__["default"] = (PointerInteraction);
//# sourceMappingURL=Pointer.js.map

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "all", function() { return all; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "altKeyOnly", function() { return altKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "altShiftKeysOnly", function() { return altShiftKeysOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focus", function() { return focus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "focusWithTabindex", function() { return focusWithTabindex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "always", function() { return always; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "click", function() { return click; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseActionButton", function() { return mouseActionButton; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "never", function() { return never; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pointerMove", function() { return pointerMove; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "singleClick", function() { return singleClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doubleClick", function() { return doubleClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "noModifierKeys", function() { return noModifierKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "platformModifierKeyOnly", function() { return platformModifierKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shiftKeyOnly", function() { return shiftKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "targetNotEditable", function() { return targetNotEditable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseOnly", function() { return mouseOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "touchOnly", function() { return touchOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "penOnly", function() { return penOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "primaryAction", function() { return primaryAction; });
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(178);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19);
/**
 * @module ol/events/condition
 */




/**
 * A function that takes an {@link module:ol/MapBrowserEvent} and returns a
 * `{boolean}`. If the condition is met, true should be returned.
 *
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default): boolean} Condition
 */
/**
 * Creates a condition function that passes when all provided conditions pass.
 * @param {...Condition} var_args Conditions to check.
 * @return {Condition} Condition function.
 */
function all(var_args) {
    var conditions = arguments;
    /**
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} All conditions passed.
     */
    return function (event) {
        var pass = true;
        for (var i = 0, ii = conditions.length; i < ii; ++i) {
            pass = pass && conditions[i](event);
            if (!pass) {
                break;
            }
        }
        return pass;
    };
}
/**
 * Return `true` if only the alt-key is pressed, `false` otherwise (e.g. when
 * additionally the shift-key is pressed).
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if only the alt key is pressed.
 * @api
 */
var altKeyOnly = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    return (originalEvent.altKey &&
        !(originalEvent.metaKey || originalEvent.ctrlKey) &&
        !originalEvent.shiftKey);
};
/**
 * Return `true` if only the alt-key and shift-key is pressed, `false` otherwise
 * (e.g. when additionally the platform-modifier-key is pressed).
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if only the alt and shift keys are pressed.
 * @api
 */
var altShiftKeysOnly = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    return (originalEvent.altKey &&
        !(originalEvent.metaKey || originalEvent.ctrlKey) &&
        originalEvent.shiftKey);
};
/**
 * Return `true` if the map has the focus. This condition requires a map target
 * element with a `tabindex` attribute, e.g. `<div id="map" tabindex="1">`.
 *
 * @param {import("../MapBrowserEvent.js").default} event Map browser event.
 * @return {boolean} The map has the focus.
 * @api
 */
var focus = function (event) {
    return event.target.getTargetElement().contains(document.activeElement);
};
/**
 * Return `true` if the map has the focus or no 'tabindex' attribute set.
 *
 * @param {import("../MapBrowserEvent.js").default} event Map browser event.
 * @return {boolean} The map container has the focus or no 'tabindex' attribute.
 */
var focusWithTabindex = function (event) {
    return event.map.getTargetElement().hasAttribute('tabindex')
        ? focus(event)
        : true;
};
/**
 * Return always true.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True.
 * @api
 */
var always = _functions_js__WEBPACK_IMPORTED_MODULE_1__["TRUE"];
/**
 * Return `true` if the event is a `click` event, `false` otherwise.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event is a map `click` event.
 * @api
 */
var click = function (mapBrowserEvent) {
    return mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CLICK;
};
/**
 * Return `true` if the event has an "action"-producing mouse button.
 *
 * By definition, this includes left-click on windows/linux, and left-click
 * without the ctrl key on Macs.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} The result.
 */
var mouseActionButton = function (mapBrowserEvent) {
    var originalEvent = /** @type {MouseEvent} */ (mapBrowserEvent.originalEvent);
    return originalEvent.button == 0 && !(_has_js__WEBPACK_IMPORTED_MODULE_2__["WEBKIT"] && _has_js__WEBPACK_IMPORTED_MODULE_2__["MAC"] && originalEvent.ctrlKey);
};
/**
 * Return always false.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} False.
 * @api
 */
var never = _functions_js__WEBPACK_IMPORTED_MODULE_1__["FALSE"];
/**
 * Return `true` if the browser event is a `pointermove` event, `false`
 * otherwise.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the browser event is a `pointermove` event.
 * @api
 */
var pointerMove = function (mapBrowserEvent) {
    return mapBrowserEvent.type == 'pointermove';
};
/**
 * Return `true` if the event is a map `singleclick` event, `false` otherwise.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event is a map `singleclick` event.
 * @api
 */
var singleClick = function (mapBrowserEvent) {
    return mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].SINGLECLICK;
};
/**
 * Return `true` if the event is a map `dblclick` event, `false` otherwise.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event is a map `dblclick` event.
 * @api
 */
var doubleClick = function (mapBrowserEvent) {
    return mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].DBLCLICK;
};
/**
 * Return `true` if no modifier key (alt-, shift- or platform-modifier-key) is
 * pressed.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True only if there no modifier keys are pressed.
 * @api
 */
var noModifierKeys = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    return (!originalEvent.altKey &&
        !(originalEvent.metaKey || originalEvent.ctrlKey) &&
        !originalEvent.shiftKey);
};
/**
 * Return `true` if only the platform-modifier-key (the meta-key on Mac,
 * ctrl-key otherwise) is pressed, `false` otherwise (e.g. when additionally
 * the shift-key is pressed).
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if only the platform modifier key is pressed.
 * @api
 */
var platformModifierKeyOnly = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    return (!originalEvent.altKey &&
        (_has_js__WEBPACK_IMPORTED_MODULE_2__["MAC"] ? originalEvent.metaKey : originalEvent.ctrlKey) &&
        !originalEvent.shiftKey);
};
/**
 * Return `true` if only the shift-key is pressed, `false` otherwise (e.g. when
 * additionally the alt-key is pressed).
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if only the shift key is pressed.
 * @api
 */
var shiftKeyOnly = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    return (!originalEvent.altKey &&
        !(originalEvent.metaKey || originalEvent.ctrlKey) &&
        originalEvent.shiftKey);
};
/**
 * Return `true` if the target element is not editable, i.e. not a `<input>`-,
 * `<select>`- or `<textarea>`-element, `false` otherwise.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True only if the target element is not editable.
 * @api
 */
var targetNotEditable = function (mapBrowserEvent) {
    var originalEvent = /** @type {KeyboardEvent|MouseEvent|TouchEvent} */ (mapBrowserEvent.originalEvent);
    var tagName = /** @type {Element} */ (originalEvent.target).tagName;
    return tagName !== 'INPUT' && tagName !== 'SELECT' && tagName !== 'TEXTAREA';
};
/**
 * Return `true` if the event originates from a mouse device.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event originates from a mouse device.
 * @api
 */
var mouseOnly = function (mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ (mapBrowserEvent).originalEvent;
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvent.pointerType == 'mouse';
};
/**
 * Return `true` if the event originates from a touchable device.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event originates from a touchable device.
 * @api
 */
var touchOnly = function (mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ (mapBrowserEvent).originalEvent;
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'touch';
};
/**
 * Return `true` if the event originates from a digital pen.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event originates from a digital pen.
 * @api
 */
var penOnly = function (mapBrowserEvent) {
    var pointerEvt = /** @type {import("../MapBrowserEvent").default} */ (mapBrowserEvent).originalEvent;
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(pointerEvt !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    // see https://www.w3.org/TR/pointerevents/#widl-PointerEvent-pointerType
    return pointerEvt.pointerType === 'pen';
};
/**
 * Return `true` if the event originates from a primary pointer in
 * contact with the surface or if the left mouse button is pressed.
 * See https://www.w3.org/TR/pointerevents/#button-states.
 *
 * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
 * @return {boolean} True if the event originates from a primary pointer.
 * @api
 */
var primaryAction = function (mapBrowserEvent) {
    var pointerEvent = /** @type {import("../MapBrowserEvent").default} */ (mapBrowserEvent).originalEvent;
    Object(_asserts_js__WEBPACK_IMPORTED_MODULE_3__["assert"])(pointerEvent !== undefined, 56); // mapBrowserEvent must originate from a pointer event
    return pointerEvent.isPrimary && pointerEvent.button === 0;
};
//# sourceMappingURL=condition.js.map

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(271);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(272);
/* harmony import */ var _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(183);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DragRotate
 */




/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an
 * {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.altShiftKeysOnly}.
 * @property {number} [duration=250] Animation duration in milliseconds.
 */
/**
 * @classdesc
 * Allows the user to rotate the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the alt and shift keys are held down.
 *
 * This interaction is only supported for mouse devices.
 * @api
 */
var DragRotate = /** @class */ (function (_super) {
    __extends(DragRotate, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            stopDown: _functions_js__WEBPACK_IMPORTED_MODULE_1__["FALSE"],
        }) || this;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_2__["altShiftKeysOnly"];
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    DragRotate.prototype.handleDragEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["mouseOnly"])(mapBrowserEvent)) {
            return;
        }
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_3__["disable"]) {
            return;
        }
        var size = map.getSize();
        var offset = mapBrowserEvent.pixel;
        var theta = Math.atan2(size[1] / 2 - offset[1], offset[0] - size[0] / 2);
        if (this.lastAngle_ !== undefined) {
            var delta = theta - this.lastAngle_;
            view.adjustRotationInternal(-delta);
        }
        this.lastAngle_ = theta;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragRotate.prototype.handleUpEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["mouseOnly"])(mapBrowserEvent)) {
            return true;
        }
        var map = mapBrowserEvent.map;
        var view = map.getView();
        view.endInteraction(this.duration_);
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragRotate.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["mouseOnly"])(mapBrowserEvent)) {
            return false;
        }
        if (Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_2__["mouseActionButton"])(mapBrowserEvent) &&
            this.condition_(mapBrowserEvent)) {
            var map = mapBrowserEvent.map;
            map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            return true;
        }
        else {
            return false;
        }
    };
    return DragRotate;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragRotate);
//# sourceMappingURL=DragRotate.js.map

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _DragBox_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(275);
/* harmony import */ var _easing_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(272);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DragZoom
 */



/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragzoom'] CSS class name for styling the
 * box.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=200] Animation duration in milliseconds.
 * @property {boolean} [out=false] Use interaction for zooming out.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the parent default
 * `boxEndCondition` function.
 */
/**
 * @classdesc
 * Allows the user to zoom the map by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when a key, shift by default, is held down.
 *
 * To change the style of the box, use CSS and the `.ol-dragzoom` selector, or
 * your custom one configured with `className`.
 * @api
 */
var DragZoom = /** @class */ (function (_super) {
    __extends(DragZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var condition = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_2__["shiftKeyOnly"];
        _this = _super.call(this, {
            condition: condition,
            className: options.className || 'ol-dragzoom',
            minArea: options.minArea,
        }) || this;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 200;
        /**
         * @private
         * @type {boolean}
         */
        _this.out_ = options.out !== undefined ? options.out : false;
        return _this;
    }
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */
    DragZoom.prototype.onBoxEnd = function (event) {
        var map = this.getMap();
        var view = /** @type {!import("../View.js").default} */ (map.getView());
        var geometry = this.getGeometry();
        if (this.out_) {
            var rotatedExtent = view.rotatedExtentForGeometry(geometry);
            var resolution = view.getResolutionForExtentInternal(rotatedExtent);
            var factor = view.getResolution() / resolution;
            geometry = geometry.clone();
            geometry.scale(factor * factor);
        }
        view.fitInternal(geometry, {
            duration: this.duration_,
            easing: _easing_js__WEBPACK_IMPORTED_MODULE_1__["easeOut"],
        });
    };
    return DragZoom;
}(_DragBox_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragZoom);
//# sourceMappingURL=DragZoom.js.map

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragBoxEvent", function() { return DragBoxEvent; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(271);
/* harmony import */ var _render_Box_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(276);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(272);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DragBox
 */
// FIXME draw drag box




/**
 * A function that takes a {@link module:ol/MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s and returns a `{boolean}`. If the condition is met,
 * true should be returned.
 * @typedef {function(this: ?, import("../MapBrowserEvent.js").default, import("../pixel.js").Pixel, import("../pixel.js").Pixel):boolean} EndCondition
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-dragbox'] CSS class name for styling the box.
 * @property {import("../events/condition.js").Condition} [condition] A function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a boolean
 * to indicate whether that event should be handled.
 * Default is {@link ol/events/condition~mouseActionButton}.
 * @property {number} [minArea=64] The minimum area of the box in pixel, this value is used by the default
 * `boxEndCondition` function.
 * @property {EndCondition} [boxEndCondition] A function that takes a {@link module:ol/MapBrowserEvent~MapBrowserEvent} and two
 * {@link module:ol/pixel~Pixel}s to indicate whether a `boxend` event should be fired.
 * Default is `true` if the area of the box is bigger than the `minArea` option.
 * @property {function(this:DragBox, import("../MapBrowserEvent.js").default):void} [onBoxEnd] Code to execute just
 * before `boxend` is fired.
 */
/**
 * @enum {string}
 */
var DragBoxEventType = {
    /**
     * Triggered upon drag box start.
     * @event DragBoxEvent#boxstart
     * @api
     */
    BOXSTART: 'boxstart',
    /**
     * Triggered on drag when box is active.
     * @event DragBoxEvent#boxdrag
     * @api
     */
    BOXDRAG: 'boxdrag',
    /**
     * Triggered upon drag box end.
     * @event DragBoxEvent#boxend
     * @api
     */
    BOXEND: 'boxend',
    /**
     * Triggered upon drag box canceled.
     * @event DragBoxEvent#boxcancel
     * @api
     */
    BOXCANCEL: 'boxcancel',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragBox~DragBox} instances are instances of
 * this type.
 */
var DragBoxEvent = /** @class */ (function (_super) {
    __extends(DragBoxEvent, _super);
    /**
     * @param {string} type The event type.
     * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Originating event.
     */
    function DragBoxEvent(type, coordinate, mapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * The coordinate of the drag event.
         * @const
         * @type {import("../coordinate.js").Coordinate}
         * @api
         */
        _this.coordinate = coordinate;
        /**
         * @const
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */
        _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return DragBoxEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'boxcancel'|'boxdrag'|'boxend', DragBoxEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'boxcancel'|'boxdrag'|'boxend', Return>} DragBoxOnSignature
 */
/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map,
 * normally combined with an {@link module:ol/events/condition} that limits
 * it to when the shift or other key is held down. This is used, for example,
 * for zooming to a specific area of the map
 * (see {@link module:ol/interaction/DragZoom~DragZoom} and
 * {@link module:ol/interaction/DragRotateAndZoom}).
 *
 * @fires DragBoxEvent
 * @api
 */
var DragBox = /** @class */ (function (_super) {
    __extends(DragBox, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragBox(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {DragBoxOnSignature<import("../Observable").OnReturn>}
         */
        _this.on;
        /***
         * @type {DragBoxOnSignature<import("../Observable").OnReturn>}
         */
        _this.once;
        /***
         * @type {DragBoxOnSignature<void>}
         */
        _this.un;
        var options = opt_options ? opt_options : {};
        /**
         * @type {import("../render/Box.js").default}
         * @private
         */
        _this.box_ = new _render_Box_js__WEBPACK_IMPORTED_MODULE_2__["default"](options.className || 'ol-dragbox');
        /**
         * @type {number}
         * @private
         */
        _this.minArea_ = options.minArea !== undefined ? options.minArea : 64;
        if (options.onBoxEnd) {
            _this.onBoxEnd = options.onBoxEnd;
        }
        /**
         * @type {import("../pixel.js").Pixel}
         * @private
         */
        _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_3__["mouseActionButton"];
        /**
         * @private
         * @type {EndCondition}
         */
        _this.boxEndCondition_ = options.boxEndCondition
            ? options.boxEndCondition
            : _this.defaultBoxEndCondition;
        return _this;
    }
    /**
     * The default condition for determining whether the boxend event
     * should fire.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent The originating MapBrowserEvent
     *     leading to the box end.
     * @param {import("../pixel.js").Pixel} startPixel The starting pixel of the box.
     * @param {import("../pixel.js").Pixel} endPixel The end pixel of the box.
     * @return {boolean} Whether or not the boxend condition should be fired.
     */
    DragBox.prototype.defaultBoxEndCondition = function (mapBrowserEvent, startPixel, endPixel) {
        var width = endPixel[0] - startPixel[0];
        var height = endPixel[1] - startPixel[1];
        return width * width + height * height >= this.minArea_;
    };
    /**
     * Returns geometry of last drawn box.
     * @return {import("../geom/Polygon.js").default} Geometry.
     * @api
     */
    DragBox.prototype.getGeometry = function () {
        return this.box_.getGeometry();
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    DragBox.prototype.handleDragEvent = function (mapBrowserEvent) {
        this.box_.setPixels(this.startPixel_, mapBrowserEvent.pixel);
        this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXDRAG, mapBrowserEvent.coordinate, mapBrowserEvent));
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragBox.prototype.handleUpEvent = function (mapBrowserEvent) {
        this.box_.setMap(null);
        var completeBox = this.boxEndCondition_(mapBrowserEvent, this.startPixel_, mapBrowserEvent.pixel);
        if (completeBox) {
            this.onBoxEnd(mapBrowserEvent);
        }
        this.dispatchEvent(new DragBoxEvent(completeBox ? DragBoxEventType.BOXEND : DragBoxEventType.BOXCANCEL, mapBrowserEvent.coordinate, mapBrowserEvent));
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragBox.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (this.condition_(mapBrowserEvent)) {
            this.startPixel_ = mapBrowserEvent.pixel;
            this.box_.setMap(mapBrowserEvent.map);
            this.box_.setPixels(this.startPixel_, this.startPixel_);
            this.dispatchEvent(new DragBoxEvent(DragBoxEventType.BOXSTART, mapBrowserEvent.coordinate, mapBrowserEvent));
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Function to execute just before `onboxend` is fired
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */
    DragBox.prototype.onBoxEnd = function (event) { };
    return DragBox;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragBox);
//# sourceMappingURL=DragBox.js.map

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Disposable_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(184);
/**
 * @module ol/render/Box
 */
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var RenderBox = /** @class */ (function (_super) {
    __extends(RenderBox, _super);
    /**
     * @param {string} className CSS class name.
     */
    function RenderBox(className) {
        var _this = _super.call(this) || this;
        /**
         * @type {import("../geom/Polygon.js").default}
         * @private
         */
        _this.geometry_ = null;
        /**
         * @type {HTMLDivElement}
         * @private
         */
        _this.element_ = document.createElement('div');
        _this.element_.style.position = 'absolute';
        _this.element_.style.pointerEvents = 'auto';
        _this.element_.className = 'ol-box ' + className;
        /**
         * @private
         * @type {import("../PluggableMap.js").default}
         */
        _this.map_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */
        _this.startPixel_ = null;
        /**
         * @private
         * @type {import("../pixel.js").Pixel}
         */
        _this.endPixel_ = null;
        return _this;
    }
    /**
     * Clean up.
     */
    RenderBox.prototype.disposeInternal = function () {
        this.setMap(null);
    };
    /**
     * @private
     */
    RenderBox.prototype.render_ = function () {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var px = 'px';
        var style = this.element_.style;
        style.left = Math.min(startPixel[0], endPixel[0]) + px;
        style.top = Math.min(startPixel[1], endPixel[1]) + px;
        style.width = Math.abs(endPixel[0] - startPixel[0]) + px;
        style.height = Math.abs(endPixel[1] - startPixel[1]) + px;
    };
    /**
     * @param {import("../PluggableMap.js").default} map Map.
     */
    RenderBox.prototype.setMap = function (map) {
        if (this.map_) {
            this.map_.getOverlayContainer().removeChild(this.element_);
            var style = this.element_.style;
            style.left = 'inherit';
            style.top = 'inherit';
            style.width = 'inherit';
            style.height = 'inherit';
        }
        this.map_ = map;
        if (this.map_) {
            this.map_.getOverlayContainer().appendChild(this.element_);
        }
    };
    /**
     * @param {import("../pixel.js").Pixel} startPixel Start pixel.
     * @param {import("../pixel.js").Pixel} endPixel End pixel.
     */
    RenderBox.prototype.setPixels = function (startPixel, endPixel) {
        this.startPixel_ = startPixel;
        this.endPixel_ = endPixel;
        this.createOrUpdateGeometry();
        this.render_();
    };
    /**
     * Creates or updates the cached geometry.
     */
    RenderBox.prototype.createOrUpdateGeometry = function () {
        var startPixel = this.startPixel_;
        var endPixel = this.endPixel_;
        var pixels = [
            startPixel,
            [startPixel[0], endPixel[1]],
            endPixel,
            [endPixel[0], startPixel[1]],
        ];
        var coordinates = pixels.map(this.map_.getCoordinateFromPixelInternal, this.map_);
        // close the polygon
        coordinates[4] = coordinates[0].slice();
        if (!this.geometry_) {
            this.geometry_ = new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_1__["default"]([coordinates]);
        }
        else {
            this.geometry_.setCoordinates([coordinates]);
        }
    };
    /**
     * @return {import("../geom/Polygon.js").default} Geometry.
     */
    RenderBox.prototype.getGeometry = function () {
        return this.geometry_;
    };
    return RenderBox;
}(_Disposable_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (RenderBox);
//# sourceMappingURL=Box.js.map

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268);
/* harmony import */ var _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(278);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(272);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/KeyboardPan
 */





/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.noModifierKeys} and
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {number} [pixelDelta=128] The amount of pixels to pan on each key
 * press.
 */
/**
 * @classdesc
 * Allows the user to pan the map using keyboard arrows.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardZoom~KeyboardZoom}.
 * @api
 */
var KeyboardPan = /** @class */ (function (_super) {
    __extends(KeyboardPan, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function KeyboardPan(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options || {};
        /**
         * @private
         * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
         * @return {boolean} Combined condition result.
         */
        _this.defaultCondition_ = function (mapBrowserEvent) {
            return (Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_3__["noModifierKeys"])(mapBrowserEvent) && Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_3__["targetNotEditable"])(mapBrowserEvent));
        };
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ =
            options.condition !== undefined
                ? options.condition
                : _this.defaultCondition_;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 100;
        /**
         * @private
         * @type {number}
         */
        _this.pixelDelta_ =
            options.pixelDelta !== undefined ? options.pixelDelta : 128;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides the direction to pan to (if an arrow key was
     * pressed).
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardPan}
     */
    KeyboardPan.prototype.handleEvent = function (mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].KEYDOWN) {
            var keyEvent = /** @type {KeyboardEvent} */ (mapBrowserEvent.originalEvent);
            var keyCode = keyEvent.keyCode;
            if (this.condition_(mapBrowserEvent) &&
                (keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].DOWN ||
                    keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].LEFT ||
                    keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].RIGHT ||
                    keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].UP)) {
                var map = mapBrowserEvent.map;
                var view = map.getView();
                var mapUnitsDelta = view.getResolution() * this.pixelDelta_;
                var deltaX = 0, deltaY = 0;
                if (keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].DOWN) {
                    deltaY = -mapUnitsDelta;
                }
                else if (keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].LEFT) {
                    deltaX = -mapUnitsDelta;
                }
                else if (keyCode == _events_KeyCode_js__WEBPACK_IMPORTED_MODULE_2__["default"].RIGHT) {
                    deltaX = mapUnitsDelta;
                }
                else {
                    deltaY = mapUnitsDelta;
                }
                var delta = [deltaX, deltaY];
                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_4__["rotate"])(delta, view.getRotation());
                Object(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["pan"])(view, delta, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardPan;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (KeyboardPan);
//# sourceMappingURL=KeyboardPan.js.map

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/events/KeyCode
 */
/**
 * @enum {number}
 * @const
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
});
//# sourceMappingURL=KeyCode.js.map

/***/ }),
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(272);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/KeyboardZoom
 */



/**
 * @typedef {Object} Options
 * @property {number} [duration=100] Animation duration in milliseconds.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.targetNotEditable}.
 * @property {number} [delta=1] The zoom level delta on each key press.
 */
/**
 * @classdesc
 * Allows the user to zoom the map using keyboard + and -.
 * Note that, although this interaction is by default included in maps,
 * the keys can only be used when browser focus is on the element to which
 * the keyboard events are attached. By default, this is the map div,
 * though you can change this with the `keyboardEventTarget` in
 * {@link module:ol/Map~Map}. `document` never loses focus but, for any other
 * element, focus will have to be on, and returned to, this element if the keys
 * are to function.
 * See also {@link module:ol/interaction/KeyboardPan~KeyboardPan}.
 * @api
 */
var KeyboardZoom = /** @class */ (function (_super) {
    __extends(KeyboardZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function KeyboardZoom(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_2__["targetNotEditable"];
        /**
         * @private
         * @type {number}
         */
        _this.delta_ = options.delta ? options.delta : 1;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 100;
        return _this;
    }
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} if it was a
     * `KeyEvent`, and decides whether to zoom in or out (depending on whether the
     * key pressed was '+' or '-').
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {KeyboardZoom}
     */
    KeyboardZoom.prototype.handleEvent = function (mapBrowserEvent) {
        var stopEvent = false;
        if (mapBrowserEvent.type == _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].KEYDOWN ||
            mapBrowserEvent.type == _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].KEYPRESS) {
            var keyEvent = /** @type {KeyboardEvent} */ (mapBrowserEvent.originalEvent);
            var charCode = keyEvent.charCode;
            if (this.condition_(mapBrowserEvent) &&
                (charCode == '+'.charCodeAt(0) || charCode == '-'.charCodeAt(0))) {
                var map = mapBrowserEvent.map;
                var delta = charCode == '+'.charCodeAt(0) ? this.delta_ : -this.delta_;
                var view = map.getView();
                Object(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["zoomByDelta"])(view, delta, undefined, this.duration_);
                keyEvent.preventDefault();
                stopEvent = true;
            }
        }
        return !stopEvent;
    };
    return KeyboardZoom;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (KeyboardZoom);
//# sourceMappingURL=KeyboardZoom.js.map

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/Kinetic
 */
/**
 * @classdesc
 * Implementation of inertial deceleration for map movement.
 *
 * @api
 */
var Kinetic = /** @class */ (function () {
    /**
     * @param {number} decay Rate of decay (must be negative).
     * @param {number} minVelocity Minimum velocity (pixels/millisecond).
     * @param {number} delay Delay to consider to calculate the kinetic
     *     initial values (milliseconds).
     */
    function Kinetic(decay, minVelocity, delay) {
        /**
         * @private
         * @type {number}
         */
        this.decay_ = decay;
        /**
         * @private
         * @type {number}
         */
        this.minVelocity_ = minVelocity;
        /**
         * @private
         * @type {number}
         */
        this.delay_ = delay;
        /**
         * @private
         * @type {Array<number>}
         */
        this.points_ = [];
        /**
         * @private
         * @type {number}
         */
        this.angle_ = 0;
        /**
         * @private
         * @type {number}
         */
        this.initialVelocity_ = 0;
    }
    /**
     * FIXME empty description for jsdoc
     */
    Kinetic.prototype.begin = function () {
        this.points_.length = 0;
        this.angle_ = 0;
        this.initialVelocity_ = 0;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     */
    Kinetic.prototype.update = function (x, y) {
        this.points_.push(x, y, Date.now());
    };
    /**
     * @return {boolean} Whether we should do kinetic animation.
     */
    Kinetic.prototype.end = function () {
        if (this.points_.length < 6) {
            // at least 2 points are required (i.e. there must be at least 6 elements
            // in the array)
            return false;
        }
        var delay = Date.now() - this.delay_;
        var lastIndex = this.points_.length - 3;
        if (this.points_[lastIndex + 2] < delay) {
            // the last tracked point is too old, which means that the user stopped
            // panning before releasing the map
            return false;
        }
        // get the first point which still falls into the delay time
        var firstIndex = lastIndex - 3;
        while (firstIndex > 0 && this.points_[firstIndex + 2] > delay) {
            firstIndex -= 3;
        }
        var duration = this.points_[lastIndex + 2] - this.points_[firstIndex + 2];
        // we don't want a duration of 0 (divide by zero)
        // we also make sure the user panned for a duration of at least one frame
        // (1/60s) to compute sane displacement values
        if (duration < 1000 / 60) {
            return false;
        }
        var dx = this.points_[lastIndex] - this.points_[firstIndex];
        var dy = this.points_[lastIndex + 1] - this.points_[firstIndex + 1];
        this.angle_ = Math.atan2(dy, dx);
        this.initialVelocity_ = Math.sqrt(dx * dx + dy * dy) / duration;
        return this.initialVelocity_ > this.minVelocity_;
    };
    /**
     * @return {number} Total distance travelled (pixels).
     */
    Kinetic.prototype.getDistance = function () {
        return (this.minVelocity_ - this.initialVelocity_) / this.decay_;
    };
    /**
     * @return {number} Angle of the kinetic panning animation (radians).
     */
    Kinetic.prototype.getAngle = function () {
        return this.angle_;
    };
    return Kinetic;
}());
/* harmony default export */ __webpack_exports__["default"] = (Kinetic);
//# sourceMappingURL=Kinetic.js.map

/***/ }),
/* 281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mode", function() { return Mode; });
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(268);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(272);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/MouseWheelZoom
 */





/**
 * @enum {string}
 */
var Mode = {
    TRACKPAD: 'trackpad',
    WHEEL: 'wheel',
};
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. Default is
 * {@link module:ol/events/condition.always}.
 * @property {boolean} [onFocusOnly=false] When the map's target has a `tabindex` attribute set,
 * the interaction will only handle events when the map has the focus.
 * @property {number} [maxDelta=1] Maximum mouse wheel delta.
 * @property {number} [duration=250] Animation duration in milliseconds.
 * @property {number} [timeout=80] Mouse wheel timeout duration in milliseconds.
 * @property {boolean} [useAnchor=true] Enable zooming using the mouse's
 * location as the anchor. When set to `false`, zooming in and out will zoom to
 * the center of the screen instead of zooming on the mouse's location.
 * @property {boolean} [constrainResolution=false] If true, the mouse wheel zoom
 * event will always animate to the closest zoom level after an interaction;
 * false means intermediary zoom levels are allowed.
 */
/**
 * @classdesc
 * Allows the user to zoom the map by scrolling the mouse wheel.
 * @api
 */
var MouseWheelZoom = /** @class */ (function (_super) {
    __extends(MouseWheelZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function MouseWheelZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, 
        /** @type {import("./Interaction.js").InteractionOptions} */ (options)) || this;
        /**
         * @private
         * @type {number}
         */
        _this.totalDelta_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.lastDelta_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.maxDelta_ = options.maxDelta !== undefined ? options.maxDelta : 1;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        /**
         * @private
         * @type {number}
         */
        _this.timeout_ = options.timeout !== undefined ? options.timeout : 80;
        /**
         * @private
         * @type {boolean}
         */
        _this.useAnchor_ =
            options.useAnchor !== undefined ? options.useAnchor : true;
        /**
         * @private
         * @type {boolean}
         */
        _this.constrainResolution_ =
            options.constrainResolution !== undefined
                ? options.constrainResolution
                : false;
        var condition = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_3__["always"];
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.onFocusOnly
            ? Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_3__["all"])(_events_condition_js__WEBPACK_IMPORTED_MODULE_3__["focusWithTabindex"], condition)
            : condition;
        /**
         * @private
         * @type {?import("../coordinate.js").Coordinate}
         */
        _this.lastAnchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.startTime_ = undefined;
        /**
         * @private
         * @type {?}
         */
        _this.timeoutId_;
        /**
         * @private
         * @type {Mode|undefined}
         */
        _this.mode_ = undefined;
        /**
         * Trackpad events separated by this delay will be considered separate
         * interactions.
         * @type {number}
         */
        _this.trackpadEventGap_ = 400;
        /**
         * @type {?}
         */
        _this.trackpadTimeoutId_;
        /**
         * The number of delta values per zoom level
         * @private
         * @type {number}
         */
        _this.deltaPerZoom_ = 300;
        return _this;
    }
    /**
     * @private
     */
    MouseWheelZoom.prototype.endInteraction_ = function () {
        this.trackpadTimeoutId_ = undefined;
        var view = this.getMap().getView();
        view.endInteraction(undefined, this.lastDelta_ ? (this.lastDelta_ > 0 ? 1 : -1) : 0, this.lastAnchor_);
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} (if it was a mousewheel-event) and eventually
     * zooms the map.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */
    MouseWheelZoom.prototype.handleEvent = function (mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) {
            return true;
        }
        var type = mapBrowserEvent.type;
        if (type !== _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].WHEEL) {
            return true;
        }
        var map = mapBrowserEvent.map;
        var wheelEvent = /** @type {WheelEvent} */ (mapBrowserEvent.originalEvent);
        wheelEvent.preventDefault();
        if (this.useAnchor_) {
            this.lastAnchor_ = mapBrowserEvent.coordinate;
        }
        // Delta normalisation inspired by
        // https://github.com/mapbox/mapbox-gl-js/blob/001c7b9/js/ui/handler/scroll_zoom.js
        var delta;
        if (mapBrowserEvent.type == _events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].WHEEL) {
            delta = wheelEvent.deltaY;
            if (_has_js__WEBPACK_IMPORTED_MODULE_2__["FIREFOX"] && wheelEvent.deltaMode === WheelEvent.DOM_DELTA_PIXEL) {
                delta /= _has_js__WEBPACK_IMPORTED_MODULE_2__["DEVICE_PIXEL_RATIO"];
            }
            if (wheelEvent.deltaMode === WheelEvent.DOM_DELTA_LINE) {
                delta *= 40;
            }
        }
        if (delta === 0) {
            return false;
        }
        else {
            this.lastDelta_ = delta;
        }
        var now = Date.now();
        if (this.startTime_ === undefined) {
            this.startTime_ = now;
        }
        if (!this.mode_ || now - this.startTime_ > this.trackpadEventGap_) {
            this.mode_ = Math.abs(delta) < 4 ? Mode.TRACKPAD : Mode.WHEEL;
        }
        var view = map.getView();
        if (this.mode_ === Mode.TRACKPAD &&
            !(view.getConstrainResolution() || this.constrainResolution_)) {
            if (this.trackpadTimeoutId_) {
                clearTimeout(this.trackpadTimeoutId_);
            }
            else {
                if (view.getAnimating()) {
                    view.cancelAnimations();
                }
                view.beginInteraction();
            }
            this.trackpadTimeoutId_ = setTimeout(this.endInteraction_.bind(this), this.timeout_);
            view.adjustZoom(-delta / this.deltaPerZoom_, this.lastAnchor_);
            this.startTime_ = now;
            return false;
        }
        this.totalDelta_ += delta;
        var timeLeft = Math.max(this.timeout_ - (now - this.startTime_), 0);
        clearTimeout(this.timeoutId_);
        this.timeoutId_ = setTimeout(this.handleWheelZoom_.bind(this, map), timeLeft);
        return false;
    };
    /**
     * @private
     * @param {import("../PluggableMap.js").default} map Map.
     */
    MouseWheelZoom.prototype.handleWheelZoom_ = function (map) {
        var view = map.getView();
        if (view.getAnimating()) {
            view.cancelAnimations();
        }
        var delta = -Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["clamp"])(this.totalDelta_, -this.maxDelta_ * this.deltaPerZoom_, this.maxDelta_ * this.deltaPerZoom_) / this.deltaPerZoom_;
        if (view.getConstrainResolution() || this.constrainResolution_) {
            // view has a zoom constraint, zoom by 1
            delta = delta ? (delta > 0 ? 1 : -1) : 0;
        }
        Object(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["zoomByDelta"])(view, delta, this.lastAnchor_, this.duration_);
        this.mode_ = undefined;
        this.totalDelta_ = 0;
        this.lastAnchor_ = null;
        this.startTime_ = undefined;
        this.timeoutId_ = undefined;
    };
    /**
     * Enable or disable using the mouse's location as an anchor when zooming
     * @param {boolean} useAnchor true to zoom to the mouse's location, false
     * to zoom to the center of the map
     * @api
     */
    MouseWheelZoom.prototype.setMouseAnchor = function (useAnchor) {
        this.useAnchor_ = useAnchor;
        if (!useAnchor) {
            this.lastAnchor_ = null;
        }
    };
    return MouseWheelZoom;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MouseWheelZoom);
//# sourceMappingURL=MouseWheelZoom.js.map

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(271);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
/* harmony import */ var _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(183);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/PinchRotate
 */



/**
 * @typedef {Object} Options
 * @property {number} [duration=250] The duration of the animation in
 * milliseconds.
 * @property {number} [threshold=0.3] Minimal angle in radians to start a rotation.
 */
/**
 * @classdesc
 * Allows the user to rotate the map by twisting with two fingers
 * on a touch screen.
 * @api
 */
var PinchRotate = /** @class */ (function (_super) {
    __extends(PinchRotate, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function PinchRotate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
        if (!pointerOptions.stopDown) {
            pointerOptions.stopDown = _functions_js__WEBPACK_IMPORTED_MODULE_1__["FALSE"];
        }
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */
        _this.anchor_ = null;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {boolean}
         */
        _this.rotating_ = false;
        /**
         * @private
         * @type {number}
         */
        _this.rotationDelta_ = 0.0;
        /**
         * @private
         * @type {number}
         */
        _this.threshold_ = options.threshold !== undefined ? options.threshold : 0.3;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 250;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    PinchRotate.prototype.handleDragEvent = function (mapBrowserEvent) {
        var rotationDelta = 0.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        // angle between touches
        var angle = Math.atan2(touch1.clientY - touch0.clientY, touch1.clientX - touch0.clientX);
        if (this.lastAngle_ !== undefined) {
            var delta = angle - this.lastAngle_;
            this.rotationDelta_ += delta;
            if (!this.rotating_ && Math.abs(this.rotationDelta_) > this.threshold_) {
                this.rotating_ = true;
            }
            rotationDelta = delta;
        }
        this.lastAngle_ = angle;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (view.getConstraints().rotation === _rotationconstraint_js__WEBPACK_IMPORTED_MODULE_2__["disable"]) {
            return;
        }
        // rotate anchor point.
        // FIXME: should be the intersection point between the lines:
        //     touch0,touch1 and previousTouch0,previousTouch1
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = Object(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["centroid"])(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // rotate
        if (this.rotating_) {
            map.render();
            view.adjustRotationInternal(rotationDelta, this.anchor_);
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    PinchRotate.prototype.handleUpEvent = function (mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            view.endInteraction(this.duration_);
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    PinchRotate.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastAngle_ = undefined;
            this.rotating_ = false;
            this.rotationDelta_ = 0.0;
            if (!this.handlingDownUpSequence) {
                map.getView().beginInteraction();
            }
            return true;
        }
        else {
            return false;
        }
    };
    return PinchRotate;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PinchRotate);
//# sourceMappingURL=PinchRotate.js.map

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(271);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/PinchZoom
 */


/**
 * @typedef {Object} Options
 * @property {number} [duration=400] Animation duration in milliseconds.
 */
/**
 * @classdesc
 * Allows the user to zoom the map by pinching with two fingers
 * on a touch screen.
 * @api
 */
var PinchZoom = /** @class */ (function (_super) {
    __extends(PinchZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function PinchZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
        if (!pointerOptions.stopDown) {
            pointerOptions.stopDown = _functions_js__WEBPACK_IMPORTED_MODULE_1__["FALSE"];
        }
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @private
         * @type {import("../coordinate.js").Coordinate}
         */
        _this.anchor_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 400;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastDistance_ = undefined;
        /**
         * @private
         * @type {number}
         */
        _this.lastScaleDelta_ = 1;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    PinchZoom.prototype.handleDragEvent = function (mapBrowserEvent) {
        var scaleDelta = 1.0;
        var touch0 = this.targetPointers[0];
        var touch1 = this.targetPointers[1];
        var dx = touch0.clientX - touch1.clientX;
        var dy = touch0.clientY - touch1.clientY;
        // distance between touches
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (this.lastDistance_ !== undefined) {
            scaleDelta = this.lastDistance_ / distance;
        }
        this.lastDistance_ = distance;
        var map = mapBrowserEvent.map;
        var view = map.getView();
        if (scaleDelta != 1.0) {
            this.lastScaleDelta_ = scaleDelta;
        }
        // scale anchor point.
        var viewportPosition = map.getViewport().getBoundingClientRect();
        var centroid = Object(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["centroid"])(this.targetPointers);
        centroid[0] -= viewportPosition.left;
        centroid[1] -= viewportPosition.top;
        this.anchor_ = map.getCoordinateFromPixelInternal(centroid);
        // scale, bypass the resolution constraint
        map.render();
        view.adjustResolutionInternal(scaleDelta, this.anchor_);
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    PinchZoom.prototype.handleUpEvent = function (mapBrowserEvent) {
        if (this.targetPointers.length < 2) {
            var map = mapBrowserEvent.map;
            var view = map.getView();
            var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
            view.endInteraction(this.duration_, direction);
            return false;
        }
        else {
            return true;
        }
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    PinchZoom.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (this.targetPointers.length >= 2) {
            var map = mapBrowserEvent.map;
            this.anchor_ = null;
            this.lastDistance_ = undefined;
            this.lastScaleDelta_ = 1;
            if (!this.handlingDownUpSequence) {
                map.getView().beginInteraction();
            }
            return true;
        }
        else {
            return false;
        }
    };
    return PinchZoom;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (PinchZoom);
//# sourceMappingURL=PinchZoom.js.map

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragAndDropEvent", function() { return DragAndDropEvent; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _format_FormatType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(113);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(268);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54);
/**
 * @module ol/interaction/DragAndDrop
 */
// FIXME should handle all geo-referenced data, not just vector data
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();







/**
 * @typedef {Object} Options
 * @property {Array<typeof import("../format/Feature.js").default|import("../format/Feature.js").default>} [formatConstructors] Format constructors
 * (and/or formats pre-constructed with options).
 * @property {import("../source/Vector.js").default} [source] Optional vector source where features will be added.  If a source is provided
 * all existing features will be removed and new features will be added when
 * they are dropped on the target.  If you want to add features to a vector
 * source without removing the existing features (append only), instead of
 * providing the source option listen for the "addfeatures" event.
 * @property {import("../proj.js").ProjectionLike} [projection] Target projection. By default, the map's view's projection is used.
 * @property {HTMLElement} [target] The element that is used as the drop target, default is the viewport element.
 */
/**
 * @enum {string}
 */
var DragAndDropEventType = {
    /**
     * Triggered when features are added
     * @event DragAndDropEvent#addfeatures
     * @api
     */
    ADD_FEATURES: 'addfeatures',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/DragAndDrop~DragAndDrop} instances are instances
 * of this type.
 */
var DragAndDropEvent = /** @class */ (function (_super) {
    __extends(DragAndDropEvent, _super);
    /**
     * @param {DragAndDropEventType} type Type.
     * @param {File} file File.
     * @param {Array<import("../Feature.js").default>} [opt_features] Features.
     * @param {import("../proj/Projection.js").default} [opt_projection] Projection.
     */
    function DragAndDropEvent(type, file, opt_features, opt_projection) {
        var _this = _super.call(this, type) || this;
        /**
         * The features parsed from dropped data.
         * @type {Array<import("../Feature.js").FeatureLike>|undefined}
         * @api
         */
        _this.features = opt_features;
        /**
         * The dropped file.
         * @type {File}
         * @api
         */
        _this.file = file;
        /**
         * The feature projection.
         * @type {import("../proj/Projection.js").default|undefined}
         * @api
         */
        _this.projection = opt_projection;
        return _this;
    }
    return DragAndDropEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'addfeatures', DragAndDropEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'addfeatures', Return>} DragAndDropOnSignature
 */
/**
 * @classdesc
 * Handles input of vector data by drag and drop.
 *
 * Note that the DragAndDrop interaction uses the TextDecoder() constructor if the supplied
 * combinnation of formats read both text string and ArrayBuffer sources. Older browsers such
 * as IE which do not support this will need a TextDecoder polyfill to be loaded before use.
 *
 * @api
 *
 * @fires DragAndDropEvent
 */
var DragAndDrop = /** @class */ (function (_super) {
    __extends(DragAndDrop, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragAndDrop(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, {
            handleEvent: _functions_js__WEBPACK_IMPORTED_MODULE_4__["TRUE"],
        }) || this;
        /***
         * @type {DragAndDropOnSignature<import("../Observable").OnReturn>}
         */
        _this.on;
        /***
         * @type {DragAndDropOnSignature<import("../Observable").OnReturn>}
         */
        _this.once;
        /***
         * @type {DragAndDropOnSignature<void>}
         */
        _this.un;
        /**
         * @private
         * @type {boolean}
         */
        _this.readAsBuffer_ = false;
        /**
         * @private
         * @type {Array<import("../format/Feature.js").default>}
         */
        _this.formats_ = [];
        var formatConstructors = options.formatConstructors
            ? options.formatConstructors
            : [];
        for (var i = 0, ii = formatConstructors.length; i < ii; ++i) {
            var format = formatConstructors[i];
            if (typeof format === 'function') {
                format = new format();
            }
            _this.formats_.push(format);
            _this.readAsBuffer_ =
                _this.readAsBuffer_ || format.getType() === _format_FormatType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ARRAY_BUFFER;
        }
        /**
         * @private
         * @type {import("../proj/Projection.js").default}
         */
        _this.projection_ = options.projection
            ? Object(_proj_js__WEBPACK_IMPORTED_MODULE_5__["get"])(options.projection)
            : null;
        /**
         * @private
         * @type {?Array<import("../events.js").EventsKey>}
         */
        _this.dropListenKeys_ = null;
        /**
         * @private
         * @type {import("../source/Vector.js").default}
         */
        _this.source_ = options.source || null;
        /**
         * @private
         * @type {HTMLElement}
         */
        _this.target = options.target ? options.target : null;
        return _this;
    }
    /**
     * @param {File} file File.
     * @param {Event} event Load event.
     * @private
     */
    DragAndDrop.prototype.handleResult_ = function (file, event) {
        var result = event.target.result;
        var map = this.getMap();
        var projection = this.projection_;
        if (!projection) {
            var view = map.getView();
            projection = view.getProjection();
        }
        var text;
        var formats = this.formats_;
        for (var i = 0, ii = formats.length; i < ii; ++i) {
            var format = formats[i];
            var input = result;
            if (this.readAsBuffer_ && format.getType() !== _format_FormatType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ARRAY_BUFFER) {
                if (text === undefined) {
                    text = new TextDecoder().decode(result);
                }
                input = text;
            }
            var features = this.tryReadFeatures_(format, input, {
                featureProjection: projection,
            });
            if (features && features.length > 0) {
                if (this.source_) {
                    this.source_.clear();
                    this.source_.addFeatures(features);
                }
                this.dispatchEvent(new DragAndDropEvent(DragAndDropEventType.ADD_FEATURES, file, features, projection));
                break;
            }
        }
    };
    /**
     * @private
     */
    DragAndDrop.prototype.registerListeners_ = function () {
        var map = this.getMap();
        if (map) {
            var dropArea = this.target ? this.target : map.getViewport();
            this.dropListenKeys_ = [
                Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(dropArea, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].DROP, this.handleDrop, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(dropArea, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAGENTER, this.handleStop, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(dropArea, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAGOVER, this.handleStop, this),
                Object(_events_js__WEBPACK_IMPORTED_MODULE_6__["listen"])(dropArea, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].DROP, this.handleStop, this),
            ];
        }
    };
    /**
     * Activate or deactivate the interaction.
     * @param {boolean} active Active.
     * @observable
     * @api
     */
    DragAndDrop.prototype.setActive = function (active) {
        if (!this.getActive() && active) {
            this.registerListeners_();
        }
        if (this.getActive() && !active) {
            this.unregisterListeners_();
        }
        _super.prototype.setActive.call(this, active);
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    DragAndDrop.prototype.setMap = function (map) {
        this.unregisterListeners_();
        _super.prototype.setMap.call(this, map);
        if (this.getActive()) {
            this.registerListeners_();
        }
    };
    /**
     * @param {import("../format/Feature.js").default} format Format.
     * @param {string} text Text.
     * @param {import("../format/Feature.js").ReadOptions} options Read options.
     * @private
     * @return {Array<import("../Feature.js").default>} Features.
     */
    DragAndDrop.prototype.tryReadFeatures_ = function (format, text, options) {
        try {
            return (
            /** @type {Array<import("../Feature.js").default>} */
            (format.readFeatures(text, options)));
        }
        catch (e) {
            return null;
        }
    };
    /**
     * @private
     */
    DragAndDrop.prototype.unregisterListeners_ = function () {
        if (this.dropListenKeys_) {
            this.dropListenKeys_.forEach(_events_js__WEBPACK_IMPORTED_MODULE_6__["unlistenByKey"]);
            this.dropListenKeys_ = null;
        }
    };
    /**
     * @param {DragEvent} event Event.
     */
    DragAndDrop.prototype.handleDrop = function (event) {
        var files = event.dataTransfer.files;
        for (var i = 0, ii = files.length; i < ii; ++i) {
            var file = files.item(i);
            var reader = new FileReader();
            reader.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].LOAD, this.handleResult_.bind(this, file));
            if (this.readAsBuffer_) {
                reader.readAsArrayBuffer(file);
            }
            else {
                reader.readAsText(file);
            }
        }
    };
    /**
     * @param {DragEvent} event Event.
     */
    DragAndDrop.prototype.handleStop = function (event) {
        event.stopPropagation();
        event.preventDefault();
        event.dataTransfer.dropEffect = 'copy';
    };
    return DragAndDrop;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragAndDrop);
//# sourceMappingURL=DragAndDrop.js.map

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(271);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(272);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/DragRotateAndZoom
 */


/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.shiftKeyOnly}.
 * @property {number} [duration=400] Animation duration in milliseconds.
 */
/**
 * @classdesc
 * Allows the user to zoom and rotate the map by clicking and dragging
 * on the map.  By default, this interaction is limited to when the shift
 * key is held down.
 *
 * This interaction is only supported for mouse devices.
 *
 * And this interaction is not included in the default interactions.
 * @api
 */
var DragRotateAndZoom = /** @class */ (function (_super) {
    __extends(DragRotateAndZoom, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function DragRotateAndZoom(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Pointer.js").Options} */ (options)) || this;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_1__["shiftKeyOnly"];
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastAngle_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.lastMagnitude_ = undefined;
        /**
         * @private
         * @type {number}
         */
        _this.lastScaleDelta_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.duration_ = options.duration !== undefined ? options.duration : 400;
        return _this;
    }
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    DragRotateAndZoom.prototype.handleDragEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_1__["mouseOnly"])(mapBrowserEvent)) {
            return;
        }
        var map = mapBrowserEvent.map;
        var size = map.getSize();
        var offset = mapBrowserEvent.pixel;
        var deltaX = offset[0] - size[0] / 2;
        var deltaY = size[1] / 2 - offset[1];
        var theta = Math.atan2(deltaY, deltaX);
        var magnitude = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        var view = map.getView();
        if (this.lastAngle_ !== undefined) {
            var angleDelta = this.lastAngle_ - theta;
            view.adjustRotationInternal(angleDelta);
        }
        this.lastAngle_ = theta;
        if (this.lastMagnitude_ !== undefined) {
            view.adjustResolutionInternal(this.lastMagnitude_ / magnitude);
        }
        if (this.lastMagnitude_ !== undefined) {
            this.lastScaleDelta_ = this.lastMagnitude_ / magnitude;
        }
        this.lastMagnitude_ = magnitude;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragRotateAndZoom.prototype.handleUpEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_1__["mouseOnly"])(mapBrowserEvent)) {
            return true;
        }
        var map = mapBrowserEvent.map;
        var view = map.getView();
        var direction = this.lastScaleDelta_ > 1 ? 1 : -1;
        view.endInteraction(this.duration_, direction);
        this.lastScaleDelta_ = 0;
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    DragRotateAndZoom.prototype.handleDownEvent = function (mapBrowserEvent) {
        if (!Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_1__["mouseOnly"])(mapBrowserEvent)) {
            return false;
        }
        if (this.condition_(mapBrowserEvent)) {
            mapBrowserEvent.map.getView().beginInteraction();
            this.lastAngle_ = undefined;
            this.lastMagnitude_ = undefined;
            return true;
        }
        else {
            return false;
        }
    };
    return DragRotateAndZoom;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (DragRotateAndZoom);
//# sourceMappingURL=DragRotateAndZoom.js.map

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DrawEvent", function() { return DrawEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createRegularPolygon", function() { return createRegularPolygon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBox", function() { return createBox; });
/* harmony import */ var _geom_Circle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23);
/* harmony import */ var _Property_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(269);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(203);
/* harmony import */ var _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(175);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(178);
/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(206);
/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(207);
/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(208);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(271);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(184);
/* harmony import */ var _layer_Vector_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(288);
/* harmony import */ var _source_Vector_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(105);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(51);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(272);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(65);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(7);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Draw
 */























/**
 * @typedef {Object} Options
 * @property {import("../geom/GeometryType.js").default} type Geometry type of
 * the geometries being drawn with this instance.
 * @property {number} [clickTolerance=6] The maximum distance in pixels between
 * "down" and "up" for a "up" event to be considered a "click" event and
 * actually add a point/vertex to the geometry being drawn.  The default of `6`
 * was chosen for the draw interaction to behave correctly on mouse as well as
 * on touch devices.
 * @property {import("../Collection.js").default<Feature>} [features]
 * Destination collection for the drawn features.
 * @property {VectorSource} [source] Destination source for
 * the drawn features.
 * @property {number} [dragVertexDelay=500] Delay in milliseconds after pointerdown
 * before the current vertex can be dragged to its exact position.
 * @property {number} [snapTolerance=12] Pixel distance for snapping to the
 * drawing finish. Must be greater than `0`.
 * @property {boolean} [stopClick=false] Stop click, singleclick, and
 * doubleclick events from firing during drawing.
 * @property {number} [maxPoints] The number of points that can be drawn before
 * a polygon ring or line string is finished. By default there is no
 * restriction.
 * @property {number} [minPoints] The number of points that must be drawn
 * before a polygon ring or line string can be finished. Default is `3` for
 * polygon rings and `2` for line strings.
 * @property {import("../events/condition.js").Condition} [finishCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether the drawing can be finished. Not used when drawing
 * POINT or MULTI_POINT geometries.
 * @property {import("../style/Style.js").StyleLike} [style]
 * Style for sketch features.
 * @property {GeometryFunction} [geometryFunction]
 * Function that is called when a geometry's coordinates are updated.
 * @property {string} [geometryName] Geometry name to use for features created
 * by the draw interaction.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default {@link module:ol/events/condition.noModifierKeys}, i.e. a click,
 * adds a vertex or deactivates freehand drawing.
 * @property {boolean} [freehand=false] Operate in freehand mode for lines,
 * polygons, and circles.  This makes the interaction always operate in freehand
 * mode and takes precedence over any `freehandCondition` option.
 * @property {import("../events/condition.js").Condition} [freehandCondition]
 * Condition that activates freehand drawing for lines and polygons. This
 * function takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether that event should be handled. The
 * default is {@link module:ol/events/condition.shiftKeyOnly}, meaning that the
 * Shift key activates freehand drawing.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 */
/**
 * Coordinate type when drawing points.
 * @typedef {import("../coordinate.js").Coordinate} PointCoordType
 */
/**
 * Coordinate type when drawing lines.
 * @typedef {Array<import("../coordinate.js").Coordinate>} LineCoordType
 */
/**
 * Coordinate type when drawing polygons.
 * @typedef {Array<Array<import("../coordinate.js").Coordinate>>} PolyCoordType
 */
/**
 * Types used for drawing coordinates.
 * @typedef {PointCoordType|LineCoordType|PolyCoordType} SketchCoordType
 */
/**
 * Function that takes an array of coordinates and an optional existing geometry
 * and a projection as arguments, and returns a geometry. The optional existing
 * geometry is the geometry that is returned when the function is called without
 * a second argument.
 * @typedef {function(!SketchCoordType, import("../geom/SimpleGeometry.js").default,
 *     import("../proj/Projection.js").default):
 *     import("../geom/SimpleGeometry.js").default} GeometryFunction
 */
/**
 * Draw mode.  This collapses multi-part geometry types with their single-part
 * cousins.
 * @enum {string}
 */
var Mode = {
    POINT: 'Point',
    LINE_STRING: 'LineString',
    POLYGON: 'Polygon',
    CIRCLE: 'Circle',
};
/**
 * @enum {string}
 */
var DrawEventType = {
    /**
     * Triggered upon feature draw start
     * @event DrawEvent#drawstart
     * @api
     */
    DRAWSTART: 'drawstart',
    /**
     * Triggered upon feature draw end
     * @event DrawEvent#drawend
     * @api
     */
    DRAWEND: 'drawend',
    /**
     * Triggered upon feature draw abortion
     * @event DrawEvent#drawabort
     * @api
     */
    DRAWABORT: 'drawabort',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Draw~Draw} instances are
 * instances of this type.
 */
var DrawEvent = /** @class */ (function (_super) {
    __extends(DrawEvent, _super);
    /**
     * @param {DrawEventType} type Type.
     * @param {Feature} feature The feature drawn.
     */
    function DrawEvent(type, feature) {
        var _this = _super.call(this, type) || this;
        /**
         * The feature being drawn.
         * @type {Feature}
         * @api
         */
        _this.feature = feature;
        return _this;
    }
    return DrawEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_1__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'drawabort'|'drawend'|'drawstart', DrawEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'drawabort'|'drawend'|'drawstart', Return>} DrawOnSignature
 */
/**
 * @classdesc
 * Interaction for drawing feature geometries.
 *
 * @fires DrawEvent
 * @api
 */
var Draw = /** @class */ (function (_super) {
    __extends(Draw, _super);
    /**
     * @param {Options} options Options.
     */
    function Draw(options) {
        var _this = this;
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
        if (!pointerOptions.stopDown) {
            pointerOptions.stopDown = _functions_js__WEBPACK_IMPORTED_MODULE_17__["FALSE"];
        }
        _this = _super.call(this, pointerOptions) || this;
        /***
         * @type {DrawOnSignature<import("../Observable").OnReturn>}
         */
        _this.on;
        /***
         * @type {DrawOnSignature<import("../Observable").OnReturn>}
         */
        _this.once;
        /***
         * @type {DrawOnSignature<void>}
         */
        _this.un;
        /**
         * @type {boolean}
         * @private
         */
        _this.shouldHandle_ = false;
        /**
         * @type {import("../pixel.js").Pixel}
         * @private
         */
        _this.downPx_ = null;
        /**
         * @type {?}
         * @private
         */
        _this.downTimeout_;
        /**
         * @type {number|undefined}
         * @private
         */
        _this.lastDragTime_;
        /**
         * Pointer type of the last pointermove event
         * @type {string}
         * @private
         */
        _this.pointerType_;
        /**
         * @type {boolean}
         * @private
         */
        _this.freehand_ = false;
        /**
         * Target source for drawn features.
         * @type {VectorSource}
         * @private
         */
        _this.source_ = options.source ? options.source : null;
        /**
         * Target collection for drawn features.
         * @type {import("../Collection.js").default<Feature>}
         * @private
         */
        _this.features_ = options.features ? options.features : null;
        /**
         * Pixel distance for snapping.
         * @type {number}
         * @private
         */
        _this.snapTolerance_ = options.snapTolerance ? options.snapTolerance : 12;
        /**
         * Geometry type.
         * @type {import("../geom/GeometryType.js").default}
         * @private
         */
        _this.type_ = /** @type {import("../geom/GeometryType.js").default} */ (options.type);
        /**
         * Drawing mode (derived from geometry type.
         * @type {Mode}
         * @private
         */
        _this.mode_ = getMode(_this.type_);
        /**
         * Stop click, singleclick, and doubleclick events from firing during drawing.
         * Default is `false`.
         * @type {boolean}
         * @private
         */
        _this.stopClick_ = !!options.stopClick;
        /**
         * The number of points that must be drawn before a polygon ring or line
         * string can be finished.  The default is 3 for polygon rings and 2 for
         * line strings.
         * @type {number}
         * @private
         */
        _this.minPoints_ = options.minPoints
            ? options.minPoints
            : _this.mode_ === Mode.POLYGON
                ? 3
                : 2;
        /**
         * The number of points that can be drawn before a polygon ring or line string
         * is finished. The default is no restriction.
         * @type {number}
         * @private
         */
        _this.maxPoints_ =
            _this.mode_ === Mode.CIRCLE
                ? 2
                : options.maxPoints
                    ? options.maxPoints
                    : Infinity;
        /**
         * A function to decide if a potential finish coordinate is permissible
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.finishCondition_ = options.finishCondition
            ? options.finishCondition
            : _functions_js__WEBPACK_IMPORTED_MODULE_17__["TRUE"];
        var geometryFunction = options.geometryFunction;
        if (!geometryFunction) {
            var mode_1 = _this.mode_;
            if (mode_1 === Mode.CIRCLE) {
                /**
                 * @param {!LineCoordType} coordinates The coordinates.
                 * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
                 * @param {import("../proj/Projection.js").default} projection The view projection.
                 * @return {import("../geom/SimpleGeometry.js").default} A geometry.
                 */
                geometryFunction = function (coordinates, geometry, projection) {
                    var circle = geometry
                        ? /** @type {Circle} */ (geometry)
                        : new _geom_Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]([NaN, NaN]);
                    var center = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["fromUserCoordinate"])(coordinates[0], projection);
                    var squaredLength = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_22__["squaredDistance"])(center, Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["fromUserCoordinate"])(coordinates[coordinates.length - 1], projection));
                    circle.setCenterAndRadius(center, Math.sqrt(squaredLength));
                    var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["getUserProjection"])();
                    if (userProjection) {
                        circle.transform(projection, userProjection);
                    }
                    return circle;
                };
            }
            else {
                var Constructor_1;
                if (mode_1 === Mode.POINT) {
                    Constructor_1 = _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"];
                }
                else if (mode_1 === Mode.LINE_STRING) {
                    Constructor_1 = _geom_LineString_js__WEBPACK_IMPORTED_MODULE_6__["default"];
                }
                else if (mode_1 === Mode.POLYGON) {
                    Constructor_1 = _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__["default"];
                }
                /**
                 * @param {!LineCoordType} coordinates The coordinates.
                 * @param {import("../geom/SimpleGeometry.js").default|undefined} geometry Optional geometry.
                 * @param {import("../proj/Projection.js").default} projection The view projection.
                 * @return {import("../geom/SimpleGeometry.js").default} A geometry.
                 */
                geometryFunction = function (coordinates, geometry, projection) {
                    if (geometry) {
                        if (mode_1 === Mode.POLYGON) {
                            if (coordinates[0].length) {
                                // Add a closing coordinate to match the first
                                geometry.setCoordinates([
                                    coordinates[0].concat([coordinates[0][0]]),
                                ]);
                            }
                            else {
                                geometry.setCoordinates([]);
                            }
                        }
                        else {
                            geometry.setCoordinates(coordinates);
                        }
                    }
                    else {
                        geometry = new Constructor_1(coordinates);
                    }
                    return geometry;
                };
            }
        }
        /**
         * @type {GeometryFunction}
         * @private
         */
        _this.geometryFunction_ = geometryFunction;
        /**
         * @type {number}
         * @private
         */
        _this.dragVertexDelay_ =
            options.dragVertexDelay !== undefined ? options.dragVertexDelay : 500;
        /**
         * Finish coordinate for the feature (first point for polygons, last point for
         * linestrings).
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.finishCoordinate_ = null;
        /**
         * Sketch feature.
         * @type {Feature}
         * @private
         */
        _this.sketchFeature_ = null;
        /**
         * Sketch point.
         * @type {Feature<Point>}
         * @private
         */
        _this.sketchPoint_ = null;
        /**
         * Sketch coordinates. Used when drawing a line or polygon.
         * @type {SketchCoordType}
         * @private
         */
        _this.sketchCoords_ = null;
        /**
         * Sketch line. Used when drawing polygon.
         * @type {Feature<LineString>}
         * @private
         */
        _this.sketchLine_ = null;
        /**
         * Sketch line coordinates. Used when drawing a polygon or circle.
         * @type {LineCoordType}
         * @private
         */
        _this.sketchLineCoords_ = null;
        /**
         * Squared tolerance for handling up events.  If the squared distance
         * between a down and up event is greater than this tolerance, up events
         * will not be handled.
         * @type {number}
         * @private
         */
        _this.squaredClickTolerance_ = options.clickTolerance
            ? options.clickTolerance * options.clickTolerance
            : 36;
        /**
         * Draw overlay where our sketch features are drawn.
         * @type {VectorLayer}
         * @private
         */
        _this.overlay_ = new _layer_Vector_js__WEBPACK_IMPORTED_MODULE_15__["default"]({
            source: new _source_Vector_js__WEBPACK_IMPORTED_MODULE_16__["default"]({
                useSpatialIndex: false,
                wrapX: options.wrapX ? options.wrapX : false,
            }),
            style: options.style ? options.style : getDefaultStyleFunction(),
            updateWhileInteracting: true,
        });
        /**
         * Name of the geometry attribute for newly created features.
         * @type {string|undefined}
         * @private
         */
        _this.geometryName_ = options.geometryName;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_18__["noModifierKeys"];
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.freehandCondition_;
        if (options.freehand) {
            _this.freehandCondition_ = _events_condition_js__WEBPACK_IMPORTED_MODULE_18__["always"];
        }
        else {
            _this.freehandCondition_ = options.freehandCondition
                ? options.freehandCondition
                : _events_condition_js__WEBPACK_IMPORTED_MODULE_18__["shiftKeyOnly"];
        }
        _this.addChangeListener(_Property_js__WEBPACK_IMPORTED_MODULE_5__["default"].ACTIVE, _this.updateState_);
        return _this;
    }
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Draw.prototype.setMap = function (map) {
        _super.prototype.setMap.call(this, map);
        this.updateState_();
    };
    /**
     * Get the overlay layer that this interaction renders sketch features to.
     * @return {VectorLayer} Overlay layer.
     * @api
     */
    Draw.prototype.getOverlay = function () {
        return this.overlay_;
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} and may actually draw or finish the drawing.
     * @param {import("../MapBrowserEvent.js").default} event Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @api
     */
    Draw.prototype.handleEvent = function (event) {
        if (event.originalEvent.type === _events_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CONTEXTMENU) {
            // Avoid context menu for long taps when drawing on mobile
            event.originalEvent.preventDefault();
        }
        this.freehand_ =
            this.mode_ !== Mode.POINT && this.freehandCondition_(event);
        var move = event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERMOVE;
        var pass = true;
        if (!this.freehand_ &&
            this.lastDragTime_ &&
            event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERDRAG) {
            var now = Date.now();
            if (now - this.lastDragTime_ >= this.dragVertexDelay_) {
                this.downPx_ = event.pixel;
                this.shouldHandle_ = !this.freehand_;
                move = true;
            }
            else {
                this.lastDragTime_ = undefined;
            }
            if (this.shouldHandle_ && this.downTimeout_ !== undefined) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
        }
        if (this.freehand_ &&
            event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERDRAG &&
            this.sketchFeature_ !== null) {
            this.addToDrawing_(event.coordinate);
            pass = false;
        }
        else if (this.freehand_ &&
            event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERDOWN) {
            pass = false;
        }
        else if (move && this.getPointerCount() < 2) {
            pass = event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERMOVE;
            if (pass && this.freehand_) {
                this.handlePointerMove_(event);
                if (this.shouldHandle_) {
                    // Avoid page scrolling when freehand drawing on mobile
                    event.originalEvent.preventDefault();
                }
            }
            else if (event.originalEvent.pointerType === 'mouse' ||
                (event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERDRAG &&
                    this.downTimeout_ === undefined)) {
                this.handlePointerMove_(event);
            }
        }
        else if (event.type === _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].DBLCLICK) {
            pass = false;
        }
        return _super.prototype.handleEvent.call(this, event) && pass;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} If the event was consumed.
     */
    Draw.prototype.handleDownEvent = function (event) {
        this.shouldHandle_ = !this.freehand_;
        if (this.freehand_) {
            this.downPx_ = event.pixel;
            if (!this.finishCoordinate_) {
                this.startDrawing_(event.coordinate);
            }
            return true;
        }
        else if (this.condition_(event)) {
            this.lastDragTime_ = Date.now();
            this.downTimeout_ = setTimeout(function () {
                this.handlePointerMove_(new _MapBrowserEvent_js__WEBPACK_IMPORTED_MODULE_7__["default"](_MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_8__["default"].POINTERMOVE, event.map, event.originalEvent, false, event.frameState));
            }.bind(this), this.dragVertexDelay_);
            this.downPx_ = event.pixel;
            return true;
        }
        else {
            this.lastDragTime_ = undefined;
            return false;
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} If the event was consumed.
     */
    Draw.prototype.handleUpEvent = function (event) {
        var pass = true;
        if (this.getPointerCount() === 0) {
            if (this.downTimeout_) {
                clearTimeout(this.downTimeout_);
                this.downTimeout_ = undefined;
            }
            this.handlePointerMove_(event);
            if (this.shouldHandle_) {
                var startingToDraw = !this.finishCoordinate_;
                if (startingToDraw) {
                    this.startDrawing_(event.coordinate);
                }
                if (!startingToDraw && this.freehand_) {
                    this.finishDrawing();
                }
                else if (!this.freehand_ &&
                    (!startingToDraw || this.mode_ === Mode.POINT)) {
                    if (this.atFinish_(event.pixel)) {
                        if (this.finishCondition_(event)) {
                            this.finishDrawing();
                        }
                    }
                    else {
                        this.addToDrawing_(event.coordinate);
                    }
                }
                pass = false;
            }
            else if (this.freehand_) {
                this.abortDrawing();
            }
        }
        if (!pass && this.stopClick_) {
            event.preventDefault();
        }
        return pass;
    };
    /**
     * Handle move events.
     * @param {import("../MapBrowserEvent.js").default} event A move event.
     * @private
     */
    Draw.prototype.handlePointerMove_ = function (event) {
        this.pointerType_ = event.originalEvent.pointerType;
        if (this.downPx_ &&
            ((!this.freehand_ && this.shouldHandle_) ||
                (this.freehand_ && !this.shouldHandle_))) {
            var downPx = this.downPx_;
            var clickPx = event.pixel;
            var dx = downPx[0] - clickPx[0];
            var dy = downPx[1] - clickPx[1];
            var squaredDistance = dx * dx + dy * dy;
            this.shouldHandle_ = this.freehand_
                ? squaredDistance > this.squaredClickTolerance_
                : squaredDistance <= this.squaredClickTolerance_;
            if (!this.shouldHandle_) {
                return;
            }
        }
        if (this.finishCoordinate_) {
            this.modifyDrawing_(event.coordinate);
        }
        else {
            this.createOrUpdateSketchPoint_(event);
        }
    };
    /**
     * Determine if an event is within the snapping tolerance of the start coord.
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {boolean} The event is within the snapping tolerance of the start.
     * @private
     */
    Draw.prototype.atFinish_ = function (pixel) {
        var at = false;
        if (this.sketchFeature_) {
            var potentiallyDone = false;
            var potentiallyFinishCoordinates = [this.finishCoordinate_];
            var mode = this.mode_;
            if (mode === Mode.POINT) {
                at = true;
            }
            else if (mode === Mode.CIRCLE) {
                at = this.sketchCoords_.length === 2;
            }
            else if (mode === Mode.LINE_STRING) {
                potentiallyDone = this.sketchCoords_.length > this.minPoints_;
            }
            else if (mode === Mode.POLYGON) {
                var sketchCoords = /** @type {PolyCoordType} */ (this.sketchCoords_);
                potentiallyDone = sketchCoords[0].length > this.minPoints_;
                potentiallyFinishCoordinates = [
                    sketchCoords[0][0],
                    sketchCoords[0][sketchCoords[0].length - 2],
                ];
            }
            if (potentiallyDone) {
                var map = this.getMap();
                for (var i = 0, ii = potentiallyFinishCoordinates.length; i < ii; i++) {
                    var finishCoordinate = potentiallyFinishCoordinates[i];
                    var finishPixel = map.getPixelFromCoordinate(finishCoordinate);
                    var dx = pixel[0] - finishPixel[0];
                    var dy = pixel[1] - finishPixel[1];
                    var snapTolerance = this.freehand_ ? 1 : this.snapTolerance_;
                    at = Math.sqrt(dx * dx + dy * dy) <= snapTolerance;
                    if (at) {
                        this.finishCoordinate_ = finishCoordinate;
                        break;
                    }
                }
            }
        }
        return at;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @private
     */
    Draw.prototype.createOrUpdateSketchPoint_ = function (event) {
        var coordinates = event.coordinate.slice();
        if (!this.sketchPoint_) {
            this.sketchPoint_ = new _Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"](new _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](coordinates));
            this.updateSketchFeatures_();
        }
        else {
            var sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinates);
        }
    };
    /**
     * @param {import("../geom/Polygon.js").default} geometry Polygon geometry.
     * @private
     */
    Draw.prototype.createOrUpdateCustomSketchLine_ = function (geometry) {
        if (!this.sketchLine_) {
            this.sketchLine_ = new _Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"]();
        }
        var ring = geometry.getLinearRing(0);
        var sketchLineGeom = this.sketchLine_.getGeometry();
        if (!sketchLineGeom) {
            sketchLineGeom = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_6__["default"](ring.getFlatCoordinates(), ring.getLayout());
            this.sketchLine_.setGeometry(sketchLineGeom);
        }
        else {
            sketchLineGeom.setFlatCoordinates(ring.getLayout(), ring.getFlatCoordinates());
            sketchLineGeom.changed();
        }
    };
    /**
     * Start the drawing.
     * @param {import("../coordinate.js").Coordinate} start Start coordinate.
     * @private
     */
    Draw.prototype.startDrawing_ = function (start) {
        var projection = this.getMap().getView().getProjection();
        this.finishCoordinate_ = start;
        if (this.mode_ === Mode.POINT) {
            this.sketchCoords_ = start.slice();
        }
        else if (this.mode_ === Mode.POLYGON) {
            this.sketchCoords_ = [[start.slice(), start.slice()]];
            this.sketchLineCoords_ = this.sketchCoords_[0];
        }
        else {
            this.sketchCoords_ = [start.slice(), start.slice()];
        }
        if (this.sketchLineCoords_) {
            this.sketchLine_ = new _Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"](new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_6__["default"](this.sketchLineCoords_));
        }
        var geometry = this.geometryFunction_(this.sketchCoords_, undefined, projection);
        this.sketchFeature_ = new _Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"]();
        if (this.geometryName_) {
            this.sketchFeature_.setGeometryName(this.geometryName_);
        }
        this.sketchFeature_.setGeometry(geometry);
        this.updateSketchFeatures_();
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
    };
    /**
     * Modify the drawing.
     * @param {import("../coordinate.js").Coordinate} coordinate Coordinate.
     * @private
     */
    Draw.prototype.modifyDrawing_ = function (coordinate) {
        var map = this.getMap();
        var geometry = this.sketchFeature_.getGeometry();
        var projection = map.getView().getProjection();
        var coordinates, last;
        if (this.mode_ === Mode.POINT) {
            last = this.sketchCoords_;
        }
        else if (this.mode_ === Mode.POLYGON) {
            coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
            last = coordinates[coordinates.length - 1];
            if (this.atFinish_(map.getPixelFromCoordinate(coordinate))) {
                // snap to finish
                coordinate = this.finishCoordinate_.slice();
            }
        }
        else {
            coordinates = this.sketchCoords_;
            last = coordinates[coordinates.length - 1];
        }
        last[0] = coordinate[0];
        last[1] = coordinate[1];
        this.geometryFunction_(
        /** @type {!LineCoordType} */ (this.sketchCoords_), geometry, projection);
        if (this.sketchPoint_) {
            var sketchPointGeom = this.sketchPoint_.getGeometry();
            sketchPointGeom.setCoordinates(coordinate);
        }
        if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON &&
            this.mode_ !== Mode.POLYGON) {
            this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ (geometry));
        }
        else if (this.sketchLineCoords_) {
            var sketchLineGeom = this.sketchLine_.getGeometry();
            sketchLineGeom.setCoordinates(this.sketchLineCoords_);
        }
        this.updateSketchFeatures_();
    };
    /**
     * Add a new coordinate to the drawing.
     * @param {!PointCoordType} coordinate Coordinate
     * @private
     */
    Draw.prototype.addToDrawing_ = function (coordinate) {
        var geometry = this.sketchFeature_.getGeometry();
        var projection = this.getMap().getView().getProjection();
        var done;
        var coordinates;
        var mode = this.mode_;
        if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
            this.finishCoordinate_ = coordinate.slice();
            coordinates = /** @type {LineCoordType} */ (this.sketchCoords_);
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) {
                    coordinates.pop();
                }
                else {
                    done = true;
                }
            }
            coordinates.push(coordinate.slice());
            this.geometryFunction_(coordinates, geometry, projection);
        }
        else if (mode === Mode.POLYGON) {
            coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
            if (coordinates.length >= this.maxPoints_) {
                if (this.freehand_) {
                    coordinates.pop();
                }
                else {
                    done = true;
                }
            }
            coordinates.push(coordinate.slice());
            if (done) {
                this.finishCoordinate_ = coordinates[0];
            }
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        this.updateSketchFeatures_();
        if (done) {
            this.finishDrawing();
        }
    };
    /**
     * Remove last point of the feature currently being drawn. Does not do anything when
     * drawing POINT or MULTI_POINT geometries.
     * @api
     */
    Draw.prototype.removeLastPoint = function () {
        if (!this.sketchFeature_) {
            return;
        }
        var geometry = this.sketchFeature_.getGeometry();
        var projection = this.getMap().getView().getProjection();
        var coordinates;
        var mode = this.mode_;
        if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
            coordinates = /** @type {LineCoordType} */ (this.sketchCoords_);
            coordinates.splice(-2, 1);
            if (coordinates.length >= 2) {
                this.finishCoordinate_ = coordinates[coordinates.length - 2].slice();
                var finishCoordinate = this.finishCoordinate_.slice();
                coordinates[coordinates.length - 1] = finishCoordinate;
                this.sketchPoint_.setGeometry(new _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](finishCoordinate));
            }
            this.geometryFunction_(coordinates, geometry, projection);
            if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON && this.sketchLine_) {
                this.createOrUpdateCustomSketchLine_(/** @type {Polygon} */ (geometry));
            }
        }
        else if (mode === Mode.POLYGON) {
            coordinates = /** @type {PolyCoordType} */ (this.sketchCoords_)[0];
            coordinates.splice(-2, 1);
            var sketchLineGeom = this.sketchLine_.getGeometry();
            if (coordinates.length >= 2) {
                var finishCoordinate = coordinates[coordinates.length - 2].slice();
                coordinates[coordinates.length - 1] = finishCoordinate;
                this.sketchPoint_.setGeometry(new _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](finishCoordinate));
            }
            sketchLineGeom.setCoordinates(coordinates);
            this.geometryFunction_(this.sketchCoords_, geometry, projection);
        }
        if (coordinates.length === 1) {
            this.abortDrawing();
        }
        this.updateSketchFeatures_();
    };
    /**
     * Stop drawing and add the sketch feature to the target layer.
     * The {@link module:ol/interaction/Draw~DrawEventType.DRAWEND} event is
     * dispatched before inserting the feature.
     * @api
     */
    Draw.prototype.finishDrawing = function () {
        var sketchFeature = this.abortDrawing_();
        if (!sketchFeature) {
            return;
        }
        var coordinates = this.sketchCoords_;
        var geometry = sketchFeature.getGeometry();
        var projection = this.getMap().getView().getProjection();
        if (this.mode_ === Mode.LINE_STRING) {
            // remove the redundant last point
            coordinates.pop();
            this.geometryFunction_(coordinates, geometry, projection);
        }
        else if (this.mode_ === Mode.POLYGON) {
            // remove the redundant last point in ring
            /** @type {PolyCoordType} */ (coordinates)[0].pop();
            this.geometryFunction_(coordinates, geometry, projection);
            coordinates = geometry.getCoordinates();
        }
        // cast multi-part geometries
        if (this.type_ === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT) {
            sketchFeature.setGeometry(new _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_10__["default"]([/** @type {PointCoordType} */ (coordinates)]));
        }
        else if (this.type_ === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING) {
            sketchFeature.setGeometry(new _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_9__["default"]([/** @type {LineCoordType} */ (coordinates)]));
        }
        else if (this.type_ === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON) {
            sketchFeature.setGeometry(new _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_11__["default"]([/** @type {PolyCoordType} */ (coordinates)]));
        }
        // First dispatch event to allow full set up of feature
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWEND, sketchFeature));
        // Then insert feature
        if (this.features_) {
            this.features_.push(sketchFeature);
        }
        if (this.source_) {
            this.source_.addFeature(sketchFeature);
        }
    };
    /**
     * Stop drawing without adding the sketch feature to the target layer.
     * @return {Feature} The sketch feature (or null if none).
     * @private
     */
    Draw.prototype.abortDrawing_ = function () {
        this.finishCoordinate_ = null;
        var sketchFeature = this.sketchFeature_;
        this.sketchFeature_ = null;
        this.sketchPoint_ = null;
        this.sketchLine_ = null;
        this.overlay_.getSource().clear(true);
        return sketchFeature;
    };
    /**
     * Stop drawing without adding the sketch feature to the target layer.
     * @api
     */
    Draw.prototype.abortDrawing = function () {
        var sketchFeature = this.abortDrawing_();
        if (sketchFeature) {
            this.dispatchEvent(new DrawEvent(DrawEventType.DRAWABORT, sketchFeature));
        }
    };
    /**
     * Append coordinates to the end of the geometry that is currently being drawn.
     * This can be used when drawing LineStrings or Polygons. Coordinates will
     * either be appended to the current LineString or the outer ring of the current
     * Polygon. If no geometry is being drawn, a new one will be created.
     * @param {!LineCoordType} coordinates Linear coordinates to be appended to
     * the coordinate array.
     * @api
     */
    Draw.prototype.appendCoordinates = function (coordinates) {
        var mode = this.mode_;
        var newDrawing = !this.sketchFeature_;
        if (newDrawing) {
            this.startDrawing_(coordinates[0]);
        }
        /** @type {LineCoordType} */
        var sketchCoords;
        if (mode === Mode.LINE_STRING || mode === Mode.CIRCLE) {
            sketchCoords = /** @type {LineCoordType} */ (this.sketchCoords_);
        }
        else if (mode === Mode.POLYGON) {
            sketchCoords =
                this.sketchCoords_ && this.sketchCoords_.length
                    ? /** @type {PolyCoordType} */ (this.sketchCoords_)[0]
                    : [];
        }
        else {
            return;
        }
        if (newDrawing) {
            sketchCoords.shift();
        }
        // Remove last coordinate from sketch drawing (this coordinate follows cursor position)
        sketchCoords.pop();
        // Append coordinate list
        for (var i = 0; i < coordinates.length; i++) {
            this.addToDrawing_(coordinates[i]);
        }
        var ending = coordinates[coordinates.length - 1];
        // Duplicate last coordinate for sketch drawing (cursor position)
        this.addToDrawing_(ending);
        this.modifyDrawing_(ending);
    };
    /**
     * Initiate draw mode by starting from an existing geometry which will
     * receive new additional points. This only works on features with
     * `LineString` geometries, where the interaction will extend lines by adding
     * points to the end of the coordinates array.
     * This will change the original feature, instead of drawing a copy.
     *
     * The function will dispatch a `drawstart` event.
     *
     * @param {!Feature<LineString>} feature Feature to be extended.
     * @api
     */
    Draw.prototype.extend = function (feature) {
        var geometry = feature.getGeometry();
        var lineString = geometry;
        this.sketchFeature_ = feature;
        this.sketchCoords_ = lineString.getCoordinates();
        var last = this.sketchCoords_[this.sketchCoords_.length - 1];
        this.finishCoordinate_ = last.slice();
        this.sketchCoords_.push(last.slice());
        this.sketchPoint_ = new _Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"](new _geom_Point_js__WEBPACK_IMPORTED_MODULE_12__["default"](last));
        this.updateSketchFeatures_();
        this.dispatchEvent(new DrawEvent(DrawEventType.DRAWSTART, this.sketchFeature_));
    };
    /**
     * Redraw the sketch features.
     * @private
     */
    Draw.prototype.updateSketchFeatures_ = function () {
        var sketchFeatures = [];
        if (this.sketchFeature_) {
            sketchFeatures.push(this.sketchFeature_);
        }
        if (this.sketchLine_) {
            sketchFeatures.push(this.sketchLine_);
        }
        if (this.sketchPoint_) {
            sketchFeatures.push(this.sketchPoint_);
        }
        var overlaySource = this.overlay_.getSource();
        overlaySource.clear(true);
        overlaySource.addFeatures(sketchFeatures);
    };
    /**
     * @private
     */
    Draw.prototype.updateState_ = function () {
        var map = this.getMap();
        var active = this.getActive();
        if (!map || !active) {
            this.abortDrawing();
        }
        this.overlay_.setMap(active ? map : null);
    };
    return Draw;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_13__["default"]));
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */
function getDefaultStyleFunction() {
    var styles = Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_20__["createEditingStyle"])();
    return function (feature, resolution) {
        return styles[feature.getGeometry().getType()];
    };
}
/**
 * Create a `geometryFunction` for `type: 'Circle'` that will create a regular
 * polygon with a user specified number of sides and start angle instead of a
 * `import("../geom/Circle.js").Circle` geometry.
 * @param {number} [opt_sides] Number of sides of the regular polygon.
 *     Default is 32.
 * @param {number} [opt_angle] Angle of the first point in counter-clockwise
 *     radians. 0 means East.
 *     Default is the angle defined by the heading from the center of the
 *     regular polygon to the current pointer position.
 * @return {GeometryFunction} Function that draws a polygon.
 * @api
 */
function createRegularPolygon(opt_sides, opt_angle) {
    return function (coordinates, opt_geometry, projection) {
        var center = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["fromUserCoordinate"])(
        /** @type {LineCoordType} */ (coordinates)[0], projection);
        var end = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["fromUserCoordinate"])(
        /** @type {LineCoordType} */ (coordinates)[coordinates.length - 1], projection);
        var radius = Math.sqrt(Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_22__["squaredDistance"])(center, end));
        var geometry = opt_geometry
            ? /** @type {Polygon} */ (opt_geometry)
            : Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__["fromCircle"])(new _geom_Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"](center), opt_sides);
        var angle = opt_angle;
        if (!opt_angle && opt_angle !== 0) {
            var x = end[0] - center[0];
            var y = end[1] - center[1];
            angle = Math.atan2(y, x);
        }
        Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__["makeRegular"])(geometry, center, radius, angle);
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["getUserProjection"])();
        if (userProjection) {
            geometry.transform(projection, userProjection);
        }
        return geometry;
    };
}
/**
 * Create a `geometryFunction` that will create a box-shaped polygon (aligned
 * with the coordinate system axes).  Use this with the draw interaction and
 * `type: 'Circle'` to return a box instead of a circle geometry.
 * @return {GeometryFunction} Function that draws a box-shaped polygon.
 * @api
 */
function createBox() {
    return function (coordinates, opt_geometry, projection) {
        var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["boundingExtent"])(
        /** @type {LineCoordType} */ ([
            coordinates[0],
            coordinates[coordinates.length - 1],
        ]).map(function (coordinate) {
            return Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["fromUserCoordinate"])(coordinate, projection);
        }));
        var boxCoordinates = [
            [
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["getBottomLeft"])(extent),
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["getBottomRight"])(extent),
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["getTopRight"])(extent),
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["getTopLeft"])(extent),
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_19__["getBottomLeft"])(extent),
            ],
        ];
        var geometry = opt_geometry;
        if (geometry) {
            geometry.setCoordinates(boxCoordinates);
        }
        else {
            geometry = new _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_14__["default"](boxCoordinates);
        }
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_21__["getUserProjection"])();
        if (userProjection) {
            geometry.transform(projection, userProjection);
        }
        return geometry;
    };
}
/**
 * Get the drawing mode.  The mode for mult-part geometries is the same as for
 * their single-part cousins.
 * @param {import("../geom/GeometryType.js").default} type Geometry type.
 * @return {Mode} Drawing mode.
 */
function getMode(type) {
    switch (type) {
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POINT:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POINT:
            return Mode.POINT;
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_LINE_STRING:
            return Mode.LINE_STRING;
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON:
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].MULTI_POLYGON:
            return Mode.POLYGON;
        case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_4__["default"].CIRCLE:
            return Mode.CIRCLE;
        default:
            throw new Error('Invalid type: ' + type);
    }
}
/* harmony default export */ __webpack_exports__["default"] = (Draw);
//# sourceMappingURL=Draw.js.map

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _flat_deflate_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(104);
/* harmony import */ var _flat_transform_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(102);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/geom/Circle
 */





/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */
var Circle = /** @class */ (function (_super) {
    __extends(Circle, _super);
    /**
     * @param {!import("../coordinate.js").Coordinate} center Center.
     *     For internal use, flat coordinates in combination with `opt_layout` and no
     *     `opt_radius` are also accepted.
     * @param {number} [opt_radius] Radius.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     */
    function Circle(center, opt_radius, opt_layout) {
        var _this = _super.call(this) || this;
        if (opt_layout !== undefined && opt_radius === undefined) {
            _this.setFlatCoordinates(opt_layout, center);
        }
        else {
            var radius = opt_radius ? opt_radius : 0;
            _this.setCenterAndRadius(center, radius, opt_layout);
        }
        return _this;
    }
    /**
     * Make a complete copy of the geometry.
     * @return {!Circle} Clone.
     * @api
     */
    Circle.prototype.clone = function () {
        var circle = new Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
     * @param {number} minSquaredDistance Minimum squared distance.
     * @return {number} Minimum squared distance.
     */
    Circle.prototype.closestPointXY = function (x, y, closestPoint, minSquaredDistance) {
        var flatCoordinates = this.flatCoordinates;
        var dx = x - flatCoordinates[0];
        var dy = y - flatCoordinates[1];
        var squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) {
                for (var i = 0; i < this.stride; ++i) {
                    closestPoint[i] = flatCoordinates[i];
                }
            }
            else {
                var delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for (var i = 2; i < this.stride; ++i) {
                    closestPoint[i] = flatCoordinates[i];
                }
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        else {
            return minSquaredDistance;
        }
    };
    /**
     * @param {number} x X.
     * @param {number} y Y.
     * @return {boolean} Contains (x, y).
     */
    Circle.prototype.containsXY = function (x, y) {
        var flatCoordinates = this.flatCoordinates;
        var dx = x - flatCoordinates[0];
        var dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    };
    /**
     * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
     * @return {import("../coordinate.js").Coordinate} Center.
     * @api
     */
    Circle.prototype.getCenter = function () {
        return this.flatCoordinates.slice(0, this.stride);
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @protected
     * @return {import("../extent.js").Extent} extent Extent.
     */
    Circle.prototype.computeExtent = function (extent) {
        var flatCoordinates = this.flatCoordinates;
        var radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createOrUpdate"])(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    };
    /**
     * Return the radius of the circle.
     * @return {number} Radius.
     * @api
     */
    Circle.prototype.getRadius = function () {
        return Math.sqrt(this.getRadiusSquared_());
    };
    /**
     * @private
     * @return {number} Radius squared.
     */
    Circle.prototype.getRadiusSquared_ = function () {
        var dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        var dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    };
    /**
     * Get the type of this geometry.
     * @return {import("./GeometryType.js").default} Geometry type.
     * @api
     */
    Circle.prototype.getType = function () {
        return _GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CIRCLE;
    };
    /**
     * Test if the geometry and the passed extent intersect.
     * @param {import("../extent.js").Extent} extent Extent.
     * @return {boolean} `true` if the geometry and the extent intersect.
     * @api
     */
    Circle.prototype.intersectsExtent = function (extent) {
        var circleExtent = this.getExtent();
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["intersects"])(extent, circleExtent)) {
            var center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) {
                return true;
            }
            if (extent[1] <= center[1] && extent[3] >= center[1]) {
                return true;
            }
            return Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["forEachCorner"])(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    };
    /**
     * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
     * @param {import("../coordinate.js").Coordinate} center Center.
     * @api
     */
    Circle.prototype.setCenter = function (center) {
        var stride = this.stride;
        var radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        var flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for (var i = 1; i < stride; ++i) {
            flatCoordinates[stride + i] = center[i];
        }
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    };
    /**
     * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
     * number) of the circle.
     * @param {!import("../coordinate.js").Coordinate} center Center.
     * @param {number} radius Radius.
     * @param {import("./GeometryLayout.js").default} [opt_layout] Layout.
     * @api
     */
    Circle.prototype.setCenterAndRadius = function (center, radius, opt_layout) {
        this.setLayout(opt_layout, center, 0);
        if (!this.flatCoordinates) {
            this.flatCoordinates = [];
        }
        /** @type {Array<number>} */
        var flatCoordinates = this.flatCoordinates;
        var offset = Object(_flat_deflate_js__WEBPACK_IMPORTED_MODULE_3__["deflateCoordinate"])(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for (var i = 1, ii = this.stride; i < ii; ++i) {
            flatCoordinates[offset++] = flatCoordinates[i];
        }
        flatCoordinates.length = offset;
        this.changed();
    };
    Circle.prototype.getCoordinates = function () {
        return null;
    };
    Circle.prototype.setCoordinates = function (coordinates, opt_layout) { };
    /**
     * Set the radius of the circle. The radius is in the units of the projection.
     * @param {number} radius Radius.
     * @api
     */
    Circle.prototype.setRadius = function (radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    };
    /**
     * Rotate the geometry around a given coordinate. This modifies the geometry
     * coordinates in place.
     * @param {number} angle Rotation angle in counter-clockwise radians.
     * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
     * @api
     */
    Circle.prototype.rotate = function (angle, anchor) {
        var center = this.getCenter();
        var stride = this.getStride();
        this.setCenter(Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["rotate"])(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    };
    /**
     * Translate the geometry.  This modifies the geometry coordinates in place.  If
     * instead you want a new geometry, first `clone()` this geometry.
     * @param {number} deltaX Delta X.
     * @param {number} deltaY Delta Y.
     * @api
     */
    Circle.prototype.translate = function (deltaX, deltaY) {
        var center = this.getCenter();
        var stride = this.getStride();
        this.setCenter(Object(_flat_transform_js__WEBPACK_IMPORTED_MODULE_4__["translate"])(center, 0, center.length, stride, deltaX, deltaY, center));
        this.changed();
    };
    return Circle;
}(_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */
Circle.prototype.transform;
/* harmony default export */ __webpack_exports__["default"] = (Circle);
//# sourceMappingURL=Circle.js.map

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BaseVector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(289);
/* harmony import */ var _renderer_canvas_VectorLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(290);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Vector
 */


/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType>}
 * @api
 */
var VectorLayer = /** @class */ (function (_super) {
    __extends(VectorLayer, _super);
    /**
     * @param {import("./BaseVector.js").Options<VectorSourceType>} [opt_options] Options.
     */
    function VectorLayer(opt_options) {
        return _super.call(this, opt_options) || this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     */
    VectorLayer.prototype.createRenderer = function () {
        return new _renderer_canvas_VectorLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this);
    };
    return VectorLayer;
}(_BaseVector_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorLayer);
//# sourceMappingURL=Vector.js.map

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(109);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(rbush__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/BaseVector
 */




/**
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 * @property {import("../style/Style.js").StyleLike|null} [style] Layer style. When set to `null`, only
 * features that have their own style will be rendered. See {@link module:ol/style} for default style
 * which will be used if this is not set.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will
 * be recreated during animations. This means that no vectors will be shown clipped, but the
 * setting will have a performance impact for large amounts of vector data. When set to `false`,
 * batches will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will
 * be recreated during interactions. See also `updateWhileAnimating`.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @enum {string}
 * @private
 */
var Property = {
    RENDER_ORDER: 'renderOrder',
};
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default|import("../source/VectorTile.js").default} VectorSourceType
 * @extends {Layer<VectorSourceType>}
 * @api
 */
var BaseVectorLayer = /** @class */ (function (_super) {
    __extends(BaseVectorLayer, _super);
    /**
     * @param {Options<VectorSourceType>} [opt_options] Options.
     */
    function BaseVectorLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        delete baseOptions.style;
        delete baseOptions.renderBuffer;
        delete baseOptions.updateWhileAnimating;
        delete baseOptions.updateWhileInteracting;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {boolean}
         */
        _this.declutter_ =
            options.declutter !== undefined ? options.declutter : false;
        /**
         * @type {number}
         * @private
         */
        _this.renderBuffer_ =
            options.renderBuffer !== undefined ? options.renderBuffer : 100;
        /**
         * User provided style.
         * @type {import("../style/Style.js").StyleLike}
         * @private
         */
        _this.style_ = null;
        /**
         * Style function for use within the library.
         * @type {import("../style/Style.js").StyleFunction|undefined}
         * @private
         */
        _this.styleFunction_ = undefined;
        _this.setStyle(options.style);
        /**
         * @type {boolean}
         * @private
         */
        _this.updateWhileAnimating_ =
            options.updateWhileAnimating !== undefined
                ? options.updateWhileAnimating
                : false;
        /**
         * @type {boolean}
         * @private
         */
        _this.updateWhileInteracting_ =
            options.updateWhileInteracting !== undefined
                ? options.updateWhileInteracting
                : false;
        return _this;
    }
    /**
     * @return {boolean} Declutter.
     */
    BaseVectorLayer.prototype.getDeclutter = function () {
        return this.declutter_;
    };
    /**
     * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
     * that resolves with an array of features. The array will either contain the topmost feature
     * when a hit was detected, or it will be empty.
     *
     * The hit detection algorithm used for this method is optimized for performance, but is less
     * accurate than the one used in {@link import("../PluggableMap.js").default#getFeaturesAtPixel}: Text
     * is not considered, and icons are only represented by their bounding box instead of the exact
     * image.
     *
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with an array of features.
     * @api
     */
    BaseVectorLayer.prototype.getFeatures = function (pixel) {
        return _super.prototype.getFeatures.call(this, pixel);
    };
    /**
     * @return {number|undefined} Render buffer.
     */
    BaseVectorLayer.prototype.getRenderBuffer = function () {
        return this.renderBuffer_;
    };
    /**
     * @return {function(import("../Feature.js").default, import("../Feature.js").default): number|null|undefined} Render
     *     order.
     */
    BaseVectorLayer.prototype.getRenderOrder = function () {
        return /** @type {import("../render.js").OrderFunction|null|undefined} */ (this.get(Property.RENDER_ORDER));
    };
    /**
     * Get the style for features.  This returns whatever was passed to the `style`
     * option at construction or to the `setStyle` method.
     * @return {import("../style/Style.js").StyleLike|null|undefined} Layer style.
     * @api
     */
    BaseVectorLayer.prototype.getStyle = function () {
        return this.style_;
    };
    /**
     * Get the style function.
     * @return {import("../style/Style.js").StyleFunction|undefined} Layer style function.
     * @api
     */
    BaseVectorLayer.prototype.getStyleFunction = function () {
        return this.styleFunction_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     animating.
     */
    BaseVectorLayer.prototype.getUpdateWhileAnimating = function () {
        return this.updateWhileAnimating_;
    };
    /**
     * @return {boolean} Whether the rendered layer should be updated while
     *     interacting.
     */
    BaseVectorLayer.prototype.getUpdateWhileInteracting = function () {
        return this.updateWhileInteracting_;
    };
    /**
     * Render declutter items for this layer
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     */
    BaseVectorLayer.prototype.renderDeclutter = function (frameState) {
        if (!frameState.declutterTree) {
            frameState.declutterTree = new rbush__WEBPACK_IMPORTED_MODULE_1___default.a(9);
        }
        /** @type {*} */ (this.getRenderer()).renderDeclutter(frameState);
    };
    /**
     * @param {import("../render.js").OrderFunction|null|undefined} renderOrder
     *     Render order.
     */
    BaseVectorLayer.prototype.setRenderOrder = function (renderOrder) {
        this.set(Property.RENDER_ORDER, renderOrder);
    };
    /**
     * Set the style for features.  This can be a single style object, an array
     * of styles, or a function that takes a feature and resolution and returns
     * an array of styles. If set to `null`, the layer has no style (a `null` style),
     * so only features that have their own styles will be rendered in the layer. Call
     * `setStyle()` without arguments to reset to the default style. See
     * {@link module:ol/style} for information on the default style.
     * @param {import("../style/Style.js").StyleLike|null} [opt_style] Layer style.
     * @api
     */
    BaseVectorLayer.prototype.setStyle = function (opt_style) {
        this.style_ = opt_style !== undefined ? opt_style : _style_Style_js__WEBPACK_IMPORTED_MODULE_3__["createDefaultStyle"];
        this.styleFunction_ =
            opt_style === null ? undefined : Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_3__["toFunction"])(this.style_);
        this.changed();
    };
    return BaseVectorLayer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (BaseVectorLayer);
//# sourceMappingURL=BaseVector.js.map

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(291);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(136);
/* harmony import */ var _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(300);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(139);
/* harmony import */ var _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(304);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _vector_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(306);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/VectorLayer
 */












/**
 * @classdesc
 * Canvas renderer for vector layers.
 * @api
 */
var CanvasVectorLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasVectorLayerRenderer, _super);
    /**
     * @param {import("../../layer/Vector.js").default} vectorLayer Vector layer.
     */
    function CanvasVectorLayerRenderer(vectorLayer) {
        var _this = _super.call(this, vectorLayer) || this;
        /** @private */
        _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);
        /**
         * @type {boolean}
         */
        _this.animatingOrInteracting_;
        /**
         * @private
         * @type {boolean}
         */
        _this.dirty_ = false;
        /**
         * @type {ImageData}
         */
        _this.hitDetectionImageData_ = null;
        /**
         * @type {Array<import("../../Feature.js").default>}
         */
        _this.renderedFeatures_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.renderedRevision_ = -1;
        /**
         * @private
         * @type {number}
         */
        _this.renderedResolution_ = NaN;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        _this.renderedExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["createEmpty"])();
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        _this.wrappedRenderedExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["createEmpty"])();
        /**
         * @private
         * @type {number}
         */
        _this.renderedRotation_;
        /**
         * @private
         * @type {import("../../coordinate").Coordinate}
         */
        _this.renderedCenter_ = null;
        /**
         * @private
         * @type {import("../../proj/Projection").default}
         */
        _this.renderedProjection_ = null;
        /**
         * @private
         * @type {function(import("../../Feature.js").default, import("../../Feature.js").default): number|null}
         */
        _this.renderedRenderOrder_ = null;
        /**
         * @private
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */
        _this.replayGroup_ = null;
        /**
         * A new replay group had to be created by `prepareFrame()`
         * @type {boolean}
         */
        _this.replayGroupChanged = true;
        /**
         * @type {import("../../render/canvas/ExecutorGroup").default}
         */
        _this.declutterExecutorGroup = null;
        /**
         * Clipping to be performed by `renderFrame()`
         * @type {boolean}
         */
        _this.clipping = true;
        return _this;
    }
    /**
     * Get a rendering container from an existing target, if compatible.
     * @param {HTMLElement} target Potential render target.
     * @param {string} transform CSS Transform.
     * @param {number} opacity Opacity.
     */
    CanvasVectorLayerRenderer.prototype.useContainer = function (target, transform, opacity) {
        if (opacity < 1) {
            target = null;
        }
        _super.prototype.useContainer.call(this, target, transform, opacity);
    };
    /**
     * @param {ExecutorGroup} executorGroup Executor group.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */
    CanvasVectorLayerRenderer.prototype.renderWorlds = function (executorGroup, frameState, opt_declutterTree) {
        var extent = frameState.extent;
        var viewState = frameState.viewState;
        var center = viewState.center;
        var resolution = viewState.resolution;
        var projection = viewState.projection;
        var rotation = viewState.rotation;
        var projectionExtent = projection.getExtent();
        var vectorSource = this.getLayer().getSource();
        var pixelRatio = frameState.pixelRatio;
        var viewHints = frameState.viewHints;
        var snapToPixel = !(viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING] || viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING]);
        var context = this.context;
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        var multiWorld = vectorSource.getWrapX() && projection.canWrapX();
        var worldWidth = multiWorld ? Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(projectionExtent) : null;
        var endWorld = multiWorld
            ? Math.ceil((extent[2] - projectionExtent[2]) / worldWidth) + 1
            : 1;
        var world = multiWorld
            ? Math.floor((extent[0] - projectionExtent[0]) / worldWidth)
            : 0;
        do {
            var transform = this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, world * worldWidth);
            executorGroup.execute(context, 1, transform, rotation, snapToPixel, undefined, opt_declutterTree);
        } while (++world < endWorld);
    };
    /**
     * Render declutter items for this layer
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     */
    CanvasVectorLayerRenderer.prototype.renderDeclutter = function (frameState) {
        if (this.declutterExecutorGroup) {
            this.renderWorlds(this.declutterExecutorGroup, frameState, frameState.declutterTree);
        }
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
    CanvasVectorLayerRenderer.prototype.renderFrame = function (frameState, target) {
        var pixelRatio = frameState.pixelRatio;
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        // set forward and inverse pixel transforms
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_5__["makeScale"])(this.pixelTransform, 1 / pixelRatio, 1 / pixelRatio);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_5__["makeInverse"])(this.inversePixelTransform, this.pixelTransform);
        var canvasTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_5__["toString"])(this.pixelTransform);
        this.useContainer(target, canvasTransform, layerState.opacity);
        var context = this.context;
        var canvas = context.canvas;
        var replayGroup = this.replayGroup_;
        var declutterExecutorGroup = this.declutterExecutorGroup;
        if ((!replayGroup || replayGroup.isEmpty()) &&
            (!declutterExecutorGroup || declutterExecutorGroup.isEmpty())) {
            if (!this.containerReused && canvas.width > 0) {
                canvas.width = 0;
            }
            return this.container;
        }
        // resize and clear
        var width = Math.round(frameState.size[0] * pixelRatio);
        var height = Math.round(frameState.size[1] * pixelRatio);
        if (canvas.width != width || canvas.height != height) {
            canvas.width = width;
            canvas.height = height;
            if (canvas.style.transform !== canvasTransform) {
                canvas.style.transform = canvasTransform;
            }
        }
        else if (!this.containerReused) {
            context.clearRect(0, 0, width, height);
        }
        this.preRender(context, frameState);
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        // clipped rendering if layer extent is set
        var clipped = false;
        var render = true;
        if (layerState.extent && this.clipping) {
            var layerExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["fromUserExtent"])(layerState.extent, projection);
            render = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(layerExtent, frameState.extent);
            clipped = render && !Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["containsExtent"])(layerExtent, frameState.extent);
            if (clipped) {
                this.clipUnrotated(context, frameState, layerExtent);
            }
        }
        if (render) {
            this.renderWorlds(replayGroup, frameState);
        }
        if (clipped) {
            context.restore();
        }
        this.postRender(context, frameState);
        var opacity = layerState.opacity;
        var container = this.container;
        if (opacity !== parseFloat(container.style.opacity)) {
            container.style.opacity = opacity === 1 ? '' : String(opacity);
        }
        if (this.renderedRotation_ !== viewState.rotation) {
            this.renderedRotation_ = viewState.rotation;
            this.hitDetectionImageData_ = null;
        }
        return this.container;
    };
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
     */
    CanvasVectorLayerRenderer.prototype.getFeatures = function (pixel) {
        return new Promise(
        /**
         * @param {function(Array<import("../../Feature").default|import("../../render/Feature").default>): void} resolve Resolver function.
         * @this {CanvasVectorLayerRenderer}
         */
        function (resolve) {
            if (!this.hitDetectionImageData_ && !this.animatingOrInteracting_) {
                var size = [this.context.canvas.width, this.context.canvas.height];
                Object(_transform_js__WEBPACK_IMPORTED_MODULE_5__["apply"])(this.pixelTransform, size);
                var center = this.renderedCenter_;
                var resolution = this.renderedResolution_;
                var rotation = this.renderedRotation_;
                var projection = this.renderedProjection_;
                var extent = this.wrappedRenderedExtent_;
                var layer = this.getLayer();
                var transforms = [];
                var width = size[0] * _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["HIT_DETECT_RESOLUTION"];
                var height = size[1] * _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["HIT_DETECT_RESOLUTION"];
                transforms.push(this.getRenderTransform(center, resolution, rotation, _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["HIT_DETECT_RESOLUTION"], width, height, 0).slice());
                var source = layer.getSource();
                var projectionExtent = projection.getExtent();
                if (source.getWrapX() &&
                    projection.canWrapX() &&
                    !Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["containsExtent"])(projectionExtent, extent)) {
                    var startX = extent[0];
                    var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(projectionExtent);
                    var world = 0;
                    var offsetX = void 0;
                    while (startX < projectionExtent[0]) {
                        --world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["HIT_DETECT_RESOLUTION"], width, height, offsetX).slice());
                        startX += worldWidth;
                    }
                    world = 0;
                    startX = extent[2];
                    while (startX > projectionExtent[2]) {
                        ++world;
                        offsetX = worldWidth * world;
                        transforms.push(this.getRenderTransform(center, resolution, rotation, _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["HIT_DETECT_RESOLUTION"], width, height, offsetX).slice());
                        startX -= worldWidth;
                    }
                }
                this.hitDetectionImageData_ = Object(_render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["createHitDetectionImageData"])(size, transforms, this.renderedFeatures_, layer.getStyleFunction(), extent, resolution, rotation);
            }
            resolve(Object(_render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_4__["hitDetect"])(pixel, this.renderedFeatures_, this.hitDetectionImageData_));
        }.bind(this));
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
    CanvasVectorLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
        var _this = this;
        if (!this.replayGroup_) {
            return undefined;
        }
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        var layer = this.getLayer();
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */
        var features = {};
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @param {number} distanceSq The squared distance to the click position
         * @return {T|undefined} Callback result.
         */
        var featureCallback = function (feature, geometry, distanceSq) {
            var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_10__["getUid"])(feature);
            var match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push((features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback,
                }));
            }
            else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        var result;
        var executorGroups = [this.replayGroup_];
        if (this.declutterExecutorGroup) {
            executorGroups.push(this.declutterExecutorGroup);
        }
        executorGroups.some(function (executorGroup) {
            return (result = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, executorGroup === _this.declutterExecutorGroup
                ? frameState.declutterTree.all().map(function (item) { return item.value; })
                : null));
        });
        return result;
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */
    CanvasVectorLayerRenderer.prototype.handleFontsChanged = function () {
        var layer = this.getLayer();
        if (layer.getVisible() && this.replayGroup_) {
            layer.changed();
        }
    };
    /**
     * Handle changes in image style state.
     * @param {import("../../events/Event.js").default} event Image style change event.
     * @private
     */
    CanvasVectorLayerRenderer.prototype.handleStyleImageChange_ = function (event) {
        this.renderIfReadyAndVisible();
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    CanvasVectorLayerRenderer.prototype.prepareFrame = function (frameState) {
        var vectorLayer = this.getLayer();
        var vectorSource = vectorLayer.getSource();
        if (!vectorSource) {
            return false;
        }
        var animating = frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING];
        var interacting = frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING];
        var updateWhileAnimating = vectorLayer.getUpdateWhileAnimating();
        var updateWhileInteracting = vectorLayer.getUpdateWhileInteracting();
        if ((!this.dirty_ && !updateWhileAnimating && animating) ||
            (!updateWhileInteracting && interacting)) {
            this.animatingOrInteracting_ = true;
            return true;
        }
        this.animatingOrInteracting_ = false;
        var frameStateExtent = frameState.extent;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var resolution = viewState.resolution;
        var pixelRatio = frameState.pixelRatio;
        var vectorLayerRevision = vectorLayer.getRevision();
        var vectorLayerRenderBuffer = vectorLayer.getRenderBuffer();
        var vectorLayerRenderOrder = vectorLayer.getRenderOrder();
        if (vectorLayerRenderOrder === undefined) {
            vectorLayerRenderOrder = _vector_js__WEBPACK_IMPORTED_MODULE_7__["defaultOrder"];
        }
        var center = viewState.center.slice();
        var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["buffer"])(frameStateExtent, vectorLayerRenderBuffer * resolution);
        var renderedExtent = extent.slice();
        var loadExtents = [extent.slice()];
        var projectionExtent = projection.getExtent();
        if (vectorSource.getWrapX() &&
            projection.canWrapX() &&
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["containsExtent"])(projectionExtent, frameState.extent)) {
            // For the replay group, we need an extent that intersects the real world
            // (-180° to +180°). To support geometries in a coordinate range from -540°
            // to +540°, we add at least 1 world width on each side of the projection
            // extent. If the viewport is wider than the world, we need to add half of
            // the viewport width to make sure we cover the whole viewport.
            var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(projectionExtent);
            var gutter = Math.max(Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["getWidth"])(extent) / 2, worldWidth);
            extent[0] = projectionExtent[0] - gutter;
            extent[2] = projectionExtent[2] + gutter;
            Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_11__["wrapX"])(center, projection);
            var loadExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["wrapX"])(loadExtents[0], projection);
            // If the extent crosses the date line, we load data for both edges of the worlds
            if (loadExtent[0] < projectionExtent[0] &&
                loadExtent[2] < projectionExtent[2]) {
                loadExtents.push([
                    loadExtent[0] + worldWidth,
                    loadExtent[1],
                    loadExtent[2] + worldWidth,
                    loadExtent[3],
                ]);
            }
            else if (loadExtent[0] > projectionExtent[0] &&
                loadExtent[2] > projectionExtent[2]) {
                loadExtents.push([
                    loadExtent[0] - worldWidth,
                    loadExtent[1],
                    loadExtent[2] - worldWidth,
                    loadExtent[3],
                ]);
            }
        }
        if (!this.dirty_ &&
            this.renderedResolution_ == resolution &&
            this.renderedRevision_ == vectorLayerRevision &&
            this.renderedRenderOrder_ == vectorLayerRenderOrder &&
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["containsExtent"])(this.wrappedRenderedExtent_, extent)) {
            if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["equals"])(this.renderedExtent_, renderedExtent)) {
                this.hitDetectionImageData_ = null;
                this.renderedExtent_ = renderedExtent;
            }
            this.renderedCenter_ = center;
            this.replayGroupChanged = false;
            return true;
        }
        this.replayGroup_ = null;
        this.dirty_ = false;
        var replayGroup = new _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__["default"](Object(_vector_js__WEBPACK_IMPORTED_MODULE_7__["getTolerance"])(resolution, pixelRatio), extent, resolution, pixelRatio);
        var declutterBuilderGroup;
        if (this.getLayer().getDeclutter()) {
            declutterBuilderGroup = new _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__["default"](Object(_vector_js__WEBPACK_IMPORTED_MODULE_7__["getTolerance"])(resolution, pixelRatio), extent, resolution, pixelRatio);
        }
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["getUserProjection"])();
        var userTransform;
        if (userProjection) {
            for (var i = 0, ii = loadExtents.length; i < ii; ++i) {
                vectorSource.loadFeatures(Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["toUserExtent"])(loadExtents[i], projection), resolution, userProjection);
            }
            userTransform = Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["getTransformFromProjections"])(userProjection, projection);
        }
        else {
            for (var i = 0, ii = loadExtents.length; i < ii; ++i) {
                vectorSource.loadFeatures(loadExtents[i], resolution, projection);
            }
        }
        var squaredTolerance = Object(_vector_js__WEBPACK_IMPORTED_MODULE_7__["getSquaredTolerance"])(resolution, pixelRatio);
        var render = 
        /**
         * @param {import("../../Feature.js").default} feature Feature.
         * @this {CanvasVectorLayerRenderer}
         */
        function (feature) {
            var styles;
            var styleFunction = feature.getStyleFunction() || vectorLayer.getStyleFunction();
            if (styleFunction) {
                styles = styleFunction(feature, resolution);
            }
            if (styles) {
                var dirty = this.renderFeature(feature, squaredTolerance, styles, replayGroup, userTransform, declutterBuilderGroup);
                this.dirty_ = this.dirty_ || dirty;
            }
        }.bind(this);
        var userExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_9__["toUserExtent"])(extent, projection);
        /** @type {Array<import("../../Feature.js").default>} */
        var features = vectorSource.getFeaturesInExtent(userExtent);
        if (vectorLayerRenderOrder) {
            features.sort(vectorLayerRenderOrder);
        }
        for (var i = 0, ii = features.length; i < ii; ++i) {
            render(features[i]);
        }
        this.renderedFeatures_ = features;
        var replayGroupInstructions = replayGroup.finish();
        var executorGroup = new _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_2__["default"](extent, resolution, pixelRatio, vectorSource.getOverlaps(), replayGroupInstructions, vectorLayer.getRenderBuffer());
        if (declutterBuilderGroup) {
            this.declutterExecutorGroup = new _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_2__["default"](extent, resolution, pixelRatio, vectorSource.getOverlaps(), declutterBuilderGroup.finish(), vectorLayer.getRenderBuffer());
        }
        this.renderedResolution_ = resolution;
        this.renderedRevision_ = vectorLayerRevision;
        this.renderedRenderOrder_ = vectorLayerRenderOrder;
        this.renderedExtent_ = renderedExtent;
        this.wrappedRenderedExtent_ = extent;
        this.renderedCenter_ = center;
        this.renderedProjection_ = projection;
        this.replayGroup_ = executorGroup;
        this.hitDetectionImageData_ = null;
        this.replayGroupChanged = true;
        return true;
    };
    /**
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {number} squaredTolerance Squared render tolerance.
     * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
     * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
     * @param {import("../../proj.js").TransformFunction} [opt_transform] Transform from user to view projection.
     * @param {import("../../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
     * @return {boolean} `true` if an image is loading.
     */
    CanvasVectorLayerRenderer.prototype.renderFeature = function (feature, squaredTolerance, styles, builderGroup, opt_transform, opt_declutterBuilderGroup) {
        if (!styles) {
            return false;
        }
        var loading = false;
        if (Array.isArray(styles)) {
            for (var i = 0, ii = styles.length; i < ii; ++i) {
                loading =
                    Object(_vector_js__WEBPACK_IMPORTED_MODULE_7__["renderFeature"])(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup) || loading;
            }
        }
        else {
            loading = Object(_vector_js__WEBPACK_IMPORTED_MODULE_7__["renderFeature"])(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, opt_transform, opt_declutterBuilderGroup);
        }
        return loading;
    };
    return CanvasVectorLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasVectorLayerRenderer);
//# sourceMappingURL=VectorLayer.js.map

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Builder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(292);
/* harmony import */ var _ImageBuilder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(295);
/* harmony import */ var _LineStringBuilder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(296);
/* harmony import */ var _PolygonBuilder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(297);
/* harmony import */ var _TextBuilder_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(298);
/**
 * @module ol/render/canvas/BuilderGroup
 */





/**
 * @type {Object<import("./BuilderType").default, typeof Builder>}
 */
var BATCH_CONSTRUCTORS = {
    'Circle': _PolygonBuilder_js__WEBPACK_IMPORTED_MODULE_3__["default"],
    'Default': _Builder_js__WEBPACK_IMPORTED_MODULE_0__["default"],
    'Image': _ImageBuilder_js__WEBPACK_IMPORTED_MODULE_1__["default"],
    'LineString': _LineStringBuilder_js__WEBPACK_IMPORTED_MODULE_2__["default"],
    'Polygon': _PolygonBuilder_js__WEBPACK_IMPORTED_MODULE_3__["default"],
    'Text': _TextBuilder_js__WEBPACK_IMPORTED_MODULE_4__["default"],
};
var BuilderGroup = /** @class */ (function () {
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Max extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function BuilderGroup(tolerance, maxExtent, resolution, pixelRatio) {
        /**
         * @private
         * @type {number}
         */
        this.tolerance_ = tolerance;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {number}
         */
        this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */
        this.resolution_ = resolution;
        /**
         * @private
         * @type {!Object<string, !Object<import("./BuilderType").default, Builder>>}
         */
        this.buildersByZIndex_ = {};
    }
    /**
     * @return {!Object<string, !Object<import("./BuilderType").default, import("./Builder.js").SerializableInstructions>>} The serializable instructions
     */
    BuilderGroup.prototype.finish = function () {
        var builderInstructions = {};
        for (var zKey in this.buildersByZIndex_) {
            builderInstructions[zKey] = builderInstructions[zKey] || {};
            var builders = this.buildersByZIndex_[zKey];
            for (var builderKey in builders) {
                var builderInstruction = builders[builderKey].finish();
                builderInstructions[zKey][builderKey] = builderInstruction;
            }
        }
        return builderInstructions;
    };
    /**
     * @param {number|undefined} zIndex Z index.
     * @param {import("./BuilderType.js").default} builderType Replay type.
     * @return {import("../VectorContext.js").default} Replay.
     */
    BuilderGroup.prototype.getBuilder = function (zIndex, builderType) {
        var zIndexKey = zIndex !== undefined ? zIndex.toString() : '0';
        var replays = this.buildersByZIndex_[zIndexKey];
        if (replays === undefined) {
            replays = {};
            this.buildersByZIndex_[zIndexKey] = replays;
        }
        var replay = replays[builderType];
        if (replay === undefined) {
            var Constructor = BATCH_CONSTRUCTORS[builderType];
            replay = new Constructor(this.tolerance_, this.maxExtent_, this.resolution_, this.pixelRatio_);
            replays[builderType] = replay;
        }
        return replay;
    };
    return BuilderGroup;
}());
/* harmony default export */ __webpack_exports__["default"] = (BuilderGroup);
//# sourceMappingURL=BuilderGroup.js.map

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(293);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18);
/* harmony import */ var _VectorContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(294);
/* harmony import */ var _colorlike_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(44);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/* harmony import */ var _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(188);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/render/canvas/Builder
 */









var CanvasBuilder = /** @class */ (function (_super) {
    __extends(CanvasBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function CanvasBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this) || this;
        /**
         * @protected
         * @type {number}
         */
        _this.tolerance = tolerance;
        /**
         * @protected
         * @const
         * @type {import("../../extent.js").Extent}
         */
        _this.maxExtent = maxExtent;
        /**
         * @protected
         * @type {number}
         */
        _this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @type {number}
         */
        _this.maxLineWidth = 0;
        /**
         * @protected
         * @const
         * @type {number}
         */
        _this.resolution = resolution;
        /**
         * @private
         * @type {Array<*>}
         */
        _this.beginGeometryInstruction1_ = null;
        /**
         * @private
         * @type {Array<*>}
         */
        _this.beginGeometryInstruction2_ = null;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        _this.bufferedMaxExtent_ = null;
        /**
         * @protected
         * @type {Array<*>}
         */
        _this.instructions = [];
        /**
         * @protected
         * @type {Array<number>}
         */
        _this.coordinates = [];
        /**
         * @private
         * @type {import("../../coordinate.js").Coordinate}
         */
        _this.tmpCoordinate_ = [];
        /**
         * @protected
         * @type {Array<*>}
         */
        _this.hitDetectionInstructions = [];
        /**
         * @protected
         * @type {import("../canvas.js").FillStrokeState}
         */
        _this.state = /** @type {import("../canvas.js").FillStrokeState} */ ({});
        return _this;
    }
    /**
     * @protected
     * @param {Array<number>} dashArray Dash array.
     * @return {Array<number>} Dash array with pixel ratio applied
     */
    CanvasBuilder.prototype.applyPixelRatio = function (dashArray) {
        var pixelRatio = this.pixelRatio;
        return pixelRatio == 1
            ? dashArray
            : dashArray.map(function (dash) {
                return dash * pixelRatio;
            });
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} stride Stride.
     * @protected
     * @return {number} My end
     */
    CanvasBuilder.prototype.appendFlatPointCoordinates = function (flatCoordinates, stride) {
        var extent = this.getBufferedMaxExtent();
        var tmpCoord = this.tmpCoordinate_;
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        for (var i = 0, ii = flatCoordinates.length; i < ii; i += stride) {
            tmpCoord[0] = flatCoordinates[i];
            tmpCoord[1] = flatCoordinates[i + 1];
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["containsCoordinate"])(extent, tmpCoord)) {
                coordinates[myEnd++] = tmpCoord[0];
                coordinates[myEnd++] = tmpCoord[1];
            }
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} closed Last input coordinate equals first.
     * @param {boolean} skipFirst Skip first coordinate.
     * @protected
     * @return {number} My end.
     */
    CanvasBuilder.prototype.appendFlatLineCoordinates = function (flatCoordinates, offset, end, stride, closed, skipFirst) {
        var coordinates = this.coordinates;
        var myEnd = coordinates.length;
        var extent = this.getBufferedMaxExtent();
        if (skipFirst) {
            offset += stride;
        }
        var lastXCoord = flatCoordinates[offset];
        var lastYCoord = flatCoordinates[offset + 1];
        var nextCoord = this.tmpCoordinate_;
        var skipped = true;
        var i, lastRel, nextRel;
        for (i = offset + stride; i < end; i += stride) {
            nextCoord[0] = flatCoordinates[i];
            nextCoord[1] = flatCoordinates[i + 1];
            nextRel = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["coordinateRelationship"])(extent, nextCoord);
            if (nextRel !== lastRel) {
                if (skipped) {
                    coordinates[myEnd++] = lastXCoord;
                    coordinates[myEnd++] = lastYCoord;
                    skipped = false;
                }
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
            }
            else if (nextRel === _extent_Relationship_js__WEBPACK_IMPORTED_MODULE_2__["default"].INTERSECTING) {
                coordinates[myEnd++] = nextCoord[0];
                coordinates[myEnd++] = nextCoord[1];
                skipped = false;
            }
            else {
                skipped = true;
            }
            lastXCoord = nextCoord[0];
            lastYCoord = nextCoord[1];
            lastRel = nextRel;
        }
        // Last coordinate equals first or only one point to append:
        if ((closed && skipped) || i === offset + stride) {
            coordinates[myEnd++] = lastXCoord;
            coordinates[myEnd++] = lastYCoord;
        }
        return myEnd;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @param {Array<number>} builderEnds Builder ends.
     * @return {number} Offset.
     */
    CanvasBuilder.prototype.drawCustomCoordinates_ = function (flatCoordinates, offset, ends, stride, builderEnds) {
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            var end = ends[i];
            var builderEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
            builderEnds.push(builderEnd);
            offset = end;
        }
        return offset;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     */
    CanvasBuilder.prototype.drawCustom = function (geometry, feature, renderer) {
        this.beginGeometry(geometry, feature);
        var type = geometry.getType();
        var stride = geometry.getStride();
        var builderBegin = this.coordinates.length;
        var flatCoordinates, builderEnd, builderEnds, builderEndss;
        var offset;
        if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].MULTI_POLYGON) {
            flatCoordinates =
                /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getOrientedFlatCoordinates();
            builderEndss = [];
            var endss = 
            /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getEndss();
            offset = 0;
            for (var i = 0, ii = endss.length; i < ii; ++i) {
                var myEnds = [];
                offset = this.drawCustomCoordinates_(flatCoordinates, offset, endss[i], stride, myEnds);
                builderEndss.push(myEnds);
            }
            this.instructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM,
                builderBegin,
                builderEndss,
                geometry,
                renderer,
                _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__["inflateMultiCoordinatesArray"],
            ]);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON ||
            type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].MULTI_LINE_STRING) {
            builderEnds = [];
            flatCoordinates =
                type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON
                    ? /** @type {import("../../geom/Polygon.js").default} */ (geometry).getOrientedFlatCoordinates()
                    : geometry.getFlatCoordinates();
            offset = this.drawCustomCoordinates_(flatCoordinates, 0, 
            /** @type {import("../../geom/Polygon.js").default|import("../../geom/MultiLineString.js").default} */ (geometry).getEnds(), stride, builderEnds);
            this.instructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM,
                builderBegin,
                builderEnds,
                geometry,
                renderer,
                _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__["inflateCoordinatesArray"],
            ]);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].LINE_STRING ||
            type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CIRCLE) {
            flatCoordinates = geometry.getFlatCoordinates();
            builderEnd = this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
            this.instructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM,
                builderBegin,
                builderEnd,
                geometry,
                renderer,
                _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__["inflateCoordinates"],
            ]);
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].MULTI_POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            builderEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (builderEnd > builderBegin) {
                this.instructions.push([
                    _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM,
                    builderBegin,
                    builderEnd,
                    geometry,
                    renderer,
                    _geom_flat_inflate_js__WEBPACK_IMPORTED_MODULE_8__["inflateCoordinates"],
                ]);
            }
        }
        else if (type == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINT) {
            flatCoordinates = geometry.getFlatCoordinates();
            this.coordinates.push(flatCoordinates[0], flatCoordinates[1]);
            builderEnd = this.coordinates.length;
            this.instructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM,
                builderBegin,
                builderEnd,
                geometry,
                renderer,
            ]);
        }
        this.endGeometry(feature);
    };
    /**
     * @protected
     * @param {import("../../geom/Geometry").default|import("../Feature.js").default} geometry The geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasBuilder.prototype.beginGeometry = function (geometry, feature) {
        this.beginGeometryInstruction1_ = [
            _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
        ];
        this.instructions.push(this.beginGeometryInstruction1_);
        this.beginGeometryInstruction2_ = [
            _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].BEGIN_GEOMETRY,
            feature,
            0,
            geometry,
        ];
        this.hitDetectionInstructions.push(this.beginGeometryInstruction2_);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */
    CanvasBuilder.prototype.finish = function () {
        return {
            instructions: this.instructions,
            hitDetectionInstructions: this.hitDetectionInstructions,
            coordinates: this.coordinates,
        };
    };
    /**
     * Reverse the hit detection instructions.
     */
    CanvasBuilder.prototype.reverseHitDetectionInstructions = function () {
        var hitDetectionInstructions = this.hitDetectionInstructions;
        // step 1 - reverse array
        hitDetectionInstructions.reverse();
        // step 2 - reverse instructions within geometry blocks
        var i;
        var n = hitDetectionInstructions.length;
        var instruction;
        var type;
        var begin = -1;
        for (i = 0; i < n; ++i) {
            instruction = hitDetectionInstructions[i];
            type = /** @type {import("./Instruction.js").default} */ (instruction[0]);
            if (type == _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].END_GEOMETRY) {
                begin = i;
            }
            else if (type == _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].BEGIN_GEOMETRY) {
                instruction[2] = i;
                Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["reverseSubArray"])(this.hitDetectionInstructions, begin, i);
                begin = -1;
            }
        }
    };
    /**
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */
    CanvasBuilder.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) {
        var state = this.state;
        if (fillStyle) {
            var fillStyleColor = fillStyle.getColor();
            state.fillStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_4__["asColorLike"])(fillStyleColor ? fillStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultFillStyle"]);
        }
        else {
            state.fillStyle = undefined;
        }
        if (strokeStyle) {
            var strokeStyleColor = strokeStyle.getColor();
            state.strokeStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_4__["asColorLike"])(strokeStyleColor ? strokeStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultStrokeStyle"]);
            var strokeStyleLineCap = strokeStyle.getLineCap();
            state.lineCap =
                strokeStyleLineCap !== undefined ? strokeStyleLineCap : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultLineCap"];
            var strokeStyleLineDash = strokeStyle.getLineDash();
            state.lineDash = strokeStyleLineDash
                ? strokeStyleLineDash.slice()
                : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultLineDash"];
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            state.lineDashOffset = strokeStyleLineDashOffset
                ? strokeStyleLineDashOffset
                : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultLineDashOffset"];
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            state.lineJoin =
                strokeStyleLineJoin !== undefined
                    ? strokeStyleLineJoin
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultLineJoin"];
            var strokeStyleWidth = strokeStyle.getWidth();
            state.lineWidth =
                strokeStyleWidth !== undefined ? strokeStyleWidth : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultLineWidth"];
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            state.miterLimit =
                strokeStyleMiterLimit !== undefined
                    ? strokeStyleMiterLimit
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_6__["defaultMiterLimit"];
            if (state.lineWidth > this.maxLineWidth) {
                this.maxLineWidth = state.lineWidth;
                // invalidate the buffered max extent cache
                this.bufferedMaxExtent_ = null;
            }
        }
        else {
            state.strokeStyle = undefined;
            state.lineCap = undefined;
            state.lineDash = null;
            state.lineDashOffset = undefined;
            state.lineJoin = undefined;
            state.lineWidth = undefined;
            state.miterLimit = undefined;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Fill instruction.
     */
    CanvasBuilder.prototype.createFill = function (state) {
        var fillStyle = state.fillStyle;
        /** @type {Array<*>} */
        var fillInstruction = [_Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].SET_FILL_STYLE, fillStyle];
        if (typeof fillStyle !== 'string') {
            // Fill is a pattern or gradient - align it!
            fillInstruction.push(true);
        }
        return fillInstruction;
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */
    CanvasBuilder.prototype.applyStroke = function (state) {
        this.instructions.push(this.createStroke(state));
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @return {Array<*>} Stroke instruction.
     */
    CanvasBuilder.prototype.createStroke = function (state) {
        return [
            _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth * this.pixelRatio,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            this.applyPixelRatio(state.lineDash),
            state.lineDashOffset * this.pixelRatio,
        ];
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState):Array<*>} createFill Create fill.
     */
    CanvasBuilder.prototype.updateFillStyle = function (state, createFill) {
        var fillStyle = state.fillStyle;
        if (typeof fillStyle !== 'string' || state.currentFillStyle != fillStyle) {
            if (fillStyle !== undefined) {
                this.instructions.push(createFill.call(this, state));
            }
            state.currentFillStyle = fillStyle;
        }
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     * @param {function(this:CanvasBuilder, import("../canvas.js").FillStrokeState): void} applyStroke Apply stroke.
     */
    CanvasBuilder.prototype.updateStrokeStyle = function (state, applyStroke) {
        var strokeStyle = state.strokeStyle;
        var lineCap = state.lineCap;
        var lineDash = state.lineDash;
        var lineDashOffset = state.lineDashOffset;
        var lineJoin = state.lineJoin;
        var lineWidth = state.lineWidth;
        var miterLimit = state.miterLimit;
        if (state.currentStrokeStyle != strokeStyle ||
            state.currentLineCap != lineCap ||
            (lineDash != state.currentLineDash &&
                !Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["equals"])(state.currentLineDash, lineDash)) ||
            state.currentLineDashOffset != lineDashOffset ||
            state.currentLineJoin != lineJoin ||
            state.currentLineWidth != lineWidth ||
            state.currentMiterLimit != miterLimit) {
            if (strokeStyle !== undefined) {
                applyStroke.call(this, state);
            }
            state.currentStrokeStyle = strokeStyle;
            state.currentLineCap = lineCap;
            state.currentLineDash = lineDash;
            state.currentLineDashOffset = lineDashOffset;
            state.currentLineJoin = lineJoin;
            state.currentLineWidth = lineWidth;
            state.currentMiterLimit = miterLimit;
        }
    };
    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasBuilder.prototype.endGeometry = function (feature) {
        this.beginGeometryInstruction1_[2] = this.instructions.length;
        this.beginGeometryInstruction1_ = null;
        this.beginGeometryInstruction2_[2] = this.hitDetectionInstructions.length;
        this.beginGeometryInstruction2_ = null;
        var endGeometryInstruction = [_Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].END_GEOMETRY, feature];
        this.instructions.push(endGeometryInstruction);
        this.hitDetectionInstructions.push(endGeometryInstruction);
    };
    /**
     * Get the buffered rendering extent.  Rendering will be clipped to the extent
     * provided to the constructor.  To account for symbolizers that may intersect
     * this extent, we calculate a buffered extent (e.g. based on stroke width).
     * @return {import("../../extent.js").Extent} The buffered rendering extent.
     * @protected
     */
    CanvasBuilder.prototype.getBufferedMaxExtent = function () {
        if (!this.bufferedMaxExtent_) {
            this.bufferedMaxExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["clone"])(this.maxExtent);
            if (this.maxLineWidth > 0) {
                var width = (this.resolution * (this.maxLineWidth + 1)) / 2;
                Object(_extent_js__WEBPACK_IMPORTED_MODULE_5__["buffer"])(this.bufferedMaxExtent_, width, this.bufferedMaxExtent_);
            }
        }
        return this.bufferedMaxExtent_;
    };
    return CanvasBuilder;
}(_VectorContext_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasBuilder);
//# sourceMappingURL=Builder.js.map

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fillInstruction", function() { return fillInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strokeInstruction", function() { return strokeInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "beginPathInstruction", function() { return beginPathInstruction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "closePathInstruction", function() { return closePathInstruction; });
/**
 * @module ol/render/canvas/Instruction
 */
/**
 * @enum {number}
 */
var Instruction = {
    BEGIN_GEOMETRY: 0,
    BEGIN_PATH: 1,
    CIRCLE: 2,
    CLOSE_PATH: 3,
    CUSTOM: 4,
    DRAW_CHARS: 5,
    DRAW_IMAGE: 6,
    END_GEOMETRY: 7,
    FILL: 8,
    MOVE_TO_LINE_TO: 9,
    SET_FILL_STYLE: 10,
    SET_STROKE_STYLE: 11,
    STROKE: 12,
};
/**
 * @type {Array<Instruction>}
 */
var fillInstruction = [Instruction.FILL];
/**
 * @type {Array<Instruction>}
 */
var strokeInstruction = [Instruction.STROKE];
/**
 * @type {Array<Instruction>}
 */
var beginPathInstruction = [Instruction.BEGIN_PATH];
/**
 * @type {Array<Instruction>}
 */
var closePathInstruction = [Instruction.CLOSE_PATH];
/* harmony default export */ __webpack_exports__["default"] = (Instruction);
//# sourceMappingURL=Instruction.js.map

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/render/VectorContext
 */
/**
 * @classdesc
 * Context for drawing geometries.  A vector context is available on render
 * events and does not need to be constructed directly.
 * @api
 */
var VectorContext = /** @class */ (function () {
    function VectorContext() {
    }
    /**
     * Render a geometry with a custom renderer.
     *
     * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {Function} renderer Renderer.
     */
    VectorContext.prototype.drawCustom = function (geometry, feature, renderer) { };
    /**
     * Render a geometry.
     *
     * @param {import("../geom/Geometry.js").default} geometry The geometry to render.
     */
    VectorContext.prototype.drawGeometry = function (geometry) { };
    /**
     * Set the rendering style.
     *
     * @param {import("../style/Style.js").default} style The rendering style.
     */
    VectorContext.prototype.setStyle = function (style) { };
    /**
     * @param {import("../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../Feature.js").default} feature Feature.
     */
    VectorContext.prototype.drawCircle = function (circleGeometry, feature) { };
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @param {import("../style/Style.js").default} style Style.
     */
    VectorContext.prototype.drawFeature = function (feature, style) { };
    /**
     * @param {import("../geom/GeometryCollection.js").default} geometryCollectionGeometry Geometry collection.
     * @param {import("../Feature.js").default} feature Feature.
     */
    VectorContext.prototype.drawGeometryCollection = function (geometryCollectionGeometry, feature) { };
    /**
     * @param {import("../geom/LineString.js").default|import("./Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawLineString = function (lineStringGeometry, feature) { };
    /**
     * @param {import("../geom/MultiLineString.js").default|import("./Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawMultiLineString = function (multiLineStringGeometry, feature) { };
    /**
     * @param {import("../geom/MultiPoint.js").default|import("./Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawMultiPoint = function (multiPointGeometry, feature) { };
    /**
     * @param {import("../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawMultiPolygon = function (multiPolygonGeometry, feature) { };
    /**
     * @param {import("../geom/Point.js").default|import("./Feature.js").default} pointGeometry Point geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawPoint = function (pointGeometry, feature) { };
    /**
     * @param {import("../geom/Polygon.js").default|import("./Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawPolygon = function (polygonGeometry, feature) { };
    /**
     * @param {import("../geom/SimpleGeometry.js").default|import("./Feature.js").default} geometry Geometry.
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     */
    VectorContext.prototype.drawText = function (geometry, feature) { };
    /**
     * @param {import("../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../style/Stroke.js").default} strokeStyle Stroke style.
     */
    VectorContext.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) { };
    /**
     * @param {import("../style/Image.js").default} imageStyle Image style.
     * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with a text style.
     */
    VectorContext.prototype.setImageStyle = function (imageStyle, opt_declutterImageWithText) { };
    /**
     * @param {import("../style/Text.js").default} textStyle Text style.
     * @param {import("../render/canvas.js").DeclutterImageWithText} [opt_declutterImageWithText] Shared data for combined decluttering with an image style.
     */
    VectorContext.prototype.setTextStyle = function (textStyle, opt_declutterImageWithText) { };
    return VectorContext;
}());
/* harmony default export */ __webpack_exports__["default"] = (VectorContext);
//# sourceMappingURL=VectorContext.js.map

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Builder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(292);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(293);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/render/canvas/ImageBuilder
 */


var CanvasImageBuilder = /** @class */ (function (_super) {
    __extends(CanvasImageBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function CanvasImageBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */
        _this.hitDetectionImage_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */
        _this.image_ = null;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.imagePixelRatio_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.anchorX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.anchorY_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.height_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.opacity_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.originX_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.originY_ = undefined;
        /**
         * @private
         * @type {boolean|undefined}
         */
        _this.rotateWithView_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.rotation_ = undefined;
        /**
         * @private
         * @type {import("../../size.js").Size|undefined}
         */
        _this.scale_ = undefined;
        /**
         * @private
         * @type {number|undefined}
         */
        _this.width_ = undefined;
        /**
         * Data shared with a text builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */
        _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} pointGeometry Point geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasImageBuilder.prototype.drawPoint = function (pointGeometry, feature) {
        if (!this.image_) {
            return;
        }
        this.beginGeometry(pointGeometry, feature);
        var flatCoordinates = pointGeometry.getFlatCoordinates();
        var stride = pointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            [
                (this.scale_[0] * this.pixelRatio) / this.imagePixelRatio_,
                (this.scale_[1] * this.pixelRatio) / this.imagePixelRatio_,
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterImageWithText_,
        ]);
        this.hitDetectionInstructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterImageWithText_,
        ]);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} multiPointGeometry MultiPoint geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasImageBuilder.prototype.drawMultiPoint = function (multiPointGeometry, feature) {
        if (!this.image_) {
            return;
        }
        this.beginGeometry(multiPointGeometry, feature);
        var flatCoordinates = multiPointGeometry.getFlatCoordinates();
        var stride = multiPointGeometry.getStride();
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatPointCoordinates(flatCoordinates, stride);
        this.instructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
            myBegin,
            myEnd,
            this.image_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_ * this.imagePixelRatio_,
            this.anchorY_ * this.imagePixelRatio_,
            Math.ceil(this.height_ * this.imagePixelRatio_),
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            [
                (this.scale_[0] * this.pixelRatio) / this.imagePixelRatio_,
                (this.scale_[1] * this.pixelRatio) / this.imagePixelRatio_,
            ],
            Math.ceil(this.width_ * this.imagePixelRatio_),
            this.declutterImageWithText_,
        ]);
        this.hitDetectionInstructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
            myBegin,
            myEnd,
            this.hitDetectionImage_,
            // Remaining arguments to DRAW_IMAGE are in alphabetical order
            this.anchorX_,
            this.anchorY_,
            this.height_,
            this.opacity_,
            this.originX_,
            this.originY_,
            this.rotateWithView_,
            this.rotation_,
            this.scale_,
            this.width_,
            this.declutterImageWithText_,
        ]);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */
    CanvasImageBuilder.prototype.finish = function () {
        this.reverseHitDetectionInstructions();
        // FIXME this doesn't really protect us against further calls to draw*Geometry
        this.anchorX_ = undefined;
        this.anchorY_ = undefined;
        this.hitDetectionImage_ = null;
        this.image_ = null;
        this.imagePixelRatio_ = undefined;
        this.height_ = undefined;
        this.scale_ = undefined;
        this.opacity_ = undefined;
        this.originX_ = undefined;
        this.originY_ = undefined;
        this.rotateWithView_ = undefined;
        this.rotation_ = undefined;
        this.width_ = undefined;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     * @param {Object} [opt_sharedData] Shared data.
     */
    CanvasImageBuilder.prototype.setImageStyle = function (imageStyle, opt_sharedData) {
        var anchor = imageStyle.getAnchor();
        var size = imageStyle.getSize();
        var hitDetectionImage = imageStyle.getHitDetectionImage();
        var image = imageStyle.getImage(this.pixelRatio);
        var origin = imageStyle.getOrigin();
        this.imagePixelRatio_ = imageStyle.getPixelRatio(this.pixelRatio);
        this.anchorX_ = anchor[0];
        this.anchorY_ = anchor[1];
        this.hitDetectionImage_ = hitDetectionImage;
        this.image_ = image;
        this.height_ = size[1];
        this.opacity_ = imageStyle.getOpacity();
        this.originX_ = origin[0];
        this.originY_ = origin[1];
        this.rotateWithView_ = imageStyle.getRotateWithView();
        this.rotation_ = imageStyle.getRotation();
        this.scale_ = imageStyle.getScaleArray();
        this.width_ = size[0];
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasImageBuilder;
}(_Builder_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasImageBuilder);
//# sourceMappingURL=ImageBuilder.js.map

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Builder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(292);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(293);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/render/canvas/LineStringBuilder
 */



var CanvasLineStringBuilder = /** @class */ (function (_super) {
    __extends(CanvasLineStringBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function CanvasLineStringBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     * @return {number} end.
     */
    CanvasLineStringBuilder.prototype.drawFlatCoordinates_ = function (flatCoordinates, offset, end, stride) {
        var myBegin = this.coordinates.length;
        var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, false, false);
        var moveToLineToInstruction = [
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].MOVE_TO_LINE_TO,
            myBegin,
            myEnd,
        ];
        this.instructions.push(moveToLineToInstruction);
        this.hitDetectionInstructions.push(moveToLineToInstruction);
        return end;
    };
    /**
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} lineStringGeometry Line string geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasLineStringBuilder.prototype.drawLineString = function (lineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) {
            return;
        }
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(lineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            _canvas_js__WEBPACK_IMPORTED_MODULE_2__["defaultLineDash"],
            _canvas_js__WEBPACK_IMPORTED_MODULE_2__["defaultLineDashOffset"],
        ], _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"]);
        var flatCoordinates = lineStringGeometry.getFlatCoordinates();
        var stride = lineStringGeometry.getStride();
        this.drawFlatCoordinates_(flatCoordinates, 0, flatCoordinates.length, stride);
        this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} multiLineStringGeometry MultiLineString geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasLineStringBuilder.prototype.drawMultiLineString = function (multiLineStringGeometry, feature) {
        var state = this.state;
        var strokeStyle = state.strokeStyle;
        var lineWidth = state.lineWidth;
        if (strokeStyle === undefined || lineWidth === undefined) {
            return;
        }
        this.updateStrokeStyle(state, this.applyStroke);
        this.beginGeometry(multiLineStringGeometry, feature);
        this.hitDetectionInstructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_STROKE_STYLE,
            state.strokeStyle,
            state.lineWidth,
            state.lineCap,
            state.lineJoin,
            state.miterLimit,
            state.lineDash,
            state.lineDashOffset,
        ], _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"]);
        var ends = multiLineStringGeometry.getEnds();
        var flatCoordinates = multiLineStringGeometry.getFlatCoordinates();
        var stride = multiLineStringGeometry.getStride();
        var offset = 0;
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            offset = this.drawFlatCoordinates_(flatCoordinates, offset, 
            /** @type {number} */ (ends[i]), stride);
        }
        this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */
    CanvasLineStringBuilder.prototype.finish = function () {
        var state = this.state;
        if (state.lastStroke != undefined &&
            state.lastStroke != this.coordinates.length) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
        }
        this.reverseHitDetectionInstructions();
        this.state = null;
        return _super.prototype.finish.call(this);
    };
    /**
     * @param {import("../canvas.js").FillStrokeState} state State.
     */
    CanvasLineStringBuilder.prototype.applyStroke = function (state) {
        if (state.lastStroke != undefined &&
            state.lastStroke != this.coordinates.length) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
            state.lastStroke = this.coordinates.length;
        }
        state.lastStroke = 0;
        _super.prototype.applyStroke.call(this, state);
        this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"]);
    };
    return CanvasLineStringBuilder;
}(_Builder_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasLineStringBuilder);
//# sourceMappingURL=LineStringBuilder.js.map

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Builder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(292);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(293);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44);
/* harmony import */ var _geom_flat_simplify_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(187);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/render/canvas/PolygonBuilder
 */




var CanvasPolygonBuilder = /** @class */ (function (_super) {
    __extends(CanvasPolygonBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function CanvasPolygonBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        return _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */
    CanvasPolygonBuilder.prototype.drawFlatCoordinatess_ = function (flatCoordinates, offset, ends, stride) {
        var state = this.state;
        var fill = state.fillStyle !== undefined;
        var stroke = state.strokeStyle !== undefined;
        var numEnds = ends.length;
        this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"]);
        this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"]);
        for (var i = 0; i < numEnds; ++i) {
            var end = ends[i];
            var myBegin = this.coordinates.length;
            var myEnd = this.appendFlatLineCoordinates(flatCoordinates, offset, end, stride, true, !stroke);
            var moveToLineToInstruction = [
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].MOVE_TO_LINE_TO,
                myBegin,
                myEnd,
            ];
            this.instructions.push(moveToLineToInstruction);
            this.hitDetectionInstructions.push(moveToLineToInstruction);
            if (stroke) {
                // Performance optimization: only call closePath() when we have a stroke.
                // Otherwise the ring is closed already (see appendFlatLineCoordinates above).
                this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["closePathInstruction"]);
                this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["closePathInstruction"]);
            }
            offset = end;
        }
        if (fill) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["fillInstruction"]);
            this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["fillInstruction"]);
        }
        if (stroke) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
            this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
        }
        return offset;
    };
    /**
     * @param {import("../../geom/Circle.js").default} circleGeometry Circle geometry.
     * @param {import("../../Feature.js").default} feature Feature.
     */
    CanvasPolygonBuilder.prototype.drawCircle = function (circleGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) {
            return;
        }
        this.setFillStrokeStyles_();
        this.beginGeometry(circleGeometry, feature);
        if (state.fillStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_FILL_STYLE,
                _canvas_js__WEBPACK_IMPORTED_MODULE_2__["defaultFillStyle"],
            ]);
        }
        if (state.strokeStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_STROKE_STYLE,
                state.strokeStyle,
                state.lineWidth,
                state.lineCap,
                state.lineJoin,
                state.miterLimit,
                state.lineDash,
                state.lineDashOffset,
            ]);
        }
        var flatCoordinates = circleGeometry.getFlatCoordinates();
        var stride = circleGeometry.getStride();
        var myBegin = this.coordinates.length;
        this.appendFlatLineCoordinates(flatCoordinates, 0, flatCoordinates.length, stride, false, false);
        var circleInstruction = [_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].CIRCLE, myBegin];
        this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"], circleInstruction);
        this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["beginPathInstruction"], circleInstruction);
        if (state.fillStyle !== undefined) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["fillInstruction"]);
            this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["fillInstruction"]);
        }
        if (state.strokeStyle !== undefined) {
            this.instructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
            this.hitDetectionInstructions.push(_Instruction_js__WEBPACK_IMPORTED_MODULE_1__["strokeInstruction"]);
        }
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} polygonGeometry Polygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasPolygonBuilder.prototype.drawPolygon = function (polygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) {
            return;
        }
        this.setFillStrokeStyles_();
        this.beginGeometry(polygonGeometry, feature);
        if (state.fillStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_FILL_STYLE,
                _canvas_js__WEBPACK_IMPORTED_MODULE_2__["defaultFillStyle"],
            ]);
        }
        if (state.strokeStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_STROKE_STYLE,
                state.strokeStyle,
                state.lineWidth,
                state.lineCap,
                state.lineJoin,
                state.miterLimit,
                state.lineDash,
                state.lineDashOffset,
            ]);
        }
        var ends = polygonGeometry.getEnds();
        var flatCoordinates = polygonGeometry.getOrientedFlatCoordinates();
        var stride = polygonGeometry.getStride();
        this.drawFlatCoordinatess_(flatCoordinates, 0, 
        /** @type {Array<number>} */ (ends), stride);
        this.endGeometry(feature);
    };
    /**
     * @param {import("../../geom/MultiPolygon.js").default} multiPolygonGeometry MultiPolygon geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasPolygonBuilder.prototype.drawMultiPolygon = function (multiPolygonGeometry, feature) {
        var state = this.state;
        var fillStyle = state.fillStyle;
        var strokeStyle = state.strokeStyle;
        if (fillStyle === undefined && strokeStyle === undefined) {
            return;
        }
        this.setFillStrokeStyles_();
        this.beginGeometry(multiPolygonGeometry, feature);
        if (state.fillStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_FILL_STYLE,
                _canvas_js__WEBPACK_IMPORTED_MODULE_2__["defaultFillStyle"],
            ]);
        }
        if (state.strokeStyle !== undefined) {
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].SET_STROKE_STYLE,
                state.strokeStyle,
                state.lineWidth,
                state.lineCap,
                state.lineJoin,
                state.miterLimit,
                state.lineDash,
                state.lineDashOffset,
            ]);
        }
        var endss = multiPolygonGeometry.getEndss();
        var flatCoordinates = multiPolygonGeometry.getOrientedFlatCoordinates();
        var stride = multiPolygonGeometry.getStride();
        var offset = 0;
        for (var i = 0, ii = endss.length; i < ii; ++i) {
            offset = this.drawFlatCoordinatess_(flatCoordinates, offset, endss[i], stride);
        }
        this.endGeometry(feature);
    };
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */
    CanvasPolygonBuilder.prototype.finish = function () {
        this.reverseHitDetectionInstructions();
        this.state = null;
        // We want to preserve topology when drawing polygons.  Polygons are
        // simplified using quantization and point elimination. However, we might
        // have received a mix of quantized and non-quantized geometries, so ensure
        // that all are quantized by quantizing all coordinates in the batch.
        var tolerance = this.tolerance;
        if (tolerance !== 0) {
            var coordinates = this.coordinates;
            for (var i = 0, ii = coordinates.length; i < ii; ++i) {
                coordinates[i] = Object(_geom_flat_simplify_js__WEBPACK_IMPORTED_MODULE_3__["snap"])(coordinates[i], tolerance);
            }
        }
        return _super.prototype.finish.call(this);
    };
    /**
     * @private
     */
    CanvasPolygonBuilder.prototype.setFillStrokeStyles_ = function () {
        var state = this.state;
        var fillStyle = state.fillStyle;
        if (fillStyle !== undefined) {
            this.updateFillStyle(state, this.createFill);
        }
        if (state.strokeStyle !== undefined) {
            this.updateStrokeStyle(state, this.applyStroke);
        }
    };
    return CanvasPolygonBuilder;
}(_Builder_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasPolygonBuilder);
//# sourceMappingURL=PolygonBuilder.js.map

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGN", function() { return TEXT_ALIGN; });
/* harmony import */ var _Builder_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(292);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(293);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _style_TextPlacement_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67);
/* harmony import */ var _colorlike_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
/* harmony import */ var _geom_flat_straightchunk_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(299);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/render/canvas/TextBuilder
 */









/**
 * @const
 * @enum {number}
 */
var TEXT_ALIGN = {
    'left': 0,
    'end': 0,
    'center': 0.5,
    'right': 1,
    'start': 1,
    'top': 0,
    'middle': 0.5,
    'hanging': 0.2,
    'alphabetic': 0.8,
    'ideographic': 0.8,
    'bottom': 1,
};
var CanvasTextBuilder = /** @class */ (function (_super) {
    __extends(CanvasTextBuilder, _super);
    /**
     * @param {number} tolerance Tolerance.
     * @param {import("../../extent.js").Extent} maxExtent Maximum extent.
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     */
    function CanvasTextBuilder(tolerance, maxExtent, resolution, pixelRatio) {
        var _this = _super.call(this, tolerance, maxExtent, resolution, pixelRatio) || this;
        /**
         * @private
         * @type {Array<HTMLCanvasElement>}
         */
        _this.labels_ = null;
        /**
         * @private
         * @type {string}
         */
        _this.text_ = '';
        /**
         * @private
         * @type {number}
         */
        _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean|undefined}
         */
        _this.textRotateWithView_ = undefined;
        /**
         * @private
         * @type {number}
         */
        _this.textRotation_ = 0;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */
        _this.textFillState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */
        _this.fillStates = {};
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */
        _this.textStrokeState_ = null;
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */
        _this.strokeStates = {};
        /**
         * @private
         * @type {import("../canvas.js").TextState}
         */
        _this.textState_ = /** @type {import("../canvas.js").TextState} */ ({});
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */
        _this.textStates = {};
        /**
         * @private
         * @type {string}
         */
        _this.textKey_ = '';
        /**
         * @private
         * @type {string}
         */
        _this.fillKey_ = '';
        /**
         * @private
         * @type {string}
         */
        _this.strokeKey_ = '';
        /**
         * Data shared with an image builder for combined decluttering.
         * @private
         * @type {import("../canvas.js").DeclutterImageWithText}
         */
        _this.declutterImageWithText_ = undefined;
        return _this;
    }
    /**
     * @return {import("../canvas.js").SerializableInstructions} the serializable instructions.
     */
    CanvasTextBuilder.prototype.finish = function () {
        var instructions = _super.prototype.finish.call(this);
        instructions.textStates = this.textStates;
        instructions.fillStates = this.fillStates;
        instructions.strokeStates = this.strokeStates;
        return instructions;
    };
    /**
     * @param {import("../../geom/SimpleGeometry.js").default|import("../Feature.js").default} geometry Geometry.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     */
    CanvasTextBuilder.prototype.drawText = function (geometry, feature) {
        var fillState = this.textFillState_;
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        if (this.text_ === '' || !textState || (!fillState && !strokeState)) {
            return;
        }
        var coordinates = this.coordinates;
        var begin = coordinates.length;
        var geometryType = geometry.getType();
        var flatCoordinates = null;
        var stride = geometry.getStride();
        if (textState.placement === _style_TextPlacement_js__WEBPACK_IMPORTED_MODULE_3__["default"].LINE &&
            (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING ||
                geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING ||
                geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON ||
                geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON)) {
            if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["intersects"])(this.getBufferedMaxExtent(), geometry.getExtent())) {
                return;
            }
            var ends = void 0;
            flatCoordinates = geometry.getFlatCoordinates();
            if (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING) {
                ends = [flatCoordinates.length];
            }
            else if (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING) {
                ends = /** @type {import("../../geom/MultiLineString.js").default} */ (geometry).getEnds();
            }
            else if (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON) {
                ends = /** @type {import("../../geom/Polygon.js").default} */ (geometry)
                    .getEnds()
                    .slice(0, 1);
            }
            else if (geometryType == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON) {
                var endss = 
                /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getEndss();
                ends = [];
                for (var i = 0, ii = endss.length; i < ii; ++i) {
                    ends.push(endss[i][0]);
                }
            }
            this.beginGeometry(geometry, feature);
            var textAlign = textState.textAlign;
            var flatOffset = 0;
            var flatEnd = void 0;
            for (var o = 0, oo = ends.length; o < oo; ++o) {
                if (textAlign == undefined) {
                    var range = Object(_geom_flat_straightchunk_js__WEBPACK_IMPORTED_MODULE_8__["matchingChunk"])(textState.maxAngle, flatCoordinates, flatOffset, ends[o], stride);
                    flatOffset = range[0];
                    flatEnd = range[1];
                }
                else {
                    flatEnd = ends[o];
                }
                for (var i = flatOffset; i < flatEnd; i += stride) {
                    coordinates.push(flatCoordinates[i], flatCoordinates[i + 1]);
                }
                var end = coordinates.length;
                flatOffset = ends[o];
                this.drawChars_(begin, end);
                begin = end;
            }
            this.endGeometry(feature);
        }
        else {
            var geometryWidths = textState.overflow ? null : [];
            switch (geometryType) {
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT:
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POINT:
                    flatCoordinates =
                        /** @type {import("../../geom/MultiPoint.js").default} */ (geometry).getFlatCoordinates();
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].LINE_STRING:
                    flatCoordinates =
                        /** @type {import("../../geom/LineString.js").default} */ (geometry).getFlatMidpoint();
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CIRCLE:
                    flatCoordinates =
                        /** @type {import("../../geom/Circle.js").default} */ (geometry).getCenter();
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_LINE_STRING:
                    flatCoordinates =
                        /** @type {import("../../geom/MultiLineString.js").default} */ (geometry).getFlatMidpoints();
                    stride = 2;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON:
                    flatCoordinates =
                        /** @type {import("../../geom/Polygon.js").default} */ (geometry).getFlatInteriorPoint();
                    if (!textState.overflow) {
                        geometryWidths.push(flatCoordinates[2] / this.resolution);
                    }
                    stride = 3;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].MULTI_POLYGON:
                    var interiorPoints = 
                    /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry).getFlatInteriorPoints();
                    flatCoordinates = [];
                    for (var i = 0, ii = interiorPoints.length; i < ii; i += 3) {
                        if (!textState.overflow) {
                            geometryWidths.push(interiorPoints[i + 2] / this.resolution);
                        }
                        flatCoordinates.push(interiorPoints[i], interiorPoints[i + 1]);
                    }
                    if (flatCoordinates.length === 0) {
                        return;
                    }
                    stride = 2;
                    break;
                default:
            }
            var end = this.appendFlatPointCoordinates(flatCoordinates, stride);
            if (end === begin) {
                return;
            }
            if (geometryWidths &&
                (end - begin) / 2 !== flatCoordinates.length / stride) {
                var beg_1 = begin / 2;
                geometryWidths = geometryWidths.filter(function (w, i) {
                    var keep = coordinates[(beg_1 + i) * 2] === flatCoordinates[i * stride] &&
                        coordinates[(beg_1 + i) * 2 + 1] === flatCoordinates[i * stride + 1];
                    if (!keep) {
                        --beg_1;
                    }
                    return keep;
                });
            }
            this.saveTextStates_();
            if (textState.backgroundFill || textState.backgroundStroke) {
                this.setFillStrokeStyle(textState.backgroundFill, textState.backgroundStroke);
                if (textState.backgroundFill) {
                    this.updateFillStyle(this.state, this.createFill);
                    this.hitDetectionInstructions.push(this.createFill(this.state));
                }
                if (textState.backgroundStroke) {
                    this.updateStrokeStyle(this.state, this.applyStroke);
                    this.hitDetectionInstructions.push(this.createStroke(this.state));
                }
            }
            this.beginGeometry(geometry, feature);
            // adjust padding for negative scale
            var padding = textState.padding;
            if (padding != _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"] &&
                (textState.scale[0] < 0 || textState.scale[1] < 0)) {
                var p0 = textState.padding[0];
                var p1 = textState.padding[1];
                var p2 = textState.padding[2];
                var p3 = textState.padding[3];
                if (textState.scale[0] < 0) {
                    p1 = -p1;
                    p3 = -p3;
                }
                if (textState.scale[1] < 0) {
                    p0 = -p0;
                    p2 = -p2;
                }
                padding = [p0, p1, p2, p3];
            }
            // The image is unknown at this stage so we pass null; it will be computed at render time.
            // For clarity, we pass NaN for offsetX, offsetY, width and height, which will be computed at
            // render time.
            var pixelRatio_1 = this.pixelRatio;
            this.instructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [1, 1],
                NaN,
                this.declutterImageWithText_,
                padding == _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"]
                    ? _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"]
                    : padding.map(function (p) {
                        return p * pixelRatio_1;
                    }),
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths,
            ]);
            var scale = 1 / pixelRatio_1;
            this.hitDetectionInstructions.push([
                _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_IMAGE,
                begin,
                end,
                null,
                NaN,
                NaN,
                NaN,
                1,
                0,
                0,
                this.textRotateWithView_,
                this.textRotation_,
                [scale, scale],
                NaN,
                this.declutterImageWithText_,
                padding,
                !!textState.backgroundFill,
                !!textState.backgroundStroke,
                this.text_,
                this.textKey_,
                this.strokeKey_,
                this.fillKey_,
                this.textOffsetX_,
                this.textOffsetY_,
                geometryWidths,
            ]);
            this.endGeometry(feature);
        }
    };
    /**
     * @private
     */
    CanvasTextBuilder.prototype.saveTextStates_ = function () {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var fillState = this.textFillState_;
        var strokeKey = this.strokeKey_;
        if (strokeState) {
            if (!(strokeKey in this.strokeStates)) {
                this.strokeStates[strokeKey] = {
                    strokeStyle: strokeState.strokeStyle,
                    lineCap: strokeState.lineCap,
                    lineDashOffset: strokeState.lineDashOffset,
                    lineWidth: strokeState.lineWidth,
                    lineJoin: strokeState.lineJoin,
                    miterLimit: strokeState.miterLimit,
                    lineDash: strokeState.lineDash,
                };
            }
        }
        var textKey = this.textKey_;
        if (!(textKey in this.textStates)) {
            this.textStates[textKey] = {
                font: textState.font,
                textAlign: textState.textAlign || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextAlign"],
                textBaseline: textState.textBaseline || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextBaseline"],
                scale: textState.scale,
            };
        }
        var fillKey = this.fillKey_;
        if (fillState) {
            if (!(fillKey in this.fillStates)) {
                this.fillStates[fillKey] = {
                    fillStyle: fillState.fillStyle,
                };
            }
        }
    };
    /**
     * @private
     * @param {number} begin Begin.
     * @param {number} end End.
     */
    CanvasTextBuilder.prototype.drawChars_ = function (begin, end) {
        var strokeState = this.textStrokeState_;
        var textState = this.textState_;
        var strokeKey = this.strokeKey_;
        var textKey = this.textKey_;
        var fillKey = this.fillKey_;
        this.saveTextStates_();
        var pixelRatio = this.pixelRatio;
        var baseline = TEXT_ALIGN[textState.textBaseline];
        var offsetY = this.textOffsetY_ * pixelRatio;
        var text = this.text_;
        var strokeWidth = strokeState
            ? (strokeState.lineWidth * Math.abs(textState.scale[0])) / 2
            : 0;
        this.instructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            pixelRatio,
            offsetY,
            strokeKey,
            strokeWidth * pixelRatio,
            text,
            textKey,
            1,
        ]);
        this.hitDetectionInstructions.push([
            _Instruction_js__WEBPACK_IMPORTED_MODULE_1__["default"].DRAW_CHARS,
            begin,
            end,
            baseline,
            textState.overflow,
            fillKey,
            textState.maxAngle,
            1,
            offsetY,
            strokeKey,
            strokeWidth,
            text,
            textKey,
            1 / pixelRatio,
        ]);
    };
    /**
     * @param {import("../../style/Text.js").default} textStyle Text style.
     * @param {Object} [opt_sharedData] Shared data.
     */
    CanvasTextBuilder.prototype.setTextStyle = function (textStyle, opt_sharedData) {
        var textState, fillState, strokeState;
        if (!textStyle) {
            this.text_ = '';
        }
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                fillState = null;
                this.textFillState_ = fillState;
            }
            else {
                fillState = this.textFillState_;
                if (!fillState) {
                    fillState = /** @type {import("../canvas.js").FillState} */ ({});
                    this.textFillState_ = fillState;
                }
                fillState.fillStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_4__["asColorLike"])(textFillStyle.getColor() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultFillStyle"]);
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                strokeState = null;
                this.textStrokeState_ = strokeState;
            }
            else {
                strokeState = this.textStrokeState_;
                if (!strokeState) {
                    strokeState = /** @type {import("../canvas.js").StrokeState} */ ({});
                    this.textStrokeState_ = strokeState;
                }
                var lineDash = textStrokeStyle.getLineDash();
                var lineDashOffset = textStrokeStyle.getLineDashOffset();
                var lineWidth = textStrokeStyle.getWidth();
                var miterLimit = textStrokeStyle.getMiterLimit();
                strokeState.lineCap = textStrokeStyle.getLineCap() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineCap"];
                strokeState.lineDash = lineDash ? lineDash.slice() : _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineDash"];
                strokeState.lineDashOffset =
                    lineDashOffset === undefined ? _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineDashOffset"] : lineDashOffset;
                strokeState.lineJoin = textStrokeStyle.getLineJoin() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineJoin"];
                strokeState.lineWidth =
                    lineWidth === undefined ? _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultLineWidth"] : lineWidth;
                strokeState.miterLimit =
                    miterLimit === undefined ? _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultMiterLimit"] : miterLimit;
                strokeState.strokeStyle = Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_4__["asColorLike"])(textStrokeStyle.getColor() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultStrokeStyle"]);
            }
            textState = this.textState_;
            var font = textStyle.getFont() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultFont"];
            Object(_canvas_js__WEBPACK_IMPORTED_MODULE_5__["registerFont"])(font);
            var textScale = textStyle.getScaleArray();
            textState.overflow = textStyle.getOverflow();
            textState.font = font;
            textState.maxAngle = textStyle.getMaxAngle();
            textState.placement = textStyle.getPlacement();
            textState.textAlign = textStyle.getTextAlign();
            textState.textBaseline =
                textStyle.getTextBaseline() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextBaseline"];
            textState.backgroundFill = textStyle.getBackgroundFill();
            textState.backgroundStroke = textStyle.getBackgroundStroke();
            textState.padding = textStyle.getPadding() || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"];
            textState.scale = textScale === undefined ? [1, 1] : textScale;
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            this.text_ = textStyle.getText() || '';
            this.textOffsetX_ = textOffsetX === undefined ? 0 : textOffsetX;
            this.textOffsetY_ = textOffsetY === undefined ? 0 : textOffsetY;
            this.textRotateWithView_ =
                textRotateWithView === undefined ? false : textRotateWithView;
            this.textRotation_ = textRotation === undefined ? 0 : textRotation;
            this.strokeKey_ = strokeState
                ? (typeof strokeState.strokeStyle == 'string'
                    ? strokeState.strokeStyle
                    : Object(_util_js__WEBPACK_IMPORTED_MODULE_6__["getUid"])(strokeState.strokeStyle)) +
                    strokeState.lineCap +
                    strokeState.lineDashOffset +
                    '|' +
                    strokeState.lineWidth +
                    strokeState.lineJoin +
                    strokeState.miterLimit +
                    '[' +
                    strokeState.lineDash.join() +
                    ']'
                : '';
            this.textKey_ =
                textState.font +
                    textState.scale +
                    (textState.textAlign || '?') +
                    (textState.textBaseline || '?');
            this.fillKey_ = fillState
                ? typeof fillState.fillStyle == 'string'
                    ? fillState.fillStyle
                    : '|' + Object(_util_js__WEBPACK_IMPORTED_MODULE_6__["getUid"])(fillState.fillStyle)
                : '';
        }
        this.declutterImageWithText_ = opt_sharedData;
    };
    return CanvasTextBuilder;
}(_Builder_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasTextBuilder);
//# sourceMappingURL=TextBuilder.js.map

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matchingChunk", function() { return matchingChunk; });
/**
 * @module ol/geom/flat/straightchunk
 */
/**
 * @param {number} maxAngle Maximum acceptable angle delta between segments.
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {Array<number>} Start and end of the first suitable chunk of the
 * given `flatCoordinates`.
 */
function matchingChunk(maxAngle, flatCoordinates, offset, end, stride) {
    var chunkStart = offset;
    var chunkEnd = offset;
    var chunkM = 0;
    var m = 0;
    var start = offset;
    var acos, i, m12, m23, x1, y1, x12, y12, x23, y23;
    for (i = offset; i < end; i += stride) {
        var x2 = flatCoordinates[i];
        var y2 = flatCoordinates[i + 1];
        if (x1 !== undefined) {
            x23 = x2 - x1;
            y23 = y2 - y1;
            m23 = Math.sqrt(x23 * x23 + y23 * y23);
            if (x12 !== undefined) {
                m += m12;
                acos = Math.acos((x12 * x23 + y12 * y23) / (m12 * m23));
                if (acos > maxAngle) {
                    if (m > chunkM) {
                        chunkM = m;
                        chunkStart = start;
                        chunkEnd = i;
                    }
                    m = 0;
                    start = i - stride;
                }
            }
            m12 = m23;
            x12 = x23;
            y12 = y23;
        }
        x1 = x2;
        y1 = y2;
    }
    m += m23;
    return m > chunkM ? [start, i] : [chunkStart, chunkEnd];
}
//# sourceMappingURL=straightchunk.js.map

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPixelIndexArray", function() { return getPixelIndexArray; });
/* harmony import */ var _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(301);
/* harmony import */ var _Executor_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(302);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52);
/* harmony import */ var _geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(102);
/**
 * @module ol/render/canvas/ExecutorGroup
 */








/**
 * @const
 * @type {Array<import("./BuilderType.js").default>}
 */
var ORDER = [
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON,
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CIRCLE,
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING,
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE,
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT,
    _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].DEFAULT,
];
var ExecutorGroup = /** @class */ (function () {
    /**
     * @param {import("../../extent.js").Extent} maxExtent Max extent for clipping. When a
     * `maxExtent` was set on the Builder for this executor group, the same `maxExtent`
     * should be set here, unless the target context does not exceed that extent (which
     * can be the case when rendering to tiles).
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The executor group can have overlapping geometries.
     * @param {!Object<string, !Object<import("./BuilderType.js").default, import("../canvas.js").SerializableInstructions>>} allInstructions
     * The serializable instructions.
     * @param {number} [opt_renderBuffer] Optional rendering buffer.
     */
    function ExecutorGroup(maxExtent, resolution, pixelRatio, overlaps, allInstructions, opt_renderBuffer) {
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        this.maxExtent_ = maxExtent;
        /**
         * @private
         * @type {boolean}
         */
        this.overlaps_ = overlaps;
        /**
         * @private
         * @type {number}
         */
        this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {number}
         */
        this.resolution_ = resolution;
        /**
         * @private
         * @type {number|undefined}
         */
        this.renderBuffer_ = opt_renderBuffer;
        /**
         * @private
         * @type {!Object<string, !Object<import("./BuilderType.js").default, import("./Executor").default>>}
         */
        this.executorsByZIndex_ = {};
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */
        this.hitDetectionContext_ = null;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        this.hitDetectionTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        this.createExecutors_(allInstructions);
    }
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     */
    ExecutorGroup.prototype.clip = function (context, transform) {
        var flatClipCoords = this.getClipCoords(transform);
        context.beginPath();
        context.moveTo(flatClipCoords[0], flatClipCoords[1]);
        context.lineTo(flatClipCoords[2], flatClipCoords[3]);
        context.lineTo(flatClipCoords[4], flatClipCoords[5]);
        context.lineTo(flatClipCoords[6], flatClipCoords[7]);
        context.clip();
    };
    /**
     * Create executors and populate them using the provided instructions.
     * @private
     * @param {!Object<string, !Object<import("./BuilderType.js").default, import("../canvas.js").SerializableInstructions>>} allInstructions The serializable instructions
     */
    ExecutorGroup.prototype.createExecutors_ = function (allInstructions) {
        for (var zIndex in allInstructions) {
            var executors = this.executorsByZIndex_[zIndex];
            if (executors === undefined) {
                executors = {};
                this.executorsByZIndex_[zIndex] = executors;
            }
            var instructionByZindex = allInstructions[zIndex];
            for (var builderType in instructionByZindex) {
                var instructions = instructionByZindex[builderType];
                executors[builderType] = new _Executor_js__WEBPACK_IMPORTED_MODULE_1__["default"](this.resolution_, this.pixelRatio_, this.overlaps_, instructions);
            }
        }
    };
    /**
     * @param {Array<import("./BuilderType.js").default>} executors Executors.
     * @return {boolean} Has executors of the provided types.
     */
    ExecutorGroup.prototype.hasExecutors = function (executors) {
        for (var zIndex in this.executorsByZIndex_) {
            var candidates = this.executorsByZIndex_[zIndex];
            for (var i = 0, ii = executors.length; i < ii; ++i) {
                if (executors[i] in candidates) {
                    return true;
                }
            }
        }
        return false;
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {number} resolution Resolution.
     * @param {number} rotation Rotation.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default, number): T} callback Feature callback.
     * @param {Array<import("../../Feature.js").FeatureLike>} declutteredFeatures Decluttered features.
     * @return {T|undefined} Callback result.
     * @template T
     */
    ExecutorGroup.prototype.forEachFeatureAtCoordinate = function (coordinate, resolution, rotation, hitTolerance, callback, declutteredFeatures) {
        hitTolerance = Math.round(hitTolerance);
        var contextSize = hitTolerance * 2 + 1;
        var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(this.hitDetectionTransform_, hitTolerance + 0.5, hitTolerance + 0.5, 1 / resolution, -1 / resolution, -rotation, -coordinate[0], -coordinate[1]);
        var newContext = !this.hitDetectionContext_;
        if (newContext) {
            this.hitDetectionContext_ = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(contextSize, contextSize);
        }
        var context = this.hitDetectionContext_;
        if (context.canvas.width !== contextSize ||
            context.canvas.height !== contextSize) {
            context.canvas.width = contextSize;
            context.canvas.height = contextSize;
        }
        else if (!newContext) {
            context.clearRect(0, 0, contextSize, contextSize);
        }
        /**
         * @type {import("../../extent.js").Extent}
         */
        var hitExtent;
        if (this.renderBuffer_ !== undefined) {
            hitExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["createEmpty"])();
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["extendCoordinate"])(hitExtent, coordinate);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_2__["buffer"])(hitExtent, resolution * (this.renderBuffer_ + hitTolerance), hitExtent);
        }
        var indexes = getPixelIndexArray(hitTolerance);
        var builderType;
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @return {T|undefined} Callback result.
         */
        function featureCallback(feature, geometry) {
            var imageData = context.getImageData(0, 0, contextSize, contextSize).data;
            for (var i_1 = 0, ii = indexes.length; i_1 < ii; i_1++) {
                if (imageData[indexes[i_1]] > 0) {
                    if (!declutteredFeatures ||
                        (builderType !== _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE &&
                            builderType !== _BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT) ||
                        declutteredFeatures.indexOf(feature) !== -1) {
                        var idx = (indexes[i_1] - 3) / 4;
                        var x = hitTolerance - (idx % contextSize);
                        var y = hitTolerance - ((idx / contextSize) | 0);
                        var result_1 = callback(feature, geometry, x * x + y * y);
                        if (result_1) {
                            return result_1;
                        }
                    }
                    context.clearRect(0, 0, contextSize, contextSize);
                    break;
                }
            }
            return undefined;
        }
        /** @type {Array<number>} */
        var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(_array_js__WEBPACK_IMPORTED_MODULE_6__["numberSafeCompareFunction"]);
        var i, j, executors, executor, result;
        for (i = zs.length - 1; i >= 0; --i) {
            var zIndexKey = zs[i].toString();
            executors = this.executorsByZIndex_[zIndexKey];
            for (j = ORDER.length - 1; j >= 0; --j) {
                builderType = ORDER[j];
                executor = executors[builderType];
                if (executor !== undefined) {
                    result = executor.executeHitDetection(context, transform, rotation, featureCallback, hitExtent);
                    if (result) {
                        return result;
                    }
                }
            }
        }
        return undefined;
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     * @return {Array<number>} Clip coordinates.
     */
    ExecutorGroup.prototype.getClipCoords = function (transform) {
        var maxExtent = this.maxExtent_;
        if (!maxExtent) {
            return null;
        }
        var minX = maxExtent[0];
        var minY = maxExtent[1];
        var maxX = maxExtent[2];
        var maxY = maxExtent[3];
        var flatClipCoords = [minX, minY, minX, maxY, maxX, maxY, maxX, minY];
        Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__["transform2D"])(flatClipCoords, 0, 8, 2, transform, flatClipCoords);
        return flatClipCoords;
    };
    /**
     * @return {boolean} Is empty.
     */
    ExecutorGroup.prototype.isEmpty = function () {
        return Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["isEmpty"])(this.executorsByZIndex_);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and test to integer pixel.
     * @param {Array<import("./BuilderType.js").default>} [opt_builderTypes] Ordered replay types to replay.
     *     Default is {@link module:ol/render/replay~ORDER}
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */
    ExecutorGroup.prototype.execute = function (context, contextScale, transform, viewRotation, snapToPixel, opt_builderTypes, opt_declutterTree) {
        /** @type {Array<number>} */
        var zs = Object.keys(this.executorsByZIndex_).map(Number);
        zs.sort(_array_js__WEBPACK_IMPORTED_MODULE_6__["numberSafeCompareFunction"]);
        // setup clipping so that the parts of over-simplified geometries are not
        // visible outside the current extent when panning
        if (this.maxExtent_) {
            context.save();
            this.clip(context, transform);
        }
        var builderTypes = opt_builderTypes ? opt_builderTypes : ORDER;
        var i, ii, j, jj, replays, replay;
        if (opt_declutterTree) {
            zs.reverse();
        }
        for (i = 0, ii = zs.length; i < ii; ++i) {
            var zIndexKey = zs[i].toString();
            replays = this.executorsByZIndex_[zIndexKey];
            for (j = 0, jj = builderTypes.length; j < jj; ++j) {
                var builderType = builderTypes[j];
                replay = replays[builderType];
                if (replay !== undefined) {
                    replay.execute(context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree);
                }
            }
        }
        if (this.maxExtent_) {
            context.restore();
        }
    };
    return ExecutorGroup;
}());
/**
 * This cache is used to store arrays of indexes for calculated pixel circles
 * to increase performance.
 * It is a static property to allow each Replaygroup to access it.
 * @type {Object<number, Array<number>>}
 */
var circlePixelIndexArrayCache = {};
/**
 * This methods creates an array with indexes of all pixels within a circle,
 * ordered by how close they are to the center.
 * A cache is used to increase performance.
 * @param {number} radius Radius.
 * @return {Array<number>} An array with indexes within a circle.
 */
function getPixelIndexArray(radius) {
    if (circlePixelIndexArrayCache[radius] !== undefined) {
        return circlePixelIndexArrayCache[radius];
    }
    var size = radius * 2 + 1;
    var maxDistanceSq = radius * radius;
    var distances = new Array(maxDistanceSq + 1);
    for (var i = 0; i <= radius; ++i) {
        for (var j = 0; j <= radius; ++j) {
            var distanceSq = i * i + j * j;
            if (distanceSq > maxDistanceSq) {
                break;
            }
            var distance = distances[distanceSq];
            if (!distance) {
                distance = [];
                distances[distanceSq] = distance;
            }
            distance.push(((radius + i) * size + (radius + j)) * 4 + 3);
            if (i > 0) {
                distance.push(((radius - i) * size + (radius + j)) * 4 + 3);
            }
            if (j > 0) {
                distance.push(((radius + i) * size + (radius - j)) * 4 + 3);
                if (i > 0) {
                    distance.push(((radius - i) * size + (radius - j)) * 4 + 3);
                }
            }
        }
    }
    var pixelIndex = [];
    for (var i = 0, ii = distances.length; i < ii; ++i) {
        if (distances[i]) {
            pixelIndex.push.apply(pixelIndex, distances[i]);
        }
    }
    circlePixelIndexArrayCache[radius] = pixelIndex;
    return pixelIndex;
}
/* harmony default export */ __webpack_exports__["default"] = (ExecutorGroup);
//# sourceMappingURL=ExecutorGroup.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/render/canvas/BuilderType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    CIRCLE: 'Circle',
    DEFAULT: 'Default',
    IMAGE: 'Image',
    LINE_STRING: 'LineString',
    POLYGON: 'Polygon',
    TEXT: 'Text',
});
//# sourceMappingURL=BuilderType.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Instruction_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(293);
/* harmony import */ var _TextBuilder_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(298);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44);
/* harmony import */ var _geom_flat_textpath_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(303);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/* harmony import */ var _geom_flat_length_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(205);
/* harmony import */ var _geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(102);
/**
 * @module ol/render/canvas/Executor
 */











/**
 * @typedef {Object} BBox
 * @property {number} minX Minimal x.
 * @property {number} minY Minimal y.
 * @property {number} maxX Maximal x.
 * @property {number} maxY Maximal y
 * @property {*} value Value.
 */
/**
 * @typedef {Object} ImageOrLabelDimensions
 * @property {number} drawImageX DrawImageX.
 * @property {number} drawImageY DrawImageY.
 * @property {number} drawImageW DrawImageW.
 * @property {number} drawImageH DrawImageH.
 * @property {number} originX OriginX.
 * @property {number} originY OriginY.
 * @property {Array<number>} scale Scale.
 * @property {BBox} declutterBox DeclutterBox.
 * @property {import("../../transform.js").Transform} canvasTransform CanvasTransform.
 */
/**
 * @typedef {{0: CanvasRenderingContext2D, 1: number, 2: import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement, 3: ImageOrLabelDimensions, 4: number, 5: Array<*>, 6: Array<*>}} ReplayImageOrLabelArgs
 */
/**
 * @template T
 * @typedef {function(import("../../Feature.js").FeatureLike, import("../../geom/SimpleGeometry.js").default): T} FeatureCallback
 */
/**
 * @type {import("../../extent.js").Extent}
 */
var tmpExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createEmpty"])();
/** @type {import("../../coordinate.js").Coordinate} */
var p1 = [];
/** @type {import("../../coordinate.js").Coordinate} */
var p2 = [];
/** @type {import("../../coordinate.js").Coordinate} */
var p3 = [];
/** @type {import("../../coordinate.js").Coordinate} */
var p4 = [];
/**
 * @param {ReplayImageOrLabelArgs} replayImageOrLabelArgs Arguments to replayImageOrLabel
 * @return {BBox} Declutter bbox.
 */
function getDeclutterBox(replayImageOrLabelArgs) {
    return replayImageOrLabelArgs[3].declutterBox;
}
var rtlRegEx = new RegExp(
/* eslint-disable prettier/prettier */
'[' +
    String.fromCharCode(0x00591) + '-' + String.fromCharCode(0x008ff) +
    String.fromCharCode(0x0fb1d) + '-' + String.fromCharCode(0x0fdff) +
    String.fromCharCode(0x0fe70) + '-' + String.fromCharCode(0x0fefc) +
    String.fromCharCode(0x10800) + '-' + String.fromCharCode(0x10fff) +
    String.fromCharCode(0x1e800) + '-' + String.fromCharCode(0x1efff) +
    ']'
/* eslint-enable prettier/prettier */
);
/**
 * @param {string} text Text.
 * @param {string} align Alignment.
 * @return {number} Text alignment.
 */
function horizontalTextAlign(text, align) {
    if ((align === 'start' || align === 'end') && !rtlRegEx.test(text)) {
        align = align === 'start' ? 'left' : 'right';
    }
    return _TextBuilder_js__WEBPACK_IMPORTED_MODULE_1__["TEXT_ALIGN"][align];
}
var Executor = /** @class */ (function () {
    /**
     * @param {number} resolution Resolution.
     * @param {number} pixelRatio Pixel ratio.
     * @param {boolean} overlaps The replay can have overlapping geometries.
     * @param {import("../canvas.js").SerializableInstructions} instructions The serializable instructions
     */
    function Executor(resolution, pixelRatio, overlaps, instructions) {
        /**
         * @protected
         * @type {boolean}
         */
        this.overlaps = overlaps;
        /**
         * @protected
         * @type {number}
         */
        this.pixelRatio = pixelRatio;
        /**
         * @protected
         * @const
         * @type {number}
         */
        this.resolution = resolution;
        /**
         * @private
         * @type {boolean}
         */
        this.alignFill_;
        /**
         * @protected
         * @type {Array<*>}
         */
        this.instructions = instructions.instructions;
        /**
         * @protected
         * @type {Array<number>}
         */
        this.coordinates = instructions.coordinates;
        /**
         * @private
         * @type {!Object<number,import("../../coordinate.js").Coordinate|Array<import("../../coordinate.js").Coordinate>|Array<Array<import("../../coordinate.js").Coordinate>>>}
         */
        this.coordinateCache_ = {};
        /**
         * @private
         * @type {!import("../../transform.js").Transform}
         */
        this.renderedTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        /**
         * @protected
         * @type {Array<*>}
         */
        this.hitDetectionInstructions = instructions.hitDetectionInstructions;
        /**
         * @private
         * @type {Array<number>}
         */
        this.pixelCoordinates_ = null;
        /**
         * @private
         * @type {number}
         */
        this.viewRotation_ = 0;
        /**
         * @type {!Object<string, import("../canvas.js").FillState>}
         */
        this.fillStates = instructions.fillStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").StrokeState>}
         */
        this.strokeStates = instructions.strokeStates || {};
        /**
         * @type {!Object<string, import("../canvas.js").TextState>}
         */
        this.textStates = instructions.textStates || {};
        /**
         * @private
         * @type {Object<string, Object<string, number>>}
         */
        this.widths_ = {};
        /**
         * @private
         * @type {Object<string, import("../canvas.js").Label>}
         */
        this.labels_ = {};
    }
    /**
     * @param {string} text Text.
     * @param {string} textKey Text style key.
     * @param {string} fillKey Fill style key.
     * @param {string} strokeKey Stroke style key.
     * @return {import("../canvas.js").Label} Label.
     */
    Executor.prototype.createLabel = function (text, textKey, fillKey, strokeKey) {
        var key = text + textKey + fillKey + strokeKey;
        if (this.labels_[key]) {
            return this.labels_[key];
        }
        var strokeState = strokeKey ? this.strokeStates[strokeKey] : null;
        var fillState = fillKey ? this.fillStates[fillKey] : null;
        var textState = this.textStates[textKey];
        var pixelRatio = this.pixelRatio;
        var scale = [
            textState.scale[0] * pixelRatio,
            textState.scale[1] * pixelRatio,
        ];
        var align = horizontalTextAlign(text, textState.textAlign || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextAlign"]);
        var strokeWidth = strokeKey && strokeState.lineWidth ? strokeState.lineWidth : 0;
        var lines = text.split('\n');
        var numLines = lines.length;
        var widths = [];
        var width = Object(_canvas_js__WEBPACK_IMPORTED_MODULE_5__["measureTextWidths"])(textState.font, lines, widths);
        var lineHeight = Object(_canvas_js__WEBPACK_IMPORTED_MODULE_5__["measureTextHeight"])(textState.font);
        var height = lineHeight * numLines;
        var renderWidth = width + strokeWidth;
        var contextInstructions = [];
        // make canvas 2 pixels wider to account for italic text width measurement errors
        var w = (renderWidth + 2) * scale[0];
        var h = (height + strokeWidth) * scale[1];
        /** @type {import("../canvas.js").Label} */
        var label = {
            width: w < 0 ? Math.floor(w) : Math.ceil(w),
            height: h < 0 ? Math.floor(h) : Math.ceil(h),
            contextInstructions: contextInstructions,
        };
        if (scale[0] != 1 || scale[1] != 1) {
            contextInstructions.push('scale', scale);
        }
        contextInstructions.push('font', textState.font);
        if (strokeKey) {
            contextInstructions.push('strokeStyle', strokeState.strokeStyle);
            contextInstructions.push('lineWidth', strokeWidth);
            contextInstructions.push('lineCap', strokeState.lineCap);
            contextInstructions.push('lineJoin', strokeState.lineJoin);
            contextInstructions.push('miterLimit', strokeState.miterLimit);
            // eslint-disable-next-line
            var Context = _has_js__WEBPACK_IMPORTED_MODULE_2__["WORKER_OFFSCREEN_CANVAS"] ? OffscreenCanvasRenderingContext2D : CanvasRenderingContext2D;
            if (Context.prototype.setLineDash) {
                contextInstructions.push('setLineDash', [strokeState.lineDash]);
                contextInstructions.push('lineDashOffset', strokeState.lineDashOffset);
            }
        }
        if (fillKey) {
            contextInstructions.push('fillStyle', fillState.fillStyle);
        }
        contextInstructions.push('textBaseline', 'middle');
        contextInstructions.push('textAlign', 'center');
        var leftRight = 0.5 - align;
        var x = align * renderWidth + leftRight * strokeWidth;
        var i;
        if (strokeKey) {
            for (i = 0; i < numLines; ++i) {
                contextInstructions.push('strokeText', [
                    lines[i],
                    x + leftRight * widths[i],
                    0.5 * (strokeWidth + lineHeight) + i * lineHeight,
                ]);
            }
        }
        if (fillKey) {
            for (i = 0; i < numLines; ++i) {
                contextInstructions.push('fillText', [
                    lines[i],
                    x + leftRight * widths[i],
                    0.5 * (strokeWidth + lineHeight) + i * lineHeight,
                ]);
            }
        }
        this.labels_[key] = label;
        return label;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../coordinate.js").Coordinate} p1 1st point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p2 2nd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p3 3rd point of the background box.
     * @param {import("../../coordinate.js").Coordinate} p4 4th point of the background box.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     */
    Executor.prototype.replayTextBackground_ = function (context, p1, p2, p3, p4, fillInstruction, strokeInstruction) {
        context.beginPath();
        context.moveTo.apply(context, p1);
        context.lineTo.apply(context, p2);
        context.lineTo.apply(context, p3);
        context.lineTo.apply(context, p4);
        context.lineTo.apply(context, p1);
        if (fillInstruction) {
            this.alignFill_ = /** @type {boolean} */ (fillInstruction[2]);
            this.fill_(context);
        }
        if (strokeInstruction) {
            this.setStrokeStyle_(context, 
            /** @type {Array<*>} */ (strokeInstruction));
            context.stroke();
        }
    };
    /**
     * @private
     * @param {number} sheetWidth Width of the sprite sheet.
     * @param {number} sheetHeight Height of the sprite sheet.
     * @param {number} centerX X.
     * @param {number} centerY Y.
     * @param {number} width Width.
     * @param {number} height Height.
     * @param {number} anchorX Anchor X.
     * @param {number} anchorY Anchor Y.
     * @param {number} originX Origin X.
     * @param {number} originY Origin Y.
     * @param {number} rotation Rotation.
     * @param {import("../../size.js").Size} scale Scale.
     * @param {boolean} snapToPixel Snap to pixel.
     * @param {Array<number>} padding Padding.
     * @param {boolean} fillStroke Background fill or stroke.
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @return {ImageOrLabelDimensions} Dimensions for positioning and decluttering the image or label.
     */
    Executor.prototype.calculateImageOrLabelDimensions_ = function (sheetWidth, sheetHeight, centerX, centerY, width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, fillStroke, feature) {
        anchorX *= scale[0];
        anchorY *= scale[1];
        var x = centerX - anchorX;
        var y = centerY - anchorY;
        var w = width + originX > sheetWidth ? sheetWidth - originX : width;
        var h = height + originY > sheetHeight ? sheetHeight - originY : height;
        var boxW = padding[3] + w * scale[0] + padding[1];
        var boxH = padding[0] + h * scale[1] + padding[2];
        var boxX = x - padding[3];
        var boxY = y - padding[0];
        if (fillStroke || rotation !== 0) {
            p1[0] = boxX;
            p4[0] = boxX;
            p1[1] = boxY;
            p2[1] = boxY;
            p2[0] = boxX + boxW;
            p3[0] = p2[0];
            p3[1] = boxY + boxH;
            p4[1] = p3[1];
        }
        var transform;
        if (rotation !== 0) {
            transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])(), centerX, centerY, 1, 1, rotation, -centerX, -centerY);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(transform, p1);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(transform, p2);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(transform, p3);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(transform, p4);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdate"])(Math.min(p1[0], p2[0], p3[0], p4[0]), Math.min(p1[1], p2[1], p3[1], p4[1]), Math.max(p1[0], p2[0], p3[0], p4[0]), Math.max(p1[1], p2[1], p3[1], p4[1]), tmpExtent);
        }
        else {
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["createOrUpdate"])(Math.min(boxX, boxX + boxW), Math.min(boxY, boxY + boxH), Math.max(boxX, boxX + boxW), Math.max(boxY, boxY + boxH), tmpExtent);
        }
        if (snapToPixel) {
            x = Math.round(x);
            y = Math.round(y);
        }
        return {
            drawImageX: x,
            drawImageY: y,
            drawImageW: w,
            drawImageH: h,
            originX: originX,
            originY: originY,
            declutterBox: {
                minX: tmpExtent[0],
                minY: tmpExtent[1],
                maxX: tmpExtent[2],
                maxY: tmpExtent[3],
                value: feature,
            },
            canvasTransform: transform,
            scale: scale,
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../canvas.js").Label|HTMLImageElement|HTMLCanvasElement|HTMLVideoElement} imageOrLabel Image.
     * @param {ImageOrLabelDimensions} dimensions Dimensions.
     * @param {number} opacity Opacity.
     * @param {Array<*>} fillInstruction Fill instruction.
     * @param {Array<*>} strokeInstruction Stroke instruction.
     * @return {boolean} The image or label was rendered.
     */
    Executor.prototype.replayImageOrLabel_ = function (context, contextScale, imageOrLabel, dimensions, opacity, fillInstruction, strokeInstruction) {
        var fillStroke = !!(fillInstruction || strokeInstruction);
        var box = dimensions.declutterBox;
        var canvas = context.canvas;
        var strokePadding = strokeInstruction
            ? (strokeInstruction[2] * dimensions.scale[0]) / 2
            : 0;
        var intersects = box.minX - strokePadding <= canvas.width / contextScale &&
            box.maxX + strokePadding >= 0 &&
            box.minY - strokePadding <= canvas.height / contextScale &&
            box.maxY + strokePadding >= 0;
        if (intersects) {
            if (fillStroke) {
                this.replayTextBackground_(context, p1, p2, p3, p4, 
                /** @type {Array<*>} */ (fillInstruction), 
                /** @type {Array<*>} */ (strokeInstruction));
            }
            Object(_canvas_js__WEBPACK_IMPORTED_MODULE_5__["drawImageOrLabel"])(context, dimensions.canvasTransform, opacity, imageOrLabel, dimensions.originX, dimensions.originY, dimensions.drawImageW, dimensions.drawImageH, dimensions.drawImageX, dimensions.drawImageY, dimensions.scale);
        }
        return true;
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     */
    Executor.prototype.fill_ = function (context) {
        if (this.alignFill_) {
            var origin_1 = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["apply"])(this.renderedTransform_, [0, 0]);
            var repeatSize = 512 * this.pixelRatio;
            context.save();
            context.translate(origin_1[0] % repeatSize, origin_1[1] % repeatSize);
            context.rotate(this.viewRotation_);
        }
        context.fill();
        if (this.alignFill_) {
            context.restore();
        }
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {Array<*>} instruction Instruction.
     */
    Executor.prototype.setStrokeStyle_ = function (context, instruction) {
        context['strokeStyle'] =
            /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
        context.lineWidth = /** @type {number} */ (instruction[2]);
        context.lineCap = /** @type {CanvasLineCap} */ (instruction[3]);
        context.lineJoin = /** @type {CanvasLineJoin} */ (instruction[4]);
        context.miterLimit = /** @type {number} */ (instruction[5]);
        if (context.setLineDash) {
            context.lineDashOffset = /** @type {number} */ (instruction[7]);
            context.setLineDash(/** @type {Array<number>} */ (instruction[6]));
        }
    };
    /**
     * @private
     * @param {string} text The text to draw.
     * @param {string} textKey The key of the text state.
     * @param {string} strokeKey The key for the stroke state.
     * @param {string} fillKey The key for the fill state.
     * @return {{label: import("../canvas.js").Label, anchorX: number, anchorY: number}} The text image and its anchor.
     */
    Executor.prototype.drawLabelWithPointPlacement_ = function (text, textKey, strokeKey, fillKey) {
        var textState = this.textStates[textKey];
        var label = this.createLabel(text, textKey, fillKey, strokeKey);
        var strokeState = this.strokeStates[strokeKey];
        var pixelRatio = this.pixelRatio;
        var align = horizontalTextAlign(text, textState.textAlign || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextAlign"]);
        var baseline = _TextBuilder_js__WEBPACK_IMPORTED_MODULE_1__["TEXT_ALIGN"][textState.textBaseline || _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultTextBaseline"]];
        var strokeWidth = strokeState && strokeState.lineWidth ? strokeState.lineWidth : 0;
        // Remove the 2 pixels we added in createLabel() for the anchor
        var width = label.width / pixelRatio - 2 * textState.scale[0];
        var anchorX = align * width + 2 * (0.5 - align) * strokeWidth;
        var anchorY = (baseline * label.height) / pixelRatio +
            2 * (0.5 - baseline) * strokeWidth;
        return {
            label: label,
            anchorX: anchorX,
            anchorY: anchorY,
        };
    };
    /**
     * @private
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {Array<*>} instructions Instructions array.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {FeatureCallback<T>} [opt_featureCallback] Feature callback.
     * @param {import("../../extent.js").Extent} [opt_hitExtent] Only check
     *     features that intersect this extent.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     * @return {T|undefined} Callback result.
     * @template T
     */
    Executor.prototype.execute_ = function (context, contextScale, transform, instructions, snapToPixel, opt_featureCallback, opt_hitExtent, opt_declutterTree) {
        /** @type {Array<number>} */
        var pixelCoordinates;
        if (this.pixelCoordinates_ && Object(_array_js__WEBPACK_IMPORTED_MODULE_7__["equals"])(transform, this.renderedTransform_)) {
            pixelCoordinates = this.pixelCoordinates_;
        }
        else {
            if (!this.pixelCoordinates_) {
                this.pixelCoordinates_ = [];
            }
            pixelCoordinates = Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_9__["transform2D"])(this.coordinates, 0, this.coordinates.length, 2, transform, this.pixelCoordinates_);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["setFromArray"])(this.renderedTransform_, transform);
        }
        var i = 0; // instruction index
        var ii = instructions.length; // end of instructions
        var d = 0; // data index
        var dd; // end of per-instruction data
        var anchorX, anchorY, prevX, prevY, roundX, roundY, image, text, textKey, strokeKey, fillKey;
        var pendingFill = 0;
        var pendingStroke = 0;
        var lastFillInstruction = null;
        var lastStrokeInstruction = null;
        var coordinateCache = this.coordinateCache_;
        var viewRotation = this.viewRotation_;
        var viewRotationFromTransform = Math.round(Math.atan2(-transform[1], transform[0]) * 1e12) / 1e12;
        var state = /** @type {import("../../render.js").State} */ ({
            context: context,
            pixelRatio: this.pixelRatio,
            resolution: this.resolution,
            rotation: viewRotation,
        });
        // When the batch size gets too big, performance decreases. 200 is a good
        // balance between batch size and number of fill/stroke instructions.
        var batchSize = this.instructions != instructions || this.overlaps ? 0 : 200;
        var /** @type {import("../../Feature.js").FeatureLike} */ feature;
        var x, y, currentGeometry;
        while (i < ii) {
            var instruction = instructions[i];
            var type = /** @type {import("./Instruction.js").default} */ (instruction[0]);
            switch (type) {
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].BEGIN_GEOMETRY:
                    feature = /** @type {import("../../Feature.js").FeatureLike} */ (instruction[1]);
                    currentGeometry = instruction[3];
                    if (!feature.getGeometry()) {
                        i = /** @type {number} */ (instruction[2]);
                    }
                    else if (opt_hitExtent !== undefined &&
                        !Object(_extent_js__WEBPACK_IMPORTED_MODULE_4__["intersects"])(opt_hitExtent, currentGeometry.getExtent())) {
                        i = /** @type {number} */ (instruction[2]) + 1;
                    }
                    else {
                        ++i;
                    }
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].BEGIN_PATH:
                    if (pendingFill > batchSize) {
                        this.fill_(context);
                        pendingFill = 0;
                    }
                    if (pendingStroke > batchSize) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    if (!pendingFill && !pendingStroke) {
                        context.beginPath();
                        prevX = NaN;
                        prevY = NaN;
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CIRCLE:
                    d = /** @type {number} */ (instruction[1]);
                    var x1 = pixelCoordinates[d];
                    var y1 = pixelCoordinates[d + 1];
                    var x2 = pixelCoordinates[d + 2];
                    var y2 = pixelCoordinates[d + 3];
                    var dx = x2 - x1;
                    var dy = y2 - y1;
                    var r = Math.sqrt(dx * dx + dy * dy);
                    context.moveTo(x1 + r, y1);
                    context.arc(x1, y1, r, 0, 2 * Math.PI, true);
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CLOSE_PATH:
                    context.closePath();
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].CUSTOM:
                    d = /** @type {number} */ (instruction[1]);
                    dd = instruction[2];
                    var geometry = 
                    /** @type {import("../../geom/SimpleGeometry.js").default} */ (instruction[3]);
                    var renderer = instruction[4];
                    var fn = instruction.length == 6 ? instruction[5] : undefined;
                    state.geometry = geometry;
                    state.feature = feature;
                    if (!(i in coordinateCache)) {
                        coordinateCache[i] = [];
                    }
                    var coords = coordinateCache[i];
                    if (fn) {
                        fn(pixelCoordinates, d, dd, 2, coords);
                    }
                    else {
                        coords[0] = pixelCoordinates[d];
                        coords[1] = pixelCoordinates[d + 1];
                        coords.length = 2;
                    }
                    renderer(coords, state);
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].DRAW_IMAGE:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    image =
                        /** @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement} */ (instruction[3]);
                    // Remaining arguments in DRAW_IMAGE are in alphabetical order
                    anchorX = /** @type {number} */ (instruction[4]);
                    anchorY = /** @type {number} */ (instruction[5]);
                    var height = /** @type {number} */ (instruction[6]);
                    var opacity = /** @type {number} */ (instruction[7]);
                    var originX = /** @type {number} */ (instruction[8]);
                    var originY = /** @type {number} */ (instruction[9]);
                    var rotateWithView = /** @type {boolean} */ (instruction[10]);
                    var rotation = /** @type {number} */ (instruction[11]);
                    var scale = /** @type {import("../../size.js").Size} */ (instruction[12]);
                    var width = /** @type {number} */ (instruction[13]);
                    var declutterImageWithText = 
                    /** @type {import("../canvas.js").DeclutterImageWithText} */ (instruction[14]);
                    if (!image && instruction.length >= 19) {
                        // create label images
                        text = /** @type {string} */ (instruction[18]);
                        textKey = /** @type {string} */ (instruction[19]);
                        strokeKey = /** @type {string} */ (instruction[20]);
                        fillKey = /** @type {string} */ (instruction[21]);
                        var labelWithAnchor = this.drawLabelWithPointPlacement_(text, textKey, strokeKey, fillKey);
                        image = labelWithAnchor.label;
                        instruction[3] = image;
                        var textOffsetX = /** @type {number} */ (instruction[22]);
                        anchorX = (labelWithAnchor.anchorX - textOffsetX) * this.pixelRatio;
                        instruction[4] = anchorX;
                        var textOffsetY = /** @type {number} */ (instruction[23]);
                        anchorY = (labelWithAnchor.anchorY - textOffsetY) * this.pixelRatio;
                        instruction[5] = anchorY;
                        height = image.height;
                        instruction[6] = height;
                        width = image.width;
                        instruction[13] = width;
                    }
                    var geometryWidths = void 0;
                    if (instruction.length > 24) {
                        geometryWidths = /** @type {number} */ (instruction[24]);
                    }
                    var padding = void 0, backgroundFill = void 0, backgroundStroke = void 0;
                    if (instruction.length > 16) {
                        padding = /** @type {Array<number>} */ (instruction[15]);
                        backgroundFill = /** @type {boolean} */ (instruction[16]);
                        backgroundStroke = /** @type {boolean} */ (instruction[17]);
                    }
                    else {
                        padding = _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"];
                        backgroundFill = false;
                        backgroundStroke = false;
                    }
                    if (rotateWithView && viewRotationFromTransform) {
                        // Canvas is expected to be rotated to reverse view rotation.
                        rotation += viewRotation;
                    }
                    else if (!rotateWithView && !viewRotationFromTransform) {
                        // Canvas is not rotated, images need to be rotated back to be north-up.
                        rotation -= viewRotation;
                    }
                    var widthIndex = 0;
                    for (; d < dd; d += 2) {
                        if (geometryWidths &&
                            geometryWidths[widthIndex++] < width / this.pixelRatio) {
                            continue;
                        }
                        var dimensions = this.calculateImageOrLabelDimensions_(image.width, image.height, pixelCoordinates[d], pixelCoordinates[d + 1], width, height, anchorX, anchorY, originX, originY, rotation, scale, snapToPixel, padding, backgroundFill || backgroundStroke, feature);
                        /** @type {ReplayImageOrLabelArgs} */
                        var args = [
                            context,
                            contextScale,
                            image,
                            dimensions,
                            opacity,
                            backgroundFill
                                ? /** @type {Array<*>} */ (lastFillInstruction)
                                : null,
                            backgroundStroke
                                ? /** @type {Array<*>} */ (lastStrokeInstruction)
                                : null,
                        ];
                        var imageArgs = void 0;
                        var imageDeclutterBox = void 0;
                        if (opt_declutterTree && declutterImageWithText) {
                            var index = dd - d;
                            if (!declutterImageWithText[index]) {
                                // We now have the image for an image+text combination.
                                declutterImageWithText[index] = args;
                                // Don't render anything for now, wait for the text.
                                continue;
                            }
                            imageArgs = declutterImageWithText[index];
                            delete declutterImageWithText[index];
                            imageDeclutterBox = getDeclutterBox(imageArgs);
                            if (opt_declutterTree.collides(imageDeclutterBox)) {
                                continue;
                            }
                        }
                        if (opt_declutterTree &&
                            opt_declutterTree.collides(dimensions.declutterBox)) {
                            continue;
                        }
                        if (imageArgs) {
                            // We now have image and text for an image+text combination.
                            if (opt_declutterTree) {
                                opt_declutterTree.insert(imageDeclutterBox);
                            }
                            // Render the image before we render the text.
                            this.replayImageOrLabel_.apply(this, imageArgs);
                        }
                        if (opt_declutterTree) {
                            opt_declutterTree.insert(dimensions.declutterBox);
                        }
                        this.replayImageOrLabel_.apply(this, args);
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].DRAW_CHARS:
                    var begin = /** @type {number} */ (instruction[1]);
                    var end = /** @type {number} */ (instruction[2]);
                    var baseline = /** @type {number} */ (instruction[3]);
                    var overflow = /** @type {number} */ (instruction[4]);
                    fillKey = /** @type {string} */ (instruction[5]);
                    var maxAngle = /** @type {number} */ (instruction[6]);
                    var measurePixelRatio = /** @type {number} */ (instruction[7]);
                    var offsetY = /** @type {number} */ (instruction[8]);
                    strokeKey = /** @type {string} */ (instruction[9]);
                    var strokeWidth = /** @type {number} */ (instruction[10]);
                    text = /** @type {string} */ (instruction[11]);
                    textKey = /** @type {string} */ (instruction[12]);
                    var pixelRatioScale = [
                        /** @type {number} */ (instruction[13]),
                        /** @type {number} */ (instruction[13]),
                    ];
                    var textState = this.textStates[textKey];
                    var font = textState.font;
                    var textScale = [
                        textState.scale[0] * measurePixelRatio,
                        textState.scale[1] * measurePixelRatio,
                    ];
                    var cachedWidths = void 0;
                    if (font in this.widths_) {
                        cachedWidths = this.widths_[font];
                    }
                    else {
                        cachedWidths = {};
                        this.widths_[font] = cachedWidths;
                    }
                    var pathLength = Object(_geom_flat_length_js__WEBPACK_IMPORTED_MODULE_8__["lineStringLength"])(pixelCoordinates, begin, end, 2);
                    var textLength = Math.abs(textScale[0]) *
                        Object(_canvas_js__WEBPACK_IMPORTED_MODULE_5__["measureAndCacheTextWidth"])(font, text, cachedWidths);
                    if (overflow || textLength <= pathLength) {
                        var textAlign = this.textStates[textKey].textAlign;
                        var startM = (pathLength - textLength) * _TextBuilder_js__WEBPACK_IMPORTED_MODULE_1__["TEXT_ALIGN"][textAlign];
                        var parts = Object(_geom_flat_textpath_js__WEBPACK_IMPORTED_MODULE_6__["drawTextOnPath"])(pixelCoordinates, begin, end, 2, text, startM, maxAngle, Math.abs(textScale[0]), _canvas_js__WEBPACK_IMPORTED_MODULE_5__["measureAndCacheTextWidth"], font, cachedWidths, viewRotationFromTransform ? 0 : this.viewRotation_);
                        drawChars: if (parts) {
                            /** @type {Array<ReplayImageOrLabelArgs>} */
                            var replayImageOrLabelArgs = [];
                            var c = void 0, cc = void 0, chars = void 0, label = void 0, part = void 0;
                            if (strokeKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = this.createLabel(chars, textKey, '', strokeKey);
                                    anchorX =
                                        /** @type {number} */ (part[2]) +
                                            (textScale[0] < 0 ? -strokeWidth : strokeWidth);
                                    anchorY =
                                        baseline * label.height +
                                            ((0.5 - baseline) * 2 * strokeWidth * textScale[1]) /
                                                textScale[0] -
                                            offsetY;
                                    var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"], false, feature);
                                    if (opt_declutterTree &&
                                        opt_declutterTree.collides(dimensions.declutterBox)) {
                                        break drawChars;
                                    }
                                    replayImageOrLabelArgs.push([
                                        context,
                                        contextScale,
                                        label,
                                        dimensions,
                                        1,
                                        null,
                                        null,
                                    ]);
                                }
                            }
                            if (fillKey) {
                                for (c = 0, cc = parts.length; c < cc; ++c) {
                                    part = parts[c]; // x, y, anchorX, rotation, chunk
                                    chars = /** @type {string} */ (part[4]);
                                    label = this.createLabel(chars, textKey, fillKey, '');
                                    anchorX = /** @type {number} */ (part[2]);
                                    anchorY = baseline * label.height - offsetY;
                                    var dimensions = this.calculateImageOrLabelDimensions_(label.width, label.height, part[0], part[1], label.width, label.height, anchorX, anchorY, 0, 0, part[3], pixelRatioScale, false, _canvas_js__WEBPACK_IMPORTED_MODULE_5__["defaultPadding"], false, feature);
                                    if (opt_declutterTree &&
                                        opt_declutterTree.collides(dimensions.declutterBox)) {
                                        break drawChars;
                                    }
                                    replayImageOrLabelArgs.push([
                                        context,
                                        contextScale,
                                        label,
                                        dimensions,
                                        1,
                                        null,
                                        null,
                                    ]);
                                }
                            }
                            if (opt_declutterTree) {
                                opt_declutterTree.load(replayImageOrLabelArgs.map(getDeclutterBox));
                            }
                            for (var i_1 = 0, ii_1 = replayImageOrLabelArgs.length; i_1 < ii_1; ++i_1) {
                                this.replayImageOrLabel_.apply(this, replayImageOrLabelArgs[i_1]);
                            }
                        }
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].END_GEOMETRY:
                    if (opt_featureCallback !== undefined) {
                        feature = /** @type {import("../../Feature.js").FeatureLike} */ (instruction[1]);
                        var result = opt_featureCallback(feature, currentGeometry);
                        if (result) {
                            return result;
                        }
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].FILL:
                    if (batchSize) {
                        pendingFill++;
                    }
                    else {
                        this.fill_(context);
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].MOVE_TO_LINE_TO:
                    d = /** @type {number} */ (instruction[1]);
                    dd = /** @type {number} */ (instruction[2]);
                    x = pixelCoordinates[d];
                    y = pixelCoordinates[d + 1];
                    roundX = (x + 0.5) | 0;
                    roundY = (y + 0.5) | 0;
                    if (roundX !== prevX || roundY !== prevY) {
                        context.moveTo(x, y);
                        prevX = roundX;
                        prevY = roundY;
                    }
                    for (d += 2; d < dd; d += 2) {
                        x = pixelCoordinates[d];
                        y = pixelCoordinates[d + 1];
                        roundX = (x + 0.5) | 0;
                        roundY = (y + 0.5) | 0;
                        if (d == dd - 2 || roundX !== prevX || roundY !== prevY) {
                            context.lineTo(x, y);
                            prevX = roundX;
                            prevY = roundY;
                        }
                    }
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].SET_FILL_STYLE:
                    lastFillInstruction = instruction;
                    this.alignFill_ = instruction[2];
                    if (pendingFill) {
                        this.fill_(context);
                        pendingFill = 0;
                        if (pendingStroke) {
                            context.stroke();
                            pendingStroke = 0;
                        }
                    }
                    context.fillStyle =
                        /** @type {import("../../colorlike.js").ColorLike} */ (instruction[1]);
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].SET_STROKE_STYLE:
                    lastStrokeInstruction = instruction;
                    if (pendingStroke) {
                        context.stroke();
                        pendingStroke = 0;
                    }
                    this.setStrokeStyle_(context, /** @type {Array<*>} */ (instruction));
                    ++i;
                    break;
                case _Instruction_js__WEBPACK_IMPORTED_MODULE_0__["default"].STROKE:
                    if (batchSize) {
                        pendingStroke++;
                    }
                    else {
                        context.stroke();
                    }
                    ++i;
                    break;
                default:
                    ++i; // consume the instruction anyway, to avoid an infinite loop
                    break;
            }
        }
        if (pendingFill) {
            this.fill_(context);
        }
        if (pendingStroke) {
            context.stroke();
        }
        return undefined;
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} contextScale Scale of the context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {boolean} snapToPixel Snap point symbols and text to integer pixels.
     * @param {import("rbush").default} [opt_declutterTree] Declutter tree.
     */
    Executor.prototype.execute = function (context, contextScale, transform, viewRotation, snapToPixel, opt_declutterTree) {
        this.viewRotation_ = viewRotation;
        this.execute_(context, contextScale, transform, this.instructions, snapToPixel, undefined, undefined, opt_declutterTree);
    };
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {FeatureCallback<T>} [opt_featureCallback] Feature callback.
     * @param {import("../../extent.js").Extent} [opt_hitExtent] Only check
     *     features that intersect this extent.
     * @return {T|undefined} Callback result.
     * @template T
     */
    Executor.prototype.executeHitDetection = function (context, transform, viewRotation, opt_featureCallback, opt_hitExtent) {
        this.viewRotation_ = viewRotation;
        return this.execute_(context, 1, transform, this.hitDetectionInstructions, true, opt_featureCallback, opt_hitExtent);
    };
    return Executor;
}());
/* harmony default export */ __webpack_exports__["default"] = (Executor);
//# sourceMappingURL=Executor.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "drawTextOnPath", function() { return drawTextOnPath; });
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(102);
/**
 * @module ol/geom/flat/textpath
 */


/**
 * @param {Array<number>} flatCoordinates Path to put text on.
 * @param {number} offset Start offset of the `flatCoordinates`.
 * @param {number} end End offset of the `flatCoordinates`.
 * @param {number} stride Stride.
 * @param {string} text Text to place on the path.
 * @param {number} startM m along the path where the text starts.
 * @param {number} maxAngle Max angle between adjacent chars in radians.
 * @param {number} scale The product of the text scale and the device pixel ratio.
 * @param {function(string, string, Object<string, number>):number} measureAndCacheTextWidth Measure and cache text width.
 * @param {string} font The font.
 * @param {Object<string, number>} cache A cache of measured widths.
 * @param {number} rotation Rotation to apply to the flatCoordinates to determine whether text needs to be reversed.
 * @return {Array<Array<*>>} The result array (or null if `maxAngle` was
 * exceeded). Entries of the array are x, y, anchorX, angle, chunk.
 */
function drawTextOnPath(flatCoordinates, offset, end, stride, text, startM, maxAngle, scale, measureAndCacheTextWidth, font, cache, rotation) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    var x1 = 0;
    var y1 = 0;
    var segmentLength = 0;
    var segmentM = 0;
    function advance() {
        x1 = x2;
        y1 = y2;
        offset += stride;
        x2 = flatCoordinates[offset];
        y2 = flatCoordinates[offset + 1];
        segmentM += segmentLength;
        segmentLength = Math.sqrt((x2 - x1) * (x2 - x1) + (y2 - y1) * (y2 - y1));
    }
    do {
        advance();
    } while (offset < end - stride && segmentM + segmentLength < startM);
    var interpolate = (startM - segmentM) / segmentLength;
    var beginX = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(x1, x2, interpolate);
    var beginY = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(y1, y2, interpolate);
    var startOffset = offset - stride;
    var startLength = segmentM;
    var endM = startM + scale * measureAndCacheTextWidth(font, text, cache);
    while (offset < end - stride && segmentM + segmentLength < endM) {
        advance();
    }
    interpolate = (endM - segmentM) / segmentLength;
    var endX = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(x1, x2, interpolate);
    var endY = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(y1, y2, interpolate);
    // Keep text upright
    var reverse;
    if (rotation) {
        var flat = [beginX, beginY, endX, endY];
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_1__["rotate"])(flat, 0, 4, 2, rotation, flat, flat);
        reverse = flat[0] > flat[2];
    }
    else {
        reverse = beginX > endX;
    }
    var PI = Math.PI;
    var result = [];
    var singleSegment = startOffset + stride === offset;
    offset = startOffset;
    segmentLength = 0;
    segmentM = startLength;
    x2 = flatCoordinates[offset];
    y2 = flatCoordinates[offset + 1];
    // All on the same segment
    if (singleSegment) {
        advance();
        var previousAngle_1 = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) {
            previousAngle_1 += previousAngle_1 > 0 ? -PI : PI;
        }
        var x = (endX + beginX) / 2;
        var y = (endY + beginY) / 2;
        result[0] = [x, y, (endM - startM) / 2, previousAngle_1, text];
        return result;
    }
    var previousAngle;
    for (var i = 0, ii = text.length; i < ii;) {
        advance();
        var angle = Math.atan2(y2 - y1, x2 - x1);
        if (reverse) {
            angle += angle > 0 ? -PI : PI;
        }
        if (previousAngle !== undefined) {
            var delta = angle - previousAngle;
            delta += delta > PI ? -2 * PI : delta < -PI ? 2 * PI : 0;
            if (Math.abs(delta) > maxAngle) {
                return null;
            }
        }
        previousAngle = angle;
        var iStart = i;
        var charLength = 0;
        for (; i < ii; ++i) {
            var index = reverse ? ii - i - 1 : i;
            var len = scale * measureAndCacheTextWidth(font, text[index], cache);
            if (offset + stride < end &&
                segmentM + segmentLength < startM + charLength + len / 2) {
                break;
            }
            charLength += len;
        }
        if (i === iStart) {
            continue;
        }
        var chars = reverse
            ? text.substring(ii - iStart, ii - i)
            : text.substring(iStart, i);
        interpolate = (startM + charLength / 2 - segmentM) / segmentLength;
        var x = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(x1, x2, interpolate);
        var y = Object(_math_js__WEBPACK_IMPORTED_MODULE_0__["lerp"])(y1, y2, interpolate);
        result.push([x, y, charLength / 2, angle, chars]);
        startM += charLength;
    }
    return result;
}
//# sourceMappingURL=textpath.js.map

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HIT_DETECT_RESOLUTION", function() { return HIT_DETECT_RESOLUTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createHitDetectionImageData", function() { return createHitDetectionImageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hitDetect", function() { return hitDetect; });
/* harmony import */ var _Immediate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(305);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58);
/* harmony import */ var _style_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52);
/**
 * @module ol/render/canvas/hitdetect
 */








var HIT_DETECT_RESOLUTION = 0.5;
/**
 * @param {import("../../size.js").Size} size Canvas size in css pixels.
 * @param {Array<import("../../transform.js").Transform>} transforms Transforms
 * for rendering features to all worlds of the viewport, from coordinates to css
 * pixels.
 * @param {Array<import("../../Feature.js").FeatureLike>} features
 * Features to consider for hit detection.
 * @param {import("../../style/Style.js").StyleFunction|undefined} styleFunction
 * Layer style function.
 * @param {import("../../extent.js").Extent} extent Extent.
 * @param {number} resolution Resolution.
 * @param {number} rotation Rotation.
 * @return {ImageData} Hit detection image data.
 */
function createHitDetectionImageData(size, transforms, features, styleFunction, extent, resolution, rotation) {
    var width = size[0] * HIT_DETECT_RESOLUTION;
    var height = size[1] * HIT_DETECT_RESOLUTION;
    var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["createCanvasContext2D"])(width, height);
    context.imageSmoothingEnabled = false;
    var canvas = context.canvas;
    var renderer = new _Immediate_js__WEBPACK_IMPORTED_MODULE_0__["default"](context, HIT_DETECT_RESOLUTION, extent, null, rotation);
    var featureCount = features.length;
    // Stretch hit detection index to use the whole available color range
    var indexFactor = Math.floor((256 * 256 * 256 - 1) / featureCount);
    var featuresByZIndex = {};
    for (var i = 1; i <= featureCount; ++i) {
        var feature = features[i - 1];
        var featureStyleFunction = feature.getStyleFunction() || styleFunction;
        if (!styleFunction) {
            continue;
        }
        var styles = featureStyleFunction(feature, resolution);
        if (!styles) {
            continue;
        }
        if (!Array.isArray(styles)) {
            styles = [styles];
        }
        var index = i * indexFactor;
        var color = '#' + ('000000' + index.toString(16)).slice(-6);
        for (var j = 0, jj = styles.length; j < jj; ++j) {
            var originalStyle = styles[j];
            var geometry = originalStyle.getGeometryFunction()(feature);
            if (!geometry || !Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(extent, geometry.getExtent())) {
                continue;
            }
            var style = originalStyle.clone();
            var fill = style.getFill();
            if (fill) {
                fill.setColor(color);
            }
            var stroke = style.getStroke();
            if (stroke) {
                stroke.setColor(color);
                stroke.setLineDash(null);
            }
            style.setText(undefined);
            var image = originalStyle.getImage();
            if (image && image.getOpacity() !== 0) {
                var imgSize = image.getImageSize();
                if (!imgSize) {
                    continue;
                }
                var imgContext = Object(_dom_js__WEBPACK_IMPORTED_MODULE_5__["createCanvasContext2D"])(imgSize[0], imgSize[1], undefined, { alpha: false });
                var img = imgContext.canvas;
                imgContext.fillStyle = color;
                imgContext.fillRect(0, 0, img.width, img.height);
                style.setImage(new _style_js__WEBPACK_IMPORTED_MODULE_3__["Icon"]({
                    img: img,
                    imgSize: imgSize,
                    anchor: image.getAnchor(),
                    anchorXUnits: _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_2__["default"].PIXELS,
                    anchorYUnits: _style_IconAnchorUnits_js__WEBPACK_IMPORTED_MODULE_2__["default"].PIXELS,
                    offset: image.getOrigin(),
                    opacity: 1,
                    size: image.getSize(),
                    scale: image.getScale(),
                    rotation: image.getRotation(),
                    rotateWithView: image.getRotateWithView(),
                }));
            }
            var zIndex = style.getZIndex() || 0;
            var byGeometryType = featuresByZIndex[zIndex];
            if (!byGeometryType) {
                byGeometryType = {};
                featuresByZIndex[zIndex] = byGeometryType;
                byGeometryType[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POLYGON] = [];
                byGeometryType[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CIRCLE] = [];
                byGeometryType[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].LINE_STRING] = [];
                byGeometryType[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINT] = [];
            }
            byGeometryType[geometry.getType().replace('Multi', '')].push(geometry, style);
        }
    }
    var zIndexKeys = Object.keys(featuresByZIndex)
        .map(Number)
        .sort(_array_js__WEBPACK_IMPORTED_MODULE_7__["numberSafeCompareFunction"]);
    for (var i = 0, ii = zIndexKeys.length; i < ii; ++i) {
        var byGeometryType = featuresByZIndex[zIndexKeys[i]];
        for (var type in byGeometryType) {
            var geomAndStyle = byGeometryType[type];
            for (var j = 0, jj = geomAndStyle.length; j < jj; j += 2) {
                renderer.setStyle(geomAndStyle[j + 1]);
                for (var k = 0, kk = transforms.length; k < kk; ++k) {
                    renderer.setTransform(transforms[k]);
                    renderer.drawGeometry(geomAndStyle[j]);
                }
            }
        }
    }
    return context.getImageData(0, 0, canvas.width, canvas.height);
}
/**
 * @param {import("../../pixel").Pixel} pixel Pixel coordinate on the hit
 * detection canvas in css pixels.
 * @param {Array<import("../../Feature").FeatureLike>} features Features. Has to
 * match the `features` array that was passed to `createHitDetectionImageData()`.
 * @param {ImageData} imageData Hit detection image data generated by
 * `createHitDetectionImageData()`.
 * @return {Array<import("../../Feature").FeatureLike>} features Features.
 */
function hitDetect(pixel, features, imageData) {
    var resultFeatures = [];
    if (imageData) {
        var x = Math.floor(Math.round(pixel[0]) * HIT_DETECT_RESOLUTION);
        var y = Math.floor(Math.round(pixel[1]) * HIT_DETECT_RESOLUTION);
        // The pixel coordinate is clamped down to the hit-detect canvas' size to account
        // for browsers returning coordinates slightly larger than the actual canvas size
        // due to a non-integer pixel ratio.
        var index = (Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["clamp"])(x, 0, imageData.width - 1) +
            Object(_math_js__WEBPACK_IMPORTED_MODULE_4__["clamp"])(y, 0, imageData.height - 1) * imageData.width) *
            4;
        var r = imageData.data[index];
        var g = imageData.data[index + 1];
        var b = imageData.data[index + 2];
        var i = b + 256 * (g + 256 * r);
        var indexFactor = Math.floor((256 * 256 * 256 - 1) / features.length);
        if (i && i % indexFactor === 0) {
            resultFeatures.push(features[i / indexFactor - 1]);
        }
    }
    return resultFeatures;
}
//# sourceMappingURL=hitdetect.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23);
/* harmony import */ var _VectorContext_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(294);
/* harmony import */ var _colorlike_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(101);
/* harmony import */ var _canvas_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16);
/* harmony import */ var _geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(102);
/* harmony import */ var _geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99);
/**
 * @module ol/render/canvas/Immediate
 */
// FIXME test, especially polygons with holes and multipolygons
// FIXME need to handle large thick features (where pixel size matters)
// FIXME add offset and end to ol/geom/flat/transform~transform2D?
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









/**
 * @classdesc
 * A concrete subclass of {@link module:ol/render/VectorContext VectorContext} that implements
 * direct rendering of features and geometries to an HTML5 Canvas context.
 * Instances of this class are created internally by the library and
 * provided to application code as vectorContext member of the
 * {@link module:ol/render/Event~RenderEvent RenderEvent} object associated with postcompose, precompose and
 * render events emitted by layers and maps.
 */
var CanvasImmediateRenderer = /** @class */ (function (_super) {
    __extends(CanvasImmediateRenderer, _super);
    /**
     * @param {CanvasRenderingContext2D} context Context.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../extent.js").Extent} extent Extent.
     * @param {import("../../transform.js").Transform} transform Transform.
     * @param {number} viewRotation View rotation.
     * @param {number} [opt_squaredTolerance] Optional squared tolerance for simplification.
     * @param {import("../../proj.js").TransformFunction} [opt_userTransform] Transform from user to view projection.
     */
    function CanvasImmediateRenderer(context, pixelRatio, extent, transform, viewRotation, opt_squaredTolerance, opt_userTransform) {
        var _this = _super.call(this) || this;
        /**
         * @private
         * @type {CanvasRenderingContext2D}
         */
        _this.context_ = context;
        /**
         * @private
         * @type {number}
         */
        _this.pixelRatio_ = pixelRatio;
        /**
         * @private
         * @type {import("../../extent.js").Extent}
         */
        _this.extent_ = extent;
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        _this.transform_ = transform;
        /**
         * @private
         * @type {number}
         */
        _this.viewRotation_ = viewRotation;
        /**
         * @private
         * @type {number}
         */
        _this.squaredTolerance_ = opt_squaredTolerance;
        /**
         * @private
         * @type {import("../../proj.js").TransformFunction}
         */
        _this.userTransform_ = opt_userTransform;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */
        _this.contextFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */
        _this.contextStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */
        _this.contextTextState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */
        _this.fillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */
        _this.strokeState_ = null;
        /**
         * @private
         * @type {HTMLCanvasElement|HTMLVideoElement|HTMLImageElement}
         */
        _this.image_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.imageAnchorX_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.imageAnchorY_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.imageHeight_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.imageOpacity_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.imageOriginX_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.imageOriginY_ = 0;
        /**
         * @private
         * @type {boolean}
         */
        _this.imageRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */
        _this.imageRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */
        _this.imageScale_ = [0, 0];
        /**
         * @private
         * @type {number}
         */
        _this.imageWidth_ = 0;
        /**
         * @private
         * @type {string}
         */
        _this.text_ = '';
        /**
         * @private
         * @type {number}
         */
        _this.textOffsetX_ = 0;
        /**
         * @private
         * @type {number}
         */
        _this.textOffsetY_ = 0;
        /**
         * @private
         * @type {boolean}
         */
        _this.textRotateWithView_ = false;
        /**
         * @private
         * @type {number}
         */
        _this.textRotation_ = 0;
        /**
         * @private
         * @type {import("../../size.js").Size}
         */
        _this.textScale_ = [0, 0];
        /**
         * @private
         * @type {?import("../canvas.js").FillState}
         */
        _this.textFillState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").StrokeState}
         */
        _this.textStrokeState_ = null;
        /**
         * @private
         * @type {?import("../canvas.js").TextState}
         */
        _this.textState_ = null;
        /**
         * @private
         * @type {Array<number>}
         */
        _this.pixelCoordinates_ = [];
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        _this.tmpLocalTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["create"])();
        return _this;
    }
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */
    CanvasImmediateRenderer.prototype.drawImages_ = function (flatCoordinates, offset, end, stride) {
        if (!this.image_) {
            return;
        }
        var pixelCoordinates = Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__["transform2D"])(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var localTransform = this.tmpLocalTransform_;
        var alpha = context.globalAlpha;
        if (this.imageOpacity_ != 1) {
            context.globalAlpha = alpha * this.imageOpacity_;
        }
        var rotation = this.imageRotation_;
        if (this.imageRotateWithView_) {
            rotation += this.viewRotation_;
        }
        for (var i = 0, ii = pixelCoordinates.length; i < ii; i += 2) {
            var x = pixelCoordinates[i] - this.imageAnchorX_;
            var y = pixelCoordinates[i + 1] - this.imageAnchorY_;
            if (rotation !== 0 ||
                this.imageScale_[0] != 1 ||
                this.imageScale_[1] != 1) {
                var centerX = x + this.imageAnchorX_;
                var centerY = y + this.imageAnchorY_;
                Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(localTransform, centerX, centerY, 1, 1, rotation, -centerX, -centerY);
                context.setTransform.apply(context, localTransform);
                context.translate(centerX, centerY);
                context.scale(this.imageScale_[0], this.imageScale_[1]);
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, -this.imageAnchorX_, -this.imageAnchorY_, this.imageWidth_, this.imageHeight_);
                context.setTransform(1, 0, 0, 1, 0, 0);
            }
            else {
                context.drawImage(this.image_, this.imageOriginX_, this.imageOriginY_, this.imageWidth_, this.imageHeight_, x, y, this.imageWidth_, this.imageHeight_);
            }
        }
        if (this.imageOpacity_ != 1) {
            context.globalAlpha = alpha;
        }
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @private
     */
    CanvasImmediateRenderer.prototype.drawText_ = function (flatCoordinates, offset, end, stride) {
        if (!this.textState_ || this.text_ === '') {
            return;
        }
        if (this.textFillState_) {
            this.setContextFillState_(this.textFillState_);
        }
        if (this.textStrokeState_) {
            this.setContextStrokeState_(this.textStrokeState_);
        }
        this.setContextTextState_(this.textState_);
        var pixelCoordinates = Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__["transform2D"])(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        var context = this.context_;
        var rotation = this.textRotation_;
        if (this.textRotateWithView_) {
            rotation += this.viewRotation_;
        }
        for (; offset < end; offset += stride) {
            var x = pixelCoordinates[offset] + this.textOffsetX_;
            var y = pixelCoordinates[offset + 1] + this.textOffsetY_;
            if (rotation !== 0 ||
                this.textScale_[0] != 1 ||
                this.textScale_[1] != 1) {
                var localTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_3__["compose"])(this.tmpLocalTransform_, x, y, 1, 1, rotation, -x, -y);
                context.setTransform.apply(context, localTransform);
                context.translate(x, y);
                context.scale(this.textScale_[0], this.textScale_[1]);
                if (this.textStrokeState_) {
                    context.strokeText(this.text_, 0, 0);
                }
                if (this.textFillState_) {
                    context.fillText(this.text_, 0, 0);
                }
                context.setTransform(1, 0, 0, 1, 0, 0);
            }
            else {
                if (this.textStrokeState_) {
                    context.strokeText(this.text_, x, y);
                }
                if (this.textFillState_) {
                    context.fillText(this.text_, x, y);
                }
            }
        }
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {number} end End.
     * @param {number} stride Stride.
     * @param {boolean} close Close.
     * @private
     * @return {number} end End.
     */
    CanvasImmediateRenderer.prototype.moveToLineTo_ = function (flatCoordinates, offset, end, stride, close) {
        var context = this.context_;
        var pixelCoordinates = Object(_geom_flat_transform_js__WEBPACK_IMPORTED_MODULE_7__["transform2D"])(flatCoordinates, offset, end, stride, this.transform_, this.pixelCoordinates_);
        context.moveTo(pixelCoordinates[0], pixelCoordinates[1]);
        var length = pixelCoordinates.length;
        if (close) {
            length -= 2;
        }
        for (var i = 2; i < length; i += 2) {
            context.lineTo(pixelCoordinates[i], pixelCoordinates[i + 1]);
        }
        if (close) {
            context.closePath();
        }
        return end;
    };
    /**
     * @param {Array<number>} flatCoordinates Flat coordinates.
     * @param {number} offset Offset.
     * @param {Array<number>} ends Ends.
     * @param {number} stride Stride.
     * @private
     * @return {number} End.
     */
    CanvasImmediateRenderer.prototype.drawRings_ = function (flatCoordinates, offset, ends, stride) {
        for (var i = 0, ii = ends.length; i < ii; ++i) {
            offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, true);
        }
        return offset;
    };
    /**
     * Render a circle geometry into the canvas.  Rendering is immediate and uses
     * the current fill and stroke styles.
     *
     * @param {import("../../geom/Circle.js").default} geometry Circle geometry.
     * @api
     */
    CanvasImmediateRenderer.prototype.drawCircle = function (geometry) {
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometry.getExtent())) {
            return;
        }
        if (this.fillState_ || this.strokeState_) {
            if (this.fillState_) {
                this.setContextFillState_(this.fillState_);
            }
            if (this.strokeState_) {
                this.setContextStrokeState_(this.strokeState_);
            }
            var pixelCoordinates = Object(_geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_8__["transformGeom2D"])(geometry, this.transform_, this.pixelCoordinates_);
            var dx = pixelCoordinates[2] - pixelCoordinates[0];
            var dy = pixelCoordinates[3] - pixelCoordinates[1];
            var radius = Math.sqrt(dx * dx + dy * dy);
            var context = this.context_;
            context.beginPath();
            context.arc(pixelCoordinates[0], pixelCoordinates[1], radius, 0, 2 * Math.PI);
            if (this.fillState_) {
                context.fill();
            }
            if (this.strokeState_) {
                context.stroke();
            }
        }
        if (this.text_ !== '') {
            this.drawText_(geometry.getCenter(), 0, 2, 2);
        }
    };
    /**
     * Set the rendering style.  Note that since this is an immediate rendering API,
     * any `zIndex` on the provided style will be ignored.
     *
     * @param {import("../../style/Style.js").default} style The rendering style.
     * @api
     */
    CanvasImmediateRenderer.prototype.setStyle = function (style) {
        this.setFillStrokeStyle(style.getFill(), style.getStroke());
        this.setImageStyle(style.getImage());
        this.setTextStyle(style.getText());
    };
    /**
     * @param {import("../../transform.js").Transform} transform Transform.
     */
    CanvasImmediateRenderer.prototype.setTransform = function (transform) {
        this.transform_ = transform;
    };
    /**
     * Render a geometry into the canvas.  Call
     * {@link module:ol/render/canvas/Immediate~CanvasImmediateRenderer#setStyle renderer.setStyle()} first to set the rendering style.
     *
     * @param {import("../../geom/Geometry.js").default|import("../Feature.js").default} geometry The geometry to render.
     * @api
     */
    CanvasImmediateRenderer.prototype.drawGeometry = function (geometry) {
        var type = geometry.getType();
        switch (type) {
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POINT:
                this.drawPoint(
                /** @type {import("../../geom/Point.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING:
                this.drawLineString(
                /** @type {import("../../geom/LineString.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON:
                this.drawPolygon(
                /** @type {import("../../geom/Polygon.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POINT:
                this.drawMultiPoint(
                /** @type {import("../../geom/MultiPoint.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_LINE_STRING:
                this.drawMultiLineString(
                /** @type {import("../../geom/MultiLineString.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].MULTI_POLYGON:
                this.drawMultiPolygon(
                /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].GEOMETRY_COLLECTION:
                this.drawGeometryCollection(
                /** @type {import("../../geom/GeometryCollection.js").default} */ (geometry));
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CIRCLE:
                this.drawCircle(
                /** @type {import("../../geom/Circle.js").default} */ (geometry));
                break;
            default:
        }
    };
    /**
     * Render a feature into the canvas.  Note that any `zIndex` on the provided
     * style will be ignored - features are rendered immediately in the order that
     * this method is called.  If you need `zIndex` support, you should be using an
     * {@link module:ol/layer/Vector~VectorLayer VectorLayer} instead.
     *
     * @param {import("../../Feature.js").default} feature Feature.
     * @param {import("../../style/Style.js").default} style Style.
     * @api
     */
    CanvasImmediateRenderer.prototype.drawFeature = function (feature, style) {
        var geometry = style.getGeometryFunction()(feature);
        if (!geometry || !Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometry.getExtent())) {
            return;
        }
        this.setStyle(style);
        this.drawGeometry(geometry);
    };
    /**
     * Render a GeometryCollection to the canvas.  Rendering is immediate and
     * uses the current styles appropriate for each geometry in the collection.
     *
     * @param {import("../../geom/GeometryCollection.js").default} geometry Geometry collection.
     */
    CanvasImmediateRenderer.prototype.drawGeometryCollection = function (geometry) {
        var geometries = geometry.getGeometriesArray();
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            this.drawGeometry(geometries[i]);
        }
    };
    /**
     * Render a Point geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Point.js").default|import("../Feature.js").default} geometry Point geometry.
     */
    CanvasImmediateRenderer.prototype.drawPoint = function (geometry) {
        if (this.squaredTolerance_) {
            geometry = /** @type {import("../../geom/Point.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) {
            this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        }
        if (this.text_ !== '') {
            this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
        }
    };
    /**
     * Render a MultiPoint geometry  into the canvas.  Rendering is immediate and
     * uses the current style.
     *
     * @param {import("../../geom/MultiPoint.js").default|import("../Feature.js").default} geometry MultiPoint geometry.
     */
    CanvasImmediateRenderer.prototype.drawMultiPoint = function (geometry) {
        if (this.squaredTolerance_) {
            geometry = /** @type {import("../../geom/MultiPoint.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        var flatCoordinates = geometry.getFlatCoordinates();
        var stride = geometry.getStride();
        if (this.image_) {
            this.drawImages_(flatCoordinates, 0, flatCoordinates.length, stride);
        }
        if (this.text_ !== '') {
            this.drawText_(flatCoordinates, 0, flatCoordinates.length, stride);
        }
    };
    /**
     * Render a LineString into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/LineString.js").default|import("../Feature.js").default} geometry LineString geometry.
     */
    CanvasImmediateRenderer.prototype.drawLineString = function (geometry) {
        if (this.squaredTolerance_) {
            geometry = /** @type {import("../../geom/LineString.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometry.getExtent())) {
            return;
        }
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            context.beginPath();
            this.moveToLineTo_(flatCoordinates, 0, flatCoordinates.length, geometry.getStride(), false);
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoint = geometry.getFlatMidpoint();
            this.drawText_(flatMidpoint, 0, 2, 2);
        }
    };
    /**
     * Render a MultiLineString geometry into the canvas.  Rendering is immediate
     * and uses the current style.
     *
     * @param {import("../../geom/MultiLineString.js").default|import("../Feature.js").default} geometry MultiLineString geometry.
     */
    CanvasImmediateRenderer.prototype.drawMultiLineString = function (geometry) {
        if (this.squaredTolerance_) {
            geometry =
                /** @type {import("../../geom/MultiLineString.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        var geometryExtent = geometry.getExtent();
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometryExtent)) {
            return;
        }
        if (this.strokeState_) {
            this.setContextStrokeState_(this.strokeState_);
            var context = this.context_;
            var flatCoordinates = geometry.getFlatCoordinates();
            var offset = 0;
            var ends = /** @type {Array<number>} */ (geometry.getEnds());
            var stride = geometry.getStride();
            context.beginPath();
            for (var i = 0, ii = ends.length; i < ii; ++i) {
                offset = this.moveToLineTo_(flatCoordinates, offset, ends[i], stride, false);
            }
            context.stroke();
        }
        if (this.text_ !== '') {
            var flatMidpoints = geometry.getFlatMidpoints();
            this.drawText_(flatMidpoints, 0, flatMidpoints.length, 2);
        }
    };
    /**
     * Render a Polygon geometry into the canvas.  Rendering is immediate and uses
     * the current style.
     *
     * @param {import("../../geom/Polygon.js").default|import("../Feature.js").default} geometry Polygon geometry.
     */
    CanvasImmediateRenderer.prototype.drawPolygon = function (geometry) {
        if (this.squaredTolerance_) {
            geometry = /** @type {import("../../geom/Polygon.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometry.getExtent())) {
            return;
        }
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) {
                this.setContextFillState_(this.fillState_);
            }
            if (this.strokeState_) {
                this.setContextStrokeState_(this.strokeState_);
            }
            var context = this.context_;
            context.beginPath();
            this.drawRings_(geometry.getOrientedFlatCoordinates(), 0, 
            /** @type {Array<number>} */ (geometry.getEnds()), geometry.getStride());
            if (this.fillState_) {
                context.fill();
            }
            if (this.strokeState_) {
                context.stroke();
            }
        }
        if (this.text_ !== '') {
            var flatInteriorPoint = geometry.getFlatInteriorPoint();
            this.drawText_(flatInteriorPoint, 0, 2, 2);
        }
    };
    /**
     * Render MultiPolygon geometry into the canvas.  Rendering is immediate and
     * uses the current style.
     * @param {import("../../geom/MultiPolygon.js").default} geometry MultiPolygon geometry.
     */
    CanvasImmediateRenderer.prototype.drawMultiPolygon = function (geometry) {
        if (this.squaredTolerance_) {
            geometry = /** @type {import("../../geom/MultiPolygon.js").default} */ (geometry.simplifyTransformed(this.squaredTolerance_, this.userTransform_));
        }
        if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_6__["intersects"])(this.extent_, geometry.getExtent())) {
            return;
        }
        if (this.strokeState_ || this.fillState_) {
            if (this.fillState_) {
                this.setContextFillState_(this.fillState_);
            }
            if (this.strokeState_) {
                this.setContextStrokeState_(this.strokeState_);
            }
            var context = this.context_;
            var flatCoordinates = geometry.getOrientedFlatCoordinates();
            var offset = 0;
            var endss = geometry.getEndss();
            var stride = geometry.getStride();
            context.beginPath();
            for (var i = 0, ii = endss.length; i < ii; ++i) {
                var ends = endss[i];
                offset = this.drawRings_(flatCoordinates, offset, ends, stride);
            }
            if (this.fillState_) {
                context.fill();
            }
            if (this.strokeState_) {
                context.stroke();
            }
        }
        if (this.text_ !== '') {
            var flatInteriorPoints = geometry.getFlatInteriorPoints();
            this.drawText_(flatInteriorPoints, 0, flatInteriorPoints.length, 2);
        }
    };
    /**
     * @param {import("../canvas.js").FillState} fillState Fill state.
     * @private
     */
    CanvasImmediateRenderer.prototype.setContextFillState_ = function (fillState) {
        var context = this.context_;
        var contextFillState = this.contextFillState_;
        if (!contextFillState) {
            context.fillStyle = fillState.fillStyle;
            this.contextFillState_ = {
                fillStyle: fillState.fillStyle,
            };
        }
        else {
            if (contextFillState.fillStyle != fillState.fillStyle) {
                contextFillState.fillStyle = fillState.fillStyle;
                context.fillStyle = fillState.fillStyle;
            }
        }
    };
    /**
     * @param {import("../canvas.js").StrokeState} strokeState Stroke state.
     * @private
     */
    CanvasImmediateRenderer.prototype.setContextStrokeState_ = function (strokeState) {
        var context = this.context_;
        var contextStrokeState = this.contextStrokeState_;
        if (!contextStrokeState) {
            context.lineCap = strokeState.lineCap;
            if (context.setLineDash) {
                context.setLineDash(strokeState.lineDash);
                context.lineDashOffset = strokeState.lineDashOffset;
            }
            context.lineJoin = strokeState.lineJoin;
            context.lineWidth = strokeState.lineWidth;
            context.miterLimit = strokeState.miterLimit;
            context.strokeStyle = strokeState.strokeStyle;
            this.contextStrokeState_ = {
                lineCap: strokeState.lineCap,
                lineDash: strokeState.lineDash,
                lineDashOffset: strokeState.lineDashOffset,
                lineJoin: strokeState.lineJoin,
                lineWidth: strokeState.lineWidth,
                miterLimit: strokeState.miterLimit,
                strokeStyle: strokeState.strokeStyle,
            };
        }
        else {
            if (contextStrokeState.lineCap != strokeState.lineCap) {
                contextStrokeState.lineCap = strokeState.lineCap;
                context.lineCap = strokeState.lineCap;
            }
            if (context.setLineDash) {
                if (!Object(_array_js__WEBPACK_IMPORTED_MODULE_5__["equals"])(contextStrokeState.lineDash, strokeState.lineDash)) {
                    context.setLineDash((contextStrokeState.lineDash = strokeState.lineDash));
                }
                if (contextStrokeState.lineDashOffset != strokeState.lineDashOffset) {
                    contextStrokeState.lineDashOffset = strokeState.lineDashOffset;
                    context.lineDashOffset = strokeState.lineDashOffset;
                }
            }
            if (contextStrokeState.lineJoin != strokeState.lineJoin) {
                contextStrokeState.lineJoin = strokeState.lineJoin;
                context.lineJoin = strokeState.lineJoin;
            }
            if (contextStrokeState.lineWidth != strokeState.lineWidth) {
                contextStrokeState.lineWidth = strokeState.lineWidth;
                context.lineWidth = strokeState.lineWidth;
            }
            if (contextStrokeState.miterLimit != strokeState.miterLimit) {
                contextStrokeState.miterLimit = strokeState.miterLimit;
                context.miterLimit = strokeState.miterLimit;
            }
            if (contextStrokeState.strokeStyle != strokeState.strokeStyle) {
                contextStrokeState.strokeStyle = strokeState.strokeStyle;
                context.strokeStyle = strokeState.strokeStyle;
            }
        }
    };
    /**
     * @param {import("../canvas.js").TextState} textState Text state.
     * @private
     */
    CanvasImmediateRenderer.prototype.setContextTextState_ = function (textState) {
        var context = this.context_;
        var contextTextState = this.contextTextState_;
        var textAlign = textState.textAlign
            ? textState.textAlign
            : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultTextAlign"];
        if (!contextTextState) {
            context.font = textState.font;
            context.textAlign = /** @type {CanvasTextAlign} */ (textAlign);
            context.textBaseline = /** @type {CanvasTextBaseline} */ (textState.textBaseline);
            this.contextTextState_ = {
                font: textState.font,
                textAlign: textAlign,
                textBaseline: textState.textBaseline,
            };
        }
        else {
            if (contextTextState.font != textState.font) {
                contextTextState.font = textState.font;
                context.font = textState.font;
            }
            if (contextTextState.textAlign != textAlign) {
                contextTextState.textAlign = /** @type {CanvasTextAlign} */ (textAlign);
                context.textAlign = /** @type {CanvasTextAlign} */ (textAlign);
            }
            if (contextTextState.textBaseline != textState.textBaseline) {
                contextTextState.textBaseline = /** @type {CanvasTextBaseline} */ (textState.textBaseline);
                context.textBaseline = /** @type {CanvasTextBaseline} */ (textState.textBaseline);
            }
        }
    };
    /**
     * Set the fill and stroke style for subsequent draw operations.  To clear
     * either fill or stroke styles, pass null for the appropriate parameter.
     *
     * @param {import("../../style/Fill.js").default} fillStyle Fill style.
     * @param {import("../../style/Stroke.js").default} strokeStyle Stroke style.
     */
    CanvasImmediateRenderer.prototype.setFillStrokeStyle = function (fillStyle, strokeStyle) {
        var _this = this;
        if (!fillStyle) {
            this.fillState_ = null;
        }
        else {
            var fillStyleColor = fillStyle.getColor();
            this.fillState_ = {
                fillStyle: Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_2__["asColorLike"])(fillStyleColor ? fillStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultFillStyle"]),
            };
        }
        if (!strokeStyle) {
            this.strokeState_ = null;
        }
        else {
            var strokeStyleColor = strokeStyle.getColor();
            var strokeStyleLineCap = strokeStyle.getLineCap();
            var strokeStyleLineDash = strokeStyle.getLineDash();
            var strokeStyleLineDashOffset = strokeStyle.getLineDashOffset();
            var strokeStyleLineJoin = strokeStyle.getLineJoin();
            var strokeStyleWidth = strokeStyle.getWidth();
            var strokeStyleMiterLimit = strokeStyle.getMiterLimit();
            var lineDash = strokeStyleLineDash
                ? strokeStyleLineDash
                : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineDash"];
            this.strokeState_ = {
                lineCap: strokeStyleLineCap !== undefined
                    ? strokeStyleLineCap
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineCap"],
                lineDash: this.pixelRatio_ === 1
                    ? lineDash
                    : lineDash.map(function (n) { return n * _this.pixelRatio_; }),
                lineDashOffset: (strokeStyleLineDashOffset
                    ? strokeStyleLineDashOffset
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineDashOffset"]) * this.pixelRatio_,
                lineJoin: strokeStyleLineJoin !== undefined
                    ? strokeStyleLineJoin
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineJoin"],
                lineWidth: (strokeStyleWidth !== undefined
                    ? strokeStyleWidth
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineWidth"]) * this.pixelRatio_,
                miterLimit: strokeStyleMiterLimit !== undefined
                    ? strokeStyleMiterLimit
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultMiterLimit"],
                strokeStyle: Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_2__["asColorLike"])(strokeStyleColor ? strokeStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultStrokeStyle"]),
            };
        }
    };
    /**
     * Set the image style for subsequent draw operations.  Pass null to remove
     * the image style.
     *
     * @param {import("../../style/Image.js").default} imageStyle Image style.
     */
    CanvasImmediateRenderer.prototype.setImageStyle = function (imageStyle) {
        var imageSize;
        if (!imageStyle || !(imageSize = imageStyle.getSize())) {
            this.image_ = null;
            return;
        }
        var imageAnchor = imageStyle.getAnchor();
        var imageOrigin = imageStyle.getOrigin();
        this.image_ = imageStyle.getImage(this.pixelRatio_);
        this.imageAnchorX_ = imageAnchor[0] * this.pixelRatio_;
        this.imageAnchorY_ = imageAnchor[1] * this.pixelRatio_;
        this.imageHeight_ = imageSize[1] * this.pixelRatio_;
        this.imageOpacity_ = imageStyle.getOpacity();
        this.imageOriginX_ = imageOrigin[0];
        this.imageOriginY_ = imageOrigin[1];
        this.imageRotateWithView_ = imageStyle.getRotateWithView();
        this.imageRotation_ = imageStyle.getRotation();
        this.imageScale_ = imageStyle.getScaleArray();
        this.imageWidth_ = imageSize[0] * this.pixelRatio_;
    };
    /**
     * Set the text style for subsequent draw operations.  Pass null to
     * remove the text style.
     *
     * @param {import("../../style/Text.js").default} textStyle Text style.
     */
    CanvasImmediateRenderer.prototype.setTextStyle = function (textStyle) {
        if (!textStyle) {
            this.text_ = '';
        }
        else {
            var textFillStyle = textStyle.getFill();
            if (!textFillStyle) {
                this.textFillState_ = null;
            }
            else {
                var textFillStyleColor = textFillStyle.getColor();
                this.textFillState_ = {
                    fillStyle: Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_2__["asColorLike"])(textFillStyleColor ? textFillStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultFillStyle"]),
                };
            }
            var textStrokeStyle = textStyle.getStroke();
            if (!textStrokeStyle) {
                this.textStrokeState_ = null;
            }
            else {
                var textStrokeStyleColor = textStrokeStyle.getColor();
                var textStrokeStyleLineCap = textStrokeStyle.getLineCap();
                var textStrokeStyleLineDash = textStrokeStyle.getLineDash();
                var textStrokeStyleLineDashOffset = textStrokeStyle.getLineDashOffset();
                var textStrokeStyleLineJoin = textStrokeStyle.getLineJoin();
                var textStrokeStyleWidth = textStrokeStyle.getWidth();
                var textStrokeStyleMiterLimit = textStrokeStyle.getMiterLimit();
                this.textStrokeState_ = {
                    lineCap: textStrokeStyleLineCap !== undefined
                        ? textStrokeStyleLineCap
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineCap"],
                    lineDash: textStrokeStyleLineDash
                        ? textStrokeStyleLineDash
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineDash"],
                    lineDashOffset: textStrokeStyleLineDashOffset
                        ? textStrokeStyleLineDashOffset
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineDashOffset"],
                    lineJoin: textStrokeStyleLineJoin !== undefined
                        ? textStrokeStyleLineJoin
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineJoin"],
                    lineWidth: textStrokeStyleWidth !== undefined
                        ? textStrokeStyleWidth
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultLineWidth"],
                    miterLimit: textStrokeStyleMiterLimit !== undefined
                        ? textStrokeStyleMiterLimit
                        : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultMiterLimit"],
                    strokeStyle: Object(_colorlike_js__WEBPACK_IMPORTED_MODULE_2__["asColorLike"])(textStrokeStyleColor ? textStrokeStyleColor : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultStrokeStyle"]),
                };
            }
            var textFont = textStyle.getFont();
            var textOffsetX = textStyle.getOffsetX();
            var textOffsetY = textStyle.getOffsetY();
            var textRotateWithView = textStyle.getRotateWithView();
            var textRotation = textStyle.getRotation();
            var textScale = textStyle.getScaleArray();
            var textText = textStyle.getText();
            var textTextAlign = textStyle.getTextAlign();
            var textTextBaseline = textStyle.getTextBaseline();
            this.textState_ = {
                font: textFont !== undefined ? textFont : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultFont"],
                textAlign: textTextAlign !== undefined ? textTextAlign : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultTextAlign"],
                textBaseline: textTextBaseline !== undefined
                    ? textTextBaseline
                    : _canvas_js__WEBPACK_IMPORTED_MODULE_4__["defaultTextBaseline"],
            };
            this.text_ = textText !== undefined ? textText : '';
            this.textOffsetX_ =
                textOffsetX !== undefined ? this.pixelRatio_ * textOffsetX : 0;
            this.textOffsetY_ =
                textOffsetY !== undefined ? this.pixelRatio_ * textOffsetY : 0;
            this.textRotateWithView_ =
                textRotateWithView !== undefined ? textRotateWithView : false;
            this.textRotation_ = textRotation !== undefined ? textRotation : 0;
            this.textScale_ = [
                this.pixelRatio_ * textScale[0],
                this.pixelRatio_ * textScale[1],
            ];
        }
    };
    return CanvasImmediateRenderer;
}(_VectorContext_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasImmediateRenderer);
//# sourceMappingURL=Immediate.js.map

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultOrder", function() { return defaultOrder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSquaredTolerance", function() { return getSquaredTolerance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTolerance", function() { return getTolerance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderFeature", function() { return renderFeature; });
/* harmony import */ var _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(301);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21);
/**
 * @module ol/renderer/vector
 */




/**
 * Feature callback. The callback will be called with three arguments. The first
 * argument is one {@link module:ol/Feature feature} or {@link module:ol/render/Feature render feature}
 * at the pixel, the second is the {@link module:ol/layer/Layer layer} of the feature and will be null for
 * unmanaged layers. The third is the {@link module:ol/geom/SimpleGeometry} of the feature. For features
 * with a GeometryCollection geometry, it will be the first detected geometry from the collection.
 * @template T
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default, import("../geom/SimpleGeometry.js").default): T} FeatureCallback
 */
/**
 * Tolerance for geometry simplification in device pixels.
 * @type {number}
 */
var SIMPLIFY_TOLERANCE = 0.5;
/**
 * @const
 * @type {Object<import("../geom/GeometryType.js").default,
 *                function(import("../render/canvas/BuilderGroup.js").default, import("../geom/Geometry.js").default,
 *                         import("../style/Style.js").default, Object): void>}
 */
var GEOMETRY_RENDERERS = {
    'Point': renderPointGeometry,
    'LineString': renderLineStringGeometry,
    'Polygon': renderPolygonGeometry,
    'MultiPoint': renderMultiPointGeometry,
    'MultiLineString': renderMultiLineStringGeometry,
    'MultiPolygon': renderMultiPolygonGeometry,
    'GeometryCollection': renderGeometryCollectionGeometry,
    'Circle': renderCircleGeometry,
};
/**
 * @param {import("../Feature.js").FeatureLike} feature1 Feature 1.
 * @param {import("../Feature.js").FeatureLike} feature2 Feature 2.
 * @return {number} Order.
 */
function defaultOrder(feature1, feature2) {
    return parseInt(Object(_util_js__WEBPACK_IMPORTED_MODULE_3__["getUid"])(feature1), 10) - parseInt(Object(_util_js__WEBPACK_IMPORTED_MODULE_3__["getUid"])(feature2), 10);
}
/**
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio Pixel ratio.
 * @return {number} Squared pixel tolerance.
 */
function getSquaredTolerance(resolution, pixelRatio) {
    var tolerance = getTolerance(resolution, pixelRatio);
    return tolerance * tolerance;
}
/**
 * @param {number} resolution Resolution.
 * @param {number} pixelRatio Pixel ratio.
 * @return {number} Pixel tolerance.
 */
function getTolerance(resolution, pixelRatio) {
    return (SIMPLIFY_TOLERANCE * resolution) / pixelRatio;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Builder group.
 * @param {import("../geom/Circle.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderCircleGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var circleReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CIRCLE);
        circleReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        circleReplay.drawCircle(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {function(import("../events/Event.js").default): void} listener Listener function.
 * @param {import("../proj.js").TransformFunction} [opt_transform] Transform from user to view projection.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 * @return {boolean} `true` if style is loading.
 */
function renderFeature(replayGroup, feature, style, squaredTolerance, listener, opt_transform, opt_declutterBuilderGroup) {
    var loading = false;
    var imageStyle = style.getImage();
    if (imageStyle) {
        var imageState = imageStyle.getImageState();
        if (imageState == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED || imageState == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].ERROR) {
            imageStyle.unlistenImageChange(listener);
        }
        else {
            if (imageState == _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].IDLE) {
                imageStyle.load();
            }
            imageState = imageStyle.getImageState();
            imageStyle.listenImageChange(listener);
            loading = true;
        }
    }
    renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup);
    return loading;
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../style/Style.js").default} style Style.
 * @param {number} squaredTolerance Squared tolerance.
 * @param {import("../proj.js").TransformFunction} [opt_transform] Optional transform function.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderFeatureInternal(replayGroup, feature, style, squaredTolerance, opt_transform, opt_declutterBuilderGroup) {
    var geometry = style.getGeometryFunction()(feature);
    if (!geometry) {
        return;
    }
    var simplifiedGeometry = geometry.simplifyTransformed(squaredTolerance, opt_transform);
    var renderer = style.getRenderer();
    if (renderer) {
        renderGeometry(replayGroup, simplifiedGeometry, style, feature);
    }
    else {
        var geometryRenderer = GEOMETRY_RENDERERS[simplifiedGeometry.getType()];
        geometryRenderer(replayGroup, simplifiedGeometry, style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/Geometry.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 */
function renderGeometry(replayGroup, geometry, style, feature) {
    if (geometry.getType() == _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].GEOMETRY_COLLECTION) {
        var geometries = 
        /** @type {import("../geom/GeometryCollection.js").default} */ (geometry).getGeometries();
        for (var i = 0, ii = geometries.length; i < ii; ++i) {
            renderGeometry(replayGroup, geometries[i], style, feature);
        }
        return;
    }
    var replay = replayGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].DEFAULT);
    replay.drawCustom(
    /** @type {import("../geom/SimpleGeometry.js").default} */ (geometry), feature, style.getRenderer());
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} replayGroup Replay group.
 * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderGeometryCollectionGeometry(replayGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var geometries = geometry.getGeometriesArray();
    var i, ii;
    for (i = 0, ii = geometries.length; i < ii; ++i) {
        var geometryRenderer = GEOMETRY_RENDERERS[geometries[i].getType()];
        geometryRenderer(replayGroup, geometries[i], style, feature, opt_declutterBuilderGroup);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/LineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiLineString.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderMultiLineStringGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var strokeStyle = style.getStroke();
    if (strokeStyle) {
        var lineStringReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LINE_STRING);
        lineStringReplay.setFillStrokeStyle(null, strokeStyle);
        lineStringReplay.drawMultiLineString(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").default} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderMultiPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (strokeStyle || fillStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawMultiPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Point.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */
    var declutterImageWithText;
    if (opt_declutterBuilderGroup) {
        builderGroup = opt_declutterBuilderGroup;
        declutterImageWithText =
            imageStyle && textStyle && textStyle.getText() ? {} : undefined;
    }
    if (imageStyle) {
        if (imageStyle.getImageState() != _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
            return;
        }
        var imageReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE);
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/MultiPoint.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderMultiPointGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var imageStyle = style.getImage();
    var textStyle = style.getText();
    /** @type {import("../render/canvas.js").DeclutterImageWithText} */
    var declutterImageWithText;
    if (opt_declutterBuilderGroup) {
        builderGroup = opt_declutterBuilderGroup;
        declutterImageWithText =
            imageStyle && textStyle && textStyle.getText() ? {} : undefined;
    }
    if (imageStyle) {
        if (imageStyle.getImageState() != _ImageState_js__WEBPACK_IMPORTED_MODULE_2__["default"].LOADED) {
            return;
        }
        var imageReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].IMAGE);
        imageReplay.setImageStyle(imageStyle, declutterImageWithText);
        imageReplay.drawMultiPoint(geometry, feature);
    }
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle, declutterImageWithText);
        textReplay.drawText(geometry, feature);
    }
}
/**
 * @param {import("../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
 * @param {import("../geom/Polygon.js").default|import("../render/Feature.js").default} geometry Geometry.
 * @param {import("../style/Style.js").default} style Style.
 * @param {import("../Feature.js").FeatureLike} feature Feature.
 * @param {import("../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder for decluttering.
 */
function renderPolygonGeometry(builderGroup, geometry, style, feature, opt_declutterBuilderGroup) {
    var fillStyle = style.getFill();
    var strokeStyle = style.getStroke();
    if (fillStyle || strokeStyle) {
        var polygonReplay = builderGroup.getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].POLYGON);
        polygonReplay.setFillStrokeStyle(fillStyle, strokeStyle);
        polygonReplay.drawPolygon(geometry, feature);
    }
    var textStyle = style.getText();
    if (textStyle && textStyle.getText()) {
        var textReplay = (opt_declutterBuilderGroup || builderGroup).getBuilder(style.getZIndex(), _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_0__["default"].TEXT);
        textReplay.setTextStyle(textStyle);
        textReplay.drawText(geometry, feature);
    }
}
//# sourceMappingURL=vector.js.map

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExtentEvent", function() { return ExtentEvent; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(178);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(271);
/* harmony import */ var _layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(288);
/* harmony import */ var _source_Vector_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(105);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(272);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(24);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(184);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Extent
 */














/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.always}.
 * @property {import("../extent.js").Extent} [extent] Initial extent. Defaults to no
 * initial extent.
 * @property {import("../style/Style.js").StyleLike} [boxStyle]
 * Style for the drawn extent box. Defaults to
 * {@link module:ol/style/Style~createEditing()['Polygon']}
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
 * pointer close enough to a segment or vertex for editing.
 * @property {import("../style/Style.js").StyleLike} [pointerStyle]
 * Style for the cursor used to draw the extent. Defaults to
 * {@link module:ol/style/Style~createEditing()['Point']}
 * @property {boolean} [wrapX=false] Wrap the drawn extent across multiple maps
 * in the X direction? Only affects visuals, not functionality.
 */
/**
 * @enum {string}
 */
var ExtentEventType = {
    /**
     * Triggered after the extent is changed
     * @event ExtentEvent#extentchanged
     * @api
     */
    EXTENTCHANGED: 'extentchanged',
};
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Extent~Extent} instances are
 * instances of this type.
 */
var ExtentEvent = /** @class */ (function (_super) {
    __extends(ExtentEvent, _super);
    /**
     * @param {import("../extent.js").Extent} extent the new extent
     */
    function ExtentEvent(extent) {
        var _this = _super.call(this, ExtentEventType.EXTENTCHANGED) || this;
        /**
         * The current extent.
         * @type {import("../extent.js").Extent}
         * @api
         */
        _this.extent = extent;
        return _this;
    }
    return ExtentEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'extentchanged', ExtentEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'extentchanged', Return>} ExtentOnSignature
 */
/**
 * @classdesc
 * Allows the user to draw a vector box by clicking and dragging on the map.
 * Once drawn, the vector box can be modified by dragging its vertices or edges.
 * This interaction is only supported for mouse devices.
 *
 * @fires ExtentEvent
 * @api
 */
var Extent = /** @class */ (function (_super) {
    __extends(Extent, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Extent(opt_options) {
        var _this = this;
        var options = opt_options || {};
        _this = _super.call(this, /** @type {import("./Pointer.js").Options} */ (options)) || this;
        /***
         * @type {ExtentOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ExtentOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ExtentOnSignature<void>}
         */
        _this.un;
        /**
         * Condition
         * @type {import("../events/condition.js").Condition}
         * @private
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_8__["always"];
        /**
         * Extent of the drawn box
         * @type {import("../extent.js").Extent}
         * @private
         */
        _this.extent_ = null;
        /**
         * Handler for pointer move events
         * @type {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null}
         * @private
         */
        _this.pointerHandler_ = null;
        /**
         * Pixel threshold to snap to extent
         * @type {number}
         * @private
         */
        _this.pixelTolerance_ =
            options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
         * Is the pointer snapped to an extent vertex
         * @type {boolean}
         * @private
         */
        _this.snappedToVertex_ = false;
        /**
         * Feature for displaying the visible extent
         * @type {Feature}
         * @private
         */
        _this.extentFeature_ = null;
        /**
         * Feature for displaying the visible pointer
         * @type {Feature<Point>}
         * @private
         */
        _this.vertexFeature_ = null;
        if (!opt_options) {
            opt_options = {};
        }
        /**
         * Layer for the extentFeature
         * @type {VectorLayer}
         * @private
         */
        _this.extentOverlay_ = new _layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
            source: new _source_Vector_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                useSpatialIndex: false,
                wrapX: !!opt_options.wrapX,
            }),
            style: opt_options.boxStyle
                ? opt_options.boxStyle
                : getDefaultExtentStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true,
        });
        /**
         * Layer for the vertexFeature
         * @type {VectorLayer}
         * @private
         */
        _this.vertexOverlay_ = new _layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
            source: new _source_Vector_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                useSpatialIndex: false,
                wrapX: !!opt_options.wrapX,
            }),
            style: opt_options.pointerStyle
                ? opt_options.pointerStyle
                : getDefaultPointerStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true,
        });
        if (opt_options.extent) {
            _this.setExtent(opt_options.extent);
        }
        return _this;
    }
    /**
     * @param {import("../pixel.js").Pixel} pixel cursor location
     * @param {import("../PluggableMap.js").default} map map
     * @return {import("../coordinate.js").Coordinate|null} snapped vertex on extent
     * @private
     */
    Extent.prototype.snapToVertex_ = function (pixel, map) {
        var pixelCoordinate = map.getCoordinateFromPixelInternal(pixel);
        var sortByDistance = function (a, b) {
            return (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["squaredDistanceToSegment"])(pixelCoordinate, a) -
                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["squaredDistanceToSegment"])(pixelCoordinate, b));
        };
        var extent = this.getExtentInternal();
        if (extent) {
            //convert extents to line segments and find the segment closest to pixelCoordinate
            var segments = getSegments(extent);
            segments.sort(sortByDistance);
            var closestSegment = segments[0];
            var vertex = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["closestOnSegment"])(pixelCoordinate, closestSegment);
            var vertexPixel = map.getPixelFromCoordinateInternal(vertex);
            //if the distance is within tolerance, snap to the segment
            if (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["distance"])(pixel, vertexPixel) <= this.pixelTolerance_) {
                //test if we should further snap to a vertex
                var pixel1 = map.getPixelFromCoordinateInternal(closestSegment[0]);
                var pixel2 = map.getPixelFromCoordinateInternal(closestSegment[1]);
                var squaredDist1 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["squaredDistance"])(vertexPixel, pixel1);
                var squaredDist2 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_10__["squaredDistance"])(vertexPixel, pixel2);
                var dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                this.snappedToVertex_ = dist <= this.pixelTolerance_;
                if (this.snappedToVertex_) {
                    vertex =
                        squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                }
                return vertex;
            }
        }
        return null;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent pointer move event
     * @private
     */
    Extent.prototype.handlePointerMove_ = function (mapBrowserEvent) {
        var pixel = mapBrowserEvent.pixel;
        var map = mapBrowserEvent.map;
        var vertex = this.snapToVertex_(pixel, map);
        if (!vertex) {
            vertex = map.getCoordinateFromPixelInternal(pixel);
        }
        this.createOrUpdatePointerFeature_(vertex);
    };
    /**
     * @param {import("../extent.js").Extent} extent extent
     * @return {Feature} extent as featrue
     * @private
     */
    Extent.prototype.createOrUpdateExtentFeature_ = function (extent) {
        var extentFeature = this.extentFeature_;
        if (!extentFeature) {
            if (!extent) {
                extentFeature = new _Feature_js__WEBPACK_IMPORTED_MODULE_1__["default"]({});
            }
            else {
                extentFeature = new _Feature_js__WEBPACK_IMPORTED_MODULE_1__["default"](Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_12__["fromExtent"])(extent));
            }
            this.extentFeature_ = extentFeature;
            this.extentOverlay_.getSource().addFeature(extentFeature);
        }
        else {
            if (!extent) {
                extentFeature.setGeometry(undefined);
            }
            else {
                extentFeature.setGeometry(Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_12__["fromExtent"])(extent));
            }
        }
        return extentFeature;
    };
    /**
     * @param {import("../coordinate.js").Coordinate} vertex location of feature
     * @return {Feature} vertex as feature
     * @private
     */
    Extent.prototype.createOrUpdatePointerFeature_ = function (vertex) {
        var vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new _Feature_js__WEBPACK_IMPORTED_MODULE_1__["default"](new _geom_Point_js__WEBPACK_IMPORTED_MODULE_4__["default"](vertex));
            this.vertexFeature_ = vertexFeature;
            this.vertexOverlay_.getSource().addFeature(vertexFeature);
        }
        else {
            var geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(vertex);
        }
        return vertexFeature;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */
    Extent.prototype.handleEvent = function (mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent || !this.condition_(mapBrowserEvent)) {
            return true;
        }
        //display pointer (if not dragging)
        if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POINTERMOVE &&
            !this.handlingDownUpSequence) {
            this.handlePointerMove_(mapBrowserEvent);
        }
        //call pointer to determine up/down/drag
        _super.prototype.handleEvent.call(this, mapBrowserEvent);
        //return false to stop propagation
        return false;
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    Extent.prototype.handleDownEvent = function (mapBrowserEvent) {
        var pixel = mapBrowserEvent.pixel;
        var map = mapBrowserEvent.map;
        var extent = this.getExtentInternal();
        var vertex = this.snapToVertex_(pixel, map);
        //find the extent corner opposite the passed corner
        var getOpposingPoint = function (point) {
            var x_ = null;
            var y_ = null;
            if (point[0] == extent[0]) {
                x_ = extent[2];
            }
            else if (point[0] == extent[2]) {
                x_ = extent[0];
            }
            if (point[1] == extent[1]) {
                y_ = extent[3];
            }
            else if (point[1] == extent[3]) {
                y_ = extent[1];
            }
            if (x_ !== null && y_ !== null) {
                return [x_, y_];
            }
            return null;
        };
        if (vertex && extent) {
            var x = vertex[0] == extent[0] || vertex[0] == extent[2] ? vertex[0] : null;
            var y = vertex[1] == extent[1] || vertex[1] == extent[3] ? vertex[1] : null;
            //snap to point
            if (x !== null && y !== null) {
                this.pointerHandler_ = getPointHandler(getOpposingPoint(vertex));
                //snap to edge
            }
            else if (x !== null) {
                this.pointerHandler_ = getEdgeHandler(getOpposingPoint([x, extent[1]]), getOpposingPoint([x, extent[3]]));
            }
            else if (y !== null) {
                this.pointerHandler_ = getEdgeHandler(getOpposingPoint([extent[0], y]), getOpposingPoint([extent[2], y]));
            }
            //no snap - new bbox
        }
        else {
            vertex = map.getCoordinateFromPixelInternal(pixel);
            this.setExtent([vertex[0], vertex[1], vertex[0], vertex[1]]);
            this.pointerHandler_ = getPointHandler(vertex);
        }
        return true; //event handled; start downup sequence
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     */
    Extent.prototype.handleDragEvent = function (mapBrowserEvent) {
        if (this.pointerHandler_) {
            var pixelCoordinate = mapBrowserEvent.coordinate;
            this.setExtent(this.pointerHandler_(pixelCoordinate));
            this.createOrUpdatePointerFeature_(pixelCoordinate);
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Event.
     * @return {boolean} If the event was consumed.
     */
    Extent.prototype.handleUpEvent = function (mapBrowserEvent) {
        this.pointerHandler_ = null;
        //If bbox is zero area, set to null;
        var extent = this.getExtentInternal();
        if (!extent || Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["getArea"])(extent) === 0) {
            this.setExtent(null);
        }
        return false; //Stop handling downup sequence
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Extent.prototype.setMap = function (map) {
        this.extentOverlay_.setMap(map);
        this.vertexOverlay_.setMap(map);
        _super.prototype.setMap.call(this, map);
    };
    /**
     * Returns the current drawn extent in the view projection (or user projection if set)
     *
     * @return {import("../extent.js").Extent} Drawn extent in the view projection.
     * @api
     */
    Extent.prototype.getExtent = function () {
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_13__["toUserExtent"])(this.getExtentInternal(), this.getMap().getView().getProjection());
    };
    /**
     * Returns the current drawn extent in the view projection
     *
     * @return {import("../extent.js").Extent} Drawn extent in the view projection.
     * @api
     */
    Extent.prototype.getExtentInternal = function () {
        return this.extent_;
    };
    /**
     * Manually sets the drawn extent, using the view projection.
     *
     * @param {import("../extent.js").Extent} extent Extent
     * @api
     */
    Extent.prototype.setExtent = function (extent) {
        //Null extent means no bbox
        this.extent_ = extent ? extent : null;
        this.createOrUpdateExtentFeature_(extent);
        this.dispatchEvent(new ExtentEvent(this.extent_));
    };
    return Extent;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_5__["default"]));
/**
 * Returns the default style for the drawn bbox
 *
 * @return {import("../style/Style.js").StyleFunction} Default Extent style
 */
function getDefaultExtentStyleFunction() {
    var style = Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_11__["createEditingStyle"])();
    return function (feature, resolution) {
        return style[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POLYGON];
    };
}
/**
 * Returns the default style for the pointer
 *
 * @return {import("../style/Style.js").StyleFunction} Default pointer style
 */
function getDefaultPointerStyleFunction() {
    var style = Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_11__["createEditingStyle"])();
    return function (feature, resolution) {
        return style[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POINT];
    };
}
/**
 * @param {import("../coordinate.js").Coordinate} fixedPoint corner that will be unchanged in the new extent
 * @return {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent} event handler
 */
function getPointHandler(fixedPoint) {
    return function (point) {
        return Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["boundingExtent"])([fixedPoint, point]);
    };
}
/**
 * @param {import("../coordinate.js").Coordinate} fixedP1 first corner that will be unchanged in the new extent
 * @param {import("../coordinate.js").Coordinate} fixedP2 second corner that will be unchanged in the new extent
 * @return {function (import("../coordinate.js").Coordinate): import("../extent.js").Extent|null} event handler
 */
function getEdgeHandler(fixedP1, fixedP2) {
    if (fixedP1[0] == fixedP2[0]) {
        return function (point) {
            return Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["boundingExtent"])([fixedP1, [point[0], fixedP2[1]]]);
        };
    }
    else if (fixedP1[1] == fixedP2[1]) {
        return function (point) {
            return Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["boundingExtent"])([fixedP1, [fixedP2[0], point[1]]]);
        };
    }
    else {
        return null;
    }
}
/**
 * @param {import("../extent.js").Extent} extent extent
 * @return {Array<Array<import("../coordinate.js").Coordinate>>} extent line segments
 */
function getSegments(extent) {
    return [
        [
            [extent[0], extent[1]],
            [extent[0], extent[3]],
        ],
        [
            [extent[0], extent[3]],
            [extent[2], extent[3]],
        ],
        [
            [extent[2], extent[3]],
            [extent[2], extent[1]],
        ],
        [
            [extent[2], extent[1]],
            [extent[0], extent[1]],
        ],
    ];
}
/* harmony default export */ __webpack_exports__["default"] = (Extent);
//# sourceMappingURL=Extent.js.map

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ModifyEvent", function() { return ModifyEvent; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(107);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(23);
/* harmony import */ var _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(178);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(271);
/* harmony import */ var _structs_RBush_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(108);
/* harmony import */ var _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(110);
/* harmony import */ var _layer_Vector_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(288);
/* harmony import */ var _source_Vector_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(105);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(272);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(16);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(65);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(52);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(184);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(7);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(21);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Modify
 */





















/**
 * The segment index assigned to a circle's center when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */
var CIRCLE_CENTER_INDEX = 0;
/**
 * The segment index assigned to a circle's circumference when
 * breaking up a circle into ModifySegmentDataType segments.
 * @type {number}
 */
var CIRCLE_CIRCUMFERENCE_INDEX = 1;
var tempExtent = [0, 0, 0, 0];
var tempSegment = [];
/**
 * @enum {string}
 */
var ModifyEventType = {
    /**
     * Triggered upon feature modification start
     * @event ModifyEvent#modifystart
     * @api
     */
    MODIFYSTART: 'modifystart',
    /**
     * Triggered upon feature modification end
     * @event ModifyEvent#modifyend
     * @api
     */
    MODIFYEND: 'modifyend',
};
/**
 * @typedef {Object} SegmentData
 * @property {Array<number>} [depth] Depth.
 * @property {import("../Feature").FeatureLike} feature Feature.
 * @property {import("../geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} [index] Index.
 * @property {Array<Array<number>>} segment Segment.
 * @property {Array<SegmentData>} [featureSegments] FeatureSegments.
 */
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event will be considered to add or move a
 * vertex to the sketch. Default is
 * {@link module:ol/events/condition.primaryAction}.
 * @property {import("../events/condition.js").Condition} [deleteCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. By default,
 * {@link module:ol/events/condition.singleClick} with
 * {@link module:ol/events/condition.altKeyOnly} results in a vertex deletion.
 * @property {import("../events/condition.js").Condition} [insertVertexCondition] A
 * function that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and
 * returns a boolean to indicate whether a new vertex should be added to the sketch
 * features. Default is {@link module:ol/events/condition.always}.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the
 * pointer close enough to a segment or vertex for editing.
 * @property {import("../style/Style.js").StyleLike} [style]
 * Style used for the modification point or vertex. For linestrings and polygons, this will
 * be the affected vertex, for circles a point along the circle, and for points the actual
 * point. If not configured, the default edit style is used (see {@link module:ol/style}).
 * When using a style function, the point feature passed to the function will have a `features`
 * property - an array whose entries are the features that are being modified, and a `geometries`
 * property - an array whose entries are the geometries that are being modified. Both arrays are
 * in the same order. The `geometries` are only useful when modifying geometry collections, where
 * the geometry will be the particular geometry from the collection that is being modified.
 * @property {VectorSource} [source] The vector source with
 * features to modify.  If a vector source is not provided, a feature collection
 * must be provided with the `features` option.
 * @property {boolean|import("../layer/BaseVector").default} [hitDetection] When configured, point
 * features will be considered for modification based on their visual appearance, instead of being within
 * the `pixelTolerance` from the pointer location. When a {@link module:ol/layer/BaseVector} is
 * provided, only the rendered representation of the features on that layer will be considered.
 * @property {Collection<Feature>} [features]
 * The features the interaction works on.  If a feature collection is not
 * provided, a vector source must be provided with the `source` option.
 * @property {boolean} [wrapX=false] Wrap the world horizontally on the sketch
 * overlay.
 * @property {boolean} [snapToPointer=!hitDetection] The vertex, point or segment being modified snaps to the
 * pointer coordinate when clicked within the `pixelTolerance`.
 */
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Modify~Modify} instances are
 * instances of this type.
 */
var ModifyEvent = /** @class */ (function (_super) {
    __extends(ModifyEvent, _super);
    /**
     * @param {ModifyEventType} type Type.
     * @param {Collection<import("../Feature").FeatureLike>} features
     * The features modified.
     * @param {import("../MapBrowserEvent.js").default} MapBrowserEvent
     * Associated {@link module:ol/MapBrowserEvent}.
     */
    function ModifyEvent(type, features, MapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * The features being modified.
         * @type {Collection<import("../Feature").FeatureLike>}
         * @api
         */
        _this.features = features;
        /**
         * Associated {@link module:ol/MapBrowserEvent}.
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */
        _this.mapBrowserEvent = MapBrowserEvent;
        return _this;
    }
    return ModifyEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_2__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'modifyend'|'modifystart', ModifyEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'modifyend'|'modifystart', Return>} ModifyOnSignature
 */
/**
 * @classdesc
 * Interaction for modifying feature geometries.  To modify features that have
 * been added to an existing source, construct the modify interaction with the
 * `source` option.  If you want to modify features in a collection (for example,
 * the collection used by a select interaction), construct the interaction with
 * the `features` option.  The interaction must be constructed with either a
 * `source` or `features` option.
 *
 * Cartesian distance from the pointer is used to determine the features that
 * will be modified. This means that geometries will only be considered for
 * modification when they are within the configured `pixelTolerane`. For point
 * geometries, the `hitDetection` option can be used to match their visual
 * appearance.
 *
 * By default, the interaction will allow deletion of vertices when the `alt`
 * key is pressed.  To configure the interaction with a different condition
 * for deletion, use the `deleteCondition` option.
 * @fires ModifyEvent
 * @api
 */
var Modify = /** @class */ (function (_super) {
    __extends(Modify, _super);
    /**
     * @param {Options} options Options.
     */
    function Modify(options) {
        var _this = _super.call(this, /** @type {import("./Pointer.js").Options} */ (options)) || this;
        /***
         * @type {ModifyOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {ModifyOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {ModifyOnSignature<void>}
         */
        _this.un;
        /** @private */
        _this.boundHandleFeatureChange_ = _this.handleFeatureChange_.bind(_this);
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_13__["primaryAction"];
        /**
         * @private
         * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Browser event.
         * @return {boolean} Combined condition result.
         */
        _this.defaultDeleteCondition_ = function (mapBrowserEvent) {
            return Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_13__["altKeyOnly"])(mapBrowserEvent) && Object(_events_condition_js__WEBPACK_IMPORTED_MODULE_13__["singleClick"])(mapBrowserEvent);
        };
        /**
         * @type {import("../events/condition.js").Condition}
         * @private
         */
        _this.deleteCondition_ = options.deleteCondition
            ? options.deleteCondition
            : _this.defaultDeleteCondition_;
        /**
         * @type {import("../events/condition.js").Condition}
         * @private
         */
        _this.insertVertexCondition_ = options.insertVertexCondition
            ? options.insertVertexCondition
            : _events_condition_js__WEBPACK_IMPORTED_MODULE_13__["always"];
        /**
         * Editing vertex.
         * @type {Feature}
         * @private
         */
        _this.vertexFeature_ = null;
        /**
         * Segments intersecting {@link this.vertexFeature_} by segment uid.
         * @type {Object<string, boolean>}
         * @private
         */
        _this.vertexSegments_ = null;
        /**
         * @type {import("../pixel.js").Pixel}
         * @private
         */
        _this.lastPixel_ = [0, 0];
        /**
         * Tracks if the next `singleclick` event should be ignored to prevent
         * accidental deletion right after vertex creation.
         * @type {boolean}
         * @private
         */
        _this.ignoreNextSingleClick_ = false;
        /**
         * @type {Collection<import("../Feature").FeatureLike>}
         * @private
         */
        _this.featuresBeingModified_ = null;
        /**
         * Segment RTree for each layer
         * @type {RBush<SegmentData>}
         * @private
         */
        _this.rBush_ = new _structs_RBush_js__WEBPACK_IMPORTED_MODULE_9__["default"]();
        /**
         * @type {number}
         * @private
         */
        _this.pixelTolerance_ =
            options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
         * @type {boolean}
         * @private
         */
        _this.snappedToVertex_ = false;
        /**
         * Indicate whether the interaction is currently changing a feature's
         * coordinates.
         * @type {boolean}
         * @private
         */
        _this.changingFeature_ = false;
        /**
         * @type {Array}
         * @private
         */
        _this.dragSegments_ = [];
        /**
         * Draw overlay where sketch features are drawn.
         * @type {VectorLayer}
         * @private
         */
        _this.overlay_ = new _layer_Vector_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
            source: new _source_Vector_js__WEBPACK_IMPORTED_MODULE_12__["default"]({
                useSpatialIndex: false,
                wrapX: !!options.wrapX,
            }),
            style: options.style ? options.style : getDefaultStyleFunction(),
            updateWhileAnimating: true,
            updateWhileInteracting: true,
        });
        /**
         * @const
         * @private
         * @type {!Object<string, function(Feature, import("../geom/Geometry.js").default): void>}
         */
        _this.SEGMENT_WRITERS_ = {
            'Point': _this.writePointGeometry_.bind(_this),
            'LineString': _this.writeLineStringGeometry_.bind(_this),
            'LinearRing': _this.writeLineStringGeometry_.bind(_this),
            'Polygon': _this.writePolygonGeometry_.bind(_this),
            'MultiPoint': _this.writeMultiPointGeometry_.bind(_this),
            'MultiLineString': _this.writeMultiLineStringGeometry_.bind(_this),
            'MultiPolygon': _this.writeMultiPolygonGeometry_.bind(_this),
            'Circle': _this.writeCircleGeometry_.bind(_this),
            'GeometryCollection': _this.writeGeometryCollectionGeometry_.bind(_this),
        };
        /**
         * @type {VectorSource}
         * @private
         */
        _this.source_ = null;
        /**
         * @type {boolean|import("../layer/BaseVector").default}
         */
        _this.hitDetection_ = null;
        var features;
        if (options.features) {
            features = options.features;
        }
        else if (options.source) {
            _this.source_ = options.source;
            features = new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"](_this.source_.getFeatures());
            _this.source_.addEventListener(_source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_10__["default"].ADDFEATURE, _this.handleSourceAdd_.bind(_this));
            _this.source_.addEventListener(_source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_10__["default"].REMOVEFEATURE, _this.handleSourceRemove_.bind(_this));
        }
        if (!features) {
            throw new Error('The modify interaction requires features, a source or a layer');
        }
        if (options.hitDetection) {
            _this.hitDetection_ = options.hitDetection;
        }
        /**
         * @type {Collection<import("../Feature.js").FeatureLike>}
         * @private
         */
        _this.features_ = features;
        _this.features_.forEach(_this.addFeature_.bind(_this));
        _this.features_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ADD, _this.handleFeatureAdd_.bind(_this));
        _this.features_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].REMOVE, _this.handleFeatureRemove_.bind(_this));
        /**
         * @type {import("../MapBrowserEvent.js").default}
         * @private
         */
        _this.lastPointerEvent_ = null;
        /**
         * Delta (x, y in map units) between matched rtree vertex and pointer vertex.
         * @type {Array<number>}
         */
        _this.delta_ = [0, 0];
        /**
         * @private
         */
        _this.snapToPointer_ =
            options.snapToPointer === undefined
                ? !_this.hitDetection_
                : options.snapToPointer;
        return _this;
    }
    /**
     * @param {Feature} feature Feature.
     * @private
     */
    Modify.prototype.addFeature_ = function (feature) {
        var geometry = feature.getGeometry();
        if (geometry) {
            var writer = this.SEGMENT_WRITERS_[geometry.getType()];
            if (writer) {
                writer(feature, geometry);
            }
        }
        var map = this.getMap();
        if (map && map.isRendered() && this.getActive()) {
            this.handlePointerAtPixel_(this.lastPixel_, map);
        }
        feature.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.boundHandleFeatureChange_);
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
     * @param {Array<Array<SegmentData>>} segments The segments subject to modification.
     * @private
     */
    Modify.prototype.willModifyFeatures_ = function (evt, segments) {
        if (!this.featuresBeingModified_) {
            this.featuresBeingModified_ = new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
            var features = this.featuresBeingModified_.getArray();
            for (var i = 0, ii = segments.length; i < ii; ++i) {
                var segment = segments[i];
                for (var s = 0, ss = segment.length; s < ss; ++s) {
                    var feature = segment[s].feature;
                    if (feature && features.indexOf(feature) === -1) {
                        this.featuresBeingModified_.push(feature);
                    }
                }
            }
            if (this.featuresBeingModified_.getLength() === 0) {
                this.featuresBeingModified_ = null;
            }
            else {
                this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYSTART, this.featuresBeingModified_, evt));
            }
        }
    };
    /**
     * @param {Feature} feature Feature.
     * @private
     */
    Modify.prototype.removeFeature_ = function (feature) {
        this.removeFeatureSegmentData_(feature);
        // Remove the vertex feature if the collection of canditate features is empty.
        if (this.vertexFeature_ && this.features_.getLength() === 0) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        feature.removeEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.boundHandleFeatureChange_);
    };
    /**
     * @param {Feature} feature Feature.
     * @private
     */
    Modify.prototype.removeFeatureSegmentData_ = function (feature) {
        var rBush = this.rBush_;
        /** @type {Array<SegmentData>} */
        var nodesToRemove = [];
        rBush.forEach(
        /**
         * @param {SegmentData} node RTree node.
         */
        function (node) {
            if (feature === node.feature) {
                nodesToRemove.push(node);
            }
        });
        for (var i = nodesToRemove.length - 1; i >= 0; --i) {
            var nodeToRemove = nodesToRemove[i];
            for (var j = this.dragSegments_.length - 1; j >= 0; --j) {
                if (this.dragSegments_[j][0] === nodeToRemove) {
                    this.dragSegments_.splice(j, 1);
                }
            }
            rBush.remove(nodeToRemove);
        }
    };
    /**
     * Activate or deactivate the interaction.
     * @param {boolean} active Active.
     * @observable
     * @api
     */
    Modify.prototype.setActive = function (active) {
        if (this.vertexFeature_ && !active) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
        _super.prototype.setActive.call(this, active);
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Modify.prototype.setMap = function (map) {
        this.overlay_.setMap(map);
        _super.prototype.setMap.call(this, map);
    };
    /**
     * Get the overlay layer that this interaction renders the modification point or vertex to.
     * @return {VectorLayer} Overlay layer.
     * @api
     */
    Modify.prototype.getOverlay = function () {
        return this.overlay_;
    };
    /**
     * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
     * @private
     */
    Modify.prototype.handleSourceAdd_ = function (event) {
        if (event.feature) {
            this.features_.push(event.feature);
        }
    };
    /**
     * @param {import("../source/Vector.js").VectorSourceEvent} event Event.
     * @private
     */
    Modify.prototype.handleSourceRemove_ = function (event) {
        if (event.feature) {
            this.features_.remove(event.feature);
        }
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Modify.prototype.handleFeatureAdd_ = function (evt) {
        this.addFeature_(/** @type {Feature} */ (evt.element));
    };
    /**
     * @param {import("../events/Event.js").default} evt Event.
     * @private
     */
    Modify.prototype.handleFeatureChange_ = function (evt) {
        if (!this.changingFeature_) {
            var feature = /** @type {Feature} */ (evt.target);
            this.removeFeature_(feature);
            this.addFeature_(feature);
        }
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Modify.prototype.handleFeatureRemove_ = function (evt) {
        var feature = /** @type {Feature} */ (evt.element);
        this.removeFeature_(feature);
    };
    /**
     * @param {Feature} feature Feature
     * @param {Point} geometry Geometry.
     * @private
     */
    Modify.prototype.writePointGeometry_ = function (feature, geometry) {
        var coordinates = geometry.getCoordinates();
        /** @type {SegmentData} */
        var segmentData = {
            feature: feature,
            geometry: geometry,
            segment: [coordinates, coordinates],
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeMultiPointGeometry_ = function (feature, geometry) {
        var points = geometry.getCoordinates();
        for (var i = 0, ii = points.length; i < ii; ++i) {
            var coordinates = points[i];
            /** @type {SegmentData} */
            var segmentData = {
                feature: feature,
                geometry: geometry,
                depth: [i],
                index: i,
                segment: [coordinates, coordinates],
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/LineString.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeLineStringGeometry_ = function (feature, geometry) {
        var coordinates = geometry.getCoordinates();
        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
            var segment = coordinates.slice(i, i + 2);
            /** @type {SegmentData} */
            var segmentData = {
                feature: feature,
                geometry: geometry,
                index: i,
                segment: segment,
            };
            this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(segment), segmentData);
        }
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeMultiLineStringGeometry_ = function (feature, geometry) {
        var lines = geometry.getCoordinates();
        for (var j = 0, jj = lines.length; j < jj; ++j) {
            var coordinates = lines[j];
            for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                var segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */
                var segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [j],
                    index: i,
                    segment: segment,
                };
                this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(segment), segmentData);
            }
        }
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/Polygon.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writePolygonGeometry_ = function (feature, geometry) {
        var rings = geometry.getCoordinates();
        for (var j = 0, jj = rings.length; j < jj; ++j) {
            var coordinates = rings[j];
            for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                var segment = coordinates.slice(i, i + 2);
                /** @type {SegmentData} */
                var segmentData = {
                    feature: feature,
                    geometry: geometry,
                    depth: [j],
                    index: i,
                    segment: segment,
                };
                this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(segment), segmentData);
            }
        }
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeMultiPolygonGeometry_ = function (feature, geometry) {
        var polygons = geometry.getCoordinates();
        for (var k = 0, kk = polygons.length; k < kk; ++k) {
            var rings = polygons[k];
            for (var j = 0, jj = rings.length; j < jj; ++j) {
                var coordinates = rings[j];
                for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                    var segment = coordinates.slice(i, i + 2);
                    /** @type {SegmentData} */
                    var segmentData = {
                        feature: feature,
                        geometry: geometry,
                        depth: [j, k],
                        index: i,
                        segment: segment,
                    };
                    this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(segment), segmentData);
                }
            }
        }
    };
    /**
     * We convert a circle into two segments.  The segment at index
     * {@link CIRCLE_CENTER_INDEX} is the
     * circle's center (a point).  The segment at index
     * {@link CIRCLE_CIRCUMFERENCE_INDEX} is
     * the circumference, and is not a line segment.
     *
     * @param {Feature} feature Feature.
     * @param {import("../geom/Circle.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeCircleGeometry_ = function (feature, geometry) {
        var coordinates = geometry.getCenter();
        /** @type {SegmentData} */
        var centerSegmentData = {
            feature: feature,
            geometry: geometry,
            index: CIRCLE_CENTER_INDEX,
            segment: [coordinates, coordinates],
        };
        /** @type {SegmentData} */
        var circumferenceSegmentData = {
            feature: feature,
            geometry: geometry,
            index: CIRCLE_CIRCUMFERENCE_INDEX,
            segment: [coordinates, coordinates],
        };
        var featureSegments = [centerSegmentData, circumferenceSegmentData];
        centerSegmentData.featureSegments = featureSegments;
        circumferenceSegmentData.featureSegments = featureSegments;
        this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["createOrUpdateFromCoordinate"])(coordinates), centerSegmentData);
        var circleGeometry = /** @type {import("../geom/Geometry.js").default} */ (geometry);
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["getUserProjection"])();
        if (userProjection && this.getMap()) {
            var projection = this.getMap().getView().getProjection();
            circleGeometry = circleGeometry
                .clone()
                .transform(userProjection, projection);
            circleGeometry = Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__["fromCircle"])(
            /** @type {import("../geom/Circle.js").default} */ (circleGeometry)).transform(projection, userProjection);
        }
        this.rBush_.insert(circleGeometry.getExtent(), circumferenceSegmentData);
    };
    /**
     * @param {Feature} feature Feature
     * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
     * @private
     */
    Modify.prototype.writeGeometryCollectionGeometry_ = function (feature, geometry) {
        var geometries = geometry.getGeometriesArray();
        for (var i = 0; i < geometries.length; ++i) {
            var geometry_1 = geometries[i];
            var writer = this.SEGMENT_WRITERS_[geometry_1.getType()];
            writer(feature, geometry_1);
        }
    };
    /**
     * @param {import("../coordinate.js").Coordinate} coordinates Coordinates.
     * @param {Array<import("../Feature").FeatureLike>} features The features being modified.
     * @param {Array<import("../geom/SimpleGeometry.js").default>} geometries The geometries being modified.
     * @return {Feature} Vertex feature.
     * @private
     */
    Modify.prototype.createOrUpdateVertexFeature_ = function (coordinates, features, geometries) {
        var vertexFeature = this.vertexFeature_;
        if (!vertexFeature) {
            vertexFeature = new _Feature_js__WEBPACK_IMPORTED_MODULE_4__["default"](new _geom_Point_js__WEBPACK_IMPORTED_MODULE_7__["default"](coordinates));
            this.vertexFeature_ = vertexFeature;
            this.overlay_.getSource().addFeature(vertexFeature);
        }
        else {
            var geometry = vertexFeature.getGeometry();
            geometry.setCoordinates(coordinates);
        }
        vertexFeature.set('features', features);
        vertexFeature.set('geometries', geometries);
        return vertexFeature;
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} and may modify the geometry.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */
    Modify.prototype.handleEvent = function (mapBrowserEvent) {
        if (!mapBrowserEvent.originalEvent) {
            return true;
        }
        this.lastPointerEvent_ = mapBrowserEvent;
        var handled;
        if (!mapBrowserEvent.map.getView().getInteracting() &&
            mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_6__["default"].POINTERMOVE &&
            !this.handlingDownUpSequence) {
            this.handlePointerMove_(mapBrowserEvent);
        }
        if (this.vertexFeature_ && this.deleteCondition_(mapBrowserEvent)) {
            if (mapBrowserEvent.type != _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_6__["default"].SINGLECLICK ||
                !this.ignoreNextSingleClick_) {
                handled = this.removePoint();
            }
            else {
                handled = true;
            }
        }
        if (mapBrowserEvent.type == _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_6__["default"].SINGLECLICK) {
            this.ignoreNextSingleClick_ = false;
        }
        return _super.prototype.handleEvent.call(this, mapBrowserEvent) && !handled;
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} evt Event.
     */
    Modify.prototype.handleDragEvent = function (evt) {
        this.ignoreNextSingleClick_ = false;
        this.willModifyFeatures_(evt, this.dragSegments_);
        var vertex = [
            evt.coordinate[0] + this.delta_[0],
            evt.coordinate[1] + this.delta_[1],
        ];
        var features = [];
        var geometries = [];
        for (var i = 0, ii = this.dragSegments_.length; i < ii; ++i) {
            var dragSegment = this.dragSegments_[i];
            var segmentData = dragSegment[0];
            var feature = segmentData.feature;
            if (features.indexOf(feature) === -1) {
                features.push(feature);
            }
            var geometry = segmentData.geometry;
            if (geometries.indexOf(geometry) === -1) {
                geometries.push(geometry);
            }
            var depth = segmentData.depth;
            var coordinates = void 0;
            var segment = segmentData.segment;
            var index = dragSegment[1];
            while (vertex.length < geometry.getStride()) {
                vertex.push(segment[index][vertex.length]);
            }
            switch (geometry.getType()) {
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POINT:
                    coordinates = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_POINT:
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index] = vertex;
                    segment[0] = vertex;
                    segment[1] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].LINE_STRING:
                    coordinates = geometry.getCoordinates();
                    coordinates[segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_LINE_STRING:
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POLYGON:
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_POLYGON:
                    coordinates = geometry.getCoordinates();
                    coordinates[depth[1]][depth[0]][segmentData.index + index] = vertex;
                    segment[index] = vertex;
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE:
                    segment[0] = vertex;
                    segment[1] = vertex;
                    if (segmentData.index === CIRCLE_CENTER_INDEX) {
                        this.changingFeature_ = true;
                        geometry.setCenter(vertex);
                        this.changingFeature_ = false;
                    }
                    else {
                        // We're dragging the circle's circumference:
                        this.changingFeature_ = true;
                        var projection = evt.map.getView().getProjection();
                        var radius = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["distance"])(Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(geometry.getCenter(), projection), Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(vertex, projection));
                        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["getUserProjection"])();
                        if (userProjection) {
                            var circleGeometry = geometry
                                .clone()
                                .transform(userProjection, projection);
                            circleGeometry.setRadius(radius);
                            radius = circleGeometry
                                .transform(projection, userProjection)
                                .getRadius();
                        }
                        geometry.setRadius(radius);
                        this.changingFeature_ = false;
                    }
                    break;
                default:
                // pass
            }
            if (coordinates) {
                this.setGeometryCoordinates_(geometry, coordinates);
            }
        }
        this.createOrUpdateVertexFeature_(vertex, features, geometries);
    };
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} evt Event.
     * @return {boolean} If the event was consumed.
     */
    Modify.prototype.handleDownEvent = function (evt) {
        if (!this.condition_(evt)) {
            return false;
        }
        var pixelCoordinate = evt.coordinate;
        this.handlePointerAtPixel_(evt.pixel, evt.map, pixelCoordinate);
        this.dragSegments_.length = 0;
        this.featuresBeingModified_ = null;
        var vertexFeature = this.vertexFeature_;
        if (vertexFeature) {
            var projection = evt.map.getView().getProjection();
            var insertVertices = [];
            var vertex = vertexFeature.getGeometry().getCoordinates();
            var vertexExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])([vertex]);
            var segmentDataMatches = this.rBush_.getInExtent(vertexExtent);
            var componentSegments = {};
            segmentDataMatches.sort(compareIndexes);
            for (var i = 0, ii = segmentDataMatches.length; i < ii; ++i) {
                var segmentDataMatch = segmentDataMatches[i];
                var segment = segmentDataMatch.segment;
                var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(segmentDataMatch.geometry);
                var depth = segmentDataMatch.depth;
                if (depth) {
                    uid += '-' + depth.join('-'); // separate feature components
                }
                if (!componentSegments[uid]) {
                    componentSegments[uid] = new Array(2);
                }
                if (segmentDataMatch.geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE &&
                    segmentDataMatch.index === CIRCLE_CIRCUMFERENCE_INDEX) {
                    var closestVertex = closestOnSegmentData(pixelCoordinate, segmentDataMatch, projection);
                    if (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(closestVertex, vertex) &&
                        !componentSegments[uid][0]) {
                        this.dragSegments_.push([segmentDataMatch, 0]);
                        componentSegments[uid][0] = segmentDataMatch;
                    }
                    continue;
                }
                if (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(segment[0], vertex) &&
                    !componentSegments[uid][0]) {
                    this.dragSegments_.push([segmentDataMatch, 0]);
                    componentSegments[uid][0] = segmentDataMatch;
                    continue;
                }
                if (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(segment[1], vertex) &&
                    !componentSegments[uid][1]) {
                    // prevent dragging closed linestrings by the connecting node
                    if ((segmentDataMatch.geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].LINE_STRING ||
                        segmentDataMatch.geometry.getType() ===
                            _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_LINE_STRING) &&
                        componentSegments[uid][0] &&
                        componentSegments[uid][0].index === 0) {
                        continue;
                    }
                    this.dragSegments_.push([segmentDataMatch, 1]);
                    componentSegments[uid][1] = segmentDataMatch;
                    continue;
                }
                if (Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(segment) in this.vertexSegments_ &&
                    !componentSegments[uid][0] &&
                    !componentSegments[uid][1] &&
                    this.insertVertexCondition_(evt)) {
                    insertVertices.push(segmentDataMatch);
                }
            }
            if (insertVertices.length) {
                this.willModifyFeatures_(evt, [insertVertices]);
            }
            for (var j = insertVertices.length - 1; j >= 0; --j) {
                this.insertVertex_(insertVertices[j], vertex);
            }
        }
        return !!this.vertexFeature_;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} evt Event.
     * @return {boolean} If the event was consumed.
     */
    Modify.prototype.handleUpEvent = function (evt) {
        for (var i = this.dragSegments_.length - 1; i >= 0; --i) {
            var segmentData = this.dragSegments_[i][0];
            var geometry = segmentData.geometry;
            if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE) {
                // Update a circle object in the R* bush:
                var coordinates = geometry.getCenter();
                var centerSegmentData = segmentData.featureSegments[0];
                var circumferenceSegmentData = segmentData.featureSegments[1];
                centerSegmentData.segment[0] = coordinates;
                centerSegmentData.segment[1] = coordinates;
                circumferenceSegmentData.segment[0] = coordinates;
                circumferenceSegmentData.segment[1] = coordinates;
                this.rBush_.update(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["createOrUpdateFromCoordinate"])(coordinates), centerSegmentData);
                var circleGeometry = geometry;
                var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["getUserProjection"])();
                if (userProjection) {
                    var projection = evt.map.getView().getProjection();
                    circleGeometry = circleGeometry
                        .clone()
                        .transform(userProjection, projection);
                    circleGeometry = Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_18__["fromCircle"])(circleGeometry).transform(projection, userProjection);
                }
                this.rBush_.update(circleGeometry.getExtent(), circumferenceSegmentData);
            }
            else {
                this.rBush_.update(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(segmentData.segment), segmentData);
            }
        }
        if (this.featuresBeingModified_) {
            this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
        }
        return false;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} evt Event.
     * @private
     */
    Modify.prototype.handlePointerMove_ = function (evt) {
        this.lastPixel_ = evt.pixel;
        this.handlePointerAtPixel_(evt.pixel, evt.map, evt.coordinate);
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel
     * @param {import("../PluggableMap.js").default} map Map.
     * @param {import("../coordinate.js").Coordinate} [opt_coordinate] The pixel Coordinate.
     * @private
     */
    Modify.prototype.handlePointerAtPixel_ = function (pixel, map, opt_coordinate) {
        var _this = this;
        var pixelCoordinate = opt_coordinate || map.getCoordinateFromPixel(pixel);
        var projection = map.getView().getProjection();
        var sortByDistance = function (a, b) {
            return (projectedDistanceToSegmentDataSquared(pixelCoordinate, a, projection) -
                projectedDistanceToSegmentDataSquared(pixelCoordinate, b, projection));
        };
        /** @type {Array<SegmentData>|undefined} */
        var nodes;
        var hitPointGeometry;
        if (this.hitDetection_) {
            var layerFilter = typeof this.hitDetection_ === 'object'
                ? function (layer) { return layer === _this.hitDetection_; }
                : undefined;
            map.forEachFeatureAtPixel(pixel, function (feature, layer, geometry) {
                geometry = geometry || feature.getGeometry();
                if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POINT &&
                    Object(_array_js__WEBPACK_IMPORTED_MODULE_17__["includes"])(_this.features_.getArray(), feature)) {
                    hitPointGeometry = geometry;
                    var coordinate = geometry.getFlatCoordinates().slice(0, 2);
                    nodes = [
                        {
                            feature: feature,
                            geometry: geometry,
                            segment: [coordinate, coordinate],
                        },
                    ];
                }
                return true;
            }, { layerFilter: layerFilter });
        }
        if (!nodes) {
            var viewExtent = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserExtent"])(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["createOrUpdateFromCoordinate"])(pixelCoordinate, tempExtent), projection);
            var buffer = map.getView().getResolution() * this.pixelTolerance_;
            var box = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["toUserExtent"])(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["buffer"])(viewExtent, buffer, tempExtent), projection);
            nodes = this.rBush_.getInExtent(box);
        }
        if (nodes && nodes.length > 0) {
            var node = nodes.sort(sortByDistance)[0];
            var closestSegment = node.segment;
            var vertex = closestOnSegmentData(pixelCoordinate, node, projection);
            var vertexPixel = map.getPixelFromCoordinate(vertex);
            var dist = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["distance"])(pixel, vertexPixel);
            if (hitPointGeometry || dist <= this.pixelTolerance_) {
                /** @type {Object<string, boolean>} */
                var vertexSegments = {};
                vertexSegments[Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(closestSegment)] = true;
                if (!this.snapToPointer_) {
                    this.delta_[0] = vertex[0] - pixelCoordinate[0];
                    this.delta_[1] = vertex[1] - pixelCoordinate[1];
                }
                if (node.geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE &&
                    node.index === CIRCLE_CIRCUMFERENCE_INDEX) {
                    this.snappedToVertex_ = true;
                    this.createOrUpdateVertexFeature_(vertex, [node.feature], [node.geometry]);
                }
                else {
                    var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    var squaredDist1 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["squaredDistance"])(vertexPixel, pixel1);
                    var squaredDist2 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["squaredDistance"])(vertexPixel, pixel2);
                    dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    this.snappedToVertex_ = dist <= this.pixelTolerance_;
                    if (this.snappedToVertex_) {
                        vertex =
                            squaredDist1 > squaredDist2
                                ? closestSegment[1]
                                : closestSegment[0];
                    }
                    this.createOrUpdateVertexFeature_(vertex, [node.feature], [node.geometry]);
                    var geometries = {};
                    geometries[Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(node.geometry)] = true;
                    for (var i = 1, ii = nodes.length; i < ii; ++i) {
                        var segment = nodes[i].segment;
                        if ((Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(closestSegment[0], segment[0]) &&
                            Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(closestSegment[1], segment[1])) ||
                            (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(closestSegment[0], segment[1]) &&
                                Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["equals"])(closestSegment[1], segment[0]))) {
                            var geometryUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(nodes[i].geometry);
                            if (!(geometryUid in geometries)) {
                                geometries[geometryUid] = true;
                                vertexSegments[Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(segment)] = true;
                            }
                        }
                        else {
                            break;
                        }
                    }
                }
                this.vertexSegments_ = vertexSegments;
                return;
            }
        }
        if (this.vertexFeature_) {
            this.overlay_.getSource().removeFeature(this.vertexFeature_);
            this.vertexFeature_ = null;
        }
    };
    /**
     * @param {SegmentData} segmentData Segment data.
     * @param {import("../coordinate.js").Coordinate} vertex Vertex.
     * @private
     */
    Modify.prototype.insertVertex_ = function (segmentData, vertex) {
        var segment = segmentData.segment;
        var feature = segmentData.feature;
        var geometry = segmentData.geometry;
        var depth = segmentData.depth;
        var index = segmentData.index;
        var coordinates;
        while (vertex.length < geometry.getStride()) {
            vertex.push(0);
        }
        switch (geometry.getType()) {
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_LINE_STRING:
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POLYGON:
                coordinates = geometry.getCoordinates();
                coordinates[depth[0]].splice(index + 1, 0, vertex);
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_POLYGON:
                coordinates = geometry.getCoordinates();
                coordinates[depth[1]][depth[0]].splice(index + 1, 0, vertex);
                break;
            case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].LINE_STRING:
                coordinates = geometry.getCoordinates();
                coordinates.splice(index + 1, 0, vertex);
                break;
            default:
                return;
        }
        this.setGeometryCoordinates_(geometry, coordinates);
        var rTree = this.rBush_;
        rTree.remove(segmentData);
        this.updateSegmentIndices_(geometry, index, depth, 1);
        /** @type {SegmentData} */
        var newSegmentData = {
            segment: [segment[0], vertex],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index,
        };
        rTree.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(newSegmentData.segment), newSegmentData);
        this.dragSegments_.push([newSegmentData, 1]);
        /** @type {SegmentData} */
        var newSegmentData2 = {
            segment: [vertex, segment[1]],
            feature: feature,
            geometry: geometry,
            depth: depth,
            index: index + 1,
        };
        rTree.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(newSegmentData2.segment), newSegmentData2);
        this.dragSegments_.push([newSegmentData2, 0]);
        this.ignoreNextSingleClick_ = true;
    };
    /**
     * Removes the vertex currently being pointed.
     * @return {boolean} True when a vertex was removed.
     * @api
     */
    Modify.prototype.removePoint = function () {
        if (this.lastPointerEvent_ &&
            this.lastPointerEvent_.type != _MapBrowserEventType_js__WEBPACK_IMPORTED_MODULE_6__["default"].POINTERDRAG) {
            var evt = this.lastPointerEvent_;
            this.willModifyFeatures_(evt, this.dragSegments_);
            var removed = this.removeVertex_();
            this.dispatchEvent(new ModifyEvent(ModifyEventType.MODIFYEND, this.featuresBeingModified_, evt));
            this.featuresBeingModified_ = null;
            return removed;
        }
        return false;
    };
    /**
     * Removes a vertex from all matching features.
     * @return {boolean} True when a vertex was removed.
     * @private
     */
    Modify.prototype.removeVertex_ = function () {
        var dragSegments = this.dragSegments_;
        var segmentsByFeature = {};
        var deleted = false;
        var component, coordinates, dragSegment, geometry, i, index, left;
        var newIndex, right, segmentData, uid;
        for (i = dragSegments.length - 1; i >= 0; --i) {
            dragSegment = dragSegments[i];
            segmentData = dragSegment[0];
            uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_20__["getUid"])(segmentData.feature);
            if (segmentData.depth) {
                // separate feature components
                uid += '-' + segmentData.depth.join('-');
            }
            if (!(uid in segmentsByFeature)) {
                segmentsByFeature[uid] = {};
            }
            if (dragSegment[1] === 0) {
                segmentsByFeature[uid].right = segmentData;
                segmentsByFeature[uid].index = segmentData.index;
            }
            else if (dragSegment[1] == 1) {
                segmentsByFeature[uid].left = segmentData;
                segmentsByFeature[uid].index = segmentData.index + 1;
            }
        }
        for (uid in segmentsByFeature) {
            right = segmentsByFeature[uid].right;
            left = segmentsByFeature[uid].left;
            index = segmentsByFeature[uid].index;
            newIndex = index - 1;
            if (left !== undefined) {
                segmentData = left;
            }
            else {
                segmentData = right;
            }
            if (newIndex < 0) {
                newIndex = 0;
            }
            geometry = segmentData.geometry;
            coordinates = geometry.getCoordinates();
            component = coordinates;
            deleted = false;
            switch (geometry.getType()) {
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_LINE_STRING:
                    if (coordinates[segmentData.depth[0]].length > 2) {
                        coordinates[segmentData.depth[0]].splice(index, 1);
                        deleted = true;
                    }
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].LINE_STRING:
                    if (coordinates.length > 2) {
                        coordinates.splice(index, 1);
                        deleted = true;
                    }
                    break;
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].MULTI_POLYGON:
                    component = component[segmentData.depth[1]];
                /* falls through */
                case _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POLYGON:
                    component = component[segmentData.depth[0]];
                    if (component.length > 4) {
                        if (index == component.length - 1) {
                            index = 0;
                        }
                        component.splice(index, 1);
                        deleted = true;
                        if (index === 0) {
                            // close the ring again
                            component.pop();
                            component.push(component[0]);
                            newIndex = component.length - 1;
                        }
                    }
                    break;
                default:
                // pass
            }
            if (deleted) {
                this.setGeometryCoordinates_(geometry, coordinates);
                var segments = [];
                if (left !== undefined) {
                    this.rBush_.remove(left);
                    segments.push(left.segment[0]);
                }
                if (right !== undefined) {
                    this.rBush_.remove(right);
                    segments.push(right.segment[1]);
                }
                if (left !== undefined && right !== undefined) {
                    /** @type {SegmentData} */
                    var newSegmentData = {
                        depth: segmentData.depth,
                        feature: segmentData.feature,
                        geometry: segmentData.geometry,
                        index: newIndex,
                        segment: segments,
                    };
                    this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_14__["boundingExtent"])(newSegmentData.segment), newSegmentData);
                }
                this.updateSegmentIndices_(geometry, index, segmentData.depth, -1);
                if (this.vertexFeature_) {
                    this.overlay_.getSource().removeFeature(this.vertexFeature_);
                    this.vertexFeature_ = null;
                }
                dragSegments.length = 0;
            }
        }
        return deleted;
    };
    /**
     * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {Array} coordinates Coordinates.
     * @private
     */
    Modify.prototype.setGeometryCoordinates_ = function (geometry, coordinates) {
        this.changingFeature_ = true;
        geometry.setCoordinates(coordinates);
        this.changingFeature_ = false;
    };
    /**
     * @param {import("../geom/SimpleGeometry.js").default} geometry Geometry.
     * @param {number} index Index.
     * @param {Array<number>|undefined} depth Depth.
     * @param {number} delta Delta (1 or -1).
     * @private
     */
    Modify.prototype.updateSegmentIndices_ = function (geometry, index, depth, delta) {
        this.rBush_.forEachInExtent(geometry.getExtent(), function (segmentDataMatch) {
            if (segmentDataMatch.geometry === geometry &&
                (depth === undefined ||
                    segmentDataMatch.depth === undefined ||
                    Object(_array_js__WEBPACK_IMPORTED_MODULE_17__["equals"])(segmentDataMatch.depth, depth)) &&
                segmentDataMatch.index > index) {
                segmentDataMatch.index += delta;
            }
        });
    };
    return Modify;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_8__["default"]));
/**
 * @param {SegmentData} a The first segment data.
 * @param {SegmentData} b The second segment data.
 * @return {number} The difference in indexes.
 */
function compareIndexes(a, b) {
    return a.index - b.index;
}
/**
 * Returns the distance from a point to a line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The coordinates of the point from
 *        which to calculate the distance.
 * @param {SegmentData} segmentData The object describing the line
 *        segment we are calculating the distance to.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {number} The square of the distance between a point and a line segment.
 */
function projectedDistanceToSegmentDataSquared(pointCoordinates, segmentData, projection) {
    var geometry = segmentData.geometry;
    if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE) {
        var circleGeometry = /** @type {import("../geom/Circle.js").default} */ (geometry);
        if (segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
            var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["getUserProjection"])();
            if (userProjection) {
                circleGeometry = /** @type {import("../geom/Circle.js").default} */ (circleGeometry.clone().transform(userProjection, projection));
            }
            var distanceToCenterSquared = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["squaredDistance"])(circleGeometry.getCenter(), Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(pointCoordinates, projection));
            var distanceToCircumference = Math.sqrt(distanceToCenterSquared) - circleGeometry.getRadius();
            return distanceToCircumference * distanceToCircumference;
        }
    }
    var coordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(pointCoordinates, projection);
    tempSegment[0] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(segmentData.segment[0], projection);
    tempSegment[1] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(segmentData.segment[1], projection);
    return Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["squaredDistanceToSegment"])(coordinate, tempSegment);
}
/**
 * Returns the point closest to a given line segment.
 *
 * @param {import("../coordinate.js").Coordinate} pointCoordinates The point to which a closest point
 *        should be found.
 * @param {SegmentData} segmentData The object describing the line
 *        segment which should contain the closest point.
 * @param {import("../proj/Projection.js").default} projection The view projection.
 * @return {import("../coordinate.js").Coordinate} The point closest to the specified line segment.
 */
function closestOnSegmentData(pointCoordinates, segmentData, projection) {
    var geometry = segmentData.geometry;
    if (geometry.getType() === _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].CIRCLE &&
        segmentData.index === CIRCLE_CIRCUMFERENCE_INDEX) {
        var circleGeometry = /** @type {import("../geom/Circle.js").default} */ (geometry);
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["getUserProjection"])();
        if (userProjection) {
            circleGeometry = /** @type {import("../geom/Circle.js").default} */ (circleGeometry.clone().transform(userProjection, projection));
        }
        return Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["toUserCoordinate"])(circleGeometry.getClosestPoint(Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(pointCoordinates, projection)), projection);
    }
    var coordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(pointCoordinates, projection);
    tempSegment[0] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(segmentData.segment[0], projection);
    tempSegment[1] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["fromUserCoordinate"])(segmentData.segment[1], projection);
    return Object(_proj_js__WEBPACK_IMPORTED_MODULE_19__["toUserCoordinate"])(Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_15__["closestOnSegment"])(coordinate, tempSegment), projection);
}
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */
function getDefaultStyleFunction() {
    var style = Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_16__["createEditingStyle"])();
    return function (feature, resolution) {
        return style[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_5__["default"].POINT];
    };
}
/* harmony default export */ __webpack_exports__["default"] = (Modify);
//# sourceMappingURL=Modify.js.map

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SelectEvent", function() { return SelectEvent; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(107);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23);
/* harmony import */ var _Interaction_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(268);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(65);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(272);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Select
 */











/**
 * @enum {string}
 */
var SelectEventType = {
    /**
     * Triggered when feature(s) has been (de)selected.
     * @event SelectEvent#select
     * @api
     */
    SELECT: 'select',
};
/**
 * A function that takes an {@link module:ol/Feature} or
 * {@link module:ol/render/Feature} and an
 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default):boolean} FilterFunction
 */
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [addCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is the event
 * for the selected features as a whole. By default, this is
 * {@link module:ol/events/condition.singleClick}. Clicking on a feature selects that
 * feature and removes any that were in the selection. Clicking outside any
 * feature removes all from the selection.
 * See `toggle`, `add`, `remove` options for adding/removing extra features to/
 * from the selection.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default): boolean} [layers]
 * A list of layers from which features should be selected. Alternatively, a
 * filter function can be provided. The function will be called for each layer
 * in the map and should return `true` for layers that you want to be
 * selectable. If the option is absent, all visible layers will be considered
 * selectable.
 * @property {import("../style/Style.js").StyleLike|null} [style]
 * Style for the selected features. By default the default edit style is used
 * (see {@link module:ol/style}). Set to `null` if this interaction should not apply
 * any style changes for selected features.
 * If set to a falsey value, the selected feature's style will not change.
 * @property {import("../events/condition.js").Condition} [removeCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * By default, this is {@link module:ol/events/condition.never}. Use this if you
 * want to use different events for add and remove instead of `toggle`.
 * @property {import("../events/condition.js").Condition} [toggleCondition] A function
 * that takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled. This is in addition
 * to the `condition` event. By default,
 * {@link module:ol/events/condition.shiftKeyOnly}, i.e. pressing `shift` as
 * well as the `condition` event, adds that feature to the current selection if
 * it is not currently selected, and removes it if it is. See `add` and `remove`
 * if you want to use different events instead of a toggle.
 * @property {boolean} [multi=false] A boolean that determines if the default
 * behaviour should select only single features or all (overlapping) features at
 * the clicked map position. The default of `false` means single select.
 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features]
 * Collection where the interaction will place selected features. Optional. If
 * not set the interaction will create a collection. In any case the collection
 * used by the interaction is returned by
 * {@link module:ol/interaction/Select~Select#getFeatures}.
 * @property {FilterFunction} [filter] A function
 * that takes an {@link module:ol/Feature} and an
 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
 * selected or `false` otherwise.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside
 * the radius around the given position will be checked for features.
 */
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Select~Select} instances are instances of
 * this type.
 */
var SelectEvent = /** @class */ (function (_super) {
    __extends(SelectEvent, _super);
    /**
     * @param {SelectEventType} type The event type.
     * @param {Array<import("../Feature.js").default>} selected Selected features.
     * @param {Array<import("../Feature.js").default>} deselected Deselected features.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Associated
     *     {@link module:ol/MapBrowserEvent}.
     */
    function SelectEvent(type, selected, deselected, mapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * Selected features array.
         * @type {Array<import("../Feature.js").default>}
         * @api
         */
        _this.selected = selected;
        /**
         * Deselected features array.
         * @type {Array<import("../Feature.js").default>}
         * @api
         */
        _this.deselected = deselected;
        /**
         * Associated {@link module:ol/MapBrowserEvent}.
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */
        _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return SelectEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_2__["default"]));

/**
 * Original feature styles to reset to when features are no longer selected.
 * @type {Object<number, import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction>}
 */
var originalFeatureStyles = {};
/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'select', SelectEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'select', Return>} SelectOnSignature
 */
/**
 * @classdesc
 * Interaction for selecting vector features. By default, selected features are
 * styled differently, so this interaction can be used for visual highlighting,
 * as well as selecting features for other actions, such as modification or
 * output. There are three ways of controlling which features are selected:
 * using the browser event as defined by the `condition` and optionally the
 * `toggle`, `add`/`remove`, and `multi` options; a `layers` filter; and a
 * further feature filter using the `filter` option.
 *
 * Selected features are added to an internal unmanaged layer.
 *
 * @fires SelectEvent
 * @api
 */
var Select = /** @class */ (function (_super) {
    __extends(Select, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Select(opt_options) {
        var _this = _super.call(this) || this;
        /***
         * @type {SelectOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {SelectOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {SelectOnSignature<void>}
         */
        _this.un;
        var options = opt_options ? opt_options : {};
        /**
         * @private
         */
        _this.boundAddFeature_ = _this.addFeature_.bind(_this);
        /**
         * @private
         */
        _this.boundRemoveFeature_ = _this.removeFeature_.bind(_this);
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_10__["singleClick"];
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.addCondition_ = options.addCondition ? options.addCondition : _events_condition_js__WEBPACK_IMPORTED_MODULE_10__["never"];
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.removeCondition_ = options.removeCondition
            ? options.removeCondition
            : _events_condition_js__WEBPACK_IMPORTED_MODULE_10__["never"];
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.toggleCondition_ = options.toggleCondition
            ? options.toggleCondition
            : _events_condition_js__WEBPACK_IMPORTED_MODULE_10__["shiftKeyOnly"];
        /**
         * @private
         * @type {boolean}
         */
        _this.multi_ = options.multi ? options.multi : false;
        /**
         * @private
         * @type {FilterFunction}
         */
        _this.filter_ = options.filter ? options.filter : _functions_js__WEBPACK_IMPORTED_MODULE_5__["TRUE"];
        /**
         * @private
         * @type {number}
         */
        _this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
         * @private
         * @type {import("../style/Style.js").default|Array<import("../style/Style.js").default>|import("../style/Style.js").StyleFunction|null}
         */
        _this.style_ =
            options.style !== undefined ? options.style : getDefaultStyleFunction();
        /**
         * @private
         * @type {import("../Collection.js").default}
         */
        _this.features_ = options.features || new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
        /** @type {function(import("../layer/Layer.js").default): boolean} */
        var layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') {
                layerFilter = options.layers;
            }
            else {
                var layers_1 = options.layers;
                layerFilter = function (layer) {
                    return Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["includes"])(layers_1, layer);
                };
            }
        }
        else {
            layerFilter = _functions_js__WEBPACK_IMPORTED_MODULE_5__["TRUE"];
        }
        /**
         * @private
         * @type {function(import("../layer/Layer.js").default): boolean}
         */
        _this.layerFilter_ = layerFilter;
        /**
         * An association between selected feature (key)
         * and layer (value)
         * @private
         * @type {Object<string, import("../layer/Layer.js").default>}
         */
        _this.featureLayerAssociation_ = {};
        return _this;
    }
    /**
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @param {import("../layer/Layer.js").default} layer Layer.
     * @private
     */
    Select.prototype.addFeatureLayerAssociation_ = function (feature, layer) {
        this.featureLayerAssociation_[Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(feature)] = layer;
    };
    /**
     * Get the selected features.
     * @return {import("../Collection.js").default<import("../Feature.js").default>} Features collection.
     * @api
     */
    Select.prototype.getFeatures = function () {
        return this.features_;
    };
    /**
     * Returns the Hit-detection tolerance.
     * @return {number} Hit tolerance in pixels.
     * @api
     */
    Select.prototype.getHitTolerance = function () {
        return this.hitTolerance_;
    };
    /**
     * Returns the associated {@link module:ol/layer/Vector~Vector vectorlayer} of
     * the (last) selected feature. Note that this will not work with any
     * programmatic method like pushing features to
     * {@link module:ol/interaction/Select~Select#getFeatures collection}.
     * @param {import("../Feature.js").FeatureLike} feature Feature
     * @return {import('../layer/Vector.js').default} Layer.
     * @api
     */
    Select.prototype.getLayer = function (feature) {
        return /** @type {import('../layer/Vector.js').default} */ (this.featureLayerAssociation_[Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(feature)]);
    };
    /**
     * Hit-detection tolerance. Pixels inside the radius around the given position
     * will be checked for features.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @api
     */
    Select.prototype.setHitTolerance = function (hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    };
    /**
     * Remove the interaction from its current map, if any,  and attach it to a new
     * map, if any. Pass `null` to just remove the interaction from the current map.
     * @param {import("../PluggableMap.js").default} map Map.
     * @api
     */
    Select.prototype.setMap = function (map) {
        var currentMap = this.getMap();
        if (currentMap && this.style_) {
            this.features_.forEach(this.restorePreviousStyle_.bind(this));
        }
        _super.prototype.setMap.call(this, map);
        if (map) {
            this.features_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ADD, this.boundAddFeature_);
            this.features_.addEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].REMOVE, this.boundRemoveFeature_);
            if (this.style_) {
                this.features_.forEach(this.applySelectedStyle_.bind(this));
            }
        }
        else {
            this.features_.removeEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ADD, this.boundAddFeature_);
            this.features_.removeEventListener(_CollectionEventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].REMOVE, this.boundRemoveFeature_);
        }
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Select.prototype.addFeature_ = function (evt) {
        var feature = evt.element;
        if (this.style_) {
            this.applySelectedStyle_(feature);
        }
    };
    /**
     * @param {import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Select.prototype.removeFeature_ = function (evt) {
        var feature = evt.element;
        if (this.style_) {
            this.restorePreviousStyle_(feature);
        }
    };
    /**
     * @return {import("../style/Style.js").StyleLike|null} Select style.
     */
    Select.prototype.getStyle = function () {
        return this.style_;
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @private
     */
    Select.prototype.applySelectedStyle_ = function (feature) {
        var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(feature);
        if (!(key in originalFeatureStyles)) {
            originalFeatureStyles[key] = feature.getStyle();
        }
        feature.setStyle(this.style_);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @private
     */
    Select.prototype.restorePreviousStyle_ = function (feature) {
        var interactions = this.getMap().getInteractions().getArray();
        for (var i = interactions.length - 1; i >= 0; --i) {
            var interaction = interactions[i];
            if (interaction !== this &&
                interaction instanceof Select &&
                interaction.getStyle() &&
                interaction.getFeatures().getArray().lastIndexOf(feature) !== -1) {
                feature.setStyle(interaction.getStyle());
                return;
            }
        }
        var key = Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(feature);
        feature.setStyle(originalFeatureStyles[key]);
        delete originalFeatureStyles[key];
    };
    /**
     * @param {import("../Feature.js").FeatureLike} feature Feature.
     * @private
     */
    Select.prototype.removeFeatureLayerAssociation_ = function (feature) {
        delete this.featureLayerAssociation_[Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getUid"])(feature)];
    };
    /**
     * Handles the {@link module:ol/MapBrowserEvent map browser event} and may change the
     * selected state of features.
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     * @return {boolean} `false` to stop event propagation.
     * @this {Select}
     */
    Select.prototype.handleEvent = function (mapBrowserEvent) {
        if (!this.condition_(mapBrowserEvent)) {
            return true;
        }
        var add = this.addCondition_(mapBrowserEvent);
        var remove = this.removeCondition_(mapBrowserEvent);
        var toggle = this.toggleCondition_(mapBrowserEvent);
        var set = !add && !remove && !toggle;
        var map = mapBrowserEvent.map;
        var features = this.getFeatures();
        var deselected = [];
        var selected = [];
        if (set) {
            // Replace the currently selected feature(s) with the feature(s) at the
            // pixel, or clear the selected feature(s) if there is no feature at
            // the pixel.
            Object(_obj_js__WEBPACK_IMPORTED_MODULE_6__["clear"])(this.featureLayerAssociation_);
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, 
            /**
             * @param {import("../Feature.js").FeatureLike} feature Feature.
             * @param {import("../layer/Layer.js").default} layer Layer.
             * @return {boolean|undefined} Continue to iterate over the features.
             */
            function (feature, layer) {
                if (this.filter_(feature, layer)) {
                    selected.push(feature);
                    this.addFeatureLayerAssociation_(feature, layer);
                    return !this.multi_;
                }
            }.bind(this), {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_,
            });
            for (var i = features.getLength() - 1; i >= 0; --i) {
                var feature = features.item(i);
                var index = selected.indexOf(feature);
                if (index > -1) {
                    // feature is already selected
                    selected.splice(index, 1);
                }
                else {
                    features.remove(feature);
                    deselected.push(feature);
                }
            }
            if (selected.length !== 0) {
                features.extend(selected);
            }
        }
        else {
            // Modify the currently selected feature(s).
            map.forEachFeatureAtPixel(mapBrowserEvent.pixel, 
            /**
             * @param {import("../Feature.js").FeatureLike} feature Feature.
             * @param {import("../layer/Layer.js").default} layer Layer.
             * @return {boolean|undefined} Continue to iterate over the features.
             */
            function (feature, layer) {
                if (this.filter_(feature, layer)) {
                    if ((add || toggle) && !Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["includes"])(features.getArray(), feature)) {
                        selected.push(feature);
                        this.addFeatureLayerAssociation_(feature, layer);
                    }
                    else if ((remove || toggle) &&
                        Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["includes"])(features.getArray(), feature)) {
                        deselected.push(feature);
                        this.removeFeatureLayerAssociation_(feature);
                    }
                    return !this.multi_;
                }
            }.bind(this), {
                layerFilter: this.layerFilter_,
                hitTolerance: this.hitTolerance_,
            });
            for (var j = deselected.length - 1; j >= 0; --j) {
                features.remove(deselected[j]);
            }
            features.extend(selected);
        }
        if (selected.length > 0 || deselected.length > 0) {
            this.dispatchEvent(new SelectEvent(SelectEventType.SELECT, selected, deselected, mapBrowserEvent));
        }
        return true;
    };
    return Select;
}(_Interaction_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/**
 * @return {import("../style/Style.js").StyleFunction} Styles.
 */
function getDefaultStyleFunction() {
    var styles = Object(_style_Style_js__WEBPACK_IMPORTED_MODULE_7__["createEditingStyle"])();
    Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].POLYGON], styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].LINE_STRING]);
    Object(_array_js__WEBPACK_IMPORTED_MODULE_8__["extend"])(styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].GEOMETRY_COLLECTION], styles[_geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_3__["default"].LINE_STRING]);
    return function (feature) {
        if (!feature.getGeometry()) {
            return null;
        }
        return styles[feature.getGeometry().getType()];
    };
}
/* harmony default export */ __webpack_exports__["default"] = (Select);
//# sourceMappingURL=Select.js.map

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(107);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(271);
/* harmony import */ var _structs_RBush_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(108);
/* harmony import */ var _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(110);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24);
/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(21);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(15);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Snap
 */














/**
 * @typedef {Object} Result
 * @property {boolean} snapped Snapped.
 * @property {import("../coordinate.js").Coordinate|null} vertex Vertex.
 * @property {import("../pixel.js").Pixel|null} vertexPixel VertexPixel.
 */
/**
 * @typedef {Object} SegmentData
 * @property {import("../Feature.js").default} feature Feature.
 * @property {Array<import("../coordinate.js").Coordinate>} segment Segment.
 */
/**
 * @typedef {Object} Options
 * @property {import("../Collection.js").default<import("../Feature.js").default>} [features] Snap to these features. Either this option or source should be provided.
 * @property {boolean} [edge=true] Snap to edges.
 * @property {boolean} [vertex=true] Snap to vertices.
 * @property {number} [pixelTolerance=10] Pixel tolerance for considering the pointer close enough to a segment or
 * vertex for snapping.
 * @property {import("../source/Vector.js").default} [source] Snap to features from this source. Either this option or features should be provided
 */
/**
 * @param  {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
 * @return {import("../Feature.js").default} Feature.
 */
function getFeatureFromEvent(evt) {
    if (
    /** @type {import("../source/Vector.js").VectorSourceEvent} */ (evt).feature) {
        return /** @type {import("../source/Vector.js").VectorSourceEvent} */ (evt)
            .feature;
    }
    else if (
    /** @type {import("../Collection.js").CollectionEvent} */ (evt).element) {
        return /** @type {import("../Feature.js").default} */ (
        /** @type {import("../Collection.js").CollectionEvent} */ (evt).element);
    }
}
var tempSegment = [];
/**
 * @classdesc
 * Handles snapping of vector features while modifying or drawing them.  The
 * features can come from a {@link module:ol/source/Vector} or {@link module:ol/Collection~Collection}
 * Any interaction object that allows the user to interact
 * with the features using the mouse can benefit from the snapping, as long
 * as it is added before.
 *
 * The snap interaction modifies map browser event `coordinate` and `pixel`
 * properties to force the snap to occur to any interaction that them.
 *
 * Example:
 *
 *     import Snap from 'ol/interaction/Snap';
 *
 *     const snap = new Snap({
 *       source: source
 *     });
 *
 *     map.addInteraction(snap);
 *
 * @api
 */
var Snap = /** @class */ (function (_super) {
    __extends(Snap, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Snap(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var pointerOptions = /** @type {import("./Pointer.js").Options} */ (options);
        if (!pointerOptions.handleDownEvent) {
            pointerOptions.handleDownEvent = _functions_js__WEBPACK_IMPORTED_MODULE_6__["TRUE"];
        }
        if (!pointerOptions.stopDown) {
            pointerOptions.stopDown = _functions_js__WEBPACK_IMPORTED_MODULE_6__["FALSE"];
        }
        _this = _super.call(this, pointerOptions) || this;
        /**
         * @type {import("../source/Vector.js").default}
         * @private
         */
        _this.source_ = options.source ? options.source : null;
        /**
         * @private
         * @type {boolean}
         */
        _this.vertex_ = options.vertex !== undefined ? options.vertex : true;
        /**
         * @private
         * @type {boolean}
         */
        _this.edge_ = options.edge !== undefined ? options.edge : true;
        /**
         * @type {import("../Collection.js").default<import("../Feature.js").default>}
         * @private
         */
        _this.features_ = options.features ? options.features : null;
        /**
         * @type {Array<import("../events.js").EventsKey>}
         * @private
         */
        _this.featuresListenerKeys_ = [];
        /**
         * @type {Object<string, import("../events.js").EventsKey>}
         * @private
         */
        _this.featureChangeListenerKeys_ = {};
        /**
         * Extents are preserved so indexed segment can be quickly removed
         * when its feature geometry changes
         * @type {Object<string, import("../extent.js").Extent>}
         * @private
         */
        _this.indexedFeaturesExtents_ = {};
        /**
         * If a feature geometry changes while a pointer drag|move event occurs, the
         * feature doesn't get updated right away.  It will be at the next 'pointerup'
         * event fired.
         * @type {!Object<string, import("../Feature.js").default>}
         * @private
         */
        _this.pendingFeatures_ = {};
        /**
         * @type {number}
         * @private
         */
        _this.pixelTolerance_ =
            options.pixelTolerance !== undefined ? options.pixelTolerance : 10;
        /**
         * Segment RTree for each layer
         * @type {import("../structs/RBush.js").default<SegmentData>}
         * @private
         */
        _this.rBush_ = new _structs_RBush_js__WEBPACK_IMPORTED_MODULE_4__["default"]();
        /**
         * @const
         * @private
         * @type {Object<string, function(import("../Feature.js").default, import("../geom/Geometry.js").default): void>}
         */
        _this.SEGMENT_WRITERS_ = {
            'Point': _this.writePointGeometry_.bind(_this),
            'LineString': _this.writeLineStringGeometry_.bind(_this),
            'LinearRing': _this.writeLineStringGeometry_.bind(_this),
            'Polygon': _this.writePolygonGeometry_.bind(_this),
            'MultiPoint': _this.writeMultiPointGeometry_.bind(_this),
            'MultiLineString': _this.writeMultiLineStringGeometry_.bind(_this),
            'MultiPolygon': _this.writeMultiPolygonGeometry_.bind(_this),
            'GeometryCollection': _this.writeGeometryCollectionGeometry_.bind(_this),
            'Circle': _this.writeCircleGeometry_.bind(_this),
        };
        return _this;
    }
    /**
     * Add a feature to the collection of features that we may snap to.
     * @param {import("../Feature.js").default} feature Feature.
     * @param {boolean} [opt_listen] Whether to listen to the feature change or not
     *     Defaults to `true`.
     * @api
     */
    Snap.prototype.addFeature = function (feature, opt_listen) {
        var register = opt_listen !== undefined ? opt_listen : true;
        var feature_uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(feature);
        var geometry = feature.getGeometry();
        if (geometry) {
            var segmentWriter = this.SEGMENT_WRITERS_[geometry.getType()];
            if (segmentWriter) {
                this.indexedFeaturesExtents_[feature_uid] = geometry.getExtent(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["createEmpty"])());
                segmentWriter(feature, geometry);
            }
        }
        if (register) {
            this.featureChangeListenerKeys_[feature_uid] = Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(feature, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].CHANGE, this.handleFeatureChange_, this);
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @private
     */
    Snap.prototype.forEachFeatureAdd_ = function (feature) {
        this.addFeature(feature);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature.
     * @private
     */
    Snap.prototype.forEachFeatureRemove_ = function (feature) {
        this.removeFeature(feature);
    };
    /**
     * @return {import("../Collection.js").default<import("../Feature.js").default>|Array<import("../Feature.js").default>} Features.
     * @private
     */
    Snap.prototype.getFeatures_ = function () {
        var features;
        if (this.features_) {
            features = this.features_;
        }
        else if (this.source_) {
            features = this.source_.getFeatures();
        }
        return features;
    };
    /**
     * @param {import("../MapBrowserEvent.js").default} evt Map browser event.
     * @return {boolean} `false` to stop event propagation.
     */
    Snap.prototype.handleEvent = function (evt) {
        var result = this.snapTo(evt.pixel, evt.coordinate, evt.map);
        if (result.snapped) {
            evt.coordinate = result.vertex.slice(0, 2);
            evt.pixel = result.vertexPixel;
        }
        return _super.prototype.handleEvent.call(this, evt);
    };
    /**
     * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Snap.prototype.handleFeatureAdd_ = function (evt) {
        var feature = getFeatureFromEvent(evt);
        this.addFeature(feature);
    };
    /**
     * @param {import("../source/Vector.js").VectorSourceEvent|import("../Collection.js").CollectionEvent} evt Event.
     * @private
     */
    Snap.prototype.handleFeatureRemove_ = function (evt) {
        var feature = getFeatureFromEvent(evt);
        this.removeFeature(feature);
    };
    /**
     * @param {import("../events/Event.js").default} evt Event.
     * @private
     */
    Snap.prototype.handleFeatureChange_ = function (evt) {
        var feature = /** @type {import("../Feature.js").default} */ (evt.target);
        if (this.handlingDownUpSequence) {
            var uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(feature);
            if (!(uid in this.pendingFeatures_)) {
                this.pendingFeatures_[uid] = feature;
            }
        }
        else {
            this.updateFeature_(feature);
        }
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} evt Event.
     * @return {boolean} If the event was consumed.
     */
    Snap.prototype.handleUpEvent = function (evt) {
        var featuresToUpdate = Object(_obj_js__WEBPACK_IMPORTED_MODULE_12__["getValues"])(this.pendingFeatures_);
        if (featuresToUpdate.length) {
            featuresToUpdate.forEach(this.updateFeature_.bind(this));
            this.pendingFeatures_ = {};
        }
        return false;
    };
    /**
     * Remove a feature from the collection of features that we may snap to.
     * @param {import("../Feature.js").default} feature Feature
     * @param {boolean} [opt_unlisten] Whether to unlisten to the feature change
     *     or not. Defaults to `true`.
     * @api
     */
    Snap.prototype.removeFeature = function (feature, opt_unlisten) {
        var unregister = opt_unlisten !== undefined ? opt_unlisten : true;
        var feature_uid = Object(_util_js__WEBPACK_IMPORTED_MODULE_11__["getUid"])(feature);
        var extent = this.indexedFeaturesExtents_[feature_uid];
        if (extent) {
            var rBush = this.rBush_;
            var nodesToRemove_1 = [];
            rBush.forEachInExtent(extent, function (node) {
                if (feature === node.feature) {
                    nodesToRemove_1.push(node);
                }
            });
            for (var i = nodesToRemove_1.length - 1; i >= 0; --i) {
                rBush.remove(nodesToRemove_1[i]);
            }
        }
        if (unregister) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["unlistenByKey"])(this.featureChangeListenerKeys_[feature_uid]);
            delete this.featureChangeListenerKeys_[feature_uid];
        }
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Snap.prototype.setMap = function (map) {
        var currentMap = this.getMap();
        var keys = this.featuresListenerKeys_;
        var features = /** @type {Array<import("../Feature.js").default>} */ (this.getFeatures_());
        if (currentMap) {
            keys.forEach(_events_js__WEBPACK_IMPORTED_MODULE_13__["unlistenByKey"]);
            keys.length = 0;
            features.forEach(this.forEachFeatureRemove_.bind(this));
        }
        _super.prototype.setMap.call(this, map);
        if (map) {
            if (this.features_) {
                keys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(this.features_, _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].ADD, this.handleFeatureAdd_, this), Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(this.features_, _CollectionEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].REMOVE, this.handleFeatureRemove_, this));
            }
            else if (this.source_) {
                keys.push(Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(this.source_, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_5__["default"].ADDFEATURE, this.handleFeatureAdd_, this), Object(_events_js__WEBPACK_IMPORTED_MODULE_13__["listen"])(this.source_, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_5__["default"].REMOVEFEATURE, this.handleFeatureRemove_, this));
            }
            features.forEach(this.forEachFeatureAdd_.bind(this));
        }
    };
    /**
     * @param {import("../pixel.js").Pixel} pixel Pixel
     * @param {import("../coordinate.js").Coordinate} pixelCoordinate Coordinate
     * @param {import("../PluggableMap.js").default} map Map.
     * @return {Result} Snap result
     */
    Snap.prototype.snapTo = function (pixel, pixelCoordinate, map) {
        var lowerLeft = map.getCoordinateFromPixel([
            pixel[0] - this.pixelTolerance_,
            pixel[1] + this.pixelTolerance_,
        ]);
        var upperRight = map.getCoordinateFromPixel([
            pixel[0] + this.pixelTolerance_,
            pixel[1] - this.pixelTolerance_,
        ]);
        var box = Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])([lowerLeft, upperRight]);
        var segments = this.rBush_.getInExtent(box);
        // If snapping on vertices only, don't consider circles
        if (this.vertex_ && !this.edge_) {
            segments = segments.filter(function (segment) {
                return segment.feature.getGeometry().getType() !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CIRCLE;
            });
        }
        var snapped = false;
        var vertex = null;
        var vertexPixel = null;
        if (segments.length === 0) {
            return {
                snapped: snapped,
                vertex: vertex,
                vertexPixel: vertexPixel,
            };
        }
        var projection = map.getView().getProjection();
        var projectedCoordinate = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["fromUserCoordinate"])(pixelCoordinate, projection);
        var closestSegmentData;
        var minSquaredDistance = Infinity;
        for (var i = 0; i < segments.length; ++i) {
            var segmentData = segments[i];
            tempSegment[0] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["fromUserCoordinate"])(segmentData.segment[0], projection);
            tempSegment[1] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["fromUserCoordinate"])(segmentData.segment[1], projection);
            var delta = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["squaredDistanceToSegment"])(projectedCoordinate, tempSegment);
            if (delta < minSquaredDistance) {
                closestSegmentData = segmentData;
                minSquaredDistance = delta;
            }
        }
        var closestSegment = closestSegmentData.segment;
        if (this.vertex_ && !this.edge_) {
            var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
            var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
            var squaredDist1 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["squaredDistance"])(pixel, pixel1);
            var squaredDist2 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["squaredDistance"])(pixel, pixel2);
            var dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
            if (dist <= this.pixelTolerance_) {
                snapped = true;
                vertex =
                    squaredDist1 > squaredDist2 ? closestSegment[1] : closestSegment[0];
                vertexPixel = map.getPixelFromCoordinate(vertex);
            }
        }
        else if (this.edge_) {
            var isCircle = closestSegmentData.feature.getGeometry().getType() ===
                _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CIRCLE;
            if (isCircle) {
                var circleGeometry = closestSegmentData.feature.getGeometry();
                var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["getUserProjection"])();
                if (userProjection) {
                    circleGeometry = circleGeometry
                        .clone()
                        .transform(userProjection, projection);
                }
                vertex = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["toUserCoordinate"])(Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["closestOnCircle"])(projectedCoordinate, 
                /** @type {import("../geom/Circle.js").default} */ (circleGeometry)), projection);
            }
            else {
                tempSegment[0] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["fromUserCoordinate"])(closestSegment[0], projection);
                tempSegment[1] = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["fromUserCoordinate"])(closestSegment[1], projection);
                vertex = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["toUserCoordinate"])(Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["closestOnSegment"])(projectedCoordinate, tempSegment), projection);
            }
            vertexPixel = map.getPixelFromCoordinate(vertex);
            if (Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["distance"])(pixel, vertexPixel) <= this.pixelTolerance_) {
                snapped = true;
                if (this.vertex_ && !isCircle) {
                    var pixel1 = map.getPixelFromCoordinate(closestSegment[0]);
                    var pixel2 = map.getPixelFromCoordinate(closestSegment[1]);
                    var squaredDist1 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["squaredDistance"])(vertexPixel, pixel1);
                    var squaredDist2 = Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_8__["squaredDistance"])(vertexPixel, pixel2);
                    var dist = Math.sqrt(Math.min(squaredDist1, squaredDist2));
                    if (dist <= this.pixelTolerance_) {
                        vertex =
                            squaredDist1 > squaredDist2
                                ? closestSegment[1]
                                : closestSegment[0];
                        vertexPixel = map.getPixelFromCoordinate(vertex);
                    }
                }
            }
        }
        if (snapped) {
            vertexPixel = [Math.round(vertexPixel[0]), Math.round(vertexPixel[1])];
        }
        return {
            snapped: snapped,
            vertex: vertex,
            vertexPixel: vertexPixel,
        };
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @private
     */
    Snap.prototype.updateFeature_ = function (feature) {
        this.removeFeature(feature, false);
        this.addFeature(feature, false);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/Circle.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeCircleGeometry_ = function (feature, geometry) {
        var projection = this.getMap().getView().getProjection();
        var circleGeometry = geometry;
        var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_10__["getUserProjection"])();
        if (userProjection) {
            circleGeometry = /** @type {import("../geom/Circle.js").default} */ (circleGeometry.clone().transform(userProjection, projection));
        }
        var polygon = Object(_geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__["fromCircle"])(circleGeometry);
        if (userProjection) {
            polygon.transform(projection, userProjection);
        }
        var coordinates = polygon.getCoordinates()[0];
        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
            var segment = coordinates.slice(i, i + 2);
            var segmentData = {
                feature: feature,
                segment: segment,
            };
            this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])(segment), segmentData);
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/GeometryCollection.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeGeometryCollectionGeometry_ = function (feature, geometry) {
        var geometries = geometry.getGeometriesArray();
        for (var i = 0; i < geometries.length; ++i) {
            var segmentWriter = this.SEGMENT_WRITERS_[geometries[i].getType()];
            if (segmentWriter) {
                segmentWriter(feature, geometries[i]);
            }
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/LineString.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeLineStringGeometry_ = function (feature, geometry) {
        var coordinates = geometry.getCoordinates();
        for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
            var segment = coordinates.slice(i, i + 2);
            var segmentData = {
                feature: feature,
                segment: segment,
            };
            this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])(segment), segmentData);
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/MultiLineString.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeMultiLineStringGeometry_ = function (feature, geometry) {
        var lines = geometry.getCoordinates();
        for (var j = 0, jj = lines.length; j < jj; ++j) {
            var coordinates = lines[j];
            for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                var segment = coordinates.slice(i, i + 2);
                var segmentData = {
                    feature: feature,
                    segment: segment,
                };
                this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])(segment), segmentData);
            }
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/MultiPoint.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeMultiPointGeometry_ = function (feature, geometry) {
        var points = geometry.getCoordinates();
        for (var i = 0, ii = points.length; i < ii; ++i) {
            var coordinates = points[i];
            var segmentData = {
                feature: feature,
                segment: [coordinates, coordinates],
            };
            this.rBush_.insert(geometry.getExtent(), segmentData);
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/MultiPolygon.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writeMultiPolygonGeometry_ = function (feature, geometry) {
        var polygons = geometry.getCoordinates();
        for (var k = 0, kk = polygons.length; k < kk; ++k) {
            var rings = polygons[k];
            for (var j = 0, jj = rings.length; j < jj; ++j) {
                var coordinates = rings[j];
                for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                    var segment = coordinates.slice(i, i + 2);
                    var segmentData = {
                        feature: feature,
                        segment: segment,
                    };
                    this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])(segment), segmentData);
                }
            }
        }
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/Point.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writePointGeometry_ = function (feature, geometry) {
        var coordinates = geometry.getCoordinates();
        var segmentData = {
            feature: feature,
            segment: [coordinates, coordinates],
        };
        this.rBush_.insert(geometry.getExtent(), segmentData);
    };
    /**
     * @param {import("../Feature.js").default} feature Feature
     * @param {import("../geom/Polygon.js").default} geometry Geometry.
     * @private
     */
    Snap.prototype.writePolygonGeometry_ = function (feature, geometry) {
        var rings = geometry.getCoordinates();
        for (var j = 0, jj = rings.length; j < jj; ++j) {
            var coordinates = rings[j];
            for (var i = 0, ii = coordinates.length - 1; i < ii; ++i) {
                var segment = coordinates.slice(i, i + 2);
                var segmentData = {
                    feature: feature,
                    segment: segment,
                };
                this.rBush_.insert(Object(_extent_js__WEBPACK_IMPORTED_MODULE_7__["boundingExtent"])(segment), segmentData);
            }
        }
    };
    return Snap;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Snap);
//# sourceMappingURL=Snap.js.map

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TranslateEvent", function() { return TranslateEvent; });
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46);
/* harmony import */ var _Property_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(269);
/* harmony import */ var _Pointer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(271);
/* harmony import */ var _functions_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51);
/* harmony import */ var _events_condition_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(272);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/interaction/Translate
 */







/**
 * @enum {string}
 */
var TranslateEventType = {
    /**
     * Triggered upon feature translation start.
     * @event TranslateEvent#translatestart
     * @api
     */
    TRANSLATESTART: 'translatestart',
    /**
     * Triggered upon feature translation.
     * @event TranslateEvent#translating
     * @api
     */
    TRANSLATING: 'translating',
    /**
     * Triggered upon feature translation end.
     * @event TranslateEvent#translateend
     * @api
     */
    TRANSLATEEND: 'translateend',
};
/**
 * A function that takes an {@link module:ol/Feature} or
 * {@link module:ol/render/Feature} and an
 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
 * translated or `false` otherwise.
 * @typedef {function(import("../Feature.js").FeatureLike, import("../layer/Layer.js").default):boolean} FilterFunction
 */
/**
 * @typedef {Object} Options
 * @property {import("../events/condition.js").Condition} [condition] A function that
 * takes an {@link module:ol/MapBrowserEvent~MapBrowserEvent} and returns a
 * boolean to indicate whether that event should be handled.
 * Default is {@link module:ol/events/condition.always}.
 * @property {Collection<import("../Feature.js").default>} [features] Only features contained in this collection will be able to be translated. If
 * not specified, all features on the map will be able to be translated.
 * @property {Array<import("../layer/Layer.js").default>|function(import("../layer/Layer.js").default): boolean} [layers] A list of layers from which features should be
 * translated. Alternatively, a filter function can be provided. The
 * function will be called for each layer in the map and should return
 * `true` for layers that you want to be translatable. If the option is
 * absent, all visible layers will be considered translatable.
 * @property {FilterFunction} [filter] A function
 * that takes an {@link module:ol/Feature} and an
 * {@link module:ol/layer/Layer} and returns `true` if the feature may be
 * translated or `false` otherwise.
 * @property {number} [hitTolerance=0] Hit-detection tolerance. Pixels inside the radius around the given position
 * will be checked for features.
 */
/**
 * @classdesc
 * Events emitted by {@link module:ol/interaction/Translate~Translate} instances
 * are instances of this type.
 */
var TranslateEvent = /** @class */ (function (_super) {
    __extends(TranslateEvent, _super);
    /**
     * @param {TranslateEventType} type Type.
     * @param {Collection<import("../Feature.js").default>} features The features translated.
     * @param {import("../coordinate.js").Coordinate} coordinate The event coordinate.
     * @param {import("../coordinate.js").Coordinate} startCoordinate The original coordinates before.translation started
     * @param {import("../MapBrowserEvent.js").default} mapBrowserEvent Map browser event.
     */
    function TranslateEvent(type, features, coordinate, startCoordinate, mapBrowserEvent) {
        var _this = _super.call(this, type) || this;
        /**
         * The features being translated.
         * @type {Collection<import("../Feature.js").default>}
         * @api
         */
        _this.features = features;
        /**
         * The coordinate of the drag event.
         * @const
         * @type {import("../coordinate.js").Coordinate}
         * @api
         */
        _this.coordinate = coordinate;
        /**
         * The coordinate of the start position before translation started.
         * @const
         * @type {import("../coordinate.js").Coordinate}
         * @api
         */
        _this.startCoordinate = startCoordinate;
        /**
         * Associated {@link module:ol/MapBrowserEvent}.
         * @type {import("../MapBrowserEvent.js").default}
         * @api
         */
        _this.mapBrowserEvent = mapBrowserEvent;
        return _this;
    }
    return TranslateEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_1__["default"]));

/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("../ObjectEventType").Types|
 *     'change:active', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<'translateend'|'translatestart'|'translating', TranslateEvent, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("../ObjectEventType").Types|
 *     'change:active'|'translateend'|'translatestart'|'translating', Return>} TranslateOnSignature
 */
/**
 * @classdesc
 * Interaction for translating (moving) features.
 *
 * @fires TranslateEvent
 * @api
 */
var Translate = /** @class */ (function (_super) {
    __extends(Translate, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Translate(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        _this = _super.call(this, /** @type {import("./Pointer.js").Options} */ (options)) || this;
        /***
         * @type {TranslateOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {TranslateOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {TranslateOnSignature<void>}
         */
        _this.un;
        /**
         * The last position we translated to.
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.lastCoordinate_ = null;
        /**
         * The start position before translation started.
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.startCoordinate_ = null;
        /**
         * @type {Collection<import("../Feature.js").default>}
         * @private
         */
        _this.features_ = options.features !== undefined ? options.features : null;
        /** @type {function(import("../layer/Layer.js").default): boolean} */
        var layerFilter;
        if (options.layers) {
            if (typeof options.layers === 'function') {
                layerFilter = options.layers;
            }
            else {
                var layers_1 = options.layers;
                layerFilter = function (layer) {
                    return Object(_array_js__WEBPACK_IMPORTED_MODULE_6__["includes"])(layers_1, layer);
                };
            }
        }
        else {
            layerFilter = _functions_js__WEBPACK_IMPORTED_MODULE_4__["TRUE"];
        }
        /**
         * @private
         * @type {function(import("../layer/Layer.js").default): boolean}
         */
        _this.layerFilter_ = layerFilter;
        /**
         * @private
         * @type {FilterFunction}
         */
        _this.filter_ = options.filter ? options.filter : _functions_js__WEBPACK_IMPORTED_MODULE_4__["TRUE"];
        /**
         * @private
         * @type {number}
         */
        _this.hitTolerance_ = options.hitTolerance ? options.hitTolerance : 0;
        /**
         * @private
         * @type {import("../events/condition.js").Condition}
         */
        _this.condition_ = options.condition ? options.condition : _events_condition_js__WEBPACK_IMPORTED_MODULE_5__["always"];
        /**
         * @type {import("../Feature.js").default}
         * @private
         */
        _this.lastFeature_ = null;
        _this.addChangeListener(_Property_js__WEBPACK_IMPORTED_MODULE_2__["default"].ACTIVE, _this.handleActiveChanged_);
        return _this;
    }
    /**
     * Handle pointer down events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} If the event was consumed.
     */
    Translate.prototype.handleDownEvent = function (event) {
        if (!event.originalEvent || !this.condition_(event)) {
            return false;
        }
        this.lastFeature_ = this.featuresAtPixel_(event.pixel, event.map);
        if (!this.lastCoordinate_ && this.lastFeature_) {
            this.startCoordinate_ = event.coordinate;
            this.lastCoordinate_ = event.coordinate;
            this.handleMoveEvent(event);
            var features = this.features_ || new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]([this.lastFeature_]);
            this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATESTART, features, event.coordinate, this.startCoordinate_, event));
            return true;
        }
        return false;
    };
    /**
     * Handle pointer up events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     * @return {boolean} If the event was consumed.
     */
    Translate.prototype.handleUpEvent = function (event) {
        if (this.lastCoordinate_) {
            this.lastCoordinate_ = null;
            this.handleMoveEvent(event);
            var features = this.features_ || new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]([this.lastFeature_]);
            this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATEEND, features, event.coordinate, this.startCoordinate_, event));
            // cleanup
            this.startCoordinate_ = null;
            return true;
        }
        return false;
    };
    /**
     * Handle pointer drag events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */
    Translate.prototype.handleDragEvent = function (event) {
        if (this.lastCoordinate_) {
            var newCoordinate = event.coordinate;
            var deltaX_1 = newCoordinate[0] - this.lastCoordinate_[0];
            var deltaY_1 = newCoordinate[1] - this.lastCoordinate_[1];
            var features = this.features_ || new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"]([this.lastFeature_]);
            features.forEach(function (feature) {
                var geom = feature.getGeometry();
                geom.translate(deltaX_1, deltaY_1);
                feature.setGeometry(geom);
            });
            this.lastCoordinate_ = newCoordinate;
            this.dispatchEvent(new TranslateEvent(TranslateEventType.TRANSLATING, features, newCoordinate, this.startCoordinate_, event));
        }
    };
    /**
     * Handle pointer move events.
     * @param {import("../MapBrowserEvent.js").default} event Event.
     */
    Translate.prototype.handleMoveEvent = function (event) {
        var elem = event.map.getViewport();
        // Change the cursor to grab/grabbing if hovering any of the features managed
        // by the interaction
        if (this.featuresAtPixel_(event.pixel, event.map)) {
            elem.classList.remove(this.lastCoordinate_ ? 'ol-grab' : 'ol-grabbing');
            elem.classList.add(this.lastCoordinate_ ? 'ol-grabbing' : 'ol-grab');
        }
        else {
            elem.classList.remove('ol-grab', 'ol-grabbing');
        }
    };
    /**
     * Tests to see if the given coordinates intersects any of our selected
     * features.
     * @param {import("../pixel.js").Pixel} pixel Pixel coordinate to test for intersection.
     * @param {import("../PluggableMap.js").default} map Map to test the intersection on.
     * @return {import("../Feature.js").default} Returns the feature found at the specified pixel
     * coordinates.
     * @private
     */
    Translate.prototype.featuresAtPixel_ = function (pixel, map) {
        return map.forEachFeatureAtPixel(pixel, function (feature, layer) {
            if (this.filter_(feature, layer)) {
                if (!this.features_ || Object(_array_js__WEBPACK_IMPORTED_MODULE_6__["includes"])(this.features_.getArray(), feature)) {
                    return feature;
                }
            }
        }.bind(this), {
            layerFilter: this.layerFilter_,
            hitTolerance: this.hitTolerance_,
        });
    };
    /**
     * Returns the Hit-detection tolerance.
     * @return {number} Hit tolerance in pixels.
     * @api
     */
    Translate.prototype.getHitTolerance = function () {
        return this.hitTolerance_;
    };
    /**
     * Hit-detection tolerance. Pixels inside the radius around the given position
     * will be checked for features.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @api
     */
    Translate.prototype.setHitTolerance = function (hitTolerance) {
        this.hitTolerance_ = hitTolerance;
    };
    /**
     * Remove the interaction from its current map and attach it to the new map.
     * Subclasses may set up event handlers to get notified about changes to
     * the map here.
     * @param {import("../PluggableMap.js").default} map Map.
     */
    Translate.prototype.setMap = function (map) {
        var oldMap = this.getMap();
        _super.prototype.setMap.call(this, map);
        this.updateState_(oldMap);
    };
    /**
     * @private
     */
    Translate.prototype.handleActiveChanged_ = function () {
        this.updateState_(null);
    };
    /**
     * @param {import("../PluggableMap.js").default} oldMap Old map.
     * @private
     */
    Translate.prototype.updateState_ = function (oldMap) {
        var map = this.getMap();
        var active = this.getActive();
        if (!map || !active) {
            map = map || oldMap;
            if (map) {
                var elem = map.getViewport();
                elem.classList.remove('ol-grab', 'ol-grabbing');
            }
        }
    };
    return Translate;
}(_Pointer_js__WEBPACK_IMPORTED_MODULE_3__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Translate);
//# sourceMappingURL=Translate.js.map

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(313);
/* harmony import */ var pcvizMapLayers_MapVectorLayer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(314);
/* harmony import */ var pcvizMapLayers_Map3DScene__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(348);
/* harmony import */ var pcvizMapLayers_MapRasterLayer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(350);







/** @namespace pcvizMapLayers */
const pcvizMapLayers = {};
pcvizMapLayers.Layer = pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_0__["default"];
pcvizMapLayers.VectorLayer = pcvizMapLayers_MapVectorLayer__WEBPACK_IMPORTED_MODULE_1__["default"];
pcvizMapLayers.Map3DScene = pcvizMapLayers_Map3DScene__WEBPACK_IMPORTED_MODULE_2__["default"];
pcvizMapLayers.MapRasterLayer = pcvizMapLayers_MapRasterLayer__WEBPACK_IMPORTED_MODULE_3__["default"];

/* harmony default export */ __webpack_exports__["default"] = (pcvizMapLayers);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapLayer; });
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(Proj4js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_3__);





const Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DB.Registry;
const CRSUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Utils.CRSUtils;

/**
 * Interface for PointCloudVizMap Layers
 * @class
 * @memberof pcvizMapLayers
 */
class MapLayer {
    constructor() {
        this._layer = undefined; // it's used only for vector layers
        this._olLayer = undefined;
        this._layerRenderer = undefined;
        this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( CRSUtils.DEFAULT_PROJECTION );
    }

    /**
     * Returns the OpenLayers layer object
     * @memberof pcvizMapLayers.MapLayer
     * @return {ol.layer} The Openlayers layer object
     */
    getOLLayer() {
        return ( this._olLayer );
    }

    /**
     * Returns the PointCloudViz layer object
     * @memberof pcvizMapLayers.MapLayer
     * @return {Layer} The layer object.
     */
    getLayer() {
        return this._layer;
    }

    /**
     * Returns the layer renderer.
     * @memberof pcvizMapLayers.MapLayer
     * @return {LayerRenderer} The layer renderer.
     */
    getLayerRenderer() {
        return this._layerRenderer;
    }

    /**
     * Sets the layer renderer.
     * @memberof pcvizMapLayers.MapLayer
     * @param {LayerRenderer} layerRenderer The layer renderer.
     */
    setLayerRenderer( layerRenderer ) {
        this._layerRenderer = layerRenderer;
    }

    /**
     * initilizes the projection of the MapLayer
     * @memberof pcvizMapLayers.MapLayer
     * @param {Layer} layer The layer
     */
    initializeProjection( layer ) {
        if ( !layer ) {
            this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( CRSUtils.DEFAULT_PROJECTION );
            return;
        }

        if ( layer.getProjection() && layer.getProj4() ) {
            Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a.defs( layer.getProjection(), layer.getProj4() );
            Object(ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_2__["register"])( Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a );
            this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( layer.getProjection() );
            return;
        }

        // FIXME: Using this for now as a quick workaround but the project projection should
        // be passed down instead of accessing the registry
        let appObject = Registry.getController( 'Application' ).getApplication().getAppObject();
        if ( appObject ) {
            let projection = appObject.getProjection();
            if ( projection ) {
                Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a.defs( projection, appObject.getProj4() );
                Object(ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_2__["register"])( Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a );
                this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( projection );
                return;
            }
        }
        this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( CRSUtils.DEFAULT_PROJECTION );
    }
}


/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapVectorLayer; });
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);
/* harmony import */ var ol_layer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(315);
/* harmony import */ var pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(313);




/**
 * This layers manages point features. They are rendered in the map view.
 * @class
 * @memberof pcvizMapLayers
 * @extends MapLayer
 * @param {string} id         Name of the object type
 * @param {string} category   Category of the object
 * @param {string} projection EPSG projection code
 * @param {object} extConfig  Additional configuration parameters
 */
class MapVectorLayer extends pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_2__["default"] {
    constructor( layer, olProjection, extConfig ) {
        super();

        this._layer = layer;
        this._featureRenderer = undefined;

        if ( layer !== undefined ) {
            this.initializeProjection( layer );
            this._olLayer = new ol_layer__WEBPACK_IMPORTED_MODULE_1__["Vector"]( {
                zIndex: 100,
                projection: olProjection,
                name: layer.getName(),
                id: layer.getId(),
                layer: layer,
                mapVectorLayer: this
            } );
            return;
        }

        var config = {
            source: new ol_source__WEBPACK_IMPORTED_MODULE_0__["Vector"](),
            layer: layer
        };
        for ( var key in extConfig ) {
            config[ key ] = extConfig[ key ];
        }
        this._olLayer = new ol_layer__WEBPACK_IMPORTED_MODULE_1__["Vector"]( config );
    }

    render( layerRenderer, parentNode ) {
        return new Promise( ( resolve, reject ) => {
            if ( this._featureRenderer && this._featureRenderer.getSymbol() )
                this._featureRenderer.getSymbol().configure( this._layer.getStyle() );
            layerRenderer.renderVectorLayer( this._layer, parentNode ).then( () => {
                resolve();
            }, reject );
        } );
    }

    getFeatureRenderer() {
        return this._featureRenderer;
    }

    setFeatureRenderer( featureRenderer ) {
        this._featureRenderer = featureRenderer;
    }

    getProjection() {
        return this._olProjection.getCode();
    }
}


/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _layer_Graticule_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(316);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Graticule", function() { return _layer_Graticule_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _layer_Group_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(174);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Group", function() { return _layer_Group_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _layer_Heatmap_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(319);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Heatmap", function() { return _layer_Heatmap_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _layer_Image_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(129);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return _layer_Image_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _layer_Layer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(131);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Layer", function() { return _layer_Layer_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _layer_MapboxVector_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(330);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MapboxVector", function() { return _layer_MapboxVector_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _layer_Tile_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(140);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Tile", function() { return _layer_Tile_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _layer_Vector_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(288);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Vector", function() { return _layer_Vector_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _layer_VectorImage_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(343);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VectorImage", function() { return _layer_VectorImage_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(331);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VectorTile", function() { return _layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _layer_WebGLPoints_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(345);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "WebGLPoints", function() { return _layer_WebGLPoints_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/**
 * @module ol/layer
 */











//# sourceMappingURL=layer.js.map

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Collection_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(106);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(134);
/* harmony import */ var _Feature_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97);
/* harmony import */ var _style_Fill_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56);
/* harmony import */ var _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(103);
/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(203);
/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98);
/* harmony import */ var _style_Stroke_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64);
/* harmony import */ var _style_Style_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(65);
/* harmony import */ var _style_Text_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66);
/* harmony import */ var _Vector_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(288);
/* harmony import */ var _source_Vector_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(105);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(16);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(11);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(24);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(7);
/* harmony import */ var _render_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(317);
/* harmony import */ var _geom_flat_geodesic_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(318);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Graticule
 */



















/**
 * @type {Stroke}
 * @private
 * @const
 */
var DEFAULT_STROKE_STYLE = new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
    color: 'rgba(0,0,0,0.2)',
});
/**
 * @type {Array<number>}
 * @private
 */
var INTERVALS = [
    90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001,
];
/**
 * @typedef {Object} GraticuleLabelDataType
 * @property {Point} geom Geometry.
 * @property {string} text Text.
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {number} [maxLines=100] The maximum number of meridians and
 * parallels from the center of the map. The default value of 100 means that at
 * most 200 meridians and 200 parallels will be displayed. The default value is
 * appropriate for conformal projections like Spherical Mercator. If you
 * increase the value, more lines will be drawn and the drawing performance will
 * decrease.
 * @property {Stroke} [strokeStyle='rgba(0,0,0,0.2)'] The
 * stroke style to use for drawing the graticule. If not provided, a not fully
 * opaque black will be used.
 * @property {number} [targetSize=100] The target size of the graticule cells,
 * in pixels.
 * @property {boolean} [showLabels=false] Render a label with the respective
 * latitude/longitude for each graticule line.
 * @property {function(number):string} [lonLabelFormatter] Label formatter for
 * longitudes. This function is called with the longitude as argument, and
 * should return a formatted string representing the longitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {function(number):string} [latLabelFormatter] Label formatter for
 * latitudes. This function is called with the latitude as argument, and
 * should return a formatted string representing the latitude. By default,
 * labels are formatted as degrees, minutes, seconds and hemisphere.
 * @property {number} [lonLabelPosition=0] Longitude label position in fractions
 * (0..1) of view extent. 0 means at the bottom of the viewport, 1 means at the
 * top.
 * @property {number} [latLabelPosition=1] Latitude label position in fractions
 * (0..1) of view extent. 0 means at the left of the viewport, 1 means at the
 * right.
 * @property {Text} [lonLabelStyle] Longitude label text
 * style. If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textBaseline: 'bottom',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: new Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textBaseline` configuration will not work well for
 * `lonLabelPosition` configurations that position labels close to the top of
 * the viewport.
 * @property {Text} [latLabelStyle] Latitude label text style.
 * If not provided, the following style will be used:
 * ```js
 * new Text({
 *   font: '12px Calibri,sans-serif',
 *   textAlign: 'end',
 *   fill: new Fill({
 *     color: 'rgba(0,0,0,1)'
 *   }),
 *   stroke: Stroke({
 *     color: 'rgba(255,255,255,1)',
 *     width: 3
 *   })
 * });
 * ```
 * Note that the default's `textAlign` configuration will not work well for
 * `latLabelPosition` configurations that position labels close to the left of
 * the viewport.
 * @property {Array<number>} [intervals=[90, 45, 30, 20, 10, 5, 2, 1, 0.5, 0.2, 0.1, 0.05, 0.01, 0.005, 0.002, 0.001]]
 * Intervals (in degrees) for the graticule. Example to limit graticules to 30 and 10 degrees intervals:
 * ```js
 * [30, 10]
 * ```
 * @property {boolean} [wrapX=true] Whether to repeat the graticule horizontally.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Layer that renders a grid for a coordinate system (currently only EPSG:4326 is supported).
 * Note that the view projection must define both extent and worldExtent.
 *
 * @fires import("../render/Event.js").RenderEvent
 * @extends {VectorLayer<import("../source/Vector.js").default>}
 * @api
 */
var Graticule = /** @class */ (function (_super) {
    __extends(Graticule, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Graticule(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_13__["assign"])({
            updateWhileAnimating: true,
            updateWhileInteracting: true,
            renderBuffer: 0,
        }, options);
        delete baseOptions.maxLines;
        delete baseOptions.strokeStyle;
        delete baseOptions.targetSize;
        delete baseOptions.showLabels;
        delete baseOptions.lonLabelFormatter;
        delete baseOptions.latLabelFormatter;
        delete baseOptions.lonLabelPosition;
        delete baseOptions.latLabelPosition;
        delete baseOptions.lonLabelStyle;
        delete baseOptions.latLabelStyle;
        delete baseOptions.intervals;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @type {import("../proj/Projection.js").default}
         */
        _this.projection_ = null;
        /**
         * @type {number}
         * @private
         */
        _this.maxLat_ = Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.maxLon_ = Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.minLat_ = -Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.minLon_ = -Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.maxX_ = Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.maxY_ = Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.minX_ = -Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.minY_ = -Infinity;
        /**
         * @type {number}
         * @private
         */
        _this.targetSize_ =
            options.targetSize !== undefined ? options.targetSize : 100;
        /**
         * @type {number}
         * @private
         */
        _this.maxLines_ = options.maxLines !== undefined ? options.maxLines : 100;
        /**
         * @type {Array<LineString>}
         * @private
         */
        _this.meridians_ = [];
        /**
         * @type {Array<LineString>}
         * @private
         */
        _this.parallels_ = [];
        /**
         * @type {Stroke}
         * @private
         */
        _this.strokeStyle_ =
            options.strokeStyle !== undefined
                ? options.strokeStyle
                : DEFAULT_STROKE_STYLE;
        /**
         * @type {import("../proj.js").TransformFunction|undefined}
         * @private
         */
        _this.fromLonLatTransform_ = undefined;
        /**
         * @type {import("../proj.js").TransformFunction|undefined}
         * @private
         */
        _this.toLonLatTransform_ = undefined;
        /**
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.projectionCenterLonLat_ = null;
        /**
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.bottomLeft_ = null;
        /**
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.bottomRight_ = null;
        /**
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.topLeft_ = null;
        /**
         * @type {import("../coordinate.js").Coordinate}
         * @private
         */
        _this.topRight_ = null;
        /**
         * @type {Array<GraticuleLabelDataType>}
         * @private
         */
        _this.meridiansLabels_ = null;
        /**
         * @type {Array<GraticuleLabelDataType>}
         * @private
         */
        _this.parallelsLabels_ = null;
        if (options.showLabels) {
            /**
             * @type {null|function(number):string}
             * @private
             */
            _this.lonLabelFormatter_ =
                options.lonLabelFormatter == undefined
                    ? _coordinate_js__WEBPACK_IMPORTED_MODULE_15__["degreesToStringHDMS"].bind(_this, 'EW')
                    : options.lonLabelFormatter;
            /**
             * @type {function(number):string}
             * @private
             */
            _this.latLabelFormatter_ =
                options.latLabelFormatter == undefined
                    ? _coordinate_js__WEBPACK_IMPORTED_MODULE_15__["degreesToStringHDMS"].bind(_this, 'NS')
                    : options.latLabelFormatter;
            /**
             * Longitude label position in fractions (0..1) of view extent. 0 means
             * bottom, 1 means top.
             * @type {number}
             * @private
             */
            _this.lonLabelPosition_ =
                options.lonLabelPosition == undefined ? 0 : options.lonLabelPosition;
            /**
             * Latitude Label position in fractions (0..1) of view extent. 0 means left, 1
             * means right.
             * @type {number}
             * @private
             */
            _this.latLabelPosition_ =
                options.latLabelPosition == undefined ? 1 : options.latLabelPosition;
            /**
             * @type {Style}
             * @private
             */
            _this.lonLabelStyleBase_ = new _style_Style_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
                text: options.lonLabelStyle !== undefined
                    ? options.lonLabelStyle.clone()
                    : new _style_Text_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                        font: '12px Calibri,sans-serif',
                        textBaseline: 'bottom',
                        fill: new _style_Fill_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                            color: 'rgba(0,0,0,1)',
                        }),
                        stroke: new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                            color: 'rgba(255,255,255,1)',
                            width: 3,
                        }),
                    }),
            });
            /**
             * @private
             * @param {import("../Feature").default} feature Feature
             * @return {Style} style
             */
            _this.lonLabelStyle_ = function (feature) {
                var label = feature.get('graticule_label');
                this.lonLabelStyleBase_.getText().setText(label);
                return this.lonLabelStyleBase_;
            }.bind(_this);
            /**
             * @type {Style}
             * @private
             */
            _this.latLabelStyleBase_ = new _style_Style_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
                text: options.latLabelStyle !== undefined
                    ? options.latLabelStyle.clone()
                    : new _style_Text_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                        font: '12px Calibri,sans-serif',
                        textAlign: 'right',
                        fill: new _style_Fill_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                            color: 'rgba(0,0,0,1)',
                        }),
                        stroke: new _style_Stroke_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
                            color: 'rgba(255,255,255,1)',
                            width: 3,
                        }),
                    }),
            });
            /**
             * @private
             * @param {import("../Feature").default} feature Feature
             * @return {Style} style
             */
            _this.latLabelStyle_ = function (feature) {
                var label = feature.get('graticule_label');
                this.latLabelStyleBase_.getText().setText(label);
                return this.latLabelStyleBase_;
            }.bind(_this);
            _this.meridiansLabels_ = [];
            _this.parallelsLabels_ = [];
            _this.addEventListener(_render_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POSTRENDER, _this.drawLabels_.bind(_this));
        }
        /**
         * @type {Array<number>}
         * @private
         */
        _this.intervals_ =
            options.intervals !== undefined ? options.intervals : INTERVALS;
        // use a source with a custom loader for lines & text
        _this.setSource(new _source_Vector_js__WEBPACK_IMPORTED_MODULE_11__["default"]({
            loader: _this.loaderFunction.bind(_this),
            strategy: _this.strategyFunction.bind(_this),
            features: new _Collection_js__WEBPACK_IMPORTED_MODULE_0__["default"](),
            overlaps: false,
            useSpatialIndex: false,
            wrapX: options.wrapX,
        }));
        /**
         * feature pool to use when updating graticule
         * @type {Array<Feature>}
         * @private
         */
        _this.featurePool_ = [];
        /**
         * @type {Style}
         * @private
         */
        _this.lineStyle_ = new _style_Style_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
            stroke: _this.strokeStyle_,
        });
        /**
         * @type {?import("../extent.js").Extent}
         * @private
         */
        _this.loadedExtent_ = null;
        /**
         * @type {?import("../extent.js").Extent}
         */
        _this.renderedExtent_ = null;
        _this.setRenderOrder(null);
        return _this;
    }
    /**
     * Strategy function for loading features based on the view's extent and
     * resolution.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} resolution Resolution.
     * @return {Array<import("../extent.js").Extent>} Extents.
     */
    Graticule.prototype.strategyFunction = function (extent, resolution) {
        // extents may be passed in different worlds, to avoid endless loop we use only one
        var realWorldExtent = extent.slice();
        if (this.projection_ && this.getSource().getWrapX()) {
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["wrapX"])(realWorldExtent, this.projection_);
        }
        if (this.loadedExtent_) {
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["approximatelyEquals"])(this.loadedExtent_, realWorldExtent, resolution)) {
                // make sure result is exactly equal to previous extent
                realWorldExtent = this.loadedExtent_.slice();
            }
            else {
                // we should not keep track of loaded extents
                this.getSource().removeLoadedExtent(this.loadedExtent_);
            }
        }
        return [realWorldExtent];
    };
    /**
     * Update geometries in the source based on current view
     * @param {import("../extent").Extent} extent Extent
     * @param {number} resolution Resolution
     * @param {import("../proj/Projection.js").default} projection Projection
     */
    Graticule.prototype.loaderFunction = function (extent, resolution, projection) {
        this.loadedExtent_ = extent;
        var source = this.getSource();
        // only consider the intersection between our own extent & the requested one
        var layerExtent = this.getExtent() || [
            -Infinity,
            -Infinity,
            Infinity,
            Infinity,
        ];
        var renderExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getIntersection"])(layerExtent, extent);
        if (this.renderedExtent_ && Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["equals"])(this.renderedExtent_, renderExtent)) {
            return;
        }
        this.renderedExtent_ = renderExtent;
        // bail out if nothing to render
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["isEmpty"])(renderExtent)) {
            return;
        }
        // update projection info
        var center = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getCenter"])(renderExtent);
        var squaredTolerance = (resolution * resolution) / 4;
        var updateProjectionInfo = !this.projection_ || !Object(_proj_js__WEBPACK_IMPORTED_MODULE_16__["equivalent"])(this.projection_, projection);
        if (updateProjectionInfo) {
            this.updateProjectionInfo_(projection);
        }
        this.createGraticule_(renderExtent, center, resolution, squaredTolerance);
        // first make sure we have enough features in the pool
        var featureCount = this.meridians_.length + this.parallels_.length;
        if (this.meridiansLabels_) {
            featureCount += this.meridians_.length;
        }
        if (this.parallelsLabels_) {
            featureCount += this.parallels_.length;
        }
        var feature;
        while (featureCount > this.featurePool_.length) {
            feature = new _Feature_js__WEBPACK_IMPORTED_MODULE_2__["default"]();
            this.featurePool_.push(feature);
        }
        var featuresColl = source.getFeaturesCollection();
        featuresColl.clear();
        var poolIndex = 0;
        // add features for the lines & labels
        var i, l;
        for (i = 0, l = this.meridians_.length; i < l; ++i) {
            feature = this.featurePool_[poolIndex++];
            feature.setGeometry(this.meridians_[i]);
            feature.setStyle(this.lineStyle_);
            featuresColl.push(feature);
        }
        for (i = 0, l = this.parallels_.length; i < l; ++i) {
            feature = this.featurePool_[poolIndex++];
            feature.setGeometry(this.parallels_[i]);
            feature.setStyle(this.lineStyle_);
            featuresColl.push(feature);
        }
    };
    /**
     * @param {number} lon Longitude.
     * @param {number} minLat Minimal latitude.
     * @param {number} maxLat Maximal latitude.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} index Index.
     * @return {number} Index.
     * @private
     */
    Graticule.prototype.addMeridian_ = function (lon, minLat, maxLat, squaredTolerance, extent, index) {
        var lineString = this.getMeridian_(lon, minLat, maxLat, squaredTolerance, index);
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["intersects"])(lineString.getExtent(), extent)) {
            if (this.meridiansLabels_) {
                var text = this.lonLabelFormatter_(lon);
                if (index in this.meridiansLabels_) {
                    this.meridiansLabels_[index].text = text;
                }
                else {
                    this.meridiansLabels_[index] = {
                        geom: new _geom_Point_js__WEBPACK_IMPORTED_MODULE_6__["default"]([]),
                        text: text,
                    };
                }
            }
            this.meridians_[index++] = lineString;
        }
        return index;
    };
    /**
     * @param {number} lat Latitude.
     * @param {number} minLon Minimal longitude.
     * @param {number} maxLon Maximal longitude.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} index Index.
     * @return {number} Index.
     * @private
     */
    Graticule.prototype.addParallel_ = function (lat, minLon, maxLon, squaredTolerance, extent, index) {
        var lineString = this.getParallel_(lat, minLon, maxLon, squaredTolerance, index);
        if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["intersects"])(lineString.getExtent(), extent)) {
            if (this.parallelsLabels_) {
                var text = this.latLabelFormatter_(lat);
                if (index in this.parallelsLabels_) {
                    this.parallelsLabels_[index].text = text;
                }
                else {
                    this.parallelsLabels_[index] = {
                        geom: new _geom_Point_js__WEBPACK_IMPORTED_MODULE_6__["default"]([]),
                        text: text,
                    };
                }
            }
            this.parallels_[index++] = lineString;
        }
        return index;
    };
    /**
     * @param {import("../render/Event.js").default} event Render event.
     * @private
     */
    Graticule.prototype.drawLabels_ = function (event) {
        var rotation = event.frameState.viewState.rotation;
        var extent = event.frameState.extent;
        var rotationCenter = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getCenter"])(extent);
        var rotationExtent = extent;
        if (rotation) {
            var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getWidth"])(extent);
            var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getHeight"])(extent);
            var cr = Math.abs(Math.cos(rotation));
            var sr = Math.abs(Math.sin(rotation));
            var unrotatedWidth = (sr * height - cr * width) / (sr * sr - cr * cr);
            var unrotatedHeight = (sr * width - cr * height) / (sr * sr - cr * cr);
            rotationExtent = [
                rotationCenter[0] - unrotatedWidth / 2,
                rotationCenter[1] - unrotatedHeight / 2,
                rotationCenter[0] + unrotatedWidth / 2,
                rotationCenter[1] + unrotatedHeight / 2,
            ];
        }
        var startWorld = 0;
        var endWorld = 0;
        var labelsAtStart = this.latLabelPosition_ < 0.5;
        var projectionExtent = this.projection_.getExtent();
        var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getWidth"])(projectionExtent);
        if (this.getSource().getWrapX() &&
            this.projection_.canWrapX() &&
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsExtent"])(projectionExtent, extent)) {
            startWorld = Math.floor((extent[0] - projectionExtent[0]) / worldWidth);
            endWorld = Math.ceil((extent[2] - projectionExtent[2]) / worldWidth);
            var inverted = Math.abs(rotation) > Math.PI / 2;
            labelsAtStart = labelsAtStart !== inverted;
        }
        var vectorContext = Object(_render_js__WEBPACK_IMPORTED_MODULE_17__["getVectorContext"])(event);
        for (var world = startWorld; world <= endWorld; ++world) {
            var poolIndex = this.meridians_.length + this.parallels_.length;
            var feature = void 0, index = void 0, l = void 0, textPoint = void 0;
            if (this.meridiansLabels_) {
                for (index = 0, l = this.meridiansLabels_.length; index < l; ++index) {
                    var lineString = this.meridians_[index];
                    if (!rotation && world === 0) {
                        textPoint = this.getMeridianPoint_(lineString, extent, index);
                    }
                    else {
                        var clone = lineString.clone();
                        clone.translate(world * worldWidth, 0);
                        clone.rotate(-rotation, rotationCenter);
                        textPoint = this.getMeridianPoint_(clone, rotationExtent, index);
                        textPoint.rotate(rotation, rotationCenter);
                    }
                    feature = this.featurePool_[poolIndex++];
                    feature.setGeometry(textPoint);
                    feature.set('graticule_label', this.meridiansLabels_[index].text);
                    vectorContext.drawFeature(feature, this.lonLabelStyle_(feature));
                }
            }
            if (this.parallelsLabels_) {
                if ((world === startWorld && labelsAtStart) ||
                    (world === endWorld && !labelsAtStart)) {
                    for (index = 0, l = this.parallels_.length; index < l; ++index) {
                        var lineString = this.parallels_[index];
                        if (!rotation && world === 0) {
                            textPoint = this.getParallelPoint_(lineString, extent, index);
                        }
                        else {
                            var clone = lineString.clone();
                            clone.translate(world * worldWidth, 0);
                            clone.rotate(-rotation, rotationCenter);
                            textPoint = this.getParallelPoint_(clone, rotationExtent, index);
                            textPoint.rotate(rotation, rotationCenter);
                        }
                        feature = this.featurePool_[poolIndex++];
                        feature.setGeometry(textPoint);
                        feature.set('graticule_label', this.parallelsLabels_[index].text);
                        vectorContext.drawFeature(feature, this.latLabelStyle_(feature));
                    }
                }
            }
        }
    };
    /**
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {import("../coordinate.js").Coordinate} center Center.
     * @param {number} resolution Resolution.
     * @param {number} squaredTolerance Squared tolerance.
     * @private
     */
    Graticule.prototype.createGraticule_ = function (extent, center, resolution, squaredTolerance) {
        var interval = this.getInterval_(resolution);
        if (interval == -1) {
            this.meridians_.length = 0;
            this.parallels_.length = 0;
            if (this.meridiansLabels_) {
                this.meridiansLabels_.length = 0;
            }
            if (this.parallelsLabels_) {
                this.parallelsLabels_.length = 0;
            }
            return;
        }
        var wrapX = false;
        var projectionExtent = this.projection_.getExtent();
        var worldWidth = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getWidth"])(projectionExtent);
        if (this.getSource().getWrapX() &&
            this.projection_.canWrapX() &&
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsExtent"])(projectionExtent, extent)) {
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getWidth"])(extent) >= worldWidth) {
                extent[0] = projectionExtent[0];
                extent[2] = projectionExtent[2];
            }
            else {
                wrapX = true;
            }
        }
        // Constrain the center to fit into the extent available to the graticule
        var validCenterP = [
            Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(center[0], this.minX_, this.maxX_),
            Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(center[1], this.minY_, this.maxY_),
        ];
        // Transform the center to lon lat
        // Some projections may have a void area at the poles
        // so replace any NaN latitudes with the min or max value closest to a pole
        var centerLonLat = this.toLonLatTransform_(validCenterP);
        if (isNaN(centerLonLat[1])) {
            centerLonLat[1] =
                Math.abs(this.maxLat_) >= Math.abs(this.minLat_)
                    ? this.maxLat_
                    : this.minLat_;
        }
        var centerLon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLonLat[0], this.minLon_, this.maxLon_);
        var centerLat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLonLat[1], this.minLat_, this.maxLat_);
        var maxLines = this.maxLines_;
        var cnt, idx, lat, lon;
        // Limit the extent to fit into the extent available to the graticule
        var validExtentP = extent;
        if (!wrapX) {
            validExtentP = [
                Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[0], this.minX_, this.maxX_),
                Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[1], this.minY_, this.maxY_),
                Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[2], this.minX_, this.maxX_),
                Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[3], this.minY_, this.maxY_),
            ];
        }
        // Transform the extent to get the lon lat ranges for the edges of the extent
        var validExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["applyTransform"])(validExtentP, this.toLonLatTransform_, undefined, 8);
        var maxLat = validExtent[3];
        var maxLon = validExtent[2];
        var minLat = validExtent[1];
        var minLon = validExtent[0];
        if (!wrapX) {
            // Check if extremities of the world extent lie inside the extent
            // (for example the pole in a polar projection)
            // and extend the extent as appropriate
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsCoordinate"])(validExtentP, this.bottomLeft_)) {
                minLon = this.minLon_;
                minLat = this.minLat_;
            }
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsCoordinate"])(validExtentP, this.bottomRight_)) {
                maxLon = this.maxLon_;
                minLat = this.minLat_;
            }
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsCoordinate"])(validExtentP, this.topLeft_)) {
                minLon = this.minLon_;
                maxLat = this.maxLat_;
            }
            if (Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["containsCoordinate"])(validExtentP, this.topRight_)) {
                maxLon = this.maxLon_;
                maxLat = this.maxLat_;
            }
            // The transformed center may also extend the lon lat ranges used for rendering
            maxLat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(maxLat, centerLat, this.maxLat_);
            maxLon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(maxLon, centerLon, this.maxLon_);
            minLat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(minLat, this.minLat_, centerLat);
            minLon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(minLon, this.minLon_, centerLon);
        }
        // Create meridians
        centerLon = Math.floor(centerLon / interval) * interval;
        lon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLon, this.minLon_, this.maxLon_);
        idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, 0);
        cnt = 0;
        if (wrapX) {
            while ((lon -= interval) >= minLon && cnt++ < maxLines) {
                idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
            }
        }
        else {
            while (lon != this.minLon_ && cnt++ < maxLines) {
                lon = Math.max(lon - interval, this.minLon_);
                idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
            }
        }
        lon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLon, this.minLon_, this.maxLon_);
        cnt = 0;
        if (wrapX) {
            while ((lon += interval) <= maxLon && cnt++ < maxLines) {
                idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
            }
        }
        else {
            while (lon != this.maxLon_ && cnt++ < maxLines) {
                lon = Math.min(lon + interval, this.maxLon_);
                idx = this.addMeridian_(lon, minLat, maxLat, squaredTolerance, extent, idx);
            }
        }
        this.meridians_.length = idx;
        if (this.meridiansLabels_) {
            this.meridiansLabels_.length = idx;
        }
        // Create parallels
        centerLat = Math.floor(centerLat / interval) * interval;
        lat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLat, this.minLat_, this.maxLat_);
        idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, 0);
        cnt = 0;
        while (lat != this.minLat_ && cnt++ < maxLines) {
            lat = Math.max(lat - interval, this.minLat_);
            idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
        }
        lat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLat, this.minLat_, this.maxLat_);
        cnt = 0;
        while (lat != this.maxLat_ && cnt++ < maxLines) {
            lat = Math.min(lat + interval, this.maxLat_);
            idx = this.addParallel_(lat, minLon, maxLon, squaredTolerance, extent, idx);
        }
        this.parallels_.length = idx;
        if (this.parallelsLabels_) {
            this.parallelsLabels_.length = idx;
        }
    };
    /**
     * @param {number} resolution Resolution.
     * @return {number} The interval in degrees.
     * @private
     */
    Graticule.prototype.getInterval_ = function (resolution) {
        var centerLon = this.projectionCenterLonLat_[0];
        var centerLat = this.projectionCenterLonLat_[1];
        var interval = -1;
        var target = Math.pow(this.targetSize_ * resolution, 2);
        /** @type {Array<number>} **/
        var p1 = [];
        /** @type {Array<number>} **/
        var p2 = [];
        for (var i = 0, ii = this.intervals_.length; i < ii; ++i) {
            var delta = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(this.intervals_[i] / 2, 0, 90);
            // Don't attempt to transform latitudes beyond the poles!
            var clampedLat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(centerLat, -90 + delta, 90 - delta);
            p1[0] = centerLon - delta;
            p1[1] = clampedLat - delta;
            p2[0] = centerLon + delta;
            p2[1] = clampedLat + delta;
            this.fromLonLatTransform_(p1, p1);
            this.fromLonLatTransform_(p2, p2);
            var dist = Math.pow(p2[0] - p1[0], 2) + Math.pow(p2[1] - p1[1], 2);
            if (dist <= target) {
                break;
            }
            interval = this.intervals_[i];
        }
        return interval;
    };
    /**
     * @param {number} lon Longitude.
     * @param {number} minLat Minimal latitude.
     * @param {number} maxLat Maximal latitude.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LineString} The meridian line string.
     * @param {number} index Index.
     * @private
     */
    Graticule.prototype.getMeridian_ = function (lon, minLat, maxLat, squaredTolerance, index) {
        var flatCoordinates = Object(_geom_flat_geodesic_js__WEBPACK_IMPORTED_MODULE_18__["meridian"])(lon, minLat, maxLat, this.projection_, squaredTolerance);
        var lineString = this.meridians_[index];
        if (!lineString) {
            lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_5__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_4__["default"].XY);
            this.meridians_[index] = lineString;
        }
        else {
            lineString.setFlatCoordinates(_geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_4__["default"].XY, flatCoordinates);
            lineString.changed();
        }
        return lineString;
    };
    /**
     * @param {LineString} lineString Meridian
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} index Index.
     * @return {Point} Meridian point.
     * @private
     */
    Graticule.prototype.getMeridianPoint_ = function (lineString, extent, index) {
        var flatCoordinates = lineString.getFlatCoordinates();
        var bottom = 1;
        var top = flatCoordinates.length - 1;
        if (flatCoordinates[bottom] > flatCoordinates[top]) {
            bottom = top;
            top = 1;
        }
        var clampedBottom = Math.max(extent[1], flatCoordinates[bottom]);
        var clampedTop = Math.min(extent[3], flatCoordinates[top]);
        var lat = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[1] + Math.abs(extent[1] - extent[3]) * this.lonLabelPosition_, clampedBottom, clampedTop);
        var coordinate0 = flatCoordinates[bottom - 1] +
            ((flatCoordinates[top - 1] - flatCoordinates[bottom - 1]) *
                (lat - flatCoordinates[bottom])) /
                (flatCoordinates[top] - flatCoordinates[bottom]);
        var coordinate = [coordinate0, lat];
        var point = this.meridiansLabels_[index].geom;
        point.setCoordinates(coordinate);
        return point;
    };
    /**
     * Get the list of meridians.  Meridians are lines of equal longitude.
     * @return {Array<LineString>} The meridians.
     * @api
     */
    Graticule.prototype.getMeridians = function () {
        return this.meridians_;
    };
    /**
     * @param {number} lat Latitude.
     * @param {number} minLon Minimal longitude.
     * @param {number} maxLon Maximal longitude.
     * @param {number} squaredTolerance Squared tolerance.
     * @return {LineString} The parallel line string.
     * @param {number} index Index.
     * @private
     */
    Graticule.prototype.getParallel_ = function (lat, minLon, maxLon, squaredTolerance, index) {
        var flatCoordinates = Object(_geom_flat_geodesic_js__WEBPACK_IMPORTED_MODULE_18__["parallel"])(lat, minLon, maxLon, this.projection_, squaredTolerance);
        var lineString = this.parallels_[index];
        if (!lineString) {
            lineString = new _geom_LineString_js__WEBPACK_IMPORTED_MODULE_5__["default"](flatCoordinates, _geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_4__["default"].XY);
        }
        else {
            lineString.setFlatCoordinates(_geom_GeometryLayout_js__WEBPACK_IMPORTED_MODULE_4__["default"].XY, flatCoordinates);
            lineString.changed();
        }
        return lineString;
    };
    /**
     * @param {LineString} lineString Parallels.
     * @param {import("../extent.js").Extent} extent Extent.
     * @param {number} index Index.
     * @return {Point} Parallel point.
     * @private
     */
    Graticule.prototype.getParallelPoint_ = function (lineString, extent, index) {
        var flatCoordinates = lineString.getFlatCoordinates();
        var left = 0;
        var right = flatCoordinates.length - 2;
        if (flatCoordinates[left] > flatCoordinates[right]) {
            left = right;
            right = 0;
        }
        var clampedLeft = Math.max(extent[0], flatCoordinates[left]);
        var clampedRight = Math.min(extent[2], flatCoordinates[right]);
        var lon = Object(_math_js__WEBPACK_IMPORTED_MODULE_14__["clamp"])(extent[0] + Math.abs(extent[0] - extent[2]) * this.latLabelPosition_, clampedLeft, clampedRight);
        var coordinate1 = flatCoordinates[left + 1] +
            ((flatCoordinates[right + 1] - flatCoordinates[left + 1]) *
                (lon - flatCoordinates[left])) /
                (flatCoordinates[right] - flatCoordinates[left]);
        var coordinate = [lon, coordinate1];
        var point = this.parallelsLabels_[index].geom;
        point.setCoordinates(coordinate);
        return point;
    };
    /**
     * Get the list of parallels.  Parallels are lines of equal latitude.
     * @return {Array<LineString>} The parallels.
     * @api
     */
    Graticule.prototype.getParallels = function () {
        return this.parallels_;
    };
    /**
     * @param {import("../proj/Projection.js").default} projection Projection.
     * @private
     */
    Graticule.prototype.updateProjectionInfo_ = function (projection) {
        var epsg4326Projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_16__["get"])('EPSG:4326');
        var worldExtent = projection.getWorldExtent();
        this.maxLat_ = worldExtent[3];
        this.maxLon_ = worldExtent[2];
        this.minLat_ = worldExtent[1];
        this.minLon_ = worldExtent[0];
        // If the world extent crosses the dateline define a custom transform to
        // return longitudes which wrap the dateline
        var toLonLatTransform = Object(_proj_js__WEBPACK_IMPORTED_MODULE_16__["getTransform"])(projection, epsg4326Projection);
        if (this.minLon_ < this.maxLon_) {
            this.toLonLatTransform_ = toLonLatTransform;
        }
        else {
            var split_1 = this.minLon_ + this.maxLon_ / 2;
            this.maxLon_ += 360;
            this.toLonLatTransform_ = function (coordinates, opt_output, opt_dimension) {
                var dimension = opt_dimension || 2;
                var lonLatCoordinates = toLonLatTransform(coordinates, opt_output, dimension);
                for (var i = 0, l = lonLatCoordinates.length; i < l; i += dimension) {
                    if (lonLatCoordinates[i] < split_1) {
                        lonLatCoordinates[i] += 360;
                    }
                }
                return lonLatCoordinates;
            };
        }
        // Transform the extent to get the limits of the view projection extent
        // which should be available to the graticule
        this.fromLonLatTransform_ = Object(_proj_js__WEBPACK_IMPORTED_MODULE_16__["getTransform"])(epsg4326Projection, projection);
        var worldExtentP = Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["applyTransform"])([this.minLon_, this.minLat_, this.maxLon_, this.maxLat_], this.fromLonLatTransform_, undefined, 8);
        this.minX_ = worldExtentP[0];
        this.maxX_ = worldExtentP[2];
        this.minY_ = worldExtentP[1];
        this.maxY_ = worldExtentP[3];
        // Determine the view projection coordinates of the extremities of the world extent
        // as these may lie inside a view extent (for example the pole in a polar projection)
        this.bottomLeft_ = this.fromLonLatTransform_([this.minLon_, this.minLat_]);
        this.bottomRight_ = this.fromLonLatTransform_([this.maxLon_, this.minLat_]);
        this.topLeft_ = this.fromLonLatTransform_([this.minLon_, this.maxLat_]);
        this.topRight_ = this.fromLonLatTransform_([this.maxLon_, this.maxLat_]);
        // Transform the projection center to lon lat
        // Some projections may have a void area at the poles
        // so replace any NaN latitudes with the min or max value closest to a pole
        this.projectionCenterLonLat_ = this.toLonLatTransform_(Object(_extent_js__WEBPACK_IMPORTED_MODULE_12__["getCenter"])(projection.getExtent()));
        if (isNaN(this.projectionCenterLonLat_[1])) {
            this.projectionCenterLonLat_[1] =
                Math.abs(this.maxLat_) >= Math.abs(this.minLat_)
                    ? this.maxLat_
                    : this.minLat_;
        }
        this.projection_ = projection;
    };
    return Graticule;
}(_Vector_js__WEBPACK_IMPORTED_MODULE_10__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (Graticule);
//# sourceMappingURL=Graticule.js.map

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toContext", function() { return toContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getVectorContext", function() { return getVectorContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenderPixel", function() { return getRenderPixel; });
/* harmony import */ var _render_canvas_Immediate_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(305);
/* harmony import */ var _has_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(101);
/* harmony import */ var _renderer_vector_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(306);
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7);
/**
 * @module ol/render
 */





/**
 * @typedef {Object} State
 * @property {CanvasRenderingContext2D} context Canvas context that the layer is being rendered to.
 * @property {import("./Feature.js").FeatureLike} feature Feature.
 * @property {import("./geom/SimpleGeometry.js").default} geometry Geometry.
 * @property {number} pixelRatio Pixel ratio used by the layer renderer.
 * @property {number} resolution Resolution that the render batch was created and optimized for.
 * This is not the view's resolution that is being rendered.
 * @property {number} rotation Rotation of the rendered layer in radians.
 */
/**
 * A function to be used when sorting features before rendering.
 * It takes two instances of {@link module:ol/Feature} or
 * {@link module:ol/render/Feature} and returns a `{number}`.
 *
 * @typedef {function(import("./Feature.js").FeatureLike, import("./Feature.js").FeatureLike):number} OrderFunction
 */
/**
 * @typedef {Object} ToContextOptions
 * @property {import("./size.js").Size} [size] Desired size of the canvas in css
 * pixels. When provided, both canvas and css size will be set according to the
 * `pixelRatio`. If not provided, the current canvas and css sizes will not be
 * altered.
 * @property {number} [pixelRatio=window.devicePixelRatio] Pixel ratio (canvas
 * pixel to css pixel ratio) for the canvas.
 */
/**
 * Binds a Canvas Immediate API to a canvas context, to allow drawing geometries
 * to the context's canvas.
 *
 * The units for geometry coordinates are css pixels relative to the top left
 * corner of the canvas element.
 * ```js
 * import {toContext} from 'ol/render';
 * import Fill from 'ol/style/Fill';
 * import Polygon from 'ol/geom/Polygon';
 *
 * var canvas = document.createElement('canvas');
 * var render = toContext(canvas.getContext('2d'),
 *     { size: [100, 100] });
 * render.setFillStrokeStyle(new Fill({ color: blue }));
 * render.drawPolygon(
 *     new Polygon([[[0, 0], [100, 100], [100, 0], [0, 0]]]));
 * ```
 *
 * @param {CanvasRenderingContext2D} context Canvas context.
 * @param {ToContextOptions} [opt_options] Options.
 * @return {CanvasImmediateRenderer} Canvas Immediate.
 * @api
 */
function toContext(context, opt_options) {
    var canvas = context.canvas;
    var options = opt_options ? opt_options : {};
    var pixelRatio = options.pixelRatio || _has_js__WEBPACK_IMPORTED_MODULE_1__["DEVICE_PIXEL_RATIO"];
    var size = options.size;
    if (size) {
        canvas.width = size[0] * pixelRatio;
        canvas.height = size[1] * pixelRatio;
        canvas.style.width = size[0] + 'px';
        canvas.style.height = size[1] + 'px';
    }
    var extent = [0, 0, canvas.width, canvas.height];
    var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_2__["scale"])(Object(_transform_js__WEBPACK_IMPORTED_MODULE_2__["create"])(), pixelRatio, pixelRatio);
    return new _render_canvas_Immediate_js__WEBPACK_IMPORTED_MODULE_0__["default"](context, pixelRatio, extent, transform, 0);
}
/**
 * Gets a vector context for drawing to the event's canvas.
 * @param {import("./render/Event.js").default} event Render event.
 * @return {CanvasImmediateRenderer} Vector context.
 * @api
 */
function getVectorContext(event) {
    // canvas may be at a different pixel ratio than frameState.pixelRatio
    var canvasPixelRatio = event.inversePixelTransform[0];
    var frameState = event.frameState;
    var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_2__["multiply"])(event.inversePixelTransform.slice(), frameState.coordinateToPixelTransform);
    var squaredTolerance = Object(_renderer_vector_js__WEBPACK_IMPORTED_MODULE_3__["getSquaredTolerance"])(frameState.viewState.resolution, canvasPixelRatio);
    var userTransform;
    var userProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["getUserProjection"])();
    if (userProjection) {
        userTransform = Object(_proj_js__WEBPACK_IMPORTED_MODULE_4__["getTransformFromProjections"])(userProjection, frameState.viewState.projection);
    }
    return new _render_canvas_Immediate_js__WEBPACK_IMPORTED_MODULE_0__["default"](event.context, canvasPixelRatio, frameState.extent, transform, frameState.viewState.rotation, squaredTolerance, userTransform);
}
/**
 * Gets the pixel of the event's canvas context from the map viewport's CSS pixel.
 * @param {import("./render/Event.js").default} event Render event.
 * @param {import("./pixel.js").Pixel} pixel CSS pixel relative to the top-left
 * corner of the map viewport.
 * @return {import("./pixel.js").Pixel} Pixel on the event's canvas context.
 * @api
 */
function getRenderPixel(event, pixel) {
    var result = pixel.slice(0);
    Object(_transform_js__WEBPACK_IMPORTED_MODULE_2__["apply"])(event.inversePixelTransform.slice(), result);
    return result;
}
//# sourceMappingURL=render.js.map

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "greatCircleArc", function() { return greatCircleArc; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "meridian", function() { return meridian; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parallel", function() { return parallel; });
/* harmony import */ var _proj_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11);
/**
 * @module ol/geom/flat/geodesic
 */


/**
 * @param {function(number): import("../../coordinate.js").Coordinate} interpolate Interpolate function.
 * @param {import("../../proj.js").TransformFunction} transform Transform from longitude/latitude to
 *     projected coordinates.
 * @param {number} squaredTolerance Squared tolerance.
 * @return {Array<number>} Flat coordinates.
 */
function line(interpolate, transform, squaredTolerance) {
    // FIXME reduce garbage generation
    // FIXME optimize stack operations
    /** @type {Array<number>} */
    var flatCoordinates = [];
    var geoA = interpolate(0);
    var geoB = interpolate(1);
    var a = transform(geoA);
    var b = transform(geoB);
    /** @type {Array<import("../../coordinate.js").Coordinate>} */
    var geoStack = [geoB, geoA];
    /** @type {Array<import("../../coordinate.js").Coordinate>} */
    var stack = [b, a];
    /** @type {Array<number>} */
    var fractionStack = [1, 0];
    /** @type {!Object<string, boolean>} */
    var fractions = {};
    var maxIterations = 1e5;
    var geoM, m, fracA, fracB, fracM, key;
    while (--maxIterations > 0 && fractionStack.length > 0) {
        // Pop the a coordinate off the stack
        fracA = fractionStack.pop();
        geoA = geoStack.pop();
        a = stack.pop();
        // Add the a coordinate if it has not been added yet
        key = fracA.toString();
        if (!(key in fractions)) {
            flatCoordinates.push(a[0], a[1]);
            fractions[key] = true;
        }
        // Pop the b coordinate off the stack
        fracB = fractionStack.pop();
        geoB = geoStack.pop();
        b = stack.pop();
        // Find the m point between the a and b coordinates
        fracM = (fracA + fracB) / 2;
        geoM = interpolate(fracM);
        m = transform(geoM);
        if (Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["squaredSegmentDistance"])(m[0], m[1], a[0], a[1], b[0], b[1]) <
            squaredTolerance) {
            // If the m point is sufficiently close to the straight line, then we
            // discard it.  Just use the b coordinate and move on to the next line
            // segment.
            flatCoordinates.push(b[0], b[1]);
            key = fracB.toString();
            fractions[key] = true;
        }
        else {
            // Otherwise, we need to subdivide the current line segment.  Split it
            // into two and push the two line segments onto the stack.
            fractionStack.push(fracB, fracM, fracM, fracA);
            stack.push(b, m, m, a);
            geoStack.push(geoB, geoM, geoM, geoA);
        }
    }
    return flatCoordinates;
}
/**
 * Generate a great-circle arcs between two lat/lon points.
 * @param {number} lon1 Longitude 1 in degrees.
 * @param {number} lat1 Latitude 1 in degrees.
 * @param {number} lon2 Longitude 2 in degrees.
 * @param {number} lat2 Latitude 2 in degrees.
 * @param {import("../../proj/Projection.js").default} projection Projection.
 * @param {number} squaredTolerance Squared tolerance.
 * @return {Array<number>} Flat coordinates.
 */
function greatCircleArc(lon1, lat1, lon2, lat2, projection, squaredTolerance) {
    var geoProjection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["get"])('EPSG:4326');
    var cosLat1 = Math.cos(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lat1));
    var sinLat1 = Math.sin(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lat1));
    var cosLat2 = Math.cos(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lat2));
    var sinLat2 = Math.sin(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lat2));
    var cosDeltaLon = Math.cos(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lon2 - lon1));
    var sinDeltaLon = Math.sin(Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lon2 - lon1));
    var d = sinLat1 * sinLat2 + cosLat1 * cosLat2 * cosDeltaLon;
    return line(
    /**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */
    function (frac) {
        if (1 <= d) {
            return [lon2, lat2];
        }
        var D = frac * Math.acos(d);
        var cosD = Math.cos(D);
        var sinD = Math.sin(D);
        var y = sinDeltaLon * cosLat2;
        var x = cosLat1 * sinLat2 - sinLat1 * cosLat2 * cosDeltaLon;
        var theta = Math.atan2(y, x);
        var lat = Math.asin(sinLat1 * cosD + cosLat1 * sinD * Math.cos(theta));
        var lon = Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toRadians"])(lon1) +
            Math.atan2(Math.sin(theta) * sinD * cosLat1, cosD - sinLat1 * Math.sin(lat));
        return [Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toDegrees"])(lon), Object(_math_js__WEBPACK_IMPORTED_MODULE_1__["toDegrees"])(lat)];
    }, Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["getTransform"])(geoProjection, projection), squaredTolerance);
}
/**
 * Generate a meridian (line at constant longitude).
 * @param {number} lon Longitude.
 * @param {number} lat1 Latitude 1.
 * @param {number} lat2 Latitude 2.
 * @param {import("../../proj/Projection.js").default} projection Projection.
 * @param {number} squaredTolerance Squared tolerance.
 * @return {Array<number>} Flat coordinates.
 */
function meridian(lon, lat1, lat2, projection, squaredTolerance) {
    var epsg4326Projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["get"])('EPSG:4326');
    return line(
    /**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */
    function (frac) {
        return [lon, lat1 + (lat2 - lat1) * frac];
    }, Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["getTransform"])(epsg4326Projection, projection), squaredTolerance);
}
/**
 * Generate a parallel (line at constant latitude).
 * @param {number} lat Latitude.
 * @param {number} lon1 Longitude 1.
 * @param {number} lon2 Longitude 2.
 * @param {import("../../proj/Projection.js").default} projection Projection.
 * @param {number} squaredTolerance Squared tolerance.
 * @return {Array<number>} Flat coordinates.
 */
function parallel(lat, lon1, lon2, projection, squaredTolerance) {
    var epsg4326Projection = Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["get"])('EPSG:4326');
    return line(
    /**
     * @param {number} frac Fraction.
     * @return {import("../../coordinate.js").Coordinate} Coordinate.
     */
    function (frac) {
        return [lon1 + (lon2 - lon1) * frac, lat];
    }, Object(_proj_js__WEBPACK_IMPORTED_MODULE_0__["getTransform"])(epsg4326Projection, projection), squaredTolerance);
}
//# sourceMappingURL=geodesic.js.map

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Vector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(288);
/* harmony import */ var _renderer_webgl_PointsLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(320);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _math_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11);
/* harmony import */ var _dom_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/Heatmap
 */





/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {Array<string>} [gradient=['#00f', '#0ff', '#0f0', '#ff0', '#f00']] The color gradient
 * of the heatmap, specified as an array of CSS color strings.
 * @property {number} [radius=8] Radius size in pixels.
 * @property {number} [blur=15] Blur size in pixels.
 * @property {string|function(import("../Feature.js").default):number} [weight='weight'] The feature
 * attribute to use for the weight or a function that returns a weight from a feature. Weight values
 * should range from 0 to 1 (and values outside will be clamped to that range).
 * @property {import("../source/Vector.js").default} [source] Source.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @enum {string}
 * @private
 */
var Property = {
    BLUR: 'blur',
    GRADIENT: 'gradient',
    RADIUS: 'radius',
};
/**
 * @const
 * @type {Array<string>}
 */
var DEFAULT_GRADIENT = ['#00f', '#0ff', '#0f0', '#ff0', '#f00'];
/**
 * @classdesc
 * Layer for rendering vector data as a heatmap.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @fires import("../render/Event.js").RenderEvent
 * @extends {VectorLayer<import("../source/Vector.js").default>}
 * @api
 */
var Heatmap = /** @class */ (function (_super) {
    __extends(Heatmap, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function Heatmap(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        delete baseOptions.gradient;
        delete baseOptions.radius;
        delete baseOptions.blur;
        delete baseOptions.weight;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.gradient_ = null;
        _this.addChangeListener(Property.GRADIENT, _this.handleGradientChanged_);
        _this.setGradient(options.gradient ? options.gradient : DEFAULT_GRADIENT);
        _this.setBlur(options.blur !== undefined ? options.blur : 15);
        _this.setRadius(options.radius !== undefined ? options.radius : 8);
        var weight = options.weight ? options.weight : 'weight';
        if (typeof weight === 'string') {
            _this.weightFunction_ = function (feature) {
                return feature.get(weight);
            };
        }
        else {
            _this.weightFunction_ = weight;
        }
        // For performance reasons, don't sort the features before rendering.
        // The render order is not relevant for a heatmap representation.
        _this.setRenderOrder(null);
        return _this;
    }
    /**
     * Return the blur size in pixels.
     * @return {number} Blur size in pixels.
     * @api
     * @observable
     */
    Heatmap.prototype.getBlur = function () {
        return /** @type {number} */ (this.get(Property.BLUR));
    };
    /**
     * Return the gradient colors as array of strings.
     * @return {Array<string>} Colors.
     * @api
     * @observable
     */
    Heatmap.prototype.getGradient = function () {
        return /** @type {Array<string>} */ (this.get(Property.GRADIENT));
    };
    /**
     * Return the size of the radius in pixels.
     * @return {number} Radius size in pixel.
     * @api
     * @observable
     */
    Heatmap.prototype.getRadius = function () {
        return /** @type {number} */ (this.get(Property.RADIUS));
    };
    /**
     * @private
     */
    Heatmap.prototype.handleGradientChanged_ = function () {
        this.gradient_ = createGradient(this.getGradient());
    };
    /**
     * Set the blur size in pixels.
     * @param {number} blur Blur size in pixels.
     * @api
     * @observable
     */
    Heatmap.prototype.setBlur = function (blur) {
        this.set(Property.BLUR, blur);
    };
    /**
     * Set the gradient colors as array of strings.
     * @param {Array<string>} colors Gradient.
     * @api
     * @observable
     */
    Heatmap.prototype.setGradient = function (colors) {
        this.set(Property.GRADIENT, colors);
    };
    /**
     * Set the size of the radius in pixels.
     * @param {number} radius Radius size in pixel.
     * @api
     * @observable
     */
    Heatmap.prototype.setRadius = function (radius) {
        this.set(Property.RADIUS, radius);
    };
    /**
     * Create a renderer for this layer.
     * @return {WebGLPointsLayerRenderer} A layer renderer.
     */
    Heatmap.prototype.createRenderer = function () {
        return new _renderer_webgl_PointsLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this, {
            className: this.getClassName(),
            attributes: [
                {
                    name: 'weight',
                    callback: function (feature) {
                        var weight = this.weightFunction_(feature);
                        return weight !== undefined ? Object(_math_js__WEBPACK_IMPORTED_MODULE_3__["clamp"])(weight, 0, 1) : 1;
                    }.bind(this),
                },
            ],
            vertexShader: "\n        precision mediump float;\n        uniform mat4 u_projectionMatrix;\n        uniform mat4 u_offsetScaleMatrix;\n        uniform float u_size;\n        attribute vec2 a_position;\n        attribute float a_index;\n        attribute float a_weight;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n\n        void main(void) {\n          mat4 offsetMatrix = u_offsetScaleMatrix;\n          float offsetX = a_index == 0.0 || a_index == 3.0 ? -u_size / 2.0 : u_size / 2.0;\n          float offsetY = a_index == 0.0 || a_index == 1.0 ? -u_size / 2.0 : u_size / 2.0;\n          vec4 offsets = offsetMatrix * vec4(offsetX, offsetY, 0.0, 0.0);\n          gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n          float u = a_index == 0.0 || a_index == 3.0 ? 0.0 : 1.0;\n          float v = a_index == 0.0 || a_index == 1.0 ? 0.0 : 1.0;\n          v_texCoord = vec2(u, v);\n          v_weight = a_weight;\n        }",
            fragmentShader: "\n        precision mediump float;\n        uniform float u_blurSlope;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n\n        void main(void) {\n          vec2 texCoord = v_texCoord * 2.0 - vec2(1.0, 1.0);\n          float sqRadius = texCoord.x * texCoord.x + texCoord.y * texCoord.y;\n          float value = (1.0 - sqrt(sqRadius)) * u_blurSlope;\n          float alpha = smoothstep(0.0, 1.0, value) * v_weight;\n          gl_FragColor = vec4(alpha, alpha, alpha, alpha);\n        }",
            hitVertexShader: "\n        precision mediump float;\n        uniform mat4 u_projectionMatrix;\n        uniform mat4 u_offsetScaleMatrix;\n        uniform float u_size;\n        attribute vec2 a_position;\n        attribute float a_index;\n        attribute float a_weight;\n        attribute vec4 a_hitColor;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n        varying vec4 v_hitColor;\n\n        void main(void) {\n          mat4 offsetMatrix = u_offsetScaleMatrix;\n          float offsetX = a_index == 0.0 || a_index == 3.0 ? -u_size / 2.0 : u_size / 2.0;\n          float offsetY = a_index == 0.0 || a_index == 1.0 ? -u_size / 2.0 : u_size / 2.0;\n          vec4 offsets = offsetMatrix * vec4(offsetX, offsetY, 0.0, 0.0);\n          gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n          float u = a_index == 0.0 || a_index == 3.0 ? 0.0 : 1.0;\n          float v = a_index == 0.0 || a_index == 1.0 ? 0.0 : 1.0;\n          v_texCoord = vec2(u, v);\n          v_hitColor = a_hitColor;\n          v_weight = a_weight;\n        }",
            hitFragmentShader: "\n        precision mediump float;\n        uniform float u_blurSlope;\n\n        varying vec2 v_texCoord;\n        varying float v_weight;\n        varying vec4 v_hitColor;\n\n        void main(void) {\n          vec2 texCoord = v_texCoord * 2.0 - vec2(1.0, 1.0);\n          float sqRadius = texCoord.x * texCoord.x + texCoord.y * texCoord.y;\n          float value = (1.0 - sqrt(sqRadius)) * u_blurSlope;\n          float alpha = smoothstep(0.0, 1.0, value) * v_weight;\n          if (alpha < 0.05) {\n            discard;\n          }\n\n          gl_FragColor = v_hitColor;\n        }",
            uniforms: {
                u_size: function () {
                    return (this.get(Property.RADIUS) + this.get(Property.BLUR)) * 2;
                }.bind(this),
                u_blurSlope: function () {
                    return (this.get(Property.RADIUS) / Math.max(1, this.get(Property.BLUR)));
                }.bind(this),
            },
            postProcesses: [
                {
                    fragmentShader: "\n            precision mediump float;\n\n            uniform sampler2D u_image;\n            uniform sampler2D u_gradientTexture;\n\n            varying vec2 v_texCoord;\n\n            void main() {\n              vec4 color = texture2D(u_image, v_texCoord);\n              gl_FragColor.a = color.a;\n              gl_FragColor.rgb = texture2D(u_gradientTexture, vec2(0.5, color.a)).rgb;\n              gl_FragColor.rgb *= gl_FragColor.a;\n            }",
                    uniforms: {
                        u_gradientTexture: function () {
                            return this.gradient_;
                        }.bind(this),
                    },
                },
            ],
        });
    };
    Heatmap.prototype.renderDeclutter = function () { };
    return Heatmap;
}(_Vector_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @param {Array<string>} colors A list of colored.
 * @return {HTMLCanvasElement} canvas with gradient texture.
 */
function createGradient(colors) {
    var width = 1;
    var height = 256;
    var context = Object(_dom_js__WEBPACK_IMPORTED_MODULE_4__["createCanvasContext2D"])(width, height);
    var gradient = context.createLinearGradient(0, 0, width, height);
    var step = 1 / (colors.length - 1);
    for (var i = 0, ii = colors.length; i < ii; ++i) {
        gradient.addColorStop(i * step, colors[i]);
    }
    context.fillStyle = gradient;
    context.fillRect(0, 0, width, height);
    return context.canvas;
}
/* harmony default export */ __webpack_exports__["default"] = (Heatmap);
//# sourceMappingURL=Heatmap.js.map

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _layer_BaseVector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(289);
/* harmony import */ var _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23);
/* harmony import */ var _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(110);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(139);
/* harmony import */ var _webgl_Buffer_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(321);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(323);
/* harmony import */ var _webgl_RenderTarget_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(328);
/* harmony import */ var _webgl_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(322);
/* harmony import */ var _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(324);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(101);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(16);
/* harmony import */ var _worker_webgl_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(329);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/webgl/PointsLayer
 */















/**
 * @typedef {Object} CustomAttribute A description of a custom attribute to be passed on to the GPU, with a value different
 * for each feature.
 * @property {string} name Attribute name.
 * @property {function(import("../../Feature").default, Object<string, *>):number} callback This callback computes the numerical value of the
 * attribute for a given feature (properties are available as 2nd arg for quicker access).
 */
/**
 * @typedef {Object} FeatureCacheItem Object that holds a reference to a feature, its geometry and properties. Used to optimize
 * rebuildBuffers by accessing these objects quicker.
 * @property {import("../../Feature").default} feature Feature
 * @property {Object<string, *>} properties Feature properties
 * @property {import("../../geom").Geometry} geometry Feature geometry
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the canvas element.
 * @property {Array<CustomAttribute>} [attributes] These attributes will be read from the features in the source and then
 * passed to the GPU. The `name` property of each attribute will serve as its identifier:
 *  * In the vertex shader as an `attribute` by prefixing it with `a_`
 *  * In the fragment shader as a `varying` by prefixing it with `v_`
 * Please note that these can only be numerical values.
 * @property {string} vertexShader Vertex shader source, mandatory.
 * @property {string} fragmentShader Fragment shader source, mandatory.
 * @property {string} [hitVertexShader] Vertex shader source for hit detection rendering.
 * @property {string} [hitFragmentShader] Fragment shader source for hit detection rendering.
 * @property {Object<string,import("../../webgl/Helper").UniformValue>} [uniforms] Uniform definitions for the post process steps
 * Please note that `u_texture` is reserved for the main texture slot.
 * @property {Array<import("./Layer").PostProcessesOptions>} [postProcesses] Post-processes definitions
 */
/**
 * @classdesc
 * WebGL vector renderer optimized for points.
 * All features will be rendered as quads (two triangles forming a square). New data will be flushed to the GPU
 * every time the vector source changes.
 *
 * You need to provide vertex and fragment shaders for rendering. This can be done using
 * {@link module:ol/webgl/ShaderBuilder} utilities. These shaders shall expect a `a_position` attribute
 * containing the screen-space projected center of the quad, as well as a `a_index` attribute
 * whose value (0, 1, 2 or 3) indicates which quad vertex is currently getting processed (see structure below).
 *
 * To include variable attributes in the shaders, you need to declare them using the `attributes` property of
 * the options object like so:
 * ```js
 * new WebGLPointsLayerRenderer(layer, {
 *   attributes: [
 *     {
 *       name: 'size',
 *       callback: function(feature) {
 *         // compute something with the feature
 *       }
 *     },
 *     {
 *       name: 'weight',
 *       callback: function(feature) {
 *         // compute something with the feature
 *       }
 *     },
 *   ],
 *   vertexShader:
 *     // shader using attribute a_weight and a_size
 *   fragmentShader:
 *     // shader using varying v_weight and v_size
 * ```
 *
 * To enable hit detection, you must as well provide dedicated shaders using the `hitVertexShader`
 * and `hitFragmentShader` properties. These shall expect the `a_hitColor` attribute to contain
 * the final color that will have to be output for hit detection to work.
 *
 * The following uniform is used for the main texture: `u_texture`.
 *
 * Please note that the main shader output should have premultiplied alpha, otherwise visual anomalies may occur.
 *
 * Points are rendered as quads with the following structure:
 *
 * ```
 *   (u0, v1)      (u1, v1)
 *  [3]----------[2]
 *   |`           |
 *   |  `         |
 *   |    `       |
 *   |      `     |
 *   |        `   |
 *   |          ` |
 *  [0]----------[1]
 *   (u0, v0)      (u1, v0)
 *  ```
 *
 * This uses {@link module:ol/webgl/Helper~WebGLHelper} internally.
 *
 * @api
 */
var WebGLPointsLayerRenderer = /** @class */ (function (_super) {
    __extends(WebGLPointsLayerRenderer, _super);
    /**
     * @param {import("../../layer/Layer.js").default} layer Layer.
     * @param {Options} options Options.
     */
    function WebGLPointsLayerRenderer(layer, options) {
        var _this = this;
        var uniforms = options.uniforms || {};
        var projectionMatrixTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["create"])();
        uniforms[_webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["DefaultUniform"].PROJECTION_MATRIX] = projectionMatrixTransform;
        _this = _super.call(this, layer, {
            className: options.className,
            uniforms: uniforms,
            postProcesses: options.postProcesses,
        }) || this;
        _this.sourceRevision_ = -1;
        _this.verticesBuffer_ = new _webgl_Buffer_js__WEBPACK_IMPORTED_MODULE_4__["default"](_webgl_js__WEBPACK_IMPORTED_MODULE_7__["ARRAY_BUFFER"], _webgl_js__WEBPACK_IMPORTED_MODULE_7__["DYNAMIC_DRAW"]);
        _this.hitVerticesBuffer_ = new _webgl_Buffer_js__WEBPACK_IMPORTED_MODULE_4__["default"](_webgl_js__WEBPACK_IMPORTED_MODULE_7__["ARRAY_BUFFER"], _webgl_js__WEBPACK_IMPORTED_MODULE_7__["DYNAMIC_DRAW"]);
        _this.indicesBuffer_ = new _webgl_Buffer_js__WEBPACK_IMPORTED_MODULE_4__["default"](_webgl_js__WEBPACK_IMPORTED_MODULE_7__["ELEMENT_ARRAY_BUFFER"], _webgl_js__WEBPACK_IMPORTED_MODULE_7__["DYNAMIC_DRAW"]);
        _this.program_ = _this.helper.getProgram(options.fragmentShader, options.vertexShader);
        /**
         * @type {boolean}
         * @private
         */
        _this.hitDetectionEnabled_ =
            options.hitFragmentShader && options.hitVertexShader ? true : false;
        _this.hitProgram_ =
            _this.hitDetectionEnabled_ &&
                _this.helper.getProgram(options.hitFragmentShader, options.hitVertexShader);
        var customAttributes = options.attributes
            ? options.attributes.map(function (attribute) {
                return {
                    name: 'a_' + attribute.name,
                    size: 1,
                    type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
                };
            })
            : [];
        /**
         * A list of attributes used by the renderer. By default only the position and
         * index of the vertex (0 to 3) are required.
         * @type {Array<import('../../webgl/Helper.js').AttributeDescription>}
         */
        _this.attributes = [
            {
                name: 'a_position',
                size: 2,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
            {
                name: 'a_index',
                size: 1,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
        ].concat(customAttributes);
        /**
         * A list of attributes used for hit detection.
         * @type {Array<import('../../webgl/Helper.js').AttributeDescription>}
         */
        _this.hitDetectionAttributes = [
            {
                name: 'a_position',
                size: 2,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
            {
                name: 'a_index',
                size: 1,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
            {
                name: 'a_hitColor',
                size: 4,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
            {
                name: 'a_featureUid',
                size: 1,
                type: _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_8__["AttributeType"].FLOAT,
            },
        ].concat(customAttributes);
        _this.customAttributes = options.attributes ? options.attributes : [];
        _this.previousExtent_ = Object(_extent_js__WEBPACK_IMPORTED_MODULE_11__["createEmpty"])();
        /**
         * This transform is updated on every frame and is the composition of:
         * - invert of the world->screen transform that was used when rebuilding buffers (see `this.renderTransform_`)
         * - current world->screen transform
         * @type {import("../../transform.js").Transform}
         * @private
         */
        _this.currentTransform_ = projectionMatrixTransform;
        /**
         * This transform is updated when buffers are rebuilt and converts world space coordinates to screen space
         * @type {import("../../transform.js").Transform}
         * @private
         */
        _this.renderTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["create"])();
        /**
         * @type {import("../../transform.js").Transform}
         * @private
         */
        _this.invertRenderTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["create"])();
        /**
         * @type {Float32Array}
         * @private
         */
        _this.renderInstructions_ = new Float32Array(0);
        /**
         * These instructions are used for hit detection
         * @type {Float32Array}
         * @private
         */
        _this.hitRenderInstructions_ = new Float32Array(0);
        /**
         * @type {WebGLRenderTarget}
         * @private
         */
        _this.hitRenderTarget_ =
            _this.hitDetectionEnabled_ && new _webgl_RenderTarget_js__WEBPACK_IMPORTED_MODULE_6__["default"](_this.helper);
        _this.worker_ = Object(_worker_webgl_js__WEBPACK_IMPORTED_MODULE_12__["create"])();
        _this.worker_.addEventListener('message', 
        /**
         * @param {*} event Event.
         * @this {WebGLPointsLayerRenderer}
         */
        function (event) {
            var received = event.data;
            if (received.type === _Layer_js__WEBPACK_IMPORTED_MODULE_5__["WebGLWorkerMessageType"].GENERATE_BUFFERS) {
                var projectionTransform = received.projectionTransform;
                if (received.hitDetection) {
                    this.hitVerticesBuffer_.fromArrayBuffer(received.vertexBuffer);
                    this.helper.flushBufferData(this.hitVerticesBuffer_);
                }
                else {
                    this.verticesBuffer_.fromArrayBuffer(received.vertexBuffer);
                    this.helper.flushBufferData(this.verticesBuffer_);
                }
                this.indicesBuffer_.fromArrayBuffer(received.indexBuffer);
                this.helper.flushBufferData(this.indicesBuffer_);
                this.renderTransform_ = projectionTransform;
                Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["makeInverse"])(this.invertRenderTransform_, this.renderTransform_);
                if (received.hitDetection) {
                    this.hitRenderInstructions_ = new Float32Array(event.data.renderInstructions);
                }
                else {
                    this.renderInstructions_ = new Float32Array(event.data.renderInstructions);
                }
                this.getLayer().changed();
            }
        }.bind(_this));
        /**
         * This object will be updated when the source changes. Key is uid.
         * @type {Object<string, FeatureCacheItem>}
         * @private
         */
        _this.featureCache_ = {};
        /**
         * Amount of features in the cache.
         * @type {number}
         * @private
         */
        _this.featureCount_ = 0;
        var source = _this.getLayer().getSource();
        _this.sourceListenKeys_ = [
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["listen"])(source, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].ADDFEATURE, _this.handleSourceFeatureAdded_, _this),
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["listen"])(source, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CHANGEFEATURE, _this.handleSourceFeatureChanged_, _this),
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["listen"])(source, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].REMOVEFEATURE, _this.handleSourceFeatureDelete_, _this),
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["listen"])(source, _source_VectorEventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CLEAR, _this.handleSourceFeatureClear_, _this),
        ];
        source.forEachFeature(function (feature) {
            this.featureCache_[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(feature)] = {
                feature: feature,
                properties: feature.getProperties(),
                geometry: feature.getGeometry(),
            };
            this.featureCount_++;
        }.bind(_this));
        return _this;
    }
    /**
     * @param {import("../../source/Vector.js").VectorSourceEvent} event Event.
     * @private
     */
    WebGLPointsLayerRenderer.prototype.handleSourceFeatureAdded_ = function (event) {
        var feature = event.feature;
        this.featureCache_[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(feature)] = {
            feature: feature,
            properties: feature.getProperties(),
            geometry: feature.getGeometry(),
        };
        this.featureCount_++;
    };
    /**
     * @param {import("../../source/Vector.js").VectorSourceEvent} event Event.
     * @private
     */
    WebGLPointsLayerRenderer.prototype.handleSourceFeatureChanged_ = function (event) {
        var feature = event.feature;
        this.featureCache_[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(feature)] = {
            feature: feature,
            properties: feature.getProperties(),
            geometry: feature.getGeometry(),
        };
    };
    /**
     * @param {import("../../source/Vector.js").VectorSourceEvent} event Event.
     * @private
     */
    WebGLPointsLayerRenderer.prototype.handleSourceFeatureDelete_ = function (event) {
        var feature = event.feature;
        delete this.featureCache_[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(feature)];
        this.featureCount_--;
    };
    /**
     * @private
     */
    WebGLPointsLayerRenderer.prototype.handleSourceFeatureClear_ = function () {
        this.featureCache_ = {};
        this.featureCount_ = 0;
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {HTMLElement} The rendered element.
     */
    WebGLPointsLayerRenderer.prototype.renderFrame = function (frameState) {
        this.preRender(frameState);
        var renderCount = this.indicesBuffer_.getSize();
        this.helper.drawElements(0, renderCount);
        this.helper.finalizeDraw(frameState);
        var canvas = this.helper.getCanvas();
        var layerState = frameState.layerStatesArray[frameState.layerIndex];
        var opacity = layerState.opacity;
        if (opacity !== parseFloat(canvas.style.opacity)) {
            canvas.style.opacity = String(opacity);
        }
        if (this.hitDetectionEnabled_) {
            this.renderHitDetection(frameState);
            this.hitRenderTarget_.clearCachedData();
        }
        this.postRender(frameState);
        return canvas;
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    WebGLPointsLayerRenderer.prototype.prepareFrame = function (frameState) {
        var layer = this.getLayer();
        var vectorSource = layer.getSource();
        var viewState = frameState.viewState;
        var viewNotMoving = !frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].ANIMATING] &&
            !frameState.viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_3__["default"].INTERACTING];
        var extentChanged = !Object(_extent_js__WEBPACK_IMPORTED_MODULE_11__["equals"])(this.previousExtent_, frameState.extent);
        var sourceChanged = this.sourceRevision_ < vectorSource.getRevision();
        if (sourceChanged) {
            this.sourceRevision_ = vectorSource.getRevision();
        }
        if (viewNotMoving && (extentChanged || sourceChanged)) {
            var projection = viewState.projection;
            var resolution = viewState.resolution;
            var renderBuffer = layer instanceof _layer_BaseVector_js__WEBPACK_IMPORTED_MODULE_0__["default"] ? layer.getRenderBuffer() : 0;
            var extent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_11__["buffer"])(frameState.extent, renderBuffer * resolution);
            vectorSource.loadFeatures(extent, resolution, projection);
            this.rebuildBuffers_(frameState);
            this.previousExtent_ = frameState.extent.slice();
        }
        // apply the current projection transform with the invert of the one used to fill buffers
        this.helper.makeProjectionTransform(frameState, this.currentTransform_);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["multiply"])(this.currentTransform_, this.invertRenderTransform_);
        this.helper.useProgram(this.program_);
        this.helper.prepareDraw(frameState);
        // write new data
        this.helper.bindBuffer(this.verticesBuffer_);
        this.helper.bindBuffer(this.indicesBuffer_);
        this.helper.enableAttributes(this.attributes);
        return true;
    };
    /**
     * Rebuild internal webgl buffers based on current view extent; costly, should not be called too much
     * @param {import("../../PluggableMap").FrameState} frameState Frame state.
     * @private
     */
    WebGLPointsLayerRenderer.prototype.rebuildBuffers_ = function (frameState) {
        // saves the projection transform for the current frame state
        var projectionTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["create"])();
        this.helper.makeProjectionTransform(frameState, projectionTransform);
        // here we anticipate the amount of render instructions that we well generate
        // this can be done since we know that for normal render we only have x, y as base instructions,
        // and x, y, r, g, b, a and featureUid for hit render instructions
        // and we also know the amount of custom attributes to append to these
        var totalInstructionsCount = (2 + this.customAttributes.length) * this.featureCount_;
        if (!this.renderInstructions_ ||
            this.renderInstructions_.length !== totalInstructionsCount) {
            this.renderInstructions_ = new Float32Array(totalInstructionsCount);
        }
        if (this.hitDetectionEnabled_) {
            var totalHitInstructionsCount = (7 + this.customAttributes.length) * this.featureCount_;
            if (!this.hitRenderInstructions_ ||
                this.hitRenderInstructions_.length !== totalHitInstructionsCount) {
                this.hitRenderInstructions_ = new Float32Array(totalHitInstructionsCount);
            }
        }
        // loop on features to fill the buffer
        var featureCache, geometry;
        var tmpCoords = [];
        var tmpColor = [];
        var renderIndex = 0;
        var hitIndex = 0;
        var hitColor;
        for (var featureUid in this.featureCache_) {
            featureCache = this.featureCache_[featureUid];
            geometry = /** @type {import("../../geom").Point} */ (featureCache.geometry);
            if (!geometry || geometry.getType() !== _geom_GeometryType_js__WEBPACK_IMPORTED_MODULE_1__["default"].POINT) {
                continue;
            }
            tmpCoords[0] = geometry.getFlatCoordinates()[0];
            tmpCoords[1] = geometry.getFlatCoordinates()[1];
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["apply"])(projectionTransform, tmpCoords);
            hitColor = Object(_Layer_js__WEBPACK_IMPORTED_MODULE_5__["colorEncodeId"])(hitIndex + 6, tmpColor);
            this.renderInstructions_[renderIndex++] = tmpCoords[0];
            this.renderInstructions_[renderIndex++] = tmpCoords[1];
            // for hit detection, the feature uid is saved in the opacity value
            // and the index of the opacity value is encoded in the color values
            if (this.hitDetectionEnabled_) {
                this.hitRenderInstructions_[hitIndex++] = tmpCoords[0];
                this.hitRenderInstructions_[hitIndex++] = tmpCoords[1];
                this.hitRenderInstructions_[hitIndex++] = hitColor[0];
                this.hitRenderInstructions_[hitIndex++] = hitColor[1];
                this.hitRenderInstructions_[hitIndex++] = hitColor[2];
                this.hitRenderInstructions_[hitIndex++] = hitColor[3];
                this.hitRenderInstructions_[hitIndex++] = Number(featureUid);
            }
            // pushing custom attributes
            var value = void 0;
            for (var j = 0; j < this.customAttributes.length; j++) {
                value = this.customAttributes[j].callback(featureCache.feature, featureCache.properties);
                this.renderInstructions_[renderIndex++] = value;
                if (this.hitDetectionEnabled_) {
                    this.hitRenderInstructions_[hitIndex++] = value;
                }
            }
        }
        /** @type {import('./Layer').WebGLWorkerGenerateBuffersMessage} */
        var message = {
            type: _Layer_js__WEBPACK_IMPORTED_MODULE_5__["WebGLWorkerMessageType"].GENERATE_BUFFERS,
            renderInstructions: this.renderInstructions_.buffer,
            customAttributesCount: this.customAttributes.length,
        };
        // additional properties will be sent back as-is by the worker
        message['projectionTransform'] = projectionTransform;
        this.worker_.postMessage(message, [this.renderInstructions_.buffer]);
        this.renderInstructions_ = null;
        /** @type {import('./Layer').WebGLWorkerGenerateBuffersMessage} */
        if (this.hitDetectionEnabled_) {
            var hitMessage = {
                type: _Layer_js__WEBPACK_IMPORTED_MODULE_5__["WebGLWorkerMessageType"].GENERATE_BUFFERS,
                renderInstructions: this.hitRenderInstructions_.buffer,
                customAttributesCount: 5 + this.customAttributes.length,
            };
            hitMessage['projectionTransform'] = projectionTransform;
            hitMessage['hitDetection'] = true;
            this.worker_.postMessage(hitMessage, [
                this.hitRenderInstructions_.buffer,
            ]);
            this.hitRenderInstructions_ = null;
        }
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
    WebGLPointsLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_10__["assert"])(this.hitDetectionEnabled_, 66);
        if (!this.hitRenderInstructions_) {
            return undefined;
        }
        var pixel = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["apply"])(frameState.coordinateToPixelTransform, coordinate.slice());
        var data = this.hitRenderTarget_.readPixel(pixel[0] / 2, pixel[1] / 2);
        var color = [data[0] / 255, data[1] / 255, data[2] / 255, data[3] / 255];
        var index = Object(_Layer_js__WEBPACK_IMPORTED_MODULE_5__["colorDecodeId"])(color);
        var opacity = this.hitRenderInstructions_[index];
        var uid = Math.floor(opacity).toString();
        var source = this.getLayer().getSource();
        var feature = source.getFeatureByUid(uid);
        if (feature) {
            return callback(feature, this.getLayer(), null);
        }
        return undefined;
    };
    /**
     * Render the hit detection data to the corresponding render target
     * @param {import("../../PluggableMap.js").FrameState} frameState current frame state
     */
    WebGLPointsLayerRenderer.prototype.renderHitDetection = function (frameState) {
        // skip render entirely if vertex buffers not ready/generated yet
        if (!this.hitVerticesBuffer_.getSize()) {
            return;
        }
        this.hitRenderTarget_.setSize([
            Math.floor(frameState.size[0] / 2),
            Math.floor(frameState.size[1] / 2),
        ]);
        this.helper.useProgram(this.hitProgram_);
        this.helper.prepareDrawToRenderTarget(frameState, this.hitRenderTarget_, true);
        this.helper.bindBuffer(this.hitVerticesBuffer_);
        this.helper.bindBuffer(this.indicesBuffer_);
        this.helper.enableAttributes(this.hitDetectionAttributes);
        var renderCount = this.indicesBuffer_.getSize();
        this.helper.drawElements(0, renderCount);
    };
    /**
     * Clean up.
     */
    WebGLPointsLayerRenderer.prototype.disposeInternal = function () {
        this.worker_.terminate();
        this.layer_ = null;
        this.sourceListenKeys_.forEach(function (key) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["unlistenByKey"])(key);
        });
        this.sourceListenKeys_ = null;
        _super.prototype.disposeInternal.call(this);
    };
    return WebGLPointsLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_5__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (WebGLPointsLayerRenderer);
//# sourceMappingURL=PointsLayer.js.map

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BufferUsage", function() { return BufferUsage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getArrayClassForType", function() { return getArrayClassForType; });
/* harmony import */ var _webgl_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(322);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19);
/**
 * @module ol/webgl/Buffer
 */



/**
 * Used to describe the intended usage for the data: `STATIC_DRAW`, `STREAM_DRAW`
 * or `DYNAMIC_DRAW`.
 * @enum {number}
 */
var BufferUsage = {
    STATIC_DRAW: _webgl_js__WEBPACK_IMPORTED_MODULE_0__["STATIC_DRAW"],
    STREAM_DRAW: _webgl_js__WEBPACK_IMPORTED_MODULE_0__["STREAM_DRAW"],
    DYNAMIC_DRAW: _webgl_js__WEBPACK_IMPORTED_MODULE_0__["DYNAMIC_DRAW"],
};
/**
 * @classdesc
 * Object used to store an array of data as well as usage information for that data.
 * Stores typed arrays internally, either Float32Array or Uint16/32Array depending on
 * the buffer type (ARRAY_BUFFER or ELEMENT_ARRAY_BUFFER) and available extensions.
 *
 * To populate the array, you can either use:
 * * A size using `#ofSize(buffer)`
 * * An `ArrayBuffer` object using `#fromArrayBuffer(buffer)`
 * * A plain array using `#fromArray(array)`
 *
 * Note:
 * See the documentation of [WebGLRenderingContext.bufferData](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bufferData)
 * for more info on buffer usage.
 * @api
 */
var WebGLArrayBuffer = /** @class */ (function () {
    /**
     * @param {number} type Buffer type, either ARRAY_BUFFER or ELEMENT_ARRAY_BUFFER.
     * @param {number} [opt_usage] Intended usage, either `STATIC_DRAW`, `STREAM_DRAW` or `DYNAMIC_DRAW`.
     * Default is `DYNAMIC_DRAW`.
     */
    function WebGLArrayBuffer(type, opt_usage) {
        /**
         * @private
         * @type {Float32Array|Uint32Array}
         */
        this.array = null;
        /**
         * @private
         * @type {number}
         */
        this.type = type;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_1__["assert"])(type === _webgl_js__WEBPACK_IMPORTED_MODULE_0__["ARRAY_BUFFER"] || type === _webgl_js__WEBPACK_IMPORTED_MODULE_0__["ELEMENT_ARRAY_BUFFER"], 62);
        /**
         * @private
         * @type {number}
         */
        this.usage = opt_usage !== undefined ? opt_usage : BufferUsage.STATIC_DRAW;
    }
    /**
     * Populates the buffer with an array of the given size (all values will be zeroes).
     * @param {number} size Array size
     */
    WebGLArrayBuffer.prototype.ofSize = function (size) {
        this.array = new (getArrayClassForType(this.type))(size);
    };
    /**
     * Populates the buffer with an array of the given size (all values will be zeroes).
     * @param {Array<number>} array Numerical array
     */
    WebGLArrayBuffer.prototype.fromArray = function (array) {
        this.array = getArrayClassForType(this.type).from(array);
    };
    /**
     * Populates the buffer with a raw binary array buffer.
     * @param {ArrayBuffer} buffer Raw binary buffer to populate the array with. Note that this buffer must have been
     * initialized for the same typed array class.
     */
    WebGLArrayBuffer.prototype.fromArrayBuffer = function (buffer) {
        this.array = new (getArrayClassForType(this.type))(buffer);
    };
    /**
     * @return {number} Buffer type.
     */
    WebGLArrayBuffer.prototype.getType = function () {
        return this.type;
    };
    /**
     * Will return null if the buffer was not initialized
     * @return {Float32Array|Uint32Array} Array.
     */
    WebGLArrayBuffer.prototype.getArray = function () {
        return this.array;
    };
    /**
     * @return {number} Usage.
     */
    WebGLArrayBuffer.prototype.getUsage = function () {
        return this.usage;
    };
    /**
     * Will return 0 if the buffer is not initialized
     * @return {number} Array size
     */
    WebGLArrayBuffer.prototype.getSize = function () {
        return this.array ? this.array.length : 0;
    };
    return WebGLArrayBuffer;
}());
/**
 * Returns a typed array constructor based on the given buffer type
 * @param {number} type Buffer type, either ARRAY_BUFFER or ELEMENT_ARRAY_BUFFER.
 * @return {Float32ArrayConstructor|Uint32ArrayConstructor} The typed array class to use for this buffer.
 */
function getArrayClassForType(type) {
    switch (type) {
        case _webgl_js__WEBPACK_IMPORTED_MODULE_0__["ARRAY_BUFFER"]:
            return Float32Array;
        case _webgl_js__WEBPACK_IMPORTED_MODULE_0__["ELEMENT_ARRAY_BUFFER"]:
            return Uint32Array;
        default:
            return Float32Array;
    }
}
/* harmony default export */ __webpack_exports__["default"] = (WebGLArrayBuffer);
//# sourceMappingURL=Buffer.js.map

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_BUFFER", function() { return ARRAY_BUFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ELEMENT_ARRAY_BUFFER", function() { return ELEMENT_ARRAY_BUFFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STREAM_DRAW", function() { return STREAM_DRAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATIC_DRAW", function() { return STATIC_DRAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DYNAMIC_DRAW", function() { return DYNAMIC_DRAW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNSIGNED_BYTE", function() { return UNSIGNED_BYTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNSIGNED_SHORT", function() { return UNSIGNED_SHORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNSIGNED_INT", function() { return UNSIGNED_INT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOAT", function() { return FLOAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSupportedExtensions", function() { return getSupportedExtensions; });
/**
 * @module ol/webgl
 */
/**
 * Constants taken from goog.webgl
 */
/**
 * Used by {@link module:ol/webgl/Helper~WebGLHelper} for buffers containing vertices data, such as
 * position, color, texture coordinate, etc. These vertices are then referenced by an index buffer
 * to be drawn on screen (see {@link module:ol/webgl.ELEMENT_ARRAY_BUFFER}).
 * @const
 * @type {number}
 * @api
 */
var ARRAY_BUFFER = 0x8892;
/**
 * Used by {@link module:ol/webgl/Helper~WebGLHelper} for buffers containing indices data.
 * Index buffers are essentially lists of references to vertices defined in a vertex buffer
 * (see {@link module:ol/webgl.ARRAY_BUFFER}), and define the primitives (triangles) to be drawn.
 * @const
 * @type {number}
 * @api
 */
var ELEMENT_ARRAY_BUFFER = 0x8893;
/**
 * Used by {link module:ol/webgl/Buffer~WebGLArrayBuffer}.
 * @const
 * @type {number}
 * @api
 */
var STREAM_DRAW = 0x88e0;
/**
 * Used by {link module:ol/webgl/Buffer~WebGLArrayBuffer}.
 * @const
 * @type {number}
 * @api
 */
var STATIC_DRAW = 0x88e4;
/**
 * Used by {link module:ol/webgl/Buffer~WebGLArrayBuffer}.
 * @const
 * @type {number}
 * @api
 */
var DYNAMIC_DRAW = 0x88e8;
/**
 * @const
 * @type {number}
 */
var UNSIGNED_BYTE = 0x1401;
/**
 * @const
 * @type {number}
 */
var UNSIGNED_SHORT = 0x1403;
/**
 * @const
 * @type {number}
 */
var UNSIGNED_INT = 0x1405;
/**
 * @const
 * @type {number}
 */
var FLOAT = 0x1406;
/** end of goog.webgl constants
 */
/**
 * @const
 * @type {Array<string>}
 */
var CONTEXT_IDS = ['experimental-webgl', 'webgl', 'webkit-3d', 'moz-webgl'];
/**
 * @param {HTMLCanvasElement} canvas Canvas.
 * @param {Object} [opt_attributes] Attributes.
 * @return {WebGLRenderingContext} WebGL rendering context.
 */
function getContext(canvas, opt_attributes) {
    var ii = CONTEXT_IDS.length;
    for (var i = 0; i < ii; ++i) {
        try {
            var context = canvas.getContext(CONTEXT_IDS[i], opt_attributes);
            if (context) {
                return /** @type {!WebGLRenderingContext} */ (context);
            }
        }
        catch (e) {
            // pass
        }
    }
    return null;
}
/**
 * @type {Array<string>}
 */
var supportedExtensions;
/**
 * @return {Array<string>} List of supported WebGL extensions.
 */
function getSupportedExtensions() {
    if (!supportedExtensions) {
        var canvas = document.createElement('canvas');
        var gl = getContext(canvas);
        if (gl) {
            supportedExtensions = gl.getSupportedExtensions();
        }
    }
    return supportedExtensions;
}
//# sourceMappingURL=webgl.js.map

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebGLWorkerMessageType", function() { return WebGLWorkerMessageType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writePointFeatureToBuffers", function() { return writePointFeatureToBuffers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBlankImageData", function() { return getBlankImageData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorEncodeId", function() { return colorEncodeId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorDecodeId", function() { return colorDecodeId; });
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(137);
/* harmony import */ var _render_Event_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(138);
/* harmony import */ var _render_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(134);
/* harmony import */ var _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(324);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/webgl/Layer
 */




/**
 * @enum {string}
 */
var WebGLWorkerMessageType = {
    GENERATE_BUFFERS: 'GENERATE_BUFFERS',
};
/**
 * @typedef {Object} WebGLWorkerGenerateBuffersMessage
 * This message will trigger the generation of a vertex and an index buffer based on the given render instructions.
 * When the buffers are generated, the worked will send a message of the same type to the main thread, with
 * the generated buffers in it.
 * Note that any addition properties present in the message *will* be sent back to the main thread.
 * @property {WebGLWorkerMessageType} type Message type
 * @property {ArrayBuffer} renderInstructions Render instructions raw binary buffer.
 * @property {ArrayBuffer} [vertexBuffer] Vertices array raw binary buffer (sent by the worker).
 * @property {ArrayBuffer} [indexBuffer] Indices array raw binary buffer (sent by the worker).
 * @property {number} [customAttributesCount] Amount of custom attributes count in the render instructions.
 */
/**
 * @typedef {Object} PostProcessesOptions
 * @property {number} [scaleRatio] Scale ratio; if < 1, the post process will render to a texture smaller than
 * the main canvas that will then be sampled up (useful for saving resource on blur steps).
 * @property {string} [vertexShader] Vertex shader source
 * @property {string} [fragmentShader] Fragment shader source
 * @property {Object<string,import("../../webgl/Helper").UniformValue>} [uniforms] Uniform definitions for the post process step
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the canvas element.
 * @property {Object<string,import("../../webgl/Helper").UniformValue>} [uniforms] Uniform definitions for the post process steps
 * @property {Array<PostProcessesOptions>} [postProcesses] Post-processes definitions
 */
/**
 * @classdesc
 * Base WebGL renderer class.
 * Holds all logic related to data manipulation & some common rendering logic
 * @template {import("../../layer/Layer.js").default} LayerType
 */
var WebGLLayerRenderer = /** @class */ (function (_super) {
    __extends(WebGLLayerRenderer, _super);
    /**
     * @param {LayerType} layer Layer.
     * @param {Options} [opt_options] Options.
     */
    function WebGLLayerRenderer(layer, opt_options) {
        var _this = _super.call(this, layer) || this;
        var options = opt_options || {};
        /**
         * @type {WebGLHelper}
         * @protected
         */
        _this.helper = new _webgl_Helper_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
            postProcesses: options.postProcesses,
            uniforms: options.uniforms,
        });
        if (options.className !== undefined) {
            _this.helper.getCanvas().className = options.className;
        }
        return _this;
    }
    /**
     * Clean up.
     */
    WebGLLayerRenderer.prototype.disposeInternal = function () {
        this.helper.dispose();
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * @param {import("../../render/EventType.js").default} type Event type.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */
    WebGLLayerRenderer.prototype.dispatchRenderEvent_ = function (type, frameState) {
        var layer = this.getLayer();
        if (layer.hasListener(type)) {
            // RenderEvent does not get a context or an inversePixelTransform, because WebGL allows much less direct editing than Canvas2d does.
            var event_1 = new _render_Event_js__WEBPACK_IMPORTED_MODULE_1__["default"](type, null, frameState, null);
            layer.dispatchEvent(event_1);
        }
    };
    /**
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */
    WebGLLayerRenderer.prototype.preRender = function (frameState) {
        this.dispatchRenderEvent_(_render_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].PRERENDER, frameState);
    };
    /**
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @protected
     */
    WebGLLayerRenderer.prototype.postRender = function (frameState) {
        this.dispatchRenderEvent_(_render_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].POSTRENDER, frameState);
    };
    return WebGLLayerRenderer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
var tmpArray_ = [];
var bufferPositions_ = { vertexPosition: 0, indexPosition: 0 };
function writePointVertex(buffer, pos, x, y, index) {
    buffer[pos + 0] = x;
    buffer[pos + 1] = y;
    buffer[pos + 2] = index;
}
/**
 * An object holding positions both in an index and a vertex buffer.
 * @typedef {Object} BufferPositions
 * @property {number} vertexPosition Position in the vertex buffer
 * @property {number} indexPosition Position in the index buffer
 */
/**
 * Pushes a quad (two triangles) based on a point geometry
 * @param {Float32Array} instructions Array of render instructions for points.
 * @param {number} elementIndex Index from which render instructions will be read.
 * @param {Float32Array} vertexBuffer Buffer in the form of a typed array.
 * @param {Uint32Array} indexBuffer Buffer in the form of a typed array.
 * @param {number} customAttributesCount Amount of custom attributes for each element.
 * @param {BufferPositions} [bufferPositions] Buffer write positions; if not specified, positions will be set at 0.
 * @return {BufferPositions} New buffer positions where to write next
 * @property {number} vertexPosition New position in the vertex buffer where future writes should start.
 * @property {number} indexPosition New position in the index buffer where future writes should start.
 * @private
 */
function writePointFeatureToBuffers(instructions, elementIndex, vertexBuffer, indexBuffer, customAttributesCount, bufferPositions) {
    // This is for x, y and index
    var baseVertexAttrsCount = 3;
    var baseInstructionsCount = 2;
    var stride = baseVertexAttrsCount + customAttributesCount;
    var x = instructions[elementIndex + 0];
    var y = instructions[elementIndex + 1];
    // read custom numerical attributes on the feature
    var customAttrs = tmpArray_;
    customAttrs.length = customAttributesCount;
    for (var i = 0; i < customAttrs.length; i++) {
        customAttrs[i] = instructions[elementIndex + baseInstructionsCount + i];
    }
    var vPos = bufferPositions ? bufferPositions.vertexPosition : 0;
    var iPos = bufferPositions ? bufferPositions.indexPosition : 0;
    var baseIndex = vPos / stride;
    // push vertices for each of the four quad corners (first standard then custom attributes)
    writePointVertex(vertexBuffer, vPos, x, y, 0);
    customAttrs.length &&
        vertexBuffer.set(customAttrs, vPos + baseVertexAttrsCount);
    vPos += stride;
    writePointVertex(vertexBuffer, vPos, x, y, 1);
    customAttrs.length &&
        vertexBuffer.set(customAttrs, vPos + baseVertexAttrsCount);
    vPos += stride;
    writePointVertex(vertexBuffer, vPos, x, y, 2);
    customAttrs.length &&
        vertexBuffer.set(customAttrs, vPos + baseVertexAttrsCount);
    vPos += stride;
    writePointVertex(vertexBuffer, vPos, x, y, 3);
    customAttrs.length &&
        vertexBuffer.set(customAttrs, vPos + baseVertexAttrsCount);
    vPos += stride;
    indexBuffer[iPos++] = baseIndex;
    indexBuffer[iPos++] = baseIndex + 1;
    indexBuffer[iPos++] = baseIndex + 3;
    indexBuffer[iPos++] = baseIndex + 1;
    indexBuffer[iPos++] = baseIndex + 2;
    indexBuffer[iPos++] = baseIndex + 3;
    bufferPositions_.vertexPosition = vPos;
    bufferPositions_.indexPosition = iPos;
    return bufferPositions_;
}
/**
 * Returns a texture of 1x1 pixel, white
 * @private
 * @return {ImageData} Image data.
 */
function getBlankImageData() {
    var canvas = document.createElement('canvas');
    var image = canvas.getContext('2d').createImageData(1, 1);
    image.data[0] = 255;
    image.data[1] = 255;
    image.data[2] = 255;
    image.data[3] = 255;
    return image;
}
/**
 * Generates a color array based on a numerical id
 * Note: the range for each component is 0 to 1 with 256 steps
 * @param {number} id Id
 * @param {Array<number>} [opt_array] Reusable array
 * @return {Array<number>} Color array containing the encoded id
 */
function colorEncodeId(id, opt_array) {
    var array = opt_array || [];
    var radix = 256;
    var divide = radix - 1;
    array[0] = Math.floor(id / radix / radix / radix) / divide;
    array[1] = (Math.floor(id / radix / radix) % radix) / divide;
    array[2] = (Math.floor(id / radix) % radix) / divide;
    array[3] = (id % radix) / divide;
    return array;
}
/**
 * Reads an id from a color-encoded array
 * Note: the expected range for each component is 0 to 1 with 256 steps.
 * @param {Array<number>} color Color array containing the encoded id
 * @return {number} Decoded id
 */
function colorDecodeId(color) {
    var id = 0;
    var radix = 256;
    var mult = radix - 1;
    id += Math.round(color[0] * radix * radix * radix * mult);
    id += Math.round(color[1] * radix * radix * mult);
    id += Math.round(color[2] * radix * mult);
    id += Math.round(color[3] * mult);
    return id;
}
/* harmony default export */ __webpack_exports__["default"] = (WebGLLayerRenderer);
//# sourceMappingURL=Layer.js.map

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShaderType", function() { return ShaderType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultUniform", function() { return DefaultUniform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AttributeType", function() { return AttributeType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "computeAttributesStride", function() { return computeAttributesStride; });
/* harmony import */ var _webgl_ContextEventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(325);
/* harmony import */ var _Disposable_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50);
/* harmony import */ var _PostProcessingPass_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(326);
/* harmony import */ var _webgl_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(322);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(101);
/* harmony import */ var _vec_mat4_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(327);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(52);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/webgl/Helper
 */










/**
 * @typedef {Object} BufferCacheEntry
 * @property {import("./Buffer.js").default} buffer Buffer.
 * @property {WebGLBuffer} webGlBuffer WebGlBuffer.
 */
/**
 * Shader types, either `FRAGMENT_SHADER` or `VERTEX_SHADER`.
 * @enum {number}
 */
var ShaderType = {
    FRAGMENT_SHADER: 0x8b30,
    VERTEX_SHADER: 0x8b31,
};
/**
 * Uniform names used in the default shaders: `PROJECTION_MATRIX`, `OFFSET_SCALE_MATRIX`.
 * and `OFFSET_ROTATION_MATRIX`.
 * @enum {string}
 */
var DefaultUniform = {
    PROJECTION_MATRIX: 'u_projectionMatrix',
    OFFSET_SCALE_MATRIX: 'u_offsetScaleMatrix',
    OFFSET_ROTATION_MATRIX: 'u_offsetRotateMatrix',
    TIME: 'u_time',
    ZOOM: 'u_zoom',
    RESOLUTION: 'u_resolution',
};
/**
 * Attribute types, either `UNSIGNED_BYTE`, `UNSIGNED_SHORT`, `UNSIGNED_INT` or `FLOAT`
 * Note: an attribute stored in a `Float32Array` should be of type `FLOAT`.
 * @enum {number}
 */
var AttributeType = {
    UNSIGNED_BYTE: _webgl_js__WEBPACK_IMPORTED_MODULE_3__["UNSIGNED_BYTE"],
    UNSIGNED_SHORT: _webgl_js__WEBPACK_IMPORTED_MODULE_3__["UNSIGNED_SHORT"],
    UNSIGNED_INT: _webgl_js__WEBPACK_IMPORTED_MODULE_3__["UNSIGNED_INT"],
    FLOAT: _webgl_js__WEBPACK_IMPORTED_MODULE_3__["FLOAT"],
};
/**
 * Description of an attribute in a buffer
 * @typedef {Object} AttributeDescription
 * @property {string} name Attribute name to use in shaders
 * @property {number} size Number of components per attributes
 * @property {AttributeType} [type] Attribute type, i.e. number of bytes used to store the value. This is
 * determined by the class of typed array which the buffer uses (eg. `Float32Array` for a `FLOAT` attribute).
 * Default is `FLOAT`.
 */
/**
 * @typedef {number|Array<number>|HTMLCanvasElement|HTMLImageElement|ImageData|import("../transform").Transform} UniformLiteralValue
 */
/**
 * Uniform value can be a number, array of numbers (2 to 4), canvas element or a callback returning
 * one of the previous types.
 * @typedef {UniformLiteralValue|function(import("../PluggableMap.js").FrameState):UniformLiteralValue} UniformValue
 */
/**
 * @typedef {Object} PostProcessesOptions
 * @property {number} [scaleRatio] Scale ratio; if < 1, the post process will render to a texture smaller than
 * the main canvas which will then be sampled up (useful for saving resource on blur steps).
 * @property {string} [vertexShader] Vertex shader source
 * @property {string} [fragmentShader] Fragment shader source
 * @property {Object<string,UniformValue>} [uniforms] Uniform definitions for the post process step
 */
/**
 * @typedef {Object} Options
 * @property {Object<string,UniformValue>} [uniforms] Uniform definitions; property names must match the uniform
 * names in the provided or default shaders.
 * @property {Array<PostProcessesOptions>} [postProcesses] Post-processes definitions
 */
/**
 * @typedef {Object} UniformInternalDescription
 * @property {string} name Name
 * @property {UniformValue} [value] Value
 * @property {WebGLTexture} [texture] Texture
 * @private
 */
/**
 * @classdesc
 * This class is intended to provide low-level functions related to WebGL rendering, so that accessing
 * directly the WebGL API should not be required anymore.
 *
 * Several operations are handled by the `WebGLHelper` class:
 *
 * ### Define custom shaders and uniforms
 *
 *   *Shaders* are low-level programs executed on the GPU and written in GLSL. There are two types of shaders:
 *
 *   Vertex shaders are used to manipulate the position and attribute of *vertices* of rendered primitives (ie. corners of a square).
 *   Outputs are:
 *
 *   * `gl_Position`: position of the vertex in screen space
 *
 *   * Varyings usually prefixed with `v_` are passed on to the fragment shader
 *
 *   Fragment shaders are used to control the actual color of the pixels drawn on screen. Their only output is `gl_FragColor`.
 *
 *   Both shaders can take *uniforms* or *attributes* as input. Attributes are explained later. Uniforms are common, read-only values that
 *   can be changed at every frame and can be of type float, arrays of float or images.
 *
 *   Shaders must be compiled and assembled into a program like so:
 *   ```js
 *   // here we simply create two shaders and assemble them in a program which is then used
 *   // for subsequent rendering calls
 *   const vertexShader = new WebGLVertex(VERTEX_SHADER);
 *   const fragmentShader = new WebGLFragment(FRAGMENT_SHADER);
 *   const program = this.context.getProgram(fragmentShader, vertexShader);
 *   helper.useProgram(this.program);
 *   ```
 *
 *   Uniforms are defined using the `uniforms` option and can either be explicit values or callbacks taking the frame state as argument.
 *   You can also change their value along the way like so:
 *   ```js
 *   helper.setUniformFloatValue('u_value', valueAsNumber);
 *   ```
 *
 * ### Defining post processing passes
 *
 *   *Post processing* describes the act of rendering primitives to a texture, and then rendering this texture to the final canvas
 *   while applying special effects in screen space.
 *   Typical uses are: blurring, color manipulation, depth of field, filtering...
 *
 *   The `WebGLHelper` class offers the possibility to define post processes at creation time using the `postProcesses` option.
 *   A post process step accepts the following options:
 *
 *   * `fragmentShader` and `vertexShader`: text literals in GLSL language that will be compiled and used in the post processing step.
 *   * `uniforms`: uniforms can be defined for the post processing steps just like for the main render.
 *   * `scaleRatio`: allows using an intermediate texture smaller or higher than the final canvas in the post processing step.
 *     This is typically used in blur steps to reduce the performance overhead by using an already downsampled texture as input.
 *
 *   The {@link module:ol/webgl/PostProcessingPass~WebGLPostProcessingPass} class is used internally, refer to its documentation for more info.
 *
 * ### Binding WebGL buffers and flushing data into them
 *
 *   Data that must be passed to the GPU has to be transferred using {@link module:ol/webgl/Buffer~WebGLArrayBuffer} objects.
 *   A buffer has to be created only once, but must be bound every time the buffer content will be used for rendering.
 *   This is done using {@link bindBuffer}.
 *   When the buffer's array content has changed, the new data has to be flushed to the GPU memory; this is done using
 *   {@link flushBufferData}. Note: this operation is expensive and should be done as infrequently as possible.
 *
 *   When binding an array buffer, a `target` parameter must be given: it should be either {@link module:ol/webgl.ARRAY_BUFFER}
 *   (if the buffer contains vertices data) or {@link module:ol/webgl.ELEMENT_ARRAY_BUFFER} (if the buffer contains indices data).
 *
 *   Examples below:
 *   ```js
 *   // at initialization phase
 *   const verticesBuffer = new WebGLArrayBuffer([], DYNAMIC_DRAW);
 *   const indicesBuffer = new WebGLArrayBuffer([], DYNAMIC_DRAW);
 *
 *   // when array values have changed
 *   helper.flushBufferData(ARRAY_BUFFER, this.verticesBuffer);
 *   helper.flushBufferData(ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
 *
 *   // at rendering phase
 *   helper.bindBuffer(ARRAY_BUFFER, this.verticesBuffer);
 *   helper.bindBuffer(ELEMENT_ARRAY_BUFFER, this.indicesBuffer);
 *   ```
 *
 * ### Specifying attributes
 *
 *   The GPU only receives the data as arrays of numbers. These numbers must be handled differently depending on what it describes (position, texture coordinate...).
 *   Attributes are used to specify these uses. Use {@link enableAttributeArray_} and either
 *   the default attribute names in {@link module:ol/webgl/Helper.DefaultAttrib} or custom ones.
 *
 *   Please note that you will have to specify the type and offset of the attributes in the data array. You can refer to the documentation of [WebGLRenderingContext.vertexAttribPointer](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/vertexAttribPointer) for more explanation.
 *   ```js
 *   // here we indicate that the data array has the following structure:
 *   // [posX, posY, offsetX, offsetY, texCoordU, texCoordV, posX, posY, ...]
 *   helper.enableAttributes([
 *     {
 *        name: 'a_position',
 *        size: 2
 *     },
 *     {
 *       name: 'a_offset',
 *       size: 2
 *     },
 *     {
 *       name: 'a_texCoord',
 *       size: 2
 *     }
 *   ])
 *   ```
 *
 * ### Rendering primitives
 *
 *   Once all the steps above have been achieved, rendering primitives to the screen is done using {@link prepareDraw}, {@link drawElements} and {@link finalizeDraw}.
 *   ```js
 *   // frame preparation step
 *   helper.prepareDraw(frameState);
 *
 *   // call this for every data array that has to be rendered on screen
 *   helper.drawElements(0, this.indicesBuffer.getArray().length);
 *
 *   // finalize the rendering by applying post processes
 *   helper.finalizeDraw(frameState);
 *   ```
 *
 * For an example usage of this class, refer to {@link module:ol/renderer/webgl/PointsLayer~WebGLPointsLayerRenderer}.
 *
 *
 * @api
 */
var WebGLHelper = /** @class */ (function (_super) {
    __extends(WebGLHelper, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function WebGLHelper(opt_options) {
        var _this = _super.call(this) || this;
        var options = opt_options || {};
        /** @private */
        _this.boundHandleWebGLContextLost_ = _this.handleWebGLContextLost.bind(_this);
        /** @private */
        _this.boundHandleWebGLContextRestored_ =
            _this.handleWebGLContextRestored.bind(_this);
        /**
         * @private
         * @type {HTMLCanvasElement}
         */
        _this.canvas_ = document.createElement('canvas');
        _this.canvas_.style.position = 'absolute';
        _this.canvas_.style.left = '0';
        /**
         * @private
         * @type {WebGLRenderingContext}
         */
        _this.gl_ = Object(_webgl_js__WEBPACK_IMPORTED_MODULE_3__["getContext"])(_this.canvas_);
        var gl = _this.getGL();
        /**
         * @private
         * @type {!Object<string, BufferCacheEntry>}
         */
        _this.bufferCache_ = {};
        /**
         * @private
         * @type {WebGLProgram}
         */
        _this.currentProgram_ = null;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(Object(_array_js__WEBPACK_IMPORTED_MODULE_9__["includes"])(Object(_webgl_js__WEBPACK_IMPORTED_MODULE_3__["getSupportedExtensions"])(), 'OES_element_index_uint'), 63);
        gl.getExtension('OES_element_index_uint');
        _this.canvas_.addEventListener(_webgl_ContextEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOST, _this.boundHandleWebGLContextLost_);
        _this.canvas_.addEventListener(_webgl_ContextEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].RESTORED, _this.boundHandleWebGLContextRestored_);
        /**
         * @private
         * @type {import("../transform.js").Transform}
         */
        _this.offsetRotateMatrix_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["create"])();
        /**
         * @private
         * @type {import("../transform.js").Transform}
         */
        _this.offsetScaleMatrix_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["create"])();
        /**
         * @private
         * @type {Array<number>}
         */
        _this.tmpMat4_ = Object(_vec_mat4_js__WEBPACK_IMPORTED_MODULE_7__["create"])();
        /**
         * @private
         * @type {Object<string, WebGLUniformLocation>}
         */
        _this.uniformLocations_ = {};
        /**
         * @private
         * @type {Object<string, number>}
         */
        _this.attribLocations_ = {};
        /**
         * Holds info about custom uniforms used in the post processing pass.
         * If the uniform is a texture, the WebGL Texture object will be stored here.
         * @type {Array<UniformInternalDescription>}
         * @private
         */
        _this.uniforms_ = [];
        if (options.uniforms) {
            for (var name_1 in options.uniforms) {
                _this.uniforms_.push({
                    name: name_1,
                    value: options.uniforms[name_1],
                });
            }
        }
        /**
         * An array of PostProcessingPass objects is kept in this variable, built from the steps provided in the
         * options. If no post process was given, a default one is used (so as not to have to make an exception to
         * the frame buffer logic).
         * @type {Array<WebGLPostProcessingPass>}
         * @private
         */
        _this.postProcessPasses_ = options.postProcesses
            ? options.postProcesses.map(function (options) {
                return new _PostProcessingPass_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
                    webGlContext: gl,
                    scaleRatio: options.scaleRatio,
                    vertexShader: options.vertexShader,
                    fragmentShader: options.fragmentShader,
                    uniforms: options.uniforms,
                });
            })
            : [new _PostProcessingPass_js__WEBPACK_IMPORTED_MODULE_2__["default"]({ webGlContext: gl })];
        /**
         * @type {string|null}
         * @private
         */
        _this.shaderCompileErrors_ = null;
        /**
         * @type {number}
         * @private
         */
        _this.startTime_ = Date.now();
        return _this;
    }
    /**
     * Just bind the buffer if it's in the cache. Otherwise create
     * the WebGL buffer, bind it, populate it, and add an entry to
     * the cache.
     * @param {import("./Buffer").default} buffer Buffer.
     * @api
     */
    WebGLHelper.prototype.bindBuffer = function (buffer) {
        var gl = this.getGL();
        var bufferKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_8__["getUid"])(buffer);
        var bufferCache = this.bufferCache_[bufferKey];
        if (!bufferCache) {
            var webGlBuffer = gl.createBuffer();
            bufferCache = {
                buffer: buffer,
                webGlBuffer: webGlBuffer,
            };
            this.bufferCache_[bufferKey] = bufferCache;
        }
        gl.bindBuffer(buffer.getType(), bufferCache.webGlBuffer);
    };
    /**
     * Update the data contained in the buffer array; this is required for the
     * new data to be rendered
     * @param {import("./Buffer").default} buffer Buffer.
     * @api
     */
    WebGLHelper.prototype.flushBufferData = function (buffer) {
        var gl = this.getGL();
        this.bindBuffer(buffer);
        gl.bufferData(buffer.getType(), buffer.getArray(), buffer.getUsage());
    };
    /**
     * @param {import("./Buffer.js").default} buf Buffer.
     */
    WebGLHelper.prototype.deleteBuffer = function (buf) {
        var gl = this.getGL();
        var bufferKey = Object(_util_js__WEBPACK_IMPORTED_MODULE_8__["getUid"])(buf);
        var bufferCacheEntry = this.bufferCache_[bufferKey];
        if (bufferCacheEntry && !gl.isContextLost()) {
            gl.deleteBuffer(bufferCacheEntry.webGlBuffer);
        }
        delete this.bufferCache_[bufferKey];
    };
    /**
     * Clean up.
     */
    WebGLHelper.prototype.disposeInternal = function () {
        this.canvas_.removeEventListener(_webgl_ContextEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].LOST, this.boundHandleWebGLContextLost_);
        this.canvas_.removeEventListener(_webgl_ContextEventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].RESTORED, this.boundHandleWebGLContextRestored_);
    };
    /**
     * Clear the buffer & set the viewport to draw.
     * Post process passes will be initialized here, the first one being bound as a render target for
     * subsequent draw calls.
     * @param {import("../PluggableMap.js").FrameState} frameState current frame state
     * @api
     */
    WebGLHelper.prototype.prepareDraw = function (frameState) {
        var gl = this.getGL();
        var canvas = this.getCanvas();
        var size = frameState.size;
        var pixelRatio = frameState.pixelRatio;
        canvas.width = size[0] * pixelRatio;
        canvas.height = size[1] * pixelRatio;
        canvas.style.width = size[0] + 'px';
        canvas.style.height = size[1] + 'px';
        gl.useProgram(this.currentProgram_);
        // loop backwards in post processes list
        for (var i = this.postProcessPasses_.length - 1; i >= 0; i--) {
            this.postProcessPasses_[i].init(frameState);
        }
        gl.bindTexture(gl.TEXTURE_2D, null);
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.useProgram(this.currentProgram_);
        this.applyFrameState(frameState);
        this.applyUniforms(frameState);
    };
    /**
     * Clear the render target & bind it for future draw operations.
     * This is similar to `prepareDraw`, only post processes will not be applied.
     * Note: the whole viewport will be drawn to the render target, regardless of its size.
     * @param {import("../PluggableMap.js").FrameState} frameState current frame state
     * @param {import("./RenderTarget.js").default} renderTarget Render target to draw to
     * @param {boolean} [opt_disableAlphaBlend] If true, no alpha blending will happen.
     */
    WebGLHelper.prototype.prepareDrawToRenderTarget = function (frameState, renderTarget, opt_disableAlphaBlend) {
        var gl = this.getGL();
        var size = renderTarget.getSize();
        gl.bindFramebuffer(gl.FRAMEBUFFER, renderTarget.getFramebuffer());
        gl.viewport(0, 0, size[0], size[1]);
        gl.bindTexture(gl.TEXTURE_2D, renderTarget.getTexture());
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, opt_disableAlphaBlend ? gl.ZERO : gl.ONE_MINUS_SRC_ALPHA);
        gl.useProgram(this.currentProgram_);
        this.applyFrameState(frameState);
        this.applyUniforms(frameState);
    };
    /**
     * Execute a draw call based on the currently bound program, texture, buffers, attributes.
     * @param {number} start Start index.
     * @param {number} end End index.
     * @api
     */
    WebGLHelper.prototype.drawElements = function (start, end) {
        var gl = this.getGL();
        var elementType = gl.UNSIGNED_INT;
        var elementSize = 4;
        var numItems = end - start;
        var offsetInBytes = start * elementSize;
        gl.drawElements(gl.TRIANGLES, numItems, elementType, offsetInBytes);
    };
    /**
     * Apply the successive post process passes which will eventually render to the actual canvas.
     * @param {import("../PluggableMap.js").FrameState} frameState current frame state
     * @api
     */
    WebGLHelper.prototype.finalizeDraw = function (frameState) {
        // apply post processes using the next one as target
        for (var i = 0; i < this.postProcessPasses_.length; i++) {
            this.postProcessPasses_[i].apply(frameState, this.postProcessPasses_[i + 1] || null);
        }
    };
    /**
     * @return {HTMLCanvasElement} Canvas.
     * @api
     */
    WebGLHelper.prototype.getCanvas = function () {
        return this.canvas_;
    };
    /**
     * Get the WebGL rendering context
     * @return {WebGLRenderingContext} The rendering context.
     * @api
     */
    WebGLHelper.prototype.getGL = function () {
        return this.gl_;
    };
    /**
     * Sets the default matrix uniforms for a given frame state. This is called internally in `prepareDraw`.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */
    WebGLHelper.prototype.applyFrameState = function (frameState) {
        var size = frameState.size;
        var rotation = frameState.viewState.rotation;
        var offsetScaleMatrix = Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["reset"])(this.offsetScaleMatrix_);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["scale"])(offsetScaleMatrix, 2 / size[0], 2 / size[1]);
        var offsetRotateMatrix = Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["reset"])(this.offsetRotateMatrix_);
        if (rotation !== 0) {
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["rotate"])(offsetRotateMatrix, -rotation);
        }
        this.setUniformMatrixValue(DefaultUniform.OFFSET_SCALE_MATRIX, Object(_vec_mat4_js__WEBPACK_IMPORTED_MODULE_7__["fromTransform"])(this.tmpMat4_, offsetScaleMatrix));
        this.setUniformMatrixValue(DefaultUniform.OFFSET_ROTATION_MATRIX, Object(_vec_mat4_js__WEBPACK_IMPORTED_MODULE_7__["fromTransform"])(this.tmpMat4_, offsetRotateMatrix));
        this.setUniformFloatValue(DefaultUniform.TIME, (Date.now() - this.startTime_) * 0.001);
        this.setUniformFloatValue(DefaultUniform.ZOOM, frameState.viewState.zoom);
        this.setUniformFloatValue(DefaultUniform.RESOLUTION, frameState.viewState.resolution);
    };
    /**
     * Sets the custom uniforms based on what was given in the constructor. This is called internally in `prepareDraw`.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */
    WebGLHelper.prototype.applyUniforms = function (frameState) {
        var gl = this.getGL();
        var value;
        var textureSlot = 0;
        this.uniforms_.forEach(function (uniform) {
            value =
                typeof uniform.value === 'function'
                    ? uniform.value(frameState)
                    : uniform.value;
            // apply value based on type
            if (value instanceof HTMLCanvasElement ||
                value instanceof HTMLImageElement ||
                value instanceof ImageData) {
                // create a texture & put data
                if (!uniform.texture) {
                    uniform.prevValue = undefined;
                    uniform.texture = gl.createTexture();
                }
                gl.activeTexture(gl["TEXTURE" + textureSlot]);
                gl.bindTexture(gl.TEXTURE_2D, uniform.texture);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                var imageReady = !(value instanceof HTMLImageElement) ||
                    /** @type {HTMLImageElement} */ (value).complete;
                if (imageReady && uniform.prevValue !== value) {
                    uniform.prevValue = value;
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, value);
                }
                // fill texture slots by increasing index
                gl.uniform1i(this.getUniformLocation(uniform.name), textureSlot++);
            }
            else if (Array.isArray(value) && value.length === 6) {
                this.setUniformMatrixValue(uniform.name, Object(_vec_mat4_js__WEBPACK_IMPORTED_MODULE_7__["fromTransform"])(this.tmpMat4_, value));
            }
            else if (Array.isArray(value) && value.length <= 4) {
                switch (value.length) {
                    case 2:
                        gl.uniform2f(this.getUniformLocation(uniform.name), value[0], value[1]);
                        return;
                    case 3:
                        gl.uniform3f(this.getUniformLocation(uniform.name), value[0], value[1], value[2]);
                        return;
                    case 4:
                        gl.uniform4f(this.getUniformLocation(uniform.name), value[0], value[1], value[2], value[3]);
                        return;
                    default:
                        return;
                }
            }
            else if (typeof value === 'number') {
                gl.uniform1f(this.getUniformLocation(uniform.name), value);
            }
        }.bind(this));
    };
    /**
     * Use a program.  If the program is already in use, this will return `false`.
     * @param {WebGLProgram} program Program.
     * @return {boolean} Changed.
     * @api
     */
    WebGLHelper.prototype.useProgram = function (program) {
        if (program == this.currentProgram_) {
            return false;
        }
        else {
            var gl = this.getGL();
            gl.useProgram(program);
            this.currentProgram_ = program;
            this.uniformLocations_ = {};
            this.attribLocations_ = {};
            return true;
        }
    };
    /**
     * Will attempt to compile a vertex or fragment shader based on source
     * On error, the shader will be returned but
     * `gl.getShaderParameter(shader, gl.COMPILE_STATUS)` will return `true`
     * Use `gl.getShaderInfoLog(shader)` to have details
     * @param {string} source Shader source
     * @param {ShaderType} type VERTEX_SHADER or FRAGMENT_SHADER
     * @return {WebGLShader} Shader object
     */
    WebGLHelper.prototype.compileShader = function (source, type) {
        var gl = this.getGL();
        var shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        return shader;
    };
    /**
     * Create a program for a vertex and fragment shader.  Throws if shader compilation fails.
     * @param {string} fragmentShaderSource Fragment shader source.
     * @param {string} vertexShaderSource Vertex shader source.
     * @return {WebGLProgram} Program
     * @api
     */
    WebGLHelper.prototype.getProgram = function (fragmentShaderSource, vertexShaderSource) {
        var gl = this.getGL();
        var fragmentShader = this.compileShader(fragmentShaderSource, gl.FRAGMENT_SHADER);
        var vertexShader = this.compileShader(vertexShaderSource, gl.VERTEX_SHADER);
        var program = gl.createProgram();
        gl.attachShader(program, fragmentShader);
        gl.attachShader(program, vertexShader);
        gl.linkProgram(program);
        if (!gl.getShaderParameter(fragmentShader, gl.COMPILE_STATUS)) {
            var message = "Fragment shader compliation failed: " + gl.getShaderInfoLog(fragmentShader);
            throw new Error(message);
        }
        gl.deleteShader(fragmentShader);
        if (!gl.getShaderParameter(vertexShader, gl.COMPILE_STATUS)) {
            var message = "Vertex shader compilation failed: " + gl.getShaderInfoLog(vertexShader);
            throw new Error(message);
        }
        gl.deleteShader(vertexShader);
        if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
            var message = "GL program linking failed: " + gl.getShaderInfoLog(vertexShader);
            throw new Error(message);
        }
        return program;
    };
    /**
     * Will get the location from the shader or the cache
     * @param {string} name Uniform name
     * @return {WebGLUniformLocation} uniformLocation
     * @api
     */
    WebGLHelper.prototype.getUniformLocation = function (name) {
        if (this.uniformLocations_[name] === undefined) {
            this.uniformLocations_[name] = this.getGL().getUniformLocation(this.currentProgram_, name);
        }
        return this.uniformLocations_[name];
    };
    /**
     * Will get the location from the shader or the cache
     * @param {string} name Attribute name
     * @return {number} attribLocation
     * @api
     */
    WebGLHelper.prototype.getAttributeLocation = function (name) {
        if (this.attribLocations_[name] === undefined) {
            this.attribLocations_[name] = this.getGL().getAttribLocation(this.currentProgram_, name);
        }
        return this.attribLocations_[name];
    };
    /**
     * Modifies the given transform to apply the rotation/translation/scaling of the given frame state.
     * The resulting transform can be used to convert world space coordinates to view coordinates.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @param {import("../transform").Transform} transform Transform to update.
     * @return {import("../transform").Transform} The updated transform object.
     * @api
     */
    WebGLHelper.prototype.makeProjectionTransform = function (frameState, transform) {
        var size = frameState.size;
        var rotation = frameState.viewState.rotation;
        var resolution = frameState.viewState.resolution;
        var center = frameState.viewState.center;
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["reset"])(transform);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_6__["compose"])(transform, 0, 0, 2 / (resolution * size[0]), 2 / (resolution * size[1]), -rotation, -center[0], -center[1]);
        return transform;
    };
    /**
     * Give a value for a standard float uniform
     * @param {string} uniform Uniform name
     * @param {number} value Value
     * @api
     */
    WebGLHelper.prototype.setUniformFloatValue = function (uniform, value) {
        this.getGL().uniform1f(this.getUniformLocation(uniform), value);
    };
    /**
     * Give a value for a standard matrix4 uniform
     * @param {string} uniform Uniform name
     * @param {Array<number>} value Matrix value
     * @api
     */
    WebGLHelper.prototype.setUniformMatrixValue = function (uniform, value) {
        this.getGL().uniformMatrix4fv(this.getUniformLocation(uniform), false, value);
    };
    /**
     * Will set the currently bound buffer to an attribute of the shader program. Used by `#enableAttributes`
     * internally.
     * @param {string} attribName Attribute name
     * @param {number} size Number of components per attributes
     * @param {number} type UNSIGNED_INT, UNSIGNED_BYTE, UNSIGNED_SHORT or FLOAT
     * @param {number} stride Stride in bytes (0 means attribs are packed)
     * @param {number} offset Offset in bytes
     * @private
     */
    WebGLHelper.prototype.enableAttributeArray_ = function (attribName, size, type, stride, offset) {
        var location = this.getAttributeLocation(attribName);
        // the attribute has not been found in the shaders; do not enable it
        if (location < 0) {
            return;
        }
        this.getGL().enableVertexAttribArray(location);
        this.getGL().vertexAttribPointer(location, size, type, false, stride, offset);
    };
    /**
     * Will enable the following attributes to be read from the currently bound buffer,
     * i.e. tell the GPU where to read the different attributes in the buffer. An error in the
     * size/type/order of attributes will most likely break the rendering and throw a WebGL exception.
     * @param {Array<AttributeDescription>} attributes Ordered list of attributes to read from the buffer
     * @api
     */
    WebGLHelper.prototype.enableAttributes = function (attributes) {
        var stride = computeAttributesStride(attributes);
        var offset = 0;
        for (var i = 0; i < attributes.length; i++) {
            var attr = attributes[i];
            this.enableAttributeArray_(attr.name, attr.size, attr.type || _webgl_js__WEBPACK_IMPORTED_MODULE_3__["FLOAT"], stride, offset);
            offset += attr.size * getByteSizeFromType(attr.type);
        }
    };
    /**
     * WebGL context was lost
     * @private
     */
    WebGLHelper.prototype.handleWebGLContextLost = function () {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["clear"])(this.bufferCache_);
        this.currentProgram_ = null;
    };
    /**
     * WebGL context was restored
     * @private
     */
    WebGLHelper.prototype.handleWebGLContextRestored = function () { };
    /**
     * Will create or reuse a given webgl texture and apply the given size. If no image data
     * specified, the texture will be empty, otherwise image data will be used and the `size`
     * parameter will be ignored.
     * Note: wrap parameters are set to clamp to edge, min filter is set to linear.
     * @param {Array<number>} size Expected size of the texture
     * @param {ImageData|HTMLImageElement|HTMLCanvasElement} [opt_data] Image data/object to bind to the texture
     * @param {WebGLTexture} [opt_texture] Existing texture to reuse
     * @return {WebGLTexture} The generated texture
     * @api
     */
    WebGLHelper.prototype.createTexture = function (size, opt_data, opt_texture) {
        var gl = this.getGL();
        var texture = opt_texture || gl.createTexture();
        // set params & size
        var level = 0;
        var internalFormat = gl.RGBA;
        var border = 0;
        var format = gl.RGBA;
        var type = gl.UNSIGNED_BYTE;
        gl.bindTexture(gl.TEXTURE_2D, texture);
        if (opt_data) {
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, format, type, opt_data);
        }
        else {
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, size[0], size[1], border, format, type, null);
        }
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        return texture;
    };
    return WebGLHelper;
}(_Disposable_js__WEBPACK_IMPORTED_MODULE_1__["default"]));
/**
 * Compute a stride in bytes based on a list of attributes
 * @param {Array<AttributeDescription>} attributes Ordered list of attributes
 * @return {number} Stride, ie amount of values for each vertex in the vertex buffer
 * @api
 */
function computeAttributesStride(attributes) {
    var stride = 0;
    for (var i = 0; i < attributes.length; i++) {
        var attr = attributes[i];
        stride += attr.size * getByteSizeFromType(attr.type);
    }
    return stride;
}
/**
 * Computes the size in byte of an attribute type.
 * @param {AttributeType} type Attribute type
 * @return {number} The size in bytes
 */
function getByteSizeFromType(type) {
    switch (type) {
        case AttributeType.UNSIGNED_BYTE:
            return Uint8Array.BYTES_PER_ELEMENT;
        case AttributeType.UNSIGNED_SHORT:
            return Uint16Array.BYTES_PER_ELEMENT;
        case AttributeType.UNSIGNED_INT:
            return Uint32Array.BYTES_PER_ELEMENT;
        case AttributeType.FLOAT:
        default:
            return Float32Array.BYTES_PER_ELEMENT;
    }
}
/* harmony default export */ __webpack_exports__["default"] = (WebGLHelper);
//# sourceMappingURL=Helper.js.map

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/webgl/ContextEventType
 */
/**
 * @enum {string}
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    LOST: 'webglcontextlost',
    RESTORED: 'webglcontextrestored',
});
//# sourceMappingURL=ContextEventType.js.map

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/webgl/PostProcessingPass
 */
var DEFAULT_VERTEX_SHADER = "\n  precision mediump float;\n  \n  attribute vec2 a_position;\n  varying vec2 v_texCoord;\n  varying vec2 v_screenCoord;\n  \n  uniform vec2 u_screenSize;\n   \n  void main() {\n    v_texCoord = a_position * 0.5 + 0.5;\n    v_screenCoord = v_texCoord * u_screenSize;\n    gl_Position = vec4(a_position, 0.0, 1.0);\n  }\n";
var DEFAULT_FRAGMENT_SHADER = "\n  precision mediump float;\n   \n  uniform sampler2D u_image;\n   \n  varying vec2 v_texCoord;\n   \n  void main() {\n    gl_FragColor = texture2D(u_image, v_texCoord);\n  }\n";
/**
 * @typedef {Object} Options
 * @property {WebGLRenderingContext} webGlContext WebGL context; mandatory.
 * @property {number} [scaleRatio] Scale ratio; if < 1, the post process will render to a texture smaller than
 * the main canvas that will then be sampled up (useful for saving resource on blur steps).
 * @property {string} [vertexShader] Vertex shader source
 * @property {string} [fragmentShader] Fragment shader source
 * @property {Object<string,import("./Helper").UniformValue>} [uniforms] Uniform definitions for the post process step
 */
/**
 * @typedef {Object} UniformInternalDescription
 * @property {import("./Helper").UniformValue} value Value
 * @property {number} location Location
 * @property {WebGLTexture} [texture] Texture
 * @private
 */
/**
 * @classdesc
 * This class is used to define Post Processing passes with custom shaders and uniforms.
 * This is used internally by {@link module:ol/webgl/Helper~WebGLHelper}.
 *
 * Please note that the final output on the DOM canvas is expected to have premultiplied alpha, which means that
 * a pixel which is 100% red with an opacity of 50% must have a color of (r=0.5, g=0, b=0, a=0.5).
 * Failing to provide pixel colors with premultiplied alpha will result in render anomalies.
 *
 * The default post-processing pass does *not* multiply color values with alpha value, it expects color values to be
 * premultiplied.
 *
 * Default shaders are shown hereafter:
 *
 * * Vertex shader:
 *
 *   ```
 *   precision mediump float;
 *
 *   attribute vec2 a_position;
 *   varying vec2 v_texCoord;
 *   varying vec2 v_screenCoord;
 *
 *   uniform vec2 u_screenSize;
 *
 *   void main() {
 *     v_texCoord = a_position * 0.5 + 0.5;
 *     v_screenCoord = v_texCoord * u_screenSize;
 *     gl_Position = vec4(a_position, 0.0, 1.0);
 *   }
 *   ```
 *
 * * Fragment shader:
 *
 *   ```
 *   precision mediump float;
 *
 *   uniform sampler2D u_image;
 *
 *   varying vec2 v_texCoord;
 *
 *   void main() {
 *     gl_FragColor = texture2D(u_image, v_texCoord);
 *   }
 *   ```
 *
 * @api
 */
var WebGLPostProcessingPass = /** @class */ (function () {
    /**
     * @param {Options} options Options.
     */
    function WebGLPostProcessingPass(options) {
        this.gl_ = options.webGlContext;
        var gl = this.gl_;
        this.scaleRatio_ = options.scaleRatio || 1;
        this.renderTargetTexture_ = gl.createTexture();
        this.renderTargetTextureSize_ = null;
        this.frameBuffer_ = gl.createFramebuffer();
        // compile the program for the frame buffer
        // TODO: make compilation errors show up
        var vertexShader = gl.createShader(gl.VERTEX_SHADER);
        gl.shaderSource(vertexShader, options.vertexShader || DEFAULT_VERTEX_SHADER);
        gl.compileShader(vertexShader);
        var fragmentShader = gl.createShader(gl.FRAGMENT_SHADER);
        gl.shaderSource(fragmentShader, options.fragmentShader || DEFAULT_FRAGMENT_SHADER);
        gl.compileShader(fragmentShader);
        this.renderTargetProgram_ = gl.createProgram();
        gl.attachShader(this.renderTargetProgram_, vertexShader);
        gl.attachShader(this.renderTargetProgram_, fragmentShader);
        gl.linkProgram(this.renderTargetProgram_);
        // bind the vertices buffer for the frame buffer
        this.renderTargetVerticesBuffer_ = gl.createBuffer();
        var verticesArray = [-1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1];
        gl.bindBuffer(gl.ARRAY_BUFFER, this.renderTargetVerticesBuffer_);
        gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(verticesArray), gl.STATIC_DRAW);
        this.renderTargetAttribLocation_ = gl.getAttribLocation(this.renderTargetProgram_, 'a_position');
        this.renderTargetUniformLocation_ = gl.getUniformLocation(this.renderTargetProgram_, 'u_screenSize');
        this.renderTargetTextureLocation_ = gl.getUniformLocation(this.renderTargetProgram_, 'u_image');
        /**
         * Holds info about custom uniforms used in the post processing pass
         * @type {Array<UniformInternalDescription>}
         * @private
         */
        this.uniforms_ = [];
        options.uniforms &&
            Object.keys(options.uniforms).forEach(function (name) {
                this.uniforms_.push({
                    value: options.uniforms[name],
                    location: gl.getUniformLocation(this.renderTargetProgram_, name),
                });
            }.bind(this));
    }
    /**
     * Get the WebGL rendering context
     * @return {WebGLRenderingContext} The rendering context.
     * @api
     */
    WebGLPostProcessingPass.prototype.getGL = function () {
        return this.gl_;
    };
    /**
     * Initialize the render target texture of the post process, make sure it is at the
     * right size and bind it as a render target for the next draw calls.
     * The last step to be initialized will be the one where the primitives are rendered.
     * @param {import("../PluggableMap.js").FrameState} frameState current frame state
     * @api
     */
    WebGLPostProcessingPass.prototype.init = function (frameState) {
        var gl = this.getGL();
        var textureSize = [
            gl.drawingBufferWidth * this.scaleRatio_,
            gl.drawingBufferHeight * this.scaleRatio_,
        ];
        // rendering goes to my buffer
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.getFrameBuffer());
        gl.viewport(0, 0, textureSize[0], textureSize[1]);
        // if size has changed: adjust canvas & render target texture
        if (!this.renderTargetTextureSize_ ||
            this.renderTargetTextureSize_[0] !== textureSize[0] ||
            this.renderTargetTextureSize_[1] !== textureSize[1]) {
            this.renderTargetTextureSize_ = textureSize;
            // create a new texture
            var level = 0;
            var internalFormat = gl.RGBA;
            var border = 0;
            var format = gl.RGBA;
            var type = gl.UNSIGNED_BYTE;
            var data = null;
            gl.bindTexture(gl.TEXTURE_2D, this.renderTargetTexture_);
            gl.texImage2D(gl.TEXTURE_2D, level, internalFormat, textureSize[0], textureSize[1], border, format, type, data);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            // bind the texture to the framebuffer
            gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.renderTargetTexture_, 0);
        }
    };
    /**
     * Render to the next postprocessing pass (or to the canvas if final pass).
     * @param {import("../PluggableMap.js").FrameState} frameState current frame state
     * @param {WebGLPostProcessingPass} [nextPass] Next pass, optional
     * @api
     */
    WebGLPostProcessingPass.prototype.apply = function (frameState, nextPass) {
        var gl = this.getGL();
        var size = frameState.size;
        gl.bindFramebuffer(gl.FRAMEBUFFER, nextPass ? nextPass.getFrameBuffer() : null);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, this.renderTargetTexture_);
        // render the frame buffer to the canvas
        gl.clearColor(0.0, 0.0, 0.0, 0.0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.enable(gl.BLEND);
        gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
        gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
        gl.bindBuffer(gl.ARRAY_BUFFER, this.renderTargetVerticesBuffer_);
        gl.useProgram(this.renderTargetProgram_);
        gl.enableVertexAttribArray(this.renderTargetAttribLocation_);
        gl.vertexAttribPointer(this.renderTargetAttribLocation_, 2, gl.FLOAT, false, 0, 0);
        gl.uniform2f(this.renderTargetUniformLocation_, size[0], size[1]);
        gl.uniform1i(this.renderTargetTextureLocation_, 0);
        this.applyUniforms(frameState);
        gl.drawArrays(gl.TRIANGLES, 0, 6);
    };
    /**
     * @return {WebGLFramebuffer} Frame buffer
     * @api
     */
    WebGLPostProcessingPass.prototype.getFrameBuffer = function () {
        return this.frameBuffer_;
    };
    /**
     * Sets the custom uniforms based on what was given in the constructor.
     * @param {import("../PluggableMap.js").FrameState} frameState Frame state.
     * @private
     */
    WebGLPostProcessingPass.prototype.applyUniforms = function (frameState) {
        var gl = this.getGL();
        var value;
        var textureSlot = 1;
        this.uniforms_.forEach(function (uniform) {
            value =
                typeof uniform.value === 'function'
                    ? uniform.value(frameState)
                    : uniform.value;
            // apply value based on type
            if (value instanceof HTMLCanvasElement || value instanceof ImageData) {
                // create a texture & put data
                if (!uniform.texture) {
                    uniform.texture = gl.createTexture();
                }
                gl.activeTexture(gl["TEXTURE" + textureSlot]);
                gl.bindTexture(gl.TEXTURE_2D, uniform.texture);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
                if (value instanceof ImageData) {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, value.width, value.height, 0, gl.UNSIGNED_BYTE, new Uint8Array(value.data));
                }
                else {
                    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, value);
                }
                // fill texture slots
                gl.uniform1i(uniform.location, textureSlot++);
            }
            else if (Array.isArray(value)) {
                switch (value.length) {
                    case 2:
                        gl.uniform2f(uniform.location, value[0], value[1]);
                        return;
                    case 3:
                        gl.uniform3f(uniform.location, value[0], value[1], value[2]);
                        return;
                    case 4:
                        gl.uniform4f(uniform.location, value[0], value[1], value[2], value[3]);
                        return;
                    default:
                        return;
                }
            }
            else if (typeof value === 'number') {
                gl.uniform1f(uniform.location, value);
            }
        });
    };
    return WebGLPostProcessingPass;
}());
/* harmony default export */ __webpack_exports__["default"] = (WebGLPostProcessingPass);
//# sourceMappingURL=PostProcessingPass.js.map

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromTransform", function() { return fromTransform; });
/**
 * @module ol/vec/mat4
 */
/**
 * @return {Array<number>} "4x4 matrix representing a 3D identity transform."
 */
function create() {
    return [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
}
/**
 * @param {Array<number>} mat4 Flattened 4x4 matrix receiving the result.
 * @param {import("../transform.js").Transform} transform Transformation matrix.
 * @return {Array<number>} "2D transformation matrix as flattened 4x4 matrix."
 */
function fromTransform(mat4, transform) {
    mat4[0] = transform[0];
    mat4[1] = transform[1];
    mat4[4] = transform[2];
    mat4[5] = transform[3];
    mat4[12] = transform[4];
    mat4[13] = transform[5];
    return mat4;
}
//# sourceMappingURL=mat4.js.map

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _array_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52);
/**
 * A wrapper class to simplify rendering to a texture instead of the final canvas
 * @module ol/webgl/RenderTarget
 */

// for pixel color reading
var tmpArray4 = new Uint8Array(4);
/**
 * @classdesc
 * This class is a wrapper around the association of both a `WebGLTexture` and a `WebGLFramebuffer` instances,
 * simplifying initialization and binding for rendering.
 * @api
 */
var WebGLRenderTarget = /** @class */ (function () {
    /**
     * @param {import("./Helper.js").default} helper WebGL helper; mandatory.
     * @param {Array<number>} [opt_size] Expected size of the render target texture; note: this can be changed later on.
     */
    function WebGLRenderTarget(helper, opt_size) {
        /**
         * @private
         * @type {import("./Helper.js").default}
         */
        this.helper_ = helper;
        var gl = helper.getGL();
        /**
         * @private
         * @type {WebGLTexture}
         */
        this.texture_ = gl.createTexture();
        /**
         * @private
         * @type {WebGLFramebuffer}
         */
        this.framebuffer_ = gl.createFramebuffer();
        /**
         * @type {Array<number>}
         * @private
         */
        this.size_ = opt_size || [1, 1];
        /**
         * @type {Uint8Array}
         * @private
         */
        this.data_ = new Uint8Array(0);
        /**
         * @type {boolean}
         * @private
         */
        this.dataCacheDirty_ = true;
        this.updateSize_();
    }
    /**
     * Changes the size of the render target texture. Note: will do nothing if the size
     * is already the same.
     * @param {Array<number>} size Expected size of the render target texture
     * @api
     */
    WebGLRenderTarget.prototype.setSize = function (size) {
        if (Object(_array_js__WEBPACK_IMPORTED_MODULE_0__["equals"])(size, this.size_)) {
            return;
        }
        this.size_[0] = size[0];
        this.size_[1] = size[1];
        this.updateSize_();
    };
    /**
     * Returns the size of the render target texture
     * @return {Array<number>} Size of the render target texture
     * @api
     */
    WebGLRenderTarget.prototype.getSize = function () {
        return this.size_;
    };
    /**
     * This will cause following calls to `#readAll` or `#readPixel` to download the content of the
     * render target into memory, which is an expensive operation.
     * This content will be kept in cache but should be cleared after each new render.
     * @api
     */
    WebGLRenderTarget.prototype.clearCachedData = function () {
        this.dataCacheDirty_ = true;
    };
    /**
     * Returns the full content of the frame buffer as a series of r, g, b, a components
     * in the 0-255 range (unsigned byte).
     * @return {Uint8Array} Integer array of color values
     * @api
     */
    WebGLRenderTarget.prototype.readAll = function () {
        if (this.dataCacheDirty_) {
            var size = this.size_;
            var gl = this.helper_.getGL();
            gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer_);
            gl.readPixels(0, 0, size[0], size[1], gl.RGBA, gl.UNSIGNED_BYTE, this.data_);
            this.dataCacheDirty_ = false;
        }
        return this.data_;
    };
    /**
     * Reads one pixel of the frame buffer as an array of r, g, b, a components
     * in the 0-255 range (unsigned byte).
     * If x and/or y are outside of existing data, an array filled with 0 is returned.
     * @param {number} x Pixel coordinate
     * @param {number} y Pixel coordinate
     * @return {Uint8Array} Integer array with one color value (4 components)
     * @api
     */
    WebGLRenderTarget.prototype.readPixel = function (x, y) {
        if (x < 0 || y < 0 || x > this.size_[0] || y >= this.size_[1]) {
            tmpArray4[0] = 0;
            tmpArray4[1] = 0;
            tmpArray4[2] = 0;
            tmpArray4[3] = 0;
            return tmpArray4;
        }
        this.readAll();
        var index = Math.floor(x) + (this.size_[1] - Math.floor(y) - 1) * this.size_[0];
        tmpArray4[0] = this.data_[index * 4];
        tmpArray4[1] = this.data_[index * 4 + 1];
        tmpArray4[2] = this.data_[index * 4 + 2];
        tmpArray4[3] = this.data_[index * 4 + 3];
        return tmpArray4;
    };
    /**
     * @return {WebGLTexture} Texture to render to
     */
    WebGLRenderTarget.prototype.getTexture = function () {
        return this.texture_;
    };
    /**
     * @return {WebGLFramebuffer} Frame buffer of the render target
     */
    WebGLRenderTarget.prototype.getFramebuffer = function () {
        return this.framebuffer_;
    };
    /**
     * @private
     */
    WebGLRenderTarget.prototype.updateSize_ = function () {
        var size = this.size_;
        var gl = this.helper_.getGL();
        this.texture_ = this.helper_.createTexture(size, null, this.texture_);
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer_);
        gl.viewport(0, 0, size[0], size[1]);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture_, 0);
        this.data_ = new Uint8Array(size[0] * size[1] * 4);
    };
    return WebGLRenderTarget;
}());
/* harmony default export */ __webpack_exports__["default"] = (WebGLRenderTarget);
//# sourceMappingURL=RenderTarget.js.map

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "create", function() { return create; });
var source = "var e=\"function\"==typeof Object.assign?Object.assign:function(e,n){if(null==e)throw new TypeError(\"Cannot convert undefined or null to object\");for(var t=Object(e),r=1,o=arguments.length;r<o;++r){var i=arguments[r];if(null!=i)for(var f in i)i.hasOwnProperty(f)&&(t[f]=i[f])}return t},n=\"GENERATE_BUFFERS\",t=[],r={vertexPosition:0,indexPosition:0};function o(e,n,t,r,o){e[n+0]=t,e[n+1]=r,e[n+2]=o}function i(e,n,i,f,s,u){var a=3+s,l=e[n+0],v=e[n+1],c=t;c.length=s;for(var g=0;g<c.length;g++)c[g]=e[n+2+g];var b=u?u.vertexPosition:0,h=u?u.indexPosition:0,d=b/a;return o(i,b,l,v,0),c.length&&i.set(c,b+3),o(i,b+=a,l,v,1),c.length&&i.set(c,b+3),o(i,b+=a,l,v,2),c.length&&i.set(c,b+3),o(i,b+=a,l,v,3),c.length&&i.set(c,b+3),b+=a,f[h++]=d,f[h++]=d+1,f[h++]=d+3,f[h++]=d+1,f[h++]=d+2,f[h++]=d+3,r.vertexPosition=b,r.indexPosition=h,r}var f=self;f.onmessage=function(t){var r=t.data;if(r.type===n){for(var o=r.customAttributesCount,s=2+o,u=new Float32Array(r.renderInstructions),a=u.length/s,l=4*a*(o+3),v=new Uint32Array(6*a),c=new Float32Array(l),g=null,b=0;b<u.length;b+=s)g=i(u,b,c,v,o,g);var h=e({vertexBuffer:c.buffer,indexBuffer:v.buffer,renderInstructions:u.buffer},r);f.postMessage(h,[c.buffer,v.buffer,u.buffer])}};";
var blob = new Blob([source], { type: 'application/javascript' });
var url = URL.createObjectURL(blob);
function create() {
    return new Worker(url);
}
//# sourceMappingURL=webgl.js.map

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMapboxPath", function() { return getMapboxPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeSpriteUrl", function() { return normalizeSpriteUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeGlyphsUrl", function() { return normalizeGlyphsUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeStyleUrl", function() { return normalizeStyleUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeSourceUrl", function() { return normalizeSourceUrl; });
/* harmony import */ var _events_Event_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53);
/* harmony import */ var _format_MVT_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(223);
/* harmony import */ var _source_State_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70);
/* harmony import */ var _layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(331);
/* harmony import */ var _source_VectorTile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(152);
/* harmony import */ var ol_mapbox_style__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(334);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/MapboxVector
 */







var mapboxBaseUrl = 'https://api.mapbox.com';
/**
 * Gets the path from a mapbox:// URL.
 * @param {string} url The Mapbox URL.
 * @return {string} The path.
 * @private
 */
function getMapboxPath(url) {
    var startsWith = 'mapbox://';
    if (url.indexOf(startsWith) !== 0) {
        return '';
    }
    return url.slice(startsWith.length);
}
/**
 * Turns mapbox:// sprite URLs into resolvable URLs.
 * @param {string} url The sprite URL.
 * @param {string} token The access token.
 * @return {string} A resolvable URL.
 * @private
 */
function normalizeSpriteUrl(url, token) {
    var mapboxPath = getMapboxPath(url);
    if (!mapboxPath) {
        return url;
    }
    var startsWith = 'sprites/';
    if (mapboxPath.indexOf(startsWith) !== 0) {
        throw new Error("unexpected sprites url: " + url);
    }
    var sprite = mapboxPath.slice(startsWith.length);
    return mapboxBaseUrl + "/styles/v1/" + sprite + "/sprite?access_token=" + token;
}
/**
 * Turns mapbox:// glyphs URLs into resolvable URLs.
 * @param {string} url The glyphs URL.
 * @param {string} token The access token.
 * @return {string} A resolvable URL.
 * @private
 */
function normalizeGlyphsUrl(url, token) {
    var mapboxPath = getMapboxPath(url);
    if (!mapboxPath) {
        return url;
    }
    var startsWith = 'fonts/';
    if (mapboxPath.indexOf(startsWith) !== 0) {
        throw new Error("unexpected fonts url: " + url);
    }
    var font = mapboxPath.slice(startsWith.length);
    return mapboxBaseUrl + "/fonts/v1/" + font + "/0-255.pbf?access_token=" + token;
}
/**
 * Turns mapbox:// style URLs into resolvable URLs.
 * @param {string} url The style URL.
 * @param {string} token The access token.
 * @return {string} A resolvable URL.
 * @private
 */
function normalizeStyleUrl(url, token) {
    var mapboxPath = getMapboxPath(url);
    if (!mapboxPath) {
        return url;
    }
    var startsWith = 'styles/';
    if (mapboxPath.indexOf(startsWith) !== 0) {
        throw new Error("unexpected style url: " + url);
    }
    var style = mapboxPath.slice(startsWith.length);
    return mapboxBaseUrl + "/styles/v1/" + style + "?&access_token=" + token;
}
/**
 * Turns mapbox:// source URLs into vector tile URL templates.
 * @param {string} url The source URL.
 * @param {string} token The access token.
 * @return {string} A vector tile template.
 * @private
 */
function normalizeSourceUrl(url, token) {
    var mapboxPath = getMapboxPath(url);
    if (!mapboxPath) {
        return url;
    }
    return "https://{a-d}.tiles.mapbox.com/v4/" + mapboxPath + "/{z}/{x}/{y}.vector.pbf?access_token=" + token;
}
/**
 * @classdesc
 * Event emitted on configuration or loading error.
 */
var ErrorEvent = /** @class */ (function (_super) {
    __extends(ErrorEvent, _super);
    /**
     * @param {Error} error error object.
     */
    function ErrorEvent(error) {
        var _this = _super.call(this, _events_EventType_js__WEBPACK_IMPORTED_MODULE_1__["default"].ERROR) || this;
        /**
         * @type {Error}
         */
        _this.error = error;
        return _this;
    }
    return ErrorEvent;
}(_events_Event_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/**
 * @typedef {Object} StyleObject
 * @property {Object<string, SourceObject>} sources The style sources.
 * @property {string} sprite The sprite URL.
 * @property {string} glyphs The glyphs URL.
 * @property {Array<LayerObject>} layers The style layers.
 */
/**
 * @typedef {Object} SourceObject
 * @property {string} url The source URL.
 * @property {SourceType} type The source type.
 */
/**
 * The Mapbox source type.
 * @enum {string}
 */
var SourceType = {
    VECTOR: 'vector',
};
/**
 * @typedef {Object} LayerObject
 * @property {string} id The layer id.
 * @property {string} source The source id.
 */
/**
 * @typedef {Object} Options
 * @property {string} styleUrl The URL of the Mapbox style object to use for this layer.  For a
 * style created with Mapbox Studio and hosted on Mapbox, this will look like
 * 'mapbox://styles/you/your-style'.
 * @property {string} accessToken The access token for your Mapbox style.
 * @property {string} [source] If your style uses more than one source, you need to use either the
 * `source` property or the `layers` property to limit rendering to a single vector source.  The
 * `source` property corresponds to the id of a vector source in your Mapbox style.
 * @property {Array<string>} [layers] Limit rendering to the list of included layers.  All layers
 * must share the same vector source.  If your style uses more than one source, you need to use
 * either the `source` property or the `layers` property to limit rendering to a single vector
 * source.
 * @property {boolean} [declutter=true] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the tile extent used by the
 * renderer when getting features from the vector tile for the rendering or hit-detection.
 * Recommended value: Vector tiles are usually generated with a buffer, so this value should match
 * the largest possible buffer of the used tiles. It should be at least the size of the largest
 * point symbol or line width.
 * @property {import("./VectorTileRenderType.js").default|string} [renderMode='hybrid'] Render mode for vector tiles:
 *  * `'hybrid'`: Polygon and line elements are rendered as images, so pixels are scaled during zoom
 *    animations. Point symbols and texts are accurately rendered as vectors and can stay upright on
 *    rotated views.
 *  * `'vector'`: Everything is rendered as vectors. Use this mode for improved performance on vector
 *    tile layers with only a few rendered features (e.g. for highlighting a subset of features of
 *    another layer with the same source).
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will be
 * recreated during animations. This means that no vectors will be shown clipped, but the setting
 * will have a performance impact for large amounts of vector data. When set to `false`, batches
 * will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will be
 * recreated during interactions. See also `updateWhileAnimating`.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * A vector tile layer based on a Mapbox style that uses a single vector source.  Configure
 * the layer with the `styleUrl` and `accessToken` shown in Mapbox Studio's share panel.
 * If the style uses more than one source, use the `source` property to choose a single
 * vector source.  If you want to render a subset of the layers in the style, use the `layers`
 * property (all layers must share the same vector source).  See the constructor options for
 * more detail.
 *
 *     var map = new Map({
 *       view: new View({
 *         center: [0, 0],
 *         zoom: 1
 *       }),
 *       layers: [
 *         new MapboxVectorLayer({
 *           styleUrl: 'mapbox://styles/mapbox/bright-v9',
 *           accessToken: 'your-mapbox-access-token-here'
 *         })
 *       ],
 *       target: 'map'
 *     });
 *
 * On configuration or loading error, the layer will trigger an `'error'` event.  Listeners
 * will receive an object with an `error` property that can be used to diagnose the problem.
 *
 * @param {Options} options Options.
 * @extends {VectorTileLayer}
 * @fires module:ol/events/Event~BaseEvent#event:error
 * @api
 */
var MapboxVectorLayer = /** @class */ (function (_super) {
    __extends(MapboxVectorLayer, _super);
    /**
     * @param {Options} options Layer options.  At a minimum, `styleUrl` and `accessToken`
     * must be provided.
     */
    function MapboxVectorLayer(options) {
        var _this = this;
        var declutter = 'declutter' in options ? options.declutter : true;
        var source = new _source_VectorTile_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
            state: _source_State_js__WEBPACK_IMPORTED_MODULE_3__["default"].LOADING,
            format: new _format_MVT_js__WEBPACK_IMPORTED_MODULE_2__["default"](),
        });
        _this = _super.call(this, {
            source: source,
            declutter: declutter,
            className: options.className,
            opacity: options.opacity,
            visible: options.visible,
            zIndex: options.zIndex,
            minResolution: options.minResolution,
            maxResolution: options.maxResolution,
            minZoom: options.minZoom,
            maxZoom: options.maxZoom,
            renderOrder: options.renderOrder,
            renderBuffer: options.renderBuffer,
            renderMode: options.renderMode,
            map: options.map,
            updateWhileAnimating: options.updateWhileAnimating,
            updateWhileInteracting: options.updateWhileInteracting,
            preload: options.preload,
            useInterimTilesOnError: options.useInterimTilesOnError,
            properties: options.properties,
        }) || this;
        _this.sourceId = options.source;
        _this.layers = options.layers;
        _this.accessToken = options.accessToken;
        _this.fetchStyle(options.styleUrl);
        return _this;
    }
    /**
     * Fetch the style object.
     * @param {string} styleUrl The URL of the style to load.
     * @protected
     */
    MapboxVectorLayer.prototype.fetchStyle = function (styleUrl) {
        var _this = this;
        var url = normalizeStyleUrl(styleUrl, this.accessToken);
        fetch(url)
            .then(function (response) {
            if (!response.ok) {
                throw new Error("unexpected response when fetching style: " + response.status);
            }
            return response.json();
        })
            .then(function (style) {
            _this.onStyleLoad(style);
        })
            .catch(function (error) {
            _this.handleError(error);
        });
    };
    /**
     * Handle the loaded style object.
     * @param {StyleObject} style The loaded style.
     * @protected
     */
    MapboxVectorLayer.prototype.onStyleLoad = function (style) {
        var _this = this;
        var sourceId;
        var sourceIdOrLayersList;
        if (this.layers) {
            // confirm all layers share the same source
            var lookup = {};
            for (var i = 0; i < style.layers.length; ++i) {
                var layer = style.layers[i];
                if (layer.source) {
                    lookup[layer.id] = layer.source;
                }
            }
            var firstSource = void 0;
            for (var i = 0; i < this.layers.length; ++i) {
                var candidate = lookup[this.layers[i]];
                if (!candidate) {
                    this.handleError(new Error("could not find source for " + this.layers[i]));
                    return;
                }
                if (!firstSource) {
                    firstSource = candidate;
                }
                else if (firstSource !== candidate) {
                    this.handleError(new Error("layers can only use a single source, found " + firstSource + " and " + candidate));
                    return;
                }
            }
            sourceId = firstSource;
            sourceIdOrLayersList = this.layers;
        }
        else {
            sourceId = this.sourceId;
            sourceIdOrLayersList = sourceId;
        }
        if (!sourceIdOrLayersList) {
            // default to the first source in the style
            sourceId = Object.keys(style.sources)[0];
            sourceIdOrLayersList = sourceId;
        }
        if (style.sprite) {
            style.sprite = normalizeSpriteUrl(style.sprite, this.accessToken);
        }
        if (style.glyphs) {
            style.glyphs = normalizeGlyphsUrl(style.glyphs, this.accessToken);
        }
        var styleSource = style.sources[sourceId];
        if (styleSource.type !== SourceType.VECTOR) {
            this.handleError(new Error("only works for vector sources, found " + styleSource.type));
            return;
        }
        var source = this.getSource();
        source.setUrl(normalizeSourceUrl(styleSource.url, this.accessToken));
        Object(ol_mapbox_style__WEBPACK_IMPORTED_MODULE_6__["applyStyle"])(this, style, sourceIdOrLayersList)
            .then(function () {
            source.setState(_source_State_js__WEBPACK_IMPORTED_MODULE_3__["default"].READY);
        })
            .catch(function (error) {
            _this.handleError(error);
        });
    };
    /**
     * Handle configuration or loading error.
     * @param {Error} error The error.
     * @protected
     */
    MapboxVectorLayer.prototype.handleError = function (error) {
        this.dispatchEvent(new ErrorEvent(error));
        var source = this.getSource();
        source.setState(_source_State_js__WEBPACK_IMPORTED_MODULE_3__["default"].ERROR);
    };
    return MapboxVectorLayer;
}(_layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_4__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (MapboxVectorLayer);
//# sourceMappingURL=MapboxVector.js.map

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BaseVector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(289);
/* harmony import */ var _renderer_canvas_VectorTileLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(332);
/* harmony import */ var _TileProperty_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(142);
/* harmony import */ var _VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(333);
/* harmony import */ var _asserts_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/VectorTile
 */






/***
 * @template Return
 * @typedef {import("../Observable").OnSignature<import("../Observable").EventTypes, import("../events/Event.js").default, Return> &
 *   import("../Observable").OnSignature<import("./Base").BaseLayerObjectEventTypes|
 *     'change:source'|'change:preload'|'change:useInterimTilesOnError', import("../Object").ObjectEvent, Return> &
 *   import("../Observable").OnSignature<import("../render/EventType").LayerRenderEventTypes, import("../render/Event").default, Return> &
 *   import("../Observable").CombinedOnSignature<import("../Observable").EventTypes|import("./Base").BaseLayerObjectEventTypes|
 *     'change:source'|'change:preload'|'change:useInterimTilesOnError'|import("../render/EventType").LayerRenderEventTypes, Return>} VectorTileLayerOnSignature
 */
/**
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the tile extent used by the
 * renderer when getting features from the vector tile for the rendering or hit-detection.
 * Recommended value: Vector tiles are usually generated with a buffer, so this value should match
 * the largest possible buffer of the used tiles. It should be at least the size of the largest
 * point symbol or line width.
 * @property {import("./VectorTileRenderType.js").default|string} [renderMode='hybrid'] Render mode for vector tiles:
 *  * `'hybrid'`: Polygon and line elements are rendered as images, so pixels are scaled during zoom
 *    animations. Point symbols and texts are accurately rendered as vectors and can stay upright on
 *    rotated views.
 *  * `'vector'`: Everything is rendered as vectors. Use this mode for improved performance on vector
 *    tile layers with only a few rendered features (e.g. for highlighting a subset of features of
 *    another layer with the same source).
 * @property {import("../source/VectorTile.js").default} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [declutter=false] Declutter images and text. Decluttering is applied to all
 * image and text styles of all Vector and VectorTile layers that have set this to `true`. The priority
 * is defined by the z-index of the layer, the `zIndex` of the style and the render order of features.
 * Higher z-index means higher priority. Within the same z-index, a feature rendered before another has
 * higher priority.
 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
 * {@link import("../style/Style.js").default the style docs} for the default style that will be used if
 * this is not defined.
 * @property {boolean} [updateWhileAnimating=false] When set to `true`, feature batches will be
 * recreated during animations. This means that no vectors will be shown clipped, but the setting
 * will have a performance impact for large amounts of vector data. When set to `false`, batches
 * will be recreated when no animation is active.
 * @property {boolean} [updateWhileInteracting=false] When set to `true`, feature batches will be
 * recreated during interactions. See also `updateWhileAnimating`.
 * @property {number} [preload=0] Preload. Load low-resolution tiles up to `preload` levels. `0`
 * means no preloading.
 * @property {boolean} [useInterimTilesOnError=true] Use interim tiles on error.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Layer for vector tile data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @param {Options} [opt_options] Options.
 * @extends {BaseVectorLayer<import("../source/VectorTile.js").default>}
 * @api
 */
var VectorTileLayer = /** @class */ (function (_super) {
    __extends(VectorTileLayer, _super);
    /**
     * @param {Options} [opt_options] Options.
     */
    function VectorTileLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = /** @type {Object} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_5__["assign"])({}, options));
        delete baseOptions.preload;
        delete baseOptions.useInterimTilesOnError;
        _this = _super.call(this, 
        /** @type {import("./BaseVector.js").Options<import("../source/VectorTile.js").default>} */ (baseOptions)) || this;
        /***
         * @type {VectorTileLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.on;
        /***
         * @type {VectorTileLayerOnSignature<import("../Observable.js").OnReturn>}
         */
        _this.once;
        /***
         * @type {VectorTileLayerOnSignature<void>}
         */
        _this.un;
        if (options.renderMode === _VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_3__["default"].IMAGE) {
            //FIXME deprecated - remove this check in v7.
            //eslint-disable-next-line
            console.warn('renderMode: "image" is deprecated. Option ignored.');
            options.renderMode = undefined;
        }
        var renderMode = options.renderMode || _VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_3__["default"].HYBRID;
        Object(_asserts_js__WEBPACK_IMPORTED_MODULE_4__["assert"])(renderMode == _VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_3__["default"].HYBRID ||
            renderMode == _VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_3__["default"].VECTOR, 28); // `renderMode` must be `'hybrid'` or `'vector'`.
        /**
         * @private
         * @type {import("./VectorTileRenderType.js").default}
         */
        _this.renderMode_ = renderMode;
        _this.setPreload(options.preload ? options.preload : 0);
        _this.setUseInterimTilesOnError(options.useInterimTilesOnError !== undefined
            ? options.useInterimTilesOnError
            : true);
        return _this;
    }
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     * @protected
     */
    VectorTileLayer.prototype.createRenderer = function () {
        return new _renderer_canvas_VectorTileLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this);
    };
    /**
     * Get the topmost feature that intersects the given pixel on the viewport. Returns a promise
     * that resolves with an array of features. The array will either contain the topmost feature
     * when a hit was detected, or it will be empty.
     *
     * The hit detection algorithm used for this method is optimized for performance, but is less
     * accurate than the one used in {@link import("../PluggableMap.js").default#getFeaturesAtPixel map.getFeaturesAtPixel()}: Text
     * is not considered, and icons are only represented by their bounding box instead of the exact
     * image.
     *
     * @param {import("../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../Feature").default>>} Promise that resolves with an array of features.
     * @api
     */
    VectorTileLayer.prototype.getFeatures = function (pixel) {
        return _super.prototype.getFeatures.call(this, pixel);
    };
    /**
     * @return {import("./VectorTileRenderType.js").default} The render mode.
     */
    VectorTileLayer.prototype.getRenderMode = function () {
        return this.renderMode_;
    };
    /**
     * Return the level as number to which we will preload tiles up to.
     * @return {number} The level to preload tiles up to.
     * @observable
     * @api
     */
    VectorTileLayer.prototype.getPreload = function () {
        return /** @type {number} */ (this.get(_TileProperty_js__WEBPACK_IMPORTED_MODULE_2__["default"].PRELOAD));
    };
    /**
     * Whether we use interim tiles on error.
     * @return {boolean} Use interim tiles on error.
     * @observable
     * @api
     */
    VectorTileLayer.prototype.getUseInterimTilesOnError = function () {
        return /** @type {boolean} */ (this.get(_TileProperty_js__WEBPACK_IMPORTED_MODULE_2__["default"].USE_INTERIM_TILES_ON_ERROR));
    };
    /**
     * Set the level as number to which we will preload tiles up to.
     * @param {number} preload The level to preload tiles up to.
     * @observable
     * @api
     */
    VectorTileLayer.prototype.setPreload = function (preload) {
        this.set(_TileProperty_js__WEBPACK_IMPORTED_MODULE_2__["default"].PRELOAD, preload);
    };
    /**
     * Set whether we use interim tiles on error.
     * @param {boolean} useInterimTilesOnError Use interim tiles on error.
     * @observable
     * @api
     */
    VectorTileLayer.prototype.setUseInterimTilesOnError = function (useInterimTilesOnError) {
        this.set(_TileProperty_js__WEBPACK_IMPORTED_MODULE_2__["default"].USE_INTERIM_TILES_ON_ERROR, useInterimTilesOnError);
    };
    return VectorTileLayer;
}(_BaseVector_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorTileLayer);
//# sourceMappingURL=VectorTile.js.map

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(291);
/* harmony import */ var _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(300);
/* harmony import */ var _TileLayer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(143);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53);
/* harmony import */ var _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(301);
/* harmony import */ var _TileState_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(74);
/* harmony import */ var _layer_VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(333);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(139);
/* harmony import */ var _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(304);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(101);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15);
/* harmony import */ var _vector_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(306);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21);
/* harmony import */ var _events_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54);
/* harmony import */ var _size_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(39);
/* harmony import */ var _coordinate_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(24);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/VectorTileLayer
 */

















/**
 * @type {!Object<string, Array<import("../../render/canvas/BuilderType.js").default>>}
 */
var IMAGE_REPLAYS = {
    'image': [
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].CIRCLE,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].IMAGE,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].TEXT,
    ],
    'hybrid': [_render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON, _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING],
    'vector': [],
};
/**
 * @type {!Object<string, Array<import("../../render/canvas/BuilderType.js").default>>}
 */
var VECTOR_REPLAYS = {
    'hybrid': [_render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].IMAGE, _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].TEXT, _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].DEFAULT],
    'vector': [
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].POLYGON,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].CIRCLE,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].LINE_STRING,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].IMAGE,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].TEXT,
        _render_canvas_BuilderType_js__WEBPACK_IMPORTED_MODULE_4__["default"].DEFAULT,
    ],
};
/**
 * @classdesc
 * Canvas renderer for vector tile layers.
 * @api
 */
var CanvasVectorTileLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasVectorTileLayerRenderer, _super);
    /**
     * @param {import("../../layer/VectorTile.js").default} layer VectorTile layer.
     */
    function CanvasVectorTileLayerRenderer(layer) {
        var _this = _super.call(this, layer) || this;
        /** @private */
        _this.boundHandleStyleImageChange_ = _this.handleStyleImageChange_.bind(_this);
        /**
         * @private
         * @type {boolean}
         */
        _this.dirty_ = false;
        /**
         * @private
         * @type {number}
         */
        _this.renderedLayerRevision_;
        /**
         * @private
         * @type {import("../../transform").Transform}
         */
        _this.renderedPixelToCoordinateTransform_ = null;
        /**
         * @private
         * @type {number}
         */
        _this.renderedRotation_;
        /**
         * @private
         * @type {!Object<string, import("../../VectorRenderTile.js").default>}
         */
        _this.renderTileImageQueue_ = {};
        /**
         * @type {Object<string, import("../../events.js").EventsKey>}
         */
        _this.tileListenerKeys_ = {};
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        _this.tmpTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["create"])();
        return _this;
    }
    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection").default} projection Projection.
     * @param {boolean} queue Queue tile for rendering.
     * @return {boolean|undefined} Tile needs to be rendered.
     */
    CanvasVectorTileLayerRenderer.prototype.prepareTile = function (tile, pixelRatio, projection, queue) {
        var render;
        var tileUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(tile);
        var state = tile.getState();
        if ((state === _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].LOADED || state === _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERROR) &&
            tileUid in this.tileListenerKeys_) {
            Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["unlistenByKey"])(this.tileListenerKeys_[tileUid]);
            delete this.tileListenerKeys_[tileUid];
        }
        if (state === _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].LOADED || state === _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].ERROR) {
            this.updateExecutorGroup_(tile, pixelRatio, projection);
            if (this.tileImageNeedsRender_(tile)) {
                render = true;
                if (queue) {
                    this.renderTileImageQueue_[tileUid] = tile;
                }
            }
        }
        return render;
    };
    /**
     * @param {number} z Tile coordinate z.
     * @param {number} x Tile coordinate x.
     * @param {number} y Tile coordinate y.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {!import("../../Tile.js").default} Tile.
     */
    CanvasVectorTileLayerRenderer.prototype.getTile = function (z, x, y, frameState) {
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var resolution = viewState.resolution;
        var projection = viewState.projection;
        var layer = this.getLayer();
        var tile = layer.getSource().getTile(z, x, y, pixelRatio, projection);
        if (tile.getState() < _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].LOADED) {
            tile.wantedResolution = resolution;
            var tileUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(tile);
            if (!(tileUid in this.tileListenerKeys_)) {
                var listenerKey = Object(_events_js__WEBPACK_IMPORTED_MODULE_14__["listen"])(tile, _events_EventType_js__WEBPACK_IMPORTED_MODULE_3__["default"].CHANGE, this.prepareTile.bind(this, tile, pixelRatio, projection, true));
                this.tileListenerKeys_[tileUid] = listenerKey;
            }
        }
        else {
            var viewHints = frameState.viewHints;
            var hifi = !(viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].ANIMATING] || viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].INTERACTING]);
            if (hifi || !tile.wantedResolution) {
                tile.wantedResolution = resolution;
            }
            var render = this.prepareTile(tile, pixelRatio, projection, false);
            if (render && layer.getRenderMode() !== _layer_VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR) {
                this.renderTileImage_(tile, frameState);
            }
        }
        return _super.prototype.getTile.call(this, z, x, y, frameState);
    };
    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @return {boolean} Tile is drawable.
     */
    CanvasVectorTileLayerRenderer.prototype.isDrawableTile = function (tile) {
        var layer = this.getLayer();
        return (_super.prototype.isDrawableTile.call(this, tile) &&
            (layer.getRenderMode() === _layer_VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR
                ? Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer) in tile.executorGroups
                : tile.hasContext(layer)));
    };
    /**
     * @inheritDoc
     */
    CanvasVectorTileLayerRenderer.prototype.getTileImage = function (tile) {
        return tile.getImage(this.getLayer());
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    CanvasVectorTileLayerRenderer.prototype.prepareFrame = function (frameState) {
        var layerRevision = this.getLayer().getRevision();
        if (this.renderedLayerRevision_ != layerRevision) {
            this.renderedTiles.length = 0;
        }
        this.renderedLayerRevision_ = layerRevision;
        return _super.prototype.prepareFrame.call(this, frameState);
    };
    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @param {number} pixelRatio Pixel ratio.
     * @param {import("../../proj/Projection.js").default} projection Projection.
     * @private
     */
    CanvasVectorTileLayerRenderer.prototype.updateExecutorGroup_ = function (tile, pixelRatio, projection) {
        var layer = /** @type {import("../../layer/VectorTile.js").default} */ (this.getLayer());
        var revision = layer.getRevision();
        var renderOrder = layer.getRenderOrder() || null;
        var resolution = tile.wantedResolution;
        var builderState = tile.getReplayState(layer);
        if (!builderState.dirty &&
            builderState.renderedResolution === resolution &&
            builderState.renderedRevision == revision &&
            builderState.renderedRenderOrder == renderOrder) {
            return;
        }
        var source = layer.getSource();
        var declutter = layer.getDeclutter();
        var sourceTileGrid = source.getTileGrid();
        var tileGrid = source.getTileGridForProjection(projection);
        var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        var sourceTiles = source.getSourceTiles(pixelRatio, projection, tile);
        var layerUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer);
        delete tile.hitDetectionImageData[layerUid];
        tile.executorGroups[layerUid] = [];
        if (declutter) {
            tile.declutterExecutorGroups[layerUid] = [];
        }
        var _loop_1 = function (t, tt) {
            var sourceTile = sourceTiles[t];
            if (sourceTile.getState() != _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].LOADED) {
                return "continue";
            }
            var sourceTileCoord = sourceTile.tileCoord;
            var sourceTileExtent = sourceTileGrid.getTileCoordExtent(sourceTileCoord);
            var sharedExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getIntersection"])(tileExtent, sourceTileExtent);
            var builderExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["buffer"])(sharedExtent, layer.getRenderBuffer() * resolution, this_1.tmpExtent);
            var bufferedExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["equals"])(sourceTileExtent, sharedExtent)
                ? null
                : builderExtent;
            builderState.dirty = false;
            var builderGroup = new _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__["default"](0, builderExtent, resolution, pixelRatio);
            var declutterBuilderGroup = declutter
                ? new _render_canvas_BuilderGroup_js__WEBPACK_IMPORTED_MODULE_0__["default"](0, sharedExtent, resolution, pixelRatio)
                : undefined;
            var squaredTolerance = Object(_vector_js__WEBPACK_IMPORTED_MODULE_12__["getSquaredTolerance"])(resolution, pixelRatio);
            /**
             * @param {import("../../Feature.js").FeatureLike} feature Feature.
             * @this {CanvasVectorTileLayerRenderer}
             */
            var render = function (feature) {
                var styles;
                var styleFunction = feature.getStyleFunction() || layer.getStyleFunction();
                if (styleFunction) {
                    styles = styleFunction(feature, resolution);
                }
                if (styles) {
                    var dirty = this.renderFeature(feature, squaredTolerance, styles, builderGroup, declutterBuilderGroup);
                    this.dirty_ = this.dirty_ || dirty;
                    builderState.dirty = builderState.dirty || dirty;
                }
            };
            var features = sourceTile.getFeatures();
            if (renderOrder && renderOrder !== builderState.renderedRenderOrder) {
                features.sort(renderOrder);
            }
            for (var i = 0, ii = features.length; i < ii; ++i) {
                var feature = features[i];
                if (!bufferedExtent ||
                    Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["intersects"])(bufferedExtent, feature.getGeometry().getExtent())) {
                    render.call(this_1, feature);
                }
            }
            var executorGroupInstructions = builderGroup.finish();
            // no need to clip when the render tile is covered by a single source tile
            var replayExtent = layer.getRenderMode() !== _layer_VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR &&
                declutter &&
                sourceTiles.length === 1
                ? null
                : sharedExtent;
            var renderingReplayGroup = new _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_1__["default"](replayExtent, resolution, pixelRatio, source.getOverlaps(), executorGroupInstructions, layer.getRenderBuffer());
            tile.executorGroups[layerUid].push(renderingReplayGroup);
            if (declutterBuilderGroup) {
                var declutterExecutorGroup = new _render_canvas_ExecutorGroup_js__WEBPACK_IMPORTED_MODULE_1__["default"](null, resolution, pixelRatio, source.getOverlaps(), declutterBuilderGroup.finish(), layer.getRenderBuffer());
                tile.declutterExecutorGroups[layerUid].push(declutterExecutorGroup);
            }
        };
        var this_1 = this;
        for (var t = 0, tt = sourceTiles.length; t < tt; ++t) {
            _loop_1(t, tt);
        }
        builderState.renderedRevision = revision;
        builderState.renderedRenderOrder = renderOrder;
        builderState.renderedResolution = resolution;
    };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
    CanvasVectorTileLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
        var resolution = frameState.viewState.resolution;
        var rotation = frameState.viewState.rotation;
        hitTolerance = hitTolerance == undefined ? 0 : hitTolerance;
        var layer = this.getLayer();
        var source = layer.getSource();
        var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        var hitExtent = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["boundingExtent"])([coordinate]);
        Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["buffer"])(hitExtent, resolution * hitTolerance, hitExtent);
        /** @type {!Object<string, import("../Map.js").HitMatch<T>|true>} */
        var features = {};
        /**
         * @param {import("../../Feature.js").FeatureLike} feature Feature.
         * @param {import("../../geom/SimpleGeometry.js").default} geometry Geometry.
         * @param {number} distanceSq The squared distance to the click position.
         * @return {T|undefined} Callback result.
         */
        var featureCallback = function (feature, geometry, distanceSq) {
            var key = feature.getId();
            if (key === undefined) {
                key = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(feature);
            }
            var match = features[key];
            if (!match) {
                if (distanceSq === 0) {
                    features[key] = true;
                    return callback(feature, layer, geometry);
                }
                matches.push((features[key] = {
                    feature: feature,
                    layer: layer,
                    geometry: geometry,
                    distanceSq: distanceSq,
                    callback: callback,
                }));
            }
            else if (match !== true && distanceSq < match.distanceSq) {
                if (distanceSq === 0) {
                    features[key] = true;
                    matches.splice(matches.lastIndexOf(match), 1);
                    return callback(feature, layer, geometry);
                }
                match.geometry = geometry;
                match.distanceSq = distanceSq;
            }
            return undefined;
        };
        var renderedTiles = 
        /** @type {Array<import("../../VectorRenderTile.js").default>} */ (this.renderedTiles);
        var found;
        var _loop_2 = function (i, ii) {
            var tile = renderedTiles[i];
            var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            if (!Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["intersects"])(tileExtent, hitExtent)) {
                return "continue";
            }
            var layerUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer);
            var executorGroups = [tile.executorGroups[layerUid]];
            var declutterExecutorGroups = tile.declutterExecutorGroups[layerUid];
            if (declutterExecutorGroups) {
                executorGroups.push(declutterExecutorGroups);
            }
            executorGroups.some(function (executorGroups) {
                var declutteredFeatures = executorGroups === declutterExecutorGroups
                    ? frameState.declutterTree.all().map(function (item) { return item.value; })
                    : null;
                for (var t = 0, tt = executorGroups.length; t < tt; ++t) {
                    var executorGroup = executorGroups[t];
                    found = executorGroup.forEachFeatureAtCoordinate(coordinate, resolution, rotation, hitTolerance, featureCallback, declutteredFeatures);
                    if (found) {
                        return true;
                    }
                }
            });
        };
        for (var i = 0, ii = renderedTiles.length; !found && i < ii; ++i) {
            _loop_2(i, ii);
        }
        return found;
    };
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
     */
    CanvasVectorTileLayerRenderer.prototype.getFeatures = function (pixel) {
        return new Promise(function (resolve, reject) {
            var layer = 
            /** @type {import("../../layer/VectorTile.js").default} */ (this.getLayer());
            var layerUid = Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer);
            var source = layer.getSource();
            var projection = this.renderedProjection;
            var projectionExtent = projection.getExtent();
            var resolution = this.renderedResolution;
            var tileGrid = source.getTileGridForProjection(projection);
            var coordinate = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["apply"])(this.renderedPixelToCoordinateTransform_, pixel.slice());
            var tileCoord = tileGrid.getTileCoordForCoordAndResolution(coordinate, resolution);
            var tile;
            for (var i = 0, ii = this.renderedTiles.length; i < ii; ++i) {
                if (tileCoord.toString() === this.renderedTiles[i].tileCoord.toString()) {
                    tile = this.renderedTiles[i];
                    if (tile.getState() === _TileState_js__WEBPACK_IMPORTED_MODULE_5__["default"].LOADED) {
                        var extent_1 = tileGrid.getTileCoordExtent(tile.tileCoord);
                        if (source.getWrapX() &&
                            projection.canWrapX() &&
                            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["containsExtent"])(projectionExtent, extent_1)) {
                            Object(_coordinate_js__WEBPACK_IMPORTED_MODULE_16__["wrapX"])(coordinate, projection);
                        }
                        break;
                    }
                    tile = undefined;
                }
            }
            if (!tile || tile.loadingSourceTiles > 0) {
                resolve([]);
                return;
            }
            var extent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
            var corner = Object(_extent_js__WEBPACK_IMPORTED_MODULE_10__["getTopLeft"])(extent);
            var tilePixel = [
                (coordinate[0] - corner[0]) / resolution,
                (corner[1] - coordinate[1]) / resolution,
            ];
            var features = tile
                .getSourceTiles()
                .reduce(function (accumulator, sourceTile) {
                return accumulator.concat(sourceTile.getFeatures());
            }, []);
            var hitDetectionImageData = tile.hitDetectionImageData[layerUid];
            if (!hitDetectionImageData && !this.animatingOrInteracting_) {
                var tileSize = Object(_size_js__WEBPACK_IMPORTED_MODULE_15__["toSize"])(tileGrid.getTileSize(tileGrid.getZForResolution(resolution)));
                var rotation = this.renderedRotation_;
                var transforms = [
                    this.getRenderTransform(tileGrid.getTileCoordCenter(tile.wrappedTileCoord), resolution, 0, _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__["HIT_DETECT_RESOLUTION"], tileSize[0] * _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__["HIT_DETECT_RESOLUTION"], tileSize[1] * _render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__["HIT_DETECT_RESOLUTION"], 0),
                ];
                hitDetectionImageData = Object(_render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__["createHitDetectionImageData"])(tileSize, transforms, features, layer.getStyleFunction(), tileGrid.getTileCoordExtent(tile.wrappedTileCoord), tile.getReplayState(layer).renderedResolution, rotation);
                tile.hitDetectionImageData[layerUid] = hitDetectionImageData;
            }
            resolve(Object(_render_canvas_hitdetect_js__WEBPACK_IMPORTED_MODULE_8__["hitDetect"])(tilePixel, features, hitDetectionImageData));
        }.bind(this));
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */
    CanvasVectorTileLayerRenderer.prototype.handleFontsChanged = function () {
        Object(_obj_js__WEBPACK_IMPORTED_MODULE_11__["clear"])(this.renderTileImageQueue_);
        var layer = this.getLayer();
        if (layer.getVisible() && this.renderedLayerRevision_ !== undefined) {
            layer.changed();
        }
    };
    /**
     * Handle changes in image style state.
     * @param {import("../../events/Event.js").default} event Image style change event.
     * @private
     */
    CanvasVectorTileLayerRenderer.prototype.handleStyleImageChange_ = function (event) {
        this.renderIfReadyAndVisible();
    };
    /**
     * Render declutter items for this layer
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     */
    CanvasVectorTileLayerRenderer.prototype.renderDeclutter = function (frameState) {
        var context = this.context;
        var alpha = context.globalAlpha;
        context.globalAlpha = this.getLayer().getOpacity();
        var viewHints = frameState.viewHints;
        var hifi = !(viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].ANIMATING] || viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].INTERACTING]);
        var tiles = 
        /** @type {Array<import("../../VectorRenderTile.js").default>} */ (this.renderedTiles);
        for (var i = 0, ii = tiles.length; i < ii; ++i) {
            var tile = tiles[i];
            var declutterExecutorGroups = tile.declutterExecutorGroups[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(this.getLayer())];
            if (declutterExecutorGroups) {
                for (var j = declutterExecutorGroups.length - 1; j >= 0; --j) {
                    declutterExecutorGroups[j].execute(this.context, 1, this.getTileRenderTransform(tile, frameState), frameState.viewState.rotation, hifi, undefined, frameState.declutterTree);
                }
            }
        }
        context.globalAlpha = alpha;
    };
    CanvasVectorTileLayerRenderer.prototype.getTileRenderTransform = function (tile, frameState) {
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var center = viewState.center;
        var resolution = viewState.resolution;
        var rotation = viewState.rotation;
        var size = frameState.size;
        var width = Math.round(size[0] * pixelRatio);
        var height = Math.round(size[1] * pixelRatio);
        var source = this.getLayer().getSource();
        var tileGrid = source.getTileGridForProjection(frameState.viewState.projection);
        var tileCoord = tile.tileCoord;
        var tileExtent = tileGrid.getTileCoordExtent(tile.wrappedTileCoord);
        var worldOffset = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent)[0] - tileExtent[0];
        var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["multiply"])(Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["scale"])(this.inversePixelTransform.slice(), 1 / pixelRatio, 1 / pixelRatio), this.getRenderTransform(center, resolution, rotation, pixelRatio, width, height, worldOffset));
        return transform;
    };
    /**
     * Render the layer.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {HTMLElement} target Target that may be used to render content to.
     * @return {HTMLElement} The rendered element.
     */
    CanvasVectorTileLayerRenderer.prototype.renderFrame = function (frameState, target) {
        var viewHints = frameState.viewHints;
        var hifi = !(viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].ANIMATING] || viewHints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_7__["default"].INTERACTING]);
        this.renderQueuedTileImages_(hifi, frameState);
        _super.prototype.renderFrame.call(this, frameState, target);
        this.renderedPixelToCoordinateTransform_ =
            frameState.pixelToCoordinateTransform.slice();
        this.renderedRotation_ = frameState.viewState.rotation;
        var layer = /** @type {import("../../layer/VectorTile.js").default} */ (this.getLayer());
        var renderMode = layer.getRenderMode();
        var source = layer.getSource();
        // Unqueue tiles from the image queue when we don't need any more
        var usedTiles = frameState.usedTiles[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(source)];
        for (var tileUid in this.renderTileImageQueue_) {
            if (!usedTiles || !(tileUid in usedTiles)) {
                delete this.renderTileImageQueue_[tileUid];
            }
        }
        var context = this.context;
        var alpha = context.globalAlpha;
        context.globalAlpha = layer.getOpacity();
        var replayTypes = VECTOR_REPLAYS[renderMode];
        var viewState = frameState.viewState;
        var rotation = viewState.rotation;
        var tiles = this.renderedTiles;
        var clips = [];
        var clipZs = [];
        for (var i = tiles.length - 1; i >= 0; --i) {
            var tile = /** @type {import("../../VectorRenderTile.js").default} */ (tiles[i]);
            var transform = this.getTileRenderTransform(tile, frameState);
            var executorGroups = tile.executorGroups[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer)];
            var clipped = false;
            for (var t = 0, tt = executorGroups.length; t < tt; ++t) {
                var executorGroup = executorGroups[t];
                if (!executorGroup.hasExecutors(replayTypes)) {
                    // sourceTile has no instructions of the types we want to render
                    continue;
                }
                var currentZ = tile.tileCoord[0];
                var currentClip = void 0;
                if (!clipped) {
                    currentClip = executorGroup.getClipCoords(transform);
                    if (currentClip) {
                        context.save();
                        // Create a clip mask for regions in this low resolution tile that are
                        // already filled by a higher resolution tile
                        for (var j = 0, jj = clips.length; j < jj; ++j) {
                            var clip = clips[j];
                            if (currentZ < clipZs[j]) {
                                context.beginPath();
                                // counter-clockwise (outer ring) for current tile
                                context.moveTo(currentClip[0], currentClip[1]);
                                context.lineTo(currentClip[2], currentClip[3]);
                                context.lineTo(currentClip[4], currentClip[5]);
                                context.lineTo(currentClip[6], currentClip[7]);
                                // clockwise (inner ring) for higher resolution tile
                                context.moveTo(clip[6], clip[7]);
                                context.lineTo(clip[4], clip[5]);
                                context.lineTo(clip[2], clip[3]);
                                context.lineTo(clip[0], clip[1]);
                                context.clip();
                            }
                        }
                    }
                }
                executorGroup.execute(context, 1, transform, rotation, hifi, replayTypes);
                if (!clipped && currentClip) {
                    context.restore();
                    clips.push(currentClip);
                    clipZs.push(currentZ);
                    clipped = true;
                }
            }
        }
        context.globalAlpha = alpha;
        return this.container;
    };
    /**
     * @param {boolean} hifi We have time to render a high fidelity map image.
     * @param {import('../../PluggableMap.js').FrameState} frameState Frame state.
     */
    CanvasVectorTileLayerRenderer.prototype.renderQueuedTileImages_ = function (hifi, frameState) {
        // When we don't have time to render hifi, only render tiles until we have used up
        // half of the frame budget of 16 ms
        for (var uid in this.renderTileImageQueue_) {
            if (!hifi && Date.now() - frameState.time > 8) {
                frameState.animate = true;
                break;
            }
            var tile = this.renderTileImageQueue_[uid];
            delete this.renderTileImageQueue_[uid];
            this.renderTileImage_(tile, frameState);
        }
    };
    /**
     * @param {import("../../Feature.js").FeatureLike} feature Feature.
     * @param {number} squaredTolerance Squared tolerance.
     * @param {import("../../style/Style.js").default|Array<import("../../style/Style.js").default>} styles The style or array of styles.
     * @param {import("../../render/canvas/BuilderGroup.js").default} builderGroup Replay group.
     * @param {import("../../render/canvas/BuilderGroup.js").default} [opt_declutterBuilderGroup] Builder group for decluttering.
     * @return {boolean} `true` if an image is loading.
     */
    CanvasVectorTileLayerRenderer.prototype.renderFeature = function (feature, squaredTolerance, styles, builderGroup, opt_declutterBuilderGroup) {
        if (!styles) {
            return false;
        }
        var loading = false;
        if (Array.isArray(styles)) {
            for (var i = 0, ii = styles.length; i < ii; ++i) {
                loading =
                    Object(_vector_js__WEBPACK_IMPORTED_MODULE_12__["renderFeature"])(builderGroup, feature, styles[i], squaredTolerance, this.boundHandleStyleImageChange_, undefined, opt_declutterBuilderGroup) || loading;
            }
        }
        else {
            loading = Object(_vector_js__WEBPACK_IMPORTED_MODULE_12__["renderFeature"])(builderGroup, feature, styles, squaredTolerance, this.boundHandleStyleImageChange_, undefined, opt_declutterBuilderGroup);
        }
        return loading;
    };
    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @return {boolean} A new tile image was rendered.
     * @private
     */
    CanvasVectorTileLayerRenderer.prototype.tileImageNeedsRender_ = function (tile) {
        var layer = /** @type {import("../../layer/VectorTile.js").default} */ (this.getLayer());
        if (layer.getRenderMode() === _layer_VectorTileRenderType_js__WEBPACK_IMPORTED_MODULE_6__["default"].VECTOR) {
            return false;
        }
        var replayState = tile.getReplayState(layer);
        var revision = layer.getRevision();
        var resolution = tile.wantedResolution;
        return (replayState.renderedTileResolution !== resolution ||
            replayState.renderedTileRevision !== revision);
    };
    /**
     * @param {import("../../VectorRenderTile.js").default} tile Tile.
     * @param {import("../../PluggableMap").FrameState} frameState Frame state.
     * @private
     */
    CanvasVectorTileLayerRenderer.prototype.renderTileImage_ = function (tile, frameState) {
        var layer = /** @type {import("../../layer/VectorTile.js").default} */ (this.getLayer());
        var replayState = tile.getReplayState(layer);
        var revision = layer.getRevision();
        var executorGroups = tile.executorGroups[Object(_util_js__WEBPACK_IMPORTED_MODULE_13__["getUid"])(layer)];
        replayState.renderedTileRevision = revision;
        var tileCoord = tile.wrappedTileCoord;
        var z = tileCoord[0];
        var source = layer.getSource();
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var projection = viewState.projection;
        var tileGrid = source.getTileGridForProjection(projection);
        var tileResolution = tileGrid.getResolution(tile.tileCoord[0]);
        var renderPixelRatio = (frameState.pixelRatio / tile.wantedResolution) * tileResolution;
        var resolution = tileGrid.getResolution(z);
        var context = tile.getContext(layer);
        // Increase tile size when overzooming for low pixel ratio, to avoid blurry tiles
        pixelRatio = Math.round(Math.max(pixelRatio, renderPixelRatio / pixelRatio));
        var size = source.getTilePixelSize(z, pixelRatio, projection);
        context.canvas.width = size[0];
        context.canvas.height = size[1];
        var renderScale = pixelRatio / renderPixelRatio;
        if (renderScale !== 1) {
            var canvasTransform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["reset"])(this.tmpTransform_);
            Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["scale"])(canvasTransform, renderScale, renderScale);
            context.setTransform.apply(context, canvasTransform);
        }
        var tileExtent = tileGrid.getTileCoordExtent(tileCoord, this.tmpExtent);
        var pixelScale = renderPixelRatio / resolution;
        var transform = Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["reset"])(this.tmpTransform_);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["scale"])(transform, pixelScale, -pixelScale);
        Object(_transform_js__WEBPACK_IMPORTED_MODULE_9__["translate"])(transform, -tileExtent[0], -tileExtent[3]);
        for (var i = 0, ii = executorGroups.length; i < ii; ++i) {
            var executorGroup = executorGroups[i];
            executorGroup.execute(context, renderScale, transform, 0, true, IMAGE_REPLAYS[layer.getRenderMode()]);
        }
        replayState.renderedTileResolution = tile.wantedResolution;
    };
    return CanvasVectorTileLayerRenderer;
}(_TileLayer_js__WEBPACK_IMPORTED_MODULE_2__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasVectorTileLayerRenderer);
//# sourceMappingURL=VectorTileLayer.js.map

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/**
 * @module ol/layer/VectorTileRenderType
 */
/**
 * @enum {string}
 * Render mode for vector tiles:
 * @api
 */
/* harmony default export */ __webpack_exports__["default"] = ({
    /**
     * Vector tiles are rendered as images. Great performance, but
     * point symbols and texts are always rotated with the view and pixels are
     * scaled during zoom animations
     * @api
     * @deprecated
     */
    IMAGE: 'image',
    /**
     * Polygon and line elements are rendered as images, so pixels
     * are scaled during zoom animations. Point symbols and texts are accurately
     * rendered as vectors and can stay upright on rotated views.
     * @api
     */
    HYBRID: 'hybrid',
    /**
     * Everything is rendered as vectors. Use this mode for improved
     * performance on vector tile layers with only a few rendered features (e.g.
     * for highlighting a subset of features of another layer with the same
     * source).
     * @api
     */
    VECTOR: 'vector',
});
//# sourceMappingURL=VectorTileRenderType.js.map

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyStyle", function() { return applyStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyBackground", function() { return applyBackground; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setupVectorSource", function() { return setupVectorSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return olms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "apply", function() { return apply; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLayer", function() { return getLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLayers", function() { return getLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getSource", function() { return getSource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_finalizeLayer", function() { return finalizeLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getFonts", function() { return getFonts; });
/* harmony import */ var ol_format_GeoJSON_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(210);
/* harmony import */ var ol_format_MVT_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(223);
/* harmony import */ var ol_Map_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(265);
/* harmony import */ var ol_tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(89);
/* harmony import */ var ol_source_TileJSON_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(149);
/* harmony import */ var ol_layer_Tile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(140);
/* harmony import */ var ol_layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(288);
/* harmony import */ var ol_source_Vector_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(105);
/* harmony import */ var ol_layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(331);
/* harmony import */ var ol_source_VectorTile_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(152);
/* harmony import */ var ol_View_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(179);
/* harmony import */ var _stylefunction_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(335);
/* harmony import */ var webfont_matcher_lib_fonts_google_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(342);
/* harmony import */ var webfont_matcher_lib_fonts_google_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(webfont_matcher_lib_fonts_google_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(336);
/* harmony import */ var mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(337);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(341);
/* harmony import */ var ol_tilegrid_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(88);
/* harmony import */ var ol_proj_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(7);
/* harmony import */ var ol_obj_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15);
/* harmony import */ var ol_Observable_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(48);
/*
ol-mapbox-style - Use Mapbox Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/




















/**
 * @typedef {import("ol/Map").default} PluggableMap
 * @typedef {import("ol/layer/Layer").default} Layer
 * @typedef {import("ol/source/Source").default} Source
 * @private
 */
var tilejsonCache = {};
var fontFamilyRegEx = /font-family: ?([^;]*);/;
var stripQuotesRegEx = /("|')/g;
var loadedFontFamilies;
function hasFontFamily(family) {
    if (!loadedFontFamilies) {
        loadedFontFamilies = {};
        var styleSheets = document.styleSheets;
        for (var i = 0, ii = styleSheets.length; i < ii; ++i) {
            var styleSheet = /** @type {CSSStyleSheet} */ (styleSheets[i]);
            try {
                var cssRules = styleSheet.rules || styleSheet.cssRules;
                if (cssRules) {
                    for (var j = 0, jj = cssRules.length; j < jj; ++j) {
                        var cssRule = cssRules[j];
                        if (cssRule.type == 5) {
                            var match = cssRule.cssText.match(fontFamilyRegEx);
                            loadedFontFamilies[match[1].replace(stripQuotesRegEx, '')] = true;
                        }
                    }
                }
            }
            catch (e) {
                // empty catch block
            }
        }
    }
    return family in loadedFontFamilies;
}
var processedFontFamilies = {};
var googleFamilies = webfont_matcher_lib_fonts_google_js__WEBPACK_IMPORTED_MODULE_12___default.a.getNames();
/**
 * @private
 * @param {Array} fonts Fonts.
 * @return {Array} Processed fonts.
 */
function getFonts(fonts) {
    var fontsKey = fonts.toString();
    if (fontsKey in processedFontFamilies) {
        return fonts;
    }
    var googleFontDescriptions = fonts.map(function (font) {
        var parts = mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_13___default()(font, 1).split(' ');
        return [parts.slice(3).join(' ').replace(/"/g, ''), parts[1] + parts[0]];
    });
    for (var i = 0, ii = googleFontDescriptions.length; i < ii; ++i) {
        var googleFontDescription = googleFontDescriptions[i];
        var family = googleFontDescription[0];
        if (!hasFontFamily(family) && googleFamilies.indexOf(family) !== -1) {
            var fontUrl = 'https://fonts.googleapis.com/css?family=' +
                family.replace(/ /g, '+') +
                ':' +
                googleFontDescription[1];
            if (!document.querySelector('link[href="' + fontUrl + '"]')) {
                var markup = document.createElement('link');
                markup.href = fontUrl;
                markup.rel = 'stylesheet';
                document.head.appendChild(markup);
            }
        }
    }
    processedFontFamilies[fontsKey] = true;
    return fonts;
}
var spriteRegEx = /^(.*)(\?.*)$/;
function withPath(url, path) {
    if (path && url.indexOf('.') === 0) {
        url = path + url;
    }
    return url;
}
function toSpriteUrl(url, path, extension) {
    url = withPath(url, path);
    var parts = url.match(spriteRegEx);
    return parts
        ? parts[1] + extension + (parts.length > 2 ? parts[2] : '')
        : url + extension;
}
/**
 * ```js
 * import {applyStyle} from 'ol-mapbox-style';
 * ```
 *
 * Applies a style function to an `ol.layer.VectorTile` or `ol.layer.Vector`
 * with an `ol.source.VectorTile` or an `ol.source.Vector`. The style function
 * will render all layers from the `glStyle` object that use the specified
 * `source`, or a subset of layers from the same source. The source needs to be
 * a `"type": "vector"` or `"type": "geojson"` source.
 *
 * Two additional properties will be set on the provided layer:
 *
 *  * `mapbox-source`: The `id` of the Mapbox Style document's source that the
 *    OpenLayers layer was created from. Usually `apply()` creates one
 *    OpenLayers layer per Mapbox Style source, unless the layer stack has
 *    layers from different sources in between.
 *  * `mapbox-layers`: The `id`s of the Mapbox Style document's layers that are
 *    included in the OpenLayers layer.
 *
 * @param {VectorTileLayer|VectorLayer} layer OpenLayers layer.
 * @param {string|Object} glStyle Mapbox Style object.
 * @param {string|Array<string>} source `source` key or an array of layer `id`s from the
 * Mapbox Style object. When a `source` key is provided, all layers for the
 * specified source will be included in the style function. When layer `id`s
 * are provided, they must be from layers that use the same source.
 * @param {string} [path=undefined] Path of the style file. Only required when
 * a relative path is used with the `"sprite"` property of the style.
 * @param {Array<number>} [resolutions=undefined] Resolutions for mapping resolution to zoom level.
 * @return {Promise} Promise which will be resolved when the style can be used
 * for rendering.
 */
function applyStyle(layer, glStyle, source, path, resolutions) {
    return new Promise(function (resolve, reject) {
        // TODO: figure out where best place to check source type is
        // Note that the source arg is an array of gl layer ids and each must be
        // dereferenced to get source type to validate
        if (typeof glStyle != 'object') {
            glStyle = JSON.parse(glStyle);
        }
        if (glStyle.version != 8) {
            return reject(new Error('glStyle version 8 required.'));
        }
        if (!(layer instanceof ol_layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__["default"] || layer instanceof ol_layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_8__["default"])) {
            return reject(new Error('Can only apply to VectorLayer or VectorTileLayer'));
        }
        var spriteScale, spriteData, spriteImageUrl, style;
        function onChange() {
            if (!style && (!glStyle.sprite || spriteData)) {
                style = Object(_stylefunction_js__WEBPACK_IMPORTED_MODULE_11__["default"])(layer, glStyle, source, resolutions, spriteData, spriteImageUrl, getFonts);
                if (!layer.getStyle()) {
                    reject(new Error("Nothing to show for source [".concat(source, "]")));
                }
                else {
                    resolve();
                }
            }
            else if (style) {
                layer.setStyle(style);
                resolve();
            }
            else {
                reject(new Error('Something went wrong trying to apply style.'));
            }
        }
        if (glStyle.sprite) {
            spriteScale = window.devicePixelRatio >= 1.5 ? 0.5 : 1;
            var sizeFactor_1 = spriteScale == 0.5 ? '@2x' : '';
            var spriteUrl_1 = toSpriteUrl(glStyle.sprite, path, sizeFactor_1 + '.json');
            fetch(spriteUrl_1, { credentials: 'same-origin' })
                .then(function (response) {
                if (!response.ok && sizeFactor_1 !== '') {
                    spriteUrl_1 = toSpriteUrl(glStyle.sprite, path, '.json');
                    return fetch(spriteUrl_1, { credentials: 'same-origin' });
                }
                else {
                    return response;
                }
            })
                .then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                else {
                    reject(new Error("Problem fetching sprite from ".concat(spriteUrl_1, ": ").concat(response.statusText)));
                }
            })
                .then(function (spritesJson) {
                if (spritesJson === undefined) {
                    return reject(new Error('No sprites found.'));
                }
                spriteData = spritesJson;
                spriteImageUrl = toSpriteUrl(glStyle.sprite, path, sizeFactor_1 + '.png');
                onChange();
            })
                .catch(function (err) {
                reject(new Error("Sprites cannot be loaded: ".concat(spriteUrl_1, ": ").concat(err.message)));
            });
        }
        else {
            onChange();
        }
    });
}
var emptyObj = {};
function setBackground(mapOrLayer, layer) {
    var background = {
        id: layer.id,
        type: layer.type,
    };
    var functionCache = {};
    function updateStyle(resolution) {
        var layout = layer.layout || {};
        var paint = layer.paint || {};
        background['paint'] = paint;
        var zoom = typeof mapOrLayer.getSource === 'function'
            ? mapOrLayer.getSource().getTileGrid().getZForResolution(resolution)
            : mapOrLayer.getView().getZoom();
        var element = typeof mapOrLayer.getTargetElement === 'function'
            ? mapOrLayer.getTargetElement()
            : undefined;
        var bg, opacity;
        if (paint['background-color'] !== undefined) {
            bg = Object(_stylefunction_js__WEBPACK_IMPORTED_MODULE_11__["getValue"])(background, 'paint', 'background-color', zoom, emptyObj, functionCache);
            if (element) {
                element.style.background = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_14__["Color"].parse(bg).toString();
            }
        }
        if (paint['background-opacity'] !== undefined) {
            opacity = Object(_stylefunction_js__WEBPACK_IMPORTED_MODULE_11__["getValue"])(background, 'paint', 'background-opacity', zoom, emptyObj, functionCache);
            if (element) {
                element.style.opacity = opacity;
            }
        }
        if (layout.visibility == 'none') {
            if (element) {
                element.style.backgroundColor = '';
                element.style.opacity = '';
            }
            return undefined;
        }
        return Object(_stylefunction_js__WEBPACK_IMPORTED_MODULE_11__["_colorWithOpacity"])(bg, opacity);
    }
    if (typeof mapOrLayer.getTargetElement === 'function') {
        if (mapOrLayer.getTargetElement()) {
            updateStyle();
        }
        mapOrLayer.on(['change:resolution', 'change:target'], updateStyle);
    }
    else if (typeof mapOrLayer.setBackground === 'function') {
        mapOrLayer.setBackground(updateStyle);
    }
    else {
        throw new Error('Unable to apply background.');
    }
}
/**
 * ```js
 * import {applyBackground} from 'ol-mapbox-style';
 * ```
 * Applies properties of the Mapbox Style's first `background` layer to the
 * provided map or VectorTile layer.
 * @param {PluggableMap|VectorTileLayer} mapOrLayer OpenLayers Map or VectorTile layer.
 * @param {Object} glStyle Mapbox Style object.
 */
function applyBackground(mapOrLayer, glStyle) {
    glStyle.layers.some(function (l) {
        if (l.type == 'background') {
            setBackground(mapOrLayer, l);
            return true;
        }
    });
}
function getSourceIdByRef(layers, ref) {
    var sourceId;
    layers.some(function (layer) {
        if (layer.id == ref) {
            sourceId = layer.source;
            return true;
        }
    });
    return sourceId;
}
function extentFromTileJSON(tileJSON) {
    var bounds = tileJSON.bounds;
    if (bounds) {
        var ll = Object(ol_proj_js__WEBPACK_IMPORTED_MODULE_17__["fromLonLat"])([bounds[0], bounds[1]]);
        var tr = Object(ol_proj_js__WEBPACK_IMPORTED_MODULE_17__["fromLonLat"])([bounds[2], bounds[3]]);
        return [ll[0], ll[1], tr[0], tr[1]];
    }
}
/**
 * Creates an OpenLayers VectorTile source for a gl source entry.
 * @param {Object} glSource "source" entry from a Mapbox Style object.
 * @param {string|undefined} url URL to use for the source. This is expected to be the complete http(s) url,
 * with access key applied.When not provided, `glSource.tiles` has to be set.
 * @return {Promise<import("ol/source/VectorTile").default>} Promise resolving to a VectorTile source.
 * @private
 */
function setupVectorSource(glSource, url) {
    glSource = Object(_util_js__WEBPACK_IMPORTED_MODULE_15__["assign"])({}, glSource);
    var cacheKey = [url, JSON.stringify(glSource)].toString();
    var tilejson = tilejsonCache[cacheKey];
    if (!tilejson) {
        tilejson = new ol_source_TileJSON_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
            url: glSource.tiles ? undefined : url,
            tileJSON: glSource.tiles ? glSource : undefined,
        });
        tilejsonCache[cacheKey] = tilejson;
    }
    return new Promise(function (resolve) {
        var key = tilejson.on('change', function () {
            var state = tilejson.getState();
            if (state === 'ready') {
                var tileJSONDoc = tilejson.getTileJSON();
                var tiles = Array.isArray(tileJSONDoc.tiles)
                    ? tileJSONDoc.tiles
                    : [tileJSONDoc.tiles];
                if (url) {
                    for (var i = 0, ii = tiles.length; i < ii; ++i) {
                        tiles[i] = decodeURI(new URL(tiles[i], url).href);
                    }
                }
                var tileGrid = tilejson.getTileGrid();
                var extent = extentFromTileJSON(tileJSONDoc);
                var minZoom = tileJSONDoc.minzoom || 0;
                var maxZoom = tileJSONDoc.maxzoom || 22;
                var source = tilejson.get('ol-source');
                if (source === undefined) {
                    source = new ol_source_VectorTile_js__WEBPACK_IMPORTED_MODULE_9__["default"]({
                        attributions: tilejson.getAttributions(),
                        format: new ol_format_MVT_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
                        tileGrid: new ol_tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                            origin: tileGrid.getOrigin(0),
                            extent: extent || tileGrid.getExtent(),
                            minZoom: minZoom,
                            resolutions: _util_js__WEBPACK_IMPORTED_MODULE_15__["defaultResolutions"].slice(0, maxZoom + 1),
                            tileSize: 512,
                        }),
                        urls: tiles,
                    });
                    tilejson.set('ol-source', source);
                }
                Object(ol_Observable_js__WEBPACK_IMPORTED_MODULE_19__["unByKey"])(key);
                resolve(source);
            }
            else if (state === 'error') {
                tilejson.set('ol-source', null);
                Object(ol_Observable_js__WEBPACK_IMPORTED_MODULE_19__["unByKey"])(key);
                resolve(undefined);
            }
        });
        if (tilejson.getState() === 'ready') {
            tilejson.changed();
        }
    });
}
function setupVectorLayer(glSource, url) {
    var layer = new ol_layer_VectorTile_js__WEBPACK_IMPORTED_MODULE_8__["default"]({
        declutter: true,
        visible: false,
    });
    setupVectorSource(glSource, url).then(function (source) {
        layer.setSource(source);
    });
    return layer;
}
function setupRasterLayer(glSource, url) {
    var layer = new ol_layer_Tile_js__WEBPACK_IMPORTED_MODULE_5__["default"]();
    var source = new ol_source_TileJSON_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
        transition: 0,
        url: glSource.tiles ? undefined : url,
        tileJSON: glSource.tiles ? glSource : undefined,
        crossOrigin: 'anonymous',
    });
    var key = source.on('change', function () {
        var state = source.getState();
        if (state === 'ready') {
            Object(ol_Observable_js__WEBPACK_IMPORTED_MODULE_19__["unByKey"])(key);
            var tileJSONDoc = /** @type {Object} */ (source.getTileJSON());
            var extent = extentFromTileJSON(tileJSONDoc);
            var tileGrid = source.getTileGrid();
            var tileSize = glSource.tileSize || tileJSONDoc.tileSize || 512;
            var minZoom = tileJSONDoc.minzoom || 0;
            var maxZoom = tileJSONDoc.maxzoom || 22;
            // Only works when using ES modules
            //@ts-ignore
            source.tileGrid = new ol_tilegrid_TileGrid_js__WEBPACK_IMPORTED_MODULE_3__["default"]({
                origin: tileGrid.getOrigin(0),
                extent: extent || tileGrid.getExtent(),
                minZoom: minZoom,
                resolutions: Object(ol_tilegrid_js__WEBPACK_IMPORTED_MODULE_16__["createXYZ"])({
                    maxZoom: maxZoom,
                    tileSize: tileSize,
                }).getResolutions(),
                tileSize: tileSize,
            });
            layer.setSource(source);
        }
        else if (state === 'error') {
            Object(ol_Observable_js__WEBPACK_IMPORTED_MODULE_19__["unByKey"])(key);
            layer.setSource(undefined);
        }
    });
    source.setTileLoadFunction(function (tile, src) {
        if (src.indexOf('{bbox-epsg-3857}') != -1) {
            var bbox = source.getTileGrid().getTileCoordExtent(tile.getTileCoord());
            src = src.replace('{bbox-epsg-3857}', bbox.toString());
        }
        var img = /** @type {import("ol/ImageTile").default} */ (tile).getImage();
        /** @type {HTMLImageElement} */ (img).src = src;
    });
    return layer;
}
var geoJsonFormat = new ol_format_GeoJSON_js__WEBPACK_IMPORTED_MODULE_0__["default"]();
function setupGeoJSONLayer(glSource, path) {
    var data = glSource.data;
    var features, geoJsonUrl;
    if (typeof data == 'string') {
        geoJsonUrl = withPath(data, path);
    }
    else {
        features = geoJsonFormat.readFeatures(data, {
            featureProjection: 'EPSG:3857',
        });
    }
    return new ol_layer_Vector_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
        source: new ol_source_Vector_js__WEBPACK_IMPORTED_MODULE_7__["default"]({
            attributions: glSource.attribution,
            features: features,
            format: geoJsonFormat,
            url: geoJsonUrl,
        }),
        visible: false,
    });
}
function updateRasterLayerProperties(glLayer, layer, view, functionCache) {
    var zoom = view.getZoom();
    var opacity = Object(_stylefunction_js__WEBPACK_IMPORTED_MODULE_11__["getValue"])(glLayer, 'paint', 'raster-opacity', zoom, emptyObj, functionCache);
    layer.setOpacity(opacity);
}
function processStyle(glStyle, map, baseUrl, host, path, accessToken) {
    if (accessToken === void 0) { accessToken = ''; }
    var promises = [];
    var view = map.getView();
    if (typeof view.options_ === 'object'
        ? Object(ol_obj_js__WEBPACK_IMPORTED_MODULE_18__["isEmpty"])(view.options_)
        : !view.isDef() && !view.getRotation() && !view.getResolutions()) {
        view = new ol_View_js__WEBPACK_IMPORTED_MODULE_10__["default"](Object(_util_js__WEBPACK_IMPORTED_MODULE_15__["assign"])(view.getProperties(), {
            maxResolution: _util_js__WEBPACK_IMPORTED_MODULE_15__["defaultResolutions"][0],
        }));
        map.setView(view);
    }
    if ('center' in glStyle && !view.getCenter()) {
        view.setCenter(Object(ol_proj_js__WEBPACK_IMPORTED_MODULE_17__["fromLonLat"])(glStyle.center));
    }
    if ('zoom' in glStyle && view.getZoom() === undefined) {
        view.setResolution(_util_js__WEBPACK_IMPORTED_MODULE_15__["defaultResolutions"][0] / Math.pow(2, glStyle.zoom));
    }
    if (!view.getCenter() || view.getZoom() === undefined) {
        view.fit(view.getProjection().getExtent(), {
            nearest: true,
            size: map.getSize(),
        });
    }
    if (glStyle.sprite) {
        if (glStyle.sprite.indexOf('mapbox://') == 0) {
            glStyle.sprite = baseUrl + '/sprite' + accessToken;
        }
        else if (glStyle.sprite.indexOf('http') != 0) {
            glStyle.sprite = (host ? host + path : '') + glStyle.sprite + accessToken;
        }
    }
    var glLayers = glStyle.layers;
    var layerIds = [];
    var glLayer, glSource, glSourceId, id, layer, url;
    var _loop_1 = function (i, ii) {
        glLayer = glLayers[i];
        var type = glLayer.type;
        if (type == 'heatmap' || type == 'hillshade') {
            //FIXME Unsupported layer type
        }
        else if (type == 'background') {
            setBackground(map, glLayer);
        }
        else {
            id = glLayer.source || getSourceIdByRef(glLayers, glLayer.ref);
            // this technique assumes gl layers will be in a particular order
            if (id != glSourceId) {
                if (layerIds.length) {
                    promises.push(finalizeLayer(layer, layerIds, glStyle, path, map));
                    layerIds = [];
                }
                glSource = glStyle.sources[id];
                url = glSource.url;
                if (url) {
                    url = withPath(url, path);
                    if (url.indexOf('mapbox://') == 0) {
                        var mapid_1 = url.replace('mapbox://', '');
                        glSource.tiles = ['a', 'b', 'c', 'd'].map(function (host) {
                            return ('https://' +
                                host +
                                '.tiles.mapbox.com/v4/' +
                                mapid_1 +
                                '/{z}/{x}/{y}.' +
                                (glSource.type == 'vector' ? 'vector.pbf' : 'png') +
                                accessToken);
                        });
                    }
                    else if (url.indexOf('/') === 0 && host.indexOf('http') === 0) {
                        url = host + url;
                    }
                }
                if (glSource.tiles) {
                    glSource.tiles = glSource.tiles.map(function (url) { return withPath(url, path); });
                }
                if (glSource.type == 'vector') {
                    layer = setupVectorLayer(glSource, url);
                }
                else if (glSource.type == 'raster') {
                    layer = setupRasterLayer(glSource, url);
                    layer.setVisible(glLayer.layout ? glLayer.layout.visibility !== 'none' : true);
                    var functionCache = {};
                    view.on('change:resolution', updateRasterLayerProperties.bind(this_1, glLayer, layer, view, functionCache));
                    updateRasterLayerProperties(glLayer, layer, view, functionCache);
                }
                else if (glSource.type == 'geojson') {
                    layer = setupGeoJSONLayer(glSource, path);
                }
                glSourceId = id;
                if (layer) {
                    layer.set('mapbox-source', glSourceId);
                }
            }
            layerIds.push(glLayer.id);
        }
    };
    var this_1 = this;
    for (var i = 0, ii = glLayers.length; i < ii; ++i) {
        _loop_1(i, ii);
    }
    promises.push(finalizeLayer(layer, layerIds, glStyle, path, map));
    map.set('mapbox-style', glStyle);
    return Promise.all(promises);
}
/**
 * ```js
 * import olms from 'ol-mapbox-style';
 * ```
 *
 * Loads and applies a Mapbox Style object to an OpenLayers Map. This includes
 * the map background, the layers, the center and the zoom.
 *
 * The center and zoom will only be set if present in the Mapbox Style document,
 * and if not already set on the OpenLayers map.
 *
 * Layers will be added to the OpenLayers map, without affecting any layers that
 * might already be set on the map.
 *
 * Layers added by `apply()` will have two additional properties:
 *
 *  * `mapbox-source`: The `id` of the Mapbox Style document's source that the
 *    OpenLayers layer was created from. Usually `apply()` creates one
 *    OpenLayers layer per Mapbox Style source, unless the layer stack has
 *    layers from different sources in between.
 *  * `mapbox-layers`: The `id`s of the Mapbox Style document's layers that are
 *    included in the OpenLayers layer.
 *
 * This function sets an additional `mapbox-style` property on the OpenLayers
 * map instance, which holds the Mapbox Style object.
 *
 * @param {PluggableMap|HTMLElement|string} map Either an existing OpenLayers Map
 * instance, or a HTML element, or the id of a HTML element that will be the
 * target of a new OpenLayers Map.
 * @param {string|Object} style JSON style object or style url pointing to a
 * Mapbox Style object. When using Mapbox APIs, the url must contain an access
 * token and look like
 * `https://api.mapbox.com/styles/v1/mapbox/bright-v9?access_token=[your_access_token_here]`.
 * When passed as JSON style object, all OpenLayers layers created by `apply()`
 * will be immediately available, but they may not have a source yet (i.e. when
 * they are defined by a TileJSON url in the Mapbox Style document). When passed
 * as style url, layers will be added to the map when the Mapbox Style document
 * is loaded and parsed.
 * @return {Promise} A promise that resolves after all layers have been added to
 * the OpenLayers Map instance, their sources set, and their styles applied. the
 * `resolve` callback will be called with the OpenLayers Map instance as
 * argument.
 */
function olms(map, style) {
    var promise, accessToken = '', baseUrl = '', host = '', path = '';
    if (typeof map === 'string' || map instanceof HTMLElement) {
        map = new ol_Map_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
            target: map,
        });
    }
    if (typeof style === 'string') {
        var parts = style.match(spriteRegEx);
        if (parts) {
            baseUrl = parts[1];
            accessToken = parts.length > 2 ? parts[2] : '';
        }
        promise = new Promise(function (resolve, reject) {
            fetch(style, {
                credentials: 'same-origin',
            })
                .then(function (response) {
                return response.json();
            })
                .then(function (glStyle) {
                var a = /** @type {HTMLAnchorElement} */ (document.createElement('A'));
                a.href = style;
                var href = a.href;
                path = a.pathname.split('/').slice(0, -1).join('/') + '/';
                host = href.substr(0, href.indexOf(path));
                processStyle(glStyle, map, baseUrl, host, path, accessToken)
                    .then(function () {
                    resolve(map);
                })
                    .catch(reject);
            })
                .catch(function (err) {
                reject(new Error("Could not load ".concat(style, ": ").concat(err.message)));
            });
        });
    }
    else {
        promise = new Promise(function (resolve, reject) {
            processStyle(style, map)
                .then(function () {
                resolve(map);
            })
                .catch(reject);
        });
    }
    return promise;
}
/**
 * ```js
 * import {apply} from 'ol-mapbox-style';
 * ```
 * Like `olms`, but returns an `ol/Map` instance instead of a `Promise`.
 *
 * @param {PluggableMap|HTMLElement|string} map Either an existing OpenLayers Map
 * instance, or a HTML element, or the id of a HTML element that will be the
 * target of a new OpenLayers Map.
 * @param {string|Object} style JSON style object or style url pointing to a
 * Mapbox Style object. When using Mapbox APIs, the url must contain an access
 * token and look like
 * `https://api.mapbox.com/styles/v1/mapbox/bright-v9?access_token=[your_access_token_here]`.
 * When passed as JSON style object, all OpenLayers layers created by `apply()`
 * will be immediately available, but they may not have a source yet (i.e. when
 * they are defined by a TileJSON url in the Mapbox Style document). When passed
 * as style url, layers will be added to the map when the Mapbox Style document
 * is loaded and parsed.
 * @return {PluggableMap} The OpenLayers Map instance that will be populated with the
 * contents described in the Mapbox Style object.
 */
function apply(map, style) {
    if (typeof map === 'string' || map instanceof HTMLElement) {
        map = new ol_Map_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
            target: map,
        });
    }
    setTimeout(function () {
        olms(map, style);
    }, 0);
    return map;
}
/**
 * If layerIds is not empty, applies the style specified in glStyle to the layer,
 * and adds the layer to the map.
 *
 * The layer may not yet have a source when the function is called.  If so, the style
 * is applied to the layer via a once listener on the 'change:source' event.
 *
 * @param {Layer} layer An OpenLayers layer instance.
 * @param {Array<string>} layerIds Array containing layer ids of already-processed layers.
 * @param {Object} glStyle Style as a JSON object.
 * @param {string|undefined} path The path part of the style URL. Only required
 * when a relative path is used with the `"sprite"` property of the style.
 * @param {PluggableMap} map OpenLayers Map.
 * @return {Promise} Returns a promise that resolves after the source has
 * been set on the specified layer, and the style has been applied.
 * @private
 */
function finalizeLayer(layer, layerIds, glStyle, path, map) {
    var minZoom = 24;
    var maxZoom = 0;
    var glLayers = glStyle.layers;
    for (var i = 0, ii = glLayers.length; i < ii; ++i) {
        var glLayer = glLayers[i];
        if (layerIds.indexOf(glLayer.id) !== -1) {
            minZoom = Math.min('minzoom' in glLayer ? glLayer.minzoom : 0, minZoom);
            maxZoom = Math.max('maxzoom' in glLayer ? glLayer.maxzoom : 24, maxZoom);
        }
    }
    return new Promise(function (resolve, reject) {
        var setStyle = function () {
            var source = layer.getSource();
            if (!source || source.getState() === 'error') {
                reject(new Error('Error accessing data for source ' + layer.get('mapbox-source')));
                return;
            }
            if (typeof source.getTileGrid === 'function') {
                var tileGrid = source.getTileGrid();
                if (tileGrid) {
                    var sourceMinZoom = tileGrid.getMinZoom();
                    if (minZoom > 0 || sourceMinZoom > 0) {
                        layer.setMaxResolution(Math.min(_util_js__WEBPACK_IMPORTED_MODULE_15__["defaultResolutions"][minZoom], tileGrid.getResolution(sourceMinZoom)) + 1e-9);
                    }
                    if (maxZoom < 24) {
                        layer.setMinResolution(_util_js__WEBPACK_IMPORTED_MODULE_15__["defaultResolutions"][maxZoom] + 1e-9);
                    }
                }
            }
            if (source instanceof ol_source_Vector_js__WEBPACK_IMPORTED_MODULE_7__["default"] ||
                source instanceof ol_source_VectorTile_js__WEBPACK_IMPORTED_MODULE_9__["default"]) {
                applyStyle(
                /** @type {import("ol/layer/Vector").default|import("ol/layer/VectorTile").default} */ (layer), glStyle, layerIds, path).then(function () {
                    layer.setVisible(true);
                    resolve();
                }, function (e) {
                    reject(e);
                });
            }
            else {
                resolve();
            }
        };
        layer.set('mapbox-layers', layerIds);
        if (map.getLayers().getArray().indexOf(layer) === -1) {
            map.addLayer(layer);
        }
        if (layer.getSource()) {
            setStyle();
        }
        else {
            layer.once('change:source', setStyle);
        }
    });
}
/**
 * ```js
 * import {getLayer} from 'ol-mapbox-style';
 * ```
 * Get the OpenLayers layer instance that contains the provided Mapbox Style
 * `layer`. Note that multiple Mapbox Style layers are combined in a single
 * OpenLayers layer instance when they use the same Mapbox Style `source`.
 * @param {PluggableMap} map OpenLayers Map.
 * @param {string} layerId Mapbox Style layer id.
 * @return {Layer} OpenLayers layer instance.
 */
function getLayer(map, layerId) {
    var layers = map.getLayers().getArray();
    for (var i = 0, ii = layers.length; i < ii; ++i) {
        var mapboxLayers = layers[i].get('mapbox-layers');
        if (mapboxLayers && mapboxLayers.indexOf(layerId) !== -1) {
            return /** @type {Layer} */ (layers[i]);
        }
    }
}
/**
 * ```js
 * import {getLayers} from 'ol-mapbox-style';
 * ```
 * Get the OpenLayers layer instances for the provided Mapbox Style `source`.
 * @param {PluggableMap} map OpenLayers Map.
 * @param {string} sourceId Mapbox Style source id.
 * @return {Array<Layer>} OpenLayers layer instances.
 */
function getLayers(map, sourceId) {
    var result = [];
    var layers = map.getLayers().getArray();
    for (var i = 0, ii = layers.length; i < ii; ++i) {
        if (layers[i].get('mapbox-source') === sourceId) {
            result.push(/** @type {Layer} */ (layers[i]));
        }
    }
    return result;
}
/**
 * ```js
 * import {getSource} from 'ol-mapbox-style';
 * ```
 * Get the OpenLayers source instance for the provided Mapbox Style `source`.
 * @param {PluggableMap} map OpenLayers Map.
 * @param {string} sourceId Mapbox Style source id.
 * @return {Source} OpenLayers source instance.
 */
function getSource(map, sourceId) {
    var layers = map.getLayers().getArray();
    for (var i = 0, ii = layers.length; i < ii; ++i) {
        var source = /** @type {Layer} */ (layers[i]).getSource();
        if (layers[i].get('mapbox-source') === sourceId) {
            return source;
        }
    }
}

//# sourceMappingURL=index.js.map

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValue", function() { return getValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderTransparent", function() { return renderTransparent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "recordStyleLayer", function() { return recordStyleLayer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_colorWithOpacity", function() { return colorWithOpacity; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_evaluateFilter", function() { return evaluateFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_fromTemplate", function() { return fromTemplate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_getValue", function() { return getValue; });
/* harmony import */ var ol_style_Circle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35);
/* harmony import */ var ol_style_Fill_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56);
/* harmony import */ var ol_style_Icon_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57);
/* harmony import */ var ol_render_Feature_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(226);
/* harmony import */ var ol_style_Stroke_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64);
/* harmony import */ var ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65);
/* harmony import */ var ol_style_Text_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66);
/* harmony import */ var mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(336);
/* harmony import */ var mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(337);
/* harmony import */ var _util_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(341);
/*
ol-mapbox-style - Use Mapbox Style objects with OpenLayers
Copyright 2016-present ol-mapbox-style contributors
License: https://raw.githubusercontent.com/openlayers/ol-mapbox-style/master/LICENSE
*/










/**
 * @typedef {import("ol/layer/Vector").default} VectorLayer
 * @typedef {import("ol/layer/VectorTile").default} VectorTileLayer
 * @typedef {import("ol/style/Style").StyleFunction} StyleFunction
 */
var isFunction = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["function"].isFunction;
var convertFunction = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["function"].convertFunction;
var isExpression = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["expression"].isExpression;
var createPropertyExpression = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["expression"].createPropertyExpression;
var types = {
    'Point': 1,
    'MultiPoint': 1,
    'LineString': 2,
    'MultiLineString': 2,
    'Polygon': 3,
    'MultiPolygon': 3,
};
var anchor = {
    'center': [0.5, 0.5],
    'left': [0, 0.5],
    'right': [1, 0.5],
    'top': [0.5, 0],
    'bottom': [0.5, 1],
    'top-left': [0, 0],
    'top-right': [1, 0],
    'bottom-left': [0, 1],
    'bottom-right': [1, 1],
};
var expressionData = function (rawExpression, propertySpec) {
    var compiledExpression = createPropertyExpression(rawExpression, propertySpec);
    if (compiledExpression.result === 'error') {
        throw new Error(compiledExpression.value
            .map(function (err) { return "".concat(err.key, ": ").concat(err.message); })
            .join(', '));
    }
    return compiledExpression.value;
};
var emptyObj = {};
var zoomObj = { zoom: 0 };
var renderFeatureCoordinates, renderFeature;
/**
 * @private
 * @param {Object} layer Gl object layer.
 * @param {string} layoutOrPaint 'layout' or 'paint'.
 * @param {string} property Feature property.
 * @param {number} zoom Zoom.
 * @param {Object} feature Gl feature.
 * @param {Object} [functionCache] Function cache.
 * @return {?} Value.
 */
function getValue(layer, layoutOrPaint, property, zoom, feature, functionCache) {
    var layerId = layer.id;
    if (!functionCache) {
        functionCache = {};
        console.warn('No functionCache provided to getValue()'); //eslint-disable-line no-console
    }
    if (!functionCache[layerId]) {
        functionCache[layerId] = {};
    }
    var functions = functionCache[layerId];
    if (!functions[property]) {
        var value_1 = (layer[layoutOrPaint] || emptyObj)[property];
        var propertySpec = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["latest"]["".concat(layoutOrPaint, "_").concat(layer.type)][property];
        if (value_1 === undefined) {
            value_1 = propertySpec.default;
        }
        var isExpr = isExpression(value_1);
        if (!isExpr && isFunction(value_1)) {
            value_1 = convertFunction(value_1, propertySpec);
            isExpr = true;
        }
        if (isExpr) {
            var compiledExpression = expressionData(value_1, propertySpec);
            functions[property] =
                compiledExpression.evaluate.bind(compiledExpression);
        }
        else {
            if (propertySpec.type == 'color') {
                value_1 = _mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["Color"].parse(value_1);
            }
            functions[property] = function () {
                return value_1;
            };
        }
    }
    zoomObj.zoom = zoom;
    return functions[property](zoomObj, feature);
}
/**
 * @private
 * @param {string} layerId Layer id.
 * @param {?} filter Filter.
 * @param {Object} feature Feature.
 * @param {number} zoom Zoom.
 * @param {Object} [filterCache] Filter cache.
 * @return {boolean} Filter result.
 */
function evaluateFilter(layerId, filter, feature, zoom, filterCache) {
    if (!filterCache) {
        console.warn('No filterCache provided to evaluateFilter()'); //eslint-disable-line no-console
    }
    if (!(layerId in filterCache)) {
        filterCache[layerId] = Object(_mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["featureFilter"])(filter).filter;
    }
    zoomObj.zoom = zoom;
    return filterCache[layerId](zoomObj, feature);
}
var renderTransparentEnabled = false;
/**
 * ```js
 * import {renderTransparent} from 'ol-mapbox-style/dist/stylefunction';
 * ```
 * Configure whether features with a transparent style should be rendered. When
 * set to `true`, it will be possible to hit detect content that is not visible,
 * like transparent fills of polygons, using `ol/layer/Layer#getFeatures()` or
 * `ol/Map#getFeaturesAtPixel()`
 * @param {boolean} enabled Rendering of transparent elements is enabled.
 * Default is `false`.
 */
function renderTransparent(enabled) {
    renderTransparentEnabled = enabled;
}
/**
 * @private
 * @param {?} color Color.
 * @param {number} opacity Opacity.
 * @return {string} Color.
 */
function colorWithOpacity(color, opacity) {
    if (color) {
        if (!renderTransparentEnabled && (color.a === 0 || opacity === 0)) {
            return undefined;
        }
        var a = color.a;
        opacity = opacity === undefined ? 1 : opacity;
        return a === 0
            ? 'transparent'
            : 'rgba(' +
                Math.round((color.r * 255) / a) +
                ',' +
                Math.round((color.g * 255) / a) +
                ',' +
                Math.round((color.b * 255) / a) +
                ',' +
                a * opacity +
                ')';
    }
    return color;
}
var templateRegEx = /^([^]*)\{(.*)\}([^]*)$/;
/**
 * @private
 * @param {string} text Text.
 * @param {Object} properties Properties.
 * @return {string} Text.
 */
function fromTemplate(text, properties) {
    var parts;
    do {
        parts = text.match(templateRegEx);
        if (parts) {
            var value = properties[parts[2]] || '';
            text = parts[1] + value + parts[3];
        }
    } while (parts);
    return text;
}
var recordLayer = false;
/**
 * ```js
 * import {recordStyleLayer} from 'ol-mapbox-style/dist/stylefunction';
 * ```
 * Turns recording of the Mapbox Style's `layer` on and off. When turned on,
 * the layer that a rendered feature belongs to will be set as the feature's
 * `mapbox-layer` property.
 * @param {boolean} [record=false] Recording of the style layer is on.
 */
function recordStyleLayer(record) {
    recordLayer = record;
}
/**
 * ```js
 * import stylefunction from 'ol-mapbox-style/dist/stylefunction';
 * ```
 * Creates a style function from the `glStyle` object for all layers that use
 * the specified `source`, which needs to be a `"type": "vector"` or
 * `"type": "geojson"` source and applies it to the specified OpenLayers layer.
 *
 * Two additional properties will be set on the provided layer:
 *
 *  * `mapbox-source`: The `id` of the Mapbox Style document's source that the
 *    OpenLayers layer was created from. Usually `apply()` creates one
 *    OpenLayers layer per Mapbox Style source, unless the layer stack has
 *    layers from different sources in between.
 *  * `mapbox-layers`: The `id`s of the Mapbox Style document's layers that are
 *    included in the OpenLayers layer.
 *
 * This function also works in a web worker. In worker mode, the main thread needs
 * to listen to messages from the worker and respond with another message to make
 * sure that sprite image loading works:
 *
 * ```js
 *  worker.addEventListener('message', event => {
 *   if (event.data.action === 'loadImage') {
 *     const image = new Image();
 *     image.crossOrigin = 'anonymous';
 *     image.addEventListener('load', function() {
 *       createImageBitmap(image, 0, 0, image.width, image.height).then(imageBitmap => {
 *         worker.postMessage({
 *           action: 'imageLoaded',
 *           image: imageBitmap,
 *           src: event.data.src
 *         }, [imageBitmap]);
 *       });
 *     });
 *     image.src = event.data.src;
 *   }
 * });
 * ```
 *
 * @param {VectorLayer|VectorTileLayer} olLayer OpenLayers layer to
 * apply the style to. In addition to the style, the layer will get two
 * properties: `mapbox-source` will be the `id` of the `glStyle`'s source used
 * for the layer, and `mapbox-layers` will be an array of the `id`s of the
 * `glStyle`'s layers.
 * @param {string|Object} glStyle Mapbox Style object.
 * @param {string|Array<string>} source `source` key or an array of layer `id`s
 * from the Mapbox Style object. When a `source` key is provided, all layers for
 * the specified source will be included in the style function. When layer `id`s
 * are provided, they must be from layers that use the same source.
 * @param {Array<number>} [resolutions=[78271.51696402048, 39135.75848201024, 19567.87924100512, 9783.93962050256, 4891.96981025128, 2445.98490512564, 1222.99245256282, 611.49622628141, 305.748113140705, 152.8740565703525, 76.43702828517625, 38.21851414258813, 19.109257071294063, 9.554628535647032, 4.777314267823516, 2.388657133911758, 1.194328566955879, 0.5971642834779395, 0.29858214173896974, 0.14929107086948487, 0.07464553543474244]]
 * Resolutions for mapping resolution to zoom level.
 * @param {Object} [spriteData=undefined] Sprite data from the url specified in
 * the Mapbox Style object's `sprite` property. Only required if a `sprite`
 * property is specified in the Mapbox Style object.
 * @param {string} [spriteImageUrl=undefined] Sprite image url for the sprite
 * specified in the Mapbox Style object's `sprite` property. Only required if a
 * `sprite` property is specified in the Mapbox Style object.
 * @param {function(Array<string>):Array<string>} [getFonts=undefined] Function that
 * receives a font stack as arguments, and returns a (modified) font stack that
 * is available. Font names are the names used in the Mapbox Style object. If
 * not provided, the font stack will be used as-is. This function can also be
 * used for loading web fonts.
 * @return {StyleFunction} Style function for use in
 * `ol.layer.Vector` or `ol.layer.VectorTile`.
 */
/* harmony default export */ __webpack_exports__["default"] = (function (olLayer, glStyle, source, resolutions, spriteData, spriteImageUrl, getFonts) {
    if (resolutions === void 0) { resolutions = _util_js__WEBPACK_IMPORTED_MODULE_9__["defaultResolutions"]; }
    if (typeof glStyle == 'string') {
        glStyle = JSON.parse(glStyle);
    }
    if (glStyle.version != 8) {
        throw new Error('glStyle version 8 required.');
    }
    var spriteImage, spriteImgSize;
    if (spriteImageUrl) {
        if (typeof Image !== 'undefined') {
            var img_1 = new Image();
            img_1.crossOrigin = 'anonymous';
            img_1.onload = function () {
                spriteImage = img_1;
                spriteImgSize = [img_1.width, img_1.height];
                olLayer.changed();
                img_1.onload = null;
            };
            img_1.src = spriteImageUrl;
        }
        else if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) { //eslint-disable-line
            var worker = /** @type {*} */ (self);
            // Main thread needs to handle 'loadImage' and dispatch 'imageLoaded'
            worker.postMessage({
                action: 'loadImage',
                src: spriteImageUrl,
            });
            worker.addEventListener('message', function handler(event) {
                if (event.data.action === 'imageLoaded' &&
                    event.data.src === spriteImageUrl) {
                    spriteImage = event.data.image;
                    spriteImgSize = [spriteImage.width, spriteImage.height];
                }
            });
        }
    }
    var allLayers = Object(_mapbox_mapbox_gl_style_spec__WEBPACK_IMPORTED_MODULE_8__["derefLayers"])(glStyle.layers);
    var layersBySourceLayer = {};
    var mapboxLayers = [];
    var iconImageCache = {};
    var patternCache = {};
    var functionCache = {};
    var filterCache = {};
    var mapboxSource;
    for (var i = 0, ii = allLayers.length; i < ii; ++i) {
        var layer = allLayers[i];
        var layerId = layer.id;
        if ((typeof source == 'string' && layer.source == source) ||
            source.indexOf(layerId) !== -1) {
            var sourceLayer = layer['source-layer'];
            if (!mapboxSource) {
                mapboxSource = layer.source;
                var source_1 = glStyle.sources[mapboxSource];
                if (!source_1) {
                    throw new Error("Source \"".concat(mapboxSource, "\" is not defined"));
                }
                var type = source_1.type;
                if (type !== 'vector' && type !== 'geojson') {
                    throw new Error("Source \"".concat(mapboxSource, "\" is not of type \"vector\" or \"geojson\", but \"").concat(type, "\""));
                }
            }
            var layers = layersBySourceLayer[sourceLayer];
            if (!layers) {
                layers = [];
                layersBySourceLayer[sourceLayer] = layers;
            }
            layers.push({
                layer: layer,
                index: i,
            });
            mapboxLayers.push(layerId);
        }
    }
    var textHalo = new ol_style_Stroke_js__WEBPACK_IMPORTED_MODULE_4__["default"]();
    var textColor = new ol_style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]();
    var styles = [];
    var styleFunction = function (feature, resolution) {
        var properties = feature.getProperties();
        var layers = layersBySourceLayer[properties.layer];
        if (!layers) {
            return;
        }
        var zoom = resolutions.indexOf(resolution);
        if (zoom == -1) {
            zoom = Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["getZoomForResolution"])(resolution, resolutions);
        }
        var type = types[feature.getGeometry().getType()];
        var f = {
            properties: properties,
            type: type,
        };
        var stylesLength = -1;
        var featureBelongsToLayer;
        var _loop_1 = function (i, ii) {
            var layerData = layers[i];
            var layer = layerData.layer;
            var layerId = layer.id;
            var layout = layer.layout || emptyObj;
            var paint = layer.paint || emptyObj;
            if (layout.visibility === 'none' ||
                ('minzoom' in layer && zoom < layer.minzoom) ||
                ('maxzoom' in layer && zoom >= layer.maxzoom)) {
                return "continue";
            }
            var filter = layer.filter;
            if (!filter || evaluateFilter(layerId, filter, f, zoom, filterCache)) {
                featureBelongsToLayer = layer;
                var color = void 0, opacity = void 0, fill = void 0, stroke = void 0, strokeColor = void 0, style = void 0;
                var index = layerData.index;
                if (type == 3 &&
                    (layer.type == 'fill' || layer.type == 'fill-extrusion')) {
                    opacity = getValue(layer, 'paint', layer.type + '-opacity', zoom, f, functionCache);
                    if (layer.type + '-pattern' in paint) {
                        var fillIcon = getValue(layer, 'paint', layer.type + '-pattern', zoom, f, functionCache);
                        if (fillIcon) {
                            var icon_1 = typeof fillIcon === 'string'
                                ? fromTemplate(fillIcon, properties)
                                : fillIcon.toString();
                            if (spriteImage && spriteData && spriteData[icon_1]) {
                                ++stylesLength;
                                style = styles[stylesLength];
                                if (!style ||
                                    !style.getFill() ||
                                    style.getStroke() ||
                                    style.getText()) {
                                    style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
                                        fill: new ol_style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"](),
                                    });
                                    styles[stylesLength] = style;
                                }
                                fill = style.getFill();
                                style.setZIndex(index);
                                var icon_cache_key = icon_1 + '.' + opacity;
                                var pattern = patternCache[icon_cache_key];
                                if (!pattern) {
                                    var spriteImageData = spriteData[icon_1];
                                    var canvas = Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["createCanvas"])(spriteImageData.width, spriteImageData.height);
                                    var ctx = /** @type {CanvasRenderingContext2D} */ (canvas.getContext('2d'));
                                    ctx.globalAlpha = opacity;
                                    ctx.drawImage(spriteImage, spriteImageData.x, spriteImageData.y, spriteImageData.width, spriteImageData.height, 0, 0, spriteImageData.width, spriteImageData.height);
                                    pattern = ctx.createPattern(canvas, 'repeat');
                                    patternCache[icon_cache_key] = pattern;
                                }
                                fill.setColor(pattern);
                            }
                        }
                    }
                    else {
                        color = colorWithOpacity(getValue(layer, 'paint', layer.type + '-color', zoom, f, functionCache), opacity);
                        if (layer.type + '-outline-color' in paint) {
                            strokeColor = colorWithOpacity(getValue(layer, 'paint', layer.type + '-outline-color', zoom, f, functionCache), opacity);
                        }
                        if (!strokeColor) {
                            strokeColor = color;
                        }
                        if (color || strokeColor) {
                            ++stylesLength;
                            style = styles[stylesLength];
                            if (!style ||
                                (color && !style.getFill()) ||
                                (!color && style.getFill()) ||
                                (strokeColor && !style.getStroke()) ||
                                (!strokeColor && style.getStroke()) ||
                                style.getText()) {
                                style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
                                    fill: color ? new ol_style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]() : undefined,
                                    stroke: strokeColor ? new ol_style_Stroke_js__WEBPACK_IMPORTED_MODULE_4__["default"]() : undefined,
                                });
                                styles[stylesLength] = style;
                            }
                            if (color) {
                                fill = style.getFill();
                                fill.setColor(color);
                            }
                            if (strokeColor) {
                                stroke = style.getStroke();
                                stroke.setColor(strokeColor);
                                stroke.setWidth(0.5);
                            }
                            style.setZIndex(index);
                        }
                    }
                }
                if (type != 1 && layer.type == 'line') {
                    color =
                        !('line-pattern' in paint) && 'line-color' in paint
                            ? colorWithOpacity(getValue(layer, 'paint', 'line-color', zoom, f, functionCache), getValue(layer, 'paint', 'line-opacity', zoom, f, functionCache))
                            : undefined;
                    var width_1 = getValue(layer, 'paint', 'line-width', zoom, f, functionCache);
                    if (color && width_1 > 0) {
                        ++stylesLength;
                        style = styles[stylesLength];
                        if (!style ||
                            !style.getStroke() ||
                            style.getFill() ||
                            style.getText()) {
                            style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]({
                                stroke: new ol_style_Stroke_js__WEBPACK_IMPORTED_MODULE_4__["default"](),
                            });
                            styles[stylesLength] = style;
                        }
                        stroke = style.getStroke();
                        stroke.setLineCap(getValue(layer, 'layout', 'line-cap', zoom, f, functionCache));
                        stroke.setLineJoin(getValue(layer, 'layout', 'line-join', zoom, f, functionCache));
                        stroke.setMiterLimit(getValue(layer, 'layout', 'line-miter-limit', zoom, f, functionCache));
                        stroke.setColor(color);
                        stroke.setWidth(width_1);
                        stroke.setLineDash(paint['line-dasharray']
                            ? getValue(layer, 'paint', 'line-dasharray', zoom, f, functionCache).map(function (x) {
                                return x * width_1;
                            })
                            : null);
                        style.setZIndex(index);
                    }
                }
                var hasImage = false;
                var text = null;
                var placementAngle = 0;
                var icon = void 0, iconImg = void 0, skipLabel = void 0;
                if ((type == 1 || type == 2) && 'icon-image' in layout) {
                    var iconImage = getValue(layer, 'layout', 'icon-image', zoom, f, functionCache);
                    if (iconImage) {
                        icon =
                            typeof iconImage === 'string'
                                ? fromTemplate(iconImage, properties)
                                : iconImage.toString();
                        var styleGeom = undefined;
                        if (spriteImage && spriteData && spriteData[icon]) {
                            var iconRotationAlignment = getValue(layer, 'layout', 'icon-rotation-alignment', zoom, f, functionCache);
                            if (type == 2) {
                                var geom = feature.getGeometry();
                                // ol package and ol-debug.js only
                                if (geom.getFlatMidpoint || geom.getFlatMidpoints) {
                                    var extent = geom.getExtent();
                                    var size = Math.sqrt(Math.max(Math.pow((extent[2] - extent[0]) / resolution, 2), Math.pow((extent[3] - extent[1]) / resolution, 2)));
                                    if (size > 150) {
                                        //FIXME Do not hard-code a size of 150
                                        var midpoint = geom.getType() === 'MultiLineString'
                                            ? geom.getFlatMidpoints()
                                            : geom.getFlatMidpoint();
                                        if (!renderFeature) {
                                            renderFeatureCoordinates = [NaN, NaN];
                                            renderFeature = new ol_render_Feature_js__WEBPACK_IMPORTED_MODULE_3__["default"]('Point', renderFeatureCoordinates, [], {}, null);
                                        }
                                        styleGeom = renderFeature;
                                        renderFeatureCoordinates[0] = midpoint[0];
                                        renderFeatureCoordinates[1] = midpoint[1];
                                        var placement = getValue(layer, 'layout', 'symbol-placement', zoom, f, functionCache);
                                        if (placement === 'line' &&
                                            iconRotationAlignment === 'map') {
                                            var stride = geom.getStride();
                                            var coordinates = geom.getFlatCoordinates();
                                            for (var i_1 = 0, ii_1 = coordinates.length - stride; i_1 < ii_1; i_1 += stride) {
                                                var x1 = coordinates[i_1];
                                                var y1 = coordinates[i_1 + 1];
                                                var x2 = coordinates[i_1 + stride];
                                                var y2 = coordinates[i_1 + stride + 1];
                                                var minX = Math.min(x1, x2);
                                                var minY = Math.min(y1, y2);
                                                var maxX = Math.max(x1, x2);
                                                var maxY = Math.max(y1, y2);
                                                if (midpoint[0] >= minX &&
                                                    midpoint[0] <= maxX &&
                                                    midpoint[1] >= minY &&
                                                    midpoint[1] <= maxY) {
                                                    placementAngle = Math.atan2(y1 - y2, x2 - x1);
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            if (type !== 2 || styleGeom) {
                                var iconSize = getValue(layer, 'layout', 'icon-size', zoom, f, functionCache);
                                var iconColor = paint['icon-color'] !== undefined
                                    ? getValue(layer, 'paint', 'icon-color', zoom, f, functionCache)
                                    : null;
                                if (!iconColor || iconColor.a !== 0) {
                                    var icon_cache_key = icon + '.' + iconSize;
                                    if (iconColor !== null) {
                                        icon_cache_key += '.' + iconColor;
                                    }
                                    iconImg = iconImageCache[icon_cache_key];
                                    if (!iconImg) {
                                        var spriteImageData_1 = spriteData[icon];
                                        iconImg = new ol_style_Icon_js__WEBPACK_IMPORTED_MODULE_2__["default"]({
                                            color: iconColor
                                                ? [
                                                    iconColor.r * 255,
                                                    iconColor.g * 255,
                                                    iconColor.b * 255,
                                                    iconColor.a,
                                                ]
                                                : undefined,
                                            img: spriteImage,
                                            imgSize: spriteImgSize,
                                            size: [spriteImageData_1.width, spriteImageData_1.height],
                                            offset: [spriteImageData_1.x, spriteImageData_1.y],
                                            rotateWithView: iconRotationAlignment === 'map',
                                            scale: iconSize / spriteImageData_1.pixelRatio,
                                            displacement: 'icon-offset' in layout
                                                ? getValue(layer, 'layout', 'icon-offset', zoom, f, functionCache).map(function (v) { return -v * spriteImageData_1.pixelRatio; })
                                                : undefined,
                                        });
                                        iconImageCache[icon_cache_key] = iconImg;
                                    }
                                }
                                if (iconImg) {
                                    ++stylesLength;
                                    style = styles[stylesLength];
                                    if (!style ||
                                        !style.getImage() ||
                                        style.getFill() ||
                                        style.getStroke()) {
                                        style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]();
                                        styles[stylesLength] = style;
                                    }
                                    style.setGeometry(styleGeom);
                                    iconImg.setRotation(placementAngle +
                                        Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["deg2rad"])(getValue(layer, 'layout', 'icon-rotate', zoom, f, functionCache)));
                                    iconImg.setOpacity(getValue(layer, 'paint', 'icon-opacity', zoom, f, functionCache));
                                    iconImg.setAnchor(anchor[getValue(layer, 'layout', 'icon-anchor', zoom, f, functionCache)]);
                                    style.setImage(iconImg);
                                    text = style.getText();
                                    style.setText(undefined);
                                    style.setZIndex(index);
                                    hasImage = true;
                                    skipLabel = false;
                                }
                            }
                            else {
                                skipLabel = true;
                            }
                        }
                    }
                }
                if (type == 1 && layer.type === 'circle') {
                    ++stylesLength;
                    style = styles[stylesLength];
                    if (!style ||
                        !style.getImage() ||
                        style.getFill() ||
                        style.getStroke()) {
                        style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]();
                        styles[stylesLength] = style;
                    }
                    var circleRadius = 'circle-radius' in paint
                        ? getValue(layer, 'paint', 'circle-radius', zoom, f, functionCache)
                        : 5;
                    var circleStrokeColor = colorWithOpacity(getValue(layer, 'paint', 'circle-stroke-color', zoom, f, functionCache), getValue(layer, 'paint', 'circle-stroke-opacity', zoom, f, functionCache));
                    var circleColor = colorWithOpacity(getValue(layer, 'paint', 'circle-color', zoom, f, functionCache), getValue(layer, 'paint', 'circle-opacity', zoom, f, functionCache));
                    var circleStrokeWidth = getValue(layer, 'paint', 'circle-stroke-width', zoom, f, functionCache);
                    var cache_key = circleRadius +
                        '.' +
                        circleStrokeColor +
                        '.' +
                        circleColor +
                        '.' +
                        circleStrokeWidth;
                    iconImg = iconImageCache[cache_key];
                    if (!iconImg) {
                        iconImg = new ol_style_Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]({
                            radius: circleRadius,
                            stroke: circleStrokeColor && circleStrokeWidth > 0
                                ? new ol_style_Stroke_js__WEBPACK_IMPORTED_MODULE_4__["default"]({
                                    width: circleStrokeWidth,
                                    color: circleStrokeColor,
                                })
                                : undefined,
                            fill: circleColor
                                ? new ol_style_Fill_js__WEBPACK_IMPORTED_MODULE_1__["default"]({
                                    color: circleColor,
                                })
                                : undefined,
                        });
                        iconImageCache[cache_key] = iconImg;
                    }
                    style.setImage(iconImg);
                    text = style.getText();
                    style.setText(undefined);
                    style.setGeometry(undefined);
                    style.setZIndex(index);
                    hasImage = true;
                }
                var label = void 0;
                if ('text-field' in layout) {
                    var textField = getValue(layer, 'layout', 'text-field', zoom, f, functionCache).toString();
                    label = fromTemplate(textField, properties).trim();
                    opacity = getValue(layer, 'paint', 'text-opacity', zoom, f, functionCache);
                }
                if (label && opacity && !skipLabel) {
                    if (!hasImage) {
                        ++stylesLength;
                        style = styles[stylesLength];
                        if (!style ||
                            !style.getText() ||
                            style.getFill() ||
                            style.getStroke()) {
                            style = new ol_style_Style_js__WEBPACK_IMPORTED_MODULE_5__["default"]();
                            styles[stylesLength] = style;
                        }
                        style.setImage(undefined);
                        style.setGeometry(undefined);
                    }
                    if (!style.getText()) {
                        style.setText(text ||
                            new ol_style_Text_js__WEBPACK_IMPORTED_MODULE_6__["default"]({
                                padding: [2, 2, 2, 2],
                            }));
                    }
                    text = style.getText();
                    var textSize = Math.round(getValue(layer, 'layout', 'text-size', zoom, f, functionCache));
                    var fontArray = getValue(layer, 'layout', 'text-font', zoom, f, functionCache);
                    var textLineHeight = getValue(layer, 'layout', 'text-line-height', zoom, f, functionCache);
                    var font = mapbox_to_css_font__WEBPACK_IMPORTED_MODULE_7___default()(getFonts ? getFonts(fontArray) : fontArray, textSize, textLineHeight);
                    var textTransform = layout['text-transform'];
                    if (textTransform == 'uppercase') {
                        label = label.toUpperCase();
                    }
                    else if (textTransform == 'lowercase') {
                        label = label.toLowerCase();
                    }
                    var maxTextWidth = getValue(layer, 'layout', 'text-max-width', zoom, f, functionCache);
                    var letterSpacing = getValue(layer, 'layout', 'text-letter-spacing', zoom, f, functionCache);
                    var wrappedLabel = type == 2
                        ? Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["applyLetterSpacing"])(label, letterSpacing)
                        : Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["wrapText"])(label, font, maxTextWidth, letterSpacing);
                    text.setText(wrappedLabel);
                    text.setFont(font);
                    text.setRotation(Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["deg2rad"])(getValue(layer, 'layout', 'text-rotate', zoom, f, functionCache)));
                    var textAnchor = getValue(layer, 'layout', 'text-anchor', zoom, f, functionCache);
                    var placement = hasImage || type == 1
                        ? 'point'
                        : getValue(layer, 'layout', 'symbol-placement', zoom, f, functionCache);
                    text.setPlacement(placement);
                    var textHaloWidth = getValue(layer, 'paint', 'text-halo-width', zoom, f, functionCache);
                    var textOffset = getValue(layer, 'layout', 'text-offset', zoom, f, functionCache);
                    var textTranslate = getValue(layer, 'paint', 'text-translate', zoom, f, functionCache);
                    // Text offset has to take halo width and line height into account
                    var vOffset = 0;
                    var hOffset = 0;
                    if (placement == 'point') {
                        var textAlign = 'center';
                        if (textAnchor.indexOf('left') !== -1) {
                            textAlign = 'left';
                            hOffset = textHaloWidth;
                        }
                        else if (textAnchor.indexOf('right') !== -1) {
                            textAlign = 'right';
                            hOffset = -textHaloWidth;
                        }
                        text.setTextAlign(textAlign);
                        var textRotationAlignment = getValue(layer, 'layout', 'text-rotation-alignment', zoom, f, functionCache);
                        text.setRotateWithView(textRotationAlignment == 'map');
                    }
                    else {
                        text.setMaxAngle((Object(_util_js__WEBPACK_IMPORTED_MODULE_9__["deg2rad"])(getValue(layer, 'layout', 'text-max-angle', zoom, f, functionCache)) *
                            label.length) /
                            wrappedLabel.length);
                        text.setTextAlign();
                        text.setRotateWithView(false);
                    }
                    var textBaseline = 'middle';
                    if (textAnchor.indexOf('bottom') == 0) {
                        textBaseline = 'bottom';
                        vOffset = -textHaloWidth - 0.5 * (textLineHeight - 1) * textSize;
                    }
                    else if (textAnchor.indexOf('top') == 0) {
                        textBaseline = 'top';
                        vOffset = textHaloWidth + 0.5 * (textLineHeight - 1) * textSize;
                    }
                    text.setTextBaseline(textBaseline);
                    text.setOffsetX(textOffset[0] * textSize + hOffset + textTranslate[0]);
                    text.setOffsetY(textOffset[1] * textSize + vOffset + textTranslate[1]);
                    textColor.setColor(colorWithOpacity(getValue(layer, 'paint', 'text-color', zoom, f, functionCache), opacity));
                    text.setFill(textColor);
                    var haloColor = colorWithOpacity(getValue(layer, 'paint', 'text-halo-color', zoom, f, functionCache), opacity);
                    if (haloColor) {
                        textHalo.setColor(haloColor);
                        // spec here : https://docs.mapbox.com/mapbox-gl-js/style-spec/#paint-symbol-text-halo-width
                        // Halo width must be doubled because it is applied around the center of the text outline
                        textHaloWidth *= 2;
                        // 1/4 of text size (spec) x 2
                        var halfTextSize = 0.5 * textSize;
                        textHalo.setWidth(textHaloWidth <= halfTextSize ? textHaloWidth : halfTextSize);
                        text.setStroke(textHalo);
                    }
                    else {
                        text.setStroke(undefined);
                    }
                    var textPadding = getValue(layer, 'layout', 'text-padding', zoom, f, functionCache);
                    var padding = text.getPadding();
                    if (textPadding !== padding[0]) {
                        padding[0] = textPadding;
                        padding[1] = textPadding;
                        padding[2] = textPadding;
                        padding[3] = textPadding;
                    }
                    style.setZIndex(index);
                }
            }
        };
        for (var i = 0, ii = layers.length; i < ii; ++i) {
            _loop_1(i, ii);
        }
        if (stylesLength > -1) {
            styles.length = stylesLength + 1;
            if (recordLayer) {
                if (typeof feature.set === 'function') {
                    // ol/Feature
                    feature.set('mapbox-layer', featureBelongsToLayer);
                }
                else {
                    // ol/render/Feature
                    feature.getProperties()['mapbox-layer'] = featureBelongsToLayer;
                }
            }
            return styles;
        }
    };
    olLayer.setStyle(styleFunction);
    olLayer.set('mapbox-source', mapboxSource);
    olLayer.set('mapbox-layers', mapboxLayers);
    return styleFunction;
});

//# sourceMappingURL=stylefunction.js.map

/***/ }),
/* 336 */
/***/ (function(module, exports) {

var fontWeights = {
  thin: 100,
  hairline: 100,
  'ultra-light': 100,
  'extra-light': 100,
  light: 200,
  book: 300,
  regular: 400,
  normal: 400,
  plain: 400,
  roman: 400,
  standard: 400,
  medium: 500,
  'semi-bold': 600,
  'demi-bold': 600,
  bold: 700,
  heavy: 800,
  black: 800,
  'extra-bold': 800,
  'ultra-black': 900,
  'extra-black': 900,
  'ultra-bold': 900,
  'heavy-black': 900,
  fat: 900,
  poster: 900
};
var sp = ' ';
var italicRE = /(italic|oblique)$/i;

var fontCache = {};

module.exports = function(fonts, size, lineHeight) {
  var cssData = fontCache[fonts];
  if (!cssData) {
    if (!Array.isArray(fonts)) {
      fonts = [fonts];
    }
    var weight = 400;
    var style = 'normal';
    var fontFamilies = [];
    var haveWeight, haveStyle;
    for (var i = 0, ii = fonts.length; i < ii; ++i) {
      var font = fonts[i];
      var parts = font.split(' ');
      var maybeWeight = parts[parts.length - 1].toLowerCase();
      if (maybeWeight == 'normal' || maybeWeight == 'italic' || maybeWeight == 'oblique') {
        style = haveStyle ? style : maybeWeight;
        parts.pop();
        maybeWeight = parts[parts.length - 1].toLowerCase();
      } else if (italicRE.test(maybeWeight)) {
        maybeWeight = maybeWeight.replace(italicRE, '');
        style = haveStyle ? style : parts[parts.length - 1].replace(maybeWeight, '');
      }
      for (var w in fontWeights) {
        var previousPart = parts.length > 1 ? parts[parts.length - 2].toLowerCase() : '';
        if (maybeWeight == w || maybeWeight == w.replace('-', '') || previousPart + '-' + maybeWeight == w) {
          weight = haveWeight ? weight : fontWeights[w];
          parts.pop();
          if (previousPart && w.startsWith(previousPart)) {
            parts.pop();
          }
          break;
        }
      }
      if (!haveWeight && typeof maybeWeight == 'number') {
        weight = maybeWeight;
      }
      var fontFamily = parts.join(sp)
        .replace('Klokantech Noto Sans', 'Noto Sans');
      if (fontFamily.indexOf(sp) !== -1) {
        fontFamily = '"' + fontFamily + '"';
      }
      fontFamilies.push(fontFamily);
    }
    // CSS font property: font-style font-weight font-size/line-height font-family
    cssData = fontCache[fonts] = [style, weight, fontFamilies];
  }
  return cssData[0] + sp + cssData[1] + sp + size + 'px' + (lineHeight ? '/' + lineHeight : '') + sp + cssData[2];
};


/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* WEBPACK VAR INJECTION */(function(global, Buffer) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Color", function() { return Color$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ParsingError", function() { return ParsingError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidationError", function() { return ValidationError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composite", function() { return composite; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "convertFilter", function() { return convertFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "derefLayers", function() { return derefLayers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "diff", function() { return diffStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expression", function() { return expression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "featureFilter", function() { return createFilter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "format", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "function", function() { return styleFunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "latest", function() { return v8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "migrate", function() { return migrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v8", function() { return v8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return validateStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "validateMapboxApiSupported", function() { return validateMapboxApiSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "visit", function() { return visit; });
var $version = 8;
var $root = {
	version: {
		required: true,
		type: "enum",
		values: [
			8
		],
		doc: "Style specification version number. Must be 8.",
		example: 8
	},
	name: {
		type: "string",
		doc: "A human-readable name for the style.",
		example: "Bright"
	},
	metadata: {
		type: "*",
		doc: "Arbitrary properties useful to track with the stylesheet, but do not influence rendering. Properties should be prefixed to avoid collisions, like 'mapbox:'."
	},
	center: {
		type: "array",
		value: "number",
		doc: "Default map center in longitude and latitude.  The style center will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",
		example: [
			-73.9749,
			40.7736
		]
	},
	zoom: {
		type: "number",
		doc: "Default zoom level.  The style zoom will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",
		example: 12.5
	},
	bearing: {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		doc: "Default bearing, in degrees. The bearing is the compass direction that is \"up\"; for example, a bearing of 90° orients the map so that east is up. This value will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",
		example: 29
	},
	pitch: {
		type: "number",
		"default": 0,
		units: "degrees",
		doc: "Default pitch, in degrees. Zero is perpendicular to the surface, for a look straight down at the map, while a greater value like 60 looks ahead towards the horizon. The style pitch will be used only if the map has not been positioned by other means (e.g. map options or user interaction).",
		example: 50
	},
	light: {
		type: "light",
		doc: "The global light source.",
		example: {
			anchor: "viewport",
			color: "white",
			intensity: 0.4
		}
	},
	terrain: {
		type: "terrain",
		doc: "A global modifier that elevates layers and markers based on a DEM data source."
	},
	fog: {
		type: "fog",
		doc: "A global effect that fades layers and markers based on their distance to the camera. The fog can be used to approximate the effect of atmosphere on distant objects and enhance the depth perception of the map when used with terrain or 3D features. Note: fog is renamed to atmosphere in the Android and iOS SDKs and planned to be changed in GL-JS v.3.0.0."
	},
	sources: {
		required: true,
		type: "sources",
		doc: "Data source specifications.",
		example: {
			"mapbox-streets": {
				type: "vector",
				url: "mapbox://mapbox.mapbox-streets-v6"
			}
		}
	},
	sprite: {
		type: "string",
		doc: "A base URL for retrieving the sprite image and metadata. The extensions `.png`, `.json` and scale factor `@2x.png` will be automatically appended. This property is required if any layer uses the `background-pattern`, `fill-pattern`, `line-pattern`, `fill-extrusion-pattern`, or `icon-image` properties. The URL must be absolute, containing the [scheme, authority and path components](https://en.wikipedia.org/wiki/URL#Syntax).",
		example: "mapbox://sprites/mapbox/bright-v8"
	},
	glyphs: {
		type: "string",
		doc: "A URL template for loading signed-distance-field glyph sets in PBF format. The URL must include `{fontstack}` and `{range}` tokens. This property is required if any layer uses the `text-field` layout property. The URL must be absolute, containing the [scheme, authority and path components](https://en.wikipedia.org/wiki/URL#Syntax).",
		example: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf"
	},
	transition: {
		type: "transition",
		doc: "A global transition definition to use as a default across properties, to be used for timing transitions between one value and the next when no property-specific transition is set. Collision-based symbol fading is controlled independently of the style's `transition` property.",
		example: {
			duration: 300,
			delay: 0
		}
	},
	projection: {
		type: "projection",
		doc: "The projection the map should be rendered in. Supported projections are Mercator, Globe, Albers, Equal Earth, Equirectangular (WGS84), Lambert conformal conic, Natural Earth, and Winkel Tripel. Terrain, sky and fog are supported by only Mercator and globe. CustomLayerInterface is not supported outside of Mercator.",
		example: {
			name: "albers",
			center: [
				-154,
				50
			],
			parallels: [
				55,
				65
			]
		}
	},
	layers: {
		required: true,
		type: "array",
		value: "layer",
		doc: "Layers will be drawn in the order of this array.",
		example: [
			{
				id: "water",
				source: "mapbox-streets",
				"source-layer": "water",
				type: "fill",
				paint: {
					"fill-color": "#00ffff"
				}
			}
		]
	}
};
var sources = {
	"*": {
		type: "source",
		doc: "Specification of a data source. For vector and raster sources, either TileJSON or a URL to a TileJSON must be provided. For image and video sources, a URL must be provided. For GeoJSON sources, a URL or inline GeoJSON must be provided."
	}
};
var source = [
	"source_vector",
	"source_raster",
	"source_raster_dem",
	"source_geojson",
	"source_video",
	"source_image"
];
var source_vector = {
	type: {
		required: true,
		type: "enum",
		values: {
			vector: {
				doc: "A vector tile source."
			}
		},
		doc: "The type of the source."
	},
	url: {
		type: "string",
		doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."
	},
	tiles: {
		type: "array",
		value: "string",
		doc: "An array of one or more tile source URLs, as in the TileJSON spec."
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		],
		doc: "An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
				doc: "Slippy map tilenames scheme."
			},
			tms: {
				doc: "OSGeo spec scheme."
			}
		},
		"default": "xyz",
		doc: "Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed."
	},
	minzoom: {
		type: "number",
		"default": 0,
		doc: "Minimum zoom level for which tiles are available, as in the TileJSON spec."
	},
	maxzoom: {
		type: "number",
		"default": 22,
		doc: "Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."
	},
	attribution: {
		type: "string",
		doc: "Contains an attribution to be displayed when the map is shown to a user."
	},
	promoteId: {
		type: "promoteId",
		doc: "A property to use as a feature id (for feature state). Either a property name, or an object of the form `{<sourceLayer>: <propertyName>}`. If specified as a string for a vector tile source, the same property is used across all its source layers. If specified as an object only specified source layers will have id overriden, others will fallback to original feature id"
	},
	volatile: {
		type: "boolean",
		"default": false,
		doc: "A setting to determine whether a source's tiles are cached locally.",
		"sdk-support": {
			"basic functionality": {
				android: "9.3.0",
				ios: "5.10.0"
			}
		}
	},
	"*": {
		type: "*",
		doc: "Other keys to configure the data source."
	}
};
var source_raster = {
	type: {
		required: true,
		type: "enum",
		values: {
			raster: {
				doc: "A raster tile source."
			}
		},
		doc: "The type of the source."
	},
	url: {
		type: "string",
		doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."
	},
	tiles: {
		type: "array",
		value: "string",
		doc: "An array of one or more tile source URLs, as in the TileJSON spec."
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		],
		doc: "An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."
	},
	minzoom: {
		type: "number",
		"default": 0,
		doc: "Minimum zoom level for which tiles are available, as in the TileJSON spec."
	},
	maxzoom: {
		type: "number",
		"default": 22,
		doc: "Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels",
		doc: "The minimum visual size to display tiles for this layer. Only configurable for raster layers."
	},
	scheme: {
		type: "enum",
		values: {
			xyz: {
				doc: "Slippy map tilenames scheme."
			},
			tms: {
				doc: "OSGeo spec scheme."
			}
		},
		"default": "xyz",
		doc: "Influences the y direction of the tile coordinates. The global-mercator (aka Spherical Mercator) profile is assumed."
	},
	attribution: {
		type: "string",
		doc: "Contains an attribution to be displayed when the map is shown to a user."
	},
	volatile: {
		type: "boolean",
		"default": false,
		doc: "A setting to determine whether a source's tiles are cached locally.",
		"sdk-support": {
			"basic functionality": {
				android: "9.3.0",
				ios: "5.10.0"
			}
		}
	},
	"*": {
		type: "*",
		doc: "Other keys to configure the data source."
	}
};
var source_raster_dem = {
	type: {
		required: true,
		type: "enum",
		values: {
			"raster-dem": {
				doc: "A RGB-encoded raster DEM source"
			}
		},
		doc: "The type of the source."
	},
	url: {
		type: "string",
		doc: "A URL to a TileJSON resource. Supported protocols are `http:`, `https:`, and `mapbox://<Tileset ID>`."
	},
	tiles: {
		type: "array",
		value: "string",
		doc: "An array of one or more tile source URLs, as in the TileJSON spec."
	},
	bounds: {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			-180,
			-85.051129,
			180,
			85.051129
		],
		doc: "An array containing the longitude and latitude of the southwest and northeast corners of the source's bounding box in the following order: `[sw.lng, sw.lat, ne.lng, ne.lat]`. When this property is included in a source, no tiles outside of the given bounds are requested by Mapbox GL."
	},
	minzoom: {
		type: "number",
		"default": 0,
		doc: "Minimum zoom level for which tiles are available, as in the TileJSON spec."
	},
	maxzoom: {
		type: "number",
		"default": 22,
		doc: "Maximum zoom level for which tiles are available, as in the TileJSON spec. Data from tiles at the maxzoom are used when displaying the map at higher zoom levels."
	},
	tileSize: {
		type: "number",
		"default": 512,
		units: "pixels",
		doc: "The minimum visual size to display tiles for this layer. Only configurable for raster layers."
	},
	attribution: {
		type: "string",
		doc: "Contains an attribution to be displayed when the map is shown to a user."
	},
	encoding: {
		type: "enum",
		values: {
			terrarium: {
				doc: "Terrarium format PNG tiles. See https://aws.amazon.com/es/public-datasets/terrain/ for more info."
			},
			mapbox: {
				doc: "Mapbox Terrain RGB tiles. See https://www.mapbox.com/help/access-elevation-data/#mapbox-terrain-rgb for more info."
			}
		},
		"default": "mapbox",
		doc: "The encoding used by this source. Mapbox Terrain RGB is used by default"
	},
	volatile: {
		type: "boolean",
		"default": false,
		doc: "A setting to determine whether a source's tiles are cached locally.",
		"sdk-support": {
			"basic functionality": {
				android: "9.3.0",
				ios: "5.10.0"
			}
		}
	},
	"*": {
		type: "*",
		doc: "Other keys to configure the data source."
	}
};
var source_geojson = {
	type: {
		required: true,
		type: "enum",
		values: {
			geojson: {
				doc: "A GeoJSON data source."
			}
		},
		doc: "The data type of the GeoJSON source."
	},
	data: {
		type: "*",
		doc: "A URL to a GeoJSON file, or inline GeoJSON."
	},
	maxzoom: {
		type: "number",
		"default": 18,
		doc: "Maximum zoom level at which to create vector tiles (higher means greater detail at high zoom levels)."
	},
	attribution: {
		type: "string",
		doc: "Contains an attribution to be displayed when the map is shown to a user."
	},
	buffer: {
		type: "number",
		"default": 128,
		maximum: 512,
		minimum: 0,
		doc: "Size of the tile buffer on each side. A value of 0 produces no buffer. A value of 512 produces a buffer as wide as the tile itself. Larger values produce fewer rendering artifacts near tile edges and slower performance."
	},
	filter: {
		type: "*",
		doc: "An expression for filtering features prior to processing them for rendering."
	},
	tolerance: {
		type: "number",
		"default": 0.375,
		doc: "Douglas-Peucker simplification tolerance (higher means simpler geometries and faster performance)."
	},
	cluster: {
		type: "boolean",
		"default": false,
		doc: "If the data is a collection of point features, setting this to true clusters the points by radius into groups. Cluster groups become new `Point` features in the source with additional properties:\n * `cluster` Is `true` if the point is a cluster \n * `cluster_id` A unqiue id for the cluster to be used in conjunction with the [cluster inspection methods](https://www.mapbox.com/mapbox-gl-js/api/#geojsonsource#getclusterexpansionzoom)\n * `point_count` Number of original points grouped into this cluster\n * `point_count_abbreviated` An abbreviated point count"
	},
	clusterRadius: {
		type: "number",
		"default": 50,
		minimum: 0,
		doc: "Radius of each cluster if clustering is enabled. A value of 512 indicates a radius equal to the width of a tile."
	},
	clusterMaxZoom: {
		type: "number",
		doc: "Max zoom on which to cluster points if clustering is enabled. Defaults to one zoom less than maxzoom (so that last zoom features are not clustered). Clusters are re-evaluated at integer zoom levels so setting clusterMaxZoom to 14 means the clusters will be displayed until z15."
	},
	clusterMinPoints: {
		type: "number",
		doc: "Minimum number of points necessary to form a cluster if clustering is enabled. Defaults to `2`."
	},
	clusterProperties: {
		type: "*",
		doc: "An object defining custom properties on the generated clusters if clustering is enabled, aggregating values from clustered points. Has the form `{\"property_name\": [operator, map_expression]}`. `operator` is any expression function that accepts at least 2 operands (e.g. `\"+\"` or `\"max\"`) — it accumulates the property value from clusters/points the cluster contains; `map_expression` produces the value of a single point.\n\nExample: `{\"sum\": [\"+\", [\"get\", \"scalerank\"]]}`.\n\nFor more advanced use cases, in place of `operator`, you can use a custom reduce expression that references a special `[\"accumulated\"]` value, e.g.:\n`{\"sum\": [[\"+\", [\"accumulated\"], [\"get\", \"sum\"]], [\"get\", \"scalerank\"]]}`"
	},
	lineMetrics: {
		type: "boolean",
		"default": false,
		doc: "Whether to calculate line distance metrics. This is required for line layers that specify `line-gradient` values."
	},
	generateId: {
		type: "boolean",
		"default": false,
		doc: "Whether to generate ids for the geojson features. When enabled, the `feature.id` property will be auto assigned based on its index in the `features` array, over-writing any previous values."
	},
	promoteId: {
		type: "promoteId",
		doc: "A property to use as a feature id (for feature state). Either a property name, or an object of the form `{<sourceLayer>: <propertyName>}`."
	}
};
var source_video = {
	type: {
		required: true,
		type: "enum",
		values: {
			video: {
				doc: "A video data source."
			}
		},
		doc: "The data type of the video source."
	},
	urls: {
		required: true,
		type: "array",
		value: "string",
		doc: "URLs to video content in order of preferred format."
	},
	coordinates: {
		required: true,
		doc: "Corners of video specified in longitude, latitude pairs.",
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number",
			doc: "A single longitude, latitude pair."
		}
	}
};
var source_image = {
	type: {
		required: true,
		type: "enum",
		values: {
			image: {
				doc: "An image data source."
			}
		},
		doc: "The data type of the image source."
	},
	url: {
		required: true,
		type: "string",
		doc: "URL that points to an image."
	},
	coordinates: {
		required: true,
		doc: "Corners of image specified in longitude, latitude pairs.",
		type: "array",
		length: 4,
		value: {
			type: "array",
			length: 2,
			value: "number",
			doc: "A single longitude, latitude pair."
		}
	}
};
var layer = {
	id: {
		type: "string",
		doc: "Unique layer name.",
		required: true
	},
	type: {
		type: "enum",
		values: {
			fill: {
				doc: "A filled polygon with an optional stroked border.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			line: {
				doc: "A stroked line.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			symbol: {
				doc: "An icon or a text label.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			circle: {
				doc: "A filled circle.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			heatmap: {
				doc: "A heatmap.",
				"sdk-support": {
					"basic functionality": {
						js: "0.41.0",
						android: "6.0.0",
						ios: "4.0.0",
						macos: "0.7.0"
					}
				}
			},
			"fill-extrusion": {
				doc: "An extruded (3D) polygon.",
				"sdk-support": {
					"basic functionality": {
						js: "0.27.0",
						android: "5.1.0",
						ios: "3.6.0",
						macos: "0.5.0"
					}
				}
			},
			raster: {
				doc: "Raster map textures such as satellite imagery.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			hillshade: {
				doc: "Client-side hillshading visualization based on DEM data. Currently, the implementation only supports Mapbox Terrain RGB and Mapzen Terrarium tiles.",
				"sdk-support": {
					"basic functionality": {
						js: "0.43.0",
						android: "6.0.0",
						ios: "4.0.0",
						macos: "0.7.0"
					}
				}
			},
			background: {
				doc: "The background color or pattern of the map.",
				"sdk-support": {
					"basic functionality": {
						js: "0.10.0",
						android: "2.0.1",
						ios: "2.0.0",
						macos: "0.1.0"
					}
				}
			},
			sky: {
				doc: "A spherical dome around the map that is always rendered behind all other layers.",
				"sdk-support": {
					"basic functionality": {
						js: "2.0.0",
						ios: "10.0.0",
						android: "10.0.0"
					}
				}
			}
		},
		doc: "Rendering type of this layer.",
		required: true
	},
	metadata: {
		type: "*",
		doc: "Arbitrary properties useful to track with the layer, but do not influence rendering. Properties should be prefixed to avoid collisions, like 'mapbox:'."
	},
	source: {
		type: "string",
		doc: "Name of a source description to be used for this layer. Required for all layer types except `background`."
	},
	"source-layer": {
		type: "string",
		doc: "Layer to use from a vector tile source. Required for vector tile sources; prohibited for all other source types, including GeoJSON sources."
	},
	minzoom: {
		type: "number",
		minimum: 0,
		maximum: 24,
		doc: "The minimum zoom level for the layer. At zoom levels less than the minzoom, the layer will be hidden."
	},
	maxzoom: {
		type: "number",
		minimum: 0,
		maximum: 24,
		doc: "The maximum zoom level for the layer. At zoom levels equal to or greater than the maxzoom, the layer will be hidden."
	},
	filter: {
		type: "filter",
		doc: "An expression specifying conditions on source features. Only features that match the filter are displayed. Zoom expressions in filters are only evaluated at integer zoom levels. The `[\"feature-state\", ...]` expression is not supported in filter expressions.  The `[\"pitch\"]` and `[\"distance-from-center\"]` expressions are supported only for filter expressions on the symbol layer."
	},
	layout: {
		type: "layout",
		doc: "Layout properties for the layer."
	},
	paint: {
		type: "paint",
		doc: "Default paint properties for this layer."
	}
};
var layout = [
	"layout_fill",
	"layout_line",
	"layout_circle",
	"layout_heatmap",
	"layout_fill-extrusion",
	"layout_symbol",
	"layout_raster",
	"layout_hillshade",
	"layout_background",
	"layout_sky"
];
var layout_background = {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_sky = {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_fill = {
	"fill-sort-key": {
		type: "number",
		doc: "Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.",
		"sdk-support": {
			"basic functionality": {
				js: "1.2.0",
				android: "9.1.0",
				ios: "5.8.0",
				macos: "0.15.0"
			},
			"data-driven styling": {
				js: "1.2.0",
				android: "9.1.0",
				ios: "5.8.0",
				macos: "0.15.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_circle = {
	"circle-sort-key": {
		type: "number",
		doc: "Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.",
		"sdk-support": {
			"basic functionality": {
				js: "1.2.0",
				android: "9.2.0",
				ios: "5.9.0",
				macos: "0.16.0"
			},
			"data-driven styling": {
				js: "1.2.0",
				android: "9.2.0",
				ios: "5.9.0",
				macos: "0.16.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_heatmap = {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_line = {
	"line-cap": {
		type: "enum",
		values: {
			butt: {
				doc: "A cap with a squared-off end which is drawn to the exact endpoint of the line."
			},
			round: {
				doc: "A cap with a rounded end which is drawn beyond the endpoint of the line at a radius of one-half of the line's width and centered on the endpoint of the line."
			},
			square: {
				doc: "A cap with a squared-off end which is drawn beyond the endpoint of the line at a distance of one-half of the line's width."
			}
		},
		"default": "butt",
		doc: "The display of line endings.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "2.3.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-join": {
		type: "enum",
		values: {
			bevel: {
				doc: "A join with a squared-off end which is drawn beyond the endpoint of the line at a distance of one-half of the line's width."
			},
			round: {
				doc: "A join with a rounded end which is drawn beyond the endpoint of the line at a radius of one-half of the line's width and centered on the endpoint of the line."
			},
			miter: {
				doc: "A join with a sharp, angled corner which is drawn with the outer sides beyond the endpoint of the path until they meet."
			}
		},
		"default": "miter",
		doc: "The display of lines when joining.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.40.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-miter-limit": {
		type: "number",
		"default": 2,
		doc: "Used to automatically convert miter joins to bevel joins for sharp angles.",
		requires: [
			{
				"line-join": "miter"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-round-limit": {
		type: "number",
		"default": 1.05,
		doc: "Used to automatically convert round joins to miter joins for shallow angles.",
		requires: [
			{
				"line-join": "round"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-sort-key": {
		type: "number",
		doc: "Sorts features in ascending order based on this value. Features with a higher sort key will appear above features with a lower sort key.",
		"sdk-support": {
			"basic functionality": {
				js: "1.2.0",
				android: "9.1.0",
				ios: "5.8.0",
				macos: "0.15.0"
			},
			"data-driven styling": {
				js: "1.2.0",
				android: "9.1.0",
				ios: "5.8.0",
				macos: "0.15.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_symbol = {
	"symbol-placement": {
		type: "enum",
		values: {
			point: {
				doc: "The label is placed at the point where the geometry is located."
			},
			line: {
				doc: "The label is placed along the line of the geometry. Can only be used on `LineString` and `Polygon` geometries."
			},
			"line-center": {
				doc: "The label is placed at the center of the line of the geometry. Can only be used on `LineString` and `Polygon` geometries. Note that a single feature in a vector tile may contain multiple line geometries."
			}
		},
		"default": "point",
		doc: "Label placement relative to its geometry.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"`line-center` value": {
				js: "0.47.0",
				android: "6.4.0",
				ios: "4.3.0",
				macos: "0.10.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-spacing": {
		type: "number",
		"default": 250,
		minimum: 1,
		units: "pixels",
		doc: "Distance between two symbol anchors.",
		requires: [
			{
				"symbol-placement": "line"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-avoid-edges": {
		type: "boolean",
		"default": false,
		doc: "If true, the symbols will not cross tile edges to avoid mutual collisions. Recommended in layers that don't have enough padding in the vector tile to prevent collisions, or if it is a point symbol layer placed after a line symbol layer. When using a client that supports global collision detection, like Mapbox GL JS version 0.42.0 or greater, enabling this property is not needed to prevent clipped labels at tile boundaries.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"symbol-sort-key": {
		type: "number",
		doc: "Sorts features in ascending order based on this value. Features with lower sort keys are drawn and placed first.  When `icon-allow-overlap` or `text-allow-overlap` is `false`, features with a lower sort key will have priority during placement. When `icon-allow-overlap` or `text-allow-overlap` is set to `true`, features with a higher sort key will overlap over features with a lower sort key.",
		"sdk-support": {
			"basic functionality": {
				js: "0.53.0",
				android: "7.4.0",
				ios: "4.11.0",
				macos: "0.14.0"
			},
			"data-driven styling": {
				js: "0.53.0",
				android: "7.4.0",
				ios: "4.11.0",
				macos: "0.14.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"symbol-z-order": {
		type: "enum",
		values: {
			auto: {
				doc: "Sorts symbols by `symbol-sort-key` if set. Otherwise, sorts symbols by their y-position relative to the viewport if `icon-allow-overlap` or `text-allow-overlap` is set to `true` or `icon-ignore-placement` or `text-ignore-placement` is `false`."
			},
			"viewport-y": {
				doc: "Sorts symbols by their y-position relative to the viewport if `icon-allow-overlap` or `text-allow-overlap` is set to `true` or `icon-ignore-placement` or `text-ignore-placement` is `false`."
			},
			source: {
				doc: "Sorts symbols by `symbol-sort-key` if set. Otherwise, no sorting is applied; symbols are rendered in the same order as the source data."
			}
		},
		"default": "auto",
		doc: "Determines whether overlapping symbols in the same layer are rendered in the order that they appear in the data source or by their y-position relative to the viewport. To control the order and prioritization of symbols otherwise, use `symbol-sort-key`.",
		"sdk-support": {
			"basic functionality": {
				js: "0.49.0",
				android: "6.6.0",
				ios: "4.5.0",
				macos: "0.12.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-allow-overlap": {
		type: "boolean",
		"default": false,
		doc: "If true, the icon will be visible even if it collides with other previously drawn symbols.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-ignore-placement": {
		type: "boolean",
		"default": false,
		doc: "If true, other symbols can be visible even if they collide with the icon.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-optional": {
		type: "boolean",
		"default": false,
		doc: "If true, text will display without their corresponding icons when the icon collides with other symbols and the text does not.",
		requires: [
			"icon-image",
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-rotation-alignment": {
		type: "enum",
		values: {
			map: {
				doc: "When `symbol-placement` is set to `point`, aligns icons east-west. When `symbol-placement` is set to `line` or `line-center`, aligns icon x-axes with the line."
			},
			viewport: {
				doc: "Produces icons whose x-axes are aligned with the x-axis of the viewport, regardless of the value of `symbol-placement`."
			},
			auto: {
				doc: "When `symbol-placement` is set to `point`, this is equivalent to `viewport`. When `symbol-placement` is set to `line` or `line-center`, this is equivalent to `map`."
			}
		},
		"default": "auto",
		doc: "In combination with `symbol-placement`, determines the rotation behavior of icons.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"`auto` value": {
				js: "0.25.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.3.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-size": {
		type: "number",
		"default": 1,
		minimum: 0,
		units: "factor of the original icon size",
		doc: "Scales the original size of the icon by the provided factor. The new pixel size of the image will be the original pixel size multiplied by `icon-size`. 1 is the original size; 3 triples the size of the image.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.35.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-text-fit": {
		type: "enum",
		values: {
			none: {
				doc: "The icon is displayed at its intrinsic aspect ratio."
			},
			width: {
				doc: "The icon is scaled in the x-dimension to fit the width of the text."
			},
			height: {
				doc: "The icon is scaled in the y-dimension to fit the height of the text."
			},
			both: {
				doc: "The icon is scaled in both x- and y-dimensions."
			}
		},
		"default": "none",
		doc: "Scales the icon to fit around the associated text.",
		requires: [
			"icon-image",
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.21.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.2.1"
			},
			"stretchable icons": {
				js: "1.6.0",
				android: "9.2.0",
				ios: "5.8.0",
				macos: "0.15.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-text-fit-padding": {
		type: "array",
		value: "number",
		length: 4,
		"default": [
			0,
			0,
			0,
			0
		],
		units: "pixels",
		doc: "Size of the additional area added to dimensions determined by `icon-text-fit`, in clockwise order: top, right, bottom, left.",
		requires: [
			"icon-image",
			"text-field",
			{
				"icon-text-fit": [
					"both",
					"width",
					"height"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.21.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.2.1"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-image": {
		type: "resolvedImage",
		doc: "Name of image in sprite to use for drawing an image background.",
		tokens: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.35.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		doc: "Rotates the icon clockwise.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.21.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-padding": {
		type: "number",
		"default": 2,
		minimum: 0,
		units: "pixels",
		doc: "Size of the additional area around the icon bounding box used for detecting symbol collisions.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-keep-upright": {
		type: "boolean",
		"default": false,
		doc: "If true, the icon may be flipped to prevent it from being rendered upside-down.",
		requires: [
			"icon-image",
			{
				"icon-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-offset": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		doc: "Offset distance of icon from its anchor. Positive values indicate right and down, while negative values indicate left and up. Each component is multiplied by the value of `icon-size` to obtain the final offset in pixels. When combined with `icon-rotate` the offset will be as if the rotated direction was up.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-anchor": {
		type: "enum",
		values: {
			center: {
				doc: "The center of the icon is placed closest to the anchor."
			},
			left: {
				doc: "The left side of the icon is placed closest to the anchor."
			},
			right: {
				doc: "The right side of the icon is placed closest to the anchor."
			},
			top: {
				doc: "The top of the icon is placed closest to the anchor."
			},
			bottom: {
				doc: "The bottom of the icon is placed closest to the anchor."
			},
			"top-left": {
				doc: "The top left corner of the icon is placed closest to the anchor."
			},
			"top-right": {
				doc: "The top right corner of the icon is placed closest to the anchor."
			},
			"bottom-left": {
				doc: "The bottom left corner of the icon is placed closest to the anchor."
			},
			"bottom-right": {
				doc: "The bottom right corner of the icon is placed closest to the anchor."
			}
		},
		"default": "center",
		doc: "Part of the icon placed closest to the anchor.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.40.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			},
			"data-driven styling": {
				js: "0.40.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"icon-pitch-alignment": {
		type: "enum",
		values: {
			map: {
				doc: "The icon is aligned to the plane of the map."
			},
			viewport: {
				doc: "The icon is aligned to the plane of the viewport."
			},
			auto: {
				doc: "Automatically matches the value of `icon-rotation-alignment`."
			}
		},
		"default": "auto",
		doc: "Orientation of icon when map is pitched.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.39.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-pitch-alignment": {
		type: "enum",
		values: {
			map: {
				doc: "The text is aligned to the plane of the map."
			},
			viewport: {
				doc: "The text is aligned to the plane of the viewport."
			},
			auto: {
				doc: "Automatically matches the value of `text-rotation-alignment`."
			}
		},
		"default": "auto",
		doc: "Orientation of text when map is pitched.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.21.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.2.1"
			},
			"`auto` value": {
				js: "0.25.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.3.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotation-alignment": {
		type: "enum",
		values: {
			map: {
				doc: "When `symbol-placement` is set to `point`, aligns text east-west. When `symbol-placement` is set to `line` or `line-center`, aligns text x-axes with the line."
			},
			viewport: {
				doc: "Produces glyphs whose x-axes are aligned with the x-axis of the viewport, regardless of the value of `symbol-placement`."
			},
			auto: {
				doc: "When `symbol-placement` is set to `point`, this is equivalent to `viewport`. When `symbol-placement` is set to `line` or `line-center`, this is equivalent to `map`."
			}
		},
		"default": "auto",
		doc: "In combination with `symbol-placement`, determines the rotation behavior of the individual glyphs forming the text.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"`auto` value": {
				js: "0.25.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.3.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-field": {
		type: "formatted",
		"default": "",
		tokens: true,
		doc: "Value to use for a text label. If a plain `string` is provided, it will be treated as a `formatted` with default/inherited formatting options. SDF images are not supported in formatted text and will be ignored.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-font": {
		type: "array",
		value: "string",
		"default": [
			"Open Sans Regular",
			"Arial Unicode MS Regular"
		],
		doc: "Font stack to use for displaying text.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-size": {
		type: "number",
		"default": 16,
		minimum: 0,
		units: "pixels",
		doc: "Font size.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.35.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-width": {
		type: "number",
		"default": 10,
		minimum: 0,
		units: "ems",
		doc: "The maximum line width for text wrapping.",
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.40.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-line-height": {
		type: "number",
		"default": 1.2,
		units: "ems",
		doc: "Text leading value for multi-line text.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "2.3.0",
				android: "10.0.0",
				ios: "10.0.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-letter-spacing": {
		type: "number",
		"default": 0,
		units: "ems",
		doc: "Text tracking amount.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.40.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-justify": {
		type: "enum",
		values: {
			auto: {
				doc: "The text is aligned towards the anchor position."
			},
			left: {
				doc: "The text is aligned to the left."
			},
			center: {
				doc: "The text is centered."
			},
			right: {
				doc: "The text is aligned to the right."
			}
		},
		"default": "center",
		doc: "Text justification options.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.39.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			},
			auto: {
				js: "0.54.0",
				android: "7.4.0",
				ios: "4.10.0",
				macos: "0.14.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-radial-offset": {
		type: "number",
		units: "ems",
		"default": 0,
		doc: "Radial offset of text, in the direction of the symbol's anchor. Useful in combination with `text-variable-anchor`, which defaults to using the two-dimensional `text-offset` if present.",
		"sdk-support": {
			"basic functionality": {
				js: "0.54.0",
				android: "7.4.0",
				ios: "4.10.0",
				macos: "0.14.0"
			},
			"data-driven styling": {
				js: "0.54.0",
				android: "7.4.0",
				ios: "4.10.0",
				macos: "0.14.0"
			}
		},
		requires: [
			"text-field"
		],
		"property-type": "data-driven",
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		}
	},
	"text-variable-anchor": {
		type: "array",
		value: "enum",
		values: {
			center: {
				doc: "The center of the text is placed closest to the anchor."
			},
			left: {
				doc: "The left side of the text is placed closest to the anchor."
			},
			right: {
				doc: "The right side of the text is placed closest to the anchor."
			},
			top: {
				doc: "The top of the text is placed closest to the anchor."
			},
			bottom: {
				doc: "The bottom of the text is placed closest to the anchor."
			},
			"top-left": {
				doc: "The top left corner of the text is placed closest to the anchor."
			},
			"top-right": {
				doc: "The top right corner of the text is placed closest to the anchor."
			},
			"bottom-left": {
				doc: "The bottom left corner of the text is placed closest to the anchor."
			},
			"bottom-right": {
				doc: "The bottom right corner of the text is placed closest to the anchor."
			}
		},
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"point"
				]
			}
		],
		doc: "To increase the chance of placing high-priority labels on the map, you can provide an array of `text-anchor` locations: the renderer will attempt to place the label at each location, in order, before moving onto the next label. Use `text-justify: auto` to choose justification based on anchor position. To apply an offset, use the `text-radial-offset` or the two-dimensional `text-offset`.",
		"sdk-support": {
			"basic functionality": {
				js: "0.54.0",
				android: "7.4.0",
				ios: "4.10.0",
				macos: "0.14.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-anchor": {
		type: "enum",
		values: {
			center: {
				doc: "The center of the text is placed closest to the anchor."
			},
			left: {
				doc: "The left side of the text is placed closest to the anchor."
			},
			right: {
				doc: "The right side of the text is placed closest to the anchor."
			},
			top: {
				doc: "The top of the text is placed closest to the anchor."
			},
			bottom: {
				doc: "The bottom of the text is placed closest to the anchor."
			},
			"top-left": {
				doc: "The top left corner of the text is placed closest to the anchor."
			},
			"top-right": {
				doc: "The top right corner of the text is placed closest to the anchor."
			},
			"bottom-left": {
				doc: "The bottom left corner of the text is placed closest to the anchor."
			},
			"bottom-right": {
				doc: "The bottom right corner of the text is placed closest to the anchor."
			}
		},
		"default": "center",
		doc: "Part of the text placed closest to the anchor.",
		requires: [
			"text-field",
			{
				"!": "text-variable-anchor"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.39.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-max-angle": {
		type: "number",
		"default": 45,
		units: "degrees",
		doc: "Maximum angle change between adjacent characters.",
		requires: [
			"text-field",
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-writing-mode": {
		type: "array",
		value: "enum",
		values: {
			horizontal: {
				doc: "If a text's language supports horizontal writing mode, symbols would be laid out horizontally."
			},
			vertical: {
				doc: "If a text's language supports vertical writing mode, symbols would be laid out vertically."
			}
		},
		doc: "The property allows control over a symbol's orientation. Note that the property values act as a hint, so that a symbol whose language doesn’t support the provided orientation will be laid out in its natural orientation. Example: English point symbol will be rendered horizontally even if array value contains single 'vertical' enum value. For symbol with point placement, the order of elements in an array define priority order for the placement of an orientation variant. For symbol with line placement, the default text writing mode is either ['horizontal', 'vertical'] or ['vertical', 'horizontal'], the order doesn't affect the placement.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "1.3.0",
				android: "8.3.0",
				ios: "5.3.0",
				macos: "0.15.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		units: "degrees",
		doc: "Rotates the text clockwise.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.35.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-padding": {
		type: "number",
		"default": 2,
		minimum: 0,
		units: "pixels",
		doc: "Size of the additional area around the text bounding box used for detecting symbol collisions.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-keep-upright": {
		type: "boolean",
		"default": true,
		doc: "If true, the text may be flipped vertically to prevent it from being rendered upside-down.",
		requires: [
			"text-field",
			{
				"text-rotation-alignment": "map"
			},
			{
				"symbol-placement": [
					"line",
					"line-center"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-transform": {
		type: "enum",
		values: {
			none: {
				doc: "The text is not altered."
			},
			uppercase: {
				doc: "Forces all letters to be displayed in uppercase."
			},
			lowercase: {
				doc: "Forces all letters to be displayed in lowercase."
			}
		},
		"default": "none",
		doc: "Specifies how to capitalize text, similar to the CSS `text-transform` property.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-offset": {
		type: "array",
		doc: "Offset distance of text from its anchor. Positive values indicate right and down, while negative values indicate left and up. If used with text-variable-anchor, input values will be taken as absolute values. Offsets along the x- and y-axis will be applied automatically based on the anchor position.",
		value: "number",
		units: "ems",
		length: 2,
		"default": [
			0,
			0
		],
		requires: [
			"text-field",
			{
				"!": "text-radial-offset"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.35.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"text-allow-overlap": {
		type: "boolean",
		"default": false,
		doc: "If true, the text will be visible even if it collides with other previously drawn symbols.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-ignore-placement": {
		type: "boolean",
		"default": false,
		doc: "If true, other symbols can be visible even if they collide with the text.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-optional": {
		type: "boolean",
		"default": false,
		doc: "If true, icons will display without their corresponding text when the text collides with other symbols and the icon does not.",
		requires: [
			"text-field",
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_raster = {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		"property-type": "constant"
	}
};
var layout_hillshade = {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		"property-type": "constant"
	}
};
var filter = {
	type: "array",
	value: "*",
	doc: "A filter selects specific features from a layer."
};
var filter_symbol = {
	type: "boolean",
	doc: "Expression which determines whether or not to display a symbol. Symbols support dynamic filtering, meaning this expression can use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature",
			"pitch",
			"distance-from-center"
		]
	}
};
var filter_fill = {
	type: "boolean",
	doc: "Expression which determines whether or not to display a polygon. Fill layer does NOT support dynamic filtering, meaning this expression can NOT use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature"
		]
	}
};
var filter_line = {
	type: "boolean",
	doc: "Expression which determines whether or not to display a Polygon or LineString. Line layer does NOT support dynamic filtering, meaning this expression can NOT use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature"
		]
	}
};
var filter_circle = {
	type: "boolean",
	doc: "Expression which determines whether or not to display a circle. Circle layer does NOT support dynamic filtering, meaning this expression can NOT use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature"
		]
	}
};
var filter_heatmap = {
	type: "boolean",
	doc: "Expression used to determine whether a point is being displayed or not. Heatmap layer does NOT support dynamic filtering, meaning this expression can NOT use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature"
		]
	}
};
var filter_operator = {
	type: "enum",
	values: {
		"==": {
			doc: "`[\"==\", key, value]` equality: `feature[key] = value`"
		},
		"!=": {
			doc: "`[\"!=\", key, value]` inequality: `feature[key] ≠ value`"
		},
		">": {
			doc: "`[\">\", key, value]` greater than: `feature[key] > value`"
		},
		">=": {
			doc: "`[\">=\", key, value]` greater than or equal: `feature[key] ≥ value`"
		},
		"<": {
			doc: "`[\"<\", key, value]` less than: `feature[key] < value`"
		},
		"<=": {
			doc: "`[\"<=\", key, value]` less than or equal: `feature[key] ≤ value`"
		},
		"in": {
			doc: "`[\"in\", key, v0, ..., vn]` set inclusion: `feature[key] ∈ {v0, ..., vn}`"
		},
		"!in": {
			doc: "`[\"!in\", key, v0, ..., vn]` set exclusion: `feature[key] ∉ {v0, ..., vn}`"
		},
		all: {
			doc: "`[\"all\", f0, ..., fn]` logical `AND`: `f0 ∧ ... ∧ fn`"
		},
		any: {
			doc: "`[\"any\", f0, ..., fn]` logical `OR`: `f0 ∨ ... ∨ fn`"
		},
		none: {
			doc: "`[\"none\", f0, ..., fn]` logical `NOR`: `¬f0 ∧ ... ∧ ¬fn`"
		},
		has: {
			doc: "`[\"has\", key]` `feature[key]` exists"
		},
		"!has": {
			doc: "`[\"!has\", key]` `feature[key]` does not exist"
		},
		within: {
			doc: "`[\"within\", object]` feature geometry is within object geometry"
		}
	},
	doc: "The filter operator."
};
var geometry_type = {
	type: "enum",
	values: {
		Point: {
			doc: "Filter to point geometries."
		},
		LineString: {
			doc: "Filter to line geometries."
		},
		Polygon: {
			doc: "Filter to polygon geometries."
		}
	},
	doc: "The geometry type for the filter to select."
};
var function_stop = {
	type: "array",
	minimum: 0,
	maximum: 24,
	value: [
		"number",
		"color"
	],
	length: 2,
	doc: "Zoom level and value pair."
};
var expression$1 = {
	type: "array",
	value: "*",
	minimum: 1,
	doc: "An expression defines a function that can be used for data-driven style properties or feature filters."
};
var expression_name = {
	doc: "",
	type: "enum",
	values: {
		"let": {
			doc: "Binds expressions to named variables, which can then be referenced in the result expression using [\"var\", \"variable_name\"].",
			group: "Variable binding",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"var": {
			doc: "References variable bound using \"let\".",
			group: "Variable binding",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		literal: {
			doc: "Provides a literal array or object value.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		array: {
			doc: "Asserts that the input is an array (optionally with a specific item type and length).  If, when the input expression is evaluated, it is not of the asserted type, then this assertion will cause the whole expression to be aborted.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		at: {
			doc: "Retrieves an item from an array.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"in": {
			doc: "Determines whether an item exists in an array or a substring exists in a string. In the specific case when the second and third arguments are string literals, you must wrap at least one of them in a [`literal`](#types-literal) expression to hint correct interpretation to the [type system](#type-system).",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "1.6.0",
					android: "9.1.0",
					ios: "5.8.0",
					macos: "0.15.0"
				}
			}
		},
		"index-of": {
			doc: "Returns the first position at which an item can be found in an array or a substring can be found in a string, or `-1` if the input cannot be found. Accepts an optional index from where to begin the search.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "1.10.0",
					android: "10.0.0",
					ios: "10.0.0"
				}
			}
		},
		slice: {
			doc: "Returns an item from an array or a substring from a string from a specified start index, or between a start index and an end index if set. The return value is inclusive of the start index but not of the end index.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "1.10.0",
					android: "10.0.0",
					ios: "10.0.0"
				}
			}
		},
		"case": {
			doc: "Selects the first output whose corresponding test condition evaluates to true, or the fallback value otherwise.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		match: {
			doc: "Selects the output for which the label value matches the input value, or the fallback value if no match is found. The input can be any expression (for example, `[\"get\", \"building_type\"]`). Each label must be unique, and must be either:\n - a single literal value; or\n - an array of literal values, the values of which must be all strings or all numbers (for example `[100, 101]` or `[\"c\", \"b\"]`).\n\nThe input matches if any of the values in the array matches using strict equality, similar to the `\"in\"` operator.\nIf the input type does not match the type of the labels, the result will be the fallback value.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		coalesce: {
			doc: "Evaluates each expression in turn until the first valid value is obtained. Invalid values are `null` and [`'image'`](#types-image) expressions that are unavailable in the style. If all values are invalid, `coalesce` returns the first value listed.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		step: {
			doc: "Produces discrete, stepped results by evaluating a piecewise-constant function defined by pairs of input and output values (\"stops\"). The `input` may be any numeric expression (e.g., `[\"get\", \"population\"]`). Stop inputs must be numeric literals in strictly ascending order. Returns the output value of the stop just less than the input, or the first output if the input is less than the first stop.",
			group: "Ramps, scales, curves",
			"sdk-support": {
				"basic functionality": {
					js: "0.42.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		interpolate: {
			doc: "Produces continuous, smooth results by interpolating between pairs of input and output values (\"stops\"). The `input` may be any numeric expression (e.g., `[\"get\", \"population\"]`). Stop inputs must be numeric literals in strictly ascending order. The output type must be `number`, `array<number>`, or `color`.\n\nInterpolation types:\n- `[\"linear\"]`: Interpolates linearly between the pair of stops just less than and just greater than the input.\n- `[\"exponential\", base]`: Interpolates exponentially between the stops just less than and just greater than the input. `base` controls the rate at which the output increases: higher values make the output increase more towards the high end of the range. With values close to 1 the output increases linearly.\n- `[\"cubic-bezier\", x1, y1, x2, y2]`: Interpolates using the cubic bezier curve defined by the given control points.",
			group: "Ramps, scales, curves",
			"sdk-support": {
				"basic functionality": {
					js: "0.42.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"interpolate-hcl": {
			doc: "Produces continuous, smooth results by interpolating between pairs of input and output values (\"stops\"). Works like `interpolate`, but the output type must be `color`, and the interpolation is performed in the Hue-Chroma-Luminance color space.",
			group: "Ramps, scales, curves",
			"sdk-support": {
				"basic functionality": {
					js: "0.49.0"
				}
			}
		},
		"interpolate-lab": {
			doc: "Produces continuous, smooth results by interpolating between pairs of input and output values (\"stops\"). Works like `interpolate`, but the output type must be `color`, and the interpolation is performed in the CIELAB color space.",
			group: "Ramps, scales, curves",
			"sdk-support": {
				"basic functionality": {
					js: "0.49.0"
				}
			}
		},
		ln2: {
			doc: "Returns mathematical constant ln(2).",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		pi: {
			doc: "Returns the mathematical constant pi.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		e: {
			doc: "Returns the mathematical constant e.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"typeof": {
			doc: "Returns a string describing the type of the given value.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		string: {
			doc: "Asserts that the input value is a string. If multiple values are provided, each one is evaluated in order until a string is obtained. If none of the inputs are strings, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		number: {
			doc: "Asserts that the input value is a number. If multiple values are provided, each one is evaluated in order until a number is obtained. If none of the inputs are numbers, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		boolean: {
			doc: "Asserts that the input value is a boolean. If multiple values are provided, each one is evaluated in order until a boolean is obtained. If none of the inputs are booleans, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		object: {
			doc: "Asserts that the input value is an object. If multiple values are provided, each one is evaluated in order until an object is obtained. If none of the inputs are objects, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		collator: {
			doc: "Returns a `collator` for use in locale-dependent comparison operations. The `case-sensitive` and `diacritic-sensitive` options default to `false`. The `locale` argument specifies the IETF language tag of the locale to use. If none is provided, the default locale is used. If the requested locale is not available, the `collator` will use a system-defined fallback locale. Use `resolved-locale` to test the results of locale fallback behavior.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		format: {
			doc: "Returns a `formatted` string for displaying mixed-format text in the `text-field` property. The input may contain a string literal or expression, including an [`'image'`](#types-image) expression. Strings may be followed by a style override object that supports the following properties:\n- `\"text-font\"`: Overrides the font stack specified by the root layout property.\n- `\"text-color\"`: Overrides the color specified by the root paint property.\n- `\"font-scale\"`: Applies a scaling factor on `text-size` as specified by the root layout property.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.48.0",
					android: "6.7.0",
					ios: "4.6.0",
					macos: "0.12.0"
				},
				"text-font": {
					js: "0.48.0",
					android: "6.7.0",
					ios: "4.6.0",
					macos: "0.12.0"
				},
				"font-scale": {
					js: "0.48.0",
					android: "6.7.0",
					ios: "4.6.0",
					macos: "0.12.0"
				},
				"text-color": {
					js: "1.3.0",
					android: "7.3.0",
					ios: "4.10.0",
					macos: "0.14.0"
				},
				image: {
					js: "1.6.0",
					android: "8.6.0",
					ios: "5.7.0",
					macos: "0.15.0"
				}
			}
		},
		image: {
			doc: "Returns a [`ResolvedImage`](/mapbox-gl-js/style-spec/types/#resolvedimage) for use in [`icon-image`](/mapbox-gl-js/style-spec/layers/#layout-symbol-icon-image), `*-pattern` entries, and as a section in the [`'format'`](#types-format) expression. A [`'coalesce'`](#coalesce) expression containing `image` expressions will evaluate to the first listed image that is currently in the style. This validation process is synchronous and requires the image to have been added to the style before requesting it in the `'image'` argument.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "1.4.0",
					android: "8.6.0",
					ios: "5.7.0",
					macos: "0.15.0"
				}
			}
		},
		"number-format": {
			doc: "Converts the input number into a string representation using the providing formatting rules. If set, the `locale` argument specifies the locale to use, as a BCP 47 language tag. If set, the `currency` argument specifies an ISO 4217 code to use for currency-style formatting. If set, the `unit` argument specifies a [simple ECMAScript unit](https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-issanctionedsimpleunitidentifier) to use for unit-style formatting. If set, the `min-fraction-digits` and `max-fraction-digits` arguments specify the minimum and maximum number of fractional digits to include.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.54.0",
					android: "8.4.0",
					ios: "5.4.0",
					macos: "0.15.0"
				}
			}
		},
		"to-string": {
			doc: "Converts the input value to a string. If the input is `null`, the result is `\"\"`. If the input is a [`boolean`](#types-boolean), the result is `\"true\"` or `\"false\"`. If the input is a number, it is converted to a string as specified by the [\"NumberToString\" algorithm](https://tc39.github.io/ecma262/#sec-tostring-applied-to-the-number-type) of the ECMAScript Language Specification. If the input is a [`color`](#color), it is converted to a string of the form `\"rgba(r,g,b,a)\"`, where `r`, `g`, and `b` are numerals ranging from 0 to 255, and `a` ranges from 0 to 1. If the input is an [`'image'`](#types-image) expression, `'to-string'` returns the image name. Otherwise, the input is converted to a string in the format specified by the [`JSON.stringify`](https://tc39.github.io/ecma262/#sec-json.stringify) function of the ECMAScript Language Specification.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"to-number": {
			doc: "Converts the input value to a number, if possible. If the input is `null` or `false`, the result is 0. If the input is `true`, the result is 1. If the input is a string, it is converted to a number as specified by the [\"ToNumber Applied to the String Type\" algorithm](https://tc39.github.io/ecma262/#sec-tonumber-applied-to-the-string-type) of the ECMAScript Language Specification. If multiple values are provided, each one is evaluated in order until the first successful conversion is obtained. If none of the inputs can be converted, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"to-boolean": {
			doc: "Converts the input value to a boolean. The result is `false` when then input is an empty string, 0, `false`, `null`, or `NaN`; otherwise it is `true`.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"to-rgba": {
			doc: "Returns a four-element array containing the input color's red, green, blue, and alpha components, in that order.",
			group: "Color",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"to-color": {
			doc: "Converts the input value to a color. If multiple values are provided, each one is evaluated in order until the first successful conversion is obtained. If none of the inputs can be converted, the expression is an error.",
			group: "Types",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		rgb: {
			doc: "Creates a color value from red, green, and blue components, which must range between 0 and 255, and an alpha component of 1. If any component is out of range, the expression is an error.",
			group: "Color",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		rgba: {
			doc: "Creates a color value from red, green, blue components, which must range between 0 and 255, and an alpha component which must range between 0 and 1. If any component is out of range, the expression is an error.",
			group: "Color",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		get: {
			doc: "Retrieves a property value from the current feature's properties, or from another object if a second argument is provided. Returns `null` if the requested property is missing.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		has: {
			doc: "Tests for the presence of an property value in the current feature's properties, or from another object if a second argument is provided.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		length: {
			doc: "Returns the length of an array or string.",
			group: "Lookup",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		properties: {
			doc: "Returns the feature properties object.  Note that in some cases, it may be more efficient to use `[\"get\", \"property_name\"]` directly.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"feature-state": {
			doc: "Retrieves a property value from the current feature's state. Returns `null` if the requested property is not present on the feature's state. A feature's state is not part of the GeoJSON or vector tile data, and must be set programmatically on each feature. Features are identified by their `id` attribute, which must be an integer or a string that can be cast to an integer. Note that [\"feature-state\"] can only be used with paint properties that support data-driven styling.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.46.0",
					android: "10.0.0",
					ios: "10.0.0"
				}
			}
		},
		"geometry-type": {
			doc: "Returns the feature's geometry type: `Point`, `LineString` or `Polygon`. `Multi*` feature types return the singular forms.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		id: {
			doc: "Returns the feature's id, if it has one.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		zoom: {
			doc: "Returns the current zoom level.  Note that in style layout and paint properties, [\"zoom\"] may only appear as the input to a top-level \"step\" or \"interpolate\" expression.",
			group: "Camera",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		pitch: {
			doc: "Returns the current pitch in degrees. `[\"pitch\"]` may only be used in the `filter` expression for a `symbol` layer.",
			group: "Camera",
			"sdk-support": {
				"basic functionality": {
					js: "2.6.0",
					android: "10.9.0",
					ios: "10.9.0"
				}
			}
		},
		"distance-from-center": {
			doc: "Returns the distance of a `symbol` instance from the center of the map. The distance is measured in pixels divided by the height of the map container. It measures 0 at the center, decreases towards the camera and increase away from the camera. For example, if the height of the map is 1000px, a value of -1 means 1000px away from the center towards the camera, and a value of 1 means a distance of 1000px away from the camera from the center. `[\"distance-from-center\"]` may only be used in the `filter` expression for a `symbol` layer.",
			group: "Camera",
			"sdk-support": {
				"basic functionality": {
					js: "2.6.0",
					android: "10.9.0",
					ios: "10.9.0"
				}
			}
		},
		"heatmap-density": {
			doc: "Returns the kernel density estimation of a pixel in a heatmap layer, which is a relative measure of how many data points are crowded around a particular pixel. Can only be used in the `heatmap-color` property.",
			group: "Heatmap",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"line-progress": {
			doc: "Returns the progress along a gradient line. Can only be used in the `line-gradient` property.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.6.0",
					macos: "0.12.0"
				}
			}
		},
		"sky-radial-progress": {
			doc: "Returns the distance of a point on the sky from the sun position. Returns 0 at sun position and 1 when the distance reaches `sky-gradient-radius`. Can only be used in the `sky-gradient` property.",
			group: "sky",
			"sdk-support": {
				"basic functionality": {
					js: "2.0.0",
					ios: "10.0.0",
					android: "10.0.0"
				}
			}
		},
		accumulated: {
			doc: "Returns the value of a cluster property accumulated so far. Can only be used in the `clusterProperties` option of a clustered GeoJSON source.",
			group: "Feature data",
			"sdk-support": {
				"basic functionality": {
					js: "0.53.0",
					android: "8.4.0",
					ios: "5.5.0",
					macos: "0.15.0"
				}
			}
		},
		"+": {
			doc: "Returns the sum of the inputs.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"*": {
			doc: "Returns the product of the inputs.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"-": {
			doc: "For two inputs, returns the result of subtracting the second input from the first. For a single input, returns the result of subtracting it from 0.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"/": {
			doc: "Returns the result of floating point division of the first input by the second.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"%": {
			doc: "Returns the remainder after integer division of the first input by the second.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"^": {
			doc: "Returns the result of raising the first input to the power specified by the second.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		sqrt: {
			doc: "Returns the square root of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.42.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		log10: {
			doc: "Returns the base-ten logarithm of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		ln: {
			doc: "Returns the natural logarithm of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		log2: {
			doc: "Returns the base-two logarithm of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		sin: {
			doc: "Returns the sine of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		cos: {
			doc: "Returns the cosine of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		tan: {
			doc: "Returns the tangent of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		asin: {
			doc: "Returns the arcsine of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		acos: {
			doc: "Returns the arccosine of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		atan: {
			doc: "Returns the arctangent of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		min: {
			doc: "Returns the minimum value of the inputs.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		max: {
			doc: "Returns the maximum value of the inputs.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		round: {
			doc: "Rounds the input to the nearest integer. Halfway values are rounded away from zero. For example, `[\"round\", -1.5]` evaluates to -2.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		abs: {
			doc: "Returns the absolute value of the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		ceil: {
			doc: "Returns the smallest integer that is greater than or equal to the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		floor: {
			doc: "Returns the largest integer that is less than or equal to the input.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		distance: {
			doc: "Returns the shortest distance in meters between the evaluated feature and the input geometry. The input value can be a valid GeoJSON of type `Point`, `MultiPoint`, `LineString`, `MultiLineString`, `Polygon`, `MultiPolygon`, `Feature`, or `FeatureCollection`. Distance values returned may vary in precision due to loss in precision from encoding geometries, particularly below zoom level 13.",
			group: "Math",
			"sdk-support": {
				"basic functionality": {
					android: "9.2.0",
					ios: "5.9.0",
					macos: "0.16.0"
				}
			}
		},
		"==": {
			doc: "Returns `true` if the input values are equal, `false` otherwise. The comparison is strictly typed: values of different runtime types are always considered unequal. Cases where the types are known to be different at parse time are considered invalid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		"!=": {
			doc: "Returns `true` if the input values are not equal, `false` otherwise. The comparison is strictly typed: values of different runtime types are always considered unequal. Cases where the types are known to be different at parse time are considered invalid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		">": {
			doc: "Returns `true` if the first input is strictly greater than the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		"<": {
			doc: "Returns `true` if the first input is strictly less than the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		">=": {
			doc: "Returns `true` if the first input is greater than or equal to the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		"<=": {
			doc: "Returns `true` if the first input is less than or equal to the second, `false` otherwise. The arguments are required to be either both strings or both numbers; if during evaluation they are not, expression evaluation produces an error. Cases where this constraint is known not to hold at parse time are considered in valid and will produce a parse error. Accepts an optional `collator` argument to control locale-dependent string comparisons.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				},
				collator: {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		},
		all: {
			doc: "Returns `true` if all the inputs are `true`, `false` otherwise. The inputs are evaluated in order, and evaluation is short-circuiting: once an input expression evaluates to `false`, the result is `false` and no further input expressions are evaluated.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		any: {
			doc: "Returns `true` if any of the inputs are `true`, `false` otherwise. The inputs are evaluated in order, and evaluation is short-circuiting: once an input expression evaluates to `true`, the result is `true` and no further input expressions are evaluated.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"!": {
			doc: "Logical negation. Returns `true` if the input is `false`, and `false` if the input is `true`.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		within: {
			doc: "Returns `true` if the evaluated feature is fully contained inside a boundary of the input geometry, `false` otherwise. The input value can be a valid GeoJSON of type `Polygon`, `MultiPolygon`, `Feature`, or `FeatureCollection`. Supported features for evaluation:\n- `Point`: Returns `false` if a point is on the boundary or falls outside the boundary.\n- `LineString`: Returns `false` if any part of a line falls outside the boundary, the line intersects the boundary, or a line's endpoint is on the boundary.",
			group: "Decision",
			"sdk-support": {
				"basic functionality": {
					js: "1.9.0",
					android: "9.1.0",
					ios: "5.8.0",
					macos: "0.15.0"
				}
			}
		},
		"is-supported-script": {
			doc: "Returns `true` if the input string is expected to render legibly. Returns `false` if the input string contains sections that cannot be rendered without potential loss of meaning (e.g. Indic scripts that require complex text shaping, or right-to-left scripts if the the `mapbox-gl-rtl-text` plugin is not in use in Mapbox GL JS).",
			group: "String",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.6.0",
					ios: "4.1.0",
					macos: "0.8.0"
				}
			}
		},
		upcase: {
			doc: "Returns the input string converted to uppercase. Follows the Unicode Default Case Conversion algorithm and the locale-insensitive case mappings in the Unicode Character Database.",
			group: "String",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		downcase: {
			doc: "Returns the input string converted to lowercase. Follows the Unicode Default Case Conversion algorithm and the locale-insensitive case mappings in the Unicode Character Database.",
			group: "String",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		concat: {
			doc: "Returns a `string` consisting of the concatenation of the inputs. Each input is converted to a string as if by `to-string`.",
			group: "String",
			"sdk-support": {
				"basic functionality": {
					js: "0.41.0",
					android: "6.0.0",
					ios: "4.0.0",
					macos: "0.7.0"
				}
			}
		},
		"resolved-locale": {
			doc: "Returns the IETF language tag of the locale being used by the provided `collator`. This can be used to determine the default system locale, or to determine if a requested locale was successfully loaded.",
			group: "String",
			"sdk-support": {
				"basic functionality": {
					js: "0.45.0",
					android: "6.5.0",
					ios: "4.2.0",
					macos: "0.9.0"
				}
			}
		}
	}
};
var fog = {
	range: {
		type: "array",
		"default": [
			0.5,
			10
		],
		minimum: -20,
		maximum: 20,
		length: 2,
		value: "number",
		"property-type": "data-constant",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		doc: "The start and end distance range in which fog fades from fully transparent to fully opaque. The distance to the point at the center of the map is defined as zero, so that negative range values are closer to the camera, and positive values are farther away.",
		example: [
			0.5,
			10
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.3.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	},
	color: {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "The color of the atmosphere region immediately below the horizon and within the `range` and above the horizon and within `horizon-blend`. Using opacity is recommended only for smoothly transitioning fog on/off as anything less than 100% opacity results in more tiles loaded and drawn.",
		"sdk-support": {
			"basic functionality": {
				js: "2.3.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	},
	"high-color": {
		type: "color",
		"property-type": "data-constant",
		"default": "#245cdf",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "The color of the atmosphere region above the horizon, `high-color` extends further above the horizon than the `color` property and its spread can be controlled with `horizon-blend`. The opacity can be set to `0` to remove the high atmosphere color contribution.",
		"sdk-support": {
			"basic functionality": {
				js: "2.9.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	},
	"space-color": {
		type: "color",
		"property-type": "data-constant",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"zoom"
			],
			4,
			"#010b19",
			7,
			"#367ab9"
		],
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "The color of the region above the horizon and after the end of the `horizon-blend` contribution. The opacity can be set to `0` to have a transparent background.",
		"sdk-support": {
			"basic functionality": {
				js: "2.9.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	},
	"horizon-blend": {
		type: "number",
		"property-type": "data-constant",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"zoom"
			],
			4,
			0.2,
			7,
			0.1
		],
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Horizon blend applies a smooth fade from the color of the atmosphere to the color of space. A value of zero leaves a sharp transition from atmosphere to space. Increasing the value blends the color of atmosphere into increasingly high angles of the sky.",
		"sdk-support": {
			"basic functionality": {
				js: "2.3.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	},
	"star-intensity": {
		type: "number",
		"property-type": "data-constant",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"zoom"
			],
			5,
			0.35,
			6,
			0
		],
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "A value controlling the star intensity where `0` will show no stars and `1` will show stars at their maximum intensity.",
		"sdk-support": {
			"basic functionality": {
				js: "2.9.0",
				android: "10.6.0",
				ios: "10.6.0"
			}
		}
	}
};
var light = {
	anchor: {
		type: "enum",
		"default": "viewport",
		values: {
			map: {
				doc: "The position of the light source is aligned to the rotation of the map."
			},
			viewport: {
				doc: "The position of the light source is aligned to the rotation of the viewport."
			}
		},
		"property-type": "data-constant",
		transition: false,
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		doc: "Whether extruded geometries are lit relative to the map or viewport.",
		example: "map",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		}
	},
	position: {
		type: "array",
		"default": [
			1.15,
			210,
			30
		],
		length: 3,
		value: "number",
		"property-type": "data-constant",
		transition: true,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		doc: "Position of the light source relative to lit (extruded) geometries, in [r radial coordinate, a azimuthal angle, p polar angle] where r indicates the distance from the center of the base of an object to its light, a indicates the position of the light relative to 0° (0° when `light.anchor` is set to `viewport` corresponds to the top of the viewport, or 0° when `light.anchor` is set to `map` corresponds to due north, and degrees proceed clockwise), and p indicates the height of the light (from 0°, directly above, to 180°, directly below).",
		example: [
			1.5,
			90,
			80
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		}
	},
	color: {
		type: "color",
		"property-type": "data-constant",
		"default": "#ffffff",
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Color tint for lighting extruded geometries.",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		}
	},
	intensity: {
		type: "number",
		"property-type": "data-constant",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Intensity of lighting (on a scale from 0 to 1). Higher numbers will present as more extreme contrast.",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		}
	}
};
var projection = {
	name: {
		type: "enum",
		values: {
			albers: {
				doc: "An Albers equal-area projection centered on the continental United States. You can configure the projection for a different region by setting `center` and `parallels` properties. You may want to set max bounds to constrain the map to the relevant region."
			},
			equalEarth: {
				doc: "An Equal Earth projection."
			},
			equirectangular: {
				doc: "An Equirectangular projection. This projection is very similar to the Plate Carrée projection."
			},
			lambertConformalConic: {
				doc: "A Lambert conformal conic projection. You can configure the projection for a region by setting `center` and `parallels` properties. You may want to set max bounds to constrain the map to the relevant region."
			},
			mercator: {
				doc: "The Mercator projection is the default projection."
			},
			naturalEarth: {
				doc: "A Natural Earth projection."
			},
			winkelTripel: {
				doc: "A Winkel Tripel projection."
			},
			globe: {
				doc: "A globe projection."
			}
		},
		"default": "mercator",
		doc: "The name of the projection to be used for rendering the map.",
		required: true,
		"sdk-support": {
			"basic functionality": {
				js: "2.6.0"
			}
		}
	},
	center: {
		type: "array",
		length: 2,
		value: "number",
		"property-type": "data-constant",
		minimum: [
			-180,
			-90
		],
		maximum: [
			180,
			90
		],
		transition: false,
		doc: "The reference longitude and latitude of the projection. `center` takes the form of [lng, lat]. This property is only configurable for conic projections (Albers and Lambert Conformal Conic). All other projections are centered on [0, 0].",
		example: [
			-96,
			37.5
		],
		requires: [
			{
				name: [
					"albers",
					"lambertConformalConic"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.6.0"
			}
		}
	},
	parallels: {
		type: "array",
		length: 2,
		value: "number",
		"property-type": "data-constant",
		minimum: [
			-90,
			-90
		],
		maximum: [
			90,
			90
		],
		transition: false,
		doc: "The standard parallels of the projection, denoting the desired latitude range with minimal distortion. `parallels` takes the form of [lat0, lat1]. This property is only configurable for conic projections (Albers and Lambert Conformal Conic).",
		example: [
			29.5,
			45.5
		],
		requires: [
			{
				name: [
					"albers",
					"lambertConformalConic"
				]
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.6.0"
			}
		}
	}
};
var terrain = {
	source: {
		type: "string",
		doc: "Name of a source of `raster_dem` type to be used for terrain elevation.",
		required: true,
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		}
	},
	exaggeration: {
		type: "number",
		"property-type": "data-constant",
		"default": 1,
		minimum: 0,
		maximum: 1000,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Exaggerates the elevation of the terrain by multiplying the data from the DEM with this value.",
		requires: [
			"source"
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		}
	}
};
var paint = [
	"paint_fill",
	"paint_line",
	"paint_circle",
	"paint_heatmap",
	"paint_fill-extrusion",
	"paint_symbol",
	"paint_raster",
	"paint_hillshade",
	"paint_background",
	"paint_sky"
];
var paint_fill = {
	"fill-antialias": {
		type: "boolean",
		"default": true,
		doc: "Whether or not the fill should be antialiased.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		doc: "The opacity of the entire fill layer. In contrast to the `fill-color`, this value will also affect the 1px stroke around the fill, if the stroke is used.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.21.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-color": {
		type: "color",
		"default": "#000000",
		doc: "The color of the filled part of this layer. This color can be specified as `rgba` with an alpha component and the color's opacity will not affect the opacity of the 1px stroke, if it is used.",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.19.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-outline-color": {
		type: "color",
		doc: "The outline color of the fill. Matches the value of `fill-color` if unspecified.",
		transition: true,
		requires: [
			{
				"!": "fill-pattern"
			},
			{
				"fill-antialias": true
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.19.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The fill is translated relative to the map."
			},
			viewport: {
				doc: "The fill is translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `fill-translate`.",
		"default": "map",
		requires: [
			"fill-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-pattern": {
		type: "resolvedImage",
		transition: false,
		doc: "Name of image in sprite to use for drawing image fills. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.49.0",
				android: "6.5.0",
				macos: "0.11.0",
				ios: "4.4.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	}
};
var paint_line = {
	"line-opacity": {
		type: "number",
		doc: "The opacity at which the line will be drawn.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-color": {
		type: "color",
		doc: "The color with which the line will be drawn.",
		"default": "#000000",
		transition: true,
		requires: [
			{
				"!": "line-pattern"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.23.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The line is translated relative to the map."
			},
			viewport: {
				doc: "The line is translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `line-translate`.",
		"default": "map",
		requires: [
			"line-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"line-width": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Stroke thickness.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.39.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-gap-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		doc: "Draws a line casing outside of a line's actual path. Value indicates the width of the inner gap.",
		transition: true,
		units: "pixels",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-offset": {
		type: "number",
		"default": 0,
		doc: "The line's offset. For linear features, a positive value offsets the line to the right, relative to the direction of the line, and a negative value to the left. For polygon features, a positive value results in an inset, and a negative value results in an outset.",
		transition: true,
		units: "pixels",
		"sdk-support": {
			"basic functionality": {
				js: "0.12.1",
				android: "3.0.0",
				ios: "3.1.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Blur applied to the line, in pixels.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"line-dasharray": {
		type: "array",
		value: "number",
		doc: "Specifies the lengths of the alternating dashes and gaps that form the dash pattern. The lengths are later scaled by the line width. To convert a dash length to pixels, multiply the length by the current line width. Note that GeoJSON sources with `lineMetrics: true` specified won't render dashed lines to the expected scale. Also note that zoom-dependent expressions will be evaluated only at integer zoom levels.",
		minimum: 0,
		transition: false,
		units: "line widths",
		requires: [
			{
				"!": "line-pattern"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "2.3.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-pattern": {
		type: "resolvedImage",
		transition: false,
		doc: "Name of image in sprite to use for drawing image lines. For seamless patterns, image width must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.49.0",
				android: "6.5.0",
				macos: "0.11.0",
				ios: "4.4.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"line-gradient": {
		type: "color",
		doc: "Defines a gradient with which to color a line feature. Can only be used with GeoJSON sources that specify `\"lineMetrics\": true`.",
		transition: false,
		requires: [
			{
				"!": "line-pattern"
			},
			{
				source: "geojson",
				has: {
					lineMetrics: true
				}
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.45.0",
				android: "6.5.0",
				ios: "4.4.0",
				macos: "0.11.0"
			},
			"data-driven styling": {
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"line-progress"
			]
		},
		"property-type": "color-ramp"
	},
	"line-trim-offset": {
		type: "array",
		value: "number",
		doc: "The line part between [trim-start, trim-end] will be marked as transparent to make a route vanishing effect. The line trim-off offset is based on the whole line range [0.0, 1.0].",
		length: 2,
		"default": [
			0,
			0
		],
		minimum: [
			0,
			0
		],
		maximum: [
			1,
			1
		],
		transition: false,
		requires: [
			{
				source: "geojson",
				has: {
					lineMetrics: true
				}
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.9.0",
				android: "10.5.0",
				ios: "10.5.0",
				macos: "10.5.0"
			}
		},
		"property-type": "constant"
	}
};
var paint_circle = {
	"circle-radius": {
		type: "number",
		"default": 5,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Circle radius.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.18.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-color": {
		type: "color",
		"default": "#000000",
		doc: "The fill color of the circle.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.18.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-blur": {
		type: "number",
		"default": 0,
		doc: "Amount to blur the circle. 1 blurs the circle such that only the centerpoint is full opacity.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.20.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-opacity": {
		type: "number",
		doc: "The opacity at which the circle will be drawn.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.20.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "The geometry's offset. Values are [x, y] where negatives indicate left and up, respectively.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The circle is translated relative to the map."
			},
			viewport: {
				doc: "The circle is translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `circle-translate`.",
		"default": "map",
		requires: [
			"circle-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-scale": {
		type: "enum",
		values: {
			map: {
				doc: "Circles are scaled according to their apparent distance to the camera."
			},
			viewport: {
				doc: "Circles are not scaled."
			}
		},
		"default": "map",
		doc: "Controls the scaling behavior of the circle when the map is pitched.",
		"sdk-support": {
			"basic functionality": {
				js: "0.21.0",
				android: "4.2.0",
				ios: "3.4.0",
				macos: "0.2.1"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-pitch-alignment": {
		type: "enum",
		values: {
			map: {
				doc: "The circle is aligned to the plane of the map."
			},
			viewport: {
				doc: "The circle is aligned to the plane of the viewport."
			}
		},
		"default": "viewport",
		doc: "Orientation of circle when map is pitched.",
		"sdk-support": {
			"basic functionality": {
				js: "0.39.0",
				android: "5.2.0",
				ios: "3.7.0",
				macos: "0.6.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"circle-stroke-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "The width of the circle's stroke. Strokes are placed outside of the `circle-radius`.",
		"sdk-support": {
			"basic functionality": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-color": {
		type: "color",
		"default": "#000000",
		doc: "The stroke color of the circle.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"circle-stroke-opacity": {
		type: "number",
		doc: "The opacity of the circle's stroke.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			},
			"data-driven styling": {
				js: "0.29.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	}
};
var paint_heatmap = {
	"heatmap-radius": {
		type: "number",
		"default": 30,
		minimum: 1,
		transition: true,
		units: "pixels",
		doc: "Radius of influence of one heatmap point in pixels. Increasing the value makes the heatmap smoother, but less detailed. `queryRenderedFeatures` on heatmap layers will return points within this radius.",
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			},
			"data-driven styling": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-weight": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: false,
		doc: "A measure of how much an individual point contributes to the heatmap. A value of 10 would be equivalent to having 10 points of weight 1 in the same spot. Especially useful when combined with clustering.",
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			},
			"data-driven styling": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"heatmap-intensity": {
		type: "number",
		"default": 1,
		minimum: 0,
		transition: true,
		doc: "Similar to `heatmap-weight` but controls the intensity of the heatmap globally. Primarily used for adjusting the heatmap based on zoom level.",
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"heatmap-color": {
		type: "color",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"heatmap-density"
			],
			0,
			"rgba(0, 0, 255, 0)",
			0.1,
			"royalblue",
			0.3,
			"cyan",
			0.5,
			"lime",
			0.7,
			"yellow",
			1,
			"red"
		],
		doc: "Defines the color of each pixel based on its density value in a heatmap.  Should be an expression that uses `[\"heatmap-density\"]` as input.",
		transition: false,
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			},
			"data-driven styling": {
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"heatmap-density"
			]
		},
		"property-type": "color-ramp"
	},
	"heatmap-opacity": {
		type: "number",
		doc: "The global opacity at which the heatmap layer will be drawn.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.41.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_symbol = {
	"icon-opacity": {
		doc: "The opacity at which the icon will be drawn.",
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-color": {
		type: "color",
		"default": "#000000",
		transition: true,
		doc: "The color of the icon. This can only be used with [SDF icons](/help/troubleshooting/using-recolorable-images-in-mapbox-maps/).",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		doc: "The color of the icon's halo. Icon halos can only be used with [SDF icons](/help/troubleshooting/using-recolorable-images-in-mapbox-maps/).",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Distance of halo to the icon outline.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Fade out the halo towards the outside.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"icon-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "Distance that the icon's anchor is moved from its original placement. Positive values indicate right and down, while negative values indicate left and up.",
		requires: [
			"icon-image"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"icon-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "Icons are translated relative to the map."
			},
			viewport: {
				doc: "Icons are translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `icon-translate`.",
		"default": "map",
		requires: [
			"icon-image",
			"icon-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-opacity": {
		type: "number",
		doc: "The opacity at which the text will be drawn.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-color": {
		type: "color",
		doc: "The color with which the text will be drawn.",
		"default": "#000000",
		transition: true,
		overridable: true,
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-color": {
		type: "color",
		"default": "rgba(0, 0, 0, 0)",
		transition: true,
		doc: "The color of the text's halo, which helps it stand out from backgrounds.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-width": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "Distance of halo to the font outline. Max text halo width is 1/4 of the font-size.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-halo-blur": {
		type: "number",
		"default": 0,
		minimum: 0,
		transition: true,
		units: "pixels",
		doc: "The halo's fadeout distance towards the outside.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			},
			"data-driven styling": {
				js: "0.33.0",
				android: "5.0.0",
				ios: "3.5.0",
				macos: "0.4.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"text-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "Distance that the text's anchor is moved from its original placement. Positive values indicate right and down, while negative values indicate left and up.",
		requires: [
			"text-field"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"text-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The text is translated relative to the map."
			},
			viewport: {
				doc: "The text is translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `text-translate`.",
		"default": "map",
		requires: [
			"text-field",
			"text-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_raster = {
	"raster-opacity": {
		type: "number",
		doc: "The opacity at which the image will be drawn.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-hue-rotate": {
		type: "number",
		"default": 0,
		period: 360,
		transition: true,
		units: "degrees",
		doc: "Rotates hues around the color wheel.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-min": {
		type: "number",
		doc: "Increase or reduce the brightness of the image. The value is the minimum brightness.",
		"default": 0,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-brightness-max": {
		type: "number",
		doc: "Increase or reduce the brightness of the image. The value is the maximum brightness.",
		"default": 1,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-saturation": {
		type: "number",
		doc: "Increase or reduce the saturation of the image.",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-contrast": {
		type: "number",
		doc: "Increase or reduce the contrast of the image.",
		"default": 0,
		minimum: -1,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-resampling": {
		type: "enum",
		doc: "The resampling/interpolation method to use for overscaling, also known as texture magnification filter",
		values: {
			linear: {
				doc: "(Bi)linear filtering interpolates pixel values using the weighted average of the four closest original source pixels creating a smooth but blurry look when overscaled"
			},
			nearest: {
				doc: "Nearest neighbor filtering interpolates pixel values using the nearest original source pixel creating a sharp but pixelated look when overscaled"
			}
		},
		"default": "linear",
		"sdk-support": {
			"basic functionality": {
				js: "0.47.0",
				android: "6.3.0",
				ios: "4.2.0",
				macos: "0.9.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"raster-fade-duration": {
		type: "number",
		"default": 300,
		minimum: 0,
		transition: false,
		units: "milliseconds",
		doc: "Fade duration when a new tile is added.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_hillshade = {
	"hillshade-illumination-direction": {
		type: "number",
		"default": 335,
		minimum: 0,
		maximum: 359,
		doc: "The direction of the light source used to generate the hillshading with 0 as the top of the viewport if `hillshade-illumination-anchor` is set to `viewport` and due north if `hillshade-illumination-anchor` is set to `map`.",
		transition: false,
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-illumination-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The hillshade illumination is relative to the north direction."
			},
			viewport: {
				doc: "The hillshade illumination is relative to the top of the viewport."
			}
		},
		"default": "viewport",
		doc: "Direction of light source when map is rotated.",
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-exaggeration": {
		type: "number",
		doc: "Intensity of the hillshade",
		"default": 0.5,
		minimum: 0,
		maximum: 1,
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-shadow-color": {
		type: "color",
		"default": "#000000",
		doc: "The shading color of areas that face away from the light source.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-highlight-color": {
		type: "color",
		"default": "#FFFFFF",
		doc: "The shading color of areas that faces towards the light source.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"hillshade-accent-color": {
		type: "color",
		"default": "#000000",
		doc: "The shading color used to accentuate rugged terrain like sharp cliffs and gorges.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.43.0",
				android: "6.0.0",
				ios: "4.0.0",
				macos: "0.7.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_background = {
	"background-color": {
		type: "color",
		"default": "#000000",
		doc: "The color with which the background will be drawn.",
		transition: true,
		requires: [
			{
				"!": "background-pattern"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"background-pattern": {
		type: "resolvedImage",
		transition: false,
		doc: "Name of image in sprite to use for drawing an image background. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.",
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"background-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		doc: "The opacity at which the background will be drawn.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.10.0",
				android: "2.0.1",
				ios: "2.0.0",
				macos: "0.1.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var paint_sky = {
	"sky-type": {
		type: "enum",
		values: {
			gradient: {
				doc: "Renders the sky with a gradient that can be configured with `sky-gradient-radius` and `sky-gradient`."
			},
			atmosphere: {
				doc: "Renders the sky with a simulated atmospheric scattering algorithm, the sun direction can be attached to the light position or explicitly set through `sky-atmosphere-sun`."
			}
		},
		"default": "atmosphere",
		doc: "The type of the sky",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"sky-atmosphere-sun": {
		type: "array",
		value: "number",
		length: 2,
		units: "degrees",
		minimum: [
			0,
			0
		],
		maximum: [
			360,
			180
		],
		transition: false,
		doc: "Position of the sun center [a azimuthal angle, p polar angle]. The azimuthal angle indicates the position of the sun relative to 0° north, where degrees proceed clockwise. The polar angle indicates the height of the sun, where 0° is directly above, at zenith, and 90° at the horizon. When this property is ommitted, the sun center is directly inherited from the light position.",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		requires: [
			{
				"sky-type": "atmosphere"
			}
		],
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"sky-atmosphere-sun-intensity": {
		type: "number",
		requires: [
			{
				"sky-type": "atmosphere"
			}
		],
		"default": 10,
		minimum: 0,
		maximum: 100,
		transition: false,
		doc: "Intensity of the sun as a light source in the atmosphere (on a scale from 0 to a 100). Setting higher values will brighten up the sky.",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		"property-type": "data-constant"
	},
	"sky-gradient-center": {
		type: "array",
		requires: [
			{
				"sky-type": "gradient"
			}
		],
		value: "number",
		"default": [
			0,
			0
		],
		length: 2,
		units: "degrees",
		minimum: [
			0,
			0
		],
		maximum: [
			360,
			180
		],
		transition: false,
		doc: "Position of the gradient center [a azimuthal angle, p polar angle]. The azimuthal angle indicates the position of the gradient center relative to 0° north, where degrees proceed clockwise. The polar angle indicates the height of the gradient center, where 0° is directly above, at zenith, and 90° at the horizon.",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"sky-gradient-radius": {
		type: "number",
		requires: [
			{
				"sky-type": "gradient"
			}
		],
		"default": 90,
		minimum: 0,
		maximum: 180,
		transition: false,
		doc: "The angular distance (measured in degrees) from `sky-gradient-center` up to which the gradient extends. A value of 180 causes the gradient to wrap around to the opposite direction from `sky-gradient-center`.",
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"sky-gradient": {
		type: "color",
		"default": [
			"interpolate",
			[
				"linear"
			],
			[
				"sky-radial-progress"
			],
			0.8,
			"#87ceeb",
			1,
			"white"
		],
		doc: "Defines a radial color gradient with which to color the sky. The color values can be interpolated with an expression using `sky-radial-progress`. The range [0, 1] for the interpolant covers a radial distance (in degrees) of [0, `sky-gradient-radius`] centered at the position specified by `sky-gradient-center`.",
		transition: false,
		requires: [
			{
				"sky-type": "gradient"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			},
			"data-driven styling": {
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"sky-radial-progress"
			]
		},
		"property-type": "color-ramp"
	},
	"sky-atmosphere-halo-color": {
		type: "color",
		"default": "white",
		doc: "A color applied to the atmosphere sun halo. The alpha channel describes how strongly the sun halo is represented in an atmosphere sky layer.",
		transition: false,
		requires: [
			{
				"sky-type": "atmosphere"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		"property-type": "data-constant"
	},
	"sky-atmosphere-color": {
		type: "color",
		"default": "white",
		doc: "A color used to tweak the main atmospheric scattering coefficients. Using white applies the default coefficients giving the natural blue color to the atmosphere. This color affects how heavily the corresponding wavelength is represented during scattering. The alpha channel describes the density of the atmosphere, with 1 maximum density and 0 no density.",
		transition: false,
		requires: [
			{
				"sky-type": "atmosphere"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		"property-type": "data-constant"
	},
	"sky-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		doc: "The opacity of the entire sky layer.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "2.0.0",
				ios: "10.0.0",
				android: "10.0.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	}
};
var transition = {
	duration: {
		type: "number",
		"default": 300,
		minimum: 0,
		units: "milliseconds",
		doc: "Time allotted for transitions to complete."
	},
	delay: {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "milliseconds",
		doc: "Length of time before a transition begins."
	}
};
var promoteId = {
	"*": {
		type: "string",
		doc: "A name of a feature property to use as ID for feature state."
	}
};
var v8 = {
	$version: $version,
	$root: $root,
	sources: sources,
	source: source,
	source_vector: source_vector,
	source_raster: source_raster,
	source_raster_dem: source_raster_dem,
	source_geojson: source_geojson,
	source_video: source_video,
	source_image: source_image,
	layer: layer,
	layout: layout,
	layout_background: layout_background,
	layout_sky: layout_sky,
	layout_fill: layout_fill,
	layout_circle: layout_circle,
	layout_heatmap: layout_heatmap,
	"layout_fill-extrusion": {
	visibility: {
		type: "enum",
		values: {
			visible: {
				doc: "The layer is shown."
			},
			none: {
				doc: "The layer is not shown."
			}
		},
		"default": "visible",
		doc: "Whether this layer is displayed.",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		"property-type": "constant"
	},
	"fill-extrusion-edge-radius": {
		type: "number",
		"private": true,
		"default": 0,
		minimum: 0,
		maximum: 1,
		doc: "Radius of a fill extrusion edge in meters. If not zero, rounds extrusion edges for a smoother appearance.",
		"sdk-support": {
			"basic functionality": {
				js: "v2.10.0",
				android: "10.7.0",
				ios: "10.7.0"
			}
		},
		"property-type": "constant"
	}
},
	layout_line: layout_line,
	layout_symbol: layout_symbol,
	layout_raster: layout_raster,
	layout_hillshade: layout_hillshade,
	filter: filter,
	filter_symbol: filter_symbol,
	filter_fill: filter_fill,
	filter_line: filter_line,
	filter_circle: filter_circle,
	"filter_fill-extrusion": {
	type: "boolean",
	doc: "Expression which determines whether or not to display a Polygon. Fill-extrusion layer does NOT support dynamic filtering, meaning this expression can NOT use the `[\"pitch\"]` and `[\"distance-from-center\"]` expressions to reference the current state of the view.",
	"default": false,
	transition: false,
	"property-type": "data-driven",
	expression: {
		interpolated: false,
		parameters: [
			"zoom",
			"feature"
		]
	}
},
	filter_heatmap: filter_heatmap,
	filter_operator: filter_operator,
	geometry_type: geometry_type,
	"function": {
	expression: {
		type: "expression",
		doc: "An expression."
	},
	stops: {
		type: "array",
		doc: "An array of stops.",
		value: "function_stop"
	},
	base: {
		type: "number",
		"default": 1,
		minimum: 0,
		doc: "The exponential base of the interpolation curve. It controls the rate at which the result increases. Higher values make the result increase more towards the high end of the range. With `1` the stops are interpolated linearly."
	},
	property: {
		type: "string",
		doc: "The name of a feature property to use as the function input.",
		"default": "$zoom"
	},
	type: {
		type: "enum",
		values: {
			identity: {
				doc: "Return the input value as the output value."
			},
			exponential: {
				doc: "Generate an output by interpolating between stops just less than and just greater than the function input."
			},
			interval: {
				doc: "Return the output value of the stop just less than the function input."
			},
			categorical: {
				doc: "Return the output value of the stop equal to the function input."
			}
		},
		doc: "The interpolation strategy to use in function evaluation.",
		"default": "exponential"
	},
	colorSpace: {
		type: "enum",
		values: {
			rgb: {
				doc: "Use the RGB color space to interpolate color values"
			},
			lab: {
				doc: "Use the LAB color space to interpolate color values."
			},
			hcl: {
				doc: "Use the HCL color space to interpolate color values, interpolating the Hue, Chroma, and Luminance channels individually."
			}
		},
		doc: "The color space in which colors interpolated. Interpolating colors in perceptual color spaces like LAB and HCL tend to produce color ramps that look more consistent and produce colors that can be differentiated more easily than those interpolated in RGB space.",
		"default": "rgb"
	},
	"default": {
		type: "*",
		required: false,
		doc: "A value to serve as a fallback function result when a value isn't otherwise available. It is used in the following circumstances:\n* In categorical functions, when the feature value does not match any of the stop domain values.\n* In property and zoom-and-property functions, when a feature does not contain a value for the specified property.\n* In identity functions, when the feature value is not valid for the style property (for example, if the function is being used for a `circle-color` property but the feature property value is not a string or not a valid color).\n* In interval or exponential property and zoom-and-property functions, when the feature value is not numeric.\nIf no default is provided, the style property's default is used in these circumstances."
	}
},
	function_stop: function_stop,
	expression: expression$1,
	expression_name: expression_name,
	fog: fog,
	light: light,
	projection: projection,
	terrain: terrain,
	paint: paint,
	paint_fill: paint_fill,
	"paint_fill-extrusion": {
	"fill-extrusion-opacity": {
		type: "number",
		"default": 1,
		minimum: 0,
		maximum: 1,
		doc: "The opacity of the entire fill extrusion layer. This is rendered on a per-layer, not per-feature, basis, and data-driven styling is not available.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-color": {
		type: "color",
		"default": "#000000",
		doc: "The base color of the extruded fill. The extrusion's surfaces will be shaded differently based on this color in combination with the root `light` settings. If this color is specified as `rgba` with an alpha component, the alpha component will be ignored; use `fill-extrusion-opacity` to set layer opacity.",
		transition: true,
		requires: [
			{
				"!": "fill-extrusion-pattern"
			}
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			},
			"data-driven styling": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-translate": {
		type: "array",
		value: "number",
		length: 2,
		"default": [
			0,
			0
		],
		transition: true,
		units: "pixels",
		doc: "The geometry's offset. Values are [x, y] where negatives indicate left and up (on the flat plane), respectively.",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-translate-anchor": {
		type: "enum",
		values: {
			map: {
				doc: "The fill extrusion is translated relative to the map."
			},
			viewport: {
				doc: "The fill extrusion is translated relative to the viewport."
			}
		},
		doc: "Controls the frame of reference for `fill-extrusion-translate`.",
		"default": "map",
		requires: [
			"fill-extrusion-translate"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-pattern": {
		type: "resolvedImage",
		transition: false,
		doc: "Name of image in sprite to use for drawing images on extruded fills. For seamless patterns, image width and height must be a factor of two (2, 4, 8, ..., 512). Note that zoom-dependent expressions will be evaluated only at integer zoom levels.",
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			},
			"data-driven styling": {
				js: "0.49.0",
				android: "6.5.0",
				macos: "0.11.0",
				ios: "4.4.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom",
				"feature"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-height": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		doc: "The height with which to extrude this layer.",
		transition: true,
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			},
			"data-driven styling": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-base": {
		type: "number",
		"default": 0,
		minimum: 0,
		units: "meters",
		doc: "The height with which to extrude the base of this layer. Must be less than or equal to `fill-extrusion-height`.",
		transition: true,
		requires: [
			"fill-extrusion-height"
		],
		"sdk-support": {
			"basic functionality": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			},
			"data-driven styling": {
				js: "0.27.0",
				android: "5.1.0",
				ios: "3.6.0",
				macos: "0.5.0"
			}
		},
		expression: {
			interpolated: true,
			parameters: [
				"zoom",
				"feature",
				"feature-state"
			]
		},
		"property-type": "data-driven"
	},
	"fill-extrusion-vertical-gradient": {
		type: "boolean",
		"default": true,
		doc: "Whether to apply a vertical gradient to the sides of a fill-extrusion layer. If true, sides will be shaded slightly darker farther down.",
		transition: false,
		"sdk-support": {
			"basic functionality": {
				js: "0.50.0",
				android: "7.0.0",
				ios: "4.7.0",
				macos: "0.13.0"
			}
		},
		expression: {
			interpolated: false,
			parameters: [
				"zoom"
			]
		},
		"property-type": "data-constant"
	},
	"fill-extrusion-ambient-occlusion-intensity": {
		"property-type": "data-constant",
		type: "number",
		"private": true,
		"default": 0,
		minimum: 0,
		maximum: 1,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Controls the intensity of shading near ground and concave angles between walls. Default value 0.0 disables ambient occlusion and values around 0.3 provide the most plausible results for buildings.",
		"sdk-support": {
			"basic functionality": {
				js: "2.10.0",
				android: "10.7.0",
				ios: "10.7.0"
			}
		}
	},
	"fill-extrusion-ambient-occlusion-radius": {
		"property-type": "data-constant",
		type: "number",
		"private": true,
		"default": 3,
		minimum: 0,
		expression: {
			interpolated: true,
			parameters: [
				"zoom"
			]
		},
		transition: true,
		doc: "Shades area near ground and concave angles between walls where the radius defines only vertical impact. Default value 3.0 corresponds to height of one floor and brings the most plausible results for buildings.",
		requires: [
			"fill-extrusion-edge-radius"
		],
		"sdk-support": {
			"basic functionality": {
				js: "2.10.0",
				android: "10.7.0",
				ios: "10.7.0"
			}
		}
	}
},
	paint_line: paint_line,
	paint_circle: paint_circle,
	paint_heatmap: paint_heatmap,
	paint_symbol: paint_symbol,
	paint_raster: paint_raster,
	paint_hillshade: paint_hillshade,
	paint_background: paint_background,
	paint_sky: paint_sky,
	transition: transition,
	"property-type": {
	"data-driven": {
		type: "property-type",
		doc: "Property is interpolable and can be represented using a property expression."
	},
	"color-ramp": {
		type: "property-type",
		doc: "Property should be specified using a color ramp from which the output color can be sampled based on a property calculation."
	},
	"data-constant": {
		type: "property-type",
		doc: "Property is interpolable but cannot be represented using a property expression."
	},
	constant: {
		type: "property-type",
		doc: "Property is constant across all zoom levels and property values."
	}
},
	promoteId: promoteId
};

// Note: This regex matches even invalid JSON strings, but since we’re
// working on the output of `JSON.stringify` we know that only valid strings
// are present (unless the user supplied a weird `options.indent` but in
// that case we don’t care since the output would be invalid anyway).
const stringOrChar = /("(?:[^\\"]|\\.)*")|[:,]/g;
function stringify(passedObj, options = {}) {
    const indent = JSON.stringify([1], undefined, options.indent === undefined ? 2 : options.indent).slice(2, -3);
    const maxLength = indent === '' ? Infinity : options.maxLength === undefined ? 80 : options.maxLength;
    let {replacer} = options;
    return function _stringify(obj, currentIndent, reserved) {
        if (obj && typeof obj.toJSON === 'function') {
            obj = obj.toJSON();
        }
        const string = JSON.stringify(obj, replacer);
        if (string === undefined) {
            return string;
        }
        const length = maxLength - currentIndent.length - reserved;
        if (string.length <= length) {
            const prettified = string.replace(stringOrChar, (match, stringLiteral) => {
                return stringLiteral || `${ match } `;
            });
            if (prettified.length <= length) {
                return prettified;
            }
        }
        if (replacer != null) {
            obj = JSON.parse(string);
            replacer = undefined;
        }
        if (typeof obj === 'object' && obj !== null) {
            const nextIndent = currentIndent + indent;
            const items = [];
            let index = 0;
            let start;
            let end;
            if (Array.isArray(obj)) {
                start = '[';
                end = ']';
                const {length} = obj;
                for (; index < length; index++) {
                    items.push(_stringify(obj[index], nextIndent, index === length - 1 ? 0 : 1) || 'null');
                }
            } else {
                start = '{';
                end = '}';
                const keys = Object.keys(obj);
                const {length} = keys;
                for (; index < length; index++) {
                    const key = keys[index];
                    const keyPart = `${ JSON.stringify(key) }: `;
                    const value = _stringify(obj[key], nextIndent, keyPart.length + (index === length - 1 ? 0 : 1));
                    if (value !== undefined) {
                        items.push(keyPart + value);
                    }
                }
            }
            if (items.length > 0) {
                return [
                    start,
                    indent + items.join(`,\n${ nextIndent }`),
                    end
                ].join(`\n${ currentIndent }`);
            }
        }
        return string;
    }(passedObj, '', 0);
}

function sortKeysBy(obj, reference) {
    const result = {};
    for (const key in reference) {
        if (obj[key] !== undefined) {
            result[key] = obj[key];
        }
    }
    for (const key in obj) {
        if (result[key] === undefined) {
            result[key] = obj[key];
        }
    }
    return result;
}
/**
 * Format a Mapbox GL Style.  Returns a stringified style with its keys
 * sorted in the same order as the reference style.
 *
 * The optional `space` argument is passed to
 * [`JSON.stringify`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify)
 * to generate formatted output.
 *
 * If `space` is unspecified, a default of `2` spaces will be used.
 *
 * @private
 * @param {Object} style a Mapbox GL Style
 * @param {number} [space] space argument to pass to `JSON.stringify`
 * @returns {string} stringified formatted JSON
 * @example
 * var fs = require('fs');
 * var format = require('mapbox-gl-style-spec').format;
 * var style = fs.readFileSync('./source.json', 'utf8');
 * fs.writeFileSync('./dest.json', format(style));
 * fs.writeFileSync('./dest.min.json', format(style, 0));
 */
function format(style, space = 2) {
    style = sortKeysBy(style, v8.$root);
    if (style.layers) {
        style.layers = style.layers.map(layer => sortKeysBy(layer, v8.layer));
    }
    return stringify(style, { indent: space });
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

var url = {};

var punycode$1 = {exports: {}};

/*! https://mths.be/punycode v1.3.2 by @mathias */

(function (module, exports) {
	(function (root) {
	    /** Detect free variables */
	    var freeExports = exports && !exports.nodeType && exports;
	    var freeModule = module && !module.nodeType && module;
	    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal;
	    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
	        root = freeGlobal;
	    }
	    /**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
	    var punycode,
	        /** Highest positive signed 32-bit float value */
	        maxInt = 2147483647,
	        // aka. 0x7FFFFFFF or 2^31-1
	        /** Bootstring parameters */
	        base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128,
	        // 0x80
	        delimiter = '-',
	        // '\x2D'
	        /** Regular expressions */
	        regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/,
	        // unprintable ASCII chars + non-ASCII chars
	        regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	        // RFC 3490 separators
	        /** Error messages */
	        errors = {
	            'overflow': 'Overflow: input needs wider integers to process',
	            'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
	            'invalid-input': 'Invalid input'
	        },
	        /** Convenience shortcuts */
	        baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode,
	        /** Temporary variable */
	        key;
	    /*--------------------------------------------------------------------------*/
	    /**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
	    function error(type) {
	        throw RangeError(errors[type]);
	    }
	    /**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
	    function map(array, fn) {
	        var length = array.length;
	        var result = [];
	        while (length--) {
	            result[length] = fn(array[length]);
	        }
	        return result;
	    }
	    /**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
	    function mapDomain(string, fn) {
	        var parts = string.split('@');
	        var result = '';
	        if (parts.length > 1) {
	            // In email addresses, only the domain name should be punycoded. Leave
	            // the local part (i.e. everything up to `@`) intact.
	            result = parts[0] + '@';
	            string = parts[1];
	        }
	        // Avoid `split(regex)` for IE8 compatibility. See #17.
	        string = string.replace(regexSeparators, '.');
	        var labels = string.split('.');
	        var encoded = map(labels, fn).join('.');
	        return result + encoded;
	    }
	    /**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
	    function ucs2decode(string) {
	        var output = [], counter = 0, length = string.length, value, extra;
	        while (counter < length) {
	            value = string.charCodeAt(counter++);
	            if (value >= 55296 && value <= 56319 && counter < length) {
	                // high surrogate, and there is a next character
	                extra = string.charCodeAt(counter++);
	                if ((extra & 64512) == 56320) {
	                    // low surrogate
	                    output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
	                } else {
	                    // unmatched surrogate; only append this code unit, in case the next
	                    // code unit is the high surrogate of a surrogate pair
	                    output.push(value);
	                    counter--;
	                }
	            } else {
	                output.push(value);
	            }
	        }
	        return output;
	    }
	    /**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
	    function ucs2encode(array) {
	        return map(array, function (value) {
	            var output = '';
	            if (value > 65535) {
	                value -= 65536;
	                output += stringFromCharCode(value >>> 10 & 1023 | 55296);
	                value = 56320 | value & 1023;
	            }
	            output += stringFromCharCode(value);
	            return output;
	        }).join('');
	    }
	    /**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
	    function basicToDigit(codePoint) {
	        if (codePoint - 48 < 10) {
	            return codePoint - 22;
	        }
	        if (codePoint - 65 < 26) {
	            return codePoint - 65;
	        }
	        if (codePoint - 97 < 26) {
	            return codePoint - 97;
	        }
	        return base;
	    }
	    /**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
	    function digitToBasic(digit, flag) {
	        //  0..25 map to ASCII a..z or A..Z
	        // 26..35 map to ASCII 0..9
	        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	    }
	    /**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * http://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
	    function adapt(delta, numPoints, firstTime) {
	        var k = 0;
	        delta = firstTime ? floor(delta / damp) : delta >> 1;
	        delta += floor(delta / numPoints);
	        for (; delta > baseMinusTMin * tMax >> 1; k += base) {
	            delta = floor(delta / baseMinusTMin);
	        }
	        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	    }
	    /**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
	    function decode(input) {
	        // Don't use UCS-2
	        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t,
	            /** Cached calculation results */
	            baseMinusT;
	        // Handle the basic code points: let `basic` be the number of input code
	        // points before the last delimiter, or `0` if there is none, then copy
	        // the first basic code points to the output.
	        basic = input.lastIndexOf(delimiter);
	        if (basic < 0) {
	            basic = 0;
	        }
	        for (j = 0; j < basic; ++j) {
	            // if it's not a basic code point
	            if (input.charCodeAt(j) >= 128) {
	                error('not-basic');
	            }
	            output.push(input.charCodeAt(j));
	        }
	        // Main decoding loop: start just after the last delimiter if any basic code
	        // points were copied; start at the beginning otherwise.
	        for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) {
	            // `index` is the index of the next character to be consumed.
	            // Decode a generalized variable-length integer into `delta`,
	            // which gets added to `i`. The overflow checking is easier
	            // if we increase `i` as we go, then subtract off its starting
	            // value at the end to obtain `delta`.
	            for (oldi = i, w = 1, k = base;; k += base) {
	                if (index >= inputLength) {
	                    error('invalid-input');
	                }
	                digit = basicToDigit(input.charCodeAt(index++));
	                if (digit >= base || digit > floor((maxInt - i) / w)) {
	                    error('overflow');
	                }
	                i += digit * w;
	                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	                if (digit < t) {
	                    break;
	                }
	                baseMinusT = base - t;
	                if (w > floor(maxInt / baseMinusT)) {
	                    error('overflow');
	                }
	                w *= baseMinusT;
	            }
	            out = output.length + 1;
	            bias = adapt(i - oldi, out, oldi == 0);
	            // `i` was supposed to wrap around from `out` to `0`,
	            // incrementing `n` each time, so we'll fix that now:
	            if (floor(i / out) > maxInt - n) {
	                error('overflow');
	            }
	            n += floor(i / out);
	            i %= out;
	            // Insert `n` at position `i` of the output
	            output.splice(i++, 0, n);
	        }
	        return ucs2encode(output);
	    }
	    /**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
	    function encode(input) {
	        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [],
	            /** `inputLength` will hold the number of code points in `input`. */
	            inputLength,
	            /** Cached calculation results */
	            handledCPCountPlusOne, baseMinusT, qMinusT;
	        // Convert the input in UCS-2 to Unicode
	        input = ucs2decode(input);
	        // Cache the length
	        inputLength = input.length;
	        // Initialize the state
	        n = initialN;
	        delta = 0;
	        bias = initialBias;
	        // Handle the basic code points
	        for (j = 0; j < inputLength; ++j) {
	            currentValue = input[j];
	            if (currentValue < 128) {
	                output.push(stringFromCharCode(currentValue));
	            }
	        }
	        handledCPCount = basicLength = output.length;
	        // `handledCPCount` is the number of code points that have been handled;
	        // `basicLength` is the number of basic code points.
	        // Finish the basic string - if it is not empty - with a delimiter
	        if (basicLength) {
	            output.push(delimiter);
	        }
	        // Main encoding loop:
	        while (handledCPCount < inputLength) {
	            // All non-basic code points < n have been handled already. Find the next
	            // larger one:
	            for (m = maxInt, j = 0; j < inputLength; ++j) {
	                currentValue = input[j];
	                if (currentValue >= n && currentValue < m) {
	                    m = currentValue;
	                }
	            }
	            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
	            // but guard against overflow
	            handledCPCountPlusOne = handledCPCount + 1;
	            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
	                error('overflow');
	            }
	            delta += (m - n) * handledCPCountPlusOne;
	            n = m;
	            for (j = 0; j < inputLength; ++j) {
	                currentValue = input[j];
	                if (currentValue < n && ++delta > maxInt) {
	                    error('overflow');
	                }
	                if (currentValue == n) {
	                    // Represent delta as a generalized variable-length integer
	                    for (q = delta, k = base;; k += base) {
	                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
	                        if (q < t) {
	                            break;
	                        }
	                        qMinusT = q - t;
	                        baseMinusT = base - t;
	                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
	                        q = floor(qMinusT / baseMinusT);
	                    }
	                    output.push(stringFromCharCode(digitToBasic(q, 0)));
	                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
	                    delta = 0;
	                    ++handledCPCount;
	                }
	            }
	            ++delta;
	            ++n;
	        }
	        return output.join('');
	    }
	    /**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
	    function toUnicode(input) {
	        return mapDomain(input, function (string) {
	            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
	        });
	    }
	    /**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
	    function toASCII(input) {
	        return mapDomain(input, function (string) {
	            return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
	        });
	    }
	    /*--------------------------------------------------------------------------*/
	    /** Define the public API */
	    punycode = {
	        /**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
	        'version': '1.3.2',
	        /**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
	        'ucs2': {
	            'decode': ucs2decode,
	            'encode': ucs2encode
	        },
	        'decode': decode,
	        'encode': encode,
	        'toASCII': toASCII,
	        'toUnicode': toUnicode
	    };
	    /** Expose `punycode` */
	    // Some AMD build optimizers, like r.js, check for specific condition patterns
	    // like the following:
	    if (freeExports && freeModule) {
	        if (module.exports == freeExports) {
	            // in Node.js or RingoJS v0.8.0+
	            freeModule.exports = punycode;
	        } else {
	            // in Narwhal or RingoJS v0.7.0-
	            for (key in punycode) {
	                punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
	            }
	        }
	    } else {
	        // in Rhino or a web browser
	        root.punycode = punycode;
	    }
	}(commonjsGlobal));
} (punycode$1, punycode$1.exports));

var util$1 = {
    isString: function (arg) {
        return typeof arg === 'string';
    },
    isObject: function (arg) {
        return typeof arg === 'object' && arg !== null;
    },
    isNull: function (arg) {
        return arg === null;
    },
    isNullOrUndefined: function (arg) {
        return arg == null;
    }
};

var querystring$1 = {};

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var decode = function (qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) {
        return obj;
    }
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') {
        maxKeys = options.maxKeys;
    }
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) {
        len = maxKeys;
    }
    for (var i = 0; i < len; ++i) {
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!hasOwnProperty(obj, k)) {
            obj[k] = v;
        } else if (Array.isArray(obj[k])) {
            obj[k].push(v);
        } else {
            obj[k] = [
                obj[k],
                v
            ];
        }
    }
    return obj;
};

var stringifyPrimitive = function (v) {
    switch (typeof v) {
    case 'string':
        return v;
    case 'boolean':
        return v ? 'true' : 'false';
    case 'number':
        return isFinite(v) ? v : '';
    default:
        return '';
    }
};
var encode = function (obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) {
        obj = undefined;
    }
    if (typeof obj === 'object') {
        return Object.keys(obj).map(function (k) {
            var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
            if (Array.isArray(obj[k])) {
                return obj[k].map(function (v) {
                    return ks + encodeURIComponent(stringifyPrimitive(v));
                }).join(sep);
            } else {
                return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
            }
        }).join(sep);
    }
    if (!name)
        return '';
    return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

querystring$1.decode = querystring$1.parse = decode;
querystring$1.encode = querystring$1.stringify = encode;

var punycode = punycode$1.exports;
var util = util$1;
url.parse = urlParse;
url.resolve = urlResolve;
url.resolveObject = urlResolveObject;
url.format = urlFormat;
url.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/,
    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,
    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = [
        '<',
        '>',
        '"',
        '`',
        ' ',
        '\r',
        '\n',
        '\t'
    ],
    // RFC 2396: characters not allowed for various reasons.
    unwise = [
        '{',
        '}',
        '|',
        '\\',
        '^',
        '`'
    ].concat(delims),
    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = [
        '%',
        '/',
        '?',
        ';',
        '#'
    ].concat(autoEscape), hostEndingChars = [
        '/',
        '?',
        '#'
    ], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
        'javascript': true,
        'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
        'javascript': true,
        'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
        'http': true,
        'https': true,
        'ftp': true,
        'gopher': true,
        'file': true,
        'http:': true,
        'https:': true,
        'ftp:': true,
        'gopher:': true,
        'file:': true
    }, querystring = querystring$1;
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && util.isObject(url) && url instanceof Url)
        return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
    if (!util.isString(url)) {
        throw new TypeError('Parameter \'url\' must be a string, not ' + typeof url);
    }
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf('?'), splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#', uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, '/');
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split('#').length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) {
                    this.query = querystring.parse(this.search.substr(1));
                } else {
                    this.query = this.search.substr(1);
                }
            } else if (parseQueryString) {
                this.search = '';
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === '//';
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for (var i = 0; i < hostEndingChars.length; i++) {
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
                hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) {
            // atSign can be anywhere.
            atSign = rest.lastIndexOf('@');
        } else {
            // atSign must be in auth portion.
            // http://a@b/c@d => host:b auth:a path:/c@d
            atSign = rest.lastIndexOf('@', hostEnd);
        }
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for (var i = 0; i < nonHostChars.length; i++) {
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
                hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1)
            hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || '';
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for (var i = 0, l = hostparts.length; i < l; i++) {
                var part = hostparts[i];
                if (!part)
                    continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = '';
                    for (var j = 0, k = part.length; j < k; j++) {
                        if (part.charCodeAt(j) > 127) {
                            // we replace non-ASCII char with a temporary placeholder
                            // we need this to make sure size of hostname is not
                            // broken by replacing non-ASCII by nothing
                            newpart += 'x';
                        } else {
                            newpart += part[j];
                        }
                    }
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) {
                            rest = '/' + notHost.join('.') + rest;
                        }
                        this.hostname = validParts.join('.');
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) {
            this.hostname = '';
        } else {
            // hostnames are always lower case.
            this.hostname = this.hostname.toLowerCase();
        }
        if (!ipv6Hostname) {
            // IDNA Support: Returns a punycoded representation of "domain".
            // It only converts parts of the domain name that
            // have non-ASCII characters, i.e. it doesn't matter if
            // you call it with a domain that already is ASCII-only.
            this.hostname = punycode.toASCII(this.hostname);
        }
        var p = this.port ? ':' + this.port : '';
        var h = this.hostname || '';
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== '/') {
                rest = '/' + rest;
            }
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) {
        // First, make 100% sure that any "autoEscape" chars get
        // escaped, even if encodeURIComponent doesn't think they
        // need to be.
        for (var i = 0, l = autoEscape.length; i < l; i++) {
            var ae = autoEscape[i];
            if (rest.indexOf(ae) === -1)
                continue;
            var esc = encodeURIComponent(ae);
            if (esc === ae) {
                esc = escape(ae);
            }
            rest = rest.split(ae).join(esc);
        }
    }
    // chop off from the tail first.
    var hash = rest.indexOf('#');
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf('?');
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) {
            this.query = querystring.parse(this.query);
        }
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = '';
        this.query = {};
    }
    if (rest)
        this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
        this.pathname = '/';
    }
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || '';
        var s = this.search || '';
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if (util.isString(obj))
        obj = urlParse(obj);
    if (!(obj instanceof Url))
        return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function () {
    var auth = this.auth || '';
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ':');
        auth += '@';
    }
    var protocol = this.protocol || '', pathname = this.pathname || '', hash = this.hash || '', host = false, query = '';
    if (this.host) {
        host = auth + this.host;
    } else if (this.hostname) {
        host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
        if (this.port) {
            host += ':' + this.port;
        }
    }
    if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
        query = querystring.stringify(this.query);
    }
    var search = this.search || query && '?' + query || '';
    if (protocol && protocol.substr(-1) !== ':')
        protocol += ':';
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = '//' + (host || '');
        if (pathname && pathname.charAt(0) !== '/')
            pathname = '/' + pathname;
    } else if (!host) {
        host = '';
    }
    if (hash && hash.charAt(0) !== '#')
        hash = '#' + hash;
    if (search && search.charAt(0) !== '?')
        search = '?' + search;
    pathname = pathname.replace(/[?#]/g, function (match) {
        return encodeURIComponent(match);
    });
    search = search.replace('#', '%23');
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function (relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source)
        return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function (relative) {
    if (util.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for (var tk = 0; tk < tkeys.length; tk++) {
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === '') {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for (var rk = 0; rk < rkeys.length; rk++) {
            var rkey = rkeys[rk];
            if (rkey !== 'protocol')
                result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.path = result.pathname = '/';
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for (var v = 0; v < keys.length; v++) {
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || '').split('/');
            while (relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host)
                relative.host = '';
            if (!relative.hostname)
                relative.hostname = '';
            if (relPath[0] !== '')
                relPath.unshift('');
            if (relPath.length < 2)
                relPath.unshift('');
            result.pathname = relPath.join('/');
        } else {
            result.pathname = relative.pathname;
        }
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || '';
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || '';
            var s = result.search || '';
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/', isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/', mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split('/') || [], relPath = relative.pathname && relative.pathname.split('/') || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = '';
        result.port = null;
        if (result.host) {
            if (srcPath[0] === '')
                srcPath[0] = result.host;
            else
                srcPath.unshift(result.host);
        }
        result.host = '';
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === '')
                    relPath[0] = relative.host;
                else
                    relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === '' ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath)
            srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!util.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
            result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
        }
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) {
            result.path = '/' + result.search;
        } else {
            result.path = null;
        }
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = srcPath.length; i >= 0; i--) {
        last = srcPath[i];
        if (last === '.') {
            srcPath.splice(i, 1);
        } else if (last === '..') {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) {
        for (; up--; up) {
            srcPath.unshift('..');
        }
    }
    if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
        srcPath.unshift('');
    }
    if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
        srcPath.push('');
    }
    var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) {
        srcPath.unshift('');
    }
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else {
        result.pathname = srcPath.join('/');
    }
    //to support request.http
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
        result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function () {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ':') {
            this.port = port.substr(1);
        }
        host = host.substr(0, host.length - port.length);
    }
    if (host)
        this.hostname = host;
};

//      
function getPropertyReference(propertyName) {
    for (let i = 0; i < v8.layout.length; i++) {
        for (const key in v8[v8.layout[i]]) {
            if (key === propertyName)
                return v8[v8.layout[i]][key];
        }
    }
    for (let i = 0; i < v8.paint.length; i++) {
        for (const key in v8[v8.paint[i]]) {
            if (key === propertyName)
                return v8[v8.paint[i]][key];
        }
    }
    return null;
}
function eachSource(style, callback) {
    for (const k in style.sources) {
        callback(style.sources[k]);
    }
}
function eachLayer(style, callback) {
    for (const layer of style.layers) {
        callback(layer);
    }
}
function eachProperty(style, options, callback) {
    function inner(layer, propertyType) {
        const properties = layer[propertyType];
        if (!properties)
            return;
        Object.keys(properties).forEach(key => {
            callback({
                path: [
                    layer.id,
                    propertyType,
                    key
                ],
                key,
                value: properties[key],
                reference: getPropertyReference(key),
                set(x) {
                    properties[key] = x;
                }
            });
        });
    }
    eachLayer(style, layer => {
        if (options.paint) {
            inner(layer, 'paint');
        }
        if (options.layout) {
            inner(layer, 'layout');
        }
    });
}

function eachLayout(layer, callback) {
    for (const k in layer) {
        if (k.indexOf('layout') === 0) {
            callback(layer[k], k);
        }
    }
}
function eachPaint(layer, callback) {
    for (const k in layer) {
        if (k.indexOf('paint') === 0) {
            callback(layer[k], k);
        }
    }
}
function resolveConstant(style, value) {
    if (typeof value === 'string' && value[0] === '@') {
        return resolveConstant(style, style.constants[value]);
    } else {
        return value;
    }
}
function isFunction$1(value) {
    return Array.isArray(value.stops);
}
function renameProperty(obj, from, to) {
    obj[to] = obj[from];
    delete obj[from];
}
function migrateToV8 (style) {
    style.version = 8;
    // Rename properties, reverse coordinates in source and layers
    eachSource(style, source => {
        if (source.type === 'video' && source.url !== undefined) {
            renameProperty(source, 'url', 'urls');
        }
        if (source.type === 'video') {
            source.coordinates.forEach(coord => {
                return coord.reverse();
            });
        }
    });
    eachLayer(style, layer => {
        eachLayout(layer, layout => {
            if (layout['symbol-min-distance'] !== undefined) {
                renameProperty(layout, 'symbol-min-distance', 'symbol-spacing');
            }
        });
        eachPaint(layer, paint => {
            if (paint['background-image'] !== undefined) {
                renameProperty(paint, 'background-image', 'background-pattern');
            }
            if (paint['line-image'] !== undefined) {
                renameProperty(paint, 'line-image', 'line-pattern');
            }
            if (paint['fill-image'] !== undefined) {
                renameProperty(paint, 'fill-image', 'fill-pattern');
            }
        });
    });
    // Inline Constants
    eachProperty(style, {
        paint: true,
        layout: true
    }, property => {
        const value = resolveConstant(style, property.value);
        if (isFunction$1(value)) {
            value.stops.forEach(stop => {
                stop[1] = resolveConstant(style, stop[1]);
            });
        }
        property.set(value);
    });
    delete style.constants;
    eachLayer(style, layer => {
        // get rid of text-max-size, icon-max-size
        // turn text-size, icon-size into layout properties
        // https://github.com/mapbox/mapbox-gl-style-spec/issues/255
        eachLayout(layer, layout => {
            delete layout['text-max-size'];
            delete layout['icon-max-size'];
        });
        eachPaint(layer, paint => {
            if (paint['text-size']) {
                if (!layer.layout)
                    layer.layout = {};
                layer.layout['text-size'] = paint['text-size'];
                delete paint['text-size'];
            }
            if (paint['icon-size']) {
                if (!layer.layout)
                    layer.layout = {};
                layer.layout['icon-size'] = paint['icon-size'];
                delete paint['icon-size'];
            }
        });
    });
    function migrateFontstackURL(input) {
        const inputParsed = url.parse(input);
        const inputPathnameParts = inputParsed.pathname.split('/');
        if (inputParsed.protocol !== 'mapbox:') {
            return input;
        } else if (inputParsed.hostname === 'fontstack') {
            assert(decodeURI(inputParsed.pathname) === '/{fontstack}/{range}.pbf');
            return 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf';
        } else if (inputParsed.hostname === 'fonts') {
            assert(inputPathnameParts[1] === 'v1');
            assert(decodeURI(inputPathnameParts[3]) === '{fontstack}');
            assert(decodeURI(inputPathnameParts[4]) === '{range}.pbf');
            return `mapbox://fonts/${ inputPathnameParts[2] }/{fontstack}/{range}.pbf`;
        } else {
            assert(false);
        }
        function assert(predicate) {
            if (!predicate) {
                throw new Error(`Invalid font url: "${ input }"`);
            }
        }
    }
    if (style.glyphs) {
        style.glyphs = migrateFontstackURL(style.glyphs);
    }
    function migrateFontStack(font) {
        function splitAndTrim(string) {
            return string.split(',').map(s => {
                return s.trim();
            });
        }
        if (Array.isArray(font)) {
            // Assume it's a previously migrated font-array.
            return font;
        } else if (typeof font === 'string') {
            return splitAndTrim(font);
        } else if (typeof font === 'object') {
            font.stops.forEach(stop => {
                stop[1] = splitAndTrim(stop[1]);
            });
            return font;
        } else {
            throw new Error('unexpected font value');
        }
    }
    eachLayer(style, layer => {
        eachLayout(layer, layout => {
            if (layout['text-font']) {
                layout['text-font'] = migrateFontStack(layout['text-font']);
            }
        });
    });
    // Reverse order of symbol layers. This is an imperfect migration.
    //
    // The order of a symbol layer in the layers list affects two things:
    // - how it is drawn relative to other layers (like oneway arrows below bridges)
    // - the placement priority compared to other layers
    //
    // It's impossible to reverse the placement priority without breaking the draw order
    // in some cases. This migration only reverses the order of symbol layers that
    // are above all other types of layers.
    //
    // Symbol layers that are at the top of the map preserve their priority.
    // Symbol layers that are below another type (line, fill) of layer preserve their draw order.
    let firstSymbolLayer = 0;
    for (let i = style.layers.length - 1; i >= 0; i--) {
        const layer = style.layers[i];
        if (layer.type !== 'symbol') {
            firstSymbolLayer = i + 1;
            break;
        }
    }
    const symbolLayers = style.layers.splice(firstSymbolLayer);
    symbolLayers.reverse();
    style.layers = style.layers.concat(symbolLayers);
    return style;
}

//      
function extend (output, ...inputs) {
    for (const input of inputs) {
        for (const k in input) {
            output[k] = input[k];
        }
    }
    return output;
}

//      
class ParsingError$1 extends Error {
    constructor(key, message) {
        super(message);
        this.message = message;
        this.key = key;
    }
}
var ParsingError$2 = ParsingError$1;

//      
/**
 * Tracks `let` bindings during expression parsing.
 * @private
 */
class Scope {
    constructor(parent, bindings = []) {
        this.parent = parent;
        this.bindings = {};
        for (const [name, expression] of bindings) {
            this.bindings[name] = expression;
        }
    }
    concat(bindings) {
        return new Scope(this, bindings);
    }
    get(name) {
        if (this.bindings[name]) {
            return this.bindings[name];
        }
        if (this.parent) {
            return this.parent.get(name);
        }
        throw new Error(`${ name } not found in scope.`);
    }
    has(name) {
        if (this.bindings[name])
            return true;
        return this.parent ? this.parent.has(name) : false;
    }
}
var Scope$1 = Scope;

//      
const NullType = { kind: 'null' };
const NumberType = { kind: 'number' };
const StringType = { kind: 'string' };
const BooleanType = { kind: 'boolean' };
const ColorType = { kind: 'color' };
const ObjectType = { kind: 'object' };
const ValueType = { kind: 'value' };
const ErrorType = { kind: 'error' };
const CollatorType = { kind: 'collator' };
const FormattedType = { kind: 'formatted' };
const ResolvedImageType = { kind: 'resolvedImage' };
function array$1(itemType, N) {
    return {
        kind: 'array',
        itemType,
        N
    };
}
function toString$1(type) {
    if (type.kind === 'array') {
        const itemType = toString$1(type.itemType);
        return typeof type.N === 'number' ? `array<${ itemType }, ${ type.N }>` : type.itemType.kind === 'value' ? 'array' : `array<${ itemType }>`;
    } else {
        return type.kind;
    }
}
const valueMemberTypes = [
    NullType,
    NumberType,
    StringType,
    BooleanType,
    ColorType,
    FormattedType,
    ObjectType,
    array$1(ValueType),
    ResolvedImageType
];
/**
 * Returns null if `t` is a subtype of `expected`; otherwise returns an
 * error message.
 * @private
 */
function checkSubtype(expected, t) {
    if (t.kind === 'error') {
        // Error is a subtype of every type
        return null;
    } else if (expected.kind === 'array') {
        if (t.kind === 'array' && (t.N === 0 && t.itemType.kind === 'value' || !checkSubtype(expected.itemType, t.itemType)) && (typeof expected.N !== 'number' || expected.N === t.N)) {
            return null;
        }
    } else if (expected.kind === t.kind) {
        return null;
    } else if (expected.kind === 'value') {
        for (const memberType of valueMemberTypes) {
            if (!checkSubtype(memberType, t)) {
                return null;
            }
        }
    }
    return `Expected ${ toString$1(expected) } but found ${ toString$1(t) } instead.`;
}
function isValidType(provided, allowedTypes) {
    return allowedTypes.some(t => t.kind === provided.kind);
}
function isValidNativeType(provided, allowedTypes) {
    return allowedTypes.some(t => {
        if (t === 'null') {
            return provided === null;
        } else if (t === 'array') {
            return Array.isArray(provided);
        } else if (t === 'object') {
            return provided && !Array.isArray(provided) && typeof provided === 'object';
        } else {
            return t === typeof provided;
        }
    });
}

var csscolorparser = {};

var parseCSSColor_1;
// (c) Dean McNamee <dean@gmail.com>, 2012.
//
// https://github.com/deanm/css-color-parser-js
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
// IN THE SOFTWARE.
// http://www.w3.org/TR/css3-color/
var kCSSColorTable = {
    'transparent': [
        0,
        0,
        0,
        0
    ],
    'aliceblue': [
        240,
        248,
        255,
        1
    ],
    'antiquewhite': [
        250,
        235,
        215,
        1
    ],
    'aqua': [
        0,
        255,
        255,
        1
    ],
    'aquamarine': [
        127,
        255,
        212,
        1
    ],
    'azure': [
        240,
        255,
        255,
        1
    ],
    'beige': [
        245,
        245,
        220,
        1
    ],
    'bisque': [
        255,
        228,
        196,
        1
    ],
    'black': [
        0,
        0,
        0,
        1
    ],
    'blanchedalmond': [
        255,
        235,
        205,
        1
    ],
    'blue': [
        0,
        0,
        255,
        1
    ],
    'blueviolet': [
        138,
        43,
        226,
        1
    ],
    'brown': [
        165,
        42,
        42,
        1
    ],
    'burlywood': [
        222,
        184,
        135,
        1
    ],
    'cadetblue': [
        95,
        158,
        160,
        1
    ],
    'chartreuse': [
        127,
        255,
        0,
        1
    ],
    'chocolate': [
        210,
        105,
        30,
        1
    ],
    'coral': [
        255,
        127,
        80,
        1
    ],
    'cornflowerblue': [
        100,
        149,
        237,
        1
    ],
    'cornsilk': [
        255,
        248,
        220,
        1
    ],
    'crimson': [
        220,
        20,
        60,
        1
    ],
    'cyan': [
        0,
        255,
        255,
        1
    ],
    'darkblue': [
        0,
        0,
        139,
        1
    ],
    'darkcyan': [
        0,
        139,
        139,
        1
    ],
    'darkgoldenrod': [
        184,
        134,
        11,
        1
    ],
    'darkgray': [
        169,
        169,
        169,
        1
    ],
    'darkgreen': [
        0,
        100,
        0,
        1
    ],
    'darkgrey': [
        169,
        169,
        169,
        1
    ],
    'darkkhaki': [
        189,
        183,
        107,
        1
    ],
    'darkmagenta': [
        139,
        0,
        139,
        1
    ],
    'darkolivegreen': [
        85,
        107,
        47,
        1
    ],
    'darkorange': [
        255,
        140,
        0,
        1
    ],
    'darkorchid': [
        153,
        50,
        204,
        1
    ],
    'darkred': [
        139,
        0,
        0,
        1
    ],
    'darksalmon': [
        233,
        150,
        122,
        1
    ],
    'darkseagreen': [
        143,
        188,
        143,
        1
    ],
    'darkslateblue': [
        72,
        61,
        139,
        1
    ],
    'darkslategray': [
        47,
        79,
        79,
        1
    ],
    'darkslategrey': [
        47,
        79,
        79,
        1
    ],
    'darkturquoise': [
        0,
        206,
        209,
        1
    ],
    'darkviolet': [
        148,
        0,
        211,
        1
    ],
    'deeppink': [
        255,
        20,
        147,
        1
    ],
    'deepskyblue': [
        0,
        191,
        255,
        1
    ],
    'dimgray': [
        105,
        105,
        105,
        1
    ],
    'dimgrey': [
        105,
        105,
        105,
        1
    ],
    'dodgerblue': [
        30,
        144,
        255,
        1
    ],
    'firebrick': [
        178,
        34,
        34,
        1
    ],
    'floralwhite': [
        255,
        250,
        240,
        1
    ],
    'forestgreen': [
        34,
        139,
        34,
        1
    ],
    'fuchsia': [
        255,
        0,
        255,
        1
    ],
    'gainsboro': [
        220,
        220,
        220,
        1
    ],
    'ghostwhite': [
        248,
        248,
        255,
        1
    ],
    'gold': [
        255,
        215,
        0,
        1
    ],
    'goldenrod': [
        218,
        165,
        32,
        1
    ],
    'gray': [
        128,
        128,
        128,
        1
    ],
    'green': [
        0,
        128,
        0,
        1
    ],
    'greenyellow': [
        173,
        255,
        47,
        1
    ],
    'grey': [
        128,
        128,
        128,
        1
    ],
    'honeydew': [
        240,
        255,
        240,
        1
    ],
    'hotpink': [
        255,
        105,
        180,
        1
    ],
    'indianred': [
        205,
        92,
        92,
        1
    ],
    'indigo': [
        75,
        0,
        130,
        1
    ],
    'ivory': [
        255,
        255,
        240,
        1
    ],
    'khaki': [
        240,
        230,
        140,
        1
    ],
    'lavender': [
        230,
        230,
        250,
        1
    ],
    'lavenderblush': [
        255,
        240,
        245,
        1
    ],
    'lawngreen': [
        124,
        252,
        0,
        1
    ],
    'lemonchiffon': [
        255,
        250,
        205,
        1
    ],
    'lightblue': [
        173,
        216,
        230,
        1
    ],
    'lightcoral': [
        240,
        128,
        128,
        1
    ],
    'lightcyan': [
        224,
        255,
        255,
        1
    ],
    'lightgoldenrodyellow': [
        250,
        250,
        210,
        1
    ],
    'lightgray': [
        211,
        211,
        211,
        1
    ],
    'lightgreen': [
        144,
        238,
        144,
        1
    ],
    'lightgrey': [
        211,
        211,
        211,
        1
    ],
    'lightpink': [
        255,
        182,
        193,
        1
    ],
    'lightsalmon': [
        255,
        160,
        122,
        1
    ],
    'lightseagreen': [
        32,
        178,
        170,
        1
    ],
    'lightskyblue': [
        135,
        206,
        250,
        1
    ],
    'lightslategray': [
        119,
        136,
        153,
        1
    ],
    'lightslategrey': [
        119,
        136,
        153,
        1
    ],
    'lightsteelblue': [
        176,
        196,
        222,
        1
    ],
    'lightyellow': [
        255,
        255,
        224,
        1
    ],
    'lime': [
        0,
        255,
        0,
        1
    ],
    'limegreen': [
        50,
        205,
        50,
        1
    ],
    'linen': [
        250,
        240,
        230,
        1
    ],
    'magenta': [
        255,
        0,
        255,
        1
    ],
    'maroon': [
        128,
        0,
        0,
        1
    ],
    'mediumaquamarine': [
        102,
        205,
        170,
        1
    ],
    'mediumblue': [
        0,
        0,
        205,
        1
    ],
    'mediumorchid': [
        186,
        85,
        211,
        1
    ],
    'mediumpurple': [
        147,
        112,
        219,
        1
    ],
    'mediumseagreen': [
        60,
        179,
        113,
        1
    ],
    'mediumslateblue': [
        123,
        104,
        238,
        1
    ],
    'mediumspringgreen': [
        0,
        250,
        154,
        1
    ],
    'mediumturquoise': [
        72,
        209,
        204,
        1
    ],
    'mediumvioletred': [
        199,
        21,
        133,
        1
    ],
    'midnightblue': [
        25,
        25,
        112,
        1
    ],
    'mintcream': [
        245,
        255,
        250,
        1
    ],
    'mistyrose': [
        255,
        228,
        225,
        1
    ],
    'moccasin': [
        255,
        228,
        181,
        1
    ],
    'navajowhite': [
        255,
        222,
        173,
        1
    ],
    'navy': [
        0,
        0,
        128,
        1
    ],
    'oldlace': [
        253,
        245,
        230,
        1
    ],
    'olive': [
        128,
        128,
        0,
        1
    ],
    'olivedrab': [
        107,
        142,
        35,
        1
    ],
    'orange': [
        255,
        165,
        0,
        1
    ],
    'orangered': [
        255,
        69,
        0,
        1
    ],
    'orchid': [
        218,
        112,
        214,
        1
    ],
    'palegoldenrod': [
        238,
        232,
        170,
        1
    ],
    'palegreen': [
        152,
        251,
        152,
        1
    ],
    'paleturquoise': [
        175,
        238,
        238,
        1
    ],
    'palevioletred': [
        219,
        112,
        147,
        1
    ],
    'papayawhip': [
        255,
        239,
        213,
        1
    ],
    'peachpuff': [
        255,
        218,
        185,
        1
    ],
    'peru': [
        205,
        133,
        63,
        1
    ],
    'pink': [
        255,
        192,
        203,
        1
    ],
    'plum': [
        221,
        160,
        221,
        1
    ],
    'powderblue': [
        176,
        224,
        230,
        1
    ],
    'purple': [
        128,
        0,
        128,
        1
    ],
    'rebeccapurple': [
        102,
        51,
        153,
        1
    ],
    'red': [
        255,
        0,
        0,
        1
    ],
    'rosybrown': [
        188,
        143,
        143,
        1
    ],
    'royalblue': [
        65,
        105,
        225,
        1
    ],
    'saddlebrown': [
        139,
        69,
        19,
        1
    ],
    'salmon': [
        250,
        128,
        114,
        1
    ],
    'sandybrown': [
        244,
        164,
        96,
        1
    ],
    'seagreen': [
        46,
        139,
        87,
        1
    ],
    'seashell': [
        255,
        245,
        238,
        1
    ],
    'sienna': [
        160,
        82,
        45,
        1
    ],
    'silver': [
        192,
        192,
        192,
        1
    ],
    'skyblue': [
        135,
        206,
        235,
        1
    ],
    'slateblue': [
        106,
        90,
        205,
        1
    ],
    'slategray': [
        112,
        128,
        144,
        1
    ],
    'slategrey': [
        112,
        128,
        144,
        1
    ],
    'snow': [
        255,
        250,
        250,
        1
    ],
    'springgreen': [
        0,
        255,
        127,
        1
    ],
    'steelblue': [
        70,
        130,
        180,
        1
    ],
    'tan': [
        210,
        180,
        140,
        1
    ],
    'teal': [
        0,
        128,
        128,
        1
    ],
    'thistle': [
        216,
        191,
        216,
        1
    ],
    'tomato': [
        255,
        99,
        71,
        1
    ],
    'turquoise': [
        64,
        224,
        208,
        1
    ],
    'violet': [
        238,
        130,
        238,
        1
    ],
    'wheat': [
        245,
        222,
        179,
        1
    ],
    'white': [
        255,
        255,
        255,
        1
    ],
    'whitesmoke': [
        245,
        245,
        245,
        1
    ],
    'yellow': [
        255,
        255,
        0,
        1
    ],
    'yellowgreen': [
        154,
        205,
        50,
        1
    ]
};
function clamp_css_byte(i) {
    // Clamp to integer 0 .. 255.
    i = Math.round(i);
    // Seems to be what Chrome does (vs truncation).
    return i < 0 ? 0 : i > 255 ? 255 : i;
}
function clamp_css_float(f) {
    // Clamp to float 0.0 .. 1.0.
    return f < 0 ? 0 : f > 1 ? 1 : f;
}
function parse_css_int(str) {
    // int or percentage.
    if (str[str.length - 1] === '%')
        return clamp_css_byte(parseFloat(str) / 100 * 255);
    return clamp_css_byte(parseInt(str));
}
function parse_css_float(str) {
    // float or percentage.
    if (str[str.length - 1] === '%')
        return clamp_css_float(parseFloat(str) / 100);
    return clamp_css_float(parseFloat(str));
}
function css_hue_to_rgb(m1, m2, h) {
    if (h < 0)
        h += 1;
    else if (h > 1)
        h -= 1;
    if (h * 6 < 1)
        return m1 + (m2 - m1) * h * 6;
    if (h * 2 < 1)
        return m2;
    if (h * 3 < 2)
        return m1 + (m2 - m1) * (2 / 3 - h) * 6;
    return m1;
}
function parseCSSColor(css_str) {
    // Remove all whitespace, not compliant, but should just be more accepting.
    var str = css_str.replace(/ /g, '').toLowerCase();
    // Color keywords (and transparent) lookup.
    if (str in kCSSColorTable)
        return kCSSColorTable[str].slice();
    // dup.
    // #abc and #abc123 syntax.
    if (str[0] === '#') {
        if (str.length === 4) {
            var iv = parseInt(str.substr(1), 16);
            // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 4095))
                return null;
            // Covers NaN.
            return [
                (iv & 3840) >> 4 | (iv & 3840) >> 8,
                iv & 240 | (iv & 240) >> 4,
                iv & 15 | (iv & 15) << 4,
                1
            ];
        } else if (str.length === 7) {
            var iv = parseInt(str.substr(1), 16);
            // TODO(deanm): Stricter parsing.
            if (!(iv >= 0 && iv <= 16777215))
                return null;
            // Covers NaN.
            return [
                (iv & 16711680) >> 16,
                (iv & 65280) >> 8,
                iv & 255,
                1
            ];
        }
        return null;
    }
    var op = str.indexOf('('), ep = str.indexOf(')');
    if (op !== -1 && ep + 1 === str.length) {
        var fname = str.substr(0, op);
        var params = str.substr(op + 1, ep - (op + 1)).split(',');
        var alpha = 1;
        // To allow case fallthrough.
        switch (fname) {
        case 'rgba':
            if (params.length !== 4)
                return null;
            alpha = parse_css_float(params.pop());
        // Fall through.
        case 'rgb':
            if (params.length !== 3)
                return null;
            return [
                parse_css_int(params[0]),
                parse_css_int(params[1]),
                parse_css_int(params[2]),
                alpha
            ];
        case 'hsla':
            if (params.length !== 4)
                return null;
            alpha = parse_css_float(params.pop());
        // Fall through.
        case 'hsl':
            if (params.length !== 3)
                return null;
            var h = (parseFloat(params[0]) % 360 + 360) % 360 / 360;
            // 0 .. 1
            // NOTE(deanm): According to the CSS spec s/l should only be
            // percentages, but we don't bother and let float or percentage.
            var s = parse_css_float(params[1]);
            var l = parse_css_float(params[2]);
            var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
            var m1 = l * 2 - m2;
            return [
                clamp_css_byte(css_hue_to_rgb(m1, m2, h + 1 / 3) * 255),
                clamp_css_byte(css_hue_to_rgb(m1, m2, h) * 255),
                clamp_css_byte(css_hue_to_rgb(m1, m2, h - 1 / 3) * 255),
                alpha
            ];
        default:
            return null;
        }
    }
    return null;
}
try {
    parseCSSColor_1 = csscolorparser.parseCSSColor = parseCSSColor;
} catch (e) {
}

//      
/**
 * An RGBA color value. Create instances from color strings using the static
 * method `Color.parse`. The constructor accepts RGB channel values in the range
 * `[0, 1]`, premultiplied by A.
 *
 * @param {number} r The red channel.
 * @param {number} g The green channel.
 * @param {number} b The blue channel.
 * @param {number} a The alpha channel.
 * @private
 */
class Color {
    constructor(r, g, b, a = 1) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    /**
     * Parses valid CSS color strings and returns a `Color` instance.
     * @returns A `Color` instance, or `undefined` if the input is not a valid color string.
     */
    static parse(input) {
        if (!input) {
            return undefined;
        }
        if (input instanceof Color) {
            return input;
        }
        if (typeof input !== 'string') {
            return undefined;
        }
        const rgba = parseCSSColor_1(input);
        if (!rgba) {
            return undefined;
        }
        return new Color(rgba[0] / 255 * rgba[3], rgba[1] / 255 * rgba[3], rgba[2] / 255 * rgba[3], rgba[3]);
    }
    /**
     * Returns an RGBA string representing the color value.
     *
     * @returns An RGBA string.
     * @example
     * var purple = new Color.parse('purple');
     * purple.toString; // = "rgba(128,0,128,1)"
     * var translucentGreen = new Color.parse('rgba(26, 207, 26, .73)');
     * translucentGreen.toString(); // = "rgba(26,207,26,0.73)"
     */
    toString() {
        const [r, g, b, a] = this.toArray();
        return `rgba(${ Math.round(r) },${ Math.round(g) },${ Math.round(b) },${ a })`;
    }
    /**
     * Returns an RGBA array of values representing the color, unpremultiplied by A.
     *
     * @returns An array of RGBA color values in the range [0, 255].
     */
    toArray() {
        const {r, g, b, a} = this;
        return a === 0 ? [
            0,
            0,
            0,
            0
        ] : [
            r * 255 / a,
            g * 255 / a,
            b * 255 / a,
            a
        ];
    }
    /**
     * Returns a RGBA array of float values representing the color, unpremultiplied by A.
     *
     * @returns An array of RGBA color values in the range [0, 1].
     */
    toArray01() {
        const {r, g, b, a} = this;
        return a === 0 ? [
            0,
            0,
            0,
            0
        ] : [
            r / a,
            g / a,
            b / a,
            a
        ];
    }
    /**
     * Returns an RGBA array of values representing the color, premultiplied by A.
     *
     * @returns An array of RGBA color values in the range [0, 1].
     */
    toArray01PremultipliedAlpha() {
        const {r, g, b, a} = this;
        return [
            r,
            g,
            b,
            a
        ];
    }
}
Color.black = new Color(0, 0, 0, 1);
Color.white = new Color(1, 1, 1, 1);
Color.transparent = new Color(0, 0, 0, 0);
Color.red = new Color(1, 0, 0, 1);
Color.blue = new Color(0, 0, 1, 1);
var Color$1 = Color;

//      
// Flow type declarations for Intl cribbed from
// https://github.com/facebook/flow/issues/1270
class Collator {
    constructor(caseSensitive, diacriticSensitive, locale) {
        if (caseSensitive)
            this.sensitivity = diacriticSensitive ? 'variant' : 'case';
        else
            this.sensitivity = diacriticSensitive ? 'accent' : 'base';
        this.locale = locale;
        this.collator = new Intl.Collator(this.locale ? this.locale : [], {
            sensitivity: this.sensitivity,
            usage: 'search'
        });
    }
    compare(lhs, rhs) {
        return this.collator.compare(lhs, rhs);
    }
    resolvedLocale() {
        // We create a Collator without "usage: search" because we don't want
        // the search options encoded in our result (e.g. "en-u-co-search")
        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
    }
}

//      
class FormattedSection {
    constructor(text, image, scale, fontStack, textColor) {
        // combine characters so that diacritic marks are not separate code points
        this.text = text.normalize ? text.normalize() : text;
        this.image = image;
        this.scale = scale;
        this.fontStack = fontStack;
        this.textColor = textColor;
    }
}
class Formatted {
    constructor(sections) {
        this.sections = sections;
    }
    static fromString(unformatted) {
        return new Formatted([new FormattedSection(unformatted, null, null, null, null)]);
    }
    isEmpty() {
        if (this.sections.length === 0)
            return true;
        return !this.sections.some(section => section.text.length !== 0 || section.image && section.image.name.length !== 0);
    }
    static factory(text) {
        if (text instanceof Formatted) {
            return text;
        } else {
            return Formatted.fromString(text);
        }
    }
    toString() {
        if (this.sections.length === 0)
            return '';
        return this.sections.map(section => section.text).join('');
    }
    serialize() {
        const serialized = ['format'];
        for (const section of this.sections) {
            if (section.image) {
                serialized.push([
                    'image',
                    section.image.name
                ]);
                continue;
            }
            serialized.push(section.text);
            const options = {};
            if (section.fontStack) {
                options['text-font'] = [
                    'literal',
                    section.fontStack.split(',')
                ];
            }
            if (section.scale) {
                options['font-scale'] = section.scale;
            }
            if (section.textColor) {
                options['text-color'] = ['rgba'].concat(section.textColor.toArray());
            }
            serialized.push(options);
        }
        return serialized;
    }
}

//      
class ResolvedImage {
    constructor(options) {
        this.name = options.name;
        this.available = options.available;
    }
    toString() {
        return this.name;
    }
    static fromString(name) {
        if (!name)
            return null;
        // treat empty values as no image
        return new ResolvedImage({
            name,
            available: false
        });
    }
    serialize() {
        return [
            'image',
            this.name
        ];
    }
}

function validateRGBA(r, g, b, a) {
    if (!(typeof r === 'number' && r >= 0 && r <= 255 && typeof g === 'number' && g >= 0 && g <= 255 && typeof b === 'number' && b >= 0 && b <= 255)) {
        const value = typeof a === 'number' ? [
            r,
            g,
            b,
            a
        ] : [
            r,
            g,
            b
        ];
        return `Invalid rgba value [${ value.join(', ') }]: 'r', 'g', and 'b' must be between 0 and 255.`;
    }
    if (!(typeof a === 'undefined' || typeof a === 'number' && a >= 0 && a <= 1)) {
        return `Invalid rgba value [${ [
            r,
            g,
            b,
            a
        ].join(', ') }]: 'a' must be between 0 and 1.`;
    }
    return null;
}
function isValue(mixed) {
    if (mixed === null) {
        return true;
    } else if (typeof mixed === 'string') {
        return true;
    } else if (typeof mixed === 'boolean') {
        return true;
    } else if (typeof mixed === 'number') {
        return true;
    } else if (mixed instanceof Color$1) {
        return true;
    } else if (mixed instanceof Collator) {
        return true;
    } else if (mixed instanceof Formatted) {
        return true;
    } else if (mixed instanceof ResolvedImage) {
        return true;
    } else if (Array.isArray(mixed)) {
        for (const item of mixed) {
            if (!isValue(item)) {
                return false;
            }
        }
        return true;
    } else if (typeof mixed === 'object') {
        for (const key in mixed) {
            if (!isValue(mixed[key])) {
                return false;
            }
        }
        return true;
    } else {
        return false;
    }
}
function typeOf(value) {
    if (value === null) {
        return NullType;
    } else if (typeof value === 'string') {
        return StringType;
    } else if (typeof value === 'boolean') {
        return BooleanType;
    } else if (typeof value === 'number') {
        return NumberType;
    } else if (value instanceof Color$1) {
        return ColorType;
    } else if (value instanceof Collator) {
        return CollatorType;
    } else if (value instanceof Formatted) {
        return FormattedType;
    } else if (value instanceof ResolvedImage) {
        return ResolvedImageType;
    } else if (Array.isArray(value)) {
        const length = value.length;
        let itemType;
        for (const item of value) {
            const t = typeOf(item);
            if (!itemType) {
                itemType = t;
            } else if (itemType === t) {
                continue;
            } else {
                itemType = ValueType;
                break;
            }
        }
        return array$1(itemType || ValueType, length);
    } else {
        return ObjectType;
    }
}
function toString(value) {
    const type = typeof value;
    if (value === null) {
        return '';
    } else if (type === 'string' || type === 'number' || type === 'boolean') {
        return String(value);
    } else if (value instanceof Color$1 || value instanceof Formatted || value instanceof ResolvedImage) {
        return value.toString();
    } else {
        return JSON.stringify(value);
    }
}

class Literal {
    constructor(type, value) {
        this.type = type;
        this.value = value;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`'literal' expression requires exactly one argument, but found ${ args.length - 1 } instead.`);
        if (!isValue(args[1]))
            return context.error(`invalid value`);
        const value = args[1];
        let type = typeOf(value);
        // special case: infer the item type if possible for zero-length arrays
        const expected = context.expectedType;
        if (type.kind === 'array' && type.N === 0 && expected && expected.kind === 'array' && (typeof expected.N !== 'number' || expected.N === 0)) {
            type = expected;
        }
        return new Literal(type, value);
    }
    evaluate() {
        return this.value;
    }
    eachChild() {
    }
    outputDefined() {
        return true;
    }
    serialize() {
        if (this.type.kind === 'array' || this.type.kind === 'object') {
            return [
                'literal',
                this.value
            ];
        } else if (this.value instanceof Color$1) {
            // Constant-folding can generate Literal expressions that you
            // couldn't actually generate with a "literal" expression,
            // so we have to implement an equivalent serialization here
            return ['rgba'].concat(this.value.toArray());
        } else if (this.value instanceof Formatted) {
            // Same as Color
            return this.value.serialize();
        } else {
            return this.value;
        }
    }
}
var Literal$1 = Literal;

//      
class RuntimeError {
    constructor(message) {
        this.name = 'ExpressionEvaluationError';
        this.message = message;
    }
    toJSON() {
        return this.message;
    }
}
var RuntimeError$1 = RuntimeError;

const types$1 = {
    string: StringType,
    number: NumberType,
    boolean: BooleanType,
    object: ObjectType
};
class Assertion {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2)
            return context.error(`Expected at least one argument.`);
        let i = 1;
        let type;
        const name = args[0];
        if (name === 'array') {
            let itemType;
            if (args.length > 2) {
                const type = args[1];
                if (typeof type !== 'string' || !(type in types$1) || type === 'object')
                    return context.error('The item type argument of "array" must be one of string, number, boolean', 1);
                itemType = types$1[type];
                i++;
            } else {
                itemType = ValueType;
            }
            let N;
            if (args.length > 3) {
                if (args[2] !== null && (typeof args[2] !== 'number' || args[2] < 0 || args[2] !== Math.floor(args[2]))) {
                    return context.error('The length argument to "array" must be a positive integer literal', 2);
                }
                N = args[2];
                i++;
            }
            type = array$1(itemType, N);
        } else {
            type = types$1[name];
        }
        const parsed = [];
        for (; i < args.length; i++) {
            const input = context.parse(args[i], i, ValueType);
            if (!input)
                return null;
            parsed.push(input);
        }
        return new Assertion(type, parsed);
    }
    evaluate(ctx) {
        for (let i = 0; i < this.args.length; i++) {
            const value = this.args[i].evaluate(ctx);
            const error = checkSubtype(this.type, typeOf(value));
            if (!error) {
                return value;
            } else if (i === this.args.length - 1) {
                throw new RuntimeError$1(`Expected value to be of type ${ toString$1(this.type) }, but found ${ toString$1(typeOf(value)) } instead.`);
            }
        }
        return null;
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
    serialize() {
        const type = this.type;
        const serialized = [type.kind];
        if (type.kind === 'array') {
            const itemType = type.itemType;
            if (itemType.kind === 'string' || itemType.kind === 'number' || itemType.kind === 'boolean') {
                serialized.push(itemType.kind);
                const N = type.N;
                if (typeof N === 'number' || this.args.length > 1) {
                    serialized.push(N);
                }
            }
        }
        return serialized.concat(this.args.map(arg => arg.serialize()));
    }
}
var Assertion$1 = Assertion;

//      
class FormatExpression {
    constructor(sections) {
        this.type = FormattedType;
        this.sections = sections;
    }
    static parse(args, context) {
        if (args.length < 2) {
            return context.error(`Expected at least one argument.`);
        }
        const firstArg = args[1];
        if (!Array.isArray(firstArg) && typeof firstArg === 'object') {
            return context.error(`First argument must be an image or text section.`);
        }
        const sections = [];
        let nextTokenMayBeObject = false;
        for (let i = 1; i <= args.length - 1; ++i) {
            const arg = args[i];
            if (nextTokenMayBeObject && typeof arg === 'object' && !Array.isArray(arg)) {
                nextTokenMayBeObject = false;
                let scale = null;
                if (arg['font-scale']) {
                    scale = context.parse(arg['font-scale'], 1, NumberType);
                    if (!scale)
                        return null;
                }
                let font = null;
                if (arg['text-font']) {
                    font = context.parse(arg['text-font'], 1, array$1(StringType));
                    if (!font)
                        return null;
                }
                let textColor = null;
                if (arg['text-color']) {
                    textColor = context.parse(arg['text-color'], 1, ColorType);
                    if (!textColor)
                        return null;
                }
                const lastExpression = sections[sections.length - 1];
                lastExpression.scale = scale;
                lastExpression.font = font;
                lastExpression.textColor = textColor;
            } else {
                const content = context.parse(args[i], 1, ValueType);
                if (!content)
                    return null;
                const kind = content.type.kind;
                if (kind !== 'string' && kind !== 'value' && kind !== 'null' && kind !== 'resolvedImage')
                    return context.error(`Formatted text type must be 'string', 'value', 'image' or 'null'.`);
                nextTokenMayBeObject = true;
                sections.push({
                    content,
                    scale: null,
                    font: null,
                    textColor: null
                });
            }
        }
        return new FormatExpression(sections);
    }
    evaluate(ctx) {
        const evaluateSection = section => {
            const evaluatedContent = section.content.evaluate(ctx);
            if (typeOf(evaluatedContent) === ResolvedImageType) {
                return new FormattedSection('', evaluatedContent, null, null, null);
            }
            return new FormattedSection(toString(evaluatedContent), null, section.scale ? section.scale.evaluate(ctx) : null, section.font ? section.font.evaluate(ctx).join(',') : null, section.textColor ? section.textColor.evaluate(ctx) : null);
        };
        return new Formatted(this.sections.map(evaluateSection));
    }
    eachChild(fn) {
        for (const section of this.sections) {
            fn(section.content);
            if (section.scale) {
                fn(section.scale);
            }
            if (section.font) {
                fn(section.font);
            }
            if (section.textColor) {
                fn(section.textColor);
            }
        }
    }
    outputDefined() {
        // Technically the combinatoric set of all children
        // Usually, this.text will be undefined anyway
        return false;
    }
    serialize() {
        const serialized = ['format'];
        for (const section of this.sections) {
            serialized.push(section.content.serialize());
            const options = {};
            if (section.scale) {
                options['font-scale'] = section.scale.serialize();
            }
            if (section.font) {
                options['text-font'] = section.font.serialize();
            }
            if (section.textColor) {
                options['text-color'] = section.textColor.serialize();
            }
            serialized.push(options);
        }
        return serialized;
    }
}

//      
class ImageExpression {
    constructor(input) {
        this.type = ResolvedImageType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2) {
            return context.error(`Expected two arguments.`);
        }
        const name = context.parse(args[1], 1, StringType);
        if (!name)
            return context.error(`No image name provided.`);
        return new ImageExpression(name);
    }
    evaluate(ctx) {
        const evaluatedImageName = this.input.evaluate(ctx);
        const value = ResolvedImage.fromString(evaluatedImageName);
        if (value && ctx.availableImages)
            value.available = ctx.availableImages.indexOf(evaluatedImageName) > -1;
        return value;
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        // The output of image is determined by the list of available images in the evaluation context
        return false;
    }
    serialize() {
        return [
            'image',
            this.input.serialize()
        ];
    }
}

const types = {
    'to-boolean': BooleanType,
    'to-color': ColorType,
    'to-number': NumberType,
    'to-string': StringType
};
/**
 * Special form for error-coalescing coercion expressions "to-number",
 * "to-color".  Since these coercions can fail at runtime, they accept multiple
 * arguments, only evaluating one at a time until one succeeds.
 *
 * @private
 */
class Coercion {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2)
            return context.error(`Expected at least one argument.`);
        const name = args[0];
        if ((name === 'to-boolean' || name === 'to-string') && args.length !== 2)
            return context.error(`Expected one argument.`);
        const type = types[name];
        const parsed = [];
        for (let i = 1; i < args.length; i++) {
            const input = context.parse(args[i], i, ValueType);
            if (!input)
                return null;
            parsed.push(input);
        }
        return new Coercion(type, parsed);
    }
    evaluate(ctx) {
        if (this.type.kind === 'boolean') {
            return Boolean(this.args[0].evaluate(ctx));
        } else if (this.type.kind === 'color') {
            let input;
            let error;
            for (const arg of this.args) {
                input = arg.evaluate(ctx);
                error = null;
                if (input instanceof Color$1) {
                    return input;
                } else if (typeof input === 'string') {
                    const c = ctx.parseColor(input);
                    if (c)
                        return c;
                } else if (Array.isArray(input)) {
                    if (input.length < 3 || input.length > 4) {
                        error = `Invalid rbga value ${ JSON.stringify(input) }: expected an array containing either three or four numeric values.`;
                    } else {
                        error = validateRGBA(input[0], input[1], input[2], input[3]);
                    }
                    if (!error) {
                        return new Color$1(input[0] / 255, input[1] / 255, input[2] / 255, input[3]);
                    }
                }
            }
            throw new RuntimeError$1(error || `Could not parse color from value '${ typeof input === 'string' ? input : String(JSON.stringify(input)) }'`);
        } else if (this.type.kind === 'number') {
            let value = null;
            for (const arg of this.args) {
                value = arg.evaluate(ctx);
                if (value === null)
                    return 0;
                const num = Number(value);
                if (isNaN(num))
                    continue;
                return num;
            }
            throw new RuntimeError$1(`Could not convert ${ JSON.stringify(value) } to number.`);
        } else if (this.type.kind === 'formatted') {
            // There is no explicit 'to-formatted' but this coercion can be implicitly
            // created by properties that expect the 'formatted' type.
            return Formatted.fromString(toString(this.args[0].evaluate(ctx)));
        } else if (this.type.kind === 'resolvedImage') {
            return ResolvedImage.fromString(toString(this.args[0].evaluate(ctx)));
        } else {
            return toString(this.args[0].evaluate(ctx));
        }
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
    serialize() {
        if (this.type.kind === 'formatted') {
            return new FormatExpression([{
                    content: this.args[0],
                    scale: null,
                    font: null,
                    textColor: null
                }]).serialize();
        }
        if (this.type.kind === 'resolvedImage') {
            return new ImageExpression(this.args[0]).serialize();
        }
        const serialized = [`to-${ this.type.kind }`];
        this.eachChild(child => {
            serialized.push(child.serialize());
        });
        return serialized;
    }
}
var Coercion$1 = Coercion;

//      
const geometryTypes = [
    'Unknown',
    'Point',
    'LineString',
    'Polygon'
];
class EvaluationContext {
    constructor() {
        this.globals = null;
        this.feature = null;
        this.featureState = null;
        this.formattedSection = null;
        this._parseColorCache = {};
        this.availableImages = null;
        this.canonical = null;
        this.featureTileCoord = null;
        this.featureDistanceData = null;
    }
    id() {
        return this.feature && this.feature.id !== undefined ? this.feature.id : null;
    }
    geometryType() {
        return this.feature ? typeof this.feature.type === 'number' ? geometryTypes[this.feature.type] : this.feature.type : null;
    }
    geometry() {
        return this.feature && 'geometry' in this.feature ? this.feature.geometry : null;
    }
    canonicalID() {
        return this.canonical;
    }
    properties() {
        return this.feature && this.feature.properties || {};
    }
    distanceFromCenter() {
        if (this.featureTileCoord && this.featureDistanceData) {
            const c = this.featureDistanceData.center;
            const scale = this.featureDistanceData.scale;
            const {x, y} = this.featureTileCoord;
            // Calculate the distance vector `d` (left handed)
            const dX = x * scale - c[0];
            const dY = y * scale - c[1];
            // The bearing vector `b` (left handed)
            const bX = this.featureDistanceData.bearing[0];
            const bY = this.featureDistanceData.bearing[1];
            // Distance is calculated as `dot(d, v)`
            const dist = bX * dX + bY * dY;
            return dist;
        }
        return 0;
    }
    parseColor(input) {
        let cached = this._parseColorCache[input];
        if (!cached) {
            cached = this._parseColorCache[input] = Color$1.parse(input);
        }
        return cached;
    }
}
var EvaluationContext$1 = EvaluationContext;

//      
class CompoundExpression {
    constructor(name, type, evaluate, args) {
        this.name = name;
        this.type = type;
        this._evaluate = evaluate;
        this.args = args;
    }
    evaluate(ctx) {
        return this._evaluate(ctx, this.args);
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return false;
    }
    serialize() {
        return [this.name].concat(this.args.map(arg => arg.serialize()));
    }
    static parse(args, context) {
        const op = args[0];
        const definition = CompoundExpression.definitions[op];
        if (!definition) {
            return context.error(`Unknown expression "${ op }". If you wanted a literal array, use ["literal", [...]].`, 0);
        }
        // Now check argument types against each signature
        const type = Array.isArray(definition) ? definition[0] : definition.type;
        const availableOverloads = Array.isArray(definition) ? [[
                definition[1],
                definition[2]
            ]] : definition.overloads;
        const overloads = availableOverloads.filter(([signature]) => !Array.isArray(signature) || // varags
        signature.length === args.length - 1    // correct param count
);
        let signatureContext = null;
        for (const [params, evaluate] of overloads) {
            // Use a fresh context for each attempted signature so that, if
            // we eventually succeed, we haven't polluted `context.errors`.
            signatureContext = new ParsingContext$1(context.registry, context.path, null, context.scope);
            // First parse all the args, potentially coercing to the
            // types expected by this overload.
            const parsedArgs = [];
            let argParseFailed = false;
            for (let i = 1; i < args.length; i++) {
                const arg = args[i];
                const expectedType = Array.isArray(params) ? params[i - 1] : params.type;
                const parsed = signatureContext.parse(arg, 1 + parsedArgs.length, expectedType);
                if (!parsed) {
                    argParseFailed = true;
                    break;
                }
                parsedArgs.push(parsed);
            }
            if (argParseFailed) {
                // Couldn't coerce args of this overload to expected type, move
                // on to next one.
                continue;
            }
            if (Array.isArray(params)) {
                if (params.length !== parsedArgs.length) {
                    signatureContext.error(`Expected ${ params.length } arguments, but found ${ parsedArgs.length } instead.`);
                    continue;
                }
            }
            for (let i = 0; i < parsedArgs.length; i++) {
                const expected = Array.isArray(params) ? params[i] : params.type;
                const arg = parsedArgs[i];
                signatureContext.concat(i + 1).checkSubtype(expected, arg.type);
            }
            if (signatureContext.errors.length === 0) {
                return new CompoundExpression(op, type, evaluate, parsedArgs);
            }
        }
        if (overloads.length === 1) {
            context.errors.push(...signatureContext.errors);
        } else {
            const expected = overloads.length ? overloads : availableOverloads;
            const signatures = expected.map(([params]) => stringifySignature(params)).join(' | ');
            const actualTypes = [];
            // For error message, re-parse arguments without trying to
            // apply any coercions
            for (let i = 1; i < args.length; i++) {
                const parsed = context.parse(args[i], 1 + actualTypes.length);
                if (!parsed)
                    return null;
                actualTypes.push(toString$1(parsed.type));
            }
            context.error(`Expected arguments of type ${ signatures }, but found (${ actualTypes.join(', ') }) instead.`);
        }
        return null;
    }
    static register(registry, definitions) {
        CompoundExpression.definitions = definitions;
        for (const name in definitions) {
            registry[name] = CompoundExpression;
        }
    }
}
function stringifySignature(signature) {
    if (Array.isArray(signature)) {
        return `(${ signature.map(toString$1).join(', ') })`;
    } else {
        return `(${ toString$1(signature.type) }...)`;
    }
}
var CompoundExpression$1 = CompoundExpression;

//      
class CollatorExpression {
    constructor(caseSensitive, diacriticSensitive, locale) {
        this.type = CollatorType;
        this.locale = locale;
        this.caseSensitive = caseSensitive;
        this.diacriticSensitive = diacriticSensitive;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`Expected one argument.`);
        const options = args[1];
        if (typeof options !== 'object' || Array.isArray(options))
            return context.error(`Collator options argument must be an object.`);
        const caseSensitive = context.parse(options['case-sensitive'] === undefined ? false : options['case-sensitive'], 1, BooleanType);
        if (!caseSensitive)
            return null;
        const diacriticSensitive = context.parse(options['diacritic-sensitive'] === undefined ? false : options['diacritic-sensitive'], 1, BooleanType);
        if (!diacriticSensitive)
            return null;
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, StringType);
            if (!locale)
                return null;
        }
        return new CollatorExpression(caseSensitive, diacriticSensitive, locale);
    }
    evaluate(ctx) {
        return new Collator(this.caseSensitive.evaluate(ctx), this.diacriticSensitive.evaluate(ctx), this.locale ? this.locale.evaluate(ctx) : null);
    }
    eachChild(fn) {
        fn(this.caseSensitive);
        fn(this.diacriticSensitive);
        if (this.locale) {
            fn(this.locale);
        }
    }
    outputDefined() {
        // Technically the set of possible outputs is the combinatoric set of Collators produced
        // by all possible outputs of locale/caseSensitive/diacriticSensitive
        // But for the primary use of Collators in comparison operators, we ignore the Collator's
        // possible outputs anyway, so we can get away with leaving this false for now.
        return false;
    }
    serialize() {
        const options = {};
        options['case-sensitive'] = this.caseSensitive.serialize();
        options['diacritic-sensitive'] = this.diacriticSensitive.serialize();
        if (this.locale) {
            options['locale'] = this.locale.serialize();
        }
        return [
            'collator',
            options
        ];
    }
}

//      
// minX, minY, maxX, maxY
const EXTENT = 8192;
function updateBBox(bbox, coord) {
    bbox[0] = Math.min(bbox[0], coord[0]);
    bbox[1] = Math.min(bbox[1], coord[1]);
    bbox[2] = Math.max(bbox[2], coord[0]);
    bbox[3] = Math.max(bbox[3], coord[1]);
}
function mercatorXfromLng(lng) {
    return (180 + lng) / 360;
}
function mercatorYfromLat(lat) {
    return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + lat * Math.PI / 360))) / 360;
}
function boxWithinBox(bbox1, bbox2) {
    if (bbox1[0] <= bbox2[0])
        return false;
    if (bbox1[2] >= bbox2[2])
        return false;
    if (bbox1[1] <= bbox2[1])
        return false;
    if (bbox1[3] >= bbox2[3])
        return false;
    return true;
}
function getTileCoordinates(p, canonical) {
    const x = mercatorXfromLng(p[0]);
    const y = mercatorYfromLat(p[1]);
    const tilesAtZoom = Math.pow(2, canonical.z);
    return [
        Math.round(x * tilesAtZoom * EXTENT),
        Math.round(y * tilesAtZoom * EXTENT)
    ];
}
function onBoundary(p, p1, p2) {
    const x1 = p[0] - p1[0];
    const y1 = p[1] - p1[1];
    const x2 = p[0] - p2[0];
    const y2 = p[1] - p2[1];
    return x1 * y2 - x2 * y1 === 0 && x1 * x2 <= 0 && y1 * y2 <= 0;
}
function rayIntersect(p, p1, p2) {
    return p1[1] > p[1] !== p2[1] > p[1] && p[0] < (p2[0] - p1[0]) * (p[1] - p1[1]) / (p2[1] - p1[1]) + p1[0];
}
// ray casting algorithm for detecting if point is in polygon
function pointWithinPolygon(point, rings) {
    let inside = false;
    for (let i = 0, len = rings.length; i < len; i++) {
        const ring = rings[i];
        for (let j = 0, len2 = ring.length; j < len2 - 1; j++) {
            if (onBoundary(point, ring[j], ring[j + 1]))
                return false;
            if (rayIntersect(point, ring[j], ring[j + 1]))
                inside = !inside;
        }
    }
    return inside;
}
function pointWithinPolygons(point, polygons) {
    for (let i = 0; i < polygons.length; i++) {
        if (pointWithinPolygon(point, polygons[i]))
            return true;
    }
    return false;
}
function perp(v1, v2) {
    return v1[0] * v2[1] - v1[1] * v2[0];
}
// check if p1 and p2 are in different sides of line segment q1->q2
function twoSided(p1, p2, q1, q2) {
    // q1->p1 (x1, y1), q1->p2 (x2, y2), q1->q2 (x3, y3)
    const x1 = p1[0] - q1[0];
    const y1 = p1[1] - q1[1];
    const x2 = p2[0] - q1[0];
    const y2 = p2[1] - q1[1];
    const x3 = q2[0] - q1[0];
    const y3 = q2[1] - q1[1];
    const det1 = x1 * y3 - x3 * y1;
    const det2 = x2 * y3 - x3 * y2;
    if (det1 > 0 && det2 < 0 || det1 < 0 && det2 > 0)
        return true;
    return false;
}
// a, b are end points for line segment1, c and d are end points for line segment2
function lineIntersectLine(a, b, c, d) {
    // check if two segments are parallel or not
    // precondition is end point a, b is inside polygon, if line a->b is
    // parallel to polygon edge c->d, then a->b won't intersect with c->d
    const vectorP = [
        b[0] - a[0],
        b[1] - a[1]
    ];
    const vectorQ = [
        d[0] - c[0],
        d[1] - c[1]
    ];
    if (perp(vectorQ, vectorP) === 0)
        return false;
    // If lines are intersecting with each other, the relative location should be:
    // a and b lie in different sides of segment c->d
    // c and d lie in different sides of segment a->b
    if (twoSided(a, b, c, d) && twoSided(c, d, a, b))
        return true;
    return false;
}
function lineIntersectPolygon(p1, p2, polygon) {
    for (const ring of polygon) {
        // loop through every edge of the ring
        for (let j = 0; j < ring.length - 1; ++j) {
            if (lineIntersectLine(p1, p2, ring[j], ring[j + 1])) {
                return true;
            }
        }
    }
    return false;
}
function lineStringWithinPolygon(line, polygon) {
    // First, check if geometry points of line segments are all inside polygon
    for (let i = 0; i < line.length; ++i) {
        if (!pointWithinPolygon(line[i], polygon)) {
            return false;
        }
    }
    // Second, check if there is line segment intersecting polygon edge
    for (let i = 0; i < line.length - 1; ++i) {
        if (lineIntersectPolygon(line[i], line[i + 1], polygon)) {
            return false;
        }
    }
    return true;
}
function lineStringWithinPolygons(line, polygons) {
    for (let i = 0; i < polygons.length; i++) {
        if (lineStringWithinPolygon(line, polygons[i]))
            return true;
    }
    return false;
}
function getTilePolygon(coordinates, bbox, canonical) {
    const polygon = [];
    for (let i = 0; i < coordinates.length; i++) {
        const ring = [];
        for (let j = 0; j < coordinates[i].length; j++) {
            const coord = getTileCoordinates(coordinates[i][j], canonical);
            updateBBox(bbox, coord);
            ring.push(coord);
        }
        polygon.push(ring);
    }
    return polygon;
}
function getTilePolygons(coordinates, bbox, canonical) {
    const polygons = [];
    for (let i = 0; i < coordinates.length; i++) {
        const polygon = getTilePolygon(coordinates[i], bbox, canonical);
        polygons.push(polygon);
    }
    return polygons;
}
function updatePoint(p, bbox, polyBBox, worldSize) {
    if (p[0] < polyBBox[0] || p[0] > polyBBox[2]) {
        const halfWorldSize = worldSize * 0.5;
        let shift = p[0] - polyBBox[0] > halfWorldSize ? -worldSize : polyBBox[0] - p[0] > halfWorldSize ? worldSize : 0;
        if (shift === 0) {
            shift = p[0] - polyBBox[2] > halfWorldSize ? -worldSize : polyBBox[2] - p[0] > halfWorldSize ? worldSize : 0;
        }
        p[0] += shift;
    }
    updateBBox(bbox, p);
}
function resetBBox(bbox) {
    bbox[0] = bbox[1] = Infinity;
    bbox[2] = bbox[3] = -Infinity;
}
function getTilePoints(geometry, pointBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * EXTENT;
    const shifts = [
        canonical.x * EXTENT,
        canonical.y * EXTENT
    ];
    const tilePoints = [];
    if (!geometry)
        return tilePoints;
    for (const points of geometry) {
        for (const point of points) {
            const p = [
                point.x + shifts[0],
                point.y + shifts[1]
            ];
            updatePoint(p, pointBBox, polyBBox, worldSize);
            tilePoints.push(p);
        }
    }
    return tilePoints;
}
function getTileLines(geometry, lineBBox, polyBBox, canonical) {
    const worldSize = Math.pow(2, canonical.z) * EXTENT;
    const shifts = [
        canonical.x * EXTENT,
        canonical.y * EXTENT
    ];
    const tileLines = [];
    if (!geometry)
        return tileLines;
    for (const line of geometry) {
        const tileLine = [];
        for (const point of line) {
            const p = [
                point.x + shifts[0],
                point.y + shifts[1]
            ];
            updateBBox(lineBBox, p);
            tileLine.push(p);
        }
        tileLines.push(tileLine);
    }
    if (lineBBox[2] - lineBBox[0] <= worldSize / 2) {
        resetBBox(lineBBox);
        for (const line of tileLines) {
            for (const p of line) {
                updatePoint(p, lineBBox, polyBBox, worldSize);
            }
        }
    }
    return tileLines;
}
function pointsWithinPolygons(ctx, polygonGeometry) {
    const pointBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const canonical = ctx.canonicalID();
    if (!canonical) {
        return false;
    }
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox))
            return false;
        for (const point of tilePoints) {
            if (!pointWithinPolygon(point, tilePolygon))
                return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tilePoints = getTilePoints(ctx.geometry(), pointBBox, polyBBox, canonical);
        if (!boxWithinBox(pointBBox, polyBBox))
            return false;
        for (const point of tilePoints) {
            if (!pointWithinPolygons(point, tilePolygons))
                return false;
        }
    }
    return true;
}
function linesWithinPolygons(ctx, polygonGeometry) {
    const lineBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const polyBBox = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    const canonical = ctx.canonicalID();
    if (!canonical) {
        return false;
    }
    if (polygonGeometry.type === 'Polygon') {
        const tilePolygon = getTilePolygon(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox))
            return false;
        for (const line of tileLines) {
            if (!lineStringWithinPolygon(line, tilePolygon))
                return false;
        }
    }
    if (polygonGeometry.type === 'MultiPolygon') {
        const tilePolygons = getTilePolygons(polygonGeometry.coordinates, polyBBox, canonical);
        const tileLines = getTileLines(ctx.geometry(), lineBBox, polyBBox, canonical);
        if (!boxWithinBox(lineBBox, polyBBox))
            return false;
        for (const line of tileLines) {
            if (!lineStringWithinPolygons(line, tilePolygons))
                return false;
        }
    }
    return true;
}
class Within {
    constructor(geojson, geometries) {
        this.type = BooleanType;
        this.geojson = geojson;
        this.geometries = geometries;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`'within' expression requires exactly one argument, but found ${ args.length - 1 } instead.`);
        if (isValue(args[1])) {
            const geojson = args[1];
            if (geojson.type === 'FeatureCollection') {
                for (let i = 0; i < geojson.features.length; ++i) {
                    const type = geojson.features[i].geometry.type;
                    if (type === 'Polygon' || type === 'MultiPolygon') {
                        return new Within(geojson, geojson.features[i].geometry);
                    }
                }
            } else if (geojson.type === 'Feature') {
                const type = geojson.geometry.type;
                if (type === 'Polygon' || type === 'MultiPolygon') {
                    return new Within(geojson, geojson.geometry);
                }
            } else if (geojson.type === 'Polygon' || geojson.type === 'MultiPolygon') {
                return new Within(geojson, geojson);
            }
        }
        return context.error(`'within' expression requires valid geojson object that contains polygon geometry type.`);
    }
    evaluate(ctx) {
        if (ctx.geometry() != null && ctx.canonicalID() != null) {
            if (ctx.geometryType() === 'Point') {
                return pointsWithinPolygons(ctx, this.geometries);
            } else if (ctx.geometryType() === 'LineString') {
                return linesWithinPolygons(ctx, this.geometries);
            }
        }
        return false;
    }
    eachChild() {
    }
    outputDefined() {
        return true;
    }
    serialize() {
        return [
            'within',
            this.geojson
        ];
    }
}
var Within$1 = Within;

//      
function isFeatureConstant(e) {
    if (e instanceof CompoundExpression$1) {
        if (e.name === 'get' && e.args.length === 1) {
            return false;
        } else if (e.name === 'feature-state') {
            return false;
        } else if (e.name === 'has' && e.args.length === 1) {
            return false;
        } else if (e.name === 'properties' || e.name === 'geometry-type' || e.name === 'id') {
            return false;
        } else if (/^filter-/.test(e.name)) {
            return false;
        }
    }
    if (e instanceof Within$1) {
        return false;
    }
    let result = true;
    e.eachChild(arg => {
        if (result && !isFeatureConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isStateConstant(e) {
    if (e instanceof CompoundExpression$1) {
        if (e.name === 'feature-state') {
            return false;
        }
    }
    let result = true;
    e.eachChild(arg => {
        if (result && !isStateConstant(arg)) {
            result = false;
        }
    });
    return result;
}
function isGlobalPropertyConstant(e, properties) {
    if (e instanceof CompoundExpression$1 && properties.indexOf(e.name) >= 0) {
        return false;
    }
    let result = true;
    e.eachChild(arg => {
        if (result && !isGlobalPropertyConstant(arg, properties)) {
            result = false;
        }
    });
    return result;
}

//      
class Var {
    constructor(name, boundExpression) {
        this.type = boundExpression.type;
        this.name = name;
        this.boundExpression = boundExpression;
    }
    static parse(args, context) {
        if (args.length !== 2 || typeof args[1] !== 'string')
            return context.error(`'var' expression requires exactly one string literal argument.`);
        const name = args[1];
        if (!context.scope.has(name)) {
            return context.error(`Unknown variable "${ name }". Make sure "${ name }" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        return new Var(name, context.scope.get(name));
    }
    evaluate(ctx) {
        return this.boundExpression.evaluate(ctx);
    }
    eachChild() {
    }
    outputDefined() {
        return false;
    }
    serialize() {
        return [
            'var',
            this.name
        ];
    }
}
var Var$1 = Var;

//      
/**
 * State associated parsing at a given point in an expression tree.
 * @private
 */
class ParsingContext {
    // The expected type of this expression. Provided only to allow Expression
    // implementations to infer argument types: Expression#parse() need not
    // check that the output type of the parsed expression matches
    // `expectedType`.
    constructor(registry, path = [], expectedType, scope = new Scope$1(), errors = []) {
        this.registry = registry;
        this.path = path;
        this.key = path.map(part => `[${ part }]`).join('');
        this.scope = scope;
        this.errors = errors;
        this.expectedType = expectedType;
    }
    /**
     * @param expr the JSON expression to parse
     * @param index the optional argument index if this expression is an argument of a parent expression that's being parsed
     * @param options
     * @param options.omitTypeAnnotations set true to omit inferred type annotations.  Caller beware: with this option set, the parsed expression's type will NOT satisfy `expectedType` if it would normally be wrapped in an inferred annotation.
     * @private
     */
    parse(expr, index, expectedType, bindings, options = {}) {
        if (index) {
            return this.concat(index, expectedType, bindings)._parse(expr, options);
        }
        return this._parse(expr, options);
    }
    _parse(expr, options) {
        if (expr === null || typeof expr === 'string' || typeof expr === 'boolean' || typeof expr === 'number') {
            expr = [
                'literal',
                expr
            ];
        }
        function annotate(parsed, type, typeAnnotation) {
            if (typeAnnotation === 'assert') {
                return new Assertion$1(type, [parsed]);
            } else if (typeAnnotation === 'coerce') {
                return new Coercion$1(type, [parsed]);
            } else {
                return parsed;
            }
        }
        if (Array.isArray(expr)) {
            if (expr.length === 0) {
                return this.error(`Expected an array with at least one element. If you wanted a literal array, use ["literal", []].`);
            }
            const op = expr[0];
            if (typeof op !== 'string') {
                this.error(`Expression name must be a string, but found ${ typeof op } instead. If you wanted a literal array, use ["literal", [...]].`, 0);
                return null;
            }
            const Expr = this.registry[op];
            if (Expr) {
                let parsed = Expr.parse(expr, this);
                if (!parsed)
                    return null;
                if (this.expectedType) {
                    const expected = this.expectedType;
                    const actual = parsed.type;
                    // When we expect a number, string, boolean, or array but have a value, wrap it in an assertion.
                    // When we expect a color or formatted string, but have a string or value, wrap it in a coercion.
                    // Otherwise, we do static type-checking.
                    //
                    // These behaviors are overridable for:
                    //   * The "coalesce" operator, which needs to omit type annotations.
                    //   * String-valued properties (e.g. `text-field`), where coercion is more convenient than assertion.
                    //
                    if ((expected.kind === 'string' || expected.kind === 'number' || expected.kind === 'boolean' || expected.kind === 'object' || expected.kind === 'array') && actual.kind === 'value') {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'assert');
                    } else if ((expected.kind === 'color' || expected.kind === 'formatted' || expected.kind === 'resolvedImage') && (actual.kind === 'value' || actual.kind === 'string')) {
                        parsed = annotate(parsed, expected, options.typeAnnotation || 'coerce');
                    } else if (this.checkSubtype(expected, actual)) {
                        return null;
                    }
                }
                // If an expression's arguments are all literals, we can evaluate
                // it immediately and replace it with a literal value in the
                // parsed/compiled result. Expressions that expect an image should
                // not be resolved here so we can later get the available images.
                if (!(parsed instanceof Literal$1) && parsed.type.kind !== 'resolvedImage' && isConstant(parsed)) {
                    const ec = new EvaluationContext$1();
                    try {
                        parsed = new Literal$1(parsed.type, parsed.evaluate(ec));
                    } catch (e) {
                        this.error(e.message);
                        return null;
                    }
                }
                return parsed;
            }
            return this.error(`Unknown expression "${ op }". If you wanted a literal array, use ["literal", [...]].`, 0);
        } else if (typeof expr === 'undefined') {
            return this.error(`'undefined' value invalid. Use null instead.`);
        } else if (typeof expr === 'object') {
            return this.error(`Bare objects invalid. Use ["literal", {...}] instead.`);
        } else {
            return this.error(`Expected an array, but found ${ typeof expr } instead.`);
        }
    }
    /**
     * Returns a copy of this context suitable for parsing the subexpression at
     * index `index`, optionally appending to 'let' binding map.
     *
     * Note that `errors` property, intended for collecting errors while
     * parsing, is copied by reference rather than cloned.
     * @private
     */
    concat(index, expectedType, bindings) {
        const path = typeof index === 'number' ? this.path.concat(index) : this.path;
        const scope = bindings ? this.scope.concat(bindings) : this.scope;
        return new ParsingContext(this.registry, path, expectedType || null, scope, this.errors);
    }
    /**
     * Push a parsing (or type checking) error into the `this.errors`
     * @param error The message
     * @param keys Optionally specify the source of the error at a child
     * of the current expression at `this.key`.
     * @private
     */
    error(error, ...keys) {
        const key = `${ this.key }${ keys.map(k => `[${ k }]`).join('') }`;
        this.errors.push(new ParsingError$2(key, error));
    }
    /**
     * Returns null if `t` is a subtype of `expected`; otherwise returns an
     * error message and also pushes it to `this.errors`.
     */
    checkSubtype(expected, t) {
        const error = checkSubtype(expected, t);
        if (error)
            this.error(error);
        return error;
    }
}
var ParsingContext$1 = ParsingContext;
function isConstant(expression) {
    if (expression instanceof Var$1) {
        return isConstant(expression.boundExpression);
    } else if (expression instanceof CompoundExpression$1 && expression.name === 'error') {
        return false;
    } else if (expression instanceof CollatorExpression) {
        // Although the results of a Collator expression with fixed arguments
        // generally shouldn't change between executions, we can't serialize them
        // as constant expressions because results change based on environment.
        return false;
    } else if (expression instanceof Within$1) {
        return false;
    }
    const isTypeAnnotation = expression instanceof Coercion$1 || expression instanceof Assertion$1;
    let childrenConstant = true;
    expression.eachChild(child => {
        // We can _almost_ assume that if `expressions` children are constant,
        // they would already have been evaluated to Literal values when they
        // were parsed.  Type annotations are the exception, because they might
        // have been inferred and added after a child was parsed.
        // So we recurse into isConstant() for the children of type annotations,
        // but otherwise simply check whether they are Literals.
        if (isTypeAnnotation) {
            childrenConstant = childrenConstant && isConstant(child);
        } else {
            childrenConstant = childrenConstant && child instanceof Literal$1;
        }
    });
    if (!childrenConstant) {
        return false;
    }
    return isFeatureConstant(expression) && isGlobalPropertyConstant(expression, [
        'zoom',
        'heatmap-density',
        'line-progress',
        'sky-radial-progress',
        'accumulated',
        'is-supported-script',
        'pitch',
        'distance-from-center'
    ]);
}

//      
/**
 * Returns the index of the last stop <= input, or 0 if it doesn't exist.
 * @private
 */
function findStopLessThanOrEqualTo(stops, input) {
    const lastIndex = stops.length - 1;
    let lowerIndex = 0;
    let upperIndex = lastIndex;
    let currentIndex = 0;
    let currentValue, nextValue;
    while (lowerIndex <= upperIndex) {
        currentIndex = Math.floor((lowerIndex + upperIndex) / 2);
        currentValue = stops[currentIndex];
        nextValue = stops[currentIndex + 1];
        if (currentValue <= input) {
            if (currentIndex === lastIndex || input < nextValue) {
                // Search complete
                return currentIndex;
            }
            lowerIndex = currentIndex + 1;
        } else if (currentValue > input) {
            upperIndex = currentIndex - 1;
        } else {
            throw new RuntimeError$1('Input is not a number.');
        }
    }
    return 0;
}

//      
class Step {
    constructor(type, input, stops) {
        this.type = type;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops) {
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static parse(args, context) {
        if (args.length - 1 < 4) {
            return context.error(`Expected at least 4 arguments, but found only ${ args.length - 1 }.`);
        }
        if ((args.length - 1) % 2 !== 0) {
            return context.error(`Expected an even number of arguments.`);
        }
        const input = context.parse(args[1], 1, NumberType);
        if (!input)
            return null;
        const stops = [];
        let outputType = null;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        for (let i = 1; i < args.length; i += 2) {
            const label = i === 1 ? -Infinity : args[i];
            const value = args[i + 1];
            const labelKey = i;
            const valueKey = i + 1;
            if (typeof label !== 'number') {
                return context.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            }
            if (stops.length && stops[stops.length - 1][0] >= label) {
                return context.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', labelKey);
            }
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            stops.push([
                label,
                parsed
            ]);
        }
        return new Step(outputType, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) {
            return outputs[0].evaluate(ctx);
        }
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) {
            return outputs[0].evaluate(ctx);
        }
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) {
            return outputs[stopCount - 1].evaluate(ctx);
        }
        const index = findStopLessThanOrEqualTo(labels, value);
        return outputs[index].evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs) {
            fn(expression);
        }
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined());
    }
    serialize() {
        const serialized = [
            'step',
            this.input.serialize()
        ];
        for (let i = 0; i < this.labels.length; i++) {
            if (i > 0) {
                serialized.push(this.labels[i]);
            }
            serialized.push(this.outputs[i].serialize());
        }
        return serialized;
    }
}
var Step$1 = Step;

var unitbezier = UnitBezier;
function UnitBezier(p1x, p1y, p2x, p2y) {
    // Calculate the polynomial coefficients, implicit first and last control points are (0,0) and (1,1).
    this.cx = 3 * p1x;
    this.bx = 3 * (p2x - p1x) - this.cx;
    this.ax = 1 - this.cx - this.bx;
    this.cy = 3 * p1y;
    this.by = 3 * (p2y - p1y) - this.cy;
    this.ay = 1 - this.cy - this.by;
    this.p1x = p1x;
    this.p1y = p1y;
    this.p2x = p2x;
    this.p2y = p2y;
}
UnitBezier.prototype = {
    sampleCurveX: function (t) {
        // `ax t^3 + bx t^2 + cx t' expanded using Horner's rule.
        return ((this.ax * t + this.bx) * t + this.cx) * t;
    },
    sampleCurveY: function (t) {
        return ((this.ay * t + this.by) * t + this.cy) * t;
    },
    sampleCurveDerivativeX: function (t) {
        return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
    },
    solveCurveX: function (x, epsilon) {
        if (epsilon === undefined)
            epsilon = 0.000001;
        if (x < 0)
            return 0;
        if (x > 1)
            return 1;
        var t = x;
        // First try a few iterations of Newton's method - normally very fast.
        for (var i = 0; i < 8; i++) {
            var x2 = this.sampleCurveX(t) - x;
            if (Math.abs(x2) < epsilon)
                return t;
            var d2 = this.sampleCurveDerivativeX(t);
            if (Math.abs(d2) < 0.000001)
                break;
            t = t - x2 / d2;
        }
        // Fall back to the bisection method for reliability.
        var t0 = 0;
        var t1 = 1;
        t = x;
        for (i = 0; i < 20; i++) {
            x2 = this.sampleCurveX(t);
            if (Math.abs(x2 - x) < epsilon)
                break;
            if (x > x2) {
                t0 = t;
            } else {
                t1 = t;
            }
            t = (t1 - t0) * 0.5 + t0;
        }
        return t;
    },
    solve: function (x, epsilon) {
        return this.sampleCurveY(this.solveCurveX(x, epsilon));
    }
};

//      
function number(a, b, t) {
    return a * (1 - t) + b * t;
}
function color(from, to, t) {
    return new Color$1(number(from.r, to.r, t), number(from.g, to.g, t), number(from.b, to.b, t), number(from.a, to.a, t));
}
function array(from, to, t) {
    return from.map((d, i) => {
        return number(d, to[i], t);
    });
}

var interpolate = /*#__PURE__*/Object.freeze({
  __proto__: null,
  number: number,
  color: color,
  array: array
});

//      
// Constants
const Xn = 0.95047,
    // D65 standard referent
    Yn = 1, Zn = 1.08883, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1, deg2rad = Math.PI / 180, rad2deg = 180 / Math.PI;
// Utilities
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function xyz2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2xyz(x) {
    x /= 255;
    return x <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
// LAB
function rgbToLab(rgbColor) {
    const b = rgb2xyz(rgbColor.r), a = rgb2xyz(rgbColor.g), l = rgb2xyz(rgbColor.b), x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn), y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.072175 * l) / Yn), z = xyz2lab((0.0193339 * b + 0.119192 * a + 0.9503041 * l) / Zn);
    return {
        l: 116 * y - 16,
        a: 500 * (x - y),
        b: 200 * (y - z),
        alpha: rgbColor.a
    };
}
function labToRgb(labColor) {
    let y = (labColor.l + 16) / 116, x = isNaN(labColor.a) ? y : y + labColor.a / 500, z = isNaN(labColor.b) ? y : y - labColor.b / 200;
    y = Yn * lab2xyz(y);
    x = Xn * lab2xyz(x);
    z = Zn * lab2xyz(z);
    return new Color$1(xyz2rgb(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
    xyz2rgb(-0.969266 * x + 1.8760108 * y + 0.041556 * z), xyz2rgb(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), labColor.alpha);
}
function interpolateLab(from, to, t) {
    return {
        l: number(from.l, to.l, t),
        a: number(from.a, to.a, t),
        b: number(from.b, to.b, t),
        alpha: number(from.alpha, to.alpha, t)
    };
}
// HCL
function rgbToHcl(rgbColor) {
    const {l, a, b} = rgbToLab(rgbColor);
    const h = Math.atan2(b, a) * rad2deg;
    return {
        h: h < 0 ? h + 360 : h,
        c: Math.sqrt(a * a + b * b),
        l,
        alpha: rgbColor.a
    };
}
function hclToRgb(hclColor) {
    const h = hclColor.h * deg2rad, c = hclColor.c, l = hclColor.l;
    return labToRgb({
        l,
        a: Math.cos(h) * c,
        b: Math.sin(h) * c,
        alpha: hclColor.alpha
    });
}
function interpolateHue(a, b, t) {
    const d = b - a;
    return a + t * (d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d);
}
function interpolateHcl(from, to, t) {
    return {
        h: interpolateHue(from.h, to.h, t),
        c: number(from.c, to.c, t),
        l: number(from.l, to.l, t),
        alpha: number(from.alpha, to.alpha, t)
    };
}
const lab = {
    forward: rgbToLab,
    reverse: labToRgb,
    interpolate: interpolateLab
};
const hcl = {
    forward: rgbToHcl,
    reverse: hclToRgb,
    interpolate: interpolateHcl
};

var colorSpaces = /*#__PURE__*/Object.freeze({
  __proto__: null,
  lab: lab,
  hcl: hcl
});

//      
class Interpolate {
    constructor(type, operator, interpolation, input, stops) {
        this.type = type;
        this.operator = operator;
        this.interpolation = interpolation;
        this.input = input;
        this.labels = [];
        this.outputs = [];
        for (const [label, expression] of stops) {
            this.labels.push(label);
            this.outputs.push(expression);
        }
    }
    static interpolationFactor(interpolation, input, lower, upper) {
        let t = 0;
        if (interpolation.name === 'exponential') {
            t = exponentialInterpolation(input, interpolation.base, lower, upper);
        } else if (interpolation.name === 'linear') {
            t = exponentialInterpolation(input, 1, lower, upper);
        } else if (interpolation.name === 'cubic-bezier') {
            const c = interpolation.controlPoints;
            const ub = new unitbezier(c[0], c[1], c[2], c[3]);
            t = ub.solve(exponentialInterpolation(input, 1, lower, upper));
        }
        return t;
    }
    static parse(args, context) {
        let [operator, interpolation, input, ...rest] = args;
        if (!Array.isArray(interpolation) || interpolation.length === 0) {
            return context.error(`Expected an interpolation type expression.`, 1);
        }
        if (interpolation[0] === 'linear') {
            interpolation = { name: 'linear' };
        } else if (interpolation[0] === 'exponential') {
            const base = interpolation[1];
            if (typeof base !== 'number')
                return context.error(`Exponential interpolation requires a numeric base.`, 1, 1);
            interpolation = {
                name: 'exponential',
                base
            };
        } else if (interpolation[0] === 'cubic-bezier') {
            const controlPoints = interpolation.slice(1);
            if (controlPoints.length !== 4 || controlPoints.some(t => typeof t !== 'number' || t < 0 || t > 1)) {
                return context.error('Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.', 1);
            }
            interpolation = {
                name: 'cubic-bezier',
                controlPoints: controlPoints
            };
        } else {
            return context.error(`Unknown interpolation type ${ String(interpolation[0]) }`, 1, 0);
        }
        if (args.length - 1 < 4) {
            return context.error(`Expected at least 4 arguments, but found only ${ args.length - 1 }.`);
        }
        if ((args.length - 1) % 2 !== 0) {
            return context.error(`Expected an even number of arguments.`);
        }
        input = context.parse(input, 2, NumberType);
        if (!input)
            return null;
        const stops = [];
        let outputType = null;
        if (operator === 'interpolate-hcl' || operator === 'interpolate-lab') {
            outputType = ColorType;
        } else if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        for (let i = 0; i < rest.length; i += 2) {
            const label = rest[i];
            const value = rest[i + 1];
            const labelKey = i + 3;
            const valueKey = i + 4;
            if (typeof label !== 'number') {
                return context.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', labelKey);
            }
            if (stops.length && stops[stops.length - 1][0] >= label) {
                return context.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', labelKey);
            }
            const parsed = context.parse(value, valueKey, outputType);
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            stops.push([
                label,
                parsed
            ]);
        }
        if (outputType.kind !== 'number' && outputType.kind !== 'color' && !(outputType.kind === 'array' && outputType.itemType.kind === 'number' && typeof outputType.N === 'number')) {
            return context.error(`Type ${ toString$1(outputType) } is not interpolatable.`);
        }
        return new Interpolate(outputType, operator, interpolation, input, stops);
    }
    evaluate(ctx) {
        const labels = this.labels;
        const outputs = this.outputs;
        if (labels.length === 1) {
            return outputs[0].evaluate(ctx);
        }
        const value = this.input.evaluate(ctx);
        if (value <= labels[0]) {
            return outputs[0].evaluate(ctx);
        }
        const stopCount = labels.length;
        if (value >= labels[stopCount - 1]) {
            return outputs[stopCount - 1].evaluate(ctx);
        }
        const index = findStopLessThanOrEqualTo(labels, value);
        const lower = labels[index];
        const upper = labels[index + 1];
        const t = Interpolate.interpolationFactor(this.interpolation, value, lower, upper);
        const outputLower = outputs[index].evaluate(ctx);
        const outputUpper = outputs[index + 1].evaluate(ctx);
        if (this.operator === 'interpolate') {
            return interpolate[this.type.kind.toLowerCase()](outputLower, outputUpper, t);    // eslint-disable-line import/namespace
        } else if (this.operator === 'interpolate-hcl') {
            return hcl.reverse(hcl.interpolate(hcl.forward(outputLower), hcl.forward(outputUpper), t));
        } else {
            return lab.reverse(lab.interpolate(lab.forward(outputLower), lab.forward(outputUpper), t));
        }
    }
    eachChild(fn) {
        fn(this.input);
        for (const expression of this.outputs) {
            fn(expression);
        }
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined());
    }
    serialize() {
        let interpolation;
        if (this.interpolation.name === 'linear') {
            interpolation = ['linear'];
        } else if (this.interpolation.name === 'exponential') {
            if (this.interpolation.base === 1) {
                interpolation = ['linear'];
            } else {
                interpolation = [
                    'exponential',
                    this.interpolation.base
                ];
            }
        } else {
            interpolation = ['cubic-bezier'].concat(this.interpolation.controlPoints);
        }
        const serialized = [
            this.operator,
            interpolation,
            this.input.serialize()
        ];
        for (let i = 0; i < this.labels.length; i++) {
            serialized.push(this.labels[i], this.outputs[i].serialize());
        }
        return serialized;
    }
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 * How it works: Two consecutive stop values define a (scaled and shifted) exponential function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
*/
function exponentialInterpolation(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    } else if (base === 1) {
        return progress / difference;
    } else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}
var Interpolate$1 = Interpolate;

class Coalesce {
    constructor(type, args) {
        this.type = type;
        this.args = args;
    }
    static parse(args, context) {
        if (args.length < 2) {
            return context.error('Expectected at least one argument.');
        }
        let outputType = null;
        const expectedType = context.expectedType;
        if (expectedType && expectedType.kind !== 'value') {
            outputType = expectedType;
        }
        const parsedArgs = [];
        for (const arg of args.slice(1)) {
            const parsed = context.parse(arg, 1 + parsedArgs.length, outputType, undefined, { typeAnnotation: 'omit' });
            if (!parsed)
                return null;
            outputType = outputType || parsed.type;
            parsedArgs.push(parsed);
        }
        // Above, we parse arguments without inferred type annotation so that
        // they don't produce a runtime error for `null` input, which would
        // preempt the desired null-coalescing behavior.
        // Thus, if any of our arguments would have needed an annotation, we
        // need to wrap the enclosing coalesce expression with it instead.
        const needsAnnotation = expectedType && parsedArgs.some(arg => checkSubtype(expectedType, arg.type));
        return needsAnnotation ? new Coalesce(ValueType, parsedArgs) : new Coalesce(outputType, parsedArgs);
    }
    evaluate(ctx) {
        let result = null;
        let argCount = 0;
        let firstImage;
        for (const arg of this.args) {
            argCount++;
            result = arg.evaluate(ctx);
            // we need to keep track of the first requested image in a coalesce statement
            // if coalesce can't find a valid image, we return the first image so styleimagemissing can fire
            if (result && result instanceof ResolvedImage && !result.available) {
                // set to first image
                if (!firstImage) {
                    firstImage = result;
                }
                result = null;
                // if we reach the end, return the first image
                if (argCount === this.args.length) {
                    return firstImage;
                }
            }
            if (result !== null)
                break;
        }
        return result;
    }
    eachChild(fn) {
        this.args.forEach(fn);
    }
    outputDefined() {
        return this.args.every(arg => arg.outputDefined());
    }
    serialize() {
        const serialized = ['coalesce'];
        this.eachChild(child => {
            serialized.push(child.serialize());
        });
        return serialized;
    }
}
var Coalesce$1 = Coalesce;

//      
class Let {
    constructor(bindings, result) {
        this.type = result.type;
        this.bindings = [].concat(bindings);
        this.result = result;
    }
    evaluate(ctx) {
        return this.result.evaluate(ctx);
    }
    eachChild(fn) {
        for (const binding of this.bindings) {
            fn(binding[1]);
        }
        fn(this.result);
    }
    static parse(args, context) {
        if (args.length < 4)
            return context.error(`Expected at least 3 arguments, but found ${ args.length - 1 } instead.`);
        const bindings = [];
        for (let i = 1; i < args.length - 1; i += 2) {
            const name = args[i];
            if (typeof name !== 'string') {
                return context.error(`Expected string, but found ${ typeof name } instead.`, i);
            }
            if (/[^a-zA-Z0-9_]/.test(name)) {
                return context.error(`Variable names must contain only alphanumeric characters or '_'.`, i);
            }
            const value = context.parse(args[i + 1], i + 1);
            if (!value)
                return null;
            bindings.push([
                name,
                value
            ]);
        }
        const result = context.parse(args[args.length - 1], args.length - 1, context.expectedType, bindings);
        if (!result)
            return null;
        return new Let(bindings, result);
    }
    outputDefined() {
        return this.result.outputDefined();
    }
    serialize() {
        const serialized = ['let'];
        for (const [name, expr] of this.bindings) {
            serialized.push(name, expr.serialize());
        }
        serialized.push(this.result.serialize());
        return serialized;
    }
}
var Let$1 = Let;

//      
class At {
    constructor(type, index, input) {
        this.type = type;
        this.index = index;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 3)
            return context.error(`Expected 2 arguments, but found ${ args.length - 1 } instead.`);
        const index = context.parse(args[1], 1, NumberType);
        const input = context.parse(args[2], 2, array$1(context.expectedType || ValueType));
        if (!index || !input)
            return null;
        const t = input.type;
        return new At(t.itemType, index, input);
    }
    evaluate(ctx) {
        const index = this.index.evaluate(ctx);
        const array = this.input.evaluate(ctx);
        if (index < 0) {
            throw new RuntimeError$1(`Array index out of bounds: ${ index } < 0.`);
        }
        if (index >= array.length) {
            throw new RuntimeError$1(`Array index out of bounds: ${ index } > ${ array.length - 1 }.`);
        }
        if (index !== Math.floor(index)) {
            throw new RuntimeError$1(`Array index must be an integer, but found ${ index } instead.`);
        }
        return array[index];
    }
    eachChild(fn) {
        fn(this.index);
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
    serialize() {
        return [
            'at',
            this.index.serialize(),
            this.input.serialize()
        ];
    }
}
var At$1 = At;

//      
class In {
    constructor(needle, haystack) {
        this.type = BooleanType;
        this.needle = needle;
        this.haystack = haystack;
    }
    static parse(args, context) {
        if (args.length !== 3) {
            return context.error(`Expected 2 arguments, but found ${ args.length - 1 } instead.`);
        }
        const needle = context.parse(args[1], 1, ValueType);
        const haystack = context.parse(args[2], 2, ValueType);
        if (!needle || !haystack)
            return null;
        if (!isValidType(needle.type, [
                BooleanType,
                StringType,
                NumberType,
                NullType,
                ValueType
            ])) {
            return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${ toString$1(needle.type) } instead`);
        }
        return new In(needle, haystack);
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (haystack == null)
            return false;
        if (!isValidNativeType(needle, [
                'boolean',
                'string',
                'number',
                'null'
            ])) {
            throw new RuntimeError$1(`Expected first argument to be of type boolean, string, number or null, but found ${ toString$1(typeOf(needle)) } instead.`);
        }
        if (!isValidNativeType(haystack, [
                'string',
                'array'
            ])) {
            throw new RuntimeError$1(`Expected second argument to be of type array or string, but found ${ toString$1(typeOf(haystack)) } instead.`);
        }
        return haystack.indexOf(needle) >= 0;
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
    }
    outputDefined() {
        return true;
    }
    serialize() {
        return [
            'in',
            this.needle.serialize(),
            this.haystack.serialize()
        ];
    }
}
var In$1 = In;

//      
class IndexOf {
    constructor(needle, haystack, fromIndex) {
        this.type = NumberType;
        this.needle = needle;
        this.haystack = haystack;
        this.fromIndex = fromIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) {
            return context.error(`Expected 3 or 4 arguments, but found ${ args.length - 1 } instead.`);
        }
        const needle = context.parse(args[1], 1, ValueType);
        const haystack = context.parse(args[2], 2, ValueType);
        if (!needle || !haystack)
            return null;
        if (!isValidType(needle.type, [
                BooleanType,
                StringType,
                NumberType,
                NullType,
                ValueType
            ])) {
            return context.error(`Expected first argument to be of type boolean, string, number or null, but found ${ toString$1(needle.type) } instead`);
        }
        if (args.length === 4) {
            const fromIndex = context.parse(args[3], 3, NumberType);
            if (!fromIndex)
                return null;
            return new IndexOf(needle, haystack, fromIndex);
        } else {
            return new IndexOf(needle, haystack);
        }
    }
    evaluate(ctx) {
        const needle = this.needle.evaluate(ctx);
        const haystack = this.haystack.evaluate(ctx);
        if (!isValidNativeType(needle, [
                'boolean',
                'string',
                'number',
                'null'
            ])) {
            throw new RuntimeError$1(`Expected first argument to be of type boolean, string, number or null, but found ${ toString$1(typeOf(needle)) } instead.`);
        }
        if (!isValidNativeType(haystack, [
                'string',
                'array'
            ])) {
            throw new RuntimeError$1(`Expected second argument to be of type array or string, but found ${ toString$1(typeOf(haystack)) } instead.`);
        }
        if (this.fromIndex) {
            const fromIndex = this.fromIndex.evaluate(ctx);
            return haystack.indexOf(needle, fromIndex);
        }
        return haystack.indexOf(needle);
    }
    eachChild(fn) {
        fn(this.needle);
        fn(this.haystack);
        if (this.fromIndex) {
            fn(this.fromIndex);
        }
    }
    outputDefined() {
        return false;
    }
    serialize() {
        if (this.fromIndex != null && this.fromIndex !== undefined) {
            const fromIndex = this.fromIndex.serialize();
            return [
                'index-of',
                this.needle.serialize(),
                this.haystack.serialize(),
                fromIndex
            ];
        }
        return [
            'index-of',
            this.needle.serialize(),
            this.haystack.serialize()
        ];
    }
}
var IndexOf$1 = IndexOf;

// Map input label values to output expression index
class Match {
    constructor(inputType, outputType, input, cases, outputs, otherwise) {
        this.inputType = inputType;
        this.type = outputType;
        this.input = input;
        this.cases = cases;
        this.outputs = outputs;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 5)
            return context.error(`Expected at least 4 arguments, but found only ${ args.length - 1 }.`);
        if (args.length % 2 !== 1)
            return context.error(`Expected an even number of arguments.`);
        let inputType;
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        const cases = {};
        const outputs = [];
        for (let i = 2; i < args.length - 1; i += 2) {
            let labels = args[i];
            const value = args[i + 1];
            if (!Array.isArray(labels)) {
                labels = [labels];
            }
            const labelContext = context.concat(i);
            if (labels.length === 0) {
                return labelContext.error('Expected at least one branch label.');
            }
            for (const label of labels) {
                if (typeof label !== 'number' && typeof label !== 'string') {
                    return labelContext.error(`Branch labels must be numbers or strings.`);
                } else if (typeof label === 'number' && Math.abs(label) > Number.MAX_SAFE_INTEGER) {
                    return labelContext.error(`Branch labels must be integers no larger than ${ Number.MAX_SAFE_INTEGER }.`);
                } else if (typeof label === 'number' && Math.floor(label) !== label) {
                    return labelContext.error(`Numeric branch labels must be integer values.`);
                } else if (!inputType) {
                    inputType = typeOf(label);
                } else if (labelContext.checkSubtype(inputType, typeOf(label))) {
                    return null;
                }
                if (typeof cases[String(label)] !== 'undefined') {
                    return labelContext.error('Branch labels must be unique.');
                }
                cases[String(label)] = outputs.length;
            }
            const result = context.parse(value, i, outputType);
            if (!result)
                return null;
            outputType = outputType || result.type;
            outputs.push(result);
        }
        const input = context.parse(args[1], 1, ValueType);
        if (!input)
            return null;
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise)
            return null;
        if (input.type.kind !== 'value' && context.concat(1).checkSubtype(inputType, input.type)) {
            return null;
        }
        return new Match(inputType, outputType, input, cases, outputs, otherwise);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const output = typeOf(input) === this.inputType && this.outputs[this.cases[input]] || this.otherwise;
        return output.evaluate(ctx);
    }
    eachChild(fn) {
        fn(this.input);
        this.outputs.forEach(fn);
        fn(this.otherwise);
    }
    outputDefined() {
        return this.outputs.every(out => out.outputDefined()) && this.otherwise.outputDefined();
    }
    serialize() {
        const serialized = [
            'match',
            this.input.serialize()
        ];
        // Sort so serialization has an arbitrary defined order, even though
        // branch order doesn't affect evaluation
        const sortedLabels = Object.keys(this.cases).sort();
        // Group branches by unique match expression to support condensed
        // serializations of the form [case1, case2, ...] -> matchExpression
        const groupedByOutput = [];
        const outputLookup = {};
        // lookup index into groupedByOutput for a given output expression
        for (const label of sortedLabels) {
            const outputIndex = outputLookup[this.cases[label]];
            if (outputIndex === undefined) {
                // First time seeing this output, add it to the end of the grouped list
                outputLookup[this.cases[label]] = groupedByOutput.length;
                groupedByOutput.push([
                    this.cases[label],
                    [label]
                ]);
            } else {
                // We've seen this expression before, add the label to that output's group
                groupedByOutput[outputIndex][1].push(label);
            }
        }
        const coerceLabel = label => this.inputType.kind === 'number' ? Number(label) : label;
        for (const [outputIndex, labels] of groupedByOutput) {
            if (labels.length === 1) {
                // Only a single label matches this output expression
                serialized.push(coerceLabel(labels[0]));
            } else {
                // Array of literal labels pointing to this output expression
                serialized.push(labels.map(coerceLabel));
            }
            serialized.push(this.outputs[outputIndex].serialize());
        }
        serialized.push(this.otherwise.serialize());
        return serialized;
    }
}
var Match$1 = Match;

class Case {
    constructor(type, branches, otherwise) {
        this.type = type;
        this.branches = branches;
        this.otherwise = otherwise;
    }
    static parse(args, context) {
        if (args.length < 4)
            return context.error(`Expected at least 3 arguments, but found only ${ args.length - 1 }.`);
        if (args.length % 2 !== 0)
            return context.error(`Expected an odd number of arguments.`);
        let outputType;
        if (context.expectedType && context.expectedType.kind !== 'value') {
            outputType = context.expectedType;
        }
        const branches = [];
        for (let i = 1; i < args.length - 1; i += 2) {
            const test = context.parse(args[i], i, BooleanType);
            if (!test)
                return null;
            const result = context.parse(args[i + 1], i + 1, outputType);
            if (!result)
                return null;
            branches.push([
                test,
                result
            ]);
            outputType = outputType || result.type;
        }
        const otherwise = context.parse(args[args.length - 1], args.length - 1, outputType);
        if (!otherwise)
            return null;
        return new Case(outputType, branches, otherwise);
    }
    evaluate(ctx) {
        for (const [test, expression] of this.branches) {
            if (test.evaluate(ctx)) {
                return expression.evaluate(ctx);
            }
        }
        return this.otherwise.evaluate(ctx);
    }
    eachChild(fn) {
        for (const [test, expression] of this.branches) {
            fn(test);
            fn(expression);
        }
        fn(this.otherwise);
    }
    outputDefined() {
        return this.branches.every(([_, out]) => out.outputDefined()) && this.otherwise.outputDefined();
    }
    serialize() {
        const serialized = ['case'];
        this.eachChild(child => {
            serialized.push(child.serialize());
        });
        return serialized;
    }
}
var Case$1 = Case;

//      
class Slice {
    constructor(type, input, beginIndex, endIndex) {
        this.type = type;
        this.input = input;
        this.beginIndex = beginIndex;
        this.endIndex = endIndex;
    }
    static parse(args, context) {
        if (args.length <= 2 || args.length >= 5) {
            return context.error(`Expected 3 or 4 arguments, but found ${ args.length - 1 } instead.`);
        }
        const input = context.parse(args[1], 1, ValueType);
        const beginIndex = context.parse(args[2], 2, NumberType);
        if (!input || !beginIndex)
            return null;
        if (!isValidType(input.type, [
                array$1(ValueType),
                StringType,
                ValueType
            ])) {
            return context.error(`Expected first argument to be of type array or string, but found ${ toString$1(input.type) } instead`);
        }
        if (args.length === 4) {
            const endIndex = context.parse(args[3], 3, NumberType);
            if (!endIndex)
                return null;
            return new Slice(input.type, input, beginIndex, endIndex);
        } else {
            return new Slice(input.type, input, beginIndex);
        }
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        const beginIndex = this.beginIndex.evaluate(ctx);
        if (!isValidNativeType(input, [
                'string',
                'array'
            ])) {
            throw new RuntimeError$1(`Expected first argument to be of type array or string, but found ${ toString$1(typeOf(input)) } instead.`);
        }
        if (this.endIndex) {
            const endIndex = this.endIndex.evaluate(ctx);
            return input.slice(beginIndex, endIndex);
        }
        return input.slice(beginIndex);
    }
    eachChild(fn) {
        fn(this.input);
        fn(this.beginIndex);
        if (this.endIndex) {
            fn(this.endIndex);
        }
    }
    outputDefined() {
        return false;
    }
    serialize() {
        if (this.endIndex != null && this.endIndex !== undefined) {
            const endIndex = this.endIndex.serialize();
            return [
                'slice',
                this.input.serialize(),
                this.beginIndex.serialize(),
                endIndex
            ];
        }
        return [
            'slice',
            this.input.serialize(),
            this.beginIndex.serialize()
        ];
    }
}
var Slice$1 = Slice;

//      
function isComparableType(op, type) {
    if (op === '==' || op === '!=') {
        // equality operator
        return type.kind === 'boolean' || type.kind === 'string' || type.kind === 'number' || type.kind === 'null' || type.kind === 'value';
    } else {
        // ordering operator
        return type.kind === 'string' || type.kind === 'number' || type.kind === 'value';
    }
}
function eq(ctx, a, b) {
    return a === b;
}
function neq(ctx, a, b) {
    return a !== b;
}
function lt(ctx, a, b) {
    return a < b;
}
function gt(ctx, a, b) {
    return a > b;
}
function lteq(ctx, a, b) {
    return a <= b;
}
function gteq(ctx, a, b) {
    return a >= b;
}
function eqCollate(ctx, a, b, c) {
    return c.compare(a, b) === 0;
}
function neqCollate(ctx, a, b, c) {
    return !eqCollate(ctx, a, b, c);
}
function ltCollate(ctx, a, b, c) {
    return c.compare(a, b) < 0;
}
function gtCollate(ctx, a, b, c) {
    return c.compare(a, b) > 0;
}
function lteqCollate(ctx, a, b, c) {
    return c.compare(a, b) <= 0;
}
function gteqCollate(ctx, a, b, c) {
    return c.compare(a, b) >= 0;
}
/**
 * Special form for comparison operators, implementing the signatures:
 * - (T, T, ?Collator) => boolean
 * - (T, value, ?Collator) => boolean
 * - (value, T, ?Collator) => boolean
 *
 * For inequalities, T must be either value, string, or number. For ==/!=, it
 * can also be boolean or null.
 *
 * Equality semantics are equivalent to Javascript's strict equality (===/!==)
 * -- i.e., when the arguments' types don't match, == evaluates to false, != to
 * true.
 *
 * When types don't match in an ordering comparison, a runtime error is thrown.
 *
 * @private
 */
function makeComparison(op, compareBasic, compareWithCollator) {
    const isOrderComparison = op !== '==' && op !== '!=';
    return class Comparison {
        constructor(lhs, rhs, collator) {
            this.type = BooleanType;
            this.lhs = lhs;
            this.rhs = rhs;
            this.collator = collator;
            this.hasUntypedArgument = lhs.type.kind === 'value' || rhs.type.kind === 'value';
        }
        static parse(args, context) {
            if (args.length !== 3 && args.length !== 4)
                return context.error(`Expected two or three arguments.`);
            const op = args[0];
            let lhs = context.parse(args[1], 1, ValueType);
            if (!lhs)
                return null;
            if (!isComparableType(op, lhs.type)) {
                return context.concat(1).error(`"${ op }" comparisons are not supported for type '${ toString$1(lhs.type) }'.`);
            }
            let rhs = context.parse(args[2], 2, ValueType);
            if (!rhs)
                return null;
            if (!isComparableType(op, rhs.type)) {
                return context.concat(2).error(`"${ op }" comparisons are not supported for type '${ toString$1(rhs.type) }'.`);
            }
            if (lhs.type.kind !== rhs.type.kind && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') {
                return context.error(`Cannot compare types '${ toString$1(lhs.type) }' and '${ toString$1(rhs.type) }'.`);
            }
            if (isOrderComparison) {
                // typing rules specific to less/greater than operators
                if (lhs.type.kind === 'value' && rhs.type.kind !== 'value') {
                    // (value, T)
                    lhs = new Assertion$1(rhs.type, [lhs]);
                } else if (lhs.type.kind !== 'value' && rhs.type.kind === 'value') {
                    // (T, value)
                    rhs = new Assertion$1(lhs.type, [rhs]);
                }
            }
            let collator = null;
            if (args.length === 4) {
                if (lhs.type.kind !== 'string' && rhs.type.kind !== 'string' && lhs.type.kind !== 'value' && rhs.type.kind !== 'value') {
                    return context.error(`Cannot use collator to compare non-string types.`);
                }
                collator = context.parse(args[3], 3, CollatorType);
                if (!collator)
                    return null;
            }
            return new Comparison(lhs, rhs, collator);
        }
        evaluate(ctx) {
            const lhs = this.lhs.evaluate(ctx);
            const rhs = this.rhs.evaluate(ctx);
            if (isOrderComparison && this.hasUntypedArgument) {
                const lt = typeOf(lhs);
                const rt = typeOf(rhs);
                // check that type is string or number, and equal
                if (lt.kind !== rt.kind || !(lt.kind === 'string' || lt.kind === 'number')) {
                    throw new RuntimeError$1(`Expected arguments for "${ op }" to be (string, string) or (number, number), but found (${ lt.kind }, ${ rt.kind }) instead.`);
                }
            }
            if (this.collator && !isOrderComparison && this.hasUntypedArgument) {
                const lt = typeOf(lhs);
                const rt = typeOf(rhs);
                if (lt.kind !== 'string' || rt.kind !== 'string') {
                    return compareBasic(ctx, lhs, rhs);
                }
            }
            return this.collator ? compareWithCollator(ctx, lhs, rhs, this.collator.evaluate(ctx)) : compareBasic(ctx, lhs, rhs);
        }
        eachChild(fn) {
            fn(this.lhs);
            fn(this.rhs);
            if (this.collator) {
                fn(this.collator);
            }
        }
        outputDefined() {
            return true;
        }
        serialize() {
            const serialized = [op];
            this.eachChild(child => {
                serialized.push(child.serialize());
            });
            return serialized;
        }
    };
}
const Equals = makeComparison('==', eq, eqCollate);
const NotEquals = makeComparison('!=', neq, neqCollate);
const LessThan = makeComparison('<', lt, ltCollate);
const GreaterThan = makeComparison('>', gt, gtCollate);
const LessThanOrEqual = makeComparison('<=', lteq, lteqCollate);
const GreaterThanOrEqual = makeComparison('>=', gteq, gteqCollate);

//      
class NumberFormat {
    // BCP 47 language tag
    // ISO 4217 currency code, required if style=currency
    // Simple units sanctioned for use in ECMAScript, required if style=unit. https://tc39.es/proposal-unified-intl-numberformat/section6/locales-currencies-tz_proposed_out.html#sec-issanctionedsimpleunitidentifier
    // Default 0
    // Default 3
    constructor(number, locale, currency, unit, minFractionDigits, maxFractionDigits) {
        this.type = StringType;
        this.number = number;
        this.locale = locale;
        this.currency = currency;
        this.unit = unit;
        this.minFractionDigits = minFractionDigits;
        this.maxFractionDigits = maxFractionDigits;
    }
    static parse(args, context) {
        if (args.length !== 3)
            return context.error(`Expected two arguments.`);
        const number = context.parse(args[1], 1, NumberType);
        if (!number)
            return null;
        const options = args[2];
        if (typeof options !== 'object' || Array.isArray(options))
            return context.error(`NumberFormat options argument must be an object.`);
        let locale = null;
        if (options['locale']) {
            locale = context.parse(options['locale'], 1, StringType);
            if (!locale)
                return null;
        }
        let currency = null;
        if (options['currency']) {
            currency = context.parse(options['currency'], 1, StringType);
            if (!currency)
                return null;
        }
        let unit = null;
        if (options['unit']) {
            unit = context.parse(options['unit'], 1, StringType);
            if (!unit)
                return null;
        }
        let minFractionDigits = null;
        if (options['min-fraction-digits']) {
            minFractionDigits = context.parse(options['min-fraction-digits'], 1, NumberType);
            if (!minFractionDigits)
                return null;
        }
        let maxFractionDigits = null;
        if (options['max-fraction-digits']) {
            maxFractionDigits = context.parse(options['max-fraction-digits'], 1, NumberType);
            if (!maxFractionDigits)
                return null;
        }
        return new NumberFormat(number, locale, currency, unit, minFractionDigits, maxFractionDigits);
    }
    evaluate(ctx) {
        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(ctx) : [], {
            style: this.currency && 'currency' || this.unit && 'unit' || 'decimal',
            currency: this.currency ? this.currency.evaluate(ctx) : undefined,
            unit: this.unit ? this.unit.evaluate(ctx) : undefined,
            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(ctx) : undefined,
            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(ctx) : undefined
        }).format(this.number.evaluate(ctx));
    }
    eachChild(fn) {
        fn(this.number);
        if (this.locale) {
            fn(this.locale);
        }
        if (this.currency) {
            fn(this.currency);
        }
        if (this.unit) {
            fn(this.unit);
        }
        if (this.minFractionDigits) {
            fn(this.minFractionDigits);
        }
        if (this.maxFractionDigits) {
            fn(this.maxFractionDigits);
        }
    }
    outputDefined() {
        return false;
    }
    serialize() {
        const options = {};
        if (this.locale) {
            options['locale'] = this.locale.serialize();
        }
        if (this.currency) {
            options['currency'] = this.currency.serialize();
        }
        if (this.unit) {
            options['unit'] = this.unit.serialize();
        }
        if (this.minFractionDigits) {
            options['min-fraction-digits'] = this.minFractionDigits.serialize();
        }
        if (this.maxFractionDigits) {
            options['max-fraction-digits'] = this.maxFractionDigits.serialize();
        }
        return [
            'number-format',
            this.number.serialize(),
            options
        ];
    }
}

//      
class Length {
    constructor(input) {
        this.type = NumberType;
        this.input = input;
    }
    static parse(args, context) {
        if (args.length !== 2)
            return context.error(`Expected 1 argument, but found ${ args.length - 1 } instead.`);
        const input = context.parse(args[1], 1);
        if (!input)
            return null;
        if (input.type.kind !== 'array' && input.type.kind !== 'string' && input.type.kind !== 'value')
            return context.error(`Expected argument of type string or array, but found ${ toString$1(input.type) } instead.`);
        return new Length(input);
    }
    evaluate(ctx) {
        const input = this.input.evaluate(ctx);
        if (typeof input === 'string') {
            return input.length;
        } else if (Array.isArray(input)) {
            return input.length;
        } else {
            throw new RuntimeError$1(`Expected value to be of type string or array, but found ${ toString$1(typeOf(input)) } instead.`);
        }
    }
    eachChild(fn) {
        fn(this.input);
    }
    outputDefined() {
        return false;
    }
    serialize() {
        const serialized = ['length'];
        this.eachChild(child => {
            serialized.push(child.serialize());
        });
        return serialized;
    }
}
var Length$1 = Length;

//      
const expressions = {
    // special forms
    '==': Equals,
    '!=': NotEquals,
    '>': GreaterThan,
    '<': LessThan,
    '>=': GreaterThanOrEqual,
    '<=': LessThanOrEqual,
    'array': Assertion$1,
    'at': At$1,
    'boolean': Assertion$1,
    'case': Case$1,
    'coalesce': Coalesce$1,
    'collator': CollatorExpression,
    'format': FormatExpression,
    'image': ImageExpression,
    'in': In$1,
    'index-of': IndexOf$1,
    'interpolate': Interpolate$1,
    'interpolate-hcl': Interpolate$1,
    'interpolate-lab': Interpolate$1,
    'length': Length$1,
    'let': Let$1,
    'literal': Literal$1,
    'match': Match$1,
    'number': Assertion$1,
    'number-format': NumberFormat,
    'object': Assertion$1,
    'slice': Slice$1,
    'step': Step$1,
    'string': Assertion$1,
    'to-boolean': Coercion$1,
    'to-color': Coercion$1,
    'to-number': Coercion$1,
    'to-string': Coercion$1,
    'var': Var$1,
    'within': Within$1
};
function rgba(ctx, [r, g, b, a]) {
    r = r.evaluate(ctx);
    g = g.evaluate(ctx);
    b = b.evaluate(ctx);
    const alpha = a ? a.evaluate(ctx) : 1;
    const error = validateRGBA(r, g, b, alpha);
    if (error)
        throw new RuntimeError$1(error);
    return new Color$1(r / 255 * alpha, g / 255 * alpha, b / 255 * alpha, alpha);
}
function has(key, obj) {
    return key in obj;
}
function get(key, obj) {
    const v = obj[key];
    return typeof v === 'undefined' ? null : v;
}
function binarySearch(v, a, i, j) {
    while (i <= j) {
        const m = i + j >> 1;
        if (a[m] === v)
            return true;
        if (a[m] > v)
            j = m - 1;
        else
            i = m + 1;
    }
    return false;
}
function varargs(type) {
    return { type };
}
CompoundExpression$1.register(expressions, {
    'error': [
        ErrorType,
        [StringType],
        (ctx, [v]) => {
            throw new RuntimeError$1(v.evaluate(ctx));
        }
    ],
    'typeof': [
        StringType,
        [ValueType],
        (ctx, [v]) => toString$1(typeOf(v.evaluate(ctx)))
    ],
    'to-rgba': [
        array$1(NumberType, 4),
        [ColorType],
        (ctx, [v]) => {
            return v.evaluate(ctx).toArray();
        }
    ],
    'rgb': [
        ColorType,
        [
            NumberType,
            NumberType,
            NumberType
        ],
        rgba
    ],
    'rgba': [
        ColorType,
        [
            NumberType,
            NumberType,
            NumberType,
            NumberType
        ],
        rgba
    ],
    'has': {
        type: BooleanType,
        overloads: [
            [
                [StringType],
                (ctx, [key]) => has(key.evaluate(ctx), ctx.properties())
            ],
            [
                [
                    StringType,
                    ObjectType
                ],
                (ctx, [key, obj]) => has(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    'get': {
        type: ValueType,
        overloads: [
            [
                [StringType],
                (ctx, [key]) => get(key.evaluate(ctx), ctx.properties())
            ],
            [
                [
                    StringType,
                    ObjectType
                ],
                (ctx, [key, obj]) => get(key.evaluate(ctx), obj.evaluate(ctx))
            ]
        ]
    },
    'feature-state': [
        ValueType,
        [StringType],
        (ctx, [key]) => get(key.evaluate(ctx), ctx.featureState || {})
    ],
    'properties': [
        ObjectType,
        [],
        ctx => ctx.properties()
    ],
    'geometry-type': [
        StringType,
        [],
        ctx => ctx.geometryType()
    ],
    'id': [
        ValueType,
        [],
        ctx => ctx.id()
    ],
    'zoom': [
        NumberType,
        [],
        ctx => ctx.globals.zoom
    ],
    'pitch': [
        NumberType,
        [],
        ctx => ctx.globals.pitch || 0
    ],
    'distance-from-center': [
        NumberType,
        [],
        ctx => ctx.distanceFromCenter()
    ],
    'heatmap-density': [
        NumberType,
        [],
        ctx => ctx.globals.heatmapDensity || 0
    ],
    'line-progress': [
        NumberType,
        [],
        ctx => ctx.globals.lineProgress || 0
    ],
    'sky-radial-progress': [
        NumberType,
        [],
        ctx => ctx.globals.skyRadialProgress || 0
    ],
    'accumulated': [
        ValueType,
        [],
        ctx => ctx.globals.accumulated === undefined ? null : ctx.globals.accumulated
    ],
    '+': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => {
            let result = 0;
            for (const arg of args) {
                result += arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '*': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => {
            let result = 1;
            for (const arg of args) {
                result *= arg.evaluate(ctx);
            }
            return result;
        }
    ],
    '-': {
        type: NumberType,
        overloads: [
            [
                [
                    NumberType,
                    NumberType
                ],
                (ctx, [a, b]) => a.evaluate(ctx) - b.evaluate(ctx)
            ],
            [
                [NumberType],
                (ctx, [a]) => -a.evaluate(ctx)
            ]
        ]
    },
    '/': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        (ctx, [a, b]) => a.evaluate(ctx) / b.evaluate(ctx)
    ],
    '%': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        (ctx, [a, b]) => a.evaluate(ctx) % b.evaluate(ctx)
    ],
    'ln2': [
        NumberType,
        [],
        () => Math.LN2
    ],
    'pi': [
        NumberType,
        [],
        () => Math.PI
    ],
    'e': [
        NumberType,
        [],
        () => Math.E
    ],
    '^': [
        NumberType,
        [
            NumberType,
            NumberType
        ],
        (ctx, [b, e]) => Math.pow(b.evaluate(ctx), e.evaluate(ctx))
    ],
    'sqrt': [
        NumberType,
        [NumberType],
        (ctx, [x]) => Math.sqrt(x.evaluate(ctx))
    ],
    'log10': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx)) / Math.LN10
    ],
    'ln': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx))
    ],
    'log2': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.log(n.evaluate(ctx)) / Math.LN2
    ],
    'sin': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.sin(n.evaluate(ctx))
    ],
    'cos': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.cos(n.evaluate(ctx))
    ],
    'tan': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.tan(n.evaluate(ctx))
    ],
    'asin': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.asin(n.evaluate(ctx))
    ],
    'acos': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.acos(n.evaluate(ctx))
    ],
    'atan': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.atan(n.evaluate(ctx))
    ],
    'min': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => Math.min(...args.map(arg => arg.evaluate(ctx)))
    ],
    'max': [
        NumberType,
        varargs(NumberType),
        (ctx, args) => Math.max(...args.map(arg => arg.evaluate(ctx)))
    ],
    'abs': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.abs(n.evaluate(ctx))
    ],
    'round': [
        NumberType,
        [NumberType],
        (ctx, [n]) => {
            const v = n.evaluate(ctx);
            // Javascript's Math.round() rounds towards +Infinity for halfway
            // values, even when they're negative. It's more common to round
            // away from 0 (e.g., this is what python and C++ do)
            return v < 0 ? -Math.round(-v) : Math.round(v);
        }
    ],
    'floor': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.floor(n.evaluate(ctx))
    ],
    'ceil': [
        NumberType,
        [NumberType],
        (ctx, [n]) => Math.ceil(n.evaluate(ctx))
    ],
    'filter-==': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        (ctx, [k, v]) => ctx.properties()[k.value] === v.value
    ],
    'filter-id-==': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => ctx.id() === v.value
    ],
    'filter-type-==': [
        BooleanType,
        [StringType],
        (ctx, [v]) => ctx.geometryType() === v.value
    ],
    'filter-<': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter-id-<': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a < b;
        }
    ],
    'filter->': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-id->': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a > b;
        }
    ],
    'filter-<=': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter-id-<=': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a <= b;
        }
    ],
    'filter->=': [
        BooleanType,
        [
            StringType,
            ValueType
        ],
        (ctx, [k, v]) => {
            const a = ctx.properties()[k.value];
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-id->=': [
        BooleanType,
        [ValueType],
        (ctx, [v]) => {
            const a = ctx.id();
            const b = v.value;
            return typeof a === typeof b && a >= b;
        }
    ],
    'filter-has': [
        BooleanType,
        [ValueType],
        (ctx, [k]) => k.value in ctx.properties()
    ],
    'filter-has-id': [
        BooleanType,
        [],
        ctx => ctx.id() !== null && ctx.id() !== undefined
    ],
    'filter-type-in': [
        BooleanType,
        [array$1(StringType)],
        (ctx, [v]) => v.value.indexOf(ctx.geometryType()) >= 0
    ],
    'filter-id-in': [
        BooleanType,
        [array$1(ValueType)],
        (ctx, [v]) => v.value.indexOf(ctx.id()) >= 0
    ],
    'filter-in-small': [
        BooleanType,
        [
            StringType,
            array$1(ValueType)
        ],
        // assumes v is an array literal
        (ctx, [k, v]) => v.value.indexOf(ctx.properties()[k.value]) >= 0
    ],
    'filter-in-large': [
        BooleanType,
        [
            StringType,
            array$1(ValueType)
        ],
        // assumes v is a array literal with values sorted in ascending order and of a single type
        (ctx, [k, v]) => binarySearch(ctx.properties()[k.value], v.value, 0, v.value.length - 1)
    ],
    'all': {
        type: BooleanType,
        overloads: [
            [
                [
                    BooleanType,
                    BooleanType
                ],
                (ctx, [a, b]) => a.evaluate(ctx) && b.evaluate(ctx)
            ],
            [
                varargs(BooleanType),
                (ctx, args) => {
                    for (const arg of args) {
                        if (!arg.evaluate(ctx))
                            return false;
                    }
                    return true;
                }
            ]
        ]
    },
    'any': {
        type: BooleanType,
        overloads: [
            [
                [
                    BooleanType,
                    BooleanType
                ],
                (ctx, [a, b]) => a.evaluate(ctx) || b.evaluate(ctx)
            ],
            [
                varargs(BooleanType),
                (ctx, args) => {
                    for (const arg of args) {
                        if (arg.evaluate(ctx))
                            return true;
                    }
                    return false;
                }
            ]
        ]
    },
    '!': [
        BooleanType,
        [BooleanType],
        (ctx, [b]) => !b.evaluate(ctx)
    ],
    'is-supported-script': [
        BooleanType,
        [StringType],
        // At parse time this will always return true, so we need to exclude this expression with isGlobalPropertyConstant
        (ctx, [s]) => {
            const isSupportedScript = ctx.globals && ctx.globals.isSupportedScript;
            if (isSupportedScript) {
                return isSupportedScript(s.evaluate(ctx));
            }
            return true;
        }
    ],
    'upcase': [
        StringType,
        [StringType],
        (ctx, [s]) => s.evaluate(ctx).toUpperCase()
    ],
    'downcase': [
        StringType,
        [StringType],
        (ctx, [s]) => s.evaluate(ctx).toLowerCase()
    ],
    'concat': [
        StringType,
        varargs(ValueType),
        (ctx, args) => args.map(arg => toString(arg.evaluate(ctx))).join('')
    ],
    'resolved-locale': [
        StringType,
        [CollatorType],
        (ctx, [collator]) => collator.evaluate(ctx).resolvedLocale()
    ]
});
var definitions = expressions;

//      
/**
 * A type used for returning and propagating errors. The first element of the union
 * represents success and contains a value, and the second represents an error and
 * contains an error value.
 * @private
 */
function success(value) {
    return {
        result: 'success',
        value
    };
}
function error(value) {
    return {
        result: 'error',
        value
    };
}

//      
function supportsPropertyExpression(spec) {
    return spec['property-type'] === 'data-driven';
}
function supportsZoomExpression(spec) {
    return !!spec.expression && spec.expression.parameters.indexOf('zoom') > -1;
}
function supportsInterpolation(spec) {
    return !!spec.expression && spec.expression.interpolated;
}

//      
function getType(val) {
    if (val instanceof Number) {
        return 'number';
    } else if (val instanceof String) {
        return 'string';
    } else if (val instanceof Boolean) {
        return 'boolean';
    } else if (Array.isArray(val)) {
        return 'array';
    } else if (val === null) {
        return 'null';
    } else {
        return typeof val;
    }
}

function isFunction(value) {
    return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function identityFunction(x) {
    return x;
}
function createFunction(parameters, propertySpec) {
    const isColor = propertySpec.type === 'color';
    const zoomAndFeatureDependent = parameters.stops && typeof parameters.stops[0][0] === 'object';
    const featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    const zoomDependent = zoomAndFeatureDependent || !featureDependent;
    const type = parameters.type || (supportsInterpolation(propertySpec) ? 'exponential' : 'interval');
    if (isColor) {
        parameters = extend({}, parameters);
        if (parameters.stops) {
            parameters.stops = parameters.stops.map(stop => {
                return [
                    stop[0],
                    Color$1.parse(stop[1])
                ];
            });
        }
        if (parameters.default) {
            parameters.default = Color$1.parse(parameters.default);
        } else {
            parameters.default = Color$1.parse(propertySpec.default);
        }
    }
    if (parameters.colorSpace && parameters.colorSpace !== 'rgb' && !colorSpaces[parameters.colorSpace]) {
        // eslint-disable-line import/namespace
        throw new Error(`Unknown color space: ${ parameters.colorSpace }`);
    }
    let innerFun;
    let hashedStops;
    let categoricalKeyType;
    if (type === 'exponential') {
        innerFun = evaluateExponentialFunction;
    } else if (type === 'interval') {
        innerFun = evaluateIntervalFunction;
    } else if (type === 'categorical') {
        innerFun = evaluateCategoricalFunction;
        // For categorical functions, generate an Object as a hashmap of the stops for fast searching
        hashedStops = Object.create(null);
        for (const stop of parameters.stops) {
            hashedStops[stop[0]] = stop[1];
        }
        // Infer key type based on first stop key-- used to encforce strict type checking later
        categoricalKeyType = typeof parameters.stops[0][0];
    } else if (type === 'identity') {
        innerFun = evaluateIdentityFunction;
    } else {
        throw new Error(`Unknown function type "${ type }"`);
    }
    if (zoomAndFeatureDependent) {
        const featureFunctions = {};
        const zoomStops = [];
        for (let s = 0; s < parameters.stops.length; s++) {
            const stop = parameters.stops[s];
            const zoom = stop[0].zoom;
            if (featureFunctions[zoom] === undefined) {
                featureFunctions[zoom] = {
                    zoom,
                    type: parameters.type,
                    property: parameters.property,
                    default: parameters.default,
                    stops: []
                };
                zoomStops.push(zoom);
            }
            featureFunctions[zoom].stops.push([
                stop[0].value,
                stop[1]
            ]);
        }
        const featureFunctionStops = [];
        for (const z of zoomStops) {
            featureFunctionStops.push([
                featureFunctions[z].zoom,
                createFunction(featureFunctions[z], propertySpec)
            ]);
        }
        const interpolationType = { name: 'linear' };
        return {
            kind: 'composite',
            interpolationType,
            interpolationFactor: Interpolate$1.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: featureFunctionStops.map(s => s[0]),
            evaluate({zoom}, properties) {
                return evaluateExponentialFunction({
                    stops: featureFunctionStops,
                    base: parameters.base
                }, propertySpec, zoom).evaluate(zoom, properties);
            }
        };
    } else if (zoomDependent) {
        const interpolationType = type === 'exponential' ? {
            name: 'exponential',
            base: parameters.base !== undefined ? parameters.base : 1
        } : null;
        return {
            kind: 'camera',
            interpolationType,
            interpolationFactor: Interpolate$1.interpolationFactor.bind(undefined, interpolationType),
            zoomStops: parameters.stops.map(s => s[0]),
            evaluate: ({zoom}) => innerFun(parameters, propertySpec, zoom, hashedStops, categoricalKeyType)
        };
    } else {
        return {
            kind: 'source',
            evaluate(_, feature) {
                const value = feature && feature.properties ? feature.properties[parameters.property] : undefined;
                if (value === undefined) {
                    return coalesce$1(parameters.default, propertySpec.default);
                }
                return innerFun(parameters, propertySpec, value, hashedStops, categoricalKeyType);
            }
        };
    }
}
function coalesce$1(a, b, c) {
    if (a !== undefined)
        return a;
    if (b !== undefined)
        return b;
    if (c !== undefined)
        return c;
}
function evaluateCategoricalFunction(parameters, propertySpec, input, hashedStops, keyType) {
    const evaluated = typeof input === keyType ? hashedStops[input] : undefined;
    // Enforce strict typing on input
    return coalesce$1(evaluated, parameters.default, propertySpec.default);
}
function evaluateIntervalFunction(parameters, propertySpec, input) {
    // Edge cases
    if (getType(input) !== 'number')
        return coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1)
        return parameters.stops[0][1];
    if (input <= parameters.stops[0][0])
        return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0])
        return parameters.stops[n - 1][1];
    const index = findStopLessThanOrEqualTo(parameters.stops.map(stop => stop[0]), input);
    return parameters.stops[index][1];
}
function evaluateExponentialFunction(parameters, propertySpec, input) {
    const base = parameters.base !== undefined ? parameters.base : 1;
    // Edge cases
    if (getType(input) !== 'number')
        return coalesce$1(parameters.default, propertySpec.default);
    const n = parameters.stops.length;
    if (n === 1)
        return parameters.stops[0][1];
    if (input <= parameters.stops[0][0])
        return parameters.stops[0][1];
    if (input >= parameters.stops[n - 1][0])
        return parameters.stops[n - 1][1];
    const index = findStopLessThanOrEqualTo(parameters.stops.map(stop => stop[0]), input);
    const t = interpolationFactor(input, base, parameters.stops[index][0], parameters.stops[index + 1][0]);
    const outputLower = parameters.stops[index][1];
    const outputUpper = parameters.stops[index + 1][1];
    let interp = interpolate[propertySpec.type] || identityFunction;
    // eslint-disable-line import/namespace
    if (parameters.colorSpace && parameters.colorSpace !== 'rgb') {
        const colorspace = colorSpaces[parameters.colorSpace];
        // eslint-disable-line import/namespace
        interp = (a, b) => colorspace.reverse(colorspace.interpolate(colorspace.forward(a), colorspace.forward(b), t));
    }
    if (typeof outputLower.evaluate === 'function') {
        return {
            evaluate(...args) {
                const evaluatedLower = outputLower.evaluate.apply(undefined, args);
                const evaluatedUpper = outputUpper.evaluate.apply(undefined, args);
                // Special case for fill-outline-color, which has no spec default.
                if (evaluatedLower === undefined || evaluatedUpper === undefined) {
                    return undefined;
                }
                return interp(evaluatedLower, evaluatedUpper, t);
            }
        };
    }
    return interp(outputLower, outputUpper, t);
}
function evaluateIdentityFunction(parameters, propertySpec, input) {
    if (propertySpec.type === 'color') {
        input = Color$1.parse(input);
    } else if (propertySpec.type === 'formatted') {
        input = Formatted.fromString(input.toString());
    } else if (propertySpec.type === 'resolvedImage') {
        input = ResolvedImage.fromString(input.toString());
    } else if (getType(input) !== propertySpec.type && (propertySpec.type !== 'enum' || !propertySpec.values[input])) {
        input = undefined;
    }
    return coalesce$1(input, parameters.default, propertySpec.default);
}
/**
 * Returns a ratio that can be used to interpolate between exponential function
 * stops.
 *
 * How it works:
 * Two consecutive stop values define a (scaled and shifted) exponential
 * function `f(x) = a * base^x + b`, where `base` is the user-specified base,
 * and `a` and `b` are constants affording sufficient degrees of freedom to fit
 * the function to the given stops.
 *
 * Here's a bit of algebra that lets us compute `f(x)` directly from the stop
 * values without explicitly solving for `a` and `b`:
 *
 * First stop value: `f(x0) = y0 = a * base^x0 + b`
 * Second stop value: `f(x1) = y1 = a * base^x1 + b`
 * => `y1 - y0 = a(base^x1 - base^x0)`
 * => `a = (y1 - y0)/(base^x1 - base^x0)`
 *
 * Desired value: `f(x) = y = a * base^x + b`
 * => `f(x) = y0 + a * (base^x - base^x0)`
 *
 * From the above, we can replace the `a` in `a * (base^x - base^x0)` and do a
 * little algebra:
 * ```
 * a * (base^x - base^x0) = (y1 - y0)/(base^x1 - base^x0) * (base^x - base^x0)
 *                     = (y1 - y0) * (base^x - base^x0) / (base^x1 - base^x0)
 * ```
 *
 * If we let `(base^x - base^x0) / (base^x1 base^x0)`, then we have
 * `f(x) = y0 + (y1 - y0) * ratio`.  In other words, `ratio` may be treated as
 * an interpolation factor between the two stops' output values.
 *
 * (Note: a slightly different form for `ratio`,
 * `(base^(x-x0) - 1) / (base^(x1-x0) - 1) `, is equivalent, but requires fewer
 * expensive `Math.pow()` operations.)
 *
 * @private
 */
function interpolationFactor(input, base, lowerValue, upperValue) {
    const difference = upperValue - lowerValue;
    const progress = input - lowerValue;
    if (difference === 0) {
        return 0;
    } else if (base === 1) {
        return progress / difference;
    } else {
        return (Math.pow(base, progress) - 1) / (Math.pow(base, difference) - 1);
    }
}

class StyleExpression {
    constructor(expression, propertySpec) {
        this.expression = expression;
        this._warningHistory = {};
        this._evaluator = new EvaluationContext$1();
        this._defaultValue = propertySpec ? getDefaultValue(propertySpec) : null;
        this._enumValues = propertySpec && propertySpec.type === 'enum' ? propertySpec.values : null;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection, featureTileCoord, featureDistanceData) {
        this._evaluator.globals = globals;
        this._evaluator.feature = feature;
        this._evaluator.featureState = featureState;
        this._evaluator.canonical = canonical || null;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection;
        this._evaluator.featureTileCoord = featureTileCoord || null;
        this._evaluator.featureDistanceData = featureDistanceData || null;
        return this.expression.evaluate(this._evaluator);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection, featureTileCoord, featureDistanceData) {
        this._evaluator.globals = globals;
        this._evaluator.feature = feature || null;
        this._evaluator.featureState = featureState || null;
        this._evaluator.canonical = canonical || null;
        this._evaluator.availableImages = availableImages || null;
        this._evaluator.formattedSection = formattedSection || null;
        this._evaluator.featureTileCoord = featureTileCoord || null;
        this._evaluator.featureDistanceData = featureDistanceData || null;
        try {
            const val = this.expression.evaluate(this._evaluator);
            // eslint-disable-next-line no-self-compare
            if (val === null || val === undefined || typeof val === 'number' && val !== val) {
                return this._defaultValue;
            }
            if (this._enumValues && !(val in this._enumValues)) {
                throw new RuntimeError$1(`Expected value to be one of ${ Object.keys(this._enumValues).map(v => JSON.stringify(v)).join(', ') }, but found ${ JSON.stringify(val) } instead.`);
            }
            return val;
        } catch (e) {
            if (!this._warningHistory[e.message]) {
                this._warningHistory[e.message] = true;
                if (typeof console !== 'undefined') {
                    console.warn(e.message);
                }
            }
            return this._defaultValue;
        }
    }
}
function isExpression(expression) {
    return Array.isArray(expression) && expression.length > 0 && typeof expression[0] === 'string' && expression[0] in definitions;
}
/**
 * Parse and typecheck the given style spec JSON expression.  If
 * options.defaultValue is provided, then the resulting StyleExpression's
 * `evaluate()` method will handle errors by logging a warning (once per
 * message) and returning the default value.  Otherwise, it will throw
 * evaluation errors.
 *
 * @private
 */
function createExpression(expression, propertySpec) {
    const parser = new ParsingContext$1(definitions, [], propertySpec ? getExpectedType(propertySpec) : undefined);
    // For string-valued properties, coerce to string at the top level rather than asserting.
    const parsed = parser.parse(expression, undefined, undefined, undefined, propertySpec && propertySpec.type === 'string' ? { typeAnnotation: 'coerce' } : undefined);
    if (!parsed) {
        return error(parser.errors);
    }
    return success(new StyleExpression(parsed, propertySpec));
}
class ZoomConstantExpression {
    constructor(kind, expression) {
        this.kind = kind;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'constant' && !isStateConstant(expression.expression);
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
}
class ZoomDependentExpression {
    constructor(kind, expression, zoomStops, interpolationType) {
        this.kind = kind;
        this.zoomStops = zoomStops;
        this._styleExpression = expression;
        this.isStateDependent = kind !== 'camera' && !isStateConstant(expression.expression);
        this.interpolationType = interpolationType;
    }
    evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluateWithoutErrorHandling(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    evaluate(globals, feature, featureState, canonical, availableImages, formattedSection) {
        return this._styleExpression.evaluate(globals, feature, featureState, canonical, availableImages, formattedSection);
    }
    interpolationFactor(input, lower, upper) {
        if (this.interpolationType) {
            return Interpolate$1.interpolationFactor(this.interpolationType, input, lower, upper);
        } else {
            return 0;
        }
    }
}
function createPropertyExpression(expression, propertySpec) {
    expression = createExpression(expression, propertySpec);
    if (expression.result === 'error') {
        return expression;
    }
    const parsed = expression.value.expression;
    const isFeatureConstant$1 = isFeatureConstant(parsed);
    if (!isFeatureConstant$1 && !supportsPropertyExpression(propertySpec)) {
        return error([new ParsingError$2('', 'data expressions not supported')]);
    }
    const isZoomConstant = isGlobalPropertyConstant(parsed, [
        'zoom',
        'pitch',
        'distance-from-center'
    ]);
    if (!isZoomConstant && !supportsZoomExpression(propertySpec)) {
        return error([new ParsingError$2('', 'zoom expressions not supported')]);
    }
    const zoomCurve = findZoomCurve(parsed);
    if (!zoomCurve && !isZoomConstant) {
        return error([new ParsingError$2('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);
    } else if (zoomCurve instanceof ParsingError$2) {
        return error([zoomCurve]);
    } else if (zoomCurve instanceof Interpolate$1 && !supportsInterpolation(propertySpec)) {
        return error([new ParsingError$2('', '"interpolate" expressions cannot be used with this property')]);
    }
    if (!zoomCurve) {
        return success(isFeatureConstant$1 ? new ZoomConstantExpression('constant', expression.value) : new ZoomConstantExpression('source', expression.value));
    }
    const interpolationType = zoomCurve instanceof Interpolate$1 ? zoomCurve.interpolation : undefined;
    return success(isFeatureConstant$1 ? new ZoomDependentExpression('camera', expression.value, zoomCurve.labels, interpolationType) : new ZoomDependentExpression('composite', expression.value, zoomCurve.labels, interpolationType));
}
// serialization wrapper for old-style stop functions normalized to the
// expression interface
class StylePropertyFunction {
    constructor(parameters, specification) {
        this._parameters = parameters;
        this._specification = specification;
        extend(this, createFunction(this._parameters, this._specification));
    }
    static deserialize(serialized) {
        return new StylePropertyFunction(serialized._parameters, serialized._specification);
    }
    static serialize(input) {
        return {
            _parameters: input._parameters,
            _specification: input._specification
        };
    }
}
function normalizePropertyExpression(value, specification) {
    if (isFunction(value)) {
        return new StylePropertyFunction(value, specification);
    } else if (isExpression(value)) {
        const expression = createPropertyExpression(value, specification);
        if (expression.result === 'error') {
            // this should have been caught in validation
            throw new Error(expression.value.map(err => `${ err.key }: ${ err.message }`).join(', '));
        }
        return expression.value;
    } else {
        let constant = value;
        if (typeof value === 'string' && specification.type === 'color') {
            constant = Color$1.parse(value);
        }
        return {
            kind: 'constant',
            evaluate: () => constant
        };
    }
}
// Zoom-dependent expressions may only use ["zoom"] as the input to a top-level "step" or "interpolate"
// expression (collectively referred to as a "curve"). The curve may be wrapped in one or more "let" or
// "coalesce" expressions.
function findZoomCurve(expression) {
    let result = null;
    if (expression instanceof Let$1) {
        result = findZoomCurve(expression.result);
    } else if (expression instanceof Coalesce$1) {
        for (const arg of expression.args) {
            result = findZoomCurve(arg);
            if (result) {
                break;
            }
        }
    } else if ((expression instanceof Step$1 || expression instanceof Interpolate$1) && expression.input instanceof CompoundExpression$1 && expression.input.name === 'zoom') {
        result = expression;
    }
    if (result instanceof ParsingError$2) {
        return result;
    }
    expression.eachChild(child => {
        const childResult = findZoomCurve(child);
        if (childResult instanceof ParsingError$2) {
            result = childResult;
        } else if (!result && childResult) {
            result = new ParsingError$2('', '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.');
        } else if (result && childResult && result !== childResult) {
            result = new ParsingError$2('', 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.');
        }
    });
    return result;
}
function getExpectedType(spec) {
    const types = {
        color: ColorType,
        string: StringType,
        number: NumberType,
        enum: StringType,
        boolean: BooleanType,
        formatted: FormattedType,
        resolvedImage: ResolvedImageType
    };
    if (spec.type === 'array') {
        return array$1(types[spec.value] || ValueType, spec.length);
    }
    return types[spec.type];
}
function getDefaultValue(spec) {
    if (spec.type === 'color' && (isFunction(spec.default) || Array.isArray(spec.default))) {
        // Special case for heatmap-color: it uses the 'default:' to define a
        // default color ramp, but createExpression expects a simple value to fall
        // back to in case of runtime errors
        return new Color$1(0, 0, 0, 0);
    } else if (spec.type === 'color') {
        return Color$1.parse(spec.default) || null;
    } else if (spec.default === undefined) {
        return null;
    } else {
        return spec.default;
    }
}

function convertLiteral(value) {
    return typeof value === 'object' ? [
        'literal',
        value
    ] : value;
}
function convertFunction(parameters, propertySpec) {
    let stops = parameters.stops;
    if (!stops) {
        // identity function
        return convertIdentityFunction(parameters, propertySpec);
    }
    const zoomAndFeatureDependent = stops && typeof stops[0][0] === 'object';
    const featureDependent = zoomAndFeatureDependent || parameters.property !== undefined;
    const zoomDependent = zoomAndFeatureDependent || !featureDependent;
    stops = stops.map(stop => {
        if (!featureDependent && propertySpec.tokens && typeof stop[1] === 'string') {
            return [
                stop[0],
                convertTokenString(stop[1])
            ];
        }
        return [
            stop[0],
            convertLiteral(stop[1])
        ];
    });
    if (zoomAndFeatureDependent) {
        return convertZoomAndPropertyFunction(parameters, propertySpec, stops);
    } else if (zoomDependent) {
        return convertZoomFunction(parameters, propertySpec, stops);
    } else {
        return convertPropertyFunction(parameters, propertySpec, stops);
    }
}
function convertIdentityFunction(parameters, propertySpec) {
    const get = [
        'get',
        parameters.property
    ];
    if (parameters.default === undefined) {
        // By default, expressions for string-valued properties get coerced. To preserve
        // legacy function semantics, insert an explicit assertion instead.
        return propertySpec.type === 'string' ? [
            'string',
            get
        ] : get;
    } else if (propertySpec.type === 'enum') {
        return [
            'match',
            get,
            Object.keys(propertySpec.values),
            get,
            parameters.default
        ];
    } else {
        const expression = [
            propertySpec.type === 'color' ? 'to-color' : propertySpec.type,
            get,
            convertLiteral(parameters.default)
        ];
        if (propertySpec.type === 'array') {
            expression.splice(1, 0, propertySpec.value, propertySpec.length || null);
        }
        return expression;
    }
}
function getInterpolateOperator(parameters) {
    switch (parameters.colorSpace) {
    case 'hcl':
        return 'interpolate-hcl';
    case 'lab':
        return 'interpolate-lab';
    default:
        return 'interpolate';
    }
}
function convertZoomAndPropertyFunction(parameters, propertySpec, stops) {
    const featureFunctionParameters = {};
    const featureFunctionStops = {};
    const zoomStops = [];
    for (let s = 0; s < stops.length; s++) {
        const stop = stops[s];
        const zoom = stop[0].zoom;
        if (featureFunctionParameters[zoom] === undefined) {
            featureFunctionParameters[zoom] = {
                zoom,
                type: parameters.type,
                property: parameters.property,
                default: parameters.default
            };
            featureFunctionStops[zoom] = [];
            zoomStops.push(zoom);
        }
        featureFunctionStops[zoom].push([
            stop[0].value,
            stop[1]
        ]);
    }
    // the interpolation type for the zoom dimension of a zoom-and-property
    // function is determined directly from the style property specification
    // for which it's being used: linear for interpolatable properties, step
    // otherwise.
    const functionType = getFunctionType({}, propertySpec);
    if (functionType === 'exponential') {
        const expression = [
            getInterpolateOperator(parameters),
            ['linear'],
            ['zoom']
        ];
        for (const z of zoomStops) {
            const output = convertPropertyFunction(featureFunctionParameters[z], propertySpec, featureFunctionStops[z]);
            appendStopPair(expression, z, output, false);
        }
        return expression;
    } else {
        const expression = [
            'step',
            ['zoom']
        ];
        for (const z of zoomStops) {
            const output = convertPropertyFunction(featureFunctionParameters[z], propertySpec, featureFunctionStops[z]);
            appendStopPair(expression, z, output, true);
        }
        fixupDegenerateStepCurve(expression);
        return expression;
    }
}
function coalesce(a, b) {
    if (a !== undefined)
        return a;
    if (b !== undefined)
        return b;
}
function getFallback(parameters, propertySpec) {
    const defaultValue = convertLiteral(coalesce(parameters.default, propertySpec.default));
    /*
     * Some fields with type: resolvedImage have an undefined default.
     * Because undefined is an invalid value for resolvedImage, set fallback to
     * an empty string instead of undefined to ensure output
     * passes validation.
     */
    if (defaultValue === undefined && propertySpec.type === 'resolvedImage') {
        return '';
    }
    return defaultValue;
}
function convertPropertyFunction(parameters, propertySpec, stops) {
    const type = getFunctionType(parameters, propertySpec);
    const get = [
        'get',
        parameters.property
    ];
    if (type === 'categorical' && typeof stops[0][0] === 'boolean') {
        const expression = ['case'];
        for (const stop of stops) {
            expression.push([
                '==',
                get,
                stop[0]
            ], stop[1]);
        }
        expression.push(getFallback(parameters, propertySpec));
        return expression;
    } else if (type === 'categorical') {
        const expression = [
            'match',
            get
        ];
        for (const stop of stops) {
            appendStopPair(expression, stop[0], stop[1], false);
        }
        expression.push(getFallback(parameters, propertySpec));
        return expression;
    } else if (type === 'interval') {
        const expression = [
            'step',
            [
                'number',
                get
            ]
        ];
        for (const stop of stops) {
            appendStopPair(expression, stop[0], stop[1], true);
        }
        fixupDegenerateStepCurve(expression);
        return parameters.default === undefined ? expression : [
            'case',
            [
                '==',
                [
                    'typeof',
                    get
                ],
                'number'
            ],
            expression,
            convertLiteral(parameters.default)
        ];
    } else if (type === 'exponential') {
        const base = parameters.base !== undefined ? parameters.base : 1;
        const expression = [
            getInterpolateOperator(parameters),
            base === 1 ? ['linear'] : [
                'exponential',
                base
            ],
            [
                'number',
                get
            ]
        ];
        for (const stop of stops) {
            appendStopPair(expression, stop[0], stop[1], false);
        }
        return parameters.default === undefined ? expression : [
            'case',
            [
                '==',
                [
                    'typeof',
                    get
                ],
                'number'
            ],
            expression,
            convertLiteral(parameters.default)
        ];
    } else {
        throw new Error(`Unknown property function type ${ type }`);
    }
}
function convertZoomFunction(parameters, propertySpec, stops, input = ['zoom']) {
    const type = getFunctionType(parameters, propertySpec);
    let expression;
    let isStep = false;
    if (type === 'interval') {
        expression = [
            'step',
            input
        ];
        isStep = true;
    } else if (type === 'exponential') {
        const base = parameters.base !== undefined ? parameters.base : 1;
        expression = [
            getInterpolateOperator(parameters),
            base === 1 ? ['linear'] : [
                'exponential',
                base
            ],
            input
        ];
    } else {
        throw new Error(`Unknown zoom function type "${ type }"`);
    }
    for (const stop of stops) {
        appendStopPair(expression, stop[0], stop[1], isStep);
    }
    fixupDegenerateStepCurve(expression);
    return expression;
}
function fixupDegenerateStepCurve(expression) {
    // degenerate step curve (i.e. a constant function): add a noop stop
    if (expression[0] === 'step' && expression.length === 3) {
        expression.push(0);
        expression.push(expression[3]);
    }
}
function appendStopPair(curve, input, output, isStep) {
    // Skip duplicate stop values. They were not validated for functions, but they are for expressions.
    // https://github.com/mapbox/mapbox-gl-js/issues/4107
    if (curve.length > 3 && input === curve[curve.length - 2]) {
        return;
    }
    // step curves don't get the first input value, as it is redundant.
    if (!(isStep && curve.length === 2)) {
        curve.push(input);
    }
    curve.push(output);
}
function getFunctionType(parameters, propertySpec) {
    if (parameters.type) {
        return parameters.type;
    } else {
        return propertySpec.expression.interpolated ? 'exponential' : 'interval';
    }
}
// "String with {name} token" => ["concat", "String with ", ["get", "name"], " token"]
function convertTokenString(s) {
    const result = ['concat'];
    const re = /{([^{}]+)}/g;
    let pos = 0;
    for (let match = re.exec(s); match !== null; match = re.exec(s)) {
        const literal = s.slice(pos, re.lastIndex - match[0].length);
        pos = re.lastIndex;
        if (literal.length > 0)
            result.push(literal);
        result.push([
            'get',
            match[1]
        ]);
    }
    if (result.length === 1) {
        return s;
    }
    if (pos < s.length) {
        result.push(s.slice(pos));
    } else if (result.length === 2) {
        return [
            'to-string',
            result[1]
        ];
    }
    return result;
}

//      
// Turn jsonlint-lines-primitives objects into primitive objects
function unbundle(value) {
    if (value instanceof Number || value instanceof String || value instanceof Boolean) {
        return value.valueOf();
    } else {
        return value;
    }
}
function deepUnbundle(value) {
    if (Array.isArray(value)) {
        return value.map(deepUnbundle);
    } else if (value instanceof Object && !(value instanceof Number || value instanceof String || value instanceof Boolean)) {
        const unbundledValue = {};
        for (const key in value) {
            unbundledValue[key] = deepUnbundle(value[key]);
        }
        return unbundledValue;
    }
    return unbundle(value);
}

//      
function isExpressionFilter(filter) {
    if (filter === true || filter === false) {
        return true;
    }
    if (!Array.isArray(filter) || filter.length === 0) {
        return false;
    }
    switch (filter[0]) {
    case 'has':
        return filter.length >= 2 && filter[1] !== '$id' && filter[1] !== '$type';
    case 'in':
        return filter.length >= 3 && (typeof filter[1] !== 'string' || Array.isArray(filter[2]));
    case '!in':
    case '!has':
    case 'none':
        return false;
    case '==':
    case '!=':
    case '>':
    case '>=':
    case '<':
    case '<=':
        return filter.length !== 3 || (Array.isArray(filter[1]) || Array.isArray(filter[2]));
    case 'any':
    case 'all':
        for (const f of filter.slice(1)) {
            if (!isExpressionFilter(f) && typeof f !== 'boolean') {
                return false;
            }
        }
        return true;
    default:
        return true;
    }
}
/**
 * Given a filter expressed as nested arrays, return a new function
 * that evaluates whether a given feature (with a .properties or .tags property)
 * passes its test.
 *
 * @private
 * @param {Array} filter mapbox gl filter
 * @param {string} layerType the type of the layer this filter will be applied to.
 * @returns {Function} filter-evaluating function
 */
function createFilter(filter, layerType = 'fill') {
    if (filter === null || filter === undefined) {
        return {
            filter: () => true,
            needGeometry: false,
            needFeature: false
        };
    }
    if (!isExpressionFilter(filter)) {
        filter = convertFilter$1(filter);
    }
    const filterExp = filter;
    let staticFilter = true;
    try {
        staticFilter = extractStaticFilter(filterExp);
    } catch (e) {
        console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.
This is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md
and paste the contents of this message in the report.
Thank you!
Filter Expression:
${ JSON.stringify(filterExp, null, 2) }
        `);
    }
    // Compile the static component of the filter
    const filterSpec = v8[`filter_${ layerType }`];
    const compiledStaticFilter = createExpression(staticFilter, filterSpec);
    let filterFunc = null;
    if (compiledStaticFilter.result === 'error') {
        throw new Error(compiledStaticFilter.value.map(err => `${ err.key }: ${ err.message }`).join(', '));
    } else {
        filterFunc = (globalProperties, feature, canonical) => compiledStaticFilter.value.evaluate(globalProperties, feature, {}, canonical);
    }
    // If the static component is not equal to the entire filter then we have a dynamic component
    // Compile the dynamic component separately
    let dynamicFilterFunc = null;
    let needFeature = null;
    if (staticFilter !== filterExp) {
        const compiledDynamicFilter = createExpression(filterExp, filterSpec);
        if (compiledDynamicFilter.result === 'error') {
            throw new Error(compiledDynamicFilter.value.map(err => `${ err.key }: ${ err.message }`).join(', '));
        } else {
            dynamicFilterFunc = (globalProperties, feature, canonical, featureTileCoord, featureDistanceData) => compiledDynamicFilter.value.evaluate(globalProperties, feature, {}, canonical, undefined, undefined, featureTileCoord, featureDistanceData);
            needFeature = !isFeatureConstant(compiledDynamicFilter.value.expression);
        }
    }
    filterFunc = filterFunc;
    const needGeometry = geometryNeeded(staticFilter);
    return {
        filter: filterFunc,
        dynamicFilter: dynamicFilterFunc ? dynamicFilterFunc : undefined,
        needGeometry,
        needFeature: !!needFeature
    };
}
function extractStaticFilter(filter) {
    if (!isDynamicFilter(filter)) {
        return filter;
    }
    // Shallow copy so we can replace expressions in-place
    let result = deepUnbundle(filter);
    // 1. Union branches
    unionDynamicBranches(result);
    // 2. Collapse dynamic conditions to  `true`
    result = collapseDynamicBooleanExpressions(result);
    return result;
}
function collapseDynamicBooleanExpressions(expression) {
    if (!Array.isArray(expression)) {
        return expression;
    }
    const collapsed = collapsedExpression(expression);
    if (collapsed === true) {
        return collapsed;
    } else {
        return collapsed.map(subExpression => collapseDynamicBooleanExpressions(subExpression));
    }
}
/**
 * Traverses the expression and replaces all instances of branching on a
 * `dynamic` conditional (such as `['pitch']` or `['distance-from-center']`)
 * into an `any` expression.
 * This ensures that all possible outcomes of a `dynamic` branch are considered
 * when evaluating the expression upfront during filtering.
 *
 * @param {Array<any>} filter the filter expression mutated in-place.
 */
function unionDynamicBranches(filter) {
    let isBranchingDynamically = false;
    const branches = [];
    if (filter[0] === 'case') {
        for (let i = 1; i < filter.length - 1; i += 2) {
            isBranchingDynamically = isBranchingDynamically || isDynamicFilter(filter[i]);
            branches.push(filter[i + 1]);
        }
        branches.push(filter[filter.length - 1]);
    } else if (filter[0] === 'match') {
        isBranchingDynamically = isBranchingDynamically || isDynamicFilter(filter[1]);
        for (let i = 2; i < filter.length - 1; i += 2) {
            branches.push(filter[i + 1]);
        }
        branches.push(filter[filter.length - 1]);
    } else if (filter[0] === 'step') {
        isBranchingDynamically = isBranchingDynamically || isDynamicFilter(filter[1]);
        for (let i = 1; i < filter.length - 1; i += 2) {
            branches.push(filter[i + 1]);
        }
    }
    if (isBranchingDynamically) {
        filter.length = 0;
        filter.push('any', ...branches);
    }
    // traverse and recurse into children
    for (let i = 1; i < filter.length; i++) {
        unionDynamicBranches(filter[i]);
    }
}
function isDynamicFilter(filter) {
    // Base Cases
    if (!Array.isArray(filter)) {
        return false;
    }
    if (isRootExpressionDynamic(filter[0])) {
        return true;
    }
    for (let i = 1; i < filter.length; i++) {
        const child = filter[i];
        if (isDynamicFilter(child)) {
            return true;
        }
    }
    return false;
}
function isRootExpressionDynamic(expression) {
    return expression === 'pitch' || expression === 'distance-from-center';
}
const dynamicConditionExpressions = new Set([
    'in',
    '==',
    '!=',
    '>',
    '>=',
    '<',
    '<=',
    'to-boolean'
]);
function collapsedExpression(expression) {
    if (dynamicConditionExpressions.has(expression[0])) {
        for (let i = 1; i < expression.length; i++) {
            const param = expression[i];
            if (isDynamicFilter(param)) {
                return true;
            }
        }
    }
    return expression;
}
// Comparison function to sort numbers and strings
function compare(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
function geometryNeeded(filter) {
    if (!Array.isArray(filter))
        return false;
    if (filter[0] === 'within')
        return true;
    for (let index = 1; index < filter.length; index++) {
        if (geometryNeeded(filter[index]))
            return true;
    }
    return false;
}
function convertFilter$1(filter) {
    if (!filter)
        return true;
    const op = filter[0];
    if (filter.length <= 1)
        return op !== 'any';
    const converted = op === '==' ? convertComparisonOp$1(filter[1], filter[2], '==') : op === '!=' ? convertNegation(convertComparisonOp$1(filter[1], filter[2], '==')) : op === '<' || op === '>' || op === '<=' || op === '>=' ? convertComparisonOp$1(filter[1], filter[2], op) : op === 'any' ? convertDisjunctionOp(filter.slice(1)) : op === 'all' ? ['all'].concat(filter.slice(1).map(convertFilter$1)) : op === 'none' ? ['all'].concat(filter.slice(1).map(convertFilter$1).map(convertNegation)) : op === 'in' ? convertInOp$1(filter[1], filter.slice(2)) : op === '!in' ? convertNegation(convertInOp$1(filter[1], filter.slice(2))) : op === 'has' ? convertHasOp$1(filter[1]) : op === '!has' ? convertNegation(convertHasOp$1(filter[1])) : op === 'within' ? filter : true;
    return converted;
}
function convertComparisonOp$1(property, value, op) {
    switch (property) {
    case '$type':
        return [
            `filter-type-${ op }`,
            value
        ];
    case '$id':
        return [
            `filter-id-${ op }`,
            value
        ];
    default:
        return [
            `filter-${ op }`,
            property,
            value
        ];
    }
}
function convertDisjunctionOp(filters) {
    return ['any'].concat(filters.map(convertFilter$1));
}
function convertInOp$1(property, values) {
    if (values.length === 0) {
        return false;
    }
    switch (property) {
    case '$type':
        return [
            `filter-type-in`,
            [
                'literal',
                values
            ]
        ];
    case '$id':
        return [
            `filter-id-in`,
            [
                'literal',
                values
            ]
        ];
    default:
        if (values.length > 200 && !values.some(v => typeof v !== typeof values[0])) {
            return [
                'filter-in-large',
                property,
                [
                    'literal',
                    values.sort(compare)
                ]
            ];
        } else {
            return [
                'filter-in-small',
                property,
                [
                    'literal',
                    values
                ]
            ];
        }
    }
}
function convertHasOp$1(property) {
    switch (property) {
    case '$type':
        return true;
    case '$id':
        return [`filter-has-id`];
    default:
        return [
            `filter-has`,
            property
        ];
    }
}
function convertNegation(filter) {
    return [
        '!',
        filter
    ];
}

//      
/**
 * Convert the given legacy filter to (the JSON representation of) an
 * equivalent expression
 * @private
 */
function convertFilter(filter) {
    return _convertFilter(filter, {});
}
/*
 * Convert the given filter to an expression, storing the expected types for
 * any feature properties referenced in expectedTypes.
 *
 * These expected types are needed in order to construct preflight type checks
 * needed for handling 'any' filters. A preflight type check is necessary in
 * order to mimic legacy filters' semantics around expected type mismatches.
 * For example, consider the legacy filter:
 *
 *     ["any", ["all", [">", "y", 0], [">", "y", 0]], [">", "x", 0]]
 *
 * Naively, we might convert this to the expression:
 *
 *     ["any", ["all", [">", ["get", "y"], 0], [">", ["get", "z"], 0]], [">", ["get", "x"], 0]]
 *
 * But if we tried to evaluate this against, say `{x: 1, y: null, z: 0}`, the
 * [">", ["get", "y"], 0] would cause an evaluation error, leading to the
 * entire filter returning false. Legacy filter semantics, though, ask for
 * [">", "y", 0] to simply return `false` when `y` is of the wrong type,
 * allowing the subsequent terms of the outer "any" expression to be evaluated
 * (resulting, in this case, in a `true` value, because x > 0).
 *
 * We account for this by inserting a preflight type-checking expression before
 * each "any" term, allowing us to avoid evaluating the actual converted filter
 * if any type mismatches would cause it to produce an evalaution error:
 *
 *     ["any",
 *       ["case",
 *         ["all", ["==", ["typeof", ["get", "y"]], "number"], ["==", ["typeof", ["get", "z"], "number]],
 *         ["all", [">", ["get", "y"], 0], [">", ["get", "z"], 0]],
 *         false
 *       ],
 *       ["case",
 *         ["==", ["typeof", ["get", "x"], "number"]],
 *         [">", ["get", "x"], 0],
 *         false
 *       ]
 *     ]
 *
 * An alternative, possibly more direct approach would be to use type checks
 * in the conversion of each comparison operator, so that the converted version
 * of each individual ==, >=, etc. would mimic the legacy filter semantics. The
 * downside of this approach is that it can lead to many more type checks than
 * would otherwise be necessary: outside the context of an "any" expression,
 * bailing out due to a runtime type error (expression semantics) and returning
 * false (legacy filter semantics) are equivalent: they cause the filter to
 * produce a `false` result.
 */
function _convertFilter(filter, expectedTypes) {
    if (isExpressionFilter(filter)) {
        return filter;
    }
    if (!filter)
        return true;
    const op = filter[0];
    if (filter.length <= 1)
        return op !== 'any';
    let converted;
    if (op === '==' || op === '!=' || op === '<' || op === '>' || op === '<=' || op === '>=') {
        const [, property, value] = filter;
        converted = convertComparisonOp(property, value, op, expectedTypes);
    } else if (op === 'any') {
        const children = filter.slice(1).map(f => {
            const types = {};
            const child = _convertFilter(f, types);
            const typechecks = runtimeTypeChecks(types);
            return typechecks === true ? child : [
                'case',
                typechecks,
                child,
                false
            ];
        });
        return ['any'].concat(children);
    } else if (op === 'all') {
        const children = filter.slice(1).map(f => _convertFilter(f, expectedTypes));
        return children.length > 1 ? ['all'].concat(children) : [].concat(...children);
    } else if (op === 'none') {
        return [
            '!',
            _convertFilter(['any'].concat(filter.slice(1)), {})
        ];
    } else if (op === 'in') {
        converted = convertInOp(filter[1], filter.slice(2));
    } else if (op === '!in') {
        converted = convertInOp(filter[1], filter.slice(2), true);
    } else if (op === 'has') {
        converted = convertHasOp(filter[1]);
    } else if (op === '!has') {
        converted = [
            '!',
            convertHasOp(filter[1])
        ];
    } else {
        converted = true;
    }
    return converted;
}
// Given a set of feature properties and an expected type for each one,
// construct an boolean expression that tests whether each property has the
// right type.
// E.g.: for {name: 'string', population: 'number'}, return
// [ 'all',
//   ['==', ['typeof', ['get', 'name'], 'string']],
//   ['==', ['typeof', ['get', 'population'], 'number]]
// ]
function runtimeTypeChecks(expectedTypes) {
    const conditions = [];
    for (const property in expectedTypes) {
        const get = property === '$id' ? ['id'] : [
            'get',
            property
        ];
        conditions.push([
            '==',
            [
                'typeof',
                get
            ],
            expectedTypes[property]
        ]);
    }
    if (conditions.length === 0)
        return true;
    if (conditions.length === 1)
        return conditions[0];
    return ['all'].concat(conditions);
}
function convertComparisonOp(property, value, op, expectedTypes) {
    let get;
    if (property === '$type') {
        return [
            op,
            ['geometry-type'],
            value
        ];
    } else if (property === '$id') {
        get = ['id'];
    } else {
        get = [
            'get',
            property
        ];
    }
    if (expectedTypes && value !== null) {
        const type = typeof value;
        expectedTypes[property] = type;
    }
    if (op === '==' && property !== '$id' && value === null) {
        return [
            'all',
            [
                'has',
                property
            ],
            // missing property != null for legacy filters
            [
                '==',
                get,
                null
            ]
        ];
    } else if (op === '!=' && property !== '$id' && value === null) {
        return [
            'any',
            [
                '!',
                [
                    'has',
                    property
                ]
            ],
            // missing property != null for legacy filters
            [
                '!=',
                get,
                null
            ]
        ];
    }
    return [
        op,
        get,
        value
    ];
}
function convertInOp(property, values, negate = false) {
    if (values.length === 0)
        return negate;
    let get;
    if (property === '$type') {
        get = ['geometry-type'];
    } else if (property === '$id') {
        get = ['id'];
    } else {
        get = [
            'get',
            property
        ];
    }
    // Determine if the list of values to be searched is homogenously typed.
    // If so (and if the type is string or number), then we can use a
    // [match, input, [...values], true, false] construction rather than a
    // bunch of `==` tests.
    let uniformTypes = true;
    const type = typeof values[0];
    for (const value of values) {
        if (typeof value !== type) {
            uniformTypes = false;
            break;
        }
    }
    if (uniformTypes && (type === 'string' || type === 'number')) {
        // Match expressions must have unique values.
        const uniqueValues = values.sort().filter((v, i) => i === 0 || values[i - 1] !== v);
        return [
            'match',
            get,
            uniqueValues,
            !negate,
            negate
        ];
    }
    return [negate ? 'all' : 'any'].concat(values.map(v => [
        negate ? '!=' : '==',
        get,
        v
    ]));
}
function convertHasOp(property) {
    if (property === '$type') {
        return true;
    } else if (property === '$id') {
        return [
            '!=',
            ['id'],
            null
        ];
    } else {
        return [
            'has',
            property
        ];
    }
}

//      
/**
 * Migrate the given style object in place to use expressions. Specifically,
 * this will convert (a) "stop" functions, and (b) legacy filters to their
 * expression equivalents.
 */
function migrateToExpressions (style) {
    const converted = [];
    eachLayer(style, layer => {
        if (layer.filter) {
            layer.filter = convertFilter(layer.filter);
        }
    });
    eachProperty(style, {
        paint: true,
        layout: true
    }, ({path, value, reference, set}) => {
        if (isExpression(value))
            return;
        if (typeof value === 'object' && !Array.isArray(value)) {
            set(convertFunction(value, reference));
            converted.push(path.join('.'));
        } else if (reference.tokens && typeof value === 'string') {
            set(convertTokenString(value));
        }
    });
    return style;
}

/**
 * Migrate a Mapbox GL Style to the latest version.
 *
 * @private
 * @alias migrate
 * @param {object} style a Mapbox GL Style
 * @returns {Object} a migrated style
 * @example
 * var fs = require('fs');
 * var migrate = require('mapbox-gl-style-spec').migrate;
 * var style = fs.readFileSync('./style.json', 'utf8');
 * fs.writeFileSync('./style.json', JSON.stringify(migrate(style)));
 */
function migrate (style) {
    let migrated = false;
    if (style.version === 7) {
        style = migrateToV8(style);
        migrated = true;
    }
    if (style.version === 8) {
        migrated = migrateToExpressions(style);
        migrated = true;
    }
    if (!migrated) {
        throw new Error('cannot migrate from', style.version);
    }
    return style;
}

function composite (style) {
    const styleIDs = [];
    const sourceIDs = [];
    const compositedSourceLayers = [];
    for (const id in style.sources) {
        const source = style.sources[id];
        if (source.type !== 'vector')
            continue;
        const match = /^mapbox:\/\/(.*)/.exec(source.url);
        if (!match)
            continue;
        styleIDs.push(id);
        sourceIDs.push(match[1]);
    }
    if (styleIDs.length < 2)
        return style;
    styleIDs.forEach(id => {
        delete style.sources[id];
    });
    const compositeID = sourceIDs.join(',');
    style.sources[compositeID] = {
        'type': 'vector',
        'url': `mapbox://${ compositeID }`
    };
    style.layers.forEach(layer => {
        if (styleIDs.indexOf(layer.source) >= 0) {
            layer.source = compositeID;
            if ('source-layer' in layer) {
                if (compositedSourceLayers.indexOf(layer['source-layer']) >= 0) {
                    throw new Error('Conflicting source layer names');
                } else {
                    compositedSourceLayers.push(layer['source-layer']);
                }
            }
        }
    });
    return style;
}

//      
var refProperties = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];

//      
function deref(layer, parent) {
    const result = {};
    for (const k in layer) {
        if (k !== 'ref') {
            result[k] = layer[k];
        }
    }
    refProperties.forEach(k => {
        if (k in parent) {
            result[k] = parent[k];
        }
    });
    return result;
}
/**
 * Given an array of layers, some of which may contain `ref` properties
 * whose value is the `id` of another property, return a new array where
 * such layers have been augmented with the 'type', 'source', etc. properties
 * from the parent layer, and the `ref` property has been removed.
 *
 * The input is not modified. The output may contain references to portions
 * of the input.
 *
 * @private
 * @param {Array<Layer>} layers
 * @returns {Array<Layer>}
 */
function derefLayers(layers) {
    layers = layers.slice();
    const map = Object.create(null);
    for (let i = 0; i < layers.length; i++) {
        map[layers[i].id] = layers[i];
    }
    for (let i = 0; i < layers.length; i++) {
        if ('ref' in layers[i]) {
            layers[i] = deref(layers[i], map[layers[i].ref]);
        }
    }
    return layers;
}

//      
/**
 * Deeply compares two object literals.
 *
 * @private
 */
function deepEqual(a, b) {
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length)
            return false;
        for (let i = 0; i < a.length; i++) {
            if (!deepEqual(a[i], b[i]))
                return false;
        }
        return true;
    }
    if (typeof a === 'object' && a !== null && b !== null) {
        if (!(typeof b === 'object'))
            return false;
        const keys = Object.keys(a);
        if (keys.length !== Object.keys(b).length)
            return false;
        for (const key in a) {
            if (!deepEqual(a[key], b[key]))
                return false;
        }
        return true;
    }
    return a === b;
}

//      
const operations = {
    /*
     * { command: 'setStyle', args: [stylesheet] }
     */
    setStyle: 'setStyle',
    /*
     * { command: 'addLayer', args: [layer, 'beforeLayerId'] }
     */
    addLayer: 'addLayer',
    /*
     * { command: 'removeLayer', args: ['layerId'] }
     */
    removeLayer: 'removeLayer',
    /*
     * { command: 'setPaintProperty', args: ['layerId', 'prop', value] }
     */
    setPaintProperty: 'setPaintProperty',
    /*
     * { command: 'setLayoutProperty', args: ['layerId', 'prop', value] }
     */
    setLayoutProperty: 'setLayoutProperty',
    /*
     * { command: 'setFilter', args: ['layerId', filter] }
     */
    setFilter: 'setFilter',
    /*
     * { command: 'addSource', args: ['sourceId', source] }
     */
    addSource: 'addSource',
    /*
     * { command: 'removeSource', args: ['sourceId'] }
     */
    removeSource: 'removeSource',
    /*
     * { command: 'setGeoJSONSourceData', args: ['sourceId', data] }
     */
    setGeoJSONSourceData: 'setGeoJSONSourceData',
    /*
     * { command: 'setLayerZoomRange', args: ['layerId', 0, 22] }
     */
    setLayerZoomRange: 'setLayerZoomRange',
    /*
     * { command: 'setLayerProperty', args: ['layerId', 'prop', value] }
     */
    setLayerProperty: 'setLayerProperty',
    /*
     * { command: 'setCenter', args: [[lon, lat]] }
     */
    setCenter: 'setCenter',
    /*
     * { command: 'setZoom', args: [zoom] }
     */
    setZoom: 'setZoom',
    /*
     * { command: 'setBearing', args: [bearing] }
     */
    setBearing: 'setBearing',
    /*
     * { command: 'setPitch', args: [pitch] }
     */
    setPitch: 'setPitch',
    /*
     * { command: 'setSprite', args: ['spriteUrl'] }
     */
    setSprite: 'setSprite',
    /*
     * { command: 'setGlyphs', args: ['glyphsUrl'] }
     */
    setGlyphs: 'setGlyphs',
    /*
     * { command: 'setTransition', args: [transition] }
     */
    setTransition: 'setTransition',
    /*
     * { command: 'setLighting', args: [lightProperties] }
     */
    setLight: 'setLight',
    /*
     * { command: 'setTerrain', args: [terrainProperties] }
     */
    setTerrain: 'setTerrain',
    /*
     *  { command: 'setFog', args: [fogProperties] }
     */
    setFog: 'setFog',
    /*
     *  { command: 'setProjection', args: [projectionProperties] }
     */
    setProjection: 'setProjection'
};
function addSource(sourceId, after, commands) {
    commands.push({
        command: operations.addSource,
        args: [
            sourceId,
            after[sourceId]
        ]
    });
}
function removeSource(sourceId, commands, sourcesRemoved) {
    commands.push({
        command: operations.removeSource,
        args: [sourceId]
    });
    sourcesRemoved[sourceId] = true;
}
function updateSource(sourceId, after, commands, sourcesRemoved) {
    removeSource(sourceId, commands, sourcesRemoved);
    addSource(sourceId, after, commands);
}
function canUpdateGeoJSON(before, after, sourceId) {
    let prop;
    for (prop in before[sourceId]) {
        if (!before[sourceId].hasOwnProperty(prop))
            continue;
        if (prop !== 'data' && !deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    for (prop in after[sourceId]) {
        if (!after[sourceId].hasOwnProperty(prop))
            continue;
        if (prop !== 'data' && !deepEqual(before[sourceId][prop], after[sourceId][prop])) {
            return false;
        }
    }
    return true;
}
function diffSources(before, after, commands, sourcesRemoved) {
    before = before || {};
    after = after || {};
    let sourceId;
    // look for sources to remove
    for (sourceId in before) {
        if (!before.hasOwnProperty(sourceId))
            continue;
        if (!after.hasOwnProperty(sourceId)) {
            removeSource(sourceId, commands, sourcesRemoved);
        }
    }
    // look for sources to add/update
    for (sourceId in after) {
        if (!after.hasOwnProperty(sourceId))
            continue;
        if (!before.hasOwnProperty(sourceId)) {
            addSource(sourceId, after, commands);
        } else if (!deepEqual(before[sourceId], after[sourceId])) {
            if (before[sourceId].type === 'geojson' && after[sourceId].type === 'geojson' && canUpdateGeoJSON(before, after, sourceId)) {
                commands.push({
                    command: operations.setGeoJSONSourceData,
                    args: [
                        sourceId,
                        after[sourceId].data
                    ]
                });
            } else {
                // no update command, must remove then add
                updateSource(sourceId, after, commands, sourcesRemoved);
            }
        }
    }
}
function diffLayerPropertyChanges(before, after, commands, layerId, klass, command) {
    before = before || {};
    after = after || {};
    let prop;
    for (prop in before) {
        if (!before.hasOwnProperty(prop))
            continue;
        if (!deepEqual(before[prop], after[prop])) {
            commands.push({
                command,
                args: [
                    layerId,
                    prop,
                    after[prop],
                    klass
                ]
            });
        }
    }
    for (prop in after) {
        if (!after.hasOwnProperty(prop) || before.hasOwnProperty(prop))
            continue;
        if (!deepEqual(before[prop], after[prop])) {
            commands.push({
                command,
                args: [
                    layerId,
                    prop,
                    after[prop],
                    klass
                ]
            });
        }
    }
}
function pluckId(layer) {
    return layer.id;
}
function indexById(group, layer) {
    group[layer.id] = layer;
    return group;
}
function diffLayers(before, after, commands) {
    before = before || [];
    after = after || [];
    // order of layers by id
    const beforeOrder = before.map(pluckId);
    const afterOrder = after.map(pluckId);
    // index of layer by id
    const beforeIndex = before.reduce(indexById, {});
    const afterIndex = after.reduce(indexById, {});
    // track order of layers as if they have been mutated
    const tracker = beforeOrder.slice();
    // layers that have been added do not need to be diffed
    const clean = Object.create(null);
    let i, d, layerId, beforeLayer, afterLayer, insertBeforeLayerId, prop;
    // remove layers
    for (i = 0, d = 0; i < beforeOrder.length; i++) {
        layerId = beforeOrder[i];
        if (!afterIndex.hasOwnProperty(layerId)) {
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            tracker.splice(tracker.indexOf(layerId, d), 1);
        } else {
            // limit where in tracker we need to look for a match
            d++;
        }
    }
    // add/reorder layers
    for (i = 0, d = 0; i < afterOrder.length; i++) {
        // work backwards as insert is before an existing layer
        layerId = afterOrder[afterOrder.length - 1 - i];
        if (tracker[tracker.length - 1 - i] === layerId)
            continue;
        if (beforeIndex.hasOwnProperty(layerId)) {
            // remove the layer before we insert at the correct position
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            tracker.splice(tracker.lastIndexOf(layerId, tracker.length - d), 1);
        } else {
            // limit where in tracker we need to look for a match
            d++;
        }
        // add layer at correct position
        insertBeforeLayerId = tracker[tracker.length - i];
        commands.push({
            command: operations.addLayer,
            args: [
                afterIndex[layerId],
                insertBeforeLayerId
            ]
        });
        tracker.splice(tracker.length - i, 0, layerId);
        clean[layerId] = true;
    }
    // update layers
    for (i = 0; i < afterOrder.length; i++) {
        layerId = afterOrder[i];
        beforeLayer = beforeIndex[layerId];
        afterLayer = afterIndex[layerId];
        // no need to update if previously added (new or moved)
        if (clean[layerId] || deepEqual(beforeLayer, afterLayer))
            continue;
        // If source, source-layer, or type have changes, then remove the layer
        // and add it back 'from scratch'.
        if (!deepEqual(beforeLayer.source, afterLayer.source) || !deepEqual(beforeLayer['source-layer'], afterLayer['source-layer']) || !deepEqual(beforeLayer.type, afterLayer.type)) {
            commands.push({
                command: operations.removeLayer,
                args: [layerId]
            });
            // we add the layer back at the same position it was already in, so
            // there's no need to update the `tracker`
            insertBeforeLayerId = tracker[tracker.lastIndexOf(layerId) + 1];
            commands.push({
                command: operations.addLayer,
                args: [
                    afterLayer,
                    insertBeforeLayerId
                ]
            });
            continue;
        }
        // layout, paint, filter, minzoom, maxzoom
        diffLayerPropertyChanges(beforeLayer.layout, afterLayer.layout, commands, layerId, null, operations.setLayoutProperty);
        diffLayerPropertyChanges(beforeLayer.paint, afterLayer.paint, commands, layerId, null, operations.setPaintProperty);
        if (!deepEqual(beforeLayer.filter, afterLayer.filter)) {
            commands.push({
                command: operations.setFilter,
                args: [
                    layerId,
                    afterLayer.filter
                ]
            });
        }
        if (!deepEqual(beforeLayer.minzoom, afterLayer.minzoom) || !deepEqual(beforeLayer.maxzoom, afterLayer.maxzoom)) {
            commands.push({
                command: operations.setLayerZoomRange,
                args: [
                    layerId,
                    afterLayer.minzoom,
                    afterLayer.maxzoom
                ]
            });
        }
        // handle all other layer props, including paint.*
        for (prop in beforeLayer) {
            if (!beforeLayer.hasOwnProperty(prop))
                continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom')
                continue;
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
            } else if (!deepEqual(beforeLayer[prop], afterLayer[prop])) {
                commands.push({
                    command: operations.setLayerProperty,
                    args: [
                        layerId,
                        prop,
                        afterLayer[prop]
                    ]
                });
            }
        }
        for (prop in afterLayer) {
            if (!afterLayer.hasOwnProperty(prop) || beforeLayer.hasOwnProperty(prop))
                continue;
            if (prop === 'layout' || prop === 'paint' || prop === 'filter' || prop === 'metadata' || prop === 'minzoom' || prop === 'maxzoom')
                continue;
            if (prop.indexOf('paint.') === 0) {
                diffLayerPropertyChanges(beforeLayer[prop], afterLayer[prop], commands, layerId, prop.slice(6), operations.setPaintProperty);
            } else if (!deepEqual(beforeLayer[prop], afterLayer[prop])) {
                commands.push({
                    command: operations.setLayerProperty,
                    args: [
                        layerId,
                        prop,
                        afterLayer[prop]
                    ]
                });
            }
        }
    }
}
/**
 * Diff two stylesheet
 *
 * Creates semanticly aware diffs that can easily be applied at runtime.
 * Operations produced by the diff closely resemble the mapbox-gl-js API. Any
 * error creating the diff will fall back to the 'setStyle' operation.
 *
 * Example diff:
 * [
 *     { command: 'setConstant', args: ['@water', '#0000FF'] },
 *     { command: 'setPaintProperty', args: ['background', 'background-color', 'black'] }
 * ]
 *
 * @private
 * @param {*} [before] stylesheet to compare from
 * @param {*} after stylesheet to compare to
 * @returns Array list of changes
 */
function diffStyles(before, after) {
    if (!before)
        return [{
                command: operations.setStyle,
                args: [after]
            }];
    let commands = [];
    try {
        // Handle changes to top-level properties
        if (!deepEqual(before.version, after.version)) {
            return [{
                    command: operations.setStyle,
                    args: [after]
                }];
        }
        if (!deepEqual(before.center, after.center)) {
            commands.push({
                command: operations.setCenter,
                args: [after.center]
            });
        }
        if (!deepEqual(before.zoom, after.zoom)) {
            commands.push({
                command: operations.setZoom,
                args: [after.zoom]
            });
        }
        if (!deepEqual(before.bearing, after.bearing)) {
            commands.push({
                command: operations.setBearing,
                args: [after.bearing]
            });
        }
        if (!deepEqual(before.pitch, after.pitch)) {
            commands.push({
                command: operations.setPitch,
                args: [after.pitch]
            });
        }
        if (!deepEqual(before.sprite, after.sprite)) {
            commands.push({
                command: operations.setSprite,
                args: [after.sprite]
            });
        }
        if (!deepEqual(before.glyphs, after.glyphs)) {
            commands.push({
                command: operations.setGlyphs,
                args: [after.glyphs]
            });
        }
        if (!deepEqual(before.transition, after.transition)) {
            commands.push({
                command: operations.setTransition,
                args: [after.transition]
            });
        }
        if (!deepEqual(before.light, after.light)) {
            commands.push({
                command: operations.setLight,
                args: [after.light]
            });
        }
        if (!deepEqual(before.fog, after.fog)) {
            commands.push({
                command: operations.setFog,
                args: [after.fog]
            });
        }
        if (!deepEqual(before.projection, after.projection)) {
            commands.push({
                command: operations.setProjection,
                args: [after.projection]
            });
        }
        // Handle changes to `sources`
        // If a source is to be removed, we also--before the removeSource
        // command--need to remove all the style layers that depend on it.
        const sourcesRemoved = {};
        // First collect the {add,remove}Source commands
        const removeOrAddSourceCommands = [];
        diffSources(before.sources, after.sources, removeOrAddSourceCommands, sourcesRemoved);
        // Push a removeLayer command for each style layer that depends on a
        // source that's being removed.
        // Also, exclude any such layers them from the input to `diffLayers`
        // below, so that diffLayers produces the appropriate `addLayers`
        // command
        const beforeLayers = [];
        if (before.layers) {
            before.layers.forEach(layer => {
                if (layer.source && sourcesRemoved[layer.source]) {
                    commands.push({
                        command: operations.removeLayer,
                        args: [layer.id]
                    });
                } else {
                    beforeLayers.push(layer);
                }
            });
        }
        // Remove the terrain if the source for that terrain is being removed
        let beforeTerrain = before.terrain;
        if (beforeTerrain) {
            if (sourcesRemoved[beforeTerrain.source]) {
                commands.push({
                    command: operations.setTerrain,
                    args: [undefined]
                });
                beforeTerrain = undefined;
            }
        }
        commands = commands.concat(removeOrAddSourceCommands);
        // Even though terrain is a top-level property
        // Its like a layer in the sense that it depends on a source being present.
        if (!deepEqual(beforeTerrain, after.terrain)) {
            commands.push({
                command: operations.setTerrain,
                args: [after.terrain]
            });
        }
        // Handle changes to `layers`
        diffLayers(beforeLayers, after.layers, commands);
    } catch (e) {
        // fall back to setStyle
        console.warn('Unable to compute style diff:', e);
        commands = [{
                command: operations.setStyle,
                args: [after]
            }];
    }
    return commands;
}

//      
// Note: Do not inherit from Error. It breaks when transpiling to ES5.
class ValidationError {
    constructor(key, value, message, identifier) {
        this.message = (key ? `${ key }: ` : '') + message;
        if (identifier)
            this.identifier = identifier;
        if (value !== null && value !== undefined && value.__line__) {
            this.line = value.__line__;
        }
    }
}

//      
// Note: Do not inherit from Error. It breaks when transpiling to ES5.
class ParsingError {
    constructor(error) {
        this.error = error;
        this.message = error.message;
        const match = error.message.match(/line (\d+)/);
        this.line = match ? parseInt(match[1], 10) : 0;
    }
}

//      
function validateObject(options) {
    const key = options.key;
    const object = options.value;
    const elementSpecs = options.valueSpec || {};
    const elementValidators = options.objectElementValidators || {};
    const style = options.style;
    const styleSpec = options.styleSpec;
    let errors = [];
    const type = getType(object);
    if (type !== 'object') {
        return [new ValidationError(key, object, `object expected, ${ type } found`)];
    }
    for (const objectKey in object) {
        const elementSpecKey = objectKey.split('.')[0];
        // treat 'paint.*' as 'paint'
        const elementSpec = elementSpecs[elementSpecKey] || elementSpecs['*'];
        let validateElement;
        if (elementValidators[elementSpecKey]) {
            validateElement = elementValidators[elementSpecKey];
        } else if (elementSpecs[elementSpecKey]) {
            validateElement = validate;
        } else if (elementValidators['*']) {
            validateElement = elementValidators['*'];
        } else if (elementSpecs['*']) {
            validateElement = validate;
        }
        if (!validateElement) {
            errors.push(new ValidationError(key, object[objectKey], `unknown property "${ objectKey }"`));
            continue;
        }
        errors = errors.concat(validateElement({
            key: (key ? `${ key }.` : key) + objectKey,
            value: object[objectKey],
            valueSpec: elementSpec,
            style,
            styleSpec,
            object,
            objectKey    // $FlowFixMe[extra-arg]
        }, object));
    }
    for (const elementSpecKey in elementSpecs) {
        // Don't check `required` when there's a custom validator for that property.
        if (elementValidators[elementSpecKey]) {
            continue;
        }
        if (elementSpecs[elementSpecKey].required && elementSpecs[elementSpecKey]['default'] === undefined && object[elementSpecKey] === undefined) {
            errors.push(new ValidationError(key, object, `missing required property "${ elementSpecKey }"`));
        }
    }
    return errors;
}

//      
function validateArray(options) {
    const array = options.value;
    const arraySpec = options.valueSpec;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const key = options.key;
    const validateArrayElement = options.arrayElementValidator || validate;
    if (getType(array) !== 'array') {
        return [new ValidationError(key, array, `array expected, ${ getType(array) } found`)];
    }
    if (arraySpec.length && array.length !== arraySpec.length) {
        return [new ValidationError(key, array, `array length ${ arraySpec.length } expected, length ${ array.length } found`)];
    }
    if (arraySpec['min-length'] && array.length < arraySpec['min-length']) {
        return [new ValidationError(key, array, `array length at least ${ arraySpec['min-length'] } expected, length ${ array.length } found`)];
    }
    let arrayElementSpec = {
        'type': arraySpec.value,
        'values': arraySpec.values,
        'minimum': arraySpec.minimum,
        'maximum': arraySpec.maximum,
        function: undefined
    };
    if (styleSpec.$version < 7) {
        arrayElementSpec.function = arraySpec.function;
    }
    if (getType(arraySpec.value) === 'object') {
        arrayElementSpec = arraySpec.value;
    }
    let errors = [];
    for (let i = 0; i < array.length; i++) {
        errors = errors.concat(validateArrayElement({
            array,
            arrayIndex: i,
            value: array[i],
            valueSpec: arrayElementSpec,
            style,
            styleSpec,
            key: `${ key }[${ i }]`
        }));
    }
    return errors;
}

//      
function validateNumber(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    let type = getType(value);
    // eslint-disable-next-line no-self-compare
    if (type === 'number' && value !== value) {
        type = 'NaN';
    }
    if (type !== 'number') {
        return [new ValidationError(key, value, `number expected, ${ type } found`)];
    }
    if ('minimum' in valueSpec) {
        let specMin = valueSpec.minimum;
        if (getType(valueSpec.minimum) === 'array') {
            const i = options.arrayIndex;
            specMin = valueSpec.minimum[i];
        }
        if (value < specMin) {
            return [new ValidationError(key, value, `${ value } is less than the minimum value ${ specMin }`)];
        }
    }
    if ('maximum' in valueSpec) {
        let specMax = valueSpec.maximum;
        if (getType(valueSpec.maximum) === 'array') {
            const i = options.arrayIndex;
            specMax = valueSpec.maximum[i];
        }
        if (value > specMax) {
            return [new ValidationError(key, value, `${ value } is greater than the maximum value ${ specMax }`)];
        }
    }
    return [];
}

//      
function validateFunction(options) {
    const functionValueSpec = options.valueSpec;
    const functionType = unbundle(options.value.type);
    let stopKeyType;
    let stopDomainValues = {};
    let previousStopDomainValue;
    let previousStopDomainZoom;
    const isZoomFunction = functionType !== 'categorical' && options.value.property === undefined;
    const isPropertyFunction = !isZoomFunction;
    const isZoomAndPropertyFunction = getType(options.value.stops) === 'array' && getType(options.value.stops[0]) === 'array' && getType(options.value.stops[0][0]) === 'object';
    const errors = validateObject({
        key: options.key,
        value: options.value,
        valueSpec: options.styleSpec.function,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            stops: validateFunctionStops,
            default: validateFunctionDefault
        }
    });
    if (functionType === 'identity' && isZoomFunction) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "property"'));
    }
    if (functionType !== 'identity' && !options.value.stops) {
        errors.push(new ValidationError(options.key, options.value, 'missing required property "stops"'));
    }
    if (functionType === 'exponential' && options.valueSpec.expression && !supportsInterpolation(options.valueSpec)) {
        errors.push(new ValidationError(options.key, options.value, 'exponential functions not supported'));
    }
    if (options.styleSpec.$version >= 8) {
        if (isPropertyFunction && !supportsPropertyExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'property functions not supported'));
        } else if (isZoomFunction && !supportsZoomExpression(options.valueSpec)) {
            errors.push(new ValidationError(options.key, options.value, 'zoom functions not supported'));
        }
    }
    if ((functionType === 'categorical' || isZoomAndPropertyFunction) && options.value.property === undefined) {
        errors.push(new ValidationError(options.key, options.value, '"property" property is required'));
    }
    return errors;
    function validateFunctionStops(options) {
        if (functionType === 'identity') {
            return [new ValidationError(options.key, options.value, 'identity function may not have a "stops" property')];
        }
        let errors = [];
        const value = options.value;
        errors = errors.concat(validateArray({
            key: options.key,
            value,
            valueSpec: options.valueSpec,
            style: options.style,
            styleSpec: options.styleSpec,
            arrayElementValidator: validateFunctionStop
        }));
        if (getType(value) === 'array' && value.length === 0) {
            errors.push(new ValidationError(options.key, value, 'array must have at least one stop'));
        }
        return errors;
    }
    function validateFunctionStop(options) {
        let errors = [];
        const value = options.value;
        const key = options.key;
        if (getType(value) !== 'array') {
            return [new ValidationError(key, value, `array expected, ${ getType(value) } found`)];
        }
        if (value.length !== 2) {
            return [new ValidationError(key, value, `array length 2 expected, length ${ value.length } found`)];
        }
        if (isZoomAndPropertyFunction) {
            if (getType(value[0]) !== 'object') {
                return [new ValidationError(key, value, `object expected, ${ getType(value[0]) } found`)];
            }
            if (value[0].zoom === undefined) {
                return [new ValidationError(key, value, 'object stop key must have zoom')];
            }
            if (value[0].value === undefined) {
                return [new ValidationError(key, value, 'object stop key must have value')];
            }
            const nextStopDomainZoom = unbundle(value[0].zoom);
            if (typeof nextStopDomainZoom !== 'number') {
                return [new ValidationError(key, value[0].zoom, 'stop zoom values must be numbers')];
            }
            if (previousStopDomainZoom && previousStopDomainZoom > nextStopDomainZoom) {
                return [new ValidationError(key, value[0].zoom, 'stop zoom values must appear in ascending order')];
            }
            if (nextStopDomainZoom !== previousStopDomainZoom) {
                previousStopDomainZoom = nextStopDomainZoom;
                previousStopDomainValue = undefined;
                stopDomainValues = {};
            }
            errors = errors.concat(validateObject({
                key: `${ key }[0]`,
                value: value[0],
                valueSpec: { zoom: {} },
                style: options.style,
                styleSpec: options.styleSpec,
                objectElementValidators: {
                    zoom: validateNumber,
                    value: validateStopDomainValue
                }
            }));
        } else {
            errors = errors.concat(validateStopDomainValue({
                key: `${ key }[0]`,
                value: value[0],
                valueSpec: {},
                style: options.style,
                styleSpec: options.styleSpec
            }, value));
        }
        if (isExpression(deepUnbundle(value[1]))) {
            return errors.concat([new ValidationError(`${ key }[1]`, value[1], 'expressions are not allowed in function stops.')]);
        }
        return errors.concat(validate({
            key: `${ key }[1]`,
            value: value[1],
            valueSpec: functionValueSpec,
            style: options.style,
            styleSpec: options.styleSpec
        }));
    }
    function validateStopDomainValue(options, stop) {
        const type = getType(options.value);
        const value = unbundle(options.value);
        const reportValue = options.value !== null ? options.value : stop;
        if (!stopKeyType) {
            stopKeyType = type;
        } else if (type !== stopKeyType) {
            return [new ValidationError(options.key, reportValue, `${ type } stop domain type must match previous stop domain type ${ stopKeyType }`)];
        }
        if (type !== 'number' && type !== 'string' && type !== 'boolean' && typeof value !== 'number' && typeof value !== 'string' && typeof value !== 'boolean') {
            return [new ValidationError(options.key, reportValue, 'stop domain value must be a number, string, or boolean')];
        }
        if (type !== 'number' && functionType !== 'categorical') {
            let message = `number expected, ${ type } found`;
            if (supportsPropertyExpression(functionValueSpec) && functionType === undefined) {
                message += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.';
            }
            return [new ValidationError(options.key, reportValue, message)];
        }
        if (functionType === 'categorical' && type === 'number' && (typeof value !== 'number' || !isFinite(value) || Math.floor(value) !== value)) {
            return [new ValidationError(options.key, reportValue, `integer expected, found ${ String(value) }`)];
        }
        if (functionType !== 'categorical' && type === 'number' && typeof value === 'number' && typeof previousStopDomainValue === 'number' && previousStopDomainValue !== undefined && value < previousStopDomainValue) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must appear in ascending order')];
        } else {
            previousStopDomainValue = value;
        }
        if (functionType === 'categorical' && value in stopDomainValues) {
            return [new ValidationError(options.key, reportValue, 'stop domain values must be unique')];
        } else {
            stopDomainValues[value] = true;
        }
        return [];
    }
    function validateFunctionDefault(options) {
        return validate({
            key: options.key,
            value: options.value,
            valueSpec: functionValueSpec,
            style: options.style,
            styleSpec: options.styleSpec
        });
    }
}

//      
function validateExpression(options) {
    const expression = (options.expressionContext === 'property' ? createPropertyExpression : createExpression)(deepUnbundle(options.value), options.valueSpec);
    if (expression.result === 'error') {
        return expression.value.map(error => {
            return new ValidationError(`${ options.key }${ error.key }`, options.value, error.message);
        });
    }
    const expressionObj = expression.value.expression || expression.value._styleExpression.expression;
    if (options.expressionContext === 'property' && options.propertyKey === 'text-font' && !expressionObj.outputDefined()) {
        return [new ValidationError(options.key, options.value, `Invalid data expression for "${ options.propertyKey }". Output values must be contained as literals within the expression.`)];
    }
    if (options.expressionContext === 'property' && options.propertyType === 'layout' && !isStateConstant(expressionObj)) {
        return [new ValidationError(options.key, options.value, '"feature-state" data expressions are not supported with layout properties.')];
    }
    if (options.expressionContext === 'filter') {
        return disallowedFilterParameters(expressionObj, options);
    }
    if (options.expressionContext && options.expressionContext.indexOf('cluster') === 0) {
        if (!isGlobalPropertyConstant(expressionObj, [
                'zoom',
                'feature-state'
            ])) {
            return [new ValidationError(options.key, options.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')];
        }
        if (options.expressionContext === 'cluster-initial' && !isFeatureConstant(expressionObj)) {
            return [new ValidationError(options.key, options.value, 'Feature data expressions are not supported with initial expression part of cluster properties.')];
        }
    }
    return [];
}
function disallowedFilterParameters(e, options) {
    const disallowedParameters = new Set([
        'zoom',
        'feature-state',
        'pitch',
        'distance-from-center'
    ]);
    if (options.valueSpec && options.valueSpec.expression) {
        for (const param of options.valueSpec.expression.parameters) {
            disallowedParameters.delete(param);
        }
    }
    if (disallowedParameters.size === 0) {
        return [];
    }
    const errors = [];
    if (e instanceof CompoundExpression$1) {
        if (disallowedParameters.has(e.name)) {
            return [new ValidationError(options.key, options.value, `["${ e.name }"] expression is not supported in a filter for a ${ options.object.type } layer with id: ${ options.object.id }`)];
        }
    }
    e.eachChild(arg => {
        errors.push(...disallowedFilterParameters(arg, options));
    });
    return errors;
}

//      
function validateBoolean(options) {
    const value = options.value;
    const key = options.key;
    const type = getType(value);
    if (type !== 'boolean') {
        return [new ValidationError(key, value, `boolean expected, ${ type } found`)];
    }
    return [];
}

//      
function validateColor(options) {
    const key = options.key;
    const value = options.value;
    const type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, `color expected, ${ type } found`)];
    }
    if (parseCSSColor_1(value) === null) {
        return [new ValidationError(key, value, `color expected, "${ value }" found`)];
    }
    return [];
}

//      
function validateEnum(options) {
    const key = options.key;
    const value = options.value;
    const valueSpec = options.valueSpec;
    const errors = [];
    if (Array.isArray(valueSpec.values)) {
        // <=v7
        if (valueSpec.values.indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, `expected one of [${ valueSpec.values.join(', ') }], ${ JSON.stringify(value) } found`));
        }
    } else {
        // >=v8
        if (Object.keys(valueSpec.values).indexOf(unbundle(value)) === -1) {
            errors.push(new ValidationError(key, value, `expected one of [${ Object.keys(valueSpec.values).join(', ') }], ${ JSON.stringify(value) } found`));
        }
    }
    return errors;
}

//      
function validateFilter(options) {
    if (isExpressionFilter(deepUnbundle(options.value))) {
        // We default to a layerType of `fill` because that points to a non-dynamic filter definition within the style-spec.
        const layerType = options.layerType || 'fill';
        return validateExpression(extend({}, options, {
            expressionContext: 'filter',
            valueSpec: options.styleSpec[`filter_${ layerType }`]
        }));
    } else {
        return validateNonExpressionFilter(options);
    }
}
function validateNonExpressionFilter(options) {
    const value = options.value;
    const key = options.key;
    if (getType(value) !== 'array') {
        return [new ValidationError(key, value, `array expected, ${ getType(value) } found`)];
    }
    const styleSpec = options.styleSpec;
    let type;
    let errors = [];
    if (value.length < 1) {
        return [new ValidationError(key, value, 'filter array must have at least 1 element')];
    }
    errors = errors.concat(validateEnum({
        key: `${ key }[0]`,
        value: value[0],
        valueSpec: styleSpec.filter_operator,
        style: options.style,
        styleSpec: options.styleSpec
    }));
    switch (unbundle(value[0])) {
    case '<':
    case '<=':
    case '>':
    case '>=':
        if (value.length >= 2 && unbundle(value[1]) === '$type') {
            errors.push(new ValidationError(key, value, `"$type" cannot be use with operator "${ value[0] }"`));
        }
    /* falls through */
    case '==':
    case '!=':
        if (value.length !== 3) {
            errors.push(new ValidationError(key, value, `filter array for operator "${ value[0] }" must have 3 elements`));
        }
    /* falls through */
    case 'in':
    case '!in':
        if (value.length >= 2) {
            type = getType(value[1]);
            if (type !== 'string') {
                errors.push(new ValidationError(`${ key }[1]`, value[1], `string expected, ${ type } found`));
            }
        }
        for (let i = 2; i < value.length; i++) {
            type = getType(value[i]);
            if (unbundle(value[1]) === '$type') {
                errors = errors.concat(validateEnum({
                    key: `${ key }[${ i }]`,
                    value: value[i],
                    valueSpec: styleSpec.geometry_type,
                    style: options.style,
                    styleSpec: options.styleSpec
                }));
            } else if (type !== 'string' && type !== 'number' && type !== 'boolean') {
                errors.push(new ValidationError(`${ key }[${ i }]`, value[i], `string, number, or boolean expected, ${ type } found`));
            }
        }
        break;
    case 'any':
    case 'all':
    case 'none':
        for (let i = 1; i < value.length; i++) {
            errors = errors.concat(validateNonExpressionFilter({
                key: `${ key }[${ i }]`,
                value: value[i],
                style: options.style,
                styleSpec: options.styleSpec
            }));
        }
        break;
    case 'has':
    case '!has':
        type = getType(value[1]);
        if (value.length !== 2) {
            errors.push(new ValidationError(key, value, `filter array for "${ value[0] }" operator must have 2 elements`));
        } else if (type !== 'string') {
            errors.push(new ValidationError(`${ key }[1]`, value[1], `string expected, ${ type } found`));
        }
        break;
    case 'within':
        type = getType(value[1]);
        if (value.length !== 2) {
            errors.push(new ValidationError(key, value, `filter array for "${ value[0] }" operator must have 2 elements`));
        } else if (type !== 'object') {
            errors.push(new ValidationError(`${ key }[1]`, value[1], `object expected, ${ type } found`));
        }
        break;
    }
    return errors;
}

//      
function validateProperty(options, propertyType) {
    const key = options.key;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const value = options.value;
    const propertyKey = options.objectKey;
    const layerSpec = styleSpec[`${ propertyType }_${ options.layerType }`];
    if (!layerSpec)
        return [];
    const transitionMatch = propertyKey.match(/^(.*)-transition$/);
    if (propertyType === 'paint' && transitionMatch && layerSpec[transitionMatch[1]] && layerSpec[transitionMatch[1]].transition) {
        return validate({
            key,
            value,
            valueSpec: styleSpec.transition,
            style,
            styleSpec
        });
    }
    const valueSpec = options.valueSpec || layerSpec[propertyKey];
    if (!valueSpec) {
        return [new ValidationError(key, value, `unknown property "${ propertyKey }"`)];
    }
    let tokenMatch;
    if (getType(value) === 'string' && supportsPropertyExpression(valueSpec) && !valueSpec.tokens && (tokenMatch = /^{([^}]+)}$/.exec(value))) {
        return [new ValidationError(key, value, `"${ propertyKey }" does not support interpolation syntax\n` + `Use an identity property function instead: \`{ "type": "identity", "property": ${ JSON.stringify(tokenMatch[1]) } }\`.`)];
    }
    const errors = [];
    if (options.layerType === 'symbol') {
        if (propertyKey === 'text-field' && style && !style.glyphs) {
            errors.push(new ValidationError(key, value, 'use of "text-field" requires a style "glyphs" property'));
        }
        if (propertyKey === 'text-font' && isFunction(deepUnbundle(value)) && unbundle(value.type) === 'identity') {
            errors.push(new ValidationError(key, value, '"text-font" does not support identity functions'));
        }
    }
    return errors.concat(validate({
        key: options.key,
        value,
        valueSpec,
        style,
        styleSpec,
        expressionContext: 'property',
        propertyType,
        propertyKey
    }));
}

//      
function validatePaintProperty(options) {
    return validateProperty(options, 'paint');
}

//      
function validateLayoutProperty(options) {
    return validateProperty(options, 'layout');
}

//      
function validateLayer(options) {
    let errors = [];
    const layer = options.value;
    const key = options.key;
    const style = options.style;
    const styleSpec = options.styleSpec;
    if (!layer.type && !layer.ref) {
        errors.push(new ValidationError(key, layer, 'either "type" or "ref" is required'));
    }
    let type = unbundle(layer.type);
    const ref = unbundle(layer.ref);
    if (layer.id) {
        const layerId = unbundle(layer.id);
        for (let i = 0; i < options.arrayIndex; i++) {
            const otherLayer = style.layers[i];
            if (unbundle(otherLayer.id) === layerId) {
                // $FlowFixMe[prop-missing] - id.__line__ is added dynamically during the readStyle step
                errors.push(new ValidationError(key, layer.id, `duplicate layer id "${ layer.id }", previously used at line ${ otherLayer.id.__line__ }`));
            }
        }
    }
    if ('ref' in layer) {
        [
            'type',
            'source',
            'source-layer',
            'filter',
            'layout'
        ].forEach(p => {
            if (p in layer) {
                errors.push(new ValidationError(key, layer[p], `"${ p }" is prohibited for ref layers`));
            }
        });
        let parent;
        style.layers.forEach(layer => {
            if (unbundle(layer.id) === ref)
                parent = layer;
        });
        if (!parent) {
            if (typeof ref === 'string')
                errors.push(new ValidationError(key, layer.ref, `ref layer "${ ref }" not found`));
        } else if (parent.ref) {
            errors.push(new ValidationError(key, layer.ref, 'ref cannot reference another ref layer'));
        } else {
            type = unbundle(parent.type);
        }
    } else if (!(type === 'background' || type === 'sky')) {
        if (!layer.source) {
            errors.push(new ValidationError(key, layer, 'missing required property "source"'));
        } else {
            const source = style.sources && style.sources[layer.source];
            const sourceType = source && unbundle(source.type);
            if (!source) {
                errors.push(new ValidationError(key, layer.source, `source "${ layer.source }" not found`));
            } else if (sourceType === 'vector' && type === 'raster') {
                errors.push(new ValidationError(key, layer.source, `layer "${ layer.id }" requires a raster source`));
            } else if (sourceType === 'raster' && type !== 'raster') {
                errors.push(new ValidationError(key, layer.source, `layer "${ layer.id }" requires a vector source`));
            } else if (sourceType === 'vector' && !layer['source-layer']) {
                errors.push(new ValidationError(key, layer, `layer "${ layer.id }" must specify a "source-layer"`));
            } else if (sourceType === 'raster-dem' && type !== 'hillshade') {
                errors.push(new ValidationError(key, layer.source, 'raster-dem source can only be used with layer type \'hillshade\'.'));
            } else if (type === 'line' && layer.paint && (layer.paint['line-gradient'] || layer.paint['line-trim-offset']) && (sourceType !== 'geojson' || !source.lineMetrics)) {
                errors.push(new ValidationError(key, layer, `layer "${ layer.id }" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`));
            }
        }
    }
    errors = errors.concat(validateObject({
        key,
        value: layer,
        valueSpec: styleSpec.layer,
        style: options.style,
        styleSpec: options.styleSpec,
        objectElementValidators: {
            '*'() {
                return [];
            },
            // We don't want to enforce the spec's `"requires": true` for backward compatibility with refs;
            // the actual requirement is validated above. See https://github.com/mapbox/mapbox-gl-js/issues/5772.
            type() {
                return validate({
                    key: `${ key }.type`,
                    value: layer.type,
                    valueSpec: styleSpec.layer.type,
                    style: options.style,
                    styleSpec: options.styleSpec,
                    object: layer,
                    objectKey: 'type'
                });
            },
            filter(options) {
                return validateFilter(extend({ layerType: type }, options));
            },
            layout(options) {
                return validateObject({
                    layer,
                    key: options.key,
                    value: options.value,
                    valueSpec: {},
                    style: options.style,
                    styleSpec: options.styleSpec,
                    objectElementValidators: {
                        '*'(options) {
                            return validateLayoutProperty(extend({ layerType: type }, options));
                        }
                    }
                });
            },
            paint(options) {
                return validateObject({
                    layer,
                    key: options.key,
                    value: options.value,
                    valueSpec: {},
                    style: options.style,
                    styleSpec: options.styleSpec,
                    objectElementValidators: {
                        '*'(options) {
                            return validatePaintProperty(extend({ layerType: type }, options));
                        }
                    }
                });
            }
        }
    }));
    return errors;
}

//      
function validateString(options) {
    const value = options.value;
    const key = options.key;
    const type = getType(value);
    if (type !== 'string') {
        return [new ValidationError(key, value, `string expected, ${ type } found`)];
    }
    return [];
}

//      
const objectElementValidators = { promoteId: validatePromoteId };
function validateSource(options) {
    const value = options.value;
    const key = options.key;
    const styleSpec = options.styleSpec;
    const style = options.style;
    if (!value.type) {
        return [new ValidationError(key, value, '"type" is required')];
    }
    const type = unbundle(value.type);
    let errors;
    switch (type) {
    case 'vector':
    case 'raster':
    case 'raster-dem':
        errors = validateObject({
            key,
            value,
            valueSpec: styleSpec[`source_${ type.replace('-', '_') }`],
            style: options.style,
            styleSpec,
            objectElementValidators
        });
        return errors;
    case 'geojson':
        errors = validateObject({
            key,
            value,
            valueSpec: styleSpec.source_geojson,
            style,
            styleSpec,
            objectElementValidators
        });
        if (value.cluster) {
            for (const prop in value.clusterProperties) {
                const [operator, mapExpr] = value.clusterProperties[prop];
                const reduceExpr = typeof operator === 'string' ? [
                    operator,
                    ['accumulated'],
                    [
                        'get',
                        prop
                    ]
                ] : operator;
                errors.push(...validateExpression({
                    key: `${ key }.${ prop }.map`,
                    value: mapExpr,
                    expressionContext: 'cluster-map'
                }));
                errors.push(...validateExpression({
                    key: `${ key }.${ prop }.reduce`,
                    value: reduceExpr,
                    expressionContext: 'cluster-reduce'
                }));
            }
        }
        return errors;
    case 'video':
        return validateObject({
            key,
            value,
            valueSpec: styleSpec.source_video,
            style,
            styleSpec
        });
    case 'image':
        return validateObject({
            key,
            value,
            valueSpec: styleSpec.source_image,
            style,
            styleSpec
        });
    case 'canvas':
        return [new ValidationError(key, null, `Please use runtime APIs to add canvas sources, rather than including them in stylesheets.`, 'source.canvas')];
    default:
        return validateEnum({
            key: `${ key }.type`,
            value: value.type,
            valueSpec: { values: getSourceTypeValues(styleSpec) },
            style,
            styleSpec
        });
    }
}
function getSourceTypeValues(styleSpec) {
    return styleSpec.source.reduce((memo, source) => {
        const sourceType = styleSpec[source];
        if (sourceType.type.type === 'enum') {
            memo = memo.concat(Object.keys(sourceType.type.values));
        }
        return memo;
    }, []);
}
function validatePromoteId({key, value}) {
    if (getType(value) === 'string') {
        return validateString({
            key,
            value
        });
    } else {
        const errors = [];
        for (const prop in value) {
            errors.push(...validateString({
                key: `${ key }.${ prop }`,
                value: value[prop]
            }));
        }
        return errors;
    }
}

//      
function validateLight(options) {
    const light = options.value;
    const styleSpec = options.styleSpec;
    const lightSpec = styleSpec.light;
    const style = options.style;
    let errors = [];
    const rootType = getType(light);
    if (light === undefined) {
        return errors;
    } else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('light', light, `object expected, ${ rootType } found`)]);
        return errors;
    }
    for (const key in light) {
        const transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && lightSpec[transitionMatch[1]] && lightSpec[transitionMatch[1]].transition) {
            errors = errors.concat(validate({
                key,
                value: light[key],
                valueSpec: styleSpec.transition,
                style,
                styleSpec
            }));
        } else if (lightSpec[key]) {
            errors = errors.concat(validate({
                key,
                value: light[key],
                valueSpec: lightSpec[key],
                style,
                styleSpec
            }));
        } else {
            errors = errors.concat([new ValidationError(key, light[key], `unknown property "${ key }"`)]);
        }
    }
    return errors;
}

//      
function validateTerrain(options) {
    const terrain = options.value;
    const key = options.key;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const terrainSpec = styleSpec.terrain;
    let errors = [];
    const rootType = getType(terrain);
    if (terrain === undefined) {
        return errors;
    } else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('terrain', terrain, `object expected, ${ rootType } found`)]);
        return errors;
    }
    for (const key in terrain) {
        const transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && terrainSpec[transitionMatch[1]] && terrainSpec[transitionMatch[1]].transition) {
            errors = errors.concat(validate({
                key,
                value: terrain[key],
                valueSpec: styleSpec.transition,
                style,
                styleSpec
            }));
        } else if (terrainSpec[key]) {
            errors = errors.concat(validate({
                key,
                value: terrain[key],
                valueSpec: terrainSpec[key],
                style,
                styleSpec
            }));
        } else {
            errors = errors.concat([new ValidationError(key, terrain[key], `unknown property "${ key }"`)]);
        }
    }
    if (!terrain.source) {
        errors.push(new ValidationError(key, terrain, `terrain is missing required property "source"`));
    } else {
        const source = style.sources && style.sources[terrain.source];
        const sourceType = source && unbundle(source.type);
        if (!source) {
            errors.push(new ValidationError(key, terrain.source, `source "${ terrain.source }" not found`));
        } else if (sourceType !== 'raster-dem') {
            errors.push(new ValidationError(key, terrain.source, `terrain cannot be used with a source of type ${ String(sourceType) }, it only be used with a "raster-dem" source type`));
        }
    }
    return errors;
}

//      
function validateFog(options) {
    const fog = options.value;
    const style = options.style;
    const styleSpec = options.styleSpec;
    const fogSpec = styleSpec.fog;
    let errors = [];
    const rootType = getType(fog);
    if (fog === undefined) {
        return errors;
    } else if (rootType !== 'object') {
        errors = errors.concat([new ValidationError('fog', fog, `object expected, ${ rootType } found`)]);
        return errors;
    }
    for (const key in fog) {
        const transitionMatch = key.match(/^(.*)-transition$/);
        if (transitionMatch && fogSpec[transitionMatch[1]] && fogSpec[transitionMatch[1]].transition) {
            errors = errors.concat(validate({
                key,
                value: fog[key],
                valueSpec: styleSpec.transition,
                style,
                styleSpec
            }));
        } else if (fogSpec[key]) {
            errors = errors.concat(validate({
                key,
                value: fog[key],
                valueSpec: fogSpec[key],
                style,
                styleSpec
            }));
        } else {
            errors = errors.concat([new ValidationError(key, fog[key], `unknown property "${ key }"`)]);
        }
    }
    return errors;
}

//      
function validateFormatted(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

//      
function validateImage(options) {
    if (validateString(options).length === 0) {
        return [];
    }
    return validateExpression(options);
}

//      
function validateProjection(options) {
    const projection = options.value;
    const styleSpec = options.styleSpec;
    const projectionSpec = styleSpec.projection;
    const style = options.style;
    let errors = [];
    const rootType = getType(projection);
    if (rootType === 'object') {
        for (const key in projection) {
            errors = errors.concat(validate({
                key,
                value: projection[key],
                valueSpec: projectionSpec[key],
                style,
                styleSpec
            }));
        }
    } else if (rootType !== 'string') {
        errors = errors.concat([new ValidationError('projection', projection, `object or string expected, ${ rootType } found`)]);
    }
    return errors;
}

//      
const VALIDATORS = {
    '*'() {
        return [];
    },
    'array': validateArray,
    'boolean': validateBoolean,
    'number': validateNumber,
    'color': validateColor,
    'enum': validateEnum,
    'filter': validateFilter,
    'function': validateFunction,
    'layer': validateLayer,
    'object': validateObject,
    'source': validateSource,
    'light': validateLight,
    'terrain': validateTerrain,
    'fog': validateFog,
    'string': validateString,
    'formatted': validateFormatted,
    'resolvedImage': validateImage,
    'projection': validateProjection
};
// Main recursive validation function. Tracks:
//
// - key: string representing location of validation in style tree. Used only
//   for more informative error reporting.
// - value: current value from style being evaluated. May be anything from a
//   high level object that needs to be descended into deeper or a simple
//   scalar value.
// - valueSpec: current spec being evaluated. Tracks value.
// - styleSpec: current full spec being evaluated.
function validate(options) {
    const value = options.value;
    const valueSpec = options.valueSpec;
    const styleSpec = options.styleSpec;
    if (valueSpec.expression && isFunction(unbundle(value))) {
        return validateFunction(options);
    } else if (valueSpec.expression && isExpression(deepUnbundle(value))) {
        return validateExpression(options);
    } else if (valueSpec.type && VALIDATORS[valueSpec.type]) {
        return VALIDATORS[valueSpec.type](options);
    } else {
        const valid = validateObject(extend({}, options, { valueSpec: valueSpec.type ? styleSpec[valueSpec.type] : valueSpec }));
        return valid;
    }
}

//      
function validateGlyphsURL (options) {
    const value = options.value;
    const key = options.key;
    const errors = validateString(options);
    if (errors.length)
        return errors;
    if (value.indexOf('{fontstack}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{fontstack}" token'));
    }
    if (value.indexOf('{range}') === -1) {
        errors.push(new ValidationError(key, value, '"glyphs" url must include a "{range}" token'));
    }
    return errors;
}

//      
/**
 * Validate a Mapbox GL style against the style specification. This entrypoint,
 * `mapbox-gl-style-spec/lib/validate_style.min`, is designed to produce as
 * small a browserify bundle as possible by omitting unnecessary functionality
 * and legacy style specifications.
 *
 * @private
 * @param {Object} style The style to be validated.
 * @param {Object} [styleSpec] The style specification to validate against.
 *     If omitted, the latest style spec is used.
 * @returns {Array<ValidationError>}
 * @example
 *   var validate = require('mapbox-gl-style-spec/lib/validate_style.min');
 *   var errors = validate(style);
 */
function validateStyle$1(style, styleSpec = v8) {
    const errors = validate({
        key: '',
        value: style,
        valueSpec: styleSpec.$root,
        styleSpec,
        style,
        objectElementValidators: {
            glyphs: validateGlyphsURL,
            '*': () => []
        }
    });
    return sortErrors(errors);
}
function sortErrors(errors) {
    return errors.slice().sort((a, b) => a.line && b.line ? a.line - b.line : 0);
}

function commonjsRequire(path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var jsonlint$1 = {};

/* parser generated by jison 0.4.15 */

(function (exports) {
	/*
	  Returns a Parser object of the following structure:

	  Parser: {
	    yy: {}
	  }

	  Parser.prototype: {
	    yy: {},
	    trace: function(),
	    symbols_: {associative list: name ==> number},
	    terminals_: {associative list: number ==> name},
	    productions_: [...],
	    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
	    table: [...],
	    defaultActions: {...},
	    parseError: function(str, hash),
	    parse: function(input),

	    lexer: {
	        EOF: 1,
	        parseError: function(str, hash),
	        setInput: function(input),
	        input: function(),
	        unput: function(str),
	        more: function(),
	        less: function(n),
	        pastInput: function(),
	        upcomingInput: function(),
	        showPosition: function(),
	        test_match: function(regex_match_array, rule_index),
	        next: function(),
	        lex: function(),
	        begin: function(condition),
	        popState: function(),
	        _currentRules: function(),
	        topState: function(),
	        pushState: function(condition),

	        options: {
	            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
	            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
	            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
	        },

	        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
	        rules: [...],
	        conditions: {associative list: name ==> set},
	    }
	  }


	  token location info (@$, _$, etc.): {
	    first_line: n,
	    last_line: n,
	    first_column: n,
	    last_column: n,
	    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
	  }


	  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
	    text:        (matched text)
	    token:       (the produced terminal token, if any)
	    line:        (yylineno)
	  }
	  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
	    loc:         (yylloc)
	    expected:    (string describing the set of expected tokens)
	    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
	  }
	*/
	var parser = function () {
	    var o = function (k, v, o, l) {
	            for (o = o || {}, l = k.length; l--; o[k[l]] = v);
	            return o;
	        }, $V0 = [
	            1,
	            12
	        ], $V1 = [
	            1,
	            13
	        ], $V2 = [
	            1,
	            9
	        ], $V3 = [
	            1,
	            10
	        ], $V4 = [
	            1,
	            11
	        ], $V5 = [
	            1,
	            14
	        ], $V6 = [
	            1,
	            15
	        ], $V7 = [
	            14,
	            18,
	            22,
	            24
	        ], $V8 = [
	            18,
	            22
	        ], $V9 = [
	            22,
	            24
	        ];
	    var parser = {
	        trace: function trace() {
	        },
	        yy: {},
	        symbols_: {
	            'error': 2,
	            'JSONString': 3,
	            'STRING': 4,
	            'JSONNumber': 5,
	            'NUMBER': 6,
	            'JSONNullLiteral': 7,
	            'NULL': 8,
	            'JSONBooleanLiteral': 9,
	            'TRUE': 10,
	            'FALSE': 11,
	            'JSONText': 12,
	            'JSONValue': 13,
	            'EOF': 14,
	            'JSONObject': 15,
	            'JSONArray': 16,
	            '{': 17,
	            '}': 18,
	            'JSONMemberList': 19,
	            'JSONMember': 20,
	            ':': 21,
	            ',': 22,
	            '[': 23,
	            ']': 24,
	            'JSONElementList': 25,
	            '$accept': 0,
	            '$end': 1
	        },
	        terminals_: {
	            2: 'error',
	            4: 'STRING',
	            6: 'NUMBER',
	            8: 'NULL',
	            10: 'TRUE',
	            11: 'FALSE',
	            14: 'EOF',
	            17: '{',
	            18: '}',
	            21: ':',
	            22: ',',
	            23: '[',
	            24: ']'
	        },
	        productions_: [
	            0,
	            [
	                3,
	                1
	            ],
	            [
	                5,
	                1
	            ],
	            [
	                7,
	                1
	            ],
	            [
	                9,
	                1
	            ],
	            [
	                9,
	                1
	            ],
	            [
	                12,
	                2
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                13,
	                1
	            ],
	            [
	                15,
	                2
	            ],
	            [
	                15,
	                3
	            ],
	            [
	                20,
	                3
	            ],
	            [
	                19,
	                1
	            ],
	            [
	                19,
	                3
	            ],
	            [
	                16,
	                2
	            ],
	            [
	                16,
	                3
	            ],
	            [
	                25,
	                1
	            ],
	            [
	                25,
	                3
	            ]
	        ],
	        performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$) {
	            /* this == yyval */
	            var $0 = $$.length - 1;
	            switch (yystate) {
	            case 1:
	                // replace escaped characters with actual character
	                this.$ = new String(yytext.replace(/\\(\\|")/g, '$' + '1').replace(/\\n/g, '\n').replace(/\\r/g, '\r').replace(/\\t/g, '\t').replace(/\\v/g, '\x0B').replace(/\\f/g, '\f').replace(/\\b/g, '\b'));
	                this.$.__line__ = this._$.first_line;
	                break;
	            case 2:
	                this.$ = new Number(yytext);
	                this.$.__line__ = this._$.first_line;
	                break;
	            case 3:
	                this.$ = null;
	                break;
	            case 4:
	                this.$ = new Boolean(true);
	                this.$.__line__ = this._$.first_line;
	                break;
	            case 5:
	                this.$ = new Boolean(false);
	                this.$.__line__ = this._$.first_line;
	                break;
	            case 6:
	                return this.$ = $$[$0 - 1];
	            case 13:
	                this.$ = {};
	                Object.defineProperty(this.$, '__line__', {
	                    value: this._$.first_line,
	                    enumerable: false
	                });
	                break;
	            case 14:
	            case 19:
	                this.$ = $$[$0 - 1];
	                Object.defineProperty(this.$, '__line__', {
	                    value: this._$.first_line,
	                    enumerable: false
	                });
	                break;
	            case 15:
	                this.$ = [
	                    $$[$0 - 2],
	                    $$[$0]
	                ];
	                break;
	            case 16:
	                this.$ = {};
	                this.$[$$[$0][0]] = $$[$0][1];
	                break;
	            case 17:
	                this.$ = $$[$0 - 2];
	                $$[$0 - 2][$$[$0][0]] = $$[$0][1];
	                break;
	            case 18:
	                this.$ = [];
	                Object.defineProperty(this.$, '__line__', {
	                    value: this._$.first_line,
	                    enumerable: false
	                });
	                break;
	            case 20:
	                this.$ = [$$[$0]];
	                break;
	            case 21:
	                this.$ = $$[$0 - 2];
	                $$[$0 - 2].push($$[$0]);
	                break;
	            }
	        },
	        table: [
	            {
	                3: 5,
	                4: $V0,
	                5: 6,
	                6: $V1,
	                7: 3,
	                8: $V2,
	                9: 4,
	                10: $V3,
	                11: $V4,
	                12: 1,
	                13: 2,
	                15: 7,
	                16: 8,
	                17: $V5,
	                23: $V6
	            },
	            { 1: [3] },
	            {
	                14: [
	                    1,
	                    16
	                ]
	            },
	            o($V7, [
	                2,
	                7
	            ]),
	            o($V7, [
	                2,
	                8
	            ]),
	            o($V7, [
	                2,
	                9
	            ]),
	            o($V7, [
	                2,
	                10
	            ]),
	            o($V7, [
	                2,
	                11
	            ]),
	            o($V7, [
	                2,
	                12
	            ]),
	            o($V7, [
	                2,
	                3
	            ]),
	            o($V7, [
	                2,
	                4
	            ]),
	            o($V7, [
	                2,
	                5
	            ]),
	            o([
	                14,
	                18,
	                21,
	                22,
	                24
	            ], [
	                2,
	                1
	            ]),
	            o($V7, [
	                2,
	                2
	            ]),
	            {
	                3: 20,
	                4: $V0,
	                18: [
	                    1,
	                    17
	                ],
	                19: 18,
	                20: 19
	            },
	            {
	                3: 5,
	                4: $V0,
	                5: 6,
	                6: $V1,
	                7: 3,
	                8: $V2,
	                9: 4,
	                10: $V3,
	                11: $V4,
	                13: 23,
	                15: 7,
	                16: 8,
	                17: $V5,
	                23: $V6,
	                24: [
	                    1,
	                    21
	                ],
	                25: 22
	            },
	            {
	                1: [
	                    2,
	                    6
	                ]
	            },
	            o($V7, [
	                2,
	                13
	            ]),
	            {
	                18: [
	                    1,
	                    24
	                ],
	                22: [
	                    1,
	                    25
	                ]
	            },
	            o($V8, [
	                2,
	                16
	            ]),
	            {
	                21: [
	                    1,
	                    26
	                ]
	            },
	            o($V7, [
	                2,
	                18
	            ]),
	            {
	                22: [
	                    1,
	                    28
	                ],
	                24: [
	                    1,
	                    27
	                ]
	            },
	            o($V9, [
	                2,
	                20
	            ]),
	            o($V7, [
	                2,
	                14
	            ]),
	            {
	                3: 20,
	                4: $V0,
	                20: 29
	            },
	            {
	                3: 5,
	                4: $V0,
	                5: 6,
	                6: $V1,
	                7: 3,
	                8: $V2,
	                9: 4,
	                10: $V3,
	                11: $V4,
	                13: 30,
	                15: 7,
	                16: 8,
	                17: $V5,
	                23: $V6
	            },
	            o($V7, [
	                2,
	                19
	            ]),
	            {
	                3: 5,
	                4: $V0,
	                5: 6,
	                6: $V1,
	                7: 3,
	                8: $V2,
	                9: 4,
	                10: $V3,
	                11: $V4,
	                13: 31,
	                15: 7,
	                16: 8,
	                17: $V5,
	                23: $V6
	            },
	            o($V8, [
	                2,
	                17
	            ]),
	            o($V8, [
	                2,
	                15
	            ]),
	            o($V9, [
	                2,
	                21
	            ])
	        ],
	        defaultActions: {
	            16: [
	                2,
	                6
	            ]
	        },
	        parseError: function parseError(str, hash) {
	            if (hash.recoverable) {
	                this.trace(str);
	            } else {
	                throw new Error(str);
	            }
	        },
	        parse: function parse(input) {
	            var self = this, stack = [0], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, TERROR = 2, EOF = 1;
	            var args = lstack.slice.call(arguments, 1);
	            var lexer = Object.create(this.lexer);
	            var sharedState = { yy: {} };
	            for (var k in this.yy) {
	                if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
	                    sharedState.yy[k] = this.yy[k];
	                }
	            }
	            lexer.setInput(input, sharedState.yy);
	            sharedState.yy.lexer = lexer;
	            sharedState.yy.parser = this;
	            if (typeof lexer.yylloc == 'undefined') {
	                lexer.yylloc = {};
	            }
	            var yyloc = lexer.yylloc;
	            lstack.push(yyloc);
	            var ranges = lexer.options && lexer.options.ranges;
	            if (typeof sharedState.yy.parseError === 'function') {
	                this.parseError = sharedState.yy.parseError;
	            } else {
	                this.parseError = Object.getPrototypeOf(this).parseError;
	            }
	            function lex() {
	                var token;
	                token = lexer.lex() || EOF;
	                if (typeof token !== 'number') {
	                    token = self.symbols_[token] || token;
	                }
	                return token;
	            }
	            var symbol, state, action, r, yyval = {}, p, len, newState, expected;
	            while (true) {
	                state = stack[stack.length - 1];
	                if (this.defaultActions[state]) {
	                    action = this.defaultActions[state];
	                } else {
	                    if (symbol === null || typeof symbol == 'undefined') {
	                        symbol = lex();
	                    }
	                    action = table[state] && table[state][symbol];
	                }
	                if (typeof action === 'undefined' || !action.length || !action[0]) {
	                    var errStr = '';
	                    expected = [];
	                    for (p in table[state]) {
	                        if (this.terminals_[p] && p > TERROR) {
	                            expected.push('\'' + this.terminals_[p] + '\'');
	                        }
	                    }
	                    if (lexer.showPosition) {
	                        errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
	                    } else {
	                        errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
	                    }
	                    this.parseError(errStr, {
	                        text: lexer.match,
	                        token: this.terminals_[symbol] || symbol,
	                        line: lexer.yylineno,
	                        loc: yyloc,
	                        expected: expected
	                    });
	                }
	                if (action[0] instanceof Array && action.length > 1) {
	                    throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
	                }
	                switch (action[0]) {
	                case 1:
	                    stack.push(symbol);
	                    vstack.push(lexer.yytext);
	                    lstack.push(lexer.yylloc);
	                    stack.push(action[1]);
	                    symbol = null;
	                    {
	                        yyleng = lexer.yyleng;
	                        yytext = lexer.yytext;
	                        yylineno = lexer.yylineno;
	                        yyloc = lexer.yylloc;
	                    }
	                    break;
	                case 2:
	                    len = this.productions_[action[1]][1];
	                    yyval.$ = vstack[vstack.length - len];
	                    yyval._$ = {
	                        first_line: lstack[lstack.length - (len || 1)].first_line,
	                        last_line: lstack[lstack.length - 1].last_line,
	                        first_column: lstack[lstack.length - (len || 1)].first_column,
	                        last_column: lstack[lstack.length - 1].last_column
	                    };
	                    if (ranges) {
	                        yyval._$.range = [
	                            lstack[lstack.length - (len || 1)].range[0],
	                            lstack[lstack.length - 1].range[1]
	                        ];
	                    }
	                    r = this.performAction.apply(yyval, [
	                        yytext,
	                        yyleng,
	                        yylineno,
	                        sharedState.yy,
	                        action[1],
	                        vstack,
	                        lstack
	                    ].concat(args));
	                    if (typeof r !== 'undefined') {
	                        return r;
	                    }
	                    if (len) {
	                        stack = stack.slice(0, -1 * len * 2);
	                        vstack = vstack.slice(0, -1 * len);
	                        lstack = lstack.slice(0, -1 * len);
	                    }
	                    stack.push(this.productions_[action[1]][0]);
	                    vstack.push(yyval.$);
	                    lstack.push(yyval._$);
	                    newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
	                    stack.push(newState);
	                    break;
	                case 3:
	                    return true;
	                }
	            }
	            return true;
	        }
	    };
	    /* generated by jison-lex 0.3.4 */
	    var lexer = function () {
	        var lexer = {
	            EOF: 1,
	            parseError: function parseError(str, hash) {
	                if (this.yy.parser) {
	                    this.yy.parser.parseError(str, hash);
	                } else {
	                    throw new Error(str);
	                }
	            },
	            // resets the lexer, sets new input
	            setInput: function (input, yy) {
	                this.yy = yy || this.yy || {};
	                this._input = input;
	                this._more = this._backtrack = this.done = false;
	                this.yylineno = this.yyleng = 0;
	                this.yytext = this.matched = this.match = '';
	                this.conditionStack = ['INITIAL'];
	                this.yylloc = {
	                    first_line: 1,
	                    first_column: 0,
	                    last_line: 1,
	                    last_column: 0
	                };
	                if (this.options.ranges) {
	                    this.yylloc.range = [
	                        0,
	                        0
	                    ];
	                }
	                this.offset = 0;
	                return this;
	            },
	            // consumes and returns one char from the input
	            input: function () {
	                var ch = this._input[0];
	                this.yytext += ch;
	                this.yyleng++;
	                this.offset++;
	                this.match += ch;
	                this.matched += ch;
	                var lines = ch.match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno++;
	                    this.yylloc.last_line++;
	                } else {
	                    this.yylloc.last_column++;
	                }
	                if (this.options.ranges) {
	                    this.yylloc.range[1]++;
	                }
	                this._input = this._input.slice(1);
	                return ch;
	            },
	            // unshifts one char (or a string) into the input
	            unput: function (ch) {
	                var len = ch.length;
	                var lines = ch.split(/(?:\r\n?|\n)/g);
	                this._input = ch + this._input;
	                this.yytext = this.yytext.substr(0, this.yytext.length - len);
	                //this.yyleng -= len;
	                this.offset -= len;
	                var oldLines = this.match.split(/(?:\r\n?|\n)/g);
	                this.match = this.match.substr(0, this.match.length - 1);
	                this.matched = this.matched.substr(0, this.matched.length - 1);
	                if (lines.length - 1) {
	                    this.yylineno -= lines.length - 1;
	                }
	                var r = this.yylloc.range;
	                this.yylloc = {
	                    first_line: this.yylloc.first_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.first_column,
	                    last_column: lines ? (lines.length === oldLines.length ? this.yylloc.first_column : 0) + oldLines[oldLines.length - lines.length].length - lines[0].length : this.yylloc.first_column - len
	                };
	                if (this.options.ranges) {
	                    this.yylloc.range = [
	                        r[0],
	                        r[0] + this.yyleng - len
	                    ];
	                }
	                this.yyleng = this.yytext.length;
	                return this;
	            },
	            // When called from action, caches matched text and appends it on next action
	            more: function () {
	                this._more = true;
	                return this;
	            },
	            // When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
	            reject: function () {
	                if (this.options.backtrack_lexer) {
	                    this._backtrack = true;
	                } else {
	                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
	                        text: '',
	                        token: null,
	                        line: this.yylineno
	                    });
	                }
	                return this;
	            },
	            // retain first n characters of the match
	            less: function (n) {
	                this.unput(this.match.slice(n));
	            },
	            // displays already matched input, i.e. for error messages
	            pastInput: function () {
	                var past = this.matched.substr(0, this.matched.length - this.match.length);
	                return (past.length > 20 ? '...' : '') + past.substr(-20).replace(/\n/g, '');
	            },
	            // displays upcoming input, i.e. for error messages
	            upcomingInput: function () {
	                var next = this.match;
	                if (next.length < 20) {
	                    next += this._input.substr(0, 20 - next.length);
	                }
	                return (next.substr(0, 20) + (next.length > 20 ? '...' : '')).replace(/\n/g, '');
	            },
	            // displays the character position where the lexing error occurred, i.e. for error messages
	            showPosition: function () {
	                var pre = this.pastInput();
	                var c = new Array(pre.length + 1).join('-');
	                return pre + this.upcomingInput() + '\n' + c + '^';
	            },
	            // test the lexed token: return FALSE when not a match, otherwise return token
	            test_match: function (match, indexed_rule) {
	                var token, lines, backup;
	                if (this.options.backtrack_lexer) {
	                    // save context
	                    backup = {
	                        yylineno: this.yylineno,
	                        yylloc: {
	                            first_line: this.yylloc.first_line,
	                            last_line: this.last_line,
	                            first_column: this.yylloc.first_column,
	                            last_column: this.yylloc.last_column
	                        },
	                        yytext: this.yytext,
	                        match: this.match,
	                        matches: this.matches,
	                        matched: this.matched,
	                        yyleng: this.yyleng,
	                        offset: this.offset,
	                        _more: this._more,
	                        _input: this._input,
	                        yy: this.yy,
	                        conditionStack: this.conditionStack.slice(0),
	                        done: this.done
	                    };
	                    if (this.options.ranges) {
	                        backup.yylloc.range = this.yylloc.range.slice(0);
	                    }
	                }
	                lines = match[0].match(/(?:\r\n?|\n).*/g);
	                if (lines) {
	                    this.yylineno += lines.length;
	                }
	                this.yylloc = {
	                    first_line: this.yylloc.last_line,
	                    last_line: this.yylineno + 1,
	                    first_column: this.yylloc.last_column,
	                    last_column: lines ? lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length : this.yylloc.last_column + match[0].length
	                };
	                this.yytext += match[0];
	                this.match += match[0];
	                this.matches = match;
	                this.yyleng = this.yytext.length;
	                if (this.options.ranges) {
	                    this.yylloc.range = [
	                        this.offset,
	                        this.offset += this.yyleng
	                    ];
	                }
	                this._more = false;
	                this._backtrack = false;
	                this._input = this._input.slice(match[0].length);
	                this.matched += match[0];
	                token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
	                if (this.done && this._input) {
	                    this.done = false;
	                }
	                if (token) {
	                    return token;
	                } else if (this._backtrack) {
	                    // recover context
	                    for (var k in backup) {
	                        this[k] = backup[k];
	                    }
	                    return false;    // rule action called reject() implying the next rule should be tested instead.
	                }
	                return false;
	            },
	            // return next match in input
	            next: function () {
	                if (this.done) {
	                    return this.EOF;
	                }
	                if (!this._input) {
	                    this.done = true;
	                }
	                var token, match, tempMatch, index;
	                if (!this._more) {
	                    this.yytext = '';
	                    this.match = '';
	                }
	                var rules = this._currentRules();
	                for (var i = 0; i < rules.length; i++) {
	                    tempMatch = this._input.match(this.rules[rules[i]]);
	                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
	                        match = tempMatch;
	                        index = i;
	                        if (this.options.backtrack_lexer) {
	                            token = this.test_match(tempMatch, rules[i]);
	                            if (token !== false) {
	                                return token;
	                            } else if (this._backtrack) {
	                                match = false;
	                                continue;    // rule action called reject() implying a rule MISmatch.
	                            } else {
	                                // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	                                return false;
	                            }
	                        } else if (!this.options.flex) {
	                            break;
	                        }
	                    }
	                }
	                if (match) {
	                    token = this.test_match(match, rules[index]);
	                    if (token !== false) {
	                        return token;
	                    }
	                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
	                    return false;
	                }
	                if (this._input === '') {
	                    return this.EOF;
	                } else {
	                    return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
	                        text: '',
	                        token: null,
	                        line: this.yylineno
	                    });
	                }
	            },
	            // return next match that has a token
	            lex: function lex() {
	                var r = this.next();
	                if (r) {
	                    return r;
	                } else {
	                    return this.lex();
	                }
	            },
	            // activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
	            begin: function begin(condition) {
	                this.conditionStack.push(condition);
	            },
	            // pop the previously active lexer condition state off the condition stack
	            popState: function popState() {
	                var n = this.conditionStack.length - 1;
	                if (n > 0) {
	                    return this.conditionStack.pop();
	                } else {
	                    return this.conditionStack[0];
	                }
	            },
	            // produce the lexer rule set which is active for the currently active lexer condition state
	            _currentRules: function _currentRules() {
	                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
	                    return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
	                } else {
	                    return this.conditions['INITIAL'].rules;
	                }
	            },
	            // return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
	            topState: function topState(n) {
	                n = this.conditionStack.length - 1 - Math.abs(n || 0);
	                if (n >= 0) {
	                    return this.conditionStack[n];
	                } else {
	                    return 'INITIAL';
	                }
	            },
	            // alias for begin(condition)
	            pushState: function pushState(condition) {
	                this.begin(condition);
	            },
	            // return the number of states currently on the stack
	            stateStackSize: function stateStackSize() {
	                return this.conditionStack.length;
	            },
	            options: {},
	            performAction: function anonymous(yy, yy_, $avoiding_name_collisions, YY_START) {
	                switch ($avoiding_name_collisions) {
	                case 0:
	                    /* skip whitespace */
	                    break;
	                case 1:
	                    return 6;
	                case 2:
	                    yy_.yytext = yy_.yytext.substr(1, yy_.yyleng - 2);
	                    return 4;
	                case 3:
	                    return 17;
	                case 4:
	                    return 18;
	                case 5:
	                    return 23;
	                case 6:
	                    return 24;
	                case 7:
	                    return 22;
	                case 8:
	                    return 21;
	                case 9:
	                    return 10;
	                case 10:
	                    return 11;
	                case 11:
	                    return 8;
	                case 12:
	                    return 14;
	                case 13:
	                    return 'INVALID';
	                }
	            },
	            rules: [
	                /^(?:\s+)/,
	                /^(?:(-?([0-9]|[1-9][0-9]+))(\.[0-9]+)?([eE][-+]?[0-9]+)?\b)/,
	                /^(?:"(?:\\[\\"bfnrt/]|\\u[a-fA-F0-9]{4}|[^\\\0-\x09\x0a-\x1f"])*")/,
	                /^(?:\{)/,
	                /^(?:\})/,
	                /^(?:\[)/,
	                /^(?:\])/,
	                /^(?:,)/,
	                /^(?::)/,
	                /^(?:true\b)/,
	                /^(?:false\b)/,
	                /^(?:null\b)/,
	                /^(?:$)/,
	                /^(?:.)/
	            ],
	            conditions: {
	                'INITIAL': {
	                    'rules': [
	                        0,
	                        1,
	                        2,
	                        3,
	                        4,
	                        5,
	                        6,
	                        7,
	                        8,
	                        9,
	                        10,
	                        11,
	                        12,
	                        13
	                    ],
	                    'inclusive': true
	                }
	            }
	        };
	        return lexer;
	    }();
	    parser.lexer = lexer;
	    function Parser() {
	        this.yy = {};
	    }
	    Parser.prototype = parser;
	    parser.Parser = Parser;
	    return new Parser();
	}();
	if (typeof commonjsRequire !== 'undefined' && 'object' !== 'undefined') {
	    exports.parser = parser;
	    exports.Parser = parser.Parser;
	    exports.parse = function () {
	        return parser.parse.apply(parser, arguments);
	    };
	}
} (jsonlint$1));

var jsonlint = jsonlint$1;

function readStyle(style) {
    if (style instanceof String || typeof style === 'string' || style instanceof Buffer) {
        try {
            return jsonlint.parse(style.toString());
        } catch (e) {
            throw new ParsingError(e);
        }
    }
    return style;
}

//      
/**
 * Validate a Mapbox GL style against the style specification.
 *
 * @private
 * @alias validate
 * @param {Object|String|Buffer} style The style to be validated. If a `String`
 *     or `Buffer` is provided, the returned errors will contain line numbers.
 * @param {Object} [styleSpec] The style specification to validate against.
 *     If omitted, the spec version is inferred from the stylesheet.
 * @returns {Array<ValidationError|ParsingError>}
 * @example
 *   var validate = require('mapbox-gl-style-spec').validate;
 *   var style = fs.readFileSync('./style.json', 'utf8');
 *   var errors = validate(style);
 */
function validateStyle(style, styleSpec = v8) {
    let s = style;
    try {
        s = readStyle(s);
    } catch (e) {
        return [e];
    }
    return validateStyle$1(s, styleSpec);
}

//      
const SUPPORTED_SPEC_VERSION = 8;
const MAX_SOURCES_IN_STYLE = 15;
function isValid(value, regex) {
    if (!value || getType(value) !== 'string')
        return true;
    return !!value.match(regex);
}
function getSourceCount(source) {
    if (source.url) {
        return source.url.split(',').length;
    } else {
        return 0;
    }
}
function getAllowedKeyErrors(obj, keys, path) {
    const allowed = new Set(keys);
    const errors = [];
    Object.keys(obj).forEach(k => {
        if (!allowed.has(k)) {
            const prop = path ? `${ path }.${ k }` : null;
            errors.push(new ValidationError(prop, obj[k], `Unsupported property "${ k }"`));
        }
    });
    return errors;
}
const acceptedSourceTypes = new Set([
    'vector',
    'raster',
    'raster-dem'
]);
function getSourceErrors(source, i) {
    const errors = [];
    /*
     * Inlined sources are not supported by the Mapbox Styles API, so only
     * "type", "url", and "tileSize" properties are valid
     */
    const sourceKeys = [
        'type',
        'url',
        'tileSize'
    ];
    errors.push(...getAllowedKeyErrors(source, sourceKeys, 'source'));
    /*
     * "type" is required and must be one of "vector", "raster", "raster-dem"
     */
    if (!acceptedSourceTypes.has(String(source.type))) {
        errors.push(new ValidationError(`sources[${ i }].type`, source.type, `Expected one of [${ Array.from(acceptedSourceTypes).join(', ') }]`));
    }
    /*
     * "source" is required. Valid examples:
     * mapbox://mapbox.abcd1234
     * mapbox://penny.abcd1234
     * mapbox://mapbox.abcd1234,penny.abcd1234
     */
    const sourceUrlPattern = /^mapbox:\/\/([^/]*)$/;
    if (!source.url || !isValid(source.url, sourceUrlPattern)) {
        errors.push(new ValidationError(`sources[${ i }].url`, source.url, 'Expected a valid Mapbox tileset url'));
    }
    return errors;
}
function getSourcesErrors(sources) {
    const errors = [];
    let count = 0;
    Object.keys(sources).forEach((s, i) => {
        const sourceErrors = getSourceErrors(sources[s], i);
        // If source has errors, skip counting
        if (!sourceErrors.length) {
            count = count + getSourceCount(sources[s]);
        }
        errors.push(...sourceErrors);
    });
    if (count > MAX_SOURCES_IN_STYLE) {
        errors.push(new ValidationError('sources', null, `Styles must contain ${ MAX_SOURCES_IN_STYLE } or fewer sources`));
    }
    return errors;
}
function getRootErrors(style, specKeys) {
    const errors = [];
    /*
     * The following keys are optional but fully managed by the Mapbox Styles
     * API. Values on stylesheet on POST or PATCH will be ignored: "owner",
     * "id", "cacheControl", "draft", "created", "modified", "protected"
     *
     * The following keys are optional. The Mapbox Styles API respects value on
     * stylesheet on PATCH, but ignores the value on POST: "visibility"
     */
    const optionalRootProperties = [
        'owner',
        'id',
        'cacheControl',
        'draft',
        'created',
        'modified',
        'visibility',
        'protected'
    ];
    const allowedKeyErrors = getAllowedKeyErrors(style, [
        ...specKeys,
        ...optionalRootProperties
    ]);
    errors.push(...allowedKeyErrors);
    if (style.version > SUPPORTED_SPEC_VERSION || style.version < SUPPORTED_SPEC_VERSION) {
        errors.push(new ValidationError('version', style.version, `Style version must be ${ SUPPORTED_SPEC_VERSION }`));
    }
    /*
     * "glyphs" is optional. If present, valid examples:
     * mapbox://fonts/penny/{fontstack}/{range}.pbf
     * mapbox://fonts/mapbox/{fontstack}/{range}.pbf
     */
    const glyphUrlPattern = /^mapbox:\/\/fonts\/([^/]*)\/{fontstack}\/{range}.pbf$/;
    if (!isValid(style.glyphs, glyphUrlPattern)) {
        errors.push(new ValidationError('glyphs', style.glyphs, 'Styles must reference glyphs hosted by Mapbox'));
    }
    /*
     * "sprite" is optional. If present, valid examples:
     * mapbox://sprites/penny/abcd1234
     * mapbox://sprites/mapbox/abcd1234/draft
     * mapbox://sprites/cyrus/abcd1234/abcd1234
     */
    const spriteUrlPattern = /^mapbox:\/\/sprites\/([^/]*)\/([^/]*)\/?([^/]*)?$/;
    if (!isValid(style.sprite, spriteUrlPattern)) {
        errors.push(new ValidationError('sprite', style.sprite, 'Styles must reference sprites hosted by Mapbox'));
    }
    /*
     * "visibility" is optional. If present, valid examples:
     * "private"
     * "public"
     */
    const visibilityPattern = /^(public|private)$/;
    if (!isValid(style.visibility, visibilityPattern)) {
        errors.push(new ValidationError('visibility', style.visibility, 'Style visibility must be public or private'));
    }
    if (style.protected !== undefined && getType(style.protected) !== 'boolean') {
        errors.push(new ValidationError('protected', style.protected, 'Style protection must be true or false'));
    }
    return errors;
}
/**
 * Validate a Mapbox GL style against the style specification and check for
 * compatibility with the Mapbox Styles API.
 *
 * @param {Object} style The style to be validated.
 * @returns {Array<ValidationError>}
 * @example
 *   var validateMapboxApiSupported = require('mapbox-gl-style-spec/lib/validate_style_mapbox_api_supported.js');
 *   var errors = validateMapboxApiSupported(style);
 */
function validateMapboxApiSupported(style, styleSpec = v8) {
    let s = style;
    try {
        s = readStyle(s);
    } catch (e) {
        return [e];
    }
    let errors = validateStyle$1(s, styleSpec).concat(getRootErrors(s, Object.keys(v8.$root)));
    if (s.sources) {
        errors = errors.concat(getSourcesErrors(s.sources));
    }
    return errors;
}

//      
const expression = {
    StyleExpression,
    isExpression,
    isExpressionFilter,
    createExpression,
    createPropertyExpression,
    normalizePropertyExpression,
    ZoomConstantExpression,
    ZoomDependentExpression,
    StylePropertyFunction
};
const styleFunction = {
    convertFunction,
    createFunction,
    isFunction
};
const visit = {
    eachSource,
    eachLayer,
    eachProperty
};


//# sourceMappingURL=index.es.js.map

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(30), __webpack_require__(338).Buffer))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(339)
var ieee754 = __webpack_require__(225)
var isArray = __webpack_require__(340)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(30)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 340 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assign", function() { return assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deg2rad", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultResolutions", function() { return defaultResolutions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createCanvas", function() { return createCanvas; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getZoomForResolution", function() { return getZoomForResolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyLetterSpacing", function() { return applyLetterSpacing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapText", function() { return wrapText; });
/* harmony import */ var ol_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53);
/* harmony import */ var ol_render_canvas_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44);
/* harmony import */ var ol_events_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54);



/**
 * Polyfill for Object.assign().  Assigns enumerable and own properties from
 * one or more source objects to a target object.
 * See https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Object/assign.
 *
 * @param {!Object} target The target object.
 * @param {...Object} var_sources The source object(s).
 * @return {!Object} The modified target object.
 */
var assign = typeof Object.assign === 'function'
    ? Object.assign
    : function (target, var_sources) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }
        var output = Object(target);
        for (var i = 1, ii = arguments.length; i < ii; ++i) {
            var source = arguments[i];
            if (source !== undefined && source !== null) {
                for (var key in source) {
                    if (source.hasOwnProperty(key)) {
                        output[key] = source[key];
                    }
                }
            }
        }
        return output;
    };
function deg2rad(degrees) {
    return (degrees * Math.PI) / 180;
}
var defaultResolutions = (function () {
    var resolutions = [];
    for (var res = 78271.51696402048; resolutions.length <= 24; res /= 2) {
        resolutions.push(res);
    }
    return resolutions;
})();
/**
 * @param {number} width Width of the canvas.
 * @param {number} height Height of the canvas.
 * @return {HTMLCanvasElement} Canvas.
 */
function createCanvas(width, height) {
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope && typeof OffscreenCanvas !== 'undefined') { // eslint-disable-line
        return /** @type {?} */ (new OffscreenCanvas(width, height));
    }
    else {
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
}
function getZoomForResolution(resolution, resolutions) {
    var i = 0;
    var ii = resolutions.length;
    for (; i < ii; ++i) {
        var candidate = resolutions[i];
        if (candidate < resolution && i + 1 < ii) {
            var zoomFactor = resolutions[i] / resolutions[i + 1];
            return i + Math.log(resolutions[i] / resolution) / Math.log(zoomFactor);
        }
    }
    return ii - 1;
}
var hairSpacePool = Array(256).join('\u200A');
function applyLetterSpacing(text, letterSpacing) {
    if (letterSpacing >= 0.05) {
        var textWithLetterSpacing = '';
        var lines = text.split('\n');
        var joinSpaceString = hairSpacePool.slice(0, Math.round(letterSpacing / 0.1));
        for (var l = 0, ll = lines.length; l < ll; ++l) {
            if (l > 0) {
                textWithLetterSpacing += '\n';
            }
            textWithLetterSpacing += lines[l].split('').join(joinSpaceString);
        }
        return textWithLetterSpacing;
    }
    return text;
}
var measureContext;
function getMeasureContext() {
    if (!measureContext) {
        measureContext = createCanvas(1, 1).getContext('2d');
    }
    return measureContext;
}
function measureText(text, letterSpacing) {
    return (getMeasureContext().measureText(text).width +
        (text.length - 1) * letterSpacing);
}
var measureCache = {};
if (ol_render_canvas_js__WEBPACK_IMPORTED_MODULE_1__["labelCache"]) {
    // Only available when using ES modules
    //@ts-ignore
    Object(ol_events_js__WEBPACK_IMPORTED_MODULE_2__["listen"])(ol_render_canvas_js__WEBPACK_IMPORTED_MODULE_1__["labelCache"], ol_events_EventType_js__WEBPACK_IMPORTED_MODULE_0__["default"].CLEAR, function () {
        measureCache = {};
    });
}
function wrapText(text, font, em, letterSpacing) {
    if (text.indexOf('\n') !== -1) {
        var hardLines = text.split('\n');
        var lines = [];
        for (var i = 0, ii = hardLines.length; i < ii; ++i) {
            lines.push(wrapText(hardLines[i], font, em, letterSpacing));
        }
        return lines.join('\n');
    }
    var key = em + ',' + font + ',' + text + ',' + letterSpacing;
    var wrappedText = measureCache[key];
    if (!wrappedText) {
        var words = text.split(' ');
        if (words.length > 1) {
            var ctx = getMeasureContext();
            ctx.font = font;
            var oneEm = ctx.measureText('M').width;
            var maxWidth = oneEm * em;
            var line = '';
            var lines = [];
            // Pass 1 - wrap lines to not exceed maxWidth
            for (var i = 0, ii = words.length; i < ii; ++i) {
                var word = words[i];
                var testLine = line + (line ? ' ' : '') + word;
                if (measureText(testLine, letterSpacing) <= maxWidth) {
                    line = testLine;
                }
                else {
                    if (line) {
                        lines.push(line);
                    }
                    line = word;
                }
            }
            if (line) {
                lines.push(line);
            }
            // Pass 2 - add lines with a width of less than 30% of maxWidth to the previous or next line
            for (var i = 0, ii = lines.length; i < ii && ii > 1; ++i) {
                var line_1 = lines[i];
                if (measureText(line_1, letterSpacing) < maxWidth * 0.35) {
                    var prevWidth = i > 0 ? measureText(lines[i - 1], letterSpacing) : Infinity;
                    var nextWidth = i < ii - 1 ? measureText(lines[i + 1], letterSpacing) : Infinity;
                    lines.splice(i, 1);
                    ii -= 1;
                    if (prevWidth < nextWidth) {
                        lines[i - 1] += ' ' + line_1;
                        i -= 1;
                    }
                    else {
                        lines[i] = line_1 + ' ' + lines[i];
                    }
                }
            }
            // Pass 3 - try to fill 80% of maxWidth for each line
            for (var i = 0, ii = lines.length - 1; i < ii; ++i) {
                var line_2 = lines[i];
                var next = lines[i + 1];
                if (measureText(line_2, letterSpacing) > maxWidth * 0.7 &&
                    measureText(next, letterSpacing) < maxWidth * 0.6) {
                    var lineWords = line_2.split(' ');
                    var lastWord = lineWords.pop();
                    if (measureText(lastWord, letterSpacing) < maxWidth * 0.2) {
                        lines[i] = lineWords.join(' ');
                        lines[i + 1] = lastWord + ' ' + next;
                    }
                    ii -= 1;
                }
            }
            wrappedText = lines.join('\n');
        }
        else {
            wrappedText = text;
        }
        wrappedText = applyLetterSpacing(wrappedText, letterSpacing);
        measureCache[key] = wrappedText;
    }
    return wrappedText;
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.10.0
(function() {
  var families;

  module.exports = {
    icon: 'icons/google.svg',
    name: 'google',
    title: 'Google Fonts',
    link: 'google.com/fonts',
    getNames: function() {
      return families;
    },
    getLink: function(name) {
      return "https://fonts.google.com/specimen/" + (name.replace(/( )/g, '+'));
    },
    normalizeName: function(name) {
      return name;
    }
  };

  families = ["ABeeZee", "Abel", "Abril Fatface", "Aclonica", "Acme", "Actor", "Adamina", "Advent Pro", "Aguafina Script", "Akronim", "Aladin", "Aldrich", "Alef", "Alegreya", "Alegreya SC", "Alegreya Sans", "Alegreya Sans SC", "Alex Brush", "Alfa Slab One", "Alice", "Alike", "Alike Angular", "Allan", "Allerta", "Allerta Stencil", "Allura", "Almendra", "Almendra Display", "Almendra SC", "Amarante", "Amaranth", "Amatic SC", "Amethysta", "Amiri", "Amita", "Anaheim", "Andada", "Andika", "Angkor", "Annie Use Your Telescope", "Anonymous Pro", "Antic", "Antic Didone", "Antic Slab", "Anton", "Arapey", "Arbutus", "Arbutus Slab", "Architects Daughter", "Archivo Black", "Archivo Narrow", "Arimo", "Arizonia", "Armata", "Artifika", "Arvo", "Arya", "Asap", "Asar", "Asset", "Astloch", "Asul", "Atomic Age", "Aubrey", "Audiowide", "Autour One", "Average", "Average Sans", "Averia Gruesa Libre", "Averia Libre", "Averia Sans Libre", "Averia Serif Libre", "Bad Script", "Balthazar", "Bangers", "Basic", "Battambang", "Baumans", "Bayon", "Belgrano", "Belleza", "BenchNine", "Bentham", "Berkshire Swash", "Bevan", "Bigelow Rules", "Bigshot One", "Bilbo", "Bilbo Swash Caps", "Biryani", "Bitter", "Black Ops One", "Bokor", "Bonbon", "Boogaloo", "Bowlby One", "Bowlby One SC", "Brawler", "Bree Serif", "Bubblegum Sans", "Bubbler One", "Buda", "Buenard", "Butcherman", "Butterfly Kids", "Cabin", "Cabin Condensed", "Cabin Sketch", "Caesar Dressing", "Cagliostro", "Calligraffitti", "Cambay", "Cambo", "Candal", "Cantarell", "Cantata One", "Cantora One", "Capriola", "Cardo", "Carme", "Carrois Gothic", "Carrois Gothic SC", "Carter One", "Catamaran", "Caudex", "Caveat", "Caveat Brush", "Cedarville Cursive", "Ceviche One", "Changa One", "Chango", "Chau Philomene One", "Chela One", "Chelsea Market", "Chenla", "Cherry Cream Soda", "Cherry Swash", "Chewy", "Chicle", "Chivo", "Chonburi", "Cinzel", "Cinzel Decorative", "Clicker Script", "Coda", "Coda Caption", "Codystar", "Combo", "Comfortaa", "Coming Soon", "Concert One", "Condiment", "Content", "Contrail One", "Convergence", "Cookie", "Copse", "Corben", "Courgette", "Cousine", "Coustard", "Covered By Your Grace", "Crafty Girls", "Creepster", "Crete Round", "Crimson Text", "Croissant One", "Crushed", "Cuprum", "Cutive", "Cutive Mono", "Damion", "Dancing Script", "Dangrek", "Dawning of a New Day", "Days One", "Dekko", "Delius", "Delius Swash Caps", "Delius Unicase", "Della Respira", "Denk One", "Devonshire", "Dhurjati", "Didact Gothic", "Diplomata", "Diplomata SC", "Domine", "Donegal One", "Doppio One", "Dorsa", "Dosis", "Dr Sugiyama", "Droid Sans", "Droid Sans Mono", "Droid Serif", "Duru Sans", "Dynalight", "EB Garamond", "Eagle Lake", "Eater", "Economica", "Eczar", "Ek Mukta", "Electrolize", "Elsie", "Elsie Swash Caps", "Emblema One", "Emilys Candy", "Engagement", "Englebert", "Enriqueta", "Erica One", "Esteban", "Euphoria Script", "Ewert", "Exo", "Exo 2", "Expletus Sans", "Fanwood Text", "Fascinate", "Fascinate Inline", "Faster One", "Fasthand", "Fauna One", "Federant", "Federo", "Felipa", "Fenix", "Finger Paint", "Fira Mono", "Fira Sans", "Fjalla One", "Fjord One", "Flamenco", "Flavors", "Fondamento", "Fontdiner Swanky", "Forum", "Francois One", "Freckle Face", "Fredericka the Great", "Fredoka One", "Freehand", "Fresca", "Frijole", "Fruktur", "Fugaz One", "GFS Didot", "GFS Neohellenic", "Gabriela", "Gafata", "Galdeano", "Galindo", "Gentium Basic", "Gentium Book Basic", "Geo", "Geostar", "Geostar Fill", "Germania One", "Gidugu", "Gilda Display", "Give You Glory", "Glass Antiqua", "Glegoo", "Gloria Hallelujah", "Goblin One", "Gochi Hand", "Gorditas", "Goudy Bookletter 1911", "Graduate", "Grand Hotel", "Gravitas One", "Great Vibes", "Griffy", "Gruppo", "Gudea", "Gurajada", "Habibi", "Halant", "Hammersmith One", "Hanalei", "Hanalei Fill", "Handlee", "Hanuman", "Happy Monkey", "Headland One", "Henny Penny", "Herr Von Muellerhoff", "Hind", "Hind Siliguri", "Hind Vadodara", "Holtwood One SC", "Homemade Apple", "Homenaje", "IM Fell DW Pica", "IM Fell DW Pica SC", "IM Fell Double Pica", "IM Fell Double Pica SC", "IM Fell English", "IM Fell English SC", "IM Fell French Canon", "IM Fell French Canon SC", "IM Fell Great Primer", "IM Fell Great Primer SC", "Iceberg", "Iceland", "Imprima", "Inconsolata", "Inder", "Indie Flower", "Inika", "Inknut Antiqua", "Irish Grover", "Istok Web", "Italiana", "Italianno", "Itim", "Jacques Francois", "Jacques Francois Shadow", "Jaldi", "Jim Nightshade", "Jockey One", "Jolly Lodger", "Josefin Sans", "Josefin Slab", "Joti One", "Judson", "Julee", "Julius Sans One", "Junge", "Jura", "Just Another Hand", "Just Me Again Down Here", "Kadwa", "Kalam", "Kameron", "Kantumruy", "Karla", "Karma", "Kaushan Script", "Kavoon", "Kdam Thmor", "Keania One", "Kelly Slab", "Kenia", "Khand", "Khmer", "Khula", "Kite One", "Knewave", "Kotta One", "Koulen", "Kranky", "Kreon", "Kristi", "Krona One", "Kurale", "La Belle Aurore", "Laila", "Lakki Reddy", "Lancelot", "Lateef", "Lato", "League Script", "Leckerli One", "Ledger", "Lekton", "Lemon", "Libre Baskerville", "Life Savers", "Lilita One", "Lily Script One", "Limelight", "Linden Hill", "Lobster", "Lobster Two", "Londrina Outline", "Londrina Shadow", "Londrina Sketch", "Londrina Solid", "Lora", "Love Ya Like A Sister", "Loved by the King", "Lovers Quarrel", "Luckiest Guy", "Lusitana", "Lustria", "Macondo", "Macondo Swash Caps", "Magra", "Maiden Orange", "Mako", "Mallanna", "Mandali", "Marcellus", "Marcellus SC", "Marck Script", "Margarine", "Marko One", "Marmelad", "Martel", "Martel Sans", "Marvel", "Mate", "Mate SC", "Maven Pro", "McLaren", "Meddon", "MedievalSharp", "Medula One", "Megrim", "Meie Script", "Merienda", "Merienda One", "Merriweather", "Merriweather Sans", "Metal", "Metal Mania", "Metamorphous", "Metrophobic", "Michroma", "Milonga", "Miltonian", "Miltonian Tattoo", "Miniver", "Miss Fajardose", "Modak", "Modern Antiqua", "Molengo", "Molle", "Monda", "Monofett", "Monoton", "Monsieur La Doulaise", "Montaga", "Montez", "Montserrat", "Montserrat Alternates", "Montserrat Subrayada", "Moul", "Moulpali", "Mountains of Christmas", "Mouse Memoirs", "Mr Bedfort", "Mr Dafoe", "Mr De Haviland", "Mrs Saint Delafield", "Mrs Sheppards", "Muli", "Mystery Quest", "NTR", "Neucha", "Neuton", "New Rocker", "News Cycle", "Niconne", "Nixie One", "Nobile", "Nokora", "Norican", "Nosifer", "Nothing You Could Do", "Noticia Text", "Noto Sans", "Noto Serif", "Nova Cut", "Nova Flat", "Nova Mono", "Nova Oval", "Nova Round", "Nova Script", "Nova Slim", "Nova Square", "Numans", "Nunito", "Odor Mean Chey", "Offside", "Old Standard TT", "Oldenburg", "Oleo Script", "Oleo Script Swash Caps", "Open Sans", "Open Sans Condensed", "Oranienbaum", "Orbitron", "Oregano", "Orienta", "Original Surfer", "Oswald", "Over the Rainbow", "Overlock", "Overlock SC", "Ovo", "Oxygen", "Oxygen Mono", "PT Mono", "PT Sans", "PT Sans Caption", "PT Sans Narrow", "PT Serif", "PT Serif Caption", "Pacifico", "Palanquin", "Palanquin Dark", "Paprika", "Parisienne", "Passero One", "Passion One", "Pathway Gothic One", "Patrick Hand", "Patrick Hand SC", "Patua One", "Paytone One", "Peddana", "Peralta", "Permanent Marker", "Petit Formal Script", "Petrona", "Philosopher", "Piedra", "Pinyon Script", "Pirata One", "Plaster", "Play", "Playball", "Playfair Display", "Playfair Display SC", "Podkova", "Poiret One", "Poller One", "Poly", "Pompiere", "Pontano Sans", "Poppins", "Port Lligat Sans", "Port Lligat Slab", "Pragati Narrow", "Prata", "Preahvihear", "Press Start 2P", "Princess Sofia", "Prociono", "Prosto One", "Puritan", "Purple Purse", "Quando", "Quantico", "Quattrocento", "Quattrocento Sans", "Questrial", "Quicksand", "Quintessential", "Qwigley", "Racing Sans One", "Radley", "Rajdhani", "Raleway", "Raleway Dots", "Ramabhadra", "Ramaraja", "Rambla", "Rammetto One", "Ranchers", "Rancho", "Ranga", "Rationale", "Ravi Prakash", "Redressed", "Reenie Beanie", "Revalia", "Rhodium Libre", "Ribeye", "Ribeye Marrow", "Righteous", "Risque", "Roboto", "Roboto Condensed", "Roboto Mono", "Roboto Slab", "Rochester", "Rock Salt", "Rokkitt", "Romanesco", "Ropa Sans", "Rosario", "Rosarivo", "Rouge Script", "Rozha One", "Rubik", "Rubik Mono One", "Rubik One", "Ruda", "Rufina", "Ruge Boogie", "Ruluko", "Rum Raisin", "Ruslan Display", "Russo One", "Ruthie", "Rye", "Sacramento", "Sahitya", "Sail", "Salsa", "Sanchez", "Sancreek", "Sansita One", "Sarala", "Sarina", "Sarpanch", "Satisfy", "Scada", "Scheherazade", "Schoolbell", "Seaweed Script", "Sevillana", "Seymour One", "Shadows Into Light", "Shadows Into Light Two", "Shanti", "Share", "Share Tech", "Share Tech Mono", "Shojumaru", "Short Stack", "Siemreap", "Sigmar One", "Signika", "Signika Negative", "Simonetta", "Sintony", "Sirin Stencil", "Six Caps", "Skranji", "Slabo 13px", "Slabo 27px", "Slackey", "Smokum", "Smythe", "Sniglet", "Snippet", "Snowburst One", "Sofadi One", "Sofia", "Sonsie One", "Sorts Mill Goudy", "Source Code Pro", "Source Sans Pro", "Source Serif Pro", "Special Elite", "Spicy Rice", "Spinnaker", "Spirax", "Squada One", "Sree Krushnadevaraya", "Stalemate", "Stalinist One", "Stardos Stencil", "Stint Ultra Condensed", "Stint Ultra Expanded", "Stoke", "Strait", "Sue Ellen Francisco", "Sumana", "Sunshiney", "Supermercado One", "Sura", "Suranna", "Suravaram", "Suwannaphum", "Swanky and Moo Moo", "Syncopate", "Tangerine", "Taprom", "Tauri", "Teko", "Telex", "Tenali Ramakrishna", "Tenor Sans", "Text Me One", "The Girl Next Door", "Tienne", "Tillana", "Timmana", "Tinos", "Titan One", "Titillium Web", "Trade Winds", "Trocchi", "Trochut", "Trykker", "Tulpen One", "Ubuntu", "Ubuntu Condensed", "Ubuntu Mono", "Ultra", "Uncial Antiqua", "Underdog", "Unica One", "UnifrakturCook", "UnifrakturMaguntia", "Unkempt", "Unlock", "Unna", "VT323", "Vampiro One", "Varela", "Varela Round", "Vast Shadow", "Vesper Libre", "Vibur", "Vidaloka", "Viga", "Voces", "Volkhov", "Vollkorn", "Voltaire", "Waiting for the Sunrise", "Wallpoet", "Walter Turncoat", "Warnes", "Wellfleet", "Wendy One", "Wire One", "Work Sans", "Yanone Kaffeesatz", "Yantramanav", "Yellowtail", "Yeseva One", "Yesteryear", "Zeyada"];

}).call(this);


/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _BaseVector_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(289);
/* harmony import */ var _renderer_canvas_VectorImageLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(344);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/VectorImage
 */



/**
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @typedef {Object} Options
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {import("../render.js").OrderFunction} [renderOrder] Render order. Function to be used when sorting
 * features before rendering. By default features are drawn in the order that they are created. Use
 * `null` to avoid the sort, but get an undefined draw order.
 * @property {number} [renderBuffer=100] The buffer in pixels around the viewport extent used by the
 * renderer when getting features from the vector source for the rendering or hit-detection.
 * Recommended value: the size of the largest symbol, line width or label.
 * @property {VectorSourceType} [source] Source.
 * @property {import("../PluggableMap.js").default} [map] Sets the layer as overlay on a map. The map will not manage
 * this layer in its layers collection, and the layer will be rendered on top. This is useful for
 * temporary layers. The standard way to add a layer to a map and have it managed by the map is to
 * use {@link import("../PluggableMap.js").default#addLayer map.addLayer()}.
 * @property {boolean} [declutter=false] Declutter images and text on this layer. The priority is defined
 * by the `zIndex` of the style and the render order of features. Higher z-index means higher priority.
 * Within the same z-index, a feature rendered before another has higher priority.
 * @property {import("../style/Style.js").StyleLike} [style] Layer style. See
 * {@link import("../style/Style.js").default the style docs} for the default style that will be used if
 * this is not defined.
 * @property {number} [imageRatio=1] Ratio by which the rendered extent should be larger than the
 * viewport extent. A larger ratio avoids cut images during panning, but will cause a decrease in performance.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Vector data that is rendered client-side.
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType>}
 * @api
 */
var VectorImageLayer = /** @class */ (function (_super) {
    __extends(VectorImageLayer, _super);
    /**
     * @param {Options<VectorSourceType>} [opt_options] Options.
     */
    function VectorImageLayer(opt_options) {
        var _this = this;
        var options = opt_options ? opt_options : {};
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        delete baseOptions.imageRatio;
        _this = _super.call(this, baseOptions) || this;
        /**
         * @type {number}
         * @private
         */
        _this.imageRatio_ =
            options.imageRatio !== undefined ? options.imageRatio : 1;
        return _this;
    }
    /**
     * @return {number} Ratio between rendered extent size and viewport extent size.
     */
    VectorImageLayer.prototype.getImageRatio = function () {
        return this.imageRatio_;
    };
    /**
     * Create a renderer for this layer.
     * @return {import("../renderer/Layer.js").default} A layer renderer.
     */
    VectorImageLayer.prototype.createRenderer = function () {
        return new _renderer_canvas_VectorImageLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this);
    };
    return VectorImageLayer;
}(_BaseVector_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (VectorImageLayer);
//# sourceMappingURL=VectorImage.js.map

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _ImageLayer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(135);
/* harmony import */ var _VectorLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(290);
/* harmony import */ var _events_EventType_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53);
/* harmony import */ var _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(122);
/* harmony import */ var _ImageState_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(37);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(109);
/* harmony import */ var rbush__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(rbush__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ViewHint_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(139);
/* harmony import */ var _transform_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(101);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(15);
/* harmony import */ var _extent_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(16);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/renderer/canvas/VectorImageLayer
 */










/**
 * @classdesc
 * Canvas renderer for image layers.
 * @api
 */
var CanvasVectorImageLayerRenderer = /** @class */ (function (_super) {
    __extends(CanvasVectorImageLayerRenderer, _super);
    /**
     * @param {import("../../layer/VectorImage.js").default} layer Vector image layer.
     */
    function CanvasVectorImageLayerRenderer(layer) {
        var _this = _super.call(this, layer) || this;
        /**
         * @private
         * @type {import("./VectorLayer.js").default}
         */
        _this.vectorRenderer_ = new _VectorLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](layer);
        /**
         * @private
         * @type {number}
         */
        _this.layerImageRatio_ = layer.getImageRatio();
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        _this.coordinateToVectorPixelTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_7__["create"])();
        /**
         * @private
         * @type {import("../../transform.js").Transform}
         */
        _this.renderedPixelToCoordinateTransform_ = null;
        return _this;
    }
    /**
     * Clean up.
     */
    CanvasVectorImageLayerRenderer.prototype.disposeInternal = function () {
        this.vectorRenderer_.dispose();
        _super.prototype.disposeInternal.call(this);
    };
    /**
     * Asynchronous layer level hit detection.
     * @param {import("../../pixel.js").Pixel} pixel Pixel.
     * @return {Promise<Array<import("../../Feature").default>>} Promise that resolves with an array of features.
     */
    CanvasVectorImageLayerRenderer.prototype.getFeatures = function (pixel) {
        if (!this.vectorRenderer_) {
            return new Promise(function (resolve) { return resolve([]); });
        }
        var vectorPixel = Object(_transform_js__WEBPACK_IMPORTED_MODULE_7__["apply"])(this.coordinateToVectorPixelTransform_, Object(_transform_js__WEBPACK_IMPORTED_MODULE_7__["apply"])(this.renderedPixelToCoordinateTransform_, pixel.slice()));
        return this.vectorRenderer_.getFeatures(vectorPixel);
    };
    /**
     * Perform action necessary to get the layer rendered after new fonts have loaded
     */
    CanvasVectorImageLayerRenderer.prototype.handleFontsChanged = function () {
        this.vectorRenderer_.handleFontsChanged();
    };
    /**
     * Determine whether render should be called.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @return {boolean} Layer is ready to be rendered.
     */
    CanvasVectorImageLayerRenderer.prototype.prepareFrame = function (frameState) {
        var pixelRatio = frameState.pixelRatio;
        var viewState = frameState.viewState;
        var viewResolution = viewState.resolution;
        var hints = frameState.viewHints;
        var vectorRenderer = this.vectorRenderer_;
        var renderedExtent = frameState.extent;
        if (this.layerImageRatio_ !== 1) {
            renderedExtent = renderedExtent.slice(0);
            Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["scaleFromCenter"])(renderedExtent, this.layerImageRatio_);
        }
        var width = Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["getWidth"])(renderedExtent) / viewResolution;
        var height = Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["getHeight"])(renderedExtent) / viewResolution;
        if (!hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_6__["default"].ANIMATING] &&
            !hints[_ViewHint_js__WEBPACK_IMPORTED_MODULE_6__["default"].INTERACTING] &&
            !Object(_extent_js__WEBPACK_IMPORTED_MODULE_9__["isEmpty"])(renderedExtent)) {
            vectorRenderer.useContainer(null, null, 1);
            var context = vectorRenderer.context;
            var imageFrameState_1 = 
            /** @type {import("../../PluggableMap.js").FrameState} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, frameState, {
                declutterTree: new rbush__WEBPACK_IMPORTED_MODULE_5___default.a(9),
                extent: renderedExtent,
                size: [width, height],
                viewState: /** @type {import("../../View.js").State} */ (Object(_obj_js__WEBPACK_IMPORTED_MODULE_8__["assign"])({}, frameState.viewState, {
                    rotation: 0,
                })),
            }));
            var image_1 = new _ImageCanvas_js__WEBPACK_IMPORTED_MODULE_3__["default"](renderedExtent, viewResolution, pixelRatio, context.canvas, function (callback) {
                if (vectorRenderer.prepareFrame(imageFrameState_1) &&
                    vectorRenderer.replayGroupChanged) {
                    vectorRenderer.clipping = false;
                    vectorRenderer.renderFrame(imageFrameState_1, null);
                    vectorRenderer.renderDeclutter(imageFrameState_1);
                    callback();
                }
            });
            image_1.addEventListener(_events_EventType_js__WEBPACK_IMPORTED_MODULE_2__["default"].CHANGE, function () {
                if (image_1.getState() === _ImageState_js__WEBPACK_IMPORTED_MODULE_4__["default"].LOADED) {
                    this.image_ = image_1;
                    var imageResolution = image_1.getResolution();
                    var imagePixelRatio = image_1.getPixelRatio();
                    var renderedResolution = (imageResolution * pixelRatio) / imagePixelRatio;
                    this.renderedResolution = renderedResolution;
                    this.coordinateToVectorPixelTransform_ = Object(_transform_js__WEBPACK_IMPORTED_MODULE_7__["compose"])(this.coordinateToVectorPixelTransform_, width / 2, height / 2, 1 / renderedResolution, -1 / renderedResolution, 0, -viewState.center[0], -viewState.center[1]);
                }
            }.bind(this));
            image_1.load();
        }
        if (this.image_) {
            this.renderedPixelToCoordinateTransform_ =
                frameState.pixelToCoordinateTransform.slice();
        }
        return !!this.image_;
    };
    /**
     */
    CanvasVectorImageLayerRenderer.prototype.preRender = function () { };
    /**
     */
    CanvasVectorImageLayerRenderer.prototype.postRender = function () { };
    /**
     */
    CanvasVectorImageLayerRenderer.prototype.renderDeclutter = function () { };
    /**
     * @param {import("../../coordinate.js").Coordinate} coordinate Coordinate.
     * @param {import("../../PluggableMap.js").FrameState} frameState Frame state.
     * @param {number} hitTolerance Hit tolerance in pixels.
     * @param {import("../vector.js").FeatureCallback<T>} callback Feature callback.
     * @param {Array<import("../Map.js").HitMatch<T>>} matches The hit detected matches with tolerance.
     * @return {T|undefined} Callback result.
     * @template T
     */
    CanvasVectorImageLayerRenderer.prototype.forEachFeatureAtCoordinate = function (coordinate, frameState, hitTolerance, callback, matches) {
        if (this.vectorRenderer_) {
            return this.vectorRenderer_.forEachFeatureAtCoordinate(coordinate, frameState, hitTolerance, callback, matches);
        }
        else {
            return _super.prototype.forEachFeatureAtCoordinate.call(this, coordinate, frameState, hitTolerance, callback, matches);
        }
    };
    return CanvasVectorImageLayerRenderer;
}(_ImageLayer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (CanvasVectorImageLayerRenderer);
//# sourceMappingURL=VectorImageLayer.js.map

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _Layer_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(131);
/* harmony import */ var _renderer_webgl_PointsLayer_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(320);
/* harmony import */ var _obj_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15);
/* harmony import */ var _webgl_ShaderBuilder_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @module ol/layer/WebGLPoints
 */




/**
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @typedef {Object} Options
 * @property {import('../style/literal.js').LiteralStyle} style Literal style to apply to the layer features.
 * @property {string} [className='ol-layer'] A CSS class name to set to the layer element.
 * @property {number} [opacity=1] Opacity (0, 1).
 * @property {boolean} [visible=true] Visibility.
 * @property {import("../extent.js").Extent} [extent] The bounding extent for layer rendering.  The layer will not be
 * rendered outside of this extent.
 * @property {number} [zIndex] The z-index for layer rendering.  At rendering time, the layers
 * will be ordered, first by Z-index and then by position. When `undefined`, a `zIndex` of 0 is assumed
 * for layers that are added to the map's `layers` collection, or `Infinity` when the layer's `setMap()`
 * method was used.
 * @property {number} [minResolution] The minimum resolution (inclusive) at which this layer will be
 * visible.
 * @property {number} [maxResolution] The maximum resolution (exclusive) below which this layer will
 * be visible.
 * @property {number} [minZoom] The minimum view zoom level (exclusive) above which this layer will be
 * visible.
 * @property {number} [maxZoom] The maximum view zoom level (inclusive) at which this layer will
 * be visible.
 * @property {VectorSourceType} [source] Source.
 * @property {boolean} [disableHitDetection=false] Setting this to true will provide a slight performance boost, but will
 * prevent all hit detection on the layer.
 * @property {Object<string, *>} [properties] Arbitrary observable properties. Can be accessed with `#get()` and `#set()`.
 */
/**
 * @classdesc
 * Layer optimized for rendering large point datasets. Takes a `style` property which
 * is a serializable JSON object describing how the layer should be rendered.
 *
 * Here are a few samples of literal style objects:
 * ```js
 * const style = {
 *   symbol: {
 *     symbolType: 'circle',
 *     size: 8,
 *     color: '#33AAFF',
 *     opacity: 0.9
 *   }
 * }
 * ```
 *
 * ```js
 * const style = {
 *   symbol: {
 *     symbolType: 'image',
 *     offset: [0, 12],
 *     size: [4, 8],
 *     src: '../static/exclamation-mark.png'
 *   }
 * }
 * ```
 *
 * **Important: a `WebGLPoints` layer must be manually disposed when removed, otherwise the underlying WebGL context
 * will not be garbage collected.**
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {Layer<VectorSourceType>}
 * @fires import("../render/Event.js").RenderEvent
 */
var WebGLPointsLayer = /** @class */ (function (_super) {
    __extends(WebGLPointsLayer, _super);
    /**
     * @param {Options<VectorSourceType>} options Options.
     */
    function WebGLPointsLayer(options) {
        var _this = this;
        var baseOptions = Object(_obj_js__WEBPACK_IMPORTED_MODULE_2__["assign"])({}, options);
        _this = _super.call(this, baseOptions) || this;
        /**
         * @private
         * @type {import('../webgl/ShaderBuilder.js').StyleParseResult}
         */
        _this.parseResult_ = Object(_webgl_ShaderBuilder_js__WEBPACK_IMPORTED_MODULE_3__["parseLiteralStyle"])(options.style);
        /**
         * @private
         * @type {boolean}
         */
        _this.hitDetectionDisabled_ = !!options.disableHitDetection;
        return _this;
    }
    /**
     * Create a renderer for this layer.
     * @return {WebGLPointsLayerRenderer} A layer renderer.
     */
    WebGLPointsLayer.prototype.createRenderer = function () {
        return new _renderer_webgl_PointsLayer_js__WEBPACK_IMPORTED_MODULE_1__["default"](this, {
            className: this.getClassName(),
            vertexShader: this.parseResult_.builder.getSymbolVertexShader(),
            fragmentShader: this.parseResult_.builder.getSymbolFragmentShader(),
            hitVertexShader: !this.hitDetectionDisabled_ &&
                this.parseResult_.builder.getSymbolVertexShader(true),
            hitFragmentShader: !this.hitDetectionDisabled_ &&
                this.parseResult_.builder.getSymbolFragmentShader(true),
            uniforms: this.parseResult_.uniforms,
            attributes: this.parseResult_.attributes,
        });
    };
    /**
     * Clean up.
     */
    WebGLPointsLayer.prototype.disposeInternal = function () {
        this.getRenderer().disposeInternal();
        _super.prototype.disposeInternal.call(this);
    };
    return WebGLPointsLayer;
}(_Layer_js__WEBPACK_IMPORTED_MODULE_0__["default"]));
/* harmony default export */ __webpack_exports__["default"] = (WebGLPointsLayer);
//# sourceMappingURL=WebGLPoints.js.map

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ShaderBuilder", function() { return ShaderBuilder; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseLiteralStyle", function() { return parseLiteralStyle; });
/* harmony import */ var _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(347);
/**
 * Classes and utilities for generating shaders from literal style objects
 * @module ol/webgl/ShaderBuilder
 */

/**
 * @typedef {Object} VaryingDescription
 * @property {string} name Varying name, as will be declared in the header.
 * @property {string} type Varying type, either `float`, `vec2`, `vec4`...
 * @property {string} expression Expression which will be assigned to the varying in the vertex shader, and
 * passed on to the fragment shader.
 */
/**
 * @classdesc
 * This class implements a classic builder pattern for generating many different types of shaders.
 * Methods can be chained, e. g.:
 *
 * ```js
 * const shader = new ShaderBuilder()
 *   .addVarying('v_width', 'float', 'a_width')
 *   .addUniform('u_time')
 *   .setColorExpression('...')
 *   .setSizeExpression('...')
 *   .outputSymbolFragmentShader();
 * ```
 */
var ShaderBuilder = /** @class */ (function () {
    function ShaderBuilder() {
        /**
         * Uniforms; these will be declared in the header (should include the type).
         * @type {Array<string>}
         * @private
         */
        this.uniforms = [];
        /**
         * Attributes; these will be declared in the header (should include the type).
         * @type {Array<string>}
         * @private
         */
        this.attributes = [];
        /**
         * Varyings with a name, a type and an expression.
         * @type {Array<VaryingDescription>}
         * @private
         */
        this.varyings = [];
        /**
         * @type {string}
         * @private
         */
        this.sizeExpression = 'vec2(1.0)';
        /**
         * @type {string}
         * @private
         */
        this.rotationExpression = '0.0';
        /**
         * @type {string}
         * @private
         */
        this.offsetExpression = 'vec2(0.0)';
        /**
         * @type {string}
         * @private
         */
        this.colorExpression = 'vec4(1.0)';
        /**
         * @type {string}
         * @private
         */
        this.texCoordExpression = 'vec4(0.0, 0.0, 1.0, 1.0)';
        /**
         * @type {string}
         * @private
         */
        this.discardExpression = 'false';
        /**
         * @type {boolean}
         * @private
         */
        this.rotateWithView = false;
    }
    /**
     * Adds a uniform accessible in both fragment and vertex shaders.
     * The given name should include a type, such as `sampler2D u_texture`.
     * @param {string} name Uniform name
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.addUniform = function (name) {
        this.uniforms.push(name);
        return this;
    };
    /**
     * Adds an attribute accessible in the vertex shader, read from the geometry buffer.
     * The given name should include a type, such as `vec2 a_position`.
     * @param {string} name Attribute name
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.addAttribute = function (name) {
        this.attributes.push(name);
        return this;
    };
    /**
     * Adds a varying defined in the vertex shader and accessible from the fragment shader.
     * The type and expression of the varying have to be specified separately.
     * @param {string} name Varying name
     * @param {'float'|'vec2'|'vec3'|'vec4'} type Type
     * @param {string} expression Expression used to assign a value to the varying.
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.addVarying = function (name, type, expression) {
        this.varyings.push({
            name: name,
            type: type,
            expression: expression,
        });
        return this;
    };
    /**
     * Sets an expression to compute the size of the shape.
     * This expression can use all the uniforms and attributes available
     * in the vertex shader, and should evaluate to a `vec2` value.
     * @param {string} expression Size expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setSizeExpression = function (expression) {
        this.sizeExpression = expression;
        return this;
    };
    /**
     * Sets an expression to compute the rotation of the shape.
     * This expression can use all the uniforms and attributes available
     * in the vertex shader, and should evaluate to a `float` value in radians.
     * @param {string} expression Size expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setRotationExpression = function (expression) {
        this.rotationExpression = expression;
        return this;
    };
    /**
     * Sets an expression to compute the offset of the symbol from the point center.
     * This expression can use all the uniforms and attributes available
     * in the vertex shader, and should evaluate to a `vec2` value.
     * Note: will only be used for point geometry shaders.
     * @param {string} expression Offset expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setSymbolOffsetExpression = function (expression) {
        this.offsetExpression = expression;
        return this;
    };
    /**
     * Sets an expression to compute the color of the shape.
     * This expression can use all the uniforms, varyings and attributes available
     * in the fragment shader, and should evaluate to a `vec4` value.
     * @param {string} expression Color expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setColorExpression = function (expression) {
        this.colorExpression = expression;
        return this;
    };
    /**
     * Sets an expression to compute the texture coordinates of the vertices.
     * This expression can use all the uniforms and attributes available
     * in the vertex shader, and should evaluate to a `vec4` value.
     * @param {string} expression Texture coordinate expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setTextureCoordinateExpression = function (expression) {
        this.texCoordExpression = expression;
        return this;
    };
    /**
     * Sets an expression to determine whether a fragment (pixel) should be discarded,
     * i.e. not drawn at all.
     * This expression can use all the uniforms, varyings and attributes available
     * in the fragment shader, and should evaluate to a `bool` value (it will be
     * used in an `if` statement)
     * @param {string} expression Fragment discard expression
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setFragmentDiscardExpression = function (expression) {
        this.discardExpression = expression;
        return this;
    };
    /**
     * Sets whether the symbols should rotate with the view or stay aligned with the map.
     * Note: will only be used for point geometry shaders.
     * @param {boolean} rotateWithView Rotate with view
     * @return {ShaderBuilder} the builder object
     */
    ShaderBuilder.prototype.setSymbolRotateWithView = function (rotateWithView) {
        this.rotateWithView = rotateWithView;
        return this;
    };
    /**
     * @return {string} Previously set size expression
     */
    ShaderBuilder.prototype.getSizeExpression = function () {
        return this.sizeExpression;
    };
    /**
     * @return {string} Previously set symbol offset expression
     */
    ShaderBuilder.prototype.getOffsetExpression = function () {
        return this.offsetExpression;
    };
    /**
     * @return {string} Previously set color expression
     */
    ShaderBuilder.prototype.getColorExpression = function () {
        return this.colorExpression;
    };
    /**
     * @return {string} Previously set texture coordinate expression
     */
    ShaderBuilder.prototype.getTextureCoordinateExpression = function () {
        return this.texCoordExpression;
    };
    /**
     * @return {string} Previously set fragment discard expression
     */
    ShaderBuilder.prototype.getFragmentDiscardExpression = function () {
        return this.discardExpression;
    };
    /**
     * Generates a symbol vertex shader from the builder parameters,
     * intended to be used on point geometries.
     *
     * Three uniforms are hardcoded in all shaders: `u_projectionMatrix`, `u_offsetScaleMatrix`,
     * `u_offsetRotateMatrix`, `u_time`.
     *
     * The following attributes are hardcoded and expected to be present in the vertex buffers:
     * `vec2 a_position`, `float a_index` (being the index of the vertex in the quad, 0 to 3).
     *
     * The following varyings are hardcoded and gives the coordinate of the pixel both in the quad and on the texture:
     * `vec2 v_quadCoord`, `vec2 v_texCoord`
     *
     * @param {boolean} [forHitDetection] If true, the shader will be modified to include hit detection variables
     * (namely, hit color with encoded feature id).
     * @return {string} The full shader as a string.
     */
    ShaderBuilder.prototype.getSymbolVertexShader = function (forHitDetection) {
        var offsetMatrix = this.rotateWithView
            ? 'u_offsetScaleMatrix * u_offsetRotateMatrix'
            : 'u_offsetScaleMatrix';
        var attributes = this.attributes;
        var varyings = this.varyings;
        if (forHitDetection) {
            attributes = attributes.concat('vec4 a_hitColor');
            varyings = varyings.concat({
                name: 'v_hitColor',
                type: 'vec4',
                expression: 'a_hitColor',
            });
        }
        return "precision mediump float;\nuniform mat4 u_projectionMatrix;\nuniform mat4 u_offsetScaleMatrix;\nuniform mat4 u_offsetRotateMatrix;\nuniform float u_time;\nuniform float u_zoom;\nuniform float u_resolution;\n" + this.uniforms
            .map(function (uniform) {
            return 'uniform ' + uniform + ';';
        })
            .join('\n') + "\nattribute vec2 a_position;\nattribute float a_index;\n" + attributes
            .map(function (attribute) {
            return 'attribute ' + attribute + ';';
        })
            .join('\n') + "\nvarying vec2 v_texCoord;\nvarying vec2 v_quadCoord;\n" + varyings
            .map(function (varying) {
            return 'varying ' + varying.type + ' ' + varying.name + ';';
        })
            .join('\n') + "\nvoid main(void) {\n  mat4 offsetMatrix = " + offsetMatrix + ";\n  vec2 halfSize = " + this.sizeExpression + " * 0.5;\n  vec2 offset = " + this.offsetExpression + ";\n  float angle = " + this.rotationExpression + ";\n  float offsetX;\n  float offsetY;\n  if (a_index == 0.0) {\n    offsetX = (offset.x - halfSize.x) * cos(angle) + (offset.y - halfSize.y) * sin(angle);\n    offsetY = (offset.y - halfSize.y) * cos(angle) - (offset.x - halfSize.x) * sin(angle);\n  } else if (a_index == 1.0) {\n    offsetX = (offset.x + halfSize.x) * cos(angle) + (offset.y - halfSize.y) * sin(angle);\n    offsetY = (offset.y - halfSize.y) * cos(angle) - (offset.x + halfSize.x) * sin(angle);\n  } else if (a_index == 2.0) {\n    offsetX = (offset.x + halfSize.x) * cos(angle) + (offset.y + halfSize.y) * sin(angle);\n    offsetY = (offset.y + halfSize.y) * cos(angle) - (offset.x + halfSize.x) * sin(angle);\n  } else {\n    offsetX = (offset.x - halfSize.x) * cos(angle) + (offset.y + halfSize.y) * sin(angle);\n    offsetY = (offset.y + halfSize.y) * cos(angle) - (offset.x - halfSize.x) * sin(angle);\n  }\n  vec4 offsets = offsetMatrix * vec4(offsetX, offsetY, 0.0, 0.0);\n  gl_Position = u_projectionMatrix * vec4(a_position, 0.0, 1.0) + offsets;\n  vec4 texCoord = " + this.texCoordExpression + ";\n  float u = a_index == 0.0 || a_index == 3.0 ? texCoord.s : texCoord.p;\n  float v = a_index == 2.0 || a_index == 3.0 ? texCoord.t : texCoord.q;\n  v_texCoord = vec2(u, v);\n  u = a_index == 0.0 || a_index == 3.0 ? 0.0 : 1.0;\n  v = a_index == 2.0 || a_index == 3.0 ? 0.0 : 1.0;\n  v_quadCoord = vec2(u, v);\n" + varyings
            .map(function (varying) {
            return '  ' + varying.name + ' = ' + varying.expression + ';';
        })
            .join('\n') + "\n}";
    };
    /**
     * Generates a symbol fragment shader from the builder parameters,
     * intended to be used on point geometries.
     *
     * Expects the following varyings to be transmitted by the vertex shader:
     * `vec2 v_quadCoord`, `vec2 v_texCoord`
     *
     * @param {boolean} [forHitDetection] If true, the shader will be modified to include hit detection variables
     * (namely, hit color with encoded feature id).
     * @return {string} The full shader as a string.
     */
    ShaderBuilder.prototype.getSymbolFragmentShader = function (forHitDetection) {
        var hitDetectionBypass = forHitDetection
            ? '  if (gl_FragColor.a < 0.1) { discard; } gl_FragColor = v_hitColor;'
            : '';
        var varyings = this.varyings;
        if (forHitDetection) {
            varyings = varyings.concat({
                name: 'v_hitColor',
                type: 'vec4',
                expression: 'a_hitColor',
            });
        }
        return "precision mediump float;\nuniform float u_time;\nuniform float u_zoom;\nuniform float u_resolution;\n" + this.uniforms
            .map(function (uniform) {
            return 'uniform ' + uniform + ';';
        })
            .join('\n') + "\nvarying vec2 v_texCoord;\nvarying vec2 v_quadCoord;\n" + varyings
            .map(function (varying) {
            return 'varying ' + varying.type + ' ' + varying.name + ';';
        })
            .join('\n') + "\nvoid main(void) {\n  if (" + this.discardExpression + ") { discard; }\n  gl_FragColor = " + this.colorExpression + ";\n  gl_FragColor.rgb *= gl_FragColor.a;\n" + hitDetectionBypass + "\n}";
    };
    return ShaderBuilder;
}());

/**
 * @typedef {Object} StyleParseResult
 * @property {ShaderBuilder} builder Shader builder pre-configured according to a given style
 * @property {Object<string,import("./Helper").UniformValue>} uniforms Uniform definitions.
 * @property {Array<import("../renderer/webgl/PointsLayer").CustomAttribute>} attributes Attribute descriptions.
 */
/**
 * Parses a {@link import("../style/literal").LiteralStyle} object and returns a {@link ShaderBuilder}
 * object that has been configured according to the given style, as well as `attributes` and `uniforms`
 * arrays to be fed to the `WebGLPointsRenderer` class.
 *
 * Also returns `uniforms` and `attributes` properties as expected by the
 * {@link module:ol/renderer/webgl/PointsLayer~WebGLPointsLayerRenderer}.
 *
 * @param {import("../style/literal").LiteralStyle} style Literal style.
 * @return {StyleParseResult} Result containing shader params, attributes and uniforms.
 */
function parseLiteralStyle(style) {
    var symbStyle = style.symbol;
    var size = symbStyle.size !== undefined ? symbStyle.size : 1;
    var color = symbStyle.color || 'white';
    var texCoord = symbStyle.textureCoord || [0, 0, 1, 1];
    var offset = symbStyle.offset || [0, 0];
    var opacity = symbStyle.opacity !== undefined ? symbStyle.opacity : 1;
    var rotation = symbStyle.rotation !== undefined ? symbStyle.rotation : 0;
    /**
     * @type {import("../style/expressions.js").ParsingContext}
     */
    var vertContext = {
        inFragmentShader: false,
        variables: [],
        attributes: [],
        stringLiteralsMap: {},
    };
    var parsedSize = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(vertContext, size, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER_ARRAY | _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER);
    var parsedOffset = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(vertContext, offset, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER_ARRAY);
    var parsedTexCoord = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(vertContext, texCoord, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER_ARRAY);
    var parsedRotation = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(vertContext, rotation, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER);
    /**
     * @type {import("../style/expressions.js").ParsingContext}
     */
    var fragContext = {
        inFragmentShader: true,
        variables: vertContext.variables,
        attributes: [],
        stringLiteralsMap: vertContext.stringLiteralsMap,
    };
    var parsedColor = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(fragContext, color, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].COLOR);
    var parsedOpacity = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(fragContext, opacity, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER);
    var opacityFilter = '1.0';
    var visibleSize = "vec2(" + Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(fragContext, size, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER_ARRAY | _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].NUMBER) + ").x";
    switch (symbStyle.symbolType) {
        case 'square':
            break;
        case 'image':
            break;
        // taken from https://thebookofshaders.com/07/
        case 'circle':
            opacityFilter = "(1.0-smoothstep(1.-4./" + visibleSize + ",1.,dot(v_quadCoord-.5,v_quadCoord-.5)*4.))";
            break;
        case 'triangle':
            var st = '(v_quadCoord*2.-1.)';
            var a = "(atan(" + st + ".x," + st + ".y))";
            opacityFilter = "(1.0-smoothstep(.5-3./" + visibleSize + ",.5,cos(floor(.5+" + a + "/2.094395102)*2.094395102-" + a + ")*length(" + st + ")))";
            break;
        default:
            throw new Error('Unexpected symbol type: ' + symbStyle.symbolType);
    }
    var builder = new ShaderBuilder()
        .setSizeExpression("vec2(" + parsedSize + ")")
        .setRotationExpression(parsedRotation)
        .setSymbolOffsetExpression(parsedOffset)
        .setTextureCoordinateExpression(parsedTexCoord)
        .setSymbolRotateWithView(!!symbStyle.rotateWithView)
        .setColorExpression("vec4(" + parsedColor + ".rgb, " + parsedColor + ".a * " + parsedOpacity + " * " + opacityFilter + ")");
    if (style.filter) {
        var parsedFilter = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["expressionToGlsl"])(fragContext, style.filter, _style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["ValueTypes"].BOOLEAN);
        builder.setFragmentDiscardExpression("!" + parsedFilter);
    }
    /** @type {Object<string,import("../webgl/Helper").UniformValue>} */
    var uniforms = {};
    // define one uniform per variable
    fragContext.variables.forEach(function (varName) {
        var uniformName = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["uniformNameForVariable"])(varName);
        builder.addUniform("float " + uniformName);
        uniforms[uniformName] = function () {
            if (!style.variables || style.variables[varName] === undefined) {
                throw new Error("The following variable is missing from the style: " + varName);
            }
            var value = style.variables[varName];
            if (typeof value === 'string') {
                value = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["getStringNumberEquivalent"])(vertContext, value);
            }
            return value !== undefined ? value : -9999999; // to avoid matching with the first string literal
        };
    });
    if (symbStyle.symbolType === 'image' && symbStyle.src) {
        var texture = new Image();
        texture.src = symbStyle.src;
        builder
            .addUniform('sampler2D u_texture')
            .setColorExpression(builder.getColorExpression() + ' * texture2D(u_texture, v_texCoord)');
        uniforms['u_texture'] = texture;
    }
    // for each feature attribute used in the fragment shader, define a varying that will be used to pass data
    // from the vertex to the fragment shader, as well as an attribute in the vertex shader (if not already present)
    fragContext.attributes.forEach(function (attrName) {
        if (vertContext.attributes.indexOf(attrName) === -1) {
            vertContext.attributes.push(attrName);
        }
        builder.addVarying("v_" + attrName, 'float', "a_" + attrName);
    });
    // for each feature attribute used in the vertex shader, define an attribute in the vertex shader.
    vertContext.attributes.forEach(function (attrName) {
        builder.addAttribute("float a_" + attrName);
    });
    return {
        builder: builder,
        attributes: vertContext.attributes.map(function (attributeName) {
            return {
                name: attributeName,
                callback: function (feature, props) {
                    var value = props[attributeName];
                    if (typeof value === 'string') {
                        value = Object(_style_expressions_js__WEBPACK_IMPORTED_MODULE_0__["getStringNumberEquivalent"])(vertContext, value);
                    }
                    return value !== undefined ? value : -9999999; // to avoid matching with the first string literal
                },
            };
        }),
        uniforms: uniforms,
    };
}
//# sourceMappingURL=ShaderBuilder.js.map

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValueTypes", function() { return ValueTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Operators", function() { return Operators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getValueType", function() { return getValueType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTypeUnique", function() { return isTypeUnique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberToGlsl", function() { return numberToGlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayToGlsl", function() { return arrayToGlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorToGlsl", function() { return colorToGlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getStringNumberEquivalent", function() { return getStringNumberEquivalent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stringToGlsl", function() { return stringToGlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "expressionToGlsl", function() { return expressionToGlsl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uniformNameForVariable", function() { return uniformNameForVariable; });
/* harmony import */ var _color_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40);
/**
 * Operators and utilities used for style expressions
 * @module ol/style/expressions
 */

/**
 * Base type used for literal style parameters; can be a number literal or the output of an operator,
 * which in turns takes {@link ExpressionValue} arguments.
 *
 * The following operators can be used:
 *
 * * Reading operators:
 *   * `['get', 'attributeName']` fetches a feature attribute (it will be prefixed by `a_` in the shader)
 *     Note: those will be taken from the attributes provided to the renderer
 *   * `['var', 'varName']` fetches a value from the style variables, or 0 if undefined
 *   * `['time']` returns the time in seconds since the creation of the layer
 *   * `['zoom']` returns the current zoom level
 *   * `['resolution']` returns the current resolution
 *
 * * Math operators:
 *   * `['*', value1, value2]` multiplies `value1` by `value2`
 *   * `['/', value1, value2]` divides `value1` by `value2`
 *   * `['+', value1, value2]` adds `value1` and `value2`
 *   * `['-', value1, value2]` subtracts `value2` from `value1`
 *   * `['clamp', value, low, high]` clamps `value` between `low` and `high`
 *   * `['%', value1, value2]` returns the result of `value1 % value2` (modulo)
 *   * `['^', value1, value2]` returns the value of `value1` raised to the `value2` power
 *
 * * Transform operators:
 *   * `['case', condition1, output1, ...conditionN, outputN, fallback]` selects the first output whose corresponding
 *     condition evaluates to `true`. If no match is found, returns the `fallback` value.
 *     All conditions should be `boolean`, output and fallback can be any kind.
 *   * `['match', input, match1, output1, ...matchN, outputN, fallback]` compares the `input` value against all
 *     provided `matchX` values, returning the output associated with the first valid match. If no match is found,
 *     returns the `fallback` value.
 *     `input` and `matchX` values must all be of the same type, and can be `number` or `string`. `outputX` and
 *     `fallback` values must be of the same type, and can be of any kind.
 *   * `['interpolate', interpolation, input, stop1, output1, ...stopN, outputN]` returns a value by interpolating between
 *     pairs of inputs and outputs; `interpolation` can either be `['linear']` or `['exponential', base]` where `base` is
 *     the rate of increase from stop A to stop B (i.e. power to which the interpolation ratio is raised); a value
 *     of 1 is equivalent to `['linear']`.
 *     `input` and `stopX` values must all be of type `number`. `outputX` values can be `number` or `color` values.
 *     Note: `input` will be clamped between `stop1` and `stopN`, meaning that all output values will be comprised
 *     between `output1` and `outputN`.
 *
 * * Logical operators:
 *   * `['<', value1, value2]` returns `true` if `value1` is strictly lower than `value2`, or `false` otherwise.
 *   * `['<=', value1, value2]` returns `true` if `value1` is lower than or equals `value2`, or `false` otherwise.
 *   * `['>', value1, value2]` returns `true` if `value1` is strictly greater than `value2`, or `false` otherwise.
 *   * `['>=', value1, value2]` returns `true` if `value1` is greater than or equals `value2`, or `false` otherwise.
 *   * `['==', value1, value2]` returns `true` if `value1` equals `value2`, or `false` otherwise.
 *   * `['!=', value1, value2]` returns `true` if `value1` does not equal `value2`, or `false` otherwise.
 *   * `['!', value1]` returns `false` if `value1` is `true` or greater than `0`, or `true` otherwise.
 *   * `['all', value1, value2, ...]` returns `true` if all the inputs are `true`, `false` otherwise.
 *   * `['any', value1, value2, ...]` returns `true` if any of the inputs are `true`, `false` otherwise.
 *   * `['between', value1, value2, value3]` returns `true` if `value1` is contained between `value2` and `value3`
 *     (inclusively), or `false` otherwise.
 *
 * * Conversion operators:
 *   * `['array', value1, ...valueN]` creates a numerical array from `number` values; please note that the amount of
 *     values can currently only be 2, 3 or 4.
 *   * `['color', red, green, blue, alpha]` creates a `color` value from `number` values; the `alpha` parameter is
 *     optional; if not specified, it will be set to 1.
 *     Note: `red`, `green` and `blue` components must be values between 0 and 255; `alpha` between 0 and 1.
 *
 * Values can either be literals or another operator, as they will be evaluated recursively.
 * Literal values can be of the following types:
 * * `boolean`
 * * `number`
 * * `string`
 * * {@link module:ol/color~Color}
 *
 * @typedef {Array<*>|import("../color.js").Color|string|number|boolean} ExpressionValue
 */
/**
 * Possible inferred types from a given value or expression.
 * Note: these are binary flags.
 * @enum {number}
 */
var ValueTypes = {
    NUMBER: 1,
    STRING: 2,
    COLOR: 4,
    BOOLEAN: 8,
    NUMBER_ARRAY: 16,
    ANY: 31,
    NONE: 0,
};
/**
 * An operator declaration must contain two methods: `getReturnType` which returns a type based on
 * the operator arguments, and `toGlsl` which returns a GLSL-compatible string.
 * Note: both methods can process arguments recursively.
 * @typedef {Object} Operator
 * @property {function(Array<ExpressionValue>): ValueTypes|number} getReturnType Returns one or several types
 * @property {function(ParsingContext, Array<ExpressionValue>, ValueTypes=): string} toGlsl Returns a GLSL-compatible string
 * Note: takes in an optional type hint as 3rd parameter
 */
/**
 * Operator declarations
 * @type {Object<string, Operator>}
 */
var Operators = {};
/**
 * Returns the possible types for a given value (each type being a binary flag)
 * To test a value use e.g. `getValueType(v) & ValueTypes.BOOLEAN`
 * @param {ExpressionValue} value Value
 * @return {ValueTypes|number} Type or types inferred from the value
 */
function getValueType(value) {
    if (typeof value === 'number') {
        return ValueTypes.NUMBER;
    }
    if (typeof value === 'boolean') {
        return ValueTypes.BOOLEAN;
    }
    if (typeof value === 'string') {
        if (Object(_color_js__WEBPACK_IMPORTED_MODULE_0__["isStringColor"])(value)) {
            return ValueTypes.COLOR | ValueTypes.STRING;
        }
        return ValueTypes.STRING;
    }
    if (!Array.isArray(value)) {
        throw new Error("Unhandled value type: " + JSON.stringify(value));
    }
    var valueArr = /** @type {Array<*>} */ (value);
    var onlyNumbers = valueArr.every(function (v) {
        return typeof v === 'number';
    });
    if (onlyNumbers) {
        if (valueArr.length === 3 || valueArr.length === 4) {
            return ValueTypes.COLOR | ValueTypes.NUMBER_ARRAY;
        }
        return ValueTypes.NUMBER_ARRAY;
    }
    if (typeof valueArr[0] !== 'string') {
        throw new Error("Expected an expression operator but received: " + JSON.stringify(valueArr));
    }
    var operator = Operators[valueArr[0]];
    if (operator === undefined) {
        throw new Error("Unrecognized expression operator: " + JSON.stringify(valueArr));
    }
    return operator.getReturnType(valueArr.slice(1));
}
/**
 * Checks if only one value type is enabled in the input number.
 * @param {ValueTypes|number} valueType Number containing value type binary flags
 * @return {boolean} True if only one type flag is enabled, false if zero or multiple
 */
function isTypeUnique(valueType) {
    return Math.log2(valueType) % 1 === 0;
}
/**
 * Context available during the parsing of an expression.
 * @typedef {Object} ParsingContext
 * @property {boolean} [inFragmentShader] If false, means the expression output should be made for a vertex shader
 * @property {Array<string>} variables List of variables used in the expression; contains **unprefixed names**
 * @property {Array<string>} attributes List of attributes used in the expression; contains **unprefixed names**
 * @property {Object<string, number>} stringLiteralsMap This object maps all encountered string values to a number
 */
/**
 * Will return the number as a float with a dot separator, which is required by GLSL.
 * @param {number} v Numerical value.
 * @return {string} The value as string.
 */
function numberToGlsl(v) {
    var s = v.toString();
    return s.indexOf('.') === -1 ? s + '.0' : s;
}
/**
 * Will return the number array as a float with a dot separator, concatenated with ', '.
 * @param {Array<number>} array Numerical values array.
 * @return {string} The array as a vector, e. g.: `vec3(1.0, 2.0, 3.0)`.
 */
function arrayToGlsl(array) {
    if (array.length < 2 || array.length > 4) {
        throw new Error('`formatArray` can only output `vec2`, `vec3` or `vec4` arrays.');
    }
    return "vec" + array.length + "(" + array.map(numberToGlsl).join(', ') + ")";
}
/**
 * Will normalize and converts to string a `vec4` color array compatible with GLSL.
 * @param {string|import("../color.js").Color} color Color either in string format or [r, g, b, a] array format,
 * with RGB components in the 0..255 range and the alpha component in the 0..1 range.
 * Note that the final array will always have 4 components.
 * @return {string} The color expressed in the `vec4(1.0, 1.0, 1.0, 1.0)` form.
 */
function colorToGlsl(color) {
    var array = Object(_color_js__WEBPACK_IMPORTED_MODULE_0__["asArray"])(color).slice();
    if (array.length < 4) {
        array.push(1);
    }
    return arrayToGlsl(array.map(function (c, i) {
        return i < 3 ? c / 255 : c;
    }));
}
/**
 * Returns a stable equivalent number for the string literal.
 * @param {ParsingContext} context Parsing context
 * @param {string} string String literal value
 * @return {number} Number equivalent
 */
function getStringNumberEquivalent(context, string) {
    if (context.stringLiteralsMap[string] === undefined) {
        context.stringLiteralsMap[string] = Object.keys(context.stringLiteralsMap).length;
    }
    return context.stringLiteralsMap[string];
}
/**
 * Returns a stable equivalent number for the string literal, for use in shaders. This number is then
 * converted to be a GLSL-compatible string.
 * @param {ParsingContext} context Parsing context
 * @param {string} string String literal value
 * @return {string} GLSL-compatible string containing a number
 */
function stringToGlsl(context, string) {
    return numberToGlsl(getStringNumberEquivalent(context, string));
}
/**
 * Recursively parses a style expression and outputs a GLSL-compatible string. Takes in a parsing context that
 * will be read and modified during the parsing operation.
 * @param {ParsingContext} context Parsing context
 * @param {ExpressionValue} value Value
 * @param {ValueTypes|number} [typeHint] Hint for the expected final type (can be several types combined)
 * @return {string} GLSL-compatible output
 */
function expressionToGlsl(context, value, typeHint) {
    // operator
    if (Array.isArray(value) && typeof value[0] === 'string') {
        var operator = Operators[value[0]];
        if (operator === undefined) {
            throw new Error("Unrecognized expression operator: " + JSON.stringify(value));
        }
        return operator.toGlsl(context, value.slice(1), typeHint);
    }
    var valueType = getValueType(value);
    if ((valueType & ValueTypes.NUMBER) > 0) {
        return numberToGlsl(/** @type {number} */ (value));
    }
    if ((valueType & ValueTypes.BOOLEAN) > 0) {
        return value.toString();
    }
    if ((valueType & ValueTypes.STRING) > 0 &&
        (typeHint === undefined || typeHint == ValueTypes.STRING)) {
        return stringToGlsl(context, value.toString());
    }
    if ((valueType & ValueTypes.COLOR) > 0 &&
        (typeHint === undefined || typeHint == ValueTypes.COLOR)) {
        return colorToGlsl(/** @type {Array<number> | string} */ (value));
    }
    if ((valueType & ValueTypes.NUMBER_ARRAY) > 0) {
        return arrayToGlsl(/** @type {Array<number>} */ (value));
    }
    throw new Error("Unexpected expression " + value + " (expected type " + typeHint + ")");
}
function assertNumber(value) {
    if (!(getValueType(value) & ValueTypes.NUMBER)) {
        throw new Error("A numeric value was expected, got " + JSON.stringify(value) + " instead");
    }
}
function assertNumbers(values) {
    for (var i = 0; i < values.length; i++) {
        assertNumber(values[i]);
    }
}
function assertString(value) {
    if (!(getValueType(value) & ValueTypes.STRING)) {
        throw new Error("A string value was expected, got " + JSON.stringify(value) + " instead");
    }
}
function assertBoolean(value) {
    if (!(getValueType(value) & ValueTypes.BOOLEAN)) {
        throw new Error("A boolean value was expected, got " + JSON.stringify(value) + " instead");
    }
}
function assertArgsCount(args, count) {
    if (args.length !== count) {
        throw new Error("Exactly " + count + " arguments were expected, got " + args.length + " instead");
    }
}
function assertArgsMinCount(args, count) {
    if (args.length < count) {
        throw new Error("At least " + count + " arguments were expected, got " + args.length + " instead");
    }
}
function assertArgsMaxCount(args, count) {
    if (args.length > count) {
        throw new Error("At most " + count + " arguments were expected, got " + args.length + " instead");
    }
}
function assertArgsEven(args) {
    if (args.length % 2 !== 0) {
        throw new Error("An even amount of arguments was expected, got " + args + " instead");
    }
}
function assertArgsOdd(args) {
    if (args.length % 2 === 0) {
        throw new Error("An odd amount of arguments was expected, got " + args + " instead");
    }
}
function assertUniqueInferredType(args, types) {
    if (!isTypeUnique(types)) {
        throw new Error("Could not infer only one type from the following expression: " + JSON.stringify(args));
    }
}
Operators['get'] = {
    getReturnType: function (args) {
        return ValueTypes.ANY;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 1);
        assertString(args[0]);
        var value = args[0].toString();
        if (context.attributes.indexOf(value) === -1) {
            context.attributes.push(value);
        }
        var prefix = context.inFragmentShader ? 'v_' : 'a_';
        return prefix + value;
    },
};
/**
 * Get the uniform name given a variable name.
 * @param {string} variableName The variable name.
 * @return {string} The uniform name.
 */
function uniformNameForVariable(variableName) {
    return 'u_var_' + variableName;
}
Operators['var'] = {
    getReturnType: function (args) {
        return ValueTypes.ANY;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 1);
        assertString(args[0]);
        var value = args[0].toString();
        if (context.variables.indexOf(value) === -1) {
            context.variables.push(value);
        }
        return uniformNameForVariable(value);
    },
};
Operators['time'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 0);
        return 'u_time';
    },
};
Operators['zoom'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 0);
        return 'u_zoom';
    },
};
Operators['resolution'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 0);
        return 'u_resolution';
    },
};
Operators['*'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " * " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['/'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " / " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['+'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " + " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['-'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " - " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['clamp'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 3);
        assertNumbers(args);
        var min = expressionToGlsl(context, args[1]);
        var max = expressionToGlsl(context, args[2]);
        return "clamp(" + expressionToGlsl(context, args[0]) + ", " + min + ", " + max + ")";
    },
};
Operators['%'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "mod(" + expressionToGlsl(context, args[0]) + ", " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['^'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "pow(" + expressionToGlsl(context, args[0]) + ", " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['>'] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " > " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['>='] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " >= " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['<'] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " < " + expressionToGlsl(context, args[1]) + ")";
    },
};
Operators['<='] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 2);
        assertNumbers(args);
        return "(" + expressionToGlsl(context, args[0]) + " <= " + expressionToGlsl(context, args[1]) + ")";
    },
};
function getEqualOperator(operator) {
    return {
        getReturnType: function (args) {
            return ValueTypes.BOOLEAN;
        },
        toGlsl: function (context, args) {
            assertArgsCount(args, 2);
            // find common type
            var type = ValueTypes.ANY;
            for (var i = 0; i < args.length; i++) {
                type = type & getValueType(args[i]);
            }
            if (type === 0) {
                throw new Error("All arguments should be of compatible type, got " + JSON.stringify(args) + " instead");
            }
            return "(" + expressionToGlsl(context, args[0], type) + " " + operator + " " + expressionToGlsl(context, args[1], type) + ")";
        },
    };
}
Operators['=='] = getEqualOperator('==');
Operators['!='] = getEqualOperator('!=');
Operators['!'] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 1);
        assertBoolean(args[0]);
        return "(!" + expressionToGlsl(context, args[0]) + ")";
    },
};
function getDecisionOperator(operator) {
    return {
        getReturnType: function (args) {
            return ValueTypes.BOOLEAN;
        },
        toGlsl: function (context, args) {
            assertArgsMinCount(args, 2);
            for (var i = 0; i < args.length; i++) {
                assertBoolean(args[i]);
            }
            var result = '';
            result = args
                .map(function (arg) { return expressionToGlsl(context, arg); })
                .join(" " + operator + " ");
            result = "(" + result + ")";
            return result;
        },
    };
}
Operators['all'] = getDecisionOperator('&&');
Operators['any'] = getDecisionOperator('||');
Operators['between'] = {
    getReturnType: function (args) {
        return ValueTypes.BOOLEAN;
    },
    toGlsl: function (context, args) {
        assertArgsCount(args, 3);
        assertNumbers(args);
        var min = expressionToGlsl(context, args[1]);
        var max = expressionToGlsl(context, args[2]);
        var value = expressionToGlsl(context, args[0]);
        return "(" + value + " >= " + min + " && " + value + " <= " + max + ")";
    },
};
Operators['array'] = {
    getReturnType: function (args) {
        return ValueTypes.NUMBER_ARRAY;
    },
    toGlsl: function (context, args) {
        assertArgsMinCount(args, 2);
        assertArgsMaxCount(args, 4);
        assertNumbers(args);
        var parsedArgs = args.map(function (val) {
            return expressionToGlsl(context, val, ValueTypes.NUMBER);
        });
        return "vec" + args.length + "(" + parsedArgs.join(', ') + ")";
    },
};
Operators['color'] = {
    getReturnType: function (args) {
        return ValueTypes.COLOR;
    },
    toGlsl: function (context, args) {
        assertArgsMinCount(args, 3);
        assertArgsMaxCount(args, 4);
        assertNumbers(args);
        var array = /** @type {Array<number>} */ (args);
        if (args.length === 3) {
            array.push(1);
        }
        var parsedArgs = args.map(function (val, i) {
            return (expressionToGlsl(context, val, ValueTypes.NUMBER) +
                (i < 3 ? ' / 255.0' : ''));
        });
        return "vec" + args.length + "(" + parsedArgs.join(', ') + ")";
    },
};
Operators['interpolate'] = {
    getReturnType: function (args) {
        var type = ValueTypes.COLOR | ValueTypes.NUMBER;
        for (var i = 3; i < args.length; i += 2) {
            type = type & getValueType(args[i]);
        }
        return type;
    },
    toGlsl: function (context, args, opt_typeHint) {
        assertArgsEven(args);
        assertArgsMinCount(args, 6);
        // validate interpolation type
        var type = args[0];
        var interpolation;
        switch (type[0]) {
            case 'linear':
                interpolation = 1;
                break;
            case 'exponential':
                interpolation = type[1];
                break;
            default:
                interpolation = null;
        }
        if (!interpolation) {
            throw new Error("Invalid interpolation type for \"interpolate\" operator, received: " + JSON.stringify(type));
        }
        // compute input/output types
        var typeHint = opt_typeHint !== undefined ? opt_typeHint : ValueTypes.ANY;
        var outputType = Operators['interpolate'].getReturnType(args) & typeHint;
        assertUniqueInferredType(args, outputType);
        var input = expressionToGlsl(context, args[1]);
        var result = null;
        for (var i = 2; i < args.length - 2; i += 2) {
            var stop1 = expressionToGlsl(context, args[i]);
            var output1 = expressionToGlsl(context, args[i + 1], outputType);
            var stop2 = expressionToGlsl(context, args[i + 2]);
            var output2 = expressionToGlsl(context, args[i + 3], outputType);
            result = "mix(" + (result || output1) + ", " + output2 + ", pow(clamp((" + input + " - " + stop1 + ") / (" + stop2 + " - " + stop1 + "), 0.0, 1.0), " + numberToGlsl(interpolation) + "))";
        }
        return result;
    },
};
Operators['match'] = {
    getReturnType: function (args) {
        var type = ValueTypes.ANY;
        for (var i = 2; i < args.length; i += 2) {
            type = type & getValueType(args[i]);
        }
        type = type & getValueType(args[args.length - 1]);
        return type;
    },
    toGlsl: function (context, args, opt_typeHint) {
        assertArgsEven(args);
        assertArgsMinCount(args, 4);
        var typeHint = opt_typeHint !== undefined ? opt_typeHint : ValueTypes.ANY;
        var outputType = Operators['match'].getReturnType(args) & typeHint;
        assertUniqueInferredType(args, outputType);
        var input = expressionToGlsl(context, args[0]);
        var fallback = expressionToGlsl(context, args[args.length - 1], outputType);
        var result = null;
        for (var i = args.length - 3; i >= 1; i -= 2) {
            var match = expressionToGlsl(context, args[i]);
            var output = expressionToGlsl(context, args[i + 1], outputType);
            result = "(" + input + " == " + match + " ? " + output + " : " + (result || fallback) + ")";
        }
        return result;
    },
};
Operators['case'] = {
    getReturnType: function (args) {
        var type = ValueTypes.ANY;
        for (var i = 1; i < args.length; i += 2) {
            type = type & getValueType(args[i]);
        }
        type = type & getValueType(args[args.length - 1]);
        return type;
    },
    toGlsl: function (context, args, opt_typeHint) {
        assertArgsOdd(args);
        assertArgsMinCount(args, 3);
        var typeHint = opt_typeHint !== undefined ? opt_typeHint : ValueTypes.ANY;
        var outputType = Operators['case'].getReturnType(args) & typeHint;
        assertUniqueInferredType(args, outputType);
        for (var i = 0; i < args.length - 1; i += 2) {
            assertBoolean(args[i]);
        }
        var fallback = expressionToGlsl(context, args[args.length - 1], outputType);
        var result = null;
        for (var i = args.length - 3; i >= 0; i -= 2) {
            var condition = expressionToGlsl(context, args[i]);
            var output = expressionToGlsl(context, args[i + 1], outputType);
            result = "(" + condition + " ? " + output + " : " + (result || fallback) + ")";
        }
        return result;
    },
};
//# sourceMappingURL=expressions.js.map

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Map3DScene; });
/* harmony import */ var ol_layer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(315);
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68);
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(313);
/* harmony import */ var pcvizMap_MapViewer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(349);








const {
    PointCloudScene,
    Model3DLayerScene
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Node;
const {
    PointCloudDBPager,
    Registry
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DB;

const {
    CRSUtils,
    MathUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Utils;
const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DB.Utils;

const Group = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Node.Group.default;

/**
 * Renders a PointCloud to an image
 * @class
 * @memberof pcvizMapLayers
 * @extends MapLayer
 * @param {PointCloudScene} pointCloudScene The PointCloudScene with all point clouds
 * @param {pcvizMap.OLMapViewer} olMapViewer             The Openlayers map object
 * @param {canvas} canvas          Canvas to attach to the viewer.
 */
class Map3DScene extends pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_4__["default"] {
    constructor( olMapViewer, canvas ) {
        super();
        this._olMapViewer = olMapViewer;

        //_imageLayer isn't used
        this._olLayer = this._imageLayer = new ol_layer__WEBPACK_IMPORTED_MODULE_0__["Image"]( {
            id: 'pointcloud',
            zIndex: 10
        } );

        this._rootNode = new Group();

        var options = {
            enableFrustumCulling: true
        };

        this._model3DLayerScene = new Model3DLayerScene();
        this._rootNode.addChild( this._model3DLayerScene );

        this._pointCloudScene = new PointCloudScene();
        this._rootNode.addChild( this._pointCloudScene );

        this._dbPager = new PointCloudDBPager();

        this._viewer = new pcvizMap_MapViewer__WEBPACK_IMPORTED_MODULE_5__["default"]( canvas, options, undefined, olMapViewer );
        this._viewer.setDatabasePager( this._dbPager );
        this._viewer.getDatabasePager().setMaxRequestsPerFrame( 1 );
        this._viewer.getDatabasePager().pushOnAddedDataCallback( ( data ) => {
            // This pushes the geometry to be processed by PointVisibilityManager when we request new geometries
            Registry.getController( 'PointVisibilityManager' ).pushNodeToProcess( data ); // This data is fine, because we use the camera position in the main viewer, not this camera position
            Registry.getController( 'PointVisibilityManager' ).notifyProcessNewGeometries();
        } );
        this._viewer.setPickingEnabled( false );

        this._viewer.setSceneData( this._rootNode );
        this._viewer.setModel3DLayerScene( this._model3DLayerScene );
        this._viewer.setPointCloudScene( this._pointCloudScene );

        this._center3d = undefined;

        this._renderSize = undefined;
        this._renderExtent = undefined;

        this._rttCanvas = document.createElement( 'canvas' );
    }

    getCenter() {
        return this._center3d;
    }

    setCenter( center ) {
        this._center3d = center;
    }

    run() {
        var eyeMapCamera = MathUtils.vec3.fromValues( 0.0, 0.0, 10.0 );
        var centerMapCamera = MathUtils.vec3.fromValues( 0.0, 0.0, 0.0 );
        var upMapCamera = MathUtils.vec3.fromValues( 0.0, 1.0, 0.0 );

        this._viewer.getCamera().setViewMatrixAsLookAt( eyeMapCamera, centerMapCamera, upMapCamera );

        this._viewer.getCamera().setRenderOrder( Utils.CAMERA_PRE_RENDER, 0 );
        this._viewer.getCamera().setReferenceFrame( Utils.TRANSFORM_ABSOLUTE_RF );
        this._renderSize = this.getMapSize();
        this._viewer.getCamera().setViewport( Utils.createViewport( 0, 0, this._renderSize[ 0 ], this._renderSize[ 1 ] ) ); // Note: we need to refactor this in a future
        this._viewer.getCamera().setClearColor( MathUtils.vec4.create() );

        this._viewer.run();
    }

    render() {
        if ( ( window.navigator.userAgent.indexOf( 'MSIE' ) !== -1 ) || ( window.navigator.userAgent.indexOf( 'Trident' ) !== -1 ) ) return;
        if ( !this._olProjection ) // make sure things still work
            return;
        var olMap = this._olMapViewer.getMap();
        this._mapExtent = ol_proj__WEBPACK_IMPORTED_MODULE_2__["transformExtent"]( olMap.getView().calculateExtent( olMap.getSize() ), CRSUtils.DEFAULT_PROJECTION, this._olProjection );

        var bs = this._rootNode.getBoundingSphere();
        if ( bs.radius() !== -1 ) {
            var zoomMultip = bs.radius() / 20;
            // FIXME: Use lodScale instead of tricking the camera.
            this._viewer.getCamera().getViewMatrix()[ 14 ] = -( Math.max( bs.center()[ 2 ], bs.center()[ 2 ] + bs.radius() - ( olMap.getView().getZoom() * zoomMultip ) ) );
        }


        this._renderSize = this.getMapSize();

        var canvas = this._viewer.getCanvas();
        canvas.width = this._renderSize[ 0 ];
        canvas.height = this._renderSize[ 1 ];

        var center = this.getCenter();
        if ( center ) {
            this._renderExtent = this._mapExtent.slice( 0 );
            //With the extent of the map viewport
            this._mapExtent[ 0 ] = this._mapExtent[ 0 ] - center[ 0 ];
            this._mapExtent[ 1 ] = this._mapExtent[ 1 ] - center[ 1 ];
            this._mapExtent[ 2 ] = this._mapExtent[ 2 ] - center[ 0 ];
            this._mapExtent[ 3 ] = this._mapExtent[ 3 ] - center[ 1 ];

            var limits = 10000;
            this._viewer.getCamera().setComputeNearFar( false );

            this._viewer.getCamera().setViewport( Utils.createViewport( 0, 0, this._renderSize[ 0 ], this._renderSize[ 1 ] ) ); // Note: we need to refactor this in a future
            Utils.mat4Ortho( this._viewer.getCamera().getProjectionMatrix(), this._mapExtent[ 0 ], this._mapExtent[ 2 ], this._mapExtent[ 1 ], this._mapExtent[ 3 ], -limits, limits );

            this._viewer.getCamera().setFinalDrawCallback( this.renderCallback() );
        } else {
            this._olLayer.setSource( undefined );
        }
    }

    forceRenderToTexture() {
        const state = this._viewer.getState();
        this.updateViewerRenderToTexture( state );
    }

    renderCallback() {
        let beginTime = Utils.timerInstanceTick();
        let elapsedTime;
        const deltaRefresh = 1;
        return ( state ) => {
            elapsedTime = Utils.timerInstanceDeltaS( beginTime, Utils.timerInstanceTick() );
            if ( elapsedTime < deltaRefresh ) return;

            beginTime = Utils.timerInstanceTick();
            this.updateViewerRenderToTexture( state );
        };
    }

    updateViewerRenderToTexture( state ) {
        const ctx = this._rttCanvas.getContext( '2d' );
        let pixels = new Uint8Array( 0 );
        let rowPixelsStart = new Uint8Array( 0 );
        let gl;
        const mapSize = this._renderSize;

        if ( mapSize && mapSize[ 0 ] && mapSize[ 1 ] ) {

            const rowSize = mapSize[ 0 ] * 4;
            const buffSize = rowSize * mapSize[ 1 ];
            const halfHeight = Math.floor( mapSize[ 1 ] * 0.5 );
            if ( pixels.length !== buffSize )
                pixels = new Uint8Array( buffSize );
            if ( rowPixelsStart.length !== rowSize )
                rowPixelsStart = new Uint8Array( rowSize );

            if ( gl === undefined )
                gl = state.getGraphicContext();

            if ( gl.checkFramebufferStatus( gl.FRAMEBUFFER ) === gl.FRAMEBUFFER_COMPLETE ) {
                gl.readPixels( 0, 0, mapSize[ 0 ], mapSize[ 1 ], gl.RGBA, gl.UNSIGNED_BYTE, pixels );

                // invert image
                // slow part...
                // so use a optimized inplace image flip.
                let offsetStart = 0;
                let offsetEnd = buffSize - rowSize;
                let i, k;

                for ( i = 0; i < halfHeight; i++ ) {
                    for ( k = 0; k < rowSize; k++ ) {
                        rowPixelsStart[ k ] = pixels[ offsetStart + k ];
                        rowPixelsStart[ k + 1 ] = pixels[ offsetStart + k + 1 ];
                        rowPixelsStart[ k + 2 ] = pixels[ offsetStart + k + 2 ];
                        rowPixelsStart[ k + 3 ] = pixels[ offsetStart + k + 3 ];
                    }

                    pixels.copyWithin( offsetStart, offsetEnd, offsetEnd + rowSize );

                    pixels.set( rowPixelsStart, offsetEnd );

                    offsetStart += rowSize;
                    offsetEnd -= rowSize;
                }

                const imageData = ctx.getImageData( 0, 0, mapSize[ 0 ], mapSize[ 1 ] );
                imageData.data.set( pixels );

                this._rttCanvas.width = mapSize[ 0 ];
                this._rttCanvas.height = mapSize[ 1 ];
                ctx.putImageData( imageData, 0, 0 );

                this._olLayer.setSource( new ol_source__WEBPACK_IMPORTED_MODULE_1__["ImageStatic"]( {
                    url: this._rttCanvas.toDataURL( 'image/png' ),
                    projection: this._olProjection,
                    imageExtent: this._renderExtent
                } ) );
            }
        }
    }

    setPointCloudProperties( pointCloud ) {
        pointCloud.PointSize = 4;

        pointCloud.pointSizeAttribute.setPointSize( pointCloud.PointSize );

        pointCloud.SizePolicy = 'POINTCLOUD_LAYER_PROPERTIES.SIZE_POLICY_FIXED';

        pointCloud.pointSizeAttribute.setAutomaticSizeEnabled( false );

        pointCloud.Geometry = 'POINTCLOUD_LAYER_PROPERTIES.GEOMETRY_CIRCLE';

        pointCloud.geometryTypeAttribute.setGeometryType( pointCloud.Geometry );
    }

    getPointCloudScene() {
        return this._pointCloudScene;
    }

    getModel3DLayerScene() {
        return this._model3DLayerScene;
    }

    getRootNode() {
        return this._rootNode;
    }

    getMapSize() {
        var size = this._olMapViewer.getMap().getSize();
        size[ 0 ] = Math.floor( size[ 0 ] );
        size[ 1 ] = Math.floor( size[ 1 ] );
        return size;
    }

    destroy() {
        this._rootNode.accept( Utils.getReleaseGLObjectVisitor() );
        this._viewer.destroy();
    }
}


/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapViewer; });
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);


const MathUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils.MathUtils;
const Viewer = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Viewer.Viewer;

/**
 *  A custom Viewer for the map view which inherits from pcvizViewer.Viewer
 *  @class
 *  @memberof pcvizMap
 *  @extends {pcvizViewer.Viewer}
 */
class MapViewer extends Viewer {
    constructor( canvas, userOptions, error, olMapViewer ) {
        super( canvas, userOptions, error );

        this._olMapViewer = olMapViewer;

        this._model3DLayerScene = undefined;

        this.getCamera().setName( 'mapCamera' );
    }

    // overwritten to avoid execute unnecessary instructions
    frame() {
        this.beginFrame();

        this.advance();

        // update viewport if a resize occured
        var canvasSizeChanged = this.updateViewport();
        // update pointcloud RTT
        if ( canvasSizeChanged ) {
            this._edlNode.setViewportDimensions( this.getCamera().getViewport().width(), this.getCamera().getViewport().height() );
        }
        // update inputs devices
        this.updateEventProxy( this._eventProxy, this.getFrameStamp() );

        // update tools
        this.updateTools();

        // setup framestamp
        this._updateVisitor.setFrameStamp( this.getFrameStamp() );
        // Update Manipulator/Event
        if ( this.getManipulator() ) {
            this.getManipulator().update( this._updateVisitor );
            MathUtils.mat4.copy( this.getCamera().getViewMatrix(), this.getManipulator().getInverseMatrix() );
        }

        if ( this.checkNeedToDoFrame() || canvasSizeChanged ) {
            this._requestRedraw = false;
            this.updateTraversal();
            this.renderingTraversal();
        }

        this.endFrame();
    }

    setModel3DLayerScene( model3DLayerScene ) {
        this._model3DLayerScene = model3DLayerScene;
    }

    getModel3DLayerScene() {
        return this._model3DLayerScene;
    }
}


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapRasterLayer; });
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);
/* harmony import */ var ol_tilegrid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88);
/* harmony import */ var ol_layer_Tile__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(140);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(313);






const MagnetAPI = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Utils.MagnetAPI;
const Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DB.Registry;
const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DB.Utils;
const TimeStampCache = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.Utils.TimeStampCache;
const CollageWebFileBrowser = PointCloudViz__WEBPACK_IMPORTED_MODULE_3___default.a.DataAccess.CollageWebFileBrowser;

const RasterOLSourceFactory = {};

RasterOLSourceFactory[ 'TileWMS' ] = function ( layer ) {
    return new ol_source__WEBPACK_IMPORTED_MODULE_0__["TileWMS"]( {
        url: layer.getSource(),
        params: JSON.parse( layer.getSourceParams() )
    } );
};

RasterOLSourceFactory[ 'OSM' ] = function ( /*layer*/) {
    return new ol_source__WEBPACK_IMPORTED_MODULE_0__["OSM"]();
};

RasterOLSourceFactory[ Utils.RASTER_CW ] = function ( layer, config ) {
    return new Promise( resolve => {

        var mountController = Registry.getInstance().getController( 'Mount' );
        mountController.getMountObject( layer.getId() ).getMountObject().then( function ( mount ) {

            var tilesPath = layer.getSource().slice( 1, -1 );
            var baseImageURL;

            var basemapUrl = layer.getDriver().getServerUrl() + layer.getDriver().getEntryPoint( 'layersFiles', layer.getId() ) + '/files/' + layer.getSource();
            if ( MagnetAPI.isConnectingFromMagnet() ) {
                baseImageURL = mount.mountPoint + '/' + tilesPath;
            } else {
                baseImageURL = MagnetAPI.getAPI().storageUrl + '/layers/' + layer.getId().toString() + '/' + layer.getSource();
            }
            basemapUrl = Utils.sanitizeUrlInPlace( basemapUrl + '/basemap.xml' );

            var cwFileBrowser = new CollageWebFileBrowser();
            cwFileBrowser.setMagnetAPI( MagnetAPI );
            cwFileBrowser.retrieve( {
                'href': basemapUrl
            } ).then( function ( basemapXML ) {
                var parser = new DOMParser();
                var xmlDoc = parser.parseFromString( basemapXML, 'text/xml' );

                // getting BoundingBox
                var bounding = xmlDoc.getElementsByTagName( 'BoundingBox' )[ 0 ];
                var extent = [ parseFloat( bounding.getAttribute( 'minx' ) ), parseFloat( bounding.getAttribute( 'miny' ) ),
                    parseFloat( bounding.getAttribute( 'maxx' ) ), parseFloat( bounding.getAttribute( 'maxy' ) )
                ];
                var width = bounding.getAttribute( 'maxx' ) - bounding.getAttribute( 'minx' );
                var height = bounding.getAttribute( 'maxy' ) - bounding.getAttribute( 'miny' );

                var timeStampString = '?ts=' + TimeStampCache.getTimeStamp( baseImageURL, tilesPath );
                if ( mount.appendQuery )
                    timeStampString += '&' + mount.appendQuery;

                resolve( new ol_source__WEBPACK_IMPORTED_MODULE_0__["XYZ"]( {
                    url: Utils.sanitizeUrlInPlace( baseImageURL + '/{z}/{x}/{-y}.jpg' ) + timeStampString,
                    projection: config.projection,
                    tileGrid: ol_tilegrid__WEBPACK_IMPORTED_MODULE_1__["createXYZ"]( {
                        extent: extent,
                        tileSize: [ 512, Math.floor( 512 * ( height / width ) ) ],
                        // resolutions: [ 128, 64, 32, 16, 8, 4, 2, 1 ] // We can choose the resolutions
                    } )
                } ) );
            } );
        } );
    } );
};

RasterOLSourceFactory[ 'XYZ' ] = function ( /*layer*/) {
    // TODO: This requires to read and parse the XML of the tms and configure the XYZ source
    return new ol_source__WEBPACK_IMPORTED_MODULE_0__["XYZ"]();
};
/**
 * This class is an adapter from Collage RasterLayers to OpenLayer RasterLayers. They are rendered in the map view.
 * @class
 * @memberof pcvizMapLayers
 * @extends MapLayer
 * @param {string} layer         Name of the object type
 * @param {string} projection EPSG projection code
 * @param {object} extConfig  Additional configuration parameters
 */
class MapRasterLayer extends pcvizMapLayers_MapLayer__WEBPACK_IMPORTED_MODULE_4__["default"] {
    constructor( layer, olProjection, extConfig ) {
        super();
        this._layer = layer;

        if ( layer !== undefined ) {
            this.initializeProjection( layer );
        }
        var config = {
            zIndex: 100,
            projection: olProjection,
            name: layer.getName(),
            id: layer.getId(),
            layer: layer,
            mapRasterLayer: this
        };

        for ( var key in extConfig ) {
            config[ key ] = extConfig[ key ];
        }

        this._olLayer = this.createOLTileLayer( layer, config );
    }

    render( layerRenderer, parentNode ) {
        return new Promise( ( resolve, reject ) => {
            layerRenderer.renderRasterLayer( this._layer, parentNode ).then( () => {
                resolve();
            }, reject );
        } );
    }

    getProjection() {
        return this._olProjection.getCode();
    }

    createOLTileLayer( layer, config ) {
        if ( !( layer.getSourceType() in ol_source__WEBPACK_IMPORTED_MODULE_0__ ) && !RasterOLSourceFactory[ layer.getSourceType() ] )
            return;

        if ( layer.getSourceType() !== Utils.RASTER_CW ) {
            config[ 'source' ] = RasterOLSourceFactory[ layer.getSourceType() ]( layer );
            return new ol_layer_Tile__WEBPACK_IMPORTED_MODULE_2__["default"]( config );
        }

        var olLayer = new ol_layer_Tile__WEBPACK_IMPORTED_MODULE_2__["default"]( config );
        RasterOLSourceFactory[ layer.getSourceType() ]( layer, config ).then( function ( source ) {
            olLayer.setSource( source );
        } );

        return olLayer;
    }
}


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_interaction__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(266);
/* harmony import */ var ol_events_condition__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(272);




var Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Registry;
var Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Utils;
var ListenerController = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.ListenerController;

/**
 * This tool manages feature selection and shows their information. It responses to global selection
 * and fires a selectionObject too.
 * @class
 * @memberof pcvizMapTools
 * @param {OLMapViewer} olMapViewer The `pcvizMap.OLMapViewer` object containing Openlayers' map.
 * @property {OLMapViewer} _olMapViewer The `pcvizMap.OLMapViewer` object containing Openlayers' map.
 * @property {Feature} _selectedFeature The selected feature.
 * @property {ol.interaction.Select} _olSelect The Openlayers interaction object.
 */
var MapInformationTool = function ( olMapViewer ) {
    this._olMapViewer = olMapViewer;

    this._selectedFeature = undefined;

    this._olSelect = undefined;

    this.init();
};

MapInformationTool.prototype = {

    /**
     * Initializes the tool.
     * @method
     * @memberof pcvizMapTools.MapInformationTool
     */
    init: function () {

        var self = this;

        this._olSelect = new ol_interaction__WEBPACK_IMPORTED_MODULE_1__["Select"]( {
            style: function ( feature ) {
                return feature.get( 'layer' ).getFeatureRenderer().getSymbol().getSelectionStyle( feature );
            },
            filter: function ( feature ) {
                return feature.getKeys().length > 1;
            },
            toggleCondition: function ( mapBrowserEvent ) {
                return Object(ol_events_condition__WEBPACK_IMPORTED_MODULE_2__["never"])( mapBrowserEvent );
            }
        } );

        this._olSelect.on( 'select', this.pickLayer.bind( this ) );
        this._olMapViewer.getMap().addInteraction( this._olSelect );

        Registry.getInstance().getController( 'SelectionObject' ).registerListener( ListenerController.PROJECT, function ( selectionObject ) {
            if ( selectionObject.getFeature !== undefined && selectionObject.getFeature() !== self._selectedFeature ) {
                self._olSelect.getFeatures().clear();
                self._olMapViewer.closeOverlay();
                if ( selectionObject.getFeature() !== undefined ) {
                    var feature = self._olMapViewer.getOLFeature( selectionObject.getFeature() );
                    if ( feature !== undefined && feature !== null ) {
                        self._selectedFeature = selectionObject.getFeature();
                        self._olSelect.getFeatures().push( feature );
                    }
                }
            } else if ( selectionObject.getFeature === undefined ) {
                self._olSelect.getFeatures().clear();
                self._olMapViewer.closeOverlay();
            }
        } );


        Registry.getController( 'UserPreferences' ).registerListener( ListenerController.PROJECT, Utils.SELECTION_COLOR_KEY, function () {
            self.refresh();
        } );
    },

    /**
     * Opens the overlay to show feature information and updates the selection object.
     * @method
     * @memberof pcvizMapTools.MapInformationTool
     * @param  {Event} ev The ol.interaction.Select event fired when a feature is selected.
     */
    pickLayer: function ( ev ) {
        if ( ev.selected.length === 0 ) {
            this.clear();
            return;
        }

        var olFeature = ev.selected[ 0 ];

        var self = this;

        var layer = ev.target.getLayer( olFeature );
        layer.get( 'layer' ).getFeature( olFeature.getId() ).then( function ( feature ) {
            var selectionObject = Registry.getInstance().getController( 'SelectionObject' ).createSelectionObject( 'VectorLayer' );
            selectionObject.setLayer( layer.get( 'layer' ) );
            selectionObject.setFeature( feature );
            selectionObject.setVertex( 0 );
            self._selectedFeature = feature;

            Registry.getInstance().getController( 'SelectionObject' ).setSelectionObject( selectionObject );
        } );

        this._olMapViewer.closeOverlay();

        // FIXME: This avoids showing the overlay with features that are not annotations, because they would show 'undefined' as their name.
        if ( olFeature.getKeys().indexOf( 'name' ) === -1 && olFeature.getKeys().indexOf( 'description' ) === -1 )
            return;

        if ( this._olMapViewer.getOverlay().getElement() !== null ) {
            var element = this._olMapViewer.getOverlay().getElement().getElementsByClassName( 'popup-content' )[ 0 ];

            var htmlName = olFeature.get( 'name' ) !== undefined ? olFeature.get( 'name' ) : '';
            var htmlDescription = olFeature.get( 'description' ) !== undefined ? olFeature.get( 'description' ) : '';
            element.children[ 0 ].innerHTML = htmlName;
            element.children[ 1 ].innerHTML = htmlDescription;
        }
        var geometry = olFeature.getGeometry();
        var coordinate;
        if ( geometry.getType() === 'LineString' && geometry.getCoordinates().length > 0 ) {
            coordinate = geometry.getCoordinateAt( 0.5 );
        } else if ( geometry.getType() === 'Polygon' ) {
            coordinate = geometry.getInteriorPoint().getCoordinates();
        } else {
            coordinate = geometry.getFirstCoordinate();
        }
        this._olMapViewer.setOverlayPosition( coordinate, olFeature.get( 'layer' ).getFeatureRenderer().getSymbol().hasImageMarker() );
    },

    refresh: function () {
        var selectionObject = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
        if ( !selectionObject )
            return;
        if ( !selectionObject.getLayer() )
            return;
        if ( !selectionObject.getLayer().getFeature )
            return;

        var feature = selectionObject.getFeature();
        // Now we can't edit features in Map, so it is not necessary check that !feature.isEnabledEditMode() (We are not rendering them with the edition color)
        if ( feature !== undefined && feature.getId() !== -1 ) {
            var olFeature = this._olMapViewer.getOLFeature( feature );
            this._olSelect.getFeatures().clear();
            if ( olFeature ) // This could be null if the layer is refreshed when a feature is being deleted
                this._olSelect.getFeatures().push( olFeature );
        }
    },

    /**
     * Closes the overlay and clears the feature from the selection object.
     * @method
     * @memberof pcvizMapTools.MapInformationTool
     */
    clear: function () {
        var selectionObject = Registry.getInstance().getController( 'SelectionObject' ).getSelectionObject();
        if ( selectionObject !== undefined ) {
            selectionObject.setFeature( undefined );
            Registry.getInstance().getController( 'SelectionObject' ).setSelectionObject( selectionObject );
        }
        this._olMapViewer.closeOverlay();
    }
};

/* harmony default export */ __webpack_exports__["default"] = (MapInformationTool);


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(353);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(355);
/* harmony import */ var pcvizMapRenderer_MapPointSymbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(356);
/* harmony import */ var pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(357);
/* harmony import */ var pcvizMapRenderer_MapLineSymbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(358);
/* harmony import */ var pcvizMapRenderer_MapLineMarkerSymbol__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(359);
/* harmony import */ var pcvizMapRenderer_MapFillSymbol__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(361);
/* harmony import */ var pcvizMapRenderer_MapFillMarkerSymbol__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(362);
/* harmony import */ var pcvizMapRenderer_MapMachineryPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(363);












/** @namespace pcvizMapRenderer */
const pcvizMapRenderer = {
    LayerRenderer: pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_0__["default"],
    Symbol: pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_1__["default"],
    PointSymbol: pcvizMapRenderer_MapPointSymbol__WEBPACK_IMPORTED_MODULE_2__["default"],
    PointMarkerSymbol: pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_3__["default"],
    LineSymbol: pcvizMapRenderer_MapLineSymbol__WEBPACK_IMPORTED_MODULE_4__["default"],
    LineMarkerSymbol: pcvizMapRenderer_MapLineMarkerSymbol__WEBPACK_IMPORTED_MODULE_5__["default"],
    FillSymbol: pcvizMapRenderer_MapFillSymbol__WEBPACK_IMPORTED_MODULE_6__["default"],
    FillMarkerSymbol: pcvizMapRenderer_MapFillMarkerSymbol__WEBPACK_IMPORTED_MODULE_7__["default"],
    MachineryMarkerSymbol: pcvizMapRenderer_MapMachineryPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_8__["default"],
};

/* harmony default export */ __webpack_exports__["default"] = (pcvizMapRenderer);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapLayerRenderer; });
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_format__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(199);
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var pcvizMap_Projection__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(354);
/* harmony import */ var pcvizMapLayers_MapVectorLayer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(314);
/* harmony import */ var pcvizMapLayers_MapRasterLayer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(350);







const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Utils;
const LayerRenderer3D = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Renderer.LayerRenderer3D;
const Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Registry;
const LayerType = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.LayerType;
const VectorLayerUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.VectorLayerUtils;
const SingleSymbolRenderer = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Renderer.SingleSymbolRenderer.default;

/**
 * The layer renderer for the map.
 * @class
 * @memberof pcvizMapLayerRenderer
 */
class MapLayerRenderer extends LayerRenderer3D {
    constructor( olMap ) {
        super();

        this._olMap = olMap;

        this._center = undefined;

        // // To be changed when we parse user/project styles
        this._readOnlyStyles = [ 'pointSize', 'sizePolicy', 'geometry' ];

        this._featureRendererId = 'Map';
    }

    renderVectorLayer( layer, groupNode ) {
        var self = this;
        if ( layer.getType() === LayerType.MODEL3D || VectorLayerUtils.isModel( layer.getCategory() ) )
            return this.renderModel3DVectorLayer( layer );

        return new Promise( ( resolve, reject ) => {

            var mapLayer = this.getOrCreateMapVectorLayer( layer );

            layer.open().then( function () {
                var featureRenderer = ( mapLayer.getFeatureRenderer( this._featureRendererId ) === undefined ) ? new SingleSymbolRenderer() : mapLayer.getFeatureRenderer( this._featureRendererId );
                if ( featureRenderer.getSymbol() === undefined ) {
                    var symbol = Registry.getController( 'Symbol' ).getSymbol( 'Map', this.getSymbolType( layer ) );
                    symbol.configure( layer.getStyle() );
                    featureRenderer.setSymbol( symbol );
                }

                // propagate highlight option
                var highlightFeature = layer.getFeatureRenderer() ? layer.getFeatureRenderer().getSymbol().getHighlightFeature() : false;
                featureRenderer.getSymbol().setHighlightFeature( highlightFeature );

                featureRenderer.renderLayer( mapLayer.getOLLayer() ).then( function () {
                    self._featureRenderer = featureRenderer;

                    layer.getAllFeaturesByPages().then( function ( originalGeoJson ) {
                        const geoJsonObject = JSON.parse( JSON.stringify( originalGeoJson ) ); // we create a clone because we modify its geometry on transformation

                        self.applyTransformations( geoJsonObject, groupNode );

                        var featuresGeoJSON = ( new ol_format__WEBPACK_IMPORTED_MODULE_1__["GeoJSON"]() ).readFeatures( geoJsonObject, {
                            dataProjection: mapLayer.getProjection(),
                            featureProjection: pcvizMap_Projection__WEBPACK_IMPORTED_MODULE_3__["default"].DEFAULT
                        } );
                        featuresGeoJSON.forEach( function ( feature ) {
                            feature.set( 'layer', mapLayer );
                        } );
                        mapLayer.getOLLayer().setSource( new ol_source__WEBPACK_IMPORTED_MODULE_2__["Vector"]( {
                            features: featuresGeoJSON
                        } ) );

                        if ( !self._olMap.getOLLayer( layer ) ) {
                            self._olMap.addLayer( mapLayer.getOLLayer() );
                        }

                        resolve( mapLayer );
                    }, reject );

                    layer.setVisibilityCallback( self._featureRendererId, function ( value ) {
                        mapLayer.getOLLayer().setVisible( value );
                    } );

                    mapLayer.getOLLayer().setVisible( layer.isVisible() );

                } );
                mapLayer.setFeatureRenderer( featureRenderer, this._featureRendererId );

            }.bind( this ) );
        } );
    }

    applyTransformations( geoJsonObject, groupNode ) {
        // We need to concat every MT in groupNode tree
        var nodePath = Utils.computeNodePath( groupNode );
        nodePath = nodePath.slice( 3 ); //We don't need the center transform
        nodePath.push( groupNode );
        var modelMat = Utils.computeLocalToWorld( nodePath, true );

        geoJsonObject.features.forEach( function ( feature ) {
            if ( feature.geometry.type === 'Point' ) {
                Utils.transformVec3ByMat4( feature.geometry.coordinates, feature.geometry.coordinates, modelMat );
            } else if ( feature.geometry.type === 'Polygon' )
                feature.geometry.coordinates[ 0 ].forEach( function ( coordinate ) {
                    Utils.transformVec3ByMat4( coordinate, coordinate, modelMat );
                } );
            else
                feature.geometry.coordinates.forEach( function ( coordinate ) {
                    Utils.transformVec3ByMat4( coordinate, coordinate, modelMat );
                } );
        } );
    }

    renderPointCloudLayer( layer ) {
        return new Promise( ( resolve, reject ) => {

            var self = this;

            var map3DScene = this._olMap.getMap3DScene();
            map3DScene.initializeProjection( layer );
            map3DScene.setCenter( this._center );
            LayerRenderer3D.prototype.renderPointCloudLayer.call( this, layer ).then( function () {
                var pointCloudNode = self.getPointCloudSceneGraph( layer );
                if ( !pointCloudNode ) { // This can happen when the pointcloud layer doesn't have url because it has not been processed
                    resolve();
                    return;
                }
                map3DScene.setPointCloudProperties( pointCloudNode );

                layer.setVisibilityCallback( self._featureRendererId, function ( value ) {
                    pointCloudNode.setNodeMask( value ? 0xffffff : 0x0 );
                    map3DScene.render();
                    self._olMap.renderExtent();
                } );

                if ( !layer.isVisible() )
                    pointCloudNode.setNodeMask( 0x0 );

                map3DScene.render();

                resolve();
            } ).catch( function () {
                reject();
            } );
        } );
    }

    renderModel3DVectorLayer( layer ) {
        return new Promise( ( resolve, reject ) => {
            var map3DScene = this._olMap.getMap3DScene();
            map3DScene.initializeProjection( layer );
            map3DScene.setCenter( this._center );

            this.ensureFeatureRenderer3D( layer );
            LayerRenderer3D.prototype.renderVectorLayer.call( this, layer ).then( ( modelNode ) => {
                resolve( modelNode );
            }, reject );
        } );
    }

    renderRasterLayer( layer ) {
        return new Promise( ( resolve, reject ) => {
            var mapLayer = this.getOrCreateMapRasterLayer( layer );
            var self = this;

            layer.open().then( function () {
                if ( !self._olMap.getOLLayer( layer ) ) {
                    self._olMap.addLayer( mapLayer.getOLLayer() );
                    self._olMap.renderExtent();
                }

                resolve( mapLayer );
            }, reject );

            layer.setVisibilityCallback( self._featureRendererId, function ( value ) {
                mapLayer.getOLLayer().setVisible( value );
            } );

            mapLayer.getOLLayer().setVisible( layer.isVisible() );
        } );
    }

    ensureFeatureRenderer3D( layer ) {
        if ( layer.getFeatureRenderer( '3D' ) !== undefined ) {
            return;
        }
        let featureRenderer = new SingleSymbolRenderer();
        let symbol = Registry.getController( 'Symbol' ).getSymbol( this._featureRendererId, this.getSymbolType( layer ) );
        symbol.configure( layer.getStyle() );
        featureRenderer.setSymbol( symbol );
        layer.setFeatureRenderer( featureRenderer, '3D' );
    }

    renderControlPoints( mapControlPointsLayer ) {
        // let control
        let featureRenderer = new SingleSymbolRenderer();
        let symbol = Registry.getController( 'Symbol' ).getSymbol( 'Map', 'Point' );
        let style = {
            'PointSymbolizer': {
                color: [ 0, 200, 100, 1 ],
                sizes: 15,
                showLabels: true,
                labelField: 'name'
            }
        };
        symbol.configure( style );
        featureRenderer.setSymbol( symbol );
        mapControlPointsLayer.setFeatureRenderer( featureRenderer, this._featureRendererId );
        featureRenderer.renderLayer( mapControlPointsLayer.getOLLayer() );
        this._olMap.addLayer( mapControlPointsLayer.getOLLayer() );
        this._olMap.renderExtent();
    }

    setControlPointsVisibility( visible ) {
        let controlPointsOLLayer = this._olMap.getOLLayerById( 'ControlPoints' );
        controlPointsOLLayer.setVisible( visible );
    }

    getOrCreateMapVectorLayer( layer ) {
        var mapVectorLayer = this._olMap.getOLLayer( layer ) ? this._olMap.getOLLayer( layer ).get( 'mapVectorLayer' ) : undefined;
        if ( mapVectorLayer )
            return mapVectorLayer;
        return new pcvizMapLayers_MapVectorLayer__WEBPACK_IMPORTED_MODULE_4__["default"]( layer, this._olMap.getProjection() );
    }

    getOrCreateMapRasterLayer( layer ) {
        var mapRasterLayer = this._olMap.getOLLayer( layer ) ? this._olMap.getOLLayer( layer ).get( 'mapRasterLayer' ) : undefined;
        if ( mapRasterLayer )
            return mapRasterLayer;
        return new pcvizMapLayers_MapRasterLayer__WEBPACK_IMPORTED_MODULE_5__["default"]( layer, this._olMap.getProjection() );
    }

    updateStyle( layer, property, value ) {
        if ( this._readOnlyStyles.indexOf( property ) === -1 ) {
            this.getNodeFromLayer( layer ).updateStyle( property, value, this._featureRendererId );
            this._olMap.renderPointCloudScene();
        }
    }

    getRasterSceneGraph( /*layer*/) {
        return undefined; // nothing to render in the map from here
    }
}


/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(Proj4js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);





const CRSUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_2___default.a.Utils.CRSUtils;

/**
 * Projection utilities.
 * @memberof pcvizMap
 * @type {Object}
 */
const Projection = {};

/**
 * Retrieves projection from epsg.io
 * @memberof pcvizMap.Projection
 * @param {string} epsg EPSG code
 * @static
 */
Projection.getProjection = ( epsg ) => {
    return new Promise( ( resolve, reject ) => {

        let projNumber = epsg.substr( 5 );

        let req = new XMLHttpRequest();
        req.open( 'GET', CRSUtils.epsgServer() + '/' + projNumber + '.proj4', true );

        // handle responseType
        req.addEventListener( 'error', function () {
            reject();
        }, false );

        req.addEventListener( 'load', function ( /*oEvent */) {
            Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a.defs( epsg, req.response );
            Object(ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__["register"])( Proj4js__WEBPACK_IMPORTED_MODULE_1___default.a );
            let projection = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( epsg );
            resolve( projection );
        } );

        req.send( null );
    } );
};

/**
 * Gets the default Mercator projection
 * @memberof pcvizMap.Projection
 * @static
 */
Projection.DEFAULT = ol_proj__WEBPACK_IMPORTED_MODULE_0__["get"]( 'EPSG:3857' ); //mercator

/* harmony default export */ __webpack_exports__["default"] = (Projection);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);



var UtilsDB = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Utils;
var Registry = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Registry;

var MapSymbol = function () {
    this._showLabels = undefined;
    this._labelField = undefined;
    this._highlightFeature = false;
};

MapSymbol.prototype = {

    MAX_RESOLUTION: 30,

    getSelectionStyle: function ( feature ) {
        return this._selectionStyle( feature );
    },

    hasImageMarker: function () {
        console.log( 'MapSymbol.hasImageMarker: Not implemented' );
        return undefined;
    },

    setSelectionStrokeColor: function ( color ) {
        UtilsDB.copyVec4( color, this._selectionStrokeColor );
    },

    /**
     * Set the selection color. By default, we're using the selection color of user's preferences.
     * But, if this method is called, the selection color used will be this.
     * @method
     * @memberof pcvizMapRenderer.MapSymbol
     * @param {Array} color the color to be set as selection color
     */
    setSelectionColor: function ( color ) {
        UtilsDB.copyVec4( color, this._selectionColor );
    },

    /**
     * Returns the color to be used as selection color. If there's a selection color assigned in this Symbol returns it,
     * else returns the value stored in user's preferences.
     * @method
     * @memberof pcvizMapRenderer.MapSymbol
     * @return {Array} the color to be used in the selected feature
     */
    getSelectionColor: function () {
        return ( this._selectionColor === undefined ) ? Registry.getController( 'UserPreferences' ).getPreference( UtilsDB.SELECTION_COLOR_KEY ) : this._selectionColor;
    },

    /**
     * Returns the color to be used as selection stroke color. If there's a selection color stroke assigned in this Symbol returns it,
     * else returns the value stored in user's preferences for the selection color (because nowadays the selection color for the stroke isn't a requirement).
     * @method
     * @memberof pcvizMapRenderer.MapSymbol
     * @return {Array} the color to be used in the selected feature
     */
    getSelectionStrokeColor: function () {
        return ( this._selectionStrokeColor === undefined ) ? Registry.getController( 'UserPreferences' ).getPreference( UtilsDB.SELECTION_COLOR_KEY ) : this._selectionStrokeColor;
    },

    getAppliedColor: function ( color ) {
        var appliedColor;
        if ( this._highlightFeature ) // in highlight mode, highlighted features are drawn in normal color
            appliedColor = color ? this._color : [ 0, 0, 0, 0 ];
        else
            appliedColor = color ? UtilsDB.RgbTofullhex( color ) : this._color;

        return appliedColor;
    },

    getFill: function ( feature, color ) {

        if ( this._rules )
            this.evaluateRules( feature );

        return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Fill"]( {
            color: this.getAppliedColor( color )
        } );
    },

    getStroke: function ( feature, color ) {

        if ( this._rules )
            this.evaluateRules( feature );

        return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
            color: this.getAppliedColor( color ),
            width: this._lineWidth
        } );
    },

    getFillStroke: function ( selected ) {

        if ( this._highlightFeature )
            return selected ? UtilsDB.RGBIntToFullHex( this._strokeColor ) : [ 0, 0, 0, 0 ];

        return selected ? UtilsDB.RgbTofullhex( this.getSelectionStrokeColor() ) : UtilsDB.RGBIntToFullHex( this._strokeColor );
    },

    getPoint: function ( feature, color ) {

        if ( this._rules )
            this.evaluateRules( feature );

        return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Circle"]( {
            fill: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Fill"]( {
                color: this.getAppliedColor( color )
            } ),
            radius: this._size
        } );
    },

    getMarker: function ( url ) {
        return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Icon"]( {
            anchor: [ 0.5, 1 ],
            src: url
        } );
    },

    getMarkerStyle: function ( feature, select, addGeometry ) {

        if ( this._highlightFeature && !select )
            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {} );

        return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
            image: select ? this.getMarker( this._selectionImageURL ) : this.getMarker( this._imageURL ),
            geometry: addGeometry ? this.getMarkerGeometry( feature ) : undefined
        } );
    },

    getLabel: function ( feature, resolution, selectionColor ) {

        var appliedColor = this.getAppliedColor( selectionColor );
        return this._showLabels ? this.renderLabel( feature, resolution, appliedColor ) : undefined;
    },

    configureLabels: function ( style ) {
        if ( !style )
            return;

        var symbolizer;
        if ( style.LineSymbolizer )
            symbolizer = style.LineSymbolizer;
        else if ( style.PointSymbolizer )
            symbolizer = style.PointSymbolizer;
        else if ( style.PolygonSymbolizer )
            symbolizer = style.PolygonSymbolizer;

        if ( !symbolizer )
            return;

        if ( symbolizer.showLabels !== undefined )
            this._showLabels = symbolizer.showLabels;
        if ( symbolizer.labelField )
            this._labelField = symbolizer.labelField;
    },

    setHighlightFeature: function ( flag ) {
        this._highlightFeature = flag;
    },

    renderLayer: function ( olLayer ) {
        olLayer.setStyle( this._style );
        return Promise.resolve();
    },

    // create OL style to render feature label

    renderLabel: function ( feature, resolution, color ) {

        if ( !feature )
            return undefined;

        if ( !resolution )
            resolution = this.MAX_RESOLUTION;

        var textStyle = new ol_style__WEBPACK_IMPORTED_MODULE_1__["Text"]( {
            textAlign: 'center',
            textBaseline: 'top',
            font: 'normal 12px Arial',
            text: '',
            fill: undefined,
            stroke: undefined,
            offsetX: 0,
            offsetY: 3,
            placement: 'point',
            maxAngle: 0.7,
            overflow: undefined,
            rotation: 0
        } );

        if ( resolution > this.MAX_RESOLUTION )
            return textStyle; // no text

        if ( color && color[ 3 ] === 0 ) // do not render label when color is transparent
            return textStyle;

        if ( this._color[ 3 ] === 0 ) // idem
            return textStyle;

        var label;
        if ( this._labelField === 'Id' )
            label = feature.getId();
        else
            label = feature.getProperties()[ this._labelField ];

        if ( ( !label && label !== 0 ) || label === '' )
            return textStyle; // no text

        if ( !Number.isInteger( label ) && label.toFixed ) { // for floats, use preference for number of decimals
            var numberOfDecimals = localStorage.getItem( 'ngStorage-numberOfDecimals' );
            label = label.toFixed( numberOfDecimals );
        }

        if ( this._labelField === 'file_name' ) {
            // remove path
            label = label.substr( label.lastIndexOf( '/' ) + 1 );
            // remove image extension
            var pos = label.indexOf( '.jpg' );
            if ( pos === -1 )
                pos = label.indexOf( '.JPG' );
            if ( pos !== -1 )
                label = label.substr( 0, pos );
        }

        label = label.toString();
        var refColor = color ? color : this._color;
        var outlineColor = '#404040';
        // use white outline for dark colors
        if ( 0.2126 * this._color[ 0 ] + 0.7152 * this._color[ 1 ] + 0.0722 * this._color[ 2 ] < 128 )
            outlineColor = '#ffffff';

        textStyle.setText( label );
        textStyle.setFill( new ol_style__WEBPACK_IMPORTED_MODULE_1__["Fill"]( {
            color: refColor
        } ) );
        textStyle.setStroke( new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
            color: outlineColor,
            width: 2
        } ) );

        return textStyle;
    },

};

/* harmony default export */ __webpack_exports__["default"] = (MapSymbol);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(355);




const Utils = window.PointCloudViz.DB.Utils;
const GISUtils = window.PointCloudViz.GIS.Utils;

const PointSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.PointSymbol;

var MapPointSymbol = function () {
    PointSymbol.call( this );
    if ( this._color === undefined )
        this._color = Utils.generateRandomRGBIntColor();
    this._size = 5;
};

MapPointSymbol.prototype = GISUtils.objectInherit( PointSymbol.prototype, GISUtils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__["default"].prototype, {

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        var self = this;

        this._style = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                image: self.getPoint( feature ),
                text: self.getLabel( feature, resolution )
            } );
        };

        this._selectionStyle = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                image: self.getPoint( feature, self.getSelectionColor() ),
                text: self.getLabel( feature, resolution, self.getSelectionColor() )
            } );
        };
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PointSymbolizer ) {
            if ( style.PointSymbolizer.color ) {
                this._color = style.PointSymbolizer.color;
                this.applyAlpha( saveAlpha );
            }
            if ( style.PointSymbolizer.size )
                this._size = style.PointSymbolizer.size / 4;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return false;
    },

} ) );

/* harmony default export */ __webpack_exports__["default"] = (MapPointSymbol);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(355);




const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.Utils;

const PointSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.PointSymbol;
const MarkerSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.MarkerSymbol;

var MapPointMarkerSymbol = function () {
    MarkerSymbol.call( this );
};

MapPointMarkerSymbol.prototype = Utils.objectInherit( PointSymbol.prototype, Utils.objectInherit( MarkerSymbol.prototype, Utils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__["default"].prototype, {

    configure: function ( style ) {
        if ( style && style.PointSymbolizer ) {
            this._rules = undefined;
            if ( style.PointSymbolizer.RuleSymbolizer )
                this._rules = style.PointSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        // Storing functions to be used on renderLayer in MapSymbol.js
        this._style = this.setStyleFunction.bind( this );

        this._selectionStyle = this.setSelectionStyleFunction.bind( this );
    },

    setStyleFunction: function ( feature, resolution ) {
        return [
            new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                image: this.getPoint( feature ),
                text: this.getLabel( feature, resolution )
            } ),
            this.getMarkerStyle( feature, false, false )
        ];
    },

    setSelectionStyleFunction: function ( feature, resolution ) {
        return [
            new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                image: this.getPoint( feature, this.getSelectionColor() ),
                text: this.getLabel( feature, resolution, this.getSelectionColor() )
            } ),
            this.getMarkerStyle( feature, true, false )
        ];
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PointSymbolizer ) {
            if ( style.PointSymbolizer.color ) {
                this._color = style.PointSymbolizer.color;
                this.applyAlpha( saveAlpha );
            }
            if ( style.PointSymbolizer.marker )
                this._imageURL = style.PointSymbolizer.marker;
            if ( style.PointSymbolizer.size )
                this._size = style.PointSymbolizer.size / 4;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return true;
    }

} ) ) );

/* harmony default export */ __webpack_exports__["default"] = (MapPointMarkerSymbol);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(355);




const LineSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.LineSymbol;
const Utils = window.PointCloudViz.DB.Utils;
const GISUtils = window.PointCloudViz.GIS.Utils;

var MapLineSymbol = function () {
    LineSymbol.call( this );
    this._color = Utils.generateRandomRGBIntColor();
    this._lineWidth = 2;
};

MapLineSymbol.prototype = GISUtils.objectInherit( LineSymbol.prototype, GISUtils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__["default"].prototype, {

    configure: function ( style ) {

        if ( style && style.LineSymbolizer ) {
            this._rules = undefined;
            if ( style.LineSymbolizer.RuleSymbolizer )
                this._rules = style.LineSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        var self = this;

        this._style = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                stroke: self.getStroke( feature ),
                text: self.getLabel( feature, resolution )
            } );
        };

        this._selectionStyle = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                stroke: self.getStroke( feature, self.getSelectionColor() ),
                text: self.getLabel( feature, resolution, self.getSelectionColor() )
            } );
        };
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.LineSymbolizer ) {
            if ( style.LineSymbolizer.strokeColor ) {
                this._color = style.LineSymbolizer.strokeColor;
                this.applyAlpha( saveAlpha );
            }
            if ( style.LineSymbolizer.selectionFillColor )
                this._selectionColor = style.LineSymbolizer.selectionFillColor;
            if ( style.LineSymbolizer.strokeWidth )
                this._lineWidth = style.LineSymbolizer.strokeWidth;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return false;
    },

} ) );

/* harmony default export */ __webpack_exports__["default"] = (MapLineSymbol);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var ol_geom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(360);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(355);





const LineSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.LineSymbol;
const MarkerSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.MarkerSymbol;
const Utils = window.PointCloudViz.DB.Utils;
const GISUtils = window.PointCloudViz.GIS.Utils;

var MapLineMarkerSymbol = function () {
    LineSymbol.call( this );
    MarkerSymbol.call( this );
    this._color = Utils.generateRandomRGBIntColor();
    this._lineWidth = 2;
};

MapLineMarkerSymbol.prototype = GISUtils.objectInherit( LineSymbol.prototype, GISUtils.objectInherit( MarkerSymbol.prototype, GISUtils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_3__["default"].prototype, {

    configure: function ( style ) {

        if ( style && style.LineSymbolizer ) {
            this._rules = undefined;
            if ( style.LineSymbolizer.RuleSymbolizer )
                this._rules = style.LineSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        var self = this;

        this._style = function ( feature, resolution ) {

            return [
                new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                    stroke: self.getStroke( feature ),
                    text: self.getLabel( feature, resolution )
                } ),
                self.getMarkerStyle( feature, false, true )
            ];
        };

        this._selectionStyle = function ( feature, resolution ) {

            return [
                new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                    stroke: self.getStroke( feature, self.getSelectionColor() ),
                    text: self.getLabel( feature, resolution, self.getSelectionColor() )
                } ),
                self.getMarkerStyle( feature, true, true )
            ];
        };
    },

    getMarkerGeometry: function ( feature ) {
        var g = feature.getGeometry();
        var coordinate;
        if ( g.getCoordinates().length > 0 ) {
            coordinate = g.getCoordinateAt( 0.5 );
        } else {
            coordinate = g.getFirstCoordinate();
        }
        return new ol_geom__WEBPACK_IMPORTED_MODULE_2__["MultiPoint"]( [ coordinate ] );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.LineSymbolizer ) {
            if ( style.LineSymbolizer.strokeColor ) {
                this._color = style.LineSymbolizer.strokeColor;
                this.applyAlpha( saveAlpha );
            }
            if ( style.LineSymbolizer.selectionFillColor )
                this._selectionColor = style.LineSymbolizer.selectionFillColor;
            if ( style.LineSymbolizer.strokeWidth )
                this._lineWidth = style.LineSymbolizer.strokeWidth;
            if ( style.LineSymbolizer.marker )
                this._imageURL = style.LineSymbolizer.marker;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return true;
    },

} ) ) );

/* harmony default export */ __webpack_exports__["default"] = (MapLineMarkerSymbol);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _geom_Circle_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(287);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return _geom_Circle_js__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _geom_Geometry_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(100);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Geometry", function() { return _geom_Geometry_js__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(211);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "GeometryCollection", function() { return _geom_GeometryCollection_js__WEBPACK_IMPORTED_MODULE_2__["default"]; });

/* harmony import */ var _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(185);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LinearRing", function() { return _geom_LinearRing_js__WEBPACK_IMPORTED_MODULE_3__["default"]; });

/* harmony import */ var _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(203);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LineString", function() { return _geom_LineString_js__WEBPACK_IMPORTED_MODULE_4__["default"]; });

/* harmony import */ var _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(206);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiLineString", function() { return _geom_MultiLineString_js__WEBPACK_IMPORTED_MODULE_5__["default"]; });

/* harmony import */ var _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(207);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPoint", function() { return _geom_MultiPoint_js__WEBPACK_IMPORTED_MODULE_6__["default"]; });

/* harmony import */ var _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(208);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiPolygon", function() { return _geom_MultiPolygon_js__WEBPACK_IMPORTED_MODULE_7__["default"]; });

/* harmony import */ var _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Point", function() { return _geom_Point_js__WEBPACK_IMPORTED_MODULE_8__["default"]; });

/* harmony import */ var _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(184);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return _geom_Polygon_js__WEBPACK_IMPORTED_MODULE_9__["default"]; });

/* harmony import */ var _geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SimpleGeometry", function() { return _geom_SimpleGeometry_js__WEBPACK_IMPORTED_MODULE_10__["default"]; });

/**
 * @module ol/geom
 */











//# sourceMappingURL=geom.js.map

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(355);




const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Utils;
const GISUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.Utils;
const FillSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.FillSymbol;
const MathUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils.MathUtils;

var MapFillSymbol = function () {
    FillSymbol.call( this );

    if ( this._color === undefined )
        this._color = Utils.generateRandomRGBIntColor();
    this._strokeColor = MathUtils.vec4.fromValues32( this._color[ 0 ], this._color[ 1 ], this._color[ 2 ], 1.0 );
};

MapFillSymbol.prototype = GISUtils.objectInherit( FillSymbol.prototype, GISUtils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_2__["default"].prototype, {

    configure: function ( style ) {

        if ( style && style.PolygonSymbolizer ) {
            this._rules = undefined;
            if ( style.PolygonSymbolizer.RuleSymbolizer )
                this._rules = style.PolygonSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        var self = this;

        this._style = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                stroke: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
                    color: self.getFillStroke( false ),
                    width: 2
                } ),
                fill: self.getFill( feature ),
                text: self.getLabel( feature, resolution )
            } );
        };

        this._selectionStyle = function ( feature, resolution ) {

            return new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                stroke: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
                    color: self.getFillStroke( true ),
                    width: 2
                } ),
                fill: self.getFill( feature, self.getSelectionColor() ),
                text: self.getLabel( feature, resolution, self.getSelectionColor() )
            } );
        };
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.fillColor ) {
                this._color = style.PolygonSymbolizer.fillColor;
                this.applyAlpha( saveAlpha );
            }
            if ( style.PolygonSymbolizer.strokeColor )
                this._strokeColor = style.PolygonSymbolizer.strokeColor;
            if ( style.PolygonSymbolizer.selectionFillColor )
                this._selectionColor = style.PolygonSymbolizer.selectionFillColor;
            if ( style.PolygonSymbolizer.selectionStrokeColor )
                this._selectionStrokeColor = style.PolygonSymbolizer.selectionStrokeColor;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
        this._strokeColor = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return false;
    },

} ) );

/* harmony default export */ __webpack_exports__["default"] = (MapFillSymbol);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var ol_geom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(360);
/* harmony import */ var pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(355);
/* harmony import */ var pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(357);








const Utils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB.Utils;
const GISUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.Utils;

const FillSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.FillSymbol;
const MarkerSymbol = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS.MarkerSymbol;
const MathUtils = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils.MathUtils;

var MapFillMarkerSymbol = function () {
    FillSymbol.call( this );
    MarkerSymbol.call( this );
    if ( this._color === undefined )
        this._color = Utils.generateRandomRGBIntColor();
    this._strokeColor = MathUtils.vec4.fromValues32( this._color[ 0 ], this._color[ 1 ], this._color[ 2 ], 1.0 );

    this._markerSymbol = new pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_4__["default"]();
};

MapFillMarkerSymbol.prototype = GISUtils.objectInherit( FillSymbol.prototype, GISUtils.objectInherit( MarkerSymbol.prototype, GISUtils.objectInherit( pcvizMapRenderer_MapSymbol__WEBPACK_IMPORTED_MODULE_3__["default"].prototype, {

    configure: function ( style ) {

        if ( style && style.PolygonSymbolizer ) {
            this._rules = undefined;
            if ( style.PolygonSymbolizer.RuleSymbolizer )
                this._rules = style.PolygonSymbolizer.RuleSymbolizer;
        }
        this.configureSymbolizers( style, true );
        this.configureLabels( style );

        var self = this;

        this._style = function ( feature, resolution ) {
            return [ new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                    stroke: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
                        color: self.getFillStroke( false ),
                        width: self._lineWidth
                    } ),
                    fill: self.getFill( feature ),
                    text: self.getLabel( feature, resolution )
                } ),
                self.getMarkerStyle( feature, false.true )
            ];
        };

        this._selectionStyle = function ( feature, resolution ) {
            return [ new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
                    stroke: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
                        color: self.getFillStroke( true ),
                        width: self._lineWidth
                    } ),
                    fill: self.getFill( feature, self.getSelectionColor() ),
                    text: self.getLabel( feature, resolution, self.getSelectionColor() )
                } ),
                self.getMarkerStyle( feature, true, true )
            ];
        };
    },

    getMarkerGeometry: function ( feature ) {
        var g = feature.getGeometry();
        return new ol_geom__WEBPACK_IMPORTED_MODULE_2__["MultiPoint"]( [ g.getInteriorPoint().getCoordinates() ] );
    },

    configureSymbolizers: function ( style, saveAlpha ) {
        if ( style && style.PolygonSymbolizer ) {
            if ( style.PolygonSymbolizer.fillColor ) {
                this._color = style.PolygonSymbolizer.fillColor;
                this.applyAlpha( saveAlpha );
            }
            if ( style.PolygonSymbolizer.strokeColor )
                this._strokeColor = style.PolygonSymbolizer.strokeColor;
            if ( style.PolygonSymbolizer.selectionFillColor )
                this._selectionColor = style.PolygonSymbolizer.selectionFillColor;
            if ( style.PolygonSymbolizer.selectionStrokeColor )
                this._selectionStrokeColor = style.PolygonSymbolizer.selectionStrokeColor;
            if ( style.PolygonSymbolizer.marker )
                this._imageURL = style.PolygonSymbolizer.marker;
        }
    },

    configureAsInvisible: function () {
        this._color = [ 0, 0, 0, 0 ];
        this._strokeColor = [ 0, 0, 0, 0 ];
    },

    hasImageMarker: function () {
        return true;
    },

} ) ) );

/* harmony default export */ __webpack_exports__["default"] = (MapFillMarkerSymbol);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return MapMachineryPointMarkerSymbol; });
/* harmony import */ var ol_style_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34);
/* harmony import */ var pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(357);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_2__);




const {
    STATUS_SITELINK3D,
    STATUS_TELEMATICS,
    MACHINE_TYPES
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_2___default.a.Renderer;

class MapMachineryPointMarkerSymbol extends pcvizMapRenderer_MapPointMarkerSymbol__WEBPACK_IMPORTED_MODULE_1__["default"] {
    constructor() {
        super();
    }

    setStyleFunction( feature, resolution ) {
        return this.getIconStyles( feature, resolution );
    }

    setSelectionStyleFunction( feature, resolution ) {
        const selectColor = this.getSelectionColor();
        return this.getIconStyles( feature, resolution, selectColor );
    }

    getIconStyles( feature, resolution, color ) {
        // Pin icon
        let statusSitelink = STATUS_SITELINK3D.find( ( config ) => config.name === feature.getProperties()[ 'status_sl3d' ] );
        statusSitelink = statusSitelink ? statusSitelink : STATUS_SITELINK3D[ 0 ];
        let pinStyle = new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Style"]( {
            image: new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Icon"]( {
                anchor: [ 0.5, 1 ],
                src: statusSitelink.icon,
                color: this.getAppliedColor( color )
            } ),
            text: this.getLabel( feature, resolution )
        } );

        // Machine icon
        let machineType = MACHINE_TYPES.find( ( config ) => config.name === feature.getProperties()[ 'machine_type' ] );
        machineType = machineType ? machineType : MACHINE_TYPES[ 0 ];
        let machineStyle = new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Style"]( {
            image: new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Icon"]( {
                anchor: [ 0.5, 1 ],
                scale: 0.4,
                displacement: [ 0, 60 ],
                src: machineType.icon,
                color: this.getAppliedColor( color )
            } )
        } );

        // Dot icon
        let statusTelematics = STATUS_TELEMATICS.find( ( config ) => config.name === feature.getProperties()[ 'status_telematics' ] );
        statusTelematics = statusTelematics ? statusTelematics : STATUS_TELEMATICS[ 0 ];
        let dotStyle = new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Style"]( {
            image: new ol_style_js__WEBPACK_IMPORTED_MODULE_0__["Icon"]( {
                anchor: [ 0.5, 1 ],
                scale: 0.15,
                displacement: [ 0, 80 ],
                src: statusTelematics.icon,
                color: this.getAppliedColor( color )
            } )
        } );

        return [ pinStyle, machineStyle, dotStyle ];
    }
}


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return SitesMapViewer; });
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7);
/* harmony import */ var ol_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34);
/* harmony import */ var ol_source__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(68);
/* harmony import */ var ol_layer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(315);
/* harmony import */ var ol_Map_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(265);
/* harmony import */ var ol_layer_Tile_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(140);
/* harmony import */ var ol_View_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(179);
/* harmony import */ var ol_geom__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(360);
/* harmony import */ var ol_Feature__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97);
/* harmony import */ var ol_layer_Group__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(174);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_10__);













const {
    CRSUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_10___default.a.Utils;

const JOBSITE_STATUS = {
    ACTIVE: 'Active',
    COMPLETED: 'Completed'
};

class SitesMapViewer {
    constructor( targetElement ) {
        this._olMap = undefined;
        this._targetElement = targetElement;
        this._center = [ 0.0, 0.0 ];
        this._sitesMapCrs = CRSUtils.WGS_84;
        this._offsetDegrees = 2; // Offset degrees to fit extent
        this._defaultExtentWGS84 = [ -178, -88, 178, 88 ]; // Default extent in WGS 84 - offset degrees
        this._locationExtent = [ Number.MAX_VALUE, Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE ]; // minLng, minLat, maxLng, maxLat

        this._selectedJobSiteFn = undefined;
        this._featureFocus = undefined;
        this._textElement = new ol_style__WEBPACK_IMPORTED_MODULE_1__["Text"]( {
            font: 'normal 12px Arial',
            text: '',
            fill: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Fill"]( {
                color: '#404040'
            } ),
            stroke: new ol_style__WEBPACK_IMPORTED_MODULE_1__["Stroke"]( {
                color: '#ffffff',
                width: 2
            } ),
            scale: 1.8,
            offsetY: -95,
        } );
        this._timeoutPointermove = null;
    }

    run() {
        this.mapTile = new ol_layer_Tile_js__WEBPACK_IMPORTED_MODULE_5__["default"]( {
            source: new ol_source__WEBPACK_IMPORTED_MODULE_2__["OSM"](),
        } );
        this._olMap = new ol_Map_js__WEBPACK_IMPORTED_MODULE_4__["default"]( {
            layers: [
                this.mapTile
            ],
            target: this._targetElement,
            view: new ol_View_js__WEBPACK_IMPORTED_MODULE_6__["default"]( {
                center: this._center,
                zoom: 2,
            } ),
        } );

        this._olMap.on( 'click', ( ev ) => {
            this.onSitesMapClick( ev.pixel );
        } );
        this._olMap.on( 'dblclick', ( ev ) => {
            this.onSitesMapClick( ev.pixel );
            return false; // stops event propagation
        } );
        this._olMap.on( 'pointermove', ( ev ) => {
            if ( !this._timeoutPointermove ) {
                this._timeoutPointermove = setTimeout( () => {
                    this.onSitesMapPointerMove( ev.pixel );
                    this._timeoutPointermove = null;
                }, 100 );
            }
        } );
    }

    setSelectedJobSiteFn( fn ) {
        this._selectedJobSiteFn = fn;
    }

    renderSitesList( sitesList, clear ) {
        if ( clear ) {
            this.clearSites();
        }

        return new Promise( ( resolve, reject ) => {
            let sitesRenderPromises = [];
            sitesList.forEach( ( site ) => {
                sitesRenderPromises.push( this.renderJobSiteMarker( site ) );
            } );

            Promise.all( sitesRenderPromises ).then( () => {
                this._center = [ ( this._locationExtent[ 0 ] + this._locationExtent[ 2 ] ) / 2.0, ( this._locationExtent[ 1 ] + this._locationExtent[ 3 ] ) / 2.0 ];
                this.fitSitesMap();
                resolve();
            } ).catch( () => {
                reject();
            } );
        } );
    }

    clearSites() {
        const group = new ol_layer_Group__WEBPACK_IMPORTED_MODULE_9__["default"]( {
            layers: [ this.mapTile ]
        } );
        this._olMap.setLayerGroup( group );
    }

    renderJobSiteMarker( site ) {
        return new Promise( ( resolve ) => {
            if ( !site.location ) {
                resolve();
                return;
            }

            const siteLocation = [ site.location[ 1 ], site.location[ 0 ] ]; // OpenLayers works with Long & Lat (original location comes in Lat & Long)

            // Update location extent with min/max Long & Lat
            this.updateSitesLocationExtent( siteLocation );

            const newSiteMarker = this.createJobSiteMarker( site, siteLocation );
            this._olMap.addLayer( newSiteMarker );
            resolve();
        } );
    }

    createJobSiteMarker( site, location ) {
        const markerGeometry = new ol_geom__WEBPACK_IMPORTED_MODULE_7__["Point"]( ol_proj__WEBPACK_IMPORTED_MODULE_0__["fromLonLat"]( location ) );
        const markerFeature = new ol_Feature__WEBPACK_IMPORTED_MODULE_8__["default"]( {
            geometry: markerGeometry,
            info: site
        } );

        const colorMarker = site.status === JOBSITE_STATUS.ACTIVE ? '#00FF00' : '#AAAAAA';

        const markerStyle = new ol_style__WEBPACK_IMPORTED_MODULE_1__["Icon"]( ( {
            anchor: [ 0.5, 0.8 ],
            src: '/assets/job-site-place.svg',
            color: colorMarker,
        } ) );

        markerFeature.setStyle( new ol_style__WEBPACK_IMPORTED_MODULE_1__["Style"]( {
            image: markerStyle,
        } ) );

        const vectorSource = new ol_source__WEBPACK_IMPORTED_MODULE_2__["Vector"]( {
            features: [ markerFeature ]
        } );

        const siteMarker = new ol_layer__WEBPACK_IMPORTED_MODULE_3__["Vector"]( {
            title: site.name,
            visible: true,
            source: vectorSource
        } );

        return siteMarker;
    }

    setFeatureText( feature, label ) {
        if ( label ) {
            this._textElement.setText( label );
        }
        let style = feature.getStyle();
        style.setText( label ? this._textElement : undefined );
        feature.setStyle( style );
    }

    updateSitesLocationExtent( newLocation ) {
        // // Update location extent with min/max Long & Lat. Setting max range values for extent. Max value Long&Lat (in WGS 84 coordinates 180,90) - offsetDegrees.
        this._locationExtent[ 0 ] = Math.max( Math.min( newLocation[ 0 ], this._locationExtent[ 0 ] ), this._defaultExtentWGS84[ 0 ] );
        this._locationExtent[ 1 ] = Math.max( Math.min( newLocation[ 1 ], this._locationExtent[ 1 ] ), this._defaultExtentWGS84[ 1 ] );
        this._locationExtent[ 2 ] = Math.min( Math.max( newLocation[ 0 ], this._locationExtent[ 2 ] ), this._defaultExtentWGS84[ 2 ] );
        this._locationExtent[ 3 ] = Math.min( Math.max( newLocation[ 1 ], this._locationExtent[ 3 ] ), this._defaultExtentWGS84[ 3 ] );
    }

    isValidExtent() {
        return this._locationExtent[ 0 ] < this._locationExtent[ 2 ] && this._locationExtent[ 1 ] < this._locationExtent[ 3 ];
    }

    fitSitesMap() {
        let degreesExtent = [ ...this._locationExtent ];
        if ( !this.isValidExtent() ) {
            degreesExtent = [ ...this._defaultExtentWGS84 ];
        }

        // As in Point we transfrom fromLonLat the position, we need it too in the extent.
        let coordMin = ol_proj__WEBPACK_IMPORTED_MODULE_0__["fromLonLat"]( [ degreesExtent[ 0 ] - this._offsetDegrees, degreesExtent[ 1 ] - this._offsetDegrees ] );
        let coordMax = ol_proj__WEBPACK_IMPORTED_MODULE_0__["fromLonLat"]( [ degreesExtent[ 2 ] + this._offsetDegrees, degreesExtent[ 3 ] + this._offsetDegrees ] );
        let extent = [ coordMin[ 0 ], coordMin[ 1 ], coordMax[ 0 ], coordMax[ 1 ] ];

        this._olMap.getView().fit( extent, this._olMap.getSize() );
    }

    onSitesMapClick( pixel ) {
        const featureSelected = this._olMap.getFeaturesAtPixel( pixel )[ 0 ]; // Just the first one feature selected
        if ( !featureSelected || !this._selectedJobSiteFn ) {
            return;
        }
        const selectedSite = featureSelected.get( 'info' );
        this._selectedJobSiteFn( selectedSite );
    }

    onSitesMapPointerMove( pixel ) {
        const featureSelected = this._olMap.getFeaturesAtPixel( pixel )[ 0 ]; // Just the first one feature selected
        if ( featureSelected === this._featureFocus ) {
            return;
        }

        if ( this._featureFocus !== undefined ) {
            this.setFeatureText( this._featureFocus, undefined );
            this._featureFocus = undefined;
            this._olMap.getViewport().style.cursor = '';
        }

        if ( !featureSelected ) {
            return;
        }

        this._olMap.getViewport().style.cursor = 'pointer';

        const jobSiteName = featureSelected.get( 'info' ).name;
        this.setFeatureText( featureSelected, jobSiteName );

        this._featureFocus = featureSelected;
    }
}


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return JobSiteMapView; });
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(PointCloudViz__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var ol_proj__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26);
/* harmony import */ var Proj4js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(Proj4js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27);
/* harmony import */ var pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33);
/* harmony import */ var pcvizMapTools_MapInformationTool__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(351);
/* harmony import */ var pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(352);
/* harmony import */ var pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(353);









const JobSiteView = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.App.JobSiteView;
const {
    Registry,
    ListenerController,
    Utils: UtilsDB
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.DB;
const pcvizGISRenderer = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Renderer;
const {
    CRSUtils,
    MathUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Utils;
const Group = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.Node.Group.default;
const {
    LayerType,
    VectorLayerUtils
} = PointCloudViz__WEBPACK_IMPORTED_MODULE_0___default.a.GIS;

/**
 * This class implements the map view for jobsite viewer. It uses [OpenLayers](http://www.openlayers.org) to render the map.
 * @class
 * @memberof pcvizMap
 * @extends JobSiteView
 * @param {element} mapElement DOM element to link the map
 * @param {object} opt        Configuration options
 * @param {canvas} viewerCanvas The canvas with 3D context in which the pointcloud is going to be rendered. If undefined, one will be created.
 * @property {OLMapViewer} _olMapViewer The map viewer that renders the OL map.
 * @property {MapInformationTool} _informationTool The information tool that works with the map.
 * @property {MapLayerRenderer} _layerRenderer The layer renderer.
 */
class JobSiteMapView extends JobSiteView { // TODO maybe we need to refactor both JobSite/Project MapViews in a BaseMapView as in 3D view cases?
    constructor( jobsite, mapElement, opt, viewerCanvas ) {
        super( jobsite );

        this._olMapViewer = new pcvizMap_OLMapViewer__WEBPACK_IMPORTED_MODULE_4__["default"]( mapElement, viewerCanvas );
        this._center = undefined;

        Registry.getInstance().getController( 'Object' ).addUpdatedFinishCallback( ListenerController.PROJECT, this.refresh.bind( this ) );

        this._workspaceController = Registry.getInstance().getController( 'Workspace' );

        this._informationTool = new pcvizMapTools_MapInformationTool__WEBPACK_IMPORTED_MODULE_5__["default"]( this._olMapViewer );
        this._layerRenderer = new pcvizMapRenderer_MapLayerRenderer__WEBPACK_IMPORTED_MODULE_7__["default"]( this._olMapViewer );

        this._layerGroupNodes = new Map();
        this.registerSymbols();
    }

    registerSymbols() {
        const symbolRegistry = Registry.getController( 'Symbol' );
        symbolRegistry.registerSymbol( 'Map', 'Point', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'PointMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'MultiPoint', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'MultiPointMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Line', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].LineSymbol );
        symbolRegistry.registerSymbol( 'Map', 'LineMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].LineMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Fill', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].FillSymbol );
        symbolRegistry.registerSymbol( 'Map', 'FillMarker', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].FillMarkerSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Panorama', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'PlanarImage', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointSymbol );
        symbolRegistry.registerSymbol( 'Map', 'Target', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].PointSymbol ); //CHECK if we want a special symbol for targets
        symbolRegistry.registerSymbol( 'Map', 'Model3D', pcvizGISRenderer.Model3DSymbol3D );
        symbolRegistry.registerSymbol( 'Map', 'Volume', pcvizGISRenderer.VolumeSymbol3D );
        symbolRegistry.registerSymbol( 'Map', 'Machinery', pcvizMapRenderer_pcvizMapRenderer__WEBPACK_IMPORTED_MODULE_6__["default"].MachineryMarkerSymbol );
    }

    /**
     * Returns the MapViewer object
     * @memberof pcvizMap.MapView
     * @return {OLMapViewer} The Map viewer
     */
    getMapViewer() {
        return this._olMapViewer;
    }

    /**
     * Returns the OpenLayers map object
     * @memberof pcvizMap.MapView
     * @return {Map} The OpenLayers map
     */
    getOLMap() {
        return this._olMapViewer.getMap();
    }

    getLayerRenderer() {
        return this._layerRenderer;
    }

    // we use a promise because another views (sceneView) must be wait to know if
    // all the layers are loaded right.
    // In this case map doesn´t need to wait to anything to resolve the promise
    run() {
        return new Promise( ( resolve ) => {
            // Setting ol projection
            this.setProjection( this._jobSite.getProjection() );

            if ( this._projection && this._jobSite.getProj4() !== '' ) {
                Proj4js__WEBPACK_IMPORTED_MODULE_2___default.a.defs( this._projection, this._jobSite.getProj4() );
                Object(ol_proj_proj4_js__WEBPACK_IMPORTED_MODULE_3__["register"])( Proj4js__WEBPACK_IMPORTED_MODULE_2___default.a );
                this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_1__["get"]( this._projection );
            } else {
                this._olProjection = ol_proj__WEBPACK_IMPORTED_MODULE_1__["get"]( CRSUtils.DEFAULT_PROJECTION );
            }
            this._olMapViewer.setProjection( this._olProjection );

            this._olMapViewer.run();

            this.drawSnapshotLayers().then( () => {
                resolve();
            } );
        } );
    }

    drawSnapshotLayers() {
        return new Promise( ( resolve, reject ) => {
            let snapshotsLayers = this._jobSite.getAllLayers();

            let promises = [];

            snapshotsLayers.forEach( ( snapshotLayer ) => {
                if ( snapshotLayer.isOpen() ) { // check is a snapshot layer was opened in JobSiteSceneView
                    let snapshot = this._jobSite.getSnapshotByLayer( snapshotLayer );
                    promises.push( this.drawSnapshotLayer( snapshotLayer, snapshot ) );
                }
            } );

            Promise.all( promises ).then( () => {
                this._olMapViewer.renderExtent();
                this._olMapViewer.fit();
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    /**
     * Method to draw a snapshot in the view
     * @param {Layer} snapshotLayer from snapshot's layerId
     * @param {object} snapshot in json format with the upper matrix to be placed
     * @returns {Promise}
     */
    drawSnapshotLayer( snapshotLayer, snapshot ) {
        return new Promise( ( resolve, reject ) => {
            let layerRenderer = this.getLayerRenderer();
            let mapViewer = this.getMapViewer();
            let parentNode = this._olMapViewer.getMap3DScene().getRootNode();

            if ( snapshot ) {
                let group = new Group();
                group.setName( snapshot.uuid );
                if ( snapshot.transformMatrix ) {
                    UtilsDB.transposeMat4( group.getMatrix(), snapshot.transformMatrix );
                    group.setMatrix( group.getMatrix() );
                }
                // Storing group node by layerId, as each group node can be only above from the corresponding layer node.
                this._layerGroupNodes.set( snapshot.layerId, group );
                parentNode.addChild( group );
                parentNode = group;
            }

            if ( !snapshotLayer.getCenter() )
                snapshotLayer.computeCenter();

            if ( this._center === undefined ) {
                const viewController = Registry.getInstance().getController( 'View' );
                if ( viewController.getCenter() !== undefined )
                    this._center = viewController.getCenter();
                else {
                    this._center = snapshotLayer.getCenter();
                    viewController.setCenter( this._center );
                }
                this._layerRenderer.setCenter( this._center );
                let transCenter = [ -this._center[ 0 ], -this._center[ 1 ], -this._center[ 2 ] ];

                this._olMapViewer.getMap3DScene().getRootNode().setMatrix( UtilsDB.translateMat4( MathUtils.mat4.create(), transCenter ) );
            }

            snapshotLayer.render( layerRenderer, mapViewer, parentNode ).then( () => {
                resolve();
            } ).catch( ( error ) => {
                reject( error );
            } );
        } );
    }

    refreshMap() {
        return new Promise( resolve => {
            this._olMapViewer.getMap3DScene()._rootNode.removeChildren();
            this._layerRenderer.initLayerNodes();

            this.drawSnapshotLayers();
            resolve();
        } );
    }

    refresh( objects ) {
        for ( let i = 0; i < objects.length; i++ ) {
            console.log( 'refresh object' );
        }
    }

    // TODO: implement a function to refresh a single project/snapshot (This function should return a promise to be compatible with SceneView)

    setMapDOMElement( element ) {
        this._mapElement = element;
        if ( this._olMapViewer !== undefined )
            this._olMapViewer.setTarget( this._mapElement );
    }

    render() {
        this._olMapViewer.renderPointCloudScene();
        this._olMapViewer.renderExtent();
    }


    // Check the usability of the following methods
    toggleExtent() {
        let olLayers = this.getOLMap().getLayers();
        for ( let i = 0; i < olLayers.getLength(); i++ ) {
            if ( olLayers.item( i ).get( 'id' ) === 'extent' )
                olLayers.item( i ).setVisible( !olLayers.item( i ).getVisible() );
        }
    }

    isExtentVisible() {
        let olLayers = this.getOLMap().getLayers();
        let isVisible;
        for ( let i = 0; i < olLayers.getLength(); i++ ) {
            if ( olLayers.item( i ).get( 'id' ) === 'extent' )
                isVisible = olLayers.item( i ).getVisible();
        }
        return isVisible;
    }

    destroy() {
        this._olMapViewer.destroy();
    }

    deleteLayer( layer ) {
        const layerNode = this._layerRenderer.getNodeFromLayer( layer );

        if ( layerNode === undefined ) {
            return;
        }

        if ( layer.getType() === LayerType.POINTCLOUD ) {
            this.deleteSnapshotLayer( layerNode, layer );
        } else {
            this.deleteVectorLayer( layerNode, layer );
        }
    }

    deleteSnapshotLayer( layerNode, layer ) {
        const matrixTransform = layerNode._parents[ 0 ];
        matrixTransform.removeChild( layerNode );

        // removes matrixTransform
        matrixTransform._parents[ 0 ].removeChild( matrixTransform );

        this._layerRenderer.removeLayerNode( layer );
        this.render();
    }

    deleteVectorLayer( layerNode, layer ) {
        if ( VectorLayerUtils.isModel( layer.category ) ) {
            layerNode._parents[ 0 ].removeChild( layerNode );
            this._layerRenderer.removeLayerNode( layer );

            this.render();
            return;
        }

        this._olMapViewer.removeLayerById( layer.layerId );
        this._olMapViewer.renderExtent();
    }
}


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var ol_ol_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(367);
/* harmony import */ var PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(371);



/* harmony default export */ __webpack_exports__["default"] = ({
    olCSS: ol_ol_css__WEBPACK_IMPORTED_MODULE_0__["default"],
    css: PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1__["default"]
});


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(368);
/* harmony import */ var _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _css_loader_dist_cjs_js_ol_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(369);
/* harmony import */ var _css_loader_dist_cjs_js_ol_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_css_loader_dist_cjs_js_ol_css__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_css_loader_dist_cjs_js_ol_css__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_css_loader_dist_cjs_js_ol_css__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isOldIE = function isOldIE() {
  var memo;
  return function memorize() {
    if (typeof memo === 'undefined') {
      // Test for IE <= 9 as proposed by Browserhacks
      // @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
      // Tests for existence of standard globals is to allow style-loader
      // to operate correctly into non-standard environments
      // @see https://github.com/webpack-contrib/style-loader/issues/177
      memo = Boolean(window && document && document.all && !window.atob);
    }

    return memo;
  };
}();

var getTarget = function getTarget() {
  var memo = {};
  return function memorize(target) {
    if (typeof memo[target] === 'undefined') {
      var styleTarget = document.querySelector(target); // Special case to return head of iframe instead of iframe itself

      if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
        try {
          // This will throw an exception if access to iframe is blocked
          // due to cross-origin restrictions
          styleTarget = styleTarget.contentDocument.head;
        } catch (e) {
          // istanbul ignore next
          styleTarget = null;
        }
      }

      memo[target] = styleTarget;
    }

    return memo[target];
  };
}();

var stylesInDom = [];

function getIndexByIdentifier(identifier) {
  var result = -1;

  for (var i = 0; i < stylesInDom.length; i++) {
    if (stylesInDom[i].identifier === identifier) {
      result = i;
      break;
    }
  }

  return result;
}

function modulesToDom(list, options) {
  var idCountMap = {};
  var identifiers = [];

  for (var i = 0; i < list.length; i++) {
    var item = list[i];
    var id = options.base ? item[0] + options.base : item[0];
    var count = idCountMap[id] || 0;
    var identifier = "".concat(id, " ").concat(count);
    idCountMap[id] = count + 1;
    var index = getIndexByIdentifier(identifier);
    var obj = {
      css: item[1],
      media: item[2],
      sourceMap: item[3]
    };

    if (index !== -1) {
      stylesInDom[index].references++;
      stylesInDom[index].updater(obj);
    } else {
      stylesInDom.push({
        identifier: identifier,
        updater: addStyle(obj, options),
        references: 1
      });
    }

    identifiers.push(identifier);
  }

  return identifiers;
}

function insertStyleElement(options) {
  var style = document.createElement('style');
  var attributes = options.attributes || {};

  if (typeof attributes.nonce === 'undefined') {
    var nonce =  true ? __webpack_require__.nc : undefined;

    if (nonce) {
      attributes.nonce = nonce;
    }
  }

  Object.keys(attributes).forEach(function (key) {
    style.setAttribute(key, attributes[key]);
  });

  if (typeof options.insert === 'function') {
    options.insert(style);
  } else {
    var target = getTarget(options.insert || 'head');

    if (!target) {
      throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
    }

    target.appendChild(style);
  }

  return style;
}

function removeStyleElement(style) {
  // istanbul ignore if
  if (style.parentNode === null) {
    return false;
  }

  style.parentNode.removeChild(style);
}
/* istanbul ignore next  */


var replaceText = function replaceText() {
  var textStore = [];
  return function replace(index, replacement) {
    textStore[index] = replacement;
    return textStore.filter(Boolean).join('\n');
  };
}();

function applyToSingletonTag(style, index, remove, obj) {
  var css = remove ? '' : obj.media ? "@media ".concat(obj.media, " {").concat(obj.css, "}") : obj.css; // For old IE

  /* istanbul ignore if  */

  if (style.styleSheet) {
    style.styleSheet.cssText = replaceText(index, css);
  } else {
    var cssNode = document.createTextNode(css);
    var childNodes = style.childNodes;

    if (childNodes[index]) {
      style.removeChild(childNodes[index]);
    }

    if (childNodes.length) {
      style.insertBefore(cssNode, childNodes[index]);
    } else {
      style.appendChild(cssNode);
    }
  }
}

function applyToTag(style, options, obj) {
  var css = obj.css;
  var media = obj.media;
  var sourceMap = obj.sourceMap;

  if (media) {
    style.setAttribute('media', media);
  } else {
    style.removeAttribute('media');
  }

  if (sourceMap && typeof btoa !== 'undefined') {
    css += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))), " */");
  } // For old IE

  /* istanbul ignore if  */


  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    while (style.firstChild) {
      style.removeChild(style.firstChild);
    }

    style.appendChild(document.createTextNode(css));
  }
}

var singleton = null;
var singletonCounter = 0;

function addStyle(obj, options) {
  var style;
  var update;
  var remove;

  if (options.singleton) {
    var styleIndex = singletonCounter++;
    style = singleton || (singleton = insertStyleElement(options));
    update = applyToSingletonTag.bind(null, style, styleIndex, false);
    remove = applyToSingletonTag.bind(null, style, styleIndex, true);
  } else {
    style = insertStyleElement(options);
    update = applyToTag.bind(null, style, options);

    remove = function remove() {
      removeStyleElement(style);
    };
  }

  update(obj);
  return function updateStyle(newObj) {
    if (newObj) {
      if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) {
        return;
      }

      update(obj = newObj);
    } else {
      remove();
    }
  };
}

module.exports = function (list, options) {
  options = options || {}; // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
  // tags it will allow on a page

  if (!options.singleton && typeof options.singleton !== 'boolean') {
    options.singleton = isOldIE();
  }

  list = list || [];
  var lastIdentifiers = modulesToDom(list, options);
  return function update(newList) {
    newList = newList || [];

    if (Object.prototype.toString.call(newList) !== '[object Array]') {
      return;
    }

    for (var i = 0; i < lastIdentifiers.length; i++) {
      var identifier = lastIdentifiers[i];
      var index = getIndexByIdentifier(identifier);
      stylesInDom[index].references--;
    }

    var newLastIdentifiers = modulesToDom(newList, options);

    for (var _i = 0; _i < lastIdentifiers.length; _i++) {
      var _identifier = lastIdentifiers[_i];

      var _index = getIndexByIdentifier(_identifier);

      if (stylesInDom[_index].references === 0) {
        stylesInDom[_index].updater();

        stylesInDom.splice(_index, 1);
      }
    }

    lastIdentifiers = newLastIdentifiers;
  };
};

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(370);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ol-box {\n  box-sizing: border-box;\n  border-radius: 2px;\n  border: 2px solid blue;\n}\n\n.ol-mouse-position {\n  top: 8px;\n  right: 8px;\n  position: absolute;\n}\n\n.ol-scale-line {\n  background: rgba(0,60,136,0.3);\n  border-radius: 4px;\n  bottom: 8px;\n  left: 8px;\n  padding: 2px;\n  position: absolute;\n}\n.ol-scale-line-inner {\n  border: 1px solid #eee;\n  border-top: none;\n  color: #eee;\n  font-size: 10px;\n  text-align: center;\n  margin: 1px;\n  will-change: contents, width;\n  transition: all 0.25s;\n}\n.ol-scale-bar {\n  position: absolute;\n  bottom: 8px;\n  left: 8px;\n}\n.ol-scale-step-marker {\n  width: 1px;\n  height: 15px;\n  background-color: #000000;\n  float: right;\n  z-Index: 10;\n}\n.ol-scale-step-text {\n  position: absolute;\n  bottom: -5px;\n  font-size: 12px;\n  z-Index: 11;\n  color: #000000;\n  text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;\n}\n.ol-scale-text {\n  position: absolute;\n  font-size: 14px;\n  text-align: center;\n  bottom: 25px;\n  color: #000000;\n  text-shadow: -2px 0 #FFFFFF, 0 2px #FFFFFF, 2px 0 #FFFFFF, 0 -2px #FFFFFF;\n}\n.ol-scale-singlebar {\n  position: relative;\n  height: 10px;\n  z-Index: 9;\n  box-sizing: border-box;\n  border: 1px solid black;\n}\n\n.ol-unsupported {\n  display: none;\n}\n.ol-viewport, .ol-unselectable {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n.ol-selectable {\n  -webkit-touch-callout: default;\n  -webkit-user-select: text;\n  -moz-user-select: text;\n  -ms-user-select: text;\n  user-select: text;\n}\n.ol-grabbing {\n  cursor: -webkit-grabbing;\n  cursor: -moz-grabbing;\n  cursor: grabbing;\n}\n.ol-grab {\n  cursor: move;\n  cursor: -webkit-grab;\n  cursor: -moz-grab;\n  cursor: grab;\n}\n.ol-control {\n  position: absolute;\n  background-color: rgba(255,255,255,0.4);\n  border-radius: 4px;\n  padding: 2px;\n}\n.ol-control:hover {\n  background-color: rgba(255,255,255,0.6);\n}\n.ol-zoom {\n  top: .5em;\n  left: .5em;\n}\n.ol-rotate {\n  top: .5em;\n  right: .5em;\n  transition: opacity .25s linear, visibility 0s linear;\n}\n.ol-rotate.ol-hidden {\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity .25s linear, visibility 0s linear .25s;\n}\n.ol-zoom-extent {\n  top: 4.643em;\n  left: .5em;\n}\n.ol-full-screen {\n  right: .5em;\n  top: .5em;\n}\n\n.ol-control button {\n  display: block;\n  margin: 1px;\n  padding: 0;\n  color: white;\n  font-size: 1.14em;\n  font-weight: bold;\n  text-decoration: none;\n  text-align: center;\n  height: 1.375em;\n  width: 1.375em;\n  line-height: .4em;\n  background-color: rgba(0,60,136,0.5);\n  border: none;\n  border-radius: 2px;\n}\n.ol-control button::-moz-focus-inner {\n  border: none;\n  padding: 0;\n}\n.ol-zoom-extent button {\n  line-height: 1.4em;\n}\n.ol-compass {\n  display: block;\n  font-weight: normal;\n  font-size: 1.2em;\n  will-change: transform;\n}\n.ol-touch .ol-control button {\n  font-size: 1.5em;\n}\n.ol-touch .ol-zoom-extent {\n  top: 5.5em;\n}\n.ol-control button:hover,\n.ol-control button:focus {\n  text-decoration: none;\n  background-color: rgba(0,60,136,0.7);\n}\n.ol-zoom .ol-zoom-in {\n  border-radius: 2px 2px 0 0;\n}\n.ol-zoom .ol-zoom-out {\n  border-radius: 0 0 2px 2px;\n}\n\n\n.ol-attribution {\n  text-align: right;\n  bottom: .5em;\n  right: .5em;\n  max-width: calc(100% - 1.3em);\n  display: flex;\n  flex-flow: row-reverse;\n  align-items: flex-end;\n}\n.ol-attribution ul {\n  margin: 0;\n  padding: 1px .5em;\n  color: #000;\n  text-shadow: 0 0 2px #fff;\n}\n.ol-attribution li {\n  display: inline;\n  list-style: none;\n}\n.ol-attribution li:not(:last-child):after {\n  content: \" \";\n}\n.ol-attribution img {\n  max-height: 2em;\n  max-width: inherit;\n  vertical-align: middle;\n}\n.ol-attribution button {\n  flex-shrink: 0;\n}\n.ol-attribution.ol-collapsed ul {\n  display: none;\n}\n.ol-attribution:not(.ol-collapsed) {\n  background: rgba(255,255,255,0.8);\n}\n.ol-attribution.ol-uncollapsible {\n  bottom: 0;\n  right: 0;\n  border-radius: 4px 0 0;\n}\n.ol-attribution.ol-uncollapsible img {\n  margin-top: -.2em;\n  max-height: 1.6em;\n}\n.ol-attribution.ol-uncollapsible button {\n  display: none;\n}\n\n.ol-zoomslider {\n  top: 4.5em;\n  left: .5em;\n  height: 200px;\n}\n.ol-zoomslider button {\n  position: relative;\n  height: 10px;\n}\n\n.ol-touch .ol-zoomslider {\n  top: 5.5em;\n}\n\n.ol-overviewmap {\n  left: 0.5em;\n  bottom: 0.5em;\n}\n.ol-overviewmap.ol-uncollapsible {\n  bottom: 0;\n  left: 0;\n  border-radius: 0 4px 0 0;\n}\n.ol-overviewmap .ol-overviewmap-map,\n.ol-overviewmap button {\n  display: block;\n}\n.ol-overviewmap .ol-overviewmap-map {\n  border: 1px solid #7b98bc;\n  height: 150px;\n  margin: 2px;\n  width: 150px;\n}\n.ol-overviewmap:not(.ol-collapsed) button {\n  bottom: 2px;\n  left: 2px;\n  position: absolute;\n}\n.ol-overviewmap.ol-collapsed .ol-overviewmap-map,\n.ol-overviewmap.ol-uncollapsible button {\n  display: none;\n}\n.ol-overviewmap:not(.ol-collapsed) {\n  background: rgba(255,255,255,0.8);\n}\n.ol-overviewmap-box {\n  border: 2px dotted rgba(0,60,136,0.7);\n}\n\n.ol-overviewmap .ol-overviewmap-box:hover {\n  cursor: move;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
// eslint-disable-next-line func-names
module.exports = function (useSourceMap) {
  var list = []; // return the list of modules as css string

  list.toString = function toString() {
    return this.map(function (item) {
      var content = cssWithMappingToString(item, useSourceMap);

      if (item[2]) {
        return "@media ".concat(item[2], " {").concat(content, "}");
      }

      return content;
    }).join('');
  }; // import a list of modules into the list
  // eslint-disable-next-line func-names


  list.i = function (modules, mediaQuery, dedupe) {
    if (typeof modules === 'string') {
      // eslint-disable-next-line no-param-reassign
      modules = [[null, modules, '']];
    }

    var alreadyImportedModules = {};

    if (dedupe) {
      for (var i = 0; i < this.length; i++) {
        // eslint-disable-next-line prefer-destructuring
        var id = this[i][0];

        if (id != null) {
          alreadyImportedModules[id] = true;
        }
      }
    }

    for (var _i = 0; _i < modules.length; _i++) {
      var item = [].concat(modules[_i]);

      if (dedupe && alreadyImportedModules[item[0]]) {
        // eslint-disable-next-line no-continue
        continue;
      }

      if (mediaQuery) {
        if (!item[2]) {
          item[2] = mediaQuery;
        } else {
          item[2] = "".concat(mediaQuery, " and ").concat(item[2]);
        }
      }

      list.push(item);
    }
  };

  return list;
};

function cssWithMappingToString(item, useSourceMap) {
  var content = item[1] || ''; // eslint-disable-next-line prefer-destructuring

  var cssMapping = item[3];

  if (!cssMapping) {
    return content;
  }

  if (useSourceMap && typeof btoa === 'function') {
    var sourceMapping = toComment(cssMapping);
    var sourceURLs = cssMapping.sources.map(function (source) {
      return "/*# sourceURL=".concat(cssMapping.sourceRoot || '').concat(source, " */");
    });
    return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
  }

  return [content].join('\n');
} // Adapted from convert-source-map (MIT)


function toComment(sourceMap) {
  // eslint-disable-next-line no-undef
  var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
  var data = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(base64);
  return "/*# ".concat(data, " */");
}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(368);
/* harmony import */ var _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(372);
/* harmony import */ var _node_modules_css_loader_dist_cjs_js_PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_node_modules_css_loader_dist_cjs_js_PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1__);

            

var options = {};

options.insert = "head";
options.singleton = false;

var update = _node_modules_style_loader_dist_runtime_injectStylesIntoStyleTag_js__WEBPACK_IMPORTED_MODULE_0___default()(_node_modules_css_loader_dist_cjs_js_PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1___default.a, options);



/* harmony default export */ __webpack_exports__["default"] = (_node_modules_css_loader_dist_cjs_js_PointCloudVizMap_css__WEBPACK_IMPORTED_MODULE_1___default.a.locals || {});

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

// Imports
var ___CSS_LOADER_API_IMPORT___ = __webpack_require__(370);
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.i, ".ol-popup h3 {\n    margin: 0;\n    display: inline-block;\n    line-height: 22px;\n    margin-bottom: 4px;\n}\n\n.popup-content {\n    text-align: left;\n    overflow: hidden;\n    max-width: 450px;\n    max-height: 400px;\n}\n\ndiv.popup-content > div {\n    max-height: 320px;\n}\n\n.ol-popup {\n    position: absolute;\n    background-color: white;\n    -webkit-filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));\n    filter: drop-shadow(0 1px 4px rgba(0,0,0,0.2));\n    padding: 5px 10px 10px 10px;\n    border: 1px solid #cccccc;\n    bottom: 20px;\n    left: -50px;\n    min-width: 280px;\n    max-width: 450px;\n    -webkit-box-shadow: 0 -2px 25px 0 rgba(0, 0, 0, 0.15), 0 13px 25px 0 rgba(0, 0, 0, 0.3);\n\n    text-align: right;\n    max-height: 400px;\n}\n\n.has-marker {\n    bottom: 60px;\n}\n\n.ol-popup:after, .ol-popup:before {\n    top: 100%;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n}\n.ol-popup:after {\n    border-top-color: white;\n    border-width: 10px;\n    left: 48px;\n    margin-left: -10px;\n}\n.ol-popup:before {\n    border-top-color: #cccccc;\n    border-width: 11px;\n    left: 48px;\n    margin-left: -11px;\n}\n.popup-closer, .popup-max, .popup-closer:hover, .popup-max:hover {\n    text-decoration: none;\n    font-weight: 600;\n    color: #000;\n    background-color: transparent;\n    padding: 0;\n    border: 0;\n}\n.ol-popup .pcviz-icon {\n    font-size: 20px;\n}\n\n.ol-popup img {\n    max-width: 100%;\n}\n\n/* This class locates the zoom controls on the left bottom corner of the widget.\n   Its default location is the top left corner. It was changed to avoid overlaying with the\n   tools of the floating toolbar. Since currently there are no tools in the MapWidget, This\n   is not necessary. Note that Scale indicator is in the left bottom corner.\n   When we support tools in the MapWidget we will need to uncomment and/or modify this class.\n.ol-zoom {\n    top: inherit !important;\n    bottom: .5em;\n}*/\n\n.ol-rotate {\n    top: inherit !important;\n    bottom: 0.5em;\n}\n\n.ol-attribution {\n    display: none !important;\n}\n\n.ol-scale-line {\n    background-color: #007DC5 !important;\n}\n\n.ol-scale-line-inner {\n    color: #eee;\n    border-color: #eee;\n}\n\n.ol-zoom button {\n    color: #eee;\n    font-size: 1.14em;\n}\n\n.ol-control button {\n    background-color: #007DC5 !important;\n}\n\n.ol-control button:hover {\n    background-color: #005C90 !important;\n}\n", ""]);
// Exports
module.exports = exports;


/***/ })
/******/ ]);
});
//# sourceMappingURL=pointcloudviz-map.js.map
!function(e,t){"object"==typeof exports&&"object"==typeof module?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.GeoTIFF=t():e.GeoTIFF=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var i=n[r]={i:r,l:!1,exports:{}};return e[r].call(i.exports,i,i.exports,t),i.l=!0,i.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=66)}([function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(e,t,n){var r=n(39)("wks"),i=n(24),o=n(0).Symbol,a="function"==typeof o;(e.exports=function(e){return r[e]||(r[e]=a&&o[e]||(a?o:i)("Symbol."+e))}).store=r},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(120),i=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,i.default)(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()},function(e,t,n){var r=n(8);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t,n){var r=n(0),i=n(1),o=n(17),a=n(10),s=n(11),u=function(e,t,n){var f,c,l,h=e&u.F,d=e&u.G,p=e&u.S,v=e&u.P,m=e&u.B,y=e&u.W,b=d?i:i[t]||(i[t]={}),g=b.prototype,w=d?r:p?r[t]:(r[t]||{}).prototype;d&&(n=t);for(f in n)(c=!h&&w&&void 0!==w[f])&&s(b,f)||(l=c?w[f]:n[f],b[f]=d&&"function"!=typeof w[f]?n[f]:m&&c?o(l,r):y&&w[f]==l?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(l):v&&"function"==typeof l?o(Function.call,l):l,v&&((b.virtual||(b.virtual={}))[f]=l,e&u.R&&g&&!g[f]&&a(g,f,l)))};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u},function(e,t,n){var r=n(5),i=n(49),o=n(35),a=Object.defineProperty;t.f=n(9)?Object.defineProperty:function(e,t,n){if(r(e),t=o(t,!0),r(n),i)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){e.exports=!n(22)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(7),i=n(23);e.exports=n(9)?function(e,t,n){return r.f(e,t,i(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(31),i=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return!t||"object"!==(void 0===t?"undefined":(0,i.default)(t))&&"function"!=typeof t?e:t}},function(e,t){e.exports={}},function(e,t,n){var r=n(73),i=n(33);e.exports=function(e){return r(i(e))}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(90),o=r(i),a=n(94),s=r(a),u=n(31),f=r(u);t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,f.default)(t)));e.prototype=(0,s.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(o.default?(0,o.default)(e,t):e.__proto__=t)}},function(e,t){e.exports=!0},function(e,t,n){var r=n(21);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,i){return e.call(t,n,r,i)}}return function(){return e.apply(t,arguments)}}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=n(128),f=function(){function e(){(0,o.default)(this,e)}return(0,s.default)(e,[{key:"decode",value:function(e,t){var n=this.decodeBlock(t),r=e.Predictor||1;if(1!==r){var i=!e.StripOffsets,o=i?e.TileWidth:e.ImageWidth,a=i?e.TileLength:e.RowsPerStrip||e.ImageLength;return(0,u.applyPredictor)(n,r,o,a,e.BitsPerSample)}return n}}]),e}();t.default=f},function(e,t,n){"use strict";var r=n(70)(!0);n(48)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){var r=n(7).f,i=n(11),o=n(2)("toStringTag");e.exports=function(e,t,n){e&&!i(e=n?e:e.prototype,o)&&r(e,o,{configurable:!0,value:t})}},function(e,t,n){n(78);for(var r=n(0),i=n(10),o=n(13),a=n(2)("toStringTag"),s="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),u=0;u<s.length;u++){var f=s[u],c=r[f],l=c&&c.prototype;l&&!l[a]&&i(l,a,f),o[f]=o.Array}},function(e,t,n){e.exports=n(97)},function(e,t,n){"use strict";t.__esModule=!0;var r=n(105),i=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){return function(){var t=e.apply(this,arguments);return new i.default(function(e,n){function r(o,a){try{var s=t[o](a),u=s.value}catch(e){return void n(e)}if(!s.done)return i.default.resolve(u).then(function(e){r("next",e)},function(e){r("throw",e)});e(u)}return r("next")})}}},function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var i="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;t.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var n=t.shift();if(n){if("object"!=typeof n)throw new TypeError(n+"must be non-object");for(var i in n)r(n,i)&&(e[i]=n[i])}}return e},t.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var o={arraySet:function(e,t,n,r,i){if(t.subarray&&e.subarray)return void e.set(t.subarray(n,n+r),i);for(var o=0;o<r;o++)e[i+o]=t[n+o]},flattenChunks:function(e){var t,n,r,i,o,a;for(r=0,t=0,n=e.length;t<n;t++)r+=e[t].length;for(a=new Uint8Array(r),i=0,t=0,n=e.length;t<n;t++)o=e[t],a.set(o,i),i+=o.length;return a}},a={arraySet:function(e,t,n,r,i){for(var o=0;o<r;o++)e[i+o]=t[n+o]},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){e?(t.Buf8=Uint8Array,t.Buf16=Uint16Array,t.Buf32=Int32Array,t.assign(t,o)):(t.Buf8=Array,t.Buf16=Array,t.Buf32=Array,t.assign(t,a))},t.setTyped(i)},function(e,t){},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(68),o=r(i),a=n(81),s=r(a),u="function"==typeof s.default&&"symbol"==typeof o.default?function(e){return typeof e}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":typeof e};t.default="function"==typeof s.default&&"symbol"===u(o.default)?function(e){return void 0===e?"undefined":u(e)}:function(e){return e&&"function"==typeof s.default&&e.constructor===s.default&&e!==s.default.prototype?"symbol":void 0===e?"undefined":u(e)}},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e}},function(e,t,n){var r=n(8),i=n(0).document,o=r(i)&&r(i.createElement);e.exports=function(e){return o?i.createElement(e):{}}},function(e,t,n){var r=n(8);e.exports=function(e,t){if(!r(e))return e;var n,i;if(t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;if("function"==typeof(n=e.valueOf)&&!r(i=n.call(e)))return i;if(!t&&"function"==typeof(n=e.toString)&&!r(i=n.call(e)))return i;throw TypeError("Can't convert object to primitive value")}},function(e,t,n){var r=n(5),i=n(72),o=n(40),a=n(38)("IE_PROTO"),s=function(){},u=function(){var e,t=n(34)("iframe"),r=o.length;for(t.style.display="none",n(53).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\/script>"),e.close(),u=e.F;r--;)delete u.prototype[o[r]];return u()};e.exports=Object.create||function(e,t){var n;return null!==e?(s.prototype=r(e),n=new s,s.prototype=null,n[a]=e):n=u(),void 0===t?n:i(n,t)}},function(e,t,n){var r=n(51),i=n(40);e.exports=Object.keys||function(e){return r(e,i)}},function(e,t,n){var r=n(39)("keys"),i=n(24);e.exports=function(e){return r[e]||(r[e]=i(e))}},function(e,t,n){var r=n(1),i=n(0),o=i["__core-js_shared__"]||(i["__core-js_shared__"]={});(e.exports=function(e,t){return o[e]||(o[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n(16)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){t.f=n(2)},function(e,t,n){var r=n(0),i=n(1),o=n(16),a=n(41),s=n(7).f;e.exports=function(e){var t=i.Symbol||(i.Symbol=o?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||s(t,e,{value:a.f(e)})}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var i=n(99),o=r(i),a=n(102),s=r(a);t.default=function(){function e(e,t){var n=[],r=!0,i=!1,o=void 0;try{for(var a,u=(0,s.default)(e);!(r=(a=u.next()).done)&&(n.push(a.value),!t||n.length!==t);r=!0);}catch(e){i=!0,o=e}finally{try{!r&&u.return&&u.return()}finally{if(i)throw o}}return n}return function(t,n){if(Array.isArray(t))return t;if((0,o.default)(Object(t)))return e(t,n);throw new TypeError("Invalid attempt to destructure non-iterable instance")}}()},function(e,t,n){var r=n(18),i=n(2)("toStringTag"),o="Arguments"==r(function(){return arguments}()),a=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,s;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=a(t=Object(e),i))?n:o?r(t):"Object"==(s=r(t))&&"function"==typeof t.callee?"Arguments":s}},function(e,t,n){"use strict";function r(e){var t,n;this.promise=new e(function(e,r){if(void 0!==t||void 0!==n)throw TypeError("Bad Promise constructor");t=e,n=r}),this.resolve=i(t),this.reject=i(n)}var i=n(21);e.exports.f=function(e){return new r(e)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=t.fieldTagNames={315:"Artist",258:"BitsPerSample",265:"CellLength",264:"CellWidth",320:"ColorMap",259:"Compression",33432:"Copyright",306:"DateTime",338:"ExtraSamples",266:"FillOrder",289:"FreeByteCounts",288:"FreeOffsets",291:"GrayResponseCurve",290:"GrayResponseUnit",316:"HostComputer",270:"ImageDescription",257:"ImageLength",256:"ImageWidth",271:"Make",281:"MaxSampleValue",280:"MinSampleValue",272:"Model",254:"NewSubfileType",274:"Orientation",262:"PhotometricInterpretation",284:"PlanarConfiguration",296:"ResolutionUnit",278:"RowsPerStrip",277:"SamplesPerPixel",305:"Software",279:"StripByteCounts",273:"StripOffsets",255:"SubfileType",263:"Threshholding",282:"XResolution",283:"YResolution",326:"BadFaxLines",327:"CleanFaxData",343:"ClipPath",328:"ConsecutiveBadFaxLines",433:"Decode",434:"DefaultImageColor",269:"DocumentName",336:"DotRange",321:"HalftoneHints",346:"Indexed",347:"JPEGTables",285:"PageName",297:"PageNumber",317:"Predictor",319:"PrimaryChromaticities",532:"ReferenceBlackWhite",339:"SampleFormat",340:"SMinSampleValue",341:"SMaxSampleValue",559:"StripRowCounts",330:"SubIFDs",292:"T4Options",293:"T6Options",325:"TileByteCounts",323:"TileLength",324:"TileOffsets",322:"TileWidth",301:"TransferFunction",318:"WhitePoint",344:"XClipPathUnits",286:"XPosition",529:"YCbCrCoefficients",531:"YCbCrPositioning",530:"YCbCrSubSampling",345:"YClipPathUnits",287:"YPosition",37378:"ApertureValue",40961:"ColorSpace",36868:"DateTimeDigitized",36867:"DateTimeOriginal",34665:"Exif IFD",36864:"ExifVersion",33434:"ExposureTime",41728:"FileSource",37385:"Flash",40960:"FlashpixVersion",33437:"FNumber",42016:"ImageUniqueID",37384:"LightSource",37500:"MakerNote",37377:"ShutterSpeedValue",37510:"UserComment",33723:"IPTC",34675:"ICC Profile",700:"XMP",42112:"GDAL_METADATA",42113:"GDAL_NODATA",34377:"Photoshop",33550:"ModelPixelScale",33922:"ModelTiepoint",34264:"ModelTransformation",34735:"GeoKeyDirectory",34736:"GeoDoubleParams",34737:"GeoAsciiParams"},i=t.fieldTags={};for(var o in r)r.hasOwnProperty(o)&&(i[r[o]]=parseInt(o,10));var a=(t.fieldTagTypes={256:"SHORT",257:"SHORT",258:"SHORT",259:"SHORT",262:"SHORT",273:"LONG",274:"SHORT",277:"SHORT",278:"LONG",279:"LONG",282:"RATIONAL",283:"RATIONAL",284:"SHORT",286:"SHORT",287:"RATIONAL",296:"SHORT",305:"ASCII",306:"ASCII",338:"SHORT",339:"SHORT",513:"LONG",514:"LONG",1024:"SHORT",1025:"SHORT",2048:"SHORT",2049:"ASCII",33550:"DOUBLE",33922:"DOUBLE",34665:"LONG",34735:"SHORT",34737:"ASCII",42113:"ASCII"},t.arrayFields=[i.BitsPerSample,i.ExtraSamples,i.SampleFormat,i.StripByteCounts,i.StripOffsets,i.StripRowCounts,i.TileByteCounts,i.TileOffsets],t.fieldTypeNames={1:"BYTE",2:"ASCII",3:"SHORT",4:"LONG",5:"RATIONAL",6:"SBYTE",7:"UNDEFINED",8:"SSHORT",9:"SLONG",10:"SRATIONAL",11:"FLOAT",12:"DOUBLE",16:"LONG8",17:"SLONG8",18:"IFD8"}),s=t.fieldTypes={};for(var u in a)a.hasOwnProperty(u)&&(s[a[u]]=parseInt(u,10));var f=(t.photometricInterpretations={WhiteIsZero:0,BlackIsZero:1,RGB:2,Palette:3,TransparencyMask:4,CMYK:5,YCbCr:6,CIELab:8,ICCLab:9},t.geoKeyNames={1024:"GTModelTypeGeoKey",1025:"GTRasterTypeGeoKey",1026:"GTCitationGeoKey",2048:"GeographicTypeGeoKey",2049:"GeogCitationGeoKey",2050:"GeogGeodeticDatumGeoKey",2051:"GeogPrimeMeridianGeoKey",2052:"GeogLinearUnitsGeoKey",2053:"GeogLinearUnitSizeGeoKey",2054:"GeogAngularUnitsGeoKey",2055:"GeogAngularUnitSizeGeoKey",2056:"GeogEllipsoidGeoKey",2057:"GeogSemiMajorAxisGeoKey",2058:"GeogSemiMinorAxisGeoKey",2059:"GeogInvFlatteningGeoKey",2060:"GeogAzimuthUnitsGeoKey",2061:"GeogPrimeMeridianLongGeoKey",2062:"GeogTOWGS84GeoKey",3072:"ProjectedCSTypeGeoKey",3073:"PCSCitationGeoKey",3074:"ProjectionGeoKey",3075:"ProjCoordTransGeoKey",3076:"ProjLinearUnitsGeoKey",3077:"ProjLinearUnitSizeGeoKey",3078:"ProjStdParallel1GeoKey",3079:"ProjStdParallel2GeoKey",3080:"ProjNatOriginLongGeoKey",3081:"ProjNatOriginLatGeoKey",3082:"ProjFalseEastingGeoKey",3083:"ProjFalseNorthingGeoKey",3084:"ProjFalseOriginLongGeoKey",3085:"ProjFalseOriginLatGeoKey",3086:"ProjFalseOriginEastingGeoKey",3087:"ProjFalseOriginNorthingGeoKey",3088:"ProjCenterLongGeoKey",3089:"ProjCenterLatGeoKey",3090:"ProjCenterEastingGeoKey",3091:"ProjCenterNorthingGeoKey",3092:"ProjScaleAtNatOriginGeoKey",3093:"ProjScaleAtCenterGeoKey",3094:"ProjAzimuthAngleGeoKey",3095:"ProjStraightVertPoleLongGeoKey",3096:"ProjRectifiedGridAngleGeoKey",4096:"VerticalCSTypeGeoKey",4097:"VerticalCitationGeoKey",4098:"VerticalDatumGeoKey",4099:"VerticalUnitsGeoKey"}),c=t.geoKeys={};for(var l in f)f.hasOwnProperty(l)&&(c[f[l]]=parseInt(l,10));t.parseXml=void 0;"undefined"==typeof window?t.parseXml=function(e){return(new(0,n(123).DOMParser)).parseFromString(e,"text/xml")}:void 0!==window.DOMParser?t.parseXml=function(e){return(new window.DOMParser).parseFromString(e,"text/xml")}:void 0!==window.ActiveXObject&&new window.ActiveXObject("Microsoft.XMLDOM")&&(t.parseXml=function(e){var t=new window.ActiveXObject("Microsoft.XMLDOM");return t.async="false",t.loadXML(e),t})},function(e,t,n){"use strict";var r=n(16),i=n(6),o=n(50),a=n(10),s=n(13),u=n(71),f=n(25),c=n(76),l=n(2)("iterator"),h=!([].keys&&"next"in[].keys()),d=function(){return this};e.exports=function(e,t,n,p,v,m,y){u(n,t,p);var b,g,w,_=function(e){if(!h&&e in O)return O[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},x=t+" Iterator",k="values"==v,S=!1,O=e.prototype,E=O[l]||O["@@iterator"]||v&&O[v],T=E||_(v),A=v?k?_("entries"):T:void 0,P="Array"==t?O.entries||E:E;if(P&&(w=c(P.call(new e)))!==Object.prototype&&w.next&&(f(w,x,!0),r||"function"==typeof w[l]||a(w,l,d)),k&&E&&"values"!==E.name&&(S=!0,T=function(){return E.call(this)}),r&&!y||!h&&!S&&O[l]||a(O,l,T),s[t]=T,s[x]=d,v)if(b={values:k?T:_("values"),keys:m?T:_("keys"),entries:A},y)for(g in b)g in O||o(O,g,b[g]);else i(i.P+i.F*(h||S),t,b);return b}},function(e,t,n){e.exports=!n(9)&&!n(22)(function(){return 7!=Object.defineProperty(n(34)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){e.exports=n(10)},function(e,t,n){var r=n(11),i=n(14),o=n(74)(!1),a=n(38)("IE_PROTO");e.exports=function(e,t){var n,s=i(e),u=0,f=[];for(n in s)n!=a&&r(s,n)&&f.push(n);for(;t.length>u;)r(s,n=t[u++])&&(~o(f,n)||f.push(n));return f}},function(e,t,n){var r=n(32),i=Math.min;e.exports=function(e){return e>0?i(r(e),9007199254740991):0}},function(e,t,n){var r=n(0).document;e.exports=r&&r.documentElement},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var r=n(51),i=n(40).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,i)}},function(e,t,n){var r=n(43),i=n(23),o=n(14),a=n(35),s=n(11),u=n(49),f=Object.getOwnPropertyDescriptor;t.f=n(9)?f:function(e,t){if(e=o(e),t=a(t,!0),u)try{return f(e,t)}catch(e){}if(s(e,t))return i(!r.f.call(e,t),e[t])}},function(e,t){},function(e,t,n){var r=n(45),i=n(2)("iterator"),o=n(13);e.exports=n(1).getIteratorMethod=function(e){if(void 0!=e)return e[i]||e["@@iterator"]||o[r(e)]}},function(e,t,n){var r=n(5),i=n(21),o=n(2)("species");e.exports=function(e,t){var n,a=r(e).constructor;return void 0===a||void 0==(n=r(a)[o])?t:i(n)}},function(e,t,n){var r,i,o,a=n(17),s=n(112),u=n(53),f=n(34),c=n(0),l=c.process,h=c.setImmediate,d=c.clearImmediate,p=c.MessageChannel,v=c.Dispatch,m=0,y={},b=function(){var e=+this;if(y.hasOwnProperty(e)){var t=y[e];delete y[e],t()}},g=function(e){b.call(e.data)};h&&d||(h=function(e){for(var t=[],n=1;arguments.length>n;)t.push(arguments[n++]);return y[++m]=function(){s("function"==typeof e?e:Function(e),t)},r(m),m},d=function(e){delete y[e]},"process"==n(18)(l)?r=function(e){l.nextTick(a(b,e,1))}:v&&v.now?r=function(e){v.now(a(b,e,1))}:p?(i=new p,o=i.port2,i.port1.onmessage=g,r=a(o.postMessage,o,1)):c.addEventListener&&"function"==typeof postMessage&&!c.importScripts?(r=function(e){c.postMessage(e+"","*")},c.addEventListener("message",g,!1)):r="onreadystatechange"in f("script")?function(e){u.appendChild(f("script")).onreadystatechange=function(){u.removeChild(this),b.call(e)}}:function(e){setTimeout(a(b,e,1),0)}),e.exports={set:h,clear:d}},function(e,t){e.exports=function(e){try{return{e:!1,v:e()}}catch(e){return{e:!0,v:e}}}},function(e,t,n){var r=n(5),i=n(8),o=n(46);e.exports=function(e,t){if(r(e),i(t)&&t.constructor===e)return t;var n=o.f(e);return(0,n.resolve)(t),n.promise}},function(e,t){function n(e,t){for(var n in e)t[n]=e[n]}function r(e,t){function r(){}var i=e.prototype;if(Object.create){var o=Object.create(t.prototype);i.__proto__=o}i instanceof t||(r.prototype=t.prototype,r=new r,n(i,r),e.prototype=i=r),i.constructor!=e&&("function"!=typeof e&&console.error("unknow Class:"+e),i.constructor=e)}function i(e,t){if(t instanceof Error)var n=t;else n=this,Error.call(this,ie[e]),this.message=ie[e],Error.captureStackTrace&&Error.captureStackTrace(this,i);return n.code=e,t&&(this.message=this.message+": "+t),n}function o(){}function a(e,t){this._node=e,this._refresh=t,s(this)}function s(e){var t=e._node._inc||e._node.ownerDocument._inc;if(e._inc!=t){var r=e._refresh(e._node);G(e,"length",r.length),n(r,e),e._inc=t}}function u(){}function f(e,t){for(var n=e.length;n--;)if(e[n]===t)return n}function c(e,t,n,r){if(r?t[f(t,r)]=n:t[t.length++]=n,e){n.ownerElement=e;var i=e.ownerDocument;i&&(r&&b(i,e,r),y(i,e,n))}}function l(e,t,n){var r=f(t,n);if(!(r>=0))throw i(ae,new Error(e.tagName+"@"+n));for(var o=t.length-1;r<o;)t[r]=t[++r];if(t.length=o,e){var a=e.ownerDocument;a&&(b(a,e,n),n.ownerElement=null)}}function h(e){if(this._features={},e)for(var t in e)this._features=e[t]}function d(){}function p(e){return"<"==e&&"&lt;"||">"==e&&"&gt;"||"&"==e&&"&amp;"||'"'==e&&"&quot;"||"&#"+e.charCodeAt()+";"}function v(e,t){if(t(e))return!0;if(e=e.firstChild)do{if(v(e,t))return!0}while(e=e.nextSibling)}function m(){}function y(e,t,n){e&&e._inc++,"http://www.w3.org/2000/xmlns/"==n.namespaceURI&&(t._nsMap[n.prefix?n.localName:""]=n.value)}function b(e,t,n,r){e&&e._inc++,"http://www.w3.org/2000/xmlns/"==n.namespaceURI&&delete t._nsMap[n.prefix?n.localName:""]}function g(e,t,n){if(e&&e._inc){e._inc++;var r=t.childNodes;if(n)r[r.length++]=n;else{for(var i=t.firstChild,o=0;i;)r[o++]=i,i=i.nextSibling;r.length=o}}}function w(e,t){var n=t.previousSibling,r=t.nextSibling;return n?n.nextSibling=r:e.firstChild=r,r?r.previousSibling=n:e.lastChild=n,g(e.ownerDocument,e),t}function _(e,t,n){var r=t.parentNode;if(r&&r.removeChild(t),t.nodeType===te){var i=t.firstChild;if(null==i)return t;var o=t.lastChild}else i=o=t;var a=n?n.previousSibling:e.lastChild;i.previousSibling=a,o.nextSibling=n,a?a.nextSibling=i:e.firstChild=i,null==n?e.lastChild=o:n.previousSibling=o;do{i.parentNode=e}while(i!==o&&(i=i.nextSibling));return g(e.ownerDocument||e,e),t.nodeType==te&&(t.firstChild=t.lastChild=null),t}function x(e,t){var n=t.parentNode;if(n){var r=e.lastChild;n.removeChild(t);var r=e.lastChild}var r=e.lastChild;return t.parentNode=e,t.previousSibling=r,t.nextSibling=null,r?r.nextSibling=t:e.firstChild=t,e.lastChild=t,g(e.ownerDocument,e,t),t}function k(){this._nsMap={}}function S(){}function O(){}function E(){}function T(){}function A(){}function P(){}function I(){}function N(){}function C(){}function M(){}function D(){}function j(){}function R(e,t){var n=[],r=9==this.nodeType?this.documentElement:this,i=r.prefix,o=r.namespaceURI;if(o&&null==i){var i=r.lookupPrefix(o);if(null==i)var a=[{namespace:o,prefix:null}]}return F(this,n,e,t,a),n.join("")}function L(e,t,n){var r=e.prefix||"",i=e.namespaceURI;if(!r&&!i)return!1;if("xml"===r&&"http://www.w3.org/XML/1998/namespace"===i||"http://www.w3.org/2000/xmlns/"==i)return!1;for(var o=n.length;o--;){var a=n[o];if(a.prefix==r)return a.namespace!=i}return!0}function F(e,t,n,r,i){if(r){if(!(e=r(e)))return;if("string"==typeof e)return void t.push(e)}switch(e.nodeType){case K:i||(i=[]);var o=(i.length,e.attributes),a=o.length,s=e.firstChild,u=e.tagName;n=H===e.namespaceURI||n,t.push("<",u);for(var f=0;f<a;f++){var c=o.item(f);"xmlns"==c.prefix?i.push({prefix:c.localName,namespace:c.value}):"xmlns"==c.nodeName&&i.push({prefix:"",namespace:c.value})}for(var f=0;f<a;f++){var c=o.item(f);if(L(c,n,i)){var l=c.prefix||"",h=c.namespaceURI,d=l?" xmlns:"+l:" xmlns";t.push(d,'="',h,'"'),i.push({prefix:l,namespace:h})}F(c,t,n,r,i)}if(L(e,n,i)){var l=e.prefix||"",h=e.namespaceURI,d=l?" xmlns:"+l:" xmlns";t.push(d,'="',h,'"'),i.push({prefix:l,namespace:h})}if(s||n&&!/^(?:meta|link|img|br|hr|input)$/i.test(u)){if(t.push(">"),n&&/^script$/i.test(u))for(;s;)s.data?t.push(s.data):F(s,t,n,r,i),s=s.nextSibling;else for(;s;)F(s,t,n,r,i),s=s.nextSibling;t.push("</",u,">")}else t.push("/>");return;case Q:case te:for(var s=e.firstChild;s;)F(s,t,n,r,i),s=s.nextSibling;return;case V:return t.push(" ",e.name,'="',e.value.replace(/[<&"]/g,p),'"');case W:return t.push(e.data.replace(/[<&]/g,p));case q:return t.push("<![CDATA[",e.data,"]]>");case J:return t.push("\x3c!--",e.data,"--\x3e");case ee:var v=e.publicId,m=e.systemId;if(t.push("<!DOCTYPE ",e.name),v)t.push(' PUBLIC "',v),m&&"."!=m&&t.push('" "',m),t.push('">');else if(m&&"."!=m)t.push(' SYSTEM "',m,'">');else{var y=e.internalSubset;y&&t.push(" [",y,"]"),t.push(">")}return;case $:return t.push("<?",e.target," ",e.data,"?>");case Y:return t.push("&",e.nodeName,";");default:t.push("??",e.nodeName)}}function U(e,t,n){var r;switch(t.nodeType){case K:r=t.cloneNode(!1),r.ownerDocument=e;case te:break;case V:n=!0}if(r||(r=t.cloneNode(!1)),r.ownerDocument=e,r.parentNode=null,n)for(var i=t.firstChild;i;)r.appendChild(U(e,i,n)),i=i.nextSibling;return r}function B(e,t,n){var r=new t.constructor;for(var i in t){var a=t[i];"object"!=typeof a&&a!=r[i]&&(r[i]=a)}switch(t.childNodes&&(r.childNodes=new o),r.ownerDocument=e,r.nodeType){case K:var s=t.attributes,f=r.attributes=new u,c=s.length;f._ownerElement=r;for(var l=0;l<c;l++)r.setAttributeNode(B(e,s.item(l),!0));break;case V:n=!0}if(n)for(var h=t.firstChild;h;)r.appendChild(B(e,h,n)),h=h.nextSibling;return r}function G(e,t,n){e[t]=n}function Z(e){switch(e.nodeType){case K:case te:var t=[];for(e=e.firstChild;e;)7!==e.nodeType&&8!==e.nodeType&&t.push(Z(e)),e=e.nextSibling;return t.join("");default:return e.nodeValue}}var H="http://www.w3.org/1999/xhtml",z={},K=z.ELEMENT_NODE=1,V=z.ATTRIBUTE_NODE=2,W=z.TEXT_NODE=3,q=z.CDATA_SECTION_NODE=4,Y=z.ENTITY_REFERENCE_NODE=5,X=z.ENTITY_NODE=6,$=z.PROCESSING_INSTRUCTION_NODE=7,J=z.COMMENT_NODE=8,Q=z.DOCUMENT_NODE=9,ee=z.DOCUMENT_TYPE_NODE=10,te=z.DOCUMENT_FRAGMENT_NODE=11,ne=z.NOTATION_NODE=12,re={},ie={},oe=(re.INDEX_SIZE_ERR=(ie[1]="Index size error",1),re.DOMSTRING_SIZE_ERR=(ie[2]="DOMString size error",2),re.HIERARCHY_REQUEST_ERR=(ie[3]="Hierarchy request error",3)),ae=(re.WRONG_DOCUMENT_ERR=(ie[4]="Wrong document",4),re.INVALID_CHARACTER_ERR=(ie[5]="Invalid character",5),re.NO_DATA_ALLOWED_ERR=(ie[6]="No data allowed",6),re.NO_MODIFICATION_ALLOWED_ERR=(ie[7]="No modification allowed",7),re.NOT_FOUND_ERR=(ie[8]="Not found",8)),se=(re.NOT_SUPPORTED_ERR=(ie[9]="Not supported",9),re.INUSE_ATTRIBUTE_ERR=(ie[10]="Attribute in use",10));re.INVALID_STATE_ERR=(ie[11]="Invalid state",11),re.SYNTAX_ERR=(ie[12]="Syntax error",12),re.INVALID_MODIFICATION_ERR=(ie[13]="Invalid modification",13),re.NAMESPACE_ERR=(ie[14]="Invalid namespace",14),re.INVALID_ACCESS_ERR=(ie[15]="Invalid access",15);i.prototype=Error.prototype,n(re,i),o.prototype={length:0,item:function(e){return this[e]||null},toString:function(e,t){for(var n=[],r=0;r<this.length;r++)F(this[r],n,e,t);return n.join("")}},a.prototype.item=function(e){return s(this),this[e]},r(a,o),u.prototype={length:0,item:o.prototype.item,getNamedItem:function(e){for(var t=this.length;t--;){var n=this[t];if(n.nodeName==e)return n}},setNamedItem:function(e){var t=e.ownerElement;if(t&&t!=this._ownerElement)throw new i(se);var n=this.getNamedItem(e.nodeName);return c(this._ownerElement,this,e,n),n},setNamedItemNS:function(e){var t,n=e.ownerElement;if(n&&n!=this._ownerElement)throw new i(se);return t=this.getNamedItemNS(e.namespaceURI,e.localName),c(this._ownerElement,this,e,t),t},removeNamedItem:function(e){var t=this.getNamedItem(e);return l(this._ownerElement,this,t),t},removeNamedItemNS:function(e,t){var n=this.getNamedItemNS(e,t);return l(this._ownerElement,this,n),n},getNamedItemNS:function(e,t){for(var n=this.length;n--;){var r=this[n];if(r.localName==t&&r.namespaceURI==e)return r}return null}},h.prototype={hasFeature:function(e,t){var n=this._features[e.toLowerCase()];return!(!n||t&&!(t in n))},createDocument:function(e,t,n){var r=new m;if(r.implementation=this,r.childNodes=new o,r.doctype=n,n&&r.appendChild(n),t){var i=r.createElementNS(e,t);r.appendChild(i)}return r},createDocumentType:function(e,t,n){var r=new P;return r.name=e,r.nodeName=e,r.publicId=t,r.systemId=n,r}},d.prototype={firstChild:null,lastChild:null,previousSibling:null,nextSibling:null,attributes:null,parentNode:null,childNodes:null,ownerDocument:null,nodeValue:null,namespaceURI:null,prefix:null,localName:null,insertBefore:function(e,t){return _(this,e,t)},replaceChild:function(e,t){this.insertBefore(e,t),t&&this.removeChild(t)},removeChild:function(e){return w(this,e)},appendChild:function(e){return this.insertBefore(e,null)},hasChildNodes:function(){return null!=this.firstChild},cloneNode:function(e){return B(this.ownerDocument||this,this,e)},normalize:function(){for(var e=this.firstChild;e;){var t=e.nextSibling;t&&t.nodeType==W&&e.nodeType==W?(this.removeChild(t),e.appendData(t.data)):(e.normalize(),e=t)}},isSupported:function(e,t){return this.ownerDocument.implementation.hasFeature(e,t)},hasAttributes:function(){return this.attributes.length>0},lookupPrefix:function(e){for(var t=this;t;){var n=t._nsMap;if(n)for(var r in n)if(n[r]==e)return r;t=t.nodeType==V?t.ownerDocument:t.parentNode}return null},lookupNamespaceURI:function(e){for(var t=this;t;){var n=t._nsMap;if(n&&e in n)return n[e];t=t.nodeType==V?t.ownerDocument:t.parentNode}return null},isDefaultNamespace:function(e){return null==this.lookupPrefix(e)}},n(z,d),n(z,d.prototype),m.prototype={nodeName:"#document",nodeType:Q,doctype:null,documentElement:null,_inc:1,insertBefore:function(e,t){if(e.nodeType==te){for(var n=e.firstChild;n;){var r=n.nextSibling;this.insertBefore(n,t),n=r}return e}return null==this.documentElement&&e.nodeType==K&&(this.documentElement=e),_(this,e,t),e.ownerDocument=this,e},removeChild:function(e){return this.documentElement==e&&(this.documentElement=null),w(this,e)},importNode:function(e,t){return U(this,e,t)},getElementById:function(e){var t=null;return v(this.documentElement,function(n){if(n.nodeType==K&&n.getAttribute("id")==e)return t=n,!0}),t},createElement:function(e){var t=new k;return t.ownerDocument=this,t.nodeName=e,t.tagName=e,t.childNodes=new o,(t.attributes=new u)._ownerElement=t,t},createDocumentFragment:function(){var e=new M;return e.ownerDocument=this,e.childNodes=new o,e},createTextNode:function(e){var t=new E;return t.ownerDocument=this,t.appendData(e),t},createComment:function(e){var t=new T;return t.ownerDocument=this,t.appendData(e),t},createCDATASection:function(e){var t=new A;return t.ownerDocument=this,t.appendData(e),t},createProcessingInstruction:function(e,t){var n=new D;return n.ownerDocument=this,n.tagName=n.target=e,n.nodeValue=n.data=t,n},createAttribute:function(e){var t=new S;return t.ownerDocument=this,t.name=e,t.nodeName=e,t.localName=e,t.specified=!0,t},createEntityReference:function(e){var t=new C;return t.ownerDocument=this,t.nodeName=e,t},createElementNS:function(e,t){var n=new k,r=t.split(":"),i=n.attributes=new u;return n.childNodes=new o,n.ownerDocument=this,n.nodeName=t,n.tagName=t,n.namespaceURI=e,2==r.length?(n.prefix=r[0],n.localName=r[1]):n.localName=t,i._ownerElement=n,n},createAttributeNS:function(e,t){var n=new S,r=t.split(":");return n.ownerDocument=this,n.nodeName=t,n.name=t,n.namespaceURI=e,n.specified=!0,2==r.length?(n.prefix=r[0],n.localName=r[1]):n.localName=t,n}},r(m,d),k.prototype={nodeType:K,hasAttribute:function(e){return null!=this.getAttributeNode(e)},getAttribute:function(e){var t=this.getAttributeNode(e);return t&&t.value||""},getAttributeNode:function(e){return this.attributes.getNamedItem(e)},setAttribute:function(e,t){var n=this.ownerDocument.createAttribute(e);n.value=n.nodeValue=""+t,this.setAttributeNode(n)},removeAttribute:function(e){var t=this.getAttributeNode(e);t&&this.removeAttributeNode(t)},appendChild:function(e){return e.nodeType===te?this.insertBefore(e,null):x(this,e)},setAttributeNode:function(e){return this.attributes.setNamedItem(e)},setAttributeNodeNS:function(e){return this.attributes.setNamedItemNS(e)},removeAttributeNode:function(e){return this.attributes.removeNamedItem(e.nodeName)},removeAttributeNS:function(e,t){var n=this.getAttributeNodeNS(e,t);n&&this.removeAttributeNode(n)},hasAttributeNS:function(e,t){return null!=this.getAttributeNodeNS(e,t)},getAttributeNS:function(e,t){var n=this.getAttributeNodeNS(e,t);return n&&n.value||""},setAttributeNS:function(e,t,n){var r=this.ownerDocument.createAttributeNS(e,t);r.value=r.nodeValue=""+n,this.setAttributeNode(r)},getAttributeNodeNS:function(e,t){return this.attributes.getNamedItemNS(e,t)},getElementsByTagName:function(e){return new a(this,function(t){var n=[];return v(t,function(r){r===t||r.nodeType!=K||"*"!==e&&r.tagName!=e||n.push(r)}),n})},getElementsByTagNameNS:function(e,t){return new a(this,function(n){var r=[];return v(n,function(i){i===n||i.nodeType!==K||"*"!==e&&i.namespaceURI!==e||"*"!==t&&i.localName!=t||r.push(i)}),r})}},m.prototype.getElementsByTagName=k.prototype.getElementsByTagName,m.prototype.getElementsByTagNameNS=k.prototype.getElementsByTagNameNS,r(k,d),S.prototype.nodeType=V,r(S,d),O.prototype={data:"",substringData:function(e,t){return this.data.substring(e,e+t)},appendData:function(e){e=this.data+e,this.nodeValue=this.data=e,this.length=e.length},insertData:function(e,t){this.replaceData(e,0,t)},appendChild:function(e){throw new Error(ie[oe])},deleteData:function(e,t){this.replaceData(e,t,"")},replaceData:function(e,t,n){n=this.data.substring(0,e)+n+this.data.substring(e+t),this.nodeValue=this.data=n,this.length=n.length}},r(O,d),E.prototype={nodeName:"#text",nodeType:W,splitText:function(e){var t=this.data,n=t.substring(e);t=t.substring(0,e),this.data=this.nodeValue=t,this.length=t.length;var r=this.ownerDocument.createTextNode(n);return this.parentNode&&this.parentNode.insertBefore(r,this.nextSibling),r}},r(E,O),T.prototype={nodeName:"#comment",nodeType:J},r(T,O),A.prototype={nodeName:"#cdata-section",nodeType:q},r(A,O),P.prototype.nodeType=ee,r(P,d),I.prototype.nodeType=ne,r(I,d),N.prototype.nodeType=X,r(N,d),C.prototype.nodeType=Y,r(C,d),M.prototype.nodeName="#document-fragment",M.prototype.nodeType=te,r(M,d),D.prototype.nodeType=$,r(D,d),j.prototype.serializeToString=function(e,t,n){return R.call(e,t,n)},d.prototype.toString=R;try{Object.defineProperty&&(Object.defineProperty(a.prototype,"length",{get:function(){return s(this),this.$$length}}),Object.defineProperty(d.prototype,"textContent",{get:function(){return Z(this)},set:function(e){switch(this.nodeType){case K:case te:for(;this.firstChild;)this.removeChild(this.firstChild);(e||String(e))&&this.appendChild(this.ownerDocument.createTextNode(e));break;default:this.data=e,this.value=e,this.nodeValue=e}}}),G=function(e,t,n){e["$$"+t]=n})}catch(e){}t.DOMImplementation=h,t.XMLSerializer=j},function(e,t,n){"use strict";function r(e,t){for(var n=e.width,r=e.height,i=new Uint8Array(n*r*3),o=void 0,a=0,s=0;a<e.length;++a,s+=3)o=256-e[a]/t*256,i[s]=o,i[s+1]=o,i[s+2]=o;return i}function i(e,t){for(var n=e.width,r=e.height,i=new Uint8Array(n*r*3),o=void 0,a=0,s=0;a<e.length;++a,s+=3)o=e[a]/t*256,i[s]=o,i[s+1]=o,i[s+2]=o;return i}function o(e,t){for(var n=e.width,r=e.height,i=new Uint8Array(n*r*3),o=t.length/3,a=t.length/3*2,s=0,u=0;s<e.length;++s,u+=3){var f=e[s];i[u]=t[f]/65536*256,i[u+1]=t[f+o]/65536*256,i[u+2]=t[f+a]/65536*256}return i}function a(e){for(var t=e.width,n=e.height,r=new Uint8Array(t*n*3),i=0,o=0;i<e.length;i+=4,o+=3){var a=e[i],s=e[i+1],u=e[i+2],f=e[i+3];r[o]=(255-a)/256*255*((255-f)/256),r[o+1]=(255-s)/256*255*((255-f)/256),r[o+2]=(255-u)/256*255*((255-f)/256)}return r}function s(e){for(var t=e.width,n=e.height,r=new Uint8ClampedArray(t*n*3),i=0,o=0;i<e.length;i+=3,o+=3){var a=e[i],s=e[i+1],u=e[i+2];r[o]=a+1.402*(u-128),r[o+1]=a-.34414*(s-128)-.71414*(u-128),r[o+2]=a+1.772*(s-128)}return r}function u(e){for(var t=e.width,n=e.height,r=new Uint8Array(t*n*3),i=0,o=0;i<e.length;i+=3,o+=3){var a=e[i+0],s=e[i+1]<<24>>24,u=e[i+2]<<24>>24,h=(a+16)/116,d=s/500+h,p=h-u/200,v=void 0,m=void 0,y=void 0;d=f*(d*d*d>.008856?d*d*d:(d-16/116)/7.787),h=c*(h*h*h>.008856?h*h*h:(h-16/116)/7.787),p=l*(p*p*p>.008856?p*p*p:(p-16/116)/7.787),v=3.2406*d+-1.5372*h+-.4986*p,m=-.9689*d+1.8758*h+.0415*p,y=.0557*d+-.204*h+1.057*p,v=v>.0031308?1.055*Math.pow(v,1/2.4)-.055:12.92*v,m=m>.0031308?1.055*Math.pow(m,1/2.4)-.055:12.92*m,y=y>.0031308?1.055*Math.pow(y,1/2.4)-.055:12.92*y,r[o]=255*Math.max(0,Math.min(1,v)),r[o+1]=255*Math.max(0,Math.min(1,m)),r[o+2]=255*Math.max(0,Math.min(1,y))}return r}Object.defineProperty(t,"__esModule",{value:!0}),t.fromWhiteIsZero=r,t.fromBlackIsZero=i,t.fromPalette=o,t.fromCMYK=a,t.fromYCbCr=s,t.fromCIELab=u;var f=.95047,c=1,l=1.08883},function(e,t,n){"use strict";function r(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function i(e,t,n){if(e&&f.isObject(e)&&e instanceof r)return e;var i=new r;return i.parse(e,t,n),i}function o(e){return f.isString(e)&&(e=i(e)),e instanceof r?e.format():r.prototype.format.call(e)}function a(e,t){return i(e,!1,!0).resolve(t)}function s(e,t){return e?i(e,!1,!0).resolveObject(t):t}var u=n(149),f=n(152);t.parse=i,t.resolve=a,t.resolveObject=s,t.format=o,t.Url=r;var c=/^([a-z0-9.+-]+:)/i,l=/:[0-9]*$/,h=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,d=["<",">",'"',"`"," ","\r","\n","\t"],p=["{","}","|","\\","^","`"].concat(d),v=["'"].concat(p),m=["%","/","?",";","#"].concat(v),y=["/","?","#"],b=/^[+a-z0-9A-Z_-]{0,63}$/,g=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,w={javascript:!0,"javascript:":!0},_={javascript:!0,"javascript:":!0},x={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},k=n(153);r.prototype.parse=function(e,t,n){if(!f.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var r=e.indexOf("?"),i=-1!==r&&r<e.indexOf("#")?"?":"#",o=e.split(i),a=/\\/g;o[0]=o[0].replace(a,"/"),e=o.join(i);var s=e;if(s=s.trim(),!n&&1===e.split("#").length){var l=h.exec(s);if(l)return this.path=s,this.href=s,this.pathname=l[1],l[2]?(this.search=l[2],this.query=t?k.parse(this.search.substr(1)):this.search.substr(1)):t&&(this.search="",this.query={}),this}var d=c.exec(s);if(d){d=d[0];var p=d.toLowerCase();this.protocol=p,s=s.substr(d.length)}if(n||d||s.match(/^\/\/[^@\/]+@[^@\/]+/)){var S="//"===s.substr(0,2);!S||d&&_[d]||(s=s.substr(2),this.slashes=!0)}if(!_[d]&&(S||d&&!x[d])){for(var O=-1,E=0;E<y.length;E++){var T=s.indexOf(y[E]);-1!==T&&(-1===O||T<O)&&(O=T)}var A,P;P=-1===O?s.lastIndexOf("@"):s.lastIndexOf("@",O),-1!==P&&(A=s.slice(0,P),s=s.slice(P+1),this.auth=decodeURIComponent(A)),O=-1;for(var E=0;E<m.length;E++){var T=s.indexOf(m[E]);-1!==T&&(-1===O||T<O)&&(O=T)}-1===O&&(O=s.length),this.host=s.slice(0,O),s=s.slice(O),this.parseHost(),this.hostname=this.hostname||"";var I="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!I)for(var N=this.hostname.split(/\./),E=0,C=N.length;E<C;E++){var M=N[E];if(M&&!M.match(b)){for(var D="",j=0,R=M.length;j<R;j++)M.charCodeAt(j)>127?D+="x":D+=M[j];if(!D.match(b)){var L=N.slice(0,E),F=N.slice(E+1),U=M.match(g);U&&(L.push(U[1]),F.unshift(U[2])),F.length&&(s="/"+F.join(".")+s),this.hostname=L.join(".");break}}}this.hostname.length>255?this.hostname="":this.hostname=this.hostname.toLowerCase(),I||(this.hostname=u.toASCII(this.hostname));var B=this.port?":"+this.port:"",G=this.hostname||"";this.host=G+B,this.href+=this.host,I&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==s[0]&&(s="/"+s))}if(!w[p])for(var E=0,C=v.length;E<C;E++){var Z=v[E];if(-1!==s.indexOf(Z)){var H=encodeURIComponent(Z);H===Z&&(H=escape(Z)),s=s.split(Z).join(H)}}var z=s.indexOf("#");-1!==z&&(this.hash=s.substr(z),s=s.slice(0,z));var K=s.indexOf("?");if(-1!==K?(this.search=s.substr(K),this.query=s.substr(K+1),t&&(this.query=k.parse(this.query)),s=s.slice(0,K)):t&&(this.search="",this.query={}),s&&(this.pathname=s),x[p]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var B=this.pathname||"",V=this.search||"";this.path=B+V}return this.href=this.format(),this},r.prototype.format=function(){var e=this.auth||"";e&&(e=encodeURIComponent(e),e=e.replace(/%3A/i,":"),e+="@");var t=this.protocol||"",n=this.pathname||"",r=this.hash||"",i=!1,o="";this.host?i=e+this.host:this.hostname&&(i=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(i+=":"+this.port)),this.query&&f.isObject(this.query)&&Object.keys(this.query).length&&(o=k.stringify(this.query));var a=this.search||o&&"?"+o||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||x[t])&&!1!==i?(i="//"+(i||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):i||(i=""),r&&"#"!==r.charAt(0)&&(r="#"+r),a&&"?"!==a.charAt(0)&&(a="?"+a),n=n.replace(/[?#]/g,function(e){return encodeURIComponent(e)}),a=a.replace("#","%23"),t+i+n+a+r},r.prototype.resolve=function(e){return this.resolveObject(i(e,!1,!0)).format()},r.prototype.resolveObject=function(e){if(f.isString(e)){var t=new r;t.parse(e,!1,!0),e=t}for(var n=new r,i=Object.keys(this),o=0;o<i.length;o++){var a=i[o];n[a]=this[a]}if(n.hash=e.hash,""===e.href)return n.href=n.format(),n;if(e.slashes&&!e.protocol){for(var s=Object.keys(e),u=0;u<s.length;u++){var c=s[u];"protocol"!==c&&(n[c]=e[c])}return x[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(e.protocol&&e.protocol!==n.protocol){if(!x[e.protocol]){for(var l=Object.keys(e),h=0;h<l.length;h++){var d=l[h];n[d]=e[d]}return n.href=n.format(),n}if(n.protocol=e.protocol,e.host||_[e.protocol])n.pathname=e.pathname;else{for(var p=(e.pathname||"").split("/");p.length&&!(e.host=p.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),n.pathname=p.join("/")}if(n.search=e.search,n.query=e.query,n.host=e.host||"",n.auth=e.auth,n.hostname=e.hostname||e.host,n.port=e.port,n.pathname||n.search){var v=n.pathname||"",m=n.search||"";n.path=v+m}return n.slashes=n.slashes||e.slashes,n.href=n.format(),n}var y=n.pathname&&"/"===n.pathname.charAt(0),b=e.host||e.pathname&&"/"===e.pathname.charAt(0),g=b||y||n.host&&e.pathname,w=g,k=n.pathname&&n.pathname.split("/")||[],p=e.pathname&&e.pathname.split("/")||[],S=n.protocol&&!x[n.protocol];if(S&&(n.hostname="",n.port=null,n.host&&(""===k[0]?k[0]=n.host:k.unshift(n.host)),n.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===p[0]?p[0]=e.host:p.unshift(e.host)),e.host=null),g=g&&(""===p[0]||""===k[0])),b)n.host=e.host||""===e.host?e.host:n.host,n.hostname=e.hostname||""===e.hostname?e.hostname:n.hostname,n.search=e.search,n.query=e.query,k=p;else if(p.length)k||(k=[]),k.pop(),k=k.concat(p),n.search=e.search,n.query=e.query;else if(!f.isNullOrUndefined(e.search)){if(S){n.hostname=n.host=k.shift();var O=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@");O&&(n.auth=O.shift(),n.host=n.hostname=O.shift())}return n.search=e.search,n.query=e.query,f.isNull(n.pathname)&&f.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!k.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var E=k.slice(-1)[0],T=(n.host||e.host||k.length>1)&&("."===E||".."===E)||""===E,A=0,P=k.length;P>=0;P--)E=k[P],"."===E?k.splice(P,1):".."===E?(k.splice(P,1),A++):A&&(k.splice(P,1),A--);if(!g&&!w)for(;A--;A)k.unshift("..");!g||""===k[0]||k[0]&&"/"===k[0].charAt(0)||k.unshift(""),T&&"/"!==k.join("/").substr(-1)&&k.push("");var I=""===k[0]||k[0]&&"/"===k[0].charAt(0);if(S){n.hostname=n.host=I?"":k.length?k.shift():"";var O=!!(n.host&&n.host.indexOf("@")>0)&&n.host.split("@");O&&(n.auth=O.shift(),n.host=n.hostname=O.shift())}return g=g||n.host&&k.length,g&&!I&&k.unshift(""),k.length?n.pathname=k.join("/"):(n.pathname=null,n.path=null),f.isNull(n.pathname)&&f.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=e.auth||n.auth,n.slashes=n.slashes||e.slashes,n.href=n.format(),n},r.prototype.parseHost=function(){var e=this.host,t=l.exec(e);t&&(t=t[0],":"!==t&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},function(e,t,n){"use strict";Object.defineProperty(t,"__esModule",{value:!0});var r=n(67);Object.keys(r).forEach(function(e){"default"!==e&&"__esModule"!==e&&Object.defineProperty(t,e,{enumerable:!0,get:function(){return r[e]}})})},function(e,t,n){"use strict";function r(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t.default=e,t}function i(e){return e&&e.__esModule?e:{default:e}}function o(e){switch(e){case x.fieldTypes.BYTE:case x.fieldTypes.ASCII:case x.fieldTypes.SBYTE:case x.fieldTypes.UNDEFINED:return 1;case x.fieldTypes.SHORT:case x.fieldTypes.SSHORT:return 2;case x.fieldTypes.LONG:case x.fieldTypes.SLONG:case x.fieldTypes.FLOAT:return 4;case x.fieldTypes.RATIONAL:case x.fieldTypes.SRATIONAL:case x.fieldTypes.DOUBLE:case x.fieldTypes.LONG8:case x.fieldTypes.SLONG8:case x.fieldTypes.IFD8:return 8;default:throw new RangeError("Invalid field type: "+e)}}function a(e){var t=e.GeoKeyDirectory;if(!t)return null;for(var n={},r=4;r<=4*t[3];r+=4){var i=x.geoKeyNames[t[r]],o=t[r+1]?x.fieldTagNames[t[r+1]]:null,a=t[r+2],s=t[r+3],u=null;if(o){if(void 0===(u=e[o])||null===u)throw new Error("Could not get value of geoKey '"+i+"'.");"string"==typeof u?u=u.substring(s,s+a-1):u.subarray&&(u=u.subarray(s,s+a-1))}else u=s;n[i]=u}return n}function s(e,t,n,r){var i=null,a=null,s=o(t);switch(t){case x.fieldTypes.BYTE:case x.fieldTypes.ASCII:case x.fieldTypes.UNDEFINED:i=new Uint8Array(n),a=e.readUint8;break;case x.fieldTypes.SBYTE:i=new Int8Array(n),a=e.readInt8;break;case x.fieldTypes.SHORT:i=new Uint16Array(n),a=e.readUint16;break;case x.fieldTypes.SSHORT:i=new Int16Array(n),a=e.readInt16;break;case x.fieldTypes.LONG:i=new Uint32Array(n),a=e.readUint32;break;case x.fieldTypes.SLONG:i=new Int32Array(n),a=e.readInt32;break;case x.fieldTypes.LONG8:case x.fieldTypes.IFD8:i=new Array(n),a=e.readUint64;break;case x.fieldTypes.SLONG8:i=new Array(n),a=e.readInt64;break;case x.fieldTypes.RATIONAL:i=new Uint32Array(2*n),a=e.readUint32;break;case x.fieldTypes.SRATIONAL:i=new Int32Array(2*n),a=e.readInt32;break;case x.fieldTypes.FLOAT:i=new Float32Array(n),a=e.readFloat32;break;case x.fieldTypes.DOUBLE:i=new Float64Array(n),a=e.readFloat64;break;default:throw new RangeError("Invalid field type: "+t)}if(t!==x.fieldTypes.RATIONAL&&t!==x.fieldTypes.SRATIONAL)for(var u=0;u<n;++u)i[u]=a.call(e,r+u*s);else for(var f=0;f<n;f+=2)i[f]=a.call(e,r+f*s),i[f+1]=a.call(e,r+(f*s+4));return t===x.fieldTypes.ASCII?String.fromCharCode.apply(null,i):i}Object.defineProperty(t,"__esModule",{value:!0}),t.Pool=t.writeArrayBuffer=t.fromUrls=t.fromBlob=t.fromFile=t.fromArrayBuffer=t.fromUrl=t.MultiGeoTIFF=t.GeoTIFF=t.rgb=t.globals=void 0;var u=n(12),f=i(u),c=n(15),l=i(c),h=n(27),d=i(h),p=n(44),v=i(p),m=n(28),y=i(m),b=n(3),g=i(b),w=n(4),_=i(w),x=(t.fromUrl=function(){var e=(0,y.default)(d.default.mark(function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",L.fromSource((0,I.makeRemoteSource)(t,n)));case 1:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),t.fromArrayBuffer=function(){var e=(0,y.default)(d.default.mark(function e(t){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",L.fromSource((0,I.makeBufferSource)(t)));case 1:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),t.fromFile=function(){var e=(0,y.default)(d.default.mark(function e(t){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",L.fromSource((0,I.makeFileSource)(t)));case 1:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),t.fromBlob=function(){var e=(0,y.default)(d.default.mark(function e(t){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",L.fromSource((0,I.makeFileReaderSource)(t)));case 1:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),t.fromUrls=function(){var e=(0,y.default)(d.default.mark(function e(t){var n,r,i=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,L.fromSource((0,I.makeRemoteSource)(t,o));case 2:return n=e.sent,e.next=5,Promise.all(i.map(function(e){return L.fromSource((0,I.makeRemoteSource)(e,o))}));case 5:return r=e.sent,e.abrupt("return",new F(n,r));case 7:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}(),t.writeArrayBuffer=function(){var e=(0,y.default)(d.default.mark(function e(t,n){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",(0,M.writeGeotiff)(t,n));case 1:case"end":return e.stop()}},e,this)}));return function(t,n){return e.apply(this,arguments)}}(),n(47)),k=r(x),S=n(125),O=i(S),E=n(145),T=i(E),A=n(146),P=i(A),I=n(147),N=n(156),C=i(N),M=n(159),D=n(64),j=r(D);t.globals=k,t.rgb=j;var R=function(){function e(){(0,g.default)(this,e)}return(0,_.default)(e,[{key:"readRasters",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){var t,n,r,i,o,a,s,u,f,c,l,h,p,m,y,b,g,w,_,x,k,S,O,E,T,A,P,I,N,C,M,D,j,R,L,F,U,B,G=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return t=G.window,n=G.width,r=G.height,i=G.resX,o=G.resY,a=G.bbox,e.next=4,this.getImage();case 4:return s=e.sent,u=s,e.next=8,this.getImageCount();case 8:if(f=e.sent,c=s.getBoundingBox(),!t||!a){e.next=12;break}throw new Error('Both "bbox" and "window" passed.');case 12:if(!n&&!r){e.next=23;break}if(t&&(l=s.getOrigin(),h=(0,v.default)(l,2),p=h[0],m=h[1],y=s.getResolution(),b=(0,v.default)(y,2),g=b[0],w=b[1],a=[p+t[0]*g,m+t[1]*w,p+t[2]*g,m+t[3]*w]),_=a||c,!n){e.next=19;break}if(!i){e.next=18;break}throw new Error("Both width and resX passed");case 18:i=(_[2]-_[0])/n;case 19:if(!r){e.next=23;break}if(!o){e.next=22;break}throw new Error("Both width and resY passed");case 22:o=(_[3]-_[1])/r;case 23:if(!i&&!o){e.next=47;break}x=[],k=0;case 26:if(!(k<f)){e.next=35;break}return e.next=29,this.getImage(k);case 29:S=e.sent,O=S.fileDirectory,E=O.SubfileType,T=O.NewSubfileType,(0===k||2===E||1&T)&&x.push(S);case 32:++k,e.next=26;break;case 35:x.sort(function(e,t){return e.getWidth()-t.getWidth()}),A=0;case 37:if(!(A<x.length)){e.next=47;break}if(P=x[A],I=(c[2]-c[0])/P.getWidth(),N=(c[3]-c[1])/P.getHeight(),u=P,!(i&&i>I||o&&o>N)){e.next=44;break}return e.abrupt("break",47);case 44:++A,e.next=37;break;case 47:return C=t,a&&(M=s.getOrigin(),D=(0,v.default)(M,2),j=D[0],R=D[1],L=u.getResolution(s),F=(0,v.default)(L,2),U=F[0],B=F[1],C=[Math.round((a[0]-j)/U),Math.round((a[1]-R)/B),Math.round((a[2]-j)/U),Math.round((a[3]-R)/B)],C=[Math.min(C[0],C[2]),Math.min(C[1],C[3]),Math.max(C[0],C[2]),Math.max(C[1],C[3])]),e.abrupt("return",u.readRasters(Object.assign({},G,{window:C})));case 50:case"end":return e.stop()}},e,this)}));return e}()}]),e}(),L=function(e){function t(e,n,r,i){var o=arguments.length>4&&void 0!==arguments[4]?arguments[4]:{};(0,g.default)(this,t);var a=(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return a.source=e,a.littleEndian=n,a.bigTiff=r,a.firstIFDOffset=i,a.cache=o.cache||!1,a.fileDirectories=null,a.fileDirectoriesParsing=null,a}return(0,l.default)(t,e),(0,_.default)(t,[{key:"getSlice",value:function(){function e(e,n){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(t,n){var r;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return r=this.bigTiff?4048:1024,e.t0=P.default,e.next=4,this.source.fetch(t,void 0!==n?n:r);case 4:return e.t1=e.sent,e.t2=t,e.t3=this.littleEndian,e.t4=this.bigTiff,e.abrupt("return",new e.t0(e.t1,e.t2,e.t3,e.t4));case 9:case"end":return e.stop()}},e,this)}));return e}()},{key:"parseFileDirectories",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){var t,n,r,i,u,f,c,l,h,p,v,m,y,b,g,w,_,k,S,O;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:t=this.firstIFDOffset,n=this.bigTiff?8:2,r=this.bigTiff?20:12,i=[];case 4:if(0===t){e.next=48;break}return e.next=7,this.getSlice(t);case 7:if(u=e.sent,f=this.bigTiff?u.readUint64(t):u.readUint16(t),c=f*r+(this.bigTiff?16:6),u.covers(t,c)){e.next=14;break}return e.next=13,this.getSlice(t,c);case 13:u=e.sent;case 14:l={},h=t+(this.bigTiff?8:2),p=0;case 17:if(!(p<f)){e.next=44;break}if(v=u.readUint16(h),m=u.readUint16(h+2),y=this.bigTiff?u.readUint64(h+4):u.readUint32(h+4),b=void 0,g=void 0,w=o(m),_=h+(this.bigTiff?12:8),!(w*y<=(this.bigTiff?8:4))){e.next=29;break}b=s(u,m,y,_),e.next=39;break;case 29:if(k=u.readOffset(_),S=o(m)*y,!u.covers(k,S)){e.next=35;break}b=s(u,m,y,k),e.next=39;break;case 35:return e.next=37,this.getSlice(k,S);case 37:O=e.sent,b=s(O,m,y,k);case 39:g=1===y&&-1===x.arrayFields.indexOf(v)&&m!==x.fieldTypes.RATIONAL&&m!==x.fieldTypes.SRATIONAL?b[0]:b,l[x.fieldTagNames[v]]=g;case 41:h+=r,++p,e.next=17;break;case 44:i.push([l,a(l)]),t=u.readOffset(t+n+r*f),e.next=4;break;case 48:return e.abrupt("return",i);case 49:case"end":return e.stop()}},e,this)}));return e}()},{key:"getImage",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){var t,n=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(this.fileDirectories){e.next=5;break}return this.fileDirectoriesParsing||(this.fileDirectoriesParsing=this.parseFileDirectories()),e.next=4,this.fileDirectoriesParsing;case 4:this.fileDirectories=e.sent;case 5:if(t=this.fileDirectories[n]){e.next=8;break}throw new RangeError("Invalid image index");case 8:return e.abrupt("return",new O.default(t[0],t[1],this.dataView,this.littleEndian,this.cache,this.source));case 9:case"end":return e.stop()}},e,this)}));return e}()},{key:"getImageCount",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(this.fileDirectories){e.next=5;break}return this.fileDirectoriesParsing||(this.fileDirectoriesParsing=this.parseFileDirectories()),e.next=4,this.fileDirectoriesParsing;case 4:this.fileDirectories=e.sent;case 5:return e.abrupt("return",this.fileDirectories.length);case 6:case"end":return e.stop()}},e,this)}));return e}()}],[{key:"fromSource",value:function(){function e(e,t){return n.apply(this,arguments)}var n=(0,y.default)(d.default.mark(function e(n,r){var i,o,a,s,u,f,c,l;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,n.fetch(0,1024);case 2:if(i=e.sent,o=new T.default(i),a=o.getUint16(0,0),s=void 0,18761!==a){e.next=10;break}s=!0,e.next=15;break;case 10:if(19789!==a){e.next=14;break}s=!1,e.next=15;break;case 14:throw new TypeError("Invalid byte order value.");case 15:if(u=o.getUint16(2,s),f=void 0,42!==u){e.next=21;break}f=!1,e.next=29;break;case 21:if(43!==u){e.next=28;break}if(f=!0,8===(c=o.getUint16(4,s))){e.next=26;break}throw new Error("Unsupported offset byte-size.");case 26:e.next=29;break;case 28:throw new TypeError("Invalid magic number.");case 29:return l=f?o.getUint64(8,s):o.getUint32(4,s),e.abrupt("return",new t(n,s,f,l,r));case 31:case"end":return e.stop()}},e,this)}));return e}()}]),t}(R);t.GeoTIFF=L,t.default=L;var F=function(e){function t(e,n){(0,g.default)(this,t);var r=(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return r.mainFile=e,r.overviewFiles=n,r.imageFiles=[e].concat(n),r.fileDirectoriesPerFile=null,r.fileDirectoriesPerFileParsing=null,r.imageCount=null,r}return(0,l.default)(t,e),(0,_.default)(t,[{key:"parseFileDirectoriesPerFile",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){var t;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return t=[this.mainFile.parseFileDirectories()].concat(this.overviewFiles.map(function(e){return e.parseFileDirectories()})),e.next=3,Promise.all(t);case 3:return this.fileDirectoriesPerFile=e.sent,e.abrupt("return",this.fileDirectoriesPerFile);case 5:case"end":return e.stop()}},e,this)}));return e}()},{key:"getImage",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){var t,n,r,i,o=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(this.fileDirectoriesPerFile){e.next=5;break}return this.fileDirectoriesPerFileParsing||(this.fileDirectoriesPerFileParsing=this.parseFileDirectoriesPerFile()),e.next=4,this.fileDirectoriesPerFileParsing;case 4:this.fileDirectoriesPerFile=e.sent;case 5:t=o,n=0;case 7:if(!(n<this.fileDirectoriesPerFile.length)){e.next=16;break}if(r=this.fileDirectoriesPerFile[n],!(t<r.length)){e.next=12;break}return i=this.imageFiles[n],e.abrupt("return",new O.default(r[t][0],r[t][1],i.dataView,i.littleEndian,i.cache,i.source));case 12:t-=r.length;case 13:++n,e.next=7;break;case 16:throw new RangeError("Invalid image index");case 17:case"end":return e.stop()}},e,this)}));return e}()},{key:"getImageCount",value:function(){function e(){return t.apply(this,arguments)}var t=(0,y.default)(d.default.mark(function e(){return d.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(this.fileDirectoriesPerFile){e.next=5;break}return this.fileDirectoriesPerFileParsing||(this.fileDirectoriesPerFileParsing=this.parseFileDirectoriesPerFile()),e.next=4,this.fileDirectoriesPerFileParsing;case 4:this.fileDirectoriesPerFile=e.sent;case 5:return e.abrupt("return",this.fileDirectoriesPerFile.reduce(function(e,t){return e+t.length},0));case 6:case"end":return e.stop()}},e,this)}));return e}()}]),t}(R);t.MultiGeoTIFF=F,t.Pool=C.default},function(e,t,n){e.exports={default:n(69),__esModule:!0}},function(e,t,n){n(20),n(26),e.exports=n(41).f("iterator")},function(e,t,n){var r=n(32),i=n(33);e.exports=function(e){return function(t,n){var o,a,s=String(i(t)),u=r(n),f=s.length;return u<0||u>=f?e?"":void 0:(o=s.charCodeAt(u),o<55296||o>56319||u+1===f||(a=s.charCodeAt(u+1))<56320||a>57343?e?s.charAt(u):o:e?s.slice(u,u+2):a-56320+(o-55296<<10)+65536)}}},function(e,t,n){"use strict";var r=n(36),i=n(23),o=n(25),a={};n(10)(a,n(2)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:i(1,n)}),o(e,t+" Iterator")}},function(e,t,n){var r=n(7),i=n(5),o=n(37);e.exports=n(9)?Object.defineProperties:function(e,t){i(e);for(var n,a=o(t),s=a.length,u=0;s>u;)r.f(e,n=a[u++],t[n]);return e}},function(e,t,n){var r=n(18);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(14),i=n(52),o=n(75);e.exports=function(e){return function(t,n,a){var s,u=r(t),f=i(u.length),c=o(a,f);if(e&&n!=n){for(;f>c;)if((s=u[c++])!=s)return!0}else for(;f>c;c++)if((e||c in u)&&u[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(32),i=Math.max,o=Math.min;e.exports=function(e,t){return e=r(e),e<0?i(e+t,0):o(e,t)}},function(e,t,n){var r=n(11),i=n(77),o=n(38)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=i(e),r(e,o)?e[o]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){var r=n(33);e.exports=function(e){return Object(r(e))}},function(e,t,n){"use strict";var r=n(79),i=n(80),o=n(13),a=n(14);e.exports=n(48)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,i(1)):"keys"==t?i(0,n):"values"==t?i(0,e[n]):i(0,[n,e[n]])},"values"),o.Arguments=o.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(82),__esModule:!0}},function(e,t,n){n(83),n(57),n(88),n(89),e.exports=n(1).Symbol},function(e,t,n){"use strict";var r=n(0),i=n(11),o=n(9),a=n(6),s=n(50),u=n(84).KEY,f=n(22),c=n(39),l=n(25),h=n(24),d=n(2),p=n(41),v=n(42),m=n(85),y=n(86),b=n(5),g=n(8),w=n(14),_=n(35),x=n(23),k=n(36),S=n(87),O=n(56),E=n(7),T=n(37),A=O.f,P=E.f,I=S.f,N=r.Symbol,C=r.JSON,M=C&&C.stringify,D=d("_hidden"),j=d("toPrimitive"),R={}.propertyIsEnumerable,L=c("symbol-registry"),F=c("symbols"),U=c("op-symbols"),B=Object.prototype,G="function"==typeof N,Z=r.QObject,H=!Z||!Z.prototype||!Z.prototype.findChild,z=o&&f(function(){return 7!=k(P({},"a",{get:function(){return P(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=A(B,t);r&&delete B[t],P(e,t,n),r&&e!==B&&P(B,t,r)}:P,K=function(e){var t=F[e]=k(N.prototype);return t._k=e,t},V=G&&"symbol"==typeof N.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof N},W=function(e,t,n){return e===B&&W(U,t,n),b(e),t=_(t,!0),b(n),i(F,t)?(n.enumerable?(i(e,D)&&e[D][t]&&(e[D][t]=!1),n=k(n,{enumerable:x(0,!1)})):(i(e,D)||P(e,D,x(1,{})),e[D][t]=!0),z(e,t,n)):P(e,t,n)},q=function(e,t){b(e);for(var n,r=m(t=w(t)),i=0,o=r.length;o>i;)W(e,n=r[i++],t[n]);return e},Y=function(e,t){return void 0===t?k(e):q(k(e),t)},X=function(e){var t=R.call(this,e=_(e,!0));return!(this===B&&i(F,e)&&!i(U,e))&&(!(t||!i(this,e)||!i(F,e)||i(this,D)&&this[D][e])||t)},$=function(e,t){if(e=w(e),t=_(t,!0),e!==B||!i(F,t)||i(U,t)){var n=A(e,t);return!n||!i(F,t)||i(e,D)&&e[D][t]||(n.enumerable=!0),n}},J=function(e){for(var t,n=I(w(e)),r=[],o=0;n.length>o;)i(F,t=n[o++])||t==D||t==u||r.push(t);return r},Q=function(e){for(var t,n=e===B,r=I(n?U:w(e)),o=[],a=0;r.length>a;)!i(F,t=r[a++])||n&&!i(B,t)||o.push(F[t]);return o};G||(N=function(){if(this instanceof N)throw TypeError("Symbol is not a constructor!");var e=h(arguments.length>0?arguments[0]:void 0),t=function(n){this===B&&t.call(U,n),i(this,D)&&i(this[D],e)&&(this[D][e]=!1),z(this,e,x(1,n))};return o&&H&&z(B,e,{configurable:!0,set:t}),K(e)},s(N.prototype,"toString",function(){return this._k}),O.f=$,E.f=W,n(55).f=S.f=J,n(43).f=X,n(54).f=Q,o&&!n(16)&&s(B,"propertyIsEnumerable",X,!0),p.f=function(e){return K(d(e))}),a(a.G+a.W+a.F*!G,{Symbol:N});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)d(ee[te++]);for(var ne=T(d.store),re=0;ne.length>re;)v(ne[re++]);a(a.S+a.F*!G,"Symbol",{for:function(e){return i(L,e+="")?L[e]:L[e]=N(e)},keyFor:function(e){if(!V(e))throw TypeError(e+" is not a symbol!");for(var t in L)if(L[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),a(a.S+a.F*!G,"Object",{create:Y,defineProperty:W,defineProperties:q,getOwnPropertyDescriptor:$,getOwnPropertyNames:J,getOwnPropertySymbols:Q}),C&&a(a.S+a.F*(!G||f(function(){var e=N();return"[null]"!=M([e])||"{}"!=M({a:e})||"{}"!=M(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],i=1;arguments.length>i;)r.push(arguments[i++]);if(n=t=r[1],(g(t)||void 0!==e)&&!V(e))return y(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!V(t))return t}),r[1]=t,M.apply(C,r)}}),N.prototype[j]||n(10)(N.prototype,j,N.prototype.valueOf),l(N,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(e,t,n){var r=n(24)("meta"),i=n(8),o=n(11),a=n(7).f,s=0,u=Object.isExtensible||function(){return!0},f=!n(22)(function(){return u(Object.preventExtensions({}))}),c=function(e){a(e,r,{value:{i:"O"+ ++s,w:{}}})},l=function(e,t){if(!i(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!o(e,r)){if(!u(e))return"F";if(!t)return"E";c(e)}return e[r].i},h=function(e,t){if(!o(e,r)){if(!u(e))return!0;if(!t)return!1;c(e)}return e[r].w},d=function(e){return f&&p.NEED&&u(e)&&!o(e,r)&&c(e),e},p=e.exports={KEY:r,NEED:!1,fastKey:l,getWeak:h,onFreeze:d}},function(e,t,n){var r=n(37),i=n(54),o=n(43);e.exports=function(e){var t=r(e),n=i.f;if(n)for(var a,s=n(e),u=o.f,f=0;s.length>f;)u.call(e,a=s[f++])&&t.push(a);return t}},function(e,t,n){var r=n(18);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(14),i=n(55).f,o={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],s=function(e){try{return i(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==o.call(e)?s(e):i(r(e))}},function(e,t,n){n(42)("asyncIterator")},function(e,t,n){n(42)("observable")},function(e,t,n){e.exports={default:n(91),__esModule:!0}},function(e,t,n){n(92),e.exports=n(1).Object.setPrototypeOf},function(e,t,n){var r=n(6);r(r.S,"Object",{setPrototypeOf:n(93).set})},function(e,t,n){var r=n(8),i=n(5),o=function(e,t){if(i(e),!r(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n(17)(Function.call,n(56).f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return o(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:o}},function(e,t,n){e.exports={default:n(95),__esModule:!0}},function(e,t,n){n(96);var r=n(1).Object;e.exports=function(e,t){return r.create(e,t)}},function(e,t,n){var r=n(6);r(r.S,"Object",{create:n(36)})},function(e,t,n){var r=function(){return this}()||Function("return this")(),i=r.regeneratorRuntime&&Object.getOwnPropertyNames(r).indexOf("regeneratorRuntime")>=0,o=i&&r.regeneratorRuntime;if(r.regeneratorRuntime=void 0,e.exports=n(98),i)r.regeneratorRuntime=o;else try{delete r.regeneratorRuntime}catch(e){r.regeneratorRuntime=void 0}},function(e,t){!function(t){"use strict";function n(e,t,n,r){var o=t&&t.prototype instanceof i?t:i,a=Object.create(o.prototype),s=new d(r||[]);return a._invoke=f(e,n,s),a}function r(e,t,n){try{return{type:"normal",arg:e.call(t,n)}}catch(e){return{type:"throw",arg:e}}}function i(){}function o(){}function a(){}function s(e){["next","throw","return"].forEach(function(t){e[t]=function(e){return this._invoke(t,e)}})}function u(e){function t(n,i,o,a){var s=r(e[n],e,i);if("throw"!==s.type){var u=s.arg,f=u.value;return f&&"object"==typeof f&&b.call(f,"__await")?Promise.resolve(f.__await).then(function(e){t("next",e,o,a)},function(e){t("throw",e,o,a)}):Promise.resolve(f).then(function(e){u.value=e,o(u)},a)}a(s.arg)}function n(e,n){function r(){return new Promise(function(r,i){t(e,n,r,i)})}return i=i?i.then(r,r):r()}var i;this._invoke=n}function f(e,t,n){var i=O;return function(o,a){if(i===T)throw new Error("Generator is already running");if(i===A){if("throw"===o)throw a;return v()}for(n.method=o,n.arg=a;;){var s=n.delegate;if(s){var u=c(s,n);if(u){if(u===P)continue;return u}}if("next"===n.method)n.sent=n._sent=n.arg;else if("throw"===n.method){if(i===O)throw i=A,n.arg;n.dispatchException(n.arg)}else"return"===n.method&&n.abrupt("return",n.arg);i=T;var f=r(e,t,n);if("normal"===f.type){if(i=n.done?A:E,f.arg===P)continue;return{value:f.arg,done:n.done}}"throw"===f.type&&(i=A,n.method="throw",n.arg=f.arg)}}}function c(e,t){var n=e.iterator[t.method];if(n===m){if(t.delegate=null,"throw"===t.method){if(e.iterator.return&&(t.method="return",t.arg=m,c(e,t),"throw"===t.method))return P;t.method="throw",t.arg=new TypeError("The iterator does not provide a 'throw' method")}return P}var i=r(n,e.iterator,t.arg);if("throw"===i.type)return t.method="throw",t.arg=i.arg,t.delegate=null,P;var o=i.arg;return o?o.done?(t[e.resultName]=o.value,t.next=e.nextLoc,"return"!==t.method&&(t.method="next",t.arg=m),t.delegate=null,P):o:(t.method="throw",t.arg=new TypeError("iterator result is not an object"),t.delegate=null,P)}function l(e){var t={tryLoc:e[0]};1 in e&&(t.catchLoc=e[1]),2 in e&&(t.finallyLoc=e[2],t.afterLoc=e[3]),this.tryEntries.push(t)}function h(e){var t=e.completion||{};t.type="normal",delete t.arg,e.completion=t}function d(e){this.tryEntries=[{tryLoc:"root"}],e.forEach(l,this),this.reset(!0)}function p(e){if(e){var t=e[w];if(t)return t.call(e);if("function"==typeof e.next)return e;if(!isNaN(e.length)){var n=-1,r=function t(){for(;++n<e.length;)if(b.call(e,n))return t.value=e[n],t.done=!1,t;return t.value=m,t.done=!0,t};return r.next=r}}return{next:v}}function v(){return{value:m,done:!0}}var m,y=Object.prototype,b=y.hasOwnProperty,g="function"==typeof Symbol?Symbol:{},w=g.iterator||"@@iterator",_=g.asyncIterator||"@@asyncIterator",x=g.toStringTag||"@@toStringTag",k="object"==typeof e,S=t.regeneratorRuntime;if(S)return void(k&&(e.exports=S));S=t.regeneratorRuntime=k?e.exports:{},S.wrap=n;var O="suspendedStart",E="suspendedYield",T="executing",A="completed",P={},I={};I[w]=function(){return this};var N=Object.getPrototypeOf,C=N&&N(N(p([])));C&&C!==y&&b.call(C,w)&&(I=C);var M=a.prototype=i.prototype=Object.create(I);o.prototype=M.constructor=a,a.constructor=o,a[x]=o.displayName="GeneratorFunction",S.isGeneratorFunction=function(e){var t="function"==typeof e&&e.constructor;return!!t&&(t===o||"GeneratorFunction"===(t.displayName||t.name))},S.mark=function(e){return Object.setPrototypeOf?Object.setPrototypeOf(e,a):(e.__proto__=a,x in e||(e[x]="GeneratorFunction")),e.prototype=Object.create(M),e},S.awrap=function(e){return{__await:e}},s(u.prototype),u.prototype[_]=function(){return this},S.AsyncIterator=u,S.async=function(e,t,r,i){var o=new u(n(e,t,r,i));return S.isGeneratorFunction(t)?o:o.next().then(function(e){return e.done?e.value:o.next()})},s(M),M[x]="Generator",M[w]=function(){return this},M.toString=function(){return"[object Generator]"},S.keys=function(e){var t=[];for(var n in e)t.push(n);return t.reverse(),function n(){for(;t.length;){var r=t.pop();if(r in e)return n.value=r,n.done=!1,n}return n.done=!0,n}},S.values=p,d.prototype={constructor:d,reset:function(e){if(this.prev=0,this.next=0,this.sent=this._sent=m,this.done=!1,this.delegate=null,this.method="next",this.arg=m,this.tryEntries.forEach(h),!e)for(var t in this)"t"===t.charAt(0)&&b.call(this,t)&&!isNaN(+t.slice(1))&&(this[t]=m)},stop:function(){this.done=!0;var e=this.tryEntries[0],t=e.completion;if("throw"===t.type)throw t.arg;return this.rval},dispatchException:function(e){function t(t,r){return o.type="throw",o.arg=e,n.next=t,r&&(n.method="next",n.arg=m),!!r}if(this.done)throw e;for(var n=this,r=this.tryEntries.length-1;r>=0;--r){var i=this.tryEntries[r],o=i.completion;if("root"===i.tryLoc)return t("end");if(i.tryLoc<=this.prev){var a=b.call(i,"catchLoc"),s=b.call(i,"finallyLoc");if(a&&s){if(this.prev<i.catchLoc)return t(i.catchLoc,!0);if(this.prev<i.finallyLoc)return t(i.finallyLoc)}else if(a){if(this.prev<i.catchLoc)return t(i.catchLoc,!0)}else{if(!s)throw new Error("try statement without catch or finally");if(this.prev<i.finallyLoc)return t(i.finallyLoc)}}}},abrupt:function(e,t){for(var n=this.tryEntries.length-1;n>=0;--n){var r=this.tryEntries[n];if(r.tryLoc<=this.prev&&b.call(r,"finallyLoc")&&this.prev<r.finallyLoc){var i=r;break}}i&&("break"===e||"continue"===e)&&i.tryLoc<=t&&t<=i.finallyLoc&&(i=null);var o=i?i.completion:{};return o.type=e,o.arg=t,i?(this.method="next",this.next=i.finallyLoc,P):this.complete(o)},complete:function(e,t){if("throw"===e.type)throw e.arg;return"break"===e.type||"continue"===e.type?this.next=e.arg:"return"===e.type?(this.rval=this.arg=e.arg,this.method="return",this.next="end"):"normal"===e.type&&t&&(this.next=t),P},finish:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.finallyLoc===e)return this.complete(n.completion,n.afterLoc),h(n),P}},catch:function(e){for(var t=this.tryEntries.length-1;t>=0;--t){var n=this.tryEntries[t];if(n.tryLoc===e){var r=n.completion;if("throw"===r.type){var i=r.arg;h(n)}return i}}throw new Error("illegal catch attempt")},delegateYield:function(e,t,n){return this.delegate={iterator:p(e),resultName:t,nextLoc:n},"next"===this.method&&(this.arg=m),P}}}(function(){return this}()||Function("return this")())},function(e,t,n){e.exports={default:n(100),__esModule:!0}},function(e,t,n){n(26),n(20),e.exports=n(101)},function(e,t,n){var r=n(45),i=n(2)("iterator"),o=n(13);e.exports=n(1).isIterable=function(e){var t=Object(e);return void 0!==t[i]||"@@iterator"in t||o.hasOwnProperty(r(t))}},function(e,t,n){e.exports={default:n(103),__esModule:!0}},function(e,t,n){n(26),n(20),e.exports=n(104)},function(e,t,n){var r=n(5),i=n(58);e.exports=n(1).getIterator=function(e){var t=i(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return r(t.call(e))}},function(e,t,n){e.exports={default:n(106),__esModule:!0}},function(e,t,n){n(57),n(20),n(26),n(107),n(118),n(119),e.exports=n(1).Promise},function(e,t,n){"use strict";var r,i,o,a,s=n(16),u=n(0),f=n(17),c=n(45),l=n(6),h=n(8),d=n(21),p=n(108),v=n(109),m=n(59),y=n(60).set,b=n(113)(),g=n(46),w=n(61),_=n(114),x=n(62),k=u.TypeError,S=u.process,O=S&&S.versions,E=O&&O.v8||"",T=u.Promise,A="process"==c(S),P=function(){},I=i=g.f,N=!!function(){try{var e=T.resolve(1),t=(e.constructor={})[n(2)("species")]=function(e){e(P,P)};return(A||"function"==typeof PromiseRejectionEvent)&&e.then(P)instanceof t&&0!==E.indexOf("6.6")&&-1===_.indexOf("Chrome/66")}catch(e){}}(),C=function(e){var t;return!(!h(e)||"function"!=typeof(t=e.then))&&t},M=function(e,t){if(!e._n){e._n=!0;var n=e._c;b(function(){for(var r=e._v,i=1==e._s,o=0;n.length>o;)!function(t){var n,o,a,s=i?t.ok:t.fail,u=t.resolve,f=t.reject,c=t.domain;try{s?(i||(2==e._h&&R(e),e._h=1),!0===s?n=r:(c&&c.enter(),n=s(r),c&&(c.exit(),a=!0)),n===t.promise?f(k("Promise-chain cycle")):(o=C(n))?o.call(n,u,f):u(n)):f(r)}catch(e){c&&!a&&c.exit(),f(e)}}(n[o++]);e._c=[],e._n=!1,t&&!e._h&&D(e)})}},D=function(e){y.call(u,function(){var t,n,r,i=e._v,o=j(e);if(o&&(t=w(function(){A?S.emit("unhandledRejection",i,e):(n=u.onunhandledrejection)?n({promise:e,reason:i}):(r=u.console)&&r.error&&r.error("Unhandled promise rejection",i)}),e._h=A||j(e)?2:1),e._a=void 0,o&&t.e)throw t.v})},j=function(e){return 1!==e._h&&0===(e._a||e._c).length},R=function(e){y.call(u,function(){var t;A?S.emit("rejectionHandled",e):(t=u.onrejectionhandled)&&t({promise:e,reason:e._v})})},L=function(e){var t=this;t._d||(t._d=!0,t=t._w||t,t._v=e,t._s=2,t._a||(t._a=t._c.slice()),M(t,!0))},F=function(e){var t,n=this;if(!n._d){n._d=!0,n=n._w||n;try{if(n===e)throw k("Promise can't be resolved itself");(t=C(e))?b(function(){var r={_w:n,_d:!1};try{t.call(e,f(F,r,1),f(L,r,1))}catch(e){L.call(r,e)}}):(n._v=e,n._s=1,M(n,!1))}catch(e){L.call({_w:n,_d:!1},e)}}};N||(T=function(e){p(this,T,"Promise","_h"),d(e),r.call(this);try{e(f(F,this,1),f(L,this,1))}catch(e){L.call(this,e)}},r=function(e){this._c=[],this._a=void 0,this._s=0,this._d=!1,this._v=void 0,this._h=0,this._n=!1},r.prototype=n(115)(T.prototype,{then:function(e,t){var n=I(m(this,T));return n.ok="function"!=typeof e||e,n.fail="function"==typeof t&&t,n.domain=A?S.domain:void 0,this._c.push(n),this._a&&this._a.push(n),this._s&&M(this,!1),n.promise},catch:function(e){return this.then(void 0,e)}}),o=function(){var e=new r;this.promise=e,this.resolve=f(F,e,1),this.reject=f(L,e,1)},g.f=I=function(e){return e===T||e===a?new o(e):i(e)}),l(l.G+l.W+l.F*!N,{Promise:T}),n(25)(T,"Promise"),n(116)("Promise"),a=n(1).Promise,l(l.S+l.F*!N,"Promise",{reject:function(e){var t=I(this);return(0,t.reject)(e),t.promise}}),l(l.S+l.F*(s||!N),"Promise",{resolve:function(e){return x(s&&this===a?T:this,e)}}),l(l.S+l.F*!(N&&n(117)(function(e){T.all(e).catch(P)})),"Promise",{all:function(e){var t=this,n=I(t),r=n.resolve,i=n.reject,o=w(function(){var n=[],o=0,a=1;v(e,!1,function(e){var s=o++,u=!1;n.push(void 0),a++,t.resolve(e).then(function(e){u||(u=!0,n[s]=e,--a||r(n))},i)}),--a||r(n)});return o.e&&i(o.v),n.promise},race:function(e){var t=this,n=I(t),r=n.reject,i=w(function(){v(e,!1,function(e){t.resolve(e).then(n.resolve,r)})});return i.e&&r(i.v),n.promise}})},function(e,t){e.exports=function(e,t,n,r){if(!(e instanceof t)||void 0!==r&&r in e)throw TypeError(n+": incorrect invocation!");return e}},function(e,t,n){var r=n(17),i=n(110),o=n(111),a=n(5),s=n(52),u=n(58),f={},c={},t=e.exports=function(e,t,n,l,h){var d,p,v,m,y=h?function(){return e}:u(e),b=r(n,l,t?2:1),g=0;if("function"!=typeof y)throw TypeError(e+" is not iterable!");if(o(y)){for(d=s(e.length);d>g;g++)if((m=t?b(a(p=e[g])[0],p[1]):b(e[g]))===f||m===c)return m}else for(v=y.call(e);!(p=v.next()).done;)if((m=i(v,b,p.value,t))===f||m===c)return m};t.BREAK=f,t.RETURN=c},function(e,t,n){var r=n(5);e.exports=function(e,t,n,i){try{return i?t(r(n)[0],n[1]):t(n)}catch(t){var o=e.return;throw void 0!==o&&r(o.call(e)),t}}},function(e,t,n){var r=n(13),i=n(2)("iterator"),o=Array.prototype;e.exports=function(e){return void 0!==e&&(r.Array===e||o[i]===e)}},function(e,t){e.exports=function(e,t,n){var r=void 0===n;switch(t.length){case 0:return r?e():e.call(n);case 1:return r?e(t[0]):e.call(n,t[0]);case 2:return r?e(t[0],t[1]):e.call(n,t[0],t[1]);case 3:return r?e(t[0],t[1],t[2]):e.call(n,t[0],t[1],t[2]);case 4:return r?e(t[0],t[1],t[2],t[3]):e.call(n,t[0],t[1],t[2],t[3])}return e.apply(n,t)}},function(e,t,n){var r=n(0),i=n(60).set,o=r.MutationObserver||r.WebKitMutationObserver,a=r.process,s=r.Promise,u="process"==n(18)(a);e.exports=function(){var e,t,n,f=function(){var r,i;for(u&&(r=a.domain)&&r.exit();e;){i=e.fn,e=e.next;try{i()}catch(r){throw e?n():t=void 0,r}}t=void 0,r&&r.enter()};if(u)n=function(){a.nextTick(f)};else if(!o||r.navigator&&r.navigator.standalone)if(s&&s.resolve){var c=s.resolve(void 0);n=function(){c.then(f)}}else n=function(){i.call(r,f)};else{var l=!0,h=document.createTextNode("");new o(f).observe(h,{characterData:!0}),n=function(){h.data=l=!l}}return function(r){var i={fn:r,next:void 0};t&&(t.next=i),e||(e=i,n()),t=i}}},function(e,t,n){var r=n(0),i=r.navigator;e.exports=i&&i.userAgent||""},function(e,t,n){var r=n(10);e.exports=function(e,t,n){for(var i in t)n&&e[i]?e[i]=t[i]:r(e,i,t[i]);return e}},function(e,t,n){"use strict";var r=n(0),i=n(1),o=n(7),a=n(9),s=n(2)("species");e.exports=function(e){var t="function"==typeof i[e]?i[e]:r[e];a&&t&&!t[s]&&o.f(t,s,{configurable:!0,get:function(){return this}})}},function(e,t,n){var r=n(2)("iterator"),i=!1;try{var o=[7][r]();o.return=function(){i=!0},Array.from(o,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!i)return!1;var n=!1;try{var o=[7],a=o[r]();a.next=function(){return{done:n=!0}},o[r]=function(){return a},e(o)}catch(e){}return n}},function(e,t,n){"use strict";var r=n(6),i=n(1),o=n(0),a=n(59),s=n(62);r(r.P+r.R,"Promise",{finally:function(e){var t=a(this,i.Promise||o.Promise),n="function"==typeof e;return this.then(n?function(n){return s(t,e()).then(function(){return n})}:e,n?function(n){return s(t,e()).then(function(){throw n})}:e)}})},function(e,t,n){"use strict";var r=n(6),i=n(46),o=n(61);r(r.S,"Promise",{try:function(e){var t=i.f(this),n=o(e);return(n.e?t.reject:t.resolve)(n.v),t.promise}})},function(e,t,n){e.exports={default:n(121),__esModule:!0}},function(e,t,n){n(122);var r=n(1).Object;e.exports=function(e,t,n){return r.defineProperty(e,t,n)}},function(e,t,n){var r=n(6);r(r.S+r.F*!n(9),"Object",{defineProperty:n(7).f})},function(e,t,n){function r(e){this.options=e||{locator:{}}}function i(e,t,n){function r(t){var r=e[t];!r&&a&&(r=2==e.length?function(n){e(t,n)}:e),i[t]=r&&function(e){r("[xmldom "+t+"]\t"+e+s(n))}||function(){}}if(!e){if(t instanceof o)return t;e=t}var i={},a=e instanceof Function;return n=n||{},r("warning"),r("error"),r("fatalError"),i}function o(){this.cdata=!1}function a(e,t){t.lineNumber=e.lineNumber,t.columnNumber=e.columnNumber}function s(e){if(e)return"\n@"+(e.systemId||"")+"#[line:"+e.lineNumber+",col:"+e.columnNumber+"]"}function u(e,t,n){return"string"==typeof e?e.substr(t,n):e.length>=t+n||t?new java.lang.String(e,t,n)+"":e}function f(e,t){e.currentElement?e.currentElement.appendChild(t):e.doc.appendChild(t)}r.prototype.parseFromString=function(e,t){var n=this.options,r=new c,a=n.domBuilder||new o,s=n.errorHandler,u=n.locator,f=n.xmlns||{},l={lt:"<",gt:">",amp:"&",quot:'"',apos:"'"};return u&&a.setDocumentLocator(u),r.errorHandler=i(s,a,u),r.domBuilder=n.domBuilder||a,/\/x?html?$/.test(t)&&(l.nbsp=" ",l.copy="©",f[""]="http://www.w3.org/1999/xhtml"),f.xml=f.xml||"http://www.w3.org/XML/1998/namespace",e?r.parse(e,f,l):r.errorHandler.error("invalid doc source"),a.doc},o.prototype={startDocument:function(){this.doc=(new l).createDocument(null,null,null),this.locator&&(this.doc.documentURI=this.locator.systemId)},startElement:function(e,t,n,r){var i=this.doc,o=i.createElementNS(e,n||t),s=r.length;f(this,o),this.currentElement=o,this.locator&&a(this.locator,o);for(var u=0;u<s;u++){var e=r.getURI(u),c=r.getValue(u),n=r.getQName(u),l=i.createAttributeNS(e,n);this.locator&&a(r.getLocator(u),l),l.value=l.nodeValue=c,o.setAttributeNode(l)}},endElement:function(e,t,n){var r=this.currentElement;r.tagName;this.currentElement=r.parentNode},startPrefixMapping:function(e,t){},endPrefixMapping:function(e){},processingInstruction:function(e,t){var n=this.doc.createProcessingInstruction(e,t);this.locator&&a(this.locator,n),f(this,n)},ignorableWhitespace:function(e,t,n){},characters:function(e,t,n){if(e=u.apply(this,arguments)){if(this.cdata)var r=this.doc.createCDATASection(e);else var r=this.doc.createTextNode(e);this.currentElement?this.currentElement.appendChild(r):/^\s*$/.test(e)&&this.doc.appendChild(r),this.locator&&a(this.locator,r)}},skippedEntity:function(e){},endDocument:function(){this.doc.normalize()},setDocumentLocator:function(e){(this.locator=e)&&(e.lineNumber=0)},comment:function(e,t,n){e=u.apply(this,arguments);var r=this.doc.createComment(e);this.locator&&a(this.locator,r),f(this,r)},startCDATA:function(){this.cdata=!0},endCDATA:function(){this.cdata=!1},startDTD:function(e,t,n){var r=this.doc.implementation;if(r&&r.createDocumentType){var i=r.createDocumentType(e,t,n);this.locator&&a(this.locator,i),f(this,i)}},warning:function(e){console.warn("[xmldom warning]\t"+e,s(this.locator))},error:function(e){console.error("[xmldom error]\t"+e,s(this.locator))},fatalError:function(e){throw console.error("[xmldom fatalError]\t"+e,s(this.locator)),e}},"endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(/\w+/g,function(e){o.prototype[e]=function(){return null}});var c=n(124).XMLReader,l=t.DOMImplementation=n(63).DOMImplementation;t.XMLSerializer=n(63).XMLSerializer,t.DOMParser=r},function(e,t){function n(){}function r(e,t,n,r,f){function d(e){if(e>65535){e-=65536;var t=55296+(e>>10),n=56320+(1023&e);return String.fromCharCode(t,n)}return String.fromCharCode(e)}function p(e){var t=e.slice(1,-1);return t in n?n[t]:"#"===t.charAt(0)?d(parseInt(t.substr(1).replace("x","0x"))):(f.error("entity not found:"+e),e)}function v(t){if(t>k){var n=e.substring(k,t).replace(/&#?\w+;/g,p);w&&m(k),r.characters(n,0,t-k),k=t}}function m(t,n){for(;t>=b&&(n=g.exec(e));)y=n.index,b=y+n[0].length,w.lineNumber++;w.columnNumber=t-y+1}for(var y=0,b=0,g=/.*(?:\r\n?|\n)|.*$/g,w=r.locator,_=[{currentNSMap:t}],x={},k=0;;){try{var S=e.indexOf("<",k);if(S<0){if(!e.substr(k).match(/^\s*$/)){var O=r.doc,E=O.createTextNode(e.substr(k));O.appendChild(E),r.currentElement=E}return}switch(S>k&&v(S),e.charAt(S+1)){case"/":var T=e.indexOf(">",S+3),A=e.substring(S+2,T),P=_.pop();T<0?(A=e.substring(S+2).replace(/[\s<].*/,""),f.error("end tag name: "+A+" is not complete:"+P.tagName),T=S+1+A.length):A.match(/\s</)&&(A=A.replace(/[\s<].*/,""),f.error("end tag name: "+A+" maybe not complete"),T=S+1+A.length);var I=P.localNSMap,N=P.tagName==A;if(N||P.tagName&&P.tagName.toLowerCase()==A.toLowerCase()){if(r.endElement(P.uri,P.localName,A),I)for(var C in I)r.endPrefixMapping(C);N||f.fatalError("end tag name: "+A+" is not match the current start tagName:"+P.tagName)}else _.push(P);T++;break;case"?":w&&m(S),T=l(e,S,r);break;case"!":w&&m(S),T=c(e,S,r,f);break;default:w&&m(S);var M=new h,D=_[_.length-1].currentNSMap,T=o(e,S,M,D,p,f),j=M.length;if(!M.closed&&u(e,T,M.tagName,x)&&(M.closed=!0,n.nbsp||f.warning("unclosed xml attribute")),w&&j){for(var R=i(w,{}),L=0;L<j;L++){var F=M[L];m(F.offset),F.locator=i(w,{})}r.locator=R,a(M,r,D)&&_.push(M),r.locator=w}else a(M,r,D)&&_.push(M);"http://www.w3.org/1999/xhtml"!==M.uri||M.closed?T++:T=s(e,T,M.tagName,p,r)}}catch(e){f.error("element parse error: "+e),T=-1}T>k?k=T:v(Math.max(S,k)+1)}}function i(e,t){return t.lineNumber=e.lineNumber,t.columnNumber=e.columnNumber,t}function o(e,t,n,r,i,o){for(var a,s,u=++t,f=b;;){var c=e.charAt(u);switch(c){case"=":if(f===g)a=e.slice(t,u),f=_;else{if(f!==w)throw new Error("attribute equal must after attrName");f=_}break;case"'":case'"':if(f===_||f===g){if(f===g&&(o.warning('attribute value must after "="'),a=e.slice(t,u)),t=u+1,!((u=e.indexOf(c,t))>0))throw new Error("attribute value no end '"+c+"' match");s=e.slice(t,u).replace(/&#?\w+;/g,i),n.add(a,s,t-1),f=k}else{if(f!=x)throw new Error('attribute value must after "="');s=e.slice(t,u).replace(/&#?\w+;/g,i),n.add(a,s,t),o.warning('attribute "'+a+'" missed start quot('+c+")!!"),t=u+1,f=k}break;case"/":switch(f){case b:n.setTagName(e.slice(t,u));case k:case S:case O:f=O,n.closed=!0;case x:case g:case w:break;default:throw new Error("attribute invalid close char('/')")}break;case"":return o.error("unexpected end of input"),f==b&&n.setTagName(e.slice(t,u)),u;case">":switch(f){case b:n.setTagName(e.slice(t,u));case k:case S:case O:break;case x:case g:s=e.slice(t,u),"/"===s.slice(-1)&&(n.closed=!0,s=s.slice(0,-1));case w:f===w&&(s=a),f==x?(o.warning('attribute "'+s+'" missed quot(")!!'),n.add(a,s.replace(/&#?\w+;/g,i),t)):("http://www.w3.org/1999/xhtml"===r[""]&&s.match(/^(?:disabled|checked|selected)$/i)||o.warning('attribute "'+s+'" missed value!! "'+s+'" instead!!'),n.add(s,s,t));break;case _:throw new Error("attribute value missed!!")}return u;case"":c=" ";default:if(c<=" ")switch(f){case b:n.setTagName(e.slice(t,u)),f=S;break;case g:a=e.slice(t,u),f=w;break;case x:var s=e.slice(t,u).replace(/&#?\w+;/g,i);o.warning('attribute "'+s+'" missed quot(")!!'),n.add(a,s,t);case k:f=S}else switch(f){case w:n.tagName;"http://www.w3.org/1999/xhtml"===r[""]&&a.match(/^(?:disabled|checked|selected)$/i)||o.warning('attribute "'+a+'" missed value!! "'+a+'" instead2!!'),n.add(a,a,t),t=u,f=g;break;case k:o.warning('attribute space is required"'+a+'"!!');case S:f=g,t=u;break;case _:f=x,t=u;break;case O:throw new Error("elements closed character '/' and '>' must be connected to")}}u++}}function a(e,t,n){for(var r=e.tagName,i=null,o=e.length;o--;){var a=e[o],s=a.qName,u=a.value,c=s.indexOf(":");if(c>0)var l=a.prefix=s.slice(0,c),h=s.slice(c+1),d="xmlns"===l&&h;else h=s,l=null,d="xmlns"===s&&"";a.localName=h,!1!==d&&(null==i&&(i={},f(n,n={})),n[d]=i[d]=u,a.uri="http://www.w3.org/2000/xmlns/",t.startPrefixMapping(d,u))}for(var o=e.length;o--;){a=e[o];var l=a.prefix;l&&("xml"===l&&(a.uri="http://www.w3.org/XML/1998/namespace"),"xmlns"!==l&&(a.uri=n[l||""]))}var c=r.indexOf(":");c>0?(l=e.prefix=r.slice(0,c),h=e.localName=r.slice(c+1)):(l=null,h=e.localName=r);var p=e.uri=n[l||""];if(t.startElement(p,h,r,e),!e.closed)return e.currentNSMap=n,e.localNSMap=i,!0;if(t.endElement(p,h,r),i)for(l in i)t.endPrefixMapping(l)}function s(e,t,n,r,i){if(/^(?:script|textarea)$/i.test(n)){var o=e.indexOf("</"+n+">",t),a=e.substring(t+1,o);if(/[&<]/.test(a))return/^script$/i.test(n)?(i.characters(a,0,a.length),o):(a=a.replace(/&#?\w+;/g,r),i.characters(a,0,a.length),o)}return t+1}function u(e,t,n,r){var i=r[n];return null==i&&(i=e.lastIndexOf("</"+n+">"),i<t&&(i=e.lastIndexOf("</"+n)),r[n]=i),i<t}function f(e,t){for(var n in e)t[n]=e[n]}function c(e,t,n,r){switch(e.charAt(t+2)){case"-":if("-"===e.charAt(t+3)){var i=e.indexOf("--\x3e",t+4);return i>t?(n.comment(e,t+4,i-t-4),i+3):(r.error("Unclosed comment"),-1)}return-1;default:if("CDATA["==e.substr(t+3,6)){var i=e.indexOf("]]>",t+9);return n.startCDATA(),n.characters(e,t+9,i-t-9),n.endCDATA(),i+3}var o=p(e,t),a=o.length;if(a>1&&/!doctype/i.test(o[0][0])){var s=o[1][0],u=a>3&&/^public$/i.test(o[2][0])&&o[3][0],f=a>4&&o[4][0],c=o[a-1];return n.startDTD(s,u&&u.replace(/^(['"])(.*?)\1$/,"$2"),f&&f.replace(/^(['"])(.*?)\1$/,"$2")),n.endDTD(),c.index+c[0].length}}return-1}function l(e,t,n){var r=e.indexOf("?>",t);if(r){var i=e.substring(t,r).match(/^<\?(\S*)\s*([\s\S]*?)\s*$/);if(i){i[0].length;return n.processingInstruction(i[1],i[2]),r+2}return-1}return-1}function h(e){}function d(e,t){return e.__proto__=t,e}function p(e,t){var n,r=[],i=/'[^']+'|"[^"]+"|[^\s<>\/=]+=?|(\/?\s*>|<)/g;for(i.lastIndex=t,i.exec(e);n=i.exec(e);)if(r.push(n),n[1])return r}var v=/[A-Z_a-z\xC0-\xD6\xD8-\xF6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/,m=new RegExp("[\\-\\.0-9"+v.source.slice(1,-1)+"\\u00B7\\u0300-\\u036F\\u203F-\\u2040]"),y=new RegExp("^"+v.source+m.source+"*(?::"+v.source+m.source+"*)?$"),b=0,g=1,w=2,_=3,x=4,k=5,S=6,O=7;n.prototype={parse:function(e,t,n){var i=this.domBuilder;i.startDocument(),f(t,t={}),r(e,t,n,i,this.errorHandler),i.endDocument()}},h.prototype={setTagName:function(e){if(!y.test(e))throw new Error("invalid tagName:"+e);this.tagName=e},add:function(e,t,n){if(!y.test(e))throw new Error("invalid attribute:"+e);this[this.length++]={qName:e,value:t,offset:n}},length:0,getLocalName:function(e){return this[e].localName},getLocator:function(e){return this[e].locator},getQName:function(e){return this[e].qName},getURI:function(e){return this[e].uri},getValue:function(e){return this[e].value}},d({},d.prototype)instanceof d||(d=function(e,t){function n(){}n.prototype=t,n=new n;for(t in e)n[t]=e[t];return n}),t.XMLReader=n},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){for(var r=0,i=t;i<n;++i)r+=e[i];return r}function o(e,t,n){switch(e){case 1:switch(t){case 8:return new Uint8Array(n);case 16:return new Uint16Array(n);case 32:return new Uint32Array(n)}break;case 2:switch(t){case 8:return new Int8Array(n);case 16:return new Int16Array(n);case 32:return new Int32Array(n)}break;case 3:switch(t){case 32:return new Float32Array(n);case 64:return new Float64Array(n)}}throw Error("Unsupported data format/bitsPerSample")}Object.defineProperty(t,"__esModule",{value:!0});var a=n(44),s=r(a),u=n(27),f=r(u),c=n(28),l=r(c),h=n(3),d=r(h),p=n(4),v=r(p),m=n(47),y=n(64),b=n(126),g=n(144),w=function(){function e(t,n,r,i,o,a){(0,d.default)(this,e),this.fileDirectory=t,this.geoKeys=n,this.dataView=r,this.littleEndian=i,this.tiles=o?{}:null,this.isTiled=!t.StripOffsets;var s=t.PlanarConfiguration;if(this.planarConfiguration=void 0===s?1:s,1!==this.planarConfiguration&&2!==this.planarConfiguration)throw new Error("Invalid planar configuration.");this.source=a}return(0,v.default)(e,[{key:"getFileDirectory",value:function(){return this.fileDirectory}},{key:"getGeoKeys",value:function(){return this.geoKeys}},{key:"getWidth",value:function(){return this.fileDirectory.ImageWidth}},{key:"getHeight",value:function(){return this.fileDirectory.ImageLength}},{key:"getSamplesPerPixel",value:function(){return this.fileDirectory.SamplesPerPixel}},{key:"getTileWidth",value:function(){return this.isTiled?this.fileDirectory.TileWidth:this.getWidth()}},{key:"getTileHeight",value:function(){return this.isTiled?this.fileDirectory.TileLength:void 0!==this.fileDirectory.RowsPerStrip?Math.min(this.fileDirectory.RowsPerStrip,this.getHeight()):this.getHeight()}},{key:"getBytesPerPixel",value:function(){for(var e=0,t=0;t<this.fileDirectory.BitsPerSample.length;++t){var n=this.fileDirectory.BitsPerSample[t];if(n%8!=0)throw new Error("Sample bit-width of "+n+" is not supported.");if(n!==this.fileDirectory.BitsPerSample[0])throw new Error("Differing size of samples in a pixel are not supported.");e+=n}return e/8}},{key:"getSampleByteSize",value:function(e){if(e>=this.fileDirectory.BitsPerSample.length)throw new RangeError("Sample index "+e+" is out of range.");var t=this.fileDirectory.BitsPerSample[e];if(t%8!=0)throw new Error("Sample bit-width of "+t+" is not supported.");return t/8}},{key:"getReaderForSample",value:function(e){var t=this.fileDirectory.SampleFormat?this.fileDirectory.SampleFormat[e]:1,n=this.fileDirectory.BitsPerSample[e];switch(t){case 1:switch(n){case 8:return DataView.prototype.getUint8;case 16:return DataView.prototype.getUint16;case 32:return DataView.prototype.getUint32}break;case 2:switch(n){case 8:return DataView.prototype.getInt8;case 16:return DataView.prototype.getInt16;case 32:return DataView.prototype.getInt32}break;case 3:switch(n){case 32:return DataView.prototype.getFloat32;case 64:return DataView.prototype.getFloat64}}throw Error("Unsupported data format/bitsPerSample")}},{key:"getArrayForSample",value:function(e,t){return o(this.fileDirectory.SampleFormat?this.fileDirectory.SampleFormat[e]:1,this.fileDirectory.BitsPerSample[e],t)}},{key:"getTileOrStrip",value:function(){function e(e,n,r,i){return t.apply(this,arguments)}var t=(0,l.default)(f.default.mark(function e(t,n,r,i){var o,a,s,u,c,l,h,d;return f.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return o=Math.ceil(this.getWidth()/this.getTileWidth()),a=Math.ceil(this.getHeight()/this.getTileHeight()),s=void 0,u=this.tiles,1===this.planarConfiguration?s=n*o+t:2===this.planarConfiguration&&(s=r*o*a+n*o+t),c=void 0,l=void 0,this.isTiled?(c=this.fileDirectory.TileOffsets[s],l=this.fileDirectory.TileByteCounts[s]):(c=this.fileDirectory.StripOffsets[s],l=this.fileDirectory.StripByteCounts[s]),e.next=10,this.source.fetch(c,l);case 10:return h=e.sent,d=void 0,null===u?d=i.decode(this.fileDirectory,h):u[s]||(d=i.decode(this.fileDirectory,h),u[s]=d),e.t0=t,e.t1=n,e.t2=r,e.next=18,d;case 18:return e.t3=e.sent,e.abrupt("return",{x:e.t0,y:e.t1,sample:e.t2,data:e.t3});case 20:case"end":return e.stop()}},e,this)}));return e}()},{key:"_readRaster",value:function(){function e(e,n,r,i,o,a,s,u){return t.apply(this,arguments)}var t=(0,l.default)(f.default.mark(function e(t,n,r,o,a,s,u,c){var l,h,d,p,v,m,y,b,w,_,x,k,S,O,E,T,A,P,I=this;return f.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:for(l=this.getTileWidth(),h=this.getTileHeight(),d=Math.max(Math.floor(t[0]/l),0),p=Math.min(Math.ceil(t[2]/l),Math.ceil(this.getWidth()/this.getTileWidth())),v=Math.max(Math.floor(t[1]/h),0),m=Math.min(Math.ceil(t[3]/h),Math.ceil(this.getHeight()/this.getTileHeight())),y=t[2]-t[0],b=this.getBytesPerPixel(),w=[],_=[],x=0;x<n.length;++x)1===this.planarConfiguration?w.push(i(this.fileDirectory.BitsPerSample,0,n[x])/8):w.push(0),_.push(this.getReaderForSample(n[x]));for(k=[],S=this.littleEndian,O=v;O<m;++O)for(E=d;E<p;++E)for(T=function(e){var i=e,s=n[e];2===I.planarConfiguration&&(b=I.getSampleByteSize(s));var u=I.getTileOrStrip(E,O,s,a);k.push(u),u.then(function(e){for(var a=e.data,s=new DataView(a),u=e.y*h,f=e.x*l,c=(e.y+1)*h,d=(e.x+1)*l,p=_[i],v=Math.min(h,h-(c-t[3])),m=Math.min(l,l-(d-t[2])),g=Math.max(0,t[1]-u);g<v;++g)for(var x=Math.max(0,t[0]-f);x<m;++x){var k=(g*l+x)*b,O=p.call(s,k+w[i],S),E=void 0;o?(E=(g+u-t[1])*y*n.length+(x+f-t[0])*n.length+i,r[E]=O):(E=(g+u-t[1])*y+x+f-t[0],r[i][E]=O)}})},A=0;A<n.length;++A)T(A);return e.next=16,Promise.all(k);case 16:if(!(s&&t[2]-t[0]!==s||u&&t[3]-t[1]!==u)){e.next=22;break}return P=void 0,P=o?(0,g.resampleInterleaved)(r,t[2]-t[0],t[3]-t[1],s,u,n.length,c):(0,g.resample)(r,t[2]-t[0],t[3]-t[1],s,u,c),P.width=s,P.height=u,e.abrupt("return",P);case 22:return r.width=s||t[2]-t[0],r.height=u||t[3]-t[1],e.abrupt("return",r);case 25:case"end":return e.stop()}},e,this)}));return e}()},{key:"readRasters",value:function(){function e(){return t.apply(this,arguments)}var t=(0,l.default)(f.default.mark(function e(){var t,n,r,i,a,s,u,c,l,h,d,p,v,m=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},y=m.window,g=m.samples,w=void 0===g?[]:g,_=m.interleave,x=m.pool,k=void 0===x?null:x,S=m.width,O=m.height,E=m.resampleMethod,T=m.fillValue;return f.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(t=y||[0,0,this.getWidth(),this.getHeight()],!(t[0]>t[2]||t[1]>t[3])){e.next=3;break}throw new Error("Invalid subsets");case 3:if(n=t[2]-t[0],r=t[3]-t[1],i=n*r,w&&w.length){e.next=10;break}for(a=0;a<this.fileDirectory.SamplesPerPixel;++a)w.push(a);e.next=17;break;case 10:s=0;case 11:if(!(s<w.length)){e.next=17;break}if(!(w[s]>=this.fileDirectory.SamplesPerPixel)){e.next=14;break}return e.abrupt("return",Promise.reject(new RangeError("Invalid sample index '"+w[s]+"'.")));case 14:++s,e.next=11;break;case 17:if(u=void 0,_)c=this.fileDirectory.SampleFormat?Math.max.apply(null,this.fileDirectory.SampleFormat):1,l=Math.max.apply(null,this.fileDirectory.BitsPerSample),u=o(c,l,i*w.length),T&&u.fill(T);else for(u=[],h=0;h<w.length;++h)d=this.getArrayForSample(w[h],i),Array.isArray(T)&&h<T.length?d.fill(T[h]):T&&!Array.isArray(T)&&d.fill(T),u.push(d);return p=k||(0,b.getDecoder)(this.fileDirectory),e.next=22,this._readRaster(t,w,u,_,p,S,O,E);case 22:return v=e.sent,e.abrupt("return",v);case 24:case"end":return e.stop()}},e,this)}));return e}()},{key:"readRGB",value:function(){function e(){return t.apply(this,arguments)}var t=(0,l.default)(f.default.mark(function e(){var t,n,r,i,o,a,s,u,c=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},l=c.window,h=c.pool,d=void 0===h?null:h,p=c.width,v=c.height,b=c.resampleMethod;return f.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(t=l||[0,0,this.getWidth(),this.getHeight()],!(t[0]>t[2]||t[1]>t[3])){e.next=3;break}throw new Error("Invalid subsets");case 3:if((n=this.fileDirectory.PhotometricInterpretation)!==m.photometricInterpretations.RGB){e.next=6;break}return e.abrupt("return",this.readRasters({window:l,interleave:!0,samples:[0,1,2],pool:d}));case 6:r=void 0,e.t0=n,e.next=e.t0===m.photometricInterpretations.WhiteIsZero?10:e.t0===m.photometricInterpretations.BlackIsZero?10:e.t0===m.photometricInterpretations.Palette?10:e.t0===m.photometricInterpretations.CMYK?12:e.t0===m.photometricInterpretations.YCbCr?14:e.t0===m.photometricInterpretations.CIELab?14:16;break;case 10:return r=[0],e.abrupt("break",17);case 12:return r=[0,1,2,3],e.abrupt("break",17);case 14:return r=[0,1,2],e.abrupt("break",17);case 16:throw new Error("Invalid or unsupported photometric interpretation.");case 17:return i={window:t,interleave:!0,samples:r,pool:d,width:p,height:v,resampleMethod:b},o=this.fileDirectory,e.next=21,this.readRasters(i);case 21:a=e.sent,s=Math.pow(2,this.fileDirectory.BitsPerSample[0]),u=void 0,e.t1=n,e.next=e.t1===m.photometricInterpretations.WhiteIsZero?27:e.t1===m.photometricInterpretations.BlackIsZero?29:e.t1===m.photometricInterpretations.Palette?31:e.t1===m.photometricInterpretations.CMYK?33:e.t1===m.photometricInterpretations.YCbCr?35:e.t1===m.photometricInterpretations.CIELab?37:39;break;case 27:return u=(0,y.fromWhiteIsZero)(a,s),e.abrupt("break",40);case 29:return u=(0,y.fromBlackIsZero)(a,s),e.abrupt("break",40);case 31:return u=(0,y.fromPalette)(a,o.ColorMap),e.abrupt("break",40);case 33:return u=(0,y.fromCMYK)(a),e.abrupt("break",40);case 35:return u=(0,y.fromYCbCr)(a),e.abrupt("break",40);case 37:return u=(0,y.fromCIELab)(a),e.abrupt("break",40);case 39:throw new Error("Unsupported photometric interpretation.");case 40:return u.width=a.width,u.height=a.height,e.abrupt("return",u);case 43:case"end":return e.stop()}},e,this)}));return e}()},{key:"getTiePoints",value:function(){if(!this.fileDirectory.ModelTiepoint)return[];for(var e=[],t=0;t<this.fileDirectory.ModelTiepoint.length;t+=6)e.push({i:this.fileDirectory.ModelTiepoint[t],j:this.fileDirectory.ModelTiepoint[t+1],k:this.fileDirectory.ModelTiepoint[t+2],x:this.fileDirectory.ModelTiepoint[t+3],y:this.fileDirectory.ModelTiepoint[t+4],z:this.fileDirectory.ModelTiepoint[t+5]});return e}},{key:"getGDALMetadata",value:function(){var e={};if(!this.fileDirectory.GDAL_METADATA)return null;for(var t=this.fileDirectory.GDAL_METADATA,n=(0,m.parseXml)(t.substring(0,t.length-1)),r=n.evaluate("GDALMetadata/Item",n,null,XPathResult.UNORDERED_NODE_SNAPSHOT_TYPE,null),i=0;i<r.snapshotLength;++i){var o=r.snapshotItem(i);e[o.getAttribute("name")]=o.textContent}return e}},{key:"getOrigin",value:function(){var e=this.fileDirectory.ModelTiepoint,t=this.fileDirectory.ModelTransformation;if(e&&6===e.length)return[e[3],e[4],e[5]];if(t)return[t[3],t[7],t[11]];throw new Error("The image does not have an affine transformation.")}},{key:"getResolution",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:null,t=this.fileDirectory.ModelPixelScale,n=this.fileDirectory.ModelTransformation;if(t)return[t[0],-t[1],t[2]];if(n)return[n[0],n[5],n[10]];if(e){var r=e.getResolution(),i=(0,s.default)(r,3),o=i[0],a=i[1],u=i[2];return[o*e.getWidth()/this.getWidth(),a*e.getHeight()/this.getHeight(),u*e.getWidth()/this.getWidth()]}throw new Error("The image does not have an affine transformation.")}},{key:"pixelIsArea",value:function(){return 1===this.geoKeys.GTRasterTypeGeoKey}},{key:"getBoundingBox",value:function(){var e=this.getOrigin(),t=this.getResolution(),n=e[0],r=e[1],i=n+t[0]*this.getWidth(),o=r+t[1]*this.getHeight();return[Math.min(n,i),Math.min(r,o),Math.max(n,i),Math.max(r,o)]}}]),e}();t.default=w},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e){switch(e.Compression){case void 0:case 1:return new a.default;case 5:return new u.default;case 6:throw new Error("old style JPEG compression is not supported.");case 7:return new c.default(e);case 8:case 32946:return new h.default;case 32773:return new p.default;default:throw new Error("Unknown compression method identifier: "+e.Compression)}}Object.defineProperty(t,"__esModule",{value:!0}),t.getDecoder=i;var o=n(127),a=r(o),s=n(129),u=r(s),f=n(130),c=r(f),l=n(131),h=r(l),d=n(143),p=r(d)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=n(12),f=r(u),c=n(15),l=r(c),h=n(19),d=r(h),p=function(e){function t(){return(0,o.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,s.default)(t,[{key:"decodeBlock",value:function(e){return e}}]),t}(d.default);t.default=p},function(e,t,n){"use strict";function r(e,t){var n=e.length-t,r=0;do{for(var i=t;i>0;i--)e[r+t]+=e[r],r++;n-=t}while(n>0)}function i(e,t,n){for(var r=0,i=e.length,o=i/n;i>t;){for(var a=t;a>0;--a)e[r+t]+=e[r],++r;i-=t}for(var s=e.slice(),u=0;u<o;++u)for(var f=0;f<n;++f)e[n*u+f]=s[(n-f-1)*o+u]}function o(e,t,n,o,a){if(!t||1===t)return e;for(var s=0;s<a.length;++s){if(a[s]%8!=0)throw new Error("When decoding with predictor, only multiple of 8 bits are supported.");if(a[s]!==a[0])throw new Error("When decoding with predictor, all samples must have the same size.")}for(var u=a[0]/8,f=a.length,c=0;c<o;++c){var l=void 0;if(2===t){switch(a[0]){case 8:l=new Uint8Array(e,c*f*n*u,f*n*u);break;case 16:l=new Uint16Array(e,c*f*n*u,f*n*u/2);break;case 32:l=new Uint32Array(e,c*f*n*u,f*n*u/4);break;default:throw new Error("Predictor 2 not allowed with "+a[0]+" bits per sample.")}r(l,f,u)}else 3===t&&(l=new Uint8Array(e,c*f*n*u,n*u),i(l,f,u))}return e}Object.defineProperty(t,"__esModule",{value:!0}),t.applyPredictor=o},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){var r=t%8,i=Math.floor(t/8),o=8-r,a=t+n-8*(i+1),s=8*(i+2)-(t+n),u=8*(i+2)-t;if(s=Math.max(0,s),i>=e.length)return console.warn("ran off the end of the buffer before finding EOI_CODE (end on input code)"),g;var f=e[i]&Math.pow(2,8-r)-1;f<<=n-o;var c=f;if(i+1<e.length){var l=e[i+1]>>>s;l<<=Math.max(0,n-u),c+=l}if(a>8&&i+2<e.length){var h=8*(i+3)-(t+n);c+=e[i+2]>>>h}return c}function o(e,t){for(var n=t.length-1;n>=0;n--)e.push(t[n]);return e}function a(e){function t(){c=258,l=y}function n(e){var t=i(e,h,l);return h+=l,t}function r(e,t){return u[c]=t,s[c]=e,c++,c>=Math.pow(2,l)&&l++,c-1}function a(e){for(var t=[],n=e;4096!==n;n=s[n])t.push(u[n]);return t}for(var s=new Uint16Array(4093),u=new Uint8Array(4093),f=0;f<=257;f++)s[f]=4096,u[f]=f;var c=258,l=y,h=0,d=[];t();for(var p=new Uint8Array(e),v=n(p),m=void 0;v!==g;){if(v===b){for(t(),v=n(p);v===b;)v=n(p);if(v>b)throw new Error("corrupted code at scanline "+v);if(v===g)break;o(d,a(v)),m=v}else if(v<c){var w=a(v);o(d,w),r(m,w[w.length-1]),m=v}else{var _=a(m);if(!_)throw new Error("Bogus entry. Not in dictionary, "+m+" / "+c+", position: "+h);o(d,_),d.push(_[_.length-1]),r(m,_[_.length-1]),m=v}c>=Math.pow(2,l)-1&&l++,v=n(p)}return new Uint8Array(d)}Object.defineProperty(t,"__esModule",{value:!0});var s=n(3),u=r(s),f=n(4),c=r(f),l=n(12),h=r(l),d=n(15),p=r(d),v=n(19),m=r(v),y=9,b=256,g=257,w=function(e){function t(){return(0,u.default)(this,t),(0,h.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,p.default)(t,e),(0,c.default)(t,[{key:"decodeBlock",value:function(e){return a(e).buffer}}]),t}(m.default);t.default=w},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t){for(var n=0,r=[],i=16;i>0&&!e[i-1];)--i;r.push({children:[],index:0});for(var o=r[0],a=void 0,s=0;s<i;s++){for(var u=0;u<e[s];u++){for(o=r.pop(),o.children[o.index]=t[n];o.index>0;)o=r.pop();for(o.index++,r.push(o);r.length<=s;)r.push(a={children:[],index:0}),o.children[o.index]=a.children,o=a;n++}s+1<i&&(r.push(a={children:[],index:0}),o.children[o.index]=a.children,o=a)}return r[0].children}function o(e,t,n,r,i,o,a,s,u){function f(){if(O>0)return O--,S>>O&1;if(255===(S=e[k++])){var t=e[k++];if(t)throw new Error("unexpected marker: "+(S<<8|t).toString(16))}return O=7,S>>>7}function c(e){for(var t=e,n=void 0;null!==(n=f());){if("number"==typeof(t=t[n]))return t;if("object"!==(void 0===t?"undefined":(0,m.default)(t)))throw new Error("invalid huffman sequence")}return null}function l(e){for(var t=e,n=0;t>0;){var r=f();if(null===r)return;n=n<<1|r,--t}return n}function h(e){var t=l(e);return t>=1<<e-1?t:t+(-1<<e)+1}function d(e,t){var n=c(e.huffmanTableDC),r=0===n?0:h(n);e.pred+=r,t[0]=e.pred;for(var i=1;i<64;){var o=c(e.huffmanTableAC),a=15&o,s=o>>4;if(0===a){if(s<15)break;i+=16}else{i+=s;t[g[i]]=h(a),i++}}}function p(e,t){var n=c(e.huffmanTableDC),r=0===n?0:h(n)<<u;e.pred+=r,t[0]=e.pred}function v(e,t){t[0]|=f()<<u}function y(e,t){if(E>0)return void E--;for(var n=o,r=a;n<=r;){var i=c(e.huffmanTableAC),s=15&i,f=i>>4;if(0===s){if(f<15){E=l(f)+(1<<f)-1;break}n+=16}else{n+=f;t[g[n]]=h(s)*(1<<u),n++}}}function b(e,t){for(var n=o,r=a,i=0;n<=r;){var s=g[n],d=t[s]<0?-1:1;switch(T){case 0:var p=c(e.huffmanTableAC),v=15&p;if(i=p>>4,0===v)i<15?(E=l(i)+(1<<i),T=4):(i=16,T=1);else{if(1!==v)throw new Error("invalid ACn encoding");A=h(v),T=i?2:3}continue;case 1:case 2:t[s]?t[s]+=(f()<<u)*d:0===--i&&(T=2===T?3:0);break;case 3:t[s]?t[s]+=(f()<<u)*d:(t[s]=A<<u,T=0);break;case 4:t[s]&&(t[s]+=(f()<<u)*d)}n++}4===T&&0===--E&&(T=0)}var w=n.mcusPerLine,_=n.progressive,x=t,k=t,S=0,O=0,E=0,T=0,A=void 0,P=r.length,I=void 0,N=void 0,C=void 0,M=void 0,D=void 0,j=void 0;j=_?0===o?0===s?p:v:0===s?y:b:d;var R=0,L=void 0,F=void 0;F=1===P?r[0].blocksPerLine*r[0].blocksPerColumn:w*n.mcusPerColumn;for(var U=i||F;R<F;){for(N=0;N<P;N++)r[N].pred=0;if(E=0,1===P)for(I=r[0],D=0;D<U;D++)!function(e,t,n){var r=n/e.blocksPerLine|0,i=n%e.blocksPerLine;t(e,e.blocks[r][i])}(I,j,R),R++;else for(D=0;D<U;D++){for(N=0;N<P;N++){I=r[N];var B=I,G=B.h,Z=B.v;for(C=0;C<Z;C++)for(M=0;M<G;M++)!function(e,t,n,r,i){var o=n/w|0,a=n%w,s=o*e.v+r,u=a*e.h+i;t(e,e.blocks[s][u])}(I,j,R,C,M)}if(++R===F)break}if(O=0,(L=e[k]<<8|e[k+1])<65280)throw new Error("marker was not found");if(!(L>=65488&&L<=65495))break;k+=2}return k-x}function a(e,t){for(var n=[],r=t.blocksPerLine,i=t.blocksPerColumn,o=r<<3,a=new Int32Array(64),s=new Uint8Array(64),u=0;u<i;u++){for(var f=u<<3,c=0;c<8;c++)n.push(new Uint8Array(o));for(var l=0;l<r;l++){!function(e,n,r){var i=t.quantizationTable,o=void 0,a=void 0,s=void 0,u=void 0,f=void 0,c=void 0,l=void 0,h=void 0,d=void 0,p=r,v=void 0;for(v=0;v<64;v++)p[v]=e[v]*i[v];for(v=0;v<8;++v){var m=8*v;0!==p[1+m]||0!==p[2+m]||0!==p[3+m]||0!==p[4+m]||0!==p[5+m]||0!==p[6+m]||0!==p[7+m]?(o=E*p[0+m]+128>>8,a=E*p[4+m]+128>>8,s=p[2+m],u=p[6+m],f=T*(p[1+m]-p[7+m])+128>>8,h=T*(p[1+m]+p[7+m])+128>>8,c=p[3+m]<<4,l=p[5+m]<<4,d=o-a+1>>1,o=o+a+1>>1,a=d,d=s*O+u*S+128>>8,s=s*S-u*O+128>>8,u=d,d=f-l+1>>1,f=f+l+1>>1,l=d,d=h+c+1>>1,c=h-c+1>>1,h=d,d=o-u+1>>1,o=o+u+1>>1,u=d,d=a-s+1>>1,a=a+s+1>>1,s=d,d=f*k+h*x+2048>>12,f=f*x-h*k+2048>>12,h=d,d=c*_+l*w+2048>>12,c=c*w-l*_+2048>>12,l=d,p[0+m]=o+h,p[7+m]=o-h,p[1+m]=a+l,p[6+m]=a-l,p[2+m]=s+c,p[5+m]=s-c,p[3+m]=u+f,p[4+m]=u-f):(d=E*p[0+m]+512>>10,p[0+m]=d,p[1+m]=d,p[2+m]=d,p[3+m]=d,p[4+m]=d,p[5+m]=d,p[6+m]=d,p[7+m]=d)}for(v=0;v<8;++v){var y=v;0!==p[8+y]||0!==p[16+y]||0!==p[24+y]||0!==p[32+y]||0!==p[40+y]||0!==p[48+y]||0!==p[56+y]?(o=E*p[0+y]+2048>>12,a=E*p[32+y]+2048>>12,s=p[16+y],u=p[48+y],f=T*(p[8+y]-p[56+y])+2048>>12,h=T*(p[8+y]+p[56+y])+2048>>12,c=p[24+y],l=p[40+y],d=o-a+1>>1,o=o+a+1>>1,a=d,d=s*O+u*S+2048>>12,s=s*S-u*O+2048>>12,u=d,d=f-l+1>>1,f=f+l+1>>1,l=d,d=h+c+1>>1,c=h-c+1>>1,h=d,d=o-u+1>>1,o=o+u+1>>1,u=d,d=a-s+1>>1,a=a+s+1>>1,s=d,d=f*k+h*x+2048>>12,f=f*x-h*k+2048>>12,h=d,d=c*_+l*w+2048>>12,c=c*w-l*_+2048>>12,l=d,p[0+y]=o+h,p[56+y]=o-h,p[8+y]=a+l,p[48+y]=a-l,p[16+y]=s+c,p[40+y]=s-c,p[24+y]=u+f,p[32+y]=u-f):(d=E*r[v+0]+8192>>14,p[0+y]=d,p[8+y]=d,p[16+y]=d,p[24+y]=d,p[32+y]=d,p[40+y]=d,p[48+y]=d,p[56+y]=d)}for(v=0;v<64;++v){var b=128+(p[v]+8>>4);n[v]=b<0?0:b>255?255:b}}(t.blocks[u][l],s,a);for(var h=0,d=l<<3,p=0;p<8;p++)for(var v=n[f+p],m=0;m<8;m++)v[d+m]=s[h++]}}return n}Object.defineProperty(t,"__esModule",{value:!0});var s=n(12),u=r(s),f=n(15),c=r(f),l=n(3),h=r(l),d=n(4),p=r(d),v=n(31),m=r(v),y=n(19),b=r(y),g=new Int32Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]),w=4017,_=799,x=3406,k=2276,S=1567,O=3784,E=5793,T=2896,A=function(){function e(){(0,h.default)(this,e),this.jfif=null,this.adobe=null,this.quantizationTables=[],this.huffmanTablesAC=[],this.huffmanTablesDC=[],this.resetFrames()}return(0,p.default)(e,[{key:"resetFrames",value:function(){this.frames=[]}},{key:"parse",value:function(e){function t(){var t=e[n]<<8|e[n+1];return n+=2,t}var n=0,r=t();if(65496!==r)throw new Error("SOI not found");for(r=t();65497!==r;){switch(r){case 65280:break;case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:var a=function(){var r=t(),i=e.subarray(n,n+r-2);return n+=i.length,i}();65504===r&&74===a[0]&&70===a[1]&&73===a[2]&&70===a[3]&&0===a[4]&&(this.jfif={version:{major:a[5],minor:a[6]},densityUnits:a[7],xDensity:a[8]<<8|a[9],yDensity:a[10]<<8|a[11],thumbWidth:a[12],thumbHeight:a[13],thumbData:a.subarray(14,14+3*a[12]*a[13])}),65518===r&&65===a[0]&&100===a[1]&&111===a[2]&&98===a[3]&&101===a[4]&&0===a[5]&&(this.adobe={version:a[6],flags0:a[7]<<8|a[8],flags1:a[9]<<8|a[10],transformCode:a[11]});break;case 65499:for(var s=t(),u=s+n-2;n<u;){var f=e[n++],c=new Int32Array(64);if(f>>4==0)for(var l=0;l<64;l++){var h=g[l];c[h]=e[n++]}else{if(f>>4!=1)throw new Error("DQT: invalid table spec");for(var d=0;d<64;d++){c[g[d]]=t()}}this.quantizationTables[15&f]=c}break;case 65472:case 65473:case 65474:t();for(var p={extended:65473===r,progressive:65474===r,precision:e[n++],scanLines:t(),samplesPerLine:t(),components:{},componentsOrder:[]},v=e[n++],m=void 0,y=0;y<v;y++){m=e[n];var b=e[n+1]>>4,w=15&e[n+1],_=e[n+2];p.componentsOrder.push(m),p.components[m]={h:b,v:w,quantizationIdx:_},n+=3}!function(e){var t=0,n=0,r=void 0,i=void 0;for(i in e.components)e.components.hasOwnProperty(i)&&(r=e.components[i],t<r.h&&(t=r.h),n<r.v&&(n=r.v));var o=Math.ceil(e.samplesPerLine/8/t),a=Math.ceil(e.scanLines/8/n);for(i in e.components)if(e.components.hasOwnProperty(i)){r=e.components[i];for(var s=Math.ceil(Math.ceil(e.samplesPerLine/8)*r.h/t),u=Math.ceil(Math.ceil(e.scanLines/8)*r.v/n),f=o*r.h,c=a*r.v,l=[],h=0;h<c;h++){for(var d=[],p=0;p<f;p++)d.push(new Int32Array(64));l.push(d)}r.blocksPerLine=s,r.blocksPerColumn=u,r.blocks=l}e.maxH=t,e.maxV=n,e.mcusPerLine=o,e.mcusPerColumn=a}(p),this.frames.push(p);break;case 65476:for(var x=t(),k=2;k<x;){for(var S=e[n++],O=new Uint8Array(16),E=0,T=0;T<16;T++,n++)O[T]=e[n],E+=O[T];for(var A=new Uint8Array(E),P=0;P<E;P++,n++)A[P]=e[n];k+=17+E,S>>4==0?this.huffmanTablesDC[15&S]=i(O,A):this.huffmanTablesAC[15&S]=i(O,A)}break;case 65501:t(),this.resetInterval=t();break;case 65498:t();for(var I=e[n++],N=[],C=this.frames[0],M=0;M<I;M++){var D=C.components[e[n++]],j=e[n++];D.huffmanTableDC=this.huffmanTablesDC[j>>4],D.huffmanTableAC=this.huffmanTablesAC[15&j],N.push(D)}var R=e[n++],L=e[n++],F=e[n++],U=o(e,n,C,N,this.resetInterval,R,L,F>>4,15&F);n+=U;break;case 65535:255!==e[n]&&n--;break;default:if(255===e[n-3]&&e[n-2]>=192&&e[n-2]<=254){n-=3;break}throw new Error("unknown JPEG marker "+r.toString(16))}r=t()}}},{key:"getResult",value:function(){var e=this.frames;if(0===this.frames.length)throw new Error("no frames were decoded");this.frames.length>1&&console.warn("more than one frame is not supported");for(var t=0;t<this.frames.length;t++){var n=this.frames[t].components,r=!0,i=!1,o=void 0;try{for(var s,u=Object.keys(n)[Symbol.iterator]();!(r=(s=u.next()).done);r=!0){var f=s.value;n[f].quantizationTable=this.quantizationTables[n[f].quantizationIdx],delete n[f].quantizationIdx}}catch(e){i=!0,o=e}finally{try{!r&&u.return&&u.return()}finally{if(i)throw o}}}for(var c=e[0],l=c.components,h=c.componentsOrder,d=[],p=c.samplesPerLine,v=c.scanLines,m=0;m<h.length;m++){var y=l[h[m]];d.push({lines:a(c,y),scaleX:y.h/c.maxH,scaleY:y.v/c.maxV})}for(var b=new Uint8Array(p*v*d.length),g=0,w=0;w<v;++w)for(var _=0;_<p;++_)for(var x=0;x<d.length;++x){var k=d[x];b[g]=k.lines[0|w*k.scaleY][0|_*k.scaleX],++g}return b}}]),e}(),P=function(e){function t(e){(0,h.default)(this,t);var n=(0,u.default)(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.reader=new A,e.JPEGTables&&n.reader.parse(e.JPEGTables),n}return(0,c.default)(t,e),(0,p.default)(t,[{key:"decodeBlock",value:function(e){return this.reader.resetFrames(),this.reader.parse(new Uint8Array(e)),this.reader.getResult().buffer}}]),t}(b.default);t.default=P},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=n(12),f=r(u),c=n(15),l=r(c),h=n(132),d=n(19),p=r(d),v=function(e){function t(){return(0,o.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,s.default)(t,[{key:"decodeBlock",value:function(e){return(0,h.inflate)(new Uint8Array(e)).buffer}}]),t}(p.default);t.default=v},function(e,t,n){"use strict";function r(e){if(!(this instanceof r))return new r(e);this.options=s.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&t.windowBits>=0&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(t.windowBits>=0&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),t.windowBits>15&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new l,this.strm.avail_out=0;var n=a.inflateInit2(this.strm,t.windowBits);if(n!==f.Z_OK)throw new Error(c[n]);this.header=new h,a.inflateGetHeader(this.strm,this.header)}function i(e,t){var n=new r(t);if(n.push(e,!0),n.err)throw n.msg||c[n.err];return n.result}function o(e,t){return t=t||{},t.raw=!0,i(e,t)}var a=n(133),s=n(29),u=n(138),f=n(139),c=n(140),l=n(141),h=n(142),d=Object.prototype.toString;r.prototype.push=function(e,t){var n,r,i,o,c,l,h=this.strm,p=this.options.chunkSize,v=this.options.dictionary,m=!1;if(this.ended)return!1;r=t===~~t?t:!0===t?f.Z_FINISH:f.Z_NO_FLUSH,"string"==typeof e?h.input=u.binstring2buf(e):"[object ArrayBuffer]"===d.call(e)?h.input=new Uint8Array(e):h.input=e,h.next_in=0,h.avail_in=h.input.length;do{if(0===h.avail_out&&(h.output=new s.Buf8(p),h.next_out=0,h.avail_out=p),n=a.inflate(h,f.Z_NO_FLUSH),n===f.Z_NEED_DICT&&v&&(l="string"==typeof v?u.string2buf(v):"[object ArrayBuffer]"===d.call(v)?new Uint8Array(v):v,n=a.inflateSetDictionary(this.strm,l)),n===f.Z_BUF_ERROR&&!0===m&&(n=f.Z_OK,m=!1),n!==f.Z_STREAM_END&&n!==f.Z_OK)return this.onEnd(n),this.ended=!0,!1;h.next_out&&(0!==h.avail_out&&n!==f.Z_STREAM_END&&(0!==h.avail_in||r!==f.Z_FINISH&&r!==f.Z_SYNC_FLUSH)||("string"===this.options.to?(i=u.utf8border(h.output,h.next_out),o=h.next_out-i,c=u.buf2string(h.output,i),h.next_out=o,h.avail_out=p-o,o&&s.arraySet(h.output,h.output,i,o,0),this.onData(c)):this.onData(s.shrinkBuf(h.output,h.next_out)))),0===h.avail_in&&0===h.avail_out&&(m=!0)}while((h.avail_in>0||0===h.avail_out)&&n!==f.Z_STREAM_END);return n===f.Z_STREAM_END&&(r=f.Z_FINISH),r===f.Z_FINISH?(n=a.inflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===f.Z_OK):r!==f.Z_SYNC_FLUSH||(this.onEnd(f.Z_OK),h.avail_out=0,!0)},r.prototype.onData=function(e){this.chunks.push(e)},r.prototype.onEnd=function(e){e===f.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=s.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},t.Inflate=r,t.inflate=i,t.inflateRaw=o,t.ungzip=i},function(e,t,n){"use strict";function r(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function i(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new b.Buf16(320),this.work=new b.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function o(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=L,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new b.Buf32(ve),t.distcode=t.distdyn=new b.Buf32(me),t.sane=1,t.back=-1,P):C}function a(e){var t;return e&&e.state?(t=e.state,t.wsize=0,t.whave=0,t.wnext=0,o(e)):C}function s(e,t){var n,r;return e&&e.state?(r=e.state,t<0?(n=0,t=-t):(n=1+(t>>4),t<48&&(t&=15)),t&&(t<8||t>15)?C:(null!==r.window&&r.wbits!==t&&(r.window=null),r.wrap=n,r.wbits=t,a(e))):C}function u(e,t){var n,r;return e?(r=new i,e.state=r,r.window=null,n=s(e,t),n!==P&&(e.state=null),n):C}function f(e){return u(e,ye)}function c(e){if(be){var t;for(m=new b.Buf32(512),y=new b.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(x(S,e.lens,0,288,m,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;x(O,e.lens,0,32,y,0,e.work,{bits:5}),be=!1}e.lencode=m,e.lenbits=9,e.distcode=y,e.distbits=5}function l(e,t,n,r){var i,o=e.state;return null===o.window&&(o.wsize=1<<o.wbits,o.wnext=0,o.whave=0,o.window=new b.Buf8(o.wsize)),r>=o.wsize?(b.arraySet(o.window,t,n-o.wsize,o.wsize,0),o.wnext=0,o.whave=o.wsize):(i=o.wsize-o.wnext,i>r&&(i=r),b.arraySet(o.window,t,n-r,i,o.wnext),r-=i,r?(b.arraySet(o.window,t,n-r,r,0),o.wnext=r,o.whave=o.wsize):(o.wnext+=i,o.wnext===o.wsize&&(o.wnext=0),o.whave<o.wsize&&(o.whave+=i))),0}function h(e,t){var n,i,o,a,s,u,f,h,d,p,v,m,y,ve,me,ye,be,ge,we,_e,xe,ke,Se,Oe,Ee=0,Te=new b.Buf8(4),Ae=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return C;n=e.state,n.mode===q&&(n.mode=Y),s=e.next_out,o=e.output,f=e.avail_out,a=e.next_in,i=e.input,u=e.avail_in,h=n.hold,d=n.bits,p=u,v=f,ke=P;e:for(;;)switch(n.mode){case L:if(0===n.wrap){n.mode=Y;break}for(;d<16;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(2&n.wrap&&35615===h){n.check=0,Te[0]=255&h,Te[1]=h>>>8&255,n.check=w(n.check,Te,2,0),h=0,d=0,n.mode=F;break}if(n.flags=0,n.head&&(n.head.done=!1),!(1&n.wrap)||(((255&h)<<8)+(h>>8))%31){e.msg="incorrect header check",n.mode=he;break}if((15&h)!==R){e.msg="unknown compression method",n.mode=he;break}if(h>>>=4,d-=4,xe=8+(15&h),0===n.wbits)n.wbits=xe;else if(xe>n.wbits){e.msg="invalid window size",n.mode=he;break}n.dmax=1<<xe,e.adler=n.check=1,n.mode=512&h?V:q,h=0,d=0;break;case F:for(;d<16;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(n.flags=h,(255&n.flags)!==R){e.msg="unknown compression method",n.mode=he;break}if(57344&n.flags){e.msg="unknown header flags set",n.mode=he;break}n.head&&(n.head.text=h>>8&1),512&n.flags&&(Te[0]=255&h,Te[1]=h>>>8&255,n.check=w(n.check,Te,2,0)),h=0,d=0,n.mode=U;case U:for(;d<32;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.head&&(n.head.time=h),512&n.flags&&(Te[0]=255&h,Te[1]=h>>>8&255,Te[2]=h>>>16&255,Te[3]=h>>>24&255,n.check=w(n.check,Te,4,0)),h=0,d=0,n.mode=B;case B:for(;d<16;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.head&&(n.head.xflags=255&h,n.head.os=h>>8),512&n.flags&&(Te[0]=255&h,Te[1]=h>>>8&255,n.check=w(n.check,Te,2,0)),h=0,d=0,n.mode=G;case G:if(1024&n.flags){for(;d<16;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.length=h,n.head&&(n.head.extra_len=h),512&n.flags&&(Te[0]=255&h,Te[1]=h>>>8&255,n.check=w(n.check,Te,2,0)),h=0,d=0}else n.head&&(n.head.extra=null);n.mode=Z;case Z:if(1024&n.flags&&(m=n.length,m>u&&(m=u),m&&(n.head&&(xe=n.head.extra_len-n.length,n.head.extra||(n.head.extra=new Array(n.head.extra_len)),b.arraySet(n.head.extra,i,a,m,xe)),512&n.flags&&(n.check=w(n.check,i,m,a)),u-=m,a+=m,n.length-=m),n.length))break e;n.length=0,n.mode=H;case H:if(2048&n.flags){if(0===u)break e;m=0;do{xe=i[a+m++],n.head&&xe&&n.length<65536&&(n.head.name+=String.fromCharCode(xe))}while(xe&&m<u);if(512&n.flags&&(n.check=w(n.check,i,m,a)),u-=m,a+=m,xe)break e}else n.head&&(n.head.name=null);n.length=0,n.mode=z;case z:if(4096&n.flags){if(0===u)break e;m=0;do{xe=i[a+m++],n.head&&xe&&n.length<65536&&(n.head.comment+=String.fromCharCode(xe))}while(xe&&m<u);if(512&n.flags&&(n.check=w(n.check,i,m,a)),u-=m,a+=m,xe)break e}else n.head&&(n.head.comment=null);n.mode=K;case K:if(512&n.flags){for(;d<16;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(h!==(65535&n.check)){e.msg="header crc mismatch",n.mode=he;break}h=0,d=0}n.head&&(n.head.hcrc=n.flags>>9&1,n.head.done=!0),e.adler=n.check=0,n.mode=q;break;case V:for(;d<32;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}e.adler=n.check=r(h),h=0,d=0,n.mode=W;case W:if(0===n.havedict)return e.next_out=s,e.avail_out=f,e.next_in=a,e.avail_in=u,n.hold=h,n.bits=d,N;e.adler=n.check=1,n.mode=q;case q:if(t===T||t===A)break e;case Y:if(n.last){h>>>=7&d,d-=7&d,n.mode=fe;break}for(;d<3;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}switch(n.last=1&h,h>>>=1,d-=1,3&h){case 0:n.mode=X;break;case 1:if(c(n),n.mode=ne,t===A){h>>>=2,d-=2;break e}break;case 2:n.mode=Q;break;case 3:e.msg="invalid block type",n.mode=he}h>>>=2,d-=2;break;case X:for(h>>>=7&d,d-=7&d;d<32;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if((65535&h)!=(h>>>16^65535)){e.msg="invalid stored block lengths",n.mode=he;break}if(n.length=65535&h,h=0,d=0,n.mode=$,t===A)break e;case $:n.mode=J;case J:if(m=n.length){if(m>u&&(m=u),m>f&&(m=f),0===m)break e;b.arraySet(o,i,a,m,s),u-=m,a+=m,f-=m,s+=m,n.length-=m;break}n.mode=q;break;case Q:for(;d<14;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(n.nlen=257+(31&h),h>>>=5,d-=5,n.ndist=1+(31&h),h>>>=5,d-=5,n.ncode=4+(15&h),h>>>=4,d-=4,n.nlen>286||n.ndist>30){e.msg="too many length or distance symbols",n.mode=he;break}n.have=0,n.mode=ee;case ee:for(;n.have<n.ncode;){for(;d<3;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.lens[Ae[n.have++]]=7&h,h>>>=3,d-=3}for(;n.have<19;)n.lens[Ae[n.have++]]=0;if(n.lencode=n.lendyn,n.lenbits=7,Se={bits:n.lenbits},ke=x(k,n.lens,0,19,n.lencode,0,n.work,Se),n.lenbits=Se.bits,ke){e.msg="invalid code lengths set",n.mode=he;break}n.have=0,n.mode=te;case te:for(;n.have<n.nlen+n.ndist;){for(;Ee=n.lencode[h&(1<<n.lenbits)-1],me=Ee>>>24,ye=Ee>>>16&255,be=65535&Ee,!(me<=d);){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(be<16)h>>>=me,d-=me,n.lens[n.have++]=be;else{if(16===be){for(Oe=me+2;d<Oe;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(h>>>=me,d-=me,0===n.have){e.msg="invalid bit length repeat",n.mode=he;break}xe=n.lens[n.have-1],m=3+(3&h),h>>>=2,d-=2}else if(17===be){for(Oe=me+3;d<Oe;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}h>>>=me,d-=me,xe=0,m=3+(7&h),h>>>=3,d-=3}else{for(Oe=me+7;d<Oe;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}h>>>=me,d-=me,xe=0,m=11+(127&h),h>>>=7,d-=7}if(n.have+m>n.nlen+n.ndist){e.msg="invalid bit length repeat",n.mode=he;break}for(;m--;)n.lens[n.have++]=xe}}if(n.mode===he)break;if(0===n.lens[256]){e.msg="invalid code -- missing end-of-block",n.mode=he;break}if(n.lenbits=9,Se={bits:n.lenbits},ke=x(S,n.lens,0,n.nlen,n.lencode,0,n.work,Se),n.lenbits=Se.bits,ke){e.msg="invalid literal/lengths set",n.mode=he;break}if(n.distbits=6,n.distcode=n.distdyn,Se={bits:n.distbits},ke=x(O,n.lens,n.nlen,n.ndist,n.distcode,0,n.work,Se),n.distbits=Se.bits,ke){e.msg="invalid distances set",n.mode=he;break}if(n.mode=ne,t===A)break e;case ne:n.mode=re;case re:if(u>=6&&f>=258){e.next_out=s,e.avail_out=f,e.next_in=a,e.avail_in=u,n.hold=h,n.bits=d,_(e,v),s=e.next_out,o=e.output,f=e.avail_out,a=e.next_in,i=e.input,u=e.avail_in,h=n.hold,d=n.bits,n.mode===q&&(n.back=-1);break}for(n.back=0;Ee=n.lencode[h&(1<<n.lenbits)-1],me=Ee>>>24,ye=Ee>>>16&255,be=65535&Ee,!(me<=d);){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(ye&&0==(240&ye)){for(ge=me,we=ye,_e=be;Ee=n.lencode[_e+((h&(1<<ge+we)-1)>>ge)],me=Ee>>>24,ye=Ee>>>16&255,be=65535&Ee,!(ge+me<=d);){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}h>>>=ge,d-=ge,n.back+=ge}if(h>>>=me,d-=me,n.back+=me,n.length=be,0===ye){n.mode=ue;break}if(32&ye){n.back=-1,n.mode=q;break}if(64&ye){e.msg="invalid literal/length code",n.mode=he;break}n.extra=15&ye,n.mode=ie;case ie:if(n.extra){for(Oe=n.extra;d<Oe;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.length+=h&(1<<n.extra)-1,h>>>=n.extra,d-=n.extra,n.back+=n.extra}n.was=n.length,n.mode=oe;case oe:for(;Ee=n.distcode[h&(1<<n.distbits)-1],me=Ee>>>24,ye=Ee>>>16&255,be=65535&Ee,!(me<=d);){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(0==(240&ye)){for(ge=me,we=ye,_e=be;Ee=n.distcode[_e+((h&(1<<ge+we)-1)>>ge)],me=Ee>>>24,ye=Ee>>>16&255,be=65535&Ee,!(ge+me<=d);){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}h>>>=ge,d-=ge,n.back+=ge}if(h>>>=me,d-=me,n.back+=me,64&ye){e.msg="invalid distance code",n.mode=he;break}n.offset=be,n.extra=15&ye,n.mode=ae;case ae:if(n.extra){for(Oe=n.extra;d<Oe;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}n.offset+=h&(1<<n.extra)-1,h>>>=n.extra,d-=n.extra,n.back+=n.extra}if(n.offset>n.dmax){e.msg="invalid distance too far back",n.mode=he;break}n.mode=se;case se:if(0===f)break e;if(m=v-f,n.offset>m){if((m=n.offset-m)>n.whave&&n.sane){e.msg="invalid distance too far back",n.mode=he;break}m>n.wnext?(m-=n.wnext,y=n.wsize-m):y=n.wnext-m,m>n.length&&(m=n.length),ve=n.window}else ve=o,y=s-n.offset,m=n.length;m>f&&(m=f),f-=m,n.length-=m;do{o[s++]=ve[y++]}while(--m);0===n.length&&(n.mode=re);break;case ue:if(0===f)break e;o[s++]=n.length,f--,n.mode=re;break;case fe:if(n.wrap){for(;d<32;){if(0===u)break e;u--,h|=i[a++]<<d,d+=8}if(v-=f,e.total_out+=v,n.total+=v,v&&(e.adler=n.check=n.flags?w(n.check,o,v,s-v):g(n.check,o,v,s-v)),v=f,(n.flags?h:r(h))!==n.check){e.msg="incorrect data check",n.mode=he;break}h=0,d=0}n.mode=ce;case ce:if(n.wrap&&n.flags){for(;d<32;){if(0===u)break e;u--,h+=i[a++]<<d,d+=8}if(h!==(4294967295&n.total)){e.msg="incorrect length check",n.mode=he;break}h=0,d=0}n.mode=le;case le:ke=I;break e;case he:ke=M;break e;case de:return D;case pe:default:return C}return e.next_out=s,e.avail_out=f,e.next_in=a,e.avail_in=u,n.hold=h,n.bits=d,(n.wsize||v!==e.avail_out&&n.mode<he&&(n.mode<fe||t!==E))&&l(e,e.output,e.next_out,v-e.avail_out)?(n.mode=de,D):(p-=e.avail_in,v-=e.avail_out,e.total_in+=p,e.total_out+=v,n.total+=v,n.wrap&&v&&(e.adler=n.check=n.flags?w(n.check,o,v,e.next_out-v):g(n.check,o,v,e.next_out-v)),e.data_type=n.bits+(n.last?64:0)+(n.mode===q?128:0)+(n.mode===ne||n.mode===$?256:0),(0===p&&0===v||t===E)&&ke===P&&(ke=j),ke)}function d(e){if(!e||!e.state)return C;var t=e.state;return t.window&&(t.window=null),e.state=null,P}function p(e,t){var n;return e&&e.state?(n=e.state,0==(2&n.wrap)?C:(n.head=t,t.done=!1,P)):C}function v(e,t){var n,r,i=t.length;return e&&e.state?(n=e.state,0!==n.wrap&&n.mode!==W?C:n.mode===W&&(r=1,(r=g(r,t,i,0))!==n.check)?M:l(e,t,i,i)?(n.mode=de,D):(n.havedict=1,P)):C}var m,y,b=n(29),g=n(134),w=n(135),_=n(136),x=n(137),k=0,S=1,O=2,E=4,T=5,A=6,P=0,I=1,N=2,C=-2,M=-3,D=-4,j=-5,R=8,L=1,F=2,U=3,B=4,G=5,Z=6,H=7,z=8,K=9,V=10,W=11,q=12,Y=13,X=14,$=15,J=16,Q=17,ee=18,te=19,ne=20,re=21,ie=22,oe=23,ae=24,se=25,ue=26,fe=27,ce=28,le=29,he=30,de=31,pe=32,ve=852,me=592,ye=15,be=!0;t.inflateReset=a,t.inflateReset2=s,t.inflateResetKeep=o,t.inflateInit=f,t.inflateInit2=u,t.inflate=h,t.inflateEnd=d,t.inflateGetHeader=p,t.inflateSetDictionary=v,t.inflateInfo="pako inflate (from Nodeca project)"},function(e,t,n){"use strict";function r(e,t,n,r){for(var i=65535&e|0,o=e>>>16&65535|0,a=0;0!==n;){a=n>2e3?2e3:n,n-=a;do{i=i+t[r++]|0,o=o+i|0}while(--a);i%=65521,o%=65521}return i|o<<16|0}e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){var o=i,a=r+n;e^=-1;for(var s=r;s<a;s++)e=e>>>8^o[255&(e^t[s])];return-1^e}var i=function(){for(var e,t=[],n=0;n<256;n++){e=n;for(var r=0;r<8;r++)e=1&e?3988292384^e>>>1:e>>>1;t[n]=e}return t}();e.exports=r},function(e,t,n){"use strict";e.exports=function(e,t){var n,r,i,o,a,s,u,f,c,l,h,d,p,v,m,y,b,g,w,_,x,k,S,O,E;n=e.state,r=e.next_in,O=e.input,i=r+(e.avail_in-5),o=e.next_out,E=e.output,a=o-(t-e.avail_out),s=o+(e.avail_out-257),u=n.dmax,f=n.wsize,c=n.whave,l=n.wnext,h=n.window,d=n.hold,p=n.bits,v=n.lencode,m=n.distcode,y=(1<<n.lenbits)-1,b=(1<<n.distbits)-1;e:do{p<15&&(d+=O[r++]<<p,p+=8,d+=O[r++]<<p,p+=8),g=v[d&y];t:for(;;){if(w=g>>>24,d>>>=w,p-=w,0===(w=g>>>16&255))E[o++]=65535&g;else{if(!(16&w)){if(0==(64&w)){g=v[(65535&g)+(d&(1<<w)-1)];continue t}if(32&w){n.mode=12;break e}e.msg="invalid literal/length code",n.mode=30;break e}_=65535&g,w&=15,w&&(p<w&&(d+=O[r++]<<p,p+=8),_+=d&(1<<w)-1,d>>>=w,p-=w),p<15&&(d+=O[r++]<<p,p+=8,d+=O[r++]<<p,p+=8),g=m[d&b];n:for(;;){if(w=g>>>24,d>>>=w,p-=w,!(16&(w=g>>>16&255))){if(0==(64&w)){g=m[(65535&g)+(d&(1<<w)-1)];continue n}e.msg="invalid distance code",n.mode=30;break e}if(x=65535&g,w&=15,p<w&&(d+=O[r++]<<p,(p+=8)<w&&(d+=O[r++]<<p,p+=8)),(x+=d&(1<<w)-1)>u){e.msg="invalid distance too far back",n.mode=30;break e}if(d>>>=w,p-=w,w=o-a,x>w){if((w=x-w)>c&&n.sane){e.msg="invalid distance too far back",n.mode=30;break e}if(k=0,S=h,0===l){if(k+=f-w,w<_){_-=w;do{E[o++]=h[k++]}while(--w);k=o-x,S=E}}else if(l<w){if(k+=f+l-w,(w-=l)<_){_-=w;do{E[o++]=h[k++]}while(--w);if(k=0,l<_){w=l,_-=w;do{E[o++]=h[k++]}while(--w);k=o-x,S=E}}}else if(k+=l-w,w<_){_-=w;do{E[o++]=h[k++]}while(--w);k=o-x,S=E}for(;_>2;)E[o++]=S[k++],E[o++]=S[k++],E[o++]=S[k++],_-=3;_&&(E[o++]=S[k++],_>1&&(E[o++]=S[k++]))}else{k=o-x;do{E[o++]=E[k++],E[o++]=E[k++],E[o++]=E[k++],_-=3}while(_>2);_&&(E[o++]=E[k++],_>1&&(E[o++]=E[k++]))}break}}break}}while(r<i&&o<s);_=p>>3,r-=_,p-=_<<3,d&=(1<<p)-1,e.next_in=r,e.next_out=o,e.avail_in=r<i?i-r+5:5-(r-i),e.avail_out=o<s?s-o+257:257-(o-s),n.hold=d,n.bits=p}},function(e,t,n){"use strict";var r=n(29),i=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],o=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],a=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],s=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function(e,t,n,u,f,c,l,h){var d,p,v,m,y,b,g,w,_,x=h.bits,k=0,S=0,O=0,E=0,T=0,A=0,P=0,I=0,N=0,C=0,M=null,D=0,j=new r.Buf16(16),R=new r.Buf16(16),L=null,F=0;for(k=0;k<=15;k++)j[k]=0;for(S=0;S<u;S++)j[t[n+S]]++;for(T=x,E=15;E>=1&&0===j[E];E--);if(T>E&&(T=E),0===E)return f[c++]=20971520,f[c++]=20971520,h.bits=1,0;for(O=1;O<E&&0===j[O];O++);for(T<O&&(T=O),I=1,k=1;k<=15;k++)if(I<<=1,(I-=j[k])<0)return-1;if(I>0&&(0===e||1!==E))return-1;for(R[1]=0,k=1;k<15;k++)R[k+1]=R[k]+j[k];for(S=0;S<u;S++)0!==t[n+S]&&(l[R[t[n+S]]++]=S);if(0===e?(M=L=l,b=19):1===e?(M=i,D-=257,L=o,F-=257,b=256):(M=a,L=s,b=-1),C=0,S=0,k=O,y=c,A=T,P=0,v=-1,N=1<<T,m=N-1,1===e&&N>852||2===e&&N>592)return 1;for(;;){g=k-P,l[S]<b?(w=0,_=l[S]):l[S]>b?(w=L[F+l[S]],_=M[D+l[S]]):(w=96,_=0),d=1<<k-P,p=1<<A,O=p;do{p-=d,f[y+(C>>P)+p]=g<<24|w<<16|_|0}while(0!==p);for(d=1<<k-1;C&d;)d>>=1;if(0!==d?(C&=d-1,C+=d):C=0,S++,0==--j[k]){if(k===E)break;k=t[n+l[S]]}if(k>T&&(C&m)!==v){for(0===P&&(P=T),y+=O,A=k-P,I=1<<A;A+P<E&&!((I-=j[A+P])<=0);)A++,I<<=1;if(N+=1<<A,1===e&&N>852||2===e&&N>592)return 1;v=C&m,f[v]=T<<24|A<<16|y-c|0}}return 0!==C&&(f[y+C]=k-P<<24|64<<16|0),h.bits=T,0}},function(e,t,n){"use strict";function r(e,t){if(t<65537&&(e.subarray&&a||!e.subarray&&o))return String.fromCharCode.apply(null,i.shrinkBuf(e,t));for(var n="",r=0;r<t;r++)n+=String.fromCharCode(e[r]);return n}var i=n(29),o=!0,a=!0;try{String.fromCharCode.apply(null,[0])}catch(e){o=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){a=!1}for(var s=new i.Buf8(256),u=0;u<256;u++)s[u]=u>=252?6:u>=248?5:u>=240?4:u>=224?3:u>=192?2:1;s[254]=s[254]=1,t.string2buf=function(e){var t,n,r,o,a,s=e.length,u=0;for(o=0;o<s;o++)n=e.charCodeAt(o),55296==(64512&n)&&o+1<s&&56320==(64512&(r=e.charCodeAt(o+1)))&&(n=65536+(n-55296<<10)+(r-56320),o++),u+=n<128?1:n<2048?2:n<65536?3:4;for(t=new i.Buf8(u),a=0,o=0;a<u;o++)n=e.charCodeAt(o),55296==(64512&n)&&o+1<s&&56320==(64512&(r=e.charCodeAt(o+1)))&&(n=65536+(n-55296<<10)+(r-56320),o++),n<128?t[a++]=n:n<2048?(t[a++]=192|n>>>6,t[a++]=128|63&n):n<65536?(t[a++]=224|n>>>12,t[a++]=128|n>>>6&63,t[a++]=128|63&n):(t[a++]=240|n>>>18,t[a++]=128|n>>>12&63,t[a++]=128|n>>>6&63,t[a++]=128|63&n);return t},t.buf2binstring=function(e){return r(e,e.length)},t.binstring2buf=function(e){for(var t=new i.Buf8(e.length),n=0,r=t.length;n<r;n++)t[n]=e.charCodeAt(n);return t},t.buf2string=function(e,t){var n,i,o,a,u=t||e.length,f=new Array(2*u);for(i=0,n=0;n<u;)if((o=e[n++])<128)f[i++]=o;else if((a=s[o])>4)f[i++]=65533,n+=a-1;else{for(o&=2===a?31:3===a?15:7;a>1&&n<u;)o=o<<6|63&e[n++],a--;a>1?f[i++]=65533:o<65536?f[i++]=o:(o-=65536,f[i++]=55296|o>>10&1023,f[i++]=56320|1023&o)}return r(f,i)},t.utf8border=function(e,t){var n;for(t=t||e.length,t>e.length&&(t=e.length),n=t-1;n>=0&&128==(192&e[n]);)n--;return n<0?t:0===n?t:n+s[e[n]]>t?n:t}},function(e,t,n){"use strict";e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},function(e,t,n){"use strict";e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},function(e,t,n){"use strict";function r(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}e.exports=r},function(e,t,n){"use strict";function r(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=n(12),f=r(u),c=n(15),l=r(c),h=n(19),d=r(h),p=function(e){function t(){return(0,o.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,s.default)(t,[{key:"decodeBlock",value:function(e){for(var t=new DataView(e),n=[],r=0;r<e.byteLength;++r){var i=t.getInt8(r);if(i<0){var o=t.getUint8(r+1);i=-i;for(var a=0;a<=i;++a)n.push(o);r+=1}else{for(var s=0;s<=i;++s)n.push(t.getUint8(r+s+1));r+=i+1}}return new Uint8Array(n).buffer}}]),t}(d.default);t.default=p},function(e,t,n){"use strict";function r(e,t,n){var r=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1;return new(Object.getPrototypeOf(e).constructor)(t*n*r)}function i(e,t,n,i,o){var a=t/i,s=n/o;return e.map(function(e){for(var u=r(e,i,o),f=0;f<o;++f)for(var c=Math.min(Math.round(s*f),n-1),l=0;l<i;++l){var h=Math.min(Math.round(a*l),t-1),d=e[c*t+h];u[f*i+l]=d}return u})}function o(e,t,n){return(1-n)*e+n*t}function a(e,t,n,i,a){var s=t/i,u=n/a;return e.map(function(e){for(var f=r(e,i,a),c=0;c<a;++c)for(var l=u*c,h=Math.floor(l),d=Math.min(Math.ceil(l),n-1),p=0;p<i;++p){var v=s*p,m=v%1,y=Math.floor(v),b=Math.min(Math.ceil(v),t-1),g=e[h*t+y],w=e[h*t+b],_=e[d*t+y],x=e[d*t+b],k=o(o(g,w,m),o(_,x,m),l%1);f[c*i+p]=k}return f})}function s(e,t,n,r,o){var s=arguments.length>5&&void 0!==arguments[5]?arguments[5]:"nearest";switch(s.toLowerCase()){case"nearest":return i(e,t,n,r,o);case"bilinear":case"linear":return a(e,t,n,r,o);default:throw new Error("Unsupported resampling method: '"+s+"'")}}function u(e,t,n,i,o,a){for(var s=t/i,u=n/o,f=r(e,i,o,a),c=0;c<o;++c)for(var l=Math.min(Math.round(u*c),n-1),h=0;h<i;++h)for(var d=Math.min(Math.round(s*h),t-1),p=0;p<a;++p){var v=e[l*t*a+d*a+p];f[c*i*a+h*a+p]=v}return f}function f(e,t,n,i,a,s){for(var u=t/i,f=n/a,c=r(e,i,a,s),l=0;l<a;++l)for(var h=f*l,d=Math.floor(h),p=Math.min(Math.ceil(h),n-1),v=0;v<i;++v)for(var m=u*v,y=m%1,b=Math.floor(m),g=Math.min(Math.ceil(m),t-1),w=0;w<s;++w){var _=e[d*t*s+b*s+w],x=e[d*t*s+g*s+w],k=e[p*t*s+b*s+w],S=e[p*t*s+g*s+w],O=o(o(_,x,y),o(k,S,y),h%1);c[l*i*s+v*s+w]=O}return c}function c(e,t,n,r,i,o){var a=arguments.length>6&&void 0!==arguments[6]?arguments[6]:"nearest";switch(a.toLowerCase()){case"nearest":return u(e,t,n,r,i,o);case"bilinear":case"linear":return f(e,t,n,r,i,o);default:throw new Error("Unsupported resampling method: '"+a+"'")}}Object.defineProperty(t,"__esModule",{value:!0}),t.resampleNearest=i,t.resampleBilinear=a,t.resample=s,t.resampleNearestInterleaved=u,t.resampleBilinearInterleaved=f,t.resampleInterleaved=c},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=function(){function e(t){(0,o.default)(this,e),this._dataView=new DataView(t)}return(0,s.default)(e,[{key:"getUint64",value:function(e,t){var n=this.getUint32(e,t),r=this.getUint32(e+4,t);return t?n<<32|r:r<<32|n}},{key:"getInt64",value:function(e,t){var n=void 0,r=void 0;return t?(n=this.getInt32(e,t),r=this.getUint32(e+4,t),n<<32|r):(n=this.getUint32(e,t),(r=this.getInt32(e+4,t))<<32|n)}},{key:"getUint8",value:function(e,t){return this._dataView.getUint8(e,t)}},{key:"getInt8",value:function(e,t){return this._dataView.getInt8(e,t)}},{key:"getUint16",value:function(e,t){return this._dataView.getUint16(e,t)}},{key:"getInt16",value:function(e,t){return this._dataView.getInt16(e,t)}},{key:"getUint32",value:function(e,t){return this._dataView.getUint32(e,t)}},{key:"getInt32",value:function(e,t){return this._dataView.getInt32(e,t)}},{key:"getFloat32",value:function(e,t){return this._dataView.getFloat32(e,t)}},{key:"getFloat64",value:function(e,t){return this._dataView.getFloat64(e,t)}},{key:"buffer",get:function(){return this._dataView.buffer}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(3),o=r(i),a=n(4),s=r(a),u=function(){function e(t,n,r,i){(0,o.default)(this,e),this._dataView=new DataView(t),this._sliceOffset=n,this._littleEndian=r,this._bigTiff=i}return(0,s.default)(e,[{key:"covers",value:function(e,t){return this.sliceOffset<=e&&this.sliceTop>=e+t}},{key:"readUint8",value:function(e){return this._dataView.getUint8(e-this._sliceOffset,this._littleEndian)}},{key:"readInt8",value:function(e){return this._dataView.getInt8(e-this._sliceOffset,this._littleEndian)}},{key:"readUint16",value:function(e){return this._dataView.getUint16(e-this._sliceOffset,this._littleEndian)}},{key:"readInt16",value:function(e){return this._dataView.getInt16(e-this._sliceOffset,this._littleEndian)}},{key:"readUint32",value:function(e){return this._dataView.getUint32(e-this._sliceOffset,this._littleEndian)}},{key:"readInt32",value:function(e){return this._dataView.getInt32(e-this._sliceOffset,this._littleEndian)}},{key:"readFloat32",value:function(e){return this._dataView.getFloat32(e-this._sliceOffset,this._littleEndian)}},{key:"readFloat64",value:function(e){return this._dataView.getFloat64(e-this._sliceOffset,this._littleEndian)}},{key:"readUint64",value:function(e){var t=this.readUint32(e),n=this.readUint32(e+4);return this._littleEndian?t<<32|n:n<<32|t}},{key:"readInt64",value:function(e){var t=void 0,n=void 0;return this._littleEndian?(t=this.readInt32(e),n=this.readUint32(e+4),t<<32|n):(t=this.readUint32(e-this._sliceOffset),(n=this.readInt32(e-this._sliceOffset+4))<<32|t)}},{key:"readOffset",value:function(e){return this._bigTiff?this.readUint64(e):this.readUint32(e)}},{key:"sliceOffset",get:function(){return this._sliceOffset}},{key:"sliceTop",get:function(){return this._sliceOffset+this.buffer.byteLength}},{key:"littleEndian",get:function(){return this._littleEndian}},{key:"bigTiff",get:function(){return this._bigTiff}},{key:"buffer",get:function(){return this._dataView.buffer}}]),e}();t.default=u},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function i(e,t,n){var r=t+n,i=new ArrayBuffer(n),o=new Uint8Array(i),a=!0,s=!1,u=void 0;try{for(var f,c=e[Symbol.iterator]();!(a=(f=c.next()).done);a=!0){var l=f.value,h=l.offset-t,d=l.top-r,p=0,v=0,m=void 0;h<0?p=-h:h>0&&(v=h),d<0?m=l.length-p:d>0&&(m=r-l.offset-p);var y=new Uint8Array(l.data,p,m);o.set(y,v)}}catch(e){s=!0,u=e}finally{try{!a&&c.return&&c.return()}finally{if(s)throw u}}return i}function o(e){if(0===e.length)return[];var t=[],n=[];t.push(n);for(var r=0;r<e.length;++r)0===r||e[r]===e[r-1]+1?n.push(e[r]):(n=[e[r]],t.push(n));return t}function a(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.headers,i=void 0===r?{}:r,o=n.blockSize;return new D(function(){var n=(0,S.default)(x.default.mark(function n(r,o){var a,s,u;return x.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.next=2,fetch(e,{headers:Object.assign({},i,{Range:"bytes="+r+"-"+(r+o)})});case 2:if(a=t.sent,a.ok){t.next=7;break}throw new Error("Error fetching data.");case 7:if(206!==a.status){t.next=21;break}if(!a.arrayBuffer){t.next=14;break}return t.next=11,a.arrayBuffer();case 11:t.t0=t.sent,t.next=17;break;case 14:return t.next=16,a.buffer();case 16:t.t0=t.sent.buffer;case 17:return s=t.t0,t.abrupt("return",{data:s,offset:r,length:o});case 21:if(!a.arrayBuffer){t.next=27;break}return t.next=24,a.arrayBuffer();case 24:t.t1=t.sent,t.next=30;break;case 27:return t.next=29,a.buffer();case 29:t.t1=t.sent.buffer;case 30:return u=t.t1,t.abrupt("return",{data:u,offset:0,length:u.byteLength});case 32:case"end":return t.stop()}},n,t)}));return function(e,t){return n.apply(this,arguments)}}(),{blockSize:o})}function s(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.headers,i=void 0===r?{}:r,o=n.blockSize;return new D(function(){var n=(0,S.default)(x.default.mark(function n(r,o){return x.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",new Promise(function(t,n){var a=new XMLHttpRequest;a.open("GET",e),a.responseType="arraybuffer",Object.entries(Object.assign({},i,{Range:"bytes="+r+"-"+(r+o)})).forEach(function(e){var t=(0,m.default)(e,2),n=t[0],r=t[1];return a.setRequestHeader(n,r)}),a.onload=function(){var e=a.response;t(206===a.status?{data:e,offset:r,length:o}:{data:e,offset:0,length:e.byteLength})},a.onerror=n,a.send()}));case 1:case"end":return t.stop()}},n,t)}));return function(e,t){return n.apply(this,arguments)}}(),{blockSize:o})}function u(e){var t=this,n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.headers,i=void 0===r?{}:r,o=n.blockSize;return new D(function(){var n=(0,S.default)(x.default.mark(function n(r,o){return x.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",new Promise(function(t,n){var a=M.default.parse(e);("http:"===a.protocol?P.default:N.default).get(Object.assign({},a,{headers:Object.assign({},i,{Range:"bytes="+r+"-"+(r+o)})}),function(e){var n=[];e.on("data",function(e){n.push(e)}),e.on("end",function(){var e=E.Buffer.concat(n).buffer;t({data:e,offset:r,length:e.byteLength})})}).on("error",n)}));case 1:case"end":return t.stop()}},n,t)}));return function(e,t){return n.apply(this,arguments)}}(),{blockSize:o})}function f(e,t){var n=t.forceXHR;if("function"==typeof fetch&&!n)return a(e,t);if("undefined"!=typeof XMLHttpRequest)return s(e,t);if(P.default.get)return u(e,t);throw new Error("No remote source available")}function c(e){return{fetch:function(){function t(e,t){return n.apply(this,arguments)}var n=(0,S.default)(x.default.mark(function t(n,r){return x.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",e.slice(n,n+r));case 1:case"end":return t.stop()}},t,this)}));return t}()}}function l(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:void 0;return new Promise(function(r,i){(0,T.open)(e,t,n,function(e,t){e?i(e):r(t)})})}function h(){for(var e=arguments.length,t=Array(e),n=0;n<e;n++)t[n]=arguments[n];return new Promise(function(e,n){T.read.apply(void 0,t.concat([function(t,r,i){t?n(t):e({bytesRead:r,buffer:i})}]))})}function d(e){var t=l(e,"r");return{fetch:function(){function e(e,t){return n.apply(this,arguments)}var n=(0,S.default)(x.default.mark(function e(n,r){var i,o,a;return x.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,t;case 2:return i=e.sent,e.next=5,h(i,E.Buffer.alloc(r),0,r,n);case 5:return o=e.sent,a=o.buffer,e.abrupt("return",a.buffer);case 8:case"end":return e.stop()}},e,this)}));return e}()}}function p(e){return{fetch:function(){function t(e,t){return n.apply(this,arguments)}var n=(0,S.default)(x.default.mark(function t(n,r){return x.default.wrap(function(t){for(;;)switch(t.prev=t.next){case 0:return t.abrupt("return",new Promise(function(t,i){var o=e.slice(n,n+r),a=new FileReader;a.onload=function(e){return t(e.target.result)},a.onerror=i,a.readAsArrayBuffer(o)}));case 1:case"end":return t.stop()}},t,this)}));return t}()}}Object.defineProperty(t,"__esModule",{value:!0});var v=n(44),m=r(v),y=n(3),b=r(y),g=n(4),w=r(g),_=n(27),x=r(_),k=n(28),S=r(k),O=function(){var e=(0,S.default)(x.default.mark(function e(t){return x.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.abrupt("return",new Promise(function(e){return setTimeout(e,t)}));case 1:case"end":return e.stop()}},e,this)}));return function(t){return e.apply(this,arguments)}}();t.makeFetchSource=a,t.makeXHRSource=s,t.makeHttpSource=u,t.makeRemoteSource=f,t.makeBufferSource=c,t.makeFileSource=d,t.makeFileReaderSource=p;var E=n(30),T=n(30),A=n(30),P=r(A),I=n(148),N=r(I),C=n(65),M=r(C),D=function(){function e(t){var n=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=n.blockSize,i=void 0===r?65535:r;(0,b.default)(this,e),this.retrievalFunction=t,this.blockSize=i,this.blockRequests=new Map,this.blocks=new Map,this.blockIdsAwaitingRequest=null}return(0,w.default)(e,[{key:"fetch",value:function(){function e(e,n){return t.apply(this,arguments)}var t=(0,S.default)(x.default.mark(function e(t,n){var r,a,s,u,f,c,l,h,d,p,v,m,y,b,g,w,_,k,E,T,A,P,I,N,C,M=this,D=arguments.length>2&&void 0!==arguments[2]&&arguments[2];return x.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:for(r=t+n,a=Math.floor(t/this.blockSize)*this.blockSize,s=[],u=[],f=[],c=a;c<r;c+=this.blockSize)l=Math.floor(c/this.blockSize),this.blocks.has(l)||this.blockRequests.has(l)||u.push(l),this.blockRequests.has(l)&&f.push(this.blockRequests.get(l)),s.push(l);if(this.blockIdsAwaitingRequest)for(h=0;h<u.length;++h)d=u[h],this.blockIdsAwaitingRequest.add(d);else this.blockIdsAwaitingRequest=new Set(u);if(D){e.next=10;break}return e.next=10,O();case 10:if(!this.blockIdsAwaitingRequest){e.next=33;break}for(p=o(Array.from(this.blockIdsAwaitingRequest).sort()),v=function(e){for(var t=M.requestData(e[0]*M.blockSize,e.length*M.blockSize),n=0;n<e.length;++n)!function(n){var r=e[n];M.blockRequests.set(r,(0,S.default)(x.default.mark(function e(){var i,o,a,s;return x.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,t;case 2:i=e.sent,o=n*M.blockSize,a=Math.min(o+M.blockSize,i.data.byteLength),s=i.data.slice(o,a),M.blockRequests.delete(r),M.blocks.set(r,{data:s,offset:i.offset+o,length:s.byteLength,top:i.offset+a});case 8:case"end":return e.stop()}},e,M)}))())}(n)},m=!0,y=!1,b=void 0,e.prev=16,g=p[Symbol.iterator]();!(m=(w=g.next()).done);m=!0)_=w.value,v(_);e.next=24;break;case 20:e.prev=20,e.t0=e.catch(16),y=!0,b=e.t0;case 24:e.prev=24,e.prev=25,!m&&g.return&&g.return();case 27:if(e.prev=27,!y){e.next=30;break}throw b;case 30:return e.finish(27);case 31:return e.finish(24);case 32:this.blockIdsAwaitingRequest=null;case 33:for(k=[],E=!0,T=!1,A=void 0,e.prev=37,P=u[Symbol.iterator]();!(E=(I=P.next()).done);E=!0)N=I.value,this.blockRequests.has(N)&&k.push(this.blockRequests.get(N));e.next=45;break;case 41:e.prev=41,e.t1=e.catch(37),T=!0,A=e.t1;case 45:e.prev=45,e.prev=46,!E&&P.return&&P.return();case 48:if(e.prev=48,!T){e.next=51;break}throw A;case 51:return e.finish(48);case 52:return e.finish(45);case 53:return e.next=55,Promise.all(k);case 55:return e.next=57,Promise.all(f);case 57:return C=s.map(function(e){return M.blocks.get(e)}),e.abrupt("return",i(C,t,n));case 59:case"end":return e.stop()}},e,this,[[16,20,24,32],[25,,27,31],[37,41,45,53],[46,,48,52]])}));return e}()},{key:"requestData",value:function(){function e(e,n){return t.apply(this,arguments)}var t=(0,S.default)(x.default.mark(function e(t,n){var r;return x.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.retrievalFunction(t,n);case 2:return r=e.sent,r.length?r.length!==r.data.byteLength&&(r.data=r.data.slice(0,r.length)):r.length=r.data.byteLength,r.top=r.offset+r.length,e.abrupt("return",r);case 6:case"end":return e.stop()}},e,this)}));return e}()}]),e}()},function(e,t,n){function r(e){if("string"==typeof e&&(e=o.parse(e)),e.protocol||(e.protocol="https:"),"https:"!==e.protocol)throw new Error('Protocol "'+e.protocol+'" not supported. Expected "https:"');return e}var i=n(30),o=n(65),a=e.exports;for(var s in i)i.hasOwnProperty(s)&&(a[s]=i[s]);a.request=function(e,t){return e=r(e),i.request.call(this,e,t)},a.get=function(e,t){return e=r(e),i.get.call(this,e,t)}},function(e,t,n){(function(e,r){var i;!function(o){function a(e){throw new RangeError(C[e])}function s(e,t){for(var n=e.length,r=[];n--;)r[n]=t(e[n]);return r}function u(e,t){var n=e.split("@"),r="";return n.length>1&&(r=n[0]+"@",e=n[1]),e=e.replace(N,"."),r+s(e.split("."),t).join(".")}function f(e){for(var t,n,r=[],i=0,o=e.length;i<o;)t=e.charCodeAt(i++),t>=55296&&t<=56319&&i<o?(n=e.charCodeAt(i++),56320==(64512&n)?r.push(((1023&t)<<10)+(1023&n)+65536):(r.push(t),i--)):r.push(t);return r}function c(e){return s(e,function(e){var t="";return e>65535&&(e-=65536,t+=j(e>>>10&1023|55296),e=56320|1023&e),t+=j(e)}).join("")}function l(e){return e-48<10?e-22:e-65<26?e-65:e-97<26?e-97:_}function h(e,t){return e+22+75*(e<26)-((0!=t)<<5)}function d(e,t,n){var r=0;for(e=n?D(e/O):e>>1,e+=D(e/t);e>M*k>>1;r+=_)e=D(e/M);return D(r+(M+1)*e/(e+S))}function p(e){var t,n,r,i,o,s,u,f,h,p,v=[],m=e.length,y=0,b=T,g=E;for(n=e.lastIndexOf(A),n<0&&(n=0),r=0;r<n;++r)e.charCodeAt(r)>=128&&a("not-basic"),v.push(e.charCodeAt(r));for(i=n>0?n+1:0;i<m;){for(o=y,s=1,u=_;i>=m&&a("invalid-input"),f=l(e.charCodeAt(i++)),(f>=_||f>D((w-y)/s))&&a("overflow"),y+=f*s,h=u<=g?x:u>=g+k?k:u-g,!(f<h);u+=_)p=_-h,s>D(w/p)&&a("overflow"),s*=p;t=v.length+1,g=d(y-o,t,0==o),D(y/t)>w-b&&a("overflow"),b+=D(y/t),y%=t,v.splice(y++,0,b)}return c(v)}function v(e){var t,n,r,i,o,s,u,c,l,p,v,m,y,b,g,S=[];for(e=f(e),m=e.length,t=T,n=0,o=E,s=0;s<m;++s)(v=e[s])<128&&S.push(j(v));for(r=i=S.length,i&&S.push(A);r<m;){for(u=w,s=0;s<m;++s)(v=e[s])>=t&&v<u&&(u=v);for(y=r+1,u-t>D((w-n)/y)&&a("overflow"),n+=(u-t)*y,t=u,s=0;s<m;++s)if(v=e[s],v<t&&++n>w&&a("overflow"),v==t){for(c=n,l=_;p=l<=o?x:l>=o+k?k:l-o,!(c<p);l+=_)g=c-p,b=_-p,S.push(j(h(p+g%b,0))),c=D(g/b);S.push(j(h(c,0))),o=d(n,y,r==i),n=0,++r}++n,++t}return S.join("")}function m(e){return u(e,function(e){return P.test(e)?p(e.slice(4).toLowerCase()):e})}function y(e){return u(e,function(e){return I.test(e)?"xn--"+v(e):e})}var b=("object"==typeof t&&t&&t.nodeType,"object"==typeof e&&e&&e.nodeType,"object"==typeof r&&r);var g,w=2147483647,_=36,x=1,k=26,S=38,O=700,E=72,T=128,A="-",P=/^xn--/,I=/[^\x20-\x7E]/,N=/[\x2E\u3002\uFF0E\uFF61]/g,C={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},M=_-x,D=Math.floor,j=String.fromCharCode;g={version:"1.4.1",ucs2:{decode:f,encode:c},decode:p,encode:v,toASCII:y,toUnicode:m},void 0!==(i=function(){return g}.call(t,n,t,e))&&(e.exports=i)}()}).call(t,n(150)(e),n(151))},function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e}},function(e,t){var n;n=function(){return this}();try{n=n||Function("return this")()||(0,eval)("this")}catch(e){"object"==typeof window&&(n=window)}e.exports=n},function(e,t,n){"use strict";e.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},function(e,t,n){"use strict";t.decode=t.parse=n(154),t.encode=t.stringify=n(155)},function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}e.exports=function(e,t,n,o){t=t||"&",n=n||"=";var a={};if("string"!=typeof e||0===e.length)return a;var s=/\+/g;e=e.split(t);var u=1e3;o&&"number"==typeof o.maxKeys&&(u=o.maxKeys);var f=e.length;u>0&&f>u&&(f=u);for(var c=0;c<f;++c){var l,h,d,p,v=e[c].replace(s,"%20"),m=v.indexOf(n);m>=0?(l=v.substr(0,m),h=v.substr(m+1)):(l=v,h=""),d=decodeURIComponent(l),p=decodeURIComponent(h),r(a,d)?i(a[d])?a[d].push(p):a[d]=[a[d],p]:a[d]=p}return a};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},function(e,t,n){"use strict";function r(e,t){if(e.map)return e.map(t);for(var n=[],r=0;r<e.length;r++)n.push(t(e[r],r));return n}var i=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,n,s){return t=t||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?r(a(e),function(a){var s=encodeURIComponent(i(a))+n;return o(e[a])?r(e[a],function(e){return s+encodeURIComponent(i(e))}).join(t):s+encodeURIComponent(i(e[a]))}).join(t):s?encodeURIComponent(i(s))+n+encodeURIComponent(i(e)):""};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)},a=Object.keys||function(e){var t=[];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.push(n);return t}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var i=n(27),o=r(i),a=n(28),s=r(a),u=n(3),f=r(u),c=n(4),l=r(c),h=n(157),d=r(h),p="undefined"!=typeof navigator?navigator.hardwareConcurrency:null,v=function(){function e(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:p;(0,f.default)(this,e),this.workers=[],this.idleWorkers=[],this.waitQueue=[],this.decoder=null;for(var n=0;n<t;++n){var r=new d.default;this.workers.push(r),this.idleWorkers.push(r)}}return(0,l.default)(e,[{key:"decode",value:function(){function e(e,n){return t.apply(this,arguments)}var t=(0,s.default)(o.default.mark(function e(t,n){var r,i=this;return o.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:return e.next=2,this.waitForWorker();case 2:return r=e.sent,e.abrupt("return",new Promise(function(e,o){r.onmessage=function(t){i.finishTask(r),e(t.data[0])},r.onerror=function(e){i.finishTask(r),o(e)},r.postMessage(["decode",t,n],[n])}));case 4:case"end":return e.stop()}},e,this)}));return e}()},{key:"waitForWorker",value:function(){function e(){return t.apply(this,arguments)}var t=(0,s.default)(o.default.mark(function e(){var t,n,r;return o.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:if(!(t=this.idleWorkers.pop())){e.next=3;break}return e.abrupt("return",t);case 3:return n={},r=new Promise(function(e){n.resolve=e}),this.waitQueue.push(n),e.abrupt("return",r);case 7:case"end":return e.stop()}},e,this)}));return e}()},{key:"finishTask",value:function(){function e(e){return t.apply(this,arguments)}var t=(0,s.default)(o.default.mark(function e(t){var n;return o.default.wrap(function(e){for(;;)switch(e.prev=e.next){case 0:n=this.waitQueue.pop(),n?n.resolve(t):this.idleWorkers.push(t);case 2:case"end":return e.stop()}},e,this)}));return e}()},{key:"destroy",value:function(){for(var e=0;e<this.workers.length;++e)this.workers[e].terminate()}}]),e}();t.default=v},function(e,t,n){e.exports=function(){return n(158)('!function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=49)}([function(e,t,n){var r=n(30)("wks"),o=n(20),i=n(2).Symbol,a="function"==typeof i;(e.exports=function(e){return r[e]||(r[e]=a&&i[e]||(a?i:o)("Symbol."+e))}).store=r},function(e,t){var n=e.exports={version:"2.5.7"};"number"==typeof __e&&(__e=n)},function(e,t){var n=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=n)},function(e,t,n){var r=n(8),o=n(40),i=n(25),a=Object.defineProperty;t.f=n(4)?Object.defineProperty:function(e,t,n){if(r(e),t=i(t,!0),r(n),o)try{return a(e,t,n)}catch(e){}if("get"in n||"set"in n)throw TypeError("Accessors not supported!");return"value"in n&&(e[t]=n.value),e}},function(e,t,n){e.exports=!n(19)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(e,t){var n={}.hasOwnProperty;e.exports=function(e,t){return n.call(e,t)}},function(e,t,n){var r=n(2),o=n(1),i=n(24),a=n(7),u=n(5),s=function(e,t,n){var f,c,l,d=e&s.F,h=e&s.G,p=e&s.S,v=e&s.P,b=e&s.B,y=e&s.W,m=h?o:o[t]||(o[t]={}),w=m.prototype,_=h?r:p?r[t]:(r[t]||{}).prototype;h&&(n=t);for(f in n)(c=!d&&_&&void 0!==_[f])&&u(m,f)||(l=c?_[f]:n[f],m[f]=h&&"function"!=typeof _[f]?n[f]:b&&c?i(l,r):y&&_[f]==l?function(e){var t=function(t,n,r){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,n)}return new e(t,n,r)}return e.apply(this,arguments)};return t.prototype=e.prototype,t}(l):v&&"function"==typeof l?i(Function.call,l):l,v&&((m.virtual||(m.virtual={}))[f]=l,e&s.R&&w&&!w[f]&&a(w,f,l)))};s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,s.U=64,s.R=128,e.exports=s},function(e,t,n){var r=n(3),o=n(13);e.exports=n(4)?function(e,t,n){return r.f(e,t,o(1,n))}:function(e,t,n){return e[t]=n,e}},function(e,t,n){var r=n(9);e.exports=function(e){if(!r(e))throw TypeError(e+" is not an object!");return e}},function(e,t){e.exports=function(e){return"object"==typeof e?null!==e:"function"==typeof e}},function(e,t,n){var r=n(56),o=n(23);e.exports=function(e){return r(o(e))}},function(e,t,n){"use strict";t.__esModule=!0,t.default=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(71),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(){function e(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),(0,o.default)(e,r.key,r)}}return function(t,n,r){return n&&e(t.prototype,n),r&&e(t,r),t}}()},function(e,t){e.exports=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}}},function(e,t){e.exports={}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(33),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e,t){if(!e)throw new ReferenceError("this hasn\'t been initialised - super() hasn\'t been called");return!t||"object"!==(void 0===t?"undefined":(0,o.default)(t))&&"function"!=typeof t?e:t}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(90),i=r(o),a=n(94),u=r(a),s=n(33),f=r(s);t.default=function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+(void 0===t?"undefined":(0,f.default)(t)));e.prototype=(0,u.default)(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(i.default?(0,i.default)(e,t):e.__proto__=t)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(12),u=r(a),s=n(97),f=function(){function e(){(0,i.default)(this,e)}return(0,u.default)(e,[{key:"decode",value:function(e,t){var n=this.decodeBlock(t),r=e.Predictor||1;if(1!==r){var o=!e.StripOffsets,i=o?e.TileWidth:e.ImageWidth,a=o?e.TileLength:e.RowsPerStrip||e.ImageLength;return(0,s.applyPredictor)(n,r,i,a,e.BitsPerSample)}return n}}]),e}();t.default=f},function(e,t){e.exports=!0},function(e,t){e.exports=function(e){try{return!!e()}catch(e){return!0}}},function(e,t){var n=0,r=Math.random();e.exports=function(e){return"Symbol(".concat(void 0===e?"":e,")_",(++n+r).toString(36))}},function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var o="undefined"!=typeof Uint8Array&&"undefined"!=typeof Uint16Array&&"undefined"!=typeof Int32Array;t.assign=function(e){for(var t=Array.prototype.slice.call(arguments,1);t.length;){var n=t.shift();if(n){if("object"!=typeof n)throw new TypeError(n+"must be non-object");for(var o in n)r(n,o)&&(e[o]=n[o])}}return e},t.shrinkBuf=function(e,t){return e.length===t?e:e.subarray?e.subarray(0,t):(e.length=t,e)};var i={arraySet:function(e,t,n,r,o){if(t.subarray&&e.subarray)return void e.set(t.subarray(n,n+r),o);for(var i=0;i<r;i++)e[o+i]=t[n+i]},flattenChunks:function(e){var t,n,r,o,i,a;for(r=0,t=0,n=e.length;t<n;t++)r+=e[t].length;for(a=new Uint8Array(r),o=0,t=0,n=e.length;t<n;t++)i=e[t],a.set(i,o),o+=i.length;return a}},a={arraySet:function(e,t,n,r,o){for(var i=0;i<r;i++)e[o+i]=t[n+i]},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){e?(t.Buf8=Uint8Array,t.Buf16=Uint16Array,t.Buf32=Int32Array,t.assign(t,i)):(t.Buf8=Array,t.Buf16=Array,t.Buf32=Array,t.assign(t,a))},t.setTyped(o)},function(e,t){var n=Math.ceil,r=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?r:n)(e)}},function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can\'t call method on  "+e);return e}},function(e,t,n){var r=n(53);e.exports=function(e,t,n){if(r(e),void 0===t)return e;switch(n){case 1:return function(n){return e.call(t,n)};case 2:return function(n,r){return e.call(t,n,r)};case 3:return function(n,r,o){return e.call(t,n,r,o)}}return function(){return e.apply(t,arguments)}}},function(e,t,n){var r=n(9);e.exports=function(e,t){if(!r(e))return e;var n,o;if(t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;if("function"==typeof(n=e.valueOf)&&!r(o=n.call(e)))return o;if(!t&&"function"==typeof(n=e.toString)&&!r(o=n.call(e)))return o;throw TypeError("Can\'t convert object to primitive value")}},function(e,t,n){var r=n(8),o=n(55),i=n(31),a=n(29)("IE_PROTO"),u=function(){},s=function(){var e,t=n(41)("iframe"),r=i.length;for(t.style.display="none",n(59).appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write("<script>document.F=Object<\\/script>"),e.close(),s=e.F;r--;)delete s.prototype[i[r]];return s()};e.exports=Object.create||function(e,t){var n;return null!==e?(u.prototype=r(e),n=new u,u.prototype=null,n[a]=e):n=s(),void 0===t?n:o(n,t)}},function(e,t,n){var r=n(43),o=n(31);e.exports=Object.keys||function(e){return r(e,o)}},function(e,t){var n={}.toString;e.exports=function(e){return n.call(e).slice(8,-1)}},function(e,t,n){var r=n(30)("keys"),o=n(20);e.exports=function(e){return r[e]||(r[e]=o(e))}},function(e,t,n){var r=n(1),o=n(2),i=o["__core-js_shared__"]||(o["__core-js_shared__"]={});(e.exports=function(e,t){return i[e]||(i[e]=void 0!==t?t:{})})("versions",[]).push({version:r.version,mode:n(18)?"pure":"global",copyright:"© 2018 Denis Pushkarev (zloirock.ru)"})},function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",")},function(e,t,n){var r=n(3).f,o=n(5),i=n(0)("toStringTag");e.exports=function(e,t,n){e&&!o(e=n?e:e.prototype,i)&&r(e,i,{configurable:!0,value:t})}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}t.__esModule=!0;var o=n(74),i=r(o),a=n(80),u=r(a),s="function"==typeof u.default&&"symbol"==typeof i.default?function(e){return typeof e}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":typeof e};t.default="function"==typeof u.default&&"symbol"===s(i.default)?function(e){return void 0===e?"undefined":s(e)}:function(e){return e&&"function"==typeof u.default&&e.constructor===u.default&&e!==u.default.prototype?"symbol":void 0===e?"undefined":s(e)}},function(e,t,n){t.f=n(0)},function(e,t,n){var r=n(2),o=n(1),i=n(18),a=n(34),u=n(3).f;e.exports=function(e){var t=o.Symbol||(o.Symbol=i?{}:r.Symbol||{});"_"==e.charAt(0)||e in t||u(t,e,{value:a.f(e)})}},function(e,t){t.f={}.propertyIsEnumerable},function(e,t,n){e.exports={default:n(51),__esModule:!0}},function(e,t,n){"use strict";var r=n(52)(!0);n(39)(String,"String",function(e){this._t=String(e),this._i=0},function(){var e,t=this._t,n=this._i;return n>=t.length?{value:void 0,done:!0}:(e=r(t,n),this._i+=e.length,{value:e,done:!1})})},function(e,t,n){"use strict";var r=n(18),o=n(6),i=n(42),a=n(7),u=n(14),s=n(54),f=n(32),c=n(60),l=n(0)("iterator"),d=!([].keys&&"next"in[].keys()),h=function(){return this};e.exports=function(e,t,n,p,v,b,y){s(n,t,p);var m,w,_,g=function(e){if(!d&&e in S)return S[e];switch(e){case"keys":case"values":return function(){return new n(this,e)}}return function(){return new n(this,e)}},k=t+" Iterator",x="values"==v,O=!1,S=e.prototype,E=S[l]||S["@@iterator"]||v&&S[v],A=E||g(v),P=v?x?g("entries"):A:void 0,M="Array"==t?S.entries||E:E;if(M&&(_=c(M.call(new e)))!==Object.prototype&&_.next&&(f(_,k,!0),r||"function"==typeof _[l]||a(_,l,h)),x&&E&&"values"!==E.name&&(O=!0,A=function(){return E.call(this)}),r&&!y||!d&&!O&&S[l]||a(S,l,A),u[t]=A,u[k]=h,v)if(m={values:x?A:g("values"),keys:b?A:g("keys"),entries:P},y)for(w in m)w in S||i(S,w,m[w]);else o(o.P+o.F*(d||O),t,m);return m}},function(e,t,n){e.exports=!n(4)&&!n(19)(function(){return 7!=Object.defineProperty(n(41)("div"),"a",{get:function(){return 7}}).a})},function(e,t,n){var r=n(9),o=n(2).document,i=r(o)&&r(o.createElement);e.exports=function(e){return i?o.createElement(e):{}}},function(e,t,n){e.exports=n(7)},function(e,t,n){var r=n(5),o=n(10),i=n(57)(!1),a=n(29)("IE_PROTO");e.exports=function(e,t){var n,u=o(e),s=0,f=[];for(n in u)n!=a&&r(u,n)&&f.push(n);for(;t.length>s;)r(u,n=t[s++])&&(~i(f,n)||f.push(n));return f}},function(e,t,n){var r=n(22),o=Math.min;e.exports=function(e){return e>0?o(r(e),9007199254740991):0}},function(e,t,n){var r=n(23);e.exports=function(e){return Object(r(e))}},function(e,t){t.f=Object.getOwnPropertySymbols},function(e,t,n){var r=n(43),o=n(31).concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return r(e,o)}},function(e,t,n){var r=n(36),o=n(13),i=n(10),a=n(25),u=n(5),s=n(40),f=Object.getOwnPropertyDescriptor;t.f=n(4)?f:function(e,t){if(e=i(e),t=a(t,!0),s)try{return f(e,t)}catch(e){}if(u(e,t))return o(!r.f.call(e,t),e[t])}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=(0,f.getDecoder)(t),o=r.decode(t,n);e.postMessage([o],[o])}var i=n(50),a=r(i),u=n(68),s=r(u),f=n(69);"undefined"!=typeof self&&self.addEventListener("message",function(e){var t=(0,s.default)(e.data),n=t[0],r=t.slice(1);switch(n){case"decode":o.apply(void 0,[self].concat((0,a.default)(r)))}})},function(e,t,n){"use strict";t.__esModule=!0;var r=n(37),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return(0,o.default)(e)}},function(e,t,n){n(38),n(61),e.exports=n(1).Array.from},function(e,t,n){var r=n(22),o=n(23);e.exports=function(e){return function(t,n){var i,a,u=String(o(t)),s=r(n),f=u.length;return s<0||s>=f?e?"":void 0:(i=u.charCodeAt(s),i<55296||i>56319||s+1===f||(a=u.charCodeAt(s+1))<56320||a>57343?e?u.charAt(s):i:e?u.slice(s,s+2):a-56320+(i-55296<<10)+65536)}}},function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e}},function(e,t,n){"use strict";var r=n(26),o=n(13),i=n(32),a={};n(7)(a,n(0)("iterator"),function(){return this}),e.exports=function(e,t,n){e.prototype=r(a,{next:o(1,n)}),i(e,t+" Iterator")}},function(e,t,n){var r=n(3),o=n(8),i=n(27);e.exports=n(4)?Object.defineProperties:function(e,t){o(e);for(var n,a=i(t),u=a.length,s=0;u>s;)r.f(e,n=a[s++],t[n]);return e}},function(e,t,n){var r=n(28);e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return"String"==r(e)?e.split(""):Object(e)}},function(e,t,n){var r=n(10),o=n(44),i=n(58);e.exports=function(e){return function(t,n,a){var u,s=r(t),f=o(s.length),c=i(a,f);if(e&&n!=n){for(;f>c;)if((u=s[c++])!=u)return!0}else for(;f>c;c++)if((e||c in s)&&s[c]===n)return e||c||0;return!e&&-1}}},function(e,t,n){var r=n(22),o=Math.max,i=Math.min;e.exports=function(e,t){return e=r(e),e<0?o(e+t,0):i(e,t)}},function(e,t,n){var r=n(2).document;e.exports=r&&r.documentElement},function(e,t,n){var r=n(5),o=n(45),i=n(29)("IE_PROTO"),a=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=o(e),r(e,i)?e[i]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?a:null}},function(e,t,n){"use strict";var r=n(24),o=n(6),i=n(45),a=n(62),u=n(63),s=n(44),f=n(64),c=n(65);o(o.S+o.F*!n(67)(function(e){Array.from(e)}),"Array",{from:function(e){var t,n,o,l,d=i(e),h="function"==typeof this?this:Array,p=arguments.length,v=p>1?arguments[1]:void 0,b=void 0!==v,y=0,m=c(d);if(b&&(v=r(v,p>2?arguments[2]:void 0,2)),void 0==m||h==Array&&u(m))for(t=s(d.length),n=new h(t);t>y;y++)f(n,y,b?v(d[y],y):d[y]);else for(l=m.call(d),n=new h;!(o=l.next()).done;y++)f(n,y,b?a(l,v,[o.value,y],!0):o.value);return n.length=y,n}})},function(e,t,n){var r=n(8);e.exports=function(e,t,n,o){try{return o?t(r(n)[0],n[1]):t(n)}catch(t){var i=e.return;throw void 0!==i&&r(i.call(e)),t}}},function(e,t,n){var r=n(14),o=n(0)("iterator"),i=Array.prototype;e.exports=function(e){return void 0!==e&&(r.Array===e||i[o]===e)}},function(e,t,n){"use strict";var r=n(3),o=n(13);e.exports=function(e,t,n){t in e?r.f(e,t,o(0,n)):e[t]=n}},function(e,t,n){var r=n(66),o=n(0)("iterator"),i=n(14);e.exports=n(1).getIteratorMethod=function(e){if(void 0!=e)return e[o]||e["@@iterator"]||i[r(e)]}},function(e,t,n){var r=n(28),o=n(0)("toStringTag"),i="Arguments"==r(function(){return arguments}()),a=function(e,t){try{return e[t]}catch(e){}};e.exports=function(e){var t,n,u;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(n=a(t=Object(e),o))?n:i?r(t):"Object"==(u=r(t))&&"function"==typeof t.callee?"Arguments":u}},function(e,t,n){var r=n(0)("iterator"),o=!1;try{var i=[7][r]();i.return=function(){o=!0},Array.from(i,function(){throw 2})}catch(e){}e.exports=function(e,t){if(!t&&!o)return!1;var n=!1;try{var i=[7],a=i[r]();a.next=function(){return{done:n=!0}},i[r]=function(){return a},e(i)}catch(e){}return n}},function(e,t,n){"use strict";t.__esModule=!0;var r=n(37),o=function(e){return e&&e.__esModule?e:{default:e}}(r);t.default=function(e){return Array.isArray(e)?e:(0,o.default)(e)}},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e){switch(e.Compression){case void 0:case 1:return new a.default;case 5:return new s.default;case 6:throw new Error("old style JPEG compression is not supported.");case 7:return new c.default(e);case 8:case 32946:return new d.default;case 32773:return new p.default;default:throw new Error("Unknown compression method identifier: "+e.Compression)}}Object.defineProperty(t,"__esModule",{value:!0}),t.getDecoder=o;var i=n(70),a=r(i),u=n(98),s=r(u),f=n(99),c=r(f),l=n(100),d=r(l),h=n(112),p=r(h)},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(12),u=r(a),s=n(15),f=r(s),c=n(16),l=r(c),d=n(17),h=r(d),p=function(e){function t(){return(0,i.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,u.default)(t,[{key:"decodeBlock",value:function(e){return e}}]),t}(h.default);t.default=p},function(e,t,n){e.exports={default:n(72),__esModule:!0}},function(e,t,n){n(73);var r=n(1).Object;e.exports=function(e,t,n){return r.defineProperty(e,t,n)}},function(e,t,n){var r=n(6);r(r.S+r.F*!n(4),"Object",{defineProperty:n(3).f})},function(e,t,n){e.exports={default:n(75),__esModule:!0}},function(e,t,n){n(38),n(76),e.exports=n(34).f("iterator")},function(e,t,n){n(77);for(var r=n(2),o=n(7),i=n(14),a=n(0)("toStringTag"),u="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<u.length;s++){var f=u[s],c=r[f],l=c&&c.prototype;l&&!l[a]&&o(l,a,f),i[f]=i.Array}},function(e,t,n){"use strict";var r=n(78),o=n(79),i=n(14),a=n(10);e.exports=n(39)(Array,"Array",function(e,t){this._t=a(e),this._i=0,this._k=t},function(){var e=this._t,t=this._k,n=this._i++;return!e||n>=e.length?(this._t=void 0,o(1)):"keys"==t?o(0,n):"values"==t?o(0,e[n]):o(0,[n,e[n]])},"values"),i.Arguments=i.Array,r("keys"),r("values"),r("entries")},function(e,t){e.exports=function(){}},function(e,t){e.exports=function(e,t){return{value:t,done:!!e}}},function(e,t,n){e.exports={default:n(81),__esModule:!0}},function(e,t,n){n(82),n(87),n(88),n(89),e.exports=n(1).Symbol},function(e,t,n){"use strict";var r=n(2),o=n(5),i=n(4),a=n(6),u=n(42),s=n(83).KEY,f=n(19),c=n(30),l=n(32),d=n(20),h=n(0),p=n(34),v=n(35),b=n(84),y=n(85),m=n(8),w=n(9),_=n(10),g=n(25),k=n(13),x=n(26),O=n(86),S=n(48),E=n(3),A=n(27),P=S.f,M=E.f,T=O.f,j=r.Symbol,C=r.JSON,L=C&&C.stringify,B=h("_hidden"),I=h("toPrimitive"),N={}.propertyIsEnumerable,Z=c("symbol-registry"),D=c("symbols"),R=c("op-symbols"),F=Object.prototype,U="function"==typeof j,z=r.QObject,H=!z||!z.prototype||!z.prototype.findChild,G=i&&f(function(){return 7!=x(M({},"a",{get:function(){return M(this,"a",{value:7}).a}})).a})?function(e,t,n){var r=P(F,t);r&&delete F[t],M(e,t,n),r&&e!==F&&M(F,t,r)}:M,K=function(e){var t=D[e]=x(j.prototype);return t._k=e,t},W=U&&"symbol"==typeof j.iterator?function(e){return"symbol"==typeof e}:function(e){return e instanceof j},q=function(e,t,n){return e===F&&q(R,t,n),m(e),t=g(t,!0),m(n),o(D,t)?(n.enumerable?(o(e,B)&&e[B][t]&&(e[B][t]=!1),n=x(n,{enumerable:k(0,!1)})):(o(e,B)||M(e,B,k(1,{})),e[B][t]=!0),G(e,t,n)):M(e,t,n)},V=function(e,t){m(e);for(var n,r=b(t=_(t)),o=0,i=r.length;i>o;)q(e,n=r[o++],t[n]);return e},Y=function(e,t){return void 0===t?x(e):V(x(e),t)},J=function(e){var t=N.call(this,e=g(e,!0));return!(this===F&&o(D,e)&&!o(R,e))&&(!(t||!o(this,e)||!o(D,e)||o(this,B)&&this[B][e])||t)},X=function(e,t){if(e=_(e),t=g(t,!0),e!==F||!o(D,t)||o(R,t)){var n=P(e,t);return!n||!o(D,t)||o(e,B)&&e[B][t]||(n.enumerable=!0),n}},Q=function(e){for(var t,n=T(_(e)),r=[],i=0;n.length>i;)o(D,t=n[i++])||t==B||t==s||r.push(t);return r},$=function(e){for(var t,n=e===F,r=T(n?R:_(e)),i=[],a=0;r.length>a;)!o(D,t=r[a++])||n&&!o(F,t)||i.push(D[t]);return i};U||(j=function(){if(this instanceof j)throw TypeError("Symbol is not a constructor!");var e=d(arguments.length>0?arguments[0]:void 0),t=function(n){this===F&&t.call(R,n),o(this,B)&&o(this[B],e)&&(this[B][e]=!1),G(this,e,k(1,n))};return i&&H&&G(F,e,{configurable:!0,set:t}),K(e)},u(j.prototype,"toString",function(){return this._k}),S.f=X,E.f=q,n(47).f=O.f=Q,n(36).f=J,n(46).f=$,i&&!n(18)&&u(F,"propertyIsEnumerable",J,!0),p.f=function(e){return K(h(e))}),a(a.G+a.W+a.F*!U,{Symbol:j});for(var ee="hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","),te=0;ee.length>te;)h(ee[te++]);for(var ne=A(h.store),re=0;ne.length>re;)v(ne[re++]);a(a.S+a.F*!U,"Symbol",{for:function(e){return o(Z,e+="")?Z[e]:Z[e]=j(e)},keyFor:function(e){if(!W(e))throw TypeError(e+" is not a symbol!");for(var t in Z)if(Z[t]===e)return t},useSetter:function(){H=!0},useSimple:function(){H=!1}}),a(a.S+a.F*!U,"Object",{create:Y,defineProperty:q,defineProperties:V,getOwnPropertyDescriptor:X,getOwnPropertyNames:Q,getOwnPropertySymbols:$}),C&&a(a.S+a.F*(!U||f(function(){var e=j();return"[null]"!=L([e])||"{}"!=L({a:e})||"{}"!=L(Object(e))})),"JSON",{stringify:function(e){for(var t,n,r=[e],o=1;arguments.length>o;)r.push(arguments[o++]);if(n=t=r[1],(w(t)||void 0!==e)&&!W(e))return y(t)||(t=function(e,t){if("function"==typeof n&&(t=n.call(this,e,t)),!W(t))return t}),r[1]=t,L.apply(C,r)}}),j.prototype[I]||n(7)(j.prototype,I,j.prototype.valueOf),l(j,"Symbol"),l(Math,"Math",!0),l(r.JSON,"JSON",!0)},function(e,t,n){var r=n(20)("meta"),o=n(9),i=n(5),a=n(3).f,u=0,s=Object.isExtensible||function(){return!0},f=!n(19)(function(){return s(Object.preventExtensions({}))}),c=function(e){a(e,r,{value:{i:"O"+ ++u,w:{}}})},l=function(e,t){if(!o(e))return"symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!i(e,r)){if(!s(e))return"F";if(!t)return"E";c(e)}return e[r].i},d=function(e,t){if(!i(e,r)){if(!s(e))return!0;if(!t)return!1;c(e)}return e[r].w},h=function(e){return f&&p.NEED&&s(e)&&!i(e,r)&&c(e),e},p=e.exports={KEY:r,NEED:!1,fastKey:l,getWeak:d,onFreeze:h}},function(e,t,n){var r=n(27),o=n(46),i=n(36);e.exports=function(e){var t=r(e),n=o.f;if(n)for(var a,u=n(e),s=i.f,f=0;u.length>f;)s.call(e,a=u[f++])&&t.push(a);return t}},function(e,t,n){var r=n(28);e.exports=Array.isArray||function(e){return"Array"==r(e)}},function(e,t,n){var r=n(10),o=n(47).f,i={}.toString,a="object"==typeof window&&window&&Object.getOwnPropertyNames?Object.getOwnPropertyNames(window):[],u=function(e){try{return o(e)}catch(e){return a.slice()}};e.exports.f=function(e){return a&&"[object Window]"==i.call(e)?u(e):o(r(e))}},function(e,t){},function(e,t,n){n(35)("asyncIterator")},function(e,t,n){n(35)("observable")},function(e,t,n){e.exports={default:n(91),__esModule:!0}},function(e,t,n){n(92),e.exports=n(1).Object.setPrototypeOf},function(e,t,n){var r=n(6);r(r.S,"Object",{setPrototypeOf:n(93).set})},function(e,t,n){var r=n(9),o=n(8),i=function(e,t){if(o(e),!r(t)&&null!==t)throw TypeError(t+": can\'t set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,r){try{r=n(24)(Function.call,n(48).f(Object.prototype,"__proto__").set,2),r(e,[]),t=!(e instanceof Array)}catch(e){t=!0}return function(e,n){return i(e,n),t?e.__proto__=n:r(e,n),e}}({},!1):void 0),check:i}},function(e,t,n){e.exports={default:n(95),__esModule:!0}},function(e,t,n){n(96);var r=n(1).Object;e.exports=function(e,t){return r.create(e,t)}},function(e,t,n){var r=n(6);r(r.S,"Object",{create:n(26)})},function(e,t,n){"use strict";function r(e,t){var n=e.length-t,r=0;do{for(var o=t;o>0;o--)e[r+t]+=e[r],r++;n-=t}while(n>0)}function o(e,t,n){for(var r=0,o=e.length,i=o/n;o>t;){for(var a=t;a>0;--a)e[r+t]+=e[r],++r;o-=t}for(var u=e.slice(),s=0;s<i;++s)for(var f=0;f<n;++f)e[n*s+f]=u[(n-f-1)*i+s]}function i(e,t,n,i,a){if(!t||1===t)return e;for(var u=0;u<a.length;++u){if(a[u]%8!=0)throw new Error("When decoding with predictor, only multiple of 8 bits are supported.");if(a[u]!==a[0])throw new Error("When decoding with predictor, all samples must have the same size.")}for(var s=a[0]/8,f=a.length,c=0;c<i;++c){var l=void 0;if(2===t){switch(a[0]){case 8:l=new Uint8Array(e,c*f*n*s,f*n*s);break;case 16:l=new Uint16Array(e,c*f*n*s,f*n*s/2);break;case 32:l=new Uint32Array(e,c*f*n*s,f*n*s/4);break;default:throw new Error("Predictor 2 not allowed with "+a[0]+" bits per sample.")}r(l,f,s)}else 3===t&&(l=new Uint8Array(e,c*f*n*s,n*s),o(l,f,s))}return e}Object.defineProperty(t,"__esModule",{value:!0}),t.applyPredictor=i},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t,n){var r=t%8,o=Math.floor(t/8),i=8-r,a=t+n-8*(o+1),u=8*(o+2)-(t+n),s=8*(o+2)-t;if(u=Math.max(0,u),o>=e.length)return console.warn("ran off the end of the buffer before finding EOI_CODE (end on input code)"),w;var f=e[o]&Math.pow(2,8-r)-1;f<<=n-i;var c=f;if(o+1<e.length){var l=e[o+1]>>>u;l<<=Math.max(0,n-s),c+=l}if(a>8&&o+2<e.length){var d=8*(o+3)-(t+n);c+=e[o+2]>>>d}return c}function i(e,t){for(var n=t.length-1;n>=0;n--)e.push(t[n]);return e}function a(e){function t(){c=258,l=y}function n(e){var t=o(e,d,l);return d+=l,t}function r(e,t){return s[c]=t,u[c]=e,c++,c>=Math.pow(2,l)&&l++,c-1}function a(e){for(var t=[],n=e;4096!==n;n=u[n])t.push(s[n]);return t}for(var u=new Uint16Array(4093),s=new Uint8Array(4093),f=0;f<=257;f++)u[f]=4096,s[f]=f;var c=258,l=y,d=0,h=[];t();for(var p=new Uint8Array(e),v=n(p),b=void 0;v!==w;){if(v===m){for(t(),v=n(p);v===m;)v=n(p);if(v>m)throw new Error("corrupted code at scanline "+v);if(v===w)break;i(h,a(v)),b=v}else if(v<c){var _=a(v);i(h,_),r(b,_[_.length-1]),b=v}else{var g=a(b);if(!g)throw new Error("Bogus entry. Not in dictionary, "+b+" / "+c+", position: "+d);i(h,g),h.push(g[g.length-1]),r(b,g[g.length-1]),b=v}c>=Math.pow(2,l)-1&&l++,v=n(p)}return new Uint8Array(h)}Object.defineProperty(t,"__esModule",{value:!0});var u=n(11),s=r(u),f=n(12),c=r(f),l=n(15),d=r(l),h=n(16),p=r(h),v=n(17),b=r(v),y=9,m=256,w=257,_=function(e){function t(){return(0,s.default)(this,t),(0,d.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,p.default)(t,e),(0,c.default)(t,[{key:"decodeBlock",value:function(e){return a(e).buffer}}]),t}(b.default);t.default=_},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}function o(e,t){for(var n=0,r=[],o=16;o>0&&!e[o-1];)--o;r.push({children:[],index:0});for(var i=r[0],a=void 0,u=0;u<o;u++){for(var s=0;s<e[u];s++){for(i=r.pop(),i.children[i.index]=t[n];i.index>0;)i=r.pop();for(i.index++,r.push(i);r.length<=u;)r.push(a={children:[],index:0}),i.children[i.index]=a.children,i=a;n++}u+1<o&&(r.push(a={children:[],index:0}),i.children[i.index]=a.children,i=a)}return r[0].children}function i(e,t,n,r,o,i,a,u,s){function f(){if(S>0)return S--,O>>S&1;if(255===(O=e[x++])){var t=e[x++];if(t)throw new Error("unexpected marker: "+(O<<8|t).toString(16))}return S=7,O>>>7}function c(e){for(var t=e,n=void 0;null!==(n=f());){if("number"==typeof(t=t[n]))return t;if("object"!==(void 0===t?"undefined":(0,b.default)(t)))throw new Error("invalid huffman sequence")}return null}function l(e){for(var t=e,n=0;t>0;){var r=f();if(null===r)return;n=n<<1|r,--t}return n}function d(e){var t=l(e);return t>=1<<e-1?t:t+(-1<<e)+1}function h(e,t){var n=c(e.huffmanTableDC),r=0===n?0:d(n);e.pred+=r,t[0]=e.pred;for(var o=1;o<64;){var i=c(e.huffmanTableAC),a=15&i,u=i>>4;if(0===a){if(u<15)break;o+=16}else{o+=u;t[w[o]]=d(a),o++}}}function p(e,t){var n=c(e.huffmanTableDC),r=0===n?0:d(n)<<s;e.pred+=r,t[0]=e.pred}function v(e,t){t[0]|=f()<<s}function y(e,t){if(E>0)return void E--;for(var n=i,r=a;n<=r;){var o=c(e.huffmanTableAC),u=15&o,f=o>>4;if(0===u){if(f<15){E=l(f)+(1<<f)-1;break}n+=16}else{n+=f;t[w[n]]=d(u)*(1<<s),n++}}}function m(e,t){for(var n=i,r=a,o=0;n<=r;){var u=w[n],h=t[u]<0?-1:1;switch(A){case 0:var p=c(e.huffmanTableAC),v=15&p;if(o=p>>4,0===v)o<15?(E=l(o)+(1<<o),A=4):(o=16,A=1);else{if(1!==v)throw new Error("invalid ACn encoding");P=d(v),A=o?2:3}continue;case 1:case 2:t[u]?t[u]+=(f()<<s)*h:0===--o&&(A=2===A?3:0);break;case 3:t[u]?t[u]+=(f()<<s)*h:(t[u]=P<<s,A=0);break;case 4:t[u]&&(t[u]+=(f()<<s)*h)}n++}4===A&&0===--E&&(A=0)}var _=n.mcusPerLine,g=n.progressive,k=t,x=t,O=0,S=0,E=0,A=0,P=void 0,M=r.length,T=void 0,j=void 0,C=void 0,L=void 0,B=void 0,I=void 0;I=g?0===i?0===u?p:v:0===u?y:m:h;var N=0,Z=void 0,D=void 0;D=1===M?r[0].blocksPerLine*r[0].blocksPerColumn:_*n.mcusPerColumn;for(var R=o||D;N<D;){for(j=0;j<M;j++)r[j].pred=0;if(E=0,1===M)for(T=r[0],B=0;B<R;B++)!function(e,t,n){var r=n/e.blocksPerLine|0,o=n%e.blocksPerLine;t(e,e.blocks[r][o])}(T,I,N),N++;else for(B=0;B<R;B++){for(j=0;j<M;j++){T=r[j];var F=T,U=F.h,z=F.v;for(C=0;C<z;C++)for(L=0;L<U;L++)!function(e,t,n,r,o){var i=n/_|0,a=n%_,u=i*e.v+r,s=a*e.h+o;t(e,e.blocks[u][s])}(T,I,N,C,L)}if(++N===D)break}if(S=0,(Z=e[x]<<8|e[x+1])<65280)throw new Error("marker was not found");if(!(Z>=65488&&Z<=65495))break;x+=2}return x-k}function a(e,t){for(var n=[],r=t.blocksPerLine,o=t.blocksPerColumn,i=r<<3,a=new Int32Array(64),u=new Uint8Array(64),s=0;s<o;s++){for(var f=s<<3,c=0;c<8;c++)n.push(new Uint8Array(i));for(var l=0;l<r;l++){!function(e,n,r){var o=t.quantizationTable,i=void 0,a=void 0,u=void 0,s=void 0,f=void 0,c=void 0,l=void 0,d=void 0,h=void 0,p=r,v=void 0;for(v=0;v<64;v++)p[v]=e[v]*o[v];for(v=0;v<8;++v){var b=8*v;0!==p[1+b]||0!==p[2+b]||0!==p[3+b]||0!==p[4+b]||0!==p[5+b]||0!==p[6+b]||0!==p[7+b]?(i=E*p[0+b]+128>>8,a=E*p[4+b]+128>>8,u=p[2+b],s=p[6+b],f=A*(p[1+b]-p[7+b])+128>>8,d=A*(p[1+b]+p[7+b])+128>>8,c=p[3+b]<<4,l=p[5+b]<<4,h=i-a+1>>1,i=i+a+1>>1,a=h,h=u*S+s*O+128>>8,u=u*O-s*S+128>>8,s=h,h=f-l+1>>1,f=f+l+1>>1,l=h,h=d+c+1>>1,c=d-c+1>>1,d=h,h=i-s+1>>1,i=i+s+1>>1,s=h,h=a-u+1>>1,a=a+u+1>>1,u=h,h=f*x+d*k+2048>>12,f=f*k-d*x+2048>>12,d=h,h=c*g+l*_+2048>>12,c=c*_-l*g+2048>>12,l=h,p[0+b]=i+d,p[7+b]=i-d,p[1+b]=a+l,p[6+b]=a-l,p[2+b]=u+c,p[5+b]=u-c,p[3+b]=s+f,p[4+b]=s-f):(h=E*p[0+b]+512>>10,p[0+b]=h,p[1+b]=h,p[2+b]=h,p[3+b]=h,p[4+b]=h,p[5+b]=h,p[6+b]=h,p[7+b]=h)}for(v=0;v<8;++v){var y=v;0!==p[8+y]||0!==p[16+y]||0!==p[24+y]||0!==p[32+y]||0!==p[40+y]||0!==p[48+y]||0!==p[56+y]?(i=E*p[0+y]+2048>>12,a=E*p[32+y]+2048>>12,u=p[16+y],s=p[48+y],f=A*(p[8+y]-p[56+y])+2048>>12,d=A*(p[8+y]+p[56+y])+2048>>12,c=p[24+y],l=p[40+y],h=i-a+1>>1,i=i+a+1>>1,a=h,h=u*S+s*O+2048>>12,u=u*O-s*S+2048>>12,s=h,h=f-l+1>>1,f=f+l+1>>1,l=h,h=d+c+1>>1,c=d-c+1>>1,d=h,h=i-s+1>>1,i=i+s+1>>1,s=h,h=a-u+1>>1,a=a+u+1>>1,u=h,h=f*x+d*k+2048>>12,f=f*k-d*x+2048>>12,d=h,h=c*g+l*_+2048>>12,c=c*_-l*g+2048>>12,l=h,p[0+y]=i+d,p[56+y]=i-d,p[8+y]=a+l,p[48+y]=a-l,p[16+y]=u+c,p[40+y]=u-c,p[24+y]=s+f,p[32+y]=s-f):(h=E*r[v+0]+8192>>14,p[0+y]=h,p[8+y]=h,p[16+y]=h,p[24+y]=h,p[32+y]=h,p[40+y]=h,p[48+y]=h,p[56+y]=h)}for(v=0;v<64;++v){var m=128+(p[v]+8>>4);n[v]=m<0?0:m>255?255:m}}(t.blocks[s][l],u,a);for(var d=0,h=l<<3,p=0;p<8;p++)for(var v=n[f+p],b=0;b<8;b++)v[h+b]=u[d++]}}return n}Object.defineProperty(t,"__esModule",{value:!0});var u=n(15),s=r(u),f=n(16),c=r(f),l=n(11),d=r(l),h=n(12),p=r(h),v=n(33),b=r(v),y=n(17),m=r(y),w=new Int32Array([0,1,8,16,9,2,3,10,17,24,32,25,18,11,4,5,12,19,26,33,40,48,41,34,27,20,13,6,7,14,21,28,35,42,49,56,57,50,43,36,29,22,15,23,30,37,44,51,58,59,52,45,38,31,39,46,53,60,61,54,47,55,62,63]),_=4017,g=799,k=3406,x=2276,O=1567,S=3784,E=5793,A=2896,P=function(){function e(){(0,d.default)(this,e),this.jfif=null,this.adobe=null,this.quantizationTables=[],this.huffmanTablesAC=[],this.huffmanTablesDC=[],this.resetFrames()}return(0,p.default)(e,[{key:"resetFrames",value:function(){this.frames=[]}},{key:"parse",value:function(e){function t(){var t=e[n]<<8|e[n+1];return n+=2,t}var n=0,r=t();if(65496!==r)throw new Error("SOI not found");for(r=t();65497!==r;){switch(r){case 65280:break;case 65504:case 65505:case 65506:case 65507:case 65508:case 65509:case 65510:case 65511:case 65512:case 65513:case 65514:case 65515:case 65516:case 65517:case 65518:case 65519:case 65534:var a=function(){var r=t(),o=e.subarray(n,n+r-2);return n+=o.length,o}();65504===r&&74===a[0]&&70===a[1]&&73===a[2]&&70===a[3]&&0===a[4]&&(this.jfif={version:{major:a[5],minor:a[6]},densityUnits:a[7],xDensity:a[8]<<8|a[9],yDensity:a[10]<<8|a[11],thumbWidth:a[12],thumbHeight:a[13],thumbData:a.subarray(14,14+3*a[12]*a[13])}),65518===r&&65===a[0]&&100===a[1]&&111===a[2]&&98===a[3]&&101===a[4]&&0===a[5]&&(this.adobe={version:a[6],flags0:a[7]<<8|a[8],flags1:a[9]<<8|a[10],transformCode:a[11]});break;case 65499:for(var u=t(),s=u+n-2;n<s;){var f=e[n++],c=new Int32Array(64);if(f>>4==0)for(var l=0;l<64;l++){var d=w[l];c[d]=e[n++]}else{if(f>>4!=1)throw new Error("DQT: invalid table spec");for(var h=0;h<64;h++){c[w[h]]=t()}}this.quantizationTables[15&f]=c}break;case 65472:case 65473:case 65474:t();for(var p={extended:65473===r,progressive:65474===r,precision:e[n++],scanLines:t(),samplesPerLine:t(),components:{},componentsOrder:[]},v=e[n++],b=void 0,y=0;y<v;y++){b=e[n];var m=e[n+1]>>4,_=15&e[n+1],g=e[n+2];p.componentsOrder.push(b),p.components[b]={h:m,v:_,quantizationIdx:g},n+=3}!function(e){var t=0,n=0,r=void 0,o=void 0;for(o in e.components)e.components.hasOwnProperty(o)&&(r=e.components[o],t<r.h&&(t=r.h),n<r.v&&(n=r.v));var i=Math.ceil(e.samplesPerLine/8/t),a=Math.ceil(e.scanLines/8/n);for(o in e.components)if(e.components.hasOwnProperty(o)){r=e.components[o];for(var u=Math.ceil(Math.ceil(e.samplesPerLine/8)*r.h/t),s=Math.ceil(Math.ceil(e.scanLines/8)*r.v/n),f=i*r.h,c=a*r.v,l=[],d=0;d<c;d++){for(var h=[],p=0;p<f;p++)h.push(new Int32Array(64));l.push(h)}r.blocksPerLine=u,r.blocksPerColumn=s,r.blocks=l}e.maxH=t,e.maxV=n,e.mcusPerLine=i,e.mcusPerColumn=a}(p),this.frames.push(p);break;case 65476:for(var k=t(),x=2;x<k;){for(var O=e[n++],S=new Uint8Array(16),E=0,A=0;A<16;A++,n++)S[A]=e[n],E+=S[A];for(var P=new Uint8Array(E),M=0;M<E;M++,n++)P[M]=e[n];x+=17+E,O>>4==0?this.huffmanTablesDC[15&O]=o(S,P):this.huffmanTablesAC[15&O]=o(S,P)}break;case 65501:t(),this.resetInterval=t();break;case 65498:t();for(var T=e[n++],j=[],C=this.frames[0],L=0;L<T;L++){var B=C.components[e[n++]],I=e[n++];B.huffmanTableDC=this.huffmanTablesDC[I>>4],B.huffmanTableAC=this.huffmanTablesAC[15&I],j.push(B)}var N=e[n++],Z=e[n++],D=e[n++],R=i(e,n,C,j,this.resetInterval,N,Z,D>>4,15&D);n+=R;break;case 65535:255!==e[n]&&n--;break;default:if(255===e[n-3]&&e[n-2]>=192&&e[n-2]<=254){n-=3;break}throw new Error("unknown JPEG marker "+r.toString(16))}r=t()}}},{key:"getResult",value:function(){var e=this.frames;if(0===this.frames.length)throw new Error("no frames were decoded");this.frames.length>1&&console.warn("more than one frame is not supported");for(var t=0;t<this.frames.length;t++){var n=this.frames[t].components,r=!0,o=!1,i=void 0;try{for(var u,s=Object.keys(n)[Symbol.iterator]();!(r=(u=s.next()).done);r=!0){var f=u.value;n[f].quantizationTable=this.quantizationTables[n[f].quantizationIdx],delete n[f].quantizationIdx}}catch(e){o=!0,i=e}finally{try{!r&&s.return&&s.return()}finally{if(o)throw i}}}for(var c=e[0],l=c.components,d=c.componentsOrder,h=[],p=c.samplesPerLine,v=c.scanLines,b=0;b<d.length;b++){var y=l[d[b]];h.push({lines:a(c,y),scaleX:y.h/c.maxH,scaleY:y.v/c.maxV})}for(var m=new Uint8Array(p*v*h.length),w=0,_=0;_<v;++_)for(var g=0;g<p;++g)for(var k=0;k<h.length;++k){var x=h[k];m[w]=x.lines[0|_*x.scaleY][0|g*x.scaleX],++w}return m}}]),e}(),M=function(e){function t(e){(0,d.default)(this,t);var n=(0,s.default)(this,(t.__proto__||Object.getPrototypeOf(t)).call(this));return n.reader=new P,e.JPEGTables&&n.reader.parse(e.JPEGTables),n}return(0,c.default)(t,e),(0,p.default)(t,[{key:"decodeBlock",value:function(e){return this.reader.resetFrames(),this.reader.parse(new Uint8Array(e)),this.reader.getResult().buffer}}]),t}(m.default);t.default=M},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(12),u=r(a),s=n(15),f=r(s),c=n(16),l=r(c),d=n(101),h=n(17),p=r(h),v=function(e){function t(){return(0,i.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,u.default)(t,[{key:"decodeBlock",value:function(e){return(0,d.inflate)(new Uint8Array(e)).buffer}}]),t}(p.default);t.default=v},function(e,t,n){"use strict";function r(e){if(!(this instanceof r))return new r(e);this.options=u.assign({chunkSize:16384,windowBits:0,to:""},e||{});var t=this.options;t.raw&&t.windowBits>=0&&t.windowBits<16&&(t.windowBits=-t.windowBits,0===t.windowBits&&(t.windowBits=-15)),!(t.windowBits>=0&&t.windowBits<16)||e&&e.windowBits||(t.windowBits+=32),t.windowBits>15&&t.windowBits<48&&0==(15&t.windowBits)&&(t.windowBits|=15),this.err=0,this.msg="",this.ended=!1,this.chunks=[],this.strm=new l,this.strm.avail_out=0;var n=a.inflateInit2(this.strm,t.windowBits);if(n!==f.Z_OK)throw new Error(c[n]);this.header=new d,a.inflateGetHeader(this.strm,this.header)}function o(e,t){var n=new r(t);if(n.push(e,!0),n.err)throw n.msg||c[n.err];return n.result}function i(e,t){return t=t||{},t.raw=!0,o(e,t)}var a=n(102),u=n(21),s=n(107),f=n(108),c=n(109),l=n(110),d=n(111),h=Object.prototype.toString;r.prototype.push=function(e,t){var n,r,o,i,c,l,d=this.strm,p=this.options.chunkSize,v=this.options.dictionary,b=!1;if(this.ended)return!1;r=t===~~t?t:!0===t?f.Z_FINISH:f.Z_NO_FLUSH,"string"==typeof e?d.input=s.binstring2buf(e):"[object ArrayBuffer]"===h.call(e)?d.input=new Uint8Array(e):d.input=e,d.next_in=0,d.avail_in=d.input.length;do{if(0===d.avail_out&&(d.output=new u.Buf8(p),d.next_out=0,d.avail_out=p),n=a.inflate(d,f.Z_NO_FLUSH),n===f.Z_NEED_DICT&&v&&(l="string"==typeof v?s.string2buf(v):"[object ArrayBuffer]"===h.call(v)?new Uint8Array(v):v,n=a.inflateSetDictionary(this.strm,l)),n===f.Z_BUF_ERROR&&!0===b&&(n=f.Z_OK,b=!1),n!==f.Z_STREAM_END&&n!==f.Z_OK)return this.onEnd(n),this.ended=!0,!1;d.next_out&&(0!==d.avail_out&&n!==f.Z_STREAM_END&&(0!==d.avail_in||r!==f.Z_FINISH&&r!==f.Z_SYNC_FLUSH)||("string"===this.options.to?(o=s.utf8border(d.output,d.next_out),i=d.next_out-o,c=s.buf2string(d.output,o),d.next_out=i,d.avail_out=p-i,i&&u.arraySet(d.output,d.output,o,i,0),this.onData(c)):this.onData(u.shrinkBuf(d.output,d.next_out)))),0===d.avail_in&&0===d.avail_out&&(b=!0)}while((d.avail_in>0||0===d.avail_out)&&n!==f.Z_STREAM_END);return n===f.Z_STREAM_END&&(r=f.Z_FINISH),r===f.Z_FINISH?(n=a.inflateEnd(this.strm),this.onEnd(n),this.ended=!0,n===f.Z_OK):r!==f.Z_SYNC_FLUSH||(this.onEnd(f.Z_OK),d.avail_out=0,!0)},r.prototype.onData=function(e){this.chunks.push(e)},r.prototype.onEnd=function(e){e===f.Z_OK&&("string"===this.options.to?this.result=this.chunks.join(""):this.result=u.flattenChunks(this.chunks)),this.chunks=[],this.err=e,this.msg=this.strm.msg},t.Inflate=r,t.inflate=o,t.inflateRaw=i,t.ungzip=o},function(e,t,n){"use strict";function r(e){return(e>>>24&255)+(e>>>8&65280)+((65280&e)<<8)+((255&e)<<24)}function o(){this.mode=0,this.last=!1,this.wrap=0,this.havedict=!1,this.flags=0,this.dmax=0,this.check=0,this.total=0,this.head=null,this.wbits=0,this.wsize=0,this.whave=0,this.wnext=0,this.window=null,this.hold=0,this.bits=0,this.length=0,this.offset=0,this.extra=0,this.lencode=null,this.distcode=null,this.lenbits=0,this.distbits=0,this.ncode=0,this.nlen=0,this.ndist=0,this.have=0,this.next=null,this.lens=new m.Buf16(320),this.work=new m.Buf16(288),this.lendyn=null,this.distdyn=null,this.sane=0,this.back=0,this.was=0}function i(e){var t;return e&&e.state?(t=e.state,e.total_in=e.total_out=t.total=0,e.msg="",t.wrap&&(e.adler=1&t.wrap),t.mode=Z,t.last=0,t.havedict=0,t.dmax=32768,t.head=null,t.hold=0,t.bits=0,t.lencode=t.lendyn=new m.Buf32(ve),t.distcode=t.distdyn=new m.Buf32(be),t.sane=1,t.back=-1,M):C}function a(e){var t;return e&&e.state?(t=e.state,t.wsize=0,t.whave=0,t.wnext=0,i(e)):C}function u(e,t){var n,r;return e&&e.state?(r=e.state,t<0?(n=0,t=-t):(n=1+(t>>4),t<48&&(t&=15)),t&&(t<8||t>15)?C:(null!==r.window&&r.wbits!==t&&(r.window=null),r.wrap=n,r.wbits=t,a(e))):C}function s(e,t){var n,r;return e?(r=new o,e.state=r,r.window=null,n=u(e,t),n!==M&&(e.state=null),n):C}function f(e){return s(e,ye)}function c(e){if(me){var t;for(b=new m.Buf32(512),y=new m.Buf32(32),t=0;t<144;)e.lens[t++]=8;for(;t<256;)e.lens[t++]=9;for(;t<280;)e.lens[t++]=7;for(;t<288;)e.lens[t++]=8;for(k(O,e.lens,0,288,b,0,e.work,{bits:9}),t=0;t<32;)e.lens[t++]=5;k(S,e.lens,0,32,y,0,e.work,{bits:5}),me=!1}e.lencode=b,e.lenbits=9,e.distcode=y,e.distbits=5}function l(e,t,n,r){var o,i=e.state;return null===i.window&&(i.wsize=1<<i.wbits,i.wnext=0,i.whave=0,i.window=new m.Buf8(i.wsize)),r>=i.wsize?(m.arraySet(i.window,t,n-i.wsize,i.wsize,0),i.wnext=0,i.whave=i.wsize):(o=i.wsize-i.wnext,o>r&&(o=r),m.arraySet(i.window,t,n-r,o,i.wnext),r-=o,r?(m.arraySet(i.window,t,n-r,r,0),i.wnext=r,i.whave=i.wsize):(i.wnext+=o,i.wnext===i.wsize&&(i.wnext=0),i.whave<i.wsize&&(i.whave+=o))),0}function d(e,t){var n,o,i,a,u,s,f,d,h,p,v,b,y,ve,be,ye,me,we,_e,ge,ke,xe,Oe,Se,Ee=0,Ae=new m.Buf8(4),Pe=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&0!==e.avail_in)return C;n=e.state,n.mode===V&&(n.mode=Y),u=e.next_out,i=e.output,f=e.avail_out,a=e.next_in,o=e.input,s=e.avail_in,d=n.hold,h=n.bits,p=s,v=f,xe=M;e:for(;;)switch(n.mode){case Z:if(0===n.wrap){n.mode=Y;break}for(;h<16;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(2&n.wrap&&35615===d){n.check=0,Ae[0]=255&d,Ae[1]=d>>>8&255,n.check=_(n.check,Ae,2,0),d=0,h=0,n.mode=D;break}if(n.flags=0,n.head&&(n.head.done=!1),!(1&n.wrap)||(((255&d)<<8)+(d>>8))%31){e.msg="incorrect header check",n.mode=de;break}if((15&d)!==N){e.msg="unknown compression method",n.mode=de;break}if(d>>>=4,h-=4,ke=8+(15&d),0===n.wbits)n.wbits=ke;else if(ke>n.wbits){e.msg="invalid window size",n.mode=de;break}n.dmax=1<<ke,e.adler=n.check=1,n.mode=512&d?W:V,d=0,h=0;break;case D:for(;h<16;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(n.flags=d,(255&n.flags)!==N){e.msg="unknown compression method",n.mode=de;break}if(57344&n.flags){e.msg="unknown header flags set",n.mode=de;break}n.head&&(n.head.text=d>>8&1),512&n.flags&&(Ae[0]=255&d,Ae[1]=d>>>8&255,n.check=_(n.check,Ae,2,0)),d=0,h=0,n.mode=R;case R:for(;h<32;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.head&&(n.head.time=d),512&n.flags&&(Ae[0]=255&d,Ae[1]=d>>>8&255,Ae[2]=d>>>16&255,Ae[3]=d>>>24&255,n.check=_(n.check,Ae,4,0)),d=0,h=0,n.mode=F;case F:for(;h<16;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.head&&(n.head.xflags=255&d,n.head.os=d>>8),512&n.flags&&(Ae[0]=255&d,Ae[1]=d>>>8&255,n.check=_(n.check,Ae,2,0)),d=0,h=0,n.mode=U;case U:if(1024&n.flags){for(;h<16;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.length=d,n.head&&(n.head.extra_len=d),512&n.flags&&(Ae[0]=255&d,Ae[1]=d>>>8&255,n.check=_(n.check,Ae,2,0)),d=0,h=0}else n.head&&(n.head.extra=null);n.mode=z;case z:if(1024&n.flags&&(b=n.length,b>s&&(b=s),b&&(n.head&&(ke=n.head.extra_len-n.length,n.head.extra||(n.head.extra=new Array(n.head.extra_len)),m.arraySet(n.head.extra,o,a,b,ke)),512&n.flags&&(n.check=_(n.check,o,b,a)),s-=b,a+=b,n.length-=b),n.length))break e;n.length=0,n.mode=H;case H:if(2048&n.flags){if(0===s)break e;b=0;do{ke=o[a+b++],n.head&&ke&&n.length<65536&&(n.head.name+=String.fromCharCode(ke))}while(ke&&b<s);if(512&n.flags&&(n.check=_(n.check,o,b,a)),s-=b,a+=b,ke)break e}else n.head&&(n.head.name=null);n.length=0,n.mode=G;case G:if(4096&n.flags){if(0===s)break e;b=0;do{ke=o[a+b++],n.head&&ke&&n.length<65536&&(n.head.comment+=String.fromCharCode(ke))}while(ke&&b<s);if(512&n.flags&&(n.check=_(n.check,o,b,a)),s-=b,a+=b,ke)break e}else n.head&&(n.head.comment=null);n.mode=K;case K:if(512&n.flags){for(;h<16;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(d!==(65535&n.check)){e.msg="header crc mismatch",n.mode=de;break}d=0,h=0}n.head&&(n.head.hcrc=n.flags>>9&1,n.head.done=!0),e.adler=n.check=0,n.mode=V;break;case W:for(;h<32;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}e.adler=n.check=r(d),d=0,h=0,n.mode=q;case q:if(0===n.havedict)return e.next_out=u,e.avail_out=f,e.next_in=a,e.avail_in=s,n.hold=d,n.bits=h,j;e.adler=n.check=1,n.mode=V;case V:if(t===A||t===P)break e;case Y:if(n.last){d>>>=7&h,h-=7&h,n.mode=fe;break}for(;h<3;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}switch(n.last=1&d,d>>>=1,h-=1,3&d){case 0:n.mode=J;break;case 1:if(c(n),n.mode=ne,t===P){d>>>=2,h-=2;break e}break;case 2:n.mode=$;break;case 3:e.msg="invalid block type",n.mode=de}d>>>=2,h-=2;break;case J:for(d>>>=7&h,h-=7&h;h<32;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if((65535&d)!=(d>>>16^65535)){e.msg="invalid stored block lengths",n.mode=de;break}if(n.length=65535&d,d=0,h=0,n.mode=X,t===P)break e;case X:n.mode=Q;case Q:if(b=n.length){if(b>s&&(b=s),b>f&&(b=f),0===b)break e;m.arraySet(i,o,a,b,u),s-=b,a+=b,f-=b,u+=b,n.length-=b;break}n.mode=V;break;case $:for(;h<14;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(n.nlen=257+(31&d),d>>>=5,h-=5,n.ndist=1+(31&d),d>>>=5,h-=5,n.ncode=4+(15&d),d>>>=4,h-=4,n.nlen>286||n.ndist>30){e.msg="too many length or distance symbols",n.mode=de;break}n.have=0,n.mode=ee;case ee:for(;n.have<n.ncode;){for(;h<3;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.lens[Pe[n.have++]]=7&d,d>>>=3,h-=3}for(;n.have<19;)n.lens[Pe[n.have++]]=0;if(n.lencode=n.lendyn,n.lenbits=7,Oe={bits:n.lenbits},xe=k(x,n.lens,0,19,n.lencode,0,n.work,Oe),n.lenbits=Oe.bits,xe){e.msg="invalid code lengths set",n.mode=de;break}n.have=0,n.mode=te;case te:for(;n.have<n.nlen+n.ndist;){for(;Ee=n.lencode[d&(1<<n.lenbits)-1],be=Ee>>>24,ye=Ee>>>16&255,me=65535&Ee,!(be<=h);){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(me<16)d>>>=be,h-=be,n.lens[n.have++]=me;else{if(16===me){for(Se=be+2;h<Se;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(d>>>=be,h-=be,0===n.have){e.msg="invalid bit length repeat",n.mode=de;break}ke=n.lens[n.have-1],b=3+(3&d),d>>>=2,h-=2}else if(17===me){for(Se=be+3;h<Se;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}d>>>=be,h-=be,ke=0,b=3+(7&d),d>>>=3,h-=3}else{for(Se=be+7;h<Se;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}d>>>=be,h-=be,ke=0,b=11+(127&d),d>>>=7,h-=7}if(n.have+b>n.nlen+n.ndist){e.msg="invalid bit length repeat",n.mode=de;break}for(;b--;)n.lens[n.have++]=ke}}if(n.mode===de)break;if(0===n.lens[256]){e.msg="invalid code -- missing end-of-block",n.mode=de;break}if(n.lenbits=9,Oe={bits:n.lenbits},xe=k(O,n.lens,0,n.nlen,n.lencode,0,n.work,Oe),n.lenbits=Oe.bits,xe){e.msg="invalid literal/lengths set",n.mode=de;break}if(n.distbits=6,n.distcode=n.distdyn,Oe={bits:n.distbits},xe=k(S,n.lens,n.nlen,n.ndist,n.distcode,0,n.work,Oe),n.distbits=Oe.bits,xe){e.msg="invalid distances set",n.mode=de;break}if(n.mode=ne,t===P)break e;case ne:n.mode=re;case re:if(s>=6&&f>=258){e.next_out=u,e.avail_out=f,e.next_in=a,e.avail_in=s,n.hold=d,n.bits=h,g(e,v),u=e.next_out,i=e.output,f=e.avail_out,a=e.next_in,o=e.input,s=e.avail_in,d=n.hold,h=n.bits,n.mode===V&&(n.back=-1);break}for(n.back=0;Ee=n.lencode[d&(1<<n.lenbits)-1],be=Ee>>>24,ye=Ee>>>16&255,me=65535&Ee,!(be<=h);){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(ye&&0==(240&ye)){for(we=be,_e=ye,ge=me;Ee=n.lencode[ge+((d&(1<<we+_e)-1)>>we)],be=Ee>>>24,ye=Ee>>>16&255,me=65535&Ee,!(we+be<=h);){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}d>>>=we,h-=we,n.back+=we}if(d>>>=be,h-=be,n.back+=be,n.length=me,0===ye){n.mode=se;break}if(32&ye){n.back=-1,n.mode=V;break}if(64&ye){e.msg="invalid literal/length code",n.mode=de;break}n.extra=15&ye,n.mode=oe;case oe:if(n.extra){for(Se=n.extra;h<Se;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.length+=d&(1<<n.extra)-1,d>>>=n.extra,h-=n.extra,n.back+=n.extra}n.was=n.length,n.mode=ie;case ie:for(;Ee=n.distcode[d&(1<<n.distbits)-1],be=Ee>>>24,ye=Ee>>>16&255,me=65535&Ee,!(be<=h);){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(0==(240&ye)){for(we=be,_e=ye,ge=me;Ee=n.distcode[ge+((d&(1<<we+_e)-1)>>we)],be=Ee>>>24,ye=Ee>>>16&255,me=65535&Ee,!(we+be<=h);){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}d>>>=we,h-=we,n.back+=we}if(d>>>=be,h-=be,n.back+=be,64&ye){e.msg="invalid distance code",n.mode=de;break}n.offset=me,n.extra=15&ye,n.mode=ae;case ae:if(n.extra){for(Se=n.extra;h<Se;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}n.offset+=d&(1<<n.extra)-1,d>>>=n.extra,h-=n.extra,n.back+=n.extra}if(n.offset>n.dmax){e.msg="invalid distance too far back",n.mode=de;break}n.mode=ue;case ue:if(0===f)break e;if(b=v-f,n.offset>b){if((b=n.offset-b)>n.whave&&n.sane){e.msg="invalid distance too far back",n.mode=de;break}b>n.wnext?(b-=n.wnext,y=n.wsize-b):y=n.wnext-b,b>n.length&&(b=n.length),ve=n.window}else ve=i,y=u-n.offset,b=n.length;b>f&&(b=f),f-=b,n.length-=b;do{i[u++]=ve[y++]}while(--b);0===n.length&&(n.mode=re);break;case se:if(0===f)break e;i[u++]=n.length,f--,n.mode=re;break;case fe:if(n.wrap){for(;h<32;){if(0===s)break e;s--,d|=o[a++]<<h,h+=8}if(v-=f,e.total_out+=v,n.total+=v,v&&(e.adler=n.check=n.flags?_(n.check,i,v,u-v):w(n.check,i,v,u-v)),v=f,(n.flags?d:r(d))!==n.check){e.msg="incorrect data check",n.mode=de;break}d=0,h=0}n.mode=ce;case ce:if(n.wrap&&n.flags){for(;h<32;){if(0===s)break e;s--,d+=o[a++]<<h,h+=8}if(d!==(4294967295&n.total)){e.msg="incorrect length check",n.mode=de;break}d=0,h=0}n.mode=le;case le:xe=T;break e;case de:xe=L;break e;case he:return B;case pe:default:return C}return e.next_out=u,e.avail_out=f,e.next_in=a,e.avail_in=s,n.hold=d,n.bits=h,(n.wsize||v!==e.avail_out&&n.mode<de&&(n.mode<fe||t!==E))&&l(e,e.output,e.next_out,v-e.avail_out)?(n.mode=he,B):(p-=e.avail_in,v-=e.avail_out,e.total_in+=p,e.total_out+=v,n.total+=v,n.wrap&&v&&(e.adler=n.check=n.flags?_(n.check,i,v,e.next_out-v):w(n.check,i,v,e.next_out-v)),e.data_type=n.bits+(n.last?64:0)+(n.mode===V?128:0)+(n.mode===ne||n.mode===X?256:0),(0===p&&0===v||t===E)&&xe===M&&(xe=I),xe)}function h(e){if(!e||!e.state)return C;var t=e.state;return t.window&&(t.window=null),e.state=null,M}function p(e,t){var n;return e&&e.state?(n=e.state,0==(2&n.wrap)?C:(n.head=t,t.done=!1,M)):C}function v(e,t){var n,r,o=t.length;return e&&e.state?(n=e.state,0!==n.wrap&&n.mode!==q?C:n.mode===q&&(r=1,(r=w(r,t,o,0))!==n.check)?L:l(e,t,o,o)?(n.mode=he,B):(n.havedict=1,M)):C}var b,y,m=n(21),w=n(103),_=n(104),g=n(105),k=n(106),x=0,O=1,S=2,E=4,A=5,P=6,M=0,T=1,j=2,C=-2,L=-3,B=-4,I=-5,N=8,Z=1,D=2,R=3,F=4,U=5,z=6,H=7,G=8,K=9,W=10,q=11,V=12,Y=13,J=14,X=15,Q=16,$=17,ee=18,te=19,ne=20,re=21,oe=22,ie=23,ae=24,ue=25,se=26,fe=27,ce=28,le=29,de=30,he=31,pe=32,ve=852,be=592,ye=15,me=!0;t.inflateReset=a,t.inflateReset2=u,t.inflateResetKeep=i,t.inflateInit=f,t.inflateInit2=s,t.inflate=d,t.inflateEnd=h,t.inflateGetHeader=p,t.inflateSetDictionary=v,t.inflateInfo="pako inflate (from Nodeca project)"},function(e,t,n){"use strict";function r(e,t,n,r){for(var o=65535&e|0,i=e>>>16&65535|0,a=0;0!==n;){a=n>2e3?2e3:n,n-=a;do{o=o+t[r++]|0,i=i+o|0}while(--a);o%=65521,i%=65521}return o|i<<16|0}e.exports=r},function(e,t,n){"use strict";function r(e,t,n,r){var i=o,a=r+n;e^=-1;for(var u=r;u<a;u++)e=e>>>8^i[255&(e^t[u])];return-1^e}var o=function(){for(var e,t=[],n=0;n<256;n++){e=n;for(var r=0;r<8;r++)e=1&e?3988292384^e>>>1:e>>>1;t[n]=e}return t}();e.exports=r},function(e,t,n){"use strict";e.exports=function(e,t){var n,r,o,i,a,u,s,f,c,l,d,h,p,v,b,y,m,w,_,g,k,x,O,S,E;n=e.state,r=e.next_in,S=e.input,o=r+(e.avail_in-5),i=e.next_out,E=e.output,a=i-(t-e.avail_out),u=i+(e.avail_out-257),s=n.dmax,f=n.wsize,c=n.whave,l=n.wnext,d=n.window,h=n.hold,p=n.bits,v=n.lencode,b=n.distcode,y=(1<<n.lenbits)-1,m=(1<<n.distbits)-1;e:do{p<15&&(h+=S[r++]<<p,p+=8,h+=S[r++]<<p,p+=8),w=v[h&y];t:for(;;){if(_=w>>>24,h>>>=_,p-=_,0===(_=w>>>16&255))E[i++]=65535&w;else{if(!(16&_)){if(0==(64&_)){w=v[(65535&w)+(h&(1<<_)-1)];continue t}if(32&_){n.mode=12;break e}e.msg="invalid literal/length code",n.mode=30;break e}g=65535&w,_&=15,_&&(p<_&&(h+=S[r++]<<p,p+=8),g+=h&(1<<_)-1,h>>>=_,p-=_),p<15&&(h+=S[r++]<<p,p+=8,h+=S[r++]<<p,p+=8),w=b[h&m];n:for(;;){if(_=w>>>24,h>>>=_,p-=_,!(16&(_=w>>>16&255))){if(0==(64&_)){w=b[(65535&w)+(h&(1<<_)-1)];continue n}e.msg="invalid distance code",n.mode=30;break e}if(k=65535&w,_&=15,p<_&&(h+=S[r++]<<p,(p+=8)<_&&(h+=S[r++]<<p,p+=8)),(k+=h&(1<<_)-1)>s){e.msg="invalid distance too far back",n.mode=30;break e}if(h>>>=_,p-=_,_=i-a,k>_){if((_=k-_)>c&&n.sane){e.msg="invalid distance too far back",n.mode=30;break e}if(x=0,O=d,0===l){if(x+=f-_,_<g){g-=_;do{E[i++]=d[x++]}while(--_);x=i-k,O=E}}else if(l<_){if(x+=f+l-_,(_-=l)<g){g-=_;do{E[i++]=d[x++]}while(--_);if(x=0,l<g){_=l,g-=_;do{E[i++]=d[x++]}while(--_);x=i-k,O=E}}}else if(x+=l-_,_<g){g-=_;do{E[i++]=d[x++]}while(--_);x=i-k,O=E}for(;g>2;)E[i++]=O[x++],E[i++]=O[x++],E[i++]=O[x++],g-=3;g&&(E[i++]=O[x++],g>1&&(E[i++]=O[x++]))}else{x=i-k;do{E[i++]=E[x++],E[i++]=E[x++],E[i++]=E[x++],g-=3}while(g>2);g&&(E[i++]=E[x++],g>1&&(E[i++]=E[x++]))}break}}break}}while(r<o&&i<u);g=p>>3,r-=g,p-=g<<3,h&=(1<<p)-1,e.next_in=r,e.next_out=i,e.avail_in=r<o?o-r+5:5-(r-o),e.avail_out=i<u?u-i+257:257-(i-u),n.hold=h,n.bits=p}},function(e,t,n){"use strict";var r=n(21),o=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0],i=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78],a=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0],u=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function(e,t,n,s,f,c,l,d){var h,p,v,b,y,m,w,_,g,k=d.bits,x=0,O=0,S=0,E=0,A=0,P=0,M=0,T=0,j=0,C=0,L=null,B=0,I=new r.Buf16(16),N=new r.Buf16(16),Z=null,D=0;for(x=0;x<=15;x++)I[x]=0;for(O=0;O<s;O++)I[t[n+O]]++;for(A=k,E=15;E>=1&&0===I[E];E--);if(A>E&&(A=E),0===E)return f[c++]=20971520,f[c++]=20971520,d.bits=1,0;for(S=1;S<E&&0===I[S];S++);for(A<S&&(A=S),T=1,x=1;x<=15;x++)if(T<<=1,(T-=I[x])<0)return-1;if(T>0&&(0===e||1!==E))return-1;for(N[1]=0,x=1;x<15;x++)N[x+1]=N[x]+I[x];for(O=0;O<s;O++)0!==t[n+O]&&(l[N[t[n+O]]++]=O);if(0===e?(L=Z=l,m=19):1===e?(L=o,B-=257,Z=i,D-=257,m=256):(L=a,Z=u,m=-1),C=0,O=0,x=S,y=c,P=A,M=0,v=-1,j=1<<A,b=j-1,1===e&&j>852||2===e&&j>592)return 1;for(;;){w=x-M,l[O]<m?(_=0,g=l[O]):l[O]>m?(_=Z[D+l[O]],g=L[B+l[O]]):(_=96,g=0),h=1<<x-M,p=1<<P,S=p;do{p-=h,f[y+(C>>M)+p]=w<<24|_<<16|g|0}while(0!==p);for(h=1<<x-1;C&h;)h>>=1;if(0!==h?(C&=h-1,C+=h):C=0,O++,0==--I[x]){if(x===E)break;x=t[n+l[O]]}if(x>A&&(C&b)!==v){for(0===M&&(M=A),y+=S,P=x-M,T=1<<P;P+M<E&&!((T-=I[P+M])<=0);)P++,T<<=1;if(j+=1<<P,1===e&&j>852||2===e&&j>592)return 1;v=C&b,f[v]=A<<24|P<<16|y-c|0}}return 0!==C&&(f[y+C]=x-M<<24|64<<16|0),d.bits=A,0}},function(e,t,n){"use strict";function r(e,t){if(t<65537&&(e.subarray&&a||!e.subarray&&i))return String.fromCharCode.apply(null,o.shrinkBuf(e,t));for(var n="",r=0;r<t;r++)n+=String.fromCharCode(e[r]);return n}var o=n(21),i=!0,a=!0;try{String.fromCharCode.apply(null,[0])}catch(e){i=!1}try{String.fromCharCode.apply(null,new Uint8Array(1))}catch(e){a=!1}for(var u=new o.Buf8(256),s=0;s<256;s++)u[s]=s>=252?6:s>=248?5:s>=240?4:s>=224?3:s>=192?2:1;u[254]=u[254]=1,t.string2buf=function(e){var t,n,r,i,a,u=e.length,s=0;for(i=0;i<u;i++)n=e.charCodeAt(i),55296==(64512&n)&&i+1<u&&56320==(64512&(r=e.charCodeAt(i+1)))&&(n=65536+(n-55296<<10)+(r-56320),i++),s+=n<128?1:n<2048?2:n<65536?3:4;for(t=new o.Buf8(s),a=0,i=0;a<s;i++)n=e.charCodeAt(i),55296==(64512&n)&&i+1<u&&56320==(64512&(r=e.charCodeAt(i+1)))&&(n=65536+(n-55296<<10)+(r-56320),i++),n<128?t[a++]=n:n<2048?(t[a++]=192|n>>>6,t[a++]=128|63&n):n<65536?(t[a++]=224|n>>>12,t[a++]=128|n>>>6&63,t[a++]=128|63&n):(t[a++]=240|n>>>18,t[a++]=128|n>>>12&63,t[a++]=128|n>>>6&63,t[a++]=128|63&n);return t},t.buf2binstring=function(e){return r(e,e.length)},t.binstring2buf=function(e){for(var t=new o.Buf8(e.length),n=0,r=t.length;n<r;n++)t[n]=e.charCodeAt(n);return t},t.buf2string=function(e,t){var n,o,i,a,s=t||e.length,f=new Array(2*s);for(o=0,n=0;n<s;)if((i=e[n++])<128)f[o++]=i;else if((a=u[i])>4)f[o++]=65533,n+=a-1;else{for(i&=2===a?31:3===a?15:7;a>1&&n<s;)i=i<<6|63&e[n++],a--;a>1?f[o++]=65533:i<65536?f[o++]=i:(i-=65536,f[o++]=55296|i>>10&1023,f[o++]=56320|1023&i)}return r(f,o)},t.utf8border=function(e,t){var n;for(t=t||e.length,t>e.length&&(t=e.length),n=t-1;n>=0&&128==(192&e[n]);)n--;return n<0?t:0===n?t:n+u[e[n]]>t?n:t}},function(e,t,n){"use strict";e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},function(e,t,n){"use strict";e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},function(e,t,n){"use strict";function r(){this.input=null,this.next_in=0,this.avail_in=0,this.total_in=0,this.output=null,this.next_out=0,this.avail_out=0,this.total_out=0,this.msg="",this.state=null,this.data_type=2,this.adler=0}e.exports=r},function(e,t,n){"use strict";function r(){this.text=0,this.time=0,this.xflags=0,this.os=0,this.extra=null,this.extra_len=0,this.name="",this.comment="",this.hcrc=0,this.done=!1}e.exports=r},function(e,t,n){"use strict";function r(e){return e&&e.__esModule?e:{default:e}}Object.defineProperty(t,"__esModule",{value:!0});var o=n(11),i=r(o),a=n(12),u=r(a),s=n(15),f=r(s),c=n(16),l=r(c),d=n(17),h=r(d),p=function(e){function t(){return(0,i.default)(this,t),(0,f.default)(this,(t.__proto__||Object.getPrototypeOf(t)).apply(this,arguments))}return(0,l.default)(t,e),(0,u.default)(t,[{key:"decodeBlock",value:function(e){for(var t=new DataView(e),n=[],r=0;r<e.byteLength;++r){var o=t.getInt8(r);if(o<0){var i=t.getUint8(r+1);o=-o;for(var a=0;a<=o;++a)n.push(i);r+=1}else{for(var u=0;u<=o;++u)n.push(t.getUint8(r+u+1));r+=o+1}}return new Uint8Array(n).buffer}}]),t}(h.default);t.default=p}]);',n.p+"ce01ea4d64aa5d892f87.decoder.worker.min.js")}},function(e,t,n){"use strict";var r=window.URL||window.webkitURL;e.exports=function(e,t){try{try{var n;try{var i=window.BlobBuilder||window.WebKitBlobBuilder||window.MozBlobBuilder||window.MSBlobBuilder;n=new i,n.append(e),n=n.getBlob()}catch(t){n=new Blob([e])}return new Worker(r.createObjectURL(n))}catch(t){return new Worker("data:application/javascript,"+encodeURIComponent(e))}}catch(e){if(!t)throw Error("Inline worker is not supported");return new Worker(t)}}},function(e,t,n){"use strict";var r=n(47),i=n(160),o=(0,i.invert)(r.fieldTagNames),a=(0,i.invert)(r.geoKeyNames),s={};(0,i.assign)(s,o),(0,i.assign)(s,a);var u=(0,i.invert)(r.fieldTypeNames),f={nextZero:function(e,t){for(var n=t;0!==e[n];)n++;return n},readUshort:function(e,t){return e[t]<<8|e[t+1]},readShort:function(e,t){var n=f.ui8;return n[0]=e[t+1],n[1]=e[t+0],f.i16[0]},readInt:function(e,t){var n=f.ui8;return n[0]=e[t+3],n[1]=e[t+2],n[2]=e[t+1],n[3]=e[t+0],f.i32[0]},readUint:function(e,t){var n=f.ui8;return n[0]=e[t+3],n[1]=e[t+2],n[2]=e[t+1],n[3]=e[t+0],f.ui32[0]},readASCII:function(e,t,n){return n.map(function(n){return String.fromCharCode(e[t+n])}).join("")},readFloat:function(e,t){var n=f.ui8;return(0,i.times)(4,function(r){n[r]=e[t+3-r]}),f.fl32[0]},readDouble:function(e,t){var n=f.ui8;return(0,i.times)(8,function(r){n[r]=e[t+7-r]}),f.fl64[0]},writeUshort:function(e,t,n){e[t]=n>>8&255,e[t+1]=255&n},writeUint:function(e,t,n){e[t]=n>>24&255,e[t+1]=n>>16&255,e[t+2]=n>>8&255,e[t+3]=n>>0&255},writeASCII:function(e,t,n){(0,i.times)(n.length,function(r){e[t+r]=n.charCodeAt(r)})},ui8:new Uint8Array(8)};f.fl64=new Float64Array(f.ui8.buffer),f.writeDouble=function(e,t,n){f.fl64[0]=n,(0,i.times)(8,function(n){e[t+n]=f.ui8[7-n]})};var c=function(e,t,n,o){var a=n,s=Object.keys(o).filter(function(e){return void 0!==e&&null!==e&&"undefined"!==e});e.writeUshort(t,a,s.length),a+=2;var f=a+12*s.length+4;return s.forEach(function(n){var s=null;"number"==typeof n?s=n:"string"==typeof n&&(s=parseInt(n,10));var c=r.fieldTagTypes[s],l=u[c];if(null==c||void 0===c||void 0===c)throw new Error("unknown type of tag: "+s);var h=o[n];if(void 0===h)throw new Error("failed to get value for key "+n);"ASCII"===c&&"string"==typeof h&&!1===(0,i.endsWith)(h,"\0")&&(h+="\0");var d=h.length;e.writeUshort(t,a,s),a+=2,e.writeUshort(t,a,l),a+=2,e.writeUint(t,a,d),a+=4;var p=[-1,1,1,2,4,8,0,0,0,0,0,0,8][l]*d,v=a;p>4&&(e.writeUint(t,a,f),v=f),"ASCII"===c?e.writeASCII(t,v,h):"SHORT"===c?(0,i.times)(d,function(n){e.writeUshort(t,v+2*n,h[n])}):"LONG"===c?(0,i.times)(d,function(n){e.writeUint(t,v+4*n,h[n])}):"RATIONAL"===c?(0,i.times)(d,function(n){e.writeUint(t,v+8*n,Math.round(1e4*h[n])),e.writeUint(t,v+8*n+4,1e4)}):"DOUBLE"===c&&(0,i.times)(d,function(n){e.writeDouble(t,v+8*n,h[n])}),p>4&&(p+=1&p,f+=p),a+=4}),[a,f]},l=function(e){var t=new Uint8Array(1e3),n=4,r=f;t[0]=77,t[1]=77,t[3]=42;var i=8;if(r.writeUint(t,n,i),n+=4,e.forEach(function(n,o){var a=c(r,t,i,n);i=a[1],o<e.length-1&&r.writeUint(t,a[0],i)}),t.slice)return t.slice(0,i).buffer;for(var o=new Uint8Array(i),a=0;a<i;a++)o[a]=t[a];return o.buffer},h=function(e,t,n,r){if(void 0===n||null===n)throw new Error("you passed into encodeImage a width of type "+n);if(void 0===t||null===t)throw new Error("you passed into encodeImage a width of type "+t);var o={256:[t],257:[n],273:[1e3],278:[n],305:"geotiff.js"};if(r)for(var a in r)r.hasOwnProperty(a)&&(o[a]=r[a]);var s=new Uint8Array(l([o])),u=new Uint8Array(e),f=o[277],c=new Uint8Array(1e3+t*n*f);return(0,i.times)(s.length,function(e){c[e]=s[e]}),(0,i.forEach)(u,function(e,t){c[1e3+t]=e}),c.buffer},d=function(e){var t={};for(var n in e)"StripOffsets"!==n&&(s[n]||console.error(n,"not in name2code:",Object.keys(s)),t[s[n]]=e[n]);return t},p=function(e){return Array.isArray(e)?e:[e]},v=[["Compression",1],["PlanarConfiguration",1],["XPosition",0],["YPosition",0],["ResolutionUnit",1],["ExtraSamples",0],["GeoAsciiParams","WGS 84\0"],["ModelTiepoint",[0,0,0,-180,90,0]],["GTModelTypeGeoKey",2],["GTRasterTypeGeoKey",1],["GeographicTypeGeoKey",4326],["GeogCitationGeoKey","WGS 84"]],m=function(e,t){var n="number"==typeof e[0],o=void 0,a=void 0,u=void 0,f=void 0;n?(o=t.height||t.ImageLength,u=t.width||t.ImageWidth,a=e.length/(o*u),f=e):(a=e.length,o=e[0].length,u=e[0][0].length,f=[],(0,i.times)(o,function(t){(0,i.times)(u,function(n){(0,i.times)(a,function(r){f.push(e[r][t][n])})})})),t.ImageLength=o,delete t.height,t.ImageWidth=u,delete t.width,t.BitsPerSample||(t.BitsPerSample=(0,i.times)(a,function(){return 8})),v.forEach(function(e){var n=e[0];if(!t[n]){var r=e[1];t[n]=r}}),t.PhotometricInterpretation||(t.PhotometricInterpretation=3===t.BitsPerSample.length?2:1),t.SamplesPerPixel||(t.SamplesPerPixel=[a]),t.StripByteCounts||(t.StripByteCounts=[a*o*u]),t.ModelPixelScale||(t.ModelPixelScale=[360/u,180/o,0]),t.SampleFormat||(t.SampleFormat=(0,i.times)(a,function(){return 1}));var c=Object.keys(t).filter(function(e){return(0,i.endsWith)(e,"GeoKey")}).sort(function(e,t){return s[e]-s[t]});if(!t.GeoKeyDirectory){var l=c.length,m=[1,1,0,l];c.forEach(function(e){var n=Number(s[e]);m.push(n);var i=void 0,o=void 0,a=void 0;"SHORT"===r.fieldTagTypes[n]?(i=1,o=0,a=t[e]):"GeogCitationGeoKey"===e?(i=t.GeoAsciiParams.length,o=Number(s.GeoAsciiParams),a=0):console.log("[geotiff.js] couldn't get TIFFTagLocation for "+e),m.push(o),m.push(i),m.push(a)}),t.GeoKeyDirectory=m}for(var y in c)c.hasOwnProperty(y)&&delete t[y];["Compression","ExtraSamples","GeographicTypeGeoKey","GTModelTypeGeoKey","GTRasterTypeGeoKey","ImageLength","ImageWidth","PhotometricInterpretation","PlanarConfiguration","ResolutionUnit","SamplesPerPixel","XPosition","YPosition"].forEach(function(e){t[e]&&(t[e]=p(t[e]))});var b=d(t);return h(f,u,o,b)};e.exports={writeGeotiff:m}},function(e,t,n){"use strict";function r(e,t){for(var n in t)t.hasOwnProperty(n)&&(e[n]=t[n])}function i(e,t){for(var n=[],r=e.length,i=0;i<r;i+=t){for(var o=[],a=i;a<i+t;a++)o.push(e[a]);n.push(o)}return n}function o(e,t){return!(e.length<t.length)&&e.substr(e.length-t.length)===t}function a(e,t){for(var n=e.length,r=0;r<n;r++)t(e[r],r)}function s(e){var t={};for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];t[r]=n}return t}function u(e){for(var t=[],n=0;n<e;n++)t.push(n);return t}function f(e,t){for(var n=[],r=0;r<e;r++)n.push(t(r));return n}function c(e){for(var t=[],n=e.length,r=0;r<n;r++)t.push(e[r]);return t}function l(e){return e.length?c(e).map(l):e}Object.defineProperty(t,"__esModule",{value:!0}),t.assign=r,t.chunk=i,t.endsWith=o,t.forEach=a,t.invert=s,t.range=u,t.times=f,t.toArray=c,t.toArrayRecursively=l}])});